
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("gJN0g", function(module, exports) {
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.40
   Copyright © 2012-2024 Faisal Salman <f@faisalman.com>
   MIT License */ /*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */ /////////////////////////////////////////////////////////////////////////////////
(function(window1, undefined) {
    'use strict';
    //////////////
    // Constants
    /////////////
    var LIBVERSION = '1.0.40', EMPTY = '', UNKNOWN = '?', FUNC_TYPE = 'function', UNDEF_TYPE = 'undefined', OBJ_TYPE = 'object', STR_TYPE = 'string', MAJOR = 'major', MODEL = 'model', NAME = 'name', TYPE = 'type', VENDOR = 'vendor', VERSION = 'version', ARCHITECTURE = 'architecture', CONSOLE = 'console', MOBILE = 'mobile', TABLET = 'tablet', SMARTTV = 'smarttv', WEARABLE = 'wearable', EMBEDDED = 'embedded', UA_MAX_LENGTH = 500;
    var AMAZON = 'Amazon', APPLE = 'Apple', ASUS = 'ASUS', BLACKBERRY = 'BlackBerry', BROWSER = 'Browser', CHROME = 'Chrome', EDGE = 'Edge', FIREFOX = 'Firefox', GOOGLE = 'Google', HUAWEI = 'Huawei', LG = 'LG', MICROSOFT = 'Microsoft', MOTOROLA = 'Motorola', OPERA = 'Opera', SAMSUNG = 'Samsung', SHARP = 'Sharp', SONY = 'Sony', XIAOMI = 'Xiaomi', ZEBRA = 'Zebra', FACEBOOK = 'Facebook', CHROMIUM_OS = 'Chromium OS', MAC_OS = 'Mac OS', SUFFIX_BROWSER = ' Browser';
    ///////////
    // Helper
    //////////
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    ///////////////
    // Map helper
    //////////////
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        // loop through all regexes maps
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1]; // odd sequence (1,3,5,..)
            j = k = 0;
            // try matching uastring with regexes
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    // check if given property is actually array
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) // assign modified match
                            this[q[0]] = q[1].call(this, match);
                            else // assign given value, ignore regex match
                            this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            // check whether function or regex
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) // call function (usually string mapper)
                            this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else // sanitize match using given regex
                            this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            // check if current value is array
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return map.hasOwnProperty('*') ? map['*'] : str;
    };
    ///////////////
    // String map
    //////////////
    // Safari < 3.0
    var oldSafariMap = {
        '1.0': '/8',
        '1.2': '/1',
        '1.3': '/3',
        '2.0': '/412',
        '2.0.2': '/416',
        '2.0.3': '/417',
        '2.0.4': '/419',
        '?': '/'
    }, windowsVersionMap = {
        'ME': '4.90',
        'NT 3.11': 'NT3.51',
        'NT 4.0': 'NT4.0',
        '2000': 'NT 5.0',
        'XP': [
            'NT 5.1',
            'NT 5.2'
        ],
        'Vista': 'NT 6.0',
        '7': 'NT 6.1',
        '8': 'NT 6.2',
        '8.1': 'NT 6.3',
        '10': [
            'NT 6.4',
            'NT 10.0'
        ],
        'RT': 'ARM'
    };
    //////////////
    // Regex map
    /////////////
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'Chrome'
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
            ],
            [
                VERSION,
                [
                    NAME,
                    'Edge'
                ]
            ],
            [
                // Presto based
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Mini'
                ]
            ],
            [
                /\bop(?:rg)?x\/([\w\.]+)/i // Opera GX
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' GX'
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i // Opera Webkit
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                // Mixed
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i // Baidu
            ],
            [
                VERSION,
                [
                    NAME,
                    'Baidu'
                ]
            ],
            [
                /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i // Maxthon
            ],
            [
                VERSION,
                [
                    NAME,
                    'Maxthon'
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
                // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
                // Trident based
                /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
                /(heytap|ovi|115)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i // Weibo
            ],
            [
                NAME,
                VERSION
            ],
            [
                /quark(?:pc)?\/([-\w\.]+)/i // Quark
            ],
            [
                VERSION,
                [
                    NAME,
                    'Quark'
                ]
            ],
            [
                /\bddg\/([\w\.]+)/i // DuckDuckGo
            ],
            [
                VERSION,
                [
                    NAME,
                    'DuckDuckGo'
                ]
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
            ],
            [
                VERSION,
                [
                    NAME,
                    'UC' + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i // WeChat
            ],
            [
                VERSION,
                [
                    NAME,
                    'WeChat'
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i // Konqueror
            ],
            [
                VERSION,
                [
                    NAME,
                    'Konqueror'
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
            ],
            [
                VERSION,
                [
                    NAME,
                    'IE'
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i // Yandex
            ],
            [
                VERSION,
                [
                    NAME,
                    'Yandex'
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i // Smart Lenovo Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Smart Lenovo ' + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1 Secure ' + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i // Firefox Focus
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' Focus'
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i // Opera Touch
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Touch'
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Coc Coc'
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i // Dolphin
            ],
            [
                VERSION,
                [
                    NAME,
                    'Dolphin'
                ]
            ],
            [
                /coast\/([\w\.]+)/i // Opera Coast
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Coast'
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i // MIUI Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'MIUI' + SUFFIX_BROWSER
                ]
            ],
            [
                /fxios\/([\w\.-]+)/i // Firefox for iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihoobrowser\/?([\w\.]*)/i // 360
            ],
            [
                VERSION,
                [
                    NAME,
                    '360'
                ]
            ],
            [
                /\b(qq)\/([\w\.]+)/i // QQ
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1Browser'
                ],
                VERSION
            ],
            [
                /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1' + SUFFIX_BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i // Samsung Internet
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + ' Internet'
                ]
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i // Sogou Explorer
            ],
            [
                VERSION,
                [
                    NAME,
                    'Sogou Explorer'
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i // Sogou Mobile
            ],
            [
                [
                    NAME,
                    'Sogou Mobile'
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i // QQ/2345
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser|rekonq)/i,
                /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
            ],
            [
                NAME
            ],
            [
                /ome\/([\w\.]+) \w* ?(iron) saf/i,
                /ome\/([\w\.]+).+qihu (360)[es]e/i // 360
            ],
            [
                VERSION,
                NAME
            ],
            [
                // WebView
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i // Chromium/Instagram/Snapchat
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'GSA'
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i // TikTok
            ],
            [
                VERSION,
                [
                    NAME,
                    'TikTok'
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + ' Headless'
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
            ],
            [
                [
                    NAME,
                    CHROME + ' WebView'
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Android ' + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
            ],
            [
                VERSION,
                [
                    NAME,
                    'Mobile Safari'
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                // Gecko based
                /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
            ],
            [
                [
                    NAME,
                    'Netscape'
                ],
                VERSION
            ],
            [
                /(wolvic|librewolf)\/([\w\.]+)/i // Wolvic/LibreWolf
            ],
            [
                NAME,
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' Reality'
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                // Other
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser
                /(links) \(([\w\.]+)/i // Links
            ],
            [
                NAME,
                [
                    VERSION,
                    /_/g,
                    '.'
                ]
            ],
            [
                /(cobalt)\/([\w\.]+)/i // Cobalt
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
            ],
            [
                [
                    ARCHITECTURE,
                    'amd64'
                ]
            ],
            [
                /(ia32(?=;))/i // IA32 (quicktime)
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i // IA32 (x86)
            ],
            [
                [
                    ARCHITECTURE,
                    'ia32'
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
            ],
            [
                [
                    ARCHITECTURE,
                    'arm64'
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
            ],
            [
                [
                    ARCHITECTURE,
                    'armhf'
                ]
            ],
            [
                // PocketPC mistakenly identified as PowerPC
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    'arm'
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i // SPARC
            ],
            [
                [
                    ARCHITECTURE,
                    'sparc'
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                //////////////////////////
                // MOBILES & TABLETS
                /////////////////////////
                // Samsung
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]((?!sm-[lr])[-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Apple
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i // iPod/iPhone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                // Sharp
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Honor
                /(?:honor)([-\w ]+)[;\)]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Honor'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Huawei
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Xiaomi
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i // Xiaomi Mi
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OPPO
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'OPPO'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(opd2\d{3}a?) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'OPPO'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Vivo
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Vivo'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Realme
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Realme'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Motorola
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // LG
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Lenovo
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Lenovo'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Nokia
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    'Nokia'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Google
                /(pixel c)\b/i // Google Pixel C
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Sony
                /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    'Xperia Tablet'
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OnePlus
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'OnePlus'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Amazon
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    'Fire Phone $1'
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // BlackBerry
                /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i // BlackBerry 10
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Asus
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // HTC
                /(nexus 9)/i // HTC Nexus 9
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'HTC'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                // ZTE
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // TCL
                /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'TCL'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // itel
                /(itel) ((\w+))/i
            ],
            [
                [
                    VENDOR,
                    lowerize
                ],
                MODEL,
                [
                    TYPE,
                    strMapper,
                    {
                        'tablet': [
                            'p10001l',
                            'w7001'
                        ],
                        '*': 'mobile'
                    }
                ]
            ],
            [
                // Acer
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Acer'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Meizu
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Meizu'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Ulefone
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Ulefone'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Energizer
                /; (energy ?\w+)(?: bui|\))/i,
                /; energizer ([\w ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Energizer'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Cat
                /; cat (b35);/i,
                /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Cat'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Smartfren
                /((?:new )?andromax[\w- ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Smartfren'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Nothing
                /droid.+; (a(?:015|06[35]|142p?))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Nothing'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // MIXED
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Infinix/Tecno/Micromax/Advan
                /; (imo) ((?!tab)[\w ]+?)(?: bui|\))/i,
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i // OPPO
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(imo) (tab \w+)/i,
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i // Surface Duo
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Fairphone'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i // AT&T
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'AT&T'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i // Siemens
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Siemens'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i // RCA Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'RCA'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Dell'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Verizon'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Barnes & Noble'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'NuVision'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i // ZTE K Series Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'ZTE'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i // ZTE Nubia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'ZTE'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Swiss'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i // Swiss ZUR Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Swiss'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i // Zeki Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Zeki'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
            ],
            [
                [
                    VENDOR,
                    'Dragon Touch'
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i // Insignia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Insignia'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'NextBook'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
            ],
            [
                [
                    VENDOR,
                    'Voice'
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
            ],
            [
                [
                    VENDOR,
                    'LvTel'
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i // Essential PH-1
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Essential'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Envizen'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'MachSpeed'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i // Rotor Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Rotor'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i // Nvidia Shield Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Nvidia'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i // Sprint Phones
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i // Microsoft Kin
            ],
            [
                [
                    MODEL,
                    /\./g,
                    ' '
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                ///////////////////
                // SMARTTVS
                ///////////////////
                /smart-tv.+(samsung)/i // Samsung
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    'SmartTV'
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i // Apple TV
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + ' TV'
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i // Google Chromecast
            ],
            [
                [
                    MODEL,
                    CHROME + 'cast'
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i // Fire TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i // Sharp
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i // Sony
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i // Xiaomi
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i // TechniSAT
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i // HbbTV devices
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                ///////////////////
                // CONSOLES
                ///////////////////
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i // Nintendo
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i // Nvidia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Nvidia'
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i // Playstation
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                ///////////////////
                // WEARABLES
                ///////////////////
                /\b(sm-[lr]\d\d[05][fnuw]?s?)\b/i // Samsung Galaxy Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /((pebble))app/i // Pebble
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i // Apple Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // XR
                ///////////////////
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(pico) (4|neo3(?: link|pro)?)/i // Pico
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /; (quest( \d| pro)?)/i // Oculus Quest
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // EMBEDDED
                ///////////////////
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i // Echo Dot
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                ////////////////////
                // MIXED (GENERIC)
                ///////////////////
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Generic'
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i // EdgeHTML
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + 'HTML'
                ]
            ],
            [
                /(arkweb)\/([\w\.]+)/i // ArkWeb
            ],
            [
                NAME,
                VERSION
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
            ],
            [
                VERSION,
                [
                    NAME,
                    'Blink'
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                // Windows
                /microsoft (windows) (vista|xp)/i // Windows (iTunes)
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i // Windows Phone
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    'Windows'
                ]
            ],
            [
                // iOS/macOS
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    '.'
                ],
                [
                    NAME,
                    'iOS'
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    '.'
                ]
            ],
            [
                // Mobile OSes
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish|openharmony)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i // Series 40
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i // BlackBerry 10
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
            ],
            [
                VERSION,
                [
                    NAME,
                    'Symbian'
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' OS'
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'webOS'
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i // watchOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'watchOS'
                ]
            ],
            [
                // Google Chromecast
                /crkey\/([\d\.]+)/i // Google Chromecast
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + 'cast'
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i // Chromium OS
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                // Smart TVs
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                // Console
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                // Other
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i // Haiku
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i // Solaris
            ],
            [
                [
                    NAME,
                    'Solaris'
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i // UNIX
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    /////////////////
    // Constructor
    ////////////////
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = 'Brave';
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == 'Macintosh' && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = 'iPad';
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != 'Unknown') _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS); // backward compatibility
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    ///////////
    // Export
    //////////
    // check js environment
    if (typeof exports !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) // browser env
        window1.UAParser = UAParser;
    }
    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === 'object' ? window : this);

});

parcelRegister("cRN1p", function(module, exports) {

var $3IE7e = parcelRequire("3IE7e");


var $iDrrr = parcelRequire("iDrrr");


var $bTZ0F = parcelRequire("bTZ0F");





var $bH6Zn = parcelRequire("bH6Zn");

let $0bccc562011c3eb0$var$pe = null;
function $0bccc562011c3eb0$export$619cdeadfd90f3e4() {
    if (typeof PerformanceObserver !== 'function') // Only instantiate the IntersectionObserver if it's supported
    return null;
    if ($0bccc562011c3eb0$var$pe !== null) return $0bccc562011c3eb0$var$pe;
    const performanceObserverCallback = (list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $bTZ0F.PerformanceObserverEntryTypes).LayoutShift) (0, $bH6Zn.EntriesBuffer)[(0, $bTZ0F.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $bTZ0F.PerformanceObserverEntryTypes).LongTask) (0, $bH6Zn.EntriesBuffer)[(0, $bTZ0F.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    };
    $0bccc562011c3eb0$var$pe = new PerformanceObserver(performanceObserverCallback);
    return $0bccc562011c3eb0$var$pe;
}


function $216fd9ef087f9b1e$export$768ccc3ab7bac3ea() {
    (0, $0bccc562011c3eb0$export$619cdeadfd90f3e4)()?.observe({
        type: (0, $bTZ0F.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
}






function $e622a59c3434b36e$export$54fb8b6aaf70ec9c() {
    (0, $0bccc562011c3eb0$export$619cdeadfd90f3e4)()?.observe({
        type: (0, $bTZ0F.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
}


function $e226cd08862f770e$export$5ecf2aafafee3e0() {
    (0, $216fd9ef087f9b1e$export$768ccc3ab7bac3ea)();
    (0, $e622a59c3434b36e$export$54fb8b6aaf70ec9c)();
}



var $jtTx3 = parcelRequire("jtTx3");


var $1AQyp = parcelRequire("1AQyp");

function $7c43f85c7225d6cd$export$e6a07a94f3e112d4(sinkFn) {
    for (const { interactionId: interactionId, data: data } of (0, $1AQyp.interactionBufferState).interactionBuffer)sinkFn(interactionId, data);
    (0, $1AQyp.interactionBufferState).interactionBuffer.length = 0;
    (0, $1AQyp.interactionBufferState).bufferInteractionData = sinkFn;
}



var $aK89A = parcelRequire("aK89A");


var $8fj6C = parcelRequire("8fj6C");


var $a33Aa = parcelRequire("a33Aa");







const $305e427ed9de0327$var$nameCache = new WeakMap();
function $305e427ed9de0327$var$getAttributeSelector(element, attributeName) {
    const attrValue = element.getAttribute(attributeName);
    if (!attrValue) return '';
    return `[${attributeName}="${attrValue}"]`;
}
function $305e427ed9de0327$var$isValidSelector(selector) {
    try {
        document.querySelector(selector);
        return true;
    } catch  {
        return false;
    }
}
function $305e427ed9de0327$var$isSelectorUnique(selector) {
    return document.querySelectorAll(selector).length === 1;
}
function $305e427ed9de0327$var$getUniqueSelector(selectorConfig, element) {
    let currentElement = element;
    const parts = [];
    const MAX_DEPTH = 3;
    let currentDepth = 0;
    while(currentElement && currentElement.localName !== 'body' && currentDepth <= MAX_DEPTH){
        const tagName = currentElement.localName;
        let selectorPart = tagName;
        if (selectorConfig.id && currentElement.id && $305e427ed9de0327$var$isValidSelector(`#${currentElement.id}`)) selectorPart += `#${currentElement.id}`;
        else if (selectorConfig.dataVC) selectorPart += $305e427ed9de0327$var$getAttributeSelector(currentElement, 'data-vc');
        else if (selectorConfig.testId) selectorPart += $305e427ed9de0327$var$getAttributeSelector(currentElement, 'data-testid') || $305e427ed9de0327$var$getAttributeSelector(currentElement, 'data-test-id');
        else if (selectorConfig.role) selectorPart += $305e427ed9de0327$var$getAttributeSelector(currentElement, 'role');
        else if (selectorConfig.className && currentElement.className) {
            const classNames = Array.from(currentElement.classList).join('.');
            if (classNames) {
                if ($305e427ed9de0327$var$isValidSelector(`.${classNames}`)) selectorPart += `.${classNames}`;
            }
        }
        parts.unshift(selectorPart);
        const potentialSelector = parts.join(' > ').trim();
        if (potentialSelector && $305e427ed9de0327$var$isSelectorUnique(potentialSelector)) return potentialSelector;
        currentElement = currentElement.parentElement;
        currentDepth++;
    }
    const potentialSelector = parts.join(' > ').trim();
    if (!potentialSelector) return 'unknown';
    else if (!$305e427ed9de0327$var$isSelectorUnique(potentialSelector)) {
        const parentElement = element.parentElement;
        if (parentElement) return `${potentialSelector}:nth-child`; // NOTE: invalid DOM selector, but enough information for VC
    }
    return potentialSelector;
}
function $305e427ed9de0327$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return 'error';
    const cachedName = $305e427ed9de0327$var$nameCache.get(element);
    if (cachedName) return cachedName;
    const uniqueSelector = $305e427ed9de0327$var$getUniqueSelector(selectorConfig, element);
    $305e427ed9de0327$var$nameCache.set(element, uniqueSelector);
    return uniqueSelector;
}
var $305e427ed9de0327$export$2e2bcd8739ae039 = $305e427ed9de0327$var$getElementName;


const $011da34d4894e558$var$DEFAULT_SELECTOR_CONFIG = {
    id: true,
    testId: true,
    role: true,
    className: true
};
function $011da34d4894e558$var$resolveSelectorConfig() {
    return (0, $jtTx3.getSelectorConfig)() ?? $011da34d4894e558$var$DEFAULT_SELECTOR_CONFIG;
}
function $011da34d4894e558$var$getTestIdName(memoizedProps) {
    if (memoizedProps['data-testid']) return `[data-testid=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-test-id']) return `[data-test-id=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-vc']) return `[data-vc=${memoizedProps['data-vc']}]`;
    return null;
}
function $011da34d4894e558$var$getUFOSegmentName(componentName, memoizedProps) {
    if (memoizedProps && memoizedProps['name']) return `UFOSegment[name=${memoizedProps['name']}]`;
    return componentName;
}
function $011da34d4894e558$var$getReactComponentHierarchy(element) {
    const componentHierarchy = [];
    function traverseFiber(fiber) {
        let currentFiber = fiber;
        while(currentFiber){
            if (currentFiber.type) {
                const componentName = currentFiber.type.displayName || currentFiber.type.name;
                if (componentName && componentName.length > 2 && !componentName.includes('Listener') && !componentName.includes('Provider')) {
                    if (componentName === 'UFOSegment') {
                        componentHierarchy.push($011da34d4894e558$var$getUFOSegmentName(componentName, currentFiber.memoizedProps));
                        break;
                    }
                    componentHierarchy.push(componentName);
                }
            }
            if (currentFiber.memoizedProps) {
                const dataIdInfo = $011da34d4894e558$var$getTestIdName(currentFiber.memoizedProps);
                if (dataIdInfo) {
                    componentHierarchy.push(dataIdInfo);
                    currentFiber = null;
                    continue;
                }
            }
            currentFiber = currentFiber.return;
        }
    }
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (reactFiberKey) {
        const fiber = element[reactFiberKey];
        traverseFiber(fiber);
    }
    return componentHierarchy.reverse().join(' > ');
}
const $011da34d4894e558$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = (0, $a33Aa.getActiveInteraction)();
    if (interaction?.type === 'press') {
        if (!interaction.responsiveness?.experimentalInputToNextPaint) {
            interaction.responsiveness = {
                ...interaction.responsiveness,
                experimentalInputToNextPaint: interaction.responsiveness?.experimentalInputToNextPaint || entry.duration,
                inputDelay: interaction.responsiveness?.inputDelay || entry.processingStart - entry.startTime
            };
            if (interaction.ufoName === 'unknown') {
                if (entry.target) interaction.unknownElementHierarchy = $011da34d4894e558$var$getReactComponentHierarchy(entry.target);
                interaction.unknownElementName = (0, $305e427ed9de0327$export$2e2bcd8739ae039)($011da34d4894e558$var$resolveSelectorConfig(), entry.target);
            }
        }
    }
};


let $58b82a44163eda99$var$performanceEventObserver;
const $58b82a44163eda99$export$17afbba0f16b4b19 = ()=>{
    $58b82a44163eda99$var$performanceEventObserver = $58b82a44163eda99$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (const entry of list)if (entry.name === 'click') (0, $011da34d4894e558$export$e6be05b411ce21a6)(entry);
    });
    return $58b82a44163eda99$var$performanceEventObserver;
};



var $ogRoY = parcelRequire("ogRoY");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $34MZN = parcelRequire("34MZN");


var $dUAp3 = parcelRequire("dUAp3");





var $bC8sq = parcelRequire("bC8sq");

const $52c3b12aaa825dc6$var$ABORT_ERROR_NAMES = new Set([
    'AbortError'
]);
const $52c3b12aaa825dc6$var$ABORT_ERROR_MESSAGES = [
    'The operation was aborted',
    'auth_window_closed'
];
// Only treated as abort when combined with AuthError name — the same string
// can appear in other error messages (e.g. 403 response bodies) where it
// should not be classified as abort.
const $52c3b12aaa825dc6$var$AUTH_ERROR_ABORT_MESSAGES = [
    'access_denied'
];
// AuthError is thrown by @atlaskit/outbound-auth-flow-client during OAuth flows
// (e.g. connecting third-party apps like GitHub or Bitbucket to Jira).
// User-initiated outcomes (closing the popup, denying consent) are classified
// as abort; server/config failures are classified as auth.
const $52c3b12aaa825dc6$var$AUTH_ERROR_NAMES = new Set([
    'AuthError'
]);
const $52c3b12aaa825dc6$var$CHUNK_LOAD_ERROR_NAMES = new Set([
    'ChunkLoadError'
]);
const $52c3b12aaa825dc6$var$CHUNK_LOAD_ERROR_MESSAGES = [
    'Unable to fetch manifest',
    'dynamically imported module',
    'Importing a module script failed'
];
const $52c3b12aaa825dc6$var$NETWORK_CLIENT_ERROR_NAMES = new Set([
    'NetworkError',
    'Network error'
]);
const $52c3b12aaa825dc6$var$NETWORK_CLIENT_ERROR_MESSAGES = [
    'Failed to fetch',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'server with the specified hostname could not be found',
    'The network connection was lost',
    'The request timed out',
    'connection failure',
    'CloseEvent: Ping timeout',
    'Curl Error: Failure when receiving data from the peer'
];
const $52c3b12aaa825dc6$var$NETWORK_SERVER_ERROR_MESSAGES = [
    '... is not valid JSON',
    'in JSON at position 0',
    'JSON.parse: unexpected character',
    'JSON.parse: unexpected end of data',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'cannot parse response',
    'Syntax or http error'
];
function $52c3b12aaa825dc6$var$matchesCategory(error) {
    const name = error.name ?? '';
    const message = error.message ?? '';
    if ($52c3b12aaa825dc6$var$ABORT_ERROR_NAMES.has(name) || $52c3b12aaa825dc6$var$ABORT_ERROR_MESSAGES.some((pattern)=>message.includes(pattern)) || // OAuth Abort errors
    $52c3b12aaa825dc6$var$AUTH_ERROR_NAMES.has(name) && $52c3b12aaa825dc6$var$AUTH_ERROR_ABORT_MESSAGES.some((pattern)=>message.includes(pattern))) return 'abort';
    if ($52c3b12aaa825dc6$var$AUTH_ERROR_NAMES.has(name)) return 'auth';
    if ($52c3b12aaa825dc6$var$CHUNK_LOAD_ERROR_NAMES.has(name) || $52c3b12aaa825dc6$var$CHUNK_LOAD_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'chunk-load';
    if ($52c3b12aaa825dc6$var$NETWORK_CLIENT_ERROR_NAMES.has(name) || $52c3b12aaa825dc6$var$NETWORK_CLIENT_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'network-client';
    if ($52c3b12aaa825dc6$var$NETWORK_SERVER_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'network-server';
    return null;
}
function $52c3b12aaa825dc6$export$17e837b2daecf805(error) {
    const directMatch = $52c3b12aaa825dc6$var$matchesCategory(error);
    if (directMatch) return directMatch;
    if (typeof error === 'object' && error !== null && 'cause' in error && error.cause instanceof Error) {
        const cause = error.cause;
        const causeMatch = $52c3b12aaa825dc6$var$matchesCategory(cause);
        if (causeMatch) return causeMatch;
    }
    return 'product';
}


let $19532a315fc91766$var$sinkHandlerFn = ()=>{};
function $19532a315fc91766$export$e5fa3ac6dc44efff(fn) {
    $19532a315fc91766$var$sinkHandlerFn = fn;
}
const $19532a315fc91766$var$RELAY_NETWORK_ERRORS_NAME = 'RelayNetwork';
const $19532a315fc91766$export$1a949ef92fd30eca = (error)=>error.name === $19532a315fc91766$var$RELAY_NETWORK_ERRORS_NAME;
const $19532a315fc91766$var$isErrorObject = (error)=>typeof error === 'object' && error !== null;
const $19532a315fc91766$var$getErrorStatusCode = (error)=>{
    if (!$19532a315fc91766$var$isErrorObject(error)) return undefined;
    if ($19532a315fc91766$export$1a949ef92fd30eca(error)) return error.source?.errors?.[0]?.extensions?.statusCode;
    if ('statusCode' in error && typeof error.statusCode === 'number') return error.statusCode;
    return undefined;
};
const $19532a315fc91766$var$getErrorTraceId = (error)=>$19532a315fc91766$var$isErrorObject(error) && 'traceId' in error && typeof error.traceId === 'string' ? error.traceId : undefined;
function $19532a315fc91766$export$3e4fb24086cfb97a(error, additionalAttributes, labelStack) {
    const activeInteraction = (0, $a33Aa.getActiveInteraction)();
    const currentTime = performance.now();
    const baseErrorData = {
        errorType: error.name || 'Error',
        errorMessage: error.message?.slice(0, 100) || 'Unknown error',
        timestamp: currentTime,
        errorCategory: (0, $52c3b12aaa825dc6$export$17e837b2daecf805)(error)
    };
    const errorData = {
        ...baseErrorData,
        statusCode: additionalAttributes?.statusCode ?? $19532a315fc91766$var$getErrorStatusCode(error),
        // Fallback to traceId from error object if it exists (e.g. FetchError)
        traceId: (0, $34MZN.getActiveTrace)()?.traceId ?? $19532a315fc91766$var$getErrorTraceId(error),
        teamName: additionalAttributes?.teamName,
        packageName: additionalAttributes?.packageName,
        errorBoundaryId: additionalAttributes?.errorBoundaryId,
        errorHash: additionalAttributes?.errorHash,
        fallbackType: additionalAttributes?.fallbackType
    };
    // Calculate time since previous interaction
    const timeSincePreviousInteraction = (0, $a33Aa.PreviousInteractionLog).timestamp != null ? currentTime - (0, $a33Aa.PreviousInteractionLog).timestamp : null;
    const context = {
        labelStack: labelStack ?? null,
        activeInteractionName: activeInteraction?.ufoName ?? null,
        activeInteractionId: activeInteraction?.id ?? null,
        activeInteractionType: activeInteraction?.type ?? null,
        previousInteractionId: (0, $a33Aa.PreviousInteractionLog).id ?? null,
        previousInteractionName: (0, $a33Aa.PreviousInteractionLog).name ?? null,
        previousInteractionType: (0, $a33Aa.PreviousInteractionLog).type ?? null,
        timeSincePreviousInteraction: timeSincePreviousInteraction,
        routeName: (0, $bC8sq.default).current ?? null
    };
    $19532a315fc91766$var$sinkHandlerFn(errorData, context);
}
const $19532a315fc91766$export$79ee0f0d40355053 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useReportTerminalError(error, additionalAttributes) {
    const $ = (0, $bDgLe.c)(8);
    const interactionContext = (0, $dUAp3.useInteractionContext)();
    const hasReportedRef = (0, $cozmU.useRef)(false);
    let t0;
    if ($[0] !== additionalAttributes || $[1] !== error || $[2] !== interactionContext?.labelStack) {
        t0 = ()=>{
            if (error && !hasReportedRef.current) {
                hasReportedRef.current = true;
                $19532a315fc91766$export$3e4fb24086cfb97a(error, additionalAttributes, interactionContext?.labelStack);
            }
        };
        $[0] = additionalAttributes;
        $[1] = error;
        $[2] = interactionContext?.labelStack;
        $[3] = t0;
    } else t0 = $[3];
    const t1 = interactionContext?.labelStack;
    let t2;
    if ($[4] !== additionalAttributes || $[5] !== error || $[6] !== t1) {
        t2 = [
            error,
            additionalAttributes,
            t1
        ];
        $[4] = additionalAttributes;
        $[5] = error;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    (0, $cozmU.useEffect)(t0, t2);
} : function useReportTerminalError(error, additionalAttributes) {
    const interactionContext = (0, $dUAp3.useInteractionContext)();
    const hasReportedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (error && !hasReportedRef.current) {
            hasReportedRef.current = true;
            $19532a315fc91766$export$3e4fb24086cfb97a(error, additionalAttributes, interactionContext?.labelStack);
        }
    }, [
        error,
        additionalAttributes,
        interactionContext?.labelStack
    ]);
};



var $bHUUH = parcelRequire("bHUUH");




function $27122965bb3ffe64$var$scheduleIdleCallback(work) {
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function' && (0, $iDrrr.fg)('ufo_payload_use_idle_callback')) window.requestIdleCallback(work);
    else (0, $bHUUH.unstable_scheduleCallback)((0, $bHUUH.unstable_IdlePriority), work);
}
var $27122965bb3ffe64$export$2e2bcd8739ae039 = $27122965bb3ffe64$var$scheduleIdleCallback;


let $5c686aa3f898d78f$var$initialized = false;
function $5c686aa3f898d78f$var$sinkInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createPayloads(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads?.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $27122965bb3ffe64$export$2e2bcd8739ae039)(onIdle);
    }
    (0, $a33Aa.sinkInteractionHandler)(sinkFn);
}
function $5c686aa3f898d78f$var$sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
    (0, $a33Aa.sinkPostInteractionLogHandler)((logOutput)=>{
        (0, $27122965bb3ffe64$export$2e2bcd8739ae039)(()=>{
            const payload = createPostInteractionLogPayload(logOutput);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $5c686aa3f898d78f$var$sinkTerminalErrors(instance, createTerminalErrorPayload) {
    (0, $19532a315fc91766$export$e5fa3ac6dc44efff)((errorData, context)=>{
        (0, $27122965bb3ffe64$export$2e2bcd8739ae039)(()=>{
            const payload = createTerminalErrorPayload(errorData, context);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $5c686aa3f898d78f$var$sinkExtraSearchPageInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createExtraSearchPageInteractionPayload(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads?.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $27122965bb3ffe64$export$2e2bcd8739ae039)(onIdle);
    }
    (0, $7c43f85c7225d6cd$export$e6a07a94f3e112d4)(sinkFn);
}




function $5c686aa3f898d78f$export$2cd8252107eb640b(analyticsWebClientAsync, config) {
    if ($5c686aa3f898d78f$var$initialized) return;
    // Always set config first so isUFOEnabled() can check config.enabled
    (0, $jtTx3.setUFOConfig)(config);
    // If UFO is disabled via config, skip all initialization
    if (!(0, $jtTx3.isUFOEnabled)()) {
        $5c686aa3f898d78f$var$initialized = true;
        return;
    }
    // Initialize pressure observer for CPU usage monitoring
    (0, $ogRoY.initialisePressureObserver)();
    (0, $ogRoY.initialiseMemoryObserver)();
    if ((0, $iDrrr.fg)('platform_ufo_enable_otel_context_manager')) {
        // Configure global OTel context manager
        const contextManager = new (0, $aK89A.UFOContextManager)();
        // set the contextmanager somewhere we can reference it later
        (0, $aK89A.setContextManager)(contextManager);
        // Register the context manager with the global OTel API
        contextManager.enable();
        (0, $3IE7e.context).setGlobalContextManager(contextManager);
    }
    if (config.vc?.enabled) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            // Use centralised getter so the FedRAMP override (forces every
            // selector field to false) is applied consistently.
            selectorConfig: (0, $jtTx3.getSelectorConfig)(),
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders
        };
        (0, $a33Aa.postInteractionLog).initializeVCObserver(vcOptions);
    }
    (0, $8fj6C.setupHiddenTimingCapture)();
    (0, $e226cd08862f770e$export$5ecf2aafafee3e0)();
    (0, $8fj6C.setupThrottleDetection)();
    $5c686aa3f898d78f$var$initialized = true;
    if (typeof PerformanceObserver !== 'undefined') {
        const observer = (0, $58b82a44163eda99$export$17afbba0f16b4b19)();
        observer.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 16
        });
    }
    Promise.all([
        analyticsWebClientAsync,
        (parcelRequire("6R8n4")),
        (parcelRequire("iP1ZM")),
        (parcelRequire("cviBU")),
        (parcelRequire("eTb2c"))
    ]).then(([awc, payloadPackage, extraPayloadPackage, createPostInteractionLogPayloadPackage, createTerminalErrorPayloadPackage])=>{
        if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then((client)=>{
            const instance = client.getInstance();
            $5c686aa3f898d78f$var$sinkInteraction(instance, payloadPackage);
            if (config?.terminalErrors?.enabled) $5c686aa3f898d78f$var$sinkTerminalErrors(instance, createTerminalErrorPayloadPackage.default);
            if (config.postInteractionLog?.enabled) $5c686aa3f898d78f$var$sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
            if (config?.extraSearchPageInteraction?.enabled) $5c686aa3f898d78f$var$sinkExtraSearchPageInteraction(instance, extraPayloadPackage);
        });
        else if (awc.sendOperationalEvent) {
            $5c686aa3f898d78f$var$sinkInteraction(awc, payloadPackage);
            if (config?.terminalErrors?.enabled) $5c686aa3f898d78f$var$sinkTerminalErrors(awc, createTerminalErrorPayloadPackage.default);
            if (config.postInteractionLog?.enabled) $5c686aa3f898d78f$var$sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
            if (config?.extraSearchPageInteraction?.enabled) $5c686aa3f898d78f$var$sinkExtraSearchPageInteraction(awc, extraPayloadPackage);
        }
    });
}
module.exports["init"] = $5c686aa3f898d78f$export$2cd8252107eb640b;

});

parcelRegister("ogRoY", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ const $2d6e535ff0126aa2$var$BUFFER_MAX_LENGTH = 1000; // ensure we don't blow up this buffer
let $2d6e535ff0126aa2$var$pressureRecordBuffer = [];
let $2d6e535ff0126aa2$var$pressureObserver = null;
let $2d6e535ff0126aa2$var$memoryRecordBuffer = [];
let $2d6e535ff0126aa2$var$memoryInterval;
function $2d6e535ff0126aa2$export$6c1060bed5fea050() {
    $2d6e535ff0126aa2$var$pressureRecordBuffer.length = 0;
}
function $2d6e535ff0126aa2$export$aa672c7221b183b0() {
    $2d6e535ff0126aa2$var$memoryRecordBuffer.length = 0;
}
function $2d6e535ff0126aa2$export$ec86686c1d2e65bc(filter) {
    $2d6e535ff0126aa2$var$pressureRecordBuffer = $2d6e535ff0126aa2$var$pressureRecordBuffer.filter(({ time: time })=>time > filter);
}
function $2d6e535ff0126aa2$export$c0142ac82f5d0c28(filter) {
    $2d6e535ff0126aa2$var$memoryRecordBuffer = $2d6e535ff0126aa2$var$memoryRecordBuffer.filter(({ time: time })=>time > filter);
}
function $2d6e535ff0126aa2$export$1f0ff35da084986e(start, end) {
    try {
        // To differentiate between the API not available, vs no PressureRecords added
        if (!('PressureObserver' in globalThis)) return null;
        const pressureStateCount = $2d6e535ff0126aa2$var$pressureRecordBuffer.reduce((pressureReport, { time: time, state: state })=>{
            if (time >= start && time <= end) pressureReport[state] += 1;
            return pressureReport;
        }, {
            nominal: 0,
            fair: 0,
            serious: 0,
            critical: 0
        });
        const pressureStateTotal = Object.values(pressureStateCount).reduce((total, count)=>total + count) || 1;
        $2d6e535ff0126aa2$export$ec86686c1d2e65bc(end);
        return {
            count: pressureStateCount,
            percentage: {
                nominal: Math.round(pressureStateCount.nominal / pressureStateTotal * 100),
                fair: Math.round(pressureStateCount.fair / pressureStateTotal * 100),
                serious: Math.round(pressureStateCount.serious / pressureStateTotal * 100),
                critical: Math.round(pressureStateCount.critical / pressureStateTotal * 100)
            }
        };
    } catch  {
        return null;
    }
}
function $2d6e535ff0126aa2$var$convertBytesToMegabytes(bytes) {
    return Math.round(Math.round(bytes / 1048576 * 100) / 100);
}
function $2d6e535ff0126aa2$export$3b47ebb9832b4e24(start, end) {
    try {
        if (!('memory' in performance)) return null;
        const accumulatedMemoryUsage = $2d6e535ff0126aa2$var$memoryRecordBuffer.reduce((acc, snapshot)=>{
            if (snapshot.time >= start && snapshot.time <= end) {
                acc.totalJSHeapSize += snapshot.totalJSHeapSize;
                acc.usedJSHeapSize += snapshot.usedJSHeapSize;
                acc.snapshotCount += 1;
            }
            return acc;
        }, {
            totalJSHeapSize: 0,
            usedJSHeapSize: 0,
            snapshotCount: 0
        });
        const memoryStateReport = {
            jsHeapSizeLimitInMB: $2d6e535ff0126aa2$var$convertBytesToMegabytes($2d6e535ff0126aa2$var$memoryRecordBuffer[0].jsHeapSizeLimit),
            // just use the first record, since this value always remains the same over time
            avgTotalJSHeapSizeInMB: $2d6e535ff0126aa2$var$convertBytesToMegabytes(accumulatedMemoryUsage.totalJSHeapSize / accumulatedMemoryUsage.snapshotCount),
            avgUsedJSHeapSizeInMB: $2d6e535ff0126aa2$var$convertBytesToMegabytes(accumulatedMemoryUsage.usedJSHeapSize / accumulatedMemoryUsage.snapshotCount)
        };
        $2d6e535ff0126aa2$export$c0142ac82f5d0c28(end);
        return memoryStateReport;
    } catch  {
        return null;
    }
}
function $2d6e535ff0126aa2$export$117ebc554c6e9f2f() {
    try {
        if ('PressureObserver' in globalThis) {
            $2d6e535ff0126aa2$var$pressureObserver = new PressureObserver((records)=>{
                if ($2d6e535ff0126aa2$var$pressureRecordBuffer.length + records.length <= $2d6e535ff0126aa2$var$BUFFER_MAX_LENGTH) $2d6e535ff0126aa2$var$pressureRecordBuffer.push(...records);
            });
            $2d6e535ff0126aa2$var$pressureObserver.observe('cpu', {
                sampleInterval: 100
            }).catch(()=>{
            // Silently handle permission policy restrictions or other observe failures
            // This prevents unhandled promise rejections from being reported to Sentry
            });
        }
    } catch  {
    /* do nothing, this is a best efforts metric */ }
}
function $2d6e535ff0126aa2$export$a3271f53e91faab7() {
    try {
        // only set up the interval if `performance.memory` is available in the browser
        if ('memory' in performance) $2d6e535ff0126aa2$var$memoryInterval = setInterval(()=>{
            // another check of `performance.memory` availability to satisfy typescript
            if ('memory' in performance) {
                const memory = performance.memory;
                if ($2d6e535ff0126aa2$var$memoryRecordBuffer.length <= $2d6e535ff0126aa2$var$BUFFER_MAX_LENGTH) $2d6e535ff0126aa2$var$memoryRecordBuffer.push({
                    time: performance.now(),
                    jsHeapSizeLimit: memory.jsHeapSizeLimit,
                    totalJSHeapSize: memory.totalJSHeapSize,
                    usedJSHeapSize: memory.usedJSHeapSize
                });
            }
        }, 100);
    } catch  {
    /* do nothing, this is a best efforts metric */ }
}
function $2d6e535ff0126aa2$export$10899ada382f2ae3() {
    clearInterval($2d6e535ff0126aa2$var$memoryInterval);
}
function $2d6e535ff0126aa2$export$b9fdd785f0fc1d40() {
    $2d6e535ff0126aa2$var$pressureObserver?.disconnect();
}
module.exports["createPressureStateReport"] = $2d6e535ff0126aa2$export$1f0ff35da084986e;
module.exports["createMemoryStateReport"] = $2d6e535ff0126aa2$export$3b47ebb9832b4e24;
module.exports["initialisePressureObserver"] = $2d6e535ff0126aa2$export$117ebc554c6e9f2f;
module.exports["initialiseMemoryObserver"] = $2d6e535ff0126aa2$export$a3271f53e91faab7;

});

parcelRegister("6R8n4", function(module, exports) {

let $4fde2fa913ae880c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4fde2fa913ae880c$var$load("4foH1"),
    $4fde2fa913ae880c$var$load("5thEc")
]).then(()=>parcelRequire('7lFgX'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("iP1ZM", function(module, exports) {

let $db3e89af46ce6792$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $db3e89af46ce6792$var$load("4foH1"),
    $db3e89af46ce6792$var$load("bi1KD")
]).then(()=>parcelRequire('bWwjK'));

});

parcelRegister("cviBU", function(module, exports) {

let $91a6d0ec7ef7c3ed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $91a6d0ec7ef7c3ed$var$load("6ELUz").then(()=>parcelRequire('4bvKY'));

});

parcelRegister("eTb2c", function(module, exports) {

let $ad6ec2fb10b99076$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ad6ec2fb10b99076$var$load("ktVny").then(()=>parcelRequire('PlEDs'));

});

parcelRegister("hvG5K", function(module, exports) {

var $jtTx3 = parcelRequire("jtTx3");

const $f4295f5b6913962f$var$defaultAllowedParams = [
    'operationName',
    'operation',
    'q'
];
function $f4295f5b6913962f$var$getAllowedParams() {
    const config = (0, $jtTx3.getConfig)();
    return config?.allowedResourcesParams || $f4295f5b6913962f$var$defaultAllowedParams;
}
function $f4295f5b6913962f$var$handleQueryParams(urlString) {
    try {
        if (typeof urlString !== 'string') return urlString;
        const url = new URL(urlString);
        const params = new URLSearchParams(url.search);
        const allowedParams = $f4295f5b6913962f$var$getAllowedParams();
        for (const [key] of params)if (!allowedParams.includes(key)) url.searchParams.delete(key);
        return url.toString();
    } catch  {
        return urlString;
    }
}
let $f4295f5b6913962f$var$config = {
    mapResources: (url)=>url,
    sanitiseEndpoints: (url)=>{
        return $f4295f5b6913962f$var$handleQueryParams(url);
    }
};
function $f4295f5b6913962f$export$8d21e34596265fa2(resourceTimingConfig) {
    const newConfig = {
        mapResources: resourceTimingConfig.mapResources,
        sanitiseEndpoints: (url)=>{
            const sanitised = resourceTimingConfig.sanitiseEndpoints(url);
            if (sanitised) return $f4295f5b6913962f$var$handleQueryParams(sanitised);
            return sanitised;
        }
    };
    $f4295f5b6913962f$var$config = newConfig;
}
function $f4295f5b6913962f$export$44487a86467333c3() {
    return $f4295f5b6913962f$var$config;
}
module.exports["configure"] = $f4295f5b6913962f$export$8d21e34596265fa2;
module.exports["getConfig"] = $f4295f5b6913962f$export$44487a86467333c3;

});

parcelRegister("59ylD", function(module, exports) {

var $6mcTh = parcelRequire("6mcTh");

const $93805df410f14b67$var$getPerformanceObject = ()=>(window ?? {}).performance;
const $93805df410f14b67$var$getPerformanceObserverObject = ()=>(window ?? {}).PerformanceObserver;
const $93805df410f14b67$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource (entry) {
        const duration = (0, $6mcTh.roundEpsilon)(entry.duration);
        // prioritising atl-edge
        const totalBackendTimeEntry = entry.serverTiming?.find((timing)=>timing.name === 'atl-edge') || entry.serverTiming?.find(// timing name should come from per-product config in the future
        (timing)=>timing.name === 'total' || timing.name === 'filter-request-papi');
        const serverTime = totalBackendTimeEntry ? (0, $6mcTh.roundEpsilon)(totalBackendTimeEntry.duration) : undefined;
        const networkTime = serverTime ? duration - serverTime : undefined;
        return {
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: (0, $6mcTh.roundEpsilon)(entry.startTime),
            duration: (0, $6mcTh.roundEpsilon)(entry.duration),
            fetchStart: (0, $6mcTh.roundEpsilon)(entry.fetchStart || 0),
            workerStart: (0, $6mcTh.roundEpsilon)(entry.workerStart || 0),
            responseStart: (0, $6mcTh.roundEpsilon)(entry.responseStart || 0),
            requestStart: (0, $6mcTh.roundEpsilon)(entry.requestStart || 0),
            serverTime: serverTime,
            networkTime: networkTime,
            encodedSize: (0, $6mcTh.roundEpsilon)(entry.encodedBodySize),
            decodedSize: (0, $6mcTh.roundEpsilon)(entry.decodedBodySize)
        };
    },
    start () {
        const performance = $93805df410f14b67$var$getPerformanceObject();
        const PerformanceObserver = $93805df410f14b67$var$getPerformanceObserverObject();
        if (!PerformanceObserver || !performance || typeof PerformanceObserver === 'undefined') return;
        if ($93805df410f14b67$export$bea963256235a63e.observer) return;
        const resources = performance.getEntriesByType?.('resource');
        if (resources) $93805df410f14b67$export$bea963256235a63e.timings = resources.map((resource)=>$93805df410f14b67$export$bea963256235a63e.transformResource(resource));
        $93805df410f14b67$export$bea963256235a63e.observer = new PerformanceObserver($93805df410f14b67$export$bea963256235a63e.addTimings);
        $93805df410f14b67$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop () {
        if ($93805df410f14b67$export$bea963256235a63e.observer) {
            $93805df410f14b67$export$bea963256235a63e.observer.disconnect();
            $93805df410f14b67$export$bea963256235a63e.observer = null;
        }
        $93805df410f14b67$export$bea963256235a63e.timings = [];
    },
    addTimings (list) {
        const entries = list.getEntries().map((entry)=>$93805df410f14b67$export$bea963256235a63e.transformResource(entry));
        const overflow = $93805df410f14b67$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $93805df410f14b67$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $93805df410f14b67$export$bea963256235a63e.maxSize;
            $93805df410f14b67$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $93805df410f14b67$export$bea963256235a63e.timings.push(...entries);
    }
};
function $93805df410f14b67$var$isValidTiming(timing, startTime, endTime) {
    return timing.startTime >= startTime && timing.startTime + timing.duration <= endTime;
}
function $93805df410f14b67$export$4138a729ef1db028(startTime, endTime) {
    const performance = $93805df410f14b67$var$getPerformanceObject();
    const PerformanceObserver = $93805df410f14b67$var$getPerformanceObserverObject();
    if (!PerformanceObserver || !$93805df410f14b67$export$bea963256235a63e.observer) {
        const resources = performance?.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>$93805df410f14b67$var$isValidTiming(timing, startTime, endTime));
        return null;
    }
    return $93805df410f14b67$export$bea963256235a63e.timings.filter((timing)=>$93805df410f14b67$var$isValidTiming(timing, startTime, endTime));
}
module.exports["resourceTimingBuffer"] = $93805df410f14b67$export$bea963256235a63e;
module.exports["filterResourceTimings"] = $93805df410f14b67$export$4138a729ef1db028;

});

parcelRegister("6mcTh", function(module, exports) {
function $c49b1eda1fa8e6a5$export$56014375de40214b(num, places = 3) {
    const factor = Math.pow(10, places);
    return Math.round((num + Number.EPSILON) * factor) / factor;
}
module.exports["roundEpsilon"] = $c49b1eda1fa8e6a5$export$56014375de40214b;

});

parcelRegister("e1XeN", function(module, exports) {
const $1dac3feda03e5fd0$var$NESTED_METRIC_SEPARATOR = '/';
function $1dac3feda03e5fd0$var$filterEntry(entry) {
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
}
function $1dac3feda03e5fd0$var$mapEntry(entry) {
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration),
        ...entry.size ? {
            size: Math.round(entry.size)
        } : {}
    };
}
const $1dac3feda03e5fd0$var$SSR_PREFIX = 'ssr';
function $1dac3feda03e5fd0$var$mapKey(key) {
    if (key === 'total') return $1dac3feda03e5fd0$var$SSR_PREFIX;
    return `${$1dac3feda03e5fd0$var$SSR_PREFIX}${$1dac3feda03e5fd0$var$NESTED_METRIC_SEPARATOR}${key}`;
}
let $1dac3feda03e5fd0$var$config;
function $1dac3feda03e5fd0$export$8d21e34596265fa2(ssrConfig) {
    $1dac3feda03e5fd0$var$config = ssrConfig;
}
function $1dac3feda03e5fd0$var$getPerformanceNavigationTiming() {
    // getEntriesByType doesn't change the returned type based on the given type key
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return performance.getEntriesByType('navigation')?.[0];
}
function $1dac3feda03e5fd0$var$getServerTimingsByName() {
    const serverTimingsByName = Object.fromEntries($1dac3feda03e5fd0$var$getPerformanceNavigationTiming()?.serverTiming?.map((timing)=>[
            timing.name,
            timing
        ]) ?? []);
    return serverTimingsByName;
}
/**
 * If we have the edge's view of ttfb and the clients view as well, then we should take the gap between them as
 * the offset to use foe edge start time.
 * This will simulate the network delays between the client and the edge as an edge startTime increase
 */ function $1dac3feda03e5fd0$var$getEdgeOffset(edgeTtfb) {
    const clientTtfb = $1dac3feda03e5fd0$var$getPerformanceNavigationTiming()?.responseStart;
    if (edgeTtfb == null || clientTtfb == null) return 0;
    return clientTtfb - edgeTtfb;
}
function $1dac3feda03e5fd0$export$5300d1b82e594615() {
    const serverTimingsByName = $1dac3feda03e5fd0$var$getServerTimingsByName();
    const edgeTotalDuration = serverTimingsByName['cdn-downstream-fbl']?.duration ?? serverTimingsByName['atl-edge']?.duration;
    if (!edgeTotalDuration) return null;
    const edgeOffset = $1dac3feda03e5fd0$var$getEdgeOffset(edgeTotalDuration);
    const cfInternalDuration = (serverTimingsByName['cdn-upstream-dns']?.duration || 0) + (serverTimingsByName['cdn-upstream-connect']?.duration || 0);
    const cfUpstreamDuration = (serverTimingsByName['cdn-upstream-fbl']?.duration || 0) - cfInternalDuration;
    const cfDownstreamDuration = (serverTimingsByName['cdn-downstream-fbl']?.duration || 0) - (serverTimingsByName['cdn-upstream-fbl']?.duration || 0);
    const atlEdgeDuration = serverTimingsByName['atl-edge']?.duration;
    const cfToAtlEdgeNetworkDuration = cfUpstreamDuration - atlEdgeDuration;
    const edgeTimings = {
        edge: {
            startTime: edgeOffset,
            duration: edgeTotalDuration
        }
    };
    if (typeof serverTimingsByName['cdn-downstream-fbl'] !== 'undefined') {
        edgeTimings['edge/cf'] = {
            startTime: edgeOffset,
            duration: serverTimingsByName['cdn-downstream-fbl']?.duration
        };
        edgeTimings['edge/cf/internal'] = {
            startTime: edgeOffset,
            duration: cfInternalDuration
        };
        edgeTimings['edge/cf/upstream'] = {
            startTime: edgeOffset + cfInternalDuration,
            duration: cfUpstreamDuration
        };
        edgeTimings['edge/cf/downstream'] = {
            startTime: edgeOffset + cfInternalDuration + cfUpstreamDuration,
            duration: cfDownstreamDuration
        };
    }
    if (typeof serverTimingsByName['atl-edge'] !== 'undefined') {
        edgeTimings['edge/atl-edge'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: atlEdgeDuration
        };
        edgeTimings['edge/atl-edge/internal'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: serverTimingsByName['atl-edge-internal']?.duration
        };
        edgeTimings['edge/atl-edge/ttfb'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: atlEdgeDuration
        };
        edgeTimings['edge/cf/upstream/network'] = {
            startTime: edgeOffset + cfInternalDuration,
            duration: cfToAtlEdgeNetworkDuration
        };
    }
    // we need a timer here to prevent UFO pipeline from shifting SSR timers to start at 0
    edgeTimings?.edge && edgeOffset && Object.assign(edgeTimings, {
        'client-network': {
            startTime: 0,
            duration: edgeOffset
        }
    });
    return edgeTimings;
}
function $1dac3feda03e5fd0$export$bf7408e83532dcd0() {
    const defaultSSRTimings = $1dac3feda03e5fd0$export$5300d1b82e594615() || {};
    let configTimings = {};
    if (typeof $1dac3feda03e5fd0$var$config?.getTimings === 'function') configTimings = $1dac3feda03e5fd0$var$config.getTimings();
    const ssrTimings = Object.entries({
        ...configTimings,
        ...defaultSSRTimings
    }).reduce((acc, entry)=>{
        if ($1dac3feda03e5fd0$var$filterEntry(entry[1])) acc[$1dac3feda03e5fd0$var$mapKey(entry[0])] = $1dac3feda03e5fd0$var$mapEntry(entry[1]);
        return acc;
    }, {});
    return ssrTimings;
}
function $1dac3feda03e5fd0$export$c7ad864055e75537() {
    return !!$1dac3feda03e5fd0$var$config?.getDoneMark();
}
function $1dac3feda03e5fd0$export$5eade9354185583d() {
    return $1dac3feda03e5fd0$var$config?.getSsrPhaseSuccess?.();
}
function $1dac3feda03e5fd0$export$3def7672244bab0c() {
    return $1dac3feda03e5fd0$var$config?.getDoneMark() ?? undefined;
}
function $1dac3feda03e5fd0$export$1c4a9b5e6e22393d() {
    if (!$1dac3feda03e5fd0$var$config?.getFeatureFlags) return undefined;
    try {
        return $1dac3feda03e5fd0$var$config.getFeatureFlags() ?? undefined;
    // eslint-disable-next-line no-empty
    } catch  {}
    return undefined;
}
function $1dac3feda03e5fd0$export$eb7c400973493903() {
    if (!$1dac3feda03e5fd0$var$config?.getSsrSuccessBreakdown) return undefined;
    try {
        return $1dac3feda03e5fd0$var$config.getSsrSuccessBreakdown() ?? undefined;
    // eslint-disable-next-line no-empty
    } catch  {}
    return undefined;
}
module.exports["configure"] = $1dac3feda03e5fd0$export$8d21e34596265fa2;
module.exports["getSSRTimings"] = $1dac3feda03e5fd0$export$bf7408e83532dcd0;
module.exports["getSSRSuccess"] = $1dac3feda03e5fd0$export$c7ad864055e75537;
module.exports["getSSRPhaseSuccess"] = $1dac3feda03e5fd0$export$5eade9354185583d;
module.exports["getSSRDoneTime"] = $1dac3feda03e5fd0$export$3def7672244bab0c;
module.exports["getSSRFeatureFlags"] = $1dac3feda03e5fd0$export$1c4a9b5e6e22393d;
module.exports["getSSRSuccessBreakdown"] = $1dac3feda03e5fd0$export$eb7c400973493903;

});

parcelRegister("8NKQ9", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

function $a4751f753e6ca8b5$var$isSameRects(rect1, rect2) {
    return rect1.x === rect2.x && rect1.y === rect2.y && rect1.width === rect2.width && rect1.height === rect2.height && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom && rect1.left === rect2.left;
}
function $a4751f753e6ca8b5$export$fc6227831ee7c7(start, stop, buffer) {
    const layoutShifts = buffer.getAll().filter((_entry)=>{
        const entry = _entry;
        const isWithinObservationWindow = entry.startTime >= start && entry.startTime <= stop;
        const allSourcesHaveSameRects = entry?.sources?.every(({ previousRect: previousRect, currentRect: currentRect })=>$a4751f753e6ca8b5$var$isSameRects(previousRect, currentRect));
        return isWithinObservationWindow && !allSourcesHaveSameRects;
    });
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
}



var $bTZ0F = parcelRequire("bTZ0F");

const $74866bc0fffe4757$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
function $74866bc0fffe4757$export$2d6e933b35bd3407(start, stop, buffer) {
    return buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $74866bc0fffe4757$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $74866bc0fffe4757$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $74866bc0fffe4757$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });
}



var $bH6Zn = parcelRequire("bH6Zn");

function $1b702fc4e26ce2a2$export$b46cecdf698e4bb5({ start: start, stop: stop }) {
    const tbt = (0, $74866bc0fffe4757$export$2d6e933b35bd3407)(start, stop, (0, $bH6Zn.EntriesBuffer)[(0, $bTZ0F.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $a4751f753e6ca8b5$export$fc6227831ee7c7)(start, stop, (0, $bH6Zn.EntriesBuffer)[(0, $bTZ0F.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
}



var $jtTx3 = parcelRequire("jtTx3");


var $eJGKV = parcelRequire("eJGKV");


var $jaPlx = parcelRequire("jaPlx");

function $aa7b2fb681640924$export$843fc9e1585a1854(interaction) {
    const { start: start, end: end } = interaction;
    const config = (0, $jtTx3.getConfig)();
    const interactionStatus = (0, $eJGKV.default)(interaction);
    const pageVisibilityUpToTTAI = (0, $jaPlx.default)(interaction);
    const tti = interaction.apdex?.[0]?.stopTime;
    const ttai = interactionStatus.originalInteractionStatus === 'SUCCEEDED' && pageVisibilityUpToTTAI === 'visible' ? Math.round(end - start) : undefined;
    const PPSMetricsAtTTI = tti !== undefined ? (0, $1b702fc4e26ce2a2$export$b46cecdf698e4bb5)({
        start: start,
        stop: tti
    }) : null;
    const PPSMetricsAtTTAI = ttai !== undefined ? (0, $1b702fc4e26ce2a2$export$b46cecdf698e4bb5)({
        start: start,
        stop: interaction.end
    }) : null;
    if ((0, $iDrrr.fg)('platform_ufo_remove_deprecated_config_fields')) {
        if (PPSMetricsAtTTAI !== null) return PPSMetricsAtTTAI;
    } else {
        if (config?.shouldCalculateLighthouseMetricsFromTTAI && PPSMetricsAtTTAI !== null) return PPSMetricsAtTTAI;
        if (PPSMetricsAtTTI !== null) return {
            ...PPSMetricsAtTTI,
            'metrics@ttai': PPSMetricsAtTTAI
        };
    }
    return {};
}
module.exports["getPPSMetrics"] = $aa7b2fb681640924$export$843fc9e1585a1854;

});

parcelRegister("eJGKV", function(module, exports) {
function $a14f8ea47a9ffd85$var$getInteractionStatus(interaction) {
    let originalInteractionStatus = interaction.abortReason ? 'ABORTED' : 'SUCCEEDED';
    const hasErrors = interaction.errors.length > 0;
    originalInteractionStatus = hasErrors ? 'FAILED' : originalInteractionStatus;
    // `overrideStatus` is to be deprecated - https://product-fabric.atlassian.net/browse/AFO-3760
    return {
        originalInteractionStatus: originalInteractionStatus,
        overrideStatus: originalInteractionStatus
    };
}
var $a14f8ea47a9ffd85$export$2e2bcd8739ae039 = $a14f8ea47a9ffd85$var$getInteractionStatus;
module.exports["default"] = $a14f8ea47a9ffd85$export$2e2bcd8739ae039;

});

parcelRegister("jaPlx", function(module, exports) {

var $8fj6C = parcelRequire("8fj6C");

function $19697b792760aa26$var$getPageVisibilityUpToTTAI(interaction) {
    const { start: start, end: end } = interaction;
    return (0, $8fj6C.getPageVisibilityState)(start, end);
}
var $19697b792760aa26$export$2e2bcd8739ae039 = $19697b792760aa26$var$getPageVisibilityUpToTTAI;
module.exports["default"] = $19697b792760aa26$export$2e2bcd8739ae039;

});

parcelRegister("9eE57", function(module, exports) {

var $ge2sX = parcelRequire("ge2sX");


var $04e9M = parcelRequire("04e9M");


var $5ZqQS = parcelRequire("5ZqQS");

const $e8c3b9e45ae9a31e$export$1a717feb4df1a945 = (names)=>{
    if (window.performance?.clearMarks) names.forEach((name)=>window.performance.clearMarks(name));
};
const $e8c3b9e45ae9a31e$export$1c64491a086778ac = (name)=>{
    if (window.performance?.getEntriesByType) {
        const entries = window.performance.getEntriesByType(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce = (name)=>{
    if (window.performance?.getEntriesByName) {
        const entries = window.performance.getEntriesByName(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d = (a, b)=>{
    const entryA = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(a);
    const entryB = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(b);
    if (entryA && entryB) return Math.abs(entryA.startTime - entryB.startTime);
    return undefined;
};
const $e8c3b9e45ae9a31e$export$f45af69d005a6ed = (name)=>{
    const mark = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(name);
    if (mark) return mark.startTime;
    return undefined;
};
const $e8c3b9e45ae9a31e$export$91b34dd9e71ad666 = ({ subject: subject, subjectId: subjectId = '' })=>{
    const startMark = `${subject}.${subjectId}.start`;
    const endMark = `${subject}.${subjectId}.end`;
    $e8c3b9e45ae9a31e$export$1a717feb4df1a945([
        startMark,
        endMark
    ]);
    window.performance?.mark?.(startMark);
};
// Filter out feature flags with falsy values to save user bandwidth
const $e8c3b9e45ae9a31e$var$filterFeatureFlags = (flags = {})=>Object.keys(flags).filter((key)=>flags[key]).reduce((acc, key)=>{
        acc[key] = flags[key];
        return acc;
    }, {});
const $e8c3b9e45ae9a31e$var$performanceEnd = async ({ details: details, subject: subject, subjectId: subjectId, includeFeatureFlags: includeFeatureFlags })=>{
    const endMark = `${subject}.${subjectId}.end`;
    window.performance?.mark?.(endMark);
    const duration = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d(`${subject}.${subjectId}.start`, endMark);
    if (duration === undefined) return;
    try {
        const analyticsClientPromise = (0, $04e9M.getAnalyticsWebClient)();
        const sessionDataPromise = includeFeatureFlags ? (0, $ge2sX.getSessionData)() : Promise.resolve({
            featureFlags: {}
        });
        const [client, { featureFlags: featureFlags }] = await Promise.all([
            analyticsClientPromise,
            sessionDataPromise
        ]);
        const filteredFeatureFlags = $e8c3b9e45ae9a31e$var$filterFeatureFlags(featureFlags);
        client.sendOperationalEvent({
            tags: [
                'performance'
            ],
            source: 'confluence-frontend',
            action: 'done',
            actionSubject: subject,
            actionSubjectId: subjectId,
            attributes: {
                featureFlags: filteredFeatureFlags,
                duration: duration,
                ...details
            }
        });
    } catch (ex) {
        // This is a catch-all no-op, to prevent analytics component from screwing
        // up the user experience in case of any unexpected errors.
        (0, $5ZqQS.getMonitoringClient)().submitError(ex, {
            attribution: 'unknown'
        });
    }
};
const $e8c3b9e45ae9a31e$export$9cbdebb35a11386 = ({ subject: subject, subjectId: subjectId = '', details: details = {}, includeFeatureFlags: includeFeatureFlags = false })=>{
    const endMarkExists = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(`${subject}.${subjectId}.end`);
    if (!endMarkExists) $e8c3b9e45ae9a31e$var$performanceEnd({
        details: details,
        includeFeatureFlags: includeFeatureFlags,
        subject: subject,
        subjectId: subjectId
    });
};
module.exports["clearMarks"] = $e8c3b9e45ae9a31e$export$1a717feb4df1a945;
module.exports["getEntryByName"] = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce;
module.exports["measureMarks"] = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d;
module.exports["getMark"] = $e8c3b9e45ae9a31e$export$f45af69d005a6ed;
module.exports["perfMarkStart"] = $e8c3b9e45ae9a31e$export$91b34dd9e71ad666;
module.exports["perfMarkEnd"] = $e8c3b9e45ae9a31e$export$9cbdebb35a11386;

});

parcelRegister("8Lf0D", function(module, exports) {
/**
 * Auto Incrementing ID
 *
 * Basic ID generation using a global integer
 */ class $35e1d987475b995b$export$1545ba9ccf1841ab {
    /**
   * ID
   *
   * Returns a stringified auto-incrementing ID
   */ ID() {
        return (++this.incrementor).toString();
    }
    /**
   * Reset
   *
   * Returns the incrementor to its original state
   */ reset() {
        this.incrementor = -1;
    }
    constructor(){
        this.incrementor = -1;
    }
}
module.exports["AutoIncrementingID"] = $35e1d987475b995b$export$1545ba9ccf1841ab;

});

parcelRegister("jy3Cx", function(module, exports) {
/**
 * Cache
 *
 * A generic cache designed to house just about anything. You can implement
 * your own type-safe LRU or just use it as a hash table
 */ class $f95e45deccc3ce2b$export$94affb487e701bf2 {
    /**
   * Data
   *
   * Returns the entirety of the cache
   */ get data() {
        return this._cache;
    }
    /**
   * Get
   *
   * Returns a cache value by key
   */ get(key) {
        return this._cache[key];
    }
    /**
   * Has
   *
   * Returns whether or not a given key exists in the cache
   */ has(key) {
        return this._cache.hasOwnProperty(key);
    }
    /**
   * Set
   *
   * Overrides the value of a given key with the specified value
   */ set(key, value) {
        this._cache[key] = value;
    }
    /**
   * Delete
   *
   * Deletes the specified cache key
   */ delete(key) {
        delete this._cache[key];
    }
    /**
   * Keys
   *
   * Returns all currently set cache keys
   */ get keys() {
        return Object.keys(this._cache);
    }
    /**
   * Values
   *
   * Returns all cached values
   */ get values() {
        return Object.values(this._cache);
    }
    /**
   * Clear
   *
   * Clears all cached values
   */ clear() {
        this._cache = {};
    }
    constructor(cache){
        this._cache = void 0;
        this._cache = cache || {};
    }
}
module.exports["Cache"] = $f95e45deccc3ce2b$export$94affb487e701bf2;

});

parcelRegister("5leFG", function(module, exports) {

var $jy3Cx = parcelRequire("jy3Cx");


var $bPw0L = parcelRequire("bPw0L");

class $e398c0accbc425cf$export$5087227eb54526 extends Map {
    /**
   * Stream
   *
   * Adds a stream of messages to the bus and invokes active
   * subscriptions to the corresponding message types
   */ async stream(events) {
        if (!events.length) return;
        const hash = {};
        for (const event of events){
            if (event.type in hash) hash[event.type].push(event);
            else hash[event.type] = [
                event
            ];
            this.cache(event.type, event);
        }
        await Promise.all(Object.keys(hash).map((key)=>{
            return this.dispatch(key, hash[key]);
        }));
    }
    /**
   * On
   *
   * Allows for registering listeners to incoming message types. Simply
   * pass the message type you wish to receive notifications for and
   * a callback to invoke
   */ on(event, callback) {
        const index = this.get(event) || new (0, $bPw0L.EventIndex)();
        const ID = index.subscribe(callback);
        this.set(event, index);
        return ID;
    }
    /**
   * Off
   *
   * Removes an event listener by event-name and ID
   */ off(event, ID) {
        const index = this.get(event);
        if (index) {
            index.unsubscribe(ID);
            if (index.size === 0) this.delete(event);
        }
    }
    /**
   * Dispatch
   *
   * Invokes all subscriptions for a given event type. Each listener
   * receives its corresponding messages as an argument
   */ async dispatch(event, ...params) {
        const index = this.get(event);
        if (index) await index.dispatch(params);
    }
    /**
   * Cache
   *
   * When caching is enabled, the Event Bus can act as a
   * database for historical message accumulation. To enable
   * this feature, pass `enableCache: true` to the constructor
   */ cache(key, value) {
        if (!this.enableCache) return;
        const values = this.Cache.get(key) || [];
        values.push(value);
        this.Cache.set(key, values);
    }
    constructor(cache){
        super();
        this.enableCache = false;
        this.Cache = new (0, $jy3Cx.Cache)();
        if (cache) this.enableCache = true;
    }
}
module.exports["EventBus"] = $e398c0accbc425cf$export$5087227eb54526;

});

parcelRegister("bPw0L", function(module, exports) {

var $8Lf0D = parcelRequire("8Lf0D");

class $93598c3fbf25b38d$export$8a9c48e07ede8c4b extends Map {
    /**
   * Subscribe
   *
   * Adds a subscription to the index and returns a unique
   * identifier
   */ subscribe(listener) {
        const ID = this.IDs.ID();
        this.set(ID, listener);
        return ID;
    }
    /**
   * Unsubscribe
   *
   * Removes a subscription from the index by ID
   */ unsubscribe(ID) {
        this.delete(ID);
    }
    /**
   * Dispatch
   *
   * Dispatches events to their registered listeners
   */ async dispatch(messages) {
        for (const [_, listener] of this)await Promise.resolve(listener(...messages));
    }
    constructor(...args){
        super(...args);
        this.IDs = new (0, $8Lf0D.AutoIncrementingID)();
    }
}
module.exports["EventIndex"] = $93598c3fbf25b38d$export$8a9c48e07ede8c4b;

});

parcelRegister("lXQLs", function(module, exports) {
const $feab3ea7dc0c8aa0$export$b471d97e795847e1 = (resourceTimings)=>{
    let hasScriptEntries = false;
    let hasNextHopProtocolProperty = false;
    for (const entry of resourceTimings){
        if (entry.initiatorType !== 'script') continue;
        hasScriptEntries = true;
        // Skip cache hits. Cached resources have transferSize === 0 and the browser reports
        // nextHopProtocol as "" since no network hop occurred.
        if (entry.transferSize === 0) continue;
        if ('nextHopProtocol' in entry) {
            hasNextHopProtocolProperty = true;
            if (entry.nextHopProtocol) return entry.nextHopProtocol;
        }
    }
    if (!hasScriptEntries || !hasNextHopProtocolProperty) return 'unsupported';
    return 'unknown';
};
module.exports["getHTTPProtocol"] = $feab3ea7dc0c8aa0$export$b471d97e795847e1;

});

parcelRegister("7W9kD", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $9f0ae7ee0cebc5b7$var$registrations = new Map();
let $9f0ae7ee0cebc5b7$var$observer;
// Bound the addition to the existing UFO payload, even on tenants with many apps.
const $9f0ae7ee0cebc5b7$var$MAX_REPORTED_EXTENSIONS = 50;
const $9f0ae7ee0cebc5b7$export$dbee8f9a070db66b = (element, source, extensionId)=>{
    if (!extensionId || !window.ResizeObserver || !(0, $9wGTI.fg)('confluence_ufo_banner_extension_dimensions')) return;
    if (!$9f0ae7ee0cebc5b7$var$observer) $9f0ae7ee0cebc5b7$var$observer = new ResizeObserver((entries)=>{
        if (!(0, $9wGTI.fg)('confluence_ufo_banner_extension_dimensions')) return;
        for (const entry of entries){
            const registration = $9f0ae7ee0cebc5b7$var$registrations.get(entry.target);
            if (!registration) continue;
            // These wrappers have no padding/border. contentRect supplies physical CSS
            // pixels after layout, without synchronous layout reads or React updates.
            // This measures allocated host space, including any active preset height.
            const { height: height, width: width } = entry.contentRect;
            if (Number.isFinite(height) && Number.isFinite(width) && height >= 0 && width >= 0) registration.dimensions = {
                height: Math.round(height),
                width: Math.round(width)
            };
        }
    });
    const registration = {
        source: source,
        extensionId: extensionId
    };
    $9f0ae7ee0cebc5b7$var$registrations.set(element, registration);
    $9f0ae7ee0cebc5b7$var$observer.observe(element);
    return ()=>{
        if ($9f0ae7ee0cebc5b7$var$registrations.get(element) !== registration) return;
        $9f0ae7ee0cebc5b7$var$observer?.unobserve(element);
        $9f0ae7ee0cebc5b7$var$registrations.delete(element);
        if ($9f0ae7ee0cebc5b7$var$registrations.size === 0) {
            $9f0ae7ee0cebc5b7$var$observer?.disconnect();
            $9f0ae7ee0cebc5b7$var$observer = undefined;
        }
    };
};
const $9f0ae7ee0cebc5b7$export$e4b460b98000468c = ()=>{
    const groups = new Map();
    for (const [element, { source: source, extensionId: extensionId, dimensions: dimensions }] of $9f0ae7ee0cebc5b7$var$registrations){
        if (!element.isConnected || !dimensions) continue;
        const group = groups.get(source) ?? new Map();
        group.set(extensionId, {
            ...dimensions
        });
        groups.set(source, group);
    }
    let reported = 0;
    let omitted = 0;
    const extensionDimensions = Object.fromEntries(Array.from(groups, ([source, dimensions])=>[
            source,
            Object.fromEntries(Array.from(dimensions).filter(()=>{
                if (reported < $9f0ae7ee0cebc5b7$var$MAX_REPORTED_EXTENSIONS) {
                    reported++;
                    return true;
                }
                omitted++;
                return false;
            }))
        ]));
    return {
        extensionDimensions: extensionDimensions,
        ...omitted ? {
            extensionDimensionsOmittedCount: omitted
        } : {}
    };
};
module.exports["observeExtensionDimensions"] = $9f0ae7ee0cebc5b7$export$dbee8f9a070db66b;
module.exports["getExtensionDimensions"] = $9f0ae7ee0cebc5b7$export$e4b460b98000468c;

});

parcelRegister("cG9jM", function(module, exports) {

let $93b0a2a7f13bc525$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $93b0a2a7f13bc525$var$load("e4siW"),
    $93b0a2a7f13bc525$var$load("76XJy")
]).then(()=>parcelRequire('a4qOe'));

});

parcelRegister("gKr8t", function(module, exports) {

var $9B4fQ = parcelRequire("9B4fQ");


var $10d5H = parcelRequire("10d5H");


var $7G1r9 = parcelRequire("7G1r9");


var $2bfWW = parcelRequire("2bfWW");


var $cC0P5 = parcelRequire("cC0P5");


var $adWn1 = parcelRequire("adWn1");


var $9jPdT = parcelRequire("9jPdT");




var $iMHGI = parcelRequire("iMHGI");


var $8xqRi = parcelRequire("8xqRi");


var $3cnNA = parcelRequire("3cnNA");



var $11MAl = parcelRequire("11MAl");


var $5c4nm = parcelRequire("5c4nm");

let $6d0c6b833ab477dd$var$apolloClient = null;
const $6d0c6b833ab477dd$var$wrappedFetch = (0, $iMHGI.createWrappedFetch)();
const $6d0c6b833ab477dd$export$ed315e0c0d70f648 = 'agg';
const $6d0c6b833ab477dd$var$fragmentMatcher = new (0, $cC0P5.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: {
        __schema: {
            types: (0, (/*@__PURE__*/$parcel$interopDefault($adWn1)))
        }
    }
});
const $6d0c6b833ab477dd$export$8ddb56c88a6a3feb = new (0, $5c4nm.BroadcastConfigurableInMemoryCache)({
    fragmentMatcher: $6d0c6b833ab477dd$var$fragmentMatcher
});
const $6d0c6b833ab477dd$export$73fc90876f9d2053 = ()=>{
    $6d0c6b833ab477dd$var$apolloClient = null;
};
const $6d0c6b833ab477dd$export$13fdb03e350a572c = ()=>{
    // Use mock gateway Apollo client in tests
    if (window.MOCK_GATEWAY_APOLLO_CLIENT) return window.MOCK_GATEWAY_APOLLO_CLIENT;
    if (!$6d0c6b833ab477dd$var$apolloClient) {
        $6d0c6b833ab477dd$var$apolloClient = $6d0c6b833ab477dd$var$createApolloClient();
        window.GLOBAL_APOLLO_AGG_CLIENT = $6d0c6b833ab477dd$var$apolloClient;
    }
    return $6d0c6b833ab477dd$var$apolloClient;
};
const $6d0c6b833ab477dd$var$createLinks = ()=>{
    const links = [
        (0, $9jPdT.createOnErrorLink)()
    ];
    const subscriptionLinks = [];
    links.push((0, $11MAl.SSRClientLink)($6d0c6b833ab477dd$export$ed315e0c0d70f648, $6d0c6b833ab477dd$export$8ddb56c88a6a3feb));
    subscriptionLinks.push((0, $3cnNA.AttachExtensionsLink));
    subscriptionLinks.push((0, $8xqRi.getAGGWebSocketLinkInstance)());
    links.push(new (0, $2bfWW.HttpLink)({
        credentials: 'include',
        uri: '/gateway/api/graphql',
        fetch: $6d0c6b833ab477dd$var$wrappedFetch
    }));
    return (0, $10d5H.split)(// Condition for handling subscriptions
    // we don't want to use subscriptions in SSR mode
    ({ query: query })=>{
        const definition = (0, $7G1r9.getMainDefinition)(query);
        return definition?.kind === 'OperationDefinition' && definition?.operation === 'subscription' && // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        true;
    }, // WebSocket link for subscriptions
    (0, $10d5H.from)(subscriptionLinks), // HTTP link for non-subscription operations
    (0, $10d5H.from)(links));
};
const $6d0c6b833ab477dd$var$createApolloClient = ()=>{
    if (typeof window['__APOLLO_AGG_STATE__'] === 'object') $6d0c6b833ab477dd$export$8ddb56c88a6a3feb.restore(window['__APOLLO_AGG_STATE__']);
    const client = new (0, $9B4fQ.ApolloClient)({
        // Prevent cache and network query to refresh when they are already preloaded on server-side.
        // Refreshing data will cause component to fallback to loading state.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        ssrMode: Boolean(undefined),
        connectToDevTools: false,
        link: (0, $10d5H.from)([
            $6d0c6b833ab477dd$var$createLinks()
        ]),
        cache: $6d0c6b833ab477dd$export$8ddb56c88a6a3feb
    });
    // This is not actual API from Apollo. This field is read in next/packages/ssr-app/src/module-replacements/apollo-client.js
    client.__isAGGClient = true;
    return client;
};
module.exports["apolloAGGCache"] = $6d0c6b833ab477dd$export$8ddb56c88a6a3feb;
module.exports["getAGGClient"] = $6d0c6b833ab477dd$export$13fdb03e350a572c;

});

parcelRegister("8xqRi", function(module, exports) {

var $4cvLo = parcelRequire("4cvLo");

function $aa9065bb91596100$export$91893b414ff080f2() {
    let WEBSOCKET_URL;
    WEBSOCKET_URL = `wss://${window?.location?.host}/gateway/api/graphql/subscriptions`;
    return WEBSOCKET_URL;
}
let $aa9065bb91596100$var$wsLink;
function $aa9065bb91596100$export$4b71fe053d09625a() {
    const WEBSOCKET_URL = $aa9065bb91596100$export$91893b414ff080f2();
    if (!$aa9065bb91596100$var$wsLink) $aa9065bb91596100$var$wsLink = new (0, $4cvLo.GraphQLWSLink)({
        url: ()=>{
            return WEBSOCKET_URL;
        },
        shouldRetry: ()=>{
            return true;
        },
        keepAlive: (0, $4cvLo.KEEP_ALIVE),
        retryAttempts: 5
    });
    return $aa9065bb91596100$var$wsLink;
}
module.exports["getAGGWebSocketLinkInstance"] = $aa9065bb91596100$export$4b71fe053d09625a;

});

parcelRegister("4cvLo", function(module, exports) {

var $bKqeQ = parcelRequire("bKqeQ");


var $10d5H = parcelRequire("10d5H");


var $bPh6H = parcelRequire("bPh6H");


var $422HI = parcelRequire("422HI");


var $04e9M = parcelRequire("04e9M");


var $dbZMH = parcelRequire("dbZMH");


var $ac4MN = parcelRequire("ac4MN");


var $bBofs = parcelRequire("bBofs");

const $fca9c472df15863c$export$e9ff5bb5c39478ed = 600000;
class $fca9c472df15863c$export$b26b2f8eae2af9a extends (0, $10d5H.ApolloLink) {
    request(operation) {
        // Add null check for operation.getContext to prevent "Cannot read properties of undefined" errors
        const context = operation.getContext?.() || {};
        // context is coming from a previous link since we are using apollo v2
        // subscriptions does not have context or extensions in some cases
        return new (0, $10d5H.Observable)((observer)=>{
            const subscription = this.client.subscribe({
                ...operation,
                query: (0, $bPh6H.print)(operation.query),
                extensions: context?.extensions
            }, {
                next: (result)=>{
                    // Transform null data to empty object
                    const transformedResult = {
                        ...result,
                        data: result.data === null ? {} : result.data
                    };
                    observer.next(transformedResult);
                },
                complete: observer.complete.bind(observer),
                error: (err)=>{
                    if (this.closedInfo && !this.closedInfo?.wasClean && !err?.message) (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                        client.sendOperationalEvent({
                            source: 'confluence-AGGWebSocketLink',
                            actionSubject: 'webSocket',
                            action: 'closed-socket-error',
                            attributes: {
                                reason: this.closedInfo?.reason,
                                code: this.closedInfo?.code,
                                wasClean: this.closedInfo?.wasClean
                            }
                        });
                    });
                    if (err instanceof Error) return observer.error(err);
                    return observer.error(new (0, $422HI.ApolloErrorInterop)({
                        graphQLErrors: Array.isArray(err) ? err : [
                            err
                        ]
                    }));
                }
            });
            // keep track of the subscription so we can unsubscribe later
            this.replayQueries[operation.operationName] = {
                unsubscribe: subscription,
                query: (0, $bPh6H.print)(operation.query)
            };
            return subscription;
        });
    }
    constructor(options){
        super();
        this.client = void 0;
        this.internetConnectionState = 'healthy';
        this.timedOut = null;
        this.closedInfo = null;
        this.replayQueries = {};
        this.currentGetInternetConnectionStatePromise = null;
        this.onConnected = (_socket, _payload, wasRetry)=>{
            (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                client.sendOperationalEvent({
                    source: 'confluence-AGGWebSocketLink',
                    actionSubject: 'webSocket',
                    action: wasRetry ? 'reconnected' : 'connected'
                });
            });
        };
        this.verifyAndUpdateInternetHealth = async ()=>{
            this.currentGetInternetConnectionStatePromise = this.currentGetInternetConnectionStatePromise || (0, $dbZMH.getInternetConnectionState)();
            const internetHealthState = await this.currentGetInternetConnectionStatePromise;
            this.internetConnectionState = internetHealthState;
            this.currentGetInternetConnectionStatePromise = null;
        };
        this.verifyAndUpdateInternetHealthUntilHealthy = async ()=>{
            await this.verifyAndUpdateInternetHealth();
            if (this.internetConnectionState === 'healthy') return;
            else this.client?.terminate();
            await new Promise((resolve)=>{
                setTimeout(resolve, 500);
            });
            return this.verifyAndUpdateInternetHealthUntilHealthy();
        };
        this.retryWait = async (retries)=>{
            const retryDelayRange = await (0, $ac4MN.getDelayRangeFromGraphqlWebsocketState)(retries);
            // This is the logic reused from legacy WebSocket with a check verifyAndUpdateInternetHealthUntilHealthy
            // If the internet connection is healthy then we can retry, otherwise we do not need to retry
            // We subtract the time spent waiting to reconnect from the exponential backoff
            const startedAt = Date.now();
            await this.verifyAndUpdateInternetHealthUntilHealthy();
            // since we took some time to verify internet health, reduce the exponential backoff
            const msCheckingInternetHealth = Date.now() - startedAt;
            const retryDelay = (0, $ac4MN.getBackOffDelay)({
                range: retryDelayRange,
                timeSpent: msCheckingInternetHealth
            });
            // monitor status looks at if a user is idle or hidden to determine the retry delay
            await new Promise((resolve)=>{
                let timeoutId = setTimeout(resolve, retryDelay);
                const newRetryDelayRange = (0, $bBofs.calculateBackOffRange)({
                    status: 'active',
                    attemptsCount: retries
                });
                const msAlreadyWaited = Date.now() - startedAt;
                const newRetryDelay = (0, $ac4MN.getBackOffDelay)({
                    range: newRetryDelayRange,
                    timeSpent: msAlreadyWaited
                });
                const actualReconnectionDelay = Math.max(newRetryDelay - msAlreadyWaited, 0);
                // Clear old timeout and set a new one with the updated delay
                clearTimeout(timeoutId);
                timeoutId = setTimeout(resolve, actualReconnectionDelay);
            });
        };
        this.client = (0, $bKqeQ.createClient)({
            ...options,
            retryWait: this.retryWait,
            on: {
                connected: this.onConnected,
                closed: (info)=>{
                    this.closedInfo = info;
                },
                ping: (received)=>{
                    if (!received /* sent */ ) this.timedOut = setTimeout(()=>{
                        // unsubscribe so that we can reconnect with new arguments
                        for(const key in this.replayQueries)// unsubscribes queries so that we can reconnect with new arguments
                        if (this.replayQueries[key]) {
                            this.replayQueries[key].unsubscribe();
                            delete this.replayQueries[key];
                        }
                        this.client.terminate();
                    }, $fca9c472df15863c$export$e9ff5bb5c39478ed / 2);
                },
                pong: (received)=>{
                    if (received && this.timedOut !== null) clearTimeout(this.timedOut);
                }
            }
        });
    }
}
module.exports["KEEP_ALIVE"] = $fca9c472df15863c$export$e9ff5bb5c39478ed;
module.exports["GraphQLWSLink"] = $fca9c472df15863c$export$b26b2f8eae2af9a;

});

parcelRegister("dbZMH", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getInternetConnectionState.ts when we move to Relay.
 */ // partially copied from Trello modified to use confluences network check
const $3d23f6bbdf409903$export$ddfffe3f5c167fa6 = async ()=>{
    // we can early return unhealthy if offline for navigator, but we cant if onLine.
    // That's because you can be online, but be waiting for VPN connection or something
    // else that blocks actually allowing internet.
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (!navigator.onLine) return 'unhealthy';
    for(let i = 0; i < 3; i++){
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        if (!navigator.onLine) return 'unhealthy';
        // stagger it a little because of flakey VPN's and firewalls
        await new Promise((res)=>setTimeout(res, 1000));
    }
    // we got 3 good attempts, safe to say healthy
    return 'healthy';
};
module.exports["getInternetConnectionState"] = $3d23f6bbdf409903$export$ddfffe3f5c167fa6;

});

parcelRegister("ac4MN", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getBackOffDelay.ts when we move to Relay.
 */ // copied from Trello

var $bBofs = parcelRequire("bBofs");

function $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(start, end) {
    const spread = end - start;
    return Math.floor(start + Math.random() * spread);
}
const $5a87cb4548ea235b$export$73e02b3a26ecb0d7 = ({ range: range, timeSpent: timeSpent = 0 })=>{
    const [lowerBound, upperBound] = range;
    const delay = $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(lowerBound, upperBound);
    return Math.max(delay - timeSpent, 0);
};
const $5a87cb4548ea235b$export$ac8ba6656a385f56 = async (retries)=>{
    /**
	 * We're overriding the status multipliers here to make the reconnection
	 * back-off less aggressive. To reduce client
	 * reconnect load on graphql-subscriptions.
	 * The default status multipliers are: { active: 1, idle: 10 }.
	 */ const activeMultiplier = 1;
    let status = 'idle';
    if (typeof window !== 'undefined') // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    status = document.visibilityState === 'visible' ? 'active' : 'idle';
    else status = 'idle';
    return (0, $bBofs.calculateBackOffRange)({
        status: status,
        attemptsCount: retries,
        statusMultipliersOverride: {
            active: activeMultiplier,
            idle: 10
        }
    });
};
module.exports["getBackOffDelay"] = $5a87cb4548ea235b$export$73e02b3a26ecb0d7;
module.exports["getDelayRangeFromGraphqlWebsocketState"] = $5a87cb4548ea235b$export$ac8ba6656a385f56;

});

parcelRegister("bBofs", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/calculateBackOffRange.ts when we move to Relay.
 */ // copied from Trello

var $11y02 = parcelRequire("11y02");

function $35212ac5bc2e900f$export$de85ae9dfb4a57bc({ status: status, attemptsCount: attemptsCount, statusMultipliersOverride: statusMultipliersOverride, jitterStatusMultipliersOverride: jitterStatusMultipliersOverride, connectionHealth: connectionHealth = 'base', baseLowerBoundOverride: baseLowerBoundOverride, baseUpperBoundOverride: baseUpperBoundOverride, maxDelayOverride: maxDelayOverride }) {
    const [baseLowerBound, baseUpperBound] = (0, $11y02.getReconnectDelayBounds)(connectionHealth);
    const maxDelay = maxDelayOverride ?? (0, $11y02.getMaxDelay)({
        status: status,
        connectionHealth: connectionHealth
    });
    const statusMultipliers = statusMultipliersOverride ?? (0, $11y02.getDefaultStatusMultipliers)();
    const jitterStatusMultipliers = jitterStatusMultipliersOverride ?? (0, $11y02.jitterStatusMultipliers);
    const attemptsMultiplier = Math.pow(2, attemptsCount);
    const totalMultiplier = statusMultipliers[status] * attemptsMultiplier;
    const jitterMultiplier = jitterStatusMultipliers[status];
    const maxFirstActiveDelay = 2000;
    const maxFirstIdleDelay = 60000;
    let tempUpperOverride;
    if (attemptsCount > 0) tempUpperOverride = undefined;
    else if (status === 'active') tempUpperOverride = maxFirstActiveDelay;
    else tempUpperOverride = maxFirstIdleDelay;
    const lowerBound = (baseLowerBoundOverride ?? baseLowerBound) * totalMultiplier;
    const upperBound = tempUpperOverride ?? (baseUpperBoundOverride ?? baseUpperBound) * totalMultiplier * jitterMultiplier;
    return [
        Math.min(lowerBound, maxDelay),
        Math.min(upperBound, maxDelay)
    ];
}
module.exports["calculateBackOffRange"] = $35212ac5bc2e900f$export$de85ae9dfb4a57bc;

});

parcelRegister("11y02", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/backOffConfig.ts when we move to Relay.
 */ // copied from Trello
const $0b8d464841156fc9$var$TEN_MINUTES_IN_MS = 600000;
const $0b8d464841156fc9$export$d89658363be37383 = ({ status: status, connectionHealth: connectionHealth })=>{
    const maxDelays = {
        active: {
            base: 64000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        },
        idle: {
            base: 450000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        }
    };
    return maxDelays[status][connectionHealth];
};
const $0b8d464841156fc9$export$1b131e77a0e75a0a = ()=>({
        active: 1,
        idle: 15
    });
const $0b8d464841156fc9$export$a1d6d3ff41cd93e9 = {
    active: 1,
    idle: 2
};
const $0b8d464841156fc9$export$e5680a2329370bd3 = (connectionHealth)=>{
    const bounds = {
        base: [
            800,
            2000
        ],
        serverIncident: [
            800,
            4000
        ]
    };
    return bounds[connectionHealth];
};
module.exports["getMaxDelay"] = $0b8d464841156fc9$export$d89658363be37383;
module.exports["getDefaultStatusMultipliers"] = $0b8d464841156fc9$export$1b131e77a0e75a0a;
module.exports["jitterStatusMultipliers"] = $0b8d464841156fc9$export$a1d6d3ff41cd93e9;
module.exports["getReconnectDelayBounds"] = $0b8d464841156fc9$export$e5680a2329370bd3;

});

parcelRegister("3cnNA", function(module, exports) {

var $10d5H = parcelRequire("10d5H");

const $eb414ef0fc36a486$export$51a2bb897a605125 = new (0, $10d5H.ApolloLink)((operation, forward)=>{
    if (operation.variables && operation.variables.__extensions) {
        operation.setContext({
            extensions: operation.variables.__extensions
        });
        // remove the property since it's not an actual valid variable
        delete operation.variables.__extensions;
    }
    return forward(operation);
});
module.exports["AttachExtensionsLink"] = $eb414ef0fc36a486$export$51a2bb897a605125;

});

parcelRegister("1E17N", function(module, exports) {

let $132a663b7640cb52$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $132a663b7640cb52$var$load("gSXIX").then(()=>parcelRequire('kWFOs'));

});

parcelRegister("lyWac", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");


var $3mugH = parcelRequire("3mugH");

// Mirrors GraphqlErrorProcessor's mark. Read through the global symbol registry rather than
// importing `isErrorMarkedAsHandled`, because ~20 test files mock
// `@confluence/graphql-error-processor` partially and a new import here would break all of them.
// The registry is the same mechanism GraphqlErrorProcessor relies on to share the mark across the
// preloader and main-app bundles, and `ignores errors already marked as handled` in this module's
// tests exercises the real `markErrorAsHandled`, so the key cannot drift unnoticed.
const $6e8f7926b945fe5e$var$HANDLED_ERROR_MARK_SYMBOL = Symbol.for('error marked as handled');
function $6e8f7926b945fe5e$var$isErrorMarkedAsHandled(error) {
    return typeof error === 'object' && error !== null && Boolean(error[$6e8f7926b945fe5e$var$HANDLED_ERROR_MARK_SYMBOL]);
}
const $6e8f7926b945fe5e$var$isLegacyUnauthorizedGraphQLError = (error)=>error?.extensions?.data?.authorized === false;
/**
 * A page the viewer is not allowed to see is a normal SSR outcome, not a defect — the render falls
 * back to the restricted-content screen. `query()` marks these as handled when a preloader resolves
 * with its query result, but a task that *rejects* with a permission error (or resolves with the
 * error itself) never passes through that path, so the handled mark alone does not keep restricted
 * pages out of the SSR prepare errors.
 *
 * Covers both status codes of the permission contract — 401 (unauthenticated) and 403 (not
 * permitted) — plus the legacy `extensions.data.authorized === false` shape, matching
 * `@confluence/unauthorized-error-boundary`. `isStatusCodeError` walks `graphQLErrors`,
 * `networkError` and `originalError`, so a rejected ApolloError wrapping a 403 is recognised too.
 * `@confluence/error-types` is used rather than the boundary's copy of this predicate to keep React
 * out of the preloader bundle.
 *
 * https://pug.jira-dev.com/wiki/spaces/CCB/pages/4709260932/GraphQL+Errors+Contract+for+Status+Code+401+and+403
 */ function $6e8f7926b945fe5e$var$isPermissionError(error) {
    const candidate = error;
    return (0, $aMcHK.isStatusCodeError)(candidate, '403', $6e8f7926b945fe5e$var$isLegacyUnauthorizedGraphQLError) || (0, $aMcHK.isStatusCodeError)(candidate, '401');
}
/**
 * Errors that are an expected outcome of preloading and must not be reported as SSR prepare errors.
 */ function $6e8f7926b945fe5e$var$isExpectedPreloadError(error) {
    return $6e8f7926b945fe5e$var$isErrorMarkedAsHandled(error) || $6e8f7926b945fe5e$var$isPermissionError(error);
}
function $6e8f7926b945fe5e$var$expandErrorToErrors(error) {
    // Error from createDataFetcherForSuspense might have nested errors
    const errors = [
        error
    ];
    if (Array.isArray(error.otherErrors)) errors.push(...error.otherErrors);
    delete error.otherErrors;
    return errors;
}
/**
 * `query()` and `queryAgg()` resolve to `{ data, errors, hasErrors }` rather than rejecting or
 * resolving to an `Error`, so a preloader that returns its result object straight into the task
 * list would otherwise slip past the `instanceof Error` checks below.
 */ function $6e8f7926b945fe5e$var$isPreloaderQueryResultWithErrors(value) {
    return typeof value === 'object' && value !== null && value.hasErrors === true && Array.isArray(value.errors);
}
/**
 * Only surfaces errors nobody has claimed. `query()` marks the expected ones (unauthorized,
 * not-found, and other known shapes) as handled before resolving, and those still come back with
 * `hasErrors: true` — reporting them here would turn every restricted or missing page into a bogus
 * SSR prepare error, since preloaders like `preloadPageStatusQuery` return their result object
 * straight into the task list.
 *
 * Filtering happens here, before the conversion below, because `new Error(message)` drops
 * `extensions` — the only place the permission status code lives on a plain GraphQL error object.
 */ function $6e8f7926b945fe5e$var$collectUnhandledQueryErrors(result) {
    const unhandledErrors = [];
    for (const error of result.errors ?? []){
        if ($6e8f7926b945fe5e$var$isExpectedPreloadError(error)) continue;
        unhandledErrors.push(error instanceof Error ? error : new Error(String(error?.message ?? error)));
    }
    return unhandledErrors;
}
function $6e8f7926b945fe5e$var$collectErrorsFromFulfilledValue(fulfilledValue) {
    if (fulfilledValue instanceof Error) return $6e8f7926b945fe5e$var$expandErrorToErrors(fulfilledValue);
    if (Array.isArray(fulfilledValue)) return fulfilledValue.flatMap((value)=>value instanceof Error || $6e8f7926b945fe5e$var$isPreloaderQueryResultWithErrors(value) ? $6e8f7926b945fe5e$var$collectErrorsFromFulfilledValue(value) : []);
    if ($6e8f7926b945fe5e$var$isPreloaderQueryResultWithErrors(fulfilledValue)) return $6e8f7926b945fe5e$var$collectUnhandledQueryErrors(fulfilledValue);
    return [];
}
async function $6e8f7926b945fe5e$export$ba9c3910d56be969(values) {
    if (!Array.isArray(values)) values = [
        values
    ];
    return Promise.allSettled(values).then((results)=>{
        const errors = [];
        for (const result of results){
            if (result.status === 'rejected') errors.push(...$6e8f7926b945fe5e$var$expandErrorToErrors(result.reason));
            else if (result.status === 'fulfilled') errors.push(...$6e8f7926b945fe5e$var$collectErrorsFromFulfilledValue(result.value));
        }
        // Drop the expected outcomes — already-handled and permission errors — so a restricted page
        // does not report a prepare error. Rejections and error values are filtered here rather than
        // at each collection site so that every path is held to the same rule; query results are
        // filtered earlier, while their `extensions` are still intact.
        const reportableErrors = errors.filter((error)=>!$6e8f7926b945fe5e$var$isExpectedPreloadError(error));
        if (reportableErrors.length > 0) {
            // Errors on preloader functions are not meant to break anything.
            // But we still want to know them...
            for (const error of reportableErrors)(0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Error caught by waitForAllReturnWhenError: ${error.message}`));
            return reportableErrors;
        }
    });
}
module.exports["waitForAllReturnWhenError"] = $6e8f7926b945fe5e$export$ba9c3910d56be969;

});

parcelRegister("3mugH", function(module, exports) {

var $lrjR8 = parcelRequire("lrjR8");

const $d967841d02dde0d1$export$17bc715070d0e7ef = new (0, $lrjR8.SSRPrepareErrorsClient)();
module.exports["ssrPrepareErrorsClient"] = $d967841d02dde0d1$export$17bc715070d0e7ef;

});

parcelRegister("lrjR8", function(module, exports) {
class $7cc20c0ac0ad5b24$export$622a2782a1f9c63 {
    submitError(e, errorData = {}) {
        let additional = {};
        // Not actually importing the error class to avoid circular dependency
        const response = // RateLimitedError or BadStatusError
        e?.response || // Apollo Error
        e?.networkError?.response;
        if (response) additional = {
            response: {
                url: response.url,
                status: response.status,
                statusText: response.statusText
            }
        };
        this.errors.push({
            error: {
                message: e.message,
                stack: e.stack
            },
            meta: errorData,
            ...additional
        });
    }
    getErrors() {
        return this.errors;
    }
    constructor(){
        this.errors = void 0;
        this.errors = [];
    }
}
module.exports["SSRPrepareErrorsClient"] = $7cc20c0ac0ad5b24$export$622a2782a1f9c63;

});

parcelRegister("bPDOf", function(module, exports) {
const $4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575 = {
    hasSeenAIFCSpotlight: 'aifc-onboarding:hasSeenAIFCSpotlight',
    isAIFCSpotlightActive: 'aifc-onboarding:isAIFCSpotlightActive',
    hasSeenWhiteboardSmartCreateSpotlight: 'aifc-onboarding:hasSeenWhiteboardSmartCreateSpotlight',
    hasSeenTrackChangesStreamingSpotlight: 'aifc-onboarding:hasSeenTrackChangesStreamingSpotlight',
    isAIFCChatSpotlightActive: 'aifc-onboarding:isAIFCChatSpotlightActive',
    hasSeenAIFCChatSpotlight: 'aifc-onboarding:hasSeenAIFCChatSpotlight',
    hasDismissedGettingStartedTour: 'aifc-onboarding:hasDismissedGettingStartedTour',
    hasSeenDeeplinkReturnSpotlight: 'aifc-onboarding:hasSeenDeeplinkReturnSpotlight',
    hasSeenTwcAifcOnboarding: 'aifc-onboarding:hasSeenTwcAifcOnboarding'
};
const $4fc1e4c0ecd68c6d$export$6024bf9594f957fe = Object.values($4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575);
module.exports["AIFC_ONBOARDING_STATE_KEYS"] = $4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575;
module.exports["AIFCOnboardingKeys"] = $4fc1e4c0ecd68c6d$export$6024bf9594f957fe;

});

parcelRegister("8Z78B", function(module, exports) {
/**
 * @generated SignedSource<<abe1bfe242e74d4385961078bad185f8>>
 * @relayHash 56e1784a86c45537dbf4ab9c8bb1ffba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7
const $38160060fa19c5ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "key"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "56e1784a86c45537dbf4ab9c8bb1ffba",
            "id": "3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7",
            "metadata": {},
            "name": "onboardingStateGetOnboardingStateQuery",
            "operationKind": "query",
            "text": "query onboardingStateGetOnboardingStateQuery($key:[String]){onboardingState(key:$key){key,value}}"
        }
    };
}();
$38160060fa19c5ea$var$node.hash = "201bff99b2bdca3d23c658876502ced3";
var $38160060fa19c5ea$export$2e2bcd8739ae039 = $38160060fa19c5ea$var$node;
module.exports["default"] = $38160060fa19c5ea$export$2e2bcd8739ae039;

});

parcelRegister("9fLxI", function(module, exports) {
async function $2552b7855153149c$export$573ee875a39e7e73({ spaceKey: spaceKey } = {
    spaceKey: undefined
}) {
    if (spaceKey) {
        var _window;
        const extensionManifestSpaceaware = (_window = window).__EXTENSION_MANIFEST_SPACEAWARE__ || (_window.__EXTENSION_MANIFEST_SPACEAWARE__ = {});
        if (!extensionManifestSpaceaware[spaceKey]) extensionManifestSpaceaware[spaceKey] = $2552b7855153149c$var$fetchExtensionManifests(spaceKey);
        return extensionManifestSpaceaware[spaceKey];
    }
    if (!window.__EXTENSION_MANIFEST__) window.__EXTENSION_MANIFEST__ = $2552b7855153149c$var$fetchExtensionManifests();
    return window.__EXTENSION_MANIFEST__;
}
function $2552b7855153149c$var$fetchExtensionManifests(spaceKey) {
    // eslint-disable-next-line check-credentials-option/has-credentials-option,no-restricted-syntax
    return fetch(`/wiki/plugins/macrobrowser/browse-macros.action?detailed=true&origin=extension-provider${spaceKey ? `&spaceKey=${spaceKey}` : ''}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((response)=>response.json());
}
module.exports["getExtensionManifest"] = $2552b7855153149c$export$573ee875a39e7e73;

});

parcelRegister("l6Xaz", function(module, exports) {
const $372ebd682f0fb003$var$SCRIPT_REGEX = /<script([^>]*)\/*>/gi;
// @ts-expect-error - TS1503 Typescript 5.9.2 upgrade
const $372ebd682f0fb003$var$QUOTES_REGEX = RegExp("^([\"']*)(?<value>.*?)\\1$");
const $372ebd682f0fb003$var$SPACE_REGEX = /\s+/;
function $372ebd682f0fb003$export$79fe7bf3ba344d67(tags, linksMode = false, matcher = $372ebd682f0fb003$var$SCRIPT_REGEX) {
    // Parse <script key="value">/script> into { key: "value" }
    if (linksMode) return Array.isArray(tags) ? tags.map((t)=>({
            src: t
        })) : [];
    if (typeof tags !== 'string') return [];
    const result = [];
    for (const [, attributes] of tags.matchAll(matcher))result.push(Object.fromEntries(attributes.split($372ebd682f0fb003$var$SPACE_REGEX).filter((pair)=>pair).map((pair)=>{
        const pos = pair.indexOf('=');
        if (pos !== -1) {
            const key = pair.substring(0, pos);
            const rawValue = pair.substring(pos + 1);
            const match = rawValue.match($372ebd682f0fb003$var$QUOTES_REGEX);
            const value = match?.groups?.value ?? rawValue;
            return [
                key,
                value
            ];
        } else return [
            pair,
            pair
        ];
    })));
    return result;
}
function $372ebd682f0fb003$export$a0d21c5c067fafcf(attributes) {
    // Convert { key: value } to key="value"
    const result = Object.entries(attributes).map(([key, value])=>value && key !== value ? `${key}="${value}"` : key).join(' ');
    return result ? ` ${result}` : '';
}
function $372ebd682f0fb003$export$eccc4243452442c6(tags) {
    // Jquery is always loaded in packages/confluence-frontend-server/templates/html/dashboard-spa-container.js
    // So we need to remove it from the superbatch tags
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).filter((attrs)=>attrs['data-wrm-key'] !== 'com.atlassian.plugins.jquery:jquery').map((attrs)=>`<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attrs)}></script>`).join('\n');
}
function $372ebd682f0fb003$export$a26b30913d2c455f(tags) {
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).map((attributes)=>{
        attributes['defer'] = 'defer';
        return `<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}></script>`;
    }).join('\n');
}
const $372ebd682f0fb003$var$srcExtractor = /src=["'](.*?)["']/gi;
function $372ebd682f0fb003$export$7ffad14b7106f714(jsTags) {
    if (!jsTags) return '';
    return [
        ...jsTags.matchAll($372ebd682f0fb003$var$srcExtractor)
    ].map((match)=>match[1]).filter((src)=>!!src).map((src)=>`<link rel="preload" href="${src}" as="script">`).join('\n');
}
function $372ebd682f0fb003$export$893dc3b18722ac51(resource, asyncScript = false) {
    const nonce = window.__SSR_NONCE_VALUE__;
    const attributes = Array.isArray(resource?.attributes) ? Object.fromEntries(resource.attributes.map((attr)=>[
            attr.key,
            attr.value
        ])) : resource.attributes || {};
    if (resource.type === 'css') return `<link rel="stylesheet" nonce="${nonce}" href="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)} />`;
    else if (resource.type === 'js') return `<script nonce="${nonce}" src="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}${asyncScript ? ' async fetchpriority="high"' : ''}></script>`;
    return '';
}
module.exports["parseScriptTags"] = $372ebd682f0fb003$export$79fe7bf3ba344d67;
module.exports["removeJquery"] = $372ebd682f0fb003$export$eccc4243452442c6;
module.exports["deferScript"] = $372ebd682f0fb003$export$a26b30913d2c455f;
module.exports["convertSuperBatchResourceToTags"] = $372ebd682f0fb003$export$893dc3b18722ac51;

});

parcelRegister("d6NtA", function(module, exports) {
var $54fed5011c3efebd$export$c32b36f46293e67b = /*#__PURE__*/ function(MicrosEnvironmentType) {
    MicrosEnvironmentType["local"] = "local";
    MicrosEnvironmentType["dev"] = "dev";
    MicrosEnvironmentType["staging"] = "staging";
    MicrosEnvironmentType["prod"] = "prod";
    return MicrosEnvironmentType;
}({});
const $54fed5011c3efebd$export$6dd1bbd39f571125 = ()=>false;
const $54fed5011c3efebd$export$23da1d24a38b0bde = ()=>globalThis.ssrContext.environmentType === "staging";
const $54fed5011c3efebd$export$64471597a28217e6 = ()=>$54fed5011c3efebd$export$6dd1bbd39f571125() || $54fed5011c3efebd$export$23da1d24a38b0bde() || globalThis.ssrContext.environmentType === "dev";
const $54fed5011c3efebd$export$4bd44a2aa29d3d6e = ()=>globalThis.ssrContext.environment;
const $54fed5011c3efebd$export$1038046b28a1d92e = ()=>globalThis.ssrContext.environmentType;
const $54fed5011c3efebd$export$94e128262c4fa6c3 = ()=>globalThis.ssrContext.entryScriptVersionId;
const $54fed5011c3efebd$export$4caa72c46cbac3be = ()=>globalThis.ssrContext?.runtimeImageVersion ?? 'unknown';
const $54fed5011c3efebd$export$7d4093513f0cae50 = ()=>globalThis.ssrContext?.isInShadow === true;
function $54fed5011c3efebd$export$bcbc3e9e1c9133d4() {
    return globalThis.ssrContext.isInIC === true;
}
function $54fed5011c3efebd$export$4b05536c6e03cc69() {
    return globalThis.ssrContext?.isInFedramp === true;
}
function $54fed5011c3efebd$export$9cbc7f94bfb6210() {
    return globalThis.ssrContext.icName;
}
function $54fed5011c3efebd$export$eb7aff7f8b96b11f() {
    return globalThis.ssrContext.isInGCP === true;
}
function $54fed5011c3efebd$export$f0bc966c9609c798() {
    return globalThis.ssrContext.cellName;
}
module.exports["isLocal"] = $54fed5011c3efebd$export$6dd1bbd39f571125;

});

parcelRegister("8nle6", function(module, exports) {
$parcel$export(module.exports, "preloadSpaceDetail", () => (parcelRequire("5SzHz")).preloadSpaceDetail);
$parcel$export(module.exports, "preloadPersonalSpaceDetail", () => (parcelRequire("jLyos")).preloadPersonalSpaceDetail);
$parcel$export(module.exports, "preloadPersonalSpaceDetailsQuery", () => (parcelRequire("jLyos")).preloadPersonalSpaceDetailsQuery);
$parcel$export(module.exports, "ConfluenceSpaceType", () => (parcelRequire("bgmQP")).ConfluenceSpaceType);
/* eslint-disable check-multiple-entry-point-exports/check-multiple-entry-point-exports */ 
var $jmjWc = parcelRequire("jmjWc");


var $5SzHz = parcelRequire("5SzHz");


var $jLyos = parcelRequire("jLyos");


var $bgmQP = parcelRequire("bgmQP");


const $b92195a33e0fb686$export$f10aab7c26f92d55 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7NksR",
    name: "SpaceTargetSelect",
    loader: async ()=>(await Promise.resolve((parcelRequire("bgmQP")))).SpaceTargetSelect
});
module.exports["SpaceTargetSelect"] = $b92195a33e0fb686$export$f10aab7c26f92d55;

});

parcelRegister("5SzHz", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $4ZxLt = parcelRequire("4ZxLt");

const $01831239f93415a0$var$getEmptyResult = ()=>Promise.resolve({
        data: null,
        loading: false,
        error: null
    });
const $01831239f93415a0$export$ec3af86ec6a1dfc6 = async (spaceKey = '', { includeSpaceTypeSettings: includeSpaceTypeSettings = false } = {})=>{
    if (spaceKey) return (0, $dYU3e.query)({
        query: (0, $4ZxLt.default),
        variables: {
            spaceKey: spaceKey,
            includeSpaceTypeSettings: includeSpaceTypeSettings
        },
        __callerPackage__: "space-utils"
    });
    return $01831239f93415a0$var$getEmptyResult();
};
const $01831239f93415a0$export$2403e25f29f92c16 = async (spaceKey = '', options)=>{
    return $01831239f93415a0$export$ec3af86ec6a1dfc6(spaceKey, options);
};
module.exports["fetchSpaceDetail"] = $01831239f93415a0$export$ec3af86ec6a1dfc6;
module.exports["preloadSpaceDetail"] = $01831239f93415a0$export$2403e25f29f92c16;

});

parcelRegister("4ZxLt", function(module, exports) {
/**
 * @generated SignedSource<<76836bee9d3181bb32ece1357a68e03f>>
 * @relayHash 8503b5ca122c8b61cd10af1b1c2004c9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b
const $cc63beb8a5381fdf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeSpaceTypeSettings"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "dataClassificationTags"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "condition": "includeSpaceTypeSettings",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "SpaceTypeSettings",
                            "kind": "LinkedField",
                            "name": "spaceTypeSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "EnabledContentTypes",
                                    "kind": "LinkedField",
                                    "name": "enabledContentTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isLivePagesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isWhiteboardsEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDatabasesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isSlidesEnabled"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "8503b5ca122c8b61cd10af1b1c2004c9",
            "id": "3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b",
            "metadata": {},
            "name": "useSpaceDetailQuery",
            "operationKind": "query",
            "text": "query useSpaceDetailQuery($spaceKey:String,$includeSpaceTypeSettings:Boolean!){space(key:$spaceKey){id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path},spaceTypeSettings@include(if:$includeSpaceTypeSettings){enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled,isSlidesEnabled}}}}"
        }
    };
}();
$cc63beb8a5381fdf$var$node.hash = "591d4790bc30ed0352bb44ad552d45cb";
var $cc63beb8a5381fdf$export$2e2bcd8739ae039 = $cc63beb8a5381fdf$var$node;
module.exports["default"] = $cc63beb8a5381fdf$export$2e2bcd8739ae039;

});

parcelRegister("jLyos", function(module, exports) {

var $a2WOL = parcelRequire("a2WOL");


var $dYU3e = parcelRequire("dYU3e");

const $51133d1487ddd8f7$export$945871a9cdda3d0b = (0, $a2WOL.default);
const $51133d1487ddd8f7$export$88da34a67bdae7e0 = ()=>{
    return (0, $dYU3e.query)({
        query: $51133d1487ddd8f7$export$945871a9cdda3d0b,
        __callerPackage__: "space-utils"
    });
};
module.exports["preloadPersonalSpaceDetailsQuery"] = $51133d1487ddd8f7$export$945871a9cdda3d0b;
module.exports["preloadPersonalSpaceDetail"] = $51133d1487ddd8f7$export$88da34a67bdae7e0;

});

parcelRegister("a2WOL", function(module, exports) {
/**
 * @generated SignedSource<<99c90ef1034a28215bdf926b84b02699>>
 * @relayHash 0616a22c791eb8d27cd97c38dbbaaaed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fdab4f721e30e106cb6e937af7ef465a8e7ce5047eb501ede326a1f7618e0cbb
const $fb9284d373020379$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "dataClassificationTags"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "preloadPersonalSpaceDetailsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "preloadPersonalSpaceDetailsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0616a22c791eb8d27cd97c38dbbaaaed",
            "id": "fdab4f721e30e106cb6e937af7ef465a8e7ce5047eb501ede326a1f7618e0cbb",
            "metadata": {},
            "name": "preloadPersonalSpaceDetailsQuery",
            "operationKind": "query",
            "text": "query preloadPersonalSpaceDetailsQuery{user:confluence_atlassianUser(current:true){id,confluence{space{id,key,dataClassificationTags}}}}"
        }
    };
}();
$fb9284d373020379$var$node.hash = "a2cf47cae3a68d2f66118a725dfea818";
var $fb9284d373020379$export$2e2bcd8739ae039 = $fb9284d373020379$var$node;
module.exports["default"] = $fb9284d373020379$export$2e2bcd8739ae039;

});

parcelRegister("bgmQP", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6wGOF = parcelRequire("6wGOF");


var $l9ukq = parcelRequire("l9ukq");


var $iMnC5 = parcelRequire("iMnC5");


var $4aRua = parcelRequire("4aRua");


var $jp2Q3 = parcelRequire("jp2Q3");

var $c8b68f6ea32b0094$export$2fabe69f8125d5a7 = /*#__PURE__*/ function(ConfluenceSpaceType) {
    ConfluenceSpaceType["ALL"] = "ALL";
    ConfluenceSpaceType["ALL_EXCEPT_PERSONAL"] = "ALL_EXCEPT_PERSONAL";
    ConfluenceSpaceType["ALL_EXCEPT_SPECIFIC"] = "ALL_EXCEPT_SPECIFIC";
    ConfluenceSpaceType["PERSONAL"] = "PERSONAL";
    ConfluenceSpaceType["SPECIFIC"] = "SPECIFIC";
    return ConfluenceSpaceType;
}({});
const $c8b68f6ea32b0094$var$i18n = (0, $kSwu1.defineMessages)({
    ariaLabel: {
        id: "space-utils.permissions-export.form.space-target-select.aria-label",
        defaultMessage: "For which spaces"
    },
    all: {
        id: "space-utils.space-target-select.all",
        defaultMessage: "All"
    },
    allDescription: {
        id: "space-utils.space-target-select.allDescription",
        defaultMessage: "All spaces, regardless of type"
    },
    allExcludingPersonal: {
        id: "space-utils.space-target-select.allExcludingPersonal",
        defaultMessage: "All (excluding personal)"
    },
    allExcludingPersonalDescription: {
        id: "space-utils.space-target-select.allExcludingPersonalDescription",
        defaultMessage: "Don't include any personal spaces"
    },
    allExcludingSpecific: {
        id: "space-utils.space-target-select.allExcludingSpecific",
        defaultMessage: "All (excluding specific spaces)"
    },
    allExcludingSpecificDescription: {
        id: "space-utils.space-target-select.allExcludingSpecificDescription",
        defaultMessage: "Choose specific spaces to exclude"
    },
    personal: {
        id: "space-utils.space-target-select.personal",
        defaultMessage: "Only personal"
    },
    personalDescription: {
        id: "space-utils.space-target-select.personalDescription",
        defaultMessage: "All personal spaces"
    },
    specific: {
        id: "space-utils.space-target-select.specific",
        defaultMessage: "Only specific spaces"
    },
    specificDescription: {
        id: "space-utils.space-target-select.specificDescription",
        defaultMessage: "Choose specific spaces to include"
    }
});
const $c8b68f6ea32b0094$var$menuItemStyle = {
    style: "_2mHwu81Y8M _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $c8b68f6ea32b0094$var$CustomOption = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((props)=>{
    const $ = (0, $bDgLe.c)(10);
    let t0;
    if ($[0] !== props.data.label) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, props.data.label);
        $[0] = props.data.label;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props.data.description) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest"
        }, props.data.description);
        $[2] = props.data.description;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $c8b68f6ea32b0094$var$menuItemStyle.style
        }, t0, t1);
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== props || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Option, props, t2);
        $[7] = props;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
});
const $c8b68f6ea32b0094$var$SELECT_STYLE_PROPS = {
    isSearchable: false,
    styles: {
        menu: (base)=>({
                ...base,
                width: '320px',
                padding: 0,
                margin: 0,
                zIndex: (0, $jp2Q3.layers).modal() + 1 // Higher than modal to appear above modal content
            }),
        menuPortal: (base)=>({
                ...base,
                zIndex: (0, $jp2Q3.layers).modal() + 1 // Higher than modal to appear above modal content
            }),
        control: (base)=>({
                ...base,
                width: '320px',
                padding: 0,
                margin: 0
            })
    }
};
const $c8b68f6ea32b0094$var$SPACE_TARGET_OPTIONS = [
    {
        label: 'all',
        value: "ALL",
        description: 'allDescription'
    },
    {
        label: 'allExcludingPersonal',
        value: "ALL_EXCEPT_PERSONAL",
        description: 'allExcludingPersonalDescription'
    },
    {
        label: 'allExcludingSpecific',
        value: "ALL_EXCEPT_SPECIFIC",
        description: 'allExcludingSpecificDescription'
    },
    {
        label: 'personal',
        value: "PERSONAL",
        description: 'personalDescription'
    },
    {
        label: 'specific',
        value: "SPECIFIC",
        description: 'specificDescription'
    }
];
const $c8b68f6ea32b0094$export$f10aab7c26f92d55 = (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { onChange: onChange, spaceTargetValue: spaceTargetValue, menuPortalTarget: menuPortalTarget } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let T0;
    let t1;
    let t2;
    let t3;
    if ($[0] !== formatMessage || $[1] !== onChange || $[2] !== spaceTargetValue) {
        let t4;
        if ($[7] !== formatMessage) {
            t4 = (option)=>({
                    label: formatMessage($c8b68f6ea32b0094$var$i18n[option.label]),
                    value: option.value,
                    description: formatMessage($c8b68f6ea32b0094$var$i18n[option.description])
                });
            $[7] = formatMessage;
            $[8] = t4;
        } else t4 = $[8];
        const options = $c8b68f6ea32b0094$var$SPACE_TARGET_OPTIONS.map(t4);
        T0 = (0, $6wGOF.default);
        t1 = options;
        if ($[9] !== onChange) {
            t2 = (newValue)=>onChange(newValue?.value);
            $[9] = onChange;
            $[10] = t2;
        } else t2 = $[10];
        let t5;
        if ($[11] !== spaceTargetValue) {
            t5 = (option_0)=>String(option_0.value) === String(spaceTargetValue);
            $[11] = spaceTargetValue;
            $[12] = t5;
        } else t5 = $[12];
        t3 = options.find(t5);
        $[0] = formatMessage;
        $[1] = onChange;
        $[2] = spaceTargetValue;
        $[3] = T0;
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else {
        T0 = $[3];
        t1 = $[4];
        t2 = $[5];
        t3 = $[6];
    }
    let t4;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            Option: $c8b68f6ea32b0094$var$CustomOption
        };
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== formatMessage) {
        t5 = formatMessage($c8b68f6ea32b0094$var$i18n.ariaLabel);
        $[14] = formatMessage;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== T0 || $[17] !== menuPortalTarget || $[18] !== t1 || $[19] !== t2 || $[20] !== t3 || $[21] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            options: t1,
            onChange: t2,
            value: t3,
            components: t4,
            menuPosition: "fixed",
            menuPortalTarget: menuPortalTarget,
            "aria-label": t5,
            ...$c8b68f6ea32b0094$var$SELECT_STYLE_PROPS
        });
        $[16] = T0;
        $[17] = menuPortalTarget;
        $[18] = t1;
        $[19] = t2;
        $[20] = t3;
        $[21] = t5;
        $[22] = t6;
    } else t6 = $[22];
    return t6;
};
module.exports["ConfluenceSpaceType"] = $c8b68f6ea32b0094$export$2fabe69f8125d5a7;
module.exports["SpaceTargetSelect"] = $c8b68f6ea32b0094$export$f10aab7c26f92d55;

});

parcelRegister("5Wig1", function(module, exports) {

var $jevsd = parcelRequire("jevsd");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/workspace/manifest.ts
var $4530881607509d00$var$confluenceWorkspaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jevsd.ConfluenceWorkspaceAriResourceOwner),
    resourceType: (0, $jevsd.ConfluenceWorkspaceAriResourceType),
    resourceIdSlug: "{activationId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/
    }
};
// src/confluence/workspace/index.ts
var $4530881607509d00$export$d47d8a7e69df1865 = class _ConfluenceWorkspaceAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $4530881607509d00$var$confluenceWorkspaceAriStaticOpts.qualifier,
            platformQualifier: $4530881607509d00$var$confluenceWorkspaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $4530881607509d00$var$confluenceWorkspaceAriStaticOpts.resourceOwner,
            resourceType: $4530881607509d00$var$confluenceWorkspaceAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $4530881607509d00$var$confluenceWorkspaceAriStaticOpts);
        return new _ConfluenceWorkspaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $4530881607509d00$var$confluenceWorkspaceAriStaticOpts);
        return new _ConfluenceWorkspaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId;
    }
};
module.exports["ConfluenceWorkspaceAri"] = $4530881607509d00$export$d47d8a7e69df1865;

});

parcelRegister("jevsd", function(module, exports) {
// src/confluence/workspace/types.ts
var $e007b94796479ac0$export$19f1a63686ec0369 = "confluence", $e007b94796479ac0$export$f1c423a93fbc71 = "workspace";
module.exports["ConfluenceWorkspaceAriResourceOwner"] = $e007b94796479ac0$export$19f1a63686ec0369;
module.exports["ConfluenceWorkspaceAriResourceType"] = $e007b94796479ac0$export$f1c423a93fbc71;

});

parcelRegister("as9lu", function(module, exports) {

var $aQ0yV = parcelRequire("aQ0yV");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/identity/user/manifest.ts
var $79c3c4c484846d28$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $aQ0yV.IdentityUserAriResourceOwner),
    resourceType: (0, $aQ0yV.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $79c3c4c484846d28$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $1gKSA.RegisteredAri) {
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $79c3c4c484846d28$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $79c3c4c484846d28$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $79c3c4c484846d28$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $79c3c4c484846d28$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $79c3c4c484846d28$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $79c3c4c484846d28$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
    constructor(opts){
        super(opts), this._userId = opts.resourceIdSegmentValues.userId;
    }
};
module.exports["IdentityUserAri"] = $79c3c4c484846d28$export$1e9d09c2be53e55e;

});

parcelRegister("aQ0yV", function(module, exports) {
// src/identity/user/types.ts
var $7e3f325f95b56bab$export$b4c14c54282a779d = "identity", $7e3f325f95b56bab$export$e9b50e20f4fbfb71 = "user";
module.exports["IdentityUserAriResourceOwner"] = $7e3f325f95b56bab$export$b4c14c54282a779d;
module.exports["IdentityUserAriResourceType"] = $7e3f325f95b56bab$export$e9b50e20f4fbfb71;

});

parcelRegister("iQzVo", function(module, exports) {
const $ac3059bce5b9a0ea$export$7bed14e1f2921c0a = {
    ENROLMENT_DATE: 'twcg-1489:enrolmentDate',
    SPOTLIGHT_SHOWN: 'twcg-1489:spotlightShown',
    PROMO_DISMISSED: 'twcg-1489:promoDismissed'
};
const $ac3059bce5b9a0ea$export$461c2b41206d7875 = Object.values($ac3059bce5b9a0ea$export$7bed14e1f2921c0a);
module.exports["TWCG_1489_CONNECTOR_ONBOARDING"] = $ac3059bce5b9a0ea$export$7bed14e1f2921c0a;
module.exports["Twcg1489ConnectorOnboardingKeys"] = $ac3059bce5b9a0ea$export$461c2b41206d7875;

});

parcelRegister("ljH80", function(module, exports) {
/**
 * @generated SignedSource<<def63672abb49c009b08c3310289a240>>
 * @relayHash 3645f14258aaf6df779f3874a7b10083
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 794380e9c61483adc5407aecc7ee4f9434dbddfd1b24827095cb41bca86c6bd6
const $761d928d522d0b4f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "userId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "AtlassianAccountUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "teamType"
                    }
                ]
            }
        ],
        "type": "AtlassianAccountUser"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useConnectorOnboardingTeamTypeQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useConnectorOnboardingTeamTypeQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "3645f14258aaf6df779f3874a7b10083",
            "id": "794380e9c61483adc5407aecc7ee4f9434dbddfd1b24827095cb41bca86c6bd6",
            "metadata": {},
            "name": "useConnectorOnboardingTeamTypeQuery",
            "operationKind": "query",
            "text": "query useConnectorOnboardingTeamTypeQuery($userId:ID!){user(accountId:$userId){__typename,...on AtlassianAccountUser{extendedProfile{teamType}},id}}"
        }
    };
}();
$761d928d522d0b4f$var$node.hash = "a2ab021a37664174ea5177e550544833";
var $761d928d522d0b4f$export$2e2bcd8739ae039 = $761d928d522d0b4f$var$node;
module.exports["default"] = $761d928d522d0b4f$export$2e2bcd8739ae039;

});

parcelRegister("iGpO4", function(module, exports) {
/**
 * @generated SignedSource<<583af0bf5d1397e9bb81877c0829a09c>>
 * @relayHash ed1c7ead1865251e45173593feb0b728
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b96b68ccc999039ea351e31941246e5bb0c0400a30e73f61b5c8a6ce57245ae1
const $dba60705293b2bec$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "resourceId"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "orgId",
                    "variableName": "orgId"
                },
                {
                    "kind": "Variable",
                    "name": "resourceId",
                    "variableName": "resourceId"
                }
            ],
            "concreteType": "AdminConnectorConnection",
            "kind": "LinkedField",
            "name": "admin_getAllDataSources",
            "plural": false,
            "selections": [
                {
                    "concreteType": "AdminConnectorEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "AdminConnector",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                },
                                {
                                    "concreteType": "AdminDataSource",
                                    "kind": "LinkedField",
                                    "name": "datasources",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "enabled"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useConnectorStatesQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useConnectorStatesQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "ed1c7ead1865251e45173593feb0b728",
            "id": "b96b68ccc999039ea351e31941246e5bb0c0400a30e73f61b5c8a6ce57245ae1",
            "metadata": {},
            "name": "useConnectorStatesQuery",
            "operationKind": "query",
            "text": "query useConnectorStatesQuery($orgId:ID!,$resourceId:ID!,$first:Int){admin_getAllDataSources(orgId:$orgId,resourceId:$resourceId,first:$first){edges{node{type,datasources{enabled}}}}}"
        }
    };
}();
$dba60705293b2bec$var$node.hash = "c1e906a9d592c8090d7d5864937f0dbe";
var $dba60705293b2bec$export$2e2bcd8739ae039 = $dba60705293b2bec$var$node;
module.exports["default"] = $dba60705293b2bec$export$2e2bcd8739ae039;

});

parcelRegister("dBcar", function(module, exports) {

var $5AFnD = parcelRequire("5AFnD");

const $3c94963df51c0e13$export$4ddca8f5712d2331 = 'onboarding-state:';
const $3c94963df51c0e13$export$f35f2899eb1390e3 = 'peopleNudge';
const $3c94963df51c0e13$export$532485ca1547f1aa = 'legacy';
const $3c94963df51c0e13$export$31c8494ea74d2536 = 'introWorkflow';
const $3c94963df51c0e13$export$1f72e9a162b3795b = 'firstSpaceSelected';
const $3c94963df51c0e13$export$6315bee451a9fcc6 = 'teamSpaceCreated';
const $3c94963df51c0e13$export$c4e14780cf349e73 = 'xflowSpaceCreated';
const $3c94963df51c0e13$export$275d3dda87d2fa7a = 'nthUserOnboardingCompletedTimestamp';
const $3c94963df51c0e13$export$da223e550b96c9d6 = 'help';
const $3c94963df51c0e13$export$ffb6b379ff35f9e = 'onboardingIntents';
const $3c94963df51c0e13$export$d3276a0d758ffd2b = 'isFoundingAdmin';
const $3c94963df51c0e13$export$756b1a5a6b2488c3 = 'isSampleContentV2SpotlightVisible';
const $3c94963df51c0e13$export$8e5a8e09b19b20a8 = 'isMoreActionsTourVisible';
const $3c94963df51c0e13$export$2e10b71f921ae144 = 'isMoreActionsHintVisible';
const $3c94963df51c0e13$export$82fe49566957c443 = 'landOnPath';
const $3c94963df51c0e13$export$f6c79e39ab4496db = 'templateOnboardingViewedTime';
const $3c94963df51c0e13$export$49ac0bbeb4be0a06 = {
    ONBOARDING_INTENT_EXPERIENCES_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceClosed',
    ONBOARDING_EXPERIENCE_ELIGIBLE: 'onboarding-intent-experience:isOnboardingExperienceEligibleUser',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_VIEWED_AT: 'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceLandClosed'
};
const $3c94963df51c0e13$export$6167e5b70dfd11d9 = {
    MODAL_SEEN: 'onboarding-reverse-trial:isModalSeen'
};
const $3c94963df51c0e13$export$49c044e5e3ccc2af = {
    EXPERIMENT_ELIGIBLE: 'templates-collection:isTaggedForTemplatesCollectionExperiment',
    EXPERIMENT_DISMISSED: 'templates-collection:isTemplatesSectionDismissed'
};
const $3c94963df51c0e13$export$dcbccfe8799c3c7b = {
    IS_DISMISSED: 'space-getting-started-tour:tourIsDismissed'
};
const $3c94963df51c0e13$export$305c55ea55928edf = {
    HAS_INVITE_CAPABILITIES: 'persistent-invite:hasInviteCapabilities'
};
const $3c94963df51c0e13$export$8b7e53c326da02ac = 'improvedGetStartedPath';
const $3c94963df51c0e13$export$cfc1794f56ac0d83 = 'improvedGetStartedWhiteboardPath';
const $3c94963df51c0e13$export$39a89660e80fa1a = 'isRedactionsTourVisible';
const $3c94963df51c0e13$export$b99b309b286adebc = 'nav4:isNav4GlobalSpotlightDismissed';
const $3c94963df51c0e13$export$20b0548cf5859d6 = 'nav4:isNav4SpaceTourDismissed';
const $3c94963df51c0e13$export$4d93dfc1d8538d55 = 'nav4:isNav4CollapseReminderSpotlightDismissed';
const $3c94963df51c0e13$export$94a4264abda026cc = 'creation-focused-nav:shouldShowSpotlight';
const $3c94963df51c0e13$export$f0597adb063e4c38 = 'creation-focused-nav:startTime';
const $3c94963df51c0e13$export$7ed75560092630f6 = {
    IS_SPOTLIGHT_DISMISS: 'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed',
    PULSE_SEEN_AT: 'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt'
};
const $3c94963df51c0e13$export$6c014427ebb0cbae = {
    HAS_SEEN_SPLASH_MODAL: 'create-with-rovo-announcement-splash:hasSeenSplashModal'
};
const $3c94963df51c0e13$export$ebacd4ef7f5400e2 = {
    CHAT_AUTO_OPENED: 'welcome-from-rovo:chatAutoOpened'
};
const $3c94963df51c0e13$export$d1ec748fb682ca97 = {
    NTH_USER_SELECTED_CONTENT_TYPE: 'nth-user-setup:nthUserSelectedContentType',
    NTH_USER_CONTENT_TYPE_SPOTLIGHT_SEEN: 'nth-user-setup:nthUserContentTypeSpotlightSeen',
    NTH_USER_CONTENT_TYPE_POPULAR_CONTENT_FOUND: 'nth-user-setup:nthUserContentTypePopularContentFound',
    NTH_USER_CONTENT_TYPE_LANDING_CONTENT_ID: 'nth-user-setup:nthUserContentTypeLandingContentId'
};
const $3c94963df51c0e13$export$1a3a43cef0acd011 = {
    PROMPT_DISMISSED: 'prompt-whiteboard-competitor-link:isPromptDismissed'
};
const $3c94963df51c0e13$export$5b471e2344a37be7 = {
    DISMISSED: 'prompt-database-competitor-link:isPromptDatabaseDismissed'
};
const $3c94963df51c0e13$export$c81223a0ce3b63df = {
    HAS_AUTO_FOLLOWED_SPACES: 'nth-user-auto-follow-spaces:hasAutoFollowedSpaces'
};
const $3c94963df51c0e13$export$f1328b04dc902e1f = {
    REVAMPED_BPQA_SHOWN_AT: 'land-users-in-editor-with-revamped-bpqa:revampedBpqaShownAt'
};
const $3c94963df51c0e13$export$e986b94fd54d134 = {
    SELECTED_TEMPLATES: 'use-cases-nth-user-onboarding:selectedTemplates',
    VIEWED_AT: 'use-cases-nth-user-onboarding:viewedAt',
    DISMISSED_HEADER: 'use-cases-nth-user-onboarding:headerDismissed',
    VIEWED_HEADER: 'use-cases-nth-user-onboarding:headerViewedAt'
};
const $3c94963df51c0e13$export$bbdc3607431bd9d3 = {
    EMOJI_TITLE_DISCOVERED: 'auto-page-emoji:emojiTitleDiscovered'
};
const $3c94963df51c0e13$export$94df39cf9e5d9804 = {
    TRENDING_PAGES: 'cross-join-nth-user-onboarding:trendingPages',
    DISMISSED: 'cross-join-nth-user-onboarding:dismissed'
};
const $3c94963df51c0e13$export$bfeb2da96277b623 = {
    INTRO_WORKFLOW: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$31c8494ea74d2536}`,
    LEGACY_ONBOARDING_STATE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$532485ca1547f1aa}`,
    IS_FOUNDING_ADMIN: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$d3276a0d758ffd2b}`,
    IS_SAMPLE_CONTENT_V2_SPOTLIGHT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$756b1a5a6b2488c3}`,
    LAND_ON_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$82fe49566957c443}`,
    TEAM_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$6315bee451a9fcc6}`,
    IS_MORE_ACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8e5a8e09b19b20a8}`,
    IS_MORE_ACTIONS_HINT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$2e10b71f921ae144}`,
    IMPROVED_GET_STARTED_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8b7e53c326da02ac}`,
    IMPROVED_GET_STARTED_WHITEBOARD_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$cfc1794f56ac0d83}`,
    IS_REDACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$39a89660e80fa1a}`,
    XFLOW_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$c4e14780cf349e73}`,
    TEMPLATE_ONBOARDING_VIEWED_TIME: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$f6c79e39ab4496db}`,
    NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$275d3dda87d2fa7a}`
};
const $3c94963df51c0e13$export$1660a2d7c2fff354 = '__complete__';
const $3c94963df51c0e13$export$66aa87593037fd4a = $3c94963df51c0e13$export$bfeb2da96277b623.LEGACY_ONBOARDING_STATE;
const $3c94963df51c0e13$export$d4f5dd2b883b8982 = [
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38
];
const $3c94963df51c0e13$export$7a13c575f2c75084 = [
    ...Object.values($3c94963df51c0e13$export$49ac0bbeb4be0a06),
    ...Object.values($3c94963df51c0e13$export$6167e5b70dfd11d9),
    ...Object.values($3c94963df51c0e13$export$49c044e5e3ccc2af),
    ...Object.values($3c94963df51c0e13$export$dcbccfe8799c3c7b),
    ...Object.values($3c94963df51c0e13$export$305c55ea55928edf),
    $3c94963df51c0e13$export$b99b309b286adebc,
    $3c94963df51c0e13$export$20b0548cf5859d6,
    $3c94963df51c0e13$export$4d93dfc1d8538d55,
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38,
    ...Object.values($3c94963df51c0e13$export$7ed75560092630f6),
    ...Object.values($3c94963df51c0e13$export$6c014427ebb0cbae),
    ...Object.values($3c94963df51c0e13$export$ebacd4ef7f5400e2),
    ...Object.values($3c94963df51c0e13$export$d1ec748fb682ca97),
    ...Object.values($3c94963df51c0e13$export$1a3a43cef0acd011),
    ...Object.values($3c94963df51c0e13$export$5b471e2344a37be7),
    ...Object.values($3c94963df51c0e13$export$bfeb2da96277b623),
    ...Object.values($3c94963df51c0e13$export$c81223a0ce3b63df),
    ...Object.values($3c94963df51c0e13$export$f1328b04dc902e1f),
    ...Object.values($3c94963df51c0e13$export$e986b94fd54d134),
    ...Object.values($3c94963df51c0e13$export$bbdc3607431bd9d3),
    ...Object.values($3c94963df51c0e13$export$94df39cf9e5d9804),
    (0, $5AFnD.LOOM_NUDGE_REMIND_ME),
    (0, $5AFnD.LOOM_NUDGE_LAST_SHOWN_AT)
];
module.exports["ONBOARDING_INTENT_EXPERIENCES"] = $3c94963df51c0e13$export$49ac0bbeb4be0a06;
module.exports["TEMPLATES_COLLECTION"] = $3c94963df51c0e13$export$49c044e5e3ccc2af;
module.exports["PERSISTENT_INVITE"] = $3c94963df51c0e13$export$305c55ea55928edf;
module.exports["IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED"] = $3c94963df51c0e13$export$4d93dfc1d8538d55;
module.exports["CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT"] = $3c94963df51c0e13$export$94a4264abda026cc;
module.exports["CREATION_FOCUSED_NAV_START_TIME"] = $3c94963df51c0e13$export$f0597adb063e4c38;
module.exports["CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH"] = $3c94963df51c0e13$export$6c014427ebb0cbae;
module.exports["WELCOME_FROM_ROVO_CHAT"] = $3c94963df51c0e13$export$ebacd4ef7f5400e2;
module.exports["NTH_USER_SETUP_CONTENT_TYPE"] = $3c94963df51c0e13$export$d1ec748fb682ca97;
module.exports["PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED"] = $3c94963df51c0e13$export$1a3a43cef0acd011;
module.exports["NTH_USER_AUTO_FOLLOW_SPACES"] = $3c94963df51c0e13$export$c81223a0ce3b63df;
module.exports["LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA"] = $3c94963df51c0e13$export$f1328b04dc902e1f;
module.exports["USE_CASES_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$e986b94fd54d134;
module.exports["NTH_USER_EMOJI_TITLE_DISCOVERED"] = $3c94963df51c0e13$export$bbdc3607431bd9d3;
module.exports["CROSS_JOIN_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$94df39cf9e5d9804;
module.exports["ONBOARDING_EXPERIENCES"] = $3c94963df51c0e13$export$bfeb2da96277b623;
module.exports["COMPLETE"] = $3c94963df51c0e13$export$1660a2d7c2fff354;
module.exports["NAV_EXPERIMENT_ONBOARDING_KEYS"] = $3c94963df51c0e13$export$d4f5dd2b883b8982;
module.exports["OnboardingKeys"] = $3c94963df51c0e13$export$7a13c575f2c75084;

});

parcelRegister("5AFnD", function(module, exports) {
const $00e2d16f0c5935d6$export$477408ab8b02b670 = 'twcg-2202-loom-nudge:remindMe';
const $00e2d16f0c5935d6$export$c98b33a7293cedf4 = 'twcg-2202-loom-nudge:lastShownAt';
module.exports["LOOM_NUDGE_REMIND_ME"] = $00e2d16f0c5935d6$export$477408ab8b02b670;
module.exports["LOOM_NUDGE_LAST_SHOWN_AT"] = $00e2d16f0c5935d6$export$c98b33a7293cedf4;

});

parcelRegister("d9tcB", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $adbc8f20ade62008$export$9d38595f26d62a61 = /*#__PURE__*/ function(AccessStatus) {
    AccessStatus["ANONYMOUS_ACCESS"] = "ANONYMOUS_ACCESS";
    AccessStatus["EXTERNAL_COLLABORATOR_ACCESS"] = "EXTERNAL_COLLABORATOR_ACCESS";
    AccessStatus["EXTERNAL_SHARE_ACCESS"] = "EXTERNAL_SHARE_ACCESS";
    AccessStatus["LICENSED_ADMIN_ACCESS"] = "LICENSED_ADMIN_ACCESS";
    AccessStatus["LICENSED_USE_ACCESS"] = "LICENSED_USE_ACCESS";
    AccessStatus["NOT_PERMITTED"] = "NOT_PERMITTED";
    AccessStatus["UNLICENSED_AUTHENTICATED_ACCESS"] = "UNLICENSED_AUTHENTICATED_ACCESS";
    return AccessStatus;
}({});
var $adbc8f20ade62008$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
var $adbc8f20ade62008$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["DEVELOPMENT"] = "DEVELOPMENT";
    Environment["PRODUCTION"] = "PRODUCTION";
    Environment["STAGING"] = "STAGING";
    return Environment;
}({});
module.exports["AccessStatus"] = $adbc8f20ade62008$export$9d38595f26d62a61;
module.exports["ConfluenceEdition"] = $adbc8f20ade62008$export$68577d543b14ae02;

});

parcelRegister("cwUrm", function(module, exports) {
const $47cf4dda49ee363d$export$ed52cc3670515af7 = (cloudId)=>({
        tenantId: cloudId,
        product: 'confluence'
    });
module.exports["buildInvitedAppShortcutsRecommendationsVariables"] = $47cf4dda49ee363d$export$ed52cc3670515af7;

});

parcelRegister("4YUBg", function(module, exports) {
/**
 * @generated SignedSource<<c911df138434165e1df56a149c5ed87d>>
 * @relayHash 3c5abea4712e217d7b3561b0c6d826bb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 15d301edc65d7aefa1614dec08095e50e15a8fc962561db8174cca939aad4ec8
const $a43ff53f7d2c5ff0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "product"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "tenantId"
    }, v2 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "product",
                    "variableName": "product"
                },
                {
                    "kind": "Variable",
                    "name": "tenantId",
                    "variableName": "tenantId"
                },
                {
                    "kind": "Literal",
                    "name": "useCase",
                    "value": "invitedAppShortcuts"
                }
            ],
            "kind": "ObjectValue",
            "name": "context"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "entityId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "reasons"
    }, v6 = {
        "kind": "ScalarField",
        "name": "score"
    }, v7 = {
        "concreteType": "GrowthRecContextResult",
        "kind": "LinkedField",
        "name": "context",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "tenantId"
            },
            {
                "kind": "ScalarField",
                "name": "product"
            },
            {
                "kind": "ScalarField",
                "name": "useCase"
            },
            {
                "kind": "ScalarField",
                "name": "sessionId"
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "identifier"
    }, v9 = {
        "kind": "ScalarField",
        "name": "message"
    }, v10 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v11 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "InvitedAppShortcutsRecommendationsQuery",
            "selections": [
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v7 /*: any*/ 
                                    ],
                                    "type": "GrowthRecRecommendations"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "InvitedAppShortcutsRecommendationsQuery",
            "selections": [
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v7 /*: any*/ 
                                    ],
                                    "type": "GrowthRecRecommendations"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "3c5abea4712e217d7b3561b0c6d826bb",
            "id": "15d301edc65d7aefa1614dec08095e50e15a8fc962561db8174cca939aad4ec8",
            "metadata": {},
            "name": "InvitedAppShortcutsRecommendationsQuery",
            "operationKind": "query",
            "text": "query InvitedAppShortcutsRecommendationsQuery($tenantId:ID,$product:String!){growthRecommendations{recommendations(context:{tenantId:$tenantId,product:$product,useCase:\"invitedAppShortcuts\"}){__typename,...on GrowthRecRecommendations{data{__typename,entityId,reasons,score},context{tenantId,product,useCase,sessionId}},...on QueryError{identifier,message,extensions{__typename,statusCode,errorType}}}}}"
        }
    };
}();
$a43ff53f7d2c5ff0$var$node.hash = "186413c3c978a3bb94c6bc4b5f252e32";
var $a43ff53f7d2c5ff0$export$2e2bcd8739ae039 = $a43ff53f7d2c5ff0$var$node;
module.exports["default"] = $a43ff53f7d2c5ff0$export$2e2bcd8739ae039;

});

parcelRegister("4vyfK", function(module, exports) {

var $dAxoX = parcelRequire("dAxoX");


var $dYU3e = parcelRequire("dYU3e");


var $fEmGS = parcelRequire("fEmGS");


var $6mKj3 = parcelRequire("6mKj3");


var $iEfsZ = parcelRequire("iEfsZ");


var $eSLr0 = parcelRequire("eSLr0");

const $2272f3d6a41ef128$var$preloadWebItemLocationWithSpaceKeyQuery = (0, $dAxoX.default);
const $2272f3d6a41ef128$var$isSystemBatchLocation = (location)=>location.length === 2 && location.includes((0, $eSLr0.SYSTEM_HEADER_LEFT)) && location.includes((0, $eSLr0.SYSTEM_USER));
// Keep this in sync with the editorToolbarLocations batched by
// load-edit-page/src/preload/preloadEditorData.ts.
const $2272f3d6a41ef128$var$CONTENT_BATCH_REQUIRED_LOCATIONS = [
    (0, $eSLr0.TOOLS_MENU_CONTAINER),
    (0, $eSLr0.SYSTEM_EDITOR_PRECURSOR_BUTTONS)
];
const $2272f3d6a41ef128$var$CONTENT_BATCH_ALLOWED_LOCATIONS = new Set([
    ...$2272f3d6a41ef128$var$CONTENT_BATCH_REQUIRED_LOCATIONS,
    (0, $eSLr0.PAGE_BUTTONS)
]);
const $2272f3d6a41ef128$var$isContentBatchLocation = (location)=>{
    const locationSet = new Set(location);
    return $2272f3d6a41ef128$var$CONTENT_BATCH_REQUIRED_LOCATIONS.every((requiredLocation)=>locationSet.has(requiredLocation)) && [
        ...locationSet
    ].every((candidateLocation)=>$2272f3d6a41ef128$var$CONTENT_BATCH_ALLOWED_LOCATIONS.has(candidateLocation));
};
const $2272f3d6a41ef128$var$filterSectionsByLocations = (webItemSections, locations)=>webItemSections.filter((section)=>locations.some((location)=>section?.id?.startsWith(`${location}/`)));
const $2272f3d6a41ef128$var$writeWebItemLocationCache = ({ locations: locations, contentId: contentId, spaceKey: spaceKey, version: version, webItemSections: webItemSections })=>{
    (0, $fEmGS.writeQueryInterop)({
        query: (0, $iEfsZ.default),
        variables: {
            location: null,
            locations: locations,
            contentId: contentId,
            spaceKey: spaceKey,
            version: version
        },
        data: {
            webItemSections: webItemSections
        },
        __callerPackage__: "web-item-location"
    });
};
const $2272f3d6a41ef128$var$writeWebItemLocationEntries = ({ locations: locations, contentId: contentId, spaceKey: spaceKey, version: version, webItemSections: webItemSections })=>{
    locations.forEach((location)=>{
        (0, $fEmGS.writeQueryInterop)({
            query: (0, $iEfsZ.default),
            variables: {
                location: location,
                locations: [],
                contentId: contentId,
                spaceKey: spaceKey,
                version: version
            },
            data: {
                webItemSections: $2272f3d6a41ef128$var$filterSectionsByLocations(webItemSections, [
                    location
                ])
            },
            __callerPackage__: "web-item-location"
        });
    });
};
function $2272f3d6a41ef128$export$8120ee10837c1dd({ location: location = null, contentId: contentId = null, spaceKey: spaceKey = null, version: version = null, context: context } = {}) {
    if (!contentId && spaceKey) return (0, $dYU3e.query)({
        query: $2272f3d6a41ef128$var$preloadWebItemLocationWithSpaceKeyQuery,
        variables: {
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            spaceKey: spaceKey,
            version: version
        },
        context: context,
        __callerPackage__: "web-item-location"
    }).then(({ data: data })=>{
        if (data?.space?.homepageId) (0, $fEmGS.writeQueryInterop)({
            query: (0, $iEfsZ.default),
            variables: {
                location: Array.isArray(location) ? null : location,
                locations: Array.isArray(location) ? location : [],
                contentId: data?.space?.homepageId,
                spaceKey: null,
                version: version
            },
            data: {
                webItemSections: data?.space?.homepageWebSections || []
            },
            __callerPackage__: "web-item-location"
        });
    });
    const variables = {
        // GraphQL doesn't cache single location strings properly when passed to locations
        // unless we're using multiple locations we should be using the location variable
        location: Array.isArray(location) ? null : location,
        locations: Array.isArray(location) ? location : [],
        contentId: contentId,
        spaceKey: spaceKey,
        version: version
    };
    const result = (0, $dYU3e.query)({
        query: (0, $iEfsZ.default),
        variables: variables,
        context: context,
        __callerPackage__: "web-item-location"
    });
    if (Array.isArray(location)) {
        const shouldWriteSystemBatchEntries = (0, $6mKj3.expValEquals)('web_item_query_batch_system_call', 'isEnabled', true) && $2272f3d6a41ef128$var$isSystemBatchLocation(location);
        const shouldWriteContentBatchEntries = $2272f3d6a41ef128$var$isContentBatchLocation(location) && (0, $6mKj3.expValEquals)('web_item_query_batch_content_call', 'isEnabled', true);
        if (shouldWriteSystemBatchEntries || shouldWriteContentBatchEntries) result.then(({ data: data })=>{
            if (!data?.webItemSections) return;
            $2272f3d6a41ef128$var$writeWebItemLocationCache({
                locations: location,
                contentId: contentId,
                spaceKey: spaceKey,
                version: version,
                webItemSections: data.webItemSections
            });
            $2272f3d6a41ef128$var$writeWebItemLocationEntries({
                locations: location,
                contentId: contentId,
                spaceKey: spaceKey,
                version: version,
                webItemSections: data.webItemSections
            });
            if (shouldWriteContentBatchEntries && location.includes((0, $eSLr0.PAGE_BUTTONS))) {
                const liveEllipsisLocations = [
                    (0, $eSLr0.TOOLS_MENU_CONTAINER),
                    (0, $eSLr0.PAGE_BUTTONS)
                ];
                $2272f3d6a41ef128$var$writeWebItemLocationCache({
                    locations: liveEllipsisLocations,
                    contentId: contentId,
                    spaceKey: spaceKey,
                    version: version,
                    webItemSections: $2272f3d6a41ef128$var$filterSectionsByLocations(data.webItemSections, liveEllipsisLocations)
                });
            }
        });
    }
    return result;
}
module.exports["preloadWebItemLocation"] = $2272f3d6a41ef128$export$8120ee10837c1dd;

});

parcelRegister("dAxoX", function(module, exports) {
/**
 * @generated SignedSource<<723e491a15ec21972dd962ca0e8f8ba8>>
 * @relayHash c407d329f5154dd3cb147b16d24f7f21
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3d78827b45ffa00d23f59d49283e3186acd1fae25701669aff456c7a90416511
const $074c400385fc6141$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "location"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locations"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "version"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "label"
    }, v3 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "homepageId"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "location",
                            "variableName": "location"
                        },
                        {
                            "kind": "Variable",
                            "name": "locations",
                            "variableName": "locations"
                        },
                        {
                            "kind": "Variable",
                            "name": "version",
                            "variableName": "version"
                        }
                    ],
                    "concreteType": "WebSection",
                    "kind": "LinkedField",
                    "name": "homepageWebSections",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "cacheKey"
                        },
                        v3 /*: any*/ ,
                        {
                            "concreteType": "WebItem",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accessKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "completeKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasCondition"
                                },
                                v1 /*: any*/ ,
                                {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "height"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "width"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "path"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "MapOfStringToString",
                                    "kind": "LinkedField",
                                    "name": "params",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                },
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "moduleKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "section"
                                },
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "tooltip"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "url"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "urlWithoutContextPath"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "weight"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "c407d329f5154dd3cb147b16d24f7f21",
            "id": "3d78827b45ffa00d23f59d49283e3186acd1fae25701669aff456c7a90416511",
            "metadata": {},
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "operationKind": "query",
            "text": "query preloadWebItemLocationWithSpaceKeyQuery($location:String,$locations:[String],$spaceKey:String,$version:Int){space(key:$spaceKey){id,homepageId,homepageWebSections(location:$location,locations:$locations,version:$version){id,label,cacheKey,styleClass,items{accessKey,completeKey,hasCondition,id,icon{height,width,path},params{key,value},label,moduleKey,section,styleClass,tooltip,url,urlWithoutContextPath,weight}}}}"
        }
    };
}();
$074c400385fc6141$var$node.hash = "fb9ef136f5257fc82dc16b8dc37de41b";
var $074c400385fc6141$export$2e2bcd8739ae039 = $074c400385fc6141$var$node;
module.exports["default"] = $074c400385fc6141$export$2e2bcd8739ae039;

});

parcelRegister("iEfsZ", function(module, exports) {
/**
 * @generated SignedSource<<50efd21e0db5811e6867b792d80a2f0a>>
 * @relayHash 0006505c7639efb87b37fdf9e06ba577
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173
const $7f80a392f18860bd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "location"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locations"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "version"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "label"
    }, v7 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v8 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "location",
                    "variableName": "location"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "locations"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "version"
                }
            ],
            "concreteType": "WebSection",
            "kind": "LinkedField",
            "name": "webItemSections",
            "plural": true,
            "selections": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "cacheKey"
                },
                v7 /*: any*/ ,
                {
                    "concreteType": "WebItem",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accessKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "completeKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasCondition"
                        },
                        v5 /*: any*/ ,
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "height"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "width"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        {
                            "concreteType": "MapOfStringToString",
                            "kind": "LinkedField",
                            "name": "params",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        },
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "moduleKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "section"
                        },
                        v7 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "tooltip"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "urlWithoutContextPath"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "weight"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WebItemLocationQuery",
            "selections": v8 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WebItemLocationQuery",
            "selections": v8 /*: any*/ 
        },
        "params": {
            "cacheID": "0006505c7639efb87b37fdf9e06ba577",
            "id": "80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173",
            "metadata": {},
            "name": "WebItemLocationQuery",
            "operationKind": "query",
            "text": "query WebItemLocationQuery($location:String,$locations:[String],$contentId:ID,$spaceKey:String,$version:Int){webItemSections(location:$location,locations:$locations,contentId:$contentId,key:$spaceKey,version:$version){id,label,cacheKey,styleClass,items{accessKey,completeKey,hasCondition,id,icon{height,width,path},params{key,value},label,moduleKey,section,styleClass,tooltip,url,urlWithoutContextPath,weight}}}"
        }
    };
}();
$7f80a392f18860bd$var$node.hash = "8e88912bf23040d88bbeb5c8cadae7c2";
var $7f80a392f18860bd$export$2e2bcd8739ae039 = $7f80a392f18860bd$var$node;
module.exports["default"] = $7f80a392f18860bd$export$2e2bcd8739ae039;

});

parcelRegister("eSLr0", function(module, exports) {
// web items
const $0673dc41d4591954$export$b1fc939aa7feb92f = 'system.content.action';
const $0673dc41d4591954$export$cc265e0ec08cd67d = 'system.content.button';
const $0673dc41d4591954$export$d2beebd05fcd6f70 = 'system.dashboard';
const $0673dc41d4591954$export$9aacf4bfaa57e6fc = 'system.content.byline';
const $0673dc41d4591954$export$1b2697f8e6fa897f = 'system.content.metadata';
const $0673dc41d4591954$export$53635c098825d80c = 'system.attachment';
const $0673dc41d4591954$export$b55f44bb0675280a = 'system.attachment.metadata';
const $0673dc41d4591954$export$932fbff4e94f11bd = 'system.attachment.history';
const $0673dc41d4591954$export$76fccc09e967256f = 'page.metadata.banner';
const $0673dc41d4591954$export$630f26f93c0b82dc = 'system.header/left';
const $0673dc41d4591954$export$67f0ff836865be9e = 'system.header/left.button.group';
const $0673dc41d4591954$export$ac6c373b69972f05 = 'system.help/pages';
const $0673dc41d4591954$export$1835f2a2eaa3b55b = 'system.user';
const $0673dc41d4591954$export$8fc5196f34e2202a = 'system.admin';
const $0673dc41d4591954$export$e83e042e2b565918 = 'system.editor.precursor.buttons';
const $0673dc41d4591954$export$2a98a7a0b026585a = 'system.create.dialog/content';
const $0673dc41d4591954$export$9022327d826319c7 = 'system.create.space.dialog/content';
const $0673dc41d4591954$export$b7555e81ec195340 = 'page.view.selection/action-panel';
const $0673dc41d4591954$export$dbd4ce8bddb36f82 = 'atl.dashboard.secondary';
const $0673dc41d4591954$export$78738b07c213d412 = 'atl.general';
const $0673dc41d4591954$export$45c1e55ebc7a8070 = 'atl.footer';
const $0673dc41d4591954$export$e1325689a3e8f66b = 'atl.page.metadata.banner';
const $0673dc41d4591954$export$e8a1b6a55853b054 = 'atl.page.content.footer.actions';
const $0673dc41d4591954$export$488204faf384ca14 = 'atl.editor.savebar';
const $0673dc41d4591954$export$c7ef8755b728af2b = 'system.admin/siteadministration';
const $0673dc41d4591954$export$a7876e82ed48f038 = 'system.admin/security';
module.exports["TOOLS_MENU_CONTAINER"] = $0673dc41d4591954$export$b1fc939aa7feb92f;
module.exports["PAGE_BUTTONS"] = $0673dc41d4591954$export$cc265e0ec08cd67d;
module.exports["SYSTEM_CONTENT_BYLINE"] = $0673dc41d4591954$export$9aacf4bfaa57e6fc;
module.exports["SYSTEM_CONTENT_METADATA"] = $0673dc41d4591954$export$1b2697f8e6fa897f;
module.exports["SYSTEM_ATTACHMENT"] = $0673dc41d4591954$export$53635c098825d80c;
module.exports["SYSTEM_ATTACHMENT_METADATA"] = $0673dc41d4591954$export$b55f44bb0675280a;
module.exports["SYSTEM_ATTACHMENT_HISTORY"] = $0673dc41d4591954$export$932fbff4e94f11bd;
module.exports["PAGE_METADATA_BANNER"] = $0673dc41d4591954$export$76fccc09e967256f;
module.exports["SYSTEM_HEADER_LEFT"] = $0673dc41d4591954$export$630f26f93c0b82dc;
module.exports["SYSTEM_HELP"] = $0673dc41d4591954$export$ac6c373b69972f05;
module.exports["SYSTEM_USER"] = $0673dc41d4591954$export$1835f2a2eaa3b55b;
module.exports["SYSTEM_ADMIN"] = $0673dc41d4591954$export$8fc5196f34e2202a;
module.exports["SYSTEM_EDITOR_PRECURSOR_BUTTONS"] = $0673dc41d4591954$export$e83e042e2b565918;
module.exports["CREATE_DIALOG"] = $0673dc41d4591954$export$2a98a7a0b026585a;
module.exports["CREATE_SPACE_DIALOG"] = $0673dc41d4591954$export$9022327d826319c7;
module.exports["ACTION_PANEL"] = $0673dc41d4591954$export$b7555e81ec195340;
module.exports["DASHBOARD_SECONDARY"] = $0673dc41d4591954$export$dbd4ce8bddb36f82;
module.exports["ATL_GENERAL"] = $0673dc41d4591954$export$78738b07c213d412;
module.exports["ATL_FOOTER"] = $0673dc41d4591954$export$45c1e55ebc7a8070;
module.exports["ATL_PAGE_METADATA"] = $0673dc41d4591954$export$e1325689a3e8f66b;
module.exports["ATL_PAGE_CONTENT_FOOTER_ACTIONS"] = $0673dc41d4591954$export$e8a1b6a55853b054;
module.exports["ATL_EDITOR_SAVEBAR"] = $0673dc41d4591954$export$488204faf384ca14;
module.exports["SYSTEM_ADMIN_SITE_ADMINISTRATION_SECURITY"] = $0673dc41d4591954$export$a7876e82ed48f038;

});

parcelRegister("8dUjs", function(module, exports) {

var $d9tcB = parcelRequire("d9tcB");


var $eSLr0 = parcelRequire("eSLr0");


var $7Ndnw = parcelRequire("7Ndnw");


var $5tgcI = parcelRequire("5tgcI");

const $84cd59e06a85be4f$export$a9c446837cd59ef8 = [
    (0, $5tgcI.SPACES_KEY),
    (0, $5tgcI.PEOPLE_KEY),
    (0, $5tgcI.DISCOVER_KEY)
];
const $84cd59e06a85be4f$export$a56df56fab66279e = ({ edition: edition, accessStatus: accessStatus })=>{
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const hideAutomation = edition !== 'PREMIUM' || !isAdmin;
    const notAllowedWebItems = [
        ...$84cd59e06a85be4f$export$a9c446837cd59ef8,
        hideAutomation ? (0, $5tgcI.AUTOMATION_KEY) : ''
    ];
    return {
        webItemParams: {
            location: (0, $eSLr0.SYSTEM_HEADER_LEFT),
            notAllowedWebItems: notAllowedWebItems
        },
        forgeExtensionParams: {
            moduleType: (0, $7Ndnw.FORGE_MODULE_GLOBAL_PAGE),
            spaceKey: ''
        }
    };
};
module.exports["getGlobalAppsParams"] = $84cd59e06a85be4f$export$a56df56fab66279e;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$3d2f468c166bad70 = 'confluence:attachmentAction';
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$3d2f468c166bad70,
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_ATTACHMENT_ACTION"] = $af2b0e533822f413$export$3d2f468c166bad70;
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("5tgcI", function(module, exports) {
const $696759caf06ef68c$export$af39e4edc5e74 = 'com.atlassian.confluence.plugins.confluence-space-ia:header-spaces-link';
const $696759caf06ef68c$export$97c436ccc42cbac9 = 'com.atlassian.confluence.plugins.confluence-space-ia:header-people-link';
const $696759caf06ef68c$export$3a7ae658938afc39 = 'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.confluence.emcee__enduser-discover';
const $696759caf06ef68c$export$ee99bc1ad01a63ae = 'com.atlassian.confluence.plugins.confluence-space-ia:header-automation-link';
const $696759caf06ef68c$export$8a23ae6ca6b0c9ee = 'com.atlassian.confluence.extra.team-calendars:header-mycalendar-link';
const $696759caf06ef68c$export$38788381122702f5 = 'com.atlassian.plugins.atlassian-connect-plugin:com.addonengine.analytics__analytics-instance-settings-menu-item-adg3';
const $696759caf06ef68c$export$6c3d789a4f56bea2 = 'com.atlassian.plugins.atlassian-connect-plugin:com.addonengine.analytics.moderate__analytics-instance-settings-menu-item-adg3';
module.exports["SPACES_KEY"] = $696759caf06ef68c$export$af39e4edc5e74;
module.exports["PEOPLE_KEY"] = $696759caf06ef68c$export$97c436ccc42cbac9;
module.exports["DISCOVER_KEY"] = $696759caf06ef68c$export$3a7ae658938afc39;
module.exports["AUTOMATION_KEY"] = $696759caf06ef68c$export$ee99bc1ad01a63ae;
module.exports["CALENDAR_KEY"] = $696759caf06ef68c$export$8a23ae6ca6b0c9ee;
module.exports["ANALYTICS_KEY"] = $696759caf06ef68c$export$38788381122702f5;
module.exports["ANALYTICS_KEY_MODERATE"] = $696759caf06ef68c$export$6c3d789a4f56bea2;

});

parcelRegister("hPkGG", function(module, exports) {
/**
 * @generated SignedSource<<5efd4a44b24bb87c092d4fc494599337>>
 * @relayHash ee5a91706bc8d2c36266138f1556fa8e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7f7a8c5a405e165722f55d2fb38fba615d09b5f4c08ede00a7a9fe5741f08c7a
const $62aeb16db236e807$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "entityAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ownerAri"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAri"
                },
                {
                    "kind": "Variable",
                    "name": "ownerAri",
                    "variableName": "ownerAri"
                }
            ],
            "concreteType": "SettingsNavigationCustomisation",
            "kind": "LinkedField",
            "name": "settings_navigationCustomisation",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SettingsMenuItemConnection",
                    "kind": "LinkedField",
                    "name": "sidebar",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SettingsMenuItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "menuId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "visible"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GlobalNavigationComponentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GlobalNavigationComponentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "ee5a91706bc8d2c36266138f1556fa8e",
            "id": "7f7a8c5a405e165722f55d2fb38fba615d09b5f4c08ede00a7a9fe5741f08c7a",
            "metadata": {},
            "name": "GlobalNavigationComponentQuery",
            "operationKind": "query",
            "text": "query GlobalNavigationComponentQuery($entityAri:ID!,$ownerAri:ID!){settings_navigationCustomisation(entityAri:$entityAri,ownerAri:$ownerAri){id,sidebar{nodes{menuId,visible}}}}"
        }
    };
}();
$62aeb16db236e807$var$node.hash = "0e74e77d53a00c9095e60ae7930a7cf3";
var $62aeb16db236e807$export$2e2bcd8739ae039 = $62aeb16db236e807$var$node;
module.exports["default"] = $62aeb16db236e807$export$2e2bcd8739ae039;

});

parcelRegister("aQN68", function(module, exports) {
/**
 * @generated SignedSource<<4397834310e821608aae72d6cd602b23>>
 * @relayHash efbccdac5bb753d6ce419c019fa1aaca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2c716a297065a0b32d13d0ef655d0af2eb808e17bfd7325a7ecbc232e2971439
const $ede2af096215976f$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useLicensedProductsQueryForGlobalAppShortcutsQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useLicensedProductsQueryForGlobalAppShortcutsQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "efbccdac5bb753d6ce419c019fa1aaca",
            "id": "2c716a297065a0b32d13d0ef655d0af2eb808e17bfd7325a7ecbc232e2971439",
            "metadata": {},
            "name": "useLicensedProductsQueryForGlobalAppShortcutsQuery",
            "operationKind": "query",
            "text": "query useLicensedProductsQueryForGlobalAppShortcutsQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
        }
    };
}();
$ede2af096215976f$var$node.hash = "4173fb2f98b7988a84dc02df0399a348";
var $ede2af096215976f$export$2e2bcd8739ae039 = $ede2af096215976f$var$node;
module.exports["default"] = $ede2af096215976f$export$2e2bcd8739ae039;

});

parcelRegister("cbHql", function(module, exports) {
/**
 * @generated SignedSource<<ca53475eaec9df41a732c9e6f52f225d>>
 * @relayHash c67b40e0841cbe3641e147b8f635e291
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8cba7661cae04b18a2f396c25dedbd53d2bb4184aef34b7e93cfb70fbef58af5
const $40163854596f3729$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceEditorSettings",
                    "kind": "LinkedField",
                    "name": "confluenceEditorSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "toolbarDockingInitialPosition"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "EditorPreferencesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "EditorPreferencesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "c67b40e0841cbe3641e147b8f635e291",
            "id": "8cba7661cae04b18a2f396c25dedbd53d2bb4184aef34b7e93cfb70fbef58af5",
            "metadata": {},
            "name": "EditorPreferencesQuery",
            "operationKind": "query",
            "text": "query EditorPreferencesQuery{userPreferences{confluenceEditorSettings{toolbarDockingInitialPosition}}}"
        }
    };
}();
$40163854596f3729$var$node.hash = "49dd5f6cf6c26477ad455a4c7f501e60";
var $40163854596f3729$export$2e2bcd8739ae039 = $40163854596f3729$var$node;
module.exports["default"] = $40163854596f3729$export$2e2bcd8739ae039;

});

parcelRegister("9sGCn", function(module, exports) {

var $5RVp4 = parcelRequire("5RVp4");


var $5tydj = parcelRequire("5tydj");


var $kBBRP = parcelRequire("kBBRP");


var $b22Ya = parcelRequire("b22Ya");


var $dOBRD = parcelRequire("dOBRD");


var $fFmJj = parcelRequire("fFmJj");


var $ge2sX = parcelRequire("ge2sX");

var $416a341702253f60$var$Client = /*#__PURE__*/ function(Client) {
    Client["CC_GRAPHQL"] = "Cc graphql client";
    Client["AGG_GRAPHQL"] = "Agg graphql client";
    return Client;
}($416a341702253f60$var$Client || {});
const $416a341702253f60$var$FRAGMENTS_BY_TYPE = [
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        fragment: (0, $b22Ya.default)
    },
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        // If we don't have `status` cached but do have `subType` cached, this ensures we still fast load it. We prefer fast loading live docs even if we're uncertain whether they're archived.
        fragment: (0, $kBBRP.default)
    },
    {
        client: "Cc graphql client",
        gqlType: 'PTPage',
        fragment: (0, $5tydj.default)
    },
    {
        // Search query uses agg graphql client
        client: "Agg graphql client",
        gqlType: 'SearchConfluencePageBlogAttachment',
        fragment: (0, $5RVp4.default)
    }
];
const $416a341702253f60$export$b4dacd1dfdee469b = (0, $dOBRD.default)((contentId)=>{
    if (!contentId) // When content id does not exist, return undefined values
    return {
        subType: undefined,
        isArchived: undefined,
        gqlType: undefined
    };
    const cloudId = (0, $ge2sX.getCloudId)();
    let subType;
    let isArchived = undefined;
    let gqlTypeUsed;
    $416a341702253f60$var$FRAGMENTS_BY_TYPE.some(({ client: client, gqlType: gqlType, fragment: fragment })=>{
        // readFragment throws an error if it finds the item in the cache without both id and subtype, so we wrap in try/catch
        try {
            let id = `${gqlType}:${contentId}`;
            if (gqlType === 'SearchConfluencePageBlogAttachment') // Search graphql query includes the ARI in the id
            id = `${gqlType}:ari:cloud:confluence:${cloudId}:page/${contentId}`;
            const fragmentData = (0, $fFmJj.readFragmentInterop)({
                id: id,
                fragment: fragment,
                interopApolloAggClient: client === "Agg graphql client",
                __callerPackage__: "live-pages-utils"
            });
            if (fragmentData && 'subType' in fragmentData && fragmentData.subType) {
                subType = fragmentData.subType;
                isArchived = 'status' in fragmentData && fragmentData.status ? fragmentData.status?.toLowerCase?.() === 'archived' : undefined;
                gqlTypeUsed = gqlType;
                return true;
            } else if (fragmentData && 'subtype' in fragmentData && fragmentData.subtype) {
                // In search graphql query's response, subtype exists as an inline fragment on ConfluencePage
                subType = fragmentData.subtype?.toLowerCase?.();
                gqlTypeUsed = gqlType;
                return true;
            }
        } catch  {}
    });
    return {
        subType: subType,
        isArchived: isArchived,
        gqlType: gqlTypeUsed
    };
});
const $416a341702253f60$export$d56c32e9e73f8f9b = ()=>$416a341702253f60$export$b4dacd1dfdee469b.clear();
module.exports["getCachedPageData"] = $416a341702253f60$export$b4dacd1dfdee469b;
module.exports["clearMemoizedCachedPageData"] = $416a341702253f60$export$d56c32e9e73f8f9b;

});

parcelRegister("5RVp4", function(module, exports) {
/**
 * @generated SignedSource<<9964ae8171b6e20649f2fca9a76ff96a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d1b5c3b39238b90e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypeSearchFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "LinkedField",
            "name": "confluenceEntity",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "subtype"
                        }
                    ],
                    "type": "ConfluencePage"
                }
            ]
        }
    ],
    "type": "SearchConfluencePageBlogAttachment"
};
$d1b5c3b39238b90e$var$node.hash = "029b00b42bd8ba9e9b5ecf4947b241c2";
var $d1b5c3b39238b90e$export$2e2bcd8739ae039 = $d1b5c3b39238b90e$var$node;
module.exports["default"] = $d1b5c3b39238b90e$export$2e2bcd8739ae039;

});

parcelRegister("5tydj", function(module, exports) {
/**
 * @generated SignedSource<<06b30fff81deb6c9145868aacd1b6057>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $019558c9ca245006$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypePageTreeFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        }
    ],
    "type": "PTPage"
};
$019558c9ca245006$var$node.hash = "7ccb76f2a832d90b6f167fe96a11f5a9";
var $019558c9ca245006$export$2e2bcd8739ae039 = $019558c9ca245006$var$node;
module.exports["default"] = $019558c9ca245006$export$2e2bcd8739ae039;

});

parcelRegister("kBBRP", function(module, exports) {
/**
 * @generated SignedSource<<ba803410513b2e2b6e70f77d471effb5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6f66d8210bca9b3e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypeContentFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        }
    ],
    "type": "Content"
};
$6f66d8210bca9b3e$var$node.hash = "03b28a640aee18909db0a4f3575e7f08";
var $6f66d8210bca9b3e$export$2e2bcd8739ae039 = $6f66d8210bca9b3e$var$node;
module.exports["default"] = $6f66d8210bca9b3e$export$2e2bcd8739ae039;

});

parcelRegister("b22Ya", function(module, exports) {
/**
 * @generated SignedSource<<3f51ca78fc05b3943b12ce8587361a0d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f9170d170545992b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataContentFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        }
    ],
    "type": "Content"
};
$f9170d170545992b$var$node.hash = "b940ae3a5484e1099f106d12713d37f5";
var $f9170d170545992b$export$2e2bcd8739ae039 = $f9170d170545992b$var$node;
module.exports["default"] = $f9170d170545992b$export$2e2bcd8739ae039;

});

parcelRegister("3y1ko", function(module, exports) {

var $xwvlW = parcelRequire("xwvlW");


var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");


var $f7B1p = parcelRequire("f7B1p");

async function $4c06255176f911bc$export$632d1cf1f5c6210f() {
    let enabled = false;
    try {
        const res = await (0, $f7B1p.cfetch)('/wiki/rest/confluenceshortcuts/latest/enabled');
        if (res.ok) enabled = await res.text() === 'true';
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Error fetching keyboard shortcuts enabled state: ${e.message}`), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        });
    }
    return window.__SHORTCUT_ENABLED__ = enabled;
}
async function $4c06255176f911bc$export$abcdd924245fc03a() {
    const { isLoggedIn: isLoggedIn, isLicensed: isLicensed } = (0, $xwvlW.getPreloaderFnContext)();
    if (isLoggedIn && isLicensed) return await $4c06255176f911bc$export$632d1cf1f5c6210f();
    return false;
}
module.exports["fetchShortcutEnabledState"] = $4c06255176f911bc$export$632d1cf1f5c6210f;
module.exports["preloadShortcutEnabledState"] = $4c06255176f911bc$export$abcdd924245fc03a;

});

parcelRegister("hXDOc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $9wGTI = parcelRequire("9wGTI");

var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $cozmU.useRef)(null);
    const preloadRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $cozmU.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Do not proceed to the next stage if only JS preloading is enabled
        if (preloadOptions?.preloadingMode === "onlyJS") return;
        // Trigger next preloading stage either if everything is enabled or if critical data preloading
        // is enabled and the corresponding feature flag is enabled.
        const shouldPreload = preloadOptions?.preloadingMode === "everything" ? true : preloadOptions?.preloadingMode === "onlyJSAndCriticalData" && (0, $9wGTI.fg)('confluence_preload_critical_data');
        if (!shouldPreload) return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $cozmU.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    // Helper to chain child handlers with hover-preloader handlers
    const chain = (...fns)=>(...args)=>{
            fns.forEach((fn)=>{
                if (fn) fn(...args);
            });
        };
    const wrappedChild = /*#__PURE__*/ (0, $cozmU.isValidElement)(children) ? /*#__PURE__*/ (0, $cozmU.cloneElement)(children, {
        onMouseEnter: chain(children.props.onMouseEnter, onMouseEnter),
        onFocus: chain(children.props.onFocus, onMouseEnter),
        onMouseLeave: chain(children.props.onMouseLeave, onMouseLeave),
        onBlur: chain(children.props.onBlur, onMouseLeave),
        onMouseDown: chain(children.props.onMouseDown, onMouseDown)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-vc": `hover-preloader-${name}`,
        "data-testid": "hover-preloader"
    }, wrappedChild);
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};
module.exports["PreloadingMode"] = $b22e252a6b9677fd$export$3c7387d0e5ed624d;
module.exports["HoverPreloader"] = $b22e252a6b9677fd$export$16d0fec7f7c7ddfa;
module.exports["PreloadingPresets"] = $b22e252a6b9677fd$export$f5ad7b1003f136b2;

});

parcelRegister("gVWsk", function(module, exports) {
function $a5a63f3e365d7e09$export$1c4065b3a9f04cf2(value) {
    if (!value || typeof value !== 'object') return false;
    const doc = value;
    // Check required properties
    if (doc.type !== 'doc') return false;
    if (!Array.isArray(doc.content)) return false;
    // Version is optional but if present should be a number
    if (doc.version !== undefined && typeof doc.version !== 'number') return false;
    return true;
}
module.exports["isJSONDocNode"] = $a5a63f3e365d7e09$export$1c4065b3a9f04cf2;

});

parcelRegister("wPrRK", function(module, exports) {


var $9WAeG = parcelRequire("9WAeG");


var $1xpoY = parcelRequire("1xpoY");



const $0a25e88d230f5014$export$df0dc85e162077fe = 500;
const $0a25e88d230f5014$export$e4579551e9b7b973 = async (name, task, timeout, skipSignal)=>{
    let timer = null;
    const slowQueryGuardTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_slow_query_guard_timeout', $0a25e88d230f5014$export$df0dc85e162077fe);
    const finalTimeout = Math.max(timeout, slowQueryGuardTimeout);
    const timeoutPromise = new Promise((resolve)=>{
        timer = setTimeout(()=>{
            resolve(false);
        }, finalTimeout);
    });
    const runTask = async ()=>{
        const run = async ()=>{
            await (0, $9WAeG.SSRMeasures).run(`ssr-app/prepare/preloadQuery/slowQueryGuard:${name}`, task);
            if (timer) clearTimeout(timer);
            return true;
        };
        return run();
    };
    return Promise.race(skipSignal ? [
        timeoutPromise,
        skipSignal.then(()=>true),
        runTask()
    ] : [
        timeoutPromise,
        runTask()
    ]);
};
module.exports["SLOW_QUERY_DEFAULT_TIMEOUT"] = $0a25e88d230f5014$export$df0dc85e162077fe;
module.exports["slowQueryGuard"] = $0a25e88d230f5014$export$e4579551e9b7b973;

});

parcelRegister("kquO1", function(module, exports) {

var $05daj = parcelRequire("05daj");


var $7Sm4c = parcelRequire("7Sm4c");


var $dYU3e = parcelRequire("dYU3e");


var $8tmcF = parcelRequire("8tmcF");


var $3mugH = parcelRequire("3mugH");

const $16ec8c3b2306adb8$var$PRELOAD_TIMEOUT_MS = 500;
const $16ec8c3b2306adb8$var$TIMED_OUT = Symbol('outgoing-links-preload-timed-out');
const $16ec8c3b2306adb8$export$a0681264c37c98d4 = (0, $05daj.default);
const $16ec8c3b2306adb8$var$runQuery = (contentId)=>(0, $dYU3e.query)({
        query: $16ec8c3b2306adb8$export$a0681264c37c98d4,
        variables: {
            contentId: contentId
        },
        __callerPackage__: "connectors"
    });
const $16ec8c3b2306adb8$var$reportUnavailable = (reason, cause)=>{
    (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Outgoing links preload unavailable: ${reason}`, {
        cause: cause
    }), {
        operation: 'preload-outgoing-links',
        reason: reason
    });
    if (cause instanceof Error) (0, $7Sm4c.markErrorAsHandled)(cause);
};
const $16ec8c3b2306adb8$export$57bfcc710803f40e = async (contentId)=>{
    try {
        const promise = $16ec8c3b2306adb8$var$runQuery(contentId);
        const result = await (0, $8tmcF.timeGuard)(()=>promise, $16ec8c3b2306adb8$var$TIMED_OUT, $16ec8c3b2306adb8$var$PRELOAD_TIMEOUT_MS);
        if (result === $16ec8c3b2306adb8$var$TIMED_OUT) {
            $16ec8c3b2306adb8$var$reportUnavailable('timeout');
            return;
        }
        if (result.hasErrors || result.errors?.length) $16ec8c3b2306adb8$var$reportUnavailable('query-error', result.errors?.[0]);
    } catch (cause) {
        $16ec8c3b2306adb8$var$reportUnavailable('query-error', cause);
    }
};
module.exports["OutgoingLinksQuery"] = $16ec8c3b2306adb8$export$a0681264c37c98d4;
module.exports["preloadOutgoingLinks"] = $16ec8c3b2306adb8$export$57bfcc710803f40e;

});

parcelRegister("05daj", function(module, exports) {
/**
 * @generated SignedSource<<9b82e025502749d65398a1224a13d8b3>>
 * @relayHash fec3092eee5be8002a509e6d3be00bc6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ab71c9a12a0be2c8e5d9d99b7deecbd0116bb7ce35f6af9111a2fe2f1177c3c
const $be4a7160c946b27a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "OutgoingLinks",
                            "kind": "LinkedField",
                            "name": "outgoingLinks",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 50
                                        }
                                    ],
                                    "concreteType": "ConfluenceExternalLinkConnection",
                                    "kind": "LinkedField",
                                    "name": "externalOutgoingLinks",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceExternalLink",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "url"
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "externalOutgoingLinks(first:50)"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadOutgoingLinksQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadOutgoingLinksQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fec3092eee5be8002a509e6d3be00bc6",
            "id": "1ab71c9a12a0be2c8e5d9d99b7deecbd0116bb7ce35f6af9111a2fe2f1177c3c",
            "metadata": {},
            "name": "preloadOutgoingLinksQuery",
            "operationKind": "query",
            "text": "query preloadOutgoingLinksQuery($contentId:ID!){content(id:$contentId){nodes{id,outgoingLinks{externalOutgoingLinks(first:50){nodes{url}}}}}}"
        }
    };
}();
$be4a7160c946b27a$var$node.hash = "62d400bfa3bd0d225066bef6f6f82860";
var $be4a7160c946b27a$export$2e2bcd8739ae039 = $be4a7160c946b27a$var$node;
module.exports["default"] = $be4a7160c946b27a$export$2e2bcd8739ae039;

});

parcelRegister("8tmcF", function(module, exports) {
function $5c639d7819ef31f1$export$baa85236a0d673f4(task, returnValueOnTimeout, timeout) {
    return Promise.race([
        task(),
        new Promise((resolve)=>setTimeout(()=>{
                resolve(typeof returnValueOnTimeout === 'function' ? returnValueOnTimeout() : returnValueOnTimeout);
            }, timeout))
    ]);
}
module.exports["timeGuard"] = $5c639d7819ef31f1$export$baa85236a0d673f4;

});

parcelRegister("3qGQ7", function(module, exports) {
const $1ddb1afb9a8b0771$var$DEFAULT_BYLINE_CONTRIBUTORS_FETCH_LIMIT = 4;
const $1ddb1afb9a8b0771$var$createSharedVariables = ({ spaceKey: spaceKey, versionOverride: versionOverride, isSSR: isSSR, preloadLabels: preloadLabels = false, includeAgentTrustReceiptData: includeAgentTrustReceiptData = false, includeAutomationDiscoveries: includeAutomationDiscoveries = false, includeAudioContent: includeAudioContent = false, includeRendererAssetsMedia: includeRendererAssetsMedia = false, includeRendererAssetsCustomChrome: includeRendererAssetsCustomChrome = false, includeMetadata: includeMetadata = false, includeClassification: includeClassification = false, includeContentHeader: includeContentHeader = false, includeContentHeaderAccess: includeContentHeaderAccess = false, includeFabricEditorEligibility: includeFabricEditorEligibility = false, includeReactions: includeReactions = false, includeRestrictions: includeRestrictions = false, includeRestrictionAncestors: includeRestrictionAncestors = false, useContentModeFragment: useContentModeFragment = false, autohighlightsQueryVariables: autohighlightsQueryVariables })=>({
        spaceKey: spaceKey,
        versionOverride: versionOverride,
        isSSR: isSSR,
        useNewContentTopper: true,
        ...preloadLabels || includeMetadata ? {
            preloadLabels: true
        } : {},
        ...includeAgentTrustReceiptData ? {
            includeAgentTrustReceiptData: true
        } : {},
        ...includeAutomationDiscoveries ? {
            includeAutomationDiscoveries: true
        } : {},
        ...includeAudioContent ? {
            includeAudioContent: true
        } : {},
        ...includeRendererAssetsMedia ? {
            includeRendererAssetsMedia: true
        } : {},
        ...includeRendererAssetsCustomChrome ? {
            includeRendererAssetsCustomChrome: true
        } : {},
        ...includeClassification || includeMetadata ? {
            includeClassification: true
        } : {},
        ...includeContentHeader ? {
            includeContentHeader: true
        } : {},
        ...includeContentHeaderAccess ? {
            includeContentHeaderAccess: true
        } : {},
        ...includeFabricEditorEligibility ? {
            includeFabricEditorEligibility: true
        } : {},
        ...includeReactions ? {
            includeReactions: true
        } : {},
        ...includeRestrictions ? {
            includeRestrictions: true
        } : {},
        ...includeRestrictionAncestors ? {
            includeRestrictionAncestors: true
        } : {},
        ...useContentModeFragment ? {
            useContentModeFragment: true
        } : {},
        ...autohighlightsQueryVariables ? {
            includeAutohighlights: true,
            autohighlightsEntityAri: autohighlightsQueryVariables.entityAri,
            autohighlightsWorkspaceId: autohighlightsQueryVariables.workspaceId
        } : {}
    });
const $1ddb1afb9a8b0771$var$createAgentSessionVariables = (agentSessionsUserId)=>agentSessionsUserId ? {
        agentSessionsPropertyKey: `cc-agent-mention-sessions:${agentSessionsUserId}`,
        fetchAgentSessionsMarker: true
    } : {};
const $1ddb1afb9a8b0771$var$createBylineVariables = (includeBylineContributors = false)=>includeBylineContributors ? {
        includeBylineContributors: true,
        bylineContributorsLimit: $1ddb1afb9a8b0771$var$DEFAULT_BYLINE_CONTRIBUTORS_FETCH_LIMIT
    } : {};
const $1ddb1afb9a8b0771$var$createAnalyticsBylineVariables = (includeAnalyticsByline = false)=>includeAnalyticsByline ? {
        includeAnalyticsByline: true
    } : {};
const $1ddb1afb9a8b0771$var$createConnectionAncestorVariables = (includeConnectionAncestors = false)=>includeConnectionAncestors ? {
        includeConnectionAncestors: true
    } : {};
const $1ddb1afb9a8b0771$export$5aa9cbe79a3cf3 = ({ contentId: contentId, agentSessionsUserId: agentSessionsUserId, includeBylineContributors: includeBylineContributors, includeConnectionAncestors: includeConnectionAncestors, includeAnalyticsByline: includeAnalyticsByline, includeContentHeaderPublicLink: includeContentHeaderPublicLink, includeRendererAssetsDsp: includeRendererAssetsDsp, rendererAssetsDspAction: rendererAssetsDspAction, externalLabelsQueryVariables: externalLabelsQueryVariables, ...sharedOptions })=>({
        contentId: contentId,
        ...$1ddb1afb9a8b0771$var$createSharedVariables(sharedOptions),
        ...$1ddb1afb9a8b0771$var$createAgentSessionVariables(agentSessionsUserId),
        ...$1ddb1afb9a8b0771$var$createBylineVariables(includeBylineContributors),
        ...$1ddb1afb9a8b0771$var$createConnectionAncestorVariables(includeConnectionAncestors),
        ...$1ddb1afb9a8b0771$var$createAnalyticsBylineVariables(includeAnalyticsByline),
        ...includeContentHeaderPublicLink ? {
            includeContentHeaderPublicLink: true
        } : {},
        ...includeRendererAssetsDsp ? {
            includeRendererAssetsDsp: true,
            rendererAssetsDspAction: rendererAssetsDspAction || 'PAGE_EXPORT'
        } : {},
        // Managed (external) labels: emit the include flag and args only when the
        // feature is on for this content. `externalLabelsCloudId`/`externalLabelsAri`
        // are declared nullable-with-default (`ID = ""`) on `ContentUnifiedQuery`, so
        // omitting them here is safe — GraphQL supplies the default, and a
        // nullable-with-default variable still satisfies the fragment's non-null
        // `ID!` argument via the variable-usage rule. Mirrors the autohighlights
        // pattern so omitting consumers get an unchanged variables object.
        ...externalLabelsQueryVariables ? {
            includeExternalLabels: true,
            externalLabelsCloudId: externalLabelsQueryVariables.cloudId,
            externalLabelsAri: externalLabelsQueryVariables.ari
        } : {}
    });
const $1ddb1afb9a8b0771$export$85ff462ea4060e8a = ({ contentId: contentId, includeBylineContributors: includeBylineContributors, includeAnalyticsByline: includeAnalyticsByline, includeContentHeaderPublicLink: includeContentHeaderPublicLink, includeRendererAssetsDsp: includeRendererAssetsDsp, rendererAssetsDspAction: rendererAssetsDspAction, ...sharedOptions })=>({
        contentId: contentId,
        ...$1ddb1afb9a8b0771$var$createSharedVariables(sharedOptions),
        ...$1ddb1afb9a8b0771$var$createBylineVariables(includeBylineContributors),
        ...$1ddb1afb9a8b0771$var$createAnalyticsBylineVariables(includeAnalyticsByline),
        ...includeContentHeaderPublicLink ? {
            includeContentHeaderPublicLink: true
        } : {},
        ...includeRendererAssetsDsp ? {
            includeRendererAssetsDsp: true,
            rendererAssetsDspAction: rendererAssetsDspAction || 'PAGE_EXPORT'
        } : {}
    });
const $1ddb1afb9a8b0771$export$2021e0be086a965a = ({ spaceKey: spaceKey, agentSessionsUserId: agentSessionsUserId, includeBylineContributors: includeBylineContributors, includeConnectionAncestors: includeConnectionAncestors, ...sharedOptions })=>({
        ...$1ddb1afb9a8b0771$var$createSharedVariables({
            ...sharedOptions,
            spaceKey: spaceKey
        }),
        spaceKey: spaceKey,
        ...$1ddb1afb9a8b0771$var$createAgentSessionVariables(agentSessionsUserId),
        ...includeBylineContributors ? {
            includeBylineContributors: true
        } : {},
        ...$1ddb1afb9a8b0771$var$createConnectionAncestorVariables(includeConnectionAncestors)
    });
module.exports["createContentUnifiedQueryVariables"] = $1ddb1afb9a8b0771$export$5aa9cbe79a3cf3;
module.exports["createContentBlogUnifiedQueryVariables"] = $1ddb1afb9a8b0771$export$85ff462ea4060e8a;
module.exports["createContentUnifiedWithSpaceKeyQueryVariables"] = $1ddb1afb9a8b0771$export$2021e0be086a965a;

});

parcelRegister("hNtOj", function(module, exports) {

var $etu7G = parcelRequire("etu7G");

const $120c25b1424bdefe$export$c82fe4eede9104df = new (0, $etu7G.SSRPermissionsErrorHandler)();
module.exports["ssrPermissionsErrorHandler"] = $120c25b1424bdefe$export$c82fe4eede9104df;

});

parcelRegister("etu7G", function(module, exports) {
class $c6d83b8df27b1c26$export$e70f491dc46ba2ed {
    markSSRPreloadPermissionError(route, error) {
        this.hasSSRPreloadPermissionsErrorForRoute = route;
        if (error) this.errorType = error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message?.key === 'confluence.content.restricted.inherited' ? 'inherited' : 'view';
    }
    getRestrictedRoute() {
        return this.hasSSRPreloadPermissionsErrorForRoute || window.__SSR_RESTRICTED_PAGE__?.route || null;
    }
    getErrorType() {
        return this.errorType || window.__SSR_RESTRICTED_PAGE__?.errorType || null;
    }
    constructor(){
        this.hasSSRPreloadPermissionsErrorForRoute = void 0;
        this.errorType = void 0;
        this.hasSSRPreloadPermissionsErrorForRoute = null;
        this.errorType = null;
    }
}
module.exports["SSRPermissionsErrorHandler"] = $c6d83b8df27b1c26$export$e70f491dc46ba2ed;

});

parcelRegister("b2p4s", function(module, exports) {
/**
 * @generated SignedSource<<4e480f3ff7d119a77ec41231b6b4ab42>>
 * @relayHash aa12b95dc97d2068b03de4a55dcec507
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0ef2c27ad493d782c86e25177000afba538c3c0eb50c460bf6d939aa03f2139c
const $ac606d0e22e5c37c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "draftShareId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "editor"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"editor\")"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "NotFoundContainerQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "NotFoundContainerQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "aa12b95dc97d2068b03de4a55dcec507",
            "id": "0ef2c27ad493d782c86e25177000afba538c3c0eb50c460bf6d939aa03f2139c",
            "metadata": {},
            "name": "NotFoundContainerQuery",
            "operationKind": "query",
            "text": "query NotFoundContainerQuery($contentId:ID!,$draftShareId:String,$status:[String]){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,links{webui},properties(key:\"editor\"){nodes{id,key,value}}}}}"
        }
    };
}();
$ac606d0e22e5c37c$var$node.hash = "df3b0c202e5cf0f97257fa8a583747bc";
var $ac606d0e22e5c37c$export$2e2bcd8739ae039 = $ac606d0e22e5c37c$var$node;
module.exports["default"] = $ac606d0e22e5c37c$export$2e2bcd8739ae039;

});

parcelRegister("3y0Sn", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $8XUSS = parcelRequire("8XUSS");

const $37592cc5d5c1e3cb$export$f75f259a21c2ee98 = (links)=>{
    const resolvedFromGql = [];
    const linksForORS = [];
    for (const link of links)if (link.product === 'confluence' && link.resolved === true && (!(0, $9wGTI.fg)('cc_preserve_smart_link_anchor_content') || !$37592cc5d5c1e3cb$export$4969d1e873fcbaaf(link.resourceUrl))) resolvedFromGql.push(link);
    else linksForORS.push(link);
    return {
        resolvedFromGql: resolvedFromGql,
        linksForORS: linksForORS
    };
};
function $37592cc5d5c1e3cb$export$4969d1e873fcbaaf(url) {
    if (!url) return false;
    try {
        return new URL(url).hash.length > 1;
    } catch  {
        const [, fragment] = url.split('#');
        return Boolean(fragment);
    }
}
const $37592cc5d5c1e3cb$export$5079bd68f592c783 = (resolvedLinks)=>{
    if (!resolvedLinks?.length) return {};
    return resolvedLinks.reduce((map, link)=>{
        const url = link.resourceUrl;
        if (!url) return map;
        const iconUrl = $37592cc5d5c1e3cb$var$getStaticIconUrl(link.resourceType, url) ?? link.iconUrl;
        const cardState = {
            status: link.canView === true ? (0, $8XUSS.RESOLVED) : (0, $8XUSS.FORBIDDEN),
            details: {
                meta: {
                    access: link.canView === true ? 'granted' : 'forbidden',
                    auth: [],
                    definitionId: $37592cc5d5c1e3cb$var$getDefinitionId(link.resourceType),
                    resourceType: link.resourceType,
                    product: 'confluence'
                },
                data: {
                    '@context': {
                        '@vocab': 'https://www.w3.org/ns/activitystreams#',
                        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
                        schema: 'https://schema.org/'
                    },
                    '@type': $37592cc5d5c1e3cb$var$getResourceType(link.resourceType, link.subType),
                    name: link.title || '',
                    url: url,
                    ...$37592cc5d5c1e3cb$var$hasTopLevelIcon(link.resourceType) && iconUrl ? {
                        icon: {
                            '@type': 'Image',
                            url: iconUrl
                        }
                    } : {},
                    ...$37592cc5d5c1e3cb$var$hasTitlePrefix(link.resourceType) && link.emojiTitle ? {
                        'atlassian:titlePrefix': {
                            '@type': 'atlassian:Emoji',
                            text: link.emojiTitle
                        }
                    } : {},
                    generator: {
                        '@type': 'Application',
                        '@id': $37592cc5d5c1e3cb$var$getGeneratorId(link.resourceType),
                        name: $37592cc5d5c1e3cb$var$getGeneratorName(link.resourceType),
                        ...iconUrl ? {
                            icon: {
                                '@type': 'Image',
                                url: iconUrl
                            }
                        } : {}
                    }
                }
            }
        };
        return {
            ...map,
            [url]: cardState
        };
    }, {});
};
/**
 * Map resourceType to the ORS definitionId.
 * Whiteboards and databases use a different provider than pages/blogs/spaces.
 */ function $37592cc5d5c1e3cb$var$getDefinitionId(resourceType) {
    switch(resourceType){
        case 'whiteboard':
        case 'database':
        case 'slide':
            return 'canvas-native-object-provider';
        default:
            return 'integrations-confluence-object-provider';
    }
}
/**
 * Whether this resourceType has a top-level `icon` field in the ORS data response.
 * Pages and blogs do not; whiteboards, databases, slides, folders, and spaces do.
 */ function $37592cc5d5c1e3cb$var$hasTopLevelIcon(resourceType) {
    switch(resourceType){
        case 'whiteboard':
        case 'database':
        case 'slide':
        case 'folder':
        case 'space':
            return true;
        default:
            return false;
    }
}
/**
 * Returns a hardcoded icon URL for resource types that do not have an icon URL returned by the
 * GraphQL API. Whiteboards and databases fall into this category.
 * These URL must match those listed in https://bitbucket.org/atlassian/canvas/src/68e87076d0168bb32184f72e66cea5cfc0a96516/services/canvas-server/canvas-server/src/routes/private/smart-link/smart-link-utils.ts
 * For database links with an `entryId` query parameter, a database-entry icon is used instead.
 */ function $37592cc5d5c1e3cb$var$getStaticIconUrl(resourceType, url) {
    switch(resourceType){
        case 'whiteboard':
            return 'https://canvas-frontend.prod-east.frontend.public.atl-paas.net/assets/whiteboard-logo.svg';
        case 'database':
            if (url) try {
                const parsedUrl = new URL(url);
                if (parsedUrl.searchParams.has('entryId')) return 'https://canvas-frontend.prod-east.frontend.public.atl-paas.net/assets/database-entry-logo.svg';
            } catch  {
            // If URL parsing fails, fall through to the default database icon
            }
            return 'https://canvas-frontend.prod-east.frontend.public.atl-paas.net/assets/database-logo.svg';
        case 'slide':
            return 'https://canvas-frontend.prod-east.frontend.public.atl-paas.net/assets/slides-logo.svg';
        case 'folder':
            return 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT1315J.svg';
        default:
            return null;
    }
}
/**
 * Whether this resourceType includes `atlassian:titlePrefix` in the ORS data response.
 * Pages, blogs, and spaces do; whiteboards and databases do not.
 */ function $37592cc5d5c1e3cb$var$hasTitlePrefix(resourceType) {
    switch(resourceType){
        case 'whiteboard':
        case 'database':
        case 'slide':
            return false;
        default:
            return true;
    }
}
/**
 * Map resourceType to the generator @id used by the SmartCard Provider.
 * Values are based on actual ORS responses.
 */ function $37592cc5d5c1e3cb$var$getGeneratorId(resourceType) {
    switch(resourceType){
        case 'whiteboard':
            return 'https://www.atlassian.com/#ConfluenceWhiteboards';
        case 'database':
            return 'https://www.atlassian.com/#ConfluenceDatabases';
        case 'slide':
            return 'https://www.atlassian.com/#ConfluenceSlides';
        default:
            return 'https://www.atlassian.com/#Confluence';
    }
}
/**
 * Map resourceType to the generator display name.
 * Values are based on actual ORS responses.
 */ function $37592cc5d5c1e3cb$var$getGeneratorName(resourceType) {
    switch(resourceType){
        case 'whiteboard':
            return 'Confluence Whiteboards';
        case 'database':
            return 'Confluence Databases';
        case 'slide':
            return 'Confluence Slides';
        default:
            return 'Confluence';
    }
}
/**
 * Map resourceType to an ActivityStreams @type value for Confluence content.
 * Values are based on actual ORS responses.
 */ function $37592cc5d5c1e3cb$var$getResourceType(resourceType, subType) {
    switch(resourceType){
        case 'blogpost':
            return [
                'Document',
                'schema:BlogPosting'
            ];
        case 'page':
            if (subType === 'live') return [
                'Document',
                'schema:DigitalDocument'
            ];
            return [
                'Document',
                'schema:TextDigitalDocument'
            ];
        case 'whiteboard':
        case 'database':
        case 'slide':
            return 'Document';
        case 'space':
            return [
                'Object',
                'atlassian:Project'
            ];
        default:
            return [
                'Document',
                'schema:TextDigitalDocument'
            ];
    }
}
module.exports["partitionResolvedLinks"] = $37592cc5d5c1e3cb$export$f75f259a21c2ee98;
module.exports["hasUrlFragment"] = $37592cc5d5c1e3cb$export$4969d1e873fcbaaf;
module.exports["buildResolvedSmartLinkState"] = $37592cc5d5c1e3cb$export$5079bd68f592c783;

});

parcelRegister("8XUSS", function(module, exports) {
// Exported for testing
const $6f18789dfc68c5f3$export$483989a9813b3c0d = 'resolved';
const $6f18789dfc68c5f3$export$a3269a3914b007e3 = 'forbidden';
const $6f18789dfc68c5f3$export$67d19e9a991baa07 = 'unauthorized';
const $6f18789dfc68c5f3$export$8bca792d963eb0ef = 'not_found';
const $6f18789dfc68c5f3$export$b70265791d2079d4 = (statusCode, access)=>{
    const statusMap = {
        200: $6f18789dfc68c5f3$export$483989a9813b3c0d,
        401: $6f18789dfc68c5f3$export$67d19e9a991baa07,
        403: $6f18789dfc68c5f3$export$a3269a3914b007e3,
        404: $6f18789dfc68c5f3$export$8bca792d963eb0ef
    };
    if (access === $6f18789dfc68c5f3$export$a3269a3914b007e3 || access === $6f18789dfc68c5f3$export$67d19e9a991baa07) return access;
    return statusMap[statusCode] || 'errored';
};
module.exports["RESOLVED"] = $6f18789dfc68c5f3$export$483989a9813b3c0d;
module.exports["FORBIDDEN"] = $6f18789dfc68c5f3$export$a3269a3914b007e3;
module.exports["getStatus"] = $6f18789dfc68c5f3$export$b70265791d2079d4;

});

parcelRegister("cS4kb", function(module, exports) {
const $5b142abb1411e5f7$var$UNKNOWN = 'unknown';
function $5b142abb1411e5f7$var$sanitizeUrl(url) {
    try {
        const urlObject = new URL(url);
        const hostname = urlObject.hostname;
        const pathname = urlObject.pathname;
        const firstPathSegment = pathname.split('/')[1];
        return firstPathSegment ? `${hostname}/${firstPathSegment}` : hostname;
    } catch  {
        return '';
    }
}
function $5b142abb1411e5f7$export$8071740a02e53ce2(link) {
    if (link.includes('/jira/') || link.includes('/servicedesk/') || link.includes('/helpcenter/') || link.includes('/projects/')) return 'jira';
    else if (link.includes('/wiki/')) return 'confluence';
    else if (link.includes('bitbucket')) return 'bitbucket';
    else if (link.includes('atlassian') || link.includes('jira-dev')) {
        // eslint-disable-next-line no-console
        console.log(`Resolving other atlassian link type: ${$5b142abb1411e5f7$var$sanitizeUrl(link)}`);
        return 'otherAtlassian';
    }
    return 'thirdParty';
}
function $5b142abb1411e5f7$export$70b802114e3b3d52(smartLinks) {
    return Object.values(smartLinks.reduce((acc, smartLink)=>{
        try {
            var _acc, _hostname;
            const hostname = new URL(smartLink.resourceUrl).hostname;
            ((_acc = acc)[_hostname = hostname] || (_acc[_hostname] = [])).push(smartLink);
        // eslint-disable-next-line no-unused-vars
        } catch (e) {
            var _acc1, _UNKNOWN;
            ((_acc1 = acc)[_UNKNOWN = $5b142abb1411e5f7$var$UNKNOWN] || (_acc1[_UNKNOWN] = [])).push(smartLink);
        }
        return acc;
    }, {}));
}
function $5b142abb1411e5f7$export$9f4b5e6e623e6720(smartLinksGroups, max) {
    const result = [];
    for (const smartLinks of smartLinksGroups){
        if (smartLinks.length <= max) result.push(smartLinks);
        else for(let i = 0; i < smartLinks.length; i += max)result.push(smartLinks.slice(i, i + max));
    }
    return result;
}
function $5b142abb1411e5f7$export$3e7fb54d0ef2df07(smartLinksGroups, min) {
    const result = [];
    const smallThirdPartyBatches = [];
    for (const smartLinks of smartLinksGroups)if (smartLinks.length >= min || $5b142abb1411e5f7$export$8071740a02e53ce2(smartLinks[0].resourceUrl) !== 'thirdParty') result.push(smartLinks);
    else smallThirdPartyBatches.push(...smartLinks);
    if (smallThirdPartyBatches.length > 0) result.push(smallThirdPartyBatches);
    return result;
}
function $5b142abb1411e5f7$export$8c4674ec524aaf2c(resourceUrl) {
    const type = $5b142abb1411e5f7$export$8071740a02e53ce2(resourceUrl);
    switch(type){
        case 'jira':
        case 'confluence':
        case 'bitbucket':
        case 'otherAtlassian':
            return true;
        default:
            return false;
    }
}
module.exports["getLinkType"] = $5b142abb1411e5f7$export$8071740a02e53ce2;
module.exports["groupSmartLinksByHostname"] = $5b142abb1411e5f7$export$70b802114e3b3d52;
module.exports["splitLinksIntoBatches"] = $5b142abb1411e5f7$export$9f4b5e6e623e6720;
module.exports["mergeSmallThirdPartyBatches"] = $5b142abb1411e5f7$export$3e7fb54d0ef2df07;
module.exports["isFirstPartyLink"] = $5b142abb1411e5f7$export$8c4674ec524aaf2c;

});

parcelRegister("fyUox", function(module, exports) {

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $1Y111 = parcelRequire("1Y111");


var $zalpJ = parcelRequire("zalpJ");

const $bf604cb6b214d1ef$var$preloadHomepageId = async (spaceKey)=>{
    const res = await (0, $dYU3e.query)({
        query: (0, $zalpJ.PreloadHomepageIdQuery),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "content-topper"
    });
    return res?.data?.space?.homepage?.id;
};
const $bf604cb6b214d1ef$var$preloadTitleContentProperty = (contentId, fetchPolicy = 'cache-first')=>(0, $dYU3e.query)({
        query: (0, $1Y111.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'archived',
                'draft'
            ]
        },
        fetchPolicy: fetchPolicy,
        __callerPackage__: "content-topper"
    });
const $bf604cb6b214d1ef$export$a65164d365713802 = async ({ contentId: contentId, contentIdPromise: contentIdPromise, spaceKey: spaceKey, fetchPolicy: fetchPolicy = 'cache-first' })=>{
    const promises = [];
    if (!contentId) {
        const homepageIdPromise = contentIdPromise || $bf604cb6b214d1ef$var$preloadHomepageId(spaceKey);
        promises.push(homepageIdPromise.then((homepageId)=>{
            return homepageId ? $bf604cb6b214d1ef$var$preloadTitleContentProperty(homepageId) : Promise.resolve({});
        }));
    } else promises.push($bf604cb6b214d1ef$var$preloadTitleContentProperty(contentId, fetchPolicy));
    return (0, $lyWac.waitForAllReturnWhenError)(promises);
};
module.exports["preloadPageTitleContentProperties"] = $bf604cb6b214d1ef$export$a65164d365713802;

});

parcelRegister("1Y111", function(module, exports) {
/**
 * @generated SignedSource<<c93173dea6bc8ed379cb4b9b29fb2a88>>
 * @relayHash 6af15886385d86202fbacd0200dc99eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0
const $66bccefa41a7dece$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "alias": "pageTitlePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-published\")"
                        },
                        {
                            "alias": "pageTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-draft\")"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "coverPictureWidth"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "6af15886385d86202fbacd0200dc99eb",
            "id": "2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0",
            "metadata": {},
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForPublishedPageQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}}}"
        }
    };
}();
$66bccefa41a7dece$var$node.hash = "9a5b243b4d944acf33577dfb16711cea";
var $66bccefa41a7dece$export$2e2bcd8739ae039 = $66bccefa41a7dece$var$node;
module.exports["default"] = $66bccefa41a7dece$export$2e2bcd8739ae039;

});

parcelRegister("zalpJ", function(module, exports) {

var $4lSsc = parcelRequire("4lSsc");


var $eB536 = parcelRequire("eB536");


var $1Y111 = parcelRequire("1Y111");


var $jtuBN = parcelRequire("jtuBN");


var $jVylI = parcelRequire("jVylI");


var $gzIc1 = parcelRequire("gzIc1");

'use no memo';
const $20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery = (0, $1Y111.default);
const $20e32f1deb8c1fe0$export$e114ec4e88c7fe33 = (0, $eB536.default);
const $20e32f1deb8c1fe0$export$c9b63bbfd869a91 = (0, $4lSsc.default);
const $20e32f1deb8c1fe0$export$cef8b8531fa62d5f = (data)=>{
    const titlePropertyContent = data?.content?.nodes?.[0]?.pageTitlePublished?.nodes?.find((node)=>node?.key == 'page-title-property-published');
    const coverPictureWidth = data?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
    if (titlePropertyContent?.value) try {
        return {
            titleContentProperties: (0, $gzIc1.contentPropertyHelper)(titlePropertyContent),
            coverPictureWidth: coverPictureWidth
        };
    } catch  {
        return {
            titleContentProperties: (0, $jVylI.defaultPropertyValue),
            coverPictureWidth: coverPictureWidth
        };
    }
    else return {
        titleContentProperties: (0, $jVylI.defaultPropertyValue),
        coverPictureWidth: coverPictureWidth
    };
};
const $20e32f1deb8c1fe0$var$QUERY_OPTIONS = (contentId)=>({
        variables: {
            contentId: contentId,
            status: [
                'current',
                'archived',
                'draft'
            ]
        },
        fetchPolicy: 'cache-first'
    });
const $20e32f1deb8c1fe0$export$9e9d248809e028e8 = ({ contentId: contentId })=>{
    const options = $20e32f1deb8c1fe0$var$QUERY_OPTIONS(contentId);
    const { data: data, error: error, loading: loading } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery, {
        variables: options.variables,
        skip: !contentId,
        __callerPackage__: "content-topper"
    });
    if (!loading && data && !error) {
        const { titleContentProperties: titleContentProperties, coverPictureWidth: coverPictureWidth } = $20e32f1deb8c1fe0$export$cef8b8531fa62d5f(data);
        return {
            titleContentProperties: titleContentProperties,
            coverPictureWidth: coverPictureWidth
        };
    }
    return {
        titleContentProperties: (0, $jVylI.defaultPropertyValue),
        coverPictureWidth: (0, $jVylI.COVERPICTUREWIDTH).FULL
    };
};
module.exports["useTitleContentPropertiesForPublishedPage_content"] = $20e32f1deb8c1fe0$export$e114ec4e88c7fe33;
module.exports["PreloadHomepageIdQuery"] = $20e32f1deb8c1fe0$export$c9b63bbfd869a91;
module.exports["getTitleContentProperty"] = $20e32f1deb8c1fe0$export$cef8b8531fa62d5f;
module.exports["useTitleContentPropertiesForPublishedPage"] = $20e32f1deb8c1fe0$export$9e9d248809e028e8;

});

parcelRegister("4lSsc", function(module, exports) {
/**
 * @generated SignedSource<<27d66eab829e89ba017f17104702246d>>
 * @relayHash 9a31bcd84d31650a9d9bf2ee5045af08
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb
const $f70a6e2cb787614b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "9a31bcd84d31650a9d9bf2ee5045af08",
            "id": "d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb",
            "metadata": {},
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery($spaceKey:String!){space(key:$spaceKey){id,homepage{id}}}"
        }
    };
}();
$f70a6e2cb787614b$var$node.hash = "57678666b7eece7bec595c782b54d686";
var $f70a6e2cb787614b$export$2e2bcd8739ae039 = $f70a6e2cb787614b$var$node;
module.exports["default"] = $f70a6e2cb787614b$export$2e2bcd8739ae039;

});

parcelRegister("eB536", function(module, exports) {
/**
 * @generated SignedSource<<f3aa298d710112bdac45cdae3936c970>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3cc0a8cff50ad3c7$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v0 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useTitleContentPropertiesForPublishedPage_content",
        "selections": [
            v0 /*: any*/ ,
            {
                "alias": "pageTitlePublished",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "page-title-property-published"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v1 /*: any*/ ,
                "storageKey": "properties(key:\"page-title-property-published\")"
            },
            {
                "alias": "pageTitleDraft",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "page-title-property-draft"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v1 /*: any*/ ,
                "storageKey": "properties(key:\"page-title-property-draft\")"
            },
            {
                "concreteType": "ContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                        "kind": "LinkedField",
                        "name": "frontend",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "coverPictureWidth"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Content"
    };
}();
$3cc0a8cff50ad3c7$var$node.hash = "6913c519b951b36b57b6c77657b055fd";
var $3cc0a8cff50ad3c7$export$2e2bcd8739ae039 = $3cc0a8cff50ad3c7$var$node;
module.exports["default"] = $3cc0a8cff50ad3c7$export$2e2bcd8739ae039;

});

parcelRegister("jVylI", function(module, exports) {
var $341ba7bb7f83b82d$export$18feebdc268a3ef1 = /*#__PURE__*/ function(TitleAlignmentType) {
    TitleAlignmentType["LEFT"] = "LEFT";
    TitleAlignmentType["CENTER"] = "CENTER";
    return TitleAlignmentType;
}({});
const $341ba7bb7f83b82d$export$f5c76f9de4274e9b = {
    titleLayoutAlignment: "LEFT",
    titlePropertySubtitle: '',
    titlePropertySubtitleEnabled: false,
    titlePropertyBylineEnabled: false,
    titlePropertyEmojiEnabled: true,
    headerImageStylingEnabled: false
};
var $341ba7bb7f83b82d$export$f84f565b1b747c24 = /*#__PURE__*/ function(COVERPICTUREWIDTH) {
    COVERPICTUREWIDTH["FULL"] = "full";
    COVERPICTUREWIDTH["FIXED"] = "fixed";
    return COVERPICTUREWIDTH;
}({});
module.exports["TitleAlignmentType"] = $341ba7bb7f83b82d$export$18feebdc268a3ef1;
module.exports["defaultPropertyValue"] = $341ba7bb7f83b82d$export$f5c76f9de4274e9b;
module.exports["COVERPICTUREWIDTH"] = $341ba7bb7f83b82d$export$f84f565b1b747c24;

});

parcelRegister("gzIc1", function(module, exports) {

var $jVylI = parcelRequire("jVylI");

const $bda1e030ddde07df$export$e2d610ec02a291e1 = (jsonProperty)=>{
    let value;
    try {
        value = JSON.parse(jsonProperty.value);
        // objects returned from the content property can be double stringified
        const quoteMatches = value.match(/"/g);
        const quoteCount = quoteMatches ? quoteMatches.length : 0;
        // if quoteCount != null this means that the object is double wrapped as a string and needs to be parsed again
        if (quoteCount) try {
            value = JSON.parse(value);
        } catch (error) {
            value = (0, $jVylI.defaultPropertyValue);
            throw new Error(`unable to parse value: ${error.message}`);
        }
    } catch (error) {
        value = (0, $jVylI.defaultPropertyValue);
        throw error;
    }
    return value;
};
module.exports["contentPropertyHelper"] = $bda1e030ddde07df$export$e2d610ec02a291e1;

});

parcelRegister("gKMkU", function(module, exports) {

var $7Ba23 = parcelRequire("7Ba23");


var $aiN0O = parcelRequire("aiN0O");


var $dYU3e = parcelRequire("dYU3e");


var $hu6Tz = parcelRequire("hu6Tz");

const $7309ff12be989147$export$a95d48b280e02650 = ({ contentId: contentId, cloudId: cloudId, activationId: activationId, contentType: contentType })=>{
    return (0, $dYU3e.queryAgg)({
        query: $7309ff12be989147$export$133357fbca043a2d,
        variables: (0, $hu6Tz.getAutohighlightsQueryVariables)({
            contentId: contentId,
            cloudId: cloudId,
            activationId: activationId,
            contentType: contentType
        }),
        __callerPackage__: "contextual-reading-aids"
    });
};
const $7309ff12be989147$export$f4a8d1adced1d4b2 = (0, $aiN0O.default);
const $7309ff12be989147$export$133357fbca043a2d = (0, $7Ba23.default);
module.exports["preloadAutohighlights"] = $7309ff12be989147$export$a95d48b280e02650;
module.exports["preloadAutohighlightsQueryFragment"] = $7309ff12be989147$export$f4a8d1adced1d4b2;

});

parcelRegister("7Ba23", function(module, exports) {
/**
 * @generated SignedSource<<b8ed35fa23788eaea0d1eb92471e7f05>>
 * @relayHash 2820a095ae7566b0d9e48bbf4b073a4b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c97859d83625338169d38498096c0e05b0ed89a36118e4c759690c6b37f1e1b3
const $13f118fd299fdf03$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "inputText"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraAssigneeAccountId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraReporterAccountId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "workspaceId"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "entityAri",
            "variableName": "entityAri"
        },
        {
            "kind": "Variable",
            "name": "inputText",
            "variableName": "inputText"
        },
        {
            "kind": "Variable",
            "name": "jiraAssigneeAccountId",
            "variableName": "jiraAssigneeAccountId"
        },
        {
            "kind": "Variable",
            "name": "jiraReporterAccountId",
            "variableName": "jiraReporterAccountId"
        },
        {
            "kind": "Variable",
            "name": "workspaceId",
            "variableName": "workspaceId"
        }
    ], v6 = {
        "concreteType": "KnowledgeDiscoveryQueryApi",
        "kind": "LinkedField",
        "name": "knowledgeDiscovery",
        "plural": false,
        "selections": [
            {
                "args": v5 /*: any*/ ,
                "kind": "LinkedField",
                "name": "keyPhrases",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "KnowledgeDiscoveryKeyPhrase",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "keyPhrase"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "category"
                                    }
                                ]
                            }
                        ],
                        "type": "KnowledgeDiscoveryKeyPhraseConnection"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "message"
                            }
                        ],
                        "type": "QueryError"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "preloadAutohighlightsQuery",
            "selections": [
                v6 /*: any*/ ,
                {
                    "fragment": {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "args": v5 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "preloadAutohighlightsQuery_query"
                            }
                        ],
                        "type": "Query"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "autohighlightsQueryFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "preloadAutohighlightsQuery",
            "selections": [
                v6 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "2820a095ae7566b0d9e48bbf4b073a4b",
            "id": "c97859d83625338169d38498096c0e05b0ed89a36118e4c759690c6b37f1e1b3",
            "metadata": {},
            "name": "preloadAutohighlightsQuery",
            "operationKind": "query",
            "text": "query preloadAutohighlightsQuery($entityAri:String!,$workspaceId:String!,$jiraReporterAccountId:String,$jiraAssigneeAccountId:String,$inputText:KnowledgeDiscoveryKeyPhraseInputText){knowledgeDiscovery{keyPhrases(entityAri:$entityAri,workspaceId:$workspaceId,jiraReporterAccountId:$jiraReporterAccountId,jiraAssigneeAccountId:$jiraAssigneeAccountId,inputText:$inputText)@optIn(to:\"KnowledgeDiscovery Get Key Phrases\"){__typename,...on KnowledgeDiscoveryKeyPhraseConnection{nodes{keyPhrase,category}},...on QueryError{message}}},...preloadAutohighlightsQuery_query_3JqkOF}fragment preloadAutohighlightsQuery_query_3JqkOF on Query{knowledgeDiscovery{keyPhrases(entityAri:$entityAri,workspaceId:$workspaceId,jiraReporterAccountId:$jiraReporterAccountId,jiraAssigneeAccountId:$jiraAssigneeAccountId,inputText:$inputText)@optIn(to:\"KnowledgeDiscovery Get Key Phrases\"){__typename,...on KnowledgeDiscoveryKeyPhraseConnection{nodes{keyPhrase,category}},...on QueryError{message}}}}"
        }
    };
}();
$13f118fd299fdf03$var$node.hash = "dbfa17d85f2c22cbfd96f030d30cc29a";
var $13f118fd299fdf03$export$2e2bcd8739ae039 = $13f118fd299fdf03$var$node;
module.exports["default"] = $13f118fd299fdf03$export$2e2bcd8739ae039;

});

parcelRegister("aiN0O", function(module, exports) {
/**
 * @generated SignedSource<<83edf1fa840e1e2cbb5c5a5eac139f64>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $82a3921aaa089fdb$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "entityAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "inputText"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jiraAssigneeAccountId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jiraReporterAccountId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "workspaceId"
        }
    ],
    "kind": "Fragment",
    "name": "preloadAutohighlightsQuery_query",
    "selections": [
        {
            "concreteType": "KnowledgeDiscoveryQueryApi",
            "kind": "LinkedField",
            "name": "knowledgeDiscovery",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "entityAri",
                            "variableName": "entityAri"
                        },
                        {
                            "kind": "Variable",
                            "name": "inputText",
                            "variableName": "inputText"
                        },
                        {
                            "kind": "Variable",
                            "name": "jiraAssigneeAccountId",
                            "variableName": "jiraAssigneeAccountId"
                        },
                        {
                            "kind": "Variable",
                            "name": "jiraReporterAccountId",
                            "variableName": "jiraReporterAccountId"
                        },
                        {
                            "kind": "Variable",
                            "name": "workspaceId",
                            "variableName": "workspaceId"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "keyPhrases",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "KnowledgeDiscoveryKeyPhrase",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "keyPhrase"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "category"
                                        }
                                    ]
                                }
                            ],
                            "type": "KnowledgeDiscoveryKeyPhraseConnection"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$82a3921aaa089fdb$var$node.hash = "e217dd52ca3b019fe148e9b8034b7cd9";
var $82a3921aaa089fdb$export$2e2bcd8739ae039 = $82a3921aaa089fdb$var$node;
module.exports["default"] = $82a3921aaa089fdb$export$2e2bcd8739ae039;

});

parcelRegister("hu6Tz", function(module, exports) {

var $gw4Eo = parcelRequire("gw4Eo");

const $ceeb6fd84b3cae53$export$7625152cc0552e6b = ({ contentId: contentId, cloudId: cloudId, activationId: activationId, contentType: contentType })=>({
        entityAri: (0, $gw4Eo.getConfluenceContentAri)({
            siteId: cloudId,
            resourceType: contentType,
            resourceId: contentId,
            activationId: ''
        }),
        workspaceId: (0, $gw4Eo.getConfluenceContentAri)({
            siteId: cloudId,
            resourceType: 'workspace',
            resourceId: activationId,
            activationId: ''
        })
    });
module.exports["getAutohighlightsQueryVariables"] = $ceeb6fd84b3cae53$export$7625152cc0552e6b;

});

parcelRegister("gw4Eo", function(module, exports) {

var $1ggpj = parcelRequire("1ggpj");

const $17a724fe65d90332$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ((0, $1ggpj.TYPES_WITH_ACTIVATIONID).includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $17a724fe65d90332$export$6a2f2c83863e9bfe;

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["SLIDE"] = "slide";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$e8b4d9d0d681efa4 = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name,
    (0, $1NBp8.EDIT_PAGE).name,
    (0, $1NBp8.EDIT_PAGE_V2).name
];
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "slide",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE,
    ["slide"]: (0, $lx6jn.FeedbackSource).SLIDE
};
const $2aa2bdb281c6889a$export$4aba9c2e2995f563 = [
    "whiteboard",
    "slide"
];
const $2aa2bdb281c6889a$export$ea7ca1acbbc07168 = (contentType)=>!!contentType && $2aa2bdb281c6889a$export$4aba9c2e2995f563.includes(contentType);
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'slide',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["DELETE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$e8b4d9d0d681efa4;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["isCanvasContentType"] = $2aa2bdb281c6889a$export$ea7ca1acbbc07168;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    FeedbackSource["SLIDE"] = "Slide";
    FeedbackSource["TABS"] = "Tabs";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("llqlc", function(module, exports) {

var $jTt8P = parcelRequire("jTt8P");

function $64e7b9256d090f27$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $jTt8P.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}
module.exports["filter"] = $64e7b9256d090f27$export$3dea766d36a8935f;

});

parcelRegister("hSTGC", function(module, exports) {

var $llqlc = parcelRequire("llqlc");

const $c6a27cbe775384e0$var$EXTENSION_NODE_TYPES = new Set([
    'extension',
    'bodiedExtension',
    'inlineExtension'
]);
const $c6a27cbe775384e0$var$extensionNodesByDocument = new WeakMap();
const $c6a27cbe775384e0$export$e7dab524997312ea = (documentAdf)=>{
    const cachedExtensionNodes = $c6a27cbe775384e0$var$extensionNodesByDocument.get(documentAdf);
    if (cachedExtensionNodes) return cachedExtensionNodes;
    const extensionNodes = (0, $llqlc.filter)(documentAdf, (node)=>$c6a27cbe775384e0$var$EXTENSION_NODE_TYPES.has(node.type));
    $c6a27cbe775384e0$var$extensionNodesByDocument.set(documentAdf, extensionNodes);
    return extensionNodes;
};
module.exports["collectExtensionNodes"] = $c6a27cbe775384e0$export$e7dab524997312ea;

});

parcelRegister("c9US3", function(module, exports) {
const $a0c6a01a3ab611bc$var$ATLAS_DOC_FORMAT = 'atlas_doc_format';
const $a0c6a01a3ab611bc$var$parsedAdfByContentNodes = new WeakMap();
const $a0c6a01a3ab611bc$export$d5dfc2a541246169 = (contentNodes)=>{
    if (!contentNodes || !contentNodes[0]) return null;
    if ($a0c6a01a3ab611bc$var$parsedAdfByContentNodes.has(contentNodes)) return $a0c6a01a3ab611bc$var$parsedAdfByContentNodes.get(contentNodes) ?? null;
    const dynamicBody = contentNodes[0].body?.dynamic;
    let parsedAdf = null;
    if (dynamicBody?.value && dynamicBody.representation === $a0c6a01a3ab611bc$var$ATLAS_DOC_FORMAT) try {
        parsedAdf = JSON.parse(dynamicBody.value);
    } catch  {
        parsedAdf = null;
    }
    $a0c6a01a3ab611bc$var$parsedAdfByContentNodes.set(contentNodes, parsedAdf);
    return parsedAdf;
};
module.exports["parseContentNodesAdf"] = $a0c6a01a3ab611bc$export$d5dfc2a541246169;

});

parcelRegister("8pcS0", function(module, exports) {
const $6863c3b6124eda1d$export$2400baf28368a887 = {
    TEMPLATE: 'com.atlassian.confluence.template',
    MACRO_CORE: 'com.atlassian.confluence.macro.core',
    MIGRATION: 'com.atlassian.confluence.migration',
    // used for all macros that use Extension API and require references to be rendered
    MACRO_WITH_REFERENCES: 'com.atlassian.confluence.macro.with.references',
    NATIVE: 'com.atlassian.confluence.native'
};
const $6863c3b6124eda1d$export$8e1715e14eb19dce = {
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__'
};
const $6863c3b6124eda1d$export$a4903313a3329d59 = {
    UNSUPPORTED_EXTENSION: 'unsupportedExtension',
    INVALID_ADF: 'invalidAdf'
};
const $6863c3b6124eda1d$export$84b772adeaf6b683 = 'extension';
const $6863c3b6124eda1d$export$5da07912b4c30471 = 'inlineExtension';
const $6863c3b6124eda1d$export$2af94dcd5e74e23b = 'bodiedExtension';
const $6863c3b6124eda1d$export$43b3eb119fc177ea = 'multiBodiedExtension';
const $6863c3b6124eda1d$export$6e997645168087e1 = [
    {
        content: [],
        type: 'paragraph'
    }
];
const $6863c3b6124eda1d$export$87be616c9ded92ee = [
    {
        type: 'extensionFrame',
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    }
];
const $6863c3b6124eda1d$export$f9804d409e73a2cd = {
    TEMPLATE: 'variable',
    INLINE_EXTERNAL_IMAGE: 'inline-external-image',
    INLINE_MEDIA_IMAGE: 'inline-media-image',
    PRIVACY_MARK: 'privacy-mark',
    ANCHOR: 'anchor',
    PANEL: 'panel',
    SECTION: 'section',
    CHEESE: 'cheese',
    COLUMN: 'column',
    CONTENT_BY_LABEL: 'contentbylabel',
    CONTENT_BY_USER: 'content-by-user',
    CREATE_SPACE_BUTTON: 'create-space-button',
    FAVORITE_PAGES: 'favpages',
    GLOBAL_REPORTS: 'global-reports',
    IM_PRESENCE: 'im',
    LOREMIPSUM: 'loremipsum',
    NAVIGATION_MAP: 'navmap',
    PAGE_TREE: 'pagetree',
    RECENTLY_UPDATED: 'recently-updated',
    RECENTLY_USED_LABELS: 'recently-used-labels',
    SEARCH: 'search',
    SPACE_DETAILS: 'space-details',
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__',
    REDACTED_MACRO_PLACEHOLDER: 'redactedMacroPlaceholder',
    TOC: 'toc',
    LIVE_SEARCH: 'livesearch',
    CREATE_FROM_TEMPLATE: 'create-from-template',
    CONFLUENCE_DATABASES: 'database-extension',
    DETAILS: 'details',
    DETAILS_SUMMARY: 'detailssummary',
    EXPAND: 'expand',
    EXCERPT: 'excerpt',
    EXCERPT_INCLUDE: 'excerpt-include',
    CHILDREN: 'children',
    PROFILE_PICTURE: 'profile-picture',
    PROFILE: 'profile',
    BLOG_POSTS: 'blog-posts',
    INCLUDE: 'include',
    JIRA: 'jira',
    JIRACHART: 'jirachart',
    LEGACY_CONTENT: 'legacy-content',
    TEAM_CALENDARS: 'calendar',
    CONTRIBUTORS: 'contributors',
    IFRAME: 'iframe',
    LIST_LABELS: 'listlabels',
    POPULAR_LABELS: 'popular-labels',
    TASKS_REPORT_MACRO: 'tasks-report-macro',
    NATIVE_EMBED: 'native-embed',
    HIDE: 'hide',
    PAGE_TREE_SEARCH: 'pagetreesearch',
    WIDGET: 'widget',
    CONTENT_REPORT_TABLE: 'content-report-table',
    CHANGE_HISTORY: 'change-history',
    VIEWPDF: 'viewpdf',
    ATTACHMENTS: 'attachments',
    AGENT_MANAGED_BLOCK: 'agent-managed-block',
    VIEWXLS: 'viewxls'
};
const $6863c3b6124eda1d$export$52ab8a936196819e = [
    'toc',
    'expand',
    'trello-board',
    'status',
    'jiraroadmap'
];
const $6863c3b6124eda1d$export$ab3b6d629a99a505 = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TOC,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.ANCHOR,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.LIVE_SEARCH,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS_SUMMARY,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXPAND,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT_INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CREATE_FROM_TEMPLATE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.REDACTED_MACRO_PLACEHOLDER,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONFLUENCE_DATABASES,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PROFILE_PICTURE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PROFILE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.ATTACHMENTS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.BLOG_POSTS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.RECENTLY_UPDATED,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TEAM_CALENDARS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTRIBUTORS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.IFRAME,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.POPULAR_LABELS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.LIST_LABELS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_BY_LABEL,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE_SEARCH,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.WIDGET,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_REPORT_TABLE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHANGE_HISTORY,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.VIEWPDF,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TASKS_REPORT_MACRO,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.VIEWXLS
];
const $6863c3b6124eda1d$export$77fa9372f916e938 = new Set([
    $6863c3b6124eda1d$export$84b772adeaf6b683,
    $6863c3b6124eda1d$export$5da07912b4c30471,
    $6863c3b6124eda1d$export$2af94dcd5e74e23b
]);
const $6863c3b6124eda1d$export$12c3fa6b8a339bbd = 255;
const $6863c3b6124eda1d$export$3b4caad8695d985a = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHILDREN,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT_INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_BY_LABEL,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.RECENTLY_UPDATED
];
const $6863c3b6124eda1d$export$b700e56f703b191 = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHILDREN,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS_SUMMARY
];
module.exports["EXTENSION_TYPE"] = $6863c3b6124eda1d$export$2400baf28368a887;
module.exports["MIGRATION_EXTENSION_KEYS"] = $6863c3b6124eda1d$export$8e1715e14eb19dce;
module.exports["REGULAR_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$84b772adeaf6b683;
module.exports["INLINE_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$5da07912b4c30471;
module.exports["BODIED_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$2af94dcd5e74e23b;
module.exports["MULTI_BODIED_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$43b3eb119fc177ea;
module.exports["EMPTY_ADF_CONTENT"] = $6863c3b6124eda1d$export$6e997645168087e1;
module.exports["MULTI_BODIED_INITIAL_CONTENT"] = $6863c3b6124eda1d$export$87be616c9ded92ee;
module.exports["EXTENSION_KEY"] = $6863c3b6124eda1d$export$f9804d409e73a2cd;
module.exports["allowedMacrosForInsertMenu"] = $6863c3b6124eda1d$export$52ab8a936196819e;
module.exports["serverRenderedExtensions"] = $6863c3b6124eda1d$export$ab3b6d629a99a505;
module.exports["supportedExtensions"] = $6863c3b6124eda1d$export$77fa9372f916e938;
module.exports["MAX_ATLASSIAN_ALLOWED_FRAGMENT_LENGTH"] = $6863c3b6124eda1d$export$12c3fa6b8a339bbd;
module.exports["MODERENIZED_MACRO_KEYS"] = $6863c3b6124eda1d$export$3b4caad8695d985a;
module.exports["MACROS_WITH_LIVE_DOC_REFERENCE"] = $6863c3b6124eda1d$export$b700e56f703b191;

});

parcelRegister("6mEZ3", function(module, exports) {

var $aMlgD = parcelRequire("aMlgD");


var $8pcS0 = parcelRequire("8pcS0");


var $juS6m = parcelRequire("juS6m");

function $b31b733ebe52245a$export$d80a64b0df71385c(params) {
    if (params.hasOwnProperty('')) return $b31b733ebe52245a$var$getParamValue(params['']) || '';
    return '';
}
function $b31b733ebe52245a$export$1d258479ae5735d7(macroParams = {}) {
    return Object.keys(macroParams).reduce((curr, key)=>{
        const value = $b31b733ebe52245a$var$getParamValue(macroParams[key]);
        if (value !== '') curr[key] = value;
        return curr;
    }, {});
}
function $b31b733ebe52245a$export$80a8efbe6e0eac1d(macroParams = {}) {
    return Object.keys(macroParams).reduce((curr, key)=>{
        const value = $b31b733ebe52245a$var$getParamValue(macroParams[key]);
        if (key !== '' || value !== '') curr[key] = {
            value: value
        };
        return curr;
    }, {});
}
// does every key have a value key inside?
function $b31b733ebe52245a$var$getParamValue(macroParam) {
    if (macroParam?.hasOwnProperty('value')) return macroParam.value;
    return macroParam;
}
function $b31b733ebe52245a$export$a113856a79fa82ca(node) {
    const { type: type, content: content, attrs: attrs, fragmentLocalId: fragmentLocalId, ...rest } = node;
    // There is a discrepancy in docs and implementation of different parts of the code
    // https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence-frontend/pull-requests/30727/overview?commentId=4917242
    const fieldWithMacroParameters = attrs?.parameters ? attrs : rest;
    const { macroParams: macroParams } = fieldWithMacroParameters?.parameters || {};
    const adf = {
        attrs: fieldWithMacroParameters,
        type: type
    };
    if (fragmentLocalId) adf.marks = [
        {
            attrs: {
                localId: fragmentLocalId,
                name: null
            },
            type: 'fragment'
        }
    ];
    // confluence needs to be updated to get rid of bodyType as per
    // https://product-fabric.atlassian.net/wiki/spaces/E/pages/252351342/Splitting+Extension+node+into+three+nodes
    // but for now, the beackend requires it to be sent
    adf.attrs.bodyType = 'none';
    if (type === 'bodiedExtension') {
        adf.content = content && content.length > 0 ? content : [];
        adf.attrs.bodyType = 'rich';
    }
    const keys = Object.keys(adf.attrs);
    keys.forEach((key)=>{
        if (adf.attrs[key] === undefined || adf.attrs[key] === null) delete adf.attrs[key];
    });
    if (adf.attrs?.parameters) adf.attrs.parameters.macroParams = $b31b733ebe52245a$export$80a8efbe6e0eac1d(macroParams);
    return adf;
}
function $b31b733ebe52245a$export$f700a29bb3cb52bb(node) {
    const { attrs: attrs, content: content, type: type } = node;
    const { macroParams: macroParams } = attrs.parameters;
    // MacroAttributes and ADNode are pretty much the same type, but
    // MacroAttributes requires either "extension", "bodiedExtension", "multiBodiedExtension" or
    // "inlineExtension". This check is so we can pass the ADNode as a
    // MacroAttributes, but will default to "extension" if given an unexpected
    // value.
    let extensionType = (0, $8pcS0.REGULAR_EXTENSION_TYPE);
    if ([
        (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE),
        (0, $8pcS0.BODIED_EXTENSION_TYPE),
        (0, $8pcS0.INLINE_EXTENSION_TYPE)
    ].indexOf(type) >= 0) extensionType = type;
    const macroAttributes = {
        type: extensionType,
        attrs: attrs
    };
    if (!macroAttributes.attrs.parameters) macroAttributes.attrs.parameters = {};
    if (content) macroAttributes.content = content;
    macroAttributes.attrs.parameters.macroParams = $b31b733ebe52245a$export$80a8efbe6e0eac1d(macroParams);
    return macroAttributes;
}
async function $b31b733ebe52245a$export$9ebfba63bbffe824(from, to, body, contentIdContext) {
    const queryData = await (0, $juS6m.experimentalContentBodyConvertQuery)(from, to, body, contentIdContext);
    return queryData.experimentalContentBodyConvert?.value;
}
async function $b31b733ebe52245a$export$4f223f6f161fb687(node, intl) {
    const legacyMacro = await $b31b733ebe52245a$export$dc6dc202968f1e29(node);
    legacyMacro.title = node.attrs?.parameters?.macroMetadata?.title;
    if (intl) {
        const description = (0, $aMlgD.getMacroDescriptionOverride)(node.attrs.extensionKey, intl);
        if (description) legacyMacro.description = description;
    }
    return legacyMacro;
}
async function $b31b733ebe52245a$export$dc6dc202968f1e29(node) {
    // just return the node if it's already in legacy format;
    if (node.hasOwnProperty('name') && !node.hasOwnProperty('attrs')) return Promise.resolve(node);
    const adNode = node;
    const { attrs: attrs } = adNode;
    const { extensionKey: extensionKey, parameters: parameters } = attrs || {
        extensionKey: null,
        parameters: {
            macroParams: {},
            macroMetadata: {
                schemaVersion: null
            }
        }
    };
    const { macroParams: macroParams, macroMetadata: macroMetadata } = parameters;
    const type = node.type;
    const name = extensionKey || '';
    const params = $b31b733ebe52245a$export$1d258479ae5735d7(macroParams || {});
    const defaultParameterValue = $b31b733ebe52245a$export$d80a64b0df71385c(macroParams || {});
    const schemaVersion = macroMetadata && macroMetadata.schemaVersion || '1';
    if (!adNode.content || adNode.content.length === 0) return {
        type: type,
        name: name,
        params: params,
        defaultParameterValue: defaultParameterValue,
        schemaVersion: schemaVersion,
        body: ''
    };
    const responseBody = await $b31b733ebe52245a$export$9ebfba63bbffe824('atlas_doc_format', 'storage', JSON.stringify({
        type: 'doc',
        content: adNode.content,
        version: 1
    }));
    return {
        type: type,
        name: name,
        params: params,
        defaultParameterValue: defaultParameterValue,
        schemaVersion: schemaVersion,
        body: responseBody || ''
    };
}
function $b31b733ebe52245a$export$9ca244251d53bbfc(node) {
    const parameters = {
        ...node?.parameters?.macroParams
    };
    if (parameters.__bodyContent) delete parameters.__bodyContent;
    // CEMS-300: To provide a consistent parameter to macro vendors for
    // both the Tiny and Fabric editors, we unwrap the parameter values
    return JSON.stringify($b31b733ebe52245a$export$1d258479ae5735d7(parameters));
}
module.exports["getDefaultParamValue"] = $b31b733ebe52245a$export$d80a64b0df71385c;
module.exports["unwrapMacroParams"] = $b31b733ebe52245a$export$1d258479ae5735d7;
module.exports["wrapMacroParams"] = $b31b733ebe52245a$export$80a8efbe6e0eac1d;
module.exports["extensionToADF"] = $b31b733ebe52245a$export$a113856a79fa82ca;
module.exports["formatAsMacroAttributes"] = $b31b733ebe52245a$export$f700a29bb3cb52bb;
module.exports["convertBody"] = $b31b733ebe52245a$export$9ebfba63bbffe824;
module.exports["formatAsLegacyMacroWithOverrides"] = $b31b733ebe52245a$export$4f223f6f161fb687;
module.exports["getParametersString"] = $b31b733ebe52245a$export$9ca244251d53bbfc;

});

parcelRegister("aMlgD", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $9wGTI = parcelRequire("9wGTI");


var $8pcS0 = parcelRequire("8pcS0");

const $123431e233f03ed6$var$i18n = (0, $kSwu1.defineMessages)({
    anchorMacroTitle: {
        id: "fabric-extension-lib.anchor.title",
        defaultMessage: "Anchor link"
    },
    anchorMacroDescription: {
        id: "fabric-extension-lib.anchor.description",
        defaultMessage: "Create a link to anywhere"
    },
    childrenMacroTitle: {
        id: "fabric-extension-lib.children.live-docs.title",
        defaultMessage: "Child items (Child pages)"
    },
    childrenMacroDescription: {
        id: "fabric-extension-lib.children.live-docs.description",
        defaultMessage: "Display a custom list of content nested under a page or live doc."
    },
    detailsMacroTitle: {
        id: "fabric-extension-lib.details.live-docs.title",
        defaultMessage: "Content properties (Page properties)"
    },
    detailsMacroDescription: {
        id: "fabric-extension-lib.details.live-docs.description",
        defaultMessage: "Enter a table of summary information in this macro and display it on another page or live doc using a content properties report macro. You will need to add a label to this content and specify it in the report macro."
    },
    pageTreeMacroTitle: {
        id: "fabric-extension-lib.pagetree.live-docs.title",
        defaultMessage: "Content tree (Page tree)"
    },
    pageTreeMacroDescription: {
        id: "fabric-extension-lib.pagetree.live-docs.description",
        defaultMessage: "Display a full or partial content tree."
    },
    includeMacroTitle: {
        id: "fabric-extension-lib.include.live-docs.title",
        defaultMessage: "Include content (Include page)"
    },
    includeMacroDescription: {
        id: "fabric-extension-lib.include.live-docs.description",
        defaultMessage: "Display the full contents of a page or live doc."
    },
    detailsSummaryMacroTitle: {
        id: "fabric-extension-lib.details-summary.live-docs.title",
        defaultMessage: "Content properties report (Page properties report)"
    },
    detailsSummaryMacroDescription: {
        id: "fabric-extension-lib.details-summary.live-docs.description",
        defaultMessage: "Display a table of pages and live docs that contain a content properties macro and a specific label. The table includes a link to each item and the summary from the macro on that page or doc."
    },
    jiraMacroTitle: {
        id: "fabric-extension-lib.jira.title",
        defaultMessage: "Jira Data Center"
    },
    jiraMacroDescription: {
        id: "fabric-extension-lib.jira.description",
        defaultMessage: "Insert Jira work items from Data Center via JQL"
    }
});
const $123431e233f03ed6$export$f37635a5fac054ef = (extensionKey, intl)=>{
    // Override new macro title for anchor macro
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).ANCHOR) return intl.formatMessage($123431e233f03ed6$var$i18n.anchorMacroTitle);
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).JIRA && (0, $9wGTI.fg)('jim-renaming-to-jira-dc-macro')) return intl.formatMessage($123431e233f03ed6$var$i18n.jiraMacroTitle);
    if ((0, $8pcS0.MACROS_WITH_LIVE_DOC_REFERENCE).includes(extensionKey)) switch(extensionKey){
        case (0, $8pcS0.EXTENSION_KEY).CHILDREN:
            return intl.formatMessage($123431e233f03ed6$var$i18n.childrenMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).PAGE_TREE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.pageTreeMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).INCLUDE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.includeMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS_SUMMARY:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsSummaryMacroTitle);
    }
    return null;
};
const $123431e233f03ed6$export$d82ae1b0fd434097 = (extensionKey, intl)=>{
    // Override new macro title and description for anchor macro
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).ANCHOR) return intl.formatMessage($123431e233f03ed6$var$i18n.anchorMacroDescription);
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).JIRA && (0, $9wGTI.fg)('jim-renaming-to-jira-dc-macro')) return intl.formatMessage($123431e233f03ed6$var$i18n.jiraMacroDescription);
    // PGXT-7617 Update macro strings referencing page content types to also include live docs content types
    if ((0, $8pcS0.MACROS_WITH_LIVE_DOC_REFERENCE).includes(extensionKey)) switch(extensionKey){
        case (0, $8pcS0.EXTENSION_KEY).CHILDREN:
            return intl.formatMessage($123431e233f03ed6$var$i18n.childrenMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).PAGE_TREE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.pageTreeMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).INCLUDE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.includeMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS_SUMMARY:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsSummaryMacroDescription);
    }
    return null;
};
module.exports["getMacroTitleOverride"] = $123431e233f03ed6$export$f37635a5fac054ef;
module.exports["getMacroDescriptionOverride"] = $123431e233f03ed6$export$d82ae1b0fd434097;

});

parcelRegister("juS6m", function(module, exports) {

var $iS5Ay = parcelRequire("iS5Ay");


var $aBfpe = parcelRequire("aBfpe");

const $3a3d352db800a7ae$export$4cf4dd4c5ab7075b = async (from, to, body, contentIdContext)=>{
    const variables = {
        from: from,
        to: to,
        body: body,
        contentIdContext: contentIdContext
    };
    const requestBody = {
        representation: from,
        value: body
    };
    const params = new URLSearchParams();
    if (contentIdContext) params.append('contentIdContext', contentIdContext);
    const queryString = params.toString();
    const queryParams = queryString ? `?${queryString}` : '';
    const url = `/wiki/rest/api/contentbody/convert/${to}${queryParams}`;
    const result = await (0, $iS5Ay.experimentalQuery)({
        url: url,
        method: 'POST',
        body: JSON.stringify(requestBody),
        credentials: 'include',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResponseOnSuccess: async (response)=>{
            if (response.ok && response.status === 200) return response.json();
            throw response;
        },
        parseResponseOnError: (error)=>{
            throw new Error(`Conversion HTTP error, status = ${error.status}, message = "${error.statusText}"`);
        },
        parseResult: (response)=>({
                experimentalContentBodyConvert: {
                    value: response.value
                }
            }),
        variables: variables
    });
    return result.data;
};
module.exports["experimentalContentBodyConvertQuery"] = $3a3d352db800a7ae$export$4cf4dd4c5ab7075b;

});

parcelRegister("iS5Ay", function(module, exports) {

var $c6StJ = parcelRequire("c6StJ");


var $6fil2 = parcelRequire("6fil2");


var $1RY07 = parcelRequire("1RY07");


var $GLgaM = parcelRequire("GLgaM");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");


var $bjeS8 = parcelRequire("bjeS8");

async function $7002390fd45cd24e$export$ca7e5505c9b1be25({ url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, fetchPolicy: fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'none', skip: skip = false, onError: onError, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, ignoreNoNetworkError: ignoreNoNetworkError, transformError: transformError }) {
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    const fetchData = async ()=>{
        try {
            const json = await (0, $GLgaM.fetchResponse)({
                url: url,
                method: method,
                body: body,
                headers: headers,
                credentials: credentials,
                parseResponseOnSuccess: parseResponseOnSuccess,
                parseResponseOnError: parseResponseOnError
            }, variables);
            return await parseResult(json, variables);
        } catch (error) {
            if (ignoreNoNetworkError && (0, $6fil2.containsNetworkError)(error)) return undefined;
            throw error;
        }
    };
    const storeInstance = (0, $c6StJ.defaultRegistry).getStore((0, $7ji4X.queryStateStore));
    const getCachedData = ()=>{
        const queryState = storeInstance.storeState.getState();
        return queryState[key]?.data;
    };
    const setCachedData = (data)=>{
        storeInstance.actions.setQueryState(key, {
            data: data,
            loading: false,
            error: undefined,
            called: true
        });
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $1RY07.apolloCompatibleQuery)({
        fetchData: fetchData,
        fetchPolicy: fetchPolicy,
        errorPolicy: errorPolicy,
        skip: skip,
        getCachedData: getCachedData,
        setCachedData: setCachedData,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalQuery"] = $7002390fd45cd24e$export$ca7e5505c9b1be25;

});

parcelRegister("1RY07", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");

async function $32cd044d306ca797$export$642c5b07a008cc22({ fetchData: fetchData, fetchPolicy: fetchPolicy, errorPolicy: errorPolicy = 'none', skip: skip = false, onCompleted: onCompleted, onError: onError, getCachedData: getCachedData, setCachedData: setCachedData, convertToApolloError: convertToApolloError }) {
    if (skip) return {
        data: undefined,
        error: undefined
    };
    // cache-first / store-or-network: return cached data if it exists or fetch from network
    if ((fetchPolicy === 'cache-first' || fetchPolicy === 'store-or-network') && getCachedData) {
        const cachedData = getCachedData();
        if (cachedData !== undefined) {
            onCompleted?.(cachedData);
            return {
                data: cachedData,
                error: undefined
            };
        }
    }
    // cache-and-network: return cached data immediately, fetch in background
    if (fetchPolicy === 'cache-and-network' && getCachedData) {
        const cachedData = getCachedData();
        if (cachedData !== undefined) {
            fetchData().catch(()=>{});
            onCompleted?.(cachedData);
            return {
                data: cachedData,
                error: undefined
            };
        }
    }
    // network-only or cache miss: fetch from network
    try {
        const data = await fetchData();
        if (fetchPolicy !== 'no-cache' && setCachedData) await setCachedData(data);
        onCompleted?.(data);
        return {
            data: data,
            error: undefined
        };
    } catch (error) {
        const apolloError = await Promise.resolve(convertToApolloError(error));
        if (apolloError.graphQLErrors?.length) apolloError.graphQLErrors.forEach((e)=>{
            (0, $7Sm4c.processError)(e);
        });
        onError?.(apolloError);
        if (errorPolicy === 'all') return {
            data: undefined,
            error: apolloError
        };
        // errorPolicy === 'none': throw the error
        throw apolloError;
    }
}
module.exports["apolloCompatibleQuery"] = $32cd044d306ca797$export$642c5b07a008cc22;

});

parcelRegister("GLgaM", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $6kV7w = parcelRequire("6kV7w");


var $3FAG5 = parcelRequire("3FAG5");

async function $2229ddfbe95e9ad1$export$4b00e7449e7c9147(fetchOptions, variables) {
    const { url: url, method: method, body: body, headers: headers, credentials: credentials, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError } = fetchOptions;
    try {
        const resolvedMethod = typeof method === 'function' ? method(variables) : method;
        const defaultBody = resolvedMethod === 'GET' ? undefined : JSON.stringify(variables);
        // Tesseract instruments the outgoing http requests automatically, no need to pass tracing headers when running in SSR.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const tracingHeaders = (0, $6kV7w.getActiveTraceHttpRequestHeaders)('' /* url, not used */ );
        const enhancedHeaders = {
            ...headers,
            ...tracingHeaders
        };
        const response = await (0, $f7B1p.cfetch)(typeof url === 'function' ? url(variables) : url, {
            method: resolvedMethod,
            body: typeof body === 'function' ? body(variables) : body || defaultBody,
            headers: enhancedHeaders,
            credentials: credentials
        });
        if (parseResponseOnSuccess) return parseResponseOnSuccess(response);
        return await $2229ddfbe95e9ad1$var$parseResponse(response);
    } catch (error) {
        if (parseResponseOnError) return parseResponseOnError(error, variables);
        throw error;
    }
}
async function $2229ddfbe95e9ad1$var$parseResponse(response) {
    if (response.status === 204) return {};
    // In case a service happens to return a 200 instead of 204 with no content
    if (response.headers?.get('content-length') === '0') return {};
    try {
        return await response.json();
    } catch (error) {
        throw (0, $3FAG5.throwErrorWithResponse)(error, response);
    }
}
module.exports["fetchResponse"] = $2229ddfbe95e9ad1$export$4b00e7449e7c9147;

});

parcelRegister("3FAG5", function(module, exports) {
// copied from next/packages/graphql/src/resolvers/throwErrorWithResponse.ts b/c of circ dep
function $6c7ad22961ce35d0$export$8a24908f7aac7ac7(error, response) {
    // Don't swallow the Response object, attach it to the error so the rest of
    // the app has a chance to see it e.g. OnErrorLink:
    if (typeof error === 'object' && error) {
        // At times our various resolver implementations interpret the JSON body of
        // non-OK responses as errors. And sometimes these errors contain a response
        // property (which may be an empty object) that leads to the loss of
        // Response information such as trace ID.
        if ('response' in error) {
            const existingErrorResponse = error.response;
            // Try to attach at least the trace ID to the existing error response:
            if (typeof existingErrorResponse === 'object' && existingErrorResponse) {
                // OnError's getResponseFromError needs the status property:
                if (!('status' in existingErrorResponse)) existingErrorResponse.status = response.status;
                // getTraceIdFromResponse needs the headers property:
                if (!('headers' in existingErrorResponse)) existingErrorResponse.headers = response.headers;
            }
        } else error.response = response;
    }
    throw error;
}
module.exports["throwErrorWithResponse"] = $6c7ad22961ce35d0$export$8a24908f7aac7ac7;

});

parcelRegister("7ji4X", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $67e5a1fc9f6e62d4$export$c6060eb21313da7c = {
    data: undefined,
    loading: false,
    error: undefined,
    called: false
};
const $67e5a1fc9f6e62d4$export$baa1629d06692c30 = {
    data: undefined,
    loading: true,
    error: undefined,
    called: true
};
const $67e5a1fc9f6e62d4$var$Store = (0, $8s9DV.createStore)({
    initialState: {},
    actions: {
        setQueryState: (key, state)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                const prevState = currentState[key] || $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
                const newState = typeof state === 'function' ? state(prevState) : state;
                setState({
                    ...currentState,
                    [key]: newState
                });
            }
    },
    name: 'useExperimentalQueryState'
});
const $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a = (0, $kBr4q.createActionsHook)($67e5a1fc9f6e62d4$var$Store);
const $67e5a1fc9f6e62d4$export$39156bd8f00c1e38 = (0, $kBr4q.createStateHook)($67e5a1fc9f6e62d4$var$Store, {
    selector: (state, params)=>state[params.key]
});
const $67e5a1fc9f6e62d4$export$14d57088f5885a49 = $67e5a1fc9f6e62d4$var$Store;
module.exports["INITIAL_IDLE_STATE"] = $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
module.exports["INITIAL_LOADING_STATE"] = $67e5a1fc9f6e62d4$export$baa1629d06692c30;
module.exports["useExperimentalQueryStateActions"] = $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a;
module.exports["useExperimentalQueryState"] = $67e5a1fc9f6e62d4$export$39156bd8f00c1e38;
module.exports["queryStateStore"] = $67e5a1fc9f6e62d4$export$14d57088f5885a49;

});

parcelRegister("6l6jb", function(module, exports) {
function $459f9fedb053e25e$export$a4f9b7f788f9e71f(params) {
    const { url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables } = params;
    return $459f9fedb053e25e$var$canonicalStringify({
        url: typeof url === 'function' ? url.toString() : url,
        method: typeof method === 'function' ? method.toString() : method,
        headers: headers,
        body: typeof body === 'function' ? body.toString() : body,
        credentials: credentials,
        variables: variables
    });
}
function $459f9fedb053e25e$export$ebaa599ca92b9c11(requestConfigs, variables) {
    const keys = requestConfigs.map((config)=>$459f9fedb053e25e$export$a4f9b7f788f9e71f({
            ...config,
            variables: variables
        })).sort();
    return $459f9fedb053e25e$var$canonicalStringify(keys);
}
// Serializes with sorted object keys for deterministic output
function $459f9fedb053e25e$var$canonicalStringify(value) {
    return JSON.stringify(value, $459f9fedb053e25e$var$canonicalStringifyReplacer);
}
function $459f9fedb053e25e$var$canonicalStringifyReplacer(_key, value) {
    // Ensures we only process plain objects (not arrays, dates, etc.)
    if (value && typeof value === 'object') {
        const proto = Object.getPrototypeOf(value);
        if (proto === Object.prototype || proto === null) {
            const keys = Object.keys(value);
            // If keys are already sorted, return the original value unchanged to avoid unnecessary object creation
            if (keys.every($459f9fedb053e25e$var$everyKeyInOrder)) return value;
            keys.sort();
            const sortedObject = Object.create(proto);
            keys.forEach((key)=>{
                sortedObject[key] = value[key];
            });
            return sortedObject;
        }
    }
    return value;
}
function $459f9fedb053e25e$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}
module.exports["generateCacheKey"] = $459f9fedb053e25e$export$a4f9b7f788f9e71f;
module.exports["generateCacheKeyForMultipleFetches"] = $459f9fedb053e25e$export$ebaa599ca92b9c11;

});

parcelRegister("bjeS8", function(module, exports) {

var $krgsn = parcelRequire("krgsn");


var $422HI = parcelRequire("422HI");

const $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a = (error)=>{
    const message = error.message || 'Unknown error';
    const status = 'response' in error ? error.response?.status : undefined;
    return new (0, $422HI.ApolloErrorInterop)({
        graphQLErrors: [
            $79bfccd7ee2a0d89$var$createGraphQLError({
                message: message,
                status: status,
                originalError: error
            })
        ]
    });
};
const $79bfccd7ee2a0d89$var$createGraphQLError = ({ message: message, status: status, originalError: originalError })=>{
    const extensions = status ? {
        statusCode: status,
        http: {
            status: status
        }
    } : undefined;
    return new (0, $krgsn.GraphQLError)(message, null, // nodes - no GraphQL query AST
    null, // source - no GraphQL query text
    null, // positions - no GraphQL query positions
    null, // path - not executing GraphQL schema fields
    originalError, extensions);
};
module.exports["convertToApolloError"] = $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a;

});

parcelRegister("aBfpe", function(module, exports) {
/**
 * https://www.iana.org/assignments/media-types/media-types.xhtml
 */ var $c27c52d002752847$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $c27c52d002752847$export$483c11740a902fcd;

});

parcelRegister("7K6Nt", function(module, exports) {

var $llqlc = parcelRequire("llqlc");


var $hSTGC = parcelRequire("hSTGC");


var $c9US3 = parcelRequire("c9US3");


var $iZ7G7 = parcelRequire("iZ7G7");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $ceVeI = parcelRequire("ceVeI");


var $1xpoY = parcelRequire("1xpoY");


var $10F8F = parcelRequire("10F8F");


var $3vv78 = parcelRequire("3vv78");


var $c4twg = parcelRequire("c4twg");


var $959F7 = parcelRequire("959F7");


var $lLjor = parcelRequire("lLjor");


var $6nf8t = parcelRequire("6nf8t");


var $gVB2D = parcelRequire("gVB2D");


var $eM1QC = parcelRequire("eM1QC");


var $9hg2I = parcelRequire("9hg2I");


var $gaqfB = parcelRequire("gaqfB");


var $2jr6j = parcelRequire("2jr6j");


var $j9Zer = parcelRequire("j9Zer");


var $eOfv4 = parcelRequire("eOfv4");


var $hwhSw = parcelRequire("hwhSw");


var $aEHCA = parcelRequire("aEHCA");


var $jl68F = parcelRequire("jl68F");


var $ivpnt = parcelRequire("ivpnt");

const $527158a32e078a3d$var$EXTENSION_TYPES = new Set([
    'extension',
    'bodiedExtension',
    'inlineExtension'
]);
/**
 * Returns a map of extensionKey → handler for all active macro preload
 * handlers based on current experiment gates and the current route.
 *
 * A handler is considered active when:
 *  - its underlying migration experiment is enabled
 *    (`isMigratedMacroImplEnabled`), AND
 *  - its `routes` configuration includes the current `route`.
 */ const $527158a32e078a3d$var$getActiveHandlers = (route)=>{
    const handlers = new Map();
    const register = (handler)=>{
        if (!handler.routes.includes(route)) return;
        if (!(0, $ceVeI.isMigratedMacroImplEnabled)(handler.extensionKey)) return;
        handlers.set(handler.extensionKey, handler);
    };
    register((0, $3vv78.blogPostsPreloadHandler));
    register((0, $c4twg.changeHistoryPreloadHandler));
    register((0, $959F7.contentByLabelPreloadHandler));
    register((0, $lLjor.contributorsPreloadHandler));
    register((0, $6nf8t.detailsSummaryPreloadHandler));
    register((0, $eM1QC.pageIncludePreloadHandler));
    register((0, $9hg2I.recentlyUpdatedPreloadHandler));
    register((0, $gVB2D.listLabelsPreloadHandler));
    register((0, $j9Zer.popularLabelsPreloadHandler));
    register((0, $gaqfB.pagetreePreloadHandler));
    register((0, $2jr6j.pagetreeSearchPreloadHandler));
    register((0, $eOfv4.profilePicturePreloadHandler));
    register((0, $hwhSw.userProfilePreloadHandler));
    register((0, $aEHCA.viewPdfPreloadHandler));
    register((0, $ivpnt.tasksReportPreloadHandler));
    register((0, $jl68F.viewXlsPreloadHandler));
    return handlers;
};
/**
 * Resolves content nodes (which may be a promise), validates the body structure,
 * and parses the ADF JSON into a document object.
 *
 * Returns null if the content nodes are invalid, the representation is not
 * 'atlas_doc_format', or the ADF JSON cannot be parsed.
 */ const $527158a32e078a3d$var$resolveAndParseADF = async (contentNodes)=>{
    const resolvedNodes = contentNodes && typeof contentNodes.then === 'function' ? await contentNodes : contentNodes;
    if (!resolvedNodes?.[0]?.body?.dynamic?.value) return null;
    if (resolvedNodes[0].body.dynamic.representation !== 'atlas_doc_format') return null;
    try {
        return JSON.parse(resolvedNodes[0].body.dynamic.value);
    } catch  {
        return null;
    }
};
const $527158a32e078a3d$var$resolveContentNodes = async (contentNodes)=>contentNodes && typeof contentNodes.then === 'function' ? await contentNodes : contentNodes;
/**
 * Resolves a `preloadCollabDraftContent` promise, extracts the document
 * field, and decodes it to an ADF object via {@link decodeCollabDraftDocument}.
 *
 * Returns `null` when the promise rejects, when the result has no
 * `data.collabDraft.document`, or when the document cannot be decoded.
 */ const $527158a32e078a3d$var$resolveCollabDraftToADF = async (collabDraftPromise)=>{
    let result;
    try {
        result = await collabDraftPromise;
    } catch  {
        return null;
    }
    return (0, $iZ7G7.decodeCollabDraftDocument)(result?.data?.collabDraft?.document);
};
/**
 * Parses the comma-separated blocklist string from Statsig into a list of
 * trimmed, non-empty regex pattern strings.
 */ const $527158a32e078a3d$var$getBlocklist = ()=>{
    const raw = (0, $1xpoY.default).getString('confluence-extensions-server-render-blocklist', '');
    const entries = raw.split(',');
    const result = [];
    for(let i = 0; i < entries.length; i++){
        const trimmed = entries[i].trim();
        if (trimmed) result.push(trimmed);
    }
    return result;
};
/**
 * Returns true when `extensionKey` is present in the blocklist.
 *
 * The blocklist is sourced from a single Statsig dynamic config
 * (`confluence-extensions-server-render-blocklist`) so it controls both SSR
 * macro query preloading and supplementary macro data preloading.
 */ const $527158a32e078a3d$var$isBlocklisted = (blocklist, extensionKey)=>{
    if (blocklist.length === 0) return false;
    return blocklist.includes(extensionKey);
};
/**
 * Default cap on the number of extensions preloaded per content node when
 * the `cc_ssr_max_extensions_to_preload` Statsig dynamic config is not set.
 */ const $527158a32e078a3d$var$DEFAULT_MAX_EXTENSIONS_TO_PRELOAD = 8;
/**
 * Default cap on the number of ADF nodes traversed when scanning the
 * document for preloadable extensions, used when the
 * `cc_ssr_macros_max_nodes_to_iterative_over` Statsig dynamic config is
 * not set.
 */ const $527158a32e078a3d$var$DEFAULT_MAX_NODES_TO_ITERATE_OVER = -1;
/**
 * Returns the maximum number of extensions to preload, sourced from the
 * `cc_ssr_max_extensions_to_preload` Statsig dynamic config.
 *
 * A non-positive or non-finite value is treated as "no limit" and is
 * returned as the sentinel `-1` so callers can opt out by configuring `0`
 * (or any negative value).
 */ const $527158a32e078a3d$var$getMaxExtensionsToPreload = ()=>{
    const value = (0, $1xpoY.default).getNumber('cc_ssr_max_extensions_to_preload', $527158a32e078a3d$var$DEFAULT_MAX_EXTENSIONS_TO_PRELOAD);
    if (!Number.isFinite(value) || value < 0) return -1;
    return Math.floor(value);
};
/**
 * Returns the maximum number of ADF nodes to iterate over when searching
 * for preloadable extension nodes, sourced from the
 * `cc_ssr_macros_max_nodes_to_iterative_over` Statsig dynamic config.
 *
 * A non-positive or non-finite value is treated as "no limit" and is
 * returned as the sentinel `-1` so callers can opt out by configuring `0`
 * (or any negative value).
 */ const $527158a32e078a3d$var$getMaxNodesToIterateOver = ()=>{
    const value = (0, $1xpoY.default).getNumber('cc_ssr_macros_max_nodes_to_iterative_over', $527158a32e078a3d$var$DEFAULT_MAX_NODES_TO_ITERATE_OVER);
    if (!Number.isFinite(value) || value < 0) return -1;
    return Math.floor(value);
};
/**
 * Filters extension nodes from the parsed ADF document that have a
 * registered preload handler and are not excluded by the SSR extension
 * blocklist.
 *
 * Two Statsig dynamic configs control the work done here:
 * - `cc_ssr_macros_max_nodes_to_iterative_over` caps the number of ADF
 *   nodes visited during traversal (default -1). A value of `-1` means
 *   no limit.
 * - `cc_ssr_max_extensions_to_preload` caps the number of matched
 *   extensions returned (default 8). A value of `-1` means no limit.
 */ const $527158a32e078a3d$var$createIsPreloadableMacroNode = (handlersByKey, blocklist)=>(node)=>{
        const extensionKey = node.attrs?.extensionKey;
        return $527158a32e078a3d$var$EXTENSION_TYPES.has(node.type) && typeof extensionKey === 'string' && handlersByKey.has(extensionKey) && !$527158a32e078a3d$var$isBlocklisted(blocklist, extensionKey);
    };
const $527158a32e078a3d$var$capPreloadableMacroNodes = (matched)=>{
    const maxExtensionsToPreload = $527158a32e078a3d$var$getMaxExtensionsToPreload();
    if (maxExtensionsToPreload === -1 || matched.length <= maxExtensionsToPreload) return matched;
    return matched.slice(0, maxExtensionsToPreload);
};
const $527158a32e078a3d$var$getPreloadableMacroNodes = (documentADF, handlersByKey)=>{
    const isPreloadableMacroNode = $527158a32e078a3d$var$createIsPreloadableMacroNode(handlersByKey, $527158a32e078a3d$var$getBlocklist());
    const maxNodesToIterateOver = $527158a32e078a3d$var$getMaxNodesToIterateOver();
    // Track how many ADF nodes the traversal has visited so we can short-
    // circuit once `cc_ssr_macros_max_nodes_to_iterative_over` is reached.
    // `filter` from @atlaskit/adf-utils/traverse walks the full document tree
    // (the document object itself is not an array), unlike `Array#filter`.
    let visited = 0;
    const matched = (0, $llqlc.filter)(documentADF, (node)=>{
        if (maxNodesToIterateOver !== -1 && visited >= maxNodesToIterateOver) return false;
        visited++;
        return isPreloadableMacroNode(node);
    });
    return $527158a32e078a3d$var$capPreloadableMacroNodes(matched);
};
const $527158a32e078a3d$var$getPreloadableMacroNodesFromSharedTraversal = (documentADF, handlersByKey)=>{
    const isPreloadableMacroNode = $527158a32e078a3d$var$createIsPreloadableMacroNode(handlersByKey, $527158a32e078a3d$var$getBlocklist());
    const matched = (0, $hSTGC.collectExtensionNodes)(documentADF).filter(isPreloadableMacroNode);
    return $527158a32e078a3d$var$capPreloadableMacroNodes(matched);
};
/**
 * Shared execution core: walks the already-resolved ADF document through the
 * active handler pipeline for the given route.
 */ const $527158a32e078a3d$var$runPreloadHandlers = async (matchedNodes, handlersByKey, context)=>{
    if (matchedNodes.length === 0) return;
    // eslint-disable-next-line check-preloaders/no-promise-all
    await Promise.all(matchedNodes.map((node)=>{
        const handler = handlersByKey.get(node.attrs.extensionKey);
        return handler.preload(node, context);
    }));
};
const $527158a32e078a3d$export$dbda8fb8d4a3a2ff = async ({ contentNodes: contentNodes, context: context, route: route })=>{
    const handlersByKey = $527158a32e078a3d$var$getActiveHandlers(route);
    if (handlersByKey.size === 0) return;
    let documentADF;
    let useSharedTraversal = false;
    if ((0, $6mKj3.expValEquals)('cc-proj-xl-dedup-macro-preload-adf-parsing', 'isEnabled', true)) {
        documentADF = (0, $c9US3.parseContentNodesAdf)(await $527158a32e078a3d$var$resolveContentNodes(contentNodes));
        useSharedTraversal = true;
    } else documentADF = await $527158a32e078a3d$var$resolveAndParseADF(contentNodes);
    if (!documentADF) return;
    // Nested LCM SSR needs macros inside `nestedContent` preloaded too, so it uses a traversal that
    // descends through LCM hierarchies when the nested gate is enabled.
    const useFullLcmHierarchyTraversal = route === 'view' && (0, $9wGTI.fg)('confluence_lcm_ssr_nested');
    let matchedNodes;
    if (useFullLcmHierarchyTraversal) matchedNodes = (0, $10F8F.getPreloadableMacroNodesWithFullLcmHierarchy)({
        documentADF: documentADF,
        isPreloadableMacroNode: $527158a32e078a3d$var$createIsPreloadableMacroNode(handlersByKey, $527158a32e078a3d$var$getBlocklist()),
        maxExtensionsToPreload: $527158a32e078a3d$var$getMaxExtensionsToPreload(),
        maxNodesToIterateOver: $527158a32e078a3d$var$getMaxNodesToIterateOver()
    });
    else if (useSharedTraversal) matchedNodes = $527158a32e078a3d$var$getPreloadableMacroNodesFromSharedTraversal(documentADF, handlersByKey);
    else matchedNodes = $527158a32e078a3d$var$getPreloadableMacroNodes(documentADF, handlersByKey);
    await $527158a32e078a3d$var$runPreloadHandlers(matchedNodes, handlersByKey, context);
};
const $527158a32e078a3d$export$50f56fb621d37e3a = async ({ collabDraftPromise: collabDraftPromise, context: context, route: route })=>{
    const handlersByKey = $527158a32e078a3d$var$getActiveHandlers(route);
    if (handlersByKey.size === 0) return;
    if ((0, $6mKj3.expValEquals)('cc-proj-xl-dedup-macro-preload-adf-parsing', 'isEnabled', true)) {
        let result;
        try {
            result = await collabDraftPromise;
        } catch  {
            return;
        }
        const documentADF = (0, $iZ7G7.parseCollabDraftAdf)(result);
        if (!documentADF) return;
        await $527158a32e078a3d$var$runPreloadHandlers($527158a32e078a3d$var$getPreloadableMacroNodesFromSharedTraversal(documentADF, handlersByKey), handlersByKey, context);
        return;
    }
    const documentADF = await $527158a32e078a3d$var$resolveCollabDraftToADF(collabDraftPromise);
    if (!documentADF) return;
    await $527158a32e078a3d$var$runPreloadHandlers($527158a32e078a3d$var$getPreloadableMacroNodes(documentADF, handlersByKey), handlersByKey, context);
};
module.exports["preloadMacroData"] = $527158a32e078a3d$export$dbda8fb8d4a3a2ff;
module.exports["preloadMacroDataFromCollabDraft"] = $527158a32e078a3d$export$50f56fb621d37e3a;

});

parcelRegister("iZ7G7", function(module, exports) {
// Maximum number of JSON.parse iterations to apply to a stringified document.
// In practice the wire shape is at most double-encoded, so 3 iterations gives
// us headroom while still bounding the loop.
const $aa12c5a22e7258c3$var$MAX_DOCUMENT_DECODE_PASSES = 3;
const $aa12c5a22e7258c3$export$c237b35d986a7858 = (document)=>{
    if (document == null) return null;
    let candidate = document;
    for(let pass = 0; pass < $aa12c5a22e7258c3$var$MAX_DOCUMENT_DECODE_PASSES; pass++){
        if (typeof candidate !== 'string') break;
        try {
            candidate = JSON.parse(candidate);
        } catch  {
            return null;
        }
    }
    // Still a string after exhausting all decode passes, or resolved to a
    // non-object primitive (number, boolean, null, etc.) — give up.
    if (typeof candidate !== 'object' || candidate === null) return null;
    return candidate;
};
const $aa12c5a22e7258c3$var$parsedAdfByCollabDraftResult = new WeakMap();
const $aa12c5a22e7258c3$export$867137d201e5eab4 = (collabDraftResult)=>{
    if (!collabDraftResult || typeof collabDraftResult !== 'object') return null;
    if ($aa12c5a22e7258c3$var$parsedAdfByCollabDraftResult.has(collabDraftResult)) return $aa12c5a22e7258c3$var$parsedAdfByCollabDraftResult.get(collabDraftResult) ?? null;
    const parsedAdf = $aa12c5a22e7258c3$export$c237b35d986a7858(collabDraftResult.data?.collabDraft?.document);
    $aa12c5a22e7258c3$var$parsedAdfByCollabDraftResult.set(collabDraftResult, parsedAdf);
    return parsedAdf;
};
module.exports["decodeCollabDraftDocument"] = $aa12c5a22e7258c3$export$c237b35d986a7858;
module.exports["parseCollabDraftAdf"] = $aa12c5a22e7258c3$export$867137d201e5eab4;

});

parcelRegister("ceVeI", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");

const $c9f3102bc65ac225$export$2512ab5eef87236d = [
    'attachments',
    'blog-posts',
    'change-history',
    'contributors',
    'detailssummary',
    'iframe',
    'include',
    'pagetree',
    'pagetreesearch',
    'profile',
    'profile-picture',
    'recently-updated',
    'viewpdf',
    'viewxls',
    'widget',
    'contentbylabel',
    'listlabels',
    'popular-labels',
    'tasks-report-macro'
];
const $c9f3102bc65ac225$var$getExperimentValue = (extensionKey)=>{
    switch(extensionKey){
        case 'blog-posts':
            return (0, $6mKj3.expValEquals)('cc_rewrite_blog_posts_legacy_macro', 'isEnabled', true);
        case 'contributors':
            return (0, $6mKj3.expValEquals)('cc_rewrite_contributors_legacy_macro', 'isEnabled', true);
        case 'detailssummary':
        case 'profile':
        case 'profile-picture':
            return (0, $6mKj3.expValEquals)('cc_macro_full_ssr_support', 'isEnabled', true);
        case 'contentbylabel':
        case 'iframe':
            return true;
        case 'listlabels':
            return (0, $6mKj3.expValEquals)('cc_rewrite_listlabels_legacy_macro', 'isEnabled', true);
        case 'pagetree':
            return (0, $6mKj3.expValEquals)('cc_rewrite_pagetree_legacy_macro', 'isEnabled', true);
        case 'pagetreesearch':
            return true;
        case 'popular-labels':
            return (0, $6mKj3.expValEquals)('cc_rewrite_popular_labels_legacy_macro', 'isEnabled', true);
        case 'recently-updated':
            return (0, $6mKj3.expValEquals)('cc_rewrite_recently_updated_legacy_macro', 'isEnabled', true);
        case 'viewpdf':
            return (0, $6mKj3.expValEquals)('cc_rewrite_viewpdf_macro', 'isEnabled', true);
        case 'viewxls':
            return (0, $6mKj3.expValEquals)('cc_rewrite_viewxls_legacy_macro', 'isEnabled', true);
        case 'widget':
            return (0, $6mKj3.expValEquals)('cc_rewrite_widget_legacy_macro', 'isEnabled', true);
        case 'attachments':
            return (0, $6mKj3.expValEquals)('cc_rewrite_attachments_legacy_macro', 'isEnabled', true);
        case 'include':
            return (0, $6mKj3.expValEquals)('cc_rewrite_page_include_legacy_macro', 'isEnabled', true);
        case 'tasks-report-macro':
            return (0, $6mKj3.expValEquals)('cc_rewrite_tasks_report_macro', 'isEnabled', true);
        case 'change-history':
            return (0, $6mKj3.expValEquals)('cc_rewrite_change_history_legacy_macro', 'isEnabled', true);
        default:
            return false;
    }
};
const $c9f3102bc65ac225$var$isMigratedMacroExtensionKey = (key)=>$c9f3102bc65ac225$export$2512ab5eef87236d.includes(key);
const $c9f3102bc65ac225$export$95a5e4cb1c9fae51 = (extensionKey)=>{
    const overrideList = (0, $1xpoY.default).getStringList('cc_macro_override_to_legacy_renderer', []);
    if (overrideList.includes(extensionKey)) return false;
    if (!$c9f3102bc65ac225$var$isMigratedMacroExtensionKey(extensionKey)) return false;
    return $c9f3102bc65ac225$var$getExperimentValue(extensionKey);
};
module.exports["MIGRATED_MACRO_EXTENSION_KEYS"] = $c9f3102bc65ac225$export$2512ab5eef87236d;
module.exports["isMigratedMacroImplEnabled"] = $c9f3102bc65ac225$export$95a5e4cb1c9fae51;

});

parcelRegister("10F8F", function(module, exports) {
const $e7c730c677403acc$var$ADF_EXTENSION_NODE_TYPES = new Set([
    'extension',
    'bodiedExtension',
    'inlineExtension',
    'multiBodiedExtension'
]);
const $e7c730c677403acc$var$LCM_EXTENSION_TYPE = 'com.atlassian.confluence.migration';
const $e7c730c677403acc$var$LCM_EXTENSION_KEY = 'legacy-content';
const $e7c730c677403acc$var$isObject = (value)=>typeof value === 'object' && value !== null;
const $e7c730c677403acc$var$isAdfExtensionNode = (node)=>$e7c730c677403acc$var$ADF_EXTENSION_NODE_TYPES.has(node.type);
const $e7c730c677403acc$var$isExactLcmNode = (node)=>$e7c730c677403acc$var$isAdfExtensionNode(node) && node.attrs?.extensionType === $e7c730c677403acc$var$LCM_EXTENSION_TYPE && node.attrs?.extensionKey === $e7c730c677403acc$var$LCM_EXTENSION_KEY;
const $e7c730c677403acc$var$getValidNestedContentDocument = (node)=>{
    if (!$e7c730c677403acc$var$isAdfExtensionNode(node)) return null;
    const nestedContent = node.attrs?.parameters?.nestedContent;
    return $e7c730c677403acc$var$isObject(nestedContent) && nestedContent.type === 'doc' && Array.isArray(nestedContent.content) ? nestedContent : null;
};
const $e7c730c677403acc$var$pushChildrenInDocumentOrder = (stack, content)=>{
    for(let index = content.length - 1; index >= 0; index--)stack.push(content[index]);
};
const $e7c730c677403acc$export$56f4def195a75ddf = ({ documentADF: documentADF, isPreloadableMacroNode: isPreloadableMacroNode, maxExtensionsToPreload: maxExtensionsToPreload, maxNodesToIterateOver: maxNodesToIterateOver })=>{
    const matched = [];
    // Depth-first stack for the document currently being walked.
    const stack = [
        documentADF
    ];
    // `nestedContent` roots discovered so far, walked only once the current document is exhausted.
    // A cursor rather than `shift()` keeps appending a newly discovered hierarchy O(1).
    const deferredHierarchies = [];
    let nextDeferredIndex = 0;
    let visited = 0;
    const hasBudgetRemaining = ()=>(maxNodesToIterateOver === -1 || visited < maxNodesToIterateOver) && (maxExtensionsToPreload === -1 || matched.length < maxExtensionsToPreload);
    while(hasBudgetRemaining()){
        if (stack.length === 0) {
            if (nextDeferredIndex >= deferredHierarchies.length) break;
            stack.push(deferredHierarchies[nextDeferredIndex++]);
        }
        const candidate = stack.pop();
        if (!$e7c730c677403acc$var$isObject(candidate)) continue;
        visited++;
        const node = candidate;
        if (isPreloadableMacroNode(node)) matched.push(node);
        if (Array.isArray(node.content)) $e7c730c677403acc$var$pushChildrenInDocumentOrder(stack, node.content);
        // Only LCM nodes carry content the renderer will recurse into, and `isExactLcmNode` reads the
        // ADF `attrs` form, so nested LCMs are recognised on their own at every depth. Following
        // `nestedContent` on any other extension would spend budget on content that is never rendered.
        const nestedContent = $e7c730c677403acc$var$isExactLcmNode(node) ? $e7c730c677403acc$var$getValidNestedContentDocument(node) : null;
        if (nestedContent) deferredHierarchies.push(nestedContent);
    }
    return matched;
};
module.exports["getPreloadableMacroNodesWithFullLcmHierarchy"] = $e7c730c677403acc$export$56f4def195a75ddf;

});

parcelRegister("3vv78", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $f9Oe5 = parcelRequire("f9Oe5");


var $gLc6G = parcelRequire("gLc6G");

const $fcca944fa3da51db$export$fcb441b1b4fb38e5 = {
    extensionKey: 'blog-posts',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, context)=>{
        try {
            const macroParams = node.attrs?.parameters?.macroParams ?? {};
            const variables = (0, $gLc6G.buildQueryVariables)(macroParams, context.spaceKey);
            await (0, $wPrRK.slowQueryGuard)('blogPostsPreload', ()=>(0, $dYU3e.query)({
                    query: (0, $f9Oe5.default),
                    variables: variables,
                    context: {
                        single: true
                    },
                    __callerPackage__: "preload-macros"
                }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
        } catch  {
            return;
        }
    }
};
module.exports["blogPostsPreloadHandler"] = $fcca944fa3da51db$export$fcb441b1b4fb38e5;

});

parcelRegister("f9Oe5", function(module, exports) {
/**
 * @generated SignedSource<<e2eef557d077fd416e405ad8813adcf0>>
 * @relayHash fef787c2e6d812e72220d382c04bd44c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 58d7df1bc883468554242bf1644d752239212384434b7e48ef0155e9af178cba
const $496608589e77ac6e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeAdfMediaToken"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeEntireBody"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeExcerpt"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "cql",
            "variableName": "cql"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "count"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "kind": "ScalarField",
        "name": "type"
    }, v11 = {
        "condition": "includeExcerpt",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "length",
                        "value": 500
                    }
                ],
                "kind": "ScalarField",
                "name": "excerpt",
                "storageKey": "excerpt(length:500)"
            },
            {
                "concreteType": "ConfluenceMacroExcerptBody",
                "kind": "LinkedField",
                "name": "macroExcerpt",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "fallbackToBody",
                                "value": false
                            }
                        ],
                        "kind": "ScalarField",
                        "name": "atlasDocFormat",
                        "storageKey": "atlasDocFormat(fallbackToBody:false)"
                    }
                ]
            }
        ]
    }, v12 = {
        "concreteType": "ContentBodyPerRepresentation",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
            {
                "condition": "includeAdfMediaToken",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "ContentBody",
                        "kind": "LinkedField",
                        "name": "atlas_doc_format",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "includeEntireBody",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "value"
                                    }
                                ]
                            },
                            {
                                "concreteType": "EmbeddedMediaToken",
                                "kind": "LinkedField",
                                "name": "mediaToken",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "token"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "name"
    }, v14 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "base"
            }
        ]
    }, v15 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            v13 /*: any*/ 
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v17 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v18 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            },
            v16 /*: any*/ ,
            v17 /*: any*/ 
        ],
        "type": "KnownUser"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            v16 /*: any*/ ,
            v17 /*: any*/ 
        ],
        "type": "UnknownUser"
    }, v20 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v21 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "lastUpdated",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "when"
            }
        ]
    }, v22 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useBlogPostsQueryQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v6 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                },
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v22 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useBlogPostsQueryQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v6 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                },
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v22 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "fef787c2e6d812e72220d382c04bd44c",
            "id": "58d7df1bc883468554242bf1644d752239212384434b7e48ef0155e9af178cba",
            "metadata": {},
            "name": "useBlogPostsQueryQuery",
            "operationKind": "query",
            "text": "query useBlogPostsQueryQuery($after:String,$cql:String!,$first:Int,$includeEntireBody:Boolean!,$includeExcerpt:Boolean!,$includeAdfMediaToken:Boolean!){search:confluence_search(cql:$cql,first:$first,after:$after){count,nodes{content{id,title,type,excerpt(length:500)@include(if:$includeExcerpt)\n        macroExcerpt@include(if:$includeExcerpt){atlasDocFormat(fallbackToBody:false)},body{atlas_doc_format@include(if:$includeAdfMediaToken){value@include(if:$includeEntireBody),mediaToken{token}}},labels{nodes{name,id}},links{webui,base},space{id,key,name},history{createdBy{__typename,...on KnownUser{accountId,displayName,profilePicture{path}},...on UnknownUser{displayName,profilePicture{path}}},createdDate,lastUpdated{when}}}},pageInfo{endCursor,hasNextPage}}}"
        }
    };
}();
$496608589e77ac6e$var$node.hash = "be8af94549bdf95f1c5815a896900346";
var $496608589e77ac6e$export$2e2bcd8739ae039 = $496608589e77ac6e$var$node;
module.exports["default"] = $496608589e77ac6e$export$2e2bcd8739ae039;

});

parcelRegister("gLc6G", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $eZ4zi = parcelRequire("eZ4zi");

const $90f568a5a6c2eff6$var$DAY = 86400000;
const $90f568a5a6c2eff6$var$DEFAULT_MAX = 100;
const $90f568a5a6c2eff6$var$MAX_LIMIT = 200;
const $90f568a5a6c2eff6$export$134cc4e90fdbc9cf = 5;
const $90f568a5a6c2eff6$var$splitMacroValues = (value)=>value.split(',').flatMap((item)=>{
        const trimmed = item.trim();
        return trimmed ? [
            trimmed
        ] : [];
    });
// Splits on commas and whitespace, for closer parity to legacy param parsing
const $90f568a5a6c2eff6$var$splitMacroValuesFixed = (value)=>value.split(/[,\s]+/).flatMap((item)=>{
        const trimmed = item.trim();
        return trimmed ? [
            trimmed
        ] : [];
    });
const $90f568a5a6c2eff6$var$quoteCqlValue = (value)=>`'${value}'`;
const $90f568a5a6c2eff6$var$createSpaceTypeClause = (spaceType, operator = '=')=>`space.type ${operator} ${spaceType}`;
const $90f568a5a6c2eff6$var$createSpaceIncludeClause = (spaces, spaceTypeClauses)=>{
    const clauses = [
        ...spaceTypeClauses
    ];
    if (spaces.length > 0) clauses.push(`space IN (${spaces.map($90f568a5a6c2eff6$var$quoteCqlValue).join(',')})`);
    if (clauses.length === 0) return null;
    return clauses.length === 1 ? clauses[0] : `(${clauses.join(' OR ')})`;
};
const $90f568a5a6c2eff6$var$addSpaceClauses = (clauses, spacesValue, currentSpaceKey)=>{
    const spaceKeys = $90f568a5a6c2eff6$var$splitMacroValues(spacesValue);
    let includeSpaces = [];
    let excludeSpaces = [];
    for (const key of spaceKeys){
        if (key === '@all') {
            includeSpaces = [];
            excludeSpaces = [];
            break;
        } else if (key === '@self' && currentSpaceKey) includeSpaces.push(currentSpaceKey);
        else if (key.startsWith('-')) excludeSpaces.push(key.slice(1));
        else includeSpaces.push(key);
    }
    if (includeSpaces.length > 0) {
        const spaceList = includeSpaces.map($90f568a5a6c2eff6$var$quoteCqlValue).join(',');
        clauses.push(`space IN (${spaceList})`);
    }
    for (const excludeSpace of excludeSpaces)clauses.push(`space != ${$90f568a5a6c2eff6$var$quoteCqlValue(excludeSpace)}`);
};
const $90f568a5a6c2eff6$var$addFixedSpaceClauses = (clauses, spacesValue, currentSpaceKey)=>{
    const spaceKeys = $90f568a5a6c2eff6$var$splitMacroValuesFixed(spacesValue);
    const includeSpaces = [];
    const includeSpaceTypeClauses = [];
    const requiredSpaces = [];
    const requiredSpaceTypeClauses = [];
    const excludeSpaces = [];
    const excludeSpaceTypeClauses = [];
    let includeAllSpaces = false;
    const addSpaceFilter = (rawKey)=>{
        const prefix = rawKey[0] === '+' || rawKey[0] === '-' ? rawKey[0] : '';
        const key = prefix ? rawKey.slice(1) : rawKey;
        const targetSpaces = prefix === '+' ? requiredSpaces : prefix === '-' ? excludeSpaces : includeSpaces;
        const targetSpaceTypeClauses = prefix === '+' ? requiredSpaceTypeClauses : prefix === '-' ? excludeSpaceTypeClauses : includeSpaceTypeClauses;
        const spaceTypeOperator = prefix === '-' ? '!=' : '=';
        if (key === '@all' || key === '*') {
            if (prefix === '-') {
                includeAllSpaces = false;
                targetSpaces.length = 0;
                targetSpaceTypeClauses.length = 0;
            } else includeAllSpaces = true;
        } else if (key === '@self') {
            if (currentSpaceKey) targetSpaces.push(currentSpaceKey);
        } else if (key === '@personal') targetSpaceTypeClauses.push($90f568a5a6c2eff6$var$createSpaceTypeClause('personal', spaceTypeOperator));
        else if (key === '@global') targetSpaceTypeClauses.push($90f568a5a6c2eff6$var$createSpaceTypeClause('global', spaceTypeOperator));
        else if (key === '@favorite' || key === '@favourite') targetSpaceTypeClauses.push($90f568a5a6c2eff6$var$createSpaceTypeClause('favorite', spaceTypeOperator));
        else if (key) targetSpaces.push(key);
    };
    for (const key of spaceKeys)addSpaceFilter(key);
    const includeClause = $90f568a5a6c2eff6$var$createSpaceIncludeClause(requiredSpaces, requiredSpaceTypeClauses) ?? (includeAllSpaces ? null : $90f568a5a6c2eff6$var$createSpaceIncludeClause(includeSpaces, includeSpaceTypeClauses));
    if (includeClause) clauses.push(includeClause);
    if (excludeSpaces.length > 0) clauses.push(`space NOT IN (${excludeSpaces.map($90f568a5a6c2eff6$var$quoteCqlValue).join(',')})`);
    clauses.push(...excludeSpaceTypeClauses);
};
const $90f568a5a6c2eff6$var$addLabelClauses = (clauses, labelsValue, matchLabels)=>{
    const labels = $90f568a5a6c2eff6$var$splitMacroValuesFixed(labelsValue);
    const requireLabels = [];
    const excludeLabels = [];
    const anyLabels = [];
    for (const label of labels){
        if (label.startsWith('+')) requireLabels.push(label.slice(1));
        else if (label.startsWith('-')) excludeLabels.push(label.slice(1));
        else anyLabels.push(label);
    }
    for (const label of requireLabels)clauses.push(`label = ${$90f568a5a6c2eff6$var$quoteCqlValue(label)}`);
    for (const label of excludeLabels)clauses.push(`label != ${$90f568a5a6c2eff6$var$quoteCqlValue(label)}`);
    if (anyLabels.length > 0) {
        if (matchLabels === 'all') for (const label of anyLabels)clauses.push(`label = ${$90f568a5a6c2eff6$var$quoteCqlValue(label)}`);
        else {
            const labelList = anyLabels.map($90f568a5a6c2eff6$var$quoteCqlValue).join(',');
            clauses.push(`label IN (${labelList})`);
        }
    }
};
const $90f568a5a6c2eff6$var$addFixedLabelClauses = (clauses, labelsValue, matchLabels)=>{
    const labels = $90f568a5a6c2eff6$var$splitMacroValues(labelsValue);
    const requireLabels = [];
    const excludeLabels = [];
    const anyLabels = [];
    for (const label of labels){
        if (label.startsWith('+')) requireLabels.push(label.slice(1));
        else if (label.startsWith('-')) excludeLabels.push(label.slice(1));
        else anyLabels.push(label);
    }
    for (const label of requireLabels)clauses.push(`label = ${$90f568a5a6c2eff6$var$quoteCqlValue(label)}`);
    if (excludeLabels.length > 0) clauses.push(`label NOT IN (${excludeLabels.map($90f568a5a6c2eff6$var$quoteCqlValue).join(',')})`);
    if (anyLabels.length > 0) {
        if (matchLabels === 'all') for (const label of anyLabels)clauses.push(`label = ${$90f568a5a6c2eff6$var$quoteCqlValue(label)}`);
        else {
            const labelList = anyLabels.map($90f568a5a6c2eff6$var$quoteCqlValue).join(',');
            clauses.push(`label IN (${labelList})`);
        }
    }
};
/**
 * Parses a relative time string like "7d", "14d", "1w", "2h" etc.
 * and returns milliseconds.
 */ const $90f568a5a6c2eff6$var$parseRelativeTime = (time)=>{
    const match = time.match(/^(\d+)([smhdwMy])$/);
    if (!match) return null;
    const value = parseInt(match[1], 10);
    const unit = match[2];
    const multipliers = {
        s: 1000,
        m: 60000,
        h: 3600000,
        d: 86400000,
        w: 604800000,
        M: 2592000000,
        y: 31536000000
    };
    return value * (multipliers[unit] ?? 0);
};
const $90f568a5a6c2eff6$var$getCurrentTime = ()=>{
    if (window.__SSR_CURRENT_DATE__) return window.__SSR_CURRENT_DATE__;
    return Date.now();
};
const $90f568a5a6c2eff6$export$fe3a78908f9d9349 = (params, currentSpaceKey)=>{
    const clauses = [
        "type = 'blogpost'"
    ];
    // Space filter
    const spacesValue = params.spaces?.value ?? params.space?.value;
    if (spacesValue) {
        if ((0, $9wGTI.fg)('cc_rewrite_blog_posts_legacy_macro_fix_param_bug')) $90f568a5a6c2eff6$var$addFixedSpaceClauses(clauses, spacesValue, currentSpaceKey);
        else $90f568a5a6c2eff6$var$addSpaceClauses(clauses, spacesValue, currentSpaceKey);
    } else if (currentSpaceKey) // Default: current space
    clauses.push(`space = ${$90f568a5a6c2eff6$var$quoteCqlValue(currentSpaceKey)}`);
    // Labels filter
    const labelsValue = params.labels?.value ?? params.label?.value;
    const matchLabels = params['match-labels']?.value ?? 'any';
    if (labelsValue) {
        if ((0, $9wGTI.fg)('cc_rewrite_blog_posts_legacy_macro_fix_param_bug')) $90f568a5a6c2eff6$var$addFixedLabelClauses(clauses, labelsValue, matchLabels);
        else $90f568a5a6c2eff6$var$addLabelClauses(clauses, labelsValue, matchLabels);
    }
    // Time filter
    const timeValue = params.time?.value;
    if (timeValue) {
        const ms = $90f568a5a6c2eff6$var$parseRelativeTime(timeValue);
        if (ms) {
            // Ensures date calculation matches in SPA context, if SSR rendered,
            // such that resulting cql matches
            const currentTime = $90f568a5a6c2eff6$var$getCurrentTime();
            const then = new Date(currentTime - ms);
            clauses.push(`lastModified >= '${then.toISOString().split('T')[0]}'`);
        }
    }
    // Author filter
    const authorValue = params.author?.value;
    if (authorValue) {
        const authors = $90f568a5a6c2eff6$var$splitMacroValues(authorValue);
        if (authors.length === 1) clauses.push(`creator = ${$90f568a5a6c2eff6$var$quoteCqlValue(authors[0])}`);
        else if (authors.length > 1) {
            const authorList = authors.map($90f568a5a6c2eff6$var$quoteCqlValue).join(',');
            clauses.push(`creator IN (${authorList})`);
        }
    }
    // Sort
    const sortValue = params.sort?.value;
    const reverseValue = params.reverse?.value === 'true';
    let orderClause = 'ORDER BY created DESC'; // default
    if (sortValue === 'title') orderClause = `ORDER BY title ${reverseValue ? 'DESC' : 'ASC'}`;
    else if (sortValue === 'creation') orderClause = `ORDER BY created ${reverseValue ? 'DESC' : 'ASC'}`;
    else if (sortValue === 'modified') orderClause = `ORDER BY lastModified ${reverseValue ? 'DESC' : 'ASC'}`;
    return `${clauses.join(' AND ')} ${orderClause}`;
};
const $90f568a5a6c2eff6$export$9a3cee82e7cc08ff = (params, currentSpaceKey)=>{
    const contentMode = params.content?.value ?? 'entire';
    const max = $90f568a5a6c2eff6$export$152d338deb24dc62(params);
    const cql = $90f568a5a6c2eff6$export$fe3a78908f9d9349(params, currentSpaceKey);
    const includeEntireBody = contentMode === 'entire';
    const includeExcerpt = contentMode === 'excerpts';
    const includeAdfMediaToken = includeEntireBody || includeExcerpt;
    const first = includeEntireBody ? Math.min(max, $90f568a5a6c2eff6$export$134cc4e90fdbc9cf) : max;
    return {
        after: undefined,
        cql: cql,
        first: first,
        includeEntireBody: includeEntireBody,
        includeExcerpt: includeExcerpt,
        includeAdfMediaToken: includeAdfMediaToken
    };
};
const $90f568a5a6c2eff6$export$152d338deb24dc62 = (params)=>{
    const maxValue = params.max?.value ?? params.maxResults?.value ?? String($90f568a5a6c2eff6$var$DEFAULT_MAX);
    return Math.min(parseInt(maxValue, 10) || $90f568a5a6c2eff6$var$DEFAULT_MAX, $90f568a5a6c2eff6$var$MAX_LIMIT);
};
const $90f568a5a6c2eff6$export$c01426de3d995a88 = (node)=>node != null;
const $90f568a5a6c2eff6$export$701669137e89de62 = (node)=>{
    const links = node.content?.links;
    if (links?.webui) return `/wiki${links.webui}`;
    return '#';
};
const $90f568a5a6c2eff6$export$3b339b277f9d309a = (node)=>{
    const spaceKey = node.content?.space?.key;
    if (spaceKey) return `/wiki/spaces/${spaceKey}`;
    return '#';
};
const $90f568a5a6c2eff6$export$2c8f257f76f536e9 = (node)=>node.content?.history?.createdBy?.displayName ?? 'Unknown';
const $90f568a5a6c2eff6$export$5879f87d8125a540 = (node)=>{
    const createdBy = node.content?.history?.createdBy;
    if (createdBy && 'accountId' in createdBy) return createdBy.accountId ?? undefined;
    return undefined;
};
const $90f568a5a6c2eff6$export$6d333a56ff392766 = (node)=>{
    const accountId = $90f568a5a6c2eff6$export$5879f87d8125a540(node);
    if (accountId) return `/wiki/people/${accountId}?ref=confluence`;
    return '#';
};
const $90f568a5a6c2eff6$export$b6704bab7c727398 = (node)=>{
    const createdBy = node.content?.history?.createdBy;
    if (createdBy && 'profilePicture' in createdBy) return createdBy.profilePicture?.path ?? undefined;
    return undefined;
};
const $90f568a5a6c2eff6$export$1028703a6dee32c7 = (node)=>node.content?.history?.createdDate ?? '';
const $90f568a5a6c2eff6$export$f81a3ec2bfb3f287 = (node)=>{
    const result = [];
    const nodes = node.content?.labels?.nodes;
    if (!nodes) return result;
    for (const label of nodes)if (label?.name) result.push(label.name);
    return result;
};
const $90f568a5a6c2eff6$export$1187b1706349df3e = (label, spaceKey)=>{
    if (spaceKey) return `/wiki/label/${spaceKey}/${encodeURIComponent(label)}`;
    return `/wiki/label/${encodeURIComponent(label)}`;
};
const $90f568a5a6c2eff6$export$1e76b7005bbc55d6 = (dateString, intl, timeZone)=>{
    const date = new Date(dateString);
    return intl.formatDate(date, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        ...(0, $9wGTI.fg)('cc-dlp-fix-blog-posts-macro-ssr-date-bug') ? {
            timeZone: timeZone
        } : {}
    });
};
const $90f568a5a6c2eff6$export$d1f5a2f86fcde3b5 = (dateString, intl, timeZone)=>{
    const timestamp = new Date(dateString).getTime();
    const diff = Date.now() - timestamp;
    if (diff < $90f568a5a6c2eff6$var$DAY) return (0, $eZ4zi.getRelativeTime)(timestamp, intl);
    return $90f568a5a6c2eff6$export$1e76b7005bbc55d6(dateString, intl, timeZone);
};
module.exports["ENTIRE_MODE_PAGE_SIZE"] = $90f568a5a6c2eff6$export$134cc4e90fdbc9cf;
module.exports["buildQueryVariables"] = $90f568a5a6c2eff6$export$9a3cee82e7cc08ff;
module.exports["getMaxResults"] = $90f568a5a6c2eff6$export$152d338deb24dc62;
module.exports["isBlogPostNode"] = $90f568a5a6c2eff6$export$c01426de3d995a88;
module.exports["getContentUrl"] = $90f568a5a6c2eff6$export$701669137e89de62;
module.exports["getSpaceUrl"] = $90f568a5a6c2eff6$export$3b339b277f9d309a;
module.exports["getAuthorName"] = $90f568a5a6c2eff6$export$2c8f257f76f536e9;
module.exports["getAuthorAccountId"] = $90f568a5a6c2eff6$export$5879f87d8125a540;
module.exports["getAuthorAvatarUrl"] = $90f568a5a6c2eff6$export$b6704bab7c727398;
module.exports["getCreatedDate"] = $90f568a5a6c2eff6$export$1028703a6dee32c7;
module.exports["getLabels"] = $90f568a5a6c2eff6$export$f81a3ec2bfb3f287;
module.exports["getLabelUrl"] = $90f568a5a6c2eff6$export$1187b1706349df3e;
module.exports["formatBlogDate"] = $90f568a5a6c2eff6$export$1e76b7005bbc55d6;
module.exports["formatSmartDate"] = $90f568a5a6c2eff6$export$d1f5a2f86fcde3b5;

});

parcelRegister("eZ4zi", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $dce38ffecfe5cc1b$var$MINUTE = 60000;
const $dce38ffecfe5cc1b$var$HOUR = 3600000;
const $dce38ffecfe5cc1b$var$DAY = 86400000;
const $dce38ffecfe5cc1b$var$WEEK = 604800000;
const $dce38ffecfe5cc1b$var$MONTH = 2592000000;
const $dce38ffecfe5cc1b$var$YEAR = 31536000000;
const $dce38ffecfe5cc1b$export$5a00511f040384d7 = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit'
});
const $dce38ffecfe5cc1b$export$406508d2ca449bd = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
});
const $dce38ffecfe5cc1b$export$d2d0bf9c4d577e53 = (0, $kSwu1.defineMessages)({
    justNow: {
        id: "macro-utils.relative-time-just-now",
        defaultMessage: "just now"
    },
    minutesAgo: {
        id: "macro-utils.relative-time-minutes-ago",
        defaultMessage: "{minuteCount, plural, one {{minuteCount} minute ago} other {{minuteCount} minutes ago}}"
    },
    hoursAgo: {
        id: "macro-utils.relative-time-hours-ago",
        defaultMessage: "{hourCount, plural, one {{hourCount} hour ago} other {{hourCount} hours ago}}"
    },
    daysAgo: {
        id: "macro-utils.relative-time-days-ago",
        defaultMessage: "{dayCount, plural, one {{dayCount} day ago} other {{dayCount} days ago}}"
    },
    weeksAgo: {
        id: "macro-utils.relative-time-weeks-ago",
        defaultMessage: "{weekCount, plural, one {{weekCount} week ago} other {{weekCount} weeks ago}}"
    },
    monthsAgo: {
        id: "macro-utils.relative-time-months-ago",
        defaultMessage: "{monthCount, plural, one {{monthCount} month ago} other {{monthCount} months ago}}"
    },
    yearsAgo: {
        id: "macro-utils.relative-time-years-ago",
        defaultMessage: "{yearCount, plural, one {{yearCount} year ago} other {{yearCount} years ago}}"
    },
    justAMomentAgo: {
        id: "macro-utils.relative-time-just-a-moment-ago",
        defaultMessage: "just a moment ago"
    },
    lessThanAMinuteAgo: {
        id: "macro-utils.relative-time-less-than-a-minute-ago",
        defaultMessage: "less than a minute ago"
    },
    aMinuteAgo: {
        id: "macro-utils.relative-time-a-minute-ago",
        defaultMessage: "a minute ago"
    },
    contentReportMinutesAgo: {
        id: "macro-utils.content-report-minutes-ago",
        defaultMessage: "{minuteCount, plural, one {{minuteCount} minute ago} other {{minuteCount} minutes ago}}"
    },
    aboutAnHourAgo: {
        id: "macro-utils.relative-time-about-an-hour-ago",
        defaultMessage: "about an hour ago"
    },
    contentReportHoursAgo: {
        id: "macro-utils.content-report-hours-ago",
        defaultMessage: "{hourCount, plural, one {about {hourCount} hour ago} other {about {hourCount} hours ago}}"
    },
    yesterdayAt: {
        id: "macro-utils.relative-time-yesterday-at",
        defaultMessage: "yesterday at {time}"
    }
});
const $dce38ffecfe5cc1b$var$formatBucketMessage = (bucket, diffMs, intl)=>{
    if (bucket.valueName && bucket.unitMs) {
        const count = bucket.countCalculator ? bucket.countCalculator(diffMs) : Math.floor(diffMs / bucket.unitMs);
        return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53[bucket.message], {
            [bucket.valueName]: count
        });
    }
    return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53[bucket.message]);
};
const $dce38ffecfe5cc1b$export$bfc1ce7d5853041b = {
    buckets: [
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$MINUTE,
            message: 'justNow'
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$HOUR,
            message: 'minutesAgo',
            valueName: 'minuteCount',
            unitMs: $dce38ffecfe5cc1b$var$MINUTE
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$DAY,
            message: 'hoursAgo',
            valueName: 'hourCount',
            unitMs: $dce38ffecfe5cc1b$var$HOUR
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$WEEK,
            message: 'daysAgo',
            valueName: 'dayCount',
            unitMs: $dce38ffecfe5cc1b$var$DAY
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$MONTH,
            message: 'weeksAgo',
            valueName: 'weekCount',
            unitMs: $dce38ffecfe5cc1b$var$WEEK
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$YEAR,
            message: 'monthsAgo',
            valueName: 'monthCount',
            unitMs: $dce38ffecfe5cc1b$var$MONTH
        },
        {
            maxDiffMs: Number.POSITIVE_INFINITY,
            message: 'yearsAgo',
            valueName: 'yearCount',
            unitMs: $dce38ffecfe5cc1b$var$YEAR
        }
    ]
};
const $dce38ffecfe5cc1b$export$409646d2c0c56892 = {
    buckets: [
        {
            maxDiffMs: 4000,
            message: 'justAMomentAgo'
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$MINUTE,
            message: 'lessThanAMinuteAgo'
        },
        {
            maxDiffMs: 2 * $dce38ffecfe5cc1b$var$MINUTE,
            message: 'aMinuteAgo'
        },
        {
            maxDiffMs: 50 * $dce38ffecfe5cc1b$var$MINUTE,
            message: 'contentReportMinutesAgo',
            valueName: 'minuteCount',
            unitMs: $dce38ffecfe5cc1b$var$MINUTE,
            countCalculator: (diffMs)=>Math.round(diffMs / $dce38ffecfe5cc1b$var$MINUTE)
        },
        {
            maxDiffMs: 90 * $dce38ffecfe5cc1b$var$MINUTE,
            message: 'aboutAnHourAgo'
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$DAY,
            message: 'contentReportHoursAgo',
            valueName: 'hourCount',
            unitMs: $dce38ffecfe5cc1b$var$HOUR,
            countCalculator: (diffMs)=>Math.round(diffMs / $dce38ffecfe5cc1b$var$HOUR)
        }
    ],
    specialCase: ({ timestampMs: timestampMs, nowMs: nowMs, diffMs: diffMs, intl: intl })=>{
        const savedTime = new Date(timestampMs);
        const now = new Date(nowMs);
        if ($dce38ffecfe5cc1b$export$221990270ebfe867(savedTime, now) && diffMs > 5 * $dce38ffecfe5cc1b$var$HOUR) return $dce38ffecfe5cc1b$export$fc16bfc40f160b09(savedTime, intl);
        return null;
    },
    fallback: ({ timestampMs: timestampMs })=>$dce38ffecfe5cc1b$export$359f3c271cd167e3(new Date(timestampMs))
};
const $dce38ffecfe5cc1b$export$e22324fe17cb0dfe = (timestamp, intl, config)=>{
    const nowMs = Date.now();
    const diffMs = nowMs - timestamp;
    if (config.specialCase) {
        const specialResult = config.specialCase({
            timestampMs: timestamp,
            nowMs: nowMs,
            diffMs: diffMs,
            intl: intl
        });
        if (specialResult !== null) return specialResult;
    }
    for (const bucket of config.buckets){
        if (diffMs < bucket.maxDiffMs) return $dce38ffecfe5cc1b$var$formatBucketMessage(bucket, diffMs, intl);
    }
    if (config.fallback) return config.fallback({
        timestampMs: timestamp,
        nowMs: nowMs,
        diffMs: diffMs,
        intl: intl
    });
    return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.justNow);
};
const $dce38ffecfe5cc1b$export$493c11ff22f45a24 = (timestamp, intl)=>{
    const now = Date.now();
    const diff = now - timestamp;
    if (diff < $dce38ffecfe5cc1b$var$MINUTE) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.justNow);
    else if (diff < $dce38ffecfe5cc1b$var$HOUR) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.minutesAgo, {
        minuteCount: Math.floor(diff / $dce38ffecfe5cc1b$var$MINUTE)
    });
    else if (diff < $dce38ffecfe5cc1b$var$DAY) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.hoursAgo, {
        hourCount: Math.floor(diff / $dce38ffecfe5cc1b$var$HOUR)
    });
    else if (diff < $dce38ffecfe5cc1b$var$WEEK) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.daysAgo, {
        dayCount: Math.floor(diff / $dce38ffecfe5cc1b$var$DAY)
    });
    else if (diff < $dce38ffecfe5cc1b$var$MONTH) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.weeksAgo, {
        weekCount: Math.floor(diff / $dce38ffecfe5cc1b$var$WEEK)
    });
    else if (diff < $dce38ffecfe5cc1b$var$YEAR) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.monthsAgo, {
        monthCount: Math.floor(diff / $dce38ffecfe5cc1b$var$MONTH)
    });
    else return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.yearsAgo, {
        yearCount: Math.floor(diff / $dce38ffecfe5cc1b$var$YEAR)
    });
};
const $dce38ffecfe5cc1b$export$221990270ebfe867 = (date, now)=>{
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    return yesterday.toLocaleDateString() === date.toLocaleDateString();
};
const $dce38ffecfe5cc1b$export$fc16bfc40f160b09 = (date, intl)=>{
    return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.yesterdayAt, {
        time: $dce38ffecfe5cc1b$export$5a00511f040384d7.format(date)
    });
};
const $dce38ffecfe5cc1b$export$359f3c271cd167e3 = (date)=>{
    return $dce38ffecfe5cc1b$export$406508d2ca449bd.format(date);
};
const $dce38ffecfe5cc1b$export$505b35374c01d686 = (timestamp, intl)=>{
    return $dce38ffecfe5cc1b$export$e22324fe17cb0dfe(timestamp, intl, $dce38ffecfe5cc1b$export$409646d2c0c56892);
};
module.exports["getRelativeTime"] = $dce38ffecfe5cc1b$export$493c11ff22f45a24;
module.exports["formatContentReportEpochTime"] = $dce38ffecfe5cc1b$export$505b35374c01d686;

});

parcelRegister("c4twg", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $k0BFU = parcelRequire("k0BFU");


var $eqmIR = parcelRequire("eqmIR");

const $3264be4c944b64e2$export$367ea2b94b2f04d6 = {
    extensionKey: 'change-history',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (_node, context)=>{
        try {
            const variables = (0, $eqmIR.buildChangeHistoryDataQueryVariables)(context.contentId);
            await (0, $wPrRK.slowQueryGuard)('changeHistoryPreload', ()=>(0, $dYU3e.query)({
                    query: (0, $k0BFU.default),
                    variables: variables,
                    context: {
                        single: true
                    },
                    __callerPackage__: "preload-macros"
                }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
        } catch  {
            return;
        }
    }
};
module.exports["changeHistoryPreloadHandler"] = $3264be4c944b64e2$export$367ea2b94b2f04d6;

});

parcelRegister("k0BFU", function(module, exports) {
/**
 * @generated SignedSource<<f53a70cd602b186fb3992ed10ea55417>>
 * @relayHash 5b6afbfce3854e9bcb1bde3de2a8c2a7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e052df92530525eaef9def99c51a000bfaed4288154845f27656bb5592202c43
const $70dced0078029077$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v4 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v5 = {
        "kind": "InlineFragment",
        "selections": v4 /*: any*/ ,
        "type": "KnownUser"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": v4 /*: any*/ ,
        "type": "UnknownUser"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v9 = {
        "kind": "ScalarField",
        "name": "when"
    }, v10 = {
        "kind": "ScalarField",
        "name": "message"
    }, v11 = {
        "kind": "ScalarField",
        "name": "number"
    }, v12 = [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ]
        },
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ 
    ], v13 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v14 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "current",
                "draft",
                "archived"
            ]
        }
    ], v15 = {
        "kind": "ScalarField",
        "name": "type"
    }, v16 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v17 = {
        "kind": "ScalarField",
        "name": "key"
    }, v18 = [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ]
        },
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ 
    ], v19 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useChangeHistoryDataQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedContentHistoryList",
                    "kind": "LinkedField",
                    "name": "contentHistory",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentHistory",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v12 /*: any*/ 
                        },
                        v13 /*: any*/ 
                    ]
                },
                {
                    "args": v14 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": v12 /*: any*/ 
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useChangeHistoryDataQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedContentHistoryList",
                    "kind": "LinkedField",
                    "name": "contentHistory",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentHistory",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v18 /*: any*/ 
                        },
                        v13 /*: any*/ 
                    ]
                },
                {
                    "args": v14 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                v19 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": v18 /*: any*/ 
                        },
                        v19 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "5b6afbfce3854e9bcb1bde3de2a8c2a7",
            "id": "e052df92530525eaef9def99c51a000bfaed4288154845f27656bb5592202c43",
            "metadata": {},
            "name": "useChangeHistoryDataQuery",
            "operationKind": "query",
            "text": "query useChangeHistoryDataQuery($contentId:ID!,$after:String,$first:Long){contentHistory(contentId:$contentId,after:$after,first:$first){nodes{by{__typename,...on KnownUser{accountId},...on UnknownUser{accountId},displayName},friendlyWhen,when,message,number},pageInfo{hasNextPage,endCursor}},singleContent(id:$contentId,status:[\"current\",\"draft\",\"archived\"]){type,subType,space{key,id},version{by{__typename,...on KnownUser{accountId},...on UnknownUser{accountId},displayName},friendlyWhen,when,message,number},id}}"
        }
    };
}();
$70dced0078029077$var$node.hash = "5c74bea9bed287cb9acb1aedf532afd9";
var $70dced0078029077$export$2e2bcd8739ae039 = $70dced0078029077$var$node;
module.exports["default"] = $70dced0078029077$export$2e2bcd8739ae039;

});

parcelRegister("eqmIR", function(module, exports) {
const $5dff6ba48bb7564d$export$9266850431e06b56 = 100;
const $5dff6ba48bb7564d$export$70f9f93372f73c04 = (contentId)=>({
        contentId: contentId,
        after: null,
        first: $5dff6ba48bb7564d$export$9266850431e06b56
    });
module.exports["CHANGE_HISTORY_PAGE_SIZE"] = $5dff6ba48bb7564d$export$9266850431e06b56;
module.exports["buildChangeHistoryDataQueryVariables"] = $5dff6ba48bb7564d$export$70f9f93372f73c04;

});

parcelRegister("959F7", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $9wGTI = parcelRequire("9wGTI");


var $6T2gk = parcelRequire("6T2gk");


var $lTGWQ = parcelRequire("lTGWQ");

const $4f6b1e9f682bf5b0$export$8981cb49f72a0f44 = {
    extensionKey: 'contentbylabel',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, context)=>{
        const variables = (0, $lTGWQ.composeMacroParamsForQuery)(node.attrs?.parameters?.macroParams, context.spaceKey, context.contentId);
        if (!variables.cql) return;
        await (0, $wPrRK.slowQueryGuard)('contentByLabelPreload', ()=>(0, $dYU3e.query)({
                query: (0, $6T2gk.default),
                variables: {
                    ...variables,
                    skipSearchTitle: (0, $9wGTI.fg)('cc_rewrite_macros_use_content_not_search_title'),
                    skipContentTitle: !(0, $9wGTI.fg)('cc_rewrite_macros_use_content_not_search_title')
                },
                context: {
                    single: true
                },
                __callerPackage__: "preload-macros"
            }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    }
};
module.exports["contentByLabelPreloadHandler"] = $4f6b1e9f682bf5b0$export$8981cb49f72a0f44;

});

parcelRegister("6T2gk", function(module, exports) {
/**
 * @generated SignedSource<<456f5798c57ca11f89fe2b88a721351a>>
 * @relayHash 07d40effadbca84bcbb2741bd9177f4e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1beeb1423c20c3504f5d3c239740ff4f3818e8e1353fb2766713f97c9e021fbd
const $fed9f45d550b7e93$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fallbackToBody"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeExcerpt"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "maxExcerptBlocks"
    }, v6 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "skipContentTitle"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "skipSearchTitle"
    }, v8 = [
        {
            "kind": "ScalarField",
            "name": "title"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = [
        {
            "alias": "search",
            "args": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "after"
                },
                {
                    "kind": "Variable",
                    "name": "cql",
                    "variableName": "cql"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                }
            ],
            "concreteType": "ConfluenceSearchConnection",
            "kind": "LinkedField",
            "name": "confluence_search",
            "plural": false,
            "selections": [
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceSearchResponse",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "condition": "skipSearchTitle",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": v8 /*: any*/ 
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "lastModified"
                        },
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                {
                                    "condition": "skipContentTitle",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": v8 /*: any*/ 
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "subType"
                                },
                                {
                                    "condition": "includeExcerpt",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceMacroExcerptBody",
                                            "kind": "LinkedField",
                                            "name": "macroExcerpt",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "fallbackToBody",
                                                            "variableName": "fallbackToBody"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "maxBlocks",
                                                            "variableName": "maxExcerptBlocks"
                                                        }
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "atlasDocFormat"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "ContentBodyPerRepresentation",
                                            "kind": "LinkedField",
                                            "name": "body",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "ContentBody",
                                                    "kind": "LinkedField",
                                                    "name": "atlas_doc_format",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "EmbeddedMediaToken",
                                                            "kind": "LinkedField",
                                                            "name": "mediaToken",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "token"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        v10 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "PaginatedLabelList",
                                    "kind": "LinkedField",
                                    "name": "labels",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "Label",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useContentByLabelDataQuery",
            "selections": v11 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useContentByLabelDataQuery",
            "selections": v11 /*: any*/ 
        },
        "params": {
            "cacheID": "07d40effadbca84bcbb2741bd9177f4e",
            "id": "1beeb1423c20c3504f5d3c239740ff4f3818e8e1353fb2766713f97c9e021fbd",
            "metadata": {},
            "name": "useContentByLabelDataQuery",
            "operationKind": "query",
            "text": "query useContentByLabelDataQuery($cql:String!,$after:String,$first:Int,$includeExcerpt:Boolean!,$fallbackToBody:Boolean!,$maxExcerptBlocks:Int,$skipSearchTitle:Boolean=false,$skipContentTitle:Boolean=true){search:confluence_search(cql:$cql,first:$first,after:$after){pageInfo{endCursor,hasNextPage},nodes{title@skip(if:$skipSearchTitle),url,lastModified,content{id,title@skip(if:$skipContentTitle),type,subType,macroExcerpt@include(if:$includeExcerpt){atlasDocFormat(fallbackToBody:$fallbackToBody,maxBlocks:$maxExcerptBlocks)}\n        body@include(if:$includeExcerpt){atlas_doc_format{mediaToken{token}}},space{id,key,name},labels{nodes{id,name}}}}}}"
        }
    };
}();
$fed9f45d550b7e93$var$node.hash = "2103820fa476500ec2c838481eb34589";
var $fed9f45d550b7e93$export$2e2bcd8739ae039 = $fed9f45d550b7e93$var$node;
module.exports["default"] = $fed9f45d550b7e93$export$2e2bcd8739ae039;

});

parcelRegister("lTGWQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $5fi0G = parcelRequire("5fi0G");

const $67a1e9c4dba455ef$var$MAX_RESULTS_CAP = 500;
const $67a1e9c4dba455ef$var$DEFAULT_MAX_RESULTS = 15;
/**
 * Block caps applied to the `macroExcerpt.atlasDocFormat` field.
 *
 * "Excerpt preview" (simple) shows a short teaser, while "Page preview"
 * (rich content) shows a substantial portion of the page.
 */ const $67a1e9c4dba455ef$var$SIMPLE_EXCERPT_MAX_BLOCKS = 3;
const $67a1e9c4dba455ef$var$RICH_CONTENT_EXCERPT_MAX_BLOCKS = 50;
const $67a1e9c4dba455ef$export$f7d89cdb032bc97a = 50;
var $67a1e9c4dba455ef$export$b769d4fd9dd3feec = /*#__PURE__*/ function(ExcerptType) {
    ExcerptType["None"] = "none";
    ExcerptType["Simple"] = "simple";
    ExcerptType["RichContent"] = "rich content";
    return ExcerptType;
}({});
var $67a1e9c4dba455ef$export$9c8b9f8fac4b24ab = /*#__PURE__*/ function(SortOption) {
    SortOption["Creation"] = "created";
    SortOption["Title"] = "title";
    SortOption["Modified"] = "lastModified";
    return SortOption;
}({});
const $67a1e9c4dba455ef$var$SORT_PARAM_TO_CQL = {
    creation: "created",
    title: "title",
    modified: "lastModified"
};
function $67a1e9c4dba455ef$var$parseSortOption(value) {
    if (!value) return undefined;
    return $67a1e9c4dba455ef$var$SORT_PARAM_TO_CQL[value];
}
function $67a1e9c4dba455ef$var$parseBoolean(value, defaultValue) {
    if (value === undefined || value === '') return defaultValue;
    return value === 'true';
}
function $67a1e9c4dba455ef$var$parseMax(value, maxCheckbox) {
    if (maxCheckbox === 'true') return {
        max: $67a1e9c4dba455ef$var$MAX_RESULTS_CAP,
        maxParseError: false
    };
    if (value === undefined || value === '') return {
        max: $67a1e9c4dba455ef$var$DEFAULT_MAX_RESULTS,
        maxParseError: false
    };
    const parsed = parseInt(value, 10);
    if (isNaN(parsed)) return {
        max: $67a1e9c4dba455ef$var$DEFAULT_MAX_RESULTS,
        maxParseError: true
    };
    if (parsed <= 0) return {
        max: $67a1e9c4dba455ef$var$DEFAULT_MAX_RESULTS,
        maxParseError: false
    };
    return {
        max: Math.min(parsed, $67a1e9c4dba455ef$var$MAX_RESULTS_CAP),
        maxParseError: false
    };
}
/**
 * Maps legacy CQL sort field names to their correct equivalents.
 * Legacy macros may have stored invalid field names directly in the cql param
 * (e.g. 'creation' instead of 'created', 'modified' instead of 'lastModified').
 */ const $67a1e9c4dba455ef$var$LEGACY_CQL_SORT_FIELD_REMAP = {
    creation: "created",
    modified: "lastModified"
};
/**
 * Normalizes sort field names in an existing ORDER BY clause within a CQL string.
 * Remaps legacy field names (e.g. 'creation', 'modified') to valid CQL field names.
 */ function $67a1e9c4dba455ef$var$normalizeCqlSortFields(cql) {
    return cql.replace(/(\border\s+by\s+)(\w+)/gi, (_match, prefix, field)=>{
        const lower = field.toLowerCase();
        const remapped = $67a1e9c4dba455ef$var$LEGACY_CQL_SORT_FIELD_REMAP[lower];
        return `${prefix}${remapped !== undefined ? remapped : field}`;
    });
}
function $67a1e9c4dba455ef$var$buildOrderByClause(sort, reverse) {
    if (!sort) return '';
    const direction = reverse ? 'desc' : 'asc';
    return ` order by ${sort} ${direction}`;
}
function $67a1e9c4dba455ef$var$parseExcerptType(value) {
    if (value === "simple") return "simple";
    if (value === "rich content") return "rich content";
    return "none";
}
function $67a1e9c4dba455ef$export$8f0d03faf499ec50(macroParams, currentSpaceKey, currentContentId) {
    const rawCql = macroParams?.cql?.value ?? '';
    const sort = $67a1e9c4dba455ef$var$parseSortOption(macroParams?.sort?.value);
    const reverse = $67a1e9c4dba455ef$var$parseBoolean(macroParams?.reverse?.value, false);
    const { max: max } = $67a1e9c4dba455ef$var$parseMax(macroParams?.max?.value ?? macroParams?.maxResults?.value, macroParams?.maxCheckbox?.value);
    const resolvedCql = $67a1e9c4dba455ef$var$normalizeCqlSortFields((0, $5fi0G.resolveQueryShorthands)(rawCql, {
        currentSpaceKey: currentSpaceKey,
        currentContentId: currentContentId
    }));
    const orderByClause = $67a1e9c4dba455ef$var$buildOrderByClause(sort, reverse);
    const cql = resolvedCql + orderByClause;
    const excerptType = $67a1e9c4dba455ef$var$parseExcerptType(macroParams?.excerptType?.value);
    return {
        cql: cql,
        after: undefined,
        // Gated here rather than in the data hook so that the SSR preload in
        // `@confluence/preload-macros` and the client render agree on `first` —
        // a mismatch would miss the preloaded cache entry and refetch.
        //
        // The ungated branch still asks for the full `max` even though the backend
        // will only ever return 50. That is deliberate: it leaves the control group
        // byte-for-byte unchanged, so if the 50 cap turns out not to hold for every
        // query, turning the gate off is a genuine rollback rather than a second
        // behaviour change.
        first: (0, $9wGTI.fg)('cc_rewrite_contentbylabel_paginate_results') ? Math.min(max, $67a1e9c4dba455ef$export$f7d89cdb032bc97a) : max,
        includeExcerpt: excerptType === "simple" || excerptType === "rich content",
        fallbackToBody: excerptType === "rich content",
        maxExcerptBlocks: excerptType === "rich content" ? $67a1e9c4dba455ef$var$RICH_CONTENT_EXCERPT_MAX_BLOCKS : $67a1e9c4dba455ef$var$SIMPLE_EXCERPT_MAX_BLOCKS
    };
}
function $67a1e9c4dba455ef$export$2f9066b0466085e(macroParams, currentSpaceKey, currentContentId) {
    return (0, $cozmU.useMemo)(()=>{
        const sort = $67a1e9c4dba455ef$var$parseSortOption(macroParams?.sort?.value);
        const reverse = $67a1e9c4dba455ef$var$parseBoolean(macroParams?.reverse?.value, false);
        const { max: max, maxParseError: maxParseError } = $67a1e9c4dba455ef$var$parseMax(macroParams?.max?.value ?? macroParams?.maxResults?.value, macroParams?.maxCheckbox?.value);
        const title = macroParams?.title?.value ?? '';
        const showLabels = $67a1e9c4dba455ef$var$parseBoolean(macroParams?.showLabels?.value, true);
        const showSpace = $67a1e9c4dba455ef$var$parseBoolean(macroParams?.showSpace?.value, true);
        const excerptType = $67a1e9c4dba455ef$var$parseExcerptType(macroParams?.excerptType?.value);
        const macroParamsForQuery = $67a1e9c4dba455ef$export$8f0d03faf499ec50(macroParams, currentSpaceKey, currentContentId);
        const cql = macroParamsForQuery.cql;
        const limitLabelLinksToSpace = cql.includes('space = ');
        return {
            cql: cql,
            sort: sort,
            reverse: reverse,
            max: max,
            maxParseError: maxParseError,
            title: title,
            showLabels: showLabels,
            showSpace: showSpace,
            excerptType: excerptType,
            limitLabelLinksToSpace: limitLabelLinksToSpace,
            macroParamsForQuery: macroParamsForQuery
        };
    }, [
        macroParams,
        currentSpaceKey,
        currentContentId
    ]);
}
module.exports["BACKEND_MAX_RESULTS_PER_REQUEST"] = $67a1e9c4dba455ef$export$f7d89cdb032bc97a;
module.exports["ExcerptType"] = $67a1e9c4dba455ef$export$b769d4fd9dd3feec;
module.exports["composeMacroParamsForQuery"] = $67a1e9c4dba455ef$export$8f0d03faf499ec50;
module.exports["useParsedMacroParams"] = $67a1e9c4dba455ef$export$2f9066b0466085e;

});

parcelRegister("5fi0G", function(module, exports) {
// Matches both bare and quoted variants of the supported sentinels
// (`currentSpace()` / `currentContent()`), tolerating optional whitespace
// before and inside the parentheses (e.g. `currentSpace ( )`). Some macro
// authors / older clients persist `"currentSpace()"` as a string literal, so
// we accept both forms. The sentinel name is captured so the resolver can
// look up the corresponding substitution value.
const $bbef8c560cd45789$var$SHORTHAND_REGEX = /"?(currentSpace|currentContent)\s*\(\s*\)"?/g;
const $bbef8c560cd45789$export$61a94fb63540ef7c = (rawCql, { currentSpaceKey: currentSpaceKey, currentContentId: currentContentId })=>{
    if (!rawCql) return rawCql;
    return rawCql.replace($bbef8c560cd45789$var$SHORTHAND_REGEX, (match, sentinel)=>{
        switch(sentinel){
            case 'currentSpace':
                return currentSpaceKey == undefined ? match : `"${currentSpaceKey}"`;
            case 'currentContent':
                return currentContentId == undefined ? match : `"${currentContentId}"`;
            default:
                return match;
        }
    });
};
module.exports["resolveQueryShorthands"] = $bbef8c560cd45789$export$61a94fb63540ef7c;

});

parcelRegister("lLjor", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $i8KfB = parcelRequire("i8KfB");


var $f21pt = parcelRequire("f21pt");

const $36b2e12d8caeb47e$var$buildVariables = (node, contentId)=>{
    const macroParams = node.attrs?.parameters?.macroParams;
    return {
        contentId: contentId,
        contentStatus: [
            'current'
        ],
        contributorsMacroParameters: macroParams ? (0, $f21pt.composeMacroParamsForQuery)(macroParams) : undefined
    };
};
const $36b2e12d8caeb47e$export$8cfaa971235f65b5 = {
    extensionKey: 'contributors',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, context)=>{
        const variables = $36b2e12d8caeb47e$var$buildVariables(node, context.contentId);
        await (0, $wPrRK.slowQueryGuard)('contributorsPreload', ()=>(0, $dYU3e.query)({
                query: (0, $i8KfB.default),
                variables: variables,
                context: {
                    single: true
                },
                __callerPackage__: "preload-macros"
            }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    }
};
module.exports["contributorsPreloadHandler"] = $36b2e12d8caeb47e$export$8cfaa971235f65b5;

});

parcelRegister("i8KfB", function(module, exports) {
/**
 * @generated SignedSource<<ec07190fb98e0f971c23bf5f1ea3300a>>
 * @relayHash ca950652c375632e8e3242fc2e8e313a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d88382e64959d1d1b6df52cae90f2de3c6d19c72e1d6376f573e550ea308fff3
const $2e401621b9e1fde0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentStatus"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contributorsMacroParameters"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "contentStatus"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "contributorsMacroParameters",
                            "variableName": "contributorsMacroParameters"
                        }
                    ],
                    "concreteType": "ConfluenceContributorsRankings",
                    "kind": "LinkedField",
                    "name": "contributorsMacro",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceAuthorRanking",
                            "kind": "LinkedField",
                            "name": "authorRankingList",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "idString"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "fullNameString"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "edits"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "comments"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "labels"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "watches"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "lastEditTime"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "lastCommentTime"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "lastLabelTime"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContributorsDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContributorsDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "ca950652c375632e8e3242fc2e8e313a",
            "id": "d88382e64959d1d1b6df52cae90f2de3c6d19c72e1d6376f573e550ea308fff3",
            "metadata": {},
            "name": "useContributorsDataQuery",
            "operationKind": "query",
            "text": "query useContributorsDataQuery($contentId:ID,$contentStatus:[String],$contributorsMacroParameters:ConfluenceContributorsMacroParametersModel){singleContent(id:$contentId,status:$contentStatus){id,contributorsMacro(contributorsMacroParameters:$contributorsMacroParameters){authorRankingList{idString,fullNameString,edits,comments,labels,watches,lastEditTime,lastCommentTime,lastLabelTime}}}}"
        }
    };
}();
$2e401621b9e1fde0$var$node.hash = "2b1ea1963eb971919228dd0de7168930";
var $2e401621b9e1fde0$export$2e2bcd8739ae039 = $2e401621b9e1fde0$var$node;
module.exports["default"] = $2e401621b9e1fde0$export$2e2bcd8739ae039;

});

parcelRegister("f21pt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $66904c9443eb5472$export$8bf632d40c0a848b = (value)=>{
    if (!value) return [
        'authors'
    ];
    return value.split(',').map((s)=>s.trim());
};
const $66904c9443eb5472$export$4c17d9c0cb17e4cf = (value)=>{
    const validOrders = [
        'count',
        'name',
        'update',
        'edits',
        'editTime'
    ];
    if (value && validOrders.includes(value)) return value;
    return 'count';
};
const $66904c9443eb5472$export$3fb54149990fb5b5 = (value)=>{
    return value === 'true';
};
const $66904c9443eb5472$export$a122018e819bbb5 = (value)=>{
    if (!value) return -1;
    const parsed = parseInt(value, 10);
    return isNaN(parsed) ? -1 : Math.max(parsed, -1);
};
const $66904c9443eb5472$export$8f0d03faf499ec50 = (macroParams)=>{
    const reverse = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.reverse?.value);
    const showAnonymous = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.showAnonymous?.value);
    return {
        include: macroParams?.include?.value,
        order: macroParams?.order?.value,
        reverse: reverse,
        showAnonymous: showAnonymous,
        page: macroParams?.page?.value,
        labels: macroParams?.labels?.value,
        label: macroParams?.label?.value,
        spaces: macroParams?.spaces?.value,
        space: macroParams?.space?.value,
        contentType: macroParams?.contentType?.value,
        publishDate: macroParams?.publishDate?.value,
        scope: macroParams?.scope?.value
    };
};
const $66904c9443eb5472$export$2f9066b0466085e = (macroParams)=>{
    return (0, $cozmU.useMemo)(()=>{
        const include = $66904c9443eb5472$export$8bf632d40c0a848b(macroParams?.include?.value);
        const order = $66904c9443eb5472$export$4c17d9c0cb17e4cf(macroParams?.order?.value);
        const reverse = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.reverse?.value);
        const limit = $66904c9443eb5472$export$a122018e819bbb5(macroParams?.limit?.value);
        const mode = macroParams?.mode?.value === 'list' ? 'list' : 'inline';
        const showAnonymous = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.showAnonymous?.value);
        const showCount = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.showCount?.value);
        const showTime = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.showLastTime?.value);
        const noneFoundMessage = macroParams?.noneFoundMessage?.value;
        const macroParamsForQuery = $66904c9443eb5472$export$8f0d03faf499ec50(macroParams);
        return {
            include: include,
            order: order,
            reverse: reverse,
            limit: limit,
            mode: mode,
            showAnonymous: showAnonymous,
            showCount: showCount,
            showTime: showTime,
            noneFoundMessage: noneFoundMessage,
            macroParamsForQuery: macroParamsForQuery
        };
    }, [
        macroParams
    ]);
};
module.exports["composeMacroParamsForQuery"] = $66904c9443eb5472$export$8f0d03faf499ec50;
module.exports["useParsedMacroParams"] = $66904c9443eb5472$export$2f9066b0466085e;

});

parcelRegister("6nf8t", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $cXk0q = parcelRequire("cXk0q");


var $3WUt7 = parcelRequire("3WUt7");

const $467c80d7f40ed92f$var$buildVariables = (node, contentId, spaceKey)=>{
    const macroParams = node.attrs?.parameters?.macroParams;
    const macroId = node.attrs?.parameters?.macroMetadata?.macroId?.value || '';
    return (0, $3WUt7.buildDetailsSummaryVariables)({
        macroParams: macroParams,
        contentId: contentId,
        spaceKey: spaceKey,
        macroId: macroId
    });
};
const $467c80d7f40ed92f$export$69acddabbc0e6f95 = {
    extensionKey: 'detailssummary',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, context)=>{
        try {
            const variables = $467c80d7f40ed92f$var$buildVariables(node, context.contentId, context.spaceKey);
            await (0, $wPrRK.slowQueryGuard)('detailsSummaryPreload', ()=>(0, $dYU3e.query)({
                    query: (0, $cXk0q.DetailsSummaryADFQuery),
                    variables: variables,
                    context: {
                        single: true
                    },
                    __callerPackage__: "preload-macros"
                }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
        } catch  {
            return;
        }
    }
};
module.exports["detailsSummaryPreloadHandler"] = $467c80d7f40ed92f$export$69acddabbc0e6f95;

});

parcelRegister("cXk0q", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $6FBXU = parcelRequire("6FBXU");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $7zgzO = parcelRequire("7zgzO");


var $3WUt7 = parcelRequire("3WUt7");

const $8b4cd8637684b33c$export$4aa63971c7cdd461 = (0, $6FBXU.default);
const $8b4cd8637684b33c$export$3a7ba9dcd3d890e8 = (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { macroDefaultProps: macroDefaultProps, macroParams: macroParams } = t0;
    const [pageIndex, setPageIndex] = (0, $cozmU.useState)(0);
    const { location: location } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setPageIndex(0);
        };
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== macroParams) {
        t2 = [
            macroParams
        ];
        $[1] = macroParams;
        $[2] = t2;
    } else t2 = $[2];
    (0, $cozmU.useEffect)(t1, t2);
    let isPDFExport;
    let t3;
    let t4;
    let t5;
    if ($[3] !== location?.pathname || $[4] !== macroDefaultProps.attributes?.macroId || $[5] !== macroDefaultProps.contentId || $[6] !== macroDefaultProps.spaceKey || $[7] !== macroParams || $[8] !== pageIndex) {
        isPDFExport = location?.pathname.startsWith("/wiki/pdf/");
        t4 = (0, $jMyy4.useQueryInterop);
        t5 = $8b4cd8637684b33c$export$4aa63971c7cdd461;
        t3 = (0, $3WUt7.buildDetailsSummaryVariables)({
            macroParams: macroParams,
            contentId: macroDefaultProps.contentId,
            spaceKey: macroDefaultProps.spaceKey,
            macroId: macroDefaultProps?.attributes?.macroId?.toString() || "",
            pageIndex: pageIndex,
            isPDFExport: isPDFExport
        });
        $[3] = location?.pathname;
        $[4] = macroDefaultProps.attributes?.macroId;
        $[5] = macroDefaultProps.contentId;
        $[6] = macroDefaultProps.spaceKey;
        $[7] = macroParams;
        $[8] = pageIndex;
        $[9] = isPDFExport;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else {
        isPDFExport = $[9];
        t3 = $[10];
        t4 = $[11];
        t5 = $[12];
    }
    let t6;
    if ($[13] !== t3) {
        t6 = {
            variables: t3,
            fetchPolicy: "cache-first"
        };
        $[13] = t3;
        $[14] = t6;
    } else t6 = $[14];
    const { data: data, error: error, loading: loading } = t4(t5, t6);
    const isInitialLoad = loading && !data;
    let t7;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (_, pageNumber)=>{
            setPageIndex(pageNumber - 1);
        };
        $[15] = t7;
    } else t7 = $[15];
    const paginateTable = t7;
    const t8 = data?.detailsLines?.totalPages || 0;
    let t9;
    if ($[16] !== data || $[17] !== error || $[18] !== isInitialLoad || $[19] !== isPDFExport || $[20] !== loading || $[21] !== pageIndex || $[22] !== t8) {
        t9 = {
            data: data,
            error: error,
            loading: loading,
            isInitialLoad: isInitialLoad,
            isPDFExport: isPDFExport,
            pageIndex: pageIndex,
            paginateTable: paginateTable,
            totalPages: t8
        };
        $[16] = data;
        $[17] = error;
        $[18] = isInitialLoad;
        $[19] = isPDFExport;
        $[20] = loading;
        $[21] = pageIndex;
        $[22] = t8;
        $[23] = t9;
    } else t9 = $[23];
    return t9;
};
module.exports["DetailsSummaryADFQuery"] = $8b4cd8637684b33c$export$4aa63971c7cdd461;
module.exports["useDetailsSummaryADFQuery"] = $8b4cd8637684b33c$export$3a7ba9dcd3d890e8;

});

parcelRegister("6FBXU", function(module, exports) {
/**
 * @generated SignedSource<<61b269fc5c97af6ef6d28bc446a0eec0>>
 * @relayHash 81e0ec3084120c0be1f11ccafd133340
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d12d7ebbccf4878f0dfbd2b2e4f86b05fa695f03a27498a938b402a9f5529b9a
const $fa83278cc1200055$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": "atlas_doc_format",
        "kind": "LocalArgument",
        "name": "contentRepresentation"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "countComments"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "countLikes"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "countUnresolvedComments"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "detailsId"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "headings"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "macroId"
    }, v9 = {
        "defaultValue": 0,
        "kind": "LocalArgument",
        "name": "pageIndex"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageSize"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "reverseSort"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "showCreator"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "showLastModified"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "showPageLabels"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v17 = {
        "kind": "ScalarField",
        "name": "macroId"
    }, v18 = {
        "kind": "ScalarField",
        "name": "name"
    }, v19 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentRepresentation",
                    "variableName": "contentRepresentation"
                },
                {
                    "kind": "Variable",
                    "name": "countComments",
                    "variableName": "countComments"
                },
                {
                    "kind": "Variable",
                    "name": "countLikes",
                    "variableName": "countLikes"
                },
                {
                    "kind": "Variable",
                    "name": "countUnresolvedComments",
                    "variableName": "countUnresolvedComments"
                },
                {
                    "kind": "Variable",
                    "name": "cql",
                    "variableName": "cql"
                },
                {
                    "kind": "Variable",
                    "name": "detailsId",
                    "variableName": "detailsId"
                },
                {
                    "kind": "Variable",
                    "name": "headings",
                    "variableName": "headings"
                },
                {
                    "kind": "Variable",
                    "name": "macroId",
                    "variableName": "macroId"
                },
                {
                    "kind": "Variable",
                    "name": "pageIndex",
                    "variableName": "pageIndex"
                },
                {
                    "kind": "Variable",
                    "name": "pageSize",
                    "variableName": "pageSize"
                },
                {
                    "kind": "Variable",
                    "name": "reverseSort",
                    "variableName": "reverseSort"
                },
                {
                    "kind": "Variable",
                    "name": "showCreator",
                    "variableName": "showCreator"
                },
                {
                    "kind": "Variable",
                    "name": "showLastModified",
                    "variableName": "showLastModified"
                },
                {
                    "kind": "Variable",
                    "name": "showPageLabels",
                    "variableName": "showPageLabels"
                },
                {
                    "kind": "Variable",
                    "name": "sortBy",
                    "variableName": "sortBy"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "DetailsSummaryLines",
            "kind": "LinkedField",
            "name": "detailsLines",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "currentPage"
                },
                {
                    "kind": "ScalarField",
                    "name": "totalPages"
                },
                {
                    "kind": "ScalarField",
                    "name": "renderedHeadings"
                },
                v17 /*: any*/ ,
                {
                    "concreteType": "DetailLine",
                    "kind": "LinkedField",
                    "name": "detailLines",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "relativeLink"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "details"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "reactionsCount"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "commentsCount"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "rowId"
                        },
                        v17 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "unresolvedCommentsCount"
                        },
                        {
                            "concreteType": "DetailLabels",
                            "kind": "LinkedField",
                            "name": "labels",
                            "plural": true,
                            "selections": [
                                v18 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "displayTitle"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "urlPath"
                                }
                            ]
                        },
                        {
                            "concreteType": "DetailCreator",
                            "kind": "LinkedField",
                            "name": "creator",
                            "plural": false,
                            "selections": [
                                v18 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                }
                            ]
                        },
                        {
                            "concreteType": "DetailLastModified",
                            "kind": "LinkedField",
                            "name": "lastModified",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyModificationDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "sortableDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useDetailsSummaryADFQueryQuery",
            "selections": v19 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v15 /*: any*/ ,
                v11 /*: any*/ ,
                v16 /*: any*/ ,
                v0 /*: any*/ ,
                v10 /*: any*/ ,
                v9 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v14 /*: any*/ ,
                v13 /*: any*/ ,
                v12 /*: any*/ ,
                v7 /*: any*/ ,
                v1 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useDetailsSummaryADFQueryQuery",
            "selections": v19 /*: any*/ 
        },
        "params": {
            "cacheID": "81e0ec3084120c0be1f11ccafd133340",
            "id": "d12d7ebbccf4878f0dfbd2b2e4f86b05fa695f03a27498a938b402a9f5529b9a",
            "metadata": {},
            "name": "useDetailsSummaryADFQueryQuery",
            "operationKind": "query",
            "text": "query useDetailsSummaryADFQueryQuery($cql:String,$detailsId:String,$sortBy:String,$reverseSort:Boolean,$spaceKey:String!,$contentId:ID!,$pageSize:Int,$pageIndex:Int=0,$countComments:Boolean,$countUnresolvedComments:Boolean,$countLikes:Boolean,$showPageLabels:Boolean,$showLastModified:Boolean,$showCreator:Boolean,$headings:String,$contentRepresentation:String=\"atlas_doc_format\",$macroId:String){detailsLines(cql:$cql,detailsId:$detailsId,sortBy:$sortBy,reverseSort:$reverseSort,spaceKey:$spaceKey,contentId:$contentId,pageSize:$pageSize,pageIndex:$pageIndex,countComments:$countComments,countUnresolvedComments:$countUnresolvedComments,countLikes:$countLikes,showPageLabels:$showPageLabels,showLastModified:$showLastModified,showCreator:$showCreator,headings:$headings,contentRepresentation:$contentRepresentation,macroId:$macroId){currentPage,totalPages,renderedHeadings,macroId,detailLines{id,title,relativeLink,details,reactionsCount,commentsCount,rowId,macroId,unresolvedCommentsCount,labels{name,displayTitle,urlPath},creator{name,accountId},lastModified{friendlyModificationDate,sortableDate}}}}"
        }
    };
}();
$fa83278cc1200055$var$node.hash = "e2f904ef103ed055ad0661a39595ea5b";
var $fa83278cc1200055$export$2e2bcd8739ae039 = $fa83278cc1200055$var$node;
module.exports["default"] = $fa83278cc1200055$export$2e2bcd8739ae039;

});

parcelRegister("3WUt7", function(module, exports) {

var $isgNA = parcelRequire("isgNA");

const $2969a01dbaf01c74$var$isTrue = (params, key)=>params?.[key]?.value === 'true';
const $2969a01dbaf01c74$var$normalizeCql = (cql)=>{
    return cql?.trim() ? cql : undefined;
};
/**
 * Resolve the effective `pageSize` query variable for the details-summary
 * macro.
 *
 * Rules (kept in one place so the runtime hook, the SSR preload-macros
 * handler, and the legacy SSR preload all behave identically):
 *
 * - When rendering inside a PDF export, always request the maximum page size
 *   (`MAX_PDF_PAGE_SIZE`) so the exported document contains every row.
 * - Otherwise, parse the user-supplied `pageSize` macro param as a base-10
 *   integer. Missing / unparseable values fall back to the default
 *   (`DEFAULT_MAX_PAGE_SIZE`).
 * - The parsed value is then clamped to `DEFAULT_MAX_PAGE_SIZE` so a macro
 *   author cannot accidentally request a larger page than the server is
 *   tuned for.
 */ const $2969a01dbaf01c74$var$resolvePageSize = (macroParams, isPDFExport)=>{
    if (isPDFExport) return 0, $isgNA.MAX_PDF_PAGE_SIZE;
    const rawValue = macroParams?.['pageSize']?.value;
    const parsed = parseInt(rawValue || `${0, $isgNA.DEFAULT_MAX_PAGE_SIZE}`, 10);
    if (Number.isNaN(parsed)) return 0, $isgNA.DEFAULT_MAX_PAGE_SIZE;
    return Math.min(parsed, (0, $isgNA.DEFAULT_MAX_PAGE_SIZE));
};
const $2969a01dbaf01c74$export$1b64d6545318c754 = ({ macroParams: macroParams, contentId: contentId, spaceKey: spaceKey, macroId: macroId, pageIndex: pageIndex = 0, isPDFExport: isPDFExport = false })=>({
        // `_parentId` is the source page where the macro was inserted; it is
        // present when nested inside of other macros and should be used instead of
        // the current page contentId.
        contentId: macroParams?.['_parentId']?.value || contentId,
        cql: $2969a01dbaf01c74$var$normalizeCql(macroParams?.['cql']?.value),
        detailsId: macroParams?.['id']?.value,
        headings: macroParams?.['headings']?.value,
        sortBy: macroParams?.['sortBy']?.value,
        spaceKey: spaceKey,
        countLikes: $2969a01dbaf01c74$var$isTrue(macroParams, 'showLikesCount'),
        reverseSort: $2969a01dbaf01c74$var$isTrue(macroParams, 'reverseSort'),
        countComments: $2969a01dbaf01c74$var$isTrue(macroParams, 'showCommentsCount'),
        countUnresolvedComments: $2969a01dbaf01c74$var$isTrue(macroParams, 'showUnresolvedCommentsCount'),
        showPageLabels: $2969a01dbaf01c74$var$isTrue(macroParams, 'showPageLabels'),
        showLastModified: $2969a01dbaf01c74$var$isTrue(macroParams, 'showLastModified'),
        showCreator: $2969a01dbaf01c74$var$isTrue(macroParams, 'showCreator'),
        pageIndex: pageIndex,
        macroId: macroId,
        pageSize: $2969a01dbaf01c74$var$resolvePageSize(macroParams, isPDFExport)
    });
module.exports["buildDetailsSummaryVariables"] = $2969a01dbaf01c74$export$1b64d6545318c754;

});

parcelRegister("isgNA", function(module, exports) {
const $38e46c834876fccf$export$38d4334417be6de4 = [
    'showCreator',
    'showLastModified',
    'showPageLabels',
    'showCommentsCount',
    'showUnresolvedCommentsCount',
    'showLikesCount'
];
const $38e46c834876fccf$export$89486cb0536270a1 = 30;
const $38e46c834876fccf$export$bcb403f7710dd1db = 500;
module.exports["optionalTableHeaderParams"] = $38e46c834876fccf$export$38d4334417be6de4;
module.exports["DEFAULT_MAX_PAGE_SIZE"] = $38e46c834876fccf$export$89486cb0536270a1;
module.exports["MAX_PDF_PAGE_SIZE"] = $38e46c834876fccf$export$bcb403f7710dd1db;

});

parcelRegister("gVB2D", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $xwvlW = parcelRequire("xwvlW");


var $kqbRJ = parcelRequire("kqbRJ");


var $3wadB = parcelRequire("3wadB");


var $izncj = parcelRequire("izncj");

const $d0a45ea7d8dc97da$var$preloadSpaceId = async (spaceKey)=>{
    let result;
    await (0, $wPrRK.slowQueryGuard)('listLabelsSpaceIdPreload', async ()=>{
        result = await (0, $dYU3e.query)({
            query: (0, $izncj.default),
            variables: {
                spaceKey: spaceKey
            },
            context: {
                single: true
            },
            __callerPackage__: "preload-macros"
        });
    }, (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    return result?.data?.space?.id ?? null;
};
const $d0a45ea7d8dc97da$export$60775a3beb35aac2 = {
    extensionKey: 'listlabels',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, context)=>{
        try {
            const { cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
            if (!cloudId) return;
            const macroParams = node.attrs?.parameters?.macroParams;
            const { isAllSpaces: isAllSpaces, spaceKey: spaceKey } = (0, $kqbRJ.resolveSpaceScope)(macroParams?.spaceKey?.value, context.spaceKey);
            const excludedLabels = (0, $kqbRJ.parseExcludedLabels)(macroParams?.excludedLabels?.value);
            let spaceId = null;
            if (!isAllSpaces) {
                if (!spaceKey) return;
                spaceId = await $d0a45ea7d8dc97da$var$preloadSpaceId(spaceKey);
                if (!spaceId) return;
            }
            const variables = {
                cloudId: cloudId,
                spaceId: spaceId,
                allSpaces: isAllSpaces,
                excludedLabels: excludedLabels
            };
            await (0, $wPrRK.slowQueryGuard)('listLabelsPreload', ()=>(0, $dYU3e.query)({
                    query: (0, $3wadB.default),
                    variables: variables,
                    context: {
                        single: true
                    },
                    __callerPackage__: "preload-macros"
                }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
        } catch  {
            return;
        }
    }
};
module.exports["listLabelsPreloadHandler"] = $d0a45ea7d8dc97da$export$60775a3beb35aac2;

});

parcelRegister("kqbRJ", function(module, exports) {
const $4939d67dcd01d0e0$export$94e0c7b39f2b34f9 = '@all';
const $4939d67dcd01d0e0$export$f8e62856e51f4d9b = 'currentSpace()';
const $4939d67dcd01d0e0$export$7b1eedb0d544c7da = (rawSpaceKey, currentSpaceKey)=>{
    if (rawSpaceKey === $4939d67dcd01d0e0$export$94e0c7b39f2b34f9) return {
        isAllSpaces: true,
        spaceKey: undefined
    };
    if (!rawSpaceKey || rawSpaceKey === $4939d67dcd01d0e0$export$f8e62856e51f4d9b) return {
        isAllSpaces: false,
        spaceKey: currentSpaceKey
    };
    return {
        isAllSpaces: false,
        spaceKey: rawSpaceKey
    };
};
const $4939d67dcd01d0e0$export$7771993ef2cbabc2 = (value)=>{
    if (!value) return [];
    const seen = new Set();
    const parts = value.split(',');
    for (const raw of parts){
        const trimmed = raw.trim();
        if (trimmed) seen.add(trimmed);
    }
    return Array.from(seen);
};
module.exports["resolveSpaceScope"] = $4939d67dcd01d0e0$export$7b1eedb0d544c7da;
module.exports["parseExcludedLabels"] = $4939d67dcd01d0e0$export$7771993ef2cbabc2;

});

parcelRegister("3wadB", function(module, exports) {
/**
 * @generated SignedSource<<e0249d0992f400a6526181a945012ffd>>
 * @relayHash e490775649afa10a1ac14bad8cbd94bd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4181465badaa41786742045fb958487f52f56cdb498c02b73b0b7eed1a8a453f
const $f7147aaabb588820$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "allSpaces"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "excludedLabels"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceId"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "allSpaces",
                    "variableName": "allSpaces"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "excludedLabels",
                    "variableName": "excludedLabels"
                },
                {
                    "kind": "Variable",
                    "name": "spaceId",
                    "variableName": "spaceId"
                }
            ],
            "concreteType": "ConfluenceListLabelsEntryConnection",
            "kind": "LinkedField",
            "name": "confluence_listLabelsMacro",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceListLabelsEntry",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useListLabelsDataQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useListLabelsDataQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "e490775649afa10a1ac14bad8cbd94bd",
            "id": "4181465badaa41786742045fb958487f52f56cdb498c02b73b0b7eed1a8a453f",
            "metadata": {},
            "name": "useListLabelsDataQuery",
            "operationKind": "query",
            "text": "query useListLabelsDataQuery($cloudId:ID!,$spaceId:ID,$allSpaces:Boolean,$excludedLabels:[String]){confluence_listLabelsMacro(cloudId:$cloudId,spaceId:$spaceId,allSpaces:$allSpaces,excludedLabels:$excludedLabels){nodes{name}}}"
        }
    };
}();
$f7147aaabb588820$var$node.hash = "2c7ef1148f466dc186b067e3d9de94fc";
var $f7147aaabb588820$export$2e2bcd8739ae039 = $f7147aaabb588820$var$node;
module.exports["default"] = $f7147aaabb588820$export$2e2bcd8739ae039;

});

parcelRegister("izncj", function(module, exports) {
/**
 * @generated SignedSource<<5afa903b77b6244a1aa2ec9b3e94ab53>>
 * @relayHash 2a6d3b6565088b774bad70b364b139c8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 782a473dfec90098d6425dcff4ef38b354db9a1cc0ae4c3ea9309997887128c7
const $23e928b69bac4fd8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useListLabelsDataSpaceIdQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useListLabelsDataSpaceIdQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2a6d3b6565088b774bad70b364b139c8",
            "id": "782a473dfec90098d6425dcff4ef38b354db9a1cc0ae4c3ea9309997887128c7",
            "metadata": {},
            "name": "useListLabelsDataSpaceIdQuery",
            "operationKind": "query",
            "text": "query useListLabelsDataSpaceIdQuery($spaceKey:String){space(key:$spaceKey){id}}"
        }
    };
}();
$23e928b69bac4fd8$var$node.hash = "b3935b747e8f02e00f6883bc6979f007";
var $23e928b69bac4fd8$export$2e2bcd8739ae039 = $23e928b69bac4fd8$var$node;
module.exports["default"] = $23e928b69bac4fd8$export$2e2bcd8739ae039;

});

parcelRegister("eM1QC", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $oDAuM = parcelRequire("oDAuM");


var $7AKam = parcelRequire("7AKam");


var $6K7Y4 = parcelRequire("6K7Y4");

const $7a5f1a746a9c082d$var$preloadById = (variables)=>(0, $wPrRK.slowQueryGuard)('pageIncludeByIdPreload', ()=>(0, $dYU3e.query)({
            query: (0, $oDAuM.default),
            variables: variables,
            context: {
                single: true
            },
            __callerPackage__: "preload-macros"
        }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
const $7a5f1a746a9c082d$var$preloadByTitle = (variables)=>(0, $wPrRK.slowQueryGuard)('pageIncludeByTitlePreload', ()=>(0, $dYU3e.query)({
            query: (0, $7AKam.default),
            variables: variables,
            context: {
                single: true
            },
            __callerPackage__: "preload-macros"
        }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
const $7a5f1a746a9c082d$export$918221fb7aa02f2c = {
    extensionKey: 'include',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, context)=>{
        const parsedTarget = (0, $6K7Y4.parseMacroTarget)(node.attrs?.parameters?.macroParams);
        const queryTarget = (0, $6K7Y4.getPageIncludeQueryTarget)(parsedTarget, context.spaceKey);
        if (queryTarget.kind === 'by-id') {
            await $7a5f1a746a9c082d$var$preloadById(queryTarget.variables);
            return;
        }
        if (queryTarget.kind === 'by-title') await $7a5f1a746a9c082d$var$preloadByTitle(queryTarget.variables);
    }
};
module.exports["pageIncludePreloadHandler"] = $7a5f1a746a9c082d$export$918221fb7aa02f2c;

});

parcelRegister("oDAuM", function(module, exports) {
/**
 * @generated SignedSource<<1c0c89d79fe77d1b063869de36dc5dd5>>
 * @relayHash 29bcc67d3111f4f97c3c431cc81c9399
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e6bb19ae6a019c7084d957bb2ca18f4a8866b288d1764e44f293dc9cd1f7ff53
const $8e0b9375d7694fe5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "atlas_doc_format",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                {
                                    "concreteType": "EmbeddedMediaToken",
                                    "kind": "LinkedField",
                                    "name": "mediaToken",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "token"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePageIncludeMacroQueryByIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePageIncludeMacroQueryByIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "29bcc67d3111f4f97c3c431cc81c9399",
            "id": "e6bb19ae6a019c7084d957bb2ca18f4a8866b288d1764e44f293dc9cd1f7ff53",
            "metadata": {},
            "name": "usePageIncludeMacroQueryByIdQuery",
            "operationKind": "query",
            "text": "query usePageIncludeMacroQueryByIdQuery($contentId:ID!){singleContent(id:$contentId){id,title,type,space{key,id},body{atlas_doc_format{value,mediaToken{token}}}}}"
        }
    };
}();
$8e0b9375d7694fe5$var$node.hash = "983fd7d5b2c3bedd36acf332a4d2a21e";
var $8e0b9375d7694fe5$export$2e2bcd8739ae039 = $8e0b9375d7694fe5$var$node;
module.exports["default"] = $8e0b9375d7694fe5$export$2e2bcd8739ae039;

});

parcelRegister("7AKam", function(module, exports) {
/**
 * @generated SignedSource<<1bce5b35349cd4550da965c94478b555>>
 * @relayHash 8f72766dbc3288a69e1f166ec6dfe741
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4236b4cf1f397110e6c228b217491c94eb02fc762436d65d8a1a2ac4ef224bd0
const $74df5cfe1a2e5d0a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "blogSpaceKey"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "blogTitle"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeBlog"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeRaw"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeSplit"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "postingDay"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "rawSpaceKey"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "rawTitle"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "splitSpaceKey"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "splitTitle"
    }, v10 = {
        "kind": "Literal",
        "name": "first",
        "value": 1
    }, v11 = {
        "kind": "Literal",
        "name": "type",
        "value": "page"
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = [
        {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v12 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        v12 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "atlas_doc_format",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                {
                                    "concreteType": "EmbeddedMediaToken",
                                    "kind": "LinkedField",
                                    "name": "mediaToken",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "token"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v14 = [
        {
            "condition": "includeRaw",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "alias": "rawContent",
                    "args": [
                        v10 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "rawSpaceKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "title",
                            "variableName": "rawTitle"
                        },
                        v11 /*: any*/ 
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v13 /*: any*/ 
                }
            ]
        },
        {
            "condition": "includeSplit",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "alias": "splitContent",
                    "args": [
                        v10 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "splitSpaceKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "title",
                            "variableName": "splitTitle"
                        },
                        v11 /*: any*/ 
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v13 /*: any*/ 
                }
            ]
        },
        {
            "condition": "includeBlog",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "alias": "blogContent",
                    "args": [
                        v10 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "postingDay",
                            "variableName": "postingDay"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "blogSpaceKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "title",
                            "variableName": "blogTitle"
                        },
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "blogpost"
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v13 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "usePageIncludeMacroQueryByTitleQuery",
            "selections": v14 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v3 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "usePageIncludeMacroQueryByTitleQuery",
            "selections": v14 /*: any*/ 
        },
        "params": {
            "cacheID": "8f72766dbc3288a69e1f166ec6dfe741",
            "id": "4236b4cf1f397110e6c228b217491c94eb02fc762436d65d8a1a2ac4ef224bd0",
            "metadata": {},
            "name": "usePageIncludeMacroQueryByTitleQuery",
            "operationKind": "query",
            "text": "query usePageIncludeMacroQueryByTitleQuery($rawSpaceKey:String!,$rawTitle:String!,$includeRaw:Boolean!,$splitSpaceKey:String!,$splitTitle:String!,$includeSplit:Boolean!,$blogSpaceKey:String!,$blogTitle:String!,$postingDay:String!,$includeBlog:Boolean!){rawContent:content(spaceKey:$rawSpaceKey,title:$rawTitle,type:\"page\",first:1)@include(if:$includeRaw){nodes{id,title,type,space{key,id},body{atlas_doc_format{value,mediaToken{token}}}}},splitContent:content(spaceKey:$splitSpaceKey,title:$splitTitle,type:\"page\",first:1)@include(if:$includeSplit){nodes{id,title,type,space{key,id},body{atlas_doc_format{value,mediaToken{token}}}}},blogContent:content(spaceKey:$blogSpaceKey,title:$blogTitle,type:\"blogpost\",postingDay:$postingDay,first:1)@include(if:$includeBlog){nodes{id,title,type,space{key,id},body{atlas_doc_format{value,mediaToken{token}}}}}}"
        }
    };
}();
$74df5cfe1a2e5d0a$var$node.hash = "f95c0a76906580963b7866b01f678dd2";
var $74df5cfe1a2e5d0a$export$2e2bcd8739ae039 = $74df5cfe1a2e5d0a$var$node;
module.exports["default"] = $74df5cfe1a2e5d0a$export$2e2bcd8739ae039;

});

parcelRegister("6K7Y4", function(module, exports) {
const $397b91bd2abb6c3a$export$bcd93dab64989992 = (macroParams)=>{
    const referencedContentId = macroParams?.['_referencedContentId']?.value ?? null;
    const parentId = macroParams?.['_parentId']?.value ?? null;
    // 1. Modern typed parameter (key is "")
    const typedValue = macroParams?.['']?.value?.trim();
    if (typedValue) return {
        location: typedValue,
        referencedContentId: referencedContentId,
        parentId: parentId,
        error: null
    };
    // 2. Legacy pageTitle (takes precedence over "0")
    const pageTitle = macroParams?.['pageTitle']?.value?.trim();
    if (pageTitle) {
        const spaceKey = macroParams?.['spaceKey']?.value?.trim();
        const location = spaceKey ? `${spaceKey}:${pageTitle}` : pageTitle;
        return {
            location: location,
            referencedContentId: referencedContentId,
            parentId: parentId,
            error: null
        };
    }
    // 3. Legacy untyped default parameter "0"
    const legacyDefault = macroParams?.['0']?.value?.trim();
    if (legacyDefault) return {
        location: legacyDefault,
        referencedContentId: referencedContentId,
        parentId: parentId,
        error: null
    };
    // No target configured
    return {
        location: null,
        referencedContentId: referencedContentId,
        parentId: parentId,
        error: 'missing-target'
    };
};
const $397b91bd2abb6c3a$var$extractContentIdFromTypedValue = (value)=>{
    const match = value.match(/confluence-content:\/\/[^/]+\/(\d+)/);
    return match ? match[1] : null;
};
const $397b91bd2abb6c3a$var$BLOG_POST_LINK_REGEX = /^(?:([\w]+):)?\/(\d{4}\/\d{2}\/\d{2})\/(.+)$/;
const $397b91bd2abb6c3a$var$isValidSpaceKey = (spaceKey)=>{
    if (!spaceKey) return false;
    if (spaceKey.startsWith('~')) return true;
    return spaceKey.length <= 255 && /^[A-Za-z0-9]+$/.test(spaceKey);
};
const $397b91bd2abb6c3a$var$parseSplitPageCandidate = (location)=>{
    const colonIdx = location.indexOf(':');
    if (colonIdx < 0) return null;
    const spaceKey = location.slice(0, colonIdx);
    const title = location.slice(colonIdx + 1);
    if (!$397b91bd2abb6c3a$var$isValidSpaceKey(spaceKey) || title.startsWith(' ')) return null;
    return {
        spaceKey: spaceKey,
        title: title
    };
};
const $397b91bd2abb6c3a$var$parseBlogPostCandidate = (location, hostSpaceKey)=>{
    const match = location.match($397b91bd2abb6c3a$var$BLOG_POST_LINK_REGEX);
    if (!match) return null;
    const spaceKey = match[1] || hostSpaceKey;
    const postingDay = match[2].replace(/\//g, '-');
    const title = match[3];
    if (!spaceKey || !title) return null;
    return {
        spaceKey: spaceKey,
        title: title,
        postingDay: postingDay
    };
};
const $397b91bd2abb6c3a$export$fc5689613a273ab4 = (parsedTarget, hostSpaceKey)=>{
    if (!parsedTarget.location) return {
        kind: 'missing-target'
    };
    const idFromTyped = $397b91bd2abb6c3a$var$extractContentIdFromTypedValue(parsedTarget.location);
    if (idFromTyped) return {
        kind: 'by-id',
        variables: {
            contentId: idFromTyped
        }
    };
    if (parsedTarget.referencedContentId) return {
        kind: 'by-id',
        variables: {
            contentId: parsedTarget.referencedContentId
        }
    };
    const rawTitle = parsedTarget.location.trim();
    if (!rawTitle) return {
        kind: 'missing-target'
    };
    const splitPageCandidate = $397b91bd2abb6c3a$var$parseSplitPageCandidate(rawTitle);
    const blogPostCandidate = $397b91bd2abb6c3a$var$parseBlogPostCandidate(rawTitle, hostSpaceKey);
    const includeRaw = !!hostSpaceKey;
    if (!includeRaw && !splitPageCandidate && !blogPostCandidate) return {
        kind: 'missing-target'
    };
    return {
        kind: 'by-title',
        variables: {
            rawSpaceKey: hostSpaceKey ?? '',
            rawTitle: rawTitle,
            includeRaw: includeRaw,
            splitSpaceKey: splitPageCandidate?.spaceKey ?? '',
            splitTitle: splitPageCandidate?.title ?? '',
            includeSplit: !!splitPageCandidate,
            blogSpaceKey: blogPostCandidate?.spaceKey ?? '',
            blogTitle: blogPostCandidate?.title ?? '',
            postingDay: blogPostCandidate?.postingDay ?? '',
            includeBlog: !!blogPostCandidate
        }
    };
};
module.exports["parseMacroTarget"] = $397b91bd2abb6c3a$export$bcd93dab64989992;
module.exports["getPageIncludeQueryTarget"] = $397b91bd2abb6c3a$export$fc5689613a273ab4;

});

parcelRegister("9hg2I", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $3WQHM = parcelRequire("3WQHM");


var $8mra2 = parcelRequire("8mra2");

const $476f3d09a54732a7$var$buildVariables = (node, context)=>{
    const macroParams = node.attrs?.parameters?.macroParams ?? {};
    const params = {
        types: macroParams['types']?.value,
        spaces: macroParams['spaces']?.value,
        labels: macroParams['labels']?.value,
        author: macroParams['author']?.value,
        max: Number(macroParams['max']?.value) || undefined
    };
    return (0, $8mra2.buildRecentlyUpdatedQueryVariables)(params, context.spaceKey ?? '');
};
const $476f3d09a54732a7$export$86adfac79e0861a1 = {
    extensionKey: 'recently-updated',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, context)=>{
        const variables = $476f3d09a54732a7$var$buildVariables(node, context);
        await (0, $wPrRK.slowQueryGuard)('recentlyUpdatedPreload', ()=>(0, $dYU3e.query)({
                query: (0, $3WQHM.default),
                variables: variables,
                context: {
                    single: true
                },
                __callerPackage__: "preload-macros"
            }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    }
};
module.exports["recentlyUpdatedPreloadHandler"] = $476f3d09a54732a7$export$86adfac79e0861a1;

});

parcelRegister("3WQHM", function(module, exports) {
/**
 * @generated SignedSource<<d93dcd7c10f7020beaca89b6f3698114>>
 * @relayHash 727c301958baf0a557d685e96bfcc728
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 70f8f49eb25e63b9c9a990b2097d7d2d64224f24bdfd36245da31052e0822ddd
const $0db13d9be330dd35$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cqlcontext"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "cql",
            "variableName": "cql"
        },
        {
            "kind": "Variable",
            "name": "cqlcontext",
            "variableName": "cqlcontext"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "url"
    }, v6 = {
        "kind": "ScalarField",
        "name": "lastModified"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "type"
    }, v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "kind": "ScalarField",
        "name": "status"
    }, v11 = {
        "kind": "ScalarField",
        "name": "key"
    }, v12 = {
        "kind": "ScalarField",
        "name": "name"
    }, v13 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v14 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ContributionStatusSummary",
                        "kind": "LinkedField",
                        "name": "lastcontributed",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "when"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "number"
    }, v16 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v17 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v18 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v19 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RecentlyUpdatedMacroQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v4 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "Space",
                                            "kind": "LinkedField",
                                            "name": "space",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ 
                                            ]
                                        },
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v19 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RecentlyUpdatedMacroQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v4 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "Space",
                                            "kind": "LinkedField",
                                            "name": "space",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v19 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "727c301958baf0a557d685e96bfcc728",
            "id": "70f8f49eb25e63b9c9a990b2097d7d2d64224f24bdfd36245da31052e0822ddd",
            "metadata": {},
            "name": "RecentlyUpdatedMacroQuery",
            "operationKind": "query",
            "text": "query RecentlyUpdatedMacroQuery($cql:String!,$cqlcontext:String!,$first:Int,$after:String){search:confluence_search(cql:$cql,cqlcontext:$cqlcontext,first:$first,after:$after){nodes{url,lastModified,content{id,type,title,status,space{key,name,id},links{webui},metadata{currentuser{lastcontributed{when}}},version{number,by{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$0db13d9be330dd35$var$node.hash = "7e6233c32402f853522988d79db44911";
var $0db13d9be330dd35$export$2e2bcd8739ae039 = $0db13d9be330dd35$var$node;
module.exports["default"] = $0db13d9be330dd35$export$2e2bcd8739ae039;

});

parcelRegister("8mra2", function(module, exports) {
const $9f74d735080597cb$export$e2092582db731ff4 = 15;
const $9f74d735080597cb$export$31a1864be1d33bad = [
    'page',
    'blogpost',
    'comment',
    'attachment',
    'whiteboard',
    'database',
    'embed',
    'folder'
];
const $9f74d735080597cb$var$TYPE_ALIASES = {
    news: 'blogpost',
    blog: 'blogpost',
    blogs: 'blogpost',
    'blog-post': 'blogpost',
    blogposts: 'blogpost',
    'blog-posts': 'blogpost',
    pages: 'page',
    comments: 'comment',
    attachments: 'attachment'
};
const $9f74d735080597cb$var$SUPPORTED_TYPES = new Set($9f74d735080597cb$export$31a1864be1d33bad);
function $9f74d735080597cb$var$isContentType(type) {
    return $9f74d735080597cb$var$SUPPORTED_TYPES.has(type);
}
function $9f74d735080597cb$var$normalizeType(rawType) {
    const normalized = $9f74d735080597cb$var$TYPE_ALIASES[rawType] ?? rawType;
    return $9f74d735080597cb$var$isContentType(normalized) ? normalized : undefined;
}
function $9f74d735080597cb$var$parseCommaSeparatedValues(value) {
    if (!value) return [];
    const parts = value.split(',');
    const result = [];
    for (const part of parts){
        const trimmed = part.trim();
        if (trimmed.length > 0) result.push(trimmed);
    }
    return result;
}
const $9f74d735080597cb$var$SPACE_SCOPE_TOKENS = {
    '@personal': 'space.type = personal',
    '@global': 'space.type != personal'
};
/**
 * CQL predicate for "every space this user can see", used for the `@all` / `*` space params.
 *
 * This MUST be an explicit predicate rather than an omitted space clause. Emitting no space
 * clause produces an unbounded CQL search that diverges from the legacy backend behaviour
 * (which resolved `@all` to the enumerated set of permitted spaces) and renders the macro as
 * an empty "No updates yet" state. See CONFCLOUD-84998.
 */ const $9f74d735080597cb$var$ALL_SPACES_CLAUSE = 'space.type in (global, personal)';
/**
 * Resolves the macro `spaces` param into a single CQL space predicate.
 *
 * Always returns a predicate: `buildCql` must never produce a query without a space clause,
 * because an unbounded search does not match the legacy macro behaviour. When the param does
 * not resolve to anything concrete (no param and no host space, or tokens that resolve away)
 * the query falls back to all spaces rather than to an unbounded search.
 */ function $9f74d735080597cb$var$resolveSpaceClause(spaces, currentSpaceKey) {
    const configuredSpaceKeys = $9f74d735080597cb$var$parseCommaSeparatedValues(spaces);
    if (configuredSpaceKeys.length === 0) return currentSpaceKey ? `space = "${currentSpaceKey}"` : $9f74d735080597cb$var$ALL_SPACES_CLAUSE;
    if (configuredSpaceKeys.includes('@all') || configuredSpaceKeys.includes('*')) return $9f74d735080597cb$var$ALL_SPACES_CLAUSE;
    const resolvedSpaceKeys = [];
    const spaceScopeClauses = new Set();
    let includeFavoriteSpaces = false;
    for (const spaceKey of configuredSpaceKeys){
        if (spaceKey === '@favorite' || spaceKey === '@favourite') {
            includeFavoriteSpaces = true;
            continue;
        }
        if ($9f74d735080597cb$var$SPACE_SCOPE_TOKENS[spaceKey]) {
            spaceScopeClauses.add($9f74d735080597cb$var$SPACE_SCOPE_TOKENS[spaceKey]);
            continue;
        }
        const resolvedSpaceKey = spaceKey === '@self' ? currentSpaceKey : spaceKey;
        if (resolvedSpaceKey) resolvedSpaceKeys.push(resolvedSpaceKey);
    }
    const clauses = [];
    if (resolvedSpaceKeys.length === 1) clauses.push(`space = "${resolvedSpaceKeys[0]}"`);
    else if (resolvedSpaceKeys.length > 1) clauses.push(`space in (${$9f74d735080597cb$var$formatQuotedCqlValues(resolvedSpaceKeys)})`);
    for (const spaceScopeClause of spaceScopeClauses)clauses.push(spaceScopeClause);
    if (includeFavoriteSpaces) clauses.push('space in (favouriteSpaces())');
    if (clauses.length === 0) // Every configured token resolved away (e.g. `@self` with no host space key). Fall back to
    // all spaces so the query still carries a space predicate.
    return $9f74d735080597cb$var$ALL_SPACES_CLAUSE;
    return clauses.length > 1 ? `(${clauses.join(' OR ')})` : clauses[0];
}
function $9f74d735080597cb$var$formatQuotedCqlValues(values) {
    return values.map((v)=>`"${v}"`).join(', ');
}
function $9f74d735080597cb$export$bbd572e80a63521b(max) {
    const parsed = Number(max);
    return Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : $9f74d735080597cb$export$e2092582db731ff4;
}
function $9f74d735080597cb$export$6a81e704675faae5(params, spaceClause) {
    const clauses = [];
    // Content types
    const typeSet = new Set();
    if (params.types) for (const part of $9f74d735080597cb$var$parseCommaSeparatedValues(String(params.types))){
        const normalizedType = $9f74d735080597cb$var$normalizeType(part.toLowerCase());
        if (normalizedType) typeSet.add(normalizedType);
    }
    else for (const t of $9f74d735080597cb$export$31a1864be1d33bad)typeSet.add(t);
    if (typeSet.size > 0) clauses.push(`type in (${[
        ...typeSet
    ].join(', ')})`);
    // Space scope — defaults to the current space
    if (spaceClause) clauses.push(spaceClause);
    // Labels
    if (params.labels) {
        const labelList = String(params.labels).split(',').map((l)=>`"${l.trim()}"`).join(', ');
        clauses.push(`label in (${labelList})`);
    }
    // Following users / contributors (author param — comma-separated account IDs)
    if (params.author) {
        const users = String(params.author).split(',').map((u)=>`"${u.trim()}"`).join(', ');
        clauses.push(`contributor in (${users})`);
    }
    return `${clauses.join(' AND ')} order by lastmodified desc`;
}
function $9f74d735080597cb$export$ae985ad2d8a37df8(params, currentSpaceKey, after = '') {
    const maxItems = $9f74d735080597cb$export$bbd572e80a63521b(params.max);
    const spaceClause = $9f74d735080597cb$var$resolveSpaceClause(params.spaces, currentSpaceKey);
    return {
        cql: $9f74d735080597cb$export$6a81e704675faae5(params, spaceClause),
        cqlcontext: '{"contentStatuses":["draft", "current"]}',
        first: maxItems,
        after: after
    };
}
module.exports["buildRecentlyUpdatedQueryVariables"] = $9f74d735080597cb$export$ae985ad2d8a37df8;

});

parcelRegister("gaqfB", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $eDO9L = parcelRequire("eDO9L");


var $6SH28 = parcelRequire("6SH28");


var $49vfa = parcelRequire("49vfa");


var $gzvFl = parcelRequire("gzvFl");


var $jvHsR = parcelRequire("jvHsR");


var $bEk7g = parcelRequire("bEk7g");

const $466aaf75a85fc8d1$export$6843d2ec6a82b03e = {
    extensionKey: 'pagetree',
    routes: [
        'view',
        'space-overview'
    ],
    preload: async (node, context)=>{
        const { rootParam: rootParam, spaceKey: spaceKey } = (0, $bEk7g.parseMacroParams)(node.attrs?.parameters?.macroParams, context.spaceKey);
        const rootType = (0, $bEk7g.parseRootType)(rootParam);
        if (!spaceKey) return;
        // Step 1: Resolve root via the appropriate query
        let homepageData;
        let ancestorData;
        let searchData;
        // All resolution queries are wrapped in slowQueryGuard so a slow
        // preload cannot hold SSR open past the configured timeout. On
        // timeout the captured `*Data` variable stays undefined, downstream
        // `resolveRootId` falls back to its safe defaults, and the renderer
        // fetches whatever it needs on the client.
        switch(rootType){
            case 'self':
                break;
            case 'title':
                if (rootParam) {
                    const pageTitle = (0, $bEk7g.parsePageTitle)(rootParam);
                    const cql = (0, $bEk7g.buildTitleSearchCql)(pageTitle, spaceKey);
                    searchData = await $466aaf75a85fc8d1$var$preloadSearchByTitle(cql);
                }
                break;
            case 'parent':
                ancestorData = await $466aaf75a85fc8d1$var$preloadAncestors(context.contentId);
                break;
            case 'home':
                homepageData = await $466aaf75a85fc8d1$var$preloadSpaceHomepage(spaceKey);
                break;
            case 'none':
                await $466aaf75a85fc8d1$var$preloadRootLevel(spaceKey);
                break;
        }
        // Derive rootId and preload its children
        const rootId = (0, $bEk7g.resolveRootId)({
            rootType: rootType,
            contentId: context.contentId,
            homepageData: homepageData,
            ancestorData: ancestorData,
            searchData: searchData
        });
        // Step 2: Fetch children + ancestors in parallel.
        // Children needs rootId, ancestors needs context.contentId — independent.
        const allTasks = [];
        if (rootId && (0, $bEk7g.needsRootChildren)(rootType)) allTasks.push($466aaf75a85fc8d1$var$preloadChildren(rootId));
        if ((0, $bEk7g.needsAncestorExpansion)(rootType)) allTasks.push($466aaf75a85fc8d1$var$preloadAncestors(context.contentId));
        if (allTasks.length > 0) await Promise.all(allTasks);
    }
};
/**
 * Preload search-by-title result for the title rootType. Returns the query data, or undefined on timeout.
 */ const $466aaf75a85fc8d1$var$preloadSearchByTitle = async (cql)=>{
    let result;
    await (0, $wPrRK.slowQueryGuard)('pageTreeSearchByTitlePreload', async ()=>{
        result = await (0, $dYU3e.query)({
            query: (0, $jvHsR.default),
            variables: {
                cql: cql
            },
            context: {
                single: true
            },
            __callerPackage__: "preload-macros"
        });
    }, (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    return result?.data;
};
/**
 * Preload space homepage for the home rootType. Returns the query data, or undefined on timeout.
 */ const $466aaf75a85fc8d1$var$preloadSpaceHomepage = async (spaceKey)=>{
    let result;
    await (0, $wPrRK.slowQueryGuard)('pageTreeSpaceHomepagePreload', async ()=>{
        result = await (0, $dYU3e.query)({
            query: (0, $49vfa.default),
            variables: {
                spaceKey: spaceKey
            },
            context: {
                single: true
            },
            __callerPackage__: "preload-macros"
        });
    }, (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    return result?.data;
};
/**
 * Preload root-level pages for the none rootType.
 */ const $466aaf75a85fc8d1$var$preloadRootLevel = (spaceKey)=>(0, $wPrRK.slowQueryGuard)('pageTreeRootLevelPreload', ()=>(0, $dYU3e.query)({
            query: (0, $gzvFl.default),
            variables: {
                spaceKey: spaceKey
            },
            context: {
                single: true
            },
            __callerPackage__: "preload-macros"
        }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
/**
 * Preload children for a page.
 */ const $466aaf75a85fc8d1$var$preloadChildren = (contentId)=>(0, $wPrRK.slowQueryGuard)('pageTreeChildrenPreload', ()=>(0, $dYU3e.query)({
            query: (0, $eDO9L.default),
            variables: {
                contentId: contentId,
                first: (0, $bEk7g.CHILDREN_PAGE_SIZE),
                after: null
            },
            context: {
                single: true
            },
            __callerPackage__: "preload-macros"
        }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
/**
 * Preload ancestor IDs for a page. Returns the query data, or undefined on timeout.
 */ const $466aaf75a85fc8d1$var$preloadAncestors = async (contentId)=>{
    let result;
    await (0, $wPrRK.slowQueryGuard)('pageTreeAncestorsPreload', async ()=>{
        result = await (0, $dYU3e.query)({
            query: (0, $6SH28.default),
            variables: {
                contentId: contentId
            },
            context: {
                single: true
            },
            __callerPackage__: "preload-macros"
        });
    }, (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    return result?.data;
};
module.exports["pagetreePreloadHandler"] = $466aaf75a85fc8d1$export$6843d2ec6a82b03e;

});

parcelRegister("eDO9L", function(module, exports) {
/**
 * @generated SignedSource<<5fb9bb2937ec97b73a42ea47b9d58e3e>>
 * @relayHash d1f76f7240783decafa55490bef87b1b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7205a6bc6cf45eb6816c5b240722b387293327e14b66466957a2a961320932d7
const $3b030073abdce2d6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "kind": "Literal",
            "name": "format",
            "value": "MILLIS"
        }
    ], v5 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "after",
                            "variableName": "after"
                        },
                        {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "first"
                        }
                    ],
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "title"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasChildren"
                                },
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "ConfluenceDate",
                                    "kind": "LinkedField",
                                    "name": "createdDate",
                                    "plural": false,
                                    "selections": v5 /*: any*/ ,
                                    "storageKey": "createdDate(format:\"MILLIS\")"
                                },
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "ConfluenceDate",
                                    "kind": "LinkedField",
                                    "name": "lastUpdatedDate",
                                    "plural": false,
                                    "selections": v5 /*: any*/ ,
                                    "storageKey": "lastUpdatedDate(format:\"MILLIS\")"
                                },
                                {
                                    "concreteType": "Map_LinkType_String",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "webui"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "PTPageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PageTreeMacroChildrenQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PageTreeMacroChildrenQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "d1f76f7240783decafa55490bef87b1b",
            "id": "7205a6bc6cf45eb6816c5b240722b387293327e14b66466957a2a961320932d7",
            "metadata": {},
            "name": "PageTreeMacroChildrenQuery",
            "operationKind": "query",
            "text": "query PageTreeMacroChildrenQuery($contentId:ID!,$first:Int,$after:String){ptpage(id:$contentId){id,children(first:$first,after:$after){nodes{id,title,hasChildren,createdDate(format:MILLIS){value},lastUpdatedDate(format:MILLIS){value},links{webui}},pageInfo{hasNextPage,endCursor}}}}"
        }
    };
}();
$3b030073abdce2d6$var$node.hash = "59283a106a3d4f2872ded3860b4892b7";
var $3b030073abdce2d6$export$2e2bcd8739ae039 = $3b030073abdce2d6$var$node;
module.exports["default"] = $3b030073abdce2d6$export$2e2bcd8739ae039;

});

parcelRegister("6SH28", function(module, exports) {
/**
 * @generated SignedSource<<6ed9797be759e375a531e38a2af48352>>
 * @relayHash 1cb037b815e517bd7984595b20d124af
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID acb8b4b0c8e9ce55d652b28f502d52dd391de7c55bdb32f248dbeb8199940cbc
const $7e0dd4f7164e5968$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "nearestAncestors",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PageTreeMacroAncestorsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PageTreeMacroAncestorsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "1cb037b815e517bd7984595b20d124af",
            "id": "acb8b4b0c8e9ce55d652b28f502d52dd391de7c55bdb32f248dbeb8199940cbc",
            "metadata": {},
            "name": "PageTreeMacroAncestorsQuery",
            "operationKind": "query",
            "text": "query PageTreeMacroAncestorsQuery($contentId:ID!){ptpage(id:$contentId){id,nearestAncestors{nodes{id}}}}"
        }
    };
}();
$7e0dd4f7164e5968$var$node.hash = "87b0f0557adb9a0866c0ecd4aae73da8";
var $7e0dd4f7164e5968$export$2e2bcd8739ae039 = $7e0dd4f7164e5968$var$node;
module.exports["default"] = $7e0dd4f7164e5968$export$2e2bcd8739ae039;

});

parcelRegister("49vfa", function(module, exports) {
/**
 * @generated SignedSource<<c76673347537b0257d7eb27040ca82b3>>
 * @relayHash c61a430f42dfefbb095b2ca84bb4127d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7a06f8ee0d26e27379e1824924505981b4e94348246f357fc7c17901ddf02d7f
const $21b326e4a95ad923$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "spaceKey"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "homepage",
        "plural": false,
        "selections": [
            v2 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PageTreeMacroSpaceHomepageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PageTreeMacroSpaceHomepageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "c61a430f42dfefbb095b2ca84bb4127d",
            "id": "7a06f8ee0d26e27379e1824924505981b4e94348246f357fc7c17901ddf02d7f",
            "metadata": {},
            "name": "PageTreeMacroSpaceHomepageQuery",
            "operationKind": "query",
            "text": "query PageTreeMacroSpaceHomepageQuery($spaceKey:String!){space(key:$spaceKey){homepage{id},id}}"
        }
    };
}();
$21b326e4a95ad923$var$node.hash = "97d54ae520df0edd2399fe104d2017bf";
var $21b326e4a95ad923$export$2e2bcd8739ae039 = $21b326e4a95ad923$var$node;
module.exports["default"] = $21b326e4a95ad923$export$2e2bcd8739ae039;

});

parcelRegister("gzvFl", function(module, exports) {
/**
 * @generated SignedSource<<b9b39b07bf56ad31c1c3d1a28791c1c9>>
 * @relayHash 423919d13d57653b2e9c3769e68f2b09
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8179a69028770ff58fa99c72360f926b70fb1edb5f40282d66611c913a793e9a
const $bd17eac6cecb59ef$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "title"
    }, v3 = {
        "kind": "ScalarField",
        "name": "hasChildren"
    }, v4 = [
        {
            "kind": "Literal",
            "name": "format",
            "value": "MILLIS"
        }
    ], v5 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v6 = {
        "args": v4 /*: any*/ ,
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdDate",
        "plural": false,
        "selections": v5 /*: any*/ ,
        "storageKey": "createdDate(format:\"MILLIS\")"
    }, v7 = {
        "args": v4 /*: any*/ ,
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "lastUpdatedDate",
        "plural": false,
        "selections": v5 /*: any*/ ,
        "storageKey": "lastUpdatedDate(format:\"MILLIS\")"
    }, v8 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v9 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "followingSiblings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "PTPageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PageTreeMacroRootLevelQuery",
            "selections": v9 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PageTreeMacroRootLevelQuery",
            "selections": v9 /*: any*/ 
        },
        "params": {
            "cacheID": "423919d13d57653b2e9c3769e68f2b09",
            "id": "8179a69028770ff58fa99c72360f926b70fb1edb5f40282d66611c913a793e9a",
            "metadata": {},
            "name": "PageTreeMacroRootLevelQuery",
            "operationKind": "query",
            "text": "query PageTreeMacroRootLevelQuery($spaceKey:String!){ptpage(spaceKey:$spaceKey){id,title,hasChildren,createdDate(format:MILLIS){value},lastUpdatedDate(format:MILLIS){value},links{webui},followingSiblings{nodes{id,title,hasChildren,createdDate(format:MILLIS){value},lastUpdatedDate(format:MILLIS){value},links{webui}},pageInfo{hasNextPage}}}}"
        }
    };
}();
$bd17eac6cecb59ef$var$node.hash = "719bdc5b722e95ed2bdf030fecc89213";
var $bd17eac6cecb59ef$export$2e2bcd8739ae039 = $bd17eac6cecb59ef$var$node;
module.exports["default"] = $bd17eac6cecb59ef$export$2e2bcd8739ae039;

});

parcelRegister("jvHsR", function(module, exports) {
/**
 * @generated SignedSource<<7ce6cc193cc37b4484da707ada8e906b>>
 * @relayHash 2eb5932fe57eda221f60bf95729cc781
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d26dc563aec2070c8c92491642682e66884032b661b2c5862a9e3c2f83bcc352
const $6c3ffceca1ec4cfc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cql"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cql",
                    "variableName": "cql"
                },
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                }
            ],
            "concreteType": "ConfluenceSearchConnection",
            "kind": "LinkedField",
            "name": "confluence_search",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceSearchResponse",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PageTreeMacroSearchByTitleQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PageTreeMacroSearchByTitleQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2eb5932fe57eda221f60bf95729cc781",
            "id": "d26dc563aec2070c8c92491642682e66884032b661b2c5862a9e3c2f83bcc352",
            "metadata": {},
            "name": "PageTreeMacroSearchByTitleQuery",
            "operationKind": "query",
            "text": "query PageTreeMacroSearchByTitleQuery($cql:String!){confluence_search(cql:$cql,first:1){nodes{content{id}}}}"
        }
    };
}();
$6c3ffceca1ec4cfc$var$node.hash = "42441e185ca1b3e501257c64db0a4892";
var $6c3ffceca1ec4cfc$export$2e2bcd8739ae039 = $6c3ffceca1ec4cfc$var$node;
module.exports["default"] = $6c3ffceca1ec4cfc$export$2e2bcd8739ae039;

});

parcelRegister("bEk7g", function(module, exports) {

var $jlIaF = parcelRequire("jlIaF");

const $26e80ddf91af379c$export$9921da6540a2b156 = (node)=>({
        id: node.id,
        title: node.title,
        hasChildren: node.hasChildren,
        url: node.links?.webui ? `${0, $jlIaF.CONTEXT_PATH}${node.links.webui}` : '',
        createdDate: node.createdDate?.value ? Number(node.createdDate.value) : undefined,
        lastModifiedDate: node.lastUpdatedDate?.value ? Number(node.lastUpdatedDate.value) : undefined
    });
// ---------------------------------------------------------------------------
// Client-side sorting
// ---------------------------------------------------------------------------
const $26e80ddf91af379c$var$naturalCompare = (a, b)=>{
    return a.localeCompare(b, undefined, {
        numeric: true,
        sensitivity: 'base'
    });
};
const $26e80ddf91af379c$export$96d07f33920abf3e = (nodes, sort, reverse)=>{
    const sorted = [
        ...nodes
    ];
    switch(sort){
        case 'bitwise':
            sorted.sort((a, b)=>a.title.localeCompare(b.title));
            break;
        case 'natural':
            sorted.sort((a, b)=>$26e80ddf91af379c$var$naturalCompare(a.title, b.title));
            break;
        case 'creation':
            sorted.sort((a, b)=>(a.createdDate || 0) - (b.createdDate || 0));
            break;
        case 'modified':
            sorted.sort((a, b)=>(a.lastModifiedDate || 0) - (b.lastModifiedDate || 0));
            break;
        case 'position':
        default:
            break;
    }
    if (reverse) sorted.reverse();
    return sorted;
};
const $26e80ddf91af379c$export$3cf9a7263d7d2d28 = 100;
const $26e80ddf91af379c$export$7db02a6ccf4cb65a = (data, sort, reverse)=>{
    const children = data?.ptpage?.children?.nodes;
    if (!children) return null;
    const nodes = [];
    for (const n of children)if (n != null) nodes.push($26e80ddf91af379c$export$9921da6540a2b156(n));
    return $26e80ddf91af379c$export$96d07f33920abf3e(nodes, sort, reverse);
};
const $26e80ddf91af379c$export$487d62996e3b3023 = async (refetchChildren, parentId, sort, reverse)=>{
    const batches = [];
    let after = null;
    let hasMore = true;
    let iteration = 0;
    while(hasMore && iteration < 100){
        const result = await refetchChildren({
            contentId: parentId,
            first: $26e80ddf91af379c$export$3cf9a7263d7d2d28,
            after: after
        });
        const children = result?.data?.ptpage?.children;
        if (!children?.nodes) break;
        batches.push(children.nodes);
        if (children.pageInfo?.hasNextPage && children.pageInfo?.endCursor !== after) after = children.pageInfo.endCursor ?? null;
        else hasMore = false;
        iteration++;
    }
    const rawNodes = batches.flat().filter((n)=>n != null);
    return $26e80ddf91af379c$export$96d07f33920abf3e(rawNodes.map($26e80ddf91af379c$export$9921da6540a2b156), sort, reverse);
};
const $26e80ddf91af379c$export$bdc9b163c4d0f3de = (value)=>{
    return value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
};
const $26e80ddf91af379c$var$isValidSort = (value)=>[
        'natural',
        'bitwise',
        'position',
        'creation',
        'modified'
    ].includes(value);
const $26e80ddf91af379c$export$66770a7e7da42ecb = (macroParams, defaultSpaceKey)=>{
    const rootParam = macroParams?.root?.value ?? null;
    const spaceKey = macroParams?.spaces?.value ?? defaultSpaceKey;
    const showExcerpt = macroParams?.excerpt?.value === 'true';
    const sortValue = macroParams?.sort?.value ?? 'position';
    const sort = $26e80ddf91af379c$var$isValidSort(sortValue) ? sortValue : 'position';
    const reverse = macroParams?.reverse?.value === 'true';
    const showSearchBox = macroParams?.searchBox?.value === 'true';
    const showExpandCollapseAll = macroParams?.expandCollapseAll?.value === 'true';
    const startDepthStr = macroParams?.startDepth?.value ?? '0';
    const startDepth = /^\d+$/.test(startDepthStr) ? parseInt(startDepthStr, 10) : 0;
    return {
        rootParam: rootParam,
        spaceKey: spaceKey,
        showExcerpt: showExcerpt,
        sort: sort,
        reverse: reverse,
        showSearchBox: showSearchBox,
        showExpandCollapseAll: showExpandCollapseAll,
        startDepth: startDepth
    };
};
const $26e80ddf91af379c$export$b364eed1315822f9 = (params)=>JSON.stringify({
        root: params.rootParam,
        spaces: params.spaceKey,
        excerpt: String(params.showExcerpt),
        sort: params.sort,
        reverse: String(params.reverse),
        searchBox: String(params.showSearchBox),
        expandCollapseAll: String(params.showExpandCollapseAll),
        startDepth: String(params.startDepth)
    });
const $26e80ddf91af379c$export$b7bc6229bead1c21 = (rootParam)=>{
    if (!rootParam) return 'home';
    const lower = rootParam.toLowerCase();
    switch(lower){
        case '@self':
            return 'self';
        case '@parent':
            return 'parent';
        case '@home':
            return 'home';
        case '@none':
            return 'none';
        default:
            return 'title';
    }
};
const $26e80ddf91af379c$export$eca7683f8ecceb76 = (data)=>data?.content?.nodes?.[0]?.macroExcerpt?.atlasDocFormat ?? undefined;
const $26e80ddf91af379c$export$a8a6626948b501bd = (data)=>data?.content?.nodes?.[0]?.body?.atlas_doc_format?.mediaToken?.token ?? undefined;
const $26e80ddf91af379c$export$31e03f73732334a0 = (data)=>{
    const rawNodes = data?.content?.nodes;
    const nodes = [];
    if (rawNodes) for (const node of rawNodes){
        if (!node?.id) continue;
        nodes.push({
            id: node.id,
            adfString: node.macroExcerpt?.atlasDocFormat ?? undefined,
            mediaToken: node.body?.atlas_doc_format?.mediaToken?.token ?? undefined
        });
    }
    const rawPageInfo = data?.content?.pageInfo;
    const pageInfo = rawPageInfo ? {
        hasNextPage: rawPageInfo.hasNextPage,
        endCursor: rawPageInfo.endCursor ?? null
    } : null;
    return {
        nodes: nodes,
        pageInfo: pageInfo
    };
};
const $26e80ddf91af379c$export$2bcabf930da035c4 = (data)=>{
    const children = data?.ptpage?.children?.nodes;
    if (!children) return [];
    const ids = [];
    for (const child of children)if (child?.id) ids.push(child.id);
    return ids;
};
const $26e80ddf91af379c$export$27ca14a7672351ca = (data)=>data?.space?.homepage?.id ?? undefined;
const $26e80ddf91af379c$export$f0abfa7ade6f050b = (data)=>data?.ptpage?.nearestAncestors?.nodes?.[0]?.id ?? undefined;
const $26e80ddf91af379c$export$af332464b727c9e9 = (data)=>data?.confluence_search?.nodes?.[0]?.content?.id ?? undefined;
const $26e80ddf91af379c$export$25828e9857936ee8 = ({ rootType: rootType, contentId: contentId, homepageData: homepageData, ancestorData: ancestorData, searchData: searchData })=>{
    switch(rootType){
        case 'self':
            return contentId;
        case 'home':
            return $26e80ddf91af379c$export$27ca14a7672351ca(homepageData);
        case 'parent':
            return $26e80ddf91af379c$export$f0abfa7ade6f050b(ancestorData);
        case 'title':
            return $26e80ddf91af379c$export$af332464b727c9e9(searchData);
        case 'none':
            return undefined;
    }
};
const $26e80ddf91af379c$export$d0cbb0149dfad6ae = (rootType)=>rootType !== 'self' && rootType !== 'parent';
const $26e80ddf91af379c$export$b38ff668c727ce06 = (rootType)=>rootType !== 'none';
const $26e80ddf91af379c$export$a802709b8af34ca = (rootParam)=>{
    const colonIndex = rootParam.indexOf(':');
    return colonIndex >= 0 ? rootParam.substring(colonIndex + 1) : rootParam;
};
const $26e80ddf91af379c$export$87777831b2e51242 = (pageTitle, spaceKey)=>{
    return `title = "${$26e80ddf91af379c$export$bdc9b163c4d0f3de(pageTitle)}" and space = "${$26e80ddf91af379c$export$bdc9b163c4d0f3de(spaceKey)}" and type = "page"`;
};
module.exports["mapPtPageNode"] = $26e80ddf91af379c$export$9921da6540a2b156;
module.exports["sortNodes"] = $26e80ddf91af379c$export$96d07f33920abf3e;
module.exports["CHILDREN_PAGE_SIZE"] = $26e80ddf91af379c$export$3cf9a7263d7d2d28;
module.exports["extractChildNodes"] = $26e80ddf91af379c$export$7db02a6ccf4cb65a;
module.exports["extractChildren"] = $26e80ddf91af379c$export$487d62996e3b3023;
module.exports["parseMacroParams"] = $26e80ddf91af379c$export$66770a7e7da42ecb;
module.exports["serializeMacroParams"] = $26e80ddf91af379c$export$b364eed1315822f9;
module.exports["parseRootType"] = $26e80ddf91af379c$export$b7bc6229bead1c21;
module.exports["extractSingleNodeAdfString"] = $26e80ddf91af379c$export$eca7683f8ecceb76;
module.exports["extractSingleNodeMediaToken"] = $26e80ddf91af379c$export$a8a6626948b501bd;
module.exports["extractBatchPage"] = $26e80ddf91af379c$export$31e03f73732334a0;
module.exports["resolveRootId"] = $26e80ddf91af379c$export$25828e9857936ee8;
module.exports["needsAncestorExpansion"] = $26e80ddf91af379c$export$d0cbb0149dfad6ae;
module.exports["needsRootChildren"] = $26e80ddf91af379c$export$b38ff668c727ce06;
module.exports["parsePageTitle"] = $26e80ddf91af379c$export$a802709b8af34ca;
module.exports["buildTitleSearchCql"] = $26e80ddf91af379c$export$87777831b2e51242;

});

parcelRegister("2jr6j", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $kVsp1 = parcelRequire("kVsp1");


var $34TzN = parcelRequire("34TzN");


var $fV8ei = parcelRequire("fV8ei");

const $9e98ea7884d33a92$export$e06ba1e8026960ca = {
    extensionKey: 'pagetreesearch',
    routes: [
        'view',
        'space-overview'
    ],
    preload: async (node, context)=>{
        const macroParams = node.attrs?.parameters?.macroParams;
        const rootPageString = (0, $fV8ei.getRootPageParam)(macroParams);
        if (rootPageString == null) return;
        const { spaceKey: spaceKey, title: title, hasExplicitSpace: hasExplicitSpace } = (0, $fV8ei.parseRootPageString)(rootPageString, context.spaceKey);
        if (!spaceKey) return;
        if (title) {
            await (0, $wPrRK.slowQueryGuard)('pageTreeSearchPreload', ()=>(0, $dYU3e.query)({
                    query: (0, $kVsp1.default),
                    variables: {
                        spaceKey: spaceKey,
                        title: title,
                        validateSpace: hasExplicitSpace
                    },
                    context: {
                        single: true
                    },
                    __callerPackage__: "preload-macros"
                }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
            return;
        }
        // Space-only validation (e.g. "MYSPACE:")
        if (hasExplicitSpace) await (0, $wPrRK.slowQueryGuard)('pageTreeSearchSpaceValidationPreload', ()=>(0, $dYU3e.query)({
                query: (0, $34TzN.default),
                variables: {
                    spaceKey: spaceKey
                },
                context: {
                    single: true
                },
                __callerPackage__: "preload-macros"
            }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    }
};
module.exports["pagetreeSearchPreloadHandler"] = $9e98ea7884d33a92$export$e06ba1e8026960ca;

});

parcelRegister("kVsp1", function(module, exports) {
/**
 * @generated SignedSource<<ac24f7a863948accfbd6d59cbbee7264>>
 * @relayHash 4484fadd23c040a81eec65da02ab0cd9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8333bcdd71159e20c0f7e8092762d02226d046fb6481936e04c0bb2aff61fca4
const $87e1172a98f7d3d7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "title"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "validateSpace"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ], v2 = [
        {
            "condition": "validateSpace",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "key",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": v1 /*: any*/ 
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "title",
                    "variableName": "title"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "page"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": v1 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePageTreeSearchQueryQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePageTreeSearchQueryQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "4484fadd23c040a81eec65da02ab0cd9",
            "id": "8333bcdd71159e20c0f7e8092762d02226d046fb6481936e04c0bb2aff61fca4",
            "metadata": {},
            "name": "usePageTreeSearchQueryQuery",
            "operationKind": "query",
            "text": "query usePageTreeSearchQueryQuery($spaceKey:String!,$title:String!,$validateSpace:Boolean!){space(key:$spaceKey)@include(if:$validateSpace){id},content(spaceKey:$spaceKey,title:$title,type:\"page\"){nodes{id}}}"
        }
    };
}();
$87e1172a98f7d3d7$var$node.hash = "1be6e27ce1b78f4f22a3ff6689bbf9e4";
var $87e1172a98f7d3d7$export$2e2bcd8739ae039 = $87e1172a98f7d3d7$var$node;
module.exports["default"] = $87e1172a98f7d3d7$export$2e2bcd8739ae039;

});

parcelRegister("34TzN", function(module, exports) {
/**
 * @generated SignedSource<<71bcfe57e49ffa98a90c029ce20a0c42>>
 * @relayHash a2a71f8c82ac5eef37dab68dd9909961
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1e18736f7c82cd2662cfe968df89a26d8a8dd52311595737ad8cf4818f4899dc
const $3a566bea7c41a78b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceValidationQueryQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceValidationQueryQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "a2a71f8c82ac5eef37dab68dd9909961",
            "id": "1e18736f7c82cd2662cfe968df89a26d8a8dd52311595737ad8cf4818f4899dc",
            "metadata": {},
            "name": "useSpaceValidationQueryQuery",
            "operationKind": "query",
            "text": "query useSpaceValidationQueryQuery($spaceKey:String!){space(key:$spaceKey){id}}"
        }
    };
}();
$3a566bea7c41a78b$var$node.hash = "7638ca6f03f75527639ed0545762f27e";
var $3a566bea7c41a78b$export$2e2bcd8739ae039 = $3a566bea7c41a78b$var$node;
module.exports["default"] = $3a566bea7c41a78b$export$2e2bcd8739ae039;

});

parcelRegister("fV8ei", function(module, exports) {
/**
 * Extracts the raw `rootPage` macro parameter value, supporting all known
 * legacy parameter aliases (`rootPage`, `rootpage`, `'0'`).
 *
 * Returns `undefined` when no `rootPage` parameter is set.
 */ const $2efd9995ee26a8d7$export$7e7a804114e88dad = (macroParams)=>{
    if (!macroParams) return undefined;
    return macroParams.rootPage?.value ?? macroParams.rootpage?.value ?? macroParams['0']?.value;
};
const $2efd9995ee26a8d7$export$d0fe7d7e2f2da886 = (rootPageString, defaultSpaceKey)=>{
    const delimiterPos = rootPageString.indexOf(':');
    if (delimiterPos > -1) {
        const rawSpaceKey = rootPageString.substring(0, delimiterPos);
        const spaceKey = rawSpaceKey || defaultSpaceKey;
        const title = rootPageString.substring(delimiterPos + 1);
        return {
            spaceKey: spaceKey,
            title: title,
            hasExplicitSpace: Boolean(rawSpaceKey)
        };
    }
    return {
        spaceKey: defaultSpaceKey,
        title: rootPageString,
        hasExplicitSpace: false
    };
};
module.exports["getRootPageParam"] = $2efd9995ee26a8d7$export$7e7a804114e88dad;
module.exports["parseRootPageString"] = $2efd9995ee26a8d7$export$d0fe7d7e2f2da886;

});

parcelRegister("j9Zer", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $xwvlW = parcelRequire("xwvlW");


var $cBlwX = parcelRequire("cBlwX");


var $bWsrO = parcelRequire("bWsrO");


var $dAlan = parcelRequire("dAlan");

/**
 * Resolves a `spaceKey` to its `spaceId` by preloading the popular-labels
 * macro's own space-id query. This is the same query (`space(key:) { id }`)
 * that `usePopularLabelsDataForSpace` runs on the client, so the response
 * warms the same Apollo cache entry the renderer reads from.
 *
 * Returns `null` when the space cannot be resolved.
 */ const $c34d9e9634b09e90$var$preloadSpaceId = async (spaceKey)=>{
    // Wrap in slowQueryGuard so a slow preload cannot hold SSR open past
    // the configured timeout. We capture the underlying query result via a
    // closure: if the guard times out the closure variable stays undefined
    // and we return null, which causes the labels preload to be skipped —
    // the renderer will fetch on the client.
    let result;
    await (0, $wPrRK.slowQueryGuard)('popularLabelsSpaceIdPreload', async ()=>{
        result = await (0, $dYU3e.query)({
            query: (0, $dAlan.default),
            variables: {
                spaceKey: spaceKey
            },
            context: {
                single: true
            },
            __callerPackage__: "preload-macros"
        });
    }, (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    return result?.data?.space?.id ?? null;
};
const $c34d9e9634b09e90$export$b9e25e62a1057304 = {
    extensionKey: 'popular-labels',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, context)=>{
        try {
            const { cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
            if (!cloudId) return;
            const macroParams = node.attrs?.parameters?.macroParams;
            // Resolve the legacy `'currentSpace()'` sentinel against the host
            // page's space key before issuing the space-id lookup, so the
            // preloaded space-id cache entry matches the renderer's lookup.
            const spaceKeyParam = (0, $cBlwX.resolveSpaceKey)(macroParams?.spaceKey?.value, context.spaceKey);
            let spaceId = null;
            if (spaceKeyParam) {
                spaceId = await $c34d9e9634b09e90$var$preloadSpaceId(spaceKeyParam);
                if (!spaceId) // SpaceKey didn't resolve — skip preloading the labels query rather
                // than warming the wrong (global) scope. The renderer will surface
                // the same error on the client.
                return;
            }
            const variables = {
                cloudId: cloudId,
                first: (0, $cBlwX.parseCount)(macroParams?.count?.value),
                style: (0, $cBlwX.toStyleEnum)((0, $cBlwX.parseStyle)(macroParams?.style?.value)),
                spaceId: spaceId
            };
            await (0, $wPrRK.slowQueryGuard)('popularLabelsPreload', ()=>(0, $dYU3e.query)({
                    query: (0, $bWsrO.default),
                    variables: variables,
                    context: {
                        single: true
                    },
                    __callerPackage__: "preload-macros"
                }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
        } catch  {
            // Preloading is best-effort cache warming. Ignore failures here and
            // let the renderer perform the query in its normal error-handled path.
            return;
        }
    }
};
module.exports["popularLabelsPreloadHandler"] = $c34d9e9634b09e90$export$b9e25e62a1057304;

});

parcelRegister("cBlwX", function(module, exports) {
const $1f71c16b1032d2d5$export$72344c9fa45ae2c1 = 100;
const $1f71c16b1032d2d5$export$a3d4695a56a4eb21 = (value)=>{
    if (!value) return $1f71c16b1032d2d5$export$72344c9fa45ae2c1;
    const parsed = parseInt(value, 10);
    return isNaN(parsed) || parsed <= 0 ? $1f71c16b1032d2d5$export$72344c9fa45ae2c1 : parsed;
};
const $1f71c16b1032d2d5$export$e13dc740254f53d7 = (value)=>{
    return value === 'heatmap' ? 'heatmap' : 'list';
};
const $1f71c16b1032d2d5$export$70583ee990b45c2f = (style)=>{
    return style === 'heatmap' ? 'HEATMAP' : 'LIST';
};
const $1f71c16b1032d2d5$export$f8e62856e51f4d9b = 'currentSpace()';
const $1f71c16b1032d2d5$export$95cd40c60becde49 = (rawSpaceKey, currentSpaceKey)=>{
    if (!rawSpaceKey) return undefined;
    if (rawSpaceKey === $1f71c16b1032d2d5$export$f8e62856e51f4d9b) return currentSpaceKey ?? rawSpaceKey;
    return rawSpaceKey;
};
module.exports["parseCount"] = $1f71c16b1032d2d5$export$a3d4695a56a4eb21;
module.exports["parseStyle"] = $1f71c16b1032d2d5$export$e13dc740254f53d7;
module.exports["toStyleEnum"] = $1f71c16b1032d2d5$export$70583ee990b45c2f;
module.exports["resolveSpaceKey"] = $1f71c16b1032d2d5$export$95cd40c60becde49;

});

parcelRegister("bWsrO", function(module, exports) {
/**
 * @generated SignedSource<<1bea52058c65965280e667d93731c507>>
 * @relayHash e0424719155ec546121f256079f01fd9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a05f556780430a9c3e9c36d02e6fcc5b4a00cb66378101a7ba963d0351ba14e5
const $08d54037c47f542d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "style"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "spaceId",
                    "variableName": "spaceId"
                },
                {
                    "kind": "Variable",
                    "name": "style",
                    "variableName": "style"
                }
            ],
            "concreteType": "ConfluencePopularLabelEntryConnection",
            "kind": "LinkedField",
            "name": "confluence_popularLabelsMacro",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluencePopularLabelEntry",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "rank"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "labelId"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePopularLabelsDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePopularLabelsDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "e0424719155ec546121f256079f01fd9",
            "id": "a05f556780430a9c3e9c36d02e6fcc5b4a00cb66378101a7ba963d0351ba14e5",
            "metadata": {},
            "name": "usePopularLabelsDataQuery",
            "operationKind": "query",
            "text": "query usePopularLabelsDataQuery($cloudId:ID!,$first:Int,$spaceId:ID,$style:ConfluencePopularLabelStyle){confluence_popularLabelsMacro(cloudId:$cloudId,first:$first,spaceId:$spaceId,style:$style){nodes{name,rank,labelId}}}"
        }
    };
}();
$08d54037c47f542d$var$node.hash = "a1e70e0ea0c7fdc30bd20e4d9ca0b0e8";
var $08d54037c47f542d$export$2e2bcd8739ae039 = $08d54037c47f542d$var$node;
module.exports["default"] = $08d54037c47f542d$export$2e2bcd8739ae039;

});

parcelRegister("dAlan", function(module, exports) {
/**
 * @generated SignedSource<<ced0a6739432a230108889f4d0e09538>>
 * @relayHash 41fee47bcd447ee8e96835308a5a4f99
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cd95adfed4d8357af09a9ad201ca4d15932c64b4fa418a1b4a4c2e557e12c551
const $566340bccba941cc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePopularLabelsDataSpaceIdQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePopularLabelsDataSpaceIdQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "41fee47bcd447ee8e96835308a5a4f99",
            "id": "cd95adfed4d8357af09a9ad201ca4d15932c64b4fa418a1b4a4c2e557e12c551",
            "metadata": {},
            "name": "usePopularLabelsDataSpaceIdQuery",
            "operationKind": "query",
            "text": "query usePopularLabelsDataSpaceIdQuery($spaceKey:String){space(key:$spaceKey){id}}"
        }
    };
}();
$566340bccba941cc$var$node.hash = "d5968c7370aba3bd3a9089e4721bb508";
var $566340bccba941cc$export$2e2bcd8739ae039 = $566340bccba941cc$var$node;
module.exports["default"] = $566340bccba941cc$export$2e2bcd8739ae039;

});

parcelRegister("eOfv4", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $30F7c = parcelRequire("30F7c");

const $ab0a577528facf1f$export$a26d4f508ed8cd67 = {
    extensionKey: 'profile-picture',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, _context)=>{
        try {
            const userId = node.attrs?.parameters?.macroParams?.User?.value;
            if (!userId) return;
            const variables = {
                userId: userId
            };
            await (0, $wPrRK.slowQueryGuard)('profilePicturePreload', ()=>(0, $dYU3e.query)({
                    query: (0, $30F7c.default),
                    variables: variables,
                    context: {
                        single: true
                    },
                    __callerPackage__: "preload-macros"
                }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
        } catch  {
            // Preloading is best-effort cache warming. Ignore failures here and
            // let the renderer perform the query in its normal error-handled path.
            return;
        }
    }
};
module.exports["profilePicturePreloadHandler"] = $ab0a577528facf1f$export$a26d4f508ed8cd67;

});

parcelRegister("30F7c", function(module, exports) {
/**
 * @generated SignedSource<<20904bfa8cc8894f1f41fd4c23de4797>>
 * @relayHash 98854a5bccd4ea4b4cf3114c1778a63a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f4c165001740b0572461dd93e231b3425c566a844e008bc410f5e0b3630c4f05
const $082db8f111d4d391$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "value"
        },
        {
            "kind": "ScalarField",
            "name": "isPrimary"
        }
    ], v2 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "userId"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": v1 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserEmail",
                    "kind": "LinkedField",
                    "name": "emails",
                    "plural": true,
                    "selections": v1 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "isActive"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useProfileInfoUserContextQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useProfileInfoUserContextQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "98854a5bccd4ea4b4cf3114c1778a63a",
            "id": "f4c165001740b0572461dd93e231b3425c566a844e008bc410f5e0b3630c4f05",
            "metadata": {},
            "name": "useProfileInfoUserContextQuery",
            "operationKind": "query",
            "text": "query useProfileInfoUserContextQuery($userId:ID){user:confluence_atlassianUser(id:$userId){id,photos{value,isPrimary},displayName,emails{value,isPrimary},title,isActive}}"
        }
    };
}();
$082db8f111d4d391$var$node.hash = "cd83aff11b55f855ecd3361dedc3552d";
var $082db8f111d4d391$export$2e2bcd8739ae039 = $082db8f111d4d391$var$node;
module.exports["default"] = $082db8f111d4d391$export$2e2bcd8739ae039;

});

parcelRegister("hwhSw", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $30F7c = parcelRequire("30F7c");

const $f988674c040264f3$export$ba7f4f786ca1288f = {
    extensionKey: 'profile',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, _context)=>{
        try {
            const userId = node.attrs?.parameters?.macroParams?.user?.value;
            if (!userId) return;
            const variables = {
                userId: userId
            };
            await (0, $wPrRK.slowQueryGuard)('userProfilePreload', ()=>(0, $dYU3e.query)({
                    query: (0, $30F7c.default),
                    variables: variables,
                    context: {
                        single: true
                    },
                    __callerPackage__: "preload-macros"
                }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
        } catch  {
            // Preloading is best-effort cache warming. Ignore failures here and
            // let the renderer perform the query in its normal error-handled path.
            return;
        }
    }
};
module.exports["userProfilePreloadHandler"] = $f988674c040264f3$export$ba7f4f786ca1288f;

});

parcelRegister("aEHCA", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $15svH = parcelRequire("15svH");


var $jqlpB = parcelRequire("jqlpB");

const $07b632e1e0c660f3$var$buildVariables = (contentId, parsed)=>{
    return (0, $jqlpB.buildViewPdfQueryVariables)({
        contentId: contentId,
        pageName: parsed.pageName,
        spaceKey: parsed.spaceKey,
        date: parsed.date
    });
};
const $07b632e1e0c660f3$export$f9e67083aa63b898 = {
    extensionKey: 'viewpdf',
    routes: [
        'view',
        'space-overview',
        'edit'
    ],
    preload: async (node, context)=>{
        const macroParams = node.attrs?.parameters?.macroParams;
        const parsed = (0, $jqlpB.parseViewPdfMacroParams)(macroParams);
        if (!parsed.attachmentName) return;
        const variables = $07b632e1e0c660f3$var$buildVariables(context.contentId, parsed);
        await (0, $wPrRK.slowQueryGuard)('viewPdfPreload', ()=>(0, $dYU3e.query)({
                query: (0, $15svH.default),
                variables: variables,
                context: {
                    single: true
                },
                __callerPackage__: "preload-macros"
            }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    }
};
module.exports["viewPdfPreloadHandler"] = $07b632e1e0c660f3$export$f9e67083aa63b898;

});

parcelRegister("15svH", function(module, exports) {
/**
 * @generated SignedSource<<c94c3f7a76f8371f5cb62396b720ee7a>>
 * @relayHash 814697115f3f596cbb9c38ce14be1f85
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fb4b2b513a3e28c226362fa46e7d11cc5508513505b03509f58942665c918c38
const $6ba83d52bb6ac0cf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "postingDay"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "title"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "type"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Variable",
            "name": "postingDay",
            "variableName": "postingDay"
        },
        {
            "kind": "Variable",
            "name": "spaceKey",
            "variableName": "spaceKey"
        },
        {
            "kind": "Variable",
            "name": "status",
            "variableName": "contentStatus"
        },
        {
            "kind": "Variable",
            "name": "title",
            "variableName": "title"
        },
        {
            "kind": "Variable",
            "name": "type",
            "variableName": "type"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 250
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "concreteType": "KeyValueHierarchyMap",
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useViewPdfDataQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "args": v8 /*: any*/ ,
                                            "concreteType": "PaginatedContentList",
                                            "kind": "LinkedField",
                                            "name": "attachments",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Content",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "attachments(first:250)"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useViewPdfDataQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "args": v8 /*: any*/ ,
                                            "concreteType": "PaginatedContentList",
                                            "kind": "LinkedField",
                                            "name": "attachments",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Content",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "attachments(first:250)"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "814697115f3f596cbb9c38ce14be1f85",
            "id": "fb4b2b513a3e28c226362fa46e7d11cc5508513505b03509f58942665c918c38",
            "metadata": {},
            "name": "useViewPdfDataQuery",
            "operationKind": "query",
            "text": "query useViewPdfDataQuery($contentId:ID,$contentStatus:[String],$spaceKey:String,$title:String,$type:String,$postingDay:String){content(id:$contentId,status:$contentStatus,spaceKey:$spaceKey,title:$title,type:$type,postingDay:$postingDay){edges{node{id,attachments(first:250){nodes{title,extensions{key,value},id}}}}}}"
        }
    };
}();
$6ba83d52bb6ac0cf$var$node.hash = "20d975cc714dfdf1087101ddcb9c164b";
var $6ba83d52bb6ac0cf$export$2e2bcd8739ae039 = $6ba83d52bb6ac0cf$var$node;
module.exports["default"] = $6ba83d52bb6ac0cf$export$2e2bcd8739ae039;

});

parcelRegister("jqlpB", function(module, exports) {
const $3500f1c8d39c6386$export$ac4d1f313c318334 = '100%';
const $3500f1c8d39c6386$export$7ce912260e18e60d = '650px';
const $3500f1c8d39c6386$export$c3becee1470bf9a7 = (size)=>{
    const numericSize = size.replace(/[^\d.]+/g, '');
    if (size.endsWith('%')) return `${numericSize}%`;
    return `${numericSize}px`;
};
const $3500f1c8d39c6386$export$3082a5716eb987e9 = (rawWidth, rawHeight)=>({
        width: rawWidth ? $3500f1c8d39c6386$export$c3becee1470bf9a7(rawWidth) : $3500f1c8d39c6386$export$ac4d1f313c318334,
        height: rawHeight ? $3500f1c8d39c6386$export$c3becee1470bf9a7(rawHeight) : $3500f1c8d39c6386$export$7ce912260e18e60d
    });
const $3500f1c8d39c6386$export$c86b59de1acee041 = (rawPageParam)=>{
    if (!rawPageParam) return {
        pageName: null,
        spaceKey: null,
        date: null
    };
    const pageParam = rawPageParam.trim();
    if (!pageParam) return {
        pageName: null,
        spaceKey: null,
        date: null
    };
    const firstColon = pageParam.indexOf(':');
    const spacePart = firstColon !== -1 ? pageParam.slice(0, firstColon) || null : null;
    const titlePart = firstColon !== -1 ? pageParam.slice(firstColon + 1) : pageParam;
    let pageName = titlePart;
    let date = null;
    const blogMatch = titlePart.match(/^\/(\d{4})\/(\d{2})\/(\d{2})\/(.+)$/);
    if (blogMatch) {
        const [, year, month, day, title] = blogMatch;
        date = `${month}/${day}/${year}`;
        pageName = title;
    }
    return {
        pageName: pageName || null,
        spaceKey: spacePart || null,
        date: date
    };
};
const $3500f1c8d39c6386$export$6cc41227155528f2 = (macroParams)=>{
    const attachmentName = macroParams?.name?.value ?? macroParams?.['']?.value ?? macroParams?.defaultParameterValue?.value ?? null;
    const decodedPage = $3500f1c8d39c6386$export$c86b59de1acee041(macroParams?.page?.value ?? null);
    const { width: viewerWidth, height: viewerHeight } = $3500f1c8d39c6386$export$3082a5716eb987e9(macroParams?.width?.value, macroParams?.height?.value);
    return {
        attachmentName: attachmentName,
        pageName: decodedPage.pageName,
        spaceKey: macroParams?.space?.value ?? decodedPage.spaceKey,
        date: macroParams?.date?.value ?? decodedPage.date,
        viewerWidth: viewerWidth,
        viewerHeight: viewerHeight
    };
};
const $3500f1c8d39c6386$export$a35ba7e9630557a6 = (date)=>{
    const parts = date.split('/');
    if (parts.length !== 3) return undefined;
    const [month, day, year] = parts;
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};
const $3500f1c8d39c6386$export$3ac25d3edc0c1d36 = ({ contentId: contentId, pageName: pageName, spaceKey: spaceKey, date: date })=>{
    const normalizedPageName = pageName?.trim() || null;
    if (normalizedPageName) {
        const variables = {
            contentStatus: [
                'current'
            ],
            title: normalizedPageName,
            type: date ? 'blogpost' : 'page'
        };
        if (spaceKey) variables.spaceKey = spaceKey;
        if (date) variables.postingDay = $3500f1c8d39c6386$export$a35ba7e9630557a6(date);
        return variables;
    }
    return {
        contentId: contentId ?? undefined,
        contentStatus: [
            'current'
        ]
    };
};
module.exports["parseViewPdfMacroParams"] = $3500f1c8d39c6386$export$6cc41227155528f2;
module.exports["buildViewPdfQueryVariables"] = $3500f1c8d39c6386$export$3ac25d3edc0c1d36;

});

parcelRegister("jl68F", function(module, exports) {

var $2zpUM = parcelRequire("2zpUM");


var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $brX63 = parcelRequire("brX63");


var $1HZKG = parcelRequire("1HZKG");

const $26467d9acf308665$var$buildVariables = (contentId, parsed)=>{
    return (0, $2zpUM.buildOfficeAttachmentQueryVariables)({
        contentId: contentId,
        pageName: parsed.pageName,
        spaceKey: parsed.spaceKey,
        date: parsed.date
    });
};
const $26467d9acf308665$export$32e4a0c912678b42 = {
    extensionKey: 'viewxls',
    // viewxls is rendered in view, space-overview, and edit routes.
    // It is not rendered in live (live edit) routes.
    routes: [
        'view',
        'space-overview',
        'edit'
    ],
    preload: async (node, context)=>{
        const macroParams = node.attrs?.parameters?.macroParams;
        const parsed = (0, $1HZKG.parseViewXlsMacroParams)(macroParams);
        if (!parsed.attachmentName) return;
        const variables = $26467d9acf308665$var$buildVariables(context.contentId, parsed);
        await (0, $wPrRK.slowQueryGuard)('viewXlsPreload', ()=>(0, $dYU3e.query)({
                query: (0, $brX63.default),
                variables: variables,
                context: {
                    single: true
                },
                __callerPackage__: "preload-macros"
            }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    }
};
module.exports["viewXlsPreloadHandler"] = $26467d9acf308665$export$32e4a0c912678b42;

});

parcelRegister("2zpUM", function(module, exports) {
/**
 * Shared parameter parsing utilities for Office Connector macros
 * (viewxls, viewpdf, etc.).
 *
 * These utilities implement the same logic as the legacy ConverterMacro.java
 * backend and are shared across all office file macro packages.
 */ const $380d6d40e78d9881$export$80abf3a79956e7b0 = (size)=>{
    const numericSize = size.replace(/[^\d.]+/g, '');
    if (!numericSize) return size;
    if (size.endsWith('%')) return `${numericSize}%`;
    return `${numericSize}px`;
};
const $380d6d40e78d9881$export$3082a5716eb987e9 = (rawWidth, rawHeight, defaultWidth, defaultHeight)=>({
        width: rawWidth ? $380d6d40e78d9881$export$80abf3a79956e7b0(rawWidth) : defaultWidth,
        height: rawHeight ? $380d6d40e78d9881$export$80abf3a79956e7b0(rawHeight) : defaultHeight
    });
const $380d6d40e78d9881$export$c86b59de1acee041 = (rawPageParam)=>{
    if (!rawPageParam) return {
        pageName: null,
        spaceKey: null,
        date: null
    };
    const pageParam = rawPageParam.trim();
    if (!pageParam) return {
        pageName: null,
        spaceKey: null,
        date: null
    };
    const firstColon = pageParam.indexOf(':');
    const spacePart = firstColon !== -1 ? pageParam.slice(0, firstColon) || null : null;
    const titlePart = firstColon !== -1 ? pageParam.slice(firstColon + 1) : pageParam;
    let pageName = titlePart;
    let date = null;
    const datePathMatch = titlePart.match(/^\/(\d{4})\/(\d{2})\/(\d{2})\/(.+)$/);
    if (datePathMatch) {
        const [, year, month, day, title] = datePathMatch;
        date = `${month}/${day}/${year}`;
        pageName = title;
    }
    return {
        pageName: pageName || null,
        spaceKey: spacePart || null,
        date: date
    };
};
const $380d6d40e78d9881$export$a35ba7e9630557a6 = (date)=>{
    const parts = date.split('/');
    if (parts.length !== 3) return undefined;
    const [month, day, year] = parts;
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};
const $380d6d40e78d9881$export$b7798d9ac552e5c0 = ({ contentId: contentId, pageName: pageName, spaceKey: spaceKey, date: date })=>{
    const normalizedPageName = pageName?.trim() || null;
    if (normalizedPageName) {
        const formattedDay = date ? $380d6d40e78d9881$export$a35ba7e9630557a6(date) : undefined;
        const variables = {
            contentStatus: [
                'current'
            ],
            title: normalizedPageName,
            type: formattedDay ? 'blogpost' : 'page'
        };
        if (spaceKey) variables.spaceKey = spaceKey;
        if (formattedDay) variables.postingDay = formattedDay;
        return variables;
    }
    return {
        contentId: contentId ?? undefined,
        contentStatus: [
            'current'
        ]
    };
};
module.exports["normalizeSizeParam"] = $380d6d40e78d9881$export$80abf3a79956e7b0;
module.exports["decodeLegacyMacroPageParam"] = $380d6d40e78d9881$export$c86b59de1acee041;
module.exports["buildOfficeAttachmentQueryVariables"] = $380d6d40e78d9881$export$b7798d9ac552e5c0;

});

parcelRegister("brX63", function(module, exports) {
/**
 * @generated SignedSource<<0c96f10d3264116bac575c1acf76ab2d>>
 * @relayHash 58b70ecccd9c88d5a0564eb4bb467f0c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f107b9eb0ae2e74b81fe44293a6d3feba92cdbd0e0f682d00960139c671adfdf
const $3792358011f8aa38$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "postingDay"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "title"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "type"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Variable",
            "name": "postingDay",
            "variableName": "postingDay"
        },
        {
            "kind": "Variable",
            "name": "spaceKey",
            "variableName": "spaceKey"
        },
        {
            "kind": "Variable",
            "name": "status",
            "variableName": "contentStatus"
        },
        {
            "kind": "Variable",
            "name": "title",
            "variableName": "title"
        },
        {
            "kind": "Variable",
            "name": "type",
            "variableName": "type"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 250
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "concreteType": "KeyValueHierarchyMap",
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useViewXlsDataQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "args": v8 /*: any*/ ,
                                            "concreteType": "PaginatedContentList",
                                            "kind": "LinkedField",
                                            "name": "attachments",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Content",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "attachments(first:250)"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useViewXlsDataQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "args": v8 /*: any*/ ,
                                            "concreteType": "PaginatedContentList",
                                            "kind": "LinkedField",
                                            "name": "attachments",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Content",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "attachments(first:250)"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "58b70ecccd9c88d5a0564eb4bb467f0c",
            "id": "f107b9eb0ae2e74b81fe44293a6d3feba92cdbd0e0f682d00960139c671adfdf",
            "metadata": {},
            "name": "useViewXlsDataQuery",
            "operationKind": "query",
            "text": "query useViewXlsDataQuery($contentId:ID,$contentStatus:[String],$spaceKey:String,$title:String,$type:String,$postingDay:String){content(id:$contentId,status:$contentStatus,spaceKey:$spaceKey,title:$title,type:$type,postingDay:$postingDay){edges{node{id,attachments(first:250){nodes{title,extensions{key,value},id}}}}}}"
        }
    };
}();
$3792358011f8aa38$var$node.hash = "af1ae137898ad1c9b71f1f894c3f69de";
var $3792358011f8aa38$export$2e2bcd8739ae039 = $3792358011f8aa38$var$node;
module.exports["default"] = $3792358011f8aa38$export$2e2bcd8739ae039;

});

parcelRegister("1HZKG", function(module, exports) {

var $2zpUM = parcelRequire("2zpUM");

const $992f412cd97d28ae$var$DEFAULT_MEDIA_VIEWER_WIDTH = '95%';
const $992f412cd97d28ae$var$DEFAULT_MEDIA_VIEWER_HEIGHT = '650px';
const $992f412cd97d28ae$var$DEFAULT_HTML_VIEWER_WIDTH = '100%';
const $992f412cd97d28ae$var$DEFAULT_HTML_VIEWER_HEIGHT = '650px';
const $992f412cd97d28ae$export$eb48810096db92d8 = (macroParams)=>{
    const attachmentName = macroParams?.name?.value ?? macroParams?.['']?.value ?? macroParams?.defaultParameterValue?.value ?? null;
    const decodedPage = (0, $2zpUM.decodeLegacyMacroPageParam)(macroParams?.page?.value ?? null);
    const rawWidth = macroParams?.width?.value;
    const rawHeight = macroParams?.height?.value;
    return {
        attachmentName: attachmentName,
        pageName: decodedPage.pageName,
        spaceKey: macroParams?.space?.value ?? decodedPage.spaceKey,
        date: macroParams?.date?.value ?? decodedPage.date,
        mediaViewerWidth: rawWidth ? (0, $2zpUM.normalizeSizeParam)(rawWidth) : $992f412cd97d28ae$var$DEFAULT_MEDIA_VIEWER_WIDTH,
        mediaViewerHeight: rawHeight ? (0, $2zpUM.normalizeSizeParam)(rawHeight) : $992f412cd97d28ae$var$DEFAULT_MEDIA_VIEWER_HEIGHT,
        htmlViewerWidth: rawWidth ? (0, $2zpUM.normalizeSizeParam)(rawWidth) : $992f412cd97d28ae$var$DEFAULT_HTML_VIEWER_WIDTH,
        htmlViewerHeight: rawHeight ? (0, $2zpUM.normalizeSizeParam)(rawHeight) : $992f412cd97d28ae$var$DEFAULT_HTML_VIEWER_HEIGHT
    };
};
const $992f412cd97d28ae$export$e5fbc944c6f94589 = (filename)=>{
    const dotIdx = filename.lastIndexOf('.');
    if (dotIdx === -1) return false;
    return filename.substring(dotIdx + 1).toLowerCase().startsWith('xls');
};
const $992f412cd97d28ae$export$184444e10bf35293 = (filename)=>{
    if (filename.length > 35) return `${filename.substring(0, 10)}...${filename.substring(filename.length - 15)}`;
    return filename;
};
module.exports["parseViewXlsMacroParams"] = $992f412cd97d28ae$export$eb48810096db92d8;
module.exports["isExcelFile"] = $992f412cd97d28ae$export$e5fbc944c6f94589;
module.exports["truncateFileName"] = $992f412cd97d28ae$export$184444e10bf35293;

});

parcelRegister("ivpnt", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $xwvlW = parcelRequire("xwvlW");


var $ei8Ok = parcelRequire("ei8Ok");


var $rPmsQ = parcelRequire("rPmsQ");


var $fzKPX = parcelRequire("fzKPX");

/**
 * Splits the spaces macro param into two buckets at preload time, mirroring
 * the runtime hook's logic so the Apollo cache key matches exactly:
 *
 * - spaceIds: tokens (@self, currentSpace()) and numeric IDs resolved
 *   synchronously. At preload time there is no current-space context so tokens
 *   are dropped (toLongIds with undefined currentSpaceId skips them).
 * - spaceKeys: human-readable keys (e.g. "ENG") passed directly to the AGG
 *   query for server-side resolution (InlineTasksByMetadata.spaceKeys).
 *
 * Falls back to the context spaceKey when no explicit spaces are provided,
 * mirroring the "current page's space" default used at runtime.
 */ const $20c66e73a45f79d8$var$resolveSpaceFilter = (spacesParam, contextSpaceKey)=>{
    if (spacesParam) {
        const parts = (0, $fzKPX.parseCommaSeparatedValues)(spacesParam) ?? [];
        const spaceIds = (0, $fzKPX.toLongIds)(parts, undefined);
        const spaceKeys = parts.filter((value)=>value !== (0, $fzKPX.CURRENT_SPACE_TOKEN) && value !== (0, $fzKPX.SELF_SPACE_TOKEN) && !/^\d+$/.test(value.startsWith('~') ? value.slice(1) : value));
        if (spaceIds.length || spaceKeys.length) return {
            spaceIds: spaceIds,
            spaceKeys: spaceKeys
        };
    }
    // Fall back to the current space from context when no explicit spaces provided.
    const contextSpaceId = Number.parseInt(contextSpaceKey, 10);
    if (!Number.isNaN(contextSpaceId)) return {
        spaceIds: [
            contextSpaceId
        ],
        spaceKeys: []
    };
    return {
        spaceIds: [],
        spaceKeys: []
    };
};
const $20c66e73a45f79d8$export$536478985aace428 = {
    extensionKey: 'tasks-report-macro',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, context)=>{
        try {
            const { cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
            if (!cloudId) return;
            const macroParams = node.attrs?.parameters?.macroParams;
            const params = (0, $rPmsQ.parseMacroParams)(macroParams);
            const { spaceIds: spaceIds, spaceKeys: spaceKeys } = $20c66e73a45f79d8$var$resolveSpaceFilter(params.spaces, context.spaceKey);
            if (!spaceIds.length && !spaceKeys.length) return;
            // Keep preload variables identical to runtime so Apollo cache keys match.
            const taskQuery = (0, $fzKPX.buildTaskQueryMetadata)(params, spaceIds, spaceKeys);
            await (0, $wPrRK.slowQueryGuard)('tasksReportPreload', ()=>(0, $dYU3e.query)({
                    query: (0, $ei8Ok.GetTasksReportQuery),
                    variables: {
                        taskQuery: taskQuery,
                        cloudId: cloudId
                    },
                    context: {
                        single: true
                    },
                    __callerPackage__: "preload-macros"
                }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
        } catch  {
            return;
        }
    }
};
module.exports["tasksReportPreloadHandler"] = $20c66e73a45f79d8$export$536478985aace428;

});

parcelRegister("ei8Ok", function(module, exports) {

var $hJ6Qq = parcelRequire("hJ6Qq");

const $fad24ea7634a5491$export$19eb1cc447563b7 = (0, $hJ6Qq.default);
module.exports["GetTasksReportQuery"] = $fad24ea7634a5491$export$19eb1cc447563b7;

});

parcelRegister("hJ6Qq", function(module, exports) {
/**
 * @generated SignedSource<<cc17e71b9350556f4415d0b083862cae>>
 * @relayHash 4257b78a458e32e70bf16869db78cf05
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9e3aa6ff5332eca65f4d3f98919099fe7dc36425d0f211fc86efcd38e6128e4c
const $711aa99d4bd43f06$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "taskQuery"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "tasksQuery",
            "variableName": "taskQuery"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "taskId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "status"
    }, v6 = {
        "kind": "ScalarField",
        "name": "dueAt"
    }, v7 = {
        "kind": "ScalarField",
        "name": "createdAt"
    }, v8 = {
        "kind": "ScalarField",
        "name": "completedAt"
    }, v9 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v10 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v11 = {
        "concreteType": "GraphQLUserInfo",
        "kind": "LinkedField",
        "name": "assignedTo",
        "plural": false,
        "selections": [
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "concreteType": "Icon",
                "kind": "LinkedField",
                "name": "profilePicture",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "path"
                    }
                ]
            }
        ]
    }, v12 = {
        "concreteType": "GraphQLUserInfo",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": [
            v9 /*: any*/ ,
            v10 /*: any*/ 
        ]
    }, v13 = {
        "concreteType": "ConfluenceContentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "adf"
            }
        ]
    }, v14 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v15 = {
        "kind": "ScalarField",
        "name": "pageId"
    }, v16 = {
        "kind": "ScalarField",
        "name": "title"
    }, v17 = [
        {
            "kind": "ScalarField",
            "name": "base"
        },
        {
            "kind": "ScalarField",
            "name": "webUi"
        }
    ], v18 = {
        "concreteType": "ConfluencePageLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v17 /*: any*/ 
    }, v19 = {
        "kind": "ScalarField",
        "name": "label"
    }, v20 = {
        "kind": "ScalarField",
        "name": "prefix"
    }, v21 = {
        "concreteType": "ConfluenceLabel",
        "kind": "LinkedField",
        "name": "labels",
        "plural": true,
        "selections": [
            v19 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v22 = {
        "concreteType": "ConfluenceSpace",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v3 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "spaceId"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "concreteType": "ConfluenceSpaceLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v17 /*: any*/ 
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "blogPostId"
    }, v24 = {
        "concreteType": "ConfluenceBlogPostLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v17 /*: any*/ 
    }, v25 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v26 = {
        "concreteType": "ConfluenceLabel",
        "kind": "LinkedField",
        "name": "labels",
        "plural": true,
        "selections": [
            v19 /*: any*/ ,
            v20 /*: any*/ ,
            v3 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "GetTasksReportQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "InlineTasksQueryResult",
                    "kind": "LinkedField",
                    "name": "inlineTasks",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphQLInlineTask",
                            "kind": "LinkedField",
                            "name": "inlineTasks",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "container",
                                    "plural": false,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v22 /*: any*/ 
                                            ],
                                            "type": "ConfluencePage"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v22 /*: any*/ 
                                            ],
                                            "type": "ConfluenceBlogPost"
                                        }
                                    ]
                                }
                            ]
                        },
                        v25 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "GetTasksReportQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "InlineTasksQueryResult",
                    "kind": "LinkedField",
                    "name": "inlineTasks",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphQLInlineTask",
                            "kind": "LinkedField",
                            "name": "inlineTasks",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "container",
                                    "plural": false,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v22 /*: any*/ 
                                            ],
                                            "type": "ConfluencePage"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v22 /*: any*/ 
                                            ],
                                            "type": "ConfluenceBlogPost"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        },
                        v25 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "4257b78a458e32e70bf16869db78cf05",
            "id": "9e3aa6ff5332eca65f4d3f98919099fe7dc36425d0f211fc86efcd38e6128e4c",
            "metadata": {},
            "name": "GetTasksReportQuery",
            "operationKind": "query",
            "text": "query GetTasksReportQuery($taskQuery:InlineTasksByMetadata!,$cloudId:ID){inlineTasks(tasksQuery:$taskQuery,cloudId:$cloudId){inlineTasks{id,taskId,status,dueAt,createdAt,completedAt,assignedTo{accountId,displayName,profilePicture{path}},createdBy{accountId,displayName},body{adf},container{__typename,...on ConfluencePage{id,pageId,title,links{base,webUi},labels{label,prefix,id},space{id,spaceId,name,links{base,webUi}}},...on ConfluenceBlogPost{id,blogPostId,title,links{base,webUi},labels{label,prefix,id},space{id,spaceId,name,links{base,webUi}}},...on Node{__isNode:__typename,id}}},endCursor}}"
        }
    };
}();
$711aa99d4bd43f06$var$node.hash = "2b6c33814689e4cbcbd78fd4ed149156";
var $711aa99d4bd43f06$export$2e2bcd8739ae039 = $711aa99d4bd43f06$var$node;
module.exports["default"] = $711aa99d4bd43f06$export$2e2bcd8739ae039;

});

parcelRegister("rPmsQ", function(module, exports) {

var $bdzG7 = parcelRequire("bdzG7");

const $3b01e085cfcfbcb8$var$DEFAULT_PAGE_SIZE = 20;
const $3b01e085cfcfbcb8$var$DEFAULT_COLUMNS = [
    'description',
    'duedate',
    'assignee',
    'location'
];
const $3b01e085cfcfbcb8$var$VALID_COLUMNS = [
    'description',
    'duedate',
    'assignee',
    'location',
    'completedate',
    'labels'
];
const $3b01e085cfcfbcb8$var$VALID_COLUMNS_SET = new Set($3b01e085cfcfbcb8$var$VALID_COLUMNS);
function $3b01e085cfcfbcb8$var$parseColumns(raw) {
    if (!raw || typeof raw !== 'string') return $3b01e085cfcfbcb8$var$DEFAULT_COLUMNS;
    const parsed = [];
    const seen = new Set();
    const parts = raw.split(',');
    for (const part of parts){
        const c = part.trim().toLowerCase();
        if ($3b01e085cfcfbcb8$var$VALID_COLUMNS_SET.has(c) && !seen.has(c)) {
            seen.add(c);
            parsed.push(c);
        }
    }
    // If no valid columns were found at all, use the documented default set.
    // This covers the case where the user supplied only invalid column names —
    // without this guard, description would be unshifted below and the user
    // would get a single-column table instead of the four-column default.
    if (!parsed.length) return $3b01e085cfcfbcb8$var$DEFAULT_COLUMNS;
    // description is always present as the first column.
    if (!parsed.includes('description')) parsed.unshift('description');
    return parsed;
}
function $3b01e085cfcfbcb8$export$66770a7e7da42ecb(macroParams) {
    const raw = macroParams ?? {};
    const columns = $3b01e085cfcfbcb8$var$parseColumns(raw.columns?.value);
    const pageSize = parseInt(raw.pageSize?.value ?? '', 10) || $3b01e085cfcfbcb8$var$DEFAULT_PAGE_SIZE;
    const reverseSort = raw.reverseSort?.value === 'true' || raw.reverseSort?.value === true;
    const status = (0, $bdzG7.normalizeTasksReportStatus)(raw.status?.value);
    return {
        columns: columns,
        spaces: raw.spaces?.value || undefined,
        pages: raw.pages?.value || undefined,
        assignees: raw.assignees?.value || undefined,
        creators: raw.creators?.value || undefined,
        labels: raw.labels?.value || undefined,
        status: status,
        duedateFrom: raw.duedateFrom?.value ?? undefined,
        duedateTo: raw.duedateTo?.value ?? undefined,
        createddateFrom: raw.createddateFrom?.value ?? undefined,
        createddateTo: raw.createddateTo?.value ?? undefined,
        pageSize: pageSize,
        sortBy: raw.sortBy?.value || undefined,
        reverseSort: reverseSort
    };
}
module.exports["parseMacroParams"] = $3b01e085cfcfbcb8$export$66770a7e7da42ecb;

});

parcelRegister("bdzG7", function(module, exports) {
const $4338c3d1d9e19bac$export$2344a301308c0556 = {
    complete: 'CHECKED',
    incomplete: 'UNCHECKED'
};
const $4338c3d1d9e19bac$var$DEFAULT_STATUS = 'incomplete';
const $4338c3d1d9e19bac$var$STATUS_ALIASES = {
    complete: 'complete',
    completed: 'complete',
    checked: 'complete',
    incomplete: 'incomplete',
    unchecked: 'incomplete'
};
const $4338c3d1d9e19bac$export$d7a098da087f5881 = (rawStatus)=>{
    const normalizedStatus = rawStatus?.trim().toLowerCase();
    if (!normalizedStatus) return $4338c3d1d9e19bac$var$DEFAULT_STATUS;
    return $4338c3d1d9e19bac$var$STATUS_ALIASES[normalizedStatus] ?? $4338c3d1d9e19bac$var$DEFAULT_STATUS;
};
module.exports["STATUS_MAP"] = $4338c3d1d9e19bac$export$2344a301308c0556;
module.exports["normalizeTasksReportStatus"] = $4338c3d1d9e19bac$export$d7a098da087f5881;

});

parcelRegister("fzKPX", function(module, exports) {

var $iDL64 = parcelRequire("iDL64");


var $bdzG7 = parcelRequire("bdzG7");

const $0eff6d7450e12c55$export$2344a301308c0556 = (0, $bdzG7.STATUS_MAP);
const $0eff6d7450e12c55$export$b589e8bb676eddda = {
    duedate: 'DUE_DATE',
    assignee: 'ASSIGNEE',
    location: 'PAGE_TITLE'
};
const $0eff6d7450e12c55$export$15d71cf2c82ff427 = (value)=>{
    if (!value) return undefined;
    const raw = value.split(',');
    const result = [];
    for (const rawValue of raw){
        const trimmed = rawValue.trim();
        if (trimmed) result.push(trimmed);
    }
    return result.length ? result : undefined;
};
const $0eff6d7450e12c55$export$c080dece27bf09b3 = 'currentSpace()';
const $0eff6d7450e12c55$export$ecbdafc24a12ca0b = '@self';
const $0eff6d7450e12c55$export$4399bda962ab122b = (value)=>{
    const normalizedValue = value.startsWith('~') ? value.slice(1) : value;
    if (!/^\d+$/.test(normalizedValue)) return undefined;
    const parsedId = Number.parseInt(normalizedValue, 10);
    return Number.isNaN(parsedId) ? undefined : parsedId;
};
const $0eff6d7450e12c55$export$3d46c7941b830c2b = (values, currentSpaceId)=>{
    if (!values?.length) return [];
    const parsedIds = [];
    for (const value of values){
        if (value === $0eff6d7450e12c55$export$c080dece27bf09b3 || value === $0eff6d7450e12c55$export$ecbdafc24a12ca0b) {
            if (currentSpaceId !== undefined) parsedIds.push(currentSpaceId);
            continue;
        }
        const parsedId = $0eff6d7450e12c55$export$4399bda962ab122b(value);
        if (parsedId !== undefined) parsedIds.push(parsedId);
    }
    return parsedIds;
};
function $0eff6d7450e12c55$export$6042c1e6bdce848e(params, spaceIds, spaceKeys, after = null) {
    const requestedStatus = params.status;
    const mappedStatus = $0eff6d7450e12c55$export$2344a301308c0556[requestedStatus] ?? $0eff6d7450e12c55$export$2344a301308c0556.incomplete;
    const pageIds = $0eff6d7450e12c55$export$3d46c7941b830c2b($0eff6d7450e12c55$export$15d71cf2c82ff427(params.pages));
    const labels = $0eff6d7450e12c55$export$15d71cf2c82ff427(params.labels);
    const assigneeAccountIds = $0eff6d7450e12c55$export$15d71cf2c82ff427(params.assignees);
    const creatorAccountIds = $0eff6d7450e12c55$export$15d71cf2c82ff427(params.creators);
    const hasDueDate = params.duedateFrom != null || params.duedateTo != null;
    const hasCreatedDate = params.createddateFrom != null || params.createddateTo != null;
    // Only pass sortParameters for columns the server can sort — labels has no
    // server-side equivalent and falls back to the server's default order.
    const sortColumn = params.sortBy ? $0eff6d7450e12c55$export$b589e8bb676eddda[params.sortBy] ?? null : null;
    const dueDate = hasDueDate ? {
        startDate: (0, $iDL64.toEpoch)(params.duedateFrom),
        endDate: (0, $iDL64.toEpoch)(params.duedateTo)
    } : null;
    const createdDateRange = hasCreatedDate ? {
        startDate: (0, $iDL64.toEpoch)(params.createddateFrom),
        endDate: (0, $iDL64.toEpoch)(params.createddateTo)
    } : null;
    return {
        first: params.pageSize,
        after: after,
        spaceIds: spaceIds.length ? spaceIds : null,
        spaceKeys: spaceKeys.length ? spaceKeys : null,
        pageIds: pageIds.length ? pageIds : null,
        labels: labels?.length ? labels : null,
        status: mappedStatus,
        accountIds: assigneeAccountIds?.length || creatorAccountIds?.length ? {
            assigneeAccountIds: assigneeAccountIds,
            creatorAccountIds: creatorAccountIds
        } : null,
        dueDate: dueDate,
        createdDateRange: createdDateRange,
        sortParameters: sortColumn ? {
            sortColumn: sortColumn,
            // Legacy macro semantics: reverseSort=false keeps default descending order,
            // reverseSort=true flips to ascending.
            sortOrder: params.reverseSort ? 'ASCENDING' : 'DESCENDING'
        } : null
    };
}
module.exports["parseCommaSeparatedValues"] = $0eff6d7450e12c55$export$15d71cf2c82ff427;
module.exports["CURRENT_SPACE_TOKEN"] = $0eff6d7450e12c55$export$c080dece27bf09b3;
module.exports["SELF_SPACE_TOKEN"] = $0eff6d7450e12c55$export$ecbdafc24a12ca0b;
module.exports["toLongIds"] = $0eff6d7450e12c55$export$3d46c7941b830c2b;
module.exports["buildTaskQueryMetadata"] = $0eff6d7450e12c55$export$6042c1e6bdce848e;

});

parcelRegister("iDL64", function(module, exports) {
const $774a0d79f8a73639$var$DAY_FIRST_DATE_PATTERN = /^(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})$/;
const $774a0d79f8a73639$var$parseDayFirstDate = (input)=>{
    const dayFirstMatch = input.match($774a0d79f8a73639$var$DAY_FIRST_DATE_PATTERN);
    if (!dayFirstMatch) return undefined;
    const day = Number.parseInt(dayFirstMatch[1], 10);
    const month = Number.parseInt(dayFirstMatch[2], 10);
    const year = Number.parseInt(dayFirstMatch[3], 10);
    if (day < 1 || day > 31 || month < 1 || month > 12) return undefined;
    const asUtcMidnight = Date.UTC(year, month - 1, day);
    const parsedDate = new Date(asUtcMidnight);
    return parsedDate.getUTCFullYear() === year && parsedDate.getUTCMonth() === month - 1 && parsedDate.getUTCDate() === day ? asUtcMidnight : undefined;
};
const $774a0d79f8a73639$export$373c6eac988f94dd = (value)=>{
    if (value == null) return undefined;
    if (typeof value === 'number') return Number.isNaN(value) ? undefined : value;
    const trimmed = value.trim();
    if (!trimmed) return undefined;
    const numeric = Number(trimmed);
    if (!Number.isNaN(numeric)) return numeric;
    // Date picker values are day-first calendar dates; parse explicitly to avoid
    // locale-dependent Date.parse swaps (e.g. 09/04 interpreted as Sep 4).
    if ($774a0d79f8a73639$var$DAY_FIRST_DATE_PATTERN.test(trimmed)) return $774a0d79f8a73639$var$parseDayFirstDate(trimmed);
    const parsed = Date.parse(trimmed);
    return Number.isNaN(parsed) ? undefined : parsed;
};
module.exports["toEpoch"] = $774a0d79f8a73639$export$373c6eac988f94dd;

});

parcelRegister("1i2qc", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $fEmGS = parcelRequire("fEmGS");


var $6mKj3 = parcelRequire("6mKj3");


var $dYU3e = parcelRequire("dYU3e");


var $6IsMq = parcelRequire("6IsMq");


var $iTcHJ = parcelRequire("iTcHJ");


var $3j8TZ = parcelRequire("3j8TZ");

const $ab4965c7462ff107$export$9af5237a3d34e849 = async (contentId, data)=>{
    const mediaConfiguration = data?.mediaConfiguration ? {
        clientId: data.mediaConfiguration.clientId || '',
        fileStoreUrl: data.mediaConfiguration.fileStoreUrl || ''
    } : null;
    const content = data?.content ? {
        nodes: data.content.nodes?.map((node)=>node ? {
                id: node.id || null,
                body: node.body ? {
                    atlas_doc_format: node.body.atlas_doc_format ? {
                        mediaToken: node.body.atlas_doc_format.mediaToken ? {
                            token: node.body.atlas_doc_format.mediaToken.token || null
                        } : null
                    } : null
                } : null
            } : null) || []
    } : null;
    (0, $fEmGS.writeQueryInterop)({
        query: (0, $iTcHJ.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft',
                'archived'
            ]
        },
        data: {
            content: content,
            mediaConfiguration: mediaConfiguration
        },
        __callerPackage__: "fabric-media-support"
    });
};
const $ab4965c7462ff107$export$86e2470edfebdc54 = async (issueAri)=>{
    const response = await (0, $dYU3e.queryAgg)({
        query: (0, $6IsMq.default),
        variables: {
            issueAri: issueAri,
            maxTokenLength: 65536
        },
        __callerPackage__: "fabric-media-support"
    });
    return response;
};
const $ab4965c7462ff107$export$2d12daceb0197048 = async (contentId, cloudId)=>{
    if ((0, $6mKj3.expVal)('confluence_media_token_preload_agg_query', 'isEnabled', false)) {
        const response = await (0, $dYU3e.query)({
            query: (0, $3j8TZ.default),
            variables: {
                cloudId: cloudId,
                contentId: contentId,
                status: [
                    'current',
                    'draft',
                    'archived'
                ],
                missingContentId: !contentId
            },
            __callerPackage__: "fabric-media-support"
        });
        return response;
    }
    const response = await (0, $dYU3e.query)({
        query: (0, $iTcHJ.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft',
                'archived'
            ]
        },
        __callerPackage__: "fabric-media-support"
    });
    return response;
};
module.exports["primeMediaTokenFromRouteData"] = $ab4965c7462ff107$export$9af5237a3d34e849;
module.exports["preloadJiraMediaToken"] = $ab4965c7462ff107$export$86e2470edfebdc54;
module.exports["preloadMediaToken"] = $ab4965c7462ff107$export$2d12daceb0197048;

});

parcelRegister("6IsMq", function(module, exports) {
/**
 * @generated SignedSource<<d76d95039bbf9cae17d368276aebc792>>
 * @relayHash b0b89409f45955f1d6631ca601f67f8b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 916fc9c88cdf0763a685d23187d4deb77c6c3625098021bbc28d6dba182b8d9b
const $684f397ef7ad0ae2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueAri"
        },
        {
            "defaultValue": 65536,
            "kind": "LocalArgument",
            "name": "maxTokenLength"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "issueAri"
        }
    ], v2 = {
        "args": [
            {
                "kind": "Variable",
                "name": "maxTokenLength",
                "variableName": "maxTokenLength"
            }
        ],
        "concreteType": "JiraMediaReadToken",
        "kind": "LinkedField",
        "name": "mediaReadToken",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "clientId"
            },
            {
                "kind": "ScalarField",
                "name": "endpointUrl"
            },
            {
                "kind": "ScalarField",
                "name": "tokenLifespanInSeconds"
            },
            {
                "concreteType": "JiraMediaTokenWithFilesConnection",
                "kind": "LinkedField",
                "name": "tokensWithFiles",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraMediaTokenWithFilesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraMediaTokenWithFiles",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "token"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b0b89409f45955f1d6631ca601f67f8b",
            "id": "916fc9c88cdf0763a685d23187d4deb77c6c3625098021bbc28d6dba182b8d9b",
            "metadata": {},
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchJiraMediaTokenQuery($issueAri:ID!,$maxTokenLength:Int=65536){jira{issueById(id:$issueAri){mediaReadToken(maxTokenLength:$maxTokenLength)@optIn(to:\"JiraMediaReadTokenInIssue\"){clientId,endpointUrl,tokenLifespanInSeconds,tokensWithFiles{edges{node{token}}}},id}}}"
        }
    };
}();
$684f397ef7ad0ae2$var$node.hash = "7036cf95096a08504e6375127746a507";
var $684f397ef7ad0ae2$export$2e2bcd8739ae039 = $684f397ef7ad0ae2$var$node;
module.exports["default"] = $684f397ef7ad0ae2$export$2e2bcd8739ae039;

});

parcelRegister("iTcHJ", function(module, exports) {
/**
 * @generated SignedSource<<5e736080ce8c5ab015a5851e0537f7fa>>
 * @relayHash 60dcb7a4a06a5eaa2ddb4f4df7437c8c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da295508da11933cde6015c5899a2dae3ede521437117bf85391f779f362e076
const $cd49b7baa8bd0c54$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "missingContentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = [
        {
            "condition": "missingContentId",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "status",
                            "variableName": "status"
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "atlas_doc_format",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "EmbeddedMediaToken",
                                                    "kind": "LinkedField",
                                                    "name": "mediaToken",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "token"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "mediaConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "60dcb7a4a06a5eaa2ddb4f4df7437c8c",
            "id": "da295508da11933cde6015c5899a2dae3ede521437117bf85391f779f362e076",
            "metadata": {},
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchMediaTokenQuery($contentId:ID,$status:[String],$missingContentId:Boolean=false){content(id:$contentId,status:$status)@skip(if:$missingContentId){nodes{id,body{atlas_doc_format{mediaToken{token}}}}},mediaConfiguration{clientId,fileStoreUrl}}"
        }
    };
}();
$cd49b7baa8bd0c54$var$node.hash = "c53e0852d23c6b17549e89592c16b84c";
var $cd49b7baa8bd0c54$export$2e2bcd8739ae039 = $cd49b7baa8bd0c54$var$node;
module.exports["default"] = $cd49b7baa8bd0c54$export$2e2bcd8739ae039;

});

parcelRegister("3j8TZ", function(module, exports) {
/**
 * @generated SignedSource<<bcf6371051972dda4e73703ef8d6345b>>
 * @relayHash 44fbfb9d6df590a6ee4e002cd5037220
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e8b1b354828c70d1a3ff4efd4b04c1bb4b5dbec948132154a057ea3cc5e9c01
const $bcd0dbc3bf494067$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "missingContentId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "size"
    }, v7 = {
        "kind": "ScalarField",
        "name": "mimeType"
    }, v8 = {
        "kind": "ScalarField",
        "name": "processingStatus"
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdAt"
    }, v10 = [
        {
            "condition": "missingContentId",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "status",
                            "variableName": "status"
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "atlas_doc_format",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "EmbeddedMediaToken",
                                                    "kind": "LinkedField",
                                                    "name": "mediaToken",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "token"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "cloudId",
                                                            "variableName": "cloudId"
                                                        }
                                                    ],
                                                    "concreteType": "MediaItem",
                                                    "kind": "LinkedField",
                                                    "name": "mediaItems",
                                                    "plural": true,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "type"
                                                        },
                                                        {
                                                            "concreteType": "MediaFileDetails",
                                                            "kind": "LinkedField",
                                                            "name": "details",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "mediaType"
                                                                },
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "failReason"
                                                                },
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "concreteType": "MediaFilePreview",
                                                                    "kind": "LinkedField",
                                                                    "name": "preview",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "cdnUrl"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MediaFileArtifact",
                                                                    "kind": "LinkedField",
                                                                    "name": "artifactsList",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v9 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        v5 /*: any*/ ,
                                                                        v8 /*: any*/ ,
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MediaFileRepresentations",
                                                                    "kind": "LinkedField",
                                                                    "name": "representations",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "MediaImageRepresentation",
                                                                            "kind": "LinkedField",
                                                                            "name": "image",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "_empty"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MediaFileMetadata",
                                                                    "kind": "LinkedField",
                                                                    "name": "mediaMetadata",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "duration"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MediaFileAbuseClassification",
                                                                    "kind": "LinkedField",
                                                                    "name": "abuseClassification",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "classification"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "confidence"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "mediaConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "graphqlHelpersFetchMediaTokenWithMediaItemsQuery",
            "selections": v10 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "graphqlHelpersFetchMediaTokenWithMediaItemsQuery",
            "selections": v10 /*: any*/ 
        },
        "params": {
            "cacheID": "44fbfb9d6df590a6ee4e002cd5037220",
            "id": "3e8b1b354828c70d1a3ff4efd4b04c1bb4b5dbec948132154a057ea3cc5e9c01",
            "metadata": {},
            "name": "graphqlHelpersFetchMediaTokenWithMediaItemsQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchMediaTokenWithMediaItemsQuery($cloudId:ID!,$contentId:ID,$status:[String],$missingContentId:Boolean=false){content(id:$contentId,status:$status)@skip(if:$missingContentId){nodes{id,body{atlas_doc_format{mediaToken{token},mediaItems(cloudId:$cloudId){id,type,details{name,size,mimeType,mediaType,processingStatus,failReason,createdAt,preview{cdnUrl},artifactsList{createdAt,mimeType,name,processingStatus,size,url},representations{image{_empty}},mediaMetadata{duration},abuseClassification{classification,confidence}}}}}}},mediaConfiguration{clientId,fileStoreUrl}}"
        }
    };
}();
$bcd0dbc3bf494067$var$node.hash = "c03e617139295e9107b3907ee1a06cb3";
var $bcd0dbc3bf494067$export$2e2bcd8739ae039 = $bcd0dbc3bf494067$var$node;
module.exports["default"] = $bcd0dbc3bf494067$export$2e2bcd8739ae039;

});

parcelRegister("bS81H", function(module, exports) {
/**
 * @generated SignedSource<<ecee5cb68219750c899a663dd271634b>>
 * @relayHash 611f36fd3ab140915814f503f8503110
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 97be9875eda07a3755479859d908d73b01a8526a1d7d39ebe7c437e3317987f8
const $5a2ebb253ede159a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "action"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentStatus"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentVersion"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "concreteType": "Confluence_dataSecurityPolicy",
            "kind": "LinkedField",
            "name": "dataSecurityPolicy",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "action",
                            "variableName": "action"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentStatus",
                            "variableName": "contentStatus"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentVersion",
                            "variableName": "contentVersion"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "DataSecurityPolicyDecision",
                    "kind": "LinkedField",
                    "name": "isActionEnabledForContent",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "action"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "allowed"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "graphqlHelpersDSPIsActionEnabledForContentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "graphqlHelpersDSPIsActionEnabledForContentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "611f36fd3ab140915814f503f8503110",
            "id": "97be9875eda07a3755479859d908d73b01a8526a1d7d39ebe7c437e3317987f8",
            "metadata": {},
            "name": "graphqlHelpersDSPIsActionEnabledForContentQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersDSPIsActionEnabledForContentQuery($action:DataSecurityPolicyAction!,$contentId:ID!,$contentStatus:DataSecurityPolicyDecidableContentStatus!,$contentVersion:Int!,$spaceKey:String){dataSecurityPolicy{isActionEnabledForContent(action:$action,contentId:$contentId,contentStatus:$contentStatus,contentVersion:$contentVersion,spaceKey:$spaceKey){action,allowed}}}"
        }
    };
}();
$5a2ebb253ede159a$var$node.hash = "c488c053b9896d7e6d5b6c4474dd396b";
var $5a2ebb253ede159a$export$2e2bcd8739ae039 = $5a2ebb253ede159a$var$node;
module.exports["default"] = $5a2ebb253ede159a$export$2e2bcd8739ae039;

});

parcelRegister("axutP", function(module, exports) {
/**
 * @generated SignedSource<<1489173bfe4b7806076804a6e2602ed8>>
 * @relayHash fa5b50f9c89692d4dd86caf1df42c2d1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 60833378a8743a6756bd6e1c0fa498d563c23b5e85cbe46b5ee3f3b782265d4a
const $972689412971ec2f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "ConfluenceTeamPresence",
            "kind": "LinkedField",
            "name": "confluence_teamPresenceContentSetting",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEnabledOnContentView"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentHeaderPresenceContentSettingsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentHeaderPresenceContentSettingsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fa5b50f9c89692d4dd86caf1df42c2d1",
            "id": "60833378a8743a6756bd6e1c0fa498d563c23b5e85cbe46b5ee3f3b782265d4a",
            "metadata": {},
            "name": "ContentHeaderPresenceContentSettingsQuery",
            "operationKind": "query",
            "text": "query ContentHeaderPresenceContentSettingsQuery($cloudId:ID!,$spaceKey:String!){confluence_teamPresenceContentSetting(cloudId:$cloudId,spaceKey:$spaceKey){isEnabledOnContentView}}"
        }
    };
}();
$972689412971ec2f$var$node.hash = "2d4682166f4edbdf50428f0d98c0918c";
var $972689412971ec2f$export$2e2bcd8739ae039 = $972689412971ec2f$var$node;
module.exports["default"] = $972689412971ec2f$export$2e2bcd8739ae039;

});

parcelRegister("8CHHT", function(module, exports) {

var $9WAeG = parcelRequire("9WAeG");


var $xwvlW = parcelRequire("xwvlW");


var $3mugH = parcelRequire("3mugH");


var $7Sm4c = parcelRequire("7Sm4c");


var $6fil2 = parcelRequire("6fil2");


var $8n0y0 = parcelRequire("8n0y0");

const $23196774779b9db8$var$setWindowExtensions = (moduleType, extensions, error, context)=>{
    window.__SSR_FORGE_EXTENSIONS__ = window.__SSR_FORGE_EXTENSIONS__ || {};
    window.__SSR_FORGE_EXTENSIONS__[moduleType] = {
        extensions: extensions,
        error: error,
        context: context
    };
};
async function $23196774779b9db8$export$afb6180712276ba1({ contentId: contentId, spaceKey: spaceKey, moduleType: moduleType, includeHidden: includeHidden = false, spaceContextOnly: spaceContextOnly = false }) {
    const { cloudId: cloudId, locale: locale } = (0, $xwvlW.getPreloaderFnContext)();
    return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/fetch:ForgeExtensionList', async ()=>{
        try {
            const extensions = await (0, $8n0y0.preloadForgeApps)({
                cloudId: cloudId,
                locale: locale,
                types: [
                    moduleType
                ],
                context: spaceContextOnly ? {
                    spaceKey: spaceKey
                } : {
                    spaceKey: spaceKey,
                    contentId: contentId != null ? Number(contentId) : undefined
                },
                includeHidden: includeHidden
            });
            $23196774779b9db8$var$setWindowExtensions(moduleType, extensions ?? [], undefined, {
                spaceKey: spaceKey,
                contentId: contentId,
                includeHidden: includeHidden,
                spaceContextOnly: spaceContextOnly
            });
        } catch (e) {
            // Want to handle network errors to not affect experience SLA
            if ((0, $6fil2.containsNetworkError)(e)) (0, $7Sm4c.markErrorAsHandled)(e);
            else (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Filed to get forge extension list: ${e.message}`));
        }
    });
}
module.exports["preloadUseExtensionList"] = $23196774779b9db8$export$afb6180712276ba1;

});

parcelRegister("8n0y0", function(module, exports) {

var $klHST = parcelRequire("klHST");


var $jGizm = parcelRequire("jGizm");


var $dYU3e = parcelRequire("dYU3e");

// Inlined from platform/packages/forge/forge-ui/src/utils/createAtlAttributionHeader.ts
// (not available as a public entry point of @atlassian/forge-ui)
const $0469ff9a24207ab9$var$createAtlAttributionHeader = (workspaceAri)=>JSON.stringify({
        atlWorkspaceAri: workspaceAri,
        service: 'forge-ui'
    });
const $0469ff9a24207ab9$export$e95a50d7f0e263b5 = async ({ cloudId: cloudId, locale: locale, types: types, context: context, includeHidden: includeHidden })=>{
    const { data: data } = await (0, $dYU3e.queryAgg)({
        query: (0, $klHST.default),
        // copied from platform/packages/forge/forge-ui/src/web-client/hooks/usePrefilteredExtensionList.ts:createUsePrefilteredExtensionListQueryOptions()
        variables: {
            cloudId: cloudId,
            context: context,
            includeHidden: includeHidden ?? false,
            types: types,
            locale: locale
        },
        /**
     * We don't want to set 'ignore' because that discards errors and we need to inspect
     * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
     * https://www.apollographql.com/docs/react/data/error-handling/
     */ errorPolicy: 'all',
        context: {
            headers: {
                'atl-attribution': $0469ff9a24207ab9$var$createAtlAttributionHeader(cloudId)
            },
            allowOnExternalPage: true
        },
        __callerPackage__: "forge-ui"
    });
    // @ts-expect-error - FIXME: This error was surfaced after enabling the `typescriptExcludeUndefinedFromNullableUnion`
    // Relay compiler option. Previously, `undefined` was incorrectly included in nullable unions in generated types; this option removes it. The owning team should fix this properly.
    const extensions = data?.confluence_forgeExtensionsByType || [];
    if (extensions.length > 0) return (0, $jGizm.transformPreFilteredExtensions)(extensions);
    return null;
};
module.exports["preloadForgeApps"] = $0469ff9a24207ab9$export$e95a50d7f0e263b5;

});

parcelRegister("klHST", function(module, exports) {
/**
 * @generated SignedSource<<f9ea6c5dc173397e0deec2c9c61e408d>>
 * @relayHash ed5f81a23070bbd7a269663fafbee425
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 208bb10d6151e8c79ff890f81580ca160b8daad9625597cd7e7540aeac36d728
const $8dbf49233d9310af$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "context"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeHidden"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "types"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "key"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "context",
                    "variableName": "context"
                },
                {
                    "kind": "Variable",
                    "name": "includeHidden",
                    "variableName": "includeHidden"
                },
                {
                    "kind": "Variable",
                    "name": "locale",
                    "variableName": "locale"
                },
                {
                    "kind": "Variable",
                    "name": "types",
                    "variableName": "types"
                }
            ],
            "concreteType": "ConfluenceForgeExtension",
            "kind": "LinkedField",
            "name": "confluence_forgeExtensionsByType",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "appId"
                },
                {
                    "kind": "ScalarField",
                    "name": "appVersion"
                },
                {
                    "kind": "ScalarField",
                    "name": "appOwner"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentType"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "consentUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "migrationKey"
                },
                {
                    "concreteType": "ConfluenceUserAccess",
                    "kind": "LinkedField",
                    "name": "userAccess",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "enabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasAccess"
                        }
                    ]
                },
                v1 /*: any*/ ,
                {
                    "concreteType": "KeyValueHierarchyMap",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceExtensionEgressDeclaration",
                    "kind": "LinkedField",
                    "name": "egress",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "addresses"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "inScopeEUD"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "scopes"
                },
                {
                    "concreteType": "ConfluenceAppInstallationLicense",
                    "kind": "LinkedField",
                    "name": "license",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "active"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "capabilitySet"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "billingPeriod"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementSlug"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isEvaluation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionEndDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "trialEndDate"
                        },
                        v2 /*: any*/ 
                    ]
                },
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "installationId"
                },
                {
                    "kind": "ScalarField",
                    "name": "hiddenBy"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadForgeApps_FetchPreFilteredForgeAppsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadForgeApps_FetchPreFilteredForgeAppsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "ed5f81a23070bbd7a269663fafbee425",
            "id": "208bb10d6151e8c79ff890f81580ca160b8daad9625597cd7e7540aeac36d728",
            "metadata": {},
            "name": "preloadForgeApps_FetchPreFilteredForgeAppsQuery",
            "operationKind": "query",
            "text": "query preloadForgeApps_FetchPreFilteredForgeAppsQuery($cloudId:ID!,$context:ConfluenceExtensionRenderingContextInput,$includeHidden:Boolean,$locale:String,$types:[String]){confluence_forgeExtensionsByType(cloudId:$cloudId,context:$context,includeHidden:$includeHidden,locale:$locale,types:$types){id,appId,appVersion,appOwner,environmentId,environmentType,environmentKey,consentUrl,migrationKey,userAccess{enabled,hasAccess},key,properties{key,value},egress{addresses,category,type,inScopeEUD},scopes,license{active,capabilitySet,billingPeriod,ccpEntitlementId,ccpEntitlementSlug,isEvaluation,subscriptionEndDate,trialEndDate,type},type,installationId,hiddenBy}}"
        }
    };
}();
$8dbf49233d9310af$var$node.hash = "d99aeaa2aa86bf313f505de4d4d482e6";
var $8dbf49233d9310af$export$2e2bcd8739ae039 = $8dbf49233d9310af$var$node;
module.exports["default"] = $8dbf49233d9310af$export$2e2bcd8739ae039;

});

parcelRegister("jGizm", function(module, exports) {

var $2zscg = parcelRequire("2zscg");

const $04d4b8463fee3aa7$var$extensionCache = new WeakMap();
const $04d4b8463fee3aa7$var$isStringArray = (value)=>Array.isArray(value) && value.every((item)=>typeof item === 'string');
/**
 * Most property values (`title`, `key`, `type`, `resource`, `icon`, …) are plain strings
 * rather than JSON, so parsing them unconditionally throws for the majority of the list —
 * around 1,100 caught `SyntaxError`s per pass on a real 143-app payload, which dominates
 * the transform.
 *
 * A JSON document can only open as an object, array, string or number, or be one of the
 * three bare literals. Anything else would have thrown and fallen back to the raw string,
 * so skipping the parse is equivalent.
 *
 * Property values that are not strings are kept verbatim for the same reason: stringifying
 * them for `JSON.parse` throws for anything but a bare literal, so the raw value survives.
 */ const $04d4b8463fee3aa7$var$canStartJsonDocument = (value)=>{
    const firstCharacter = value[0];
    return firstCharacter === '{' || firstCharacter === '[' || firstCharacter === '"' || firstCharacter === '-' || firstCharacter >= '0' && firstCharacter <= '9' || value === 'true' || value === 'false' || value === 'null';
};
const $04d4b8463fee3aa7$var$normalizeProperties = (properties)=>{
    const normalizedProperties = properties.reduce((acc, property)=>{
        if (!property.value || !property.key) return acc;
        if (typeof property.value !== 'string' || !$04d4b8463fee3aa7$var$canStartJsonDocument(property.value.trim())) {
            acc[property.key] = property.value;
            return acc;
        }
        try {
            const jsonValue = JSON.parse(property.value);
            acc[property.key] = jsonValue;
        } catch (_error) {
            acc[property.key] = property.value;
        }
        return acc;
    }, {});
    if ('migratedFrom' in normalizedProperties && !$04d4b8463fee3aa7$var$isStringArray(normalizedProperties.migratedFrom)) {
        const { migratedFrom: _migratedFrom, ...propertiesWithoutInvalidMigratedFrom } = normalizedProperties;
        return propertiesWithoutInvalidMigratedFrom;
    }
    return normalizedProperties;
};
const $04d4b8463fee3aa7$export$9ff84ea1b2ab439c = (extensions)=>{
    if (!extensions || extensions.length === 0) return [];
    if ($04d4b8463fee3aa7$var$extensionCache.has(extensions)) return $04d4b8463fee3aa7$var$extensionCache.get(extensions);
    const result = (extensions || []).flatMap((extension)=>{
        if (!extension) return [];
        if (!extension.environmentKey) return [];
        return [
            {
                id: extension.id,
                appId: extension.appId,
                key: extension.key,
                environmentId: extension.environmentId,
                environmentType: extension.environmentType === (0, $2zscg.ExtensionEnvironment).DEVELOPMENT || extension.environmentType === (0, $2zscg.ExtensionEnvironment).STAGING || extension.environmentType === (0, $2zscg.ExtensionEnvironment).PRODUCTION ? extension.environmentType : (0, $2zscg.ExtensionEnvironment).DEVELOPMENT,
                environmentKey: extension.environmentKey,
                properties: $04d4b8463fee3aa7$var$normalizeProperties(extension.properties),
                license: extension.license ? {
                    ...extension.license,
                    capabilitySet: $04d4b8463fee3aa7$var$mapCapabilitySet(extension.license.capabilitySet)
                } : null,
                userAccess: extension.userAccess ? {
                    hasAccess: extension.userAccess.hasAccess ?? false,
                    enabled: extension.userAccess.enabled ?? false
                } : null,
                type: extension.type,
                installationId: extension.installationId,
                appVersion: extension.appVersion ?? undefined,
                consentUrl: extension.consentUrl ?? undefined,
                migrationKey: extension.migrationKey ?? undefined,
                egress: extension.egress?.flatMap((egress)=>{
                    if (!egress.type || !egress.addresses) return [];
                    return [
                        {
                            type: egress.type,
                            addresses: egress.addresses?.flatMap((address)=>address ?? []),
                            category: egress.category ?? undefined,
                            inScopeEUD: egress.inScopeEUD ?? undefined
                        }
                    ];
                }) ?? undefined,
                sandboxPolicies: extension.sandboxPolicies ?? undefined,
                scopes: extension.scopes ?? undefined,
                installationConfig: extension.installationConfig?.flatMap((config)=>{
                    if (!config?.key || config.value === null) return [];
                    return [
                        {
                            key: config.key,
                            value: config.value
                        }
                    ];
                }) ?? undefined,
                dataClassificationPolicyDecision: {
                    status: extension.hiddenBy === 'APP_ACCESS_RULES' ? 'BLOCKED' : 'ALLOWED'
                }
            }
        ];
    });
    const IS_TESTING_ENV = false;
    if (!IS_TESTING_ENV) $04d4b8463fee3aa7$var$extensionCache.set(extensions, result);
    return result;
};
const $04d4b8463fee3aa7$var$mapCapabilitySet = (capabilitySet)=>{
    switch(capabilitySet){
        case 'CAPABILITY_ADVANCED':
            return 'capabilityAdvanced';
        default:
            return 'capabilityStandard';
    }
};
module.exports["transformPreFilteredExtensions"] = $04d4b8463fee3aa7$export$9ff84ea1b2ab439c;

});

parcelRegister("2zscg", function(module, exports) {
var $a413c718e4c7bf40$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $a413c718e4c7bf40$export$9a2372818e2520c6 = {
    ATTACHMENT_ACTION: 'confluence:attachmentAction',
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    FULL_PAGE: 'confluence:fullPage',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $a413c718e4c7bf40$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    FULL_PAGE: 'jira:fullPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
const $a413c718e4c7bf40$export$586232a3e4271798 = {
    CUSTOM_MERGE_CHECK: 'bitbucket:mergeCheck',
    DYNAMIC_PIPELINES_PROVIDER: 'bitbucket:dynamicPipelinesProvider',
    REPOSITORY_CODE_FILE_VIEWER: 'bitbucket:repoCodeFileViewer',
    REPOSITORY_CODE_OVERVIEW_CARD: 'bitbucket:repoCodeOverviewCard',
    REPOSITORY_CODE_OVERVIEW_ACTION: 'bitbucket:repoCodeOverviewAction',
    REPOSITORY_CODE_OVERVIEW_PANEL: 'bitbucket:repoCodeOverviewPanel',
    REPOSITORY_PULL_REQUEST_CARD: 'bitbucket:repoPullRequestCard',
    REPOSITORY_PULL_REQUEST_ACTION: 'bitbucket:repoPullRequestAction',
    REPOSITORY_PULL_REQUEST_OVERVIEW_PANEL: 'bitbucket:repoPullRequestOverviewPanel',
    REPOSITORY_MAIN_MENU_PAGE: 'bitbucket:repoMainMenuPage',
    REPOSITORY_SETTINGS_MENU_PAGE: 'bitbucket:repoSettingsMenuPage',
    PROJECT_SETTINGS_MENU_PAGE: 'bitbucket:projectSettingsMenuPage',
    WORKSPACE_GLOBAL_PAGE: 'bitbucket:workspaceGlobalPage',
    WORKSPACE_PERSONAL_SETTINGS_PAGE: 'bitbucket:workspacePersonalSettingsPage',
    WORKSPACE_SETTINGS_MENU_PAGE: 'bitbucket:workspaceSettingsMenuPage'
};
const $a413c718e4c7bf40$export$ffcb70f38ee10c0a = {
    FULL_PAGE: 'global:fullPage',
    GLOBAL_UI: 'global:ui'
};
module.exports["ExtensionEnvironment"] = $a413c718e4c7bf40$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $a413c718e4c7bf40$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $a413c718e4c7bf40$export$f06ffa3aa6bfec95;
module.exports["BitbucketExtension"] = $a413c718e4c7bf40$export$586232a3e4271798;
module.exports["GlobalExtension"] = $a413c718e4c7bf40$export$ffcb70f38ee10c0a;

});

parcelRegister("e5EnV", function(module, exports) {
/**
 * @generated SignedSource<<19f88e77d3cfba146c135d602dcd850a>>
 * @relayHash 6cd75834f128f4e69b90e03b31603fd0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 12b9ea0b2a8549a655e6db18139e709c6bf2e6d45eff5ec0488c52b8b8309362
const $e4798d13ae2c4a75$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "status"
                },
                {
                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        }
                    ]
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphQLConfluenceUserRoles",
                            "kind": "LinkedField",
                            "name": "roles",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "canBeSuperAdmin"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "RestrictedPageWithCanViewQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "RestrictedPageWithCanViewQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "6cd75834f128f4e69b90e03b31603fd0",
            "id": "12b9ea0b2a8549a655e6db18139e709c6bf2e6d45eff5ec0488c52b8b8309362",
            "metadata": {},
            "name": "RestrictedPageWithCanViewQuery",
            "operationKind": "query",
            "text": "query RestrictedPageWithCanViewQuery($id:ID!){singleContent(id:$id){id,status,links{webui}},user:confluence_atlassianUser(current:true){id,confluence{roles{canBeSuperAdmin}}}}"
        }
    };
}();
$e4798d13ae2c4a75$var$node.hash = "cac9cbea2e6f98b7e3ef1e383776a339";
var $e4798d13ae2c4a75$export$2e2bcd8739ae039 = $e4798d13ae2c4a75$var$node;
module.exports["default"] = $e4798d13ae2c4a75$export$2e2bcd8739ae039;

});

parcelRegister("6jrkJ", function(module, exports) {

var $68uaC = parcelRequire("68uaC");


var $9wGTI = parcelRequire("9wGTI");

const $00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE = 'confluence.asSuperAdmin';
function $00ee7f2affe27fcd$export$2fc1623749affa1a() {
    return Boolean((0, $68uaC.Cookies).get($00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE));
}
function $00ee7f2affe27fcd$export$b097cdee5288154b() {
    if ((0, $9wGTI.fg)('remove_admin_cookie_on_banner_dismiss')) (0, $68uaC.Cookies).removeStrictlyNecessary($00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE);
    else (0, $68uaC.Cookies).remove($00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE);
}
async function $00ee7f2affe27fcd$export$f5d5d0f409509831() {
    await (0, $68uaC.Cookies).set($00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE, 'true', undefined, (0, $68uaC.CookieLevel).NECESSARY);
}
module.exports["getSuperAdminClaim"] = $00ee7f2affe27fcd$export$2fc1623749affa1a;
module.exports["removeSuperAdminClaim"] = $00ee7f2affe27fcd$export$b097cdee5288154b;
module.exports["setSuperAdminClaim"] = $00ee7f2affe27fcd$export$f5d5d0f409509831;

});

parcelRegister("hiC7Y", function(module, exports) {
/**
 * @generated SignedSource<<994231445f227a67e1aaccbbe4790b5b>>
 * @relayHash 0f84e07ae7daaa03ff834c7e22000d77
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78
const $55ca182de67fa1f0$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphQLConfluenceUserRoles",
                            "kind": "LinkedField",
                            "name": "roles",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isSuperAdmin"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "IsSuperAdminQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "IsSuperAdminQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "0f84e07ae7daaa03ff834c7e22000d77",
            "id": "54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78",
            "metadata": {},
            "name": "IsSuperAdminQuery",
            "operationKind": "query",
            "text": "query IsSuperAdminQuery{user:confluence_atlassianUser(current:true){id,confluence{roles{isSuperAdmin}}}}"
        }
    };
}();
$55ca182de67fa1f0$var$node.hash = "9aa53dcf116596c8f8285a3aa93878ce";
var $55ca182de67fa1f0$export$2e2bcd8739ae039 = $55ca182de67fa1f0$var$node;
module.exports["default"] = $55ca182de67fa1f0$export$2e2bcd8739ae039;

});

parcelRegister("eDV4X", function(module, exports) {
const $e24dc53dc88ae3e8$export$3211963609921415 = [
    'current',
    'draft'
];
const $e24dc53dc88ae3e8$export$d7a13677648fb230 = 'edit-label-dialog-heading';
var $e24dc53dc88ae3e8$export$1385d81a6c6bbcd4 = /*#__PURE__*/ function(ActionTypes) {
    ActionTypes["CLEAR"] = "clear";
    ActionTypes["CREATE_OPTION"] = "create-option";
    ActionTypes["REMOVE_VALUE"] = "remove-value";
    ActionTypes["POP_VALUE"] = "pop-value";
    ActionTypes["SELECT_OPTION"] = "select-option";
    return ActionTypes;
}({});
const $e24dc53dc88ae3e8$export$cac90560d1a4fb86 = /[:;,.•?&[\]()#^*@!<>]/;
var $e24dc53dc88ae3e8$export$b9e669a853ca2f38 = /*#__PURE__*/ function(ContentTypes) {
    ContentTypes["TEMPLATE"] = "template";
    return ContentTypes;
}({});
module.exports["ALLOWED_CONTENT_STATUSES"] = $e24dc53dc88ae3e8$export$3211963609921415;
module.exports["ActionTypes"] = $e24dc53dc88ae3e8$export$1385d81a6c6bbcd4;
module.exports["INVALID_CHARACTERS"] = $e24dc53dc88ae3e8$export$cac90560d1a4fb86;
module.exports["ContentTypes"] = $e24dc53dc88ae3e8$export$b9e669a853ca2f38;

});

parcelRegister("fD4xZ", function(module, exports) {
/**
 * @generated SignedSource<<1a93f69da43b9061a7c9446104b7f51c>>
 * @relayHash b698f2f645007ae504c47432886a8c9f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ec1bbae0d06503f83cace8fb8dcc810514d285963c0c294c636dfbed334b851a
const $d6621697d90b85f7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "orderBy",
                                    "value": {
                                        "direction": "ASCENDING",
                                        "sortField": "LABELLING_CREATIONDATE"
                                    }
                                }
                            ],
                            "concreteType": "PaginatedLabelList",
                            "kind": "LinkedField",
                            "name": "labels",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "count"
                                },
                                {
                                    "concreteType": "Label",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "label"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "prefix"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useLabelsSelectPropsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useLabelsSelectPropsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "b698f2f645007ae504c47432886a8c9f",
            "id": "ec1bbae0d06503f83cace8fb8dcc810514d285963c0c294c636dfbed334b851a",
            "metadata": {},
            "name": "useLabelsSelectPropsQuery",
            "operationKind": "query",
            "text": "query useLabelsSelectPropsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,status,operations{operation,targetType},space{id},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){count,nodes{__typename,id,label,name,prefix}}}}}"
        }
    };
}();
$d6621697d90b85f7$var$node.hash = "d18f04cceb469e9db4defcdb1b9ec4bd";
var $d6621697d90b85f7$export$2e2bcd8739ae039 = $d6621697d90b85f7$var$node;
module.exports["default"] = $d6621697d90b85f7$export$2e2bcd8739ae039;

});

parcelRegister("jkwMx", function(module, exports) {

var $cqob2 = parcelRequire("cqob2");


var $e9oF4 = parcelRequire("e9oF4");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $9HB34 = parcelRequire("9HB34");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");

const $ad7e745e3d59b8c7$export$bb5886bf758160d3 = (0, $e9oF4.default);
const $ad7e745e3d59b8c7$export$ffff3ea8cf53a69e = (0, $cqob2.default);
const $ad7e745e3d59b8c7$var$SETTLED_EMPTY = {
    labels: [],
    loading: false,
    error: undefined
};
const $ad7e745e3d59b8c7$export$1e91156d5765cc4b = (cloudId, contentId)=>cloudId && contentId ? `ari:cloud:confluence:${cloudId}:page/${contentId}` : '';
const $ad7e745e3d59b8c7$export$48837ed000c21cf = (contentId)=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const entityAri = $ad7e745e3d59b8c7$export$1e91156d5765cc4b(cloudId, contentId);
    const skip = !(0, $9wGTI.fg)('confluence_managed_external_labels_endpoint') || !cloudId || !contentId;
    // Start loading when active so consumers don't flash empty before the first read.
    const [state, setState] = (0, $cozmU.useState)(()=>skip ? $ad7e745e3d59b8c7$var$SETTLED_EMPTY : {
            labels: [],
            loading: true,
            error: undefined
        });
    const runQuery = (0, $cozmU.useCallback)(()=>{
        if (skip) {
            setState($ad7e745e3d59b8c7$var$SETTLED_EMPTY);
            return ()=>{};
        }
        setState((prev)=>({
                ...prev,
                loading: true,
                error: undefined
            }));
        let cancelled = false;
        const subscription = (0, $6SsN4.fetchQuery)((0, $9HB34.getRelayEnvironment)(), $ad7e745e3d59b8c7$export$bb5886bf758160d3, {
            cloudId: cloudId,
            id: entityAri
        }, {
            // Read store-first (warmed by `preloadManagedLabels` during SSR),
            // network otherwise. No `X-Query-Context` header: the field resolves
            // headerless, which is what lets it fold into the batched
            // ContentUnifiedQuery.
            fetchPolicy: 'store-or-network'
        }).subscribe({
            next: (data)=>{
                if (cancelled) return;
                // Gateway types array and elements as nullable; drop nulls.
                setState({
                    labels: (data?.confluence_externalLabels ?? []).filter((label)=>label != null),
                    loading: false,
                    error: undefined
                });
            },
            error: (err)=>{
                if (cancelled) return;
                setState((prev)=>({
                        ...prev,
                        loading: false,
                        error: err instanceof Error ? err : new Error(String(err))
                    }));
            }
        });
        return ()=>{
            cancelled = true;
            subscription.unsubscribe();
        };
    }, [
        skip,
        cloudId,
        entityAri
    ]);
    // `runQuery` returns its cleanup, tearing down the in-flight fetch on unmount/re-run.
    (0, $cozmU.useEffect)(()=>{
        return runQuery();
    }, [
        runQuery
    ]);
    return {
        labels: state.labels,
        loading: state.loading,
        error: state.error,
        refetch: ()=>{
            if (!skip) runQuery();
        }
    };
};
const $ad7e745e3d59b8c7$export$7fcfc8c1f94175ba = (fragmentRef)=>{
    // Native `useFragment` calls `useRelayEnvironment()` even for a null ref, so it
    // throws when no provider is mounted (Apollo mode / Apollo-mode jest tests). The
    // spread only exists when the gate is on, so skip the read entirely when it's off.
    // The gate is session-stable within a render tree, matching `useReadFragmentInterop`.
    const data = (0, $9wGTI.fg)('confluence_managed_external_labels_endpoint') ? // eslint-disable-next-line react-hooks/rules-of-hooks -- gate is session-stable within a render tree, matching useReadFragmentInterop
    (0, $6SsN4.useFragment)($ad7e745e3d59b8c7$export$ffff3ea8cf53a69e, fragmentRef ?? null) : null;
    // Gateway types array and elements as nullable; drop nulls.
    return (data?.confluence_externalLabels ?? []).filter((label)=>label != null);
};
const $ad7e745e3d59b8c7$export$931547829ee50720 = (contentId)=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const includeExternalLabels = Boolean(cloudId) && Boolean(contentId) && (0, $9wGTI.fg)('confluence_managed_external_labels_endpoint');
    return {
        includeExternalLabels: includeExternalLabels,
        cloudId: includeExternalLabels ? cloudId : '',
        id: includeExternalLabels ? $ad7e745e3d59b8c7$export$1e91156d5765cc4b(cloudId, contentId) : ''
    };
};
module.exports["buildExternalLabelsAri"] = $ad7e745e3d59b8c7$export$1e91156d5765cc4b;
module.exports["useExternalLabels"] = $ad7e745e3d59b8c7$export$48837ed000c21cf;
module.exports["useExternalLabelsFragment"] = $ad7e745e3d59b8c7$export$7fcfc8c1f94175ba;
module.exports["useExternalLabelsFragmentVariables"] = $ad7e745e3d59b8c7$export$931547829ee50720;

});

parcelRegister("cqob2", function(module, exports) {
/**
 * @generated SignedSource<<69a1f3de73c3ec1c5c64e3b35cea7a4d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $07831018b6e60c32$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ],
    "kind": "Fragment",
    "name": "useExternalLabels_query",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "ConfluenceExternalLabel",
            "kind": "LinkedField",
            "name": "confluence_externalLabels",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "kind"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "Query"
};
$07831018b6e60c32$var$node.hash = "7d28bc802d44490f82047790ad70cb83";
var $07831018b6e60c32$export$2e2bcd8739ae039 = $07831018b6e60c32$var$node;
module.exports["default"] = $07831018b6e60c32$export$2e2bcd8739ae039;

});

parcelRegister("e9oF4", function(module, exports) {
/**
 * @generated SignedSource<<b9754658ef133de839007ab6255673ef>>
 * @relayHash 86987791157c6aeb4f02ade819203bff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f1bebf65bb0058062a5f20b41b072b9b6d77d7dce49de5f8d66e78144518f290
const $d3d143b69f678795$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "ConfluenceExternalLabel",
            "kind": "LinkedField",
            "name": "confluence_externalLabels",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "kind"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useExternalLabelsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useExternalLabelsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "86987791157c6aeb4f02ade819203bff",
            "id": "f1bebf65bb0058062a5f20b41b072b9b6d77d7dce49de5f8d66e78144518f290",
            "metadata": {},
            "name": "useExternalLabelsQuery",
            "operationKind": "query",
            "text": "query useExternalLabelsQuery($cloudId:ID!,$id:ID!){confluence_externalLabels(cloudId:$cloudId,id:$id){id,kind,name}}"
        }
    };
}();
$d3d143b69f678795$var$node.hash = "05a01cd2e9877ac3fd6774883b47072b";
var $d3d143b69f678795$export$2e2bcd8739ae039 = $d3d143b69f678795$var$node;
module.exports["default"] = $d3d143b69f678795$export$2e2bcd8739ae039;

});

parcelRegister("9xoMO", function(module, exports) {

var $dBcar = parcelRequire("dBcar");


var $gxTpP = parcelRequire("gxTpP");


var $5cryL = parcelRequire("5cryL");


var $lohHj = parcelRequire("lohHj");


var $b4VFP = parcelRequire("b4VFP");


var $d282Z = parcelRequire("d282Z");


var $d0hiC = parcelRequire("d0hiC");


var $9DBk6 = parcelRequire("9DBk6");


var $isKLx = parcelRequire("isKLx");


var $1gy7x = parcelRequire("1gy7x");


var $h86CY = parcelRequire("h86CY");


var $jbYIt = parcelRequire("jbYIt");


var $ccGoc = parcelRequire("ccGoc");


var $eoU1C = parcelRequire("eoU1C");


var $2wUAJ = parcelRequire("2wUAJ");


var $6eN5W = parcelRequire("6eN5W");


var $kNKrY = parcelRequire("kNKrY");


var $lIcXr = parcelRequire("lIcXr");


var $bPDOf = parcelRequire("bPDOf");


var $eyUJP = parcelRequire("eyUJP");


var $eC276 = parcelRequire("eC276");


var $fsF73 = parcelRequire("fsF73");


var $bEwOV = parcelRequire("bEwOV");


var $gGieN = parcelRequire("gGieN");


var $exrKs = parcelRequire("exrKs");


var $i1J1l = parcelRequire("i1J1l");


var $iTy0f = parcelRequire("iTy0f");


var $8l6NF = parcelRequire("8l6NF");


var $iQzVo = parcelRequire("iQzVo");


var $4UYoK = parcelRequire("4UYoK");


var $kijQ0 = parcelRequire("kijQ0");


var $93sUJ = parcelRequire("93sUJ");

const $af0fb818e1350632$export$1c433575c0d65d05 = [
    ...(0, $2wUAJ.StorageEnforcementOnboardingKeys),
    ...(0, $dBcar.OnboardingKeys),
    ...(0, $gxTpP.ContextualInviteNudgeOnboardingKeys),
    ...(0, $5cryL.EditorOnboardingKeys),
    ...(0, $d282Z.InsightsOnboardingKeys),
    ...(0, $isKLx.SpaceMissionControlOnboardingKeys),
    ...(0, $h86CY.PresenceAdminFeedbackSurveyOnboardingKeys),
    ...(0, $jbYIt.RoleBasedAccessControlOnboardingKeys),
    ...(0, $ccGoc.RovoVideoPlayerStateOnboardingKeys),
    ...(0, $eoU1C.ShareAndRestrictDialogOnboardingKeys),
    ...(0, $6eN5W.TrialComponentsOnboardingKeys),
    ...(0, $1gy7x.PersonalizedTemplatesOnboardingKeys),
    ...(0, $9DBk6.LiveDocsOnboardingKeys),
    ...(0, $b4VFP.HomeTakeoverOnboardingKeys),
    ...(0, $lohHj.FeedOnboardingKeys),
    ...(0, $d0hiC.LandInSpampleSpaceOnboardingKeys),
    ...(0, $kNKrY.CreateIntroFirstStepOnboardingStateKeys),
    ...(0, $lIcXr.NewContentHistoryOnboardingStateKeys),
    ...(0, $bPDOf.AIFCOnboardingKeys),
    ...(0, $eyUJP.NthUserHomeOnboardingRevampKeys),
    ...(0, $eC276.ExportJiraContextToPageTourKeys),
    ...(0, $fsF73.ConfluenceRecapOnboardingKeys),
    ...(0, $gGieN.SuggestWhiteboardBasedOnPageTitleOnboardingKeys),
    ...(0, $exrKs.SuggestSkillBasedOnPageTitleOnboardingKeys),
    ...(0, $i1J1l.SuggestAgentBasedOnPageTitleOnboardingKeys),
    ...(0, $bEwOV.SnippetsOnboardingKeys),
    ...(0, $iTy0f.SmartLinkDraggableOnboardingKeys),
    ...(0, $8l6NF.ChangeboardingAdminNavTourOnboardingKeys),
    ...(0, $iQzVo.Twcg1489ConnectorOnboardingKeys),
    ...(0, $4UYoK.UniversalCreateCwRExperimentSpotlightOnboardingKeys),
    ...(0, $kijQ0.MeetingsPillNewLozengeOnboardingKeys),
    ...(0, $93sUJ.MeetingsOnboardingKeys)
];
module.exports["OnboardingKeysCombined"] = $af0fb818e1350632$export$1c433575c0d65d05;

});

parcelRegister("gxTpP", function(module, exports) {
const $62a1556a5bf2ef38$export$ed1ceddf3ffdd8ab = {
    EXPERIMENT_ELIGIBLE_TAG: 'onboarding-contextual-invite-nudge:contextualInviteNudgeEligibleTag',
    WAS_CONFETTI_SEEN: 'onboarding-contextual-invite-nudge:wasFirstPublishConfettiSeen'
};
const $62a1556a5bf2ef38$export$fdbc8dd83db637ed = Object.values($62a1556a5bf2ef38$export$ed1ceddf3ffdd8ab);
module.exports["CONTEXTUAL_INVITE_NUDGE"] = $62a1556a5bf2ef38$export$ed1ceddf3ffdd8ab;
module.exports["ContextualInviteNudgeOnboardingKeys"] = $62a1556a5bf2ef38$export$fdbc8dd83db637ed;

});

parcelRegister("5cryL", function(module, exports) {
const $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b = {
    EDITOR_ONBOARDING_ELIGIBLE_NEW: 'editor-state:editorOnboardingEligiblity',
    EDITOR_VISITED: 'editor-state:editorVisited',
    WAS_DRAFT_BANNER_SEEN: 'editor-state:wasDraftBannerSeen',
    IS_DRAFT_BANNER_VISIBLE: 'editor-state:isDraftBannerVisible',
    IS_LAND_IN_EDITOR_BANNER_VISIBLE: 'editor-state:isLandInEditorBannerVisible',
    HAS_USER_PUBLISHED: 'editor-state:hasUserPublished',
    SUCCESS_FLAG_SEEN: 'editor-state:successFlagCompleted',
    RECENT_SPOTLIGHT_OPEN: 'editor-state:recentSpotlightOpen',
    RECENT_SPOTLIGHT_SEEN: 'editor-state:recentSpotlightCompleted',
    EDITOR_TUTORIAL_SUCCESS_FLAG_SEEN: 'editor-state:editorTutorialSuccessFlagCompleted',
    WAS_EDITOR_CONVERSION_DIALOG_SEEN: 'editor-state:wasEditorConversionModalSeen',
    WAS_EDITOR_CONVERSION_DIALOG_V3_SEEN: 'editor-state:wasEditorConversionModalV3Seen'
};
const $d59a11eb5a1dc2b2$export$1a907d3885d0a16c = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-blueprint';
const $d59a11eb5a1dc2b2$export$3cae7707c5db4087 = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-v2-blueprint';
const $d59a11eb5a1dc2b2$export$fa405f661a23ebc5 = 'editor-onboarding';
const $d59a11eb5a1dc2b2$export$caf77613d415fe3 = [
    ...Object.values($d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b),
    $d59a11eb5a1dc2b2$export$1a907d3885d0a16c,
    $d59a11eb5a1dc2b2$export$3cae7707c5db4087
];
module.exports["EDITOR_ONBOARDING_STATE_KEYS"] = $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY"] = $d59a11eb5a1dc2b2$export$1a907d3885d0a16c;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED"] = $d59a11eb5a1dc2b2$export$3cae7707c5db4087;
module.exports["ONBOARDING_TUTORIAL_LABEL"] = $d59a11eb5a1dc2b2$export$fa405f661a23ebc5;
module.exports["EditorOnboardingKeys"] = $d59a11eb5a1dc2b2$export$caf77613d415fe3;

});

parcelRegister("lohHj", function(module, exports) {
const $3f26c87821b680a5$export$215d0f9cb557eff8 = 'onboarding-popular-feed-card:isDismissed';
const $3f26c87821b680a5$export$84bf53f359485dfc = [
    $3f26c87821b680a5$export$215d0f9cb557eff8
];
module.exports["FeedOnboardingKeys"] = $3f26c87821b680a5$export$84bf53f359485dfc;

});

parcelRegister("b4VFP", function(module, exports) {
const $390e454b1ae488b2$export$1d1c13df264a094 = {
    hasSeenHomeNudge: 'home-onboarding-takeover-v2:hasSeenHomeNudge',
    isHomeNudgeScheduledAt: 'home-onboarding-takeover-v2:isHomeNudgeScheduledAt',
    takeoverSeenAt: 'home-onboarding-takeover-v2:takeoverSeenAt',
    onboardingActionStates: 'home-onboarding-takeover-v2:onboardingActionStates',
    isCollapsed: 'home-onboarding-takeover-v2:isCollapsed',
    hasSeenConfetti: 'home-onboarding-takeover-v2:hasSeenConfetti',
    hasDismissedCarousel: 'home-onboarding-takeover-v2:hasDismissedCarousel',
    hasDismissedLearningResources: 'home-onboarding-takeover-v2:hasDismissedLearningResources',
    hasDismissedTakeover: 'home-onboarding-takeover-v2:hasDismissedTakeover'
};
const $390e454b1ae488b2$export$3392b5b28b589b00 = Object.values($390e454b1ae488b2$export$1d1c13df264a094);
module.exports["HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS"] = $390e454b1ae488b2$export$1d1c13df264a094;
module.exports["HomeTakeoverOnboardingKeys"] = $390e454b1ae488b2$export$3392b5b28b589b00;

});

parcelRegister("d282Z", function(module, exports) {
const $a18eeb1d05dccc62$export$fc9b2402bb5adac2 = {
    CONTEXTUAL_FLOATING_BUTTON_NUDGE: 'onboarding-insights:hasContextualFloatingButtonBeenSeen',
    AUDIO_BRIEFING: 'onboarding-insights:hasAudioBriefingChangeboardingBeenSeen',
    AUDIO_V3_CHANGEBOARDING: 'onboarding-insights:hasAudioV3ChangeboardingBeenSeen',
    FLOATING_TABLE_OF_CONTENTS: 'onboarding-insights:hasFloatingTableOfContentsBeenInteractedWith'
};
const $a18eeb1d05dccc62$export$fac0a92023e58acd = Object.values($a18eeb1d05dccc62$export$fc9b2402bb5adac2);
module.exports["ONBOARDING_INSIGHTS"] = $a18eeb1d05dccc62$export$fc9b2402bb5adac2;
module.exports["InsightsOnboardingKeys"] = $a18eeb1d05dccc62$export$fac0a92023e58acd;

});

parcelRegister("d0hiC", function(module, exports) {
const $fd31f36c9d251c72$export$3b7e7c8d78a4b783 = {
    hasDismissedBanner: 'land-in-sample-space:hasDismissedBanner',
    hasSeenSampleContentFlag: 'land-in-sample-space:hasSeenSampleContentFlag'
};
const $fd31f36c9d251c72$export$12692b0da4497e60 = Object.values($fd31f36c9d251c72$export$3b7e7c8d78a4b783);
module.exports["LandInSpampleSpaceOnboardingKeys"] = $fd31f36c9d251c72$export$12692b0da4497e60;

});

parcelRegister("9DBk6", function(module, exports) {
const $d9e19a0d44ee3302$export$b02e3be205ee7739 = {
    LIVE_PAGE_CONTEXTUAL_NUDGE_SEEN: 'live-page-nudge:wasLivePageNudgeSeen',
    // used to limit calls to the invite permissions API
    LIVE_PAGE_INVITE_INELIGIBLE: 'live-page-nudge:livePageNudgeInviteIneligible'
};
const $d9e19a0d44ee3302$export$b3d9533dbdf35d0 = Object.values($d9e19a0d44ee3302$export$b02e3be205ee7739);
module.exports["LIVE_PAGE_NUDGE"] = $d9e19a0d44ee3302$export$b02e3be205ee7739;
module.exports["LiveDocsOnboardingKeys"] = $d9e19a0d44ee3302$export$b3d9533dbdf35d0;

});

parcelRegister("isKLx", function(module, exports) {
const $d14f8037089c8dc2$export$92d46364e5595a5a = {
    SPACE_SETTINGS_CHANGEBOARDING_FIRST_SEEN_AT: 'space-mission-control-onboarding:spaceSettingsChangeboardingFirstSeenAt',
    SPACE_SETTINGS_CHANGEBOARDING_DISMISSED_AT: 'space-mission-control-onboarding:spaceSettingsChangeboardingDismissedAt'
};
const $d14f8037089c8dc2$export$d9eb44525b9507f7 = Object.values($d14f8037089c8dc2$export$92d46364e5595a5a);
module.exports["SpaceMissionControlOnboardingKeys"] = $d14f8037089c8dc2$export$d9eb44525b9507f7;

});

parcelRegister("1gy7x", function(module, exports) {
const $071869849092e495$export$d8593f7ef284bfd8 = {
    onboardingActionStates: 'personalized-templates-v2:onboardingActionStates',
    hasDismissedOnboardingActions: 'personalized-templates-v2:hasDismissedOnboardingActions',
    takeoverSeenAt: 'personalized-templates-v2:takeoverSeenAt',
    isTemplateListDismissed: 'personalized-templates-v2:isTemplateListDismissed',
    templateUsageValues: 'personalized-templates-v2:templateUsageValues'
};
const $071869849092e495$export$67c979693bf8551b = Object.values($071869849092e495$export$d8593f7ef284bfd8);
module.exports["PERSONALIZED_TEMPLATES_V2_ONBOARDING_STATE_KEYS"] = $071869849092e495$export$d8593f7ef284bfd8;
module.exports["PersonalizedTemplatesOnboardingKeys"] = $071869849092e495$export$67c979693bf8551b;

});

parcelRegister("h86CY", function(module, exports) {
const $1dd4a0157170f997$export$f8474b3e5d170456 = {
    PRESENCE_ADMIN_FEEDBACK_SEEN: 'presence-feedback-survey:hasAdminSeenFeedbackSurvey'
};
const $1dd4a0157170f997$export$dcc0ca03f6f8c68d = Object.values($1dd4a0157170f997$export$f8474b3e5d170456);
module.exports["ONBOARDING_PRESENCE_ADMIN_FEEDBACK_SURVEY_KEYS"] = $1dd4a0157170f997$export$f8474b3e5d170456;
module.exports["PresenceAdminFeedbackSurveyOnboardingKeys"] = $1dd4a0157170f997$export$dcc0ca03f6f8c68d;

});

parcelRegister("jbYIt", function(module, exports) {
const $15e5f1cf9df2e13c$export$67837434b2dea54f = {
    USERS_TABLE_SPOTLIGHT_SEEN: 'RoleBasedAccessControl:usersTableSpotlightSeen',
    DEFAULTS_ROLE_TABLE_MODAL_SEEN: 'RoleBasedAccessControl:defaultsRoleTableModalSeen',
    GA_IN_PRODUCT_ONBOARDING_FLAG_SEEN: 'RoleBasedAccessControl:gaInProductOnboardingFlagSeen',
    DEFAULT_ROLE_TABLE_SPOTLIGHT_SEEN: 'RoleBasedAccessControl:defaultRoleTableSpotlightSeen',
    CUSTOM_ROLE_PAGE_SPOTLIGHT_SEEN: 'RoleBasedAccessControl:customRolePageSpotlightSeen'
};
const $15e5f1cf9df2e13c$export$134f165f9f20f01c = Object.values($15e5f1cf9df2e13c$export$67837434b2dea54f);
module.exports["ONBOARDING_ROLE_BASED_ACCESS_CONTROL"] = $15e5f1cf9df2e13c$export$67837434b2dea54f;
module.exports["RoleBasedAccessControlOnboardingKeys"] = $15e5f1cf9df2e13c$export$134f165f9f20f01c;

});

parcelRegister("ccGoc", function(module, exports) {
const $1acbcc6f3166a324$export$fa80c824b7402d9f = {
    ROVO_VIDEO_PLAYER_SEEN: 'onboarding-rovo-video-player:rovoVideoPlayerSeen'
};
const $1acbcc6f3166a324$export$d42bdf2f6333fafd = Object.values($1acbcc6f3166a324$export$fa80c824b7402d9f);
module.exports["RovoVideoPlayerStateOnboardingKeys"] = $1acbcc6f3166a324$export$d42bdf2f6333fafd;

});

parcelRegister("eoU1C", function(module, exports) {
const $b3332cb66ea1a913$export$7f1c6b461c54348b = {
    DIALOG_SPOTLIGHT_SEEN: 'random:ShareAndRestrictDialog:spotlightSeen',
    PUBLIC_LINK_FOOTER_BUTTON_SEEN: 'ShareAndRestrictDialog:editPublicLinkFooterSpotLightSeen',
    EDIT_PUBLIC_LINK_PERMISSION_SEEN: 'ShareAndRestrictDialog:editPublicLinkPermissionSpotLightSeen',
    GENERAL_AND_SPECIFIC_ACCESS_SEEN: 'ShareAndRestrictDialog:generalAndSpecificAccessSpotLightSeen',
    CTA_NOTIFY_MESSAGE_FOOTER_SEEN: 'ShareAndRestrictDialog:ctaNotifyMessageFooterSpotLightSeen'
};
const $b3332cb66ea1a913$export$e5c211f9c9c7792f = Object.values($b3332cb66ea1a913$export$7f1c6b461c54348b);
module.exports["ONBOARDING_SHARE_AND_RESTRICT_DIALOG"] = $b3332cb66ea1a913$export$7f1c6b461c54348b;
module.exports["ShareAndRestrictDialogOnboardingKeys"] = $b3332cb66ea1a913$export$e5c211f9c9c7792f;

});

parcelRegister("2wUAJ", function(module, exports) {
const $70d55b678e14166c$export$13e578b1c1856d6f = {
    FLAGS_DISMISSED_FREE_THRESHOLD: 'storage-enforcement-state:flagsDismissedFreeThreshold'
};
const $70d55b678e14166c$export$abe3d9e5b5171ebf = Object.values($70d55b678e14166c$export$13e578b1c1856d6f);
module.exports["STORAGE_ENFORCEMENT_STATE_KEYS"] = $70d55b678e14166c$export$13e578b1c1856d6f;
module.exports["StorageEnforcementOnboardingKeys"] = $70d55b678e14166c$export$abe3d9e5b5171ebf;

});

parcelRegister("6eN5W", function(module, exports) {
const $e04ddb4a5df5bba6$export$840dd6f6c8ecd45f = {
    ACTION_MENU_OPENED: 'trial-components:actionMenuOpened',
    TRIAL_1_DAY_FLAG_DISMISSED: 'trial-components:dismissedTrial1DayFlag',
    TRIAL_3_DAY_FLAG_DISMISSED: 'trial-components:dismissedTrial3DayFlag',
    GRACE_PERIOD_0_DAY_FLAG_DISMISSED: 'trial-components:dismissedPredunning0DayFlag',
    GRACE_PERIOD_1_DAY_FLAG_DISMISSED: 'trial-components:dismissedPredunning1DayFlag',
    GRACE_PERIOD_2_DAY_FLAG_DISMISSED: 'trial-components:dismissedPredunning2DayFlag',
    GRACE_PERIOD_3_DAY_FLAG_DISMISSED: 'trial-components:dismissedPredunning3DayFlag',
    TRIAL_UNHANDLED_DAY_FLAG_DISMISSED: 'trial-components:dismissedTrialUnhandledDayFlag'
};
const $e04ddb4a5df5bba6$export$8001dc7a7ed753e1 = Object.values($e04ddb4a5df5bba6$export$840dd6f6c8ecd45f);
module.exports["TRIAL_COMPONENTS_EXPERIENCES"] = $e04ddb4a5df5bba6$export$840dd6f6c8ecd45f;
module.exports["TrialComponentsOnboardingKeys"] = $e04ddb4a5df5bba6$export$8001dc7a7ed753e1;

});

parcelRegister("kNKrY", function(module, exports) {
const $9b3060c835515c41$export$ff14eab135fe9584 = {
    headerSeenAt: 'create-intro-first-step:headerSeenAt',
    headerCompleted: 'create-intro-first-step:headerCompleted',
    headerDismissed: 'create-intro-first-step:headerDismissed'
};
const $9b3060c835515c41$export$1c0fd29b58a87c97 = Object.values($9b3060c835515c41$export$ff14eab135fe9584);
module.exports["CreateIntroFirstStepOnboardingStateKeys"] = $9b3060c835515c41$export$1c0fd29b58a87c97;

});

parcelRegister("lIcXr", function(module, exports) {
const $06a9ae8b05df4a8c$export$561442d092b808c6 = {
    HAS_SEEN_SPOTLIGHT: 'new-content-history-onboarding:hasSeenSpotlight1'
};
const $06a9ae8b05df4a8c$export$a8854c7bde991ac7 = Object.values($06a9ae8b05df4a8c$export$561442d092b808c6);
module.exports["NEW_CONTENT_HISTORY_ONBOARDING_STATE_KEYS"] = $06a9ae8b05df4a8c$export$561442d092b808c6;
module.exports["NewContentHistoryOnboardingStateKeys"] = $06a9ae8b05df4a8c$export$a8854c7bde991ac7;

});

parcelRegister("eyUJP", function(module, exports) {
const $37b72543ace58c19$export$a266d7c13575e674 = {
    onboardingActionStates: 'nth-user-home-onboarding-revamp:onboardingActionStates',
    areAllActionsDismissed: 'nth-user-home-onboarding-revamp:areAllActionsDismissed',
    takeoverSeenAt: 'nth-user-home-onboarding-revamp:takeoverSeenAt',
    isTemplateListDismissed: 'nth-user-home-onboarding-revamp:isTemplateListDismissed',
    templateUsageValues: 'nth-user-home-onboarding-revamp:templateUsageValues'
};
const $37b72543ace58c19$export$f9348e90ce13bd50 = Object.values($37b72543ace58c19$export$a266d7c13575e674);
module.exports["NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS"] = $37b72543ace58c19$export$a266d7c13575e674;
module.exports["NthUserHomeOnboardingRevampKeys"] = $37b72543ace58c19$export$f9348e90ce13bd50;

});

parcelRegister("eC276", function(module, exports) {
const $6acee6b0894846a1$export$fe11c6170169891b = {
    TOUR_COMPLETED: 'random:ExportJiraContextToPage:tourCompleted',
    TOUR_DISMISSED: 'random:ExportJiraContextToPage:tourDismissed'
};
const $6acee6b0894846a1$export$7eebc92289f9ff40 = Object.values($6acee6b0894846a1$export$fe11c6170169891b);
module.exports["ExportJiraContextToPageTourKeys"] = $6acee6b0894846a1$export$7eebc92289f9ff40;

});

parcelRegister("fsF73", function(module, exports) {
const $29520d740d888926$export$84bb2ff8e52d4c63 = {
    HAS_SEEN_PUBLISH_SPOTLIGHT: 'confluence-recap:hasSeenPublishSpotlight'
};
const $29520d740d888926$export$42e96b8eba35eec9 = Object.values($29520d740d888926$export$84bb2ff8e52d4c63);
module.exports["CONFLUENCE_RECAP_ONBOARDING_STATE_KEYS"] = $29520d740d888926$export$84bb2ff8e52d4c63;
module.exports["ConfluenceRecapOnboardingKeys"] = $29520d740d888926$export$42e96b8eba35eec9;

});

parcelRegister("bEwOV", function(module, exports) {
const $91bce0a19c17c87b$export$608e762b0e8c3e5d = {
    HAS_SEEN_FIRST_SNIPPET_CREATED_MODAL: 'snippets:hasSeenFirstSnippetCreatedModal',
    HAS_SEEN_SNIPPETS_TAB_SPOTLIGHT: 'snippets:hasSeenSnippetsTabSpotlight'
};
const $91bce0a19c17c87b$export$cf7ec9d4d7075704 = Object.values($91bce0a19c17c87b$export$608e762b0e8c3e5d);
module.exports["SNIPPETS_ONBOARDING"] = $91bce0a19c17c87b$export$608e762b0e8c3e5d;
module.exports["SnippetsOnboardingKeys"] = $91bce0a19c17c87b$export$cf7ec9d4d7075704;

});

parcelRegister("gGieN", function(module, exports) {
const $24bab03e25b23f73$export$df82485048e605d4 = {
    hasDismissedFlowChart: 'suggest-whiteboard-based-on-page-title:hasDismissedFlowChart',
    hasDismissedBrainstorming: 'suggest-whiteboard-based-on-page-title:hasDismissedBrainstorming',
    hasDismissedRetro: 'suggest-whiteboard-based-on-page-title:hasDismissedRetro',
    hasDismissedProductRoadmap: 'suggest-whiteboard-based-on-page-title:hasDismissedProductRoadmap',
    hasDismissedPrioritizationMatrix: 'suggest-whiteboard-based-on-page-title:hasDismissedPrioritizationMatrix',
    hasDismissedOrgChart: 'suggest-whiteboard-based-on-page-title:hasDismissedOrgChart',
    hasDismissedStickyNotePack: 'suggest-whiteboard-based-on-page-title:hasDismissedStickyNotePack',
    hasDismissedAllTemplateSuggestions: 'suggest-whiteboard-based-on-page-title:hasDismissedAllTemplateSuggestions'
};
const $24bab03e25b23f73$export$70c9c230d84d75ef = Object.values($24bab03e25b23f73$export$df82485048e605d4);
module.exports["SUGGEST_WHITEBOARD_BASED_ON_PAGE_TITLE_ONBOARDING_STATE_KEYS"] = $24bab03e25b23f73$export$df82485048e605d4;
module.exports["SuggestWhiteboardBasedOnPageTitleOnboardingKeys"] = $24bab03e25b23f73$export$70c9c230d84d75ef;

});

parcelRegister("exrKs", function(module, exports) {
const $0be47723f71ecf5a$export$68726aa6479c32ea = {
    hasDismissedWritePrd: 'suggest-skill-based-on-page-title:hasDismissedWritePrd',
    hasDismissedWriteHowToArticle: 'suggest-skill-based-on-page-title:hasDismissedWriteHowToArticle',
    hasDismissedResearchInsights: 'suggest-skill-based-on-page-title:hasDismissedResearchInsights',
    hasDismissedCreateActionPlan: 'suggest-skill-based-on-page-title:hasDismissedCreateActionPlan',
    hasDismissedMarketingBriefSkill: 'suggest-skill-based-on-page-title:hasDismissedMarketingBriefSkill',
    hasDismissedAllSkillSuggestions: 'suggest-skill-based-on-page-title:hasDismissedAllSkillSuggestions'
};
const $0be47723f71ecf5a$export$fde582fc9946f220 = Object.values($0be47723f71ecf5a$export$68726aa6479c32ea);
module.exports["SUGGEST_SKILL_BASED_ON_PAGE_TITLE_ONBOARDING_STATE_KEYS"] = $0be47723f71ecf5a$export$68726aa6479c32ea;
module.exports["SuggestSkillBasedOnPageTitleOnboardingKeys"] = $0be47723f71ecf5a$export$fde582fc9946f220;

});

parcelRegister("i1J1l", function(module, exports) {
const $2942cd38c2776ad9$export$589fce97fb79e61b = {
    // Planner
    hasDismissedPlannerOnce: 'suggest-agent-based-on-page-title:hasDismissedPlannerOnce',
    hasDismissedPlannerPermanently: 'suggest-agent-based-on-page-title:hasDismissedPlannerPermanently',
    hasDismissedDiscoveryAndFeedbackOnce: 'suggest-agent-based-on-page-title:hasDismissedDiscoveryAndFeedbackOnce',
    hasDismissedDiscoveryAndFeedbackPermanently: 'suggest-agent-based-on-page-title:hasDismissedDiscoveryAndFeedbackPermanently',
    hasShownTechWriterContentIds: 'suggest-agent-based-on-page-title:hasShownTechWriterContentIds',
    catalogState: 'suggest-agent-based-on-page-title:catalogState'
};
const $2942cd38c2776ad9$export$ecbd342637c16a8a = Object.values($2942cd38c2776ad9$export$589fce97fb79e61b);
const $2942cd38c2776ad9$export$d3824c57be9dc0d6 = [
    $2942cd38c2776ad9$export$589fce97fb79e61b.hasDismissedPlannerPermanently,
    $2942cd38c2776ad9$export$589fce97fb79e61b.hasDismissedDiscoveryAndFeedbackPermanently
];
module.exports["SuggestAgentBasedOnPageTitleOnboardingKeys"] = $2942cd38c2776ad9$export$ecbd342637c16a8a;

});

parcelRegister("iTy0f", function(module, exports) {
const $f4695f4ca31fd51c$export$a6cb5d34cb10fc27 = {
    CHANGEBOARD_VIEWED: 'smart-link-draggable:changeboardViewed'
};
const $f4695f4ca31fd51c$export$1a93287f12972b73 = Object.values($f4695f4ca31fd51c$export$a6cb5d34cb10fc27);
module.exports["SmartLinkDraggableOnboardingKeys"] = $f4695f4ca31fd51c$export$1a93287f12972b73;

});

parcelRegister("8l6NF", function(module, exports) {
/**
 * Onboarding-state keys for the admin-nav changeboarding tour. The tour is a
 * 3-step popover walkthrough shown to product admins the first time they
 * land on Confluence Admin after the RBAC admin modernization experiment
 * ships.
 */ const $aa5a5848fd75f53d$export$85befb6401d118b0 = {
    TOUR_SEEN: 'changeboarding-admin-nav-tour:tourSeen'
};
const $aa5a5848fd75f53d$export$d48b7123660bbab = [
    $aa5a5848fd75f53d$export$85befb6401d118b0.TOUR_SEEN
];
module.exports["CHANGEBOARDING_ADMIN_NAV_TOUR"] = $aa5a5848fd75f53d$export$85befb6401d118b0;
module.exports["ChangeboardingAdminNavTourOnboardingKeys"] = $aa5a5848fd75f53d$export$d48b7123660bbab;

});

parcelRegister("4UYoK", function(module, exports) {
/**
 * Onboarding-state keys for the spotlight that is anchored to the Universal
 * Create menu dropdown shown the first time a user in the Universal Create
 * (CwR) experiment cohort opens the create menu.
 */ const $88afb75838a9f8b5$export$134ea9981ab0c82e = {
    hasSeenUniversalCreateCwRExperimentSpotlight: 'universal-create-cwr-experiment-spotlight:hasSeenUniversalCreateCwRExperimentSpotlight'
};
const $88afb75838a9f8b5$export$5b55ba0fa31f0184 = Object.values($88afb75838a9f8b5$export$134ea9981ab0c82e);
module.exports["UNIVERSAL_CREATE_CWR_EXPERIMENT_SPOTLIGHT_ONBOARDING_STATE_KEYS"] = $88afb75838a9f8b5$export$134ea9981ab0c82e;
module.exports["UniversalCreateCwRExperimentSpotlightOnboardingKeys"] = $88afb75838a9f8b5$export$5b55ba0fa31f0184;

});

parcelRegister("kijQ0", function(module, exports) {
const $d25de9b113b7e89d$export$c5731692e18a3b07 = 'meetings-pill-new-lozenge:firstSeenAt';
const $d25de9b113b7e89d$export$cea43ec254f1512b = 'meetings-pill-new-lozenge:clickCount';
const $d25de9b113b7e89d$export$78eeb8847faa424a = [
    $d25de9b113b7e89d$export$c5731692e18a3b07,
    $d25de9b113b7e89d$export$cea43ec254f1512b
];
module.exports["MEETINGS_PILL_NEW_LOZENGE_FIRST_SEEN_AT_KEY"] = $d25de9b113b7e89d$export$c5731692e18a3b07;
module.exports["MEETINGS_PILL_NEW_LOZENGE_CLICK_COUNT_KEY"] = $d25de9b113b7e89d$export$cea43ec254f1512b;
module.exports["MeetingsPillNewLozengeOnboardingKeys"] = $d25de9b113b7e89d$export$78eeb8847faa424a;

});

parcelRegister("93sUJ", function(module, exports) {
// Persisted flag for the Meetings-panel onboarding example state (STARB-4361).
// Once the onboarding is retired — the user dismisses it via the ✕, or a real
// recorded meeting appears — this is set to `'true'` and the example never shows
// again (the panel falls through to the empty state). Per-user, server-side,
// cross-device.
const $c6245f54c912fb87$export$5922cd883734f0ff = 'meetings-onboarding:retired';
const $c6245f54c912fb87$export$53572b29fe84aaf9 = 'meetings-onboarding:notesContentId';
const $c6245f54c912fb87$export$95300effd89f6a97 = 'meetings-onboarding:acceptedActions';
const $c6245f54c912fb87$export$bed5eff8608627ac = [
    $c6245f54c912fb87$export$5922cd883734f0ff,
    $c6245f54c912fb87$export$53572b29fe84aaf9,
    $c6245f54c912fb87$export$95300effd89f6a97
];
module.exports["MEETINGS_ONBOARDING_RETIRED_KEY"] = $c6245f54c912fb87$export$5922cd883734f0ff;
module.exports["MEETINGS_ONBOARDING_NOTES_CONTENT_ID_KEY"] = $c6245f54c912fb87$export$53572b29fe84aaf9;
module.exports["MEETINGS_ONBOARDING_ACCEPTED_ACTIONS_KEY"] = $c6245f54c912fb87$export$95300effd89f6a97;
module.exports["MeetingsOnboardingKeys"] = $c6245f54c912fb87$export$bed5eff8608627ac;

});

parcelRegister("cRQNp", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $j25oo = parcelRequire("j25oo");

function $345f814d0887da7c$export$8301c585ee328ce0({ contentId: contentId, includeContentBody: includeContentBody = true, status: status, useCache: useCache }) {
    return (0, $dYU3e.query)({
        query: (0, $j25oo.default),
        variables: {
            contentId: contentId,
            includeContentBody: includeContentBody,
            status: status
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "read-time"
    });
}
module.exports["preloadReadTime"] = $345f814d0887da7c$export$8301c585ee328ce0;

});

parcelRegister("j25oo", function(module, exports) {
/**
 * @generated SignedSource<<b0ed3f943392beb78acd9d9ea9b42788>>
 * @relayHash 24201b9545ec89a2ece8511e9a2a8999
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b3c5854ab0548b89c651d5a1e8fc47a2aa65f94c49e96a88597856cd78fc203c
const $6b1bc0e8ad61af00$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "includeContentBody"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "condition": "includeContentBody",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "dynamic",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "representation"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useReadTimeQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useReadTimeQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "24201b9545ec89a2ece8511e9a2a8999",
            "id": "b3c5854ab0548b89c651d5a1e8fc47a2aa65f94c49e96a88597856cd78fc203c",
            "metadata": {},
            "name": "useReadTimeQuery",
            "operationKind": "query",
            "text": "query useReadTimeQuery($contentId:ID,$status:[String],$includeContentBody:Boolean=true){content(id:$contentId,status:$status){nodes{id,type,body@include(if:$includeContentBody){dynamic{value,representation}},operations{operation,targetType}}}}"
        }
    };
}();
$6b1bc0e8ad61af00$var$node.hash = "1de89fa5a6335c6c91c524557c055ef1";
var $6b1bc0e8ad61af00$export$2e2bcd8739ae039 = $6b1bc0e8ad61af00$var$node;
module.exports["default"] = $6b1bc0e8ad61af00$export$2e2bcd8739ae039;

});

parcelRegister("aqBZ0", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $1f65bcd6ebccf55c$export$41b2e06f27dfe96e = 'archived';
const $1f65bcd6ebccf55c$export$e2153f1ee0381860 = 'ARCHIVE_';
const $1f65bcd6ebccf55c$export$c8e98879124fb1f0 = 'UNARCHIVE_';
const $1f65bcd6ebccf55c$export$781b73bccf46ba2c = 255;
const $1f65bcd6ebccf55c$export$ab874a69c0b17d25 = 500;
var $1f65bcd6ebccf55c$export$ca079fdb822b790f = /*#__PURE__*/ function(ArchiveStatus) {
    ArchiveStatus["LOADING"] = "loading";
    ArchiveStatus["ERROR"] = "error";
    ArchiveStatus["SUCCESS"] = "success";
    return ArchiveStatus;
}({});
const $1f65bcd6ebccf55c$export$90622b83e51be397 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
const $1f65bcd6ebccf55c$export$a2742df05b19b873 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/#When-content-is-inheriting-restrictions-from-parent-content';
const $1f65bcd6ebccf55c$export$9de02bef22980fc = 'https://support.atlassian.com/confluence-cloud/docs/archive-pages/#Who-can-archive-an-item';
const $1f65bcd6ebccf55c$export$45c8fb669461b6d5 = 'https://support.atlassian.com/confluence-cloud/docs/restore-archived-pages-to-the-page-tree/#Who-can-restore-an-item';
const $1f65bcd6ebccf55c$export$f71e45bebd610efa = 'archivedPageBanner';
const $1f65bcd6ebccf55c$export$7d669dd29a0917b2 = 'archive-page-banner-restore-link';
const $1f65bcd6ebccf55c$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    restoreLinkMessage: {
        id: "archive-pages.page-banner.link.unarchive",
        defaultMessage: "Restore"
    },
    learnMoreLinkMessage: {
        id: "archive-pages.page-banner.link.learn-more",
        defaultMessage: "Learn more"
    },
    hasRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-restorable",
        defaultMessage: "This content is archived. Restore to make changes."
    },
    noRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-unrestorable",
        defaultMessage: "This content is archived."
    }
});
module.exports["CONTENT_STATUS_ARCHIVED"] = $1f65bcd6ebccf55c$export$41b2e06f27dfe96e;
module.exports["ARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$e2153f1ee0381860;
module.exports["UNARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$c8e98879124fb1f0;
module.exports["ARCHIVE_PAGES_WITH_NOTE_CHARACTER_LIMIT"] = $1f65bcd6ebccf55c$export$781b73bccf46ba2c;
module.exports["BULK_ARCHIVE_PAGE_SELECTION_LIMIT"] = $1f65bcd6ebccf55c$export$ab874a69c0b17d25;
module.exports["ArchiveStatus"] = $1f65bcd6ebccf55c$export$ca079fdb822b790f;
module.exports["PAGE_INHERITED_RESTRICTIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$a2742df05b19b873;
module.exports["ARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$9de02bef22980fc;
module.exports["UNARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$45c8fb669461b6d5;
module.exports["ARCHIVED_PAGE_BANNER_ANALYTICS_SOURCE"] = $1f65bcd6ebccf55c$export$f71e45bebd610efa;
module.exports["ARCHIVED_PAGE_BANNER_RESTORE_LINK_TESTID"] = $1f65bcd6ebccf55c$export$7d669dd29a0917b2;
module.exports["i18n"] = $1f65bcd6ebccf55c$export$a7357cdd1f0b0168;

});

parcelRegister("ccWUN", function(module, exports) {
/**
 * @generated SignedSource<<655e5b5d54928e9a3dbeab0fae4a36b9>>
 * @relayHash b9d1efe6b1cd056569e39345117f0c88
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 81989b0b417d33031602bc94683f12b047f59581ccbc8926b307e0c037ab314c
const $462dea7d21a073f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "archived",
                "current"
            ]
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v5 = {
        "concreteType": "ArchivedContentMetadata",
        "kind": "LinkedField",
        "name": "archivedContentMetadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "archiveNote"
            }
        ]
    }, v6 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v7 = {
        "kind": "InlineFragment",
        "selections": v6 /*: any*/ ,
        "type": "KnownUser"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": v6 /*: any*/ ,
        "type": "UnknownUser"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ArchivedPageBannerV2ArchivedPageBannerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "lastUpdated",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ArchivedPageBannerV2_content"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ArchivedPageBannerV2ArchivedPageBannerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "lastUpdated",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b9d1efe6b1cd056569e39345117f0c88",
            "id": "81989b0b417d33031602bc94683f12b047f59581ccbc8926b307e0c037ab314c",
            "metadata": {},
            "name": "ArchivedPageBannerV2ArchivedPageBannerQuery",
            "operationKind": "query",
            "text": "query ArchivedPageBannerV2ArchivedPageBannerQuery($contentId:ID){content(id:$contentId,status:[\"archived\",\"current\"]){nodes{id,type,operations{operation,targetType},archivedContentMetadata{archiveNote},history{lastUpdated{by{__typename,...on KnownUser{accountId},...on UnknownUser{accountId}}}},...ArchivedPageBannerV2_content}}}fragment ArchivedPageBannerV2_content on Content{id,type,operations{operation,targetType},archivedContentMetadata{archiveNote},history{lastUpdated{by{__typename,...on KnownUser{accountId},...on UnknownUser{accountId}}}}}"
        }
    };
}();
$462dea7d21a073f6$var$node.hash = "f6e1082054df2975d0307494e9090b59";
var $462dea7d21a073f6$export$2e2bcd8739ae039 = $462dea7d21a073f6$var$node;
module.exports["default"] = $462dea7d21a073f6$export$2e2bcd8739ae039;

});

parcelRegister("gFF2G", function(module, exports) {
/**
 * @generated SignedSource<<b09412736b8beecddca9546c0e2759d4>>
 * @relayHash 30a7ec0bd1bc84739eda7e4fe244b93f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0842a0612fc51286d828e08036899cfa0544d19e34074003bb58229be73c3c8d
const $385b63e5393fb4b0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "archived",
                        "current"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "30a7ec0bd1bc84739eda7e4fe244b93f",
            "id": "0842a0612fc51286d828e08036899cfa0544d19e34074003bb58229be73c3c8d",
            "metadata": {},
            "name": "ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
            "operationKind": "query",
            "text": "query ArchivedPageBannerV2ArchivedPageBannerContainerQuery($contentId:ID){content(id:$contentId,status:[\"archived\",\"current\"]){nodes{id,status}}}"
        }
    };
}();
$385b63e5393fb4b0$var$node.hash = "c639141edd782146ad296893dc79f146";
var $385b63e5393fb4b0$export$2e2bcd8739ae039 = $385b63e5393fb4b0$var$node;
module.exports["default"] = $385b63e5393fb4b0$export$2e2bcd8739ae039;

});

parcelRegister("4trRg", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $flWvL = parcelRequire("flWvL");


var $joyRP = parcelRequire("joyRP");

const $b51af1b6a5dfb3b5$export$79f4fda3b987b044 = ({ contentId: contentId, isDraft: isDraft, useCache: useCache = false, isArchived: isArchived })=>{
    const status = (0, $flWvL.queryStatusFor)(isDraft, isArchived);
    return (0, $dYU3e.query)({
        query: (0, $joyRP.default),
        variables: {
            contentId: contentId,
            isDraft: isDraft,
            status: [
                status
            ]
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "editor-content-mode-button"
    });
};
module.exports["preloadContentMode"] = $b51af1b6a5dfb3b5$export$79f4fda3b987b044;

});

parcelRegister("flWvL", function(module, exports) {
const $601c87545eb15d39$export$7744ef788ce8060b = (server)=>{
    if (typeof server === 'string') {
        const v = server.toLowerCase();
        if (v === 'compact') return 'compact';
    }
    return 'standard';
};
const $601c87545eb15d39$export$c21c52065fb17015 = (ui)=>ui === 'compact' ? 'COMPACT' : 'STANDARD';
const $601c87545eb15d39$export$9b5b746082006bde = (m)=>m === 'compact' ? 'standard' : 'compact';
const $601c87545eb15d39$export$bc47da214dd10736 = (opts)=>{
    if (opts.isLivePage) return 'CURRENT';
    if (opts.isEditorPage) return 'DRAFT';
    return 'CURRENT';
};
const $601c87545eb15d39$export$7052ab1304ba8160 = (isDraft, isArchived)=>{
    return isArchived ? 'archived' : isDraft ? 'draft' : 'current';
};
module.exports["serverToUiContentMode"] = $601c87545eb15d39$export$7744ef788ce8060b;
module.exports["uiToServerContentMode"] = $601c87545eb15d39$export$c21c52065fb17015;
module.exports["flipContentMode"] = $601c87545eb15d39$export$9b5b746082006bde;
module.exports["resolveContentStatus"] = $601c87545eb15d39$export$bc47da214dd10736;
module.exports["queryStatusFor"] = $601c87545eb15d39$export$7052ab1304ba8160;

});

parcelRegister("joyRP", function(module, exports) {
/**
 * @generated SignedSource<<11e8316517ac59e0b0326a7aa3a855c6>>
 * @relayHash ff452defe6c30c6aef6cb69359d0b5a9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 34a936a3c8d22258a1afe16bee6383e33250109cc96bccd4cb0241a006a579ad
const $fd020ad5a5ea36ff$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDraft"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "contentMode"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "isDraft",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "concreteType": "PublishedContentProperties",
                                            "kind": "LinkedField",
                                            "name": "latest",
                                            "plural": false,
                                            "selections": v1 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "condition": "isDraft",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "DraftContentProperties",
                                            "kind": "LinkedField",
                                            "name": "draft",
                                            "plural": false,
                                            "selections": v1 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEditorContentModeValueQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEditorContentModeValueQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ff452defe6c30c6aef6cb69359d0b5a9",
            "id": "34a936a3c8d22258a1afe16bee6383e33250109cc96bccd4cb0241a006a579ad",
            "metadata": {},
            "name": "useEditorContentModeValueQuery",
            "operationKind": "query",
            "text": "query useEditorContentModeValueQuery($contentId:ID!,$isDraft:Boolean!,$status:[String]){content(id:$contentId,status:$status){nodes{id,contentProperties{latest@skip(if:$isDraft){contentMode},draft@include(if:$isDraft){contentMode}}}}}"
        }
    };
}();
$fd020ad5a5ea36ff$var$node.hash = "51a479801516afe1b59a1bbcd1c3f7d5";
var $fd020ad5a5ea36ff$export$2e2bcd8739ae039 = $fd020ad5a5ea36ff$var$node;
module.exports["default"] = $fd020ad5a5ea36ff$export$2e2bcd8739ae039;

});

parcelRegister("gad6U", function(module, exports) {
/**
 * @generated SignedSource<<c2d774a48c90fa70a24cdb1130a0d5d5>>
 * @relayHash 05121d91dabaeb1256fcb9012d73ba65
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c83d09eb0de6a3bf710d7364431c8200591175f07d8ff8317f01a5255ea13554
const $ad449ae2ccc67b2c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "value"
    }, v6 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v2 /*: any*/ ,
                    v5 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v9 = [
        v7 /*: any*/ ,
        v8 /*: any*/ 
    ], v10 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "base"
            }
        ]
    }, v11 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "editor"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"editor\"])"
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v7 /*: any*/ ,
        v8 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAudioContentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v9 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v9 /*: any*/ 
                                }
                            ]
                        },
                        v10 /*: any*/ ,
                        v11 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAudioContentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v12 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v12 /*: any*/ 
                                }
                            ]
                        },
                        v10 /*: any*/ ,
                        v11 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "05121d91dabaeb1256fcb9012d73ba65",
            "id": "c83d09eb0de6a3bf710d7364431c8200591175f07d8ff8317f01a5255ea13554",
            "metadata": {},
            "name": "useAudioContentQuery",
            "operationKind": "query",
            "text": "query useAudioContentQuery($contentId:ID!){singleContent(id:$contentId){id,title,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},history{createdBy{__typename,displayName,profilePicture{path}},ownedBy{__typename,displayName,profilePicture{path}}},links{webui,base},properties(keys:[\"emoji-title-published\",\"editor\"]){nodes{value,key}}}}"
        }
    };
}();
$ad449ae2ccc67b2c$var$node.hash = "a697f593a36975591a0fa8257ca3e174";
var $ad449ae2ccc67b2c$export$2e2bcd8739ae039 = $ad449ae2ccc67b2c$var$node;
module.exports["default"] = $ad449ae2ccc67b2c$export$2e2bcd8739ae039;

});

parcelRegister("lKLmX", function(module, exports) {
/**
 * @generated SignedSource<<0fb7b778e884fde647da24980606dd2b>>
 * @relayHash 0e97369e1bfa5659fc7cb13e5e23293d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ef04a28901a87d914dea7ee1db36f3d9adc5f2ceeff420236ef0357e7a9388a9
const $c7a72aad1b5e4549$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeApprovalExpirationConfig"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeApprovalsBetaFeatures"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "otherContentStatus"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "transitionType"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "spaceKey"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            {
                "concreteType": "SpaceTypeSettings",
                "kind": "LinkedField",
                "name": "spaceTypeSettings",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "EnabledFeatures",
                        "kind": "LinkedField",
                        "name": "enabledFeatures",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isContentApprovalsEnabled"
                            }
                        ]
                    }
                ]
            },
            {
                "condition": "includeApprovalExpirationConfig",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "SpaceSettings",
                        "kind": "LinkedField",
                        "name": "settings",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "ContentStateSettings",
                                "kind": "LinkedField",
                                "name": "contentStateSettings",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "ContentState",
                                        "kind": "LinkedField",
                                        "name": "spaceContentStates",
                                        "plural": true,
                                        "selections": [
                                            v8 /*: any*/ ,
                                            v9 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v11 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "success"
    }, v13 = {
        "kind": "ScalarField",
        "name": "message"
    }, v14 = {
        "kind": "ScalarField",
        "name": "isEnabled"
    }, v15 = {
        "kind": "ScalarField",
        "name": "value"
    }, v16 = {
        "kind": "ScalarField",
        "name": "principalType"
    }, v17 = {
        "kind": "ScalarField",
        "name": "principalId"
    }, v18 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v19 = {
        "kind": "ScalarField",
        "name": "isActive"
    }, v20 = {
        "kind": "ScalarField",
        "name": "isPrimary"
    }, v21 = [
        v8 /*: any*/ ,
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        {
            "concreteType": "AtlassianUserPhoto",
            "kind": "LinkedField",
            "name": "photos",
            "plural": true,
            "selections": [
                v15 /*: any*/ ,
                v20 /*: any*/ 
            ]
        }
    ], v22 = {
        "condition": "includeApprovalsBetaFeatures",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    v11 /*: any*/ 
                ],
                "concreteType": "ConfluenceContentApprovalsSiteSettings",
                "kind": "LinkedField",
                "name": "confluence_contentApprovalsSiteSettings",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "enabled"
                    }
                ]
            },
            {
                "args": [
                    v11 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "filterSelf",
                        "value": false
                    },
                    {
                        "kind": "Variable",
                        "name": "spaceKey",
                        "variableName": "spaceKey"
                    }
                ],
                "concreteType": "ConfluenceContentApprovalsSpaceSettingConfigPayload",
                "kind": "LinkedField",
                "name": "confluence_contentApprovalsSpaceSettingConfig",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    {
                        "concreteType": "MutationError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            v13 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "ConfluenceContentApprovalsSpaceSettingConfig",
                        "kind": "LinkedField",
                        "name": "config",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "disallowFirstPublish"
                            },
                            {
                                "condition": "includeApprovalExpirationConfig",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "concreteType": "ConfluenceApprovalExpirationConfig",
                                        "kind": "LinkedField",
                                        "name": "approvalExpirationConfig",
                                        "plural": false,
                                        "selections": [
                                            v14 /*: any*/ ,
                                            {
                                                "concreteType": "ConfluenceApprovalExpirationInterval",
                                                "kind": "LinkedField",
                                                "name": "interval",
                                                "plural": false,
                                                "selections": [
                                                    v15 /*: any*/ ,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "unit"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "restartApproval"
                                            },
                                            {
                                                "concreteType": "ConfluenceApprovalExpirationChangeStatus",
                                                "kind": "LinkedField",
                                                "name": "changeStatus",
                                                "plural": false,
                                                "selections": [
                                                    v14 /*: any*/ ,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "expireToContentStateId"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "concreteType": "ConfluenceApprovalReviewerConfig",
                                "kind": "LinkedField",
                                "name": "enforcedApprovalReviewerConfig",
                                "plural": false,
                                "selections": [
                                    v14 /*: any*/ ,
                                    {
                                        "concreteType": "ConfluenceSpaceApprovalReviewerEntry",
                                        "kind": "LinkedField",
                                        "name": "reviewers",
                                        "plural": true,
                                        "selections": [
                                            v16 /*: any*/ ,
                                            v17 /*: any*/ ,
                                            {
                                                "concreteType": "AtlassianUser",
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": v21 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v23 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v24 = {
        "kind": "ScalarField",
        "name": "status"
    }, v25 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "number"
            }
        ]
    }, v26 = {
        "args": [
            v11 /*: any*/ ,
            {
                "kind": "Variable",
                "name": "transitionType",
                "variableName": "transitionType"
            }
        ],
        "concreteType": "ConfluenceApprovalsWorkflowStatus",
        "kind": "LinkedField",
        "name": "confluence_contentApprovalStatuses",
        "plural": true,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "allowsReviews"
            },
            {
                "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
                "kind": "LinkedField",
                "name": "displayProperties",
                "plural": false,
                "selections": [
                    v9 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    }
                ]
            }
        ]
    }, v27 = {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
    }, v28 = {
        "kind": "Literal",
        "name": "fetchWorkflowReview",
        "value": true
    }, v29 = {
        "kind": "Literal",
        "name": "workflowId",
        "value": "1"
    }, v30 = [
        v11 /*: any*/ ,
        v27 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "otherContentStatus"
        },
        v28 /*: any*/ ,
        v29 /*: any*/ 
    ], v31 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v32 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v33 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v13 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    v31 /*: any*/ ,
                    v32 /*: any*/ 
                ]
            }
        ]
    }, v34 = {
        "kind": "ScalarField",
        "name": "reviewStatus"
    }, v35 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            v34 /*: any*/ 
        ]
    }, v36 = [
        v11 /*: any*/ ,
        v27 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        v28 /*: any*/ ,
        v29 /*: any*/ 
    ], v37 = {
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": v21 /*: any*/ 
    }, v38 = [
        v15 /*: any*/ 
    ], v39 = {
        "concreteType": "ConfluenceWorkflowApplicationDetails",
        "kind": "LinkedField",
        "name": "workflowApplication",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "workflowId"
            },
            {
                "kind": "ScalarField",
                "name": "contentId"
            },
            {
                "kind": "ScalarField",
                "name": "contentVersion"
            },
            {
                "kind": "ScalarField",
                "name": "contentStatus"
            },
            {
                "kind": "ScalarField",
                "name": "workflowStatusId"
            },
            v19 /*: any*/ ,
            v37 /*: any*/ ,
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "lastModificationDate",
                "plural": false,
                "selections": v38 /*: any*/ 
            },
            {
                "concreteType": "AtlassianUser",
                "kind": "LinkedField",
                "name": "modifier",
                "plural": false,
                "selections": v21 /*: any*/ 
            }
        ]
    }, v40 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "creatorAaid"
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "creationDate",
                "plural": false,
                "selections": v38 /*: any*/ 
            },
            v34 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "reviewComment"
            },
            {
                "condition": "includeApprovalsBetaFeatures",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "ConfluenceApprovalsDate",
                        "kind": "LinkedField",
                        "name": "dueDate",
                        "plural": false,
                        "selections": v38 /*: any*/ 
                    }
                ]
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "reviewLastModified",
                "plural": false,
                "selections": v38 /*: any*/ 
            },
            v37 /*: any*/ ,
            {
                "concreteType": "ConfluenceReviewerDecisionInfo",
                "kind": "LinkedField",
                "name": "reviewerDecisions",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "decisionId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reviewerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "required"
                    },
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "reviewerDecisionStatus"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "comment"
                    },
                    {
                        "concreteType": "ConfluenceApprovalsDate",
                        "kind": "LinkedField",
                        "name": "lastModifiedDate",
                        "plural": false,
                        "selections": v38 /*: any*/ 
                    },
                    {
                        "concreteType": "AtlassianUser",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v8 /*: any*/ ,
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            {
                                "concreteType": "AtlassianUserPhoto",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": [
                                    v20 /*: any*/ ,
                                    v15 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v41 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v13 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    v31 /*: any*/ ,
                    v32 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v8 /*: any*/ 
                        ],
                        "type": "BulkMutationErrorExtension"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                v10 /*: any*/ ,
                v22 /*: any*/ ,
                {
                    "args": v23 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v24 /*: any*/ ,
                                v25 /*: any*/ 
                            ]
                        }
                    ]
                },
                v26 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v30 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v33 /*: any*/ ,
                        v35 /*: any*/ 
                    ]
                },
                {
                    "args": v36 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v33 /*: any*/ ,
                        v39 /*: any*/ ,
                        v40 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                v10 /*: any*/ ,
                v22 /*: any*/ ,
                {
                    "args": v23 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                },
                v26 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v30 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v41 /*: any*/ ,
                        v35 /*: any*/ 
                    ]
                },
                {
                    "args": v36 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v41 /*: any*/ ,
                        v39 /*: any*/ ,
                        v40 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "0e97369e1bfa5659fc7cb13e5e23293d",
            "id": "ef04a28901a87d914dea7ee1db36f3d9adc5f2ceeff420236ef0357e7a9388a9",
            "metadata": {},
            "name": "ApprovalsContextApprovalsDataQuery",
            "operationKind": "query",
            "text": "query ApprovalsContextApprovalsDataQuery($cloudId:ID!,$contentId:ID!,$contentStatus:String!,$otherContentStatus:String!,$transitionType:ConfluenceApprovalTransitionType,$spaceKey:String!,$includeApprovalsBetaFeatures:Boolean!,$includeApprovalExpirationConfig:Boolean!){space(key:$spaceKey){id,spaceTypeSettings{enabledFeatures{isContentApprovalsEnabled}},settings@include(if:$includeApprovalExpirationConfig){contentStateSettings{spaceContentStates{id,name}}}},confluence_contentApprovalsSiteSettings(cloudId:$cloudId)@include(if:$includeApprovalsBetaFeatures){enabled}\n  confluence_contentApprovalsSpaceSettingConfig(cloudId:$cloudId,spaceKey:$spaceKey,filterSelf:false)@include(if:$includeApprovalsBetaFeatures){success,errors{message},config{disallowFirstPublish,approvalExpirationConfig@include(if:$includeApprovalExpirationConfig){isEnabled,interval{value,unit},restartApproval,changeStatus{isEnabled,expireToContentStateId}},enforcedApprovalReviewerConfig{isEnabled,reviewers{principalType,principalId,user{id,displayName,isActive,photos{value,isPrimary}}}}}},content(id:$contentId){nodes{status,version{number},id}},confluence_contentApprovalStatuses(cloudId:$cloudId,transitionType:$transitionType){id,allowsReviews,displayProperties{name,color}},confluence_getActiveWorkflowApplicationForOtherStatus:confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$otherContentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowReviewWithDecisions{id,reviewStatus}},confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$contentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowApplication{id,workflowId,contentId,contentVersion,contentStatus,workflowStatusId,isActive,creator{id,displayName,isActive,photos{value,isPrimary}},lastModificationDate{value},modifier{id,displayName,isActive,photos{value,isPrimary}}},workflowReviewWithDecisions{id,creatorAaid,creationDate{value},reviewStatus,reviewComment,dueDate@include(if:$includeApprovalsBetaFeatures){value},reviewLastModified{value},creator{id,displayName,isActive,photos{value,isPrimary}},reviewerDecisions{decisionId,reviewerId,required,principalType,principalId,reviewerDecisionStatus,comment,lastModifiedDate{value},user{id,displayName,isActive,photos{isPrimary,value}}}}}}"
        }
    };
}();
$c7a72aad1b5e4549$var$node.hash = "a285f0ce20dbf6d66aa1a29a488d317f";
var $c7a72aad1b5e4549$export$2e2bcd8739ae039 = $c7a72aad1b5e4549$var$node;
module.exports["default"] = $c7a72aad1b5e4549$export$2e2bcd8739ae039;

});

parcelRegister("iOp5s", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");

const $e8d397546331cd08$var$APPROVALS_DISABLED_ERROR_MESSAGE = 'Approvals are disabled';
const $e8d397546331cd08$var$isApprovalsDisabledGraphQLError = (error)=>Boolean(error.message?.includes($e8d397546331cd08$var$APPROVALS_DISABLED_ERROR_MESSAGE));
const $e8d397546331cd08$export$b724ffcdc4a2c130 = (error)=>{
    if (!error) return false;
    const graphQLErrors = 'graphQLErrors' in error ? error.graphQLErrors : undefined;
    if (graphQLErrors?.length) return graphQLErrors.every($e8d397546331cd08$var$isApprovalsDisabledGraphQLError);
    return $e8d397546331cd08$var$isApprovalsDisabledGraphQLError(error);
};
const $e8d397546331cd08$var$markGraphQLErrorAndCauseAsHandled = (error)=>{
    (0, $7Sm4c.markErrorAsHandled)(error);
    const originalCause = error.originalError?.cause;
    if (originalCause && $e8d397546331cd08$var$isApprovalsDisabledGraphQLError(originalCause)) (0, $7Sm4c.markErrorAsHandled)(originalCause);
};
const $e8d397546331cd08$export$50302788ce0889ee = (error)=>{
    if (!error || !$e8d397546331cd08$export$b724ffcdc4a2c130(error)) return;
    (0, $7Sm4c.markErrorAsHandled)(error);
    const graphQLErrors = 'graphQLErrors' in error ? error.graphQLErrors : undefined;
    graphQLErrors?.forEach($e8d397546331cd08$var$markGraphQLErrorAndCauseAsHandled);
};
module.exports["markApprovalsDisabledErrorAsHandled"] = $e8d397546331cd08$export$50302788ce0889ee;

});

parcelRegister("7tHGa", function(module, exports) {
var $c76572742e8d6c54$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "CURRENT";
    ContentStatus["DRAFT"] = "DRAFT";
    ContentStatus["ARCHIVED"] = "ARCHIVED";
    return ContentStatus;
}({});
module.exports["ContentStatus"] = $c76572742e8d6c54$export$b2be22e9d5dd3927;

});

parcelRegister("gSfo4", function(module, exports) {

var $7tHGa = parcelRequire("7tHGa");

const $d569ee9ba15fe187$var$classificationContentStatusEnumToSingleContentSearchArrayMap = {
    [(0, $7tHGa.ContentStatus).CURRENT]: 'current',
    [(0, $7tHGa.ContentStatus).DRAFT]: 'draft',
    [(0, $7tHGa.ContentStatus).ARCHIVED]: 'archived'
};
const $d569ee9ba15fe187$var$getSingleContentStatusStringFromClassificationStatus = (status)=>{
    return $d569ee9ba15fe187$var$classificationContentStatusEnumToSingleContentSearchArrayMap[status];
};
const $d569ee9ba15fe187$export$930e5fd4dd47a5f1 = (statuses)=>{
    return statuses.map((status)=>$d569ee9ba15fe187$var$getSingleContentStatusStringFromClassificationStatus(status)).filter(Boolean);
};
module.exports["getQuerySingleContentStatusArrayVariable"] = $d569ee9ba15fe187$export$930e5fd4dd47a5f1;

});

parcelRegister("79mss", function(module, exports) {
/**
 * @generated SignedSource<<217ed72306ad0003c83611da9b9dfec7>>
 * @relayHash 02343eb4ab11fc6471bc117cd9c349d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f9794fe079d8566f47a9f279f6b1eb86fd6f7441be80aea326be0f0bc4e003d
const $22165adc85ae14ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "lowerCaseContentStatusArray"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "lowerCaseContentStatusArray"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "ClassificationLevelDetails",
                    "kind": "LinkedField",
                    "name": "classificationLevelDetails",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentDataClassificationLevel",
                            "kind": "LinkedField",
                            "name": "classificationLevel",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "guideline"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "guidelineADF"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "color"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "featureEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "source"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReclassificationPermitted"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canManageSpaceSettings"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "classificationControlSetting"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "userOverrideSetting"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentClassificationContentDataClassificationQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentClassificationContentDataClassificationQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "02343eb4ab11fc6471bc117cd9c349d2",
            "id": "2f9794fe079d8566f47a9f279f6b1eb86fd6f7441be80aea326be0f0bc4e003d",
            "metadata": {},
            "name": "useContentClassificationContentDataClassificationQuery",
            "operationKind": "query",
            "text": "query useContentClassificationContentDataClassificationQuery($contentId:ID!,$lowerCaseContentStatusArray:[String]){singleContent(id:$contentId,status:$lowerCaseContentStatusArray){id,classificationLevelDetails{classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}}"
        }
    };
}();
$22165adc85ae14ea$var$node.hash = "e2a3c90b94181436fe0a32faafb92cf6";
var $22165adc85ae14ea$export$2e2bcd8739ae039 = $22165adc85ae14ea$var$node;
module.exports["default"] = $22165adc85ae14ea$export$2e2bcd8739ae039;

});

parcelRegister("d3OVq", function(module, exports) {
/**
 * @generated SignedSource<<a13cd2a1d29aae2129c9a2a32580afb2>>
 * @relayHash 08655b5a07a80d6db6123fa2b954538c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6a03e95f43b1257f84130aca2fcbdeff6cdf7b832e117cacf3d0b825870beb22
const $49f91628ee52d08c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "width"
    }, v5 = {
        "kind": "ScalarField",
        "name": "height"
    }, v6 = [
        v2 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v7 = {
        "concreteType": "MapOfStringToString",
        "kind": "LinkedField",
        "name": "hoverOrFocus",
        "plural": true,
        "selections": v6 /*: any*/ 
    }, v8 = {
        "kind": "ScalarField",
        "name": "color"
    }, v9 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v10 = [
        v9 /*: any*/ ,
        v8 /*: any*/ 
    ], v11 = [
        v8 /*: any*/ ,
        v7 /*: any*/ 
    ], v12 = {
        "kind": "ScalarField",
        "name": "background"
    }, v13 = {
        "kind": "ScalarField",
        "name": "backgroundImage"
    }, v14 = {
        "kind": "ScalarField",
        "name": "backgroundPosition"
    }, v15 = {
        "kind": "ScalarField",
        "name": "backgroundSize"
    }, v16 = {
        "kind": "ScalarField",
        "name": "backgroundRepeat"
    }, v17 = {
        "kind": "ScalarField",
        "name": "backgroundOrigin"
    }, v18 = {
        "kind": "ScalarField",
        "name": "backgroundClip"
    }, v19 = {
        "kind": "ScalarField",
        "name": "backgroundAttachment"
    }, v20 = {
        "kind": "ScalarField",
        "name": "backgroundBlendMode"
    }, v21 = [
        v12 /*: any*/ ,
        v9 /*: any*/ ,
        v13 /*: any*/ ,
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ ,
        v17 /*: any*/ ,
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        v20 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "padding"
        },
        {
            "kind": "ScalarField",
            "name": "borderRadius"
        }
    ], v22 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        v3 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "homepage",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                },
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "isDefault"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "SpaceSettings",
                            "kind": "LinkedField",
                            "name": "settings",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "routeOverrideEnabled"
                                }
                            ]
                        },
                        {
                            "concreteType": "Theme",
                            "kind": "LinkedField",
                            "name": "theme",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "themeKey"
                                }
                            ]
                        },
                        {
                            "concreteType": "LookAndFeel",
                            "kind": "LinkedField",
                            "name": "lookAndFeel",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "MapOfStringToString",
                                    "kind": "LinkedField",
                                    "name": "headings",
                                    "plural": true,
                                    "selections": v6 /*: any*/ 
                                },
                                {
                                    "concreteType": "MenusLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "menus",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "HeaderLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "header",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "concreteType": "ButtonLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "button",
                                            "plural": false,
                                            "selections": v10 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "NavigationLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "primaryNavigation",
                                            "plural": false,
                                            "selections": v11 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "NavigationLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "secondaryNavigation",
                                            "plural": false,
                                            "selections": v11 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "SearchFieldLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "search",
                                            "plural": false,
                                            "selections": v10 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "ContentLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ScreenLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "screen",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                v14 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                {
                                                    "concreteType": "LayerScreenLookAndFeel",
                                                    "kind": "LinkedField",
                                                    "name": "layer",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "gutterTop"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "gutterRight"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "gutterBottom"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "gutterLeft"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "ContainerLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "container",
                                            "plural": false,
                                            "selections": v21 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "ContainerLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "header",
                                            "plural": false,
                                            "selections": v21 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "ContainerLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "body",
                                            "plural": false,
                                            "selections": v21 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "SpaceMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PaginatedLabelList",
                                    "kind": "LinkedField",
                                    "name": "labels",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "Label",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "prefix"
                                                },
                                                v3 /*: any*/ ,
                                                v1 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceBaseQueryBaseQuery",
            "selections": v22 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceBaseQueryBaseQuery",
            "selections": v22 /*: any*/ 
        },
        "params": {
            "cacheID": "08655b5a07a80d6db6123fa2b954538c",
            "id": "6a03e95f43b1257f84130aca2fcbdeff6cdf7b832e117cacf3d0b825870beb22",
            "metadata": {},
            "name": "useSpaceBaseQueryBaseQuery",
            "operationKind": "query",
            "text": "query useSpaceBaseQueryBaseQuery($spaceKey:String){spaces(spaceKey:$spaceKey){nodes{id,key,alias,name,homepage{id},icon{path,width,height,isDefault},type,settings{routeOverrideEnabled},theme{themeKey},lookAndFeel{headings{key,value},menus{hoverOrFocus{key,value},color},header{backgroundColor,button{backgroundColor,color},primaryNavigation{color,hoverOrFocus{key,value}},secondaryNavigation{color,hoverOrFocus{key,value}},search{backgroundColor,color}},content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius},header{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius},body{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}},metadata{labels{nodes{prefix,name,id}}},operations{operation,targetType}}}}"
        }
    };
}();
$49f91628ee52d08c$var$node.hash = "e885d5c349d4cf19afe686a9f6747925";
var $49f91628ee52d08c$export$2e2bcd8739ae039 = $49f91628ee52d08c$var$node;
module.exports["default"] = $49f91628ee52d08c$export$2e2bcd8739ae039;

});

parcelRegister("ixL26", function(module, exports) {
/**
 * @generated SignedSource<<fbb30a8834043aa8efe95e491818e212>>
 * @relayHash d6be154debcc9cc4834278390fc53126
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2aa0ed74afe3b72eb6db76d715d8da108ed70a4d3568c05987cecb7b3770645b
const $0d2a1fbf3179ce94$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "excludeOperations"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "Theme",
                    "kind": "LinkedField",
                    "name": "theme",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "themeKey"
                        }
                    ]
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "condition": "excludeOperations",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "concreteType": "OperationCheckResult",
                                    "kind": "LinkedField",
                                    "name": "operations",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "operation"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "emoji-title-published"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"emoji-title-published\"])"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SpaceOverviewQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SpaceOverviewQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "d6be154debcc9cc4834278390fc53126",
            "id": "2aa0ed74afe3b72eb6db76d715d8da108ed70a4d3568c05987cecb7b3770645b",
            "metadata": {},
            "name": "SpaceOverviewQuery",
            "operationKind": "query",
            "text": "query SpaceOverviewQuery($spaceKey:String!,$excludeOperations:Boolean!){space(key:$spaceKey){id,currentUser{isAdmin},name,type,theme{themeKey},icon{path},homepage{id,operations@skip(if:$excludeOperations){operation},properties(keys:[\"emoji-title-published\"]){nodes{id,key,value}}}}}"
        }
    };
}();
$0d2a1fbf3179ce94$var$node.hash = "800c4a5e07b722b2b0e454947ac55f3c";
var $0d2a1fbf3179ce94$export$2e2bcd8739ae039 = $0d2a1fbf3179ce94$var$node;
module.exports["default"] = $0d2a1fbf3179ce94$export$2e2bcd8739ae039;

});

parcelRegister("3hHGU", function(module, exports) {
/**
 * @generated SignedSource<<97883e4f3341dc8eee867b0d2022b8b6>>
 * @relayHash 167c1a5fbdbb53604f3f562e570f1f91
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9aa276284b5516cde1d9f7f8b3fe7215cd9ebb9294f9ac504abc7c452e599030
const $02fb880a65c09e36$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "isPinned"
    }, v2 = {
        "kind": "ScalarField",
        "name": "title"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "ConfluenceSmartSpaceOverview",
            "kind": "LinkedField",
            "name": "confluence_smartSpaceOverview",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceSmartSpaceOverviewSummary",
                    "kind": "LinkedField",
                    "name": "summary",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "body"
                        },
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceSmartSpaceOverviewFAQ",
                    "kind": "LinkedField",
                    "name": "faq",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSmartSpaceOverviewFAQEntry",
                            "kind": "LinkedField",
                            "name": "entries",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "question"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "answer"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "followUpQuestions"
                                },
                                {
                                    "concreteType": "ConfluenceSmartSpaceOverviewFAQSource",
                                    "kind": "LinkedField",
                                    "name": "sources",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "content",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "excerpt"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "embeddedProduct"
                                                },
                                                {
                                                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                                    "kind": "LinkedField",
                                                    "name": "links",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "webui"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceSmartSpaceOverviewTopLinks",
                    "kind": "LinkedField",
                    "name": "topLinks",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "contentId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "lastRefreshed"
                        },
                        {
                            "concreteType": "ConfluenceSmartSpaceOverviewTopLink",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "url"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOverviewSwitcherQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOverviewSwitcherQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "167c1a5fbdbb53604f3f562e570f1f91",
            "id": "9aa276284b5516cde1d9f7f8b3fe7215cd9ebb9294f9ac504abc7c452e599030",
            "metadata": {},
            "name": "SpaceOverviewSwitcherQuery",
            "operationKind": "query",
            "text": "query SpaceOverviewSwitcherQuery($cloudId:ID!,$spaceKey:String!){confluence_smartSpaceOverview(cloudId:$cloudId,spaceKey:$spaceKey){summary{body,isPinned},faq{entries{question,answer,followUpQuestions,sources{content{id,title,excerpt,embeddedProduct,links{webui}}}}},topLinks{contentId,lastRefreshed,links{isPinned,title,url}}}}"
        }
    };
}();
$02fb880a65c09e36$var$node.hash = "1b64f396256f01419c73a81884314905";
var $02fb880a65c09e36$export$2e2bcd8739ae039 = $02fb880a65c09e36$var$node;
module.exports["default"] = $02fb880a65c09e36$export$2e2bcd8739ae039;

});

parcelRegister("jpSPX", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $cEgMD = parcelRequire("cEgMD");


var $8Psje = parcelRequire("8Psje");

const $d271b30f20f80b69$export$bb12d233342ab079 = ({ spaceKey: spaceKey, isRovoEnabled: isRovoEnabled, cloudId: cloudId })=>Boolean(cloudId) && !(0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) && !(0, $8Psje.isRovoSystemSpaceKey)(spaceKey) && isRovoEnabled && (0, $6mKj3.expVal)('smart_space_overview', 'isEnabled', false);
module.exports["isSmartSpaceOverviewEnabled"] = $d271b30f20f80b69$export$bb12d233342ab079;

});

parcelRegister("8Psje", function(module, exports) {
const $5c0c9a15440579bc$export$fb74cd09fc20f0c3 = (spaceKey)=>{
    if (!spaceKey) return false;
    return spaceKey.startsWith('~ROVO') && spaceKey.endsWith('~');
};
module.exports["isRovoSystemSpaceKey"] = $5c0c9a15440579bc$export$fb74cd09fc20f0c3;

});

parcelRegister("d5h4f", function(module, exports) {
/**
 * @generated SignedSource<<c66496c25cb521f876dac5a42fd2fcd2>>
 * @relayHash 237b04f22d9b44361b6e9b7436f12aa7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 995bea55a94fd3b763d25f287ae43c4506bba32bd0abef2bf4de024e2ba46bf9
const $9de934dc3b27501e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentVersion"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "referenceId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "title"
    }, v7 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "hasRestrictions"
    }, v9 = {
        "kind": "ScalarField",
        "name": "hasViewRestrictions"
    }, v10 = {
        "kind": "ScalarField",
        "name": "hasInheritedRestrictions"
    }, v11 = {
        "kind": "ScalarField",
        "name": "name"
    }, v12 = {
        "kind": "ScalarField",
        "name": "key"
    }, v13 = {
        "kind": "ScalarField",
        "name": "type"
    }, v14 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            v11 /*: any*/ ,
            v12 /*: any*/ ,
            v13 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "status"
    }, v16 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
            v4 /*: any*/ ,
            v13 /*: any*/ ,
            v6 /*: any*/ ,
            v15 /*: any*/ 
        ]
    }, v17 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "value"
    }, v19 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "import-source",
                    "imported-page-modified-date"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v12 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(keys:[\"import-source\",\"imported-page-modified-date\"])"
    }, v20 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v21 = {
        "kind": "InlineFragment",
        "selections": v20 /*: any*/ ,
        "type": "KnownUser"
    }, v22 = {
        "kind": "InlineFragment",
        "selections": v20 /*: any*/ ,
        "type": "UnknownUser"
    }, v23 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v24 = [
        v4 /*: any*/ 
    ], v25 = {
        "args": [
            {
                "kind": "Literal",
                "name": "first",
                "value": 10
            },
            v23 /*: any*/ 
        ],
        "concreteType": "PaginatedSpaceList",
        "kind": "LinkedField",
        "name": "spaces",
        "plural": false,
        "selections": [
            {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    v11 /*: any*/ ,
                    {
                        "concreteType": "Content",
                        "kind": "LinkedField",
                        "name": "homepage",
                        "plural": false,
                        "selections": v24 /*: any*/ 
                    }
                ]
            }
        ]
    }, v26 = {
        "alias": "user",
        "args": [
            {
                "kind": "Literal",
                "name": "current",
                "value": true
            }
        ],
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "concreteType": "ConfluenceUser",
                "kind": "LinkedField",
                "name": "confluence",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": v24 /*: any*/ 
                    }
                ]
            }
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
    }, v27 = {
        "args": v3 /*: any*/ ,
        "kind": "ScalarField",
        "name": "paywallStatus"
    }, v28 = {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
    }, v29 = [
        v28 /*: any*/ 
    ], v30 = {
        "args": v29 /*: any*/ ,
        "concreteType": "CanvasToken",
        "kind": "LinkedField",
        "name": "canvasToken",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "token"
            }
        ]
    }, v31 = [
        v18 /*: any*/ 
    ], v32 = {
        "args": v29 /*: any*/ ,
        "concreteType": "ContentMediaSession",
        "kind": "LinkedField",
        "name": "contentMediaSession",
        "plural": false,
        "selections": [
            {
                "concreteType": "MediaAccessTokens",
                "kind": "LinkedField",
                "name": "accessTokens",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "MediaToken",
                        "kind": "LinkedField",
                        "name": "readOnlyToken",
                        "plural": false,
                        "selections": v31 /*: any*/ 
                    },
                    {
                        "concreteType": "MediaToken",
                        "kind": "LinkedField",
                        "name": "readWriteToken",
                        "plural": false,
                        "selections": v31 /*: any*/ 
                    }
                ]
            },
            {
                "concreteType": "MediaConfiguration",
                "kind": "LinkedField",
                "name": "configuration",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "fileStoreUrl"
                    }
                ]
            }
        ]
    }, v33 = [
        {
            "kind": "ScalarField",
            "name": "isEntitled"
        }
    ], v34 = {
        "concreteType": "Entitlements",
        "kind": "LinkedField",
        "name": "entitlements",
        "plural": false,
        "selections": [
            {
                "concreteType": "WhiteboardFeatures",
                "kind": "LinkedField",
                "name": "whiteboardFeatures",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "SmartConnectorsFeature",
                        "kind": "LinkedField",
                        "name": "smartConnectors",
                        "plural": false,
                        "selections": v33 /*: any*/ 
                    },
                    {
                        "concreteType": "SmartSectionsFeature",
                        "kind": "LinkedField",
                        "name": "smartSections",
                        "plural": false,
                        "selections": v33 /*: any*/ 
                    }
                ]
            }
        ]
    }, v35 = {
        "kind": "Literal",
        "name": "contentStatus",
        "value": "CURRENT"
    }, v36 = {
        "kind": "Variable",
        "name": "contentVersion",
        "variableName": "contentVersion"
    }, v37 = [
        {
            "kind": "ScalarField",
            "name": "allowed"
        }
    ], v38 = {
        "concreteType": "Confluence_dataSecurityPolicy",
        "kind": "LinkedField",
        "name": "dataSecurityPolicy",
        "plural": false,
        "selections": [
            {
                "alias": "isExportAllowed",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "action",
                        "value": "PAGE_EXPORT"
                    },
                    v28 /*: any*/ ,
                    v35 /*: any*/ ,
                    v36 /*: any*/ ,
                    v23 /*: any*/ 
                ],
                "concreteType": "DataSecurityPolicyDecision",
                "kind": "LinkedField",
                "name": "isActionEnabledForContent",
                "plural": false,
                "selections": v37 /*: any*/ 
            },
            {
                "alias": "isDownloadAllowed",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "action",
                        "value": "ATTACHMENT_DOWNLOAD"
                    },
                    v28 /*: any*/ ,
                    v35 /*: any*/ ,
                    v36 /*: any*/ ,
                    v23 /*: any*/ 
                ],
                "concreteType": "DataSecurityPolicyDecision",
                "kind": "LinkedField",
                "name": "isActionEnabledForContent",
                "plural": false,
                "selections": v37 /*: any*/ 
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WhiteboardUnifiedQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v14 /*: any*/ ,
                                v13 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v19 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v21 /*: any*/ ,
                                                v22 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v25 /*: any*/ ,
                v26 /*: any*/ ,
                v27 /*: any*/ ,
                v30 /*: any*/ ,
                v32 /*: any*/ ,
                v34 /*: any*/ ,
                v38 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WhiteboardUnifiedQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v14 /*: any*/ ,
                                v13 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v19 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v21 /*: any*/ ,
                                                v22 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v25 /*: any*/ ,
                v26 /*: any*/ ,
                v27 /*: any*/ ,
                v30 /*: any*/ ,
                v32 /*: any*/ ,
                v34 /*: any*/ ,
                v38 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "237b04f22d9b44361b6e9b7436f12aa7",
            "id": "995bea55a94fd3b763d25f287ae43c4506bba32bd0abef2bf4de024e2ba46bf9",
            "metadata": {},
            "name": "WhiteboardUnifiedQuery",
            "operationKind": "query",
            "text": "query WhiteboardUnifiedQuery($contentId:ID!,$spaceKey:String,$contentVersion:Int!){content(id:$contentId){nodes{id,referenceId,title,operations{operation,targetType},hasRestrictions,hasViewRestrictions,hasInheritedRestrictions,space{id,name,key,type,alias},type,status,ancestors{id,type,title,status},metadata{currentuser{favourited{isFavourite}},lastModifiedDate},properties(keys:[\"import-source\",\"imported-page-modified-date\"]){nodes{key,value}},history{createdBy{__typename,...on KnownUser{accountId},...on UnknownUser{accountId}}}}},spaces(spaceKey:$spaceKey,first:10){nodes{id,name,homepage{id}}},user:confluence_atlassianUser(current:true){id,confluence{space{id}}},paywallStatus(id:$contentId),canvasToken(contentId:$contentId){token},contentMediaSession(contentId:$contentId){accessTokens{readOnlyToken{value},readWriteToken{value}},configuration{fileStoreUrl}},entitlements{whiteboardFeatures{smartConnectors{isEntitled},smartSections{isEntitled}}},dataSecurityPolicy{isExportAllowed:isActionEnabledForContent(action:PAGE_EXPORT,contentId:$contentId,contentStatus:CURRENT,spaceKey:$spaceKey,contentVersion:$contentVersion){allowed},isDownloadAllowed:isActionEnabledForContent(action:ATTACHMENT_DOWNLOAD,contentId:$contentId,contentStatus:CURRENT,spaceKey:$spaceKey,contentVersion:$contentVersion){allowed}}}"
        }
    };
}();
$9de934dc3b27501e$var$node.hash = "3a27147e54d7dc7fee56b195174180ed";
var $9de934dc3b27501e$export$2e2bcd8739ae039 = $9de934dc3b27501e$var$node;
module.exports["default"] = $9de934dc3b27501e$export$2e2bcd8739ae039;

});

parcelRegister("kwaj3", function(module, exports) {
/**
 * @generated SignedSource<<82a5121e796d7d88be54dc18b0c66612>>
 * @relayHash 7a46b279c61b3080707b64c6f2a92e47
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f9ec01d56a841624c18f4cc3a1a96a06f53f806043d4f21f968b593c8ea5b1c7
const $80d237b89b6ac744$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "7a46b279c61b3080707b64c6f2a92e47",
            "id": "f9ec01d56a841624c18f4cc3a1a96a06f53f806043d4f21f968b593c8ea5b1c7",
            "metadata": {},
            "name": "SpaceQuery",
            "operationKind": "query",
            "text": "query SpaceQuery($spaceKey:String){space(key:$spaceKey){id,name,icon{path},homepage{id}}}"
        }
    };
}();
$80d237b89b6ac744$var$node.hash = "6eceb4fc897c8a684e865776c35134e0";
var $80d237b89b6ac744$export$2e2bcd8739ae039 = $80d237b89b6ac744$var$node;
module.exports["default"] = $80d237b89b6ac744$export$2e2bcd8739ae039;

});

parcelRegister("bcVE2", function(module, exports) {
const $234cfa339ee54346$var$isQueryParamPresent = (value)=>Array.isArray(value) ? value.length > 0 : Boolean(value);
const $234cfa339ee54346$export$ca840bf5ed4ee034 = ({ parentProduct: parentProduct, presentationMode: presentationMode })=>$234cfa339ee54346$var$isQueryParamPresent(parentProduct) || $234cfa339ee54346$var$isQueryParamPresent(presentationMode);
module.exports["isEmbeddedWhiteboardMode"] = $234cfa339ee54346$export$ca840bf5ed4ee034;

});

parcelRegister("c7BJC", function(module, exports) {
/**
 * @generated SignedSource<<7480b5813e71e947657f66416e8eb77e>>
 * @relayHash 3d5107055d0ad5e5fed0e694feb80f1c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5acb81487b5b5127dead4c25a310545e5437aad4717ee4c6f1d7a5a5a6c6614e
const $0040230a36fc338e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentVersion"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "title"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "ScalarField",
        "name": "status"
    }, v8 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v9 = [
        v3 /*: any*/ 
    ], v10 = [
        {
            "kind": "ScalarField",
            "name": "value"
        },
        {
            "kind": "ScalarField",
            "name": "isPrimary"
        }
    ], v11 = {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
    }, v12 = {
        "kind": "Literal",
        "name": "contentStatus",
        "value": "CURRENT"
    }, v13 = {
        "kind": "Variable",
        "name": "contentVersion",
        "variableName": "contentVersion"
    }, v14 = [
        {
            "kind": "ScalarField",
            "name": "allowed"
        }
    ], v15 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "referenceId"
                        },
                        v4 /*: any*/ ,
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasRestrictions"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasViewRestrictions"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasInheritedRestrictions"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                v6 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        },
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "ancestors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v6 /*: any*/ ,
                                v4 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                },
                v8 /*: any*/ 
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "homepage",
                            "plural": false,
                            "selections": v9 /*: any*/ 
                        }
                    ]
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": v10 /*: any*/ 
                },
                {
                    "concreteType": "AtlassianUserEmail",
                    "kind": "LinkedField",
                    "name": "emails",
                    "plural": true,
                    "selections": v10 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "locale"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": v9 /*: any*/ 
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        },
        {
            "concreteType": "Confluence_dataSecurityPolicy",
            "kind": "LinkedField",
            "name": "dataSecurityPolicy",
            "plural": false,
            "selections": [
                {
                    "alias": "isExportAllowed",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "action",
                            "value": "PAGE_EXPORT"
                        },
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v8 /*: any*/ 
                    ],
                    "concreteType": "DataSecurityPolicyDecision",
                    "kind": "LinkedField",
                    "name": "isActionEnabledForContent",
                    "plural": false,
                    "selections": v14 /*: any*/ 
                },
                {
                    "alias": "isDownloadAllowed",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "action",
                            "value": "ATTACHMENT_DOWNLOAD"
                        },
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v8 /*: any*/ 
                    ],
                    "concreteType": "DataSecurityPolicyDecision",
                    "kind": "LinkedField",
                    "name": "isActionEnabledForContent",
                    "plural": false,
                    "selections": v14 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "DatabaseContainerQuery",
            "selections": v15 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "DatabaseContainerQuery",
            "selections": v15 /*: any*/ 
        },
        "params": {
            "cacheID": "3d5107055d0ad5e5fed0e694feb80f1c",
            "id": "5acb81487b5b5127dead4c25a310545e5437aad4717ee4c6f1d7a5a5a6c6614e",
            "metadata": {},
            "name": "DatabaseContainerQuery",
            "operationKind": "query",
            "text": "query DatabaseContainerQuery($contentId:ID!,$spaceKey:String,$contentVersion:Int!){content(id:$contentId){nodes{id,referenceId,title,operations{operation,targetType},hasRestrictions,hasViewRestrictions,hasInheritedRestrictions,space{id,name,key,type,alias},type,status,ancestors{id,type,title,status}}},spaces(spaceKey:$spaceKey,first:10){nodes{id,name,homepage{id}}},user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary},emails{value,isPrimary},locale,confluence{space{id}}},dataSecurityPolicy{isExportAllowed:isActionEnabledForContent(action:PAGE_EXPORT,contentId:$contentId,contentStatus:CURRENT,spaceKey:$spaceKey,contentVersion:$contentVersion){allowed},isDownloadAllowed:isActionEnabledForContent(action:ATTACHMENT_DOWNLOAD,contentId:$contentId,contentStatus:CURRENT,spaceKey:$spaceKey,contentVersion:$contentVersion){allowed}}}"
        }
    };
}();
$0040230a36fc338e$var$node.hash = "7a60e16be16d4c46e03e2f2d23d9dc89";
var $0040230a36fc338e$export$2e2bcd8739ae039 = $0040230a36fc338e$var$node;
module.exports["default"] = $0040230a36fc338e$export$2e2bcd8739ae039;

});

parcelRegister("1TElT", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $5DJsZ = parcelRequire("5DJsZ");

const $0272cf4ae0232c26$export$a9fe7043b42a1476 = (contentId, draftShareId, useCache)=>{
    return (0, $dYU3e.query)({
        query: (0, $5DJsZ.default),
        variables: {
            contentId: contentId,
            draftShareId: draftShareId,
            status: [
                'current',
                'draft'
            ],
            skipPublishedFragment: false
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "emoji-title"
    });
};
module.exports["preloadEmojiTitle"] = $0272cf4ae0232c26$export$a9fe7043b42a1476;

});

parcelRegister("5DJsZ", function(module, exports) {
/**
 * @generated SignedSource<<8b96b7ca504d956e62c9a3c7888eb72c>>
 * @relayHash 736318216100158fedfd1efdb0277723
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ee7b55ba4a12d84512c880cfd1a46392ff785081052c438befeefd868cef06a6
const $4dc353069380bea7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipPublishedFragment"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v4 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "condition": "skipPublishedFragment",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "emojiTitlePublished",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "emoji-title-published"
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v5 /*: any*/ ,
                                    "storageKey": "properties(key:\"emoji-title-published\")"
                                }
                            ]
                        },
                        {
                            "alias": "emojiTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "emoji-title-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v5 /*: any*/ ,
                            "storageKey": "properties(key:\"emoji-title-draft\")"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PublishedContentProperties",
                                    "kind": "LinkedField",
                                    "name": "latest",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "defaultTitleEmoji"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EmojiTitleQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EmojiTitleQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "736318216100158fedfd1efdb0277723",
            "id": "ee7b55ba4a12d84512c880cfd1a46392ff785081052c438befeefd868cef06a6",
            "metadata": {},
            "name": "EmojiTitleQuery",
            "operationKind": "query",
            "text": "query EmojiTitleQuery($contentId:ID,$status:[String],$draftShareId:String,$skipPublishedFragment:Boolean!){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,emojiTitlePublished:properties(key:\"emoji-title-published\")@skip(if:$skipPublishedFragment){nodes{id,key,value,version{number}}},emojiTitleDraft:properties(key:\"emoji-title-draft\"){nodes{id,key,value,version{number}}},contentProperties{latest{defaultTitleEmoji}}}}}"
        }
    };
}();
$4dc353069380bea7$var$node.hash = "c3af19fccb4a5096e4bb34c9aa198098";
var $4dc353069380bea7$export$2e2bcd8739ae039 = $4dc353069380bea7$var$node;
module.exports["default"] = $4dc353069380bea7$export$2e2bcd8739ae039;

});

parcelRegister("65pdw", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $lC6Qd = parcelRequire("lC6Qd");

function $4e9d3c2f55d09139$export$cca2a63dd6cc6345(contentId, draftShareId, useCache) {
    return (0, $dYU3e.query)({
        query: (0, $lC6Qd.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            draftShareId: draftShareId
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "page-cover-picture"
    });
}
module.exports["preloadEditorPageCoverPicture"] = $4e9d3c2f55d09139$export$cca2a63dd6cc6345;

});

parcelRegister("lC6Qd", function(module, exports) {
/**
 * @generated SignedSource<<809e2044c3792f08e4a1f1fd3c386e1c>>
 * @relayHash eca6e9d325c97f4fd5880178ecc63561
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2e9338430096a14321d43ffc4d7c87126164ce6f2d44ea4ede01d437b0ec12d
const $03de5ecc01e321ee$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "cover-picture-id-draft",
                                        "cover-picture-id-published"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "number"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CoverPictureQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CoverPictureQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "eca6e9d325c97f4fd5880178ecc63561",
            "id": "e2e9338430096a14321d43ffc4d7c87126164ce6f2d44ea4ede01d437b0ec12d",
            "metadata": {},
            "name": "CoverPictureQuery",
            "operationKind": "query",
            "text": "query CoverPictureQuery($contentId:ID,$status:[String],$draftShareId:String){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"]){nodes{id,key,value,version{number}}}}}}"
        }
    };
}();
$03de5ecc01e321ee$var$node.hash = "cbe85309884dfe8220661d705f977e0f";
var $03de5ecc01e321ee$export$2e2bcd8739ae039 = $03de5ecc01e321ee$var$node;
module.exports["default"] = $03de5ecc01e321ee$export$2e2bcd8739ae039;

});

parcelRegister("4TRDb", function(module, exports) {
/**
 * @generated SignedSource<<08bbdfb732a0e903037634e82b2cebab>>
 * @relayHash c0a7532c77f00a6d3db89afbba6c2124
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e3afe4be4952ff1385de921ea89e96ad689b38bd27c628e4ceacc511c99519eb
const $027763ba95a6da42$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "draft"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "concreteType": "ContentBodyPerRepresentation",
                            "kind": "LinkedField",
                            "name": "body",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentBody",
                                    "kind": "LinkedField",
                                    "name": "atlas_doc_format",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SmartCreatePageEditorDataWrapperComponentQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SmartCreatePageEditorDataWrapperComponentQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "c0a7532c77f00a6d3db89afbba6c2124",
            "id": "e3afe4be4952ff1385de921ea89e96ad689b38bd27c628e4ceacc511c99519eb",
            "metadata": {},
            "name": "SmartCreatePageEditorDataWrapperComponentQuery",
            "operationKind": "query",
            "text": "query SmartCreatePageEditorDataWrapperComponentQuery($contentId:ID!){content(id:$contentId,status:[\"draft\"]){nodes{id,title,body{atlas_doc_format{value}},space{id,key,alias}}}}"
        }
    };
}();
$027763ba95a6da42$var$node.hash = "1aa5e1f3fdc665522f842f14ed2e0264";
var $027763ba95a6da42$export$2e2bcd8739ae039 = $027763ba95a6da42$var$node;
module.exports["default"] = $027763ba95a6da42$export$2e2bcd8739ae039;

});

parcelRegister("a2zQR", function(module, exports) {
/**
 * @generated SignedSource<<e77ba13c86de7ab0ec90d72e14a5eba1>>
 * @relayHash 3674404876fb671e57a7bc564c9498dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d9d6149ee0dc2a6f69d42a3b799534977c79ae87426c615721176aadbe34bd6
const $fbc22293d57aa8f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "title"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "status"
    }, v6 = [
        v1 /*: any*/ 
    ], v7 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "embedUrl"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    "kind": "LinkedField",
                                    "name": "currentuser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "FavouritedSummary",
                                            "kind": "LinkedField",
                                            "name": "favourited",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasRestrictions"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasViewRestrictions"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasInheritedRestrictions"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                v4 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        },
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "ancestors",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v4 /*: any*/ ,
                                v2 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "embeddedProduct"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "homepage",
                            "plural": false,
                            "selections": v6 /*: any*/ 
                        }
                    ]
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": v6 /*: any*/ 
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EmbedContainerQuery",
            "selections": v7 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EmbedContainerQuery",
            "selections": v7 /*: any*/ 
        },
        "params": {
            "cacheID": "3674404876fb671e57a7bc564c9498dc",
            "id": "5d9d6149ee0dc2a6f69d42a3b799534977c79ae87426c615721176aadbe34bd6",
            "metadata": {},
            "name": "EmbedContainerQuery",
            "operationKind": "query",
            "text": "query EmbedContainerQuery($contentId:ID!,$spaceKey:String!){content(id:$contentId){nodes{id,title,metadata{frontend{embedUrl},currentuser{favourited{isFavourite}}},operations{operation,targetType},hasRestrictions,hasViewRestrictions,hasInheritedRestrictions,space{id,name,key,type,alias},type,status,ancestors{id,type,title,status},embeddedProduct}},spaces(spaceKey:$spaceKey,first:10){nodes{id,name,homepage{id}}},user:confluence_atlassianUser(current:true){id,confluence{space{id}}}}"
        }
    };
}();
$fbc22293d57aa8f6$var$node.hash = "93be96607102ab4e689586d3195128e3";
var $fbc22293d57aa8f6$export$2e2bcd8739ae039 = $fbc22293d57aa8f6$var$node;
module.exports["default"] = $fbc22293d57aa8f6$export$2e2bcd8739ae039;

});

parcelRegister("cvj7x", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $3gyyc = parcelRequire("3gyyc");


var $7W8i8 = parcelRequire("7W8i8");


var $65pdw = parcelRequire("65pdw");


var $1TElT = parcelRequire("1TElT");


var $3cpum = parcelRequire("3cpum");


var $7PLO8 = parcelRequire("7PLO8");


var $irrTO = parcelRequire("irrTO");


var $9sGCn = parcelRequire("9sGCn");


var $4trRg = parcelRequire("4trRg");

parcelRequire("kGDoD");
var $9nGwZ = parcelRequire("9nGwZ");


var $1c0dB = parcelRequire("1c0dB");


var $kDt9L = parcelRequire("kDt9L");


var $4vyfK = parcelRequire("4vyfK");


var $cRQNp = parcelRequire("cRQNp");


var $kIqZK = parcelRequire("kIqZK");


var $eSLr0 = parcelRequire("eSLr0");


var $8CHHT = parcelRequire("8CHHT");


var $7Ndnw = parcelRequire("7Ndnw");


var $lyWac = parcelRequire("lyWac");


var $fqIt3 = parcelRequire("fqIt3");


var $7K6Nt = parcelRequire("7K6Nt");


var $9OYfw = parcelRequire("9OYfw");


var $hr9NW = parcelRequire("hr9NW");

const $c13994d6914d469f$var$logger = (0, $7W8i8.getLogger)('load-edit-page');
function $c13994d6914d469f$export$3c152a4b9416769b({ contentId: contentId, useCache: useCache = false, isLivePage: isLivePage = false }) {
    return (0, $3cpum.preloadEditorContentState)({
        contentId: contentId,
        useCache: useCache,
        shouldGetDraftVersion: !isLivePage
    });
}
async function $c13994d6914d469f$export$1149cf9041c3e7b8({ spaceKey: spaceKey, contentId: contentId, shouldPreloadMentionsProvider: shouldPreloadMentionsProvider = false, useCache: useCache = false, catchFn: // use cache for native editor data
catchFn, isBlog: isBlog, cloudId: cloudId, isLivePage: isLivePage = false, isSsrRoutePreload: isSsrRoutePreload = false, contentStatePreloadPromise: contentStatePreloadPromise }) {
    // note: explicitly casting to Promise<any> to avoid typescript incorrectly inferring tuple types; although we don't use the return value of this function regardless
    $c13994d6914d469f$var$logger.debug`Calling preloadEditorData ${performance.now() / 1000}`;
    const draftShareId = (0, $7PLO8.getDraftShareIdFromQueryParam)();
    const shouldReuseContentStatePreloadPromise = contentStatePreloadPromise !== undefined;
    // preload queries shared by Synchrony and Native Collab editors
    const immediateResultsPromises = [
        (0, $irrTO.preloadDraftContentAppearance)(contentId, useCache)
    ];
    // specific native collab editor queries
    if (!!contentId) {
        if ((0, $6mKj3.expValEquals)('web_item_query_batch_content_call', 'isEnabled', true)) {
            const editorToolbarLocations = isLivePage ? [
                (0, $eSLr0.TOOLS_MENU_CONTAINER),
                (0, $eSLr0.PAGE_BUTTONS),
                (0, $eSLr0.SYSTEM_EDITOR_PRECURSOR_BUTTONS)
            ] : [
                (0, $eSLr0.TOOLS_MENU_CONTAINER),
                (0, $eSLr0.SYSTEM_EDITOR_PRECURSOR_BUTTONS)
            ];
            immediateResultsPromises.push((0, $4vyfK.preloadWebItemLocation)({
                contentId: contentId,
                location: editorToolbarLocations
            }));
        }
        const collabDraftPromise = (0, $9OYfw.preloadCollabDraftContent)(contentId, draftShareId, (0, $6mKj3.expValEquals)('platform_editor_collabdraft_query_improvements', 'isEnabled', true) ? useCache || !(0, $fqIt3.isCollabDraftCacheStale)(contentId, draftShareId) : useCache);
        immediateResultsPromises.push(collabDraftPromise);
        immediateResultsPromises.push((0, $7K6Nt.preloadMacroDataFromCollabDraft)({
            collabDraftPromise: collabDraftPromise,
            context: {
                contentId: contentId,
                spaceKey: spaceKey || ''
            },
            route: isLivePage ? 'live' : 'edit'
        }));
        immediateResultsPromises.push((0, $hr9NW.preloadEditorNodeDataProvidersData)(contentId, cloudId, isBlog));
        const { isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(contentId ?? undefined);
        immediateResultsPromises.push((0, $4trRg.preloadContentMode)({
            contentId: contentId,
            isDraft: !isLivePage,
            useCache: useCache,
            isArchived: isArchived
        }));
        immediateResultsPromises.push((0, $1TElT.preloadEmojiTitle)(contentId, draftShareId, useCache), (0, $9OYfw.preloadNativeCollab)(contentId, draftShareId, useCache));
    }
    immediateResultsPromises.push((0, $65pdw.preloadEditorPageCoverPicture)(contentId, draftShareId, useCache), shouldReuseContentStatePreloadPromise ? contentStatePreloadPromise : $c13994d6914d469f$export$3c152a4b9416769b({
        contentId: contentId,
        useCache: useCache,
        isLivePage: isLivePage
    }));
    if (isLivePage) {
        if (!(isSsrRoutePreload && (0, $3gyyc.isSSRStreaming)() && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true))) // Pre-loading apps in the byline area for live pages. Currently only live pages have extension point apps and not classic editor.
        immediateResultsPromises.push((0, $4vyfK.preloadWebItemLocation)({
            contentId: contentId,
            location: (0, $eSLr0.SYSTEM_CONTENT_BYLINE)
        }), // For some reason the addition of the filter (uses new Forge query) is causing SSR to timeout - workaround by skipping the filter
        (0, $8CHHT.preloadUseExtensionList)({
            spaceKey: spaceKey || '',
            moduleType: (0, $7Ndnw.FORGE_MODULE_BYLINE)
        }));
        immediateResultsPromises.push((0, $9nGwZ.preloadLastUpdated)(contentId, useCache));
        immediateResultsPromises.push((0, $cRQNp.preloadReadTime)({
            contentId: contentId,
            useCache: useCache
        }));
        immediateResultsPromises.push((0, $kIqZK.preloadBylinePageAdf)({
            contentId: contentId,
            useCache: useCache
        }));
    }
    if (shouldPreloadMentionsProvider) immediateResultsPromises.push((0, $kDt9L.preloadMentionsProvider)());
    immediateResultsPromises.push((0, $1c0dB.preloadEditorPageTitleContentProperties)({
        contentId: contentId,
        draftShareId: draftShareId,
        useCache: useCache
    }));
    await (0, $lyWac.waitForAllReturnWhenError)(immediateResultsPromises.map((p)=>!!catchFn ? p?.catch(catchFn) : p));
    $c13994d6914d469f$var$logger.debug`preloadEditorData complete ${performance.now() / 1000}`;
}
module.exports["preloadEditorDataContentState"] = $c13994d6914d469f$export$3c152a4b9416769b;
module.exports["preloadEditorData"] = $c13994d6914d469f$export$1149cf9041c3e7b8;

});

parcelRegister("3gyyc", function(module, exports) {

var $1P2f3 = parcelRequire("1P2f3");

const $59e4a4ba3e3599a7$export$7e063004a2621936 = ()=>{
    try {
        const isSSRRendered = // In most places there is no document when running on server-side
        typeof document === 'undefined' || // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        typeof $1P2f3 !== 'undefined' && $1P2f3.env?.REACT_SSR || typeof window !== 'undefined' && window.__SSR_RENDERED__ || globalThis.__SSR_RENDERED__;
        const isSSRReactStreaming = typeof window !== 'undefined' && window.__SSR_REACT_STREAMING__ || globalThis.__SSR_REACT_STREAMING__;
        return Boolean(isSSRRendered) && Boolean(isSSRReactStreaming);
    } catch  {
        // Catch possible error that might occur and just return false
        return false;
    }
};
module.exports["isSSRStreaming"] = $59e4a4ba3e3599a7$export$7e063004a2621936;

});

parcelRegister("3cpum", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $6mKj3 = parcelRequire("6mKj3");


var $kLkaa = parcelRequire("kLkaa");


var $60cDW = parcelRequire("60cDW");


var $3lWl0 = parcelRequire("3lWl0");

function $3c6dabb2bbdb2dae$export$fd17b4d4de258fd0({ contentId: contentId, useCache: useCache, shouldGetDraftVersion: shouldGetDraftVersion }) {
    const contentStatePromise = (0, $dYU3e.query)({
        query: (0, $3lWl0.default),
        variables: {
            contentId: contentId,
            isDraft: shouldGetDraftVersion,
            shouldSkipContentStateLastUpdated: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) ? false : shouldGetDraftVersion,
            isApprovalsFgOn: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true),
            format: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) ? 'MILLIS' : 'USER_FRIENDLY',
            shouldSkipAvailableContentStates: false,
            shouldSkipEditOnlyFields: false
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "content-state"
    });
    if (!(0, $60cDW.getSSRRenderInputs)().uri) return contentStatePromise;
    return contentStatePromise.then((result)=>{
        if (result.data) (0, $kLkaa.ssrContentStateManager).setContentStateData(result.data);
        return result;
    });
}
module.exports["preloadEditorContentState"] = $3c6dabb2bbdb2dae$export$fd17b4d4de258fd0;

});

parcelRegister("kLkaa", function(module, exports) {

var $kryrq = parcelRequire("kryrq");

const $0d582ce5ee1ccbcd$export$71b19f18353d1646 = new (0, $kryrq.SSRContentStateManager)();
module.exports["ssrContentStateManager"] = $0d582ce5ee1ccbcd$export$71b19f18353d1646;

});

parcelRegister("kryrq", function(module, exports) {
class $35f0b3b8b19ef661$export$2099f874c187e33c {
    setContentStateData(data) {
        if (data === null) {
            this.contentStateData = null;
            this.hasContentStateData = false;
            this.contentStateDataConsumers.clear();
            return;
        }
        this.contentStateData = data;
        this.hasContentStateData = true;
        const consumers = this.contentStateDataConsumers;
        this.contentStateDataConsumers = new Set();
        consumers.forEach((consumer)=>consumer(data));
    }
    getContentStateData() {
        return this.contentStateData;
    }
    onContentStateDataAvailable(consumer) {
        if (this.hasContentStateData) {
            consumer(this.contentStateData);
            return;
        }
        this.contentStateDataConsumers.add(consumer);
    }
    constructor(){
        this.contentStateData = null;
        this.hasContentStateData = false;
        this.contentStateDataConsumers = new Set();
    }
}
module.exports["SSRContentStateManager"] = $35f0b3b8b19ef661$export$2099f874c187e33c;

});

parcelRegister("3lWl0", function(module, exports) {
/**
 * @generated SignedSource<<f94631fe88bfaea1f9346228f17314d1>>
 * @relayHash e78f45ef84b0309b46cad2982bdd129a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d9dbad7f6be18f479464c7740ecc608e88f02669cea51d9e028e75b6b84f4eb9
const $34dd87dd4e33f987$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "format"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isApprovalsFgOn"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldSkipAvailableContentStates"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldSkipContentStateLastUpdated"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldSkipEditOnlyFields"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "Variable",
        "name": "isDraft",
        "variableName": "isDraft"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "color"
    }, v11 = {
        "kind": "ScalarField",
        "name": "restrictionLevel"
    }, v12 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v7 /*: any*/ ,
                {
                    "args": [
                        v8 /*: any*/ 
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        {
                            "condition": "shouldSkipEditOnlyFields",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isCallerPermitted"
                                }
                            ]
                        },
                        {
                            "condition": "isApprovalsFgOn",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastModifierAaid"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldSkipContentStateLastUpdated",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "format",
                                    "variableName": "format"
                                },
                                v8 /*: any*/ 
                            ],
                            "concreteType": "ConfluenceDate",
                            "kind": "LinkedField",
                            "name": "contentStateLastUpdated",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "shouldSkipAvailableContentStates",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        }
                    ],
                    "concreteType": "AvailableContentStates",
                    "kind": "LinkedField",
                    "name": "availableContentStates",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentState",
                            "kind": "LinkedField",
                            "name": "customContentStates",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "ContentState",
                            "kind": "LinkedField",
                            "name": "spaceContentStates",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v7 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EditorContentStateQuery",
            "selections": v12 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EditorContentStateQuery",
            "selections": v12 /*: any*/ 
        },
        "params": {
            "cacheID": "e78f45ef84b0309b46cad2982bdd129a",
            "id": "d9dbad7f6be18f479464c7740ecc608e88f02669cea51d9e028e75b6b84f4eb9",
            "metadata": {},
            "name": "EditorContentStateQuery",
            "operationKind": "query",
            "text": "query EditorContentStateQuery($contentId:ID!,$isDraft:Boolean!,$isApprovalsFgOn:Boolean!,$format:GraphQLDateFormat!,$shouldSkipContentStateLastUpdated:Boolean!,$shouldSkipAvailableContentStates:Boolean=false,$shouldSkipEditOnlyFields:Boolean=false){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel,isCallerPermitted@skip(if:$shouldSkipEditOnlyFields),lastModifierAaid@include(if:$isApprovalsFgOn)},contentStateLastUpdated(format:$format,isDraft:$isDraft)@skip(if:$shouldSkipContentStateLastUpdated){value}},availableContentStates(contentId:$contentId)@skip(if:$shouldSkipAvailableContentStates){customContentStates{name,color,id},spaceContentStates{name,color,id,restrictionLevel}}}"
        }
    };
}();
$34dd87dd4e33f987$var$node.hash = "f76426744ff28f16601d3ae4d51a17fb";
var $34dd87dd4e33f987$export$2e2bcd8739ae039 = $34dd87dd4e33f987$var$node;
module.exports["default"] = $34dd87dd4e33f987$export$2e2bcd8739ae039;

});

parcelRegister("7PLO8", function(module, exports) {
const $3009aa09d1bfedbe$export$93a0fdadbf6c055a = ()=>{
    return new URLSearchParams(window.location.search.substring(1)).get('draftShareId') || '';
};
module.exports["getDraftShareIdFromQueryParam"] = $3009aa09d1bfedbe$export$93a0fdadbf6c055a;

});

parcelRegister("irrTO", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $9o4Fw = parcelRequire("9o4Fw");

const $e1546bd447729439$export$f4a1f447ac6a7a9a = (contentId, useCache = true)=>{
    return (0, $dYU3e.query)({
        query: (0, $9o4Fw.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            ...!useCache ? {
                cacheBuster: Date.now()
            } : {}
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        // Match Apollo's warm-cache behavior across editor unmounts and subsequent page visits.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr -- This controls request-scoped cache retention, not rendered output.
        relayQueryPreloadRetention: 'environment',
        __callerPackage__: "content-appearance"
    });
};
module.exports["preloadDraftContentAppearance"] = $e1546bd447729439$export$f4a1f447ac6a7a9a;

});

parcelRegister("kGDoD", function(module, exports) {
$parcel$export(module.exports, "preloadLastUpdated", () => (parcelRequire("9nGwZ")).preloadLastUpdated);
/* eslint-disable check-multiple-entry-point-exports/check-multiple-entry-point-exports */ 
var $9nGwZ = parcelRequire("9nGwZ");


var $9BupY = parcelRequire("9BupY");


});

parcelRegister("9nGwZ", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $9BupY = parcelRequire("9BupY");

function $693a95aca15bff58$export$e7a15421d1327843(contentId, useCache) {
    return (0, $dYU3e.query)({
        query: (0, $9BupY.default),
        variables: {
            contentId: contentId
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "content-header"
    });
}
module.exports["preloadLastUpdated"] = $693a95aca15bff58$export$e7a15421d1327843;

});

parcelRegister("9BupY", function(module, exports) {
/**
 * @generated SignedSource<<6cd69bb600740f6a687eaabe82eab755>>
 * @relayHash 596c33f2627461693b923b812b6e225f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a6f2f69ce739ced471a1cd1301a6cc419fb9a9219690e4c2e066d590fc835235
const $173882722a7c2e36$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "when"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "LivePagesByLineLastUpdatedQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "LivePagesByLineLastUpdatedQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "596c33f2627461693b923b812b6e225f",
            "id": "a6f2f69ce739ced471a1cd1301a6cc419fb9a9219690e4c2e066d590fc835235",
            "metadata": {},
            "name": "LivePagesByLineLastUpdatedQuery",
            "operationKind": "query",
            "text": "query LivePagesByLineLastUpdatedQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,version{friendlyWhen,when}}}}"
        }
    };
}();
$173882722a7c2e36$var$node.hash = "4e6df5756d13dcdcef29e05d538280a7";
var $173882722a7c2e36$export$2e2bcd8739ae039 = $173882722a7c2e36$var$node;
module.exports["default"] = $173882722a7c2e36$export$2e2bcd8739ae039;

});

parcelRegister("1c0dB", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $kae7O = parcelRequire("kae7O");

const $cb49cba09ddc32ea$export$2ea86854c75d3ec8 = async ({ contentId: contentId, draftShareId: draftShareId, useCache: useCache })=>{
    const variables = {
        contentId: contentId,
        status: [
            'current',
            'draft',
            'archived'
        ],
        draftShareId: draftShareId,
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    };
    return (0, $dYU3e.query)({
        query: (0, $kae7O.default),
        variables: variables,
        __callerPackage__: "content-topper"
    });
};
module.exports["preloadEditorPageTitleContentProperties"] = $cb49cba09ddc32ea$export$2ea86854c75d3ec8;

});

parcelRegister("kae7O", function(module, exports) {
/**
 * @generated SignedSource<<235e2f4f1cae802c5b7683463fdf34f9>>
 * @relayHash 177df4e8b836b390b9636d650c93a7b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 73afdec0b7224f93dd9771ff4d32ef23242471659162b27d31de856f0e22f612
const $99e3ac9ccccf9f94$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "alias": "pageTitlePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-published\")"
                        },
                        {
                            "alias": "pageTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-draft\")"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "coverPictureWidth"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForEditorQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForEditorQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "177df4e8b836b390b9636d650c93a7b2",
            "id": "73afdec0b7224f93dd9771ff4d32ef23242471659162b27d31de856f0e22f612",
            "metadata": {},
            "name": "useTitleContentPropertiesForEditorQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForEditorQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}}}"
        }
    };
}();
$99e3ac9ccccf9f94$var$node.hash = "cdd7743e3348e4dc97a35c6808323ae0";
var $99e3ac9ccccf9f94$export$2e2bcd8739ae039 = $99e3ac9ccccf9f94$var$node;
module.exports["default"] = $99e3ac9ccccf9f94$export$2e2bcd8739ae039;

});

parcelRegister("kDt9L", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $dYU3e = parcelRequire("dYU3e");


var $89CKS = parcelRequire("89CKS");

const $6bd71bdc26599ad9$export$45c648ba9bf4e12f = async ()=>(0, $dYU3e.query)({
        query: (0, $89CKS.default),
        __callerPackage__: "fabric-media-support"
    });
module.exports["preloadMentionsProvider"] = $6bd71bdc26599ad9$export$45c648ba9bf4e12f;

});

parcelRegister("kIqZK", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $dYU3e = parcelRequire("dYU3e");


var $grd6j = parcelRequire("grd6j");

async function $760eca6be826728d$export$650b241b1f8dc3b6({ contentId: contentId, useCache: useCache }) {
    if (!contentId || !(0, $6mKj3.expValEquals)('confluence_1p_and_3p_connection_byline_experiment', 'isEnabled', true)) return;
    return (0, $dYU3e.query)({
        query: (0, $grd6j.default),
        variables: {
            contentId: contentId
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "byline-connections"
    });
}
module.exports["preloadBylinePageAdf"] = $760eca6be826728d$export$650b241b1f8dc3b6;

});

parcelRegister("grd6j", function(module, exports) {
/**
 * @generated SignedSource<<eff7d44a3c3325ad9844d6a92fba38bc>>
 * @relayHash f812791104b0d3338eca867ab249c516
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a655ee1f977a9f534301bf4073cd137e9afcf643751bd79aaaac4c541f973511
const $634ac6ca07897c3c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentBodyPerRepresentation",
                            "kind": "LinkedField",
                            "name": "body",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentBody",
                                    "kind": "LinkedField",
                                    "name": "dynamic",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "representation"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "BylinePageAdfQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "BylinePageAdfQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f812791104b0d3338eca867ab249c516",
            "id": "a655ee1f977a9f534301bf4073cd137e9afcf643751bd79aaaac4c541f973511",
            "metadata": {},
            "name": "BylinePageAdfQuery",
            "operationKind": "query",
            "text": "query BylinePageAdfQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,body{dynamic{value,representation}}}}}"
        }
    };
}();
$634ac6ca07897c3c$var$node.hash = "71971ced9613217ef152b156007bcf74";
var $634ac6ca07897c3c$export$2e2bcd8739ae039 = $634ac6ca07897c3c$var$node;
module.exports["default"] = $634ac6ca07897c3c$export$2e2bcd8739ae039;

});

parcelRegister("fqIt3", function(module, exports) {
const $3014a7cdda499b2d$var$collabDraftFetchTimestamps = new Map();
// TTL for CollabDraftQuery cached data
// This prevents stale data during SPA transitions while still allowing
// cache-first for SSR-rendered pages within the TTL window
const $3014a7cdda499b2d$var$COLLAB_DRAFT_TTL_MS = 15000;
/**
 * Creates a composite cache key that includes both contentId and draftShareId.
 * This aligns with how Apollo caches queries by their variables.
 */ const $3014a7cdda499b2d$var$getCacheKey = (contentId, draftShareId)=>{
    return `${contentId}:${draftShareId || ''}`;
};
function $3014a7cdda499b2d$export$76901333d647261(contentId, draftShareId) {
    const key = $3014a7cdda499b2d$var$getCacheKey(contentId, draftShareId);
    const lastFetchTime = $3014a7cdda499b2d$var$collabDraftFetchTimestamps.get(key);
    if (!lastFetchTime) return true;
    return Date.now() - lastFetchTime > $3014a7cdda499b2d$var$COLLAB_DRAFT_TTL_MS;
}
function $3014a7cdda499b2d$export$85437e97168f99bc(contentId, draftShareId) {
    const key = $3014a7cdda499b2d$var$getCacheKey(contentId, draftShareId);
    $3014a7cdda499b2d$var$collabDraftFetchTimestamps.set(key, Date.now());
}
function $3014a7cdda499b2d$export$5f725cb33e7218ab(contentId, draftShareId) {
    const key = $3014a7cdda499b2d$var$getCacheKey(contentId, draftShareId);
    $3014a7cdda499b2d$var$collabDraftFetchTimestamps.delete(key);
}
function $3014a7cdda499b2d$export$a379bfa68f31645e() {
    $3014a7cdda499b2d$var$collabDraftFetchTimestamps.clear();
}
module.exports["isCollabDraftCacheStale"] = $3014a7cdda499b2d$export$76901333d647261;
module.exports["markCollabDraftFetched"] = $3014a7cdda499b2d$export$85437e97168f99bc;
module.exports["clearCollabDraftTimestamp"] = $3014a7cdda499b2d$export$5f725cb33e7218ab;

});

parcelRegister("9OYfw", function(module, exports) {

var $iZ7G7 = parcelRequire("iZ7G7");


var $6mKj3 = parcelRequire("6mKj3");


var $dYU3e = parcelRequire("dYU3e");


var $l1kdf = parcelRequire("l1kdf");


var $nIvaQ = parcelRequire("nIvaQ");


var $8R0gj = parcelRequire("8R0gj");


var $hNtOj = parcelRequire("hNtOj");


var $27Dus = parcelRequire("27Dus");

function $cb117090d47a4a62$export$952cf09a216eb6d(contentId, draftShareId, useCache) {
    return (0, $dYU3e.query)({
        query: (0, $nIvaQ.getCollabDraftQuery)(),
        variables: {
            id: contentId,
            hydrateAdf: true,
            ...draftShareId ? {
                draftShareId: draftShareId
            } : undefined
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "load-edit-page"
    }).then(async (result)=>{
        // There is a bug in appolo client (https://github.com/apollographql/react-apollo/issues/3918)
        // that doesn't preserve the result in caches if there is an error in SSR
        // So we need to preserve the error, to be able to verify it later during render phase in SSR
        if (result?.errors?.some((err)=>(0, $8R0gj.isDraftSSRPreloadPermissionError)(err?.message))) (0, $hNtOj.ssrPermissionsErrorHandler).markSSRPreloadPermissionError('edit');
        // There are two reasons to store smart card URLs on the window object:
        // 1. The OTP uses a document snapshot from Confluence that may be outdated and miss recently added or removed smart cards,
        //    so we must reconcile the list of smart cards with the draft content.
        // 2. The draft content stores links with slugs, but the Confluence snapshot does not,
        //    so we need to add slugs sourced from the draft content.
        // Therefore, we extract smart cards from the draft content here, save them on the window object,
        // and later use them to align the Confluence snapshot with the draft content.
        if ((0, $6mKj3.expValEquals)('cc-proj-xl-dedup-macro-preload-adf-parsing', 'isEnabled', true)) window['__SMART_CARDS_IN_DRAFT__'] = (0, $27Dus.findSmartCardNodesFromDoc)((0, $iZ7G7.parseCollabDraftAdf)(result));
        else window['__SMART_CARDS_IN_DRAFT__'] = (0, $27Dus.findSmartCardNodes)(result?.data?.collabDraft?.document || '');
        return result;
    });
}
function $cb117090d47a4a62$export$7c1f00ae06ab82b8(contentId, draftShareId, useCache, status) {
    return (0, $dYU3e.query)({
        query: (0, $l1kdf.NativeCollabQuery),
        variables: {
            contentId: contentId,
            ...draftShareId && {
                draftShareId: draftShareId
            },
            status: status ?? [
                'draft',
                'current'
            ]
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        context: {
            single: 'true'
        },
        __callerPackage__: "load-edit-page"
    });
}
module.exports["preloadCollabDraftContent"] = $cb117090d47a4a62$export$952cf09a216eb6d;
module.exports["preloadNativeCollab"] = $cb117090d47a4a62$export$7c1f00ae06ab82b8;

});

parcelRegister("l1kdf", function(module, exports) {

var $hrBIS = parcelRequire("hrBIS");

const $c2e596865d8e6fea$export$79b924d780de6f0d = (0, $hrBIS.default);
module.exports["NativeCollabQuery"] = $c2e596865d8e6fea$export$79b924d780de6f0d;

});

parcelRegister("hrBIS", function(module, exports) {
/**
 * @generated SignedSource<<4cf4db12dd73f2ac885d741a3d7c65ba>>
 * @relayHash 4e152ff0861f20bc69927f68972ccc1e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 24bbbff0309d612fd3761eb95cc4e8454341bfb5663a836acebc11c0a54451dc
const $83575f8369490c15$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "draftShareId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "draftShareId",
            "variableName": "draftShareId"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Variable",
            "name": "status",
            "variableName": "status"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "ScalarField",
        "name": "status"
    }, v5 = {
        "kind": "ScalarField",
        "name": "number"
    }, v6 = {
        "kind": "ScalarField",
        "name": "ncsStepVersion"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "homepageId"
            }
        ]
    }, v12 = {
        "concreteType": "PaginatedLabelList",
        "kind": "LinkedField",
        "name": "labels",
        "plural": false,
        "selections": [
            {
                "concreteType": "Label",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v2 /*: any*/ ,
                    v10 /*: any*/ 
                ]
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v14 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "NativeCollabQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                },
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "NativeCollabQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                },
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "4e152ff0861f20bc69927f68972ccc1e",
            "id": "24bbbff0309d612fd3761eb95cc4e8454341bfb5663a836acebc11c0a54451dc",
            "metadata": {},
            "name": "NativeCollabQuery",
            "operationKind": "query",
            "text": "query NativeCollabQuery($contentId:ID,$draftShareId:String,$status:[String]){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,type,status,version{number,ncsStepVersion,by{__typename,type,...on KnownUser{accountId}}},history{createdBy{__typename,displayName},createdDate},space{id,name,homepageId},labels{nodes{id,name}},subType}}}"
        }
    };
}();
$83575f8369490c15$var$node.hash = "182a5142c1846497c5e27245efe74033";
var $83575f8369490c15$export$2e2bcd8739ae039 = $83575f8369490c15$var$node;
module.exports["default"] = $83575f8369490c15$export$2e2bcd8739ae039;

});

parcelRegister("nIvaQ", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $fXb84 = parcelRequire("fXb84");


var $7ZQNA = parcelRequire("7ZQNA");

const $c4f625141049567c$export$1248f2ac56981fbd = ()=>(0, $6mKj3.expValEquals)('platform_editor_early_exit_return_draft', 'isEnabled', true) ? (0, $fXb84.CollabDraftWithRelevanceQuery) : (0, $7ZQNA.CollabDraftQuery);
module.exports["getCollabDraftQuery"] = $c4f625141049567c$export$1248f2ac56981fbd;

});

parcelRegister("fXb84", function(module, exports) {

var $kiLxw = parcelRequire("kiLxw");

const $abbff5e8c5475947$export$fb92c84fb9714700 = (0, $kiLxw.default);
module.exports["CollabDraftWithRelevanceQuery"] = $abbff5e8c5475947$export$fb92c84fb9714700;

});

parcelRegister("kiLxw", function(module, exports) {
/**
 * @generated SignedSource<<c2d68d945c3fe4452d03d6bdc8ddfd5c>>
 * @relayHash 5eb9ba691ed48d80122a8d87074eee9c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 19ff778aa0cc634375733dc31cf334d93ce6c8c4e3dd7bf786f4393165965ee1
const $ff1e82bf0b897703$var$node = function() {
    var v0 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hydrateAdf"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "hydrateAdf",
                    "variableName": "hydrateAdf"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "CollabDraft",
            "kind": "LinkedField",
            "name": "collabDraft",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "document"
                },
                {
                    "kind": "ScalarField",
                    "name": "version"
                },
                {
                    "concreteType": "CollabDraftMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "relevance"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CollabDraftWithRelevanceQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CollabDraftWithRelevanceQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "5eb9ba691ed48d80122a8d87074eee9c",
            "id": "19ff778aa0cc634375733dc31cf334d93ce6c8c4e3dd7bf786f4393165965ee1",
            "metadata": {},
            "name": "CollabDraftWithRelevanceQuery",
            "operationKind": "query",
            "text": "query CollabDraftWithRelevanceQuery($id:ID!,$draftShareId:String=\"\",$hydrateAdf:Boolean){collabDraft(id:$id,draftShareId:$draftShareId,hydrateAdf:$hydrateAdf){document,version,metadata{title,relevance}}}"
        }
    };
}();
$ff1e82bf0b897703$var$node.hash = "c0bfcca7b64103265224238d7c18d9b1";
var $ff1e82bf0b897703$export$2e2bcd8739ae039 = $ff1e82bf0b897703$var$node;
module.exports["default"] = $ff1e82bf0b897703$export$2e2bcd8739ae039;

});

parcelRegister("7ZQNA", function(module, exports) {

var $lU81J = parcelRequire("lU81J");

const $270318977b9095e1$export$89183b1b5e58f33c = (0, $lU81J.default);
module.exports["CollabDraftQuery"] = $270318977b9095e1$export$89183b1b5e58f33c;

});

parcelRegister("lU81J", function(module, exports) {
/**
 * @generated SignedSource<<81d932c04171cccd3ee1c517fa2180ce>>
 * @relayHash cd92794db2ea2a3b9bfa36b4fb9ae833
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44e85cfd7f416b92fd30c810982ddfc4aeaa8b9ab964fe47829b79185c29b63a
const $e1affc2f9f206abd$var$node = function() {
    var v0 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hydrateAdf"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "hydrateAdf",
                    "variableName": "hydrateAdf"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "CollabDraft",
            "kind": "LinkedField",
            "name": "collabDraft",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "document"
                },
                {
                    "kind": "ScalarField",
                    "name": "version"
                },
                {
                    "concreteType": "CollabDraftMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CollabDraftQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CollabDraftQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "cd92794db2ea2a3b9bfa36b4fb9ae833",
            "id": "44e85cfd7f416b92fd30c810982ddfc4aeaa8b9ab964fe47829b79185c29b63a",
            "metadata": {},
            "name": "CollabDraftQuery",
            "operationKind": "query",
            "text": "query CollabDraftQuery($id:ID!,$draftShareId:String=\"\",$hydrateAdf:Boolean){collabDraft(id:$id,draftShareId:$draftShareId,hydrateAdf:$hydrateAdf){document,version,metadata{title}}}"
        }
    };
}();
$e1affc2f9f206abd$var$node.hash = "3cf6959ca06a0e7e4a4e60e0c720b14e";
var $e1affc2f9f206abd$export$2e2bcd8739ae039 = $e1affc2f9f206abd$var$node;
module.exports["default"] = $e1affc2f9f206abd$export$2e2bcd8739ae039;

});

parcelRegister("8R0gj", function(module, exports) {

var $747ya = parcelRequire("747ya");

async function $65899b702fdd32b1$export$dfd3c4c0aa957792(contentId, draftShareId) {
    window.__PRELOAD_DRAFT__ = {
        contentId: contentId,
        draftFetchPromise: (0, $747ya.fetchDraft)(contentId, draftShareId),
        startTime: window?.performance?.now?.()
    };
}
const $65899b702fdd32b1$var$DRAFT_PERMISSION_ERROR = '.PermissionException: User does not have permission';
function $65899b702fdd32b1$export$9d45b1b64b2cb8e1(message) {
    if (!message) return false;
    return message.indexOf($65899b702fdd32b1$var$DRAFT_PERMISSION_ERROR) > -1 || false;
}
module.exports["preloadDraft"] = $65899b702fdd32b1$export$dfd3c4c0aa957792;
module.exports["isDraftSSRPreloadPermissionError"] = $65899b702fdd32b1$export$9d45b1b64b2cb8e1;

});

parcelRegister("747ya", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $6mKj3 = parcelRequire("6mKj3");


var $fqIt3 = parcelRequire("fqIt3");


var $nIvaQ = parcelRequire("nIvaQ");

async function $67d2826966f59cb2$export$af6160a01d539948(contentId, draftShareId) {
    // Use cache-first only if SSR rendered AND cache is not stale (within TTL)
    // This prevents stale data during SPA transitions while still benefiting from SSR cache
    const shouldUseCache = (0, $6mKj3.expValEquals)('platform_editor_collabdraft_query_improvements', 'isEnabled', true) ? window.__SSR_RENDERED__ || !(0, $fqIt3.isCollabDraftCacheStale)(contentId, draftShareId) : window.__SSR_RENDERED__;
    const response = await (0, $c0rhi.queryInterop)({
        query: (0, $nIvaQ.getCollabDraftQuery)(),
        variables: {
            id: contentId,
            hydrateAdf: true,
            ...draftShareId ? {
                draftShareId: draftShareId
            } : undefined
        },
        fetchPolicy: shouldUseCache ? 'cache-first' : 'network-only',
        __callerPackage__: "fabric-providers"
    });
    const { data: data, error: error } = response;
    if (error || !data?.collabDraft) return {
        draft: null,
        response: response
    };
    const { document: document, version: version, metadata: metadata } = data.collabDraft;
    const draft = {
        version: version,
        metadata: $67d2826966f59cb2$var$excludeTypename(metadata),
        document: JSON.parse(document || '')
    };
    return {
        draft: draft,
        response: response
    };
}
function $67d2826966f59cb2$var$excludeTypename(metadata) {
    if (!metadata) return metadata;
    const { __typename: __typename, ...rest } = metadata;
    return rest;
}
module.exports["fetchDraft"] = $67d2826966f59cb2$export$af6160a01d539948;

});

parcelRegister("27Dus", function(module, exports) {

var $eRwHS = parcelRequire("eRwHS");


var $gVWsk = parcelRequire("gVWsk");


var $6GQtz = parcelRequire("6GQtz");


var $aN0qB = parcelRequire("aN0qB");

function $010c1dfc98319256$export$4d8d014fcb52d0f(doc) {
    if (!(0, $gVWsk.isJSONDocNode)(doc)) return [];
    const cardProvider = new (0, $6GQtz.ConfluenceEditorCardProvider)('custom');
    return (0, $eRwHS.findNodesToPrefetch)(doc, [
        {
            provider: cardProvider,
            maxNodesToPrefetch: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH).smartCard
        }
    ], (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT))[0].nodes;
}
function $010c1dfc98319256$export$1970baffe86d32af(docJsonString) {
    if (!docJsonString) return [];
    return $010c1dfc98319256$export$4d8d014fcb52d0f(JSON.parse(docJsonString));
}
module.exports["findSmartCardNodesFromDoc"] = $010c1dfc98319256$export$4d8d014fcb52d0f;
module.exports["findSmartCardNodes"] = $010c1dfc98319256$export$1970baffe86d32af;

});

parcelRegister("eRwHS", function(module, exports) {
function $d135bda53bcecc47$export$41263783ff0932a8(doc, providers, maxNodesToVisit) {
    // Counter for the total number of visited nodes to limit the traversal.
    let totalVisitedNodesCount = 0;
    // A map to store the results, with the provider name as the key.
    const resultMap = providers.reduce((acc, { provider: provider })=>{
        acc[provider.name] = {
            provider: provider,
            nodes: []
        };
        return acc;
    }, {});
    // It doesn't use `filter` function from `@atlaskit/adf-utils/traverse` because it does not support early stopping.
    // We need to stop traversing when we reach the maximum number of nodes to visit to support large documents.
    // Create a list of providers for which we still need to find nodes.
    const providersToLookup = providers.filter(({ maxNodesToPrefetch: maxNodesToPrefetch })=>maxNodesToPrefetch > 0).map(({ provider: provider, maxNodesToPrefetch: maxNodesToPrefetch })=>({
            provider: provider,
            maxNodesToPrefetch: maxNodesToPrefetch,
            foundNodes: 0
        }));
    // Stack for the depth-first search (DFS), starting with the root document node.
    const nodesToVisit = [
        doc
    ];
    // The loop continues as long as there are nodes to visit, providers to look for,
    // and the visited nodes limit has not been reached.
    while(nodesToVisit.length > 0 && providersToLookup.length > 0 && totalVisitedNodesCount < maxNodesToVisit){
        totalVisitedNodesCount += 1;
        // Pop from the end to maintain DFS order (LIFO - Last In, First Out)
        const currentNode = nodesToVisit.pop();
        if (!currentNode) continue;
        // Using a reverse loop to avoid issues with array mutation (when removing elements).
        for(let i = providersToLookup.length - 1; i >= 0; i--){
            const providerToFind = providersToLookup[i];
            // Check if the current provider supports this node.
            if (providerToFind.provider.isNodeSupported(currentNode)) {
                // If provider supports the node, add it to the result map.
                resultMap[providerToFind.provider.name].nodes.push(currentNode);
                // Increment the count of found nodes for this provider.
                providerToFind.foundNodes += 1;
                // If the provider has found enough nodes, remove it from the lookup list.
                if (providerToFind.foundNodes >= providerToFind.maxNodesToPrefetch) providersToLookup.splice(i, 1);
            }
        }
        // If the current node has children, add them to the stack in reverse order
        // to maintain left-to-right traversal when popping from the stack,
        // because it's LIFO.
        if (currentNode.content) // Push children in reverse order to maintain correct DFS traversal order
        for(let i = currentNode.content.length - 1; i >= 0; i--){
            const node = currentNode.content[i];
            if (node) nodesToVisit.push(node);
        }
    }
    // Return an array of the found nodes, grouped by provider.
    return Object.values(resultMap);
}
module.exports["findNodesToPrefetch"] = $d135bda53bcecc47$export$41263783ff0932a8;

});

parcelRegister("6GQtz", function(module, exports) {

var $6RwwD = parcelRequire("6RwwD");


var $6mKj3 = parcelRequire("6mKj3");

const $1f40ba7d8e61cd02$var$isTrelloBoardUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?trello\.com\/b/);
const $1f40ba7d8e61cd02$var$isFigmaFileUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?figma\.com\/(design|board|file|proto|slides)/);
const $1f40ba7d8e61cd02$var$isFigmaMakeSiteUrl = (url)=>!!url.match(/^https:\/\/.+\.figma\.site/);
const $1f40ba7d8e61cd02$var$isMiroUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?miro\.com\/app\/board/);
const $1f40ba7d8e61cd02$var$isCanvaUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?canva\.com\/design/);
const $1f40ba7d8e61cd02$var$isLucidUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?lucid\.app\/lucidchart/);
const $1f40ba7d8e61cd02$var$isGoogleSlidesUrl = (url)=>!!url.match(/^https:\/\/docs\.google\.com\/presentation/);
const $1f40ba7d8e61cd02$var$isOneDrivePowerPointUrl = (url)=>!!url.match(/^https:\/\/onedrive\.live\.com\/:p/) || !!url.match(/^https:\/\/1drv\.ms\/p/);
const $1f40ba7d8e61cd02$var$isTrelloCardUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?trello\.com\/c/);
const $1f40ba7d8e61cd02$var$isPowerBIUrl = (url)=>!!url.match(/^https:\/\/app\.powerbi\.com\/(groups|reportEmbed)/);
const $1f40ba7d8e61cd02$var$isGoogleDocsUrl = (url)=>!!url.match(/^https:\/\/docs\.google\.com\/document/);
// https://learn.microsoft.com/en-us/onedrive/developer/controls/file-pickers/?view=odsp-graph-online
const $1f40ba7d8e61cd02$var$isLearnMicrosoftUrl = (url)=>!!url.match(/^https:\/\/learn\.microsoft\.com/);
// https://support.google.com/mail/answer/112508?hl=en&co=GENIE.Platform%3DDesktop
const $1f40ba7d8e61cd02$var$isSupportGoogleUrl = (url)=>!!url.match(/^https:\/\/support\.google\.com/);
// https://docs.github.com/en/codespaces
const $1f40ba7d8e61cd02$var$isDocsGithubUrl = (url)=>!!url.match(/^https:\/\/docs\.github\.com/);
const $1f40ba7d8e61cd02$var$isDropboxUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?dropbox\.com\/(home|preview|s|sh|sc|t|scl)/);
const $1f40ba7d8e61cd02$var$isBoxUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?box\.com\/(folder|file|notes|integrations|services|s|v)/);
const $1f40ba7d8e61cd02$var$isSlackUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?slack\.com\/(archives|client)/);
const $1f40ba7d8e61cd02$var$isTeamsUrl = (url)=>!!url.match(/^https:\/\/teams\.microsoft\.com\/l\/channel/) || !!url.match(/^https:\/\/teams\.cloud\.microsoft\/l\/channel/);
const $1f40ba7d8e61cd02$var$isLovableAppUrl = (url)=>!!url.match(/^https:\/\/.+\.lovable\.app/);
const $1f40ba7d8e61cd02$var$isReplitAppUrl = (url)=>!!url.match(/^https:\/\/.+\.replit\.app/);
class $1f40ba7d8e61cd02$export$9d24f5da29b1273e extends (0, $6RwwD.EditorCardProvider) {
    getHardCodedAppearance(url) {
        if (this.shouldDisplayAsEmbed(url)) return 'embed';
        if (this.shouldDisplayAsCard(url)) return 'block';
        return super.getHardCodedAppearance(url);
    }
    /**
   * Opt in to honouring an explicitly-requested embed appearance as the default
   * (validated, with a card fallback) for the quick-insert embed flow. Both active
   * cohorts of the quick-insert embeds experiment (`prioritizeLinkInQIM` and
   * `prioritizeEmbedInQIM`) enable this — they differ only in quick-insert menu
   * ordering, not in embedding behaviour. Only `control` and unenrolled users keep
   * the existing behaviour.
   *
   * The platform only calls this when a link is inserted with a requested embed
   * appearance and the user has no saved preference, so the exposure here is
   * scoped to the quick-insert embed insertion path.
   */ shouldHonorRequestedEmbedAsDefault() {
        return (0, $6mKj3.expVal)('confluence_quick_insert_embeds', 'cohort', 'control') !== 'control';
    }
    shouldDisplayAsEmbed(url) {
        return $1f40ba7d8e61cd02$var$isTrelloBoardUrl(url) || $1f40ba7d8e61cd02$var$isFigmaFileUrl(url) || $1f40ba7d8e61cd02$var$isFigmaMakeSiteUrl(url) || $1f40ba7d8e61cd02$var$isMiroUrl(url) || $1f40ba7d8e61cd02$var$isCanvaUrl(url) || $1f40ba7d8e61cd02$var$isLucidUrl(url) || $1f40ba7d8e61cd02$var$isGoogleSlidesUrl(url) || $1f40ba7d8e61cd02$var$isOneDrivePowerPointUrl(url);
    }
    shouldDisplayAsCard(url) {
        return $1f40ba7d8e61cd02$var$isTrelloCardUrl(url) || $1f40ba7d8e61cd02$var$isPowerBIUrl(url) || $1f40ba7d8e61cd02$var$isGoogleDocsUrl(url) || $1f40ba7d8e61cd02$var$isLearnMicrosoftUrl(url) || $1f40ba7d8e61cd02$var$isSupportGoogleUrl(url) || $1f40ba7d8e61cd02$var$isDocsGithubUrl(url) || $1f40ba7d8e61cd02$var$isDropboxUrl(url) || $1f40ba7d8e61cd02$var$isBoxUrl(url) || $1f40ba7d8e61cd02$var$isSlackUrl(url) || $1f40ba7d8e61cd02$var$isTeamsUrl(url) || $1f40ba7d8e61cd02$var$isLovableAppUrl(url) || $1f40ba7d8e61cd02$var$isReplitAppUrl(url);
    }
    constructor(envKey, baseUrlOverride, onResolve, customCardClient, supportedUrlFilter, name){
        super(envKey, baseUrlOverride, 'CONFLUENCE', onResolve, customCardClient, supportedUrlFilter);
        this.name = void 0;
        this.name = name ?? 'editorCardProvider';
    }
}
module.exports["ConfluenceEditorCardProvider"] = $1f40ba7d8e61cd02$export$9d24f5da29b1273e;

});

parcelRegister("6RwwD", function(module, exports) {
/* eslint-disable require-unicode-regexp,prefer-regex-literals */ 
var $6Q8Dd = parcelRequire("6Q8Dd");


var $8OcYi = parcelRequire("8OcYi");


var $3ewaO = parcelRequire("3ewaO");


var $4yccB = parcelRequire("4yccB");


var $kzwaO = parcelRequire("kzwaO");


var $cXJjm = parcelRequire("cXJjm");


var $ggGdk = parcelRequire("ggGdk");


var $drRzc = parcelRequire("drRzc");


var $iDrrr = parcelRequire("iDrrr");


var $biKbJ = parcelRequire("biKbJ");


var $iyuxZ = parcelRequire("iyuxZ");


var $koAyx = parcelRequire("koAyx");


var $8kONW = parcelRequire("8kONW");

const $d4521f0694a3bb0e$var$BATCH_WAIT_TIME = 50;
// Check if it is matching a Jira Roadmaps or Jira Timeline url
// NOT to be confused with JSM timeline
const $d4521f0694a3bb0e$var$JIRA_ROADMAP_OR_TIMELINE_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/.*?\/(timeline|roadmap)\/?/;
const $d4521f0694a3bb0e$var$POLARIS_VIEW_REGEX = /^https:\/\/.*?\/jira\/polaris\/projects\/[^\/]+?\/ideas\/view\/\d+$|^https:\/\/.*?\/secure\/JiraProductDiscoveryAnonymous\.jspa\?hash=\w+|^https:\/\/.*?\/jira\/polaris\/share\/\w+|^https:\/\/.*?\/jira\/discovery\/share\/views\/[\w-]+(\?selectedIssue=[\w-]+&issueViewLayout=sidebar&issueViewSection=[\w-]+)?$/;
const $d4521f0694a3bb0e$var$JWM_VIEW_REGEX = /^https:\/\/.*?\/jira\/core\/projects\/[^\/]+?\/(timeline|calendar|list|board|summary|(form\/[^\/]+?))\/?/;
const $d4521f0694a3bb0e$var$JIRA_LIST_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/list\/?/;
const $d4521f0694a3bb0e$var$GIPHY_MEDIA_REGEX = /^https:\/\/(.*?\.)?giphy\.com\/(gifs|media|clips)\//;
const $d4521f0694a3bb0e$var$PROFORMA_VIEW_REGEX = /^https:\/\/[^/]+\/jira\/(core|software(\/c)?|servicedesk)\/projects\/\w+\/forms\/form\/direct\/\d+\/\d+.*$/;
// prettier-ignore
const $d4521f0694a3bb0e$var$CONFLUENCE_WHITEBOARD_DECIMAL_REGEX = RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>\\d+)(\\?\\/)?");
// prettier-ignore
const $d4521f0694a3bb0e$var$CONFLUENCE_WHITEBOARD_UUID_REGEX = RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})(\\?\\/)?");
const $d4521f0694a3bb0e$var$CONFLUENCE_DATABASE_REGEX = /\/wiki\/spaces\/~?[\d\w]+\/database\/\d+(\?.*)?$/;
const $d4521f0694a3bb0e$var$YOUTUBE_VIDEO_REGEX = /^https:\/\/(.*?\.)?(youtube\..*?\/(watch\?|v\/|shorts\/)|youtu\.be)/;
// prettier-ignore
const $d4521f0694a3bb0e$var$LOOM_VIDEO_URL_REGEX = RegExp("^https:\\/\\/(.*?\\.)?(loom\\..*?\\/(share|embed))\\/([a-zA-Z0-9-]*-)?(?<videoId>[a-f0-9]{32})");
// prettier-ignore
const $d4521f0694a3bb0e$var$LOOM_PLAYLIST_URL_REGEX = /^https:\/\/(.*?\.)?loom\..*?\/(?:playlists\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?:\/view)?|embed\/playlists\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:\?|$)/i;
const $d4521f0694a3bb0e$var$LOOM_SCREENSHOT_URL_REGEX = RegExp("^https:\\/\\/(.*?\\.)?loom\\..*?\\/i\\/(?<id>[a-f0-9]{32})");
const $d4521f0694a3bb0e$var$JIRA_DASHBOARD_REGEX = /^https:\/\/.*?\/jira\/dashboards\/[0-9]+.*/;
const $d4521f0694a3bb0e$var$JIRA_BACKLOG_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\/backlog\??.*/;
const $d4521f0694a3bb0e$var$JIRA_BOARD_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\??.*/;
const $d4521f0694a3bb0e$var$JIRA_PLAN_REGEX = RegExp("https:\\/\\/.*?\\/jira\\/plans\\/(?<resourceId>\\d+)");
// prettier-ignore
const $d4521f0694a3bb0e$var$JIRA_PLAN_WITH_SCENARIO_REGEX = RegExp("https:\\/\\/.*?\\/jira\\/plans\\/(?<resourceId>\\d+)\\/scenarios\\/(?<resourceContext>\\d+)\\/(timeline|summary|calendar|program\\/\\d+|dependencies)\\/?");
const $d4521f0694a3bb0e$var$JIRA_VERSION_REGEX = /https:\/\/.*?\/projects\/[^\/]+?\/versions\/\d+\/tab\/release-report-all-issues/;
const $d4521f0694a3bb0e$var$JIRA_FORM_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/form\/\d\??.*/;
const $d4521f0694a3bb0e$var$JIRA_SUMMARY_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/summary/;
const $d4521f0694a3bb0e$var$ROVO_AGENT_PROFILE_PAGE_REGEX = /^https:\/\/.*?\/people\/agent\/.+$/;
const $d4521f0694a3bb0e$var$CUSTOMER_360_LANDING_PAGE_REGEX = /^https:\/\/customer\.atlassian\.com\/.*$/;
// prettier-ignore
const $d4521f0694a3bb0e$var$CONFLUENCE_TEAM_CALENDARS_REGEX = RegExp("\\/wiki\\/spaces\\/(?<resourceContext>[^\\/]+)\\/calendars\\/(?<resourceId>[a-zA-Z0-9-]+)");
const $d4521f0694a3bb0e$var$JIRA_ISSUE_NAVIGATOR_REGEX = /^https:\/\/.*?\/jira\/software|core\/(c\/)?projects\/[^\/]+?\/issues\/?/;
const $d4521f0694a3bb0e$var$AVP_VISUALIZATION_VIEW_REGEX = /^https:\/\/.*?\/avpviz\/c\/[^\/]+.*/;
const $d4521f0694a3bb0e$var$DASHBOARDS_CHART_VIEW_REGEX = /^https:\/\/.*?\/dashboards\/c\/[^\/]+.*/;
const $d4521f0694a3bb0e$var$JIRA_WORK_ITEM_REGEX = /\/browse\/((?:\w+)-(?:\d+))/i;
const $d4521f0694a3bb0e$var$DOES_URL_MATCH_PATH_START_REGEX = /^[a-zA-Z0-9]/;
const $d4521f0694a3bb0e$var$DOES_URL_MATCH_PATH_END_REGEX = /[a-zA-Z0-9]$/;
const $d4521f0694a3bb0e$var$CONFLUENCE_SHORT_LINK_URL_REGEX = /^https:\/\/[^/?#]+\/wiki\/x\/[A-Za-z0-9_-]+\/?(?:[?#].*)?$/;
const $d4521f0694a3bb0e$var$isConfluenceShortLinkUrl = (url)=>url.match($d4521f0694a3bb0e$var$CONFLUENCE_SHORT_LINK_URL_REGEX);
const $d4521f0694a3bb0e$var$isJiraRoadmapOrTimeline = (url)=>url.match($d4521f0694a3bb0e$var$JIRA_ROADMAP_OR_TIMELINE_REGEX);
const $d4521f0694a3bb0e$var$isPolarisView = (url)=>url.match($d4521f0694a3bb0e$var$POLARIS_VIEW_REGEX);
const $d4521f0694a3bb0e$var$isJwmView = (url)=>url.match($d4521f0694a3bb0e$var$JWM_VIEW_REGEX);
const $d4521f0694a3bb0e$var$isJiraList = (url)=>url.match($d4521f0694a3bb0e$var$JIRA_LIST_REGEX);
const $d4521f0694a3bb0e$var$isGiphyMedia = (url)=>url.match($d4521f0694a3bb0e$var$GIPHY_MEDIA_REGEX);
const $d4521f0694a3bb0e$var$isProformaView = (url)=>url.match($d4521f0694a3bb0e$var$PROFORMA_VIEW_REGEX);
const $d4521f0694a3bb0e$var$isConfluenceWhiteboard = (url)=>url.match($d4521f0694a3bb0e$var$CONFLUENCE_WHITEBOARD_DECIMAL_REGEX) || url.match($d4521f0694a3bb0e$var$CONFLUENCE_WHITEBOARD_UUID_REGEX);
const $d4521f0694a3bb0e$var$isConfluenceDatabase = (url)=>url.match($d4521f0694a3bb0e$var$CONFLUENCE_DATABASE_REGEX);
const $d4521f0694a3bb0e$var$isYoutubeVideo = (url)=>url.match($d4521f0694a3bb0e$var$YOUTUBE_VIDEO_REGEX);
const $d4521f0694a3bb0e$var$isLoomVideoUrl = (url)=>{
    return url.match($d4521f0694a3bb0e$var$LOOM_VIDEO_URL_REGEX);
};
const $d4521f0694a3bb0e$var$isLoomPlaylistUrl = (url)=>{
    return url.match($d4521f0694a3bb0e$var$LOOM_PLAYLIST_URL_REGEX);
};
const $d4521f0694a3bb0e$var$isLoomScreenshotUrl = (url)=>{
    return url.match($d4521f0694a3bb0e$var$LOOM_SCREENSHOT_URL_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraDashboard = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_DASHBOARD_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraBacklog = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_BACKLOG_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraBoard = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_BOARD_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraPlan = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_PLAN_REGEX) || url.match($d4521f0694a3bb0e$var$JIRA_PLAN_WITH_SCENARIO_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraVersion = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_VERSION_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraForm = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_FORM_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraSummary = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_SUMMARY_REGEX);
};
const $d4521f0694a3bb0e$var$isRovoAgentProfilePage = (url)=>{
    return url.match($d4521f0694a3bb0e$var$ROVO_AGENT_PROFILE_PAGE_REGEX);
};
const $d4521f0694a3bb0e$var$isCustomer360LandingPage = (url)=>url.match($d4521f0694a3bb0e$var$CUSTOMER_360_LANDING_PAGE_REGEX);
const $d4521f0694a3bb0e$var$isConfluenceTeamCalendars = (url)=>url.match($d4521f0694a3bb0e$var$CONFLUENCE_TEAM_CALENDARS_REGEX);
const $d4521f0694a3bb0e$var$isJiraIssueNavigator = (url)=>url.match($d4521f0694a3bb0e$var$JIRA_ISSUE_NAVIGATOR_REGEX);
const $d4521f0694a3bb0e$var$isAvpVisualizationView = (url)=>url.match($d4521f0694a3bb0e$var$AVP_VISUALIZATION_VIEW_REGEX) || ((0, $iDrrr.fg)('platform_avp_viz_dashboard_link_embed') ? url.match($d4521f0694a3bb0e$var$DASHBOARDS_CHART_VIEW_REGEX) : null);
const $d4521f0694a3bb0e$export$6a9668b99d8a1708 = (url)=>$d4521f0694a3bb0e$var$JIRA_WORK_ITEM_REGEX.test(url);
// Local UrlChecker-compatible wrapper around the boolean-returning
// `isConfluenceSlideUrl` from `./url-checkers` (the single source of truth for
// slide URL matching). Wrapping (rather than aliasing the imported identifier
// directly inside the exported `internalUrlCheckers` object) avoids the
// @atlaskit/editor/no-re-export lint rule and gives the registry a uniform
// `(url) => RegExpMatchArray | null` signature. Consumers of
// `internalUrlCheckers` only check the truthiness of the result, so returning
// a synthetic single-element match array (or `null`) preserves behaviour.
const $d4521f0694a3bb0e$var$isConfluenceSlide = (url)=>(0, $8kONW.isConfluenceSlideUrl)(url) ? [
        url
    ] : null;
const $d4521f0694a3bb0e$export$da256e60841d38fd = {
    isJiraRoadmapOrTimeline: $d4521f0694a3bb0e$var$isJiraRoadmapOrTimeline,
    isPolarisView: $d4521f0694a3bb0e$var$isPolarisView,
    isJwmView: $d4521f0694a3bb0e$var$isJwmView,
    isJiraList: $d4521f0694a3bb0e$var$isJiraList,
    isConfluenceWhiteboard: $d4521f0694a3bb0e$var$isConfluenceWhiteboard,
    isConfluenceDatabase: $d4521f0694a3bb0e$var$isConfluenceDatabase,
    isConfluenceSlide: $d4521f0694a3bb0e$var$isConfluenceSlide,
    isJiraDashboard: $d4521f0694a3bb0e$var$isJiraDashboard,
    isJiraBacklog: $d4521f0694a3bb0e$var$isJiraBacklog,
    isJiraBoard: $d4521f0694a3bb0e$var$isJiraBoard,
    isJiraPlan: $d4521f0694a3bb0e$var$isJiraPlan,
    isJiraVersion: $d4521f0694a3bb0e$var$isJiraVersion,
    isJiraForm: $d4521f0694a3bb0e$var$isJiraForm,
    isJiraSummary: $d4521f0694a3bb0e$var$isJiraSummary,
    isRovoAgentProfilePage: $d4521f0694a3bb0e$var$isRovoAgentProfilePage,
    isConfluenceTeamCalendars: $d4521f0694a3bb0e$var$isConfluenceTeamCalendars,
    isJiraIssueNavigator: $d4521f0694a3bb0e$var$isJiraIssueNavigator
};
function $d4521f0694a3bb0e$export$4006295459a20a0(url) {
    return Object.values($d4521f0694a3bb0e$export$da256e60841d38fd).some((checker)=>checker(url));
}
function $d4521f0694a3bb0e$export$78234eee43b97e81(url) {
    return !$d4521f0694a3bb0e$export$4006295459a20a0(url);
}
function $d4521f0694a3bb0e$var$getAppearanceForNode(node) {
    return node.type === 'blockCard' ? 'block' : node.type === 'embedCard' ? 'embed' : 'inline';
}
function $d4521f0694a3bb0e$var$isCardNode(node) {
    return [
        'inlineCard',
        'blockCard',
        'embedCard'
    ].includes(node.type) && !!node.attrs && 'url' in node.attrs && typeof node.attrs.url === 'string';
}
class $d4521f0694a3bb0e$export$e4635c0135e1a519 extends (0, $drRzc.NodeDataProvider) {
    refreshCache(node) {
        if (this.getCacheStatusForNode(node) !== 'network') this.getData(node, ()=>{});
    }
    getData(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) return;
        // if we can load a response from cache, use it first
        const key = this.nodeDataKey(jsonNode);
        const details = this.smartCardLocalCacheClient.getItem(key);
        // NAVX-4712: Handle responses with non-resolved statuses that were previously cached
        const isResolvedCachedResponse = details && details.meta && (0, $ggGdk.getStatus)(details) === 'resolved';
        if (isResolvedCachedResponse) callback({
            data: details
        });
        // if parent class NodeDataProvider has cached the network request for the node
        // we can skip fetching the data async and updating the session storage cache
        if (isResolvedCachedResponse && this.getCacheStatusForNode(jsonNode) === 'network') return;
        // fetch the latest data async and update the session storage cache
        this.getDataAsync(node, (payload)=>{
            const response = payload.data;
            if (!payload.error && response?.meta) {
                const status = (0, $ggGdk.getStatus)(response);
                if (status === 'resolved') this.smartCardLocalCacheClient.setItem(key, response);
            }
            callback(payload);
        });
    }
    nodeDataKey(node) {
        if (!(0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization')) return node.attrs.url;
        return `${node.attrs.url}|${$d4521f0694a3bb0e$var$getAppearanceForNode(node)}`;
    }
    fetchNodesData(nodes) {
        const promises = nodes.map((node)=>{
            const url = node.attrs.url;
            const appearance = (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization') ? $d4521f0694a3bb0e$var$getAppearanceForNode(node) : undefined;
            return this.cardClient.fetchData(url, false, appearance);
        });
        return Promise.all(promises);
    }
    isNodeSupported(node) {
        if (!$d4521f0694a3bb0e$var$isCardNode(node)) return false;
        if (!this.supportedUrlFilter) return true;
        return this.supportedUrlFilter(node.attrs.url);
    }
    async batchProviders(keys) {
        // EDM-2205: Batch requests in the case that user paste multiple links at
        // once. This is so that only one /providersData is being called.
        const providersData = await this.fetchProvidersData();
        return keys.map(()=>providersData);
    }
    async checkLinkResolved(resourceUrl) {
        try {
            const response = await this.fetchData(resourceUrl);
            if ((0, $ggGdk.getStatus)(response) !== 'not_found') return true;
        } catch  {
            return false;
        }
    }
    async fetchDataForResource(resourceUrl) {
        try {
            const response = await this.fetchData(resourceUrl);
            if ((0, $ggGdk.getStatus)(response) !== 'not_found') return response;
        } catch  {
            return undefined;
        }
    }
    extractAriFromData(responseData) {
        if (responseData.data && 'atlassian:ari' in responseData.data) return responseData.data['atlassian:ari'];
        return undefined;
    }
    async fetchProvidersData() {
        const endpoint = `${this.resolverUrl}/providers`;
        const response = await (0, $biKbJ.request)('post', endpoint, undefined, this.requestHeaders);
        return {
            patterns: response.providers.reduce((allSources, provider)=>{
                return allSources.concat(provider.patterns);
            }, []),
            userPreferences: response.userPreferences
        };
    }
    async loadProviderData() {
        try {
            this.providersData = await this.providersLoader.load('providersData');
        } catch (err) {
            // eslint-disable-next-line
            console.error('failed to fetch /providers', err);
            this.providersLoader.clear('providerData');
            return undefined;
        }
    }
    async findPattern(url) {
        return !!await this.findPatternData(url) || !!await this.checkLinkResolved(url);
    }
    doesUrlMatchPath(path, url) {
        // Using [a-zA-Z0-9] here instead of \w since that includes underscores
        const startingRegex = $d4521f0694a3bb0e$var$DOES_URL_MATCH_PATH_START_REGEX.test(path) ? '(^|[^a-zA-Z0-9])' : '';
        const endingRegex = $d4521f0694a3bb0e$var$DOES_URL_MATCH_PATH_END_REGEX.test(path) ? '($|[^a-zA-Z0-9])' : '';
        const escapedPath = path.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        const regexPattern = new RegExp(`${startingRegex}${escapedPath}${endingRegex}`);
        return regexPattern.test(url);
    }
    async findUserPreference(url) {
        if (!this.providersData) await this.loadProviderData();
        const userPreferences = this.providersData?.userPreferences;
        if (userPreferences) {
            const { defaultAppearance: defaultAppearance, appearances: appearances } = userPreferences;
            const allMatchedLabeledAppearances = appearances.filter(({ urlSegment: urlSegment })=>this.doesUrlMatchPath(urlSegment, url));
            if (allMatchedLabeledAppearances.length > 0) {
                const longestMatchedLabeledAppearance = allMatchedLabeledAppearances.reduce((previousLabeledAppearance, currentLabeledAppearance)=>previousLabeledAppearance.urlSegment.length > currentLabeledAppearance.urlSegment.length ? previousLabeledAppearance : currentLabeledAppearance);
                return longestMatchedLabeledAppearance.appearance;
            }
            if (defaultAppearance !== 'inline') return defaultAppearance;
        }
    }
    async findPatternData(url) {
        if (!this.providersData) await this.loadProviderData();
        return this.providersData?.patterns.find((pattern)=>url.match(pattern.source));
    }
    /**
   *
   * Decides whether the url passed in should be embedded by default
   *
   * protected so that subclasses can override this in order to custom handle links embedded by default
   *
   * @param url
   * @returns 'embed' for the card appearance to embed by default
   */ getHardCodedAppearance(url) {
        // Replace directly with isJiraPlan(url) on cleanup
        const isJiraPlanEvaluated = $d4521f0694a3bb0e$var$isJiraPlan(url);
        const isJiraFormEvaluated = $d4521f0694a3bb0e$var$isJiraForm(url);
        const isJiraSummaryEvaluated = $d4521f0694a3bb0e$var$isJiraSummary(url);
        let isConfluenceTeamCalendarsEvaluated;
        if ((0, $iDrrr.fg)('tc_smart_link_embed_view')) isConfluenceTeamCalendarsEvaluated = $d4521f0694a3bb0e$var$isConfluenceTeamCalendars(url);
        if ($d4521f0694a3bb0e$var$isJiraRoadmapOrTimeline(url) || $d4521f0694a3bb0e$var$isPolarisView(url) || $d4521f0694a3bb0e$var$isJwmView(url) || $d4521f0694a3bb0e$var$isJiraList(url) || $d4521f0694a3bb0e$var$isGiphyMedia(url) || $d4521f0694a3bb0e$var$isProformaView(url) || $d4521f0694a3bb0e$var$isConfluenceWhiteboard(url) || $d4521f0694a3bb0e$var$isConfluenceDatabase(url) || (0, $8kONW.isConfluenceSlideUrl)(url) || $d4521f0694a3bb0e$var$isYoutubeVideo(url) || $d4521f0694a3bb0e$var$isLoomVideoUrl(url) || $d4521f0694a3bb0e$var$isLoomPlaylistUrl(url) && (0, $iDrrr.fg)('loom-playlist-smartlink-embed-default') || $d4521f0694a3bb0e$var$isLoomScreenshotUrl(url) && (0, $iDrrr.fg)('loom-support-screenshot-sl-resolution') || $d4521f0694a3bb0e$var$isJiraDashboard(url) || $d4521f0694a3bb0e$var$isJiraBacklog(url) || $d4521f0694a3bb0e$var$isJiraBoard(url) || $d4521f0694a3bb0e$var$isRovoAgentProfilePage(url) || $d4521f0694a3bb0e$var$isJiraVersion(url) || isJiraPlanEvaluated || isJiraFormEvaluated || isJiraSummaryEvaluated || $d4521f0694a3bb0e$var$isCustomer360LandingPage(url) || isConfluenceTeamCalendarsEvaluated || $d4521f0694a3bb0e$var$isJiraIssueNavigator(url) || $d4521f0694a3bb0e$var$isAvpVisualizationView(url)) return 'embed';
    }
    async fetchData(url) {
        // it uses fetchNodesData internally and caches the result
        return await this.getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS({
            // It's ok to cast any resourceUrl to inlineCard here, because only URL is important for the request.
            type: 'inlineCard',
            attrs: {
                url: url
            }
        });
    }
    async resolvesToHardCodedEmbed(url) {
        try {
            const response = await this.fetchData(url);
            const resolvedUrl = (0, $3ewaO.extractSmartLinkUrl)(response);
            return resolvedUrl !== undefined && this.getHardCodedAppearance(resolvedUrl) === 'embed';
        } catch  {
            return false;
        }
    }
    /**
   * Make a /resolve call and find out if result has embed capability
   */ async canBeResolvedAsEmbed(url) {
        try {
            const details = await this.fetchData(url);
            if (!details) return false;
            // Imagine response is "unauthorized". We won't be able to tell if even after auth
            // page going to have preview. Yes, we can show auth view for embed. But what if even after
            // success auth flow there won't be preview? We will already have ugly embed ADF.
            // Being on a safe side - if we get anything but resolved - we decide it can't be an embed.
            if ((0, $ggGdk.getStatus)(details) !== 'resolved') return false;
            const embed = (0, $8OcYi.extractSmartLinkEmbed)(details);
            return !!embed;
        } catch  {
            return false;
        }
    }
    /**
   * Opt-in hook: when a caller explicitly requests an `'embed'` appearance and the
   * user has no saved preference for the URL, honour that request as the default
   * (above any provider default), validating embeddability first and falling back
   * to a card (`'block'`) when the link cannot be embedded.
   *
   * Defaults to `false` so behaviour is unchanged for every existing consumer.
   * Subclasses (e.g. Confluence) can override this to opt in, typically behind an
   * experiment.
   */ shouldHonorRequestedEmbedAsDefault() {
        return false;
    }
    async getAuthStatusFromResolveResponse(url) {
        try {
            const { meta: { access: access, visibility: visibility } } = await this.fetchData(url);
            return {
                access: access,
                visibility: visibility
            };
        } catch  {
            return undefined;
        }
    }
    /**
   * Make a /resolve call and find out if result has datasource capability
   */ async getDatasourceFromResolveResponse(url) {
        try {
            const response = await this.fetchData(url);
            const datasources = response && response.datasources || [];
            if (datasources.length > 0) // For now we only have one datasource expected even though it is in an array.
            // When we have resources returning more than one we will have revisit this part.
            return datasources[0];
        } catch  {
            return undefined;
        }
    }
    /**
   * This is used to determine if the url is a local Jira url or a remote one.
   */ isLocalUrl(url) {
        return new URL(url).origin === this.baseUrl;
    }
    async resolve(url, appearance, shouldForceAppearance, isEmbedFriendlyLocation) {
        try {
            if (shouldForceAppearance === true) // At this point we don't need to check pattern nor call `check` because manual change means
            // this url is already supported and can be resolved. We want to ignore all other options and
            // respect user's choice.
            return this.transformer.toSmartlinkAdf(url, appearance);
            const hardCodedAppearance = this.getHardCodedAppearance(url);
            const [matchedProviderPattern, userPreference] = await Promise.all([
                this.findPatternData(url),
                this.findUserPreference(url)
            ]);
            if ((0, $iDrrr.fg)('issue-link-suggestions-in-comments')) {
                if ($d4521f0694a3bb0e$export$6a9668b99d8a1708(url) && this.isLocalUrl(url)) {
                    const data = await this.fetchDataForResource(url);
                    if (data) {
                        const issueAri = this.extractAriFromData(data);
                        if (issueAri) this.onResolve?.(url, issueAri);
                    }
                }
            }
            if (shouldForceAppearance === false && userPreference === 'url') return Promise.reject(undefined);
            const isSupported = !!matchedProviderPattern || await this.checkLinkResolved(url);
            if (isSupported) {
                const providerDefaultAppearance = matchedProviderPattern?.defaultView;
                const isEmbedFriendlyLocationEvaluated = isEmbedFriendlyLocation || isEmbedFriendlyLocation === undefined;
                let preferredAppearance = shouldForceAppearance === undefined ? // Ignore both User and provider's appearances if older editor that doesn't send shouldForceAppearance
                hardCodedAppearance || appearance : // User preferred appearance. It would be either one that has matching domain/path pattern OR
                // if user's default choice is NOT "inline" (so, block or embed at this point, url was dealt with above)
                userPreference || // If user's default choice is "inline" or user hasn't specified preferences at all,
                // we check whatever one of the hardcoded providers match url (jira /timeline, polaris, etc)
                isEmbedFriendlyLocationEvaluated && hardCodedAppearance || // If non match, we see if this provider has default appearance for this particular regexp
                providerDefaultAppearance || // If not, we pick what editor (or any other client) requested
                appearance;
                const isNativeEmbedShortlinkResolutionEnabled = (0, $iDrrr.fg)('platform_native_embeds_enable_shortlink_resolution');
                const shouldResolveShortLinkForEmbed = isNativeEmbedShortlinkResolutionEnabled && matchedProviderPattern !== undefined && $d4521f0694a3bb0e$var$isConfluenceShortLinkUrl(url) && userPreference === undefined && isEmbedFriendlyLocationEvaluated;
                // Confluence shortlinks do not identify their content type. Resolve the URL before
                // deciding whether it should use one of the existing hardcoded embed appearances.
                if (shouldResolveShortLinkForEmbed && await this.resolvesToHardCodedEmbed(url)) preferredAppearance = 'embed';
                if (preferredAppearance === userPreference && userPreference === 'embed') {
                    const canItBeEmbed = await this.canBeResolvedAsEmbed(url);
                    if (!canItBeEmbed) preferredAppearance = 'inline';
                }
                // When a caller explicitly requested an embed (e.g. Confluence's quick-insert
                // embed flow tags the inserted link) and the user has no saved preference for
                // this URL, honour embed-by-default above the provider default — but only in an
                // embed-friendly location (matching how hard-coded embeds are gated above) and
                // only when the link can actually be embedded, otherwise fall back to a card.
                // Gated behind a default-off opt-in hook so other consumers are unaffected.
                if (!userPreference && appearance === 'embed' && isEmbedFriendlyLocationEvaluated && this.shouldHonorRequestedEmbedAsDefault()) {
                    const canItBeEmbed = await this.canBeResolvedAsEmbed(url);
                    preferredAppearance = canItBeEmbed ? 'embed' : 'block';
                }
                const datasource = await this.getDatasourceFromResolveResponse(url);
                if (datasource) {
                    const { id: id, parameters: parameters } = datasource;
                    return this.transformer.toDatasourceAdf({
                        id: id,
                        parameters: parameters,
                        // in the future when we support multiple views, we will need to pass this in as a parameter
                        // transform toDatasourceAdf to accept multiple views (like how how appearance for other other transforms are handled)
                        views: [
                            {
                                type: 'table'
                            }
                        ]
                    }, url);
                }
                if (isEmbedFriendlyLocationEvaluated && !userPreference) {
                    const authStatus = await this.getAuthStatusFromResolveResponse(url);
                    if (authStatus) {
                        const { access: access } = authStatus;
                        if (access === 'unauthorized') return this.transformer.toSmartlinkAdf(url, 'block');
                    }
                }
                return this.transformer.toSmartlinkAdf(url, preferredAppearance);
            }
        } catch (e) {
            // eslint-disable-next-line
            console.warn(`Error when trying to check Smart Card url "${url}"${e instanceof Error ? ` - ${e.name} ${e.message}` : ''}`, e);
        }
        return Promise.reject(undefined);
    }
    constructor(envKey, baseUrlOverride, product, onResolve, customCardClient, supportedUrlFilter){
        super();
        this.name = void 0;
        this.baseUrl = void 0;
        this.resolverUrl = void 0;
        this.providersData = void 0;
        this.requestHeaders = void 0;
        this.transformer = void 0;
        this.providersLoader = void 0;
        this.cardClient = void 0;
        this.smartCardLocalCacheClient = (0, $iyuxZ.SmartCardLocalCacheClient).getInstance();
        this.onResolve = void 0;
        this.supportedUrlFilter = void 0;
        this.name = 'editorCardProvider';
        this.baseUrl = baseUrlOverride || (0, $kzwaO.getBaseUrl)(envKey);
        this.resolverUrl = (0, $cXJjm.getResolverUrl)(envKey, baseUrlOverride);
        this.transformer = new (0, $koAyx.Transformer)();
        this.onResolve = onResolve;
        this.supportedUrlFilter = supportedUrlFilter;
        this.requestHeaders = {
            Origin: this.baseUrl
        };
        this.providersLoader = new (0, (/*@__PURE__*/$parcel$interopDefault($6Q8Dd)))((keys)=>this.batchProviders(keys), {
            batchScheduleFn: (callback)=>setTimeout(callback, $d4521f0694a3bb0e$var$BATCH_WAIT_TIME)
        });
        this.cardClient = customCardClient ?? new (0, $4yccB.default)(envKey, baseUrlOverride);
        if (!customCardClient && product) this.cardClient.setProduct(product);
    }
}
const $d4521f0694a3bb0e$export$b7c3c9a99f7959f5 = new $d4521f0694a3bb0e$export$e4635c0135e1a519();
module.exports["isInternalUrl"] = $d4521f0694a3bb0e$export$4006295459a20a0;
module.exports["isExternalUrl"] = $d4521f0694a3bb0e$export$78234eee43b97e81;
module.exports["EditorCardProvider"] = $d4521f0694a3bb0e$export$e4635c0135e1a519;
module.exports["editorCardProvider"] = $d4521f0694a3bb0e$export$b7c3c9a99f7959f5;

});

parcelRegister("3ewaO", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $jMcHR = parcelRequire("jMcHR");


var $kAdyG = parcelRequire("kAdyG");

const $15d3ac0a1a1c5122$export$7ba9b12c6a1b73de = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.url;
    return (0, $jMcHR.extractLink)(response?.data);
};
module.exports["extractSmartLinkUrl"] = $15d3ac0a1a1c5122$export$7ba9b12c6a1b73de;

});

parcelRegister("4yccB", function(module, exports) {

var $QO4PV = parcelRequire("QO4PV");


var $6Q8Dd = parcelRequire("6Q8Dd");


var $iKWdo = parcelRequire("iKWdo");


var $lPEt0 = parcelRequire("lPEt0");


var $axuex = parcelRequire("axuex");


var $j39Hd = parcelRequire("j39Hd");


var $ixC10 = parcelRequire("ixC10");


var $cXJjm = parcelRequire("cXJjm");


var $grief = parcelRequire("grief");


var $2g31M = parcelRequire("2g31M");


var $ggGdk = parcelRequire("ggGdk");


var $iDrrr = parcelRequire("iDrrr");


var $c2kDy = parcelRequire("c2kDy");


var $44Sj0 = parcelRequire("44Sj0");

const $614b823604b25d0c$var$MAX_BATCH_SIZE = 50;
const $614b823604b25d0c$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $614b823604b25d0c$var$URL_RESPONSE_CACHE_SIZE = 100;
const $614b823604b25d0c$export$d6a66073b5d79eb3 = new (0, $lPEt0.LRUMap)($614b823604b25d0c$var$URL_RESPONSE_CACHE_SIZE);
const $614b823604b25d0c$var$urlResponseInFlightCache = new Map();
class $614b823604b25d0c$export$2e2bcd8739ae039 {
    setProduct(product) {
        this.product = product;
    }
    /**
   * Set custom headers to be sent with each request to the resolver.
   *
   * @param headers - Object containing headers to be sent with each request.
   */ setHeaders(headers) {
        this.headers = headers;
    }
    createUrlLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($axuex)))({
            limit: 1,
            interval: $614b823604b25d0c$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolveUrl);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($6Q8Dd)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $614b823604b25d0c$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolveUrl`.
            cache: false
        });
    }
    getUrlLoader(hostname) {
        if (!this.urlLoadersByDomain[hostname]) this.urlLoadersByDomain[hostname] = this.createUrlLoader();
        return this.urlLoadersByDomain[hostname];
    }
    getHostName(url) {
        try {
            return new URL(url).hostname;
        } catch (error) {
            throw new (0, $grief.InvalidUrlError)(error);
        }
    }
    async resolveUrlWithoutInlineOptimization(url, hostname, force) {
        let responsePromise = $614b823604b25d0c$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            const urlLoader = this.getUrlLoader(hostname);
            responsePromise = urlLoader.load({
                resourceUrl: url,
                ignoreCachedValue: force || undefined
            });
            $614b823604b25d0c$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $614b823604b25d0c$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $44Sj0.isSuccessfulResponse)(response) || (0, $ggGdk.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $614b823604b25d0c$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async resolveUrlWithInlineOptimization(url, hostname, force, appearance) {
        const cacheKey = `${url}|${appearance}`;
        const inFlightCacheKey = JSON.stringify([
            url,
            appearance,
            force
        ]);
        let responsePromise = $614b823604b25d0c$var$urlResponseInFlightCache.get(inFlightCacheKey);
        if (!responsePromise) {
            responsePromise = $614b823604b25d0c$export$d6a66073b5d79eb3.get(cacheKey);
            if (!responsePromise || force) {
                const urlLoader = this.getUrlLoader(hostname);
                responsePromise = urlLoader.load({
                    resourceUrl: url,
                    ignoreCachedValue: force || undefined,
                    appearance: appearance
                });
                $614b823604b25d0c$export$d6a66073b5d79eb3.set(cacheKey, responsePromise);
                $614b823604b25d0c$var$urlResponseInFlightCache.set(inFlightCacheKey, responsePromise);
            }
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $614b823604b25d0c$export$d6a66073b5d79eb3.delete(cacheKey);
            throw e;
        } finally{
            if ($614b823604b25d0c$var$urlResponseInFlightCache.get(inFlightCacheKey) === responsePromise) $614b823604b25d0c$var$urlResponseInFlightCache.delete(inFlightCacheKey);
        }
        const isUnresolvedLink = !(0, $44Sj0.isSuccessfulResponse)(response) || (0, $ggGdk.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $614b823604b25d0c$export$d6a66073b5d79eb3.delete(cacheKey);
        return response;
    }
    async resolveUrl(url, force = false, appearance) {
        const hostname = this.getHostName(url);
        if (appearance !== undefined && (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization')) return this.resolveUrlWithInlineOptimization(url, hostname, force, appearance);
        return this.resolveUrlWithoutInlineOptimization(url, hostname, force);
    }
    async prefetchData(url, appearance) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false, appearance);
        if ((0, $44Sj0.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($QO4PV)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false, appearance);
                    if ((0, $44Sj0.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch  {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $c2kDy.isErrorResponse)(response) && response.error.status === 429;
    }
    /**
   * Fetch data from URL
   * @param url - The URL to fetch data for
   * @param force - Whether to force a fresh fetch, bypassing cache
   * @param appearance - Card appearance hint for ORS to optimize response payload.
   *                     When 'inline', ORS returns minimal data (title, status).
   *                     When 'block' or 'embed', ORS returns full data including summary.
   */ async fetchData(url, force, appearance) {
        let response = await this.resolveUrl(url, force, appearance);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($QO4PV)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false, appearance);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $44Sj0.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
   * Fetch data for multiple ARIs (batch) in one operation
   * @param aris Array of ARIs to fetch data for
   */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $j39Hd.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
   * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
   * spec.
   * @param data Payload including the search provider key and query. An empty search query string
   * results in recent results being returned (pre-query).
   * @returns JsonLd collection of search results.
   */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $j39Hd.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $c2kDy.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $j39Hd.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $2g31M.NetworkError)) return new (0, $ixC10.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $ixC10.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $ixC10.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    // URL isn't supported
                    return new (0, $ixC10.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $ixC10.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $ixC10.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
   * This method will strigify both enumerable and  non enumerable properties of an object
   * @param err
   * @returns object serialized to JSON with both enumerable and non enumerable objects
   */ stringifyError(err) {
        /**
     * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
     * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
     * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
     */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
    constructor(envKey, baseUrlOverride){
        this.resolverUrl = void 0;
        this.envKey = void 0;
        this.baseUrlOverride = void 0;
        this.urlLoadersByDomain = void 0;
        this.retryConfig = void 0;
        this.resolvedCache = void 0;
        this.product = void 0;
        this.headers = void 0;
        this.postBatchResolveNew = async (resources, resourceType, keyGetter)=>{
            // De-duplicate requested URLs (see `this.createUrlLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = (0, (/*@__PURE__*/$parcel$interopDefault($iKWdo)))(resources, keyGetter);
            let resolvedResources = [];
            const headers = {
                /**
         * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
         * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
         */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ?? {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $j39Hd.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources, headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $j39Hd.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources, headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $c2kDy.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[keyGetter(resource)] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[keyGetter(originalResource)]);
        };
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createUrlLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
         * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
         * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
         */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ? this.headers : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $j39Hd.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $j39Hd.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $c2kDy.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        this.batchResolveUrl = async (urls)=>{
            return this.postBatchResolveNew(urls, 'URL', (resource)=>{
                // Appearance is only added to the payload when the inline resolve optimization gate is on.
                // Preserve differently shaped requests for the same URL so a reduced inline response cannot
                // be returned to a block request from the same batch.
                if (resource.appearance !== undefined && (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization')) return JSON.stringify([
                    resource.resourceUrl,
                    resource.appearance,
                    resource.ignoreCachedValue === true
                ]);
                return resource.resourceUrl;
            });
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $cXJjm.getResolverUrl)(envKey, baseUrlOverride);
        this.urlLoadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
}
module.exports["default"] = $614b823604b25d0c$export$2e2bcd8739ae039;

});

parcelRegister("QO4PV", function(module, exports) {
// Packages

var $lbZ9z = parcelRequire("lbZ9z");

function $09ebb3b1b19cd625$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        op = $lbZ9z.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $09ebb3b1b19cd625$var$retry;

});

parcelRegister("lbZ9z", function(module, exports) {

module.exports = (parcelRequire("4co4r"));

});

parcelRegister("4co4r", function(module, exports) {

var $8xi9I = parcelRequire("8xi9I");

exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $8xi9I(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});

parcelRegister("8xi9I", function(module, exports) {
function $636f7d2929f63478$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $636f7d2929f63478$var$RetryOperation;
$636f7d2929f63478$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$636f7d2929f63478$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$636f7d2929f63478$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$636f7d2929f63478$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$636f7d2929f63478$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$636f7d2929f63478$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$636f7d2929f63478$var$RetryOperation.prototype.start = $636f7d2929f63478$var$RetryOperation.prototype.try;
$636f7d2929f63478$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$636f7d2929f63478$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$636f7d2929f63478$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});

parcelRegister("iKWdo", function(module, exports) {

var $j6gAQ = parcelRequire("j6gAQ");


var $1Rned = parcelRequire("1Rned");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $da79ae2b1521df52$var$uniqBy(array, iteratee) {
    return array && array.length ? $1Rned(array, $j6gAQ(iteratee, 2)) : [];
}
module.exports = $da79ae2b1521df52$var$uniqBy;

});

parcelRegister("1Rned", function(module, exports) {

var $dLza3 = parcelRequire("dLza3");


var $gqaVn = parcelRequire("gqaVn");


var $3wyDU = parcelRequire("3wyDU");


var $jG16D = parcelRequire("jG16D");


var $4sYWJ = parcelRequire("4sYWJ");


var $j8WYy = parcelRequire("j8WYy");

/** Used as the size to enable large array optimizations. */ var $15acc2503c30cdc7$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $15acc2503c30cdc7$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $gqaVn, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $3wyDU;
    } else if (length >= $15acc2503c30cdc7$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $4sYWJ(array);
        if (set) return $j8WYy(set);
        isCommon = false;
        includes = $jG16D;
        seen = new $dLza3;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $15acc2503c30cdc7$var$baseUniq;

});

parcelRegister("gqaVn", function(module, exports) {

var $62lK8 = parcelRequire("62lK8");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $bf478c6b28a93eba$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $62lK8(array, value, 0) > -1;
}
module.exports = $bf478c6b28a93eba$var$arrayIncludes;

});

parcelRegister("62lK8", function(module, exports) {

var $7jN2X = parcelRequire("7jN2X");


var $4Jcz7 = parcelRequire("4Jcz7");


var $jMyMb = parcelRequire("jMyMb");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $4653cbb84a510850$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $jMyMb(array, value, fromIndex) : $7jN2X(array, $4Jcz7, fromIndex);
}
module.exports = $4653cbb84a510850$var$baseIndexOf;

});

parcelRegister("7jN2X", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $55405a69ad8b093d$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $55405a69ad8b093d$var$baseFindIndex;

});

parcelRegister("4Jcz7", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $37151c9a2b945fe4$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $37151c9a2b945fe4$var$baseIsNaN;

});

parcelRegister("jMyMb", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e66d79db7455d8ea$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $e66d79db7455d8ea$var$strictIndexOf;

});

parcelRegister("3wyDU", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $290f3b94ccd981c7$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $290f3b94ccd981c7$var$arrayIncludesWith;

});

parcelRegister("4sYWJ", function(module, exports) {

var $lE8ES = parcelRequire("lE8ES");


var $jEK83 = parcelRequire("jEK83");


var $j8WYy = parcelRequire("j8WYy");

/** Used as references for various `Number` constants. */ var $34090d9ff4ab3dd6$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $34090d9ff4ab3dd6$var$createSet = !($lE8ES && 1 / $j8WYy(new $lE8ES([
    ,
    -0
]))[1] == $34090d9ff4ab3dd6$var$INFINITY) ? $jEK83 : function(values) {
    return new $lE8ES(values);
};
module.exports = $34090d9ff4ab3dd6$var$createSet;

});

parcelRegister("jEK83", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $e4f588fe3a77f67d$var$noop() {
// No operation performed.
}
module.exports = $e4f588fe3a77f67d$var$noop;

});

parcelRegister("axuex", function(module, exports) {
'use strict';
class $7ac4702e317338af$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $7ac4702e317338af$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $7ac4702e317338af$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $7ac4702e317338af$var$pThrottle;
module.exports.AbortError = $7ac4702e317338af$var$AbortError;

});

parcelRegister("j39Hd", function(module, exports) {

var $2g31M = parcelRequire("2g31M");

const $53f448a1a60c9e76$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
async function $53f448a1a60c9e76$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $53f448a1a60c9e76$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new (0, $2g31M.NetworkError)(error);
        throw error;
    }
}
module.exports["request"] = $53f448a1a60c9e76$export$b5fe3f66a567bec0;

});

parcelRegister("2g31M", function(module, exports) {
class $70283a430bb4f4fe$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
module.exports["NetworkError"] = $70283a430bb4f4fe$export$bae979e68e4dc802;

});

parcelRegister("ixC10", function(module, exports) {
class $5661a24319617f8d$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}
module.exports["APIError"] = $5661a24319617f8d$export$3e5b797e39668f84;

});

parcelRegister("cXJjm", function(module, exports) {

var $kzwaO = parcelRequire("kzwaO");

const $aee62c7b870e0d6a$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? '/gateway/api/object-resolver';
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || (0, $kzwaO.getBaseUrl)(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
module.exports["getResolverUrl"] = $aee62c7b870e0d6a$export$dc37652c1696f231;

});

parcelRegister("kzwaO", function(module, exports) {

var $4B79C = parcelRequire("4B79C");

const $445f8294ba7508fe$export$f654b28f82155665 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? (0, $4B79C.prodBaseUrl);
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in (0, $4B79C.BaseUrls) ? (0, $4B79C.BaseUrls)[envKey] : (0, $4B79C.prodBaseUrl);
    return typeof window !== 'undefined' && typeof window.location !== 'undefined' ? window.location.origin : '';
};
module.exports["getBaseUrl"] = $445f8294ba7508fe$export$f654b28f82155665;

});

parcelRegister("4B79C", function(module, exports) {
const $ef9de7657ea9d2d2$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $ef9de7657ea9d2d2$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $ef9de7657ea9d2d2$export$7469f9cd9cda802c = 'https://api-private.atlassian.com';
const $ef9de7657ea9d2d2$export$e2b040f052407032 = {
    dev: $ef9de7657ea9d2d2$var$devBaseUrl,
    development: $ef9de7657ea9d2d2$var$devBaseUrl,
    stg: $ef9de7657ea9d2d2$var$stgBaseUrl,
    staging: $ef9de7657ea9d2d2$var$stgBaseUrl,
    prd: $ef9de7657ea9d2d2$export$7469f9cd9cda802c,
    prod: $ef9de7657ea9d2d2$export$7469f9cd9cda802c,
    production: $ef9de7657ea9d2d2$export$7469f9cd9cda802c
};
var $ef9de7657ea9d2d2$export$2e2bcd8739ae039 = $ef9de7657ea9d2d2$export$e2b040f052407032;
module.exports["prodBaseUrl"] = $ef9de7657ea9d2d2$export$7469f9cd9cda802c;
module.exports["BaseUrls"] = $ef9de7657ea9d2d2$export$e2b040f052407032;

});

parcelRegister("grief", function(module, exports) {
class $8165f67089b396cb$export$19fa02dd69bd4efd extends Error {
    constructor(error){
        super(error);
        this.name = 'InvalidUrlError';
    }
}
module.exports["InvalidUrlError"] = $8165f67089b396cb$export$19fa02dd69bd4efd;

});

parcelRegister("ggGdk", function(module, exports) {
const $b75c372cb2906748$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $b75c372cb2906748$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $b75c372cb2906748$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};
module.exports["getStatus"] = $b75c372cb2906748$export$b70265791d2079d4;

});

parcelRegister("c2kDy", function(module, exports) {
const $3cbc4520680d3a92$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};
module.exports["isErrorResponse"] = $3cbc4520680d3a92$export$bea7bee8a87e7c52;

});

parcelRegister("44Sj0", function(module, exports) {
const $d86f0936ed92dc7f$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
module.exports["isSuccessfulResponse"] = $d86f0936ed92dc7f$export$1b59fe731a28a49d;

});

parcelRegister("drRzc", function(module, exports) {

var $4iudd = parcelRequire("4iudd");

class $27efd3461a9c6d27$export$1185db7a00c13eed {
    /**
   * Sets the SSR data for the provider.
   * This pre-populates the cache with data rendered on the server, preventing redundant network requests on the client.
   * Calling this method will invalidate the existing cache.
   *
   * @example
   * ```
   * const ssrData = window.__SSR_NODE_DATA__ || {};
   * nodeDataProvider.setSSRData(ssrData);
   * ```
   *
   * @param ssrData A map of node data keys to their corresponding data.
   */ setSSRData(ssrData = {}) {
        this.updateCache(ssrData, {
            strategy: 'replace',
            source: 'ssr'
        });
    }
    /**
   * Clears all cached data.
   * This increments the internal cache version, invalidating any pending network requests.
   *
   * @example
   * ```
   * function useMyNodeDataProvider(contentId: string) {
   *  const nodeDataProvider = new MyNodeDataProvider();
   *
   *  // Reset the cache when the contentId changes (e.g., when the user navigates to a different page).
   *  useEffect(() => {
   *    nodeDataProvider.resetCache();
   *  }, [contentId]);
   *
   *  return nodeDataProvider;
   * }
   * ```
   */ resetCache() {
        this.cacheVersion++;
        this.cache = {};
    }
    /**
   * Fetches data for a given node using a cache-first-then-network strategy.
   *
   * The provided callback may be called multiple times:
   * 1. Immediately with data from the SSR cache, if available.
   * 2. Asynchronously with data fetched from the network.
   *
   * @example
   * ```
   * const nodeDataProvider = new MyNodeDataProvider();
   *
   * nodeDataProvider.getData(node, (data) => {
   * 	console.log('Node data:', data);
   * });
   * ```
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @param callback The callback function to call with the fetched data or an error.
   */ getData(node, callback) {
        // Move implementation to a separate async method
        // to keep this method synchronous and avoid async/await in the public API.
        this.getDataAsync(node, callback);
    }
    async getDataAsync(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        const dataFromCache = this.cache[dataKey];
        if (dataFromCache !== undefined) // If we have the data in the SSR data, we can use it directly
        callback({
            data: dataFromCache.data
        });
        if ((0, $4iudd.isSSR)()) // During SSR, we only use the cache and never fetch from the network.
        // Use loading state instead.
        return;
        // If no data is available in the cache, or the data is from the network,
        // we need to fetch it from the network.
        if (dataFromCache?.source !== 'network') {
            // Store the current cache version before making the request,
            // so we can check if the cache has changed while we are waiting for the network response.
            const cacheVersionBeforeRequest = this.cacheVersion;
            // Create a unique key for the in-flight network request
            // based on the cache version and the data key.
            const networkRequestInFlightKey = `${cacheVersionBeforeRequest}-${dataKey}`;
            // Check if there is already a network request in flight for this data
            // to avoid duplicate requests.
            const networkRequestInFlight = this.networkRequestsInFlight[networkRequestInFlightKey];
            if (networkRequestInFlight) {
                try {
                    const data = await networkRequestInFlight;
                    callback({
                        data: data
                    });
                } catch (error) {
                    callback({
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
                return;
            }
            try {
                const dataPromise = this.fetchNodesData([
                    jsonNode
                ]).then(([value])=>value);
                // Store the promise in the in-flight requests map
                this.networkRequestsInFlight[networkRequestInFlightKey] = dataPromise;
                const data = await dataPromise;
                // We need to call the callback with the data with result even if the cache version has changed,
                // so all promises that are waiting for the data can resolve.
                callback({
                    data: data
                });
                // If the cache version has changed, we don't want to use the data from the network
                // because it could be stale data.
                if (cacheVersionBeforeRequest === this.cacheVersion) // Replace promise with the resolved data in the cache
                this.updateCache({
                    [dataKey]: data
                }, {
                    strategy: 'merge',
                    source: 'network'
                });
            } catch (error) {
                // If an error occurs, we call the callback with the error
                callback({
                    error: error instanceof Error ? error : new Error(String(error))
                });
            } finally{
                // Ensure we clean up the in-flight request entry
                delete this.networkRequestsInFlight[networkRequestInFlightKey];
            }
        }
    }
    /**
   * Fetches data for a given node and returns it as a Promise.
   * This is a convenience wrapper around the `data` method for use with async/await.
   *
   * Note: This promise resolves with the *first* available data, which could be from the SSR cache or the network.
   * It may not provide the most up-to-date data if a network fetch is in progress.
   *
   * Note: This method is only for migration purposes. Use {@link getData} in new code instead.
   *
   * @private
   * @deprecated Don't use this method, use {@link getData} method instead.
   *             This method is only for migration purposes.
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @returns A promise that resolves with the node's data.
   */ getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS(node) {
        return new Promise((resolve, reject)=>{
            try {
                this.getData(node, (payload)=>{
                    if (payload.error) reject(payload.error);
                    else resolve(payload.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Checks the cache for the given node and returns its status.
   *
   * Possible return values:
   * - `false`: No cached data found for the node.
   * - `'ssr'`: Data is cached from server-side rendering (SSR).
   * - `'network'`: Data is cached from a network request.
   *
   * @param node The node (or its ProseMirror representation) to check in the cache.
   * @returns The cache status: `false`, `'ssr'`, or `'network'`.
   */ getCacheStatusForNode(node) {
        const dataFromCache = this.getNodeDataFromCache(node);
        return dataFromCache ? dataFromCache.source : false;
    }
    /**
   * Retrieves the cached data for a given node, if available.
   *
   * @param node The node (or its ProseMirror representation) for which to retrieve cached data.
   * @returns The cached data object containing `data` and `source`, or `undefined` if no cache entry exists.
   */ getNodeDataFromCache(node) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return undefined;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        return this.cache[dataKey];
    }
    /**
   * Returns the keys of the cache.
   *
   * @returns An array of the keys of the cache.
   */ getNodeDataCacheKeys() {
        return Object.keys(this.cache);
    }
    /**
   * Updates the cache with new records using merge or replace strategies.
   * This method should be the only way to modify the cache directly.
   * This allow subclasses to use it when needed. e.g. abstract fetchNodesData implementation.
   *
   * @example
   * ```
   * const newRecords = {
   *   'node-id-1': { value: 'updated data' },
   *   'node-id-3': { value: 'new data' }
   * };
   * nodeDataProvider.updateCache(newRecords, { strategy: 'merge', source: 'network' });
   * ```
   *
   * Supports two strategies:
   * - 'merge' (default): Merges new records into the existing cache.
   * - 'replace': Replaces the entire cache with the new records, invalidating any in-flight requests.
   *
   * @param records A map of node data keys to their corresponding data.
   * @param options Optional settings for the update operation.
   * @param options.strategy The strategy to use for updating the cache ('merge' or 'replace'). Defaults to 'merge'.
   * @param options.source The source of the data being added ('ssr' or 'network'). Defaults to 'network'.
   */ updateCache(records = {}, options) {
        const strategy = options?.strategy ?? 'merge';
        const source = options?.source ?? 'network';
        if (strategy === 'merge') {
            for (const [key, data] of Object.entries(records))this.cache[key] = {
                data: data,
                source: source
            };
            return;
        } else if (strategy === 'replace') {
            // Replace the entire cache with the new records
            // This will increase the cache version to invalidate any in-flight requests
            this.resetCache();
            this.cache = Object.fromEntries(Object.entries(records).map(([key, data])=>[
                    key,
                    {
                        data: data,
                        source: source
                    }
                ]));
        }
    }
    /**
   * Removes one or more entries from the cache.
   *
   * @param keys A single data key or array of data keys to remove from the cache.
   */ removeFromCache(keys) {
        keys.forEach((key)=>{
            delete this.cache[key];
        });
    }
    constructor(){
        this.cacheVersion = void 0;
        this.cache = void 0;
        this.networkRequestsInFlight = void 0;
        /**
     * A unique name for the provider. Used for identification in SSR.
     */ this.name = void 0;
        this.cacheVersion = 0;
        this.cache = {};
        this.networkRequestsInFlight = {};
    }
}
module.exports["NodeDataProvider"] = $27efd3461a9c6d27$export$1185db7a00c13eed;

});

parcelRegister("biKbJ", function(module, exports) {
const $57ceb58159fd0951$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $57ceb58159fd0951$export$bae979e68e4dc802 extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(error){
        super(error);
    }
}
async function $57ceb58159fd0951$export$b5fe3f66a567bec0(method, url, // eslint-disable-next-line @typescript-eslint/no-explicit-any
data, headers) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || $57ceb58159fd0951$var$ALLOWED_RESPONSE_STATUS_CODES.includes(response.status)) return await response.json();
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $57ceb58159fd0951$export$bae979e68e4dc802(error);
        throw error;
    }
}
module.exports["request"] = $57ceb58159fd0951$export$b5fe3f66a567bec0;

});

parcelRegister("iyuxZ", function(module, exports) {
parcelRequire("6YrB3");
var $f9XbP = parcelRequire("f9XbP");

var $842937149a04b8ba$var$_SmartCardLocalCacheClient;
const $842937149a04b8ba$var$SMART_CARD_CACHE_CLIENT_KEY = 'smart-card-url-data';
const $842937149a04b8ba$var$SMART_CARD_CACHE_KEY = 'response-cache';
const $842937149a04b8ba$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS = 100;
class $842937149a04b8ba$export$1987ad1ab31f2528 {
    /**
   * Gets the singleton instance of SmartCardLocalCacheClient.
   * This ensures all callers share the same in-memory cache and prevents
   * race conditions when multiple instances write to the same storage key.
   * @param maxItems Maximum number of items to store in the cache (only used on first instantiation)
   * @returns The singleton instance
   */ static getInstance(maxItems = $842937149a04b8ba$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS) {
        if (!$842937149a04b8ba$export$1987ad1ab31f2528.instance) $842937149a04b8ba$export$1987ad1ab31f2528.instance = new $842937149a04b8ba$export$1987ad1ab31f2528(maxItems);
        return $842937149a04b8ba$export$1987ad1ab31f2528.instance;
    }
    /**
   * Resets the singleton instance. Only intended for testing purposes.
   * @internal
   */ static resetInstance() {
        $842937149a04b8ba$export$1987ad1ab31f2528.instance = null;
    }
    constructor(maxItems = $842937149a04b8ba$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS){
        this.storageClient = new (0, $f9XbP.StorageClient)($842937149a04b8ba$var$SMART_CARD_CACHE_CLIENT_KEY, {
            storageEngine: 'sessionStorage'
        });
        this.maxItems = void 0;
        this.memoryCache = void 0;
        this.pendingWrite = false;
        /**
     * Retrieves the entire cache object from memory
     * @returns The entire cache object
     */ this.getCache = ()=>{
            return this.memoryCache;
        };
        /**
     * Caches the SmartLinkResponse against the provided url in storage
     * @param url The url (key) to store the response against
     * @param response The SmartLinkResponse to be cached in storage
     */ this.setItem = (url, response)=>{
            // Add or update the item in the cache with current timestamp
            this.memoryCache[url] = {
                data: response,
                timestamp: Date.now()
            };
            // Apply FIFO behavior if cache exceeds maxItems
            const cacheKeys = Object.keys(this.memoryCache);
            if (cacheKeys.length > this.maxItems) {
                // Sort keys by timestamp (oldest first) and remove the oldest items
                const sortedKeys = cacheKeys.sort((a, b)=>this.memoryCache[a].timestamp - this.memoryCache[b].timestamp);
                const itemsToRemove = cacheKeys.length - this.maxItems;
                const keysToRemove = sortedKeys.slice(0, itemsToRemove);
                keysToRemove.forEach((key)=>{
                    delete this.memoryCache[key];
                });
            }
            // Write through to storage asynchronously (non-blocking)
            // Debounced to batch multiple rapid calls into a single write
            if (!this.pendingWrite) {
                this.pendingWrite = true;
                queueMicrotask(()=>{
                    try {
                        this.storageClient.setItemWithExpiry($842937149a04b8ba$var$SMART_CARD_CACHE_KEY, JSON.stringify(this.memoryCache));
                    } catch (_) {
                    // Ignore storage write errors (e.g. quota exceeded) to prevent blocking future writes
                    // Cache will still function in-memory for the session, but won't persist
                    } finally{
                        this.pendingWrite = false;
                    }
                });
            }
        };
        /**
     * Retrieves the cached SmartLinkResponse for the provided url from storage (if it exists)
     * @param url The url (key) to retrieve the cached response for
     * @returns The cached SmartLinkResponse if it exists, else undefined
     */ this.getItem = (url)=>{
            if (!url) return;
            const response = this.memoryCache?.[url]?.data;
            return response;
        };
        /**
     * Checks if a cached entry exists for the provided url in storage
     * @param url The url (key) to check for existence in the cache
     * @returns True if a cached entry exists, else false
     */ this.isUrlInCache = (url)=>{
            return url in this.memoryCache;
        };
        this.maxItems = maxItems;
        // Load cache from storage into memory on instantiation
        const stored = this.storageClient.getItem($842937149a04b8ba$var$SMART_CARD_CACHE_KEY, {
            useExpiredItem: true
        });
        this.memoryCache = stored ? JSON.parse(stored) : {};
    }
}
$842937149a04b8ba$var$_SmartCardLocalCacheClient = $842937149a04b8ba$export$1987ad1ab31f2528;
$842937149a04b8ba$export$1987ad1ab31f2528.instance = null;
module.exports["SmartCardLocalCacheClient"] = $842937149a04b8ba$export$1987ad1ab31f2528;

});

parcelRegister("6YrB3", function(module, exports) {
$parcel$export(module.exports, "StorageClient", () => (parcelRequire("f9XbP")).StorageClient);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $f9XbP = parcelRequire("f9XbP");


var $293056f9068f55f6$export$2e2bcd8739ae039 = (0, $f9XbP.StorageClient);

});

parcelRegister("f9XbP", function(module, exports) {

var $fmV2n = parcelRequire("fmV2n");


var $4KkEB = parcelRequire("4KkEB");

class $cecff34dc45d8bb2$export$6c85f5032e75eff9 {
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
    constructor(clientKey, options){
        this.client = void 0;
        this.clientKey = void 0;
        this.handlers = void 0;
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || (0, $4KkEB.DEFAULT_STORAGE_ENGINE);
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $fmV2n.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
}
module.exports["StorageClient"] = $cecff34dc45d8bb2$export$6c85f5032e75eff9;

});

parcelRegister("fmV2n", function(module, exports) {
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $a61ea4cfed034b37$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $a61ea4cfed034b37$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    let replacedWindowRef = false;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else {
            // Fallback for environments where global might not exist
            windowRef = {};
            replacedWindowRef = true;
        }
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') {
        windowRef = {};
        replacedWindowRef = true;
    }
    // If we had to replace the window reference, reflect it back to global.window
    if (replacedWindowRef && typeof $parcel$global !== 'undefined') $parcel$global.window = windowRef;
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$a61ea4cfed034b37$export$c65e688d8b365035
        },
        configurable: true,
        writable: true
    });
};
module.exports["mockWindowStorage"] = $a61ea4cfed034b37$export$efebfe7859cae3c7;

});

parcelRegister("4KkEB", function(module, exports) {
const $0745f528b71a1a3c$export$3364800d9d60baf9 = 'localStorage';
module.exports["DEFAULT_STORAGE_ENGINE"] = $0745f528b71a1a3c$export$3364800d9d60baf9;

});

parcelRegister("koAyx", function(module, exports) {
class $b7cac00c977cfcad$export$f993aef960936087 {
    buildInlineAdf(url) {
        return {
            type: 'inlineCard',
            attrs: {
                url: url
            }
        };
    }
    buildBlockAdf(url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url
            }
        };
    }
    buildEmbedAdf(url) {
        return {
            type: 'embedCard',
            attrs: {
                url: url,
                layout: 'wide'
            }
        };
    }
    buildDatasourceAdf(datasource, url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url,
                datasource: datasource
            }
        };
    }
    toSmartlinkAdf(url, appearance) {
        switch(appearance){
            case 'inline':
                return this.buildInlineAdf(url);
            case 'block':
                return this.buildBlockAdf(url);
            case 'embed':
                return this.buildEmbedAdf(url);
        }
    }
    toDatasourceAdf(datasource, url) {
        return this.buildDatasourceAdf(datasource, url);
    }
}
module.exports["Transformer"] = $b7cac00c977cfcad$export$f993aef960936087;

});

parcelRegister("8kONW", function(module, exports) {
/**
 * URL checker utilities for Confluence content types.
 *
 * Exported via the `@atlaskit/editor-card-provider/url-checkers` subpath
 * so consumers don't have to depend on the barrel file.
 */ /**
 * Matches Confluence Slides URLs.
 *
 * Examples:
 *   - /wiki/spaces/TEAM/slide/12345
 *   - /wiki/spaces/~uid/slide/8fb8c642-803d-59fe-8d1c-066610e860c6
 */ // eslint-disable-next-line require-unicode-regexp -- consistent with isConfluenceDatabase in provider.ts
const $025d94307c54f6b4$var$CONFLUENCE_SLIDE_URL_PATTERN = /\/wiki\/spaces\/~?[\d\w]+\/slide\/[\d\w-]+(\?.*)?$/;
const $025d94307c54f6b4$export$4091d55e0211d2e1 = (url)=>$025d94307c54f6b4$var$CONFLUENCE_SLIDE_URL_PATTERN.test(url);
module.exports["isConfluenceSlideUrl"] = $025d94307c54f6b4$export$4091d55e0211d2e1;

});

parcelRegister("aN0qB", function(module, exports) {
// Usually, one screen contains about 2_500 nodes, so 10_000 is more than enough.
const $e5ce665804adc727$export$d723a039341399fc = 10000;
const $e5ce665804adc727$export$109b6787e4cb0d4c = {
    smartCard: 10,
    emoji: 500
};
module.exports["NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT"] = $e5ce665804adc727$export$d723a039341399fc;
module.exports["NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH"] = $e5ce665804adc727$export$109b6787e4cb0d4c;

});

parcelRegister("hr9NW", function(module, exports) {

var $jC7Je = parcelRequire("jC7Je");


var $4iudd = parcelRequire("4iudd");


var $kwzZh = parcelRequire("kwzZh");


var $67keU = parcelRequire("67keU");


var $4yccB = parcelRequire("4yccB");


var $gVWsk = parcelRequire("gVWsk");


var $6RwwD = parcelRequire("6RwwD");


var $yuV6Z = parcelRequire("yuV6Z");


var $32x2E = parcelRequire("32x2E");


var $9WAeG = parcelRequire("9WAeG");


var $jQQYu = parcelRequire("jQQYu");


var $6GQtz = parcelRequire("6GQtz");


var $6mKj3 = parcelRequire("6mKj3");


var $dYU3e = parcelRequire("dYU3e");


var $xwvlW = parcelRequire("xwvlW");


var $60cDW = parcelRequire("60cDW");


var $aN0qB = parcelRequire("aN0qB");


var $kY8KV = parcelRequire("kY8KV");


var $6GukH = parcelRequire("6GukH");


var $985xA = parcelRequire("985xA");

const $8323d63e0ec880b7$var$MEASURE_SEGMENT = 'ssr-app/prepare/preloadQuery/editor/nodeDataProvidersData';
const $8323d63e0ec880b7$var$DEFAULT_TIMEOUT = 300;
const $8323d63e0ec880b7$var$EDITOR_CARD_PROVIDER_NAME = 'editorCardProvider';
const $8323d63e0ec880b7$var$EXTERNAL_CARD_PROVIDER_NAME = 'externalEditorCardProvider';
const $8323d63e0ec880b7$var$preloadEditorNodeDataProvidersDataQuery = (0, $jC7Je.default);
async function $8323d63e0ec880b7$export$82c96ba69b54d1e5(contentId, cloudId, isBlog) {
    if (!contentId) return;
    if (!(0, $4iudd.isSSR)()) // If we are not in SSR, we don't need to preload node data providers data.
    return;
    await (0, $9WAeG.SSRMeasures).run($8323d63e0ec880b7$var$MEASURE_SEGMENT, async ()=>{
        const fetchAdfStart = performance.now();
        const docJsonString = await $8323d63e0ec880b7$var$fetchAdf(contentId);
        const fetchAdfDuration = performance.now() - fetchAdfStart;
        if (!docJsonString) return;
        const doc = JSON.parse(docJsonString);
        // Validate that the parsed document is a valid JSONDocNode
        if (!(0, $985xA.isValidJSONDocNode)(doc)) return;
        const providers = [];
        let syncedBlocksPromise;
        if ((0, $gVWsk.isJSONDocNode)(doc)) syncedBlocksPromise = (0, $6GukH.preloadEditorSyncedBlocksData)(contentId, cloudId, isBlog, doc);
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if ((0, $6mKj3.expValEquals)('cc_editor_node_data_providers_preload_config', 'isEnabled', true) && (0, $6mKj3.expValEquals)('cc_editor_node_data_providers_preload_config', 'isSplittingEnabled', true)) {
            providers.push({
                provider: $8323d63e0ec880b7$export$ebf5846faf5beb2(),
                maxNodesToPrefetch: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH).smartCard
            });
            providers.push({
                provider: $8323d63e0ec880b7$export$21425f1d7e912e7a(),
                maxNodesToPrefetch: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH).smartCard
            });
        } else providers.push({
            provider: $8323d63e0ec880b7$var$ssrEditorCardProvider(),
            maxNodesToPrefetch: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH).smartCard
        });
        const emojiNodeDataProvider = await $8323d63e0ec880b7$var$ssrEmojiNodeDataProvider();
        if (emojiNodeDataProvider) providers.push({
            provider: emojiNodeDataProvider,
            maxNodesToPrefetch: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH).emoji
        });
        providers.forEach(({ provider: provider })=>{
            (0, $9WAeG.SSRMeasures).markMeasureStart($8323d63e0ec880b7$var$measureProviderSegment(provider.name));
        });
        let editorNodeDataProvidersData = await (0, $67keU.prefetchNodeDataProvidersData)({
            doc: doc,
            providers: providers,
            timeout: ((0, $6mKj3.expValEquals)('cc_editor_node_data_providers_preload_config', 'isEnabled', true) ? // eslint-disable-next-line confluence-feature-gating/inline-expVal-params
            (0, $6mKj3.expVal)('cc_editor_node_data_providers_preload_config', 'defaultTimeout', $8323d63e0ec880b7$var$DEFAULT_TIMEOUT) || $8323d63e0ec880b7$var$DEFAULT_TIMEOUT : $8323d63e0ec880b7$var$DEFAULT_TIMEOUT) - fetchAdfDuration,
            maxNodesToVisit: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT)
        });
        Object.entries(editorNodeDataProvidersData).forEach(([providerName, { duration: duration }])=>{
            (0, $9WAeG.SSRMeasures).setMeasureDuration($8323d63e0ec880b7$var$measureProviderSegment(providerName), duration);
        });
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if ((0, $6mKj3.expValEquals)('cc_editor_node_data_providers_preload_config', 'isEnabled', true) && (0, $6mKj3.expValEquals)('cc_editor_node_data_providers_preload_config', 'isSplittingEnabled', true)) editorNodeDataProvidersData = $8323d63e0ec880b7$export$45312dbe9e8537fb(editorNodeDataProvidersData);
        const nodeDataToStore = Object.fromEntries(Object.entries(editorNodeDataProvidersData).map(([providerName, { data: data }])=>[
                providerName,
                data
            ]));
        (0, $kY8KV.addToSSREditorNodeDataProvidersStore)(nodeDataToStore);
        // Ensure synced blocks data is fully resolved before returning
        if (syncedBlocksPromise) await syncedBlocksPromise;
    });
}
function $8323d63e0ec880b7$export$45312dbe9e8537fb(nodeDataProvidersSsrData, // will merge to the first provider in the list, which is `editorCardProvider` in our case, so it should be listed first in the array
keysOfProviderDataToMerge = [
    $8323d63e0ec880b7$var$EDITOR_CARD_PROVIDER_NAME,
    $8323d63e0ec880b7$var$EXTERNAL_CARD_PROVIDER_NAME
]) {
    if (keysOfProviderDataToMerge.length < 2) return nodeDataProvidersSsrData;
    const [mainProviderName, ...sourceKeys] = keysOfProviderDataToMerge;
    const result = {
        ...nodeDataProvidersSsrData
    };
    const processedSourceKeys = new Set();
    for (const sourceKey of sourceKeys){
        if (sourceKey === mainProviderName || processedSourceKeys.has(sourceKey)) continue;
        processedSourceKeys.add(sourceKey);
        const sourceData = result[sourceKey];
        if (sourceData) {
            result[mainProviderName] = result[mainProviderName] || {
                data: {},
                duration: 0,
                success: false
            };
            result[mainProviderName] = {
                data: {
                    ...result[mainProviderName].data,
                    ...sourceData.data
                },
                duration: Math.max(result[mainProviderName].duration, sourceData.duration),
                success: result[mainProviderName].success || sourceData.success
            };
            delete result[sourceKey];
        }
    }
    return result;
}
function $8323d63e0ec880b7$var$fetchAdf(contentId) {
    return (0, $9WAeG.SSRMeasures).run(`${$8323d63e0ec880b7$var$MEASURE_SEGMENT}/fetch:AdfDocQuery`, async ()=>{
        try {
            const result = await (0, $dYU3e.query)({
                query: $8323d63e0ec880b7$var$preloadEditorNodeDataProvidersDataQuery,
                variables: {
                    contentId: contentId,
                    status: [
                        'draft'
                    ]
                },
                fetchPolicy: 'network-only',
                __callerPackage__: "load-edit-page"
            });
            if (result.hasErrors) return undefined;
            return result.data?.singleContent?.body?.atlas_doc_format?.value || undefined;
        } catch  {
            return undefined;
        }
    });
}
async function $8323d63e0ec880b7$var$ssrEmojiNodeDataProvider() {
    const { userId: userId, cloudId: cloudId, isLicensed: isLicensed, isLoggedIn: isLoggedIn } = (0, $xwvlW.getPreloaderFnContext)();
    // We need a special emoji parameters that supports SSR load optimization here.
    const emojiResourceParams = (0, $yuV6Z.createEmojiProviderParameters)({
        cloudId: cloudId,
        userId: userId,
        isLicensed: isLicensed,
        isLoggedIn: isLoggedIn
    });
    return (0, $32x2E.getEmojiNodeDataProvider)((0, $kwzZh.default), {
        ...emojiResourceParams,
        allowAnonymousAccess: true
    });
}
function $8323d63e0ec880b7$var$ssrEditorCardProvider() {
    const { host: host, cloudId: cloudId, userContext: userContext, customURLs: customURLs } = (0, $60cDW.getSSRRenderInputs)();
    const objectResolverURL = customURLs?.['object-resolver-service']?.match(/^(https?:\/\/[^/]+)/)?.[0];
    const ssrCardClient = new (0, $4yccB.default)('custom', objectResolverURL);
    ssrCardClient.setHeaders({
        Cookie: (0, $jQQYu.createCookie)(userContext),
        Origin: host.startsWith('http') ? host : `https://${host}`,
        CloudId: cloudId
    });
    // No URL filter: accepts both internal and external URLs
    return new (0, $6GQtz.ConfluenceEditorCardProvider)('custom', objectResolverURL, undefined, ssrCardClient);
}
function $8323d63e0ec880b7$var$createSSREditorCardProvider(urlFilter, nameOverride) {
    const { host: host, cloudId: cloudId, userContext: userContext, customURLs: customURLs } = (0, $60cDW.getSSRRenderInputs)();
    // This URL will be something like `https://object-resolver.staging.atl-paas.net/resolve/batch`.
    // We need only protocol and host to pass it to the EditorCardProvider,
    // because path will be added by `CardClient`.
    const objectResolverURL = customURLs?.['object-resolver-service']?.match(/^(https?:\/\/[^/]+)/)?.[0];
    // We need to define a custom CardClient for SSR, because the default one works through public API gateway.
    const ssrCardClient = new (0, $4yccB.default)('custom', objectResolverURL);
    // Headers from `fetchORSForSSR` from confluence/next/packages/content-smartlinks/src/index.ts
    ssrCardClient.setHeaders({
        Cookie: (0, $jQQYu.createCookie)(userContext),
        Origin: host.startsWith('http') ? host : `https://${host}`,
        CloudId: cloudId
    });
    return new (0, $6GQtz.ConfluenceEditorCardProvider)('custom', objectResolverURL, undefined, ssrCardClient, urlFilter, nameOverride);
}
function $8323d63e0ec880b7$export$ebf5846faf5beb2() {
    return $8323d63e0ec880b7$var$createSSREditorCardProvider((0, $6RwwD.isInternalUrl));
}
function $8323d63e0ec880b7$export$21425f1d7e912e7a() {
    return $8323d63e0ec880b7$var$createSSREditorCardProvider((0, $6RwwD.isExternalUrl), $8323d63e0ec880b7$var$EXTERNAL_CARD_PROVIDER_NAME);
}
function $8323d63e0ec880b7$var$measureProviderSegment(providerName) {
    return `${$8323d63e0ec880b7$var$MEASURE_SEGMENT}/${providerName}`;
}
module.exports["preloadEditorNodeDataProvidersData"] = $8323d63e0ec880b7$export$82c96ba69b54d1e5;

});

parcelRegister("jC7Je", function(module, exports) {
/**
 * @generated SignedSource<<a5c664904afb7aa720df5692f74ea8df>>
 * @relayHash 72f0e11f3a3324a5c8d9d9a03df96df2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c6de5103060e3ef016dd939ce41c1ace25f1b934ec83c466b567b4f6ef2e2985
const $f23059387da63ee7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "atlas_doc_format",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadEditorNodeDataProvidersDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadEditorNodeDataProvidersDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "72f0e11f3a3324a5c8d9d9a03df96df2",
            "id": "c6de5103060e3ef016dd939ce41c1ace25f1b934ec83c466b567b4f6ef2e2985",
            "metadata": {},
            "name": "preloadEditorNodeDataProvidersDataQuery",
            "operationKind": "query",
            "text": "query preloadEditorNodeDataProvidersDataQuery($contentId:ID,$status:[String]){singleContent(id:$contentId,status:$status){id,body{atlas_doc_format{value}}}}"
        }
    };
}();
$f23059387da63ee7$var$node.hash = "b082e4555a8e2adb34e1cfb641ee98a0";
var $f23059387da63ee7$export$2e2bcd8739ae039 = $f23059387da63ee7$var$node;
module.exports["default"] = $f23059387da63ee7$export$2e2bcd8739ae039;

});

parcelRegister("67keU", function(module, exports) {

var $eRwHS = parcelRequire("eRwHS");

async function $787da7bcf8e68b93$export$65217f7ac34c2278({ providers: providers, doc: doc, timeout: timeout, maxNodesToVisit: maxNodesToVisit = Infinity }) {
    if (timeout <= 0) // If the global timeout is 0 or negative, skip fetching entirely.
    return providers.reduce((acc, { provider: provider })=>{
        acc[provider.name] = {
            data: {},
            success: false,
            duration: 0
        };
        return acc;
    }, {});
    const providersWithDefaults = providers.map(({ provider: provider, maxNodesToPrefetch: maxNodesToPrefetch = Infinity, timeout: providerTimeout = Infinity })=>({
            provider: provider,
            maxNodesToPrefetch: maxNodesToPrefetch,
            // Use the minimum of the global timeout and the provider-specific timeout
            timeout: Math.min(providerTimeout, timeout)
        }));
    const providerTimeouts = providersWithDefaults.reduce((acc, { provider: provider, timeout: timeout })=>{
        acc[provider.name] = timeout;
        return acc;
    }, {});
    const nodesWithProviders = (0, $eRwHS.findNodesToPrefetch)(doc, providersWithDefaults, maxNodesToVisit).map(({ provider: provider, nodes: nodes })=>({
            provider: provider,
            nodes: nodes,
            timeout: providerTimeouts[provider.name]
        }));
    const promises = nodesWithProviders.map(async ({ nodes: nodes, provider: provider, timeout: timeout })=>{
        if (timeout <= 0) return {
            provider: provider,
            success: false,
            duration: 0,
            nodes: nodes,
            data: []
        };
        const start = performance.now();
        function getDurationFromStart() {
            return Math.min(performance.now() - start, timeout);
        }
        try {
            const timeoutPromise = new Promise((_, reject)=>{
                setTimeout(()=>{
                    reject();
                }, timeout);
            });
            const data = await Promise.race([
                provider.fetchNodesData(nodes),
                timeoutPromise
            ]);
            return {
                provider: provider,
                success: true,
                duration: getDurationFromStart(),
                nodes: nodes,
                data: data
            };
        } catch  {
            return {
                provider: provider,
                success: false,
                duration: getDurationFromStart(),
                nodes: nodes,
                data: []
            };
        }
    });
    const results = await Promise.all(promises);
    return results.reduce((acc, { provider: provider, success: success, duration: duration, nodes: nodes, data: data })=>{
        const ssrData = data.reduce((providerSsrData, nodeData, nodeIndex)=>{
            const node = nodes[nodeIndex];
            const nodeDataKey = provider.nodeDataKey(node);
            providerSsrData[nodeDataKey] = nodeData;
            return providerSsrData;
        }, {});
        acc[provider.name] = {
            data: ssrData,
            success: success,
            duration: duration
        };
        return acc;
    }, {});
}
module.exports["prefetchNodeDataProvidersData"] = $787da7bcf8e68b93$export$65217f7ac34c2278;

});

parcelRegister("yuV6Z", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $378a693b2c26358e$export$ca6dda5263526f75 = '/gateway/api/emoji';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $378a693b2c26358e$var$isServerEnvironment = ()=>false; // "1" true || "" false || undefined false
const $378a693b2c26358e$var$isClientEnvironment = ()=>!!window.__SSR_RENDERED__;
const $378a693b2c26358e$export$2e27ba8337eb718f = '/gateway/api/elements/emoji';
const $378a693b2c26358e$export$756c07819e5ddb69 = (cloudId, emojiId, scale)=>{
    const baseUrl = (0, $iDrrr.fg)('use-elements-stargate-emoji-path') ? $378a693b2c26358e$export$2e27ba8337eb718f : $378a693b2c26358e$export$ca6dda5263526f75;
    return `${baseUrl}/${cloudId}/${emojiId}/path?scale=${scale ?? 'MDPI'}`;
};
const $378a693b2c26358e$export$761bef4dd134445c = (params)=>{
    const { isSSR: isSSR, hasCloudId: hasCloudId, isGuestUser: isGuestUser } = params;
    const ssrEnabled = !!(isSSR && hasCloudId);
    // SSR Not Supported
    if (!ssrEnabled || isGuestUser) return false;
    // SSR For Logged in Users
    return true;
};
const $378a693b2c26358e$export$fc7d38d59502d4a6 = ({ onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    if (!onEmojiLoadSuccess && !onEmojiLoadFail) return undefined;
    return {
        onEmojiLoadSuccess: onEmojiLoadSuccess,
        onEmojiLoadFail: onEmojiLoadFail
    };
};
const $378a693b2c26358e$export$91e66df277b39831 = (emojiId)=>{
    const { id: id, shortName: shortName } = emojiId;
    const regexp = new RegExp(/:([^:]+):/g); // tests and takes the value between two colons
    if (id) return id;
    if (regexp.test(shortName)) return shortName.replaceAll(':', '');
    return shortName;
};
const $378a693b2c26358e$export$1dcae2834e6255a2 = (params)=>{
    // Feature enabled flags
    const isSSR = $378a693b2c26358e$var$isServerEnvironment() || $378a693b2c26358e$var$isClientEnvironment();
    const isGuestUser = !params.isLicensed || !params.isLoggedIn;
    // Transform parameters
    const cloudId = params?.cloudId ?? '';
    const userId = params?.userId ?? undefined;
    const disableUpload = params?.disableUpload;
    const emojiSSRConfig = params?.emojiSSRConfig ?? {};
    // Enable emoji ssr
    const useEmojiSSR = $378a693b2c26358e$export$761bef4dd134445c({
        isSSR: isSSR,
        hasCloudId: !!cloudId,
        isGuestUser: isGuestUser
    });
    // Default emoji SSR interface
    const emojiSSRConfigOverride = useEmojiSSR ? {
        optimisticImageApi: {
            getUrl: (emojiId)=>$378a693b2c26358e$export$756c07819e5ddb69(cloudId, $378a693b2c26358e$export$91e66df277b39831(emojiId))
        },
        ...emojiSSRConfig
    } : undefined;
    // Enable emoji load callbacks
    const emojiLoadCallbacks = $378a693b2c26358e$export$fc7d38d59502d4a6({
        onEmojiLoadSuccess: params?.onEmojiLoadSuccess,
        onEmojiLoadFail: params?.onEmojiLoadFail
    });
    return {
        cloudId: cloudId,
        userId: userId,
        disableUpload: disableUpload,
        ...useEmojiSSR && {
            emojiSSRConfig: emojiSSRConfigOverride
        },
        emojiLoadCallbacks: emojiLoadCallbacks
    };
};
module.exports["getOptimisticImageURL"] = $378a693b2c26358e$export$756c07819e5ddb69;
module.exports["getEmojiSSRSupport"] = $378a693b2c26358e$export$761bef4dd134445c;
module.exports["createEmojiProviderParameters"] = $378a693b2c26358e$export$1dcae2834e6255a2;

});

parcelRegister("32x2E", function(module, exports) {

var $1UWNP = parcelRequire("1UWNP");


var $bwAnG = parcelRequire("bwAnG");


var $7W8i8 = parcelRequire("7W8i8");

const $dc26b22176754e2e$var$logger = (0, $7W8i8.getLogger)('emoji-provider');
const $dc26b22176754e2e$export$ca6dda5263526f75 = '/gateway/api/emoji';
const $dc26b22176754e2e$export$240be4f98742fdda = (cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const config = {
        providers: [
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/standard`
            },
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/atlassian`
            }
        ],
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks
    };
    if (cloudId && (userId || allowAnonymousAccess)) config.providers.push({
        url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/site`
    });
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $dc26b22176754e2e$export$1504d130127dbc5f = (_EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? false;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    // For signed-in users, allowAnonymousAccess does not change the provider config. Sharing the
    // resource lets uploads propagate immediately between editor, title, and reaction pickers.
    const allowAnonymousAccessCacheKey = userId ? false : allowAnonymousAccess;
    return `${cloudId}_${userId}_${allowAnonymousAccessCacheKey}_${emojiSSRConfig ? 'withSSR' : 'noSSR'}`;
};
const $dc26b22176754e2e$export$9e6d4bd03aadcea5 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? undefined;
    const emojiConfig = $dc26b22176754e2e$export$240be4f98742fdda(cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess);
    return new EmojiResource(emojiConfig);
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return emojiResource.getEmojiProvider();
    } catch (err) {
        return Promise.resolve(undefined);
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$b263a0680b18512c = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return new (0, $bwAnG.EmojiNodeDataProvider)(emojiResource);
    } catch (err) {
        return undefined;
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
module.exports["getEmojiConfig"] = $dc26b22176754e2e$export$240be4f98742fdda;
module.exports["getEmojiProvider"] = $dc26b22176754e2e$export$8210f5f78c0bcf27;
module.exports["getEmojiNodeDataProvider"] = $dc26b22176754e2e$export$b263a0680b18512c;

});

parcelRegister("bwAnG", function(module, exports) {

var $4iudd = parcelRequire("4iudd");


var $l4yrE = parcelRequire("l4yrE");


var $4xiow = parcelRequire("4xiow");


var $drRzc = parcelRequire("drRzc");


var $anBbz = parcelRequire("anBbz");

class $dfb1108de4ce4e19$export$67106c51beb59865 extends (0, $drRzc.NodeDataProvider) {
    isNodeSupported(node) {
        return node.type === 'emoji';
    }
    nodeDataKey(node) {
        return node.attrs.id || node.attrs.shortName;
    }
    /**
   * Implementing different re-fetching strategy for emoji.
   *
   * Default strategy for NodeDataProvider is to:
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   * 4. Re-render node with fresh data.
   *
   * This is similar, but doesn't update the node.
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   */ getData(node, callback) {
        const cached = this.getNodeDataFromCache(node);
        if (cached?.data) {
            callback(cached);
            if (!(0, $4iudd.isSSR)() && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(()=>void this.getDataAsync(node, ()=>{}));
        } else this.getDataAsync(node, callback);
    }
    async fetchNodesData(nodes) {
        // If we have an `optimisticImageApi`, use it to generate a URL immediately.
        // This is how emojis are server-side rendered in Confluence.
        // Without this, the emoji server response will hit timeout on SSR and the emoji will not be rendered.
        //
        // We are using this optimization only in SSR because on client side we need to know a valid emoji size
        // which is not possible to get from optimisticImageApi.
        //
        // Check platform/packages/editor/renderer/src/react/nodes/emoji.tsx
        // and platform/packages/elements/emoji/src/components/common/ResourcedEmojiComponent.tsx
        const getOptimisticImageUrl = this.emojiResource.emojiProviderConfig.optimisticImageApi?.getUrl;
        if ((0, $4iudd.isSSR)() && getOptimisticImageUrl) return nodes.map((node)=>{
            if ((0, $anBbz.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true)) {
                // Skip SSR for nodes without an Id
                if (!node.attrs.id) return undefined;
                const unicodeEmoji = (0, $4xiow.emojiIdToEmoji)(node.attrs.id);
                if (unicodeEmoji) return {
                    id: node.attrs.id,
                    shortName: node.attrs.shortName,
                    fallback: node.attrs.text,
                    representation: {
                        unicodeEmoji: unicodeEmoji
                    },
                    searchable: true,
                    type: '',
                    category: ''
                };
            }
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            const optimisticImageURL = getOptimisticImageUrl(emojiId);
            return {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text,
                representation: {
                    height: (0, $l4yrE.defaultEmojiHeight),
                    width: (0, $l4yrE.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true,
                // Type and category are unknown at this point.
                // It's not a big deal, because EmojiNodeView doesn't use them.
                type: '',
                category: ''
            };
        });
        // This is slower path because during access to emojiProvider emojiResource
        // makes a request to fetch all emojis.
        const emojiProvider = await this.emojiProvider;
        const fetches = nodes.map(async (node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            // This usually fast because the emojiProvider already has all emojis fetched.
            const result = await emojiProvider.fetchByEmojiId(emojiId, true);
            // For STANDARD emojis, return a UnicodeRepresentation so they are rendered
            // as native text characters rather than images (twemoji removal).
            if (node.attrs.id && result && (0, $anBbz.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true)) {
                const unicodeEmoji = (0, $4xiow.emojiIdToEmoji)(node.attrs.id);
                if (unicodeEmoji) return {
                    ...result,
                    representation: {
                        unicodeEmoji: unicodeEmoji
                    }
                };
            }
            // If we have optimisticImageApi, we need to path response and set URL from it to match the URL used in SSR.
            if (getOptimisticImageUrl && result) {
                const optimisticImageURL = getOptimisticImageUrl(emojiId);
                if (result.representation && 'imagePath' in result.representation) return {
                    ...result,
                    representation: {
                        ...result.representation,
                        imagePath: optimisticImageURL
                    }
                };
            }
            return result;
        });
        return Promise.all(fetches);
    }
    constructor(resource){
        super();
        this.name = 'emojiNodeDataProvider';
        this.emojiResource = void 0;
        this.emojiProvider = void 0;
        this.emojiResource = resource;
        this.emojiProvider = resource.getEmojiProvider();
    }
}
module.exports["EmojiNodeDataProvider"] = $dfb1108de4ce4e19$export$67106c51beb59865;

});

parcelRegister("jQQYu", function(module, exports) {
// Creates a cookie for object-resolver header
const $64671b371f568ec9$export$7892c26d6c7a7447 = (userContext)=>{
    const cookieTarget = 'cloud.session.token';
    return `${cookieTarget}=${userContext}`;
};
module.exports["createCookie"] = $64671b371f568ec9$export$7892c26d6c7a7447;

});

parcelRegister("kY8KV", function(module, exports) {
/**
 * Adds data to the SSR editor node data providers store on the window object.
 * This allows multiple loaders to safely add data to the same object without
 * overwriting each other's data.
 *
 * @param data - The data to merge into the existing store
 */ function $5ae7655949a69969$export$a2bf498e230933ac(data) {
    const existingData = window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] || {};
    window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] = {
        ...existingData,
        ...data
    };
}
module.exports["addToSSREditorNodeDataProvidersStore"] = $5ae7655949a69969$export$a2bf498e230933ac;

});

parcelRegister("6GukH", function(module, exports) {

var $45MGZ = parcelRequire("45MGZ");

const $86855d2f29349b22$var$MEASURE_SEGMENT = 'ssr-app/prepare/preloadQuery/editor/syncedBlocksData';
async function $86855d2f29349b22$export$bd3ad760f826791(contentId, cloudId, isBlog, doc) {
    if (!contentId || !cloudId || typeof isBlog === 'undefined') return;
    return (0, $45MGZ.preloadSyncedBlocksData)({
        contentId: contentId,
        cloudId: cloudId,
        isBlog: isBlog,
        doc: doc,
        measureSegment: $86855d2f29349b22$var$MEASURE_SEGMENT
    });
}
module.exports["preloadEditorSyncedBlocksData"] = $86855d2f29349b22$export$bd3ad760f826791;

});

parcelRegister("45MGZ", function(module, exports) {

var $4iudd = parcelRequire("4iudd");


var $8Pm8w = parcelRequire("8Pm8w");


var $6oMcp = parcelRequire("6oMcp");


var $cuwGS = parcelRequire("cuwGS");


var $79ir6 = parcelRequire("79ir6");


var $gb05o = parcelRequire("gb05o");


var $9WAeG = parcelRequire("9WAeG");


var $1i2qc = parcelRequire("1i2qc");


var $6mKj3 = parcelRequire("6mKj3");


var $3mugH = parcelRequire("3mugH");


var $kY8KV = parcelRequire("kY8KV");


var $8AcAF = parcelRequire("8AcAF");


var $l9Wsf = parcelRequire("l9Wsf");

const $8435e015d85a0f69$var$MEASURE_SEGMENT = 'ssr-app/prepare/preloadQuery/syncedBlocksData';
// Timeout for fetching synced block references in milliseconds
// This is currently set to higher value to account for potential network latencys
// We will monitor performance and adjust this value as needed
const $8435e015d85a0f69$var$DEFAULT_TIMEOUT = 1500;
// New default timeout for batch fetch implementation, which includes more relistics value
const $8435e015d85a0f69$var$DEFAULT_TIMEOUT_NEXT = 500;
async function $8435e015d85a0f69$export$1de9b28b2fdef558(options) {
    const { contentId: contentId, cloudId: cloudId, isBlog: isBlog, doc: doc, measureSegment: measureSegment, timeout: timeout } = options;
    if (!contentId || !cloudId || !doc || !(0, $4iudd.isSSR)() || typeof isBlog === 'undefined') return;
    const segmentName = measureSegment || $8435e015d85a0f69$var$MEASURE_SEGMENT;
    let blockNodeIdentifiers = [];
    // When FG is enabled, check for empty synced blocks BEFORE entering the measured run
    // so pages with no synced blocks don't record a metric for this segment
    blockNodeIdentifiers = (0, $l9Wsf.extractSyncBlockIdentifiers)(doc);
    if (blockNodeIdentifiers.length === 0) return;
    if (doc && (0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'isEnabled', false)) {
        blockNodeIdentifiers = (0, $l9Wsf.extractSyncBlockIdentifiers)(doc);
        // If no synced blocks found, return early
        if (blockNodeIdentifiers.length === 0) return;
    }
    await (0, $9WAeG.SSRMeasures).run(segmentName, async ()=>{
        // Use bulk load (batchFetchData) when doc is available
        if (doc) // Extract block identifiers from the ADF document
        {
            if (!(0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'isEnabled', false)) blockNodeIdentifiers = (0, $l9Wsf.extractSyncBlockIdentifiers)(doc);
        }
        const syncBlockReferences = await $8435e015d85a0f69$export$9523b76ee01ef6d(contentId, cloudId, isBlog, blockNodeIdentifiers, segmentName, timeout);
        if (!syncBlockReferences) {
            if (blockNodeIdentifiers.length > 0) (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Synced block fetch returned incomplete results: ${blockNodeIdentifiers.length} blocks missing`), {
                code: (0, $gb05o.SyncedBlocksSSRErrorCodeMap).FETCH_INCOMPLETE,
                contentId: contentId,
                cloudId: cloudId,
                isBlog: isBlog,
                identifiers: blockNodeIdentifiers,
                missingIdentifiers: blockNodeIdentifiers
            });
            return;
        }
        // check if results match the requested block identifiers, if not,
        // it means the fetch was likely incomplete/failed,
        if (syncBlockReferences.length !== blockNodeIdentifiers.length) {
            // Find which block identifiers are missing from the results
            const returnedIdentifiers = new Set(syncBlockReferences.map((ref)=>`${ref.resourceId}:${ref.data?.blockInstanceId ?? 'unknown'}`));
            const missingIdentifiers = blockNodeIdentifiers.filter((identifier)=>!returnedIdentifiers.has(`${identifier.resourceId}:${identifier.blockInstanceId}`));
            (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Synced block fetch returned incomplete results: ${missingIdentifiers.length} blocks missing`), {
                code: (0, $gb05o.SyncedBlocksSSRErrorCodeMap).FETCH_INCOMPLETE,
                contentId: contentId,
                cloudId: cloudId,
                isBlog: isBlog,
                identifiers: blockNodeIdentifiers,
                missingIdentifiers: missingIdentifiers
            });
        }
        (0, $kY8KV.addToSSREditorNodeDataProvidersStore)({
            syncBlocks: syncBlockReferences
        });
        const syncedBlocksWithMedia = syncBlockReferences.filter((syncBlock)=>{
            // Preload media data providers for synced blocks that contain media nodes
            const containedNodeTypes = (0, $8AcAF.syncBlockContainsNodes)(syncBlock, [
                'media'
            ]);
            return containedNodeTypes.length > 0 && containedNodeTypes.includes('media');
        });
        const tasks = [];
        syncedBlocksWithMedia.forEach((syncBlockInstance)=>{
            tasks.push($8435e015d85a0f69$export$6df3cdf918cdf771(syncBlockInstance, cloudId));
        });
        await Promise.allSettled(tasks);
    });
}
async function $8435e015d85a0f69$export$6df3cdf918cdf771(syncBlock, cloudId) {
    if (!syncBlock) return null;
    const { product: product, contentId: contentId } = (0, $cuwGS.parseResourceId)(syncBlock.resourceId) || {};
    if (!product) return {
        resourceId: syncBlock.resourceId,
        result: undefined
    };
    if (product === 'confluence-page') {
        if (!contentId) return {
            resourceId: syncBlock.resourceId,
            result: undefined
        };
        const result = await (0, $1i2qc.preloadMediaToken)(contentId, cloudId);
        return {
            resourceId: syncBlock.resourceId,
            result: result
        };
    }
    if (product === 'jira-work-item') {
        const jiraIssueAri = syncBlock.data?.sourceAri;
        if (!jiraIssueAri) return {
            resourceId: syncBlock.resourceId,
            result: undefined
        };
        const result = await (0, $1i2qc.preloadJiraMediaToken)(jiraIssueAri);
        return {
            resourceId: syncBlock.resourceId,
            result: result
        };
    }
    return null;
}
function $8435e015d85a0f69$export$9523b76ee01ef6d(contentId, cloudId, isBlog, blockNodeIdentifiers, measureSegment = $8435e015d85a0f69$var$MEASURE_SEGMENT, timeout = (0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'isEnabled', false) ? $8435e015d85a0f69$var$DEFAULT_TIMEOUT_NEXT : $8435e015d85a0f69$var$DEFAULT_TIMEOUT) {
    return (0, $9WAeG.SSRMeasures).run(`${measureSegment}/fetch:SyncBlockReferences`, async ()=>{
        const pageAri = (0, $6oMcp.getConfluencePageAri)({
            cloudId: cloudId,
            pageId: contentId,
            pageType: isBlog ? 'blogpost' : 'page'
        });
        const timeoutError = new Error('timeout');
        let batchFetchDataConfig = undefined;
        if ((0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'isEnabled', false)) batchFetchDataConfig = {
            timeoutMs: (0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'timeout', null) ?? timeout,
            isSSR: (0, $4iudd.isSSR)(),
            maxBatchSize: (0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'maxBatchSize', null) ?? undefined
        };
        try {
            let results;
            if ((0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'isEnabled', false)) // We only passing the batchFetchDataConfig when the experiment is enabled,
            // however, batchFetchData is NOT gateed.
            results = await (0, $8Pm8w.batchFetchData)(cloudId, pageAri, blockNodeIdentifiers, batchFetchDataConfig);
            else results = await Promise.race([
                (0, $8Pm8w.batchFetchData)(cloudId, pageAri, blockNodeIdentifiers),
                new Promise((_resolve, reject)=>setTimeout(()=>{
                        reject(timeoutError);
                    }, timeout))
            ]);
            if (!results) {
                // No results returned - this could indicate a failure in the batch fetch operation
                // this would not be timeout, as it will throw a timeout error instead,
                // so we can attribute this to a fetch failure and log accordingly
                (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error('Synced blocks fetch returned no results'), {
                    code: (0, $gb05o.SyncedBlocksSSRErrorCodeMap).BATCH_FETCH_FAILED,
                    contentId: contentId,
                    cloudId: cloudId,
                    isBlog: isBlog,
                    identifiers: blockNodeIdentifiers
                });
                return undefined;
            }
            // check if result is timeout error
            if (Array.isArray(results) && results.length > 0 && (0, $4iudd.isSSR)() && // we only want to apply this logic for SSR, as in client side we can allow for retries and better error handling.
            (0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'isEnabled', false)) {
                const isTimeout = results.some((result)=>(0, $79ir6.SyncBlockError).Aborted === result.error?.type);
                if (isTimeout) {
                    // This means the batch fetch operation timed out
                    (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error('Synced blocks fetch operation timed out'), {
                        code: (0, $gb05o.SyncedBlocksSSRErrorCodeMap).FETCH_TIMEOUT,
                        contentId: contentId,
                        cloudId: cloudId,
                        isBlog: isBlog,
                        identifiers: blockNodeIdentifiers
                    });
                    // we don't want to return timeout results,
                    // as it might cause error on the initial page load.
                    return undefined;
                }
            }
            return results;
        } catch (error) {
            // Network or API error
            const errorMessage = error instanceof Error ? error.message : String(error);
            const errorName = error instanceof Error ? error.name : undefined;
            (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Batch fetch for synced blocks failed: unable to fetch ${blockNodeIdentifiers.length} blocks`), {
                code: (0, $gb05o.SyncedBlocksSSRErrorCodeMap).BATCH_FETCH_FAILED,
                contentId: contentId,
                cloudId: cloudId,
                isBlog: isBlog,
                identifiers: blockNodeIdentifiers,
                errorMessage: errorMessage,
                errorName: errorName
            });
            return undefined;
        }
    });
}
module.exports["preloadSyncedBlocksData"] = $8435e015d85a0f69$export$1de9b28b2fdef558;

});

parcelRegister("8Pm8w", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ 
var $cozmU = parcelRequire("cozmU");


var $ieeJu = parcelRequire("ieeJu");


var $3xsB6 = parcelRequire("3xsB6");


var $05aaK = parcelRequire("05aaK");


var $79ir6 = parcelRequire("79ir6");


var $916Gd = parcelRequire("916Gd");


var $7GRSG = parcelRequire("7GRSG");


var $cuwGS = parcelRequire("cuwGS");


var $d04Ge = parcelRequire("d04Ge");

const $9b0c4608cd445e14$var$BLOCK_ARI_TO_RESOURCE_ID_REGEX = /^ari:cloud:blocks:.*:synced-block\/(.+)$/;
const $9b0c4608cd445e14$var$EXTRACT_RESOURCE_ID_FROM_BLOCK_ARI_REGEX = /ari:cloud:blocks:[^:]+:synced-block\/(.+)$/;
const $9b0c4608cd445e14$var$mapBlockError = (error)=>{
    switch(error.status){
        case 400:
        case 401:
            return (0, $79ir6.SyncBlockError).InvalidRequest;
        case 403:
            return (0, $79ir6.SyncBlockError).Forbidden;
        case 404:
            return (0, $79ir6.SyncBlockError).NotFound;
        case 409:
            return (0, $79ir6.SyncBlockError).Conflict;
        case 429:
            return (0, $79ir6.SyncBlockError).RateLimited;
        case 500:
        case 503:
        case 504:
            return (0, $79ir6.SyncBlockError).ServerError;
    }
    return (0, $79ir6.SyncBlockError).Errored;
};
const $9b0c4608cd445e14$var$mapErrorResponseCode = (errorCode)=>{
    switch(errorCode){
        case 'FORBIDDEN':
            return (0, $79ir6.SyncBlockError).Forbidden;
        case 'RESOURCE_NOT_FOUND':
        case 'NOT_FOUND':
            return (0, $79ir6.SyncBlockError).NotFound;
        case 'EntityNotFound':
            return (0, $79ir6.SyncBlockError).EntityNotFound;
        case 'INVALID_REQUEST':
            return (0, $79ir6.SyncBlockError).InvalidRequest;
        case 'CONFLICT':
            return (0, $79ir6.SyncBlockError).Conflict;
        case 'RATE_LIMITED':
            return (0, $79ir6.SyncBlockError).RateLimited;
        case 'SERVER_ERROR':
            return (0, $79ir6.SyncBlockError).ServerError;
        case 'INVALID_CONTENT':
            return (0, $79ir6.SyncBlockError).InvalidContent;
        default:
            return (0, $79ir6.SyncBlockError).Errored;
    }
};
const $9b0c4608cd445e14$export$7a367d6c9621d11 = (blockAri)=>{
    // Validate ARI format and extract resourceId using regex
    // Format: ari:cloud:blocks:{uuid}:synced-block/{product}/{parentId}/{resourceId}
    // The regex captures the full path after synced-block/
    // e.g. ari:cloud:blocks:DUMMY-a5a01d21-1cc3-4f29-9565-f2bb8cd969f5:synced-block/confluence-page/455232061495/e8cf64e3-1b6e-489b-ad86-8465b0905bb4
    // should return confluence-page/455232061495/e8cf64e3-1b6e-489b-ad86-8465b0905bb4
    const match = blockAri.match($9b0c4608cd445e14$var$BLOCK_ARI_TO_RESOURCE_ID_REGEX);
    return match?.[1] || null;
};
const $9b0c4608cd445e14$export$bba762cb095b2f42 = (data, resourceId)=>{
    let createdAt;
    if (data.createdAt !== undefined && data.createdAt !== null) try {
        createdAt = new Date(data.createdAt).toISOString();
    } catch  {
        // fallback to undefined
        // as we don't want to block the whole process due to invalid date
        createdAt = undefined;
    }
    return {
        blockInstanceId: data.blockInstanceId,
        content: JSON.parse(data.content),
        contentUpdatedAt: (0, $d04Ge.convertContentUpdatedAt)(data.contentUpdatedAt),
        createdAt: createdAt,
        createdBy: data.createdBy,
        product: data.product,
        resourceId: resourceId,
        sourceAri: data.sourceAri,
        status: data.status
    };
};
const $9b0c4608cd445e14$export$17132bdfdc28611c = async (documentAri)=>{
    let response;
    try {
        response = await (0, $05aaK.getReferenceSyncedBlocks)(documentAri);
    } catch (error) {
        if (error instanceof (0, $05aaK.BlockError)) return $9b0c4608cd445e14$var$mapBlockError(error);
        return (0, $79ir6.SyncBlockError).Errored;
    }
    const { blocks: blocks, errors: errors } = response || {};
    const blocksInstances = (blocks || []).map((blockContentResponse)=>{
        try {
            const resourceId = $9b0c4608cd445e14$export$7a367d6c9621d11(blockContentResponse.blockAri);
            if (!resourceId) // could not extract resourceId from blockAri, return InvalidContent error
            return {
                error: {
                    type: (0, $79ir6.SyncBlockError).InvalidContent
                },
                resourceId: blockContentResponse.blockAri
            };
            return {
                data: $9b0c4608cd445e14$export$bba762cb095b2f42(blockContentResponse, resourceId),
                resourceId: resourceId
            };
        } catch  {
            // JSON parsing error, return InvalidContent error
            return {
                error: {
                    type: (0, $79ir6.SyncBlockError).InvalidContent
                },
                resourceId: blockContentResponse.blockAri
            };
        }
    });
    const errorInstances = (errors || []).map((errorBlock)=>({
            error: {
                type: (0, $79ir6.SyncBlockError).Errored
            },
            resourceId: errorBlock.blockAri
        }));
    return [
        ...blocksInstances,
        ...errorInstances
    ];
};
const $9b0c4608cd445e14$export$2837853885c81488 = (blockAri)=>{
    const match = blockAri.match($9b0c4608cd445e14$var$EXTRACT_RESOURCE_ID_FROM_BLOCK_ARI_REGEX);
    return match?.[1];
};
const $9b0c4608cd445e14$export$abdcb5d4d6767e73 = async (cloudId, parentAri, blockNodeIdentifiers, config)=>{
    const blockIdentifiers = blockNodeIdentifiers.map((blockIdentifier)=>({
            blockAri: (0, $3xsB6.generateBlockAriFromReference)({
                cloudId: cloudId,
                resourceId: blockIdentifier.resourceId
            }),
            blockInstanceId: blockIdentifier.blockInstanceId
        }));
    // Create a set of valid resourceIds for validation
    const validResourceIds = new Set(blockNodeIdentifiers.map((blockNodeIdentifier)=>blockNodeIdentifier.resourceId));
    // Track which resourceIds have been processed
    const processedResourceIds = new Set();
    if (!parentAri) return blockNodeIdentifiers.map((blockNodeIdentifier)=>({
            error: {
                type: (0, $79ir6.SyncBlockError).Errored
            },
            resourceId: blockNodeIdentifier.resourceId
        }));
    try {
        const response = await (0, $05aaK.batchRetrieveSyncedBlocks)({
            blockIdentifiers: blockIdentifiers,
            config: config
        });
        const results = [];
        // Process successful blocks
        if (response.success) for (const blockContentResponse of response.success){
            // Extract resourceId from the returned blockAri
            const resourceId = $9b0c4608cd445e14$export$2837853885c81488(blockContentResponse.blockAri);
            if (!resourceId || !validResourceIds.has(resourceId)) continue;
            processedResourceIds.add(resourceId);
            const { content: content, deletionReason: deletionReason, sourceAri: sourceAri, blockAri: blockAri, contentUpdatedAt: contentUpdatedAt, blockInstanceId: blockInstanceId, product: product, status: status } = blockContentResponse;
            if (!content) {
                results.push({
                    error: {
                        type: (0, $79ir6.SyncBlockError).NotFound,
                        reason: deletionReason,
                        sourceAri: sourceAri
                    },
                    resourceId: resourceId
                });
                continue;
            }
            try {
                const syncedBlockData = JSON.parse(content);
                results.push({
                    data: {
                        content: syncedBlockData,
                        resourceId: blockAri,
                        contentUpdatedAt: (0, $d04Ge.convertContentUpdatedAt)(contentUpdatedAt),
                        blockInstanceId: blockInstanceId,
                        sourceAri: sourceAri,
                        product: product,
                        status: status,
                        deletionReason: deletionReason
                    },
                    resourceId: resourceId
                });
            } catch  {
                results.push({
                    error: {
                        type: (0, $79ir6.SyncBlockError).Errored,
                        reason: `parsing JSON content response failed for resourceId: ${resourceId} localId: ${blockAri}`
                    },
                    resourceId: resourceId
                });
            }
        }
        // Process errors
        if (response.error) for (const errorResponse of response.error){
            // Extract resourceId from the returned blockAri
            const resourceId = $9b0c4608cd445e14$export$2837853885c81488(errorResponse.blockAri);
            if (!resourceId || !validResourceIds.has(resourceId)) continue;
            processedResourceIds.add(resourceId);
            results.push({
                error: {
                    type: $9b0c4608cd445e14$var$mapErrorResponseCode(errorResponse.code),
                    reason: errorResponse.reason
                },
                resourceId: resourceId
            });
        }
        // Ensure all resourceIds have a result - return NotFound for any missing ones
        for (const blockNodeIdentifier of blockNodeIdentifiers)if (!processedResourceIds.has(blockNodeIdentifier.resourceId)) results.push({
            error: {
                type: (0, $79ir6.SyncBlockError).NotFound
            },
            resourceId: blockNodeIdentifier.resourceId
        });
        return results;
    } catch (error) {
        if (error instanceof (0, $05aaK.BlockTimeoutError) && (0, $ieeJu.expValEquals)('platform_editor_sync_block_ssr_config', 'isEnabled', true)) return blockNodeIdentifiers.map((blockNodeIdentifier)=>({
                error: {
                    type: (0, $79ir6.SyncBlockError).Aborted,
                    reason: error.message
                },
                resourceId: blockNodeIdentifier.resourceId
            }));
        // If batch request fails, return error for all resourceIds. Capture the HTTP
        // status from `BlockError` so fetch analytics can break failures down by
        // statusCode (EDITOR-7862); undefined for non-HTTP failures. Thread the PII-safe
        // original message/name so the renderer can de-opaque the `errored` bucket.
        return blockNodeIdentifiers.map((blockNodeIdentifier)=>({
                error: {
                    type: error instanceof (0, $05aaK.BlockError) ? $9b0c4608cd445e14$var$mapBlockError(error) : (0, $79ir6.SyncBlockError).Errored,
                    reason: error.message,
                    ...error instanceof (0, $05aaK.BlockError) && {
                        statusCode: error.status
                    },
                    ...(0, $916Gd.getPiiSafeOriginalError)(error)
                },
                resourceId: blockNodeIdentifier.resourceId
            }));
    }
};
const $9b0c4608cd445e14$export$13b682467148f88a = async (cloudId, parentAri, parentId, product, data, stepVersion)=>{
    if (!parentAri || !parentId) return data.map((block)=>({
            error: (0, $79ir6.SyncBlockError).Errored,
            resourceId: block.resourceId
        }));
    try {
        // Create a map from blockAri to original resourceId for matching responses
        const blockAriToResourceIdMap = new Map();
        const blocks = data.map((block)=>{
            const blockAri = (0, $3xsB6.generateBlockAri)({
                cloudId: cloudId,
                parentId: parentId,
                product: product,
                resourceId: block.resourceId
            });
            blockAriToResourceIdMap.set(blockAri, block.resourceId);
            return {
                blockAri: blockAri,
                content: JSON.stringify(block.content),
                status: block.status,
                stepVersion: stepVersion
            };
        });
        const response = await (0, $05aaK.updateSyncedBlocks)({
            blocks: blocks
        });
        const results = [];
        // Process successful updates
        if (response.success) {
            const successResourceIds = new Set(response.success.map((block)=>blockAriToResourceIdMap.get(block.blockAri)));
            for (const block of data)if (successResourceIds.has(block.resourceId)) results.push({
                resourceId: block.resourceId
            });
        }
        if (response.error) {
            const errorResourceIds = new Map(response.error.map((err)=>[
                    // Use the map to get the original resourceId
                    blockAriToResourceIdMap.get(err.blockAri) || '',
                    $9b0c4608cd445e14$var$mapErrorResponseCode(err.code)
                ]));
            for (const block of data){
                const error = errorResourceIds.get(block.resourceId);
                if (error) results.push({
                    error: error,
                    resourceId: block.resourceId
                });
                else if (!results.some((r)=>r.resourceId === block.resourceId)) // If not in success or error lists, mark as errored
                results.push({
                    error: (0, $79ir6.SyncBlockError).Errored,
                    resourceId: block.resourceId
                });
            }
        }
        return results;
    } catch (error) {
        if (error instanceof (0, $05aaK.BlockError)) return data.map((block)=>({
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                resourceId: block.resourceId,
                statusCode: error.status
            }));
        return data.map((block)=>({
                error: (0, $916Gd.stringifyError)(error),
                resourceId: block.resourceId
            }));
    }
};

/**
 * ADFFetchProvider implementation that fetches synced block data from Block Service API
 */ class $9b0c4608cd445e14$var$BlockServiceADFFetchProvider {
    // resourceId of the reference synced block.
    // the ARI must be constructed to call the block service API
    async fetchData(resourceId) {
        const blockAri = (0, $3xsB6.generateBlockAriFromReference)({
            cloudId: this.cloudId,
            resourceId: resourceId
        });
        try {
            const blockContentResponse = await (0, $05aaK.getSyncedBlockContent)({
                blockAri: blockAri
            });
            const { content: content, sourceAri: sourceAri, deletionReason: deletionReason, blockInstanceId: blockInstanceId, contentUpdatedAt: contentUpdatedAt, product: product, status: status } = blockContentResponse;
            if (!content) return {
                error: {
                    type: (0, $79ir6.SyncBlockError).NotFound,
                    reason: deletionReason,
                    sourceAri: sourceAri
                },
                resourceId: resourceId
            };
            // Parse the synced block content from the response's content
            const syncedBlockData = JSON.parse(content);
            return {
                data: {
                    content: syncedBlockData,
                    resourceId: blockAri,
                    blockInstanceId: blockInstanceId,
                    // this was the node's localId, but has become the resourceId.
                    contentUpdatedAt: (0, $d04Ge.convertContentUpdatedAt)(contentUpdatedAt),
                    sourceAri: sourceAri,
                    product: product,
                    status: status,
                    deletionReason: deletionReason
                },
                resourceId: resourceId
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) // Capture the HTTP status so fetch analytics can break failures down by
            // statusCode (EDITOR-7862). Thread the PII-safe original message/name so
            // the renderer can de-opaque failures.
            return {
                error: {
                    type: $9b0c4608cd445e14$var$mapBlockError(error),
                    reason: error.message,
                    statusCode: error.status,
                    ...(0, $916Gd.getPiiSafeOriginalError)(error)
                },
                resourceId: resourceId
            };
            return {
                error: {
                    type: (0, $79ir6.SyncBlockError).Errored,
                    reason: error.message,
                    ...(0, $916Gd.getPiiSafeOriginalError)(error)
                },
                resourceId: resourceId
            };
        }
    }
    async fetchReferences(referenceResourceId) {
        try {
            const blockAri = (0, $3xsB6.generateBlockAriFromReference)({
                cloudId: this.cloudId,
                resourceId: referenceResourceId
            });
            const response = await (0, $05aaK.getReferenceSyncedBlocksByBlockAri)({
                blockAri: blockAri
            });
            const locationScopeOf = (documentAri)=>(0, $7GRSG.getFieldAwareLocationScope)({
                    documentAri: documentAri,
                    hostAri: this.parentAri,
                    productType: (0, $3xsB6.getProductFromSourceAri)(documentAri)
                });
            const references = [];
            response.references.forEach((reference)=>{
                references.push({
                    ...reference,
                    hasAccess: true,
                    onSameDocument: this.parentAri === reference.documentAri,
                    ...locationScopeOf(reference.documentAri)
                });
            });
            response.errors.forEach((reference)=>{
                if (reference.code === 'FORBIDDEN') references.push({
                    blockAri: reference.blockAri,
                    documentAri: reference.documentAri,
                    hasAccess: false,
                    onSameDocument: false,
                    ...locationScopeOf(reference.documentAri)
                });
            });
            return {
                references: references
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                error: $9b0c4608cd445e14$var$mapBlockError(error)
            };
            return {
                error: (0, $79ir6.SyncBlockError).Errored
            };
        }
    }
    /**
   * Batch fetches multiple synced blocks by their resource IDs.
   * @param blockNodeIdentifiers - Array of block node identifiers to fetch
   * @param config - Optional batch fetch configuration
   * @returns Array of SyncBlockInstance results
   */ async batchFetchData(blockNodeIdentifiers, config) {
        return await $9b0c4608cd445e14$export$abdcb5d4d6767e73(this.cloudId, this.parentAri, blockNodeIdentifiers, config);
    }
    /**
   * Subscribes to real-time updates for a specific block using GraphQL WebSocket subscriptions.
   * @param resourceId - The resource ID of the block to subscribe to
   * @param onUpdate - Callback function invoked when the block is updated
   * @param onError - Optional callback function invoked on subscription errors
   * @returns Unsubscribe function to stop receiving updates
   */ subscribeToBlockUpdates(resourceId, onUpdate, onError, onComplete) {
        const blockAri = (0, $3xsB6.generateBlockAriFromReference)({
            cloudId: this.cloudId,
            resourceId: resourceId
        });
        // Track the real unsubscribe fn once the dynamic import resolves
        let unsubscribe;
        let cancelled = false;
        // Dynamically import blockSubscription so that graphql-ws is NOT pulled
        // into the SSR/preload bundle that imports this subpath.
        (parcelRequire("ed90V")).then(({ subscribeToBlockUpdates: subscribeToBlockUpdatesWS })=>{
            if (cancelled) return;
            unsubscribe = subscribeToBlockUpdatesWS(blockAri, (parsedData)=>{
                // Convert ParsedBlockSubscriptionData to SyncBlockInstance
                const syncBlockInstance = {
                    data: {
                        content: parsedData.content,
                        resourceId: parsedData.blockAri,
                        blockInstanceId: parsedData.blockInstanceId,
                        sourceAri: parsedData.sourceAri,
                        product: parsedData.product,
                        createdAt: parsedData.createdAt,
                        contentUpdatedAt: parsedData.contentUpdatedAt,
                        createdBy: parsedData.createdBy,
                        status: parsedData.status
                    },
                    resourceId: parsedData.resourceId
                };
                onUpdate(syncBlockInstance);
            }, onError, onComplete);
        }).catch((err)=>{
            if (cancelled) return;
            onError?.(err instanceof Error ? err : new Error('Failed to load subscription module'));
        });
        // Return an unsubscribe fn that works whether the import has resolved or not
        return ()=>{
            cancelled = true;
            unsubscribe?.();
        };
    }
    constructor({ cloudId: cloudId, parentAri: parentAri }){
        this.cloudId = void 0;
        this.parentAri = void 0;
        this.cloudId = cloudId;
        this.parentAri = parentAri;
    }
}
/**
 * ADFWriteProvider implementation that writes synced block data to Block Service API
 */ class $9b0c4608cd445e14$var$BlockServiceADFWriteProvider {
    async writeData(data) {
        if (!this.parentAri || !this.parentId) return {
            error: (0, $79ir6.SyncBlockError).Errored
        };
        const { resourceId: resourceId } = data;
        const blockAri = (0, $3xsB6.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId,
            product: this.product,
            resourceId: resourceId
        });
        const stepVersion = this.getVersion ? await this.getVersion() : undefined;
        try {
            const status = data.status;
            await (0, $05aaK.updateSyncedBlock)({
                blockAri: blockAri,
                content: JSON.stringify(data.content),
                stepVersion: stepVersion,
                status: status
            });
            return {
                resourceId: resourceId
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                resourceId: resourceId,
                statusCode: error.status
            };
            return {
                error: (0, $916Gd.stringifyError)(error),
                resourceId: resourceId
            };
        }
    }
    async createData(data) {
        if (!this.parentAri || !this.parentId) return {
            error: (0, $79ir6.SyncBlockError).Errored
        };
        const { resourceId: resourceId } = data;
        const blockAri = (0, $3xsB6.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId,
            product: this.product,
            resourceId: resourceId
        });
        const stepVersion = this.getVersion ? await this.getVersion() : undefined;
        const status = 'unpublished';
        try {
            await (0, $05aaK.createSyncedBlock)({
                blockAri: blockAri,
                blockInstanceId: data.blockInstanceId,
                sourceAri: this.parentAri,
                product: this.product,
                content: JSON.stringify(data.content),
                stepVersion: stepVersion,
                status: status
            });
            return {
                resourceId: resourceId
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                resourceId: resourceId,
                statusCode: error.status
            };
            return {
                error: (0, $916Gd.stringifyError)(error),
                resourceId: resourceId
            };
        }
    }
    // soft deletes the source synced block
    async deleteData(resourceId, deleteReason) {
        if (!this.parentId) return {
            resourceId: resourceId,
            success: false,
            error: (0, $79ir6.SyncBlockError).Errored
        };
        const blockAri = (0, $3xsB6.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId,
            product: this.product,
            resourceId: resourceId
        });
        try {
            await (0, $05aaK.deleteSyncedBlock)({
                blockAri: blockAri,
                deleteReason: deleteReason
            });
            return {
                resourceId: resourceId,
                success: true,
                error: undefined
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockNotFoundError) && this.parentAri) return this.deleteOrphanBlock({
                blockAri: blockAri,
                resourceId: resourceId,
                parentAri: this.parentAri,
                deleteReason: deleteReason
            });
            if (error instanceof (0, $05aaK.BlockError)) {
                if (error.status === 404) // User should not be blocked by not_found error when deleting,
                // hence returns successful result for 404 error
                return {
                    resourceId: resourceId,
                    success: true
                };
                return {
                    resourceId: resourceId,
                    success: false,
                    error: $9b0c4608cd445e14$var$mapBlockError(error),
                    statusCode: error.status
                };
            }
            return {
                resourceId: resourceId,
                success: false,
                error: (0, $916Gd.stringifyError)(error)
            };
        }
    }
    // The block is an orphan (e.g. from a copied page) — it doesn't exist in Block Service.
    // Block Service uses soft-deletes, so we must first create the block then delete it,
    // ensuring a deletion-reason record is stored (used to display errors in reference blocks).
    async deleteOrphanBlock({ blockAri: blockAri, resourceId: resourceId, parentAri: parentAri, deleteReason: deleteReason }) {
        try {
            const stepVersion = this.getVersion ? await this.getVersion() : undefined;
            try {
                await (0, $05aaK.createSyncedBlock)({
                    blockAri: blockAri,
                    blockInstanceId: resourceId,
                    sourceAri: parentAri,
                    product: this.product,
                    content: '[]',
                    stepVersion: stepVersion
                });
            } catch (createError) {
                // "Conditional check failed" means the block already exists in Block Service.
                // This can happen when an orphan block is copied and pasted — a reference block repair
                // in the backend may have already created it. We can proceed directly to delete it.
                if (createError instanceof Error && createError.message.includes('Conditional check failed')) ;
                else if (createError instanceof (0, $05aaK.BlockError)) return {
                    resourceId: resourceId,
                    success: false,
                    error: $9b0c4608cd445e14$var$mapBlockError(createError),
                    statusCode: createError.status
                };
                else return {
                    resourceId: resourceId,
                    success: false,
                    error: (0, $916Gd.stringifyError)(createError)
                };
            }
            await (0, $05aaK.deleteSyncedBlock)({
                blockAri: blockAri,
                deleteReason: deleteReason
            });
            return {
                resourceId: resourceId,
                success: true,
                error: undefined
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                resourceId: resourceId,
                success: false,
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                statusCode: error.status
            };
            return {
                resourceId: resourceId,
                success: false,
                error: (0, $916Gd.stringifyError)(error)
            };
        }
    }
    // the sourceId is the resourceId of the source synced block.
    generateResourceIdForReference(sourceId) {
        return (0, $cuwGS.createResourceIdForReference)(this.product, this.parentId || '', sourceId);
    }
    generateResourceId() {
        return crypto.randomUUID();
    }
    generateBlockAri(resourceId) {
        return (0, $3xsB6.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId || '',
            product: this.product,
            resourceId: resourceId
        });
    }
    async updateReferenceData(blocks, noContent) {
        if (!this.parentAri) return {
            success: false,
            error: (0, $79ir6.SyncBlockError).Errored
        };
        try {
            await (0, $05aaK.updateReferenceSyncedBlockOnDocument)({
                documentAri: this.parentAri,
                blocks: blocks.map((block)=>({
                        blockAri: (0, $3xsB6.generateBlockAriFromReference)({
                            cloudId: this.cloudId,
                            resourceId: block.resourceId
                        }),
                        blockInstanceId: block.localId
                    })),
                noContent: noContent
            });
            return {
                success: true
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                success: false,
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                statusCode: error.status
            };
            return {
                success: false,
                error: (0, $916Gd.stringifyError)(error)
            };
        }
    }
    async writeDataBatch(data) {
        if (!this.parentAri || !this.parentId) return data.map((block)=>({
                error: (0, $79ir6.SyncBlockError).Errored,
                resourceId: block.resourceId
            }));
        const stepVersion = this.getVersion ? await this.getVersion() : undefined;
        try {
            // Create a map from blockAri to original resourceId for matching responses
            const blockAriToResourceIdMap = new Map();
            const blocks = data.map((block)=>{
                const blockAri = this.generateBlockAri(block.resourceId);
                blockAriToResourceIdMap.set(blockAri, block.resourceId);
                return {
                    blockAri: blockAri,
                    content: JSON.stringify(block.content),
                    status: block.status,
                    stepVersion: stepVersion
                };
            });
            const response = await (0, $05aaK.updateSyncedBlocks)({
                blocks: blocks
            });
            const results = [];
            // Process successful updates
            if (response.success) {
                const successBlocks = new Map(response.success.map((block)=>[
                        blockAriToResourceIdMap.get(block.blockAri),
                        block
                    ]));
                for (const block of data){
                    const successBlock = successBlocks.get(block.resourceId);
                    if (successBlock) results.push({
                        resourceId: block.resourceId,
                        status: successBlock.status
                    });
                }
            }
            if (response.error) {
                const errorResourceIds = new Map(response.error.map((err)=>[
                        // Use the map to get the original resourceId
                        blockAriToResourceIdMap.get(err.blockAri) || '',
                        $9b0c4608cd445e14$var$mapErrorResponseCode(err.code)
                    ]));
                for (const block of data){
                    const error = errorResourceIds.get(block.resourceId);
                    if (error) {
                        if (error !== (0, $79ir6.SyncBlockError).NotFound) results.push({
                            error: error,
                            resourceId: block.resourceId
                        });
                    } else if (!results.some((r)=>r.resourceId === block.resourceId)) // If not in success or error lists, mark as errored
                    results.push({
                        error: (0, $79ir6.SyncBlockError).Errored,
                        resourceId: block.resourceId
                    });
                }
            }
            return results;
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return data.map((block)=>({
                    error: $9b0c4608cd445e14$var$mapBlockError(error),
                    resourceId: block.resourceId,
                    statusCode: error.status
                }));
            return data.map((block)=>({
                    error: (0, $916Gd.stringifyError)(error),
                    resourceId: block.resourceId
                }));
        }
    }
    constructor({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product, getVersion: getVersion }){
        this.cloudId = void 0;
        this.parentId = void 0;
        this.getVersion = void 0;
        this.product = void 0;
        this.parentAri = void 0;
        this.cloudId = cloudId;
        this.parentAri = parentAri;
        this.parentId = parentId;
        this.product = product;
        this.getVersion = getVersion;
    }
}
const $9b0c4608cd445e14$var$createBlockServiceAPIProviders = ({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product, getVersion: getVersion })=>{
    return {
        fetchProvider: new $9b0c4608cd445e14$var$BlockServiceADFFetchProvider({
            cloudId: cloudId,
            parentAri: parentAri
        }),
        writeProvider: new $9b0c4608cd445e14$var$BlockServiceADFWriteProvider({
            cloudId: cloudId,
            parentAri: parentAri,
            parentId: parentId,
            product: product,
            getVersion: getVersion
        })
    };
};
const $9b0c4608cd445e14$export$ec654f5ac7e6d976 = ({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product, getVersion: getVersion })=>{
    return (0, $cozmU.useMemo)(()=>{
        return $9b0c4608cd445e14$var$createBlockServiceAPIProviders({
            cloudId: cloudId,
            parentAri: parentAri,
            parentId: parentId,
            product: product,
            getVersion: getVersion
        });
    }, [
        cloudId,
        parentAri,
        parentId,
        product,
        getVersion
    ]);
};
const $9b0c4608cd445e14$var$createBlockServiceFetchOnlyAPIProvider = ({ cloudId: cloudId, parentAri: parentAri })=>{
    return {
        fetchProvider: new $9b0c4608cd445e14$var$BlockServiceADFFetchProvider({
            cloudId: cloudId,
            parentAri: parentAri
        }),
        writeProvider: undefined
    };
};
const $9b0c4608cd445e14$export$1e67317f82b65067 = ({ cloudId: cloudId, parentAri: parentAri })=>(0, $cozmU.useMemo)(()=>$9b0c4608cd445e14$var$createBlockServiceFetchOnlyAPIProvider({
            cloudId: cloudId,
            parentAri: parentAri
        }), [
        cloudId,
        parentAri
    ]);
module.exports["batchFetchData"] = $9b0c4608cd445e14$export$abdcb5d4d6767e73;
module.exports["useMemoizedBlockServiceAPIProviders"] = $9b0c4608cd445e14$export$ec654f5ac7e6d976;

});

parcelRegister("3xsB6", function(module, exports) {
/* eslint-disable require-unicode-regexp */ 
var $EBNuL = parcelRequire("EBNuL");

const $a2c616dead6b3b85$var$GET_LOCAL_ID_FROM_BLOCK_RESOURCE_ID_REGEX = /ari:cloud:blocks:[^:]+:synced-block\/([a-zA-Z0-9-]+)/;
const $a2c616dead6b3b85$var$JIRA_SOURCE_ARI_REGEX = /ari:cloud:jira:.*/;
const $a2c616dead6b3b85$var$CONFLUENCE_SOURCE_ARI_REGEX = /ari:cloud:confluence:.*/;
const $a2c616dead6b3b85$export$e79189cdb9940bc5 = ({ cloudId: cloudId, parentId: parentId, product: product, resourceId: resourceId })=>{
    return `ari:cloud:blocks:${cloudId}:synced-block/${product}/${parentId}/${resourceId}`;
};
const $a2c616dead6b3b85$export$92a2331f8a9ed841 = ({ cloudId: cloudId, resourceId: resourceId })=>{
    return `ari:cloud:blocks:${cloudId}:synced-block/${resourceId}`;
};
const $a2c616dead6b3b85$export$3f0878b0afe5a2c0 = (ari)=>{
    const match = ari.match($a2c616dead6b3b85$var$GET_LOCAL_ID_FROM_BLOCK_RESOURCE_ID_REGEX);
    if (match?.[1]) return match[1];
    throw new Error(`Invalid block ARI: ${ari}`);
};
const $a2c616dead6b3b85$export$36d45714d1e88dec = ({ documentAri: documentAri, hostAri: hostAri })=>{
    if (documentAri === hostAri) return 'same-document';
    const location = (0, $EBNuL.parseJiraFieldLocation)({
        ari: documentAri
    });
    const hostLocation = (0, $EBNuL.parseJiraFieldLocation)({
        ari: hostAri
    });
    if (!location || !hostLocation || location.issueAri !== hostLocation.issueAri) return 'elsewhere';
    return location.fieldId === hostLocation.fieldId ? 'same-document' : 'same-parent-document';
};
const $a2c616dead6b3b85$export$c10656f449ea0fb5 = (ari)=>{
    const jiraMatch = ari?.search($a2c616dead6b3b85$var$JIRA_SOURCE_ARI_REGEX);
    if (jiraMatch !== -1) return 'jira-work-item';
    const confluenceMatch = ari?.search($a2c616dead6b3b85$var$CONFLUENCE_SOURCE_ARI_REGEX);
    if (confluenceMatch !== -1) return 'confluence-page';
    return undefined;
};
module.exports["generateBlockAri"] = $a2c616dead6b3b85$export$e79189cdb9940bc5;
module.exports["generateBlockAriFromReference"] = $a2c616dead6b3b85$export$92a2331f8a9ed841;
module.exports["getLocationScope"] = $a2c616dead6b3b85$export$36d45714d1e88dec;
module.exports["getProductFromSourceAri"] = $a2c616dead6b3b85$export$c10656f449ea0fb5;

});

parcelRegister("EBNuL", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $059546548da04295$var$JIRA_WORK_ITEM_ARI_REGEX = /ari:cloud:jira:([^:]+):issue\/(\d+)/;
const $059546548da04295$var$JIRA_ISSUE_FIELD_VALUE_ARI_REGEX = /ari:cloud:jira:([^:]+):issuefieldvalue\/([^/]+)\/([^/]+)/;
const $059546548da04295$export$e7d6f26185793d4f = ({ cloudId: cloudId, workItemId: workItemId })=>{
    return `ari:cloud:jira:${cloudId}:issue/${workItemId}`;
};
const $059546548da04295$var$getFieldValueAriParts = (ari)=>{
    const match = ari.match($059546548da04295$var$JIRA_ISSUE_FIELD_VALUE_ARI_REGEX);
    if (match?.[1] && match[2] && match[3]) return {
        cloudId: match[1],
        issueId: match[2],
        fieldId: match[3]
    };
    return undefined;
};
const $059546548da04295$export$3ee1e41ffca0b1ff = ({ ari: ari })=>{
    const match = ari.match($059546548da04295$var$JIRA_WORK_ITEM_ARI_REGEX);
    if (match?.[2]) return match[2];
    const fieldValueParts = $059546548da04295$var$getFieldValueAriParts(ari);
    if (fieldValueParts) return fieldValueParts.issueId;
    throw new Error(`Invalid Jira work item ARI: ${ari}`);
};
const $059546548da04295$export$9d29a8e91440be5c = ({ ari: ari })=>{
    const fieldValueParts = $059546548da04295$var$getFieldValueAriParts(ari);
    if (fieldValueParts) return $059546548da04295$export$e7d6f26185793d4f({
        cloudId: fieldValueParts.cloudId,
        workItemId: fieldValueParts.issueId
    });
    return ari;
};
const $059546548da04295$var$JIRA_DESCRIPTION_FIELD_ID = 'description';
const $059546548da04295$var$toJiraFieldLocation = ({ cloudId: cloudId, fieldId: fieldId, issueId: issueId })=>({
        fieldId: fieldId,
        issueAri: $059546548da04295$export$e7d6f26185793d4f({
            cloudId: cloudId,
            workItemId: issueId
        })
    });
const $059546548da04295$export$decd92eb8dd00bf5 = ({ ari: ari })=>{
    const workItemMatch = ari.match($059546548da04295$var$JIRA_WORK_ITEM_ARI_REGEX);
    if (workItemMatch?.[1] && workItemMatch[2]) return $059546548da04295$var$toJiraFieldLocation({
        cloudId: workItemMatch[1],
        fieldId: $059546548da04295$var$JIRA_DESCRIPTION_FIELD_ID,
        issueId: workItemMatch[2]
    });
    const fieldValueParts = $059546548da04295$var$getFieldValueAriParts(ari);
    return fieldValueParts && $059546548da04295$var$toJiraFieldLocation(fieldValueParts);
};
module.exports["getJiraIssueAriFromSourceAri"] = $059546548da04295$export$9d29a8e91440be5c;
module.exports["parseJiraFieldLocation"] = $059546548da04295$export$decd92eb8dd00bf5;

});

parcelRegister("05aaK", function(module, exports) {

var $48FpT = parcelRequire("48FpT");

const $59e004c7d849e8bb$export$f426a9918d7f49b3 = (response)=>{
    const content = response.content;
    return typeof content === 'string';
};
const $59e004c7d849e8bb$export$571f6abc3f4e5951 = async (documentAri)=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildGetDocumentReferenceBlocksQuery(documentAri),
        operationName: $59e004c7d849e8bb$var$GET_DOCUMENT_REFERENCE_BLOCKS_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockGetDocumentReferenceBlocks`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data) throw new Error('No data returned from GraphQL query');
    return result.data.blockService_getDocumentReferenceBlocks;
};
const $59e004c7d849e8bb$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $59e004c7d849e8bb$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $59e004c7d849e8bb$var$GET_DOCUMENT_REFERENCE_BLOCKS_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_DOCUMENT_REFERENCE_BLOCKS';
const $59e004c7d849e8bb$var$UPDATE_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_UPDATE_BLOCK';
const $59e004c7d849e8bb$var$DELETE_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_DELETE_BLOCK';
const $59e004c7d849e8bb$var$CREATE_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_CREATE_BLOCK';
const $59e004c7d849e8bb$var$UPDATE_DOCUMENT_REFERENCES_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_UPDATE_DOCUMENT_REFERENCES';
const $59e004c7d849e8bb$var$BATCH_RETRIEVE_BLOCKS_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_BATCH_RETRIEVE_BLOCKS';
const $59e004c7d849e8bb$var$GET_BLOCK_REFERENCES_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_REFERENCES';
const $59e004c7d849e8bb$var$GET_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_BLOCK';
const $59e004c7d849e8bb$var$BATCH_UPDATE_BLOCKS_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_BATCH_UPDATE_BLOCKS';
const $59e004c7d849e8bb$var$buildGetDocumentReferenceBlocksQuery = (documentAri)=>`query ${$59e004c7d849e8bb$var$GET_DOCUMENT_REFERENCE_BLOCKS_OPERATION_NAME} {
	blockService_getDocumentReferenceBlocks(documentAri: ${JSON.stringify(documentAri)}) {
		blocks {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			product
			sourceAri
			status
			version
		}
		errors {
			blockAri
			code
			reason
		}
	}
}`;
const $59e004c7d849e8bb$var$buildGetBlockQuery = (blockAri)=>`query ${$59e004c7d849e8bb$var$GET_BLOCK_OPERATION_NAME} {
	blockService_getBlock(blockAri: ${JSON.stringify(blockAri)}) {
		blockAri
		blockInstanceId
		content
		contentUpdatedAt
		createdAt
		createdBy
		deletionReason
		product
		sourceAri
		status
		version
	}
}`;
const $59e004c7d849e8bb$var$buildUpdateBlockMutation = (blockAri, content, stepVersion, status)=>{
    const inputParts = [
        `blockAri: ${JSON.stringify(blockAri)}`,
        `content: ${JSON.stringify(content)}`
    ];
    if (stepVersion !== undefined) inputParts.push(`stepVersion: ${stepVersion}`);
    if (status !== undefined) inputParts.push(`status: ${JSON.stringify(status)}`);
    const inputArgs = inputParts.join(', ');
    return `mutation ${$59e004c7d849e8bb$var$UPDATE_BLOCK_OPERATION_NAME} {
	blockService_updateBlock(input: { ${inputArgs} }) {
		__typename
	}
}`;
};
const $59e004c7d849e8bb$var$buildDeleteBlockMutation = (blockAri, deletionReason)=>{
    const inputParts = [
        `blockAri: ${JSON.stringify(blockAri)}`
    ];
    if (deletionReason !== undefined) inputParts.push(`deletionReason: ${JSON.stringify(deletionReason)}`);
    const inputArgs = inputParts.join(', ');
    return `mutation ${$59e004c7d849e8bb$var$DELETE_BLOCK_OPERATION_NAME} {
	blockService_deleteBlock(input: { ${inputArgs} }) {
		deleted
	}
}`;
};
/**
 * Converts product string to GraphQL enum format
 * 'confluence-page' -> 'CONFLUENCE_PAGE'
 * 'jira-work-item' -> 'JIRA_WORK_ITEM'
 */ const $59e004c7d849e8bb$var$convertProductToGraphQLEnum = (product)=>{
    switch(product){
        case 'confluence-page':
            return 'CONFLUENCE_PAGE';
        case 'jira-work-item':
            return 'JIRA_WORK_ITEM';
        default:
            {
                const exhaustiveCheck = product;
                throw new Error(`Unsupported product: ${exhaustiveCheck}`);
            }
    }
};
const $59e004c7d849e8bb$var$buildCreateBlockMutation = (blockAri, blockInstanceId, content, product, sourceAri, stepVersion, status)=>{
    const inputParts = [
        `blockAri: ${JSON.stringify(blockAri)}`,
        `blockInstanceId: ${JSON.stringify(blockInstanceId)}`,
        `content: ${JSON.stringify(content)}`,
        `product: ${$59e004c7d849e8bb$var$convertProductToGraphQLEnum(product)}`,
        `sourceAri: ${JSON.stringify(sourceAri)}`
    ];
    if (stepVersion !== undefined) inputParts.push(`stepVersion: ${stepVersion}`);
    if (status !== undefined) inputParts.push(`status: ${JSON.stringify(status)}`);
    const inputArgs = inputParts.join(', ');
    return `mutation ${$59e004c7d849e8bb$var$CREATE_BLOCK_OPERATION_NAME} {
	blockService_createBlock(input: { ${inputArgs} }) {
		blockAri
		blockInstanceId
		content
		contentUpdatedAt
		createdAt
		createdBy
		deletionReason
		product
		sourceAri
		status
		version
	}
}`;
};
const $59e004c7d849e8bb$var$buildUpdateDocumentReferencesMutation = (documentAri, blocks, noContent)=>{
    const blocksArray = blocks.map((block)=>`{ blockAri: ${JSON.stringify(block.blockAri)}, blockInstanceId: ${JSON.stringify(block.blockInstanceId)} }`).join(', ');
    const inputArgs = `documentAri: ${JSON.stringify(documentAri)}, blocks: [${blocksArray}], noContent: ${noContent}`;
    return `mutation ${$59e004c7d849e8bb$var$UPDATE_DOCUMENT_REFERENCES_OPERATION_NAME} {
	blockService_updateDocumentReferences(input: { ${inputArgs} }) {
		blocks {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			product
			sourceAri
			status
			version
		}
		errors {
			blockAri
			code
			reason
		}
	}
}`;
};
const $59e004c7d849e8bb$var$buildBatchRetrieveBlocksQuery = (blockAris)=>{
    const blockArisArray = blockAris.map((ari)=>JSON.stringify(ari)).join(', ');
    const inputArgs = `blockAris: [${blockArisArray}]`;
    return `query ${$59e004c7d849e8bb$var$BATCH_RETRIEVE_BLOCKS_OPERATION_NAME} {
	blockService_batchRetrieveBlocks(input: { ${inputArgs} }) {
		success {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			deletionReason
			product
			sourceAri
			status
			version
		}
		error {
			blockAri
			code
			reason
		}
	}
}`;
};
const $59e004c7d849e8bb$var$buildGetBlockReferencesQuery = (blockAri)=>{
    return `query ${$59e004c7d849e8bb$var$GET_BLOCK_REFERENCES_OPERATION_NAME} {
	blockService_getReferences(blockAri: ${JSON.stringify(blockAri)}) {
		references {
			blockAri
			blockInstanceId
			createdAt
			createdBy
			documentAri
		}
		errors {
			blockAri
			code
			reason
		}
	}
}`;
};
const $59e004c7d849e8bb$var$buildBatchUpdateBlocksMutation = (blocks)=>{
    const blocksArray = blocks.map((block)=>{
        const inputParts = [
            `blockAri: ${JSON.stringify(block.blockAri)}`,
            `content: ${JSON.stringify(block.content)}`
        ];
        if (block.stepVersion !== undefined) inputParts.push(`stepVersion: ${block.stepVersion}`);
        if (block.status !== undefined) inputParts.push(`status: ${JSON.stringify(block.status)}`);
        return `{ ${inputParts.join(', ')} }`;
    }).join(', ');
    return `mutation ${$59e004c7d849e8bb$var$BATCH_UPDATE_BLOCKS_OPERATION_NAME} {
	blockService_batchUpdateBlocks(input: { blocks: [${blocksArray}] }) {
		success {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			deletionReason
			product
			sourceAri
			status
			version
		}
		error {
			blockAri
			code
			reason
		}
	}
}`;
};
class $59e004c7d849e8bb$export$e47a0a94b0998697 extends Error {
    constructor(status){
        super(`Block error`), this.status = status;
    }
}
class $59e004c7d849e8bb$export$f5a00468af285e38 extends Error {
    constructor(){
        super('Block not found in Block Service');
        this.name = 'BlockNotFoundError';
    }
}
class $59e004c7d849e8bb$export$b5687000eb0902be extends Error {
    constructor(){
        super('Block request timed out');
        this.name = 'BlockTimeoutError';
    }
}
const $59e004c7d849e8bb$export$fab66d51cc0c1a7 = async ({ blockAri: blockAri })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildGetBlockQuery(blockAri),
        operationName: $59e004c7d849e8bb$var$GET_BLOCK_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockGetBlock`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_getBlock) throw new Error('No data returned from GraphQL query');
    return result.data.blockService_getBlock;
};
const $59e004c7d849e8bb$export$48a4f565308f4741 = async ({ blockIdentifiers: blockIdentifiers, config: config })=>{
    const blockAris = blockIdentifiers.map((blockIdentifier)=>blockIdentifier.blockAri);
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildBatchRetrieveBlocksQuery(blockAris),
        operationName: $59e004c7d849e8bb$var$BATCH_RETRIEVE_BLOCKS_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockBatchRetrieveBlocks`;
    // undefined or 0 or negative means no timeout,
    // We don't enforce a minimum timeout for simplicity
    const fetchPromise = (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    const timeoutMs = config?.timeoutMs ?? 0;
    const response = await (timeoutMs > 0 ? Promise.race([
        fetchPromise,
        new Promise((_, reject)=>setTimeout(()=>reject(new $59e004c7d849e8bb$export$b5687000eb0902be()), timeoutMs))
    ]) : fetchPromise);
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_batchRetrieveBlocks) throw new Error('No data returned from GraphQL query');
    const graphqlResponse = result.data.blockService_batchRetrieveBlocks;
    return {
        success: graphqlResponse.success,
        error: graphqlResponse.error
    };
};
const $59e004c7d849e8bb$export$cbbc86409cac3ee5 = async ({ blockAri: blockAri, deleteReason: deleteReason })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildDeleteBlockMutation(blockAri, deleteReason),
        operationName: $59e004c7d849e8bb$var$DELETE_BLOCK_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockDeleteBlock`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) {
        const allNotFound = result.errors.every((e)=>e.extensions?.errorType === 'RESOURCE_NOT_FOUND');
        if (allNotFound) // Throw BlockNotFoundError so the caller can create the block first then retry the delete.
        // Block Service uses soft-deletes: the entry must exist before deletion so a deletion-reason
        // is stored (used to display errors in reference blocks).
        throw new $59e004c7d849e8bb$export$f5a00468af285e38();
        throw new Error(result.errors.map((e)=>e.message).join(', '));
    }
    const isDeleted = result.data?.blockService_deleteBlock?.deleted;
    if (!isDeleted) throw new Error('Block deletion failed; deleted flag is false');
};
const $59e004c7d849e8bb$export$d5bf0c5618431e5e = async ({ blockAri: blockAri, content: content, stepVersion: stepVersion, status: status })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildUpdateBlockMutation(blockAri, content, stepVersion, status),
        operationName: $59e004c7d849e8bb$var$UPDATE_BLOCK_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockUpdateBlock`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
};
const $59e004c7d849e8bb$export$fbc30658d812c800 = async ({ blockAri: blockAri, blockInstanceId: blockInstanceId, sourceAri: sourceAri, product: product, content: content, stepVersion: stepVersion, status: status })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildCreateBlockMutation(blockAri, blockInstanceId, content, product, sourceAri, stepVersion, status),
        operationName: $59e004c7d849e8bb$var$CREATE_BLOCK_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockCreateBlock`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_createBlock) throw new Error('No data returned from GraphQL mutation');
    return result.data.blockService_createBlock;
};
const $59e004c7d849e8bb$export$59c7369fa04bcba1 = async ({ documentAri: documentAri, blocks: blocks, noContent: noContent = true })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildUpdateDocumentReferencesMutation(documentAri, blocks, noContent),
        operationName: $59e004c7d849e8bb$var$UPDATE_DOCUMENT_REFERENCES_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockUpdateDocumentReferences`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData),
        keepalive: true
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!noContent) {
        if (!result.data?.blockService_updateDocumentReferences) throw new Error('No data returned from GraphQL mutation');
        return result.data.blockService_updateDocumentReferences;
    }
};
const $59e004c7d849e8bb$export$75f5aeff9ce22a33 = async ({ blockAri: blockAri })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildGetBlockReferencesQuery(blockAri),
        operationName: $59e004c7d849e8bb$var$GET_BLOCK_REFERENCES_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockGetReferences`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_getReferences) throw new Error('No data returned from GraphQL query');
    const graphqlResponse = result.data.blockService_getReferences;
    return {
        blockAri: blockAri,
        references: graphqlResponse.references || [],
        errors: graphqlResponse.errors || []
    };
};
const $59e004c7d849e8bb$export$a9e53fa4329b5ed2 = async ({ blocks: blocks })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildBatchUpdateBlocksMutation(blocks),
        operationName: $59e004c7d849e8bb$var$BATCH_UPDATE_BLOCKS_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockBatchUpdateBlocks`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_batchUpdateBlocks) throw new Error('No data returned from GraphQL mutation');
    const graphqlResponse = result.data.blockService_batchUpdateBlocks;
    return {
        success: graphqlResponse.success,
        error: graphqlResponse.error
    };
};
module.exports["getReferenceSyncedBlocks"] = $59e004c7d849e8bb$export$571f6abc3f4e5951;
module.exports["BlockError"] = $59e004c7d849e8bb$export$e47a0a94b0998697;
module.exports["BlockNotFoundError"] = $59e004c7d849e8bb$export$f5a00468af285e38;
module.exports["BlockTimeoutError"] = $59e004c7d849e8bb$export$b5687000eb0902be;
module.exports["getSyncedBlockContent"] = $59e004c7d849e8bb$export$fab66d51cc0c1a7;
module.exports["batchRetrieveSyncedBlocks"] = $59e004c7d849e8bb$export$48a4f565308f4741;
module.exports["deleteSyncedBlock"] = $59e004c7d849e8bb$export$cbbc86409cac3ee5;
module.exports["updateSyncedBlock"] = $59e004c7d849e8bb$export$d5bf0c5618431e5e;
module.exports["createSyncedBlock"] = $59e004c7d849e8bb$export$fbc30658d812c800;
module.exports["updateReferenceSyncedBlockOnDocument"] = $59e004c7d849e8bb$export$59c7369fa04bcba1;
module.exports["getReferenceSyncedBlocksByBlockAri"] = $59e004c7d849e8bb$export$75f5aeff9ce22a33;
module.exports["updateSyncedBlocks"] = $59e004c7d849e8bb$export$a9e53fa4329b5ed2;

});

parcelRegister("48FpT", function(module, exports) {
const $fc075454b76b2577$var$MAX_RETRY_DELAY = 30000;
const $fc075454b76b2577$var$parseRetryAfter = (retryAfter)=>{
    // retryAfter can either be in seconds or HTTP date
    const parsedRetryAfter = parseInt(retryAfter, 10);
    if (!isNaN(parsedRetryAfter) && parsedRetryAfter > 0) return parsedRetryAfter * 1000;
    const retryDate = new Date(retryAfter);
    if (isNaN(retryDate.getTime())) return undefined;
    const delayFromDate = retryDate.getTime() - Date.now();
    if (delayFromDate > 0) return delayFromDate;
    return undefined;
};
const $fc075454b76b2577$export$cffaac380b94df26 = async (url, options, retriesRemaining = 3, delay = 1000)=>{
    const response = await fetch(url, options);
    const shouldRetry = !response.ok && response.status === 429 && retriesRemaining > 1;
    if (!shouldRetry) return response;
    const retryAfter = response.headers.get('Retry-After');
    const parsedDelay = (retryAfter ? $fc075454b76b2577$var$parseRetryAfter(retryAfter) : undefined) ?? delay;
    const retryDelay = Math.min(parsedDelay, $fc075454b76b2577$var$MAX_RETRY_DELAY);
    await new Promise((resolve)=>setTimeout(resolve, retryDelay));
    return $fc075454b76b2577$export$cffaac380b94df26(url, options, retriesRemaining - 1, delay * 2);
};
module.exports["fetchWithRetry"] = $fc075454b76b2577$export$cffaac380b94df26;

});

parcelRegister("79ir6", function(module, exports) {
var $2ca041ce04439e9b$export$686dd843fdf311d4 = /*#__PURE__*/ function(SyncBlockError) {
    SyncBlockError["Errored"] = "errored";
    SyncBlockError["NotFound"] = "not_found";
    SyncBlockError["Forbidden"] = "forbidden";
    SyncBlockError["InvalidRequest"] = "invalid_request";
    SyncBlockError["RateLimited"] = "rate_limited";
    SyncBlockError["Conflict"] = "conflict";
    // attempt to create block that already exists
    SyncBlockError["ServerError"] = "server_error";
    SyncBlockError["InvalidContent"] = "invalid_content";
    // content is not a valid JSON
    SyncBlockError["Offline"] = "offline";
    SyncBlockError["Unpublished"] = "unpublished";
    // request was aborted, typically due to client timeout
    SyncBlockError["Aborted"] = "aborted";
    // block does not exist on this site (e.g. cross-site reference or hard deleted)
    SyncBlockError["EntityNotFound"] = "entity_not_found";
    return SyncBlockError;
}({});
const $2ca041ce04439e9b$export$7486a7adf8b0d591 = 'Data provider not set';
class $2ca041ce04439e9b$export$ca0858d4f5eeeac extends Error {
    constructor(message = $2ca041ce04439e9b$export$7486a7adf8b0d591){
        super(message);
        this.isProviderNotReadyError = true;
        this.name = 'ProviderNotReadyError';
        // Restore prototype chain so instanceof works after transpilation.
        Object.setPrototypeOf(this, $2ca041ce04439e9b$export$ca0858d4f5eeeac.prototype);
    }
}
const $2ca041ce04439e9b$export$7ba508051f94701f = (error)=>{
    if (error instanceof $2ca041ce04439e9b$export$ca0858d4f5eeeac) return true;
    if (typeof error === 'object' && error !== null && error.isProviderNotReadyError === true) return true;
    return error instanceof Error && error.message === $2ca041ce04439e9b$export$7486a7adf8b0d591;
};
module.exports["SyncBlockError"] = $2ca041ce04439e9b$export$686dd843fdf311d4;
module.exports["ProviderNotReadyError"] = $2ca041ce04439e9b$export$ca0858d4f5eeeac;
module.exports["isProviderNotReadyError"] = $2ca041ce04439e9b$export$7ba508051f94701f;

});

parcelRegister("916Gd", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $79ir6 = parcelRequire("79ir6");

const $5f570f8dd9ccb4e4$export$7fc2c997455452c8 = (error)=>{
    try {
        return JSON.stringify(error);
    } catch  {
        return undefined;
    }
};
const $5f570f8dd9ccb4e4$export$74ce7fda6da1109 = (error)=>{
    if (error instanceof Error) return {
        ...error.message && {
            originalMessage: error.message
        },
        ...error.name && {
            originalName: error.name
        }
    };
    return {};
};
const $5f570f8dd9ccb4e4$var$SYNC_BLOCK_ERROR_REASONS = new Set(Object.values((0, $79ir6.SyncBlockError)));
const $5f570f8dd9ccb4e4$export$3bf11deac13e0617 = (error)=>{
    if (error && $5f570f8dd9ccb4e4$var$SYNC_BLOCK_ERROR_REASONS.has(error)) return error;
    return 'unknown';
};
const $5f570f8dd9ccb4e4$export$78792f4ddc3998e8 = (error, statusCode)=>{
    return {
        reason: $5f570f8dd9ccb4e4$export$3bf11deac13e0617(error),
        ...statusCode !== undefined && {
            statusCode: statusCode
        }
    };
};
const $5f570f8dd9ccb4e4$export$9bd766f5cc31fe3b = new Set([
    'source_deleted',
    'source_unpublished',
    'source_unsynced',
    'source_not_found',
    'permission_denied',
    'unauthenticated',
    // Mirror the benign write-path enum equivalents so already-classified errors are
    // treated consistently.
    'not_found',
    'forbidden',
    'unpublished',
    // `offline` is an expected client connectivity state, not a read-path system failure:
    // the error component is rendered for the offline experience, so it should not inflate
    // the true error rate. It still emits `reason` (so its volume can be inspected) but is
    // excluded from true-error counts.
    'offline'
]);
/**
 * Ordered list of substring matchers mapping known free-text fetch/subscribe error
 * strings to a categorical {@link SyncBlockFetchErrorReason}. Each entry is a list of
 * lowercase needles; if ANY needle is found (case-insensitively) in the raw `error`
 * string, the entry's reason is used. Order matters: more specific entries must precede
 * more general ones.
 *
 * Plain `String.includes` substring matching is used deliberately instead of `RegExp`:
 * it sidesteps the `require-unicode-regexp` lint rule AND the declaration build's lower
 * compile target (which rejects the regex `u` flag with TS1501), while being faster and
 * easier to read. Doing this classification in code (rather than in dashboard SQL) keeps
 * the buckets versioned with the source strings that produce them (EDITOR-7862).
 */ const $5f570f8dd9ccb4e4$var$FETCH_REASON_MATCHERS = [
    // Benign: source-state transitions (deletionReason values + free text).
    [
        [
            'source-document-deleted'
        ],
        'source_deleted'
    ],
    [
        [
            'source-block-deleted'
        ],
        'source_deleted'
    ],
    [
        [
            'source-block-unpublished'
        ],
        'source_unpublished'
    ],
    [
        [
            'source-block-unsynced'
        ],
        'source_unsynced'
    ],
    [
        [
            'does not exist'
        ],
        'source_not_found'
    ],
    [
        [
            'unpublished'
        ],
        'source_unpublished'
    ],
    // Working-as-designed permission outcomes.
    [
        [
            'unauthenticated'
        ],
        'unauthenticated'
    ],
    [
        [
            'not permitted to read synced block'
        ],
        'permission_denied'
    ],
    [
        [
            'bulk permission check failed'
        ],
        'permission_denied'
    ],
    [
        [
            'permission denied'
        ],
        'permission_denied'
    ],
    // Genuine system failures.
    [
        [
            'reconnection failed after'
        ],
        'websocket_exhausted'
    ],
    // `reconnect to the subscription` (not a bare `reconnect`) avoids false positives on
    // unrelated DB/GraphQL "reconnect" messages while still matching the WS-drop string.
    [
        [
            'websocket',
            'reconnect to the subscription',
            'subscription terminated'
        ],
        'websocket_drop'
    ],
    [
        [
            '429',
            'rate limit',
            'rate-limit',
            'ratelimit'
        ],
        'rate_limited'
    ],
    // `econnrefused`/`econnreset` (not a bare `econn`, which would also match `reconnect`).
    [
        [
            'network',
            'failed to fetch',
            'econnrefused',
            'econnreset',
            'timed out',
            'timeout'
        ],
        'network'
    ],
    [
        [
            'data provider not set'
        ],
        'data_provider_not_ready'
    ]
];
const $5f570f8dd9ccb4e4$export$b7fb09a58aa76c55 = (error)=>{
    const enumReason = $5f570f8dd9ccb4e4$export$3bf11deac13e0617(error);
    if (enumReason !== 'unknown') return enumReason;
    if (error) {
        const haystack = error.toLowerCase();
        for (const [needles, reason] of $5f570f8dd9ccb4e4$var$FETCH_REASON_MATCHERS){
            if (needles.some((needle)=>haystack.includes(needle))) return reason;
        }
    }
    return 'unknown';
};
const $5f570f8dd9ccb4e4$export$4ae89cef01c11c46 = (error, statusCode, deferred)=>{
    const reason = $5f570f8dd9ccb4e4$export$b7fb09a58aa76c55(error);
    return {
        reason: reason,
        // A deferred (tab-hidden) exhaustion is benign regardless of reason bucket.
        benign: deferred === true || $5f570f8dd9ccb4e4$export$9bd766f5cc31fe3b.has(reason),
        ...statusCode !== undefined && {
            statusCode: statusCode
        },
        ...deferred === true && {
            deferred: true
        }
    };
};
function $5f570f8dd9ccb4e4$export$999ed1af1b20ac2d(actionSubjectId, error, resourceId, sourceProduct, attribution) {
    return {
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: actionSubjectId,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            error: error,
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...attribution?.reason && {
                reason: attribution.reason
            },
            ...attribution?.statusCode !== undefined && {
                statusCode: attribution.statusCode
            },
            // `benign` is only present on fetch/subscribe attribution (EDITOR-7862). It is a
            // boolean (never UGC); the `'benign' in attribution` check both guards the
            // write-path attribution (which has no `benign`) and narrows the union so
            // `attribution.benign` is accessible.
            ...attribution && 'benign' in attribution && {
                benign: attribution.benign
            },
            // `deferred` is only present on fetch/subscribe attribution, and only when a
            // tab-hidden exhaustion was deferred rather than surfaced. Boolean, never UGC.
            ...attribution && 'deferred' in attribution && attribution.deferred === true && {
                deferred: true
            }
        }
    };
}
const $5f570f8dd9ccb4e4$export$94dcd08406353dba = (error, resourceId, sourceProduct, attribution)=>// Branch on attribution presence so each call resolves to a concrete overload: with
    // attribution it hits the fetch overload (wider `reason`); without it, the
    // no-attribution overload. Both produce a fetch event regardless.
    attribution ? $5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH, error, resourceId, sourceProduct, attribution) : $5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$c5131f589148b9d3 = (error, resourceId, sourceProduct)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_GET_SOURCE_INFO, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$adc2363832f8735d = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$154595d209a77913 = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).REFERENCE_SYNCED_BLOCK_UPDATE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$5d2f0c264cf49280 = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$cd0aaab38ff32ec2 = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_DELETE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$e40ed1768baf5d1e = (error, resourceId, sourceProduct)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE_CACHE, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$5665a31a69693485 = (resourceId, sourceProduct, context)=>({
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_SOURCE_INFO_ORPHANED,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...context?.hasPendingDeletion !== undefined && {
                hasPendingDeletion: context.hasPendingDeletion
            },
            ...context?.hasSubscribers !== undefined && {
                hasSubscribers: context.hasSubscribers
            }
        }
    });
const $5f570f8dd9ccb4e4$export$82f9608c8438ecb2 = (rescheduleCount, resourceId, sourceProduct)=>({
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CACHE_DELETION_FORCED,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            rescheduleCount: rescheduleCount,
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$ebf3ba305f3f0e1a = (error, resourceId, sourceProduct)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH_REFERENCES, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$b20c56c32ea6ad76 = (resourceId, blockInstanceId, sourceProduct)=>({
        action: (0, $krYZG.ACTION).FETCHED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            blockInstanceId: blockInstanceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$5b8e0915870366d0 = (resourceId, sourceProduct)=>{
    return {
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).BODIED_SYNCED_BLOCK,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            resourceId: resourceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    };
};
const $5f570f8dd9ccb4e4$export$23e42fbf8039414c = (resourceId, blockInstanceId, sourceProduct, enrichment)=>({
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...blockInstanceId && {
                blockInstanceId: blockInstanceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...enrichment?.inputMethod && {
                inputMethod: enrichment.inputMethod
            },
            ...enrichment?.createdEmpty !== undefined && {
                createdEmpty: enrichment.createdEmpty
            },
            ...enrichment?.nodeTypes?.length && {
                nodeTypes: enrichment.nodeTypes
            }
        }
    });
const $5f570f8dd9ccb4e4$export$c76f6dd50db89cda = (resourceId, blockInstanceId, sourceProduct)=>({
        action: (0, $krYZG.ACTION).ADDED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_ADD_CONTENT,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...blockInstanceId && {
                blockInstanceId: blockInstanceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$f2b4214fae56af83 = (resourceId, hasReference, sourceProduct)=>({
        action: (0, $krYZG.ACTION).UPDATED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...hasReference !== undefined && {
                hasReference: hasReference
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$2283f5d682476cde = (resourceId, sourceProduct, enrichment)=>({
        action: (0, $krYZG.ACTION).DELETED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_DELETE,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...enrichment?.blockInstanceId && {
                blockInstanceId: enrichment.blockInstanceId
            },
            ...enrichment?.deletionReason && {
                deletionReason: enrichment.deletionReason
            },
            ...enrichment?.mechanism && {
                mechanism: enrichment.mechanism
            }
        }
    });
module.exports["stringifyError"] = $5f570f8dd9ccb4e4$export$7fc2c997455452c8;
module.exports["getPiiSafeOriginalError"] = $5f570f8dd9ccb4e4$export$74ce7fda6da1109;
module.exports["buildErrorAttribution"] = $5f570f8dd9ccb4e4$export$78792f4ddc3998e8;
module.exports["buildFetchErrorAttribution"] = $5f570f8dd9ccb4e4$export$4ae89cef01c11c46;
module.exports["fetchErrorPayload"] = $5f570f8dd9ccb4e4$export$94dcd08406353dba;
module.exports["getSourceInfoErrorPayload"] = $5f570f8dd9ccb4e4$export$c5131f589148b9d3;
module.exports["updateErrorPayload"] = $5f570f8dd9ccb4e4$export$adc2363832f8735d;
module.exports["updateReferenceErrorPayload"] = $5f570f8dd9ccb4e4$export$154595d209a77913;
module.exports["createErrorPayload"] = $5f570f8dd9ccb4e4$export$5d2f0c264cf49280;
module.exports["deleteErrorPayload"] = $5f570f8dd9ccb4e4$export$cd0aaab38ff32ec2;
module.exports["updateCacheErrorPayload"] = $5f570f8dd9ccb4e4$export$e40ed1768baf5d1e;
module.exports["sourceInfoOrphanedPayload"] = $5f570f8dd9ccb4e4$export$5665a31a69693485;
module.exports["cacheDeletionForcedPayload"] = $5f570f8dd9ccb4e4$export$82f9608c8438ecb2;
module.exports["fetchReferencesErrorPayload"] = $5f570f8dd9ccb4e4$export$ebf3ba305f3f0e1a;
module.exports["fetchSuccessPayload"] = $5f570f8dd9ccb4e4$export$b20c56c32ea6ad76;
module.exports["createSuccessPayload"] = $5f570f8dd9ccb4e4$export$5b8e0915870366d0;
module.exports["createSuccessOperationalPayload"] = $5f570f8dd9ccb4e4$export$23e42fbf8039414c;
module.exports["addContentSuccessPayload"] = $5f570f8dd9ccb4e4$export$c76f6dd50db89cda;
module.exports["updateSuccessPayload"] = $5f570f8dd9ccb4e4$export$f2b4214fae56af83;
module.exports["deleteSuccessPayload"] = $5f570f8dd9ccb4e4$export$2283f5d682476cde;

});

parcelRegister("7GRSG", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");


var $3xsB6 = parcelRequire("3xsB6");

const $23c76758ad9684b4$export$63fea0488f1f3b79 = (productType)=>productType === 'jira-work-item' && (0, $4o0zT.isExperimentEnabled)('editor_synced_blocks_jira_custom_rich_text');
const $23c76758ad9684b4$export$6f2c88a8b48b006f = ({ documentAri: documentAri, hostAri: hostAri, productType: productType })=>hostAri !== undefined && $23c76758ad9684b4$export$63fea0488f1f3b79(productType) ? {
        locationScope: (0, $3xsB6.getLocationScope)({
            documentAri: documentAri,
            hostAri: hostAri
        })
    } : undefined;
module.exports["getFieldAwareLocationScope"] = $23c76758ad9684b4$export$6f2c88a8b48b006f;

});

parcelRegister("cuwGS", function(module, exports) {

var $kcJaM = parcelRequire("kcJaM");

const $dfc9aeca876e07dc$var$isSyncBlockProduct = (product)=>{
    return (0, $kcJaM.SYNC_BLOCK_PRODUCTS).includes(product);
};
const $dfc9aeca876e07dc$export$8aafdd7901afa57f = (resourceId)=>{
    if (!resourceId) return undefined;
    const [product, contentId, uuid, ...rest] = resourceId.split('/');
    // invalid if any part is missing or there are extra parts
    if (!product || !contentId || !uuid || rest.length > 0) return undefined;
    // invalid if product is not recognized
    if (!$dfc9aeca876e07dc$var$isSyncBlockProduct(product)) return undefined;
    return {
        product: product,
        contentId: contentId,
        uuid: uuid
    };
};
const $dfc9aeca876e07dc$export$cf5895b3b46faf63 = (product, contentId, uuid)=>{
    return `${product}/${contentId}/${uuid}`;
};
module.exports["parseResourceId"] = $dfc9aeca876e07dc$export$8aafdd7901afa57f;
module.exports["createResourceIdForReference"] = $dfc9aeca876e07dc$export$cf5895b3b46faf63;

});

parcelRegister("kcJaM", function(module, exports) {
const $d6e2f975e4365dc3$export$c05408ef703373ad = [
    'confluence-page',
    'jira-work-item'
];
module.exports["SYNC_BLOCK_PRODUCTS"] = $d6e2f975e4365dc3$export$c05408ef703373ad;

});

parcelRegister("d04Ge", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $acebaa6737646e6e$var$GET_CONTENT_ID_AND_PRODUCT_REGEX = /^(confluence-page|jira-work-item)\/([^/]+)/;
const $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal = (content, options)=>{
    let normalizedContent;
    content.forEach((contentNode, index)=>{
        if (!contentNode) {
            normalizedContent?.push(contentNode);
            return;
        }
        const hasAnnotationMark = contentNode.marks?.some((mark)=>mark.type === 'annotation');
        const shouldConvertPanelC1 = options.convertPanelC1ToPanel && contentNode.type === 'panel_c1';
        const childContent = contentNode.content ? $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal(contentNode.content, options) : undefined;
        const hasContentChanged = childContent !== undefined && childContent !== contentNode.content;
        if (!hasAnnotationMark && !shouldConvertPanelC1 && !hasContentChanged) {
            normalizedContent?.push(contentNode);
            return;
        }
        if (!normalizedContent) normalizedContent = content.slice(0, index);
        const normalizedNode = {
            ...contentNode
        };
        if (shouldConvertPanelC1) normalizedNode.type = 'panel';
        if (hasAnnotationMark) {
            const marks = contentNode.marks?.filter((mark)=>mark.type !== 'annotation');
            if (marks && marks.length > 0) normalizedNode.marks = marks;
            else delete normalizedNode.marks;
        }
        if (hasContentChanged && childContent) normalizedNode.content = childContent;
        normalizedContent.push(normalizedNode);
    });
    return normalizedContent ?? content;
};
const $acebaa6737646e6e$export$19bb1d88f473b9c5 = (content)=>{
    return $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal(content, {
        convertPanelC1ToPanel: false
    });
};
const $acebaa6737646e6e$export$b223a7607ed061dc = (content)=>{
    return $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal(content, {
        convertPanelC1ToPanel: true
    });
};
const $acebaa6737646e6e$export$aafb32b192c8228c = (node)=>{
    const content = node.content.toJSON();
    return {
        blockInstanceId: node.attrs.localId,
        content: content ? $acebaa6737646e6e$export$b223a7607ed061dc(content) : content,
        resourceId: node.attrs.resourceId
    };
};
const $acebaa6737646e6e$export$c5b34fb9069ebb1d = (localId, resourceId)=>{
    return {
        type: 'syncBlock',
        attrs: {
            localId: localId,
            resourceId: resourceId
        }
    };
};
const $acebaa6737646e6e$export$cd9b0caaea319019 = (node)=>{
    if (node.type !== 'syncBlock' || !node.attrs || !('localId' in node.attrs) || !('resourceId' in node.attrs) || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $acebaa6737646e6e$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $acebaa6737646e6e$export$648ff8dd259e0d9c = (node)=>{
    if (node.type.name !== 'syncBlock' || !node.attrs?.localId || !node.attrs?.resourceId || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $acebaa6737646e6e$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $acebaa6737646e6e$export$18b85168a73dad03 = (nodes)=>{
    return nodes.map((node)=>$acebaa6737646e6e$export$648ff8dd259e0d9c(node)).filter((node)=>node !== undefined);
};
const $acebaa6737646e6e$export$2cf4a74c3e18f31a = (resourceId)=>{
    const match = resourceId.match($acebaa6737646e6e$var$GET_CONTENT_ID_AND_PRODUCT_REGEX);
    if (match?.[2]) return {
        sourceProduct: match[1],
        sourceContentId: match[2]
    };
    throw new Error(`Invalid resourceId: ${resourceId}`);
};
const $acebaa6737646e6e$export$31cbe0bed21e05b1 = (resourceId)=>{
    if (!resourceId) return undefined;
    try {
        return $acebaa6737646e6e$export$2cf4a74c3e18f31a(resourceId).sourceProduct;
    } catch  {
        return undefined;
    }
};
const $acebaa6737646e6e$export$4c6687d128f55da5 = (contentUpdatedAt)=>{
    if (typeof contentUpdatedAt === 'number') try {
        return new Date(contentUpdatedAt).toISOString();
    } catch  {
        return undefined;
    }
    return undefined;
};
module.exports["normalizeSyncBlockJSONContent"] = $acebaa6737646e6e$export$b223a7607ed061dc;
module.exports["convertSyncBlockPMNodeToSyncBlockData"] = $acebaa6737646e6e$export$aafb32b192c8228c;
module.exports["createSyncBlockNode"] = $acebaa6737646e6e$export$c5b34fb9069ebb1d;
module.exports["convertSyncBlockJSONNodeToSyncBlockNode"] = $acebaa6737646e6e$export$cd9b0caaea319019;
module.exports["convertPMNodesToSyncBlockNodes"] = $acebaa6737646e6e$export$18b85168a73dad03;
module.exports["getContentIdAndProductFromResourceId"] = $acebaa6737646e6e$export$2cf4a74c3e18f31a;
module.exports["getSourceProductFromResourceIdSafe"] = $acebaa6737646e6e$export$31cbe0bed21e05b1;
module.exports["convertContentUpdatedAt"] = $acebaa6737646e6e$export$4c6687d128f55da5;

});

parcelRegister("ed90V", function(module, exports) {

let $a589458c7f0ee6e9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a589458c7f0ee6e9$var$load("zUKwV"),
    $a589458c7f0ee6e9$var$load("fUeur"),
    $a589458c7f0ee6e9$var$load("cp9QV")
]).then(()=>parcelRequire('kRm6Y'));

});

parcelRegister("6oMcp", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $0dfedb71521ac678$var$CONFLUENCE_PAGE_ARI_REGEX = /ari:cloud:confluence:[^:]+:(page|blogpost)\/(\d+)/;
const $0dfedb71521ac678$export$3c54cf45dfed84ea = ({ pageId: pageId, cloudId: cloudId, pageType: pageType })=>{
    return `ari:cloud:confluence:${cloudId}:${pageType}/${pageId}`;
};
const $0dfedb71521ac678$export$2ee4e689bde04de2 = ({ ari: ari })=>{
    const match = ari.match($0dfedb71521ac678$var$CONFLUENCE_PAGE_ARI_REGEX);
    if (match?.[2]) return {
        type: match[1],
        id: match[2]
    };
    throw new Error(`Invalid page ARI: ${ari}`);
};
module.exports["getConfluencePageAri"] = $0dfedb71521ac678$export$3c54cf45dfed84ea;
module.exports["getPageIdAndTypeFromConfluencePageAri"] = $0dfedb71521ac678$export$2ee4e689bde04de2;

});

parcelRegister("gb05o", function(module, exports) {
/**
 * Error codes for synced blocks preloading
 * Used for tracking and monitoring errors during SSR preload phase
 */ const $dcd4a25c1def153c$export$f10410d219e3ec29 = {
    /**
   * Occurs when the fetch operation returns fewer results than requested.
   * This indicates incomplete data retrieval or potential data loss.
   * Included in error: list of missing block identifiers
   */ FETCH_INCOMPLETE: 'SYNCED_BLOCKS_FETCH_INCOMPLETE',
    /**
   * Occurs when the batch fetch operation throws an error during execution.
   * This indicates a network error, timeout, or API failure.
   * Included in error: resource IDs that failed to fetch
   */ BATCH_FETCH_FAILED: 'SYNCED_BLOCKS_BATCH_FETCH_FAILED',
    /**
   * Occurs when the fetch operation times out without returning results.
   * This is specific to the bulk fetch operation with a configurable timeout.
   */ FETCH_TIMEOUT: 'SYNCED_BLOCKS_FETCH_TIMEOUT'
};
module.exports["SyncedBlocksSSRErrorCodeMap"] = $dcd4a25c1def153c$export$f10410d219e3ec29;

});

parcelRegister("8AcAF", function(module, exports) {
function $239408713401734d$export$25570414f819b6df(syncBlock, nodeTypes) {
    if (!syncBlock?.data?.content) return [];
    if (nodeTypes.length === 0) return [];
    const nodeTypesSet = new Set(nodeTypes);
    const foundTypes = new Set();
    const content = syncBlock.data.content;
    const checkNode = (node)=>{
        if (!node || typeof node !== 'object') return false;
        // Check if this node matches one of the requested types
        if (typeof node.type === 'string' && nodeTypesSet.has(node.type) && !foundTypes.has(node.type)) {
            // node type found, add to found set and remove from search set
            foundTypes.add(node.type);
            nodeTypesSet.delete(node.type);
            // If all types have been found, we can stop searching
            if (nodeTypesSet.size === 0) return true;
        }
        // Recursively check all child content
        if (Array.isArray(node.content)) // Return true to stop searching if all types have been found in children
        return node.content.some(checkNode);
        return false;
    };
    content.some(checkNode);
    return Array.from(foundTypes);
}
module.exports["syncBlockContainsNodes"] = $239408713401734d$export$25570414f819b6df;

});

parcelRegister("l9Wsf", function(module, exports) {
const $7267ec4c0ff40ba5$var$isSyncBlockNode = (node)=>{
    return node.type === 'syncBlock' && typeof node.attrs === 'object' && node.attrs !== null && 'resourceId' in node.attrs && 'localId' in node.attrs && typeof node.attrs.resourceId === 'string' && typeof node.attrs.localId === 'string';
};
function $7267ec4c0ff40ba5$export$7895de99cf1d8719(doc) {
    const content = doc.content || [];
    return content.reduce((acc, node)=>{
        if ($7267ec4c0ff40ba5$var$isSyncBlockNode(node)) acc.push({
            resourceId: node.attrs.resourceId,
            blockInstanceId: node.attrs.localId
        });
        return acc;
    }, []);
}
module.exports["extractSyncBlockIdentifiers"] = $7267ec4c0ff40ba5$export$7895de99cf1d8719;

});

parcelRegister("985xA", function(module, exports) {
function $4a85fd13a342ae42$export$e3ccb083fef98320(value) {
    if (!value || typeof value !== 'object') return false;
    const doc = value;
    // Check required properties
    if (doc.type !== 'doc') return false;
    if (!Array.isArray(doc.content)) return false;
    // Version is optional but if present should be a number
    if (doc.version !== undefined && typeof doc.version !== 'number') return false;
    return true;
}
module.exports["isValidJSONDocNode"] = $4a85fd13a342ae42$export$e3ccb083fef98320;

});

parcelRegister("32Xjk", function(module, exports) {
/**
 * @generated SignedSource<<1411d3b38bfd3828f39e9de902613b71>>
 * @relayHash 3d166b53e496ae6a12171538cb6c6ca8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 47671c12a30051dade8a24379bdff81b92cd52b7a0f16a09096ff4fec8aa47ce
const $6ea889d48284c196$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "emoji-ever-set"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"emoji-ever-set\")"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useEmojiEverSetPropertyQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useEmojiEverSetPropertyQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "3d166b53e496ae6a12171538cb6c6ca8",
            "id": "47671c12a30051dade8a24379bdff81b92cd52b7a0f16a09096ff4fec8aa47ce",
            "metadata": {},
            "name": "useEmojiEverSetPropertyQuery",
            "operationKind": "query",
            "text": "query useEmojiEverSetPropertyQuery($contentId:ID,$status:[String],$draftShareId:String){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,properties(key:\"emoji-ever-set\"){nodes{id,key,value}}}}}"
        }
    };
}();
$6ea889d48284c196$var$node.hash = "7922225ac99254e0526a345863d19578";
var $6ea889d48284c196$export$2e2bcd8739ae039 = $6ea889d48284c196$var$node;
module.exports["default"] = $6ea889d48284c196$export$2e2bcd8739ae039;

});

parcelRegister("fxLAA", function(module, exports) {
/**
 * @generated SignedSource<<f7a45c7e6fe282e53efbc50e707a28b4>>
 * @relayHash 956ced6a9f85fb994986ab4d0d7cffa3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e83d8378c923ba932bd8dd0335f6b765775cdc24ed775b3d1375f23bc47d6bd8
const $d3bfdb752c338d80$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "embeddedContentRender"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeClassification"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeDevDocsBylineConnection"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includePublicLink"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isMarkdownModeEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v9 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useAccessButtonFragment"
    }, v10 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useEditButtonFragment"
    }, v11 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useNewContentTopper"
    }, v12 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useObjectHeaderFragment"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionOverride"
    }, v14 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v15 = [
        {
            "kind": "Variable",
            "name": "embeddedContentRender",
            "variableName": "embeddedContentRender"
        },
        v14 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "status",
            "variableName": "status"
        },
        {
            "kind": "Variable",
            "name": "version",
            "variableName": "versionOverride"
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "id"
    }, v17 = {
        "kind": "ScalarField",
        "name": "type"
    }, v18 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v19 = {
        "kind": "ScalarField",
        "name": "title"
    }, v20 = {
        "kind": "ScalarField",
        "name": "status"
    }, v21 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v22 = {
        "kind": "ScalarField",
        "name": "key"
    }, v23 = {
        "kind": "ScalarField",
        "name": "value"
    }, v24 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v16 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ 
            ]
        }
    ], v25 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "devdocsProperties",
                    "smartFolderProperties"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v24 /*: any*/ ,
        "storageKey": "properties(keys:[\"devdocsProperties\",\"smartFolderProperties\"])"
    }, v26 = {
        "kind": "ScalarField",
        "name": "number"
    }, v27 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v16 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        v26 /*: any*/ 
                    ]
                }
            ]
        }
    ], v28 = {
        "alias": "appearancePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "content-appearance-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v27 /*: any*/ ,
        "storageKey": "properties(key:\"content-appearance-published\")"
    }, v29 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v30 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v31 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v32 = [
        v17 /*: any*/ ,
        v21 /*: any*/ ,
        v30 /*: any*/ ,
        v31 /*: any*/ 
    ], v33 = {
        "alias": "emojiTitlePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v27 /*: any*/ ,
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v34 = {
        "condition": "useNewContentTopper",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": "pageTitlePublished",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "page-title-property-published"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v27 /*: any*/ ,
                "storageKey": "properties(key:\"page-title-property-published\")"
            }
        ]
    }, v35 = {
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "editor"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v24 /*: any*/ ,
        "storageKey": "properties(key:\"editor\")"
    }, v36 = {
        "kind": "ScalarField",
        "name": "name"
    }, v37 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v16 /*: any*/ ,
            v36 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "homepageId"
            }
        ]
    }, v38 = {
        "kind": "ScalarField",
        "name": "message"
    }, v39 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v40 = {
        "kind": "ScalarField",
        "name": "when"
    }, v41 = {
        "kind": "ScalarField",
        "name": "contentTypeModified"
    }, v42 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "generatedBy"
                    },
                    {
                        "condition": "isMarkdownModeEnabled",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isMarkdownMode"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v43 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "sourceTemplateEntityId"
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                "kind": "LinkedField",
                "name": "frontend",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "fabricEditorSupported"
                    },
                    {
                        "condition": "useNewContentTopper",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "coverPictureWidth"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v44 = {
        "condition": "includePublicLink",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "pageId",
                        "variableName": "contentId"
                    }
                ],
                "concreteType": "PublicLinkPage",
                "kind": "LinkedField",
                "name": "publicLinkPage",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "pageId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "pageStatus"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "accessType"
                    }
                ]
            }
        ]
    }, v45 = [
        v14 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        }
    ], v46 = {
        "kind": "ScalarField",
        "name": "count"
    }, v47 = {
        "kind": "ScalarField",
        "name": "isCurrentUserContributor"
    }, v48 = {
        "kind": "ScalarField",
        "name": "isOwnerContributor"
    }, v49 = [
        v22 /*: any*/ ,
        v23 /*: any*/ 
    ], v50 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "spaceKey"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v16 /*: any*/ ,
            {
                "concreteType": "Theme",
                "kind": "LinkedField",
                "name": "theme",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "themeKey"
                    }
                ]
            },
            {
                "concreteType": "LookAndFeel",
                "kind": "LinkedField",
                "name": "lookAndFeel",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "MapOfStringToString",
                        "kind": "LinkedField",
                        "name": "headings",
                        "plural": true,
                        "selections": v49 /*: any*/ 
                    },
                    {
                        "concreteType": "ContentLookAndFeel",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "ContainerLookAndFeel",
                                "kind": "LinkedField",
                                "name": "header",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "background"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundAttachment"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundBlendMode"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundClip"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundColor"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundImage"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundOrigin"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundPosition"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundRepeat"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundSize"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "borderRadius"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "padding"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v51 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v52 = [
        v51 /*: any*/ ,
        v17 /*: any*/ ,
        v21 /*: any*/ ,
        v30 /*: any*/ ,
        v31 /*: any*/ 
    ], v53 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v54 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v22 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            }
        ]
    }, v55 = [
        v51 /*: any*/ ,
        v21 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ContentHeaderUnifiedQuery",
            "selections": [
                {
                    "args": v15 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v16 /*: any*/ ,
                                {
                                    "condition": "useEditButtonFragment",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "EditContentButton_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "editContentButton"
                                        }
                                    ]
                                },
                                {
                                    "condition": "useAccessButtonFragment",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "useShareAndRestrictButtonData_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "shareAndRestrictButtonData"
                                        }
                                    ]
                                },
                                {
                                    "condition": "useObjectHeaderFragment",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "ContentTypesHeader_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "contentTypesHeader"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeClassification",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "BylineClassification_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "bylineClassificationFragment"
                                        }
                                    ]
                                },
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                {
                                    "condition": "includeDevDocsBylineConnection",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "ancestors",
                                            "plural": true,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                {
                                                    "concreteType": "History",
                                                    "kind": "LinkedField",
                                                    "name": "history",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "createdBy",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v25 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v28 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        v29 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": v32 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v32 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "lastOwnedBy",
                                            "plural": false,
                                            "selections": v32 /*: any*/ 
                                        }
                                    ]
                                },
                                v33 /*: any*/ ,
                                v34 /*: any*/ ,
                                v35 /*: any*/ ,
                                v37 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v38 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v32 /*: any*/ 
                                        },
                                        v39 /*: any*/ ,
                                        v40 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        v41 /*: any*/ 
                                    ]
                                },
                                v42 /*: any*/ ,
                                v43 /*: any*/ 
                            ]
                        }
                    ]
                },
                v44 /*: any*/ ,
                {
                    "args": v45 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        v46 /*: any*/ ,
                        v47 /*: any*/ ,
                        v48 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v32 /*: any*/ 
                        }
                    ]
                },
                v50 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v7 /*: any*/ ,
                v13 /*: any*/ ,
                v1 /*: any*/ ,
                v6 /*: any*/ ,
                v11 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v12 /*: any*/ ,
                v10 /*: any*/ ,
                v9 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ContentHeaderUnifiedQuery",
            "selections": [
                {
                    "args": v15 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v28 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        v29 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": v52 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v52 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "lastOwnedBy",
                                            "plural": false,
                                            "selections": v52 /*: any*/ 
                                        }
                                    ]
                                },
                                v33 /*: any*/ ,
                                v35 /*: any*/ ,
                                v37 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v38 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v52 /*: any*/ 
                                        },
                                        v39 /*: any*/ ,
                                        v40 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        v41 /*: any*/ 
                                    ]
                                },
                                v42 /*: any*/ ,
                                v43 /*: any*/ ,
                                {
                                    "condition": "useEditButtonFragment",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        v53 /*: any*/ ,
                                        {
                                            "concreteType": "ContentMetadata",
                                            "kind": "LinkedField",
                                            "name": "metadata",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                                    "kind": "LinkedField",
                                                    "name": "frontend",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "embedded"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "collabService"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "Space",
                                            "kind": "LinkedField",
                                            "name": "space",
                                            "plural": false,
                                            "selections": [
                                                v22 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "useAccessButtonFragment",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasInheritedRestrictions"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasRestrictions"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasViewRestrictions"
                                        }
                                    ]
                                },
                                {
                                    "condition": "useObjectHeaderFragment",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        v53 /*: any*/ ,
                                        v54 /*: any*/ ,
                                        {
                                            "alias": "smartFolderProperties",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "keys",
                                                    "value": [
                                                        "smartFolderProperties"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "PaginatedJsonContentPropertyList",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JsonContentProperty",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": v49 /*: any*/ 
                                                }
                                            ],
                                            "storageKey": "properties(keys:[\"smartFolderProperties\"])"
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "draftVersion",
                                            "plural": false,
                                            "selections": [
                                                v41 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v39 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": v55 /*: any*/ 
                                                },
                                                v40 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeClassification",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        v53 /*: any*/ ,
                                        v54 /*: any*/ ,
                                        {
                                            "concreteType": "ClassificationLevelDetails",
                                            "kind": "LinkedField",
                                            "name": "classificationLevelDetails",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "ContentDataClassificationLevel",
                                                    "kind": "LinkedField",
                                                    "name": "classificationLevel",
                                                    "plural": false,
                                                    "selections": [
                                                        v16 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "guideline"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "guidelineADF"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "description"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "color"
                                                        },
                                                        v36 /*: any*/ ,
                                                        v20 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "featureEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "source"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isReclassificationPermitted"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canManageSpaceSettings"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "classificationControlSetting"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "userOverrideSetting"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeDevDocsBylineConnection",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "ancestors",
                                            "plural": true,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                {
                                                    "concreteType": "History",
                                                    "kind": "LinkedField",
                                                    "name": "history",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "createdBy",
                                                            "plural": false,
                                                            "selections": v55 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                v25 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v34 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v45 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        v46 /*: any*/ ,
                        v47 /*: any*/ ,
                        v48 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v52 /*: any*/ 
                        }
                    ]
                },
                v50 /*: any*/ ,
                v44 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "956ced6a9f85fb994986ab4d0d7cffa3",
            "id": "e83d8378c923ba932bd8dd0335f6b765775cdc24ed775b3d1375f23bc47d6bd8",
            "metadata": {},
            "name": "ContentHeaderUnifiedQuery",
            "operationKind": "query",
            "text": "query ContentHeaderUnifiedQuery($contentId:ID!,$spaceKey:String,$versionOverride:Int,$embeddedContentRender:String,$limit:Int,$useNewContentTopper:Boolean=false,$isMarkdownModeEnabled:Boolean=false,$includeDevDocsBylineConnection:Boolean=false,$useObjectHeaderFragment:Boolean=false,$useEditButtonFragment:Boolean=false,$useAccessButtonFragment:Boolean=false,$includePublicLink:Boolean=false,$includeClassification:Boolean=false,$status:[String]){content(id:$contentId,version:$versionOverride,embeddedContentRender:$embeddedContentRender,status:$status){nodes{id,...EditContentButton_content@include(if:$useEditButtonFragment),...useShareAndRestrictButtonData_content@include(if:$useAccessButtonFragment),...ContentTypesHeader_content@include(if:$useObjectHeaderFragment),...BylineClassification_content@include(if:$includeClassification),type,subType,title,status,ancestors@include(if:$includeDevDocsBylineConnection){id,title,type,subType,history{createdBy{__typename,displayName}},properties(keys:[\"devdocsProperties\",\"smartFolderProperties\"]){nodes{id,key,value}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},ownedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},properties(key:\"editor\"){nodes{id,key,value}},space{id,name,homepageId},version{message,by{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},friendlyWhen,when,number,contentTypeModified},contentProperties{latest{generatedBy,isMarkdownMode@include(if:$isMarkdownModeEnabled)}},metadata{sourceTemplateEntityId,lastModifiedDate,frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}}}},publicLinkPage(pageId:$contentId)@include(if:$includePublicLink){pageId,pageStatus,accessType},contentContributors(id:$contentId,limit:$limit){count,isCurrentUserContributor,isOwnerContributor,nodes{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},space(key:$spaceKey){id,theme{themeKey},lookAndFeel{headings{key,value},content{header{background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundRepeat,backgroundSize,borderRadius,padding}}}}}fragment BylineClassification_content on Content{id,title,type,status,operations{operation,targetType},space{id,name,key,alias},...useContentClassification_content}fragment ContentTypesHeader_content on Content{id,title,operations{operation,targetType},space{id,name,key,alias},type,subType,status,smartFolderProperties:properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when}}fragment EditContentButton_content on Content{id,type,operations{operation,targetType},metadata{frontend{fabricEditorSupported,embedded,collabService}},subType,space{id,key}}fragment useContentClassification_content on Content{id,classificationLevelDetails{classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}fragment useShareAndRestrictButtonData_content on Content{id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title}"
        }
    };
}();
$d3bfdb752c338d80$var$node.hash = "ff95a3f94a3551e8404849a9d5a27517";
var $d3bfdb752c338d80$export$2e2bcd8739ae039 = $d3bfdb752c338d80$var$node;
module.exports["default"] = $d3bfdb752c338d80$export$2e2bcd8739ae039;

});

parcelRegister("80xNa", function(module, exports) {
const $5d488939c8bec967$export$21191b0c00ca25f4 = 4;
const $5d488939c8bec967$export$4b915fb24c39b396 = {
    //copied from change-edition. Was not allowed to import it into preloadContentHeader + to prevent bundle size increase.
    FREE: 'FREE',
    PREMIUM: 'PREMIUM',
    STANDARD: 'STANDARD'
};
module.exports["DEFAULT_CONTRIBUTORS_FETCH_LIMIT"] = $5d488939c8bec967$export$21191b0c00ca25f4;
module.exports["CONFLUENCE_EDITION"] = $5d488939c8bec967$export$4b915fb24c39b396;

});

parcelRegister("5Ff2j", function(module, exports) {

let $41fc71ff22374a1e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $41fc71ff22374a1e$var$load("lya9W"),
    $41fc71ff22374a1e$var$load("gA528")
]).then(()=>parcelRequire('cS7ok'));

});

parcelRegister("2XqLa", function(module, exports) {
/**
 * @generated SignedSource<<a63d6821b45767207607249abf9688dc>>
 * @relayHash 3d96e93646da973911628e43055a9f08
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e401857f7c01e3a1e9f0925bc458239f573445ed8b7119ee7ef804a2ec848c88
const $24a18f673122a45e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PagesSpaceIdQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PagesSpaceIdQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3d96e93646da973911628e43055a9f08",
            "id": "e401857f7c01e3a1e9f0925bc458239f573445ed8b7119ee7ef804a2ec848c88",
            "metadata": {},
            "name": "PagesSpaceIdQuery",
            "operationKind": "query",
            "text": "query PagesSpaceIdQuery($spaceKey:String){space(key:$spaceKey){id}}"
        }
    };
}();
$24a18f673122a45e$var$node.hash = "deb46e23288932c7ab718d7f71cc2103";
var $24a18f673122a45e$export$2e2bcd8739ae039 = $24a18f673122a45e$var$node;
module.exports["default"] = $24a18f673122a45e$export$2e2bcd8739ae039;

});

parcelRegister("jG2Es", function(module, exports) {
/**
 * @generated SignedSource<<308939eb97236fd7abf20adc7a4f957c>>
 * @relayHash 59320f1b8601c0164d05458b5671082b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7db8c3153986b4dbb13acf7de34310f81ac9a8e0ac042516b4ef9dcad70cc31e
const $2a2707667ff6d1a7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "globalPageCardAppearancePreference"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "PagesSortPersistenceOption",
                    "kind": "LinkedField",
                    "name": "spacePagesSortView",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "field"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "order"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpacePagesPersistenceQueriesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpacePagesPersistenceQueriesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "59320f1b8601c0164d05458b5671082b",
            "id": "7db8c3153986b4dbb13acf7de34310f81ac9a8e0ac042516b4ef9dcad70cc31e",
            "metadata": {},
            "name": "SpacePagesPersistenceQueriesQuery",
            "operationKind": "query",
            "text": "query SpacePagesPersistenceQueriesQuery($spaceKey:String!){userPreferences{globalPageCardAppearancePreference,spacePagesSortView(spaceKey:$spaceKey){field,order}}}"
        }
    };
}();
$2a2707667ff6d1a7$var$node.hash = "2a6df4b92cf1482402557b6fd5bb750a";
var $2a2707667ff6d1a7$export$2e2bcd8739ae039 = $2a2707667ff6d1a7$var$node;
module.exports["default"] = $2a2707667ff6d1a7$export$2e2bcd8739ae039;

});

parcelRegister("khheP", function(module, exports) {
/**
 * @generated SignedSource<<df47d391d55dfb270aba4acf06377c79>>
 * @relayHash 767409598881887aa79d216996b506d5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6841cfcc0970a95f1d151af08e5fdeee1588edf1ca9d6b1e88d51154f26c4932
const $fdbd89e429f2aa39$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudIdARI"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commonFilters"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "confluenceFilters"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "disableQueryReplacement"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entities"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experience"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeRecommended"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLicensed"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "query"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sort"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceId"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "tenantId"
    }, v14 = {
        "kind": "Variable",
        "name": "experience",
        "variableName": "experience"
    }, v15 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "disableQueryReplacement",
            "variableName": "disableQueryReplacement"
        },
        v14 /*: any*/ ,
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "commonFilters",
                    "variableName": "commonFilters"
                },
                {
                    "kind": "Variable",
                    "name": "confluenceFilters",
                    "variableName": "confluenceFilters"
                },
                {
                    "kind": "Variable",
                    "name": "entities",
                    "variableName": "entities"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "cloudIdARI"
                }
            ],
            "kind": "ObjectValue",
            "name": "filters"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
        },
        {
            "kind": "Variable",
            "name": "sort",
            "variableName": "sort"
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v19 = {
        "kind": "ScalarField",
        "name": "description"
    }, v20 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v21 = {
        "kind": "ScalarField",
        "name": "title"
    }, v22 = {
        "kind": "ScalarField",
        "name": "type"
    }, v23 = {
        "kind": "ScalarField",
        "name": "url"
    }, v24 = {
        "kind": "ScalarField",
        "name": "lastModified"
    }, v25 = {
        "kind": "ScalarField",
        "name": "isVerified"
    }, v26 = {
        "kind": "ScalarField",
        "name": "name"
    }, v27 = {
        "concreteType": "SearchConfluenceResultSpace",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v17 /*: any*/ ,
            v26 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "webUiLink"
            }
        ]
    }, v28 = {
        "kind": "ScalarField",
        "name": "currentUserIsWatching"
    }, v29 = {
        "concreteType": "SpaceUserMetadata",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isWatched"
            },
            {
                "kind": "ScalarField",
                "name": "isWatchingBlogs"
            }
        ]
    }, v30 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v31 = {
        "kind": "ScalarField",
        "name": "blank"
    }, v32 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "content",
        "plural": true,
        "selections": [
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v31 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "excerpt"
            }
        ]
    }, v33 = {
        "kind": "ScalarField",
        "name": "subtype"
    }, v34 = {
        "alias": "pageStatus",
        "kind": "ScalarField",
        "name": "status"
    }, v35 = {
        "kind": "ScalarField",
        "name": "webUi"
    }, v36 = {
        "kind": "ScalarField",
        "name": "editUi"
    }, v37 = [
        v35 /*: any*/ ,
        v36 /*: any*/ 
    ], v38 = {
        "concreteType": "ConfluencePageLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v37 /*: any*/ 
    }, v39 = {
        "kind": "ScalarField",
        "name": "key"
    }, v40 = {
        "kind": "ScalarField",
        "name": "value"
    }, v41 = [
        v18 /*: any*/ ,
        v17 /*: any*/ ,
        v39 /*: any*/ ,
        v40 /*: any*/ 
    ], v42 = {
        "concreteType": "ConfluenceContentTitleEmoji",
        "kind": "LinkedField",
        "name": "titleEmojiPublished",
        "plural": false,
        "selections": v41 /*: any*/ 
    }, v43 = {
        "concreteType": "ConfluenceContentTitleEmoji",
        "kind": "LinkedField",
        "name": "titleEmojiDraft",
        "plural": false,
        "selections": v41 /*: any*/ 
    }, v44 = {
        "concreteType": "ConfluenceContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            v42 /*: any*/ ,
            v43 /*: any*/ 
        ]
    }, v45 = [
        {
            "kind": "Literal",
            "name": "keys",
            "value": [
                "editor"
            ]
        }
    ], v46 = [
        v18 /*: any*/ ,
        v39 /*: any*/ ,
        v40 /*: any*/ 
    ], v47 = {
        "alias": "editorVersion",
        "args": v45 /*: any*/ ,
        "concreteType": "ConfluencePageProperty",
        "kind": "LinkedField",
        "name": "properties",
        "plural": true,
        "selections": v46 /*: any*/ ,
        "storageKey": "properties(keys:[\"editor\"])"
    }, v48 = {
        "kind": "ScalarField",
        "name": "alias"
    }, v49 = {
        "concreteType": "ConfluenceSpace",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v17 /*: any*/ ,
            v39 /*: any*/ ,
            v48 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v50 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v51 = [
        {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                v17 /*: any*/ ,
                v50 /*: any*/ ,
                v26 /*: any*/ 
            ]
        }
    ], v52 = {
        "concreteType": "ConfluenceUserInfo",
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": v51 /*: any*/ 
    }, v53 = {
        "concreteType": "ConfluenceUserInfo",
        "kind": "LinkedField",
        "name": "owner",
        "plural": false,
        "selections": v51 /*: any*/ 
    }, v54 = [
        {
            "concreteType": "ConfluenceFavoritedSummary",
            "kind": "LinkedField",
            "name": "favoritedSummary",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFavorite"
                }
            ]
        }
    ], v55 = {
        "concreteType": "ConfluencePageViewerSummary",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": v54 /*: any*/ 
    }, v56 = {
        "concreteType": "ConfluenceCommentCountSummary",
        "kind": "LinkedField",
        "name": "commentCountSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "total"
            }
        ]
    }, v57 = {
        "kind": "ScalarField",
        "name": "count"
    }, v58 = {
        "concreteType": "ConfluenceLikesSummary",
        "kind": "LinkedField",
        "name": "likesSummary",
        "plural": false,
        "selections": [
            v57 /*: any*/ 
        ]
    }, v59 = {
        "alias": "blogPostStatus",
        "kind": "ScalarField",
        "name": "status"
    }, v60 = {
        "concreteType": "ConfluenceBlogPostLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v37 /*: any*/ 
    }, v61 = {
        "alias": "editorVersion",
        "args": v45 /*: any*/ ,
        "concreteType": "ConfluenceBlogPostProperty",
        "kind": "LinkedField",
        "name": "properties",
        "plural": true,
        "selections": v46 /*: any*/ ,
        "storageKey": "properties(keys:[\"editor\"])"
    }, v62 = {
        "concreteType": "ConfluenceBlogPostViewerSummary",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": v54 /*: any*/ 
    }, v63 = {
        "alias": "contentStatus",
        "kind": "ScalarField",
        "name": "status"
    }, v64 = [
        v35 /*: any*/ 
    ], v65 = {
        "concreteType": "ConfluenceEmbedLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v64 /*: any*/ 
    }, v66 = {
        "concreteType": "ConfluenceContentViewerSummary",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": v54 /*: any*/ 
    }, v67 = {
        "concreteType": "ConfluenceDatabaseLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v64 /*: any*/ 
    }, v68 = {
        "concreteType": "ConfluenceWhiteboardLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v64 /*: any*/ 
    }, v69 = {
        "concreteType": "ConfluenceFolderLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v64 /*: any*/ 
    }, v70 = {
        "concreteType": "SearchProductCount",
        "kind": "LinkedField",
        "name": "totalCounts",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "product"
            },
            v57 /*: any*/ 
        ]
    }, v71 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v72 = [
        {
            "fields": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "containerId",
                            "variableName": "spaceId"
                        },
                        {
                            "kind": "Literal",
                            "name": "product",
                            "value": "confluence"
                        },
                        {
                            "kind": "Variable",
                            "name": "tenantId",
                            "variableName": "tenantId"
                        },
                        {
                            "kind": "Literal",
                            "name": "userId",
                            "value": "context"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "context"
                },
                {
                    "fields": [
                        {
                            "kind": "Literal",
                            "name": "caller",
                            "value": "confluence"
                        },
                        v14 /*: any*/ 
                    ],
                    "kind": "ObjectValue",
                    "name": "modelRequestParams"
                },
                {
                    "kind": "Literal",
                    "name": "requestingUserId",
                    "value": "context"
                }
            ],
            "kind": "ObjectValue",
            "name": "recommendationsQuery"
        }
    ], v73 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "content",
        "plural": true,
        "selections": [
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v31 /*: any*/ ,
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "length",
                        "value": 372
                    }
                ],
                "kind": "ScalarField",
                "name": "excerpt",
                "storageKey": "excerpt(length:372)"
            }
        ]
    }, v74 = [
        v35 /*: any*/ ,
        v36 /*: any*/ ,
        v18 /*: any*/ 
    ], v75 = {
        "concreteType": "ConfluencePageLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v74 /*: any*/ 
    }, v76 = {
        "concreteType": "ConfluenceContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            v43 /*: any*/ ,
            v42 /*: any*/ 
        ]
    }, v77 = {
        "concreteType": "ConfluenceSpace",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v39 /*: any*/ ,
            v48 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v78 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v50 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v79 = {
        "concreteType": "ConfluenceUserInfo",
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v78 /*: any*/ 
        ]
    }, v80 = {
        "kind": "ScalarField",
        "name": "createdAt"
    }, v81 = [
        v79 /*: any*/ ,
        v80 /*: any*/ 
    ], v82 = {
        "concreteType": "ConfluenceBlogPostLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v74 /*: any*/ 
    }, v83 = [
        v18 /*: any*/ ,
        v39 /*: any*/ ,
        v40 /*: any*/ ,
        v17 /*: any*/ 
    ], v84 = {
        "alias": "editorVersion",
        "args": v45 /*: any*/ ,
        "concreteType": "ConfluencePageProperty",
        "kind": "LinkedField",
        "name": "properties",
        "plural": true,
        "selections": v83 /*: any*/ ,
        "storageKey": "properties(keys:[\"editor\"])"
    }, v85 = [
        {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                v18 /*: any*/ ,
                v17 /*: any*/ ,
                v50 /*: any*/ ,
                v26 /*: any*/ 
            ]
        },
        v17 /*: any*/ 
    ], v86 = {
        "concreteType": "ConfluenceUserInfo",
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": v85 /*: any*/ 
    }, v87 = {
        "concreteType": "ConfluenceUserInfo",
        "kind": "LinkedField",
        "name": "owner",
        "plural": false,
        "selections": v85 /*: any*/ 
    }, v88 = {
        "alias": "editorVersion",
        "args": v45 /*: any*/ ,
        "concreteType": "ConfluenceBlogPostProperty",
        "kind": "LinkedField",
        "name": "properties",
        "plural": true,
        "selections": v83 /*: any*/ ,
        "storageKey": "properties(keys:[\"editor\"])"
    }, v89 = {
        "kind": "InlineFragment",
        "selections": [
            v17 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v90 = {
        "concreteType": "ConfluenceUserInfo",
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v78 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v91 = [
        v90 /*: any*/ ,
        v80 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SearchResultsAGGSearchQuery",
            "selections": [
                {
                    "concreteType": "SearchQueryAPI",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "results",
                            "args": v15 /*: any*/ ,
                            "concreteType": "SearchItemConnection",
                            "kind": "LinkedField",
                            "name": "search",
                            "plural": false,
                            "selections": [
                                v16 /*: any*/ ,
                                {
                                    "concreteType": "SearchResultItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v27 /*: any*/ ,
                                                        {
                                                            "condition": "isLicensed",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "alias": "watchDialogContent",
                                                                    "concreteType": "Content",
                                                                    "kind": "LinkedField",
                                                                    "name": "content",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "Space",
                                                                            "kind": "LinkedField",
                                                                            "name": "space",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v29 /*: any*/ ,
                                                                                v30 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v32 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "confluenceEntity",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v33 /*: any*/ ,
                                                                        v34 /*: any*/ ,
                                                                        v38 /*: any*/ ,
                                                                        v44 /*: any*/ ,
                                                                        v47 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v53 /*: any*/ ,
                                                                        v55 /*: any*/ ,
                                                                        v56 /*: any*/ ,
                                                                        v58 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluencePage"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v59 /*: any*/ ,
                                                                        v60 /*: any*/ ,
                                                                        v44 /*: any*/ ,
                                                                        v61 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v53 /*: any*/ ,
                                                                        v62 /*: any*/ ,
                                                                        v56 /*: any*/ ,
                                                                        v58 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceBlogPost"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v65 /*: any*/ ,
                                                                        v44 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v53 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        v56 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceEmbed"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v67 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v53 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        v56 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceDatabase"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v68 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v53 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        v56 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceWhiteboard"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v69 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v53 /*: any*/ ,
                                                                        v66 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceFolder"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchConfluencePageBlogAttachment"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v70 /*: any*/ ,
                                v71 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeRecommended",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "SmartsQueryApi",
                            "kind": "LinkedField",
                            "name": "smarts",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v72 /*: any*/ ,
                                    "concreteType": "SmartsRecommendedObject",
                                    "kind": "LinkedField",
                                    "name": "recommendedObject",
                                    "plural": true,
                                    "selections": [
                                        v73 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "object",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v33 /*: any*/ ,
                                                        v34 /*: any*/ ,
                                                        v75 /*: any*/ ,
                                                        v76 /*: any*/ ,
                                                        v55 /*: any*/ ,
                                                        v47 /*: any*/ ,
                                                        v77 /*: any*/ ,
                                                        v79 /*: any*/ ,
                                                        v53 /*: any*/ ,
                                                        {
                                                            "concreteType": "ConfluencePageVersion",
                                                            "kind": "LinkedField",
                                                            "name": "latestVersion",
                                                            "plural": false,
                                                            "selections": v81 /*: any*/ 
                                                        },
                                                        v56 /*: any*/ ,
                                                        v58 /*: any*/ 
                                                    ],
                                                    "type": "ConfluencePage"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v59 /*: any*/ ,
                                                        v82 /*: any*/ ,
                                                        v76 /*: any*/ ,
                                                        v62 /*: any*/ ,
                                                        v61 /*: any*/ ,
                                                        v77 /*: any*/ ,
                                                        v79 /*: any*/ ,
                                                        v53 /*: any*/ ,
                                                        {
                                                            "concreteType": "ConfluenceBlogPostVersion",
                                                            "kind": "LinkedField",
                                                            "name": "latestVersion",
                                                            "plural": false,
                                                            "selections": v81 /*: any*/ 
                                                        },
                                                        v56 /*: any*/ ,
                                                        v58 /*: any*/ 
                                                    ],
                                                    "type": "ConfluenceBlogPost"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v10 /*: any*/ ,
                v1 /*: any*/ ,
                v9 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v11 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ ,
                v8 /*: any*/ ,
                v7 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SearchResultsAGGSearchQuery",
            "selections": [
                {
                    "concreteType": "SearchQueryAPI",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "results",
                            "args": v15 /*: any*/ ,
                            "concreteType": "SearchItemConnection",
                            "kind": "LinkedField",
                            "name": "search",
                            "plural": false,
                            "selections": [
                                v16 /*: any*/ ,
                                {
                                    "concreteType": "SearchResultItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v27 /*: any*/ ,
                                                        v32 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "confluenceEntity",
                                                            "plural": false,
                                                            "selections": [
                                                                v18 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v33 /*: any*/ ,
                                                                        v34 /*: any*/ ,
                                                                        v38 /*: any*/ ,
                                                                        v44 /*: any*/ ,
                                                                        v84 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v86 /*: any*/ ,
                                                                        v87 /*: any*/ ,
                                                                        v55 /*: any*/ ,
                                                                        v56 /*: any*/ ,
                                                                        v58 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluencePage"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v59 /*: any*/ ,
                                                                        v60 /*: any*/ ,
                                                                        v44 /*: any*/ ,
                                                                        v88 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v86 /*: any*/ ,
                                                                        v87 /*: any*/ ,
                                                                        v62 /*: any*/ ,
                                                                        v56 /*: any*/ ,
                                                                        v58 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceBlogPost"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v65 /*: any*/ ,
                                                                        v44 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v86 /*: any*/ ,
                                                                        v87 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        v56 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceEmbed"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v67 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v86 /*: any*/ ,
                                                                        v87 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        v56 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceDatabase"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v68 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v86 /*: any*/ ,
                                                                        v87 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        v56 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceWhiteboard"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v69 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v86 /*: any*/ ,
                                                                        v87 /*: any*/ ,
                                                                        v66 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceFolder"
                                                                },
                                                                v89 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "isLicensed",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "alias": "watchDialogContent",
                                                                    "concreteType": "Content",
                                                                    "kind": "LinkedField",
                                                                    "name": "content",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "Space",
                                                                            "kind": "LinkedField",
                                                                            "name": "space",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v29 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v17 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchConfluencePageBlogAttachment"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v70 /*: any*/ ,
                                v71 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeRecommended",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "SmartsQueryApi",
                            "kind": "LinkedField",
                            "name": "smarts",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v72 /*: any*/ ,
                                    "concreteType": "SmartsRecommendedObject",
                                    "kind": "LinkedField",
                                    "name": "recommendedObject",
                                    "plural": true,
                                    "selections": [
                                        v73 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "object",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v33 /*: any*/ ,
                                                        v34 /*: any*/ ,
                                                        v75 /*: any*/ ,
                                                        v76 /*: any*/ ,
                                                        v55 /*: any*/ ,
                                                        v84 /*: any*/ ,
                                                        v77 /*: any*/ ,
                                                        v90 /*: any*/ ,
                                                        v87 /*: any*/ ,
                                                        {
                                                            "concreteType": "ConfluencePageVersion",
                                                            "kind": "LinkedField",
                                                            "name": "latestVersion",
                                                            "plural": false,
                                                            "selections": v91 /*: any*/ 
                                                        },
                                                        v56 /*: any*/ ,
                                                        v58 /*: any*/ 
                                                    ],
                                                    "type": "ConfluencePage"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v59 /*: any*/ ,
                                                        v82 /*: any*/ ,
                                                        v76 /*: any*/ ,
                                                        v62 /*: any*/ ,
                                                        v88 /*: any*/ ,
                                                        v77 /*: any*/ ,
                                                        v90 /*: any*/ ,
                                                        v87 /*: any*/ ,
                                                        {
                                                            "concreteType": "ConfluenceBlogPostVersion",
                                                            "kind": "LinkedField",
                                                            "name": "latestVersion",
                                                            "plural": false,
                                                            "selections": v91 /*: any*/ 
                                                        },
                                                        v56 /*: any*/ ,
                                                        v58 /*: any*/ 
                                                    ],
                                                    "type": "ConfluenceBlogPost"
                                                },
                                                v89 /*: any*/ 
                                            ]
                                        },
                                        v17 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "767409598881887aa79d216996b506d5",
            "id": "6841cfcc0970a95f1d151af08e5fdeee1588edf1ca9d6b1e88d51154f26c4932",
            "metadata": {},
            "name": "SearchResultsAGGSearchQuery",
            "operationKind": "query",
            "text": "query SearchResultsAGGSearchQuery($query:String!,$cloudIdARI:[String!]!,$limit:Int!,$entities:[String!]!,$commonFilters:SearchCommonFilter,$confluenceFilters:SearchConfluenceFilter,$sort:[SearchSortInput],$after:String,$disableQueryReplacement:Boolean,$experience:String!,$isLicensed:Boolean!,$includeRecommended:Boolean=false,$spaceId:String!,$tenantId:String!){search{results:search(experience:$experience,query:$query,first:$limit,after:$after,sort:$sort,disableQueryReplacement:$disableQueryReplacement,filters:{entities:$entities,locations:$cloudIdARI,commonFilters:$commonFilters,confluenceFilters:$confluenceFilters}){totalCount,edges{node{id,__typename,description,iconUrl,title,type,url,...on SearchConfluencePageBlogAttachment{lastModified,isVerified,space{id,name,webUiLink},watchDialogContent:content@include(if:$isLicensed){id,__typename,currentUserIsWatching,space{currentUser{isWatched,isWatchingBlogs},operations{operation,targetType},id}},content{id,__typename,blank,excerpt},confluenceEntity{__typename,...on ConfluencePage{id,__typename,title,type,subtype,pageStatus:status,links{webUi,editUi},metadata{titleEmojiPublished{__typename,id,key,value},titleEmojiDraft{__typename,id,key,value}},editorVersion:properties(keys:[\"editor\"]){__typename,key,value,id},space{id,key,alias,name},author{user{__typename,id,picture,name},id},owner{user{__typename,id,picture,name},id},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},likesSummary{count}},...on ConfluenceBlogPost{id,__typename,title,type,blogPostStatus:status,links{webUi,editUi},metadata{titleEmojiPublished{__typename,id,key,value},titleEmojiDraft{__typename,id,key,value}},editorVersion:properties(keys:[\"editor\"]){__typename,key,value,id},space{id,key,alias,name},author{user{__typename,id,picture,name},id},owner{user{__typename,id,picture,name},id},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},likesSummary{count}},...on ConfluenceEmbed{id,__typename,title,type,contentStatus:status,links{webUi},metadata{titleEmojiPublished{__typename,id,key,value},titleEmojiDraft{__typename,id,key,value}},space{id,key,alias,name},author{user{__typename,id,picture,name},id},owner{user{__typename,id,picture,name},id},viewer{favoritedSummary{isFavorite}},commentCountSummary{total}},...on ConfluenceDatabase{id,__typename,title,type,contentStatus:status,links{webUi},space{id,key,alias,name},author{user{__typename,id,picture,name},id},owner{user{__typename,id,picture,name},id},viewer{favoritedSummary{isFavorite}},commentCountSummary{total}},...on ConfluenceWhiteboard{id,__typename,title,type,contentStatus:status,links{webUi},space{id,key,alias,name},author{user{__typename,id,picture,name},id},owner{user{__typename,id,picture,name},id},viewer{favoritedSummary{isFavorite}},commentCountSummary{total}},...on ConfluenceFolder{id,__typename,title,type,contentStatus:status,links{webUi},space{id,key,alias,name},author{user{__typename,id,picture,name},id},owner{user{__typename,id,picture,name},id},viewer{favoritedSummary{isFavorite}}},...on Node{__isNode:__typename,id}}}}},totalCounts{product,count},pageInfo{endCursor}}},smarts@include(if:$includeRecommended){recommendedObject(recommendationsQuery:{context:{userId:\"context\",tenantId:$tenantId,product:\"confluence\",containerId:$spaceId},modelRequestParams:{experience:$experience,caller:\"confluence\"},requestingUserId:\"context\"}){content{id,__typename,blank,excerpt(length:372)},object{__typename,...on ConfluencePage{id,__typename,title,type,subtype,pageStatus:status,links{webUi,editUi,__typename},metadata{titleEmojiDraft{__typename,id,key,value},titleEmojiPublished{__typename,id,key,value}},viewer{favoritedSummary{isFavorite}},editorVersion:properties(keys:[\"editor\"]){__typename,key,value,id},space{id,__typename,key,alias,name},author{user{id,__typename,picture,name},id},owner{user{__typename,id,picture,name},id},latestVersion{author{user{id,__typename,picture,name},id},createdAt},commentCountSummary{total},likesSummary{count}},...on ConfluenceBlogPost{id,__typename,title,type,blogPostStatus:status,links{webUi,editUi,__typename},metadata{titleEmojiDraft{__typename,id,key,value},titleEmojiPublished{__typename,id,key,value}},viewer{favoritedSummary{isFavorite}},editorVersion:properties(keys:[\"editor\"]){__typename,key,value,id},space{id,__typename,key,alias,name},author{user{id,__typename,picture,name},id},owner{user{__typename,id,picture,name},id},latestVersion{author{user{id,__typename,picture,name},id},createdAt},commentCountSummary{total},likesSummary{count}},...on Node{__isNode:__typename,id}},id}}}"
        }
    };
}();
$fdbd89e429f2aa39$var$node.hash = "d1ed786c62b431549c6e881cb261091e";
var $fdbd89e429f2aa39$export$2e2bcd8739ae039 = $fdbd89e429f2aa39$var$node;
module.exports["default"] = $fdbd89e429f2aa39$export$2e2bcd8739ae039;

});

parcelRegister("dC2j7", function(module, exports) {
/* eslint-disable @typescript-eslint/consistent-type-imports, no-unneeded-ternary */ 
var $c3Qwv = parcelRequire("c3Qwv");

const $acb737f2b02900d4$var$CCSortOrder = {
    ASC: 'ASC',
    DESC: 'DESC'
};
const $acb737f2b02900d4$export$3e1423ba918b02c3 = 12;
const $acb737f2b02900d4$export$964ee2c26a2e8aba = {
    page: 'ati:cloud:confluence:page',
    blogpost: 'ati:cloud:confluence:blogpost',
    embed: 'ati:cloud:confluence:embed',
    folder: 'ati:cloud:confluence:folder',
    whiteboard: 'ati:cloud:confluence:whiteboard',
    database: 'ati:cloud:confluence:database'
};
const $acb737f2b02900d4$var$AGG_EXPERIENCE = 'ConfSpacePages';
const $acb737f2b02900d4$var$STARRED_PAGE_LABEL = 'my:favourite';
const $acb737f2b02900d4$export$f471e8a003a4fb0d = (sortBy)=>{
    if (!sortBy) return [];
    const order = sortBy.order === $acb737f2b02900d4$var$CCSortOrder.ASC ? 'ASC' : 'DESC';
    let field;
    switch(sortBy.field){
        case 'LAST_MODIFIED_DATE':
            field = 'latestModifiedDate';
            break;
        case 'TITLE':
            field = 'title';
            break;
        default:
            field = 'latestModifiedDate';
    }
    return [
        {
            field: field,
            order: order
        }
    ];
};
const $acb737f2b02900d4$export$832c8592ab821c21 = ({ cloudId: cloudId, spaceKey: spaceKey, userId: userId, isLicensed: isLicensed, spaceId: spaceId, isWhiteboardEnabled: isWhiteboardEnabled, isDatabaseEnabled: isDatabaseEnabled, searchText: searchText, pagesFilter: pagesFilter, sort: sort, after: after = '', includeRecommended: includeRecommended = false })=>{
    return {
        cloudIdARI: [
            `ari:cloud:confluence::site/${cloudId}`
        ],
        tenantId: cloudId,
        limit: $acb737f2b02900d4$export$3e1423ba918b02c3,
        after: after,
        query: searchText,
        commonFilters: {
            range: {}
        },
        confluenceFilters: {
            spacesFilter: [
                spaceKey
            ],
            ...pagesFilter === 'worked-on' && userId && isLicensed && {
                contributorsFilter: [
                    userId
                ]
            },
            ...pagesFilter === 'starred' && isLicensed && {
                labelsFilter: [
                    $acb737f2b02900d4$var$STARRED_PAGE_LABEL
                ]
            },
            titleMatchOnly: true,
            contentStatuses: [
                'CURRENT',
                'DRAFT'
            ],
            containerStatus: []
        },
        sort: sort ? sort : [],
        entities: [
            $acb737f2b02900d4$export$964ee2c26a2e8aba.page,
            $acb737f2b02900d4$export$964ee2c26a2e8aba.embed,
            $acb737f2b02900d4$export$964ee2c26a2e8aba.folder,
            ...isWhiteboardEnabled ? [
                $acb737f2b02900d4$export$964ee2c26a2e8aba.whiteboard
            ] : [],
            ...isDatabaseEnabled ? [
                $acb737f2b02900d4$export$964ee2c26a2e8aba.database
            ] : []
        ],
        experience: $acb737f2b02900d4$var$AGG_EXPERIENCE,
        spaceId: spaceId,
        isLicensed: Boolean(isLicensed),
        includeRecommended: includeRecommended
    };
};
const $acb737f2b02900d4$export$9afcdf80918a886b = (options)=>{
    const { cloudId: cloudId, spaceKey: spaceKey, queryParams: queryParams, userId: userId, isLicensed: isLicensed, spaceId: spaceId = '', isWhiteboardEnabled: isWhiteboardEnabled = false, isDatabaseEnabled: isDatabaseEnabled = false } = options;
    const pagesFilter = (0, $c3Qwv.getSingleParam)(queryParams, 'pagesFilter');
    const searchText = (0, $c3Qwv.getSingleParam)(queryParams, 'text') || '';
    const sort = [
        {
            field: 'latestModifiedDate',
            order: 'DESC'
        }
    ];
    return $acb737f2b02900d4$export$832c8592ab821c21({
        cloudId: cloudId,
        spaceKey: spaceKey,
        userId: userId,
        isLicensed: isLicensed,
        spaceId: spaceId,
        isWhiteboardEnabled: isWhiteboardEnabled,
        isDatabaseEnabled: isDatabaseEnabled,
        searchText: searchText,
        pagesFilter: pagesFilter,
        sort: sort
    });
};
module.exports["convertCcSortToAggSort"] = $acb737f2b02900d4$export$f471e8a003a4fb0d;
module.exports["getAggSpacePagesQueryVariables"] = $acb737f2b02900d4$export$832c8592ab821c21;
module.exports["getPreloadAggSpacePagesQueryVariables"] = $acb737f2b02900d4$export$9afcdf80918a886b;

});

parcelRegister("yuLaV", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $jH9cM = parcelRequire("jH9cM");


var $3ricL = parcelRequire("3ricL");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $705f1ec06aff7fce$export$dd376e644565eb89 = (contentType)=>{
    if (contentType === 'database' || contentType === 'whiteboard' || contentType === 'slide') {
        if ((0, $9wGTI.fg)('use_frontend_feature_encoding_sdk')) {
            const featureKeyMap = {
                database: 'confluence-databases',
                slide: 'confluence-slides',
                whiteboard: 'confluence-whiteboards'
            };
            const isEnvEnabled = (0, $3ricL.isFeatureEnabled)('confluence', featureKeyMap[contentType], {
                'fedramp-moderate': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_fedramp'),
                'isolated-cloud-commercial': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_ic')
            });
            if (contentType === 'slide') return isEnvEnabled && !(0, $9wGTI.fg)('cc-mui-slides-opted-out') && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
            return isEnvEnabled;
        }
        if (contentType === 'slide') return !(0, $jH9cM.isFedRamp)() && !(0, $9wGTI.fg)('cc-mui-slides-opted-out') && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
        return !(0, $jH9cM.isFedRamp)();
    }
    return true;
};
module.exports["isContentTypeEnabledInCurrentEnv"] = $705f1ec06aff7fce$export$dd376e644565eb89;

});

parcelRegister("aYbn7", function(module, exports) {
/**
 * @generated SignedSource<<3da907304922aa316c0cd54ed0c14713>>
 * @relayHash 7df592bb5fda30e06f43718e9defe250
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 19a2cf3f1071fa87f2247c1bd2cea6e61fa75346876ceb3ad87e1ca8779b8e5d
const $ece8cda195425f0d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "value"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "atlas_doc_format",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "confRev"
                        }
                    ]
                },
                {
                    "alias": "appearancePublished",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "content-appearance-published"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "number"
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "storageKey": "properties(key:\"content-appearance-published\")"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentRendererExternalQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentRendererExternalQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "7df592bb5fda30e06f43718e9defe250",
            "id": "19a2cf3f1071fa87f2247c1bd2cea6e61fa75346876ceb3ad87e1ca8779b8e5d",
            "metadata": {},
            "name": "ContentRendererExternalQuery",
            "operationKind": "query",
            "text": "query ContentRendererExternalQuery($contentId:ID!){singleContent(id:$contentId){id,body{atlas_doc_format{value}},type,version{confRev},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}}}}"
        }
    };
}();
$ece8cda195425f0d$var$node.hash = "8649e53c65ceb270b387846df51531ee";
var $ece8cda195425f0d$export$2e2bcd8739ae039 = $ece8cda195425f0d$var$node;
module.exports["default"] = $ece8cda195425f0d$export$2e2bcd8739ae039;

});

parcelRegister("eP7b6", function(module, exports) {
/**
 * @generated SignedSource<<293007c6777799aa33e10204d25d472b>>
 * @relayHash 002ee32db0695a9b63af69a407a07639
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d8fe2acb674a13f635de2de38cd556b5d67fea5e30e200be8bdac0269751a54
const $0ba271c76ca4c8d2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = {
        "kind": "ScalarField",
        "name": "value"
    }, v4 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v5 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "alias": "appearancePublished",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "content-appearance-published"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": v4 /*: any*/ ,
                    "storageKey": "properties(key:\"content-appearance-published\")"
                },
                {
                    "alias": "emojiTitlePublished",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "emoji-title-published"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": v4 /*: any*/ ,
                    "storageKey": "properties(key:\"emoji-title-published\")"
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "editor"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ],
                    "storageKey": "properties(key:\"editor\")"
                },
                {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                            "kind": "LinkedField",
                            "name": "frontend",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "fabricEditorSupported"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentTitleExternalQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentTitleExternalQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "002ee32db0695a9b63af69a407a07639",
            "id": "5d8fe2acb674a13f635de2de38cd556b5d67fea5e30e200be8bdac0269751a54",
            "metadata": {},
            "name": "ContentTitleExternalQuery",
            "operationKind": "query",
            "text": "query ContentTitleExternalQuery($contentId:ID!){singleContent(id:$contentId){id,title,appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{fabricEditorSupported}}}}"
        }
    };
}();
$0ba271c76ca4c8d2$var$node.hash = "99403818c8d620c95107a7fed0ae3cd7";
var $0ba271c76ca4c8d2$export$2e2bcd8739ae039 = $0ba271c76ca4c8d2$var$node;
module.exports["default"] = $0ba271c76ca4c8d2$export$2e2bcd8739ae039;

});

parcelRegister("9HhEw", function(module, exports) {
/**
 * @generated SignedSource<<79c229d4f4ae3adcbe0b4f7f72920a16>>
 * @relayHash 80f146a83f48be7b9331f291c6222df0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 441a5a61fe71025e06bc5da2cffef931ef0f47310237ad63b8470d65a380d962
const $cb80c8184222fcac$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = [
        v3 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v9 = {
        "kind": "ScalarField",
        "name": "number"
    }, v10 = {
        "kind": "ScalarField",
        "name": "confRev"
    }, v11 = {
        "kind": "ScalarField",
        "name": "syncRev"
    }, v12 = {
        "kind": "ScalarField",
        "name": "contentTypeModified"
    }, v13 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v3 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ExternalByLineQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "lastOwnedBy",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                },
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ExternalByLineQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "lastOwnedBy",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                },
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "80f146a83f48be7b9331f291c6222df0",
            "id": "441a5a61fe71025e06bc5da2cffef931ef0f47310237ad63b8470d65a380d962",
            "metadata": {},
            "name": "ExternalByLineQuery",
            "operationKind": "query",
            "text": "query ExternalByLineQuery($contentId:ID!){singleContent(id:$contentId){id,type,history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId}},ownedBy{__typename,type,displayName,...on KnownUser{accountId}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId}}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,confRev,syncRev,contentTypeModified}}}"
        }
    };
}();
$cb80c8184222fcac$var$node.hash = "012bf9a7497572d73e22134c755e8758";
var $cb80c8184222fcac$export$2e2bcd8739ae039 = $cb80c8184222fcac$var$node;
module.exports["default"] = $cb80c8184222fcac$export$2e2bcd8739ae039;

});

parcelRegister("73cd2", function(module, exports) {
/**
 * @generated SignedSource<<c6c020a68d69e9e48a5ac030b6585a64>>
 * @relayHash 4fdb1f894d6df44e4cf39caaffb8cb1f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a0e4e72ab737980a3ca2f8403bce83b6a5ed72adbe7eada3312127dad645f8d7
const $6373d130d96f71f6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shareToken"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "key"
    }, v4 = {
        "kind": "ScalarField",
        "name": "status"
    }, v5 = {
        "kind": "ScalarField",
        "name": "value"
    }, v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "shareToken",
                    "variableName": "shareToken"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "referenceId"
                },
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "kind": "ScalarField",
                    "name": "subType"
                },
                v4 /*: any*/ ,
                {
                    "concreteType": "ConfluenceAccessLinkInfo",
                    "kind": "LinkedField",
                    "name": "accessLinkInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accessType"
                        },
                        v4 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "createdDate"
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "lastUpdated",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "when"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "friendlyWhen"
                        }
                    ]
                },
                {
                    "alias": "appearancePublished",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "content-appearance-published"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "number"
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "storageKey": "properties(key:\"content-appearance-published\")"
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "editor"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ],
                    "storageKey": "properties(key:\"editor\")"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SharedContentQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SharedContentQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "4fdb1f894d6df44e4cf39caaffb8cb1f",
            "id": "a0e4e72ab737980a3ca2f8403bce83b6a5ed72adbe7eada3312127dad645f8d7",
            "metadata": {},
            "name": "SharedContentQuery",
            "operationKind": "query",
            "text": "query SharedContentQuery($shareToken:String!,$contentId:ID){singleContent(shareToken:$shareToken,id:$contentId){id,referenceId,space{id,key,alias,name},title,type,subType,status,accessLinkInfo{accessType,status},history{createdDate,lastUpdated{when}},version{friendlyWhen},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},properties(key:\"editor\"){nodes{id,key,value}}}}"
        }
    };
}();
$6373d130d96f71f6$var$node.hash = "2aaa01efb1277573924d9d8cb34989ad";
var $6373d130d96f71f6$export$2e2bcd8739ae039 = $6373d130d96f71f6$var$node;
module.exports["default"] = $6373d130d96f71f6$export$2e2bcd8739ae039;

});

parcelRegister("83sfO", function(module, exports) {
const $567f280605647fdf$export$5d4c19aec4201e9 = 'live';
module.exports["LIVE_PAGE_SUBTYPE"] = $567f280605647fdf$export$5d4c19aec4201e9;

});

parcelRegister("5WLjq", function(module, exports) {

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $5IsL6 = parcelRequire("5IsL6");


var $gW6rh = parcelRequire("gW6rh");


var $4H4Pj = parcelRequire("4H4Pj");


var $4eIcx = parcelRequire("4eIcx");


var $5t9S7 = parcelRequire("5t9S7");

const $0075b8fcac3e7fa4$export$19b525d696aff959 = ({ isLicensed: isLicensed, selectedSpaceKey: selectedSpaceKey })=>{
    const preloadQueries = [];
    if (isLicensed) {
        preloadQueries.push((0, $dYU3e.query)({
            query: (0, $gW6rh.default),
            variables: {},
            __callerPackage__: "space-utils"
        }));
        if (selectedSpaceKey) preloadQueries.push((0, $dYU3e.query)({
            query: (0, $4eIcx.default),
            variables: {
                selectedSpaceKey: selectedSpaceKey
            },
            __callerPackage__: "space-utils"
        }));
        else preloadQueries.push((0, $dYU3e.query)({
            query: (0, $4H4Pj.default),
            variables: {},
            __callerPackage__: "space-utils"
        }));
    } else preloadQueries.push((0, $dYU3e.query)({
        query: (0, $5t9S7.default),
        variables: {},
        __callerPackage__: "space-utils"
    }));
    preloadQueries.push((0, $5IsL6.preloadCreateSpace)({
        isLicensed: isLicensed
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(preloadQueries);
};
module.exports["preloadSpacesList"] = $0075b8fcac3e7fa4$export$19b525d696aff959;

});

parcelRegister("5IsL6", function(module, exports) {

var $fEhQK = parcelRequire("fEhQK");


var $dYU3e = parcelRequire("dYU3e");

/**
 * see next/packages/create-space/src/useCanCreateSpace.tsx for the query usage
 */ const $c4ac54148814de4b$var$PreloadCreateSpaceQuery = (0, $fEhQK.default);
const $c4ac54148814de4b$export$25bcc47d8ed557d4 = ({ isLicensed: isLicensed })=>{
    if (!isLicensed) return Promise.resolve({
        data: null
    });
    return (0, $dYU3e.query)({
        query: $c4ac54148814de4b$var$PreloadCreateSpaceQuery,
        __callerPackage__: "create-space-preload"
    });
};
module.exports["preloadCreateSpace"] = $c4ac54148814de4b$export$25bcc47d8ed557d4;

});

parcelRegister("fEhQK", function(module, exports) {
/**
 * @generated SignedSource<<d09735fc2cd7a6020b32121ef039e936>>
 * @relayHash a615654a08ce3274fc54e07efd9211ea
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e5addd49b9ac727e4192ce3ec103b6837173e48788768fc87bc51109c51864cf
const $ba87c6a44dc20089$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "preloadCreateSpaceQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "preloadCreateSpaceQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "a615654a08ce3274fc54e07efd9211ea",
            "id": "e5addd49b9ac727e4192ce3ec103b6837173e48788768fc87bc51109c51864cf",
            "metadata": {},
            "name": "preloadCreateSpaceQuery",
            "operationKind": "query",
            "text": "query preloadCreateSpaceQuery{user:confluence_atlassianUser(current:true){id,confluence{operations{operation}}}}"
        }
    };
}();
$ba87c6a44dc20089$var$node.hash = "9a716c385cdfcba90204a7cf16292b9a";
var $ba87c6a44dc20089$export$2e2bcd8739ae039 = $ba87c6a44dc20089$var$node;
module.exports["default"] = $ba87c6a44dc20089$export$2e2bcd8739ae039;

});

parcelRegister("gW6rh", function(module, exports) {
/**
 * @generated SignedSource<<6731d778ac5ebb58b720918619ebf00d>>
 * @relayHash 3aa9658e6db0cb9714f9e327bc6d5bd0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9732bd17f0f57947436f8213d4305b2e471121c66764a94800bca9ec865695d8
const $af8a2f26164bd677$var$node = function() {
    var v0 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "favourite",
                    "value": true
                },
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 30
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": "current"
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "spaces(favourite:true,first:30,status:\"current\")"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useSpacesDataStarredSpacesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useSpacesDataStarredSpacesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "3aa9658e6db0cb9714f9e327bc6d5bd0",
            "id": "9732bd17f0f57947436f8213d4305b2e471121c66764a94800bca9ec865695d8",
            "metadata": {},
            "name": "useSpacesDataStarredSpacesQuery",
            "operationKind": "query",
            "text": "query useSpacesDataStarredSpacesQuery{spaces(favourite:true,first:30,status:\"current\"){__typename,nodes{alias,id,name,key,status,icon{path}}}}"
        }
    };
}();
$af8a2f26164bd677$var$node.hash = "519f9d02cbfeb4f3f118821c02e3a7b9";
var $af8a2f26164bd677$export$2e2bcd8739ae039 = $af8a2f26164bd677$var$node;
module.exports["default"] = $af8a2f26164bd677$export$2e2bcd8739ae039;

});

parcelRegister("4H4Pj", function(module, exports) {
/**
 * @generated SignedSource<<522284270ccae9ff37ff7a08efdc694a>>
 * @relayHash 0f8f1589411c8c2d9b98218fe1edd493
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 68fe95b23891fbec5be8b12d63fd41809cfcfc27e7e63fbb44888dd38747ee79
const $893f79462ca6be46$var$node = function() {
    var v0 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "limit",
                    "value": 26
                }
            ],
            "concreteType": "MyVisitedSpaces",
            "kind": "LinkedField",
            "name": "myVisitedSpaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MyVisitedSpacesItems",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "spaces",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                },
                                {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "path"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "myVisitedSpaces(limit:26)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useSpacesDataMyVisitedSpacesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useSpacesDataMyVisitedSpacesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "0f8f1589411c8c2d9b98218fe1edd493",
            "id": "68fe95b23891fbec5be8b12d63fd41809cfcfc27e7e63fbb44888dd38747ee79",
            "metadata": {},
            "name": "useSpacesDataMyVisitedSpacesQuery",
            "operationKind": "query",
            "text": "query useSpacesDataMyVisitedSpacesQuery{myVisitedSpaces(limit:26){nodes{spaces{alias,id,name,key,status,icon{path}}}}}"
        }
    };
}();
$893f79462ca6be46$var$node.hash = "7082555a280d4e2eb838dda87a12b019";
var $893f79462ca6be46$export$2e2bcd8739ae039 = $893f79462ca6be46$var$node;
module.exports["default"] = $893f79462ca6be46$export$2e2bcd8739ae039;

});

parcelRegister("4eIcx", function(module, exports) {
/**
 * @generated SignedSource<<2801721cb0c85e92874b08f85a0ef8ee>>
 * @relayHash e0d0ca312e455dd89cba54cfb1984fbb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 526240db83f047ca0274a00241245e9aa0b1109c534c8e0fb8577568d58ba35e
const $f0042d2ade0da40c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "selectedSpaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "alias"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "ScalarField",
        "name": "status"
    }, v6 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v7 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "selectedSpaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isFavourited"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "limit",
                    "value": 26
                }
            ],
            "concreteType": "MyVisitedSpaces",
            "kind": "LinkedField",
            "name": "myVisitedSpaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MyVisitedSpacesItems",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "spaces",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "myVisitedSpaces(limit:26)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery",
            "selections": v7 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery",
            "selections": v7 /*: any*/ 
        },
        "params": {
            "cacheID": "e0d0ca312e455dd89cba54cfb1984fbb",
            "id": "526240db83f047ca0274a00241245e9aa0b1109c534c8e0fb8577568d58ba35e",
            "metadata": {},
            "name": "useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery",
            "operationKind": "query",
            "text": "query useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery($selectedSpaceKey:String){space(key:$selectedSpaceKey){alias,id,name,key,status,icon{path},currentUser{isFavourited}},myVisitedSpaces(limit:26){nodes{spaces{alias,id,name,key,status,icon{path}}}}}"
        }
    };
}();
$f0042d2ade0da40c$var$node.hash = "24da03b127211694c7ed862f0d6a1ac9";
var $f0042d2ade0da40c$export$2e2bcd8739ae039 = $f0042d2ade0da40c$var$node;
module.exports["default"] = $f0042d2ade0da40c$export$2e2bcd8739ae039;

});

parcelRegister("5t9S7", function(module, exports) {
/**
 * @generated SignedSource<<834023d7f0314fe8e5962f6e892c4636>>
 * @relayHash 6a42dba0e2f55d85a4e53a29287ca269
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5e3f4c044b63a16f4dffed6bb0854c1e5cb8e810b97ad22a7a75eed9bb785476
const $410f901cf69fac5d$var$node = function() {
    var v0 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "spaces(first:10)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useSpacesDataAnonymousSpacesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useSpacesDataAnonymousSpacesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "6a42dba0e2f55d85a4e53a29287ca269",
            "id": "5e3f4c044b63a16f4dffed6bb0854c1e5cb8e810b97ad22a7a75eed9bb785476",
            "metadata": {},
            "name": "useSpacesDataAnonymousSpacesQuery",
            "operationKind": "query",
            "text": "query useSpacesDataAnonymousSpacesQuery{spaces(first:10){nodes{alias,id,name,key,status,icon{path}}}}"
        }
    };
}();
$410f901cf69fac5d$var$node.hash = "7f837e22c8d2b27a827944523b07b786";
var $410f901cf69fac5d$export$2e2bcd8739ae039 = $410f901cf69fac5d$var$node;
module.exports["default"] = $410f901cf69fac5d$export$2e2bcd8739ae039;

});

parcelRegister("gGK1T", function(module, exports) {
/**
 * @generated SignedSource<<e983bd00ea24afc042f5f11535352524>>
 * @relayHash b8208417e6c09fc98b947c6af794b0f3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c971c003da78a01cf940b7459511673bdc72b6148aa95f1c43a4a7a4369e8327
const $edbbfe37cbd0175f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": 4,
            "kind": "LocalArgument",
            "name": "limit"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v8 = [
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ], v9 = [
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        }
    ], v10 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentOwnershipContributorsContentOwnershipContributorsQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v8 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v8 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v8 /*: any*/ 
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentOwnershipContributorsContentOwnershipContributorsQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v10 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v10 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v10 /*: any*/ 
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b8208417e6c09fc98b947c6af794b0f3",
            "id": "c971c003da78a01cf940b7459511673bdc72b6148aa95f1c43a4a7a4369e8327",
            "metadata": {},
            "name": "useContentOwnershipContributorsContentOwnershipContributorsQuery",
            "operationKind": "query",
            "text": "query useContentOwnershipContributorsContentOwnershipContributorsQuery($contentId:ID!,$limit:Int=4){content(id:$contentId){nodes{id,history{ownedBy{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}}},version{by{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}}}}},contentContributors(id:$contentId,limit:$limit){nodes{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}}}}"
        }
    };
}();
$edbbfe37cbd0175f$var$node.hash = "e8dd42a19657acc23120ab54c46606ff";
var $edbbfe37cbd0175f$export$2e2bcd8739ae039 = $edbbfe37cbd0175f$var$node;
module.exports["default"] = $edbbfe37cbd0175f$export$2e2bcd8739ae039;

});

parcelRegister("2E1L5", function(module, exports) {
const $f1205e6da653ae62$export$16708f74bd486c8 = 'confluence_page_ownership_changeboarding';
const $f1205e6da653ae62$export$9ed1986df73b834a = 'change-page-ownership-link';
const $f1205e6da653ae62$export$21191b0c00ca25f4 = 10;
const $f1205e6da653ae62$export$83728ea2bd792f67 = {
    USER_IS_NULL: 'You cannot set an owner as an anonymous user.',
    USER_NOT_FOUND: 'Owner id is an invalid account id.',
    USER_MISSING_PAGE_PERMISSION: 'New owner must have view and edit permission on the content.',
    CONTENT_ID_INVALID: 'Content id is invalid.',
    INSUFFICIENT_PERMISSIONS: 'You must be the content creator, owner, or a space admin to set the owner.'
};
const $f1205e6da653ae62$export$f0b683cb64dc68b0 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
const $f1205e6da653ae62$export$b344b39e3835f655 = 'https://support.atlassian.com/confluence-cloud/docs/transfer-ownership-of-your-page-to-another-person/';
const $f1205e6da653ae62$export$7ab4b084abc24ac8 = 'https://support.atlassian.com/confluence-cloud/docs/transfer-ownership-of-your-page-to-another-person/';
module.exports["CONTENT_OWNERSHIP_WEB_ITEM_ID"] = $f1205e6da653ae62$export$9ed1986df73b834a;
module.exports["DEFAULT_CONTRIBUTORS_FETCH_LIMIT"] = $f1205e6da653ae62$export$21191b0c00ca25f4;
module.exports["EXPECTED_ERROR_MESSAGES"] = $f1205e6da653ae62$export$83728ea2bd792f67;
module.exports["PARENT_PAGE_LEARN_MORE_URL"] = $f1205e6da653ae62$export$f0b683cb64dc68b0;
module.exports["CONFIRM_MODAL_LEARN_MORE_LINK"] = $f1205e6da653ae62$export$7ab4b084abc24ac8;

});

parcelRegister("duklN", function(module, exports) {
/**
 * @generated SignedSource<<cc7770e3fb2fd979845343325dfb00a2>>
 * @relayHash 512d3c288e476ca23b45061d9102b2d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2afb2ac9c484784fd55eb2fcafbcb54d438eef15f40b0e4c160a6b625de2a3b
const $78d6c4b2c14ab559$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePageTitlePageTitleQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePageTitlePageTitleQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "512d3c288e476ca23b45061d9102b2d6",
            "id": "e2afb2ac9c484784fd55eb2fcafbcb54d438eef15f40b0e4c160a6b625de2a3b",
            "metadata": {},
            "name": "usePageTitlePageTitleQuery",
            "operationKind": "query",
            "text": "query usePageTitlePageTitleQuery($contentId:ID!){singleContent(id:$contentId){id,title}}"
        }
    };
}();
$78d6c4b2c14ab559$var$node.hash = "49163e20c25d3da0c01ad2e924f87c37";
var $78d6c4b2c14ab559$export$2e2bcd8739ae039 = $78d6c4b2c14ab559$var$node;
module.exports["default"] = $78d6c4b2c14ab559$export$2e2bcd8739ae039;

});

parcelRegister("5Sm9D", function(module, exports) {
/**
 * @generated SignedSource<<4e5e0d9d3bafadb77e44eb00ef09a292>>
 * @relayHash 18c4852f7ec8f6f30016824f3c4be9cb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d694991811b80ccee5c1ce3e650e3bf63a5f29612b9a2458f16fd70e8bdf6d44
const $bcf2a116d61699fa$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeArchiveFolderSupport"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeAutomationDiscovery"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeDevDocsSyncStatus"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeFolderSummary"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeJiraPlannerConnection"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "kind": "ScalarField",
        "name": "type"
    }, v11 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v12 = {
        "kind": "ScalarField",
        "name": "status"
    }, v13 = {
        "kind": "ScalarField",
        "name": "key"
    }, v14 = {
        "kind": "ScalarField",
        "name": "value"
    }, v15 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "number"
            }
        ]
    }, v16 = {
        "args": [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "id"
            },
            {
                "kind": "Literal",
                "name": "status",
                "value": [
                    "CURRENT",
                    "DRAFT"
                ]
            }
        ],
        "concreteType": "PTPage",
        "kind": "LinkedField",
        "name": "ptpage",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "after",
                        "variableName": "after"
                    },
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 40
                    }
                ],
                "concreteType": "PTPaginatedPageList",
                "kind": "LinkedField",
                "name": "children",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "PTPage",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            v8 /*: any*/ ,
                            v9 /*: any*/ ,
                            v12 /*: any*/ ,
                            v10 /*: any*/ ,
                            v11 /*: any*/ ,
                            {
                                "concreteType": "Map_LinkType_String",
                                "kind": "LinkedField",
                                "name": "links",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "webui"
                                    }
                                ]
                            },
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "keys",
                                        "value": [
                                            "emoji-title-published",
                                            "emoji-title-draft",
                                            "editor"
                                        ]
                                    }
                                ],
                                "concreteType": "PaginatedJsonContentPropertyList",
                                "kind": "LinkedField",
                                "name": "properties",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JsonContentProperty",
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": [
                                            v8 /*: any*/ ,
                                            v13 /*: any*/ ,
                                            v14 /*: any*/ ,
                                            v15 /*: any*/ 
                                        ]
                                    }
                                ],
                                "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
                            }
                        ]
                    },
                    {
                        "concreteType": "PTPageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v17 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v18 = {
        "condition": "includeArchiveFolderSupport",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            v12 /*: any*/ ,
            v9 /*: any*/ ,
            v11 /*: any*/ 
        ]
    }, v19 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "condition": "includeArchiveFolderSupport",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "targetType"
                    }
                ]
            }
        ]
    }, v20 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "coverPicture"
                    }
                ]
            }
        ]
    }, v21 = {
        "condition": "includeFolderSummary",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            v15 /*: any*/ ,
            {
                "concreteType": "ContentBodyPerRepresentation",
                "kind": "LinkedField",
                "name": "body",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ContentBody",
                        "kind": "LinkedField",
                        "name": "storage",
                        "plural": false,
                        "selections": [
                            v14 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v22 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v8 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ 
            ]
        }
    ], v23 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "smartFolderProperties"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v22 /*: any*/ ,
        "storageKey": "properties(keys:[\"smartFolderProperties\"])"
    }, v24 = {
        "condition": "includeJiraPlannerConnection",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": "jiraPlannerConnection",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "keys",
                        "value": [
                            "jira-planner-connection"
                        ]
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JsonContentProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            v13 /*: any*/ ,
                            v14 /*: any*/ 
                        ]
                    }
                ],
                "storageKey": "properties(keys:[\"jira-planner-connection\"])"
            }
        ]
    }, v25 = [
        {
            "kind": "Literal",
            "name": "keys",
            "value": [
                "devdocsProperties"
            ]
        }
    ], v26 = {
        "alias": "devDocsOwnershipProperties",
        "args": v25 /*: any*/ ,
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v8 /*: any*/ ,
                    v13 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(keys:[\"devdocsProperties\"])"
    }, v27 = {
        "condition": "includeDevDocsSyncStatus",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": "devDocsProperties",
                "args": v25 /*: any*/ ,
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v22 /*: any*/ ,
                "storageKey": "properties(keys:[\"devdocsProperties\"])"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "FolderOverviewFirstPageQuery",
            "selections": [
                {
                    "condition": "includeAutomationDiscovery",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "contentId",
                                                "variableName": "contentId"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "FolderViewActions_query"
                                    }
                                ],
                                "type": "Query"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "folderViewActions"
                        }
                    ]
                },
                v16 /*: any*/ ,
                {
                    "args": v17 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v18 /*: any*/ ,
                        v19 /*: any*/ ,
                        v20 /*: any*/ ,
                        v21 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        v26 /*: any*/ ,
                        v27 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ ,
                v3 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "FolderOverviewFirstPageQuery",
            "selections": [
                v16 /*: any*/ ,
                {
                    "args": v17 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v18 /*: any*/ ,
                        v19 /*: any*/ ,
                        v20 /*: any*/ ,
                        v21 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        v26 /*: any*/ ,
                        v27 /*: any*/ ,
                        v8 /*: any*/ 
                    ]
                },
                {
                    "condition": "includeAutomationDiscovery",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "user",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "current",
                                    "value": true
                                }
                            ],
                            "concreteType": "AtlassianUser",
                            "kind": "LinkedField",
                            "name": "confluence_atlassianUser",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "AtlassianUserEmail",
                                    "kind": "LinkedField",
                                    "name": "emails",
                                    "plural": true,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "isPrimary"
                                        }
                                    ]
                                },
                                v8 /*: any*/ 
                            ],
                            "storageKey": "confluence_atlassianUser(current:true)"
                        },
                        {
                            "args": v17 /*: any*/ ,
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "singleContent",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "18c4852f7ec8f6f30016824f3c4be9cb",
            "id": "d694991811b80ccee5c1ce3e650e3bf63a5f29612b9a2458f16fd70e8bdf6d44",
            "metadata": {},
            "name": "FolderOverviewFirstPageQuery",
            "operationKind": "query",
            "text": "query FolderOverviewFirstPageQuery($id:ID!,$after:String,$contentId:ID!,$includeDevDocsSyncStatus:Boolean=false,$includeAutomationDiscovery:Boolean=false,$includeFolderSummary:Boolean=false,$includeArchiveFolderSupport:Boolean=false,$includeJiraPlannerConnection:Boolean=false){...FolderViewActions_query_3SK5LQ@include(if:$includeAutomationDiscovery),ptpage(id:$id,status:[CURRENT,DRAFT]){id,title,type,subType,children(first:40,after:$after){nodes{id,title,status,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage,endCursor}}},singleContent(id:$contentId){status@include(if:$includeArchiveFolderSupport)\n    title@include(if:$includeArchiveFolderSupport)\n    subType@include(if:$includeArchiveFolderSupport),operations{operation,targetType@include(if:$includeArchiveFolderSupport)},contentProperties{latest{coverPicture}},version@include(if:$includeFolderSummary){number}\n    body@include(if:$includeFolderSummary){storage{value}},properties(keys:[\"smartFolderProperties\"]){nodes{id,key,value}},jiraPlannerConnection:properties(keys:[\"jira-planner-connection\"])@include(if:$includeJiraPlannerConnection){nodes{key,value}},devDocsOwnershipProperties:properties(keys:[\"devdocsProperties\"]){nodes{id,key}},devDocsProperties:properties(keys:[\"devdocsProperties\"])@include(if:$includeDevDocsSyncStatus){nodes{id,key,value}},id}}fragment AutomationActionsMenu_query_3SK5LQ on Query{...useKeepUpToDateAction_query_3SK5LQ}fragment FolderViewActions_query_3SK5LQ on Query{...AutomationActionsMenu_query_3SK5LQ}fragment useKeepUpToDateAction_query_3SK5LQ on Query{user:confluence_atlassianUser(current:true){emails{value,isPrimary},id},singleContent(id:$contentId){ancestors{id},id}}"
        }
    };
}();
$bcf2a116d61699fa$var$node.hash = "9717d5883492d9cbdc1a8f62d36b484d";
var $bcf2a116d61699fa$export$2e2bcd8739ae039 = $bcf2a116d61699fa$var$node;
module.exports["default"] = $bcf2a116d61699fa$export$2e2bcd8739ae039;

});

parcelRegister("8N95V", function(module, exports) {
/**
 * @generated SignedSource<<1cc0f8340d365118c8b0f69a30f40fe2>>
 * @relayHash 3b5fad1a56c1598624b4b5ffdde44051
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4c049eefe56af2e3d93d69210c8f6fc06cdb796a19b009865dd5ce274d19afd1
const $aa86d7b4cd56d740$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ids"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "ids",
        "variableName": "ids"
    }, v2 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "type",
            "value": "page"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "lastUpdated",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "when"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v8 = [
        {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v3 /*: any*/ ,
                {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "concreteType": "Contributors",
                            "kind": "LinkedField",
                            "name": "contributors",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContributorUsers",
                                    "kind": "LinkedField",
                                    "name": "publishers",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "users",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v9 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "type",
            "value": "folder"
        }
    ], v10 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "type",
            "value": "whiteboard"
        }
    ], v11 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "type",
            "value": "database"
        }
    ], v12 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "type",
            "value": "embed"
        }
    ], v13 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "type",
            "value": "slide"
        }
    ], v14 = [
        {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v3 /*: any*/ ,
                {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "concreteType": "Contributors",
                            "kind": "LinkedField",
                            "name": "contributors",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContributorUsers",
                                    "kind": "LinkedField",
                                    "name": "publishers",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "users",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FolderOverviewChildrenContentQuery",
            "selections": [
                {
                    "alias": "pageContent",
                    "args": v2 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v8 /*: any*/ 
                },
                {
                    "alias": "folderContent",
                    "args": v9 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v8 /*: any*/ 
                },
                {
                    "alias": "whiteboardContent",
                    "args": v10 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v8 /*: any*/ 
                },
                {
                    "alias": "databaseContent",
                    "args": v11 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v8 /*: any*/ 
                },
                {
                    "alias": "embedContent",
                    "args": v12 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v8 /*: any*/ 
                },
                {
                    "alias": "slideContent",
                    "args": v13 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v8 /*: any*/ 
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FolderOverviewChildrenContentQuery",
            "selections": [
                {
                    "alias": "pageContent",
                    "args": v2 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v14 /*: any*/ 
                },
                {
                    "alias": "folderContent",
                    "args": v9 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v14 /*: any*/ 
                },
                {
                    "alias": "whiteboardContent",
                    "args": v10 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v14 /*: any*/ 
                },
                {
                    "alias": "databaseContent",
                    "args": v11 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v14 /*: any*/ 
                },
                {
                    "alias": "embedContent",
                    "args": v12 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v14 /*: any*/ 
                },
                {
                    "alias": "slideContent",
                    "args": v13 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v14 /*: any*/ 
                }
            ]
        },
        "params": {
            "cacheID": "3b5fad1a56c1598624b4b5ffdde44051",
            "id": "4c049eefe56af2e3d93d69210c8f6fc06cdb796a19b009865dd5ce274d19afd1",
            "metadata": {},
            "name": "FolderOverviewChildrenContentQuery",
            "operationKind": "query",
            "text": "query FolderOverviewChildrenContentQuery($ids:[ID!]!){pageContent:content(ids:$ids,type:\"page\"){nodes{id,history{lastUpdated{when},contributors{publishers{users{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}}}},folderContent:content(ids:$ids,type:\"folder\"){nodes{id,history{lastUpdated{when},contributors{publishers{users{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}}}},whiteboardContent:content(ids:$ids,type:\"whiteboard\"){nodes{id,history{lastUpdated{when},contributors{publishers{users{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}}}},databaseContent:content(ids:$ids,type:\"database\"){nodes{id,history{lastUpdated{when},contributors{publishers{users{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}}}},embedContent:content(ids:$ids,type:\"embed\"){nodes{id,history{lastUpdated{when},contributors{publishers{users{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}}}},slideContent:content(ids:$ids,type:\"slide\"){nodes{id,history{lastUpdated{when},contributors{publishers{users{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}}}}}"
        }
    };
}();
$aa86d7b4cd56d740$var$node.hash = "47e4e127b7c7f393d655d6799a3ed4a3";
var $aa86d7b4cd56d740$export$2e2bcd8739ae039 = $aa86d7b4cd56d740$var$node;
module.exports["default"] = $aa86d7b4cd56d740$export$2e2bcd8739ae039;

});

parcelRegister("fDjhq", function(module, exports) {
/**
 * @generated SignedSource<<3109149276b986eaf0299498538eb4cd>>
 * @relayHash 18644583dc162084508502df5d9d10a2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6f47846f5a71e03a8d1c2c0eba57b4116f4d3d9acb67d9cb6a6b27d0d301d0c6
const $15c1c72a72f2cd3e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": 100,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeArchiveFolderSupport"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeAutomationDiscovery"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeDevDocsSyncStatus"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeFolderSummary"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeJiraPlannerConnection"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "parentId"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = {
        "kind": "ScalarField",
        "name": "title"
    }, v12 = {
        "kind": "ScalarField",
        "name": "type"
    }, v13 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v14 = {
        "args": [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "parentId"
            },
            {
                "kind": "Literal",
                "name": "status",
                "value": [
                    "CURRENT",
                    "DRAFT"
                ]
            }
        ],
        "concreteType": "PTPage",
        "kind": "LinkedField",
        "name": "ptpage",
        "plural": false,
        "selections": [
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v12 /*: any*/ ,
            v13 /*: any*/ 
        ]
    }, v15 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "status"
    }, v17 = {
        "condition": "includeArchiveFolderSupport",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            v16 /*: any*/ ,
            v11 /*: any*/ ,
            v13 /*: any*/ 
        ]
    }, v18 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "condition": "includeArchiveFolderSupport",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "targetType"
                    }
                ]
            }
        ]
    }, v19 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "coverPicture"
                    }
                ]
            }
        ]
    }, v20 = {
        "kind": "ScalarField",
        "name": "value"
    }, v21 = {
        "condition": "includeFolderSummary",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "number"
                    }
                ]
            },
            {
                "concreteType": "ContentBodyPerRepresentation",
                "kind": "LinkedField",
                "name": "body",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ContentBody",
                        "kind": "LinkedField",
                        "name": "storage",
                        "plural": false,
                        "selections": [
                            v20 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "key"
    }, v23 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v10 /*: any*/ ,
                v22 /*: any*/ ,
                v20 /*: any*/ 
            ]
        }
    ], v24 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "smartFolderProperties"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v23 /*: any*/ ,
        "storageKey": "properties(keys:[\"smartFolderProperties\"])"
    }, v25 = {
        "condition": "includeJiraPlannerConnection",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": "jiraPlannerConnection",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "keys",
                        "value": [
                            "jira-planner-connection"
                        ]
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JsonContentProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            v22 /*: any*/ ,
                            v20 /*: any*/ 
                        ]
                    }
                ],
                "storageKey": "properties(keys:[\"jira-planner-connection\"])"
            }
        ]
    }, v26 = [
        {
            "kind": "Literal",
            "name": "keys",
            "value": [
                "devdocsProperties"
            ]
        }
    ], v27 = {
        "alias": "devDocsOwnershipProperties",
        "args": v26 /*: any*/ ,
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v10 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(keys:[\"devdocsProperties\"])"
    }, v28 = {
        "condition": "includeDevDocsSyncStatus",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": "devDocsProperties",
                "args": v26 /*: any*/ ,
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v23 /*: any*/ ,
                "storageKey": "properties(keys:[\"devdocsProperties\"])"
            }
        ]
    }, v29 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v30 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v31 = {
        "kind": "Variable",
        "name": "parentId",
        "variableName": "parentId"
    }, v32 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v33 = [
        v29 /*: any*/ ,
        v30 /*: any*/ ,
        v31 /*: any*/ ,
        v32 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "type",
            "value": "FOLDER"
        }
    ], v34 = {
        "kind": "ScalarField",
        "name": "emojiTitlePublished"
    }, v35 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v36 = {
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v23 /*: any*/ 
    }, v37 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v38 = [
        {
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v16 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v34 /*: any*/ ,
                v35 /*: any*/ ,
                v36 /*: any*/ 
            ]
        },
        v37 /*: any*/ 
    ], v39 = [
        v29 /*: any*/ ,
        v30 /*: any*/ ,
        v31 /*: any*/ ,
        v32 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "type",
            "value": "CONTENT"
        }
    ], v40 = [
        {
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v16 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v34 /*: any*/ ,
                v35 /*: any*/ ,
                v36 /*: any*/ 
            ]
        },
        v37 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "DualStreamQueriesFirstPageQuery",
            "selections": [
                {
                    "condition": "includeAutomationDiscovery",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "contentId",
                                                "variableName": "contentId"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "FolderViewActions_query"
                                    }
                                ],
                                "type": "Query"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "folderViewActions"
                        }
                    ]
                },
                v14 /*: any*/ ,
                {
                    "args": v15 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v17 /*: any*/ ,
                        v18 /*: any*/ ,
                        v19 /*: any*/ ,
                        v21 /*: any*/ ,
                        v24 /*: any*/ ,
                        v25 /*: any*/ ,
                        v27 /*: any*/ ,
                        v28 /*: any*/ 
                    ]
                },
                {
                    "alias": "folders",
                    "args": v33 /*: any*/ ,
                    "concreteType": "ConfluenceContentTreeItemConnection",
                    "kind": "LinkedField",
                    "name": "confluence_contentTreeChildren",
                    "plural": false,
                    "selections": v38 /*: any*/ 
                },
                {
                    "alias": "content",
                    "args": v39 /*: any*/ ,
                    "concreteType": "ConfluenceContentTreeItemConnection",
                    "kind": "LinkedField",
                    "name": "confluence_contentTreeChildren",
                    "plural": false,
                    "selections": v38 /*: any*/ 
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ ,
                v3 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "DualStreamQueriesFirstPageQuery",
            "selections": [
                v14 /*: any*/ ,
                {
                    "args": v15 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v17 /*: any*/ ,
                        v18 /*: any*/ ,
                        v19 /*: any*/ ,
                        v21 /*: any*/ ,
                        v24 /*: any*/ ,
                        v25 /*: any*/ ,
                        v27 /*: any*/ ,
                        v28 /*: any*/ ,
                        v10 /*: any*/ 
                    ]
                },
                {
                    "alias": "folders",
                    "args": v33 /*: any*/ ,
                    "concreteType": "ConfluenceContentTreeItemConnection",
                    "kind": "LinkedField",
                    "name": "confluence_contentTreeChildren",
                    "plural": false,
                    "selections": v40 /*: any*/ 
                },
                {
                    "alias": "content",
                    "args": v39 /*: any*/ ,
                    "concreteType": "ConfluenceContentTreeItemConnection",
                    "kind": "LinkedField",
                    "name": "confluence_contentTreeChildren",
                    "plural": false,
                    "selections": v40 /*: any*/ 
                },
                {
                    "condition": "includeAutomationDiscovery",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "user",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "current",
                                    "value": true
                                }
                            ],
                            "concreteType": "AtlassianUser",
                            "kind": "LinkedField",
                            "name": "confluence_atlassianUser",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "AtlassianUserEmail",
                                    "kind": "LinkedField",
                                    "name": "emails",
                                    "plural": true,
                                    "selections": [
                                        v20 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "isPrimary"
                                        }
                                    ]
                                },
                                v10 /*: any*/ 
                            ],
                            "storageKey": "confluence_atlassianUser(current:true)"
                        },
                        {
                            "args": v15 /*: any*/ ,
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "singleContent",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "18644583dc162084508502df5d9d10a2",
            "id": "6f47846f5a71e03a8d1c2c0eba57b4116f4d3d9acb67d9cb6a6b27d0d301d0c6",
            "metadata": {},
            "name": "DualStreamQueriesFirstPageQuery",
            "operationKind": "query",
            "text": "query DualStreamQueriesFirstPageQuery($cloudId:ID!,$parentId:ID!,$spaceKey:String,$contentId:ID!,$first:Int=100,$includeDevDocsSyncStatus:Boolean=false,$includeAutomationDiscovery:Boolean=false,$includeFolderSummary:Boolean=false,$includeArchiveFolderSupport:Boolean=false,$includeJiraPlannerConnection:Boolean=false){...FolderViewActions_query_3SK5LQ@include(if:$includeAutomationDiscovery),ptpage(id:$parentId,status:[CURRENT,DRAFT]){id,title,type,subType},singleContent(id:$contentId){status@include(if:$includeArchiveFolderSupport)\n    title@include(if:$includeArchiveFolderSupport)\n    subType@include(if:$includeArchiveFolderSupport),operations{operation,targetType@include(if:$includeArchiveFolderSupport)},contentProperties{latest{coverPicture}},version@include(if:$includeFolderSummary){number}\n    body@include(if:$includeFolderSummary){storage{value}},properties(keys:[\"smartFolderProperties\"]){nodes{id,key,value}},jiraPlannerConnection:properties(keys:[\"jira-planner-connection\"])@include(if:$includeJiraPlannerConnection){nodes{key,value}},devDocsOwnershipProperties:properties(keys:[\"devdocsProperties\"]){nodes{id,key}},devDocsProperties:properties(keys:[\"devdocsProperties\"])@include(if:$includeDevDocsSyncStatus){nodes{id,key,value}},id},folders:confluence_contentTreeChildren(cloudId:$cloudId,parentId:$parentId,spaceKey:$spaceKey,type:FOLDER,first:$first){nodes{__typename,id,title,status,type,subType,emojiTitlePublished,links{webui},properties{nodes{id,key,value}}},pageInfo{hasNextPage,endCursor}},content:confluence_contentTreeChildren(cloudId:$cloudId,parentId:$parentId,spaceKey:$spaceKey,type:CONTENT,first:$first){nodes{__typename,id,title,status,type,subType,emojiTitlePublished,links{webui},properties{nodes{id,key,value}}},pageInfo{hasNextPage,endCursor}}}fragment AutomationActionsMenu_query_3SK5LQ on Query{...useKeepUpToDateAction_query_3SK5LQ}fragment FolderViewActions_query_3SK5LQ on Query{...AutomationActionsMenu_query_3SK5LQ}fragment useKeepUpToDateAction_query_3SK5LQ on Query{user:confluence_atlassianUser(current:true){emails{value,isPrimary},id},singleContent(id:$contentId){ancestors{id},id}}"
        }
    };
}();
$15c1c72a72f2cd3e$var$node.hash = "fde8fffa3cce30051905c4e27577cb19";
var $15c1c72a72f2cd3e$export$2e2bcd8739ae039 = $15c1c72a72f2cd3e$var$node;
module.exports["default"] = $15c1c72a72f2cd3e$export$2e2bcd8739ae039;

});

parcelRegister("7jfZt", function(module, exports) {
const $41f3867909531b3f$export$f14e72fd46160aae = 100;
const $41f3867909531b3f$export$8ec3d08588d2eeda = 40;
const $41f3867909531b3f$export$52f2a5e5fe3f446b = (folderNodes, contentNodes, foldersExhausted, visibleCount)=>{
    const allFolderNodesShown = visibleCount >= folderNodes.length;
    const showContent = foldersExhausted && allFolderNodesShown;
    if (!showContent) return folderNodes.slice(0, visibleCount);
    const remainingSlots = visibleCount - folderNodes.length;
    const visibleContent = remainingSlots > 0 ? contentNodes.slice(0, remainingSlots) : [];
    return [
        ...folderNodes,
        ...visibleContent
    ];
};
/** Collects the ids of a stream's nodes, skipping any node without an id. */ const $41f3867909531b3f$var$collectIds = (stream)=>{
    const ids = [];
    for (const node of stream?.nodes ?? [])if (node?.id) ids.push(node.id);
    return ids;
};
const $41f3867909531b3f$export$e91dc7634634b3e7 = (folders, content)=>{
    const folderIds = $41f3867909531b3f$var$collectIds(folders);
    const contentIds = $41f3867909531b3f$var$collectIds(content);
    const foldersExhausted = folderIds.length === 0 || !(folders?.pageInfo?.hasNextPage ?? false);
    return $41f3867909531b3f$export$52f2a5e5fe3f446b(folderIds, contentIds, foldersExhausted, $41f3867909531b3f$export$8ec3d08588d2eeda);
};
module.exports["FETCH_SIZE"] = $41f3867909531b3f$export$f14e72fd46160aae;
module.exports["PAGE_SIZE"] = $41f3867909531b3f$export$8ec3d08588d2eeda;
module.exports["selectVisibleNodes"] = $41f3867909531b3f$export$52f2a5e5fe3f446b;
module.exports["getInitialVisibleChildIds"] = $41f3867909531b3f$export$e91dc7634634b3e7;

});

parcelRegister("ieWRE", function(module, exports) {
/**
 * @generated SignedSource<<cc3649e97b9be1d6269151089c18fb3f>>
 * @relayHash 544e060744fb4498c2bc0371295ea8f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44a5510e6c08eb024dc9e65741680c85b5e934e6cb2711735740a5c625e28126
const $89ec832c644948be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFoldersEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSmartFoldersEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsSmartFoldersEnabledQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsSmartFoldersEnabledQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "544e060744fb4498c2bc0371295ea8f5",
            "id": "44a5510e6c08eb024dc9e65741680c85b5e934e6cb2711735740a5c625e28126",
            "metadata": {},
            "name": "useIsSmartFoldersEnabledQuery",
            "operationKind": "query",
            "text": "query useIsSmartFoldersEnabledQuery($spaceKey:String!){space(key:$spaceKey){id,spaceTypeSettings{enabledContentTypes{isFoldersEnabled,isSmartFoldersEnabled}}}}"
        }
    };
}();
$89ec832c644948be$var$node.hash = "03675b093cffce21dc93e86a9415a3c7";
var $89ec832c644948be$export$2e2bcd8739ae039 = $89ec832c644948be$var$node;
module.exports["default"] = $89ec832c644948be$export$2e2bcd8739ae039;

});

parcelRegister("iaK3p", function(module, exports) {
/**
 * @generated SignedSource<<77901a4d26c14ce3e165e61f1fbc7d81>>
 * @relayHash 5f15c23509e6cb7f2874b0f92de8a11b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8c70e28d771c617ecf7c58416cff6761443cf9b61782cdb47a1bb82fdf95ba9f
const $8d30006ecab20121$var$node = function() {
    var v0 = [
        {
            "concreteType": "DiscoveredFeature",
            "kind": "LinkedField",
            "name": "featureDiscovery",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pluginKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "featureKey"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "5f15c23509e6cb7f2874b0f92de8a11b",
            "id": "8c70e28d771c617ecf7c58416cff6761443cf9b61782cdb47a1bb82fdf95ba9f",
            "metadata": {},
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "operationKind": "query",
            "text": "query useFeatureDiscoveryFeatureDiscoveryQuery{featureDiscovery{pluginKey,featureKey}}"
        }
    };
}();
$8d30006ecab20121$var$node.hash = "8577be880df828fbee71c90a7701eddf";
var $8d30006ecab20121$export$2e2bcd8739ae039 = $8d30006ecab20121$var$node;
module.exports["default"] = $8d30006ecab20121$export$2e2bcd8739ae039;

});

parcelRegister("MyxIQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $apw3A = parcelRequire("apw3A");


var $4PX6o = parcelRequire("4PX6o");


var $bkTet = parcelRequire("bkTet");


var $xwvlW = parcelRequire("xwvlW");


var $wPrRK = parcelRequire("wPrRK");


var $1xpoY = parcelRequire("1xpoY");


var $60cDW = parcelRequire("60cDW");


var $d6NtA = parcelRequire("d6NtA");



var $d5fg6 = parcelRequire("d5fg6");


var $0VKZa = parcelRequire("0VKZa");

/**
 * Post Office class for managing in memory cache of Placement queries.
 * We store the cache reference on the global object to persist across SSR requests.
 */ const $cdd1e9f9feeb24fd$var$POST_OFFICE_QUERY_CACHE = globalThis?.__POST_OFFICE_QUERY_CACHE__ || {};
const $cdd1e9f9feeb24fd$var$postOfficeClient = new (0, $d5fg6.PostOfficeCacheClient)($cdd1e9f9feeb24fd$var$POST_OFFICE_QUERY_CACHE);
const $cdd1e9f9feeb24fd$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $cdd1e9f9feeb24fd$export$b3732c8ff6f9c463 = (res)=>{
    if (typeof res === 'undefined') throw new Error('No response from server');
    if (res.ok) return res;
    throw new Error($cdd1e9f9feeb24fd$export$18a0019e5439b209(res));
};
const $cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse = (data)=>{
    const init = {
        status: 200,
        statusText: 'ok!'
    };
    return new Response(JSON.stringify(data), init);
};
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $cdd1e9f9feeb24fd$var$getIsSSR = ()=>Boolean(undefined);
const $cdd1e9f9feeb24fd$var$POST_OFFICE_SERVICE_NAME = 'post-office';
const $cdd1e9f9feeb24fd$var$POST_OFFICE_ARCHETYPE_NAME = 'post-office-archetype';
const $cdd1e9f9feeb24fd$var$confluenceFetcher = async (url, headers, requestInit)=>{
    // When in SPA mode, we want to re-use the pending fetcher if it exists - so that we don't make another Network request from the Transition preloaders
    if (!$cdd1e9f9feeb24fd$var$getIsSSR()) {
        const cachedFetcher = $cdd1e9f9feeb24fd$var$postOfficeClient.getFetcherWithUrl(url);
        if (cachedFetcher) return cachedFetcher;
    }
    let fetcher;
    fetcher = (0, $4PX6o.defaultFetcher)(url, headers, requestInit);
    fetcher = fetcher.then($cdd1e9f9feeb24fd$export$b3732c8ff6f9c463).then((res)=>res.json()).then((data)=>{
        $cdd1e9f9feeb24fd$var$postOfficeClient.setDataWithUrl(url, data);
        return $cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse(data);
    });
    // When we're in SPA mode, we want to cache the fetcher so that it can be reused
    // if the network request takes too long and the data doesn't come back in time
    // before another request is requested by <Placement>
    if (!$cdd1e9f9feeb24fd$var$getIsSSR()) $cdd1e9f9feeb24fd$var$postOfficeClient.setFetcherWithUrl(url, fetcher);
    return fetcher;
};
const $cdd1e9f9feeb24fd$var$cookieMap = new Map([
    [
        'consentToken',
        (0, $bkTet.ATLASSIAN_CONSENT_COOKIE_KEY)
    ],
    [
        'fallbackConsentToken',
        (0, $bkTet.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)
    ]
]);
const $cdd1e9f9feeb24fd$var$mapCookiesToFetchHeaders = (cookies)=>{
    if (typeof cookies !== 'object' || cookies === null) return undefined;
    return Array.from($cdd1e9f9feeb24fd$var$cookieMap.entries()).map(([key, value])=>{
        if (cookies[key]) return `${value}=${cookies[key]}`;
        return '';
    }).filter(Boolean).join(';');
};
/**
 * Common method for setting up the Post Office placement request URL with the environment and product context
 *
 * @param placementId
 * @param contextOptions
 * @returns
 */ const $cdd1e9f9feeb24fd$var$preloadPostOfficePlacement = async (placementId, contextOptions, extraFetchOptions)=>{
    const { postOfficeContext: postOfficeContext, environment: environment } = contextOptions;
    // Mirror client-side guard in Placement.tsx (useInitialDataIfEnabled → isPostOfficePlacementsGloballyDisabled)
    // to prevent SSR/client mismatch when placements are globally disabled (e.g. stableUI=1).
    if (postOfficeContext.disableAllPlacements) return;
    const confluenceFetcherWithS2SHeaders = async (url)=>{
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const isSSR = Boolean(undefined);
        if (isSSR) {
            let hostEnv = 'prod';
            if (environment.currentEnv !== 'production') hostEnv = 'staging';
            const { cookiesConsentToken: cookiesConsentToken, cookiesFallbackToken: cookiesFallbackToken, isBifrostIcRequest: isBifrostIcRequest } = (0, $60cDW.getSSRRenderInputs)();
            const cookies = $cdd1e9f9feeb24fd$var$mapCookiesToFetchHeaders({
                consentToken: cookiesConsentToken,
                fallbackConsentToken: cookiesFallbackToken
            });
            const fetchHeaders = !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': $cdd1e9f9feeb24fd$var$POST_OFFICE_SERVICE_NAME,
                // Tells Tesseract to S2S with `post-office`
                ...isBifrostIcRequest === true ? {
                    'x-archetype-name': $cdd1e9f9feeb24fd$var$POST_OFFICE_ARCHETYPE_NAME
                } : {},
                'x-ssr-service-env': hostEnv // Defaults to current Env, however Post Office is not in dev
            } : {};
            if (cookies) fetchHeaders.Cookie = cookies;
            const finalUrl = (0, $d6NtA.isLocal)() ? url : url.replace('gateway/api/post-office/', '');
            return $cdd1e9f9feeb24fd$var$confluenceFetcher(finalUrl, fetchHeaders, extraFetchOptions?.requestInit);
        }
        return $cdd1e9f9feeb24fd$var$confluenceFetcher(url, undefined, extraFetchOptions?.requestInit);
    };
    const basePath = (0, $apw3A.buildBasePath)(environment.currentEnv, environment.envConfigs);
    return (0, $4PX6o.requestInitialData)(placementId, postOfficeContext, confluenceFetcherWithS2SHeaders, {
        ...basePath,
        resource: extraFetchOptions?.resource
    });
};
const $cdd1e9f9feeb24fd$export$420f2f91a928b3b6 = ()=>{
    return (0, $cozmU.useCallback)((url, requestOptions)=>{
        // Use data in cache if it exists
        const data = $cdd1e9f9feeb24fd$var$postOfficeClient.getDataWithUrl(url);
        if (data) /**
       * Preloaded data must be serialized, however our initialData is expected to be in the form of a Response promise.
       * TODO: Remove this workaround once the Post Office placement API is updated to handle flat data.
       */ return Promise.resolve($cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse(data));
        // When in SPA mode, we want to re-use the pending fetcher if it exists - so that we don't make another Network request from the Placement component
        if (!$cdd1e9f9feeb24fd$var$getIsSSR()) {
            const fetcher = $cdd1e9f9feeb24fd$var$postOfficeClient.getFetcherWithUrl(url);
            if (fetcher) return fetcher;
        }
        // Convert headers to Record<string, string> if present
        let headers = {};
        if (requestOptions?.headers) {
            if (requestOptions.headers instanceof Headers) requestOptions.headers.forEach((value, name)=>{
                headers[name] = value;
            });
            else if (Array.isArray(requestOptions.headers)) requestOptions.headers.forEach(([name, value])=>{
                headers[name] = value;
            });
            else headers = requestOptions.headers;
        }
        // Use a new fetcher if neither data nor fetcher is in cache
        return $cdd1e9f9feeb24fd$var$confluenceFetcher(url, headers, requestOptions);
    }, []);
};
const $cdd1e9f9feeb24fd$export$17b92961ead3f211 = (placementId)=>{
    const [preloadedData, setPreloadedData] = (0, $cozmU.useState)(()=>{
        const data = $cdd1e9f9feeb24fd$var$postOfficeClient.getDataWithPlacementId(placementId);
        if (data) return data;
        return undefined;
    });
    const setter = (0, $cozmU.useCallback)((data)=>{
        $cdd1e9f9feeb24fd$var$postOfficeClient.setDataWithPlacementId(placementId, data);
        setPreloadedData(data);
    }, [
        placementId
    ]);
    return [
        preloadedData,
        setter
    ];
};
const $cdd1e9f9feeb24fd$export$1d2f4123d64ba093 = async (placementId, extraFetchOptions)=>{
    const sessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const postOfficeTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_preload_postoffice_timeout', (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    return (0, $wPrRK.slowQueryGuard)(`preloadPostOfficePlacement:${placementId}`, ()=>$cdd1e9f9feeb24fd$var$preloadPostOfficePlacement(placementId, {
            postOfficeContext: (0, $0VKZa.sessionToPostOfficeContext)(sessionContext),
            environment: {
                currentEnv: (0, $0VKZa.transformConfluenceEnvToPostOfficeEnvironment)(sessionContext.environment)
            }
        }, extraFetchOptions), postOfficeTimeout);
};
module.exports["usePlacementSSRFetch"] = $cdd1e9f9feeb24fd$export$420f2f91a928b3b6;
module.exports["usePlacementPreloadedData"] = $cdd1e9f9feeb24fd$export$17b92961ead3f211;
module.exports["preloadPostOfficePlacementWithSessionContext"] = $cdd1e9f9feeb24fd$export$1d2f4123d64ba093;

});

parcelRegister("apw3A", function(module, exports) {

var $3rMm0 = parcelRequire("3rMm0");


var $jdpvF = parcelRequire("jdpvF");

const $9fbb603c3fc74986$export$e8b30f9c4a80230f = (currentEnv, envConfigs = (0, $jdpvF.defaultEnvironmentValues).envConfigs)=>{
    const baseUrl = envConfigs[currentEnv].api.origin;
    // TypeScript & Safety reasons: Final default to staging-prod API path in case path got overriden somewhere to be undefined, but this should not be the case
    const path = envConfigs[currentEnv].api.pathname ?? (0, $3rMm0.API_PATHNAME_STG_PROD);
    return {
        baseUrl: baseUrl,
        path: path
    };
};
module.exports["buildBasePath"] = $9fbb603c3fc74986$export$e8b30f9c4a80230f;

});

parcelRegister("4PX6o", function(module, exports) {
const $dc9030da747a3f79$export$77754e0ac9f8aba3 = (url, headers, fetchOptions)=>fetch(url, {
        ...fetchOptions,
        headers: {
            credentials: 'include',
            mode: 'cors',
            'Content-Type': 'application/json',
            ...headers,
            ...fetchOptions?.headers
        }
    });
const $dc9030da747a3f79$export$c4c39037cc4b06ab = async (placementId, context, fetcher = $dc9030da747a3f79$export$77754e0ac9f8aba3, options)=>{
    const baseUrl = options.baseUrl;
    const path = options.path;
    const requestUrl = baseUrl ? new URL(path, baseUrl).toString() : path;
    const requestResource = options.resource ? options.resource : '';
    function stringifyObjectValues(input) {
        const entries = Object.entries(input);
        const stringifiedEntries = entries.filter(([, v])=>typeof v !== 'undefined' && v !== null).map(([key, value])=>[
                key,
                String(value)
            ]);
        return Object.fromEntries(stringifiedEntries);
    }
    const contextAsSearchParams = new URLSearchParams(stringifyObjectValues(context));
    contextAsSearchParams.sort();
    const url = encodeURI(`${requestUrl}${placementId}${requestResource}?${contextAsSearchParams.toString()}`);
    // Response will be handled inside the component
    return fetcher(url);
};
module.exports["defaultFetcher"] = $dc9030da747a3f79$export$77754e0ac9f8aba3;
module.exports["requestInitialData"] = $dc9030da747a3f79$export$c4c39037cc4b06ab;

});

parcelRegister("d5fg6", function(module, exports) {
class $2eb32372f08d498d$export$11e1da55bed53d18 {
    getKey(url) {
        const urlMatches = url.match(/placements\/([\w\-/]+)(?:.*updateKey=)?(\w+)?/);
        if (urlMatches?.length && urlMatches.length > 1) return urlMatches.slice(1).filter(Boolean).join('/');
        return url;
    }
    get(key) {
        return this.cache[key];
    }
    set(key, value) {
        this.cache[key] = value;
    }
    getDataWithPlacementId(placementId) {
        return this.get(`placements/${placementId}`)?.data;
    }
    setDataWithPlacementId(placementId, data) {
        this.set(`placements/${placementId}`, {
            data: data,
            fetcher: undefined
        });
    }
    getDataWithUrl(url) {
        return this.get('placements/' + this.getKey(url))?.data;
    }
    setDataWithUrl(url, data) {
        const cache = this.get(`placements/${this.getKey(url)}`);
        this.set(`placements/${this.getKey(url)}`, {
            fetcher: cache?.fetcher,
            data: data
        });
    }
    getFetcherWithUrl(url) {
        return this.get(`placements/${this.getKey(url)}`)?.fetcher;
    }
    setFetcherWithUrl(url, fetcher) {
        const cache = this.get(`placements/${this.getKey(url)}`);
        this.set(`placements/${this.getKey(url)}`, {
            data: cache?.data,
            fetcher: fetcher
        });
    }
    constructor(cache){
        this.cache = cache;
        globalThis.__POST_OFFICE_QUERY_CACHE__ = cache;
    }
}
module.exports["PostOfficeCacheClient"] = $2eb32372f08d498d$export$11e1da55bed53d18;

});

parcelRegister("0VKZa", function(module, exports) {

var $i3jcY = parcelRequire("i3jcY");


var $d9tcB = parcelRequire("d9tcB");

const $e888fb1bd5b30926$var$CONFLUENCE_PRODUCT = 'confluence';
const $e888fb1bd5b30926$var$DEFAULT_POST_OFFICE_CONTEXT = {
    product: $e888fb1bd5b30926$var$CONFLUENCE_PRODUCT,
    locale: 'en'
};
const $e888fb1bd5b30926$var$getWorkspaceARI = ({ cloudId: cloudId, activationId: activationId })=>{
    return `ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
};
const $e888fb1bd5b30926$export$40fdfb947dabfc30 = (sessionData)=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId, locale: locale, orgId: orgId, edition: edition } = sessionData;
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const workspaceAri = $e888fb1bd5b30926$var$getWorkspaceARI({
        activationId: activationId,
        cloudId: cloudId
    });
    return {
        ...$e888fb1bd5b30926$var$DEFAULT_POST_OFFICE_CONTEXT,
        locale: locale,
        orgId: orgId,
        isSiteAdmin: isAdmin,
        tenantId: cloudId === '' ? undefined : cloudId,
        workspaceAri: workspaceAri,
        workspaceId: activationId,
        subproduct: undefined,
        productEdition: edition || undefined,
        disableAllPlacements: (0, $i3jcY.isStableUIEnabledForTests)() ? true : undefined
    };
};
const $e888fb1bd5b30926$export$76d03739bfe0286a = (environment)=>{
    switch(environment){
        case 'STAGING':
            return 'staging';
        case 'PRODUCTION':
            return 'production';
        case 'DEVELOPMENT':
            return 'local';
        default:
            return 'local';
    }
};
module.exports["sessionToPostOfficeContext"] = $e888fb1bd5b30926$export$40fdfb947dabfc30;
module.exports["transformConfluenceEnvToPostOfficeEnvironment"] = $e888fb1bd5b30926$export$76d03739bfe0286a;

});

parcelRegister("i3jcY", function(module, exports) {

const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return (window.location.search ?? '').includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("byPOx", function(module, exports) {
/**
 * @generated SignedSource<<b733e0a60fa7a2103af52ebf9c82676d>>
 * @relayHash 411aa56f960d21732fdea57d6645aefa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a480d9b1888fbb308b36f8f29f5b4576f84e4817c537652251e266c7ab98d45d
const $c11e5f03fd3a6c81$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "team"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasPersonalSpace"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useGetTeamAndSubanchorGetPersonalSpaceKeyQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useGetTeamAndSubanchorGetPersonalSpaceKeyQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "411aa56f960d21732fdea57d6645aefa",
            "id": "a480d9b1888fbb308b36f8f29f5b4576f84e4817c537652251e266c7ab98d45d",
            "metadata": {},
            "name": "useGetTeamAndSubanchorGetPersonalSpaceKeyQuery",
            "operationKind": "query",
            "text": "query useGetTeamAndSubanchorGetPersonalSpaceKeyQuery{user:confluence_atlassianUser(current:true){id,team,confluence{hasPersonalSpace,space{id,key}}}}"
        }
    };
}();
$c11e5f03fd3a6c81$var$node.hash = "d084357d5b8c80b2a717087a9d5973e6";
var $c11e5f03fd3a6c81$export$2e2bcd8739ae039 = $c11e5f03fd3a6c81$var$node;
module.exports["default"] = $c11e5f03fd3a6c81$export$2e2bcd8739ae039;

});

parcelRegister("lWFZM", function(module, exports) {
/**
 * @generated SignedSource<<a28a6d4ece37010a1b3dc61b788601fc>>
 * @relayHash c4dbb1e53daef1b7c8f169a3f50616ce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 83251c724d7af2d6ea333c162ae5a4de26266110e4352c5b02f33510b840978f
const $f9637bad6b9857cf$var$node = function() {
    var v0 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "usePersonalSpace",
                    "value": true
                }
            ],
            "concreteType": "PaginatedTemplateInfoList",
            "kind": "LinkedField",
            "name": "allTemplates",
            "plural": false,
            "selections": [
                {
                    "concreteType": "TemplateInfo",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "templateId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "contentBlueprintId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "blueprintModuleCompleteKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "itemModuleCompleteKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ],
            "storageKey": "allTemplates(usePersonalSpace:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "PersonalizedTemplatesV2AllTemplatesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "PersonalizedTemplatesV2AllTemplatesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "c4dbb1e53daef1b7c8f169a3f50616ce",
            "id": "83251c724d7af2d6ea333c162ae5a4de26266110e4352c5b02f33510b840978f",
            "metadata": {},
            "name": "PersonalizedTemplatesV2AllTemplatesQuery",
            "operationKind": "query",
            "text": "query PersonalizedTemplatesV2AllTemplatesQuery{allTemplates(usePersonalSpace:true){nodes{templateId,contentBlueprintId,blueprintModuleCompleteKey,itemModuleCompleteKey,name}}}"
        }
    };
}();
$f9637bad6b9857cf$var$node.hash = "f89ae5ce759533fd2a0812719d0966df";
var $f9637bad6b9857cf$export$2e2bcd8739ae039 = $f9637bad6b9857cf$var$node;
module.exports["default"] = $f9637bad6b9857cf$export$2e2bcd8739ae039;

});

parcelRegister("l57Xv", function(module, exports) {
/**
 * @generated SignedSource<<23711dc6752a7094995d8efb756e1c1a>>
 * @relayHash 1dbbd240576b496aabf7631bbe5e8317
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ad6fa59108f9429438bd30d3273091c7c3dbac7714e0489bd218aecdc02623cc
const $03e9502d9a3559f4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "accountId"
                }
            ],
            "concreteType": "GrowthUnifiedProfileResult",
            "kind": "LinkedField",
            "name": "growthUnifiedProfile_getUnifiedProfile",
            "plural": false,
            "selections": [
                {
                    "concreteType": "GrowthUnifiedProfilePaidChannelContextByProduct",
                    "kind": "LinkedField",
                    "name": "paidChannelContext",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GrowthUnifiedProfilePaidChannelContext",
                            "kind": "LinkedField",
                            "name": "confluence",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "subAnchor"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useGetTeamAndSubanchorGetSubanchorsAGGQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useGetTeamAndSubanchorGetSubanchorsAGGQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1dbbd240576b496aabf7631bbe5e8317",
            "id": "ad6fa59108f9429438bd30d3273091c7c3dbac7714e0489bd218aecdc02623cc",
            "metadata": {},
            "name": "useGetTeamAndSubanchorGetSubanchorsAGGQuery",
            "operationKind": "query",
            "text": "query useGetTeamAndSubanchorGetSubanchorsAGGQuery($accountId:ID!){growthUnifiedProfile_getUnifiedProfile(accountId:$accountId){paidChannelContext{confluence{subAnchor}}}}"
        }
    };
}();
$03e9502d9a3559f4$var$node.hash = "41238e70a66e2ffbcfc5e10ca0de9d20";
var $03e9502d9a3559f4$export$2e2bcd8739ae039 = $03e9502d9a3559f4$var$node;
module.exports["default"] = $03e9502d9a3559f4$export$2e2bcd8739ae039;

});

parcelRegister("k2RxH", function(module, exports) {

var $kTGj5 = parcelRequire("kTGj5");


var $ctLrB = parcelRequire("ctLrB");


var $7Pigg = parcelRequire("7Pigg");


var $493fu = parcelRequire("493fu");

const $355018d1e9284f84$var$WORKED_ON_EVENT_TYPES_V3 = [
    (0, $ctLrB.ActivityEventType).EDITED,
    (0, $ctLrB.ActivityEventType).PUBLISHED,
    (0, $ctLrB.ActivityEventType).UPDATED,
    (0, $ctLrB.ActivityEventType).CREATED,
    (0, $ctLrB.ActivityEventType).STARTED,
    (0, $ctLrB.ActivityEventType).SNAPSHOTTED
];
const $355018d1e9284f84$var$COLLABORATED_ON_EVENT_TYPES = [
    (0, $ctLrB.ActivityEventType).COMMENTED,
    ...$355018d1e9284f84$var$WORKED_ON_EVENT_TYPES_V3
];
const $355018d1e9284f84$var$OBJECT_TYPES = [
    (0, $ctLrB.ActivitiesObjectType).PAGE,
    (0, $ctLrB.ActivitiesObjectType).BLOGPOST,
    (0, $ctLrB.ActivitiesObjectType).EMBED
];
const $355018d1e9284f84$var$PAGE_SIZE = 24;
const $355018d1e9284f84$export$c0883c47d72a59fc = ({ pill: pill, cloudId: cloudId, endCursor: endCursor, isWhiteboardViewedEnabled: isWhiteboardViewedEnabled, isWhiteboardUpdatedEnabled: isWhiteboardUpdatedEnabled, isDatabaseEnabled: isDatabaseEnabled })=>{
    const createdDateFilter = 'and created >= startOfDay("-90d") ';
    const activityQuery = (0, $7Pigg.default);
    const activityCloudId = (0, $kTGj5.PlatformSiteAri).create({
        siteId: cloudId
    }).toString();
    switch(pill){
        case 'created':
            return {
                query: (0, $493fu.default),
                variables: {
                    cql: `type in (page, blogpost, embed${isWhiteboardUpdatedEnabled ? ', whiteboard' : ''}${isDatabaseEnabled ? ', database' : ''}) and owner=currentUser() ${createdDateFilter}order by created desc`,
                    cqlcontext: `{"contentStatuses":["draft", "current"]}`,
                    first: $355018d1e9284f84$var$PAGE_SIZE,
                    after: endCursor
                }
            };
        case 'worked-on':
            return {
                query: activityQuery,
                variables: {
                    cloudId: activityCloudId,
                    first: $355018d1e9284f84$var$PAGE_SIZE,
                    after: endCursor,
                    eventTypes: $355018d1e9284f84$var$WORKED_ON_EVENT_TYPES_V3,
                    objectTypes: [
                        ...$355018d1e9284f84$var$OBJECT_TYPES,
                        (0, $ctLrB.ActivitiesObjectType).CONTENT,
                        ...isWhiteboardUpdatedEnabled ? [
                            (0, $ctLrB.ActivitiesObjectType).WHITEBOARD
                        ] : [],
                        ...isDatabaseEnabled ? [
                            (0, $ctLrB.ActivitiesObjectType).DATABASE
                        ] : []
                    ]
                }
            };
        case 'collaborated-on':
            return {
                query: activityQuery,
                variables: {
                    cloudId: (0, $kTGj5.PlatformSiteAri).create({
                        siteId: cloudId
                    }).toString(),
                    first: $355018d1e9284f84$var$PAGE_SIZE,
                    after: endCursor,
                    eventTypes: $355018d1e9284f84$var$COLLABORATED_ON_EVENT_TYPES,
                    objectTypes: [
                        ...$355018d1e9284f84$var$OBJECT_TYPES,
                        ...isWhiteboardUpdatedEnabled ? [
                            (0, $ctLrB.ActivitiesObjectType).WHITEBOARD
                        ] : [],
                        ...isDatabaseEnabled ? [
                            (0, $ctLrB.ActivitiesObjectType).DATABASE
                        ] : [],
                        (0, $ctLrB.ActivitiesObjectType).CONTENT,
                        (0, $ctLrB.ActivitiesObjectType).COMMENT
                    ]
                }
            };
        case 'all':
        default:
            return {
                query: activityQuery,
                variables: {
                    cloudId: activityCloudId,
                    first: $355018d1e9284f84$var$PAGE_SIZE,
                    after: endCursor,
                    eventTypes: [],
                    objectTypes: [
                        ...$355018d1e9284f84$var$OBJECT_TYPES,
                        (0, $ctLrB.ActivitiesObjectType).CONTENT,
                        ...isWhiteboardViewedEnabled ? [
                            (0, $ctLrB.ActivitiesObjectType).WHITEBOARD
                        ] : [],
                        ...isDatabaseEnabled ? [
                            (0, $ctLrB.ActivitiesObjectType).DATABASE
                        ] : []
                    ]
                }
            };
    }
};
module.exports["getRecentQueryOptions"] = $355018d1e9284f84$export$c0883c47d72a59fc;

});

parcelRegister("ctLrB", function(module, exports) {

var $5T18X = parcelRequire("5T18X");


var $kSwu1 = parcelRequire("kSwu1");

var $61e4e33a86012bad$export$62aa48085237e36f = /*#__PURE__*/ function(LoadingState) {
    LoadingState[LoadingState["done"] = 0] = "done";
    LoadingState[LoadingState["initial"] = 1] = "initial";
    LoadingState[LoadingState["pagination"] = 2] = "pagination";
    return LoadingState;
}({});
var $61e4e33a86012bad$export$f5dd0176116f8854 = /*#__PURE__*/ function(HomeViewFilters) {
    HomeViewFilters["ALL"] = "ALL";
    HomeViewFilters["WORKED_ON"] = "WORKED_ON";
    HomeViewFilters["CREATED"] = "CREATED";
    HomeViewFilters["STARRED"] = "STARRED";
    HomeViewFilters["TASKS"] = "TASKS";
    HomeViewFilters["DRAFTS"] = "DRAFTS";
    return HomeViewFilters;
}({});
var $61e4e33a86012bad$export$132f858337fea016 = /*#__PURE__*/ function(ActivityEventType) {
    ActivityEventType["ASSIGNED"] = "ASSIGNED";
    ActivityEventType["COMMENTED"] = "COMMENTED";
    ActivityEventType["CREATED"] = "CREATED";
    ActivityEventType["EDITED"] = "EDITED";
    ActivityEventType["LIKED"] = "LIKED";
    ActivityEventType["PUBLISHED"] = "PUBLISHED";
    ActivityEventType["SNAPSHOTTED"] = "SNAPSHOTTED";
    ActivityEventType["STARTED"] = "STARTED";
    ActivityEventType["TRANSITIONED"] = "TRANSITIONED";
    ActivityEventType["UNASSIGNED"] = "UNASSIGNED";
    ActivityEventType["UPDATED"] = "UPDATED";
    ActivityEventType["VIEWED"] = "VIEWED";
    return ActivityEventType;
}({});
var $61e4e33a86012bad$export$4edf00fad4b97379 = /*#__PURE__*/ function(ActivitiesObjectType) {
    ActivitiesObjectType["BLOGPOST"] = "BLOGPOST";
    ActivitiesObjectType["DATABASE"] = "DATABASE";
    ActivitiesObjectType["EMBED"] = "EMBED";
    ActivitiesObjectType["ISSUE"] = "ISSUE";
    ActivitiesObjectType["PAGE"] = "PAGE";
    ActivitiesObjectType["SLIDE"] = "SLIDE";
    ActivitiesObjectType["WHITEBOARD"] = "WHITEBOARD";
    ActivitiesObjectType["CONTENT"] = "CONTENT";
    ActivitiesObjectType["COMMENT"] = "COMMENT";
    return ActivitiesObjectType;
}({});
const $61e4e33a86012bad$var$i18n = (0, $kSwu1.defineMessages)({
    untitled: {
        id: "home.views.untitled",
        defaultMessage: "Untitled"
    }
});
const $61e4e33a86012bad$export$232e7dd3cd551a33 = $61e4e33a86012bad$var$i18n.untitled;
const $61e4e33a86012bad$export$2786ecc2e2951fe3 = (networkStatus)=>{
    if (networkStatus === (0, $5T18X.NetworkStatus).loading || networkStatus === (0, $5T18X.NetworkStatus).setVariables) return 1;
    if (networkStatus === (0, $5T18X.NetworkStatus).fetchMore) return 2;
    return 0;
};
function $61e4e33a86012bad$export$b29ea735dcfba3c1(value) {
    return value !== null && value !== undefined;
}
const $61e4e33a86012bad$export$4b0a6c95b9c45006 = (textFilter, title)=>{
    const trimmedTextFilter = textFilter.trim();
    if (trimmedTextFilter === '') return true;
    return (title || '').toUpperCase().indexOf(textFilter.toUpperCase()) > -1;
};
const $61e4e33a86012bad$export$c29c1699278467fe = (recent, isActivityV3HomeRecent)=>{
    if (recent?.object?.data?.commentId) {
        recent.event.eventType = 'commented';
        recent.object.data = recent?.object?.data?.container;
    }
    const content = recent?.object?.data;
    if (isActivityV3HomeRecent) {
        if (content) {
            content.type = content.type?.toLowerCase();
            if (content.type === 'blog_post') content.type = 'blogpost';
            content.subtype = content.subtype?.toLowerCase();
            // The "status" field is ConfluencePage/ConfluenceBlogPost type for pages/blogs but is
            // ConfluenceContentStatus type for all other content types. To prevent the GraphQL
            // "returns different types" error, we are using the aliases "pageStatus" and "blogStatus"
            content.status = [
                content.status,
                content.pageStatus,
                content.blogStatus
            ].find((status)=>status)?.toLowerCase();
            // FE workaround for activity query returning "status: DRAFT" for published content with unpublished changes
            if (content.status === 'draft' && content.createdAt) content.status = 'current';
        }
        recent.event.eventType = recent.event?.eventType.toUpperCase();
    }
    return recent;
};
const $61e4e33a86012bad$export$7105b33a95adadcf = (content)=>{
    return content?.status !== 'archived';
};
const $61e4e33a86012bad$export$d54a312242c6a930 = (content)=>{
    return content?.status !== 'trashed';
};
const $61e4e33a86012bad$export$78ba6bbd8fcbc43f = (userId, content)=>{
    const createdBy = content?.status === 'draft' ? content?.version?.by : content?.history?.createdBy;
    return userId === createdBy?.accountId;
};
module.exports["LoadingState"] = $61e4e33a86012bad$export$62aa48085237e36f;
module.exports["HomeViewFilters"] = $61e4e33a86012bad$export$f5dd0176116f8854;
module.exports["ActivityEventType"] = $61e4e33a86012bad$export$132f858337fea016;
module.exports["ActivitiesObjectType"] = $61e4e33a86012bad$export$4edf00fad4b97379;
module.exports["untitled"] = $61e4e33a86012bad$export$232e7dd3cd551a33;
module.exports["getLoadingState"] = $61e4e33a86012bad$export$2786ecc2e2951fe3;
module.exports["notEmpty"] = $61e4e33a86012bad$export$b29ea735dcfba3c1;
module.exports["byTitle"] = $61e4e33a86012bad$export$4b0a6c95b9c45006;
module.exports["transformActivityData"] = $61e4e33a86012bad$export$c29c1699278467fe;
module.exports["notArchived"] = $61e4e33a86012bad$export$7105b33a95adadcf;
module.exports["notDeleted"] = $61e4e33a86012bad$export$d54a312242c6a930;
module.exports["isCreatorCurrentUser"] = $61e4e33a86012bad$export$78ba6bbd8fcbc43f;

});

parcelRegister("7Pigg", function(module, exports) {
/**
 * @generated SignedSource<<482cb30e3ae284d8984fc9037a9cc5b4>>
 * @relayHash 3dad6697998a01d7a3ed7ebc02048dd1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c2ea6b5f911e55d36ef6b0b36d1ea8e472c62e46f062984bf199c0ae27820518
const $38dad1ddcca5450a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "eventTypes"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "objectTypes"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "fields": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "eventTypes",
                            "variableName": "eventTypes"
                        },
                        {
                            "kind": "Variable",
                            "name": "objectTypes",
                            "variableName": "objectTypes"
                        },
                        {
                            "kind": "Literal",
                            "name": "products",
                            "value": [
                                "CONFLUENCE"
                            ]
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "arguments"
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "rootContainerIds.0",
                            "variableName": "cloudId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "rootContainerIds"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "AND"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "title"
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "ScalarField",
        "name": "subtype"
    }, v11 = {
        "alias": "pageStatus",
        "kind": "ScalarField",
        "name": "status"
    }, v12 = {
        "kind": "ScalarField",
        "name": "createdAt"
    }, v13 = {
        "kind": "ScalarField",
        "name": "webUi"
    }, v14 = [
        v13 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "editUi"
        }
    ], v15 = {
        "concreteType": "ConfluencePageLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v14 /*: any*/ 
    }, v16 = {
        "concreteType": "ConfluenceBodies",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "excerpt"
            }
        ]
    }, v17 = [
        {
            "concreteType": "ConfluenceFavoritedSummary",
            "kind": "LinkedField",
            "name": "favoritedSummary",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFavorite"
                }
            ]
        }
    ], v18 = {
        "concreteType": "ConfluencePageViewerSummary",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": v17 /*: any*/ 
    }, v19 = {
        "concreteType": "ConfluenceCommentCountSummary",
        "kind": "LinkedField",
        "name": "commentCountSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "total"
            }
        ]
    }, v20 = {
        "concreteType": "ConfluenceSpace",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v21 = {
        "concreteType": "ConfluenceLikesSummary",
        "kind": "LinkedField",
        "name": "likesSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "count"
            }
        ]
    }, v22 = [
        {
            "kind": "Literal",
            "name": "keys",
            "value": [
                "editor"
            ]
        }
    ], v23 = {
        "kind": "ScalarField",
        "name": "value"
    }, v24 = [
        v23 /*: any*/ 
    ], v25 = {
        "concreteType": "ConfluenceContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ConfluenceContentTitleEmoji",
                "kind": "LinkedField",
                "name": "titleEmojiDraft",
                "plural": false,
                "selections": v24 /*: any*/ 
            },
            {
                "concreteType": "ConfluenceContentTitleEmoji",
                "kind": "LinkedField",
                "name": "titleEmojiPublished",
                "plural": false,
                "selections": v24 /*: any*/ 
            }
        ]
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v12 /*: any*/ ,
            v15 /*: any*/ ,
            v16 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ ,
            v20 /*: any*/ ,
            v21 /*: any*/ ,
            {
                "alias": "editorVersion",
                "args": v22 /*: any*/ ,
                "concreteType": "ConfluencePageProperty",
                "kind": "LinkedField",
                "name": "properties",
                "plural": true,
                "selections": v24 /*: any*/ ,
                "storageKey": "properties(keys:[\"editor\"])"
            },
            v25 /*: any*/ 
        ],
        "type": "ConfluencePage"
    }, v27 = {
        "alias": "blogStatus",
        "kind": "ScalarField",
        "name": "status"
    }, v28 = {
        "concreteType": "ConfluenceBlogPostLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v14 /*: any*/ 
    }, v29 = {
        "concreteType": "ConfluenceBlogPostViewerSummary",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": v17 /*: any*/ 
    }, v30 = {
        "alias": "editorVersion",
        "args": v22 /*: any*/ ,
        "concreteType": "ConfluenceBlogPostProperty",
        "kind": "LinkedField",
        "name": "properties",
        "plural": true,
        "selections": v24 /*: any*/ ,
        "storageKey": "properties(keys:[\"editor\"])"
    }, v31 = {
        "kind": "ScalarField",
        "name": "status"
    }, v32 = [
        v13 /*: any*/ 
    ], v33 = {
        "concreteType": "ConfluenceContentViewerSummary",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": v17 /*: any*/ 
    }, v34 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v31 /*: any*/ ,
            {
                "concreteType": "ConfluenceWhiteboardLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v32 /*: any*/ 
            },
            v33 /*: any*/ ,
            v19 /*: any*/ ,
            v20 /*: any*/ 
        ],
        "type": "ConfluenceWhiteboard"
    }, v35 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v31 /*: any*/ ,
            {
                "concreteType": "ConfluenceDatabaseLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v32 /*: any*/ 
            },
            v33 /*: any*/ ,
            v19 /*: any*/ ,
            v20 /*: any*/ 
        ],
        "type": "ConfluenceDatabase"
    }, v36 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v31 /*: any*/ ,
            {
                "concreteType": "ConfluenceEmbedLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v32 /*: any*/ 
            },
            v33 /*: any*/ ,
            v19 /*: any*/ ,
            v20 /*: any*/ ,
            v25 /*: any*/ 
        ],
        "type": "ConfluenceEmbed"
    }, v37 = {
        "kind": "ScalarField",
        "name": "commentId"
    }, v38 = [
        v7 /*: any*/ ,
        v37 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
                v26 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        v27 /*: any*/ ,
                        v28 /*: any*/ ,
                        v16 /*: any*/ ,
                        v29 /*: any*/ ,
                        v19 /*: any*/ ,
                        v20 /*: any*/ ,
                        v30 /*: any*/ ,
                        v25 /*: any*/ 
                    ],
                    "type": "ConfluenceBlogPost"
                },
                v34 /*: any*/ 
            ]
        }
    ], v39 = {
        "concreteType": "ActivityEvent",
        "kind": "LinkedField",
        "name": "event",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "timestamp"
            },
            {
                "kind": "ScalarField",
                "name": "eventType"
            }
        ]
    }, v40 = {
        "concreteType": "ActivityPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v41 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v42 = [
        v23 /*: any*/ ,
        v7 /*: any*/ 
    ], v43 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v12 /*: any*/ ,
            v15 /*: any*/ ,
            v16 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ ,
            v20 /*: any*/ ,
            v21 /*: any*/ ,
            {
                "alias": "editorVersion",
                "args": v22 /*: any*/ ,
                "concreteType": "ConfluencePageProperty",
                "kind": "LinkedField",
                "name": "properties",
                "plural": true,
                "selections": v42 /*: any*/ ,
                "storageKey": "properties(keys:[\"editor\"])"
            },
            v25 /*: any*/ 
        ],
        "type": "ConfluencePage"
    }, v44 = {
        "alias": "editorVersion",
        "args": v22 /*: any*/ ,
        "concreteType": "ConfluenceBlogPostProperty",
        "kind": "LinkedField",
        "name": "properties",
        "plural": true,
        "selections": v42 /*: any*/ ,
        "storageKey": "properties(keys:[\"editor\"])"
    }, v45 = [
        v7 /*: any*/ 
    ], v46 = {
        "kind": "InlineFragment",
        "selections": v45 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v47 = [
        v7 /*: any*/ ,
        v37 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
                v41 /*: any*/ ,
                v43 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        v27 /*: any*/ ,
                        v28 /*: any*/ ,
                        v16 /*: any*/ ,
                        v29 /*: any*/ ,
                        v19 /*: any*/ ,
                        v20 /*: any*/ ,
                        v44 /*: any*/ ,
                        v25 /*: any*/ 
                    ],
                    "type": "ConfluenceBlogPost"
                },
                v34 /*: any*/ ,
                v46 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "HomeRecentActivityQuery",
            "selections": [
                {
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MyActivity",
                            "kind": "LinkedField",
                            "name": "myActivity",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "ActivityConnection",
                                    "kind": "LinkedField",
                                    "name": "all",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ActivityItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "ActivityNode",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "concreteType": "ActivityObject",
                                                            "kind": "LinkedField",
                                                            "name": "object",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v26 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                v27 /*: any*/ ,
                                                                                v12 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v16 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                v20 /*: any*/ ,
                                                                                v21 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v25 /*: any*/ 
                                                                            ],
                                                                            "type": "ConfluenceBlogPost"
                                                                        },
                                                                        v34 /*: any*/ ,
                                                                        v35 /*: any*/ ,
                                                                        v36 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v38 /*: any*/ ,
                                                                            "type": "ConfluenceInlineComment"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v38 /*: any*/ ,
                                                                            "type": "ConfluenceFooterComment"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v39 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v40 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "HomeRecentActivityQuery",
            "selections": [
                {
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MyActivity",
                            "kind": "LinkedField",
                            "name": "myActivity",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "ActivityConnection",
                                    "kind": "LinkedField",
                                    "name": "all",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ActivityItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "ActivityNode",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "concreteType": "ActivityObject",
                                                            "kind": "LinkedField",
                                                            "name": "object",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v41 /*: any*/ ,
                                                                        v43 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                v27 /*: any*/ ,
                                                                                v12 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v16 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v19 /*: any*/ ,
                                                                                v20 /*: any*/ ,
                                                                                v21 /*: any*/ ,
                                                                                v44 /*: any*/ ,
                                                                                v25 /*: any*/ 
                                                                            ],
                                                                            "type": "ConfluenceBlogPost"
                                                                        },
                                                                        v34 /*: any*/ ,
                                                                        v35 /*: any*/ ,
                                                                        v36 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v47 /*: any*/ ,
                                                                            "type": "ConfluenceInlineComment"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v47 /*: any*/ ,
                                                                            "type": "ConfluenceFooterComment"
                                                                        },
                                                                        v46 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v45 /*: any*/ ,
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v45 /*: any*/ ,
                                                                            "type": "MercuryPortfolio"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v39 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v40 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "3dad6697998a01d7a3ed7ebc02048dd1",
            "id": "c2ea6b5f911e55d36ef6b0b36d1ea8e472c62e46f062984bf199c0ae27820518",
            "metadata": {},
            "name": "HomeRecentActivityQuery",
            "operationKind": "query",
            "text": "query HomeRecentActivityQuery($cloudId:ID!,$first:Int,$after:String,$eventTypes:[String!],$objectTypes:[String!]){activity{myActivity{all(filter:{type:AND,rootContainerIds:[$cloudId],arguments:{products:[\"CONFLUENCE\"],objectTypes:$objectTypes,eventTypes:$eventTypes}},first:$first,after:$after){edges{cursor,node{id,object{id,data{__typename,...on ConfluencePage{id,title,type,subtype,pageStatus:status,createdAt,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},likesSummary{count},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceBlogPost{id,title,type,blogStatus:status,createdAt,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},likesSummary{count},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceWhiteboard{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name}},...on ConfluenceDatabase{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name}},...on ConfluenceEmbed{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceInlineComment{id,commentId,container{__typename,...on ConfluencePage{id,title,type,subtype,pageStatus:status,createdAt,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},likesSummary{count},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceBlogPost{id,title,type,blogStatus:status,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceWhiteboard{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name}},...on Node{__isNode:__typename,id}}},...on ConfluenceFooterComment{id,commentId,container{__typename,...on ConfluencePage{id,title,type,subtype,pageStatus:status,createdAt,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},likesSummary{count},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceBlogPost{id,title,type,blogStatus:status,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceWhiteboard{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name}},...on Node{__isNode:__typename,id}}},...on Node{__isNode:__typename,id},...on DevOpsPullRequestDetails{id},...on MercuryPortfolio{id}}},event{id,timestamp,eventType}}},pageInfo{hasNextPage,endCursor}}}}}"
        }
    };
}();
$38dad1ddcca5450a$var$node.hash = "52341ed87e0393b64ab0d4467f335784";
var $38dad1ddcca5450a$export$2e2bcd8739ae039 = $38dad1ddcca5450a$var$node;
module.exports["default"] = $38dad1ddcca5450a$export$2e2bcd8739ae039;

});

parcelRegister("493fu", function(module, exports) {
/**
 * @generated SignedSource<<450d62048a00a7671a0495c232f885c6>>
 * @relayHash f0145d2844cb31576b9be51e3b4df41d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b2a7906eff37e0caa37a462044732c692e9ba5599a2b0e93eb2b126520f4761b
const $c756b2564f8020f1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cqlcontext"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "cql",
            "variableName": "cql"
        },
        {
            "kind": "Variable",
            "name": "cqlcontext",
            "variableName": "cqlcontext"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "title"
    }, v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v9 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v10 = {
        "args": [
            {
                "kind": "Literal",
                "name": "length",
                "value": 372
            }
        ],
        "kind": "ScalarField",
        "name": "excerpt",
        "storageKey": "excerpt(length:372)"
    }, v11 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "commentsCount"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "createdDate"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "key"
    }, v13 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            v5 /*: any*/ ,
            v12 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v14 = {
        "concreteType": "LikesResponse",
        "kind": "LinkedField",
        "name": "likes",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "count"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "status"
    }, v16 = {
        "kind": "ScalarField",
        "name": "blank"
    }, v17 = {
        "kind": "ScalarField",
        "name": "value"
    }, v18 = {
        "alias": "editorVersion",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "editor"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    v12 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(key:\"editor\")"
    }, v19 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    v17 /*: any*/ ,
                    v12 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\"])"
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v21 = [
        v20 /*: any*/ 
    ], v22 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v23 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v20 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "HomeRecentCreatedQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v4 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v21 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": v21 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v22 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "HomeRecentCreatedQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v4 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v23 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": v23 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v22 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f0145d2844cb31576b9be51e3b4df41d",
            "id": "b2a7906eff37e0caa37a462044732c692e9ba5599a2b0e93eb2b126520f4761b",
            "metadata": {},
            "name": "HomeRecentCreatedQuery",
            "operationKind": "query",
            "text": "query HomeRecentCreatedQuery($cql:String!,$cqlcontext:String!,$first:Int,$after:String){search:confluence_search(cql:$cql,cqlcontext:$cqlcontext,first:$first,after:$after){nodes{content{id,title,type,subType,links{webui,editui},excerpt(length:372),metadata{currentuser{favourited{isFavourite}},comments{commentsCount},createdDate},space{alias,id,key,name},likes{count},status,blank,editorVersion:properties(key:\"editor\"){nodes{id,key,value}},emoji:properties(keys:[\"emoji-title-published\"]){nodes{id,value,key}},history{createdBy{__typename,...on KnownUser{accountId}}},version{by{__typename,...on KnownUser{accountId}}}}},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$c756b2564f8020f1$var$node.hash = "85d080eebc369ed2623af7fb67441257";
var $c756b2564f8020f1$export$2e2bcd8739ae039 = $c756b2564f8020f1$var$node;
module.exports["default"] = $c756b2564f8020f1$export$2e2bcd8739ae039;

});

parcelRegister("5dcQK", function(module, exports) {
/**
 * @generated SignedSource<<ab148751716f98f00deddf45b6de3959>>
 * @relayHash 375208eee06e531e31912b7a419f44d0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6ead1382726b260e2d93f54b2da52d4042d91bc06acdee3a39ad5b4709186307
const $a2dc34d339146e99$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "recentFilter"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useRecentPreferencesHomeRecentUserPreferencesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useRecentPreferencesHomeRecentUserPreferencesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "375208eee06e531e31912b7a419f44d0",
            "id": "6ead1382726b260e2d93f54b2da52d4042d91bc06acdee3a39ad5b4709186307",
            "metadata": {},
            "name": "useRecentPreferencesHomeRecentUserPreferencesQuery",
            "operationKind": "query",
            "text": "query useRecentPreferencesHomeRecentUserPreferencesQuery{userPreferences{recentFilter}}"
        }
    };
}();
$a2dc34d339146e99$var$node.hash = "7467140cd6c953941675ec5eab0f0de2";
var $a2dc34d339146e99$export$2e2bcd8739ae039 = $a2dc34d339146e99$var$node;
module.exports["default"] = $a2dc34d339146e99$export$2e2bcd8739ae039;

});

parcelRegister("1abNy", function(module, exports) {
/**
 * @generated SignedSource<<45e1157e30330b381f1779e6a6b13578>>
 * @relayHash 62d0ae3cc424d28cdfd278c6ed4201e3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 02857286577e787ccdd046602aa1cf2c1745318f4c88787491f6db95af2b6f9b
const $4ae0e3efa3fecc57$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "limit"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "start"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ], v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "limit",
                    "variableName": "limit"
                },
                {
                    "kind": "Variable",
                    "name": "start",
                    "variableName": "start"
                }
            ],
            "concreteType": "PaginatedContentList",
            "kind": "LinkedField",
            "name": "favoriteContent",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "subType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "excerpt"
                        },
                        {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "editui"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                }
                            ]
                        },
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "lastUpdated",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "when"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "editorVersion",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "editor"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v3 /*: any*/ ,
                            "storageKey": "properties(key:\"editor\")"
                        },
                        {
                            "alias": "emoji",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "emoji-title-published"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v3 /*: any*/ ,
                            "storageKey": "properties(keys:[\"emoji-title-published\"])"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    "kind": "LinkedField",
                                    "name": "currentuser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "FavouritedSummary",
                                            "kind": "LinkedField",
                                            "name": "favourited",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "RecentlyViewedSummary",
                                            "kind": "LinkedField",
                                            "name": "viewed",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "lastSeen"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "LikesModelMetadataDto",
                                    "kind": "LinkedField",
                                    "name": "likes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                                    "kind": "LinkedField",
                                    "name": "comments",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "commentsCount"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                },
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useStarredDataHomeStarredPagesQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useStarredDataHomeStarredPagesQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "62d0ae3cc424d28cdfd278c6ed4201e3",
            "id": "02857286577e787ccdd046602aa1cf2c1745318f4c88787491f6db95af2b6f9b",
            "metadata": {},
            "name": "useStarredDataHomeStarredPagesQuery",
            "operationKind": "query",
            "text": "query useStarredDataHomeStarredPagesQuery($limit:Int,$start:Int)@allowHigherTimeout{favoriteContent(limit:$limit,start:$start){nodes{id,subType,type,title,excerpt,links{editui,webui},history{lastUpdated{when}},editorVersion:properties(key:\"editor\"){nodes{id,key,value}},emoji:properties(keys:[\"emoji-title-published\"]){nodes{id,key,value}},metadata{currentuser{favourited{isFavourite},viewed{lastSeen}},likes{count},comments{commentsCount}},space{alias,id,key,name}},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$4ae0e3efa3fecc57$var$node.hash = "16905464af1968f88f238bc0c6585634";
var $4ae0e3efa3fecc57$export$2e2bcd8739ae039 = $4ae0e3efa3fecc57$var$node;
module.exports["default"] = $4ae0e3efa3fecc57$export$2e2bcd8739ae039;

});

parcelRegister("d64J2", function(module, exports) {
/**
 * @generated SignedSource<<2d62ef64b860026e339ca7c6a503eb4c>>
 * @relayHash b21205896b56de61c144ea7d0548f80d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1d1b9f41b5612543ef58997db3b4d247971963f3a0117ac3fffe895483a45f2e
const $ed2416599a6e6a62$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cqlcontext"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ], v6 = [
        {
            "alias": "search",
            "args": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "after"
                },
                {
                    "kind": "Literal",
                    "name": "cql",
                    "value": "type in (page,blogpost) order by lastModified desc"
                },
                {
                    "kind": "Variable",
                    "name": "cqlcontext",
                    "variableName": "cqlcontext"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                }
            ],
            "concreteType": "ConfluenceSearchConnection",
            "kind": "LinkedField",
            "name": "confluence_search",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceSearchResponse",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "title"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "subType"
                                },
                                {
                                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "webui"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "editui"
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "length",
                                            "value": 372
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "excerpt",
                                    "storageKey": "excerpt(length:372)"
                                },
                                {
                                    "concreteType": "ContentMetadata",
                                    "kind": "LinkedField",
                                    "name": "metadata",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                            "kind": "LinkedField",
                                            "name": "currentuser",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "FavouritedSummary",
                                                    "kind": "LinkedField",
                                                    "name": "favourited",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isFavourite"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                                            "kind": "LinkedField",
                                            "name": "comments",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "commentsCount"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastModifiedDate"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "alias"
                                        },
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "LikesResponse",
                                    "kind": "LinkedField",
                                    "name": "likes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "blank"
                                },
                                {
                                    "alias": "editorVersion",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "editor"
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v5 /*: any*/ ,
                                    "storageKey": "properties(key:\"editor\")"
                                },
                                {
                                    "alias": "emoji",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "keys",
                                            "value": [
                                                "emoji-title-draft"
                                            ]
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v5 /*: any*/ ,
                                    "storageKey": "properties(keys:[\"emoji-title-draft\"])"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useDraftsDataHomeDraftsQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useDraftsDataHomeDraftsQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "b21205896b56de61c144ea7d0548f80d",
            "id": "1d1b9f41b5612543ef58997db3b4d247971963f3a0117ac3fffe895483a45f2e",
            "metadata": {},
            "name": "useDraftsDataHomeDraftsQuery",
            "operationKind": "query",
            "text": "query useDraftsDataHomeDraftsQuery($cqlcontext:String,$first:Int,$after:String){search:confluence_search(cql:\"type in (page,blogpost) order by lastModified desc\",cqlcontext:$cqlcontext,first:$first,after:$after){nodes{content{id,title,type,subType,links{webui,editui},excerpt(length:372),metadata{currentuser{favourited{isFavourite}},comments{commentsCount},lastModifiedDate},space{alias,id,key,name},likes{count},status,blank,editorVersion:properties(key:\"editor\"){nodes{id,key,value}},emoji:properties(keys:[\"emoji-title-draft\"]){nodes{id,key,value}}}},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$ed2416599a6e6a62$var$node.hash = "7618e5a200bb793a16a7e96fb74bdb29";
var $ed2416599a6e6a62$export$2e2bcd8739ae039 = $ed2416599a6e6a62$var$node;
module.exports["default"] = $ed2416599a6e6a62$export$2e2bcd8739ae039;

});

parcelRegister("kgC8N", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ const $8494f2a7cbb1632a$var$PAGE_SIZE = 24;
const $8494f2a7cbb1632a$export$57a6045b566b8b90 = {
    variables: {
        cqlcontext: `{"contentStatuses":["draft"]}`,
        first: $8494f2a7cbb1632a$var$PAGE_SIZE
    }
};
module.exports["DRAFTS_QUERY_OPTIONS"] = $8494f2a7cbb1632a$export$57a6045b566b8b90;

});

parcelRegister("01STT", function(module, exports) {
var $8357fd24c5d501e8$export$27a5bd065ad55220 = /*#__PURE__*/ function(View) {
    View["OVERVIEW"] = "overview";
    View["RECENT"] = "recent";
    View["STARRED"] = "starred";
    View["WATCHING"] = "watching";
    View["DRAFTS"] = "drafts";
    View["TASKS"] = "tasks";
    return View;
}({});
const $8357fd24c5d501e8$export$f183fe8f38c8cf4f = [
    "recent",
    "starred",
    "watching",
    "drafts",
    "tasks"
];
module.exports["View"] = $8357fd24c5d501e8$export$27a5bd065ad55220;
module.exports["SUPPORTED_ROUTES"] = $8357fd24c5d501e8$export$f183fe8f38c8cf4f;

});

parcelRegister("iwZYw", function(module, exports) {
/**
 * @generated SignedSource<<0f601e53264e4335e95f52245f9778c6>>
 * @relayHash 7354786c74bc87b4af0be7aa1c508959
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cabf46c80d68570a7536cd273538fd1d7a98ce651705dc29413ac4754b769dbc
const $3ac726b99ebc60d4$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceAdminAnnouncementBanner",
            "kind": "LinkedField",
            "name": "adminAnnouncementBanner",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "isDismissible"
                },
                {
                    "kind": "ScalarField",
                    "name": "content"
                },
                {
                    "kind": "ScalarField",
                    "name": "appearance"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "updatedAt"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useRegisterAdminAnnouncementBannerQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useRegisterAdminAnnouncementBannerQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "7354786c74bc87b4af0be7aa1c508959",
            "id": "cabf46c80d68570a7536cd273538fd1d7a98ce651705dc29413ac4754b769dbc",
            "metadata": {},
            "name": "useRegisterAdminAnnouncementBannerQuery",
            "operationKind": "query",
            "text": "query useRegisterAdminAnnouncementBannerQuery{adminAnnouncementBanner{id,isDismissible,content,appearance,title,updatedAt}}"
        }
    };
}();
$3ac726b99ebc60d4$var$node.hash = "240e64f11995d52e66311a69dc8032ab";
var $3ac726b99ebc60d4$export$2e2bcd8739ae039 = $3ac726b99ebc60d4$var$node;
module.exports["default"] = $3ac726b99ebc60d4$export$2e2bcd8739ae039;

});

parcelRegister("1hmAp", function(module, exports) {
/**
 * @generated SignedSource<<dc205b784e864c4042673f60370ebfb9>>
 * @relayHash 70e80297d041fb31c0639d661a01c799
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54
const $dc4c6b557b36d823$var$node = function() {
    var v0 = [
        {
            "alias": "storage",
            "concreteType": "ConfluenceStorage",
            "kind": "LinkedField",
            "name": "confluence_storage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "bytesUsed"
                },
                {
                    "kind": "ScalarField",
                    "name": "isStorageEnforcementGracePeriodComplete"
                },
                {
                    "kind": "ScalarField",
                    "name": "gracePeriodEndDate"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "70e80297d041fb31c0639d661a01c799",
            "id": "6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54",
            "metadata": {},
            "name": "useGetCurrentStorageUsageQuery",
            "operationKind": "query",
            "text": "query useGetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed,isStorageEnforcementGracePeriodComplete,gracePeriodEndDate}}"
        }
    };
}();
$dc4c6b557b36d823$var$node.hash = "41d2bf41d832c3866355b26b49942948";
var $dc4c6b557b36d823$export$2e2bcd8739ae039 = $dc4c6b557b36d823$var$node;
module.exports["default"] = $dc4c6b557b36d823$export$2e2bcd8739ae039;

});

parcelRegister("ibNn3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDUvk = parcelRequire("iDUvk");


var $5UaGA = parcelRequire("5UaGA");


var $bGVJw = parcelRequire("bGVJw");


var $5h1mk = parcelRequire("5h1mk");


var $8RKDP = parcelRequire("8RKDP");

const $9a875a626b0d54c7$var$scopesNamesAsString = (scopes = [])=>scopes.map((e)=>e.name).sort().join(',');
const $9a875a626b0d54c7$export$daf66a67c26dc848 = (config)=>{
    const currentScopeNames = $9a875a626b0d54c7$var$scopesNamesAsString(config.scopes);
    const matchScopes = (0, $cozmU.useCallback)((input)=>$9a875a626b0d54c7$export$ec890b48cae4cc1c(config)(input), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        currentScopeNames
    ]);
    const [state, setState] = (0, $cozmU.useState)($9a875a626b0d54c7$var$initialState);
    const route = (0, $5h1mk.usePostOfficeRoute)();
    const context = (0, $bGVJw.usePostOfficeContext)();
    const next = matchScopes({
        route: route,
        context: context
    });
    const nextScopeNames = $9a875a626b0d54c7$var$scopesNamesAsString(next);
    const updateKey = `${currentScopeNames}-${nextScopeNames}`;
    $9a875a626b0d54c7$var$usePostOfficeScopeSpy(state, config);
    (0, $cozmU.useEffect)(()=>{
        if ($9a875a626b0d54c7$export$fcc046cb16c47539({
            next: next,
            state: state,
            treatIntersectionAsSame: config.treatIntersectionAsSame
        })) setState(({ current: current })=>({
                updateKey: (0, $5UaGA.simpleHash)(updateKey),
                current: next,
                previous: current
            }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        updateKey
    ]);
    return state;
};
const $9a875a626b0d54c7$var$initialState = {
    updateKey: undefined,
    current: [],
    previous: []
};
const $9a875a626b0d54c7$var$createMatchScope = ({ route: route, context: context })=>(input)=>{
        const contextMatch = route ? 'pathname' in route ? {
            route: route,
            context: context
        } : route.current ? {
            route: $9a875a626b0d54c7$var$extractRelevantUrlFields(route.current),
            context: context
        } : {
            route: undefined,
            context: context
        } : {
            route: undefined,
            context: context
        };
        const inputMatch = input.when;
        return $9a875a626b0d54c7$export$5c1cef6f5f213829({
            contextMatch: contextMatch,
            inputMatch: inputMatch
        });
    };
const $9a875a626b0d54c7$var$extractRelevantUrlFields = (route)=>{
    const { hostname: hostname, pathname: pathname, search: search } = new URL(route);
    return {
        hostname: hostname,
        pathname: pathname,
        search: search
    };
};
const $9a875a626b0d54c7$export$5c1cef6f5f213829 = ({ contextMatch: contextMatch, inputMatch: inputMatch })=>(0, (/*@__PURE__*/$parcel$interopDefault($iDUvk)))(contextMatch, inputMatch, (contextValue, inputValue)=>$9a875a626b0d54c7$var$isValueMatchDeep({
            contextValue: contextValue,
            inputValue: inputValue
        }));
const $9a875a626b0d54c7$var$isValueMatch = ({ contextValue: contextValue, inputValue: inputValue })=>{
    if (!contextValue || !inputValue) return false;
    if (typeof inputValue === 'string') return contextValue === inputValue;
    if (inputValue?.equals) return contextValue === inputValue.equals;
    if (!inputValue?.matches) return false;
    if (typeof inputValue.matches !== 'string' || typeof contextValue !== 'string') return false;
    return new RegExp(inputValue.matches).test(contextValue);
};
const $9a875a626b0d54c7$var$isValueMatchDeep = ({ contextValue: contextValue, inputValue: inputValue })=>typeof inputValue === 'object' && typeof contextValue === 'object' ? $9a875a626b0d54c7$export$5c1cef6f5f213829({
        contextMatch: contextValue,
        inputMatch: inputValue
    }) : $9a875a626b0d54c7$var$isValueMatch({
        contextValue: contextValue,
        inputValue: inputValue
    });
const $9a875a626b0d54c7$export$ec890b48cae4cc1c = ({ scopes: scopes })=>(input)=>scopes.filter($9a875a626b0d54c7$var$createMatchScope(input)).map((scope)=>({
                name: scope.name
            }));
const $9a875a626b0d54c7$export$fcc046cb16c47539 = ({ next: next, state: state, treatIntersectionAsSame: treatIntersectionAsSame })=>{
    const currentSet = Array.from(new Set(state.current.map((e)=>e.name)));
    const nextSet = Array.from(new Set(next.map((e)=>e.name)));
    if (treatIntersectionAsSame) {
        if (currentSet.length !== 0 && nextSet.length === 0) return true;
    } else {
        if (currentSet.length !== nextSet.length) return true;
    }
    return !nextSet.every((e)=>currentSet.includes(e));
};
// Scope Spy
const $9a875a626b0d54c7$var$usePostOfficeScopeSpy = (state, config)=>{
    if (config?.consoleSpy && typeof window !== 'undefined' && !window?.postOffice?.scopes) {
        const [listen, update] = (0, $8RKDP.createSimplePubSub)();
        window.postOffice = {
            ...window.postOffice,
            scopes: {
                [config?.consoleSpy.name]: {
                    listen: listen,
                    update: update,
                    list: config.scopes
                }
            }
        };
    }
    (0, $cozmU.useEffect)(()=>{
        if (!config?.consoleSpy) return;
        if (!window.postOffice?.scopes) return;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        window.postOffice?.scopes?.[config?.consoleSpy.name]?.update?.(state);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        $9a875a626b0d54c7$var$scopesNamesAsString(state.current)
    ]);
};
module.exports["usePostOfficeContextScope"] = $9a875a626b0d54c7$export$daf66a67c26dc848;
module.exports["createMatchScopes"] = $9a875a626b0d54c7$export$ec890b48cae4cc1c;

});

parcelRegister("iDUvk", function(module, exports) {

var $5du2X = parcelRequire("5du2X");


var $alIi2 = parcelRequire("alIi2");

/**
 * This method is like `_.isMatch` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with five
 * arguments: (objValue, srcValue, index|key, object, source).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, srcValue) {
 *   if (isGreeting(objValue) && isGreeting(srcValue)) {
 *     return true;
 *   }
 * }
 *
 * var object = { 'greeting': 'hello' };
 * var source = { 'greeting': 'hi' };
 *
 * _.isMatchWith(object, source, customizer);
 * // => true
 */ function $d927b313c5b2752a$var$isMatchWith(object, source, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    return $5du2X(object, source, $alIi2(source), customizer);
}
module.exports = $d927b313c5b2752a$var$isMatchWith;

});

parcelRegister("5UaGA", function(module, exports) {
const $8fc9840d3c007d61$export$b211ce59c0ea1cfb = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};
module.exports["simpleHash"] = $8fc9840d3c007d61$export$b211ce59c0ea1cfb;

});

parcelRegister("5h1mk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $6nvBr = parcelRequire("6nvBr");


var $1RMKR = parcelRequire("1RMKR");

const $a524e85936787c13$export$98c77e1bd702ed15 = ({ routeSubscriber: routeSubscriber, initialUrl: initialUrl })=>{
    let state = $a524e85936787c13$var$initializeState({
        initialUrl: initialUrl
    });
    const handleUpdate = (routeChange)=>{
        const next = routeChange.next?.toString();
        if (next === state.current && state.searchParams === routeChange.next?.searchParams) return;
        state = {
            previous: state.current,
            current: next,
            searchParams: routeChange.next?.searchParams
        };
    };
    const subscribe = (next)=>routeSubscriber((routeChange)=>{
            handleUpdate(routeChange);
            next();
        });
    const getSnapshot = ()=>{
        return state;
    };
    return {
        subscribe: subscribe,
        getSnapshot: getSnapshot
    };
};
const $a524e85936787c13$var$usePostOfficeRouteStore = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const { subscribe: subscribe, getSnapshot: getSnapshot } = t0;
    const route = (0, $6nvBr.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return (0, $1RMKR.useStableObject)(route);
} : ({ subscribe: subscribe, getSnapshot: getSnapshot })=>{
    const route = (0, $6nvBr.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return (0, $1RMKR.useStableObject)(route);
};
const $a524e85936787c13$var$initialState = {
    previous: undefined,
    current: undefined,
    searchParams: undefined
};
const $a524e85936787c13$var$initializeState = ({ initialUrl: initialUrl })=>({
        ...$a524e85936787c13$var$initialState,
        current: initialUrl ? initialUrl?.toString() : undefined,
        searchParams: initialUrl?.searchParams
    });
const $a524e85936787c13$export$f7f47a74e8b47b1f = /*#__PURE__*/ (0, $cozmU.createContext)($a524e85936787c13$var$initialState);
const $a524e85936787c13$export$89eadc6b3e5f4e9e = ({ children: children, ...props })=>{
    const ref = (0, $cozmU.useRef)();
    if (!ref.current) ref.current = $a524e85936787c13$export$98c77e1bd702ed15(props);
    const route = $a524e85936787c13$var$usePostOfficeRouteStore(ref.current);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a524e85936787c13$export$f7f47a74e8b47b1f.Provider, {
        value: route
    }, children);
};
const $a524e85936787c13$export$79301b66f7808cd8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($a524e85936787c13$export$f7f47a74e8b47b1f);
} : ()=>(0, $cozmU.useContext)($a524e85936787c13$export$f7f47a74e8b47b1f); //Route listener
module.exports["PostOfficeRouteContext"] = $a524e85936787c13$export$f7f47a74e8b47b1f;
module.exports["PostOfficeRouteProvider"] = $a524e85936787c13$export$89eadc6b3e5f4e9e;
module.exports["usePostOfficeRoute"] = $a524e85936787c13$export$79301b66f7808cd8;

});

parcelRegister("1RMKR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $323d99f2c95b5263$export$cdf98ded28406f69(obj) {
    return Object.entries(obj).sort().flatMap((v)=>v);
}
function $323d99f2c95b5263$export$ed02d4adf2068b08(obj) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $cozmU.useMemo)(()=>obj, $323d99f2c95b5263$export$cdf98ded28406f69(obj));
}
module.exports["useStableObject"] = $323d99f2c95b5263$export$ed02d4adf2068b08;

});

parcelRegister("8RKDP", function(module, exports) {
const $f5ed2f634676d1ae$export$92469b55607f005b = ()=>{
    const subscribers = new Map();
    const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    const publish = (payload)=>{
        subscribers.forEach((callback)=>callback(payload));
    };
    return [
        subscribe,
        publish
    ];
};
module.exports["createSimplePubSub"] = $f5ed2f634676d1ae$export$92469b55607f005b;

});

parcelRegister("6U5eU", function(module, exports) {

var $ghPz3 = parcelRequire("ghPz3");

const $9db2e529afbaed9d$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>(0, $ghPz3.createPlacementComponent)(placementId, Component, placementConfigurationOptions);
module.exports["createPlacementComponent"] = $9db2e529afbaed9d$export$8a57effc6307f916;

});

parcelRegister("ghPz3", function(module, exports) {

var $iSnB4 = parcelRequire("iSnB4");


var $k2UaY = parcelRequire("k2UaY");


var $40SXV = parcelRequire("40SXV");


var $cozmU = parcelRequire("cozmU");


var $8aG6j = parcelRequire("8aG6j");


var $i3S9F = parcelRequire("i3S9F");


var $iQwJa = parcelRequire("iQwJa");

var $1RMKR = parcelRequire("1RMKR");


var $gswTK = parcelRequire("gswTK");

//#region src/create-placement-component/hooks/useComponentError/index.ts
const $bdb63b81fab5fc28$var$useComponentErrorHandling = ({ onEvent: onEvent, onError: onError, fallbackRender: fallbackRender, errorFallback: errorFallback })=>{
    return {
        onError: (0, $cozmU.useCallback)((error, info)=>{
            onEvent?.({
                type: "component-error",
                error: error
            });
            onError?.(error, info);
        }, [
            onEvent,
            onError
        ]),
        fallbackRender: fallbackRender ?? errorFallback
    };
};
//#endregion
//#region src/create-placement-component/index.tsx
const $bdb63b81fab5fc28$export$eaeb39efb2b24b52 = (placementId, Component, placementConfigurationOptions)=>(0, $40SXV.withErrorBoundary)((props)=>{
        if (placementConfigurationOptions?.hideInIsolatedCloud && typeof document !== "undefined" && (0, $i3S9F.isIsolatedCloud)()) return null;
        const { context: contextWithRoute, onEvent: onEvent, initialData: initialData, fetch: fetch, ...componentProps } = props;
        const { postOfficeRoute: route, ...context } = contextWithRoute;
        if ((0, $iQwJa.isPostOfficePlacementsGloballyDisabled)(context)) return null;
        const stableContext = (0, $1RMKR.useStableObject)(context);
        return /* @__PURE__ */ (0, $8aG6j.jsx)((0, $k2UaY.n), {
            initialData: initialData,
            onEvent: onEvent,
            children: /* @__PURE__ */ (0, $8aG6j.jsx)((0, $gswTK.MaybePlacementFetchingProvider), {
                fetch: fetch?.fetch,
                children: /* @__PURE__ */ (0, $8aG6j.jsx)((0, $k2UaY.t), {
                    route: route,
                    context: stableContext,
                    placement: {
                        placementId: placementId
                    },
                    choreographer: placementConfigurationOptions?.choreographer,
                    subscription: placementConfigurationOptions?.subscription,
                    children: /* @__PURE__ */ (0, $8aG6j.jsx)(Component, {
                        context: stableContext,
                        initialData: initialData,
                        ...componentProps
                    })
                })
            })
        });
    });
const $bdb63b81fab5fc28$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>{
    const placement = $bdb63b81fab5fc28$export$eaeb39efb2b24b52(placementId, Component, placementConfigurationOptions);
    return (props)=>{
        const { onError: onError, fallbackRender: fallbackRender } = $bdb63b81fab5fc28$var$useComponentErrorHandling(props);
        return placement({
            ...props,
            errorBoundaryLocation: (0, $iSnB4.n),
            placementId: placementId,
            onError: onError,
            fallbackRender: fallbackRender
        });
    };
};
 //# sourceMappingURL=create-placement-component.mjs.map
module.exports["createPlacementComponent"] = $bdb63b81fab5fc28$export$8a57effc6307f916;

});

parcelRegister("iSnB4", function(module, exports) {
//#region src/create-placement-component/constants/index.ts
const $dbdf92f9d3dda009$export$625550452a3fa3ec = {
    isSiteAdmin: void 0,
    locale: void 0,
    product: void 0,
    subproduct: void 0,
    tenantId: void 0,
    workspaceAri: "no-workspace-ari-available",
    workspaceId: void 0,
    orgId: void 0,
    productEdition: void 0,
    disableAllPlacements: void 0
};
const $dbdf92f9d3dda009$export$7ccc53e8f1e7dfc5 = "create-placement-component";
 //# sourceMappingURL=constants-fSV07SOB.mjs.map
module.exports["t"] = $dbdf92f9d3dda009$export$625550452a3fa3ec;
module.exports["n"] = $dbdf92f9d3dda009$export$7ccc53e8f1e7dfc5;

});

parcelRegister("k2UaY", function(module, exports) {

var $3TXEn = parcelRequire("3TXEn");


var $iSnB4 = parcelRequire("iSnB4");


var $gOWly = parcelRequire("gOWly");


var $cozmU = parcelRequire("cozmU");


var $aHfj2 = parcelRequire("aHfj2");


var $6NRmI = parcelRequire("6NRmI");


var $cXtTj = parcelRequire("cXtTj");


var $8aG6j = parcelRequire("8aG6j");


var $bGVJw = parcelRequire("bGVJw");

var $5h1mk = parcelRequire("5h1mk");

var $1RMKR = parcelRequire("1RMKR");

parcelRequire("eq1BO");
var $f1G3w = parcelRequire("f1G3w");


var $4cICV = parcelRequire("4cICV");


var $jTNdj = parcelRequire("jTNdj");

//#region src/create-placement-component/providers/render-tracker/index.tsx
/**
* List of Placements we do not want to track placement (rendered) for, due to cost reasons, until we have a better solution.
*/ const $e97f91eca0568947$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS = [
    "screen-space-flags"
];
const $e97f91eca0568947$var$RenderTrackerProvider = ({ children: children, placementId: placementId })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $aHfj2.useFirePostOfficeAnalyticsEvents)();
    const subscriptionEnabled = (0, $gOWly.useSubscriptionConfig)().subscription?.enabled ?? false;
    (0, $cozmU.useEffect)(()=>{
        if ($e97f91eca0568947$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS.includes(placementId)) return;
        fireAnalyticsEvent({
            eventType: "track",
            action: "rendered",
            actionSubject: "placement",
            attributes: {
                subscriptionEnabled: subscriptionEnabled
            }
        });
    }, [
        fireAnalyticsEvent,
        placementId,
        subscriptionEnabled
    ]);
    return /* @__PURE__ */ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
//#endregion
//#region src/create-placement-component/providers/stable-analytics/index.tsx
const $e97f91eca0568947$var$postOfficeAnalyticsContextData = {
    attributes: {
        build: {
            c: undefined,
            b: undefined,
            t: undefined
        }
    }
};
const $e97f91eca0568947$var$StableAnaltyicsProvider = ({ children: children })=>{
    return /* @__PURE__ */ (0, $8aG6j.jsx)((0, $f1G3w.PostOfficeAnalyticsContext), {
        data: $e97f91eca0568947$var$postOfficeAnalyticsContextData,
        children: children
    });
};
//#endregion
//#region src/create-placement-component/providers/stable-context/index.tsx
const $e97f91eca0568947$var$StableContextProvider = ({ context: context, children: children })=>{
    const stableContext = (0, $1RMKR.useStableObject)({
        ...(0, $iSnB4.t),
        ...context
    });
    return /* @__PURE__ */ (0, $8aG6j.jsx)((0, $bGVJw.PostOfficeContextProvider), {
        value: stableContext,
        children: children
    });
};
//#endregion
//#region src/create-placement-component/providers/stable-placement/index.tsx
const $e97f91eca0568947$var$StablePlacementProvider = ({ children: children, placement: placement })=>{
    const stableValue = (0, $1RMKR.useStableObject)(placement);
    return /* @__PURE__ */ (0, $8aG6j.jsx)((0, $4cICV.PlacementProvider), {
        value: stableValue,
        children: children
    });
};
//#endregion
//#region src/create-placement-component/hooks/useLocation/index.ts
const $e97f91eca0568947$var$isLocationAvailable = ()=>typeof globalThis !== "undefined" && typeof globalThis.location !== "undefined";
const $e97f91eca0568947$var$useLocationHref = ()=>{
    return $e97f91eca0568947$var$isLocationAvailable() ? globalThis.location.href : void 0;
};
//#endregion
//#region src/create-placement-component/providers/stable-route/index.tsx
const $e97f91eca0568947$var$StableRouteProvider = ({ route: route, children: children })=>{
    const href = $e97f91eca0568947$var$useLocationHref();
    const stableRoute = (0, $1RMKR.useStableObject)(route ?? {
        previous: href,
        current: href,
        searchParams: href ? new URL(href).searchParams : void 0
    });
    return /* @__PURE__ */ (0, $8aG6j.jsx)((0, $5h1mk.PostOfficeRouteContext).Provider, {
        value: stableRoute,
        children: children
    });
};
//#endregion
//#region src/create-placement-component/hooks/usePerformanceTracking/index.ts
const $e97f91eca0568947$var$usePerformanceTracking = ({ onEvent: onEvent, initialData: initialData })=>{
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(initialData !== void 0);
    const onMount = (0, $cozmU.useCallback)(()=>{
        return ()=>onEvent?.({
                type: "unmount"
            });
    }, [
        onEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (initialData) initialData.then(()=>{
            onEvent?.({
                type: "initial-data-complete"
            });
        }).catch((error)=>{
            onEvent?.({
                type: "initial-data-error",
                error: error
            });
        }).finally(()=>{
            setIsLoading(false);
        });
        else setIsLoading(false);
    }, [
        initialData,
        onEvent
    ]);
    const onComponentError = (0, $cozmU.useCallback)((error)=>{
        onEvent?.({
            type: "component-error",
            error: error
        });
    }, [
        onEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isLoading === false) onEvent?.({
            type: "component-ready"
        });
    }, [
        isLoading
    ]);
    return {
        onMount: onMount,
        isLoading: isLoading,
        onComponentError: onComponentError
    };
};
//#endregion
//#region src/create-placement-component/providers/performance-tracking/index.tsx
const $e97f91eca0568947$export$7ccc53e8f1e7dfc5 = (0, $cozmU.memo)(({ children: children, ...props })=>{
    const isUFOEnabled = (0, $cXtTj.default).checkGate("enable_ufo_tracking_in_post_office");
    const { isLoading: isLoading, onMount: onMount } = $e97f91eca0568947$var$usePerformanceTracking(props);
    return /* @__PURE__ */ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            isUFOEnabled && isLoading && /* @__PURE__ */ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOLoadHold, {
                name: (0, $jTNdj.UFOv2).HoldNames.PLACEMENT
            }),
            /* @__PURE__ */ (0, $8aG6j.jsx)((0, $3TXEn.TrackMount), {
                onMount: onMount,
                children: children
            })
        ]
    });
});
/**
* This component fires two UFOv2 segment events:
* - `post-office-placement`: to track overall placement
* - `post-office-placement.{some-placement-id}`: to track individual placement performance
*
* When using this component, ensure that the parent component is only fired once. Otherwise,
* this component will fire these events every time the parent re-renders.
*/ const $e97f91eca0568947$export$43caf9889c228507 = (0, $cozmU.memo)(({ placementId: placementId, children: children })=>{
    /**
	* If feature gate is not enabled, then we just return the children without the
	* UFO segments attached.
	*/ if (!(0, $cXtTj.default).checkGate("post_office_update_ufov2_placements")) return children;
    return /* @__PURE__ */ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOSegment, {
        name: (0, $jTNdj.UFOv2).SegmentNames.PLACEMENT,
        children: /* @__PURE__ */ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOSegment, {
            name: `${(0, $jTNdj.UFOv2).SegmentNames.PLACEMENT}.${placementId}`,
            children: children
        })
    });
});
//#endregion
//#region src/create-placement-component/providers/index.tsx
/**
* Feature gate name for GraphQL subscriptions in Post Office placements.
* When disabled, subscriptions will not be enabled even if configured.
*/ const $e97f91eca0568947$var$POST_OFFICE_GRAPHQL_SUBSCRIPTIONS_FEATURE_GATE = "post-office_graphql_subscriptions_enabled";
/**
* Optional provider that wraps subscription providers only if feature gate is enabled.
*/ const $e97f91eca0568947$var$OptionalPostOfficeSubscriptionsProvider = ({ children: children, subscription: subscription })=>{
    if ((0, $cXtTj.default).checkGate($e97f91eca0568947$var$POST_OFFICE_GRAPHQL_SUBSCRIPTIONS_FEATURE_GATE)) return /* @__PURE__ */ (0, $8aG6j.jsx)((0, $gOWly.StableSubscriptionConfigProvider), {
        subscription: subscription,
        children: children
    });
    return children;
};
const $e97f91eca0568947$export$625550452a3fa3ec = ({ children: children, context: context, placement: placement, route: route, choreographer: choreographer, subscription: subscription })=>{
    return /* @__PURE__ */ (0, $8aG6j.jsx)($e97f91eca0568947$var$StableContextProvider, {
        context: context,
        children: /* @__PURE__ */ (0, $8aG6j.jsx)($e97f91eca0568947$var$StablePlacementProvider, {
            placement: placement,
            children: /* @__PURE__ */ (0, $8aG6j.jsx)($e97f91eca0568947$var$StableRouteProvider, {
                route: route,
                children: /* @__PURE__ */ (0, $8aG6j.jsx)($e97f91eca0568947$var$StableAnaltyicsProvider, {
                    children: /* @__PURE__ */ (0, $8aG6j.jsx)($e97f91eca0568947$var$OptionalPostOfficeSubscriptionsProvider, {
                        subscription: subscription,
                        children: /* @__PURE__ */ (0, $8aG6j.jsx)((0, $6NRmI.StableChoreographerProvider), {
                            choreographer: choreographer,
                            placementId: placement.placementId,
                            children: /* @__PURE__ */ (0, $8aG6j.jsx)($e97f91eca0568947$var$RenderTrackerProvider, {
                                placementId: placement.placementId,
                                children: children
                            })
                        })
                    })
                })
            })
        })
    });
};
 //# sourceMappingURL=providers-Dugy3MKY.mjs.map
module.exports["n"] = $e97f91eca0568947$export$7ccc53e8f1e7dfc5;
module.exports["r"] = $e97f91eca0568947$export$43caf9889c228507;
module.exports["t"] = $e97f91eca0568947$export$625550452a3fa3ec;

});

parcelRegister("3TXEn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8aG6j = parcelRequire("8aG6j");

//#region src/track-mount/index.tsx
/**
* Utility component to track when a component is mounted and unmounted.
*/ const $2d74c775401f1bf8$export$21b400a8c8ebc91a = ({ onMount: onMount, children: children })=>{
    (0, $cozmU.useEffect)(()=>{
        return onMount();
    }, []);
    return /* @__PURE__ */ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
 //# sourceMappingURL=track-mount.mjs.map
module.exports["TrackMount"] = $2d74c775401f1bf8$export$21b400a8c8ebc91a;

});

parcelRegister("gOWly", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8aG6j = parcelRequire("8aG6j");

//#region src/create-placement-component/providers/stable-graphql-subscription/index.tsx
const $c3ee9346ab988916$var$SubscriptionConfigContext = (0, $cozmU.createContext)({
    subscription: void 0
});
const $c3ee9346ab988916$export$d870bd1cf2974c88 = ({ subscription: subscription, children: children })=>{
    const memoizedValue = (0, $cozmU.useMemo)(()=>({
            subscription: subscription
        }), [
        subscription
    ]);
    return /* @__PURE__ */ (0, $8aG6j.jsx)($c3ee9346ab988916$var$SubscriptionConfigContext.Provider, {
        value: memoizedValue,
        children: children
    });
};
const $c3ee9346ab988916$export$1129f1fe63b2d7ab = ()=>{
    return (0, $cozmU.useContext)($c3ee9346ab988916$var$SubscriptionConfigContext);
};
 //# sourceMappingURL=stable-graphql-subscription.mjs.map
module.exports["StableSubscriptionConfigProvider"] = $c3ee9346ab988916$export$d870bd1cf2974c88;
module.exports["useSubscriptionConfig"] = $c3ee9346ab988916$export$1129f1fe63b2d7ab;

});

parcelRegister("eq1BO", function(module, exports) {
$parcel$export(module.exports, "PostOfficeAnalyticsContext", () => (parcelRequire("f1G3w")).PostOfficeAnalyticsContext);

var $g8WS7 = parcelRequire("g8WS7");


var $jpjVJ = parcelRequire("jpjVJ");


var $kLVNa = parcelRequire("kLVNa");


var $lnqxO = parcelRequire("lnqxO");


var $lxTPJ = parcelRequire("lxTPJ");


var $6i8go = parcelRequire("6i8go");


var $kM1fo = parcelRequire("kM1fo");


var $jwHjP = parcelRequire("jwHjP");


var $9udEN = parcelRequire("9udEN");


var $gYVlH = parcelRequire("gYVlH");


var $f1G3w = parcelRequire("f1G3w");


var $1Pvvv = parcelRequire("1Pvvv");


var $3FUF4 = parcelRequire("3FUF4");


var $9JDIO = parcelRequire("9JDIO");


var $HUhul = parcelRequire("HUhul");


var $9NCOm = parcelRequire("9NCOm");


});

parcelRegister("jTNdj", function(module, exports) {

var $b8pma = parcelRequire("b8pma");


var $65DSU = parcelRequire("65DSU");

const $8f5948bf59d85fb8$export$c91b09caa8ecbab1 = {
    /** Names for UFOv2 segments for Post Office */ SegmentNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
        PLACEMENT: 'post-office-placement',
        MESSAGE: 'post-office-message'
    },
    /** Names for UFOv2 holds for Post Office */ HoldNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement-loading',
        PLACEMENT: 'post-office-placement-loading',
        MESSAGE: 'post-office-message-loading'
    },
    UFOLoadHold: (0, $b8pma.default),
    UFOSegment: (0, $65DSU.default)
};
module.exports["UFOv2"] = $8f5948bf59d85fb8$export$c91b09caa8ecbab1;

});

parcelRegister("40SXV", function(module, exports) {

var $aHfj2 = parcelRequire("aHfj2");


var $8aG6j = parcelRequire("8aG6j");


var $852mP = parcelRequire("852mP");


var $9EOlJ = parcelRequire("9EOlJ");

//#region src/withErrorBoundary.tsx
const $2ec1cc8aa6828215$export$f0c7a449e0cfaec7 = (Component)=>(props)=>{
        const { errorBoundaryLocation: errorBoundaryLocation, placementId: placementId, messageTemplateId: messageTemplateId, fallbackRender: fallbackRender, onError: onError } = props;
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $aHfj2.useFirePostOfficeAnalyticsEvents)();
        const internalOnError = (additionalAnalytics, onError)=>(error, info)=>{
                if (onError) onError(error, info);
                fireAnalyticsEvent({
                    eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                    action: "caughtError",
                    actionSubject: "PostOfficeErrorBoundary",
                    actionSubjectId: additionalAnalytics.errorBoundaryLocation
                }, {
                    error: {
                        name: error.name,
                        message: error.message,
                        stack: error.stack
                    },
                    info: info,
                    errorBoundaryLocation: additionalAnalytics.errorBoundaryLocation,
                    placementId: additionalAnalytics.placementId,
                    messageTemplateId: additionalAnalytics.messageTemplateId
                });
            };
        const internalFallbackRender = (FallbackRender)=>(props)=>{
                if (FallbackRender) return /* @__PURE__ */ (0, $8aG6j.jsx)(FallbackRender, {
                    ...props
                });
                return null;
            };
        return /* @__PURE__ */ (0, $8aG6j.jsx)((0, $9EOlJ.ErrorBoundary), {
            fallbackRender: internalFallbackRender(fallbackRender),
            onError: internalOnError({
                errorBoundaryLocation: errorBoundaryLocation,
                placementId: placementId,
                messageTemplateId: messageTemplateId
            }, onError),
            children: /* @__PURE__ */ (0, $8aG6j.jsx)(Component, {
                ...props
            })
        });
    };
 //# sourceMappingURL=withErrorBoundary.mjs.map
module.exports["withErrorBoundary"] = $2ec1cc8aa6828215$export$f0c7a449e0cfaec7;

});

parcelRegister("dJkmj", function(module, exports) {
module.exports = JSON.parse("{\"admin-hub.adminhub-urm-rank-ra-using-ml-spotlight.body\":[{\"type\":0,\"value\":\"We've brought the most relevant requests to the top.\"}],\"admin-hub.adminhub-urm-rank-ra-using-ml-spotlight.button-done\":[{\"type\":0,\"value\":\"Done\"}],\"admin-hub.adminhub-urm-rank-ra-using-ml-spotlight.heading\":[{\"type\":0,\"value\":\"Review requests quickly\"}],\"adminhub.user.requests.count.message.spotlight.content.body\":[{\"type\":0,\"value\":\"See how many times a user has tried to access their requested app\"}],\"adminhub.user.requests.count.message.spotlight.content.done\":[{\"type\":0,\"value\":\"Done\"}],\"adminhub.user.requests.count.message.spotlight.content.headline\":[{\"type\":0,\"value\":\"View access attempts\"}],\"growth-groot.adminhub-request-access-weekly-digest.email.approve-all-cta\":[{\"type\":0,\"value\":\"Approve all\"}],\"growth-groot.adminhub-request-access-weekly-digest.email.footer.admin-note\":[{\"type\":0,\"value\":\"You received this email because you're an admin for \"},{\"type\":1,\"value\":\"orgName\"},{\"type\":0,\"value\":\".\"}],\"growth-groot.adminhub-request-access-weekly-digest.email.footer.approve-all-cta\":[{\"type\":0,\"value\":\"Approve all\"}],\"growth-groot.adminhub-request-access-weekly-digest.email.footer.review-all-cta\":[{\"type\":0,\"value\":\"Review all\"}],\"growth-groot.adminhub-request-access-weekly-digest.email.footer.sent-by\":[{\"type\":0,\"value\":\"This message was sent to you by Atlassian Administration.\"}],\"growth-groot.adminhub-request-access-weekly-digest.email.header.no-dates\":[{\"type\":0,\"value\":\"Recent pending access requests\"}],\"growth-groot.adminhub-request-access-weekly-digest.email.header.with-dates\":[{\"type\":0,\"value\":\"Recent pending access requests from \"},{\"type\":1,\"value\":\"startDate\"},{\"type\":0,\"value\":\" - \"},{\"type\":1,\"value\":\"endDate\"}],\"growth-groot.adminhub-request-access-weekly-digest.email.org-icon.alt\":[{\"type\":0,\"value\":\"Organisation icon\"}],\"growth-groot.adminhub-request-access-weekly-digest.email.overflow-note\":[{\"type\":0,\"value\":\"Showing \"},{\"type\":1,\"value\":\"shown\"},{\"type\":0,\"value\":\" of \"},{\"type\":1,\"value\":\"total\"},{\"type\":0,\"value\":\" requests\"}],\"growth-groot.adminhub-request-access-weekly-digest.email.request-card.app-requested-label\":[{\"type\":0,\"value\":\"App requested\"}],\"growth-groot.adminhub-request-access-weekly-digest.email.request-card.approve-cta\":[{\"type\":0,\"value\":\"Approve\"}],\"growth-groot.adminhub-request-access-weekly-digest.email.request-card.date-label\":[{\"type\":0,\"value\":\"Date requested\"}],\"growth-groot.adminhub-request-access-weekly-digest.email.request-card.days-ago\":[{\"offset\":0,\"options\":{\"one\":{\"value\":[{\"type\":7},{\"type\":0,\"value\":\" DAY AGO\"}]},\"other\":{\"value\":[{\"type\":7},{\"type\":0,\"value\":\" DAYS AGO\"}]}},\"pluralType\":\"cardinal\",\"type\":6,\"value\":\"days\"}],\"growth-groot.adminhub-request-access-weekly-digest.email.request-card.existing-access-label\":[{\"type\":0,\"value\":\"Existing access\"}],\"growth-groot.adminhub-request-access-weekly-digest.email.request-card.requested-by-label\":[{\"type\":0,\"value\":\"Requested by\"}],\"growth-groot.adminhub-request-access-weekly-digest.email.request-card.review-cta\":[{\"type\":0,\"value\":\"Review\"}],\"growth-groot.adminhub-request-access-weekly-digest.email.request-card.summary-label\":[{\"type\":0,\"value\":\"Summary\"}],\"growth-groot.adminhub-request-access-weekly-digest.email.review-all-cta\":[{\"type\":0,\"value\":\"Review all\"}],\"growth-groot.adminhub-request-access-weekly-digest.email.stats.oldest-request-label\":[{\"type\":0,\"value\":\"oldest request\"}],\"growth-groot.adminhub-request-access-weekly-digest.email.stats.oldest-request-value\":[{\"offset\":0,\"options\":{\"one\":{\"value\":[{\"type\":7},{\"type\":0,\"value\":\" day\"}]},\"other\":{\"value\":[{\"type\":7},{\"type\":0,\"value\":\" days\"}]}},\"pluralType\":\"cardinal\",\"type\":6,\"value\":\"days\"}],\"growth-groot.adminhub-request-access-weekly-digest.email.stats.pending-requests-label\":[{\"type\":0,\"value\":\"pending requests\"}],\"growth-groot.adminhub-request-access-weekly-digest.email.stats.products-label\":[{\"type\":0,\"value\":\"products\"}],\"growth-groot.adminhub-request-access-weekly-digest.email.subject\":[{\"offset\":0,\"options\":{\"one\":{\"value\":[{\"type\":7},{\"type\":0,\"value\":\" access request is\"}]},\"other\":{\"value\":[{\"type\":7},{\"type\":0,\"value\":\" access requests are\"}]}},\"pluralType\":\"cardinal\",\"type\":6,\"value\":\"totalPendingCount\"},{\"type\":0,\"value\":\" pending your review\"}],\"growth-groot.pending-request-access-summary.message-template.in-app-notification.body\":[{\"type\":0,\"value\":\"Approve or deny your users' requests for app access.\"}],\"growth-groot.pending-request-access-summary.message-template.in-app-notification.heading\":[{\"type\":1,\"value\":\"totalRequests\"},{\"type\":0,\"value\":\" access requests are waiting for review\"}],\"user.access.settings.access.message.spotlight.content.body\":[{\"type\":0,\"value\":\"Create a message that users in your organization will see when they want to request access to an app.\"}],\"user.access.settings.access.message.spotlight.content.got.it\":[{\"type\":0,\"value\":\"Got it\"}],\"user.access.settings.access.message.spotlight.content.headline\":[{\"type\":0,\"value\":\"Create an access message\"}]}");

});

parcelRegister("cUcPn", function(module, exports) {
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $cfc2cb470fbdc4fd$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $cfc2cb470fbdc4fd$export$2e2bcd8739ae039 = $cfc2cb470fbdc4fd$export$852ff24d0930c62f;
module.exports["default"] = $cfc2cb470fbdc4fd$export$2e2bcd8739ae039;

});

parcelRegister("ksfN5", function(module, exports) {

let $ee42abe27a03dbbe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ee42abe27a03dbbe$var$load("2EtNs").then(()=>parcelRequire('hdw0u'));

});

parcelRegister("1WW3i", function(module, exports) {

let $16b83d280b3030ab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $16b83d280b3030ab$var$load("eWeHm").then(()=>parcelRequire('ir5y3'));

});

parcelRegister("8JNw5", function(module, exports) {

let $65c8efa2120b2547$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $65c8efa2120b2547$var$load("g7ZJa").then(()=>parcelRequire('8DKDE'));

});

parcelRegister("b4Dfp", function(module, exports) {

let $80fe832fad8c521a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $80fe832fad8c521a$var$load("eE62E").then(()=>parcelRequire('3LhCp'));

});

parcelRegister("7N8K6", function(module, exports) {

let $5ac3e41982a65805$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5ac3e41982a65805$var$load("lv1Bk").then(()=>parcelRequire('es3YO'));

});

parcelRegister("caZSr", function(module, exports) {

let $8dd66ab13b205a9f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8dd66ab13b205a9f$var$load("d55l3").then(()=>parcelRequire('6A3i9'));

});

parcelRegister("7baG8", function(module, exports) {

let $53a1d80e0f25af7a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $53a1d80e0f25af7a$var$load("lz84V").then(()=>parcelRequire('2IAb4'));

});

parcelRegister("iG5Z7", function(module, exports) {

let $d990caabda07c5cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d990caabda07c5cb$var$load("j3LfE").then(()=>parcelRequire('7A9F2'));

});

parcelRegister("z0NfQ", function(module, exports) {

let $0693e28eac491a5c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0693e28eac491a5c$var$load("3XEhJ").then(()=>parcelRequire('bHbAe'));

});

parcelRegister("lay1O", function(module, exports) {

let $f694ed77ee89f0b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f694ed77ee89f0b8$var$load("llDgL").then(()=>parcelRequire('1LBHL'));

});

parcelRegister("c09TU", function(module, exports) {

let $8bcd2a38cba15758$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8bcd2a38cba15758$var$load("58sqC").then(()=>parcelRequire('70TWY'));

});

parcelRegister("hbyeW", function(module, exports) {

let $c82e061f83ed955f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c82e061f83ed955f$var$load("lDzKw").then(()=>parcelRequire('1uPoa'));

});

parcelRegister("ihfOC", function(module, exports) {

let $d4e61523d66e59b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d4e61523d66e59b1$var$load("1idoH").then(()=>parcelRequire('jzsWR'));

});

parcelRegister("iTVjy", function(module, exports) {

let $dc29d28366cb2820$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dc29d28366cb2820$var$load("aRADU").then(()=>parcelRequire('ex3A7'));

});

parcelRegister("jambV", function(module, exports) {

let $df402a356c9f0946$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $df402a356c9f0946$var$load("dVjby").then(()=>parcelRequire('4CKzi'));

});

parcelRegister("bgRQf", function(module, exports) {

let $834af42ee262650b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $834af42ee262650b$var$load("ejhOV").then(()=>parcelRequire('LLnIC'));

});

parcelRegister("fkCwb", function(module, exports) {

let $b2969a2b259d0231$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b2969a2b259d0231$var$load("k7WuK").then(()=>parcelRequire('12Fue'));

});

parcelRegister("e1R9y", function(module, exports) {

let $a36a63ca5adfa98b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a36a63ca5adfa98b$var$load("1yEPv").then(()=>parcelRequire('5Dkws'));

});

parcelRegister("8y7KT", function(module, exports) {

let $639783c4d14456eb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $639783c4d14456eb$var$load("4u6HT").then(()=>parcelRequire('7BBhH'));

});

parcelRegister("llaTT", function(module, exports) {

let $f89403c4735842fa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f89403c4735842fa$var$load("anABM").then(()=>parcelRequire('8IXkM'));

});

parcelRegister("bFqV5", function(module, exports) {

let $87e867bce2d707bc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $87e867bce2d707bc$var$load("49Clp").then(()=>parcelRequire('6ZoVr'));

});

parcelRegister("52S0G", function(module, exports) {

let $3ac708f18336605d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3ac708f18336605d$var$load("3kgJe").then(()=>parcelRequire('8n4CU'));

});

parcelRegister("9oOUi", function(module, exports) {

let $6d7dd80a7594e321$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6d7dd80a7594e321$var$load("6HXr2").then(()=>parcelRequire('gNexk'));

});

parcelRegister("5NwB0", function(module, exports) {

let $438ad033ceda5bb5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $438ad033ceda5bb5$var$load("tISiS").then(()=>parcelRequire('1hkfJ'));

});

parcelRegister("hEUq2", function(module, exports) {

let $cdb1efb52b539217$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cdb1efb52b539217$var$load("hIl9r").then(()=>parcelRequire('kXEgC'));

});

parcelRegister("7XWIt", function(module, exports) {

let $5ccb96ea2a075d23$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5ccb96ea2a075d23$var$load("koBp7").then(()=>parcelRequire('gXAFG'));

});

parcelRegister("jFYco", function(module, exports) {

let $e5308aec5aa6f80a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e5308aec5aa6f80a$var$load("8pW1D").then(()=>parcelRequire('PcQsj'));

});

parcelRegister("5sLxi", function(module, exports) {

let $3fa470f40cbfe456$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3fa470f40cbfe456$var$load("v2jdI").then(()=>parcelRequire('eqPcR'));

});

parcelRegister("bYnX5", function(module, exports) {

let $8b77e0ac1dec4a74$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8b77e0ac1dec4a74$var$load("djK0N").then(()=>parcelRequire('3ApYG'));

});

parcelRegister("fRuEg", function(module, exports) {

let $b8c3945dd8c3406d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b8c3945dd8c3406d$var$load("f06Ms").then(()=>parcelRequire('b5wn5'));

});

parcelRegister("etig5", function(module, exports) {

let $a891efdd5b74363c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a891efdd5b74363c$var$load("g74Qa").then(()=>parcelRequire('dzXuS'));

});

parcelRegister("g9XuR", function(module, exports) {

let $bc3ba36a02722c32$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bc3ba36a02722c32$var$load("ePLv5").then(()=>parcelRequire('7i8wT'));

});

parcelRegister("87dWx", function(module, exports) {

let $5e89cb012104b030$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5e89cb012104b030$var$load("6kfQO").then(()=>parcelRequire('fgxGg'));

});

parcelRegister("b66vN", function(module, exports) {

let $81454e5c623d0aa1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $81454e5c623d0aa1$var$load("3q2n1").then(()=>parcelRequire('iUWMf'));

});

parcelRegister("jn6Vd", function(module, exports) {
module.exports = JSON.parse("{\"admin-hub.adminhub-performance-monitoring-first-run.body-0\":[{\"type\":0,\"value\":\"See how your apps loaded for users in the last 24 hours, grouped by fast, moderate, and slow experiences.\"}],\"admin-hub.adminhub-performance-monitoring-first-run.body-1\":[{\"type\":0,\"value\":\"Understand which configuration issues affect load times, and where improvements can make the difference.\"}],\"admin-hub.adminhub-performance-monitoring-first-run.body-10\":[{\"type\":0,\"value\":\"Click any row to see what's impacting this app's performance and review detailed metrics.\"}],\"admin-hub.adminhub-performance-monitoring-first-run.body-2\":[{\"type\":0,\"value\":\"Find what's affecting performance the most. View insight details to understand the issue and take the next step.\"}],\"admin-hub.adminhub-performance-monitoring-first-run.body-3\":[{\"type\":0,\"value\":\"Explore how load times split across fast, moderate, and slow for the period you chose.\"}],\"admin-hub.adminhub-performance-monitoring-first-run.body-4\":[{\"type\":0,\"value\":\"The same data plotted over time, so you can identify when slow loads occurred and tell whether a change helped.\"}],\"admin-hub.adminhub-performance-monitoring-first-run.body-5\":[{\"type\":0,\"value\":\"Change the time range and how often data is sampled, or switch between alternative data views.\"}],\"admin-hub.adminhub-performance-monitoring-first-run.body-6\":[{\"type\":0,\"value\":\"Compare the impact of network speed, CPU cores, network protocol, and operating system over the last 4 weeks.\"}],\"admin-hub.adminhub-performance-monitoring-first-run.body-7\":[{\"type\":0,\"value\":\"Filter to the product or site you care about, then explore the details to learn how page loads are distributed.\"}],\"admin-hub.adminhub-performance-monitoring-first-run.body-8\":[{\"type\":0,\"value\":\"Compare load times for each app to quickly assess individual performance and evaluate optimization needs.\"}],\"admin-hub.adminhub-performance-monitoring-first-run.body-9\":[{\"type\":0,\"value\":\"Use search, filter and sorting capabilities to quickly identify which apps need attention.\"}],\"admin-hub.adminhub-performance-monitoring-first-run.button-back\":[{\"type\":0,\"value\":\"Back\"}],\"admin-hub.adminhub-performance-monitoring-first-run.button-done\":[{\"type\":0,\"value\":\"Done\"}],\"admin-hub.adminhub-performance-monitoring-first-run.button-next\":[{\"type\":0,\"value\":\"Next\"}],\"admin-hub.adminhub-performance-monitoring-first-run.heading-0\":[{\"type\":0,\"value\":\"App performance at a glance\"}],\"admin-hub.adminhub-performance-monitoring-first-run.heading-1\":[{\"type\":0,\"value\":\"Find what's slowing things down\"}],\"admin-hub.adminhub-performance-monitoring-first-run.heading-10\":[{\"type\":0,\"value\":\"View performance breakdown\"}],\"admin-hub.adminhub-performance-monitoring-first-run.heading-2\":[{\"type\":0,\"value\":\"Review insights\"}],\"admin-hub.adminhub-performance-monitoring-first-run.heading-3\":[{\"type\":0,\"value\":\"See the spread of load times\"}],\"admin-hub.adminhub-performance-monitoring-first-run.heading-4\":[{\"type\":0,\"value\":\"Watch load times change\"}],\"admin-hub.adminhub-performance-monitoring-first-run.heading-5\":[{\"type\":0,\"value\":\"Adjust the view to get a clear picture\"}],\"admin-hub.adminhub-performance-monitoring-first-run.heading-6\":[{\"type\":0,\"value\":\"See how user setup affects load times\"}],\"admin-hub.adminhub-performance-monitoring-first-run.heading-7\":[{\"type\":0,\"value\":\"Narrow it to one product or site\"}],\"admin-hub.adminhub-performance-monitoring-first-run.heading-8\":[{\"type\":0,\"value\":\"Get a comprehensive overview\"}],\"admin-hub.adminhub-performance-monitoring-first-run.heading-9\":[{\"type\":0,\"value\":\"Boost your investigation\"}],\"admin-hub.adminhub-performance-monitoring-first-run.step-count\":[{\"type\":1,\"value\":\"step\"},{\"type\":0,\"value\":\" of \"},{\"type\":1,\"value\":\"totalSteps\"}],\"aviator.service-health-dashboard.app-status-spotlight.action.back\":[{\"type\":0,\"value\":\"Back\"}],\"aviator.service-health-dashboard.app-status-spotlight.action.done\":[{\"type\":0,\"value\":\"Done\"}],\"aviator.service-health-dashboard.app-status-spotlight.action.next\":[{\"type\":0,\"value\":\"Next\"}],\"aviator.service-health-dashboard.app-status-spotlight.step-counter\":[{\"type\":1,\"value\":\"current\"},{\"type\":0,\"value\":\" of \"},{\"type\":1,\"value\":\"total\"}],\"aviator.service-health-dashboard.app-status-spotlight.step1.body\":[{\"type\":0,\"value\":\"View active incidents, maintenance events and their details.\"}],\"aviator.service-health-dashboard.app-status-spotlight.step1.heading\":[{\"type\":0,\"value\":\"Track current events\"}],\"aviator.service-health-dashboard.app-status-spotlight.step2.body\":[{\"type\":0,\"value\":\"Search and filter past incidents and maintenance events.\"}],\"aviator.service-health-dashboard.app-status-spotlight.step2.heading\":[{\"type\":0,\"value\":\"Browse event history\"}],\"aviator.service-health-dashboard.app-status-spotlight.step3.body\":[{\"type\":0,\"value\":\"View which app experiences across app instances are currently impacted.\"}],\"aviator.service-health-dashboard.app-status-spotlight.step3.heading\":[{\"type\":0,\"value\":\"Check experience status\"}],\"aviator.service-health-dashboard.app-status-spotlight.step4.body\":[{\"type\":0,\"value\":\"Get an overview of how events affect your apps and their experiences.\"}],\"aviator.service-health-dashboard.app-status-spotlight.step4.heading\":[{\"type\":0,\"value\":\"Review impact on apps\"}],\"aviator.service-health-dashboard.spotlight.action.back\":[{\"type\":0,\"value\":\"Back\"}],\"aviator.service-health-dashboard.spotlight.action.done\":[{\"type\":0,\"value\":\"Done\"}],\"aviator.service-health-dashboard.spotlight.action.next\":[{\"type\":0,\"value\":\"Next\"}],\"aviator.service-health-dashboard.spotlight.step-counter\":[{\"type\":1,\"value\":\"current\"},{\"type\":0,\"value\":\" of \"},{\"type\":1,\"value\":\"total\"}],\"aviator.service-health-dashboard.spotlight.step1.body\":[{\"type\":0,\"value\":\"View the current status and recent events for each app in your organization.\"}],\"aviator.service-health-dashboard.spotlight.step1.heading\":[{\"type\":0,\"value\":\"Dive into app status\"}],\"aviator.service-health-dashboard.spotlight.step2.body\":[{\"type\":0,\"value\":\"Stay informed about incidents and maintenance events in your organization\"}],\"aviator.service-health-dashboard.spotlight.step2.heading\":[{\"type\":0,\"value\":\"Subscribe to updates\"}],\"catapult.adminhub-system-health-dashboard-app-status-spotlight.screen-space-flags.description.no-translate\":[{\"type\":0,\"value\":\"Replace this with a short summary of what this message tells the recipient.\"}],\"catapult.adminhub-system-health-dashboard-app-status-spotlight.screen-space-flags.title.no-translate\":[{\"type\":0,\"value\":\"This is a Post Office Test Message\"}]}");

});

parcelRegister("6DVal", function(module, exports) {

let $4d62ba89612d0740$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4d62ba89612d0740$var$load("8K2Ks").then(()=>parcelRequire('ksC63'));

});

parcelRegister("dnviE", function(module, exports) {

let $9bd5b3d09a7018d6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9bd5b3d09a7018d6$var$load("fK3Bb").then(()=>parcelRequire('6uAWE'));

});

parcelRegister("inQF0", function(module, exports) {

let $d6233940b2f3bc5f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d6233940b2f3bc5f$var$load("kOtuG").then(()=>parcelRequire('9AunT'));

});

parcelRegister("3pSD4", function(module, exports) {

let $27ce151d0ad81d3a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $27ce151d0ad81d3a$var$load("2UXfO").then(()=>parcelRequire('hN4Vk'));

});

parcelRegister("l7JF3", function(module, exports) {

let $f60dabc8004e4373$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f60dabc8004e4373$var$load("ac3D4").then(()=>parcelRequire('1e2My'));

});

parcelRegister("9EPTJ", function(module, exports) {

let $70801b50a8171516$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $70801b50a8171516$var$load("6FheE").then(()=>parcelRequire('b6MHo'));

});

parcelRegister("bi9fn", function(module, exports) {

let $83888c6b6019dfbe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $83888c6b6019dfbe$var$load("fpifQ").then(()=>parcelRequire('7wnS8'));

});

parcelRegister("6eRZW", function(module, exports) {

let $48adefc62c42bb8a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $48adefc62c42bb8a$var$load("dCwTP").then(()=>parcelRequire('fHOi0'));

});

parcelRegister("c5itn", function(module, exports) {

let $8cc447f546e3404b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8cc447f546e3404b$var$load("d81M2").then(()=>parcelRequire('8A6W8'));

});

parcelRegister("5Lkat", function(module, exports) {

let $4320fc7898de7e9f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4320fc7898de7e9f$var$load("g2EkB").then(()=>parcelRequire('igR1Y'));

});

parcelRegister("2RTex", function(module, exports) {

let $216b6034504297c6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $216b6034504297c6$var$load("joKjD").then(()=>parcelRequire('h32Q8'));

});

parcelRegister("8UQU8", function(module, exports) {

let $67dc97662e28cde9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $67dc97662e28cde9$var$load("bvblR").then(()=>parcelRequire('1kFIu'));

});

parcelRegister("4iWGP", function(module, exports) {

let $32265e68ccef9323$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $32265e68ccef9323$var$load("63Bl6").then(()=>parcelRequire('iXAjO'));

});

parcelRegister("e6L7b", function(module, exports) {

let $a4562c424c9c7627$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a4562c424c9c7627$var$load("71uoA").then(()=>parcelRequire('dY6Fe'));

});

parcelRegister("4JoIz", function(module, exports) {

let $371e89d97439bb8a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $371e89d97439bb8a$var$load("iIwy7").then(()=>parcelRequire('25io6'));

});

parcelRegister("6JOFf", function(module, exports) {

let $4e7e3ee6dd23ea31$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4e7e3ee6dd23ea31$var$load("5zuZn").then(()=>parcelRequire('jH664'));

});

parcelRegister("84Cal", function(module, exports) {

let $018453d433fb8472$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $018453d433fb8472$var$load("6g8QC").then(()=>parcelRequire('DCRg6'));

});

parcelRegister("1bYEh", function(module, exports) {

let $0de5dd1093d2672e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0de5dd1093d2672e$var$load("75Bsd").then(()=>parcelRequire('4JbSw'));

});

parcelRegister("28r74", function(module, exports) {

let $18e15c3525e5be21$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $18e15c3525e5be21$var$load("bGm0C").then(()=>parcelRequire('cWhKw'));

});

parcelRegister("gx9jb", function(module, exports) {

let $c096f2e08bf6536c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c096f2e08bf6536c$var$load("2lwGB").then(()=>parcelRequire('5kCW0'));

});

parcelRegister("l8Kdm", function(module, exports) {

let $f63e318f8fe449f2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f63e318f8fe449f2$var$load("3VQ72").then(()=>parcelRequire('baWyr'));

});

parcelRegister("3TFWR", function(module, exports) {

let $2d670c3dbb333169$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2d670c3dbb333169$var$load("iIYnd").then(()=>parcelRequire('8weu1'));

});

parcelRegister("9kURA", function(module, exports) {

let $6cc2173022304d3c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6cc2173022304d3c$var$load("9cI2H").then(()=>parcelRequire('4hgLX'));

});

parcelRegister("4a06L", function(module, exports) {

let $30782e0d72814e29$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $30782e0d72814e29$var$load("ahGEq").then(()=>parcelRequire('31qLi'));

});

parcelRegister("abJUx", function(module, exports) {

let $76ae8b6fcda5dabc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $76ae8b6fcda5dabc$var$load("jVpEb").then(()=>parcelRequire('gFhjm'));

});

parcelRegister("4t3lo", function(module, exports) {

let $340c76e82ec9e3c2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $340c76e82ec9e3c2$var$load("dppZk").then(()=>parcelRequire('cqHuz'));

});

parcelRegister("4ESb7", function(module, exports) {

let $3644ec8d69785b93$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3644ec8d69785b93$var$load("70Wj9").then(()=>parcelRequire('dz0ts'));

});

parcelRegister("5pKn7", function(module, exports) {

let $3f1342074b6408f9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3f1342074b6408f9$var$load("lj6hI").then(()=>parcelRequire('6qcWD'));

});

parcelRegister("jqAt5", function(module, exports) {

let $03a666206a0cc88c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $03a666206a0cc88c$var$load("kys5a").then(()=>parcelRequire('70ADh'));

});

parcelRegister("2rLoo", function(module, exports) {

let $1c82dd866b9b15be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1c82dd866b9b15be$var$load("7MAqQ").then(()=>parcelRequire('8zD3c'));

});

parcelRegister("fiPK2", function(module, exports) {

let $b240ac3adbd3cfa5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b240ac3adbd3cfa5$var$load("fuqyw").then(()=>parcelRequire('4iMWs'));

});

parcelRegister("k9ukf", function(module, exports) {

let $eabc2bedbebae831$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eabc2bedbebae831$var$load("kfioc").then(()=>parcelRequire('hoerD'));

});

parcelRegister("9ig6e", function(module, exports) {

let $6c424881535a3627$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6c424881535a3627$var$load("gxjfb").then(()=>parcelRequire('hGwoj'));

});

parcelRegister("7MsWr", function(module, exports) {

let $5aa3775089dc221b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5aa3775089dc221b$var$load("8l4hg").then(()=>parcelRequire('8uQ82'));

});

parcelRegister("i2fPX", function(module, exports) {
module.exports = JSON.parse('{"admin-hub-notifications.dropdown-menu-button.aria-label":[{"type":0,"value":"More actions"}],"admin-hub-notifications.unread-notifications.aria-label":[{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" unread notification"}]},"other":{"value":[{"type":7},{"type":0,"value":" unread notifications"}]}},"pluralType":"cardinal","type":6,"value":"displayedCount"}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.body-0":[{"type":0,"value":"Gain insight into your current period, past usage, and 30, 60, 90-day history."}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.body-1":[{"type":0,"value":"Explore usage broken down by apps, features, and individual users."}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.body-2":[{"type":0,"value":"Download usage data for in-depth analysis, custom reports, and easy sharing."}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.button-back":[{"type":0,"value":"Back"}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.button-done":[{"type":0,"value":"Done"}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.button-next":[{"type":0,"value":"Next"}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.heading-0":[{"type":0,"value":"Track "},{"type":1,"value":"meterName"},{"type":0,"value":" credits across time"}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.heading-1":[{"type":0,"value":"Granular "},{"type":1,"value":"meterName"},{"type":0,"value":" insights"}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.heading-2":[{"type":0,"value":"Download usage reports"}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.step-count":[{"type":1,"value":"step"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.body-1":[{"type":0,"value":"Different reports now live in dedicated spaces so you can quickly find what you need."}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.body-2":[{"type":0,"value":"Assess your Data Center instances and get them ready for cloud migration."}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.body-3":[{"type":0,"value":"Monitor and improve the health and performance of your Data Center instances."}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.body-4":[{"type":0,"value":"Discover Data Center instances you own based on existing connections."}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.button-back":[{"type":0,"value":"Back"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.button-done":[{"type":0,"value":"Done"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.button-next":[{"type":0,"value":"Next"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.heading-1":[{"type":0,"value":"What\'s new in Portfolio insights"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.heading-2":[{"type":0,"value":"Cloud readiness"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.heading-3":[{"type":0,"value":"Instance health"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.heading-4":[{"type":0,"value":"Detected instances"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.step-count":[{"type":1,"value":"step"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"admin-hub.adminhub-rovo-chat-button-spotlight.body":[{"type":0,"value":"Troubleshoot common tasks with Rovo admin skills. Go to "},{"type":1,"value":"rovoSettings"},{"type":0,"value":" to turn on "},{"type":1,"value":"rovoChatInAdministration"},{"type":0,"value":"."}],"admin-hub.adminhub-rovo-chat-button-spotlight.button-open-rovo-chat":[{"type":0,"value":"Open Rovo Chat"}],"admin-hub.adminhub-rovo-chat-button-spotlight.heading":[{"type":0,"value":"Meet your new admin assistant"}],"admin-hub.adminhub-rovo-chat-button-spotlight.rovo-chat-in-administration":[{"type":0,"value":"Rovo Chat in Administration"}],"admin-hub.adminhub-rovo-chat-button-spotlight.rovo-settings-link":[{"type":0,"value":"Rovo settings"}],"admin-hub.adminhub-rovo-chat-button-spotlight.rovo-settings-link-text":[{"type":0,"value":"Rovo settings"}],"admin-hub.adminhub-rovo-chat-toggle-spotlight.body":[{"type":0,"value":"Turn on Rovo Chat to enable it in Atlassian Administration."}],"admin-hub.adminhub-rovo-chat-toggle-spotlight.button-try-it":[{"type":0,"value":"Turn on"}],"admin-hub.adminhub-rovo-chat-toggle-spotlight.heading":[{"type":0,"value":"Turn on Rovo Chat"}],"admin-hub.adminhub-theme-darkmode.button-back":[{"type":0,"value":"Back"}],"admin-hub.adminhub-theme-darkmode.button-done":[{"type":0,"value":"Done"}],"admin-hub.adminhub-theme-darkmode.button-next":[{"type":0,"value":"Next"}],"admin-hub.adminhub-theme-darkmode.spotlight-body-1":[{"type":0,"value":"Reduce glare and boost focus with our sleek new dark theme."}],"admin-hub.adminhub-theme-darkmode.spotlight-body-2":[{"type":0,"value":"Go dark, stay light, or match your browser settings. Give it a try."}],"admin-hub.adminhub-theme-darkmode.spotlight-heading-1":[{"type":0,"value":"Experience dark mode"}],"admin-hub.adminhub-theme-darkmode.spotlight-heading-2":[{"type":0,"value":"Switch themes"}],"admin-hub.adminhub-theme-darkmode.step-count-1":[{"type":0,"value":"1 of 2"}],"admin-hub.adminhub-theme-darkmode.step-count-2":[{"type":0,"value":"2 of 2"}],"admin-hub.adminhub-unit-create-ga-spotlight-tour.screen-space-flags.button-back":[{"type":0,"value":"Back"}],"admin-hub.adminhub-unit-create-ga-spotlight-tour.screen-space-flags.button-done":[{"type":0,"value":"Done"}],"admin-hub.adminhub-unit-create-ga-spotlight-tour.screen-space-flags.button-next":[{"type":0,"value":"Next"}],"admin-hub.adminhub-unit-create-ga-spotlight-tour.screen-space-flags.step-1-description":[{"type":0,"value":"Take a moment for a quick tour of this unit to understand what it can do and contain."}],"admin-hub.adminhub-unit-create-ga-spotlight-tour.screen-space-flags.step-1-title":[{"type":0,"value":"Take a tour of your new unit"}],"admin-hub.adminhub-unit-create-ga-spotlight-tour.screen-space-flags.step-2-description":[{"type":0,"value":"You can add as many Atlassian apps and sites as people in this unit need to do their work."}],"admin-hub.adminhub-unit-create-ga-spotlight-tour.screen-space-flags.step-2-title":[{"type":0,"value":"A container for apps and sites"}],"admin-hub.adminhub-unit-create-ga-spotlight-tour.screen-space-flags.step-3-description":[{"type":0,"value":"Need to add more apps? No worries, it\'s easy to add any Atlassian app or collection to your unit."}],"admin-hub.adminhub-unit-create-ga-spotlight-tour.screen-space-flags.step-3-title":[{"type":0,"value":"Add apps and collections"}],"admin-hub.adminhub-unit-create-ga-spotlight-tour.screen-space-flags.step-count":[{"type":1,"value":"step"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"admin-hub.adminhub-unit-profile-groups-tab-spotlight-tour.screen-space-flags.button-back":[{"type":0,"value":"Back"}],"admin-hub.adminhub-unit-profile-groups-tab-spotlight-tour.screen-space-flags.button-done":[{"type":0,"value":"Done"}],"admin-hub.adminhub-unit-profile-groups-tab-spotlight-tour.screen-space-flags.button-next":[{"type":0,"value":"Next"}],"admin-hub.adminhub-unit-profile-groups-tab-spotlight-tour.screen-space-flags.step-1-description":[{"type":0,"value":"You can create or allocate identity provider groups to this unit\'s directory to streamline access control to apps in this unit."}],"admin-hub.adminhub-unit-profile-groups-tab-spotlight-tour.screen-space-flags.step-1-title":[{"type":0,"value":"Unit-scoped groups"}],"admin-hub.adminhub-unit-profile-groups-tab-spotlight-tour.screen-space-flags.step-2-description":[{"type":0,"value":"Groups created manually in this unit are local to this unit and aren\'t shared with any other unit."}],"admin-hub.adminhub-unit-profile-groups-tab-spotlight-tour.screen-space-flags.step-2-title":[{"type":0,"value":"Create a group"}],"admin-hub.adminhub-unit-profile-groups-tab-spotlight-tour.screen-space-flags.step-3-description":[{"type":0,"value":"Continue your unit tour by clicking the Settings tab."}],"admin-hub.adminhub-unit-profile-groups-tab-spotlight-tour.screen-space-flags.step-3-title":[{"type":0,"value":"Click the Settings tab"}],"admin-hub.adminhub-unit-profile-groups-tab-spotlight-tour.screen-space-flags.step-count":[{"type":1,"value":"step"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"admin-hub.adminhub-unit-profile-settings-tab-spotlight-tour.screen-space-flags.description.no-translate":[{"type":0,"value":"Replace this with a short summary of what this message tells the recipient."}],"admin-hub.adminhub-unit-profile-settings-tab-spotlight-tour.screen-space-flags.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"admin-hub.adminhub-unit-profile-users-tab-ga-spotlight-tour.screen-space-flags.description.no-translate":[{"type":0,"value":"Replace this with a short summary of what this message tells the recipient."}],"admin-hub.adminhub-unit-profile-users-tab-ga-spotlight-tour.screen-space-flags.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"admin-hub.adminhub-units-ga-onboarding-modal.screen-space-flags.description.no-translate":[{"type":0,"value":"Replace this with a short summary of what this message tells the recipient."}],"admin-hub.adminhub-units-ga-onboarding-modal.screen-space-flags.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"adminhub.inbox.recommendations.placement.empty-state.description":[{"type":0,"value":"Recommendations help you follow best practices for your organization. We\u2019ll let you know here when there are new ways to improve your security and setup."}],"adminhub.inbox.recommendations.placement.empty-state.header":[{"type":0,"value":"Improve your organization with recommendations"}],"adminhub.inbox.recommendations.placement.error-state.description":[{"type":0,"value":"Try refreshing the page. If this keeps happening, "},{"children":[{"type":0,"value":"contact support"}],"type":8,"value":"support"},{"type":0,"value":"."}],"adminhub.inbox.recommendations.placement.error-state.header":[{"type":0,"value":"We\u2019re not sure what went wrong"}],"adminhub.inbox.recommendations.placement.header":[{"type":0,"value":"Recommendations"}],"adminhub.inbox.recommendations.placement.loading":[{"type":0,"value":"Loading recommendations"}],"ai-3p-connector-action-required.admin-hub-notifications.actionLink":[{"type":0,"value":"Go to connector settings"}],"ai-3p-connector-action-required.admin-hub-notifications.body":[{"type":0,"value":"Your "},{"type":1,"value":"connectorType"},{"type":0,"value":" connector is still syncing, but a configuration issue needs your review. Some content may not be included as intended until it\'s resolved. Go to the connector setting and select the "},{"children":[{"type":0,"value":"Action required"}],"type":8,"value":"b"},{"type":0,"value":" status on your connector to see what needs attention and how to fix it."}],"ai-3p-connector-action-required.admin-hub-notifications.heading":[{"type":0,"value":"Your "},{"type":1,"value":"connectorType"},{"type":0,"value":" connector needs attention"}],"ai-3p-connector-draft-reminder.admin-hub-notifications.actionLink":[{"type":0,"value":"View your connectors page"}],"ai-3p-connector-draft-reminder.admin-hub-notifications.body":[{"type":0,"value":"You started setting up your "},{"children":[{"type":1,"value":"connectorType"}],"type":8,"value":"b"},{"type":0,"value":" connector but didn\u2019t finish. Finish setting up the draft so your connector can be used in Rovo."}],"ai-3p-connector-draft-reminder.admin-hub-notifications.heading":[{"type":0,"value":"Finish setting up your "},{"type":1,"value":"connectorType"},{"type":0,"value":" connector"}],"ai-3p-connector-healthcheck-failure.admin-hub-notifications.actionLink":[{"type":0,"value":"Go to connector settings"}],"ai-3p-connector-healthcheck-failure.admin-hub-notifications.body":[{"type":0,"value":"Your "},{"type":1,"value":"connectorType"},{"type":0,"value":" connector"},{"options":{"other":{"value":[]},"true":{"value":[{"type":0,"value":" on "},{"type":1,"value":"cloudUrl"}]}},"type":5,"value":"hasCloudUrl"},{"type":0,"value":" is currently experiencing issues and cannot sync data from "},{"type":1,"value":"connectorType"},{"type":0,"value":"."}],"ai-3p-connector-healthcheck-failure.admin-hub-notifications.heading":[{"type":0,"value":"Action required: Your "},{"type":1,"value":"connectorType"},{"type":0,"value":" Teamwork Graph connector needs attention"}],"ai-3p-connector-healthcheck-recovery.admin-hub-notifications.actionLink":[{"type":0,"value":"View your connectors"}],"ai-3p-connector-healthcheck-recovery.admin-hub-notifications.body":[{"type":0,"value":"Good news! Your "},{"type":1,"value":"connectorType"},{"type":0,"value":" connector"},{"options":{"other":{"value":[]},"true":{"value":[{"type":0,"value":" on "},{"type":1,"value":"cloudUrl"}]}},"type":5,"value":"hasCloudUrl"},{"type":0,"value":" has recovered and is now syncing data normally. No further action is required."}],"ai-3p-connector-healthcheck-recovery.admin-hub-notifications.heading":[{"type":0,"value":"Your "},{"type":1,"value":"connectorType"},{"type":0,"value":" Teamwork Graph connector is back online"}],"ai-3p-connector-initial-scan-completed.admin-hub-notifications.actionLink":[{"type":0,"value":"View your connectors"}],"ai-3p-connector-initial-scan-completed.admin-hub-notifications.body":[{"type":0,"value":"We\'ve finished the initial sync of your "},{"type":1,"value":"connectorType"},{"type":0,"value":" connector and ingested everything your connector configuration allows. Your data is now searchable in Rovo - try asking a question or running a search to see it in action."}],"ai-3p-connector-initial-scan-completed.admin-hub-notifications.heading":[{"type":0,"value":"Your "},{"type":1,"value":"connectorType"},{"type":0,"value":" connector\'s initial sync is complete"}],"brie-automated-restore-failed.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t complete the automated restore test for "},{"type":1,"value":"cloudUrl"},{"type":0,"value":" run on "},{"type":1,"value":"jobStartTimeTimestamp"},{"type":0,"value":". This may affect your ability to recover data if needed. Review restore test view more details."}],"brie-automated-restore-failed.admin-hub-notifications.heading":[{"type":0,"value":"Automated restore test did not complete"}],"brie-backup-completed-admin-hub-in-app.admin-hub-notifications.action":[{"type":0,"value":"Check Backup"}],"brie-backup-completed-admin-hub-in-app.admin-hub-notifications.body":[{"type":0,"value":"You can view details in the attached report or download the report for "},{"type":1,"value":"product"},{"type":0,"value":"."}],"brie-backup-completed-admin-hub-in-app.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" backup "},{"type":1,"value":"status"},{"type":0,"value":" for "},{"type":1,"value":"cloudUrl"}],"brie-backup-failed.admin-hub-notifications.body":[{"type":0,"value":"The backup for "},{"type":1,"value":"cloudUrl"},{"type":0,"value":" failed on "},{"type":1,"value":"jobStartTimeTimestamp"},{"type":0,"value":". This means your latest data may not be protected. Review backup job to view more details."}],"brie-backup-failed.admin-hub-notifications.heading":[{"type":0,"value":"Backup failed"}],"brie-backup-incomplete.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t complete the backup for "},{"type":1,"value":"cloudUrl"},{"type":0,"value":" on "},{"type":1,"value":"jobStartTimeTimestamp"},{"type":0,"value":". This means your latest data may not be protected. Review backup job to view more details."}],"brie-backup-incomplete.admin-hub-notifications.heading":[{"type":0,"value":"Backup did not complete"}],"brie-restore-completed-successfully.admin-hub-notifications.body":[{"type":0,"value":"The restore job for "},{"type":1,"value":"cloudUrl"},{"type":0,"value":" finished successfully. Review restore job to view more details."}],"brie-restore-completed-successfully.admin-hub-notifications.heading":[{"type":0,"value":"Restore complete"}],"brie-restore-failed.admin-hub-notifications.body":[{"type":0,"value":"The restore for "},{"type":1,"value":"cloudUrl"},{"type":0,"value":" that started at "},{"type":1,"value":"startTime"},{"type":0,"value":" on "},{"type":1,"value":"jobStartTimeTimestamp"},{"type":0,"value":" has failed. Review restore job to view more details."}],"brie-restore-failed.admin-hub-notifications.heading":[{"type":0,"value":"Restore failed"}],"brie-restore-incomplete.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t complete the restore for "},{"type":1,"value":"cloudUrl"},{"type":0,"value":" started at "},{"type":1,"value":"startTime"},{"type":0,"value":" on "},{"type":1,"value":"jobStartTimeTimestamp"},{"type":0,"value":". Review restore job to view more details."}],"brie-restore-incomplete.admin-hub-notifications.heading":[{"type":0,"value":"Restore did not complete"}],"brie-scheduler-halted-access-issue.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t run the scheduled backup for "},{"type":1,"value":"cloudUrl"},{"type":0,"value":" on "},{"type":1,"value":"jobStartTimeTimestamp"},{"type":0,"value":" due to a user access issue. This means your latest data may not be protected."}],"brie-scheduler-halted-access-issue.admin-hub-notifications.heading":[{"type":0,"value":"Scheduled backup could not run"}],"commerce.commerce-soft-limit-breach-ccp.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" is over the user limit"}],"commerce.commerce-soft-limit-breach-ccp.body-default.no-translate":[{"type":0,"value":"We recommend removing users as soon as possible if you don\'t want to automatically upgrade user tiers"}],"encryption.policy-page.spotlight.apps":[{"type":0,"value":"Your CMK encrypted apps will appear here."}],"encryption.policy-page.spotlight.back":[{"type":0,"value":"Back"}],"encryption.policy-page.spotlight.dismiss":[{"type":0,"value":"Dismiss"}],"encryption.policy-page.spotlight.done":[{"type":0,"value":"Done"}],"encryption.policy-page.spotlight.next":[{"type":0,"value":"Next"}],"encryption.policy-page.spotlight.tenantIdVpce":[{"type":0,"value":"Update your AWS KMS key policy with Encryption Tenant Identifier-tag pair and VPC endpoint(s) to enhance security."}],"growth-groot.pending-request-access-summary.admin-hub-notification.body":[{"type":0,"value":"Approve or deny your users\' requests for app access."}],"growth-groot.pending-request-access-summary.admin-hub-notification.heading":[{"type":1,"value":"totalRequests"},{"type":0,"value":" access requests are waiting for review"}],"placement.admin-hub-notifications.button.markAsRead":[{"type":0,"value":"Mark all as read"}],"placement.admin-hub-notifications.give-feedback":[{"type":0,"value":"Give feedback"}],"placement.admin-hub-notifications.learn-more.beta":[{"type":0,"value":"About this feature"}],"placement.admin-hub-notifications.main-heading":[{"type":0,"value":"Notifications"}],"placement.admin-hub-notifications.mark-as-read-tooltip":[{"type":0,"value":"Mark as read"}],"placement.admin-hub-notifications.mark-as-unread-tooltip":[{"type":0,"value":"Mark as unread"}],"post-office.access-invalid-payment.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t process payment for your subscription due to an issue with your payment details. To avoid losing your Atlassian Access security settings, update your payment details by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.access-invalid-payment.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.access-missing-payment.admin-hub-notifications.body":[{"type":0,"value":"We don\u2019t have a payment method for your subscription. To avoid losing your Atlassian Access security settings, add your payment details by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.access-missing-payment.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.admin-hub-expiring-customer-account-scim-tokens.notification.actionLink":[{"type":0,"value":"Regenerate key"}],"post-office.admin-hub-expiring-customer-account-scim-tokens.notification.body":[{"type":0,"value":"Regenerate key for "},{"type":1,"value":"directoryName"},{"type":0,"value":" to continue customer provisioning."}],"post-office.admin-hub-expiring-customer-account-scim-tokens.notification.header":[{"type":0,"value":"Your SCIM API key will expire on "},{"type":1,"value":"expirationDate"},{"type":0,"value":"."}],"post-office.admin-hub-expiring-scim-tokens.notification.actionLink":[{"type":0,"value":"Regenerate key"}],"post-office.admin-hub-expiring-scim-tokens.notification.body":[{"type":0,"value":"Regenerate key for "},{"type":1,"value":"directoryName"},{"type":0,"value":" to continue user provisioning."}],"post-office.admin-hub-expiring-scim-tokens.notification.header":[{"type":0,"value":"Your SCIM API key will expire on "},{"type":1,"value":"expirationDate"},{"type":0,"value":"."}],"post-office.admin-hub-permissions-notification-shipit.admin-hub-notifications.body.non-final":[{"type":1,"value":"requesterName"},{"type":0,"value":" requested org admin permissions for "},{"type":1,"value":"orgName"},{"type":0,"value":"."}],"post-office.admin-hub-permissions-notification-shipit.admin-hub-notifications.heading.non-final":[{"type":0,"value":"Org Admin Request"}],"post-office.admin-hub-portfolio-analyzer-new-product-discovered-appified.admin-hub-notifications.body":[{"type":0,"value":"We\'ve found "},{"children":[{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" Atlassian app"}]},"other":{"value":[{"type":7},{"type":0,"value":" Atlassian apps"}]}},"pluralType":"cardinal","type":6,"value":"products"}],"type":8,"value":"strong"},{"type":0,"value":" that might belong to your portfolio. Review and connect them to get more insights. "}],"post-office.admin-hub-portfolio-analyzer-new-product-discovered-appified.admin-hub-notifications.heading":[{"type":0,"value":"Detected "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" Atlassian app"}]},"other":{"value":[{"type":7},{"type":0,"value":" Atlassian apps"}]}},"pluralType":"cardinal","type":6,"value":"products"}],"post-office.admin-hub-portfolio-analyzer-new-product-discovered-appified.notification.buttonText":[{"type":0,"value":"Review detected apps"}],"post-office.admin-hub-portfolio-analyzer-new-product-discovered.admin-hub-notifications.body":[{"type":0,"value":"We\'ve found "},{"children":[{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" product"}]},"other":{"value":[{"type":7},{"type":0,"value":" products"}]}},"pluralType":"cardinal","type":6,"value":"products"}],"type":8,"value":"strong"},{"type":0,"value":" that might belong to your portfolio. Review and connect them to get more insights. "}],"post-office.admin-hub-portfolio-analyzer-new-product-discovered.admin-hub-notifications.heading":[{"type":0,"value":"Detected "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" product"}]},"other":{"value":[{"type":7},{"type":0,"value":" products"}]}},"pluralType":"cardinal","type":6,"value":"products"}],"post-office.admin-hub-portfolio-analyzer-new-product-discovered.notification.buttonText":[{"type":0,"value":"Review detected products"}],"post-office.adminhub-common.email-header.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.adminhub-scope-alignment-reminder.admin-hub-notifications.body":[{"type":0,"value":"We\'re consolidating groups and teams visibility to support future improvements and features. Assign teams to a site to avoid losing team data."}],"post-office.adminhub-scope-alignment-reminder.admin-hub-notifications.heading":[{"type":0,"value":"Teams must be assigned to sites"}],"post-office.adminhub-scope-alignment-reminder.notification.buttonText":[{"type":0,"value":"Assign teams"}],"post-office.commerce-cbp-hard-limit-breach-ccp-breach.admin-hub-notifications.action":[{"type":0,"value":"View usage"}],"post-office.commerce-cbp-hard-limit-breach-ccp-breach.admin-hub-notifications.body":[{"type":0,"value":"As a result, some features will be restricted or unavailable until your allowance resets."}],"post-office.commerce-cbp-hard-limit-breach-ccp-breach.admin-hub-notifications.heading":[{"type":1,"value":"chargeElement"},{"type":0,"value":" limit reached"}],"post-office.commerce-cbp-hard-limit-breach-ccp-milestone.admin-hub-notifications.action":[{"type":0,"value":"View usage"}],"post-office.commerce-cbp-hard-limit-breach-ccp-milestone.admin-hub-notifications.body":[{"type":0,"value":"Your org has used "},{"type":1,"value":"usageMileStone"},{"type":0,"value":"% of its "},{"type":1,"value":"chargeElement"},{"type":0,"value":" limit. Monitor your org\u2019s usage in Atlassian Administration."}],"post-office.commerce-cbp-hard-limit-breach-ccp-milestone.admin-hub-notifications.heading":[{"type":1,"value":"usageMileStone"},{"type":0,"value":"% of "},{"type":1,"value":"chargeElement"},{"type":0,"value":" limit has been used"}],"post-office.commerce-decoupled-offering-ccp.admin-hub-notifications.action":[{"type":0,"value":"Review new bill"}],"post-office.commerce-decoupled-offering-ccp.admin-hub-notifications.body":[{"type":0,"value":"You can now be billed for this app based on the number of Jira Service Management agents, instead of Jira users. If you don\'t switch to the new way of billing, we\'ll transition you automatically soon."}],"post-office.commerce-decoupled-offering-ccp.admin-hub-notifications.heading":[{"type":0,"value":"Move to a new way of billing for "},{"type":1,"value":"productName"},{"type":0,"value":" for Jira Service Management"}],"post-office.commerce-decoupled-offering-order-confirmation-ccp.admin-hub-notifications.action":[{"type":0,"value":"View subscription"}],"post-office.commerce-decoupled-offering-order-confirmation-ccp.admin-hub-notifications.body":[{"type":0,"value":"The way you\'re billed for "},{"type":1,"value":"productName"},{"type":0,"value":" for Jira Service Management has been updated, which means you\'re now billed based on the number of JSM agents who have access to the app. Organization admins can view and manage user access in Atlassian Administration."}],"post-office.commerce-decoupled-offering-order-confirmation-ccp.admin-hub-notifications.heading":[{"type":0,"value":"Enjoy more control over billing for "},{"type":1,"value":"productName"},{"type":0,"value":" for JSM"}],"post-office.commerce-invoice-json-download-ppc.admin-hub-notifications.body":[{"type":0,"value":"You can start your download by clicking here"}],"post-office.commerce-invoice-json-download-ppc.admin-hub-notifications.heading":[{"type":0,"value":"JSON file for invoice ["},{"type":1,"value":"invoiceNumber"},{"type":0,"value":"] is ready"}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-multiple-different-trial-lengths.admin-hub.notification.body":[{"type":0,"value":"Get a free trial of "},{"type":1,"value":"entitlementOne"},{"type":0,"value":" & "},{"type":1,"value":"entitlementTwo"},{"type":0,"value":" "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":" with your "},{"type":1,"value":"purchasedEntitlement"},{"type":0,"value":" purchase."}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-multiple-different-trial-lengths.admin-hub.notification.header":[{"type":0,"value":"Try "},{"type":1,"value":"entitlementOne"},{"type":0,"value":" & "},{"type":1,"value":"entitlementTwo"},{"type":0,"value":" "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":" free"}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-multiple.admin-hub.notification.body":[{"type":0,"value":"Get a free trial of "},{"type":1,"value":"entitlementOne"},{"type":0,"value":" & "},{"type":1,"value":"entitlementTwo"},{"type":0,"value":" "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":" with your "},{"type":1,"value":"purchasedEntitlement"},{"type":0,"value":" purchase."}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-multiple.admin-hub.notification.header":[{"type":0,"value":"Try "},{"type":1,"value":"entitlementOne"},{"type":0,"value":" & "},{"type":1,"value":"entitlementTwo"},{"type":0,"value":" "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":" free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-confluence.admin-hub.notification.body":[{"type":0,"value":"Tired of hunting for the right doc? Build a single source of truth for your team\u2019s info with Confluence "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":". Free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":"."}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-confluence.admin-hub.notification.header":[{"type":0,"value":"Try Confluence"}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jira.admin-hub.notification.body":[{"type":0,"value":"With Jira, your team can move fast, stay aligned, and build better - together. Try the "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":" plan free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":"."}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jira.admin-hub.notification.header":[{"type":0,"value":"Try Jira"}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jpd.admin-hub.notification.body":[{"type":0,"value":"Say goodbye to messy backlogs. Keep your brilliant ideas in one place with Jira Product Discovery "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":". Free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":"."}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jpd.admin-hub.notification.header":[{"type":0,"value":"Try Jira Product Discovery"}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jsm.admin-hub.notification.body":[{"type":0,"value":"Bring developers, IT, and ops on the same tool and make work visible across teams with the "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":" plan. Free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":"."}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jsm.admin-hub.notification.header":[{"type":0,"value":"Try Jira Service Management"}],"post-office.commerce-migration-opsgenie-ccp.admin-hub.notification.body":[{"type":0,"value":"We\u2019ll need a payment method before "},{"type":1,"value":"lastDate"},{"type":0,"value":" to start the migration, otherwise migration will be cancelled automatically"}],"post-office.commerce-migration-opsgenie-ccp.admin-hub.notification.header.heading":[{"type":0,"value":"Migrating Opsgenie to "},{"type":1,"value":"targetProductName"},{"type":0,"value":", bill approval pending"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-no-discount-appify.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ll migrate from Opsgenie to your Atlassian cloud app on "},{"type":1,"value":"migrationDate"},{"type":0,"value":"."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-no-discount-appify.admin-hub.notification.header.heading":[{"type":0,"value":"Review the potential increase in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-no-discount.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ll migrate from Opsgenie to your Atlassian cloud product on "},{"type":1,"value":"migrationDate"},{"type":0,"value":"."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-no-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Review the potential increase in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-partial-discount-appify.admin-hub.notification.body":[{"type":0,"value":"We\'re providing a "},{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"discountPercentage"},{"type":0,"value":" discount on your Atlassian Guard subscription for one year and the estimated bill may have changed. Review the bill estimate based on the number of users who\u2019ll migrate from Opsgenie to your Atlassian cloud app on "},{"type":1,"value":"migrationDate"},{"type":0,"value":"."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-partial-discount-appify.admin-hub.notification.header.heading":[{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"discountPercentage"},{"type":0,"value":" discount applied on your Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-partial-discount.admin-hub.notification.body":[{"type":0,"value":"We\'re providing a "},{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"discountPercentage"},{"type":0,"value":" discount on your Atlassian Guard subscription for one year and the estimated bill may have changed. Review the bill estimate based on the number of users who\u2019ll migrate from Opsgenie to your Atlassian cloud product on "},{"type":1,"value":"migrationDate"},{"type":0,"value":"."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-partial-discount.admin-hub.notification.header.heading":[{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"discountPercentage"},{"type":0,"value":" discount applied on your Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount-appify.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ll migrate from Opsgenie to your Atlassian cloud app on "},{"type":1,"value":"migrationDate"},{"type":0,"value":"."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount-appify.admin-hub.notification.header.heading":[{"type":0,"value":"Review the changes in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount-appify.notification.manage-users":[{"type":0,"value":"Manage users"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount-appify.notification.review-subscription":[{"type":0,"value":"Review subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount-appify.notification.secondary-action":[{"type":0,"value":"Download Report"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ll migrate from Opsgenie to your Atlassian cloud product on "},{"type":1,"value":"migrationDate"},{"type":0,"value":"."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Review the changes in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount.notification.manage-users":[{"type":0,"value":"Manage users"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount.notification.review-subscription":[{"type":0,"value":"Review subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-no-discount-appify.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ve migrated from Opsgenie to your Atlassian cloud app."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-no-discount-appify.admin-hub.notification.header.heading":[{"type":0,"value":"Review the potential increase in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-no-discount.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ve migrated from Opsgenie to your Atlassian cloud product."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-no-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Review the potential increase in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-partial-discount-appify.admin-hub.notification.body":[{"type":0,"value":"We\u2019re providing a "},{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"discountPercentage"},{"type":0,"value":" discount for one year on your Atlassian Guard subscription. Ensure the bill estimate is correct based on the number of users migrated from Opsgenie to your Atlassian cloud app."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-partial-discount-appify.admin-hub.notification.header.heading":[{"type":0,"value":"Review the bill estimate of the discounted Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-partial-discount.admin-hub.notification.body":[{"type":0,"value":"We\u2019re providing a "},{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"discountPercentage"},{"type":0,"value":" discount for one year on your Atlassian Guard subscription. Ensure the bill estimate is correct based on the number of users migrated from Opsgenie to your Atlassian cloud product."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-partial-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Review the bill estimate of the discounted Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount-appify.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ve migrated from Opsgenie to your Atlassian cloud app."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount-appify.admin-hub.notification.header.heading":[{"type":0,"value":"Review the changes in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount-appify.notification.manage-users":[{"type":0,"value":"Manage users"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount-appify.notification.review-subscription":[{"type":0,"value":"Review subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ve migrated from Opsgenie to your Atlassian cloud product."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Review the changes in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount.notification.manage-users":[{"type":0,"value":"Manage users"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount.notification.review-subscription":[{"type":0,"value":"Review subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-new-ag-full-discount.admin-hub.notification.body":[{"type":0,"value":"We\'ve activated a new Atlassian Guard subscription with a "},{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"fullDiscountPercentage"},{"type":0,"value":" discount for one year. Review the subscription plan."}],"post-office.commerce-migration-opsgenie-generic-ccp-new-ag-full-discount.admin-hub.notification.header.heading":[{"type":0,"value":"A new Atlassian Guard subscription has been activated"}],"post-office.commerce-migration-opsgenie-generic-ccp-new-ag-review-full-discount.admin-hub.notification.body":[{"type":0,"value":"We\'ve activated a new Atlassian Guard subscription for your Jira Service Management Premium account. Verify the domains and review the list of users who\u2019ll use Atlassian Guard."}],"post-office.commerce-migration-opsgenie-generic-ccp-new-ag-review-full-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Configure your Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-full-discount-appify.admin-hub.notification.body":[{"type":0,"value":"We\'ve activated a new Atlassian Guard subscription with "},{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"fullDiscountPercentage"},{"type":0,"value":" discount for one year. Ensure the bill estimate is correct based on the number of users migrated from Opsgenie to your Atlassian cloud app."}],"post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-full-discount-appify.admin-hub.notification.header.heading":[{"type":0,"value":"Review the bill estimate of your newly activated Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-full-discount.admin-hub.notification.body":[{"type":0,"value":"We\'ve activated a new Atlassian Guard subscription with "},{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"fullDiscountPercentage"},{"type":0,"value":" discount for one year. Ensure the bill estimate is correct based on the number of users migrated from Opsgenie to your Atlassian cloud product."}],"post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-full-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Review the bill estimate of your newly activated Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-review-full-discount.admin-hub.notification.body":[{"type":0,"value":"We\'ve activated a new Atlassian Guard subscription for your Jira Service Management Premium account. Verify the domains and review the list of users who\u2019ll use Atlassian Guard."}],"post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-review-full-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Configure your Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp.admin-hub.notification.body":[{"type":1,"value":"bodyContent"}],"post-office.commerce-migration-opsgenie-generic-ccp.admin-hub.notification.header.heading":[{"type":1,"value":"titleContent"}],"post-office.commerce-payment-failure-hams-atlassian-access-paid.body":[{"type":0,"value":"We couldn\u2019t process payment for your subscription due to an issue with your payment details. To avoid losing your Atlassian Access security settings, update your payment details."}],"post-office.commerce-payment-failure-hams-atlassian-access-paid.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.commerce-payment-failure-hams-atlassian-access-trial.admin-hub-notifications.body":[{"type":0,"value":"We don\u2019t have a payment method for your subscription. To avoid losing your Atlassian Access security settings, add payment details as soon as possible."}],"post-office.commerce-payment-failure-hams-atlassian-access-trial.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.commerce-payment-failure-hams-multi-product-paid.body":[{"type":0,"value":"We couldn\u2019t process payment for subscriptions for this site ("},{"type":1,"value":"siteUrl"},{"type":0,"value":") due to an issue with your payment details. To avoid your subscription being deactivated, update your payment details."}],"post-office.commerce-payment-failure-hams-multi-product-paid.heading":[{"type":0,"value":"Payment failed for "},{"type":1,"value":"product"},{"type":0,"value":" +"},{"type":1,"value":"remainingProducts"},{"type":0,"value":" more"}],"post-office.commerce-payment-failure-hams-multi-product-trial.admin-hub-notifications.body":[{"type":0,"value":"We don\u2019t have a payment method for subscriptions for this site ("},{"type":1,"value":"siteUrl"},{"type":0,"value":"). To avoid your subscription being deactivated, add payment details as soon as possible."}],"post-office.commerce-payment-failure-hams-multi-product-trial.heading":[{"type":0,"value":"Payment failed for "},{"type":1,"value":"product"},{"type":0,"value":" +"},{"type":1,"value":"remainingProducts"},{"type":0,"value":" more"}],"post-office.commerce-payment-failure-hams-single-product-paid.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t process payment for your subscription due to an issue with your payment details. To avoid your subscription being deactivated, update your payment details."}],"post-office.commerce-payment-failure-hams-single-product-paid.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.commerce-payment-failure-hams-single-product-trial.admin-hub-notifications.body":[{"type":0,"value":"We don\u2019t have a payment method for your subscription. To avoid your subscription being deactivated, add payment details as soon as possible."}],"post-office.commerce-payment-failure-hams-single-product-trial.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.commerce-payment-failure-trials-multi-product-invalid-payment.body":[{"type":0,"value":"We couldn\u2019t process payment for subscriptions on your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":") due to an issue with your payment details. To avoid your subscription being deactivated, update your payment details."}],"post-office.commerce-payment-failure-trials-multi-product-invalid-payment.heading":[{"type":0,"value":"Payment failed for "},{"type":1,"value":"product"},{"type":0,"value":" +"},{"type":1,"value":"remainingProducts"},{"type":0,"value":" more"}],"post-office.commerce-payment-failure-trials-multi-product-missing-payment.body":[{"type":0,"value":"We don\u2019t have a payment method for your subscriptions on your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":"). To avoid your subscriptions being deactivated, add payment details as soon as possible."}],"post-office.commerce-payment-failure-trials-multi-product-missing-payment.heading":[{"type":0,"value":"Payment failed for "},{"type":1,"value":"product"},{"type":0,"value":" +"},{"type":1,"value":"remainingProducts"},{"type":0,"value":" more"}],"post-office.commerce-payment-failure-trials-single-product-invalid-payment.body":[{"type":0,"value":"We couldn\u2019t process payment for subscription due to an issue with your payment details. To avoid your subscription being deactivated, update your payment details."}],"post-office.commerce-payment-failure-trials-single-product-invalid-payment.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.commerce-payment-failure-trials-single-product-missing-payment.body":[{"type":0,"value":"We don\u2019t have a payment method for your subscription. To avoid your subscription being deactivated, add payment details."}],"post-office.commerce-payment-failure-trials-single-product-missing-payment.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.commerce-permission-request-add-payment-ccp.admin-hub-notifications.body.no-translate":[{"options":{"other":{"value":[{"type":0,"value":"Hi, I\u2019d like to request an upgrade and need payment details added to this subscription."}]},"true":{"value":[{"type":1,"value":"customMessage"}]}},"type":5,"value":"hasCustomMessage"}],"post-office.commerce-permission-request-add-payment-ccp.admin-hub-notifications.heading":[{"type":0,"value":"Request to add payment from "},{"type":1,"value":"name"}],"post-office.commerce-permission-request-add-payment-response-ccp.admin-hub-notifications.body.no-translate":[{"type":0,"value":"Great news! Your request has been approved. Billing admin has added payment details to your subscription."}],"post-office.commerce-permission-request-add-payment-response-ccp.admin-hub-notifications.heading":[{"type":0,"value":"Payment details added by billing admin"}],"post-office.commerce-permission-request-grant-ba-role-ccp.admin-hub-notifications.body.no-translate":[{"type":1,"value":"name"},{"type":0,"value":" ("},{"children":[{"type":1,"value":"email"}],"type":8,"value":"b"},{"type":0,"value":") requested billing admin permission."}],"post-office.commerce-permission-request-grant-ba-role-ccp.admin-hub-notifications.heading":[{"type":0,"value":"Billing admin access requested"}],"post-office.commerce-permission-request-grant-ba-role-response-ccp-approved.admin-hub-notifications.body":[{"type":0,"value":"Your billing admin request was approved."}],"post-office.commerce-permission-request-grant-ba-role-response-ccp-approved.admin-hub-notifications.heading":[{"type":0,"value":"You\'re now a billing admin"}],"post-office.commerce-permission-request-grant-ba-role-response-ccp-declined.admin-hub-notifications.body":[{"type":0,"value":"Your billing admin request was declined. If needed, you can submit another request."}],"post-office.commerce-permission-request-grant-ba-role-response-ccp-declined.admin-hub-notifications.heading":[{"type":0,"value":"Your request to be a billing admin was declined"}],"post-office.commerce-pre-dunning-ccp-multi-trial-missing-payment.body":[{"type":0,"value":"We don\u2019t have a payment method for some of your subscriptions. To avoid your subscriptions being deactivated, add payment details as soon as possible."}],"post-office.commerce-pre-dunning-ccp-multi-trial-missing-payment.heading":[{"type":0,"value":"Your trial expired for "},{"type":1,"value":"product"},{"type":0,"value":" +"},{"type":1,"value":"remainingProducts"},{"type":0,"value":" more"}],"post-office.commerce-pre-dunning-ccp-single-trial-missing-payment.body":[{"type":0,"value":"We don\u2019t have a payment method for your subscription. To avoid your subscription being deactivated, add payment details as soon as possible."}],"post-office.commerce-pre-dunning-ccp-single-trial-missing-payment.heading":[{"type":0,"value":"Your "},{"type":1,"value":"product"},{"type":0,"value":" trial expired"}],"post-office.commerce-quote-json-download-ppc.admin-hub-notifications.body":[{"type":0,"value":"You can start your download by clicking here"}],"post-office.commerce-quote-json-download-ppc.admin-hub-notifications.heading":[{"type":0,"value":"JSON file for quote ["},{"type":1,"value":"quoteNumber"},{"type":0,"value":"] is ready"}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-pooled-meter-announce-breach.admin-hub-notifications.body":[{"type":0,"value":"Your org has used "},{"type":1,"value":"usageMileStone"},{"type":0,"value":"% of its "},{"type":1,"value":"chargeElement"},{"type":0,"value":" allowance. Monitor your org\u2019s usage in Atlassian Administration."}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-pooled-meter-announce-breach.admin-hub-notifications.heading":[{"type":1,"value":"chargeElement"},{"type":0,"value":" allowance reached"}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-pooled-meter-announce-milestone.admin-hub-notifications.body":[{"type":0,"value":"Your org has used "},{"type":1,"value":"usageMileStone"},{"type":0,"value":"% of its "},{"type":1,"value":"chargeElement"},{"type":0,"value":" allowance. Monitor your org\u2019s usage in Atlassian Administration."}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-pooled-meter-announce-milestone.admin-hub-notifications.heading":[{"type":1,"value":"usageMileStone"},{"type":0,"value":"% of "},{"type":1,"value":"chargeElement"},{"type":0,"value":" allowance used"}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-pooled-meter-announce-view-usage.admin-hub-notifications.action":[{"type":0,"value":"View usage"}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rde.admin-hub-notifications.action":[{"type":0,"value":"Request upgrade"}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rde.admin-hub-notifications.body":[{"type":0,"value":"Rovo Dev will be disabled for users who reach their limit. Allow more credits by requesting an upgrade to Rovo Dev Standard."}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rde.admin-hub-notifications.heading":[{"type":0,"value":"Upgrade Rovo Dev users to avoid interruption"}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rds-mileStone-generic.admin-hub-notifications.body":[{"type":0,"value":"At least one user has reached "},{"type":1,"value":"usageMileStone"},{"type":0,"value":"% of their Rovo Dev credit limit. If extra usage is enabled, extra charges will apply to use over the limit. Otherwise, Rovo Dev will be disabled for those users."}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rds-mileStone-generic.admin-hub-notifications.heading":[{"type":1,"value":"usageMileStone"},{"type":0,"value":"% of Rovo Dev credits used"}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rds.admin-hub-notifications.body":[{"type":0,"value":"If an extra usage limit has been set, Rovo Dev usage will be disabled for those users. Otherwise, charges will apply for extra usage."}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rds.admin-hub-notifications.heading":[{"type":0,"value":"Users have reached their Rovo Dev credit limit"}],"post-office.commerce-subscription-paid-trials-auto-conversion-off-ccp.admin-hub-notifications.body":[{"type":0,"value":"A "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been added to your billing account ("},{"type":1,"value":"transactionAccountNumber"},{"type":0,"value":"). You can move it to a different billing account until your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":"."}],"post-office.commerce-subscription-paid-trials-auto-conversion-off-ccp.admin-hub-notifications.heading":[{"type":0,"value":"New subscription added to your account"}],"post-office.commerce-subscription-paid-trials-ccp.admin-hub-notifications.body":[{"type":0,"value":"A "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been added to your billing account ("},{"type":1,"value":"transactionAccountNumber"},{"type":0,"value":"). You can move it to a different billing account until your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":"."}],"post-office.commerce-subscription-paid-trials-ccp.admin-hub-notifications.heading":[{"type":0,"value":"New subscription added to your account"}],"post-office.commerce-subscription-paid-trials-no-payment-method-ccp.admin-hub-notifications.body":[{"type":0,"value":"A "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been added to your billing account ("},{"type":1,"value":"transactionAccountNumber"},{"type":0,"value":"). You can move it to a different billing account until your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":"."}],"post-office.commerce-subscription-paid-trials-no-payment-method-ccp.admin-hub-notifications.heading":[{"type":0,"value":"New subscription added to your account"}],"post-office.common.email.body.sent-by-atlassian-cloud.footer.org-id":[{"type":0,"value":" (ID: "},{"type":1,"value":"orgId"},{"type":0,"value":")"}],"post-office.common.email.body.sent-by-atlassian-cloud.footer.text":[{"type":0,"value":"This message was sent to you by Atlassian Administration. You are receiving this email because you are an admin for "},{"type":1,"value":"orgName"}],"post-office.et-domain-verification-missing-token.admin-hub.notification.body":[{"type":0,"value":"We\'re unable to verify that you own "},{"children":[{"type":1,"value":"domain"}],"type":8,"value":"strong"},{"type":0,"value":" due to missing tokens. Verify this domain to keep your managed accounts."}],"post-office.et-domain-verification-missing-token.admin-hub.notification.header":[{"type":0,"value":"Domain will be unverified in "},{"type":1,"value":"remainingDays"},{"type":0,"value":" days"}],"post-office.et-domain-verification-token-revoked.admin-hub.notification.body":[{"children":[{"type":1,"value":"domain"}],"type":8,"value":"strong"},{"type":0,"value":" is no longer verified. Accounts with this domain are now unmanaged. Verify the domain again to claim these accounts."}],"post-office.et-domain-verification-token-revoked.admin-hub.notification.header":[{"type":0,"value":"Domain has been unverified"}],"post-office.generic-invalid-payment.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t process payment for your subscription because of an issue with your payment details. To avoid your subscription being deactivated, update your payment details by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.generic-invalid-payment.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.generic-missing-payment.admin-hub-notifications.body":[{"type":0,"value":"We don\u2019t have payment details for your subscription. To avoid your subscription being deactivated, add payment details by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.generic-missing-payment.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.multi-generic-invalid.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t process payment for subscriptions on this site "},{"type":1,"value":"siteUrl"},{"type":0,"value":" due to an issue with your payment details. To avoid your subscription being deactivated, update your payment details by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.multi-generic-invalid.admin-hub-notifications.heading":[{"type":0,"value":"Payment failed"}],"post-office.multi-generic-missing.admin-hub-notifications.body":[{"type":0,"value":"We don\u2019t have a payment method for subscriptions on this site "},{"type":1,"value":"siteUrl"},{"type":0,"value":". To avoid your subscription being deactivated, add payment details by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.multi-generic-missing.admin-hub-notifications.heading":[{"type":0,"value":"Payment failed"}],"post-office.one-admin-left-notification.admin-hub.notification.body":[{"type":0,"value":"You\'re the only organization admin for this organization. Add another admin to avoid being locked out if you lose access."}],"post-office.one-admin-left-notification.admin-hub.notification.header":[{"type":0,"value":"Only one organization admin"}],"post-office.one-admin-left-notification.admin-hub.notification.how-to-add-admin-link":[{"type":0,"value":"How to add an admin"}],"post-office.one-admin-left-notification.notification.add-another-admin-link":[{"type":0,"value":"Add another organization admin"}],"post-office.partner-unified-xp-pvr-registrations.admin-hub-notifications.body":[{"type":0,"value":"You can view the PVR registration by clicking here"}],"post-office.partner-unified-xp-pvr-registrations.admin-hub-notifications.heading":[{"type":0,"value":"PVR registration "},{"type":1,"value":"pvrNumber"},{"type":0,"value":" submitted by "},{"type":1,"value":"submittedBy"}],"post-office.pure-dynamic-template.admin-hub.notification.body.no-translate":[{"type":1,"value":"bodyText"}],"post-office.pure-dynamic-template.admin-hub.notification.header.heading.no-translate":[{"type":1,"value":"headingText"}],"post-office.single-generic-invalid.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t process payment for your subscription due to a problem with your payment details. To avoid your subscription being deactivated, update your payment details by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.single-generic-invalid.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.single-generic-missing.admin-hub-notifications.body":[{"type":0,"value":"We don\u2019t have a payment method for your subscription. To avoid your subscription being deactivated, add a payment method by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.single-generic-missing.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.three-ds-payment-failure.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t process your payment since we need your help to complete 3-D Secure (3DS) authentication."}],"post-office.three-ds-payment-failure.admin-hub-notifications.heading":[{"type":0,"value":"3DS payment failure"}],"post-office.townsquare-goals-request-trial.admin-hub-notifications.body":[{"type":0,"value":"Hi, I\u2019d like to try goals in the early access program. I think it can help the team save time and work better together. It\u2019s free to try if we\u2019re eligible."}],"post-office.townsquare-goals-request-trial.admin-hub-notifications.heading":[{"type":1,"value":"requesterName"},{"type":0,"value":" sent an approval request."}],"toggleLabel":[{"type":0,"value":"Only show unread"}]}');

});

parcelRegister("bRqeA", function(module, exports) {

let $8a28fe8c393ddb21$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8a28fe8c393ddb21$var$load("eWLcK").then(()=>parcelRequire('gDRIW'));

});

parcelRegister("9jD1I", function(module, exports) {

let $6c84294fe1449a2e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6c84294fe1449a2e$var$load("2T0W4").then(()=>parcelRequire('eLcdP'));

});

parcelRegister("cZ3uF", function(module, exports) {

let $973de44f60c63e00$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $973de44f60c63e00$var$load("9IIJ7").then(()=>parcelRequire('hsgqZ'));

});

parcelRegister("dmPno", function(module, exports) {

let $9bb52eb19c634fb1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9bb52eb19c634fb1$var$load("cugua").then(()=>parcelRequire('2cqmf'));

});

parcelRegister("d63z9", function(module, exports) {

let $988e9a031bfd1ae2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $988e9a031bfd1ae2$var$load("iyIG8").then(()=>parcelRequire('gg1CP'));

});

parcelRegister("dYrFI", function(module, exports) {

let $a2c658084fc618b6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a2c658084fc618b6$var$load("hHL2G").then(()=>parcelRequire('9MLdd'));

});

parcelRegister("fwUrk", function(module, exports) {

let $b4e59fee03185fa7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b4e59fee03185fa7$var$load("jfwui").then(()=>parcelRequire('1HcFC'));

});

parcelRegister("aSvJn", function(module, exports) {

let $7eb78fa428dbd579$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7eb78fa428dbd579$var$load("2UlhK").then(()=>parcelRequire('4rvnJ'));

});

parcelRegister("hJ4rW", function(module, exports) {

let $ce7a173b27c8720f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ce7a173b27c8720f$var$load("hh17O").then(()=>parcelRequire('14rsg'));

});

parcelRegister("57BZh", function(module, exports) {

let $3bab12b70bab94d2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3bab12b70bab94d2$var$load("YsXtp").then(()=>parcelRequire('fjU0o'));

});

parcelRegister("48G6M", function(module, exports) {

let $3038929a9af5be47$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3038929a9af5be47$var$load("opvyH").then(()=>parcelRequire('hXkW3'));

});

parcelRegister("ce9jn", function(module, exports) {

let $8e6e03e4daac3137$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8e6e03e4daac3137$var$load("8BxCK").then(()=>parcelRequire('etu66'));

});

parcelRegister("8uzv1", function(module, exports) {

let $62eca984292b7364$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $62eca984292b7364$var$load("dA5Gb").then(()=>parcelRequire('gOGuu'));

});

parcelRegister("kvD9W", function(module, exports) {

let $eee5141fa9689947$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eee5141fa9689947$var$load("61IAr").then(()=>parcelRequire('kVpQP'));

});

parcelRegister("8ala4", function(module, exports) {

let $5f1fac1f26bd4a1e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5f1fac1f26bd4a1e$var$load("ga2TL").then(()=>parcelRequire('kE3gq'));

});

parcelRegister("hhTMG", function(module, exports) {

let $c95f4bc9aa5540df$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c95f4bc9aa5540df$var$load("652oW").then(()=>parcelRequire('4JU8n'));

});

parcelRegister("j9FdF", function(module, exports) {

let $df1ed4e5113be7c5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $df1ed4e5113be7c5$var$load("1rWCo").then(()=>parcelRequire('763ky'));

});

parcelRegister("8DcID", function(module, exports) {

let $648bd4f65e3b8329$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $648bd4f65e3b8329$var$load("38R1r").then(()=>parcelRequire('ii5Pq'));

});

parcelRegister("g93PL", function(module, exports) {

let $bc1075efdaf2e9af$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bc1075efdaf2e9af$var$load("jJJBm").then(()=>parcelRequire('8dH9J'));

});

parcelRegister("38C5h", function(module, exports) {

let $248fa92f2ba8577d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $248fa92f2ba8577d$var$load("4Owtx").then(()=>parcelRequire('lzUbJ'));

});

parcelRegister("1j6R2", function(module, exports) {

let $0f3ce1f454ddc8a7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0f3ce1f454ddc8a7$var$load("h4PCn").then(()=>parcelRequire('66Wiy'));

});

parcelRegister("db8Mq", function(module, exports) {

let $99831cfe73a3fd85$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $99831cfe73a3fd85$var$load("3CP92").then(()=>parcelRequire('2gIVQ'));

});

parcelRegister("dAssT", function(module, exports) {

let $9e44b7bc9937b176$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9e44b7bc9937b176$var$load("bWTZH").then(()=>parcelRequire('8grab'));

});

parcelRegister("hXhj2", function(module, exports) {

let $d1255efd8488ee2e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d1255efd8488ee2e$var$load("jNYJM").then(()=>parcelRequire('62WZV'));

});

parcelRegister("ijv9f", function(module, exports) {

let $d55229b903d397e6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d55229b903d397e6$var$load("JFzIm").then(()=>parcelRequire('3mhE7'));

});

parcelRegister("bwFNp", function(module, exports) {

let $86431aad7348782e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $86431aad7348782e$var$load("fADOz").then(()=>parcelRequire('f97jT'));

});

parcelRegister("7EuHF", function(module, exports) {

let $592415e0ecd48a53$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $592415e0ecd48a53$var$load("fzfXk").then(()=>parcelRequire('cXi1a'));

});

parcelRegister("824Zb", function(module, exports) {

let $5d9260bd71d6fd94$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5d9260bd71d6fd94$var$load("hJXks").then(()=>parcelRequire('3bENj'));

});

parcelRegister("3Vtyt", function(module, exports) {

let $2dbd9efe0bc49c85$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2dbd9efe0bc49c85$var$load("e3tNc").then(()=>parcelRequire('5YNhz'));

});

parcelRegister("bzZRD", function(module, exports) {

let $86e2f37f97ba0fcb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $86e2f37f97ba0fcb$var$load("985CF").then(()=>parcelRequire('2pf0Y'));

});

parcelRegister("5PAsW", function(module, exports) {

let $43ee0085e4bffe6f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $43ee0085e4bffe6f$var$load("78b3f").then(()=>parcelRequire('jVhcJ'));

});

parcelRegister("f2STn", function(module, exports) {

let $af419f606fe02c07$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $af419f606fe02c07$var$load("ayC8c").then(()=>parcelRequire('03715'));

});

parcelRegister("iNdWn", function(module, exports) {

let $dae79deaee0a6d36$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dae79deaee0a6d36$var$load("7lW68").then(()=>parcelRequire('4tD29'));

});

parcelRegister("7LKZI", function(module, exports) {

let $5a8160470db3a26d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a8160470db3a26d$var$load("1KdtN").then(()=>parcelRequire('9nXnA'));

});

parcelRegister("e0FlU", function(module, exports) {
module.exports = JSON.parse("{\"rovo-agents.scenario-onboarding.backButton\":[{\"type\":0,\"value\":\"Back\"}],\"rovo-agents.scenario-onboarding.close.no-translate\":[{\"type\":0,\"value\":\"Close\"}],\"rovo-agents.scenario-onboarding.doneButton\":[{\"type\":0,\"value\":\"Done\"}],\"rovo-agents.scenario-onboarding.gettingStarted\":[{\"type\":0,\"value\":\"Getting started with your agent\"}],\"rovo-agents.scenario-onboarding.nextButton\":[{\"type\":0,\"value\":\"Next\"}],\"rovo-agents.scenario-onboarding.startTour\":[{\"type\":0,\"value\":\"Start Tour\"}],\"rovo-agents.scenario-onboarding.step1Body\":[{\"type\":0,\"value\":\"Scenarios allow you to instruct your agent to do things differently depending on the situation.\"}],\"rovo-agents.scenario-onboarding.step1Headline\":[{\"type\":0,\"value\":\"Tune your agent to each situation\"}],\"rovo-agents.scenario-onboarding.step2Body\":[{\"type\":0,\"value\":\"Unlike scenarios, behavior is the instructions your agent always follows, no matter the situation.\"}],\"rovo-agents.scenario-onboarding.step2Headline\":[{\"type\":0,\"value\":\"Set your agent's traits and goals\"}],\"rovo-agents.scenario-onboarding.step3Body\":[{\"type\":0,\"value\":\"You can add knowledge to your agent's scenarios so it has the right information to answer prompts in each situation.\"}],\"rovo-agents.scenario-onboarding.step3Headline\":[{\"type\":0,\"value\":\"See what your agent knows\"}],\"rovo-agents.scenario-onboarding.step4Body\":[{\"type\":0,\"value\":\"You can add skills to your agent's scenarios so it can connect and take action across apps.\"}],\"rovo-agents.scenario-onboarding.step4Headline\":[{\"type\":0,\"value\":\"See what your agent can do\"}],\"rovo-agents.scenario-onboarding.stepIndicator\":[{\"type\":1,\"value\":\"currentStep\"},{\"type\":0,\"value\":\" of \"},{\"type\":1,\"value\":\"totalSteps\"}]}");

});

parcelRegister("eabg7", function(module, exports) {

let $a4fabba68e00317b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a4fabba68e00317b$var$load("c2cNk").then(()=>parcelRequire('g3aLF'));

});

parcelRegister("jZeAX", function(module, exports) {

let $e8cf0915a22f6631$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e8cf0915a22f6631$var$load("QGW8D").then(()=>parcelRequire('8g2vO'));

});

parcelRegister("2axJb", function(module, exports) {

let $1946ad95b5608d6d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1946ad95b5608d6d$var$load("ifl3H").then(()=>parcelRequire('5Q5fO'));

});

parcelRegister("lUsnv", function(module, exports) {

let $ff34d7438629bf5a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ff34d7438629bf5a$var$load("4mEml").then(()=>parcelRequire('53hPN'));

});

parcelRegister("8c7JZ", function(module, exports) {

let $5f7572e59acb670a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5f7572e59acb670a$var$load("rZOZY").then(()=>parcelRequire('6I9wx'));

});

parcelRegister("abUmM", function(module, exports) {

let $76b6a7a32ef744b4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $76b6a7a32ef744b4$var$load("dDFt1").then(()=>parcelRequire('izODv'));

});

parcelRegister("eXUz1", function(module, exports) {

let $ae5273c9aad06291$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae5273c9aad06291$var$load("2JeW2").then(()=>parcelRequire('2xbrn'));

});

parcelRegister("fEYiZ", function(module, exports) {

let $b6695eca943024fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b6695eca943024fc$var$load("77e5Z").then(()=>parcelRequire('3cnHI'));

});

parcelRegister("5ptAs", function(module, exports) {

let $3f063ce92a888344$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3f063ce92a888344$var$load("9e1BM").then(()=>parcelRequire('hOkKa'));

});

parcelRegister("1VQcl", function(module, exports) {

let $16839ac7cb8b7e4c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $16839ac7cb8b7e4c$var$load("jli6F").then(()=>parcelRequire('88Pbf'));

});

parcelRegister("4xiJB", function(module, exports) {

let $34d8c6cb373b1dd8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $34d8c6cb373b1dd8$var$load("aKNtX").then(()=>parcelRequire('gD7TW'));

});

parcelRegister("g7kN0", function(module, exports) {

let $bbbd6d1d9f7a7f90$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bbbd6d1d9f7a7f90$var$load("b1YKO").then(()=>parcelRequire('dIOb5'));

});

parcelRegister("5aDHN", function(module, exports) {

let $3c3caf9757e84a38$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3c3caf9757e84a38$var$load("5yx51").then(()=>parcelRequire('287IL'));

});

parcelRegister("6Db5r", function(module, exports) {

let $4d3efc2f4129054e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4d3efc2f4129054e$var$load("8bdxk").then(()=>parcelRequire('abqJ2'));

});

parcelRegister("7EnAW", function(module, exports) {

let $591e92412b539392$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $591e92412b539392$var$load("lmyBt").then(()=>parcelRequire('bcqJt'));

});

parcelRegister("1NMC1", function(module, exports) {

let $1500136b7a032e26$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1500136b7a032e26$var$load("7d1aK").then(()=>parcelRequire('dx9Yh'));

});

parcelRegister("h7mrz", function(module, exports) {

let $c7647ff3325ec027$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c7647ff3325ec027$var$load("dXU3R").then(()=>parcelRequire('ASIbO'));

});

parcelRegister("dJrN5", function(module, exports) {

let $9ff508fc29d2fd78$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9ff508fc29d2fd78$var$load("3EIMp").then(()=>parcelRequire('90zwb'));

});

parcelRegister("kIiRu", function(module, exports) {

let $f1468c4669e8840a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f1468c4669e8840a$var$load("1SKts").then(()=>parcelRequire('8AO1A'));

});

parcelRegister("6cC5U", function(module, exports) {

let $484169c6fe4fd565$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $484169c6fe4fd565$var$load("jLUYl").then(()=>parcelRequire('izNDz'));

});

parcelRegister("jOK5M", function(module, exports) {

let $e6d670c8590a6d59$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e6d670c8590a6d59$var$load("4pRNe").then(()=>parcelRequire('t8RbL'));

});

parcelRegister("3cL9D", function(module, exports) {

let $255711f3f513e7b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $255711f3f513e7b3$var$load("hFiOH").then(()=>parcelRequire('7LtNY'));

});

parcelRegister("3sD7h", function(module, exports) {

let $2852544fa75330be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2852544fa75330be$var$load("f9dTk").then(()=>parcelRequire('grELN'));

});

parcelRegister("5TuXS", function(module, exports) {

let $44aa1bc46649a520$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $44aa1bc46649a520$var$load("40l8F").then(()=>parcelRequire('ihcxT'));

});

parcelRegister("7PMPV", function(module, exports) {

let $5b432db6c085f47c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5b432db6c085f47c$var$load("aCDxA").then(()=>parcelRequire('3HZz3'));

});

parcelRegister("4fQN1", function(module, exports) {

let $3191831052ee1d58$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3191831052ee1d58$var$load("bbzzZ").then(()=>parcelRequire('fSqVW'));

});

parcelRegister("2sOFs", function(module, exports) {

let $1cb57fd458a90a7d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1cb57fd458a90a7d$var$load("kEAWR").then(()=>parcelRequire('eRL2S'));

});

parcelRegister("aFgC3", function(module, exports) {

let $7c3a9ea8e4450213$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7c3a9ea8e4450213$var$load("btCC0").then(()=>parcelRequire('gAZWb'));

});

parcelRegister("idbW5", function(module, exports) {

let $d422b3209c036515$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d422b3209c036515$var$load("fRb1S").then(()=>parcelRequire('4zy6a'));

});

parcelRegister("kY8vo", function(module, exports) {

let $f4400237aea1f309$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f4400237aea1f309$var$load("9JiEa").then(()=>parcelRequire('beqfv'));

});

parcelRegister("7t28c", function(module, exports) {

let $56fce51529b3d8bb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $56fce51529b3d8bb$var$load("4Kewe").then(()=>parcelRequire('4TcAS'));

});

parcelRegister("877yj", function(module, exports) {

let $5e84d5e99f0e3124$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5e84d5e99f0e3124$var$load("b5fXF").then(()=>parcelRequire('ick0T'));

});

parcelRegister("6J3MX", function(module, exports) {

let $4e59e260facd3dd2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4e59e260facd3dd2$var$load("hN4vM").then(()=>parcelRequire('lfr2i'));

});

parcelRegister("bjFRG", function(module, exports) {

let $83d1f18c6c9717d0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $83d1f18c6c9717d0$var$load("k2TRi").then(()=>parcelRequire('iZH4z'));

});

parcelRegister("17jnj", function(module, exports) {
module.exports = JSON.parse('{"assets-deeplinking-modal.closeButton":[{"type":0,"value":"Close"}],"assets-deeplinking-modal.description1":[{"type":0,"value":"You can now click directly on data points in your charts to drill in and see the underlying records. For example, if you select a bar in the \u201CTicket volume\u201D chart, we\u2019ll open a detailed view showing the actual tickets that make up that data point."}],"assets-deeplinking-modal.description2":[{"type":0,"value":"This lets you move from high-level trends to the raw sources behind them in just one click."}],"assets-deeplinking-modal.doneButton":[{"type":0,"value":"Done"}],"assets-deeplinking-modal.heading":[{"type":0,"value":"See the data behind your charts"}],"jira-ops-reports-changeboarding.close-button":[{"type":0,"value":"Close"}],"jira-ops-reports-changeboarding.done-button":[{"type":0,"value":"Got it"}],"jira-ops-reports-changeboarding.feature1":[{"type":0,"value":"Add views as tabs to organize information your way"}],"jira-ops-reports-changeboarding.feature2":[{"type":0,"value":"Create new charts to meet your custom needs."}],"jira-ops-reports-changeboarding.heading":[{"type":0,"value":"Your new reporting experience"}],"jira-ops-reports-changeboarding.more-about-reports-button":[{"type":0,"value":"More about reports"}],"jira-ops-reports-changeboarding.subtitle":[{"type":0,"value":"Tailor your reports by adding tabs, widgets, charts and editing filters."}],"jira-ops-reports-changeboarding.whats-new-heading":[{"type":0,"value":"What\u2019s new?"}]}');

});

parcelRegister("6ClI5", function(module, exports) {

let $4d1721d90763667f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4d1721d90763667f$var$load("f7WNn").then(()=>parcelRequire('4jDg1'));

});

parcelRegister("8hGTN", function(module, exports) {

let $6081301c5eaa781e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6081301c5eaa781e$var$load("7gDpy").then(()=>parcelRequire('cLCJ4'));

});

parcelRegister("kgAWE", function(module, exports) {

let $ec11f5c70e79e470$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ec11f5c70e79e470$var$load("ei38P").then(()=>parcelRequire('gYJh2'));

});

parcelRegister("5i55E", function(module, exports) {

let $3da294f7f4bff2ad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3da294f7f4bff2ad$var$load("fdgSn").then(()=>parcelRequire('9e5Xy'));

});

parcelRegister("6lzM7", function(module, exports) {

let $49f07468f0e2be52$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $49f07468f0e2be52$var$load("fwT6m").then(()=>parcelRequire('5skey'));

});

parcelRegister("c6grN", function(module, exports) {

let $8cf2cdabce865ec3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8cf2cdabce865ec3$var$load("gXNhS").then(()=>parcelRequire('hpkWz'));

});

parcelRegister("eXr6z", function(module, exports) {

let $ae3b99da6d784e69$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae3b99da6d784e69$var$load("KbdSp").then(()=>parcelRequire('33VPg'));

});

parcelRegister("7Waeo", function(module, exports) {

let $017dc5b936b15eb4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $017dc5b936b15eb4$var$load("ccfBZ").then(()=>parcelRequire('jmquI'));

});

parcelRegister("av8hd", function(module, exports) {

let $7a533837d25c416d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a533837d25c416d$var$load("11O9x").then(()=>parcelRequire('bs9vZ'));

});

parcelRegister("iinO3", function(module, exports) {

let $d51c5fdff3e468bd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d51c5fdff3e468bd$var$load("hUdDj").then(()=>parcelRequire('iJhe0'));

});

parcelRegister("6aSdw", function(module, exports) {

let $47edbb9c4ff263b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $47edbb9c4ff263b7$var$load("aYE4r").then(()=>parcelRequire('ghPja'));

});

parcelRegister("8IdGC", function(module, exports) {

let $01a30c972327f970$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $01a30c972327f970$var$load("48zVO").then(()=>parcelRequire('98jLT'));

});

parcelRegister("5Ljvt", function(module, exports) {

let $43207922bf183141$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $43207922bf183141$var$load("iKk6B").then(()=>parcelRequire('kJB8U'));

});

parcelRegister("h9UHK", function(module, exports) {

let $c7df4349f40bc7e3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c7df4349f40bc7e3$var$load("8DXol").then(()=>parcelRequire('6Jxyr'));

});

parcelRegister("exAVp", function(module, exports) {

let $a960ca4e3a20d916$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a960ca4e3a20d916$var$load("3aGSv").then(()=>parcelRequire('fiCF0'));

});

parcelRegister("fkdWp", function(module, exports) {

let $b28389ab1577e9d9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b28389ab1577e9d9$var$load("1kIci").then(()=>parcelRequire('i3sps'));

});

parcelRegister("g930E", function(module, exports) {

let $bc0fd234cc17c41d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bc0fd234cc17c41d$var$load("hMgGX").then(()=>parcelRequire('dlDoU'));

});

parcelRegister("fWgxi", function(module, exports) {

let $b9a9197c8454bff8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b9a9197c8454bff8$var$load("3SQRp").then(()=>parcelRequire('701D3'));

});

parcelRegister("fDLGH", function(module, exports) {

let $b62f7d564f3f6f45$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b62f7d564f3f6f45$var$load("1wPsb").then(()=>parcelRequire('8wcaG'));

});

parcelRegister("lTuyI", function(module, exports) {

let $ff0670682c2f99c7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ff0670682c2f99c7$var$load("4UbgM").then(()=>parcelRequire('icNiA'));

});

parcelRegister("hfwWF", function(module, exports) {

let $c8ed64a3357bc9b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c8ed64a3357bc9b7$var$load("7wxHT").then(()=>parcelRequire('9TSXb'));

});

parcelRegister("iYOer", function(module, exports) {

let $0390d9fe79ae776f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0390d9fe79ae776f$var$load("aushQ").then(()=>parcelRequire('4U3Do'));

});

parcelRegister("b7HfY", function(module, exports) {

let $8191e70a32c37776$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8191e70a32c37776$var$load("gmbe8").then(()=>parcelRequire('9oMWl'));

});

parcelRegister("e12Gu", function(module, exports) {

let $a3433dc1d6bef1a2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a3433dc1d6bef1a2$var$load("7LC10").then(()=>parcelRequire('fSxHo'));

});

parcelRegister("khLm8", function(module, exports) {

let $ec4a211ea8f068da$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ec4a211ea8f068da$var$load("lOHne").then(()=>parcelRequire('jBnAe'));

});

parcelRegister("bxTdC", function(module, exports) {

let $867d9c0b02a10fa4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $867d9c0b02a10fa4$var$load("bEtan").then(()=>parcelRequire('86N95'));

});

parcelRegister("7zpdc", function(module, exports) {

let $582f5bde5a9bca99$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $582f5bde5a9bca99$var$load("5ASZi").then(()=>parcelRequire('cVirH'));

});

parcelRegister("eeoPq", function(module, exports) {

let $a5c5a1ec1ada6481$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a5c5a1ec1ada6481$var$load("e3EkW").then(()=>parcelRequire('iHj8H'));

});

parcelRegister("5Bt1H", function(module, exports) {

let $4146ec7824ef94de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4146ec7824ef94de$var$load("fgwxB").then(()=>parcelRequire('bZ1s3'));

});

parcelRegister("lMJex", function(module, exports) {

let $fdc12b12990cc13c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fdc12b12990cc13c$var$load("b97TL").then(()=>parcelRequire('53lm2'));

});

parcelRegister("8ggZy", function(module, exports) {

let $603cff961e609247$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $603cff961e609247$var$load("kqGj7").then(()=>parcelRequire('kETxu'));

});

parcelRegister("gOpNc", function(module, exports) {

let $c3d552b456de9185$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c3d552b456de9185$var$load("47TJV").then(()=>parcelRequire('5Sb7N'));

});

parcelRegister("9JALx", function(module, exports) {

let $7164d5eb61319afe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7164d5eb61319afe$var$load("VzTdH").then(()=>parcelRequire('521Vt'));

});

parcelRegister("e2NTg", function(module, exports) {

let $a397f3c21843e1c5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a397f3c21843e1c5$var$load("68wRK").then(()=>parcelRequire('erD4R'));

});

parcelRegister("aDXRl", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("dhgg6", function(module, exports) {

let $9aa97983c54cc73e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9aa97983c54cc73e$var$load("hklN5").then(()=>parcelRequire('Pnbvz'));

});

parcelRegister("4quJN", function(module, exports) {

let $33916f004bba2870$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $33916f004bba2870$var$load("bYzoO").then(()=>parcelRequire('hw6F1'));

});

parcelRegister("4YtW3", function(module, exports) {

let $39f3fc90292cfce0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $39f3fc90292cfce0$var$load("5oeVE").then(()=>parcelRequire('4GxPk'));

});

parcelRegister("1dXJ4", function(module, exports) {

let $0e4555aa3b1eb04d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0e4555aa3b1eb04d$var$load("6oncS").then(()=>parcelRequire('6CJQQ'));

});

parcelRegister("hpIew", function(module, exports) {

let $cad7153fa4f19290$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cad7153fa4f19290$var$load("dLIpQ").then(()=>parcelRequire('92xsd'));

});

parcelRegister("l91fK", function(module, exports) {

let $f64b690aa9ce67aa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f64b690aa9ce67aa$var$load("3roLh").then(()=>parcelRequire('64Tla'));

});

parcelRegister("7OnNX", function(module, exports) {

let $5affab0be59320a6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5affab0be59320a6$var$load("itNgg").then(()=>parcelRequire('lX49y'));

});

parcelRegister("hnOZU", function(module, exports) {

let $ca7c24b5c627fc61$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ca7c24b5c627fc61$var$load("7kll5").then(()=>parcelRequire('aTo8h'));

});

parcelRegister("fgbrU", function(module, exports) {

let $b1c13b344fe8f05e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b1c13b344fe8f05e$var$load("gWJWo").then(()=>parcelRequire('lUvBC'));

});

parcelRegister("iT7rO", function(module, exports) {

let $dc0323feb0b530c6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dc0323feb0b530c6$var$load("jbyyZ").then(()=>parcelRequire('e64EK'));

});

parcelRegister("4YZ6d", function(module, exports) {

let $3a0c2911c64132c7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3a0c2911c64132c7$var$load("aqtvy").then(()=>parcelRequire('fyi6x'));

});

parcelRegister("lO34q", function(module, exports) {

let $fe00a62cf4bab2b2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fe00a62cf4bab2b2$var$load("36JAe").then(()=>parcelRequire('CBVOE'));

});

parcelRegister("2LAgN", function(module, exports) {

let $203c1b024b3123de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $203c1b024b3123de$var$load("d5XNJ").then(()=>parcelRequire('3Twqm'));

});

parcelRegister("lAEfc", function(module, exports) {

let $fb7c2d676e07258a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fb7c2d676e07258a$var$load("kIpJ3").then(()=>parcelRequire('1RXgW'));

});

parcelRegister("eVqNW", function(module, exports) {

let $addb2e644349483b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $addb2e644349483b$var$load("bWjOt").then(()=>parcelRequire('dWcMf'));

});

parcelRegister("ioF3u", function(module, exports) {

let $d64a5096f0087237$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d64a5096f0087237$var$load("cPWct").then(()=>parcelRequire('f79mI'));

});

parcelRegister("1EU5y", function(module, exports) {

let $135508e940418db0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $135508e940418db0$var$load("jggnq").then(()=>parcelRequire('hUTYd'));

});

parcelRegister("d50eo", function(module, exports) {

let $985bebde7d38a555$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $985bebde7d38a555$var$load("e0Ntg").then(()=>parcelRequire('9NblC'));

});

parcelRegister("5UW3g", function(module, exports) {

let $44ef368f47e69d4a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $44ef368f47e69d4a$var$load("2JgKr").then(()=>parcelRequire('aI5qS'));

});

parcelRegister("2qyIm", function(module, exports) {

let $1c48f00fc7ef291a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1c48f00fc7ef291a$var$load("acuHR").then(()=>parcelRequire('b16F1'));

});

parcelRegister("6UYsU", function(module, exports) {

let $5096e033dc8365c2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5096e033dc8365c2$var$load("3O4Ad").then(()=>parcelRequire('82VBy'));

});

parcelRegister("5Jp07", function(module, exports) {

let $42c48c5c1b7f84dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $42c48c5c1b7f84dd$var$load("game2").then(()=>parcelRequire('aCtQL'));

});

parcelRegister("hjwpd", function(module, exports) {

let $c9ad591ef5b7d118$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c9ad591ef5b7d118$var$load("eIQjF").then(()=>parcelRequire('5NZ8M'));

});

parcelRegister("1dgn9", function(module, exports) {

let $0e23b49435988386$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0e23b49435988386$var$load("38DCQ").then(()=>parcelRequire('9K6KX'));

});

parcelRegister("ajJkr", function(module, exports) {

let $782ed710d328cd82$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $782ed710d328cd82$var$load("9keOr").then(()=>parcelRequire('1BPk1'));

});

parcelRegister("gIgCg", function(module, exports) {

let $c2ada50c723b21b0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c2ada50c723b21b0$var$load("kVp0R").then(()=>parcelRequire('kfsBI'));

});

parcelRegister("lxn1t", function(module, exports) {

let $fade89e849f67fa0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fade89e849f67fa0$var$load("boO82").then(()=>parcelRequire('epPtX'));

});

parcelRegister("3ZONs", function(module, exports) {

let $2e8e78cad9bda857$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2e8e78cad9bda857$var$load("1oiW8").then(()=>parcelRequire('jrVd1'));

});

parcelRegister("eZukP", function(module, exports) {

let $ae9e4b10fc84cc8b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae9e4b10fc84cc8b$var$load("dWZoZ").then(()=>parcelRequire('4173K'));

});

parcelRegister("1Zm20", function(module, exports) {

let $172c93e5e4cdef21$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $172c93e5e4cdef21$var$load("d0hH7").then(()=>parcelRequire('98n0p'));

});

parcelRegister("fzP1A", function(module, exports) {

let $b571b44b5ef8dee5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b571b44b5ef8dee5$var$load("eQ1QI").then(()=>parcelRequire('9RLUJ'));

});

parcelRegister("5cVsx", function(module, exports) {

let $3caaa4f8f98199d7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3caaa4f8f98199d7$var$load("gUkiy").then(()=>parcelRequire('3CCJR'));

});

parcelRegister("jDEId", function(module, exports) {

let $e4c13d672521a11c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e4c13d672521a11c$var$load("fe1ax").then(()=>parcelRequire('fJvIy'));

});

parcelRegister("gxVgn", function(module, exports) {

let $c0bc25a91992ad9b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c0bc25a91992ad9b$var$load("13Qno").then(()=>parcelRequire('9wqlu'));

});

parcelRegister("8DLD7", function(module, exports) {
module.exports = JSON.parse("{\"jsm-gs.cases.spotlight.step1.body.non-final\":[{\"type\":0,\"value\":\"Streamline how your team documents findings and outcomes with a dedicated \"},{\"children\":[{\"type\":0,\"value\":\"Case notes\"}],\"type\":8,\"value\":\"strong\"},{\"type\":0,\"value\":\" section within work items.\"}],\"jsm-gs.cases.spotlight.step1.next.non-final\":[{\"type\":0,\"value\":\"Next\"}],\"jsm-gs.cases.spotlight.step1.step-count.non-final\":[{\"type\":0,\"value\":\"1 of 3\"}],\"jsm-gs.cases.spotlight.step1.title.non-final\":[{\"type\":0,\"value\":\"Better manage your case load\"}],\"jsm-gs.cases.spotlight.step2.back.non-final\":[{\"type\":0,\"value\":\"Back\"}],\"jsm-gs.cases.spotlight.step2.body.non-final\":[{\"type\":0,\"value\":\"To enable \"},{\"children\":[{\"type\":0,\"value\":\"Case notes\"}],\"type\":8,\"value\":\"strong\"},{\"type\":0,\"value\":\" on work items, simply create or assign existing request types to this work category.\"}],\"jsm-gs.cases.spotlight.step2.next.non-final\":[{\"type\":0,\"value\":\"Next\"}],\"jsm-gs.cases.spotlight.step2.step-count.non-final\":[{\"type\":0,\"value\":\"2 of 3\"}],\"jsm-gs.cases.spotlight.step2.title.non-final\":[{\"type\":0,\"value\":\"Create or assign existing types\"}],\"jsm-gs.cases.spotlight.step3.back.non-final\":[{\"type\":0,\"value\":\"Back\"}],\"jsm-gs.cases.spotlight.step3.body.non-final\":[{\"type\":0,\"value\":\"Lock down sensitive \"},{\"children\":[{\"type\":0,\"value\":\"Cases\"}],\"type\":8,\"value\":\"strong\"},{\"type\":0,\"value\":\" with work item security so only those with access can view case information.\"}],\"jsm-gs.cases.spotlight.step3.done.non-final\":[{\"type\":0,\"value\":\"Done\"}],\"jsm-gs.cases.spotlight.step3.step-count.non-final\":[{\"type\":0,\"value\":\"3 of 3\"}],\"jsm-gs.cases.spotlight.step3.title.non-final\":[{\"type\":0,\"value\":\"Restrict access to specific people\"}]}");

});

parcelRegister("5vdvc", function(module, exports) {

let $401a52436abd32a2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $401a52436abd32a2$var$load("hT3HO").then(()=>parcelRequire('i21D4'));

});

parcelRegister("qEMXn", function(module, exports) {

let $0502119811f58bda$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0502119811f58bda$var$load("4eots").then(()=>parcelRequire('lH8ux'));

});

parcelRegister("5jrVu", function(module, exports) {

let $3de463afbd9fb904$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3de463afbd9fb904$var$load("andjq").then(()=>parcelRequire('44a2R'));

});

parcelRegister("koJIg", function(module, exports) {

let $ed998232215323e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ed998232215323e8$var$load("bjEoV").then(()=>parcelRequire('gzr0l'));

});

parcelRegister("aw7Dc", function(module, exports) {

let $7a82cff64a0e5c1a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a82cff64a0e5c1a$var$load("gwDxW").then(()=>parcelRequire('d1aby'));

});

parcelRegister("jXjZI", function(module, exports) {

let $e873097f94176b03$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e873097f94176b03$var$load("cFsE9").then(()=>parcelRequire('blieT'));

});

parcelRegister("db8ly", function(module, exports) {

let $9982c6e81fca1709$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9982c6e81fca1709$var$load("6bfA4").then(()=>parcelRequire('2iAaN'));

});

parcelRegister("kTwQy", function(module, exports) {

let $f3626c612636750e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f3626c612636750e$var$load("3Pigm").then(()=>parcelRequire('2FEom'));

});

parcelRegister("7lkyB", function(module, exports) {

let $558a70ceca3b8018$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $558a70ceca3b8018$var$load("fgUfc").then(()=>parcelRequire('5hJ2d'));

});

parcelRegister("dCvJo", function(module, exports) {

let $9ea770176033af04$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9ea770176033af04$var$load("5Gh9S").then(()=>parcelRequire('kZQM9'));

});

parcelRegister("jTB0l", function(module, exports) {

let $e7bfdbaf84318676$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e7bfdbaf84318676$var$load("f0O62").then(()=>parcelRequire('3zXaW'));

});

parcelRegister("5S1zV", function(module, exports) {

let $44633851538e3ae4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $44633851538e3ae4$var$load("2pSWr").then(()=>parcelRequire('59BKS'));

});

parcelRegister("5TqnL", function(module, exports) {

let $44a68dc20b860f34$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $44a68dc20b860f34$var$load("5eXEK").then(()=>parcelRequire('iMsTX'));

});

parcelRegister("bvhrU", function(module, exports) {

let $86001ff9b0fc513b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $86001ff9b0fc513b$var$load("gDdfm").then(()=>parcelRequire('9xOUG'));

});

parcelRegister("58giV", function(module, exports) {

let $3bca58c816509f67$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3bca58c816509f67$var$load("gb6VF").then(()=>parcelRequire('jyuar'));

});

parcelRegister("6hkl8", function(module, exports) {

let $49241baf7eac8a6b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $49241baf7eac8a6b$var$load("7vT85").then(()=>parcelRequire('jueHI'));

});

parcelRegister("f8pos", function(module, exports) {

let $b04b4cfe633378fd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b04b4cfe633378fd$var$load("fxHSF").then(()=>parcelRequire('5DOfN'));

});

parcelRegister("ajGUp", function(module, exports) {

let $782cf683d166d9a8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $782cf683d166d9a8$var$load("6gApR").then(()=>parcelRequire('99uGZ'));

});

parcelRegister("ixanl", function(module, exports) {

let $d7e35b67aa5c169a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d7e35b67aa5c169a$var$load("fFmkS").then(()=>parcelRequire('e4s0f'));

});

parcelRegister("lAjmB", function(module, exports) {

let $fb6bfaf86350e35f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fb6bfaf86350e35f$var$load("h5FFt").then(()=>parcelRequire('9SpED'));

});

parcelRegister("jWwky", function(module, exports) {

let $e84c8347e621b410$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e84c8347e621b410$var$load("krFS6").then(()=>parcelRequire('5AB0A'));

});

parcelRegister("3qo0Q", function(module, exports) {

let $27e66d315d34a94d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $27e66d315d34a94d$var$load("aAhAA").then(()=>parcelRequire('6dgyz'));

});

parcelRegister("k3qFk", function(module, exports) {

let $e998c5b24c189ecc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e998c5b24c189ecc$var$load("gVbDR").then(()=>parcelRequire('dMqdD'));

});

parcelRegister("793El", function(module, exports) {

let $533c346e8fcba480$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $533c346e8fcba480$var$load("4oC4A").then(()=>parcelRequire('cXsib'));

});

parcelRegister("25ZVe", function(module, exports) {

let $186c14d6a4715cc0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $186c14d6a4715cc0$var$load("k4XXp").then(()=>parcelRequire('lqnQ4'));

});

parcelRegister("2bv7j", function(module, exports) {

let $1974bf0241177c0e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1974bf0241177c0e$var$load("51wgc").then(()=>parcelRequire('jRPVi'));

});

parcelRegister("520hK", function(module, exports) {

let $3a9d5c52663aec57$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3a9d5c52663aec57$var$load("5asEs").then(()=>parcelRequire('aJYAY'));

});

parcelRegister("fRJ7g", function(module, exports) {

let $b8cecd5f575073e9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b8cecd5f575073e9$var$load("dwJdU").then(()=>parcelRequire('46CwV'));

});

parcelRegister("1WZFn", function(module, exports) {

let $16bb0ae1dfaa6c36$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $16bb0ae1dfaa6c36$var$load("6WCjV").then(()=>parcelRequire('72NA2'));

});

parcelRegister("eYvVI", function(module, exports) {

let $ae6f6fe36a6af4d8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae6f6fe36a6af4d8$var$load("bMkZK").then(()=>parcelRequire('8ZkfH'));

});

parcelRegister("4aDKk", function(module, exports) {

let $3096ed5bba5ba149$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3096ed5bba5ba149$var$load("bCU4M").then(()=>parcelRequire('sf0Zg'));

});

parcelRegister("kIThW", function(module, exports) {

let $f162cdd7490fe375$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f162cdd7490fe375$var$load("7g9TA").then(()=>parcelRequire('8NzTu'));

});

parcelRegister("k618X", function(module, exports) {

let $ea1541408e13d6f9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ea1541408e13d6f9$var$load("ajQbp").then(()=>parcelRequire('2c1Xy'));

});

parcelRegister("bqSK2", function(module, exports) {

let $852c95ef8d3e41a1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $852c95ef8d3e41a1$var$load("cusCL").then(()=>parcelRequire('9ibN1'));

});

parcelRegister("aQHtk", function(module, exports) {
module.exports = JSON.parse("{\"post-office.cc-changeboarding-block-menu-primary-new.spotlight-button\":[{\"type\":0,\"value\":\"Done\"}],\"post-office.cc-changeboarding-block-menu-primary-new.spotlight-description\":[{\"type\":0,\"value\":\"Blocks of content can now be easily transformed, kept in sync, and saved as a template!\"}],\"post-office.cc-changeboarding-block-menu-primary-new.spotlight-header\":[{\"type\":0,\"value\":\"Transform, sync & save blocks\"}],\"post-office.cc-changeboarding-block-menu-primary-new.spotlight-image-alt\":[{\"type\":0,\"value\":\"Blocks feature illustration\"}],\"post-office.cc-changeboarding-block-menu-primary.spotlight-button\":[{\"type\":0,\"value\":\"Done\"}],\"post-office.cc-changeboarding-block-menu-primary.spotlight-description\":[{\"type\":0,\"value\":\"Blocks of content can now be easily transformed, kept in sync, and saved as a template!\"}],\"post-office.cc-changeboarding-block-menu-primary.spotlight-header\":[{\"type\":0,\"value\":\"Transform, sync & save blocks\"}],\"post-office.cc-changeboarding-block-menu-primary.spotlight-image-alt\":[{\"type\":0,\"value\":\"Blocks feature illustration\"}],\"post-office.cc-changeboarding-block-menu-templates.spotlight-button\":[{\"type\":0,\"value\":\"Done\"}],\"post-office.cc-changeboarding-block-menu-templates.spotlight-description\":[{\"type\":0,\"value\":\"Save any content as a block template for easy reuse across Confluence and Jira!\"}],\"post-office.cc-changeboarding-block-menu-templates.spotlight-header\":[{\"type\":0,\"value\":\"Save content with block templates\"}],\"post-office.cc-changeboarding-block-menu-templates.spotlight-image-alt\":[{\"type\":0,\"value\":\"Block templates feature illustration\"}],\"post-office.cc-changeboarding-block-menu-templates.spotlight-learn-more\":[{\"type\":0,\"value\":\"Learn more\"}],\"post-office.cc-changeboarding-block-menu-transform.spotlight-button\":[{\"type\":0,\"value\":\"Done\"}],\"post-office.cc-changeboarding-block-menu-transform.spotlight-description\":[{\"type\":0,\"value\":\"Easily change content blocks from one format to another!\"}],\"post-office.cc-changeboarding-block-menu-transform.spotlight-header-new\":[{\"type\":0,\"value\":\"Quickly change format\"}],\"post-office.cc-changeboarding-block-menu-transform.spotlight-image-alt-new\":[{\"type\":0,\"value\":\"Format feature illustration\"}],\"post-office.cc-changeboarding-block-menu-transform.spotlight-learn-more\":[{\"type\":0,\"value\":\"Learn more\"}],\"post-office.cc-changeboarding-synced-blocks.activation-spotlight-description\":[{\"type\":0,\"value\":\"You can reuse content in synced blocks in Confluence and Jira. Just copy and paste this synced block in a new location\"}],\"post-office.cc-changeboarding-synced-blocks.activation-spotlight-header\":[{\"type\":0,\"value\":\"Reuse this content\"}],\"post-office.cc-changeboarding-synced-blocks.activation-spotlight-image-alt\":[{\"type\":0,\"value\":\"Animation showing a synced block being copied from its source and pasted into another page as a linked reference\"}],\"post-office.cc-changeboarding-synced-blocks.spotlight-button\":[{\"type\":0,\"value\":\"Done\"}],\"post-office.cc-changeboarding-synced-blocks.spotlight-description\":[{\"type\":0,\"value\":\"Synced blocks maintain source of truth across Confluence & Jira. Insert, copy, and paste!\"}],\"post-office.cc-changeboarding-synced-blocks.spotlight-header\":[{\"type\":0,\"value\":\"Keep content in sync\"}],\"post-office.cc-changeboarding-synced-blocks.spotlight-image-alt\":[{\"type\":0,\"value\":\"Synced blocks feature illustration\"}],\"post-office.cc-changeboarding-synced-blocks.spotlight-learn-more\":[{\"type\":0,\"value\":\"Learn more\"}],\"post-office.cc-editor-table-cell-menu-changes.spotlight-button\":[{\"type\":0,\"value\":\"Got it\"}],\"post-office.cc-editor-table-cell-menu-changes.spotlight-description\":[{\"type\":0,\"value\":\"Controls to add or delete rows and columns have moved to their own menus. You can also align content vertically from the cell menu.\"}],\"post-office.cc-editor-table-cell-menu-changes.spotlight-header\":[{\"type\":0,\"value\":\"Simple table controls\"}],\"post-office.cc-editor-table-cell-menu-changes.spotlight-image-alt\":[{\"type\":0,\"value\":\"Table cell menu illustration\"}]}");

});

parcelRegister("fMSEy", function(module, exports) {

let $b7e5bbac1ce5b118$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b7e5bbac1ce5b118$var$load("l6Yi1").then(()=>parcelRequire('lY2D6'));

});

parcelRegister("3G9it", function(module, exports) {

let $2adc818b8bb4a1f8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2adc818b8bb4a1f8$var$load("3mfEV").then(()=>parcelRequire('hXZOC'));

});

parcelRegister("aM2FB", function(module, exports) {

let $7d80754deab0d1af$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7d80754deab0d1af$var$load("e9gHo").then(()=>parcelRequire('cJ22M'));

});

parcelRegister("bF4VV", function(module, exports) {

let $0230e48b0ed85efd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0230e48b0ed85efd$var$load("gq0Gj").then(()=>parcelRequire('3qU5n'));

});

parcelRegister("2SbnI", function(module, exports) {

let $21797406b4eeaebd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $21797406b4eeaebd$var$load("kFTBl").then(()=>parcelRequire('8WAx5'));

});

parcelRegister("hDNJd", function(module, exports) {

let $cd7ca733c441a7b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cd7ca733c441a7b1$var$load("aZxOH").then(()=>parcelRequire('57iPO'));

});

parcelRegister("3elgK", function(module, exports) {

let $25a32d7df13a4a60$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $25a32d7df13a4a60$var$load("bRS34").then(()=>parcelRequire('e9aXv'));

});

parcelRegister("iYqND", function(module, exports) {

let $dd029e7095315873$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dd029e7095315873$var$load("cTEMA").then(()=>parcelRequire('4YWqR'));

});

parcelRegister("dZkOi", function(module, exports) {

let $a2f11d557b1de0c4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a2f11d557b1de0c4$var$load("fG4dn").then(()=>parcelRequire('i8Ju0'));

});

parcelRegister("7Kl9V", function(module, exports) {

let $5a3d3e0c47abb400$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a3d3e0c47abb400$var$load("dBfAG").then(()=>parcelRequire('3LcuQ'));

});

parcelRegister("1jiqi", function(module, exports) {

let $0f45db3b62ea3a95$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0f45db3b62ea3a95$var$load("bhFWY").then(()=>parcelRequire('SZYPs'));

});

parcelRegister("kwgrL", function(module, exports) {

let $ef038dcf9842e149$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ef038dcf9842e149$var$load("5Ipsb").then(()=>parcelRequire('bEw7J'));

});

parcelRegister("9cjc7", function(module, exports) {

let $6b241faf2d0e51b9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b241faf2d0e51b9$var$load("9bycB").then(()=>parcelRequire('3U4X8'));

});

parcelRegister("eY6Xm", function(module, exports) {

let $ae5c10aecbfd6755$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae5c10aecbfd6755$var$load("8vXBw").then(()=>parcelRequire('eRnb4'));

});

parcelRegister("8b476", function(module, exports) {

let $5f428aa95f000fca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5f428aa95f000fca$var$load("12bd1").then(()=>parcelRequire('jjtG3'));

});

parcelRegister("6AL9N", function(module, exports) {

let $4ccaaf462db8034c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ccaaf462db8034c$var$load("2dUzq").then(()=>parcelRequire('gnnqb'));

});

parcelRegister("TQ212", function(module, exports) {

let $0a7d7f8b1e97d343$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0a7d7f8b1e97d343$var$load("dDQyn").then(()=>parcelRequire('7aj4H'));

});

parcelRegister("8gBYS", function(module, exports) {

let $604d4795dc58784d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $604d4795dc58784d$var$load("klG72").then(()=>parcelRequire('kJV9w'));

});

parcelRegister("h1EBA", function(module, exports) {

let $c6520700dca973ff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c6520700dca973ff$var$load("bB5zS").then(()=>parcelRequire('4E0mt'));

});

parcelRegister("2rKwb", function(module, exports) {

let $1c822fe7afb10fd8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1c822fe7afb10fd8$var$load("haKnr").then(()=>parcelRequire('eWpWZ'));

});

parcelRegister("bs9HJ", function(module, exports) {

let $8569d650877126a0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8569d650877126a0$var$load("e6rmp").then(()=>parcelRequire('ba2NN'));

});

parcelRegister("SxP1K", function(module, exports) {

let $0a3f479be6115b53$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0a3f479be6115b53$var$load("dykgD").then(()=>parcelRequire('58PXh'));

});

parcelRegister("848Jl", function(module, exports) {

let $5df57822bb0a6a32$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5df57822bb0a6a32$var$load("2sjPq").then(()=>parcelRequire('icssZ'));

});

parcelRegister("d6B6Y", function(module, exports) {

let $98a89f7dc1957cf6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $98a89f7dc1957cf6$var$load("8Tg6a").then(()=>parcelRequire('2ldir'));

});

parcelRegister("aHbdn", function(module, exports) {

let $7c969e905e5e09ca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7c969e905e5e09ca$var$load("aue9j").then(()=>parcelRequire('bXqxG'));

});

parcelRegister("lqWIu", function(module, exports) {

let $f9a99297c703882d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f9a99297c703882d$var$load("iRiuC").then(()=>parcelRequire('2GzuM'));

});

parcelRegister("d7OQl", function(module, exports) {

let $98e35e3d626de6b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $98e35e3d626de6b3$var$load("dZRz2").then(()=>parcelRequire('9AUmY'));

});

parcelRegister("8eV38", function(module, exports) {

let $5ffbe25dc39370c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5ffbe25dc39370c3$var$load("9TTXb").then(()=>parcelRequire('f8EwP'));

});

parcelRegister("huJQM", function(module, exports) {

let $cbc8cdeb7b003453$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cbc8cdeb7b003453$var$load("6OD5x").then(()=>parcelRequire('lnAbD'));

});

parcelRegister("d65j7", function(module, exports) {

let $988ff3d1ae08d737$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $988ff3d1ae08d737$var$load("30KfA").then(()=>parcelRequire('kywzF'));

});

parcelRegister("7zcwB", function(module, exports) {

let $58258476f3bbc90a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $58258476f3bbc90a$var$load("iAyPJ").then(()=>parcelRequire('1ilAf'));

});

parcelRegister("e2I4y", function(module, exports) {

let $a3937074f9ca61c6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a3937074f9ca61c6$var$load("hgjk6").then(()=>parcelRequire('hCiFJ'));

});

parcelRegister("87swa", function(module, exports) {

let $5e95193d064a08af$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5e95193d064a08af$var$load("92bBQ").then(()=>parcelRequire('efaNz'));

});

parcelRegister("bE3B0", function(module, exports) {

let $87a638383020f3a2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $87a638383020f3a2$var$load("838CA").then(()=>parcelRequire('iwO9t'));

});

parcelRegister("gHvGn", function(module, exports) {
module.exports = JSON.parse('{"ccommerce.commerce-payment-method-manage-ccp.email.subject.ach-direct-debit-dispute":[{"type":0,"value":"Action required: ACH Direct debit payment failed"}],"commerce-access-invalid-payment-ccp.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"commerce-access-invalid-payment-hams.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.get-in-touch":[{"type":0,"value":"To understand more on why we couldn\'t generate your invoice, please "},{"type":1,"value":"getInTouchLink"},{"type":0,"value":" with us."}],"commerce-auto-cancellation-uninvoiceable-ccp.email.get-in-touch-link":[{"type":0,"value":"get in touch"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.no-invoice-generation":[{"type":0,"value":"We couldn\'t generate an invoice for your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") as we don\'t have\\n\\t\\t\\t\\tyour complete billing information. As a result, your subscription has been canceled."}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-1":[{"type":0,"value":"Once you\u2019ve updated the billing details, reactivate your subscription by going to "}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-2":[{"type":0,"value":"Subscriptions > Inactive "}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-3":[{"type":0,"value":"tab"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-4":[{"type":0,"value":" > Reactivate"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-5":[{"type":0,"value":". If you reactivate your subscription within 60 days of cancellation, your data and preferences will remain the same."}],"commerce-auto-cancellation-uninvoiceable-ccp.email.title":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.update-billing-details-button":[{"type":0,"value":"Update billing details"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.update-billing-details-partner-button":[{"type":0,"value":"Update billing details"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.wrong-details":[{"type":0,"value":"It could be because you\u2019ve entered the wrong details, or that the information you\u2019ve provided us is\\n\\t\\t\\t\\tincomplete. Don\'t worry, you can reactivate your subscription after updating your billing information."}],"commerce-credit-account-deactivation-ccp.clear-unpaid-invoices":[{"type":0,"value":"Clear any unpaid invoices associated with your account."}],"commerce-credit-account-deactivation-ccp.message-template.deactivation.help-message":[{"type":0,"value":"We understand that managing payments can sometimes be challenging, and we\'re here to help."}],"commerce-credit-account-deactivation-ccp.message-template.deactivation.learn-reasons":[{"type":0,"value":"Learn about possible reasons"}],"commerce-credit-account-deactivation-ccp.message-template.deactivation.message":[{"type":0,"value":"You can no longer use Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms to place your orders as your billing account\u2019s eligibility has been suspended. "},{"type":1,"value":"learnReason"}],"commerce-credit-account-deactivation-ccp.message-template.deactivation.title":[{"type":0,"value":"You\u2019re no longer eligible for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" terms"}],"commerce-credit-account-deactivation-ccp.reach-out":[{"type":0,"value":"Reach out to us so we can review your eligibility."}],"commerce-credit-account-deactivation-ccp.reconsider-eligibility":[{"type":0,"value":"If you\u2019d like us to reconsider your eligibility for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms, we suggest you to:"}],"commerce-credit-account-deactivation-ccp.view-unpaid-invoices-link":[{"type":0,"value":"View unpaid invoices"}],"commerce-credit-account-limit-increase-request-rejection-ccp.message-template.couldn\'t-approve-request":[{"type":0,"value":"Unfortunately, we couldn\u2019t approve your request because you\u2019ve reached the maximum credit limit that we can offer at this time. You can check back in a few months to see if your eligibility has changed."}],"commerce-credit-account-limit-increase-request-rejection-ccp.message-template.email.subject":[{"type":0,"value":"Unable to offer a higher Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit"}],"commerce-credit-account-limit-increase-request-rejection-ccp.message-template.rejected.title":[{"type":0,"value":"We\u2019re unable to offer you a higher Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit"}],"commerce-credit-account-limit-increase-request-rejection-ccp.message-template.thank-you.submitting":[{"type":0,"value":"Thank you for submitting your application for increasing your Atlassian Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit."}],"commerce-credit-account-limit-increase-request-rejection-ccp.move-forward":[{"type":0,"value":"You can still move forward with your purchase. We suggest using a credit card to pay for your order. Reach out to us if you need further help in placing your order."}],"commerce-credit-account-reactivation-ccp.message-template.good-news.restored.billing.account":[{"type":0,"value":"Good news! We\u2019ve restored your billing account\u2019s eligibility for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms. Here are the details:"}],"commerce-credit-account-reactivation-ccp.message-template.restored.title":[{"type":0,"value":"Your eligibility has been restored"}],"commerce-invoice-drawdown-ccp.message-template.confirm":[{"type":0,"value":"This email confirms that we\'ve generated your invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":". The invoice is attached as a PDF for your records."}],"commerce-invoice-drawdown-ccp.message-template.covered-by-wallet":[{"type":0,"value":"This invoice is covered by the funds available in your wallet."}],"commerce-invoice-drawdown-ccp.message-template.title":[{"type":0,"value":"Your invoice has been generated"}],"commerce-invoice-generated-ccp-g.message-template.confirm":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\u2019ve generated your invoice "},{"type":1,"value":"businessKey"},{"type":0,"value":". "}],"commerce-invoice-generated-ccp-g.message-template.partner.confirm":[{"type":0,"value":"This email is to confirm that we\u2019ve generated the following invoice. The payment due date is "},{"type":1,"value":"dueDate"}],"commerce-invoice-generated-ccp-g.message-template.partner.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce-invoice-generated-ccp-g.message-template.title":[{"type":0,"value":"Your invoice has been generated"}],"commerce-invoice-generated-ccp.message-template.confirm":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\u2019ve generated your invoice "},{"type":1,"value":"businessKey"},{"type":0,"value":". "}],"commerce-invoice-generated-ccp.message-template.partner.confirm":[{"type":0,"value":"This email is to confirm that we\u2019ve generated the following invoice. The payment due date is "},{"type":1,"value":"dueDate"}],"commerce-invoice-generated-ccp.message-template.partner.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce-invoice-generated-ccp.message-template.title":[{"type":0,"value":"Your invoice has been generated"}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.dc-message":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\u2019ve generated your invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":". The\\n\\t\\t\\t\\tinvoice is attached as a PDF for your records."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.invoice-attached":[{"type":0,"value":"The attached invoice is to be paid before the due date mentioned in the invoice."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.manage-invoices":[{"type":0,"value":"To view or manage your invoices and subscription, go to your site\'s Administration."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.partner-message":[{"type":0,"value":"This email is to confirm that we\u2019ve generated the following invoice. The payment due date is "},{"type":1,"value":"dueDate"},{"type":0,"value":"."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.partner.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.title":[{"type":0,"value":"Your invoice has been generated"}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.view-subscription":[{"type":0,"value":"View subscription"}],"commerce-invoice-terms-payment-pending-ccp.message-template.dc-message":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\u2019ve generated your invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":". The\\n\\t\\t\\t\\tinvoice is attached as a PDF for your records."}],"commerce-invoice-terms-payment-pending-ccp.message-template.invoice-attached":[{"type":0,"value":"The attached invoice is to be paid before the due date mentioned in the invoice."}],"commerce-invoice-terms-payment-pending-ccp.message-template.manage-invoices":[{"type":0,"value":"To view or manage your invoices and subscription, go to your site\'s Administration."}],"commerce-invoice-terms-payment-pending-ccp.message-template.partner-message":[{"type":0,"value":"This email is to confirm that we\u2019ve generated the following invoice. The payment due date is "},{"type":1,"value":"dueDate"},{"type":0,"value":"."}],"commerce-invoice-terms-payment-pending-ccp.message-template.partner.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce-invoice-terms-payment-pending-ccp.message-template.title":[{"type":0,"value":"Your invoice has been generated"}],"commerce-invoice-terms-payment-pending-ccp.message-template.view-subscription":[{"type":0,"value":"View subscription"}],"commerce-invoice-updated-ccp-g.message-template.invoice-attached":[{"type":0,"value":"For your records, the invoice is attached as a PDF."}],"commerce-invoice-updated-ccp-g.message-template.title":[{"type":0,"value":"Your invoice has been updated"}],"commerce-invoice-updated-ccp-g.message-template.updated":[{"type":0,"value":"This is a follow up email about the credit note generated against your subscription cancellation\\n                    request. To process this request, we\'ve updated your existing invoice with the latest changes."}],"commerce-invoice-updated-ccp-g.message-template.updated_partner":[{"type":0,"value":"This is a follow up email about the credit note generated against a subscription cancellation\\n\\t\\t\\t\\trequest. To process this request, we\'ve updated your existing invoice with the latest changes."}],"commerce-invoice-updated-ccp-g.message-template.view-invoice":[{"type":0,"value":"View Invoice"}],"commerce-invoice-updated-ccp.message-template.invoice-attached":[{"type":0,"value":"For your records, the invoice is attached as a PDF."}],"commerce-invoice-updated-ccp.message-template.title":[{"type":0,"value":"Your invoice has been updated"}],"commerce-invoice-updated-ccp.message-template.updated":[{"type":0,"value":"This is a follow up email about the credit note generated against your subscription cancellation\\n                    request. To process this request, we\'ve updated your existing invoice with the latest changes."}],"commerce-invoice-updated-ccp.message-template.updated_partner":[{"type":0,"value":"This is a follow up email about the credit note generated against a subscription cancellation\\n\\t\\t\\t\\trequest. To process this request, we\'ve updated your existing invoice with the latest changes."}],"commerce-invoice-updated-ccp.message-template.view-invoice":[{"type":0,"value":"View Invoice"}],"commerce-marketing-multiple-product-upgrade-ccp-multiple.message.entity.link.label":[{"type":0,"value":"Atlassian Administration"}],"commerce-marketing-multiple-product-upgrade-ccp-multiple.product.purchased.message.body.multiple":[{"type":0,"value":"Get a free trial of "},{"type":1,"value":"firstEntitlementProductName"},{"type":0,"value":" & "},{"type":1,"value":"secondEntitlementProductName"},{"type":0,"value":" "},{"type":1,"value":"firstEntitlementOfferingName"},{"type":0,"value":" with your "},{"type":1,"value":"purchasedEntitlementProductName"},{"type":0,"value":" purchase."}],"commerce-marketing-multiple-product-upgrade-ccp-multiple.product.purchased.message.title.different.trial.lengths.multiple":[{"type":0,"value":"Try "},{"type":1,"value":"firstEntitlementProductName"},{"type":0,"value":" & "},{"type":1,"value":"secondEntitlementProductName"},{"type":0,"value":" "},{"type":1,"value":"firstEntitlementOfferingName"},{"type":0,"value":" free"}],"commerce-marketing-multiple-product-upgrade-ccp-multiple.product.purchased.message.title.multiple":[{"type":0,"value":"Try "},{"type":1,"value":"firstEntitlementProductName"},{"type":0,"value":" & "},{"type":1,"value":"secondEntitlementProductName"},{"type":0,"value":" "},{"type":1,"value":"firstEntitlementOfferingName"},{"type":0,"value":" free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"firstEntitlementTrialLength"}],"commerce-marketing-multiple-product-upgrade-ccp-single.message.entity.link.label":[{"type":0,"value":"Atlassian Administration"}],"commerce-marketing-multiple-product-upgrade-ccp-single.product.purchased.message.title.single":[{"type":0,"value":"Try "},{"type":1,"value":"firstEntitlementProductName"}],"commerce-marketing-multiple-product-upgrade-ccp-single.product.purchased.try.confluence.message.body.single":[{"type":0,"value":"Tired of hunting for the right doc? Build a single source of truth for your team\'s info with Confluence "},{"type":1,"value":"firstEntitlementOfferingName"},{"type":0,"value":". Free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"firstEntitlementTrialLength"},{"type":0,"value":"."}],"commerce-marketing-multiple-product-upgrade-ccp-single.product.purchased.try.jira.message.body.single":[{"type":0,"value":"With Jira, your team can move fast, stay aligned, and build better - together. Try the "},{"type":1,"value":"firstEntitlementOfferingName"},{"type":0,"value":" plan free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"firstEntitlementTrialLength"},{"type":0,"value":"."}],"commerce-marketing-multiple-product-upgrade-ccp-single.product.purchased.try.jpd.message.body.single":[{"type":0,"value":"Say goodbye to messy backlogs. Keep your brilliant ideas in one place with Jira Product Discovery "},{"type":1,"value":"firstEntitlementOfferingName"},{"type":0,"value":". Free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"firstEntitlementTrialLength"},{"type":0,"value":"."}],"commerce-marketing-multiple-product-upgrade-ccp-single.product.purchased.try.jsm.message.body.single":[{"type":0,"value":"Bring developers, IT, and ops on the same tool and make work visible across teams with the "},{"type":1,"value":"firstEntitlementOfferingName"},{"type":0,"value":" plan. Free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"firstEntitlementTrialLength"},{"type":0,"value":"."}],"commerce-marketing-multiple-product-upgrade-ccp.subtext":[{"type":0,"value":"Atlassian Administration"}],"commerce-on-account-approval-partner.email.attached-instructions":[{"type":0,"value":"We\'ve attached instructions outlining how to read your statement."}],"commerce-on-account-approval-partner.email.good-news":[{"type":0,"value":"Good news! We\u2019ve approved your application for Pay on account with terms of Net-\\n\\t\\t\\t\\t"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" days from statement date."}],"commerce-on-account-approval-partner.email.list.billing-account":[{"type":0,"value":"Billing account: "},{"type":1,"value":"transactionAccountNum"}],"commerce-on-account-approval-partner.email.list.payment-method":[{"type":0,"value":"Payment method: Pay on account"}],"commerce-on-account-approval-partner.email.list.payment-terms":[{"type":0,"value":"Payment terms: Net-"},{"type":1,"value":"netTermsDuration"}],"commerce-on-account-approval-partner.email.payment-option-details":[{"type":0,"value":"This payment option allows you to buy your Atlassian products now, and pay within\\n\\t\\t\\t\\t"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" days from the statement date"}],"commerce-on-account-approval-partner.email.statement-info":[{"type":0,"value":"As Pay on account Partner, you will now receive a statement twice a month (on the 1st and 16th) covering\\n\\t\\t\\t\\tinvoices for the periods 16th to last day and 1st to 15th respectively."}],"commerce-on-account-approval-partner.email.subject":[{"type":0,"value":"Your Pay on account request is approved"}],"commerce-on-account-approval-partner.email.title":[{"type":0,"value":"Your Pay on account request has been approved"}],"commerce-on-account-deactivation-partner-ccp.email.accountsreceivable":[{"type":0,"value":"accountsreceivable@atlassian.com"}],"commerce-on-account-deactivation-partner-ccp.email.apply-again":[{"type":0,"value":"You may apply again for Pay on account option after 6 months. Don\u2019t worry, you can still place new orders using a credit card. "}],"commerce-on-account-deactivation-partner-ccp.email.contact-us":[{"type":0,"value":"Should you have questions or wish to discuss ways to reactivate your pay on account option, please contact us at "},{"type":1,"value":"accountsReceivableEmail"}],"commerce-on-account-deactivation-partner-ccp.email.list.billing-account":[{"type":0,"value":"Billing account: "},{"type":1,"value":"transactionAccountNum"}],"commerce-on-account-deactivation-partner-ccp.email.list.payment-method":[{"type":0,"value":"Payment method: Pay on account"}],"commerce-on-account-deactivation-partner-ccp.email.on-account-being-deactivated":[{"type":0,"value":"Your Pay on account option with Atlassian is being deactivated effective immediately, due to overdue balances and failure to meet the agreed payment terms. "}],"commerce-on-account-deactivation-partner-ccp.email.reach-us":[{"type":0,"value":"You can reach out to us if you need further help in placing your order."}],"commerce-on-account-deactivation-partner-ccp.email.subject":[{"type":0,"value":"Pay on account deactivation notice"}],"commerce-on-account-deactivation-partner-ccp.email.title":[{"type":0,"value":"Pay on account is deactivated"}],"commerce-on-account-rejection-partner-ccp.email.accountsreceivable":[{"type":0,"value":"accountsreceivable@atlassian.com"}],"commerce-on-account-rejection-partner-ccp.email.apply-again":[{"type":0,"value":"You can resubmit your application after 6 months to be considered again.  "}],"commerce-on-account-rejection-partner-ccp.email.contact-us":[{"type":0,"value":"You can still go ahead with your purchase. We suggest using a credit card to pay for your order. If you still need help placing an order contact us at  "},{"type":1,"value":"accountsReceivableEmail"}],"commerce-on-account-rejection-partner-ccp.email.list.billing-account":[{"type":0,"value":"Billing account: "},{"type":1,"value":"transactionAccountNum"}],"commerce-on-account-rejection-partner-ccp.email.list.payment-method":[{"type":0,"value":"Payment method: Pay on account"}],"commerce-on-account-rejection-partner-ccp.email.on-account-application-rejected":[{"type":0,"value":"Thank you for submitting your application for Pay on account. Unfortunately, we couldn\u2019t approve your application because you didn\u2019t meet our credit check requirements. "}],"commerce-on-account-rejection-partner-ccp.email.sales-op-support.no-translate":[{"type":0,"value":"sales-ops-support@atlassian.com"}],"commerce-on-account-rejection-partner-ccp.email.subject":[{"type":0,"value":"Pay on account application rejection notice"}],"commerce-on-account-rejection-partner-ccp.email.title":[{"type":0,"value":"We\u2019re unable to approve your Pay on account request"}],"commerce-payment-failure-ccp.email.trial.cc.org.4more.expiration.submit-request.faq":[{"type":0,"value":"FAQ"}],"commerce-payment-failure-hams.email.not-trial.without-cc.add-payment-details":[{"type":0,"value":"We noticed you haven\'t added payment details for "},{"type":1,"value":"allProductListString"},{"type":0,"value":". Add payment details today so your team can keep working without interruption."}],"commerce-payment-failure-hams.email.not-trial.without-cc.cloud.4more.not-interested":[{"type":0,"value":"If you\'re no longer interested, you can "},{"type":1,"value":"linkToAdmin"},{"type":0,"value":" at any time."}],"commerce-payment-failure-hams.email.not-trial.without-cc.cloud.4more.not-interested.update-subscription":[{"type":0,"value":"update your subscription"}],"commerce-payment-failure-hams.email.not-trial.without-cc.not-cloud.4more.not-interested":[{"type":0,"value":"If you\'re no longer interested, you can "},{"type":1,"value":"linkToAdmin"},{"type":0,"value":" at any time."}],"commerce-payment-failure-hams.email.not-trial.without-cc.not-cloud.4more.not-interested.update-subscription":[{"type":0,"value":"update your subscription"}],"commerce-payment-failure-hams.email.subject":[{"type":1,"value":"subject"}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.additional-actions":[{"type":0,"value":"Or see "},{"type":1,"value":"additionalActionsLink"},{"type":0,"value":" you can take if you\u2019re unable to make payments."}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.check-details":[{"type":0,"value":"If your details look correct, please try a different payment method or contact your bank. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.not-processed":[{"type":0,"value":"We\'re unable to process your payment for for Bitbucket ("},{"type":1,"value":"bbAccountName"},{"type":0,"value":") due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.submit-request":[{"type":0,"value":"If you need to speak to one of our team members about your situation, please "},{"type":1,"value":"submitRequestLink"},{"type":0,"value":" to the Atlassian Support Team."}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.submit-request.contact-us":[{"type":0,"value":"submit a request"}],"commerce-payment-failure-hams.email.trial.cc.check-details":[{"type":0,"value":"If your details look correct, please try a different payment method or alternatively contact your bank.Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.additional-actions":[{"type":0,"value":"Or see "},{"type":1,"value":"additionalActionsLink"},{"type":0,"value":" you can take if you\u2019re unable to make payments."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.check-details":[{"type":0,"value":"If your details look correct, please try a different payment method or contact your bank. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.not-processed":[{"type":0,"value":"We\'re unable to process your payment for Atlassian Cloud "},{"type":1,"value":"linkToDomain"},{"type":0,"value":" due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.not-processed.part-1":[{"type":0,"value":"We\'re unable to process your payment for the following products on "},{"type":1,"value":"linkToDomain"},{"type":0,"value":":"}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.not-processed.part-2":[{"type":0,"value":"This is due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.submit-request":[{"type":0,"value":"If you need to speak to one of our team members about your situation, please "},{"type":1,"value":"submitRequestLink"},{"type":0,"value":" to the Atlassian Support Team."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.submit-request.contact-us":[{"type":0,"value":"submit a request"}],"commerce-payment-failure-hams.email.trial.cc.not-processed":[{"type":0,"value":"We couldn\'t process payment for "},{"type":1,"value":"allProductListString"},{"type":0,"value":" due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.additional-actions":[{"type":0,"value":"If you\u2019re unable to make payments or you need to speak to one of our team members about your situation, please "},{"type":1,"value":"submitRequestLink"},{"type":0,"value":" to the Atlassian Support Team."}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.check-details":[{"type":0,"value":"If your details look correct, please try a different payment method or contact your bank. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.check-details.submit":[{"type":0,"value":"submit a request"}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.not-processed":[{"type":0,"value":"We\'re unable to process your payment for "},{"type":1,"value":"orgProductListString"},{"type":0,"value":" due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.submit-request":[{"type":0,"value":"For more information about what happens when you\u2019re unsubscribed from Atlassian Access, "},{"type":1,"value":"submitRequestLink"}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.submit-request.faq":[{"type":0,"value":"see our FAQ"}],"commerce-payment-failure-hams.email.trial.without-cc.2-4.expiration.learn-more":[{"type":0,"value":"Learn more about our products and how teams use them to do great work at "},{"type":1,"value":"supportLink"},{"type":0,"value":"."}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.2-4.expiration.part-1":[{"type":0,"value":"It\u2019s okay, we all get busy! Your trial for the following products on "},{"type":1,"value":"linkToDomain"},{"type":0,"value":" has ended"}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.2-4.expiration.part-2":[{"type":0,"value":"Your trial may have ended, but you can still add your payment details and keep the momentum going."}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.4more.expiration.expiration.part-1":[{"type":0,"value":"Your Standard plan trial for the following products on "},{"type":1,"value":"linkToDomain"},{"type":0,"value":" has ended:"}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.4more.expiration.expiration.part-2":[{"type":0,"value":"But it\u2019s not too late! You can still add payment details and keep the work you\u2019ve done so far."}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.4more.expiration.not-interested":[{"type":0,"value":"If you\'re no longer interested, you can "},{"type":1,"value":"linkToAdmin"},{"type":0,"value":" at any time."}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.4more.expiration.not-interested.cancel-subscription":[{"type":0,"value":"cancel your subscription"}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.less2.expiration.part-1":[{"type":0,"value":"Your trial for the following products on "},{"type":1,"value":"linkToDomain"},{"type":0,"value":" has ended:"}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.less2.expiration.part-2":[{"type":0,"value":"Your trial may have ended, but this could just be the beginning! Add payment details to keep working\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\twith your dream team."}],"commerce-payment-failure-hams.email.trial.without-cc.less2.expiration.learn-more":[{"type":0,"value":"Learn more about our products and how teams use them to do great work at "},{"type":1,"value":"supportLink"},{"type":0,"value":"."}],"commerce-payment-failure-hams.email.trial.without-cc.less2.expiration.learn-more.support":[{"type":0,"value":"support.atlassian.com"}],"commerce-payment-failure-hams.email.trial.without-cc.org.2-4.expiration":[{"type":0,"value":"It\'s okay, we all get busy! Your trial of "},{"type":1,"value":"orgProductListString"},{"type":0,"value":" has ended, but you can still add payment details and keep the momentum going."}],"commerce-payment-failure-hams.email.trial.without-cc.org.4more.expiration.expiration":[{"type":0,"value":"It\'s not too late! Your trial of "},{"type":1,"value":"orgProductListString"},{"type":0,"value":" has ended, but you can still add payment\\n\\t\\t\\t\\t\\t\\t\\t\\t\\tdetails and keep the work you\'ve done so far."}],"commerce-payment-failure-hams.email.trial.without-cc.org.less2.expiration":[{"type":0,"value":"Your trial of "},{"type":1,"value":"orgProductListString"},{"type":0,"value":" has ended, but this could just be the beginning. Add payment details to keep working with your dream team"}],"commerce-payment-failure-hams.email.trial.without-cc.without-cc.org.4more.expiration.not-interested":[{"type":0,"value":"If you\'re no longer interested, you can unsubscribe at any time within the Manage Subscriptions area\\n\\t\\t\\t\\t\\t\\t\\t\\t\\tof your organization administration."}],"commerce-payment-failure-hams.email.update-payment-details":[{"type":0,"value":"Update Payment Detail"}],"commerce-payment-failure-trials.add-payment":[{"type":0,"value":"Add your payment details today to ensure continuous access to the product and prevent any potential loss of data and security configurations."}],"commerce-payment-failure-trials.add-payment-without-access":[{"type":0,"value":"Add your payment details today to ensure continuous access to the product and prevent any potential loss of data."}],"commerce-payment-failure-trials.billing-cycle-label.no-translate":[{"type":0,"value":" | "},{"type":1,"value":"billingCycle"}],"commerce-payment-failure-trials.billing-cycle-text-label.no-translate":[{"type":0,"value":"| "},{"type":1,"value":"billingCycle"}],"commerce-payment-failure-trials.card-details":[{"type":0,"value":"Card: "},{"type":1,"value":"cardBrand"},{"type":0,"value":" ending in "},{"type":1,"value":"lastFourDigits"}],"commerce-payment-failure-trials.contact-your-bank":[{"type":0,"value":"Contact your bank if you need more information about the issue.\\n                        Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-trials.contact_us":[{"type":1,"value":"contactUs"},{"type":0,"value":" to talk about your situation, or "},{"type":1,"value":"downGradeToFreePlan"},{"type":0,"value":". We suggest you export your data before your subscription gets canceled. For more information, see our "},{"type":1,"value":"dataStorageFAQs"},{"type":0,"value":"."}],"commerce-payment-failure-trials.contact_us_access":[{"type":1,"value":"contactUs"},{"type":0,"value":" to talk about your situation. We suggest you export your data before your subscription gets canceled. For more information, see our "},{"type":1,"value":"dataStorageFAQs"},{"type":0,"value":"."}],"commerce-payment-failure-trials.contact_us_access.contact_us_link":[{"type":0,"value":"Contact us"}],"commerce-payment-failure-trials.contact_us_access.data_storage_link":[{"type":0,"value":"Data Storage FAQs"}],"commerce-payment-failure-trials.contact_us_access.downgrade_link":[{"type":0,"value":"downgrade to a free plan"}],"commerce-payment-failure-trials.couldnt-charge-card":[{"type":0,"value":"We\'re reaching out as we couldn\'t charge your card for invoice "},{"type":1,"value":"invoiceNumber"}],"commerce-payment-failure-trials.couldnt-charge-paypal":[{"type":0,"value":"We couldn\'t charge your PayPal account for the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" because there was a problem with your account settings or the payment method selected from your PayPal wallet."}],"commerce-payment-failure-trials.ent-org-name-with-space-label.no-translate":[{"type":1,"value":"separator"},{"type":0,"value":" "},{"type":1,"value":"entOrgName"},{"type":0,"value":" "}],"commerce-payment-failure-trials.entitlement-number-label.no-translate":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce-payment-failure-trials.entitlement-number-text.no-translate":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce-payment-failure-trials.has_payment_method.add-payment-caption":[{"type":0,"value":"Add payment details to continue subscription"}],"commerce-payment-failure-trials.has_payment_method.caption":[{"type":0,"value":"Action required: Your payment was declined"}],"commerce-payment-failure-trials.has_payment_method.could_not_process_payment_for_following":[{"type":0,"value":"We couldn\'t process payment, based on the payment information we have for this account."}],"commerce-payment-failure-trials.has_payment_method.has_company_name.could_not_process_payment_for_following":[{"type":0,"value":"We couldn\'t process payment for "},{"type":1,"value":"companyName"},{"type":0,"value":", based on the payment information we have for this account."}],"commerce-payment-failure-trials.has_payment_method.no_retries.partners.caption":[{"type":0,"value":"Action required: Update payment details by "},{"type":1,"value":"dueDate"}],"commerce-payment-failure-trials.has_payment_method.partners.payment-declined-title.has-next-retry.with-companyname":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required: Payment declined"}],"commerce-payment-failure-trials.has_payment_method.partners.payment-declined-title.has-next-retry.without-companyName":[{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required: Payment declined"}],"commerce-payment-failure-trials.has_payment_method.partners.payment-declined-title.no-retries.with-companyname":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required to keep subscription"}],"commerce-payment-failure-trials.has_payment_method.partners.payment-declined-title.no-retries.without-companyName":[{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required to keep subscription"}],"commerce-payment-failure-trials.has_payment_method.payment-declined-title":[{"type":0,"value":"Action required: Payment declined for #"},{"type":1,"value":"invoiceNumber"}],"commerce-payment-failure-trials.has_payment_method.update-credit-card--not-access":[{"type":0,"value":"Update your credit card details, or add a different credit card. For monthly subscriptions, we don\u2019t accept bank transfers."}],"commerce-payment-failure-trials.has_payment_method.update-credit-card--not-access-contact-bank":[{"type":0,"value":"Contact your bank if you need more information about the issue. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-trials.has_payment_method.update-credit-card-access-annual":[{"type":0,"value":"Update your payment details or add a different payment method to ensure continuous access to the product and prevent any potential loss of data and security configurations."}],"commerce-payment-failure-trials.has_payment_method.update-credit-card-access-annual-contact-bank":[{"type":0,"value":"Contact your bank if you need more information about the issue. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-trials.has_payment_method.update-credit-card-access-annual-monthly-subscriptions":[{"type":0,"value":"For monthly subscriptions, we don\u2019t accept bank transfers."}],"commerce-payment-failure-trials.has_payment_method.update-payment-caption":[{"type":0,"value":"Update payment details to continue subscription"}],"commerce-payment-failure-trials.has_payment_method.update-paypal":[{"type":0,"value":"Log in to your PayPal account and go to your automatic payment settings. Select a different payment method for your Atlassian payment. You should also check that your account isn\'t restricted and allows international payments."}],"commerce-payment-failure-trials.has_payment_method.we_could_not_process":[{"type":0,"value":"We couldn\'t process payment for the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":", based on the payment information we have for this account."}],"commerce-payment-failure-trials.invoice-number":[{"type":1,"value":"element"},{"type":0,"value":" "},{"type":1,"value":"invoiceNumber"}],"commerce-payment-failure-trials.invoice-number-label":[{"type":0,"value":"Invoice Number:"}],"commerce-payment-failure-trials.invoice_pdf_attachment":[{"type":0,"value":"For your records, the invoice with payment due is attached as a PDF."}],"commerce-payment-failure-trials.item-description-label.no-translate":[{"type":1,"value":"description"}],"commerce-payment-failure-trials.item-description.no-translate":[{"type":0,"value":" "},{"type":1,"value":"description"}],"commerce-payment-failure-trials.log-in-paypal":[{"type":0,"value":"Log in to PayPal"}],"commerce-payment-failure-trials.no_payment_method.partners.add_your_payment_details":[{"type":0,"value":"Add payment details today to avoid interruptions."}],"commerce-payment-failure-trials.no_payment_method.partners.caption":[{"type":0,"value":"Add payment details to avoid interruptions"}],"commerce-payment-failure-trials.no_payment_method.partners.title.with-companyname":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required: Add payment details"}],"commerce-payment-failure-trials.no_payment_method.partners.title.without-companyName":[{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required: Add payment details"}],"commerce-payment-failure-trials.no_payment_method.title":[{"type":0,"value":"Action required: Add your payment details"}],"commerce-payment-failure-trials.no_payment_method.unable_to_process_your_payment":[{"type":0,"value":"We were unable to process your payment since we haven\'t received your payment details for your subscription."}],"commerce-payment-failure-trials.no_payment_method.we_could_not_process":[{"type":0,"value":"We couldn\'t process your payment for Atlassian products as you haven\'t provided us with payment details yet."}],"commerce-payment-failure-trials.no_payment_method.we_could_not_process-access":[{"type":0,"value":"We\'re reaching out as we couldn\'t process your recent payment for invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" due to an issue with your account\'s payment details."}],"commerce-payment-failure-trials.payment":[{"type":0,"value":"This payment was for:"}],"commerce-payment-failure-trials.paypal-details":[{"type":0,"value":"PayPal account: "},{"type":1,"value":"element"}],"commerce-payment-failure-trials.sold-to-details.address":[{"type":1,"value":"element"},{"type":0,"value":" "},{"type":1,"value":"address"}],"commerce-payment-failure-trials.sold-to-details.address-message":[{"type":0,"value":"Address:"}],"commerce-payment-failure-trials.sold-to-details.company":[{"type":1,"value":"element"},{"type":0,"value":" "},{"type":1,"value":"companyName"}],"commerce-payment-failure-trials.sold-to-details.company-label":[{"type":0,"value":"Company:"}],"commerce-payment-failure-trials.sold-to-details.customer-contact":[{"type":1,"value":"element"},{"type":0,"value":" "},{"type":1,"value":"customerContact"}],"commerce-payment-failure-trials.sold-to-details.customer-contact-label":[{"type":0,"value":"Customer contact:"}],"commerce-payment-failure-trials.total-bill":[{"type":0,"value":"Your total bill is "},{"type":1,"value":"element"}],"commerce-payment-failure-trials.unable-to-pay":[{"type":0,"value":"If you\'re unable to make payments:"}],"commerce-payment-failure-trials.update-credit-card":[{"type":0,"value":"Update your payment details today to ensure continuous access to the product and prevent any potential loss of data and security configurations."}],"commerce-payment-failure-trials.update-credit-card-access":[{"type":0,"value":"Update your credit card details, or add a different credit card to ensure continuous access to the product and prevent any potential loss of data and security configurations."}],"commerce-payment-failure-trials.update-credit-card-without-access":[{"type":0,"value":"Update your credit card details, or add a different credit card to ensure continuous access to the product and prevent any potential loss of data."}],"commerce-payment-failure-trials.we_will_try_to_process_again":[{"type":0,"value":"We\u2019ll try to process your payment again on "},{"type":1,"value":"dueDate"},{"type":0,"value":"."}],"commerce-payment-failure-trials.what-to-do":[{"type":0,"value":"What you need to do:"}],"commerce-payment-failure-trials.without-payment-faq-product-access-lost":[{"type":0,"value":"Without this payment, product access will be lost, and product data will be permanently deleted soon after. See our "},{"type":1,"value":"element"}],"commerce-permission-request-add-payment-ccp.email.add-payment-request-text":[{"type":0,"value":"There is an add payment request from "},{"type":1,"value":"name"},{"type":0,"value":" ("},{"type":1,"value":"email"},{"type":0,"value":") for the subscription: "}],"commerce-permission-request-add-payment-ccp.email.begin-quotes.no-translate":[{"type":0,"value":"\u275D "}],"commerce-permission-request-add-payment-ccp.email.end-quotes.no-translate":[{"type":0,"value":" \u275E"}],"commerce-permission-request-add-payment-ccp.email.personal-note.no-translate":[{"options":{"other":{"value":[{"type":0,"value":"Hi, I\u2019d like to request an upgrade and need payment details added to this subscription."}]},"true":{"value":[{"type":1,"value":"customMessage"}]}},"type":5,"value":"hasCustomMessage"}],"commerce-permission-request-add-payment-ccp.email.subtext-for-personal-note":[{"type":0,"value":"To help you with more details, here\u2019s a note from the requester: "}],"commerce-permission-request-add-payment-ccp.email.title":[{"type":0,"value":"Request from "},{"type":1,"value":"name"},{"type":0,"value":" to add payment details"}],"commerce-permission-request-add-payment-ccp.email.whats-next-subtext":[{"type":0,"value":"If you approve the request, continue with adding payment details for the subscription and we\u2019ll notify the requester. Ignore this email to deny. "}],"commerce-permission-request-add-payment-response-ccp.email.add-payment-request-text":[{"type":0,"value":"Great news! Your request has been approved. Billing admin has added payment details to your subscription."}],"commerce-permission-request-add-payment-response-ccp.email.benefits-text":[{"type":0,"value":"You can now enjoy the benefits of:"}],"commerce-permission-request-add-payment-response-ccp.email.go-to-site":[{"type":0,"value":"Go to site"}],"commerce-permission-request-add-payment-response-ccp.email.title":[{"type":0,"value":"Your request is complete"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.add-on-count":[{"type":0,"value":"Units: "},{"type":1,"value":"count"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.add-on-entitlement-number":[{"type":1,"value":"entitlementNumber"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.free-entitlement.no-action":[{"type":0,"value":"You don\u2019t need to do anything, and your monthly Statuspage payments will remain the same."}],"commerce-pre-comms-sp-add-on-merge-ccp.email.merged-addon":[{"type":0,"value":"Over the next few days, we\u2019ll simplify things for you by merging these "},{"type":1,"value":"addOnName"},{"type":0,"value":" add-on subscriptions into one:"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.multiple-addons":[{"type":0,"value":"We noticed your Statuspage subscription "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" for "},{"type":1,"value":"site"},{"type":0,"value":" has more than one "},{"type":1,"value":"addOnName"},{"type":0,"value":" add-on: "}],"commerce-pre-comms-sp-add-on-merge-ccp.email.paid-entitlement.merged-add-on":[{"type":0,"value":"You\u2019ll only see one Subscribers add-on listed on your next invoice."}],"commerce-pre-comms-sp-add-on-merge-ccp.email.paid-entitlement.no-change":[{"type":0,"value":"There\u2019s no change to what you\u2019ll pay each month."}],"commerce-pre-comms-sp-add-on-merge-ccp.email.paid-entitlement.no-setup":[{"type":0,"value":"You won\u2019t need to set up or configure anything."}],"commerce-pre-comms-sp-add-on-merge-ccp.email.title":[{"type":0,"value":"We\u2019re merging your "},{"type":1,"value":"addOnName"},{"type":0,"value":" add-ons for Statuspage"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.what-this-means":[{"type":0,"value":"What this means for you"}],"commerce-reactivation-order-to-paid-ccp.email.subject":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"}],"commerce-subscription-auto-servco-upgrade-notification.message.link.view.apps":[{"type":0,"value":"View apps"}],"commerce-subscription-auto-servco-upgrade-notification.message.link.what.is.service.collection":[{"type":0,"value":"What\'s Service Collection?"}],"commerce-subscription-auto-servco-upgrade-notification.message.text":[{"type":0,"value":"Jira Service Management has moved to Service Collection on your site. You can now use the new Customer Service Management app while your existing setup stays the same."}],"commerce-subscription-auto-servco-upgrade-notification.message.title":[{"type":0,"value":"Jira Service Management update"}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.body.full.agent":[{"type":0,"value":"We upgraded you to a no-cost 14 day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" Standard, because you went over the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":"-"},{"type":1,"value":"userType"},{"type":0,"value":" for the Free plan. Add payment details before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" to avoid deactivation. Cancel anytime.\\nYou can switch back to a Free plan anytime by reducing your "},{"type":1,"value":"userType"},{"type":0,"value":" count."}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.body.full.user":[{"type":0,"value":"We upgraded you to a no-cost 14 day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" Standard, because you went over the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":"-"},{"type":1,"value":"userType"},{"type":0,"value":" for the Free plan. Add payment details before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" to avoid deactivation. Cancel anytime.\\nYou can switch back to a Free plan anytime by reducing your "},{"type":1,"value":"userType"},{"type":0,"value":" count."}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.path.manage.billing":[{"type":0,"value":"Manage billing"}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.primary.action":[{"type":0,"value":"Add payment"}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.secondary.action":[{"type":0,"value":"Manage subscriptions"}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.title.agent":[{"type":0,"value":"Subscription upgraded: Add payment or remove "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"userType"},{"type":0,"value":" before your trial ends"}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.title.user":[{"type":0,"value":"Subscription upgraded: Add payment or remove "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"userType"},{"type":0,"value":" before your trial ends"}],"commerce-subscription-cancellation-ecc.email.subject":[{"type":1,"value":"partnerName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" canceled"}],"commerce-subscription-cancellation-occurs-ccp-g.email.reactivate-instructions-1":[{"type":0,"value":"To reactivate your subscription, go to "}],"commerce-subscription-cancellation-occurs-ccp-g.email.reactivate-instructions-2":[{"type":0,"value":"Subscriptions > Inactive "}],"commerce-subscription-cancellation-occurs-ccp-g.email.reactivate-instructions-3":[{"type":0,"value":"tab"}],"commerce-subscription-cancellation-occurs-ccp-g.email.reactivate-instructions-4":[{"type":0,"value":" > Reactivate."}],"commerce-subscription-cancellation-occurs-ccp.email.reactivate-instructions-1":[{"type":0,"value":"To reactivate your subscription, go to "}],"commerce-subscription-cancellation-occurs-ccp.email.reactivate-instructions-2":[{"type":0,"value":"Subscriptions > Inactive "}],"commerce-subscription-cancellation-occurs-ccp.email.reactivate-instructions-3":[{"type":0,"value":"tab"}],"commerce-subscription-cancellation-occurs-ccp.email.reactivate-instructions-4":[{"type":0,"value":" > Reactivate."}],"commerce-subscription-paid-trials-auto-conversion-off-ccp.subtext":[{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-auto-conversion-off-ccp.subtext-with-site-url":[{"type":1,"value":"siteURL"},{"type":0,"value":" &#x2022; "},{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-ccp.subtext":[{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-ccp.subtext-with-site-url":[{"type":1,"value":"siteURL"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-no-payment-method-ccp.subtext":[{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-no-payment-method-ccp.subtext-with-site-url":[{"type":1,"value":"siteURL"},{"type":0,"value":" &#x2022; "},{"type":1,"value":"entitlementNumber"}],"commerce-subscription-reactivation-ccp.email.subject":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"}],"commerce-subscription-reactivation-trial-ccp.email.subject":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce-subscription-skip-trial-ccp.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription is active"}],"commerce-subscription-skip-trial-ccp.email.estimated-bill":[{"type":1,"value":"currency"},{"type":0,"value":" "},{"type":1,"value":"amountExcludingTax"},{"type":0,"value":" (excluding tax)"},{"type":1,"value":"content"}],"commerce-subscription-skip-trial-ccp.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription is active"}],"commerce-subscription-skip-trial-ccp.email.subject":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"newPricingPlanName"},{"type":0,"value":" subscription "}],"commerce-subscription-systematic-downgrade-ccp.email.subject":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldPricingPlan"},{"type":0,"value":" subscription "}],"commerce.bill-estimate-common.key":[{"type":0,"value":"Estimated bill:"}],"commerce.bill-estimate-common.value":[{"type":1,"value":"currency"},{"type":0,"value":" "},{"type":1,"value":"amountExcludingTax"},{"type":0,"value":" (excludes tax)"}],"commerce.billing-cycle-common.key":[{"type":0,"value":"Billing cycle:"}],"commerce.billing-cycle-common.value":[{"type":1,"value":"billingCycle"}],"commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.3ds-secure":[{"type":0,"value":"3DS is a mechanism that makes your online card transactions more secure."}],"commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.caption":[{"type":0,"value":"Action needed: Retry your payment with 3DS authentication"}],"commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.direct.help":[{"type":0,"value":"We couldn\'t process your payment since we need your help to complete 3-D Secure (3DS) authentication."}],"commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.direct.retry":[{"type":0,"value":"3DS is a mechanism that makes your online card transactions more secure. Please retry making the payment and complete 3DS authentication. You may be asked to verify through an app, enter a confirmation code sent to your phone, or be asked to authenticate in a different way."}],"commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.direct.subject":[{"type":0,"value":"Action needed: Retry your payment with 3DS authentication"}],"commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.international-transactions":[{"type":0,"value":"Keep in mind that banks sometimes decline payments due to restrictions on international transactions."}],"commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.partner-or-reseller.help":[{"type":0,"value":"We couldn\'t process your payment for the following invoice because we need your help to complete 3-D Secure (3DS) authentication:"}],"commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.partner-or-reseller.retry":[{"type":0,"value":"Retry making the payment and complete 3DS authentication. You may be asked to verify through an app, enter a confirmation code sent to your phone, or be asked to authenticate in a different way."}],"commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.partner-or-reseller.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action needed: Retry payment"}],"commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.retry-payment-button":[{"type":0,"value":"Retry payment"}],"commerce.commerce-approvals-received-author-notification.email.body":[{"type":0,"value":"Your initiative ("},{"type":1,"value":"initiativeName"},{"type":0,"value":") has been approved and is now ready for release."}],"commerce.commerce-approvals-received-author-notification.email.cta.link":[{"type":0,"value":"Click on the button below to release the initiative in Workbench."}],"commerce.commerce-approvals-received-author-notification.email.initiative.link":[{"type":0,"value":"Go to initiative"}],"commerce.commerce-approvals-received-author-notification.email.regards":[{"type":0,"value":"Regards,"}],"commerce.commerce-approvals-received-author-notification.email.your.workbench.team":[{"type":0,"value":"Your Workbench team"}],"commerce.commerce-approvals-received-author-notification.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Workbench"}],"commerce.commerce-approvals-received-author-notification.message-template.email.subject.no-translate":[{"type":0,"value":"Your initiative is ready for release"}],"commerce.commerce-approvals-received-author-notification.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.body.cancellation-reason":[{"type":0,"value":"It could be because the information provided to us is incorrect or incomplete. Don\'t worry,\\n                            the subscription can be reactivated after you update your billing information."}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.body.reactive-within":[{"type":1,"value":"content"},{"type":0,"value":" If you reactivate the subscription within 60 days of cancellation, we\'ll restore the relevant data and preferences. For trials, the reactivation period is 15 days."}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.body.subscription-cancellation-message":[{"type":0,"value":"We couldn\'t generate an invoice for the following subscription as we don\'t have your complete billing information.\\n                            As a result, the subscription has been canceled."}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription canceled - update billing details"}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.subject":[{"type":1,"value":"title"},{"type":0,"value":" canceled"}],"commerce.commerce-auto-downgrade-uninvoiceable-ccp.message-template.email.body.caption":[{"type":0,"value":"You are now on the Free plan of "},{"type":1,"value":"productName"}],"commerce.commerce-auto-downgrade-uninvoiceable-ccp.message-template.email.body.interruptions":[{"type":0,"value":"To avoid any interruptions, make sure your payment details are up to date."}],"commerce.commerce-auto-downgrade-uninvoiceable-ccp.message-template.email.body.invoice-failure":[{"type":0,"value":"We were unable to generate an invoice for your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription ("},{"type":1,"value":"entitlementId"},{"type":0,"value":") as we don\'t have your complete billing information. As a result, we\'ve moved your subscription to the Free plan. This way, you can still use "},{"type":1,"value":"productName"},{"type":0,"value":", but with limited features."}],"commerce.commerce-auto-downgrade-uninvoiceable-ccp.message-template.email.body.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-auto-downgrade-uninvoiceable-ccp.message-template.email.body.upgrade":[{"type":0,"value":"Want to go back on your original plan? You can upgrade your subscription. "},{"children":[{"type":0,"value":"Learn how to change plans"}],"type":8,"value":"link"}],"commerce.commerce-auto-downgrade-uninvoiceable-ccp.message-template.email.subject":[{"type":1,"value":"productName"},{"type":0,"value":" subscription moved to Free plan"}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.caption":[{"type":0,"value":"Changes have been made to your billing account"}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.change.bill-to-party":[{"type":0,"value":"your billing details were updated. The following changes were made:"}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.change.bill-to-price-eligibility":[{"type":0,"value":"your bill-to pricing eligibility was changed."}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.change.invoice-group-recipients":[{"type":0,"value":"your list of invoice recipients was changed."}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.change.ship-to-party":[{"type":0,"value":"your sold-to details were updated. The following changes were made:"}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.change.ship-to-price-eligibility":[{"type":0,"value":"your sold-to pricing eligibility was changed."}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.company-name-key":[{"type":0,"value":"Company name:"}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.introduction":[{"type":0,"value":"This email is to let you know that some changes were made to a billing account managed by you."}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.invoice-group.recipients":[{"type":0,"value":"Updated list of recipients:"}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.notice":[{"type":0,"value":"To centrally manage all your accounts, visit "},{"type":1,"value":"adminHubLink"}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.party.phone-key":[{"type":0,"value":"Phone:"}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.party.postal-address":[{"type":0,"value":"Postal address:"}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.party.tax-id-key":[{"type":0,"value":"Tax id:"}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.price-eligibility.academic":[{"type":0,"value":"Price eligibility was updated to Academic."}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.price-eligibility.classroom":[{"type":0,"value":"Price eligibility was updated to Classroom."}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.price-eligibility.community":[{"type":0,"value":"Price eligibility was updated to Community."}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.price-eligibility.generic":[{"type":0,"value":"Price eligibility was updated."}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.price-eligibility.opensource":[{"type":0,"value":"Price eligibility was updated to Open Source."}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.subject":[{"type":0,"value":"Atlassian billing account information was updated"}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.updated-at":[{"type":0,"value":"At "},{"type":1,"value":"updatedAt"},{"type":0,"value":","}],"commerce.commerce-cancellation-occurs-offering-archived-ccp-direct.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productInfo"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.ecc.partner-details":[{"type":0,"value":"Your partner details are:"}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.partner.customer-details":[{"type":0,"value":"Your customer details are:"}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.partner.subscription-details":[{"type":0,"value":"Your subscription details are:"}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.summary.dc-uncollectible":[{"type":0,"value":"We\u2019ve canceled the following subscription. This is because we weren\u2019t able to process your payment."}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.summary.dc-uninvoiceable":[{"type":0,"value":"We\u2019ve canceled the following subscription. This is because we\u2019re missing the right payment details, so we weren\u2019t able to process your payment."}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.summary.partner":[{"type":0,"value":"We\'ve canceled the following subscription:"}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.caption.direct-customer":[{"type":0,"value":"Your "},{"type":1,"value":"productInfo"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.caption.partner-end-customer-contact":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.mpucup.body.exceeded-user-limit":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription was canceled because your team exceeded the 10-user limit on the Free plan and payment details were not added to upgrade to the Standard plan."}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.mpucup.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has ended"}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.mpucup.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has ended"}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.subject.partner-billing-admin-and-billing-user":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" canceled"}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.subject.partner-bu-and-ecc":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.special-char-colon":[{"type":0,"value":":"}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.special-char-period":[{"type":0,"value":"."}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.this-is-because-we-do-not-have-your-customers-billing-information":[{"type":0,"value":"This is because we don\'t have your customer\'s complete billing information. It could be because the information provided to us is incorrect or incomplete."}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.this-is-because-we-were-not-able-to-collect-payment-for-an-invoice":[{"type":0,"value":"This is because we weren\'t able to collect payment for an invoice."}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.we-have-cancelled-the-following-subscription":[{"type":0,"value":"We\'ve canceled the following subscription"}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.we-have-cancelled-your-customers-subscription":[{"type":0,"value":"We\'ve canceled your customer\'s subscription."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.email.caption":[{"type":0,"value":"We\'re sad to see you go"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.email.direct-customer.jsm-requirement":[{"type":0,"value":"This is because our Marketplace app partner has updated the way this app is billed, which means it needs to be installed on Jira Service Management going forward. Since you don\'t have an active JSM subscription, the app can no longer be billed compatibly."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.email.direct-customer.prevention-option":[{"type":0,"value":"There\'s still time to prevent cancellation. You just need to purchase a Jira Service Management subscription before "},{"type":1,"value":"cancellationDate"},{"type":0,"value":"."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.email.partner.caption":[{"type":0,"value":"We\'re sad to see you go"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.email.partner.caption.twc":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" scheduled for cancellation"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.body.sub-cancel-note.twc":[{"type":0,"value":"Your subscription will be canceled at the end of your current billing cycle on "},{"children":[{"type":1,"value":"nextBillingDate"}],"type":8,"value":"b"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.direct-customer.body.billing-admin.keep-subscription":[{"type":0,"value":"You can always "},{"type":1,"value":"undoLink"},{"type":0,"value":"."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.direct-customer.body.billing-admin.manage-subscription-button":[{"type":0,"value":"View subscription"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.direct-customer.body.billing-admin.undo-cancellation-link":[{"type":0,"value":"undo your cancellation"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.direct-customer.body.billing-user.keep-subscription":[{"type":0,"value":"You can always "},{"type":1,"value":"undoLink"},{"type":0,"value":"."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.direct-customer.body.received-request":[{"type":0,"value":"We\'ve received your request to cancel your subscription:"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.direct-customer.body.sub-cancel-note":[{"type":0,"value":"Your subscription will be canceled at the end of your current billing cycle on "},{"type":1,"value":"nextBillingDate"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":" Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" is scheduled for cancellation"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.billing-partner-details.twc":[{"type":0,"value":"Your billing partner details are:"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.data-deletion-note":[{"type":0,"value":"Product data will be deleted in 60 days from the date of cancellation. For trials, we retain data for 15 days. If you\u2019d like to request deletion of personal data, "},{"type":1,"value":"contactSupport"},{"type":0,"value":". Learn about "},{"type":1,"value":"privacyPolicy"},{"type":0,"value":"."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.jira-decoupled.cancellation-notice":[{"type":0,"value":"Your subscription will be canceled on "},{"type":1,"value":"nextBillingDate"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\'ll send you an email once the cancellation has gone through."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.jira-decoupled.contact-us":[{"type":0,"value":"contact us"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.jira-decoupled.data-deletion-note":[{"type":0,"value":"Product data will be deleted 60 days from cancellation. For trials, we retain data for 15 days. If you\'d like to request deletion of personal data, "},{"type":1,"value":"contactUs"},{"type":0,"value":"."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.jira-decoupled.intro":[{"type":0,"value":"Your app subscription is scheduled for cancellation. This is because our Marketplace app partner has updated the way this app is billed, which means it needs to be installed on Jira Service Management going forward. Since you don\'t have an active JSM subscription, the app can no longer be billed compatibly."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.jira-decoupled.prevention-option":[{"type":0,"value":"There\'s still time to prevent cancellation. You just need to contact your Atlassian billing partner to purchase a Jira Service Management subscription before "},{"type":1,"value":"cancellationDate"},{"type":0,"value":"."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.received-request":[{"type":0,"value":"We\'ve received a request to cancel the following subscription:"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.received-request.twc":[{"type":0,"value":"We\'ve received your request to cancel your subscription"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.undo-cancellation":[{"type":0,"value":"You can always "},{"type":1,"value":"undoLink"},{"type":0,"value":" from "},{"type":1,"value":"partnerManagedSubscriptionsLink"},{"type":0,"value":"."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.undo-cancellation-link":[{"type":0,"value":"undo your cancellation"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.email.ecc.subject":[{"type":1,"value":"billingPartnerName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.email.ecc.subject.twc":[{"type":1,"value":"billingPartnerName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" is scheduled for cancellation"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.billing-admin.keep-subscription":[{"type":0,"value":"If needed, you can contact us to reverse the cancellation request. If you reactivate the subscription within 60 days of cancellation, we\'ll restore the relevant data and preferences. For trials, the reactivation period is 15 days."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.billing-admin.undo-cancellation-link":[{"type":0,"value":"undo your cancellation"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.billing-user.keep-subscription":[{"type":0,"value":"If needed, you can contact us to reverse the cancellation request. "},{"type":1,"value":"undoLink"},{"type":0,"value":"."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.customer-details.twc":[{"type":0,"value":"Your customer details are:"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.ecc.atlassian-privacy-policy":[{"type":0,"value":"Atlassian\u2019s Privacy Policy"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.ecc.contact-atlassian-support":[{"type":0,"value":"contact Atlassian support"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.ecc.contact-billing-partner":[{"type":0,"value":"You can contact your Atlassian billing partner if you need help or want to reverse the cancellation request."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.jira-decoupled.cancellation-notice":[{"type":0,"value":"Your subscription will be canceled on "},{"type":1,"value":"nextBillingDate"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\'ll send you an email once the cancellation has gone through."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.jira-decoupled.intro":[{"type":0,"value":"Your customer\'s app subscription is scheduled for cancellation. This is because our Marketplace app partner has updated the way this app is billed, which means it needs to be installed on Jira Service Management going forward. Since your customer doesn\'t have an active JSM subscription, the app can no longer be billed compatibly."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.jira-decoupled.prevention-option":[{"type":0,"value":"There\'s still time to prevent cancellation. You just need to purchase a Jira Service Management subscription before "},{"type":1,"value":"cancellationDate"},{"type":0,"value":"."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.keep-subscription":[{"type":0,"value":"Keeping the subscription"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.keep-subscription.twc":[{"type":0,"value":"Your customer contact can undo the cancellation at any time from "},{"type":1,"value":"partnerManagedSubscriptionsLink"},{"type":0,"value":"."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.partner-managed-subscriptions-link":[{"type":1,"value":"partnerManagedSubscriptionsLink"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.partner.billing-admin.undo-cancellation-link":[{"type":0,"value":"Learn how to undo a cancellation"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.received-request":[{"type":0,"value":"We\u2019ve received a request to cancel the following subscription:"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.received-request.twc":[{"type":0,"value":"We\u2019ve received your customer\u2019s request to cancel their subscription."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.sub-cancel-note":[{"type":0,"value":"The subscription will be canceled at the end of the current billing cycle on "},{"type":1,"value":"nextBillingDate"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.sub-cancel-note.twc":[{"type":0,"value":"The subscription will be canceled at the end of the current billing cycle on "},{"children":[{"type":1,"value":"nextBillingDate"}],"type":8,"value":"b"},{"type":0,"value":". Until then, the subscription can still be used. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.subscription-details.twc":[{"type":0,"value":"Your subscription details are:"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.subject.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" : "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.subject.with-company-name.twc":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.subject.without-company-name":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.subject.without-company-name.twc":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.body.billing-faq-url":[{"type":0,"value":"When and how will I be billed?"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.breach-adjust-limit":[{"type":0,"value":"Organization admins can adjust this limit anytime."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.breach-body":[{"type":0,"value":"Your organization has reached the monthly "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit set by your admin. As a result, some features will be restricted or unavailable until your usage reset date. "},{"type":1,"value":"learnMoreLink"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.breach-caption":[{"type":0,"value":"Your organization has hit its "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.breach-visit-admin":[{"type":0,"value":"Visit Atlassian Administration to get more details on "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage in your organization."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.milestone-body":[{"type":0,"value":"Your organization has used 80% of its "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit. This is a limit that was set by your admin, and is different to the allowance included with your subscriptions."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.milestone-caption":[{"type":0,"value":"80% of your "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit has been used"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.milestone-visit-admin":[{"type":0,"value":"Visit Atlassian Administration to get more details on "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage in your organization."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.milestone-whats-next":[{"type":0,"value":"Once your organization reaches the limit, some features will be restricted or unavailable until your usage resets. Organization admins can adjust this limit anytime."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.milestone-whats-next.enforced":[{"type":0,"value":"For the amount of usage above the allowance, at the end of the current cycle, you\u2019ll receive a bill for extra usage incurred this cycle."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.milestone-whats-next.non-enforced":[{"type":0,"value":"Any usage beyond your allowance is considered extra usage. "},{"children":[{"type":0,"value":"You won\u2019t be billed for your extra usage at this time."}],"type":8,"value":"b"},{"type":0,"value":" "},{"type":1,"value":"billingUrl"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.subject.breach":[{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit reached"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.subject.milestone":[{"type":0,"value":"Your organization has used 80% of your "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.email.body.view-usage":[{"type":0,"value":"View usage"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.email.more-about-usage-charges-and-billing":[{"type":0,"value":"More about usage charges and billing"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.email.whats-next":[{"type":0,"value":"What\'s next?"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.breach-adjust-limit":[{"type":0,"value":"You can adjust this limit anytime."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.breach-body":[{"type":0,"value":"Your customer has reached the monthly "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit you set. As a result, some features will be restricted or unavailable for your customer until their usage reset date. "},{"type":1,"value":"learnMoreLink"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.breach-caption":[{"type":0,"value":"Your customer has hit their "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.breach-visit-ppc":[{"type":0,"value":"Visit PPC to get more details on your customer\'s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.milestone-body":[{"type":0,"value":"Your customer has used 80% of their organization\'s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit. This is a limit that was set by your customer\'s admin, and is different to the allowance included with your customer\'s subscriptions."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.milestone-caption":[{"type":0,"value":"80% of your customer\'s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit has been used"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.milestone-visit-ppc":[{"type":0,"value":"Visit PPC to get more details on your customer\'s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.milestone-whats-next":[{"type":0,"value":"Once your customer reaches the limit, some features will be restricted or unavailable until their usage resets. You can adjust this limit anytime."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.milestone.billable-usage-notice.enforced":[{"type":0,"value":"For the amount of usage above the allowance, at the end of the current cycle, you\u2019ll receive a bill for extra usage incurred this cycle."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.milestone.billable-usage-notice.non-enforced":[{"type":0,"value":"Any usage beyond your allowance is considered extra usage. "},{"children":[{"type":0,"value":"You won\u2019t be billed for extra usage at this time."}],"type":8,"value":"b"},{"type":0,"value":" "},{"type":1,"value":"billingUrl"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.subject.breach":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit reached"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.subject.breach.without-company-name":[{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit reached"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.subject.milestone":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": 80% of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.subject.milestone.without-company-name":[{"type":0,"value":"80% of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit"}],"commerce.commerce-credit-account-approval-ccp.email.list.credit-limit":[{"type":0,"value":"Credit limit: "},{"type":1,"value":"creditLimitFormatted"},{"type":1,"value":"limitShareText"}],"commerce.commerce-credit-account-approval-ccp.message-template.approved.title":[{"type":0,"value":"Your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms application has been approved"}],"commerce.commerce-credit-account-approval-ccp.message-template.email.subject":[{"type":0,"value":"Approved for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms"}],"commerce.commerce-credit-account-approval-ccp.message-template.good-news":[{"type":0,"value":"Good news! We\u2019ve approved your application for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms. Here are the details: "}],"commerce.commerce-credit-account-deactivation-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Your account is now ineligible for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms"}],"commerce.commerce-credit-account-limit-update-ccp.email.list.new-credit-limit":[{"type":0,"value":"New Credit limit: "},{"type":1,"value":"newCreditLimitFormatted"},{"type":1,"value":"limitShareText"}],"commerce.commerce-credit-account-limit-update-ccp.email.possible-reasons":[{"type":0,"value":"Learn about possible reasons."}],"commerce.commerce-credit-account-limit-update-ccp.email.statement-info":[{"type":0,"value":"We\u2019ve decreased your credit limit to "},{"type":1,"value":"newCreditLimitFormatted"},{"type":0,"value":". Your previous credit limit was "},{"type":1,"value":"creditLimitFormatted"},{"type":0,"value":". "},{"type":1,"value":"possibleReasons"}],"commerce.commerce-credit-account-limit-update-ccp.message-template.decrease.title":[{"type":0,"value":"We\u2019ve decreased your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit"}],"commerce.commerce-credit-account-limit-update-ccp.message-template.email.decrease.subject":[{"type":0,"value":"Your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit has been decreased"}],"commerce.commerce-credit-account-limit-update-ccp.message-template.email.increase.subject":[{"type":0,"value":"Your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit has been increased"}],"commerce.commerce-credit-account-limit-update-ccp.message-template.good-news":[{"type":0,"value":"Good news! We\u2019ve increased your credit limit to "},{"type":1,"value":"newCreditLimitFormatted"},{"type":0,"value":". Your previous credit limit was "},{"type":1,"value":"creditLimitFormatted"},{"type":0,"value":". Here are the details: "}],"commerce.commerce-credit-account-limit-update-ccp.message-template.increase.title":[{"type":0,"value":"We\u2019ve increased your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit"}],"commerce.commerce-credit-account-reactivation-ccp.message-template.email.subject":[{"type":0,"value":"Your account is now re-eligible for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms"}],"commerce.commerce-credit-account-rejection-ccp.message-template.bad-news":[{"type":0,"value":"Unfortunately, we couldn\u2019t approve your application because you didn\u2019t meet our credit check requirements."}],"commerce.commerce-credit-account-rejection-ccp.message-template.email.subject":[{"type":0,"value":"Couldn\u2019t approve your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms application"}],"commerce.commerce-credit-account-rejection-ccp.message-template.other-option":[{"type":0,"value":"You can still move forward with your purchase. We suggest using a credit card to pay for your order. Reach out to us if you need further help in placing your order."}],"commerce.commerce-credit-account-rejection-ccp.message-template.rejection.title":[{"type":0,"value":"We\u2019re unable to approve you for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms"}],"commerce.commerce-credit-account-rejection-ccp.message-template.thanks":[{"type":0,"value":"Thank you for submitting your application for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.email.subject":[{"type":0,"value":"Credit Application Result: Reject"}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.how-to-move-forward":[{"type":0,"value":"Here\'s how to move forward:"}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.instruction.all-fields":[{"children":[{"type":0,"value":"Double-check"}],"type":8,"value":"strong"},{"type":0,"value":" that every field is filled in \u2014 this helps us complete our review faster."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.instruction.return-form":[{"children":[{"type":0,"value":"Send them the form"}],"type":8,"value":"strong"},{"type":0,"value":" and ask them to return it directly to us."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.instruction.sign":[{"children":[{"type":0,"value":"Sign"}],"type":8,"value":"strong"},{"type":0,"value":" the top of the form."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.instruction.vendors":[{"children":[{"type":0,"value":"Choose two vendors"}],"type":8,"value":"strong"},{"type":0,"value":" you\'ve traded with for at least 12 months, whose trade volume with you exceeds the credit limit you\'re requesting. Please note: they can\'t be related entities."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.option.financial-statements":[{"children":[{"type":0,"value":"Latest audited financial statements"}],"type":8,"value":"strong"},{"type":0,"value":" (if you haven\'t already shared these), or"}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.option.trade-references":[{"children":[{"type":0,"value":"A completed trade references form"}],"type":8,"value":"strong"},{"type":0,"value":" (attached)"}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.reassessment":[{"type":0,"value":"The good news? This isn\'t final \u2014 we\'d be happy to reassess your account once we have a bit more information."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.reassessment-underway":[{"type":0,"value":"Once we receive everything, we\'ll get your reassessment underway."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.rejection":[{"type":0,"value":"Thank you for applying for payment terms with us. After carefully reviewing your application, we\'re unable to approve Net-30 terms at this time."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.resubmit-instructions":[{"type":0,"value":"Once you have the additional information ready, you can resubmit a new Net-30 application directly from your account (the application link is available there). Just include "},{"children":[{"type":0,"value":"one"}],"type":8,"value":"strong"},{"type":0,"value":" of the following with your resubmission:"}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.trade-reference-intro":[{"type":0,"value":"Using the trade references form? Just follow these 4 steps:"}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.card-expiry-warning-message":[{"type":0,"value":"Heads up \u2014 your credit card expires in "},{"type":1,"value":"expiryMonthAndYear"},{"type":0,"value":". To make sure your next payment is made on time so you can continue using your subscriptions without interruption, you\u2019ll need to update your payment details before "},{"type":1,"value":"dueDate"},{"type":0,"value":"."}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.no-update-action":[{"type":0,"value":"What happens if I don\u2019t update my details?"}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.no-update-action-warning":[{"type":0,"value":"Your next payment attempt will fail \u2013 this means your subscription could be deactivated and you could lose product access and data."}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.select":[{"type":0,"value":"Select "}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Your credit card expires soon"}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.time-to-update-credit-card-details":[{"type":0,"value":"Time to update your credit card details"}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.update-payment-details":[{"type":0,"value":"Update payment details"}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.update-payment-details-note":[{"type":0,"value":" below to edit your saved card."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.email.subject":[{"type":0,"value":"Additional information needed for your Net-30 application"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.financial.balance-sheet":[{"type":0,"value":"Balance Sheet"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.financial.cash-flow":[{"type":0,"value":"Cash Flow Statement"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.financial.income-statement":[{"type":0,"value":"Income Statement"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.instruction.all-fields":[{"type":0,"value":"Ensure all fields are completed so we can finalize the review without delays."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.instruction.return-form":[{"type":0,"value":"Send them the form and ask them to return it directly to us."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.instruction.sign":[{"type":0,"value":"Sign the top of the form."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.instruction.vendors":[{"type":0,"value":"Select two vendors you\'ve traded with for at least 12 months, whose trade volume with you exceeds the credit limit you\'re requesting. Please note that they can\'t be related entities."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.intro":[{"type":0,"value":"Thank you for your interest in setting up Net-30 payment terms with us. After reviewing your D&B credit profile, we\'re unable to approve the request at this time."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.option1-accounting-team":[{"type":0,"value":"Your accounting team should be able to provide these. They\'ll give us a clearer view of your account and support our reassessment."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.option1-heading":[{"type":0,"value":"Option 1: Provide your audited financial statements"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.option1-intro":[{"type":0,"value":"If you haven\'t already shared these, please send your most recent:"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.option2-heading":[{"type":0,"value":"Option 2: Provide trade references"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.option2-intro":[{"type":0,"value":"If you\'d prefer this option, please complete the attached trade reference form. Here\'s what we\'ll need:"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.reconsider":[{"type":0,"value":"If you\'d like us to reconsider, we\'d be glad to take another look with some additional information from your end."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.thank-you":[{"type":0,"value":"Thank you again for being an Atlassian customer. We appreciate your business and look forward to hearing from you soon."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.two-options":[{"type":0,"value":"You have two options:"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.whats-next-body":[{"type":0,"value":"Please let us know which option you\'d like to pursue, or feel free to reach out with any questions. We\'re here to support you and want to make this process as straightforward as possible."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.whats-next-heading":[{"type":0,"value":"What happens next?"}],"commerce.commerce-customer-contact-remove-digest.email.body.removed-contact":[{"type":1,"value":"name"},{"type":0,"value":" ("},{"type":1,"value":"email"},{"type":0,"value":")"}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.caption":[{"type":0,"value":"Customer contact removed"}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.contact-removed":[{"type":0,"value":"Contact removed: "}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.impacted-subscriptions":[{"type":0,"value":"Impacted subscriptions:"}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.intro":[{"type":0,"value":"We\'ve removed a key customer contact from a billing profile."}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.questions":[{"type":0,"value":"If you have any questions, please reach out to your Atlassian billing partner."}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.removed-by":[{"type":0,"value":"Removed by: "}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.view-changes":[{"type":0,"value":"You can view the changes at "},{"type":1,"value":"url"},{"type":0,"value":" page."}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.view-changes-link":[{"type":0,"value":"partner managed subscriptions"}],"commerce.commerce-customer-contact-remove-digest.message-template.email.remaining-subs":[{"type":0,"value":"+ "},{"type":1,"value":"remainingCount"},{"type":0,"value":" subscriptions."}],"commerce.commerce-customer-contact-remove-digest.message-template.email.subject":[{"type":0,"value":"Customer contact removed"}],"commerce.commerce-customers-deactivation-eve.email.body-p1":[{"type":0,"value":"U.S. law prohibits Atlassian, an Australian corporation with offices in the United States, from providing you with access to our products and services. After analyzing the applicable lists of restricted parties maintained by the U.S. Government, we were unable to confirm that your name was not affiliated with a restricted party."}],"commerce.commerce-customers-deactivation-eve.email.body-p2":[{"type":0,"value":"If this is a case of misidentification, please reply with two different copies of official documentation to verify your identity."}],"commerce.commerce-customers-deactivation-eve.email.body-p3":[{"type":0,"value":"Official documentation includes, but is not limited to, a government-issued driver\'s license or identification card, passport, utility bill, mortgage or bank statement, etc. Please make sure your full name and address are clearly visible."}],"commerce.commerce-customers-deactivation-eve.email.body-p4":[{"type":0,"value":"You may check out these resources for more information: U.S. export controls ("},{"type":1,"value":"exportControl"},{"type":0,"value":") | Consolidated Screening List ("},{"type":1,"value":"csl"},{"type":0,"value":")"}],"commerce.commerce-customers-deactivation-eve.email.body-p5":[{"type":0,"value":"Please reply directly via email with any further questions and the identification requested."}],"commerce.commerce-customers-deactivation-eve.email.body-p6":[{"type":0,"value":"We look forward to your reply."}],"commerce.commerce-customers-deactivation-eve.email.body.csl":[{"type":0,"value":"https://www.trade.gov/consolidated-screening-list"}],"commerce.commerce-customers-deactivation-eve.email.body.exportControl":[{"type":0,"value":"https://www.trade.gov/us-export-controls"}],"commerce.commerce-customers-deactivation-eve.email.caption":[{"type":0,"value":"Deactivated Atlassian Account"}],"commerce.commerce-customers-deactivation-eve.email.salutation":[{"type":0,"value":"Dear Atlassian user,"}],"commerce.commerce-customers-deactivation-eve.email.subject":[{"type":0,"value":"Deactivated Atlassian Account"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.billed-based-on-the-users":[{"type":0,"value":"Until now, billing for this app has been linked to your total user count for Jira. The change will mean that you\'ll be billed based on the number of agents who use the Jira Service Management subscription instead."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.billing-flexibility-info-message":[{"type":0,"value":"Billing flexibility is now available for your "},{"type":1,"value":"productName"},{"type":0,"value":" for Jira Service Management app."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.body.this-change-will-introduce-pricing-updates":[{"type":0,"value":"The change will introduce pricing updates that are set out by our Marketplace partners. These updates will come into effect with the new way of billing, even if your user count isn\'t updated."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.body.we-will-make-the-change":[{"type":0,"value":"We\'ll automatically make the change on "},{"type":1,"value":"nextBillingDate"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.caption":[{"type":0,"value":"Have more billing flexibility and only pay for what you need"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.if-you-dont-do-anything":[{"type":0,"value":"If you don\'t do anything"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.maximize-your-billing-efficiency":[{"type":0,"value":"Maximize your billing efficiency"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.need-more-info":[{"type":0,"value":"Need more info? See our guide on "},{"type":1,"value":"howMarketplaceAreBilled"},{"type":0,"value":"."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.billed-based-on-the-users":[{"type":0,"value":"Until now, billing for this app has been linked to your customer\'s total user count for Jira. The change will mean that your customer will be billed based on the number of agents who use the Jira Service Management subscription instead."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.billing-flexibility-info-message":[{"type":0,"value":"Billing flexibility is now available for your customer\'s "},{"type":1,"value":"productName"},{"type":0,"value":" for Jira Service Management app."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.body.this-change-will-introduce-pricing-updates":[{"type":0,"value":"The change will introduce pricing updates that are set out by our Marketplace partners. These updates will come into effect with the new way of billing, even if your user count isn\'t updated."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.body.we-will-make-the-change":[{"type":0,"value":"We\'ll automatically make the change on "},{"type":1,"value":"nextBillingDate"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.caption":[{"type":0,"value":"Give your customer more billing flexibility"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.customer-label":[{"type":0,"value":"Customer: "},{"type":1,"value":"customerName"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.pay-for-what-you-need":[{"type":0,"value":"To only pay for what you need, your customer can update the number of JSM agents by heading to Atlassian Administration."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.pay-only-for-users-who-need-access":[{"type":0,"value":"This means they have the option to only pay for the users that really need access."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.review-your-bill":[{"type":0,"value":"Make the switch now so your customer can start making the most of billing flexibility for this app. Keep in mind that the bill may be impacted, and can be changed by the organization admin by managing JSM access as needed. We\'d recommend reviewing the bill as you make the change."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.pay-for-what-you-need":[{"type":0,"value":"To only pay for what you need, your organization admin can update the number of JSM agents by heading to Atlassian Administration."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.pay-only-for-users-who-need-access":[{"type":0,"value":"This means you have the option to only pay for the users that really need access."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.review-your-bill":[{"type":0,"value":"Make the switch now to start making the most of billing flexibility for this app. Keep in mind that your bill may be impacted, and can be changed by the organization admin by managing JSM access as needed. We\'d recommend reviewing your bill as you make the change."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Update billing for your Marketplace app"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.what-do-i-need-to-do":[{"type":0,"value":"What do I need to do?"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.what-does-this-mean":[{"type":0,"value":"What does this mean?"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.body.direct.p1":[{"type":0,"value":"As requested, we\'ve updated the way you\'re billed for "},{"type":1,"value":"productName"},{"type":0,"value":" for Jira Service Management. You can now enjoy more control over who has access to and is charged for the app, and your bill will be based on the number of Jira Service Management agents, instead of the user count for Jira."}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.body.direct.p2":[{"type":0,"value":"It\'s a good idea to review who you\'d like to have access to the app. Keep in mind that your bill may be impacted, and organization admins can change it by managing who has access to the app as needed."}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.body.partner.p1":[{"type":0,"value":"As requested, we\'ve updated the way your customer is billed for "},{"type":1,"value":"productName"},{"type":0,"value":" for Jira Service Management. They can now enjoy more control over who has access to and is charged for the app, and the bill will be linked to the number of JSM agents instead of the user count for Jira."}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.body.partner.p2":[{"type":0,"value":"It\'s a good idea to remind your customer to review who they\'d like to have access to the app, and their bill may be impacted. Organization admins can adjust the bill by managing who has access to the app as needed."}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.button.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.help":[{"type":0,"value":"Have a question? We\'re here to help. "},{"type":1,"value":"getInTouch"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.link.get-in-touch":[{"type":0,"value":"Get in touch"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.link.how-billed":[{"type":0,"value":"Find out more about how Marketplace apps are billed."}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.signoff":[{"type":0,"value":"Thanks,"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.subject.direct":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" for JSM billing has been updated"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.subject.partner":[{"type":0,"value":"Update billing for your customer\'s Marketplace app"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.team":[{"type":0,"value":"The Atlassian team"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.title.direct":[{"type":0,"value":"Enjoy more control over your Marketplace app billing"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.title.partner":[{"type":0,"value":"Enjoy more control over your customer\'s app billing"}],"commerce.commerce-dunning-cancellation-credit-ccp.message-template.email.credit-note-button":[{"type":0,"value":"View credit note"}],"commerce.commerce-dunning-cancellation-credit-ccp.message-template.email.direct.caption":[{"type":0,"value":"Your credit note has been generated"}],"commerce.commerce-dunning-cancellation-credit-ccp.message-template.email.direct.processed":[{"type":0,"value":"We have processed your cancellation request for subscriptions under the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":". We\'ve generated a credit note "},{"type":1,"value":"creditNoteNumber"},{"type":0,"value":" against your invoice and adjusted the outstanding amount."}],"commerce.commerce-dunning-cancellation-credit-ccp.message-template.email.direct.subject":[{"type":0,"value":"Credit note generated against invoice "},{"type":1,"value":"invoiceNumber"}],"commerce.commerce-dunning-cancellation-credit-ccp.message-template.email.no-refund":[{"type":0,"value":"Please note that this credit note will not result in any refund since it is generated against an unpaid invoice."}],"commerce.commerce-dunning-cancellation-credit-ccp.message-template.email.partner-or-reseller.caption":[{"type":0,"value":"Credit note generated"}],"commerce.commerce-dunning-cancellation-credit-ccp.message-template.email.partner-or-reseller.processed":[{"type":0,"value":"We\'ve processed a cancellation request for subscriptions under the following invoice. We\'ve generated a credit note against the invoice and adjusted the outstanding amount."}],"commerce.commerce-dunning-cancellation-credit-ccp.message-template.email.partner-or-reseller.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Credit note generated"}],"commerce.commerce-dynamic-content-test-cns.message-template.email.greeting.custom":[{"type":1,"value":"greetingText"}],"commerce.commerce-dynamic-content-test-cns.message-template.email.greeting.default":[{"type":0,"value":"Dear "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-dynamic-content-test-cns.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"commerce.commerce-invoice-drawdown-ccp.message-template.email.subject":[{"type":0,"value":"Your Atlassian invoice is ready"}],"commerce.commerce-invoice-generated-ccp-g.message-template.email.partner.subject":[{"type":1,"value":"message"}],"commerce.commerce-invoice-generated-ccp-g.message-template.email.subject":[{"type":0,"value":"Your invoice has been processed"}],"commerce.commerce-invoice-generated-ccp.message-template.email.partner.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"businessKey"},{"type":0,"value":" generated"}],"commerce.commerce-invoice-generated-ccp.message-template.email.subject":[{"type":0,"value":"Your invoice has been processed"}],"commerce.commerce-invoice-resend-email-ccp.message-template.email.body":[{"type":0,"value":"As requested, we\'ve attached a copy of your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":")."}],"commerce.commerce-invoice-resend-email-ccp.message-template.email.caption":[{"type":0,"value":"Your invoice is ready"}],"commerce.commerce-invoice-resend-email-ccp.message-template.email.direct.subject":[{"type":0,"value":"Your invoice is attached ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":")"}],"commerce.commerce-invoice-resend-email-ccp.message-template.email.partner-or-reseller.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" invoice is attached ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":")"}],"commerce.commerce-invoice-resend-email-ccp.message-template.email.view-invoices.body":[{"type":0,"value":"You can also access your invoices in your billing account."}],"commerce.commerce-invoice-resend-email-ccp.message-template.email.view-invoices.partner.body":[{"type":0,"value":"You can also access your invoices in the Partner Purchasing Center."}],"commerce.commerce-invoice-resend-email-ccp.message-template.email.view-invoices.view-invoices":[{"type":0,"value":"View invoices"}],"commerce.commerce-invoice-resend-email-ccp.view-invoices.view-invoices":[{"type":0,"value":"View invoices"}],"commerce.commerce-invoice-terms-payment-pending-ccp-g.message-template.email.partner.company-name.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" Invoice generated"}],"commerce.commerce-invoice-terms-payment-pending-ccp-g.message-template.email.partner.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" generated"}],"commerce.commerce-invoice-terms-payment-pending-ccp-g.message-template.email.subject":[{"type":0,"value":"Your invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" has been processed"}],"commerce.commerce-invoice-terms-payment-pending-ccp.message-template.email.partner.company-name.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" Invoice generated"}],"commerce.commerce-invoice-terms-payment-pending-ccp.message-template.email.partner.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" generated"}],"commerce.commerce-invoice-terms-payment-pending-ccp.message-template.email.subject":[{"type":0,"value":"Your invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" has been processed"}],"commerce.commerce-invoice-terms-payment-received-email-ccp.message-template.email.caption":[{"type":0,"value":"Your payment has been processed"}],"commerce.commerce-invoice-terms-payment-received-email-ccp.message-template.email.direct.confirm":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\'ve received your payment for the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":". The invoice is attached as a PDF for your records."}],"commerce.commerce-invoice-terms-payment-received-email-ccp.message-template.email.direct.subject":[{"type":0,"value":"Your payment has been processed for the invoice "},{"type":1,"value":"invoiceNumber"}],"commerce.commerce-invoice-terms-payment-received-email-ccp.message-template.email.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce.commerce-invoice-terms-payment-received-email-ccp.message-template.email.partner-or-reseller.confirm":[{"type":0,"value":"This email is to confirm we\'ve received payment for the following invoice:"}],"commerce.commerce-invoice-terms-payment-received-email-ccp.message-template.email.partner-or-reseller.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Payment processed"}],"commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.amount-label":[{"type":0,"value":"Amount Due:"}],"commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.attached-pdf":[{"type":0,"value":"Please find attached a copy of the invoice for your reference with payment instructions. To ensure uninterrupted service, we request that you settle this outstanding amount as soon as possible."}],"commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.caption":[{"type":0,"value":"Reactivation of Services and Payment Reminder"}],"commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.contact-us":[{"type":0,"value":"If there are any issues or if you require any additional information, feel free to "},{"type":1,"value":"contactUs"},{"type":0,"value":"."}],"commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.contact-us-link":[{"type":0,"value":"contact us"}],"commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.details":[{"type":0,"value":"Upon reactivation of your subscription, we wish to remind you that your "},{"children":[{"type":0,"value":"previous invoice is overdue"}],"type":8,"value":"strong"},{"type":0,"value":". See below details:"}],"commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.due-date-label":[{"type":0,"value":"Due Date:"}],"commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.invoice-date-label":[{"type":0,"value":"Invoice Date:"}],"commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.invoice-number-label":[{"type":0,"value":"Invoice:"}],"commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.payment-confirm":[{"type":0,"value":"If you have already made the payment, please send remittance advice to "},{"type":1,"value":"arLink"},{"type":0,"value":"."}],"commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.reactivation-date-label":[{"type":0,"value":"Reactivation Date:"}],"commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.subject":[{"type":0,"value":"Reactivation of Services and Payment Reminder - Invoice "},{"type":1,"value":"invoiceNumber"}],"commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.thank-you":[{"type":0,"value":"Thank you for your prompt attention to this matter."}],"commerce.commerce-invoice-updated-ccp-g.message-template.email.partner.company-name.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp-g.message-template.email.partner.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp-g.message-template.email.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp.message-template.email.partner.company-name.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp.message-template.email.partner.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp.message-template.email.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.confluence.offer-message":[{"type":0,"value":"When you use the two together, you can centralize your docs, connect work across teams and more. With the Standard plan, you get:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.confluence.single-congratulations-message":[{"type":0,"value":"Did you know that "},{"type":1,"value":"purchasedProductName"},{"type":0,"value":" works even better with Confluence?"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.confluence.single-product-caption":[{"type":0,"value":"Build a single source of truth for all your team\u2019s important info"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.confluence.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.cta.try-now":[{"type":0,"value":"Try now"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jpd.offer-message":[{"type":0,"value":"Together, the products help you capture ideas and prioritize work, so you\u2019re always organized. With the Standard plan, you get:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jpd.single-congratulations-message":[{"type":0,"value":"Did you know "},{"type":1,"value":"purchasedProductName"},{"type":0,"value":" works even better with Jira Product Discovery?"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jpd.single-product-caption":[{"type":0,"value":"Say goodbye to messy backlogs"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jpd.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsm.offer-message":[{"type":0,"value":"With the Standard plan, you get:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsm.single-congratulations-message":[{"type":0,"value":"People who use Jira Service Management say that work is more visible for all teams involved, from request to resolution."}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsm.single-product-caption":[{"type":0,"value":"Bring developers, IT, and operations onto the same platform"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsm.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsw.offer-message":[{"type":0,"value":"With Jira, your team can move fast, stay aligned, and build better - together. With the Standard plan, you get:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsw.single-congratulations-message":[{"type":0,"value":"Jira and "},{"type":1,"value":"purchasedProductName"},{"type":0,"value":" can help you visualize and deliver work, fast."}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsw.single-product-caption":[{"type":0,"value":"Break down silos and connect the dots between teams"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsw.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.multi-congratulations-message":[{"type":0,"value":"Congrats on purchasing "},{"type":1,"value":"purchasedProductTitle"},{"type":0,"value":"! Get free trials of these products and unlock these advanced features:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.multi-product-caption":[{"type":0,"value":"Get free trials of "},{"type":1,"value":"productName1"},{"type":0,"value":" & "},{"type":1,"value":"productName2"},{"type":0,"value":" Standard with your "},{"type":1,"value":"purchasedProductName"},{"type":0,"value":" purchase"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.trial-length-message":[{"type":0,"value":"Free "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":"-day trial"}]},"other":{"value":[{"type":7},{"type":0,"value":"-day trial"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":". Cancel anytime."}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.multi-entitlement-with-trial-length.subject":[{"type":0,"value":"Try "},{"type":1,"value":"firstProduct"},{"type":0,"value":" & "},{"type":1,"value":"secondProduct"},{"type":0,"value":" free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.multi-entitlement.subject":[{"type":0,"value":"Try "},{"type":1,"value":"firstProduct"},{"type":0,"value":" & "},{"type":1,"value":"secondProduct"},{"type":0,"value":" free"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.single-entitlement.subject":[{"type":0,"value":"Try "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.advanced-user-project-permissions":[{"type":0,"value":"Advanced user & project permissions"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.advanced-user-space-permissions":[{"type":0,"value":"Advanced user & space permissions"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.custom-project-roles":[{"type":0,"value":"Custom project roles"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.higher-automation-limit":[{"type":0,"value":"Higher automation limit"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.insights-into-page-views":[{"type":0,"value":"Get insights into page views"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.on-call-management":[{"type":0,"value":"On-call management"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.published-views":[{"type":0,"value":"Published views"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.trial-length":[{"type":0,"value":"Free "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":"-day trial"}]},"other":{"value":[{"type":7},{"type":0,"value":"-day trial"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":". Cancel anytime."}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-agents":[{"type":0,"value":"Unlimited agents"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-agents-storage":[{"type":0,"value":"Unlocked agent & storage limits"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-creator-storage":[{"type":0,"value":"Unlocked creator & storage limits"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-creators":[{"type":0,"value":"Unlimited creators"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-user-storage":[{"type":0,"value":"Unlocked user & storage limits"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-users":[{"type":0,"value":"Unlimited users"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.user-project-permissions":[{"type":0,"value":"Advanced user & project permissions"}],"commerce.commerce-marketing-multiple-product-upgrade.email.confluence-logo.alt-text":[{"type":0,"value":"Confluence logo"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-archive.alt-text":[{"type":0,"value":"Icon - Archive"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-check-circle.alt-text":[{"type":0,"value":"Icon - Check circle"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-graph.alt-text":[{"type":0,"value":"Icon - Graph"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-lightning.alt-text":[{"type":0,"value":"Icon - Lightning"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-link.alt-text":[{"type":0,"value":"Icon - Link"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-people.alt-text":[{"type":0,"value":"Icon - People"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-phone.alt-text":[{"type":0,"value":"Icon - Phone"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-unlock.alt-text":[{"type":0,"value":"Icon - Unlock"}],"commerce.commerce-marketing-multiple-product-upgrade.email.jira-logo.alt-text":[{"type":0,"value":"Jira logo"}],"commerce.commerce-marketing-multiple-product-upgrade.email.jpd-logo.alt-text":[{"type":0,"value":"Jira Product Discovery logo"}],"commerce.commerce-marketing-multiple-product-upgrade.email.jsm-logo.alt-text":[{"type":0,"value":"Jira Service Management logo"}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.automatic-removal":[{"type":0,"value":"After "},{"type":1,"value":"uninstallDate"},{"type":0,"value":", no further action will be required from you; the app will be removed automatically."}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.back-up-data":[{"type":0,"value":"Back up or export any data you still need \u2014 data may be lost when the app is removed."}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.caption":[{"type":0,"value":"Final notice: action required"}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.exception-heading":[{"type":0,"value":"If you have an unresolved concern"}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.exception-path":[{"type":0,"value":"If you have an active support commitment, contractual arrangement, or ownership dispute, reply to this email today so we can review before we proceed."}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.find-alternative":[{"type":0,"value":"Migrate to a supported alternative from the "},{"type":1,"value":"marketplaceLink"},{"type":0,"value":" if you still need this capability."}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"firstName"},{"type":0,"value":","}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.introduction":[{"type":0,"value":"This is your final notice. On "},{"type":1,"value":"uninstallDate"},{"type":0,"value":", Atlassian will uninstall the following unsupported app(s) from your Atlassian site ("},{"type":1,"value":"siteName"},{"type":0,"value":" \u2014 "},{"type":1,"value":"siteUrl"},{"type":0,"value":") and access will be removed:"}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.marketplace-link":[{"type":0,"value":"Atlassian Marketplace"}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.recommended-actions-introduction":[{"type":0,"value":"Before "},{"type":1,"value":"uninstallDate"},{"type":0,"value":", please:"}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.retirement-status":[{"type":0,"value":"These apps\u2019 Marketplace listings have been archived or removed and are no longer maintained or supported."}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.signature":[{"type":0,"value":"Thank you,\\\\nThe Atlassian Marketplace team"}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.subject":[{"type":0,"value":"Final notice \u2014 app will be uninstalled on "},{"type":1,"value":"uninstallDate"}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.support":[{"type":0,"value":"If you need help, please "},{"type":1,"value":"supportLink"},{"type":0,"value":"."}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.support-link":[{"type":0,"value":"contact Atlassian Support"}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.affected-apps":[{"type":0,"value":"App(s) affected on your site"}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.app-retirement-status":[{"type":0,"value":" \u2014 Marketplace listing archived or removed"}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.back-up-data":[{"type":0,"value":"Export or back up any data you need from the app."}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.caption":[{"type":0,"value":"Action required"}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.exception-path":[{"type":0,"value":"If you believe this affects you in error, or you have an active support commitment or contractual arrangement tied to this app, please "},{"type":1,"value":"supportLink"},{"type":0,"value":" so we can review your account before any action is taken."}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.find-alternative":[{"type":0,"value":"Identify a supported alternative on the "},{"type":1,"value":"marketplaceLink"},{"type":0,"value":" and migrate if needed."}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"firstName"},{"type":0,"value":","}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.introduction":[{"type":0,"value":"We\u2019re contacting you because one or more apps installed on your Atlassian site ("},{"type":1,"value":"siteName"},{"type":0,"value":" \u2014 "},{"type":1,"value":"siteUrl"},{"type":0,"value":") are tied to Marketplace listings that have been archived or removed by their partner and are no longer maintained or supported."}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.no-support":[{"type":0,"value":"These apps no longer receive updates, fixes, or security patches, and there is no supported version or partner support available."}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.recommended-actions":[{"type":0,"value":"What we recommend you do before "},{"type":1,"value":"uninstallDate"}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.reminder":[{"type":0,"value":"We\u2019ll send you a reminder before the deadline. Thank you for helping us keep your site secure and supported."}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.review-use":[{"type":0,"value":"Review whether the app is still in active use on your site."}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.signature":[{"type":0,"value":"The Atlassian Marketplace team"}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.subject":[{"type":0,"value":"Action needed by "},{"type":1,"value":"uninstallDate"},{"type":0,"value":": an app on your Atlassian site is being retired"}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.support":[{"type":0,"value":"If you need help, please "},{"type":1,"value":"supportLink"},{"type":0,"value":"."}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.support-link":[{"type":0,"value":"contact Atlassian Support"}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.uninstall-action":[{"type":0,"value":"To keep your site secure and supported, Atlassian will remove access to and uninstall these app(s) on "},{"type":1,"value":"uninstallDate"},{"type":0,"value":"."}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.uninstall-early":[{"type":0,"value":"Uninstall the app yourself once you\u2019re ready \u2014 no need to wait for the deadline."}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.what-this-means":[{"type":0,"value":"What this means"}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.already-uninstalled":[{"type":0,"value":"If you\u2019ve already uninstalled it, no further action is needed and you can ignore this message."}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.back-up-data":[{"type":0,"value":"Back up or export any data you need from the app."}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.caption":[{"type":0,"value":"Reminder: action required"}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.exception-heading":[{"type":0,"value":"Need more time or think this is in error?"}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.exception-path":[{"type":0,"value":"If you have an active support commitment, contractual arrangement, or a dispute about ownership of this app, please "},{"type":1,"value":"supportLink"},{"type":0,"value":" so we can review your account before any action is taken."}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.find-alternative":[{"type":0,"value":"Move to a supported alternative \u2014 browse the "},{"type":1,"value":"marketplaceLink"},{"type":0,"value":"."}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"firstName"},{"type":0,"value":","}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.introduction":[{"type":0,"value":"This is a reminder that the following unsupported app(s) on your Atlassian site ("},{"type":1,"value":"siteName"},{"type":0,"value":" \u2014 "},{"type":1,"value":"siteUrl"},{"type":0,"value":") will be uninstalled by Atlassian on "},{"type":1,"value":"uninstallDate"},{"type":0,"value":" because the Marketplace listing has been archived or removed:"}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.marketplace-link":[{"type":0,"value":"Atlassian Marketplace"}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.recommended-actions-introduction":[{"type":0,"value":"Before "},{"type":1,"value":"uninstallDate"},{"type":0,"value":", we recommend you:"}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.signature":[{"type":0,"value":"The Atlassian Marketplace team"}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.still-time":[{"type":0,"value":"There is still time to act."}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.subject":[{"type":0,"value":"Reminder \u2014 app retirement on your Atlassian site on "},{"type":1,"value":"uninstallDate"}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.support":[{"type":0,"value":"If you need help, please "},{"type":1,"value":"supportLink"},{"type":0,"value":"."}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.support-link":[{"type":0,"value":"contact Atlassian Support"}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.uninstall-early":[{"type":0,"value":"Uninstall the app when ready."}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.billing":[{"type":1,"value":"billingUrl"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.faq":[{"type":0,"value":"FAQs"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.migrate":[{"type":0,"value":"You have been successfully migrated from Jira Work Management to Jira, within "},{"type":1,"value":"site"},{"type":0,"value":"."}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.options":[{"type":0,"value":"To view pricing, auto-renewal, and cancellation options, go to "},{"type":1,"value":"billing"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.site":[{"type":1,"value":"siteUrl"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.subsciption":[{"type":0,"value":"The current price of your subscription has not changed. However, pricing may vary if changes are made to your user tier, plan, and/or licensing. See "},{"type":1,"value":"faq"},{"type":0,"value":" for more details."}],"commerce.commerce-migration-jwm-to-jira.message-template.email.caption":[{"type":0,"value":"You\u2019ve been successfully migrated to Jira"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.subject":[{"type":0,"value":"Your migration was successful"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.CMK.encryption-policy-info":[{"type":0,"value":"CMK policy enrollment is required for activation. "},{"type":1,"value":"supportInfo"},{"type":0,"value":" to self-enroll before provisioning Atlassian app instances. For step-by-step instructions, refer to the support "},{"type":1,"value":"CMKSupportUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.CMK.manage-subscription":[{"type":0,"value":"Please click \u2018Manage Subscription\u2019"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.CMK.partner-managed-subscription":[{"type":0,"value":"Please visit your partner-managed subscriptions page"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.CMK.view-subscription":[{"type":0,"value":"Please click \u2018View all Subscriptions\u2019"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"Remember, extra usage charges can now be accrued \u2014 any extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit and added to your next invoice. Don\u2019t worry \u2014 we\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this usage limit or disable extra usage anytime in Atlassian Administration. You can view a detailed breakdown of your team\u2019s usage in your billing account."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.allowance-contributions-enforcement-ubp5":[{"type":0,"value":"Remember, any usage above your allowance may incur extra usage charges, which will be added to your bill at the end of your bill cycle. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.cbp-details":[{"type":0,"value":"Your plan includes:"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.more-information":[{"type":0,"value":"You can visit "},{"type":1,"value":"supportUrl"},{"type":0,"value":" to learn more about how billing works."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.no-payment.expect-final-invoice":[{"type":0,"value":"We\u2019ll send the final invoice within 24 hours, which will include all the details and payment options for your order."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.payment-processing":[{"type":0,"value":"We\u2019re processing your payment and will email the final invoice within 24 hours."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.set-up-your-cloud-site":[{"type":0,"value":"Dive right in and "},{"type":1,"value":"getStartedUrl"},{"type":0,"value":" by setting up your new "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.thanks-for-choosing-atlassian":[{"type":0,"value":"Thanks for choosing Atlassian. We\u2019ve received your order."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.view-subscription":[{"type":0,"value":"You can view your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" details from your "},{"type":1,"value":"hostingDetails"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.button.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.button.view-subscription":[{"type":0,"value":"View all Subscriptions"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.non-cloud.billing-info":[{"type":0,"value":"Go to your billing account to set up your new subscriptions."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct.future-dated-with-date.body.intro":[{"type":0,"value":"You\'ll be able to set up and start using your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\'ll send you a reminder when they\'re ready."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct.future-dated.body.intro":[{"type":0,"value":"You\'ll be able to set up and start using your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription from its start date"}]},"other":{"value":[{"type":0,"value":"subscriptions from their start dates"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":". We\'ll send you a reminder when they\'re ready."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.admin-permission-url":[{"type":0,"value":"how to give users admin permissions"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.atlassian-billing-partner":[{"type":0,"value":"Atlassian billing partner: "}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.atlassian-billing-reseller":[{"type":0,"value":"Atlassian reseller: "}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.give-admin-permission":[{"type":0,"value":"Setting up your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" means you\u2019ll automatically get admin permissions as an org and site admin. You can also give admin roles to others - see "},{"type":1,"value":"giveUserAdminPermissionUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received the order placed by your Atlassian billing partner. The "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription is"}]},"other":{"value":[{"type":0,"value":"subscriptions are"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" now active and ready to use."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.intro.reseller":[{"type":0,"value":"Good news \u2014 we\u2019ve received the order placed by your Atlassian reseller. The "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription is"}]},"other":{"value":[{"type":0,"value":"subscriptions are"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" now active and ready to use."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.manage-reseller":[{"type":0,"value":"You can view or cancel your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" at any time by going to "},{"type":1,"value":"manageSubscriptionUrl"},{"type":0,"value":" and following the steps."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.manage-subscription":[{"type":0,"value":"You can view or cancel "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"the subscription"}]},"other":{"value":[{"type":0,"value":"these subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" from "},{"type":1,"value":"partnerManagedSubscriptionUrl"},{"type":0,"value":" page."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.setup-your-site":[{"type":0,"value":"Get started straight away by setting up your new "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":":"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.site-heading":[{"type":0,"value":"Site: "}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.site-url":[{"children":[{"type":1,"value":"siteURL"}],"type":8,"value":"a"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.button.get-started":[{"type":0,"value":"Get started"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.ecc-reseller-managed-subscription.url":[{"type":0,"value":"your Subscription overview"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.future-dated-with-date.body-ecc.intro.reseller":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian reseller, and the products will be ready for use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.future-dated-with-date.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian billing partner, and the products will be ready for use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.future-dated.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian billing partner, and the products will be ready for use from their start dates. We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.future-dated.body.intro.reseller":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian reseller, and the products will be ready for use from their start dates. We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.partner-managed-subscription.url":[{"type":0,"value":"your partner-managed subscriptions"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.subject":[{"type":1,"value":"billToPartyName"},{"type":0,"value":": Atlassian product order confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.allowance-contributions-enforcement-ubp5":[{"type":0,"value":"Remember, any usage above the allowance may incur extra usage charges, which will be added to your customer\u2019s bill at the end of the bill cycle. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.auto_prov_notification":[{"type":0,"value":"The products will be added to your customer\u2019s account shortly."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.cbp-details":[{"type":0,"value":"The plan also includes the following:"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.customer_contact_info":[{"type":0,"value":"Your customer contact can view or cancel "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"this subscription"}]},"other":{"value":[{"type":0,"value":"these subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" at any time."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.get-started":[{"type":0,"value":"You can get started straight away by setting up the subscriptions. We\u2019ve also sent a notification to your customer with a setup link to get started. "}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.intro":[{"type":0,"value":"Thanks for choosing Atlassian. We\u2019ve received your order."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.manage-subscription":[{"type":0,"value":"You can manage "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"this subscription"}]},"other":{"value":[{"type":0,"value":"these subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" from our "},{"type":1,"value":"ppcHomePage"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.next_steps_invoice_info":[{"type":0,"value":"We\u2019ll email the invoice with all the details within 24 hours."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.next_steps_notification":[{"type":0,"value":"We\u2019ll also send a notification to your customer with a link to set up their new "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" and get started."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.rovo-dev-credits-usage-details":[{"type":0,"value":"Remember, extra usage charges can now be accrued \u2014 any extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit and added to the next invoice. We\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this usage limit or disable extra usage anytime in Atlassian Administration."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.rovo-dev-details":[{"type":0,"value":"We\u2019ll send you an invoice with all the details within 24 hours. We\u2019ll also send an email to your customer with a link to set up and get started with their new subscription. You can get started straight away by setting up the subscriptions."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.button.get-started":[{"type":0,"value":"Get started"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.future-dated-with-date.body.intro":[{"type":0,"value":"Thanks for choosing Atlassian. We\u2019ve received your order, and the products will be ready to use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder to your customer when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.future-dated.body.intro":[{"type":0,"value":"Thanks for choosing Atlassian. We\'ve received your order, and the products will be ready for use from their start dates. We\u2019ll send a reminder to your customer when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": Order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.remaining-subs":[{"type":0,"value":"+ "},{"type":1,"value":"remainingCount"},{"type":0,"value":" more subscriptions."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.twc-offer.cta.explore":[{"type":0,"value":"Explore Teamwork collection"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.twc-offer.price-decrease.title":[{"type":0,"value":"Want to pay less for your subscription?"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.twc-offer.price-increase.title":[{"type":0,"value":"Try new apps for free with Teamwork Collection"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.twc-offer.row.one.description":[{"type":0,"value":"of apps, Jira, Confluence, Loom, and Rovo"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.twc-offer.row.one.title":[{"type":0,"value":"One collection"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.twc-offer.row.three.description":[{"type":0,"value":"without losing any work"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.twc-offer.row.three.title":[{"type":0,"value":"Switch back anytime"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.twc-offer.row.two.description":[{"type":0,"value":"for daily use"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.twc-offer.row.two.title":[{"type":0,"value":"More AI credits"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.future.date.reminder":[{"type":0,"value":"You\'ll be able to set up and start using your subscriptions from their start dates. We\'ll send you a reminder when they\'re ready."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.future.with.date.reminder":[{"type":0,"value":"You\'ll be able to set up and start using your subscription/s on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\'ll send you a reminder when they\'re ready."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.more-information":[{"type":0,"value":"For more information on how to manage your subscriptions and billing, visit "},{"type":1,"value":"supportUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.no-payment.expect-final-invoice":[{"type":0,"value":"Expect the final invoice within 24 hours, which will include all the necessary details and payment options for your order."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.payment-processing":[{"type":0,"value":"We\u2019re processing your payment and will email the final invoice within 24 hours."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.set-up-your-cloud-site":[{"type":0,"value":"Dive right in and "},{"type":1,"value":"getStartedUrl"},{"type":0,"value":" by setting up your cloud site for your new subscription."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.thanks-for-choosing-atlassian":[{"type":0,"value":"Thanks for choosing Atlassian. We\u2019ve received your order."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.view-subscription":[{"type":0,"value":"You can view your subscription details from your site\u2019s "},{"type":1,"value":"siteAdmin"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.button.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.button.view-subscription":[{"type":0,"value":"View all Subscriptions"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your Atlassian order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" is confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.body.atlassian-billing-partner":[{"type":0,"value":"Atlassian billing partner: "}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.body.intro":[{"type":0,"value":"Good news \u2013 we\u2019ve received your order for:"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.body.subscription-list-title":[{"type":0,"value":"Subscription list:"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.future-date.subject":[{"type":1,"value":"partnerName"},{"type":0,"value":": Order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.future-dated-with-date.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian billing partner, and the products will be ready for use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.future-dated.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian billing partner, and the products will be ready for use from their start dates. We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.partner-manage-subscriptions":[{"type":0,"value":"You can view the subscription from "},{"type":1,"value":"partnerManagedSubscriptionUrl"},{"type":0,"value":" page."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.partner-managed-subscription.url":[{"type":0,"value":"your partner-managed subscriptions"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.intro":[{"type":0,"value":"Good news \u2013 we\u2019ve received your order for:"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.next_steps":[{"type":0,"value":"Get started by setting up your customer\u2019s cloud site for the new subscription."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.ppc_homepage":[{"type":0,"value":" You can also view and manage the subscription details from our Partner Purchasing Center. "},{"type":1,"value":"viewQuoteUrl"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.processing":[{"type":0,"value":"We\u2019re processing the payment and will email the final invoice within 24 hours."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.subscription-list-title":[{"type":0,"value":"Subscription list:"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.future-date.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": Order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.future-dated-with-date.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received your order, and the products will be ready for use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder to your customer when they are active."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.future-dated.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received your order, and the products will be ready for use from their start dates. We\u2019ll send a reminder to your customer when they are active."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.subject":[{"type":0,"value":"We\u2019ve received your order for "},{"type":1,"value":"customerCompanyName"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.remaining-subs":[{"type":0,"value":"+ "},{"type":1,"value":"remainingCount"},{"type":0,"value":" more subscriptions."}],"commerce.commerce-order-fulfilled-from-quote-no-payment-method-ccp.message-template.email.subject":[{"type":0,"value":"This template has been deprecated"}],"commerce.commerce-order-fulfilled-from-quote-no-payment-method-ccp.message.email.body.no-translate":[{"type":0,"value":"This template has been deprecated as it has been merged along with \'commerce-quote-order-fulfilled-ccp\' template with dynamic content added to differentiate between pull/push payment method."}],"commerce.commerce-partner-cancellation-personal-data-deletion-link":[{"type":0,"value":"personal data deletion request form"}],"commerce.commerce-partner-personal-data-deletion":[{"type":0,"value":"If your customer would like to place a request for immediate deletion of personal data after cancellation, they can submit a "},{"type":1,"value":"formLink"},{"type":0,"value":". Otherwise, the data will be deleted in accordance with Atlassian\u2019s standard "},{"type":1,"value":"policyLink"},{"type":0,"value":"."}],"commerce.commerce-payment-confirmation-generic-email-ccp.email.direct.caption":[{"type":0,"value":"Your payment has been processed"}],"commerce.commerce-payment-confirmation-generic-email-ccp.email.direct.confirm":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\'ve received your payment for the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":". The invoice is attached as a PDF for your records."}],"commerce.commerce-payment-confirmation-generic-email-ccp.email.partner-or-reseller.caption":[{"type":0,"value":"Your payment has been processed"}],"commerce.commerce-payment-confirmation-generic-email-ccp.email.partner-or-reseller.confirm":[{"type":0,"value":"This email is to confirm we have received payment for the following invoice:"}],"commerce.commerce-payment-confirmation-generic-email-ccp.message-template.email.direct.subject":[{"type":0,"value":"Your payment has been processed for the invoice "},{"type":1,"value":"invoiceNumber"}],"commerce.commerce-payment-confirmation-generic-email-ccp.message-template.email.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce.commerce-payment-confirmation-generic-email-ccp.message-template.email.partner-or-reseller.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Payment processed"}],"commerce.commerce-payment-method-manage-ccp.account-ending-key":[{"type":0,"value":"Account ending: "}],"commerce.commerce-payment-method-manage-ccp.account-ending-value":[{"type":1,"value":"last4"}],"commerce.commerce-payment-method-manage-ccp.account-holder-name-key":[{"type":0,"value":"Account holder name: "}],"commerce.commerce-payment-method-manage-ccp.account-holder-name-value":[{"type":1,"value":"accountHolder"}],"commerce.commerce-payment-method-manage-ccp.authorization-date-key":[{"type":0,"value":"Authorization date: "}],"commerce.commerce-payment-method-manage-ccp.authorization-date-value":[{"type":1,"value":"authorizationDate"}],"commerce.commerce-payment-method-manage-ccp.authorization-details":[{"type":0,"value":"Authorization details"}],"commerce.commerce-payment-method-manage-ccp.bank-name-key":[{"type":0,"value":"Bank name: "}],"commerce.commerce-payment-method-manage-ccp.bank-name-value":[{"type":1,"value":"bankName"}],"commerce.commerce-payment-method-manage-ccp.caption.direct-debit-authorization":[{"type":0,"value":"Direct debit authorization"}],"commerce.commerce-payment-method-manage-ccp.caption.direct-debit-dispute":[{"type":0,"value":"Update payment details to continue subscription"}],"commerce.commerce-payment-method-manage-ccp.caption.flex-wallet-active":[{"type":0,"value":"Your wallet is active"}],"commerce.commerce-payment-method-manage-ccp.could-not-process-payment":[{"type":0,"value":"We couldn\'t process your recent payment due to a dispute raised with your bank."}],"commerce.commerce-payment-method-manage-ccp.direct-debit-legal-terms":[{"type":0,"value":"You have authorized Atlassian to debit the bank account specified above for any amount owed for charges arising from your use of Atlassian\u2019 services and/or purchase of products from Atlassian, pursuant to Atlassian\u2019 website and terms, until this authorization is revoked. You have authorized Atlassian to debit your bank account periodically if and when you use Atlassian\u2019 services or purchase more than one of Atlassian\u2019 products periodically pursuant to Atlassian terms. Payments that fall outside the regular debits authorized above will only be debited after your authorization is obtained."}],"commerce.commerce-payment-method-manage-ccp.email.subject.ach-direct-debit-mandate":[{"type":0,"value":"Confirmation: Direct debit authorization"}],"commerce.commerce-payment-method-manage-ccp.email.subject.flex-wallet-active":[{"type":0,"value":"Your Atlassian wallet is active"}],"commerce.commerce-payment-method-manage-ccp.flex-contact-us":[{"type":0,"value":"Contact us"}],"commerce.commerce-payment-method-manage-ccp.flex-view-wallet-details":[{"type":0,"value":"View your Wallet details"}],"commerce.commerce-payment-method-manage-ccp.flex-wallet-active-intro":[{"type":0,"value":"Thanks for choosing Atlassian. Your wallet is now active, and the Atlassian subscriptions linked to your wallet will bill against it from your next billing cycle."}],"commerce.commerce-payment-method-manage-ccp.flex-wallet-no-separate-payment":[{"type":0,"value":"Charges for these subscriptions are paid from your wallet, so no separate payment is required from you."}],"commerce.commerce-payment-method-manage-ccp.flex-wallet-question":[{"type":0,"value":"Have a question about your wallet? Your Atlassian account team is here to help. "},{"type":1,"value":"contactUs"}],"commerce.commerce-payment-method-manage-ccp.how-to-cancel-direct-debit":[{"type":0,"value":"You can cancel this direct debit at any time by deleting the linked bank account from your "},{"type":1,"value":"paymentMethods"},{"type":0,"value":" page"}],"commerce.commerce-payment-method-manage-ccp.payment-methods":[{"type":0,"value":"Payment methods"}],"commerce.commerce-payment-method-manage-ccp.received-authorization":[{"type":0,"value":"We\u2019ve received your authorization for direct debit."}],"commerce.commerce-payment-method-manage-ccp.routing-number-key":[{"type":0,"value":"Routing number: "}],"commerce.commerce-payment-method-manage-ccp.routing-number-value":[{"type":1,"value":"routingNumber"}],"commerce.commerce-payment-method-manage-ccp.update-bank-details":[{"type":0,"value":"Update your bank account details, or link a different bank account. For monthly subscriptions, we don\u2019t accept bank transfers."}],"commerce.commerce-permission-request-add-payment-ccp.message-template.email.subject":[{"type":0,"value":"Action needed: You have an add payment request"}],"commerce.commerce-permission-request-add-payment-response-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Request complete: Payment details added by billing admin "}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.cta.accept-billing-admin-request":[{"type":0,"value":"Review billing admin request"}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.feature.manage-payment-method":[{"type":0,"value":"Manage payment methods and addresses"}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.feature.receive-emails":[{"type":0,"value":"Receive emails about products, billing and orders"}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.feature.view-and-manage":[{"type":0,"value":"View and manage all subscriptions in your account"}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.feature.view-and-manage-invoices":[{"type":0,"value":"View and manage invoices and quotes"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.account-name":[{"type":1,"value":"transactionAccountName"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.account-number":[{"type":1,"value":"transactionAccountNumber"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.ba-request-text":[{"type":1,"value":"name"},{"type":0,"value":" ("},{"type":1,"value":"email"},{"type":0,"value":") is requesting billing admin permission for the following account: "}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.begin-quotes.no-translate":[{"type":0,"value":"\u275D "}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.end-quotes.no-translate":[{"type":0,"value":" \u275E"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.personal-note.no-translate":[{"type":1,"value":"customMessage"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.subtext-for-personal-note":[{"type":0,"value":"The request was sent with the following note: "}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.title":[{"type":1,"value":"name"},{"type":0,"value":" is requesting billing admin access"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.total-entitlements":[{"type":1,"value":"totalEntitlements"},{"type":0,"value":" subscriptions"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.what-they-can-do":[{"type":0,"value":"If you approve, they\'ll be able to:"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.whats-next-subtext":[{"type":0,"value":"If you accept the request, we\'ll notify the requester. If you don\'t want to grant billing admin access, you can decline the request."}],"commerce.commerce-permission-request-grant-ba-role-ccp.message-template.email.subject":[{"type":0,"value":"Action needed: "},{"type":1,"value":"requesterName"},{"type":0,"value":" is requesting Billing admin access"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.cta.manageSubscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.manage-payment-method":[{"type":0,"value":"Manage payment methods and addresses"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.receive-emails":[{"type":0,"value":"Receive emails about products, billing and orders"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.receive-emails-for-changes":[{"type":0,"value":"Receive emails about any changes"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.request-billing-admin":[{"type":0,"value":"Request billing admins to make changes to subscriptions"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.view-and-manage":[{"type":0,"value":"View and manage all subscriptions in your account"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.view-and-manage-invoices":[{"type":0,"value":"View and manage invoices and quotes"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.view-and-manage-site":[{"type":0,"value":"View, upgrade, downgrade and cancel subscriptions in your site"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.account-name":[{"type":1,"value":"transactionAccountName"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.account-number":[{"type":1,"value":"transactionAccountNumber"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.ba-approved-text":[{"type":0,"value":"Great news - your billing admin request has been approved for the following account: "}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.ba-declined-text":[{"type":0,"value":"Your request to become a billing admin on the following account has been declined."}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.title-approved":[{"type":0,"value":"You\'re now a billing admin"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.title-declined":[{"type":0,"value":"Your billing admin request has been declined"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.total-entitlements":[{"type":1,"value":"totalEntitlements"},{"type":0,"value":" subscriptions"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.what-you-get":[{"type":0,"value":"You\'ll now be able to:"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.what-you-get-without-access":[{"type":0,"value":"You\'ll still be able to:"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.message-template.email.subject.approved":[{"type":0,"value":"Your billing admin request has been approved"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.message-template.email.subject.declined":[{"type":0,"value":"Your billing admin request has been declined"}],"commerce.commerce-pre-comms-sp-add-on-merge-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Important information about your Statuspage add-ons"}],"commerce.commerce-pre-dunning-ccp.mpucup.email.body-text":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" Standard "},{"children":[{"type":0,"value":"trial has ended."}],"type":8,"value":"strong"},{"type":0,"value":" You\'re currently over the 10-user limit for our Free plan. Add payment details now to keep your team active - otherwise, your team will lose access to "},{"type":1,"value":"productName"},{"type":0,"value":" and your data will be permanently deleted."}],"commerce.commerce-pre-dunning-ccp.mpucup.email.body-text-within-limit":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" Standard "},{"children":[{"type":0,"value":"trial has ended."}],"type":8,"value":"strong"},{"type":0,"value":" Add payment details now to keep your team on Standard - otherwise, your team will lose access to some "},{"type":1,"value":"productName"},{"type":0,"value":" features and be downgraded to the Free plan."}],"commerce.commerce-pre-dunning-ccp.mpucup.email.heading":[{"type":0,"value":"Last chance to keep your "},{"type":1,"value":"productName"},{"type":0,"value":" site and data"}],"commerce.commerce-pre-dunning-ccp.mpucup.email.not-ready-heading":[{"type":0,"value":"Not ready to upgrade?"}],"commerce.commerce-pre-dunning-ccp.mpucup.email.subject":[{"type":0,"value":"Last chance to keep your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription"}],"commerce.commerce-pre-dunning-ccp.mpucup.email.switch-back-to-free-admin":[{"type":0,"value":"You can switch back to a Free plan by "},{"children":[{"type":0,"value":"reducing your user count"}],"type":8,"value":"link"},{"type":0,"value":" to 10 or fewer."}],"commerce.commerce-pre-dunning-ccp.mpucup.email.switch-back-to-free-non-admin":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" admin can switch back to a Free plan by reducing your user count to 10 or fewer."}],"commerce.commerce-pre-dunning-ccp.v2.email.contact-us":[{"type":0,"value":"Please "},{"type":1,"value":"contactUs"},{"type":0,"value":" with any questions, we\'re always happy to help."}],"commerce.commerce-pre-dunning-ccp.v2.email.greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"firstName"},{"type":0,"value":","}],"commerce.commerce-pre-dunning-ccp.v2.email.total-bill":[{"type":0,"value":"Your total estimated bill is "},{"type":1,"value":"amount"},{"type":0,"value":" (excludes tax)"}],"commerce.commerce-quote-expired-ccp.email.caption":[{"type":0,"value":"Your quote has expired"}],"commerce.commerce-quote-expired-ccp.email.contact-us":[{"type":0,"value":"Contact us"}],"commerce.commerce-quote-expired-ccp.email.ready-to-order":[{"type":0,"value":"If you\u2019d like to try Atlassian products, opt for a free trial."}],"commerce.commerce-quote-expired-ccp.email.reminder-before-expiry":[{"type":0,"value":"Your quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" has expired. You\u2019ll no longer be able to pay for it."}],"commerce.commerce-quote-expired-ccp.email.view-quote":[{"type":0,"value":"You can always create a new quote by reaching out to us."}],"commerce.commerce-quote-expired-ccp.message-template.email.subject":[{"type":0,"value":"Your Atlassian quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" has expired"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"It\u2019s time to renew your subscription"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.direct-customer.request-quote-to-avoid-losing-access":[{"type":0,"value":"To avoid losing access to your products, request a quote that is valid until the end of your billing cycle. When you are ready to pay, simply review the quote and place your order. "}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.list-subscriptions":[{"type":0,"value":"Subscriptions list:"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.partner.caption":[{"type":0,"value":"It\u2019s time to renew"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.partner.subject.with-customer-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" : Request quote to renew subscription"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.reach-out-to-create-quote":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.request-quote-to-avoid-customer-losing-access":[{"type":0,"value":"To avoid losing access to the products, request a quote valid until the end of your billing cycle. When your customer is ready to pay, they can simply review the quote and place an order."}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.subject":[{"type":0,"value":"Request quote to renew subscription"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.subscriptions-are-expiring":[{"type":0,"value":"Just a heads up that you have subscriptions that are approaching their end date, so it\u2019s time to renew."}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.subscriptions-are-expiring-for-customer-company":[{"type":0,"value":"Just a heads up that you have subscriptions for "},{"type":1,"value":"customerCompanyName"},{"type":0,"value":" that are approaching their end date, so it\u2019s time to renew."}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.direct-customer.body.reach-us":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.direct-customer.body.request-a-quote-message":[{"type":0,"value":"You\u2019re on a free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") that ends on "},{"type":1,"value":"quoteEndDate"},{"type":0,"value":". To avoid losing access to your product after the trial ends, request a quote valid until the trial expiry date. When you are ready to pay simply review the quote and place your order."}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.direct-customer.caption":[{"type":0,"value":"Create a quote for your trial"}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.direct-customer.subject":[{"type":0,"value":"Request quote for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partner.body.request-a-quote-message":[{"type":0,"value":"The free trial trial of Confluence Premium ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") subscription for "},{"type":1,"value":"customerCompanyName"},{"type":0,"value":" ends on "},{"type":1,"value":"quoteEndDate"},{"type":0,"value":". To avoid losing access to the product after the trial ends, request a quote that\u2019s valid until the trial expiry date. When your customer is ready to pay, they can simply review the quote and place an order."}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partner.caption":[{"type":0,"value":"Create a quote for subscription trial "}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partner.subject.with-customer-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : Request a quote"}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partner.subject.without-customer-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : Request a quote"}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partners.body.reach-us":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.direct-customer.body.reach-us":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.direct-customer.body.request-a-quote-message":[{"type":0,"value":"You\u2019re on a free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") that ends on "},{"type":1,"value":"quoteEndDate"},{"type":0,"value":". To avoid losing access to your product after the trial ends, request a quote valid until the trial expiry date. When you are ready to pay simply review the quote and place your order."}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Create a quote for your trial"}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Request quote for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partner.body.request-a-quote-message":[{"type":0,"value":"The free trial trial of Confluence Premium ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") subscription for "},{"type":1,"value":"customerCompanyName"},{"type":0,"value":" ends on "},{"type":1,"value":"quoteEndDate"},{"type":0,"value":". To avoid losing access to the product after the trial ends, request a quote that\u2019s valid until the trial expiry date. When your customer is ready to pay, they can simply review the quote and place an order."}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partner.caption":[{"type":0,"value":"Create a quote for subscription trial "}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partner.subject.with-customer-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : Request a quote"}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partner.subject.without-customer-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : Request a quote"}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partners.body.reach-us":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.caption":[{"type":0,"value":"We\'ve updated your quote billing period"}],"commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.ppc-homepage":[{"type":0,"value":"You can also view the quote from our "},{"children":[{"type":0,"value":"Partner Purchasing Center."}],"type":8,"value":"RawLink"}],"commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" quote billing period change"}],"commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.updated-quote-body":[{"type":0,"value":"We\'ve updated the quote billing period for "},{"type":1,"value":"quoteNumber"},{"type":0,"value":". This is because there was a change to the subscription plan, user tier or billing cycle since the quote was created, which changed the start date for one or more items on the quote."}],"commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.valid-until":[{"type":0,"value":"The quote is valid until "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". To view the updated details, select \'View quote\' and download the PDF."}],"commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.caption":[{"type":0,"value":"We\'ve updated your quote"}],"commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.estimates-changed":[{"type":0,"value":"Changing the billing period has changed how we calculate the quote total, which means that the quote total has now been updated."}],"commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.ppc-homepage":[{"type":0,"value":"You can also view the quote from our "},{"children":[{"type":0,"value":"Partner Purchasing Center."}],"type":8,"value":"RawLink"}],"commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" quote billing period and total change"}],"commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.updated-quote-body":[{"type":0,"value":"We\'ve updated the quote billing period and quote total for "},{"type":1,"value":"quoteNumber"},{"type":0,"value":". This is because there was a change to the subscription plan, user tier or billing cycle since the quote was created, which changed the start date for one or more items on the quote."}],"commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.valid-until":[{"type":0,"value":"The quote is valid until "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". To view the updated details, select \'View quote\' and download the PDF."}],"commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.caption":[{"type":0,"value":"We\'ve updated your quote total"}],"commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.ppc-homepage":[{"type":0,"value":"You can also view the quote from our "},{"children":[{"type":0,"value":"Partner Purchasing Center."}],"type":8,"value":"RawLink"}],"commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" quote total change"}],"commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.updated-quote":[{"type":0,"value":"We\'ve updated the quote total for "},{"type":1,"value":"quoteNumber"},{"type":0,"value":". This is because the billing address or sold-to address or subscription\'s user count linked to the quote was updated since the quote was created, which changes how we estimate the quote total."}],"commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.valid-until":[{"type":0,"value":"The quote is valid until "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". To view the updated details, select \'View quote\' and download the PDF."}],"commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-auto-fix-estimate.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"commerce.commerce-quote-open-auto-fix-estimate.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"commerce.commerce-quote-open-auto-fix-estimate.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-quote-open-auto-fix-estimate.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"commerce.commerce-quote-open-auto-fix-estimate.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"commerce.commerce-quote-open-auto-fix-estimate.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"commerce.commerce-quote-open-auto-fix-estimate.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"commerce.commerce-quote-open-auto-renewal-ccp.ecc.partner.caption":[{"type":0,"value":"It\u2019s time to renew "}],"commerce.commerce-quote-open-auto-renewal-ccp.ecc.partner.get-in-touch":[{"type":0,"value":"Get in touch with your Atlassian Billing Partner to get started on your renewal. They\u2019ll be able to help you with your quote and any next steps."}],"commerce.commerce-quote-open-auto-renewal-ccp.ecc.partner.let-you-know":[{"type":0,"value":"We hope you\u2019ve been enjoying your Atlassian products. We wanted to let you know that your subscription/s expire soon, so it\u2019s time to renew."}],"commerce.commerce-quote-open-auto-renewal-ccp.ecc.partner.what-you-need-to-do":[{"type":0,"value":"What do I need to do?"}],"commerce.commerce-quote-open-auto-renewal-ccp.message-template.email.ecc.subject":[{"type":0,"value":"Contact your Atlassian Billing Partner to renew "}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.caption":[{"type":0,"value":"Renew your subscription"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.partner.caption":[{"type":0,"value":"It\'s time to renew your subscription"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.partner.create-order":[{"type":0,"value":"When your customer is ready to convert the quote to an order, proceed to pay and confirm the order. You can also head to our Partner Purchasing Center to create an order. "},{"children":[{"type":0,"value":"Learn more"}],"type":8,"value":"learnMoreLink"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.partner.create-order-title":[{"type":0,"value":"To create an order"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.partner.intro":[{"type":0,"value":"Hi, "},{"children":[],"type":8,"value":"br"},{"type":0,"value":"Just a heads up that the subscription for "},{"type":1,"value":"companyName"},{"type":0,"value":" expires soon and is ready to be renewed. To review the subscription details and the cost, we\'ve created a quote that\'s valid until the end of your customer\'s billing cycle."}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.partner.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.quote-created":[{"type":0,"value":"This is a friendly reminder that you have subscriptions up for renewal on "},{"children":[{"type":1,"value":"renewalDate"}],"type":8,"value":"b"},{"type":0,"value":". To review your subscription details and assess the cost, we\'ve created a quote("},{"type":1,"value":"quoteNumber"},{"type":0,"value":") that\'s valid until the end of your current billing cycle. To view the details, download the attached quote PDF."}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.ready-to-pay":[{"children":[{"type":0,"value":"Ready to pay?"}],"type":8,"value":"b"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.reseller.create-order":[{"type":0,"value":"When your customer is ready to convert the quote to an order, proceed to pay and confirm the order. "},{"children":[{"type":0,"value":"Learn more"}],"type":8,"value":"learnMoreLink"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.view-details":[{"type":0,"value":"When you\'re ready to renew your subscription, access the quote from the "},{"children":[{"type":0,"value":"Quotes"}],"type":8,"value":"b"},{"type":0,"value":" page of your "},{"children":[{"type":0,"value":"billing account"}],"type":8,"value":"billingLink"},{"type":0,"value":" and place an order."}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.what-happens-answer":[{"type":0,"value":"Your subscription will be canceled, unless you renew for the next billing cycle."}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.what-happens-question":[{"children":[{"type":0,"value":"What happens after my current billing cycle ends?"}],"type":8,"value":"b"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.message-template.email.subject.direct":[{"type":0,"value":"Renew now: your subscription expires soon"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.message-template.email.subject.partner":[{"type":0,"value":"Quote created for "},{"type":1,"value":"companyName"},{"type":0,"value":" ("},{"type":1,"value":"quoteNumber"},{"type":0,"value":")"}],"commerce.commerce-quote-open-auto-trial-ccp.email.caption":[{"type":0,"value":"Your quote is ready"}],"commerce.commerce-quote-open-auto-trial-ccp.email.place-order":[{"type":0,"value":"Ready to start your paid subscription? Simply review the quote and place your order."}],"commerce.commerce-quote-open-auto-trial-ccp.email.quote-created":[{"type":0,"value":"We\'ve created a quote for your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"edition"},{"type":0,"value":" trial ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":"), to help you assess if it\'s the right plan for you. The quote is valid until your trial ends on "},{"children":[{"type":1,"value":"trialExpiry"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-quote-open-auto-trial-ccp.email.reminder":[{"type":0,"value":"Just a reminder \u2013 be sure to order before your trial ends to avoid losing access to your product."}],"commerce.commerce-quote-open-auto-trial-ccp.email.view-details":[{"type":0,"value":"To view the details, download the attached quote PDF or go to the "},{"children":[{"type":0,"value":"Quotes"}],"type":8,"value":"b"},{"type":0,"value":" page of your "},{"children":[{"type":0,"value":"billing account"}],"type":8,"value":"billingLink"},{"type":0,"value":"."}],"commerce.commerce-quote-open-auto-trial-ccp.email.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-auto-trial-ccp.message-template.email.subject":[{"type":0,"value":"Quote created: "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"edition"},{"type":0,"value":" trial ("},{"type":1,"value":"quoteNumber"},{"type":0,"value":")"}],"commerce.commerce-quote-open-ccp.email.contract-type-non-standard":[{"type":0,"value":"When you\'re ready to convert the quote to an order, contact your customer advocate."}],"commerce.commerce-quote-open-ccp.email.contract-type-standard":[{"type":0,"value":"When you\'re ready to convert the quote to an order, go to the quote in your billing account and proceed to create an order."}],"commerce.commerce-quote-open-ccp.email.direct-customer":[{"type":0,"value":"Your quote ("},{"type":1,"value":"quoteNumber"},{"type":0,"value":") is ready and will be valid until "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". To view the details of the quote, download the attached PDF or go to your site\'s "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"},{"type":0,"value":" at "},{"children":[{"type":0,"value":"admin.atlassian.com/billing"}],"type":8,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-quote-open-ccp.email.direct-customer-caption":[{"type":0,"value":"Here\u2019s the quote you requested"}],"commerce.commerce-quote-open-ccp.email.direct-customer-quote-open":[{"type":0,"value":"Your quote ("},{"type":1,"value":"quoteNumber"},{"type":0,"value":") is ready and will be valid until "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". To view the details of the quote, download the attached PDF or go to your site\'s "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"},{"type":0,"value":" at "},{"children":[{"type":1,"value":"billingUrlText"}],"type":8,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-quote-open-ccp.email.direct-customer-quote-open-reminder":[{"type":0,"value":"Keep in mind, if you have product trials in the quote, we recommend placing your order before the trial ends. If you need more time, "},{"children":[{"type":0,"value":"reach out to us"}],"type":8,"value":"RawLink"},{"type":0,"value":" to extend your quote validity."}],"commerce.commerce-quote-open-ccp.email.manage-subscription":[{"type":0,"value":"You can view subscription and billing details on your "},{"children":[{"type":0,"value":"Manage Subscriptions"}],"type":8,"value":"RawLink"},{"type":0,"value":" page."}],"commerce.commerce-quote-open-ccp.email.partner-or-reseller-caption":[{"type":0,"value":"Here\u2019s the quote you requested"}],"commerce.commerce-quote-open-ccp.email.partner-or-reseller-quote-open":[{"type":0,"value":"Good news \u2013 the quote you requested is now ready:"}],"commerce.commerce-quote-open-ccp.email.partner-or-reseller-quote-open-details":[{"type":0,"value":"The quote will be valid until "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". To view the details, select \u2018View quote\u2019 and download the PDF."}],"commerce.commerce-quote-open-ccp.email.partner-or-reseller-view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-ccp.email.partner-ppc-homepage":[{"type":0,"value":"You can also view quotes and manage these subscriptions from our Partner Purchasing Center. "},{"children":[{"type":0,"value":"Learn more"}],"type":8,"value":"RawLink"}],"commerce.commerce-quote-open-ccp.email.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-ccp.message-template.email.subject.direct":[{"type":0,"value":"Your Atlassian quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" is here!"}],"commerce.commerce-quote-open-ccp.message-template.email.subject.partner-or-reseller":[{"type":1,"value":"companyName"},{"type":0,"value":" quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" is ready"}],"commerce.commerce-quote-reminder-expiry-ccp.email.administration":[{"type":0,"value":"Administration"}],"commerce.commerce-quote-reminder-expiry-ccp.email.caption":[{"type":0,"value":"Your quote will expire soon"}],"commerce.commerce-quote-reminder-expiry-ccp.email.order-in-bac":[{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":" and create an order."}],"commerce.commerce-quote-reminder-expiry-ccp.email.ready-to-order":[{"type":0,"value":"When you\u2019re ready to convert your quote to an order, go to your site\'s "}],"commerce.commerce-quote-reminder-expiry-ccp.email.reminder-before-expiry":[{"type":0,"value":"This is a friendly reminder that your quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" will expire on "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". Once expired, the quote will be canceled and you have to create a new one."}],"commerce.commerce-quote-reminder-expiry-ccp.email.view-quote":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-reminder-expiry-ccp.message-template.email.subject":[{"type":0,"value":"Your Atlassian quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" will expire soon"}],"commerce.commerce-quote-stale-ccp.email.body":[{"type":0,"value":"Just a heads up that your quote for "},{"type":1,"value":"companyName"},{"type":0,"value":" needs to be updated before it can be moved back to OPEN."}],"commerce.commerce-quote-stale-ccp.email.caption":[{"type":0,"value":"Your quote needs to be reviewed"}],"commerce.commerce-quote-stale-ccp.email.update-line-item":[{"type":0,"value":"Head to the effected line item/s on the quote and follow the prompts from the error to update it. If that doesn\'t work, you\'ll need to raise a GSAC ticket so that an Atlassian Customer Advocate can look into it."}],"commerce.commerce-quote-stale-ccp.message-template.email.subject":[{"type":0,"value":"Action required: "},{"type":1,"value":"companyName"},{"type":0,"value":" quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" needs review"}],"commerce.commerce-reactivation-order-to-paid-ccp.email.body.caption":[{"type":0,"value":" Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been successfully reactivated"}],"commerce.commerce-reactivation-order-to-paid-ccp.email.body.great-news":[{"type":0,"value":"Great news - you\u2019re now on a "},{"type":1,"value":"newPricingPlanName"},{"type":0,"value":", "},{"type":1,"value":"productName"},{"type":0,"value":" subscription."}],"commerce.commerce-reactivation-order-to-paid-ccp.email.body.we-will-charge":[{"type":0,"value":"We\u2019ll charge your chosen payment method and send you an invoice within 24 hours."}],"commerce.commerce-reactivation-order-to-paid-ccp.email.body.welcome-back":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription ("},{"type":1,"value":"entNumber"},{"type":0,"value":")"}],"commerce.commerce-reactivation-order-to-paid-ccp.personal-information":[{"type":0,"value":"Since you reactivated your subscription within 60 days of cancellation, your data and preferences\\n                    are as you left them. You can jump right in and get started!"}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.cannot-be-refunded":[{"type":0,"value":"Please note that this balance can\'t be refunded or exchanged for cash."}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.caption":[{"type":0,"value":"Your Service Credits adjustment has been processed"}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.direct.completed":[{"type":0,"value":"We have successfully processed your request for SLA Compensation. You are entitled to receive Service Credits, as per our service level commitment. These credits will be added to your account balance and will be used in future invoices."}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.direct.subject":[{"type":0,"value":"Your Service Credits adjustment has been processed"}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.direct.terms":[{"type":0,"value":"Service Credits are applied to your account governed by the terms in "},{"type":1,"value":"slaLink"},{"type":0,"value":". To read more about Service Credits, click "},{"type":1,"value":"hereLink"},{"type":0,"value":"."}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.here-link-text":[{"type":0,"value":"here"}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.partner-or-reseller.completed":[{"type":0,"value":"We\'ve successfully processed a request for SLA Compensation. You\'re entitled to receive Service Credits, as per our service level commitment. These credits will be added to your account balance and used in future invoices."}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.partner-or-reseller.subject":[{"type":1,"value":"companyName"},{"type":0,"value":": Your Service Credits adjustment has been processed"}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.partner-or-reseller.terms":[{"type":0,"value":"Service Credits are applied to your account governed by the terms in "},{"type":1,"value":"slaLink"},{"type":0,"value":". Read more about "},{"type":1,"value":"serviceCreditsLink"},{"type":0,"value":"."}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.service-credits-link-text":[{"type":0,"value":"Service Credits"}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.sla-link-text":[{"type":0,"value":"Atlassian Service Level Agreement"}],"commerce.commerce-refund-generic-email-ccp.email.direct.caption":[{"type":0,"value":"Your refund has been processed"}],"commerce.commerce-refund-generic-email-ccp.email.partner-or-reseller.caption":[{"type":0,"value":"Your refund has been processed"}],"commerce.commerce-refund-generic-email-ccp.email.partner-or-reseller.completed":[{"type":0,"value":"We have completed the refund related to the following invoice:"}],"commerce.commerce-refund-generic-email-ccp.email.partner-or-reseller.refund-amount":[{"type":0,"value":"The refund has been credited to the payment method used in the original purchase. Please allow 2-3 business days for the refunded amount to appear on your bank statement. Please note that any subscription changes based on your refund request will reflect on your account shortly."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.cash-refund":[{"type":0,"value":"If you would like to receive a cash refund instead, please reach out to "},{"children":[{"type":0,"value":"accountsreceivable@atlassian.com"}],"type":8,"value":"a"},{"type":0,"value":"."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.completed":[{"type":0,"value":"We have completed the refund related to the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":"."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.credit-issued":[{"type":0,"value":"The credits issued on this credit note will be applied to any outstanding unpaid invoices you may have."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.direct.subject":[{"type":0,"value":"Refund processed for invoice "},{"type":1,"value":"invoiceNumber"}],"commerce.commerce-refund-generic-email-ccp.message-template.email.more-info":[{"type":0,"value":"For more information about invoices and subscriptions, go to your sites "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.partner-or-reseller.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Refund processed"}],"commerce.commerce-refund-generic-email-ccp.message-template.email.refund-amount":[{"type":0,"value":"The refunded amount should appear on your bank statement in 2-3 business days. Any subscription changes based on your refund request will reflect on your account soon."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.refund-credited-to-cc":[{"type":0,"value":"A refund from the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" has been credited to your card "},{"children":[{"type":1,"value":"cardBrand"},{"type":0,"value":" ending in "},{"type":1,"value":"maskedNumber"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.refund-credited-to-paypal":[{"type":0,"value":"A refund from the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" has been credited to your "},{"children":[{"type":0,"value":"PayPal account, "},{"type":1,"value":"paypalEmail"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.terms-completed":[{"type":0,"value":"We have completed the refund related to the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" and generated a credit note "},{"type":1,"value":"creditNoteNumber"},{"type":0,"value":" against it."}],"commerce.commerce-refund-internal-ccp.message-template.email.adc-refund.body":[{"type":0,"value":"Advocate Central REFUND LINK - "},{"type":1,"value":"advocateCentralUrl"},{"type":0,"value":"/refunds/"},{"type":1,"value":"refundId"},{"type":0,"value":"."}],"commerce.commerce-refund-internal-ccp.message-template.email.refund-bank-transfer.subject":[{"type":0,"value":"Bank Refund Request - Refund #"},{"type":1,"value":"refundId"}],"commerce.commerce-refund-internal-ccp.message-template.email.refund-onAccount.subject":[{"type":0,"value":"Expert Account Refund Request - Refund #"},{"type":1,"value":"refundId"}],"commerce.commerce-refund-internal-ccp.message-template.email.refund.body":[{"type":0,"value":"CASSI REFUND LINK - "},{"type":1,"value":"cassiUrl"},{"type":0,"value":"/ui/refunds/"},{"type":1,"value":"refundId"},{"type":0,"value":"."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.dc.email.breached-caption":[{"type":0,"value":"Users in your site have used up their Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.dc.email.milestone-caption":[{"type":0,"value":"Users in your site are using up their Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.dc.email.subject.breached":[{"type":1,"value":"productName"},{"type":0,"value":" credit allowance used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.dc.email.subject.milestone":[{"type":1,"value":"productName"},{"type":0,"value":" credit allowance running low"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.breached.need-to-know-list-admin-can-limit-usage":[{"type":0,"value":"Organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.breached.need-to-know-list-extra-usage-charges":[{"type":0,"value":"Extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit \u2014 any extra charges will be added to your next invoice. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.breached.need-to-know-list-user-can-use-extra":[{"type":0,"value":"Unless an organization admin has adjusted the extra usage limit or disabled extra usage, users will be able to use up to 2,000 extra Rovo Dev credits for an extra charge on top of the 2,000 credits included in the subscription."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.need-to-know-list-extra-charges-in-invoice":[{"type":0,"value":"Once users exceed their allowance of Rovo Dev credits, extra usage will be charged at USD 0.01 per extra Rovo Dev credit \u2014 any extra charges will be added to your next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.need-to-know-list-monitor-usage":[{"type":0,"value":"It\'s a good idea to monitor usage in your billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.view-usage":[{"type":0,"value":"View usage"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.dc.breached-info-message":[{"type":0,"value":"At least one of your users has used up their Rovo Dev credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.dc.breached.monitoring-message":[{"type":0,"value":"Monitor what your team\'s using by viewing a detailed breakdown of their usage in your billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.dc.milestone-info-message":[{"type":0,"value":"At least one of your users has used up "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their Rovo Dev credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.body.breached.need-to-know-list-extra-usage-charges":[{"type":0,"value":"Extra usage will extra usage will be charged at USD 0.01 per extra Rovo Dev credit \u2014 any extra charges will be added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.body.breached.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.body.milestone.need-to-know-list-monitor-usage":[{"type":0,"value":"It\u2019s a good idea to encourage your customer to monitor their usage in their billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.body.milestone.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.breached-info-message":[{"type":0,"value":"At least one of your customer\'s users has used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.milestone-info-message":[{"type":0,"value":"At least one of your customer\'s users has used up "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"productName"},{"type":0,"value":" credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.what-you-need":[{"type":0,"value":"What you need to know:"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.body.breached.need-to-know-list-users-can-use-extra":[{"type":0,"value":"Unless an organization admin has adjusted the extra usage limit or disabled extra usage, users will be able to use up to 2,000 extra Rovo Dev credits for an extra charge on top of the 2,000 credits included in the subscription."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.body.milestone.need-to-know-list-users-can-use-extra":[{"type":0,"value":"Once users exceed their allowance of Rovo Dev credits, extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit \u2014 any extra charges will be added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.breached-caption":[{"type":0,"value":"Users in your customer\'s site have used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.milestone-caption":[{"type":0,"value":"Users in your customer\'s site are using up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.subject.breached.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Users have used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.subject.milestone.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Users are using up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.breached-caption":[{"type":0,"value":"Users in your site have used up their Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.breached-caption-announcement":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance has been used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.breached-caption-announcement.ubp5":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance has been used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.breached-rde-caption":[{"type":0,"value":"Upgrade to Rovo Dev Standard to get more Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.milestone-caption":[{"type":0,"value":"Users in your site are using up their Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.milestone-caption-allowance-announencement":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance has been used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.milestone-caption-allowance-announencement.ubp5":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance has been used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.subject.breached":[{"type":0,"value":"Rovo Dev credit allowance used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.subject.breached.pooled-meter":[{"type":1,"value":"productName"},{"type":0,"value":" allowance used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.subject.milestone":[{"type":1,"value":"productName"},{"type":0,"value":" credit allowance running low"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.subject.milestone.pooled-meter":[{"type":1,"value":"productName"},{"type":0,"value":" allowance is running low"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.need-to-know-list-admin-can-limit-usage":[{"type":0,"value":"Organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.need-to-know-list-extra-usage-charges":[{"type":0,"value":"Extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit \u2014 any extra charges will be added to your next invoice. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.need-to-know-list-user-can-use-extra":[{"type":0,"value":"Unless an organization admin has adjusted the extra usage limit or disabled extra usage, users will be able to use up to 2,000 extra Rovo Dev credits for an extra charge on top of the 2,000 credits included in the subscription."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.rde.need-to-know-list-monitor":[{"type":0,"value":"You can monitor usage in your billing account to see which users have used their allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.rde.need-to-know-list-ugrade-to-standard":[{"type":0,"value":"To increase Rovo Dev credits and allow extra usage, organization admins can upgrade to Rovo Dev Standard."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.rde.need-to-know-list-user-cannot-use-extra":[{"type":0,"value":"Users who are at their credit limit won\'t be able to use any Rovo Dev features until the next billing cycle."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.trials.need-to-know-list-admin-can-limit-usage":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage for when the paid plan starts \u2014 this can be done anytime in Atlassian Administration to keep costs predictable. "}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.trials.need-to-know-list-extra-usage-charges":[{"type":0,"value":"If you want to allow extra usage before the trial ends, you can end the trial early and start the paid plan. If you do this, usage will reset and any usage over the allocated amount will be charged at USD 0.01 per extra Rovo Dev credit and added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.trialsneed-to-know-list-function-disabled":[{"type":0,"value":"Rovo Dev functionality is disabled for users who reach their allowance, and usage resets when the paid plan starts."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.need-to-know-list-extra-charges-in-invoice":[{"type":0,"value":"Once users exceed their allowance of Rovo Dev credits, extra usage will be charged at USD 0.01 per extra Rovo Dev credit \u2014 any extra charges will be added to your next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.need-to-know-list-monitor-usage":[{"type":0,"value":"It\'s a good idea to monitor usage in your billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.trials.need-to-know-list-extra-charges-in-invoice":[{"type":0,"value":"If you want to allow extra usage before the trial ends, you can end the trial early and start the paid plan. If you do this, usage will reset and any usage over the allocated amount will be charged at USD 0.01 per extra Rovo Dev credit and added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.trials.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage for when the paid plan starts \u2014 this can be done at any time in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.trials.need-to-know-list-will-be-disabled":[{"type":0,"value":"Once users use up their Rovo Dev credits, Rovo Dev functionality will be disabled until usage resets when the paid plan starts."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.view-usage":[{"type":0,"value":"View usage"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.billing-faq-url":[{"type":0,"value":"When and how will I be billed?"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-billable-usage-notice":[{"type":0,"value":"Any usage beyond your allowance is considered billable usage. "},{"children":[{"type":0,"value":"You won\u2019t be billed for your billable usage at this time."}],"type":8,"value":"b"},{"type":0,"value":" "},{"type":1,"value":"billingUrl"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-details.ubp5":[{"type":0,"value":"Visit Atlassian Administration to get more details on "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage in your organization."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-info-message":[{"type":0,"value":"At least one of your users has used up their Rovo Dev credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-info-message-announcement.ubp5":[{"type":0,"value":"Your org has used "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-rde-info-message":[{"type":0,"value":"At least one of your users has used up their free Rovo Dev credit allowance in Jira."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-update-limits.ubp5":[{"type":0,"value":"Your org admin can update your usage limits anytime."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-what-next.ubp5":[{"type":0,"value":"If your org admin has enabled extra usage, you\u2019ll incur extra usage charges up to your extra usage limit. If extra usage is disabled, some features will be restricted or unavailable until your usage resets."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached.monitoring-message":[{"type":0,"value":"Monitor what your team\'s using by viewing a detailed breakdown of their usage in your billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-billable-usage-notice":[{"type":0,"value":"Once your organization exceeds your allowance, you\u2019ll start to incur billable usage. "},{"children":[{"type":0,"value":"You won\u2019t be billed for your billable usage at this time."}],"type":8,"value":"b"},{"type":0,"value":" "},{"type":1,"value":"billingUrl"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-info-message":[{"type":0,"value":"At least one of your users has used up "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their Rovo Dev credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-info-message-allowance-announcement":[{"type":0,"value":"Your organization has used "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of its "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-info-message-allowance-announcement.ubp5":[{"type":0,"value":"Your org has used "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-info-message-allowance-org-details.ubp5":[{"type":0,"value":"Visit Atlassian Administration to get more details on "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage in your organization."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-what-next.ubp5":[{"type":0,"value":"If your org reaches 100% of their allowance, extra usage charges will be incurred if extra usage is enabled. Otherwise, some features will be restricted or unavailable until your usage resets."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.usage-details-announcement":[{"type":0,"value":"Visit Atlassian Administration to get more details on "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage in your organization."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.billing-faq-url":[{"type":0,"value":"When and how will they be billed?"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.body.breached.need-to-know-list-extra-usage-charges":[{"type":0,"value":"Extra usage will extra usage will be charged at USD 0.01 per extra Rovo Dev credit \u2014 any extra charges will be added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.body.breached.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.body.milestone.need-to-know-list-monitor-usage":[{"type":0,"value":"It\u2019s a good idea to encourage your customer to monitor their usage in their billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.body.milestone.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-billable-usage-notice":[{"type":0,"value":"Any usage beyond your customer\u2019s allowance is considered billable usage. "},{"children":[{"type":0,"value":"You won\u2019t be billed for your billable usage at this time."}],"type":8,"value":"b"},{"type":0,"value":" "},{"type":1,"value":"billingUrl"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-details.ubp5":[{"type":0,"value":"Visit PPC to get more details on your customer\u2019s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-info-message":[{"type":0,"value":"At least one of your customer\'s users has used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-info-message-pooled-meter.ubp5":[{"type":0,"value":"Your customer has used "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-update-limits.ubp5":[{"type":0,"value":"You can update your customer\u2019s usage limits anytime."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-what-next.ubp5":[{"type":0,"value":"If you\'ve enabled extra usage for your customer, they\u2019ll incur extra usage charges up to the extra usage limit. If extra usage is disabled, some features will be restricted or unavailable until their usage resets."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-billable-usage-notice":[{"type":0,"value":"Once your customer\u2019s organization exceeds their allowance, they\u2019ll start to incur billable usage. "},{"children":[{"type":0,"value":"You won\u2019t be billed for your billable usage at this time."}],"type":8,"value":"b"},{"type":0,"value":" "},{"type":1,"value":"billingUrl"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-details.ubp5":[{"type":0,"value":"Visit PPC to get more details on your customer\u2019s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-info-message":[{"type":0,"value":"At least one of your customer\'s users has used up "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"productName"},{"type":0,"value":" credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-info-message-pooled-meter":[{"type":0,"value":"Your customer has used "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their organization\u2019s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-info-message-pooled-meter.ubp5":[{"type":0,"value":"Your customer has used "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-info-message-vist-ppc-pooled-meter":[{"type":0,"value":"Visit PPC to get more details on your customer\u2019s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-what-next.ubp5":[{"type":0,"value":"If your customer reaches 100% of their allowance, extra usage charges will be incurred if extra usage is enabled. Otherwise, some features will be restricted or unavailable until their usage resets."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.what-you-need":[{"type":0,"value":"What you need to know:"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.whats-next.ubp5":[{"type":0,"value":"What\u2019s next?"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.body.breached.need-to-know-list-users-can-use-extra":[{"type":0,"value":"Unless an organization admin has adjusted the extra usage limit or disabled extra usage, users will be able to use up to 2,000 extra Rovo Dev credits for an extra charge on top of the 2,000 credits included in the subscription."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.body.milestone.need-to-know-list-users-can-use-extra":[{"type":0,"value":"Once users exceed their allowance of Rovo Dev credits, extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit \u2014 any extra charges will be added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.breached-caption":[{"type":0,"value":"Users in your customer\'s site have used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.breached-caption-pooled-meter":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your customer\u2019s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance has been used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.breached-caption-pooled-meter.ubp5":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your customer\u2019s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance has been used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.milestone-caption":[{"type":0,"value":"Users in your customer\'s site are using up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.milestone-caption-pooled-meter.ubp5":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your customer\u2019s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance has been used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.subject.breached.pooled-meter":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" allowance used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.subject.breached.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Users have used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.subject.milestone.pooled-meter":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" allowance is running low "}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.subject.milestone.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Users are using up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-ship-to-party-archival-ccp.body.initimation":[{"type":0,"value":"Please note that this sold-to address is no longer available for billing."}],"commerce.commerce-ship-to-party-archival-ccp.body.partner.p3":[{"type":0,"value":"To view the changes, head to "},{"type":1,"value":"ppcHomePageLink"},{"type":0,"value":"."}],"commerce.commerce-ship-to-party-archival-ccp.email.body.disclaimer":[{"type":0,"value":"We\'ve deactivated the below sold-to address:"}],"commerce.commerce-ship-to-party-archival-ccp.message-template.email.subject":[{"type":1,"value":"name"},{"type":0,"value":" Sold to address deactivated"}],"commerce.commerce-soft-limit-breach-ccp.email.automatic-upgrade":[{"type":0,"value":"Automatic upgrade"}],"commerce.commerce-soft-limit-breach-ccp.email.manage-users":[{"type":0,"value":"Manage "},{"type":1,"value":"product"}],"commerce.commerce-soft-limit-breach-ccp.email.no-upgrade":[{"type":0,"value":"Don\'t want to upgrade? "}],"commerce.commerce-soft-limit-breach-ccp.email.no-upgrade-text":[{"type":0,"value":"We recommend removing "},{"type":1,"value":"exceededLimit"},{"type":0,"value":" users before your upgrade date. You can do this by selecting Manage users in your "},{"type":1,"value":"product"},{"type":0,"value":" subscription"}],"commerce.commerce-soft-limit-breach-ccp.email.note1":[{"type":0,"value":"If no changes are made, you\'ll be upgraded and we\'ll send you an invoice of prorated costs for the remainder of your billing period."}],"commerce.commerce-soft-limit-breach-ccp.email.note2":[{"type":0,"value":"You don\'t need to take any action. We\'ll automatically upgrade your account and the new charges will be applied."}],"commerce.commerce-soft-limit-breach-ccp.email.product-limit-exceeded":[{"type":0,"value":"Your "},{"type":1,"value":"product"},{"type":0,"value":" user limit of "},{"type":1,"value":"lowerLimit"},{"type":0,"value":"-"},{"type":1,"value":"upperLimit"},{"type":0,"value":" has exceeded by "},{"type":1,"value":"exceededLimit"},{"type":0,"value":" users."}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.final-reminder":[{"type":0,"value":"In a few days you\u2019ll be automatically upgraded to a new limit of "},{"type":1,"value":"lowerLimit"},{"type":0,"value":"-"},{"type":1,"value":"upperLimit"},{"type":0,"value":" to accommodate your growing user count."}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.final-reminder-caption":[{"type":0,"value":"You\u2019re about to be upgraded"}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.first-reminder":[{"type":0,"value":"Soon you\'ll be automatically upgraded to a new limit of "},{"type":1,"value":"lowerLimit"},{"type":0,"value":"-"},{"type":1,"value":"upperLimit"},{"type":0,"value":" to accommodate your growing user count."}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.first-reminder-caption":[{"type":0,"value":"Your team is growing"}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.second-reminder":[{"type":0,"value":"In the next week, you\u2019ll be automatically upgraded to a new limit of "},{"type":1,"value":"lowerLimit"},{"type":0,"value":"-"},{"type":1,"value":"upperLimit"},{"type":0,"value":" to accommodate your growing user count. "}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.second-reminder-caption":[{"type":0,"value":"You\u2019ll be upgraded soon"}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.subject.final-reminder":[{"type":0,"value":"Last chance: manage users before automatic upgrade"}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.subject.reminder":[{"type":0,"value":"Action required before automatic upgrade"}],"commerce.commerce-subscription-activation-ccp.message-template.ecc.start-set-up":[{"type":0,"value":"Start set up"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.admin-permission-url":[{"type":0,"value":"how to give users admin permissions"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.body.atlassian-billing-partner":[{"type":0,"value":"Atlassian reseller: "}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.body.manage-subscription":[{"type":0,"value":"You can view or cancel your subscriptions at any time by going to "},{"type":1,"value":"partnerManagedSubscriptionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.body.setup-site":[{"type":0,"value":"Setting up the site means you\u2019ll automatically get admin permissions as an org and site admin. You can also give admin roles to others - see "},{"type":1,"value":"giveUserAdminPermissionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.body.site-heading":[{"type":0,"value":"Site: "}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.caption.with-site":[{"type":0,"value":"Your products are ready for use "}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.caption.without-site":[{"type":0,"value":"Set up your subscription and get started"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.partner-managed-subscription.url":[{"type":0,"value":"your partner-managed subscriptions"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.reseller.body.atlassian-billing-partner":[{"type":0,"value":"Atlassian billing partner: "}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.reseller.subscriptions-active":[{"type":0,"value":"Great news! Your Atlassian partner had placed an order for Atlassian products on "},{"type":1,"value":"orderDate"},{"type":0,"value":". The subscriptions are now active and ready to use."},{"type":1,"value":"contentForSite"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.set-up-subscriptions":[{"type":0,"value":"Get started by setting up your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":"."}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.site-info":[{"type":0,"value":"They\'ll be added to your site shortly."}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.subscriptions-active":[{"type":0,"value":"Great news! Your Atlassian reseller had placed an order for Atlassian products on "},{"type":1,"value":"orderDate"},{"type":0,"value":". The subscriptions are now active and ready to use."},{"type":1,"value":"contentForSite"}],"commerce.commerce-subscription-activation-ccp.message-template.email.partner.body.manage-subscription":[{"type":0,"value":"You can manage these subscriptions from our "},{"type":1,"value":"ppcHomePage"}],"commerce.commerce-subscription-activation-ccp.message-template.email.partner.ppc-url":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-activation-ccp.message-template.email.partner.subscriptions-active":[{"type":0,"value":"Great news \u2014 the subscriptions that you ordered for your customer on "},{"type":1,"value":"orderDate"},{"type":0,"value":" are now active and ready to use. We\u2019ve also informed your customer that they can get started."}],"commerce.commerce-subscription-activation-ccp.message-template.email.remaining-subs":[{"type":0,"value":"+ "},{"type":1,"value":"remainingCount"},{"type":0,"value":" more subscriptions."}],"commerce.commerce-subscription-activation-ccp.message-template.email.reseller.body.manage-subscription":[{"type":0,"value":"You can view or cancel your subscriptions at any time by going to your "},{"type":1,"value":"managedSubscriptionUrl"},{"type":0,"value":" page and following the steps."}],"commerce.commerce-subscription-activation-ccp.message-template.email.reseller.partner-managed-subscription.url":[{"type":0,"value":"Subscription overview"}],"commerce.commerce-subscription-activation-ccp.message-template.email.set-up-subscriptions":[{"type":0,"value":"Get started by setting up your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":"."}],"commerce.commerce-subscription-activation-ccp.message-template.email.subject.ecc":[{"type":0,"value":"It\u2019s time to set up your subscription"}],"commerce.commerce-subscription-activation-ccp.message-template.email.subject.partner":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": it\u2019s time to set up subscriptions"}],"commerce.commerce-subscription-activation-ccp.message-template.email.subject.singular":[{"type":0,"value":"It\'s time to set up your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"}],"commerce.commerce-subscription-activation-ccp.message-template.email.subscriptions-active":[{"type":0,"value":"Great news \u2014 the "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription that you ordered on "},{"type":1,"value":"orderDate"},{"type":0,"value":" is"}]},"other":{"value":[{"type":0,"value":"subscriptions that you ordered on "},{"type":1,"value":"orderDate"},{"type":0,"value":" are"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" now active."}],"commerce.commerce-subscription-activation-ccp.message-template.email.time-to-get-set-up":[{"type":0,"value":"It\'s time to get set up"}],"commerce.commerce-subscription-add-on-usage-reminder-ccp-g.body.dc.p3":[{"type":0,"value":"You can manage the subscription from your Subscription details page."}],"commerce.commerce-subscription-add-on-usage-reminder-ccp-g.body.partner.p3":[{"type":0,"value":"You can manage the subscription from our "},{"type":1,"value":"ppcSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.body.dc.p3":[{"type":0,"value":"You can manage the subscription from your Subscription details page."}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.body.partner.p3":[{"type":0,"value":"You can manage the subscription from our "},{"type":1,"value":"ppcSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.message-template.email.dc.add-on.cta":[{"type":0,"value":"Increase usage limit"}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.message-template.email.dc.cta":[{"type":0,"value":"Get add-on"}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.message-template.email.partner.add-on.cta":[{"type":0,"value":"Get quote for higher limit"}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.message-template.email.partner.cta":[{"type":0,"value":"Get add-on"}],"commerce.commerce-subscription-auto-downgrade-ccp.email.partner.subject.with.company.name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":":"},{"type":1,"value":"productName"},{"type":0,"value":" now on Free plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.limted.features.info":[{"type":0,"value":"This way, your customer can still use "},{"type":1,"value":"productName"},{"type":0,"value":", but with limited features."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.dc.email.subject":[{"type":0,"value":"You\u2019re now on "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.body.summary.partner-uncollectible":[{"type":0,"value":"We\u2019ve moved the below subscription to the Free plan. This is because we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.body.summary.partner-uninvoiceable":[{"type":0,"value":"We\u2019ve moved the below subscription to the Free plan. This is because we don\u2019t have your customer\u2019s complete billing information. It could be because the information provided to us is incorrect or incomplete."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.body.request-deletion-of-personal-data-link":[{"type":0,"value":"request for deletion of your personal data"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.caption-v3":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.summary":[{"type":0,"value":"As requested, your "},{"type":1,"value":"previousOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.go-back-original-plan":[{"type":0,"value":"Want to go back on the original plan?"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.review-and-manage-subscription":[{"type":0,"value":"Review the customer\u2019s billing details from our Partner Purchasing Center and change the subscription."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.subscription-downgraded-message":[{"type":0,"value":"We couldn\'t collect payment for an invoice generated for this subscription. As a result, we\'ve moved the subscription to the Free plan. This way, "},{"type":1,"value":"productName"},{"type":0,"value":" can still be used, but with limited features."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.you-may-request-deletion-of-personal-data":[{"type":0,"value":"Your customer can also place a "},{"type":1,"value":"requestForDeletionOfPersonalDataLink"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.caption":[{"type":1,"value":"productName"},{"type":0,"value":" moved to Free plan due to payment issue"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.body":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" has been downgraded to the Free plan. Restore your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan to keep access to unlimited users, AI credits, and more storage for your team."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.body.confluence-standard":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" has been downgraded to the Free plan. Restore your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan to keep access to unlimited users, advanced permissions, and 250GB of storage."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.body.jira-premium":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" has been downgraded to the Free plan. Restore your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan to keep access to unlimited users and storage, AI credits, and advanced admin controls."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.body.jira-product-discovery-premium.ai-non-final":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" has been downgraded to the Free plan. Restore your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan to keep access to advanced roadmaps, field-level security, or admin insights."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.body.jira-product-discovery-standard":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" has been downgraded to the Free plan. Restore your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan to keep access to increased user limits, permissions, and published views for your team."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.body.jira-standard":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" has been downgraded to the Free plan. Restore your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan to keep access to unlimited users, roles and permissions, and 1,700 monthly automations."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.body.loom-business":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has been downgraded to the Starter plan. Restore your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan to keep access to increased user limits, recording insights, and unlimited videos for your team."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.body.loom-business-ai":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has been downgraded to the Starter plan. Restore your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan to keep access to unlimited recording, custom branding, or AI-powered features."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.body.premium":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" has been downgraded to the Free plan. Restore your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan to keep access to unlimited users, AI credits, and unlimited storage for your team."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.body.service-standard":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" has been downgraded to the Free plan. Restore your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan to keep access to increased user limits, 250GB of storage, and Assets for your team."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.body.teamwork-premium":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" has been downgraded to the Free plan. Restore your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan to keep access to unlimited users and storage, AI credits, and Atlassian Guard."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.body.teamwork-standard":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" has been downgraded to the Free plan. Restore your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan to keep access to increased user limits, AI credits, and videos without limits for your team."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.current-plan-label":[{"type":0,"value":"Current plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.current-plan-name":[{"type":1,"value":"productName"},{"type":0,"value":" Free"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.current-plan-name.loom":[{"type":1,"value":"productName"},{"type":0,"value":" Starter"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.greeting":[{"type":0,"value":"Hello "},{"type":1,"value":"firstName"},{"type":0,"value":","}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.heading":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has ended"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.restore-access.ai-non-final":[{"type":0,"value":"Restore access"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.subject":[{"type":0,"value":"You\u2019re now on "},{"type":1,"value":"productName"},{"type":0,"value":" Free"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.subject.loom":[{"type":0,"value":"You\u2019re now on "},{"type":1,"value":"productName"},{"type":0,"value":" Starter"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.uncollectible.caption.ai-non-final":[{"type":0,"value":"You are now on the Free plan of "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.uncollectible.interruptions.ai-non-final":[{"type":0,"value":"To avoid any interruptions, make sure your payment details are up to date."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.uncollectible.manage-subscription.ai-non-final":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.uncollectible.payment-failure.ai-non-final":[{"type":0,"value":"We couldn\u2019t process payment for your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription ("},{"type":1,"value":"entitlementId"},{"type":0,"value":") due to an issue with your payment details. As a result, we\u2019ve moved your subscription to the Free plan. This way, you can still use "},{"type":1,"value":"productName"},{"type":0,"value":", but with limited features."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.uncollectible.subject.ai-non-final":[{"type":1,"value":"productName"},{"type":0,"value":" subscription moved to Free plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.uncollectible.upgrade.ai-non-final":[{"type":0,"value":"Want to go back on your original plan? You can upgrade your subscription. "},{"children":[{"type":0,"value":"Learn how to change plans"}],"type":8,"value":"link"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.partner.email.body.personal-data-retention-summary.link":[{"type":0,"value":"request for deletion of their personal data."}],"commerce.commerce-subscription-auto-upgrade-ccp.learn-how-to-do-this":[{"type":0,"value":"Learn how to do this"}],"commerce.commerce-subscription-auto-upgrade-ccp.legal-update-twcg-1465.downgrade":[{"type":0,"value":"downgrade"}],"commerce.commerce-subscription-auto-upgrade-ccp.legal-update-twcg-1465.reduce-your-user-count":[{"type":0,"value":"reduce your user count"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-admin-partner.body.switch-to-back-free-plan":[{"type":0,"value":"You can switch back to a Free plan at any time from our "},{"type":1,"value":"partnerPurchasingCenterLink"},{"type":0,"value":". Your customer\u2019s site or organization admin will first need to reduce the "},{"type":1,"value":"userType"},{"type":0,"value":" count for the product to 10 or fewer."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-admin-partner.caption":[{"type":0,"value":"Your customer can now enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-admin-partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.body.more-information":[{"type":0,"value":"For help or more information, contact your Atlassian billing partner."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.body.partner-managed-subscriptions":[{"type":0,"value":"You can also cancel your subscription at any time by going to your "},{"type":1,"value":"partnerManagedSubscriptions"},{"type":0,"value":" and following the steps. [Link to ECC section on admin hub]"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.body.stay-on-plan":[{"type":0,"value":"If you\u2019d like to stay on the "},{"type":1,"value":"planName"},{"type":0,"value":" plan, with instructions."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.caption":[{"type":0,"value":"Enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.body.subscription-trial":[{"type":0,"value":"We\u2019ve upgraded you to a free 14-day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":". This is because the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"userType"},{"type":0,"value":" limit for the Free plan was exceeded."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.body.switch-to-back-free-plan":[{"type":0,"value":"You can switch back to a Free plan at any time by reducing your "},{"type":1,"value":"userType"},{"type":0,"value":" count. "},{"type":1,"value":"learnHowToDoThis"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.direct-customer.body.stay-on-plan":[{"type":0,"value":"If you\u2019d like to stay on the "},{"type":1,"value":"planName"},{"type":0,"value":" plan, you don\u2019t need to do anything."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.direct-customer.body.subscription-trial":[{"type":0,"value":"We\u2019ve upgraded the following subscription to a free 14-day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". This is because you went over the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"userType"},{"type":0,"value":" limit for the Free plan."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.body.switch-to-back-free-plan":[{"type":0,"value":"To stay on the Standard plan, you don\'t need to do anything. We\'ll charge your saved payment method when your trial ends. To return to the Free plan, first "},{"type":1,"value":"reduceYourUserCount"},{"type":0,"value":" to meet the plan limit, then "},{"type":1,"value":"downgrade"},{"type":0,"value":"."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.contextual-info.next-bill-date-label":[{"type":0,"value":"Next bill date"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.contextual-info.next-bill-estimate-label":[{"type":0,"value":"Next bill estimate"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.contextual-info.next-bill-estimate-value":[{"type":1,"value":"amount"},{"type":0,"value":" "},{"type":1,"value":"billingCycle"},{"type":0,"value":" (excluding taxes)"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.contextual-info.plan-label":[{"type":0,"value":"Plan"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.contextual-info.plan-name":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.body.explore-standard-cta":[{"type":0,"value":"Explore Standard"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.body.subscription-trial":[{"type":0,"value":"You\'ve reached the user limit for your Free plan, so "},{"children":[{"type":0,"value":"we\'ve upgraded you"}],"type":8,"value":"bold"},{"type":0,"value":" to our Standard plan. It\'s free for 14 days."},{"type":1,"value":"br"},{"type":0,"value":"You can now add unlimited users to your projects and help your team ship faster."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.body.subscription-trial-with-end-date":[{"type":0,"value":"You\'ve reached the user limit for your Free plan, so "},{"children":[{"type":0,"value":"we\'ve upgraded you"}],"type":8,"value":"bold"},{"type":0,"value":" to our Standard plan. It\'s free for 14 days."},{"type":1,"value":"br"},{"type":1,"value":"br"},{"type":0,"value":"You can now add unlimited users to your projects and help your team ship faster. Your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"bold"},{"type":0,"value":"."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.caption":[{"type":0,"value":"Your Standard trial has started"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.subscription-details-heading":[{"type":0,"value":"Subscription details"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.what-happens-next-heading":[{"type":0,"value":"What happens next?"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.header.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.header.confluence-logo-alt":[{"type":0,"value":"Confluence"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.header.jira-logo-alt":[{"type":0,"value":"Jira"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.header.jpd-logo-alt":[{"type":0,"value":"Jira Product Discovery"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.unlocks-additional-features":[{"type":0,"value":"Your new "},{"type":1,"value":"planName"},{"type":0,"value":" plan unlocks additional features to help your team achieve more together:"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.want-to-stay-on-standard":[{"type":0,"value":"Don\'t want to stay on "},{"type":1,"value":"planName"},{"type":0,"value":"?"}],"commerce.commerce-subscription-auto-upgrade-ccp.partner-managed-subscriptions-link":[{"type":0,"value":"partner-managed subscriptions"}],"commerce.commerce-subscription-auto-upgrade-ccp.partner-purchasing-link\'":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-auto-upgrade-ccp.screen-space-flags.description.no-translate":[{"type":0,"value":"You\'re over the Free user limit, so we moved you to a Standard trial."}],"commerce.commerce-subscription-auto-upgrade-ccp.screen-space-flags.title.no-translate":[{"type":0,"value":"Welcome to your 14-day free trial of Standard"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.email.icon-warning.alt-text":[{"type":0,"value":"Icon - Warning"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.learn-how-to-do-this":[{"type":0,"value":"Learn how to do this"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-admin-partner.body.switch-to-back-free-plan":[{"type":0,"value":"You can switch back to a Free plan at any time from our "},{"type":1,"value":"partnerPurchasingCenterLink"},{"type":0,"value":". Your customer\u2019s site or organization admin will first need to reduce the "},{"type":1,"value":"userType"},{"type":0,"value":" count for the product to 10 or fewer."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-admin-partner.caption":[{"type":0,"value":"Add payment details to enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-admin-partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Important things to know about "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.body.more-information":[{"type":0,"value":"For help or more information, contact your Atlassian billing partner."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.body.partner-managed-subscriptions":[{"type":0,"value":"You can also cancel your subscription at any time by going to your "},{"type":1,"value":"partnerManagedSubscriptions"},{"type":0,"value":" and following the steps. [Link to ECC section on admin hub]"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.body.stay-on-plan":[{"type":0,"value":"If you\u2019d like to stay on the "},{"type":1,"value":"planName"},{"type":0,"value":" plan, you\u2019ll just need to make sure your Atlassian billing partner has the correct billing details. We\u2019ve also sent them an email with instructions."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.caption":[{"type":0,"value":"Enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.subject":[{"type":1,"value":"partnerName"},{"type":0,"value":": Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been upgraded to the "},{"type":1,"value":"planName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.add-payment-details":[{"type":0,"value":"Add payment details before the trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":", otherwise the subscription will be deactivated."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.subscription-trial":[{"type":0,"value":"We\u2019ve upgraded you to a free 14-day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":". This is because the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"chargeElement"},{"type":0,"value":" limit for the Free plan was exceeded."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.switch-to-back-free-plan":[{"type":0,"value":"You can switch back to a Free plan at any time by reducing your "},{"type":1,"value":"userType"},{"type":0,"value":" count. "},{"type":1,"value":"learnHowToDoThis"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.take-action-or-lose-access":[{"type":0,"value":"You\u2019ll lose access to "},{"type":1,"value":"productName"},{"type":0,"value":" if you don\u2019t take action "},{"type":1,"value":"takeActionBy"},{"type":0,"value":"."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.take-action-or-lose-access.take-action-by-trial-end-date-available":[{"type":0,"value":"by "},{"type":1,"value":"trialEndMonth"},{"type":0,"value":" "},{"offset":0,"options":{"few":{"value":[{"type":0,"value":"$rd"}]},"one":{"value":[{"type":7},{"type":0,"value":"st"}]},"other":{"value":[{"type":7},{"type":0,"value":"th"}]},"two":{"value":[{"type":7},{"type":0,"value":"nd"}]}},"pluralType":"ordinal","type":6,"value":"trialEndDate"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.take-action-or-lose-access.take-action-by-trial-end-date-not-available":[{"type":0,"value":"soon"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.what-you-need-to-do":[{"type":0,"value":"What you need to do"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.you-can-switch-back-to-free-plan-billing-admin":[{"type":0,"value":"You can switch back to a Free plan at any time by "},{"children":[{"type":0,"value":"reducing your user count"}],"type":8,"value":"Link"},{"type":0,"value":"."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.you-can-switch-back-to-free-plan-mpucup-user":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" admin can switch back to a Free plan at any time by reducing your user count."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.body-intro":[{"type":0,"value":"Your team now has a "},{"children":[{"type":0,"value":"free 14-day trial"}],"type":8,"value":"b"},{"type":0,"value":" of "},{"type":1,"value":"productName"},{"type":0,"value":" Standard because you reached the 10-user limit on the Free plan."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.confluence.invite-team":[{"children":[{"type":0,"value":"Invite your team."}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need to your spaces."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.confluence.page-insights":[{"children":[{"type":0,"value":"Measure impact."}],"type":8,"value":"b"},{"type":0,"value":" Track views and engagement with page insights."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.confluence.rovo-ai":[{"children":[{"type":0,"value":"Draft faster."}],"type":8,"value":"b"},{"type":0,"value":" Generate ideas and first drafts with Rovo AI."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.jira.automation":[{"children":[{"type":0,"value":"Automate tedious tasks."}],"type":8,"value":"b"},{"type":0,"value":" Set rules for repetitive updates."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.jira.invite-team":[{"children":[{"type":0,"value":"Invite your team."}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need to your spaces."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.jira.rovo-agents":[{"children":[{"type":0,"value":"Put agents to work."}],"type":8,"value":"b"},{"type":0,"value":" Call on Rovo agents for specialized tasks."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.heading":[{"type":0,"value":"We\'ve upgraded you to "},{"type":1,"value":"productName"},{"type":0,"value":" Standard"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.payment-deadline":[{"type":0,"value":"Add payment details before your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":" to keep all your users and features. If you don\'t add payment details or reduce your user count to 10 or fewer by "},{"type":1,"value":"trialEndDate"},{"type":0,"value":", you will lose access to "},{"type":1,"value":"productName"},{"type":0,"value":" and your data will be permanently deleted."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.what-you-need-to-do":[{"type":0,"value":"What you need to do"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.body.stay-on-plan":[{"type":0,"value":"If you\u2019ve already added your payment details, you don\u2019t need to do anything."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.body.subscription-trial":[{"type":0,"value":"We\u2019ve upgraded the following subscription to a free 14-day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". This is because you went over the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"userType"},{"type":0,"value":" limit for the Free plan."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Add payment details to enjoy the benefits of "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.subject3":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" plan has changed to Standard"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.billing-admin-partner.add-payment-or-remove-users":[{"type":0,"value":"Add payment to keep unlimited users and stay on Standard, or have your customer\u2019s admin remove users so you can switch back to Free in the "},{"type":1,"value":"partnerPurchasingCenterLink"},{"type":0,"value":". Take action "},{"type":1,"value":"takeActionBy"},{"type":0,"value":" to avoid site deactivation."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.billing-user-partner.add-payment-or-remove-users":[{"type":0,"value":"To keep unlimited and users stay on Standard, ensure your Atlassian billing partner updates your billing details. We\u2019ve also sent them instructions. To switch back to Free, "},{"type":1,"value":"removeUsersLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.billing-user-partner.take-action":[{"type":0,"value":"Take action "},{"type":1,"value":"takeActionBy"},{"type":0,"value":" to avoid site deactivation. For help, contact your Atlassian billing partner."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.direct-customer.add-payment-or-remove-users":[{"type":0,"value":"Add payment to keep unlimited users and stay on Standard, or "},{"type":1,"value":"removeUsersLink"},{"type":0,"value":" to switch back to the Free plan. Take action "},{"type":1,"value":"takeActionBy"},{"type":0,"value":" to avoid site deactivation."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.over-free-limit-moved-to-standard":[{"type":0,"value":"You\'re over the Free user limit, so we moved you to Standard, which includes unlimited users."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.partner-purchasing-center":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.remove-users":[{"type":0,"value":"remove users"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.take-action-by-trial-end-date-available":[{"type":0,"value":"by "},{"type":1,"value":"trialEndMonth"},{"type":0,"value":" "},{"offset":0,"options":{"few":{"value":[{"type":0,"value":"$rd"}]},"one":{"value":[{"type":7},{"type":0,"value":"st"}]},"other":{"value":[{"type":7},{"type":0,"value":"th"}]},"two":{"value":[{"type":7},{"type":0,"value":"nd"}]}},"pluralType":"ordinal","type":6,"value":"trialEndDate"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.take-action-by-trial-end-date-not-available":[{"type":0,"value":"soon"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.unlocks-additional-features":[{"type":0,"value":"Your new "},{"type":1,"value":"planName"},{"type":0,"value":" plan unlocks additional features to help your team achieve more together:"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.want-to-stay-on-standard":[{"type":0,"value":"Don\'t want to stay on "},{"type":1,"value":"planName"},{"type":0,"value":"?"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.partner-managed-subscriptions-link":[{"type":0,"value":"partner-managed subscriptions"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.partner-purchasing-link\'":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-bill-date-change-ccp.message-template-template.email.body.caption":[{"type":0,"value":"Your bill date will soon be changed"}],"commerce.commerce-subscription-bill-date-change-ccp.message-template-template.email.body.closing-line":[{"type":0,"value":"Your new bill date will be in effect from the next billing cycle. To transition you to the new\\n\\t\\t\\t\\t\\t  bill date, pro-rated adjustments will be applied to your next invoice."}],"commerce.commerce-subscription-bill-date-change-ccp.message-template-template.email.body.first-line":[{"type":0,"value":"We\'ve processed your request to change the bill date for your "},{"type":1,"value":"productName"},{"type":0,"value":"\\n\\t\\t\\t\\t\\t\\t("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") subscription to "},{"type":1,"value":"requestedNextBillingDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-bill-date-change-ccp.message-template-template.email.body.second-line":[{"type":0,"value":"If you have any other product and subscriptions on the same site that belong to the same product family,\\n            they need to be billed together. That means we\u2019ve changed the bill date for those subscriptions too."}],"commerce.commerce-subscription-bill-date-change-ccp.message-template.email.subject":[{"type":0,"value":"Your bill date will soon be changed"}],"commerce.commerce-subscription-cancellation-ecc.email.body.billing-partner":[{"type":0,"value":"Atlassian billing partner"}],"commerce.commerce-subscription-cancellation-ecc.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offering"},{"type":0,"value":" subscription is canceled"}],"commerce.commerce-subscription-cancellation-ecc.email.body.contact-atlassian-support":[{"type":0,"value":"contact Atlassian support"}],"commerce.commerce-subscription-cancellation-ecc.email.body.data-will-be-deleted":[{"type":0,"value":"Data will be deleted within 60 days from the date of cancellation. If you\u2019d like to request deletion of the data earlier, "}],"commerce.commerce-subscription-cancellation-ecc.email.body.reactivate":[{"type":0,"value":"Your Atlassian billing partner can ask us to reactivate the subscription if needed. If you weren\u2019t expecting this email, you can contact us."}],"commerce.commerce-subscription-cancellation-ecc.email.body.this-is-to-let-you-know":[{"type":0,"value":"This is to let you know that we\u2019ve canceled the following subscription:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-direct.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productInfo"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g-direct.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productInfo"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.auto-cancellation-info.uninvoiceable":[{"type":0,"value":"If you want to keep your subscription, you can update your billing details and then reactivate."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.cta-direct-customer.billing-user":[{"type":0,"value":"If you want to keep your subscription, you can ask a billing admin to reactivate it. "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.cta-direct-customer.billing-user.link":[{"type":0,"value":"Learn more about reactivation"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.cta-direct-customer.support.link":[{"type":0,"value":"see how to reactivate it"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.cta-direct-customer.support.link.twc":[{"type":0,"value":"reactivate your subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.ecc.partner-details":[{"type":0,"value":"Your partner details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.how-to-reactivate-subscription":[{"type":0,"value":"If you want to keep your subscription, you can "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.how-to-reactivate-subscription.twc":[{"type":0,"value":"We\'re sad to see you go, but if you change your mind, you can always "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.partner.customer-details":[{"type":0,"value":"Your customer details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.partner.subscription-details":[{"type":0,"value":"Your subscription details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.personal-data-retention-summary.direct-customer":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your product\'s data and preferences. You can also submit a "},{"type":1,"value":"deletionOfPersonalDataLink"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.personal-data-retention-summary.direct-customer.link":[{"type":0,"value":"request for deletion of your personal data."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.personal-data-retention-summary.direct-customer.link.twc":[{"type":0,"value":"immediate deletion of your personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.personal-data-retention-summary.direct-customer.twc":[{"type":0,"value":"If you reactivate your subscription within 60 days, your data and preferences will remain the same. For trials, data is stored for 15 days. You may also place a request for "},{"type":1,"value":"deletionOfPersonalDataLink"},{"type":0,"value":". Learn about the "},{"type":1,"value":"privacyPolicyLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.summary.dc-uncollectible":[{"type":0,"value":"We\u2019ve canceled the following subscription. This is because we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.summary.dc-uninvoiceable":[{"type":0,"value":"We\u2019ve canceled the following subscription. This is because we\u2019re missing the right payment details, so we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.summary.partner":[{"type":0,"value":"As requested, we\'ve canceled the following subscription:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.caption.direct-customer":[{"type":0,"value":"Your "},{"type":1,"value":"productInfo"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.caption.partner-end-customer-contact":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.direct-customer.body.cta.reactivate-subscription":[{"type":0,"value":"Reactivate subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.subject.partner-billing-admin-and-billing-user":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.subject.partner-bu-and-ecc":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.as-requested-we-have-cancelled-the-following-subscription":[{"type":0,"value":"As requested, we\'ve canceled the following subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.as-requested-we-have-cancelled-your-customers-subscription":[{"type":0,"value":"As requested, we\'ve canceled your customer\'s subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-customers-product-data":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your customer\'s product data and preferences."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-product-data":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your product\'s data and preferences."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.if-you-want-to-keep-your-subscription-reach-out-to-your-billing-partner-to-reactivate":[{"type":0,"value":"If you want to keep your subscription, reach out to your Atlassian billing partner to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.if-your-customer-wants-to-keep-the-subscription-reach-out-to-us-to-reactivate":[{"type":0,"value":"If your customer wants to keep the subscription, "},{"type":1,"value":"reachOutLink"},{"type":0,"value":" to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.reach-out-to-us":[{"type":0,"value":"reach out to us"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.request-for-deletion-of-their-personal-data":[{"type":0,"value":"request for deletion of their personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.request-for-deletion-of-your-personal-data":[{"type":0,"value":"request for deletion of your personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.special-char-colon":[{"type":0,"value":":"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.special-char-period":[{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.this-is-because-we-do-not-have-your-customers-billing-information":[{"type":0,"value":"This is because we don\'t have your customer\'s complete billing information. It could be because the information provided to us is incorrect or incomplete."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.this-is-because-we-were-not-able-to-collect-payment-for-an-invoice":[{"type":0,"value":"This is because we weren\'t able to collect payment for an invoice."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.update-your-customers-billing-details-and-then-reach-out-to-us-to-reactivate":[{"type":0,"value":"Update your customer\'s billing details and then "},{"type":1,"value":"reachOutLink"},{"type":0,"value":" to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.we-have-cancelled-your-customers-subscription":[{"type":0,"value":"We\'ve canceled your customer\'s subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.you-can-also-submit-a-request-for-deletion-of-your-personal-data":[{"type":0,"value":"You can also submit a "},{"type":1,"value":"requestForDeletionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.your-customer-can-also-submit-a-request-for-deletion-of-their-personal-data":[{"type":0,"value":"Your customer can also submit a "},{"type":1,"value":"requestForDeletionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.auto-cancellation-info.uninvoiceable":[{"type":0,"value":"If you want to keep your subscription, you can update your billing details and then reactivate."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.cta-direct-customer.billing-user":[{"type":0,"value":"If you want to keep your subscription, you can ask a billing admin to reactivate it. "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.cta-direct-customer.billing-user.link":[{"type":0,"value":"Learn more about reactivation"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.cta-direct-customer.support.link":[{"type":0,"value":"see how to reactivate it"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.cta-direct-customer.support.link.twc":[{"type":0,"value":"reactivate your subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.ecc.partner-details":[{"type":0,"value":"Your partner details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.how-to-reactivate-subscription":[{"type":0,"value":"If you want to keep your subscription, you can "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.how-to-reactivate-subscription.twc":[{"type":0,"value":"We\'re sad to see you go, but if you change your mind, you can always "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.partner.customer-details":[{"type":0,"value":"Your customer details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.partner.subscription-details":[{"type":0,"value":"Your subscription details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your app\'s data and preferences. You can also submit a "},{"type":1,"value":"deletionOfPersonalDataLink"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.link":[{"type":0,"value":"request for deletion of your personal data."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.link.twc":[{"type":0,"value":"immediate deletion of your personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.twc":[{"type":0,"value":"If you reactivate your subscription within 60 days, your data and preferences will remain the same. For trials, data is stored for 15 days. You may also place a request for "},{"type":1,"value":"deletionOfPersonalDataLink"},{"type":0,"value":". Learn about the "},{"type":1,"value":"privacyPolicyLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.summary.dc-uncollectible":[{"type":0,"value":"We\u2019ve canceled the following subscription. This is because we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.summary.dc-uninvoiceable":[{"type":0,"value":"We\u2019ve canceled the following subscription. This is because we\u2019re missing the right payment details, so we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.summary.partner":[{"type":0,"value":"As requested, we\'ve canceled the following subscription:"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.caption.direct-customer":[{"type":0,"value":"Your "},{"type":1,"value":"productInfo"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.caption.partner-end-customer-contact":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.direct-customer.body.cta.reactivate-subscription":[{"type":0,"value":"Reactivate subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.body.cta.reactivate-button":[{"type":0,"value":"Reactivate "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.body.exceeded-user-limit":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription was canceled because your team exceeded the 10-user limit on the Free plan and payment details were not added to upgrade to the Standard plan."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.body.restore-within-15-days":[{"type":0,"value":"You can restore your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription and all data within the next 15 days. After that, your data will be permanently deleted."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.body.restore-within-15-days-non-admin":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" admin can restore your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription and all data within the next 15 days. After that, your data will be permanently deleted."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has ended"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has ended"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.subject.partner-billing-admin-and-billing-user":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.subject.partner-bu-and-ecc":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.as-requested-we-have-cancelled-the-following-subscription":[{"type":0,"value":"As requested, we\'ve canceled the following subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.as-requested-we-have-cancelled-your-customers-subscription":[{"type":0,"value":"As requested, we\'ve canceled your customer\'s subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-customers-product-data":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your customer\'s product data and preferences."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-product-data":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your product\'s data and preferences."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-you-want-to-keep-your-subscription-reach-out-direct-customer-non-cloud":[{"type":0,"value":"If you want to keep your subscription, "},{"type":1,"value":"reachOutLinkForNonCloud"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-you-want-to-keep-your-subscription-reach-out-to-your-billing-partner-to-reactivate":[{"type":0,"value":"If you want to keep your subscription, reach out to your Atlassian billing partner to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-your-customer-wants-to-keep-the-subscription-reach-out-to-us-to-reactivate":[{"type":0,"value":"If your customer wants to keep the subscription, "},{"type":1,"value":"reachOutLink"},{"type":0,"value":" to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.reach-out-to-us":[{"type":0,"value":"reach out to us"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.request-for-deletion-of-their-personal-data":[{"type":0,"value":"request for deletion of their personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.request-for-deletion-of-your-personal-data":[{"type":0,"value":"request for deletion of your personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.special-char-colon":[{"type":0,"value":":"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.special-char-period":[{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.this-is-because-we-do-not-have-your-customers-billing-information":[{"type":0,"value":"This is because we don\'t have your customer\'s complete billing information. It could be because the information provided to us is incorrect or incomplete."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.this-is-because-we-were-not-able-to-collect-payment-for-an-invoice":[{"type":0,"value":"This is because we weren\'t able to collect payment for an invoice."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.update-your-customers-billing-details-and-then-reach-out-to-us-to-reactivate":[{"type":0,"value":"Update your customer\'s billing details and then "},{"type":1,"value":"reachOutLink"},{"type":0,"value":" to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.we-have-cancelled-your-customers-subscription":[{"type":0,"value":"We\'ve canceled your customer\'s subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.you-can-also-submit-a-request-for-deletion-of-your-personal-data":[{"type":0,"value":"You can also submit a "},{"type":1,"value":"requestForDeletionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.your-customer-can-also-submit-a-request-for-deletion-of-their-personal-data":[{"type":0,"value":"Your customer can also submit a "},{"type":1,"value":"requestForDeletionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.email.caption":[{"type":0,"value":"We\'re sad to see you go"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.email.direct-customer.jsm-requirement":[{"type":0,"value":"This is because our Marketplace app partner has updated the way this app is billed, which means it needs to be installed on Jira Service Management going forward. Since you don\'t have an active JSM subscription, the app can no longer be billed compatibly."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.email.direct-customer.prevention-option":[{"type":0,"value":"There\'s still time to prevent cancellation. You just need to purchase a Jira Service Management subscription before "},{"type":1,"value":"cancellationDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.email.partner.caption":[{"type":0,"value":"We\'re sad to see you go"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.email.partner.caption.twc":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" scheduled for cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.body.sub-cancel-note.twc":[{"type":0,"value":"Your subscription will be canceled at the end of your current billing cycle on "},{"children":[{"type":1,"value":"nextBillingDate"}],"type":8,"value":"b"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.billing-admin.keep-subscription":[{"type":0,"value":"You can always "},{"type":1,"value":"undoLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.billing-admin.manage-subscription-button":[{"type":0,"value":"View subscription"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.billing-admin.undo-cancellation-link":[{"type":0,"value":"undo your cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.billing-user.keep-subscription":[{"type":0,"value":"You can always "},{"type":1,"value":"undoLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.received-request":[{"type":0,"value":"We\'ve received your request to cancel your subscription:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.sub-cancel-note":[{"type":0,"value":"Your subscription will be canceled at the end of your current billing cycle on "},{"type":1,"value":"nextBillingDate"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":" Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" is scheduled for cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.billing-partner-details.twc":[{"type":0,"value":"Your billing partner details are:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.data-deletion-note":[{"type":0,"value":"Product data will be deleted in 60 days from the date of cancellation. For trials, we retain data for 15 days. If you\u2019d like to request deletion of personal data, "},{"type":1,"value":"contactSupport"},{"type":0,"value":". Learn about "},{"type":1,"value":"privacyPolicy"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.jira-decoupled.cancellation-notice":[{"type":0,"value":"Your subscription will be canceled on "},{"type":1,"value":"nextBillingDate"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\'ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.jira-decoupled.contact-us":[{"type":0,"value":"contact us"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.jira-decoupled.data-deletion-note":[{"type":0,"value":"Product data will be deleted 60 days from cancellation. For trials, we retain data for 15 days. If you\'d like to request deletion of personal data, "},{"type":1,"value":"contactUs"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.jira-decoupled.intro":[{"type":0,"value":"Your app subscription is scheduled for cancellation. This is because our Marketplace app partner has updated the way this app is billed, which means it needs to be installed on Jira Service Management going forward. Since you don\'t have an active JSM subscription, the app can no longer be billed compatibly."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.jira-decoupled.prevention-option":[{"type":0,"value":"There\'s still time to prevent cancellation. You just need to contact your Atlassian billing partner to purchase a Jira Service Management subscription before "},{"type":1,"value":"cancellationDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.received-request":[{"type":0,"value":"We\'ve received a request to cancel the following subscription:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.received-request.twc":[{"type":0,"value":"We\'ve received your request to cancel your subscription"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.undo-cancellation":[{"type":0,"value":"You can always "},{"type":1,"value":"undoLink"},{"type":0,"value":" from "},{"type":1,"value":"partnerManagedSubscriptionsLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.undo-cancellation-link":[{"type":0,"value":"undo your cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.email.ecc.subject":[{"type":1,"value":"billingPartnerName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.email.ecc.subject.twc":[{"type":1,"value":"billingPartnerName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" is scheduled for cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.billing-admin.keep-subscription":[{"type":0,"value":"If needed, you can contact us to reverse the cancellation request. If you reactivate the subscription within 60 days of cancellation, we\'ll restore the relevant data and preferences. For trials, the reactivation period is 15 days."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.billing-admin.undo-cancellation-link":[{"type":0,"value":"undo your cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.billing-user.keep-subscription":[{"type":0,"value":"If needed, you can contact us to reverse the cancellation request. "},{"type":1,"value":"undoLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.customer-details.twc":[{"type":0,"value":"Your customer details are:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.ecc.atlassian-privacy-policy":[{"type":0,"value":"Atlassian\u2019s Privacy Policy"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.ecc.contact-atlassian-support":[{"type":0,"value":"contact Atlassian support"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.ecc.contact-billing-partner":[{"type":0,"value":"You can contact your Atlassian billing partner if you need help or want to reverse the cancellation request."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.jira-decoupled.cancellation-notice":[{"type":0,"value":"Your subscription will be canceled on "},{"type":1,"value":"nextBillingDate"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\'ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.jira-decoupled.intro":[{"type":0,"value":"Your customer\'s app subscription is scheduled for cancellation. This is because our Marketplace app partner has updated the way this app is billed, which means it needs to be installed on Jira Service Management going forward. Since your customer doesn\'t have an active JSM subscription, the app can no longer be billed compatibly."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.jira-decoupled.prevention-option":[{"type":0,"value":"There\'s still time to prevent cancellation. You just need to purchase a Jira Service Management subscription before "},{"type":1,"value":"cancellationDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.keep-subscription":[{"type":0,"value":"Keeping the subscription"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.keep-subscription.twc":[{"type":0,"value":"Your customer contact can undo the cancellation at any time from "},{"type":1,"value":"partnerManagedSubscriptionsLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.partner-managed-subscriptions-link":[{"type":1,"value":"partnerManagedSubscriptionsLink"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.partner.billing-admin.undo-cancellation-link":[{"type":0,"value":"Learn how to undo a cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.received-request":[{"type":0,"value":"We\u2019ve received a request to cancel the following subscription:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.received-request.twc":[{"type":0,"value":"We\u2019ve received your customer\u2019s request to cancel their subscription."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.sub-cancel-note":[{"type":0,"value":"The subscription will be canceled at the end of the current billing cycle on "},{"type":1,"value":"nextBillingDate"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.sub-cancel-note.twc":[{"type":0,"value":"The subscription will be canceled at the end of the current billing cycle on "},{"children":[{"type":1,"value":"nextBillingDate"}],"type":8,"value":"b"},{"type":0,"value":". Until then, the subscription can still be used. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.subscription-details.twc":[{"type":0,"value":"Your subscription details are:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.subject.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" : "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.subject.with-company-name.twc":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.subject.without-company-name":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.subject.without-company-name.twc":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.direct-customer.body.could-not-process-payment":[{"type":0,"value":"This is to let you know that we\u2019ve canceled the following subscription since we were unable to process your payment. "}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.direct-customer.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.body.cta.reactivate-button":[{"type":0,"value":"Reactivate "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.body.exceeded-user-limit":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription was canceled because your team exceeded the 10-user limit on the Free plan and payment details were not added to upgrade to the Standard plan."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.body.restore-within-15-days":[{"type":0,"value":"You can restore your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription and all data within the next 15 days. After that, your data will be permanently deleted."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.body.restore-within-15-days-admin":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" admin can restore your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription and all data within the next 15 days. After that, your data will be permanently deleted."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has ended"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has ended"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.partner.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t collect payment for an invoice generated for the following subscription.As a result, the subscription has been canceled."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.partner.caption":[{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Subscription canceled due to non-payment"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.partner.subject.no-customer-company-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Subscription canceled due to non-payment"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.body.cta-direct-customer.reactivate-subscription":[{"type":0,"value":"Don\u2019t worry, all\u2019s not lost! You can "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.body.personal-data-retention-summary.direct-customer":[{"type":0,"value":"If you reactivate within 60 days, we\'ll restore your product\'s data and preferences. You can also submit a "},{"type":1,"value":"deletionOfPersonalDataLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.link":[{"type":0,"value":"request for deletion of your personal data"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t process payment for your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":") due to an issue with your payment details. As a result, we\'ve canceled your plan changes scheduled for "},{"type":1,"value":"scheduleStartDate"},{"type":0,"value":". "}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.cta.reactivate-subscription-button":[{"type":0,"value":"Reactivate subscription"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.product-list-item":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" | "},{"type":1,"value":"siteUrl"},{"type":0,"value":")"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.subscription-is-still-active":[{"type":1,"value":"productName"},{"type":0,"value":" subscription is still active, but the scheduled changes won\'t happen."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.update-payment-details":[{"type":0,"value":"We recommend updating your payment details to ensure this doesn\'t happen again."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your scheduled changes have been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.subject":[{"type":1,"value":"productName"},{"type":0,"value":" scheduled changes have been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t process payment for your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":") due to an issue with your payment details. As a result, we\'ve canceled your plan changes scheduled for "},{"type":1,"value":"scheduleStartDate"},{"type":0,"value":". "}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.body.payment-details-up-to-date":[{"type":0,"value":"To avoid this in the future, ensure your payment details are up to date."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.body.subscription-is-still-active":[{"type":1,"value":"productName"},{"type":0,"value":" subscription is still active, but the scheduled changes won\'t happen."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your scheduled changes have been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" scheduled changes canceled"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.dc.breached-upgrade-plan-info":[{"type":0,"value":"If you want to increase your included quantity, you can upgrade your plan."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.dc.breached-upgrade-plan-info.partner":[{"type":0,"value":"If you want to increase the included quantity, you can upgrade your customer\u2019s plan."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.dc.siteAdmin":[{"type":0,"value":"Administration"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.dc.what-you-need-to-do":[{"type":0,"value":"What do I need to do?"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.email.dc.billing-url":[{"type":1,"value":"url"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.dc.email.milestone-caption":[{"type":0,"value":"Your included quantity of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"},{"type":0,"value":" is running low"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.dc.email.subject.breached":[{"type":0,"value":"You\u2019ve exceeded your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.dc.email.subject.milestone":[{"type":0,"value":"You\u2019re running out of included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.body.subscription-details":[{"type":0,"value":"Subscription details:"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.breached-caption":[{"type":0,"value":"You\u2019ll now be charged extra for using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.breached-info-message":[{"type":0,"value":"We wanted to let you know that you\u2019ve reached your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.dc.body.included-qty-info":[{"type":0,"value":"Your plan includes "},{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":" of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":". "},{"type":1,"value":"viewUsage"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.dc.milestone-info-message":[{"type":0,"value":"We wanted to let you know that you\u2019ve reached "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.breached-what-to-know":[{"type":0,"value":"You can continue to use your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription as normal, but keep in mind that any "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" you use from now on will incur extra charges. Any extra usage charges will be reflected in your next invoice, and can be viewed in your site\u2019s "},{"type":1,"value":"admin"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.extra-charge-details":[{"type":0,"value":"Any extra charges will be reflected in your subscription details page"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.extra-charge-info":[{"type":0,"value":"If you go over this amount, extra usage charges will be added to your next invoice"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.upgrade-plan":[{"type":0,"value":"Upgrade your plan"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.upgrade-plan-increase-qty":[{"type":0,"value":"You can upgrade your plan to increase your included quantity"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.breached-what-to-know":[{"type":0,"value":"Your customer can continue to use their "},{"type":1,"value":"productName"},{"type":0,"value":" subscription as normal, but any "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" they use from now on will incur extra charges.Any extra charges will be reflected in the next bill, and can be viewed in the Partner Purchasing Centre."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.extra-charge-details":[{"type":0,"value":"Any extra charges will be reflected in the subscription details page"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.extra-charge-info":[{"type":0,"value":"If they go over this amount, extra usage charges will be added to their next invoice"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.included-qty-info":[{"type":0,"value":"This plan includes "},{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":" of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":". "},{"type":1,"value":"viewUsage"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.upgrade-plan-increase-qty":[{"type":0,"value":"You can upgrade the plan to increase your customer\u2019s included quantity"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.breached-caption":[{"type":0,"value":"Your customer will now be charged extra for using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.breached-info-message":[{"type":0,"value":"Your customer has reached their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.milestone-info-message":[{"type":0,"value":"Your customer has reached "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.what-you-need":[{"type":0,"value":"What you need to know:"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.partner.email.milestone-caption":[{"type":0,"value":"Included quantity of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"},{"type":0,"value":" is running low"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.partner.email.subject.breached.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" has exceeded their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.partner.email.subject.milestone.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is running out of included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.dc.breached-upgrade-plan-info":[{"type":0,"value":"If you want to increase your included quantity, you can upgrade your plan."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.dc.breached-upgrade-plan-info.partner":[{"type":0,"value":"If you want to increase the included quantity, you can upgrade your customer\u2019s plan."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.dc.siteAdmin":[{"type":0,"value":"Administration"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.dc.what-you-need-to-do":[{"type":0,"value":"What do I need to do?"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.email.dc.billing-url":[{"type":1,"value":"url"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.dc.email.milestone-caption":[{"type":0,"value":"Your included quantity of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"},{"type":0,"value":" is running low"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.dc.email.subject.breached":[{"type":0,"value":"You\u2019ve exceeded your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.dc.email.subject.milestone":[{"type":0,"value":"You\u2019re running out of included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.body.subscription-details":[{"type":0,"value":"Subscription details:"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.breached-caption":[{"type":0,"value":"You\u2019ll now be charged extra for using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.breached-info-message":[{"type":0,"value":"We wanted to let you know that you\u2019ve reached your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.dc.body.included-qty-info":[{"type":0,"value":"Your plan includes "},{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":" of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":". "},{"type":1,"value":"viewUsage"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.dc.milestone-info-message":[{"type":0,"value":"We wanted to let you know that you\u2019ve reached "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.breached-what-to-know":[{"type":0,"value":"You can continue to use your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription as normal, but keep in mind that any "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" you use from now on will incur extra charges. Any extra usage charges will be reflected in your next invoice, and can be viewed in your site\u2019s "},{"type":1,"value":"admin"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.extra-charge-details":[{"type":0,"value":"Any extra charges will be reflected in your subscription details page"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.extra-charge-info":[{"type":0,"value":"If you go over this amount, extra usage charges will be added to your next invoice"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.upgrade-plan":[{"type":0,"value":"Upgrade your plan"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.upgrade-plan-increase-qty":[{"type":0,"value":"You can upgrade your plan to increase your included quantity"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.breached-what-to-know":[{"type":0,"value":"Your customer can continue to use their "},{"type":1,"value":"productName"},{"type":0,"value":" subscription as normal, but any "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" they use from now on will incur extra charges.Any extra charges will be reflected in the next bill, and can be viewed in the Partner Purchasing Centre."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.extra-charge-details":[{"type":0,"value":"Any extra charges will be reflected in the subscription details page"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.extra-charge-info":[{"type":0,"value":"If they go over this amount, extra usage charges will be added to their next invoice"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.included-qty-info":[{"type":0,"value":"This plan includes "},{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":" of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":". "},{"type":1,"value":"viewUsage"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.upgrade-plan-increase-qty":[{"type":0,"value":"You can upgrade the plan to increase your customer\u2019s included quantity"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.breached-caption":[{"type":0,"value":"Your customer will now be charged extra for using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.breached-info-message":[{"type":0,"value":"Your customer has reached their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.milestone-info-message":[{"type":0,"value":"Your customer has reached "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.what-you-need":[{"type":0,"value":"What you need to know:"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.partner.email.milestone-caption":[{"type":0,"value":"Included quantity of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"},{"type":0,"value":" is running low"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.partner.email.subject.breached.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" has exceeded their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.partner.email.subject.milestone.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is running out of included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.caption":[{"type":0,"value":"Let\u2019s take it to the next level"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.caption.ecc":[{"type":0,"value":"Subscription moved from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.caption.partner":[{"type":0,"value":"Subscription moved from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.current-plan":[{"type":0,"value":"We\u2019re glad you\u2019re enjoying your monthly "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" plan for "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.direct-customer-caption":[{"type":0,"value":"Subscription moved from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.ecc-subscription-moved":[{"type":0,"value":"Based on a quote that\u2019s already paid, you have subscriptions that are now on annual from monthly."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.ecc-view-cancel-subscription":[{"type":0,"value":"You can view or cancel the subscription at any time from "},{"type":1,"value":"partnerManagedSubscriptionsUrl"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.managed-subscriptions-url":[{"type":1,"value":"url"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.partner-manage-subscription":[{"type":0,"value":"You can manage the subscription from the "},{"type":1,"value":"partnerPurchaseCentralUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.partner-subscription-moved":[{"type":0,"value":"Based on a quote that\u2019s already paid, your customer\u2019s subscriptions are now on annual from monthly."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.partner-view-cancel-subscription":[{"type":0,"value":"Your customer contact can view and cancel the subscription at any time from "},{"type":1,"value":"partnerManagedSubscriptionsUrl"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-subscription-list":[{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"},{"type":1,"value":"siteUrlSeparator"},{"children":[{"type":1,"value":"siteUrl"}],"type":8,"value":"siteUrlLink"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-subscription-moved":[{"type":0,"value":"Based on a quote that you\u2019ve already paid, you have subscriptions that are now on annual from monthly."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-view-cancel-subscription":[{"type":0,"value":"You can view and manage your subscription from your billing account. "}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.body.charge-note.auto-renewal":[{"type":0,"value":" We\u2019ll charge your chosen payment details annually, and your subscription will be renewed automatically each year. Don\u2019t worry \u2013 we\u2019ll let you know when your renewal is coming up."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.body.charge-note.termed":[{"type":0,"value":"We\'ll charge your chosen payment details and let you know when your renewal is coming up."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.body.plan-note.auto-renewal":[{"type":0,"value":"As requested, your subscription has now been moved to the annual (auto-renewal) plan."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.body.plan-note.termed":[{"type":0,"value":"As requested, your subscription has now been moved to the annual plan."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" subscription"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject.ECC":[{"type":0,"value":"["},{"type":1,"value":"customerName"},{"type":0,"value":"] Billing cycle changed from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject.direct":[{"type":0,"value":"Billing cycle changed from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject.nonpause-billing":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" subscription"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject.partner":[{"type":0,"value":"["},{"type":1,"value":"customerName"},{"type":0,"value":"] Billing cycle changed from monthly to annual"}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.caption":[{"type":0,"value":"Let\u2019s make it long term"}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.charge-note.auto-renewal":[{"type":0,"value":"We\u2019ll charge your chosen payment details annually for this subscription, and it will be renewed automatically each year. Don\u2019t worry \u2013 we\u2019ll let you know when your renewal is coming up."}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.charge-note.termed":[{"type":0,"value":" We\'ll charge your chosen payment details and let you know when your renewal is coming up."}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.subscription-note.auto-renewal":[{"type":0,"value":"We hope you\'ve enjoyed your monthly "},{"type":1,"value":"oldPricingPlan"},{"type":0,"value":" trial for "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":").\\n\\t\\t\\t\\tAs requested, your subscription has been moved to an annual (auto-renewal) plan, which will start after\\n\\t\\t\\t\\tyour trial period has ended."}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.subscription-note.termed":[{"type":0,"value":"We hope you\'ve enjoyed your monthly "},{"type":1,"value":"oldPricingPlan"},{"type":0,"value":" trial for "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":").\\n                As requested, your subscription has been moved to an annual plan, which will start after your trial\\n                period has ended."}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.subject":[{"type":0,"value":"Let\u2019s make it long term"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.body.charge-quantities-added-message":[{"type":0,"value":"You added new "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" to your subscription. Based on these changes, we\u2019ve adjusted your billed "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" to "},{"type":1,"value":"maximumBillingUsageValue"},{"type":0,"value":" and prorated the cost for new "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" for the remaining time in your billing period."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.body.estimated-bill":[{"type":0,"value":"Your estimated bill for the next billing cycle is "},{"children":[{"type":1,"value":"currency"},{"type":0,"value":" "},{"type":1,"value":"amountExcludingTax"}],"type":8,"value":"b"},{"type":0,"value":" (excluding tax)."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.body.final-invoice-details":[{"type":0,"value":"Your final invoice will reflect all "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" added before the end of your current billing period and the subsequent prorated charges."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.body.to-view-bill":[{"type":0,"value":"To view your bill breakdown and usage details, visit your "},{"children":[{"type":0,"value":"Subscription details"}],"type":8,"value":"b"},{"type":0,"value":" page."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your team is growing"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"New "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" added to "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.body.charge-quantities-added-message":[{"type":0,"value":"More "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" have been added to the following subscription:"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.body.final-invoice-details":[{"type":0,"value":"The final invoice will reflect the total number of "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" added before the end of the current billing cycle."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.body.p2-billing-adjusted":[{"type":0,"value":"The billed "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" have been adjusted to "},{"type":1,"value":"maximumBillingUsageValue"},{"type":0,"value":" and the cost for the new "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" has been prorated for the remaining time in the billing period."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.body.ppc":[{"type":0,"value":"You can view the usage details from our "},{"type":1,"value":"ppcSubscriptionsPageLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your customer\u2019s team is growing"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.subject.with-customer-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" New "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.subject.without-customer-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" New "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-offering-cancellation-ccp.email.app-retiring":[{"type":0,"value":"We wanted to let you know that we\u2019re no longer offering "},{"type":1,"value":"appName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". "}],"commerce.commerce-subscription-offering-cancellation-ccp.email.cancelled-at-end-of-billing-cycle":[{"type":0,"value":"This means your subscription will be canceled at the end of your last billing cycle."}],"commerce.commerce-subscription-offering-cancellation-ccp.email.cancelled-immediately":[{"type":0,"value":"This means your subscription will be canceled 30 days from the date of this email."}],"commerce.commerce-subscription-offering-cancellation-ccp.email.cancelled-on-offering-expiry-date":[{"type":0,"value":"This means your subscription will be canceled on "},{"type":1,"value":"expiryDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-offering-cancellation-ccp.email.caption":[{"type":1,"value":"appName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" is being retired"}],"commerce.commerce-subscription-offering-cancellation-ccp.message-template.email.body.subscription-details":[{"type":0,"value":"Subscription details:"}],"commerce.commerce-subscription-offering-cancellation-ccp.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"appName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription will be canceled"}],"commerce.commerce-subscription-offering-movement-ccp.email.app-getting-replaced":[{"type":0,"value":" The developers of "},{"type":1,"value":"appName"},{"type":0,"value":" are retiring this app and replacing it with a free version. Your paid\\n                subscription will transition to "},{"type":1,"value":"freeAppName"},{"type":0,"value":". From the end of your last billing cycle, you\u2019ll no \\n\\t\\t\\t\\tlonger be charged for this app."}],"commerce.commerce-subscription-offering-movement-ccp.email.caption":[{"type":0,"value":"Your paid subscription for this app will convert to a free subscription"}],"commerce.commerce-subscription-offering-movement-ccp.message-template.email.subject":[{"type":1,"value":"appName"},{"type":0,"value":" is being retired."}],"commerce.commerce-subscription-opt-out-ccp-g.direct.message-template.email.body.billing-info":[{"type":0,"value":"We\u2019ll charge you for your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation. You may first be charged a prorated amount to align your bill date with your previous plan. Any remaining days of your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan will be adjusted as credits in your invoice."}],"commerce.commerce-subscription-opt-out-ccp-g.direct.message-template.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" free trial has ended"}],"commerce.commerce-subscription-opt-out-ccp-g.direct.message-template.email.body.intimation":[{"type":0,"value":"We hope you enjoyed your free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":". Your paid "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan has now started from date "},{"type":1,"value":"billingStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-opt-out-ccp-g.message-template.email.subject":[{"type":0,"value":"Your no-cost, trial period on "},{"type":1,"value":"productName"},{"type":0,"value":" paid plan has ended"}],"commerce.commerce-subscription-opt-out-ccp-g.partner.message-template.email.body.billing-info":[{"type":0,"value":"We\u2019ll charge for the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation. Your customer may first be charged a prorated amount to align their bill date with the previous plan. Any remaining days of the "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan will be adjusted as credits in the invoice."}],"commerce.commerce-subscription-opt-out-ccp-g.partner.message-template.email.body.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" trial has ended"}],"commerce.commerce-subscription-opt-out-ccp-g.partner.message-template.email.body.upgradation":[{"type":0,"value":"The subscription is now upgraded from a "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" paid plan to a "},{"type":1,"value":"offeringName"},{"type":0,"value":" paid plan."}],"commerce.commerce-subscription-opt-out-ccp-g.partner.message-template.email.intimation":[{"type":0,"value":"The free "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan trial for the following product has ended."}],"commerce.commerce-subscription-opt-out-ccp-grouped.email.direct.body.allowance-contributions-enforcement-ubp5":[{"type":0,"value":"Remember \u2014 if your organization admin has enabled extra usage, any usage above the allowance will incur extra usage charges. These will be reflected on your bill at the end of the cycle. Organization admins can adjust usage limits anytime. "}],"commerce.commerce-subscription-opt-out-ccp-grouped.email.partner.body.allowance-contributions-enforcement-ubp5":[{"type":0,"value":"Remember \u2014 if you\u2019ve enabled extra usage, any usage above the allowance will incur extra usage charges. These will be reflected on your bill at the end of the cycle. You can adjust usage limits anytime."}],"commerce.commerce-subscription-opt-out-ccp.direct.message-template.email.body.billing-info":[{"type":0,"value":"We\u2019ll charge you for your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation. You may first be charged a prorated amount to align your bill date with your previous plan. Any remaining days of your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan will be adjusted as credits in your invoice."}],"commerce.commerce-subscription-opt-out-ccp.direct.message-template.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" free trial has ended"}],"commerce.commerce-subscription-opt-out-ccp.direct.message-template.email.body.caption.upsell-twc":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan is active"}],"commerce.commerce-subscription-opt-out-ccp.direct.message-template.email.body.intimation":[{"type":0,"value":"We hope you enjoyed your free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":". Your paid "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan has now started from date "},{"type":1,"value":"billingStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-opt-out-ccp.email.direct.body.allowance-contributions-enforcement-ubp5":[{"type":0,"value":"Remember, if your organization admin has enabled extra usage, any usage above the allowance may incur extra usage charges, which will be added to your bill at the end of your bill cycle. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-opt-out-ccp.email.partner.body.allowance-contributions-enforcement-ubp5":[{"type":0,"value":"Remember, any usage above the allowance may incur extra usage charges, which will be added to your customer\'s bill at the end of the bill cycle. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-opt-out-ccp.message-template.direct.email.body.trial-end-upsell-twc-offer.confluence-decrease":[{"type":0,"value":"Get more out of Confluence, Jira, Loom, and Rovo in one bundle and save."}],"commerce.commerce-subscription-opt-out-ccp.message-template.direct.email.body.trial-end-upsell-twc-offer.confluence-increase":[{"type":0,"value":"Get more out of "},{"type":1,"value":"productName"},{"type":0,"value":" and level-up your pages with Teamwork Collection."}],"commerce.commerce-subscription-opt-out-ccp.message-template.direct.email.body.trial-end-upsell-twc-offer.jira-decrease":[{"type":0,"value":"Get more out of Jira, Confluence, Loom, and Rovo in one bundle and save."}],"commerce.commerce-subscription-opt-out-ccp.message-template.direct.email.body.trial-end-upsell-twc-offer.jira-increase":[{"type":0,"value":"Get more out of "},{"type":1,"value":"productName"},{"type":0,"value":" and level-up your projects with Teamwork Collection."}],"commerce.commerce-subscription-opt-out-ccp.message-template.direct.email.body.trial-end-upsell-twc-offer.loom-decrease":[{"type":0,"value":"Get Loom, Jira, Confluence, and Rovo in one bundle and save."}],"commerce.commerce-subscription-opt-out-ccp.message-template.direct.email.body.trial-end-upsell-twc-offer.loom-increase":[{"type":0,"value":"Get Loom, Jira, Confluence, and Rovo in one bundle for just $5 more each month."}],"commerce.commerce-subscription-opt-out-ccp.message-template.direct.email.body.trial-end-upsell-twc-offer.plan-started":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan started on "},{"type":1,"value":"billingStartDate"},{"type":0,"value":". "}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.subject":[{"type":0,"value":"Your no-cost, trial period on "},{"type":1,"value":"productName"},{"type":0,"value":" paid plan has ended"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.confluence-price-decrease.row.one.description":[{"type":0,"value":"Bundle Confluence with Jira, Loom, and Rovo"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.confluence-price-decrease.row.three.title":[{"type":0,"value":"Switch back anytime"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.confluence-price-decrease.row.two.description":[{"type":0,"value":"Pay less for all four apps than you currently pay for Confluence"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.confluence-price-decrease.title":[{"type":0,"value":"Want to pay less for Confluence?"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.confluence-price-increase.row.one.description":[{"type":0,"value":"of apps, Jira, Confluence, Loom, and Rovo"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.confluence-price-increase.row.one.title":[{"type":0,"value":"One collection"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.confluence-price-increase.row.three.description":[{"type":0,"value":"to make sure AI is as useful as it can be"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.confluence-price-increase.row.three.title":[{"type":0,"value":"More context"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.confluence-price-increase.row.two.description":[{"type":0,"value":"to instantly create more pages and whiteboards"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.confluence-price-increase.row.two.title":[{"type":0,"value":"More AI credits"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.confluence-price-increase.title":[{"type":0,"value":"Take your pages to the next level"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.cta.explore":[{"type":0,"value":"Explore Teamwork collection"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.cta.see-pricing":[{"type":0,"value":"See pricing"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.jira-price-decrease.row.one.description":[{"type":0,"value":"Bundle Jira with Confluence, Loom, and Rovo"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.jira-price-decrease.row.three.title":[{"type":0,"value":"Switch back anytime"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.jira-price-decrease.row.two.description":[{"type":0,"value":"Pay less for all four apps than you currently pay for Jira"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.jira-price-decrease.title":[{"type":0,"value":"Want to pay less for Jira?"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.jira-price-increase.row.one.description":[{"type":0,"value":"of apps, Jira, Confluence, Loom, and Rovo"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.jira-price-increase.row.one.title":[{"type":0,"value":"One collection"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.jira-price-increase.row.three.description":[{"type":0,"value":"to instantly create work in bulk"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.jira-price-increase.row.three.title":[{"type":0,"value":"More agents"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.jira-price-increase.row.two.description":[{"type":0,"value":"to automatically triage more work"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.jira-price-increase.row.two.title":[{"type":0,"value":"More AI credits"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.jira-price-increase.title":[{"type":0,"value":"Take your projects to the next level"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.loom-business-and-ai.row.one.description":[{"type":0,"value":"of apps, Jira, Confluence, Loom, and Rovo"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.loom-business-and-ai.row.one.title":[{"type":0,"value":"One collection"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.loom-business-and-ai.row.three.description":[{"type":0,"value":"for less than you think"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.loom-business-and-ai.row.three.title":[{"type":0,"value":"All in one place"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.loom-business-and-ai.row.two.description":[{"type":0,"value":"to easily connect Loom with your other tools"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.loom-business-and-ai.row.two.title":[{"type":0,"value":"More AI credits"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.loom-business-and-ai.title":[{"type":0,"value":"Get more from Loom with the full collection"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.loom-business.row.one.title":[{"type":0,"value":"Bundle Loom with Jira, Confluence, and Rovo"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.loom-business.row.three.title":[{"type":0,"value":"Switch back anytime"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.loom-business.row.two.title":[{"type":0,"value":"Pay less for all four apps than you currently pay for Loom"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.loom-business.title":[{"type":0,"value":"Want to pay less for Loom?"}],"commerce.commerce-subscription-opt-out-ccp.partner.message-template.email.body.billing-info":[{"type":0,"value":"We\u2019ll charge for the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation. Your customer may first be charged a prorated amount to align their bill date with the previous plan. Any remaining days of the "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan will be adjusted as credits in the invoice."}],"commerce.commerce-subscription-opt-out-ccp.partner.message-template.email.body.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" trial has ended"}],"commerce.commerce-subscription-opt-out-ccp.partner.message-template.email.body.upgradation":[{"type":0,"value":"The subscription is now upgraded from a "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" paid plan to a "},{"type":1,"value":"offeringName"},{"type":0,"value":" paid plan."}],"commerce.commerce-subscription-opt-out-ccp.partner.message-template.email.intimation":[{"type":0,"value":"The free "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan trial for the following product has ended."}],"commerce.commerce-subscription-order-fulfilled-ccp.message-template.email.reseller.body.manage-subscription":[{"type":0,"value":"You can view "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" and billing details on your "},{"type":1,"value":"manageSubscriptionUrl"},{"type":0,"value":" page."}],"commerce.commerce-subscription-order-fulfilled-ccp.message-template.email.reseller.manage-url":[{"type":0,"value":"Manage Subscriptions"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.ba-when-the-trial-ends":[{"type":0,"value":"Your subscription will be canceled, unless you place an order for the paid plan before the trial end date. "},{"type":1,"value":"upGradeTrialContent"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.bu-when-the-trial-ends":[{"type":0,"value":"When you\'re ready to start paid subscription, your billing admin will need to use the quote we send them to place an order."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.caption-new":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.caption-partner-new":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p1":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". The trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p1.partner":[{"type":0,"value":"This is to notify you that your customer\'s free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has started."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p2.partner":[{"type":0,"value":"When trial ends, the subscription will be deactivated. To extend the trial "},{"type":1,"value":"reachOutTous"},{"type":0,"value":" before the trial end date. You may also request a quote, valid until the trial expiry date."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p3":[{"type":0,"value":"We\'ve sent a quote to your billing admin. When you\'re ready to start your paid subscription, your billing admin will need to use the quote to place an order."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p3-admin":[{"type":0,"value":"During your trial, we\'ll send you a quote. When you\'re ready to start your paid subscription, you can use the quote to place the order."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.reach-out-us":[{"type":0,"value":"reach out to us"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.twc.p1":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". The trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" - to start making the most of it, make sure you "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.twc.p1.partner":[{"type":0,"value":"This is to notify you that your customer\'s free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has started. To start making the most of it, make sure you or your customer "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.ba.upgrade-trial-description":[{"type":0,"value":"Your customer will be charged for their existing "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan and any included quantities until then."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.cbp-details":[{"type":0,"value":"Your trial includes:"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.cbps-description":[{"type":0,"value":"As part of the free trial, usage can\u2019t exceed the included quantity or allocation for each applicable usage type. Once the paid plan starts, extra usage will be allowed, and extra usage charges will be added to the invoice as required. "},{"children":[{"type":0,"value":"More about how billing works."}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.cbp-description":[{"type":0,"value":"As part of the free trial, your customer can only use up to the included amount for each quota. If they want extra usage straight away you can contact us. Otherwise, they\u2019ll be able to use more than the included quantity once their paid plan starts, and extra usage charges will be added to the invoice as per their usage."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.cbp-details":[{"type":0,"value":"The subscription also includes the following quotas:"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.trial-ends":[{"type":0,"value":"The trial ends on "},{"type":1,"value":"trialEndDate"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.trial-ends-description":[{"type":0,"value":"Your trial will be automatically converted to the paid plan once your trial ends. "},{"type":1,"value":"upGradeTrialContent"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.upgrade-trial-cbp-description":[{"type":0,"value":" When we invoice your customer for their upgraded plan, we\u2019ll also include any extra usage charges from the previous plan."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.upgrade-trial-description":[{"type":0,"value":"Your customer will be charged for their existing "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan and any included quantities until then."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"As part of the free trial, users can only use up to 2,000 Rovo Dev credits. Rovo Dev functionality will be disabled for any user who reaches this usage. Once the paid plan starts, they\u2019ll be able to use more for USD\xa00.01 per extra Rovo Dev credit. To keep spending predictable, organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration. You can view detailed usage in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.upgrade-cbp-details":[{"type":0,"value":"Your new plan includes:"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.upgrade-trial-cbp-description":[{"type":0,"value":" When we invoice you for your upgraded plan, we\u2019ll also include any extra usage charges from your previous plan."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.dc.body.ubp5-enforcement":[{"type":0,"value":"During your trial, you can only use the allowances included in your subscription."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.dc.twc.body.ubp5-enforcement":[{"type":0,"value":"During your trial, you can only use the allowances included in your subscription."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.partner.body.twc.ubp5-enforcement":[{"type":0,"value":"During the trial, your customer can only use the allowances included in their subscription."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.partner.body.ubp5-enforcement":[{"type":0,"value":"During the trial, your customer can only use the allowances included in their subscription."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.partner.body.upgraded-cbp-details":[{"type":0,"value":"The new plan includes:"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.partner.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.subject-new":[{"type":0,"value":"Your new "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-paid-trials-cc.message-template.email.direct-customer.body.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.caption-new":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.cbp-details":[{"type":0,"value":"Your trial includes:"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.cbps-description":[{"type":0,"value":"As part of the free trial, usage can\u2019t exceed the included quantity or allowance for each applicable usage type. Once the paid plan starts, extra usage will be allowed, and extra usage charges will be added to the invoice as required. "},{"children":[{"type":0,"value":"More about how billing works."}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.good-news":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.as-requested":[{"type":0,"value":"Your customer\'s free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has started."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.caption-new":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.cbps-description":[{"type":0,"value":"During the trial, your customer can only use the allowances included in their subscription."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcSubscriptionsPageLink"},{"type":0,"value":". You won\'t be charged if you switch before the trial ends."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.rovo-dev-description":[{"type":0,"value":"As part of the free trial, your customer can only use up to 2,000 Rovo Dev credits. Rovo Dev functionality will be disabled for any user who reaches this usage. Once the paid plan starts, they\u2019ll be able to use more for USD\xa00.01 per extra Rovo Dev credit. To keep spending predictable, organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.subscription-includes":[{"type":0,"value":"The subscription also includes the following:"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.trial-ends-description":[{"type":0,"value":"Your trial will be automatically converted to the paid plan once your trial ends. "},{"type":1,"value":"upGradeTrialContent"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.trial-ends-on":[{"type":0,"value":"The trial ends on "},{"type":1,"value":"trialEndDate"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.twc-as-requested":[{"type":0,"value":"Your customer\'s free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has started. To start making the most of it, make sure you or your customer "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.upgrade-trial-cbp-description":[{"type":0,"value":" When we invoice your customer for their upgraded plan, we\u2019ll also include any extra usage charges from the previous plan."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.upgrade-trial-description":[{"type":0,"value":"Your customer will be charged for their existing "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan and any included quantities until then."},{"type":1,"value":"upgradeTrialCbpContent"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"As part of the free trial, users can only use up to 2,000 Rovo Dev credits. Rovo Dev functionality will be disabled for any user who reaches this usage. Once the paid plan starts, they\u2019ll be able to use more for USD\xa00.01 per extra Rovo Dev credit. To keep spending predictable, organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration. You can view detailed usage in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.trial-ends-description":[{"type":0,"value":"Your trial will be automatically converted to the paid plan once your trial ends"},{"type":1,"value":"upGradeTrialContent"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.twc-good-news":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" - to start making the most of it, make sure you "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.upgrade-trial-cbp-description":[{"type":0,"value":" When we invoice you for your upgraded plan, we\u2019ll also include any extra usage charges from your previous plan."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.upgrade-trial-description":[{"type":0,"value":", and you\u2019ll continue to be charged for your existing "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan and any included quantities until then."},{"type":1,"value":"upgradeTrialCbpContent"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.dc.body.ubp5-enforcement":[{"type":0,"value":"During your trial, you can only use the allowances included in your subscription."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.dc.twc.body.ubp5-enforcement":[{"type":0,"value":"During your trial, you can only use the allowances included in your subscription."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-direct-trial-optimization.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-direct-trial-optimization.changed-your-mind":[{"type":0,"value":"Changed your mind?"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-direct-trial-optimization.subtitle":[{"type":0,"value":"Your free "},{"children":[{"type":1,"value":"trialLength"},{"type":0,"value":" trial"}],"type":8,"value":"b"},{"type":0,"value":" has started. Your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-direct-trial-optimization.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.cta.get-started":[{"type":0,"value":"Get started"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.confluence.access":[{"children":[{"type":0,"value":"Set access guardrails."}],"type":8,"value":"b"},{"type":0,"value":" Control what users can create and see."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.confluence.docs":[{"children":[{"type":0,"value":"Create docs instantly."}],"type":8,"value":"b"},{"type":0,"value":" Generate plans, roadmaps, and more with AI."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.confluence.find":[{"children":[{"type":0,"value":"Find what you need."}],"type":8,"value":"b"},{"type":0,"value":" Search across all your connected apps in one place."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jira.access":[{"children":[{"type":0,"value":"Set access guardrails."}],"type":8,"value":"b"},{"type":0,"value":" Control what users can create and see."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jira.automate":[{"children":[{"type":0,"value":"Automate tedious tasks."}],"type":8,"value":"b"},{"type":0,"value":" Set rules for repetitive updates."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jira.plans":[{"children":[{"type":0,"value":"Turn plans into work."}],"type":8,"value":"b"},{"type":0,"value":" Create work items from docs using AI."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jpd.access":[{"children":[{"type":0,"value":"Set access guardrails."}],"type":8,"value":"b"},{"type":0,"value":" Control what users can create and see."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jpd.align":[{"children":[{"type":0,"value":"Align your team."}],"type":8,"value":"b"},{"type":0,"value":" Share plans with co-workers, no sign up required."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jpd.prioritize":[{"children":[{"type":0,"value":"Prioritize ideas."}],"type":8,"value":"b"},{"type":0,"value":" Define and refine your opportunities in one place."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.loom.edit":[{"children":[{"type":0,"value":"Edit your videos."}],"type":8,"value":"b"},{"type":0,"value":" Cut \u201Cums\u201D and more with trim and stitch tools."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.loom.engagement":[{"children":[{"type":0,"value":"Understand engagement."}],"type":8,"value":"b"},{"type":0,"value":" See who watched and for how long."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.loom.record":[{"children":[{"type":0,"value":"Record without limits."}],"type":8,"value":"b"},{"type":0,"value":" Create and share unlimited videos."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.twc.confluence":[{"children":[{"type":0,"value":"Create docs instantly."}],"type":8,"value":"b"},{"type":0,"value":" Generate plans, roadmaps, and more with AI."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.twc.jira":[{"children":[{"type":0,"value":"Turn plans into work."}],"type":8,"value":"b"},{"type":0,"value":" Create work items from docs using AI."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.twc.loom":[{"children":[{"type":0,"value":"Align without meetings."}],"type":8,"value":"b"},{"type":0,"value":" Explain work or decisions with async video."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.twc.rovo":[{"children":[{"type":0,"value":"Put agents to work."}],"type":8,"value":"b"},{"type":0,"value":" Create AI agents to handle specific tasks."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.how-trial-works.bullet-full-access":[{"type":0,"value":"You get full access to all "},{"children":[{"type":1,"value":"planName"},{"type":0,"value":" features"}],"type":8,"value":"link"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.how-trial-works.bullet-refund":[{"type":0,"value":"You can request a refund within 30 days if you forget to cancel."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.how-trial-works.bullet-reminder":[{"type":0,"value":"We\'ll remind you 3 days before your trial ends. Cancel anytime."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.how-trial-works.title":[{"type":0,"value":"How your trial works"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subject":[{"type":0,"value":"Your new "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.next-bill-date.label":[{"type":0,"value":"Next bill date"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.next-bill-estimate.label":[{"type":0,"value":"Next bill estimate"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.next-bill-estimate.value":[{"type":1,"value":"amount"},{"type":0,"value":" "},{"type":1,"value":"billingCycle"},{"type":0,"value":" (excluding taxes)"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.plan.label":[{"type":0,"value":"Plan"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.rovo-credits.label":[{"type":0,"value":"Rovo credits"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.rovo-credits.value":[{"type":1,"value":"quantity"},{"type":0,"value":" per user / month"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.title":[{"type":0,"value":"Subscription details"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subtitle":[{"type":0,"value":"Your free "},{"children":[{"type":1,"value":"trialLength"},{"type":0,"value":" trial"}],"type":8,"value":"b"},{"type":0,"value":" has started. "},{"type":1,"value":"offeringName"},{"type":0,"value":" gives you unlimited users and advanced features that help you:"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.title.confluence":[{"type":0,"value":"Create and collaborate in one place"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.title.jira":[{"type":0,"value":"Start building better workflows"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.title.jpd":[{"type":0,"value":"Discover your next great product idea"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.title.loom":[{"type":0,"value":"Align your team without extra meetings"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.title.twc":[{"type":0,"value":"Sync work across teams, all in one place"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-trial-optimization.features.keep-work":[{"type":0,"value":"Keep all of your work if you change plans."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-trial-optimization.features.refund":[{"type":0,"value":"Get a refund if you forget to cancel within 30 days."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-trial-optimization.features.reminder":[{"type":0,"value":"We\'ll remind you 3 days before your trial ends. Cancel anytime."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.partner.body.twc.ubp5-enforcement":[{"type":0,"value":"During the trial, your customer can only use the allowances included in their subscription."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.partner.body.ubp5-enforcement":[{"type":0,"value":"During the trial, your customer can only use the allowances included in their subscription."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.subject-new":[{"type":0,"value":"Your new "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.subject-new.partners":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": new "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.cbps-description":[{"type":0,"value":"As part of the free trial, usage can\u2019t exceed the included quantity or allocation for each applicable usage type. Once the paid plan starts, extra usage will be allowed, and extra usage charges will be added to the invoice as required. "},{"children":[{"type":0,"value":"More about how billing works."}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.cta-admin-button":[{"type":0,"value":"Add payment details"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.cta-user":[{"type":0,"value":"For a seamless transition when your trial ends, your billing admin will need to add payment details before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.downgrade-to-free":[{"type":0,"value":"Add your payment details by "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" to continue using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" without any disruption. If you\u2019re under the user limit and don\u2019t add payment, you\u2019ll automatically switch to the Free plan at the end of your trial."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"As part of the free trial, users can only use up to 2,000 Rovo Dev credits. Rovo Dev functionality will be disabled for any user who reaches this usage. Once the paid plan starts, they\u2019ll be able to use more for USD\xa00.01 per extra Rovo Dev credit. To keep spending predictable, organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration. You can view detailed usage in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.trial-started":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.twc.trial-started":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" - to start making the most of it, make sure you "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.caption-new":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.cta-button":[{"type":0,"value":"Add payment details"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.heading":[{"type":0,"value":"Add payment details to keep your current features"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.intro":[{"type":0,"value":"Your team has been busy in "},{"type":1,"value":"productName"},{"type":0,"value":", and we want to make sure you have everything you need to keep moving forward."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.keep-plan-consequence":[{"type":0,"value":"You won\'t be charged until your trial ends. If you don\'t add payment details, your site will automatically move to the "},{"type":1,"value":"productName"},{"type":0,"value":" Free plan."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.keep-plan.confluence-premium":[{"type":0,"value":"To keep using "},{"type":1,"value":"offeringName"},{"type":0,"value":" features like advanced permissions and analytics after your trial ends, add your payment details before "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.keep-plan.confluence-standard":[{"type":0,"value":"To keep using "},{"type":1,"value":"offeringName"},{"type":0,"value":" features like audit logs and 250 GB of storage after your trial ends, add your payment details before "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.keep-plan.generic":[{"type":0,"value":"To keep using "},{"type":1,"value":"offeringName"},{"type":0,"value":" features after your trial ends, add your payment details before "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.keep-plan.jira-premium":[{"type":0,"value":"To keep using "},{"type":1,"value":"offeringName"},{"type":0,"value":" features like advanced planning and unlimited automation after your trial ends, add your payment details before "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.keep-plan.jira-standard":[{"type":0,"value":"To keep using "},{"type":1,"value":"offeringName"},{"type":0,"value":" features like audit logs and increased user limits after your trial ends, add your payment details before "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.section-heading":[{"type":0,"value":"Stay on your current plan"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.subject":[{"type":0,"value":"You\'re currently using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.subject.confluence":[{"type":0,"value":"You\'re using "},{"type":1,"value":"offeringName"},{"type":0,"value":" features, here\'s how to keep them \uD83D\uDCA1"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.trial-details":[{"type":0,"value":"When you signed up, we started you on a "},{"children":[{"type":1,"value":"trialLength"},{"type":0,"value":" trial"}],"type":8,"value":"b"},{"type":0,"value":" of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" so you could experience our most powerful features. Your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.subject-new":[{"type":0,"value":"Your new "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.caption":[{"type":0,"value":"Your subscription is successfully reactivated"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.caption.grouped":[{"type":0,"value":"Your subscription is successfully reactivated"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.plans":[{"type":0,"value":"If you decide "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" isn\u2019t for you \u2013 no problem. You can either cancel or change the plan from your account before the trial ends."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.plans.grouped":[{"type":0,"value":"If you decide "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" isn\u2019t for you \u2013 no problem. You can either cancel or change the plan from your account before the trial ends."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.preferences":[{"type":0,"value":"Your data and preferences are just as you left them, so jump right in and get started. "}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.preferences.grouped":[{"type":0,"value":"Your data and preferences are just as you left them, so jump right in and get started. "}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.reactivation":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your subscription:"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.reactivation.grouped":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your subscription:"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.subject":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.subject.grouped":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.subscription-details":[{"type":0,"value":"Your subscription will move back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan at the end of the trial period. To keep your subscription on the "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan, "},{"type":1,"value":"contactUs"},{"type":0,"value":" before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.subscription-details.grouped":[{"type":0,"value":"Your subscription will move back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan at the end of the trial period. To keep your subscription on the "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan, "},{"type":1,"value":"contactUs"},{"type":0,"value":" before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.trial-ends":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.trial-ends.grouped":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.email.body.caption":[{"type":0,"value":"Subscription successfully reactivated"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.email.body.caption.grouped":[{"type":0,"value":"Subscription successfully reactivated"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.email.body.info":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your customer\u2019s subscription."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.email.body.info.grouped":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your customer\u2019s subscription."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.plans":[{"type":0,"value":"If your customer decides "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" isn\u2019t for them, go to our Partner Purchasing Center and change the plan before the trial ends."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.plans.grouped":[{"type":0,"value":"If your customer decides "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" isn\u2019t for them, go to our Partner Purchasing Center and change the plan before the trial ends."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.subscription-details":[{"type":0,"value":"The subscription will move back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan at the end of the trial period. If your customer wants to keep the subscription on the "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan, "},{"type":1,"value":"contactUs"},{"type":0,"value":" before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.subscription-details.grouped":[{"type":0,"value":"The subscription will move back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan at the end of the trial period. If your customer wants to keep the subscription on the "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan, "},{"type":1,"value":"contactUs"},{"type":0,"value":" before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.trial-ends":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.trial-ends.grouped":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.commerce-subscription-reactivation-ccp-g.paid.personal-data-information":[{"type":0,"value":"If you have reactivated your subscription within 60 days of cancellation, your data and preferences will be as you left them. You can jump right in and get started!"}],"commerce.commerce-subscription-reactivation-ccp.email.body.caption":[{"type":0,"value":"Your subscription is successfully reactivated"}],"commerce.commerce-subscription-reactivation-ccp.email.body.welcome-back":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your subscription:"}],"commerce.commerce-subscription-reactivation-ccp.free.personal-information":[{"type":0,"value":"Your data and preferences are just as you left them, so jump right in and get started!"}],"commerce.commerce-subscription-reactivation-ccp.free.personal-information.partner":[{"type":0,"value":"Your customer\u2019s data and preferences are just as you left them."}],"commerce.commerce-subscription-reactivation-ccp.paid.personal-data-information":[{"type":0,"value":"If you have reactivated your subscription within 60 days of cancellation, your data and preferences will be as you\\n\\t\\t\\t\\t\\t\\t\\t\\tleft them. You can jump right in and get started!"}],"commerce.commerce-subscription-reactivation-ccp.paid.personal-information-next":[{"type":0,"value":"If you\u2019ve already settled the outstanding amount, you\u2019re all set. If not, settling it immediately will ensure uninterrupted service and prevent any future deactivations."}],"commerce.commerce-subscription-reactivation-ccp.paid.personal-information.partner":[{"type":0,"value":"If you have reactivated your subscription within 60 days of cancellation, your customer\u2019s data and preferences will be as you left them."}],"commerce.commerce-subscription-reactivation-ccp.paid.what\'s-next":[{"type":0,"value":"What\u2019s next"}],"commerce.commerce-subscription-reactivation-ccp.partner.email.body.caption":[{"type":0,"value":"Subscription trial successfully reactivated"}],"commerce.commerce-subscription-reactivation-ccp.partner.email.body.info":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your customer\u2019s subscription trial."}],"commerce.commerce-subscription-reactivation-ccp.partner.trial.email.body.caption":[{"type":0,"value":"Subscription successfully reactivated"}],"commerce.commerce-subscription-reactivation-ccp.partner.trial.email.body.info":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your customer\u2019s subscription."}],"commerce.commerce-subscription-reactivation-ccp.subject.email.partner.subject.customerCompanyName":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Welcome back to "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-reactivation-ccp.subject.email.partner.trial.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Welcome back to "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-reactivation-ccp.trial.personal-information":[{"type":0,"value":"When your trial ends, we\u2019ll charge your chosen payment method and send you an invoice within 24 hours."}],"commerce.commerce-subscription-reactivation-ccp.trial.personal-information-next":[{"type":0,"value":"Your data and preferences are just as you left them, so jump right in and get started"}],"commerce.commerce-subscription-reactivation-ccp.trial.personal-information-next.partner":[{"type":0,"value":"Your customer\u2019s data and preferences are just as you left them."}],"commerce.commerce-subscription-reactivation-ccp.trial.personal-information.partner":[{"type":0,"value":"When the trial ends, we\u2019ll charge the chosen payment method and send an invoice within 24 hours."}],"commerce.commerce-subscription-reactivations-digest.message-template.email.body.caption":[{"type":0,"value":"We\'ve reactivated your subscriptions"}],"commerce.commerce-subscription-reactivations-digest.message-template.email.body.details":[{"type":0,"value":"Your data and preferences are just as you left them, so your team can jump back in straight away."}],"commerce.commerce-subscription-reactivations-digest.message-template.email.body.intro":[{"type":0,"value":"As requested, we\'ve reactivated "},{"type":1,"value":"numOfReactivatedSubscriptions"},{"type":0,"value":" subscriptions in the last 24 hours."}],"commerce.commerce-subscription-reactivations-digest.message-template.email.subject":[{"type":0,"value":"Your daily reactivations"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.change-your-plan":[{"type":0,"value":"To change your plan"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t process payment for your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":") due to an issue with your payment details. To ensure your service continues smoothly, we\'ve moved you back on your previous plan."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.manage-subscription-change-plan":[{"type":0,"value":"Go to Manage subscription, then Change plan. "}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.payment-details-up-to-date":[{"type":0,"value":"Make sure your payment details are up to date."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.update-plan":[{"type":0,"value":"You may need to remove users if the number of users you have exceeds the user limit allowed on your updated plan. You can do this by heading to your Directory in Administration Hub."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.what-you-need-to-do":[{"type":0,"value":"What you need to do"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your subscription has been changed"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been changed"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.change-your-plan":[{"type":0,"value":"To change your plan"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t process payment for your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":") due to an issue with your payment details. To ensure service continues smoothly, we\'ve changed the subscription back to its previous plan."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.update-plan":[{"type":0,"value":"You may need to remove users if the number of users exceeds the user limit allowed on the updated plan. You can do this from the Directory in Administration Hub."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.what-you-need-to-do":[{"type":0,"value":"What you need to do"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your subscription has been changed"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.manage-subscription":[{"type":0,"value":"Ensure the payment details are up to date then manage the subscription in Partner Purchasing Center."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription changed"}],"commerce.commerce-subscription-rewind-uncollectible.user-count-key":[{"type":0,"value":"Users:"}],"commerce.commerce-subscription-rewind-uncollectible.user-count-value":[{"type":1,"value":"users"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.accepted-request.direct-customer-whats-next":[{"type":0,"value":"You can use your current plan, but you won\u2019t be able to make any changes. You\u2019ll need to "},{"type":1,"value":"contactLink"},{"type":0,"value":" for any modifications."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.accepted-request.nonpause-billing-accepted-request":[{"type":0,"value":"We\'ve accepted your request to move your subscription from monthly to annual (auto-renewal) plan, which will start at the end of your current billing cycle."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.caption.ecc":[{"type":0,"value":"Scheduled changes to billing cycle"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.caption.nonpause-billing-caption":[{"type":0,"value":"Let\u2019s take it to the next level"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.caption.partner":[{"type":0,"value":"Scheduled changes to billing cycle"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.direct-customer-caption":[{"type":0,"value":"Scheduled changes to billing cycle"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-accepted-request":[{"type":0,"value":"You can use the current plan, but your partner would need to contact us for any modifications. "}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-details":[{"children":[{"type":0,"value":"Subscription:"}],"type":8,"value":"bold"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"},{"type":1,"value":"siteUrlSeparator"},{"children":[{"type":1,"value":"siteUrl"}],"type":8,"value":"siteUrlLink"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-details-billing-partner":[{"children":[{"type":0,"value":"Atlassian billing partner:"}],"type":8,"value":"bold"},{"type":0,"value":" "},{"type":1,"value":"billingPartner"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-subscription-moved":[{"type":0,"value":"The billing cycle for one of your subscriptions will be moved from monthly to annual on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-wont-billed":[{"type":0,"value":"You won\'t be billed between the end of your current monthly billing cycle and the start of your annual billing."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.nonpause-billing-current-plan":[{"type":0,"value":"We\u2019re glad you\u2019re enjoying your monthly "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" plan for "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.partner-accepted-request":[{"type":0,"value":"The customer can continue with the existing plan, but you won\u2019t be able to make any changes. You\u2019ll need to "},{"type":1,"value":"contactLink"},{"type":0,"value":" for any modifications."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.partner-subscription-moved":[{"type":0,"value":"The billing cycle for one of your customer\u2019s subscriptions will be moved from monthly to annual on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ve also informed your customer about the change."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.partner-wont-billed":[{"type":0,"value":"Your customer won\'t be billed between the end of the current monthly billing cycle and the start of the annual billing."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-subscription-list":[{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"},{"type":1,"value":"siteUrlSeparator"},{"children":[{"type":1,"value":"siteUrl"}],"type":8,"value":"siteUrlLink"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-subscription-moved":[{"type":0,"value":"The billing cycle for one of your subscriptions will be moved from monthly to annual on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.wont-billed.direct-customer-wont-billed":[{"type":0,"value":"You won\'t be billed between the end of your current monthly billing cycle and the start of your annual billing."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.message-template.email.subject.ECC":[{"type":0,"value":"["},{"type":1,"value":"customerName"},{"type":0,"value":"]: Billing cycle change scheduled"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.message-template.email.subject.direct":[{"type":0,"value":"Billing cycle change scheduled"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.message-template.email.subject.nonpause-billing":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" subscription"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.message-template.email.subject.partner":[{"type":0,"value":"["},{"type":1,"value":"customerName"},{"type":0,"value":"]: Billing cycle change scheduled"}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.email.caption":[{"type":0,"value":"Your billing frequency will soon be changed"}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.email.contact-us":[{"type":0,"value":"If you have any questions concerning this change, please contact us."}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.email.request-to-change-bill-freq":[{"type":0,"value":"We received a request to change the billing frequency for your Statuspage subscription "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.email.when-will-cycle-change":[{"type":0,"value":"We\u2019ll change your "},{"type":1,"value":"oldBillingCycleName"},{"type":0,"value":" subscription to "},{"type":1,"value":"newBillingCycleName"},{"type":0,"value":" subscription at the end of your current billing cycle."}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.message-template.email.subject":[{"type":0,"value":"Your request to change your billing frequency"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.direcct-customer.view-subscription":[{"type":0,"value":"You can view or cancel your subscription at any time from your site\u2019s "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"},{"type":0,"value":" at "},{"type":1,"value":"billingUrlLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.direct.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.direct.email.body.subscription-downgraded-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is scheduled to move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be reflected on your next bill."}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.message-template.email.direct-customer.subject":[{"type":0,"value":"You\u2019re scheduled for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.message-template.email.partner.body.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcHomePage"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is scheduled for "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.partner.change-subscription":[{"type":0,"value":"Your customer contact can cancel the subscription at any time from "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.partner.email.body.caption":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.partner.email.body.subscription-downgraded-message":[{"type":0,"value":"As requested, your customer\u2019s "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is scheduled to move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from the previous plan will be reflected on the next bill."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.direcct-customer.view-subscription":[{"type":0,"value":"You can view or cancel your subscription at any time from your site\u2019s "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"},{"type":0,"value":" at "},{"type":1,"value":"billingUrlLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.direct.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.direct.email.body.subscription-downgraded-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is scheduled to move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be reflected on your next bill."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.email.dc.ubp-enforcement":[{"type":0,"value":"Remember, if your organization admin has enabled extra usage, any usage above the allowance may incur extra usage charges, which will be added to your bill each month. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.email.partner.ubp-enforcement":[{"type":0,"value":"Remember, if your customer exceeds their allowance for their plan, extra usage charges will be added to their next invoice. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"You\u2019re scheduled for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.message-template.email.partner.body.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcHomePage"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.message-template.email.partner.ppc-url":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is scheduled for "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.partner.change-subscription":[{"type":0,"value":"Your customer contact can cancel the subscription at any time from "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.partner.email.body.caption":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.partner.email.body.subscription-downgraded-message":[{"type":0,"value":"As requested, your customer\u2019s "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is scheduled to move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from the previous plan will be reflected on the next bill."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.caption":[{"type":0,"value":"Welcome to the "},{"type":1,"value":"newPricingPlanName"},{"type":0,"value":" plan for "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.charge-chosen-payment-method":[{"type":0,"value":"We\'ll charge your chosen payment method within 24 hours and send you a payment confirmation along with your invoice"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.atlassian-admin-link":[{"type":0,"value":"admin.atlassian.com"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.caption":[{"type":0,"value":"Welcome to your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.decision":[{"type":0,"value":"If you decide that this isn\u2019t for you, "},{"type":1,"value":"content"},{"type":0,"value":" "},{"type":1,"value":"atlassianAdminLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.decision.has-multiple-offering":[{"type":0,"value":"you can change your plan from"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.decision.has-single-offering":[{"type":0,"value":"you can cancel anytime from"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.great-news":[{"type":0,"value":"Great news \u2014 your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription is now up and running. Here are the details:"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.great-news":[{"type":0,"value":"Great news - you\u2019re now on a "},{"type":1,"value":"newPricingPlanName"},{"type":0,"value":", "},{"type":1,"value":"productName"},{"type":0,"value":" subscription ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.how-addon-billed":[{"type":0,"value":"Find out more about "},{"type":1,"value":"manageAddonLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.manage-addon-link":[{"type":0,"value":"how add-ons are billed"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.on-pricing-plan":[{"type":0,"value":" on "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.atlassian-admin-link":[{"type":0,"value":"admin.atlassian.com/billing/partner-managed-subscriptions"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.caption":[{"type":0,"value":"Welcome to "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.decision":[{"type":0,"value":"If your customer decides this isn\u2019t for them, they can "},{"type":1,"value":"content"},{"type":0,"value":" at any time from "},{"type":1,"value":"atlassianAdminLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.decision.has-multiple-offering":[{"type":0,"value":"change their plan"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.decision.has-single-offering":[{"type":0,"value":"cancel the subscription"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.great-news":[{"type":0,"value":"Great news \u2014 "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription"},{"type":1,"value":"companyName"},{"type":0,"value":" is now up and running. Here are the details:"}],"commerce.commerce-subscription-skip-trial-ccp.personal-information":[{"type":0,"value":"Remember - your invoice contains personal information such as your address and other billing admin details, so you should only share it with trusted sources."}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.change-plan":[{"type":0,"value":"Change plan"}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.change-plan-and-upgrade":[{"type":0,"value":" and upgrade your subscription. Don\u2019t forget to add your payment details so you can use "},{"type":1,"value":"productName"},{"type":0,"value":" without any interruptions."}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.manage-subscription-button":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.no-payment-info":[{"type":0,"value":"Since we dont have your complete billing information, we moved you to the Free plan. You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" but with limited features."}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.product-info":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldPricingPlanName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.title":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is now on the Free plan"}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.to-get-back-go-to":[{"type":0,"value":"Want to go back on the "},{"type":1,"value":"oldPricingPlanName"},{"type":0,"value":" plan? Select "}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.trial-has-ended":[{"type":0,"value":"Your "},{"type":1,"value":"oldPricingPlanName"},{"type":0,"value":" trial for "},{"type":1,"value":"productName"},{"type":0,"value":" has ended. We hope you enjoyed it!"}],"commerce.commerce-subscription-transferred-ccp-g.message-template.email.transferred-to-billing-account.transferred":[{"type":0,"value":"We\'ve successfully transferred the requested subscription to your Billing Account, "},{"type":1,"value":"transferredToBillingAccountName"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.direct-customer.transferred-to-billing-account.can-now-manage":[{"type":0,"value":"You can now manage this subscription \u2014 or access quotes, orders, and invoices \u2014 from "},{"type":1,"value":"transferredToBillingAccountName"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.direct-customer.transferred-to-billing-account.uninterrupted-service":[{"type":0,"value":"To ensure uninterrupted access to your subscriptions, add your payment details before your bill end date."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.partner-manage-subscriptions":[{"type":0,"value":"Your customer contact can view and cancel the subscription by going to "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.subject.direct-customer.transferred-from-billing-account":[{"type":1,"value":"productName"},{"type":0,"value":" subscription removed from your account"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.subject.direct-customer.transferred-to-billing-account":[{"type":1,"value":"productName"},{"type":0,"value":" subscription added to your account"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.subject.partner.transferred-from-billing-account":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription removed from billing account"}]},"yes":{"value":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription removed from billing account"}]}},"type":5,"value":"hasCustomerCompanyName"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.subject.partner.transferred-to-billing-account":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription added to your billing account"}]},"yes":{"value":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription added to your billing account"}]}},"type":5,"value":"hasCustomerCompanyName"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-from-billing-account.can-not-manage":[{"type":0,"value":"You can no longer manage this subscription \u2014 or access quotes, orders, and invoices \u2014 from "},{"type":1,"value":"transferredFromBillingAccountName"},{"type":0,"value":". However, all the invoices up to the date of transfer are still available."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-from-billing-account.caption":[{"type":0,"value":"Subscription removed from billing account"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-from-billing-account.product-transferred-info":[{"type":0,"value":"If you had any other product and subscriptions on the same site that belonged to the same product family,\\n\\t\\t\\tthey need to be billed together. That means we\u2019ve transferred them too."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-from-billing-account.transferred":[{"type":0,"value":"We\'ve successfully transferred the requested subscription from your Billing Account, "},{"type":1,"value":"transferredFromBillingAccountName"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-to-billing-account.caption":[{"type":0,"value":"Subscription added to your billing account"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-to-billing-account.product-transferred-info":[{"type":0,"value":"If the billing account "},{"type":1,"value":"transferredFromBillingAccountName"},{"type":0,"value":" had any other product and subscriptions on the same site that belonged to the same product family, they need to be billed together. That means we\u2019ve transferred them too."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-to-billing-account.transferred":[{"type":0,"value":"We\u2019ve successfully transferred the requested subscription to your Billing Account, "},{"type":1,"value":"transferredToBillingAccountName"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-to-customer-billing-account.caption":[{"type":0,"value":"Subscription transferred to your billing account"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp-g.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp-g.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"Each month, any usage over the allocated amount will be billed at USD\xa00.01 per extra Rovo Dev credit, which will be added to your next invoice. Don\u2019t worry \u2014 we\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this limit or disable extra usage anytime in Atlassian Administration. You can view usage details in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp-g.message-template.email.body.rovo-dev-credits-usage-details-partner":[{"type":0,"value":"Each month, any usage over the allocated amount will be billed at USD\xa00.01 per extra Rovo Dev credit, which will be added to the next invoice. We\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this limit or disable extra usage anytime in Atlassian Administration. "}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.direct.email.body.trial-ended-message":[{"type":0,"value":"We hope you enjoyed your free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". Your paid plan has now started from "},{"type":1,"value":"billingStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.direct.email.body.we-will-charge-you":[{"type":0,"value":"We\u2019ll charge you for your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation."}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.direct.email.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" free trial has ended"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.direct.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" free trial has ended"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.body.partner.subscription-includes":[{"type":0,"value":"The subscription also includes the following:"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"Each month, any usage over the allocated amount will be billed at USD\xa00.01 per extra Rovo Dev credit, which will be added to your next invoice. Don\u2019t worry \u2014 we\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this limit or disable extra usage anytime in Atlassian Administration. You can view usage details in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.body.rovo-dev-credits-usage-details-partner":[{"type":0,"value":"Each month, any usage over the allocated amount will be billed at USD\xa00.01 per extra Rovo Dev credit, which will be added to the next invoice. We\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this limit or disable extra usage anytime in Atlassian Administration. "}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-decrease.row.one.description":[{"type":0,"value":"Bundle Confluence with Jira, Loom, and Rovo"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-decrease.row.three.title":[{"type":0,"value":"Switch back anytime"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-decrease.row.two.description":[{"type":0,"value":"Pay less for all four apps than you currently pay for Confluence"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-decrease.title":[{"type":0,"value":"Want to pay less for Confluence?"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-increase.row.one.description":[{"type":0,"value":"of apps, Jira, Confluence, Loom, and Rovo"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-increase.row.one.title":[{"type":0,"value":"One collection"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-increase.row.three.description":[{"type":0,"value":"to make sure AI is as useful as it can be"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-increase.row.three.title":[{"type":0,"value":"More context"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-increase.row.two.description":[{"type":0,"value":"to instantly create more pages and whiteboards"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-increase.row.two.title":[{"type":0,"value":"More AI credits"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-increase.title":[{"type":0,"value":"Take your pages to the next level"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.cta.explore":[{"type":0,"value":"Explore Teamwork collection"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.cta.see-pricing":[{"type":0,"value":"See pricing"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-decrease.row.one.description":[{"type":0,"value":"Bundle Jira with Confluence, Loom, and Rovo"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-decrease.row.three.title":[{"type":0,"value":"Switch back anytime"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-decrease.row.two.description":[{"type":0,"value":"Pay less for all four apps than you currently pay for Jira"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-decrease.title":[{"type":0,"value":"Want to pay less for Jira?"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-increase.row.one.description":[{"type":0,"value":"of apps, Jira, Confluence, Loom, and Rovo"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-increase.row.one.title":[{"type":0,"value":"One collection"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-increase.row.three.description":[{"type":0,"value":"to instantly create work in bulk"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-increase.row.three.title":[{"type":0,"value":"More agents"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-increase.row.two.description":[{"type":0,"value":"to automatically triage more work"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-increase.row.two.title":[{"type":0,"value":"More AI credits"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-increase.title":[{"type":0,"value":"Take your projects to the next level"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business-and-ai.row.one.description":[{"type":0,"value":"of apps, Jira, Confluence, Loom, and Rovo"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business-and-ai.row.one.title":[{"type":0,"value":"One collection"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business-and-ai.row.three.description":[{"type":0,"value":"for less than you think"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business-and-ai.row.three.title":[{"type":0,"value":"All in one place"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business-and-ai.row.two.description":[{"type":0,"value":"to easily connect Loom with your other tools"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business-and-ai.row.two.title":[{"type":0,"value":"More AI credits"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business-and-ai.title":[{"type":0,"value":"Get more from Loom with the full collection"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business.row.one.title":[{"type":0,"value":"Bundle Loom with Jira, Confluence, and Rovo"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business.row.three.title":[{"type":0,"value":"Switch back anytime"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business.row.two.title":[{"type":0,"value":"Pay less for all four apps than you currently pay for Loom"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business.title":[{"type":0,"value":"Want to pay less for Loom?"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.body.trial-ended-message":[{"type":0,"value":"The free "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan trial for the following product has ended, and the paid period has started from "},{"type":1,"value":"billingStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.body.we-will-charge-you":[{"type":0,"value":"We\u2019ll charge the chosen payment method and send you an invoice soon, along with the payment confirmation."}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has ended"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.caption.upsell-twc":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan is active"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Free "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has ended"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.subject.without-company-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Free "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has ended"}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" trial has ended"}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.email.moved-back-old-plan":[{"type":0,"value":"The subscription will be moved back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan. You don\'t have to pay any additional charges for the trial period used as we continued your billing per your "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan while on trial. If you were initially on the Free plan, you won\'t be charged anything. "}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.email.subscription-opted-out-from-to":[{"type":0,"value":"As requested, we\'ve ended the no-cost "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" trial of the following product:"}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.message-template.email.body.view-subscription":[{"type":0,"value":"If needed, you can always restart the trial from our "},{"type":1,"value":"ppcSubscriptionLink"}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.message-template.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" trial ended on request"}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.body.trial-ended-message":[{"type":0,"value":"The no-cost "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan trial for the following product has ended."}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.body.upgrade-offering-message":[{"type":0,"value":"The subscription is now upgraded from a "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" paid plan to a "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" paid plan:"}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.body.view-subscription":[{"type":0,"value":"To view the subscription, visit our "},{"type":1,"value":"ppcSubscriptionLink"}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.body.we-will-charge-message":[{"type":0,"value":"We\u2019ll charge you for a "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with the payment confirmation. You may first be charged a prorated amount to align your bill date with your previous plan. Any remaining days of the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan will be adjusted as credits in your invoice."}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" paid plan has started"}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": No cost "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" trial period has ended"}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.ba-add-payment":[{"type":0,"value":"For a seamless transition when your trial ends, you\u2019ll need to add payment details before "},{"type":1,"value":"trialEndDateBold"},{"type":0,"value":". "}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.bu-add-payment":[{"type":0,"value":"For a seamless transition when your trial ends, your billing admin will need to add payment details before "},{"type":1,"value":"trialEndDateBold"},{"type":0,"value":". "}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.cancel":[{"type":0,"value":"If you decide this isn\u2019t for you, you can cancel your subscription before your trial ends by logging in to your account."}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offering"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.on-trial":[{"type":0,"value":"Good news \u2014 you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offering"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDateBold"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.subscription-details":[{"type":0,"value":"Here are the subscription details:"}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.trial-auto-convert":[{"type":0,"value":"Your trial will be automatically converted to the paid plan once your trial ends."}],"commerce.commerce-subscription-trial-started-digest.message-template.email.subject":[{"type":0,"value":"Your new "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.caption.lets-make-it-official":[{"type":0,"value":"Let\u2019s make it official"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.caption.time-flies":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial is coming to an end"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.add-payment":[{"type":0,"value":"If you want to continue with the paid plan, you\u2019ll need to add payment details before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.auto-conversion":[{"type":0,"value":"If you want to continue, you don\u2019t need to do anything. When your trial ends, we\u2019ll charge the payment method you chose when you signed up."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.auto-conversion-off":[{"type":0,"value":"Your subscription will be deactivated. "}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.auto-conversion-off-upgrade-trial":[{"type":0,"value":"You\u2019ll be moved back to the "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan. "}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.change-or-cancel-plan":[{"type":0,"value":"You can change or cancel your subscription before your trial ends by going to "},{"type":1,"value":"changePlanLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.deactivate-if-payment-not-added":[{"type":0,"value":"If you don\u2019t add your payment details before your trial ends, your subscription will be deactivated."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.downgrade-or-deactivate-if-payment-not-added":[{"type":0,"value":"If you don\u2019t add your payment details before your trial ends, we\u2019ll move you to the Free plan \u2014 as long as you meet the user limit requirements. If not, your subscription will be deactivated."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.downgrade-or-deactivate-if-payment-not-added-v2":[{"type":0,"value":"If you don\u2019t add your payment details before your trial ends, we\u2019ll move you to the Free plan \u2014 as long as you meet the limit requirements. If not, your subscription will be deactivated."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.extend-trial":[{"type":0,"value":"If you\u2019d like to extend your trial, you\u2019ll need to contact us at "},{"type":1,"value":"salesOpsSupportEmail"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.reminder-trial-ending":[{"type":0,"value":"Heads up \u2014 your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.scheduled-for-cancellation":[{"type":0,"value":"You can undo the cancellation by "},{"type":1,"value":"contactingUs"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.trial-will-end":[{"type":0,"value":"We hope you\'re enjoying your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.trial-will-end-twc":[{"type":0,"value":"We hope you\'re enjoying your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial and your team\'s making the most of the increased collaboration."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.features.your-features-include":[{"children":[{"type":0,"value":"Your features include:"}],"type":8,"value":"b"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.headline-body.end-of-trial-with-pde":[{"type":0,"value":"Your subscription begins on "},{"type":1,"value":"subscriptionStartDate"},{"type":0,"value":". Learn about your plan\u2019s features and see what they can do for you."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.headline-caption.end-of-trial-with-pde":[{"type":0,"value":"Ready for your next chapter?"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.auto-conversion":[{"type":0,"value":"If your customer wants to continue on this plan, you don\u2019t need to do anything. When the trial ends, we\u2019ll charge the payment method you chose when you signed up."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.auto-conversion-off":[{"type":0,"value":"When the trial ends, the subscription will be deactivated. "}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.auto-conversion-off-upgrade-trial":[{"type":0,"value":"The subscription will move back to the "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan. "}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.auto-conversion-upgrade-trial":[{"type":0,"value":"If your customer wants to continue on this plan, you don\u2019t need to do anything. When the trial ends, the subscription will be moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and charged on the next bill date."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.deactivate-if-payment-not-added":[{"type":0,"value":"To continue, add payment details (if you haven\u2019t already) before your trial ends to avoid deactivation."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.downgrade-or-deactivate-if-payment-not-added":[{"type":0,"value":"To continue with the paid plan, add payment details (if you haven\u2019t already) before your trial ends to avoid downgrading to the Free plan or deactivation."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.extend-trial":[{"type":0,"value":"To extend the trial, "},{"type":1,"value":"reachOutTous"},{"type":0,"value":" before the trial end date. You may also request a quote, valid until the trial expiry date."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.reach-out-to-us":[{"type":0,"value":"reach out to us"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.reminder-trial-ending":[{"type":0,"value":"Heads up \u2014 your customer\'s "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial for "},{"type":1,"value":"productName"},{"type":0,"value":" ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.scheduled-for-cancellation":[{"type":0,"value":"The trial is scheduled for cancellation. If your customer wants to undo the cancellation, "},{"type":1,"value":"contactUs"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.body.intro":[{"type":0,"value":"Your trial will end in 3 days. Add your payment details now so you don\u2019t lose your features."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.body.refund-policy":[{"children":[{"type":0,"value":"Switch plans anytime."}],"type":8,"value":"b"},{"type":0,"value":" Refund within 30 days of initial purchase if you change your mind."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.body.title":[{"type":0,"value":"Keep what\u2019s working for you"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.confluence.premium.permissions":[{"type":0,"value":"You\u2019ll no longer be able to choose who can view, edit, or comment on pages."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.confluence.premium.rovo":[{"type":0,"value":"You won\u2019t be able to use Rovo (AI) features anymore, like search, chat, or content help."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.confluence.premium.whiteboards":[{"type":0,"value":"Whiteboards are great for planning and brainstorming, but Free only allows 3 per person."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.confluence.standard.permissions":[{"type":0,"value":"You\u2019ll no longer be able to choose who can view, edit, or comment on pages."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.confluence.standard.rovo":[{"type":0,"value":"You won\u2019t be able to use Rovo (AI) features anymore, like search, chat, or content help."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.confluence.standard.users":[{"type":0,"value":"The user limit will drop from unlimited to 10 people."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.confluence.standard.users.above-limit":[{"type":0,"value":"The user limit will drop to 10 people. You have "},{"type":1,"value":"userCount"},{"type":0,"value":" people, so your site may be deactivated."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jira.premium.permissions":[{"type":0,"value":"You won\u2019t be able to set rules on who can create, view, or comment on work items."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jira.premium.plans":[{"type":0,"value":"Without cross-project plans, you won\u2019t be able to see status or problems across teams."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jira.premium.rovo":[{"type":0,"value":"You won\u2019t be able to use Rovo (AI) features anymore, like search, chat or agents."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jira.standard.permissions":[{"type":0,"value":"You won\u2019t be able to set rules on who can create, view, or comment on work items."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jira.standard.rovo":[{"type":0,"value":"You won\u2019t be able to use Rovo (AI) features anymore, like search, chat or agents."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jira.standard.users":[{"type":0,"value":"The user limit will drop from unlimited to 10 people."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jira.standard.users.above-limit":[{"type":0,"value":"The user limit will drop to 10 people. You have "},{"type":1,"value":"userCount"},{"type":0,"value":" people, so your site may be deactivated."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jpd.premium.roadmaps":[{"type":0,"value":"Cross-project roadmaps won\u2019t be available, so you can\u2019t see all ideas in one view."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jpd.premium.rovo":[{"type":0,"value":"You won\u2019t be able to use Rovo (AI) features anymore, like search, chat, or content help."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jpd.premium.view-restrictions":[{"type":0,"value":"You won\u2019t be able to control who can see, edit, or create views."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jpd.standard.published-view":[{"type":0,"value":"You won\u2019t be able to publish and share your plans with people unless they\u2019re signed in."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jpd.standard.storage":[{"type":0,"value":"Storage will drop from 250 GB to 2 GB, which will limit your ability to upload files."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jpd.standard.users":[{"type":0,"value":"The user limit will drop from unlimited to 3."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.personalised-no-pde.features.jpd.standard.users.above-limit":[{"type":0,"value":"The user limit will drop to 3 creators. You have "},{"type":1,"value":"userCount"},{"type":0,"value":" people, so your site may be deactivated."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.add-payment":[{"type":0,"value":"Add payment details before "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.end-of-trial-with-pde":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial is ending"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.mpucup":[{"type":0,"value":"Payment required to keep your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.mpucup.no-product-name":[{"type":0,"value":"Payment required to keep your subscription"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.partner.add-payment":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Add payment details before "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends"}]},"yes":{"value":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Add payment details before "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends"}]}},"type":5,"value":"hasCustomerCompanyName"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.partner.trial-ends-soon":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends soon"}]},"yes":{"value":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends soon"}]}},"type":5,"value":"hasCustomerCompanyName"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.personalised-no-pde":[{"type":0,"value":"Don\u2019t lose your features - add payment details today"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.trial-ends-soon":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends soon"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.title":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" trial is ending"}],"commerce.commerce-subscription-trial-will-end-ccp.mpucup.email.add-payment-details-before-trial-ends":[{"type":0,"value":"Add payment details before your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":" to keep all your users and features. If you don\'t add payment details or reduce your user count to 10 or fewer by "},{"type":1,"value":"trialEndDate"},{"type":0,"value":", you will lose access to "},{"type":1,"value":"productName"},{"type":0,"value":" and your data will be permanently deleted."}],"commerce.commerce-subscription-trial-will-end-ccp.mpucup.email.add-payment-details-before-trial-ends-within-limit":[{"type":0,"value":"Add payment details before your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":" to keep all your features. If you don\'t add payment details by "},{"type":1,"value":"trialEndDate"},{"type":0,"value":", you will lose access to "},{"type":1,"value":"productName"},{"type":0,"value":" Standard."}],"commerce.commerce-subscription-trial-will-end-ccp.mpucup.email.caption":[{"type":0,"value":"Add payment details to keep your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription"}],"commerce.commerce-subscription-trial-will-end-ccp.mpucup.email.what-you-need-to-do":[{"type":0,"value":"What you need to do"}],"commerce.commerce-subscription-trial-will-end-ccp.mpucup.email.your-trial-ends-in-days":[{"type":0,"value":"Your free "},{"type":1,"value":"productName"},{"type":0,"value":" Standard trial ends in "},{"children":[{"type":0,"value":"3 days"}],"type":8,"value":"b"},{"type":0,"value":". Add payment details now to ensure your team has uninterrupted access."}],"commerce.commerce-subscription-upcoming-renewal-ccp.email.add-payment-details":[{"type":0,"value":"We noticed that we don\'t have your payment details on file. Add payment details before the renewal date to avoid any disruptions to your subscription."}],"commerce.commerce-subscription-upcoming-renewal-ccp.email.caption":[{"type":0,"value":"Your upcoming renewal"}],"commerce.commerce-subscription-upcoming-renewal-ccp.email.payment-method-charged":[{"type":0,"value":"We\u2019ll charge your chosen payment method at this time. If you want to use a different payment method, update your details before the renewal date."}],"commerce.commerce-subscription-upcoming-renewal-ccp.email.renewal-reminder":[{"type":0,"value":"This is a friendly reminder that your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will renew on "},{"type":1,"value":"renewalDate"},{"type":0,"value":". Here are the details:"}],"commerce.commerce-subscription-upcoming-renewal-ccp.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription renews soon"}],"commerce.commerce-subscription-upgrade-ccp-g.direct.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp-g.direct.email.body.subscription-upgrade-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be charged to your existing payment method."}],"commerce.commerce-subscription-upgrade-ccp-g.direct.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" plan has been upgraded"}],"commerce.commerce-subscription-upgrade-ccp-g.partner.email.body.caption":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp-g.partner.email.body.subscription-upgrade-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be charged to the existing payment method."}],"commerce.commerce-subscription-upgrade-ccp-g.partner.message-template.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is now on "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp.direct.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp.direct.email.body.subscription-upgrade-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be charged to your existing payment method."}],"commerce.commerce-subscription-upgrade-ccp.direct.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" plan has been upgraded"}],"commerce.commerce-subscription-upgrade-ccp.email.dc.ubp-enforcement":[{"type":0,"value":"Remember, if your organization admin has enabled extra usage, any usage above the allowance may incur extra usage charges, which will be added to your bill each month. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-upgrade-ccp.email.partner.ubp-enforcement":[{"type":0,"value":"Remember, if your customer exceeds their allowance for their plan, extra usage charges will be added to their next invoice. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-upgrade-ccp.partner.email.body.caption":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp.partner.email.body.subscription-upgrade-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be charged to the existing payment method."}],"commerce.commerce-subscription-upgrade-ccp.partner.message-template.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is now on "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.dc.info-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"previousOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.dc.metered-billing":[{"type":0,"value":"Remember, you can only use up to the included quantity for each quota type. If you want a higher included quantity or the option to use extra, you\u2019ll need to upgrade to a paid plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.dc.metered.upgrade-trial-opt-out":[{"type":0,"value":"Remember, if you go over the included quantity for any of the quota types on your subscription, extra usage charges will be added to your next invoice."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.dc.metered.upgrade-trial-opt-out.ubp5-enforcement":[{"type":0,"value":"Remember, if you go over the included quantity or allowance for any of the usage types on your subscription, extra usage charges will be added to your next invoice. Organization admins can set and adjust usage limits anytime."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.partner.info-message":[{"type":0,"value":"As requested, your customer\u2019s "},{"type":1,"value":"previousOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.partner.metered-billing":[{"type":0,"value":"Remember, if your customer wants a higher included quantity, or wants the option to use extra, they\u2019ll need to upgrade to a paid plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.partner.metered.upgrade-trial-opt-out":[{"type":0,"value":"Remember, if your customer goes over the included quantity for any of the quota types on the subscription, extra usage charges will be added to their next invoice."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.partner.metered.upgrade-trial-opt-out.ubp5-enforcement":[{"type":0,"value":"Remember, if your customer goes over the included quantity or allowance for any of the usage types on the subscription, extra usage charges will be added to their next invoice. You can set and adjust usage limits anytime."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.dc.email.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.dc.email.subject":[{"type":0,"value":"You\u2019re now on "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.email.partner.body.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcSubscriptionsPageLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.partner.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.partner.email.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is now on the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.dc.info-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"previousOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.dc.metered-billing":[{"type":0,"value":"Remember, you can only use up to the included quantity for each quota type. If you want a higher included quantity or the option to use extra, you\u2019ll need to upgrade to a paid plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.dc.metered.upgrade-trial-opt-out":[{"type":0,"value":"Remember, if you go over the included quantity for any of the quota types on your subscription, extra usage charges will be added to your next invoice."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.dc.metered.upgrade-trial-opt-out.ubp5-enforcement":[{"type":0,"value":"Remember, if your organization admin has enabled extra usage, any usage above the allowance may incur extra usage charges, which will be added to your bill at the end of your bill cycle. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.partner.info-message":[{"type":0,"value":"As requested, your customer\u2019s "},{"type":1,"value":"previousOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.partner.metered-billing":[{"type":0,"value":"Remember, if your customer wants a higher included quantity, or wants the option to use extra, they\u2019ll need to upgrade to a paid plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.partner.metered.upgrade-trial-opt-out":[{"type":0,"value":"Remember, if your customer goes over the included quantity for any of the quota types on the subscription, extra usage charges will be added to their next invoice."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.partner.metered.upgrade-trial-opt-out.ubp5-enforcement":[{"type":0,"value":"Remember, any usage above the allowance may incur extra usage charges, which will be added to your customer\'s bill at the end of the bill cycle. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.dc.email.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.dc.email.subject":[{"type":0,"value":"You\u2019re now on "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.email.partner.body.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcSubscriptionsPageLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.partner.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.partner.email.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is now on the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-trial-extension-ad.created-date-bold.key":[{"type":0,"value":"Created date: "}],"commerce.commerce-trial-extension-ad.created-date-value":[{"type":1,"value":"createdDate"}],"commerce.commerce-trial-extension-ad.created-date.key":[{"type":1,"value":"createdDateKey"}],"commerce.commerce-trial-extension-ad.email.approved":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has approved the request."}],"commerce.commerce-trial-extension-ad.email.caption":[{"type":0,"value":"Trial Extension "},{"type":1,"value":"requestId"}],"commerce.commerce-trial-extension-ad.email.declined":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has declined the request. The request us now closed."}],"commerce.commerce-trial-extension-ad.email.default":[{"type":0,"value":"Your request for a trial extension has been received and is being processed."}],"commerce.commerce-trial-extension-ad.email.in-review":[{"type":1,"value":"initiatorName"},{"type":0,"value":" is the assignee of the approval request."}],"commerce.commerce-trial-extension-ad.email.reasons-provided":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has provided supporting reasons."}],"commerce.commerce-trial-extension-ad.email.reasons-requested":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has requested supporting reasons."}],"commerce.commerce-trial-extension-ad.email.request-cancelled":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has cancelled the request. The request us now closed."}],"commerce.commerce-trial-extension-ad.email.waiting-for-review":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has submitted a new Trial Extension request."}],"commerce.commerce-trial-extension-ad.initiator-id-bold.key":[{"type":0,"value":"Initiator: "}],"commerce.commerce-trial-extension-ad.initiator-id-value":[{"type":1,"value":"initiator"}],"commerce.commerce-trial-extension-ad.initiator-id.key":[{"type":1,"value":"initiatorKey"}],"commerce.commerce-trial-extension-ad.message-template.email.subject":[{"type":0,"value":"Trial Extension "},{"type":1,"value":"requestId"}],"commerce.commerce-trial-extension-ad.request-id-bold.key":[{"type":0,"value":"Request ID: "}],"commerce.commerce-trial-extension-ad.request-id-value":[{"type":1,"value":"requestId"}],"commerce.commerce-trial-extension-ad.request-id.key":[{"type":1,"value":"requestIdKey"}],"commerce.commerce-trial-extension-ad.status-bold.key":[{"type":0,"value":"Status: "}],"commerce.commerce-trial-extension-ad.status-value":[{"type":1,"value":"status"}],"commerce.commerce-trial-extension-ad.status.key":[{"type":1,"value":"statusKey"}],"commerce.commerce-trial-extension-ad.subscription-bold.key":[{"type":0,"value":"Subscription: "}],"commerce.commerce-trial-extension-ad.subscription-value":[{"type":1,"value":"entitlementNumber"}],"commerce.commerce-trial-extension-ad.subscription.key":[{"type":1,"value":"subscriptionKey"}],"commerce.commerce-trial-extension-ad.support-ticket-id-bold.key":[{"type":0,"value":"Support Ticket: "}],"commerce.commerce-trial-extension-ad.support-ticket-id-value":[{"type":1,"value":"supportTicket"}],"commerce.commerce-trial-extension-ad.support-ticket-id.key":[{"type":1,"value":"supportTicketKey"}],"commerce.commerce-trial-extension-ad.total-trial-length-bold.key":[{"type":0,"value":"Total days on trial so far: "}],"commerce.commerce-trial-extension-ad.total-trial-length-value":[{"type":1,"value":"currentTotalTrialLength"}],"commerce.commerce-trial-extension-ad.total-trial-length.key":[{"type":1,"value":"totalTrialLengthKey"}],"commerce.commerce-trial-extension-ad.trial-length-bold.key":[{"type":0,"value":"Request: "}],"commerce.commerce-trial-extension-ad.trial-length-value":[{"type":0,"value":"Extend trial for "},{"type":1,"value":"netTrialDays"},{"type":0,"value":" days"}],"commerce.commerce-trial-extension-ad.trial-length.key":[{"type":1,"value":"requestKey"}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.billable-usage-notice":[{"type":0,"value":"Any usage beyond your allowance is considered extra usage. "},{"children":[{"type":0,"value":"You won\u2019t be billed for extra usage at this time."}],"type":8,"value":"b"},{"type":0,"value":" "},{"type":1,"value":"billingUrl"}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.billable-usage-notice.enforced":[{"type":0,"value":"If your organization goes over the extra usage limit, you\u2019ll receive a bill for extra usage incurred at the end of your bill cycle"}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.billing-faq-url":[{"type":0,"value":"When and how will I be billed?"}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.cta.view-usage":[{"type":0,"value":"View usage"}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.disabled":[{"type":0,"value":"An admin has disabled extra usage for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on your organization."}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.enabled.intro":[{"type":0,"value":"An admin has enabled extra usage for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on your organization."}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.limit-policy.adjust-limit":[{"type":0,"value":"Organization and billing admins can adjust this limit anytime."}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.limit-set":[{"type":0,"value":"An admin has set the "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit on your organization. Your organization now allows monthly usage up to "},{"type":1,"value":"limit"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"},{"type":0,"value":"."}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.visit-admin":[{"type":0,"value":"Visit Atlassian Administration to get more details on "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage in your organization."}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.subject.disabled":[{"type":0,"value":"Extra "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage has been disabled"}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.subject.enabled":[{"type":0,"value":"Extra "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage has been enabled"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.billable-usage-notice":[{"type":0,"value":"Any usage beyond your allowance is considered extra usage. "},{"children":[{"type":0,"value":"You won\u2019t be billed for extra usage at this time."}],"type":8,"value":"b"},{"type":0,"value":" "},{"type":1,"value":"billingUrl"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.billable-usage-notice.enforced":[{"type":0,"value":"If your organization allows extra usage above the allowance, at the end of the cycle, you\u2019ll receive a bill for extra usage incurred"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.billing-faq-url":[{"type":0,"value":"When and how will I be billed?"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.policy.adjust-limit":[{"type":0,"value":"Organization and billing admins can adjust this limit anytime."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.set":[{"type":0,"value":"An admin has set the "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit on your organization. Your organization now allows monthly usage up to "},{"type":1,"value":"limit"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"},{"type":0,"value":"."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.updated":[{"type":0,"value":"An admin has updated the "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit on your organization. Your extra usage limit for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" is now "},{"type":1,"value":"limit"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"},{"type":0,"value":"."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.updated.unlimited":[{"type":0,"value":"An admin has updated the "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit on your organization. Your extra usage for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" has no set limit."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.visit-admin":[{"type":0,"value":"Visit Atlassian Administration to get more details on "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage in your organization."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.caption.set":[{"type":0,"value":"New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit set"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.caption.updated":[{"type":0,"value":"New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit updated"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.subject.set":[{"type":0,"value":"New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit set"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.subject.updated":[{"type":0,"value":"New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit updated"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.email.body.cta.view-usage":[{"type":0,"value":"View usage"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.billable-usage-notice":[{"type":0,"value":"Any usage beyond your customer\'s allowance is considered extra usage. "},{"children":[{"type":0,"value":"You won\u2019t be billed for extra usage at this time."}],"type":8,"value":"b"},{"type":0,"value":" "},{"type":1,"value":"billingUrl"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.billable-usage-notice.enforced":[{"type":0,"value":"If your customer\u2019s usage exceeds their allowance, you\u2019ll receive an extra usage bill at the end of the cycle"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.billing-faq-url":[{"type":0,"value":"When and how will they be billed?"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.policy.adjust-limit":[{"type":0,"value":"Organization and billing admins can adjust this limit anytime."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.set":[{"type":0,"value":"An admin has set the "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit for your customer\'s organization. They can now use up to "},{"type":1,"value":"limit"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"},{"type":0,"value":"."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.updated":[{"type":0,"value":"An admin has updated the "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit for your customer\'s organization. Your customer\'s extra usage limit for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" is now "},{"type":1,"value":"limit"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"},{"type":0,"value":"."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.updated.unlimited":[{"type":0,"value":"An admin has updated the "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit for your customer\'s organization. Your customer\'s extra usage for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" has no set limit."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.visit-ppc":[{"type":0,"value":"Visit PPC to get more details on your customer\'s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.caption.set":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit has been set"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.caption.updated":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit has been updated"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.subject.set":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit set"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.subject.set.without-company-name":[{"type":0,"value":"New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit set"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.subject.updated":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit updated"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.subject.updated.without-company-name":[{"type":0,"value":"New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit updated"}],"commerce.commerce-write-off-email-ccp.message-template.email.caption":[{"type":0,"value":"Your invoice has been written off"}],"commerce.commerce-write-off-email-ccp.message-template.email.no-refund":[{"type":0,"value":"Please note that this credit note will not result in any refund since it is generated against an unpaid invoice."}],"commerce.commerce-write-off-email-ccp.message-template.email.processed-write-off":[{"type":0,"value":"We\'ve processed a write-off for invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":". If the invoice used any account balance, this has been returned to your account."}],"commerce.commerce-write-off-email-ccp.message-template.email.subject":[{"type":0,"value":"Write-off processed for invoice "},{"type":1,"value":"invoiceNumber"}],"commerce.commerce.commerce-ship-to-party-archival-ccp.email.body.caption":[{"type":1,"value":"name"},{"type":0,"value":": Sold to address deactivated"}],"commerce.common-ui.manage-subscription-from-ppc-homepage":[{"type":0,"value":"You can manage the subscription from our "},{"type":1,"value":"partnerPurchasingCenterLink"},{"type":0,"value":"."}],"commerce.common-ui.ppc":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.common.atlassian-privacy-policy":[{"type":0,"value":"Atlassian Privacy Policy"}],"commerce.common.contact-us-to-talk-or-downgrade-to-free":[{"type":1,"value":"contactUs"},{"type":0,"value":" to talk about your situation, or "},{"type":1,"value":"downGradeToFreePlan"},{"type":0,"value":". We suggest you export your data before your subscription gets canceled. For more information, see our "},{"type":1,"value":"dataStorageFAQs"},{"type":0,"value":"."}],"commerce.common.contact-your-bank-for-more-info":[{"type":0,"value":"Contact your bank if you need more information about the issue."}],"commerce.common.contacting-us":[{"type":0,"value":"contacting us"}],"commerce.common.data-retention-and-backup-policy":[{"type":0,"value":"data retention and backup policies"}],"commerce.common.data-storage-faqs":[{"type":0,"value":"Data Storage FAQs"}],"commerce.common.downgrade-to-a-free-plan":[{"type":0,"value":"downgrade to a free plan"}],"commerce.common.email.atl-logo.alt-text":[{"type":0,"value":"Atlassian logo"}],"commerce.common.email.billing-url":[{"type":1,"value":"url"}],"commerce.common.email.bitbucket-logo.alt-text":[{"type":0,"value":"Bitbucket logo"}],"commerce.common.email.compass-logo.alt-text":[{"type":0,"value":"Compass logo"}],"commerce.common.email.confluence-logo.alt-text":[{"type":0,"value":"Confluence logo"}],"commerce.common.email.csm-logo.alt-text":[{"type":0,"value":"Customer Service Management logo"}],"commerce.common.email.dx-logo.alt-text":[{"type":0,"value":"DX logo"}],"commerce.common.email.focus-logo.alt-text":[{"type":0,"value":"Focus logo"}],"commerce.common.email.guard-logo.alt-text":[{"type":0,"value":"Guard logo"}],"commerce.common.email.jpd-logo.alt-text":[{"type":0,"value":"Jira Product Discovery logo"}],"commerce.common.email.jsm-logo.alt-text":[{"type":0,"value":"Jira Service Management logo"}],"commerce.common.email.loom-logo.alt-text":[{"type":0,"value":"Loom logo"}],"commerce.common.email.rovo-dev-logo.alt-text":[{"type":0,"value":"Rovo Dev logo"}],"commerce.common.email.rovo-logo.alt-text":[{"type":0,"value":"Rovo logo"}],"commerce.common.email.siteAdmin":[{"type":0,"value":"Administration"}],"commerce.common.email.talent-logo.alt-text":[{"type":0,"value":"Talent logo"}],"commerce.common.if-you-are-unable-to-pay":[{"type":0,"value":"If you\'re unable to make payments:"}],"commerce.common.jira-logo.alt-text":[{"type":0,"value":"Jira logo"}],"commerce.common.manage-subscription-document-link":[{"type":0,"value":"Manage your subscription for Standard and Premium plans"}],"commerce.common.subscriptiom-reactivation-link":[{"type":0,"value":"reactivate your subscription"}],"commerce.common.view-subscription":[{"type":0,"value":"You can view your subscription details from your site\u2019s "},{"type":1,"value":"siteAdmin"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.email.body.what-happens-if-your-customer-uses-extra":[{"type":0,"value":"Remember, if your customer goes over the included quantity for any of the quota types on the subscription, extra usage charges will be added to their next invoice."}],"commerce.email.changed-your-mind":[{"type":0,"value":"Changed your mind?"}],"commerce.email.cms.learn-more":[{"type":0,"value":"Pay later by invoice."}],"commerce.email.current-plan-details":[{"type":0,"value":"More information about your current plan"}],"commerce.email.dont-want-continue":[{"type":0,"value":"Don\'t want to continue with the subscription?"}],"commerce.email.dont-want-to-cancel":[{"type":0,"value":"Don\'t want to cancel?"}],"commerce.email.extra-usage-charge-for-metered-billing":[{"type":0,"value":"Remember, if the included quantity or allowance for any of the usage types on the subscription are exceeded each billing cycle, extra usage charges will be added to the next invoice. "},{"type":1,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.email.how-to":[{"type":0,"value":"How to pay your invoices"}],"commerce.email.included-products":[{"type":0,"value":"Included products:"}],"commerce.email.last-page":[{"type":0,"value":"The last page of your invoice includes Atlassian\u2019s account details and instructions on how to pay."}],"commerce.email.list.billing-account":[{"type":0,"value":"Billing account: "},{"type":1,"value":"transactionAccountNum"}],"commerce.email.list.credit-limit":[{"type":0,"value":"Credit limit: "},{"type":1,"value":"creditLimitFormatted"}],"commerce.email.list.payment-method":[{"type":0,"value":"Payment method: Pay later by invoice"}],"commerce.email.list.payment-terms":[{"type":0,"value":"Payment terms: "},{"type":1,"value":"netTermsDuration"}],"commerce.email.list.taxId":[{"type":1,"value":"identifierName"},{"type":0,"value":": "},{"type":1,"value":"id"}],"commerce.email.new-plan-includes":[{"type":0,"value":"Your new plan includes:"}],"commerce.email.payment-days":[{"type":0,"value":"You\u2019ll have "},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" days from the order invoice date to send your payment to Atlassian. You can pay using bank transfer or ACH/check (U.S. banks). "}],"commerce.email.subscription-and-billing-support-url":[{"type":0,"value":"More about how billing works."}],"commerce.email.subscription-details":[{"type":0,"value":"Here are the subscription details:"}],"commerce.email.subscription-includes":[{"type":0,"value":"Your subscription includes:"}],"commerce.email.subscription-includes-quotes":[{"type":0,"value":"The subscription also includes the following quotas:"}],"commerce.email.subscription-list-title":[{"type":0,"value":"Subscription list:"}],"commerce.email.teamwork-collection":[{"type":0,"value":"Teamwork Collection can make it easy for your whole organization to work more effectively together - "},{"type":1,"value":"findOut"},{"type":0,"value":"."}],"commerce.email.teamwork-collection.find-out":[{"type":0,"value":"find out more about Atlassian collections"}],"commerce.email.the.new-plan-includes":[{"type":0,"value":"The new plan includes:"}],"commerce.email.trial-ends":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.email.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.email.view-usage":[{"type":0,"value":"View usage"}],"commerce.email.want-to-keep your subscription":[{"type":0,"value":"Want to keep your subscription?"}],"commerce.email.what-do-i-need-to-do":[{"type":0,"value":"What do I need to do?"}],"commerce.email.what-do-you-need-to-do":[{"type":0,"value":"What you need to do:"}],"commerce.email.what-happens-when-trial-ends":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.email.whats-next":[{"type":0,"value":"What\u2019s next?"}],"commerce.learn-more":[{"type":0,"value":"To learn more, see "},{"type":1,"value":"learnMore"}],"commerce.list.payment-terms":[{"type":0,"value":"Payment terms: Net-"},{"type":1,"value":"netTermsDuration"}],"commerce.message-template.email.explore-all-features-button.explore-all-features":[{"type":0,"value":"Explore all features"}],"commerce.message-template.email.features-list.confluence.premium.analytics":[{"children":[{"type":0,"value":"Analytics:"}],"type":8,"value":"b"},{"type":0,"value":" See who has viewed a page and when"}],"commerce.message-template.email.features-list.confluence.premium.atlassian-intelligence":[{"children":[{"type":0,"value":"Atlassian intelligence:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up your day-to-day work"}],"commerce.message-template.email.features-list.confluence.premium.unlimited-users":[{"children":[{"type":0,"value":"Unlimited users:"}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need"}],"commerce.message-template.email.features-list.confluence.standard.page-insights":[{"children":[{"type":0,"value":"Page insights:"}],"type":8,"value":"b"},{"type":0,"value":" See engagement data, like page views"}],"commerce.message-template.email.features-list.confluence.standard.page-permissions":[{"children":[{"type":0,"value":"Page permissions:"}],"type":8,"value":"b"},{"type":0,"value":" Choose who can view, edit, and comment"}],"commerce.message-template.email.features-list.confluence.standard.unlimited-users":[{"children":[{"type":0,"value":"Unlimited users:"}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need"}],"commerce.message-template.email.features-list.jira.premium.atlassian-intelligence":[{"children":[{"type":0,"value":"Atlassian intelligence:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up your day-to-day work"}],"commerce.message-template.email.features-list.jira.premium.cross-team-planning":[{"children":[{"type":0,"value":"Cross-team planning:"}],"type":8,"value":"b"},{"type":0,"value":" See all projects and timelines in one place"}],"commerce.message-template.email.features-list.jira.premium.unlimited-users":[{"children":[{"type":0,"value":"Unlimited users:"}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need"}],"commerce.message-template.email.features-list.jira.standard.automation":[{"children":[{"type":0,"value":"Automation:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up your work and remove human error"}],"commerce.message-template.email.features-list.jira.standard.data-residency":[{"children":[{"type":0,"value":"Data residency:"}],"type":8,"value":"b"},{"type":0,"value":" Choose where your data is stored"}],"commerce.message-template.email.features-list.jira.standard.unlimited-users":[{"children":[{"type":0,"value":"Unlimited users:"}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need"}],"commerce.message-template.email.features-list.jpd.premium.atlassian-intelligence":[{"children":[{"type":0,"value":"Atlassian intelligence:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up your day-to-day work"}],"commerce.message-template.email.features-list.jpd.premium.roadmaps":[{"children":[{"type":0,"value":"Roadmaps:"}],"type":8,"value":"b"},{"type":0,"value":" See multiple roadmaps in a single view"}],"commerce.message-template.email.features-list.jpd.premium.unlimited-creators":[{"children":[{"type":0,"value":"Unlimited creators:"}],"type":8,"value":"b"},{"type":0,"value":" People who can create and manage projects"}],"commerce.message-template.email.features-list.jpd.standard.automation":[{"children":[{"type":0,"value":"Automation:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up work and reduce human error"}],"commerce.message-template.email.features-list.jpd.standard.published-views":[{"children":[{"type":0,"value":"Published views:"}],"type":8,"value":"b"},{"type":0,"value":" Share read-only views with anyone"}],"commerce.message-template.email.features-list.jpd.standard.unlimited-creators":[{"children":[{"type":0,"value":"Unlimited creators:"}],"type":8,"value":"b"},{"type":0,"value":" People who can create and manage projects"}],"commerce.message-template.email.features-list.jsm.premium.ai-features":[{"children":[{"type":0,"value":"AI features:"}],"type":8,"value":"b"},{"type":0,"value":" AI-powered agents, search, and chat"}],"commerce.message-template.email.features-list.jsm.premium.change-automation":[{"children":[{"type":0,"value":"Change automation:"}],"type":8,"value":"b"},{"type":0,"value":" Gate deploys and automate record creation"}],"commerce.message-template.email.features-list.jsm.premium.unlimited-agents":[{"children":[{"type":0,"value":"Unlimited agents:"}],"type":8,"value":"b"},{"type":0,"value":" Grow your team, with no cap on customers"}],"commerce.message-template.email.features-list.jsm.standard.branded-help-center":[{"children":[{"type":0,"value":"Branded help center:"}],"type":8,"value":"b"},{"type":0,"value":" Use your company\'s branding and URLs"}],"commerce.message-template.email.features-list.jsm.standard.enhanced-support":[{"children":[{"type":0,"value":"Enhanced support:"}],"type":8,"value":"b"},{"type":0,"value":" Get business hour support from our experts"}],"commerce.message-template.email.features-list.jsm.standard.unlimited-agents":[{"children":[{"type":0,"value":"Unlimited agents:"}],"type":8,"value":"b"},{"type":0,"value":" Grow your team, with no cap on customers"}],"commerce.message-template.email.features-list.loom.business-ai.advanced-editing":[{"children":[{"type":0,"value":"Advanced editing:"}],"type":8,"value":"b"},{"type":0,"value":" Trim, stitch, remove silence and filler words"}],"commerce.message-template.email.features-list.loom.business-ai.unlimited-recording-time":[{"children":[{"type":0,"value":"Unlimited recording time:"}],"type":8,"value":"b"},{"type":0,"value":" Record for as long as you want"}],"commerce.message-template.email.features-list.loom.business-ai.unlimited-videos":[{"children":[{"type":0,"value":"Unlimited videos:"}],"type":8,"value":"b"},{"type":0,"value":" Record as many videos as you want"}],"commerce.message-template.email.features-list.loom.business.editing":[{"children":[{"type":0,"value":"Editing:"}],"type":8,"value":"b"},{"type":0,"value":" Trim out mistakes or stitch multiple videos together"}],"commerce.message-template.email.features-list.loom.business.unlimited-recording-time":[{"children":[{"type":0,"value":"Unlimited recording time:"}],"type":8,"value":"b"},{"type":0,"value":" Record for as long as you want"}],"commerce.message-template.email.features-list.loom.business.unlimited-videos":[{"children":[{"type":0,"value":"Unlimited videos:"}],"type":8,"value":"b"},{"type":0,"value":" Record as many videos as you want"}],"commerce.message-template.email.features-list.service-collection.premium.advanced-aiops":[{"children":[{"type":0,"value":"Advanced AIOps:"}],"type":8,"value":"b"},{"type":0,"value":" Fast alert grouping, incident creation, and more"}],"commerce.message-template.email.features-list.service-collection.premium.ai-agents":[{"children":[{"type":0,"value":"AI agents:"}],"type":8,"value":"b"},{"type":0,"value":" Save time and use AI for basic conversational support"}],"commerce.message-template.email.features-list.service-collection.premium.asset-management":[{"children":[{"type":0,"value":"Asset management:"}],"type":8,"value":"b"},{"type":0,"value":" Manage the lifecycle of assets and services"}],"commerce.message-template.email.features-list.service-collection.standard.ai-powered-agents":[{"children":[{"type":0,"value":"AI-powered agents:"}],"type":8,"value":"b"},{"type":0,"value":" Automate support, resolve requests faster"}],"commerce.message-template.email.features-list.service-collection.standard.custom-help-center":[{"children":[{"type":0,"value":"Custom help center:"}],"type":8,"value":"b"},{"type":0,"value":" Deliver a seamless support experience"}],"commerce.message-template.email.features-list.service-collection.standard.unlimited-emails":[{"children":[{"type":0,"value":"Unlimited emails:"}],"type":8,"value":"b"},{"type":0,"value":" Talk to customers as much as you need"}],"commerce.message-template.email.upgrade-benefits.compass.body.customizations":[{"type":0,"value":"More customizations"}],"commerce.message-template.email.upgrade-benefits.compass.body.increased-user-limits":[{"type":0,"value":"Increased user limits"}],"commerce.message-template.email.upgrade-benefits.compass.body.reusable-templates":[{"type":0,"value":"20 reusable templates"}],"commerce.message-template.email.upgrade-benefits.service-collection.body.agents-and-customers":[{"type":0,"value":"Up to 20,000 agents and unlimited customers"}],"commerce.message-template.email.upgrade-benefits.service-collection.body.ai-powered-support":[{"type":0,"value":"AI-powered employee support, operations, and customer service"}],"commerce.message-template.email.upgrade-benefits.service-collection.body.audit-logs-data-residency":[{"type":0,"value":"Audit logs and multi-region data residency"}],"commerce.message-template.email.upgrade-benefits.service-collection.body.custom-help-center":[{"type":0,"value":"Custom-branded help center"}],"commerce.message-template.email.upgrade-benefits.service-collection.body.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.message-template.email.upgrade-benefits.service-collection.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\'s team of experts"}],"commerce.message-template.email.upgrade-benefits.service-collection.body.unlimited-email-notifications":[{"type":0,"value":"Unlimited email notifications"}],"commerce.message-template.email.upgrade-benifits.compass.body.storage":[{"type":0,"value":"One year of data retention"}],"commerce.message-template.email.upgrade-benifits.compass.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.confluence.body.increased-user-limits":[{"type":0,"value":"Increased user limits"}],"commerce.message-template.email.upgrade-benifits.confluence.body.page-analytics":[{"type":0,"value":"Page analytics"}],"commerce.message-template.email.upgrade-benifits.confluence.body.space-and-page-permissions":[{"type":0,"value":"Space and page permissions"}],"commerce.message-template.email.upgrade-benifits.confluence.body.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.message-template.email.upgrade-benifits.confluence.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.jira.body.create-issues":[{"type":0,"value":"Anonymous access to let external users view and create issues"}],"commerce.message-template.email.upgrade-benifits.jira.body.increased-user-limits":[{"type":0,"value":"Increased user limits"}],"commerce.message-template.email.upgrade-benifits.jira.body.issue-permissions":[{"type":0,"value":"Advanced project and issue permissions"}],"commerce.message-template.email.upgrade-benifits.jira.body.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.message-template.email.upgrade-benifits.jira.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.jpd.body.custom-project-roles":[{"type":0,"value":"Custom project roles"}],"commerce.message-template.email.upgrade-benifits.jpd.body.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.message-template.email.upgrade-benifits.jpd.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.jpd.body.unlimited-creators":[{"type":0,"value":"Unlimited creators"}],"commerce.message-template.email.upgrade-benifits.jsm.body.automation-rules-per-month":[{"type":0,"value":"500 project automation rules per month"}],"commerce.message-template.email.upgrade-benifits.jsm.body.increased-user-limits":[{"type":0,"value":"Increased user limits"}],"commerce.message-template.email.upgrade-benifits.jsm.body.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.message-template.email.upgrade-benifits.jsm.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.jsm.body.track-changes":[{"type":0,"value":"Audit logs to troubleshoot and track changes"}],"commerce.message-template.next-steps":[{"type":0,"value":"Next steps:"}],"commerce.message-template.start-set-up":[{"type":0,"value":"Start set up"}],"commerce.next-bill-estimate-common.key":[{"type":0,"value":"Next estimated bill (prorated):"}],"commerce.partner-manage-subscriptions":[{"type":0,"value":"Your customer contact can cancel the subscription at any time from "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":"."}],"commerce.partner-name.key":[{"type":0,"value":"Atlassian billing partner:"}],"commerce.partner-name.value":[{"type":1,"value":"partnerName"}],"commerce.payment-option-details":[{"type":0,"value":"This payment option allows you to buy your Atlassian products now, and pay within\\n    \\t\\t\\t\\t"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" days."}],"commerce.requested-by-common.key":[{"type":0,"value":"Requested by:"}],"commerce.requested-by-common.value":[{"type":1,"value":"orderPlacedBy"}],"commerce.requested-by-common.value-with-email":[{"type":1,"value":"name"},{"type":0,"value":" ("},{"type":1,"value":"emailLink"},{"type":0,"value":")"}],"commerce.requested-by-common.value-without-email":[{"type":1,"value":"name"}],"commerce.reseller-manage-subscriptions":[{"type":0,"value":"Your customer contact can cancel the subscription at any time from the "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":" page."}],"commerce.reseller-manage-subscriptions-subscription-overview":[{"type":0,"value":"Subscription overview"}],"commerce.servco-post-auto-uplift-email-notification.email.banner-alt":[{"type":0,"value":"Service Collection"}],"commerce.servco-post-auto-uplift-email-notification.email.button-v2":[{"type":0,"value":"See details"}],"commerce.servco-post-auto-uplift-email-notification.email.csm-label":[{"type":0,"value":"Customer Service Management"}],"commerce.servco-post-auto-uplift-email-notification.email.heading":[{"type":0,"value":"Jira Service Management is now part of Service Collection"}],"commerce.servco-post-auto-uplift-email-notification.email.help-message":[{"type":0,"value":"If you have any questions or need assistance exploring the new features, please don\'t hesitate to reach out."}],"commerce.servco-post-auto-uplift-email-notification.email.instruction-how-to-add-label":[{"type":0,"value":"Ready to add to your sites. "},{"type":1,"value":"viewInstructions"}],"commerce.servco-post-auto-uplift-email-notification.email.instructions.url":[{"type":0,"value":"View Instructions"}],"commerce.servco-post-auto-uplift-email-notification.email.intro":[{"type":0,"value":"We\'re excited to announce that as of "},{"type":1,"value":"month"},{"type":0,"value":" "},{"type":1,"value":"day"},{"type":0,"value":", "},{"type":1,"value":"year"},{"type":0,"value":", your Jira Service Management has become part of Service Collection. Try the new Customer Service Management app and enjoy extra features, with no changes to your Jira Service Management."}],"commerce.servco-post-auto-uplift-email-notification.email.jsm-label.v2":[{"type":0,"value":"Jira Service Management"}],"commerce.servco-post-auto-uplift-email-notification.email.new-app-label":[{"type":0,"value":"New app"}],"commerce.servco-post-auto-uplift-email-notification.email.on-your-entitlement":[{"type":0,"value":"On your entitlement:"}],"commerce.servco-post-auto-uplift-email-notification.email.received-because":[{"type":0,"value":"You received this email because you\'re an admin for "},{"type":1,"value":"orgName"},{"type":0,"value":"."}],"commerce.servco-post-auto-uplift-email-notification.email.sent-by":[{"type":0,"value":"This message was sent to you by Atlassian Administration."}],"commerce.servco-post-auto-uplift-email-notification.message-template.email.subject":[{"type":0,"value":"Jira Service Management has moved to Service Collection"}],"commerce.ship-to-information.address-key":[{"type":0,"value":"Address:"}],"commerce.ship-to-information.address-value":[{"type":1,"value":"soldToAddress"}],"commerce.ship-to-information.company-name-key":[{"type":0,"value":"Company:"}],"commerce.ship-to-information.company-name-key-alt-customer":[{"type":0,"value":"Customer:"}],"commerce.ship-to-information.company-name-value":[{"type":1,"value":"soldToCompanyName"}],"commerce.ship-to-information.end-customer-contact-key":[{"type":0,"value":"Customer contact:"}],"commerce.ship-to-information.end-customer-contact-value":[{"type":1,"value":"endCustomerContacts"}],"commerce.ship-to-information.invoice-number-key":[{"type":0,"value":"Invoice number:"}],"commerce.ship-to-information.invoice-number-value":[{"type":1,"value":"invoiceNumber"}],"commerce.subscription-common.entitlement-details":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce.subscription-common.entitlement-details-with-org-name":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") | "},{"type":1,"value":"orgName"}],"commerce.subscription-common.entitlement-details-with-site-url":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" | "},{"type":1,"value":"siteURL"},{"type":0,"value":")"}],"commerce.subscription-common.entitlement-details-without-orgName":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce.subscription-common.key":[{"type":0,"value":"Subscription:"}],"commerce.subscription-common.new-quote-total-key":[{"type":0,"value":"New quote total:"}],"commerce.subscription-common.old-quote-total-key":[{"type":0,"value":"Old quote total:"}],"commerce.subscription-common.quote-number-key":[{"type":0,"value":"Quote:"}],"commerce.subscription-common.quote-number-value":[{"type":1,"value":"quoteNumber"}],"commerce.subscription-common.quote-total-key":[{"type":0,"value":"Quote total:"}],"commerce.subscription-common.quote-total-value":[{"type":1,"value":"currency"},{"type":0,"value":" "},{"type":1,"value":"amount"}],"commerce.subscription-common.value-with-offering":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" "},{"type":1,"value":"entitlementDetails"}],"commerce.subscription-common.value-with-offering-without-entitlement":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" "}],"commerce.subscription-common.value-with-pricing-plan":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"pricingPlanName"},{"type":0,"value":" "},{"type":1,"value":"entitlementDetails"}],"commerce.subscription-common.value-with-product":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"entitlementDetails"}],"commerce.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"commerce.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"commerce.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"common.cloud-payment-retry-actions.admin-hub-url":[{"type":0,"value":"admin.atlassian.com"}],"common.cloud-payment-retry-actions.atlassian-administration":[{"type":0,"value":"Atlassian administration"}],"common.cloud-payment-retry-actions.billing-console-url":[{"type":0,"value":"admin.atlassian.com/billing"}],"common.cloud-payment-retry-actions.billing-overview":[{"type":0,"value":"Billing overview"}],"common.cloud-payment-retry-actions.change-plan":[{"type":0,"value":"Change plan"}],"common.cloud-payment-retry-actions.contact-supportt":[{"type":0,"value":"If you need to speak to our team, you may "},{"type":1,"value":"element"},{"type":0,"value":" to the Atlassian Support Team."}],"common.cloud-payment-retry-actions.contact-us-heading":[{"type":0,"value":"Contact us:"}],"common.cloud-payment-retry-actions.data-storage-faq":[{"type":0,"value":"Data Storage FAQs"}],"common.cloud-payment-retry-actions.downgrade-heading":[{"type":0,"value":"Downgrade to a Free plan:"}],"common.cloud-payment-retry-actions.export-data":[{"type":0,"value":"We advise you to export your business data from your Atlassian instance. For more information, see our "},{"type":1,"value":"element"}],"common.cloud-payment-retry-actions.export-data-heading":[{"type":0,"value":"Export your data:"}],"common.cloud-payment-retry-actions.free":[{"type":0,"value":"Free"}],"common.cloud-payment-retry-actions.free-plan-change":[{"type":0,"value":"Change to the Free plan at "},{"type":1,"value":"link"},{"type":0,"value":". In "},{"type":1,"value":"billingOverview"},{"type":0,"value":", select "},{"type":1,"value":"manage"},{"type":0,"value":" in the "},{"type":1,"value":"subscriptions"},{"type":0,"value":" section. In "},{"type":1,"value":"subscriptionDetails"},{"type":0,"value":", select "},{"type":1,"value":"manage"},{"type":0,"value":" for your product. In "},{"type":1,"value":"subscriptionDetails"},{"type":0,"value":", select "},{"type":1,"value":"planChange"},{"type":0,"value":". Select the "},{"type":1,"value":"free"},{"type":0,"value":" plan and confirm"}],"common.cloud-payment-retry-actions.here-are-actions":[{"type":0,"value":"Here are some actions we suggest you take:"}],"common.cloud-payment-retry-actions.manage":[{"type":0,"value":"Manage"}],"common.cloud-payment-retry-actions.manage-users":[{"type":0,"value":"Manage users"}],"common.cloud-payment-retry-actions.reduce-users":[{"type":0,"value":"If applicable, you\'ll first need to reduce users to 10 or fewer (three agents or fewer for Jira Service Management). Go to your site\'s admin at "},{"type":1,"value":"link"},{"type":0,"value":". In "},{"type":1,"value":"admin"},{"type":0,"value":", select "},{"type":1,"value":"manage"},{"type":0,"value":". Find users you want to remove, and select "},{"type":1,"value":"showDetails"},{"type":0,"value":"."}],"common.cloud-payment-retry-actions.show-details":[{"type":0,"value":"Show details &gt; Actions &gt; Remove user"}],"common.cloud-payment-retry-actions.submit-ticket":[{"type":0,"value":"Submit a ticket"}],"common.cloud-payment-retry-actions.subscription-details":[{"type":0,"value":"Subscription details"}],"common.cloud-payment-retry-actions.subscriptions":[{"type":0,"value":"Subscriptions"}],"common.cloud-payment-retry-actions.what-if-unable":[{"type":0,"value":"What if I\'m unable to make payments?"}],"common.invoice.manage-subscriptions.partner-info":[{"type":0,"value":"To manage subscriptions, visit our Partner Purchasing Center (PPC)."}],"common.invoice.manage-subscriptions.subscription-info":[{"type":0,"value":"To view or manage your invoices and subscription, go to your site\'s Administration."}],"post-office.commerce-access-invalid-payment-hams.caption":[{"type":0,"value":"Action needed: Retry your payment with 3DS authentication"}],"post-office.commerce-access-invalid-payment-hams.error-message.access":[{"type":0,"value":"We couldn\u2019t process your payment for Atlassian Access since we need your help to complete 3-D Secure (3DS) authentication. 3DS is a mechanism that makes your online card transactions more secure."}],"post-office.commerce-access-invalid-payment-hams.error-message.bitbucket":[{"type":0,"value":"We couldn\u2019t process your payment for Bitbucket ("},{"type":1,"value":"bbAccountName"},{"type":0,"value":") since we need your help to complete 3-D Secure (3DS) authentication. 3DS is a mechanism that makes your online card transactions more secure."}],"post-office.commerce-access-invalid-payment-hams.error-message.cloud":[{"type":0,"value":"We couldn\'t process your payment for Atlassian Cloud since we need your help to complete 3-D Secure (3DS) authentication. 3DS is a mechanism that makes your online card transactions more secure."}],"post-office.commerce-access-invalid-payment-hams.error-message.server":[{"type":0,"value":"We couldn\u2019t process your payment for "},{"type":1,"value":"productInfoString"},{"type":0,"value":" since we need your help to complete 3-D Secure (3DS) authentication. 3DS is a mechanism that makes your online card transactions more secure."}],"post-office.commerce-access-invalid-payment-hams.retry-button":[{"type":0,"value":"Retry Payment"}],"post-office.commerce-access-invalid-payment-hams.retry-message":[{"type":0,"value":"Please retry making the payment and complete 3DS authentication. You may be asked to verify through an app, enter a confirmation code sent to your phone, or asked to authenticate in a different way."}],"post-office.commerce-common.Contact-us":[{"type":0,"value":"Contact us"}],"post-office.commerce-common.atlassian-support-team":[{"type":0,"value":"Atlassian Support Team"}],"post-office.commerce-common.auto-upgrade-subscription-details.plan.label":[{"type":0,"value":"Plan"}],"post-office.commerce-common.auto-upgrade-subscription-details.plan.value":[{"type":1,"value":"productName"},{"type":0,"value":" Standard ("},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" user"}]},"other":{"value":[{"type":7},{"type":0,"value":" users"}]}},"pluralType":"cardinal","type":6,"value":"userCount"},{"type":0,"value":")"}],"post-office.commerce-common.auto-upgrade-subscription-details.plan.value.no-user-count":[{"type":1,"value":"productName"},{"type":0,"value":" Standard"}],"post-office.commerce-common.auto-upgrade-subscription-details.switch-back-to-free.heading":[{"type":0,"value":"Not ready to upgrade?"}],"post-office.commerce-common.auto-upgrade-subscription-details.switch-back-to-free.switch-back-to-free-admin":[{"type":0,"value":"You can switch back to a Free plan by "},{"children":[{"type":0,"value":"reducing your user count"}],"type":8,"value":"link"},{"type":0,"value":" to 10 or fewer."}],"post-office.commerce-common.auto-upgrade-subscription-details.switch-back-to-free.switch-back-to-free-non-admin":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" admin can switch back to a Free plan by reducing your user count to 10 or fewer."}],"post-office.commerce-common.blocks.regards":[{"type":0,"value":"Regards,"}],"post-office.commerce-common.blocks.thanks":[{"type":0,"value":"Thanks,"}],"post-office.commerce-common.cheers":[{"type":0,"value":"Cheers,"}],"post-office.commerce-common.cheers.from-atlassian-team":[{"type":0,"value":"The Atlassian team"}],"post-office.commerce-common.cheers.from-atlassians":[{"type":0,"value":"The Atlassians"}],"post-office.commerce-common.choose-plan-link":[{"type":0,"value":"Choose plan"}],"post-office.commerce-common.choose-plan.billing-console":[{"type":0,"value":"Keep Premium plan"}],"post-office.commerce-common.choose-plan.choose-plan.billing-console":[{"type":0,"value":"Choose plan"}],"post-office.commerce-common.consumption.included-quantity-details":[{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"includedQuantityUnit"}],"post-office.commerce-common.consumption.summary-included-quantity":[{"type":0,"value":"Included quantity"}],"post-office.commerce-common.consumptionl.summary-consumed-quantity":[{"type":0,"value":"Consumed quantity"}],"post-office.commerce-common.consumptionl.summary-consumed-quantity-details":[{"type":1,"value":"consumedQuantity"},{"type":0,"value":" "},{"type":1,"value":"consumedQuantityUnit"}],"post-office.commerce-common.consumptionl.summary.consumption-percentage":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% consumed"}],"post-office.commerce-common.contact-support-button.partner":[{"type":0,"value":"Contact Support"}],"post-office.commerce-common.contact-us":[{"type":0,"value":"contact us"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt":[{"type":0,"value":"Atlassian Jira"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-confluence":[{"type":0,"value":"Atlassian Confluence"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-jira-product-discovery":[{"type":0,"value":"Atlassian Jira Product Discovery"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-jira-service-management":[{"type":0,"value":"Atlassian Jira Service Management"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-loom":[{"type":0,"value":"Atlassian Loom"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-service-collection":[{"type":0,"value":"Atlassian Service Collection"}],"post-office.commerce-common.email-header-v3.atlassian-logo-alt":[{"type":0,"value":"Atlassian Jira"}],"post-office.commerce-common.email-header-v3.atlassian-logo-alt-confluence":[{"type":0,"value":"Atlassian Confluence"}],"post-office.commerce-common.email-header-v3.atlassian-logo-alt-jira-product-discovery":[{"type":0,"value":"Atlassian Jira Product Discovery"}],"post-office.commerce-common.email-header-v3.atlassian-logo-alt-loom":[{"type":0,"value":"Atlassian Loom"}],"post-office.commerce-common.email-header-v3.atlassian-logo-alt-serivce-collection":[{"type":0,"value":"Atlassian Service Collection"}],"post-office.commerce-common.email-header-v3.atlassian-logo-alt-teamwork-collection":[{"type":0,"value":"Atlassian Teamwork Collection"}],"post-office.commerce-common.email-header.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.commerce-common.email.plan-section.description.end-of-trial-with-pde":[{"children":[{"type":0,"value":"Switch plans anytime."}],"type":8,"value":"b"},{"type":0,"value":" 30-day money back guarantee if you forget to cancel."}],"post-office.commerce-common.email.plan-section.explore-plan.link-description.end-of-trial-with-pde":[{"children":[{"type":0,"value":"Explore all plans \u2192"}],"type":8,"value":"b"}],"post-office.commerce-common.email.subscription-details-section.billing-cycle-subtitle.end-of-trial-with-pde":[{"type":0,"value":"Billing cycle"}],"post-office.commerce-common.email.subscription-details-section.first-bill-estimate-subtitle.end-of-trial-with-pde":[{"type":0,"value":"First bill estimate"}],"post-office.commerce-common.email.subscription-details-section.first-bill-estimate-suffix.end-of-trial-with-pde":[{"type":0,"value":" (Excludes taxes)"}],"post-office.commerce-common.email.subscription-details-section.plan-subtitle.end-of-trial-with-pde":[{"type":0,"value":"Plan"}],"post-office.commerce-common.email.subscription-details-section.title.end-of-trial-with-pde":[{"type":0,"value":"Subscription details"}],"post-office.commerce-common.email.subscription-details-section.trial-ends-subtitle.end-of-trial-with-pde":[{"type":0,"value":"Trial ends"}],"post-office.commerce-common.email.subscription.deactivate-consequence-section.deactivate-info":[{"type":0,"value":"Add payment details before your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":" to keep all your users and features. If you don\u2019t add payment details or reduce your user count to "},{"type":1,"value":"ceiling"},{"type":0,"value":" or fewer by "},{"type":1,"value":"trialEndDate"},{"type":0,"value":", you will lose access to "},{"type":1,"value":"productName"},{"type":0,"value":" and your data will be permanently deleted."}],"post-office.commerce-common.email.subscription.deactivate-consequence-section.what-to-do-question":[{"type":0,"value":"What do I need to do?"}],"post-office.commerce-common.email.subscription.description.end-of-trial-with-pde":[{"type":0,"value":"When your trial ends, we\u2019ll charge the payment method you chose when you signed up."}],"post-office.commerce-common.email.subscription.downgrade-consequence-section.downgrade-info":[{"type":0,"value":"If you don\u2019t add payment details you\u2019ll downgrade to the Free plan and lose access to your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan features."}],"post-office.commerce-common.email.subscription.downgrade-consequence-section.features-question":[{"type":0,"value":"Which other features will I lose access to?"}],"post-office.commerce-common.email.subscription.headline.end-of-trial-with-pde":[{"type":0,"value":"You don\'t need to do anything"}],"post-office.commerce-common.email.subscription.other-features-you-lose.confluence-premium":[{"type":0,"value":"Comparison between Premium and Free plans. Key differences are unlimited whiteboards, page insights, and access to Rovo on Premium."}],"post-office.commerce-common.email.subscription.other-features-you-lose.confluence-standard":[{"type":0,"value":"Comparison between Standard and Free plans. Key differences are unlimited users, page insights, and access to Rovo on Standard."}],"post-office.commerce-common.email.subscription.other-features-you-lose.jira-premium":[{"type":0,"value":"Comparison between Premium and Free plans. Key differences are plans for multiple projects, ability to assign roles, and access to Rovo on Premium."}],"post-office.commerce-common.email.subscription.other-features-you-lose.jira-standard":[{"type":0,"value":"Comparison between Standard and Free plans. Key differences are unlimited users, ability to assign roles, and access to Rovo on Standard."}],"post-office.commerce-common.email.subscription.other-features-you-lose.jpd-premium":[{"type":0,"value":"Comparison between Premium and Free plans. Key differences are roadmaps for multiple spaces, ability to assign roles, and access to Rovo on Premium."}],"post-office.commerce-common.email.subscription.other-features-you-lose.jpd-standard":[{"type":0,"value":"Comparison between Standard and Free plans. Key differences are unlimited users and ability to assign roles on Standard."}],"post-office.commerce-common.email.subscription.payment-details.keep-your-plan":[{"type":0,"value":"Keep "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"post-office.commerce-common.email.subscription.tick-circle-green-icon.end-of-trial-with-pde":[{"type":0,"value":"Green tick circle icon for the billing section"}],"post-office.commerce-common.features-image.confluence-premium":[{"type":0,"value":"Confluence Premium Features"}],"post-office.commerce-common.features-image.confluence-standard":[{"type":0,"value":"Confluence Standard Features"}],"post-office.commerce-common.features-image.jira-premium":[{"type":0,"value":"Jira Premium Features"}],"post-office.commerce-common.features-image.jira-product-discovery-premium":[{"type":0,"value":"Jira Product Discovery Premium Features"}],"post-office.commerce-common.features-image.jira-product-discovery-standard":[{"type":0,"value":"Jira Product Discovery Standard Features"}],"post-office.commerce-common.features-image.jira-service-management-premium":[{"type":0,"value":"Jira Service Management Premium Features"}],"post-office.commerce-common.features-image.jira-service-management-standard":[{"type":0,"value":"Jira Service Management Standard Features"}],"post-office.commerce-common.features-image.jira-standard":[{"type":0,"value":"Jira Standard Features"}],"post-office.commerce-common.features-image.loom-business":[{"type":0,"value":"Loom Business Features"}],"post-office.commerce-common.features-image.loom-business-ai":[{"type":0,"value":"Loom Business + AI Features"}],"post-office.commerce-common.features-image.service-collection-premium":[{"type":0,"value":"Service Collection Premium Features"}],"post-office.commerce-common.features-image.service-collection-standard":[{"type":0,"value":"Service Collection Standard Features"}],"post-office.commerce-common.footer-v2.ai-disclaimer":[{"type":0,"value":"Some content in this email has been generated by AI."}],"post-office.commerce-common.footer-v2.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.commerce-common.footer-v2.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"post-office.commerce-common.footer-v2.dot-separator":[{"type":0,"value":"\u2022"}],"post-office.commerce-common.footer-v2.facebook-alt-text":[{"type":0,"value":"Facebook"}],"post-office.commerce-common.footer-v2.facebook-title":[{"type":0,"value":"Facebook"}],"post-office.commerce-common.footer-v2.footer-links.contact-us":[{"type":1,"value":"contactLink"}],"post-office.commerce-common.footer-v2.footer-links.privacy-policy":[{"type":1,"value":"privacyPolicy"}],"post-office.commerce-common.footer-v2.footer-links.read-our-blog":[{"type":1,"value":"thirdText"}],"post-office.commerce-common.footer-v2.linkedin-alt-text":[{"type":0,"value":"LinkedIn"}],"post-office.commerce-common.footer-v2.linkedin-title":[{"type":0,"value":"LinkedIn"}],"post-office.commerce-common.footer-v2.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.commerce-common.footer-v2.partner-portal":[{"type":0,"value":"Partner Portal"}],"post-office.commerce-common.footer-v2.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"post-office.commerce-common.footer-v2.read-our-blog":[{"type":0,"value":"Read our blog"}],"post-office.commerce-common.footer-v2.unsubscribe":[{"children":[{"type":0,"value":"Unsubscribe"}],"type":8,"value":"a"},{"type":0,"value":" to opt out of future emails like this"}],"post-office.commerce-common.footer-v2.x-alt-text":[{"type":0,"value":"X"}],"post-office.commerce-common.footer-v2.x-title":[{"type":0,"value":"X"}],"post-office.commerce-common.footer-v2.youtube-alt-text":[{"type":0,"value":"Youtube"}],"post-office.commerce-common.footer-v2.youtube-title":[{"type":0,"value":"Youtube"}],"post-office.commerce-common.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.commerce-common.footer.contact-us":[{"type":0,"value":" Contact us \u2022 "}],"post-office.commerce-common.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"post-office.commerce-common.footer.facebook-alt-text":[{"type":0,"value":"Facebook"}],"post-office.commerce-common.footer.facebook-title":[{"type":0,"value":"Facebook"}],"post-office.commerce-common.footer.footer-links.contact-us":[{"type":1,"value":"contactLink"}],"post-office.commerce-common.footer.footer-links.privacy-policy":[{"type":1,"value":"privacyPolicy"}],"post-office.commerce-common.footer.footer-links.read-our-blog":[{"type":0,"value":" "},{"type":1,"value":"thirdText"}],"post-office.commerce-common.footer.linkedin-alt-text":[{"type":0,"value":"LinkedIn"}],"post-office.commerce-common.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"post-office.commerce-common.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.commerce-common.footer.office-address.we-are-located-at":[{"type":0,"value":"We are located at "}],"post-office.commerce-common.footer.partner-portal":[{"type":0,"value":"Partner Portal"}],"post-office.commerce-common.footer.privacy-policy":[{"type":0,"value":"Privacy Policy \u2022 "}],"post-office.commerce-common.footer.read-our-blog":[{"type":0,"value":"Read our blog"}],"post-office.commerce-common.footer.twitter-alt-text":[{"type":0,"value":"Twitter"}],"post-office.commerce-common.footer.twitter-title":[{"type":0,"value":"Twitter"}],"post-office.commerce-common.formal-goodbye":[{"type":0,"value":"Please "},{"type":1,"value":"contactUsLink"},{"type":0,"value":" with any questions, we\'re always happy to help."}],"post-office.commerce-common.formal-goodbye.contact-representative":[{"type":0,"value":"Contact your Atlassian representative if you have any questions."}],"post-office.commerce-common.formal-thank-you":[{"type":0,"value":"Thank you for taking action at your earliest convenience."}],"post-office.commerce-common.get-in-touch":[{"type":0,"value":"Have a question? We\'re here to help. "},{"type":1,"value":"getInTouchLink"}],"post-office.commerce-common.need-help-with-contact-us":[{"type":0,"value":"Need help with plans and billing? "},{"type":1,"value":"contactUs"}],"post-office.commerce-common.not-personal-greetings":[{"type":0,"value":"Hi,"}],"post-office.commerce-common.payment-details.add":[{"type":0,"value":"Add payment details"}],"post-office.commerce-common.payment-details.add.v2":[{"type":0,"value":"explore your plan options"}],"post-office.commerce-common.payment-details.update":[{"type":0,"value":"Update payment details"}],"post-office.commerce-common.personal-greetings":[{"type":0,"value":"Hi "},{"type":1,"value":"firstName"},{"type":0,"value":","}],"post-office.commerce-common.product.entitlement-number.billing-cycle":[{"type":0,"value":"Billing cycle: "},{"type":1,"value":"billingCycle"}],"post-office.commerce-common.product.entitlement-number.requested-by-email-id":[{"type":0,"value":"Requested by: "},{"type":1,"value":"requestedByEmailId"}],"post-office.commerce-common.product.entitlement-number.site-url.no-translate":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"}]},"true":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" | "},{"type":1,"value":"siteUrl"}]}},"type":5,"value":"hasSiteUrl"}],"post-office.commerce-common.product.entitlement-number.users-count":[{"type":1,"value":"chargeElement"},{"type":0,"value":"s: "},{"type":1,"value":"usersCount"}],"post-office.commerce-common.product.product-title.no-translate":[{"options":{"other":{"value":[{"type":1,"value":"productName"}]},"true":{"value":[{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"offeringName"},{"type":0,"value":")"}]}},"type":5,"value":"hasOfferingName"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-asset-credits":[{"children":[{"type":0,"value":"Assets objects:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-asset-credits-with-unit":[{"children":[{"type":0,"value":"Assets objects:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-automation-credits":[{"children":[{"type":0,"value":"Automation steps:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-automation-credits-with-unit":[{"children":[{"type":0,"value":"Automation steps:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-build-time":[{"children":[{"type":0,"value":"Bitbucket build minutes:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-build-time-with-unit":[{"children":[{"type":0,"value":"Bitbucket build minutes:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-lfs-storage":[{"children":[{"type":0,"value":"Bitbucket Git LFS:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-lfs-storage-with-unit":[{"children":[{"type":0,"value":"Bitbucket Git LFS:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-package-network":[{"children":[{"type":0,"value":"Bitbucket package network:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-package-network-with-unit":[{"children":[{"type":0,"value":"Bitbucket package network:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-package-storage":[{"children":[{"type":0,"value":"Bitbucket package storage:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-package-storage-with-unit":[{"children":[{"type":0,"value":"Bitbucket package storage:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-build-time":[{"children":[{"type":0,"value":"Bitbucket build minutes:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-build-time-with-unit":[{"children":[{"type":0,"value":"Bitbucket build minutes:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-csm-resolution":[{"children":[{"type":0,"value":"AI agent resolutions:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-csm-resolution-with-unit":[{"children":[{"type":0,"value":"AI agent resolutions:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-indexed-objects":[{"children":[{"type":0,"value":"Indexed objects:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-indexed-objects-with-unit":[{"children":[{"type":0,"value":"Indexed objects:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-lfs-storage":[{"children":[{"type":0,"value":"Bitbucket Git LFS:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-lfs-storage-with-unit":[{"children":[{"type":0,"value":"Bitbucket Git LFS:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-package-network":[{"children":[{"type":0,"value":"Bitbucket package network:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-package-network-with-unit":[{"children":[{"type":0,"value":"Bitbucket package network:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-package-storage":[{"children":[{"type":0,"value":"Bitbucket package storage:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-package-storage-with-unit":[{"children":[{"type":0,"value":"Bitbucket package storage:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-rovo-dev-credits":[{"children":[{"type":0,"value":"Rovo credits:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-rovo-dev-credits-with-unit":[{"children":[{"type":0,"value":"Rovo credits:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-runners-concurrency-limit":[{"children":[{"type":0,"value":"Pipeline runners:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-runners-concurrency-limit-with-unit":[{"children":[{"type":0,"value":"Pipeline runners:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription-product-details.bill-estimate-and-currency":[{"type":1,"value":"currency"},{"type":0,"value":" "},{"type":1,"value":"amountExcludingTax"}],"post-office.commerce-common.subscription-product-details.bill-estimate-title":[{"type":0,"value":"Total bill estimate"}],"post-office.commerce-common.subscription-product-details.entitlement-number.no-translate":[{"type":1,"value":"entitlementNumber"}],"post-office.commerce-common.subscription-product-details.exclude-taxes":[{"type":0,"value":"(excludes taxes)"}],"post-office.commerce-common.subscription-product-details.offering-name.user-size.billing-cycle.no-translate":[{"type":1,"value":"siteDetails"}],"post-office.commerce-common.subscription-product-details.product-name.no-translate":[{"type":1,"value":"productName"}],"post-office.commerce-common.subscription-product-details.site-url.no-translate":[{"type":1,"value":"siteURL"}],"post-office.commerce-common.subscription.atlassian-guard-standard":[{"type":0,"value":"Atlassian Guard Standard"}],"post-office.commerce-common.subscription.atlassian-rovo":[{"type":0,"value":"Atlassian Rovo"}],"post-office.commerce-common.subscription.cbp-allowance-detail-asset-credits":[{"type":0,"value":"Assets objects: "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription.cbp-allowance-detail-asset-credits-label":[{"type":0,"value":"Assets objects"}],"post-office.commerce-common.subscription.cbp-allowance-detail-asset-credits-with-unit":[{"type":0,"value":"Assets objects: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-allowance-detail-automation-credits":[{"type":0,"value":"Automation steps: "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-automation-credits-label":[{"type":0,"value":"Automation steps"}],"post-office.commerce-common.subscription.cbp-allowance-detail-automation-credits-with-unit":[{"type":0,"value":"Automation steps: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-build-time":[{"type":0,"value":"Bitbucket build minutes: "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-build-time-label":[{"type":0,"value":"Bitbucket build minutes"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-build-time-with-unit":[{"type":0,"value":"Bitbucket build minutes: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-lfs-storage":[{"type":0,"value":"Bitbucket Git LFS: "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-lfs-storage-label":[{"type":0,"value":"Bitbucket Git LFS"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-lfs-storage-with-unit":[{"type":0,"value":"Bitbucket Git LFS: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-package-network":[{"type":0,"value":"Bitbucket package network: "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-package-network-label":[{"type":0,"value":"Bitbucket package network"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-package-network-with-unit":[{"type":0,"value":"Bitbucket package network: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-package-storage":[{"type":0,"value":"Bitbucket package storage: "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-package-storage-label":[{"type":0,"value":"Bitbucket package storage"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-package-storage-with-unit":[{"type":0,"value":"Bitbucket package storage: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-allowance-detail-build-time":[{"type":0,"value":"Bitbucket build minutes: "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription.cbp-allowance-detail-build-time-label":[{"type":0,"value":"Bitbucket build minutes"}],"post-office.commerce-common.subscription.cbp-allowance-detail-build-time-with-unit":[{"type":0,"value":"Bitbucket build minutes: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-allowance-detail-csm-resolution":[{"type":0,"value":"AI agent resolutions: "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-csm-resolution-label":[{"type":0,"value":"AI agent resolutions"}],"post-office.commerce-common.subscription.cbp-allowance-detail-csm-resolution-with-unit":[{"type":0,"value":"AI agent resolutions: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-default-value-with-unit":[{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-allowance-detail-indexed-objects":[{"type":0,"value":"Indexed objects: "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-indexed-objects-label":[{"type":0,"value":"Indexed objects"}],"post-office.commerce-common.subscription.cbp-allowance-detail-indexed-objects-with-unit":[{"type":0,"value":"Indexed objects: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-lfs-storage":[{"type":0,"value":"Bitbucket Git LFS: "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription.cbp-allowance-detail-lfs-storage-label":[{"type":0,"value":"Bitbucket Git LFS"}],"post-office.commerce-common.subscription.cbp-allowance-detail-lfs-storage-with-unit":[{"type":0,"value":"Bitbucket Git LFS: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-allowance-detail-package-network":[{"type":0,"value":"Bitbucket package network: "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription.cbp-allowance-detail-package-network-label":[{"type":0,"value":"Bitbucket package network"}],"post-office.commerce-common.subscription.cbp-allowance-detail-package-network-with-unit":[{"type":0,"value":"Bitbucket package network: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-allowance-detail-package-storage":[{"type":0,"value":"Bitbucket package storage: "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription.cbp-allowance-detail-package-storage-label":[{"type":0,"value":"Bitbucket package storage"}],"post-office.commerce-common.subscription.cbp-allowance-detail-package-storage-with-unit":[{"type":0,"value":"Bitbucket package storage: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-allowance-detail-per-month-value":[{"type":1,"value":"value"},{"type":0,"value":" / month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-per-month-value-with-unit":[{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":" / month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-per-user-per-month-value":[{"type":1,"value":"value"},{"type":0,"value":" per user / month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-per-user-per-month-value-with-unit":[{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":" per user / month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-rovo-dev-credits":[{"type":0,"value":"Rovo credits: "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-rovo-dev-credits-label":[{"type":0,"value":"Rovo credits"}],"post-office.commerce-common.subscription.cbp-allowance-detail-rovo-dev-credits-with-unit":[{"type":0,"value":"Rovo credits: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-runners-concurrency-limit":[{"type":0,"value":"Pipeline runners: "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription.cbp-allowance-detail-runners-concurrency-limit-label":[{"type":0,"value":"Pipeline runners"}],"post-office.commerce-common.subscription.cbp-allowance-detail-runners-concurrency-limit-with-unit":[{"type":0,"value":"Pipeline runners: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-charge-element-package-network":[{"children":[{"type":0,"value":"Network traffic:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-charge-element-package-storage":[{"children":[{"type":0,"value":"Package storage:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-charge-element-rovo-dev-credits":[{"children":[{"type":0,"value":"Rovo Dev credits:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" credits per user"}],"post-office.commerce-common.subscription.cbp-charge-element-runners":[{"children":[{"type":0,"value":"Pipeline runners:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-charge-element-storage":[{"children":[{"type":0,"value":"Storage (Git LFS):"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-charge-element-storage-minutes":[{"children":[{"type":0,"value":"Build minutes:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.free-access":[{"type":0,"value":"Free access to:"}],"post-office.commerce-common.subscription.included-apps":[{"type":0,"value":"Included apps:"}],"post-office.commerce-common.subscription.pooled-allocation.per-user-month":[{"type":1,"value":"credits"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" per user/month"}],"post-office.commerce-common.subscription.product-title.no-translate":[{"type":1,"value":"productName"}],"post-office.commerce-common.subscription.product.billing-admin-partner-contextual-info.address.no-translate":[{"type":0,"value":"Address: "},{"type":1,"value":"address"}],"post-office.commerce-common.subscription.product.billing-admin-partner-contextual-info.company.no-translate":[{"type":0,"value":"Company: "},{"type":1,"value":"companyName"}],"post-office.commerce-common.subscription.product.billing-admin-partner-contextual-info.customer-contact.no-translate":[{"type":0,"value":"Customer contact: "},{"type":1,"value":"customerContact"}],"post-office.commerce-common.subscription.product.billing-cycle.no-translate":[{"type":0,"value":"| "},{"type":1,"value":"billingCycle"}],"post-office.commerce-common.subscription.product.billing-user-partner-contextual-info.partner-name.no-translate":[{"type":0,"value":"Atlassian billing partner: "},{"type":1,"value":"billingPartner"}],"post-office.commerce-common.subscription.product.charge quantities.no-translate":[{"type":0,"value":"| "},{"type":1,"value":"usageQuantity"},{"type":0,"value":" "},{"type":1,"value":"chargeElement"},{"type":0,"value":"s "}],"post-office.commerce-common.subscription.product.entitlement-number.no-translate":[{"type":1,"value":"entitlementNumber"}],"post-office.commerce-common.subscription.product.offering-name.no-translate":[{"type":1,"value":"offeringName"},{"type":0,"value":" "}],"post-office.commerce-common.subscription.product.site-url.no-translate":[{"type":1,"value":"siteUrl"}],"post-office.commerce-common.subscription.rovo-dev-credit-allocation.per-user":[{"type":1,"value":"credits"},{"type":0,"value":" Rovo Dev credits per user"}],"post-office.commerce-common.subscriptions-change-plan":[{"type":0,"value":"Subscriptions"}],"post-office.commerce-common.subscriptions.excludes-taxes":[{"type":0,"value":"(excludes taxes)"}],"post-office.commerce-common.subscriptions.this-payment-is-for":[{"type":0,"value":"This payment is for:"}],"post-office.commerce-common.subscriptions.total-bill-estimate":[{"type":0,"value":"Total bill estimate:"}],"post-office.commerce-common.subscriptions.total-bill-estimate-after-trial":[{"type":0,"value":"Total bill estimate after trial ends:"}],"post-office.commerce-common.subscriptions.your-estimated-bill-is":[{"type":0,"value":"Your estimated bill is:"}],"post-office.commerce-common.the-atlassian-team":[{"type":0,"value":"The Atlassian team"}],"post-office.commerce-common.view-subscription.billing-console":[{"type":0,"value":"View subscription"}],"post-office.commerce-decoupled-offering-ccp.button.review-bill":[{"type":0,"value":"Review your new bill"}],"post-office.commerce-decoupled-offering-ccp.marketplace-details-guide":[{"type":0,"value":"how Marketplace apps are billed"}],"post-office.commerce-order-fulfilled-ccp.email.billing-account.other-host-type":[{"type":0,"value":"billing account"}],"post-office.commerce-order-fulfilled-ccp.email.billing-url":[{"type":1,"value":"url"}],"post-office.commerce-order-fulfilled-ccp.email.cmk.support-url":[{"type":0,"value":"page"}],"post-office.commerce-order-fulfilled-ccp.email.direct-customer.get-started":[{"type":0,"value":"get started"}],"post-office.commerce-order-fulfilled-ccp.email.siteAdmin.cloud":[{"type":0,"value":"site\u2019s "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"}],"post-office.commerce-order-fulfilled-ccp.email.support-url":[{"type":0,"value":"billing support"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.billing-url":[{"type":1,"value":"url"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.get-started":[{"type":0,"value":"get started"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.siteAdmin":[{"type":0,"value":"Administration"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.support-url":[{"type":1,"value":"url"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.view-quote-url":[{"type":0,"value":"Learn more"}],"post-office.commerce-payment-failure-hams.email.support.additional_actions":[{"type":0,"value":"additional actions"}],"post-office.commerce-payment-failure-hams.email.title.check-payment-details":[{"type":0,"value":"Action needed: Please update your payment details"}],"post-office.commerce-payment-failure-hams.email.title.expiration":[{"type":0,"value":"This doesn\'t have to be a goodbye"}],"post-office.commerce-payment-failure-hams.email.title.expired":[{"type":0,"value":"Your Atlassian subscription has expired"}],"post-office.commerce-payment-failure-hams.email.title.make-it-official":[{"type":0,"value":"Let\'s make it official!"}],"post-office.commerce-payment-failure-hams.email.title.trial-check-payment-details":[{"type":0,"value":"Action needed: Please update your payment details"}],"post-office.commerce-payment-failure-hams.email.title.trial-end":[{"type":0,"value":"Your trial has ended. What\'s next?"}],"post-office.commerce-subscription-auto-downgrade-ccp.bac-banner.body.with-plan":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" has been downgraded to the "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan."}],"post-office.commerce-subscription-auto-downgrade-ccp.bac-banner.restore-plan":[{"type":0,"value":"Restore "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"post-office.commerce-subscription-auto-downgrade-ccp.bac-banner.title":[{"type":0,"value":"Your "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has ended"}],"post-office.commerce-subscription-paid-trials-auto-conversion-off-ccp.email.partner.set-up":[{"type":0,"value":"set up the collection"}],"post-office.commerce-subscription-paid-trials-ccp.email.direct-customer.set-up":[{"type":0,"value":"set up your collection"}],"post-office.commerce-subscription-paid-trials-ccp.email.partner.set-up":[{"type":0,"value":"sets up the collection"}],"post-office.commerce.star-email-template.body.agent-limit":[{"type":0,"value":"Get "},{"children":[{"type":0,"value":"unlimited agents"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"250 GB file storage"}],"type":8,"value":"b"}],"post-office.commerce.star-email-template.body.ai-triage":[{"type":0,"value":"Use "},{"children":[{"type":0,"value":"AI"}],"type":8,"value":"b"},{"type":0,"value":" to triage requests from portal, email, and chat"}],"post-office.commerce.star-email-template.body.ai-written-support":[{"type":0,"value":"Power your Rovo agent with "},{"children":[{"type":0,"value":"AI written support articles"}],"type":8,"value":"b"}],"post-office.commerce.star-email-template.body.assets":[{"type":0,"value":"Track business "},{"children":[{"type":0,"value":"assets"}],"type":8,"value":"b"},{"type":0,"value":" and link them to work items"}],"post-office.commerce.star-email-template.body.auto":[{"type":0,"value":"You\'ve reached the agent limit for your Free plan, so we\'ve upgraded you to our "},{"children":[{"type":0,"value":"14-day free trial"}],"type":8,"value":"b"},{"type":0,"value":" of the "},{"children":[{"type":0,"value":"Standard"}],"type":8,"value":"b"},{"type":0,"value":" plan."}],"post-office.commerce.star-email-template.body.auto.change-your-mind":[{"type":0,"value":"If you change your mind, get refunded in the first 30 days of your purchase. You can also "},{"children":[{"type":0,"value":"cancel or switch back to the Free plan"}],"type":8,"value":"b"},{"type":0,"value":" anytime by reducing your usage to be within its limits."}],"post-office.commerce.star-email-template.body.auto.storage":[{"type":0,"value":"You\'ve reached the 2 GB storage limit for your Free plan, so we\'ve upgraded you to our "},{"children":[{"type":0,"value":"14-day free trial"}],"type":8,"value":"b"},{"type":0,"value":" of the "},{"children":[{"type":0,"value":"Standard"}],"type":8,"value":"b"},{"type":0,"value":" plan."}],"post-office.commerce.star-email-template.body.billing-date-with-pde":[{"type":0,"value":"You won\'t be charged until your next billing date on "},{"children":[{"type":1,"value":"nextBillTimestamp"}],"type":8,"value":"b"},{"type":0,"value":". We\'ll remind you 3 days before your trial ends."}],"post-office.commerce.star-email-template.body.billing-date-without-pde":[{"type":0,"value":"To continue with Standard, add payment details by "},{"children":[{"type":1,"value":"nextBillTimestamp"}],"type":8,"value":"b"},{"type":0,"value":". We\'ll remind you 3 days before your trial ends."}],"post-office.commerce.star-email-template.body.direct":[{"type":0,"value":"You\'re currently on a "},{"children":[{"type":0,"value":"14-day free trial"}],"type":8,"value":"b"},{"type":0,"value":" of our "},{"children":[{"type":0,"value":"Standard plan"}],"type":8,"value":"b"},{"type":0,"value":". Dive in to manage requests, incidents, changes and assets. All in one place, with the power of AI."}],"post-office.commerce.star-email-template.body.manual":[{"type":0,"value":"Enjoy your "},{"children":[{"type":0,"value":"14-day free trial"}],"type":8,"value":"b"},{"type":0,"value":" of our "},{"children":[{"type":0,"value":"Standard plan"}],"type":8,"value":"b"},{"type":0,"value":" with brand new benefits like AI, Assets, higher automation limits and unlimited agents."}],"post-office.commerce.star-email-template.body.manual-direct.change-your-mind":[{"type":0,"value":"If you change your mind, get refunded in the first 30 days of your purchase. You can also "},{"children":[{"type":0,"value":"cancel or switch back to the Free plan"}],"type":8,"value":"b"},{"type":0,"value":" anytime."}],"post-office.commerce.star-email-template.body.rovo-ai-agents":[{"type":0,"value":"Resolve requests and incidents faster with "},{"children":[{"type":0,"value":"Rovo AI agents"}],"type":8,"value":"b"}],"post-office.commerce.star-email-template.body.rovo-ai-agents-direct":[{"type":0,"value":"Resolve requests and incidents faster with "},{"children":[{"type":0,"value":"AI agents"}],"type":8,"value":"b"}],"post-office.commerce.star-email-template.button.explore-standard-direct":[{"type":0,"value":"Explore your new service space"}],"post-office.commerce.star-email-template.button.explore-standard-manual-auto":[{"type":0,"value":"Explore Standard"}],"post-office.commerce.star-email-template.caption.add-payment-details-button":[{"type":0,"value":"Add Payment Details"}],"post-office.commerce.star-email-template.caption.billing":[{"type":0,"value":"What happens to your billing?"}],"post-office.commerce.star-email-template.caption.heading.auto":[{"type":0,"value":"\uD83D\uDC4B Say hello to unlimited agents"}],"post-office.commerce.star-email-template.caption.heading.auto.storage":[{"type":0,"value":"\uD83D\uDC4B Say hello to more storage"}],"post-office.commerce.star-email-template.caption.heading.welcome.manual-direct":[{"type":0,"value":"\uD83C\uDF89 Welcome to Service Collection Standard"}],"post-office.commerce.star-email-template.link.explore-plans":[{"type":0,"value":"Explore all plans"}],"post-office.commerce.star-email-template.subject.auto-upgrade":[{"type":0,"value":"You\'ve been upgraded to our Standard plan - free for 14 days"}],"post-office.commerce.star-email-template.subject.direct-trial":[{"type":0,"value":"Welcome to your Service Collection "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan!"}],"post-office.commerce.star-email-template.subject.manual-trial":[{"type":0,"value":"Your "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialDaysLeft"},{"type":0,"value":" free trial of our "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan has started"}],"post-office.commerce.star-email-template.subscription.excludes-taxes":[{"type":0,"value":"(Excludes Taxes)"}],"post-office.commerce.star-email-template.subscription.header":[{"type":0,"value":"Subscription Details"}],"post-office.commerce.star-email-template.subscription.header-no-payment":[{"type":0,"value":"Trial details"}],"post-office.commerce.star-email-template.subscription.included-apps":[{"type":0,"value":"Included apps:"}],"post-office.commerce.star-email-template.subscription.next-bill-date":[{"type":0,"value":"Next bill date"}],"post-office.commerce.star-email-template.subscription.next-bill-estimate":[{"type":0,"value":"Next bill estimate"}],"post-office.commerce.star-email-template.subscription.next-bill-estimate-no-payment":[{"type":0,"value":"Estimated first bill"}],"post-office.commerce.star-email-template.subscription.trial-end-date":[{"type":0,"value":"Trial ends"}],"post-office.commerce.star-email-template.subscription.users":[{"type":1,"value":"count"},{"type":0,"value":" "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"user"}]},"other":{"value":[{"type":0,"value":"users"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"post-office.star-email-template.email-header-alt":[{"type":0,"value":"Service Collection"}],"post-office.star-email-template.email-header-subtitle":[{"type":0,"value":"Includes:"}],"post-office.star-email-template.footer.ai-disclaimer":[{"type":0,"value":"Some content in this email has been generated by AI."}],"post-office.star-email-template.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.star-email-template.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"post-office.star-email-template.footer.dot-separator":[{"type":0,"value":"\u2022"}],"post-office.star-email-template.footer.facebook-alt-text":[{"type":0,"value":"Facebook"}],"post-office.star-email-template.footer.facebook-title":[{"type":0,"value":"Facebook"}],"post-office.star-email-template.footer.linkedin-alt-text":[{"type":0,"value":"LinkedIn"}],"post-office.star-email-template.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"post-office.star-email-template.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.star-email-template.footer.partner-portal":[{"type":0,"value":"Partner Portal"}],"post-office.star-email-template.footer.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"post-office.star-email-template.footer.read-our-blog":[{"type":0,"value":"Read our blog"}],"post-office.star-email-template.footer.unsubscribe":[{"children":[{"type":0,"value":"Unsubscribe"}],"type":8,"value":"a"},{"type":0,"value":" to opt out of future emails like this"}],"post-office.star-email-template.footer.x-alt-text":[{"type":0,"value":"X"}],"post-office.star-email-template.footer.x-title":[{"type":0,"value":"X"}],"post-office.star-email-template.footer.youtube-alt-text":[{"type":0,"value":"Youtube"}],"post-office.star-email-template.footer.youtube-title":[{"type":0,"value":"Youtube"}]}');

});

parcelRegister("hWly3", function(module, exports) {

let $d0f8918199dfb820$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d0f8918199dfb820$var$load("1vCS4").then(()=>parcelRequire('2vnwT'));

});

parcelRegister("kD2jz", function(module, exports) {

let $f0493ed50b23f670$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f0493ed50b23f670$var$load("f8KfO").then(()=>parcelRequire('8BTik'));

});

parcelRegister("1w2IL", function(module, exports) {

let $11aae3ea361742f4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $11aae3ea361742f4$var$load("kTn2q").then(()=>parcelRequire('dBx2j'));

});

parcelRegister("8RbOE", function(module, exports) {

let $672c70600b004d4e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $672c70600b004d4e$var$load("5uMul").then(()=>parcelRequire('37nX5'));

});

parcelRegister("63Yel", function(module, exports) {

let $46a1be6924618d7b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $46a1be6924618d7b$var$load("c1VEk").then(()=>parcelRequire('e2UQ4'));

});

parcelRegister("5M5pV", function(module, exports) {

let $4345a32f29659869$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4345a32f29659869$var$load("73Pi9").then(()=>parcelRequire('7juli'));

});

parcelRegister("2nT0u", function(module, exports) {

let $1bc865f4d97f4a36$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1bc865f4d97f4a36$var$load("gkEwh").then(()=>parcelRequire('lqGqh'));

});

parcelRegister("3e8DW", function(module, exports) {

let $2599624000f6b6a9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2599624000f6b6a9$var$load("bYFNb").then(()=>parcelRequire('7B3R9'));

});

parcelRegister("7OtJ9", function(module, exports) {

let $5b044321ea4353c5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5b044321ea4353c5$var$load("82NW6").then(()=>parcelRequire('aZesB'));

});

parcelRegister("c9erU", function(module, exports) {

let $8d81889d68d47224$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8d81889d68d47224$var$load("1Dbsb").then(()=>parcelRequire('equoS'));

});

parcelRegister("jxNdA", function(module, exports) {

let $e3a74717df47386c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e3a74717df47386c$var$load("h4z0k").then(()=>parcelRequire('8Wpsg'));

});

parcelRegister("fdsXl", function(module, exports) {

let $b13e87fce887e10d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b13e87fce887e10d$var$load("kIPH1").then(()=>parcelRequire('6dPAH'));

});

parcelRegister("fNRe5", function(module, exports) {

let $b814b83f36a07bd4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b814b83f36a07bd4$var$load("ebJuj").then(()=>parcelRequire('ggVYZ'));

});

parcelRegister("kPor2", function(module, exports) {

let $f29b866320c3afc1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f29b866320c3afc1$var$load("4TMY0").then(()=>parcelRequire('9p5H9'));

});

parcelRegister("2kbU2", function(module, exports) {

let $1b16aea8da0abedc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1b16aea8da0abedc$var$load("1cH6h").then(()=>parcelRequire('8aeX8'));

});

parcelRegister("fZi6C", function(module, exports) {

let $ba3a98f218532e90$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ba3a98f218532e90$var$load("3PH8B").then(()=>parcelRequire('4RJ4O'));

});

parcelRegister("eRwKc", function(module, exports) {

let $ad1f6a3adf8cfd61$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ad1f6a3adf8cfd61$var$load("brR2x").then(()=>parcelRequire('ce2xj'));

});

parcelRegister("yg9gZ", function(module, exports) {

let $066fb3dbf01d9661$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $066fb3dbf01d9661$var$load("bQ8uQ").then(()=>parcelRequire('l1RCr'));

});

parcelRegister("zjuWb", function(module, exports) {

let $06a264e4df9a0983$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $06a264e4df9a0983$var$load("3CHBz").then(()=>parcelRequire('aCXGM'));

});

parcelRegister("enIzW", function(module, exports) {

let $a785cb0e44999d3a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a785cb0e44999d3a$var$load("hqjTG").then(()=>parcelRequire('2Epvx'));

});

parcelRegister("8rNKP", function(module, exports) {

let $6267708a0f6db3ad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6267708a0f6db3ad$var$load("9DQ1i").then(()=>parcelRequire('01cHG'));

});

parcelRegister("hzrWy", function(module, exports) {

let $ccab6185f9a9ce1a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ccab6185f9a9ce1a$var$load("eJKPl").then(()=>parcelRequire('ahcE1'));

});

parcelRegister("M9Xz5", function(module, exports) {

let $090c359a55d75dd1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $090c359a55d75dd1$var$load("g7h0d").then(()=>parcelRequire('dPSPT'));

});

parcelRegister("2I4JV", function(module, exports) {

let $1f935e0597102150$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1f935e0597102150$var$load("6wIOl").then(()=>parcelRequire('7I0Sx'));

});

parcelRegister("026q8", function(module, exports) {

let $00652afc4c448f86$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $00652afc4c448f86$var$load("aHXF0").then(()=>parcelRequire('63hEC'));

});

parcelRegister("46mMR", function(module, exports) {

let $2fc965ff6789c976$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2fc965ff6789c976$var$load("5gOt7").then(()=>parcelRequire('h4JGL'));

});

parcelRegister("kezJr", function(module, exports) {

let $ebb0d5172cf66331$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ebb0d5172cf66331$var$load("lsavo").then(()=>parcelRequire('6dV99'));

});

parcelRegister("dsfVu", function(module, exports) {

let $0287220a55fe3e4f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0287220a55fe3e4f$var$load("ga6DO").then(()=>parcelRequire('uF7NE'));

});

parcelRegister("j1a5i", function(module, exports) {

let $dd85eee5736e92a7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dd85eee5736e92a7$var$load("8v3WH").then(()=>parcelRequire('bTHXI'));

});

parcelRegister("kuDvi", function(module, exports) {

let $eeb540a43d0df58f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eeb540a43d0df58f$var$load("hPGN2").then(()=>parcelRequire('7oNEf'));

});

parcelRegister("9jMo8", function(module, exports) {

let $6c8b6c5274eb6267$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6c8b6c5274eb6267$var$load("2a33i").then(()=>parcelRequire('i8TJK'));

});

parcelRegister("hrIu5", function(module, exports) {

let $cb3776f57be19fb0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cb3776f57be19fb0$var$load("9f1ZJ").then(()=>parcelRequire('jWhXH'));

});

parcelRegister("04ndd", function(module, exports) {

let $00d2614e850b2dfc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $00d2614e850b2dfc$var$load("aonFR").then(()=>parcelRequire('jzfNl'));

});

parcelRegister("gnNML", function(module, exports) {

let $bed569aa2aa0fe52$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bed569aa2aa0fe52$var$load("eKKVJ").then(()=>parcelRequire('5M7U7'));

});

parcelRegister("evz1y", function(module, exports) {

let $a8ff20f74d1d46e7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a8ff20f74d1d46e7$var$load("4FcIh").then(()=>parcelRequire('1MW0k'));

});

parcelRegister("k2auA", function(module, exports) {
module.exports = JSON.parse('{"confluence-ai-audio.scenario-changeboarding.backButton":[{"type":0,"value":"Back"}],"confluence-ai-audio.scenario-changeboarding.doneButton":[{"type":0,"value":"Done"}],"confluence-ai-audio.scenario-changeboarding.nextButton":[{"type":0,"value":"Next"}],"confluence-ai-audio.scenario-changeboarding.step1Body":[{"type":0,"value":"Not ready to listen? Add it to your playlist for later or play it on the app."}],"confluence-ai-audio.scenario-changeboarding.step1Headline":[{"type":0,"value":"Save it"}],"confluence-ai-audio.scenario-changeboarding.step2Body":[{"type":0,"value":"See what\u2019s next, change the order, or start playing."}],"confluence-ai-audio.scenario-changeboarding.step2Headline":[{"type":0,"value":"Open playlist"}],"confluence-ai-audio.scenario-changeboarding.step3Body":[{"type":0,"value":"Copy and share a link so anyone with access can listen."}],"confluence-ai-audio.scenario-changeboarding.step3Headline":[{"type":0,"value":"Share it"}],"confluence-ai-audio.scenario-changeboarding.stepIndicator":[{"type":1,"value":"currentStep"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"post-office.audio-button-spotlight.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2 hello there"}],"post-office.audio-player-spotlight-tour.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}]}');

});

parcelRegister("FwuiN", function(module, exports) {

let $07cd07d6dc583847$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $07cd07d6dc583847$var$load("bvzn7").then(()=>parcelRequire('7ZQnz'));

});

parcelRegister("eNgNU", function(module, exports) {

let $ac52ad316f16984d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ac52ad316f16984d$var$load("4JNj3").then(()=>parcelRequire('3uIoZ'));

});

parcelRegister("lUgKS", function(module, exports) {

let $ff2bd3270ec6506a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ff2bd3270ec6506a$var$load("6Sc8a").then(()=>parcelRequire('53xVm'));

});

parcelRegister("7ThjH", function(module, exports) {

let $5beb1a2e5594f9de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5beb1a2e5594f9de$var$load("5PMZ7").then(()=>parcelRequire('kbnAl'));

});

parcelRegister("9sv9x", function(module, exports) {

let $6e2ee4e4df261b33$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6e2ee4e4df261b33$var$load("eFPiR").then(()=>parcelRequire('bzJlI'));

});

parcelRegister("782SK", function(module, exports) {

let $530b840db98fa19c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $530b840db98fa19c$var$load("gNoLM").then(()=>parcelRequire('gM5CY'));

});

parcelRegister("fKkKP", function(module, exports) {

let $b76b4048b41d8f5d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b76b4048b41d8f5d$var$load("jfLa3").then(()=>parcelRequire('2UqKe'));

});

parcelRegister("5cj9Q", function(module, exports) {

let $3c8cef132fae3feb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3c8cef132fae3feb$var$load("aXEGC").then(()=>parcelRequire('5rcuK'));

});

parcelRegister("i1khq", function(module, exports) {

let $d1e80d306523600c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d1e80d306523600c$var$load("8LJb5").then(()=>parcelRequire('3dnnL'));

});

parcelRegister("SNoUr", function(module, exports) {

let $0a4b5d3921ed3aec$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0a4b5d3921ed3aec$var$load("cZ1pB").then(()=>parcelRequire('l0pmC'));

});

parcelRegister("1cRIF", function(module, exports) {

let $0e1094fabe83d0b0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0e1094fabe83d0b0$var$load("ffzdy").then(()=>parcelRequire('lHuP1'));

});

parcelRegister("dzVtf", function(module, exports) {

let $9e2b1fc193892750$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9e2b1fc193892750$var$load("d27F7").then(()=>parcelRequire('k1dfP'));

});

parcelRegister("gRM9j", function(module, exports) {

let $c476f20187ea9a56$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c476f20187ea9a56$var$load("hQMun").then(()=>parcelRequire('bIE2F'));

});

parcelRegister("9Mae7", function(module, exports) {

let $71e08791f2407bc2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $71e08791f2407bc2$var$load("3mvse").then(()=>parcelRequire('cDWwk'));

});

parcelRegister("8qc8Y", function(module, exports) {

let $621a2beb62bd4b0c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $621a2beb62bd4b0c$var$load("iNJuM").then(()=>parcelRequire('5a4ee'));

});

parcelRegister("hENPP", function(module, exports) {

let $cdacd448d6128674$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cdacd448d6128674$var$load("kTLg7").then(()=>parcelRequire('53Dtk'));

});

parcelRegister("h9rEa", function(module, exports) {

let $c7c8b905ad4c37ef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c7c8b905ad4c37ef$var$load("fuRbZ").then(()=>parcelRequire('lSkKw'));

});

parcelRegister("4Uw1Y", function(module, exports) {

let $39353d0d88612d1d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $39353d0d88612d1d$var$load("lgdty").then(()=>parcelRequire('arOdO'));

});

parcelRegister("a2LSY", function(module, exports) {

let $74ff3c6788cedd07$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $74ff3c6788cedd07$var$load("2Zf1V").then(()=>parcelRequire('irsZi'));

});

parcelRegister("jTUwT", function(module, exports) {

let $e7cf00f952d7eddb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e7cf00f952d7eddb$var$load("j01vV").then(()=>parcelRequire('8sQ1G'));

});

parcelRegister("6kNHQ", function(module, exports) {

let $49cb2aec3bc44cd9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $49cb2aec3bc44cd9$var$load("32Y6K").then(()=>parcelRequire('jjbTG'));

});

parcelRegister("dLmOX", function(module, exports) {

let $a0515de5ab0b10f9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a0515de5ab0b10f9$var$load("ID2Zz").then(()=>parcelRequire('l9iLx'));

});

parcelRegister("aCYfF", function(module, exports) {

let $7bcc30be605c5e67$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7bcc30be605c5e67$var$load("fqmZx").then(()=>parcelRequire('b0sxg'));

});

parcelRegister("fWbyw", function(module, exports) {

let $b9a53c8a52a3d189$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b9a53c8a52a3d189$var$load("83g46").then(()=>parcelRequire('fcV88'));

});

parcelRegister("as9ur", function(module, exports) {

let $79c3e16d3782ac4d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $79c3e16d3782ac4d$var$load("j0xox").then(()=>parcelRequire('3rW6P'));

});

parcelRegister("5x5w9", function(module, exports) {

let $407450809c1f159e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $407450809c1f159e$var$load("dabrh").then(()=>parcelRequire('3j7l0'));

});

parcelRegister("eJkio", function(module, exports) {

let $ab9502f855e9ad6e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ab9502f855e9ad6e$var$load("awyMj").then(()=>parcelRequire('gwSds'));

});

parcelRegister("e1SWB", function(module, exports) {

let $a36bc770510d36cc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a36bc770510d36cc$var$load("k8KoF").then(()=>parcelRequire('deuDv'));

});

parcelRegister("e8j4V", function(module, exports) {

let $a4a09c9ca2aad9fb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a4a09c9ca2aad9fb$var$load("kNvQj").then(()=>parcelRequire('41hqQ'));

});

parcelRegister("4ZM8U", function(module, exports) {

let $3a32341711b3f31c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3a32341711b3f31c$var$load("6ccwN").then(()=>parcelRequire('2F5Ek'));

});

parcelRegister("kljmN", function(module, exports) {

let $ecf4caa42c8a43de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ecf4caa42c8a43de$var$load("jIVAP").then(()=>parcelRequire('8YtHg'));

});

parcelRegister("eZ572", function(module, exports) {

let $ae8aba7095cc27bb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae8aba7095cc27bb$var$load("8Hnn3").then(()=>parcelRequire('7tZTX'));

});

parcelRegister("62Cc4", function(module, exports) {

let $46608e741d193fbd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $46608e741d193fbd$var$load("goxlR").then(()=>parcelRequire('dEcBE'));

});

parcelRegister("8MpM5", function(module, exports) {

let $6646ccb97ff7db94$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6646ccb97ff7db94$var$load("kZJPe").then(()=>parcelRequire('2f9bg'));

});

parcelRegister("9aKzs", function(module, exports) {
module.exports = JSON.parse("{\"post-office.confluence-create-agent-spotlight.spotlight-button\":[{\"type\":0,\"value\":\"Got it\"}],\"post-office.confluence-create-agent-spotlight.spotlight-description\":[{\"type\":0,\"value\":\"Create custom agents trained on your team's workflow so they can jump in at anytime.\"}],\"post-office.confluence-create-agent-spotlight.spotlight-header\":[{\"type\":0,\"value\":\"Build your perfect teammate\"}],\"post-office.confluence-create-agent-spotlight.spotlight-image-alt\":[{\"type\":0,\"value\":\"Create agent illustration\"}]}");

});

parcelRegister("8GURh", function(module, exports) {

let $653e59db58ec0e55$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $653e59db58ec0e55$var$load("59VZS").then(()=>parcelRequire('hNZLv'));

});

parcelRegister("4zGtD", function(module, exports) {

let $354b6158b63b6a61$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $354b6158b63b6a61$var$load("fD3Bu").then(()=>parcelRequire('fKvt9'));

});

parcelRegister("aid6F", function(module, exports) {

let $77e5c07eb1cfc49a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $77e5c07eb1cfc49a$var$load("gRJ61").then(()=>parcelRequire('4tVLF'));

});

parcelRegister("4Clyy", function(module, exports) {

let $35cb6eaa02af2c27$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $35cb6eaa02af2c27$var$load("db90I").then(()=>parcelRequire('g1dkF'));

});

parcelRegister("8uQPR", function(module, exports) {

let $62fa1c1db5c732c5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $62fa1c1db5c732c5$var$load("joW5u").then(()=>parcelRequire('k9KM9'));

});

parcelRegister("hOrRF", function(module, exports) {

let $cf7cb886f3239849$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cf7cb886f3239849$var$load("67xgi").then(()=>parcelRequire('5WdXD'));

});

parcelRegister("2yPxv", function(module, exports) {

let $1dd6bc6451171c90$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1dd6bc6451171c90$var$load("bVvFl").then(()=>parcelRequire('fFON2'));

});

parcelRegister("2jMAY", function(module, exports) {

let $1b030d299a081d3f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1b030d299a081d3f$var$load("60L1Q").then(()=>parcelRequire('k5qKR'));

});

parcelRegister("biFM8", function(module, exports) {

let $83a1c7dc7a401aba$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $83a1c7dc7a401aba$var$load("9gh8z").then(()=>parcelRequire('7qzbM'));

});

parcelRegister("krKp5", function(module, exports) {

let $ee2a530a51f16ba3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ee2a530a51f16ba3$var$load("icxPh").then(()=>parcelRequire('9zD1O'));

});

parcelRegister("269w2", function(module, exports) {

let $187385eb619312b0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $187385eb619312b0$var$load("1oTaS").then(()=>parcelRequire('hy8Uz'));

});

parcelRegister("JEIM5", function(module, exports) {

let $0893ca75ed0b85b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0893ca75ed0b85b1$var$load("cqvdC").then(()=>parcelRequire('eEupV'));

});

parcelRegister("hByEB", function(module, exports) {

let $cd10c5e710c15c71$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cd10c5e710c15c71$var$load("4rUkz").then(()=>parcelRequire('j5mxX'));

});

parcelRegister("bUhBn", function(module, exports) {

let $8ab294079f11e2c7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8ab294079f11e2c7$var$load("7VF4B").then(()=>parcelRequire('glZuM'));

});

parcelRegister("lgRkc", function(module, exports) {

let $f7c474c47157cfbf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f7c474c47157cfbf$var$load("3tcBd").then(()=>parcelRequire('6D8as'));

});

parcelRegister("fqI37", function(module, exports) {

let $b3bb73ff25ba54b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b3bb73ff25ba54b1$var$load("31l79").then(()=>parcelRequire('8qkRD'));

});

parcelRegister("6oC6u", function(module, exports) {

let $4a828a8f231dc155$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a828a8f231dc155$var$load("7MbjQ").then(()=>parcelRequire('ilRcA'));

});

parcelRegister("cnzYU", function(module, exports) {

let $90338b328da7cc45$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $90338b328da7cc45$var$load("iP1nm").then(()=>parcelRequire('1DMG7'));

});

parcelRegister("IzJ62", function(module, exports) {

let $085fd2afd387a590$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $085fd2afd387a590$var$load("laJkP").then(()=>parcelRequire('gSO05'));

});

parcelRegister("9Ze4j", function(module, exports) {

let $01e05591c09953c2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $01e05591c09953c2$var$load("aWTot").then(()=>parcelRequire('5P7h1'));

});

parcelRegister("6z72A", function(module, exports) {

let $4c7b79193495cfa7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4c7b79193495cfa7$var$load("kjUC9").then(()=>parcelRequire('lIMts'));

});

parcelRegister("irxYM", function(module, exports) {

let $d6d51b3327ca92cc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d6d51b3327ca92cc$var$load("fgeyW").then(()=>parcelRequire('kp3Lm'));

});

parcelRegister("OrW9M", function(module, exports) {

let $097a5755c4dcda28$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $097a5755c4dcda28$var$load("b21vI").then(()=>parcelRequire('v5Cjh'));

});

parcelRegister("8TWgT", function(module, exports) {

let $67b0a94a0514236a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $67b0a94a0514236a$var$load("hMefO").then(()=>parcelRequire('6767A'));

});

parcelRegister("h75Oa", function(module, exports) {

let $c757987ea709c1fd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c757987ea709c1fd$var$load("hKlVe").then(()=>parcelRequire('hRTcJ'));

});

parcelRegister("1MpTu", function(module, exports) {

let $14be5c20e137fdff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $14be5c20e137fdff$var$load("b9c2O").then(()=>parcelRequire('eTJBe'));

});

parcelRegister("lhybn", function(module, exports) {

let $f7e5b36c53d480d4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f7e5b36c53d480d4$var$load("2JG5z").then(()=>parcelRequire('cO1la'));

});

parcelRegister("iMfuZ", function(module, exports) {

let $dab8bb74aa80b825$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dab8bb74aa80b825$var$load("dAnlL").then(()=>parcelRequire('slsry'));

});

parcelRegister("ie2Ua", function(module, exports) {

let $d44bc9a688bbe8f5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d44bc9a688bbe8f5$var$load("9A2Qz").then(()=>parcelRequire('9mb1G'));

});

parcelRegister("aolZxO", function(module, exports) {

let $01f3d36cd0f8b736$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $01f3d36cd0f8b736$var$load("jxJ7F").then(()=>parcelRequire('finor'));

});

parcelRegister("4SSNj", function(module, exports) {

let $38e6b59a0ce8d291$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $38e6b59a0ce8d291$var$load("hgEqe").then(()=>parcelRequire('fKNbW'));

});

parcelRegister("aXc5k", function(module, exports) {

let $7f98c9e42a620c9d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7f98c9e42a620c9d$var$load("8k5hX").then(()=>parcelRequire('cRDxd'));

});

parcelRegister("hpKAi", function(module, exports) {

let $cad8e82f47d4c5a7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cad8e82f47d4c5a7$var$load("I9usf").then(()=>parcelRequire('3ON4W'));

});

parcelRegister("2QCge", function(module, exports) {

let $212e1de9c2d4d82e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $212e1de9c2d4d82e$var$load("dnzC2").then(()=>parcelRequire('kKZFe'));

});

parcelRegister("8l5Vh", function(module, exports) {
module.exports = JSON.parse("{\"post-office.fabric-editor.confluence-agent-content-suggestions.notification-drawer.shared\":[{\"type\":1,\"value\":\"agentName\"},{\"type\":0,\"value\":\" shared \"},{\"offset\":0,\"options\":{\"one\":{\"value\":[{\"type\":7},{\"type\":0,\"value\":\" suggestion\"}]},\"other\":{\"value\":[{\"type\":7},{\"type\":0,\"value\":\" suggestions\"}]}},\"pluralType\":\"cardinal\",\"type\":6,\"value\":\"count\"},{\"type\":0,\"value\":\" with you\"}],\"post-office.fabric-editor.confluence-editor-agentic-typeahead-spotlight.spotlight-body\":[{\"type\":0,\"value\":\"Mention an agent to instantly brainstorm ideas, draft content, and analyze data.\"}],\"post-office.fabric-editor.confluence-editor-agentic-typeahead-spotlight.spotlight-headline\":[{\"type\":0,\"value\":\"Your agents are ready to help\"}],\"post-office.fabric-editor.confluence-editor-agentic-typeahead-spotlight.spotlight-primary-action\":[{\"type\":0,\"value\":\"Got it\"}]}");

});

parcelRegister("2S5KU", function(module, exports) {

let $217516e0b7e47e53$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $217516e0b7e47e53$var$load("baWf1").then(()=>parcelRequire('bg8C1'));

});

parcelRegister("g4LNg", function(module, exports) {

let $bb4217e354613ca9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bb4217e354613ca9$var$load("cL29a").then(()=>parcelRequire('3ouW4'));

});

parcelRegister("exKg5", function(module, exports) {

let $a96807bc302c7711$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a96807bc302c7711$var$load("8d08B").then(()=>parcelRequire('gRWb4'));

});

parcelRegister("gaFGJ", function(module, exports) {

let $bc5deaf0bc45d12b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bc5deaf0bc45d12b$var$load("59255").then(()=>parcelRequire('dQaet'));

});

parcelRegister("6e45s", function(module, exports) {

let $4887387e5d75285b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4887387e5d75285b$var$load("QAMCX").then(()=>parcelRequire('daGt5'));

});

parcelRegister("32aVk", function(module, exports) {

let $235a083865ba038d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $235a083865ba038d$var$load("ipMBa").then(()=>parcelRequire('29cY7'));

});

parcelRegister("iiAkf", function(module, exports) {

let $d52615f242e3e6cd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d52615f242e3e6cd$var$load("4Fe0y").then(()=>parcelRequire('iloPx'));

});

parcelRegister("2kve5", function(module, exports) {

let $1b25abe6b9737386$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1b25abe6b9737386$var$load("frY3Q").then(()=>parcelRequire('heWOF'));

});

parcelRegister("avBPq", function(module, exports) {

let $7a6a248ea054858f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a6a248ea054858f$var$load("guXpK").then(()=>parcelRequire('fnieY'));

});

parcelRegister("bRMrv", function(module, exports) {

let $8a3a38a37781eb2a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8a3a38a37781eb2a$var$load("iBlah").then(()=>parcelRequire('e3AoE'));

});

parcelRegister("9OSuz", function(module, exports) {

let $72630d907bfe843b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $72630d907bfe843b$var$load("2UZrx").then(()=>parcelRequire('dcIsE'));

});

parcelRegister("6htpd", function(module, exports) {

let $492b23fe85e4a8c2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $492b23fe85e4a8c2$var$load("c9IX9").then(()=>parcelRequire('dBzQm'));

});

parcelRegister("7NeIw", function(module, exports) {

let $5ac8868a8d715ead$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5ac8868a8d715ead$var$load("fGR58").then(()=>parcelRequire('a1X57'));

});

parcelRegister("8lAlf", function(module, exports) {

let $613c79989be84219$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $613c79989be84219$var$load("kDN1X").then(()=>parcelRequire('gvihj'));

});

parcelRegister("eqRMq", function(module, exports) {

let $a81d3600938a0a28$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a81d3600938a0a28$var$load("fXmm3").then(()=>parcelRequire('5NBwN'));

});

parcelRegister("fZnKc", function(module, exports) {

let $ba3ef8a0916ae24f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ba3ef8a0916ae24f$var$load("aW1xT").then(()=>parcelRequire('gnVhL'));

});

parcelRegister("eXwQn", function(module, exports) {

let $ae400d78c90d3308$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae400d78c90d3308$var$load("juBWy").then(()=>parcelRequire('b4WDI'));

});

parcelRegister("3HgGd", function(module, exports) {

let $2b12538dfd8d9838$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2b12538dfd8d9838$var$load("71skT").then(()=>parcelRequire('2d3Ig'));

});

parcelRegister("iLuVk", function(module, exports) {

let $da949a981cf63a97$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $da949a981cf63a97$var$load("gK7PJ").then(()=>parcelRequire('diLu9'));

});

parcelRegister("4ECdt", function(module, exports) {

let $36388ad2254f57c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $36388ad2254f57c9$var$load("66YlC").then(()=>parcelRequire('iijwr'));

});

parcelRegister("l5Xon", function(module, exports) {

let $03f695342f24810f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $03f695342f24810f$var$load("jhnib").then(()=>parcelRequire('k3l7l'));

});

parcelRegister("2QxFd", function(module, exports) {

let $212a8cfff74b6afd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $212a8cfff74b6afd$var$load("5A08g").then(()=>parcelRequire('jA9aC'));

});

parcelRegister("5uSzX", function(module, exports) {

let $400a17538153b204$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $400a17538153b204$var$load("gpPIs").then(()=>parcelRequire('6e15x'));

});

parcelRegister("eUzIC", function(module, exports) {

let $adb2009ce6094cdd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $adb2009ce6094cdd$var$load("2ruUM").then(()=>parcelRequire('4P2wv'));

});

parcelRegister("4lKDT", function(module, exports) {

let $32ad4dccb97f5c8c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $32ad4dccb97f5c8c$var$load("eKpGd").then(()=>parcelRequire('2syXW'));

});

parcelRegister("78WuP", function(module, exports) {

let $5336a7e5b21a8718$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5336a7e5b21a8718$var$load("MWjax").then(()=>parcelRequire('k4rw1'));

});

parcelRegister("63SLp", function(module, exports) {

let $469d80cb434ca6b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $469d80cb434ca6b3$var$load("7m68o").then(()=>parcelRequire('8Xck8'));

});

parcelRegister("5VwrO", function(module, exports) {

let $450b720cb9a31cba$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $450b720cb9a31cba$var$load("49J53").then(()=>parcelRequire('6B0CT'));

});

parcelRegister("lSRnF", function(module, exports) {

let $fee80c69edcc8be6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fee80c69edcc8be6$var$load("fKd1v").then(()=>parcelRequire('efQU9'));

});

parcelRegister("2QwtB", function(module, exports) {

let $2129a144af6d22a2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2129a144af6d22a2$var$load("cCzJA").then(()=>parcelRequire('bpo59'));

});

parcelRegister("cTmP6", function(module, exports) {

let $962c5354218d80bf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $962c5354218d80bf$var$load("5v6nN").then(()=>parcelRequire('5XaKi'));

});

parcelRegister("9vcQi", function(module, exports) {

let $6eb0f889a42fe6ec$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6eb0f889a42fe6ec$var$load("5oeaX").then(()=>parcelRequire('1qlZk'));

});

parcelRegister("01AdQ", function(module, exports) {

let $004c31208d7d505f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $004c31208d7d505f$var$load("879MX").then(()=>parcelRequire('anzDT'));

});

parcelRegister("8bawX", function(module, exports) {

let $5f4784f6b03bcbfb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5f4784f6b03bcbfb$var$load("6SVTg").then(()=>parcelRequire('ithSW'));

});

parcelRegister("hExow", function(module, exports) {
module.exports = JSON.parse('{"growth-confluence-find.confluence-d1d6-back-to-product-email.message-template.email.icon-check-circle.alt-text":[{"type":0,"value":"Icon - Check circle"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.button-text":[{"type":0,"value":"Let\'s go"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.header":[{"type":0,"value":"Confluence is better "},{"type":1,"value":"lineBreak"},{"type":0,"value":" when the team\u2019s all in"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.main-image.alt-text":[{"type":0,"value":"Confluence cards showing tasks with assignees and different types of work"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.pre-footer-header":[{"type":0,"value":"Your team\u2019s waiting for your great ideas!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.pre-footer-subtext":[{"type":0,"value":"Jump back into Confluence and start collaborating today"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-1.description":[{"type":0,"value":"Click "},{"children":[{"type":0,"value":"Share"}],"type":8,"value":"b"},{"type":0,"value":" in Confluence to copy a link you can send in email, Slack or MS Teams"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-1.title":[{"type":0,"value":"Link content to teammates"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-2.description":[{"type":0,"value":"Give feedback on docs in progress, and @mention teammates to keep everyone in the loop"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-2.title":[{"type":0,"value":"Comment in pages"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-3.description":[{"type":0,"value":"Align on the best path forward by voting on ideas as a team in whiteboards"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-3.title":[{"type":0,"value":"Vote in whiteboards"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-header":[{"type":0,"value":"How to use Confluence "},{"type":1,"value":"lineBreak"},{"type":0,"value":" with your team:"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.subtext":[{"type":0,"value":"You\u2019re creating awesome ideas in Confluence, "},{"type":1,"value":"firstName"},{"type":0,"value":". It\u2019s "},{"type":1,"value":"lineBreak"},{"type":0,"value":" time to share them with your team!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.subject.no-first-issue-assigned":[{"type":0,"value":"\uD83D\uDC4F Your ideas deserve an audience, "},{"type":1,"value":"firstName"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.button-text":[{"type":0,"value":"Let\'s go"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.header":[{"type":0,"value":"Get your ideas"},{"type":1,"value":"lineBreak"},{"type":0,"value":"on \u201Cpaper\u201D, "},{"type":1,"value":"firstName"},{"type":0,"value":"!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.main-image.alt-text":[{"type":0,"value":"Confluence cards showing tasks with assignees and different types of work"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.pre-footer-header":[{"type":0,"value":"Ready to jump back in?"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.pre-footer-subtext":[{"type":0,"value":"Go back to Confluence today to start doing your team\u2019s best work"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-1.description":[{"type":0,"value":"Jot down & organize your ideas with sleek editor tools"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-1.title":[{"type":0,"value":"Start with a page"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-2.description":[{"type":0,"value":"@mention someone to show them what you\u2019re working on"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-2.title":[{"type":0,"value":"Brainstorm with teammates"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-3.description":[{"type":0,"value":"Connect Slack, Microsoft, or Google to keep the whole team in sync"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-3.title":[{"type":0,"value":"Connect your tools"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-header":[{"type":0,"value":"Easy ways to get setup:"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.subtext":[{"type":0,"value":"It only takes a minute to wrap up your Confluence setup. Jump back in now to start unleashing your team\u2019s knowledge."}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.subject.no-first-issue-assigned":[{"type":0,"value":"\uD83D\uDC4B Almost there\u2014need help setting up Confluence?"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.button-text":[{"type":0,"value":"Let\'s go"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.header":[{"type":0,"value":"It\u2019s time to make your space, more spacious"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.main-image.alt-text":[{"type":0,"value":"Confluence cards showing tasks with assignees and different types of work"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.pre-footer-header":[{"type":0,"value":"Create a space everyone will rave about!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.pre-footer-subtext":[{"type":0,"value":"Create, organize & share to get the team\u2019s ideas all out there"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-1.description":[{"type":0,"value":"Simply drag items around in the left-hand sidebar & click + to create something new to your space"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-1.title":[{"type":0,"value":"Drag, drop & create in context"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-2.description":[{"type":0,"value":"Add folders to create directories where everything\u2019s stored. You can even convert pages to folders in the ... menu."}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-2.title":[{"type":0,"value":"Pop it into a folder"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-3.description":[{"type":0,"value":"Create "},{"children":[{"type":0,"value":"smart links"}],"type":8,"value":"b"},{"type":0,"value":" to auto-pull content into Confluence from other tools your team already uses, like Google Docs or MS Excel"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-3.title":[{"type":0,"value":"Link from your favorite tools"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-header":[{"type":0,"value":"Tips for building out your team\u2019s space:"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.subtext":[{"type":0,"value":"Your "},{"children":[{"type":0,"value":"space"}],"type":8,"value":"b"},{"type":0,"value":" is like a hub for your team\u2019s docs & resources. "},{"type":1,"value":"lineBreak"},{"type":0,"value":"Create more and organize it all in your space today!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.icon-check-circle.alt-text":[{"type":0,"value":"Icon - Check circle"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.subject.no-first-issue-assigned":[{"type":0,"value":"\uD83E\uDD29 Impressive work you\u2019ve got there, "},{"type":1,"value":"firstName"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.button-text":[{"type":0,"value":"Let\'s go"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.header":[{"type":0,"value":"Take your team\u2019s knowledge"},{"type":1,"value":"lineBreak"},{"type":0,"value":" to the next level"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.main-image.alt-text":[{"type":0,"value":"Confluence cards showing tasks with assignees and different types of work"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.pre-footer-header":[{"type":0,"value":"Go ahead - unleash your team\u2019s knowledge!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.pre-footer-subtext":[{"type":0,"value":"Speed up teamwork by building out your knowledge hub today"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-1.description":[{"type":0,"value":"Organize work for specific teams, projects and workstreams in separate spaces to create specialized knowledge repos"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-1.title":[{"type":0,"value":"More spaces = more knowledge sources"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-2.description":[{"type":0,"value":"Rovo Search helps any team instantly find the info they need in Confluence, Slack, MS Office, and more!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-2.title":[{"type":0,"value":"Search across spaces & tools"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-3.description":[{"type":0,"value":"Need to make a page or presentation with info from multiple sources? Ask Rovo Chat to pull in knowledge from anywhere and auto-create it for you in a snap!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-3.title":[{"type":0,"value":"Just ask Rovo"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-header":[{"type":0,"value":"Try out the knowledge hub basics:"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.subtext":[{"type":0,"value":"Creating new spaces with even more Confluence content helps "},{"type":1,"value":"lineBreak"},{"type":0,"value":"unlock knowledge across every team!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.icon-check-circle.alt-text":[{"type":0,"value":"Icon - Check circle"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.subject.no-first-issue-assigned":[{"type":0,"value":"\uD83E\uDDD9 Did you know? A knowledge hub makes work easier"}],"growth-confluence-find.message-templates.confluence-notification-drawer-getting-started-nth-user.welcome-to-confluence":[{"type":0,"value":"Welcome to Confluence, "},{"type":1,"value":"name"},{"type":0,"value":"! Learn how to create your first doc."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.atlassian-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.capture-your-ideas":[{"type":0,"value":"Capture your ideas as a team in pages, whiteboards, and more today."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.capture-your-thoughts":[{"type":0,"value":"Capture your thoughts and ideas on docs and whiteboards."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.collaborate-with-your-new-teammate":[{"type":0,"value":"Collaborate with your new teammate on your next big idea today."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.confluence-is":[{"children":[{"type":0,"value":"Confluence is a collaborative workspace"}],"type":8,"value":"b"},{"type":0,"value":" where over 75,000+ customers create and organize knowledge with their team"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.create-with-a-template":[{"type":0,"value":"Create with a template"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.customer-logos.alt":[{"type":0,"value":"Customer logos including Twilio, NASA, Illumina, Docker, and Morningstar"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.forward-invite-banner":[{"type":0,"value":"\uD83D\uDC4B "},{"children":[{"type":0,"value":"Forward this email"}],"type":8,"value":"b"},{"type":0,"value":" to easily invite more teammates"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.get-started-at-lightning-speed":[{"type":0,"value":"\u26A1 Get started at lightning speed with a template"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.get-your-ideas-on-paper":[{"type":0,"value":"Get your ideas on \\"paper\\" with pages, whiteboards, and more in Confluence today."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.great-job-adding":[{"type":0,"value":"Great job adding your work to your Confluence space!"},{"children":[],"type":8,"value":"br"},{"type":0,"value":"Invite a teammate to get feedback on it today."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.great-momentum":[{"type":0,"value":"Great momentum, "},{"type":1,"value":"name"},{"type":0,"value":"! Keep it going with a template"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.great-work":[{"type":0,"value":"\uD83E\uDD29 Great work\u2014Your space deserves an audience"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.invite-teammates":[{"type":0,"value":"Invite teammates"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.invite-your-teammates":[{"type":0,"value":"Invite your teammates to collaborate and align on ideas quickly."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.jump-back-in":[{"type":0,"value":"Jump back in"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.kick-off-collaboration":[{"type":0,"value":"Kick off collaboration with your new teammate, "},{"type":1,"value":"name"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.last-edited":[{"type":0,"value":"Last edited "},{"type":1,"value":"relativeTime"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.last-edited.shortJustNow":[{"type":0,"value":"just now"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.last-edited.shortXDaysAgo":[{"type":1,"value":"timeAgo"},{"type":0,"value":"d ago"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.last-edited.shortXHoursAgo":[{"type":1,"value":"timeAgo"},{"type":0,"value":"h ago"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.last-edited.shortXMinutesAgo":[{"type":1,"value":"timeAgo"},{"type":0,"value":"m ago"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.lets-create-your-next":[{"type":0,"value":"Let\'s create your next big idea, "},{"type":1,"value":"name"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.nows-the-time":[{"type":0,"value":"\u23F0 Now\'s the time to create something great as a team"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.one-new-teammate":[{"type":0,"value":"1 new teammate joined your Confluence space. Capture your next big idea with them in pages, whiteboards, and more today."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.or-share-this-link":[{"type":0,"value":"Or share this link:"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.save-time-with":[{"type":0,"value":"Save time with these templates"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.share-your-work":[{"type":0,"value":"Share your work with the team, "},{"type":1,"value":"name"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.space":[{"type":1,"value":"spaceName"},{"type":0,"value":" space"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.start-creating-fast":[{"type":0,"value":"Start creating fast with templates recommended for your team."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.team":[{"type":0,"value":"Team"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.90-day-plan":[{"type":0,"value":"90-day plan"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.all-hands-meeting":[{"type":0,"value":"All hands meeting"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.annual-plan-one-pager":[{"type":0,"value":"Annual plan one-pager"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.aws-architecture-diagram":[{"type":0,"value":"AWS architecture diagram"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.business-plan-one-pager":[{"type":0,"value":"Business plan one-pager"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.business-status-update":[{"type":0,"value":"Business status update"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.career-development-plan":[{"type":0,"value":"Career development plan"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.competitive-analysis":[{"type":0,"value":"Competitive analysis"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.content-design-glossary":[{"type":0,"value":"Content design glossary"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.content-strategy":[{"type":0,"value":"Content strategy"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.customer-impact-assessment":[{"type":0,"value":"Customer impact assessment"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.customer-interview-report":[{"type":0,"value":"Customer interview report"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.daci-decision-documentation":[{"type":0,"value":"DACI: decision documentation"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.design-decision":[{"type":0,"value":"Design decision"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.design-review":[{"type":0,"value":"Design review"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.design-sprint":[{"type":0,"value":"Design sprint"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.design-systems":[{"type":0,"value":"Design systems"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.devops-runbook":[{"type":0,"value":"DevOps runbook"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.disruptive-brainstorming":[{"type":0,"value":"Disruptive brainstorming"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.employee-handbook":[{"type":0,"value":"Employee handbook"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.end-of-week-status-report":[{"type":0,"value":"End of week status report"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.executive-business-review":[{"type":0,"value":"Executive business review"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.hiring-process":[{"type":0,"value":"Hiring process"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.how-to-article":[{"type":0,"value":"How-to article"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.hr-knowledge-base-management":[{"type":0,"value":"HR knowledge base management"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.incident-communication":[{"type":0,"value":"Incident communication"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.incident-postmortem":[{"type":0,"value":"Incident postmortem"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.itsm-change-management":[{"type":0,"value":"ITSM change management"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.itsm-known-errors":[{"type":0,"value":"ITSM known errors"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.itsm-post-incident-reviews":[{"type":0,"value":"ITSM post incident reviews"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.itsm-runbook":[{"type":0,"value":"ITSM runbook"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.itsm-weekly-major-incident-report":[{"type":0,"value":"ITSM weekly major incident report"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.job-description":[{"type":0,"value":"Job description"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.lennys-performance-review":[{"type":0,"value":"Lenny\'s performance review"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.lennys-product-requirements":[{"type":0,"value":"Lenny\'s product requirements"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.marketing-blog-post":[{"type":0,"value":"Marketing blog post"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.marketing-campaign":[{"type":0,"value":"Marketing campaign"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.marketing-plan":[{"type":0,"value":"Marketing plan"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.meeting-notes":[{"type":0,"value":"Meeting notes"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.message-house":[{"type":0,"value":"Message house"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.mutual-action-plan":[{"type":0,"value":"Mutual action plan"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.okrs":[{"type":0,"value":"OKRs"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.persona":[{"type":0,"value":"Persona"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.presenter-mode":[{"type":0,"value":"Presenter mode"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.product-requirements":[{"type":0,"value":"Product requirements"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.product-roadmap":[{"type":0,"value":"Product roadmap"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.project-kickoff":[{"type":0,"value":"Project kickoff"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.project-plan":[{"type":0,"value":"Project plan"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.project-status":[{"type":0,"value":"Project status"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.project-timeline-template":[{"type":0,"value":"Project timeline"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.qtc-acquisition":[{"type":0,"value":"QTC acquisition"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.quarterly-check-in":[{"type":0,"value":"Quarterly check in"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.remote-team-meeting":[{"type":0,"value":"Remote team meeting"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.risk-assessment-matrix":[{"type":0,"value":"Risk assessment matrix"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.roles-and-responsibilities-play":[{"type":0,"value":"Roles and responsibilities play"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.sales-account-planning":[{"type":0,"value":"Sales account planning"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.sales-portal":[{"type":0,"value":"Sales portal"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.service-team-health-monitor":[{"type":0,"value":"Service team health monitor"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.smart-goals":[{"type":0,"value":"SMART goals"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.software-architecture-review":[{"type":0,"value":"Software architecture review"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.sprint-planning-meeting":[{"type":0,"value":"Sprint planning meeting"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.stakeholder-communications":[{"type":0,"value":"Stakeholder communications"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.standard-operating-procedure":[{"type":0,"value":"Standard operating procedure (SOP)"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.strategic-plan":[{"type":0,"value":"Strategic plan"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.swot-analysis":[{"type":0,"value":"SWOT analysis"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.team-homepage":[{"type":0,"value":"Team homepage"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.team-poster":[{"type":0,"value":"Team poster"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.to-do-list":[{"type":0,"value":"To-do list"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.troubleshooting-article":[{"type":0,"value":"Troubleshooting article"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.vendor-agreement":[{"type":0,"value":"Vendor agreement"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.virtual-event":[{"type":0,"value":"Virtual event"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.vision-to-values":[{"type":0,"value":"Vision to values"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.weekly-meeting-notes":[{"type":0,"value":"Weekly meeting notes"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.work-trip-planner":[{"type":0,"value":"Work trip planner"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.workshop-planner":[{"type":0,"value":"Workshop planner"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.writing-guidelines":[{"type":0,"value":"Writing guidelines"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.unsubscribe":[{"children":[{"type":0,"value":"Unsubscribe"}],"type":8,"value":"a"},{"type":0,"value":" to opt out of future emails like this."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.use-template":[{"type":0,"value":"Use template"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.we-recommend-starting":[{"type":0,"value":"We recommend starting with these templates for your team:"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.we-recommend-these-templates":[{"type":0,"value":"We recommend these templates for your team:"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.4ls-retro":[{"type":0,"value":"4 Ls Retro"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.action-plan":[{"type":0,"value":"Action plan"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.annual-calendar-2025-2026":[{"type":0,"value":"Annual Calendar"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.brainwriting":[{"type":0,"value":"Brainwriting"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.concept-map":[{"type":0,"value":"Concept map"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.crazy-8s":[{"type":0,"value":"Crazy 8s brainstorming"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.disruptive-brainstorm":[{"type":0,"value":"Disruptive brainstorm"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.elevator-pitch":[{"type":0,"value":"Elevator pitch"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.executive-summary":[{"type":0,"value":"Executive summary"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.fishbone-diagram":[{"type":0,"value":"Fishbone diagram"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.flow-chart":[{"type":0,"value":"Flowchart"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.focus-area-diagram":[{"type":0,"value":"Focus area diagram"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.gap-analysis":[{"type":0,"value":"Gap analysis"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.health-monitor":[{"type":0,"value":"Team health monitor"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.ice-breakers":[{"type":0,"value":"Icebreakers"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.incident-postmortem":[{"type":0,"value":"Incident postmortem"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.network-of-teams":[{"type":0,"value":"Network of teams"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.org-chart":[{"type":0,"value":"Org chart"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.prioritization":[{"type":0,"value":"Prioritization matrix"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.product-roadmap":[{"type":0,"value":"Product roadmap"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.product-vision-board":[{"type":0,"value":"Product vision board"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.root-cause-analysis":[{"type":0,"value":"Root cause analysis"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.service-blueprint":[{"type":0,"value":"Service blueprint"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.simple-retrospective":[{"type":0,"value":"Simple retrospective"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.stakeholder-mapping":[{"type":0,"value":"Stakeholder mapping"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.swimlanes":[{"type":0,"value":"Swimlanes process map"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.swot-analysis":[{"type":0,"value":"SWOT Analysis"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.team-formation-guide":[{"type":0,"value":"Team charter template"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.timeline-workflow":[{"type":0,"value":"Timeline workflow"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.user-story-map":[{"type":0,"value":"User story map"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.workflow":[{"type":0,"value":"Workflow"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.youre-off-to-a-great-start":[{"type":0,"value":"\uD83D\uDE80 You\'re off to a great start\u2014Let\'s start creating"}],"post-office.growth-confluence-find.connect-tools-spotlight.body":[{"type":0,"value":"Connect your team\'s most used apps to get better answers and more results across Search and Chat."}],"post-office.growth-confluence-find.connect-tools-spotlight.headline":[{"type":0,"value":"Search across tools"}],"post-office.growth-confluence-find.connect-tools-spotlight.primary-action":[{"type":0,"value":"Setup"}],"post-office.growth-confluence-find.flag-to-share.copied":[{"type":0,"value":"Copied!"}],"post-office.growth-confluence-find.flag-to-share.copy-link":[{"type":0,"value":"Copy link"}],"post-office.growth-confluence-find.flag-to-share.first.database.description":[{"type":0,"value":"Add your teammates so you can collaborate and stay in sync."}],"post-office.growth-confluence-find.flag-to-share.first.database.primary-action":[{"type":0,"value":"Share database"}],"post-office.growth-confluence-find.flag-to-share.first.database.title":[{"type":0,"value":"You\'ve created your first database"}],"post-office.growth-confluence-find.flag-to-share.first.live-doc.description":[{"type":0,"value":"Add your teammates so you can collaborate and stay in sync."}],"post-office.growth-confluence-find.flag-to-share.first.live-doc.primary-action":[{"type":0,"value":"Share doc"}],"post-office.growth-confluence-find.flag-to-share.first.live-doc.title":[{"type":0,"value":"You\'ve created your first live doc"}],"post-office.growth-confluence-find.flag-to-share.first.whiteboard.description":[{"type":0,"value":"Add your teammates so you can collaborate together in real time."}],"post-office.growth-confluence-find.flag-to-share.first.whiteboard.primary-action":[{"type":0,"value":"Share whiteboard"}],"post-office.growth-confluence-find.flag-to-share.first.whiteboard.title":[{"type":0,"value":"You\'ve created your first whiteboard"}],"post-office.growth-confluence-find.flag-to-share.second.land.database.description":[{"type":0,"value":"Share this database with your teammates, so everyone can contribute and stay in sync."}],"post-office.growth-confluence-find.flag-to-share.second.land.live-doc.description":[{"type":0,"value":"Share this doc with your teammates, so everyone has the same context."}],"post-office.growth-confluence-find.flag-to-share.second.land.whiteboard.description":[{"type":0,"value":"Share this whiteboard with your teammates, so you can brainstorm together in real time."}],"post-office.growth-confluence-find.flag-to-share.second.primary-action":[{"type":0,"value":"Share"}],"post-office.growth-confluence-find.flag-to-share.second.title":[{"type":0,"value":"Collaborate with your team"}],"post-office.growth-confluence-find.flag-to-share.second.xflow.database.description":[{"type":0,"value":"Share this database with your Jira team, so they can contribute and stay in sync."}],"post-office.growth-confluence-find.flag-to-share.second.xflow.live-doc.description":[{"type":0,"value":"Share this doc with your Jira teammates, so everyone has the same project info."}],"post-office.growth-confluence-find.flag-to-share.second.xflow.whiteboard.description":[{"type":0,"value":"Share this whiteboard with your Jira team, so you can brainstorm together in real time."}],"post-office.growth-confluence-find.invite-reminder-flag.description":[{"type":0,"value":"Don\'t miss out on project updates and decisions from your teammates"}],"post-office.growth-confluence-find.invite-reminder-flag.primary-action":[{"type":0,"value":"Join your team"}],"post-office.growth-confluence-find.invite-reminder-flag.title-team-invited":[{"type":0,"value":"Your team invited you to Confluence"}],"post-office.growth-confluence-find.invite-reminder-flag.title-user-invited":[{"type":1,"value":"adminName"},{"type":0,"value":" invited you to Confluence"}]}');

});

parcelRegister("7TLih", function(module, exports) {

let $5c025b0bbd992113$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5c025b0bbd992113$var$load("kUReN").then(()=>parcelRequire('2FHx4'));

});

parcelRegister("7mTau", function(module, exports) {

let $55d561b966c24d89$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $55d561b966c24d89$var$load("eMF3x").then(()=>parcelRequire('7ILCN'));

});

parcelRegister("aQ5Te", function(module, exports) {

let $7e43544c3d2d8e1b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7e43544c3d2d8e1b$var$load("iv98M").then(()=>parcelRequire('4Ukan'));

});

parcelRegister("3mJ4S", function(module, exports) {

let $273664acf2a35328$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $273664acf2a35328$var$load("8SFsg").then(()=>parcelRequire('hcy9K'));

});

parcelRegister("ehEnr", function(module, exports) {

let $a661f93ed06af945$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a661f93ed06af945$var$load("j71Pg").then(()=>parcelRequire('kdyiW'));

});

parcelRegister("bhKPe", function(module, exports) {

let $83759ac2ec41eca1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $83759ac2ec41eca1$var$load("jMxQ4").then(()=>parcelRequire('8kErv'));

});

parcelRegister("8aPOA", function(module, exports) {

let $5f377342f17c9de4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5f377342f17c9de4$var$load("hEDAR").then(()=>parcelRequire('h9KoL'));

});

parcelRegister("5c04W", function(module, exports) {

let $3c7e2263226b27a9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3c7e2263226b27a9$var$load("8VZD6").then(()=>parcelRequire('6f7Pr'));

});

parcelRegister("iElhp", function(module, exports) {

let $d93c7827edd49df5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d93c7827edd49df5$var$load("aD1tR").then(()=>parcelRequire('eCKK0'));

});

parcelRegister("2MSuk", function(module, exports) {

let $207a54a7d7fe00dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $207a54a7d7fe00dd$var$load("gH5IN").then(()=>parcelRequire('jbvFg'));

});

parcelRegister("gyU53", function(module, exports) {

let $c0eb52be32e9c243$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c0eb52be32e9c243$var$load("8ykXg").then(()=>parcelRequire('diFy4'));

});

parcelRegister("hUMS7", function(module, exports) {

let $d0ad9396062add77$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d0ad9396062add77$var$load("6k2Mx").then(()=>parcelRequire('EMrLW'));

});

parcelRegister("eCwrg", function(module, exports) {

let $aa4dc6f61252a1ba$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aa4dc6f61252a1ba$var$load("7Yi8H").then(()=>parcelRequire('3VKkk'));

});

parcelRegister("2vIBs", function(module, exports) {

let $1d41134510778054$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1d41134510778054$var$load("6z8cX").then(()=>parcelRequire('eB5yM'));

});

parcelRegister("ipMGk", function(module, exports) {

let $d68052fbb23903ed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d68052fbb23903ed$var$load("fxpHG").then(()=>parcelRequire('3R04o'));

});

parcelRegister("gre8P", function(module, exports) {

let $bf7a23258a581beb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bf7a23258a581beb$var$load("c5NNO").then(()=>parcelRequire('fq0jP'));

});

parcelRegister("ahKBm", function(module, exports) {

let $77cfa409d5db0163$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $77cfa409d5db0163$var$load("ellam").then(()=>parcelRequire('1WyD0'));

});

parcelRegister("lpVTB", function(module, exports) {

let $f978d7a71402f5c6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f978d7a71402f5c6$var$load("16C0F").then(()=>parcelRequire('5WonM'));

});

parcelRegister("bNzyH", function(module, exports) {

let $896fda86ed27d4f2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $896fda86ed27d4f2$var$load("eJ5SG").then(()=>parcelRequire('2dsSH'));

});

parcelRegister("9TBwA", function(module, exports) {

let $73465bb93592b71e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $73465bb93592b71e$var$load("6pDZc").then(()=>parcelRequire('h3zUr'));

});

parcelRegister("6Uq1z", function(module, exports) {

let $507c28ea788735cf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $507c28ea788735cf$var$load("gQsKk").then(()=>parcelRequire('hjDgk'));

});

parcelRegister("krNGI", function(module, exports) {

let $ee2cdf45cbd44a26$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ee2cdf45cbd44a26$var$load("5jRki").then(()=>parcelRequire('8fqnr'));

});

parcelRegister("eRkHK", function(module, exports) {

let $ad1613737902a6eb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ad1613737902a6eb$var$load("jUEOF").then(()=>parcelRequire('eLJSK'));

});

parcelRegister("9X0Cq", function(module, exports) {

let $73ea1aa273c9d3e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $73ea1aa273c9d3e1$var$load("l3a5T").then(()=>parcelRequire('f6vAO'));

});

parcelRegister("kgvwa", function(module, exports) {

let $ec0dc008227a4f73$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ec0dc008227a4f73$var$load("4oMoL").then(()=>parcelRequire('bt3Vm'));

});

parcelRegister("6l3j3", function(module, exports) {

let $49d744cae09efa74$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $49d744cae09efa74$var$load("gpmPo").then(()=>parcelRequire('azrW4'));

});

parcelRegister("h0a3n", function(module, exports) {

let $c60a3c2c116d5023$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c60a3c2c116d5023$var$load("05bp2").then(()=>parcelRequire('7kvZY'));

});

parcelRegister("3Mq6j", function(module, exports) {

let $2c0a19e17eea1550$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2c0a19e17eea1550$var$load("hVbzv").then(()=>parcelRequire('jMjFS'));

});

parcelRegister("71Rjt", function(module, exports) {

let $51e1fb4774a648f4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $51e1fb4774a648f4$var$load("9ze1k").then(()=>parcelRequire('l86OZ'));

});

parcelRegister("cTrN7", function(module, exports) {

let $96302ddaa069266f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $96302ddaa069266f$var$load("4Yw33").then(()=>parcelRequire('hLcf2'));

});

parcelRegister("aUto0", function(module, exports) {

let $7f15edd3ee94a533$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7f15edd3ee94a533$var$load("UJ9mk").then(()=>parcelRequire('6fEu9'));

});

parcelRegister("jcOzM", function(module, exports) {

let $dfb65ea73430197d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dfb65ea73430197d$var$load("hNDlV").then(()=>parcelRequire('fHpzH'));

});

parcelRegister("f9Xq7", function(module, exports) {

let $b095c9e23b783c76$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b095c9e23b783c76$var$load("jgg9p").then(()=>parcelRequire('1F9S0'));

});

parcelRegister("e0QjB", function(module, exports) {

let $a339a57ddd3344e7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a339a57ddd3344e7$var$load("6F1vf").then(()=>parcelRequire('U0Rbi'));

});

parcelRegister("9RDCk", function(module, exports) {
module.exports = JSON.parse("{\"cc-performance-enablement.confluence-performance-diagnstic-survey.description.no-translate\":[{\"type\":0,\"value\":\"Atlassians: got one minute to help make Confluence faster? Five quick questions about your current experience using Confluence on Hello.\"}],\"cc-performance-enablement.confluence-performance-diagnstic-survey.title.no-translate\":[{\"type\":0,\"value\":\"Confluence performance survey\"}]}");

});

parcelRegister("lupz6", function(module, exports) {

let $fa503b0443382064$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fa503b0443382064$var$load("7d07Z").then(()=>parcelRequire('eD0OE'));

});

parcelRegister("7XJiU", function(module, exports) {

let $5cc12f80172f577d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5cc12f80172f577d$var$load("cl0OV").then(()=>parcelRequire('coQbI'));

});

parcelRegister("9j5hY", function(module, exports) {

let $6c69fda9d8996943$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6c69fda9d8996943$var$load("E7cKS").then(()=>parcelRequire('6FojU'));

});

parcelRegister("6ylJH", function(module, exports) {

let $4c56c75e44991494$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4c56c75e44991494$var$load("hoalb").then(()=>parcelRequire('7QZgS'));

});

parcelRegister("8ue0N", function(module, exports) {

let $62dbfe81d6c9d1f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $62dbfe81d6c9d1f1$var$load("6thhm").then(()=>parcelRequire('8Sq6j'));

});

parcelRegister("6p26I", function(module, exports) {

let $4a96b65bd8e01837$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a96b65bd8e01837$var$load("5IbvV").then(()=>parcelRequire('er37V'));

});

parcelRegister("1zirR", function(module, exports) {

let $12475ec9953aca57$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $12475ec9953aca57$var$load("29cFY").then(()=>parcelRequire('CldXB'));

});

parcelRegister("htPBS", function(module, exports) {

let $cb9d2dbdce3ce652$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cb9d2dbdce3ce652$var$load("6siu6").then(()=>parcelRequire('1Uadq'));

});

parcelRegister("4lKRE", function(module, exports) {

let $32ad79d9af3af715$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $32ad79d9af3af715$var$load("c1ScT").then(()=>parcelRequire('iZo6Y'));

});

parcelRegister("gRWyk", function(module, exports) {

let $c47f03ea47f71db8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c47f03ea47f71db8$var$load("b2qiy").then(()=>parcelRequire('02gLn'));

});

parcelRegister("aWiRr", function(module, exports) {

let $7f6df388ca09164f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7f6df388ca09164f$var$load("90WS6").then(()=>parcelRequire('2AFRD'));

});

parcelRegister("53Kck", function(module, exports) {

let $3af1117d7e701e80$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3af1117d7e701e80$var$load("aVBEd").then(()=>parcelRequire('2LiHe'));

});

parcelRegister("8hHOm", function(module, exports) {

let $6081e5464ae9d84a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6081e5464ae9d84a$var$load("ZnDct").then(()=>parcelRequire('cFCwW'));

});

parcelRegister("bVckf", function(module, exports) {

let $8ade9428a3ec8bd3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8ade9428a3ec8bd3$var$load("d9zHV").then(()=>parcelRequire('jTpZK'));

});

parcelRegister("h6uCG", function(module, exports) {

let $c73ac043cc550716$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c73ac043cc550716$var$load("aw4g1").then(()=>parcelRequire('79VEy'));

});

parcelRegister("eRZcr", function(module, exports) {

let $ad357ce3c87b548c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ad357ce3c87b548c$var$load("e4L1t").then(()=>parcelRequire('l6vBr'));

});

parcelRegister("7PDrO", function(module, exports) {

let $5b3be54a2c2bde50$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5b3be54a2c2bde50$var$load("hbbZ6").then(()=>parcelRequire('8FnAl'));

});

parcelRegister("i7KWJ", function(module, exports) {

let $d31d4c00dc59e6b5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d31d4c00dc59e6b5$var$load("blKel").then(()=>parcelRequire('csjtj'));

});

parcelRegister("9A01X", function(module, exports) {

let $6f977ff0de245299$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6f977ff0de245299$var$load("7NbNi").then(()=>parcelRequire('5vcEB'));

});

parcelRegister("6vNhc", function(module, exports) {

let $4bdbdc9be27abeb9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4bdbdc9be27abeb9$var$load("kPPky").then(()=>parcelRequire('iUKxx'));

});

parcelRegister("b7AO3", function(module, exports) {

let $0216eaeff050a9d7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0216eaeff050a9d7$var$load("2Oo8E").then(()=>parcelRequire('4DBal'));

});

parcelRegister("18xT8", function(module, exports) {

let $0d40d34b32c8ef8c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0d40d34b32c8ef8c$var$load("4x4jh").then(()=>parcelRequire('7fm4Z'));

});

parcelRegister("dXfvT", function(module, exports) {

let $a28cd1aa9b15d3c0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a28cd1aa9b15d3c0$var$load("9p01G").then(()=>parcelRequire('apn22'));

});

parcelRegister("cw89E", function(module, exports) {

let $91cecc8c59809bc1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $91cecc8c59809bc1$var$load("15alC").then(()=>parcelRequire('dXE5M'));

});

parcelRegister("amZIT", function(module, exports) {

let $78cbd665693b8523$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $78cbd665693b8523$var$load("lw5Qp").then(()=>parcelRequire('bW6vt'));

});

parcelRegister("jAmh8", function(module, exports) {

let $e422a8876509c3d4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e422a8876509c3d4$var$load("8bZMt").then(()=>parcelRequire('72wZ1'));

});

parcelRegister("7q4Iv", function(module, exports) {

let $566e9eccd1f76a6b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $566e9eccd1f76a6b$var$load("7Lxgl").then(()=>parcelRequire('a37i2'));

});

parcelRegister("dk9wT", function(module, exports) {

let $9b3488ffff9f626f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9b3488ffff9f626f$var$load("02Vht").then(()=>parcelRequire('17YSJ'));

});

parcelRegister("iVH0Y", function(module, exports) {

let $dc7eeab3f48b7166$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dc7eeab3f48b7166$var$load("1PC1f").then(()=>parcelRequire('4kiqx'));

});

parcelRegister("5QhtO", function(module, exports) {

let $440f5e368f6db21a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $440f5e368f6db21a$var$load("eattu").then(()=>parcelRequire('720SO'));

});

parcelRegister("f1A3H", function(module, exports) {

let $af02eb7f8e18c6ea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $af02eb7f8e18c6ea$var$load("gpMmg").then(()=>parcelRequire('39Uv9'));

});

parcelRegister("4frRm", function(module, exports) {

let $317e2c7a8747aa44$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $317e2c7a8747aa44$var$load("eURm0").then(()=>parcelRequire('j61Xq'));

});

parcelRegister("2ac9b", function(module, exports) {

let $1935f0178819890a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1935f0178819890a$var$load("f6WYE").then(()=>parcelRequire('ajldk'));

});

parcelRegister("h8OJ6", function(module, exports) {

let $c7aa8842ac632b72$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c7aa8842ac632b72$var$load("2tPvI").then(()=>parcelRequire('3M1n7'));

});

parcelRegister("b9HG5", function(module, exports) {
module.exports = JSON.parse("{\"cpq.cpq-user-feedback.question.no-translate\":[{\"type\":0,\"value\":\"What is your feedback?\"}],\"cpq.cpq-user-feedback.statement.no-translate\":[{\"type\":0,\"value\":\"What is your feedback?\"}]}");

});

parcelRegister("cG81y", function(module, exports) {

let $0261ccee405291d4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0261ccee405291d4$var$load("7OEli").then(()=>parcelRequire('5XgFD'));

});

parcelRegister("2NyU9", function(module, exports) {

let $209b3bbb8376b90a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $209b3bbb8376b90a$var$load("2KfwO").then(()=>parcelRequire('ajT1B'));

});

parcelRegister("ietP8", function(module, exports) {

let $d460ab2dbc1d7fbf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d460ab2dbc1d7fbf$var$load("g8Cbp").then(()=>parcelRequire('gFnm0'));

});

parcelRegister("1eovA", function(module, exports) {

let $0e5a1c1db1a83ede$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0e5a1c1db1a83ede$var$load("7uhdl").then(()=>parcelRequire('04yKK'));

});

parcelRegister("5k7oO", function(module, exports) {

let $3e048f51072b5747$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3e048f51072b5747$var$load("80wi9").then(()=>parcelRequire('hAVOk'));

});

parcelRegister("88KU9", function(module, exports) {

let $5ed3745fa6fe4b2a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5ed3745fa6fe4b2a$var$load("lzOwV").then(()=>parcelRequire('dT28m'));

});

parcelRegister("etvON", function(module, exports) {

let $a89c7495bf355dab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a89c7495bf355dab$var$load("4vmcC").then(()=>parcelRequire('dNRsB'));

});

parcelRegister("9kCgZ", function(module, exports) {

let $6cb3ab89a6c4e5b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6cb3ab89a6c4e5b3$var$load("dWu2v").then(()=>parcelRequire('kK3nH'));

});

parcelRegister("kxQKy", function(module, exports) {

let $ef4fceb8cbee4453$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ef4fceb8cbee4453$var$load("cCX2j").then(()=>parcelRequire('4n0zW'));

});

parcelRegister("fqcA7", function(module, exports) {

let $b3a30b232604c959$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b3a30b232604c959$var$load("j33tP").then(()=>parcelRequire('hoEr3'));

});

parcelRegister("1k6j7", function(module, exports) {

let $0f6c8d3aa3f335b2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0f6c8d3aa3f335b2$var$load("fyYQF").then(()=>parcelRequire('32Edz'));

});

parcelRegister("8rJtX", function(module, exports) {

let $6264202a4e92fc30$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6264202a4e92fc30$var$load("c937Z").then(()=>parcelRequire('38oce'));

});

parcelRegister("37RbN", function(module, exports) {

let $246b48d8a11a9a39$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $246b48d8a11a9a39$var$load("hZDjH").then(()=>parcelRequire('8EP4c'));

});

parcelRegister("bCAVJ", function(module, exports) {

let $875fe3dc38fb333a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $875fe3dc38fb333a$var$load("6yhsL").then(()=>parcelRequire('fqL9o'));

});

parcelRegister("d3t0X", function(module, exports) {

let $98120fd5d300f07e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $98120fd5d300f07e$var$load("keBqf").then(()=>parcelRequire('bmVXy'));

});

parcelRegister("bMGI1", function(module, exports) {

let $89454e8279762075$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $89454e8279762075$var$load("ksM6Y").then(()=>parcelRequire('hsq8h'));

});

parcelRegister("8hbyi", function(module, exports) {

let $6068df47d4016d91$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6068df47d4016d91$var$load("hfEI5").then(()=>parcelRequire('5sVbI'));

});

parcelRegister("d1DSE", function(module, exports) {

let $97ba4dd056b383a3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $97ba4dd056b383a3$var$load("i6JM4").then(()=>parcelRequire('dD34N'));

});

parcelRegister("iugLC", function(module, exports) {

let $d75808eefc14dc03$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d75808eefc14dc03$var$load("23PTT").then(()=>parcelRequire('atjK4'));

});

parcelRegister("hAZGJ", function(module, exports) {

let $ccf5a67403e50e89$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ccf5a67403e50e89$var$load("lTJDt").then(()=>parcelRequire('h5Ykw'));

});

parcelRegister("6gViH", function(module, exports) {

let $4910af658e815ecc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4910af658e815ecc$var$load("1Pk0z").then(()=>parcelRequire('bDxYF'));

});

parcelRegister("69cDb", function(module, exports) {

let $479d619c7eb97df8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $479d619c7eb97df8$var$load("lcQmz").then(()=>parcelRequire('jsozp'));

});

parcelRegister("4myJI", function(module, exports) {

let $32d4296bf01dde71$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $32d4296bf01dde71$var$load("2eOkY").then(()=>parcelRequire('1GPOE'));

});

parcelRegister("9cxEo", function(module, exports) {

let $6b2f565334413c58$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b2f565334413c58$var$load("kmcTd").then(()=>parcelRequire('aVIPp'));

});

parcelRegister("kalAm", function(module, exports) {

let $eae57c3fe3dd6b26$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eae57c3fe3dd6b26$var$load("iQeyY").then(()=>parcelRequire('cCaxa'));

});

parcelRegister("7Fzov", function(module, exports) {

let $5957d14fd66384a6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5957d14fd66384a6$var$load("aNWiG").then(()=>parcelRequire('8aTnT'));

});

parcelRegister("8OFrP", function(module, exports) {

let $66b324e703317985$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $66b324e703317985$var$load("TwJAa").then(()=>parcelRequire('dDG6f'));

});

parcelRegister("5gsuk", function(module, exports) {

let $3d548b81e64f9b5a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3d548b81e64f9b5a$var$load("3K4dQ").then(()=>parcelRequire('81bUc'));

});

parcelRegister("5U4bf", function(module, exports) {

let $44c56cd5f8fbcf77$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $44c56cd5f8fbcf77$var$load("1MAF8").then(()=>parcelRequire('54X8R'));

});

parcelRegister("44BT5", function(module, exports) {

let $2f74eccac25c9e04$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2f74eccac25c9e04$var$load("90ONN").then(()=>parcelRequire('9seif'));

});

parcelRegister("4MR8N", function(module, exports) {

let $37c4ddc39bd740dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $37c4ddc39bd740dd$var$load("5LXJQ").then(()=>parcelRequire('5JDZ8'));

});

parcelRegister("6fdO5", function(module, exports) {

let $48beda8bf84933f2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $48beda8bf84933f2$var$load("2ZV6d").then(()=>parcelRequire('hSyVS'));

});

parcelRegister("86TRc", function(module, exports) {

let $5e7a364d35f603c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5e7a364d35f603c9$var$load("1M5tg").then(()=>parcelRequire('en58w'));

});

parcelRegister("lKnw1", function(module, exports) {

let $fd502289a7823dc1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fd502289a7823dc1$var$load("3HAaW").then(()=>parcelRequire('6zWKz'));

});

parcelRegister("iwQJq", function(module, exports) {
module.exports = JSON.parse('{"cross-flow-jpd-notify-continue-set-up.notification.primary.action":[{"type":0,"value":"Finish setup"}],"cross-flow-jpd-notify-continue-set-up.notification.secondary.action":[{"type":0,"value":"Start a new project"}],"cross-flow-jpd-notify-continue-set-up.notification.title":[{"type":0,"value":"Finish setting up "},{"type":1,"value":"templateName"}],"cross-flow-jsm-notify-continue-set-up.notification.body":[{"type":0,"value":"85% of users find that using Jira with Jira Service Management makes it easier to coordinate and resolve requests."}],"cross-flow-jsm-notify-continue-set-up.notification.generic.title":[{"type":0,"value":"Finish setting up "},{"type":1,"value":"templateName"}],"cross-flow-jsm-notify-continue-set-up.notification.primary.action":[{"type":0,"value":"Finish setup"}],"cross-flow-jsm-notify-continue-set-up.notification.secondary.action":[{"type":0,"value":"Start a new project"}],"cross-flow-jsm-notify-continue-set-up.notification.specific.title":[{"type":0,"value":"Finish setting up your "},{"type":1,"value":"templateName"},{"type":0,"value":" project"}],"cross-flow-product-notification-added-new-product.message.jira.product.discovery.body":[{"type":0,"value":"Jira Product Discovery has been added to your site. Use it to capture, prioritize, and roadmap ideas."}],"cross-flow-product-notification-added-new-product.message.jira.servicedesk.ondemand.body":[{"type":0,"value":"Jira Service Management has been added to your site. Use it to receive, track, and manage requests."}],"cross-flow-product-notification-added-new-product.message.path.link.label":[{"type":0,"value":"Atlassian Administration"}],"cross-flow-product-notification-added-new-product.message.title":[{"type":1,"value":"actorName"},{"type":0,"value":" added "},{"type":1,"value":"productName"}],"cross-flow-product-notification-added-new-product.request.primary.action.label":[{"type":0,"value":"View project"}],"cross-flow-product-notification-added-new-product.request.secondary.action.label":[{"type":0,"value":"Learn more"}],"cross-flow-product-request-approval.message.title":[{"type":0,"value":"Your request to try "},{"type":1,"value":"product_name"},{"type":0,"value":" has been approved!"}],"cross-flow-product-request-reminder.message.com.atlassian.service.collection.body":[{"type":0,"value":"Service Collection helps your teams deliver exceptional service experiences for employees and customers through a single platform."}],"cross-flow-product-request-reminder.message.confluence.ondemand.body":[{"type":0,"value":"Confluence is a single place for all documentation and it seamlessly links to Jira. It\u2019s free to try and cancel anytime."}],"cross-flow-product-request-reminder.message.jira.product.discovery.body":[{"type":0,"value":"Jira Product Discovery is a roadmap and prioritization tool that links to your business or software projects."}],"cross-flow-product-request-reminder.message.jira.servicedesk.ondemand.body":[{"type":0,"value":"Jira Service Management links to your business or software projects to receive and manage requests."}],"cross-flow-product-request-reminder.message.path.link.label":[{"type":0,"value":"Atlassian Administration"}],"cross-flow-product-request-reminder.message.title":[{"type":0,"value":"Action required: "},{"type":1,"value":"requestor_name"},{"type":0,"value":" is waiting for your approval to try "},{"type":1,"value":"product_name"}],"cross-flow-product-request-reminder.message.title.doublerequestors":[{"type":0,"value":"Action required: "},{"type":1,"value":"requestor_name"},{"type":0,"value":" and "},{"type":1,"value":"previous_requestor_name"},{"type":0,"value":" are waiting for your approval to try "},{"type":1,"value":"product_name"}],"cross-flow-product-request-reminder.message.title.multirequestors":[{"type":0,"value":"Action required: "},{"type":1,"value":"requestor_name"},{"type":0,"value":" and "},{"type":1,"value":"previous_requestor_count"},{"type":0,"value":" others are waiting for your approval to try "},{"type":1,"value":"product_name"}],"cross-flow-product-request-reminder.request.primary.action.label":[{"type":0,"value":"Start free"}],"cross-flow-product-request-reminder.request.secondary.action.label":[{"type":0,"value":"Learn more"}],"cross-flow-product-request.message.path.link.label":[{"type":0,"value":"Atlassian Administration"}],"cross-flow-product-request.message.title":[{"type":0,"value":"Approve app request from "},{"type":1,"value":"actorName"}],"cross-flow-product-request.request.primary.action.label":[{"type":0,"value":"Start free"}],"cross-flow-product-request.request.primary.action.review.label":[{"type":0,"value":"Review request"}],"cross-flow-product-request.request.secondary.action.label":[{"type":0,"value":"Learn more"}],"cross-flow-product-store-recommendations.confluence.body":[{"type":0,"value":"Create consistency with award-winning page templates."}],"cross-flow-product-store-recommendations.confluence.title":[{"type":0,"value":"Content creation"}],"cross-flow-product-store-recommendations.jira.body":[{"type":0,"value":"Visualize work with custom workflow, lists, boards, backlogs, and more."}],"cross-flow-product-store-recommendations.jira.title":[{"type":0,"value":"Plan and track work"}],"cross-flow-product-store-recommendations.jpd.product-discovery.body":[{"type":0,"value":"Prioritize ideas then connect them from discovery through to delivery."}],"cross-flow-product-store-recommendations.jpd.product-discovery.title":[{"type":0,"value":"Product discovery"}],"cross-flow-product-store-recommendations.jpd.product-roadmap.body":[{"type":0,"value":"Create custom roadmaps and share your plans with anyone."}],"cross-flow-product-store-recommendations.jpd.product-roadmap.title":[{"type":0,"value":"Product roadmap"}],"cross-flow-product-store-recommendations.jsm.analytics-service-management.body":[{"type":0,"value":"Help employees access and request the data and analytics they need."}],"cross-flow-product-store-recommendations.jsm.analytics-service-management.title":[{"type":0,"value":"Analytics service management"}],"cross-flow-product-store-recommendations.jsm.customer-service-management.body":[{"type":0,"value":"Help your customers easily raise requests, report problems, and get support."}],"cross-flow-product-store-recommendations.jsm.customer-service-management.title":[{"type":0,"value":"Customer service management"}],"cross-flow-product-store-recommendations.jsm.design-service-management.body":[{"type":0,"value":"Manage employee requests for designs, reviews, and any other request."}],"cross-flow-product-store-recommendations.jsm.design-service-management.title":[{"type":0,"value":"Design service management"}],"cross-flow-product-store-recommendations.jsm.facilities-service-management.body":[{"type":0,"value":"Easily manage requests for maintenance, moving, and event planning."}],"cross-flow-product-store-recommendations.jsm.facilities-service-management.title":[{"type":0,"value":"Facilities service management"}],"cross-flow-product-store-recommendations.jsm.finance-service-management.body":[{"type":0,"value":"Easily manage and track budget, spend, and any other finance request."}],"cross-flow-product-store-recommendations.jsm.finance-service-management.title":[{"type":0,"value":"Finance service management"}],"cross-flow-product-store-recommendations.jsm.general-service-management.body":[{"type":0,"value":"Create one place to collect and manage any type of request."}],"cross-flow-product-store-recommendations.jsm.general-service-management.title":[{"type":0,"value":"General service management"}],"cross-flow-product-store-recommendations.jsm.hr-service-management.body":[{"type":0,"value":"Simplify onboarding, off-boarding, and any other HR request."}],"cross-flow-product-store-recommendations.jsm.hr-service-management.title":[{"type":0,"value":"HR service management"}],"cross-flow-product-store-recommendations.jsm.it-service-management.body":[{"type":0,"value":"Quickly respond to requests, resolve incidents, and deploy changes."}],"cross-flow-product-store-recommendations.jsm.it-service-management.title":[{"type":0,"value":"IT service management"}],"cross-flow-product-store-recommendations.jsm.legal-service-management.body":[{"type":0,"value":"Easily manage requests about contracts, policies, and more."}],"cross-flow-product-store-recommendations.jsm.legal-service-management.title":[{"type":0,"value":"Legal service management"}],"cross-flow-product-store-recommendations.jsm.marketing-service-management.body":[{"type":0,"value":"Manage employee requests for assets, reviews, and any other marketing request."}],"cross-flow-product-store-recommendations.jsm.marketing-service-management.title":[{"type":0,"value":"Marketing service management"}],"cross-flow-product-store-recommendations.jsm.sales-service-management.body":[{"type":0,"value":"Easily manage requests for quote support, contract reviews, and more."}],"cross-flow-product-store-recommendations.jsm.sales-service-management.title":[{"type":0,"value":"Sales service management"}],"cross-flow.components.product-store-template-card.template-image-alt-text":[{"type":0,"value":"A document titled quarterly planning. The document has details like mission, scope and a monthly plan."}],"cross-flow.components.product-store-template-card.template-try-cta-button-text":[{"type":0,"value":"Try template"}],"cross-flow.cross-flow-product-request-approval.action":[{"type":0,"value":"Go to Jira Product Discovery"}],"cross-flow.cross-flow-product-request-approval.description":[{"type":0,"value":"Prioritize ideas, build living roadmaps, and connect to delivery in Jira."}],"cross-flow.cross-flow-product-request-approval.title":[{"type":0,"value":"Your access to Jira Product Discovery has been approved"}],"cross-flow.cross-flow-product-request.screen-space-flags.action.get-started":[{"type":0,"value":"Get started"}],"cross-flow.cross-flow-product-request.screen-space-flags.action.remind-me-later":[{"type":0,"value":"Remind me later"}],"cross-flow.cross-flow-product-request.screen-space-flags.action.review-request":[{"type":0,"value":"Review request"}],"cross-flow.cross-flow-product-request.screen-space-flags.description":[{"type":1,"value":"requesterName"},{"type":0,"value":" sent a request to try "},{"type":1,"value":"productName"},{"type":0,"value":". It\'s free to try. Cancel any time."}],"cross-flow.cross-flow-product-request.screen-space-flags.title":[{"type":0,"value":"Approve a request to try "},{"type":1,"value":"productName"}],"cross-flow.xflow-notification-end-user-added-loom.message-template.email.subject":[{"type":0,"value":"\uD83C\uDF89 "},{"type":1,"value":"name"},{"type":0,"value":" has started using Loom"}],"cross-flow.xflow-notification-end-user-added-loom.message.email.admin-url.no-translate":[{"type":0,"value":"admin.atlassian.com"}],"cross-flow.xflow-notification-end-user-added-loom.message.email.footer.icon.alt":[{"type":0,"value":"Atlassian Logo"}],"cross-flow.xflow-notification-end-user-added-loom.message.email.get-started.button":[{"type":0,"value":"Get started"}],"cross-flow.xflow-notification-end-user-added-loom.message.email.header.icon.alt":[{"type":0,"value":"Loom Logo"}],"cross-flow.xflow-notification-end-user-added-loom.message.email.headline":[{"type":1,"value":"name"},{"type":0,"value":" has started using Loom!"}],"cross-flow.xflow-notification-end-user-added-loom.message.email.instance-url.no-translate":[{"type":1,"value":"instanceUrl"}],"cross-flow.xflow-notification-end-user-added-loom.message.email.lead-paragraph":[{"type":0,"value":"Loom has been added to "},{"type":1,"value":"instanceURL"},{"type":0,"value":". You don\u2019t need to do anything. "},{"children":[{"type":0,"value":"Invite up to 10 members, for free."}],"type":8,"value":"b"},{"type":0,"value":" You can cancel any time at "},{"type":1,"value":"adminURL"},{"type":0,"value":"."}],"cross-flow.xflow-notification-end-user-added-loom.message.email.sent-by-atlassian":[{"type":0,"value":"This message was sent to you by Atlassian Cloud"}],"cross-flow.xflow-notification-end-user-added-loom.message.email.value-prop.communication":[{"type":0,"value":"\uD83D\uDE80 Explore Loom and see how it can transform your team\'s communication and collaboration."}],"cross-flow.xflow-notification-end-user-added-loom.message.email.value-prop.efficiency":[{"type":0,"value":"\u23F1\uFE0F Teams using Loom report a 29% reduction in meetings and a 74% increase in efficiency."}],"cross-flow.xflow-notification-end-user-added-loom.message.email.value-prop.share-video":[{"type":0,"value":"\uD83D\uDCF9 Loom allows teams to create and share video messages effortlessly."}]}');

});

parcelRegister("esDHJ", function(module, exports) {

let $a8727aaa0c103137$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a8727aaa0c103137$var$load("8uTFT").then(()=>parcelRequire('9GqZ9'));

});

parcelRegister("9AMHt", function(module, exports) {

let $6fbd40b54bd88904$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6fbd40b54bd88904$var$load("4o3WJ").then(()=>parcelRequire('1HfXN'));

});

parcelRegister("4eLN9", function(module, exports) {

let $315d8aa747699639$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $315d8aa747699639$var$load("52FP2").then(()=>parcelRequire('6AGJc'));

});

parcelRegister("hkPKW", function(module, exports) {

let $c9ec739e92bef01a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c9ec739e92bef01a$var$load("6XsHL").then(()=>parcelRequire('8Uqwy'));

});

parcelRegister("beYaH", function(module, exports) {

let $82efad5757ea673f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $82efad5757ea673f$var$load("5ddYP").then(()=>parcelRequire('bQ93l'));

});

parcelRegister("6ZiaS", function(module, exports) {

let $516689a39e370d77$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $516689a39e370d77$var$load("4r2y8").then(()=>parcelRequire('9tNWK'));

});

parcelRegister("h2Q2Q", function(module, exports) {

let $c68afe987888e604$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c68afe987888e604$var$load("7eMpd").then(()=>parcelRequire('9rZZk'));

});

parcelRegister("bU500", function(module, exports) {

let $8aa8cd69762c4b87$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8aa8cd69762c4b87$var$load("r5gXC").then(()=>parcelRequire('9zf6W'));

});

parcelRegister("awDKW", function(module, exports) {

let $7a9bbb43093fc45d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a9bbb43093fc45d$var$load("020fI").then(()=>parcelRequire('7eMeC'));

});

parcelRegister("AzXWa", function(module, exports) {

let $06df42f3bda32fed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $06df42f3bda32fed$var$load("grlv4").then(()=>parcelRequire('8z5sq'));

});

parcelRegister("eF6Ya", function(module, exports) {

let $aaca4d02618997eb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aaca4d02618997eb$var$load("11YfA").then(()=>parcelRequire('cPC4h'));

});

parcelRegister("dd9cR", function(module, exports) {

let $99e3a171c805cbfd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $99e3a171c805cbfd$var$load("lzV4B").then(()=>parcelRequire('fWciR'));

});

parcelRegister("a1Acb", function(module, exports) {

let $74c613118ca03447$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $74c613118ca03447$var$load("ipHLW").then(()=>parcelRequire('iMMeq'));

});

parcelRegister("4LZ3t", function(module, exports) {

let $379ae9735d88c38c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $379ae9735d88c38c$var$load("jTt1X").then(()=>parcelRequire('4ipdI'));

});

parcelRegister("9bTeQ", function(module, exports) {

let $6b0ffd576fbe628f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b0ffd576fbe628f$var$load("bxGuJ").then(()=>parcelRequire('aRaqD'));

});

parcelRegister("5HqKc", function(module, exports) {

let $4265b6bbea81a0f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4265b6bbea81a0f1$var$load("6qadE").then(()=>parcelRequire('eiQsN'));

});

parcelRegister("4uo0N", function(module, exports) {

let $344c97041af2b7a7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $344c97041af2b7a7$var$load("l75ju").then(()=>parcelRequire('f1zCj'));

});

parcelRegister("1juUo", function(module, exports) {

let $0f4f8a9b7a8e5e31$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0f4f8a9b7a8e5e31$var$load("kyun8").then(()=>parcelRequire('lWqWj'));

});

parcelRegister("cwrME", function(module, exports) {

let $91de0671db68e7ca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $91de0671db68e7ca$var$load("6EAab").then(()=>parcelRequire('g4R9y'));

});

parcelRegister("8Qg1Z", function(module, exports) {

let $66ff9d7c54015891$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $66ff9d7c54015891$var$load("bZzRf").then(()=>parcelRequire('cMYdw'));

});

parcelRegister("2EI43", function(module, exports) {

let $1ef17f74ab472f27$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1ef17f74ab472f27$var$load("9JS7u").then(()=>parcelRequire('cQfJB'));

});

parcelRegister("daXaK", function(module, exports) {

let $997a1beb36caf57e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $997a1beb36caf57e$var$load("9AUQY").then(()=>parcelRequire('hfsbb'));

});

parcelRegister("e9mhf", function(module, exports) {

let $02a8914957c61fde$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $02a8914957c61fde$var$load("amAv0").then(()=>parcelRequire('6Sidc'));

});

parcelRegister("aoRDp", function(module, exports) {

let $7925bffd8c060791$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7925bffd8c060791$var$load("jxXXO").then(()=>parcelRequire('aGgN4'));

});

parcelRegister("1FZc3", function(module, exports) {

let $1389168061947429$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1389168061947429$var$load("4QPGH").then(()=>parcelRequire('iv1eT'));

});

parcelRegister("3gHqI", function(module, exports) {

let $26148e03e184431d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $26148e03e184431d$var$load("4WGuU").then(()=>parcelRequire('iF5xc'));

});

parcelRegister("dtwRs", function(module, exports) {

let $9cf779549ede87ea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9cf779549ede87ea$var$load("6DebQ").then(()=>parcelRequire('4WiK3'));

});

parcelRegister("kOGAu", function(module, exports) {

let $f279832db94ae910$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f279832db94ae910$var$load("4rwgn").then(()=>parcelRequire('8Nmoe'));

});

parcelRegister("dRke1", function(module, exports) {

let $a16fe9dfb27e46ae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a16fe9dfb27e46ae$var$load("gqzs7").then(()=>parcelRequire('5z2Qf'));

});

parcelRegister("4bMpu", function(module, exports) {

let $30cdbdbedf2e02ed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $30cdbdbedf2e02ed$var$load("fC6Z3").then(()=>parcelRequire('2jW6D'));

});

parcelRegister("3QLtk", function(module, exports) {

let $2cdb0d688da2aaa6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2cdb0d688da2aaa6$var$load("k2qqp").then(()=>parcelRequire('1V42t'));

});

parcelRegister("8hTGT", function(module, exports) {

let $608b1c4a0a4aff3d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $608b1c4a0a4aff3d$var$load("gxsnu").then(()=>parcelRequire('dlgjv'));

});

parcelRegister("bXeCN", function(module, exports) {

let $8b408c947e3e75cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8b408c947e3e75cb$var$load("2aRNt").then(()=>parcelRequire('5Fqy2'));

});

parcelRegister("9wqIE", function(module, exports) {

let $6eebd4103856a4d0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6eebd4103856a4d0$var$load("ksXJ1").then(()=>parcelRequire('dIzw1'));

});

parcelRegister("f5lVB", function(module, exports) {
module.exports = JSON.parse('{"jsm-cbp-grace-period-notification.message.link.extra.objects":[{"type":0,"value":"Get extra objects"}],"jsm-cbp-grace-period-notification.message.link.learn.more":[{"type":0,"value":"Learn more"}],"jsm-cbp-grace-period-notification.message.link.manage.usage":[{"type":0,"value":"Manage usage"}],"jsm-cbp-grace-period-notification.message.text.ninety.days":[{"type":0,"value":"Consumption-based pricing will come into effect after "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"daysRemaining"}],"jsm-cbp-grace-period-notification.message.text.thirty.days":[{"type":0,"value":"Extra usage of Assets and the virtual service agent in Jira Service Management will be billed."}],"jsm-cbp-grace-period-notification.message.title.ninety.days":[{"type":0,"value":"You are nearing the end of your Grace period"}],"jsm-cbp-grace-period-notification.message.title.thirty.days":[{"type":0,"value":"Consumption-based pricing starts in "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"daysRemaining"}],"jsm-sequoia.edition-benefits-modal.screen-space-flags.description.no-translate":[{"type":0,"value":"Add your payment details by "},{"type":1,"value":"date"},{"type":0,"value":" to continue using "},{"type":1,"value":"edition"},{"type":0,"value":". "},{"type":1,"value":"plansLink"}],"jsm-sequoia.edition-benefits-modal.screen-space-flags.title.no-translate":[{"type":0,"value":"Explore your trial"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.heading":[{"type":0,"value":"Consumption-based pricing starts with your next renewal"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.intro":[{"type":0,"value":"We\u2019re letting you know that Assets and Virtual service agent will move to consumption-based pricing at your next renewal on "},{"type":1,"value":"cbpEffectiveDate"},{"type":0,"value":". Additional charges will only apply if your usage exceeds the included limit. Check your current usage and learn more below."}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.need-to-know":[{"type":0,"value":"Helpful things to know:"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.comment.alt-text":[{"type":0,"value":"comment"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.lightbulb.alt-text":[{"type":0,"value":"lightbulb"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.list.optimize-schema":[{"children":[{"type":0,"value":"Contact support"}],"type":8,"value":"a"},{"type":0,"value":" if you have any questions"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.list.usage-limit":[{"type":0,"value":"Consider "},{"children":[{"type":0,"value":"optimizing the structure of your schemas"}],"type":8,"value":"a"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.more-details-button":[{"type":0,"value":"More details"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.subject":[{"type":0,"value":"[Reminder] Upcoming pricing changes to Assets and Virtual Service Agent"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.support.annual.feature-usage-limits-guide":[{"type":0,"value":"For more information, read more about "},{"children":[{"type":0,"value":"how feature usage limits work"}],"type":8,"value":"a"},{"type":0,"value":"."}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.view-and-manage-usage-button":[{"type":0,"value":"View and manage usage"}],"jsm-sequoia.jsm-edition-awareness-button-popup.screen-space-flags.description.no-translate":[{"type":0,"value":"You won\'t be charged until your next billing date on "},{"children":[{"type":1,"value":"nextBillingDate"}],"type":8,"value":"strong"},{"type":0,"value":". "},{"children":[{"type":0,"value":"See plans"}],"type":8,"value":"a"},{"type":0,"value":" or "},{"children":[{"type":0,"value":"cancel anytime"}],"type":8,"value":"b"},{"type":0,"value":"."}],"jsm-sequoia.jsm-edition-awareness-button-popup.screen-space-flags.title.no-translate":[{"type":0,"value":"You\'ve been upgraded to a "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialDaysLeft"},{"type":0,"value":" free trial of our "},{"type":1,"value":"edition"},{"type":0,"value":" plan"}],"jsm-sequoia.jsm-edition-awareness-premium-upsell-modal.screen-space-flags.description":[{"type":0,"value":"Discover Premium capabilities from the Edition Awareness upgrade button."}],"jsm-sequoia.jsm-edition-awareness-premium-upsell-modal.screen-space-flags.title":[{"type":0,"value":"Explore Jira Service Management Premium"}],"jsm-sequoia.nearing-storage-limit.body.agent-limit":[{"type":0,"value":"Get "},{"children":[{"type":0,"value":"unlimited agents"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"250 GB file storage"}],"type":8,"value":"b"}],"jsm-sequoia.nearing-storage-limit.body.ai-written-support":[{"type":0,"value":"Power your Rovo agent with "},{"children":[{"type":0,"value":"AI written support articles"}],"type":8,"value":"b"}],"jsm-sequoia.nearing-storage-limit.body.assets":[{"type":0,"value":"Track business "},{"children":[{"type":0,"value":"assets"}],"type":8,"value":"b"},{"type":0,"value":" and link them to work items"}],"jsm-sequoia.nearing-storage-limit.body.disclaimer":[{"type":0,"value":"We will automatically upgrade you to a "},{"children":[{"type":0,"value":"14-day free trial"}],"type":8,"value":"b"},{"type":0,"value":" of our "},{"children":[{"type":0,"value":"Standard plan"}],"type":8,"value":"b"},{"type":0,"value":". You can "},{"children":[{"type":0,"value":"switch back to the Free plan"}],"type":8,"value":"b"},{"type":0,"value":" anytime by reducing your limits."}],"jsm-sequoia.nearing-storage-limit.body.rovo-ai-agents":[{"type":0,"value":"Resolve requests and incidents faster with "},{"children":[{"type":0,"value":"Rovo AI agents"}],"type":8,"value":"b"}],"jsm-sequoia.nearing-storage-limit.button.try-standard":[{"type":0,"value":"Try Standard for free"}],"jsm-sequoia.nearing-storage-limit.caption.body":[{"type":0,"value":"You\'ve used at least 1.8 GB of the 2 GB storage available on the Free plan. Once you reach 2 GB, you\'ll be upgraded to the 14-day free trial of our Standard plan."}],"jsm-sequoia.nearing-storage-limit.caption.disclaimer":[{"type":0,"value":"What happens once storage is full?"}],"jsm-sequoia.nearing-storage-limit.caption.heading":[{"type":0,"value":"You\'re almost out of storage"}],"jsm-sequoia.nearing-storage-limit.email-header-alt":[{"type":0,"value":"Service Collection"}],"jsm-sequoia.nearing-storage-limit.email-header-subtitle":[{"type":0,"value":"Includes:"}],"jsm-sequoia.nearing-storage-limit.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"jsm-sequoia.nearing-storage-limit.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"jsm-sequoia.nearing-storage-limit.footer.dot-separator":[{"type":0,"value":"\u2022"}],"jsm-sequoia.nearing-storage-limit.footer.facebook-alt-text":[{"type":0,"value":"Facebook"}],"jsm-sequoia.nearing-storage-limit.footer.facebook-title":[{"type":0,"value":"Facebook"}],"jsm-sequoia.nearing-storage-limit.footer.linkedin-alt-text":[{"type":0,"value":"LinkedIn"}],"jsm-sequoia.nearing-storage-limit.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"jsm-sequoia.nearing-storage-limit.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"jsm-sequoia.nearing-storage-limit.footer.partner-portal":[{"type":0,"value":"Partner Portal"}],"jsm-sequoia.nearing-storage-limit.footer.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"jsm-sequoia.nearing-storage-limit.footer.read-our-blog":[{"type":0,"value":"Read our blog"}],"jsm-sequoia.nearing-storage-limit.footer.unsubscribe":[{"children":[{"type":0,"value":"Unsubscribe"}],"type":8,"value":"a"},{"type":0,"value":" to opt out of future emails like this"}],"jsm-sequoia.nearing-storage-limit.footer.x-alt-text":[{"type":0,"value":"X"}],"jsm-sequoia.nearing-storage-limit.footer.x-title":[{"type":0,"value":"X"}],"jsm-sequoia.nearing-storage-limit.footer.youtube-alt-text":[{"type":0,"value":"Youtube"}],"jsm-sequoia.nearing-storage-limit.footer.youtube-title":[{"type":0,"value":"Youtube"}],"jsm-sequoia.nearing-storage-limit.link.explore-plans":[{"type":0,"value":"Explore all plans"}],"jsm-sequoia.service-collection-nearing-storage-limit-awareness.email.subject":[{"type":0,"value":"You are about to reach your limit"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.avatar.alt_text.user_avatar":[{"type":0,"value":"User Avatar"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.connection":[{"type":0,"value":"Connection"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.csm":[{"type":0,"value":"Customer Service Management"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.id-badge":[{"type":0,"value":"ID Badge"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.jsm":[{"type":0,"value":"Jira Service Management"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.service-collection":[{"type":0,"value":"Service Collection"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.csm.description":[{"type":0,"value":"Deliver better customer support and quickly turn feedback into product improvements."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.csm.title":[{"type":0,"value":"Delight external customers with purpose-built features"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.jsm.description":[{"type":0,"value":"Make internal support easier by enabling HR, IT, and other teams to resolve employee requests quickly."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.jsm.title":[{"type":0,"value":"Unite teams to deliver exceptional service experiences"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.alt_text.atlassian":[{"type":0,"value":"Atlassian"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.contact_us":[{"type":0,"value":"Contact us"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.location":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.privacy_policy":[{"type":0,"value":"Privacy Policy"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.read_our_blog":[{"type":0,"value":"Blog"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.twitter.no-translate":[{"type":0,"value":"Twitter"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.header.greeting":[{"type":0,"value":"Hey "},{"type":1,"value":"adminName"},{"type":0,"value":","}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.header.message":[{"type":1,"value":"requestingUserName"},{"type":0,"value":" has requested a trial of Service Collection."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.request-card":[{"type":1,"value":"requestingUserName"},{"type":0,"value":" requested your organization try Service Collection, Atlassian\u2019s solution for AI service management at high velocity."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.request-card.cta":[{"type":0,"value":"Try Service Collection for free"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.request-card.review-request-cta":[{"type":0,"value":"Review request"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.subject":[{"type":0,"value":"Hey "},{"type":1,"value":"adminName"},{"type":0,"value":", "},{"type":1,"value":"requestingUserName"},{"type":0,"value":" wants you to start a Service Collection trial"}],"jsm-servco-uplift-notification.message.button.servco.uplift":[{"type":0,"value":"Try it now"}],"jsm-servco-uplift-notification.message.link.learn.more.servco.uplift":[{"type":0,"value":"What\'s Service Collection"}],"jsm-servco-uplift-notification.message.text.servco.uplift":[{"type":0,"value":"Deliver great service experiences fast with a template designed to help your external customers."}],"jsm-servco-uplift-notification.message.title.servco.uplift":[{"type":0,"value":"Try Customer Service Management today with Service Collection"}],"post-office.ad-controls-sequoia.custom-dropdown-item.1.no-translate":[{"type":0,"value":"the first custom dropdown item"}],"post-office.ad-controls-sequoia.custom-dropdown-item.2.no-translate":[{"type":0,"value":"the second custom dropdown item"}],"post-office.ad-controls-sequoia.custom-reason.existing-products.no-translate":[{"type":0,"value":"the second reason for displaying the message to the customer"}],"post-office.ad-controls-sequoia.custom-reason.team-size.no-translate":[{"type":0,"value":"the first reason for displaying the message to the customer"}],"post-office.ad-controls-sequoia.default-reason.existing-products":[{"type":0,"value":"your existing Atlassian products"}],"post-office.ad-controls-sequoia.default-reason.team-size":[{"type":0,"value":"the size of your team"}],"post-office.ad-controls-sequoia.dismiss-flag.not-interested.subtitle":[{"type":0,"value":"You won\u2019t see this here as often."}],"post-office.ad-controls-sequoia.dismiss-flag.not-interested.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"post-office.ad-controls-sequoia.dropdown-item.not-interested.label":[{"type":0,"value":"Not interested"}],"post-office.ad-controls-sequoia.dropdown-item.remind-me-later.label":[{"type":0,"value":"Remind me later"}],"post-office.ad-controls-sequoia.dropdown-item.why-am-i-seeing-this.label":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls-sequoia.dropdown-menu-trigger.aria-label":[{"type":1,"value":"messageInstanceId"},{"type":0,"value":" options menu"}],"post-office.ad-controls-sequoia.dropdown-menu-trigger.tooltip":[{"type":0,"value":"More actions"}],"post-office.ad-controls-sequoia.reasons-modal.accept-button.label-ok":[{"type":0,"value":"OK"}],"post-office.ad-controls-sequoia.reasons-modal.body":[{"type":0,"value":"We think you\'d find this relevant. This is based on:"}],"post-office.ad-controls-sequoia.reasons-modal.privacy-policy-link.text":[{"type":0,"value":"Learn more about your data privacy with Atlassian"}],"post-office.ad-controls-sequoia.reasons-modal.title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.jsm-assets-premium-trial-dashboard-item.lozenge-try":[{"type":0,"value":"Try"}],"post-office.jsm-assets-premium-trial-dashboard-item.menu-item-label":[{"type":0,"value":"Dashboards"}],"post-office.jsm-assets-premium-trial-dashboard-item.reasons-modal-bullet-one":[{"type":0,"value":"your current product usage"}],"post-office.jsm-assets-premium-trial-dashboard-item.reasons-modal-bullet-two":[{"type":0,"value":"features available in premium"}],"post-office.jsm-assets-premium-trial-dashboard-item.reasons-modal-explanation":[{"type":0,"value":"We think this premium feature will help you get more out of Assets. The recommendation is based on:"}],"post-office.jsm-assets-premium-trial-dashboard-item.reasons-modal-title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.jsm-assets-premium-trial-data-manager-item.lozenge-try":[{"type":0,"value":"Try"}],"post-office.jsm-assets-premium-trial-data-manager-item.menu-item-label":[{"type":0,"value":"Data Manager"}],"post-office.jsm-assets-premium-trial-data-manager-item.reasons-modal-bullet-one":[{"type":0,"value":"your current product usage"}],"post-office.jsm-assets-premium-trial-data-manager-item.reasons-modal-bullet-two":[{"type":0,"value":"features available in premium"}],"post-office.jsm-assets-premium-trial-data-manager-item.reasons-modal-explanation":[{"type":0,"value":"We think this premium feature will help you get more out of Assets. The recommendation is based on:"}],"post-office.jsm-assets-premium-trial-data-manager-item.reasons-modal-title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.jsm-assets-premium-trial-item.lozenge-try":[{"type":0,"value":"Try"}],"post-office.jsm-assets-premium-trial-item.menu-item-label":[{"type":0,"value":"Assets"}],"post-office.jsm-assets-premium-trial-item.reasons-modal-bullet-one":[{"type":0,"value":"your current product usage"}],"post-office.jsm-assets-premium-trial-item.reasons-modal-bullet-two":[{"type":0,"value":"features available in premium"}],"post-office.jsm-assets-premium-trial-item.reasons-modal-explanation":[{"type":0,"value":"We think this premium feature will help you get more out of Assets. The recommendation is based on:"}],"post-office.jsm-assets-premium-trial-item.reasons-modal-title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.jsm-issue-view-details-section.description":[{"type":0,"value":"Update incidents from within Slack and summarize key events with AI."}],"post-office.jsm-issue-view-details-section.dismiss-button-one":[{"type":0,"value":"I don\'t use Slack"}],"post-office.jsm-issue-view-details-section.reasons-modal-bullet-one":[{"type":0,"value":"your usage of Jira Service Management\'s Alerts and Incidents features"}],"post-office.jsm-issue-view-details-section.reasons-modal-explanation":[{"type":0,"value":"We think Service Collection Premium will improve your team\'s workflow. The recommendation is based on:"}],"post-office.jsm-issue-view-details-section.title":[{"type":0,"value":"Resolve incidents on Slack with AI"}],"servco-recent-purchase-in-product-recruitment.message.description":[{"type":0,"value":"Discover the best features and configure it to your team\'s needs."},{"type":1,"value":"br"},{"type":0,"value":"Book a free 45 minute session with an Atlassian expert."}],"servco-recent-purchase-in-product-recruitment.message.link.book.now":[{"type":0,"value":"Book now"}],"servco-recent-purchase-in-product-recruitment.message.title":[{"type":0,"value":"Get expert help setting up Service Collection"}],"servco-recent-purchase-in-product-recruitment.modal.reason.recent-purchase":[{"type":0,"value":"Your recent purchase of Service Collection"}],"servco-recent-purchase-in-product-recruitment.modal.reason.user-count":[{"type":0,"value":"The number of users in Service Collection"}],"servco-recent-purchase-in-product-recruitment.modal.why-am-i-seeing-this.based-on":[{"type":0,"value":"This recommendation is based on:"}],"servco-recent-purchase-in-product-recruitment.modal.why-am-i-seeing-this.intro":[{"type":0,"value":"Your organization recently purchased Service Collection. We believe that speaking with an Atlassian expert will help you get the most out of it."}]}');

});

parcelRegister("eJARV", function(module, exports) {

let $aba1de03573cbb12$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aba1de03573cbb12$var$load("7Xrtc").then(()=>parcelRequire('6ebnt'));

});

parcelRegister("c8HEb", function(module, exports) {

let $8d6816d24a4d3e76$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8d6816d24a4d3e76$var$load("ahusQ").then(()=>parcelRequire('2ldfU'));

});

parcelRegister("3S5og", function(module, exports) {

let $2d1a98ad645d5c85$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2d1a98ad645d5c85$var$load("g5bp4").then(()=>parcelRequire('bnTBa'));

});

parcelRegister("1DOsy", function(module, exports) {

let $132093341d5e5807$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $132093341d5e5807$var$load("au4aS").then(()=>parcelRequire('9zDo7'));

});

parcelRegister("5A0e0", function(module, exports) {

let $41007d36edcb09c4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $41007d36edcb09c4$var$load("agOhm").then(()=>parcelRequire('j6kOd'));

});

parcelRegister("1BlH8", function(module, exports) {

let $12aa13488a3fc403$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $12aa13488a3fc403$var$load("3bFVa").then(()=>parcelRequire('b78Nn'));

});

parcelRegister("eIS6p", function(module, exports) {

let $ab7f245b635c82a2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ab7f245b635c82a2$var$load("hwMc4").then(()=>parcelRequire('1hpcT'));

});

parcelRegister("937y2", function(module, exports) {

let $696a3fbeedd01cf6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $696a3fbeedd01cf6$var$load("6d0N2").then(()=>parcelRequire('5mJ8W'));

});

parcelRegister("cn7N4", function(module, exports) {

let $901dad0fbb9e2438$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $901dad0fbb9e2438$var$load("kNMVE").then(()=>parcelRequire('8moab'));

});

parcelRegister("7RVtq", function(module, exports) {

let $5baa10b66e63705a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5baa10b66e63705a$var$load("25quG").then(()=>parcelRequire('hyY0a'));

});

parcelRegister("2C8PW", function(module, exports) {

let $1e75fc2b0262b3f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1e75fc2b0262b3f1$var$load("3gPE9").then(()=>parcelRequire('1L0Io'));

});

parcelRegister("2grYS", function(module, exports) {

let $1a62c7cf1692f5b9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1a62c7cf1692f5b9$var$load("1v8Pq").then(()=>parcelRequire('kCLLG'));

});

parcelRegister("hPl05", function(module, exports) {

let $cfa77d566f242c8b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cfa77d566f242c8b$var$load("k7rQv").then(()=>parcelRequire('gyHBB'));

});

parcelRegister("2VzBa", function(module, exports) {

let $221c84c04c42f209$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $221c84c04c42f209$var$load("gBmHm").then(()=>parcelRequire('gDdZS'));

});

parcelRegister("1BrDj", function(module, exports) {

let $12aeae807d8c652a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $12aeae807d8c652a$var$load("5HAQI").then(()=>parcelRequire('HQzTB'));

});

parcelRegister("11EUE", function(module, exports) {

let $0bf59ed9d7c05b2b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0bf59ed9d7c05b2b$var$load("iiDzS").then(()=>parcelRequire('37HNP'));

});

parcelRegister("aMBi9", function(module, exports) {

let $7d9b5074c804cfea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7d9b5074c804cfea$var$load("bT5Gj").then(()=>parcelRequire('iNjlU'));

});

parcelRegister("27hut", function(module, exports) {

let $18a9cd7d2d64929f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $18a9cd7d2d64929f$var$load("ess1I").then(()=>parcelRequire('bMOBC'));

});

parcelRegister("6OsG3", function(module, exports) {

let $4f5da85177c547bc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4f5da85177c547bc$var$load("jk0Ep").then(()=>parcelRequire('ltaMB'));

});

parcelRegister("33ogS", function(module, exports) {

let $23947aabeec3c892$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $23947aabeec3c892$var$load("lpM0o").then(()=>parcelRequire('iwHFa'));

});

parcelRegister("cDzdi", function(module, exports) {

let $933471373dddce5a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $933471373dddce5a$var$load("4YU10").then(()=>parcelRequire('hSHUk'));

});

parcelRegister("hTXg4", function(module, exports) {

let $035cfe1969b633fa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $035cfe1969b633fa$var$load("g3MV3").then(()=>parcelRequire('1FbNA'));

});

parcelRegister("4yGSl", function(module, exports) {

let $351b9894bf970fb3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $351b9894bf970fb3$var$load("3evQb").then(()=>parcelRequire('9HKtk'));

});

parcelRegister("67VKj", function(module, exports) {

let $476030b004d75b75$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $476030b004d75b75$var$load("jjPSy").then(()=>parcelRequire('dqffR'));

});

parcelRegister("7CdPL", function(module, exports) {

let $58b6d02634d21b09$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $58b6d02634d21b09$var$load("4ohDn").then(()=>parcelRequire('gBupx'));

});

parcelRegister("9fzK8", function(module, exports) {

let $6bc13d9ef43363a1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6bc13d9ef43363a1$var$load("etgmr").then(()=>parcelRequire('jehk3'));

});

parcelRegister("9BrJT", function(module, exports) {

let $6fdd162d31112ae6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6fdd162d31112ae6$var$load("fmHid").then(()=>parcelRequire('015AX'));

});

parcelRegister("1tMpf", function(module, exports) {

let $113e0c5ca331751c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $113e0c5ca331751c$var$load("24Vlz").then(()=>parcelRequire('4qZXY'));

});

parcelRegister("5toJp", function(module, exports) {

let $3fc2d85848bb1049$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3fc2d85848bb1049$var$load("aws4y").then(()=>parcelRequire('FX4ay'));

});

parcelRegister("9bd4K", function(module, exports) {

let $6aef48a8610e0f7f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6aef48a8610e0f7f$var$load("leByQ").then(()=>parcelRequire('4P3Pm'));

});

parcelRegister("9VH07", function(module, exports) {

let $73aacb031061907d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $73aacb031061907d$var$load("jBxUm").then(()=>parcelRequire('jg4Tr'));

});

parcelRegister("kPern", function(module, exports) {

let $f293c5a744e50124$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f293c5a744e50124$var$load("g1bcx").then(()=>parcelRequire('kSafG'));

});

parcelRegister("eCFB3", function(module, exports) {

let $aa54e18cc7672700$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aa54e18cc7672700$var$load("1p9cy").then(()=>parcelRequire('5H3Kj'));

});

parcelRegister("9Joxq", function(module, exports) {

let $715b59cbcd4b81f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $715b59cbcd4b81f1$var$load("ejtUr").then(()=>parcelRequire('i3qzx'));

});

parcelRegister("fnjwM", function(module, exports) {
module.exports = JSON.parse('{"app.accept":[{"type":0,"value":"Accept"}],"app.reject":[{"type":0,"value":"Reject"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"ecosystem-forge-apps.ecosystem-forge-apps-in-app.hello-world":[{"type":0,"value":"Hello "},{"type":1,"value":"propA"},{"type":0,"value":". Is is a lovely "},{"type":1,"value":"propB"}],"jira.jira-project-pages-gdrive-deprecation.message-template.email.subject":[{"type":0,"value":"Google Drive will no longer be supported in Jira Project Pages"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-1":[{"type":0,"value":"We\'re reaching out to notify you that from April 23rd 2024, syncing Google Drive shared drives will no longer be supported in Project Pages for the users in your site. Users will no longer be able to access their shared drives Jira as we are removing the feature, but they will still be able to sync Confluence spaces to Jira."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-2":[{"type":0,"value":"Please note that we are not deleting any data within Google Drive itself. The change only affects the ability to sync, link, and access Google Shared Drives from Jira."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-3":[{"type":0,"value":"This is part of our ongoing efforts to streamline our services and ensure the highest quality experience for our users."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-4":[{"type":0,"value":"Next steps:"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-5":[{"type":0,"value":"We are committed to providing you with the best possible experience, and appreciate your understanding as we make these necessary improvements. Thank you for your continued support."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body.list-1":[{"type":0,"value":"No immediate action is required from your end regarding this deprecation. However, we understand that this change may impact your workflow, and we are here to support you through this transition."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body.list-3":[{"type":0,"value":"For any feedback, or further questions and assistance with change management, please contact jnguyen2@atlassian.com"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.greeting":[{"type":0,"value":"Dear Admin,"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.title":[{"type":0,"value":"Google Drive will no longer be supported in Jira Project Pages"}],"jira.jira-weekly-digest.message-template.email.subject":[{"type":0,"value":"Your weekly digest for Jira project: "},{"type":1,"value":"projectName"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesCompletion":[{"type":0,"value":"issues completed in the past week"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesCreated":[{"type":0,"value":"issues created in the past week"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesUpdated":[{"type":0,"value":"issues updated in the past week"}],"jira.jira-weekly-digest.test-message.email.body.plusSign":[{"type":0,"value":"+"}],"jira.jira-weekly-digest.test-message.email.header":[{"type":0,"value":"Here\'s your weekly digest for Jira ("},{"type":1,"value":"projectName"},{"type":0,"value":") over the past week"}],"jira.jira-weekly-digest.test-message.email.headerDescription":[{"type":0,"value":"You\u2019re receiving this email because you have opted in to receive weekly updates for this project in Jira."}],"jira.jira-weekly-digest.test-message.email.playbookBodyText":[{"type":0,"value":"Atlassian Playbook"}],"jira.jira-weekly-digest.test-message.email.playbookHeader":[{"type":0,"value":"Has your team conducted a retrospective recently?"}],"jira.jira-weekly-digest.test-message.email.playbookSubheader":[{"type":0,"value":"A retrospective gives you an opportunity to review your latest project progress and make improvements for the future. Find out more at "},{"type":1,"value":"link"},{"type":0,"value":"."}],"jira.jira-weekly-digest.test-message.email.tableHeader":[{"type":0,"value":"Weekly Summary"}],"jira.suppression-email-notification-email.contact-us":[{"type":0,"value":"contact us"}],"jira.suppression-email-notification-email.email.body":[{"type":0,"value":"This is an automatated message to notify you that the jira "},{"type":1,"value":"emailType"},{"type":0,"value":" email \\n\\t\\t\\t\\t\\t\\tto "},{"type":1,"value":"affectedUserEmail"},{"type":0,"value":" has been suppressed. Please visit this "},{"type":1,"value":"unsuppressApiLink"},{"type":0,"value":" to unsuppress the user\'s email."}],"jira.suppression-email-notification-email.email.body.goodbye":[{"type":0,"value":"Please "},{"type":1,"value":"contactUsLink"},{"type":0,"value":" if the issue persists, we\'re always happy to help."}],"jira.suppression-email-notification-email.email.body.regards":[{"type":0,"value":"Jira Notifications Team"}],"jira.suppression-email-notification-email.email.body.signoff":[{"type":0,"value":"Regards,"}],"jira.suppression-email-notification-email.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"jira.suppression-email-notification-email.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jira.suppression-email-notification-email.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"playground.end-of-trial-extension.description.no-translate":[{"type":0,"value":"End of trial extension test message."}],"playground.end-of-trial-extension.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"playground.playground-local-execution-message.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"playground.playground-local-execution-message.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"playground.playground-local-execution-message.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hello, fellow child "},{"type":1,"value":"name"},{"type":0,"value":","}],"playground.playground-local-execution-message.test-message.email.body.no-translate":[{"type":0,"value":"We are currently trying to locally execute this message!"}],"playground.playground-local-execution-message.test-message.email.body.regards.no-translate":[{"type":0,"value":"Playground Team"}],"playground.playground-local-execution-message.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"playground.playground-local-execution-message.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"playground.post-office-auto-merge-config.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"playground.post-office-auto-merge-config.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"playground.post-office-auto-merge-config.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"playground.post-office-auto-merge-config.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"playground.post-office-auto-merge-config.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"playground.post-office-auto-merge-config.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"playground.post-office-auto-merge-config.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"post-office.commerce-common.unsuppress-email-link":[{"type":0,"value":"link"}],"post-office.jira-email.contact-us":[{"type":0,"value":"contact us"}],"post-office.playground.go-faster-techops-rollup-notifier.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.playground.test-playground-message.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"sharc.sharc-tenant-migration-brazil-unpinned.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"sharc.sharc-tenant-migration-brazil-unpinned.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}]}');

});

parcelRegister("alZ6t", function(module, exports) {

let $789b436fb3f5f156$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $789b436fb3f5f156$var$load("czp36").then(()=>parcelRequire('k8Mou'));

});

parcelRegister("jjI9T", function(module, exports) {

let $e1020ba74cbc8ee1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e1020ba74cbc8ee1$var$load("kMAXW").then(()=>parcelRequire('6r2F4'));

});

parcelRegister("4CGwT", function(module, exports) {

let $35dbb3893c50b21a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $35dbb3893c50b21a$var$load("3GkDf").then(()=>parcelRequire('dHGfx'));

});

parcelRegister("hLcE3", function(module, exports) {

let $cee0a27c61e54e96$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cee0a27c61e54e96$var$load("jC9Rs").then(()=>parcelRequire('efoXP'));

});

parcelRegister("b968C", function(module, exports) {

let $81d54bd671fa97c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $81d54bd671fa97c3$var$load("8ynxX").then(()=>parcelRequire('4KpqX'));

});

parcelRegister("7AD3N", function(module, exports) {

let $586a31c42d8bc602$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $586a31c42d8bc602$var$load("3gJkM").then(()=>parcelRequire('1Ezgp'));

});

parcelRegister("lQ73y", function(module, exports) {

let $fe63ed8bfdf96417$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fe63ed8bfdf96417$var$load("eqo8j").then(()=>parcelRequire('hlIKn'));

});

parcelRegister("jdijK", function(module, exports) {

let $dfcd70b5a6cc271b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dfcd70b5a6cc271b$var$load("7I7e4").then(()=>parcelRequire('7yWuG'));

});

parcelRegister("c4QmP", function(module, exports) {

let $8cae7accf1d20a4e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8cae7accf1d20a4e$var$load("csrLl").then(()=>parcelRequire('h7eL8'));

});

parcelRegister("aJgCR", function(module, exports) {

let $7cfb00e6570526e7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7cfb00e6570526e7$var$load("j5Lsa").then(()=>parcelRequire('7c7pH'));

});

parcelRegister("1B4TH", function(module, exports) {

let $129d0ba9b187676c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $129d0ba9b187676c$var$load("4sHgh").then(()=>parcelRequire('l3tuo'));

});

parcelRegister("hRqHT", function(module, exports) {

let $d00c1a53624d436e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d00c1a53624d436e$var$load("4s68a").then(()=>parcelRequire('4xyaY'));

});

parcelRegister("jyUGx", function(module, exports) {

let $e3dd29c482d56786$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e3dd29c482d56786$var$load("eMKcg").then(()=>parcelRequire('5nOGu'));

});

parcelRegister("bi7ue", function(module, exports) {

let $83872ed08a722622$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $83872ed08a722622$var$load("9Lid4").then(()=>parcelRequire('edb6M'));

});

parcelRegister("63Oos", function(module, exports) {

let $469a1cfebf766da6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $469a1cfebf766da6$var$load("4H2JR").then(()=>parcelRequire('jh47D'));

});

parcelRegister("cPVbs", function(module, exports) {

let $95869af6b68aac18$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $95869af6b68aac18$var$load("4BUAw").then(()=>parcelRequire('8AkjG'));

});

parcelRegister("lUbkO", function(module, exports) {

let $ff279ec3568edb1b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ff279ec3568edb1b$var$load("26vCJ").then(()=>parcelRequire('7qViT'));

});

parcelRegister("fojmp", function(module, exports) {

let $b3481d8196fa095d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b3481d8196fa095d$var$load("248fi").then(()=>parcelRequire('9xGa0'));

});

parcelRegister("1Im5h", function(module, exports) {

let $13fb07fa61eede04$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $13fb07fa61eede04$var$load("1eaJh").then(()=>parcelRequire('3d0aC'));

});

parcelRegister("b7PuI", function(module, exports) {

let $81984ae2677b3d9d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $81984ae2677b3d9d$var$load("cb2qH").then(()=>parcelRequire('jB01E'));

});

parcelRegister("awCZh", function(module, exports) {

let $7a9b229aabae0deb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a9b229aabae0deb$var$load("cXZBf").then(()=>parcelRequire('3MFgx'));

});

parcelRegister("fX5Gv", function(module, exports) {

let $b9d0c68d1b3a511a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b9d0c68d1b3a511a$var$load("g9KgO").then(()=>parcelRequire('7MsWl'));

});

parcelRegister("5vsDw", function(module, exports) {

let $40260f9974bc93a6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $40260f9974bc93a6$var$load("kFGbg").then(()=>parcelRequire('6powa'));

});

parcelRegister("jRjmb", function(module, exports) {

let $e751fb6a029280b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e751fb6a029280b3$var$load("cCVdk").then(()=>parcelRequire('hnl91'));

});

parcelRegister("bzsYJ", function(module, exports) {

let $86c9711d1992ad7a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $86c9711d1992ad7a$var$load("iDM0X").then(()=>parcelRequire('gDmPq'));

});

parcelRegister("jP49l", function(module, exports) {

let $e6e5ffc676417e45$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e6e5ffc676417e45$var$load("fDyFp").then(()=>parcelRequire('4P8Ug'));

});

parcelRegister("7wWJW", function(module, exports) {

let $57b91614a6605f3b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $57b91614a6605f3b$var$load("ciiT8").then(()=>parcelRequire('h4rNI'));

});

parcelRegister("2n8d7", function(module, exports) {

let $1ba4193510f30e75$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1ba4193510f30e75$var$load("oK6sK").then(()=>parcelRequire('dzbrU'));

});

parcelRegister("lmH7k", function(module, exports) {

let $f8dd19334bb1322e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f8dd19334bb1322e$var$load("gQVui").then(()=>parcelRequire('1zeU2'));

});

parcelRegister("6ua4X", function(module, exports) {

let $4b8d5ce559d4ca77$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4b8d5ce559d4ca77$var$load("hD494").then(()=>parcelRequire('9LT4x'));

});

parcelRegister("iFzjG", function(module, exports) {

let $d977737589411039$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d977737589411039$var$load("e6T9M").then(()=>parcelRequire('4VR5g'));

});

parcelRegister("3WTZO", function(module, exports) {

let $2e02397e7b5f75f6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2e02397e7b5f75f6$var$load("7OyVM").then(()=>parcelRequire('kLdrv'));

});

parcelRegister("fXzfL", function(module, exports) {

let $b9e7b63e553a0daf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b9e7b63e553a0daf$var$load("7xkIQ").then(()=>parcelRequire('7ctPc'));

});

parcelRegister("haLUf", function(module, exports) {

let $c8088808ee52962b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c8088808ee52962b$var$load("7hBz4").then(()=>parcelRequire('k3BXj'));

});

parcelRegister("kDvBY", function(module, exports) {
module.exports = JSON.parse('{"INAPP-1736.spotlight.body":[{"type":0,"value":"We\'ve got the basic settings for your integration covered. Customize them to make sure you get the most out of the integration."}],"INAPP-1736.spotlight.primary":[{"type":0,"value":"OK"}],"INAPP-1736.spotlight.secondary":[{"type":0,"value":"Dismiss"}],"INAPP-1736.spotlight.title":[{"type":0,"value":"Set up your integration"}],"INAPP-1737.spotlight.body":[{"type":0,"value":"Draggable tags help you create well-defined alerts and manage them with ease. All you have to do is drag-and-drop the tags into any alert property field as needed"}],"INAPP-1737.spotlight.primary":[{"type":0,"value":"Learn more"}],"INAPP-1737.spotlight.secondary":[{"type":0,"value":"OK"}],"INAPP-1737.spotlight.title":[{"type":0,"value":"Create rich and informative alerts"}],"alert.status.acked":[{"type":0,"value":"Acknowledged"}],"alert.status.closed":[{"type":0,"value":"Closed"}],"alert.status.open":[{"type":0,"value":"Open"}],"alert.status.snoozed":[{"type":0,"value":"Snoozed"}],"alexstrasza.assess-risk-button-spotlight.description":[{"type":0,"value":"Evaluate the potential impact of this change before approving or scheduling."}],"alexstrasza.assess-risk-button-spotlight.heading":[{"type":0,"value":"Assess risk with Rovo Ops"}],"alexstrasza.assess-risk-button-spotlight.try-it-now":[{"type":0,"value":"Try it now"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.created-at.no-translate":[{"type":0,"value":"Created "},{"type":1,"value":"createdAt"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Note added"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.id-label.no-translate":[{"type":0,"value":"ID"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.status-label.no-translate":[{"type":0,"value":"Status"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.tiny-id-label.no-translate":[{"type":0,"value":"Tiny ID"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.view-alert-button.no-translate":[{"type":0,"value":"View Alert"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.view-alert-compass-button.no-translate":[{"type":0,"value":"View Alert in Compass"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.view-alert-jsm-button.no-translate":[{"type":0,"value":"View Alert in Jira Service Management"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.view-og-alert-button.no-translate":[{"type":0,"value":"View alert in OpsGenie"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.subject.no-translate":[{"type":1,"value":"product"},{"type":0,"value":" Note added to alert: ("},{"type":1,"value":"priority"},{"type":0,"value":") "},{"type":1,"value":"message"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.assignee-label.no-translate":[{"type":0,"value":"Assignee"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.created-at.no-translate":[{"type":0,"value":"Created "},{"type":1,"value":"createdAt"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Description"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.id-label.no-translate":[{"type":0,"value":"ID"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.integration-label.no-translate":[{"type":0,"value":"Integration"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.responder-label.no-translate":[{"type":0,"value":"Responder"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.source-label.no-translate":[{"type":0,"value":"Source"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.status-label.no-translate":[{"type":0,"value":"Status"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.tags-label.no-translate":[{"type":0,"value":"Tags"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.tiny-id-label.no-translate":[{"type":0,"value":"Tiny ID"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.view-alert-button.no-translate":[{"type":0,"value":"View Alert"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.view-alert-compass-button.no-translate":[{"type":0,"value":"View Alert in Compass"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.view-alert-jsm-button.no-translate":[{"type":0,"value":"View Alert in Jira Service Management"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.view-og-alert-button.no-translate":[{"type":0,"value":"View in OpsGenie"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.subject.no-translate":[{"type":1,"value":"product"},{"type":0,"value":" Alert acknowledged: ("},{"type":1,"value":"priority"},{"type":0,"value":") "},{"type":1,"value":"message"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.assignee-label.no-translate":[{"type":0,"value":"Assignee"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.created-at.no-translate":[{"type":0,"value":"Created "},{"type":1,"value":"createdAt"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Description"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.id-label.no-translate":[{"type":0,"value":"ID"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.integration-label.no-translate":[{"type":0,"value":"Integration"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.responder-label.no-translate":[{"type":0,"value":"Responder"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.source-label.no-translate":[{"type":0,"value":"Source"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.status-label.no-translate":[{"type":0,"value":"Status"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.tags-label.no-translate":[{"type":0,"value":"Tags"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.tiny-id-label.no-translate":[{"type":0,"value":"Tiny ID"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.view-alert-button.no-translate":[{"type":0,"value":"View Alert"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.view-alert-compass-button.no-translate":[{"type":0,"value":"View Alert in Compass"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.view-alert-jsm-button.no-translate":[{"type":0,"value":"View Alert in Jira Service Management"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.view-og-alert-button.no-translate":[{"type":0,"value":"View in OpsGenie"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.subject.no-translate":[{"type":1,"value":"product"},{"type":0,"value":" Alert assigned: ("},{"type":1,"value":"priority"},{"type":0,"value":") "},{"type":1,"value":"message"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.assignee-label.no-translate":[{"type":0,"value":"Assignee"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.created-at.no-translate":[{"type":0,"value":"Created "},{"type":1,"value":"createdAt"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Description"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.id-label.no-translate":[{"type":0,"value":"ID"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.integration-label.no-translate":[{"type":0,"value":"Integration"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.responder-label.no-translate":[{"type":0,"value":"Responder"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.source-label.no-translate":[{"type":0,"value":"Source"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.status-label.no-translate":[{"type":0,"value":"Status"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.tags-label.no-translate":[{"type":0,"value":"Tags"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.tiny-id-label.no-translate":[{"type":0,"value":"Tiny ID"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.view-alert-button.no-translate":[{"type":0,"value":"View Alert"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.view-alert-compass-button.no-translate":[{"type":0,"value":"View Alert in Compass"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.view-alert-jsm-button.no-translate":[{"type":0,"value":"View Alert in Jira Service Management"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.view-og-alert-button.no-translate":[{"type":0,"value":"View in OpsGenie"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.subject.no-translate":[{"type":1,"value":"product"},{"type":0,"value":" Alert closed: ("},{"type":1,"value":"priority"},{"type":0,"value":") "},{"type":1,"value":"message"}],"alexstrasza.jsm-operations-alert-export.message-template.email.subject.no-translate":[{"type":0,"value":"Export Alert Result"}],"alexstrasza.jsm-operations-alert-export.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"alexstrasza.jsm-operations-alert-export.test-message.email.body.no-translate":[{"type":0,"value":"We\u2019ve exported your alerts and now you can download the zip file here:"}],"alexstrasza.jsm-operations-alert-export.test-message.email.continue-export-label.no-translate":[{"type":0,"value":"The results contain the latest 10k alerts. To continue exporting, you can click the link below:"}],"alexstrasza.jsm-operations-alert-export.test-message.email.expiry.no-translate":[{"type":0,"value":"Please note that the export link will expire in 14 days."}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.assignee-label.no-translate":[{"type":0,"value":"Assignee"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.created-at.no-translate":[{"type":0,"value":"Created "},{"type":1,"value":"createdAt"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Description"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.id-label.no-translate":[{"type":0,"value":"ID"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.integration-label.no-translate":[{"type":0,"value":"Integration"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.responder-label.no-translate":[{"type":0,"value":"Responder"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.source-label.no-translate":[{"type":0,"value":"Source"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.status-label.no-translate":[{"type":0,"value":"Status"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.tags-label.no-translate":[{"type":0,"value":"Tags"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.tiny-id-label.no-translate":[{"type":0,"value":"Tiny ID"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.view-alert-button.no-translate":[{"type":0,"value":"View Alert"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.view-alert-compass-button.no-translate":[{"type":0,"value":"View Alert in Compass"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.view-alert-jsm-button.no-translate":[{"type":0,"value":"View Alert in Jira Service Management"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.view-og-alert-button.no-translate":[{"type":0,"value":"View in OpsGenie"}],"alexstrasza.jsm-operations-alert-new.message-template.email.subject.no-translate":[{"type":1,"value":"product"},{"type":0,"value":" New alert: ("},{"type":1,"value":"priority"},{"type":0,"value":") "},{"type":1,"value":"message"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.download-button.no-translate":[{"type":0,"value":"Download "},{"type":1,"value":"exportType"},{"type":0,"value":" log"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.download-icon.alt.no-translate":[{"type":0,"value":"Download icon"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.export-criteria-category.no-translate":[{"type":0,"value":"Category: "},{"type":1,"value":"filterCategories"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.export-criteria-label.no-translate":[{"type":0,"value":"Export Criteria:"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.export-criteria-log-level.no-translate":[{"type":0,"value":"Log level: "},{"type":1,"value":"filterLogLevels"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.export-criteria-search.no-translate":[{"type":0,"value":"Search: "},{"type":1,"value":"searchKeywords"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.export-criteria-time.no-translate":[{"type":0,"value":"Time: "},{"type":1,"value":"from"},{"type":0,"value":" to "},{"type":1,"value":"to"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.greeting.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"userFullName"},{"type":0,"value":","}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.heading.no-translate":[{"type":0,"value":"Download your "},{"type":1,"value":"exportType"},{"type":0,"value":" log"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.intro-message.no-translate":[{"type":0,"value":"The CSV file for "},{"type":1,"value":"siteName"},{"type":0,"value":"\'s "},{"type":1,"value":"exportType"},{"type":0,"value":" log is ready to download. The download link will expire in 24 hours."}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.limit-note.no-translate":[{"type":0,"value":"Up to 100,000 activities can be exported at once, activities over the limit would be skipped in the CSV file."}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.subject.no-translate":[{"type":0,"value":"Your "},{"type":1,"value":"exportType"},{"type":0,"value":" log is ready to download"}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.affected-role-label.no-translate":[{"type":0,"value":"Affected member role"}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.button-text.no-translate":[{"type":0,"value":"View your alert notifications"}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.contact-methods.no-translate":[{"type":0,"value":"contact methods"}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Description"}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.description-text.no-translate":[{"type":0,"value":"The role-based notification "},{"type":1,"value":"roleBasedNotificationSettingName"},{"type":0,"value":" will trigger alert notifications based on the conditions set by the admin."}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.note-label.no-translate":[{"type":0,"value":"Note"}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.note-text.no-translate":[{"type":0,"value":"Review your "},{"type":1,"value":"contactMethods"},{"type":0,"value":" to confirm that this role-based notification works as expected."}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.override-message.no-translate":[{"type":0,"value":"Role-based notifications override your personal notifications."}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.title.no-translate":[{"type":0,"value":"Role-based notification turned on"}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.subject.no-translate":[{"type":0,"value":"Role-based notification turned on"}],"alexstrasza.jsm-operations-rotation-ends.message-template.email.body.team.no-translate":[{"type":0,"value":"Team"}],"alexstrasza.jsm-operations-rotation-ends.message-template.email.subject.no-translate":[{"type":0,"value":"["},{"type":1,"value":"productName"},{"type":0,"value":"] Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" ends"}],"alexstrasza.jsm-operations-rotation-ends.test-message.email.body.rotation-ending-at.no-translate":[{"type":0,"value":"Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" is ending, at "},{"type":1,"value":"endTime"},{"type":0,"value":"."}],"alexstrasza.jsm-operations-rotation-ends.test-message.email.body.rotation-ending-now.no-translate":[{"type":0,"value":"Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" is ending now."}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.app-store-logo.alt.no-translate":[{"type":0,"value":"Download on the App Store"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.manage-notifications.link-text.no-translate":[{"type":0,"value":"update your notification settings"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.manage-notifications.no-translate":[{"type":0,"value":"To customize the email or unsubscribe, "},{"type":1,"value":"link"},{"type":0,"value":"."}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.mobile-app.no-translate":[{"type":0,"value":"Stay notified and comment on the go with Jira Service Management Mobile App"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.play-store-logo.alt.no-translate":[{"type":0,"value":"Download on the Play Store"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.team.no-translate":[{"type":0,"value":"Team"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.footer-logo.alt.no-translate":[{"type":0,"value":"Atlassian"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.footer.privacy-policy.no-translate":[{"type":0,"value":"Privacy Policy"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.footer.text.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.subject.no-translate":[{"type":0,"value":"["},{"type":1,"value":"productName"},{"type":0,"value":"] Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" starts"}],"alexstrasza.jsm-operations-rotation-starts.test-message.email.body.rotation-starting-at.no-translate":[{"type":0,"value":"Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" is starting, at "},{"type":1,"value":"startTime"},{"type":0,"value":"."}],"alexstrasza.jsm-operations-rotation-starts.test-message.email.body.rotation-starting-now.no-translate":[{"type":0,"value":"Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" is starting now."}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.alert-feature-image.alt.no-translate":[{"type":0,"value":"Alert management illustration"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.chat-feature-image.alt.no-translate":[{"type":0,"value":"Chat integration illustration"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.explore-subheading.no-translate":[{"type":0,"value":"Explore how operations can elevate your team\'s response"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-alert-description.no-translate":[{"type":0,"value":"Improve response efficiency and reduce the alert fatigue."}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-alert-title.no-translate":[{"type":0,"value":"Manage all alerts in one place"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-chat-description.no-translate":[{"type":0,"value":"Handle alerts and on-call using your chat tools."}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-chat-title.no-translate":[{"type":0,"value":"Respond to alerts via chat"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-integration-description.no-translate":[{"type":0,"value":"Connect your IT tools and apps to centralize alerts in one place."}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-integration-title.no-translate":[{"type":0,"value":"Integrate with your apps"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-oncall-description.no-translate":[{"type":0,"value":"Set on-call schedules easily and never miss a critical alert."}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-oncall-title.no-translate":[{"type":0,"value":"Become an on-call team"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.heading.no-translate":[{"children":[{"type":1,"value":"teamName"}],"type":8,"value":"strong"},{"type":0,"value":" has launched its operations and is ready to respond"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.integration-feature-image.alt.no-translate":[{"type":0,"value":"Integration illustration"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.launch-message.no-translate":[{"children":[{"type":1,"value":"actorUserName"}],"type":8,"value":"strong"},{"type":0,"value":" has launched "},{"children":[{"type":1,"value":"teamName"},{"type":0,"value":"\'s"}],"type":8,"value":"strong"},{"type":0,"value":" operations and added you as a member to collaborate."}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.learn-more-link.no-translate":[{"type":0,"value":"Learn more"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.oncall-feature-image.alt.no-translate":[{"type":0,"value":"On-call scheduling illustration"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.start-collaborating-button.no-translate":[{"type":0,"value":"Start collaborating"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.team-image.alt.no-translate":[{"type":0,"value":"Team profile picture"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.what-are-operations.no-translate":[{"type":0,"value":"What are operations?"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.subject.no-translate":[{"type":0,"value":"You\'re invited to collaborate on your team\'s operations"}],"alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.email-allowlist.no-translate":[{"type":0,"value":"Your email server might be rejecting emails from Jira Service Management. Request your email administrator to allowlist jsm-notifications.atlassian.net."}],"alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.email-deactivated.no-translate":[{"type":0,"value":"The email address "},{"type":1,"value":"displayName"},{"type":0,"value":" you had added for alert notifications is deactivated."}],"alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.email-reactivate.no-translate":[{"type":0,"value":"If the email address is correct, go to the Alert notifications page in your personal settings and reactivate it."}],"alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.greeting.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"fullName"},{"type":0,"value":","}],"alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.mobile-deactivated.no-translate":[{"type":0,"value":"The mobile device "},{"type":1,"value":"displayName"},{"type":0,"value":" added to your contact methods for mobile push notifications is currently deactivated because it\'s invalid or your app instance was unregistered. To continue receiving push notifications, re-install the application and verify the status from the Alert notifications page in your Jira personal settings."}],"alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.phone-deactivated.no-translate":[{"type":0,"value":"The phone number "},{"type":1,"value":"displayName"},{"type":0,"value":" added to your contact methods for voice/SMS is currently deactivated because it\'s invalid or it\'s blocklisted by your service provider. If the phone number is correct, go to the Alert notifications page in your Jira personal settings and reactivate it."}],"alexstrasza.jsm-operations-user-contact-disabled.message-template.email.subject.no-translate":[{"type":0,"value":"["},{"type":1,"value":"product"},{"type":0,"value":"] Contact method for notifications deactivated"}],"alexstrasza.jsm-ops-enablement-notification-drawer.message-template.notification-drawer.message":[{"type":1,"value":"actorName"},{"type":0,"value":" launched "},{"type":1,"value":"teamName"},{"type":0,"value":"\'s operations"}],"alexstrasza.operations-overview-discoverability-spotlights.high-bug.description":[{"type":0,"value":"Your team\'s been logging a lot of bugs. Set up operations to get ahead of the next one \u2014 with on-call, alerting, and incident response built right in."}],"alexstrasza.operations-overview-discoverability-spotlights.high-bug.tour.step1-description":[{"type":0,"value":"Your team\'s been logging a lot of bugs. Click "},{"children":[{"type":0,"value":"More"}],"type":8,"value":"b"},{"type":0,"value":" to set up operations and get ahead of the next one \u2014 with on-call, alerting, and incident response built right in."}],"alexstrasza.operations-overview-discoverability-spotlights.inactive-ops.description":[{"type":0,"value":"It\'s been a while since you started setting up operations. Turn on alerts and on-call schedules to unlock its full potential for your team."}],"alexstrasza.operations-overview-discoverability-spotlights.inactive-ops.heading":[{"type":0,"value":"You\'re almost there"}],"alexstrasza.operations-overview-discoverability-spotlights.inactive-ops.primary-action":[{"type":0,"value":"Go to Operations"}],"alexstrasza.operations-overview-discoverability-spotlights.inactive-ops.tour.step1-description":[{"type":0,"value":"It\'s been a while since you started setting up operations. Click "},{"children":[{"type":0,"value":"More"}],"type":8,"value":"b"},{"type":0,"value":" to set up operations and unlock its full potential for your team."}],"alexstrasza.operations-overview-discoverability-spotlights.marketplace-ops.description":[{"type":0,"value":"You\'re getting notified through third-party integrations today. Instead, set up operations to receive real-time alerts and stay on top of issues as soon as they happen."}],"alexstrasza.operations-overview-discoverability-spotlights.marketplace-ops.tour.step1-description":[{"type":0,"value":"You\'re getting notified through third-party integrations today. Click "},{"children":[{"type":0,"value":"More"}],"type":8,"value":"b"},{"type":0,"value":" to set up operations and unlock its full potential for your team."}],"alexstrasza.operations-overview-discoverability-spotlights.shared.explore-operations.heading":[{"type":0,"value":"Explore Operations"}],"alexstrasza.operations-overview-discoverability-spotlights.shared.explore-operations.primary-action":[{"type":0,"value":"Explore"}],"alexstrasza.operations-overview-discoverability-spotlights.tour.next-button":[{"type":0,"value":"Next"}],"alexstrasza.operations-overview-discoverability-spotlights.tour.primary-action":[{"type":0,"value":"Go to Operations"}],"alexstrasza.operations-overview-discoverability-spotlights.tour.step-count":[{"type":1,"value":"currentStep"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"alexstrasza.operations-overview-discoverability-spotlights.tour.step1-heading":[{"type":0,"value":"Complete your Operations setup"}],"alexstrasza.operations-overview-discoverability-spotlights.tour.step2-description":[{"type":0,"value":"Click on "},{"children":[{"type":0,"value":"Operations"}],"type":8,"value":"b"},{"type":0,"value":" to set up alerts and on-call schedules to make sure your team stay on top of issues as soon as they happen."}],"alexstrasza.operations-overview-discoverability-spotlights.tour.step2-heading":[{"type":0,"value":"You\'re almost there"}],"alexstrasza.risk-assessment-spotlight.explore-categories.description":[{"type":0,"value":"Rovo Ops breaks down risk into categories. Select any category to see risk details, contributing factors, and why it was flagged."}],"alexstrasza.risk-assessment-spotlight.explore-categories.heading":[{"type":0,"value":"Explore risk by category"}],"alexstrasza.risk-assessment-spotlight.mitigate-risk.description":[{"type":0,"value":"Get actionable mitigation steps tailored to each risk category, so you can address issues before the change goes live."}],"alexstrasza.risk-assessment-spotlight.mitigate-risk.heading":[{"type":0,"value":"Mitigate risk"}],"alexstrasza.risk-assessment-spotlight.navigation.done":[{"type":0,"value":"Done"}],"alexstrasza.risk-assessment-spotlight.navigation.next":[{"type":0,"value":"Next"}],"alexstrasza.risk-assessment-spotlight.navigation.progress":[{"type":1,"value":"currentStep"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"eoc-heartbeats.message-id.spotlight.body":[{"type":0,"value":"Copy heartbeat\u2019s name, edit, duplicate, and manage more heartbeat actions."}],"eoc-heartbeats.message-id.spotlight.dismiss":[{"type":0,"value":"OK"}],"eoc-heartbeats.message-id.spotlight.title":[{"type":0,"value":"Easy access to heartbeat actions"}],"eoc-heartbeats.tour.learn-more.no-translate":[{"type":0,"value":"Learn More"}],"post-office.alexstrasza.jsm-operations-alert-new.mobile-push-body.no-translate":[{"type":1,"value":"description"}],"post-office.alexstrasza.jsm-operations-alert-new.mobile-push-subtitle.no-translate":[{"type":0,"value":"Status: "},{"type":1,"value":"status"},{"type":0,"value":" | Source: "},{"type":1,"value":"source"}],"post-office.alexstrasza.jsm-operations-alert-new.mobile-push-title.no-translate":[{"type":0,"value":"["},{"type":1,"value":"priority"},{"type":0,"value":"] "},{"type":1,"value":"message"}]}');

});

parcelRegister("3qG4F", function(module, exports) {

let $27f46fe301a4f1c6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $27f46fe301a4f1c6$var$load("9Mfkk").then(()=>parcelRequire('fI9Wr'));

});

parcelRegister("6vgTR", function(module, exports) {

let $4bc2bf4c480bc5ee$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4bc2bf4c480bc5ee$var$load("9ixoP").then(()=>parcelRequire('loxal'));

});

parcelRegister("5uH1o", function(module, exports) {

let $40012044f76e1eb9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $40012044f76e1eb9$var$load("6gYLk").then(()=>parcelRequire('kG5PD'));

});

parcelRegister("eycDR", function(module, exports) {

let $a97e0c12e5e6f64e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a97e0c12e5e6f64e$var$load("6a2En").then(()=>parcelRequire('lFRox'));

});

parcelRegister("71unu", function(module, exports) {

let $51d030ce104f439b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $51d030ce104f439b$var$load("k41Nz").then(()=>parcelRequire('ePTMY'));

});

parcelRegister("7QImw", function(module, exports) {

let $5b6fcd2da049a344$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5b6fcd2da049a344$var$load("cJgVv").then(()=>parcelRequire('je163'));

});

parcelRegister("esvWB", function(module, exports) {

let $a86c75aa9fd55145$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a86c75aa9fd55145$var$load("grpo1").then(()=>parcelRequire('b5TtR'));

});

parcelRegister("wwoSG", function(module, exports) {

let $061c1f4ca48486a5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $061c1f4ca48486a5$var$load("kQ5b3").then(()=>parcelRequire('kq8Om'));

});

parcelRegister("d9FaO", function(module, exports) {

let $993c0dc81c416575$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $993c0dc81c416575$var$load("eBgRM").then(()=>parcelRequire('bpq65'));

});

parcelRegister("bcEp6", function(module, exports) {

let $82802814640b153e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $82802814640b153e$var$load("4DfKF").then(()=>parcelRequire('dELuh'));

});

parcelRegister("cPisg", function(module, exports) {

let $9568902efee7e113$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9568902efee7e113$var$load("2Fqck").then(()=>parcelRequire('62Oxr'));

});

parcelRegister("gKvel", function(module, exports) {

let $c3192aea34b43c24$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c3192aea34b43c24$var$load("6bO1t").then(()=>parcelRequire('2czCF'));

});

parcelRegister("iexSm", function(module, exports) {

let $d463cfd728aad5f6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d463cfd728aad5f6$var$load("jahlu").then(()=>parcelRequire('DtmYT'));

});

parcelRegister("3cwM2", function(module, exports) {

let $254bea47965b13b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $254bea47965b13b8$var$load("2LhzZ").then(()=>parcelRequire('gD6Td'));

});

parcelRegister("6rvzd", function(module, exports) {

let $4b0dc042cc6f079a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4b0dc042cc6f079a$var$load("fL6dO").then(()=>parcelRequire('en50B'));

});

parcelRegister("2TrDa", function(module, exports) {

let $21b626b849ff4563$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $21b626b849ff4563$var$load("bgjqj").then(()=>parcelRequire('8Xml8'));

});

parcelRegister("8bc2h", function(module, exports) {

let $5f48afe2917e28a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5f48afe2917e28a4$var$load("k3pVa").then(()=>parcelRequire('3LYhU'));

});

parcelRegister("SJxrG", function(module, exports) {

let $0a485e3f0e2bd51d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0a485e3f0e2bd51d$var$load("dtPqn").then(()=>parcelRequire('i0ncI'));

});

parcelRegister("bdFPK", function(module, exports) {

let $82b15bdfbcd1c0b2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $82b15bdfbcd1c0b2$var$load("5Fibl").then(()=>parcelRequire('gbX36'));

});

parcelRegister("dn4qr", function(module, exports) {

let $9bc0db20fd8d732a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9bc0db20fd8d732a$var$load("c3Lo8").then(()=>parcelRequire('7SHlu'));

});

parcelRegister("4ukYk", function(module, exports) {

let $344a3b657a4f1f68$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $344a3b657a4f1f68$var$load("h1z5r").then(()=>parcelRequire('83fYT'));

});

parcelRegister("7qtmD", function(module, exports) {

let $5681bd3a33aaa7dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5681bd3a33aaa7dd$var$load("4l735").then(()=>parcelRequire('km8f3'));

});

parcelRegister("8RiMF", function(module, exports) {

let $6731d80b6233ab33$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6731d80b6233ab33$var$load("6OgGr").then(()=>parcelRequire('fo4h8'));

});

parcelRegister("lWsSi", function(module, exports) {

let $ff9569afbe900d70$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ff9569afbe900d70$var$load("795yO").then(()=>parcelRequire('jqdPx'));

});

parcelRegister("ftx15", function(module, exports) {

let $02e84f2cdf379c8d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $02e84f2cdf379c8d$var$load("36yXL").then(()=>parcelRequire('cIa6C'));

});

parcelRegister("4pFQf", function(module, exports) {

let $3369f41a173f2fd0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3369f41a173f2fd0$var$load("6m2IY").then(()=>parcelRequire('9j8gc'));

});

parcelRegister("lq0RK", function(module, exports) {

let $f97cb2a2a43f3cef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f97cb2a2a43f3cef$var$load("i9MSA").then(()=>parcelRequire('gOaOa'));

});

parcelRegister("gdfv9", function(module, exports) {

let $bcd9e285e2e56d29$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bcd9e285e2e56d29$var$load("3XXkw").then(()=>parcelRequire('6BPzb'));

});

parcelRegister("ifomm", function(module, exports) {

let $d48c8607bcaac3f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d48c8607bcaac3f1$var$load("hG9vb").then(()=>parcelRequire('9jlHa'));

});

parcelRegister("d8v7l", function(module, exports) {

let $99042903774c77be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $99042903774c77be$var$load("dk61q").then(()=>parcelRequire('atTXx'));

});

parcelRegister("8fuUJ", function(module, exports) {

let $6017b4547a072c86$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6017b4547a072c86$var$load("zlHdL").then(()=>parcelRequire('lFe4L'));

});

parcelRegister("8aMn9", function(module, exports) {

let $5f34c7ada698ea56$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5f34c7ada698ea56$var$load("iIy5h").then(()=>parcelRequire('59zua'));

});

parcelRegister("8TCeu", function(module, exports) {

let $67a11e01de61ad76$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $67a11e01de61ad76$var$load("1BGiy").then(()=>parcelRequire('abAFo'));

});

parcelRegister("iV0ke", function(module, exports) {

let $dc5dcd74cdfa8c63$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dc5dcd74cdfa8c63$var$load("iU68J").then(()=>parcelRequire('99y2W'));

});

parcelRegister("eKgSp", function(module, exports) {
module.exports = JSON.parse("{\"INAPP-2055.spotlight.body\":[{\"type\":0,\"value\":\"Draggable tags help you create well-defined alerts and manage them with ease. All you have to do is drag-and-drop the tags into any alert property field as needed\"}],\"INAPP-2055.spotlight.primary\":[{\"type\":0,\"value\":\"Learn more\"}],\"INAPP-2055.spotlight.secondary\":[{\"type\":0,\"value\":\"OK\"}],\"INAPP-2055.spotlight.title\":[{\"type\":0,\"value\":\"Create rich and informative alerts\"}],\"INAPP-3273.spotlight.body\":[{\"type\":0,\"value\":\"Triage and resolve alerts faster by using Atlassian Intelligence to access similar alerts.\"}],\"INAPP-3273.spotlight.primary\":[{\"type\":0,\"value\":\"OK\"}],\"INAPP-3273.spotlight.title\":[{\"type\":0,\"value\":\"Drive faster alert resolution with Atlassian Intelligence\"}],\"aiops-grogu.rovo-ops-cta-spotlight.body\":[{\"type\":0,\"value\":\"Investigate and compare alerts, and find related resources to resolve faster.\"}],\"aiops-grogu.rovo-ops-cta-spotlight.done\":[{\"type\":0,\"value\":\"Ok\"}],\"aiops-grogu.rovo-ops-cta-spotlight.heading\":[{\"type\":0,\"value\":\"Triage alerts with Rovo Ops\"}],\"jira-ops-group-customisation.spotlight.body\":[{\"type\":0,\"value\":\"Your team's alerts are grouped based on the similarity of alert titles, descriptions, tags and so on within a specific time window. If you want more control, you can fine-tune how alerts are grouped. Only team admins, Ops admins, or Jira admins can change these settings.\"}],\"jira-ops-group-customisation.spotlight.primary\":[{\"type\":0,\"value\":\"OK\"}],\"jira-ops-group-customisation.spotlight.title\":[{\"type\":0,\"value\":\"Configure alert groups\"}],\"jira-ops-unified-view-revamp.grouped-alerts.spotlight.body\":[{\"type\":0,\"value\":\"Expand to quickly view all alerts in the group.\"}],\"jira-ops-unified-view-revamp.grouped-alerts.spotlight.title\":[{\"type\":0,\"value\":\"View grouped alerts\"}],\"jira-ops-unified-view-revamp.snr-header.spotlight.body\":[{\"type\":0,\"value\":\"Rovo helps you classify your alerts as signal or noise so you can focus on what matters most.\"}],\"jira-ops-unified-view-revamp.snr-header.spotlight.title\":[{\"type\":0,\"value\":\"Triage alerts faster\"}],\"jira-ops-unified-view-revamp.spotlight.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"jira-ops-unified-view-revamp.spotlight.go-back\":[{\"type\":0,\"value\":\"Go back\"}],\"jira-ops-unified-view-revamp.spotlight.next\":[{\"type\":0,\"value\":\"Next\"}],\"jira-ops-unified-view-revamp.spotlight.ok\":[{\"type\":0,\"value\":\"OK\"}]}");

});

parcelRegister("429nu", function(module, exports) {

let $2efe9f9863f50a21$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2efe9f9863f50a21$var$load("3M52M").then(()=>parcelRequire('iHSlK'));

});

parcelRegister("lkJRX", function(module, exports) {

let $f87f0be67a438bd0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f87f0be67a438bd0$var$load("hXzW4").then(()=>parcelRequire('jBawD'));

});

parcelRegister("lTmRO", function(module, exports) {

let $ff0078efe4272a3b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ff0078efe4272a3b$var$load("6H6xO").then(()=>parcelRequire('cChcG'));

});

parcelRegister("kVSfW", function(module, exports) {

let $f3d337a45540f2df$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f3d337a45540f2df$var$load("dKUKe").then(()=>parcelRequire('fKoq1'));

});

parcelRegister("lga3Q", function(module, exports) {

let $f7a2e5841688e740$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f7a2e5841688e740$var$load("3P4OX").then(()=>parcelRequire('4FqPu'));

});

parcelRegister("4lqx1", function(module, exports) {

let $329db4356c1723f6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $329db4356c1723f6$var$load("fXZcJ").then(()=>parcelRequire('8R6aY'));

});

parcelRegister("8ESoT", function(module, exports) {

let $64dc41f1b18baa96$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $64dc41f1b18baa96$var$load("bfegz").then(()=>parcelRequire('jnv4H'));

});

parcelRegister("gWvPm", function(module, exports) {

let $c55ac06017699058$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c55ac06017699058$var$load("6llrY").then(()=>parcelRequire('3MFZ2'));

});

parcelRegister("9A72q", function(module, exports) {

let $6f9cef7be8961bff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6f9cef7be8961bff$var$load("idtF6").then(()=>parcelRequire('61pnU'));

});

parcelRegister("gx1CC", function(module, exports) {

let $c090fc7ffb3b343c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c090fc7ffb3b343c$var$load("uBxej").then(()=>parcelRequire('aHRnk'));

});

parcelRegister("bBCYv", function(module, exports) {

let $873162058cd85fdc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $873162058cd85fdc$var$load("jka8i").then(()=>parcelRequire('ly8Do'));

});

parcelRegister("8CdyV", function(module, exports) {

let $645c648e46057318$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $645c648e46057318$var$load("gSlAj").then(()=>parcelRequire('9cEBf'));

});

parcelRegister("dMuHY", function(module, exports) {

let $a08794167812bab1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a08794167812bab1$var$load("hBjFq").then(()=>parcelRequire('l8lqB'));

});

parcelRegister("kMCDP", function(module, exports) {

let $f21643b6d3c5d153$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f21643b6d3c5d153$var$load("4sGH7").then(()=>parcelRequire('duoyh'));

});

parcelRegister("dWA2c", function(module, exports) {

let $a26ca4d6572daaa3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a26ca4d6572daaa3$var$load("eCtPz").then(()=>parcelRequire('fmv6i'));

});

parcelRegister("izvSu", function(module, exports) {

let $d854392254bb19a6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d854392254bb19a6$var$load("eGaEl").then(()=>parcelRequire('46zrQ'));

});

parcelRegister("7Lxrh", function(module, exports) {

let $5a76dc7a2b7adb8a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a76dc7a2b7adb8a$var$load("2rPrN").then(()=>parcelRequire('4qpjD'));

});

parcelRegister("jdwgw", function(module, exports) {

let $dfd84277ded5e2f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dfd84277ded5e2f1$var$load("4knbp").then(()=>parcelRequire('kQV6d'));

});

parcelRegister("cHuDH", function(module, exports) {

let $93f14481d36e17c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $93f14481d36e17c9$var$load("22kOQ").then(()=>parcelRequire('5QxPW'));

});

parcelRegister("keqsm", function(module, exports) {

let $eba9a3236d207650$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eba9a3236d207650$var$load("3PcMr").then(()=>parcelRequire('7zAJE'));

});

parcelRegister("bKddi", function(module, exports) {

let $88ce3d8319dbcafa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $88ce3d8319dbcafa$var$load("hH5L8").then(()=>parcelRequire('22kSN'));

});

parcelRegister("eZBaS", function(module, exports) {

let $aea3993f11ad2ea1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aea3993f11ad2ea1$var$load("bKq5Y").then(()=>parcelRequire('50qNL'));

});

parcelRegister("d2EqJ", function(module, exports) {

let $97ead2dbaaf214dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $97ead2dbaaf214dd$var$load("l8yhk").then(()=>parcelRequire('83VkF'));

});

parcelRegister("8yPmT", function(module, exports) {

let $63b9585c952b3222$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $63b9585c952b3222$var$load("1vfKI").then(()=>parcelRequire('MSpSB'));

});

parcelRegister("lkxV9", function(module, exports) {

let $f875c72b88ab1569$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f875c72b88ab1569$var$load("hZ9Wf").then(()=>parcelRequire('1Wcz9'));

});

parcelRegister("lLCIC", function(module, exports) {

let $fd8c057d7d457d3b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fd8c057d7d457d3b$var$load("3e714").then(()=>parcelRequire('6pVZj'));

});

parcelRegister("lkqfj", function(module, exports) {

let $f86fd3288521d12c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f86fd3288521d12c$var$load("fnfyQ").then(()=>parcelRequire('j28kp'));

});

parcelRegister("efFK4", function(module, exports) {

let $a602d87e55f80afa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a602d87e55f80afa$var$load("5Y0la").then(()=>parcelRequire('98Yey'));

});

parcelRegister("krC0o", function(module, exports) {

let $ee23cf55524a009a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ee23cf55524a009a$var$load("cyzjl").then(()=>parcelRequire('4RJAV'));

});

parcelRegister("9muly", function(module, exports) {

let $6d0db55321ff106f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6d0db55321ff106f$var$load("kFz1Z").then(()=>parcelRequire('b2bZn'));

});

parcelRegister("apk7s", function(module, exports) {

let $793bd8716e096495$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $793bd8716e096495$var$load("ekw2t").then(()=>parcelRequire('ldfgH'));

});

parcelRegister("fDi4x", function(module, exports) {

let $b618844b90eaf60a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b618844b90eaf60a$var$load("ggmz8").then(()=>parcelRequire('6NTOJ'));

});

parcelRegister("gpcYc", function(module, exports) {

let $bf190ab3b2febcae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bf190ab3b2febcae$var$load("j2KAJ").then(()=>parcelRequire('i2frm'));

});

parcelRegister("ib4T9", function(module, exports) {

let $d3bd0bd71f6a9214$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d3bd0bd71f6a9214$var$load("lrlVs").then(()=>parcelRequire('9bVII'));

});

parcelRegister("lzOvC", function(module, exports) {
module.exports = JSON.parse('{"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.benefits.admin-key":[{"children":[{"type":0,"value":"Admin key"}],"type":8,"value":"b"},{"type":0,"value":": Access restricted content so you can fix issues"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.benefits.advanced-insights":[{"children":[{"type":0,"value":"Advanced insights"}],"type":8,"value":"b"},{"type":0,"value":": Audit and track all admin activity"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.benefits.support":[{"children":[{"type":0,"value":"24/7 support"}],"type":8,"value":"b"},{"type":0,"value":": Dedicated support team for critical issues"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.description":[{"type":1,"value":"firstName"},{"type":0,"value":" wants to try the \'Mission Control\' feature on the Premium plan. This will give them a dashboard to easily see activity across spaces."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.no-name.description":[{"type":0,"value":"Someone on your team has requested to try the \'Mission Control\' feature on the Confluence Premium plan. This will give them a dashboard to easily see activity across spaces."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try \'Mission Control\'"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.no-name.title":[{"type":0,"value":"Help your team do more and worry less"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"firstName"},{"type":0,"value":" wants to try \'Mission Control\'"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.title":[{"type":0,"value":"Help "},{"type":1,"value":"firstName"},{"type":0,"value":" stay across team activity"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-features-title":[{"type":0,"value":"You also get more admin features"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.description":[{"type":1,"value":"firstName"},{"type":0,"value":" wants to try advanced page elements on the Premium plan. This will give your team the tools to create richer content."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.no-name.description":[{"type":0,"value":"Someone on your team wants to try advanced page elements on the Premium plan. This will give your team the tools to create richer content."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try advanced page elements"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.no-name.title":[{"type":0,"value":"Help your team create engaging content"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"firstName"},{"type":0,"value":" wants to try advanced page elements"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.title":[{"type":0,"value":"Help "},{"type":1,"value":"firstName"},{"type":0,"value":" create engaging content"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.description":[{"type":1,"value":"firstName"},{"type":0,"value":" wants to try the advanced permissions features on the Premium plan. This will let them easily troubleshoot access issues and copy settings to new spaces."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.no-name.description":[{"type":0,"value":"Someone on your team wants to try the advanced permissions features on the Premium plan. This will let them easily troubleshoot access issues and copy settings to new spaces."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try advanced permissions features"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.no-name.title":[{"type":0,"value":"Help your team manage access better"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"firstName"},{"type":0,"value":" wants to try advanced permissions features"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.title":[{"type":0,"value":"Help "},{"type":1,"value":"firstName"},{"type":0,"value":" manage access better"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.description":[{"type":1,"value":"firstName"},{"type":0,"value":" wants to try the \'Company Hub\' feature on the Premium plan. This will let them create a central place for updates and key resources."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.no-name.description":[{"type":0,"value":"Someone on your team wants to try the \u2018Company Hub\u2019 feature on the Premium plan. This will let them create a central place for updates and key resources."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try \'Company Hub\'"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.no-name.title":[{"type":0,"value":"Give your team one place to share updates"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"firstName"},{"type":0,"value":" wants to try \'Company Hub\'"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.title":[{"type":0,"value":"Give "},{"type":1,"value":"firstName"},{"type":0,"value":" one place to share updates"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.description":[{"type":1,"value":"firstName"},{"type":0,"value":" wants to try the \'Content manager\' feature on the Premium plan. This will make it easy for them to bulk manage content across spaces."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.no-name.description":[{"type":0,"value":"Someone on your team wants to try the \u2018Content Manager\u2019 feature on the Premium plan. This will make it easy for them to bulk manage content across spaces."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try \'Content manager\'"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.no-name.title":[{"type":0,"value":"Help your team keep spaces organised"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"firstName"},{"type":0,"value":" wants to try \'Content manager\'"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.title":[{"type":0,"value":"Help "},{"type":1,"value":"firstName"},{"type":0,"value":" keep spaces organised"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.body-description":[{"children":[{"type":0,"value":"Let "},{"type":1,"value":"firstName"},{"type":0,"value":" try on a free, "},{"type":1,"value":"trialLengthDays"},{"type":0,"value":"-day trial."}],"type":8,"value":"b"},{"type":1,"value":"br"},{"type":1,"value":"br"},{"type":0,"value":"Cancel anytime. We\'ll remind you "},{"type":1,"value":"reminderDays"},{"type":0,"value":" days before your trial ends."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.description":[{"type":1,"value":"firstName"},{"type":0,"value":" has requested to try features on the Confluence Premium plan."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.no-name.body-description":[{"children":[{"type":0,"value":"Let your team member try on a free, "},{"type":1,"value":"trialLengthDays"},{"type":0,"value":"-day trial."}],"type":8,"value":"b"},{"type":1,"value":"br"},{"type":1,"value":"br"},{"type":0,"value":"Cancel anytime. We\'ll remind you "},{"type":1,"value":"reminderDays"},{"type":0,"value":" days before your trial ends."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.no-name.description":[{"type":0,"value":"Someone on your team has requested to try features on the Confluence Premium plan."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try new features"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.no-name.title":[{"type":0,"value":"Unlock more insights, clarity, and speed for your team"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"firstName"},{"type":0,"value":" wants to try new features"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.title":[{"type":0,"value":"Unlock more insights, clarity, and speed for "},{"type":1,"value":"firstName"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.explore-all-features":[{"type":0,"value":"Explore all features \u2192"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.get-started-button":[{"type":0,"value":"Get Started"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.img.alt":[{"type":0,"value":"Confluence logo"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.learn-more":[{"type":0,"value":"Learn more"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.description":[{"type":1,"value":"firstName"},{"type":0,"value":" wants to try advanced whiteboard features on the Premium plan. This will let them create unlimited whiteboards and use smart integrations."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.no-name.description":[{"type":0,"value":"Someone on your team wants to try advanced whiteboard features on the Premium plan. This will let them create unlimited whiteboards and use smart integrations."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try advanced whiteboard features"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.no-name.title":[{"type":0,"value":"Boost your team\'s collaboration"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"firstName"},{"type":0,"value":" wants to try advanced whiteboard features"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.title":[{"type":0,"value":"Boost "},{"type":1,"value":"firstName"},{"type":0,"value":"\'s team collaboration"}],"growth-luna.jira-pre-dunning-confirm-plan-modal.screen-space-flags.description.no-translate":[{"type":0,"value":"TWCG-2131 content will be added here."}],"growth-luna.jira-pre-dunning-confirm-plan-modal.screen-space-flags.title.no-translate":[{"type":0,"value":"Confirm plan modal placeholder"}],"growth-luna.jira-twcg-810-upgrade-free.action.primary.pde":[{"type":0,"value":"Try it free"}],"growth-luna.jira-twcg-810-upgrade-free.modal.automations.body":[{"type":0,"value":"Your team has already used half your free automation runs. Try a higher limit free for "},{"type":1,"value":"trialLength"},{"type":0,"value":" days with "},{"options":{"other":{"value":[{"type":0,"value":"Standard"}]},"premium":{"value":[{"type":0,"value":"Premium"}]},"standard":{"value":[{"type":0,"value":"Standard"}]}},"type":5,"value":"edition"},{"type":0,"value":"."}],"growth-luna.jira-twcg-810-upgrade-free.modal.automations.feature.limit":[{"type":0,"value":"Increase your limit to 1,700 monthly runs"}],"growth-luna.jira-twcg-810-upgrade-free.modal.automations.feature.rovo":[{"type":0,"value":"Create new automations fast with Rovo AI"}],"growth-luna.jira-twcg-810-upgrade-free.modal.automations.feature.workflows":[{"type":0,"value":"Keep workflows moving and avoid interruptions"}],"growth-luna.jira-twcg-810-upgrade-free.modal.automations.heading":[{"type":0,"value":"Keep your "},{"type":1,"value":"count"},{"type":0,"value":" rules running"}],"growth-luna.jira-twcg-810-upgrade-free.modal.plans.body":[{"type":0,"value":"See progress across your team\'s work in one view. Try Plans free for "},{"type":1,"value":"trialLength"},{"type":0,"value":" days with "},{"options":{"other":{"value":[{"type":0,"value":"Standard"}]},"premium":{"value":[{"type":0,"value":"Premium"}]},"standard":{"value":[{"type":0,"value":"Standard"}]}},"type":5,"value":"edition"},{"type":0,"value":"."}],"growth-luna.jira-twcg-810-upgrade-free.modal.plans.feature.blockers":[{"type":0,"value":"Spot blockers early and keep things moving"}],"growth-luna.jira-twcg-810-upgrade-free.modal.plans.feature.goals":[{"type":0,"value":"Help your team hit goals together"}],"growth-luna.jira-twcg-810-upgrade-free.modal.plans.feature.timelines":[{"type":0,"value":"Create one view of all your team\'s timelines"}],"growth-luna.jira-twcg-810-upgrade-free.modal.plans.heading":[{"type":0,"value":"Keep your "},{"type":1,"value":"count"},{"type":0,"value":" projects on track"}],"growth-luna.jira-twcg-810-upgrade-free.modal.rovo.body":[{"type":0,"value":"Help your team move work in progress faster. Try Rovo AI free for "},{"type":1,"value":"trialLength"},{"type":0,"value":" days with "},{"options":{"other":{"value":[{"type":0,"value":"Standard"}]},"premium":{"value":[{"type":0,"value":"Premium"}]},"standard":{"value":[{"type":0,"value":"Standard"}]}},"type":5,"value":"edition"},{"type":0,"value":"."}],"growth-luna.jira-twcg-810-upgrade-free.modal.rovo.feature.connect":[{"type":0,"value":"Connect related and duplicate tasks automatically"}],"growth-luna.jira-twcg-810-upgrade-free.modal.rovo.feature.next-steps":[{"type":0,"value":"Turn big work into clearer next steps"}],"growth-luna.jira-twcg-810-upgrade-free.modal.rovo.feature.summaries":[{"type":0,"value":"Get instant summaries of what\'s happening"}],"growth-luna.jira-twcg-810-upgrade-free.modal.rovo.heading":[{"offset":0,"options":{"=0":{"value":[{"type":0,"value":"Stay across your team\'s tasks"}]},"one":{"value":[{"type":0,"value":"Stay across your team\'s "},{"type":7},{"type":0,"value":" task"}]},"other":{"value":[{"type":0,"value":"Stay across your team\'s "},{"type":7},{"type":0,"value":" tasks"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"growth-luna.jira-twcg-810-upgrade-free.placement.banner.automations.cta":[{"type":0,"value":"Get more runs"}],"growth-luna.jira-twcg-810-upgrade-free.placement.banner.automations.title":[{"type":0,"value":"Keep your "},{"type":1,"value":"count"},{"type":0,"value":" rules running"}],"growth-luna.jira-twcg-810-upgrade-free.placement.banner.plans.cta":[{"type":0,"value":"Try Plans"}],"growth-luna.jira-twcg-810-upgrade-free.placement.banner.plans.title":[{"type":0,"value":"Keep your "},{"type":1,"value":"count"},{"type":0,"value":" projects on track"}],"growth-luna.jira-twcg-810-upgrade-free.placement.banner.rovo.cta":[{"type":0,"value":"Try Rovo"}],"growth-luna.jira-twcg-810-upgrade-free.placement.banner.rovo.title":[{"offset":0,"options":{"=0":{"value":[{"type":0,"value":"Stay across your team\'s tasks"}]},"one":{"value":[{"type":0,"value":"Stay across your team\'s "},{"type":7},{"type":0,"value":" task"}]},"other":{"value":[{"type":0,"value":"Stay across your team\'s "},{"type":7},{"type":0,"value":" tasks"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"post-office.ep-migration-inapp-715.body":[{"type":0,"value":"Get Confluence Premium to ship projects faster with advanced admin controls and analytics."}],"post-office.ep-migration-inapp-715.change-plans-button":[{"type":0,"value":"Change plans"}],"post-office.ep-migration-inapp-715.image-alt":[{"type":0,"value":"Confluence Premium illustration"}],"post-office.ep-migration-inapp-715.not-now-button":[{"type":0,"value":"Not now"}],"post-office.ep-migration-inapp-715.title":[{"type":0,"value":"Grow more agile"}],"post-office.jira-exp-banner.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}],"post-office.jira-standard-automation-limit-awareness-banner.close":[{"type":0,"value":"Close"}],"post-office.jira-standard-automation-limit-awareness-banner.message":[{"type":0,"value":"You\'re nearing or at your monthly automation run limit. Automations will fail to run this month if you hit the limit."}]}');

});

parcelRegister("62vgI", function(module, exports) {

let $465b2f4c3aa5215a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $465b2f4c3aa5215a$var$load("dhGnB").then(()=>parcelRequire('47Fb9'));

});

parcelRegister("gPR4R", function(module, exports) {

let $c41a94d8467b2839$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c41a94d8467b2839$var$load("3OExY").then(()=>parcelRequire('44D6H'));

});

parcelRegister("5g3kR", function(module, exports) {

let $3d4108b3f44cc888$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3d4108b3f44cc888$var$load("31iqC").then(()=>parcelRequire('k0a53'));

});

parcelRegister("c1drX", function(module, exports) {

let $8c0002ee132070f8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8c0002ee132070f8$var$load("4OTW1").then(()=>parcelRequire('dsAfZ'));

});

parcelRegister("Sjgmg", function(module, exports) {

let $0a33fc7581ece655$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0a33fc7581ece655$var$load("QY9sf").then(()=>parcelRequire('6n86q'));

});

parcelRegister("6MB91", function(module, exports) {

let $4f0409e9dd16805a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4f0409e9dd16805a$var$load("bXVWk").then(()=>parcelRequire('a8lFX'));

});

parcelRegister("2oCab", function(module, exports) {

let $1beb6d1960bcf963$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1beb6d1960bcf963$var$load("baM9Z").then(()=>parcelRequire('gTJRz'));

});

parcelRegister("hzd9l", function(module, exports) {

let $cc9fe7d2b58a3eca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cc9fe7d2b58a3eca$var$load("hB3Eu").then(()=>parcelRequire('360nH'));

});

parcelRegister("3t2D5", function(module, exports) {

let $28661ea8537591d5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $28661ea8537591d5$var$load("2js81").then(()=>parcelRequire('b51St'));

});

parcelRegister("2pKAa", function(module, exports) {

let $1c220cdf4ede1533$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1c220cdf4ede1533$var$load("ACr5m").then(()=>parcelRequire('8DWFf'));

});

parcelRegister("45Usu", function(module, exports) {

let $2fb36c847fc7e7f6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2fb36c847fc7e7f6$var$load("aWQdo").then(()=>parcelRequire('iXhoH'));

});

parcelRegister("bHjty", function(module, exports) {

let $8842d14daf0976d5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8842d14daf0976d5$var$load("3FDv8").then(()=>parcelRequire('cZcdH'));

});

parcelRegister("alPmq", function(module, exports) {

let $7893b4b7005f1459$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7893b4b7005f1459$var$load("aZseA").then(()=>parcelRequire('1IPyy'));

});

parcelRegister("4M6FR", function(module, exports) {

let $37a0d2785aca0bf4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $37a0d2785aca0bf4$var$load("3BLof").then(()=>parcelRequire('bzGOQ'));

});

parcelRegister("iyYoP", function(module, exports) {

let $d83a410795af93c5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d83a410795af93c5$var$load("9T5k3").then(()=>parcelRequire('jHe08'));

});

parcelRegister("kZwkd", function(module, exports) {

let $f482943e16809e45$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f482943e16809e45$var$load("iHntS").then(()=>parcelRequire('86YTx'));

});

parcelRegister("dHoaX", function(module, exports) {

let $9f920b4a38316150$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9f920b4a38316150$var$load("5IV2y").then(()=>parcelRequire('7oxlX'));

});

parcelRegister("3raFD", function(module, exports) {

let $280c2babbae73b6f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $280c2babbae73b6f$var$load("aDY98").then(()=>parcelRequire('4XYeE'));

});

parcelRegister("exitT", function(module, exports) {

let $a9527bb6ff1e34f9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a9527bb6ff1e34f9$var$load("fnJtc").then(()=>parcelRequire('71iMm'));

});

parcelRegister("bVXPj", function(module, exports) {

let $8b036ce1026eb32f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8b036ce1026eb32f$var$load("8fU5H").then(()=>parcelRequire('84nhu'));

});

parcelRegister("c0zow", function(module, exports) {

let $8be0f0ba3eaaed72$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8be0f0ba3eaaed72$var$load("eaREO").then(()=>parcelRequire('5Ya9l'));

});

parcelRegister("jZhFg", function(module, exports) {

let $e8d16aa5df2675b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e8d16aa5df2675b7$var$load("eyFqR").then(()=>parcelRequire('7fBLo'));

});

parcelRegister("fV7bw", function(module, exports) {

let $b971c09ed50e2cb1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b971c09ed50e2cb1$var$load("1ToNc").then(()=>parcelRequire('a9DA3'));

});

parcelRegister("fPID5", function(module, exports) {

let $b86e3ceee7586d9b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b86e3ceee7586d9b$var$load("hswX7").then(()=>parcelRequire('2JDGU'));

});

parcelRegister("fYROS", function(module, exports) {

let $ba26350a0cc70f04$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ba26350a0cc70f04$var$load("fGPFy").then(()=>parcelRequire('5amq3'));

});

parcelRegister("eRbae", function(module, exports) {

let $ad0eacd9d567f52c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ad0eacd9d567f52c$var$load("59eoJ").then(()=>parcelRequire('5eHYY'));

});

parcelRegister("15Kks", function(module, exports) {

let $0cba32073cf7b239$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0cba32073cf7b239$var$load("9BDcp").then(()=>parcelRequire('2yxbz'));

});

parcelRegister("6vg3U", function(module, exports) {

let $4bc218e90a077ffc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4bc218e90a077ffc$var$load("2U4Fl").then(()=>parcelRequire('jhjyP'));

});

parcelRegister("lrnaw", function(module, exports) {

let $f9be176a02934af1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f9be176a02934af1$var$load("7Qlxf").then(()=>parcelRequire('gqMfj'));

});

parcelRegister("9LzqH", function(module, exports) {

let $71c3fc6fa20599b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $71c3fc6fa20599b8$var$load("8JsK3").then(()=>parcelRequire('elZZU'));

});

parcelRegister("jbbJk", function(module, exports) {

let $df6824bb4278365f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $df6824bb4278365f$var$load("40Noq").then(()=>parcelRequire('cWUx5'));

});

parcelRegister("jZeNQ", function(module, exports) {

let $e8cf32623222e075$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e8cf32623222e075$var$load("1SmLA").then(()=>parcelRequire('lkzxj'));

});

parcelRegister("jQ2cU", function(module, exports) {

let $03ba2373755b0249$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $03ba2373755b0249$var$load("a1jbE").then(()=>parcelRequire('1DOrr'));

});

parcelRegister("4HVs6", function(module, exports) {

let $36d7be6b3bd3351a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $36d7be6b3bd3351a$var$load("ijSqD").then(()=>parcelRequire('1IyNH'));

});

parcelRegister("2Zd3Q", function(module, exports) {
module.exports = JSON.parse("{\"post-office.aurum.jira-assets-schemas-display-name.body\":[{\"type\":0,\"value\":\"Clarify and localise entities without breaking AQL or integrations.\"}],\"post-office.aurum.jira-assets-schemas-display-name.headline\":[{\"type\":0,\"value\":\"Display names are here\"}],\"post-office.aurum.jira-assets-schemas-display-name.primary-action\":[{\"type\":0,\"value\":\"Learn more\"}]}");

});

parcelRegister("iUZnC", function(module, exports) {

let $dc5d11c24757e6f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dc5d11c24757e6f1$var$load("6pCBB").then(()=>parcelRequire('dyiz8'));

});

parcelRegister("9N4Up", function(module, exports) {

let $720c7f6eedf66d2c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $720c7f6eedf66d2c$var$load("kVn0V").then(()=>parcelRequire('4Gx21'));

});

parcelRegister("1n5UH", function(module, exports) {

let $0ffc86be333e2614$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0ffc86be333e2614$var$load("5DQ1z").then(()=>parcelRequire('jq72x'));

});

parcelRegister("g6ptF", function(module, exports) {

let $bb90f82aff2e8c48$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bb90f82aff2e8c48$var$load("LDejH").then(()=>parcelRequire('4kqQW'));

});

parcelRegister("7wcyl", function(module, exports) {

let $5795424cbbaef507$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5795424cbbaef507$var$load("2uDQw").then(()=>parcelRequire('5TQHI'));

});

parcelRegister("gRTcM", function(module, exports) {

let $c47c6b2bae4d8e30$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c47c6b2bae4d8e30$var$load("5nuqb").then(()=>parcelRequire('imuHq'));

});

parcelRegister("hKBiq", function(module, exports) {

let $cec3a9c98d8bab8b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cec3a9c98d8bab8b$var$load("kH60N").then(()=>parcelRequire('20dtZ'));

});

parcelRegister("3Rtoa", function(module, exports) {

let $2cfd1e542797205b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2cfd1e542797205b$var$load("4xb4h").then(()=>parcelRequire('lcD9q'));

});

parcelRegister("l7W0z", function(module, exports) {

let $f6173fa1702103be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f6173fa1702103be$var$load("aaCvY").then(()=>parcelRequire('k9wsA'));

});

parcelRegister("cbXiM", function(module, exports) {

let $8e048338f2087a5e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8e048338f2087a5e$var$load("kBHDQ").then(()=>parcelRequire('hPeXS'));

});

parcelRegister("sUJqP", function(module, exports) {

let $056e9f6342f2efa5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $056e9f6342f2efa5$var$load("gLIUa").then(()=>parcelRequire('1Njen'));

});

parcelRegister("lzFjf", function(module, exports) {

let $fb4ce911992a60b9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fb4ce911992a60b9$var$load("4gt8Y").then(()=>parcelRequire('6K5q2'));

});

parcelRegister("99T91", function(module, exports) {

let $6aafbad93d1d7ee1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6aafbad93d1d7ee1$var$load("aJxF6").then(()=>parcelRequire('fg1MZ'));

});

parcelRegister("9M8yL", function(module, exports) {

let $71df3c82ca7ae347$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $71df3c82ca7ae347$var$load("hvMwI").then(()=>parcelRequire('b6zgf'));

});

parcelRegister("bKsZA", function(module, exports) {

let $88da7ad85add128c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $88da7ad85add128c$var$load("1fYNS").then(()=>parcelRequire('hKBbO'));

});

parcelRegister("4VyCo", function(module, exports) {

let $396756bec475bba7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $396756bec475bba7$var$load("8zAtc").then(()=>parcelRequire('iq87w'));

});

parcelRegister("2QyXe", function(module, exports) {

let $212b8d4dd19af914$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $212b8d4dd19af914$var$load("iRSNZ").then(()=>parcelRequire('i8DbP'));

});

parcelRegister("lKFwf", function(module, exports) {

let $fd5e19b0e605c528$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fd5e19b0e605c528$var$load("7S3EG").then(()=>parcelRequire('fv9M0'));

});

parcelRegister("k14ay", function(module, exports) {

let $e927228db1153861$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e927228db1153861$var$load("bF9pH").then(()=>parcelRequire('hjyq5'));

});

parcelRegister("clUv1", function(module, exports) {

let $8fe345c72b06ee67$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8fe345c72b06ee67$var$load("3RZXT").then(()=>parcelRequire('5vDId'));

});

parcelRegister("btmDe", function(module, exports) {

let $85a3f55336e9f153$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $85a3f55336e9f153$var$load("brigs").then(()=>parcelRequire('IMFGA'));

});

parcelRegister("byka9", function(module, exports) {

let $86928298bb1b8c7f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $86928298bb1b8c7f$var$load("1nFCT").then(()=>parcelRequire('dVXVf'));

});

parcelRegister("5ydME", function(module, exports) {

let $40aad1e0ae837d96$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $40aad1e0ae837d96$var$load("cXEr9").then(()=>parcelRequire('a1VQu'));

});

parcelRegister("gGpon", function(module, exports) {

let $c25443f66bfda50e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c25443f66bfda50e$var$load("6uR2i").then(()=>parcelRequire('h5Hfe'));

});

parcelRegister("9eo1c", function(module, exports) {

let $6b880d68a5084e6d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b880d68a5084e6d$var$load("uZppM").then(()=>parcelRequire('eClAU'));

});

parcelRegister("jKqGZ", function(module, exports) {

let $e60704bcd3eb4d55$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e60704bcd3eb4d55$var$load("fUm6j").then(()=>parcelRequire('d13oO'));

});

parcelRegister("aK5dI", function(module, exports) {

let $7d223fe91e100691$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7d223fe91e100691$var$load("9bw2v").then(()=>parcelRequire('alwPS'));

});

parcelRegister("l7CJr", function(module, exports) {

let $f6084bc28f627a3a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f6084bc28f627a3a$var$load("e9YoG").then(()=>parcelRequire('leXh7'));

});

parcelRegister("bODaF", function(module, exports) {

let $89a2bfc5e5cd68c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $89a2bfc5e5cd68c9$var$load("gAnNF").then(()=>parcelRequire('goKXq'));

});

parcelRegister("kZji1", function(module, exports) {

let $f47877af894602af$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f47877af894602af$var$load("eLnML").then(()=>parcelRequire('aoLOs'));

});

parcelRegister("1CKFL", function(module, exports) {

let $12ed8b42f2d94c81$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $12ed8b42f2d94c81$var$load("bpyl4").then(()=>parcelRequire('3Bdfh'));

});

parcelRegister("bEOB5", function(module, exports) {

let $87caadb071390041$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $87caadb071390041$var$load("22cfO").then(()=>parcelRequire('d1WRJ'));

});

parcelRegister("kKovn", function(module, exports) {

let $f1ab1cb6425fd314$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f1ab1cb6425fd314$var$load("ag6no").then(()=>parcelRequire('abRm9'));

});

parcelRegister("3LkYB", function(module, exports) {

let $2bd6085f5861d79f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2bd6085f5861d79f$var$load("g0rrw").then(()=>parcelRequire('9rxg1'));

});

parcelRegister("5LXn7", function(module, exports) {
module.exports = JSON.parse('{"jira-business-saved-views.admin.changeboarding.spotlight.body":[{"type":0,"value":"Saved views are now in timeline view.\\n\\nSave your view for everyone in the project or reset it back to your previous saved view."}],"jira-business-saved-views.admin.changeboarding.spotlight.headline":[{"type":0,"value":"Save and reset your timeline view"}],"jira-business-saved-views.admin.changeboarding.spotlight.primary-action":[{"type":0,"value":"OK"}],"jira-business-saved-views.admin.changeboarding.spotlight.secondary-action":[{"type":0,"value":"More about saved views"}],"jira-business-saved-views.changeboarding.spotlight.body":[{"type":0,"value":"Saved views are now in timeline view. Your admin set up a view to help make collaboration easier.\\n\\nYou can make changes to your view or reset to the admin\'s view anytime."}],"jira-business-saved-views.changeboarding.spotlight.headline":[{"type":0,"value":"Reset your view"}],"jira-business-saved-views.changeboarding.spotlight.primary-action":[{"type":0,"value":"OK"}],"jira-business-saved-views.changeboarding.spotlight.secondary-action":[{"type":0,"value":"More about saved views"}],"jira-filter-refinement-standalone-release-changeboarding.tour.addFieldsBody":[{"type":0,"value":"Add the fields you need and remove the fields you don\u2019t."}],"jira-filter-refinement-standalone-release-changeboarding.tour.addFieldsHeadline":[{"type":0,"value":"Add and remove fields"}],"jira-filter-refinement-standalone-release-changeboarding.tour.backButton":[{"type":0,"value":"Back"}],"jira-filter-refinement-standalone-release-changeboarding.tour.doneButton":[{"type":0,"value":"Done"}],"jira-filter-refinement-standalone-release-changeboarding.tour.filterHomeBody":[{"type":0,"value":"More fields and more ways to surface the information that is important to you."}],"jira-filter-refinement-standalone-release-changeboarding.tour.filterHomeHeadline":[{"type":0,"value":"A new home for filters"}],"jira-filter-refinement-standalone-release-changeboarding.tour.nextButton":[{"type":0,"value":"Next"}],"jira-filter-refinement-standalone-release-changeboarding.tour.reorderPinFieldsBody":[{"type":0,"value":"Reorder and pin fields to prioritize what matters most to you."}],"jira-filter-refinement-standalone-release-changeboarding.tour.reorderPinFieldsHeadline":[{"type":0,"value":"Reorder and pin fields"}],"jira-filter-refinement-standalone-release-changeboarding.tour.stepIndicator":[{"type":1,"value":"currentStep"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"jira-software-backlog-bulk-agents-changeboarding.spotlight.body":[{"type":0,"value":"Select the "},{"children":[{"type":0,"value":"Agent sessions"}],"type":8,"value":"b"},{"type":0,"value":" field to monitor agent activity."}],"jira-software-backlog-bulk-agents-changeboarding.spotlight.configureFields":[{"type":0,"value":"Configure fields"}],"jira-software-backlog-bulk-agents-changeboarding.spotlight.headline":[{"type":0,"value":"View & manage agent activity"}],"jira-software-list-bulk-agent-changeboarding.spotlight.body":[{"type":0,"value":"Select the "},{"children":[{"type":0,"value":"Agent sessions"}],"type":8,"value":"b"},{"type":0,"value":" column to monitor agent activity."}],"jira-software-list-bulk-agent-changeboarding.spotlight.configureColumns":[{"type":0,"value":"Configure columns"}],"jira-software-list-bulk-agent-changeboarding.spotlight.headline":[{"type":0,"value":"View & manage agent activity"}],"jira-software-timeline-hierarchy-changeboarding-flag.back":[{"type":0,"value":"Back"}],"jira-software-timeline-hierarchy-changeboarding-flag.done":[{"type":0,"value":"Done"}],"jira-software-timeline-hierarchy-changeboarding-flag.next":[{"type":0,"value":"Next"}],"jira-software-timeline-hierarchy-changeboarding-flag.step1.description":[{"type":0,"value":"Select the highest level of work you want to see. Zoom out for a high-level overview or drill down into the details."}],"jira-software-timeline-hierarchy-changeboarding-flag.step1.title":[{"type":0,"value":"Set your timeline level "}],"jira-software-timeline-hierarchy-changeboarding-flag.step2.description":[{"type":0,"value":"Hide items that aren\'t linked to a higher level parent to keep your timeline clean and focused on your primary goals."}],"jira-software-timeline-hierarchy-changeboarding-flag.step2.title":[{"type":0,"value":"Focus on what matters"}],"jira-software-timeline-hierarchy-changeboarding-flag.stepCount":[{"type":1,"value":"current"},{"type":0,"value":" of "},{"type":1,"value":"total"}],"jira-software-timeline-inline-hierarchy-changeboarding-flag.back":[{"type":0,"value":"Back"}],"jira-software-timeline-inline-hierarchy-changeboarding-flag.done":[{"type":0,"value":"Done"}],"jira-software-timeline-inline-hierarchy-changeboarding-flag.next":[{"type":0,"value":"Next"}],"jira-software-timeline-inline-hierarchy-changeboarding-flag.step1.description":[{"type":0,"value":"Use view settings to control exactly how your timeline looks and feels."}],"jira-software-timeline-inline-hierarchy-changeboarding-flag.step1.title":[{"type":0,"value":"Your timeline, your way"}],"jira-software-timeline-inline-hierarchy-changeboarding-flag.step2.description":[{"type":0,"value":"Decide how hierarchy appears when filters are applied."}],"jira-software-timeline-inline-hierarchy-changeboarding-flag.step2.title":[{"type":0,"value":"Control your hierarchy"}],"jira-software-timeline-inline-hierarchy-changeboarding-flag.stepCount":[{"type":1,"value":"current"},{"type":0,"value":" of "},{"type":1,"value":"total"}],"jira-software-timeline-m3.descriptionContentBulkOperations":[{"type":0,"value":"Edit, move, transition, watch or delete multiple work items simultaneously."}],"jira-software-timeline-m3.descriptionContentCustomizeBar":[{"type":0,"value":"Make specific work items easier to scan or highlight as a priority."}],"jira-software-timeline-m3.descriptionContentFindWork":[{"type":0,"value":"Search, filter and group work items."}],"jira-software-timeline-m3.descriptionContentSeeSubtasks":[{"type":0,"value":"They now appear under epics."}],"jira-software-timeline-m3.headingContentBulkOperations":[{"type":0,"value":"Reduce repetitive work"}],"jira-software-timeline-m3.headingContentCustomizeBar":[{"type":0,"value":"Customize bars using colors"}],"jira-software-timeline-m3.headingContentFindWork":[{"type":0,"value":"Quickly find work items"}],"jira-software-timeline-m3.headingContentSeeSubtasks":[{"type":0,"value":"See subtasks at a glance"}],"jira-software-timeline-m3.modal.closeButton":[{"type":0,"value":"Close"}],"jira-software-timeline-m3.modal.doneButton":[{"type":0,"value":"Done"}],"jira-software-timeline-m3.modal.nextButton":[{"type":0,"value":"Next"}],"jira-software-timeline-m3.timelineImprovmentsLink":[{"type":0,"value":"Read about Timeline improvements."}],"jira-yurree.jira-software-timeline-hide-top-level-changeboarding.screen-space-flags.description.no-translate":[{"type":0,"value":"Replace this with a short summary of what this message tells the recipient."}],"jira-yurree.jira-software-timeline-hide-top-level-changeboarding.screen-space-flags.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"post-office.software-timeline-example-message-template.example-placement.cta-button.no-translate":[{"type":0,"value":"Try now"}],"post-office.software-timeline-testing.dismiss-button.no-translate":[{"type":0,"value":"Dismiss"}],"post-office.software-timeline-testing.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}],"post-office.software-timeline-testing.test-message.dismiss-button.no-translate":[{"type":0,"value":"Dismiss"}],"timeline-10k-issues-flag.actions":[{"type":0,"value":"Learn more about the 10k limit"}],"timeline-10k-issues-flag.description":[{"type":0,"value":"Parent rollup bars in timeline have been disabled to give you a smoother performance and experience."}],"timeline-10k-issues-flag.title":[{"type":0,"value":"This space has more than 10k work items."}],"timeline-feedback-collector.spotlight.body":[{"type":0,"value":"In doing this we are keen to hear feedback from users about the timeline, what else you may want, and importantly, what you don\u2019t want."}],"timeline-feedback-collector.spotlight.dismiss":[{"type":0,"value":"Dismiss"}],"timeline-feedback-collector.spotlight.give-feedback":[{"type":0,"value":"Give feedback"}],"timeline-feedback-collector.spotlight.heading":[{"type":0,"value":"We\u2019re updating Jira timelines"}]}');

});

parcelRegister("lNvx6", function(module, exports) {

let $fde6a25d972abedb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fde6a25d972abedb$var$load("ffL9q").then(()=>parcelRequire('gUEt6'));

});

parcelRegister("gazYW", function(module, exports) {

let $bc597dc570bda84b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bc597dc570bda84b$var$load("fmDnQ").then(()=>parcelRequire('8HOnL'));

});

parcelRegister("kxeq9", function(module, exports) {

let $ef321365178de3e7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ef321365178de3e7$var$load("3rhE8").then(()=>parcelRequire('4BUsS'));

});

parcelRegister("1IDHd", function(module, exports) {

let $1408b15176103be7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1408b15176103be7$var$load("500la").then(()=>parcelRequire('3PolQ'));

});

parcelRegister("AT11t", function(module, exports) {

let $06ee09d6ba829a83$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $06ee09d6ba829a83$var$load("6b24k").then(()=>parcelRequire('4YWIe'));

});

parcelRegister("bmVIy", function(module, exports) {

let $846e854be72f8123$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $846e854be72f8123$var$load("6RWRK").then(()=>parcelRequire('2bvZR'));

});

parcelRegister("c1Sw8", function(module, exports) {

let $8c1fde05a0f7c5a8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8c1fde05a0f7c5a8$var$load("3GnHu").then(()=>parcelRequire('2Tp3d'));

});

parcelRegister("lp3zR", function(module, exports) {

let $f94eb52c61488e8a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f94eb52c61488e8a$var$load("cUvDi").then(()=>parcelRequire('fRHy9'));

});

parcelRegister("283aW", function(module, exports) {

let $18cecabbc62d81ab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $18cecabbc62d81ab$var$load("9w5Pu").then(()=>parcelRequire('ee5TU'));

});

parcelRegister("dZ4om", function(module, exports) {

let $a2e461080b85f102$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a2e461080b85f102$var$load("dMka0").then(()=>parcelRequire('iZmVB'));

});

parcelRegister("3sUkb", function(module, exports) {

let $285fad7f9963ee92$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $285fad7f9963ee92$var$load("bN59W").then(()=>parcelRequire('2uAdz'));

});

parcelRegister("jBmNc", function(module, exports) {

let $e453272139f771e3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e453272139f771e3$var$load("bvlVk").then(()=>parcelRequire('fSnRF'));

});

parcelRegister("15qwh", function(module, exports) {

let $0caad458c81dd88b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0caad458c81dd88b$var$load("7UMuq").then(()=>parcelRequire('8xanX'));

});

parcelRegister("5PzhD", function(module, exports) {

let $43ed15bf1bdf985f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $43ed15bf1bdf985f$var$load("g4Z5x").then(()=>parcelRequire('8AJ85'));

});

parcelRegister("7UkhN", function(module, exports) {

let $5c1d7fc57852fde6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5c1d7fc57852fde6$var$load("7MFNP").then(()=>parcelRequire('flV2z'));

});

parcelRegister("2tRH7", function(module, exports) {

let $1ce7f0cf3ab9848b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1ce7f0cf3ab9848b$var$load("khw6G").then(()=>parcelRequire('dvYsA'));

});

parcelRegister("e1zmU", function(module, exports) {

let $a35c981c1fe73f82$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a35c981c1fe73f82$var$load("iID8O").then(()=>parcelRequire('lvPWI'));

});

parcelRegister("87I2q", function(module, exports) {

let $5ea1233603dd54e7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5ea1233603dd54e7$var$load("l4jYP").then(()=>parcelRequire('ctAD3'));

});

parcelRegister("6WREV", function(module, exports) {

let $50f1c872b89262dc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $50f1c872b89262dc$var$load("jjlJY").then(()=>parcelRequire('b3QZU'));

});

parcelRegister("2sB85", function(module, exports) {

let $1caaff6f64a0fcb2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1caaff6f64a0fcb2$var$load("7Fdvi").then(()=>parcelRequire('3aiGT'));

});

parcelRegister("hY2q5", function(module, exports) {

let $d149eac1a081d9b2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d149eac1a081d9b2$var$load("4NvRS").then(()=>parcelRequire('8ETRV'));

});

parcelRegister("l5xuT", function(module, exports) {

let $f5a40c70fcf9483f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f5a40c70fcf9483f$var$load("7OYG4").then(()=>parcelRequire('jJ8Je'));

});

parcelRegister("2ksgB", function(module, exports) {

let $1b23603da448f5eb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1b23603da448f5eb$var$load("1uk6L").then(()=>parcelRequire('hdPzW'));

});

parcelRegister("9cyWu", function(module, exports) {

let $6b3056e12bca434b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b3056e12bca434b$var$load("8XceY").then(()=>parcelRequire('8kAsA'));

});

parcelRegister("5UvXI", function(module, exports) {

let $44daf9b4fdeb8fc5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $44daf9b4fdeb8fc5$var$load("lnocA").then(()=>parcelRequire('lcwZc'));

});

parcelRegister("7zFF6", function(module, exports) {

let $583c1e7b97220452$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $583c1e7b97220452$var$load("3vIvK").then(()=>parcelRequire('i69y6'));

});

parcelRegister("6RotY", function(module, exports) {

let $4feaaf05ae1aabc2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4feaaf05ae1aabc2$var$load("eZtLZ").then(()=>parcelRequire('jZd2X'));

});

parcelRegister("02GWY", function(module, exports) {

let $00818103400b22df$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $00818103400b22df$var$load("9qH0V").then(()=>parcelRequire('lO1fk'));

});

parcelRegister("gyLnY", function(module, exports) {

let $c0e4941a9b0ab2b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c0e4941a9b0ab2b8$var$load("5odJ3").then(()=>parcelRequire('6VT5N'));

});

parcelRegister("37a11", function(module, exports) {

let $2449cb698b5ab97f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2449cb698b5ab97f$var$load("cbbXH").then(()=>parcelRequire('9UfLH'));

});

parcelRegister("gieR4", function(module, exports) {

let $bdc9d9a9ef07fc8f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bdc9d9a9ef07fc8f$var$load("jtvE1").then(()=>parcelRequire('k5Q6H'));

});

parcelRegister("cfoJK", function(module, exports) {

let $8eaa12f84794e7e6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8eaa12f84794e7e6$var$load("7NJ03").then(()=>parcelRequire('7oVJi'));

});

parcelRegister("7MnUN", function(module, exports) {

let $5a9f911ba762f8f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a9f911ba762f8f1$var$load("d23ER").then(()=>parcelRequire('8N6FV'));

});

parcelRegister("9u4Zn", function(module, exports) {

let $6e7ac919885c9599$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6e7ac919885c9599$var$load("7u6dQ").then(()=>parcelRequire('bXm86'));

});

parcelRegister("d9Kla", function(module, exports) {
module.exports = JSON.parse('{"export-issues-flyout-spotlight-tour.spotlight.body":[{"type":0,"value":"Export your work items in the format you need, right from the more actions menu."}],"export-issues-flyout-spotlight-tour.spotlight.heading":[{"type":0,"value":"Export options have moved"}],"export-issues-flyout-spotlight-tour.spotlight.okButton":[{"type":0,"value":"OK"}],"jira-filter-refinement-board-and-backlog.tour.backButton":[{"type":0,"value":"Back"}],"jira-filter-refinement-board-and-backlog.tour.doneButton":[{"type":0,"value":"Done"}],"jira-filter-refinement-board-and-backlog.tour.nextButton":[{"type":0,"value":"Next"}],"jira-filter-refinement-board-and-backlog.tour.step1Body":[{"type":0,"value":"Add the fields you need and remove the fields you don\u2019t."}],"jira-filter-refinement-board-and-backlog.tour.step1Headline":[{"type":0,"value":"Add and remove fields"}],"jira-filter-refinement-board-and-backlog.tour.step2Body":[{"type":0,"value":"Reorder and pin fields to\xa0prioritize\xa0what matters\xa0most to you."}],"jira-filter-refinement-board-and-backlog.tour.step2Headline":[{"type":0,"value":"Reorder and pin fields"}],"jira-filter-refinement-board-and-backlog.tour.stepIndicator":[{"type":1,"value":"currentStep"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"jira-filter-refinement.tour.backButton":[{"type":0,"value":"Back"}],"jira-filter-refinement.tour.doneButton":[{"type":0,"value":"Done"}],"jira-filter-refinement.tour.nextButton":[{"type":0,"value":"Next"}],"jira-filter-refinement.tour.step1Body":[{"type":0,"value":"Save any filter combination to reuse later."}],"jira-filter-refinement.tour.step1Headline":[{"type":0,"value":"Save your filter"}],"jira-filter-refinement.tour.step2Body":[{"type":0,"value":"Add the fields you need and remove the fields you don\u2019t."}],"jira-filter-refinement.tour.step2Headline":[{"type":0,"value":"Add and remove fields"}],"jira-filter-refinement.tour.step3Body":[{"type":0,"value":"Reorder and pin fields to\xa0prioritize\xa0what matters\xa0most to you."}],"jira-filter-refinement.tour.step3Headline":[{"type":0,"value":"Reorder and pin fields"}],"jira-filter-refinement.tour.stepIndicator":[{"type":1,"value":"currentStep"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"jira-nin-issue-preview-panel-resize.body":[{"type":0,"value":"Drag to resize the panel and view more work item information."}],"jira-nin-issue-preview-panel-resize.heading":[{"type":0,"value":"Expand the panel"}],"jira-nin-issue-preview-panel.body":[{"type":0,"value":"View and edit work items in the new preview panel, while staying on the List."}],"jira-nin-issue-preview-panel.dismiss":[{"type":0,"value":"Dismiss"}],"jira-nin-issue-preview-panel.heading":[{"type":0,"value":"Access work items instantly"}],"jira-nin-issue-preview-panel.more":[{"type":0,"value":"More about preview panels"}],"jira-nin-issue-preview-panel.new-window":[{"type":0,"value":"(opens in a new window)"}],"jira-nin-issue-preview-panel.tour.arrows-heading":[{"type":0,"value":"Preview your work items"}],"jira-nin-issue-preview-panel.tour.arrows-image-alt":[{"type":0,"value":"Navigation arrows on the glance panel"}],"jira-nin-issue-preview-panel.tour.arrows-modal-body":[{"type":0,"value":"Select the arrows to move through work items. Select minimise to view your work in a preview panel."}],"jira-nin-issue-preview-panel.tour.arrows-panel-body":[{"type":0,"value":"Select the arrows to move through work items. Select expand for modal view."}],"jira-nin-issue-preview-panel.tour.back":[{"type":0,"value":"Back"}],"jira-nin-issue-preview-panel.tour.dismiss":[{"type":0,"value":"Dismiss"}],"jira-nin-issue-preview-panel.tour.done":[{"type":0,"value":"Done"}],"jira-nin-issue-preview-panel.tour.intro-body":[{"type":0,"value":"View work item details in a layout that works best for your list."}],"jira-nin-issue-preview-panel.tour.intro-heading":[{"type":0,"value":"New ways to view work in context"}],"jira-nin-issue-preview-panel.tour.next":[{"type":0,"value":"Next"}],"jira-nin-issue-preview-panel.tour.resize-body":[{"type":0,"value":"Drag to resize the panel and view more work item information."}],"jira-nin-issue-preview-panel.tour.resize-heading":[{"type":0,"value":"Expand the panel"}],"jira-nin-issue-preview-panel.tour.step-count":[{"type":1,"value":"current"},{"type":0,"value":" of "},{"type":1,"value":"total"}],"jira-nin-list-merge-modal-onboarding-v2.closeButton":[{"type":0,"value":"Close"}],"jira-nin-list-merge-modal-onboarding-v2.copyListSettingsDescription":[{"type":0,"value":"Want us to apply your current filter and group settings to this new List view?"}],"jira-nin-list-merge-modal-onboarding-v2.copyListSettingsNo":[{"type":0,"value":"No"}],"jira-nin-list-merge-modal-onboarding-v2.copyListSettingsYes":[{"type":0,"value":"Yes"}],"jira-nin-list-merge-modal-onboarding-v2.description":[{"type":0,"value":"We\'ve merged the best of List and All Work into a faster, accessible experience. A new List view."}],"jira-nin-list-merge-modal-onboarding-v2.filtersAndGroupsDescription":[{"type":0,"value":"Any existing filters and groups will be applied."}],"jira-nin-list-merge-modal-onboarding-v2.heading":[{"type":0,"value":"We\'ve merged List and All Work"}],"jira-nin-list-merge-modal-onboarding-v2.learnMoreLink":[{"type":0,"value":"Read our community post about the merge of List and All Work views"}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.body":[{"type":0,"value":"We\'ve merged the best of List and All Work into a faster, accessible experience. A new List view."}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.dismiss":[{"type":0,"value":"Dismiss"}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.explore-list-view-button-label":[{"type":0,"value":"Explore List view"}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.filter":[{"type":0,"value":"One place to search work and filter results to find what you need."}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.heading":[{"type":0,"value":"We\'ve merged List and All Work views"}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.more-actions":[{"type":0,"value":"Dive deeper - view work items as a chart, use format rules to highlight key work, and more."}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.next":[{"type":0,"value":"Next"}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.ok":[{"type":0,"value":"OK"}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.tell-me-more-aria-label":[{"type":0,"value":"Read our community post about the merge of List and All Work views"}],"jira-nin-list-merge-spotlight-onboarding.spotlight.body":[{"type":0,"value":"We\'ve merged the best of List and All Work into a faster, accessible experience."}],"jira-nin-list-merge-spotlight-onboarding.spotlight.dismiss":[{"type":0,"value":"Dismiss"}],"jira-nin-list-merge-spotlight-onboarding.spotlight.heading":[{"type":0,"value":"We\'ve merged List and All Work views"}],"jira-nin-list-merge-spotlight-onboarding.spotlight.tell-me-more":[{"type":0,"value":"Tell me more"}],"jira-nin-list-merge-spotlight-onboarding.spotlight.tell-me-more-aria-label":[{"type":0,"value":"Read our community post about the merge of List and All Work views"}],"jira-nl2jql-ai-filter-changeboarding.spotlight.body":[{"type":0,"value":"We\u2019ve improved AI filtering to give you more accurate results. Just describe what you\u2019re looking for."}],"jira-nl2jql-ai-filter-changeboarding.spotlight.headline":[{"type":0,"value":"Find work faster with AI"}],"jira-nl2jql-ai-filter-changeboarding.spotlight.tryItOutButton":[{"type":0,"value":"Try it out"}],"jira.filter.refinement.filter-popup.changeboarding.description.filter":[{"type":0,"value":"You can now filter work items by status and priority, making it easier to find work."}],"jira.filter.refinement.filter-popup.changeboarding.description.improvements":[{"type":0,"value":"More improvements to come."}],"jira.filter.refinement.filter-popup.changeboarding.description.parent":[{"type":0,"value":"Use the parent filter to search for epics, as well as any other work items with child work items."}],"jira.filter.refinement.filter-popup.changeboarding.dismiss":[{"type":0,"value":"Dismiss"}],"jira.filter.refinement.filter-popup.changeboarding.next":[{"type":0,"value":"Next"}],"jira.filter.refinement.filter-popup.changeboarding.ok":[{"type":0,"value":"OK"}],"jira.filter.refinement.filter-popup.changeboarding.page2.title":[{"type":0,"value":"We\'ve updated epic to parent"}],"jira.filter.refinement.filter-popup.changeboarding.title":[{"type":0,"value":"Introducing a new home for filters"}]}');

});

parcelRegister("ktcOp", function(module, exports) {

let $ee70744c507aaa00$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ee70744c507aaa00$var$load("1Ms7M").then(()=>parcelRequire('hc7BF'));

});

parcelRegister("iBniq", function(module, exports) {

let $d8adc0d742be624e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d8adc0d742be624e$var$load("g9nZd").then(()=>parcelRequire('6x7Wf'));

});

parcelRegister("9E25K", function(module, exports) {

let $705978db2bef7d54$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $705978db2bef7d54$var$load("9MfRk").then(()=>parcelRequire('fcHTk'));

});

parcelRegister("6anjp", function(module, exports) {

let $47d5c2883b89a1fa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $47d5c2883b89a1fa$var$load("8TJOR").then(()=>parcelRequire('aI1UL'));

});

parcelRegister("luucs", function(module, exports) {

let $fa53d36abbe6b9bd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fa53d36abbe6b9bd$var$load("8udy0").then(()=>parcelRequire('jxKmu'));

});

parcelRegister("f5joJ", function(module, exports) {

let $afb65eadc03e7348$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $afb65eadc03e7348$var$load("lPTEq").then(()=>parcelRequire('8rN1d'));

});

parcelRegister("6nrI0", function(module, exports) {

let $4a4a6277697d84ae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a4a6277697d84ae$var$load("4THFF").then(()=>parcelRequire('9qZYh'));

});

parcelRegister("bxaDU", function(module, exports) {

let $865b0830cdb669c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $865b0830cdb669c9$var$load("c07nz").then(()=>parcelRequire('lL655'));

});

parcelRegister("98EBs", function(module, exports) {

let $6a745b55355e5ebd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6a745b55355e5ebd$var$load("kkCU9").then(()=>parcelRequire('lsYsg'));

});

parcelRegister("gE99x", function(module, exports) {

let $c1e77b56f868dde7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c1e77b56f868dde7$var$load("13fXN").then(()=>parcelRequire('jO7eN'));

});

parcelRegister("hlhL8", function(module, exports) {

let $ca022c70a16fc01c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ca022c70a16fc01c$var$load("7W0qN").then(()=>parcelRequire('3Cqh1'));

});

parcelRegister("9yRox", function(module, exports) {

let $6f60b519b079f7af$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6f60b519b079f7af$var$load("41eX3").then(()=>parcelRequire('iW6Wy'));

});

parcelRegister("lQ8wg", function(module, exports) {

let $fe651015e40e8669$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fe651015e40e8669$var$load("cfh02").then(()=>parcelRequire('1sCFb'));

});

parcelRegister("jnLzZ", function(module, exports) {

let $e1c5129333456a2e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e1c5129333456a2e$var$load("begO5").then(()=>parcelRequire('6qior'));

});

parcelRegister("2C8Xo", function(module, exports) {

let $1e7614098fc5d85e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1e7614098fc5d85e$var$load("8tx7H").then(()=>parcelRequire('id4iX'));

});

parcelRegister("5h5os", function(module, exports) {

let $3d72b94a9716722a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3d72b94a9716722a$var$load("7IzyO").then(()=>parcelRequire('1Q3kL'));

});

parcelRegister("ei1op", function(module, exports) {

let $a673d3b590b535ff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a673d3b590b535ff$var$load("dRvv6").then(()=>parcelRequire('4lX2f'));

});

parcelRegister("9fvHg", function(module, exports) {

let $6bbe1a16306d06c2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6bbe1a16306d06c2$var$load("bMZ6i").then(()=>parcelRequire('6fjoN'));

});

parcelRegister("hLER0", function(module, exports) {

let $cef6843046890d2f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cef6843046890d2f$var$load("9T1xY").then(()=>parcelRequire('9ddlz'));

});

parcelRegister("aFnwY", function(module, exports) {

let $7c3ffc6e53f4c31a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7c3ffc6e53f4c31a$var$load("fdC1a").then(()=>parcelRequire('2k2Js'));

});

parcelRegister("0sqpa", function(module, exports) {

let $00160ccac9e938f6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $00160ccac9e938f6$var$load("etiqp").then(()=>parcelRequire('95wyr'));

});

parcelRegister("fVd32", function(module, exports) {

let $b9764ceeda5f6479$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b9764ceeda5f6479$var$load("8fQkM").then(()=>parcelRequire('dHoxp'));

});

parcelRegister("bmLRy", function(module, exports) {

let $8466e05112081d4a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8466e05112081d4a$var$load("27XGC").then(()=>parcelRequire('dhc7q'));

});

parcelRegister("k3mzK", function(module, exports) {

let $e9959982e1e795ee$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e9959982e1e795ee$var$load("jP6tH").then(()=>parcelRequire('9detW'));

});

parcelRegister("1Uxdk", function(module, exports) {

let $1644c903370f6a0f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1644c903370f6a0f$var$load("blpTr").then(()=>parcelRequire('krxDQ'));

});

parcelRegister("k7AMr", function(module, exports) {

let $ea60fde112b11c49$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ea60fde112b11c49$var$load("eiqE0").then(()=>parcelRequire('5fIMo'));

});

parcelRegister("kum9N", function(module, exports) {

let $eea7cbe7f6313604$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eea7cbe7f6313604$var$load("6NqUi").then(()=>parcelRequire('2jWoY'));

});

parcelRegister("1kfoi", function(module, exports) {

let $0f7399014fd9f2af$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0f7399014fd9f2af$var$load("hJEnB").then(()=>parcelRequire('gUbjY'));

});

parcelRegister("2UjWQ", function(module, exports) {

let $21e04901ed75854e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $21e04901ed75854e$var$load("7yXxF").then(()=>parcelRequire('aYy4X'));

});

parcelRegister("jaQ6u", function(module, exports) {

let $df575e2d729117ca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $df575e2d729117ca$var$load("fbON9").then(()=>parcelRequire('b8clR'));

});

parcelRegister("hMVdN", function(module, exports) {

let $cf334e5dcb70b3f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cf334e5dcb70b3f1$var$load("iJrtF").then(()=>parcelRequire('8uAmU'));

});

parcelRegister("6pAEW", function(module, exports) {

let $4ab183a8c5dfe625$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ab183a8c5dfe625$var$load("kIyIG").then(()=>parcelRequire('kN7Rq'));

});

parcelRegister("kzCrI", function(module, exports) {

let $efa4e620dae3d6af$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $efa4e620dae3d6af$var$load("1RNDi").then(()=>parcelRequire('8lOUT'));

});

parcelRegister("gKRAQ", function(module, exports) {

let $c32a83bfbf473f15$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c32a83bfbf473f15$var$load("b4gHG").then(()=>parcelRequire('997Tf'));

});

parcelRegister("3NgrG", function(module, exports) {
module.exports = JSON.parse("{\"jira-forms-conditional-fields-changeboarding.spotlight.body.no-translate\":[{\"type\":0,\"value\":\"Create conditions to have more control over the information you receive.\"}],\"jira-forms-conditional-fields-changeboarding.spotlight.heading.no-translate\":[{\"type\":0,\"value\":\"Show fields based on previous responses\"}],\"jira-forms-conditional-fields-changeboarding.spotlight.ok.no-translate\":[{\"type\":0,\"value\":\"Ok\"}],\"jira-tanuki.jira-forms-public-forms-changeboarding-flag.screen-space-flags.description.no-translate\":[{\"type\":0,\"value\":\"Jira Forms can now be shared publicly with anyone online. You can also customize forms by adding conditions.\"}],\"jira-tanuki.jira-forms-public-forms-changeboarding-flag.screen-space-flags.title.no-translate\":[{\"type\":0,\"value\":\"Public forms available now\"}],\"jira-tanuki.jira-forms-public-forms-changeboarding.screen-space-flags.description.no-translate\":[{\"type\":0,\"value\":\"Jira Forms can now be shared publicly, so you can receive responses from anyone online and collect work for your team in real time. You can also customize forms by adding conditions and setting required fields.\"}],\"jira-tanuki.jira-forms-public-forms-changeboarding.screen-space-flags.title.no-translate\":[{\"type\":0,\"value\":\"Public forms available now\"}],\"jira-tanuki.jira-in-context-config-sidebar-changeboarding.screen-space-flags.description.no-translate\":[{\"type\":0,\"value\":\"From the \"},{\"children\":[{\"type\":0,\"value\":\"All work\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" tab, you can now use currency or percentage formatting for a number field.\"}],\"jira-tanuki.jira-in-context-config-sidebar-changeboarding.screen-space-flags.title.no-translate\":[{\"type\":0,\"value\":\"Introducing currency formatting\"}]}");

});

parcelRegister("7UFKR", function(module, exports) {

let $5c2e26fcf18a1da5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5c2e26fcf18a1da5$var$load("iqwP8").then(()=>parcelRequire('cR9fY'));

});

parcelRegister("7xrR7", function(module, exports) {

let $57d1390ce3ad00e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $57d1390ce3ad00e8$var$load("8nWCM").then(()=>parcelRequire('6HeYS'));

});

parcelRegister("5x31x", function(module, exports) {

let $40726144b4435ac2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $40726144b4435ac2$var$load("dAkfP").then(()=>parcelRequire('9dOeR'));

});

parcelRegister("irJXn", function(module, exports) {

let $d6de65aae9098e8f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d6de65aae9098e8f$var$load("fpb0q").then(()=>parcelRequire('7Gkdd'));

});

parcelRegister("aj07G", function(module, exports) {

let $780bc61e2ad356d6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $780bc61e2ad356d6$var$load("1FB5D").then(()=>parcelRequire('b6JYG'));

});

parcelRegister("5KdSc", function(module, exports) {

let $42ec029075f3d039$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $42ec029075f3d039$var$load("8DCST").then(()=>parcelRequire('jZoyS'));

});

parcelRegister("elzTc", function(module, exports) {

let $a71eddbc355ada65$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a71eddbc355ada65$var$load("kaRj4").then(()=>parcelRequire('iDavy'));

});

parcelRegister("jpvXg", function(module, exports) {

let $e21923b73923d475$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e21923b73923d475$var$load("amBK5").then(()=>parcelRequire('2OPDq'));

});

parcelRegister("iyt6Y", function(module, exports) {

let $d821fbec99bb9376$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d821fbec99bb9376$var$load("eU8Xq").then(()=>parcelRequire('cexM8'));

});

parcelRegister("kGz6V", function(module, exports) {

let $03e2e2f4439b00f0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $03e2e2f4439b00f0$var$load("3dvXG").then(()=>parcelRequire('2UJi7'));

});

parcelRegister("feZ8g", function(module, exports) {

let $b187956f1d5d09cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b187956f1d5d09cb$var$load("6QR3R").then(()=>parcelRequire('61S0g'));

});

parcelRegister("Gh97v", function(module, exports) {

let $07f1393763a58e69$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $07f1393763a58e69$var$load("cNz9w").then(()=>parcelRequire('934zW'));

});

parcelRegister("lQTvq", function(module, exports) {

let $fe89829883f7b554$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fe89829883f7b554$var$load("cAwkO").then(()=>parcelRequire('g5D5L'));

});

parcelRegister("j0D9N", function(module, exports) {

let $dd6c64268ac452d0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dd6c64268ac452d0$var$load("bxhDL").then(()=>parcelRequire('l2sCl'));

});

parcelRegister("7u6a1", function(module, exports) {

let $57301d1eef027105$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $57301d1eef027105$var$load("7Ep8d").then(()=>parcelRequire('25rei'));

});

parcelRegister("78jBd", function(module, exports) {

let $53187bc0964e4b5c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $53187bc0964e4b5c$var$load("ayZ37").then(()=>parcelRequire('etnRk'));

});

parcelRegister("kk9UR", function(module, exports) {

let $ecbd5e049b16e7a0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ecbd5e049b16e7a0$var$load("f2tuW").then(()=>parcelRequire('cx1Jy'));

});

parcelRegister("p0vY1", function(module, exports) {

let $04b2bc1a3b6a2a82$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $04b2bc1a3b6a2a82$var$load("g6ZPm").then(()=>parcelRequire('2JsVa'));

});

parcelRegister("5Z0g7", function(module, exports) {

let $45b2d9ad58ff4dc5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $45b2d9ad58ff4dc5$var$load("jirLe").then(()=>parcelRequire('cNtYP'));

});

parcelRegister("5i3XF", function(module, exports) {

let $3da1b4d155ab08f4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3da1b4d155ab08f4$var$load("9N0t2").then(()=>parcelRequire('c8tBI'));

});

parcelRegister("aVvtu", function(module, exports) {

let $7f47a4725dee1a3f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7f47a4725dee1a3f$var$load("OrFMi").then(()=>parcelRequire('lKjg0'));

});

parcelRegister("7Fvbt", function(module, exports) {

let $59548d413b52e863$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $59548d413b52e863$var$load("dbdyp").then(()=>parcelRequire('iyYNP'));

});

parcelRegister("2RDu2", function(module, exports) {

let $215f289533ec0762$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $215f289533ec0762$var$load("8LUfP").then(()=>parcelRequire('jivQS'));

});

parcelRegister("c2ndM", function(module, exports) {

let $8c37af380ebb94b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8c37af380ebb94b1$var$load("cC5vO").then(()=>parcelRequire('5WBjM'));

});

parcelRegister("gUTaH", function(module, exports) {

let $c50cac405b2010ab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c50cac405b2010ab$var$load("wwMNk").then(()=>parcelRequire('8NPvM'));

});

parcelRegister("lCWMS", function(module, exports) {

let $fbeabf8869e9dc35$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fbeabf8869e9dc35$var$load("4XzxG").then(()=>parcelRequire('3BIWQ'));

});

parcelRegister("hm9Dy", function(module, exports) {

let $ca2bf76bffcabdb9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ca2bf76bffcabdb9$var$load("c9EY5").then(()=>parcelRequire('2pgm7'));

});

parcelRegister("3ONYW", function(module, exports) {

let $2c7ccffada1f688f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2c7ccffada1f688f$var$load("94fYc").then(()=>parcelRequire('3uu6I'));

});

parcelRegister("hRI0p", function(module, exports) {

let $d01985862b692ea2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d01985862b692ea2$var$load("jC3rz").then(()=>parcelRequire('cSW0X'));

});

parcelRegister("gTtok", function(module, exports) {

let $c4c894e5cda34eb8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c4c894e5cda34eb8$var$load("bqITJ").then(()=>parcelRequire('8PH7O'));

});

parcelRegister("hb44P", function(module, exports) {

let $c816a054c6420895$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c816a054c6420895$var$load("8FBa8").then(()=>parcelRequire('emErc'));

});

parcelRegister("hX03y", function(module, exports) {

let $d117fd869ae67ef6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d117fd869ae67ef6$var$load("1zA7i").then(()=>parcelRequire('aG699'));

});

parcelRegister("fYaiw", function(module, exports) {

let $ba047289be234b43$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ba047289be234b43$var$load("8kOTu").then(()=>parcelRequire('gv1yu'));

});

parcelRegister("6VwSN", function(module, exports) {

let $50b192c47b48678c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $50b192c47b48678c$var$load("g3dJ1").then(()=>parcelRequire('6mMuG'));

});

parcelRegister("bEUWX", function(module, exports) {
module.exports = JSON.parse("{\"gnin.fps-redirect.changeboarding.description\":[{\"type\":0,\"value\":\"Looking for more? Switch to find results and answers from all your Atlassian and connected apps.\"}],\"gnin.fps-redirect.changeboarding.primary-button\":[{\"type\":0,\"value\":\"Got it\"}],\"gnin.fps-redirect.changeboarding.title\":[{\"type\":0,\"value\":\"Switch to search beyond Jira\"}],\"post-office.quick-find-spotlight.spotlight-body-1\":[{\"type\":0,\"value\":\"Apply a mix of filters to narrow down results.\"}],\"post-office.quick-find-spotlight.spotlight-body-2\":[{\"type\":0,\"value\":\"Search only Jira, or expand across all your Atlassian and connected apps.\"}],\"post-office.quick-find-spotlight.spotlight-button-done\":[{\"type\":0,\"value\":\"Done\"}],\"post-office.quick-find-spotlight.spotlight-button-next\":[{\"type\":0,\"value\":\"Next\"}],\"post-office.quick-find-spotlight.spotlight-heading-1\":[{\"type\":0,\"value\":\"Filter for what you need\"}],\"post-office.quick-find-spotlight.spotlight-heading-2\":[{\"type\":0,\"value\":\"Choose where to search\"}],\"search-page.gnin-redirect.changeboarding.back-button\":[{\"type\":0,\"value\":\"Back\"}],\"search-page.gnin-redirect.changeboarding.next-button\":[{\"type\":0,\"value\":\"Next\"}],\"search-page.gnin-redirect.changeboarding.primary-button\":[{\"type\":0,\"value\":\"Got it\"}],\"search-page.gnin-redirect.changeboarding.step-label\":[{\"type\":1,\"value\":\"current\"},{\"type\":0,\"value\":\" of \"},{\"type\":1,\"value\":\"total\"}],\"search-page.gnin-redirect.changeboarding.step1.description\":[{\"type\":0,\"value\":\"Your results may come from all your apps or just Jira, depending on your search terms.\"}],\"search-page.gnin-redirect.changeboarding.step1.image-alt\":[{\"type\":0,\"value\":\"Rovo full page search smart AI answer illustration\"}],\"search-page.gnin-redirect.changeboarding.step1.title\":[{\"type\":0,\"value\":\"Search that adapts to you\"}],\"search-page.gnin-redirect.changeboarding.step2.description\":[{\"type\":0,\"value\":\"You can switch anytime to search Jira work items (including JQL).\"}],\"search-page.gnin-redirect.changeboarding.step2.image-alt\":[{\"type\":0,\"value\":\"Rovo full page search illustration\"}],\"search-page.gnin-redirect.changeboarding.step2.title\":[{\"type\":0,\"value\":\"Switch your view anytime\"}],\"search-plex.jira-quick-find-intent-detection-changeboarding.description.no-translate\":[{\"type\":0,\"value\":\"Quick find intent detection test message.\"}],\"search-plex.jira-quick-find-intent-detection-changeboarding.title.no-translate\":[{\"type\":0,\"value\":\"This is a Post Office Test Message\"}]}");

});

parcelRegister("2RLjC", function(module, exports) {

let $21653be28f725bfe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $21653be28f725bfe$var$load("cHK32").then(()=>parcelRequire('97vpA'));

});

parcelRegister("dGu50", function(module, exports) {

let $9f6687ce65b92ba0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9f6687ce65b92ba0$var$load("3bxQs").then(()=>parcelRequire('6cqls'));

});

parcelRegister("aOiiW", function(module, exports) {

let $7decc5d0283a3961$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7decc5d0283a3961$var$load("iH1Vh").then(()=>parcelRequire('i9vg1'));

});

parcelRegister("funYt", function(module, exports) {

let $b46c412531f82f5a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b46c412531f82f5a$var$load("gSoco").then(()=>parcelRequire('1omd8'));

});

parcelRegister("i24EM", function(module, exports) {

let $d20c069aef7697b4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d20c069aef7697b4$var$load("k7cv3").then(()=>parcelRequire('kDgIv'));

});

parcelRegister("jhXoI", function(module, exports) {

let $e0adae02d38ca9a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e0adae02d38ca9a4$var$load("emn3F").then(()=>parcelRequire('35djh'));

});

parcelRegister("L5WWk", function(module, exports) {

let $08d9016022c0d896$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $08d9016022c0d896$var$load("7T7dD").then(()=>parcelRequire('kJc0Z'));

});

parcelRegister("h0oUr", function(module, exports) {

let $c615c238f8230e88$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c615c238f8230e88$var$load("8umAl").then(()=>parcelRequire('kSRpm'));

});

parcelRegister("13Wsv", function(module, exports) {

let $0c636af48e62cb47$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0c636af48e62cb47$var$load("1CmfX").then(()=>parcelRequire('diBX0'));

});

parcelRegister("gVqQl", function(module, exports) {

let $c526cabe09ffb51a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c526cabe09ffb51a$var$load("89Bhf").then(()=>parcelRequire('dgqCg'));

});

parcelRegister("aSf2F", function(module, exports) {

let $7eaa9d911032e182$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7eaa9d911032e182$var$load("l6Lby").then(()=>parcelRequire('a3Njm'));

});

parcelRegister("iaMoz", function(module, exports) {

let $d3aeb37756df8646$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d3aeb37756df8646$var$load("hIIHZ").then(()=>parcelRequire('dzl2R'));

});

parcelRegister("cpDmt", function(module, exports) {

let $90965a35c91deaea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $90965a35c91deaea$var$load("4kNi5").then(()=>parcelRequire('bM7JN'));

});

parcelRegister("1Crzy", function(module, exports) {

let $12deba5f042da86c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $12deba5f042da86c$var$load("7w0NZ").then(()=>parcelRequire('kBEk1'));

});

parcelRegister("2NSFh", function(module, exports) {

let $20aa8fafe7b6689b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $20aa8fafe7b6689b$var$load("lilq5").then(()=>parcelRequire('iVTZa'));

});

parcelRegister("2Durl", function(module, exports) {

let $1eb6d605dad83707$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1eb6d605dad83707$var$load("j4mjo").then(()=>parcelRequire('k6NDD'));

});

parcelRegister("2fH5g", function(module, exports) {

let $1a3e670a17a5ae44$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1a3e670a17a5ae44$var$load("3kAYj").then(()=>parcelRequire('32JtS'));

});

parcelRegister("de9J4", function(module, exports) {

let $9a142087c9eaf836$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9a142087c9eaf836$var$load("1nYUd").then(()=>parcelRequire('7JZv5'));

});

parcelRegister("2w5Qd", function(module, exports) {

let $1d5319e0f30125ab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1d5319e0f30125ab$var$load("1qvAs").then(()=>parcelRequire('dpCjt'));

});

parcelRegister("ht60R", function(module, exports) {

let $cb79cf1f78c52260$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cb79cf1f78c52260$var$load("jD1h4").then(()=>parcelRequire('6jMfg'));

});

parcelRegister("l8Lmn", function(module, exports) {

let $f63f1509be12ab12$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f63f1509be12ab12$var$load("c03Vk").then(()=>parcelRequire('8jROn'));

});

parcelRegister("e07cw", function(module, exports) {

let $a316a6bb73b8b009$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a316a6bb73b8b009$var$load("dWG3o").then(()=>parcelRequire('3X6zI'));

});

parcelRegister("jKS37", function(module, exports) {

let $e61c3d3ea0a2de8d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e61c3d3ea0a2de8d$var$load("bQ2Kg").then(()=>parcelRequire('7PjED'));

});

parcelRegister("cdolv", function(module, exports) {

let $8e49958034e5728e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8e49958034e5728e$var$load("duvLw").then(()=>parcelRequire('S3xVJ'));

});

parcelRegister("eDzD9", function(module, exports) {

let $aa8058af4e74a3ea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aa8058af4e74a3ea$var$load("8qNMQ").then(()=>parcelRequire('3iotu'));

});

parcelRegister("2mx5U", function(module, exports) {

let $1b874eaa8ba63bbd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1b874eaa8ba63bbd$var$load("dNYjV").then(()=>parcelRequire('4imFK'));

});

parcelRegister("1PMkZ", function(module, exports) {

let $15600cad976edbfa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $15600cad976edbfa$var$load("32TIL").then(()=>parcelRequire('kdnv1'));

});

parcelRegister("hWVm9", function(module, exports) {

let $d114582f0ecfa392$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d114582f0ecfa392$var$load("4k4DB").then(()=>parcelRequire('2Bci7'));

});

parcelRegister("jSqbS", function(module, exports) {

let $e787605956345cfa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e787605956345cfa$var$load("3hRC4").then(()=>parcelRequire('1JfdL'));

});

parcelRegister("1VVPw", function(module, exports) {

let $1687f920947107f9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1687f920947107f9$var$load("cMWPa").then(()=>parcelRequire('f2zu1'));

});

parcelRegister("3xs7D", function(module, exports) {

let $293a44a4d90a99d2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $293a44a4d90a99d2$var$load("7nNMy").then(()=>parcelRequire('48pWg'));

});

parcelRegister("dNusO", function(module, exports) {

let $a0b77b71f61a3689$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a0b77b71f61a3689$var$load("6YMb9").then(()=>parcelRequire('1W4wY'));

});

parcelRegister("dilgY", function(module, exports) {

let $9add751bd0e6f3fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9add751bd0e6f3fc$var$load("5YJ3b").then(()=>parcelRequire('9GMD8'));

});

parcelRegister("7sfMS", function(module, exports) {

let $56d764f58e2caf97$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $56d764f58e2caf97$var$load("lbbXI").then(()=>parcelRequire('5bnnd'));

});

parcelRegister("yNAPT", function(module, exports) {
module.exports = JSON.parse("{\"jira-glance-panel-navigation-arrows.spotlight.body\":[{\"type\":0,\"value\":\"View your work in a side panel or modal, and navigate both contextually.\"}],\"jira-glance-panel-navigation-arrows.spotlight.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"jira-glance-panel-navigation-arrows.spotlight.headline\":[{\"type\":0,\"value\":\"Control how you view work\"}],\"jira-glance-panel-navigation-arrows.spotlight.image-alt\":[{\"type\":0,\"value\":\"Navigation arrows on the glance panel\"}],\"jira-glance-panel-navigation-arrows.spotlight.primary-action\":[{\"type\":0,\"value\":\"OK\"}],\"jira-work-item-view-native-projects-field.body\":[{\"type\":0,\"value\":\"Your existing project connections have moved to the new field. Nothing to set up.\"}],\"jira-work-item-view-native-projects-field.button.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"jira-work-item-view-native-projects-field.button.done\":[{\"type\":0,\"value\":\"Got it\"}],\"jira-work-item-view-native-projects-field.headline\":[{\"type\":0,\"value\":\"Projects are now part of Jira\"}],\"jira-work-item-view-native-projects-field.image-alt\":[{\"type\":0,\"value\":\"Illustration showing a native Atlas project smart card pointing to the project interface\"}],\"jira-work-item-view-native-projects-field.tp.body\":[{\"type\":0,\"value\":\"Connect your work to a project, track progress, and easily share updates.\"}],\"jira-work-item-view-native-projects-field.tp.button.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"jira-work-item-view-native-projects-field.tp.button.done\":[{\"type\":0,\"value\":\"Try Projects\"}],\"jira-work-item-view-native-projects-field.tp.headline\":[{\"type\":0,\"value\":\"Share updates with Projects\"}],\"jira-work-item-view-native-projects-field.tp.image-alt\":[{\"type\":0,\"value\":\"Illustration showing the new Projects field in the Jira work item view, ready to connect work to a project\"}]}");

});

parcelRegister("at6ge", function(module, exports) {

let $79f178108ab18d07$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $79f178108ab18d07$var$load("cPx82").then(()=>parcelRequire('4hxe6'));

});

parcelRegister("h3LQV", function(module, exports) {

let $c6b7d6093eebdc1c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c6b7d6093eebdc1c$var$load("jmw3U").then(()=>parcelRequire('hM9EQ'));

});

parcelRegister("iDANl", function(module, exports) {

let $d918693b8dc072bf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d918693b8dc072bf$var$load("jIY8J").then(()=>parcelRequire('gaGff'));

});

parcelRegister("bsAiM", function(module, exports) {

let $857e78062daffadf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $857e78062daffadf$var$load("6Im4e").then(()=>parcelRequire('423mv'));

});

parcelRegister("6lyYa", function(module, exports) {

let $49efd474e2bf0f7b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $49efd474e2bf0f7b$var$load("LkFfU").then(()=>parcelRequire('iEoTz'));

});

parcelRegister("8qi8n", function(module, exports) {

let $621ed17838251034$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $621ed17838251034$var$load("1pIYU").then(()=>parcelRequire('aJQZ1'));

});

parcelRegister("6XkOd", function(module, exports) {

let $510865024b64a943$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $510865024b64a943$var$load("8uldz").then(()=>parcelRequire('h6kf3'));

});

parcelRegister("d67Hj", function(module, exports) {

let $9891ce762bd21c08$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9891ce762bd21c08$var$load("gsBNh").then(()=>parcelRequire('eZokD'));

});

parcelRegister("1keZ4", function(module, exports) {

let $0f73483179005c93$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0f73483179005c93$var$load("2JDUr").then(()=>parcelRequire('8cRf6'));

});

parcelRegister("2nKnU", function(module, exports) {

let $1bc1b5c06d1c1687$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1bc1b5c06d1c1687$var$load("ct4Di").then(()=>parcelRequire('2h44e'));

});

parcelRegister("gWLXI", function(module, exports) {

let $c5674465eb5a96e5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c5674465eb5a96e5$var$load("ldiqw").then(()=>parcelRequire('4oKje'));

});

parcelRegister("1BDAL", function(module, exports) {

let $12b7f54f53aa7859$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $12b7f54f53aa7859$var$load("gZpRF").then(()=>parcelRequire('5iuuv'));

});

parcelRegister("jtjTT", function(module, exports) {

let $e2d02998bb39a6e6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e2d02998bb39a6e6$var$load("eW0Rv").then(()=>parcelRequire('8DqwB'));

});

parcelRegister("e1N2p", function(module, exports) {

let $a3673290bdaad900$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a3673290bdaad900$var$load("gh5bR").then(()=>parcelRequire('5sDgs'));

});

parcelRegister("9lyX3", function(module, exports) {

let $6ce12fdd5399002d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6ce12fdd5399002d$var$load("gGssw").then(()=>parcelRequire('lJYd4'));

});

parcelRegister("dTUIP", function(module, exports) {

let $a1ec69364dc0b553$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a1ec69364dc0b553$var$load("1umq9").then(()=>parcelRequire('e17RD'));

});

parcelRegister("04MZU", function(module, exports) {

let $00e661b848004445$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $00e661b848004445$var$load("1oqKK").then(()=>parcelRequire('2SIpH'));

});

parcelRegister("dVWXL", function(module, exports) {

let $a24e560c6f43d315$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a24e560c6f43d315$var$load("1q3a9").then(()=>parcelRequire('8EwCw'));

});

parcelRegister("a8PaN", function(module, exports) {

let $762258a9de3bd80d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $762258a9de3bd80d$var$load("72nL8").then(()=>parcelRequire('cFX9N'));

});

parcelRegister("jCefS", function(module, exports) {

let $e47c9fb3ba1433a8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e47c9fb3ba1433a8$var$load("6euaV").then(()=>parcelRequire('ZsA5q'));

});

parcelRegister("9V8bE", function(module, exports) {

let $738fc9b0ab0518a5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $738fc9b0ab0518a5$var$load("caRmm").then(()=>parcelRequire('f6VVd'));

});

parcelRegister("1mMbt", function(module, exports) {

let $0fed38d8bc66260e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0fed38d8bc66260e$var$load("6zNJe").then(()=>parcelRequire('a5gXS'));

});

parcelRegister("1F49G", function(module, exports) {

let $135cd7e38ba6aa28$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $135cd7e38ba6aa28$var$load("f3j46").then(()=>parcelRequire('kphPq'));

});

parcelRegister("a7MkY", function(module, exports) {

let $75f00d9b6aec54b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $75f00d9b6aec54b8$var$load("eOjuo").then(()=>parcelRequire('8VrZ8'));

});

parcelRegister("c736q", function(module, exports) {

let $8d188b9daf0f36dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8d188b9daf0f36dd$var$load("gohsw").then(()=>parcelRequire('63W9D'));

});

parcelRegister("fYv7t", function(module, exports) {

let $ba14994d805741a1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ba14994d805741a1$var$load("3mUOz").then(()=>parcelRequire('2sa3n'));

});

parcelRegister("5GFdo", function(module, exports) {

let $4240d86d4cf5cefc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4240d86d4cf5cefc$var$load("3M9cg").then(()=>parcelRequire('3Zxzs'));

});

parcelRegister("aBTMj", function(module, exports) {

let $7b98a08097656745$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7b98a08097656745$var$load("fZZSN").then(()=>parcelRequire('d0QDj'));

});

parcelRegister("bDOVy", function(module, exports) {

let $879ad759a198f9b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $879ad759a198f9b1$var$load("Iwd00").then(()=>parcelRequire('1rAfd'));

});

parcelRegister("euBtw", function(module, exports) {

let $a8d0efd2a242ca44$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a8d0efd2a242ca44$var$load("aUyl6").then(()=>parcelRequire('jXJDf'));

});

parcelRegister("cMpDF", function(module, exports) {

let $94dddb0d6bbc4b6c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $94dddb0d6bbc4b6c$var$load("6rAtd").then(()=>parcelRequire('dWZ0T'));

});

parcelRegister("cPYe2", function(module, exports) {

let $9588f6f21593c378$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9588f6f21593c378$var$load("dcGu1").then(()=>parcelRequire('bS1nb'));

});

parcelRegister("fgCrG", function(module, exports) {

let $b1d62c189c3d1af1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b1d62c189c3d1af1$var$load("h2u4q").then(()=>parcelRequire('77uPd'));

});

parcelRegister("hkOdi", function(module, exports) {

let $c9eb41419735db42$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c9eb41419735db42$var$load("lNJhK").then(()=>parcelRequire('2HGNz'));

});

parcelRegister("fyclM", function(module, exports) {
module.exports = JSON.parse('{"post-office.attachment-consolidation-add-create.spotlight.body":[{"type":0,"value":"Find your pages, videos, and files in one place. You can search for existing content or upload new files directly."}],"post-office.attachment-consolidation-add-create.spotlight.got-it":[{"type":0,"value":"Got it"}],"post-office.attachment-consolidation-add-create.spotlight.headline":[{"type":0,"value":"Confluence and Loom are now in Attachments"}],"post-office.jira-issue-view-contextual-survey.dismiss-label":[{"type":0,"value":"Dismiss survey"}],"post-office.jira-issue-view-contextual-survey.highest-score-label":[{"type":0,"value":"Very easy"}],"post-office.jira-issue-view-contextual-survey.lowest-score-label":[{"type":0,"value":"Not very easy"}],"post-office.jira-issue-view-contextual-survey.question":[{"type":0,"value":"We\u2019d love to hear from you"}],"post-office.jira-issue-view-contextual-survey.scale-button-label":[{"type":1,"value":"score"},{"type":0,"value":" out of 5"}],"post-office.jira-issue-view-contextual-survey.statement":[{"type":0,"value":"How easy is it to get work done in this view?"}],"post-office.jira-issue-view-contextual-survey.submit-label":[{"type":0,"value":"Submit"}],"post-office.jira-issue-view-contextual-survey.text-description":[{"type":0,"value":"Your feedback will be used to improve our products."}],"post-office.jira-issue-view-contextual-survey.text-label":[{"type":0,"value":"What influenced your rating? (optional)"}],"post-office.jira-issue-view-contextual-survey.thank-you":[{"type":0,"value":"Thanks for your feedback"}]}');

});

parcelRegister("cGd1k", function(module, exports) {

let $93b381d76b95e833$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $93b381d76b95e833$var$load("cdpBA").then(()=>parcelRequire('6LAvj'));

});

parcelRegister("3HDjE", function(module, exports) {

let $2b23e29a91ebb6e6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2b23e29a91ebb6e6$var$load("kDqdQ").then(()=>parcelRequire('iMThV'));

});

parcelRegister("hAAl0", function(module, exports) {

let $cce1fc6187654d32$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cce1fc6187654d32$var$load("bfJHQ").then(()=>parcelRequire('gkqjf'));

});

parcelRegister("ky6Rt", function(module, exports) {

let $ef5c4e261239d155$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ef5c4e261239d155$var$load("wk5oE").then(()=>parcelRequire('8b5so'));

});

parcelRegister("aU26J", function(module, exports) {

let $7f00c4dd708118b9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7f00c4dd708118b9$var$load("8MTmw").then(()=>parcelRequire('dDCfi'));

});

parcelRegister("4FonW", function(module, exports) {

let $365de827786c9700$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $365de827786c9700$var$load("dNgq6").then(()=>parcelRequire('kZIz1'));

});

parcelRegister("6uKj4", function(module, exports) {

let $4ba976f668204103$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ba976f668204103$var$load("lyCUB").then(()=>parcelRequire('54zFO'));

});

parcelRegister("3tAQa", function(module, exports) {

let $2880a83e99ead708$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2880a83e99ead708$var$load("hdwzT").then(()=>parcelRequire('95Tgt'));

});

parcelRegister("1HVDx", function(module, exports) {

let $13e68409d80b942e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $13e68409d80b942e$var$load("2LUAT").then(()=>parcelRequire('krj0u'));

});

parcelRegister("9CafP", function(module, exports) {

let $6fff9df531b8d666$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6fff9df531b8d666$var$load("d3NsJ").then(()=>parcelRequire('fkI6f'));

});

parcelRegister("6ltLd", function(module, exports) {

let $49ebca0fa3253ab9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $49ebca0fa3253ab9$var$load("gezlD").then(()=>parcelRequire('fdaQW'));

});

parcelRegister("i16Fe", function(module, exports) {

let $d1dd7d4e847eee83$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d1dd7d4e847eee83$var$load("fMJgW").then(()=>parcelRequire('hFmfH'));

});

parcelRegister("6r2ld", function(module, exports) {

let $4af714989f672f83$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4af714989f672f83$var$load("b3qLT").then(()=>parcelRequire('jQmuA'));

});

parcelRegister("kf1O9", function(module, exports) {

let $ebc69c5a0b9a6098$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ebc69c5a0b9a6098$var$load("hkRB5").then(()=>parcelRequire('jZ5Re'));

});

parcelRegister("b4nzq", function(module, exports) {

let $80f25a0577d579e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $80f25a0577d579e8$var$load("hU08q").then(()=>parcelRequire('1dLFm'));

});

parcelRegister("ljPEV", function(module, exports) {

let $f85371b716abd4b6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f85371b716abd4b6$var$load("6T4uM").then(()=>parcelRequire('i2jiX'));

});

parcelRegister("8KduJ", function(module, exports) {

let $65dd165aca026ca8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $65dd165aca026ca8$var$load("eHweH").then(()=>parcelRequire('8NaJc'));

});

parcelRegister("hMJjt", function(module, exports) {

let $cf2a1197cae8ed6f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cf2a1197cae8ed6f$var$load("aO1ri").then(()=>parcelRequire('gOPsU'));

});

parcelRegister("40c6r", function(module, exports) {

let $2ea08ce46248e367$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2ea08ce46248e367$var$load("6E1jP").then(()=>parcelRequire('10L4G'));

});

parcelRegister("6LxVi", function(module, exports) {

let $4ed1724840812fa3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ed1724840812fa3$var$load("42LBe").then(()=>parcelRequire('9CqS1'));

});

parcelRegister("7p3Ya", function(module, exports) {

let $563df276cb808438$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $563df276cb808438$var$load("jY5FA").then(()=>parcelRequire('7TJiG'));

});

parcelRegister("dIGoT", function(module, exports) {

let $9fd04645058aab7e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9fd04645058aab7e$var$load("hmx8U").then(()=>parcelRequire('jeoCN'));

});

parcelRegister("aX1s8", function(module, exports) {

let $7f908a95adc004c0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7f908a95adc004c0$var$load("am7EO").then(()=>parcelRequire('4hdme'));

});

parcelRegister("c3rCu", function(module, exports) {

let $8c6b308dce44e2f4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8c6b308dce44e2f4$var$load("gJgz9").then(()=>parcelRequire('8G00A'));

});

parcelRegister("dVLoB", function(module, exports) {

let $a2455d07f8d23c6f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a2455d07f8d23c6f$var$load("ecpU2").then(()=>parcelRequire('aDeUo'));

});

parcelRegister("j5CRW", function(module, exports) {

let $de5ca2882f6e68d6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $de5ca2882f6e68d6$var$load("jk6JR").then(()=>parcelRequire('bjaXE'));

});

parcelRegister("lg8vL", function(module, exports) {

let $f7a1b1ca7d5a8ed7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f7a1b1ca7d5a8ed7$var$load("fIF1Z").then(()=>parcelRequire('lyQOo'));

});

parcelRegister("9jSrV", function(module, exports) {

let $6c901ff0c6999c70$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6c901ff0c6999c70$var$load("pse3c").then(()=>parcelRequire('b5CQZ'));

});

parcelRegister("92SVU", function(module, exports) {

let $695ee98177f70b55$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $695ee98177f70b55$var$load("haODU").then(()=>parcelRequire('6R04P'));

});

parcelRegister("aghh8", function(module, exports) {

let $7788cc88aef11ff8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7788cc88aef11ff8$var$load("cehMQ").then(()=>parcelRequire('fnCRV'));

});

parcelRegister("kksE6", function(module, exports) {

let $eccbe55b8e307df5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eccbe55b8e307df5$var$load("a3uJJ").then(()=>parcelRequire('6Mo1N'));

});

parcelRegister("2Di42", function(module, exports) {

let $1ead3c70427089b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1ead3c70427089b1$var$load("kEI64").then(()=>parcelRequire('bzsMv'));

});

parcelRegister("mhkYP", function(module, exports) {

let $042f810885b0d1b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $042f810885b0d1b8$var$load("2KjDN").then(()=>parcelRequire('1lLHB'));

});

parcelRegister("bAQal", function(module, exports) {

let $870b8591c0267912$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $870b8591c0267912$var$load("gOkzU").then(()=>parcelRequire('fiapf'));

});

parcelRegister("c8Pyb", function(module, exports) {
module.exports = JSON.parse('{"growth-jira-onboarding.Contact-us":[{"type":0,"value":"Contact us"}],"growth-jira-onboarding.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"growth-jira-onboarding.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"growth-jira-onboarding.footer.dot-separator":[{"type":0,"value":"\u2022"}],"growth-jira-onboarding.footer.facebook-alt-text":[{"type":0,"value":"Facebook"}],"growth-jira-onboarding.footer.facebook-title":[{"type":0,"value":"Facebook"}],"growth-jira-onboarding.footer.footer-links.contact-us":[{"type":1,"value":"contactLink"}],"growth-jira-onboarding.footer.footer-links.privacy-policy":[{"type":1,"value":"privacyPolicy"}],"growth-jira-onboarding.footer.footer-links.read-our-blog":[{"type":1,"value":"thirdText"}],"growth-jira-onboarding.footer.linkedin-alt-text":[{"type":0,"value":"LinkedIn"}],"growth-jira-onboarding.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"growth-jira-onboarding.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"growth-jira-onboarding.footer.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"growth-jira-onboarding.footer.read-our-blog":[{"type":0,"value":"Read our blog"}],"growth-jira-onboarding.footer.x-alt-text":[{"type":0,"value":"X"}],"growth-jira-onboarding.footer.x-title":[{"type":0,"value":"X"}],"growth-jira-onboarding.footer.youtube-alt-text":[{"type":0,"value":"Youtube"}],"growth-jira-onboarding.footer.youtube-title":[{"type":0,"value":"Youtube"}],"growth-jira-onboarding.invite-reminder-with-board-activity.customer-logos.alt":[{"type":0,"value":"Customer logos including Twilio, NASA, Illumina, Docker, and Morningstar"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.board-heading":[{"type":0,"value":"Join in on your team\u2019s recent work"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.board-heading-text":[{"type":0,"value":"Here\u2019s what everyone\u2019s been up to in Jira:"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.button-text":[{"type":0,"value":"Start collaborating"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.button-text.join-now":[{"type":0,"value":"Join now"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.button-view-all":[{"type":0,"value":"View all work"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.column.assignee":[{"type":0,"value":"Assignee"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.column.due-date":[{"type":0,"value":"Due date"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.column.status":[{"type":0,"value":"Status"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.column.summary":[{"type":0,"value":"Summary"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.created-by":[{"type":0,"value":"Created by "},{"type":1,"value":"projectAdmin"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.header-admin-only":[{"type":1,"value":"projectAdmin"},{"type":0,"value":" is waiting for you to join \'"},{"type":1,"value":"projectName"},{"type":0,"value":"\'"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.header-many-user":[{"type":1,"value":"projectAdmin"},{"type":0,"value":" and "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" other"}]},"other":{"value":[{"type":7},{"type":0,"value":" others"}]}},"pluralType":"cardinal","type":6,"value":"otherUsers"},{"type":0,"value":" are waiting for you to join \'"},{"type":1,"value":"projectName"},{"type":0,"value":"\'"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.in-body-header":[{"type":0,"value":"Your team is waiting for you to join them in Jira"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.subject.no-translate":[{"type":0,"value":"Reminder: You\u2019ve been invited to plan and track work in Jira"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.status.category.done":[{"type":0,"value":"Done"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.status.category.inProgress":[{"type":0,"value":"In Progress"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.status.category.todo":[{"type":0,"value":"To Do"}],"growth-jira-onboarding.invite-reminder-with-board-activity.social-proof.text":[{"children":[{"type":0,"value":"Jira is the #1 project management tool"}],"type":8,"value":"b"},{"type":0,"value":" where over 75,000+ customers plan and track work across every team."}],"growth-jira-onboarding.invite-reminder-with-board-activitye.message-template.email.project-launch":[{"type":1,"value":"projectName"}],"growth-jira-onboarding.jira-issueview-description-title-final.screen-space-flags.description.no-translate":[{"type":0,"value":"Replace this with a short summary of what this message tells the recipient."}],"growth-jira-onboarding.jira-issueview-description-title-final.screen-space-flags.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.body-text":[{"children":[{"type":0,"value":"Jira is the #1 project management tool"}],"type":8,"value":"b"},{"type":0,"value":" where over 75,000+ customers plan and track work across every team."}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.button-text":[{"type":0,"value":"Join now"}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.created-by":[{"type":0,"value":"Created by "},{"type":1,"value":"projectAdmin"}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.header":[{"type":0,"value":"Start collaborating with your team in Jira"}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.invite-nudge.banner":[{"type":0,"value":"\uD83D\uDC4B "},{"children":[{"type":0,"value":"Forward this email"}],"type":8,"value":"b"},{"type":0,"value":" to easily invite more teammates"}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.project-launch":[{"type":1,"value":"filteredProjectName"},{"type":0,"value":" Launch"}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.subject.start-collaborating":[{"type":0,"value":"Start collaborating with your team on "},{"type":1,"value":"filteredProjectName"}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.unsubscribe-link-text":[{"children":[{"type":0,"value":"Unsubscribe"}],"type":8,"value":"a"},{"type":0,"value":" to opt out of future emails like this"}],"growth-jira-onboarding.jira-side-nav-mature-example-project-space-setup.screen-space-flags.description.no-translate":[{"type":0,"value":"Replace this with a short summary of what this message tells the recipient."}],"growth-jira-onboarding.jira-side-nav-mature-example-project-space-setup.screen-space-flags.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"jira-sidebar-nav-day-x-notification.body-text":[{"type":0,"value":"We\u2019ve added features to boost your productivity. "},{"children":[{"type":0,"value":"Customize your sidebar"}],"type":8,"value":"strong"},{"type":0,"value":" to change what shows up."}],"jira-sidebar-nav-day-x-notification.button-text":[{"type":0,"value":"Got it"}],"post-office.components.email.default-project-name":[{"type":0,"value":"Big Campaign"}],"post-office.components.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"post-office.components.email.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.growth-jira-onboarding-common.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.growth-jira-onboarding-common.footer.contact-us":[{"type":0,"value":" Contact us \u2022 "}],"post-office.growth-jira-onboarding-common.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"post-office.growth-jira-onboarding-common.footer.facebook-alt-text":[{"type":0,"value":"Facebook"}],"post-office.growth-jira-onboarding-common.footer.facebook-title":[{"type":0,"value":"Facebook"}],"post-office.growth-jira-onboarding-common.footer.footer-links.contact-us":[{"type":1,"value":"contactLink"}],"post-office.growth-jira-onboarding-common.footer.footer-links.join-atlassian-community":[{"type":1,"value":"joinAtlassianCommunity"}],"post-office.growth-jira-onboarding-common.footer.footer-links.privacy-policy":[{"type":1,"value":"privacyPolicy"}],"post-office.growth-jira-onboarding-common.footer.footer-links.read-in-browser":[{"type":1,"value":"readInBrowser"}],"post-office.growth-jira-onboarding-common.footer.footer-links.read-our-blog":[{"type":0,"value":" "},{"type":1,"value":"thirdText"}],"post-office.growth-jira-onboarding-common.footer.join-atlassian-community":[{"type":0,"value":"Join Atlassian Community"}],"post-office.growth-jira-onboarding-common.footer.linkedin-alt-text":[{"type":0,"value":"LinkedIn"}],"post-office.growth-jira-onboarding-common.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"post-office.growth-jira-onboarding-common.footer.office-address":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.growth-jira-onboarding-common.footer.partner-portal":[{"type":0,"value":"Partner Portal"}],"post-office.growth-jira-onboarding-common.footer.privacy-policy":[{"type":0,"value":"Privacy Policy \u2022 "}],"post-office.growth-jira-onboarding-common.footer.read-in-browser":[{"type":0,"value":"Read in browser \u2022 "}],"post-office.growth-jira-onboarding-common.footer.read-our-blog":[{"type":0,"value":"Read our blog \u2022 "}],"post-office.growth-jira-onboarding-common.footer.twitter-alt-text":[{"type":0,"value":"Twitter"}],"post-office.growth-jira-onboarding-common.footer.twitter-title":[{"type":0,"value":"Twitter"}],"post-office.growth-jira-onboarding-common.footer.unsubscribe":[{"type":0,"value":"If you no longer wish to receive these emails, please update your preferences or "},{"type":1,"value":"unsubscribe"},{"type":0,"value":" here."}],"post-office.growth-jira-onboarding-common.footer.unsubscribeText":[{"type":0,"value":"unsubscribe"}],"post-office.growth-jira-onboarding-common.jira-email-header.atlassian-text":[{"type":0,"value":"Atlassian"}],"post-office.growth-jira-onboarding-common.jira-email-header.jira-logo-alt-text":[{"type":0,"value":"Jira"}],"post-office.growth-jira-onboarding-common.jira-email-header.jira-text":[{"type":0,"value":"Jira"}],"post-office.growth-jira-onboarding.jira-messaging-research-recruitment.screen-space-flags.description":[{"type":0,"value":"Tell us about your setup experience and we\u2019ll send you a $100 gift card as a thank you."}],"post-office.growth-jira-onboarding.jira-messaging-research-recruitment.screen-space-flags.header":[{"type":0,"value":"Join our paid research study \uD83D\uDCB8"}],"post-office.growth-jira-onboarding.jira-rovo-spotlight.screen-space-flags.body":[{"type":0,"value":"Use Rovo to create structured tasks, connect agents, and organize work."}],"post-office.growth-jira-onboarding.jira-rovo-spotlight.screen-space-flags.cta":[{"type":0,"value":"Try now"}],"post-office.growth-jira-onboarding.jira-rovo-spotlight.screen-space-flags.headline":[{"type":0,"value":"Try a suggested action"}],"post-office.growth-jira-onboarding.jira-setup-user-interviews-signup.screen-space-flags.cta-link":[{"type":0,"value":"Join now"}],"post-office.test-placement.jonboarding-jira-side-nav-projects.dismiss-button.no-translate":[{"type":0,"value":"Dismiss"}]}');

});

parcelRegister("72yBg", function(module, exports) {

let $52038f2383e9cbf9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $52038f2383e9cbf9$var$load("8odnZ").then(()=>parcelRequire('fTfl4'));

});

parcelRegister("34CHz", function(module, exports) {

let $23cfc42dced5091a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $23cfc42dced5091a$var$load("8wMqD").then(()=>parcelRequire('ivsNK'));

});

parcelRegister("kMKcN", function(module, exports) {

let $f21c21c1180751e2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f21c21c1180751e2$var$load("2qVSg").then(()=>parcelRequire('cJ54O'));

});

parcelRegister("apltJ", function(module, exports) {

let $793ce66279b24fc0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $793ce66279b24fc0$var$load("4tZMg").then(()=>parcelRequire('h2Non'));

});

parcelRegister("3K0Yv", function(module, exports) {

let $2b966c98080a9ed7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2b966c98080a9ed7$var$load("1HQlP").then(()=>parcelRequire('4cuP7'));

});

parcelRegister("djKWK", function(module, exports) {

let $9b21775555292613$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9b21775555292613$var$load("3EoTF").then(()=>parcelRequire('8Q6P1'));

});

parcelRegister("01utY", function(module, exports) {

let $0047bd511cd29ad3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0047bd511cd29ad3$var$load("3ouij").then(()=>parcelRequire('k0hrO'));

});

parcelRegister("24m3m", function(module, exports) {

let $181d0fd2054fb836$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $181d0fd2054fb836$var$load("5nLLr").then(()=>parcelRequire('7yALc'));

});

parcelRegister("96EuC", function(module, exports) {

let $6a14159d7fe61856$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6a14159d7fe61856$var$load("41TS2").then(()=>parcelRequire('cMyrd'));

});

parcelRegister("2U42d", function(module, exports) {

let $21d3f0f429691f1a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $21d3f0f429691f1a$var$load("gZdf8").then(()=>parcelRequire('3QdN6'));

});

parcelRegister("7Gz2R", function(module, exports) {

let $5987a3df77fce068$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5987a3df77fce068$var$load("7TrUY").then(()=>parcelRequire('jbQXQ'));

});

parcelRegister("eJudw", function(module, exports) {

let $ab9cb520164014c5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ab9cb520164014c5$var$load("5NBva").then(()=>parcelRequire('ekj5i'));

});

parcelRegister("jWXSm", function(module, exports) {

let $e861e129e0e16b8e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e861e129e0e16b8e$var$load("6JkpT").then(()=>parcelRequire('a3SKX'));

});

parcelRegister("d0CCF", function(module, exports) {

let $97893c1dd4bda325$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $97893c1dd4bda325$var$load("9wWCX").then(()=>parcelRequire('dZSv1'));

});

parcelRegister("hVgMi", function(module, exports) {

let $d0c4c64d498cd55c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d0c4c64d498cd55c$var$load("1zzxF").then(()=>parcelRequire('96XsG'));

});

parcelRegister("aqAkV", function(module, exports) {

let $797884c1aeabe436$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $797884c1aeabe436$var$load("78lVo").then(()=>parcelRequire('l65Qx'));

});

parcelRegister("8jPAN", function(module, exports) {

let $60e81e49af87893d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $60e81e49af87893d$var$load("9K4EB").then(()=>parcelRequire('fEcy1'));

});

parcelRegister("hJ1Ua", function(module, exports) {

let $ce781dee1895fa28$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ce781dee1895fa28$var$load("H4Ms4").then(()=>parcelRequire('8pT9o'));

});

parcelRegister("a9ymm", function(module, exports) {

let $764565bbafad35a9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $764565bbafad35a9$var$load("2pkVK").then(()=>parcelRequire('C4qTk'));

});

parcelRegister("dqohW", function(module, exports) {

let $9c608b3fae8b5ef6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9c608b3fae8b5ef6$var$load("er5Jq").then(()=>parcelRequire('6raEW'));

});

parcelRegister("c5L14", function(module, exports) {

let $8cda6c229977823b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8cda6c229977823b$var$load("3BOlE").then(()=>parcelRequire('61ISI'));

});

parcelRegister("1xaV8", function(module, exports) {

let $11e1581581285ff8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $11e1581581285ff8$var$load("dTjN8").then(()=>parcelRequire('5kzRw'));

});

parcelRegister("htHe6", function(module, exports) {

let $cb96acf6c2d39f05$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cb96acf6c2d39f05$var$load("3SCPB").then(()=>parcelRequire('64vuc'));

});

parcelRegister("8xsok", function(module, exports) {

let $63776dbbe981f098$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $63776dbbe981f098$var$load("kaDNR").then(()=>parcelRequire('fWA8k'));

});

parcelRegister("id7hU", function(module, exports) {

let $d41f181cf6c6e377$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d41f181cf6c6e377$var$load("iSHt2").then(()=>parcelRequire('5I7hK'));

});

parcelRegister("fy3FM", function(module, exports) {

let $b51ce157a7fb2544$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b51ce157a7fb2544$var$load("fELfG").then(()=>parcelRequire('42zOJ'));

});

parcelRegister("5NLRP", function(module, exports) {

let $4396a8cc561d5430$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4396a8cc561d5430$var$load("hHg56").then(()=>parcelRequire('2e3vn'));

});

parcelRegister("94DnD", function(module, exports) {

let $69b308d7e99b14c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $69b308d7e99b14c3$var$load("eURYs").then(()=>parcelRequire('k8Syd'));

});

parcelRegister("juHGP", function(module, exports) {

let $e312b58b069d2ac2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e312b58b069d2ac2$var$load("kVxUh").then(()=>parcelRequire('6ABC3'));

});

parcelRegister("a2UWN", function(module, exports) {

let $750643d3ad37a6cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $750643d3ad37a6cb$var$load("9HyuV").then(()=>parcelRequire('9Zqjk'));

});

parcelRegister("5PbVc", function(module, exports) {

let $43daf690170dc602$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $43daf690170dc602$var$load("fBe3V").then(()=>parcelRequire('fbkQ6'));

});

parcelRegister("amBbx", function(module, exports) {

let $78b8cda3540900a5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $78b8cda3540900a5$var$load("fYTt7").then(()=>parcelRequire('eWcXO'));

});

parcelRegister("fkh2h", function(module, exports) {

let $b285f032781f4b5a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b285f032781f4b5a$var$load("hQcxQ").then(()=>parcelRequire('heR7q'));

});

parcelRegister("40r0l", function(module, exports) {

let $2eac1c126e885df6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2eac1c126e885df6$var$load("cHbKu").then(()=>parcelRequire('3G11Q'));

});

parcelRegister("gK3zM", function(module, exports) {
module.exports = JSON.parse('{"jira-pandora.common.footer.address.no-translate":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"jira-pandora.common.footer.copyright.no-translate":[{"type":0,"value":"Copyright 2025 Atlassian Pty Ltd. All rights reserved."}],"jira-pandora.common.project-access-email.banner.alt":[{"type":0,"value":"Jira banner image"}],"jira-pandora.jira-onboarding-hub-welcome-modal.screen-space-flags.description.no-translate":[{"type":0,"value":"At Atlassian, we use Jira to plan and manage work. We created a Jira board to help you manage your onboarding to-do list (you may have a separate list if you\u2019re in TEAM Camp). This Jira board is filled with tasks, required to-do\'s, and recommended content. You can think of it as your personal tracker for the onboarding process! Follow it each day and be sure to mark items complete."}],"jira-pandora.jira-onboarding-hub-welcome-modal.screen-space-flags.title.no-translate":[{"type":0,"value":"Hi Newlassian, welcome to Jira!"}],"jira-pandora.jira-project-access-granted.email.body.content":[{"type":0,"value":"You can now access "},{"children":[{"type":1,"value":"projectName"}],"type":8,"value":"b"}],"jira-pandora.jira-project-access-granted.email.body.redacted.content":[{"children":[{"type":0,"value":"You can now access your Jira project"}],"type":8,"value":"b"}],"jira-pandora.jira-project-access-granted.email.button.redacted.text":[{"type":0,"value":"View project"}],"jira-pandora.jira-project-access-granted.email.button.text":[{"type":0,"value":"View project"}],"jira-pandora.jira-project-access-granted.message-template.email.redacted.subject":[{"type":0,"value":"You\'ve been granted access to your project"}],"jira-pandora.jira-project-access-granted.message-template.email.subject":[{"type":0,"value":"You\'ve been granted access to "},{"type":1,"value":"projectName"}],"jira-pandora.jira-project-access-request-reminder.email.body.content":[{"type":0,"value":"Users have requested to join "},{"children":[{"type":1,"value":"projectName"}],"type":8,"value":"b"},{"type":0,"value":" project"}],"jira-pandora.jira-project-access-request-reminder.email.body.redacted.content":[{"children":[{"type":0,"value":"Users have requested to join your Jira project"}],"type":8,"value":"b"}],"jira-pandora.jira-project-access-request-reminder.email.button.redacted.text":[{"type":0,"value":"View access requests"}],"jira-pandora.jira-project-access-request-reminder.email.button.text":[{"type":0,"value":"View access requests"}],"jira-pandora.jira-project-access-request-reminder.message-template.email.redacted.subject":[{"type":0,"value":"Access request for your project"}],"jira-pandora.jira-project-access-request-reminder.message-template.email.subject":[{"type":0,"value":"Access request for "},{"type":1,"value":"projectName"}],"jira-sprints-auto-managed-feature-discovery.spotlight-content":[{"type":0,"value":"Sprints can now start and complete automatically based on their scheduled dates."}],"jira-sprints-auto-managed-feature-discovery.spotlight-cta-button-label":[{"type":0,"value":"See how"}],"jira-sprints-auto-managed-feature-discovery.spotlight-headline":[{"type":0,"value":"Automate your sprint transitions"}]}');

});

parcelRegister("dC2IS", function(module, exports) {

let $9e90efa6c4f35e23$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9e90efa6c4f35e23$var$load("j91ZG").then(()=>parcelRequire('7D5qo'));

});

parcelRegister("aIZAP", function(module, exports) {

let $7cedca82960e51c8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7cedca82960e51c8$var$load("eqb80").then(()=>parcelRequire('3R11v'));

});

parcelRegister("hWcFz", function(module, exports) {

let $d0f1ae51b50ed4be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d0f1ae51b50ed4be$var$load("7U0ZZ").then(()=>parcelRequire('kSReM'));

});

parcelRegister("i96r9", function(module, exports) {

let $d35e0f82ab6414a6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d35e0f82ab6414a6$var$load("dFx6Z").then(()=>parcelRequire('hxna1'));

});

parcelRegister("3nia2", function(module, exports) {

let $27519b7bc2d3145c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $27519b7bc2d3145c$var$load("3ZKoa").then(()=>parcelRequire('29L2I'));

});

parcelRegister("da2r6", function(module, exports) {

let $994e194c25680776$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $994e194c25680776$var$load("lG9oH").then(()=>parcelRequire('1srhl'));

});

parcelRegister("bXNpI", function(module, exports) {

let $8b5b88f50c71bc2b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8b5b88f50c71bc2b$var$load("iFAZb").then(()=>parcelRequire('8WQ9T'));

});

parcelRegister("66n3X", function(module, exports) {

let $4715316a88f66b8d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4715316a88f66b8d$var$load("3qfa1").then(()=>parcelRequire('eZNsU'));

});

parcelRegister("cpZ6Z", function(module, exports) {

let $90a7395d788ada6e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $90a7395d788ada6e$var$load("4X4ps").then(()=>parcelRequire('gRIfA'));

});

parcelRegister("4ET6R", function(module, exports) {

let $3645a57fb3848d5c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3645a57fb3848d5c$var$load("flwJx").then(()=>parcelRequire('fX373'));

});

parcelRegister("9VSom", function(module, exports) {

let $73b3a108640df010$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $73b3a108640df010$var$load("fWeSS").then(()=>parcelRequire('imzoA'));

});

parcelRegister("SDfFq", function(module, exports) {

let $0a437dd45ab69394$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0a437dd45ab69394$var$load("bVmut").then(()=>parcelRequire('cvfgq'));

});

parcelRegister("bt1SJ", function(module, exports) {

let $8593dcd73d1efee3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8593dcd73d1efee3$var$load("67MZP").then(()=>parcelRequire('4Ag7T'));

});

parcelRegister("lzChE", function(module, exports) {

let $fb4a9037f3c22e54$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fb4a9037f3c22e54$var$load("aYIpK").then(()=>parcelRequire('gfniG'));

});

parcelRegister("hXmDf", function(module, exports) {

let $d12980a1590d6e1f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d12980a1590d6e1f$var$load("6IsAQ").then(()=>parcelRequire('hbq8w'));

});

parcelRegister("aUZ8j", function(module, exports) {

let $7f2e8e1f856077ae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7f2e8e1f856077ae$var$load("9RuM8").then(()=>parcelRequire('3clIp'));

});

parcelRegister("1u6AF", function(module, exports) {

let $114db481c6ee5500$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $114db481c6ee5500$var$load("bbY5v").then(()=>parcelRequire('dEoj3'));

});

parcelRegister("sImHY", function(module, exports) {

let $056507a806be8009$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $056507a806be8009$var$load("bBEqB").then(()=>parcelRequire('f9qcJ'));

});

parcelRegister("fcZIE", function(module, exports) {

let $b127da2843347986$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b127da2843347986$var$load("hZuNW").then(()=>parcelRequire('bd79y'));

});

parcelRegister("16P0m", function(module, exports) {

let $0cedea745db8bf19$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0cedea745db8bf19$var$load("fCREn").then(()=>parcelRequire('6lQ38'));

});

parcelRegister("7vwBZ", function(module, exports) {

let $5774b9a5dc5a4d4b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5774b9a5dc5a4d4b$var$load("j3ukk").then(()=>parcelRequire('4izHB'));

});

parcelRegister("cVRT2", function(module, exports) {

let $96a49bad274603e6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $96a49bad274603e6$var$load("aCEjw").then(()=>parcelRequire('lXjqY'));

});

parcelRegister("8JdZ1", function(module, exports) {

let $65ad5f7cc86c22c1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $65ad5f7cc86c22c1$var$load("7rweH").then(()=>parcelRequire('fh4F3'));

});

parcelRegister("guipf", function(module, exports) {

let $c00db9c2fd1fd5a0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c00db9c2fd1fd5a0$var$load("hp02C").then(()=>parcelRequire('byToY'));

});

parcelRegister("k0CnR", function(module, exports) {

let $e91194f8470d664b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e91194f8470d664b$var$load("f1zfJ").then(()=>parcelRequire('in4jU'));

});

parcelRegister("b8ebr", function(module, exports) {

let $81ab719f6bb031a6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $81ab719f6bb031a6$var$load("8MNFC").then(()=>parcelRequire('7gyT3'));

});

parcelRegister("6NLKW", function(module, exports) {

let $4f3c5d13033f0bb6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4f3c5d13033f0bb6$var$load("6ELou").then(()=>parcelRequire('kIehH'));

});

parcelRegister("kh1Vy", function(module, exports) {

let $ec26e3ea75b9d40a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ec26e3ea75b9d40a$var$load("jh1c7").then(()=>parcelRequire('5AXUg'));

});

parcelRegister("3gqHa", function(module, exports) {

let $260792d113d7c388$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $260792d113d7c388$var$load("9S5ny").then(()=>parcelRequire('lJ1bX'));

});

parcelRegister("gVvdw", function(module, exports) {

let $c52a2f47ad5f5828$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c52a2f47ad5f5828$var$load("hIDvy").then(()=>parcelRequire('drmZg'));

});

parcelRegister("3vvpd", function(module, exports) {

let $28dca0debc1645a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $28dca0debc1645a4$var$load("gXhOE").then(()=>parcelRequire('frwJg'));

});

parcelRegister("4yDFm", function(module, exports) {

let $35191b46f85ed341$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $35191b46f85ed341$var$load("jq7RW").then(()=>parcelRequire('5uBij'));

});

parcelRegister("9ZMNS", function(module, exports) {

let $746faaea66037fcd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $746faaea66037fcd$var$load("bc9eO").then(()=>parcelRequire('kjvLv'));

});

parcelRegister("dFCLX", function(module, exports) {

let $9f3d2e1a8a86bc5d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9f3d2e1a8a86bc5d$var$load("8DjHZ").then(()=>parcelRequire('debUt'));

});

parcelRegister("h89dU", function(module, exports) {
module.exports = JSON.parse('{"ai-rovo.actions-software-backlog.nudge-description.nonfinal":[{"type":0,"value":"We have identified "},{"type":1,"value":"numberOfSuggestions"},{"type":0,"value":" work item "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"update"}]},"other":{"value":[{"type":0,"value":"updates"}]}},"pluralType":"cardinal","type":6,"value":"numberOfSuggestions"}],"ai-rovo.actions-software-backlog.nudge-icon-label.nonfinal":[{"type":0,"value":"Work items icon"}],"ai-rovo.actions-software-backlog.nudge-title.nonfinal":[{"type":0,"value":"You have "},{"type":1,"value":"numberOfSuggestions"},{"type":0,"value":" work item "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"update"}]},"other":{"value":[{"type":0,"value":"updates"}]}},"pluralType":"cardinal","type":6,"value":"numberOfSuggestions"}],"jira-issueview-quickactions.src.ui.index.recommended-for-you":[{"type":0,"value":"Recommended for you"}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.description.now":[{"type":0,"value":"Everything else about how you use these containers remains the same."}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.description.soon":[{"type":0,"value":"Jira \'projects\' will soon be renamed \'spaces\'"}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.learn-more":[{"type":0,"value":"Read more about this change"}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.title.now":[{"type":0,"value":"Jira \'projects\' are now called \'spaces\'"}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.title.soon":[{"type":0,"value":"Coming soon"}],"jira-pulsar.common.components.cross-flow.add":[{"type":0,"value":"Add"}],"jira-pulsar.common.components.cross-flow.dismiss":[{"type":0,"value":"Dismiss"}],"jira-pulsar.common.components.issue-view-description-ad.close":[{"type":0,"value":"Close"}],"jira-pulsar.jira-comment-mention.message-template.notification-drawer.message":[{"type":1,"value":"user1"},{"type":0,"value":" mentioned you in a comment"}],"jira-pulsar.jira-comment-mention.message-template.notification-drawer.message.anonymous":[{"type":0,"value":"You\'ve been mentioned in a comment"}],"jira-pulsar.jira-common.celebration-icon.body_image_alt":[{"type":0,"value":"Celebration icon"}],"jira-pulsar.jira-common.exclamation-icon.body_image_alt":[{"type":0,"value":"Exclamation icon"}],"jira-pulsar.jira-common.jira-logo.alt_text":[{"type":0,"value":"Jira logo"}],"jira-pulsar.jira-common.message-template.text.body.display.old.field.value":[{"type":0,"value":"was: "},{"type":1,"value":"oldFieldValue"}],"jira-pulsar.jira-common.redesign.footer.atlassian-logo.no-translate":[{"type":0,"value":"Atlassian logo"}],"jira-pulsar.jira-common.right-arrow-icon.no-translate":[{"type":0,"value":"&#x2192;"}],"jira-pulsar.jira-contact-admin.message-template.email.body.from.contact.admin":[{"type":0,"value":"From:"}],"jira-pulsar.jira-contact-admin.message-template.email.body.new.message.from.contact.admin":[{"type":0,"value":"New message from Contact Administrators page"}],"jira-pulsar.jira-contact-admin.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"header"}],"jira-pulsar.jira-issue-approval-decided.right.arrow.image.alt.no-translate":[{"type":0,"value":"->"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.assigned.to":[{"type":0,"value":"Assigned to: "},{"type":1,"value":"assignee"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.event.approvers":[{"type":0,"value":"Approvers: "}],"jira-pulsar.jira-issue-approval.message-template.email.approval.event.approvers.plus.no-translate":[{"type":0,"value":"+"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.issue.approved.by.user.subject":[{"type":1,"value":"user"},{"type":0,"value":" has approved "},{"type":1,"value":"issueLabel"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.issue.approved.subject":[{"type":1,"value":"issueLabel"},{"type":0,"value":" has been approved"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.issue.declined.by.user.subject":[{"type":1,"value":"user"},{"type":0,"value":" has declined "},{"type":1,"value":"issueLabel"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.required":[{"type":1,"value":"issueLink"},{"type":0,"value":" requires your approval"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.required.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"issueLabel"}],"jira-pulsar.jira-issue-approval.message-template.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"jira-pulsar.jira-issue-approval.message-template.email.unassigned":[{"type":0,"value":"Unassigned"}],"jira-pulsar.jira-issue-archived.message-template.redacted.email.subject":[{"type":0,"value":"("},{"type":1,"value":"issueKey"},{"type":0,"value":") work item was archived"}],"jira-pulsar.jira-issue-assign.message-template-template.email.body.heading":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"assigned"}],"type":8,"value":"b"},{"type":0,"value":" this work item to you"}],"jira-pulsar.jira-issue-assign.message-template.email.html.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"type":1,"value":"issueKey"},{"type":0,"value":" to you"}],"jira-pulsar.jira-issue-assign.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"type":1,"value":"issueKey"},{"type":0,"value":" to you"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.direct.assigned.anonymous.issue-terminology-refresh-m4":[{"type":0,"value":"You\'ve been assigned to "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.direct.assigned.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"},{"type":0,"value":" to you"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.direct.unassigned.anonymous.issue-terminology-refresh-m4":[{"type":0,"value":"You\'ve been unassigned from "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.direct.unassigned.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" unassigned you from "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.assigned.anonymous":[{"type":0,"value":"There\'s a new assignee on an issue"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.assigned.anonymous.issue-terminology-refresh-m4":[{"type":0,"value":"There\'s a new assignee on "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.assigned.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"},{"type":0,"value":" to "},{"type":1,"value":"newAssignee"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.assignee.change.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" reassigned "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"},{"type":0,"value":" from "},{"type":1,"value":"oldAssignee"},{"type":0,"value":" to "},{"type":1,"value":"newAssignee"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.unassigned.anonymous.issue-terminology-refresh-m4":[{"type":0,"value":"The "},{"options":{"Bug":{"value":[{"type":0,"value":"bug\'s"}]},"Epic":{"value":[{"type":0,"value":"epic\'s"}]},"Generalrequest":{"value":[{"type":0,"value":"request\'s"}]},"Idea":{"value":[{"type":0,"value":"idea\'s"}]},"Story":{"value":[{"type":0,"value":"story\'s"}]},"Subtask":{"value":[{"type":0,"value":"subtask\'s"}]},"Task":{"value":[{"type":0,"value":"task\'s"}]},"other":{"value":[{"type":0,"value":"work item\'s"}]}},"type":5,"value":"issueType"},{"type":0,"value":" assignee has been removed"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.unassigned.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" unassigned "},{"type":1,"value":"oldAssignee"},{"type":0,"value":" from "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-assigned.email.body.assignee":[{"type":0,"value":"Assignee"}],"jira-pulsar.jira-issue-assigned.email.body.unassigned":[{"type":0,"value":"Unassigned"}],"jira-pulsar.jira-issue-comment-delete.email.body.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-comment-delete.message-template.hipppa.view.update":[{"type":0,"value":"Comment: "},{"children":[{"type":0,"value":"View update"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-comment-delete.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-comment-update.email.body.added":[{"type":0,"value":"Added"}],"jira-pulsar.jira-issue-comment-update.email.body.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-comment-update.email.body.edited":[{"type":0,"value":"Edited"}],"jira-pulsar.jira-issue-comment-update.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") "},{"type":1,"value":"summary"}],"jira-pulsar.jira-issue-comment-update.message-template.notification-drawer.message.anonymous.issue-terminology-refresh-m4":[{"type":0,"value":"There\'s a new update in a comment on "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-comment-update.message-template.notification-drawer.message.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" updated the comment on "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-comment-update.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-comment.body_image_alt":[{"type":0,"value":"Icon for comment on a Jira issue"}],"jira-pulsar.jira-issue-comment.email.body.add-comment":[{"type":0,"value":"Add comment"}],"jira-pulsar.jira-issue-comment.email.body.view-comment":[{"type":0,"value":"View comment"}],"jira-pulsar.jira-issue-comment.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-comment.message-template.notification-drawer.message.anonymous.issue-terminology-refresh-m4":[{"type":0,"value":"There\'s a new comment on "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-comment.message-template.notification-drawer.message.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-create.email.body.unassigned":[{"type":0,"value":"Unassigned"}],"jira-pulsar.jira-issue-create.message-template.notification-drawer.message":[{"type":1,"value":"user"},{"type":0,"value":" created "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-delete.message-template.notification-drawer.message":[{"type":1,"value":"user"},{"type":0,"value":" deleted "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-mention.message-template.notification-drawer.message.anonymous.issue-terminology-refresh-m4":[{"type":0,"value":"You\'ve been mentioned on "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-mention.message-template.notification-drawer.message.issue-terminology-refresh-m4":[{"type":1,"value":"user1"},{"type":0,"value":" mentioned you on "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-moved.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-moved.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"issueKey"},{"type":0,"value":" Work item was updated"}],"jira-pulsar.jira-issue-reopen.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"jira-pulsar.jira-issue-reopen.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jira-pulsar.jira-issue-reopen.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"jira-pulsar.jira-issue-reopen.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"jira-pulsar.jira-issue-reopened.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-transitioned.message-template.notification-drawer.message.anonymous.issue-terminology-refresh-m4":[{"options":{"Bug":{"value":[{"type":0,"value":"A bug"}]},"Epic":{"value":[{"type":0,"value":"An epic"}]},"Generalrequest":{"value":[{"type":0,"value":"A request"}]},"Idea":{"value":[{"type":0,"value":"An idea"}]},"Story":{"value":[{"type":0,"value":"A story"}]},"Subtask":{"value":[{"type":0,"value":"A subtask"}]},"Task":{"value":[{"type":0,"value":"A task"}]},"other":{"value":[{"type":0,"value":"A work item"}]}},"type":5,"value":"issueType"},{"type":0,"value":" has been transitioned from "},{"type":1,"value":"fromStatus"},{"type":0,"value":" to "},{"type":1,"value":"toStatus"}],"jira-pulsar.jira-issue-transitioned.message-template.notification-drawer.message.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" changed "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"},{"type":0,"value":" from "},{"type":1,"value":"fromStatus"},{"type":0,"value":" to "},{"type":1,"value":"toStatus"}],"jira-pulsar.jira-issue-update.email.body.slash.no-translate":[{"type":0,"value":" \u2192 "}],"jira-pulsar.jira-issue-update.message-template.changeby":[{"type":0,"value":"Change by: "},{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-update.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-update.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-update.message-template.hipppa.view.update":[{"children":[{"type":0,"value":"View update"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-update.message-template.notification-drawer.message":[{"type":1,"value":"user"},{"type":0,"value":" updated "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-work-started.message-template.email.body.started":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"started work on this work item"}],"type":8,"value":"color"}],"jira-pulsar.jira-issue-work-started.message-template.email.redacted.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-work-stopped.message-template.email.body.stopped":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"stopped work on this work item"}],"type":8,"value":"color"}],"jira-pulsar.jira-issue-work-stopped.message-template.email.redacted.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-worklog-delete.email.body.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-worklog-delete.email.body.work.log.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-worklog-update.email.body.edited":[{"type":0,"value":"Edited"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.add.worklog.title":[{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"},{"type":0,"value":" "},{"children":[{"type":0,"value":"added a worklog"}],"type":8,"value":"strong"},{"type":0,"value":" on "},{"children":[{"type":1,"value":"issueKey"}],"type":8,"value":"b"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.change.by":[{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.add.comment":[{"children":[{"type":0,"value":"Add Comment"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.description":[{"children":[{"type":0,"value":"View work description"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.entry.logged.by":[{"type":1,"value":"entry"},{"type":0,"value":" logged by "},{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklogged.body_image_alt":[{"type":0,"value":"Product logo"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.confluence":[{"type":0,"value":"Confluence"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.ctaMessageForIssueComment":[{"type":0,"value":"Try"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.descriptionForIssuecomment":[{"type":0,"value":"Put the details in a page to keep the description short"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.titleForIssueComment":[{"type":0,"value":"Create a page"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.confluence":[{"type":0,"value":"Confluence"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.ctaMessageForIssueDescription":[{"type":0,"value":"Try"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.descriptionForIssueDescription":[{"type":0,"value":"Put the details in a page to keep the description short"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.titleForIssueDescription":[{"type":0,"value":"Create a page"}],"jira-xflow-confluence.placements.in-app.jira-issueview-quickactions.add":[{"type":0,"value":"Add"}],"jira-xflow-confluence.placements.in-app.jira-issueview-quickactions.confluence":[{"type":0,"value":"Confluence"}],"jira-xflow-confluence.placements.in-app.jira-issueview-quickactions.page":[{"type":0,"value":"Page"}],"jira-xflow-jpd.placements.in-app.jira-issueview-comment-template.ctaMessageForIssueComment":[{"type":0,"value":"Try"}],"jira-xflow-jpd.placements.in-app.jira-issueview-comment-template.descriptionForIssuecomment":[{"type":0,"value":"Capture ideas and insights"}],"jira-xflow-jpd.placements.in-app.jira-issueview-comment-template.jpd":[{"type":0,"value":"Jira Product Discovery"}],"jira-xflow-jpd.placements.in-app.jira-issueview-description-template.ctaMessageForIssueDescription":[{"type":0,"value":"Try"}],"jira-xflow-jpd.placements.in-app.jira-issueview-description-template.descriptionForIssueDescription":[{"type":0,"value":"Capture ideas and insights"}],"jira-xflow-jpd.placements.in-app.jira-issueview-description-template.jpd":[{"type":0,"value":"Jira Product Discovery"}],"jira-xflow-jpd.placements.in-app.jira-issueview-description-template.titleForIssueDescription":[{"type":0,"value":"Idea"}],"jira-xflow-jpd.placements.in-app.jira-issueview-quickactions.add":[{"type":0,"value":"Add"}],"jira-xflow-jpd.placements.in-app.jira-issueview-quickactions.idea":[{"type":0,"value":"Idea"}],"jira-xflow-jpd.placements.in-app.jira-issueview-quickactions.jpd":[{"type":0,"value":"Jira Product Discovery"}],"jira-xflow-loom.placements.in-app.jira-issueview-comment.ctaMessageForIssueComment":[{"type":0,"value":"Try"}],"jira-xflow-loom.placements.in-app.jira-issueview-comment.descriptionForIssuecomment":[{"type":0,"value":"Record a comment"}],"jira-xflow-loom.placements.in-app.jira-issueview-comment.loom":[{"type":0,"value":"Loom"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.ctaMessageForIssueDescription":[{"type":0,"value":"Try"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.descriptionForIssueDescription":[{"type":0,"value":"Use video to explain the work"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.loom":[{"type":0,"value":"Loom"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.titleForIssueDescription":[{"type":0,"value":"Record your screen"}],"jira-xflow-loom.placements.in-app.jira-issueview-quickactions.add":[{"type":0,"value":"Add"}],"jira-xflow-loom.placements.in-app.jira-issueview-quickactions.loom":[{"type":0,"value":"Loom"}],"jira-xflow-loom.placements.in-app.jira-issueview-quickactions.video":[{"type":0,"value":"Video"}],"jira.default.subject":[{"type":0,"value":"[JIRA] Project Update: "},{"type":1,"value":"projectName"},{"type":0,"value":" ("},{"type":1,"value":"projectKey"},{"type":0,"value":")"}],"jira.jira-bulk.message-template.email.header":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"sent you"}],"type":8,"value":"strong"},{"type":0,"value":" a message."}],"jira.jira-bulk.message-template.email.subject.user.provided.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"subject"}],"jira.jira-bulk.message-template.text.message":[{"type":1,"value":"user"},{"type":0,"value":" sent you a message"}],"jira.jira-common.email.addon-banner.gmail":[{"type":0,"value":"Gmail"}],"jira.jira-common.email.addon-banner.install-text":[{"type":0,"value":"Install the Atlassian email extension for "},{"type":1,"value":"gmailLink"},{"type":0,"value":" or "},{"type":1,"value":"outlookLink"},{"type":0,"value":"."}],"jira.jira-common.email.addon-banner.main-text":[{"type":0,"value":"Update work items without leaving your inbox."}],"jira.jira-common.email.addon-banner.opt-out":[{"type":0,"value":"Don\'t show again"}],"jira.jira-common.email.addon-banner.outlook":[{"type":0,"value":"Outlook"}],"jira.jira-common.email.addon-banner.tip":[{"type":0,"value":"Tip:"}],"jira.jira-common.email.dot-separator.no-translate":[{"type":0,"value":" \u2022 "}],"jira.jira-common.email.footer.custom.message":[{"type":1,"value":"footerText"}],"jira.jira-common.email.footer.download.app-store.no-translate":[{"type":0,"value":"Download on the App Store"}],"jira.jira-common.email.footer.get-on.google-play.no-translate":[{"type":0,"value":"Get it on Google Play"}],"jira.jira-common.email.footer.get.apps":[{"type":0,"value":"Get Jira notifications on your phone! Download the Jira Cloud app for "}],"jira.jira-common.email.footer.get.apps.new":[{"type":0,"value":"Get Jira notifications on your phone! Download the Jira Cloud app for "},{"children":[{"type":0,"value":"Android"}],"type":8,"value":"a1"},{"type":0,"value":" or "},{"children":[{"type":0,"value":"iOS"}],"type":8,"value":"a2"},{"type":0,"value":"."}],"jira.jira-common.email.footer.give.feedback":[{"type":0,"value":"Give feedback"}],"jira.jira-common.email.footer.manage.notifications":[{"type":0,"value":"Manage Notifications"}],"jira.jira-common.email.footer.open.attachment":[{"type":0,"value":"Open the work item to view attachments over 100 KB"}],"jira.jira-common.email.footer.privacy.policy":[{"type":0,"value":"Privacy Policy"}],"jira.jira-common.email.footer.sent-by-atlassian-jira":[{"type":0,"value":"This email was sent by Atlassian Jira"}],"jira.jira-common.email.footer.sent.by":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-common.email.footer.unsubscribe-message":[{"type":0,"value":"If you no longer wish to receive these emails, please update your preferences or unsubscribe "},{"children":[{"type":0,"value":"here"}],"type":8,"value":"link"},{"type":0,"value":"."}],"jira.jira-common.email.slash.no-translate":[{"type":0,"value":"/"}],"jira.jira-common.email.twg-cli-banner.link-text":[{"type":0,"value":"Teamwork Graph CLI"}],"jira.jira-common.email.twg-cli-banner.text":[{"type":0,"value":"Give your AI agents rich Jira context with fewer credits. Query open work items and dependencies with "},{"type":1,"value":"twgCliLink"},{"type":0,"value":"."}],"jira.jira-common.email.twg-cli-banner.tip":[{"type":0,"value":"Tip:"}],"jira.jira-common.message-template.text.body.assignee.label":[{"type":0,"value":"Assignee:"}],"jira.jira-common.message-template.text.body.attachments.label":[{"type":0,"value":"Attachments:"}],"jira.jira-common.message-template.text.body.key.label":[{"type":0,"value":"Key:"}],"jira.jira-common.message-template.text.body.manage.notifications":[{"type":0,"value":"Manage Notifications"}],"jira.jira-common.message-template.text.body.priority.label":[{"type":0,"value":"Priority:"}],"jira.jira-common.message-template.text.body.project.label":[{"type":0,"value":"Project:"}],"jira.jira-common.message-template.text.body.reporter.heading":[{"type":0,"value":"Reporter: "}],"jira.jira-common.message-template.text.body.reporter.label":[{"type":0,"value":"Reporter:"}],"jira.jira-common.message-template.text.body.sent.by":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-common.message-template.text.body.work.type.label":[{"type":0,"value":"Work type:"}],"jira.jira-filter-subscription.message-template.email.table.filter-label":[{"type":0,"value":"Filter: "}],"jira.jira-filter-subscription.message-template.email.table.header":[{"type":0,"value":"Work Item Subscription"}],"jira.jira-filter-subscription.message-template.email.table.subscriber-label":[{"type":0,"value":"Subscriber:"}],"jira.jira-issue-approval-decided.message-template.approval.by.user":[{"type":1,"value":"user"},{"type":0,"value":" has approved "},{"type":1,"value":"issueLink"}],"jira.jira-issue-approval-decided.message-template.approval.event.allapproved.transition":[{"type":1,"value":"issueTypeName"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.approval.event.approved.transition.plural":[{"type":1,"value":"remainingApprovals"},{"type":0,"value":" more approvals required to move this "},{"type":1,"value":"issueTypeName"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.approval.event.approved.transition.singular":[{"type":0,"value":"1 more approval required to move this "},{"type":1,"value":"issueTypeName"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.approval.event.declined.transition":[{"type":1,"value":"issueTypeName"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.declined.by.user":[{"type":1,"value":"user"},{"type":0,"value":" has declined "},{"type":1,"value":"issueLink"}],"jira.jira-issue-approval.message-template.approval.required.title":[{"type":1,"value":"issueLabel"},{"type":0,"value":" requires your approval"}],"jira.jira-issue-approval.message-template.approval.title.all-approved":[{"type":1,"value":"issueLink"},{"type":0,"value":" has been approved!"}],"jira.jira-issue-approval.message-template.email.approval.approved":[{"type":0,"value":"Approved"}],"jira.jira-issue-approval.message-template.email.approval.approvers.remaining":[{"type":1,"value":"remainingApprovers"},{"type":0,"value":" more approvals required to move this "},{"type":1,"value":"issueType"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"approvedStatus"}],"jira.jira-issue-approval.message-template.email.approval.assigned.to":[{"type":0,"value":"Assigned to: "},{"type":1,"value":"assignee"}],"jira.jira-issue-approval.message-template.email.approval.declined":[{"type":0,"value":"Declined"}],"jira.jira-issue-approval.message-template.email.approval.declined.transition":[{"type":1,"value":"issueType"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"declinedStatus"}],"jira.jira-issue-approval.message-template.email.approval.event.approvers":[{"type":0,"value":"Approvers: "}],"jira.jira-issue-approval.message-template.email.approval.one.approver.remaining":[{"type":0,"value":"1 more approval required to move this "},{"type":1,"value":"issueType"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"approvedStatus"}],"jira.jira-issue-approval.message-template.email.approval.view.work.item":[{"type":0,"value":"View "},{"type":1,"value":"issueType"}],"jira.jira-issue-approval.message-template.email.approved.by":[{"type":1,"value":"deciderName"},{"type":0,"value":" has approved "},{"type":1,"value":"issueLabel"}],"jira.jira-issue-approval.message-template.email.declined.by":[{"type":1,"value":"deciderName"},{"type":0,"value":" has declined "},{"type":1,"value":"issueLabel"}],"jira.jira-issue-approval.message-template.email.footer.contact.us":[{"type":0,"value":"Contact Us"}],"jira.jira-issue-approval.message-template.email.footer.location":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"jira.jira-issue-approval.message-template.email.footer.privacy.policy":[{"type":0,"value":"Privacy Policy"}],"jira.jira-issue-approval.message-template.email.issue.approved":[{"type":1,"value":"issueLabel"},{"type":0,"value":" has been approved!"}],"jira.jira-issue-approval.message-template.email.issue.has.moved.from":[{"type":1,"value":"issueType"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"approvedStatus"}],"jira.jira-issue-archived.message-template.email.subject":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"archived a work item."}],"type":8,"value":"strong"}],"jira.jira-issue-archived.message-template.redacted.email.subject":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"archived a work item."}],"type":8,"value":"strong"}],"jira.jira-issue-archived.message-template.text.archived.work.item":[{"type":1,"value":"user"},{"type":0,"value":" archived "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-assign.text.body.assigned":[{"type":0,"value":" "},{"type":1,"value":"user"},{"type":0,"value":" reassigned "},{"type":1,"value":"issueKey"}],"jira.jira-issue-assign.text.body.assignee.update":[{"type":0,"value":"Assignee: "},{"type":1,"value":"assigneeName"},{"type":0,"value":" was: ("},{"type":1,"value":"oldAssigneeName"},{"type":0,"value":")"}],"jira.jira-issue-assign.text.body.sentby":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-issue-batch.email.body.issue.comments.heading":[{"type":0,"value":"Comments"}],"jira.jira-issue-batch.email.body.issue.created.heading":[{"type":0,"value":"Work item created"}],"jira.jira-issue-batch.email.body.issue.updates.heading":[{"type":0,"value":"Updates"}],"jira.jira-issue-batch.email.body.issue.worklog.heading":[{"type":0,"value":"Work log"}],"jira.jira-issue-batch.email.body.summary.issue.comment.created.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" added a new comment"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" new comments"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.comment.created.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" new comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.created.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" new comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.deleted.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" deleted a comment"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.comment.deleted.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.deleted.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.updated.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" updated a comment"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.comment.updated.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.updated.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.created.heading":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"created a work item"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.deleted.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" deleted a work item"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work items"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.dot":[{"type":0,"value":". "}],"jira.jira-issue-batch.email.body.summary.issue.fallback.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.fallback.more.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.fallback.two.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.separator.comma":[{"type":0,"value":", "}],"jira.jira-issue-batch.email.body.summary.issue.updates.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"type":1,"value":"count"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.updates.multiple.users.heading":[{"type":1,"value":"user"},{"type":0,"value":" and "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" other person"}]},"other":{"value":[{"type":7},{"type":0,"value":" other people"}]}},"pluralType":"cardinal","type":6,"value":"userCount"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  made "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"an update"}]},"other":{"value":[{"type":1,"value":"count"},{"type":0,"value":" updates"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.updates.two.users.heading":[{"type":1,"value":"user"},{"type":0,"value":" and "},{"type":1,"value":"user1"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  made "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"an update"}]},"other":{"value":[{"type":1,"value":"count"},{"type":0,"value":" updates"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.added.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" added a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.added.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.added.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" deleted a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.started.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" started a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  started "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.started.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  started "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.started.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  started "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.updated.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" updated a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.updated.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.updated.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.unredacted.body.summary.issue.fallback.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.unredacted.body.summary.issue.fallback.more.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.unredacted.body.summary.issue.fallback.two.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issueId"},{"type":0,"value":") "},{"type":1,"value":"summary"}],"jira.jira-issue-batch.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] Updates for "},{"type":1,"value":"issueId"}],"jira.jira-issue-closed.message-template.email.body.closed":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"closed a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-closed.message-template.email.body.closed.redesigned":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"closed a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-closed.message-template.text.email.body":[{"type":1,"value":"user"},{"type":0,"value":" closed "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-comment-delete.message-template.email.body.commented":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"deleted a comment on a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-comment-delete.message-template.text.comment.was.deleted":[{"type":0,"value":"Comment: was deleted"}],"jira.jira-issue-comment-delete.message-template.text.updated.work.item":[{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-comment-update.message-template.email.body.commented":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"edited a comment on a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-comment-update.message-template.text.body.comment.was":[{"type":0,"value":"was (Author: "},{"type":1,"value":"authorName"},{"type":0,"value":"):"}],"jira.jira-issue-comment-update.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" edited a comment on "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-comment.message-template.email.body.commented":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"added a comment on a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-comment.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-common.message-template.text.body.common.author":[{"type":0,"value":"Author:"}],"jira.jira-issue-common.message-template.text.body.common.issue.author":[{"type":0,"value":"Author:"}],"jira.jira-issue-create.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"created a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-create.email.body.view.attachments":[{"type":0,"value":"View Attachments"}],"jira.jira-issue-create.email.body.view.components":[{"type":0,"value":"View Components"}],"jira.jira-issue-create.email.body.view.description":[{"type":0,"value":"View description"}],"jira.jira-issue-create.email.body.view.environment":[{"type":0,"value":"View environment"}],"jira.jira-issue-create.email.body.view.labels":[{"type":0,"value":"View labels"}],"jira.jira-issue-create.email.body.view.work.type":[{"type":0,"value":"View Work Type"}],"jira.jira-issue-create.message-template.email.original.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issueKey"},{"type":0,"value":") "},{"type":1,"value":"summary"}],"jira.jira-issue-create.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" created "},{"type":1,"value":"issueKey"}],"jira.jira-issue-create.message-template.text.body.common.issue.key":[{"type":0,"value":"Key"}],"jira.jira-issue-create.message-template.text.body.common.summary":[{"type":0,"value":"Summary"}],"jira.jira-issue-create.message-template.text.email.body.created":[{"type":1,"value":"user"},{"type":0,"value":" created a work item"}],"jira.jira-issue-create.text.body.common.assignee":[{"type":0,"value":"Assignee"}],"jira.jira-issue-create.text.body.common.attachments":[{"type":0,"value":"Attachments"}],"jira.jira-issue-create.text.body.common.created":[{"type":0,"value":"Created"}],"jira.jira-issue-create.text.body.common.description":[{"type":0,"value":"Description"}],"jira.jira-issue-create.text.body.common.priority":[{"type":0,"value":"Priority"}],"jira.jira-issue-create.text.body.common.reporter":[{"type":0,"value":"Reporter"}],"jira.jira-issue-create.text.body.common.status":[{"type":0,"value":"Status"}],"jira.jira-issue-create.text.body.common.work.type":[{"type":0,"value":"Work type"}],"jira.jira-issue-delete.message-template.email.body.workitem.deleted":[{"type":1,"value":"actioner"},{"type":0,"value":" deleted this work item at "},{"type":1,"value":"timestamp"}],"jira.jira-issue-delete.message-template.redacted.email.body.workitem.deleted":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"deleted"}],"type":8,"value":"strong"},{"type":0,"value":" a work item"}],"jira.jira-issue-delete.message-template.text.deleted.work.item":[{"type":1,"value":"user"},{"type":0,"value":" deleted "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-filter-subscription.message-template.email.subject":[{"type":0,"value":"[JIRA] Subscription: "},{"type":1,"value":"filterName"}],"jira.jira-issue-filter-subscription.message-template.text.email.body.header":[{"type":0,"value":"Work Item Subscription"}],"jira.jira-issue-filter-subscription.message-template.text.email.body.header.filter-name":[{"type":0,"value":"Filter: "},{"type":1,"value":"filterName"},{"type":1,"value":"count"}],"jira.jira-issue-filter-subscription.message-template.text.email.body.header.subscriber-info":[{"type":0,"value":"Subscriber: "},{"type":1,"value":"subscriberName"}],"jira.jira-issue-mention.email.body.colon.no-translate":[{"type":0,"value":": "}],"jira.jira-issue-mention.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"mentioned you"}],"type":8,"value":"strong"},{"type":0,"value":" on a work item"}],"jira.jira-issue-mention.email.body.mentioned.you":[{"type":0,"value":" mentioned you "}],"jira.jira-issue-mention.email.body.onWorkItem.you":[{"type":0,"value":" on a work item "}],"jira.jira-issue-mention.email.body.spaces.no-translate":[{"type":0,"value":"&nbsp;&nbsp;"}],"jira.jira-issue-mention.email.body.view.work.item":[{"type":0,"value":" View work item "}],"jira.jira-issue-mention.email.subject.mention":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"issueKey"}],"jira.jira-issue-mention.push.mentioned.you":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"summary"}],"jira.jira-issue-mention.push.mentioned.you.redacted":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on this work item"}],"jira.jira-issue-mention.text.body.addComment":[{"type":0,"value":" Add Comment: "}],"jira.jira-issue-mention.text.body.manage.notifications":[{"type":0,"value":"Manage Notifications"}],"jira.jira-issue-mention.text.body.mention.hint":[{"type":0,"value":" Hint: You can mention someone in a work item description or comment by typing  \\"@\\" in front of their username."}],"jira.jira-issue-mention.text.body.mentioned":[{"type":0,"value":" mentioned you on "}],"jira.jira-issue-mention.text.body.sentby":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-issue-mention.text.body.unassigned":[{"type":0,"value":"Unassigned"}],"jira.jira-issue-mention.text.body.viewOnline":[{"type":0,"value":" View Online: "}],"jira.jira-issue-moved.message-template.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"moved a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-moved.message-template.text.email.body":[{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-notify.email.body.heading":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"b"},{"type":0,"value":" a work item with you"}],"jira.jira-issue-notify.email.body.heading.redesigned":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"b"},{"type":0,"value":" a work item with you"}],"jira.jira-issue-notify.email.subject.notify":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" shared \\""},{"type":1,"value":"issueKey"},{"type":0,"value":" "},{"type":1,"value":"summary"},{"type":0,"value":"\\" with you"}],"jira.jira-issue-reopened.message-template.email.body.reopened":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"reopened a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-reopened.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" reopened "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-resolved.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" resolved "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-search.message-template.email.subject.filter.results":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" shared the filter \\""},{"type":1,"value":"filterName"},{"type":0,"value":"\\" with you"}],"jira.jira-issue-search.message-template.email.subject.search.results":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" shared a search result with you"}],"jira.jira-issue-share.message-template.email.header.filter":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"strong"},{"type":0,"value":" a filter with you."}],"jira.jira-issue-share.message-template.email.header.results":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"strong"},{"type":0,"value":" a search result with you."}],"jira.jira-issue-share.message-template.email.shared-with":[{"type":0,"value":" Also shared with "}],"jira.jira-issue-share.message-template.email.view.results":[{"type":0,"value":"View search results"}],"jira.jira-issue-share.message-template.text.shared.filter.heading":[{"type":1,"value":"user"},{"type":0,"value":" shared a filter with you"}],"jira.jira-issue-share.message-template.text.shared.results.heading":[{"type":1,"value":"user"},{"type":0,"value":" shared a search result with you"}],"jira.jira-issue-share.message-template.text.shared.with.others":[{"type":0,"value":"Also shared with"}],"jira.jira-issue-test.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] test template "},{"type":1,"value":"issueKey"}],"jira.jira-issue-update.message-template.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"updated a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-update.message-template.email.body.created.redesigned":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"updated a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-update.message-template.email.body.worklog.change.by":[{"type":0,"value":"Change by: "}],"jira.jira-issue-update.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-work-started.message-template.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"made "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" update"}]},"other":{"value":[{"type":7},{"type":0,"value":" updates"}]}},"pluralType":"cardinal","type":6,"value":"numberOfUpdates"}],"type":8,"value":"strong"}],"jira.jira-issue-work-started.message-template.email.body.created.redesigned":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"made "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" update"}]},"other":{"value":[{"type":7},{"type":0,"value":" updates"}]}},"pluralType":"cardinal","type":6,"value":"numberOfUpdates"}],"type":8,"value":"strong"}],"jira.jira-issue-work-started.message-template.text.header":[{"type":0,"value":"Work on "},{"type":1,"value":"workItemKey"},{"type":0,"value":" started by "},{"type":1,"value":"user"}],"jira.jira-issue-work-stopped.message-template.text.header":[{"type":0,"value":"Work on "},{"type":1,"value":"workItemKey"},{"type":0,"value":" stopped by "},{"type":1,"value":"user"}],"jira.jira-issue-worklog-delete.message-template.email.body.title.redesigned":[{"children":[{"type":0,"value":" made 2 updates"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"edited 1 work log"}],"type":8,"value":"b"},{"type":0,"value":"."}],"jira.jira-issue-worklog-delete.message-template.email.redacted.body.title":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"deleted a worklog"}],"type":8,"value":"b"},{"type":0,"value":" on a work item"}],"jira.jira-issue-worklog-deleted.message-template.text.email.body.deleted.worklog":[{"type":0,"value":"The following worklog was deleted:"}],"jira.jira-issue-worklog-update.message-template.email.body.title":[{"children":[{"type":0,"value":" made 2 updates"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"edited 1 work log"}],"type":8,"value":"b"},{"type":0,"value":"."}],"jira.jira-issue-worklog-update.message-template.email.body.title.redesigned":[{"children":[{"type":0,"value":" made 2 updates"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"edited 1 work log"}],"type":8,"value":"b"},{"type":0,"value":"."}],"jira.jira-issue-worklog-update.message-template.email.redacted.body.title":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"updated a worklog"}],"type":8,"value":"b"},{"type":0,"value":" on a work item"}],"jira.jira-issue-worklog-updated.message-template.email.body.description":[{"type":0,"value":"Description"}],"jira.jira-issue-worklog-updated.message-template.email.body.timeLogged":[{"type":0,"value":"Time logged"}],"jira.jira-issue-worklogged.message-template.email.body.description":[{"type":0,"value":"Description: "}],"jira.jira-issue-worklogged.message-template.email.body.logTitle":[{"type":0,"value":"Work log"}],"jira.jira-issue-worklogged.message-template.email.body.timelogged":[{"type":0,"value":"Time logged: "}],"jira.jira-issue-worklogged.message-template.email.body.title":[{"children":[{"type":0,"value":" made 2 updates"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"added 1 work log"}],"type":8,"value":"b"},{"type":0,"value":"."}],"jira.jira-issue-worklogged.message-template.email.body.updateTitle":[{"type":0,"value":"Updates"}],"jira.jira-issue-worklogged.message-template.email.body.worklog.change.by":[{"type":0,"value":"Change by: "}],"jira.jira-issue-worklogged.message-template.email.body.worklog.entry":[{"type":0,"value":"Worklog entry:"}],"jira.jira-issue-worklogged.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" logged work on "},{"type":1,"value":"issueKey"}],"jira.jira-issue-worklogged.message-template.text.body.common.change.by":[{"type":0,"value":"Change by"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.created.on":[{"type":0,"value":"Created on:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.edited.by":[{"type":0,"value":"Edited by:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.edited.on":[{"type":0,"value":"Edited on:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.key":[{"type":0,"value":"Key:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.worklog.entry.label":[{"type":0,"value":"Worklog entry"}],"jira.jira-issue-worklogged.message-template.text.body.common.project":[{"type":0,"value":"Project:"}],"jira.jira-issue-worklogged.message-template.text.body.common.start.date":[{"type":0,"value":"Start Date:"}],"jira.jira-issue-worklogged.message-template.text.body.common.time.spent":[{"type":0,"value":"Time Spent:"}],"jira.jira-issue-worklogged.message-template.text.body.common.url":[{"type":0,"value":"URL:"}],"jira.jira-issue-worklogged.message-template.text.body.common.view.work.description":[{"type":0,"value":"View work description"}],"jira.jira-issue-worklogged.message-template.text.body.common.work.type":[{"type":0,"value":"Work type:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.body":[{"type":0,"value":"Work Description:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.description":[{"type":0,"value":"Worklog Description:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.description.was":[{"type":0,"value":"Worklog Description was:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.id":[{"type":0,"value":"Worklog Id:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.time.estimated":[{"type":0,"value":"Remaining Estimate:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.time.spent":[{"type":0,"value":"Worklog Time Spent:"}],"jira.jira-issue-worklogged.message-template.text.body.redacted.logged.by":[{"type":1,"value":"worklogEntry"},{"type":0,"value":" logged by "},{"type":1,"value":"actioner"}],"jira.jira-issue-worklogged.message-template.text.email.body.created":[{"type":1,"value":"user"},{"type":0,"value":" logged work on "},{"type":1,"value":"issueKey"}],"jira.jira-issue-worklogged.message-template.text.email.body.tracking":[{"type":0,"value":"Issue time Tracking"}],"jira.jira-project-deletion-reminder.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"header"},{"type":0,"value":" "}],"jira.jira-project-event-archived-restore.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project restored from archive "}],"jira.jira-project-event-archived.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Space archived"}],"jira.jira-project-event-delete-failed.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Could not permanently delete the project "}],"jira.jira-project-event-deleted-restore.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project restored from trash"}],"jira.jira-project-event-deleted.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project moved to trash"}],"jira.jira-project-event-user-invited-new-user.message-template.email.subject":[{"type":0,"value":"Action requested: "},{"type":1,"value":"userName"},{"type":0,"value":" invited you to join your team in "},{"type":1,"value":"projectName"},{"type":0,"value":", Jira"}],"jira.jira-project-event-user-invited-new-user.message-template.email.subject.redacted":[{"type":0,"value":"Action requested: You\'ve been invited to join your team in Jira"}],"jira.jira-project-event-user-invited.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"userName"},{"type":0,"value":") invited you to ("},{"type":1,"value":"projectName"},{"type":0,"value":")  "}],"jira.user.premium-plan.requested.email.explaination":[{"type":0,"value":"You can try Jira Premium for free with no commitment. This trial period includes access\\n\\t\\t\\t\\tto our advanced planning features plus other great functionalities that unlock new ways\\n\\t\\t\\t\\tof working for your teams."}],"jira.user.premium-plan.requested.email.greeting":[{"type":0,"value":"Hi,"}],"jira.user.premium-plan.requested.email.learn-more":[{"type":0,"value":"Learn more about Jira Premium."}],"jira.user.premium-plan.requested.email.start-trial":[{"type":0,"value":"Start your Jira Premium trial"}],"jira.user.premium-plan.requested.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" has requested a free trial of Jira Premium"}],"jira.user.premium-plan.requested.email.text":[{"type":1,"value":"user"},{"type":0,"value":" has requested a free trial of Jira Premium."}],"note.added.by.user":[{"type":1,"value":"userName"},{"type":0,"value":" added this note"}],"post-office.jira-pulsar.jira-issue-approval.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-archived.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-closed.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-comment-delete.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-comment-update.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-delete.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-generic.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-moved.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-resolved.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-update.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.placement.jira-top-banner.primary-message":[{"type":0,"value":"As we roll out \'work\' as the new term for items tracked in Jira, you may still see \'issue\' in some areas."}],"postoffice.jira.issue.common.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.common.reply-button":[{"type":0,"value":"Reply"}],"postoffice.jira.issue.common.visibility-level":[{"type":0,"value":"Restricted to "},{"children":[{"type":1,"value":"name"}],"type":8,"value":"b"},{"type":0,"value":" "},{"type":1,"value":"type"}],"postoffice.jira.issue.metioned.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.share-search.shared-with.no-translate":[{"type":0,"value":"sharedWithUser"}],"postoffice.jira.issue.work.started.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.work.stopped.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.worklogged.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.project.event.avatar.no-translate":[{"type":0,"value":"avatar"}],"postoffice.jira.project.event.blueprint.no-translate":[{"type":0,"value":"blueprintLogo"}],"postoffice.jira.project.event.globe.no-translate":[{"type":0,"value":"globeLogo"}],"postoffice.jira.project.event.logo.no-translate":[{"type":0,"value":"logo"}],"postoffice.jira.project.event.write.no-translate":[{"type":0,"value":"writeLogo"}],"ptr-changeboarding-space-navigation-spotlight.message-templates.spotlight.body":[{"type":0,"value":"Everything else about how you use these containers remains the same."}],"ptr-changeboarding-space-navigation-spotlight.message-templates.spotlight.dismiss":[{"type":0,"value":"Dismiss"}],"ptr-changeboarding-space-navigation-spotlight.message-templates.spotlight.learn-more":[{"type":0,"value":"Learn more"}],"ptr-changeboarding-space-navigation-spotlight.message-templates.spotlight.title":[{"type":0,"value":"Jira \'projects\' are now called \'spaces\'"}],"push.mobile.issue.approval.requested.description":[{"type":0,"value":"on "},{"type":1,"value":"summary"}],"push.mobile.issue.approval.requested.title":[{"type":0,"value":"Approval requested"}],"push.mobile.issue.assignment.description.assigned.others":[{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"type":1,"value":"summary"},{"type":0,"value":" to "},{"type":1,"value":"assignee"}],"push.mobile.issue.assignment.description.assigned.you":[{"type":1,"value":"user"},{"type":0,"value":" assigned you to "},{"type":1,"value":"summary"}],"push.mobile.issue.assignment.description.unassigned.others":[{"type":1,"value":"user"},{"type":0,"value":" unassigned "},{"type":1,"value":"oldAssignee"},{"type":0,"value":" from "},{"type":1,"value":"summary"}],"push.mobile.issue.assignment.description.unassigned.you":[{"type":1,"value":"user"},{"type":0,"value":" unassigned you from "},{"type":1,"value":"summary"}],"push.mobile.issue.attachment.added.description":[{"type":1,"value":"user"},{"type":0,"value":" added an attachment to "},{"type":1,"value":"summary"}],"push.mobile.issue.attachment.added.description.redacted":[{"type":1,"value":"user"},{"type":0,"value":" added an attachment"}],"push.mobile.issue.comment.added.android.description":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.added.ios.body.redacted":[{"type":0,"value":"commented on this work item"}],"push.mobile.issue.comment.added.ios.subtitle":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.android.description":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.android.description.redacted":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you in a comment on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.ios.subtitle":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.ios.subtitle.redacted":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you in a comment on this work item"}],"push.mobile.issue.create.android.description":[{"type":1,"value":"user"},{"type":0,"value":" created a work item"}],"push.mobile.issue.create.android.title":[{"type":0,"value":"Work item Created"}],"push.mobile.issue.create.ios.body.redacted":[{"type":0,"value":"Open to view work item details"}],"push.mobile.issue.create.ios.subtitle":[{"type":1,"value":"user"},{"type":0,"value":" created a work item"}],"push.mobile.issue.transition.description.resolved":[{"type":0,"value":"\u2714 "},{"type":1,"value":"user"},{"type":0,"value":" resolved "},{"type":1,"value":"summary"}],"push.mobile.issue.transition.description.resolved.redacted":[{"type":0,"value":"\u2714 "},{"type":1,"value":"user"},{"type":0,"value":" resolved this work item"}],"push.mobile.issue.transition.ios.description":[{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"summary"},{"type":0,"value":" to "},{"type":1,"value":"status"}],"push.mobile.issue.transition.ios.description.redacted":[{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"summary"},{"type":0,"value":" to "},{"type":1,"value":"status"}],"st-office.placement.jira-top-banner.primary-cta-text":[{"type":0,"value":"Read about this terminology change"}],"template..project-deletion-reminder.restore-link.multiple-project":[{"type":0,"value":" Restore"}],"template..project-deletion-reminder.restore-link.single-project":[{"type":0,"value":" Restore"}],"template..project-deletion-reminder.trash-link.multiple-project":[{"type":0,"value":" Trash"}],"template.project-deletion-reminder.generic-message.mutiple-projects":[{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" project"}]},"other":{"value":[{"type":7},{"type":0,"value":" projects"}]}},"pluralType":"cardinal","type":6,"value":"projectCount"},{"type":0,"value":" will be permanently deleted in 7 days "}],"template.project-deletion-reminder.generic-message.single-project":[{"type":0,"value":"The project will be permanently deleted in 7 days "}],"template.project-deletion-reminder.view-more-projects-message":[{"type":0,"value":"+ "},{"type":1,"value":"remainingProjectCount"},{"type":0,"value":" other projects currently in "}],"template.project-event-user-invited-new.custom-message-heading":[{"type":0,"value":"A note from "},{"type":1,"value":"inviterName"}],"template.project-event-user-invited-new.custom-message-heading-no-inviter":[{"type":0,"value":"A note from the admin"}],"template.project-event-user-invited-new.footer.sent-by":[{"type":0,"value":"This message was sent to you by Atlassian Cloud"}],"template.project-event-user-invited-new.join-space":[{"type":0,"value":"Join the space"}],"template.project-event-user-invited-new.logo-alt-text":[{"type":0,"value":"Jira logo"}],"template.project-event-user-invited-new.product-description":[{"children":[{"type":0,"value":"What is Jira?"}],"type":8,"value":"strong"},{"type":0,"value":" A software tool for project and work item tracking with your team"}],"template.project-event-user-invited-new.social-proof-text":[{"type":1,"value":"numberOfCustomers"},{"type":0,"value":"+ customers use Jira to move work forward"}],"template.project-event-user-invited-new.title-generic":[{"type":0,"value":"You\'ve been invited to join your team in Jira"}],"template.project-event-user-invited-new.title-inviter":[{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" invited you to join your team in Jira"}],"template.project-event-user-invited-new.welcome-message":[{"type":1,"value":"waveEmoji"},{"type":0,"value":" G\'day, "},{"type":1,"value":"recipientFirstName"}],"template.project-event-user-invited.invited-custom-message":[{"type":1,"value":"customMessage"}],"template.project-event-user-invited.invited-message":[{"type":1,"value":"userName"},{"type":0,"value":"  invited you to "},{"children":[{"type":0,"value":" "},{"type":1,"value":"projectName"},{"type":0,"value":" "}],"type":8,"value":"b"}],"template.project.archived.event.admins.permission.message":[{"type":0,"value":"Only Jira admins can restore the space."}],"template.project.deleted.event.admins.permission.message":[{"type":0,"value":"Only Jira admins can restore the project."}],"template.project.event.project.archive.restore.body.template":[{"type":0,"value":" "},{"type":1,"value":"userName"},{"type":0,"value":" restored this project from archive on "},{"type":1,"value":"eventTime"}],"template.project.event.project.archived.body.template":[{"type":1,"value":"userName"},{"type":0,"value":" archived this space on "},{"type":1,"value":"eventTime"}],"template.project.event.project.archived.body.template.generic.message":[{"type":0,"value":"This space and its work items, components, attachments, and versions will be available in the "},{"children":[{"type":0,"value":" archive "}],"type":8,"value":"a"},{"type":0,"value":" forever"}],"template.project.event.project.deleted.body.template":[{"type":1,"value":"userName"},{"type":0,"value":" moved this project to trash on "},{"type":1,"value":"eventTime"}],"template.project.event.project.deleted.body.template.generic.message":[{"type":0,"value":"The project, including all its issues, components, attachments, and versions will be available in the "},{"children":[{"type":0,"value":" trash "}],"type":8,"value":"a"},{"type":0,"value":" for 60 days after which it will be permanently deleted."}],"template.project.event.project.deleted.failure.body.template.generic.message":[{"type":0,"value":"It\'s probably a temporary problem. "},{"children":[{"type":0,"value":" Go to trash "}],"type":8,"value":"a"},{"type":0,"value":" and try again. If it persists, please contact support."}],"template.project.event.project.deleted.restore.body.template":[{"type":0,"value":" "},{"type":1,"value":"userName"},{"type":0,"value":" restored this project from trash on "},{"type":1,"value":"eventTime"}],"template.project.event.project.deletion.failure.body.template":[{"type":0,"value":"We couldn\'t delete this project"}],"template.project.event.project.privacy.contactus.template":[{"type":0,"value":"Contact us"}],"template.project.event.project.privacy.copyright.template":[{"type":0,"value":"Copyright 2025 Atlassian Pty Ltd. All rights reserved."}],"template.project.event.project.privacy.location.template":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"template.project.event.project.privacy.policy.template":[{"type":0,"value":"Privacy policy"}],"template.project.event.project.privacy.policy.template.dot":[{"type":0,"value":"."}],"template.project.event.project.user.invited.collborate.message":[{"type":0,"value":"Collaborate, align, and deliver work, all in "},{"children":[{"type":0,"value":" one place "}],"type":8,"value":"b"}],"template.project.event.project.user.invited.collect.message":[{"type":0,"value":"Collect and send work to other teams or stakeholders using "},{"children":[{"type":0,"value":" forms "}],"type":8,"value":"b"}],"template.project.event.project.user.invited.join.link":[{"type":0,"value":"Join the Project"}],"template.project.event.project.user.invited.learn.more.message":[{"type":0,"value":"Learn more about Jira "}],"template.project.event.project.user.invited.use.jira.generic.message":[{"type":0,"value":"Use Jira to..."}],"template.project.event.project.user.invited.view.work.message":[{"type":0,"value":"View work your way using the "},{"children":[{"type":0,"value":" list, board, calendar "}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":" timeline "}],"type":8,"value":"b"},{"type":0,"value":" views"}],"template.subscription.filter.count.issue-term-refresh":[{"type":0,"value":" ("},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" work item"}]},"other":{"value":[{"type":7},{"type":0,"value":" work items"}]}},"pluralType":"cardinal","type":6,"value":"total"},{"type":0,"value":")"}],"template.subscription.filter.html.subset.issue-term-refresh":[{"type":0,"value":"Displaying "},{"type":1,"value":"actual"},{"type":0,"value":" of "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" matched work item"}]},"other":{"value":[{"type":7},{"type":0,"value":" matched work items"}]}},"pluralType":"cardinal","type":6,"value":"total"},{"type":0,"value":". "}],"template.subscription.filter.html.view.filter.work-items":[{"type":0,"value":"View all of them"}],"template.subscription.filter.redacted.html.edit":[{"type":0,"value":"You may edit this subscription "},{"children":[{"type":0,"value":" here "}],"type":8,"value":"a"},{"type":0,"value":" "}],"template.subscription.filter.redacted.html.view.filter":[{"type":0,"value":"Details are hidden to protect sensitive data. "},{"children":[{"type":0,"value":" View the filter "}],"type":8,"value":"a"},{"type":0,"value":" in Jira"}],"template.subscription.filter.subcount.issue-term-refresh":[{"type":0,"value":"  ("},{"type":1,"value":"actual"},{"type":0,"value":" of "},{"type":1,"value":"total"},{"type":0,"value":" work items)"}],"template.subscription.filter.text.count.issue-term-refresh":[{"type":0,"value":" ("},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" work item"}]},"other":{"value":[{"type":7},{"type":0,"value":" work items"}]}},"pluralType":"cardinal","type":6,"value":"total"},{"type":0,"value":")"}],"template.subscription.filter.text.subcount.issue-term-refresh":[{"type":0,"value":" ("},{"type":1,"value":"actual"},{"type":0,"value":" of "},{"type":1,"value":"total"},{"type":0,"value":" work items)"}],"user.avatar.alt":[{"type":0,"value":"User avatar"}]}');

});

parcelRegister("18AbW", function(module, exports) {

let $0d429cb08dfaedd0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0d429cb08dfaedd0$var$load("9H975").then(()=>parcelRequire('3pMf6'));

});

parcelRegister("5TrQ9", function(module, exports) {

let $44a7af4c4e583c16$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $44a7af4c4e583c16$var$load("jR2lV").then(()=>parcelRequire('7ATou'));

});

parcelRegister("apcQm", function(module, exports) {

let $793633a45813a2df$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $793633a45813a2df$var$load("j2Ec8").then(()=>parcelRequire('iPERp'));

});

parcelRegister("38Pio", function(module, exports) {

let $2499e8b81fbe14a0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2499e8b81fbe14a0$var$load("4JobB").then(()=>parcelRequire('ilwNa'));

});

parcelRegister("ePu5I", function(module, exports) {

let $acbd2b9427e1aeae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $acbd2b9427e1aeae$var$load("kBW39").then(()=>parcelRequire('hGaYG'));

});

parcelRegister("3ie9X", function(module, exports) {

let $265e095c59643f8c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $265e095c59643f8c$var$load("2aylT").then(()=>parcelRequire('f9smC'));

});

parcelRegister("f3eB3", function(module, exports) {

let $af527569023a3124$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $af527569023a3124$var$load("OuGjy").then(()=>parcelRequire('eTprP'));

});

parcelRegister("4L0cU", function(module, exports) {

let $376bb65be0024c11$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $376bb65be0024c11$var$load("i1dal").then(()=>parcelRequire('7T1D5'));

});

parcelRegister("eQsRU", function(module, exports) {

let $acec50b7b1fe775b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $acec50b7b1fe775b$var$load("8iwxF").then(()=>parcelRequire('41yZF'));

});

parcelRegister("hWyGN", function(module, exports) {

let $d102c30304942b96$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d102c30304942b96$var$load("aTl5q").then(()=>parcelRequire('282Ch'));

});

parcelRegister("aVyPi", function(module, exports) {

let $7f4a3e070c3f4e1b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7f4a3e070c3f4e1b$var$load("5rjaP").then(()=>parcelRequire('4T4PR'));

});

parcelRegister("hkaHC", function(module, exports) {

let $c9cc9b3e58f858c7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c9cc9b3e58f858c7$var$load("kP4pR").then(()=>parcelRequire('26Zwu'));

});

parcelRegister("7BPcO", function(module, exports) {

let $58a3b57740325c9b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $58a3b57740325c9b$var$load("dwdIx").then(()=>parcelRequire('ll9qG'));

});

parcelRegister("iiAOW", function(module, exports) {

let $d52678413abdab0e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d52678413abdab0e$var$load("cw3qI").then(()=>parcelRequire('3G8I1'));

});

parcelRegister("7vYJq", function(module, exports) {

let $578a89af1db9822f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $578a89af1db9822f$var$load("4GGM3").then(()=>parcelRequire('9N0Km'));

});

parcelRegister("7UAe1", function(module, exports) {

let $5c29dcefb5ccc4e2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5c29dcefb5ccc4e2$var$load("cuCvR").then(()=>parcelRequire('6ypMh'));

});

parcelRegister("alQ7v", function(module, exports) {

let $78944b7f02d62caa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $78944b7f02d62caa$var$load("jHjHj").then(()=>parcelRequire('hnZaI'));

});

parcelRegister("9R1Vi", function(module, exports) {

let $72ca8e31df12311d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $72ca8e31df12311d$var$load("lhvPc").then(()=>parcelRequire('8JrQP'));

});

parcelRegister("9Y5Ly", function(module, exports) {

let $741e30ae42be8052$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $741e30ae42be8052$var$load("99lD1").then(()=>parcelRequire('27Oo7'));

});

parcelRegister("cV5oE", function(module, exports) {

let $967efe9193445bd2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $967efe9193445bd2$var$load("3T0Xt").then(()=>parcelRequire('4ySQE'));

});

parcelRegister("7eC1l", function(module, exports) {

let $54475559f8ecd36a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $54475559f8ecd36a$var$load("c6XFt").then(()=>parcelRequire('eied3'));

});

parcelRegister("3DmQG", function(module, exports) {

let $2a56bceb6b45d9be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2a56bceb6b45d9be$var$load("dliPD").then(()=>parcelRequire('kDzg3'));

});

parcelRegister("a0gCC", function(module, exports) {

let $7486cc406fe6e801$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7486cc406fe6e801$var$load("gZdAC").then(()=>parcelRequire('1aoyS'));

});

parcelRegister("fkXoM", function(module, exports) {

let $b2a6cc9b66445021$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b2a6cc9b66445021$var$load("hiZ4G").then(()=>parcelRequire('h6GGi'));

});

parcelRegister("bkkFx", function(module, exports) {

let $83f198621ac01a9f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $83f198621ac01a9f$var$load("dj3uv").then(()=>parcelRequire('4RzXz'));

});

parcelRegister("4xEEU", function(module, exports) {

let $34e9c879b7336265$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $34e9c879b7336265$var$load("h0RNK").then(()=>parcelRequire('ilsxq'));

});

parcelRegister("cgoSX", function(module, exports) {

let $8eda486683e5658e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8eda486683e5658e$var$load("6NpHC").then(()=>parcelRequire('eoXUj'));

});

parcelRegister("4A4dR", function(module, exports) {

let $355dccbdcfc7a141$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $355dccbdcfc7a141$var$load("9Onj7").then(()=>parcelRequire('4cg1h'));

});

parcelRegister("3tX10", function(module, exports) {

let $2891dbb38871e5b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2891dbb38871e5b3$var$load("25vBs").then(()=>parcelRequire('7oJNO'));

});

parcelRegister("9XdYK", function(module, exports) {

let $73f4779eebf746e4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $73f4779eebf746e4$var$load("a4EjD").then(()=>parcelRequire('2RHQv'));

});

parcelRegister("kMafC", function(module, exports) {

let $f2003df3c11f3402$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f2003df3c11f3402$var$load("eB9by").then(()=>parcelRequire('fjjUa'));

});

parcelRegister("lleYH", function(module, exports) {

let $f8972d70bce1cf63$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f8972d70bce1cf63$var$load("dZDiM").then(()=>parcelRequire('i91dS'));

});

parcelRegister("g1YnZ", function(module, exports) {

let $babb94b3509fe47e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $babb94b3509fe47e$var$load("5vsEj").then(()=>parcelRequire('hGl08'));

});

parcelRegister("1LJzY", function(module, exports) {

let $149d89544d92e414$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $149d89544d92e414$var$load("jyMdm").then(()=>parcelRequire('1lGij'));

});

parcelRegister("kYoj6", function(module, exports) {
module.exports = JSON.parse("{\"acrabats.rovo-dev-spotlight.explore-rovo-dev.description\":[{\"type\":0,\"value\":\"Get started on this work item using Rovo Dev to generate code. It's work is only visible to you.\"}],\"acrabats.rovo-dev-spotlight.explore-rovo-dev.heading\":[{\"type\":0,\"value\":\"Start coding with Rovo Dev in Jira\"}],\"acrabats.rovo-dev-spotlight.navigation.back\":[{\"type\":0,\"value\":\"Back\"}],\"acrabats.rovo-dev-spotlight.navigation.next\":[{\"type\":0,\"value\":\"Next\"}],\"acrabats.rovo-dev-spotlight.navigation.progress\":[{\"type\":1,\"value\":\"currentStep\"},{\"type\":0,\"value\":\" of \"},{\"type\":1,\"value\":\"totalSteps\"}],\"acrabats.rovo-dev-spotlight.navigation.read-more\":[{\"type\":0,\"value\":\"Read more\"}],\"acrabats.rovo-dev-spotlight.understand-rovo-dev.description\":[{\"type\":0,\"value\":\"Once the agent has finished, you're in control of approving the work and sharing with your team.\"}],\"acrabats.rovo-dev-spotlight.understand-rovo-dev.heading\":[{\"type\":0,\"value\":\"You review and approve\"}],\"devai-acrabats.ai-planner-plan-created.message-template.notification-drawer.message.no-translate\":[{\"type\":1,\"value\":\"actorName\"},{\"type\":0,\"value\":\" updated your page\"}],\"devai-acrabats.blocks.header.alt_text.atlassian\":[{\"type\":0,\"value\":\"Atlassian\"}],\"devai-acrabats.components.email..footer.img.alt\":[{\"type\":0,\"value\":\"Atlassian Logo\"}],\"devai-acrabats.components.email..footer.text\":[{\"type\":0,\"value\":\"This message was sent to you by Atlassian Cloud\"}],\"devai-acrabats.components.email.footer.note.no-org-name\":[{\"type\":0,\"value\":\"You received this because you're an organization admin\"}],\"devai-acrabats.components.email.footer.note.org-name\":[{\"type\":0,\"value\":\"You received this because you're an organization admin for \"},{\"type\":1,\"value\":\"orgName\"}],\"devai-acrabats.devai-rovodevcli-enablebydefault.message-template.email.subject\":[{\"type\":0,\"value\":\"Rovo Dev is coming to the terminal\"}],\"devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.fifth-paragraph\":[{\"type\":0,\"value\":\"Learn more about how RovoDev CLI capabilities and its data use and controls \"},{\"type\":1,\"value\":\"link\"},{\"type\":0,\"value\":\".\"}],\"devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.fifth-paragraph.link\":[{\"type\":0,\"value\":\"here\"}],\"devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.first-paragraph\":[{\"type\":0,\"value\":\"Rovo Dev CLI brings powerful Rovo Dev capabilities, along with your team's Jira and Confluence\\n\\t\\t\\t\\t\\tknowledge, to your terminal.\"}],\"devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.fourth-paragraph\":[{\"type\":0,\"value\":\"Rovo Dev users will receive instructions soon for how to install Rovo Dev CLI and use it in your team's workflow.\"}],\"devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.heading\":[{\"type\":0,\"value\":\"Rovo Dev CLI has been enabled for your site\"}],\"devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.second-paragraph\":[{\"type\":0,\"value\":\"Developers can collaborate with AI to generate and ship code, turn work items into features,\\n\\t\\t\\t\\t\\task questions in natural language, and more. And all without switching contexts.\"}],\"devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.third-paragraph\":[{\"type\":0,\"value\":\"Rovo Dev CLI enables users to connect to third-party data sources via \"},{\"type\":1,\"value\":\"link\"},{\"type\":0,\"value\":\".\"}],\"devai-acrabats.devai-rovodevcli-enablebydefault.message.email.body.third-paragraph.link\":[{\"type\":0,\"value\":\"Model Context Protocol\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Rovo Dev is now ready to use in your terminal\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.bullet-point-1\":[{\"type\":0,\"value\":\"Natural language insights into repositories, files, and features.\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.bullet-point-2\":[{\"type\":0,\"value\":\"AI-powered code generation and shipping.\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.bullet-point-3\":[{\"type\":0,\"value\":\"Collaboration with AI to turn work items into features.\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.bullet-point-4\":[{\"type\":0,\"value\":\"Connecting to third-party data sources via Model Context Protocol.\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.first-paragraph\":[{\"type\":0,\"value\":\"We've enabled access to Rovo Dev CLI for your site (\"},{\"type\":1,\"value\":\"link\"},{\"type\":0,\"value\":\") as part of the Rovo Dev Agents beta.\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.first-paragraph.link\":[{\"type\":1,\"value\":\"siteName\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.heading\":[{\"type\":0,\"value\":\"Your team can now use Rovo Dev CLI\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.second-paragraph\":[{\"type\":0,\"value\":\"Once your team \"},{\"type\":1,\"value\":\"link\"},{\"type\":0,\"value\":\", they can access Rovo Dev features like:\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.second-paragraph.link\":[{\"type\":0,\"value\":\"installs the agent in their terminal\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.message.email.body.third-paragraph.link\":[{\"type\":0,\"value\":\"manage access for your site\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.read-more-button\":[{\"type\":0,\"value\":\"Read more about Rovo Dev CLI\"}],\"devai-acrabats.rovo-dev-cli-rollout-admin-email.test-message.email.body.third-paragraph\":[{\"type\":0,\"value\":\"If you don't want your team to be able to access Rovo Dev CLI, \"},{\"type\":1,\"value\":\"link\"},{\"type\":0,\"value\":\".\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Rovo Dev is now ready to use in your terminal\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.bullet-point-1\":[{\"type\":0,\"value\":\"Natural language insights into repositories, files, and features.\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.bullet-point-2\":[{\"type\":0,\"value\":\"AI-powered code generation and implementation.\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.bullet-point-3\":[{\"type\":0,\"value\":\"Automated test creation to improve coverage metrics.\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.bullet-point-4\":[{\"type\":0,\"value\":\"Dynamic documentation writing reflecting repository features and changes.\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.first-paragraph\":[{\"type\":0,\"value\":\"We've enabled access to Rovo Dev CLI as part of the Rovo Dev Agents beta.\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.heading\":[{\"type\":0,\"value\":\"You can now use Rovo Dev CLI\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.img.alt\":[{\"type\":0,\"value\":\"Rovo Dev CLI Screenshot\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-1\":[{\"type\":0,\"value\":\"Install ACLI (or update to the latest version if you already have ACLI installed) using instructions for your OS:\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-1.link-1\":[{\"type\":0,\"value\":\"macOS\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-1.link-2\":[{\"type\":0,\"value\":\"Linux\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-1.link-3\":[{\"type\":0,\"value\":\"Windows\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-2\":[{\"type\":0,\"value\":\"Generate an unscoped API token from your  \"},{\"type\":1,\"value\":\"link\"},{\"type\":0,\"value\":\".\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-2.link\":[{\"type\":0,\"value\":\"Atlassian profile\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-3\":[{\"type\":0,\"value\":\"In your terminal, run:\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-3.code\":[{\"type\":0,\"value\":\"acli rovodev auth login\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-4\":[{\"type\":0,\"value\":\"Run this command to open Rovo Dev in interactive mode:\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.numbered-list-4.code\":[{\"type\":0,\"value\":\"acli rovodev run\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.second-paragraph\":[{\"type\":0,\"value\":\"Once you \"},{\"type\":1,\"value\":\"link\"},{\"type\":0,\"value\":\", you can access Rovo Dev features like:\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.message.email.body.second-paragraph.link\":[{\"type\":0,\"value\":\"install the agent in your terminal\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.read-more-button\":[{\"type\":0,\"value\":\"Read more about Rovo Dev CLI\"}],\"devai-acrabats.rovo-dev-cli-rollout-user-email.test-message.email.body.sub-header\":[{\"type\":0,\"value\":\"How do I get started?\"}],\"jiraRovoDev.survey.question\":[{\"type\":0,\"value\":\"Rovo Dev in Jira is valuable to my work.\"}],\"jiraRovoDev.survey.score.neutral\":[{\"type\":0,\"value\":\"Neutral\"}],\"jiraRovoDev.survey.score.stronglyAgree\":[{\"type\":0,\"value\":\"Strongly agree\"}],\"jiraRovoDev.survey.score.stronglyDisagree\":[{\"type\":0,\"value\":\"Strongly disagree\"}],\"jiraRovoDev.survey.statement\":[{\"type\":0,\"value\":\"To what extent do you agree or disagree with the statement?\"}]}");

});

parcelRegister("eiM2m", function(module, exports) {

let $a698024910fe1ec5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a698024910fe1ec5$var$load("6cvtG").then(()=>parcelRequire('lThAM'));

});

parcelRegister("65wfA", function(module, exports) {

let $46ec39fd026fffa5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $46ec39fd026fffa5$var$load("3OPor").then(()=>parcelRequire('hp18S'));

});

parcelRegister("1ZTvk", function(module, exports) {

let $17468af4db4b2823$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $17468af4db4b2823$var$load("kw7rG").then(()=>parcelRequire('ej5T6'));

});

parcelRegister("Z8qZU", function(module, exports) {

let $0b7c3d866f485965$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0b7c3d866f485965$var$load("5rRtL").then(()=>parcelRequire('89sM5'));

});

parcelRegister("8DQF6", function(module, exports) {

let $64aad0cbc40f70df$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $64aad0cbc40f70df$var$load("pCNeH").then(()=>parcelRequire('ktCJt'));

});

parcelRegister("lBaPq", function(module, exports) {

let $fb9573f7018f6080$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fb9573f7018f6080$var$load("hsMaR").then(()=>parcelRequire('dclhw'));

});

parcelRegister("hu2Y1", function(module, exports) {

let $cba78a3c94520640$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cba78a3c94520640$var$load("lcYIy").then(()=>parcelRequire('aDWPG'));

});

parcelRegister("fFJVd", function(module, exports) {

let $b68e4e7eb57089c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b68e4e7eb57089c9$var$load("fyLlq").then(()=>parcelRequire('NqY6J'));

});

parcelRegister("7S9Yp", function(module, exports) {

let $5bb5500769e616b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5bb5500769e616b1$var$load("jVxFg").then(()=>parcelRequire('aqqds'));

});

parcelRegister("82UKL", function(module, exports) {

let $5dba88a38530c7b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5dba88a38530c7b3$var$load("bYjVc").then(()=>parcelRequire('iIzZc'));

});

parcelRegister("fN6YI", function(module, exports) {

let $b7f0d85b80003983$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b7f0d85b80003983$var$load("7GTra").then(()=>parcelRequire('1B3E3'));

});

parcelRegister("aXPnF", function(module, exports) {

let $7fb74534b14623f8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7fb74534b14623f8$var$load("3Jz0r").then(()=>parcelRequire('bKaQH'));

});

parcelRegister("kQdee", function(module, exports) {

let $f2c2ece4b54103e7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f2c2ece4b54103e7$var$load("dq9dU").then(()=>parcelRequire('47unM'));

});

parcelRegister("ck1Qm", function(module, exports) {

let $8f88c8620811a7fb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8f88c8620811a7fb$var$load("ar8sk").then(()=>parcelRequire('aT23u'));

});

parcelRegister("e3a29", function(module, exports) {

let $a3a92100d94588c0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a3a92100d94588c0$var$load("3XaL4").then(()=>parcelRequire('gbG2U'));

});

parcelRegister("8Co6l", function(module, exports) {

let $64649161918c57df$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $64649161918c57df$var$load("8DUDw").then(()=>parcelRequire('dioSh'));

});

parcelRegister("2lIfS", function(module, exports) {

let $1b5fdf118dae3fd0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1b5fdf118dae3fd0$var$load("hMSmu").then(()=>parcelRequire('hUWD8'));

});

parcelRegister("joXxg", function(module, exports) {

let $e1fe70bfda0381ec$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e1fe70bfda0381ec$var$load("aGXuL").then(()=>parcelRequire('igvON'));

});

parcelRegister("77CA0", function(module, exports) {

let $52f71cfd29662c7f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $52f71cfd29662c7f$var$load("iQdMe").then(()=>parcelRequire('4kgzx'));

});

parcelRegister("7Fdds", function(module, exports) {

let $59469d2eed9680c5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $59469d2eed9680c5$var$load("bRVyN").then(()=>parcelRequire('edhMH'));

});

parcelRegister("4fva7", function(module, exports) {

let $3180bc48eb79600c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3180bc48eb79600c$var$load("2Oq1T").then(()=>parcelRequire('bxnkl'));

});

parcelRegister("3IxoF", function(module, exports) {

let $2b4f6312570d616a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2b4f6312570d616a$var$load("546Lp").then(()=>parcelRequire('iLoit'));

});

parcelRegister("gH2aF", function(module, exports) {

let $c27258a3cfac0a9b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c27258a3cfac0a9b$var$load("h3fmA").then(()=>parcelRequire('5bhBf'));

});

parcelRegister("bljMD", function(module, exports) {

let $84210079b4d00c2b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $84210079b4d00c2b$var$load("ioXt4").then(()=>parcelRequire('6zpp9'));

});

parcelRegister("h4Lqr", function(module, exports) {

let $c6e799144ccb3dd2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c6e799144ccb3dd2$var$load("6H8St").then(()=>parcelRequire('204u0'));

});

parcelRegister("6Rozx", function(module, exports) {

let $4feac0d323e1fa2d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4feac0d323e1fa2d$var$load("g5est").then(()=>parcelRequire('gFsqp'));

});

parcelRegister("4G3JL", function(module, exports) {

let $367dfbcc0306383c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $367dfbcc0306383c$var$load("h35IG").then(()=>parcelRequire('gqIxI'));

});

parcelRegister("95bn1", function(module, exports) {

let $69cd669bd77c31e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $69cd669bd77c31e1$var$load("5mYfK").then(()=>parcelRequire('deQmq'));

});

parcelRegister("4j19V", function(module, exports) {

let $3229d5f475304a17$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3229d5f475304a17$var$load("625Oo").then(()=>parcelRequire('l7pYO'));

});

parcelRegister("1FQvq", function(module, exports) {

let $1382595ca1943f43$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1382595ca1943f43$var$load("jqMyw").then(()=>parcelRequire('5BBR7'));

});

parcelRegister("4P9pt", function(module, exports) {

let $3833396e6e3803a3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3833396e6e3803a3$var$load("knrfq").then(()=>parcelRequire('faONE'));

});

parcelRegister("MhCQ6", function(module, exports) {

let $091227daf4ab2993$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $091227daf4ab2993$var$load("lEUKo").then(()=>parcelRequire('jueqp'));

});

parcelRegister("aeOW7", function(module, exports) {

let $7742b913e544a3b2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7742b913e544a3b2$var$load("1Wpbi").then(()=>parcelRequire('94tYd'));

});

parcelRegister("d6JHs", function(module, exports) {

let $98af48f7c9330495$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $98af48f7c9330495$var$load("2XB6R").then(()=>parcelRequire('8eLGQ'));

});

parcelRegister("6HVff", function(module, exports) {
module.exports = JSON.parse("{\"jsm-sherpas.jira-screen-modal.screen-space-flags.description.no-translate\":[{\"type\":0,\"value\":\"Replace this with a short summary of what this message tells the recipient.\"}],\"jsm-sherpas.jira-screen-modal.screen-space-flags.title.no-translate\":[{\"type\":0,\"value\":\"This is a Post Office Test Message\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.closing\":[{\"type\":0,\"value\":\"Launch your space today to give your team a single, self-service entry point for HR help.\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.contact\":[{\"type\":0,\"value\":\"Please \"},{\"type\":1,\"value\":\"contactUsLink\"},{\"type\":0,\"value\":\" with any questions, we're always happy to help.\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.contact-us-link\":[{\"type\":0,\"value\":\"contact us\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.cta\":[{\"type\":0,\"value\":\"Go to your space\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.greeting\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.heading\":[{\"type\":0,\"value\":\"Bring your HR team together in Jira Service Management\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.intro\":[{\"type\":0,\"value\":\"You recently started an HR service space, but it looks like your team hasn't moved in yet. When you're ready, Jira Service Management can help you centralize requests and track onboarding in one place.\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.signoff\":[{\"type\":0,\"value\":\"Cheers,\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.step-1\":[{\"children\":[{\"type\":0,\"value\":\"Add team members\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" as agents to handle requests\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.step-2\":[{\"children\":[{\"type\":0,\"value\":\"Set up request types\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" like \\\"New hire onboarding\\\"\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.step-3\":[{\"children\":[{\"type\":0,\"value\":\"Publish your portal\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" so employees can find help\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.steps-heading\":[{\"type\":0,\"value\":\"Get started in three steps:\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.team-name\":[{\"type\":0,\"value\":\"The Atlassians\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.subject\":[{\"type\":0,\"value\":\"Quick check-in on your HR service space\"}]}");

});

parcelRegister("2Kd6C", function(module, exports) {

let $1ffa0b29e13093f0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1ffa0b29e13093f0$var$load("4M9gU").then(()=>parcelRequire('5iEs0'));

});

parcelRegister("lw41y", function(module, exports) {

let $fa9fb53b7e4120c7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fa9fb53b7e4120c7$var$load("62NPr").then(()=>parcelRequire('l1o7E'));

});

parcelRegister("crUJD", function(module, exports) {

let $910404121c0ecade$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $910404121c0ecade$var$load("9OYkz").then(()=>parcelRequire('ew50i'));

});

parcelRegister("b1wqV", function(module, exports) {

let $02123574b2a5e2ba$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $02123574b2a5e2ba$var$load("hEbOm").then(()=>parcelRequire('4VqWk'));

});

parcelRegister("g6r7n", function(module, exports) {

let $bb923dee204af4b6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bb923dee204af4b6$var$load("6EaIq").then(()=>parcelRequire('fQS9W'));

});

parcelRegister("3VXaK", function(module, exports) {

let $2dd49857a8d19404$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2dd49857a8d19404$var$load("6qmG0").then(()=>parcelRequire('61tl1'));

});

parcelRegister("6dDc8", function(module, exports) {

let $48725c38ed8781bf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $48725c38ed8781bf$var$load("gFZTd").then(()=>parcelRequire('iK0uC'));

});

parcelRegister("aIzii", function(module, exports) {

let $7cd9641d670e1d7e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7cd9641d670e1d7e$var$load("ioyvr").then(()=>parcelRequire('ff3i7'));

});

parcelRegister("83hQf", function(module, exports) {

let $5dcc71835dbfc6b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5dcc71835dbfc6b7$var$load("9Z0Fu").then(()=>parcelRequire('81vin'));

});

parcelRegister("cQcQk", function(module, exports) {

let $95944db4985c79a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $95944db4985c79a4$var$load("cXaEa").then(()=>parcelRequire('53k1V'));

});

parcelRegister("6YyWh", function(module, exports) {

let $514372d126fbb9b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $514372d126fbb9b8$var$load("g2VgR").then(()=>parcelRequire('lHOoU'));

});

parcelRegister("5Z7pM", function(module, exports) {

let $45b866af14464219$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $45b866af14464219$var$load("iJHt2").then(()=>parcelRequire('jwGsZ'));

});

parcelRegister("2rBOg", function(module, exports) {

let $1c7b6e9de4126c41$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1c7b6e9de4126c41$var$load("afdDN").then(()=>parcelRequire('gZgD2'));

});

parcelRegister("aVKau", function(module, exports) {

let $7f530a4bab3d7a13$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7f530a4bab3d7a13$var$load("e8q4A").then(()=>parcelRequire('9aJM5'));

});

parcelRegister("e0dbW", function(module, exports) {

let $a31b4c5635459737$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a31b4c5635459737$var$load("hl8UQ").then(()=>parcelRequire('hzR9x'));

});

parcelRegister("h7c5Y", function(module, exports) {

let $c75c78ff5162ee45$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c75c78ff5162ee45$var$load("b9Ezt").then(()=>parcelRequire('8O7b5'));

});

parcelRegister("3zn4F", function(module, exports) {

let $29968a11cc761b35$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $29968a11cc761b35$var$load("eSj9v").then(()=>parcelRequire('9rP2W'));

});

parcelRegister("6Pqb8", function(module, exports) {

let $4f8bd00be3d06a1f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4f8bd00be3d06a1f$var$load("411Xv").then(()=>parcelRequire('cTKB1'));

});

parcelRegister("f09u8", function(module, exports) {

let $aebe36a55a4b7b7a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aebe36a55a4b7b7a$var$load("3tIuh").then(()=>parcelRequire('grZPa'));

});

parcelRegister("f8znK", function(module, exports) {

let $b0530c7f31ebc629$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b0530c7f31ebc629$var$load("3IzUl").then(()=>parcelRequire('dmX3a'));

});

parcelRegister("bKnCl", function(module, exports) {

let $88d64f8bb54a2d7b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $88d64f8bb54a2d7b$var$load("eXAqK").then(()=>parcelRequire('dSGyX'));

});

parcelRegister("9Tbjf", function(module, exports) {

let $733205f471566904$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $733205f471566904$var$load("5p2vG").then(()=>parcelRequire('8wCOZ'));

});

parcelRegister("7tpoI", function(module, exports) {

let $570ef14213e4bfde$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $570ef14213e4bfde$var$load("kyCKW").then(()=>parcelRequire('ejSw3'));

});

parcelRegister("1NbHf", function(module, exports) {

let $14e370b7936c2459$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $14e370b7936c2459$var$load("fHfwP").then(()=>parcelRequire('2QJch'));

});

parcelRegister("3HIVY", function(module, exports) {

let $2b283e33b0155703$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2b283e33b0155703$var$load("5MGgR").then(()=>parcelRequire('20aSF'));

});

parcelRegister("a8ohm", function(module, exports) {

let $760d7c0f377be919$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $760d7c0f377be919$var$load("fyT30").then(()=>parcelRequire('eJKFa'));

});

parcelRegister("ivZD4", function(module, exports) {

let $d7aaed8225e9fdd2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d7aaed8225e9fdd2$var$load("bbzLK").then(()=>parcelRequire('bAncG'));

});

parcelRegister("iSxsK", function(module, exports) {

let $dbe73a1f8d50237e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dbe73a1f8d50237e$var$load("jckkN").then(()=>parcelRequire('69PuF'));

});

parcelRegister("RcCEN", function(module, exports) {

let $09febdeaef9e8c58$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $09febdeaef9e8c58$var$load("d0q5G").then(()=>parcelRequire('7Opv9'));

});

parcelRegister("bgfWq", function(module, exports) {

let $832d8df773ec8c4e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $832d8df773ec8c4e$var$load("ePad5").then(()=>parcelRequire('41kf5'));

});

parcelRegister("imUvr", function(module, exports) {

let $d5f61cff04498b35$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d5f61cff04498b35$var$load("8vDlN").then(()=>parcelRequire('2g443'));

});

parcelRegister("gCVPz", function(module, exports) {

let $c1ad0df6e6d62208$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c1ad0df6e6d62208$var$load("bPMV3").then(()=>parcelRequire('5hDHL'));

});

parcelRegister("afU4v", function(module, exports) {

let $7776ccbea065fc8c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7776ccbea065fc8c$var$load("320QW").then(()=>parcelRequire('dhfMB'));

});

parcelRegister("aK9R1", function(module, exports) {

let $7d25d81ae966c42b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7d25d81ae966c42b$var$load("3tmz7").then(()=>parcelRequire('3FmP7'));

});

parcelRegister("b9hxd", function(module, exports) {
module.exports = JSON.parse('{"jsm-phantom.jira-space-settings-playbooks-navigation-spotlight.screen-space-flags.description.no-translate":[{"type":0,"value":"Replace this with a short summary of what this message tells the recipient."}],"jsm-phantom.jira-space-settings-playbooks-navigation-spotlight.screen-space-flags.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"post-office.jsm-phantom.issue-view.playbook.spotlight-close-button":[{"type":0,"value":"Close"}],"post-office.jsm-phantom.issue-view.playbook.spotlight-first-line":[{"type":0,"value":"Follow step-by-step guidance and run automate actions to resolve work faster."}],"post-office.jsm-phantom.issue-view.playbook.spotlight-heading":[{"type":0,"value":"Resolve work items faster with playbooks"}],"post-office.jsm-phantom.issue-view.playbook.spotlight-learn-more":[{"type":0,"value":"Learn more about playbooks"}],"post-office.jsm-phantom.issue-view.playbook.spotlight-second-line":[{"type":0,"value":"No playbook yet? Share your runbooks with project admin to turn them into actionable playbooks."}],"post-office.jsm-phantom.space-settings.playbook-nav.spotlight-close-button":[{"type":0,"value":"Close"}],"post-office.jsm-phantom.space-settings.playbook-nav.spotlight-first-line":[{"type":0,"value":"Create reusable playbooks from runbooks, SOPs, and how-tos to give your team step-by-step guidance and automated actions to resolve work items faster, right in context."}],"post-office.jsm-phantom.space-settings.playbook-nav.spotlight-heading":[{"type":0,"value":"Turn your team\u2019s knowledge into playbooks"}],"post-office.jsm-phantom.space-settings.playbook-nav.spotlight-learn-more":[{"type":0,"value":"Learn more about playbooks"}],"post-office.jsm-phantom.space-settings.playbook-nav.spotlight.create-playbook":[{"type":0,"value":"Create playbook"}]}');

});

parcelRegister("gFZts", function(module, exports) {

let $c240292dbf42a2b4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c240292dbf42a2b4$var$load("g731f").then(()=>parcelRequire('gXkR8'));

});

parcelRegister("eWItg", function(module, exports) {

let $ae18fa7af95f010c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae18fa7af95f010c$var$load("dp2jt").then(()=>parcelRequire('ekUbo'));

});

parcelRegister("78918", function(module, exports) {

let $5310466a1a2f1853$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5310466a1a2f1853$var$load("8cHEI").then(()=>parcelRequire('2rGO2'));

});

parcelRegister("gJib5", function(module, exports) {

let $c2def30f988c0a48$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c2def30f988c0a48$var$load("i74Oi").then(()=>parcelRequire('aDQGW'));

});

parcelRegister("1sFPA", function(module, exports) {

let $1108dac4d8bd5dfa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1108dac4d8bd5dfa$var$load("5c1dQ").then(()=>parcelRequire('cg7lg'));

});

parcelRegister("cwUFF", function(module, exports) {

let $91f46ee283d666c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $91f46ee283d666c3$var$load("2lb6C").then(()=>parcelRequire('3Epo6'));

});

parcelRegister("6dvF9", function(module, exports) {

let $486c848588c3aa89$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $486c848588c3aa89$var$load("4gXw8").then(()=>parcelRequire('lh0tz'));

});

parcelRegister("csb1s", function(module, exports) {

let $9110a6647b4a9f24$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9110a6647b4a9f24$var$load("iCR06").then(()=>parcelRequire('4zXN0'));

});

parcelRegister("bCHa3", function(module, exports) {

let $8764b940c05ae3b0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8764b940c05ae3b0$var$load("80ZsV").then(()=>parcelRequire('5xmUO'));

});

parcelRegister("553z6", function(module, exports) {

let $3b302f561946e66f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3b302f561946e66f$var$load("khpL1").then(()=>parcelRequire('1AJnC'));

});

parcelRegister("14QYC", function(module, exports) {

let $0c8f423ae3392b5e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0c8f423ae3392b5e$var$load("dck3v").then(()=>parcelRequire('9jWY7'));

});

parcelRegister("iTvo8", function(module, exports) {

let $dc15b617222fa4be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dc15b617222fa4be$var$load("fXGdz").then(()=>parcelRequire('fdJi1'));

});

parcelRegister("22MCk", function(module, exports) {

let $17d17b04054099c4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $17d17b04054099c4$var$load("q0cUM").then(()=>parcelRequire('hWhdh'));

});

parcelRegister("3W3fm", function(module, exports) {

let $2dd94ea21d852a8d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2dd94ea21d852a8d$var$load("jPNKi").then(()=>parcelRequire('31pQW'));

});

parcelRegister("5k5XS", function(module, exports) {

let $3e03727cd30a9cb0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3e03727cd30a9cb0$var$load("2Uj5H").then(()=>parcelRequire('hFueX'));

});

parcelRegister("kGoGQ", function(module, exports) {

let $f0eae1d673d98d0b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f0eae1d673d98d0b$var$load("7sqwa").then(()=>parcelRequire('4XFbr'));

});

parcelRegister("eyOq1", function(module, exports) {

let $a99b59c5bac73238$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a99b59c5bac73238$var$load("gsGjU").then(()=>parcelRequire('4DIXi'));

});

parcelRegister("2desL", function(module, exports) {

let $19c803b01a928407$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $19c803b01a928407$var$load("29QG4").then(()=>parcelRequire('1YxK5'));

});

parcelRegister("6ruAp", function(module, exports) {

let $4b0cfd78210a302c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4b0cfd78210a302c$var$load("jdfXm").then(()=>parcelRequire('eh53f'));

});

parcelRegister("gxAUL", function(module, exports) {

let $c0ac5cdd3d563bd6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c0ac5cdd3d563bd6$var$load("g2E6R").then(()=>parcelRequire('e7QVA'));

});

parcelRegister("7xXf0", function(module, exports) {

let $57e991822880a7f8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $57e991822880a7f8$var$load("9pOEg").then(()=>parcelRequire('ddkGO'));

});

parcelRegister("6xmsq", function(module, exports) {

let $4c273eb85e013bc7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4c273eb85e013bc7$var$load("3IA1C").then(()=>parcelRequire('fGplT'));

});

parcelRegister("lStcL", function(module, exports) {

let $fed54b97f7b55bed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fed54b97f7b55bed$var$load("lkiub").then(()=>parcelRequire('b4bht'));

});

parcelRegister("dwuVP", function(module, exports) {

let $9d8641e43c665d51$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9d8641e43c665d51$var$load("8Szhy").then(()=>parcelRequire('dHTzR'));

});

parcelRegister("9uf6k", function(module, exports) {

let $6e82a127330bad3d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6e82a127330bad3d$var$load("aAjPW").then(()=>parcelRequire('8N4YE'));

});

parcelRegister("19tni", function(module, exports) {

let $0d6d6ae74a295601$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0d6d6ae74a295601$var$load("3CgQU").then(()=>parcelRequire('dVInm'));

});

parcelRegister("fI7ZB", function(module, exports) {

let $b7012a392b284492$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b7012a392b284492$var$load("aH9hz").then(()=>parcelRequire('4EDRK'));

});

parcelRegister("4QBCK", function(module, exports) {

let $38793410994b5bb9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $38793410994b5bb9$var$load("4maWX").then(()=>parcelRequire('hxlEI'));

});

parcelRegister("lf5sD", function(module, exports) {

let $f76f3c1c0cced188$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f76f3c1c0cced188$var$load("2o4Wm").then(()=>parcelRequire('4N68Y'));

});

parcelRegister("ewCAm", function(module, exports) {

let $a931fc19b33b6ce8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a931fc19b33b6ce8$var$load("2x412").then(()=>parcelRequire('00Mm5'));

});

parcelRegister("gSOTt", function(module, exports) {

let $c4a92aec1d40963e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c4a92aec1d40963e$var$load("PYk2N").then(()=>parcelRequire('iyFSu'));

});

parcelRegister("9b0w8", function(module, exports) {

let $6ae58ad715618026$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6ae58ad715618026$var$load("Lfv9s").then(()=>parcelRequire('6yPaB'));

});

parcelRegister("9ejEW", function(module, exports) {

let $6b84abd0a39e70d1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b84abd0a39e70d1$var$load("7muI7").then(()=>parcelRequire('fmoP3'));

});

parcelRegister("bMYzJ", function(module, exports) {

let $89532a62e40ef6b4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $89532a62e40ef6b4$var$load("9XTcG").then(()=>parcelRequire('3HIEW'));

});

parcelRegister("62SxZ", function(module, exports) {
module.exports = JSON.parse("{\"jsm-megatron.jsm-help-center-management-update-help-center.screen-space-flags.description.no-translate\":[{\"type\":0,\"value\":\"Replace this with a short summary of what this message tells the recipient.\"}],\"jsm-megatron.jsm-help-center-management-update-help-center.screen-space-flags.title.no-translate\":[{\"type\":0,\"value\":\"This is a Post Office Test Message\"}]}");

});

parcelRegister("jMin0", function(module, exports) {

let $e660bfe812fb3935$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e660bfe812fb3935$var$load("lKf69").then(()=>parcelRequire('355lK'));

});

parcelRegister("jOOLq", function(module, exports) {

let $e6da1082d411d41c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e6da1082d411d41c$var$load("fUJ1w").then(()=>parcelRequire('bwGgS'));

});

parcelRegister("dFsO2", function(module, exports) {

let $9f3572fd153aeb29$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9f3572fd153aeb29$var$load("fxjSJ").then(()=>parcelRequire('f88aq'));

});

parcelRegister("7RHRl", function(module, exports) {

let $5b9f813348cc4102$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5b9f813348cc4102$var$load("j5eLf").then(()=>parcelRequire('c7uMm'));

});

parcelRegister("2yal3", function(module, exports) {

let $1db6c6c511c59ced$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1db6c6c511c59ced$var$load("fPGHD").then(()=>parcelRequire('4PLSl'));

});

parcelRegister("aqy1O", function(module, exports) {

let $7976ba6295901549$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7976ba6295901549$var$load("c6Gbu").then(()=>parcelRequire('1CQfg'));

});

parcelRegister("c9kh3", function(module, exports) {

let $8d860d526cdadcd2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8d860d526cdadcd2$var$load("50YOt").then(()=>parcelRequire('dNraY'));

});

parcelRegister("7HGdd", function(module, exports) {

let $59bd4b05a711cd18$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $59bd4b05a711cd18$var$load("kI17W").then(()=>parcelRequire('6qALh'));

});

parcelRegister("gsysz", function(module, exports) {

let $bfb9fde079da3d6f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bfb9fde079da3d6f$var$load("7bVkI").then(()=>parcelRequire('75cuU'));

});

parcelRegister("gWeg4", function(module, exports) {

let $c54d1f8619f3a8e4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c54d1f8619f3a8e4$var$load("lMFGf").then(()=>parcelRequire('jNVzi'));

});

parcelRegister("kL6H0", function(module, exports) {

let $f1cd6373aa8d08af$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f1cd6373aa8d08af$var$load("4Qpbc").then(()=>parcelRequire('1I4YL'));

});

parcelRegister("damiK", function(module, exports) {

let $995d821e21e3fd0c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $995d821e21e3fd0c$var$load("lq0cX").then(()=>parcelRequire('cHiba'));

});

parcelRegister("7N3rm", function(module, exports) {

let $5abfc72bfa3ad646$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5abfc72bfa3ad646$var$load("bTSj6").then(()=>parcelRequire('8MbrZ'));

});

parcelRegister("5Xelr", function(module, exports) {

let $455d970aa02e860b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $455d970aa02e860b$var$load("lshE9").then(()=>parcelRequire('lmFzk'));

});

parcelRegister("gpKRP", function(module, exports) {

let $bf3355faae4d4c66$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bf3355faae4d4c66$var$load("8vBqw").then(()=>parcelRequire('4e51K'));

});

parcelRegister("1v10D", function(module, exports) {

let $1179781e1927dc29$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1179781e1927dc29$var$load("c8o4A").then(()=>parcelRequire('fKNN6'));

});

parcelRegister("9ghzJ", function(module, exports) {

let $6be33dc235aed216$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6be33dc235aed216$var$load("drPsu").then(()=>parcelRequire('a8LtR'));

});

parcelRegister("heZJy", function(module, exports) {

let $c8d3a180a9027c4d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c8d3a180a9027c4d$var$load("4fGp6").then(()=>parcelRequire('8kp7r'));

});

parcelRegister("fn69F", function(module, exports) {

let $b30dc736f67ca3b9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b30dc736f67ca3b9$var$load("ccc7F").then(()=>parcelRequire('7ioQX'));

});

parcelRegister("asfgE", function(module, exports) {

let $79c85cb860a6d54f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $79c85cb860a6d54f$var$load("5V801").then(()=>parcelRequire('kpHv5'));

});

parcelRegister("gwAVU", function(module, exports) {

let $c07c489c324a0d64$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c07c489c324a0d64$var$load("9nmxE").then(()=>parcelRequire('i7XM9'));

});

parcelRegister("iTmWZ", function(module, exports) {

let $dc0f2a87f5ad5130$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dc0f2a87f5ad5130$var$load("7RotC").then(()=>parcelRequire('4lqwr'));

});

parcelRegister("fg2Cq", function(module, exports) {

let $b1ba61a7dfb3d1b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b1ba61a7dfb3d1b3$var$load("66YRA").then(()=>parcelRequire('3yQXY'));

});

parcelRegister("3sB2n", function(module, exports) {

let $2850b77c9960a25e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2850b77c9960a25e$var$load("fv9iD").then(()=>parcelRequire('flsvT'));

});

parcelRegister("a8Wlb", function(module, exports) {

let $7627e800565b0b32$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7627e800565b0b32$var$load("ep6Mk").then(()=>parcelRequire('epjnC'));

});

parcelRegister("hc9RE", function(module, exports) {

let $c84b357f2cceca83$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c84b357f2cceca83$var$load("2yPtR").then(()=>parcelRequire('4QUw1'));

});

parcelRegister("kGBbT", function(module, exports) {

let $f0f49434c58dde32$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f0f49434c58dde32$var$load("1zvzU").then(()=>parcelRequire('eJ4Dg'));

});

parcelRegister("2CDZ1", function(module, exports) {

let $1e8e253224ada80c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1e8e253224ada80c$var$load("fAuHA").then(()=>parcelRequire('45jHT'));

});

parcelRegister("7sB4Q", function(module, exports) {

let $56e7e8a91e977f33$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $56e7e8a91e977f33$var$load("eUsSw").then(()=>parcelRequire('924WQ'));

});

parcelRegister("5t147", function(module, exports) {

let $3fb07cbf6cada63f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3fb07cbf6cada63f$var$load("cQ37s").then(()=>parcelRequire('cXC52'));

});

parcelRegister("krmx4", function(module, exports) {

let $ee17cebb64a64715$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ee17cebb64a64715$var$load("3JXZr").then(()=>parcelRequire('86OzW'));

});

parcelRegister("lPcPF", function(module, exports) {

let $fe3850a38df489b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fe3850a38df489b3$var$load("6lSZL").then(()=>parcelRequire('7HUMA'));

});

parcelRegister("l14WC", function(module, exports) {

let $f4cd86d4888851e2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f4cd86d4888851e2$var$load("g0ljR").then(()=>parcelRequire('lPpdd'));

});

parcelRegister("hD4Qb", function(module, exports) {

let $cd59d5754452b5f4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cd59d5754452b5f4$var$load("6oDW5").then(()=>parcelRequire('5j34c'));

});

parcelRegister("lpVVF", function(module, exports) {
module.exports = JSON.parse('{"jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.email.body.address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.email.body.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.email.body.cta.shift-details":[{"type":0,"value":"View shift details"}],"jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.email.body.cta.work-items":[{"type":0,"value":"View work items"}],"jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.email.body.heading":[{"type":0,"value":"Your shift in "},{"type":1,"value":"scheduleName"},{"type":0,"value":" starts in "},{"type":1,"value":"leadMinutes"},{"type":0,"value":" minutes"}],"jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.email.body.preferences":[{"type":0,"value":"Manage notifications for your schedules"}],"jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.email.body.shift-ends.label":[{"type":0,"value":"Shift ends:"}],"jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.email.body.shift-starts.label":[{"type":0,"value":"Shift starts:"}],"jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.message-template.email.subject":[{"type":0,"value":"Your shift in "},{"type":1,"value":"scheduleName"},{"type":0,"value":" starts soon"}],"jsm-project-summary-onboarding.changeLayout":[{"type":0,"value":"Change the layout and order of charts"}],"jsm-project-summary-onboarding.closeButton":[{"type":0,"value":"Close"}],"jsm-project-summary-onboarding.description":[{"type":0,"value":"You can now edit the summary page to keep your team up to date. Tailor your space overview by customizing the layout, filters, and charts."}],"jsm-project-summary-onboarding.editFilters":[{"type":0,"value":"Edit filters"}],"jsm-project-summary-onboarding.heading":[{"type":0,"value":"Edit your space summary"}],"jsm-project-summary-onboarding.hideAddCharts":[{"type":0,"value":"Hide or add charts"}],"jsm-project-summary-onboarding.moreAboutFeature":[{"type":0,"value":"More about space summary"}],"jsm-project-summary-onboarding.okButton":[{"type":0,"value":"Got it"}],"jsm-project-summary-onboarding.whatsNewTitle":[{"type":0,"value":"What\u2019s new?"}],"jsm-wfm-setup-completion-reminder.body-nonfinal":[{"type":0,"value":"Start routing work to agents based on schedules, availability, and capacity."}],"jsm-wfm-setup-completion-reminder.cta-nonfinal":[{"type":0,"value":"Set up"}],"jsm-wfm-setup-completion-reminder.dismiss-nonfinal":[{"type":0,"value":"Dismiss"}],"jsm-wfm-setup-completion-reminder.title-nonfinal":[{"type":0,"value":"Set up workforce management"}]}');

});

parcelRegister("acziF", function(module, exports) {

let $76d6684155d91efa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $76d6684155d91efa$var$load("clzDl").then(()=>parcelRequire('c4uOe'));

});

parcelRegister("jP4Dk", function(module, exports) {

let $e6e65fd11289375c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e6e65fd11289375c$var$load("80U4D").then(()=>parcelRequire('dvadT'));

});

parcelRegister("g9Mmd", function(module, exports) {

let $bc32ff5b0d0ba770$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bc32ff5b0d0ba770$var$load("j2deT").then(()=>parcelRequire('dEEnn'));

});

parcelRegister("c8CIX", function(module, exports) {

let $8d644534cc38ad0a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8d644534cc38ad0a$var$load("8LOKW").then(()=>parcelRequire('g3RHO'));

});

parcelRegister("cLyLc", function(module, exports) {

let $94b4d67bac82e4b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $94b4d67bac82e4b1$var$load("1yBnY").then(()=>parcelRequire('cN2Nx'));

});

parcelRegister("6huTR", function(module, exports) {

let $492c4cb090ad355f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $492c4cb090ad355f$var$load("1wn0F").then(()=>parcelRequire('2tZDf'));

});

parcelRegister("02XSw", function(module, exports) {

let $008ea29e2785563d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $008ea29e2785563d$var$load("sRO5I").then(()=>parcelRequire('koyVD'));

});

parcelRegister("5CNqE", function(module, exports) {

let $4186d7e56ff0e40c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4186d7e56ff0e40c$var$load("g5Wvk").then(()=>parcelRequire('7xXrU'));

});

parcelRegister("iPbDx", function(module, exports) {

let $db46043615d54f9e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $db46043615d54f9e$var$load("HsCzv").then(()=>parcelRequire('4rZCo'));

});

parcelRegister("j3Rl4", function(module, exports) {

let $de07ac18c51a3c51$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $de07ac18c51a3c51$var$load("e7mzU").then(()=>parcelRequire('bouJk'));

});

parcelRegister("1uoXH", function(module, exports) {

let $115bf4adc942d769$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $115bf4adc942d769$var$load("83eto").then(()=>parcelRequire('cJDu0'));

});

parcelRegister("lNTqV", function(module, exports) {

let $fdf92c77c5fdddac$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fdf92c77c5fdddac$var$load("iXmvI").then(()=>parcelRequire('b9CSL'));

});

parcelRegister("6Wm8l", function(module, exports) {

let $50d954243c9e44c7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $50d954243c9e44c7$var$load("5iVxj").then(()=>parcelRequire('990rL'));

});

parcelRegister("iRCg9", function(module, exports) {

let $dbbadac5dba1e30d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dbbadac5dba1e30d$var$load("hukdG").then(()=>parcelRequire('kyaSe'));

});

parcelRegister("3kGub", function(module, exports) {

let $26d432269dc2deb0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $26d432269dc2deb0$var$load("jnlqz").then(()=>parcelRequire('fUGpa'));

});

parcelRegister("1QZp2", function(module, exports) {

let $159a4718520ae19c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $159a4718520ae19c$var$load("g4c70").then(()=>parcelRequire('649Bv'));

});

parcelRegister("01qRf", function(module, exports) {

let $0044ed82f58348e3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0044ed82f58348e3$var$load("lEBEM").then(()=>parcelRequire('3DNWB'));

});

parcelRegister("uwqzU", function(module, exports) {

let $05bbf4eb358d0325$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $05bbf4eb358d0325$var$load("8DTy4").then(()=>parcelRequire('R99iv'));

});

parcelRegister("mKEZ8", function(module, exports) {

let $04463fe71977467d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $04463fe71977467d$var$load("5MdzJ").then(()=>parcelRequire('fBBEW'));

});

parcelRegister("l0rWL", function(module, exports) {

let $f4af46b67049ac62$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f4af46b67049ac62$var$load("gfBQB").then(()=>parcelRequire('5kaEJ'));

});

parcelRegister("4ALsf", function(module, exports) {

let $357f55bc8c8ecc87$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $357f55bc8c8ecc87$var$load("jMrHj").then(()=>parcelRequire('iZBtj'));

});

parcelRegister("aBQpk", function(module, exports) {

let $01fe4a5f736cb467$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $01fe4a5f736cb467$var$load("yV6mq").then(()=>parcelRequire('jaYaK'));

});

parcelRegister("9aVqg", function(module, exports) {

let $6ae1972e372a81f4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6ae1972e372a81f4$var$load("bA1Ze").then(()=>parcelRequire('5kRaj'));

});

parcelRegister("6nZlF", function(module, exports) {

let $4a647a97dccdfb61$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a647a97dccdfb61$var$load("b5DyJ").then(()=>parcelRequire('15XZL'));

});

parcelRegister("danHd", function(module, exports) {

let $995e97163c3a0eb7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $995e97163c3a0eb7$var$load("1vghY").then(()=>parcelRequire('9uu3u'));

});

parcelRegister("6G461", function(module, exports) {

let $4dc9d7bbde719473$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4dc9d7bbde719473$var$load("5TbY4").then(()=>parcelRequire('55pYC'));

});

parcelRegister("2OLQd", function(module, exports) {

let $20d55c8d1026a138$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $20d55c8d1026a138$var$load("4LA5S").then(()=>parcelRequire('5roIj'));

});

parcelRegister("be6SR", function(module, exports) {

let $82c65782e61dbcb8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $82c65782e61dbcb8$var$load("1sSWt").then(()=>parcelRequire('hGZVV'));

});

parcelRegister("lVSd3", function(module, exports) {

let $ff78f8b731ca6759$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ff78f8b731ca6759$var$load("3oNaU").then(()=>parcelRequire('fi7n7'));

});

parcelRegister("cpdri", function(module, exports) {

let $90823e981070f5e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $90823e981070f5e8$var$load("dNJRO").then(()=>parcelRequire('kSqa6'));

});

parcelRegister("3Bixi", function(module, exports) {

let $29f334aeab35bb59$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $29f334aeab35bb59$var$load("fJAgc").then(()=>parcelRequire('g3f55'));

});

parcelRegister("3Yuu3", function(module, exports) {

let $2e4e9f1ee0aa8454$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2e4e9f1ee0aa8454$var$load("iKZaN").then(()=>parcelRequire('f811W'));

});

parcelRegister("k3dTn", function(module, exports) {

let $e98edd285d099ed4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e98edd285d099ed4$var$load("kQOp7").then(()=>parcelRequire('1XS4x'));

});

parcelRegister("56e4D", function(module, exports) {

let $3b686e094296da07$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3b686e094296da07$var$load("2bmSH").then(()=>parcelRequire('iR55a'));

});

parcelRegister("03a7D", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("iUFhM", function(module, exports) {

let $dc4d7b6ece384144$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dc4d7b6ece384144$var$load("fbUx3").then(()=>parcelRequire('7Wkhh'));

});

parcelRegister("6kbnv", function(module, exports) {

let $49ad6fcb7b42f4c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $49ad6fcb7b42f4c9$var$load("gQxLC").then(()=>parcelRequire('5dr6c'));

});

parcelRegister("isMeM", function(module, exports) {

let $d7104279c0fff186$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d7104279c0fff186$var$load("dzNSE").then(()=>parcelRequire('4flfD'));

});

parcelRegister("6ePtG", function(module, exports) {

let $48abfb514a50c6ae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $48abfb514a50c6ae$var$load("5hjht").then(()=>parcelRequire('1gxMF'));

});

parcelRegister("8h36A", function(module, exports) {

let $606251e9cd784b22$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $606251e9cd784b22$var$load("bpjR5").then(()=>parcelRequire('6Rt75'));

});

parcelRegister("iGK1b", function(module, exports) {

let $d9afd87a27f28c28$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d9afd87a27f28c28$var$load("kdosV").then(()=>parcelRequire('d02ln'));

});

parcelRegister("cdt3d", function(module, exports) {

let $8e4d3bd6d3b4e7ac$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8e4d3bd6d3b4e7ac$var$load("1rljH").then(()=>parcelRequire('jsqSS'));

});

parcelRegister("6wWfH", function(module, exports) {

let $4c12eae5d5846f34$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4c12eae5d5846f34$var$load("lQQwQ").then(()=>parcelRequire('2oq3E'));

});

parcelRegister("2Neoq", function(module, exports) {

let $208b5286403da667$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $208b5286403da667$var$load("88sXV").then(()=>parcelRequire('eXC49'));

});

parcelRegister("enz3X", function(module, exports) {

let $a77e6967caaaf961$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a77e6967caaaf961$var$load("9MKUm").then(()=>parcelRequire('cjdgt'));

});

parcelRegister("9fEIL", function(module, exports) {

let $6bc51a19fde0b5cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6bc51a19fde0b5cb$var$load("8b1LB").then(()=>parcelRequire('aFJf4'));

});

parcelRegister("2RZTm", function(module, exports) {

let $21708a724f0d4b38$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $21708a724f0d4b38$var$load("a4wJB").then(()=>parcelRequire('cLfcK'));

});

parcelRegister("bm8hE", function(module, exports) {

let $84482cbca7d97542$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $84482cbca7d97542$var$load("3GVyX").then(()=>parcelRequire('2CZnm'));

});

parcelRegister("ccxy3", function(module, exports) {

let $8e20a103c91546a0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8e20a103c91546a0$var$load("b8tYi").then(()=>parcelRequire('3tEGO'));

});

parcelRegister("fF1ow", function(module, exports) {

let $b66bc44823ad44b4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b66bc44823ad44b4$var$load("duexz").then(()=>parcelRequire('h4K13'));

});

parcelRegister("7sapK", function(module, exports) {

let $56d339fd2a5e9a85$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $56d339fd2a5e9a85$var$load("aQMbY").then(()=>parcelRequire('dUCTu'));

});

parcelRegister("6tBdX", function(module, exports) {

let $4b725375fa4aab56$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4b725375fa4aab56$var$load("lnHpr").then(()=>parcelRequire('dz5D7'));

});

parcelRegister("5DiPD", function(module, exports) {

let $419f33e6238b6d22$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $419f33e6238b6d22$var$load("8VwfX").then(()=>parcelRequire('zwQRn'));

});

parcelRegister("4KOk9", function(module, exports) {

let $37627ea0db62dfed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $37627ea0db62dfed$var$load("54iKW").then(()=>parcelRequire('lzJNJ'));

});

parcelRegister("4IrS3", function(module, exports) {

let $36f0e40cabf6b65b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $36f0e40cabf6b65b$var$load("3jKg4").then(()=>parcelRequire('dutYd'));

});

parcelRegister("8oujl", function(module, exports) {

let $61c813bec8b42b8f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $61c813bec8b42b8f$var$load("aNrcY").then(()=>parcelRequire('gCiXl'));

});

parcelRegister("DIrQ3", function(module, exports) {

let $07761f14e1593b37$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $07761f14e1593b37$var$load("4BBRG").then(()=>parcelRequire('2KlJ2'));

});

parcelRegister("gZQ9s", function(module, exports) {

let $c5facc0d8b5730bd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c5facc0d8b5730bd$var$load("cEOBh").then(()=>parcelRequire('5mufr'));

});

parcelRegister("clvP4", function(module, exports) {

let $8fd021862f8e216a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8fd021862f8e216a$var$load("2QvjT").then(()=>parcelRequire('8sXOG'));

});

parcelRegister("KfxtW", function(module, exports) {

let $08b059b862207b1a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $08b059b862207b1a$var$load("7czjb").then(()=>parcelRequire('8LeSZ'));

});

parcelRegister("2z4QG", function(module, exports) {

let $1de29c826721e552$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1de29c826721e552$var$load("lQ6Bu").then(()=>parcelRequire('dDMVS'));

});

parcelRegister("d713K", function(module, exports) {

let $98bcc036b7658da1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $98bcc036b7658da1$var$load("695sI").then(()=>parcelRequire('70147'));

});

parcelRegister("h9naC", function(module, exports) {

let $c7c54010e793f403$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c7c54010e793f403$var$load("fXXDL").then(()=>parcelRequire('hopxO'));

});

parcelRegister("7prL8", function(module, exports) {

let $5650669dbf62e4d7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5650669dbf62e4d7$var$load("1dHe5").then(()=>parcelRequire('iEOIs'));

});

parcelRegister("937zY", function(module, exports) {

let $696a45f82220b7c1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $696a45f82220b7c1$var$load("bfbL0").then(()=>parcelRequire('aocP1'));

});

parcelRegister("dclGe", function(module, exports) {

let $99bd369a0b78a535$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $99bd369a0b78a535$var$load("3m9RT").then(()=>parcelRequire('1YcRm'));

});

parcelRegister("kkNoL", function(module, exports) {

let $ecdbfe62a2428c6a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ecdbfe62a2428c6a$var$load("hKwnn").then(()=>parcelRequire('iaAyD'));

});

parcelRegister("34TFK", function(module, exports) {

let $23dcee2f3c70654b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $23dcee2f3c70654b$var$load("9aMDB").then(()=>parcelRequire('h8Rqx'));

});

parcelRegister("iO9wq", function(module, exports) {

let $db14486427169f06$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $db14486427169f06$var$load("5RDyg").then(()=>parcelRequire('i4LVu'));

});

parcelRegister("6QKF0", function(module, exports) {
module.exports = JSON.parse("{\"confluence-integrations.confluence-devdocs-sync-complete.message-template.notification-drawer.message\":[{\"type\":0,\"value\":\"Docs created from your code are ready\"}],\"confluence-integrations.project-pages-revamp-onboarding-spotlight.body\":[{\"type\":0,\"value\":\"Pages is now Docs. Access pages, live docs, and more, all from your space.\"}],\"confluence-integrations.project-pages-revamp-onboarding-spotlight.done-button\":[{\"type\":0,\"value\":\"Done\"}],\"confluence-integrations.project-pages-revamp-onboarding-spotlight.heading\":[{\"type\":0,\"value\":\"One place for all your project docs\"}]}");

});

parcelRegister("58F0p", function(module, exports) {

let $3bdd81f88a5c3777$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3bdd81f88a5c3777$var$load("k7Dnl").then(()=>parcelRequire('9i2oi'));

});

parcelRegister("kIii3", function(module, exports) {

let $f1461abc1fdf2507$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f1461abc1fdf2507$var$load("cObhK").then(()=>parcelRequire('6qycB'));

});

parcelRegister("eppSn", function(module, exports) {

let $a7d778f2eb67a676$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a7d778f2eb67a676$var$load("6sKsv").then(()=>parcelRequire('lIIii'));

});

parcelRegister("2UIqY", function(module, exports) {

let $21f3476f586654db$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $21f3476f586654db$var$load("9wYt0").then(()=>parcelRequire('2gEZT'));

});

parcelRegister("fZuj0", function(module, exports) {

let $ba440f928de1d27c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ba440f928de1d27c$var$load("bwIB0").then(()=>parcelRequire('7NsNP'));

});

parcelRegister("5TuVS", function(module, exports) {

let $44aa155562075d1e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $44aa155562075d1e$var$load("1mr1Y").then(()=>parcelRequire('lJPUp'));

});

parcelRegister("fULde", function(module, exports) {

let $b960b560bd0f6de0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b960b560bd0f6de0$var$load("ciR0c").then(()=>parcelRequire('cyUPE'));

});

parcelRegister("dVNJ2", function(module, exports) {

let $a2472ba72bed8324$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a2472ba72bed8324$var$load("1m3JB").then(()=>parcelRequire('5HjuF'));

});

parcelRegister("kdH7o", function(module, exports) {

let $eb8677e766cbe23b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eb8677e766cbe23b$var$load("1s4Mb").then(()=>parcelRequire('dLbGh'));

});

parcelRegister("girve", function(module, exports) {

let $bdd3a93e3d0b5686$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bdd3a93e3d0b5686$var$load("9uXfC").then(()=>parcelRequire('cuewo'));

});

parcelRegister("91l9v", function(module, exports) {

let $69149d7cbef2db5b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $69149d7cbef2db5b$var$load("7rTXm").then(()=>parcelRequire('1zefa'));

});

parcelRegister("jrZjR", function(module, exports) {

let $e2901ab32f15e28c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e2901ab32f15e28c$var$load("1UUyE").then(()=>parcelRequire('bk50W'));

});

parcelRegister("kEqGy", function(module, exports) {

let $f08c3e3a25e8fc05$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f08c3e3a25e8fc05$var$load("21w5u").then(()=>parcelRequire('B9X3D'));

});

parcelRegister("9g7V6", function(module, exports) {

let $6bdbc072063b0f20$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6bdbc072063b0f20$var$load("bdqac").then(()=>parcelRequire('dSjS5'));

});

parcelRegister("awfIw", function(module, exports) {

let $7a8915a71233e2bf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a8915a71233e2bf$var$load("hZ7yF").then(()=>parcelRequire('kaZS7'));

});

parcelRegister("50HSs", function(module, exports) {

let $3a5efcfb9e1d51fe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3a5efcfb9e1d51fe$var$load("94QX4").then(()=>parcelRequire('j4Mcf'));

});

parcelRegister("k7EOY", function(module, exports) {

let $ea64204df2da39d7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ea64204df2da39d7$var$load("4GUO8").then(()=>parcelRequire('2ryMG'));

});

parcelRegister("avOKD", function(module, exports) {

let $7a742abe1f1392c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a742abe1f1392c9$var$load("lj8m0").then(()=>parcelRequire('8mfQ7'));

});

parcelRegister("8aJGT", function(module, exports) {

let $5f32b324e7c4403f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5f32b324e7c4403f$var$load("8vLZJ").then(()=>parcelRequire('1U2Qj'));

});

parcelRegister("b2n8Q", function(module, exports) {

let $8091d5119526e3f4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8091d5119526e3f4$var$load("gQvB5").then(()=>parcelRequire('i4ySq'));

});

parcelRegister("1FdUP", function(module, exports) {

let $13646a1efb263bfe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $13646a1efb263bfe$var$load("h2ndR").then(()=>parcelRequire('du0VX'));

});

parcelRegister("1PBOf", function(module, exports) {

let $1557e20f040a9e30$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1557e20f040a9e30$var$load("87AZ8").then(()=>parcelRequire('9wwbg'));

});

parcelRegister("ayxE3", function(module, exports) {

let $7af72d8a695b78d6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7af72d8a695b78d6$var$load("cly39").then(()=>parcelRequire('kwKie'));

});

parcelRegister("3yI8C", function(module, exports) {

let $2976c8f9d1727717$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2976c8f9d1727717$var$load("aRcDN").then(()=>parcelRequire('5eo49'));

});

parcelRegister("hmA7l", function(module, exports) {

let $ca4081eff11ef43a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ca4081eff11ef43a$var$load("894o2").then(()=>parcelRequire('aAW0m'));

});

parcelRegister("8suUU", function(module, exports) {

let $6288ebb6481400b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6288ebb6481400b1$var$load("5laHz").then(()=>parcelRequire('9j0Ep'));

});

parcelRegister("1f1ta", function(module, exports) {

let $0e7854f80087d490$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0e7854f80087d490$var$load("hXaWt").then(()=>parcelRequire('2NLmt'));

});

parcelRegister("gwAcJ", function(module, exports) {

let $c07bb7eb7530ebb1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c07bb7eb7530ebb1$var$load("3aIcV").then(()=>parcelRequire('fMBHX'));

});

parcelRegister("6odmS", function(module, exports) {

let $4a6f5a93fc7ffffe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a6f5a93fc7ffffe$var$load("9y7HQ").then(()=>parcelRequire('dGXM1'));

});

parcelRegister("dNgup", function(module, exports) {

let $a0aca46d975727d7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a0aca46d975727d7$var$load("b4rrC").then(()=>parcelRequire('gy9DE'));

});

parcelRegister("8rgs7", function(module, exports) {

let $624d9b7f239a6113$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $624d9b7f239a6113$var$load("kQXg5").then(()=>parcelRequire('jG2N2'));

});

parcelRegister("aowj5", function(module, exports) {

let $791534c227f320c0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $791534c227f320c0$var$load("9uhto").then(()=>parcelRequire('2qRwZ'));

});

parcelRegister("8Mkmm", function(module, exports) {

let $6642996de4b01278$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6642996de4b01278$var$load("2h8kX").then(()=>parcelRequire('2PgN2'));

});

parcelRegister("i9CdS", function(module, exports) {

let $d376b77f4e0cf4cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d376b77f4e0cf4cb$var$load("f07eY").then(()=>parcelRequire('l4vKr'));

});

parcelRegister("5WcjV", function(module, exports) {
module.exports = JSON.parse('{"post-office.rovo-chat-button.main-heading.dismiss":[{"type":0,"value":"Dismiss"}],"post-office.rovo-chat-button.onboarding-heading":[{"type":0,"value":"Chat with Rovo AI"}],"post-office.rovo-chat-button.onboarding-input-placeholder-1":[{"type":0,"value":"Pick a conversation starter or ask Rovo anything"}],"post-office.rovo-chat-button.onboarding-input-placeholder-2":[{"type":0,"value":"Write a prompt"}],"post-office.rovo-chat-button.send-prompt":[{"type":0,"value":"Send prompt"}],"post-office.rovo-chat.3p-connector-nudge.connect-button":[{"type":0,"value":"Connect "},{"type":1,"value":"appName"}],"post-office.rovo-chat.3p-connector-nudge.dismiss-button":[{"type":0,"value":"Dismiss"}],"post-office.rovo-chat.3p-connector-nudge.heading":[{"type":0,"value":"Your admin has added "},{"type":1,"value":"appName"}],"post-office.rovo-chat.3p-connector-nudge.logo-alt":[{"type":1,"value":"appName"},{"type":0,"value":" logo"}],"post-office.rovo-chat.3p-connector-nudge.subtitle":[{"type":0,"value":"Connect your account to see more results"}],"post-office.rovo-chat.long-running-task-fullpage-banner.body":[{"type":0,"value":"Max takes on complex, multi-step work and comes back with a finished result."}],"post-office.rovo-chat.long-running-task-fullpage-banner.cta-button":[{"type":0,"value":"Get a team summary"}],"post-office.rovo-chat.long-running-task-fullpage-banner.dismiss-button":[{"type":0,"value":"Dismiss"}],"post-office.rovo-chat.long-running-task-fullpage-banner.headline":[{"type":0,"value":"Meet Max. It handles everything."}],"post-office.rovo-chat.long-running-task-fullpage-banner.max-label":[{"type":0,"value":"Max"}],"post-office.rovo-chat.long-running-task-fullpage-banner.primary-task-meta":[{"type":0,"value":"Awaiting user response"}],"post-office.rovo-chat.long-running-task-fullpage-banner.primary-task-meta-timestamp":[{"type":0,"value":"1 minute ago"}],"post-office.rovo-chat.long-running-task-fullpage-banner.primary-task-title":[{"type":0,"value":"Implement new authentication system"}],"post-office.rovo-chat.long-running-task-fullpage-banner.secondary-task-meta":[{"type":0,"value":"Just now"}],"post-office.rovo-chat.long-running-task-fullpage-banner.secondary-task-title":[{"type":0,"value":"New Policy Presentation"}],"post-office.rovo-chat.long-running-task-spotlight.body":[{"type":0,"value":"Max takes on complex, multi-step work and comes back with a finished result."}],"post-office.rovo-chat.long-running-task-spotlight.headline":[{"type":0,"value":"Say hi to Max"}],"post-office.rovo-chat.long-running-task-spotlight.side-panel-banner.body":[{"type":0,"value":"Max takes on complex, multi-step work for you."}],"post-office.rovo-chat.long-running-task-spotlight.side-panel-banner.dismiss-button":[{"type":0,"value":"Dismiss"}],"post-office.rovo-chat.long-running-task-spotlight.side-panel-banner.headline":[{"type":0,"value":"Meet Max. It handles everything."}],"post-office.rovo-chat.long-running-task-spotlight.side-panel-banner.try-max-button":[{"type":0,"value":"Try Max"}],"post-office.rovo-chat.memory-settings-onboarding-spotlight.action":[{"type":0,"value":"See how"}],"post-office.rovo-chat.memory-settings-onboarding-spotlight.body":[{"type":0,"value":"Rovo now remembers facts and details from your chats to make responses more personalized and helpful"}],"post-office.rovo-chat.memory-settings-onboarding-spotlight.headline":[{"type":0,"value":"A more personalized Rovo"}],"post-office.rovo-chat.web-search-preference-spotlight.body":[{"type":0,"value":"Web search is now on by default. You can turn it off anytime."}],"post-office.rovo-chat.web-search-preference-spotlight.headline":[{"type":0,"value":"Web search is on"}],"post-office.rovo-chat.web-search-spotlight.body":[{"type":0,"value":"We\'re running an experiment to improve Rovo. For some users, web search is now on by default\u2014you can turn it off any time."}],"post-office.rovo-chat.web-search-spotlight.dismiss":[{"type":0,"value":"Turn off default web search"}],"post-office.rovo-chat.web-search-spotlight.done":[{"type":0,"value":"Done"}],"post-office.rovo-chat.web-search-spotlight.headline":[{"type":0,"value":"Web search is now on by default"}],"post-office.rovo-chat.web-search-spotlight.manage-defaults":[{"type":0,"value":"Manage my defaults"}],"rovo-chat.inline-memory-saved-message.description.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"rovo-chat.inline-memory-saved-message.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"rovo-chat.rovo-chat-scheduled-chat-recurring-chat-complete.message-template.notification-drawer.message":[{"type":0,"value":"Rovo has completed your scheduled query"}],"rovo-chat.rovo-chat-task-awaiting-user.message-template.notification-drawer.message.no-translate":[{"type":0,"value":"Rovo is awaiting your response"}],"rovo-chat.rovo-chat-task-complete.message-template.notification-drawer.message":[{"type":0,"value":"Rovo has completed your task"}],"rovo-chat.rovo-chat-task-plan-generated.message-template.notification-drawer.message.no-translate":[{"type":0,"value":"Rovo has generated your plan"}]}');

});

parcelRegister("bGmWa", function(module, exports) {

let $881568c81b02779c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $881568c81b02779c$var$load("1ARj0").then(()=>parcelRequire('bKYpH'));

});

parcelRegister("3Cd3y", function(module, exports) {

let $2a1f0c6ef47650d3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2a1f0c6ef47650d3$var$load("5lGGX").then(()=>parcelRequire('bAzBg'));

});

parcelRegister("goDhu", function(module, exports) {

let $befd5ba38e006b0b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $befd5ba38e006b0b$var$load("jB5ov").then(()=>parcelRequire('48Qm4'));

});

parcelRegister("hewKr", function(module, exports) {

let $c8bd259300443e90$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c8bd259300443e90$var$load("k32Bn").then(()=>parcelRequire('gg4ee'));

});

parcelRegister("dZJcY", function(module, exports) {

let $a3040a4f11d130c2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a3040a4f11d130c2$var$load("bBNFz").then(()=>parcelRequire('eknDD'));

});

parcelRegister("f3DVu", function(module, exports) {

let $af661b53bffe8230$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $af661b53bffe8230$var$load("cujfT").then(()=>parcelRequire('fLbVb'));

});

parcelRegister("gCXvv", function(module, exports) {

let $c1ae5ad797f1de06$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c1ae5ad797f1de06$var$load("jv1W1").then(()=>parcelRequire('eoW7v'));

});

parcelRegister("boVWr", function(module, exports) {

let $84cee1922cff73de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $84cee1922cff73de$var$load("42Bqq").then(()=>parcelRequire('hiamJ'));

});

parcelRegister("6x9hI", function(module, exports) {

let $4c1d06e76a97c94e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4c1d06e76a97c94e$var$load("dcfds").then(()=>parcelRequire('eU3AQ'));

});

parcelRegister("h3xxR", function(module, exports) {

let $c6acbcd48437cb2f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c6acbcd48437cb2f$var$load("g07T8").then(()=>parcelRequire('bqeEy'));

});

parcelRegister("fsMMj", function(module, exports) {

let $b41f4edb6ba42f5e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b41f4edb6ba42f5e$var$load("kr42s").then(()=>parcelRequire('iAUci'));

});

parcelRegister("db4Xx", function(module, exports) {

let $99802640bfedc43d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $99802640bfedc43d$var$load("lJEIV").then(()=>parcelRequire('1dtXv'));

});

parcelRegister("a8FB5", function(module, exports) {

let $761aeb11e73c3157$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $761aeb11e73c3157$var$load("4jwJ3").then(()=>parcelRequire('52LyJ'));

});

parcelRegister("2q9wP", function(module, exports) {

let $1c3566a353549f93$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1c3566a353549f93$var$load("a6iRV").then(()=>parcelRequire('eOaJh'));

});

parcelRegister("fOqRP", function(module, exports) {

let $b8305dc7caf5f966$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b8305dc7caf5f966$var$load("lAYyC").then(()=>parcelRequire('aGsFc'));

});

parcelRegister("5iWHo", function(module, exports) {

let $3dcc2a8bca4a2f10$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3dcc2a8bca4a2f10$var$load("4vEh0").then(()=>parcelRequire('KFkzr'));

});

parcelRegister("l4pkE", function(module, exports) {

let $f56d9f22a9eda167$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f56d9f22a9eda167$var$load("irTAI").then(()=>parcelRequire('gDXUd'));

});

parcelRegister("dpxdg", function(module, exports) {

let $9c375f907a4af170$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9c375f907a4af170$var$load("159pY").then(()=>parcelRequire('8Yzmj'));

});

parcelRegister("d0DKq", function(module, exports) {

let $978a1b8765846aa3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $978a1b8765846aa3$var$load("d98eX").then(()=>parcelRequire('frnTl'));

});

parcelRegister("irNuw", function(module, exports) {

let $d6e12393069271b9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d6e12393069271b9$var$load("4kq29").then(()=>parcelRequire('lnPSR'));

});

parcelRegister("8A21B", function(module, exports) {

let $63f3419a89502a03$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $63f3419a89502a03$var$load("gzlcr").then(()=>parcelRequire('lt0zY'));

});

parcelRegister("dAg7u", function(module, exports) {

let $9e3b2433ef75dd6c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9e3b2433ef75dd6c$var$load("ioziG").then(()=>parcelRequire('h0g74'));

});

parcelRegister("bkcEB", function(module, exports) {

let $83eb60c67ebaad99$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $83eb60c67ebaad99$var$load("cE4pd").then(()=>parcelRequire('bJXhH'));

});

parcelRegister("2BQks", function(module, exports) {

let $1e67a0eb72705cc8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1e67a0eb72705cc8$var$load("Bf65L").then(()=>parcelRequire('afd3B'));

});

parcelRegister("e3rpj", function(module, exports) {

let $a3b69afffe9faa86$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a3b69afffe9faa86$var$load("jEVwz").then(()=>parcelRequire('5ZzmK'));

});

parcelRegister("gJfty", function(module, exports) {

let $c2dcda78e47f655e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c2dcda78e47f655e$var$load("fMITV").then(()=>parcelRequire('8IEGN'));

});

parcelRegister("cOMKb", function(module, exports) {

let $954ff70ee1c280c6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $954ff70ee1c280c6$var$load("GYTWV").then(()=>parcelRequire('auRGd'));

});

parcelRegister("gSl3D", function(module, exports) {

let $c492061d7c5eabfb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c492061d7c5eabfb$var$load("4GBfP").then(()=>parcelRequire('98Qmo'));

});

parcelRegister("aZ3u6", function(module, exports) {

let $7ff24dde41b476f3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7ff24dde41b476f3$var$load("beTrz").then(()=>parcelRequire('bAogT'));

});

parcelRegister("1ZacD", function(module, exports) {

let $172367084aa84264$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $172367084aa84264$var$load("caN5r").then(()=>parcelRequire('8kGHF'));

});

parcelRegister("5poTN", function(module, exports) {

let $3f0299f0d2b22d00$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3f0299f0d2b22d00$var$load("fAirC").then(()=>parcelRequire('eJwHU'));

});

parcelRegister("4ddjz", function(module, exports) {

let $3112b456f7e3dd8a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3112b456f7e3dd8a$var$load("lXu14").then(()=>parcelRequire('hKIjR'));

});

parcelRegister("5XYFn", function(module, exports) {

let $4581857e24c453e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4581857e24c453e1$var$load("jWT3L").then(()=>parcelRequire('2K1Za'));

});

parcelRegister("gWZMd", function(module, exports) {

let $c571fbb282209729$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c571fbb282209729$var$load("lK4Gr").then(()=>parcelRequire('eTYup'));

});

parcelRegister("8IaD6", function(module, exports) {
module.exports = JSON.parse("{\"shared-user-preferences-onboarding.modal.alternative-text\":[{\"type\":0,\"value\":\"Alternatively, you can choose light or dark mode from the \"},{\"children\":[{\"type\":0,\"value\":\"Appearance\"}],\"type\":8,\"value\":\"appearanceSettings\"},{\"type\":0,\"value\":\" settings in your profile menu.\"}],\"shared-user-preferences-onboarding.modal.button.accept\":[{\"type\":0,\"value\":\"Okay\"}],\"shared-user-preferences-onboarding.modal.button.choose-theme\":[{\"type\":0,\"value\":\"Choose mode\"}],\"shared-user-preferences-onboarding.modal.button.close\":[{\"type\":0,\"value\":\"Close modal\"}],\"shared-user-preferences-onboarding.modal.description\":[{\"type\":0,\"value\":\"All supported apps will now match your system's display mode by default.\"}],\"shared-user-preferences-onboarding.modal.feature.consistent\":[{\"type\":0,\"value\":\"Consistent look and feel\"}],\"shared-user-preferences-onboarding.modal.feature.override\":[{\"type\":0,\"value\":\"Choose display mode for individual apps\"}],\"shared-user-preferences-onboarding.modal.feature.set-once\":[{\"type\":0,\"value\":\"Only set your display mode once\"}],\"shared-user-preferences-onboarding.modal.title\":[{\"type\":0,\"value\":\"Your display mode is now synced\"}]}");

});

parcelRegister("fjK1g", function(module, exports) {

let $b26c53d9c17eafe9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b26c53d9c17eafe9$var$load("2hZuF").then(()=>parcelRequire('650YV'));

});

parcelRegister("7Cxrz", function(module, exports) {

let $58c6063c5ca39a35$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $58c6063c5ca39a35$var$load("28FoP").then(()=>parcelRequire('cluqU'));

});

parcelRegister("gm21G", function(module, exports) {

let $be8045c120d8c71f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $be8045c120d8c71f$var$load("6zP5L").then(()=>parcelRequire('g1Zfp'));

});

parcelRegister("f0OVj", function(module, exports) {

let $aede5b6990465ccd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aede5b6990465ccd$var$load("12wpT").then(()=>parcelRequire('6xjV0'));

});

parcelRegister("baPkP", function(module, exports) {

let $822872ec8f023382$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $822872ec8f023382$var$load("fyAVO").then(()=>parcelRequire('iUX4f'));

});

parcelRegister("acwEe", function(module, exports) {

let $76d4598bcdbad909$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $76d4598bcdbad909$var$load("4GpiG").then(()=>parcelRequire('9IHIE'));

});

parcelRegister("1F7Fi", function(module, exports) {

let $135f90e559795dd0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $135f90e559795dd0$var$load("ia6Aw").then(()=>parcelRequire('dfeXA'));

});

parcelRegister("bYaRo", function(module, exports) {

let $8b6db8e7ca15df5a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8b6db8e7ca15df5a$var$load("l6Cdh").then(()=>parcelRequire('3EMoA'));

});

parcelRegister("7o16o", function(module, exports) {

let $560ba12a722b798f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $560ba12a722b798f$var$load("j4rni").then(()=>parcelRequire('2jAjz'));

});

parcelRegister("dlX8d", function(module, exports) {

let $9b8b1ad3fb83ed95$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9b8b1ad3fb83ed95$var$load("dO5re").then(()=>parcelRequire('hG6TU'));

});

parcelRegister("eEXjN", function(module, exports) {

let $aac2d08488ab9e34$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aac2d08488ab9e34$var$load("eZtKA").then(()=>parcelRequire('aERQP'));

});

parcelRegister("7Tvwf", function(module, exports) {

let $5bf61e7a6fda237d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5bf61e7a6fda237d$var$load("ereYz").then(()=>parcelRequire('iQyWj'));

});

parcelRegister("8G60n", function(module, exports) {

let $6516e77b8cf0cea2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6516e77b8cf0cea2$var$load("dWtto").then(()=>parcelRequire('iVaap'));

});

parcelRegister("iEFhI", function(module, exports) {

let $d94bfcb911fbc4f7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d94bfcb911fbc4f7$var$load("bZsVc").then(()=>parcelRequire('4Ttgk'));

});

parcelRegister("5J4lr", function(module, exports) {

let $42b486890a13afbe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $42b486890a13afbe$var$load("1pCBb").then(()=>parcelRequire('64tbW'));

});

parcelRegister("7TAVK", function(module, exports) {

let $5bfa5114a32b57de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5bfa5114a32b57de$var$load("5tyGk").then(()=>parcelRequire('cgJRD'));

});

parcelRegister("8K6Nr", function(module, exports) {

let $65d7e43b1e882f4e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $65d7e43b1e882f4e$var$load("1hP6d").then(()=>parcelRequire('k6nbq'));

});

parcelRegister("7Afq7", function(module, exports) {

let $5857db59220abb98$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5857db59220abb98$var$load("2ymcr").then(()=>parcelRequire('edMNK'));

});

parcelRegister("5gNbS", function(module, exports) {

let $3d649a96ab9e5cb8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3d649a96ab9e5cb8$var$load("9pq1l").then(()=>parcelRequire('45ZXM'));

});

parcelRegister("88tHU", function(module, exports) {

let $0187530d9f27975f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0187530d9f27975f$var$load("1g5q0").then(()=>parcelRequire('gjiud'));

});

parcelRegister("4LNoh", function(module, exports) {

let $3791dd2dfa2699ab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3791dd2dfa2699ab$var$load("cqNk4").then(()=>parcelRequire('1imww'));

});

parcelRegister("3UJPP", function(module, exports) {

let $2d9a27f054c16277$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2d9a27f054c16277$var$load("7YRqx").then(()=>parcelRequire('d2xbW'));

});

parcelRegister("8BoSL", function(module, exports) {

let $6435148d3e53c845$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6435148d3e53c845$var$load("ahmEh").then(()=>parcelRequire('gRHWX'));

});

parcelRegister("5bseM", function(module, exports) {

let $3c63e2300210cc27$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3c63e2300210cc27$var$load("8Jy6V").then(()=>parcelRequire('3CFxq'));

});

parcelRegister("8Taz6", function(module, exports) {

let $678ba7ce23a039d3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $678ba7ce23a039d3$var$load("d9lsa").then(()=>parcelRequire('7OOQP'));

});

parcelRegister("dSUn6", function(module, exports) {

let $a1bc0bbec02a590a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a1bc0bbec02a590a$var$load("dqqDj").then(()=>parcelRequire('6ML4N'));

});

parcelRegister("fV2yV", function(module, exports) {

let $b96e2ab8b2cb70aa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b96e2ab8b2cb70aa$var$load("aZ3Em").then(()=>parcelRequire('3yy7h'));

});

parcelRegister("7dIJm", function(module, exports) {

let $541c71dfc2a2550e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $541c71dfc2a2550e$var$load("fyD9k").then(()=>parcelRequire('5ZAju'));

});

parcelRegister("23tal", function(module, exports) {

let $17f27c4c3c46b4c4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $17f27c4c3c46b4c4$var$load("3eCyF").then(()=>parcelRequire('lOrr0'));

});

parcelRegister("dMbaR", function(module, exports) {

let $a0786d0471ff9ff3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a0786d0471ff9ff3$var$load("7i2hB").then(()=>parcelRequire('ios8g'));

});

parcelRegister("hfWR0", function(module, exports) {

let $c9017d908af29622$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c9017d908af29622$var$load("dY1xW").then(()=>parcelRequire('1t8Qa'));

});

parcelRegister("91jOk", function(module, exports) {

let $6913930f5d647cee$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6913930f5d647cee$var$load("4idmO").then(()=>parcelRequire('gtSH4'));

});

parcelRegister("f6wto", function(module, exports) {

let $aff09b097c468796$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aff09b097c468796$var$load("iQAb2").then(()=>parcelRequire('hXcsW'));

});

parcelRegister("4PWHz", function(module, exports) {

let $385975c9d07fed80$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $385975c9d07fed80$var$load("kdCub").then(()=>parcelRequire('7bJmJ'));

});

parcelRegister("kPr2b", function(module, exports) {
module.exports = JSON.parse('{"integrations-service.integrations-service-mcp-request-digest-event.message-template.email.footer.confluence-app":[{"type":0,"value":"Get Confluence notifications on your phone! Download the Confluence Cloud app for "},{"type":1,"value":"androidLink"},{"type":0,"value":" or "},{"type":1,"value":"iosLink"},{"type":0,"value":"."}],"integrations-service.integrations-service-mcp-request-digest-event.message-template.email.footer.feedback":[{"type":0,"value":"Give feedback"}],"integrations-service.integrations-service-mcp-request-digest-event.message-template.email.footer.jira-app":[{"type":0,"value":"Get Jira notifications on your phone! Download the Jira Cloud app for "},{"type":1,"value":"androidLink"},{"type":0,"value":" or "},{"type":1,"value":"iosLink"},{"type":0,"value":"."}],"integrations-service.integrations-service-mcp-request-digest-event.message-template.email.footer.privacy":[{"type":0,"value":"Privacy policy"}],"integrations-service.integrations-service-mcp-request-notification.message-template.in-app.admin-hub-notifications.heading.no-translate":[{"type":0,"value":"MCP server request for "},{"type":1,"value":"appName"}],"integrations-service.integrations-service-mcp-request-notification.message-template.notification-drawer.message.no-translate":[{"type":0,"value":"MCP server request for "},{"type":1,"value":"appName"}],"integrations-service.integrations-service-mcp-request-updated.message-template.email.footer.confluence-app":[{"type":0,"value":"Get Confluence notifications on your phone! Download the Confluence Cloud app for "},{"type":1,"value":"androidLink"},{"type":0,"value":" or "},{"type":1,"value":"iosLink"},{"type":0,"value":"."}],"integrations-service.integrations-service-mcp-request-updated.message-template.email.footer.feedback":[{"type":0,"value":"Give feedback"}],"integrations-service.integrations-service-mcp-request-updated.message-template.email.footer.jira-app":[{"type":0,"value":"Get Jira notifications on your phone! Download the Jira Cloud app for "},{"type":1,"value":"androidLink"},{"type":0,"value":" or "},{"type":1,"value":"iosLink"},{"type":0,"value":"."}],"integrations-service.integrations-service-mcp-request-updated.message-template.email.footer.privacy":[{"type":0,"value":"Privacy policy"}],"integrations-service.mcp-server-request-digest.message-template.email.footer.confluence-app":[{"type":0,"value":"Get Confluence notifications on your phone! Download the Confluence Cloud app for Android or iOS."}],"integrations-service.mcp-server-request-digest.message-template.email.footer.feedback":[{"type":0,"value":"Give feedback"}],"integrations-service.mcp-server-request-digest.message-template.email.footer.jira-app":[{"type":0,"value":"Get Jira notifications on your phone! Download the Jira Cloud app for Android or iOS."}],"integrations-service.mcp-server-request-digest.message-template.email.footer.privacy":[{"type":0,"value":"Privacy policy"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.after.blank-page":[{"type":0,"value":"A shared consent link may display a blank page after the Microsoft administrator selects "},{"children":[{"type":0,"value":"Accept"}],"type":8,"value":"b"},{"type":0,"value":". This is expected."}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.after.consequence":[{"type":0,"value":"If consent is not granted by "},{"type":1,"value":"deadline"},{"type":0,"value":" users may no longer be able to resolve SharePoint and OneDrive Smart Links or find SharePoint and OneDrive content through Rovo."}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.after.heading":[{"type":0,"value":"After granting consent"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.after.verify":[{"type":0,"value":"To verify completion, the Microsoft administrator can open "},{"children":[{"type":0,"value":"Enterprise applications"}],"type":8,"value":"b"},{"type":0,"value":" in the Microsoft Entra admin center, search for application ID "},{"children":[{"type":1,"value":"applicationId"}],"type":8,"value":"mono"},{"type":0,"value":", open the "},{"children":[{"type":0,"value":"Atlassian"}],"type":8,"value":"b"},{"type":0,"value":" application, and confirm under "},{"children":[{"type":0,"value":"Permissions"}],"type":8,"value":"b"},{"type":0,"value":" that admin consent has been granted."}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.application.heading":[{"type":0,"value":"Application to approve"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.application.id":[{"children":[{"type":0,"value":"Application ID:"}],"type":8,"value":"b"},{"type":0,"value":" "},{"children":[{"type":1,"value":"applicationId"}],"type":8,"value":"mono"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.application.name":[{"children":[{"type":0,"value":"Name:"}],"type":8,"value":"b"},{"type":0,"value":" Atlassian"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.application.publisher":[{"children":[{"type":0,"value":"Verified publisher:"}],"type":8,"value":"b"},{"type":0,"value":" Atlassian"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.cta":[{"type":0,"value":"Open the Microsoft admin consent flow"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.disruption.intro":[{"type":0,"value":"Complete this by "},{"type":1,"value":"deadline"},{"type":0,"value":" to prevent disruption to:"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.disruption.previews":[{"type":0,"value":"SharePoint and OneDrive Rich-link and inline-file previews"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.disruption.rovo":[{"type":0,"value":"SharePoint and OneDrive experiences in Rovo"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"recipientName"},{"type":0,"value":","}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.intro":[{"type":0,"value":"A Microsoft 365 administrator needs to approve Atlassian\'s new Microsoft publisher-verified application for your Atlassian site, "},{"children":[{"type":1,"value":"siteName"}],"type":8,"value":"b"},{"type":0,"value":" to ensure users can continue resolving SmartLinks and access SharePoint/OneDrive data if enabled."}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.preheader":[{"type":0,"value":"Ask your Microsoft 365 administrator to approve Atlassian\'s publisher-verified application."}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.roles.application-administrator":[{"type":0,"value":"Application Administrator"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.roles.atlassian-account":[{"type":0,"value":"The Microsoft administrator needs an Atlassian account to open the consent flow, but they do not need Atlassian admin permissions."}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.roles.cloud-application-administrator":[{"type":0,"value":"Cloud Application Administrator"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.roles.forward":[{"type":0,"value":"If you do not have one of these roles, forward this email or send the consent link to your Microsoft administrator."}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.roles.global-administrator":[{"type":0,"value":"Global Administrator"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.roles.heading":[{"type":0,"value":"Who should complete this?"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.roles.intro":[{"type":0,"value":"The person granting consent must have one of these Microsoft 365 roles:"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.subject":[{"type":0,"value":"Action required by "},{"type":1,"value":"deadline"},{"type":0,"value":": Keep SharePoint and OneDrive working in Atlassian"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.support-doc":[{"type":0,"value":"For complete instructions, see "},{"children":[{"type":0,"value":"Upgrade your SharePoint and OneDrive connection in Atlassian"}],"type":8,"value":"link"},{"type":0,"value":"."}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.why-receiving":[{"type":0,"value":"We\'re contacting you because users in your tenant have connected SharePoint/OneDrive to Atlassian to resolve SmartLinks or use the SharePoint and OneDrive connector."}],"integrations-service.sharepoint-smartlink-app-migration-test.message-template.in-app.screen-space-flags.copied":[{"type":0,"value":"Copied!"}],"integrations-service.sharepoint-smartlink-app-migration-test.message-template.in-app.screen-space-flags.copy-consent-link":[{"type":0,"value":"Copy consent link"}],"integrations-service.sharepoint-smartlink-app-migration-test.message-template.in-app.screen-space-flags.description":[{"type":0,"value":"Grant admin consent to the updated SharePoint app so people in your organization can continue using SharePoint and OneDrive links. If you\'re not a Microsoft Entra admin, copy the consent link and share it with your Microsoft admin. "},{"children":[{"type":0,"value":"Learn more"}],"type":8,"value":"link"}],"integrations-service.sharepoint-smartlink-app-migration-test.message-template.in-app.screen-space-flags.grant-consent":[{"type":0,"value":"Grant Consent"}],"integrations-service.sharepoint-smartlink-app-migration-test.message-template.in-app.screen-space-flags.remind-me-later":[{"type":0,"value":"Remind me later"}],"integrations-service.sharepoint-smartlink-app-migration-test.message-template.in-app.screen-space-flags.title":[{"type":0,"value":"Action required: Grant consent for SharePoint/OneDrive"}],"integrations-service.sharepoint-smartlink-app-migration-test.message-template.in-app.screen-space-flags.warning-icon-label":[{"type":0,"value":"Warning"}],"post-office.integrations-service.integrations-service-mcp-global-sync-notification.auth-required.body.no-translate":[{"type":0,"value":"The connection for *"},{"type":1,"value":"serverName"},{"type":0,"value":"* has expired or needs to be re-authorized."}],"post-office.integrations-service.integrations-service-mcp-global-sync-notification.auth-required.reauth-button.no-translate":[{"type":0,"value":"Re-authenticate"}],"post-office.integrations-service.integrations-service-mcp-global-sync-notification.auth-required.runbook-link.no-translate":[{"type":0,"value":"Runbook / more information"}],"post-office.integrations-service.integrations-service-mcp-global-sync-notification.auth-required.title.no-translate":[{"type":0,"value":":warning: Global MCP tool sync cannot run \u2014 authentication required"}],"post-office.integrations-service.integrations-service-mcp-global-sync-notification.subtitle.no-translate":[{"type":0,"value":"Remote: "},{"type":1,"value":"remoteToolCount"},{"type":0,"value":" tools \xb7 YAML baseline: "},{"type":1,"value":"baselineToolCount"},{"type":0,"value":" tools"}],"post-office.integrations-service.integrations-service-mcp-global-sync-notification.sync-failure.body.no-translate":[{"type":0,"value":"The global MCP tool sync for *"},{"type":1,"value":"serverName"},{"type":0,"value":"* failed. Check the runbook for troubleshooting and retry guidance."}],"post-office.integrations-service.integrations-service-mcp-global-sync-notification.sync-failure.runbook-link.no-translate":[{"type":0,"value":"Runbook / more information"}],"post-office.integrations-service.integrations-service-mcp-global-sync-notification.sync-failure.title.no-translate":[{"type":0,"value":":x: Global MCP tool sync failed \u2014 "},{"type":1,"value":"serverName"}],"post-office.integrations-service.integrations-service-mcp-global-sync-notification.title.no-translate":[{"type":0,"value":"Global MCP tool sync \u2014 "},{"type":1,"value":"serverName"}]}');

});

parcelRegister("4ZWNt", function(module, exports) {

let $3a3a77cb77c81d81$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3a3a77cb77c81d81$var$load("1x1hq").then(()=>parcelRequire('keR8t'));

});

parcelRegister("jmb7g", function(module, exports) {

let $e178b1d5bb3d0344$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e178b1d5bb3d0344$var$load("5SFfH").then(()=>parcelRequire('cip0f'));

});

parcelRegister("lV852", function(module, exports) {

let $ff55306adec21850$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ff55306adec21850$var$load("cpw3f").then(()=>parcelRequire('9ttis'));

});

parcelRegister("2N2rV", function(module, exports) {

let $20820eca1ddc2072$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $20820eca1ddc2072$var$load("fMz6k").then(()=>parcelRequire('ai0DV'));

});

parcelRegister("5q0jV", function(module, exports) {

let $3f1fa10dcd17f126$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3f1fa10dcd17f126$var$load("47UEn").then(()=>parcelRequire('3W7Xn'));

});

parcelRegister("kwUKZ", function(module, exports) {

let $ef22d2869d9ce795$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ef22d2869d9ce795$var$load("kQsQ2").then(()=>parcelRequire('k4DCG'));

});

parcelRegister("hhfhU", function(module, exports) {

let $c93fe208fbad2242$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c93fe208fbad2242$var$load("1BJMn").then(()=>parcelRequire('f9W2E'));

});

parcelRegister("iboJb", function(module, exports) {

let $d3cc6f7d11ebced6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d3cc6f7d11ebced6$var$load("fZTMJ").then(()=>parcelRequire('93PwR'));

});

parcelRegister("9Vsjx", function(module, exports) {

let $739f6681efb47a9c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $739f6681efb47a9c$var$load("adUHY").then(()=>parcelRequire('hUfD3'));

});

parcelRegister("27sh5", function(module, exports) {

let $18b22af10688cb16$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $18b22af10688cb16$var$load("41mwo").then(()=>parcelRequire('bn1Qz'));

});

parcelRegister("6oIvE", function(module, exports) {

let $4a87829f3340441b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a87829f3340441b$var$load("jAdw5").then(()=>parcelRequire('995N0'));

});

parcelRegister("1wxZ1", function(module, exports) {

let $11c323f3e431d206$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $11c323f3e431d206$var$load("aHh12").then(()=>parcelRequire('ino8y'));

});

parcelRegister("g7Mce", function(module, exports) {

let $bbd2af8d81b56101$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bbd2af8d81b56101$var$load("kabpX").then(()=>parcelRequire('hVxxy'));

});

parcelRegister("d6Xn9", function(module, exports) {

let $98b9e4020acd4448$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $98b9e4020acd4448$var$load("1mBGM").then(()=>parcelRequire('bOMYM'));

});

parcelRegister("f1A8G", function(module, exports) {

let $af02fb7aa98cb8b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $af02fb7aa98cb8b3$var$load("5qrQ7").then(()=>parcelRequire('a5Otz'));

});

parcelRegister("20HRd", function(module, exports) {

let $176d9a077a04ed0e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $176d9a077a04ed0e$var$load("aQY1v").then(()=>parcelRequire('f78wq'));

});

parcelRegister("gi6su", function(module, exports) {

let $bdc356483d4e1c70$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bdc356483d4e1c70$var$load("1hrrC").then(()=>parcelRequire('bWaGQ'));

});

parcelRegister("fkjiw", function(module, exports) {

let $b287b169febdf2c7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b287b169febdf2c7$var$load("lFqZL").then(()=>parcelRequire('10h68'));

});

parcelRegister("f86Qv", function(module, exports) {

let $b03ce9cfc8b1abc7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b03ce9cfc8b1abc7$var$load("lEI22").then(()=>parcelRequire('4yJhG'));

});

parcelRegister("gd6Pb", function(module, exports) {

let $030ba9ed4e3e67f4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $030ba9ed4e3e67f4$var$load("7vEL5").then(()=>parcelRequire('2bSUA'));

});

parcelRegister("fPpTt", function(module, exports) {

let $b85fb462ec84ef07$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b85fb462ec84ef07$var$load("2bEe7").then(()=>parcelRequire('37tBB'));

});

parcelRegister("jdobf", function(module, exports) {

let $dfd1fcf783677cb1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dfd1fcf783677cb1$var$load("ati4D").then(()=>parcelRequire('gqMS7'));

});

parcelRegister("iCCpE", function(module, exports) {

let $d8e9928c08494dfb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d8e9928c08494dfb$var$load("fZxb2").then(()=>parcelRequire('fm06P'));

});

parcelRegister("hHzOZ", function(module, exports) {

let $ce323d362d189870$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ce323d362d189870$var$load("iUZSO").then(()=>parcelRequire('5BgXL'));

});

parcelRegister("g9fh6", function(module, exports) {

let $bc1955e0a5262b0a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bc1955e0a5262b0a$var$load("cwhTA").then(()=>parcelRequire('flNN8'));

});

parcelRegister("5wENs", function(module, exports) {

let $405f9648784b1a8a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $405f9648784b1a8a$var$load("i6tRn").then(()=>parcelRequire('lLjPW'));

});

parcelRegister("4jY0a", function(module, exports) {

let $32577ade5ea8de6e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $32577ade5ea8de6e$var$load("1oQz9").then(()=>parcelRequire('9fbEv'));

});

parcelRegister("4ErJP", function(module, exports) {

let $36306a12993c3b57$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $36306a12993c3b57$var$load("fivRZ").then(()=>parcelRequire('4Nduc'));

});

parcelRegister("dA83e", function(module, exports) {

let $9e34e1f4fdaafadf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9e34e1f4fdaafadf$var$load("25IqW").then(()=>parcelRequire('4IsQh'));

});

parcelRegister("hXgoQ", function(module, exports) {

let $d124aafad7b2605a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d124aafad7b2605a$var$load("CWJ4s").then(()=>parcelRequire('bxak3'));

});

parcelRegister("bRXbf", function(module, exports) {

let $8a428cec17c7bac0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8a428cec17c7bac0$var$load("4s0RU").then(()=>parcelRequire('lxnoM'));

});

parcelRegister("dJRZ3", function(module, exports) {

let $a0095a5d41ddb35d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a0095a5d41ddb35d$var$load("6HRvx").then(()=>parcelRequire('3rEfR'));

});

parcelRegister("1fZEx", function(module, exports) {

let $0ea704204922f810$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0ea704204922f810$var$load("3RfWO").then(()=>parcelRequire('1xXfP'));

});

parcelRegister("ahjHi", function(module, exports) {

let $77bac5606969eb52$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $77bac5606969eb52$var$load("ivmch").then(()=>parcelRequire('b45mf'));

});

parcelRegister("ce9f2", function(module, exports) {
module.exports = JSON.parse('{"jsm-nebula-kb-suggested-topic.multiple.button.primary":[{"type":0,"value":"View suggestions"}],"jsm-nebula-kb-suggested-topic.notification.subtitle":[{"type":0,"value":"These suggestions are for "},{"type":1,"value":"projectName"}],"jsm-nebula-kb-suggested-topic.notification.title":[{"offset":0,"options":{"one":{"value":[{"type":0,"value":"You have "},{"type":7},{"type":0,"value":" new article suggestion for your knowledge base"}]},"other":{"value":[{"type":0,"value":"You have "},{"type":7},{"type":0,"value":" new article suggestions for your knowledge base"}]}},"pluralType":"cardinal","type":6,"value":"numSuggestions"}],"jsm-nebula-kb-suggested-topic.single.button.primary":[{"type":0,"value":"View suggestion"}],"jsm-nebula-kb-suggested-topic.singletopic.notification.subtitle":[{"type":0,"value":"This suggestion is for "},{"type":1,"value":"projectName"}],"jsm-nebula-kb-suggested-topic.singletopic.notification.title":[{"type":0,"value":"You have a new article suggestion for your knowledge base"}],"jsm-nebula.jsm-kb-activation-reminder.add-knowledge-from-third-party-apps":[{"type":0,"value":"Add knowledge from third-party apps"}],"jsm-nebula.jsm-kb-activation-reminder.boost-agent-productivity":[{"type":0,"value":"Boost agent productivity"}],"jsm-nebula.jsm-kb-activation-reminder.create-or-link-articles":[{"type":0,"value":"Create or link articles."}],"jsm-nebula.jsm-kb-activation-reminder.empower-customers-with-instant-access":[{"type":0,"value":"Empower customers with instant access to helpful articles"}],"jsm-nebula.jsm-kb-activation-reminder.get-started-button-label":[{"type":0,"value":"Get started"}],"jsm-nebula.jsm-kb-activation-reminder.getting-started-is-easy":[{"type":0,"value":"Getting started is easy"}],"jsm-nebula.jsm-kb-activation-reminder.greeting-message":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jsm-nebula.jsm-kb-activation-reminder.header.text":[{"type":0,"value":"Say goodbye to knowledge silos"}],"jsm-nebula.jsm-kb-activation-reminder.how-to-set-up-your-knowledge-base":[{"type":0,"value":"How to set up your knowledge base"}],"jsm-nebula.jsm-kb-activation-reminder.illustration.alt":[{"type":0,"value":"KnowledgeBase Illustration"}],"jsm-nebula.jsm-kb-activation-reminder.improve-ai-powered-suggestions":[{"type":0,"value":"Improve AI-powered suggestions"}],"jsm-nebula.jsm-kb-activation-reminder.improve-knowledge-base-health-by-closing-knowledge-gaps":[{"type":0,"value":"Improve knowledge base health by closing knowledge gaps."}],"jsm-nebula.jsm-kb-activation-reminder.knowledge-base-benefit":[{"type":0,"value":"By setting up a knowledge base, you can provide instant answers to your customers, reduce repetitive requests, and help your team resolve requests faster."}],"jsm-nebula.jsm-kb-activation-reminder.knowledge-base-help":[{"type":0,"value":"Adding knowledge to your Jira Service Management project helps:"}],"jsm-nebula.jsm-kb-activation-reminder.message-template.email.subject":[{"type":0,"value":"[Jira Service Management] Set up your knowledge base today"}],"jsm-nebula.jsm-kb-activation-reminder.need-help-explore-these-resources":[{"type":0,"value":"Need help? Explore these resources"}],"jsm-nebula.jsm-kb-activation-reminder.privacy-policy":[{"type":0,"value":"Privacy policy"}],"jsm-nebula.jsm-kb-activation-reminder.project-notice":[{"type":0,"value":"We noticed your Jira Service Management project, "},{"children":[{"type":1,"value":"project"}],"type":8,"value":"b"},{"type":0,"value":", doesn\'t have a knowledge base yet."}],"jsm-nebula.jsm-kb-activation-reminder.sent-to-you-by-atlassian-jira-service-management":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management  \u2022"}],"jsm-nebula.jsm-kb-activation-reminder.share-them-with-your-team-and-customers":[{"type":0,"value":"Share them with your team and customers."}],"jsm-nebula.jsm-kb-activation-reminder.start-building-your-knowledge-base":[{"type":0,"value":"Start building your knowledge base"}],"jsm-nebula.jsm-kb-activation-reminder.stay-notified-and-comment-on-the-go-with-jira-mobile-app":[{"type":0,"value":"Stay notified and comment on the go with Jira Mobile App"}],"jsm-nebula.jsm-kb-activation-reminder.subheading":[{"type":0,"value":"Set up knowledge base to keep requests and knowledge within Jira Service Management."}],"jsm-nebula.jsm-kb-activation-reminder.surface-instant-answers-deflect-requests-and-keep-everything-in-one-place":[{"type":0,"value":"Surface instant answers, deflect requests, and keep everything in one place"}],"jsm-nebula.jsm-kb-activation-reminder.tips-for-writing-effective-knowledge-articles":[{"type":0,"value":"Tips for writing effective knowledge articles"}],"jsm-nebula.jsm-kb-activation-reminder.to-build-your-knowledge-base":[{"type":0,"value":"To build your knowledge base, all you need to do is:"}],"jsm-nebula.jsm-kb-activation-reminder.to-customize-email-or-unsubscribe":[{"type":0,"value":"To customize the email or unsubscribe, "}],"jsm-nebula.jsm-kb-activation-reminder.update-your-notification-settings":[{"type":0,"value":"update your notification settings."}],"jsm-nebula.jsm-kb-activation-reminder.why-set-up-knowledge-base":[{"type":0,"value":"Why set up a knowledge base?"}],"jsm-nebula.solcom-create-space-spotlight.action":[{"type":0,"value":"Get started"}],"jsm-nebula.solcom-create-space-spotlight.body":[{"type":0,"value":"Tell Rovo what you need in plain language and it\'ll build the space for you."}],"jsm-nebula.solcom-create-space-spotlight.headline":[{"type":0,"value":"Support teams faster with Rovo"}]}');

});

parcelRegister("h4XLq", function(module, exports) {

let $c6f12b486c75c484$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c6f12b486c75c484$var$load("2hoPf").then(()=>parcelRequire('ksGGA'));

});

parcelRegister("aSIuu", function(module, exports) {

let $7ec17572ab57c42e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7ec17572ab57c42e$var$load("h2DZg").then(()=>parcelRequire('be3Fc'));

});

parcelRegister("23l4O", function(module, exports) {

let $17ec35f0fb79820f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $17ec35f0fb79820f$var$load("i8MqZ").then(()=>parcelRequire('4iWFW'));

});

parcelRegister("cChEl", function(module, exports) {

let $92f6b97eafe79655$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $92f6b97eafe79655$var$load("lE85C").then(()=>parcelRequire('ngbTB'));

});

parcelRegister("f3rj4", function(module, exports) {

let $af5c51545a31e1b5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $af5c51545a31e1b5$var$load("2Vb2u").then(()=>parcelRequire('8Tx8H'));

});

parcelRegister("gcN2A", function(module, exports) {

let $bcc3cec750b14c9a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bcc3cec750b14c9a$var$load("lb22P").then(()=>parcelRequire('lsm9k'));

});

parcelRegister("bzeFj", function(module, exports) {

let $86be56d2144abf92$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $86be56d2144abf92$var$load("8SVs3").then(()=>parcelRequire('5DOQP'));

});

parcelRegister("iaQTW", function(module, exports) {

let $d3b2324016b7b137$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d3b2324016b7b137$var$load("kSW8T").then(()=>parcelRequire('4I2Tm'));

});

parcelRegister("3VbYR", function(module, exports) {

let $2daffd0df4e42727$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2daffd0df4e42727$var$load("8R6v8").then(()=>parcelRequire('efSSv'));

});

parcelRegister("66euP", function(module, exports) {

let $470e8c48e35e5658$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $470e8c48e35e5658$var$load("lRlez").then(()=>parcelRequire('9KjV4'));

});

parcelRegister("dWdh5", function(module, exports) {

let $a25afd32beb7a311$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a25afd32beb7a311$var$load("7uxAd").then(()=>parcelRequire('5wLXc'));

});

parcelRegister("6L5mq", function(module, exports) {

let $4ebb4a5d8d00bf8b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ebb4a5d8d00bf8b$var$load("6ZAZK").then(()=>parcelRequire('iUNPK'));

});

parcelRegister("8d9mp", function(module, exports) {

let $5fa6cc65f32aa3fa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5fa6cc65f32aa3fa$var$load("iUoKv").then(()=>parcelRequire('lV45y'));

});

parcelRegister("6oh7C", function(module, exports) {

let $4a72440701c3a072$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a72440701c3a072$var$load("gRQ4A").then(()=>parcelRequire('1Pq7B'));

});

parcelRegister("5Ih8N", function(module, exports) {

let $428e5ba2901e35ca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $428e5ba2901e35ca$var$load("7W3A8").then(()=>parcelRequire('1cjlo'));

});

parcelRegister("aiIM4", function(module, exports) {

let $77fe510e579e24a6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $77fe510e579e24a6$var$load("5uxEx").then(()=>parcelRequire('9hNFj'));

});

parcelRegister("ezVJc", function(module, exports) {

let $a9d11d2c24419247$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a9d11d2c24419247$var$load("br3uv").then(()=>parcelRequire('8Qbrh'));

});

parcelRegister("d5Py7", function(module, exports) {

let $9883ba9a534c4fe3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9883ba9a534c4fe3$var$load("iPZA4").then(()=>parcelRequire('4mnrm'));

});

parcelRegister("l460a", function(module, exports) {

let $f55ea07e33a23219$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f55ea07e33a23219$var$load("8NPMz").then(()=>parcelRequire('8ZrYM'));

});

parcelRegister("ktgFI", function(module, exports) {

let $ee7372c6fed87f41$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ee7372c6fed87f41$var$load("HyqnQ").then(()=>parcelRequire('4Y1Om'));

});

parcelRegister("5RWbp", function(module, exports) {

let $445f08e90572cd9a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $445f08e90572cd9a$var$load("kV7xL").then(()=>parcelRequire('9gsmM'));

});

parcelRegister("akrpS", function(module, exports) {

let $785109f15a47bf0b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $785109f15a47bf0b$var$load("hvokT").then(()=>parcelRequire('lzKpS'));

});

parcelRegister("9su3t", function(module, exports) {

let $6e2e0ae65eae4002$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6e2e0ae65eae4002$var$load("j4XhX").then(()=>parcelRequire('aSk5o'));

});

parcelRegister("krb0o", function(module, exports) {

let $ee0eddb43867fc9e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ee0eddb43867fc9e$var$load("iW785").then(()=>parcelRequire('cwNj3'));

});

parcelRegister("ax70l", function(module, exports) {

let $7ab26b6e7b307337$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7ab26b6e7b307337$var$load("c2qY5").then(()=>parcelRequire('7dIob'));

});

parcelRegister("Mb2FM", function(module, exports) {

let $090d0c8afe100800$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $090d0c8afe100800$var$load("lynYB").then(()=>parcelRequire('aRezM'));

});

parcelRegister("5hvFc", function(module, exports) {

let $3d871a00b9d04d9f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3d871a00b9d04d9f$var$load("ah8oK").then(()=>parcelRequire('k2qXo'));

});

parcelRegister("i9uou", function(module, exports) {

let $d370a4e3974b021b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d370a4e3974b021b$var$load("bFPau").then(()=>parcelRequire('dWKDy'));

});

parcelRegister("bqXXX", function(module, exports) {

let $0225f21ea6bc4206$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0225f21ea6bc4206$var$load("canhk").then(()=>parcelRequire('bO4BZ'));

});

parcelRegister("bwbqM", function(module, exports) {

let $862b8cd05c131e76$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $862b8cd05c131e76$var$load("kSVFa").then(()=>parcelRequire('dMM03'));

});

parcelRegister("d4pv2", function(module, exports) {

let $983f6dc554f1233d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $983f6dc554f1233d$var$load("1TBSO").then(()=>parcelRequire('gGBhu'));

});

parcelRegister("4im8D", function(module, exports) {

let $320a040d2b0da095$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $320a040d2b0da095$var$load("dNopY").then(()=>parcelRequire('gNGKu'));

});

parcelRegister("8RCWw", function(module, exports) {

let $67417b3a6bd801d5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $67417b3a6bd801d5$var$load("kXnHJ").then(()=>parcelRequire('6YGvg'));

});

parcelRegister("c6FoP", function(module, exports) {

let $8d0628a1c685ee2a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8d0628a1c685ee2a$var$load("eveqf").then(()=>parcelRequire('6dqVR'));

});

parcelRegister("2N9a7", function(module, exports) {
module.exports = JSON.parse('{"post-office.stakeholder-comms-common.email-header.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"stakeholder-comms-confirm-add-subscriber-email.email-events-list.no-translate":[{"type":0,"value":"You will now receive emails whenever:"}],"stakeholder-comms-confirm-add-subscriber-email.endpoint-info.no-translate":[{"type":0,"value":"View Status page"}],"stakeholder-comms-confirm-add-subscriber-email.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"stakeholder-comms-confirm-add-subscriber-email.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"stakeholder-comms-confirm-add-subscriber-email.list-item.incident-resolved.no-translate":[{"type":0,"value":"An incident is resolved"}],"stakeholder-comms-confirm-add-subscriber-email.list-item.service-outage.no-translate":[{"type":0,"value":"A service outage or degradation occurs"}],"stakeholder-comms-confirm-add-subscriber-email.message-template.email.subject-generic.no-translate":[{"type":0,"value":"Added as subscriber to status page updates"}],"stakeholder-comms-confirm-add-subscriber-email.message-template.email.subject-with-page-name.no-translate":[{"type":0,"value":"Added as subscriber to "},{"type":1,"value":"pageNameText"},{"type":0,"value":" status updates"}],"stakeholder-comms-confirm-add-subscriber-email.title-message.email.title.no-translate":[{"type":0,"value":"You have been added as a subscriber"}],"stakeholder-comms-confirm-add-subscriber-email.webhook-added.no-translate":[{"type":0,"value":"The admin has successfully added you as a subscriber to "},{"type":1,"value":"pageNameText"},{"type":0,"value":" status page."}],"stakeholder-comms-webhook-notification-confirmation-email.endpoint-info-hyperlink.no-translate":[{"type":0,"value":"Read more about status pages"}],"stakeholder-comms-webhook-notification-confirmation-email.endpoint-info.no-translate":[{"type":0,"value":"The endpoint "},{"type":1,"value":"webhookEndpointUrl"},{"type":0,"value":" is now set to receive updates. "}],"stakeholder-comms-webhook-notification-confirmation-email.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"stakeholder-comms-webhook-notification-confirmation-email.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"stakeholder-comms-webhook-notification-confirmation-email.greeting.no-translate":[{"type":0,"value":"Hi there,"}],"stakeholder-comms-webhook-notification-confirmation-email.title-message.email.title.no-translate":[{"type":0,"value":"Webhook subscription activated"}],"stakeholder-comms-webhook-notification-confirmation-email.webhook-added.no-translate":[{"type":0,"value":"We\'ve added your webhook subscription for "},{"type":1,"value":"pageNameText"},{"type":0,"value":" status page."}],"stakeholder-comms-webhook-notification-delivery-failure.deactivation-reason.no-translate":[{"type":0,"value":" has been deactivated because we couldn\'t deliver notifications to it. This endpoint was previously reachable, but it\'s now returning errors or is unreachable."}],"stakeholder-comms-webhook-notification-delivery-failure.endpoint-deactivated.no-translate":[{"type":0,"value":"Your endpoint "},{"type":1,"value":"webhookEndpointUrl"}],"stakeholder-comms-webhook-notification-delivery-failure.endpoint-info-hyperlink.no-translate":[{"type":0,"value":"Read more about status pages"}],"stakeholder-comms-webhook-notification-delivery-failure.footer-message-url.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"stakeholder-comms-webhook-notification-delivery-failure.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"stakeholder-comms-webhook-notification-delivery-failure.resubscribe-message.no-translate":[{"type":0,"value":"To continue receiving updates, resubscribe to your endpoint."}],"stakeholder-comms-webhook-notification-delivery-failure.title-message.email.title.no-translate":[{"type":0,"value":"Webhook subscription deactivated"}],"stakeholder-comms-webhook-validation-failure.endpoint-info-hyperlink.no-translate":[{"type":0,"value":"Read more about status pages"}],"stakeholder-comms-webhook-validation-failure.endpoint-unreachable.no-translate":[{"type":0,"value":"The endpoint "},{"type":1,"value":"webhookEndpointUrl"},{"type":0,"value":" could not be reached or did not respond."}],"stakeholder-comms-webhook-validation-failure.footer-message-url.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"stakeholder-comms-webhook-validation-failure.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"stakeholder-comms-webhook-validation-failure.title-message.email.title.no-translate":[{"type":0,"value":"Endpoint validation failed"}],"stakeholder-comms-webhook-validation-failure.webhook-validation-error.no-translate":[{"type":0,"value":"We couldn\'t notify your webhook for "},{"type":1,"value":"pageNameText"},{"type":0,"value":" status page updates."}],"status-page.create-component-details.spotlight.got-it":[{"type":0,"value":"Ok, got it"}],"status-page.create-component.spotlight.action":[{"type":0,"value":"Dismiss"}],"status-page.create-component.spotlight.primary-action":[{"type":0,"value":"Next"}],"status-page.create-component.spotlight.step1.body":[{"type":0,"value":"Customize each component and link it to a service"}],"status-page.create-component.spotlight.step1.heading":[{"type":0,"value":"Add component"}],"status-page.create-component.spotlight.step2.body":[{"type":0,"value":"Organize your components by adding them to specific groups."}],"status-page.create-component.spotlight.step2.heading":[{"type":0,"value":"Group components"}],"status-page.create-component.spotlight.step3.body":[{"type":0,"value":"Add multiple components and groups for better structure and clarity."}],"status-page.create-component.spotlight.step3.heading":[{"type":0,"value":"Manage and organize"}],"status-page.details.actions.spotlight.body":[{"type":0,"value":"Easily manage your status page, edit details and post updates to keep your audience informed."}],"status-page.details.actions.spotlight.got-it":[{"type":0,"value":"Ok, got it"}],"status-page.details.actions.spotlight.heading":[{"type":0,"value":"Update and manage"}],"status-page.details.tabs.spotlight.action":[{"type":0,"value":"Dismiss"}],"status-page.details.tabs.spotlight.body":[{"type":0,"value":"Review your status page, target audience, and post real-time incident updates, all from a single place."}],"status-page.details.tabs.spotlight.body.line1":[{"type":0,"value":"Review your status page, target"}],"status-page.details.tabs.spotlight.body.line2":[{"type":0,"value":"audience, and post real-time incident"}],"status-page.details.tabs.spotlight.body.line3":[{"type":0,"value":"updates, all from a single place."}],"status-page.details.tabs.spotlight.heading":[{"type":0,"value":"All at a glance"}],"status-page.details.tabs.spotlight.primary-action":[{"type":0,"value":"Next"}],"statuspage.actions-spotlight.progress":[{"type":1,"value":"currentStep"},{"type":0,"value":"/"},{"type":1,"value":"totalSteps"}],"statuspage.appearance-spotlight.action":[{"type":0,"value":"Ok, got it"}],"statuspage.appearance-spotlight.body":[{"type":0,"value":"Customize with additional flexibility and advanced styling."}],"statuspage.appearance-spotlight.heading":[{"type":0,"value":"Switch to CSS view"}],"statuspage.confirm-incident-notifications.button.verify-email.no-translate":[{"type":0,"value":"Confirm subscription"}],"statuspage.confirm-incident-notifications.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"statuspage.confirm-incident-notifications.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"statuspage.confirm-incident-notifications.list-item.incident-resolved.no-translate":[{"type":0,"value":"An incident is resolved"}],"statuspage.confirm-incident-notifications.list-item.scheduled-maintenance.no-translate":[{"type":0,"value":"Scheduled maintenance is announced"}],"statuspage.confirm-incident-notifications.list-item.service-outage.no-translate":[{"type":0,"value":"A service outage or degradation occurs"}],"statuspage.confirm-incident-notifications.message-template.email.subject-generic.no-translate":[{"type":0,"value":"Confirm your email to subscribe to status page updates"}],"statuspage.confirm-incident-notifications.message-template.email.subject-with-page-name.no-translate":[{"type":0,"value":"Confirm your email to subscribe to "},{"type":1,"value":"pageName"},{"type":0,"value":" status updates"}],"statuspage.confirm-incident-notifications.test-message.email.body-hello.no-translate":[{"type":0,"value":"Hi there,"},{"type":1,"value":"br"},{"type":1,"value":"br"},{"type":0,"value":"Please confirm your email address to start receiving incident and maintenance notifications."},{"type":1,"value":"br"},{"type":1,"value":"br"},{"type":0,"value":"Once confirmed, you\u2019ll receive emails whenever:"}],"statuspage.confirm-incident-notifications.title-message.email.title.no-translate":[{"type":0,"value":"Confirm your subscription"}],"statuspage.create-component-spotlight.progress":[{"type":1,"value":"currentStep"},{"type":0,"value":"/"},{"type":1,"value":"totalSteps"}],"statuspage.edit-spotlight.action":[{"type":0,"value":"Done"}],"statuspage.edit-spotlight.body":[{"type":0,"value":"Customize your status page to match your brand. Add the components you need and personalize the look and feel with brand new colours and themes."}],"statuspage.edit-spotlight.heading":[{"type":0,"value":"Status page created! Set it up in a few simple steps."}],"statuspage.navigation-spotlight.action":[{"type":0,"value":"About status pages"}],"statuspage.navigation-spotlight.body":[{"type":0,"value":"Post real-time updates and customize your status pages directly from here, without switching platforms."}],"statuspage.navigation-spotlight.heading":[{"type":0,"value":"Create and manage status pages"}],"statuspage.stakeholder-comms-archive-email.title.no-translate":[{"type":0,"value":"Your status page is archived and will be deleted in 60 days."}],"statuspage.stakeholder-comms-archive-page-email.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"statuspage.stakeholder-comms-archive-page-email.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"statuspage.stakeholder-comms-archive-page-email.incident-details-message.email.title.no-translate":[{"type":0,"value":"Details of the status page"}],"statuspage.stakeholder-comms-archive-page-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Atlassian Logo"}],"statuspage.stakeholder-comms-archive-page-email.message-template.email.subject.no-translate":[{"type":0,"value":"Status page archived"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.hello-message.no-translate":[{"type":0,"value":"Hi there,"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-description-title.no-translate":[{"type":0,"value":"Archived on"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-details.no-translate":[{"type":1,"value":"archivedOn"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-status-title.no-translate":[{"type":0,"value":"URL"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-status.no-translate":[{"type":1,"value":"pageUrl"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-time-title.no-translate":[{"type":0,"value":"Permanent deletion date"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-time.no-translate":[{"type":1,"value":"deletionDate"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.introduction-message.no-translate":[{"type":0,"value":"We\'ve received your request to archive the status page. This status page will be automatically deleted in 60 days"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.post-info-message.no-translate":[{"type":0,"value":"If you wish to restore it, you can do so within the next 60 days"}],"statuspage.stakeholder-comms-confirm-webhook-subscription-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"statuspage.stakeholder-comms-confirm-webhook-subscription-email.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"statuspage.stakeholder-comms-confirm-webhook-subscription-email.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"statuspage.stakeholder-comms-confirm-webhook-subscription-email.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"statuspage.stakeholder-comms-confirm-webhook-subscription-email.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"statuspage.stakeholder-comms-confirm-webhook-subscription-email.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"statuspage.stakeholder-comms-confirm-webhook-subscription-email.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"statuspage.stakeholder-comms-page-restored-email.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"statuspage.stakeholder-comms-page-restored-email.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"statuspage.stakeholder-comms-page-restored-email.incident-details-message.email.title.no-translate":[{"type":0,"value":"Details of the status page"}],"statuspage.stakeholder-comms-page-restored-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Atlassian Logo"}],"statuspage.stakeholder-comms-page-restored-email.message-template.email.subject.no-translate":[{"type":0,"value":"Status page restored"}],"statuspage.stakeholder-comms-page-restored-email.test-message.email.hello-message.no-translate":[{"type":0,"value":"Hi there,"}],"statuspage.stakeholder-comms-page-restored-email.test-message.email.incident-info-description-title.no-translate":[{"type":0,"value":"Archived on"}],"statuspage.stakeholder-comms-page-restored-email.test-message.email.incident-info-details.no-translate":[{"type":1,"value":"archivedOn"}],"statuspage.stakeholder-comms-page-restored-email.test-message.email.incident-info-status-title.no-translate":[{"type":0,"value":"URL"}],"statuspage.stakeholder-comms-page-restored-email.test-message.email.incident-info-status.no-translate":[{"type":1,"value":"pageUrl"}],"statuspage.stakeholder-comms-page-restored-email.test-message.email.introduction-message.no-translate":[{"type":0,"value":"We\'ve received your request to restore the status page. You can now edit the page and post any updates as needed."}],"statuspage.stakeholder-comms-page-restored-email.test-message.email.post-info-message.no-translate":[{"type":0,"value":"You can publish the page when you\'re ready to make it accessible to all subscribers."}],"statuspage.stakeholder-comms-page-restored-email.title.no-translate":[{"type":0,"value":"Your status page has been restored"}],"statuspage.stakeholder-comms-sender-test.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"statuspage.stakeholder-comms-sender-test.footer-message.email.body":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"statuspage.stakeholder-comms-sender-test.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"statuspage.stakeholder-comms-sender-test.test-message.email.body.no-translate":[{"type":0,"value":"Thanks for subscribing to pageName status updates. You\'re almost done - we just need to confirm your subscription."}],"statuspage.stakeholder-comms-sender-test.test-message.email.link-body.no-translate":[{"type":0,"value":"In order to activate your subscription, please click the following link:"}],"statuspage.stakeholder-comms-sender-test.title-message.email.title":[{"type":0,"value":"Confirm your subscription."}],"statuspage.stakeholder-comms-subscriber-incident-status-email.affected-components.and-more.no-translate":[{"type":0,"value":" and "},{"type":1,"value":"count"},{"type":0,"value":" more"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.button.view-status-page.no-translate":[{"type":0,"value":"View Status page"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"statuspage.stakeholder-comms-subscriber-incident-status-email.footer-unsubscribe-url.email.email.no-translate":[{"type":0,"value":"Unsubscribe"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.incident-details-message.email.title.no-translate":[{"type":0,"value":"Incident details"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.message-template.email.subject-generic.no-translate":[{"type":0,"value":"Status page Incident: "},{"type":1,"value":"incidentName"},{"type":0,"value":" ("},{"type":1,"value":"incidentStatus"},{"type":0,"value":")"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.message-template.email.subject-with-page-name.no-translate":[{"type":1,"value":"pageName"},{"type":0,"value":" Incident: "},{"type":1,"value":"incidentName"},{"type":0,"value":" ("},{"type":1,"value":"incidentStatus"},{"type":0,"value":")"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.hello-message.no-translate":[{"type":0,"value":"Hi there,"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-affected-components-title.no-translate":[{"type":0,"value":"Affected components"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-affected-components.no-translate":[{"type":1,"value":"affectedComponentsString"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-description-title.no-translate":[{"type":0,"value":"Details"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-details.no-translate":[{"type":1,"value":"incidentDescription"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-status-title.no-translate":[{"type":0,"value":"Status"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-status.no-translate":[{"type":1,"value":"incidentStatus"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-time-title.no-translate":[{"type":0,"value":"Time posted"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-time.no-translate":[{"type":1,"value":"timePosted"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.introduction-message.no-translate":[{"type":0,"value":"We\'re investigating issues reported on the "},{"type":1,"value":"pageNameText"},{"type":0,"value":"status page. Here are the details:"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.post-info-message.no-translate":[{"type":0,"value":"You received this email because you subscribed to incident updates for "},{"type":1,"value":"pageNameText"},{"type":0,"value":"."}],"statuspage.stakeholder-comms-subscriber-incident-status-email.title-message.email.title.no-translate":[{"type":1,"value":"incidentName"},{"type":0,"value":" ("},{"type":1,"value":"incidentStatus"},{"type":0,"value":")"}],"statuspage.stakeholder-comms-user-added-verify-email.button.verify-email":[{"type":0,"value":"Verify your email"}],"statuspage.stakeholder-comms-user-added-verify-email.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"statuspage.stakeholder-comms-user-added-verify-email.footer-message.email.body":[{"type":0,"value":"This email was sent by Atlassian Jira Service Management \u2022 "}],"statuspage.stakeholder-comms-user-added-verify-email.message-template.email.subject.no-translate":[{"type":0,"value":"[Action required] Verify your email to join "},{"type":1,"value":"siteName"},{"type":0,"value":"\'s site as a stakeholder on "},{"type":1,"value":"env"}],"statuspage.stakeholder-comms-user-added-verify-email.table-message1.email.body":[{"type":0,"value":"Know about disruptions that affect operations"}],"statuspage.stakeholder-comms-user-added-verify-email.table-message2.email.body":[{"type":0,"value":"Make better decisions as you\u2019re always informed"}],"statuspage.stakeholder-comms-user-added-verify-email.table-message3.email.body":[{"type":0,"value":"Get notified about the health and status of key services"}],"statuspage.stakeholder-comms-user-added-verify-email.table-title-message.email.title":[{"type":0,"value":"Stay in the loop always"}],"statuspage.stakeholder-comms-user-added-verify-email.test-message.email.body.hello.no-translate":[{"type":0,"value":"G\'day "},{"type":1,"value":"name"},{"type":0,"value":","}],"statuspage.stakeholder-comms-user-added-verify-email.test-message.email.body1.no-translate":[{"type":1,"value":"adminName"},{"type":0,"value":" has invited you to join their Jira Service Management site, "},{"type":1,"value":"siteName"},{"type":0,"value":", as a stakeholder."}],"statuspage.stakeholder-comms-user-added-verify-email.test-message.email.body2.no-translate":[{"type":0,"value":"Once you verify your email, you\'ll start receiving important notifications about incidents and changes directly to your inbox."}],"statuspage.stakeholder-comms-user-added-verify-email.test-message.email.body3.no-translate":[{"type":0,"value":"To receive updates on incidents communications, verify your email now!"}],"statuspage.stakeholder-comms-user-added-verify-email.title-message.email.title":[{"type":0,"value":"You\u2019ve been invited to join "},{"type":1,"value":"siteName"},{"type":0,"value":" as a stakeholder"}],"statuspage.stakeholder-comms-webhook-notification-confirmation-email.message-template.email.subject.no-translate":[{"type":0,"value":"Your webhook subscription is active"}],"statuspage.stakeholder-comms-webhook-notification-delivery-failure.message-template.email.subject.no-translate":[{"type":0,"value":"Your webhook subscription is deactivated"}],"statuspage.stakeholder-comms-webhook-validation-failure.message-template.email.subject.no-translate":[{"type":0,"value":"Your webhook subscription could not be activated"}],"statuspage.statuspage-navigation-spotlight-v2.description.no-translate":[{"type":0,"value":"Statuspage navigation spotlight v2 test message."}],"statuspage.statuspage-navigation-spotlight-v2.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"statuspage.statuspage-navigation-spotlight.description.no-translate":[{"type":0,"value":"Statuspage navigation spotlight test message."}],"statuspage.statuspage-navigation-spotlight.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}]}');

});

parcelRegister("c2txx", function(module, exports) {

let $8c3c95f20262782b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8c3c95f20262782b$var$load("dkOn3").then(()=>parcelRequire('1Lsqe'));

});

parcelRegister("5bfTF", function(module, exports) {

let $3c5a4f99f839bb84$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3c5a4f99f839bb84$var$load("9rrQ3").then(()=>parcelRequire('5VTyv'));

});

parcelRegister("yv2PF", function(module, exports) {

let $067b41eaef55dd30$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $067b41eaef55dd30$var$load("lMHeM").then(()=>parcelRequire('2wmA2'));

});

parcelRegister("5ytEt", function(module, exports) {

let $40b720f17e9295c1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $40b720f17e9295c1$var$load("dyg7C").then(()=>parcelRequire('5gVqq'));

});

parcelRegister("84xPc", function(module, exports) {

let $5e08ef53c2da31b6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5e08ef53c2da31b6$var$load("exJfV").then(()=>parcelRequire('aCwYR'));

});

parcelRegister("g50do", function(module, exports) {

let $bb4d47a6287a3920$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bb4d47a6287a3920$var$load("gsZNK").then(()=>parcelRequire('2XELA'));

});

parcelRegister("ldTqI", function(module, exports) {

let $f735cf1d9643f8c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f735cf1d9643f8c9$var$load("6PSzu").then(()=>parcelRequire('hqeI3'));

});

parcelRegister("1P4Bo", function(module, exports) {

let $153e1fbb0e76155b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $153e1fbb0e76155b$var$load("9xa6R").then(()=>parcelRequire('lP7yJ'));

});

parcelRegister("kLuUQ", function(module, exports) {

let $f1e02dadbf355fe3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f1e02dadbf355fe3$var$load("1YQWl").then(()=>parcelRequire('8PJr6'));

});

parcelRegister("17Z99", function(module, exports) {

let $0d25e0548c28b24f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0d25e0548c28b24f$var$load("2K7kE").then(()=>parcelRequire('9Nkia'));

});

parcelRegister("7WGGY", function(module, exports) {

let $5c8f10eca2afd5a2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5c8f10eca2afd5a2$var$load("7l3Pb").then(()=>parcelRequire('lWLcR'));

});

parcelRegister("jeifm", function(module, exports) {

let $dffd7a892c99e561$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dffd7a892c99e561$var$load("94J3Y").then(()=>parcelRequire('jhQrO'));

});

parcelRegister("dM9Ko", function(module, exports) {

let $a07751ad769c56df$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a07751ad769c56df$var$load("dp569").then(()=>parcelRequire('fxGXs'));

});

parcelRegister("9dS55", function(module, exports) {

let $6b6f47556d160e80$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b6f47556d160e80$var$load("ciwQa").then(()=>parcelRequire('cDmyS'));

});

parcelRegister("aruux", function(module, exports) {

let $79a413fb4df28c6f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $79a413fb4df28c6f$var$load("lUobG").then(()=>parcelRequire('56ziH'));

});

parcelRegister("6z61k", function(module, exports) {

let $4c7aae7901bad2e3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4c7aae7901bad2e3$var$load("aW2jH").then(()=>parcelRequire('hnC1a'));

});

parcelRegister("5kRoJ", function(module, exports) {

let $3e283db97351b18a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3e283db97351b18a$var$load("8jpkv").then(()=>parcelRequire('4YnFK'));

});

parcelRegister("feR2c", function(module, exports) {

let $b1814d5ca40bbc4a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b1814d5ca40bbc4a$var$load("9H4Yh").then(()=>parcelRequire('6D2O4'));

});

parcelRegister("4etg2", function(module, exports) {

let $314f2a345afdf3a7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $314f2a345afdf3a7$var$load("2OxSs").then(()=>parcelRequire('25Wds'));

});

parcelRegister("8nZQJ", function(module, exports) {

let $01935cb06e143400$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $01935cb06e143400$var$load("2xkr3").then(()=>parcelRequire('exVrW'));

});

parcelRegister("8lFmQ", function(module, exports) {

let $61405f9650dda366$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $61405f9650dda366$var$load("hs9ik").then(()=>parcelRequire('i6yE3'));

});

parcelRegister("g8jnN", function(module, exports) {

let $bbec6db8ee996d2c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bbec6db8ee996d2c$var$load("ccCKs").then(()=>parcelRequire('hXUtP'));

});

parcelRegister("jBETK", function(module, exports) {

let $e461328eabd5e724$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e461328eabd5e724$var$load("6CgbS").then(()=>parcelRequire('9iyv6'));

});

parcelRegister("3rMHk", function(module, exports) {

let $2829ab117b1f6bf2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2829ab117b1f6bf2$var$load("kA0Mr").then(()=>parcelRequire('63UFV'));

});

parcelRegister("dIytw", function(module, exports) {

let $9fca207ba7e0c574$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9fca207ba7e0c574$var$load("bZGIU").then(()=>parcelRequire('41VWU'));

});

parcelRegister("ISfPl", function(module, exports) {

let $086e31f1c129de58$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $086e31f1c129de58$var$load("cLU5V").then(()=>parcelRequire('dZMvw'));

});

parcelRegister("9vqSC", function(module, exports) {

let $6ebbdc196f4d360a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6ebbdc196f4d360a$var$load("PqYIe").then(()=>parcelRequire('RPxwf'));

});

parcelRegister("dcv25", function(module, exports) {

let $99c477ce9e884692$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $99c477ce9e884692$var$load("gUDo1").then(()=>parcelRequire('iNKsx'));

});

parcelRegister("6DwO1", function(module, exports) {

let $4d4fd521603a06b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4d4fd521603a06b8$var$load("1DKre").then(()=>parcelRequire('6tNEy'));

});

parcelRegister("4iphv", function(module, exports) {

let $320c74323becf2e2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $320c74323becf2e2$var$load("2nKmH").then(()=>parcelRequire('jIByH'));

});

parcelRegister("fxZOi", function(module, exports) {

let $b519e24ddafcf476$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b519e24ddafcf476$var$load("d21Hl").then(()=>parcelRequire('elIN1'));

});

parcelRegister("9GOzA", function(module, exports) {

let $70df4405e839235f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $70df4405e839235f$var$load("dfRLB").then(()=>parcelRequire('g1EId'));

});

parcelRegister("dfTVS", function(module, exports) {

let $9a681017f9e71d7a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9a681017f9e71d7a$var$load("kLIOD").then(()=>parcelRequire('j2ZL3'));

});

parcelRegister("Nzu2E", function(module, exports) {

let $09501a02ce48a566$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $09501a02ce48a566$var$load("iJ0AA").then(()=>parcelRequire('3eqd8'));

});

parcelRegister("jZkCD", function(module, exports) {
module.exports = JSON.parse("{\"post-office.team-wolverine.team-wolverine-jira-migration-success.screen-space-flags.cta-link\":[{\"type\":0,\"value\":\"Go to space\"}],\"post-office.team-wolverine.team-wolverine-jira-migration-success.screen-space-flags.description\":[{\"type\":0,\"value\":\"Your work has been imported and your new space is set up.\"}],\"post-office.team-wolverine.team-wolverine-jira-migration-success.screen-space-flags.header\":[{\"type\":0,\"value\":\"Your space is ready\"}]}");

});

parcelRegister("6ZT3C", function(module, exports) {

let $518325d2f79a65ae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $518325d2f79a65ae$var$load("cg3GS").then(()=>parcelRequire('59e1l'));

});

parcelRegister("5cTfJ", function(module, exports) {

let $3ca8eecbbc768e9b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3ca8eecbbc768e9b$var$load("6SbRq").then(()=>parcelRequire('4lYdB'));

});

parcelRegister("camC3", function(module, exports) {

let $8db7f5a6918372b4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8db7f5a6918372b4$var$load("d7GYX").then(()=>parcelRequire('5cwpc'));

});

parcelRegister("a1edG", function(module, exports) {

let $74b5072277453fe7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $74b5072277453fe7$var$load("dVLgf").then(()=>parcelRequire('8OX4t'));

});

parcelRegister("hozy7", function(module, exports) {

let $caa040e71203fe9c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $caa040e71203fe9c$var$load("6offb").then(()=>parcelRequire('1nfLG'));

});

parcelRegister("3sU7B", function(module, exports) {

let $285f8538b32f554a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $285f8538b32f554a$var$load("tkrur").then(()=>parcelRequire('1U0bm'));

});

parcelRegister("ad5pE", function(module, exports) {

let $76ef51252b89fa0f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $76ef51252b89fa0f$var$load("ePGL7").then(()=>parcelRequire('9m0ZZ'));

});

parcelRegister("lTULb", function(module, exports) {

let $ff1ac361905b20bd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ff1ac361905b20bd$var$load("7AfGw").then(()=>parcelRequire('6sWpL'));

});

parcelRegister("dAEiR", function(module, exports) {

let $9e4de68473c8091e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9e4de68473c8091e$var$load("lqSaP").then(()=>parcelRequire('1lEAN'));

});

parcelRegister("9nH1R", function(module, exports) {

let $6d47a3b26d0e463a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6d47a3b26d0e463a$var$load("ghOMN").then(()=>parcelRequire('gb2jc'));

});

parcelRegister("kjKfL", function(module, exports) {

let $eca975efeeabaa70$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eca975efeeabaa70$var$load("cuIms").then(()=>parcelRequire('aCy2v'));

});

parcelRegister("g2PTm", function(module, exports) {

let $bae515e3cc7db40d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bae515e3cc7db40d$var$load("gjDiT").then(()=>parcelRequire('iYkhF'));

});

parcelRegister("6q5Fg", function(module, exports) {

let $4ac990a9a7106f39$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ac990a9a7106f39$var$load("7cize").then(()=>parcelRequire('jVqyT'));

});

parcelRegister("lghd1", function(module, exports) {

let $03fe9677998d683a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $03fe9677998d683a$var$load("8Xg77").then(()=>parcelRequire('kriK5'));

});

parcelRegister("64AMJ", function(module, exports) {

let $46bfa68356781fb1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $46bfa68356781fb1$var$load("4Qt6m").then(()=>parcelRequire('6Su4j'));

});

parcelRegister("a7XXP", function(module, exports) {

let $75f9126d4b8cb9f2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $75f9126d4b8cb9f2$var$load("dHfMi").then(()=>parcelRequire('bgKoB'));

});

parcelRegister("b5VVj", function(module, exports) {

let $813d17b1d510d594$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $813d17b1d510d594$var$load("gdILP").then(()=>parcelRequire('dZO5w'));

});

parcelRegister("jlOJT", function(module, exports) {

let $e167563f8b2b34d1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e167563f8b2b34d1$var$load("fd6UR").then(()=>parcelRequire('1E4jW'));

});

parcelRegister("hIhOs", function(module, exports) {

let $ce545cf68e4dac31$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ce545cf68e4dac31$var$load("aFPee").then(()=>parcelRequire('kDu7b'));

});

parcelRegister("28Vku", function(module, exports) {

let $18f8cc930c07a92f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $18f8cc930c07a92f$var$load("4r5MC").then(()=>parcelRequire('dRwNL'));

});

parcelRegister("2sxxn", function(module, exports) {

let $1ca8361ad84f0ae4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1ca8361ad84f0ae4$var$load("9DQeJ").then(()=>parcelRequire('lFxj3'));

});

parcelRegister("aRIgT", function(module, exports) {

let $7e9132007d1a9628$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7e9132007d1a9628$var$load("4awUz").then(()=>parcelRequire('393nX'));

});

parcelRegister("9ciVU", function(module, exports) {

let $6b23ebbc568acbed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b23ebbc568acbed$var$load("iF52h").then(()=>parcelRequire('ezqBe'));

});

parcelRegister("5DLSN", function(module, exports) {

let $41b5bccb49f4272b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $41b5bccb49f4272b$var$load("bgcC0").then(()=>parcelRequire('atcQX'));

});

parcelRegister("jMFNQ", function(module, exports) {

let $e672ed311771acd0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e672ed311771acd0$var$load("6GASH").then(()=>parcelRequire('bVIoD'));

});

parcelRegister("72eR9", function(module, exports) {

let $51f43e79da823257$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $51f43e79da823257$var$load("2TbuH").then(()=>parcelRequire('13c5l'));

});

parcelRegister("8Vo2l", function(module, exports) {

let $67f64ad2ca8ba6e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $67f64ad2ca8ba6e8$var$load("cMZfy").then(()=>parcelRequire('dlhw6'));

});

parcelRegister("8sK49", function(module, exports) {

let $6294abfd4ae45f32$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6294abfd4ae45f32$var$load("7DQ9M").then(()=>parcelRequire('8Wmxm'));

});

parcelRegister("jvQHv", function(module, exports) {

let $e349cad3cad63e1c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e349cad3cad63e1c$var$load("iacA0").then(()=>parcelRequire('kZDqV'));

});

parcelRegister("i2Vpd", function(module, exports) {

let $d234f17efe702777$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d234f17efe702777$var$load("POM2m").then(()=>parcelRequire('eetOO'));

});

parcelRegister("8qoY9", function(module, exports) {

let $62241ec6bb41ae9a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $62241ec6bb41ae9a$var$load("2Qw02").then(()=>parcelRequire('d1Q49'));

});

parcelRegister("1hFwa", function(module, exports) {

let $0ef79586c4cf848f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0ef79586c4cf848f$var$load("6VXSK").then(()=>parcelRequire('5oVxu'));

});

parcelRegister("4nr8Z", function(module, exports) {

let $32fe5da6846621e4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $32fe5da6846621e4$var$load("1vhr7").then(()=>parcelRequire('6m47E'));

});

parcelRegister("kBX89", function(module, exports) {

let $f015216d97548d49$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f015216d97548d49$var$load("tyd5V").then(()=>parcelRequire('8uqSG'));

});

parcelRegister("2tp0D", function(module, exports) {
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-unsafe-member-access */ 
var $8aG6j = parcelRequire("8aG6j");


var $cXtTj = parcelRequire("cXtTj");


var $4OYR1 = parcelRequire("4OYR1");


var $jTNdj = parcelRequire("jTNdj");


var $o0RSX = parcelRequire("o0RSX");


var $k4HA2 = parcelRequire("k4HA2");


var $6StHo = parcelRequire("6StHo");


var $d3gqW = parcelRequire("d3gqW");


var $RJe7a = parcelRequire("RJe7a");


var $2WXqg = parcelRequire("2WXqg");


var $6J69K = parcelRequire("6J69K");


var $1p8wq = parcelRequire("1p8wq");


var $3TXEn = parcelRequire("3TXEn");


var $40SXV = parcelRequire("40SXV");


var $82Ab4 = parcelRequire("82Ab4");


var $cozmU = parcelRequire("cozmU");


var $g7aP0 = parcelRequire("g7aP0");


var $6l4K1 = parcelRequire("6l4K1");

const $210c900388def499$var$STABLE_EMPTY_OBJECT = {};
const $210c900388def499$export$9750eb54d7c7e789 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        ...props,
        children: children
    });
};
const $210c900388def499$export$7b7e5a348ef9a7c1 = (messageComponents, _placementId, messageValidator)=>{
    const initializeMessageRenderer = ()=>{
        // Return renderer component
        return /*#__PURE__*/ (0, $cozmU.memo)(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, recommendationSession: recommendationSession, fallbackRender: fallbackRender, loadingFallback: loadingFallback, onError: onError, messageCategory: messageCategory, postOffice: postOffice, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, configSetId: configSetId, SuspenseBoundary: SuspenseBoundary = (0, $cozmU.Suspense), ...data })=>{
            const isUFOEnabled = (0, $cXtTj.default).checkGate('enable_ufo_tracking_in_post_office');
            const { markMessageFailed: markMessageFailed, markMessageUnmounted: markMessageUnmounted, messageSuccessComponent: messageSuccessComponent } = (0, $cozmU.useMemo)(()=>{
                const messagePerformanceTracker = isUFOEnabled ? new (0, $4OYR1.UFOv1).MessagePerformanceTracker(messageTemplateId) : undefined;
                const onMessageSuccess = ()=>{
                    messagePerformanceTracker?.markSuccess();
                };
                const isChunkLoadError = (error)=>{
                    return error?.name === 'ChunkLoadError';
                };
                const markMessageFailed = (onError)=>(error, info)=>{
                        if (!isChunkLoadError(error)) messagePerformanceTracker?.markFailure(error);
                        onError && onError(error, info);
                    };
                return {
                    /** To be called when the message is unmounted  */ markMessageUnmounted: messagePerformanceTracker?.abort,
                    /** To be called when the message fails to render */ markMessageFailed: markMessageFailed,
                    /** To be rendered when the message is successfully loaded */ messageSuccessComponent: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3TXEn.TrackMount), {
                        onMount: onMessageSuccess
                    })
                };
            }, [
                messageTemplateId
            ]);
            (0, $cozmU.useEffect)(()=>{
                return ()=>{
                    markMessageUnmounted?.();
                };
            }, [
                markMessageUnmounted
            ]);
            const Core = ()=>{
                const Component = messageComponents?.[messageTemplateId];
                // This should not happen but things can happen at runtime;
                if (!Component) // Throw to error boundary
                throw new (0, $o0RSX.InvalidMessageTemplateIdError)(JSON.stringify({
                    messageTemplateId: messageTemplateId,
                    messageInstanceId: messageInstanceId
                }));
                let validatedMessage;
                if (messageValidator) {
                    // The messageValidator should also throw an error if the validation failed,
                    // which will again be thrown here and should be caught by the ErrorBoundary
                    validatedMessage = messageValidator(data);
                    if (!validatedMessage) throw new (0, $o0RSX.MessageRendererEmptyValidationResponseError)();
                }
                const loadingComponent = (0, $cozmU.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOLoadHold, {
                        name: (0, $jTNdj.UFOv2).HoldNames.MESSAGE,
                        children: loadingFallback ?? null
                    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
                        children: loadingFallback ?? null
                    }), // oxlint-disable-next-line react-hooks/exhaustive-deps
                [
                    loadingFallback,
                    isUFOEnabled
                ]);
                // This any should be factored out as part of validation work
                const componentProps = messageValidator ? validatedMessage : data;
                // Client-triggered messages: hydrate must return triggerType at top level
                // (e.g. triggerType: messageContext.triggerType). Single source of truth.
                const triggerType = componentProps.triggerType;
                const hasTrigger = (0, $1p8wq.isClientTriggeredMessage)(triggerType);
                // Create waitForTrigger for triggered messages
                const { waitForTrigger: waitForTrigger } = (0, $2WXqg.useWaitForTrigger)({
                    hasTrigger: hasTrigger,
                    messageSuccessComponent: messageSuccessComponent,
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory
                });
                // messageTemplateId exists in the API but component is empty (should not happen)
                if (!Component) return null;
                const messageContextValue = (0, $cozmU.useMemo)(()=>({
                        messageInstanceId: messageInstanceId,
                        messageTemplateId: messageTemplateId,
                        messageCategory: messageCategory,
                        triggerId: triggerId,
                        messageCreationType: messageCreationType,
                        transactionAccountId: componentProps.transactionAccountId,
                        analyticsDetails: postOffice?.analyticsDetails,
                        journeyId: journeyId,
                        journeyTriggerId: journeyTriggerId,
                        configSetId: configSetId
                    }), [
                    componentProps.transactionAccountId,
                    messageCategory
                ]);
                // MaybeChoreographerWrapper sits at the top so it can claim its slot while the
                // lazy chunk is loading; it no-ops for client-triggered messages, which handle
                // their own choreography via MaybeTriggeredMessageValidator below.
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6l4K1.MaybeChoreographerWrapper), {
                    ChoreographerWrapper: (0, $g7aP0.ChoreographerWrapper),
                    enabled: !waitForTrigger,
                    messageId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d3gqW.FeatureFlaggedUfoWrapper), {
                        messageTemplateId: messageTemplateId,
                        isEnabled: isUFOEnabled,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $k4HA2.MessageContextProvider), {
                            value: messageContextValue,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $82Ab4.RecommendationProvider), {
                                value: recommendationSession ?? $210c900388def499$var$STABLE_EMPTY_OBJECT,
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)(SuspenseBoundary, {
                                    fallback: loadingComponent,
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $RJe7a.MaybeTriggeredMessageValidator), {
                                        waitForTrigger: waitForTrigger,
                                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6StHo.MessageAnalyticsContextProvider), {
                                            children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $6J69K.MaybeManualMessageViewedEvent), {
                                                isManual: !!waitForTrigger,
                                                children: [
                                                    !waitForTrigger && messageSuccessComponent,
                                                    /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                                                        onError: onError,
                                                        messageInstanceId: messageInstanceId,
                                                        ...componentProps,
                                                        waitForTrigger: waitForTrigger
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                });
            };
            return (0, $40SXV.withErrorBoundary)(Core)({
                errorBoundaryLocation: 'placement-message-renderer-component',
                messageTemplateId: messageTemplateId,
                fallbackRender: fallbackRender,
                onError: markMessageFailed(onError)
            });
        });
    };
    return {
        initializeMessageRenderer: initializeMessageRenderer,
        MessageRenderer: initializeMessageRenderer()
    };
};
module.exports["MaybeSuspenseBoundary"] = $210c900388def499$export$9750eb54d7c7e789;
module.exports["asMessageRenderer"] = $210c900388def499$export$7b7e5a348ef9a7c1;

});

parcelRegister("4OYR1", function(module, exports) {

var $jAbAo = parcelRequire("jAbAo");


var $8fXDz = parcelRequire("8fXDz");

const $baf07cb19e3d1dfe$export$96236906ebaa7f87 = {
    MessagePerformanceTracker: $jAbAo.MessagePerformanceTracker,
    PlacementPerformanceTracker: $8fXDz.PlacementPerformanceTracker
};
module.exports["UFOv1"] = $baf07cb19e3d1dfe$export$96236906ebaa7f87;

});

parcelRegister("jAbAo", function(module, exports) {

var $34VCg = parcelRequire("34VCg");


var $gZFfs = parcelRequire("gZFfs");


var $8UDja = parcelRequire("8UDja");

class $01005f2678a8118a$export$ae5c73c7c4f454e6 {
    constructor(messageTemplateId){
        this.aggregatedExperience = void 0;
        this.messageSpecificExperience = void 0;
        this.experiences = void 0;
        this.metadata = {};
        this.markSuccess = ()=>{
            for (const experience of this.experiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFailure = (error)=>{
            for (const experience of this.experiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    error: JSON.stringify(error)
                }
            });
        };
        this.abort = ()=>{
            for (const experience of this.experiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $34VCg.UFOExperience)((0, $8UDja.UFOExperienceNames).MESSAGE, {
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $gZFfs.ExperienceTypes).Load,
            platform: {
                component: (0, $8UDja.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.messageSpecificExperience = new (0, $34VCg.UFOExperience)(`${(0, $8UDja.UFOExperienceNames).MESSAGE}.${messageTemplateId}`, {
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $gZFfs.ExperienceTypes).Load,
            platform: {
                component: (0, $8UDja.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.experiences = [
            this.aggregatedExperience,
            this.messageSpecificExperience
        ];
        this.experiences.forEach((experience)=>experience.start());
        this.metadata = {
            messageTemplateId: messageTemplateId
        };
    }
}
module.exports["MessagePerformanceTracker"] = $01005f2678a8118a$export$ae5c73c7c4f454e6;

});

parcelRegister("8UDja", function(module, exports) {
const $21c39d458f004fb5$export$cc7ddf8ca628f6f1 = {
    REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
    PLACEMENT: 'post-office-placement',
    MESSAGE: 'post-office-message'
};
const $21c39d458f004fb5$export$6d482cfa20c9d220 = 'post-office';
module.exports["UFOExperienceNames"] = $21c39d458f004fb5$export$cc7ddf8ca628f6f1;
module.exports["POST_OFFICE_PLATFORM_NAME"] = $21c39d458f004fb5$export$6d482cfa20c9d220;

});

parcelRegister("8fXDz", function(module, exports) {

var $34VCg = parcelRequire("34VCg");


var $gZFfs = parcelRequire("gZFfs");


var $8UDja = parcelRequire("8UDja");

const $e2ea1aa57de97a70$var$STEPS = {
    RML_FETCH: 'rml-fetch',
    RML_RENDER: 'rml-render',
    INITIAL_DATA: 'initial-data-load',
    COMPONENT_READY: 'component-ready'
};
const $e2ea1aa57de97a70$var$UFO_EXPERIENCE_CONFIG = {
    performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $gZFfs.ExperienceTypes).Load,
    platform: {
        component: (0, $8UDja.POST_OFFICE_PLATFORM_NAME)
    },
    timings: [
        {
            key: `${$e2ea1aa57de97a70$var$STEPS.RML_FETCH}-complete`,
            endMark: `${$e2ea1aa57de97a70$var$STEPS.RML_FETCH}-complete`
        },
        {
            key: `${$e2ea1aa57de97a70$var$STEPS.RML_RENDER}-complete`,
            endMark: `${$e2ea1aa57de97a70$var$STEPS.RML_RENDER}-complete`
        },
        {
            key: `${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-complete`,
            endMark: `${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-complete`
        },
        {
            key: `${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-error`,
            endMark: `${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-error`
        }
    ]
};
class $e2ea1aa57de97a70$export$8b48c2105ba0b35a {
    constructor(placementId, consumptionType = 'remote'){
        /** UFO experience for tracking the performance of all placements in aggregate.
     * This supports setting up a single platform-level SLO for all placements.
     */ this.aggregatedExperience = void 0;
        /** UFO experience for tracking the performance of a specific placement.
     * This supports setting up a placement-specific SLOs.
     */ this.placementSpecificExperience = void 0;
        this.placementExperiences = [];
        this.metadata = {};
        this.markFetchComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$e2ea1aa57de97a70$var$STEPS.RML_FETCH}-complete`);
        };
        this.markRenderComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$e2ea1aa57de97a70$var$STEPS.RML_RENDER}-complete`);
        };
        this.markInitialDataComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-complete`);
        };
        this.markComponentReady = ()=>{
            for (const experience of this.placementExperiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFetchFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $e2ea1aa57de97a70$var$STEPS.RML_FETCH,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markRenderFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $e2ea1aa57de97a70$var$STEPS.RML_RENDER,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markInitialDataFailure = (_)=>{
            for (const experience of this.placementExperiences)experience.mark(`${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-error`);
        };
        this.markComponentFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $e2ea1aa57de97a70$var$STEPS.COMPONENT_READY,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markComponentAborted = ()=>{
            for (const experience of this.placementExperiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $34VCg.UFOExperience)((0, $8UDja.UFOExperienceNames).PLACEMENT, $e2ea1aa57de97a70$var$UFO_EXPERIENCE_CONFIG);
        this.placementSpecificExperience = new (0, $34VCg.UFOExperience)(`${(0, $8UDja.UFOExperienceNames).PLACEMENT}.${placementId}`, $e2ea1aa57de97a70$var$UFO_EXPERIENCE_CONFIG);
        this.placementExperiences = [
            this.aggregatedExperience,
            this.placementSpecificExperience
        ];
        for (const experience of this.placementExperiences)experience.start();
        this.metadata = {
            placementId: placementId,
            consumptionType: consumptionType
        };
    }
}
module.exports["PlacementPerformanceTracker"] = $e2ea1aa57de97a70$export$8b48c2105ba0b35a;

});

parcelRegister("o0RSX", function(module, exports) {
//#region src/index.ts

var $ddnoW = parcelRequire("ddnoW");

let $0482ea6551d2dfec$export$b9722560029694e7 = /* @__PURE__ */ function(PostOfficeErrorCodes) {
    PostOfficeErrorCodes["MessageTemplatePlacementError"] = "MessageTemplatePlacementError";
    PostOfficeErrorCodes["NotAbleToProcessRecipientExpansionInputError"] = "NotAbleToProcessRecipientExpansionInputError";
    PostOfficeErrorCodes["NotAbleToProcessEmailTemplateError"] = "NotAbleToProcessEmailTemplateError";
    PostOfficeErrorCodes["RecipientExpansionManagerError"] = "RecipientExpansionManagerError";
    PostOfficeErrorCodes["RecipientExpansionProcessingError"] = "RecipientExpansionProcessingError";
    PostOfficeErrorCodes["RecipientExpansionMethodInvocationError"] = "RecipientExpansionMethodInvocationError";
    PostOfficeErrorCodes["MessageConsumptionFailure"] = "MessageConsumptionFailure";
    PostOfficeErrorCodes["ReceiverInputValidationError"] = "ReceiverInputValidationError";
    PostOfficeErrorCodes["InvalidMessageTemplateIdError"] = "InvalidMessageTemplateIdError";
    PostOfficeErrorCodes["MessageTemplateNotFoundError"] = "MessageTemplateNotFoundError";
    PostOfficeErrorCodes["ConfigSetNotFoundError"] = "ConfigSetNotFoundError";
    PostOfficeErrorCodes["JourneyNotFoundError"] = "JourneyNotFoundError";
    PostOfficeErrorCodes["MessageTemplateNotEnabledError"] = "MessageTemplateNotEnabledError";
    PostOfficeErrorCodes["MessageTemplateActionValidationError"] = "MessageTemplateActionValidationError";
    PostOfficeErrorCodes["MessageTemplateActionHandlerTimeoutError"] = "MessageTemplateActionHandlerTimeoutError";
    PostOfficeErrorCodes["MessageRendererEmptyValidationResponseError"] = "MessageRendererEmptyValidationResponseError";
    PostOfficeErrorCodes["IngestionHandlerFailedSendError"] = "IngestionHandlerFailedSendError";
    PostOfficeErrorCodes["OrchestrationHandlerFailedSendError"] = "OrchestrationHandlerFailedSendError";
    PostOfficeErrorCodes["DigestEngineFailedSendError"] = "DigestEngineFailedSendError";
    PostOfficeErrorCodes["UnableToGetUserDetailsError"] = "UnableToGetUserDetailsError";
    PostOfficeErrorCodes["GatewayTimeoutError"] = "GatewayTimeoutError";
    PostOfficeErrorCodes["InvalidPayloadError"] = "InvalidPayloadError";
    PostOfficeErrorCodes["UnsupportedAttachmentTypeError"] = "UnsupportedAttachmentType";
    PostOfficeErrorCodes["InvalidEmailRequestHeader"] = "InvalidEmailRequestHeader";
    PostOfficeErrorCodes["NonProdEmailDomainError"] = "NonProdEmailDomainError";
    PostOfficeErrorCodes["UnsupportedMessageAtPlacementError"] = "UnsupportedMessageAtPlacementError";
    PostOfficeErrorCodes["HydrationFailureAtPlacementError"] = "HydrationFailureAtPlacementError";
    PostOfficeErrorCodes["AllMessagesFailureHydrationAtPlacementError"] = "AllMessagesFailureHydrationAtPlacementError";
    PostOfficeErrorCodes["UnusedValidateError"] = "UnusedValidateError";
    PostOfficeErrorCodes["RecipientExpanderMapRetrievalError"] = "RecipientExpanderMapRetrievalError";
    PostOfficeErrorCodes["GrowthRecRecommendationsError"] = "GrowthRecRecommendationsError";
    PostOfficeErrorCodes["PlacementNotFoundError"] = "PlacementNotFoundError";
    PostOfficeErrorCodes["UnexpectedMobileNotificationsError"] = "UnexpectedMobileNotificationsError";
    PostOfficeErrorCodes["MobilePushPlacementError"] = "MobilePushPlacementError";
    PostOfficeErrorCodes["MissingIngestionSourceError"] = "MissingIngestionSourceError";
    PostOfficeErrorCodes["RenderRedactedNotFoundError"] = "RenderRedactedNotFoundError";
    PostOfficeErrorCodes["UnexpectedAtlassianMailError"] = "UnexpectedAtlassianMailError";
    PostOfficeErrorCodes["RetryableAtlassianMailError"] = "RetryableAtlassianMailError";
    PostOfficeErrorCodes["RetryableMobileNotificationsError"] = "RetryableMobileNotificationsError";
    PostOfficeErrorCodes["RecipientExpanderError"] = "RecipientExpanderError";
    PostOfficeErrorCodes["RetryableTCSError"] = "RetryableTCSError";
    PostOfficeErrorCodes["MessageEventServiceError"] = "MessageEventServiceError";
    PostOfficeErrorCodes["HydrationDeliveryNoDataFoundError"] = "HydrationDeliveryNoDataFoundError";
    PostOfficeErrorCodes["PlacementMessageError"] = "PlacementMessageError";
    PostOfficeErrorCodes["PlacementError"] = "PlacementError";
    PostOfficeErrorCodes["PlacementSystemError"] = "PlacementSystemError";
    PostOfficeErrorCodes["PlacementRuntimeError"] = "PlacementRuntimeError";
    PostOfficeErrorCodes["PlacementMiddlewareError"] = "PlacementMiddlewareError";
    PostOfficeErrorCodes["SendOutNotFoundError"] = "SendOutNotFoundError";
    PostOfficeErrorCodes["SendOutUpdateForbiddenError"] = "SendOutUpdateForbiddenError";
    PostOfficeErrorCodes["SendOutUserStatusTransitionForbiddenError"] = "SendOutUserStatusTransitionForbiddenError";
    PostOfficeErrorCodes["SendOutValidationError"] = "SendOutValidationError";
    PostOfficeErrorCodes["SendOutFailedToInitiateApprovalRequest"] = "SendOutFailedToInitiateApprovalRequest";
    PostOfficeErrorCodes["MessageTemplateError"] = "MessageTemplateError";
    PostOfficeErrorCodes["MessageTemplatePackageMalformedError"] = "MessageTemplatePackageMalformedError";
    PostOfficeErrorCodes["EmptyMessageTemplateRegistryError"] = "EmptyMessageTemplateRegistryError";
    PostOfficeErrorCodes["PostOfficeGraphQLError"] = "PostOfficeGraphQLError";
    PostOfficeErrorCodes["NotificationRollupConflictError"] = "NotificationRollupConflictError";
    PostOfficeErrorCodes["TesseractTemplateRuntimeMappingDisabledError"] = "TesseractTemplateRuntimeMappingDisabledError";
    PostOfficeErrorCodes["TesseractTemplateRuntimeMappingValidationError"] = "TesseractTemplateRuntimeMappingValidationError";
    return PostOfficeErrorCodes;
}({});
var $0482ea6551d2dfec$export$46f86d28cd0a5d38 = class extends Error {
};
var $0482ea6551d2dfec$export$627bc00a5ef5f6ae = class extends Error {
};
/**
* @deprecated Do not use this pattern. Throwing errors from `hydrate()` to control message
* visibility is an anti-pattern that conflates hydration with filtering.
*
* **Why this is wrong:**
* Filtering decisions (e.g. experiment cohort checks, feature flag gates) belong in the
* filtering/eligibility stage, not inside `hydrate()`. Using errors as control flow here
* risks spreading a pattern that is difficult to reason about, harms observability, and
* fires experiment exposures at the wrong layer.
*
* **What to do instead:**
* - Use **message template filters** to gate visibility based on experiment or feature flag state.
* - For experiment exposure specifically, fire exposures on the Placement Frontend
*   (Narrow-Level Triggering) as described in the official guidance:
*   https://hello.atlassian.net/wiki/spaces/POSTOFFICE/pages/5372727565/Where+to+fire+exposure+for+experiments+in+Post+Office
* - The long-term platform solution for narrow exposure is tracked in POST-773.
*
* This class will be removed once all existing usages have been migrated.
*/ var $0482ea6551d2dfec$export$66e065cfeb491a4d = class HydrationAbortError extends $0482ea6551d2dfec$export$46f86d28cd0a5d38 {
    static is(value) {
        return value instanceof HydrationAbortError;
    }
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$d145ea5319863172 = class extends Error {
    constructor(message, code, cause){
        super(message, {
            cause: cause
        }), (0, $ddnoW._)(this, "code", void 0);
        this.code = code;
    }
};
var $0482ea6551d2dfec$export$69be53c018c89481 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, details){
        super(message, "PostOfficeGraphQLError"), (0, $ddnoW._)(this, "clientName", void 0), (0, $ddnoW._)(this, "operationName", void 0), (0, $ddnoW._)(this, "status", void 0), (0, $ddnoW._)(this, "graphQLErrorMessage", void 0), (0, $ddnoW._)(this, "errors", void 0), (0, $ddnoW._)(this, "sanitisedRequestHeaders", void 0), (0, $ddnoW._)(this, "sanitisedResponseHeaders", void 0), (0, $ddnoW._)(this, "responseBody", void 0);
        this.name = this.constructor.name;
        this.clientName = details.clientName;
        this.operationName = details.operationName;
        this.status = details.status;
        this.graphQLErrorMessage = details.graphQLErrorMessage;
        this.errors = details.errors;
        this.sanitisedRequestHeaders = details.sanitisedRequestHeaders;
        this.sanitisedResponseHeaders = details.sanitisedResponseHeaders;
        this.responseBody = details.responseBody;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$6452976adc01572 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(cause, code){
        super($0482ea6551d2dfec$var$getErrorMessage(cause), code, cause);
        this.name = this.constructor.name;
    }
};
const $0482ea6551d2dfec$var$getErrorMessage = (cause)=>{
    if (cause instanceof Error) return cause.message;
    if (typeof cause === "string") return cause;
    return "Unknown error";
};
function $0482ea6551d2dfec$export$4cb1ea6034a33155(error) {
    return typeof error === "object" && !!error && "status" in error && typeof error.status === "number";
}
function $0482ea6551d2dfec$export$aed524b0009b5631(error) {
    return typeof error === "object" && !!error && "logLevel" in error && typeof error.logLevel === "string";
}
var $0482ea6551d2dfec$export$ed601cd0dc1a1be7 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(args){
        /**
		* It is expected that this error message can be not deterministic.
		* This error message can be displayed in the "Failures" and "Preview It" tabs for message makers.
		* Showing the error cause helps them understand what was the problem with their payload.
		*
		* On Post Office (platform) side, we use "instanceof MessageTemplateError" check
		* to distinguish between message makers code errors and platform errors,
		* but we don't rely on the error message itself.
		*/ const errMessage = args.cause instanceof Error ? args.cause.message : "Error in message template code";
        super(errMessage, "MessageTemplateError", args.cause), (0, $ddnoW._)(this, "function", void 0), (0, $ddnoW._)(this, "messageTemplateId", void 0), (0, $ddnoW._)(this, "triggerId", void 0);
        this.name = this.constructor.name;
        this.messageTemplateId = args.messageTemplateId;
        this.triggerId = args.triggerId;
        this.function = args.function;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$2833d4759f81601b = class extends $0482ea6551d2dfec$export$ed601cd0dc1a1be7 {
    constructor(args){
        super(args);
        this.message = "Invalid CSS property could not be processed by Juice";
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$8d39b103586e9fd4 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, cause){
        super(message, "NotAbleToProcessEmailTemplateError", cause);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$f649da38897d27f7 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), (0, $ddnoW._)(this, "input", void 0);
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$c2852c1c4d9aba3e = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionProcessingError"), (0, $ddnoW._)(this, "input", void 0);
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$4b7b4e09547e4bb3 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionMethodInvocationError"), (0, $ddnoW._)(this, "input", void 0);
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$360a094a97597d87 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message){
        super(message, "RecipientExpansionManagerError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$4d068b43eb55165b = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), (0, $ddnoW._)(this, "input", void 0);
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$ac007ee150add337 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message){
        super(message, "ReceiverInputValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$19cb89dd679394cb = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message){
        super(message, "InvalidMessageTemplateIdError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$78651662ad470cc5 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Message Template not found", "MessageTemplateNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$43b3b4535703ed1b = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    get nonSensitiveFields() {
        return {
            configSetId: this.configSetId
        };
    }
    constructor(configSetId){
        super(`Config Set with ConfigSetId ${configSetId} could not be found`, "ConfigSetNotFoundError"), (0, $ddnoW._)(this, "configSetId", void 0);
        this.configSetId = configSetId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$8a5041670cdd8db2 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(journeyId){
        super("Journey not found", "JourneyNotFoundError"), (0, $ddnoW._)(this, "journeyId", void 0);
        this.journeyId = journeyId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$1240ddc25cf964e6 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Message Template action handler validation error", "MessageTemplateActionValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$3c4884b7ae7fe517 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(timeoutInSeconds = 5){
        super(`Message Template action handler timed out after ${timeoutInSeconds} seconds`, "MessageTemplateActionHandlerTimeoutError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$913b8e68dc7ae8fe = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Placement not found", "PlacementNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$3dfc27a8d3942f4d = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Message Renderer received empty response from validator", "MessageRendererEmptyValidationResponseError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$e5ccdf8bbfead7a2 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Failed to send some events", "IngestionHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$823733742d803ae6 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Failed to send some events", "OrchestrationHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$1caa32527f23acd2 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(errorCause){
        super("Failed to send digest event to orchestration queue", "DigestEngineFailedSendError"), (0, $ddnoW._)(this, "errorCause", void 0);
        this.name = this.constructor.name;
        this.errorCause = errorCause;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$a6f2aad8fa094b39 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(accountId, customErrorMessage){
        super(customErrorMessage ?? "Unable to get user details for the given account ID", "UnableToGetUserDetailsError"), (0, $ddnoW._)(this, "accountId", void 0);
        this.accountId = accountId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$2296e5dc6a1bf3d2 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(accountId, customErrorMessage){
        super(customErrorMessage ?? "Gateway timeout occurred", "GatewayTimeoutError"), (0, $ddnoW._)(this, "accountId", void 0);
        this.accountId = accountId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$2f1e27130c2bf271 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, payloadSize){
        super(message, "InvalidPayloadError"), (0, $ddnoW._)(this, "payloadSize", void 0);
        this.name = this.constructor.name;
        this.payloadSize = payloadSize;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$d0dc094613469f2b = class extends $0482ea6551d2dfec$export$46f86d28cd0a5d38 {
    constructor(message, workspaceId){
        super(message), (0, $ddnoW._)(this, "workspaceId", void 0);
        this.name = this.constructor.name;
        this.workspaceId = workspaceId;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$5603eab37ce562f5 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(fileType){
        super("The attachment file is not supported", "UnsupportedAttachmentType"), (0, $ddnoW._)(this, "fileType", void 0);
        this.name = this.constructor.name;
        this.fileType = fileType;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$e0e9aa0e9c6b37ff = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, error){
        super(message, "InvalidEmailRequestHeader"), (0, $ddnoW._)(this, "error", void 0);
        this.name = this.constructor.name;
        this.error = error;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$3ad818f64601e141 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message){
        super(message, "NonProdEmailDomainError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$25470bb6cba4fba0 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor({ messageTemplateId: messageTemplateId, placementId: placementId }){
        super("messageTemplateId not supported by placement", "UnsupportedMessageAtPlacementError"), (0, $ddnoW._)(this, "messageTemplateId", void 0), (0, $ddnoW._)(this, "placementId", void 0);
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$ce14d445679448b6 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(error, { messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, placementId: placementId }){
        super(error?.message ?? "unknown error", "HydrationFailureAtPlacementError"), (0, $ddnoW._)(this, "messageTemplateId", void 0), (0, $ddnoW._)(this, "messageInstanceId", void 0), (0, $ddnoW._)(this, "placementId", void 0);
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.messageInstanceId = messageInstanceId;
        this.placementId = placementId;
        this.stack = error?.stack;
    }
};
var $0482ea6551d2dfec$export$c9a26a17db1045c8 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor({ placementId: placementId }){
        super("All messages failed at placement", "AllMessagesFailureHydrationAtPlacementError"), (0, $ddnoW._)(this, "placementId", void 0);
        this.name = this.constructor.name;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$8ab4fb362168b928 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Unexpected invocation of validate() function for push delivery channel", "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$2afd69f57fe5285f = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Recipient expander not found for mapper", "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$7635d2b1a281d626 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, errors){
        super(message, "GrowthRecRecommendationsError"), (0, $ddnoW._)(this, "errors", void 0);
        this.errors = errors;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$90bef7fa95eca3fa = class extends Error {
    constructor(status){
        super("Posting Mobile Notifications message failed"), (0, $ddnoW._)(this, "status", void 0);
        this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$6d1a4929f6ff1a32 = class extends $0482ea6551d2dfec$export$46f86d28cd0a5d38 {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$c19fc5e8aa4e064d = class extends Error {
    constructor(){
        super("Ingestion source is required when custom profile is specified");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$2d3a68dab93b8cc4 = class extends Error {
    constructor(){
        super("A renderRedacted function is required when redactionLevel is set to a non-null value");
        this.name = this.constructor.name;
    }
};
var $0482ea6551d2dfec$export$175c1dbb0d7c238a = class extends Error {
    constructor(status){
        super("Enqueueing email failed"), (0, $ddnoW._)(this, "status", void 0);
        this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$23fab744b3076342 = class extends Error {
    constructor(message, status){
        super(message), (0, $ddnoW._)(this, "message", void 0), (0, $ddnoW._)(this, "status", void 0);
        this.message = message;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$194adecfa0265ea1 = class extends Error {
    constructor(msg, messageInstanceId, error){
        super(msg), (0, $ddnoW._)(this, "msg", void 0), (0, $ddnoW._)(this, "messageInstanceId", void 0);
        this.msg = msg;
        this.messageInstanceId = messageInstanceId;
        if (error instanceof Error) this.stack = error.stack;
        else Error.captureStackTrace(this, this.constructor);
        this.name = this.constructor.name;
    }
};
var $0482ea6551d2dfec$export$c504492f06c975b5 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor({ ipmNumber: ipmNumber, variantFromStatsig: variantFromStatsig, contentfulLocale: contentfulLocale }){
        super("hydrate delivery marketing-screen-space-flag-contentful-usecase No data found for the user", "HydrationDeliveryNoDataFoundError"), (0, $ddnoW._)(this, "ipmNumber", void 0), (0, $ddnoW._)(this, "variantFromStatsig", void 0), (0, $ddnoW._)(this, "contentfulLocale", void 0);
        this.name = this.constructor.name;
        this.ipmNumber = ipmNumber;
        this.variantFromStatsig = variantFromStatsig;
        this.contentfulLocale = contentfulLocale;
        Error.captureStackTrace(this, this.constructor);
    }
};
/**
* Error thrown when an upstream service (e.g., Atlassian Mail, Mobile Notifications, TCS)
* returns a retryable error status code (e.g. 500, 502, 503, 504).
*
* An SQS message that encounters this error will be retried.
*
* Only the final retry will be counted against our reliability SLOs and canary analysis.
*/ var $0482ea6551d2dfec$export$1c932b9d1680ee0b = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, code, cause){
        super(message, code, cause);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$5d5d1885c87ef4bc = class extends Error {
    constructor(message, options){
        super(message, options);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
/**
* Wraps an error thrown while running a recipient expander. Carries the expander key and message
* template id so they can be surfaced in logs and used to emit the recipient expander SLO metric.
*
* Co-located here with {@link UnretryableError} so a dedicated serializer can live in
* `@post-office/error-serializers` (the expander-specific fields are otherwise dropped by the
* generic error serializer).
*/ var $0482ea6551d2dfec$export$85497ede72633b85 = class extends $0482ea6551d2dfec$export$1c932b9d1680ee0b {
    constructor(error, { expanderKey: expanderKey, messageTemplateId: messageTemplateId }){
        const message = error instanceof Error ? error.message : String(error);
        super(`Recipient Expander Error: ${message}`, "RecipientExpanderError", error), (0, $ddnoW._)(this, "expanderKey", void 0), (0, $ddnoW._)(this, "messageTemplateId", void 0);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
        this.expanderKey = expanderKey;
        this.messageTemplateId = messageTemplateId;
    }
};
/**
* Unretryable variant of {@link RecipientExpanderError}, thrown when an expander fails with a
* non-retryable error. The originating error is preserved as the `cause`.
*/ var $0482ea6551d2dfec$export$359a331da49d1ec8 = class extends $0482ea6551d2dfec$export$5d5d1885c87ef4bc {
    constructor(error, { expanderKey: expanderKey, messageTemplateId: messageTemplateId }){
        const message = error instanceof Error ? error.message : String(error);
        super(`Unretryable Recipient Expander Error: ${message}`, {
            cause: error
        }), (0, $ddnoW._)(this, "expanderKey", void 0), (0, $ddnoW._)(this, "messageTemplateId", void 0);
        this.name = this.constructor.name;
        this.expanderKey = expanderKey;
        this.messageTemplateId = messageTemplateId;
    }
};
/**
* Thrown when a message template package loads but is missing one or more exports that every
* template is required to have. In production the bundler intermittently produces module
* namespaces with re-exported bindings missing, which is decided once per process and then
* permanent. Detection uses a sentinel export rather than an exhaustive check, so `missingFields`
* reports what was inspected, not every binding the bundler actually dropped.
*
* Callers must treat this as a platform failure and let the message retry onto a healthy process;
* never as "the template has no subscriptions/config", which silently discards traffic.
*/ var $0482ea6551d2dfec$export$8506e646874f88f6 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    get nonSensitiveFields() {
        return {
            missingFields: this.missingFields.join(",")
        };
    }
    constructor(messageTemplateId, missingFields){
        super("Message template package loaded without required exports", "MessageTemplatePackageMalformedError"), (0, $ddnoW._)(this, "messageTemplateId", void 0), (0, $ddnoW._)(this, "missingFields", void 0);
        this.messageTemplateId = messageTemplateId;
        this.missingFields = missingFields;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
/**
* Thrown when the message template registry reports zero templates. There is no legitimate state in
* which Post Office has no templates, so callers must retry rather than read it as "nobody is
* subscribed"; the latter acks the message and discards it permanently.
*/ var $0482ea6551d2dfec$export$6a4077faeb1c609 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Message template registry returned no templates", "EmptyMessageTemplateRegistryError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$c2cfe2317dcfcabb = class extends Error {
    get nonSensitiveFields() {
        return {
            deliveryChannel: this.deliveryChannel
        };
    }
    constructor(deliveryChannel){
        super("Duplicate message detected"), (0, $ddnoW._)(this, "deliveryChannel", void 0);
        this.deliveryChannel = deliveryChannel;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
const $0482ea6551d2dfec$export$fec3468114498229 = (value)=>typeof value === "object" && value !== null && Object.values(value).every((field)=>field === void 0 || field === null || typeof field === "string" || typeof field === "number" || typeof field === "boolean");
 //# sourceMappingURL=index.mjs.map
module.exports["InvalidMessageTemplateIdError"] = $0482ea6551d2dfec$export$19cb89dd679394cb;
module.exports["MessageRendererEmptyValidationResponseError"] = $0482ea6551d2dfec$export$3dfc27a8d3942f4d;

});

parcelRegister("6StHo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8aG6j = parcelRequire("8aG6j");

const $501ed2d1c3ff3743$export$c81717973c6c4a90 = (0, $cozmU.createContext)({
    fireMessageViewedInMessageComponent: null,
    setFireMessageViewedInMessageComponent: ()=>{}
});
const $501ed2d1c3ff3743$export$1737ab199e83455e = ({ children: children })=>{
    const fireMessageViewedInMessageComponent = (0, $cozmU.useRef)(false);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent,
            setFireMessageViewedInMessageComponent: (value)=>{
                fireMessageViewedInMessageComponent.current = value;
            }
        }), [
        fireMessageViewedInMessageComponent
    ]);
    return /* @__PURE__ */ (0, $8aG6j.jsx)($501ed2d1c3ff3743$export$c81717973c6c4a90.Provider, {
        value: contextValue,
        children: children
    });
};
const $501ed2d1c3ff3743$export$bb426ba114b64992 = ()=>(0, $cozmU.useContext)($501ed2d1c3ff3743$export$c81717973c6c4a90);
 //# sourceMappingURL=message-analytics-context.mjs.map
module.exports["MessageAnalyticsContextProvider"] = $501ed2d1c3ff3743$export$1737ab199e83455e;
module.exports["useMessageAnalyticsContext"] = $501ed2d1c3ff3743$export$bb426ba114b64992;

});

parcelRegister("d3gqW", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $jTNdj = parcelRequire("jTNdj");

//#region src/message-renderer-provider/ufo-wrapper.tsx
const $98084d8efd96fde1$export$8e6fb7035018b3e4 = ({ isEnabled: isEnabled, messageTemplateId: messageTemplateId, children: children })=>{
    if (isEnabled) return /* @__PURE__ */ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOSegment, {
        name: (0, $jTNdj.UFOv2).SegmentNames.MESSAGE,
        children: /* @__PURE__ */ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOSegment, {
            name: `${(0, $jTNdj.UFOv2).SegmentNames.MESSAGE}.${messageTemplateId}`,
            children: children
        })
    });
    return /* @__PURE__ */ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
 //# sourceMappingURL=ufo-wrapper.mjs.map
module.exports["FeatureFlaggedUfoWrapper"] = $98084d8efd96fde1$export$8e6fb7035018b3e4;

});

parcelRegister("RJe7a", function(module, exports) {

var $dn77R = parcelRequire("dn77R");


var $8aG6j = parcelRequire("8aG6j");

//#region src/message-renderer-provider/maybe-triggered-message-validator.tsx
/**
* Renders {@link TriggeredMessageValidator} when `waitForTrigger` is provided (i.e. the message is
* client-triggered), otherwise renders `children` unchanged. Lets callers slot the validator into
* an existing JSX tree without forking the tree into "triggered" and "non-triggered" branches.
*
* IMPORTANT: this wrapper must be mounted BELOW the Suspense boundary that owns the lazy template,
* so the validator only mounts after the template's chunk has resolved. Otherwise the validator
* commits with the Suspense fallback as its children (template hasn't executed yet, ref is false),
* and when the chunk later resolves only the Suspense subtree re-renders — the validator above
* never sees the ref flip to true and stays stuck in 'pending' with `display:none`. See PO-7815
* follow-up.
*/ const $0a18086c6bef8c43$export$dac988aa97dc7b79 = ({ children: children, waitForTrigger: waitForTrigger })=>{
    if (!waitForTrigger) return /* @__PURE__ */ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return /* @__PURE__ */ (0, $8aG6j.jsx)((0, $dn77R.TriggeredMessageValidator), {
        waitForTrigger: waitForTrigger,
        children: children
    });
};
 //# sourceMappingURL=maybe-triggered-message-validator.mjs.map
module.exports["MaybeTriggeredMessageValidator"] = $0a18086c6bef8c43$export$dac988aa97dc7b79;

});

parcelRegister("dn77R", function(module, exports) {

var $cWRw8 = parcelRequire("cWRw8");


var $cozmU = parcelRequire("cozmU");


var $8aG6j = parcelRequire("8aG6j");

//#region src/message-renderer-provider/triggered-message-validator.tsx
/** Hide content until validated; avoids flash without off-screen positioning or scrollbar issues. */ const $9bc2f36132f2baa7$var$HIDDEN_CONTAINER_STYLE = {
    display: "none"
};
/**
* Validates that waitForTrigger was called for triggered messages.
*
* - First render: render children inside a hidden container so the template runs and can call
*   waitForTrigger without any visible flash (blocking during render would create a catch-22).
* - After commit (useLayoutEffect): if the template did not call waitForTrigger, set state to
*   'blocked' and return null. If it did, set 'allowed' and make the container visible.
*
* The effect depends on [waitForTrigger, children] so that when the template is lazy-loaded
* (inside Suspense), we re-run after the lazy chunk resolves and the template runs. On the first
* run we do not block if the ref is false, so a suspending template gets one more commit to
* call waitForTrigger before we block.
*/ const $9bc2f36132f2baa7$export$c8b5f992b8a1b38b = ({ children: children, waitForTrigger: waitForTrigger })=>{
    const [validated, setValidated] = (0, $cozmU.useState)("pending");
    (0, $cWRw8.t)(()=>{
        const calledRef = waitForTrigger?.__calledRef;
        if (calledRef?.current) {
            setValidated("allowed");
            return;
        }
        if (calledRef) setValidated("blocked");
    }, [
        waitForTrigger,
        children
    ]);
    if (validated === "blocked") return null;
    const isHidden = validated === "pending";
    return /* @__PURE__ */ (0, $8aG6j.jsx)("span", {
        style: isHidden ? $9bc2f36132f2baa7$var$HIDDEN_CONTAINER_STYLE : void 0,
        "aria-hidden": isHidden,
        "data-testid": isHidden ? "triggered-message-validator-hidden" : void 0,
        children: children
    });
};
 //# sourceMappingURL=triggered-message-validator.mjs.map
module.exports["TriggeredMessageValidator"] = $9bc2f36132f2baa7$export$c8b5f992b8a1b38b;

});

parcelRegister("cWRw8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

//#region src/use-isomorphic-layout-effect.ts
/**
* `useLayoutEffect` warns during SSR ("Warning: useLayoutEffect does nothing on the server").
* Fall back to `useEffect` on the server so utilities in this package are safe to render in SSR
* contexts. In the browser the synchronous commit-time semantics of `useLayoutEffect` are preserved.
*
* Consumers import this as `useLayoutEffect` so the call site reads identically to React's hook.
*
* See: https://medium.com/@alexandereardon/uselayouteffect-and-ssr-192986cdcf7a
*/ const $96d46a3f71d08468$export$625550452a3fa3ec = typeof window !== "undefined" ? (0, $cozmU.useLayoutEffect) : (0, $cozmU.useEffect);
 //# sourceMappingURL=use-isomorphic-layout-effect-Br3YqoXZ.mjs.map
module.exports["t"] = $96d46a3f71d08468$export$625550452a3fa3ec;

});

parcelRegister("2WXqg", function(module, exports) {

var $b7cYO = parcelRequire("b7cYO");


var $bFQKv = parcelRequire("bFQKv");


var $cozmU = parcelRequire("cozmU");


var $8aG6j = parcelRequire("8aG6j");


var $7NHN3 = parcelRequire("7NHN3");

//#region src/hooks/use-wait-for-trigger.tsx
/**
* Component that calls messageInstanceViewed, renders messageSuccessComponent, and calls onShow callback once when mounted
*/ const $225f17aa9a922e84$var$OnChoreographerApproved = ({ children: children, onShow: onShow, messageSuccessComponent: messageSuccessComponent, additionalMetadataFromFrontend: additionalMetadataFromFrontend = {} })=>{
    const hasShownRef = (0, $cozmU.useRef)(false);
    const { messageInstanceViewed: messageInstanceViewed } = (0, $7NHN3.useMessageInstanceEvent)();
    (0, $cozmU.useEffect)(()=>{
        if (hasShownRef.current) return;
        hasShownRef.current = true;
        messageInstanceViewed(additionalMetadataFromFrontend);
        onShow?.();
    }, []);
    return /* @__PURE__ */ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            messageSuccessComponent,
            children
        ]
    });
};
/**
* Creates the waitForTrigger function for triggered messages.
* This function handles all choreography and analytics wrapping automatically.
* The ref for validation is attached to the function as __calledRef.
*
* @param hasTrigger - Whether this message has a trigger (triggerType !== 'onPageLoad')
* @param messageSuccessComponent - Optional component to render when choreographer approves (for UFO tracking)
* @returns Object containing waitForTrigger function (with attached ref)
*/ const $225f17aa9a922e84$export$b5884e72fa051e28 = ({ hasTrigger: hasTrigger, messageSuccessComponent: messageSuccessComponent, messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const waitForTriggerCalledRef = (0, $cozmU.useRef)(false);
    const waitForTriggerCallback = (0, $cozmU.useCallback)(({ isTriggerActive: isTriggerActive, messageContent: messageContent, onMessageShown: onMessageShown, additionalMetadataFromFrontend: additionalMetadataFromFrontend, onTeardown: onTeardown })=>{
        waitForTriggerCalledRef.current = true;
        if (!isTriggerActive) return null;
        return /* @__PURE__ */ (0, $8aG6j.jsx)((0, $b7cYO.ChoreographerWrapper), {
            messageId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory,
            children: /* @__PURE__ */ (0, $8aG6j.jsx)($225f17aa9a922e84$var$OnChoreographerApproved, {
                onShow: onMessageShown,
                additionalMetadataFromFrontend: additionalMetadataFromFrontend,
                messageSuccessComponent: messageSuccessComponent,
                children: onTeardown !== void 0 ? /* @__PURE__ */ (0, $8aG6j.jsx)((0, $bFQKv.UnmountCleanup), {
                    onCleanup: onTeardown,
                    children: messageContent
                }) : messageContent
            })
        });
    }, [
        messageInstanceId,
        messageTemplateId,
        messageCategory,
        messageSuccessComponent
    ]);
    const waitForTrigger = hasTrigger ? waitForTriggerCallback : void 0;
    if (waitForTrigger) waitForTrigger.__calledRef = waitForTriggerCalledRef;
    return {
        waitForTrigger: waitForTrigger
    };
};
 //# sourceMappingURL=use-wait-for-trigger.mjs.map
module.exports["useWaitForTrigger"] = $225f17aa9a922e84$export$b5884e72fa051e28;

});

parcelRegister("b7cYO", function(module, exports) {

var $6NRmI = parcelRequire("6NRmI");


var $cozmU = parcelRequire("cozmU");


var $aHfj2 = parcelRequire("aHfj2");


var $cXtTj = parcelRequire("cXtTj");


var $8aG6j = parcelRequire("8aG6j");

//#region src/message-renderer-provider/choreographer-wrapper.tsx
const $817a6ab11e5002a9$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    if (useChoreographedRender({
        messageId: messageId
    })) return /* @__PURE__ */ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return null;
};
const $817a6ab11e5002a9$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $6NRmI.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $aHfj2.useFirePostOfficeAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if ((0, $cXtTj.default).checkGate("enable_tracking_choreographed_post_office_messages")) fireAnalyticsEvent({
            eventType: "operational",
            action: "maybeChoreographed",
            actionSubject: "postOfficeMessage"
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $cXtTj.default).checkGate("enable_choreographed_post_office_messages");
    const useMessageTemplateIdAsChoreographerMessageId = (0, $cXtTj.default).checkGate("post-office_use_template_id_for_choreo");
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        if (shouldBeChoreographed({
            messageType: messageCategory ? messageCategory.toLowerCase() : void 0
        })) return /* @__PURE__ */ (0, $8aG6j.jsx)($817a6ab11e5002a9$var$ChoreographedComponent, {
            choreographerFactory: factory,
            messageId: useMessageTemplateIdAsChoreographerMessageId ? messageTemplateId : messageId,
            children: children
        });
    }
    return /* @__PURE__ */ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
 //# sourceMappingURL=choreographer-wrapper.mjs.map
module.exports["ChoreographerWrapper"] = $817a6ab11e5002a9$export$8db7ba034addcd65;

});

parcelRegister("bFQKv", function(module, exports) {

var $cWRw8 = parcelRequire("cWRw8");


var $cozmU = parcelRequire("cozmU");


var $8aG6j = parcelRequire("8aG6j");

//#region src/unmount-cleanup.tsx
/**
* Runs `onCleanup` when the wrapper unmounts. Wrap arbitrary UI without a custom component + effect.
*/ const $87fc70e55f2a27ac$export$ea970fe2c565070a = ({ onCleanup: onCleanup, children: children })=>{
    const onCleanupRef = (0, $cozmU.useRef)(onCleanup);
    (0, $cWRw8.t)(()=>{
        onCleanupRef.current = onCleanup;
    });
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            onCleanupRef.current?.();
        };
    }, []);
    return /* @__PURE__ */ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
 //# sourceMappingURL=unmount-cleanup.mjs.map
module.exports["UnmountCleanup"] = $87fc70e55f2a27ac$export$ea970fe2c565070a;

});

parcelRegister("7NHN3", function(module, exports) {

var $kEPax = parcelRequire("kEPax");

const $b15c706fb306d92c$export$39b0f5626e96f41e = (0, $kEPax.useMessageInstanceEvent);
module.exports["useMessageInstanceEvent"] = $b15c706fb306d92c$export$39b0f5626e96f41e;

});

parcelRegister("6J69K", function(module, exports) {

var $6MYaw = parcelRequire("6MYaw");


var $8aG6j = parcelRequire("8aG6j");

//#region src/maybe-manual-message-viewed-event.tsx
/**
* Messages that use waitForTrigger handle the message view event internally.
* All other messages use automatic `MessageViewed`.
*
*/ const $4e5bb8892ac55081$export$9915b88f81e90e6e = ({ isManual: isManual, children: children })=>{
    return isManual ? /* @__PURE__ */ (0, $8aG6j.jsx)((0, $6MYaw.ManualMessageViewedEvent), {
        children: children
    }) : /* @__PURE__ */ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
 //# sourceMappingURL=maybe-manual-message-viewed-event.mjs.map
module.exports["MaybeManualMessageViewedEvent"] = $4e5bb8892ac55081$export$9915b88f81e90e6e;

});

parcelRegister("6MYaw", function(module, exports) {

var $3TXEn = parcelRequire("3TXEn");


var $6StHo = parcelRequire("6StHo");


var $cozmU = parcelRequire("cozmU");


var $8aG6j = parcelRequire("8aG6j");


var $7NHN3 = parcelRequire("7NHN3");


var $9ME8P = parcelRequire("9ME8P");


var $lixOz = parcelRequire("lixOz");

//#region src/message-viewed-component.tsx
const $4f15e6011b914f0d$export$de534803cb07dfcc = ({ children: children })=>{
    const { fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent, setFireMessageViewedInMessageComponent: setFireMessageViewedInMessageComponent } = (0, $6StHo.useMessageAnalyticsContext)();
    if (fireMessageViewedInMessageComponent) setFireMessageViewedInMessageComponent(true);
    return /* @__PURE__ */ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
/**
* This component is used as a child of a message component to fire the message viewed event when mounted.
* It will only fire the message viewed event if the message viewed event is not fired in the message component.
* @returns a component that fires the message viewed event when mounted.
*/ const $4f15e6011b914f0d$export$14fe1fc3395b6e3f = ()=>{
    const { fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent } = (0, $6StHo.useMessageAnalyticsContext)();
    const { messageViewed: messageViewed } = (0, $9ME8P.useMessageEvent)();
    const { messageInstanceViewed: messageInstanceViewed, messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully } = (0, $7NHN3.useMessageInstanceEvent)();
    const hasDeliveredSuccessfullyBeenFired = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!hasDeliveredSuccessfullyBeenFired.current) {
            hasDeliveredSuccessfullyBeenFired.current = true;
            messageInstanceDeliveredSuccessfully();
        }
    }, [
        messageInstanceDeliveredSuccessfully
    ]);
    const messageViewedVoidFunction = (0, $cozmU.useCallback)(()=>{
        if (fireMessageViewedInMessageComponent && !fireMessageViewedInMessageComponent.current) {
            messageViewed();
            messageInstanceViewed();
        }
    }, []);
    return /* @__PURE__ */ (0, $8aG6j.jsx)((0, $3TXEn.TrackMount), {
        onMount: messageViewedVoidFunction
    });
};
/**
* NOT USED YET due to implementation affecting rendering.
* This component wraps a message component and fires the message "viewed" event when the message enters the viewport.
* It will also fire a "delivery successful" event when the message is rendered, regardless of whether it is in the viewport.
* @returns a component that fires the message viewed event when the message is in the viewport.
*/ const $4f15e6011b914f0d$export$4c73c6f545b966b7 = ({ children: children })=>{
    const messageRef = (0, $cozmU.useRef)(null);
    const { messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully } = (0, $7NHN3.useMessageInstanceEvent)();
    const { inViewport: inViewport, enterCount: enterCount } = (0, $lixOz.useInViewport)(messageRef, {});
    const hasDeliveredSuccessfullyBeenFired = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!hasDeliveredSuccessfullyBeenFired.current) {
            hasDeliveredSuccessfullyBeenFired.current = true;
            messageInstanceDeliveredSuccessfully();
        }
    }, [
        messageInstanceDeliveredSuccessfully
    ]);
    return /* @__PURE__ */ (0, $8aG6j.jsxs)("section", {
        ref: messageRef,
        children: [
            inViewport && enterCount >= 1 ? /* @__PURE__ */ (0, $8aG6j.jsx)($4f15e6011b914f0d$export$14fe1fc3395b6e3f, {}) : null,
            children
        ]
    });
};
 //# sourceMappingURL=message-viewed-component.mjs.map
module.exports["ManualMessageViewedEvent"] = $4f15e6011b914f0d$export$de534803cb07dfcc;
module.exports["MessageViewed"] = $4f15e6011b914f0d$export$14fe1fc3395b6e3f;

});

parcelRegister("9ME8P", function(module, exports) {

var $di43e = parcelRequire("di43e");

var $bGVJw = parcelRequire("bGVJw");


var $k4HA2 = parcelRequire("k4HA2");


var $4cICV = parcelRequire("4cICV");


var $kEPax = parcelRequire("kEPax");


var $cozmU = parcelRequire("cozmU");


var $dEG1b = parcelRequire("dEG1b");

//#region src/error.ts
var $71f7bbf8faadfbf0$var$MessageLifecycleContextError = class extends Error {
    constructor(){
        super("useMessageLifecycle must be used inside a Message template render component.");
    }
};
var $71f7bbf8faadfbf0$var$MessageLifecycleClientError = class extends Error {
    constructor(){
        super("API call to /messages failed due to an error");
    }
};
//#endregion
//#region src/index.ts
/**
* Exposes functions for updating message lifecycle
*/ const $71f7bbf8faadfbf0$export$3cbbf1e81e2ecb39 = ()=>{
    if (!globalThis.window.postOfficeMessageEventClient) globalThis.window.postOfficeMessageEventClient = new (0, $dEG1b.MessageEventClient)();
    const client = globalThis.window.postOfficeMessageEventClient;
    const { dismissMessageFromPlacement: dismissMessageFromPlacement, markReadFromPlacement: markReadFromPlacement, markClickedFromPlacement: markClickedFromPlacement, markViewedFromPlacement: markViewedFromPlacement, snoozeMessageFromPlacement: snoozeMessageFromPlacement } = (0, $di43e.useMessagePlacementHooks)();
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId, analyticsDetails: analyticsDetails } = (0, $k4HA2.useMessageContext)();
    const { placementId: placementId } = (0, $4cICV.usePlacementContext)();
    const context = {
        browser: (0, $bGVJw.usePostOfficeContext)(),
        recommendation: (0, $kEPax.useRecommendationContext)()
    };
    return {
        markAllAsRead: (0, $cozmU.useCallback)(async (messages)=>{
            const messagesEventPostPayload = messages.map((message)=>{
                const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId } = message;
                if (!messageInstanceId || !messageTemplateId || !placementId) throw new $71f7bbf8faadfbf0$var$MessageLifecycleContextError();
                return {
                    messageInstanceId: message["messageInstanceId"],
                    messageTemplateId: message["messageTemplateId"],
                    type: "read",
                    placement: placementId,
                    createdAt: Date.now(),
                    analyticsDetails: analyticsDetails,
                    context: context
                };
            });
            try {
                await client.markAllAsReadEvent(messagesEventPostPayload);
            } catch (error) {
                throw new $71f7bbf8faadfbf0$var$MessageLifecycleClientError();
            }
        }, [
            client,
            placementId,
            analyticsDetails,
            context
        ]),
        messageRead: (0, $cozmU.useCallback)(async ()=>{
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new $71f7bbf8faadfbf0$var$MessageLifecycleContextError();
            markReadFromPlacement({
                messageInstanceId: messageInstanceId
            });
            try {
                await client.sendEvent({
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    type: "read",
                    placement: placementId,
                    createdAt: Date.now(),
                    analyticsDetails: analyticsDetails,
                    context: context
                });
            } catch (error) {
                throw new $71f7bbf8faadfbf0$var$MessageLifecycleClientError();
            }
        }, [
            client,
            messageInstanceId,
            messageTemplateId,
            placementId,
            analyticsDetails,
            context,
            markReadFromPlacement
        ]),
        messageUnread: (0, $cozmU.useCallback)(async ()=>{
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new $71f7bbf8faadfbf0$var$MessageLifecycleContextError();
            try {
                await client.sendEvent({
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    type: "unread",
                    placement: placementId,
                    createdAt: Date.now(),
                    context: context,
                    analyticsDetails: analyticsDetails
                });
            } catch (error) {
                throw new $71f7bbf8faadfbf0$var$MessageLifecycleClientError();
            }
        }, [
            messageInstanceId,
            messageTemplateId,
            placementId,
            analyticsDetails,
            context
        ]),
        messageViewed: (0, $cozmU.useCallback)(async ()=>{
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new $71f7bbf8faadfbf0$var$MessageLifecycleContextError();
            markViewedFromPlacement({
                messageInstanceId: messageInstanceId
            });
            client.batchSendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                transactionAccountId: transactionAccountId,
                type: "viewed",
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            });
        }, [
            client,
            messageInstanceId,
            messageTemplateId,
            placementId,
            analyticsDetails,
            context,
            transactionAccountId,
            markViewedFromPlacement
        ]),
        messageClicked: (0, $cozmU.useCallback)(async ()=>{
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new $71f7bbf8faadfbf0$var$MessageLifecycleContextError();
            markClickedFromPlacement({
                messageInstanceId: messageInstanceId
            });
            client.batchSendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                transactionAccountId: transactionAccountId,
                type: "clicked",
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            });
        }, [
            client,
            messageInstanceId,
            messageTemplateId,
            placementId,
            analyticsDetails,
            context,
            transactionAccountId,
            markClickedFromPlacement
        ]),
        messageClickedSecondary: (0, $cozmU.useCallback)(async ()=>{
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new $71f7bbf8faadfbf0$var$MessageLifecycleContextError();
            client.batchSendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                transactionAccountId: transactionAccountId,
                type: "clickedSecondary",
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            });
        }, [
            client,
            messageInstanceId,
            messageTemplateId,
            placementId,
            analyticsDetails,
            context,
            transactionAccountId
        ]),
        messageAcknowledged: (0, $cozmU.useCallback)(async ()=>{
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new $71f7bbf8faadfbf0$var$MessageLifecycleContextError();
            client.batchSendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                transactionAccountId: transactionAccountId,
                type: "acknowledged",
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            });
        }, [
            client,
            messageInstanceId,
            messageTemplateId,
            placementId,
            analyticsDetails,
            context,
            transactionAccountId
        ]),
        messageDismissed: (0, $cozmU.useCallback)(async ()=>{
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new $71f7bbf8faadfbf0$var$MessageLifecycleContextError();
            dismissMessageFromPlacement({
                messageInstanceId: messageInstanceId
            });
            client.batchSendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                transactionAccountId: transactionAccountId,
                type: "dismissed",
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            });
        }, [
            client,
            messageInstanceId,
            messageTemplateId,
            placementId,
            analyticsDetails,
            context,
            transactionAccountId,
            dismissMessageFromPlacement
        ]),
        messageSnoozed: (0, $cozmU.useCallback)(async (snoozeDays)=>{
            const MILLIS_IN_A_DAY = 864e5;
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new $71f7bbf8faadfbf0$var$MessageLifecycleContextError();
            snoozeMessageFromPlacement({
                messageInstanceId: messageInstanceId
            });
            const statusExpiryTime = Date.now() + snoozeDays * MILLIS_IN_A_DAY;
            client.batchSendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                transactionAccountId: transactionAccountId,
                type: "snoozed",
                placement: placementId,
                createdAt: Date.now(),
                statusExpiryTime: statusExpiryTime,
                analyticsDetails: analyticsDetails,
                context: context
            });
        }, [
            client,
            messageInstanceId,
            messageTemplateId,
            placementId,
            analyticsDetails,
            context,
            transactionAccountId,
            snoozeMessageFromPlacement
        ])
    };
};
 //# sourceMappingURL=index.mjs.map
module.exports["useMessageEvent"] = $71f7bbf8faadfbf0$export$3cbbf1e81e2ecb39;

});

parcelRegister("lixOz", function(module, exports) {
$parcel$export(module.exports, "useInViewport", () => $f8158248d0f47600$export$6215040b989f9b0f, (v) => $f8158248d0f47600$export$6215040b989f9b0f = v);
var $f8158248d0f47600$export$1e511d4a378977f5;
var $f8158248d0f47600$export$6215040b989f9b0f;
var $f8158248d0f47600$export$436b63fa4855237f;
var $f8158248d0f47600$export$2e2bcd8739ae039;
var $f8158248d0f47600$export$95cef81be5ddcfd4;
"use strict";
$f8158248d0f47600$export$1e511d4a378977f5 = true;
$f8158248d0f47600$export$6215040b989f9b0f = $f8158248d0f47600$export$436b63fa4855237f = $f8158248d0f47600$export$2e2bcd8739ae039 = $f8158248d0f47600$export$95cef81be5ddcfd4 = void 0;

var $f8158248d0f47600$var$_handleViewport = $f8158248d0f47600$var$_interopRequireDefault((parcelRequire("3Tfn6")));
$f8158248d0f47600$export$436b63fa4855237f = $f8158248d0f47600$var$_handleViewport.default;

var $f8158248d0f47600$var$_useInViewport = $f8158248d0f47600$var$_interopRequireDefault((parcelRequire("byriw")));
$f8158248d0f47600$export$6215040b989f9b0f = $f8158248d0f47600$var$_useInViewport.default;
function $f8158248d0f47600$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var $f8158248d0f47600$var$customProps = $f8158248d0f47600$export$95cef81be5ddcfd4 = [
    'inViewport',
    'enterCount',
    'leaveCount'
];
var $f8158248d0f47600$var$_default = $f8158248d0f47600$export$2e2bcd8739ae039 = $f8158248d0f47600$var$_handleViewport.default;

});

parcelRegister("3Tfn6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $2d526ea1e19243c2$export$1e511d4a378977f5, (v) => $2d526ea1e19243c2$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $2d526ea1e19243c2$export$2e2bcd8739ae039, (v) => $2d526ea1e19243c2$export$2e2bcd8739ae039 = v);
var $2d526ea1e19243c2$export$1e511d4a378977f5;
var $2d526ea1e19243c2$export$2e2bcd8739ae039;
"use strict";
$2d526ea1e19243c2$export$1e511d4a378977f5 = true;
$2d526ea1e19243c2$export$2e2bcd8739ae039 = void 0;

var $cozmU = parcelRequire("cozmU");


var $2d526ea1e19243c2$var$_hoistNonReactStatics = $2d526ea1e19243c2$var$_interopRequireDefault((parcelRequire("aH9xZ")));

var $2d526ea1e19243c2$var$_useInViewport = $2d526ea1e19243c2$var$_interopRequireDefault((parcelRequire("byriw")));

var $3dWch = parcelRequire("3dWch");


var $8aG6j = parcelRequire("8aG6j");

var $2d526ea1e19243c2$var$_excluded = [
    "onEnterViewport",
    "onLeaveViewport"
];
function $2d526ea1e19243c2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $2d526ea1e19243c2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $2d526ea1e19243c2$var$_extends() {
    return $2d526ea1e19243c2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2d526ea1e19243c2$var$_extends.apply(null, arguments);
}
function $2d526ea1e19243c2$var$handleViewport(TargetComponent, options, config) {
    if (options === void 0) options = $3dWch.defaultOptions;
    if (config === void 0) config = $3dWch.defaultConfig;
    var ForwardedRefComponent = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
        var refProps = {
            forwardedRef: ref
        };
        return /*#__PURE__*/ (0, $8aG6j.jsx)(TargetComponent, $2d526ea1e19243c2$var$_extends({}, props, refProps));
    });
    var InViewport = (_ref)=>{
        var { onEnterViewport: onEnterViewport = $3dWch.noop, onLeaveViewport: onLeaveViewport = $3dWch.noop } = _ref, restProps = $2d526ea1e19243c2$var$_objectWithoutPropertiesLoose(_ref, $2d526ea1e19243c2$var$_excluded);
        var node = (0, $cozmU.useRef)(null);
        var { inViewport: inViewport, enterCount: enterCount, leaveCount: leaveCount } = (0, $2d526ea1e19243c2$var$_useInViewport.default)(node, options, config, {
            onEnterViewport: onEnterViewport,
            onLeaveViewport: onLeaveViewport
        });
        var props = $2d526ea1e19243c2$var$_extends({}, restProps, {
            inViewport: inViewport,
            enterCount: enterCount,
            leaveCount: leaveCount
        });
        return /*#__PURE__*/ (0, $8aG6j.jsx)(ForwardedRefComponent, $2d526ea1e19243c2$var$_extends({}, props, {
            ref: node
        }));
    };
    var name = TargetComponent.displayName || TargetComponent.name || 'Component';
    InViewport.displayName = "handleViewport(" + name + ")";
    return (0, $2d526ea1e19243c2$var$_hoistNonReactStatics.default)(InViewport, ForwardedRefComponent);
}
var $2d526ea1e19243c2$var$_default = $2d526ea1e19243c2$export$2e2bcd8739ae039 = $2d526ea1e19243c2$var$handleViewport;

});

parcelRegister("byriw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $86980b6f9121fe40$export$1e511d4a378977f5, (v) => $86980b6f9121fe40$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $86980b6f9121fe40$export$2e2bcd8739ae039, (v) => $86980b6f9121fe40$export$2e2bcd8739ae039 = v);
var $86980b6f9121fe40$export$1e511d4a378977f5;
var $86980b6f9121fe40$export$2e2bcd8739ae039;
"use strict";
$86980b6f9121fe40$export$1e511d4a378977f5 = true;
$86980b6f9121fe40$export$2e2bcd8739ae039 = void 0;

var $cozmU = parcelRequire("cozmU");


var $3dWch = parcelRequire("3dWch");

var $86980b6f9121fe40$var$defaultMutationObserverOption = {
    attributes: true,
    childList: true,
    subtree: true
};
var $86980b6f9121fe40$var$useInViewport = function useInViewport(target, options, config, props) {
    if (options === void 0) options = $3dWch.defaultOptions;
    if (config === void 0) config = $3dWch.defaultConfig;
    if (props === void 0) props = $3dWch.defaultProps;
    var { onEnterViewport: onEnterViewport, onLeaveViewport: onLeaveViewport } = props;
    var [, forceUpdate] = (0, $cozmU.useState)();
    var observer = (0, $cozmU.useRef)();
    var inViewportRef = (0, $cozmU.useRef)(false);
    var intersected = (0, $cozmU.useRef)(false);
    var enterCountRef = (0, $cozmU.useRef)(0);
    var leaveCountRef = (0, $cozmU.useRef)(0);
    // State to track when target is available
    var [isTargetReady, setIsTargetReady] = (0, $cozmU.useState)(Boolean(target.current));
    function startObserver(_ref) {
        var { observerRef: observerRef } = _ref;
        var targetRef = target.current;
        if (targetRef) {
            var node = targetRef;
            if (node) observerRef == null || observerRef.observe(node);
        }
    }
    function stopObserver(_ref2) {
        var { observerRef: observerRef } = _ref2;
        var targetRef = target.current;
        if (targetRef) {
            var node = targetRef;
            if (node) observerRef == null || observerRef.unobserve(node);
        }
        observerRef == null || observerRef.disconnect();
        observer.current = null;
    }
    var handleIntersection = (entries)=>{
        var entry = entries[0] || {};
        var { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = entry;
        var isInViewport = typeof isIntersecting !== 'undefined' ? isIntersecting : intersectionRatio > 0;
        // enter
        if (!intersected.current && isInViewport) {
            intersected.current = true;
            onEnterViewport == null || onEnterViewport();
            enterCountRef.current += 1;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
            return;
        }
        // leave
        if (intersected.current && !isInViewport) {
            intersected.current = false;
            onLeaveViewport == null || onLeaveViewport();
            if (config.disconnectOnLeave && observer.current) // disconnect observer on leave
            observer.current.disconnect();
            leaveCountRef.current += 1;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
        }
    };
    function initIntersectionObserver(_ref3) {
        var { observerRef: observerRef } = _ref3;
        if (!observerRef) {
            observer.current = new IntersectionObserver(handleIntersection, options);
            return observer.current;
        }
        return observerRef;
    }
    (0, $cozmU.useEffect)(()=>{
        var observerRef = observer.current;
        // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
        observerRef = initIntersectionObserver({
            observerRef: observerRef
        });
        startObserver({
            observerRef: observerRef
        });
        return ()=>{
            stopObserver({
                observerRef: observerRef
            });
        };
    }, [
        target.current,
        options,
        config,
        onEnterViewport,
        onLeaveViewport
    ]);
    // Use MutationObserver to detect when `target.current` becomes non-null
    // only at start up
    (0, $cozmU.useEffect)(()=>{
        var currentElement = target.current;
        var mutationObserver = null;
        // MutationObserver callback to check when the target ref is assigned
        var handleOnChange = ()=>{
            if (target.current && !isTargetReady) {
                setIsTargetReady(true);
                if (mutationObserver) mutationObserver.disconnect();
            }
        };
        if (currentElement) setIsTargetReady(true); // If target is already available, mark it ready
        else {
            // Observe changes to detect when `target.current` becomes non-null
            mutationObserver = new MutationObserver(handleOnChange);
            mutationObserver.observe(document.body, $86980b6f9121fe40$var$defaultMutationObserverOption);
        }
        // Cleanup function to stop observing when the component unmounts
        return ()=>{
            if (mutationObserver) mutationObserver.disconnect();
        };
    }, [
        target.current
    ]);
    return {
        inViewport: inViewportRef.current,
        enterCount: enterCountRef.current,
        leaveCount: leaveCountRef.current
    };
};
var $86980b6f9121fe40$var$_default = $86980b6f9121fe40$export$2e2bcd8739ae039 = $86980b6f9121fe40$var$useInViewport;

});

parcelRegister("3dWch", function(module, exports) {
$parcel$export(module.exports, "noop", () => $258fbab87dea3908$export$8793edee2d425525, (v) => $258fbab87dea3908$export$8793edee2d425525 = v);
$parcel$export(module.exports, "defaultProps", () => $258fbab87dea3908$export$9c21a3269931e1e6, (v) => $258fbab87dea3908$export$9c21a3269931e1e6 = v);
$parcel$export(module.exports, "defaultOptions", () => $258fbab87dea3908$export$ba43bf67f3d48107, (v) => $258fbab87dea3908$export$ba43bf67f3d48107 = v);
$parcel$export(module.exports, "defaultConfig", () => $258fbab87dea3908$export$f84bd70098573c5c, (v) => $258fbab87dea3908$export$f84bd70098573c5c = v);
var $258fbab87dea3908$export$1e511d4a378977f5;
var $258fbab87dea3908$export$8793edee2d425525;
var $258fbab87dea3908$export$9c21a3269931e1e6;
var $258fbab87dea3908$export$ba43bf67f3d48107;
var $258fbab87dea3908$export$f84bd70098573c5c;
"use strict";
$258fbab87dea3908$export$1e511d4a378977f5 = true;
$258fbab87dea3908$export$8793edee2d425525 = $258fbab87dea3908$export$9c21a3269931e1e6 = $258fbab87dea3908$export$ba43bf67f3d48107 = $258fbab87dea3908$export$f84bd70098573c5c = void 0;
var $258fbab87dea3908$var$defaultOptions = $258fbab87dea3908$export$ba43bf67f3d48107 = {};
var $258fbab87dea3908$var$defaultConfig = $258fbab87dea3908$export$f84bd70098573c5c = {
    disconnectOnLeave: false
};
var $258fbab87dea3908$var$noop = ()=>{};
$258fbab87dea3908$export$8793edee2d425525 = $258fbab87dea3908$var$noop;
var $258fbab87dea3908$var$defaultProps = $258fbab87dea3908$export$9c21a3269931e1e6 = {
    onEnterViewport: $258fbab87dea3908$var$noop,
    onLeaveViewport: $258fbab87dea3908$var$noop
};

});

parcelRegister("1p8wq", function(module, exports) {
//#region src/utils/is-client-triggered-message.ts
/**
* Determines if a message is client-triggered (requires waitForTrigger).
* Client-triggered messages have triggerType of 'gasV3' or 'poTrigger'.
*
* @param triggerType - The trigger type from message context
* @returns true if the message is client-triggered (gasV3 or poTrigger)
*/ const $105ebc83fd8b95ac$export$21c420c0c257c346 = (triggerType)=>{
    if (!triggerType) return false;
    return triggerType === "gasV3" || triggerType === "poTrigger";
};
 //# sourceMappingURL=is-client-triggered-message.mjs.map
module.exports["isClientTriggeredMessage"] = $105ebc83fd8b95ac$export$21c420c0c257c346;

});

parcelRegister("g7aP0", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cXtTj = parcelRequire("cXtTj");


var $aHfj2 = parcelRequire("aHfj2");


var $6NRmI = parcelRequire("6NRmI");


var $cozmU = parcelRequire("cozmU");

const $2adf26225a469e82$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return null;
};
const $2adf26225a469e82$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $6NRmI.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $aHfj2.useFirePostOfficeAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $cXtTj.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $cXtTj.default).checkGate('enable_choreographed_post_office_messages');
    const useMessageTemplateIdAsChoreographerMessageId = (0, $cXtTj.default).checkGate('post-office_use_template_id_for_choreo');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) {
            // Use messageTemplateId as choreographer messageId when feature flag is enabled,
            // otherwise use the original messageId (messageInstanceId) for backward compatibility
            const choreographerMessageId = useMessageTemplateIdAsChoreographerMessageId ? messageTemplateId : messageId;
            return /*#__PURE__*/ (0, $8aG6j.jsx)($2adf26225a469e82$var$ChoreographedComponent, {
                choreographerFactory: factory,
                messageId: choreographerMessageId,
                children: children
            });
        }
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
module.exports["ChoreographerWrapper"] = $2adf26225a469e82$export$8db7ba034addcd65;

});

parcelRegister("6l4K1", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

//#region src/message-renderer-provider/maybe-choreographer-wrapper.tsx
/**
* Conditionally wraps `children` in the supplied `ChoreographerWrapper` component when `enabled`
* is true (typically: non client-triggered messages), otherwise renders `children` unchanged.
* Client-triggered messages skip the outer choreographer because they handle their own
* choreography internally via `waitForTrigger`.
*
* The choreographer wrapper is passed in via the `ChoreographerWrapper` prop (rather than
* imported here) so the V1 and V2 message renderers each continue using their own sibling
* `ChoreographerWrapper`. This keeps each package's `jest.spyOn(<own module>,
* 'ChoreographerWrapper')` working unchanged, avoids any cross-package call routing that would
* be invisible at the renderer's call site, and isolates this file to the only piece of logic
* that is genuinely shared — the "wrap when enabled, passthrough otherwise" branch.
*/ const $49d861c416ed9629$export$738797901aa9197a = ({ ChoreographerWrapper: ChoreographerWrapper, enabled: enabled, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, children: children })=>{
    if (!enabled) return /* @__PURE__ */ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return /* @__PURE__ */ (0, $8aG6j.jsx)(ChoreographerWrapper, {
        messageId: messageId,
        messageTemplateId: messageTemplateId,
        messageCategory: messageCategory,
        children: children
    });
};
 //# sourceMappingURL=maybe-choreographer-wrapper.mjs.map
module.exports["MaybeChoreographerWrapper"] = $49d861c416ed9629$export$738797901aa9197a;

});

parcelRegister("gfQZH", function(module, exports) {

var $6NRmI = parcelRequire("6NRmI");


var $cozmU = parcelRequire("cozmU");


var $aHfj2 = parcelRequire("aHfj2");


var $j4yZr = parcelRequire("j4yZr");


var $h2UfS = parcelRequire("h2UfS");

//#region src/hooks/utils.ts
const $bd572791806bd7f6$var$resStatusAsString = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $bd572791806bd7f6$var$assertResponseIsOk = (res)=>{
    if (res.ok) return res;
    throw new Error($bd572791806bd7f6$var$resStatusAsString(res));
};
const $bd572791806bd7f6$var$toLoading = ()=>({
        isLoading: true,
        data: void 0,
        error: void 0
    });
const $bd572791806bd7f6$var$toError = (error)=>({
        isLoading: false,
        error: error instanceof Error ? error : Error(String(error)),
        data: void 0
    });
const $bd572791806bd7f6$var$toData = (data)=>({
        isLoading: false,
        error: void 0,
        data: data
    });
//#endregion
//#region src/hooks/useData.ts
var $bd572791806bd7f6$var$AlreadyRunningError = class extends Error {
    constructor(){
        super("Request is already running.");
        this.name = "AlreadyRunningError";
    }
};
const $bd572791806bd7f6$export$c1cf1cf4c5d51937 = (promiseToResolve, options)=>{
    const [state, setState] = (0, $cozmU.useState)($bd572791806bd7f6$var$toLoading());
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $aHfj2.useFirePostOfficeAnalyticsEvents)();
    const { name: analyticsSubjectId, ...analyticsAttributes } = options?.analytics ?? {
        name: "unknown"
    };
    (0, $cozmU.useEffect)(()=>{
        if (typeof promiseToResolve !== "function") return;
        const abortController = new AbortController();
        const { signal: signal } = abortController;
        promiseToResolve({
            signal: signal
        })?.then(async (res)=>{
            if (!res) return;
            if ($bd572791806bd7f6$var$assertResponseIsOk(res)) {
                const data = await res.json();
                setState($bd572791806bd7f6$var$toData(data));
                fireAnalyticsEvent({
                    action: "resolved",
                    actionSubject: "dataPromise",
                    actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($j4yZr)))(analyticsSubjectId) + "DataPromise",
                    eventType: "operational",
                    attributes: {
                        ...analyticsAttributes
                    }
                });
            }
        }).catch((err)=>{
            if (err instanceof $bd572791806bd7f6$var$AlreadyRunningError || signal.aborted) return;
            const errorState = $bd572791806bd7f6$var$toError(err);
            fireAnalyticsEvent({
                action: "rejected",
                actionSubject: "dataPromise",
                actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($j4yZr)))(analyticsSubjectId) + "DataPromise",
                eventType: "operational",
                attributes: {
                    ...analyticsAttributes,
                    errorName: errorState.error.name ?? "unknown",
                    errorMessage: errorState.error.message ?? "unknown"
                }
            });
            setState(errorState);
        });
        return ()=>{
            abortController.abort();
        };
    }, [
        promiseToResolve
    ]);
    return state;
};
//#endregion
//#region src/hooks/useInitialData.ts
const $bd572791806bd7f6$export$5523c5f3222291d0 = (initialData)=>{
    const initialDataCallback = (0, $cozmU.useMemo)(()=>{
        if (typeof initialData === "undefined") return;
        return ()=>initialData;
    }, [
        initialData
    ]);
    return $bd572791806bd7f6$export$c1cf1cf4c5d51937(initialDataCallback, {
        analytics: {
            name: "initialData"
        }
    });
};
//#endregion
//#region src/hooks/usePlacement.ts
const $bd572791806bd7f6$export$ee1d67e435d25cb5 = (placementId, fetcher = {
    fetch: (...args)=>globalThis.fetch(...args)
})=>{
    if (!fetcher.fetch) throw new Error("No fetcher found. If you are using usePlacement outside or a browser you must supply a fetcher yourself");
    return (path, context, requestOptions, config)=>{
        const timerRef = (0, $cozmU.useRef)();
        const isRunningPromise = (0, $cozmU.useRef)(false);
        (0, $cozmU.useEffect)(()=>{
            return ()=>{
                if (timerRef.current) clearTimeout(timerRef.current);
            };
        }, []);
        const promiseToResolve = (0, $cozmU.useMemo)(()=>{
            if (config?.isEnabled === false) return;
            return ({ signal: signal })=>{
                if (isRunningPromise.current) return Promise.reject(new $bd572791806bd7f6$var$AlreadyRunningError());
                isRunningPromise.current = true;
                timerRef.current = setTimeout(()=>{
                    isRunningPromise.current = false;
                }, config?.throttleTime ?? 0);
                return (0, $h2UfS.fetchPlacementData)(placementId, path, context, fetcher, {
                    ...requestOptions,
                    signal: signal
                });
            };
        }, [
            config?.deps,
            path
        ]);
        return $bd572791806bd7f6$export$c1cf1cf4c5d51937(promiseToResolve, {
            analytics: {
                name: placementId,
                path: path
            }
        });
    };
};
//#endregion
//#region src/hooks/useDisableChoreographer.ts
const $bd572791806bd7f6$export$11054bdfeabc9c6f = ()=>{
    const { setChoreographerEnabled: setChoreographerEnabled } = (0, $6NRmI.useChoreographerContext)();
    (0, $cozmU.useEffect)(()=>{
        setChoreographerEnabled(false);
    }, []);
};
 //# sourceMappingURL=hooks.mjs.map
module.exports["useInitialData"] = $bd572791806bd7f6$export$5523c5f3222291d0;
module.exports["createUsePlacement"] = $bd572791806bd7f6$export$ee1d67e435d25cb5;

});

parcelRegister("h2UfS", function(module, exports) {

var $dBFrb = parcelRequire("dBFrb");

const $37087aade39ee2a6$export$2e74004b635d08aa = `/gateway/api/post-office/api/v1/placements/`;
const $37087aade39ee2a6$export$ce743d02f83ee521 = (placementId, path, context, fetcher, requestOptions)=>{
    const defaultHeaders = {
        credentials: 'include',
        mode: 'cors',
        'Content-Type': 'application/json'
    };
    const normalizedPath = path === '' || path === '/' ? '' : `/${path.charAt(0) === '/' ? path.substring(1) : path}`;
    const queryParams = (0, $dBFrb.buildSearchParams)(context);
    const contextAsSearchParams = queryParams.toString();
    const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
    const url = encodeURI(`${$37087aade39ee2a6$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
    return fetcher.fetch(url, {
        ...requestOptions,
        headers: {
            ...defaultHeaders,
            ...requestOptions?.headers
        }
    });
};
module.exports["fetchPlacementData"] = $37087aade39ee2a6$export$ce743d02f83ee521;

});

parcelRegister("akYdf", function(module, exports) {

let $786a7aa05880157c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $786a7aa05880157c$var$load("euQDG").then(()=>parcelRequire('ladbN'));

});

parcelRegister("lvMF9", function(module, exports) {

let $fa923d9dabc56e07$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fa923d9dabc56e07$var$load("c5xfp").then(()=>parcelRequire('9LuQs'));

});

parcelRegister("kqpHz", function(module, exports) {

let $edea2c30f8de8de1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $edea2c30f8de8de1$var$load("h5f5q").then(()=>parcelRequire('3vc5a'));

});

parcelRegister("8VcfZ", function(module, exports) {

let $67ed278c533c5fa5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $67ed278c533c5fa5$var$load("aNATs").then(()=>parcelRequire('izrYO'));

});

parcelRegister("kIyJU", function(module, exports) {

let $f152dd389d4b31bb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f152dd389d4b31bb$var$load("iepbm").then(()=>parcelRequire('f8bSH'));

});

parcelRegister("iM7Ej", function(module, exports) {

let $dab2a4a8c20a398b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dab2a4a8c20a398b$var$load("hf1R0").then(()=>parcelRequire('aqEDi'));

});

parcelRegister("gUOKX", function(module, exports) {

let $c5093f78b4df5351$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c5093f78b4df5351$var$load("eWwgD").then(()=>parcelRequire('bs890'));

});

parcelRegister("16MwB", function(module, exports) {

let $0cebfe0604bd76a0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0cebfe0604bd76a0$var$load("kCFQG").then(()=>parcelRequire('8H6xv'));

});

parcelRegister("7tCfz", function(module, exports) {

let $5718e98a5cd862d9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5718e98a5cd862d9$var$load("hJHcU").then(()=>parcelRequire('9SPGe'));

});

parcelRegister("drLlu", function(module, exports) {

let $9ca285cf93eaed48$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9ca285cf93eaed48$var$load("cK9ry").then(()=>parcelRequire('gxmER'));

});

parcelRegister("aodZl", function(module, exports) {

let $7906ff1731bf0b6f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7906ff1731bf0b6f$var$load("bn5cc").then(()=>parcelRequire('ji2nX'));

});

parcelRegister("jcbnX", function(module, exports) {

let $df97f8328ef4b041$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $df97f8328ef4b041$var$load("lcCAy").then(()=>parcelRequire('ipy33'));

});

parcelRegister("04kNl", function(module, exports) {

let $00d0814ab7b38a9f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $00d0814ab7b38a9f$var$load("cMvkf").then(()=>parcelRequire('2Eqgi'));

});

parcelRegister("4sOmk", function(module, exports) {

let $3400d73ffb62fd5e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3400d73ffb62fd5e$var$load("jzwOL").then(()=>parcelRequire('bEtU9'));

});

parcelRegister("jI7Xz", function(module, exports) {

let $e5984d07e239b35c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e5984d07e239b35c$var$load("8O3Uy").then(()=>parcelRequire('1iAhR'));

});

parcelRegister("96uhU", function(module, exports) {

let $6a0c2b23656d1d24$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6a0c2b23656d1d24$var$load("7Odh4").then(()=>parcelRequire('3K89L'));

});

parcelRegister("d2Z9e", function(module, exports) {

let $97fae4f7446de880$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $97fae4f7446de880$var$load("ghHBJ").then(()=>parcelRequire('86h2A'));

});

parcelRegister("jOQRj", function(module, exports) {

let $e6dbb0838a205ffb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e6dbb0838a205ffb$var$load("10K40").then(()=>parcelRequire('9SPU4'));

});

parcelRegister("9Jdil", function(module, exports) {

let $7152a11b4405fc00$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7152a11b4405fc00$var$load("5PVmS").then(()=>parcelRequire('6EonI'));

});

parcelRegister("hNsLK", function(module, exports) {

let $cf4d5438ed7ba07a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cf4d5438ed7ba07a$var$load("dCKoW").then(()=>parcelRequire('5UVoK'));

});

parcelRegister("fSfFb", function(module, exports) {

let $b8e80c94a05dabaa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b8e80c94a05dabaa$var$load("9Qd4N").then(()=>parcelRequire('lhL27'));

});

parcelRegister("lpr3v", function(module, exports) {

let $f960eb6ee4de46e3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f960eb6ee4de46e3$var$load("9CH7J").then(()=>parcelRequire('8fEpm'));

});

parcelRegister("kefFC", function(module, exports) {

let $eba1454194279c07$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eba1454194279c07$var$load("9recn").then(()=>parcelRequire('gt6Wi'));

});

parcelRegister("9ye8Q", function(module, exports) {

let $6f42424ba1000c76$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6f42424ba1000c76$var$load("gIwVL").then(()=>parcelRequire('95wrf'));

});

parcelRegister("2X25C", function(module, exports) {

let $2262b667cbf4104d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2262b667cbf4104d$var$load("aWmB3").then(()=>parcelRequire('cX2Xm'));

});

parcelRegister("l37gC", function(module, exports) {

let $f52f83e4d6490c89$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f52f83e4d6490c89$var$load("cuarN").then(()=>parcelRequire('kYIr9'));

});

parcelRegister("gE6P6", function(module, exports) {

let $c1e5acb6eda9fb17$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c1e5acb6eda9fb17$var$load("3w3Lf").then(()=>parcelRequire('a7vD4'));

});

parcelRegister("TsHLR", function(module, exports) {

let $0a6b67616a886738$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0a6b67616a886738$var$load("kBatH"),
    $0a6b67616a886738$var$load("5bGEM")
]).then(()=>parcelRequire('5xGss'));

});

parcelRegister("1zg1j", function(module, exports) {

let $12457c9ce3bb5fd5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $12457c9ce3bb5fd5$var$load("i7bfr").then(()=>parcelRequire('8DJ5H'));

});

parcelRegister("4oES9", function(module, exports) {

let $33391bb890f420de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $33391bb890f420de$var$load("2AWp7").then(()=>parcelRequire('2tt2w'));

});

parcelRegister("b8UKN", function(module, exports) {

let $81cc7732df9e7f52$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $81cc7732df9e7f52$var$load("8UDB0").then(()=>parcelRequire('2CZFJ'));

});

parcelRegister("5ty5K", function(module, exports) {

let $3fca1b1be2b12f68$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3fca1b1be2b12f68$var$load("3hcNr").then(()=>parcelRequire('a3wxG'));

});

parcelRegister("3yrzt", function(module, exports) {

let $2969ef2768c71540$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2969ef2768c71540$var$load("6wr18"),
    $2969ef2768c71540$var$load("63q9w"),
    $2969ef2768c71540$var$load("e00ow"),
    $2969ef2768c71540$var$load("ffEVr"),
    $2969ef2768c71540$var$load("jKavk")
]).then(()=>parcelRequire('5qn5Y'));

});

parcelRegister("b1mpA", function(module, exports) {

let $80612c2f97542fdb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $80612c2f97542fdb$var$load("alfJN"),
    $80612c2f97542fdb$var$load("bewN4")
]).then(()=>parcelRequire('dujcx'));

});

parcelRegister("kG8cA", function(module, exports) {

let $f0de17a6c62222a7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f0de17a6c62222a7$var$load("1ll9c").then(()=>parcelRequire('eDiDN'));

});

parcelRegister("1u6TY", function(module, exports) {

let $114df253333a3a38$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $114df253333a3a38$var$load("dMEDW").then(()=>parcelRequire('ha4VZ'));

});

parcelRegister("5fNzV", function(module, exports) {

let $3d34cfb53c1e2f52$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3d34cfb53c1e2f52$var$load("fenbO").then(()=>parcelRequire('2BarZ'));

});

parcelRegister("a9DE8", function(module, exports) {

let $76497f9200fda7d6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $76497f9200fda7d6$var$load("bSvCi").then(()=>parcelRequire('bXjqC'));

});

parcelRegister("fbFbW", function(module, exports) {

let $b0e7d5e35c25d44a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b0e7d5e35c25d44a$var$load("4Ngka").then(()=>parcelRequire('6TyRF'));

});

parcelRegister("5IcfZ", function(module, exports) {

let $428a91c952c6a455$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $428a91c952c6a455$var$load("6wr18"),
    $428a91c952c6a455$var$load("7EorR"),
    $428a91c952c6a455$var$load("8YxM8"),
    $428a91c952c6a455$var$load("ffEVr"),
    $428a91c952c6a455$var$load("alfJN"),
    $428a91c952c6a455$var$load("63q9w"),
    $428a91c952c6a455$var$load("cIssl"),
    $428a91c952c6a455$var$load("60R8b")
]).then(()=>parcelRequire('beTZ0'));

});

parcelRegister("5pIHD", function(module, exports) {

let $3f11f69b124bd82b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3f11f69b124bd82b$var$load("6wr18"),
    $3f11f69b124bd82b$var$load("7EorR"),
    $3f11f69b124bd82b$var$load("8YxM8"),
    $3f11f69b124bd82b$var$load("ffEVr"),
    $3f11f69b124bd82b$var$load("alfJN"),
    $3f11f69b124bd82b$var$load("63q9w"),
    $3f11f69b124bd82b$var$load("cIssl")
]).then(()=>parcelRequire('gHYOw'));

});

parcelRegister("68rmX", function(module, exports) {

let $4778b8648f60830e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4778b8648f60830e$var$load("6wr18"),
    $4778b8648f60830e$var$load("7EorR"),
    $4778b8648f60830e$var$load("8YxM8"),
    $4778b8648f60830e$var$load("ffEVr"),
    $4778b8648f60830e$var$load("alfJN"),
    $4778b8648f60830e$var$load("63q9w"),
    $4778b8648f60830e$var$load("is6Xk")
]).then(()=>parcelRequire('3asRP'));

});

parcelRegister("HP62w", function(module, exports) {

let $083ba6f356d3c63c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $083ba6f356d3c63c$var$load("j9dgA").then(()=>parcelRequire('la1DB'));

});

parcelRegister("hG4QL", function(module, exports) {

let $cdea1f023372ccb1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cdea1f023372ccb1$var$load("fLME2"),
    $cdea1f023372ccb1$var$load("deRdB"),
    $cdea1f023372ccb1$var$load("9f9CJ")
]).then(()=>parcelRequire('i6JU0'));

});

parcelRegister("Ijp39", function(module, exports) {

let $085329369c150e2f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $085329369c150e2f$var$load("4dkxU").then(()=>parcelRequire('gCH0f'));

});

parcelRegister("iQvb4", function(module, exports) {

let $db8544871c946b0a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $db8544871c946b0a$var$load("bGK9o").then(()=>parcelRequire('8wHPX'));

});

parcelRegister("hQgYM", function(module, exports) {

let $cfd476c3427ac7c5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cfd476c3427ac7c5$var$load("agw1u").then(()=>parcelRequire('1YIuM'));

});

parcelRegister("9Ngej", function(module, exports) {

let $7215478c10c194a8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7215478c10c194a8$var$load("e9Gaa").then(()=>parcelRequire('fhCIY'));

});

parcelRegister("bOWz0", function(module, exports) {

let $89b1cabb90b1d016$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $89b1cabb90b1d016$var$load("5k22f"),
    $89b1cabb90b1d016$var$load("jb4U5")
]).then(()=>parcelRequire('kivHf'));

});

parcelRegister("js75E", function(module, exports) {

let $e29621c6f967bfe8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e29621c6f967bfe8$var$load("8jr2Q").then(()=>parcelRequire('fcLee'));

});

parcelRegister("gjWy6", function(module, exports) {

let $be1bd65518ede712$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $be1bd65518ede712$var$load("kNToB").then(()=>parcelRequire('9ioMD'));

});

parcelRegister("6wCsT", function(module, exports) {

let $4c039190c9dacfd8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4c039190c9dacfd8$var$load("4DjEE").then(()=>parcelRequire('iLS8a'));

});

parcelRegister("kioN8", function(module, exports) {

let $ec68b8240fbbad94$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ec68b8240fbbad94$var$load("2K7Mk"),
    $ec68b8240fbbad94$var$load("l8DDU"),
    $ec68b8240fbbad94$var$load("1p6D5")
]).then(()=>parcelRequire('ewGhr'));

});

parcelRegister("iUEn1", function(module, exports) {

let $dc4cc5a8bcf1de8c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $dc4cc5a8bcf1de8c$var$load("2K7Mk"),
    $dc4cc5a8bcf1de8c$var$load("l8DDU"),
    $dc4cc5a8bcf1de8c$var$load("9P0i8")
]).then(()=>parcelRequire('ivytD'));

});

parcelRegister("b5lrF", function(module, exports) {

let $8120cbe70267d5c4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8120cbe70267d5c4$var$load("2K7Mk"),
    $8120cbe70267d5c4$var$load("l8DDU"),
    $8120cbe70267d5c4$var$load("f3BNu")
]).then(()=>parcelRequire('6M9Ea'));

});

parcelRegister("hbhxM", function(module, exports) {

let $c8211295fbe5db1a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c8211295fbe5db1a$var$load("lywMT").then(()=>parcelRequire('fTRKE'));

});

parcelRegister("4o0P9", function(module, exports) {

let $331a0af1b284990c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $331a0af1b284990c$var$load("hhss7"),
    $331a0af1b284990c$var$load("E8tDv")
]).then(()=>parcelRequire('bI9OO'));

});

parcelRegister("1hX93", function(module, exports) {

let $0f0541f84593c07f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0f0541f84593c07f$var$load("deRdB"),
    $0f0541f84593c07f$var$load("lMOk9")
]).then(()=>parcelRequire('crj98'));

});

parcelRegister("hDwOy", function(module, exports) {

let $03504022da5d263a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $03504022da5d263a$var$load("7Sty7").then(()=>parcelRequire('gQx1o'));

});

parcelRegister("8xMKh", function(module, exports) {

let $638737a6f0306c80$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $638737a6f0306c80$var$load("8nv8W").then(()=>parcelRequire('9WA7x'));

});

parcelRegister("8pT27", function(module, exports) {

let $620b58fcdf139942$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $620b58fcdf139942$var$load("4Pq08"),
    $620b58fcdf139942$var$load("2dRiZ")
]).then(()=>parcelRequire('eSCcy'));

});

parcelRegister("kio1C", function(module, exports) {

let $ec681ff6990ccefc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ec681ff6990ccefc$var$load("dLaMq").then(()=>parcelRequire('cG693'));

});

parcelRegister("gfw4h", function(module, exports) {

let $bd46ec134ba05bde$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bd46ec134ba05bde$var$load("d8mrd").then(()=>parcelRequire('9mhnB'));

});

parcelRegister("hbRQf", function(module, exports) {

let $c83d3a94674558e7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c83d3a94674558e7$var$load("iqGsY").then(()=>parcelRequire('lLqYF'));

});

parcelRegister("7pPRq", function(module, exports) {

let $566318ace9101cd4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $566318ace9101cd4$var$load("gPxSC").then(()=>parcelRequire('6audw'));

});

parcelRegister("hl7od", function(module, exports) {

let $c9fa21405f7de3ae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c9fa21405f7de3ae$var$load("exWiR").then(()=>parcelRequire('lKPPC'));

});

parcelRegister("a7REi", function(module, exports) {

let $75f42c6041b9a272$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $75f42c6041b9a272$var$load("259SL").then(()=>parcelRequire('kdxyO'));

});

parcelRegister("doOUt", function(module, exports) {

let $9c1501e3861c6fe8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9c1501e3861c6fe8$var$load("jhmYA").then(()=>parcelRequire('dP6DD'));

});

parcelRegister("lXnAF", function(module, exports) {

let $ffc16836753d1079$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ffc16836753d1079$var$load("fe8Vi").then(()=>parcelRequire('5TSBI'));

});

parcelRegister("1nz0n", function(module, exports) {

let $101317b17d36b050$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $101317b17d36b050$var$load("4prFw").then(()=>parcelRequire('58e3q'));

});

parcelRegister("jRQub", function(module, exports) {

let $e76bae2b5cea8775$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e76bae2b5cea8775$var$load("6lPy7").then(()=>parcelRequire('cK86V'));

});

parcelRegister("5e1aL", function(module, exports) {

let $3cdf2b6fd42b42ed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3cdf2b6fd42b42ed$var$load("1bzlJ").then(()=>parcelRequire('j4Jti'));

});

parcelRegister("9jKBC", function(module, exports) {

let $6c8a0a55e8032103$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6c8a0a55e8032103$var$load("150Hv").then(()=>parcelRequire('eEhkb'));

});

parcelRegister("20CQe", function(module, exports) {

let $1769b5f29273f097$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1769b5f29273f097$var$load("1ps2b").then(()=>parcelRequire('liPJQ'));

});

parcelRegister("72pu6", function(module, exports) {

let $51fc7cfd31993e90$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $51fc7cfd31993e90$var$load("gd4T0").then(()=>parcelRequire('ijpG3'));

});

parcelRegister("9yg4r", function(module, exports) {

let $01cb6a580843debe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $01cb6a580843debe$var$load("hy25J").then(()=>parcelRequire('y5TQ4'));

});

parcelRegister("8aSEo", function(module, exports) {

let $5f39a65a542125df$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5f39a65a542125df$var$load("4gQ0g").then(()=>parcelRequire('cOWeu'));

});

parcelRegister("6F7Hq", function(module, exports) {

let $4d9c8b560b82adb9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4d9c8b560b82adb9$var$load("h6ZlO").then(()=>parcelRequire('jHIaa'));

});

parcelRegister("iEC4s", function(module, exports) {

let $d9497e7fd0be55a9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d9497e7fd0be55a9$var$load("bIT1G").then(()=>parcelRequire('kbY8Y'));

});

parcelRegister("dGdpq", function(module, exports) {

let $9f599963a0026725$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9f599963a0026725$var$load("dTC2n").then(()=>parcelRequire('1NEqo'));

});

parcelRegister("95IHj", function(module, exports) {

let $69e740ae10c5107b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $69e740ae10c5107b$var$load("kuaiI").then(()=>parcelRequire('iQ6VV'));

});

parcelRegister("4BIn1", function(module, exports) {

let $35ad09232b3ae75d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $35ad09232b3ae75d$var$load("6LRul").then(()=>parcelRequire('cUKV8'));

});

parcelRegister("hxkIJ", function(module, exports) {

let $cc45976244cfefe8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cc45976244cfefe8$var$load("8VmXM").then(()=>parcelRequire('8wtSZ'));

});

parcelRegister("8To3x", function(module, exports) {

let $67961ed1c69135fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $67961ed1c69135fc$var$load("4u0Vj").then(()=>parcelRequire('1Xrt4'));

});

parcelRegister("5OQC6", function(module, exports) {

let $43ca6f3c6a227f00$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $43ca6f3c6a227f00$var$load("9tLH5").then(()=>parcelRequire('76z5a'));

});

parcelRegister("fvpvd", function(module, exports) {

let $b49d888699cd5f02$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b49d888699cd5f02$var$load("5Skmw").then(()=>parcelRequire('ixFhm'));

});

parcelRegister("iIKcH", function(module, exports) {

let $da102d2ec872fb37$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $da102d2ec872fb37$var$load("3UBrA").then(()=>parcelRequire('a1s3K'));

});

parcelRegister("3pcqi", function(module, exports) {

let $27ad57e40eb5c133$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $27ad57e40eb5c133$var$load("kg55A").then(()=>parcelRequire('hZbkE'));

});

parcelRegister("kEMl5", function(module, exports) {

let $f09d0a3b9585a84e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f09d0a3b9585a84e$var$load("dTc56").then(()=>parcelRequire('8hhWO'));

});

parcelRegister("cQEz0", function(module, exports) {

let $95a9ce7a122d098b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $95a9ce7a122d098b$var$load("27n0o").then(()=>parcelRequire('4fk1U'));

});

parcelRegister("2rla6", function(module, exports) {

let $1c6e84b30c5a212f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1c6e84b30c5a212f$var$load("6TKsl").then(()=>parcelRequire('1F4gt'));

});

parcelRegister("64lbb", function(module, exports) {

let $46b38b93e6146112$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $46b38b93e6146112$var$load("8uTI1").then(()=>parcelRequire('bP19W'));

});

parcelRegister("OV8r1", function(module, exports) {

let $0990fd74e5780bb2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0990fd74e5780bb2$var$load("krNw5").then(()=>parcelRequire('7pSGJ'));

});

parcelRegister("eNTpv", function(module, exports) {

let $ac709fa8cf5f225e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ac709fa8cf5f225e$var$load("6wr18"),
    $ac709fa8cf5f225e$var$load("ffEVr"),
    $ac709fa8cf5f225e$var$load("e00ow"),
    $ac709fa8cf5f225e$var$load("gnVZR")
]).then(()=>parcelRequire('lAOH0'));

});

parcelRegister("6Rp58", function(module, exports) {

let $0149fc7bf2da736a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0149fc7bf2da736a$var$load("cvqAO").then(()=>parcelRequire('6CqTn'));

});

parcelRegister("4Z92t", function(module, exports) {

let $3a13dedfa2d19a85$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3a13dedfa2d19a85$var$load("l0cN2").then(()=>parcelRequire('b7WVl'));

});

parcelRegister("8lUMZ", function(module, exports) {

let $614c5603fe113d3d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $614c5603fe113d3d$var$load("aMQbl").then(()=>parcelRequire('2ZEis'));

});

parcelRegister("dvWh4", function(module, exports) {

let $9d6b5fb172bc5626$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9d6b5fb172bc5626$var$load("jJ9WO").then(()=>parcelRequire('7nyii'));

});

parcelRegister("dVkYh", function(module, exports) {

let $a230ddb409ddc801$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a230ddb409ddc801$var$load("fLME2"),
    $a230ddb409ddc801$var$load("5vnv3")
]).then(()=>parcelRequire('6IQ7q'));

});

parcelRegister("lLPkH", function(module, exports) {

let $fd95ce635e9b88ea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fd95ce635e9b88ea$var$load("gsTRc").then(()=>parcelRequire('iQlQW'));

});

parcelRegister("gox8X", function(module, exports) {

let $03148698125697ad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $03148698125697ad$var$load("88Ld5").then(()=>parcelRequire('78MMN'));

});

parcelRegister("lyjZN", function(module, exports) {

let $fb0c48ae3033fcf1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fb0c48ae3033fcf1$var$load("bT5Fb").then(()=>parcelRequire('gzZPE'));

});

parcelRegister("hhPGR", function(module, exports) {

let $c95c1ecc6e58ad4a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c95c1ecc6e58ad4a$var$load("A730b").then(()=>parcelRequire('bvt03'));

});

parcelRegister("7H2QT", function(module, exports) {

let $599ec2e75f74d6eb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $599ec2e75f74d6eb$var$load("kvDgi").then(()=>parcelRequire('6mmwO'));

});

parcelRegister("3M2FJ", function(module, exports) {

let $2bf7ed6d42a42e53$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2bf7ed6d42a42e53$var$load("inHtj").then(()=>parcelRequire('e54Mi'));

});

parcelRegister("aoisw", function(module, exports) {

let $790a76dee04d96a2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $790a76dee04d96a2$var$load("bQKXB").then(()=>parcelRequire('a9PEP'));

});

parcelRegister("axN0I", function(module, exports) {

let $7ad300ea11f97d60$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7ad300ea11f97d60$var$load("7VkXe").then(()=>parcelRequire('hI9zk'));

});

parcelRegister("2S5mH", function(module, exports) {

let $2174c953b08abe01$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2174c953b08abe01$var$load("acDyP").then(()=>parcelRequire('jFfCE'));

});

parcelRegister("3pAtC", function(module, exports) {

let $27c0006e9ef08033$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $27c0006e9ef08033$var$load("c2Uej").then(()=>parcelRequire('28zmI'));

});

parcelRegister("eaVnl", function(module, exports) {

let $a51e816f177b81fa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a51e816f177b81fa$var$load("hPAxN").then(()=>parcelRequire('fyvpZ'));

});

parcelRegister("5AtIC", function(module, exports) {

let $41175e0a745de899$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $41175e0a745de899$var$load("4OKLJ").then(()=>parcelRequire('dgu1c'));

});

parcelRegister("bsVJx", function(module, exports) {

let $858f17eb6a1d5478$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $858f17eb6a1d5478$var$load("7wfih").then(()=>parcelRequire('fFJDf'));

});

parcelRegister("hl2or", function(module, exports) {

let $c9f6411801c4eb2c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c9f6411801c4eb2c$var$load("fUWxf"),
    $c9f6411801c4eb2c$var$load("lpnhD"),
    $c9f6411801c4eb2c$var$load("1bEie")
]).then(()=>parcelRequire('21un0'));

});

parcelRegister("8BCeg", function(module, exports) {

let $643f6eee0873df2c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $643f6eee0873df2c$var$load("4Pq08"),
    $643f6eee0873df2c$var$load("lBPbW")
]).then(()=>parcelRequire('5NRnf'));

});

parcelRegister("cMQQT", function(module, exports) {

let $94f2f713cfa87217$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $94f2f713cfa87217$var$load("1ksMZ").then(()=>parcelRequire('jVlIb'));

});

parcelRegister("c2XVQ", function(module, exports) {

let $8c542935265892d2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8c542935265892d2$var$load("6wr18"),
    $8c542935265892d2$var$load("ffEVr"),
    $8c542935265892d2$var$load("zhROw")
]).then(()=>parcelRequire('envni'));

});

parcelRegister("6JKcV", function(module, exports) {

let $4e7ac9e0fe822402$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4e7ac9e0fe822402$var$load("fLTw7").then(()=>parcelRequire('gcgHD'));

});

parcelRegister("9Dx2i", function(module, exports) {

let $01cf8193f20b3df2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $01cf8193f20b3df2$var$load("fPpz5").then(()=>parcelRequire('5yShf'));

});

parcelRegister("6fJFQ", function(module, exports) {

let $48d792ad793e3a43$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $48d792ad793e3a43$var$load("eTEia").then(()=>parcelRequire('b6ilL'));

});

parcelRegister("EvCCI", function(module, exports) {

let $079c44011372e3a3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $079c44011372e3a3$var$load("gI9zw").then(()=>parcelRequire('51djL'));

});

parcelRegister("33XCl", function(module, exports) {

let $23afe5ae7980ff62$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $23afe5ae7980ff62$var$load("5sX9V").then(()=>parcelRequire('1GqEu'));

});

parcelRegister("fcrtA", function(module, exports) {

let $b10d4a3676796e5e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b10d4a3676796e5e$var$load("7e69v").then(()=>parcelRequire('dRAfE'));

});

parcelRegister("lVNzU", function(module, exports) {

let $ff75610c0f1363fe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ff75610c0f1363fe$var$load("iqkaY").then(()=>parcelRequire('iYFyy'));

});

parcelRegister("3DW81", function(module, exports) {

let $2a721ab5df606d76$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2a721ab5df606d76$var$load("7Mx65").then(()=>parcelRequire('bkdiP'));

});

parcelRegister("ez7mF", function(module, exports) {

let $a9aa0c0709b1ab86$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a9aa0c0709b1ab86$var$load("e6Ade").then(()=>parcelRequire('i2qpQ'));

});

parcelRegister("8uN0M", function(module, exports) {

let $62f724c35a4d7cf8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $62f724c35a4d7cf8$var$load("68RdC").then(()=>parcelRequire('9Dcag'));

});

parcelRegister("iAv3R", function(module, exports) {

let $d883aeeca726fe32$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d883aeeca726fe32$var$load("gIivJ").then(()=>parcelRequire('fCmlM'));

});

parcelRegister("gU4dn", function(module, exports) {

let $c4e5254758f2570d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c4e5254758f2570d$var$load("llDyE").then(()=>parcelRequire('kUWXh'));

});

parcelRegister("2RRYh", function(module, exports) {

let $216a659382b21186$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $216a659382b21186$var$load("iIDDM").then(()=>parcelRequire('cTgjO'));

});

parcelRegister("4fgeJ", function(module, exports) {

let $317528670c938573$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $317528670c938573$var$load("3WxzV").then(()=>parcelRequire('eT9jO'));

});

parcelRegister("jnxGd", function(module, exports) {

let $e1ba4a694cccd737$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e1ba4a694cccd737$var$load("oCreq").then(()=>parcelRequire('chuTi'));

});

parcelRegister("8BjjX", function(module, exports) {

let $6430c4245b50a198$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6430c4245b50a198$var$load("7GBjq").then(()=>parcelRequire('7XDYs'));

});

parcelRegister("jeNBR", function(module, exports) {

let $e015ce9705c15ed7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e015ce9705c15ed7$var$load("k1hKE").then(()=>parcelRequire('8tvui'));

});

parcelRegister("3V7up", function(module, exports) {

let $2dac8134aa263f12$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2dac8134aa263f12$var$load("ebu4d").then(()=>parcelRequire('2Cbos'));

});

parcelRegister("lDtJn", function(module, exports) {

let $fc044d66af955332$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fc044d66af955332$var$load("4td60").then(()=>parcelRequire('15RBx'));

});

parcelRegister("7AhJG", function(module, exports) {

let $5859a7236324755c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5859a7236324755c$var$load("82U9s").then(()=>parcelRequire('fSY96'));

});

parcelRegister("1LjTk", function(module, exports) {

let $14899c41d8fdd919$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $14899c41d8fdd919$var$load("dxcsb"),
    $14899c41d8fdd919$var$load("99ObF"),
    $14899c41d8fdd919$var$load("7qcx6")
]).then(()=>parcelRequire('72Bx1'));

});

parcelRegister("aWcR9", function(module, exports) {

let $7f694b2b5e631623$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7f694b2b5e631623$var$load("6eCOh").then(()=>parcelRequire('kC1b5'));

});

parcelRegister("igktx", function(module, exports) {

let $d4b99a9ff446a698$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d4b99a9ff446a698$var$load("5ANhY").then(()=>parcelRequire('iGt4r'));

});

parcelRegister("2ktat", function(module, exports) {

let $1b24132c86ae7e66$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1b24132c86ae7e66$var$load("81e2B"),
    $1b24132c86ae7e66$var$load("b7Vqq")
]).then(()=>parcelRequire('4mJjX'));

});

parcelRegister("dAUhM", function(module, exports) {

let $9e5a4c53a15cd84e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9e5a4c53a15cd84e$var$load("f0cbZ").then(()=>parcelRequire('1JbJg'));

});

parcelRegister("2NY4P", function(module, exports) {

let $20aec26a4d2421b2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $20aec26a4d2421b2$var$load("ab9fz").then(()=>parcelRequire('OBlEA'));

});

parcelRegister("1TZuF", function(module, exports) {

let $162aa0dbc00a29d6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $162aa0dbc00a29d6$var$load("8PQ1l").then(()=>parcelRequire('b27do'));

});

parcelRegister("31vhh", function(module, exports) {

let $2339ba369157504b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2339ba369157504b$var$load("j4PKp").then(()=>parcelRequire('fhPxA'));

});

parcelRegister("3ZuMa", function(module, exports) {

let $2e7ef114166e54f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2e7ef114166e54f1$var$load("4kM14").then(()=>parcelRequire('iCRnQ'));

});

parcelRegister("j5KnW", function(module, exports) {

let $de627710a8b96974$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $de627710a8b96974$var$load("9CqXp").then(()=>parcelRequire('3AMf6'));

});

parcelRegister("1H3tc", function(module, exports) {

let $13bc7fa8bfb28e90$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $13bc7fa8bfb28e90$var$load("IB63P").then(()=>parcelRequire('goxVI'));

});

parcelRegister("7rWc9", function(module, exports) {

let $56c83255d8382497$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $56c83255d8382497$var$load("fZBju").then(()=>parcelRequire('iWuGG'));

});

parcelRegister("ftvk5", function(module, exports) {

let $b441dc899a6b021a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b441dc899a6b021a$var$load("4ssp9").then(()=>parcelRequire('3ea4j'));

});

parcelRegister("amsNh", function(module, exports) {

let $78b24b536ab5b88e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $78b24b536ab5b88e$var$load("70GAZ").then(()=>parcelRequire('ggD06'));

});

parcelRegister("d42xT", function(module, exports) {

let $982d9f943697a93f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $982d9f943697a93f$var$load("agVmZ"),
    $982d9f943697a93f$var$load("dxcsb"),
    $982d9f943697a93f$var$load("99ObF"),
    $982d9f943697a93f$var$load("4flC1"),
    $982d9f943697a93f$var$load("fDXJE"),
    $982d9f943697a93f$var$load("lrpUd"),
    $982d9f943697a93f$var$load("4LY4N"),
    $982d9f943697a93f$var$load("91F8D")
]).then(()=>parcelRequire('2L0qe'));

});

parcelRegister("5vi32", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lTECB = parcelRequire("lTECB");


var $7zgzO = parcelRequire("7zgzO");

function $36802f16e927d19b$export$c850f609dc850980() {
    const { location: location } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    return (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)(location || window.location);
}
module.exports["useIsEmbeddedConfluence_DO_NOT_USE"] = $36802f16e927d19b$export$c850f609dc850980;

});

parcelRegister("5kbLE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $1RMKR = parcelRequire("1RMKR");


var $7L44N = parcelRequire("7L44N");


var $6U5eU = parcelRequire("6U5eU");


var $k2UaY = parcelRequire("k2UaY");


var $cozmU = parcelRequire("cozmU");


var $fcLDg = parcelRequire("fcLDg");


var $jBS9T = parcelRequire("jBS9T");

const $a0d19ad2319e4e34$var$STABLE_OBJECT = {};
const $a0d19ad2319e4e34$var$Placement = ({ placementId: placementId, placementProps: placementProps, children: children, ErrorFallback: ErrorFallback, PlacementComponent: PlacementComponent, disableInitialData: disableInitialData = false, onEvent: onEvent })=>{
    const MemoizedPlacement = (0, $cozmU.useMemo)(()=>(0, $6U5eU.createPlacementComponent)(placementId, PlacementComponent), [
        placementId,
        PlacementComponent
    ]);
    const stableLocalPlacementProps = (0, $1RMKR.useStableObject)(placementProps ?? $a0d19ad2319e4e34$var$STABLE_OBJECT);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $k2UaY.r), {
        placementId: placementId,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7L44N.default), {
            placementId: placementId,
            consumptionType: "local",
            onEvent: onEvent,
            disableInitialData: disableInitialData,
            children: ({ initialData: initialData, context: context, onEvent: sharedOnEvent })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $fcLDg.default), {
                    analyticsChannel: (0, $jBS9T.ANALYTICS_CHANNEL),
                    placementId: placementId,
                    onError: sharedOnEvent,
                    fallback: ErrorFallback,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)(MemoizedPlacement, {
                        initialData: initialData,
                        context: context,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore - Confluence Local Consumption
                        errorFallback: ErrorFallback,
                        onEvent: sharedOnEvent,
                        ...stableLocalPlacementProps,
                        children: children
                    })
                })
        })
    });
};
const $a0d19ad2319e4e34$var$PlacementMemoized = /*#__PURE__*/ (0, $cozmU.memo)($a0d19ad2319e4e34$var$Placement);
var $a0d19ad2319e4e34$export$2e2bcd8739ae039 = $a0d19ad2319e4e34$var$PlacementMemoized;
module.exports["default"] = $a0d19ad2319e4e34$export$2e2bcd8739ae039;

});

parcelRegister("7L44N", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $f1G3w = parcelRequire("f1G3w");


var $8BQV6 = parcelRequire("8BQV6");


var $4QMIF = parcelRequire("4QMIF");


var $a33Aa = parcelRequire("a33Aa");


var $iQwJa = parcelRequire("iQwJa");

var $bGVJw = parcelRequire("bGVJw");

var $5h1mk = parcelRequire("5h1mk");

var $1RMKR = parcelRequire("1RMKR");


var $4OYR1 = parcelRequire("4OYR1");


var $gswTK = parcelRequire("gswTK");


var $9aSEF = parcelRequire("9aSEF");


var $4PX6o = parcelRequire("4PX6o");


var $3raeL = parcelRequire("3raeL");

const $17d7b5e1361d82f3$var$useInitialDataIfEnabled = (0, $gtMdU.isReactCompilerActivePlatform)() ? (placementId, context, baseUrl, path, disableInitialData)=>{
    const $ = (0, $bDgLe.c)(10);
    const fetcher = (0, $gswTK.usePlacementFetchingContext)();
    let t0;
    if ($[0] !== context) {
        t0 = (0, $iQwJa.isPostOfficePlacementsGloballyDisabled)(context);
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const arePlacementsGloballyDisabled = t0;
    let t1;
    if ($[2] !== arePlacementsGloballyDisabled || $[3] !== baseUrl || $[4] !== context || $[5] !== disableInitialData || $[6] !== fetcher.fetch || $[7] !== path || $[8] !== placementId) {
        t1 = arePlacementsGloballyDisabled || disableInitialData ? undefined : (0, $4PX6o.requestInitialData)(placementId, context, fetcher.fetch, {
            baseUrl: baseUrl,
            path: path
        });
        $[2] = arePlacementsGloballyDisabled;
        $[3] = baseUrl;
        $[4] = context;
        $[5] = disableInitialData;
        $[6] = fetcher.fetch;
        $[7] = path;
        $[8] = placementId;
        $[9] = t1;
    } else t1 = $[9];
    return t1;
} : (placementId, context, baseUrl, path, disableInitialData)=>{
    const fetcher = (0, $gswTK.usePlacementFetchingContext)();
    const arePlacementsGloballyDisabled = (0, $iQwJa.isPostOfficePlacementsGloballyDisabled)(context);
    return (0, $cozmU.useMemo)(()=>arePlacementsGloballyDisabled || disableInitialData ? undefined : (0, $4PX6o.requestInitialData)(placementId, context, fetcher.fetch, {
            baseUrl: baseUrl,
            path: path
        }), [
        arePlacementsGloballyDisabled,
        disableInitialData,
        baseUrl,
        path,
        placementId,
        context,
        fetcher.fetch
    ]);
};
/**
 * Validates error is a standard Error instance. If not, wraps in new Error instance.
 */ const $17d7b5e1361d82f3$var$validateErrorFromEventType = (err, eventType)=>{
    if (err instanceof Error) return err;
    if (typeof err === 'string') return new Error(err);
    return new Error(`Unknown error during ${eventType}`);
};
/**
 * Reports an error to UFO v2 for a given placement, on the current UFO v2 active interaction.
 * @param ufoV2Interaction Context of the current active UFO v2 interaction
 * @param placementId Post Office placement identifier
 * @param error
 * @param errorEventType Event type that triggered the error
 * @returns void
 */ const $17d7b5e1361d82f3$var$handleUfoV2Error = ({ ufoV2Interaction: ufoV2Interaction, placementId: placementId, error: error, errorEventType: errorEventType })=>{
    const validatedError = $17d7b5e1361d82f3$var$validateErrorFromEventType(error, errorEventType);
    const { interactionId: interactionId, labelStack: labelStack } = ufoV2Interaction;
    if (interactionId) (0, $a33Aa.addError)(interactionId, `${errorEventType}:${placementId}`, labelStack || null, validatedError.name, validatedError.message, validatedError.stack);
    else (0, $a33Aa.addErrorToAll)(`${errorEventType}:${placementId}`, labelStack || null, validatedError.name, validatedError.message, validatedError.stack);
};
const $17d7b5e1361d82f3$var$Placement = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: t1, children: children } = t0;
    const disableInitialData = t1 === undefined ? false : t1;
    const isUFOEnabled = true;
    const postOfficeRoute = (0, $5h1mk.usePostOfficeRoute)();
    const context = (0, $bGVJw.usePostOfficeContext)();
    const { baseUrl: baseUrl, path: path } = (0, $3raeL.useBuildBasePath)();
    let t2;
    if ($[0] !== context || $[1] !== postOfficeRoute) {
        t2 = {
            ...context,
            postOfficeRoute: postOfficeRoute
        };
        $[0] = context;
        $[1] = postOfficeRoute;
        $[2] = t2;
    } else t2 = $[2];
    const stableContextWithRoute = (0, $1RMKR.useStableObject)(t2);
    let t3;
    if ($[3] !== consumptionType || $[4] !== placementId) {
        t3 = new (0, $4OYR1.UFOv1).PlacementPerformanceTracker(placementId, consumptionType);
        $[3] = consumptionType;
        $[4] = placementId;
        $[5] = t3;
    } else t3 = $[5];
    const ufoV1PlacementTracker = t3;
    const ufoV2InteractionId = (0, $cozmU.useContext)((0, $4QMIF.default));
    const ufoV2InteractionContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    const t4 = ufoV2InteractionContext?.labelStack;
    let t5;
    if ($[6] !== t4 || $[7] !== ufoV2InteractionId.current) {
        t5 = {
            interactionId: ufoV2InteractionId.current,
            labelStack: t4
        };
        $[6] = t4;
        $[7] = ufoV2InteractionId.current;
        $[8] = t5;
    } else t5 = $[8];
    const stableUfoV2Interaction = (0, $1RMKR.useStableObject)(t5);
    let t6;
    if ($[9] !== consumptionType || $[10] !== placementId || $[11] !== placementOnEvent || $[12] !== stableUfoV2Interaction || $[13] !== ufoV1PlacementTracker) {
        t6 = (t7)=>{
            const { type: type, error: error } = t7;
            if (consumptionType === "local") {
                switch(type){
                    case "fetch-error":
                    case "component-error":
                    case "render-error":
                        $17d7b5e1361d82f3$var$handleUfoV2Error({
                            ufoV2Interaction: stableUfoV2Interaction,
                            placementId: placementId,
                            error: error,
                            errorEventType: type
                        });
                }
                return;
            }
            if (consumptionType === "remote") {
                placementOnEvent?.({
                    type: type,
                    error: error
                });
                bb29: switch(type){
                    case "fetch-complete":
                        ufoV1PlacementTracker?.markFetchComplete();
                        break bb29;
                    case "fetch-error":
                        ufoV1PlacementTracker?.markFetchFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                        break bb29;
                    case "render-complete":
                        ufoV1PlacementTracker?.markRenderComplete();
                        break bb29;
                    case "render-error":
                        ufoV1PlacementTracker?.markRenderFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                        break bb29;
                    case "initial-data-complete":
                        ufoV1PlacementTracker?.markInitialDataComplete();
                        break bb29;
                    case "initial-data-error":
                        ufoV1PlacementTracker?.markInitialDataFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                        break bb29;
                    case "component-error":
                        ufoV1PlacementTracker?.markComponentFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                        break bb29;
                    case "component-ready":
                        ufoV1PlacementTracker?.markComponentReady();
                        break bb29;
                    case "unmount":
                        ufoV1PlacementTracker?.markComponentAborted();
                }
            }
        };
        $[9] = consumptionType;
        $[10] = placementId;
        $[11] = placementOnEvent;
        $[12] = stableUfoV2Interaction;
        $[13] = ufoV1PlacementTracker;
        $[14] = t6;
    } else t6 = $[14];
    const componentOnEvent = t6;
    const initialData = $17d7b5e1361d82f3$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
    let t7;
    if ($[15] !== placementId) {
        t7 = {
            source: (0, $9aSEF.ANALYTICS_SOURCE),
            componentName: "Placement",
            attributes: {
                placementId: placementId,
                channel: "in-app"
            }
        };
        $[15] = placementId;
        $[16] = t7;
    } else t7 = $[16];
    const placementAnalyticsContext = t7;
    let t8;
    if ($[17] !== children || $[18] !== componentOnEvent || $[19] !== initialData || $[20] !== stableContextWithRoute) {
        t8 = children({
            initialData: initialData,
            context: stableContextWithRoute,
            onEvent: componentOnEvent
        });
        $[17] = children;
        $[18] = componentOnEvent;
        $[19] = initialData;
        $[20] = stableContextWithRoute;
        $[21] = t8;
    } else t8 = $[21];
    let t9;
    if ($[22] !== placementAnalyticsContext || $[23] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f1G3w.PostOfficeAnalyticsContext), {
            data: placementAnalyticsContext
        }, t8);
        $[22] = placementAnalyticsContext;
        $[23] = t8;
        $[24] = t9;
    } else t9 = $[24];
    return t9;
} : ({ placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: disableInitialData = false, children: children })=>{
    const isUFOEnabled = true;
    const postOfficeRoute = (0, $5h1mk.usePostOfficeRoute)();
    const context = (0, $bGVJw.usePostOfficeContext)();
    const { baseUrl: baseUrl, path: path } = (0, $3raeL.useBuildBasePath)();
    const stableContextWithRoute = (0, $1RMKR.useStableObject)({
        ...context,
        postOfficeRoute: postOfficeRoute
    });
    const ufoV1PlacementTracker = (0, $cozmU.useMemo)(()=>isUFOEnabled ? new (0, $4OYR1.UFOv1).PlacementPerformanceTracker(placementId, consumptionType) : undefined, [
        isUFOEnabled,
        placementId,
        consumptionType
    ]);
    const ufoV2InteractionId = (0, $cozmU.useContext)((0, $4QMIF.default));
    const ufoV2InteractionContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    const stableUfoV2Interaction = (0, $1RMKR.useStableObject)({
        interactionId: ufoV2InteractionId.current,
        labelStack: ufoV2InteractionContext?.labelStack
    });
    // Callback function to listen to the different stages of the component and track its performance
    const componentOnEvent = (0, $cozmU.useCallback)(({ type: type, error: error })=>{
        // Used for local placement components, UFO v2 events
        if (consumptionType === 'local') {
            switch(type){
                case 'fetch-error':
                case 'component-error':
                case 'render-error':
                    $17d7b5e1361d82f3$var$handleUfoV2Error({
                        ufoV2Interaction: stableUfoV2Interaction,
                        placementId: placementId,
                        error: error,
                        errorEventType: type
                    });
            }
            return;
        }
        // Used for remote placement components, UFO v1 events
        if (consumptionType === 'remote') {
            placementOnEvent?.({
                type: type,
                error: error
            });
            switch(type){
                case 'fetch-complete':
                    ufoV1PlacementTracker?.markFetchComplete();
                    break;
                case 'fetch-error':
                    ufoV1PlacementTracker?.markFetchFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                    break;
                case 'render-complete':
                    ufoV1PlacementTracker?.markRenderComplete();
                    break;
                case 'render-error':
                    ufoV1PlacementTracker?.markRenderFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                    break;
                case 'initial-data-complete':
                    ufoV1PlacementTracker?.markInitialDataComplete();
                    break;
                case 'initial-data-error':
                    ufoV1PlacementTracker?.markInitialDataFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                    break;
                case 'component-error':
                    ufoV1PlacementTracker?.markComponentFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                    break;
                case 'component-ready':
                    ufoV1PlacementTracker?.markComponentReady();
                    break;
                case 'unmount':
                    ufoV1PlacementTracker?.markComponentAborted();
                    break;
            }
        }
    }, [
        placementOnEvent,
        ufoV1PlacementTracker,
        consumptionType,
        placementId,
        stableUfoV2Interaction
    ]);
    const initialData = $17d7b5e1361d82f3$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
    const placementAnalyticsContext = (0, $cozmU.useMemo)(()=>({
            source: (0, $9aSEF.ANALYTICS_SOURCE),
            componentName: `Placement`,
            attributes: {
                placementId: placementId,
                channel: 'in-app'
            }
        }), [
        placementId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f1G3w.PostOfficeAnalyticsContext), {
        data: placementAnalyticsContext
    }, children({
        initialData: initialData,
        context: stableContextWithRoute,
        onEvent: componentOnEvent
    }));
};
var $17d7b5e1361d82f3$export$2e2bcd8739ae039 = $17d7b5e1361d82f3$var$Placement;
module.exports["default"] = $17d7b5e1361d82f3$export$2e2bcd8739ae039;

});

parcelRegister("9aSEF", function(module, exports) {
const $94018a62770928ba$export$85183a312807388d = 'postOffice';
const $94018a62770928ba$export$f7109619a5e9e0d6 = 'post-office-frontend';
module.exports["ANALYTICS_SOURCE"] = $94018a62770928ba$export$f7109619a5e9e0d6;

});

parcelRegister("3raeL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $apw3A = parcelRequire("apw3A");

var $jdpvF = parcelRequire("jdpvF");

const $04b3f6e864eb8426$export$83d6c58b7ab7ae67 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const postOfficeEnvironment = (0, $jdpvF.usePostOfficeEnvironment)();
    let t0;
    if ($[0] !== postOfficeEnvironment.currentEnv || $[1] !== postOfficeEnvironment.envConfigs) {
        t0 = (0, $apw3A.buildBasePath)(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs);
        $[0] = postOfficeEnvironment.currentEnv;
        $[1] = postOfficeEnvironment.envConfigs;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : ()=>{
    const postOfficeEnvironment = (0, $jdpvF.usePostOfficeEnvironment)();
    return (0, $cozmU.useMemo)(()=>(0, $apw3A.buildBasePath)(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs), [
        postOfficeEnvironment.currentEnv,
        postOfficeEnvironment.envConfigs
    ]);
};
module.exports["useBuildBasePath"] = $04b3f6e864eb8426$export$83d6c58b7ab7ae67;

});

parcelRegister("fcLDg", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $lzgC6 = parcelRequire("lzgC6");


var $cozmU = parcelRequire("cozmU");

class $45465d036124c3a6$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidCatch(error, errorInfo) {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'handled',
            actionSubject: 'error',
            actionSubjectId: 'postOfficePlacementErrorBoundary',
            attributes: {
                error: error?.message,
                errorInfo: errorInfo,
                placementId: this.props.placementId
            }
        });
        analyticsEvent.fire(this.props.analyticsChannel);
        this.props.onError({
            error: error,
            type: 'render-error'
        });
        this.setState({
            hasError: true
        });
    }
    render() {
        if (this.state.hasError) return this.props.fallback ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
            children: this.props.fallback
        }) : null;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
const $45465d036124c3a6$var$ErrorBoundaryWithAnalytics = (0, $lzgC6.default)()($45465d036124c3a6$var$ErrorBoundary);
var $45465d036124c3a6$export$2e2bcd8739ae039 = $45465d036124c3a6$var$ErrorBoundaryWithAnalytics;
module.exports["default"] = $45465d036124c3a6$export$2e2bcd8739ae039;

});

parcelRegister("jBS9T", function(module, exports) {
const $27b0c301be1a67fd$export$85183a312807388d = 'postOffice';
module.exports["ANALYTICS_CHANNEL"] = $27b0c301be1a67fd$export$85183a312807388d;

});

parcelRegister("9oJIg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gswTK = parcelRequire("gswTK");


var $MyxIQ = parcelRequire("MyxIQ");

const $5176b2e7fefe99e5$export$9be10e5cc29463c9 = ({ children: children })=>{
    const fetch = (0, $MyxIQ.usePlacementSSRFetch)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gswTK.PlacementFetchingProvider), {
        fetch: fetch
    }, children);
};
module.exports["PlacementFetchProvider"] = $5176b2e7fefe99e5$export$9be10e5cc29463c9;

});

parcelRegister("8MKuN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $a33Aa = parcelRequire("a33Aa");


var $jb2gB = parcelRequire("jb2gB");

const $88668855474bc367$export$27cee8d00af73bce = [
    'edit-page.page_load',
    'edit-page.transition',
    'space-overview-edit-page.page_load',
    'space-overview-edit-page.transition',
    'live-edit.page_load',
    'live-edit.transition'
];
function $88668855474bc367$export$2510d15b8c74a469({ children: children, excludedInteractions: excludedInteractions = $88668855474bc367$export$27cee8d00af73bce }) {
    // Capture the interaction once at mount time to ensure stable behavior for the
    // component's lifetime. getActiveInteraction() can return null mid-render cycle
    // if the UFO interaction ends, which would cause the ignore prop to toggle
    // between renders and effectively un-ignore the hold on a subsequent re-render.
    const ignoreHoldsRef = (0, $cozmU.useRef)(null);
    if (ignoreHoldsRef.current === null) {
        const interaction = (0, $a33Aa.getActiveInteraction)();
        if (interaction) {
            const { type: type, ufoName: ufoName } = interaction;
            ignoreHoldsRef.current = excludedInteractions.includes(`${ufoName}.${type}`);
        } else ignoreHoldsRef.current = false;
    }
    const ignoreHolds = ignoreHoldsRef.current ?? false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jb2gB.default), {
        ignore: ignoreHolds
    }, children);
}
module.exports["ConditionalUfoHoldIgnore"] = $88668855474bc367$export$2510d15b8c74a469;

});

parcelRegister("ctTo0", function(module, exports) {
/**
 * @generated SignedSource<<991ce2d939a58c458f86c450ce401fbc>>
 * @relayHash cfd6fa9dcb9e9305611fc3619dc85ec3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5c673b0736dce3bbc3183b766ba5dc60fdc106f9b1261efc2d3ca8806009b3f6
const $d7558363fe39fca1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "enabled"
        },
        {
            "kind": "ScalarField",
            "name": "messageContent"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceAccessRequestSettingsConfiguration",
            "kind": "LinkedField",
            "name": "confluence_accessRequestSettings",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceAccessRequestSettings",
                    "kind": "LinkedField",
                    "name": "contentAccessRequestSettings",
                    "plural": false,
                    "selections": v1 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceAccessRequestSettings",
                    "kind": "LinkedField",
                    "name": "spaceAccessRequestSettings",
                    "plural": false,
                    "selections": v1 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAccessRequestSettingsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAccessRequestSettingsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "cfd6fa9dcb9e9305611fc3619dc85ec3",
            "id": "5c673b0736dce3bbc3183b766ba5dc60fdc106f9b1261efc2d3ca8806009b3f6",
            "metadata": {},
            "name": "useAccessRequestSettingsQuery",
            "operationKind": "query",
            "text": "query useAccessRequestSettingsQuery($cloudId:ID!){confluence_accessRequestSettings(cloudId:$cloudId){contentAccessRequestSettings{enabled,messageContent},spaceAccessRequestSettings{enabled,messageContent}}}"
        }
    };
}();
$d7558363fe39fca1$var$node.hash = "a036ba125a56fbf2de00fed43babc58f";
var $d7558363fe39fca1$export$2e2bcd8739ae039 = $d7558363fe39fca1$var$node;
module.exports["default"] = $d7558363fe39fca1$export$2e2bcd8739ae039;

});

parcelRegister("kdKo9", function(module, exports) {
/**
 * @generated SignedSource<<f026ee318392a45fe95d1de0923dc1ed>>
 * @relayHash 8899b56f857af5bbb6a7740a976421fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ccc3fed4f1272376987ab0969757e99e08b473a8f3181629a4d10c47646cafb7
const $04119cd59f78d958$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceSettings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "routeOverrideEnabled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceRestrictionCheckQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceRestrictionCheckQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8899b56f857af5bbb6a7740a976421fb",
            "id": "ccc3fed4f1272376987ab0969757e99e08b473a8f3181629a4d10c47646cafb7",
            "metadata": {},
            "name": "SpaceRestrictionCheckQuery",
            "operationKind": "query",
            "text": "query SpaceRestrictionCheckQuery($spaceKey:String!){space(key:$spaceKey){id,settings{routeOverrideEnabled}}}"
        }
    };
}();
$04119cd59f78d958$var$node.hash = "57291753cf0096ea57a2f2351520a494";
var $04119cd59f78d958$export$2e2bcd8739ae039 = $04119cd59f78d958$var$node;
module.exports["default"] = $04119cd59f78d958$export$2e2bcd8739ae039;

});

parcelRegister("dtDUi", function(module, exports) {
/* eslint-disable prefer-template */ 
var $64KID = parcelRequire("64KID");


var $fMEnQ = parcelRequire("fMEnQ");

const $dab54f7f733e6dc2$var$DOC_LINK = 'https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4848884799/Debugging+Hydration+Mismatches';
const $dab54f7f733e6dc2$export$476b9d1d68660527 = [
    {
        matchers: [
            /Hydration failed because the initial UI does not match what was rendered on the server/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /The server could not finish this Suspense boundary, likely due to an error during server rendering/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This root received an early update, before anything was able hydrate. Switched the entire root to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Text content does not match server-rendered HTML./
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating this Suspense boundary. Switched to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    //Production errors
    {
        matchers: [
            /Minified React error #418/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server in production. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #419/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #421/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #422/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #423/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #424/
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #425/
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    }
];
const $dab54f7f733e6dc2$export$5796b97ecb5a412 = (errorString)=>{
    for (const { matchers: matchers, friendlyError: friendlyError, hydrationFailed: hydrationFailed } of $dab54f7f733e6dc2$export$476b9d1d68660527){
        if (matchers.some((matcher)=>matcher.test(errorString))) return {
            ...friendlyError,
            originalString: errorString,
            hydrationFailed: hydrationFailed
        };
    }
    return {
        friendlyMessage: 'An additional error occurred, attached below.',
        docLink: '',
        fallback: true,
        originalString: errorString,
        hydrationFailed: false
    };
};
const $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2 = (url)=>{
    const match = (0, $fMEnQ.Route).matchFirst(Object.values((0, $64KID.namedRoutes)), url);
    return {
        error: new Error(`Hydration failed on route ${match?.name}`),
        route: match?.name || 'unknown'
    };
};
function $dab54f7f733e6dc2$export$260985b5e8a6fce6({ source: source, route: route, errorWithRoute: errorWithRoute, isSSRReactStreaming: isSSRReactStreaming }) {
    const attribution = isSSRReactStreaming ? 'streaming-hydration' : 'hydration';
    const error = $dab54f7f733e6dc2$var$trimTextLength(errorWithRoute.message || String(errorWithRoute), 1000);
    return {
        type: 'sendOperationalEvent',
        data: {
            source: source,
            route: route,
            action: 'failed',
            actionSubject: 'hydration',
            attributes: {
                error: error,
                route: route,
                attribution: attribution,
                isSSRReactStreaming: isSSRReactStreaming
            }
        }
    };
}
function $dab54f7f733e6dc2$var$trimTextLength(text, maxLength) {
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
}
module.exports["matchHydrationError"] = $dab54f7f733e6dc2$export$5796b97ecb5a412;
module.exports["getHydrationErrorWithRoute"] = $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2;
module.exports["getHydrationFailureOperationalEvent"] = $dab54f7f733e6dc2$export$260985b5e8a6fce6;

});

parcelRegister("dA1Sn", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");

const $18ccf8477934fc9e$export$2a8604960d7d23d9 = 30000;
const $18ccf8477934fc9e$var$useTwoStageHydration = (name, enabled)=>{
    const fullCycleOutput = window.__FULLCYCLE__?.[name];
    const isNoFullCycleOutput = fullCycleOutput === undefined;
    const isNoSSR = !window.__SSR_RENDERED__;
    // Rely on a normal hydration/rendering flow when it's a transition or there's no full cycle output
    // or when experience is not hydratable
    const [hydrated, setHydrated] = (0, $cozmU.useState)(isNoSSR || isNoFullCycleOutput || !window.__HYDRATABLE__ || !enabled);
    (0, $cozmU.useEffect)(()=>{
        setHydrated(true);
        const cleanup = ()=>{
            delete window.__FULLCYCLE__?.[name];
        };
        // Arbitrary 30s CLEANUP_TIMEOUT to allow for the element to be rendered before removal
        // to not force an unecessary re-render or flash of blank content, even in slowest cases
        setTimeout(cleanup, $18ccf8477934fc9e$export$2a8604960d7d23d9);
        return cleanup;
    }, [
        name
    ]);
    return {
        hydrated: hydrated,
        fullCycleOutput: fullCycleOutput
    };
};
const $18ccf8477934fc9e$export$ca5d80b93e3e21b2 = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals -- the saveFullCycleOutput() only runs in the browser
    const nodesForPartialHydration = document.querySelectorAll('[data-fullcycle-name]');
    if (nodesForPartialHydration.length > 0) window.__FULLCYCLE__ = Array.from(nodesForPartialHydration).reduce((acc, node)=>{
        acc[node.dataset.fullcycleName] = node.innerHTML;
        return acc;
    }, {});
};
const $18ccf8477934fc9e$export$137b13ff1789fa49 = (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { style: style, name: name, children: children, enabled: t1, ssrPlaceholder: t2 } = t0;
    const enabled = t1 === undefined ? false : t1;
    const ssrPlaceholder = t2 === undefined ? false : t2;
    const { hydrated: hydrated, fullCycleOutput: fullCycleOutput } = $18ccf8477934fc9e$var$useTwoStageHydration(name, enabled);
    if ((0, $6mKj3.expValEquals)("cc_fix_hydration_ttvc", "isEnabled", true)) {
        if (!enabled) return children;
        if (hydrated) {
            let t3;
            if ($[0] !== name || $[1] !== ssrPlaceholder) {
                t3 = ssrPlaceholder ? {
                    "data-ssr-placeholder": name,
                    "data-ssr-placeholder-replace": name
                } : {};
                $[0] = name;
                $[1] = ssrPlaceholder;
                $[2] = t3;
            } else t3 = $[2];
            let t4;
            if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
                t4 = {
                    position: "relative",
                    height: "100%",
                    width: "100%"
                };
                $[3] = t4;
            } else t4 = $[3];
            let t5;
            if ($[4] !== children || $[5] !== name || $[6] !== t3) {
                t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    "data-testid": "two-stage-hydration",
                    "data-fullcycle-name": name,
                    ...t3,
                    style: t4
                }, children);
                $[4] = children;
                $[5] = name;
                $[6] = t3;
                $[7] = t5;
            } else t5 = $[7];
            return t5;
        }
        const innerHTML = fullCycleOutput;
        let t3;
        if ($[8] !== name || $[9] !== ssrPlaceholder) {
            t3 = ssrPlaceholder ? {
                "data-ssr-placeholder": name,
                "data-ssr-placeholder-replace": name
            } : {};
            $[8] = name;
            $[9] = ssrPlaceholder;
            $[10] = t3;
        } else t3 = $[10];
        let t4;
        if ($[11] !== innerHTML) {
            t4 = {
                __html: innerHTML
            };
            $[11] = innerHTML;
            $[12] = t4;
        } else t4 = $[12];
        let t5;
        if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = {
                position: "relative",
                height: "100%",
                width: "100%"
            };
            $[13] = t5;
        } else t5 = $[13];
        let t6;
        if ($[14] !== name || $[15] !== t3 || $[16] !== t4) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-testid": "two-stage-hydration",
                "data-fullcycle-name": name,
                ...t3,
                dangerouslySetInnerHTML: t4,
                style: t5
            });
            $[14] = name;
            $[15] = t3;
            $[16] = t4;
            $[17] = t6;
        } else t6 = $[17];
        return t6;
    }
    if (!enabled || hydrated) return children;
    const innerHTML_0 = fullCycleOutput;
    let t3;
    if ($[22] !== innerHTML_0) {
        t3 = {
            __html: innerHTML_0
        };
        $[22] = innerHTML_0;
        $[23] = t3;
    } else t3 = $[23];
    let t4;
    if ($[24] !== name || $[25] !== style || $[26] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: style,
            "data-testid": "two-stage-hydration",
            "data-fullcycle-name": name,
            dangerouslySetInnerHTML: t3
        });
        $[24] = name;
        $[25] = style;
        $[26] = t3;
        $[27] = t4;
    } else t4 = $[27];
    return t4;
};
const $18ccf8477934fc9e$export$b6db8e1e111c3550 = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { name: name, style: style, children: children, enabled: t1, ssrPlaceholder: t2 } = t0;
    const enabled = t1 === undefined ? true : t1;
    const ssrPlaceholder = t2 === undefined ? false : t2;
    let t3;
    if ($[0] !== children || $[1] !== enabled || $[2] !== name || $[3] !== ssrPlaceholder || $[4] !== style) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($18ccf8477934fc9e$export$137b13ff1789fa49, {
            name: name,
            style: style,
            enabled: enabled,
            ssrPlaceholder: ssrPlaceholder
        }, children);
        $[0] = children;
        $[1] = enabled;
        $[2] = name;
        $[3] = ssrPlaceholder;
        $[4] = style;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
};
module.exports["saveFullCycleOutput"] = $18ccf8477934fc9e$export$ca5d80b93e3e21b2;
module.exports["TwoStageHydration"] = $18ccf8477934fc9e$export$b6db8e1e111c3550;

});

parcelRegister("8sZwv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jvnPU = parcelRequire("jvnPU");


var $3d3WW = parcelRequire("3d3WW");


var $iDrrr = parcelRequire("iDrrr");


var $bGVJw = parcelRequire("bGVJw");


var $jdpvF = parcelRequire("jdpvF");


var $arQiA = parcelRequire("arQiA");


var $l08Du = parcelRequire("l08Du");


var $VDfNH = parcelRequire("VDfNH");


var $6m3nS = parcelRequire("6m3nS");


var $1RMKR = parcelRequire("1RMKR");


var $e79Od = parcelRequire("e79Od");


var $di43e = parcelRequire("di43e");


var $blkyl = parcelRequire("blkyl");


var $2295f = parcelRequire("2295f");

const $3ce14727ee29c8fc$export$fb465b6e855c1e85 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { environment: envWithOverrides, context: context, children: children, analyticsClientInstance: analyticsClientInstance } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $iDrrr.fg)("post-office-rml-fedramp-compliant-urls");
        $[0] = t1;
    } else t1 = $[0];
    const isFedRampCompliantUrlsEnabled = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $jdpvF.buildDefaultEnvironmentValues)(isFedRampCompliantUrlsEnabled);
        $[1] = t2;
    } else t2 = $[1];
    const environmentValues = t2;
    let t3;
    if ($[2] !== envWithOverrides) {
        t3 = (0, $blkyl.generateEnvironmentConfigWithOverrides)(environmentValues, envWithOverrides);
        $[2] = envWithOverrides;
        $[3] = t3;
    } else t3 = $[3];
    const stableEnvironment = (0, $1RMKR.useStableObject)(t3);
    let t4;
    if ($[4] !== context.current) {
        t4 = $3ce14727ee29c8fc$var$composeConfig((0, $bGVJw.defaultPostOfficeContextValue), context.current);
        $[4] = context.current;
        $[5] = t4;
    } else t4 = $[5];
    const stableContext = (0, $1RMKR.useStableObject)(t4);
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $di43e.createMessagePlacementValues)();
        $[6] = t5;
    } else t5 = $[6];
    const memoizedMessagePlacementValues = t5;
    let t6;
    if ($[7] !== analyticsClientInstance || $[8] !== children) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $VDfNH.PostOfficeScreenContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di43e.MessagePlacementProvider), {
            value: memoizedMessagePlacementValues
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l08Du.RouteListenerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6m3nS.TriggerContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3ce14727ee29c8fc$var$MaybeAnalyticsListener, {
            analyticsClientInstance: analyticsClientInstance
        }, children)))));
        $[7] = analyticsClientInstance;
        $[8] = children;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== stableContext || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bGVJw.InternalPostOfficeContextProvider), {
            value: stableContext
        }, t6);
        $[10] = stableContext;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== stableEnvironment || $[14] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3ce14727ee29c8fc$var$MaybePostOfficeCacheProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdpvF.PostOfficeEnvironmentProvider), {
            value: stableEnvironment
        }, t7));
        $[13] = stableEnvironment;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    return t8;
} : ({ environment: envWithOverrides, context: context, children: children, analyticsClientInstance: analyticsClientInstance })=>{
    const isFedRampCompliantUrlsEnabled = (0, $iDrrr.fg)('post-office-rml-fedramp-compliant-urls');
    const environmentValues = (0, $cozmU.useMemo)(()=>(0, $jdpvF.buildDefaultEnvironmentValues)(isFedRampCompliantUrlsEnabled), [
        isFedRampCompliantUrlsEnabled
    ]);
    const stableEnvironment = (0, $1RMKR.useStableObject)((0, $blkyl.generateEnvironmentConfigWithOverrides)(environmentValues, envWithOverrides));
    const stableContext = (0, $1RMKR.useStableObject)($3ce14727ee29c8fc$var$composeConfig((0, $bGVJw.defaultPostOfficeContextValue), context.current));
    const memoizedMessagePlacementValues = (0, $cozmU.useMemo)(()=>(0, $di43e.createMessagePlacementValues)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3ce14727ee29c8fc$var$MaybePostOfficeCacheProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdpvF.PostOfficeEnvironmentProvider), {
        value: stableEnvironment
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bGVJw.InternalPostOfficeContextProvider), {
        value: stableContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $VDfNH.PostOfficeScreenContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di43e.MessagePlacementProvider), {
        value: memoizedMessagePlacementValues
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l08Du.RouteListenerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6m3nS.TriggerContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3ce14727ee29c8fc$var$MaybeAnalyticsListener, {
        analyticsClientInstance: analyticsClientInstance
    }, children))))))));
};
const $3ce14727ee29c8fc$var$swrConfig = {
    provider: (0, $2295f.localStorageCacheProvider),
    use: [
        (0, $2295f.postOfficeCacheMiddleware)
    ]
};
const $3ce14727ee29c8fc$var$MaybePostOfficeCacheProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = t0;
    if ((0, $iDrrr.fg)("post-office-use-placement-with-client")) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jvnPU.SWRConfig), {
                value: $3ce14727ee29c8fc$var$swrConfig
            }, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[2] = children;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ children: children })=>{
    if ((0, $iDrrr.fg)('post-office-use-placement-with-client')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jvnPU.SWRConfig), {
        value: $3ce14727ee29c8fc$var$swrConfig
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
const $3ce14727ee29c8fc$var$MaybeAnalyticsListener = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, analyticsClientInstance: analyticsClientInstance } = t0;
    const isEPExposuresListenerEnabled = (0, $iDrrr.fg)("post-office_ep_exposures_enabled");
    const isAnalyticsListenerEnabled = (0, $iDrrr.fg)("post-office-analytics-listener-enabled");
    let content = children;
    if (isEPExposuresListenerEnabled) {
        let t1;
        if ($[0] !== analyticsClientInstance || $[1] !== content) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e79Od.EPExposuresListener), {
                analyticsClientInstance: analyticsClientInstance
            }, content);
            $[0] = analyticsClientInstance;
            $[1] = content;
            $[2] = t1;
        } else t1 = $[2];
        content = t1;
    }
    if (isAnalyticsListenerEnabled) {
        const { handleEvent: handleEvent } = (0, $arQiA.postOfficeGasv3ListenerStore);
        let t1;
        if ($[3] !== content) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
                channel: "*",
                onEvent: handleEvent
            }, content);
            $[3] = content;
            $[4] = t1;
        } else t1 = $[4];
        content = t1;
    }
    let t1;
    if ($[5] !== content) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, content);
        $[5] = content;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : ({ children: children, analyticsClientInstance: analyticsClientInstance })=>{
    const isEPExposuresListenerEnabled = (0, $iDrrr.fg)('post-office_ep_exposures_enabled');
    const isAnalyticsListenerEnabled = (0, $iDrrr.fg)('post-office-analytics-listener-enabled');
    let content = children;
    if (isEPExposuresListenerEnabled) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e79Od.EPExposuresListener), {
        analyticsClientInstance: analyticsClientInstance
    }, content);
    if (isAnalyticsListenerEnabled) {
        const { handleEvent: handleEvent } = (0, $arQiA.postOfficeGasv3ListenerStore);
        content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
            channel: "*",
            onEvent: handleEvent
        }, content);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, content);
};
const $3ce14727ee29c8fc$var$composeConfig = (base, ...rest)=>rest.reduce((acc, v)=>{
        // Bring logic inline with lodash merge
        // Iterator (right) properties that resolve to undefined are skipped if an Accumulator (left) value already exists
        for(const key in v)if (typeof v[key] === 'undefined') delete v[key];
        return {
            ...acc,
            ...v
        };
    }, {
        ...base
    });
module.exports["PostOfficeProvider"] = $3ce14727ee29c8fc$export$fb465b6e855c1e85;

});

parcelRegister("arQiA", function(module, exports) {

var $dwM0U = parcelRequire("dwM0U");

function $e445a34dfcfa6076$var$getSubscribers() {
    if (typeof window !== 'undefined' && window.postOffice?.gasv3Listener?.subscribers) return window.postOffice.gasv3Listener.subscribers;
    if (typeof window !== 'undefined') {
        window.postOffice = {
            ...window.postOffice,
            gasv3Listener: {
                ...window.postOffice?.gasv3Listener,
                subscribers: new Map()
            }
        };
        return window.postOffice.gasv3Listener.subscribers;
    }
    return new Map();
}
const $e445a34dfcfa6076$var$createPostOfficeGasv3ListenerStore = ()=>{
    const subscribers = $e445a34dfcfa6076$var$getSubscribers();
    const handleEvent = (event)=>{
        subscribers.forEach((callback, matcher)=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($dwM0U)))(event.payload, matcher)) callback();
        });
    };
    const subscribe = (matcher, callback)=>{
        subscribers.set(matcher, callback);
        return ()=>{
            subscribers.delete(matcher);
        };
    };
    return {
        subscribe: subscribe,
        handleEvent: handleEvent
    };
};
const $e445a34dfcfa6076$export$19b95495a42be187 = $e445a34dfcfa6076$var$createPostOfficeGasv3ListenerStore();
module.exports["postOfficeGasv3ListenerStore"] = $e445a34dfcfa6076$export$19b95495a42be187;

});

parcelRegister("l08Du", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $8RKDP = parcelRequire("8RKDP");


var $5h1mk = parcelRequire("5h1mk");

const $acc09a1fccfadb8a$var$noop = ()=>{};
const $acc09a1fccfadb8a$var$RouteListenerContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    update: $acc09a1fccfadb8a$var$noop
});
const $acc09a1fccfadb8a$export$7a2084f4baac29a7 = ()=>(0, $8RKDP.createSimplePubSub)();
const $acc09a1fccfadb8a$export$72fd8977abf03d60 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($acc09a1fccfadb8a$var$RouteListenerContext);
} : ()=>(0, $cozmU.useContext)($acc09a1fccfadb8a$var$RouteListenerContext);
const $acc09a1fccfadb8a$export$755edb1665399d41 = ()=>{
    const ref = (0, $cozmU.useRef)();
    if (!ref.current) ref.current = $acc09a1fccfadb8a$export$7a2084f4baac29a7();
    const [routeSubscriber, updateRoute] = ref.current;
    const routeConfig = (0, $cozmU.useMemo)(()=>({
            initialUrl: new URL(window.location.href),
            routeSubscriber: routeSubscriber
        }), [
        routeSubscriber
    ]);
    const routeUpdater = (0, $cozmU.useMemo)(()=>({
            update: updateRoute
        }), [
        updateRoute
    ]);
    return [
        routeConfig,
        routeUpdater
    ];
};
const $acc09a1fccfadb8a$export$bb606326acdd1a64 = (deps)=>{
    const { update: update } = $acc09a1fccfadb8a$export$72fd8977abf03d60();
    (0, $cozmU.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        update({
            next: new URL(window.location.href)
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
const $acc09a1fccfadb8a$export$31986273b686f5ea = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children } = t0;
    const [route, routeUpdater] = $acc09a1fccfadb8a$export$755edb1665399d41();
    let t1;
    if ($[0] !== children || $[1] !== route) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5h1mk.PostOfficeRouteProvider), route, children);
        $[0] = children;
        $[1] = route;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== routeUpdater || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($acc09a1fccfadb8a$var$RouteListenerContext.Provider, {
            value: routeUpdater
        }, t1);
        $[3] = routeUpdater;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ children: children })=>{
    const [route, routeUpdater] = $acc09a1fccfadb8a$export$755edb1665399d41();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($acc09a1fccfadb8a$var$RouteListenerContext.Provider, {
        value: routeUpdater
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5h1mk.PostOfficeRouteProvider), route, children));
};
module.exports["usePostOfficeRouteUpdate"] = $acc09a1fccfadb8a$export$bb606326acdd1a64;
module.exports["RouteListenerProvider"] = $acc09a1fccfadb8a$export$31986273b686f5ea;

});

parcelRegister("6m3nS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $e71ebdc70c2ecd2e$var$initialActiveTriggerState = {
    activeTriggerState: {}
};
const $e71ebdc70c2ecd2e$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $e71ebdc70c2ecd2e$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($e71ebdc70c2ecd2e$var$initialActiveTriggerState);
const $e71ebdc70c2ecd2e$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($e71ebdc70c2ecd2e$var$initialTriggerDispatchState);
const $e71ebdc70c2ecd2e$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [recordState, setRecordState] = (0, $cozmU.useState)({});
    const setTriggerState = (0, $cozmU.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setRecordState((current)=>{
            if (!!current[triggerId] === isActive) return current;
            if (isActive) return {
                ...current,
                [triggerId]: true
            };
            const { [triggerId]: excludedTrigger, ...rest } = current;
            return rest;
        });
    }, []);
    const triggerContextValue = (0, $cozmU.useMemo)(()=>({
            activeTriggerState: recordState
        }), [
        recordState
    ]);
    const triggerContexDispatchValue = (0, $cozmU.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e71ebdc70c2ecd2e$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e71ebdc70c2ecd2e$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $e71ebdc70c2ecd2e$export$454c1d7c35958f5e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerContext);
} : ()=>(0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerContext);
const $e71ebdc70c2ecd2e$export$23cbf084e08bdb93 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerDispatchContext);
} : ()=>(0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerDispatchContext);
const $e71ebdc70c2ecd2e$export$3b196fe93a948c18 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (triggerId)=>{
    const $ = (0, $bDgLe.c)(3);
    const { activeTriggerState: activeTriggerState } = $e71ebdc70c2ecd2e$export$454c1d7c35958f5e();
    let t0;
    if ($[0] !== activeTriggerState || $[1] !== triggerId) {
        t0 = triggerId ? {
            isActive: !!activeTriggerState[triggerId]
        } : {
            isActive: undefined
        };
        $[0] = activeTriggerState;
        $[1] = triggerId;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $e71ebdc70c2ecd2e$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: !!activeTriggerState[triggerId]
    } : {
        isActive: undefined
    };
};
const $e71ebdc70c2ecd2e$export$83b33e5fe4cce64 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { triggerId: triggerId } = t0;
    const { setTriggerState: setContextTriggerState } = $e71ebdc70c2ecd2e$export$23cbf084e08bdb93();
    let t1;
    if ($[0] !== setContextTriggerState || $[1] !== triggerId) {
        t1 = (t2)=>{
            const { isActive: isActive } = t2;
            return setContextTriggerState({
                triggerId: triggerId,
                isActive: isActive
            });
        };
        $[0] = setContextTriggerState;
        $[1] = triggerId;
        $[2] = t1;
    } else t1 = $[2];
    const fireTrigger = t1;
    let t2;
    if ($[3] !== fireTrigger) {
        t2 = {
            fireTrigger: fireTrigger
        };
        $[3] = fireTrigger;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $e71ebdc70c2ecd2e$export$23cbf084e08bdb93();
    const fireTrigger = (0, $cozmU.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $e71ebdc70c2ecd2e$export$e45375ff75169f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (messageId)=>{
    const $ = (0, $bDgLe.c)(17);
    const { isActive: hasMessageStarted } = $e71ebdc70c2ecd2e$export$3b196fe93a948c18(`${messageId}-started`);
    const t0 = `${messageId}-start`;
    let t1;
    if ($[0] !== t0) {
        t1 = {
            triggerId: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { fireTrigger: requestMessageStartTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t1);
    const t2 = `${messageId}-dismiss`;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            triggerId: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const { fireTrigger: fireDismissClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t3);
    const t4 = `${messageId}-cta-click`;
    let t5;
    if ($[4] !== t4) {
        t5 = {
            triggerId: t4
        };
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    const { fireTrigger: fireCtaClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t5);
    let t6;
    if ($[6] !== requestMessageStartTrigger) {
        t6 = ()=>{
            requestMessageStartTrigger({
                isActive: true
            });
        };
        $[6] = requestMessageStartTrigger;
        $[7] = t6;
    } else t6 = $[7];
    const requestMessageStart = t6;
    let t7;
    if ($[8] !== fireDismissClickTrigger) {
        t7 = ()=>{
            fireDismissClickTrigger({
                isActive: true
            });
        };
        $[8] = fireDismissClickTrigger;
        $[9] = t7;
    } else t7 = $[9];
    const dismissMessage = t7;
    let t8;
    if ($[10] !== fireCtaClickTrigger) {
        t8 = ()=>{
            fireCtaClickTrigger({
                isActive: true
            });
        };
        $[10] = fireCtaClickTrigger;
        $[11] = t8;
    } else t8 = $[11];
    const handlePostOfficeClickTracking = t8;
    let t9;
    if ($[12] !== dismissMessage || $[13] !== handlePostOfficeClickTracking || $[14] !== hasMessageStarted || $[15] !== requestMessageStart) {
        t9 = {
            hasMessageStarted: hasMessageStarted,
            requestMessageStart: requestMessageStart,
            dismissMessage: dismissMessage,
            handlePostOfficeClickTracking: handlePostOfficeClickTracking
        };
        $[12] = dismissMessage;
        $[13] = handlePostOfficeClickTracking;
        $[14] = hasMessageStarted;
        $[15] = requestMessageStart;
        $[16] = t9;
    } else t9 = $[16];
    return t9;
} : (messageId)=>{
    // listeners
    const { isActive: hasMessageStarted } = $e71ebdc70c2ecd2e$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $cozmU.useCallback)(()=>{
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger
    ]);
    const dismissMessage = (0, $cozmU.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $cozmU.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};
module.exports["TriggerContextProvider"] = $e71ebdc70c2ecd2e$export$e80a5720bb4c8fe3;
module.exports["useTrigger"] = $e71ebdc70c2ecd2e$export$3b196fe93a948c18;
module.exports["useFirePostOfficeTrigger"] = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64;
module.exports["usePostOfficeExernalMessageProxy"] = $e71ebdc70c2ecd2e$export$e45375ff75169f;

});

parcelRegister("e79Od", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $l7jo6 = parcelRequire("l7jo6");


var $3d3WW = parcelRequire("3d3WW");

const $d5b433beb4d04640$var$ENGAGEMENT_PLATFORM_CHANNEL = 'engagementPlatform';
const $d5b433beb4d04640$var$isPromise = (value)=>{
    return value && typeof value.then === 'function';
};
const $d5b433beb4d04640$export$3476bc3bd0845b44 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, analyticsClientInstance: analyticsClientInstance } = t0;
    let t1;
    if ($[0] !== analyticsClientInstance) {
        t1 = (event)=>{
            if (!analyticsClientInstance) return;
            const { eventType: eventType, attributes: attributes, ...restPayload } = event.payload || {};
            const userId = restPayload?.userId || attributes?.userId;
            const tenantId = restPayload?.tenantId || attributes?.tenantId;
            if (eventType !== "track" && eventType !== "operational") return;
            if (!userId || !tenantId) return;
            const processEvent = (client)=>{
                try {
                    if (tenantId) client.setTenantInfo((0, $l7jo6.tenantType).CLOUD_ID, tenantId);
                    if (userId) client.setUserInfo((0, $l7jo6.userType).ATLASSIAN_ACCOUNT, userId);
                } catch (t2) {
                    return;
                }
                const gasPayload = {
                    ...restPayload,
                    tenantId: tenantId,
                    ...attributes ? {
                        attributes: attributes
                    } : {}
                };
                if (eventType === "track") client.sendTrackEvent(gasPayload);
                else if (eventType === "operational") client.sendOperationalEvent(gasPayload);
            };
            if ($d5b433beb4d04640$var$isPromise(analyticsClientInstance)) analyticsClientInstance.then(processEvent);
            else processEvent(analyticsClientInstance);
        };
        $[0] = analyticsClientInstance;
        $[1] = t1;
    } else t1 = $[1];
    const handleEvent = t1;
    let t2;
    if ($[2] !== children || $[3] !== handleEvent) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
            channel: $d5b433beb4d04640$var$ENGAGEMENT_PLATFORM_CHANNEL,
            onEvent: handleEvent
        }, children);
        $[2] = children;
        $[3] = handleEvent;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ children: children, analyticsClientInstance: analyticsClientInstance })=>{
    const handleEvent = (0, $cozmU.useCallback)((event)=>{
        if (!analyticsClientInstance) return;
        const { eventType: eventType, attributes: attributes, ...restPayload } = event.payload || {};
        const userId = restPayload?.userId || attributes?.userId;
        const tenantId = restPayload?.tenantId || attributes?.tenantId;
        if (eventType !== 'track' && eventType !== 'operational') return;
        if (!userId || !tenantId) return;
        // Handle Promise if analyticsClientInstance is a Promise
        const processEvent = (client)=>{
            // Update client with user and tenant info
            try {
                if (tenantId) client.setTenantInfo((0, $l7jo6.tenantType).CLOUD_ID, tenantId);
                if (userId) client.setUserInfo((0, $l7jo6.userType).ATLASSIAN_ACCOUNT, userId);
            } catch (error) {
                return;
            }
            // Build payload with tenantId at top level (userId is automatically included via setUserInfo)
            const gasPayload = {
                ...restPayload,
                tenantId: tenantId,
                ...attributes ? {
                    attributes: attributes
                } : {}
            };
            if (eventType === 'track') client.sendTrackEvent(gasPayload);
            else if (eventType === 'operational') client.sendOperationalEvent(gasPayload);
        };
        if ($d5b433beb4d04640$var$isPromise(analyticsClientInstance)) analyticsClientInstance.then(processEvent);
        else processEvent(analyticsClientInstance);
    }, [
        analyticsClientInstance
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        channel: $d5b433beb4d04640$var$ENGAGEMENT_PLATFORM_CHANNEL,
        onEvent: handleEvent
    }, children);
};
module.exports["EPExposuresListener"] = $d5b433beb4d04640$export$3476bc3bd0845b44;

});

parcelRegister("blkyl", function(module, exports) {
const $3d63cb5f2152d1a1$export$ae3dab16eb1fc2cc = (defaultEnvironmentValues, environmentWithOverrides)=>{
    const { env: env, overrides: overrides } = environmentWithOverrides;
    return {
        currentEnv: env,
        envConfigs: {
            ...defaultEnvironmentValues.envConfigs,
            [env]: {
                remoteModule: {
                    origin: overrides?.remoteModule?.origin ?? defaultEnvironmentValues.envConfigs[env].remoteModule.origin,
                    pathname: overrides?.remoteModule?.pathname ?? defaultEnvironmentValues.envConfigs[env].remoteModule.pathname,
                    searchParams: overrides?.remoteModule?.searchParams ?? defaultEnvironmentValues.envConfigs[env].remoteModule.searchParams
                },
                api: {
                    origin: overrides?.api?.origin ?? defaultEnvironmentValues.envConfigs[env].api.origin,
                    pathname: overrides?.api?.pathname ?? defaultEnvironmentValues.envConfigs[env].api.pathname,
                    searchParams: overrides?.api?.searchParams ?? defaultEnvironmentValues.envConfigs[env].api.searchParams
                }
            }
        }
    };
};
module.exports["generateEnvironmentConfigWithOverrides"] = $3d63cb5f2152d1a1$export$ae3dab16eb1fc2cc;

});

parcelRegister("2295f", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3PVFp = parcelRequire("3PVFp");

parcelRequire("6YrB3");
var $f9XbP = parcelRequire("f9XbP");

const $af0c3fa8f4094b14$var$STORAGE_KEY = 'POST_OFFICE__CLIENT_CACHE';
const $af0c3fa8f4094b14$var$CACHE_KEY = 'placement-api';
const $af0c3fa8f4094b14$var$CACHE_EXPIRY = 120000; // 2 minutes
const $af0c3fa8f4094b14$var$storageClient = new (0, $f9XbP.StorageClient)($af0c3fa8f4094b14$var$STORAGE_KEY);
const $af0c3fa8f4094b14$export$3c979fbaa76beaf9 = (cache)=>{
    if (cache instanceof Map && cache.size > 0) {
        const existingCache = $af0c3fa8f4094b14$export$54eb3e634424b746();
        const mergedCache = new Map([
            ...existingCache,
            ...cache
        ]);
        const appCache = Array.from(mergedCache.entries());
        // localStorage.getItem("POST_OFFICE__CLIENT_CACHE_placement-api")
        $af0c3fa8f4094b14$var$storageClient.setItemWithExpiry($af0c3fa8f4094b14$var$CACHE_KEY, appCache, $af0c3fa8f4094b14$var$CACHE_EXPIRY);
    }
};
const $af0c3fa8f4094b14$export$54eb3e634424b746 = ()=>{
    if (typeof window === 'undefined') // Return a dummy storage for server-side rendering
    return new Map();
    // When initializing, we restore the data from `localStorage` into a map.
    const cache = $af0c3fa8f4094b14$var$storageClient.getItem($af0c3fa8f4094b14$var$CACHE_KEY) || [];
    return new Map(cache);
};
const $af0c3fa8f4094b14$export$711c5bb855c82238 = (useSWRNext)=>{
    return (key, fetcher, config)=>{
        const { cache: cache } = (0, $3PVFp.useSWRConfig)();
        const swr = useSWRNext(key, fetcher, config);
        /**
     * This will execute even when data is pulled from the local storage cache.
     * This means that the cache will be updated and the CACHE_EXPIRY reset to be a rolling window.
     *
     * We may want to change this behaviour in the future to only update the cache when the data is NOT pulled from the local storage cache.
     */ (0, $cozmU.useEffect)(()=>{
            if (swr.data !== undefined) $af0c3fa8f4094b14$export$3c979fbaa76beaf9(cache);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            swr.data
        ]);
        return swr;
    };
};
module.exports["localStorageCacheProvider"] = $af0c3fa8f4094b14$export$54eb3e634424b746;
module.exports["postOfficeCacheMiddleware"] = $af0c3fa8f4094b14$export$711c5bb855c82238;

});

parcelRegister("5nuFe", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $f7e158d3e97078e1$export$e5c6d63c1f3f867f = (0, $cozmU.createContext)({
    usePageRecommendationData: ()=>({
            data: undefined,
            loading: false,
            hoverPageError: undefined,
            recPageError: undefined
        }),
    useInlineReactionsData: (_numberOfReactedUsers, _skip)=>({
            data: {
                authorName: undefined,
                authorAvatar: undefined,
                reactionsCount: undefined,
                reactionsSummary: undefined,
                reactedUsers: undefined,
                userId: undefined,
                activationId: undefined
            },
            loading: false,
            error: undefined
        }),
    getPageDataFromUrl: ()=>({
            contentId: undefined,
            contentType: undefined,
            spaceKey: undefined
        }),
    emojiProvider: undefined
});
module.exports["ConfluenceExperimentsContext"] = $f7e158d3e97078e1$export$e5c6d63c1f3f867f;

});

parcelRegister("7Px0t", function(module, exports) {
const $5fe4063a771982d5$export$bc4310477dcd6b19 = {
    ATLASSIAN_SWITCHER: 'atlassianSwitcher',
    PROJECT_PAGES: 'project-pages',
    TWC_MARKETING_EMAIL: 'marketingEmail',
    CONFLUENCE_HOME: 'confluenceHome',
    WAC: 'wac',
    STORYBOOK: 'storybook',
    TEST: 'test',
    TWC_XFLOW_CONFLUENCE_TEMPLATE: 'confluence-template-xflow'
};
const $5fe4063a771982d5$export$1b7797189cccf3b2 = {
    ATLASSIAN_SWITCHER_TRY: 'atlassianSwitcherTry',
    PROJECT_PAGES: 'project-pages',
    WAC_HOMEPAGE_TWC_OFFER: 'wacHomepageTwcOffer',
    STORYBOOK: 'storybook',
    TEST: 'test',
    // TWC Marketing Email (twc-marketing-email-v2) CTA contexts
    JIRA_PLATFORM_TOP_CTA: 'jiraPlatformTopCta',
    JIRA_PLATFORM_BOTTOM_CTA: 'jiraPlatformBottomCta',
    JIRA_ARTICLE_TOP_CTA: 'jiraArticleTopCta',
    JIRA_ARTICLE_BOTTOM_CTA: 'jiraArticleBottomCta',
    JIRA_DATA_TOP_CTA: 'jiraDataTopCta',
    JIRA_DATA_BOTTOM_CTA: 'jiraDataBottomCta',
    CONFLUENCE_PLATFORM_TOP_CTA: 'confluencePlatformTopCta',
    CONFLUENCE_PLATFORM_BOTTOM_CTA: 'confluencePlatformBottomCta',
    CONFLUENCE_ARTICLE_TOP_CTA: 'confluenceArticleTopCta',
    CONFLUENCE_ARTICLE_BOTTOM_CTA: 'confluenceArticleBottomCta',
    CONFLUENCE_DATA_TOP_CTA: 'confluenceDataTopCta',
    CONFLUENCE_DATA_BOTTOM_CTA: 'confluenceDataBottomCta',
    JIRA_CONF_PLATFORM_TOP_CTA: 'jiraConfPlatformTopCta',
    JIRA_CONF_PLATFORM_BOTTOM_CTA: 'jiraConfPlatformBottomCta',
    JIRA_CONF_ARTICLE_TOP_CTA: 'jiraConfArticleTopCta',
    JIRA_CONF_ARTICLE_BOTTOM_CTA: 'jiraConfArticleBottomCta',
    JIRA_CONF_DATA_TOP_CTA: 'jiraConfDataTopCta',
    JIRA_CONF_DATA_BOTTOM_CTA: 'jiraConfDataBottomCta',
    // TWCG-1794: atlassian-switcher Loom intercept (offer TWC over standalone Loom)
    ATLASSIAN_SWITCHER_LOOM_INTERCEPT: 'atlassianSwitcherLoomIntercept',
    LOOM_MEETINGS_PILL: 'loomMeetingsPill',
    CONFLUENCE_XFLOW_SIDENAV: 'confluence-xflow-sidenav',
    CONFLUENCE_XFLOW_FLAG: 'confluence-xflow-flag',
    CONFLUENCE_MEETINGS_TAB: 'confluence-meetings-tab'
};
module.exports["SOURCE_COMPONENT"] = $5fe4063a771982d5$export$bc4310477dcd6b19;
module.exports["SOURCE_CONTEXT"] = $5fe4063a771982d5$export$1b7797189cccf3b2;

});

parcelRegister("8dbvt", function(module, exports) {

var $cxMI6 = parcelRequire("cxMI6");

const $d8f8e39152f0bc27$export$19f6fc45ac74736 = (data, strategiesCounter)=>{
    const pageCardData = (0, $cxMI6.transformGlobalContent)(data.content);
    pageCardData.likesCount = 0;
    pageCardData.commentsCount = 0;
    pageCardData.recommendationStrategy = $d8f8e39152f0bc27$export$7c50bf2d337b5c51(data, strategiesCounter);
    return pageCardData;
};
const $d8f8e39152f0bc27$export$7c50bf2d337b5c51 = (data, strategiesCounter)=>{
    const strategies = data.strategy;
    if (strategies.includes('CONTENT_TO_CONTENT')) return 'CONTENT_TO_CONTENT';
    const currentCounter = new Map();
    strategies.forEach((entry)=>{
        const entryCount = strategiesCounter.get(entry) || 0;
        currentCounter.set(entry, entryCount);
    });
    const sortedCounter = new Map([
        ...currentCounter.entries()
    ].sort((a, b)=>a[1] - b[1]));
    const strategy = [
        ...sortedCounter.keys()
    ][0];
    const count = strategiesCounter.get(strategy) || 0;
    strategiesCounter.set(strategy, count + 1);
    return strategy;
};
const $d8f8e39152f0bc27$export$9c80c5ff7d0b31d7 = (recs)=>{
    if (!recs) return;
    const strategiesCounter = new Map();
    const recsSortedByStrategyCount = [
        ...recs
    ].sort((a, b)=>a.strategy.length > b.strategy.length ? 1 : -1);
    const transformedRecs = recsSortedByStrategyCount.map((rec)=>$d8f8e39152f0bc27$export$19f6fc45ac74736(rec, strategiesCounter));
    // return to initial order
    const pageCards = new Array();
    recs.forEach((rec)=>{
        const contentId = rec?.content?.id;
        if (!contentId) return;
        const el = transformedRecs.find((card)=>card?.id === contentId);
        if (el) pageCards.push(el);
    });
    return pageCards;
};
module.exports["transformEndOfPageRecContent"] = $d8f8e39152f0bc27$export$19f6fc45ac74736;
module.exports["transformAndOrderRecs"] = $d8f8e39152f0bc27$export$9c80c5ff7d0b31d7;

});

parcelRegister("cxMI6", function(module, exports) {

var $brn6e = parcelRequire("brn6e");


var $8rneB = parcelRequire("8rneB");


var $huWyw = parcelRequire("huWyw");


var $c7GB4 = parcelRequire("c7GB4");

const $c6273926c8df4325$var$ALL_CONTENT_TYPE = [
    'page',
    'blogpost',
    'whiteboard',
    'database',
    'embed',
    'folder',
    'slide'
];
const $c6273926c8df4325$var$resumeDraftWebUiBypass = (urlPath, content)=>{
    const bypassUrl = (0, $huWyw.getURLBypassingResumeDraftAction)({
        url: urlPath || '',
        spaceKey: content?.space?.alias || content?.space?.key || '',
        contentType: content?.type,
        editorVersion: content?.editorVersion?.nodes?.[0]?.value?.replace(/['"]+/g, ''),
        contentId: content?.id || '',
        noContextPath: true
    });
    return bypassUrl;
};
const $c6273926c8df4325$export$a0bd4958aceee288 = (content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent)=>{
    const EMOJI_CONTENT_TYPE = isWhiteboardEmojiFGEnabled ? [
        'page',
        'blogpost',
        'embed',
        'whiteboard',
        'slide'
    ] : [
        'page',
        'blogpost',
        'embed'
    ];
    const contentType = $c6273926c8df4325$var$ALL_CONTENT_TYPE.includes(content?.type) ? content.type : 'page';
    if (isActivityV3HomeRecent) return {
        id: (0, $c7GB4.getIdFromConfluenceContentAri)({
            ari: content?.id,
            resourceType: contentType
        }) || '',
        status: content?.status === 'draft' || content?.status === 'unpublished' ? content?.status : undefined,
        // @ts-expect-error TODO FIXME there is some deep null mismatch, which might be worth fixing
        title: (0, $brn6e.getTitleAndEmoji)(content?.title, content?.metadata?.titleEmojiPublished?.value || '', content?.metadata?.titleEmojiDraft?.value || '', content?.status, untitledDraftText, EMOJI_CONTENT_TYPE.includes(contentType)),
        type: contentType,
        subType: content?.subtype,
        editorVersion: content?.editorVersion,
        links: {
            editui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.editUi, content),
            webui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.webUi, content)
        },
        isStarred: content?.viewer?.favoritedSummary?.isFavorite || false,
        likesCount: content?.likesSummary?.count || 0,
        commentsCount: content?.commentCountSummary?.total || 0,
        excerpt: content?.body?.excerpt?.trim()
    };
    return {
        id: content?.id || '',
        status: content?.status === 'draft' || content?.status === 'unpublished' ? content?.status : undefined,
        // @ts-expect-error TODO FIXME there is some deep null mismatch, which might be worth fixing
        title: (0, $brn6e.getTitleAndEmoji)(content?.title, (0, $8rneB.getEmojiPublishedFromProperties)(content), (0, $8rneB.getEmojiDraftFromProperties)(content), content?.status, untitledDraftText, EMOJI_CONTENT_TYPE.includes(contentType)),
        type: contentType,
        subType: content?.subType,
        editorVersion: content?.editorVersion,
        links: {
            editui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.editui, content),
            webui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.webui, content)
        },
        isStarred: content?.metadata?.currentuser?.favourited?.isFavourite || false,
        likesCount: content?.likes?.count || 0,
        commentsCount: content?.metadata?.comments?.commentsCount || 0,
        excerpt: content?.excerpt?.trim(),
        lastAction: {
            when: content?.metadata?.lastModifiedDate || '',
            action: 'updated'
        }
    };
};
const $c6273926c8df4325$export$898674fde3fd0597 = (content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent = false)=>{
    const spaceAlias = content?.space?.alias || content?.space?.key;
    return {
        ...$c6273926c8df4325$export$a0bd4958aceee288(content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent),
        space: {
            spaceKey: spaceAlias || '',
            name: content?.space?.name || ''
        },
        creatorId: content?.creatorId || '',
        history: {
            ownedBy: {
                displayName: content?.history?.ownedBy?.displayName || ''
            }
        }
    };
};
const $c6273926c8df4325$export$1e1d4cb60561af2b = (content, untitledDraftText = '', isWhiteboardEmojiFGEnabled = false)=>{
    const createdBy = content?.status === 'draft' ? content?.version?.by : content?.history?.createdBy;
    const ownedBy = content?.status === 'draft' ? content?.version?.by : content?.history?.ownedBy;
    return {
        ...$c6273926c8df4325$export$a0bd4958aceee288(content, untitledDraftText, isWhiteboardEmojiFGEnabled),
        createdBy: {
            displayName: createdBy?.displayName || '',
            profilePicture: createdBy?.profilePicture?.path || '',
            accountId: createdBy?.accountId || ''
        },
        ownedBy: {
            displayName: ownedBy?.displayName || '',
            profilePicture: ownedBy?.profilePicture?.path || '',
            accountId: ownedBy?.accountId || ''
        }
    };
};
const $c6273926c8df4325$export$ee67d5d6f48183b0 = (card)=>Boolean(card.createdBy);
module.exports["transformGlobalContent"] = $c6273926c8df4325$export$898674fde3fd0597;
module.exports["transformSpaceContent"] = $c6273926c8df4325$export$1e1d4cb60561af2b;
module.exports["isSpacePageCard"] = $c6273926c8df4325$export$ee67d5d6f48183b0;

});

parcelRegister("brn6e", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $7PLO8 = parcelRequire("7PLO8");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $6mKj3 = parcelRequire("6mKj3");


var $3shHM = parcelRequire("3shHM");


var $8rneB = parcelRequire("8rneB");


var $5DJsZ = parcelRequire("5DJsZ");


var $5amrO = parcelRequire("5amrO");

const $a7a7184e7345058e$export$8807f1cb55bf77de = async ({ userId: userId, cloudId: cloudId, emojiId: emojiId })=>{
    const provider = await (0, $8rneB.getEmojiProvider)(cloudId, userId);
    if (provider) {
        const emoji = await provider.findById(emojiId);
        if (emoji) return provider.loadMediaEmoji(emoji);
    }
    return Promise.resolve(null);
};
const $a7a7184e7345058e$export$66e71aac8865f81a = /([a-z\d_-]+):/;
let $a7a7184e7345058e$var$hasSetFavicon = false;
let $a7a7184e7345058e$var$previousFavicon = null;
const $a7a7184e7345058e$var$updateFaviconHref = (href)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const favIcons = document.querySelectorAll("link[rel~='icon']");
    favIcons.forEach((linkEl)=>{
        // remember default favicon on first change in case we need to revert
        if (!$a7a7184e7345058e$var$hasSetFavicon) {
            $a7a7184e7345058e$var$previousFavicon = linkEl.href;
            $a7a7184e7345058e$var$hasSetFavicon = true;
        }
        linkEl.href = href;
    });
};
const $a7a7184e7345058e$export$4bb2c221b7e4cc0 = (emoji)=>{
    if (!(0, $iDrrr.fg)('confluence_emoji_title_favicon')) return;
    if (!emoji) {
        if ($a7a7184e7345058e$var$hasSetFavicon && $a7a7184e7345058e$var$previousFavicon) $a7a7184e7345058e$var$updateFaviconHref($a7a7184e7345058e$var$previousFavicon);
        return;
    }
    $a7a7184e7345058e$var$updateFaviconHref(emoji);
};
const $a7a7184e7345058e$export$ea48fb6f63107646 = async ({ selectedEmoji: selectedEmoji, emojiProvider: emojiProvider, onUpdateStartEmoji: onUpdateStartEmoji, createAnalyticsEvent: createAnalyticsEvent, emojiTitleState: emojiTitleState, onEmojiUpdated: onEmojiUpdated, onUpdateEndEmoji: onUpdateEndEmoji, updateContentProperty: updateContentProperty, contentId: contentId, componentName: componentName, isLivePage: isLivePage, emojiStatusFieldName: emojiStatusFieldName, aiSuggestedEmojiId: aiSuggestedEmojiId, isSmartCreate: isSmartCreate, hasReplacedAIFCEmoji: hasReplacedAIFCEmoji, setHasReplacedAIFCEmoji: setHasReplacedAIFCEmoji, aiEmojiSuggestionSource: aiEmojiSuggestionSource }, _event)=>{
    onUpdateStartEmoji && onUpdateStartEmoji();
    // Snapshot before overwrite to detect if the AIFC-suggested emoji was replaced.
    const previouslySelectedEmoji = emojiTitleState.state.selectedEmoji;
    const previouslySelectedEmojiId = typeof previouslySelectedEmoji === 'string' ? previouslySelectedEmoji : previouslySelectedEmoji?.id;
    const replacedAIFCSuggestedEmoji = !hasReplacedAIFCEmoji && !!isSmartCreate && !!aiSuggestedEmojiId && previouslySelectedEmojiId === aiSuggestedEmojiId;
    if (replacedAIFCSuggestedEmoji) setHasReplacedAIFCEmoji?.(true);
    const replacedBlankPageAutoSuggestedEmoji = !hasReplacedAIFCEmoji && aiEmojiSuggestionSource === 'pasteAutoTitle' && !!aiSuggestedEmojiId && previouslySelectedEmojiId === aiSuggestedEmojiId;
    if (replacedBlankPageAutoSuggestedEmoji) setHasReplacedAIFCEmoji?.(true);
    const replacedSuggestTitleSuggestedEmoji = !hasReplacedAIFCEmoji && aiEmojiSuggestionSource === 'suggestTitle' && !!aiSuggestedEmojiId && previouslySelectedEmojiId === aiSuggestedEmojiId;
    if (replacedSuggestTitleSuggestedEmoji) setHasReplacedAIFCEmoji?.(true);
    // Snapshot the shared flag at fire time so the value reflects the latest
    // state regardless of when/where the picker JSX was created.
    const justRestoredEmoji = !!emojiTitleState.justRestoredEmoji;
    (0, $3shHM.sendAnalyticsEvent)(createAnalyticsEvent, {
        eventType: 'sendUIEvent',
        element: 'button',
        action: 'clicked',
        actionSubject: 'emojiPicker',
        actionSubjectId: 'emoji',
        attributes: {
            emojiId: selectedEmoji?.id,
            inputMethod: 'title',
            isLivePage: isLivePage,
            replacedAIFCSuggestedEmoji: replacedAIFCSuggestedEmoji,
            replacedBlankPageAutoSuggestedEmoji: replacedBlankPageAutoSuggestedEmoji,
            replacedSuggestTitleSuggestedEmoji: replacedSuggestTitleSuggestedEmoji,
            aiEmojiSuggestionSource: aiEmojiSuggestionSource,
            isRestoreLatestEmojiEnabled: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_livedocs_restore_latest_emoji'),
            replacedRestoredEmoji: justRestoredEmoji
        }
    });
    // Reset after firing so the next selection correctly reports
    // replacedRestoredEmoji=false.
    emojiTitleState.justRestoredEmoji = false;
    const propertyKey = (0, $5amrO.convertEmojiFieldNameToPropertyKey)(emojiStatusFieldName);
    const loadedEmoji = await emojiProvider.loadMediaEmoji(selectedEmoji, true);
    emojiTitleState.setOpenSecondEmojiPicker(false);
    emojiTitleState.setSelectedEmoji(loadedEmoji);
    return onEmojiUpdated().then(({ data: data })=>{
        const versionNumber = (0, $8rneB.getVersionNumber)(data, emojiStatusFieldName);
        const newVersionNumber = versionNumber ? versionNumber + 1 : 1;
        const emojiValue = selectedEmoji?.id?.replace(/['"]+/g, '') ?? '';
        return updateContentProperty({
            propertyKey: propertyKey,
            propertyValue: emojiValue,
            hasExistingProperty: versionNumber > 0,
            options: {
                update: ()=>{
                    try {
                        const cacheData = (0, $l1uFv.readQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            __callerPackage__: "emoji-title"
                        });
                        if (cacheData.content.nodes[0][emojiStatusFieldName]) cacheData.content.nodes[0][emojiStatusFieldName].nodes[0] = {
                            ...cacheData.content.nodes[0][emojiStatusFieldName].nodes[0],
                            id: contentId,
                            key: propertyKey,
                            value: emojiValue,
                            version: {
                                number: newVersionNumber,
                                __typename: 'Version'
                            }
                        };
                        (0, $fEmGS.writeQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            data: data,
                            __callerPackage__: "emoji-title"
                        });
                    } catch (error) {
                        throw new Error(`${componentName} failed to write to cache while updating ${propertyKey} content property after user selecting emoji ${error.message}`);
                    }
                }
            },
            shouldOptimisticResponse: true
        }).then(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
            emojiTitleState.setSelectedEmoji(loadedEmoji);
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user selecting emoji ${error.message}`);
        });
    });
};
const $a7a7184e7345058e$export$fbfb144f0da80edc = (_event, { onUpdateStartEmoji: onUpdateStartEmoji, onUpdateEndEmoji: onUpdateEndEmoji, onEmojiUpdated: onEmojiUpdated, contentId: contentId, updateContentProperty: updateContentProperty, componentName: componentName = '', emojiStatusFieldName: emojiStatusFieldName })=>{
    onUpdateStartEmoji && onUpdateStartEmoji();
    const propertyKey = (0, $5amrO.convertEmojiFieldNameToPropertyKey)(emojiStatusFieldName);
    return onEmojiUpdated().then(()=>{
        return updateContentProperty({
            propertyKey: propertyKey,
            isDelete: true,
            options: {
                update: ()=>{
                    try {
                        const data = (0, $l1uFv.readQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            __callerPackage__: "emoji-title"
                        });
                        data.content.nodes[0][emojiStatusFieldName] = {
                            nodes: [],
                            __typename: 'PaginatedJsonContentPropertyList'
                        };
                        (0, $fEmGS.writeQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            data: data,
                            __callerPackage__: "emoji-title"
                        });
                    } catch (error) {
                        throw new Error(`${componentName} failed to write to cache while updating content property after user removing emoji ${error.message}`);
                    }
                }
            },
            shouldOptimisticResponse: true
        }).finally(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user removing emoji ${error.message}`);
        });
    });
};
const $a7a7184e7345058e$export$8c0236acf4c550c0 = RegExp("^(\\p{RI}\\p{RI}|\\p{Extended_Pictographic}(\\p{Emoji_Modifier}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?(\\u{200D}\\p{Extended_Pictographic}(\\p{Emoji_Modifier}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?)*)", "u");
const $a7a7184e7345058e$export$cb9bb843138d9261 = (title)=>title && title.replace($a7a7184e7345058e$export$8c0236acf4c550c0, '').trimLeft() || '';
const $a7a7184e7345058e$export$9d1875ac2476f6b6 = (title)=>title && $a7a7184e7345058e$export$8c0236acf4c550c0.exec(title)?.[0] || '';
const $a7a7184e7345058e$export$388f90f8e727e4d5 = (rawTitle = '', rawPublishedEmoji = '', rawDraftEmoji = '', status = '', untitledDraftText = '', getEmoji = true)=>{
    const nativeEmoji = getEmoji ? $a7a7184e7345058e$export$9d1875ac2476f6b6(rawTitle) : '';
    let selectedEmoji = '';
    if (getEmoji) selectedEmoji = status?.toLowerCase() === 'draft' ? rawDraftEmoji : rawPublishedEmoji;
    const hasNativeEmoji = nativeEmoji.length > 0;
    const hasSelectedEmoji = selectedEmoji.length > 0;
    const emoji = hasSelectedEmoji ? selectedEmoji : nativeEmoji;
    let text = hasNativeEmoji && !hasSelectedEmoji ? $a7a7184e7345058e$export$cb9bb843138d9261(rawTitle) : rawTitle;
    if (status === 'draft' && !text) text = untitledDraftText;
    return {
        text: text,
        emoji: emoji,
        selectedEmoji: selectedEmoji
    };
};
module.exports["getEmojiFromEmojiId"] = $a7a7184e7345058e$export$8807f1cb55bf77de;
module.exports["maybeOverrideFaviconWithEmoji"] = $a7a7184e7345058e$export$4bb2c221b7e4cc0;
module.exports["onSelectEmoji"] = $a7a7184e7345058e$export$ea48fb6f63107646;
module.exports["onRemoveEmoji"] = $a7a7184e7345058e$export$fbfb144f0da80edc;
module.exports["emojiExp"] = $a7a7184e7345058e$export$8c0236acf4c550c0;
module.exports["removeEmojiFromTitle"] = $a7a7184e7345058e$export$cb9bb843138d9261;
module.exports["getEmojiFromTitle"] = $a7a7184e7345058e$export$9d1875ac2476f6b6;
module.exports["getTitleAndEmoji"] = $a7a7184e7345058e$export$388f90f8e727e4d5;

});

parcelRegister("l1uFv", function(module, exports) {

var $jWnFe = parcelRequire("jWnFe");


var $eqEJl = parcelRequire("eqEJl");


var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");


var $7M67g = parcelRequire("7M67g");

const $65c7b8940c778902$var$CLIENT_EDGE_TRAVERSAL_PATH_KEY = '__clientEdgeTraversalPath';
function $65c7b8940c778902$var$cloneRelayQueryResult(data) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jWnFe)))(data, (value, key)=>{
        // Relay fragment refs can contain operation descriptors and client-edge reader nodes.
        // Keep that internal metadata by reference while restoring Apollo-compatible mutable data.
        if (key === (0, $eqEJl.FRAGMENT_OWNER_KEY) || key === $65c7b8940c778902$var$CLIENT_EDGE_TRAVERSAL_PATH_KEY) return value;
        return undefined;
    });
}
function $65c7b8940c778902$export$627cb922211284f(params) {
    const operationName = (0, $7M67g.getRelayOperationName)(params.query);
    const source = (0, $iffSy.isRelayEnabled)(params.__callerPackage__, {
        operationName: operationName,
        phase: 'cache'
    }) ? 'relay' : 'apollo';
    // Cache reads stay native to the selected route. The cache bridge only
    // mirrors successful writes/results into the other cache.
    return $65c7b8940c778902$var$readQueryInteropOriginal(params, source);
}
function $65c7b8940c778902$var$readQueryInteropOriginal(params, source) {
    return source === 'relay' ? $65c7b8940c778902$var$readQueryInteropRelay(params) : $65c7b8940c778902$var$readQueryInteropApollo(params);
}
function $65c7b8940c778902$var$readQueryInteropRelay(params) {
    const relayEnv = typeof window !== 'undefined' ? window.GLOBAL_RELAY_ENV : undefined;
    if (!relayEnv) throw new Error(`[Relay migration] Missing GLOBAL_RELAY_ENV for readQueryInterop; ${params.__callerPackage__}.`);
    const queryNode = params.query;
    if (!queryNode?.fragment || !queryNode?.operation) return null;
    const variables = params.variables ?? {};
    const operation = (0, $eqEJl.createOperationDescriptor)(queryNode, variables);
    const snapshot = relayEnv.lookup(operation.fragment);
    return snapshot.isMissingData ? null : $65c7b8940c778902$var$cloneRelayQueryResult(snapshot.data);
}
function $65c7b8940c778902$var$readQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].readQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["readQueryInterop"] = $65c7b8940c778902$export$627cb922211284f;

});

parcelRegister("jWnFe", function(module, exports) {

var $hGc5T = parcelRequire("hGc5T");

/** Used to compose bitmasks for cloning. */ var $e845ca4b0059397d$var$CLONE_DEEP_FLAG = 1, $e845ca4b0059397d$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.cloneWith` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the deep cloned value.
 * @see _.cloneWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(true);
 *   }
 * }
 *
 * var el = _.cloneDeepWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 20
 */ function $e845ca4b0059397d$var$cloneDeepWith(value, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    return $hGc5T(value, $e845ca4b0059397d$var$CLONE_DEEP_FLAG | $e845ca4b0059397d$var$CLONE_SYMBOLS_FLAG, customizer);
}
module.exports = $e845ca4b0059397d$var$cloneDeepWith;

});

parcelRegister("hGc5T", function(module, exports) {

var $1tgXD = parcelRequire("1tgXD");


var $7aPLP = parcelRequire("7aPLP");


var $aDCaS = parcelRequire("aDCaS");


var $e8WyO = parcelRequire("e8WyO");


var $lunGb = parcelRequire("lunGb");


var $19mn0 = parcelRequire("19mn0");


var $7WBxT = parcelRequire("7WBxT");


var $gwj3d = parcelRequire("gwj3d");


var $j60dZ = parcelRequire("j60dZ");


var $cTBpe = parcelRequire("cTBpe");


var $14dnq = parcelRequire("14dnq");


var $jOCrv = parcelRequire("jOCrv");


var $kGJE1 = parcelRequire("kGJE1");


var $cZmfO = parcelRequire("cZmfO");


var $jFqhM = parcelRequire("jFqhM");


var $1ScXu = parcelRequire("1ScXu");


var $6DVFM = parcelRequire("6DVFM");


var $aBDCC = parcelRequire("aBDCC");


var $izVFW = parcelRequire("izVFW");


var $1ji1e = parcelRequire("1ji1e");


var $f14Rr = parcelRequire("f14Rr");


var $dNyAN = parcelRequire("dNyAN");

/** Used to compose bitmasks for cloning. */ var $cdefbd8efe913551$var$CLONE_DEEP_FLAG = 1, $cdefbd8efe913551$var$CLONE_FLAT_FLAG = 2, $cdefbd8efe913551$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $cdefbd8efe913551$var$argsTag = '[object Arguments]', $cdefbd8efe913551$var$arrayTag = '[object Array]', $cdefbd8efe913551$var$boolTag = '[object Boolean]', $cdefbd8efe913551$var$dateTag = '[object Date]', $cdefbd8efe913551$var$errorTag = '[object Error]', $cdefbd8efe913551$var$funcTag = '[object Function]', $cdefbd8efe913551$var$genTag = '[object GeneratorFunction]', $cdefbd8efe913551$var$mapTag = '[object Map]', $cdefbd8efe913551$var$numberTag = '[object Number]', $cdefbd8efe913551$var$objectTag = '[object Object]', $cdefbd8efe913551$var$regexpTag = '[object RegExp]', $cdefbd8efe913551$var$setTag = '[object Set]', $cdefbd8efe913551$var$stringTag = '[object String]', $cdefbd8efe913551$var$symbolTag = '[object Symbol]', $cdefbd8efe913551$var$weakMapTag = '[object WeakMap]';
var $cdefbd8efe913551$var$arrayBufferTag = '[object ArrayBuffer]', $cdefbd8efe913551$var$dataViewTag = '[object DataView]', $cdefbd8efe913551$var$float32Tag = '[object Float32Array]', $cdefbd8efe913551$var$float64Tag = '[object Float64Array]', $cdefbd8efe913551$var$int8Tag = '[object Int8Array]', $cdefbd8efe913551$var$int16Tag = '[object Int16Array]', $cdefbd8efe913551$var$int32Tag = '[object Int32Array]', $cdefbd8efe913551$var$uint8Tag = '[object Uint8Array]', $cdefbd8efe913551$var$uint8ClampedTag = '[object Uint8ClampedArray]', $cdefbd8efe913551$var$uint16Tag = '[object Uint16Array]', $cdefbd8efe913551$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $cdefbd8efe913551$var$cloneableTags = {};
$cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$argsTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$arrayTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$arrayBufferTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$dataViewTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$boolTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$dateTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$float32Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$float64Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$int8Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$int16Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$int32Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$mapTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$numberTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$objectTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$regexpTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$setTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$stringTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$symbolTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$uint8Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$uint8ClampedTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$uint16Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$uint32Tag] = true;
$cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$errorTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$funcTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $cdefbd8efe913551$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $cdefbd8efe913551$var$CLONE_DEEP_FLAG, isFlat = bitmask & $cdefbd8efe913551$var$CLONE_FLAT_FLAG, isFull = bitmask & $cdefbd8efe913551$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$izVFW(value)) return value;
    var isArr = $1ScXu(value);
    if (isArr) {
        result = $kGJE1(value);
        if (!isDeep) return $7WBxT(value, result);
    } else {
        var tag = $jOCrv(value), isFunc = tag == $cdefbd8efe913551$var$funcTag || tag == $cdefbd8efe913551$var$genTag;
        if ($6DVFM(value)) return $19mn0(value, isDeep);
        if (tag == $cdefbd8efe913551$var$objectTag || tag == $cdefbd8efe913551$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $jFqhM(value);
            if (!isDeep) return isFlat ? $j60dZ(value, $lunGb(result, value)) : $gwj3d(value, $e8WyO(result, value));
        } else {
            if (!$cdefbd8efe913551$var$cloneableTags[tag]) return object ? value : {};
            result = $cZmfO(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $1tgXD);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($1ji1e(value)) value.forEach(function(subValue) {
        result.add($cdefbd8efe913551$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($aBDCC(value)) value.forEach(function(subValue, key) {
        result.set(key, $cdefbd8efe913551$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $14dnq : $cTBpe : isFlat ? $dNyAN : $f14Rr;
    var props = isArr ? undefined : keysFunc(value);
    $7aPLP(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $aDCaS(result, key, $cdefbd8efe913551$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $cdefbd8efe913551$var$baseClone;

});

parcelRegister("7aPLP", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $5391a0175a1872c4$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $5391a0175a1872c4$var$arrayEach;

});

parcelRegister("e8WyO", function(module, exports) {

var $bk5x8 = parcelRequire("bk5x8");


var $f14Rr = parcelRequire("f14Rr");

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $a4bf3cec5f860948$var$baseAssign(object, source) {
    return object && $bk5x8(source, $f14Rr(source), object);
}
module.exports = $a4bf3cec5f860948$var$baseAssign;

});

parcelRegister("lunGb", function(module, exports) {

var $bk5x8 = parcelRequire("bk5x8");


var $dNyAN = parcelRequire("dNyAN");

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $fa4ec48e79e3b749$var$baseAssignIn(object, source) {
    return object && $bk5x8(source, $dNyAN(source), object);
}
module.exports = $fa4ec48e79e3b749$var$baseAssignIn;

});

parcelRegister("gwj3d", function(module, exports) {

var $bk5x8 = parcelRequire("bk5x8");


var $j1qF4 = parcelRequire("j1qF4");

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $c06e699caf978d13$var$copySymbols(source, object) {
    return $bk5x8(source, $j1qF4(source), object);
}
module.exports = $c06e699caf978d13$var$copySymbols;

});

parcelRegister("j60dZ", function(module, exports) {

var $bk5x8 = parcelRequire("bk5x8");


var $ahKsp = parcelRequire("ahKsp");

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $de6ec073df6f66ec$var$copySymbolsIn(source, object) {
    return $bk5x8(source, $ahKsp(source), object);
}
module.exports = $de6ec073df6f66ec$var$copySymbolsIn;

});

parcelRegister("kGJE1", function(module, exports) {
/** Used for built-in method references. */ var $f0fb22f60689ed3d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f0fb22f60689ed3d$var$hasOwnProperty = $f0fb22f60689ed3d$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $f0fb22f60689ed3d$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $f0fb22f60689ed3d$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $f0fb22f60689ed3d$var$initCloneArray;

});

parcelRegister("cZmfO", function(module, exports) {

var $bAYSF = parcelRequire("bAYSF");


var $2nf4s = parcelRequire("2nf4s");


var $aOXy4 = parcelRequire("aOXy4");


var $cPFvk = parcelRequire("cPFvk");


var $39R3S = parcelRequire("39R3S");

/** `Object#toString` result references. */ var $974c71bfd764326f$var$boolTag = '[object Boolean]', $974c71bfd764326f$var$dateTag = '[object Date]', $974c71bfd764326f$var$mapTag = '[object Map]', $974c71bfd764326f$var$numberTag = '[object Number]', $974c71bfd764326f$var$regexpTag = '[object RegExp]', $974c71bfd764326f$var$setTag = '[object Set]', $974c71bfd764326f$var$stringTag = '[object String]', $974c71bfd764326f$var$symbolTag = '[object Symbol]';
var $974c71bfd764326f$var$arrayBufferTag = '[object ArrayBuffer]', $974c71bfd764326f$var$dataViewTag = '[object DataView]', $974c71bfd764326f$var$float32Tag = '[object Float32Array]', $974c71bfd764326f$var$float64Tag = '[object Float64Array]', $974c71bfd764326f$var$int8Tag = '[object Int8Array]', $974c71bfd764326f$var$int16Tag = '[object Int16Array]', $974c71bfd764326f$var$int32Tag = '[object Int32Array]', $974c71bfd764326f$var$uint8Tag = '[object Uint8Array]', $974c71bfd764326f$var$uint8ClampedTag = '[object Uint8ClampedArray]', $974c71bfd764326f$var$uint16Tag = '[object Uint16Array]', $974c71bfd764326f$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $974c71bfd764326f$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $974c71bfd764326f$var$arrayBufferTag:
            return $bAYSF(object);
        case $974c71bfd764326f$var$boolTag:
        case $974c71bfd764326f$var$dateTag:
            return new Ctor(+object);
        case $974c71bfd764326f$var$dataViewTag:
            return $2nf4s(object, isDeep);
        case $974c71bfd764326f$var$float32Tag:
        case $974c71bfd764326f$var$float64Tag:
        case $974c71bfd764326f$var$int8Tag:
        case $974c71bfd764326f$var$int16Tag:
        case $974c71bfd764326f$var$int32Tag:
        case $974c71bfd764326f$var$uint8Tag:
        case $974c71bfd764326f$var$uint8ClampedTag:
        case $974c71bfd764326f$var$uint16Tag:
        case $974c71bfd764326f$var$uint32Tag:
            return $39R3S(object, isDeep);
        case $974c71bfd764326f$var$mapTag:
            return new Ctor;
        case $974c71bfd764326f$var$numberTag:
        case $974c71bfd764326f$var$stringTag:
            return new Ctor(object);
        case $974c71bfd764326f$var$regexpTag:
            return $aOXy4(object);
        case $974c71bfd764326f$var$setTag:
            return new Ctor;
        case $974c71bfd764326f$var$symbolTag:
            return $cPFvk(object);
    }
}
module.exports = $974c71bfd764326f$var$initCloneByTag;

});

parcelRegister("2nf4s", function(module, exports) {

var $bAYSF = parcelRequire("bAYSF");

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $1ba96b89566301a8$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $bAYSF(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $1ba96b89566301a8$var$cloneDataView;

});

parcelRegister("aOXy4", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $7e0cc3fe33183417$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $7e0cc3fe33183417$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $7e0cc3fe33183417$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $7e0cc3fe33183417$var$cloneRegExp;

});

parcelRegister("cPFvk", function(module, exports) {

var $2v1OR = parcelRequire("2v1OR");

/** Used to convert symbols to primitives and strings. */ var $957a7155a4d05ec8$var$symbolProto = $2v1OR ? $2v1OR.prototype : undefined, $957a7155a4d05ec8$var$symbolValueOf = $957a7155a4d05ec8$var$symbolProto ? $957a7155a4d05ec8$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $957a7155a4d05ec8$var$cloneSymbol(symbol) {
    return $957a7155a4d05ec8$var$symbolValueOf ? Object($957a7155a4d05ec8$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $957a7155a4d05ec8$var$cloneSymbol;

});

parcelRegister("aBDCC", function(module, exports) {

var $aPSWx = parcelRequire("aPSWx");


var $gGzL7 = parcelRequire("gGzL7");


var $izBVL = parcelRequire("izBVL");

/* Node.js helper references. */ var $7b8c182c149a3e72$var$nodeIsMap = $izBVL && $izBVL.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $7b8c182c149a3e72$var$isMap = $7b8c182c149a3e72$var$nodeIsMap ? $gGzL7($7b8c182c149a3e72$var$nodeIsMap) : $aPSWx;
module.exports = $7b8c182c149a3e72$var$isMap;

});

parcelRegister("aPSWx", function(module, exports) {

var $jOCrv = parcelRequire("jOCrv");


var $7WFUU = parcelRequire("7WFUU");

/** `Object#toString` result references. */ var $7e3949613e91b78e$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $7e3949613e91b78e$var$baseIsMap(value) {
    return $7WFUU(value) && $jOCrv(value) == $7e3949613e91b78e$var$mapTag;
}
module.exports = $7e3949613e91b78e$var$baseIsMap;

});

parcelRegister("1ji1e", function(module, exports) {

var $l6Y5L = parcelRequire("l6Y5L");


var $gGzL7 = parcelRequire("gGzL7");


var $izBVL = parcelRequire("izBVL");

/* Node.js helper references. */ var $0f458af8916b54b7$var$nodeIsSet = $izBVL && $izBVL.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $0f458af8916b54b7$var$isSet = $0f458af8916b54b7$var$nodeIsSet ? $gGzL7($0f458af8916b54b7$var$nodeIsSet) : $l6Y5L;
module.exports = $0f458af8916b54b7$var$isSet;

});

parcelRegister("l6Y5L", function(module, exports) {

var $jOCrv = parcelRequire("jOCrv");


var $7WFUU = parcelRequire("7WFUU");

/** `Object#toString` result references. */ var $f5e8c58b63155910$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $f5e8c58b63155910$var$baseIsSet(value) {
    return $7WFUU(value) && $jOCrv(value) == $f5e8c58b63155910$var$setTag;
}
module.exports = $f5e8c58b63155910$var$baseIsSet;

});

parcelRegister("3shHM", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $8rneB = parcelRequire("8rneB");


var $5amrO = parcelRequire("5amrO");


var $5DJsZ = parcelRequire("5DJsZ");

const $d6c558249b167bda$export$5e53520e517ec9ab = (createAnalyticsEvent, { eventType: eventType, element: element, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes = {} })=>{
    createAnalyticsEvent({
        type: eventType,
        data: {
            action: action,
            source: 'EmojiTitleSection',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                element: element,
                ...attributes
            }
        }
    }).fire();
};
const $d6c558249b167bda$export$1fa99c5c7c4cc530 = async ({ createAnalyticsEvent: createAnalyticsEvent, contentId: contentId, isLivePage: isLivePage })=>{
    const { data: data } = await (0, $c0rhi.queryInterop)({
        query: (0, $5DJsZ.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            skipPublishedFragment: false
        },
        __callerPackage__: "emoji-title"
    });
    const emojiId = (0, $8rneB.getEmojiId)(data, (0, $5amrO.EMOJI_TITLE_DRAFT_FIELD));
    const hasDraftEmoji = emojiId.length >= 0 && emojiId !== '';
    // only track draft with emoji
    if (hasDraftEmoji) $d6c558249b167bda$export$5e53520e517ec9ab(createAnalyticsEvent, {
        eventType: 'sendTrackEvent',
        element: '',
        action: 'created',
        actionSubject: 'draftWithEmoji',
        actionSubjectId: '',
        attributes: {
            emojiId: emojiId,
            isLivePage: isLivePage
        }
    });
};
const $d6c558249b167bda$export$5a8401d422e6e576 = ({ createAnalyticsEvent: createAnalyticsEvent, emoji: emoji, context: context, error: error = {
    message: ''
}, isLivePage: isLivePage })=>{
    $d6c558249b167bda$export$5e53520e517ec9ab(createAnalyticsEvent, {
        eventType: 'sendTrackEvent',
        element: 'emoji',
        action: 'error',
        actionSubject: 'renderEmoji',
        actionSubjectId: 'renderEmojiError',
        attributes: {
            emojiShortName: emoji && emoji.shortName,
            emojiId: emoji && emoji.id,
            context: context,
            errorMessage: error.message,
            isLivePage: isLivePage
        }
    });
};
module.exports["sendAnalyticsEvent"] = $d6c558249b167bda$export$5e53520e517ec9ab;
module.exports["trackDraftCreatedWithEmoji"] = $d6c558249b167bda$export$1fa99c5c7c4cc530;
module.exports["onFailedToLoadEmoji"] = $d6c558249b167bda$export$5a8401d422e6e576;

});

parcelRegister("8rneB", function(module, exports) {

var $kwzZh = parcelRequire("kwzZh");


var $32x2E = parcelRequire("32x2E");


var $5amrO = parcelRequire("5amrO");

const $61659933fe71a4ee$export$d2d37cdca5b73056 = (data, emojiFieldName)=>data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.version?.number || 0;
const $61659933fe71a4ee$export$4f65bc4b6ab2638 = (data, emojiFieldName)=>(data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$7f77dde40cb9b60a = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$var$transformProperty = (property)=>{
    if (property) return {
        propertyId: property?.id ?? '',
        value: (property?.value || '').replace(/['"]+/g, '').replace(/null/, ''),
        versionNumber: 'version' in property && property.version?.number || 0
    };
};
const $61659933fe71a4ee$var$findPropertyByKey = (object, key)=>$61659933fe71a4ee$var$transformProperty(object?.properties?.nodes?.find((node)=>node?.key === key));
const $61659933fe71a4ee$export$1b37039eb4b94aa5 = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-published');
const $61659933fe71a4ee$export$4d2921b7085d93bb = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-draft');
const $61659933fe71a4ee$export$f6641c501f8a1aee = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$e1cb12562674727b = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$db0acf1152e62ad6 = (data)=>((data?.content?.nodes?.[0] || data?.singleContent)?.emojiTitlePublished?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$a5b3ff94c918547 = (content)=>(content?.emoji?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$c4fe69c947489b89 = (content)=>(content?.emojiDraft?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$bb520a2176fa2873 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$fbf43d9e87015d93 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$b8852397200defa1 = (data, emojiFieldName)=>{
    let nodes;
    if (data && 'content' in data) nodes = data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0];
    else nodes = data?.emojiTitlePublished?.nodes?.[0];
    return !!nodes?.value && nodes?.value !== '""' && nodes?.value !== '"null"';
};
const $61659933fe71a4ee$export$496af73e8e85fd08 = (data)=>{
    return $61659933fe71a4ee$export$b8852397200defa1(data, 'emojiTitlePublished');
};
const $61659933fe71a4ee$export$53519180ca077ff2 = (data)=>$61659933fe71a4ee$export$b8852397200defa1(data, (0, $5amrO.EMOJI_TITLE_PUBLISHED_FIELD));
const $61659933fe71a4ee$export$8210f5f78c0bcf27 = async (cloudId, userId)=>{
    return await (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
        cloudId: cloudId,
        userId: userId
    });
};
var $61659933fe71a4ee$export$66d7571a7d7aad65 = /*#__PURE__*/ function(DefaultTitleEmojiValues) {
    DefaultTitleEmojiValues["LIVE_PAGE_DEFAULT"] = "live-page-default";
    DefaultTitleEmojiValues["NONE"] = "none";
    return DefaultTitleEmojiValues;
}({});
const $61659933fe71a4ee$export$efb819bf9c3235c7 = (data)=>{
    if (!data) return false;
    const defaultTitleEmoji = data?.content?.nodes?.[0]?.contentProperties?.latest?.defaultTitleEmoji;
    // This property denotes whether or not we show a default emoji icon, and is initially set to null to avoid backfilling on the BE;
    // therefore, a null value OR a specifically set value implies that we need to show a default icon, while a "none" value implies
    // that we should not show an icon. The default icon should also be overriden by a user-set emoji.
    return defaultTitleEmoji === null || defaultTitleEmoji === "live-page-default";
};
module.exports["getVersionNumber"] = $61659933fe71a4ee$export$d2d37cdca5b73056;
module.exports["getEmojiId"] = $61659933fe71a4ee$export$4f65bc4b6ab2638;
module.exports["sanitizeEmojiValue"] = $61659933fe71a4ee$export$7f77dde40cb9b60a;
module.exports["getEmojiPublishedProperty"] = $61659933fe71a4ee$export$1b37039eb4b94aa5;
module.exports["getEmojiDraftProperty"] = $61659933fe71a4ee$export$4d2921b7085d93bb;
module.exports["getEmojiFromPublishedPageProperties"] = $61659933fe71a4ee$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $61659933fe71a4ee$export$e1cb12562674727b;
module.exports["getPublishedEmojiId"] = $61659933fe71a4ee$export$db0acf1152e62ad6;
module.exports["getEmojiValueFromContent"] = $61659933fe71a4ee$export$a5b3ff94c918547;
module.exports["getEmojiDraftFromProperties"] = $61659933fe71a4ee$export$bb520a2176fa2873;
module.exports["getEmojiPublishedFromProperties"] = $61659933fe71a4ee$export$fbf43d9e87015d93;
module.exports["getHasEmoji"] = $61659933fe71a4ee$export$b8852397200defa1;
module.exports["doesContentHaveEmojiPublished"] = $61659933fe71a4ee$export$496af73e8e85fd08;
module.exports["getEmojiProvider"] = $61659933fe71a4ee$export$8210f5f78c0bcf27;
module.exports["DefaultTitleEmojiValues"] = $61659933fe71a4ee$export$66d7571a7d7aad65;
module.exports["getHasLiveDocsDefaultEmoji"] = $61659933fe71a4ee$export$efb819bf9c3235c7;

});

parcelRegister("5amrO", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $99t4P = parcelRequire("99t4P");

const $bb7cbab4663812b3$export$342dc808a4f4a7ab = 'emoji-title-draft';
const $bb7cbab4663812b3$export$97ffb0b9059d248e = 'emoji-title-published';
const $bb7cbab4663812b3$export$5a027b13986198b7 = 'emojiTitleDraft';
const $bb7cbab4663812b3$export$b78a8db8f4546258 = 'emojiTitlePublished';
const $bb7cbab4663812b3$export$61509c1d76ea5fb2 = (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
};
const $bb7cbab4663812b3$export$28c62f1b367f9166 = (fieldName)=>{
    return fieldName === $bb7cbab4663812b3$export$b78a8db8f4546258 ? $bb7cbab4663812b3$export$97ffb0b9059d248e : $bb7cbab4663812b3$export$342dc808a4f4a7ab;
};
module.exports["EMOJI_TITLE_DRAFT_FIELD"] = $bb7cbab4663812b3$export$5a027b13986198b7;
module.exports["EMOJI_TITLE_PUBLISHED_FIELD"] = $bb7cbab4663812b3$export$b78a8db8f4546258;
module.exports["useEmojiStatusFieldName"] = $bb7cbab4663812b3$export$61509c1d76ea5fb2;
module.exports["convertEmojiFieldNameToPropertyKey"] = $bb7cbab4663812b3$export$28c62f1b367f9166;

});

parcelRegister("99t4P", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $6b4026d31beb25d0$export$f0410e068eb2ef9e = (contentType)=>{
    return contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
};
module.exports["isEmojiTitleEnabled"] = $6b4026d31beb25d0$export$f0410e068eb2ef9e;

});

parcelRegister("huWyw", function(module, exports) {

var $jlIaF = parcelRequire("jlIaF");

const $61f50eb1c9d5c417$export$35f6369946b1d8c9 = ({ url: url, spaceKey: spaceKey, contentType: contentType, editorVersion: editorVersion, contentId: contentId, fabricEditorSupported: fabricEditorSupported, noContextPath: noContextPath })=>{
    const isPage = contentType === 'page';
    const isBlog = contentType === 'blogpost';
    const isPageOrBlog = isPage || isBlog;
    const isUsingFabricEditor = fabricEditorSupported || editorVersion === 'v2'; // as opposed to the v1 TinyMCE editor
    const providedURLHitsResumeDraftAction = url.includes('resumedraft.action');
    if (isPageOrBlog && isUsingFabricEditor && providedURLHitsResumeDraftAction) {
        const contentTypeForURL = isPage ? 'pages' : 'blog';
        const contentIdForURL = contentId;
        // Extract the query string from the relative URL.
        const queryString = url.includes('?') ? url.slice(url.indexOf('?') + 1) : '';
        // Extract the `draftShareId` from the query string.
        const urlSearchParams = new URLSearchParams(queryString);
        const draftShareId = urlSearchParams.get('draftShareId');
        const draftShareIdParamString = draftShareId ? `draftShareId=${draftShareId}` : '';
        const optionalContextPath = noContextPath ? '' : (0, $jlIaF.CONTEXT_PATH);
        const bypassURL = `${optionalContextPath}/spaces/${spaceKey}/${contentTypeForURL}/edit-v2/${contentIdForURL}?${draftShareIdParamString}`;
        return bypassURL;
    } else return url;
};
module.exports["getURLBypassingResumeDraftAction"] = $61f50eb1c9d5c417$export$35f6369946b1d8c9;

});

parcelRegister("c7GB4", function(module, exports) {

var $gsyiL = parcelRequire("gsyiL");

var $iOCEj = parcelRequire("iOCEj");

var $av9vJ = parcelRequire("av9vJ");

var $lEAnc = parcelRequire("lEAnc");

var $6B1vK = parcelRequire("6B1vK");

var $1lJ86 = parcelRequire("1lJ86");

var $cCPLV = parcelRequire("cCPLV");


var $1ggpj = parcelRequire("1ggpj");

const $c96e0d62cf176fc6$export$84dfa7fadd8a006b = ({ ari: ari, resourceType: resourceType })=>{
    if (!ari) return null;
    switch(resourceType){
        case (0, $1ggpj.ContentType).PAGE:
            return (0, $6B1vK.ConfluencePageAri).parse(ari).pageId;
        case (0, $1ggpj.ContentType).BLOGPOST:
            return (0, $gsyiL.ConfluenceBlogpostAri).parse(ari).blogpostId;
        case (0, $1ggpj.ContentType).WHITEBOARD:
            return (0, $cCPLV.ConfluenceWhiteboardAri).parse(ari).whiteboardId;
        case (0, $1ggpj.ContentType).DATABASE:
            return (0, $iOCEj.ConfluenceDatabaseAri).parse(ari).databaseId;
        case (0, $1ggpj.ContentType).EMBED:
            return (0, $av9vJ.ConfluenceEmbedAri).parse(ari).embedId;
        case (0, $1ggpj.ContentType).FOLDER:
            return (0, $lEAnc.ConfluenceFolderAri).parse(ari).folderId;
        case (0, $1ggpj.ContentType).SLIDE:
            return (0, $1lJ86.ConfluenceSlideAri).parse(ari).slideId;
    }
};
module.exports["getIdFromConfluenceContentAri"] = $c96e0d62cf176fc6$export$84dfa7fadd8a006b;

});

parcelRegister("gsyiL", function(module, exports) {

var $eQkRH = parcelRequire("eQkRH");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/blogpost/manifest.ts
var $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $eQkRH.ConfluenceBlogpostAriResourceOwner),
    resourceType: (0, $eQkRH.ConfluenceBlogpostAriResourceType),
    resourceIdSlug: "{blogpostId}",
    resourceIdSegmentFormats: {
        blogpostId: /[0-9]+/
    }
};
// src/confluence/blogpost/index.ts
var $bfb9de7804f5bb44$export$8602a2c2f6ac09bc = class _ConfluenceBlogpostAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get blogpostId() {
        return this._blogpostId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts.qualifier,
            platformQualifier: $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts.resourceOwner,
            resourceType: $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts.resourceType,
            resourceId: `${opts.blogpostId}`,
            resourceIdSegmentValues: {
                blogpostId: opts.blogpostId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            blogpostId: this.blogpostId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._blogpostId = opts.resourceIdSegmentValues.blogpostId;
    }
};
module.exports["ConfluenceBlogpostAri"] = $bfb9de7804f5bb44$export$8602a2c2f6ac09bc;

});

parcelRegister("eQkRH", function(module, exports) {
// src/confluence/blogpost/types.ts
var $ace61b64202bfb2d$export$9389f06bd1d0765c = "confluence", $ace61b64202bfb2d$export$fb777a2d645a4129 = "blogpost";
module.exports["ConfluenceBlogpostAriResourceOwner"] = $ace61b64202bfb2d$export$9389f06bd1d0765c;
module.exports["ConfluenceBlogpostAriResourceType"] = $ace61b64202bfb2d$export$fb777a2d645a4129;

});

parcelRegister("iOCEj", function(module, exports) {

var $jp6rV = parcelRequire("jp6rV");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/database/manifest.ts
var $db2ae073c8566cc3$var$confluenceDatabaseAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jp6rV.ConfluenceDatabaseAriResourceOwner),
    resourceType: (0, $jp6rV.ConfluenceDatabaseAriResourceType),
    resourceIdSlug: "activation/{activationId}/{databaseId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        databaseId: /[0-9]+/
    }
};
// src/confluence/database/index.ts
var $db2ae073c8566cc3$export$317cd32472deea7e = class _ConfluenceDatabaseAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get databaseId() {
        return this._databaseId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $db2ae073c8566cc3$var$confluenceDatabaseAriStaticOpts.qualifier,
            platformQualifier: $db2ae073c8566cc3$var$confluenceDatabaseAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $db2ae073c8566cc3$var$confluenceDatabaseAriStaticOpts.resourceOwner,
            resourceType: $db2ae073c8566cc3$var$confluenceDatabaseAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.databaseId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                databaseId: opts.databaseId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $db2ae073c8566cc3$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $db2ae073c8566cc3$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            databaseId: this.databaseId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._databaseId = opts.resourceIdSegmentValues.databaseId;
    }
};
module.exports["ConfluenceDatabaseAri"] = $db2ae073c8566cc3$export$317cd32472deea7e;

});

parcelRegister("jp6rV", function(module, exports) {
// src/confluence/database/types.ts
var $e2055ad385da7e5a$export$e83bc7b627335f1d = "confluence", $e2055ad385da7e5a$export$d26db9a1a0b750aa = "database";
module.exports["ConfluenceDatabaseAriResourceOwner"] = $e2055ad385da7e5a$export$e83bc7b627335f1d;
module.exports["ConfluenceDatabaseAriResourceType"] = $e2055ad385da7e5a$export$d26db9a1a0b750aa;

});

parcelRegister("av9vJ", function(module, exports) {

var $1pgGd = parcelRequire("1pgGd");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/embed/manifest.ts
var $7a542d43713a04fa$var$confluenceEmbedAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1pgGd.ConfluenceEmbedAriResourceOwner),
    resourceType: (0, $1pgGd.ConfluenceEmbedAriResourceType),
    resourceIdSlug: "activation/{activationId}/{embedId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        embedId: /[0-9]+/
    }
};
// src/confluence/embed/index.ts
var $7a542d43713a04fa$export$47d4b4205d0ac61a = class _ConfluenceEmbedAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get embedId() {
        return this._embedId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7a542d43713a04fa$var$confluenceEmbedAriStaticOpts.qualifier,
            platformQualifier: $7a542d43713a04fa$var$confluenceEmbedAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7a542d43713a04fa$var$confluenceEmbedAriStaticOpts.resourceOwner,
            resourceType: $7a542d43713a04fa$var$confluenceEmbedAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.embedId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                embedId: opts.embedId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $7a542d43713a04fa$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $7a542d43713a04fa$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            embedId: this.embedId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._embedId = opts.resourceIdSegmentValues.embedId;
    }
};
module.exports["ConfluenceEmbedAri"] = $7a542d43713a04fa$export$47d4b4205d0ac61a;

});

parcelRegister("1pgGd", function(module, exports) {
// src/confluence/embed/types.ts
var $10651083a44828c2$export$7a02af293cacddd2 = "confluence", $10651083a44828c2$export$f817d48842ea0d4a = "embed";
module.exports["ConfluenceEmbedAriResourceOwner"] = $10651083a44828c2$export$7a02af293cacddd2;
module.exports["ConfluenceEmbedAriResourceType"] = $10651083a44828c2$export$f817d48842ea0d4a;

});

parcelRegister("lEAnc", function(module, exports) {

var $7SOnZ = parcelRequire("7SOnZ");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/folder/manifest.ts
var $fc398c589f411de7$var$confluenceFolderAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $7SOnZ.ConfluenceFolderAriResourceOwner),
    resourceType: (0, $7SOnZ.ConfluenceFolderAriResourceType),
    resourceIdSlug: "activation/{activationId}/{folderId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        folderId: /[0-9]+/
    }
};
// src/confluence/folder/index.ts
var $fc398c589f411de7$export$501a782385a3f485 = class _ConfluenceFolderAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get folderId() {
        return this._folderId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $fc398c589f411de7$var$confluenceFolderAriStaticOpts.qualifier,
            platformQualifier: $fc398c589f411de7$var$confluenceFolderAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $fc398c589f411de7$var$confluenceFolderAriStaticOpts.resourceOwner,
            resourceType: $fc398c589f411de7$var$confluenceFolderAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.folderId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                folderId: opts.folderId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $fc398c589f411de7$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $fc398c589f411de7$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            folderId: this.folderId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._folderId = opts.resourceIdSegmentValues.folderId;
    }
};
module.exports["ConfluenceFolderAri"] = $fc398c589f411de7$export$501a782385a3f485;

});

parcelRegister("7SOnZ", function(module, exports) {
// src/confluence/folder/types.ts
var $5bd4a92be6836a9b$export$77cf4e1b17902bfa = "confluence", $5bd4a92be6836a9b$export$6256ff329bc25a9c = "folder";
module.exports["ConfluenceFolderAriResourceOwner"] = $5bd4a92be6836a9b$export$77cf4e1b17902bfa;
module.exports["ConfluenceFolderAriResourceType"] = $5bd4a92be6836a9b$export$6256ff329bc25a9c;

});

parcelRegister("6B1vK", function(module, exports) {

var $jyUkr = parcelRequire("jyUkr");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/page/manifest.ts
var $4cd75eda3ba03299$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jyUkr.ConfluencePageAriResourceOwner),
    resourceType: (0, $jyUkr.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $4cd75eda3ba03299$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $4cd75eda3ba03299$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $4cd75eda3ba03299$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $4cd75eda3ba03299$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $4cd75eda3ba03299$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $4cd75eda3ba03299$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $4cd75eda3ba03299$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $4cd75eda3ba03299$export$3f931dd15d96caff;

});

parcelRegister("jyUkr", function(module, exports) {
// src/confluence/page/types.ts
var $e3dce2fc5add42f7$export$da53e4f7db4c6a71 = "confluence", $e3dce2fc5add42f7$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $e3dce2fc5add42f7$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $e3dce2fc5add42f7$export$636fc622562a2c5b;

});

parcelRegister("1lJ86", function(module, exports) {

var $1AG0i = parcelRequire("1AG0i");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/slide/manifest.ts
var $0fbac26e81c45336$var$confluenceSlideAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1AG0i.ConfluenceSlideAriResourceOwner),
    resourceType: (0, $1AG0i.ConfluenceSlideAriResourceType),
    resourceIdSlug: "activation/{activationId}/{slideId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        slideId: /[0-9]+/
    }
};
// src/confluence/slide/index.ts
var $0fbac26e81c45336$export$86048ac46024146a = class _ConfluenceSlideAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get slideId() {
        return this._slideId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $0fbac26e81c45336$var$confluenceSlideAriStaticOpts.qualifier,
            platformQualifier: $0fbac26e81c45336$var$confluenceSlideAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $0fbac26e81c45336$var$confluenceSlideAriStaticOpts.resourceOwner,
            resourceType: $0fbac26e81c45336$var$confluenceSlideAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.slideId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                slideId: opts.slideId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $0fbac26e81c45336$var$confluenceSlideAriStaticOpts);
        return new _ConfluenceSlideAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $0fbac26e81c45336$var$confluenceSlideAriStaticOpts);
        return new _ConfluenceSlideAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            slideId: this.slideId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._slideId = opts.resourceIdSegmentValues.slideId;
    }
};
module.exports["ConfluenceSlideAri"] = $0fbac26e81c45336$export$86048ac46024146a;

});

parcelRegister("1AG0i", function(module, exports) {
// src/confluence/slide/types.ts
var $1289bc4ba87a8942$export$204fa7edd529d4b3 = "confluence", $1289bc4ba87a8942$export$3de52c55a164daa4 = "slide";
module.exports["ConfluenceSlideAriResourceOwner"] = $1289bc4ba87a8942$export$204fa7edd529d4b3;
module.exports["ConfluenceSlideAriResourceType"] = $1289bc4ba87a8942$export$3de52c55a164daa4;

});

parcelRegister("cCPLV", function(module, exports) {

var $9z7xR = parcelRequire("9z7xR");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/whiteboard/manifest.ts
var $9311318266bf230b$var$confluenceWhiteboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $9z7xR.ConfluenceWhiteboardAriResourceOwner),
    resourceType: (0, $9z7xR.ConfluenceWhiteboardAriResourceType),
    resourceIdSlug: "{whiteboardId}",
    resourceIdSegmentFormats: {
        whiteboardId: /[0-9]+/
    }
};
// src/confluence/whiteboard/index.ts
var $9311318266bf230b$export$ba3d25b6768ddb10 = class _ConfluenceWhiteboardAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get whiteboardId() {
        return this._whiteboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $9311318266bf230b$var$confluenceWhiteboardAriStaticOpts.qualifier,
            platformQualifier: $9311318266bf230b$var$confluenceWhiteboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $9311318266bf230b$var$confluenceWhiteboardAriStaticOpts.resourceOwner,
            resourceType: $9311318266bf230b$var$confluenceWhiteboardAriStaticOpts.resourceType,
            resourceId: `${opts.whiteboardId}`,
            resourceIdSegmentValues: {
                whiteboardId: opts.whiteboardId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $9311318266bf230b$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $9311318266bf230b$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            whiteboardId: this.whiteboardId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._whiteboardId = opts.resourceIdSegmentValues.whiteboardId;
    }
};
module.exports["ConfluenceWhiteboardAri"] = $9311318266bf230b$export$ba3d25b6768ddb10;

});

parcelRegister("9z7xR", function(module, exports) {
// src/confluence/whiteboard/types.ts
var $6f6d3c41ba97755c$export$6130ea1abbb885ef = "confluence", $6f6d3c41ba97755c$export$d3070d1568a10e2d = "whiteboard";
module.exports["ConfluenceWhiteboardAriResourceOwner"] = $6f6d3c41ba97755c$export$6130ea1abbb885ef;
module.exports["ConfluenceWhiteboardAriResourceType"] = $6f6d3c41ba97755c$export$d3070d1568a10e2d;

});

parcelRegister("2HQyh", function(module, exports) {
/**
 * @generated SignedSource<<3ccde3616734a111f53da6e5e1f8991e>>
 * @relayHash ab13c035f40ba0298bd82a325ff2c401
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e58f63c20fdf70f91a40059b6e32935f05ca4978a7c84ffed3e0dfca58f47c41
const $5b8dbd4fd00aa380$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "exp"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "key"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "keyString"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "keyString"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v5 /*: any*/ 
        ]
    }, v7 = [
        {
            "kind": "Variable",
            "name": "entityId",
            "variableName": "id"
        },
        {
            "kind": "Variable",
            "name": "entityType",
            "variableName": "type"
        },
        {
            "kind": "Variable",
            "name": "experience",
            "variableName": "exp"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "title"
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v11 = {
        "kind": "ScalarField",
        "name": "creatorId"
    }, v12 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v14 = {
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v14 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v16 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    v14 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v17 = {
        "kind": "ScalarField",
        "name": "strategy"
    }, v18 = {
        "args": [
            {
                "kind": "Variable",
                "name": "entityId",
                "variableName": "key"
            }
        ],
        "concreteType": "RecommendedPagesSpaceStatus",
        "kind": "LinkedField",
        "name": "getRecommendedPagesSpaceStatus",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "recommendedPagesEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "defaultBehavior"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EndOfPageRecommendationQuery",
            "selections": [
                v6 /*: any*/ ,
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "RecommendedPages",
                    "kind": "LinkedField",
                    "name": "getRecommendedPages",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "RecommendedPagesItem",
                            "kind": "LinkedField",
                            "name": "recommendedPages",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ 
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        }
                    ]
                },
                v18 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EndOfPageRecommendationQuery",
            "selections": [
                v6 /*: any*/ ,
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "RecommendedPages",
                    "kind": "LinkedField",
                    "name": "getRecommendedPages",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "RecommendedPagesItem",
                            "kind": "LinkedField",
                            "name": "recommendedPages",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ 
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        }
                    ]
                },
                v18 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "ab13c035f40ba0298bd82a325ff2c401",
            "id": "e58f63c20fdf70f91a40059b6e32935f05ca4978a7c84ffed3e0dfca58f47c41",
            "metadata": {},
            "name": "EndOfPageRecommendationQuery",
            "operationKind": "query",
            "text": "query EndOfPageRecommendationQuery($type:String!,$id:ID!,$exp:String!,$key:ID!,$keyString:String!){space(key:$keyString){id},getRecommendedPages(entityType:$type,entityId:$id,experience:$exp){recommendedPages{content{id,title,type,subType,creatorId,links{webui},history{ownedBy{__typename,displayName}},space{id,key,name},emoji:properties(key:\"emoji-title-published\"){nodes{id,key,value}}},strategy}},getRecommendedPagesSpaceStatus(entityId:$key){recommendedPagesEnabled,defaultBehavior}}"
        }
    };
}();
$5b8dbd4fd00aa380$var$node.hash = "e939560761a450cc2ece30ee9466334e";
var $5b8dbd4fd00aa380$export$2e2bcd8739ae039 = $5b8dbd4fd00aa380$var$node;
module.exports["default"] = $5b8dbd4fd00aa380$export$2e2bcd8739ae039;

});

parcelRegister("1AapX", function(module, exports) {
/**
 * @generated SignedSource<<49f29fe4cce6e5914fc9f51ae5a226c1>>
 * @relayHash bde3b931406ea3b1108284cc13c5d3a4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2af0384892c40194e0e0a528388473adfd17c11fe5e5c3ae99fd5096a1349d29
const $43fd533a637b8d46$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "status"
    }, v7 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "key"
    }, v9 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v2 /*: any*/ ,
                v8 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ], v10 = {
        "alias": "editorVersion",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "editor"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v9 /*: any*/ ,
        "storageKey": "properties(key:\"editor\")"
    }, v11 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "emoji-title-draft"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v9 /*: any*/ ,
        "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"])"
    }, v12 = {
        "args": [
            {
                "kind": "Literal",
                "name": "length",
                "value": 372
            }
        ],
        "kind": "ScalarField",
        "name": "excerpt",
        "storageKey": "excerpt(length:372)"
    }, v13 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "commentsCount"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            }
        ]
    }, v14 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v17 = [
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ 
    ], v18 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v19 = {
        "concreteType": "LikesResponse",
        "kind": "LinkedField",
        "name": "likes",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "count"
            }
        ]
    }, v20 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceHoverPageCardQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v17 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v17 /*: any*/ 
                                }
                            ]
                        },
                        v18 /*: any*/ ,
                        v19 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": v17 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceHoverPageCardQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v20 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v20 /*: any*/ 
                                }
                            ]
                        },
                        v18 /*: any*/ ,
                        v19 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": v20 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "bde3b931406ea3b1108284cc13c5d3a4",
            "id": "2af0384892c40194e0e0a528388473adfd17c11fe5e5c3ae99fd5096a1349d29",
            "metadata": {},
            "name": "SpaceHoverPageCardQuery",
            "operationKind": "query",
            "text": "query SpaceHoverPageCardQuery($id:ID!){singleContent(id:$id){id,title,type,subType,status,links{webui,editui},editorVersion:properties(key:\"editor\"){nodes{id,key,value}},emoji:properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"]){nodes{id,key,value}},excerpt(length:372),metadata{currentuser{favourited{isFavourite}},comments{commentsCount},lastModifiedDate},history{createdBy{__typename,profilePicture{path},displayName,...on KnownUser{accountId}},ownedBy{__typename,profilePicture{path},displayName,...on KnownUser{accountId}}},space{id,key,alias,name},likes{count},version{by{__typename,profilePicture{path},displayName,...on KnownUser{accountId}}}}}"
        }
    };
}();
$43fd533a637b8d46$var$node.hash = "43d0bff36706ae93bf29ac12a5604ee3";
var $43fd533a637b8d46$export$2e2bcd8739ae039 = $43fd533a637b8d46$var$node;
module.exports["default"] = $43fd533a637b8d46$export$2e2bcd8739ae039;

});

parcelRegister("3V1KT", function(module, exports) {

var $71jDq = parcelRequire("71jDq");

const $bb6fcff23ee99252$export$d1ed7f06ad741aec = (0, $71jDq.default);
module.exports["ReactionsContentQuery"] = $bb6fcff23ee99252$export$d1ed7f06ad741aec;

});

parcelRegister("71jDq", function(module, exports) {
/**
 * @generated SignedSource<<4ace922d92a4d91954ed2877f69143ae>>
 * @relayHash f5d80e75401b9c7d3d224f964fef6438
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1233c9b22c359c5d8cbed7e4b61033fe5b764797cdcb71dc0673a7aa5eed93f4
const $380a75471f8fd0e5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "contentReactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "reactionsCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "containerAri"
                                },
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "emojiId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reacted"
                                        },
                                        v1 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ReactionsContentQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ReactionsContentQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f5d80e75401b9c7d3d224f964fef6438",
            "id": "1233c9b22c359c5d8cbed7e4b61033fe5b764797cdcb71dc0673a7aa5eed93f4",
            "metadata": {},
            "name": "ReactionsContentQuery",
            "operationKind": "query",
            "text": "query ReactionsContentQuery($contentId:ID!){content(id:$contentId){nodes{id,contentReactionsSummary{reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}}}"
        }
    };
}();
$380a75471f8fd0e5$var$node.hash = "324529dfd12ad8cfc9429a4857981e84";
var $380a75471f8fd0e5$export$2e2bcd8739ae039 = $380a75471f8fd0e5$var$node;
module.exports["default"] = $380a75471f8fd0e5$export$2e2bcd8739ae039;

});

parcelRegister("2OQgp", function(module, exports) {

var $6snPf = parcelRequire("6snPf");

const $b0d4ef9b24ddbdc3$export$e27c33fe32c2fd7b = (0, $6snPf.default);
module.exports["ReactedUsersQuery"] = $b0d4ef9b24ddbdc3$export$e27c33fe32c2fd7b;

});

parcelRegister("6snPf", function(module, exports) {
/**
 * @generated SignedSource<<c7c013e439bad88b330cd4d9c70935f1>>
 * @relayHash a2be411b1772244feef74a2765f2ac57
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8df3009a9d79522bd8efe037cb70fe5c72987241726fa1580e2f0eb97ceb9c96
const $d0a610df0853dabe$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerType"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "emojiId"
    }, v5 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "containerId",
                    "variableName": "containerId"
                },
                {
                    "kind": "Variable",
                    "name": "containerType",
                    "variableName": "containerType"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                },
                {
                    "kind": "Variable",
                    "name": "emojiId",
                    "variableName": "emojiId"
                }
            ],
            "concreteType": "ReactedUsersResponse",
            "kind": "LinkedField",
            "name": "reactedUsers",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "count"
                },
                {
                    "kind": "ScalarField",
                    "name": "emojiId"
                },
                {
                    "kind": "ScalarField",
                    "name": "reacted"
                },
                {
                    "concreteType": "ConfluencePerson",
                    "kind": "LinkedField",
                    "name": "confluencePerson",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "displayName"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "profilePicture",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ReactedUsersQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ReactedUsersQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "a2be411b1772244feef74a2765f2ac57",
            "id": "8df3009a9d79522bd8efe037cb70fe5c72987241726fa1580e2f0eb97ceb9c96",
            "metadata": {},
            "name": "ReactedUsersQuery",
            "operationKind": "query",
            "text": "query ReactedUsersQuery($contentId:String!,$containerId:String!,$containerType:ContainerType!,$contentType:GraphQLReactionContentType!,$emojiId:String!){reactedUsers(contentId:$contentId,containerId:$containerId,containerType:$containerType,contentType:$contentType,emojiId:$emojiId){count,emojiId,reacted,confluencePerson{accountId,displayName,profilePicture{path}}}}"
        }
    };
}();
$d0a610df0853dabe$var$node.hash = "c015b4e131a157a2b697f6c2a7cdf8e3";
var $d0a610df0853dabe$export$2e2bcd8739ae039 = $d0a610df0853dabe$var$node;
module.exports["default"] = $d0a610df0853dabe$export$2e2bcd8739ae039;

});

parcelRegister("kcIQr", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $9DHhW = parcelRequire("9DHhW");

const $8f5ec29d1cc276d5$export$b8af4dbcbdf99d70 = ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (payload)=>createAnalyticsEvent(payload);
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const createEvent = t0;
    let t1;
    if ($[2] !== createEvent) {
        t1 = {
            createEvent: createEvent
        };
        $[2] = createEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["useConfluenceAnalyticsEvents"] = $8f5ec29d1cc276d5$export$b8af4dbcbdf99d70;

});

parcelRegister("f7MuR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $26d702ce000cc6e9$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $26d702ce000cc6e9$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        }
};
const $26d702ce000cc6e9$export$39f521003d60a645 = (0, $8s9DV.createStore)({
    initialState: $26d702ce000cc6e9$var$initialState,
    actions: $26d702ce000cc6e9$var$actions,
    name: 'siteUserTraitsStore'
});
const $26d702ce000cc6e9$export$55703aaacc066827 = (0, $kBr4q.createHook)($26d702ce000cc6e9$export$39f521003d60a645);
const $26d702ce000cc6e9$export$60cc1c45e628d86f = (0, $kBr4q.createActionsHook)($26d702ce000cc6e9$export$39f521003d60a645);
async function $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $26d702ce000cc6e9$var$hasFetched = false;
function $26d702ce000cc6e9$export$f1fbc6ad89f91b89() {
    $26d702ce000cc6e9$var$hasFetched = false;
}
function $26d702ce000cc6e9$var$getSiteUserTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.siteUser);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.siteUser);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $26d702ce000cc6e9$export$f02520a2cf0afa96({ skip: skip, skipBootstrap: skipBootstrap, fetchPolicy: fetchPolicy = 'cache-first' } = {}) {
    // skip=true -> full idle, no preload/store/fetch
    const preloadedData = (0, $cozmU.useMemo)(()=>skip ? null : $26d702ce000cc6e9$var$getSiteUserTraitsFromSources(), [
        skip
    ]);
    const [storeState, storeActions] = $26d702ce000cc6e9$export$55703aaacc066827();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    // Track whether cache-and-network fetch dispatched this mount
    const fetchDispatchedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (skip) return;
        if (!cloudId || !userId) return;
        if (skipBootstrap) return;
        if (!hasLicensedAccess) return;
        if (fetchPolicy === 'cache-first') {
            // Old behavior: don't fetch if we have data from any source
            if (preloadedData || storeState.data || storeState.loading || storeState.error) return;
            if ($26d702ce000cc6e9$var$hasFetched) return;
            $26d702ce000cc6e9$var$hasFetched = true;
            storeActions.start();
            $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then((data)=>storeActions.success(data), (err)=>storeActions.error(err));
        } else {
            // cache-and-network: fetch once per mount
            if (storeState.loading) {
                fetchDispatchedRef.current = true;
                return;
            }
            if (fetchDispatchedRef.current) return;
            fetchDispatchedRef.current = true;
            storeActions.start();
            $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then((data)=>storeActions.success(data), (err)=>storeActions.error(err));
        }
    }, [
        skip,
        skipBootstrap,
        fetchPolicy,
        cloudId,
        userId,
        hasLicensedAccess,
        preloadedData,
        storeState,
        storeActions
    ]);
    if (skip) return {
        data: null,
        loading: false,
        error: null
    };
    // Fetched store result wins over preloaded data
    if (storeState.data) return {
        data: storeState.data,
        loading: storeState.loading,
        error: storeState.error
    };
    if (preloadedData) return {
        data: preloadedData,
        loading: storeState.loading,
        error: null
    };
    return {
        data: null,
        loading: storeState.loading,
        error: storeState.error
    };
}
module.exports["useSiteUserTraits"] = $26d702ce000cc6e9$export$f02520a2cf0afa96;

});

parcelRegister("dcJRl", function(module, exports) {
const $1eca0028b5407519$export$bab1229873daab56 = (tapTraits)=>{
    if (!tapTraits || Object.entries(tapTraits).length === 0) return null;
    return Object.entries(tapTraits).reduce((acc, [name, value])=>[
            ...acc,
            {
                name: name,
                value: String(value)
            }
        ], []);
};
module.exports["formatTapTraits"] = $1eca0028b5407519$export$bab1229873daab56;

});

parcelRegister("lh7DM", function(module, exports) {

let $f7d11cc0797ba0fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f7d11cc0797ba0fc$var$load("agVmZ"),
    $f7d11cc0797ba0fc$var$load("dxcsb"),
    $f7d11cc0797ba0fc$var$load("99ObF"),
    $f7d11cc0797ba0fc$var$load("fDXJE"),
    $f7d11cc0797ba0fc$var$load("lrpUd"),
    $f7d11cc0797ba0fc$var$load("4LY4N"),
    $f7d11cc0797ba0fc$var$load("4flC1")
]).then(()=>parcelRequire('eN31l'));

});

parcelRegister("aDyoj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");




parcelRequire("63sT2");
var $8NccQ = parcelRequire("8NccQ");
var $dYn3u = parcelRequire("dYn3u");


var $gqUuL = parcelRequire("gqUuL");


var $852mP = parcelRequire("852mP");

const $08452e6d6a4098ea$export$91b4dd3bfc301325 = (analyticsClient)=>{
    return (event)=>{
        return Promise.resolve(analyticsClient).then((client)=>{
            switch(event.eventType){
                case 0, $852mP.UI_EVENT_TYPE:
                    client.sendUIEvent(event);
                    break;
                case 0, $852mP.TRACK_EVENT_TYPE:
                    client.sendTrackEvent(event);
                    break;
                case 0, $852mP.OPERATIONAL_EVENT_TYPE:
                    client.sendOperationalEvent(event);
                    break;
                case 0, $852mP.SCREEN_EVENT_TYPE:
                    client.sendScreenEvent(event);
                    break;
            }
        });
    };
};


// Copied from xflow-ui. We post raw analytics events (context and payload only) from xflow-ui to consumer (CFE), transform on consumer and post to gasv3.



const $39100ae7653d17e4$var$GROWTH_TAG = 'growth';
const $39100ae7653d17e4$var$extractFromEventContext = (propertyNames, context)=>context.reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            const navContextProp = contextItem ? contextItem[propertyName] : null;
            acc.push(navContextProp || contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
const $39100ae7653d17e4$var$getSources = (context)=>$39100ae7653d17e4$var$extractFromEventContext([
        'source'
    ], context);
const $39100ae7653d17e4$var$getExtraAttributes = (context)=>context.reduce((ans, { attributes: attributes, ...contextProps })=>{
        const newAttributes = {
            ...ans,
            ...contextProps
        };
        return attributes ? {
            ...newAttributes,
            ...attributes
        } : newAttributes;
    }, {});
const $39100ae7653d17e4$var$getPackageInfo = (context)=>context.map((contextItem)=>({
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        })).filter((p)=>p.packageName);
const $39100ae7653d17e4$var$last = (values)=>values[values.length - 1];
const $39100ae7653d17e4$export$3f40e8c44448be30 = (event)=>{
    const { context: context, payload: payload } = event;
    if (!payload) return null;
    const sources = $39100ae7653d17e4$var$getSources(context);
    const source = $39100ae7653d17e4$var$last(sources) || (0, $852mP.DEFAULT_SOURCE);
    const extraAttributes = $39100ae7653d17e4$var$getExtraAttributes(context);
    const { packageName: packageName, packageVersion: packageVersion } = $39100ae7653d17e4$var$last($39100ae7653d17e4$var$getPackageInfo(context)) || {};
    const { eventType: eventType = (0, $852mP.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = payload;
    const attributes = {
        packageName: packageName,
        packageVersion: packageVersion,
        ...extraAttributes,
        ...payloadAttributes
    };
    const tags = payload.tags || [];
    tags.push($39100ae7653d17e4$var$GROWTH_TAG);
    switch(eventType){
        case 0, $852mP.UI_EVENT_TYPE:
        case 0, $852mP.OPERATIONAL_EVENT_TYPE:
        case 0, $852mP.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: tags.slice(0)
            };
        case 0, $852mP.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                source: source,
                tags: tags.slice(0)
            };
        default:
            break;
    }
    return null;
};





const $59a3e79e459608db$export$b4d5da5f34fb77ad = 'crossFlowProvider';
const $59a3e79e459608db$export$9d8252a268f4fa72 = 'errorCaught';
const $59a3e79e459608db$export$1045419caf49b395 = 'errorBoundary';
const $59a3e79e459608db$export$d54c183f56e39aa5 = 'crossFlowSupport';
const $59a3e79e459608db$export$e5c2c058fa8068a6 = 'uiInitialized';
const $59a3e79e459608db$export$e67cdcb8867a3bd0 = 'openInvoked';




const $f4edb280b529d91a$var$version = "0.0.0-use.local";
const $f4edb280b529d91a$export$84f9cf7ef89d4c26 = {
    version: $f4edb280b529d91a$var$version
};
const $f4edb280b529d91a$export$59518efab336a8b5 = (event)=>{
    const attributes = {
        ...event.attributes || {},
        crossFlowSupport: $f4edb280b529d91a$export$84f9cf7ef89d4c26
    };
    return {
        ...event,
        attributes: attributes
    };
};


const $2d56ab819e6936bb$export$a5a156dc5df42f0 = (event, requestOptions)=>{
    if (!requestOptions) return event;
    const attributes = {
        // Spread the extra analytics attributes first, because we don't want consumers to override any event attributes below
        ...requestOptions.extraAnalyticsAttributes || {},
        ...event.attributes || {},
        sourceComponent: requestOptions.sourceComponent,
        sourceContext: requestOptions.sourceContext
    };
    return {
        ...event,
        attributes: attributes
    };
};








const $2afc09defa936d50$var$name = "platform-pkg";
const $2afc09defa936d50$var$version = "0.0.0-use.local";
const $2afc09defa936d50$var$payload = {
    eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
    action: (0, $59a3e79e459608db$export$9d8252a268f4fa72),
    actionSubject: (0, $59a3e79e459608db$export$1045419caf49b395)
};
const $2afc09defa936d50$var$context = [
    {
        source: $59a3e79e459608db$export$b4d5da5f34fb77ad
    },
    {
        packageName: $2afc09defa936d50$var$name,
        packageVersion: $2afc09defa936d50$var$version
    }
];
class $2afc09defa936d50$export$e926676385687eaf extends (0, $cozmU.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error) {
        this.props.onAnalyticsEvent({
            payload: $2afc09defa936d50$var$payload,
            context: $2afc09defa936d50$var$context
        });
        if (this.props.onError) this.props.onError(error);
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false
        };
    }
}


parcelRequire("kgHuu");
var $3qdJ0 = parcelRequire("3qdJ0");

var $4b58641a5d50fe20$export$fc604aa353a97e10 = /*#__PURE__*/ function(UtmCampaign) {
    UtmCampaign["atlassian-switcher"] = "atlassian_switcher";
    return UtmCampaign;
}({});


const $dcb4e29cfd63a6dd$export$c37558e5c67d2b01 = 'https://qa-wac.internal.atlassian.com';
const $dcb4e29cfd63a6dd$export$f199baf8dfc7621e = 'https://www.atlassian.com';
const $dcb4e29cfd63a6dd$export$fb1e43fdafe12e9b = '/software/opsgenie/try';
const $dcb4e29cfd63a6dd$export$e6c04a1dd86d1c14 = '/try/cloud/signup';
const $dcb4e29cfd63a6dd$export$2a45a00073911255 = '/software';


const $f5471fd49a9d2c96$var$utmCampaignMap = {
    'atlassian-switcher': (0, $4b58641a5d50fe20$export$fc604aa353a97e10)['atlassian-switcher']
};
const $f5471fd49a9d2c96$var$isBundledProduct = (productKey)=>{
    return [
        (0, $3qdJ0.Targets).JIRA_SOFTWARE,
        (0, $3qdJ0.Targets).JIRA_SERVICE_DESK,
        (0, $3qdJ0.Targets).JIRA_CORE,
        (0, $3qdJ0.Targets).CONFLUENCE
    ].includes(productKey);
};
const $f5471fd49a9d2c96$var$getBundleSignUpParams = (productKey)=>{
    const bundles = {
        [(0, $3qdJ0.Targets).JIRA_SOFTWARE]: 'jira-software',
        [(0, $3qdJ0.Targets).JIRA_SERVICE_DESK]: 'jira-service-desk',
        [(0, $3qdJ0.Targets).JIRA_CORE]: 'jira-core',
        [(0, $3qdJ0.Targets).CONFLUENCE]: 'confluence'
    };
    // Bundles default to free
    return `bundle=${bundles[productKey]}&edition=free`;
};
const $f5471fd49a9d2c96$var$isProductWithCustomSignUpPath = (productKey)=>{
    return [
        (0, $3qdJ0.Targets).OPSGENIE
    ].includes(productKey);
};
const $f5471fd49a9d2c96$var$getProductCustomSignUpPath = (productKey)=>{
    // Only Opsgenie. Trello, Bitbucket and Statuspage are handled by Product Store directly.
    const links = {
        [(0, $3qdJ0.Targets).OPSGENIE]: (0, $dcb4e29cfd63a6dd$export$fb1e43fdafe12e9b)
    };
    return links[productKey];
};
const $f5471fd49a9d2c96$var$isSourceComponentWithUtmParams = (sourceComponent)=>{
    return Boolean($f5471fd49a9d2c96$var$utmCampaignMap[sourceComponent]);
};
const $f5471fd49a9d2c96$var$getUtmParams = (sourceComponent, sourceContext)=>{
    let utmParams = '';
    if (sourceComponent && $f5471fd49a9d2c96$var$isSourceComponentWithUtmParams(sourceComponent)) {
        utmParams = utmParams + `utm_campaign=${$f5471fd49a9d2c96$var$utmCampaignMap[sourceComponent]}&utm_medium=in_product_ad`;
        if (sourceContext) utmParams = utmParams + `&utm_source=${sourceContext}`;
    }
    return utmParams;
};
const $f5471fd49a9d2c96$export$39eab502fc96327d = (productKey, env, sourceComponent, sourceContext)=>{
    const wacUrl = env === 'staging' ? (0, $dcb4e29cfd63a6dd$export$c37558e5c67d2b01) : (0, $dcb4e29cfd63a6dd$export$f199baf8dfc7621e);
    const utmParams = $f5471fd49a9d2c96$var$getUtmParams(sourceComponent, sourceContext);
    let queryParams = '';
    let bundleParams = '';
    let path = (0, $dcb4e29cfd63a6dd$export$2a45a00073911255);
    if ($f5471fd49a9d2c96$var$isBundledProduct(productKey)) {
        path = (0, $dcb4e29cfd63a6dd$export$e6c04a1dd86d1c14);
        bundleParams = $f5471fd49a9d2c96$var$getBundleSignUpParams(productKey);
    } else if ($f5471fd49a9d2c96$var$isProductWithCustomSignUpPath(productKey)) path = $f5471fd49a9d2c96$var$getProductCustomSignUpPath(productKey);
    if (!!bundleParams) queryParams = queryParams + `?${bundleParams}`;
    if (!!utmParams) queryParams = queryParams + (!!queryParams ? '&' : '?') + utmParams;
    return wacUrl + path + queryParams;
};
const $f5471fd49a9d2c96$export$2827e2473cb9a346 = (productKey, env = 'production', sourceComponent, sourceContext)=>{
    const url = $f5471fd49a9d2c96$export$39eab502fc96327d(productKey, env, sourceComponent, sourceContext);
    window.open(url, '_blank');
};



const $55aa4af0e198d81c$var$IntegrationView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("ioPQA")));
const $55aa4af0e198d81c$export$79d79d8dd8574306 = (IntegrationView)=>(props)=>{
        const { children: children, analyticsClient: analyticsClient, originProduct: originProduct, redirectToWac: redirectToWac, env: env, plugins: plugins = [], globalExperimentalOptions: globalExperimentalOptions, onError: onError, ...baseProviderProps } = props;
        const onCloseResolver = (0, $cozmU.useRef)();
        const [firstHandshakeReceived, setFirstHandshakeReceived] = (0, $cozmU.useState)(false);
        const fireEvent = (0, $cozmU.useMemo)(()=>(0, $08452e6d6a4098ea$export$91b4dd3bfc301325)(analyticsClient), [
            analyticsClient
        ]);
        const [requestOptions, setRequestOptions] = (0, $cozmU.useState)();
        const onAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
            const gasV3Event = (0, $39100ae7653d17e4$export$3f40e8c44448be30)(payload);
            if (gasV3Event) {
                const enrichedEvent = (0, $2d56ab819e6936bb$export$a5a156dc5df42f0)((0, $f4edb280b529d91a$export$59518efab336a8b5)(gasV3Event), requestOptions);
                fireEvent(enrichedEvent);
            }
        }, [
            fireEvent,
            requestOptions
        ]);
        const onHandShake = (0, $cozmU.useCallback)((appName)=>{
            if (!firstHandshakeReceived) {
                onAnalyticsEvent({
                    payload: {
                        eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                        action: (0, $59a3e79e459608db$export$e5c2c058fa8068a6),
                        actionSubject: (0, $59a3e79e459608db$export$d54c183f56e39aa5),
                        attributes: {
                            appName: appName
                        }
                    },
                    context: [
                        {
                            source: $59a3e79e459608db$export$b4d5da5f34fb77ad
                        }
                    ]
                });
                setFirstHandshakeReceived(true);
            }
        }, [
            firstHandshakeReceived,
            onAnalyticsEvent
        ]);
        const onOpen = (0, $cozmU.useCallback)((options)=>{
            /**
     * Reset first handshake state to ensure 1:1 value of open invoked and handshake received
     * Caveat that if open api is invoked while cross flow support UI is already mounted there will be mismatch of openInvoked events to uiInitialized events
     */ setFirstHandshakeReceived(false);
            const analyticsEvent = {
                // setRequestOptions does not update the state right away (updates on the next render) so for the openInvoked event we need to manually append the sourceComponent and sourceContext
                payload: (0, $2d56ab819e6936bb$export$a5a156dc5df42f0)({
                    eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                    action: (0, $59a3e79e459608db$export$e67cdcb8867a3bd0),
                    actionSubject: (0, $59a3e79e459608db$export$d54c183f56e39aa5)
                }, options),
                context: [
                    {
                        source: $59a3e79e459608db$export$b4d5da5f34fb77ad
                    }
                ]
            };
            onAnalyticsEvent(analyticsEvent);
            // Short circuit requestOptions for WAC expansions
            if (options.journey === (0, $dYn3u.Journeys).GET_STARTED && redirectToWac) {
                (0, $f5471fd49a9d2c96$export$2827e2473cb9a346)(options.targetProduct, env, options.sourceComponent, options.sourceContext);
                const completionStatus = {};
                return Promise.resolve(completionStatus);
            }
            const updatedExperimentalOptions = {
                ...globalExperimentalOptions || {},
                // "globalExperimentalOptions" will be injected to EVERY crossFlow invoke
                ...options.experimentalOptions || {} // "options.experimentalOptions" takes care of passing experimentalOptions to ONE specific crossFlow invoke
            };
            options.experimentalOptions = updatedExperimentalOptions;
            setRequestOptions(options);
            return new Promise((resolve)=>{
                onCloseResolver.current = resolve;
            });
        }, [
            onAnalyticsEvent,
            env,
            redirectToWac,
            globalExperimentalOptions
        ]);
        const onClose = (0, $cozmU.useCallback)((completionStatus)=>{
            setFirstHandshakeReceived(false);
            setRequestOptions(undefined);
            onCloseResolver.current && onCloseResolver.current(completionStatus);
        }, []);
        const { colorMode: colorMode } = (0, $gqUuL.getGlobalTheme)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8NccQ.BaseCrossFlowApiProvider), {
            onOpen: onOpen
        }, children, requestOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2afc09defa936d50$export$e926676385687eaf), {
            onAnalyticsEvent: onAnalyticsEvent,
            onError: onError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IntegrationView, {
            ...baseProviderProps,
            ...requestOptions,
            onAnalyticsEvent: onAnalyticsEvent,
            originProduct: originProduct,
            theme: colorMode,
            onClose: onClose,
            onHandShake: onHandShake,
            plugins: plugins,
            env: env,
            redirectToWac: redirectToWac,
            zIndex: requestOptions.zIndex ?? 1000
        }))));
    };
const $55aa4af0e198d81c$export$d900e4062895cd7c = $55aa4af0e198d81c$export$79d79d8dd8574306($55aa4af0e198d81c$var$IntegrationView);



const $f277a6ccc9f41939$var$ConfluenceProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $55aa4af0e198d81c$export$d900e4062895cd7c), {
            ...props,
            originProduct: "confluence"
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $55aa4af0e198d81c$export$d900e4062895cd7c), {
        ...props,
        originProduct: "confluence"
    });
};
var $f277a6ccc9f41939$export$2e2bcd8739ae039 = $f277a6ccc9f41939$var$ConfluenceProvider;
module.exports["default"] = $f277a6ccc9f41939$export$2e2bcd8739ae039;

});

parcelRegister("63sT2", function(module, exports) {
$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => (parcelRequire("8NccQ")).BaseCrossFlowApiProvider);
$parcel$export(module.exports, "useCrossFlow", () => (parcelRequire("8NccQ")).useCrossFlow);
$parcel$export(module.exports, "withCrossFlow", () => (parcelRequire("8NccQ")).withCrossFlow);
$parcel$export(module.exports, "Journeys", () => (parcelRequire("dYn3u")).Journeys);
$parcel$export(module.exports, "Reasons", () => (parcelRequire("dYn3u")).Reasons);

var $8NccQ = parcelRequire("8NccQ");


var $dYn3u = parcelRequire("dYn3u");


});

parcelRegister("8NccQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $h9Y0D = parcelRequire("h9Y0D");


var $6j5v3 = parcelRequire("6j5v3");


var $dYn3u = parcelRequire("dYn3u");

const $95842fb34f191a76$var$LATEST_VERSION = (0, $6j5v3.VERSION);
/**
 * Private Cross Flow context
 *
 * Not to be used directly other than by useCrossFlow and BaseCrossFlowApiProvider
 */ const $95842fb34f191a76$var$CrossFlowContext = /*#__PURE__*/ (0, $cozmU.createContext)(()=>({
        isEnabled: false,
        reason: (0, $dYn3u.Reasons).NO_PROVIDER
    }));
const $95842fb34f191a76$export$59ce2d27e6cd8c9 = (onOpen)=>(version)=>{
        switch(version){
            case 0, $6j5v3.VERSION:
                return {
                    isEnabled: true,
                    api: (0, $h9Y0D.createAPIv0)(onOpen),
                    apiV1: (0, $6j5v3.createAPIv1)(onOpen)
                };
            default:
                return {
                    isEnabled: false,
                    reason: (0, $dYn3u.Reasons).NO_API_SUPPORT
                };
        }
    };
const $95842fb34f191a76$export$c0ddec072762f62a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { onOpen: onOpen, children: children } = t0;
    let t1;
    if ($[0] !== onOpen) {
        t1 = $95842fb34f191a76$export$59ce2d27e6cd8c9(onOpen);
        $[0] = onOpen;
        $[1] = t1;
    } else t1 = $[1];
    const negotiateApi = t1;
    let t2;
    if ($[2] !== children || $[3] !== negotiateApi) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($95842fb34f191a76$var$CrossFlowContext.Provider, {
            value: negotiateApi
        }, children);
        $[2] = children;
        $[3] = negotiateApi;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ onOpen: onOpen, children: children })=>{
    const negotiateApi = (0, $cozmU.useMemo)(()=>$95842fb34f191a76$export$59ce2d27e6cd8c9(onOpen), [
        onOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($95842fb34f191a76$var$CrossFlowContext.Provider, {
        value: negotiateApi
    }, children);
};
const $95842fb34f191a76$export$6e7a10fe635a0dfc = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const negotiateApi = (0, $cozmU.useContext)($95842fb34f191a76$var$CrossFlowContext);
    let t0;
    if ($[0] !== negotiateApi) {
        t0 = negotiateApi($95842fb34f191a76$var$LATEST_VERSION);
        $[0] = negotiateApi;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const negotiateApi = (0, $cozmU.useContext)($95842fb34f191a76$var$CrossFlowContext);
    return (0, $cozmU.useMemo)(()=>negotiateApi($95842fb34f191a76$var$LATEST_VERSION), [
        negotiateApi
    ]);
};
function $95842fb34f191a76$export$655b6c19a0daddb8(//component coming in here has no crossflow type yet, but expects it
WrappedComponent) {
    const ComponentWithCrossFlow = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
        const $ = (0, $bDgLe.c)(3);
        const crossFlow = $95842fb34f191a76$export$6e7a10fe635a0dfc();
        let t0;
        if ($[0] !== crossFlow || $[1] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                ...props,
                crossFlow: crossFlow
            });
            $[0] = crossFlow;
            $[1] = props;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    } : (props)=>{
        const crossFlow = $95842fb34f191a76$export$6e7a10fe635a0dfc();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
            ...props,
            crossFlow: crossFlow
        });
    };
    ComponentWithCrossFlow.displayName = `withCrossFlow(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return ComponentWithCrossFlow;
}
module.exports["BaseCrossFlowApiProvider"] = $95842fb34f191a76$export$c0ddec072762f62a;
module.exports["useCrossFlow"] = $95842fb34f191a76$export$6e7a10fe635a0dfc;
module.exports["withCrossFlow"] = $95842fb34f191a76$export$655b6c19a0daddb8;

});

parcelRegister("h9Y0D", function(module, exports) {
const $dac2ee632762edd0$export$a4ad2735b021c132 = 0;
const $dac2ee632762edd0$export$9ff7368ac93fcf2d = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["createAPIv0"] = $dac2ee632762edd0$export$9ff7368ac93fcf2d;

});

parcelRegister("6j5v3", function(module, exports) {
const $146c188c19063c17$export$a4ad2735b021c132 = 1;
const $146c188c19063c17$export$8fd5792fc468459f = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["VERSION"] = $146c188c19063c17$export$a4ad2735b021c132;
module.exports["createAPIv1"] = $146c188c19063c17$export$8fd5792fc468459f;

});

parcelRegister("dYn3u", function(module, exports) {
const $f5b6049530406f9f$export$3411873bfd520bb6 = {
    GET_STARTED: 'get-started',
    DECIDE: 'decide',
    DISCOVER: 'discover'
};
const $f5b6049530406f9f$export$da2d4f2f250d6f84 = {
    NO_API_SUPPORT: 'Could not provide requested API version',
    NO_PROVIDER: 'Provider not found'
};
module.exports["Journeys"] = $f5b6049530406f9f$export$3411873bfd520bb6;
module.exports["Reasons"] = $f5b6049530406f9f$export$da2d4f2f250d6f84;

});

parcelRegister("kgHuu", function(module, exports) {
$parcel$export(module.exports, "CrossFlowExtensions", () => (parcelRequire("6ROIE")).CrossFlowExtensions);
$parcel$export(module.exports, "Targets", () => (parcelRequire("3qdJ0")).Targets);

var $6ROIE = parcelRequire("6ROIE");


var $3qdJ0 = parcelRequire("3qdJ0");


});

parcelRegister("6ROIE", function(module, exports) {
class $f31eace768ed80b8$export$a5e53d1dcbd6eb61 {
    constructor(options){
        Object.assign(this, options);
        Object.freeze(this);
    }
}
module.exports["CrossFlowExtensions"] = $f31eace768ed80b8$export$a5e53d1dcbd6eb61;

});

parcelRegister("3qdJ0", function(module, exports) {
/**
 * We are keeping a manual list of targets for the purposes of type safety.
 */ const $8c8615b3f214c36e$export$59a8eb9cff113544 = {
    CONFLUENCE: 'confluence.ondemand',
    JIRA_CORE: 'jira-core.ondemand',
    JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
    JIRA_SOFTWARE: 'jira-software.ondemand',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    JIRA_CUSTOMER_SERVICE: 'jira-customer-service',
    BITBUCKET: 'bitbucket.ondemand',
    TRELLO: 'trello',
    OPSGENIE: 'opsgenie',
    STATUSPAGE: 'statuspage',
    /**
	 * @private
	 * @deprecated Use ATLAS instead
	 */ TEAM_CENTRAL: 'townsquare',
    ATLAS: 'townsquare',
    /**
	 * @private
	 * @deprecated
	 */ AVOCADO: 'avocado',
    ANALYTICS: 'atlassian-analytics-free',
    COMPASS: 'compass',
    LOOM: 'loom',
    ROVO: 'rovo.ondemand',
    TEAMWORK_COLLECTION: 'teamwork-collection'
};
module.exports["Targets"] = $8c8615b3f214c36e$export$59a8eb9cff113544;

});

parcelRegister("ioPQA", function(module, exports) {

let $d652afa743910df6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d652afa743910df6$var$load("1qpqD"),
    $d652afa743910df6$var$load("i0Zk0"),
    $d652afa743910df6$var$load("i5oVl")
]).then(()=>parcelRequire('eUM4P'));

});

parcelRegister("lsxnT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $cozmU.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $cozmU.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $cozmU.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    ChoreographedComponent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightTarget: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("hSHWm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $d1e7679282bf3961$export$8b4809eaf655f286 = /*#__PURE__*/ (0, $cozmU.createContext)({});
module.exports["CoreInvitesContext"] = $d1e7679282bf3961$export$8b4809eaf655f286;

});

parcelRegister("5tvD8", function(module, exports) {

let $3fc8324ba982ef21$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3fc8324ba982ef21$var$load("agVmZ"),
    $3fc8324ba982ef21$var$load("lya9W"),
    $3fc8324ba982ef21$var$load("Mp0pM"),
    $3fc8324ba982ef21$var$load("hE9re"),
    $3fc8324ba982ef21$var$load("fo4nX"),
    $3fc8324ba982ef21$var$load("lrXQY"),
    $3fc8324ba982ef21$var$load("kQNKW"),
    $3fc8324ba982ef21$var$load("7zPi7")
]).then(()=>parcelRequire('MVtCj'));

});

parcelRegister("koZ31", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $6a2b9fa9e63188b2$export$1ba03842b7d3a654 = /*#__PURE__*/ function(CoreInvitesSource) {
    CoreInvitesSource["UNKNOWN"] = "unknown";
    CoreInvitesSource["MENTION"] = "mention";
    CoreInvitesSource["PEOPLE_MENU"] = "peopleMenu";
    CoreInvitesSource["ONBOARDING_INVITE_FLAG"] = "onboarding-invite-flag";
    CoreInvitesSource["PERSISTENT_INVITE_PAGETREE"] = "pageTree";
    CoreInvitesSource["PERSISTENT_INVITE_HOMESCREEN"] = "homeScreen";
    CoreInvitesSource["CONTEXTUAL_INVITE_NUDGE"] = "onboarding-contextual-invite-nudge";
    CoreInvitesSource["LIVE_PAGES_NUDGE"] = "onboarding-contextual-invite-live-pages-nudge";
    CoreInvitesSource["SHARE_DIALOG"] = "share-dialog";
    CoreInvitesSource["SHARE_AND_RESTRICT_DIALOG"] = "share-and-restrict-dialog";
    CoreInvitesSource["IBO_TAKEOVER_INVITE"] = "onboarding-takeover-invite-people";
    CoreInvitesSource["EA_DROPDOWN"] = "ea-dropdown";
    CoreInvitesSource["HOME_ONBOARDING_TAKEOVER_V2"] = "home-onboarding-takeover-v2";
    CoreInvitesSource["CROSS_JOIN"] = "virality-cross-join";
    CoreInvitesSource["OPEN_MODAL_QUERY_PARAM"] = "open-modal-query-param";
    return CoreInvitesSource;
}({});
module.exports["CoreInvitesSource"] = $6a2b9fa9e63188b2$export$1ba03842b7d3a654;

});

parcelRegister("hrAmX", function(module, exports) {

var $a4dgs = parcelRequire("a4dgs");


var $8zRYE = parcelRequire("8zRYE");


var $jecot = parcelRequire("jecot");

const $6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME = 'ServerRenderedBanners';
const $6ee3834dea9f6c5c$export$f7df67e8f3ba0620 = (name, inArray)=>inArray.findIndex((banner)=>banner.name === name);
class $6ee3834dea9f6c5c$export$bbac707b3ebb5681 extends (0, $a4dgs.BaseStateContainer) {
    constructor(props = {}){
        super();
        // Resolved unconditionally, even when it is about to be discarded, so that exposure for the
        // nav-height flags is unchanged from before this was extracted into a helper.
        /** Frozen at construction: a mid-session flag flip must not change an instance's arithmetic. */ this.topNavHeight = void 0;
        this.suppressed = void 0;
        this.pendingNotify = null;
        this.unsubscribeFromStore = null;
        this.state = {
            banners: []
        };
        this._updateServerRenderedBanners = (spaBannerHeight)=>{
            if (spaBannerHeight === 0) this.hide($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME);
            else this.show($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME, spaBannerHeight);
        };
        /**
     * Adds or updates the specified banner in the list of visible banners.
     * Add the banner is not already in the list, otherwise update the banner's height.
     * Applied on the next microtask; a suppressed container drops the write entirely.
     *
     * @param {string} name Unique name of the banner
     * @param {number} height Height of the banner, in pixels
     */ this.show = (name, height)=>{
            if (this.suppressed) return;
            (0, $8zRYE.showBanner)(name, height);
        };
        /**
     * Removes the specified banner from the list of visible banners
     * Remove the banner if it is in the list, do nothing it is not
     *
     * @param {string} name Unique name of the banner
     */ this.hide = (name)=>{
            if (this.suppressed) return;
            (0, $8zRYE.hideBanner)(name);
        };
        /**
     * Returns the combined height of all banners in the list.
     * @param {boolean} includeTopNav Include `TOP_NAV_HEIGHT` in the calculation
     * if not `false`
     * @returns {number} Combined height of all visible banners
     */ this.getTotalHeight = (includeTopNav)=>this.state.banners.reduce((totalOffset, banner)=>totalOffset + banner.height, includeTopNav !== false ? this.topNavHeight : 0);
        /**
     * Returns list of all banners in visible list in "-" seperated string.
     * @returns {string} Combined names of all banners in visible list seperated by "-"
     */ this.getBannerList = ()=>this.state.banners.map((banner)=>banner.name).join('-');
        /**
     * Detaches from the store. unstated gives containers no teardown hook, so any caller that creates
     * short-lived containers — fixtures, tests, anything mounted more than once — must call this, or
     * the store keeps the listener and with it this instance alive for the lifetime of the module.
     */ this.destroy = ()=>{
            this.unsubscribeFromStore?.();
            this.unsubscribeFromStore = null;
        };
        this.scheduleNotify = ()=>{
            if (this.pendingNotify) return;
            this.pendingNotify = Promise.resolve().then(()=>{
                this.pendingNotify = null;
                return this.notifyListeners();
            });
        };
        const navHeight = (0, $jecot.resolveTopNavHeight)();
        this.topNavHeight = props.hasTopNav === false ? 0 : navHeight;
        this.suppressed = props.suppressed === true;
        if (this.suppressed) return;
        (0, $8zRYE.seedBanners)(props.initialState?.banners ?? []);
        this.state = {
            banners: (0, $8zRYE.getBanners)()
        };
        // The mirror is synchronous so a read straight after a flush is fresh; the notification is
        // coalesced, so a tick's worth of store changes costs one round no matter which container
        // (or hook) wrote them.
        this.unsubscribeFromStore = (0, $8zRYE.subscribeToBanners)(()=>{
            this.state = {
                banners: (0, $8zRYE.getBanners)()
            };
            this.scheduleNotify();
        });
    }
}
module.exports["findBanner"] = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620;
module.exports["BannerStateContainer"] = $6ee3834dea9f6c5c$export$bbac707b3ebb5681;

});

parcelRegister("a4dgs", function(module, exports) {
// unstated is deprecated; new banner state belongs in src/bannerStore.ts
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");

class $5ed4587dbe3a0e20$export$5db0f71585d91cd4 extends (0, $kNIYN.Container) {
    subscribe(fn) {
        this.listeners.add(fn);
    }
    unsubscribe(fn) {
        this.listeners.delete(fn);
    }
    setState(updater, callback) {
        return Promise.resolve().then(()=>{
            const next = typeof updater === 'function' ? updater(this.state) : updater;
            if (next == null) {
                callback?.();
                return;
            }
            this.state = Object.assign({}, this.state, next);
            return this.notifyListeners().then(()=>{
                callback?.();
            });
        });
    }
    notifyListeners() {
        // Snapshot before notifying: a listener's re-render makes unstated's Subscribe unsubscribe
        // and resubscribe, which would mutate the Set mid-iteration.
        const snapshot = Array.from(this.listeners);
        return Promise.all(snapshot.map((listener)=>listener())).then(()=>undefined);
    }
    constructor(...args){
        super(...args);
        this.listeners = new Set();
    }
}
module.exports["BaseStateContainer"] = $5ed4587dbe3a0e20$export$5db0f71585d91cd4;

});

parcelRegister("8zRYE", function(module, exports) {

var $i3jcY = parcelRequire("i3jcY");

/**
 * Module store for the page-top banner stack, read through `useSyncExternalStore`.
 *
 * A module store, not a library: see `docs/llm/agent-instructions/common/state-management.md`.
 *
 * Writes are deferred to a microtask and coalesced here rather than in any caller, so every writer —
 * the container shim and the `useBannerState` hooks — inherits it. Notification is synchronous and
 * several banners still call `show`/`hide` from a render body, so an undeferred write would update
 * other components mid-render.
 *
 * Global and unscoped: only three production containers exist — the client root, the SSR root
 * (mutually exclusive with it), and `WithoutBanners`, which is write-free and read-once.
 *
 * SSR: Tesseract isolates each request, so module state is per-request. `handleReactRender.tsx`
 * serialises the server's list into `window.__SSR_BANNERS__`, which this store reads at module init,
 * so the first render — including the hydrating one — matches the server without waiting on a
 * container. The server has no such global, so its seed is an explicit `seedBanners` call from the
 * SSR entry point; that keeps `ssrBannerManager` out of this module.
 *
 * `stableUI=1` (E2E/VR runs) is honoured here, at all three entry points that can change `banners`,
 * rather than in each writer: `ssrBannerManager` registers banners regardless of the URL param, so
 * an unguarded hydration seed would give a hydrating render banners the SSR render dropped, and the
 * `useBannerState` hooks never see the param at all.
 */ /** Frozen so a consumer cannot mutate it, and stable so `getSnapshot` never triggers a re-render. */ const $827d62b6188a5818$var$NO_BANNERS = Object.freeze([]);
/**
 * Read at module init rather than from a component, so the store is populated before anything
 * renders. Entries are validated because the value is deserialised from the page.
 *
 * No `typeof window` guard: the build substitutes `globalThis`, so `window` is always defined in both
 * environments. On the server the property simply is not set, which the `Array.isArray` check already
 * covers — the server seed comes from `seedBanners` instead.
 */ const $827d62b6188a5818$var$readHydrationBanners = ()=>{
    // `Array.isArray` is deliberately first: it short-circuits on the server, where the global is
    // never set, so the request URI — not available this early in module evaluation — is never read.
    if (!Array.isArray(window.__SSR_BANNERS__) || (0, $i3jcY.isStableUIEnabledForTests)()) return $827d62b6188a5818$var$NO_BANNERS;
    const parsed = window.__SSR_BANNERS__.filter((banner)=>typeof banner?.name === 'string' && typeof banner?.height === 'number');
    return parsed.length > 0 ? parsed : $827d62b6188a5818$var$NO_BANNERS;
};
let $827d62b6188a5818$var$banners = $827d62b6188a5818$var$readHydrationBanners();
const $827d62b6188a5818$var$listeners = new Set();
const $827d62b6188a5818$export$49fd326b255f6ddb = ()=>$827d62b6188a5818$var$banners;
const $827d62b6188a5818$export$7cfac2c025b473e4 = (listener)=>{
    $827d62b6188a5818$var$listeners.add(listener);
    return ()=>{
        $827d62b6188a5818$var$listeners.delete(listener);
    };
};
const $827d62b6188a5818$var$commit = (next)=>{
    $827d62b6188a5818$var$banners = next;
    // Snapshot first: a listener may unsubscribe while being notified.
    Array.from($827d62b6188a5818$var$listeners).forEach((listener)=>listener());
};
let $827d62b6188a5818$var$pending = [];
let $827d62b6188a5818$var$pendingFlush = null;
const $827d62b6188a5818$var$enqueue = (mutate)=>{
    // Evaluated per call rather than memoised at module init: an SPA transition changes
    // `window.location.search`, so the param is not a session constant.
    // Hides are dropped along with shows, which is safe because nothing can enter the store.
    if ((0, $i3jcY.isStableUIEnabledForTests)()) return;
    $827d62b6188a5818$var$pending.push(mutate);
    if ($827d62b6188a5818$var$pendingFlush) return;
    $827d62b6188a5818$var$pendingFlush = Promise.resolve().then(()=>{
        $827d62b6188a5818$var$pendingFlush = null;
        const queued = $827d62b6188a5818$var$pending;
        $827d62b6188a5818$var$pending = [];
        let next = $827d62b6188a5818$var$banners;
        let changed = false;
        for (const run of queued){
            // Applied against the running value, not the pre-flush one, so a name shown twice in a tick
            // resolves against the first write rather than duplicating.
            const result = run(next);
            if (result === undefined) continue;
            next = result;
            changed = true;
        }
        if (changed) $827d62b6188a5818$var$commit(next);
    });
};
const $827d62b6188a5818$export$f5c0eb035ef26e87 = (name, height)=>{
    $827d62b6188a5818$var$enqueue((current)=>{
        const index = current.findIndex((banner)=>banner.name === name);
        if (index === -1) return [
            ...current,
            {
                name: name,
                height: height
            }
        ];
        if (current[index].height !== height) {
            const next = [
                ...current
            ];
            // Replace rather than mutate, so the previous array keeps the old height.
            next[index] = {
                name: name,
                height: height
            };
            return next;
        }
        return undefined;
    });
};
const $827d62b6188a5818$export$11fa8b7d26b756a8 = (name)=>{
    $827d62b6188a5818$var$enqueue((current)=>{
        const index = current.findIndex((banner)=>banner.name === name);
        if (index === -1) return undefined;
        const next = [
            ...current
        ];
        next.splice(index, 1);
        return next;
    });
};
const $827d62b6188a5818$export$468156c225d4c0f9 = (initial)=>{
    if ((0, $i3jcY.isStableUIEnabledForTests)()) return;
    if ($827d62b6188a5818$var$banners.length === 0 && initial.length > 0) $827d62b6188a5818$var$commit([
        ...initial
    ]);
};
const $827d62b6188a5818$export$b3f5cfd1906442cb = ()=>{
    $827d62b6188a5818$var$banners = $827d62b6188a5818$var$NO_BANNERS;
    $827d62b6188a5818$var$listeners.clear();
    $827d62b6188a5818$var$pending = [];
    $827d62b6188a5818$var$pendingFlush = null;
};
module.exports["getBanners"] = $827d62b6188a5818$export$49fd326b255f6ddb;
module.exports["subscribeToBanners"] = $827d62b6188a5818$export$7cfac2c025b473e4;
module.exports["showBanner"] = $827d62b6188a5818$export$f5c0eb035ef26e87;
module.exports["hideBanner"] = $827d62b6188a5818$export$11fa8b7d26b756a8;
module.exports["seedBanners"] = $827d62b6188a5818$export$468156c225d4c0f9;

});

parcelRegister("jecot", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $ff48e00b2c36a911$export$756e5b68ec79d923 = ()=>{
    if (// The increased height change is applied when FHS or app switcher improvements are enabled.
    // Ideally we could check `useIsFhsEnabled()` but this has to work outside React too.
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $6mKj3.expVal)('navx-full-height-sidebar-exp', 'isEnabled', false) || (0, $9wGTI.fg)('platform_dst_ads_appswitcher_improvements')) return 56;
    return 48;
};
module.exports["resolveTopNavHeight"] = $ff48e00b2c36a911$export$756e5b68ec79d923;

});

parcelRegister("bJX6u", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");

const $258e0d668fcd3778$export$7e292eecf5a8f340 = {
    contentState: null,
    contentStateLastUpdated: null,
    shouldRunContentStateEffect: true,
    defaultStatesArray: [],
    customStatesArray: [],
    isContentStateEnabled: true,
    isSuggestedEnabled: true,
    isCustomEnabled: true,
    isUpdating: false,
    lastFetchedIsDraft: null,
    lastFetchedContentId: null
};
class $258e0d668fcd3778$export$ade89fbf99f42685 extends (0, $kNIYN.Container) {
    populateState(ssrContentStateData) {
        const newContentStateValues = Object.assign({}, $258e0d668fcd3778$export$7e292eecf5a8f340);
        newContentStateValues.shouldRunContentStateEffect = false;
        newContentStateValues.contentState = ssrContentStateData?.singleContent?.contentState || null;
        newContentStateValues.contentStateLastUpdated = ssrContentStateData?.singleContent?.contentStateLastUpdated?.value || null;
        newContentStateValues.defaultStatesArray = ssrContentStateData?.availableContentStates?.spaceContentStates?.filter((i)=>!!i) || [];
        newContentStateValues.customStatesArray = ssrContentStateData?.availableContentStates?.customContentStates?.filter((i)=>!!i) || [];
        // If an admin has turned off a toggle, BE returns us the value as null
        // If an empty array is returned [], means the feature is still enabled - there's just no values in there.
        // if both return as null it means the admin disabled content states
        const isSuggestedContentStatesDisabled = !ssrContentStateData?.availableContentStates?.spaceContentStates;
        const isCustomContentStatesDisabled = !ssrContentStateData?.availableContentStates?.customContentStates;
        const isContentStatesDisabled = isSuggestedContentStatesDisabled && isCustomContentStatesDisabled;
        if (isContentStatesDisabled) newContentStateValues.isContentStateEnabled = false;
        else if (isSuggestedContentStatesDisabled) // if spaceContentStates is null, admin disabled suggested
        newContentStateValues.isSuggestedEnabled = false;
        else if (isCustomContentStatesDisabled) // if customContentStates is null, admin disabled custom
        newContentStateValues.isCustomEnabled = false;
        this.state = newContentStateValues;
    }
    constructor(ssrContentStateData){
        super();
        this.state = {
            ...$258e0d668fcd3778$export$7e292eecf5a8f340
        };
        // Guards optimistic, mutation-owned fields (applied status + option list) from being
        // clobbered by stale refetches while an operation is pending. Kept off `state` so it
        // survives the refetch-driven `setInitialValues` calls.
        this.isOptimisticOperationPending = false;
        this.setIsOptimisticOperationPending = (isOptimisticOperationPending)=>{
            this.isOptimisticOperationPending = isOptimisticOperationPending;
        };
        // The contentId for which the empty add-status trigger should be kept visible after a
        // view-mode delete. Stored as an id (not a boolean) so render can scope it to the current page
        // without a navigation listener — it's only honored while this matches the active contentId,
        // so it naturally clears on navigation. Kept off `state` so a fresh container (refresh) resets it.
        this.keepEmptyTriggerForContentId = null;
        this.setKeepEmptyTriggerForContentId = (contentId)=>{
            this.keepEmptyTriggerForContentId = contentId;
        };
        this.setContentState = (contentState)=>this.setState({
                contentState: contentState
            });
        this.setShouldRunContentStateEffect = (shouldRunContentStateEffect)=>this.setState({
                shouldRunContentStateEffect: shouldRunContentStateEffect
            });
        this.setDefaultStatesArray = (defaultStatesArray)=>this.setState({
                defaultStatesArray: defaultStatesArray
            });
        this.setCustomStatesArray = (customStatesArray)=>this.setState({
                customStatesArray: customStatesArray
            });
        this.setIsContentStateEnabled = (isContentStateEnabled)=>this.setState({
                isContentStateEnabled: isContentStateEnabled
            });
        this.setIsSuggestedEnabled = (isSuggestedEnabled)=>this.setState({
                isSuggestedEnabled: isSuggestedEnabled
            });
        this.setIsCustomEnabled = (isCustomEnabled)=>this.setState({
                isCustomEnabled: isCustomEnabled
            });
        this.setIsUpdating = (isUpdating)=>this.setState({
                isUpdating: isUpdating
            });
        this.setLastFetchedIsDraft = (lastFetchedIsDraft)=>this.setState({
                lastFetchedIsDraft: lastFetchedIsDraft
            });
        this.setLastFetchedContentId = (lastFetchedContentId)=>this.setState({
                lastFetchedContentId: lastFetchedContentId
            });
        this.setInitialValues = (contentStateState)=>this.setState(contentStateState);
        this.resetToDefaults = ()=>this.setState({
                ...$258e0d668fcd3778$export$7e292eecf5a8f340
            });
        if (ssrContentStateData) this.populateState(ssrContentStateData);
    }
}
module.exports["defaultValues"] = $258e0d668fcd3778$export$7e292eecf5a8f340;
module.exports["ContentStateStateContainer"] = $258e0d668fcd3778$export$ade89fbf99f42685;

});

parcelRegister("ktUCG", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");


var $6mKj3 = parcelRequire("6mKj3");


var $8rneB = parcelRequire("8rneB");


var $bKZz0 = parcelRequire("bKZz0");

class $122734ff4c4db131$export$c7d05d5ff2632978 extends (0, $kNIYN.Container) {
    populateState(ssrEmojiTitleData) {
        const { emojiStatusFieldName: emojiStatusFieldName, queryData: queryData, isLivePage: isLivePage } = ssrEmojiTitleData;
        const emojiId = (0, $8rneB.getEmojiId)(queryData, emojiStatusFieldName);
        const hasDefaultLiveTitleEmoji = (0, $8rneB.getHasLiveDocsDefaultEmoji)(queryData);
        this.setSelectedEmoji(emojiId || null);
        this.setHasLiveDocsDefaultEmoji(hasDefaultLiveTitleEmoji && isLivePage);
    }
    constructor(ssrEmojiTitleData){
        super();
        // Analytics-only flag: intentionally bypasses Container state so mutations
        // never trigger subscriber re-renders.
        this.justRestoredEmoji = false;
        this.state = {
            emojiPickerLoaded: false,
            isLoading: true,
            isMouseEnterTitle: false,
            isUpdatingEmoji: false,
            openFirstEmojiPicker: false,
            openSecondEmojiPicker: false,
            selectedEmoji: null,
            isEmojiButtonFocused: false,
            isRemovingEmoji: false,
            hasLiveDocsDefaultEmoji: false,
            previousEmojiIdByContentId: {}
        };
        this.onUpdateStart = ()=>this.setState({
                isUpdatingEmoji: true
            });
        this.onUpdateEnd = ()=>{
            this.setState({
                isUpdatingEmoji: false
            });
            this.setState({
                isRemovingEmoji: false
            });
        };
        this.setIsEmojiButtonFocused = (isEmojiButtonFocused)=>this.setState({
                isEmojiButtonFocused: isEmojiButtonFocused
            });
        this.setIsRemovingEmoji = (isRemovingEmoji)=>this.setState({
                isRemovingEmoji: isRemovingEmoji
            });
        this.setIsUpdatingEmoji = (isUpdatingEmoji)=>this.setState({
                isUpdatingEmoji: isUpdatingEmoji
            });
        // first emoji picker is open when user already selected an emoji
        // click on the emoji and want to change it to different emoji
        this.setOpenFirstEmojiPicker = (isOpen)=>{
            if (this.state.openFirstEmojiPicker !== isOpen) this.setState({
                openFirstEmojiPicker: isOpen
            });
        };
        // second emoji picker is open when not yet selected an emoji
        // and want to add emoji via Add emoji button
        this.setOpenSecondEmojiPicker = (isOpen)=>{
            if (this.state.openSecondEmojiPicker !== isOpen) this.setState({
                openSecondEmojiPicker: isOpen
            });
        };
        this.setSelectedEmoji = (emoji)=>this.setState({
                selectedEmoji: emoji
            });
        this.onEmojiPickerLoaded = ()=>{
            if (!this.state.emojiPickerLoaded) this.setState({
                emojiPickerLoaded: true
            });
        };
        // for testing
        this.setContainerState = (newState)=>this.setState((state)=>({
                    ...state,
                    ...newState
                }));
        this.setLoadingEmoji = (isLoading)=>this.setState({
                isLoading: isLoading
            });
        this.setHasLiveDocsDefaultEmoji = (hasDefaultEmoji)=>this.setState({
                hasLiveDocsDefaultEmoji: hasDefaultEmoji
            });
        this.getPreviousEmojiId = (contentId)=>this.state.previousEmojiIdByContentId[contentId] ?? null;
        // Pass `null` to clear just that entry.
        this.setPreviousEmojiId = (contentId, previousEmojiId)=>{
            const next = {
                ...this.state.previousEmojiIdByContentId
            };
            if (previousEmojiId === null) delete next[contentId];
            else next[contentId] = previousEmojiId;
            if ((0, $6mKj3.isExperimentEnabled)('cc_page_experiences_livedocs_restore_latest_emoji')) (0, $bKZz0.writeSessionStoragePreviousEmojiCache)(next);
            return this.setState({
                previousEmojiIdByContentId: next
            });
        };
        if ((0, $6mKj3.isExperimentEnabled)('cc_page_experiences_livedocs_restore_latest_emoji')) {
            const hydrated = (0, $bKZz0.readSessionStoragePreviousEmojiCache)();
            if (Object.keys(hydrated).length > 0) this.state = {
                ...this.state,
                previousEmojiIdByContentId: hydrated
            };
        }
        if (ssrEmojiTitleData) this.populateState(ssrEmojiTitleData);
    }
}
module.exports["EmojiTitleStateContainer"] = $122734ff4c4db131$export$c7d05d5ff2632978;

});

parcelRegister("bKZz0", function(module, exports) {
/**
 * sessionStorage mirror for the per-contentId `previousEmojiId` cache used by
 * the Live Docs "Restore emoji" affordance. Survives same-tab refresh; not a
 * source of truth — the in-memory unstated state is. Failures degrade silently.
 */ 
var $17wUi = parcelRequire("17wUi");


var $ivEX1 = parcelRequire("ivEX1");

const $dabf2e5c28263f4b$var$STORAGE_KEY = (0, $ivEX1.sessionKeys).EMOJI_TITLE_PREVIOUS_EMOJI;
const $dabf2e5c28263f4b$export$6adb2744b497be8f = ()=>{
    try {
        const raw = (0, $17wUi.confluenceSessionStorageInstance)?.getItem($dabf2e5c28263f4b$var$STORAGE_KEY);
        if (!raw || typeof raw !== 'string') return {};
        const parsed = JSON.parse(raw);
        if (!parsed || parsed.v !== 1 || typeof parsed.entries !== 'object' || !parsed.entries) return {};
        // Defensive: filter to non-empty string values in case the slot was
        // mutated by something else on the same origin.
        const out = {};
        for (const [contentId, emojiId] of Object.entries(parsed.entries))if (typeof emojiId === 'string' && emojiId.length > 0) out[contentId] = emojiId;
        return out;
    } catch  {
        return {};
    }
};
const $dabf2e5c28263f4b$export$3ef572a2467e08f4 = (map)=>{
    try {
        const entries = {};
        for (const [contentId, emojiId] of Object.entries(map))if (typeof emojiId === 'string' && emojiId.length > 0) entries[contentId] = emojiId;
        // Drop the key entirely when empty to keep storage clean.
        if (Object.keys(entries).length === 0) {
            (0, $17wUi.confluenceSessionStorageInstance)?.removeItem($dabf2e5c28263f4b$var$STORAGE_KEY);
            return;
        }
        (0, $17wUi.confluenceSessionStorageInstance)?.setItem($dabf2e5c28263f4b$var$STORAGE_KEY, JSON.stringify({
            v: 1,
            entries: entries
        }));
    } catch  {
    // Quota / consent / disabled storage — swallow; in-memory cache is unaffected.
    }
};
const $dabf2e5c28263f4b$export$fc4e54f3757eb471 = $dabf2e5c28263f4b$var$STORAGE_KEY;
module.exports["readSessionStoragePreviousEmojiCache"] = $dabf2e5c28263f4b$export$6adb2744b497be8f;
module.exports["writeSessionStoragePreviousEmojiCache"] = $dabf2e5c28263f4b$export$3ef572a2467e08f4;

});

parcelRegister("ivEX1", function(module, exports) {
/**
 * Registry of keys used with `confluenceSessionStorageInstance` (session storage).
 *
 * Keys here are intentionally NOT persisted across browser sessions.
 * Do NOT add keys here that should survive a tab close — use `LocalStorageKeys.ts` instead.
 */ const $ebcfca89ee3399cd$export$43572ca00746d574 = {
    /**
	 * The layout ('grid' | 'list') selected by the user for the folder contents view.
	 * Persisted for the duration of the browser session only.
	 */ FOLDER_VIEW_LAYOUT: 'folder.view.layout',
    /**
	 * Overrides the release track to 'dev'. Useful for running end-to-end tests
	 * from a dev machine against a production instance.
	 * Used by @confluence/build-info.
	 */ TELEMETRY_DEV_TRACK_OVERRIDE: 'confluence.telemetry-dev-track-override',
    /**
	 * Enables Confluence frontend logging when set to 'true'.
	 * Used by @confluence/logger.
	 */ ENABLE_LOGGING: 'confluence.enable-logging',
    /**
	 * Controls the minimum log level (1–5) for Confluence frontend logging.
	 * Used by @confluence/logger.
	 */ LOG_LEVEL: 'confluence.log-level',
    /**
	 * Tracks when the page-watch nudge was last shown to the user.
	 * Used by @confluence/third-party-nudge.
	 */ PAGE_VIEW_NUDGE_DATE: 'page-view-nudge-date',
    /**
	 * Tracks the state of the notification section nudge.
	 * Used by @confluence/third-party-nudge.
	 */ NOTIFICATION_NUDGE_STATE: 'notification-nudge-state',
    /**
	 * Per-contentId cache of the most recent custom emoji observed on a Live
	 * Doc, used to drive the "Restore emoji" affordance.
	 * Used by @confluence/emoji-title.
	 */ EMOJI_TITLE_PREVIOUS_EMOJI: 'confluence.emoji-title.previousEmojiId.v1',
    /**
	 * Identifies the title-based agent suggestion already shown in this editing
	 * session. The value is the owning agent/content pair so the currently visible
	 * suggestion can remain mounted while all other title suggestions are suppressed.
	 * Used by @confluence/experiment-ootb-title-based-agent-suggestion-nudge.
	 */ TITLE_AGENT_NUDGE_SHOWN_SESSION: 'confluence.title-agent-nudge.shown-session'
};
module.exports["sessionKeys"] = $ebcfca89ee3399cd$export$43572ca00746d574;

});

parcelRegister("brNvA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $2c05d1bead0fe3b6$export$fb4e7a383f5cb089 = /*#__PURE__*/ (0, $cozmU.createContext)({
    commentToReattach: null,
    reattachHighlight: null,
    isInReattachMode: ()=>false
});
$2c05d1bead0fe3b6$export$fb4e7a383f5cb089.displayName = 'ReattachCommentContext';
const $2c05d1bead0fe3b6$export$29a077948aa018ea = /*#__PURE__*/ (0, $cozmU.createContext)({
    setCommentToReattach: ()=>{},
    setReattachHighlight: ()=>{},
    clearReattachMode: ()=>{}
});
$2c05d1bead0fe3b6$export$fb4e7a383f5cb089.displayName = 'ReattachCommentDispatchContext';
const $2c05d1bead0fe3b6$export$eeb6c3345224df9d = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children } = t0;
    const [commentToReattach, setCommentToReattach] = (0, $cozmU.useState)(null);
    const [reattachHighlight, setReattachHighlight] = (0, $cozmU.useState)(null);
    let t1;
    if ($[0] !== commentToReattach) {
        t1 = ()=>Boolean(commentToReattach);
        $[0] = commentToReattach;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== commentToReattach || $[3] !== reattachHighlight || $[4] !== t1) {
        t2 = {
            commentToReattach: commentToReattach,
            reattachHighlight: reattachHighlight,
            isInReattachMode: t1
        };
        $[2] = commentToReattach;
        $[3] = reattachHighlight;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    const providerValue = t2;
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            setCommentToReattach: setCommentToReattach,
            setReattachHighlight: (highlight)=>{
                setReattachHighlight(highlight?.numMatches !== 0 ? highlight : null);
            },
            clearReattachMode: ()=>{
                setCommentToReattach(null);
                setReattachHighlight(null);
            }
        };
        $[6] = t3;
    } else t3 = $[6];
    const dispatchProviderValue = t3;
    let t4;
    if ($[7] !== children) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c05d1bead0fe3b6$export$29a077948aa018ea.Provider, {
            value: dispatchProviderValue
        }, children);
        $[7] = children;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== providerValue || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c05d1bead0fe3b6$export$fb4e7a383f5cb089.Provider, {
            value: providerValue
        }, t4);
        $[9] = providerValue;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ children: children })=>{
    const [commentToReattach, setCommentToReattach] = (0, $cozmU.useState)(null);
    const [reattachHighlight, setReattachHighlight] = (0, $cozmU.useState)(null);
    const providerValue = (0, $cozmU.useMemo)(()=>({
            commentToReattach: commentToReattach,
            reattachHighlight: reattachHighlight,
            isInReattachMode: ()=>Boolean(commentToReattach)
        }), [
        commentToReattach,
        reattachHighlight
    ]);
    const dispatchProviderValue = (0, $cozmU.useMemo)(()=>({
            setCommentToReattach: setCommentToReattach,
            setReattachHighlight: (highlight)=>{
                setReattachHighlight(highlight?.numMatches !== 0 ? highlight : null);
            },
            clearReattachMode: ()=>{
                setCommentToReattach(null);
                setReattachHighlight(null);
            }
        }), [
        setCommentToReattach,
        setReattachHighlight
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c05d1bead0fe3b6$export$fb4e7a383f5cb089.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c05d1bead0fe3b6$export$29a077948aa018ea.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $2c05d1bead0fe3b6$export$d801c7a3a205f98e = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($2c05d1bead0fe3b6$export$fb4e7a383f5cb089);
} : ()=>{
    return (0, $cozmU.useContext)($2c05d1bead0fe3b6$export$fb4e7a383f5cb089);
};
const $2c05d1bead0fe3b6$export$344893016ba0bdd4 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($2c05d1bead0fe3b6$export$29a077948aa018ea);
} : ()=>{
    return (0, $cozmU.useContext)($2c05d1bead0fe3b6$export$29a077948aa018ea);
};
module.exports["ReattachCommentContext"] = $2c05d1bead0fe3b6$export$fb4e7a383f5cb089;
module.exports["ReattachCommentProvider"] = $2c05d1bead0fe3b6$export$eeb6c3345224df9d;
module.exports["useReattachComment"] = $2c05d1bead0fe3b6$export$d801c7a3a205f98e;
module.exports["useReattachCommentDispatch"] = $2c05d1bead0fe3b6$export$344893016ba0bdd4;

});

parcelRegister("fN9wG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4aRua = parcelRequire("4aRua");


var $9DHhW = parcelRequire("9DHhW");


var $7aRa9 = parcelRequire("7aRa9");


var $9wGTI = parcelRequire("9wGTI");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $17wUi = parcelRequire("17wUi");


var $b5SMr = parcelRequire("b5SMr");


var $elPdM = parcelRequire("elPdM");


var $c0rhi = parcelRequire("c0rhi");

const $bd929afc952baa40$var$INVITE_CAPABILITIES_URL = '/gateway/api/v3/invitations/capabilities';
const $bd929afc952baa40$var$INVITE_CAPABILITIES_DIRECT_INVITE_MODE_KEY = 'confluence_invite_capabilities_direct_invite_mode';
const $bd929afc952baa40$var$i18n = (0, $kSwu1.defineMessages)({
    inviteSuccessTitle: {
        id: "fabric-media-support.mentions-provider.x-product-user-invite.success.title",
        defaultMessage: "Successfully added"
    },
    inviteSuccessDescription: {
        id: "fabric-media-support.mentions-provider.x-product-user-invite.success.description",
        defaultMessage: "We sent an email to <b>{name}</b> confirming you added them to Confluence."
    }
});
const $bd929afc952baa40$export$3bdfaf8c811be72d = /*#__PURE__*/ (0, $cozmU.createContext)({});
const $bd929afc952baa40$var$hasDirectInviteCapabilities = async (cloudId, createAnalyticsEvent)=>{
    try {
        const canUserAccessJira = await $bd929afc952baa40$var$hasJiraSoftwareAccess(cloudId) ?? false;
        let directInviteMode;
        let invitePendingApprovalMode;
        if (canUserAccessJira) {
            //Call invite capabilities endpoint only if directInviteMode value is not available from local storage
            directInviteMode = (0, $17wUi.confluenceLocalStorageInstance).getItem($bd929afc952baa40$var$INVITE_CAPABILITIES_DIRECT_INVITE_MODE_KEY);
            if (!directInviteMode) {
                const response = await (0, $f7B1p.cfetch)(`${$bd929afc952baa40$var$INVITE_CAPABILITIES_URL}?resource=ari:cloud:platform::site/${cloudId}`, {
                    method: 'GET',
                    headers: {
                        ACCEPT: 'application/json'
                    }
                });
                if (!response.ok) throw new Error(`Network response error.  HTTP status: ${response.status}`);
                const data = await response.json();
                for (const item of data)if (item?.resourceARI?.includes('confluence')) {
                    directInviteMode = item?.directInvite?.mode;
                    invitePendingApprovalMode = item?.invitePendingApproval?.mode;
                    break;
                }
                createAnalyticsEvent && createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        source: 'editor',
                        action: 'fetched',
                        actionSubject: 'inviteCapabilitiesForXProductUserInvite',
                        attributes: {
                            directInviteMode: directInviteMode,
                            invitePendingApprovalMode: invitePendingApprovalMode
                        }
                    }
                }).fire();
                if (!!directInviteMode) (0, $17wUi.confluenceLocalStorageInstance).setItem($bd929afc952baa40$var$INVITE_CAPABILITIES_DIRECT_INVITE_MODE_KEY, directInviteMode, 86400);
            }
        }
        return directInviteMode === 'ANYONE';
    } catch (error) {
        const errorMessage = error instanceof Error ? error.message : String(error);
        createAnalyticsEvent && createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: 'editor',
                action: 'errored',
                actionSubject: 'inviteCapabilitiesForXProductUserInvite',
                attributes: {
                    errorMessage: errorMessage
                }
            }
        }).fire();
        return false;
    }
};
const $bd929afc952baa40$var$hasJiraSoftwareAccess = async (cloudId)=>{
    return (0, $c0rhi.queryInterop)({
        query: (0, $b5SMr.default),
        variables: {
            resourceId: `ari:cloud:jira::site/${cloudId}`,
            permissionId: 'write'
        },
        __callerPackage__: "fabric-media-support"
    }).then(({ data: data })=>{
        const hasJira = data?.confluence_tenantContext?.licensedProducts.some((product)=>product?.productKey?.toLowerCase().includes('jira-software') && product?.licenseStatus === (0, $elPdM.LicenseStatus).ACTIVE);
        return !!hasJira && data?.permitted;
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).FLYWHEEL_ENGAGEMENT
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return false;
    });
};
const $bd929afc952baa40$export$266d732058715003 = ({ children: children, flags: flags })=>{
    const { accessStatus: accessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const promiseRef = (0, $cozmU.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isEligibleXProductUserInvite = (0, $cozmU.useCallback)(()=>{
        //check the eligibility criteria only once per SPA
        if (promiseRef.current) return promiseRef.current;
        promiseRef.current = (async ()=>{
            try {
                if (!(0, $9wGTI.fg)('cc_virality_x_product_user_invite_kill_switch') || !(accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS)) return false;
                return await $bd929afc952baa40$var$hasDirectInviteCapabilities(cloudId, createAnalyticsEvent);
            } catch  {
                return false;
            }
        })();
        return promiseRef.current;
    }, [
        accessStatus,
        cloudId,
        createAnalyticsEvent
    ]);
    const showSuccessFlag = (0, $cozmU.useCallback)((name, isSuccess)=>{
        if (isSuccess) flags.showFlag({
            id: `x-product-user-invite-success`,
            title: formatMessage($bd929afc952baa40$var$i18n.inviteSuccessTitle),
            description: formatMessage($bd929afc952baa40$var$i18n.inviteSuccessDescription, {
                name: name,
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                        weight: "bold"
                    }, chunks)
            }),
            type: 'success-circle'
        });
    }, [
        flags,
        formatMessage
    ]);
    const value = (0, $cozmU.useMemo)(()=>({
            isEligibleXProductUserInvite: isEligibleXProductUserInvite,
            onXProductUserInviteClick: (name, isSuccess)=>{
                showSuccessFlag(name, isSuccess);
            }
        }), [
        isEligibleXProductUserInvite,
        showSuccessFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bd929afc952baa40$export$3bdfaf8c811be72d.Provider, {
        value: value
    }, children);
};
const $bd929afc952baa40$export$363c701b8b10381c = (0, $7aRa9.withFlags)($bd929afc952baa40$export$266d732058715003);
module.exports["XProductUserInviteContext"] = $bd929afc952baa40$export$3bdfaf8c811be72d;
module.exports["XProductUserInviteProvider"] = $bd929afc952baa40$export$363c701b8b10381c;

});

parcelRegister("7aRa9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $cozmU.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("b5SMr", function(module, exports) {
/**
 * @generated SignedSource<<6d920e0b0bb587b6b159e40c1bffaa50>>
 * @relayHash 0799e7283121eb71f27f154269c35d2f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f082ceabb2a22dad1af827fe35d8b92c3abbe18d26f157a4497a988561a8d8ff
const $0dd0647641a6eb7a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "permissionId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "resourceId"
    }, v2 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "permissionId",
                    "variableName": "permissionId"
                },
                {
                    "kind": "Variable",
                    "name": "resourceId",
                    "variableName": "resourceId"
                }
            ],
            "kind": "ScalarField",
            "name": "permitted"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "GetUserAccessQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "GetUserAccessQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "0799e7283121eb71f27f154269c35d2f",
            "id": "f082ceabb2a22dad1af827fe35d8b92c3abbe18d26f157a4497a988561a8d8ff",
            "metadata": {},
            "name": "GetUserAccessQuery",
            "operationKind": "query",
            "text": "query GetUserAccessQuery($resourceId:String!,$permissionId:String!){confluence_tenantContext{licensedProducts{licenseStatus,productKey}},permitted(resourceId:$resourceId,permissionId:$permissionId)}"
        }
    };
}();
$0dd0647641a6eb7a$var$node.hash = "32bb5d7171ecf6d04700c4e127e76256";
var $0dd0647641a6eb7a$export$2e2bcd8739ae039 = $0dd0647641a6eb7a$var$node;
module.exports["default"] = $0dd0647641a6eb7a$export$2e2bcd8739ae039;

});

parcelRegister("elPdM", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $ad8e722f7df5268a$export$902181cb056f3d0b = /*#__PURE__*/ function(LicenseStatus) {
    LicenseStatus["ACTIVE"] = "ACTIVE";
    LicenseStatus["SUSPENDED"] = "SUSPENDED";
    LicenseStatus["UNLICENSED"] = "UNLICENSED";
    return LicenseStatus;
}({});
module.exports["LicenseStatus"] = $ad8e722f7df5268a$export$902181cb056f3d0b;

});

parcelRegister("kCeSx", function(module, exports) {
$parcel$export(module.exports, "default", () => $f022e5db44f52121$export$2e2bcd8739ae039);

var $bEYte = parcelRequire("bEYte");


var $apyi7 = parcelRequire("apyi7");


var $eYRlV = parcelRequire("eYRlV");


var $iyEDi = parcelRequire("iyEDi");


var $eYNcX = parcelRequire("eYNcX");


var $g4VeD = parcelRequire("g4VeD");

const $f022e5db44f52121$var$selectContentsFromIds = (0, $eYRlV.createContentsFromIdsSelector)();
const $f022e5db44f52121$export$c31df4bd766f9c35 = (state)=>{
    let spaceKey;
    let contentId;
    let contentType;
    let createpageProps = {};
    // CreatePage passes draftId as contentId. Use it instead of the one coming from
    if (state.editor.get('draftId') && state.editor.get('statusCode') === (0, $eYNcX.OK)) {
        contentId = state.editor.get('draftId');
        const createdPage = state.editor.get('result');
        let ancestors;
        let parentPage;
        if (typeof createdPage?.get === 'function') {
            contentType = createdPage.get('type', null);
            ancestors = createdPage.get('ancestors', []);
            parentPage = ancestors.last();
        } else {
            contentType = createdPage.type;
            ancestors = createdPage.ancestors || [];
            parentPage = ancestors[ancestors.length - 1];
        }
        createpageProps = {
            parentPageId: `${// So the page can either be a plain object or a record depending on timing...
            // TODO: Get rid of all the redux here.
            parentPage ? typeof parentPage.get === 'function' ? parentPage.get('id') : parentPage.id : 0}`,
            // cast to string
            pageVersion: 0 // enforce version 0, otherwise saving will fail with 409 Conflict
        };
    }
    const routeParams = (0, $iyEDi.getRouteParams)(state);
    const location = (0, $iyEDi.getLocation)(state);
    if (!spaceKey) spaceKey = routeParams.spaceKey;
    if (!contentId) // on old viewPage we need `contentId` for request permissions component
    // we can get it as `pageId` from location query;
    contentId = routeParams.contentId || (location.query || {}).pageId;
    if (!contentId && spaceKey) // Fallback to space homepage if no content id found
    contentId = `${state.entities.getIn([
        'spaces',
        spaceKey,
        'homepageId'
    ])}`; // string
    const currentPage = state.entities.getIn([
        'contents',
        `${contentId}`
    ]);
    if (contentId && currentPage) contentType = currentPage.type;
    const editorForCommentsIsEnabled = state.views.viewPage.editor.contentId;
    if (editorForCommentsIsEnabled) contentType = 'comment';
    if ([
        'CREATE_TEMPLATE_SPACE',
        'EDIT_TEMPLATE_SPACE',
        'EDIT_TEMPLATE',
        'CREATE_TEMPLATE'
    ].includes(location.routeName)) contentType = 'template';
    let viewpageProps = {};
    const currentPageVersion = state.entities.getIn([
        'versions',
        `${contentId}`
    ], {});
    if (currentPage) {
        const parentPage = currentPage.ancestors && currentPage.ancestors.size ? $f022e5db44f52121$var$selectContentsFromIds((0, $apyi7.fromJS)([
            currentPage.ancestors.last()
        ]), state).first() : null;
        viewpageProps = {
            pageTitle: currentPage.title,
            pageVersion: currentPageVersion.number,
            parentPageTitle: parentPage ? parentPage.title : '',
            parentPageId: parentPage ? parentPage.id : '0',
            canRemovePage: currentPage.currentUserPermissions && currentPage.currentUserPermissions.includes('delete')
        };
    }
    const experimentProps = {
        experimentFeatures: state.views.dashboard.get('experimentFeatures')
    };
    // TODO: there is no simple way to select the parent yet so this code will be commented out till we solve it
    // matches /spaces/{spaceKey}/pages or /spaces/{spaceKey}/pages/ only
    //const isPageTree = /\/spaces\/([~0-9A-z]*)\/pages(\/)?$/.test(location.pathname);
    //const contextualMenuOpenForPageId = state.views.spaceHome.pageTreeContextualMenu;
    //
    //if (isPageTree && !!contextualMenuOpenForPageId) {
    //    const selectedPage = state.entities.getIn(['contents', contextualMenuOpenForPageId]);
    //    if (selectedPage) {
    //        const parentPage = selectedPage.ancestors.size ? selectContentsFromIds(fromJS([selectedPage.ancestors.last()]), state).first() : null;
    //        viewpageProps = {
    //            contentId: selectedPage.id,
    //            pageTitle: selectedPage.title,
    //            parentPageTitle: parentPage ? parentPage.title : null,
    //            parentPageId: parentPage ? parentPage.id : '0',
    //            canRemovePage: selectedPage.currentUserPermissions.includes('delete')
    //        };
    //    }
    //}
    return {
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: contentType,
        spaceName: state.entities.getIn([
            'spaces',
            spaceKey,
            'name'
        ]),
        spaceType: state.entities.getIn([
            'spaces',
            spaceKey,
            'type'
        ]),
        ...viewpageProps,
        ...createpageProps,
        ...experimentProps
    };
};
var $f022e5db44f52121$export$2e2bcd8739ae039 = (0, $bEYte.connect)($f022e5db44f52121$export$c31df4bd766f9c35)((0, $g4VeD.default));

});

parcelRegister("eYRlV", function(module, exports) {

var $fZl6o = parcelRequire("fZl6o");


var $apyi7 = parcelRequire("apyi7");


var $ePeSL = parcelRequire("ePeSL");

const $ae800dfdeadf4eac$var$PREDEFINED_BLUEPRINT_TYPES = {
    'meeting-notes': true,
    decisions: true,
    'kb-how-to-article': true,
    'file-list': true,
    retrospective: true,
    requirements: true,
    'shared-links': true,
    'kb-troubleshooting-article': true,
    'task-report': true,
    jirareport: true
};
function $ae800dfdeadf4eac$var$isEmpty(data) {
    if (!data) return true;
    return !$ae800dfdeadf4eac$var$size(data);
}
function $ae800dfdeadf4eac$var$size(data) {
    if (!data) return 0;
    return data.hasOwnProperty('size') ? data.size : data.length;
}
const $ae800dfdeadf4eac$export$1ada442d7b78f25 = (0, $ePeSL.default)((item)=>item, (item, users)=>users, // 'containers' may be a space or a content, right now it's only ever content on file records
(item, users, containers)=>containers, (item, users, containers, versions)=>versions, (item, users, containers, versions)=>{
    let version = versions.get(`${item.version}`);
    if (version) version = version.set('by', users.get(version.by));
    const container = item.container ? containers.get(`${item.container}`) : null;
    let result = item.set('createdBy', users.get(item.createdBy)).set('version', version);
    if (item.contributors) result = result.set('contributors', item.contributors.map((accountId)=>users.get(accountId)));
    if (item.viewers) result = result.set('viewers', item.viewers.map((accountId)=>users.get(accountId)));
    if (container) {
        result = result.set('container', container);
        const containerVersion = container.get('version');
        if (containerVersion) result = result.setIn([
            'container',
            'version'
        ], versions.get(`${containerVersion}`));
    }
    return result;
});
const $ae800dfdeadf4eac$export$5c63e7dafa621e16 = (contentId, state)=>{
    const entities = state.entities;
    const content = entities.get('contents').get(`${contentId}`);
    if (content && (content.createdBy || content.version)) return $ae800dfdeadf4eac$export$1ada442d7b78f25(content, entities.get('users'), entities.get('contents'), entities.get('versions'));
    return content;
};
const $ae800dfdeadf4eac$export$fe6dd8e2950283cb = (state, contentId, permissionType)=>{
    const content = state.entities.getIn([
        'contents',
        contentId
    ]);
    return content.currentUserPermissions.contains(permissionType);
};
const $ae800dfdeadf4eac$export$84b461ed686ebfb9 = (state, contentId)=>$ae800dfdeadf4eac$export$fe6dd8e2950283cb(state, contentId, 'update');
const $ae800dfdeadf4eac$var$buildContentCreatedBy = (0, $ePeSL.default)((item)=>item, (item, users)=>users, (item, users)=>item.set('createdBy', users.get(item.createdBy)));
const $ae800dfdeadf4eac$export$5c767ea021dac201 = ()=>(0, $fZl6o.createSelector)((ids)=>ids, (ids, state, contents)=>contents || state.entities.get('contents'), (ids, state)=>state.entities.get('contents'), (ids, state)=>state.entities.get('versions'), (ids, state)=>state.entities.get('users'), // 'containers' may be a space or a content, right now it's only ever content on file records
    (ids, contents, containers, versions, users)=>{
        if (!ids) return null;
        if (typeof ids === 'number' || typeof ids === 'string') ids = (0, $apyi7.List)([
            `${ids}`
        ]);
        if (ids.length && !(0, $apyi7.List).isList(ids)) ids = (0, $apyi7.List)(ids);
        if (!ids.size) return (0, $apyi7.List)([]);
        ids = ids.filter((id)=>!!contents.get(`${id}`));
        return ids.map((id)=>{
            const content = contents.get(`${id}`);
            if (content.createdBy || content.version) return $ae800dfdeadf4eac$export$1ada442d7b78f25(content, users, containers, versions);
            return content;
        });
    });
const $ae800dfdeadf4eac$export$7203590478a6c254 = ()=>(0, $fZl6o.createSelector)((ids)=>ids, (ids, state)=>state.entities.get('contents'), (ids, contents)=>{
        if ($ae800dfdeadf4eac$var$isEmpty(ids)) return (0, $apyi7.List)([]);
        return ids.map((id)=>contents.get(`${id}`));
    });
const $ae800dfdeadf4eac$export$167cb14480de4389 = ()=>(0, $fZl6o.createSelector)((ids)=>ids, (ids, state)=>state.entities.get('contents'), (ids, state)=>state.entities.get('users'), (ids, contents, users)=>{
        if ($ae800dfdeadf4eac$var$isEmpty(ids)) return (0, $apyi7.List)([]);
        return ids.map((id)=>{
            const content = contents.get(`${id}`);
            if (content && content.createdBy) return $ae800dfdeadf4eac$var$buildContentCreatedBy(content, users);
            return content;
        });
    });
const $ae800dfdeadf4eac$var$getContent = (contentId, state)=>state.entities.getIn([
        'contents',
        contentId
    ]);
const $ae800dfdeadf4eac$var$getLabels = (contentId, state)=>state.entities.get('labels');
const $ae800dfdeadf4eac$export$e23bbeb6c3d185f2 = (0, $fZl6o.createSelector)($ae800dfdeadf4eac$var$getContent, $ae800dfdeadf4eac$var$getLabels, (content, labels)=>{
    if (!content || !labels) return '';
    const contentLabels = content.get('labels');
    if (!contentLabels || contentLabels.size === 0) return '';
    const contentBlueprintId = contentLabels.find((labelId)=>{
        const labelData = labels.get(labelId);
        return !labelData ? false : $ae800dfdeadf4eac$var$PREDEFINED_BLUEPRINT_TYPES[labelData.get('name')];
    });
    return contentBlueprintId ? labels.get(contentBlueprintId).get('name') : '';
});
module.exports["buildContentItem"] = $ae800dfdeadf4eac$export$5c63e7dafa621e16;
module.exports["createContentsFromIdsSelector"] = $ae800dfdeadf4eac$export$5c767ea021dac201;

});

parcelRegister("ePeSL", function(module, exports) {
$parcel$export(module.exports, "default", () => $acb15f65db8e2947$export$2e2bcd8739ae039);

var $fZl6o = parcelRequire("fZl6o");

/**
 * WeakMapMemoizer allows memoisation of lists
 */ class $acb15f65db8e2947$var$WeakMapMemoizer {
    memoize(...weakArgs) {
        return this._memoizeImpl(this.map, weakArgs, 0);
    }
    _memoizeImpl(map, args, i) {
        let value = map.get(args[i]);
        if (i === args.length - 1) {
            if (!value) {
                value = this.func(...args);
                map.set(args[i], value);
            }
            return value;
        }
        if (!value) {
            value = new WeakMap();
            map.set(args[i], value);
        }
        return this._memoizeImpl(value, args, i + 1);
    }
    constructor(func){
        this.map = new WeakMap();
        this.func = func;
    }
}
var /**
 * createSelectorCreator - drop in replacement for reselect.createSelector
 * which offers better performance when dealing with lists that should
 * be recreated very often
 */ $acb15f65db8e2947$export$2e2bcd8739ae039 = (0, $fZl6o.createSelectorCreator)((func)=>{
    const memoizer = new $acb15f65db8e2947$var$WeakMapMemoizer(func);
    return memoizer.memoize.bind(memoizer);
});

});

parcelRegister("g4VeD", function(module, exports) {

var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $1i7uI = parcelRequire("1i7uI");


var $cSdzn = parcelRequire("cSdzn");

class $bb496ac4c35df382$export$2e2bcd8739ae039 extends (0, $cozmU.Component) {
    componentDidMount() {
        this._setLegacyProps(this.props);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this._setLegacyProps(nextProps);
    }
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(this.props, nextProps);
    }
    componentWillUnmount() {
        this._setAJSValues({});
        this._cancelWaitForGlobalInProgress();
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        this._waitForGlobalInProgress = null;
        this._setLegacyProps = (props)=>{
            this._cancelWaitForGlobalInProgress();
            this._waitForGlobalInProgress = (0, $cSdzn.default)({
                listener: 'LegacyBridge.js',
                globalProperty: 'AJS.params'
            }, ()=>this._setAJSValues(props));
        };
        this._cancelWaitForGlobalInProgress = ()=>{
            if (this._waitForGlobalInProgress) // This prevents waitForGlobal to updates this component in random order in case of multiple calls.
            this._waitForGlobalInProgress.cancel();
        };
        this._setAJSValues = (props)=>{
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).AJS || !(0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).AJS.params) return;
            const { spaceKey: spaceKey, spaceName: spaceName, spaceType: spaceType, contentId: contentId, contentType: contentType, pageTitle: pageTitle, pageVersion: pageVersion, parentPageId: parentPageId, parentPageTitle: parentPageTitle, canRemovePage: canRemovePage, experimentFeatures: experimentFeatures } = props;
            const createPage = pageVersion === 0;
            const pageId = createPage ? '0' : contentId;
            // page/content info
            (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).AJS.params.pageId = pageId;
            (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).AJS.params.spaceKey = spaceKey;
            const metaParams = {
                // page/content info
                'content-id': contentId,
                'content-type': contentType,
                'page-id': pageId,
                'page-title': pageTitle,
                'page-version': pageVersion,
                'parent-page-id': parentPageId,
                'parent-page-title': parentPageTitle,
                'latest-page-id': contentId,
                'can-remove-page': canRemovePage,
                'new-page': createPage,
                // space info
                'space-key': spaceKey,
                'space-name': spaceName,
                'space-type': spaceType,
                // experiments
                'experiment-features': experimentFeatures
            };
            // Do not set if legacy bridge in next has already handled
            // See: next/packages/view-page/src/LegacyBridgeNext.js
            if ((0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).AJS.Meta && !(0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).AJS.Meta.get('has-next-legacy-bridge')) Object.keys(metaParams).forEach((key)=>{
                // standalone mode doesn't have AJS
                (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).AJS.Meta.set(key, metaParams[key]);
            });
        };
    }
}
$bb496ac4c35df382$export$2e2bcd8739ae039.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    contentType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    spaceName: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    spaceType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    pageTitle: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    pageVersion: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number,
    parentPageId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    parentPageTitle: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    canRemovePage: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    experimentFeatures: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string
};
module.exports["default"] = $bb496ac4c35df382$export$2e2bcd8739ae039;

});

parcelRegister("cSdzn", function(module, exports) {
$parcel$export(module.exports, "default", () => $95f50dcfd27e28ce$export$2e2bcd8739ae039);
function $95f50dcfd27e28ce$var$isDefined(path) {
    const pathParts = path.split('.');
    let obj = window[pathParts.shift()];
    while(typeof obj !== 'undefined' && pathParts.length)obj = obj[pathParts.shift()];
    return obj;
}
const $95f50dcfd27e28ce$var$lines = {};
function $95f50dcfd27e28ce$var$logOnce(message) {}
function $95f50dcfd27e28ce$export$d2adf65b87e47523() {
    for(const key in $95f50dcfd27e28ce$var$lines)delete $95f50dcfd27e28ce$var$lines[key];
}
function $95f50dcfd27e28ce$export$2e2bcd8739ae039({ listener: listener, globalProperty: globalProperty, interval: interval = 250 }, callback) {
    if ($95f50dcfd27e28ce$var$isDefined(globalProperty)) {
        $95f50dcfd27e28ce$var$logOnce(`window.${globalProperty} is already available for use by ${listener}.`);
        callback();
        return null;
    }
    const waitForGlobalInterval = setInterval(()=>{
        $95f50dcfd27e28ce$var$logOnce(`${listener} is waiting for window.${globalProperty} to be available`);
        if ($95f50dcfd27e28ce$var$isDefined(globalProperty)) {
            $95f50dcfd27e28ce$var$logOnce(`window.${globalProperty} now available!`);
            clearInterval(waitForGlobalInterval);
            callback();
        }
    }, interval);
    return {
        cancel () {
            if (waitForGlobalInterval) clearInterval(waitForGlobalInterval);
        }
    };
}

});

parcelRegister("7SkLu", function(module, exports) {

var $E1QOf = parcelRequire("E1QOf");


var $a33Aa = parcelRequire("a33Aa");

function $c60ab42870e33b24$export$f9c6890b323d326b(key, value) {
    const interactionId = (0, $E1QOf.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    (0, $a33Aa.addCohortingCustomData)(currentInteractionId, key, value);
}
module.exports["addUFOCustomCohortData"] = $c60ab42870e33b24$export$f9c6890b323d326b;

});

parcelRegister("aXWtB", function(module, exports) {

var $b8pma = parcelRequire("b8pma");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");

const $35c87ab817b10787$var$createLoadingComponent = ()=>{
    return (0, $b8pma.default)({
        name: 'LoadingConfluenceConversationAssistantBundle'
    });
};



const $35c87ab817b10787$export$3ca68d91b1a1bca2 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "HQN7e",
    name: "ConfluenceConversationAssistant",
    loader: async ()=>{
        if (!(0, $9wGTI.fg)('rovo_chat_fix_confluence_chunk_loading')) return (await (parcelRequire("7kvWk"))).ConfluenceConversationAssistant;
        // Fetch the outer loadable chunk (loadable-ConversationAssistant) AND
        // the AI-mate @atlassian/conversation-assistant chunk in parallel. Both
        // `import()` calls live inside this LoadableLazy object expression, so
        // LoadableMetaBabelPlugin tags them BOTH with this loadable's id — which
        // causes parcel-reporter-loadable to union both bundle groups into
        // preloadAssets for this loadable. Without the second `import()`, the
        // register chunk that owns modules like
        //   platform/…/atlassian-project-status-update-action-renderer/main.tsx
        // (module id 'iuVKP' on CDN / '2xPvv' in local builds) is not included
        // in this loadable's chunk set, and the runtime throws
        //   `Cannot find module 'iuVKP'`
        // when the outer loader's compiled `.then(() => parcelRequire('iuVKP'))`
        // fires.
        const [outer] = await Promise.all([
            (parcelRequire("7kvWk")),
            // eslint-disable-next-line import/dynamic-import-chunkname
            (parcelRequire("7t3um"))
        ]);
        return outer.ConfluenceConversationAssistant;
    },
    loading: $35c87ab817b10787$var$createLoadingComponent
});
module.exports["ConfluenceConversationAssistant"] = $35c87ab817b10787$export$3ca68d91b1a1bca2;

});

parcelRegister("7kvWk", function(module, exports) {

let $55632d3a1b4e72de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $55632d3a1b4e72de$var$load("k8nz9"),
    $55632d3a1b4e72de$var$load("mUfsl"),
    $55632d3a1b4e72de$var$load("5sZTx"),
    $55632d3a1b4e72de$var$load("deTdD"),
    $55632d3a1b4e72de$var$load("1JeTB"),
    $55632d3a1b4e72de$var$load("6wr18"),
    $55632d3a1b4e72de$var$load("ffEVr"),
    $55632d3a1b4e72de$var$load("Wowvf"),
    $55632d3a1b4e72de$var$load("zUKwV"),
    $55632d3a1b4e72de$var$load("fUeur"),
    $55632d3a1b4e72de$var$load("hhss7"),
    $55632d3a1b4e72de$var$load("7EorR"),
    $55632d3a1b4e72de$var$load("ce05o"),
    $55632d3a1b4e72de$var$load("cxCk7"),
    $55632d3a1b4e72de$var$load("7SteV"),
    $55632d3a1b4e72de$var$load("iEsP0"),
    $55632d3a1b4e72de$var$load("fwbNS"),
    $55632d3a1b4e72de$var$load("aoJPa")
]).then(()=>parcelRequire('kaQDe'));

});

parcelRegister("7t3um", function(module, exports) {

let $56fdf29f2425eb45$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $56fdf29f2425eb45$var$load("5sZTx"),
    $56fdf29f2425eb45$var$load("deTdD"),
    $56fdf29f2425eb45$var$load("1JeTB"),
    $56fdf29f2425eb45$var$load("6wr18"),
    $56fdf29f2425eb45$var$load("cxCk7"),
    $56fdf29f2425eb45$var$load("7SteV"),
    $56fdf29f2425eb45$var$load("ffEVr"),
    $56fdf29f2425eb45$var$load("Wowvf"),
    $56fdf29f2425eb45$var$load("zUKwV"),
    $56fdf29f2425eb45$var$load("fUeur"),
    $56fdf29f2425eb45$var$load("hhss7"),
    $56fdf29f2425eb45$var$load("7EorR"),
    $56fdf29f2425eb45$var$load("ce05o")
]).then(()=>parcelRequire('7Myh3'));

});

parcelRegister("gEtAQ", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $b5832a8b6d0203e7$export$d9797e3a42403d0f = ()=>Boolean((0, $1NBp8.VIEW_PAGE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$b6ab121b23baa35 = ()=>Boolean((0, $1NBp8.VIEW_BLOG).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_MOBILE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$99418391c9d4edd1 = ()=>Boolean((0, $1NBp8.HOME).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3b7cd9ec7876f958 = ()=>Boolean((0, $1NBp8.EDIT_PAGE_EMBED).match(window.location.pathname) || (0, $1NBp8.EDIT_PAGE_V2).match(window.location.pathname) || (0, $1NBp8.EDIT_BLOG_V2).match(window.location.pathname) || (0, $1NBp8.EDIT_PAGE).match(window.location.pathname) || (0, $1NBp8.EDIT_BLOG).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3ea67fa37c59fc23 = ()=>Boolean((0, $1NBp8.SPACE_OVERVIEW).match(window.location.pathname));
const $b5832a8b6d0203e7$export$ea39914fa18450ef = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.DATABASE_VIEW).name;
    return Boolean((0, $1NBp8.DATABASE_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$3a15fff847513284 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.WHITEBOARD_BOARD).name;
    return Boolean((0, $1NBp8.WHITEBOARD_BOARD).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$e40fec4aab490836 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.SLIDES_VIEW).name;
    return Boolean((0, $1NBp8.SLIDES_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$49ce8db5bd2e4087 = (routeName)=>{
    if (!routeName) return false;
    const editRoutes = [
        (0, $1NBp8.EDIT_PAGE_EMBED).name,
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name
    ];
    return editRoutes.includes(routeName);
};
module.exports["isViewPage"] = $b5832a8b6d0203e7$export$d9797e3a42403d0f;
module.exports["isBlogPage"] = $b5832a8b6d0203e7$export$b6ab121b23baa35;
module.exports["isHomePage"] = $b5832a8b6d0203e7$export$99418391c9d4edd1;
module.exports["isSpaceOverview"] = $b5832a8b6d0203e7$export$3ea67fa37c59fc23;
module.exports["isDatabase"] = $b5832a8b6d0203e7$export$ea39914fa18450ef;
module.exports["isWhiteboard"] = $b5832a8b6d0203e7$export$3a15fff847513284;
module.exports["isSlides"] = $b5832a8b6d0203e7$export$e40fec4aab490836;
module.exports["isEditPage"] = $b5832a8b6d0203e7$export$49ce8db5bd2e4087;

});

parcelRegister("i1t43", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $w6R6I = parcelRequire("w6R6I");


var $iDrrr = parcelRequire("iDrrr");


var $7vK9E = parcelRequire("7vK9E");

var $iMnC5 = parcelRequire("iMnC5");

const $7e44050607850249$var$styles = {
    base: "_0bjKvDcjp5 _0WKd3G4z3T",
    visitedLink: "_2nTuUYWfPD _3ADzdEWfPD _1warJ9WfPD _4scvAwWyeI",
    defaultAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _1UtDYzM7Tp _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0clgaMM7Tp _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8 _0CMRbkAwSC",
    defaultAppearanceMotion: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzM7Tp _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMM7Tp _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbkAwSC",
    subtleAppearance: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYzZpcK _32C2rk98eZ _0i9AWAYbGa _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMZpcK _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _0CMRbky7kJ",
    subtleAppearanceMotion: "_00uqCYjOvk _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzZpcK _32C2rkjOvk _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMZpcK _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbky7kJ",
    inverseAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _1UtDYze5R3 _2nTuUYe5R3 _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0clgaMe5R3 _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8 _0CMRbke5R3",
    inverseAppearanceMotion: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYze5R3 _2nTuUYe5R3 _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMe5R3 _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbke5R3",
    iconWrapper: "_3iDTPbS8kF _1ANEUSLRg7 _1RrJLiQame _1mT5xdRAKS _2I62gzVQEB"
};
const $7e44050607850249$var$iconStyles = null;
const $7e44050607850249$var$LinkWithoutRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(30);
    let children;
    let htmlAttributes;
    let newWindowLabel;
    let t1;
    let target;
    let testId;
    if ($[0] !== t0) {
        const { children: t2, testId: t3, appearance: t4, newWindowLabel: t5, target: t6, className: _preventedClassName, style: _preventedStyle, ...t7 } = t0;
        children = t2;
        testId = t3;
        t1 = t4;
        newWindowLabel = t5;
        target = t6;
        htmlAttributes = t7;
        $[0] = t0;
        $[1] = children;
        $[2] = htmlAttributes;
        $[3] = newWindowLabel;
        $[4] = t1;
        $[5] = target;
        $[6] = testId;
    } else {
        children = $[1];
        htmlAttributes = $[2];
        newWindowLabel = $[3];
        t1 = $[4];
        target = $[5];
        testId = $[6];
    }
    const appearance = t1 === undefined ? "default" : t1;
    let t2;
    if ($[7] !== appearance) {
        t2 = appearance === "default" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.defaultAppearanceMotion : $7e44050607850249$var$styles.defaultAppearance);
        $[7] = appearance;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== appearance) {
        t3 = appearance === "subtle" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.subtleAppearanceMotion : $7e44050607850249$var$styles.subtleAppearance);
        $[9] = appearance;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== appearance) {
        t4 = appearance === "inverse" && ((0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.inverseAppearanceMotion : $7e44050607850249$var$styles.inverseAppearance);
        $[11] = appearance;
        $[12] = t4;
    } else t4 = $[12];
    const t5 = appearance !== "inverse" && $7e44050607850249$var$styles.visitedLink;
    let t6;
    if ($[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
        t6 = (0, $w6R6I.cx)($7e44050607850249$var$styles.base, t2, t3, t4, t5);
        $[13] = t2;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== target || $[19] !== testId) {
        t7 = target === "_blank" && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            as: "span",
            xcss: $7e44050607850249$var$styles.iconWrapper,
            testId: testId && `${testId}__icon`,
            children: [
                "\uFEFF",
                /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
                    width: "12",
                    height: "12",
                    viewBox: "0 0 12 12",
                    fill: "none",
                    className: (0, $hekY6.default)([
                        "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                        fill: "currentColor"
                    })
                })
            ]
        });
        $[18] = target;
        $[19] = testId;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== children || $[22] !== htmlAttributes || $[23] !== newWindowLabel || $[24] !== ref || $[25] !== t6 || $[26] !== t7 || $[27] !== target || $[28] !== testId) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor), {
            ...htmlAttributes,
            target: target,
            ref: ref,
            xcss: t6,
            testId: testId,
            componentName: "Link",
            newWindowLabel: newWindowLabel,
            children: [
                children,
                t7
            ]
        });
        $[21] = children;
        $[22] = htmlAttributes;
        $[23] = newWindowLabel;
        $[24] = ref;
        $[25] = t6;
        $[26] = t7;
        $[27] = target;
        $[28] = testId;
        $[29] = t8;
    } else t8 = $[29];
    return t8;
} : ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>/*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $w6R6I.cx)($7e44050607850249$var$styles.base, appearance === 'default' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.defaultAppearanceMotion : $7e44050607850249$var$styles.defaultAppearance), appearance === 'subtle' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.subtleAppearanceMotion : $7e44050607850249$var$styles.subtleAppearance), appearance === 'inverse' && ((0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.inverseAppearanceMotion : $7e44050607850249$var$styles.inverseAppearance), // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $7e44050607850249$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                as: "span",
                xcss: $7e44050607850249$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $hekY6.default)([
                            "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
                        ]),
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    }); // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $7e44050607850249$var$Link = /*#__PURE__*/ (0, $cozmU.forwardRef)($7e44050607850249$var$LinkWithoutRef);
var $7e44050607850249$export$2e2bcd8739ae039 = $7e44050607850249$var$Link;
module.exports["default"] = $7e44050607850249$export$2e2bcd8739ae039;

});

parcelRegister("4o1RV", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $1eD4P = parcelRequire("1eD4P");


var $ihkY1 = parcelRequire("ihkY1");


var $kBW0t = parcelRequire("kBW0t");

function $f3bd82ae210529c7$export$57395cb9dce31159() {
    const $ = (0, $bDgLe.c)(3);
    const { navigationPolicy: navigationPolicy } = (0, $1eD4P.useReactProps_DO_NOT_USE)() || {};
    const routePolicy = (0, $ihkY1.useRoutePolicy)(navigationPolicy);
    const shimUrl = (0, $kBW0t.useShimUrl)(navigationPolicy);
    let t0;
    if ($[0] !== routePolicy || $[1] !== shimUrl) {
        t0 = {
            routePolicy: routePolicy,
            ...shimUrl
        };
        $[0] = routePolicy;
        $[1] = shimUrl;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
}
module.exports["useNavigationPolicy"] = $f3bd82ae210529c7$export$57395cb9dce31159;

});

parcelRegister("ihkY1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lTECB = parcelRequire("lTECB");


var $1eD4P = parcelRequire("1eD4P");


var $cb6fO = parcelRequire("cb6fO");


var $kBW0t = parcelRequire("kBW0t");

function $477c5af85d2d7fb0$export$53e37724c6846f41(navigationPolicy) {
    const isEmbeddedConfluence = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    const { shimUrl: shimUrl } = (0, $kBW0t.useShimUrl)(navigationPolicy);
    const iframePassThroughProps = (0, $1eD4P.useReactProps_DO_NOT_USE)();
    const enableIframeSpaTransitions = iframePassThroughProps?.enableSpaTransitions;
    const getEmbeddedConfluenceRoutePolicy = (0, $cozmU.useCallback)(()=>({
            push ({ match: match, matchSupportedRoute: matchSupportedRoute, open: open, push: defaultPush }, url, forceReload) {
                // When navigate to an url with anchor only e.g. `#test`, the navigation doesn't need to continue as SPA transition,
                // Hence, there is no need to continue the navigation using `push` and potentially execute parent product's navigate method.
                // In this case, we exit `routePolicy.push` earlier and use `open` (window.open) to load the url in the exisitng browsing context
                if ((0, $cb6fO.isHashedOnlyURL)(url)) {
                    open(url, '_self');
                    return;
                }
                const _currRouteName = match?.name;
                const _currRouteContentId = match?.params.contentId;
                const _destinationRoute = matchSupportedRoute(url);
                const _dstRouteName = _destinationRoute?.name;
                const _dstRouteContentId = _destinationRoute?.params.contentId;
                const _dstRouteSpaceKey = _destinationRoute?.params.spaceKey;
                /**
       * Transition within the same window if the target route is navigating to the same content
       * This can ensure link to anchors in the page can still happen within the same window, instead of opening a new tab
       **/ const modifiers = {
                    routeName: $477c5af85d2d7fb0$var$toEPRouteName(_dstRouteName),
                    contentId: _dstRouteContentId,
                    spaceKey: _dstRouteSpaceKey,
                    target: this.willPushInSelf(_currRouteName, _currRouteContentId, _dstRouteName, _dstRouteContentId) ? '_self' : '_blank'
                };
                const defaultNavigate = (url_0, { target: target })=>{
                    // We double check the url here in case parent product modify the `url` in `navigate` function and provided the hashed-only url to `defaultNavigate`
                    if ((0, $cb6fO.isHashedOnlyURL)(url_0)) {
                        open(url_0, '_self');
                        return;
                    }
                    const destRoute = matchSupportedRoute(url_0);
                    const willPushInSelf = this.willPushInSelf(_currRouteName, _currRouteContentId, destRoute?.name, destRoute?.params.contentId);
                    // When navigate to an url with anchor and destination is under the same route for same content,
                    // EP's default navigtation should simply follow browser's navigation instead of going to `defaultPush` and execute `history.push`.
                    // In this case, we use `open` (window.open) to load in the exisitng browsing context
                    if (willPushInSelf && Boolean(destRoute?.hash)) {
                        open(destRoute?.hash, '_self');
                        return;
                    }
                    if (target === '_self') defaultPush(url_0, forceReload);
                    else open(url_0, target);
                };
                /**
       * defaultNavigate can be invoked by the embedding product because it's the 3rd argument to
       * navigationPolicy's navigate. If embedding product tells EP to navigate to a URL in a new
       * tab, EP should not shim (rebase) it since the embedding product has already had a chance
       * and they chose not to. On the other hand, if the embedding product does not tell EP to
       * nagivate, EP can shim the url only when opening a new tab (some links might not have been
       * shimmed, need to shim all links supposed to be shimmed as the last defense).
       **/ return navigationPolicy?.navigate ? navigationPolicy?.navigate(url, modifiers, defaultNavigate) : defaultNavigate(modifiers.target === '_self' ? url : shimUrl(url), modifiers);
            },
            willPushInSelf (currRouteName, currRouteContentId, dstRouteName, dstRouteContentId) {
                const isEPRoute = !!$477c5af85d2d7fb0$var$toEPRouteName(dstRouteName);
                const isSameRoute = currRouteName === dstRouteName && currRouteContentId === dstRouteContentId;
                const shouldTransition = !!enableIframeSpaTransitions && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(currRouteName ?? '') && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(dstRouteName ?? '') && currRouteContentId === dstRouteContentId;
                return isEPRoute && (isSameRoute || shouldTransition);
            }
        }), [
        enableIframeSpaTransitions,
        navigationPolicy,
        shimUrl
    ]);
    return (0, $cozmU.useMemo)(()=>isEmbeddedConfluence ? getEmbeddedConfluenceRoutePolicy() : undefined, [
        isEmbeddedConfluence,
        getEmbeddedConfluenceRoutePolicy
    ]);
}
function $477c5af85d2d7fb0$var$toEPRouteName(routeName) {
    switch(routeName){
        case 'VIEW_PAGE':
        case 'EDIT_PAGE_EMBED':
            return routeName;
        default:
            return undefined;
    }
}
module.exports["useRoutePolicy"] = $477c5af85d2d7fb0$export$53e37724c6846f41;

});

parcelRegister("kBW0t", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $dOBRD = parcelRequire("dOBRD");


var $f8dGE = parcelRequire("f8dGE");


var $7nEuU = parcelRequire("7nEuU");

var $bnFzS = parcelRequire("bnFzS");


var $cb6fO = parcelRequire("cb6fO");

const $734ea8da77496ad5$var$isAdfContent = (content)=>{
    return content && typeof content === 'object' && content.type === 'doc' && Array.isArray(content.content);
};
function $734ea8da77496ad5$export$8ed0b067e5cd675d(navigationPolicy) {
    const $ = (0, $bDgLe.c)(17);
    const shimTemplate = navigationPolicy?.shimUrl;
    const domainNamesToReplace = navigationPolicy?.domainNamesToReplace;
    const spaceKeyFilter = navigationPolicy?.spaceKeyFilter;
    let t0;
    if ($[0] !== domainNamesToReplace || $[1] !== shimTemplate || $[2] !== spaceKeyFilter) {
        t0 = (urlToShim)=>$734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        $[0] = domainNamesToReplace;
        $[1] = shimTemplate;
        $[2] = spaceKeyFilter;
        $[3] = t0;
    } else t0 = $[3];
    const shimUrl = t0;
    let t1;
    if ($[4] !== domainNamesToReplace || $[5] !== shimTemplate || $[6] !== spaceKeyFilter) {
        t1 = (adf)=>{
            if (!shimTemplate || !adf || !Object.keys(adf).length) return adf;
            const adfClone = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(adf);
            $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfClone, shimTemplate, domainNamesToReplace, spaceKeyFilter);
            return adfClone;
        };
        $[4] = domainNamesToReplace;
        $[5] = shimTemplate;
        $[6] = spaceKeyFilter;
        $[7] = t1;
    } else t1 = $[7];
    const shimAdfUrls = t1;
    let t2;
    if ($[8] !== domainNamesToReplace || $[9] !== shimAdfUrls || $[10] !== shimTemplate || $[11] !== spaceKeyFilter) {
        t2 = (html)=>{
            if (!shimTemplate || !html) return html;
            try {
                const parsedContent = JSON.parse(html);
                if ($734ea8da77496ad5$var$isAdfContent(parsedContent)) {
                    if (html.includes("\"extensionKey\":\"nested-table\"")) {
                        const processedAdf = $734ea8da77496ad5$var$shimAdfWithNestedTables(parsedContent, shimAdfUrls);
                        return JSON.stringify(processedAdf);
                    } else {
                        const shimmedAdf = shimAdfUrls(parsedContent);
                        return JSON.stringify(shimmedAdf);
                    }
                }
            } catch  {}
            try {
                return $734ea8da77496ad5$var$shimDomUrls(new DOMParser().parseFromString(html, "text/html"), shimTemplate, domainNamesToReplace, spaceKeyFilter).body.innerHTML;
            } catch  {
                return html;
            }
        };
        $[8] = domainNamesToReplace;
        $[9] = shimAdfUrls;
        $[10] = shimTemplate;
        $[11] = spaceKeyFilter;
        $[12] = t2;
    } else t2 = $[12];
    const shimHtmlUrls = t2;
    let t3;
    if ($[13] !== shimAdfUrls || $[14] !== shimHtmlUrls || $[15] !== shimUrl) {
        t3 = {
            shimUrl: shimUrl,
            shimAdfUrls: shimAdfUrls,
            shimHtmlUrls: shimHtmlUrls
        };
        $[13] = shimAdfUrls;
        $[14] = shimHtmlUrls;
        $[15] = shimUrl;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
}
function $734ea8da77496ad5$var$shimDomUrls(dom, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    const anchors = dom.getElementsByTagName('a');
    Array.from(anchors).forEach((a)=>{
        a.href = $734ea8da77496ad5$var$shimThisUrl(a.href, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    const imgs = dom.getElementsByTagName('img');
    Array.from(imgs).forEach((img)=>{
        img.src = $734ea8da77496ad5$var$shimThisUrl(img.src, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    return dom;
}
function $734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    if (!shimTemplate || !urlToShim || (0, $cb6fO.isHashedOnlyURL)(urlToShim) || !$734ea8da77496ad5$var$isUrlForShimmedSpace(urlToShim, spaceKeyFilter)) return urlToShim;
    try {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const baseUrl = document.baseURI || window.location.toString();
        const absUrlWithDomainToShim = $734ea8da77496ad5$var$getAbsUrlWithDomain(urlToShim, baseUrl);
        const urlPrefixToShim = $734ea8da77496ad5$var$ccAbsUrlWithDomain(baseUrl);
        const urlShimTemplate = $734ea8da77496ad5$var$shimAbsUrlWithDomain(shimTemplate, baseUrl);
        return $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace);
    } catch  {
        return urlToShim;
    }
}
function $734ea8da77496ad5$var$isUrlForShimmedSpace(url, spaceKeyFilter) {
    // If no filter, shim all URLs (backwards compatibility)
    if (!spaceKeyFilter?.length) return true;
    // Regex to extract spaceKey from /spaces/<spaceKey>/
    const match = url.match(/\/spaces\/([^/]+)/);
    if (match) {
        // If URL contains /spaces/<spaceKey>, only shim if spaceKey is in the filter
        const spaceKey = match[1];
        return spaceKeyFilter.includes(spaceKey);
    }
    // For other /wiki URLs (e.g., share links), retain previous behavior and shim
    return true;
}
const $734ea8da77496ad5$var$ccAbsUrlWithDomain = (0, $dOBRD.default)((base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain((0, $cb6fO.CONTEXT_PATH), base)));
const $734ea8da77496ad5$var$shimAbsUrlWithDomain = (0, $dOBRD.default)((urlShimTemplate, base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain(urlShimTemplate, base)));
function $734ea8da77496ad5$var$getAbsUrlWithDomain(url, base) {
    return new URL(url, base).toString();
}
function $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace) {
    if (absUrlWithDomainToShim.includes((0, $cb6fO.CONTEXT_PATH))) {
        //We can only rebase or shim /wiki URLs
        const absUrlObj = new URL(absUrlWithDomainToShim);
        const baseUrlObj = new URL(baseUrl);
        //Check if the URL should be rebased
        if (domainNamesToReplace?.includes(absUrlObj.hostname)) {
            //Rebase the URL by replacing the origin string of absUrlWithDomainToShim with that of baseUrl
            const rebasedAbsUrlToShim = absUrlWithDomainToShim.replace(absUrlObj.origin, baseUrlObj.origin);
            //Shimming the rebased URL
            return rebasedAbsUrlToShim.replace(urlPrefixToShim, urlShimTemplate);
        }
    }
    return absUrlWithDomainToShim.replace(urlPrefixToShim, urlShimTemplate);
}
function $734ea8da77496ad5$var$appendSlash(url) {
    if (!url.endsWith('/')) return `${url}/`;
    return url;
}
const $734ea8da77496ad5$var$URL_ADF_KEYS = [
    'url',
    'href'
];
function $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfJson, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    Object.entries(adfJson).forEach(([key, value])=>{
        if (!value) return;
        if ($734ea8da77496ad5$var$URL_ADF_KEYS.includes(key) && typeof value === 'string') adfJson[key] = $734ea8da77496ad5$var$shimThisUrl(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        else if (typeof value === 'object') $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
}
/**
 * Shims URLs in ADF content that contains nested tables.
 * This function processes ADF document content with nested tables by:
 * 1. Transforming nested tables (incoming)
 * 2. Applying URL shimming via shimAdfUrls
 * 3. Transforming nested tables (outgoing)
 *
 * @param adfContent - Parsed ADF document content (already validated)
 * @param shimAdfUrls - Function to apply URL shimming to ADF objects
 * @returns Processed ADF object with shimmed URLs and transformed nested tables
 */ function $734ea8da77496ad5$var$shimAdfWithNestedTables(adfContent, shimAdfUrls) {
    // Process ADF document with nested tables - transform and delegate to shimAdfUrls
    const { transformedAdf: transformedAdf } = (0, $bnFzS.transformNestedTablesIncomingDocument)(adfContent);
    const shimmedAdf = shimAdfUrls(transformedAdf);
    return (0, $7nEuU.transformNestedTableNodeOutgoingDocument)(shimmedAdf);
}
module.exports["useShimUrl"] = $734ea8da77496ad5$export$8ed0b067e5cd675d;

});

parcelRegister("f8dGE", function(module, exports) {

var $hGc5T = parcelRequire("hGc5T");

/** Used to compose bitmasks for cloning. */ var $b042384c0682c153$var$CLONE_DEEP_FLAG = 1, $b042384c0682c153$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $b042384c0682c153$var$cloneDeep(value) {
    return $hGc5T(value, $b042384c0682c153$var$CLONE_DEEP_FLAG | $b042384c0682c153$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $b042384c0682c153$var$cloneDeep;

});

parcelRegister("aFbGo", function(module, exports) {
const $3fe527a88453b695$export$5dd7a635c52544a = ()=>window?.location?.search?.indexOf('lite=1') >= 0;
module.exports["isViewPageLite"] = $3fe527a88453b695$export$5dd7a635c52544a;

});

parcelRegister("5q601", function(module, exports) {
const $23ec6b91fddb9839$export$190611e0edbb22d5 = 'viewEditButtonClicked';
const $23ec6b91fddb9839$export$ed5bb54d3f9e4a8e = 'editButtonClickedToEditRouteChange';
const $23ec6b91fddb9839$export$caabe0b707a0bfac = 'editRouteChangeToPageLoad';
const $23ec6b91fddb9839$export$a5b3479b02282e8c = 'tinySynchronyPluginsLoad';
const $23ec6b91fddb9839$export$1787f4f7916eb601 = 'tinySynchronyContentFetch';
const $23ec6b91fddb9839$export$99c2e20685f1cd4e = 'editIntentToEditPageTTI';
const $23ec6b91fddb9839$export$e04cfb21f00b2ad0 = 'editIntentToEditPageFMP';
const $23ec6b91fddb9839$export$1d8f87e0ed24898e = 'editEmbeddedPageTTI';
const $23ec6b91fddb9839$export$16bdef2ba2fa4a5 = 'editEmbeddedPageFMP';
const $23ec6b91fddb9839$export$4d09a02f749e3cc2 = 'routeChangeToEditorTTI';
const $23ec6b91fddb9839$export$c2bda34fe2c26f89 = 'tinySynchronyContentMetadaPreload';
module.exports["VIEW_EDIT_BUTTON_CLICKED_ACTION"] = $23ec6b91fddb9839$export$190611e0edbb22d5;
module.exports["EDIT_ROUTE_CHANGE_ACTION"] = $23ec6b91fddb9839$export$ed5bb54d3f9e4a8e;
module.exports["EDIT_ROUTE_CHANGE_TO_FMP_ACTION"] = $23ec6b91fddb9839$export$caabe0b707a0bfac;
module.exports["TINY_SYNCHRONY_PLUGINS_LOAD_ACTION"] = $23ec6b91fddb9839$export$a5b3479b02282e8c;
module.exports["TINY_SYNCHRONY_CONTENT_FETCH_ACTION"] = $23ec6b91fddb9839$export$1787f4f7916eb601;
module.exports["EDIT_INTENT_EDIT_TTI_ACTION"] = $23ec6b91fddb9839$export$99c2e20685f1cd4e;
module.exports["EDIT_INTENT_EDIT_FMP_ACTION"] = $23ec6b91fddb9839$export$e04cfb21f00b2ad0;
module.exports["EMBEDDED_EDIT_TTI_ACTION"] = $23ec6b91fddb9839$export$1d8f87e0ed24898e;
module.exports["EMBEDDED_EDIT_FMP_ACTION"] = $23ec6b91fddb9839$export$16bdef2ba2fa4a5;
module.exports["EDIT_ROUTE_CHANGE_TO_TTI_ACTION"] = $23ec6b91fddb9839$export$4d09a02f749e3cc2;
module.exports["TINY_SYNCHRONY_CONTENT_METADATA_PRELOAD"] = $23ec6b91fddb9839$export$c2bda34fe2c26f89;

});

parcelRegister("lSOAM", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");


var $8RwKN = parcelRequire("8RwKN");


var $64KID = parcelRequire("64KID");


var $fQ3iN = parcelRequire("fQ3iN");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    (0, $64KID.namedRoutes).HOME.name,
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $8RwKN.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const $2a47a9fc48674e91$export$c5aa7fcaede4a84d = (0, $iDdTC.metrics).pageLoad;
const $2a47a9fc48674e91$export$19ba7be4fcf34f3d = (0, $iDdTC.metrics).custom;
const $2a47a9fc48674e91$export$36d7a61d0660e29c = (0, $iDdTC.metrics).interaction;
const $2a47a9fc48674e91$var$concurrent = (0, $iDdTC.metrics).concurrent;
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["createPageLoadMetric"] = $2a47a9fc48674e91$export$c5aa7fcaede4a84d;
module.exports["createCustomMetric"] = $2a47a9fc48674e91$export$19ba7be4fcf34f3d;
module.exports["createInteractionMetric"] = $2a47a9fc48674e91$export$36d7a61d0660e29c;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("iDdTC", function(module, exports) {

var $9aI7t = parcelRequire("9aI7t");


var $b5593 = parcelRequire("b5593");


var $b90aI = parcelRequire("b90aI");


var $1Ht4b = parcelRequire("1Ht4b");


var $aaEQD = parcelRequire("aaEQD");

const $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54 = {
    pageLoad: $1Ht4b.pageLoad,
    pageSegmentLoad: $aaEQD.pageSegmentLoad,
    interaction: $b90aI.interaction,
    custom: $b5593.custom,
    concurrent: $9aI7t.concurrent
};
module.exports["metrics"] = $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54;

});

parcelRegister("9aI7t", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $b5593 = parcelRequire("b5593");


var $b90aI = parcelRequire("b90aI");

const $95763ae236d73d99$var$concurrentMetrics = {};
const $95763ae236d73d99$var$getKey = (config, type)=>`${type}--${config.key}`;
const $95763ae236d73d99$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $95763ae236d73d99$var$ensurePath = (config, type)=>{
    const key = $95763ae236d73d99$var$getKey(config, type);
    if (!(key in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[key] = {};
};
const $95763ae236d73d99$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $95763ae236d73d99$var$getKey(config, type);
    if (concurrentKey in $95763ae236d73d99$var$concurrentMetrics && $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $95763ae236d73d99$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $95763ae236d73d99$var$validateConfig(config);
    $95763ae236d73d99$var$ensurePath(config, type);
    const metricFromCache = $95763ae236d73d99$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $lCTbz.BMEventsType).INLINE_RESULT ? (0, $b90aI.interaction) : (0, $b5593.custom);
    const metric = metricFactory(config);
    $95763ae236d73d99$var$concurrentMetrics[$95763ae236d73d99$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $95763ae236d73d99$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).CUSTOM)
};
module.exports["concurrent"] = $95763ae236d73d99$export$370df09ecc3de059;

});

parcelRegister("b5593", function(module, exports) {

var $ipFlS = parcelRequire("ipFlS");


var $lCTbz = parcelRequire("lCTbz");

const $39f57926a8ef795b$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).CUSTOM
    });
};
module.exports["custom"] = $39f57926a8ef795b$export$4c00f665f0d4b443;

});

parcelRegister("ipFlS", function(module, exports) {

var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $7IphZ = parcelRequire("7IphZ");

class $4db3d4178d03c3ea$export$efdd3e096bc27746 extends (0, $7IphZ.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $hvVQt.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $581yf.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}
module.exports["Metric"] = $4db3d4178d03c3ea$export$efdd3e096bc27746;

});

parcelRegister("b90aI", function(module, exports) {

var $ipFlS = parcelRequire("ipFlS");


var $lCTbz = parcelRequire("lCTbz");

const $060787d14b6a30d6$export$92473e6020ad89b4 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).INLINE_RESULT
    });
};
module.exports["interaction"] = $060787d14b6a30d6$export$92473e6020ad89b4;

});

parcelRegister("1Ht4b", function(module, exports) {

var $3L5Pu = parcelRequire("3L5Pu");


var $lCTbz = parcelRequire("lCTbz");

const $a55ff36d094d83ef$export$791d520f7e8058a5 = (config)=>{
    return new (0, $3L5Pu.PageLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_LOAD
    });
};
module.exports["pageLoad"] = $a55ff36d094d83ef$export$791d520f7e8058a5;

});

parcelRegister("3L5Pu", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $jk8rA = parcelRequire("jk8rA");


var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $lCTbz = parcelRequire("lCTbz");


var $2QFOI = parcelRequire("2QFOI");


var $wgCbG = parcelRequire("wgCbG");


var $eNslE = parcelRequire("eNslE");

class $bbca0ae0eaeecc15$export$3c51073271a9eac3 extends (0, $2QFOI.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $wgCbG.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $wgCbG.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $wgCbG.pageLoadMetaMetric).markFMP(mark);
            } else (0, $wgCbG.pageLoadMetaMetric).markFMP(this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $hvVQt.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $581yf.submitter).queue(data);
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $wgCbG.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $wgCbG.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $581yf.submitter).config.configChunk;
        if (!configChunk?.[(0, $lCTbz.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $eNslE.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $581yf.submitter).queue(webVitalMetric.getData());
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}
module.exports["PageLoadMetric"] = $bbca0ae0eaeecc15$export$3c51073271a9eac3;

});

parcelRegister("eNslE", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");

class $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7 extends (0, $7IphZ.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $lCTbz.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $7IphZ.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}
module.exports["WebVitalsMetric"] = $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7;

});

parcelRegister("aaEQD", function(module, exports) {

var $h51B5 = parcelRequire("h51B5");


var $lCTbz = parcelRequire("lCTbz");

const $2eb5124fdb2b6158$export$94114666844d5f66 = (config)=>{
    return new (0, $h51B5.PageSegmentLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
module.exports["pageSegmentLoad"] = $2eb5124fdb2b6158$export$94114666844d5f66;

});

parcelRegister("h51B5", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");


var $ipFlS = parcelRequire("ipFlS");


var $wgCbG = parcelRequire("wgCbG");

class $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1 extends (0, $ipFlS.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $lCTbz.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $7IphZ.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $7IphZ.MetricState).STARTED) (0, $wgCbG.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP = 'fmp';
module.exports["PageSegmentLoadMetric"] = $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1;

});

parcelRegister("fQ3iN", function(module, exports) {
/**
 * BM3 Deprecation Phase 2 — gated wrapper around the raw BM3 page-segment-load factory.
 *
 * This file is the canonical implementation behind the public name
 * `createPageSegmentLoadMetric` (re-exported from
 * `@confluence/browser-metrics/entry-points/metricConfigs.ts`). All Confluence consumers
 * call the gated variant by virtue of importing the public name; there is no separate
 * "raw" public entry point.
 *
 * When the `cc_bm3_deprecation_phase_2` gate is OFF (default), every method call delegates
 * verbatim to the underlying BM3 PageSegmentLoadMetric so existing behaviour and the BM3
 * `PAGE_SEGMENT_LOAD` analytics events are preserved.
 *
 * When the gate is ON, the BM3 calls are skipped and equivalent UFO custom marks / custom
 * data are emitted instead. This lets us roll out the removal of the BM3 page-segment-load
 * events incrementally — controlled by Statsig — without touching any of the ~25
 * perf.config files or ~20 imperative call sites. Consumers continue to use
 * `METRIC.start()`, `.stop()`, `.cancel()`, `.mark()`, `.markFMP()`,
 * `.startFromPageLoad()` exactly as before; the gate decision is centralised here.
 *
 * The gate `fg(...)` is evaluated **inline at the callsite of each method**, never aliased
 * or wrapped, in line with the feature-gate-and-experiment-usage AGENTS guidance. Per-method
 * (rather than per-construction) evaluation is required because perf.config modules are
 * imported very early in app boot — earlier than Statsig data is loaded — so a one-shot
 * `fg()` call at construction time would always read the default (false) value.
 *
 * Implementation note: rather than returning a *new* wrapper object, this helper mutates
 * the real BM3 metric instance by overriding selected methods with bound functions that
 * consult the gate. This preserves the metric's class identity, prototype chain, and
 * private internal state so it remains a fully drop-in substitute everywhere a BM3
 * PageSegmentLoadMetric is used (including in `pageLoadMetric.include[]` / `until[]`
 * arrays where BM3 walks the internal experience graph).
 *
 * Once the gate has fully ramped, this file's body will be replaced with a UFO-only
 * implementation and the BM3 dependency removed entirely.
 */ 
var $gXfti = parcelRequire("gXfti");


var $knAY5 = parcelRequire("knAY5");


var $9wGTI = parcelRequire("9wGTI");


var $3YpC9 = parcelRequire("3YpC9");


var $kw6I9 = parcelRequire("kw6I9");

function $a96d58ddd476e3f0$export$34f706592a2f7442(config) {
    const metric = (0, $kw6I9.createBM3PageSegmentLoadMetricRaw)(config);
    const key = config.key;
    // Capture the original methods before overriding them.
    const realStart = metric.start.bind(metric);
    const realStartFromPageLoad = metric.startFromPageLoad.bind(metric);
    const realStop = metric.stop.bind(metric);
    const realCancel = metric.cancel.bind(metric);
    const realMark = metric.mark.bind(metric);
    const realMarkFMP = metric.markFMP.bind(metric);
    metric.start = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStart(...args);
    };
    metric.startFromPageLoad = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStartFromPageLoad(...args);
    };
    metric.stop = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            const opts = args[0];
            if (opts?.customData) (0, $gXfti.addUFOCustomData)(opts.customData);
            return true;
        }
        return realStop(...args);
    };
    metric.cancel = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            // Note - there's no equivalent for cancel in UFO, so we use the end mark instead.
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            return;
        }
        return realCancel(...args);
    };
    metric.mark = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [name, timestamp] = args;
            (0, $knAY5.addUFOCustomMark)(name, timestamp);
            return;
        }
        return realMark(...args);
    };
    metric.markFMP = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [timestamp] = args;
            (0, $knAY5.addUFOCustomMark)(`fmp:${key}`, timestamp);
            return;
        }
        return realMarkFMP(...args);
    };
    return metric;
}
module.exports["createPageSegmentLoadMetric"] = $a96d58ddd476e3f0$export$34f706592a2f7442;

});

parcelRegister("3YpC9", function(module, exports) {
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';
module.exports["PAGE_SEGMENT_MARK_PREFIX_START"] = $4dbe182ee19642b3$export$f59b3ea823fcdb3d;
module.exports["PAGE_SEGMENT_MARK_PREFIX_END"] = $4dbe182ee19642b3$export$a217b163593f51a;

});

parcelRegister("kw6I9", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");

const $864083edfead32eb$export$2a2fe1e11b4e0413 = (0, $iDdTC.metrics).pageSegmentLoad;
module.exports["createBM3PageSegmentLoadMetricRaw"] = $864083edfead32eb$export$2a2fe1e11b4e0413;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("fd6g2", function(module, exports) {
// "confluence.fe.custom.XXX"
const $88f9a74d7687653d$export$3fe4a04f712fdf3b = 'mentions-query';
const $88f9a74d7687653d$export$18a3d3c084ff47d0 = 'profile-card-query';
const $88f9a74d7687653d$export$95463e4d15a0dca9 = 'legacy-extension-loading';
const $88f9a74d7687653d$export$5a66bfdc2ac06329 = 'fabric-publish-page';
const $88f9a74d7687653d$export$96dfe3e664538004 = 'time-to-app-idle';
const $88f9a74d7687653d$export$18a3e97ff841447b = 'share-notif-from-restrictions';
const $88f9a74d7687653d$export$d0eb1faf5fa0dbc7 = 'tc-events-fetch';
const $88f9a74d7687653d$export$ec119fee4dbc7f75 = 'tc-subcals-fetch';
const $88f9a74d7687653d$export$693c7d831f137ed3 = 'tc-jira-projects-fetch';
module.exports["MENTIONS_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$3fe4a04f712fdf3b;
module.exports["PROFILE_CARD_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$18a3d3c084ff47d0;
module.exports["LEGACY_EXTENSION_LOADING_CUSTOM_KEY"] = $88f9a74d7687653d$export$95463e4d15a0dca9;
module.exports["FABRIC_PUBLISH_PAGE_KEY"] = $88f9a74d7687653d$export$5a66bfdc2ac06329;
module.exports["TIME_TO_APP_IDLE_KEY"] = $88f9a74d7687653d$export$96dfe3e664538004;
module.exports["TEAM_CALENDARS_EVENT_FETCH_KEY"] = $88f9a74d7687653d$export$d0eb1faf5fa0dbc7;
module.exports["TEAM_CALENDARS_SUBCALS_FETCH_KEY"] = $88f9a74d7687653d$export$ec119fee4dbc7f75;
module.exports["TEAM_CALENDARS_JIRA_PROJECTS_FETCH_KEY"] = $88f9a74d7687653d$export$693c7d831f137ed3;

});

parcelRegister("loJVf", function(module, exports) {

let $f93f7617efe317e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f93f7617efe317e8$var$load("aWPe2").then(()=>parcelRequire('bDxwy'));

});

parcelRegister("8Ss4E", function(module, exports) {

var $3AVOh = parcelRequire("3AVOh");


var $kyKWe = parcelRequire("kyKWe");


var $34MZN = parcelRequire("34MZN");


var $eYg5X = parcelRequire("eYg5X");


var $lTECB = parcelRequire("lTECB");


var $hukUK = parcelRequire("hukUK");


var $9wGTI = parcelRequire("9wGTI");


var $c3Qwv = parcelRequire("c3Qwv");


var $1NBp8 = parcelRequire("1NBp8");


var $cEgMD = parcelRequire("cEgMD");


var $irVI7 = parcelRequire("irVI7");


var $gykrH = parcelRequire("gykrH");


var $aJPUt = parcelRequire("aJPUt");


var $fGzMp = parcelRequire("fGzMp");


var $1A7bE = parcelRequire("1A7bE");


var $7v9li = parcelRequire("7v9li");


var $949zl = parcelRequire("949zl");


var $h10mo = parcelRequire("h10mo");

const $8c50530bac3b9ba1$var$noPermissionOrNotFoundExperiences = [
    (0, $irVI7.NOT_FOUND_EXPERIENCE),
    (0, $irVI7.RESTRICTED_PAGE_EXPERIENCE),
    (0, $irVI7.RESTRICTED_SPACE_EXPERIENCE),
    (0, $irVI7.RESTRICTED_SPACE_FOR_GUEST_EXPERIENCE)
];
const $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound = (0, $1A7bE.collectAny)($8c50530bac3b9ba1$var$noPermissionOrNotFoundExperiences);
const $8c50530bac3b9ba1$var$stopOnConnectAddon = (0, $1A7bE.collectAny)([
    (0, $irVI7.CONNECT_ADDON_EXPERIENCE)
]);
/**
 * Stores the new experiences started due to SPA transition
 */ const $8c50530bac3b9ba1$var$namesStartedInPreviousRoute = [];
/**
 *  Specifies routes that signify completion for each experience.
 *  Used with experienceTracker's collect function to monitor progress of experiences.
 *  For example, 'create page' experience is considered complete when it leads to 'edit page'.
 */ const $8c50530bac3b9ba1$var$redirectRoutesForExperiences = {
    [(0, $irVI7.CREATE_PAGE_EXPERIENCE)]: [
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name,
        (0, $1NBp8.VIEW_PAGE).name // CREATE_PAGE_EXPERIENCE -> VIEW_PAGE means a live page was created
    ],
    // Same redirect routes as CREATE_PAGE_EXPERIENCE — the link-creation flow also succeeds when it leads to edit-page (a page was created from an Undefined Link).
    [(0, $irVI7.CREATE_PAGE_FROM_LINK_CREATION_EXPERIENCE)]: [
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name,
        (0, $1NBp8.VIEW_PAGE).name
    ],
    [(0, $irVI7.CREATE_WHITEBOARD_EXPERIENCE)]: [
        (0, $1NBp8.WHITEBOARD_BOARD).name
    ],
    [(0, $irVI7.CREATE_SLIDE_EXPERIENCE)]: [
        (0, $1NBp8.SLIDES_VIEW).name
    ],
    [(0, $irVI7.CREATE_DATABASE_EXPERIENCE)]: [
        (0, $1NBp8.DATABASE_VIEW).name
    ],
    [(0, $irVI7.CREATE_EMBED_EXPERIENCE)]: [
        (0, $1NBp8.EMBED_VIEW).name
    ]
};
const $8c50530bac3b9ba1$var$EXPERIENCES_TO_ABORT_ON_ROUTE_CHANGE = [
    (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE)
];
const $8c50530bac3b9ba1$export$4b786e0ae0cc0857 = {
    [(0, $1NBp8.SPACE_OVERVIEW).name]: 'space',
    [(0, $1NBp8.COMPANY_HUB).name]: 'space',
    [(0, $1NBp8.EDIT_PAGE_EMBED).name]: 'page',
    [(0, $1NBp8.EDIT_PAGE_V2).name]: 'page',
    [(0, $1NBp8.EDIT_BLOG_V2).name]: 'blog',
    [(0, $1NBp8.VIEW_PAGE).name]: 'page',
    [(0, $1NBp8.VIEW_BLOG).name]: 'blog',
    [(0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name]: 'blog'
};
const $8c50530bac3b9ba1$export$5396770e9da36673 = (routeName)=>{
    switch(routeName){
        case (0, $1NBp8.EDIT_BLOG).name:
        case (0, $1NBp8.EDIT_PAGE).name:
        case (0, $1NBp8.CREATE_PAGE).name:
            return 'TINY';
        default:
            return 'FABRIC';
    }
};
function $8c50530bac3b9ba1$export$cac1117e2433d80e(match, transitionId, sessionData) {
    if (!match) return;
    const tracker = (0, $fGzMp.getExperienceTracker)();
    // Moves current route data to previous route data to ensure `getExperienceTracker.ts getPreviousRouteExperienceData()` works correctly
    (0, $fGzMp.captureRouteChange)(match.name);
    // Live page's edit-page and session experience starts after the route has finished loading and unsubscribed from the tracker, so it's not in the `startExperienceForRoute` function's namesStartedInPreviousRoute array. We will handle finishing it separately in `finishLivePageExperiences`.
    // It's important that `finishLivePageExperiences` is invoked before we attempt to succeed EDIT_PAGE_EXPERIENCE below, as `finishLivePageExperiences` is responsible for succeeding EDIT_PAGE_EXPERIENCE on live pages while setting the experience attribute `isLivePage
    $8c50530bac3b9ba1$var$finishLivePageExperiences();
    $8c50530bac3b9ba1$var$namesStartedInPreviousRoute.forEach((name)=>{
        const allowedRoutes = $8c50530bac3b9ba1$var$redirectRoutesForExperiences[name];
        // For create content routes, we do not want to abort if it is routing to correct page.
        // But, if it is a create experience and routing to a page is is not supposed to be going to,
        // we can assume something is wrong and we abort it.
        if (allowedRoutes && allowedRoutes.includes(match.name)) return;
        if (// If we were on edit-page or view-page/session experience and leave to another route, we should succeed that experience, not abort it.
        name === (0, $irVI7.EDIT_PAGE_EXPERIENCE) && (0, $7v9li.hasHealthyRunningEditPageExperience)() || name === (0, $irVI7.COMPANY_HUB_EDITOR_EXPERIENCE) && (0, $7v9li.hasHealthyRunningCompanyHubEditExperience)() || name === (0, $irVI7.VIEW_PAGE_SESSION_EXPERIENCE) && (0, $949zl.hasHealthyRunningViewPageExperience)()) {
            tracker.succeed({
                name: name
            });
            return;
        }
        // For all other situations, we still abort.
        tracker.abort({
            name: name,
            reason: 'Aborted due to SPA started a new experience'
        });
    });
    $8c50530bac3b9ba1$var$namesStartedInPreviousRoute.length = 0;
    const unsubscribe = tracker.subscribe((e)=>{
        if (e.action === 'taskStart') $8c50530bac3b9ba1$var$namesStartedInPreviousRoute.push(e.name);
    });
    $8c50530bac3b9ba1$var$EXPERIENCES_TO_ABORT_ON_ROUTE_CHANGE.forEach((name)=>{
        $8c50530bac3b9ba1$var$namesStartedInPreviousRoute.push(name);
    });
    switch(match.name){
        case (0, $1NBp8.COMPANY_HUB_EDIT).name:
            $8c50530bac3b9ba1$var$startCompanyHubEditor(transitionId, sessionData);
            break;
        case (0, $1NBp8.EDIT_PAGE_EMBED).name:
        case (0, $1NBp8.EDIT_PAGE_V2).name:
        case (0, $1NBp8.EDIT_BLOG_V2).name:
        case (0, $1NBp8.EDIT_PAGE).name:
        case (0, $1NBp8.EDIT_BLOG).name:
        case (0, $1NBp8.CREATE_PAGE).name:
        case (0, $1NBp8.HUB_EDIT).name:
            $8c50530bac3b9ba1$var$startEditPage(match, transitionId, sessionData);
            break;
        case (0, $1NBp8.VIEW_PAGE).name:
        case (0, $1NBp8.VIEW_BLOG).name:
        case (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name:
            $8c50530bac3b9ba1$var$startViewContent(match.params.contentId, transitionId, $8c50530bac3b9ba1$export$4b786e0ae0cc0857[match.name], match.query, sessionData);
            break;
        case (0, $1NBp8.PAGE_SPLIT).name:
            $8c50530bac3b9ba1$var$startSplitPageLoad(match.params.contentId, transitionId);
            break;
        case (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name:
            $8c50530bac3b9ba1$var$startEditPageSmartCreate(match);
            break;
        case (0, $1NBp8.ADMIN_NEW_GLOBAL_PERMISSIONS).name:
            $8c50530bac3b9ba1$var$startViewPublicLinkGlobalSettings(match.query.tab, match.query.space, transitionId);
            break;
        case (0, $1NBp8.EXTERNAL_SHARE).name:
            $8c50530bac3b9ba1$var$startViewPublicLinkSharedPage(match.params.id, transitionId);
            break;
        case (0, $1NBp8.SPACE_OVERVIEW).name:
            $8c50530bac3b9ba1$var$startViewContent(match.params.spaceKey, transitionId, $8c50530bac3b9ba1$export$4b786e0ae0cc0857[match.name], match.query, sessionData, {
                spaceKey: match.params.spaceKey,
                isLandingPage: match.search === '?mode=global'
            });
            break;
        case (0, $1NBp8.COMPANY_HUB).name:
            const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)(sessionData) || '';
            $8c50530bac3b9ba1$var$startViewContent(spaceKey, transitionId, $8c50530bac3b9ba1$export$4b786e0ae0cc0857[match.name], match.query, sessionData, {
                spaceKey: spaceKey
            });
            break;
        case (0, $1NBp8.HOME).name:
            (0, $h10mo.startHome)();
            break;
        case (0, $1NBp8.EDIT_TEMPLATE_SPACE).name:
        case (0, $1NBp8.EDIT_TEMPLATE).name:
            $8c50530bac3b9ba1$var$startTemplateEditPage(match.params.contentId, transitionId);
            break;
        case (0, $1NBp8.CREATE_TEMPLATE_SPACE).name:
        case (0, $1NBp8.CREATE_TEMPLATE).name:
            $8c50530bac3b9ba1$var$startTemplateEditPage(/* id */ undefined, transitionId);
            break;
        case (0, $1NBp8.ADVANCED_SEARCH).name:
            $8c50530bac3b9ba1$var$startAdvancedSearch(match);
            break;
        case (0, $1NBp8.SPACE_ARCHIVED_PAGES).name:
            $8c50530bac3b9ba1$var$startArchivedPagesList();
            break;
        case (0, $1NBp8.SPACE_BULK_TOOLS).name:
            $8c50530bac3b9ba1$var$startContentManager();
            break;
        case (0, $1NBp8.SPACE_DIRECTORY).name:
            $8c50530bac3b9ba1$var$startSpaceDirectory();
            break;
        case (0, $1NBp8.TEMPLATE_GALLERY).name:
            $8c50530bac3b9ba1$var$startTemplateGallery();
            break;
        case (0, $1NBp8.SPACE_PAGES).name:
            $8c50530bac3b9ba1$var$startSpacePages();
            break;
        case (0, $1NBp8.WHITEBOARD_BOARD).name:
            $8c50530bac3b9ba1$var$startWhiteboardBoard(match);
            break;
        case (0, $1NBp8.SLIDES_VIEW).name:
            $8c50530bac3b9ba1$var$startSlideView(match.params.contentId);
            break;
        case (0, $1NBp8.DATABASE_VIEW).name:
            $8c50530bac3b9ba1$var$startDatabaseView(match.params.contentId);
            break;
        case (0, $1NBp8.EMBED_VIEW).name:
            $8c50530bac3b9ba1$var$startEmbedPageView(match.params.contentId);
            break;
        case (0, $1NBp8.FOLDER_VIEW).name:
            $8c50530bac3b9ba1$var$startFolderView(match.params.contentId);
            break;
        case (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).name:
            //Adding the other space perms uplift tabs at a later date.
            if (match.params.tab === 'public-links') $8c50530bac3b9ba1$var$startViewPublicLinksSpaceSettings();
            break;
        case (0, $1NBp8.ADMIN_ANNOUNCEMENT_BANNER_RENDERER).name:
            $8c50530bac3b9ba1$var$startViewAdminAnnouncementBannerSettings();
            break;
        case (0, $1NBp8.SPACE_MANAGER).name:
            $8c50530bac3b9ba1$var$startSpaceManager();
            break;
        case (0, $1NBp8.ADMIN_COMPANY_HOME_BUILDER).name:
        case (0, $1NBp8.ADMIN_CUSTOMIZE_NAVIGATION).name:
            $8c50530bac3b9ba1$var$startCompanyHomeBuilderLoad();
            break;
    }
    const startCreateOperations = ()=>{
        const subType = typeof match?.query?.subType === 'string' ? match.query.subType : null;
        if (match.name === (0, $1NBp8.CREATE_CONTENT).name) $8c50530bac3b9ba1$var$startCreateContent(match, sessionData, subType);
        else if (match.query.createDialog) {
            $8c50530bac3b9ba1$var$startCreatePage(String(transitionId), transitionId, subType);
            (0, $7v9li.startCreateAndEditPage)();
        }
    };
    startCreateOperations();
    unsubscribe();
}
function $8c50530bac3b9ba1$var$startSplitPageLoad(contentId, transitionId) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPLIT_PAGE_LOAD_EXPERIENCE),
        id: contentId,
        startTime: transitionId === 0 ? 0 : undefined
    });
}
function $8c50530bac3b9ba1$var$startCreatePage(id, transitionId, subType) {
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    experienceTracker.start({
        name: (0, $irVI7.CREATE_PAGE_EXPERIENCE),
        id: id,
        attributes: {
            isLivePage: subType?.toLowerCase() === 'live'
        },
        startTime: transitionId === 0 ? 0 : undefined,
        collect (events, experience) {
            experience.stopOn(events.find((event)=>event.action === 'taskFail' && (0, $gykrH.hasName)(event, (0, $irVI7.CREATE_PAGE_LOAD_DIALOG_EXPERIENCE), (0, $irVI7.CREATE_PAGE_TEMPLATE_VARIABLES_EXPERIENCE))));
            experience.stopOn(events.find((event)=>event.action === 'taskSuccess' && (0, $gykrH.hasName)(event, (0, $irVI7.CREATE_PAGE_TEMPLATE_VARIABLES_EXPERIENCE))));
            experience.stopOn(events.find((event)=>event.action === 'taskAbort' && (0, $gykrH.hasName)(event, (0, $irVI7.CREATE_PAGE_TEMPLATE_VARIABLES_EXPERIENCE))));
        }
    });
    experienceTracker.start({
        name: (0, $irVI7.CREATE_PAGE_LOAD_DIALOG_EXPERIENCE),
        id: id,
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_DIALOG_LOAD
    });
}
function $8c50530bac3b9ba1$export$b9a409823a06b924(experienceName) {
    const activeTrace = (0, $34MZN.getActiveTrace)();
    if (!activeTrace) (0, $eYg5X.default)(experienceName.replace(/\//g, '-'));
}
function $8c50530bac3b9ba1$export$478e84e2cc5ff22d(compoundExperience, editorLoadExperience, editorPublishExperience) {
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    const compoundTaskId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    const compoundExperienceAttributes = {
        ...compoundExperience.attributes,
        compoundTaskId: compoundTaskId
    };
    experienceTracker.start({
        ...compoundExperience,
        id: compoundTaskId,
        attributes: compoundExperienceAttributes,
        collect: (events, experience)=>{
            experience.stopOn(events.find(({ action: action, name: name })=>action === 'taskFail' && name === editorLoadExperience.name));
            experience.stopOn(events.find(({ action: action, name: name })=>(action === 'taskSuccess' || action === 'taskFail') && name === editorPublishExperience.name));
            if (compoundExperience.collect) compoundExperience.collect(events, experience);
        }
    });
    experienceTracker.start({
        ...editorLoadExperience,
        id: editorLoadExperience.id || compoundExperience.id,
        timeout: editorLoadExperience.timeout || (0, $aJPUt.ExperienceTimeout).EDITOR_LOAD,
        attributes: compoundExperienceAttributes,
        collect: editorLoadExperience.collect
    });
}
function $8c50530bac3b9ba1$export$7df6656d8508e8da(subExperience) {
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    // Initialize attributes from the original subExperience
    const attributes = {
        ...subExperience.attributes
    };
    // Extract the compound experience name from the sub-experience name if it follows
    // the naming convention "<compound_experience_name>/<sub_experience>"
    const subExperienceName = subExperience.name;
    const nameParts = subExperienceName.split('/');
    // Only attempt to get compound experience if the name includes a separator
    if (nameParts.length > 1) {
        const compoundExperienceName = nameParts[0];
        const compoundExperienceState = experienceTracker.getExperienceState(compoundExperienceName);
        // If compound experience exists, inherit its compoundTaskId
        if (compoundExperienceState) // Link the compound experience's compoundTaskId if available
        {
            if (compoundExperienceState.attributes?.compoundTaskId) attributes.compoundTaskId = compoundExperienceState.attributes.compoundTaskId;
        }
    }
    // Start the sub-experience with the attributes (original or enhanced with compoundTaskId)
    experienceTracker.start({
        ...subExperience,
        attributes: attributes
    });
}
const $8c50530bac3b9ba1$var$stopOnCloseForEditPage = (events, experience, loadExperienceName, closeExperienceName)=>{
    const loadStopExperience = events.find((event)=>event.name === loadExperienceName && (0, $gykrH.isStop)(event));
    const closeStopExperience = events.find((event)=>event.name === closeExperienceName && (0, $gykrH.isStop)(event));
    if (!closeStopExperience) return;
    // prettier-ignore
    if ((!loadStopExperience || loadStopExperience.action !== "taskSuccess") && closeStopExperience.action === "taskSuccess") // loading incomplete or failed, therefore editing session was broken and close doesn't indicate a success
    experience.abort({
        reason: "Editor closed before load completed",
        attributes: {
            loadExperienceState: loadStopExperience?.action ?? "incomplete"
        }
    });
    else experience.stopOn(closeStopExperience);
};
function $8c50530bac3b9ba1$var$startEditPageSmartCreate(match) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.EDIT_PAGE_SMART_CREATE_LOAD_EXPERIENCE),
        id: match.params.contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT,
        collect: (events, experience)=>{
            const hasNoPermissionOrNotFoundEvent = events.find((event)=>(0, $gykrH.isStop)(event) && (0, $gykrH.hasName)(event, ...$8c50530bac3b9ba1$var$noPermissionOrNotFoundExperiences));
            if (hasNoPermissionOrNotFoundEvent) experience.fail({
                error: new Error(`${hasNoPermissionOrNotFoundEvent.name} experience resulted in ${hasNoPermissionOrNotFoundEvent.action} - unexpected for the smart create editor`)
            });
        }
    });
}
function $8c50530bac3b9ba1$var$startEditPage(match, transitionId, sessionData) {
    const isLegacyEditor = $8c50530bac3b9ba1$export$5396770e9da36673(match?.name ?? '') === 'TINY';
    let editPageExperienceName = (0, $irVI7.EDIT_PAGE_EXPERIENCE);
    if (match.name === (0, $1NBp8.EDIT_PAGE_EMBED).name) editPageExperienceName = (0, $irVI7.EDIT_PAGE_EMBED_EXPERIENCE);
    else if (isLegacyEditor) editPageExperienceName = (0, $irVI7.EDIT_LEGACY_PAGE_EXPERIENCE);
    $8c50530bac3b9ba1$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: editPageExperienceName,
        id: match.params.contentId,
        startTime: transitionId === 0 ? 0 : undefined,
        attributes: {
            editor: $8c50530bac3b9ba1$export$5396770e9da36673(match.name),
            contentType: $8c50530bac3b9ba1$export$4b786e0ae0cc0857[match.name],
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            isCompanyHub: match?.name === (0, $1NBp8.COMPANY_HUB_EDIT).name || match?.name === (0, $1NBp8.HUB_EDIT).name,
            contentId: match.params.contentId,
            isGuest: sessionData?.accessStatus === 'EXTERNAL_COLLABORATOR_ACCESS'
        },
        // override with full-page-editor specific stop/collect behaviour
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
            const loadExperienceName = isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_LOAD_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE);
            const closeExperienceName = isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_CLOSE_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_CLOSE_EXPERIENCE);
            $8c50530bac3b9ba1$var$stopOnCloseForEditPage(events, experience, loadExperienceName, closeExperienceName);
        }
    }, /* editorLoadExperience */ {
        name: isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_LOAD_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE),
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
            const closeExperienceName = isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_CLOSE_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_CLOSE_EXPERIENCE);
            const closeExperience = events.find((event)=>(0, $gykrH.isStop)(event) && event.name === closeExperienceName);
            if (closeExperience) experience.abort({
                reason: 'Editor closed before load completed',
                attributes: {
                    closeExperienceState: closeExperience?.action ?? 'incomplete'
                }
            });
        }
    }, /* editorPublishExperience */ {
        name: isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_PUBLISH_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_PUBLISH_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startCompanyHubEditor(transitionId, sessionData) {
    $8c50530bac3b9ba1$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: (0, $irVI7.COMPANY_HUB_EDITOR_EXPERIENCE),
        startTime: transitionId === 0 ? 0 : undefined,
        attributes: {
            editor: 'FABRIC',
            contentType: 'space',
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            isCompanyHub: true
        },
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
            $8c50530bac3b9ba1$var$stopOnCloseForEditPage(events, experience, (0, $irVI7.COMPANY_HUB_EDITOR_LOAD_EXPERIENCE), (0, $irVI7.COMPANY_HUB_EDITOR_CLOSE_EXPERIENCE));
        }
    }, /* editorLoadExperience */ {
        name: (0, $irVI7.COMPANY_HUB_EDITOR_LOAD_EXPERIENCE),
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
        }
    }, /* editorPublishExperience */ {
        name: (0, $irVI7.FRONT_COVER_PUBLISH_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startViewContent(id, transitionId, contentType, query, sessionData, attributes) {
    // WS-3261 - We need to track if the view is coming from an external source (email notification, Slack, etc.)
    const isFromExternal = Boolean(query && query.atlOrigin);
    // Track APDEX part of the content (title and content itself)
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.VIEW_CONTENT_EXPERIENCE),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD,
        attributes: {
            contentType: contentType,
            isFromExternal: isFromExternal,
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            ...attributes
        },
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
            $8c50530bac3b9ba1$var$stopOnConnectAddon(events, experience);
        }
    });
}
function $8c50530bac3b9ba1$var$startViewPublicLinkGlobalSettings(tab, space, transitionId) {
    if (tab === 'public-links' && !space) (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.VIEW_PUBLIC_LINK_SITE_SETTINGS_EXPERIENCE),
        id: 'public-links',
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD
    });
}
function $8c50530bac3b9ba1$var$startViewPublicLinksSpaceSettings() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.VIEW_PUBLIC_LINKS_SPACE_SETTINGS_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD
    });
}
function $8c50530bac3b9ba1$var$startViewPublicLinkSharedPage(id, transitionId) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.VIEW_PUBLIC_LINK_SHARED_PAGE_EXPERIENCE),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD
    });
}
function $8c50530bac3b9ba1$var$startTemplateEditPage(id, transitionId) {
    $8c50530bac3b9ba1$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: (0, $irVI7.TEMPLATE_EDIT_PAGE_EXPERIENCE),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        collect: (events, experience)=>{
            experience.stopOn(events.find((event)=>(0, $gykrH.isStop)(event) && event.name === (0, $irVI7.TEMPLATE_EDIT_PAGE_CLOSE_EXPERIENCE)));
        }
    }, /* editorLoadExperience */ {
        name: (0, $irVI7.TEMPLATE_EDIT_PAGE_LOAD_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).TEMPLATE_EDITOR_LOAD
    }, /* editorPublishExperience */ {
        name: (0, $irVI7.TEMPLATE_EDIT_PAGE_PUBLISH_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startAdvancedSearch(match) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE),
        id: (0, $hukUK.objectHash)((0, (/*@__PURE__*/$parcel$interopDefault($3AVOh)))(match.query, [
            'search_id'
        ]))
    });
}
function $8c50530bac3b9ba1$var$startArchivedPagesList() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPACE_ARCHIVED_PAGES_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startContentManager() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CONTENT_MANAGER_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startSpaceDirectory() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPACE_DIRECTORY_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).SPACE_DIRECTORY
    });
}
function $8c50530bac3b9ba1$var$startTemplateGallery() {
    const TemplateGallerySubExperiences = [
        (0, $irVI7.TEMPLATE_GALLERY_CATEGORIES_EXPERIENCE),
        (0, $irVI7.TEMPLATE_GALLERY_SPACE_SELECTOR_EXPERIENCE),
        (0, $irVI7.TEMPLATE_GALLERY_CARDS_EXPERIENCE),
        (0, $irVI7.TEMPLATE_GALLERY_TEMPLATE_DETAIL_EXPERIENCE)
    ];
    const collectTemplateGalleryLoadExperiences = (events, experience)=>{
        (0, $1A7bE.collectAll)(TemplateGallerySubExperiences)(events, experience);
    };
    const stopOnRestrictedPage = (0, $1A7bE.collectAll)([
        (0, $irVI7.RESTRICTED_PAGE_EXPERIENCE)
    ]);
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.TEMPLATE_GALLERY_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT,
        collect: (events, experience)=>{
            collectTemplateGalleryLoadExperiences(events, experience);
            stopOnRestrictedPage(events, experience);
        }
    });
}
function $8c50530bac3b9ba1$var$startSpacePages() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPACE_PAGES_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startCreateContent(match, sessionData, subType) {
    const queryParams = match.query;
    const isPersonalSpace = queryParams.spaceKey?.[0] !== undefined ? (queryParams.spaceKey[0] === '~').toString() : 'unknown';
    const flow = (0, $c3Qwv.getSingleParam)(queryParams, 'source') || 'createContentRoute';
    if (match.params.contentType === 'whiteboard') (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_WHITEBOARD_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const whiteboardExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $irVI7.WHITEBOARD_EXPERIENCE));
            if (whiteboardExperienceStart) experience.succeed();
        }
    });
    else if (match.params.contentType === 'slide') (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_SLIDE_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const slideExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $irVI7.SLIDE_EXPERIENCE));
            if (slideExperienceStart) experience.succeed();
        }
    });
    else if (match.params.contentType === 'database') (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_DATABASE_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const databaseExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $irVI7.DATABASE_EXPERIENCE));
            if (databaseExperienceStart) experience.succeed();
        }
    });
    else if (match.params.contentType === 'smartLinkEmbed') (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_EMBED_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const smartLinkEmbedExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $irVI7.EMBED_EXPERIENCE));
            if (smartLinkEmbedExperienceStart) experience.succeed();
        }
    });
    else if ([
        'page',
        'blog'
    ].includes(match.params.contentType)) {
        // Undefined Links flows (linkCreation=true) are tracked under a separate non-SLA experience
        // to prevent them from polluting the SLA'd create-page experience
        const isLinkCreationFlow = (0, $9wGTI.fg)('cc_create_page_link_creation_split') && (0, $c3Qwv.getSingleParam)(queryParams, 'linkCreation') === 'true';
        const createPageExperienceName = isLinkCreationFlow ? (0, $irVI7.CREATE_PAGE_FROM_LINK_CREATION_EXPERIENCE) : (0, $irVI7.CREATE_PAGE_EXPERIENCE);
        (0, $fGzMp.getExperienceTracker)().start({
            name: createPageExperienceName,
            timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
            attributes: {
                contentType: match.params.contentType,
                flow: flow,
                isCreateContentRoute: true,
                isPersonalSpace: isPersonalSpace,
                edition: sessionData?.edition,
                shard: sessionData?.shard,
                isLivePage: subType?.toLowerCase() === 'live'
            },
            collect: (events, experience)=>{
                const editPageStarted = events.find((event)=>event.action === 'taskStart' && (event.name === (0, $irVI7.EDIT_PAGE_EXPERIENCE) || event.name === (0, $irVI7.EDIT_LEGACY_PAGE_EXPERIENCE)));
                if (editPageStarted) experience.succeed();
            }
        });
    }
}
function $8c50530bac3b9ba1$var$startWhiteboardBoard(match) {
    const embeddedWhiteboardSubExperiences = [
        (0, $irVI7.WHITEBOARD_CONTENT_EXPERIENCE)
    ];
    const subExperiences = [
        (0, $irVI7.WHITEBOARD_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE)
    ];
    const isEmbedded = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    const contentId = match.params.contentId;
    $8c50530bac3b9ba1$var$startSubExperiencesForMainExperience(contentId, (0, $irVI7.WHITEBOARD_EXPERIENCE), isEmbedded ? embeddedWhiteboardSubExperiences : subExperiences);
}
function $8c50530bac3b9ba1$var$startSlideView(contentId) {
    const subExperiences = [
        (0, $irVI7.SLIDE_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE)
    ];
    const embeddedSlideSubExperiences = [
        (0, $irVI7.SLIDE_CONTENT_EXPERIENCE)
    ];
    const isEmbedded = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    $8c50530bac3b9ba1$var$startSubExperiencesForMainExperience(contentId, (0, $irVI7.SLIDE_EXPERIENCE), isEmbedded ? embeddedSlideSubExperiences : subExperiences);
}
function $8c50530bac3b9ba1$var$startDatabaseView(contentId) {
    const subExperiences = [
        (0, $irVI7.DATABASE_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE)
    ];
    const embeddedDatabaseSubExperiences = [
        (0, $irVI7.DATABASE_CONTENT_EXPERIENCE)
    ];
    const isEmbedded = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    $8c50530bac3b9ba1$var$startSubExperiencesForMainExperience(contentId, (0, $irVI7.DATABASE_EXPERIENCE), isEmbedded ? embeddedDatabaseSubExperiences : subExperiences);
}
function $8c50530bac3b9ba1$var$startSubExperiencesForMainExperience(contentId, mainExperience, subExperiences) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: mainExperience,
        collect: (events, experience)=>{
            (0, $1A7bE.collectAll)(subExperiences)(events, experience);
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
    subExperiences.forEach((name)=>{
        (0, $fGzMp.getExperienceTracker)().start({
            name: name,
            id: contentId
        });
    });
}
function $8c50530bac3b9ba1$var$startEmbedPageView(contentId) {
    const embedPageSubExperiences = [
        (0, $irVI7.EMBED_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE),
        (0, $irVI7.VIEW_PAGE_FAVORITE_BUTTON_EXPERIENCE)
    ];
    const subExperiences = [
        (0, $irVI7.EMBED_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE)
    ];
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.EMBED_EXPERIENCE),
        collect: (events, experience)=>{
            (0, $1A7bE.collectAll)(subExperiences)(events, experience);
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
    embedPageSubExperiences.forEach((name)=>{
        (0, $fGzMp.getExperienceTracker)().start({
            name: name,
            id: contentId
        });
    });
}
function $8c50530bac3b9ba1$var$startFolderView(contentId) {
    const folderSubExperiences = [
        (0, $irVI7.FOLDER_CONTENT_EXPERIENCE)
    ];
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.FOLDER_EXPERIENCE),
        collect: (events, experience)=>{
            (0, $1A7bE.collectAll)(folderSubExperiences)(events, experience);
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
    folderSubExperiences.forEach((name)=>{
        (0, $fGzMp.getExperienceTracker)().start({
            name: name,
            id: contentId
        });
    });
}
function $8c50530bac3b9ba1$var$startViewAdminAnnouncementBannerSettings() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.ADMIN_ANNOUNCEMENT_BANNER_SETTINGS_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
}
function $8c50530bac3b9ba1$var$startSpaceManager() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPACE_MANAGER_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
}
function $8c50530bac3b9ba1$var$startCompanyHomeBuilderLoad() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.COMPANY_HOME_BUILDER_LOAD_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
}
function $8c50530bac3b9ba1$var$finishLivePageExperiences() {
    const tracker = (0, $fGzMp.getExperienceTracker)();
    const livePageExperiencesToSucceed = [
        (0, $irVI7.EDIT_PAGE_EXPERIENCE),
        (0, $irVI7.LIVE_PAGE_SESSION_EXPERIENCE)
    ];
    livePageExperiencesToSucceed.forEach((experience)=>{
        const experienceState = tracker.getExperienceState(experience);
        // We want to identify if it's actively running, and if so, succeed it. This aligns with how we succeed non-live-page experiences on transition.
        // We validate the `isLivePage` attribute is `true` before succeeding, to avoid undesirably succeeding edit-page here when it's not a live page
        if (experienceState && !experienceState?.hasStopped && experienceState?.attributes?.isLivePage) tracker.succeed({
            name: experience
        });
    });
}
module.exports["routeNameToContentTypeMap"] = $8c50530bac3b9ba1$export$4b786e0ae0cc0857;
module.exports["startExperienceForRoute"] = $8c50530bac3b9ba1$export$cac1117e2433d80e;
module.exports["startUFOPressTrace"] = $8c50530bac3b9ba1$export$b9a409823a06b924;
module.exports["startEditorExperiences"] = $8c50530bac3b9ba1$export$478e84e2cc5ff22d;
module.exports["startEditorSubExperience"] = $8c50530bac3b9ba1$export$7df6656d8508e8da;

});

parcelRegister("3AVOh", function(module, exports) {

var $79D42 = parcelRequire("79D42");


var $hGc5T = parcelRequire("hGc5T");


var $hcV0q = parcelRequire("hcV0q");


var $aI4Cx = parcelRequire("aI4Cx");


var $bk5x8 = parcelRequire("bk5x8");


var $ezTcL = parcelRequire("ezTcL");


var $jPzTX = parcelRequire("jPzTX");


var $14dnq = parcelRequire("14dnq");

/** Used to compose bitmasks for cloning. */ var $29e193b87644e449$var$CLONE_DEEP_FLAG = 1, $29e193b87644e449$var$CLONE_FLAT_FLAG = 2, $29e193b87644e449$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $29e193b87644e449$var$omit = $jPzTX(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $79D42(paths, function(path) {
        path = $aI4Cx(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $bk5x8(object, $14dnq(object), result);
    if (isDeep) result = $hGc5T(result, $29e193b87644e449$var$CLONE_DEEP_FLAG | $29e193b87644e449$var$CLONE_FLAT_FLAG | $29e193b87644e449$var$CLONE_SYMBOLS_FLAG, $ezTcL);
    var length = paths.length;
    while(length--)$hcV0q(result, paths[length]);
    return result;
});
module.exports = $29e193b87644e449$var$omit;

});

parcelRegister("hcV0q", function(module, exports) {

var $aI4Cx = parcelRequire("aI4Cx");


var $gO1os = parcelRequire("gO1os");


var $3ye78 = parcelRequire("3ye78");


var $4yN45 = parcelRequire("4yN45");

/** Used for built-in method references. */ var $c86fc6d9079351ab$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c86fc6d9079351ab$var$hasOwnProperty = $c86fc6d9079351ab$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $c86fc6d9079351ab$var$baseUnset(object, path) {
    path = $aI4Cx(path, object);
    // Prevent prototype pollution:
    // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
    // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
    var index = -1, length = path.length;
    if (!length) return true;
    while(++index < length){
        var key = $4yN45(path[index]);
        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !$c86fc6d9079351ab$var$hasOwnProperty.call(object, '__proto__')) return false;
        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
    }
    var obj = $3ye78(object, path);
    return obj == null || delete obj[$4yN45($gO1os(path))];
}
module.exports = $c86fc6d9079351ab$var$baseUnset;

});

parcelRegister("3ye78", function(module, exports) {

var $5g03W = parcelRequire("5g03W");


var $dAhdV = parcelRequire("dAhdV");

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $295f7eda793e290e$var$parent(object, path) {
    return path.length < 2 ? object : $5g03W(object, $dAhdV(path, 0, -1));
}
module.exports = $295f7eda793e290e$var$parent;

});

parcelRegister("ezTcL", function(module, exports) {

var $etJuK = parcelRequire("etJuK");

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $a9cf2821aeb590cb$var$customOmitClone(value) {
    return $etJuK(value) ? undefined : value;
}
module.exports = $a9cf2821aeb590cb$var$customOmitClone;

});

parcelRegister("jPzTX", function(module, exports) {

var $lyW2B = parcelRequire("lyW2B");


var $e7pPJ = parcelRequire("e7pPJ");


var $d246i = parcelRequire("d246i");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $e6fea10dbb684687$var$flatRest(func) {
    return $d246i($e7pPJ(func, undefined, $lyW2B), func + '');
}
module.exports = $e6fea10dbb684687$var$flatRest;

});

parcelRegister("lyW2B", function(module, exports) {

var $avFJ9 = parcelRequire("avFJ9");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $fb29cba7dcd09042$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $avFJ9(array, 1) : [];
}
module.exports = $fb29cba7dcd09042$var$flatten;

});

parcelRegister("avFJ9", function(module, exports) {

var $8kPaX = parcelRequire("8kPaX");


var $eED1E = parcelRequire("eED1E");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $7a6d2ac83094702e$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $eED1E);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $7a6d2ac83094702e$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $8kPaX(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $7a6d2ac83094702e$var$baseFlatten;

});

parcelRegister("eED1E", function(module, exports) {

var $2v1OR = parcelRequire("2v1OR");


var $bZ5J1 = parcelRequire("bZ5J1");


var $1ScXu = parcelRequire("1ScXu");

/** Built-in value references. */ var $aab312c604d1130a$var$spreadableSymbol = $2v1OR ? $2v1OR.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $aab312c604d1130a$var$isFlattenable(value) {
    return $1ScXu(value) || $bZ5J1(value) || !!($aab312c604d1130a$var$spreadableSymbol && value && value[$aab312c604d1130a$var$spreadableSymbol]);
}
module.exports = $aab312c604d1130a$var$isFlattenable;

});

parcelRegister("hukUK", function(module, exports) {

var $9HkI0 = parcelRequire("9HkI0");


var $1AV5C = parcelRequire("1AV5C");

let $ad68a267ac2e31a8$var$SESSION_SALT;
const $ad68a267ac2e31a8$export$237ebf1f4974c28e = ()=>{
    $ad68a267ac2e31a8$var$SESSION_SALT = (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
};
const $ad68a267ac2e31a8$var$toStringArray = (arr)=>`[${arr.map((item)=>$ad68a267ac2e31a8$var$toString(item)).join(',')}]`;
const $ad68a267ac2e31a8$var$toString = (o)=>{
    if (o === null) return 'null';
    if (Array.isArray(o)) return $ad68a267ac2e31a8$var$toStringArray(o);
    if (typeof o == 'object') return $ad68a267ac2e31a8$export$66b1d6a1029e925d(o);
    if (typeof o == 'string') return `"${o}"`;
    return `${o.toString()}`;
};
const $ad68a267ac2e31a8$export$66b1d6a1029e925d = (o)=>{
    if (!$ad68a267ac2e31a8$var$SESSION_SALT) $ad68a267ac2e31a8$export$237ebf1f4974c28e();
    const strToHash = `${Object.entries(o).filter(([_, value])=>typeof value !== 'undefined').sort((a, b)=>a[0].localeCompare(b[0])).map(([key, value])=>`${key}:${$ad68a267ac2e31a8$var$toString(value)}`).join()},${$ad68a267ac2e31a8$var$SESSION_SALT}`;
    return (0, $1AV5C.hashData)(strToHash);
};
module.exports["objectHash"] = $ad68a267ac2e31a8$export$66b1d6a1029e925d;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_PAGE_COMMENT"] = 30000] = "VIEW_PAGE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("1A7bE", function(module, exports) {

var $gykrH = parcelRequire("gykrH");

const $812facbbd37978f7$export$feb7963ae429f97f = (experienceNames)=>{
    const experienceNameSet = new Set(experienceNames);
    return (events, experience)=>{
        // Fail as soon as any sub-experience is failed or aborted
        experience.stopOn(events.find((event)=>experienceNameSet.has(event.name) && (event.action === 'taskFail' || event.action === 'taskAbort')), {
            incompleteSubExperiences: [
                ...experienceNameSet
            ].join(', ')
        });
        // If there's a success remove the experience from the set
        // of experiences we're waiting for.
        events.forEach((event)=>{
            if ((0, $gykrH.isStop)(event)) experienceNameSet.delete(event.name);
        });
        // Experience is considered complete if all sub-experiences
        // are complete.
        if (experienceNameSet.size === 0) experience.succeed();
    };
};
const $812facbbd37978f7$export$79dbdd3e43727beb = (experienceNames)=>(events, experience)=>experience.stopOn(events.find((event)=>(0, $gykrH.isStop)(event) && (0, $gykrH.hasName)(event, ...experienceNames)));
module.exports["collectAll"] = $812facbbd37978f7$export$feb7963ae429f97f;
module.exports["collectAny"] = $812facbbd37978f7$export$79dbdd3e43727beb;

});

parcelRegister("h10mo", function(module, exports) {

var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");


var $1A7bE = parcelRequire("1A7bE");

const $49be9d39a158f0e7$var$homeSubExperiences = [
    (0, $irVI7.HOME_OVERVIEW_EXPERIENCE),
    (0, $irVI7.HOME_RECENT_EXPERIENCE),
    (0, $irVI7.HOME_STARRED_EXPERIENCE),
    (0, $irVI7.HOME_WATCHING_EXPERIENCE),
    (0, $irVI7.HOME_DRAFTS_EXPERIENCE)
];
function $49be9d39a158f0e7$export$4278268ff5675d74() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.HOME_EXPERIENCE),
        collect: (0, $1A7bE.collectAny)($49be9d39a158f0e7$var$homeSubExperiences)
    });
}
module.exports["startHome"] = $49be9d39a158f0e7$export$4278268ff5675d74;

});

parcelRegister("hzVuz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");





var $bQm3c = parcelRequire("bQm3c");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $hBkCm = parcelRequire("hBkCm");

var $f7B1p = parcelRequire("f7B1p");


var $k3pHv = parcelRequire("k3pHv");

const $b7aff31f4e633d8f$var$checkDomainApproval = async (cloudId, userId, onError)=>{
    let OrgMemberCapabilityType = /*#__PURE__*/ function(OrgMemberCapabilityType) {
        OrgMemberCapabilityType["DIRECT_ACCESS"] = "DIRECT_ACCESS";
        OrgMemberCapabilityType["REQUEST_ACCESS"] = "REQUEST_ACCESS";
        OrgMemberCapabilityType["PENDING_REQUEST_EXISTS"] = "PENDING_REQUEST_EXISTS";
        return OrgMemberCapabilityType;
    }({});
    const params = new URLSearchParams({
        resource: `ari:cloud:confluence::site/${cloudId}`
    });
    let hasCapabilities = false;
    try {
        const response = await (0, $f7B1p.cfetch)(`/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`, {
            method: 'GET',
            headers: {
                resource: `ari:cloud:confluence::site/${cloudId}`,
                ACCEPT: 'application/json',
                'Account-Id': userId
            }
        });
        const data = await response.json();
        if (Object.values(data.results)[0] in OrgMemberCapabilityType) hasCapabilities = true;
    } catch (e) {
        if ((0, $hBkCm.BadStatusError).isBadStatusError(e) && e.response?.status === 401) // A 401 from the invitations gateway is expected for guest/external users whose
        // session tokens are scoped to Confluence only and cannot authenticate against
        // platform APIs. Treat this as "not an org member" without failing the experience.
        return false;
        const response = (0, $hBkCm.BadStatusError).isBadStatusError(e) ? e.response : undefined;
        const error = new Error(`Error in getting approved domains, status = ${response?.status}, message = "${response?.statusText}"`);
        onError(error);
    }
    return hasCapabilities;
};
const $b7aff31f4e633d8f$export$435bbe3b3c44f9d8 = (isExternalShareRequest = false)=>{
    const { isLicensed: isLicensed, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [isApprovedOrgMember, setIsApprovedOrgMember] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        const validateDomain = async ()=>{
            if (userId && !isLicensed && isExternalShareRequest) {
                const isApproved = await $b7aff31f4e633d8f$var$checkDomainApproval(cloudId, userId, (error)=>{
                    experienceTracker.fail({
                        name: (0, $irVI7.VIEW_PUBLIC_LINK_SHARED_PAGE_EXPERIENCE),
                        error: error
                    });
                });
                isApproved && setIsApprovedOrgMember(isApproved);
            }
        };
        validateDomain();
    }, [
        userId,
        isLicensed,
        cloudId,
        experienceTracker,
        isExternalShareRequest
    ]);
    if (!userId) return {
        userType: (0, $k3pHv.UserTypes).ANONYMOUS
    };
    if (isLicensed) return {
        userType: (0, $k3pHv.UserTypes).CONFLUENCE_USER
    };
    return {
        userType: isApprovedOrgMember ? (0, $k3pHv.UserTypes).ORG_MEMBER : (0, $k3pHv.UserTypes).ATLASSIAN_USER
    };
};



var $gXrHX = parcelRequire("gXrHX");

const $a5952995c9c756c1$export$355d4724e049b0df = ({ children: children, path: path, shareToken: shareToken })=>{
    const isExternalShareRequest = !!(0, $1NBp8.EXTERNAL_SHARE).match(path);
    const isAccessLinkRequest = !!(0, $1NBp8.ACCESS_LINK).match(path) && (0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false);
    const { userType: userType } = (0, $b7aff31f4e633d8f$export$435bbe3b3c44f9d8)(isExternalShareRequest || isAccessLinkRequest);
    // Extract shareToken from path if it's an external share request
    const extractedShareToken = (0, $cozmU.useMemo)(()=>{
        if (isExternalShareRequest) {
            const match = (0, $1NBp8.EXTERNAL_SHARE).match(path);
            return match?.params?.externalToken || undefined;
        } else if (isAccessLinkRequest) {
            const match = (0, $1NBp8.ACCESS_LINK).match(path);
            return match?.params?.shareToken || undefined;
        }
        return undefined;
    }, [
        isExternalShareRequest,
        path,
        isAccessLinkRequest
    ]);
    // Use provided shareToken if available, otherwise use extracted one
    const resolvedShareToken = shareToken || extractedShareToken;
    const externalShareContextValue = (0, $cozmU.useMemo)(()=>({
            isExternalShareRequest: isExternalShareRequest || isAccessLinkRequest,
            userType: userType,
            shareToken: resolvedShareToken,
            isAccessLinkRequest: isAccessLinkRequest
        }), [
        isExternalShareRequest,
        userType,
        resolvedShareToken,
        isAccessLinkRequest
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gXrHX.ExternalShareContext).Provider, {
        value: externalShareContextValue
    }, children);
};
module.exports["ExternalShareContextProvider"] = $a5952995c9c756c1$export$355d4724e049b0df;

});

parcelRegister("k3pHv", function(module, exports) {
var $dcb154d9b517823f$export$df06b7fc047181f5 = /*#__PURE__*/ function(UserTypes) {
    // Anonymous users, not logged in
    UserTypes["ANONYMOUS"] = "anonymous";
    // Logged in, not Confluence user - member in the org
    UserTypes["ORG_MEMBER"] = "org-member";
    // Logged in, Licensed Confluence user
    UserTypes["CONFLUENCE_USER"] = "confluence-user";
    // Logged in, Atlassian user not in the org
    UserTypes["ATLASSIAN_USER"] = "atlassian-user";
    return UserTypes;
}({});
module.exports["UserTypes"] = $dcb154d9b517823f$export$df06b7fc047181f5;

});

parcelRegister("gXrHX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $k3pHv = parcelRequire("k3pHv");

const $a357cfbdfa4d3d24$export$74d34469a946b330 = /*#__PURE__*/ (0, $cozmU.createContext)({
    isExternalShareRequest: false,
    userType: (0, $k3pHv.UserTypes).ANONYMOUS,
    shareToken: undefined,
    isAccessLinkRequest: false
});
module.exports["ExternalShareContext"] = $a357cfbdfa4d3d24$export$74d34469a946b330;

});

parcelRegister("hmDFY", function(module, exports) {

let $ca4344963891a626$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ca4344963891a626$var$load("8k5W1").then(()=>parcelRequire('42H7Z'));

});

parcelRegister("iMLPM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");


// Keep the machine registry graph out of the root App bundle and off the page-load
// critical path. The host renders nothing and only observes flows that start from
// user interaction, so it loads in the background phase: no SSR preload and no UFO
// load hold on every page view. A late mount reads the registry's current snapshot.
// Producers call `preloadRemixWatcherHost` at flow admission so the chunk is already
// in flight before any machine-derived phase becomes user-visible.
const $8fae2dbb97264744$var$LazyRemixWatcherHost = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "ikpQt",
    name: 'RemixWatcherHost',
    loader: async ()=>(await (parcelRequire("8pF6M"))).RemixWatcherHost,
    loading: ()=>null
});
const $8fae2dbb97264744$export$8ac6a35c27bccce6 = ()=>{
    if (!(0, $9wGTI.fg)('remix_state_rearchitecture_enabled')) return;
    // Fire-and-forget: the loadable surfaces load failures through its own error path.
    $8fae2dbb97264744$var$LazyRemixWatcherHost.preload();
};
const $8fae2dbb97264744$export$b6d016c0687b53a1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).CE_MAU
    }, (0, $9wGTI.fg)('remix_state_rearchitecture_enabled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8fae2dbb97264744$var$LazyRemixWatcherHost, null) : null);
module.exports["preloadRemixWatcherHost"] = $8fae2dbb97264744$export$8ac6a35c27bccce6;
module.exports["RemixWatcherMount"] = $8fae2dbb97264744$export$b6d016c0687b53a1;

});

parcelRegister("8pF6M", function(module, exports) {

let $62008bcfbc8aceec$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $62008bcfbc8aceec$var$load("ecqah"),
    $62008bcfbc8aceec$var$load("j3CG3")
]).then(()=>parcelRequire('1HmBi'));

});

parcelRegister("6UYek", function(module, exports) {

var $fbcPJ = parcelRequire("fbcPJ");


var $cozmU = parcelRequire("cozmU");


var $kyKWe = parcelRequire("kyKWe");


var $fD0Uz = parcelRequire("fD0Uz");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $1xpoY = parcelRequire("1xpoY");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $3vc4U = parcelRequire("3vc4U");

const $da160e8fa3112de6$var$SubscriptionsContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $da160e8fa3112de6$var$SubscriptionsDispatchContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $da160e8fa3112de6$export$2612561ece05d878 = [
    '401',
    'Failed to fetch',
    'Load Failed',
    'Network error',
    'GraphQL error: undefined',
    'Auth category: UNAUTHENTICATED is not allowed in service confluence_monolith_subscriptions'
];
const $da160e8fa3112de6$var$getLegacyApolloError = (error)=>{
    if (!('errors' in error) || !Array.isArray(error.errors)) return undefined;
    const firstError = error.errors[0];
    return firstError && typeof firstError === 'object' ? firstError : undefined;
};
const $da160e8fa3112de6$var$getLegacyApolloErrorMessage = (error)=>{
    const firstError = $da160e8fa3112de6$var$getLegacyApolloError(error);
    if (!firstError || !('message' in firstError)) return undefined;
    return typeof firstError.message === 'string' ? firstError.message : undefined;
};
const $da160e8fa3112de6$var$getLegacyApolloErrorStatusCode = (error)=>{
    const firstError = $da160e8fa3112de6$var$getLegacyApolloError(error);
    if (!firstError || !('extensions' in firstError)) return undefined;
    const { extensions: extensions } = firstError;
    if (!extensions || typeof extensions !== 'object' || !('statusCode' in extensions)) return undefined;
    return typeof extensions.statusCode === 'number' ? extensions.statusCode : undefined;
};
const $da160e8fa3112de6$export$5f043fff8b6d3ca6 = ({ children: children })=>{
    const [contentModified, setContentModified] = (0, $cozmU.useState)(null);
    const [contentId, setContentId] = (0, $cozmU.useState)(null);
    const [contentType, setContentType] = (0, $cozmU.useState)(null);
    const subscribersRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef({});
    // if there are no subscribers left we set the contentId and contentType to null
    // remove subscriber on unmount of subscription component
    /***
   * Adds a subscriber to the context.
   * @delta - the delta to subscribe to
   * @subscriberId - an id for the subscriber, used to remove the subscriber later
   * @onSubscriptionData - callback to be called when data is received for the delta
   * @returns uniqueSubscriberId - a unique id for the subscriber, used to remove the subscriber later
   */ const addSubscriber = (0, $cozmU.useCallback)(({ subscriberId: subscriberId, onSubscriptionData: onSubscriptionData, delta: delta })=>{
        const subscribers = subscribersRef.current;
        const uniqueSubscriberId = `${subscriberId}-${(0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()}`; // ensure unique subscriberId
        const currentSubscribersForDelta = subscribers?.[delta] || [];
        subscribers[delta] = [
            ...currentSubscribersForDelta,
            {
                id: uniqueSubscriberId,
                onSubscriptionData: onSubscriptionData
            }
        ];
        return uniqueSubscriberId;
    }, []);
    const removeSubscriber = (0, $cozmU.useCallback)(({ delta: delta, subscriberId: subscriberId })=>{
        const subscribers = subscribersRef.current;
        if (subscribers.hasOwnProperty(delta)) {
            subscribers[delta] = (subscribers[delta] ?? []).filter((sub)=>sub.id !== subscriberId);
            // if there are no subscribers left for this delta, we can remove the delta
            if (subscribers[delta].length === 0) {
                delete subscribers[delta];
                // if that was the last subscriber we can stop the subscription entirely
                if (Object.keys(subscribers).length === 0) {
                    setContentId(null);
                    setContentType(null);
                }
            }
        }
    }, [
        setContentId,
        setContentType
    ]);
    const callSubscribers = (0, $cozmU.useCallback)((deltas, data)=>{
        const subscribers = subscribersRef.current;
        deltas.forEach((delta)=>{
            const subscribersForDelta = subscribers[delta];
            if (subscribersForDelta) subscribersForDelta.forEach((subscriber)=>{
                const callback = subscriber?.onSubscriptionData?.(delta, data);
                if (callback instanceof Promise) Promise.resolve(callback).catch((err)=>{
                    (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                        // hard coded as the package will cause circular dependency
                        attribution: 'page-experiences'
                    });
                });
            });
        });
    }, []);
    const { id: id, onSubscriptionComplete: onSubscriptionComplete, extensions: extensions, onSubscriptionData: onDataReceived } = (0, $3vc4U.useSubscriptionValues)({
        contentType: contentType,
        contentId: contentId
    });
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const skipSubscriptionForAnonUsers = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS;
    const { error: error } = (0, $fD0Uz.useSubscriptionInterop)((0, $fbcPJ.default), {
        variables: {
            id: id,
            __extensions: extensions
        },
        extensions: extensions,
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData (response) {
            onDataReceived(response);
            const { subscriptionData: subscriptionData } = response;
            if (!subscriptionData || !subscriptionData.data) return;
            const deltas = subscriptionData?.data?.confluence_onContentModified?._deltas;
            const data = subscriptionData?.data?.confluence_onContentModified;
            if (deltas && Array.isArray(deltas) && deltas.length > 0 && data) callSubscribers(deltas, data);
            setContentModified(data ?? null);
        },
        skip: !id || skipSubscriptionForAnonUsers || !(0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider'),
        interopApolloAggClient: true,
        __callerPackage__: "graphql"
    });
    (0, $cozmU.useEffect)(()=>{
        if (error) {
            const errorMessage = error?.message || $da160e8fa3112de6$var$getLegacyApolloErrorMessage(error) || error?.graphQLErrors?.[0]?.message || error?.graphQLErrors?.[0]?.originalError?.message || error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.extensions?.message;
            const statusCode = $da160e8fa3112de6$var$getLegacyApolloErrorStatusCode(error);
            // if there is no error message it is likely to be a client side network issue
            // eg spotty vpn
            //
            // When graphql-subscriptions rate-limits us it returns an HTML page (eg a 429),
            // which graphql-ws feeds into JSON.parse and throws a SyntaxError. In V8 the
            // thrown message embeds the offending token, eg:
            //   Unexpected token '<', "<!DOCTYPE "... is not valid JSON
            // We match on the HTML markers rather than the generic "Unexpected token" so we
            // only suppress HTML payloads and not unrelated malformed-JSON bugs.
            const isHtmlRateLimitError = (0, $1xpoY.default).getBoolean('confluence_html_error_catching', false) && Boolean(errorMessage && /Unexpected token '<'|<!DOCTYPE|<html/.test(errorMessage));
            const isIgnoredError = $da160e8fa3112de6$export$2612561ece05d878.some((errorString)=>error?.message.includes(errorString)) || !errorMessage || isHtmlRateLimitError;
            if (statusCode !== 403 && !isIgnoredError) {
                const e = new Error(`Subscription Error - :${errorMessage}`);
                (0, $fJlJm.setContentErrorAttributes)(e, {
                    objectId: contentId,
                    objectType: contentType
                });
                (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                    // hard coded as the package will cause circular dependency
                    attribution: 'page-experiences'
                });
            }
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error,
        contentId,
        contentType
    ]);
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            contentModified: contentModified,
            error: error
        }), [
        contentModified,
        error
    ]);
    const dispatchContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            setContentType: setContentType,
            setContentId: setContentId,
            addSubscriber: addSubscriber,
            removeSubscriber: removeSubscriber
        }), [
        setContentType,
        setContentId,
        addSubscriber,
        removeSubscriber
    ]);
    if ((0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($da160e8fa3112de6$var$SubscriptionsContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($da160e8fa3112de6$var$SubscriptionsDispatchContext.Provider, {
        value: dispatchContextValue
    }, children));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
const $da160e8fa3112de6$export$98d6302051bd25df = ()=>{
    return (0, $cozmU.useContext)($da160e8fa3112de6$var$SubscriptionsContext);
};
const $da160e8fa3112de6$export$e2675019a3c1d99f = ()=>{
    return (0, $cozmU.useContext)($da160e8fa3112de6$var$SubscriptionsDispatchContext);
};
module.exports["SubscriptionsContextProvider"] = $da160e8fa3112de6$export$5f043fff8b6d3ca6;
module.exports["useSubscriptionsContext"] = $da160e8fa3112de6$export$98d6302051bd25df;
module.exports["useSubscriptionsDispatchContext"] = $da160e8fa3112de6$export$e2675019a3c1d99f;

});

parcelRegister("fbcPJ", function(module, exports) {
/**
 * @generated SignedSource<<75dc67bed6c2efce761cd8d41d39e8c1>>
 * @relayHash 509c79ed3aa65395a6739ffb9126f832
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c37239834392dbf88f3de4f8af11c861efb04723bfa417c1f6958c4e58059293
const $31174e902ea6e4b2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "type"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "ScalarField",
        "name": "version"
    }, v6 = [
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "value"
        },
        v5 /*: any*/ ,
        v3 /*: any*/ 
    ], v7 = [
        v4 /*: any*/ ,
        v3 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "spaceKey"
    }, v9 = {
        "kind": "ScalarField",
        "name": "contentId"
    }, v10 = [
        v9 /*: any*/ ,
        v3 /*: any*/ 
    ], v11 = {
        "kind": "ScalarField",
        "name": "confVersion"
    }, v12 = {
        "kind": "ScalarField",
        "name": "commentId"
    }, v13 = {
        "kind": "ScalarField",
        "name": "inlineCommentType"
    }, v14 = {
        "kind": "ScalarField",
        "name": "adfBodyContent"
    }, v15 = {
        "kind": "ScalarField",
        "name": "markerRef"
    }, v16 = {
        "kind": "ScalarField",
        "name": "publishVersionNumber"
    }, v17 = {
        "kind": "ScalarField",
        "name": "from"
    }, v18 = {
        "kind": "ScalarField",
        "name": "to"
    }, v19 = {
        "kind": "ScalarField",
        "name": "pos"
    }, v20 = {
        "kind": "ScalarField",
        "name": "annotationType"
    }, v21 = [
        v12 /*: any*/ ,
        v15 /*: any*/ ,
        v3 /*: any*/ 
    ], v22 = {
        "kind": "ScalarField",
        "name": "replies"
    }, v23 = {
        "kind": "ScalarField",
        "name": "pageCommentType"
    }, v24 = [
        v3 /*: any*/ ,
        v12 /*: any*/ 
    ], v25 = {
        "kind": "ScalarField",
        "name": "emojiId"
    }, v26 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "ConfluenceContentModified",
            "kind": "LinkedField",
            "name": "confluence_onContentModified",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "accountId"
                },
                {
                    "kind": "ScalarField",
                    "name": "originTabId"
                },
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "_deltas"
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "contentStateUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "emojiTitleUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "coverPictureUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "pageTitlePropertyUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyDeleted",
                    "kind": "LinkedField",
                    "name": "coverPictureDeleted",
                    "plural": false,
                    "selections": v7 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyDeleted",
                    "kind": "LinkedField",
                    "name": "emojiTitleDeleted",
                    "plural": false,
                    "selections": v7 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyDeleted",
                    "kind": "LinkedField",
                    "name": "contentStateDeleted",
                    "plural": false,
                    "selections": v7 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceCoverPictureWidthUpdated",
                    "kind": "LinkedField",
                    "name": "coverPictureWidthUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "coverPictureWidth"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluencePageBlogified",
                    "kind": "LinkedField",
                    "name": "pageBlogified",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "spaceName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "blogTitle"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "converterDisplayName"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceEmbedUpdated",
                    "kind": "LinkedField",
                    "name": "embedUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "product"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isBlankStateUpdate"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluencePageMigrated",
                    "kind": "LinkedField",
                    "name": "pageMigrated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fabricEligibility"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceContentRestrictionUpdated",
                    "kind": "LinkedField",
                    "name": "contentRestrictionUpdated",
                    "plural": false,
                    "selections": v10 /*: any*/ 
                },
                {
                    "concreteType": "ConfluencePageMoved",
                    "kind": "LinkedField",
                    "name": "pageMoved",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "oldSpaceKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "newSpaceKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "oldParentId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "oldPosition"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "newSpaceAlias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "oldSpaceAlias"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluencePageUpdated",
                    "kind": "LinkedField",
                    "name": "pageUpdated",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "trigger"
                        },
                        v11 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceWorkflowApplicationChanged",
                    "kind": "LinkedField",
                    "name": "workflowApplicationChanged",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "changeType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "newWorkflowStatusId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "contentStatus"
                        },
                        v5 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceMarkdownModeUpdated",
                    "kind": "LinkedField",
                    "name": "markdownModeUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isMarkdownMode"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceContentUpdatedWithTemplate",
                    "kind": "LinkedField",
                    "name": "contentUpdatedWithTemplate",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "subtype"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentCreated",
                    "kind": "LinkedField",
                    "name": "inlineCommentCreated",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        v3 /*: any*/ ,
                        v15 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceRendererInlineCommentCreated",
                    "kind": "LinkedField",
                    "name": "rendererInlineCommentCreated",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v12 /*: any*/ ,
                        v14 /*: any*/ ,
                        v13 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceInlineCommentStep",
                            "kind": "LinkedField",
                            "name": "step",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceInlineCommentStepMark",
                                    "kind": "LinkedField",
                                    "name": "mark",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                                            "kind": "LinkedField",
                                            "name": "attrs",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ]
                                        },
                                        v3 /*: any*/ 
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentCreated",
                    "kind": "LinkedField",
                    "name": "editorInlineCommentCreated",
                    "plural": false,
                    "selections": [
                        v14 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v15 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentUpdated",
                    "kind": "LinkedField",
                    "name": "inlineCommentUpdated",
                    "plural": false,
                    "selections": v21 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceInlineCommentDeleted",
                    "kind": "LinkedField",
                    "name": "inlineCommentDeleted",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v15 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentResolved",
                    "kind": "LinkedField",
                    "name": "inlineCommentResolved",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceInlineCommentResolveProperties",
                            "kind": "LinkedField",
                            "name": "inlineResolveProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isDangling"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolved"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedByDangling"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedFriendlyDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedTime"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedUser"
                                },
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "inlineText"
                        },
                        v15 /*: any*/ ,
                        v22 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentUpdated",
                    "kind": "LinkedField",
                    "name": "inlineCommentUnresolved",
                    "plural": false,
                    "selections": v21 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceInlineCommentReattached",
                    "kind": "LinkedField",
                    "name": "inlineCommentReattached",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v3 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceInlineCommentStep",
                            "kind": "LinkedField",
                            "name": "step",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceInlineCommentStepMark",
                                    "kind": "LinkedField",
                                    "name": "mark",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                                            "kind": "LinkedField",
                                            "name": "attrs",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v20 /*: any*/ 
                                            ]
                                        },
                                        v3 /*: any*/ 
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceCommentCreated",
                    "kind": "LinkedField",
                    "name": "commentCreated",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v14 /*: any*/ ,
                        v12 /*: any*/ ,
                        v23 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceCommentUpdated",
                    "kind": "LinkedField",
                    "name": "commentUpdated",
                    "plural": false,
                    "selections": v24 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceCommentUpdated",
                    "kind": "LinkedField",
                    "name": "commentDeleted",
                    "plural": false,
                    "selections": v24 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceCommentCreated",
                    "kind": "LinkedField",
                    "name": "commentResolved",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v14 /*: any*/ ,
                        v12 /*: any*/ ,
                        v23 /*: any*/ ,
                        v22 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceCommentUpdated",
                    "kind": "LinkedField",
                    "name": "commentReopened",
                    "plural": false,
                    "selections": v24 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceSchedulePublished",
                    "kind": "LinkedField",
                    "name": "schedulePublished",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "publishTime"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "eventType"
                        },
                        v11 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceContentAccessRequested",
                    "kind": "LinkedField",
                    "name": "contentAccessRequested",
                    "plural": false,
                    "selections": v10 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentAccessDecisionMade",
                    "kind": "LinkedField",
                    "name": "contentAccessDecisionMade",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "decision"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineReactionAdded",
                    "kind": "LinkedField",
                    "name": "inlineReactionAdded",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v15 /*: any*/ ,
                        v25 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "newHighlight"
                        },
                        {
                            "concreteType": "ConfluenceInlineCommentStep",
                            "kind": "LinkedField",
                            "name": "step",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceInlineCommentStepMark",
                                    "kind": "LinkedField",
                                    "name": "mark",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                                            "kind": "LinkedField",
                                            "name": "attrs",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ]
                                        },
                                        v1 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "stepType"
                                }
                            ]
                        },
                        v16 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineReactionRemoved",
                    "kind": "LinkedField",
                    "name": "inlineReactionRemoved",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v15 /*: any*/ ,
                        v25 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineReactionHighlightDeleted",
                    "kind": "LinkedField",
                    "name": "inlineReactionHighlightDeleted",
                    "plural": false,
                    "selections": v21 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SubscriptionsContextProviderSubscription",
            "selections": v26 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SubscriptionsContextProviderSubscription",
            "selections": v26 /*: any*/ 
        },
        "params": {
            "cacheID": "509c79ed3aa65395a6739ffb9126f832",
            "id": "c37239834392dbf88f3de4f8af11c861efb04723bfa417c1f6958c4e58059293",
            "metadata": {},
            "name": "SubscriptionsContextProviderSubscription",
            "operationKind": "subscription",
            "text": "subscription SubscriptionsContextProviderSubscription($id:ID!){confluence_onContentModified(id:$id){type,id,accountId,originTabId,__typename,_deltas,contentStateUpdated{key,value,version,__typename},emojiTitleUpdated{key,value,version,__typename},coverPictureUpdated{key,value,version,__typename},pageTitlePropertyUpdated{key,value,version,__typename},coverPictureDeleted{key,__typename},emojiTitleDeleted{key,__typename},contentStateDeleted{key,__typename},coverPictureWidthUpdated{coverPictureWidth,__typename},pageBlogified{spaceKey,spaceName,blogTitle,converterDisplayName,__typename},embedUpdated{product,isBlankStateUpdate,__typename},pageMigrated{fabricEligibility,__typename},contentRestrictionUpdated{contentId,__typename},pageMoved{oldSpaceKey,newSpaceKey,oldParentId,oldPosition,newSpaceAlias,oldSpaceAlias,__typename},pageUpdated{__typename,trigger,confVersion},workflowApplicationChanged{contentId,changeType,newWorkflowStatusId,contentStatus,version,__typename},markdownModeUpdated{isMarkdownMode,__typename},contentUpdatedWithTemplate{spaceKey,subtype,__typename},inlineCommentCreated{commentId,inlineCommentType,adfBodyContent,__typename,markerRef},rendererInlineCommentCreated{__typename,commentId,adfBodyContent,inlineCommentType,markerRef,publishVersionNumber,step{from,to,pos,mark{attrs{annotationType,__typename},__typename},__typename}},editorInlineCommentCreated{adfBodyContent,commentId,inlineCommentType,markerRef,__typename},inlineCommentUpdated{commentId,markerRef,__typename},inlineCommentDeleted{commentId,inlineCommentType,markerRef,__typename},inlineCommentResolved{commentId,inlineResolveProperties{isDangling,resolved,resolvedByDangling,resolvedFriendlyDate,resolvedTime,resolvedUser,__typename},inlineText,markerRef,replies,__typename},inlineCommentUnresolved{commentId,markerRef,__typename},inlineCommentReattached{commentId,__typename,markerRef,publishVersionNumber,step{from,mark{attrs{__typename,annotationType},__typename},__typename}},commentCreated{__typename,adfBodyContent,commentId,pageCommentType},commentUpdated{__typename,commentId},commentDeleted{__typename,commentId},commentResolved{__typename,adfBodyContent,commentId,pageCommentType,replies},commentReopened{__typename,commentId},schedulePublished{publishTime,eventType,confVersion,__typename},contentAccessRequested{contentId,__typename},contentAccessDecisionMade{contentId,decision,__typename},inlineReactionAdded{commentId,markerRef,emojiId,newHighlight,step{from,to,pos,mark{attrs{annotationType,id},type},stepType},publishVersionNumber,__typename},inlineReactionRemoved{commentId,markerRef,emojiId,__typename},inlineReactionHighlightDeleted{commentId,markerRef,__typename}}}"
        }
    };
}();
$31174e902ea6e4b2$var$node.hash = "c37cfea9a825383fc3da89eb6b15ecfd";
var $31174e902ea6e4b2$export$2e2bcd8739ae039 = $31174e902ea6e4b2$var$node;
module.exports["default"] = $31174e902ea6e4b2$export$2e2bcd8739ae039;

});

parcelRegister("fD0Uz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7EPz1 = parcelRequire("7EPz1");


var $6SsN4 = parcelRequire("6SsN4");


var $eqEJl = parcelRequire("eqEJl");


var $422HI = parcelRequire("422HI");


var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");


var $iF5wn = parcelRequire("iF5wn");

const $c7f06d7e4ea271ae$var$isRelayGraphQLTaggedNode = (subscription)=>typeof subscription === 'function' || subscription.kind !== 'Document';
const $c7f06d7e4ea271ae$var$isFormattedExecutionResult = (response)=>Boolean(response && typeof response === 'object' && ('data' in response || 'errors' in response));
const $c7f06d7e4ea271ae$var$isSubscriptionData = (response)=>!$c7f06d7e4ea271ae$var$isFormattedExecutionResult(response);
const $c7f06d7e4ea271ae$var$getSubscriptionDataAndExtensions = (response)=>{
    if (response == null) return {
        data: undefined,
        extensions: undefined
    };
    if ($c7f06d7e4ea271ae$var$isSubscriptionData(response)) return {
        data: response,
        extensions: undefined
    };
    return {
        data: response.data ?? undefined,
        extensions: response.extensions
    };
};
const $c7f06d7e4ea271ae$export$4966ff7f324f6363 = (response)=>{
    const { data: data, extensions: extensions } = $c7f06d7e4ea271ae$var$getSubscriptionDataAndExtensions(response);
    return {
        ...extensions ? {
            extensions: extensions
        } : {},
        subscriptionData: {
            data: data,
            loading: false,
            ...extensions ? {
                extensions: extensions
            } : {}
        }
    };
};
const $c7f06d7e4ea271ae$var$__TEST_ONLY_isTestOnlySafeEnvironment = ()=>{
    const isProduction = true;
    const isCloudProduction = true;
    const isCloudStaging = false;
    if (isProduction || isCloudProduction || isCloudStaging) return false;
    const isTest = false;
    const isDevelopment = false;
    const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost';
    return isTest || isDevelopment || isLocalhost;
};
const $c7f06d7e4ea271ae$export$1bed67b955596e29 = (forceRelay)=>{
    if (!$c7f06d7e4ea271ae$var$__TEST_ONLY_isTestOnlySafeEnvironment()) return false;
    window.__TEST_ONLY_FORCE_RELAY_MODE__ = forceRelay;
    return true;
};
function $c7f06d7e4ea271ae$export$275462b87cef6610(subscription, options) {
    const forceRelayMode = window.__TEST_ONLY_FORCE_RELAY_MODE__;
    const shouldUseRelay = forceRelayMode || (0, $iffSy.isRelayEnabled)(options?.__callerPackage__, {
        phase: 'subscription'
    });
    if (shouldUseRelay) {
        if (!$c7f06d7e4ea271ae$var$isRelayGraphQLTaggedNode(subscription)) throw new Error('[Relay migration] useSubscriptionInterop Relay mode requires graphql tag');
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return $c7f06d7e4ea271ae$var$useSubscriptionInteropRelay(subscription, options);
    } else {
        const { interopApolloAggClient: interopApolloAggClient, extensions: extensions, ...apolloOptions } = options ?? {};
        // Apollo v2's `useSubscription` does not forward a per-call `context` option down
        // to the WebSocket link, so we smuggle `extensions` through `variables.__extensions`.
        // `AttachExtensionsLink` strips it back out and re-attaches it to the operation
        // context, which `GraphQLWSLink.request` then sets on the wire payload.
        const variables = extensions !== undefined ? {
            ...apolloOptions.variables,
            __extensions: extensions
        } : apolloOptions.variables;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return (0, $7EPz1.useSubscription)((0, $86okN.toDocumentNode)(subscription), {
            ...apolloOptions,
            variables: variables,
            ...interopApolloAggClient ? {
                client: window.GLOBAL_APOLLO_AGG_CLIENT ?? window.MOCK_GATEWAY_APOLLO_CLIENT
            } : {}
        });
    }
}
const $c7f06d7e4ea271ae$var$toApolloErrorInterop = (error)=>new (0, $422HI.ApolloErrorInterop)({
        networkError: error instanceof Error ? error : new Error(String(error))
    });
function $c7f06d7e4ea271ae$var$useSubscriptionInteropRelay(subscription, options) {
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const [data, setData] = (0, $cozmU.useState)(undefined);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const [loading, setLoading] = (0, $cozmU.useState)(!options?.skip);
    const disposableRef = (0, $cozmU.useRef)(null);
    const callbacksRef = (0, $cozmU.useRef)(options);
    callbacksRef.current = options;
    const skip = options?.skip;
    const variables = (0, $iF5wn.useMemoObj)(options?.variables, options?.__callerPackage__, {
        phase: 'subscription'
    });
    const extensions = (0, $iF5wn.useMemoObj)(options?.extensions, options?.__callerPackage__, {
        phase: 'subscription'
    });
    (0, $cozmU.useEffect)(()=>{
        if (skip) {
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(undefined);
        setData(undefined);
        try {
            disposableRef.current = (0, $eqEJl.requestSubscription)(environment, {
                subscription: subscription,
                variables: variables,
                // `RelayWebSocketSubscriptionHandler` reads `cacheConfig.metadata.extensions`
                // and attaches them to the WS payload's `extensions` field.
                // cacheConfig is always set because useMemoObj coerces undefined → {}, so any
                // guard on `extensions` would always evaluate the same way. The consumer
                // (RelayWebSocketSubscriptionHandler) ignores an empty extensions object.
                cacheConfig: {
                    metadata: {
                        extensions: extensions
                    }
                },
                onNext: (response)=>{
                    const { data: responseData } = $c7f06d7e4ea271ae$var$getSubscriptionDataAndExtensions(response);
                    setData(responseData);
                    setError(undefined);
                    setLoading(false);
                    callbacksRef.current?.onSubscriptionData?.($c7f06d7e4ea271ae$export$4966ff7f324f6363(response));
                },
                onError: (err_0)=>{
                    setError($c7f06d7e4ea271ae$var$toApolloErrorInterop(err_0));
                    setLoading(false);
                },
                onCompleted: ()=>{
                    setLoading(false);
                    callbacksRef.current?.onSubscriptionComplete?.();
                }
            });
        } catch (err) {
            setError($c7f06d7e4ea271ae$var$toApolloErrorInterop(err));
            setLoading(false);
        }
        return ()=>{
            if (!disposableRef.current) return;
            disposableRef.current.dispose();
            disposableRef.current = null;
        };
    }, [
        environment,
        subscription,
        variables,
        extensions,
        skip
    ]);
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSubscriptionInterop"] = $c7f06d7e4ea271ae$export$275462b87cef6610;

});

parcelRegister("3vc4U", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $bQm3c = parcelRequire("bQm3c");


var $fSDun = parcelRequire("fSDun");

const $e5d99b79ae0d2558$var$REPLAY_WINDOW_HOURS = 48;
const $e5d99b79ae0d2558$export$d9c46c14618307b6 = ({ contentId: contentId, contentType: contentType, replayCap: replayCap })=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const lastSequenceId = (0, $cozmU.useRef)(Math.floor(new Date().getTime() / 1000));
    const [updateExtensionsTrigger, setUpdateExtensionsTrigger] = (0, $cozmU.useState)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onSubscriptionComplete = (0, $cozmU.useCallback)(()=>{
        setUpdateExtensionsTrigger(updateExtensionsTrigger + 1);
    }, [
        updateExtensionsTrigger,
        setUpdateExtensionsTrigger
    ]);
    const onSubscriptionData = (0, $cozmU.useCallback)((result)=>{
        // update the last received message timestamp with either the messages time or use a best guess from the current time
        lastSequenceId.current = result?.extensions?.sequenceNumber ?? Math.floor(new Date().getTime() / 1000);
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'received',
                actionSubject: 'subscription.event',
                source: 'AGGSubscriptions',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    request_id: result?.extensions?.agg?.request_id || '',
                    traceId: result?.extensions?.traceId || ''
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType
    ]);
    const ari = !contentId || !contentType || !cloudId || !activationId ? '' : (0, $fSDun.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: contentType,
        activationId: activationId,
        resourceId: contentId
    });
    const extensions = (0, $cozmU.useMemo)(()=>{
        const fallbackReplayCapInSeconds = Math.floor((Date.now() - $e5d99b79ae0d2558$var$REPLAY_WINDOW_HOURS * 3600000) / 1000);
        let sequenceNumber;
        if (replayCap !== undefined) sequenceNumber = replayCap;
        else if (lastSequenceId.current < fallbackReplayCapInSeconds) sequenceNumber = fallbackReplayCapInSeconds;
        else sequenceNumber = lastSequenceId.current;
        return updateExtensionsTrigger > 0 ? {
            command: {
                type: 'replay',
                data: {
                    sequenceNumber: sequenceNumber
                }
            }
        } : {};
    }, [
        updateExtensionsTrigger,
        replayCap
    ]);
    return {
        id: ari,
        extensions: extensions,
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData: onSubscriptionData
    };
};
module.exports["useSubscriptionValues"] = $e5d99b79ae0d2558$export$d9c46c14618307b6;

});

parcelRegister("fSDun", function(module, exports) {
// Copied from @confluence/content-types-utils/src/getConfluenceContentAri.ts
/**
 * Resource types where the ARIs include activationIds. This is a pattern
 * that started with Confluence Databases.
 */ const $ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID = [
    'database',
    'embed',
    'folder',
    'slide'
];
const $ad4104a6b6731a94$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ($ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID.includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $ad4104a6b6731a94$export$6a2f2c83863e9bfe;

});

parcelRegister("l1eT4", function(module, exports) {

let $f4d53d45cfd5d893$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f4d53d45cfd5d893$var$load("kY5BF").then(()=>parcelRequire('fUwgh'));

});

parcelRegister("kE2cJ", function(module, exports) {

var $jiJCD = parcelRequire("jiJCD");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");



parcelRequire("gSgn8");


var $9wGTI = parcelRequire("9wGTI");


var $7zgzO = parcelRequire("7zgzO");

const $14c2681824cc07d8$export$7b9b5b70059a466b = ({ href: href = null, name: name, params: params, to: to = null, usePush: usePush = false, forceReload: forceReload = false, reason: reason, skipRouteChange: skipRouteChange = false, excludedQueryParams: excludedQueryParams })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { push: push, replace: replace, toUrl: toUrl, getHash: getHash, getQueryParams: getQueryParams, getHref: getHref, matchRoute: matchRoute } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const getUrl = ()=>{
        const customPath = href || to;
        let parsedUrl = {};
        if (customPath) parsedUrl = (0, $jiJCD.parse)(customPath, true);
        const currentQuery = getQueryParams();
        if (excludedQueryParams && (0, $9wGTI.fg)('confluence_frontend_excluded_query_params_redirect')) excludedQueryParams.forEach((param)=>{
            delete currentQuery[param];
        });
        return toUrl(name, {
            hash: getHash(),
            query: currentQuery,
            ...params,
            ...parsedUrl
        });
    };
    (0, $cozmU.useEffect)(()=>{
        const oldRoute = matchRoute(getHref());
        const oldRouteName = oldRoute?.name || null;
        const getAnalyticsAttributes = ({ newRouteName: newRouteName })=>({
                oldRouteName: oldRouteName,
                newRouteName: newRouteName,
                // It is safe to fire an event with the names of the route params because they are not UGC.
                // They are part of our route definitions. In contrast, the values of the route params are UGC.
                // Additionally, both the names and values of the route query params are UGC because they are
                // read directly from the URL without matching against our route definitions.
                oldRouteParamNames: Object.keys(oldRoute?.params || {}),
                newRouteParamNames: Object.keys(params || {}),
                // Space key related attributes.
                isOldRouteSpaceKeyDefined: !!oldRoute?.params?.spaceKey,
                isNewRouteSpaceKeyDefined: !!params?.spaceKey,
                areSpaceKeysEqual: oldRoute?.params?.spaceKey === params?.spaceKey,
                areSpaceKeysEqualLowercase: oldRoute?.params?.spaceKey?.toLowerCase() === params?.spaceKey?.toLowerCase()
            });
        const doRedirect = ()=>{
            // Reset the delayed content redirection object to avoid unnecessary redirects
            window['__DELAYED_CONTENT_REDIRECTION__'] = {};
            const gottenUrl = getUrl();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'redirect',
                    actionSubject: oldRouteName,
                    actionSubjectId: name || matchRoute(gottenUrl)?.name,
                    source: oldRouteName
                }
            }).fire();
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'redirect',
                    actionSubject: 'route',
                    source: 'Redirection',
                    attributes: getAnalyticsAttributes({
                        newRouteName: name || matchRoute(gottenUrl)?.name
                    })
                }
            }).fire();
            // Skip route change by only rewrite URL
            if (skipRouteChange) try {
                window.history.replaceState({}, '', gottenUrl);
                return;
            } catch  {
            // If replaceState failed, then run the redirect normally
            }
            (usePush ? push : replace)(gottenUrl, forceReload);
        };
        try {
            doRedirect();
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'redirectFailed',
                    actionSubject: 'route',
                    source: 'Redirection',
                    attributes: {
                        ...getAnalyticsAttributes({
                            newRouteName: name
                        }),
                        errorMessage: error?.message
                    }
                }
            }).fire();
            throw error;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
module.exports["Redirection"] = $14c2681824cc07d8$export$7b9b5b70059a466b;

});

parcelRegister("k1GeI", function(module, exports) {

let $e944a9eb606426d9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e944a9eb606426d9$var$load("5zLU3").then(()=>parcelRequire('6nGVD'));

});

parcelRegister("eMS5h", function(module, exports) {

let $ac3f80630bfa0d53$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ac3f80630bfa0d53$var$load("9dZCH").then(()=>parcelRequire('ghOyy'));

});

parcelRegister("5gmpn", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f6b55c9cc88888b7$export$93af822566053b3e = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "GCw5R",
    _reactTreeRootForServerPlaceholderId: true,
    name: 'MainLayout',
    loader: async ()=>(await (parcelRequire("eYCnY"))).MainLayout
});
module.exports["MainLayout"] = $f6b55c9cc88888b7$export$93af822566053b3e;

});

parcelRegister("eYCnY", function(module, exports) {

let $ae7471e168d8b700$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae7471e168d8b700$var$load("4GE9S").then(()=>parcelRequire('cmkWO'));

});

parcelRegister("6pwLK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5vi32 = parcelRequire("5vi32");


var $lJlG6 = parcelRequire("lJlG6");


var $jxpvN = parcelRequire("jxpvN");

const $f91eb48475fb1f4e$export$fce08d0d9d687787 = ({ includeTopNav: includeTopNav, suppressed: suppressed, children: children })=>{
    const { includeTopNav: inheritedOrDefaultValue, suppressed: inheritedSuppressed } = (0, $cozmU.useContext)((0, $jxpvN.BannerContext));
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isMobileApp = (0, $lJlG6.isMobileApp_DO_NOT_USE)();
    if (typeof includeTopNav !== 'boolean') includeTopNav = isEmbeddedConfluence || isMobileApp ? false : inheritedOrDefaultValue;
    // Suppression is inherited so a nested provider cannot accidentally un-suppress a subtree.
    const resolvedSuppressed = suppressed === true || inheritedSuppressed === true;
    const bannerContextValue = (0, $cozmU.useMemo)(()=>({
            includeTopNav: includeTopNav,
            suppressed: resolvedSuppressed
        }), [
        includeTopNav,
        resolvedSuppressed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jxpvN.BannerContext).Provider, {
        value: bannerContextValue
    }, children);
};
module.exports["BannerContextProvider"] = $f91eb48475fb1f4e$export$fce08d0d9d687787;

});

parcelRegister("jxpvN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $205998aae8e9bd72$export$60bd66ed7962b851 = /*#__PURE__*/ (0, $cozmU.createContext)({
    includeTopNav: true
});
$205998aae8e9bd72$export$60bd66ed7962b851.displayName = 'BannerContext';
module.exports["BannerContext"] = $205998aae8e9bd72$export$60bd66ed7962b851;

});

parcelRegister("djZz9", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $38a3bf8a14810337$export$de3a38bd9f6fbd0c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "JEntR",
    name: "SpaceOverviewLoader",
    loader: async ()=>(await (parcelRequire("d9COu"))).SpaceOverview
});

const $38a3bf8a14810337$export$5c3607a122f4ef5a = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "AGreW",
    name: "SpaceOverviewSwitcherLoader",
    loader: async ()=>(await (parcelRequire("jJQTD"))).SpaceOverviewSwitcher
});
module.exports["SpaceOverviewLoader"] = $38a3bf8a14810337$export$de3a38bd9f6fbd0c;
module.exports["SpaceOverviewSwitcherLoader"] = $38a3bf8a14810337$export$5c3607a122f4ef5a;

});

parcelRegister("d9COu", function(module, exports) {

let $993a39283a500243$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $993a39283a500243$var$load("kT6dz"),
    $993a39283a500243$var$load("bPC3R"),
    $993a39283a500243$var$load("bHb1X"),
    $993a39283a500243$var$load("4UHov"),
    $993a39283a500243$var$load("86OhX"),
    $993a39283a500243$var$load("3pUic"),
    $993a39283a500243$var$load("yIsjX"),
    $993a39283a500243$var$load("4CyIY"),
    $993a39283a500243$var$load("2F69B"),
    $993a39283a500243$var$load("iY1NC"),
    $993a39283a500243$var$load("53Y0O"),
    $993a39283a500243$var$load("kYlwR"),
    $993a39283a500243$var$load("1tqsw"),
    $993a39283a500243$var$load("8yk9S"),
    $993a39283a500243$var$load("ezYRV"),
    $993a39283a500243$var$load("eNgZ8"),
    $993a39283a500243$var$load("lAHCT"),
    $993a39283a500243$var$load("8d6BA"),
    $993a39283a500243$var$load("ksOjm"),
    $993a39283a500243$var$load("jAsJw"),
    $993a39283a500243$var$load("jisiR"),
    $993a39283a500243$var$load("icVON"),
    $993a39283a500243$var$load("90SZm"),
    $993a39283a500243$var$load("crfrC"),
    $993a39283a500243$var$load("7gL7H"),
    $993a39283a500243$var$load("aNyWk"),
    $993a39283a500243$var$load("gSKF7"),
    $993a39283a500243$var$load("iTOzX"),
    $993a39283a500243$var$load("ipkwd"),
    $993a39283a500243$var$load("a7sEM"),
    $993a39283a500243$var$load("6gMrU"),
    $993a39283a500243$var$load("iECXC"),
    $993a39283a500243$var$load("5dkX4"),
    $993a39283a500243$var$load("h5t0Y"),
    $993a39283a500243$var$load("4Gdnz"),
    $993a39283a500243$var$load("4UAag"),
    $993a39283a500243$var$load("zUKwV"),
    $993a39283a500243$var$load("fUeur"),
    $993a39283a500243$var$load("1JeTB"),
    $993a39283a500243$var$load("6wr18"),
    $993a39283a500243$var$load("3fdX4"),
    $993a39283a500243$var$load("VYd77"),
    $993a39283a500243$var$load("9Oxea"),
    $993a39283a500243$var$load("b0ARW"),
    $993a39283a500243$var$load("cxCk7"),
    $993a39283a500243$var$load("7SteV"),
    $993a39283a500243$var$load("dxcsb"),
    $993a39283a500243$var$load("ffEVr"),
    $993a39283a500243$var$load("Wowvf"),
    $993a39283a500243$var$load("4g6rd"),
    $993a39283a500243$var$load("fq1gG"),
    $993a39283a500243$var$load("hhss7"),
    $993a39283a500243$var$load("7EorR"),
    $993a39283a500243$var$load("1gUNx"),
    $993a39283a500243$var$load("e66P8")
]).then(()=>parcelRequire('eiWUW'));

});

parcelRegister("jJQTD", function(module, exports) {

let $e5eb406b192b07db$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e5eb406b192b07db$var$load("hUbK8"),
    $e5eb406b192b07db$var$load("agVmZ"),
    $e5eb406b192b07db$var$load("ca0UP"),
    $e5eb406b192b07db$var$load("a92TB"),
    $e5eb406b192b07db$var$load("kT6dz"),
    $e5eb406b192b07db$var$load("bPC3R"),
    $e5eb406b192b07db$var$load("bHb1X"),
    $e5eb406b192b07db$var$load("4UHov"),
    $e5eb406b192b07db$var$load("86OhX"),
    $e5eb406b192b07db$var$load("3pUic"),
    $e5eb406b192b07db$var$load("yIsjX"),
    $e5eb406b192b07db$var$load("4CyIY"),
    $e5eb406b192b07db$var$load("2F69B"),
    $e5eb406b192b07db$var$load("iY1NC"),
    $e5eb406b192b07db$var$load("53Y0O"),
    $e5eb406b192b07db$var$load("kYlwR"),
    $e5eb406b192b07db$var$load("1tqsw"),
    $e5eb406b192b07db$var$load("8yk9S"),
    $e5eb406b192b07db$var$load("ezYRV"),
    $e5eb406b192b07db$var$load("eNgZ8"),
    $e5eb406b192b07db$var$load("lAHCT"),
    $e5eb406b192b07db$var$load("8d6BA"),
    $e5eb406b192b07db$var$load("ksOjm"),
    $e5eb406b192b07db$var$load("jAsJw"),
    $e5eb406b192b07db$var$load("jisiR"),
    $e5eb406b192b07db$var$load("icVON"),
    $e5eb406b192b07db$var$load("90SZm"),
    $e5eb406b192b07db$var$load("crfrC"),
    $e5eb406b192b07db$var$load("7gL7H"),
    $e5eb406b192b07db$var$load("aNyWk"),
    $e5eb406b192b07db$var$load("gSKF7"),
    $e5eb406b192b07db$var$load("iTOzX"),
    $e5eb406b192b07db$var$load("ipkwd"),
    $e5eb406b192b07db$var$load("a7sEM"),
    $e5eb406b192b07db$var$load("6gMrU"),
    $e5eb406b192b07db$var$load("iECXC"),
    $e5eb406b192b07db$var$load("5dkX4"),
    $e5eb406b192b07db$var$load("e66P8"),
    $e5eb406b192b07db$var$load("h5t0Y"),
    $e5eb406b192b07db$var$load("4Gdnz"),
    $e5eb406b192b07db$var$load("4UAag"),
    $e5eb406b192b07db$var$load("zUKwV"),
    $e5eb406b192b07db$var$load("fUeur"),
    $e5eb406b192b07db$var$load("1JeTB"),
    $e5eb406b192b07db$var$load("6wr18"),
    $e5eb406b192b07db$var$load("3fdX4"),
    $e5eb406b192b07db$var$load("VYd77"),
    $e5eb406b192b07db$var$load("9Oxea"),
    $e5eb406b192b07db$var$load("b0ARW"),
    $e5eb406b192b07db$var$load("cxCk7"),
    $e5eb406b192b07db$var$load("7SteV"),
    $e5eb406b192b07db$var$load("dxcsb"),
    $e5eb406b192b07db$var$load("ffEVr"),
    $e5eb406b192b07db$var$load("Wowvf"),
    $e5eb406b192b07db$var$load("4g6rd"),
    $e5eb406b192b07db$var$load("fq1gG"),
    $e5eb406b192b07db$var$load("hhss7"),
    $e5eb406b192b07db$var$load("7EorR"),
    $e5eb406b192b07db$var$load("1gUNx"),
    $e5eb406b192b07db$var$load("7J0Jt")
]).then(()=>parcelRequire('2m4WS'));

});

parcelRegister("iqPBi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $KDAt0 = parcelRequire("KDAt0");


var $5X6fy = parcelRequire("5X6fy");


var $9DHhW = parcelRequire("9DHhW");


var $6mKj3 = parcelRequire("6mKj3");


var $dPJCf = parcelRequire("dPJCf");


var $1ytiN = parcelRequire("1ytiN");


var $fM6x5 = parcelRequire("fM6x5");


var $cEgMD = parcelRequire("cEgMD");


var $8oCjN = parcelRequire("8oCjN");


var $4b4iP = parcelRequire("4b4iP");


var $j9XVO = parcelRequire("j9XVO");

const $023f02fd9a9aead0$var$DISPLAY_ROOT = 'display';
const $023f02fd9a9aead0$var$SPACE_ROOT = 'spaces';
const $023f02fd9a9aead0$var$getUrlRoot = (pathname)=>{
    if (!pathname) return undefined;
    if (pathname.includes(`/${$023f02fd9a9aead0$var$SPACE_ROOT}/`)) return $023f02fd9a9aead0$var$SPACE_ROOT;
    else if (pathname.includes(`/${$023f02fd9a9aead0$var$DISPLAY_ROOT}/`)) return $023f02fd9a9aead0$var$DISPLAY_ROOT;
    else return undefined;
};
const $023f02fd9a9aead0$var$useContentSlug = (0, $dPJCf.createRouteParamHook)('contentSlug');
const $023f02fd9a9aead0$var$useContentId = (0, $dPJCf.createRouteParamHook)('contentId');
const $023f02fd9a9aead0$var$LegacySpaceBaseComponent = ({ children: children, spaceKey: spaceKey, space: space, isSpaceLoading: isSpaceLoading })=>{
    const contentId = $023f02fd9a9aead0$var$useContentId();
    const contentSlug = $023f02fd9a9aead0$var$useContentSlug();
    const isViewPage = !!contentId || !!contentSlug;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { isAnonymous: isAnonymous } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const history = (0, $dPJCf.useHistory)();
    const isFirstRoute = history?.length === 1;
    const location = (0, $KDAt0.useLocation)();
    const fixSpaceEncodingInSpaceKey = ()=>{
        const pathname = location?.pathname || '';
        const decodedPathname = decodeURIComponent(pathname);
        if (// excludes the cases where there are no + symbols to replace at all
        // eg: /spaces/perfectly-fine-space-key
        pathname.indexOf('+') !== -1 && // excludes the cases where there is a + that follows the space key portion of the path
        // eg: /spaces/DS/other+stuff+that+contains+plus
        spaceKey.indexOf('+') !== -1 && // excludes the cases where the decoded path name still contains a + (from %2B)
        // , but the replacement to strip the + from the space key has already happened in previous SPA transition
        // eg: pathname = '/spaces/space%2Bkey', decodedPathname = '/spaces/space+key', spaceKey = 'space+key'
        decodedPathname.indexOf(`spaces/${spaceKey}`) !== -1) history?.replace?.({
            ...location,
            // Ensure we are replacing the "+" in the space key not other funny stuff
            pathname: decodedPathname.replace(`spaces/${spaceKey}`, `spaces/${spaceKey}`.replace(/\+/g, ' '))
        });
    };
    const removeEmailQueryParameters = ()=>{
        if (!location?.search?.includes('src=mail') && !location?.search?.includes('src.mail.')) return;
        let search = location?.search?.substring(1);
        const params = search.split('&').filter((param)=>!param.includes('src=mail') && !param.startsWith('src.mail.'));
        search = `?${params.join('&')}`;
        history?.replace?.({
            ...location,
            search: search
        });
    };
    (0, $cozmU.useEffect)(()=>{
        fixSpaceEncodingInSpaceKey();
        removeEmailQueryParameters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        spaceKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isSpaceLoading) return;
        if (space && space.alias && space.alias !== spaceKey) {
            const pathnameRoot = $023f02fd9a9aead0$var$getUrlRoot(location?.pathname);
            if (pathnameRoot) {
                const routeName = routeDataRef.current?.routeName || null;
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'redirect',
                        actionSubject: 'route',
                        source: 'SpaceBase',
                        attributes: {
                            routeName: routeName,
                            // Space key related attributes.
                            areSpaceKeysEqualLowercase: space?.alias?.toLowerCase() === spaceKey?.toLowerCase()
                        }
                    }
                }).fire();
                history?.replace?.({
                    ...location,
                    pathname: location?.pathname?.replace(`/${pathnameRoot}/${spaceKey}`, `/${pathnameRoot}/${space.alias}`)
                });
            }
            return;
        }
    }, [
        createAnalyticsEvent,
        history,
        location,
        space,
        spaceKey,
        routeDataRef,
        isSpaceLoading
    ]);
    /*
   * Removing SpaceBaseThemedComponent for the Company Hub app-like experience
   *
   * @see {@link https://www.figma.com/design/MBdUXhdmgbsIkMkOhQGu5e/Hub-App?node-id=101-52260}
   * @see {@link https://hello.atlassian.net/wiki/spaces/CLI/pages/4856024337/Confluence-less+Team+25+US+Experience}
   */ const SpaceBaseWrapper = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) ? (0, $cozmU.Fragment) : (0, $8oCjN.SpaceBaseThemedComponent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4b4iP.SpaceRestrictionHandler), {
        spaceKey: spaceKey,
        isAnonymous: isAnonymous,
        contentId: contentId,
        isFirstRoute: isFirstRoute,
        goBackPreviousPage: history?.goBack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "space-base-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))({
            'wrapper-space-view-page': isViewPage,
            'wrapper-space-home-page': !isViewPage
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SpaceBaseWrapper, null, children)));
};
const $023f02fd9a9aead0$var$SpaceBaseComponent = ({ children: children, spaceKey: spaceKey, space: space, isSpaceLoading: isSpaceLoading })=>{
    const contentId = $023f02fd9a9aead0$var$useContentId();
    const contentSlug = $023f02fd9a9aead0$var$useContentSlug();
    const isViewPage = !!contentId || !!contentSlug;
    const { isAnonymous: isAnonymous } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    // We cannot use useRenderServerPlaceholder() here
    // because SpaceBaseComponent is invoked through withDocumentTitle's inline
    // function pattern, which breaks hooks during renderToString.
    // The !isTransition check ensures SPA navigations always take the SPA branch,
    // matching the pattern in useRenderServerPlaceholder.
    const isTransition = window.__SSR_RENDERED__ === false;
    const isSSROrHydrating = (0, $6mKj3.expVal)('confluence_hydration_with_document_title_fix', 'isEnabled', false) ? // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    Boolean(undefined) || Boolean(window.__HYDRATABLE__) && !isTransition : // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    Boolean(undefined);
    if (isSSROrHydrating && (0, $6mKj3.expVal)('confluence_frontend_ssr_space_not_found', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4b4iP.SpaceRestrictionHandler), {
        spaceKey: spaceKey,
        isAnonymous: isAnonymous,
        contentId: contentId,
        goBackPreviousPage: ()=>{}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "space-base-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))({
            'wrapper-space-view-page': isViewPage,
            'wrapper-space-home-page': !isViewPage
        })
    }, children));
    else if (isSSROrHydrating) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "space-base-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))({
            'wrapper-space-view-page': isViewPage,
            'wrapper-space-home-page': !isViewPage
        })
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($023f02fd9a9aead0$var$LegacySpaceBaseComponent, {
        spaceKey: spaceKey,
        space: space,
        isSpaceLoading: isSpaceLoading
    }, children);
};
const $023f02fd9a9aead0$var$useSpaceKey = (0, $dPJCf.createRouteParamHook)('spaceKey');
const $023f02fd9a9aead0$export$adbf61121b32bd9b = ({ children: children, spaceKey: spaceKey })=>{
    const resolvedSpaceKey = $023f02fd9a9aead0$var$useSpaceKey() || spaceKey || '';
    const { space: space, loading: loading } = (0, $j9XVO.useSpaceBaseQuery)({
        resolvedSpaceKey: resolvedSpaceKey
    });
    return (0, $fM6x5.default)(()=>space?.name)($023f02fd9a9aead0$var$SpaceBaseComponent)({
        spaceKey: resolvedSpaceKey,
        space: space,
        children: children,
        isSpaceLoading: loading
    });
};
module.exports["SpaceBase"] = $023f02fd9a9aead0$export$adbf61121b32bd9b;

});

parcelRegister("fM6x5", function(module, exports) {
$parcel$export(module.exports, "default", () => $6436abe84fc91b7d$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $8EsbU = parcelRequire("8EsbU");


var $d5RCH = parcelRequire("d5RCH");

function $6436abe84fc91b7d$export$2e2bcd8739ae039(getTitle, wrapperStyle) {
    if (typeof wrapperStyle === 'undefined') wrapperStyle = {};
    return (BaseComponent)=>(props)=>{
            const title = getTitle(props);
            const siteTitle = (0, $8EsbU.getOverride)('site-title') || '';
            const titleDefinedOnWindow = window['__DOCUMENT_TITLE_TAG__'] || '';
            let titleProp;
            if (titleDefinedOnWindow) titleProp = titleDefinedOnWindow;
            else if (title && siteTitle) titleProp = `${title} - ${siteTitle}`;
            else titleProp = title || siteTitle;
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                style: wrapperStyle,
                "data-testid": "with-document-title"
            }, !window['__SSR_RENDERED__'] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5RCH.PageTitle), {
                title: titleProp
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BaseComponent, props)));
        };
}

});

parcelRegister("d5RCH", function(module, exports) {
function $69aebb91e74cbedb$export$155581e8dc02007a({ title: title }) {
    // document.title is safe to set during render:
    // - It's idempotent (setting the same value multiple times is safe)
    // - It doesn't trigger React re-renders
    // - Many React libraries do this (react-helmet, react-document-title, etc.)
    // - It's a browser API, not React state, so it doesn't violate React's rules
    // - The last component to render will have its title set, avoiding race conditions
    if (typeof document !== 'undefined' && title) document.title = title;
    return null;
}
module.exports["PageTitle"] = $69aebb91e74cbedb$export$155581e8dc02007a;

});

parcelRegister("8oCjN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $lKNXy = parcelRequire("lKNXy");


var $f9opb = parcelRequire("f9opb");

var $jgc4t = parcelRequire("jgc4t");


var $7zgzO = parcelRequire("7zgzO");


var $ep3mz = parcelRequire("ep3mz");


var $1NBp8 = parcelRequire("1NBp8");


var $3Klda = parcelRequire("3Klda");


var $5ZqQS = parcelRequire("5ZqQS");


var $7Sm4c = parcelRequire("7Sm4c");


var $3IBnw = parcelRequire("3IBnw");


var $fyPYm = parcelRequire("fyPYm");


var $6mKj3 = parcelRequire("6mKj3");


var $fwscq = parcelRequire("fwscq");


var $eSlm6 = parcelRequire("eSlm6");

const $7bbee5da9ba28ec8$var$connectAddonContainerStyle = {
    position: 'relative'
};
const $7bbee5da9ba28ec8$var$connectAddonProps = {
    contentStyle: {
        width: '100%',
        textAlign: 'center',
        display: 'inline-block'
    },
    width: '100%',
    height: '100%'
};
const $7bbee5da9ba28ec8$var$SPACE_THEME_KEY_MODULE_KEY_REGEX = /^ac:(.*)__(.*)-remote-theme$/;
const $7bbee5da9ba28ec8$export$3d1ab4d62a569dc7 = (themeKey)=>{
    const regexResult = $7bbee5da9ba28ec8$var$SPACE_THEME_KEY_MODULE_KEY_REGEX.exec(themeKey);
    return regexResult ? [
        regexResult[1],
        regexResult[2]
    ] : [
        null,
        null
    ];
};
const $7bbee5da9ba28ec8$export$7f576b861c4a75d4 = ({ children: children })=>{
    const { match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const [{ contentIdLoading: contentIdLoading }] = (0, $ep3mz.usePageState)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const isBlogpost = contentType === 'blogpost';
    const isSpaceOverview = match?.name === (0, $1NBp8.SPACE_OVERVIEW).name;
    const skipContentQuery = !contentId || !spaceKey || !isSpaceOverview || contentIdLoading;
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(window.__SSR_RENDERED__);
    const pageContentQueryResult = (0, $jMyy4.useQueryInterop)((0, $jgc4t.default), {
        context: {
            single: true
        },
        variables: {
            contentId: contentId ?? '',
            spaceKey: spaceKey,
            versionOverride: null,
            isSSR: isSSR,
            useNewContentTopper: true
        },
        skip: skipContentQuery || isBlogpost,
        __callerPackage__: "space-base"
    });
    const blogContentQueryResult = (0, $jMyy4.useQueryInterop)((0, $f9opb.default), {
        context: {
            single: true
        },
        variables: {
            contentId: contentId ?? '',
            spaceKey: spaceKey,
            isSSR: isSSR,
            versionOverride: null,
            useNewContentTopper: true
        },
        skip: skipContentQuery || !isBlogpost,
        __callerPackage__: "space-base"
    });
    const contentQueryResult = isBlogpost ? blogContentQueryResult : pageContentQueryResult;
    const themeKey = contentQueryResult?.data?.space?.theme?.themeKey;
    const routeOverrideEnabled = contentQueryResult?.data?.space?.settings?.routeOverrideEnabled;
    const [themeAddonKey, themeModuleKey] = $7bbee5da9ba28ec8$export$3d1ab4d62a569dc7(themeKey ?? '');
    const skipOverrideQuery = !themeAddonKey || !themeModuleKey || !routeOverrideEnabled;
    const overrideQueryResult = (0, $eSlm6.useExperimentalThemeSpaceHomeOverrideQuery)({
        variables: {
            themeAddonKey: themeAddonKey,
            themeModuleKey: themeModuleKey,
            spaceKey: spaceKey || '',
            spaceHomePageId: contentId || ''
        },
        skip: skipOverrideQuery
    });
    const productCtx = overrideQueryResult.data?.experimentalThemeSpaceHomeOverride?.spaceHomeOverrideDescriptor?.productCtx;
    const productContext = (0, $cozmU.useMemo)(()=>productCtx ? JSON.parse(productCtx) : undefined, [
        productCtx
    ]);
    if (contentQueryResult.error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(contentQueryResult.error, {
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        });
        (0, $7Sm4c.markErrorAsHandled)(contentQueryResult.error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
    }
    if (overrideQueryResult.error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(overrideQueryResult.error, {
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        });
        (0, $7Sm4c.markErrorAsHandled)(overrideQueryResult.error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
    }
    if (contentIdLoading) return null;
    if (skipContentQuery) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
    if (contentQueryResult.loading || !skipOverrideQuery && overrideQueryResult.loading) return null;
    if (skipOverrideQuery) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
    if (!contentQueryResult.data || !overrideQueryResult.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
    const { hasSpaceHomeOverride: hasSpaceHomeOverride, spaceHomeOverrideDescriptor: spaceHomeOverrideDescriptor } = overrideQueryResult.data.experimentalThemeSpaceHomeOverride;
    if (!hasSpaceHomeOverride || !spaceHomeOverrideDescriptor) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
    // Ensure required fields are present for ConnectAddonDescriptor
    if (!spaceHomeOverrideDescriptor.addon_key || !spaceHomeOverrideDescriptor.key || !spaceHomeOverrideDescriptor.url || !spaceHomeOverrideDescriptor.contextJwt || !spaceHomeOverrideDescriptor.structuredContext || !spaceHomeOverrideDescriptor.productCtx) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
    const descriptor = {
        addon_key: spaceHomeOverrideDescriptor.addon_key,
        key: spaceHomeOverrideDescriptor.key,
        url: spaceHomeOverrideDescriptor.url,
        contextJwt: spaceHomeOverrideDescriptor.contextJwt,
        structuredContext: spaceHomeOverrideDescriptor.structuredContext,
        productContext: productContext
    };
    // When the metric flag is off, preserve the original render tree exactly: a
    // Fragment containing the background layer and a plain ConnectAddon (no
    // experience tracking, no iframe lifecycle callbacks).
    if (!(0, $6mKj3.expVal)('confluence_enable_connect_group_6_metrics', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Klda.ContentScreenBackgroundLayer), {
        lookAndFeel: contentQueryResult?.data?.space?.lookAndFeel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lKNXy.ConnectAddon), {
        containerStyle: $7bbee5da9ba28ec8$var$connectAddonContainerStyle,
        descriptor: descriptor,
        ...$7bbee5da9ba28ec8$var$connectAddonProps
    }), isSpaceOverview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fyPYm.ContentViewedEvent), {
        contentId: contentId
    }));
    // When the flag is on, route through ConnectThemeRenderer which tracks the
    // CONNECT_THEME_RENDER_EXPERIENCE via the Connect iframe lifecycle callbacks.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7bbee5da9ba28ec8$var$ConnectThemeRenderer, {
        descriptor: descriptor,
        addonKey: themeAddonKey,
        moduleKey: themeModuleKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Klda.ContentScreenBackgroundLayer), {
        lookAndFeel: contentQueryResult?.data?.space?.lookAndFeel
    }), isSpaceOverview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fyPYm.ContentViewedEvent), {
        contentId: contentId
    }));
};
/**
 * Renders the remote theme via ConnectAddon and tracks the
 * CONNECT_THEME_RENDER_EXPERIENCE for the "Connect themes" capability (Group 6 of
 * the @ecosystem Feature Test Migration), gated behind the
 * `confluence_enable_connect_group_6_metrics` experiment.
 *
 * Mirrors the canonical ConnectCustomContentIframe lifecycle: start on render,
 * succeed/fail via the Connect iframe callbacks, and abort on unmount if the
 * experience started but never resolved.
 */ const $7bbee5da9ba28ec8$var$ConnectThemeRenderer = ({ children: children, descriptor: descriptor, addonKey: addonKey, moduleKey: moduleKey })=>{
    const experienceStartedRef = (0, $cozmU.useRef)(false);
    const experienceResolvedRef = (0, $cozmU.useRef)(false);
    // Note: this component is only rendered when the
    // `confluence_enable_connect_group_6_metrics` flag is on (gated at the call
    // site in SpaceBaseThemedComponent), so no flag check is needed here.
    const startExperienceIfNeeded = (0, $cozmU.useCallback)(()=>{
        const extension = {
            addonKey: addonKey,
            moduleKey: moduleKey
        };
        if (!(0, $fwscq.ThemeExperienceTrackerSupport).isTrackable(extension)) return false;
        if (!experienceStartedRef.current) {
            (0, $fwscq.ThemeExperienceTrackerSupport).start(extension);
            experienceStartedRef.current = true;
        }
        return true;
    }, [
        addonKey,
        moduleKey
    ]);
    const onIframeEstablished = (0, $cozmU.useCallback)(()=>{
        if (startExperienceIfNeeded() && !experienceResolvedRef.current) {
            (0, $fwscq.ThemeExperienceTrackerSupport).succeed();
            experienceResolvedRef.current = true;
        }
    }, [
        startExperienceIfNeeded
    ]);
    const onIframeTimeout = (0, $cozmU.useCallback)(()=>{
        if (startExperienceIfNeeded() && !experienceResolvedRef.current) {
            (0, $fwscq.ThemeExperienceTrackerSupport).fail('Connect theme iframe timeout');
            experienceResolvedRef.current = true;
        }
    }, [
        startExperienceIfNeeded
    ]);
    const onIframeFailedToLoad = (0, $cozmU.useCallback)(()=>{
        if (startExperienceIfNeeded() && !experienceResolvedRef.current) {
            (0, $fwscq.ThemeExperienceTrackerSupport).fail('Connect theme iframe failed to load');
            experienceResolvedRef.current = true;
        }
    }, [
        startExperienceIfNeeded
    ]);
    // Start the experience as soon as we render the theme.
    (0, $cozmU.useEffect)(()=>{
        startExperienceIfNeeded();
    }, [
        startExperienceIfNeeded
    ]);
    // Abort if the component unmounts before the render experience resolves.
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (experienceStartedRef.current && !experienceResolvedRef.current) (0, $fwscq.ThemeExperienceTrackerSupport).abort('SpaceBaseThemedComponent unmounted before theme render experience resolved');
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lKNXy.ConnectAddon), {
        containerStyle: $7bbee5da9ba28ec8$var$connectAddonContainerStyle,
        descriptor: descriptor,
        onIframeEstablished: onIframeEstablished,
        onIframeTimeout: onIframeTimeout,
        onIframeFailedToLoad: onIframeFailedToLoad,
        ...$7bbee5da9ba28ec8$var$connectAddonProps
    }));
};
module.exports["SpaceBaseThemedComponent"] = $7bbee5da9ba28ec8$export$7f576b861c4a75d4;

});

parcelRegister("lKNXy", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");


const $d2cf06290ddd4b8d$export$1679e39403bb0c0c = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rJ3Sr",
    loader: async ()=>(await (parcelRequire("ar4g0"))).ConnectAddon,
    name: 'ConnectAddonNext'
});
module.exports["ConnectAddon"] = $d2cf06290ddd4b8d$export$1679e39403bb0c0c;

});

parcelRegister("ar4g0", function(module, exports) {

let $798fba5ba3f9bf38$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $798fba5ba3f9bf38$var$load("fWCBZ"),
    $798fba5ba3f9bf38$var$load("lK9vp"),
    $798fba5ba3f9bf38$var$load("Wowvf"),
    $798fba5ba3f9bf38$var$load("6d83I")
]).then(()=>parcelRequire('2uezU'));

});

parcelRegister("3Klda", function(module, exports) {

var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");

const $2ba61f17a8768eba$var$screenLayerStyles = {
    display: 'block',
    position: 'absolute',
    width: '100%',
    top: 0,
    left: 0,
    height: 250
};
class $2ba61f17a8768eba$export$e0e5b47f08900b58 extends (0, $cozmU.Component) {
    render() {
        const { lookAndFeel: lookAndFeel } = this.props;
        if (!lookAndFeel || !lookAndFeel.content) return null;
        const customScreenLayerStyles = lookAndFeel?.content?.screen?.layer || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "content-screen-background-layer",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                ...$2ba61f17a8768eba$var$screenLayerStyles,
                ...customScreenLayerStyles
            }
        });
    }
}
$2ba61f17a8768eba$export$e0e5b47f08900b58.propTypes = {
    lookAndFeel: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object
};
module.exports["ContentScreenBackgroundLayer"] = $2ba61f17a8768eba$export$e0e5b47f08900b58;

});

parcelRegister("fyPYm", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bavCP = parcelRequire("bavCP");


var $eyzLS = parcelRequire("eyzLS");

let $701bdc3764047e40$var$lastContentId;
const $701bdc3764047e40$export$cc2fc38458ee98cc = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { contentId: contentId } = t0;
    let t1;
    let t2;
    if ($[0] !== contentId) {
        t1 = ()=>{
            $701bdc3764047e40$var$lastContentId = contentId;
        };
        t2 = [
            contentId
        ];
        $[0] = contentId;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] !== contentId) {
        t3 = {
            contentId: contentId
        };
        $[3] = contentId;
        $[4] = t3;
    } else t3 = $[4];
    const t4 = $701bdc3764047e40$var$lastContentId === contentId;
    let t5;
    if ($[5] !== t3 || $[6] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
            query: (0, $eyzLS.default),
            variables: t3,
            fetchPolicy: "network-only",
            skip: t4,
            __callerPackage__: "content-body"
        }, $701bdc3764047e40$var$_temp);
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
};
function $701bdc3764047e40$var$_temp() {
    return null;
}
module.exports["ContentViewedEvent"] = $701bdc3764047e40$export$cc2fc38458ee98cc;

});

parcelRegister("bavCP", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $jMyy4 = parcelRequire("jMyy4");

const $86f32d96feea2a1f$export$67f105fad14d18d = (0, $3u0dr.isReactCompilerActiveV2)() ? function QueryInterop(t0) {
    const $ = (0, $bDgLe.c)(7);
    let children;
    let props;
    let query;
    if ($[0] !== t0) {
        ({ children: children, query: query, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
        $[3] = query;
    } else {
        children = $[1];
        props = $[2];
        query = $[3];
    }
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    let t1;
    if ($[4] !== children || $[5] !== result) {
        t1 = children(result);
        $[4] = children;
        $[5] = result;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : function QueryInterop({ children: children, query: query, ...props }) {
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    return children(result);
};
module.exports["QueryInterop"] = $86f32d96feea2a1f$export$67f105fad14d18d;

});

parcelRegister("eyzLS", function(module, exports) {
/**
 * @generated SignedSource<<b170f4062a7b22df5c789ae2263ec5d9>>
 * @relayHash 6b82c836e177933e272ade59efcd5b5c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6442e1d626bb37ef4897bdc166747bc6f6f93f7d888574ea37d7d5521fde4b42
const $ac80f5dc8fd0c04e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "trigger",
                    "value": "viewed"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentViewedEventQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentViewedEventQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "6b82c836e177933e272ade59efcd5b5c",
            "id": "6442e1d626bb37ef4897bdc166747bc6f6f93f7d888574ea37d7d5521fde4b42",
            "metadata": {},
            "name": "ContentViewedEventQuery",
            "operationKind": "query",
            "text": "query ContentViewedEventQuery($contentId:ID){content(id:$contentId,trigger:\"viewed\"){nodes{id}}}"
        }
    };
}();
$ac80f5dc8fd0c04e$var$node.hash = "d8b1d8e3bca16082db7c9284db04b505";
var $ac80f5dc8fd0c04e$export$2e2bcd8739ae039 = $ac80f5dc8fd0c04e$var$node;
module.exports["default"] = $ac80f5dc8fd0c04e$export$2e2bcd8739ae039;

});

parcelRegister("fwscq", function(module, exports) {

var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");

const $e3580b2eccf81d32$var$getError = (messageOrError)=>{
    if (messageOrError instanceof Error) return messageOrError;
    return new Error(messageOrError);
};
const $e3580b2eccf81d32$export$570932507afcc1e1 = new class ThemeExperienceTrackerSupport {
    isTrackable(extension) {
        return Boolean(extension?.addonKey) && Boolean(extension?.moduleKey);
    }
    start(extension) {
        (0, $fGzMp.getExperienceTracker)().start({
            name: (0, $irVI7.CONNECT_THEME_RENDER_EXPERIENCE),
            attributes: {
                addonKey: extension?.addonKey,
                moduleKey: extension?.moduleKey
            }
        });
    }
    succeed() {
        (0, $fGzMp.getExperienceTracker)().succeed({
            name: (0, $irVI7.CONNECT_THEME_RENDER_EXPERIENCE)
        });
    }
    fail(messageOrError) {
        (0, $fGzMp.getExperienceTracker)().fail({
            name: (0, $irVI7.CONNECT_THEME_RENDER_EXPERIENCE),
            error: $e3580b2eccf81d32$var$getError(messageOrError)
        });
    }
    abort(reason) {
        (0, $fGzMp.getExperienceTracker)().abort({
            name: (0, $irVI7.CONNECT_THEME_RENDER_EXPERIENCE),
            reason: reason
        });
    }
}();
module.exports["ThemeExperienceTrackerSupport"] = $e3580b2eccf81d32$export$570932507afcc1e1;

});

parcelRegister("eSlm6", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $aBfpe = parcelRequire("aBfpe");

const $d5f5bff41df6d94f$export$aa603d43549e91b7 = ({ skip: skip, variables: variables })=>{
    const { themeAddonKey: themeAddonKey, themeModuleKey: themeModuleKey, spaceKey: spaceKey, spaceHomePageId: spaceHomePageId } = variables;
    return (0, $dK51B.useExperimentalQuery)({
        url: ()=>{
            if (!themeAddonKey || !themeModuleKey) // This will be handled by parseResponseOnError to return expected data when these keys are missing
            throw new Error('themeAddonKey and themeModuleKey are missing');
            return `/wiki/plugins/servlet/ac/${themeAddonKey}/${themeModuleKey}/?classifier=json&space.key=${spaceKey}&content.id=${spaceHomePageId}&content.type=page`;
        },
        method: 'GET',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResponseOnError: ()=>null,
        parseResult: (data)=>({
                experimentalThemeSpaceHomeOverride: {
                    hasSpaceHomeOverride: data !== null,
                    spaceHomeOverrideDescriptor: data
                }
            }),
        skip: skip,
        variables: variables
    });
};
module.exports["useExperimentalThemeSpaceHomeOverrideQuery"] = $d5f5bff41df6d94f$export$aa603d43549e91b7;

});

parcelRegister("dK51B", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1GTIR = parcelRequire("1GTIR");


var $fqCbQ = parcelRequire("fqCbQ");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");

function $7ac155b86059b716$export$9a41df5b9f27a628({ url: url, method: method, headers: headers, body: body, variables: variables, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError
    });
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    return $7ac155b86059b716$export$defacdf98710c90a({
        key: key,
        fetchData: fetchData,
        variables: variables,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        skip: skip,
        fetchPolicy: fetchPolicy,
        pollInterval: pollInterval
    });
}
function $7ac155b86059b716$export$defacdf98710c90a({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    const { queryState: queryState, execute: execute, refetch: refetch, stopPolling: stopPolling } = (0, $fqCbQ.useExperimentalQueryExecution)({
        key: key,
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        fetchPolicy: fetchPolicy,
        isLazyQuery: false,
        pollInterval: pollInterval,
        isSSR: isSSR
    });
    (0, $cozmU.useEffect)(()=>{
        // Edit Page uses JSDOM, so effects run in SSR. Experimental queries should not execute during SSR
        if (!skip && !isSSR) execute();
    }, [
        execute,
        key,
        skip,
        fetchPolicy,
        isSSR
    ]);
    // If skip is true, return idle state with refetch
    if (skip) return {
        ...(0, $7ji4X.INITIAL_IDLE_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
    // Use store state if available, otherwise return initial loading state with refetch
    // (stable reference prevents extra renders before query executes)
    return queryState ? {
        ...queryState,
        refetch: refetch,
        stopPolling: stopPolling
    } : {
        ...(0, $7ji4X.INITIAL_LOADING_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQuery"] = $7ac155b86059b716$export$9a41df5b9f27a628;
module.exports["useExperimentalQueryBase"] = $7ac155b86059b716$export$defacdf98710c90a;

});

parcelRegister("1GTIR", function(module, exports) {

var $26Yfd = parcelRequire("26Yfd");


var $GLgaM = parcelRequire("GLgaM");

// Allows using variables from either the mutate call or initial hook call
// Follows Apollo Client behavior: only falls back when variables is undefined, not empty object
const $e94116a19c839dfc$var$resolveVariables = (localVariables, fallbackVariables)=>{
    return localVariables !== undefined ? localVariables : fallbackVariables ?? {};
};
const $e94116a19c839dfc$export$80ee20aa64f130f = ({ url: url, method: method, variables: variables = {}, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const response = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, resolvedVariables);
        return parseResult(response, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
const $e94116a19c839dfc$export$54f10667ecd8890d = ({ requestConfigs: requestConfigs, variables: variables = {}, parseResult: parseResult })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const responses = await Promise.all(requestConfigs.map((fetchOptions)=>(0, $GLgaM.fetchResponse)(fetchOptions, resolvedVariables)));
        return parseResult(responses, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
module.exports["useFetchData"] = $e94116a19c839dfc$export$80ee20aa64f130f;
module.exports["useFetchDataWithMultipleFetches"] = $e94116a19c839dfc$export$54f10667ecd8890d;

});

parcelRegister("fqCbQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $26Yfd = parcelRequire("26Yfd");


var $hR9WV = parcelRequire("hR9WV");


var $7ji4X = parcelRequire("7ji4X");


var $iXGsw = parcelRequire("iXGsw");

const $2b5be438041a56b3$export$96d43f36deadf5d1 = new Map();
function $2b5be438041a56b3$export$ca796a141438ab25({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, fetchPolicy: fetchPolicy, isLazyQuery: isLazyQuery = false, pollInterval: pollInterval, isSSR: isSSR = false }) {
    // For no-cache: use local state per hook instance instead of shared state
    const [localState, setLocalState] = (0, $cozmU.useState)();
    const sharedState = (0, $7ji4X.useExperimentalQueryState)({
        key: key
    });
    const { setQueryState: setQueryState } = (0, $7ji4X.useExperimentalQueryStateActions)();
    // Store the last used variables for polling
    // This ensures lazy queries remember their variables for subsequent poll requests
    const lastVariablesRef = (0, $cozmU.useRef)(undefined);
    // Choose which state to expose based on fetchPolicy
    const queryState = fetchPolicy === 'no-cache' ? localState : sharedState;
    const execute = (0, $26Yfd.useStableCallback)(async (variables, options)=>{
        // Store variables for future polling requests
        // This matches Apollo's behavior where lazy queries remember their variables
        if (variables !== undefined) lastVariablesRef.current = variables;
        // Use provided variables, or fall back to stored variables (e.g., during polling)
        const effectiveVariables = variables ?? lastVariablesRef.current;
        // If cache-first and we have data, return immediately (unless bypassCache is true, e.g., for polling)
        if (fetchPolicy === 'cache-first' && queryState?.data !== undefined && !options?.bypassCache) {
            onCompleted?.(queryState.data);
            return;
        }
        // Check if this exact query is already in flight (deduplication)
        const existingPromise = $2b5be438041a56b3$export$96d43f36deadf5d1.get(key);
        if (existingPromise) {
            // Wait for the shared promise
            const outcome = await existingPromise;
            // Set local state if no-cache policy. Other fetch policies use shared state
            if (fetchPolicy === 'no-cache') {
                if (outcome.error) setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: outcome.error,
                        called: true
                    }));
                else if (outcome.data !== undefined) setLocalState({
                    data: outcome.data,
                    loading: false,
                    error: undefined,
                    called: true
                });
            }
            // Call this component's callbacks
            if (outcome.error) onError?.(outcome.error);
            else if (outcome.data !== undefined) onCompleted?.(outcome.data);
            return;
        }
        // Create a Promise for the fetch operation that resolves to the outcome
        const fetchPromise = (async ()=>{
            try {
                // Set loading state if not initial fetch
                const shouldSetLoadingState = !options?.skipLoadingState && (isLazyQuery || queryState?.loading === false || queryState?.data !== undefined || queryState?.error);
                if (shouldSetLoadingState) {
                    // Update the appropriate state based on fetchPolicy
                    if (fetchPolicy === 'no-cache') setLocalState({
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                    else setQueryState(key, {
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                }
                const data = await fetchData(effectiveVariables);
                if (fetchPolicy === 'no-cache') setLocalState({
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                else setQueryState(key, {
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                onCompleted?.(data);
                return {
                    data: data
                };
            } catch (error) {
                const finalError = await (0, $hR9WV.handleError)({
                    error: error,
                    transformError: transformError,
                    onError: onError
                });
                if (fetchPolicy === 'no-cache') setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                else setQueryState(key, (prev)=>({
                        data: prev.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                return {
                    error: finalError
                };
            } finally{
                // Remove from in-flight map so future calls create a new request
                $2b5be438041a56b3$export$96d43f36deadf5d1.delete(key);
            }
        })();
        // Store the Promise in the Map before starting the fetch
        $2b5be438041a56b3$export$96d43f36deadf5d1.set(key, fetchPromise);
        await fetchPromise;
    });
    // Note: This only updates the shared state, so any fetch policies (e.g. "no-cache") will be ignored.
    // Please implement local state usage if it's needed in the future.
    const refetch = (0, $26Yfd.useStableCallback)(async (variables)=>{
        try {
            setQueryState(key, {
                data: queryState?.data,
                loading: true,
                error: undefined,
                called: true
            });
            const data = await fetchData(variables);
            setQueryState(key, {
                data: data,
                loading: false,
                error: undefined,
                called: true
            });
            onCompleted?.(data);
            return {
                data: data
            };
        } catch (error) {
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            setQueryState(key, (prev)=>({
                    data: prev.data,
                    loading: false,
                    error: finalError,
                    called: true
                }));
            throw finalError;
        }
    });
    const { stopPolling: stopPolling } = (0, $iXGsw.usePollInterval)(pollInterval, execute, fetchPolicy, isLazyQuery, queryState?.called, isSSR);
    return {
        queryState: queryState,
        execute: execute,
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQueryExecution"] = $2b5be438041a56b3$export$ca796a141438ab25;

});

parcelRegister("hR9WV", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $bjeS8 = parcelRequire("bjeS8");

const $b1a7f6ba28f294ca$export$d3da1ecaf1206c58 = async ({ error: error, transformError: transformError, onError: onError })=>{
    // The `transformError` callback can optionally return a new error to replace the original,
    // allowing for custom errors (e.g. based on the error's status code)
    const finalError = (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    // Process error for monitoring/analytics
    if (finalError.graphQLErrors?.length) finalError.graphQLErrors.forEach((e)=>{
        (0, $7Sm4c.processError)(e);
    });
    onError?.(finalError);
    return finalError;
};
module.exports["handleError"] = $b1a7f6ba28f294ca$export$d3da1ecaf1206c58;

});

parcelRegister("iXGsw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $d90d6eaddcfc40bd$export$55982a4d88e0db29(pollInterval, execute, fetchPolicy, isLazyQuery, called, isSSR) {
    if (pollInterval && fetchPolicy === 'cache-first') throw new Error('Queries that specify the cache-first fetchPolicy cannot also be polling queries.');
    const pollIntervalRef = (0, $cozmU.useRef)(null);
    const stopPolling = (0, $cozmU.useCallback)(()=>{
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
    }, []);
    const handlePoll = (0, $cozmU.useCallback)(()=>{
        execute(undefined, {
            bypassCache: true,
            skipLoadingState: true
        });
    }, [
        execute
    ]);
    // For non-lazy queries: poll immediately when pollInterval > 0
    // For lazy queries: only poll after query has been called at least once
    const shouldStartPolling = (0, $cozmU.useMemo)(()=>{
        if (isSSR || !pollInterval || pollInterval <= 0) return false;
        return !isLazyQuery || called;
    }, [
        isSSR,
        pollInterval,
        isLazyQuery,
        called
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Clear any existing poll interval when conditions change
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
        if (shouldStartPolling) pollIntervalRef.current = setInterval(()=>{
            handlePoll();
        }, pollInterval);
        // Cleanup on unmount or when dependencies change
        return ()=>{
            if (pollIntervalRef.current) {
                clearInterval(pollIntervalRef.current);
                pollIntervalRef.current = null;
            }
        };
    }, [
        pollInterval,
        handlePoll,
        shouldStartPolling
    ]);
    return {
        stopPolling: stopPolling
    };
}
module.exports["usePollInterval"] = $d90d6eaddcfc40bd$export$55982a4d88e0db29;

});

parcelRegister("4b4iP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $67Foi = parcelRequire("67Foi");


var $eAduJ = parcelRequire("eAduJ");


var $fG32j = parcelRequire("fG32j");


var $aZfd8 = parcelRequire("aZfd8");

const $343989ced147f5e6$export$20a459334853e190 = ({ children: children, spaceKey: spaceKey, isAnonymous: isAnonymous = false, contentId: contentId, isFirstRoute: isFirstRoute = false, goBackPreviousPage: goBackPreviousPage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fG32j.SpaceRestrictionCheck), {
        spaceKey: spaceKey,
        contentId: contentId
    }, ({ isSpaceRestricted: isSpaceRestricted, isSpaceNotFound: isSpaceNotFound })=>{
        if (isSpaceRestricted) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eAduJ.RestrictedSpace), {
            goToPreviousPage: goBackPreviousPage,
            isFirstRoute: isFirstRoute,
            contentId: contentId
        });
        if (isSpaceNotFound && !isAnonymous && !contentId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZfd8.Space404), {
            goBackPreviousPage: goBackPreviousPage,
            isFirstRoute: isFirstRoute
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $67Foi.ScreenEvent), {
            name: "spaceNotFoundScreen",
            id: spaceKey
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    });
};
module.exports["SpaceRestrictionHandler"] = $343989ced147f5e6$export$20a459334853e190;

});

parcelRegister("eAduJ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0e8fee473144754c$export$5ef003f00c9525a1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wviAQ",
    name: "RestrictedSpace",
    loader: async ()=>(await (parcelRequire("gXGo2"))).RestrictedSpace
});
module.exports["RestrictedSpace"] = $0e8fee473144754c$export$5ef003f00c9525a1;

});

parcelRegister("gXGo2", function(module, exports) {

let $c5930923ab95ec58$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c5930923ab95ec58$var$load("zUKwV"),
    $c5930923ab95ec58$var$load("fUeur"),
    $c5930923ab95ec58$var$load("7EorR"),
    $c5930923ab95ec58$var$load("hhss7"),
    $c5930923ab95ec58$var$load("2OcM6")
]).then(()=>parcelRequire('9at9H'));

});

parcelRegister("fG32j", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $kdKo9 = parcelRequire("kdKo9");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");



var $jMyy4 = parcelRequire("jMyy4");

const $06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery = (0, $kdKo9.default);
const $06e8bea7aad8a7b8$export$f1b4255eb8ae314e = (0, $3u0dr.isReactCompilerActiveV2)() ? function SpaceRestrictionCheck(t0) {
    const $ = (0, $bDgLe.c)(14);
    const { asSuperAdmin: asSuperAdmin, children: children, spaceKey: spaceKey, contentId: contentId } = t0;
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let t1;
    if ($[0] !== asSuperAdmin) {
        t1 = asSuperAdmin == undefined ? undefined : {
            asSuperAdmin: asSuperAdmin
        };
        $[0] = asSuperAdmin;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = spaceKey || stateSpaceKey;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            spaceKey: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t1 || $[5] !== t3) {
        t4 = {
            context: t1,
            errorPolicy: "all",
            variables: t3
        };
        $[4] = t1;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery, {
        ...t4,
        __callerPackage__: "restrictions"
    });
    let t5;
    let t6;
    if ($[7] !== children || $[8] !== contentId || $[9] !== data || $[10] !== error || $[11] !== loading) {
        t6 = Symbol.for("react.early_return_sentinel");
        bb0: {
            let isSpaceNotFound;
            let isSpaceRestricted;
            if (error) {
                isSpaceNotFound = $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error);
                isSpaceRestricted = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error);
                if (isSpaceNotFound || isSpaceRestricted) (0, $7Sm4c.markErrorAsHandled)(error);
            } else if (data) {
                const errorSwallowed = data.space === null;
                isSpaceNotFound = errorSwallowed && window.__SPACE_NOTFOUND_CHECK_ERROR__;
                isSpaceRestricted = errorSwallowed && window.__SPACE_RESTRICTED_CHECK_ERROR__;
            }
            if (loading) {
                t6 = null;
                break bb0;
            }
            const contentIsNotViewableBecauseOfSpaceRestrictions = Boolean(contentId) && window?.__SPACE_RESTRICTED_ERROR__ === contentId;
            t5 = children({
                error: error,
                isSpaceNotFound: isSpaceNotFound,
                isSpaceRestricted: isSpaceRestricted || contentIsNotViewableBecauseOfSpaceRestrictions
            });
        }
        $[7] = children;
        $[8] = contentId;
        $[9] = data;
        $[10] = error;
        $[11] = loading;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    if (t6 !== Symbol.for("react.early_return_sentinel")) return t6;
    return t5;
} : function SpaceRestrictionCheck({ asSuperAdmin: asSuperAdmin, children: children, spaceKey: spaceKey, contentId: contentId }) {
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery, {
        context: asSuperAdmin == undefined ? undefined : {
            asSuperAdmin: asSuperAdmin
        },
        errorPolicy: 'all',
        variables: {
            // XXX Though SpaceRestrictionCheckProps defines spaceKey as required,
            // SpaceBaseComponent is not written in TypeScript and it may provide
            // undefined as it is reading spaceKey from redux. While it would result
            // in a better separation of concerns to have a fix in SpaceBaseComponent,
            // such a fix would be riskier.
            spaceKey: spaceKey || stateSpaceKey
        },
        __callerPackage__: "restrictions"
    });
    let isSpaceNotFound;
    let isSpaceRestricted;
    if (error) {
        isSpaceNotFound = $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error);
        isSpaceRestricted = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error);
        if (isSpaceNotFound || isSpaceRestricted) (0, $7Sm4c.markErrorAsHandled)(error);
    } else if (data) {
        const errorSwallowed = data.space === null;
        isSpaceNotFound = errorSwallowed && window['__SPACE_NOTFOUND_CHECK_ERROR__'];
        isSpaceRestricted = errorSwallowed && window['__SPACE_RESTRICTED_CHECK_ERROR__'];
    }
    if (loading) return null;
    const contentIsNotViewableBecauseOfSpaceRestrictions = Boolean(contentId) && window?.['__SPACE_RESTRICTED_ERROR__'] === contentId;
    return children({
        error: error,
        isSpaceNotFound: isSpaceNotFound,
        isSpaceRestricted: isSpaceRestricted || contentIsNotViewableBecauseOfSpaceRestrictions
    });
};
function $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ({ statusCode: statusCode })=>statusCode === 404 || statusCode === 400);
}
function $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ()=>(0, $1uFM6.isUnauthorizedError)(error));
}
function $06e8bea7aad8a7b8$var$isSpaceError({ graphQLErrors: graphQLErrors }, extensionsPredicate) {
    if (graphQLErrors && graphQLErrors.length > 0) for (const { extensions: extensions, path: path } of graphQLErrors){
        if (Array.isArray(path) && path.indexOf('space') !== -1 && extensions && extensionsPredicate(extensions)) return true;
    }
    return false;
}
module.exports["SpaceRestrictionCheck"] = $06e8bea7aad8a7b8$export$f1b4255eb8ae314e;
module.exports["isSpaceNotFoundError"] = $06e8bea7aad8a7b8$export$498e7daa29ea2c61;
module.exports["isSpaceRestrictedError"] = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef;

});

parcelRegister("aZfd8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $wtSEP = parcelRequire("wtSEP");

const $c70a78199cd90f84$export$a506b89ee82dfeb8 = (props)=>{
    const { isFirstRoute: isFirstRoute, goBackPreviousPage: goBackPreviousPage } = props;
    const onClickGoPreviousLink = (e)=>{
        e.preventDefault();
        if (goBackPreviousPage) goBackPreviousPage();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $wtSEP.NotFound), {
        secondaryButtonProps: {
            children: !isFirstRoute && goBackPreviousPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                id: "space-404.text.go.back.previous.page",
                defaultMessage: "Go to previous page"
            }),
            onClick: onClickGoPreviousLink
        }
    });
};
$c70a78199cd90f84$export$a506b89ee82dfeb8.displayName = 'Space404';
module.exports["Space404"] = $c70a78199cd90f84$export$a506b89ee82dfeb8;

});

parcelRegister("wtSEP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $251dbde4d6244b59$export$271f9f08425019c7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "pM5to",
    name: "NotFound",
    loader: async ()=>// eslint-disable-next-line
        (await (parcelRequire("lYi1m"))).NotFound
});
module.exports["NotFound"] = $251dbde4d6244b59$export$271f9f08425019c7;

});

parcelRegister("lYi1m", function(module, exports) {

let $ffed2e293401599d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ffed2e293401599d$var$load("zUKwV"),
    $ffed2e293401599d$var$load("fUeur"),
    $ffed2e293401599d$var$load("85Ack"),
    $ffed2e293401599d$var$load("k0Z8C"),
    $ffed2e293401599d$var$load("7EorR"),
    $ffed2e293401599d$var$load("hhss7"),
    $ffed2e293401599d$var$load("gEi5K")
]).then(()=>parcelRequire('3nvKi'));

});

parcelRegister("j9XVO", function(module, exports) {

var $kiJuS = parcelRequire("kiJuS");


var $d3OVq = parcelRequire("d3OVq");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");

const $2278a3c3763ebfe6$export$f1cfc3b574a4d714 = (0, $d3OVq.default);
const $2278a3c3763ebfe6$export$9d574d064e4f4f51 = (0, $kiJuS.default);
const $2278a3c3763ebfe6$export$8eab19bcc4a0311d = ({ resolvedSpaceKey: resolvedSpaceKey })=>{
    const { data: spaceBaseQueryData, loading: spaceBaseQueryLoading, error: spaceBaseQueryError } = (0, $jMyy4.useQueryInterop)($2278a3c3763ebfe6$export$f1cfc3b574a4d714, {
        skip: // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        Boolean(undefined) || (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false),
        variables: {
            spaceKey: resolvedSpaceKey
        },
        __callerPackage__: "space-base"
    });
    const { data: singleSpaceQueryData, loading: singleSpaceQueryLoading, error: singleSpaceQueryError } = (0, $jMyy4.useQueryInterop)($2278a3c3763ebfe6$export$9d574d064e4f4f51, {
        skip: // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        Boolean(undefined) || !(0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false),
        variables: {
            spaceKey: resolvedSpaceKey
        },
        __callerPackage__: "space-base"
    });
    let space, loading;
    if ((0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false)) {
        loading = singleSpaceQueryLoading;
        space = singleSpaceQueryError && !singleSpaceQueryLoading ? null : singleSpaceQueryData?.space;
    } else {
        loading = spaceBaseQueryLoading;
        space = spaceBaseQueryError && !spaceBaseQueryLoading ? null : spaceBaseQueryData?.spaces?.nodes?.[0];
    }
    return {
        space: space,
        loading: loading
    };
};
module.exports["useSpaceBaseQuery"] = $2278a3c3763ebfe6$export$8eab19bcc4a0311d;

});

parcelRegister("kiJuS", function(module, exports) {
/**
 * @generated SignedSource<<3ce11fe803ce3ee1884a6393aee1a87e>>
 * @relayHash c65404aa4339865deb33b960b63ac1fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e03d29f1801373ff6e80b3bfcf7c8bfe26a96bb6370f9f8c083d9d51a7a1a366
const $667a49a7f0668b30$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceBaseQuerySingleSpaceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceBaseQuerySingleSpaceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c65404aa4339865deb33b960b63ac1fb",
            "id": "e03d29f1801373ff6e80b3bfcf7c8bfe26a96bb6370f9f8c083d9d51a7a1a366",
            "metadata": {},
            "name": "useSpaceBaseQuerySingleSpaceQuery",
            "operationKind": "query",
            "text": "query useSpaceBaseQuerySingleSpaceQuery($spaceKey:String){space(key:$spaceKey){id,key,name,alias}}"
        }
    };
}();
$667a49a7f0668b30$var$node.hash = "0994a40a61365970e08e840dbdb433df";
var $667a49a7f0668b30$export$2e2bcd8739ae039 = $667a49a7f0668b30$var$node;
module.exports["default"] = $667a49a7f0668b30$export$2e2bcd8739ae039;

});

parcelRegister("jNRDO", function(module, exports) {

let $e6ac33ec1f17f296$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e6ac33ec1f17f296$var$load("fp9cm").then(()=>parcelRequire('9ehFI'));

});

parcelRegister("1DpTu", function(module, exports) {

let $130d84ff46cf579b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $130d84ff46cf579b$var$load("6XCf4"),
    $130d84ff46cf579b$var$load("ebvEF"),
    $130d84ff46cf579b$var$load("aEiTV"),
    $130d84ff46cf579b$var$load("1qlDN"),
    $130d84ff46cf579b$var$load("1yVM6"),
    $130d84ff46cf579b$var$load("22Xly")
]).then(()=>parcelRequire('kQJNb'));

});

parcelRegister("8NC5Z", function(module, exports) {

var $896gY = parcelRequire("896gY");


var $7Sm4c = parcelRequire("7Sm4c");


var $euL71 = parcelRequire("euL71");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $5ZqQS = parcelRequire("5ZqQS");


var $bQm3c = parcelRequire("bQm3c");


var $jMyy4 = parcelRequire("jMyy4");

const $1de3a5511529eed3$export$f032b5e8b485da1d = ({ skip: skip = false } = {})=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const shouldSkip = skip || edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $896gY.default), {
        skip: shouldSkip,
        __callerPackage__: "company-hub-utils"
    });
    if (error) {
        if (!((0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error))) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    return !shouldSkip && !data?.entitlements?.companyHub?.isEntitled;
};
module.exports["useCompanyHubPremiumGate"] = $1de3a5511529eed3$export$f032b5e8b485da1d;

});

parcelRegister("896gY", function(module, exports) {
/**
 * @generated SignedSource<<0bf45832ece12ce1024ca4a87950d3ec>>
 * @relayHash c31aa70a9a01e2207eb48c0b9be8b493
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 46122cb94f25a4d113917d2f15feffbc32da4a3126240723b7ca4eed1bf9dbd6
const $983e77d68212dc57$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "CompanyHubFeature",
                    "kind": "LinkedField",
                    "name": "companyHub",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useCompanyHubPremiumGateCompanyHubPremiumGateQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useCompanyHubPremiumGateCompanyHubPremiumGateQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "c31aa70a9a01e2207eb48c0b9be8b493",
            "id": "46122cb94f25a4d113917d2f15feffbc32da4a3126240723b7ca4eed1bf9dbd6",
            "metadata": {},
            "name": "useCompanyHubPremiumGateCompanyHubPremiumGateQuery",
            "operationKind": "query",
            "text": "query useCompanyHubPremiumGateCompanyHubPremiumGateQuery{entitlements{companyHub{isEntitled}}}"
        }
    };
}();
$983e77d68212dc57$var$node.hash = "a5508e7e7123c5675909c4f9214a5be2";
var $983e77d68212dc57$export$2e2bcd8739ae039 = $983e77d68212dc57$var$node;
module.exports["default"] = $983e77d68212dc57$export$2e2bcd8739ae039;

});

parcelRegister("f9jv7", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $b29e4bf652226e80$export$6ccdb59d3479f4f1 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '404');
module.exports["isNotFoundError"] = $b29e4bf652226e80$export$6ccdb59d3479f4f1;

});

parcelRegister("7CeAz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cEgMD = parcelRequire("cEgMD");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $1ytiN = parcelRequire("1ytiN");


var $8NC5Z = parcelRequire("8NC5Z");

const $16ea73778f65e8da$export$1d4394ae12760637 = ()=>{
    const { frontCoverState: frontCoverState, isSiteAdmin: isSiteAdmin, loading: loading } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
    const canPublish = isSiteAdmin || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const isAdminDiscoverable = // 1. If entitled (e.g. Premium), both site admin and product admin have the
    //    entry point in the top nav, because it leads to COMPANY_HUB.
    // 2. If not entitled (e.g. Free or Standard):
    //   a. only site admin has the entry point in the top nav, because it
    //      renders an upsell;
    //   b. product admin doesn't have the entry point in the top nav, because
    //      it automatically redirects to HOME.
    shouldShowPremiumUpsell ? isSiteAdmin : canPublish;
    const isCompanyHubFeatureAvailable = !shouldShowPremiumUpsell;
    const isCompanyHubPublished = Boolean(isCompanyHubFeatureAvailable && frontCoverState === (0, $cEgMD.FrontCoverStateEnum).SHOWN);
    const isCompanyHubShownToEditors = Boolean(isCompanyHubFeatureAvailable && frontCoverState === (0, $cEgMD.FrontCoverStateEnum).EDITORS_ONLY || isCompanyHubPublished);
    const isCompanyHubEntryPointEnabled = Boolean(isCompanyHubFeatureAvailable && (isCompanyHubPublished || isCompanyHubShownToEditors) || isAdminDiscoverable);
    return {
        canPublish: isCompanyHubFeatureAvailable && canPublish,
        isCompanyHubPublished: isCompanyHubPublished,
        isCompanyHubShownToEditors: isCompanyHubShownToEditors,
        isCompanyHubEntryPointEnabled: isCompanyHubEntryPointEnabled,
        loading: Boolean(loading)
    };
};
module.exports["useIsCompanyHubEnabled"] = $16ea73778f65e8da$export$1d4394ae12760637;

});

parcelRegister("eqNP8", function(module, exports) {
/* FullPageLoadingScreen.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lfoFx = parcelRequire("lfoFx");

const $94835ea6111c7010$var$zIndexBlanket = 500; // layers.blanket()
const $94835ea6111c7010$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1mT5xdy1CL _2IhTon715P _3OE6xY715P _1VJPcaiDnZ _42Yu6B6zpv",
            __cmplp.className
        ])
    });
});
const $94835ea6111c7010$export$5b927fc1ef8c468b = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_23rrnH4Jcb _42Yu6BN779 _0jFU0VN91d _39xV02N91d _1mT5xdy1CL _3OE6xYdnbC _2IhTondnbC _0KLXrulfZc _1YKVNs4qrS _3OZqoKe6K4",
            __cmplp.className
        ])
    });
});
const $94835ea6111c7010$export$fe2b6579564feee = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($94835ea6111c7010$export$7c6e2c02157bb7d2, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        interactionName: "full-page-loading-screen",
        size: 26
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($94835ea6111c7010$export$5b927fc1ef8c468b, null));
module.exports["FullPageLoadingScreen"] = $94835ea6111c7010$export$fe2b6579564feee;

});

parcelRegister("gi8UL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $422HI = parcelRequire("422HI");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $1NBp8 = parcelRequire("1NBp8");


var $cEgMD = parcelRequire("cEgMD");


var $6s78L = parcelRequire("6s78L");


var $fEmGS = parcelRequire("fEmGS");


var $43e2h = parcelRequire("43e2h");


var $bZB1l = parcelRequire("bZB1l");


var $fg6th = parcelRequire("fg6th");


var $fbF8y = parcelRequire("fbF8y");

const $acd2ea8b6650161b$var$SPACE_ALREADY_EXISTS_ERROR = 'A space already exists';
const $acd2ea8b6650161b$export$66010d469140e6a6 = (error)=>{
    return !!error?.graphQLErrors?.some((error)=>{
        const isStatusCode400 = error.extensions?.statusCode === 400;
        const hasSimpleErrorMessage = error.message.includes($acd2ea8b6650161b$var$SPACE_ALREADY_EXISTS_ERROR);
        const hasNestedErrorMessage = error.extensions?.data?.errors?.every((err)=>err?.message?.translation?.includes($acd2ea8b6650161b$var$SPACE_ALREADY_EXISTS_ERROR));
        return isStatusCode400 && (hasSimpleErrorMessage || hasNestedErrorMessage);
    });
};
const $acd2ea8b6650161b$export$167bd8b1ca11153c = "User doesn't have permission to create system space";
const $acd2ea8b6650161b$export$ed3e7d674501852d = (error)=>$acd2ea8b6650161b$var$hasNestedApolloErrorMessage(error, $acd2ea8b6650161b$export$167bd8b1ca11153c);
const $acd2ea8b6650161b$var$hasNestedApolloErrorMessage = (error, errorMessage)=>{
    return error?.graphQLErrors?.[0]?.extensions?.data?.errors?.some((err)=>err?.message?.translation?.includes(errorMessage));
};
const $acd2ea8b6650161b$var$getErrorFlagConfig = (title, description, actions = [], id)=>({
        id: id,
        title: title,
        description: description,
        actions: actions
    });
const $acd2ea8b6650161b$var$showStalePermissionsErrorFlag = (flags)=>{
    const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpaceStalePermissionsErrorFlagTitle);
    const description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpaceStalePermissionsErrorFlagDescription,
        values: {
            a: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: "https://support.atlassian.com/confluence-cloud/docs/create-and-customize-a-company-hub",
                    target: "_blank"
                }, chunks)
        }
    });
    const actions = [
        {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpaceStalePermissionsErrorFlagButton),
            onClick: ()=>window.location.reload()
        }
    ];
    flags.showErrorFlag($acd2ea8b6650161b$var$getErrorFlagConfig(title, description, actions));
};
const $acd2ea8b6650161b$var$showUnauthorizedErrorFlag = (flags)=>{
    const id = 'create-system-space-permissions-failure';
    const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpacePermissionsErrorFlagTitle);
    const description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpacePermissionsErrorFlagDescription,
        values: {
            b: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks)
        }
    });
    const actions = [
        {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpacePermissionsErrorFlagButton),
            href: (0, $1NBp8.ADMIN_NEW_GLOBAL_PERMISSIONS).toUrl()
        }
    ];
    flags.showErrorFlag($acd2ea8b6650161b$var$getErrorFlagConfig(title, description, actions, id));
};
const $acd2ea8b6650161b$var$showGenericErrorFlag = (flags)=>{
    const id = 'create-system-space-failure';
    const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpaceErrorFlagTitle);
    const description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpaceErrorFlagDescription);
    flags.showErrorFlag($acd2ea8b6650161b$var$getErrorFlagConfig(title, description, [], id));
};
const $acd2ea8b6650161b$export$a7357cdd1f0b0168 = // eslint-disable-next-line check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages -- To not throw away existing translations when the concept "Company Home Builder" was obsoleted
(0, $kSwu1.defineMessages)({
    createCompanyHubSpaceErrorFlagTitle: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-error-flag-title",
        defaultMessage: "Something went wrong"
    },
    createCompanyHubSpaceErrorFlagDescription: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-error-flag-description",
        defaultMessage: "Try again to continue setting up your landing page."
    },
    createCompanyHubSpacePermissionsErrorFlagTitle: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-permissions-error-flag-title",
        defaultMessage: "You need permission"
    },
    createCompanyHubSpacePermissionsErrorFlagDescription: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-permissions-error-flag-description",
        defaultMessage: "You need <b>Create space</b> permissions to create this hub."
    },
    createCompanyHubSpacePermissionsErrorFlagButton: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-permissions-error-flag-button",
        defaultMessage: "Go to permissions"
    },
    createCompanyHubSpaceStalePermissionsErrorFlagTitle: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-stale-permissions-error-flag-title",
        defaultMessage: "We couldn\u2019t create your hub"
    },
    createCompanyHubSpaceStalePermissionsErrorFlagDescription: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-stale-permissions-error-flag-description",
        defaultMessage: "Only product admins can create and activate a <a>Company hub</a>"
    },
    createCompanyHubSpaceStalePermissionsErrorFlagButton: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-stale-permissions-error-flag-button",
        defaultMessage: "Got it"
    }
});
async function $acd2ea8b6650161b$export$cb27704aaa7dfff2(flags) {
    const client = (0, $hp2SH.getApolloClient)();
    try {
        const hasHubSpace = await (0, $43e2h.checkIfCompanyHubSpaceExists)();
        if (!hasHubSpace) {
            const { data: data, errors: errors } = await (0, $6s78L.mutateInterop)({
                mutation: (0, $fg6th.default),
                variables: {
                    input: {
                        systemSpaceHomepageTemplate: (0, $bZB1l.SystemSpaceHomepageTemplate).EAP
                    }
                },
                update: (cache, { data: data })=>{
                    const companyHubName = data?.createSystemSpace?.name;
                    if (!companyHubName) return;
                    $acd2ea8b6650161b$var$updateSiteConfigurationCache(cache, companyHubName);
                },
                __callerPackage__: "company-hub-utils"
            });
            if (errors?.length) throw new (0, $422HI.ApolloErrorInterop)({
                graphQLErrors: errors
            });
            if (data?.createSystemSpace?.id != null) $acd2ea8b6650161b$var$updateFrontCoverStateCache(client);
            return {
                didCreateSpace: true,
                homepageId: data?.createSystemSpace?.homepageId
            };
        }
        $acd2ea8b6650161b$var$updateFrontCoverStateCache(client);
        return {
            didCreateSpace: false,
            homepageId: undefined
        };
    } catch (error) {
        if ($acd2ea8b6650161b$export$66010d469140e6a6(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            $acd2ea8b6650161b$var$updateFrontCoverStateCache(client);
            return {
                didCreateSpace: false,
                homepageId: undefined
            };
        }
        if (flags) {
            if ($acd2ea8b6650161b$export$ed3e7d674501852d(error)) $acd2ea8b6650161b$var$showStalePermissionsErrorFlag(flags);
            else if ((0, $1uFM6.isUnauthorizedError)(error)) $acd2ea8b6650161b$var$showUnauthorizedErrorFlag(flags);
            else $acd2ea8b6650161b$var$showGenericErrorFlag(flags);
        }
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        throw error;
    }
}
function $acd2ea8b6650161b$var$updateFrontCoverStateCache(cache) {
    $acd2ea8b6650161b$var$updateSiteConfigurationCache(cache, null, (0, $cEgMD.FrontCoverStateEnum).EDITORS_ONLY);
}
function $acd2ea8b6650161b$var$updateSiteConfigurationCache(_cache, companyHubName, frontCoverState) {
    (0, $fEmGS.writeQueryInterop)({
        query: (0, $fbF8y.default),
        data: {
            siteSettings: {
                // Codegen is specifically configured to not add __typename when generating the types file,
                // so unfortunately ts-ignore is required here.
                // @ts-ignore
                __typename: 'SiteSettings',
                ...companyHubName ? {
                    companyHubName: companyHubName
                } : {},
                ...frontCoverState ? {
                    frontCover: {
                        frontCoverState: frontCoverState,
                        // Codegen is specifically configured to not add __typename when generating the types file,
                        // so unfortunately ts-ignore is required here.
                        // @ts-ignore
                        __typename: 'FrontCover'
                    }
                } : {}
            }
        },
        __callerPackage__: "company-hub-utils"
    });
}
module.exports["hasStalePermissionsErrorMessage"] = $acd2ea8b6650161b$export$ed3e7d674501852d;
module.exports["i18n"] = $acd2ea8b6650161b$export$a7357cdd1f0b0168;
module.exports["createCompanyHubSpace"] = $acd2ea8b6650161b$export$cb27704aaa7dfff2;

});

parcelRegister("43e2h", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $cEgMD = parcelRequire("cEgMD");


var $dSvuc = parcelRequire("dSvuc");


var $c0rhi = parcelRequire("c0rhi");

async function $efb8b6f89ca41072$export$bd1440de1c6279ff() {
    const key = (0, $cEgMD.getCompanyHubSpaceKey)();
    if (!key) throw new Error('Failed to get company hub space key');
    try {
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: (0, $dSvuc.CompanyHubSpaceQuery),
            variables: {
                key: key
            },
            __callerPackage__: "company-hub-utils"
        });
        return !!data?.space?.id;
    } catch (error) {
        if (error?.message.includes('NotFoundException')) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return false;
        } else throw error;
    }
}
module.exports["checkIfCompanyHubSpaceExists"] = $efb8b6f89ca41072$export$bd1440de1c6279ff;

});

parcelRegister("dSvuc", function(module, exports) {

var $8m8tN = parcelRequire("8m8tN");

const $d89c04ce1104682e$export$64834e9fe6776d12 = (0, $8m8tN.default);
module.exports["CompanyHubSpaceQuery"] = $d89c04ce1104682e$export$64834e9fe6776d12;

});

parcelRegister("8m8tN", function(module, exports) {
/**
 * @generated SignedSource<<22025a05bd4c5824adfd3b7c2aa87820>>
 * @relayHash f54737bfd2a13d4b0794f55692abc45f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5dadc9e02b20435a2eb281b9e0526d9c30d7939933ec6809776a6a63a0bfbfb0
const $a46838f64d9d3dd2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "key"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "homepageId"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CompanyHubSpaceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CompanyHubSpaceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f54737bfd2a13d4b0794f55692abc45f",
            "id": "5dadc9e02b20435a2eb281b9e0526d9c30d7939933ec6809776a6a63a0bfbfb0",
            "metadata": {},
            "name": "CompanyHubSpaceQuery",
            "operationKind": "query",
            "text": "query CompanyHubSpaceQuery($key:String!){space(key:$key){id,homepageId}}"
        }
    };
}();
$a46838f64d9d3dd2$var$node.hash = "27e0b4cea0d06588f669e5b18022e172";
var $a46838f64d9d3dd2$export$2e2bcd8739ae039 = $a46838f64d9d3dd2$var$node;
module.exports["default"] = $a46838f64d9d3dd2$export$2e2bcd8739ae039;

});

parcelRegister("bZB1l", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $f8cc4d70fe32131d$export$7347d1c116cc1a56 = /*#__PURE__*/ function(SystemSpaceHomepageTemplate) {
    SystemSpaceHomepageTemplate["EAP"] = "EAP";
    SystemSpaceHomepageTemplate["MINIMAL"] = "MINIMAL";
    SystemSpaceHomepageTemplate["VISUAL"] = "VISUAL";
    return SystemSpaceHomepageTemplate;
}({});
module.exports["SystemSpaceHomepageTemplate"] = $f8cc4d70fe32131d$export$7347d1c116cc1a56;

});

parcelRegister("fg6th", function(module, exports) {
/**
 * @generated SignedSource<<0846e0fadbf09c50aad36a858dc422d6>>
 * @relayHash fe06e2f4a69f3231f81c25802441a1dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 694ca0efa967ba191320a5158bb8c5493f3d9fad08441a81d4bd1701967c7fc1
const $50fdf9c304115b8b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "createSystemSpace",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "homepageId"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CreateCompanyHubSpaceMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CreateCompanyHubSpaceMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fe06e2f4a69f3231f81c25802441a1dc",
            "id": "694ca0efa967ba191320a5158bb8c5493f3d9fad08441a81d4bd1701967c7fc1",
            "metadata": {},
            "name": "CreateCompanyHubSpaceMutation",
            "operationKind": "mutation",
            "text": "mutation CreateCompanyHubSpaceMutation($input:SystemSpaceHomepageInput!){createSystemSpace(input:$input){homepageId,id,name,type}}"
        }
    };
}();
$50fdf9c304115b8b$var$node.hash = "6d874a2575f518173ffd31619b161569";
var $50fdf9c304115b8b$export$2e2bcd8739ae039 = $50fdf9c304115b8b$var$node;
module.exports["default"] = $50fdf9c304115b8b$export$2e2bcd8739ae039;

});

parcelRegister("fbF8y", function(module, exports) {
/**
 * @generated SignedSource<<671cda1bccf0a3f50223a0090b44579c>>
 * @relayHash 4811a5c342533b21d8dd3e696c5fe3f8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4b172e9d092e820e54ac35b21158bc7ef6a5fb96801347d822b558b506f90cf8
const $dd16027bddebb268$var$node = function() {
    var v0 = [
        {
            "concreteType": "SiteSettings",
            "kind": "LinkedField",
            "name": "siteSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "companyHubName"
                },
                {
                    "concreteType": "FrontCover",
                    "kind": "LinkedField",
                    "name": "frontCover",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "frontCoverState"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "SiteConfigurationQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "SiteConfigurationQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "4811a5c342533b21d8dd3e696c5fe3f8",
            "id": "4b172e9d092e820e54ac35b21158bc7ef6a5fb96801347d822b558b506f90cf8",
            "metadata": {},
            "name": "SiteConfigurationQuery",
            "operationKind": "query",
            "text": "query SiteConfigurationQuery{siteSettings{companyHubName,frontCover{frontCoverState}}}"
        }
    };
}();
$dd16027bddebb268$var$node.hash = "b4b2ce4fdc75a41f2f68ef6d954513ab";
var $dd16027bddebb268$export$2e2bcd8739ae039 = $dd16027bddebb268$var$node;
module.exports["default"] = $dd16027bddebb268$export$2e2bcd8739ae039;

});

parcelRegister("3I7mv", function(module, exports) {

let $2b3b311c6214ec49$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2b3b311c6214ec49$var$load("eW2qV"),
    $2b3b311c6214ec49$var$load("lya9W"),
    $2b3b311c6214ec49$var$load("6wr18"),
    $2b3b311c6214ec49$var$load("lmRBB"),
    $2b3b311c6214ec49$var$load("hohnS"),
    $2b3b311c6214ec49$var$load("8qpwN"),
    $2b3b311c6214ec49$var$load("7e1By"),
    $2b3b311c6214ec49$var$load("kUuw5"),
    $2b3b311c6214ec49$var$load("hKFtK"),
    $2b3b311c6214ec49$var$load("dnVmf"),
    $2b3b311c6214ec49$var$load("85Ack"),
    $2b3b311c6214ec49$var$load("agVmZ"),
    $2b3b311c6214ec49$var$load("ffEVr"),
    $2b3b311c6214ec49$var$load("cYP30")
]).then(()=>parcelRequire('35RMv'));

});

parcelRegister("ak57N", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");

var $2w2Hu = parcelRequire("2w2Hu");


const $a0c4fc2f529fa1f8$export$99fa8db8497fb663 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "fAvbz",
    name: 'EditPageLoaderServer',
    loader: async ()=>(await (parcelRequire("iHuJP"))).EditPageLoaderServer,
    _mustPreloadWhenRenderingSPA: [
        (0, $2w2Hu.MustPreloadLoadableNames).ClassicEditorContextProviderLoader,
        (0, $2w2Hu.MustPreloadLoadableNames).NativeCollabLoader,
        (0, $2w2Hu.MustPreloadLoadableNames).FullPageEditorLoader
    ]
});
module.exports["EditPageLoaderServer"] = $a0c4fc2f529fa1f8$export$99fa8db8497fb663;

});

parcelRegister("2w2Hu", function(module, exports) {
/**
 * These are loadable names that cross reference by multiple places.
 * They were kept as constants here instead of automatically generated for consistency.
 * ONLY put names here if they are going to be used in _mustPreloadWhenRenderingSPA.
 */ const $8cf96aaaf31dfd76$export$75ebf2388340a0ba = {
    ClassicRendererLoader: 'ClassicRendererLoader',
    ClassicEditorContextProviderLoader: 'ClassicEditorContextProviderLoader',
    NativeCollabLoader: 'NativeCollabLoader',
    FullPageEditorLoader: 'FullPageEditorLoader',
    ViewPageRouteComponentLoader: 'ViewPageRouteComponentLoader',
    LivePageComponentLoader: 'LivePageComponentLoader',
    EditorByLineArea: 'EditorByLineArea',
    TitleAreaContentComponents: 'TitleAreaContentComponents'
};
module.exports["MustPreloadLoadableNames"] = $8cf96aaaf31dfd76$export$75ebf2388340a0ba;

});

parcelRegister("iHuJP", function(module, exports) {

let $d9d4161cdf3f864a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d9d4161cdf3f864a$var$load("cgtG8").then(()=>parcelRequire('g3qL5'));

});

parcelRegister("faAj4", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $54Cdh = parcelRequire("54Cdh");

class $c089dd5bc3bc2565$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $8aG6j.jsx)($c089dd5bc3bc2565$var$WithEditorActionsNew, {
            ...this.props
        });
    }
    constructor(props){
        super(props);
    }
}
const $c089dd5bc3bc2565$var$WithEditorActionsNew = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WithEditorActionsNew(props) {
    const $ = (0, $bDgLe.c)(3);
    const { render: render } = props;
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $54Cdh.EditorContext));
    const t0 = context?.editorActions;
    let t1;
    if ($[0] !== render || $[1] !== t0) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)($c089dd5bc3bc2565$var$WithEditorActionsInner, {
            render: render,
            editorActions: t0
        });
        $[0] = render;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function WithEditorActionsNew(props) {
    const { render: render } = props;
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $54Cdh.EditorContext));
    return /*#__PURE__*/ (0, $8aG6j.jsx)($c089dd5bc3bc2565$var$WithEditorActionsInner, {
        render: render,
        editorActions: context?.editorActions
    });
}; // Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $c089dd5bc3bc2565$var$WithEditorActionsInner extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidMount() {
        this.props.editorActions._privateSubscribe(()=>this.forceUpdate());
    }
    componentWillUnmount() {
        this.props.editorActions._privateUnsubscribe(()=>this.forceUpdate());
    }
    render() {
        return this.props.render(this.props.editorActions);
    }
}
module.exports["default"] = $c089dd5bc3bc2565$export$2e2bcd8739ae039;

});

parcelRegister("bIp5p", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $4631e26c523d1a56$var$initialState = {
    isEditingLocked: false,
    isInViewMode: true,
    isInAutoFocusMode: true,
    selectedExtensionLocalId: null,
    selectedToEditCardId: null,
    selectedToRemoveCardId: null
};
// Actions for managing the Custom Site Extensions state that is shared between the extension and the config panel
const $4631e26c523d1a56$var$actions = {
    setIsInViewMode: (isInViewMode)=>({ setState: setState })=>{
            setState({
                isInViewMode: isInViewMode
            });
        },
    setIsEditingLocked: (isEditingLocked)=>({ setState: setState })=>{
            setState({
                isEditingLocked: isEditingLocked
            });
        },
    setIsInAutoFocusMode: (isInAutoFocusMode)=>({ setState: setState })=>{
            setState({
                isInAutoFocusMode: isInAutoFocusMode
            });
        },
    setSelectedExtensionLocalId: (extensionLocalId)=>({ getState: getState, setState: setState })=>{
            if (getState().isInViewMode) return;
            setState({
                selectedExtensionLocalId: extensionLocalId
            });
        },
    setSelectedToEditCardId: (cardId)=>({ getState: getState, setState: setState })=>{
            if (getState().isInViewMode) return;
            setState({
                selectedToEditCardId: cardId
            });
        },
    setSelectedToRemoveCardId: (cardId)=>({ getState: getState, setState: setState })=>{
            if (getState().isInViewMode) return;
            setState({
                selectedToRemoveCardId: cardId
            });
        }
};
const $4631e26c523d1a56$var$ExtensionsStateStore = (0, $8s9DV.createStore)({
    initialState: $4631e26c523d1a56$var$initialState,
    actions: $4631e26c523d1a56$var$actions,
    name: 'ExtensionsStateStore'
});
const $4631e26c523d1a56$export$732cb2f7b629a11e = (0, $kBr4q.createHook)($4631e26c523d1a56$var$ExtensionsStateStore);
const $4631e26c523d1a56$export$d50cb813b9099554 = (0, $kBr4q.createActionsHook)($4631e26c523d1a56$var$ExtensionsStateStore);
module.exports["useExtensionsState"] = $4631e26c523d1a56$export$732cb2f7b629a11e;
module.exports["useExtensionsActions"] = $4631e26c523d1a56$export$d50cb813b9099554;

});

parcelRegister("hKzt8", function(module, exports) {

let $cec23ef25e3355be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cec23ef25e3355be$var$load("lya9W"),
    $cec23ef25e3355be$var$load("gkVge"),
    $cec23ef25e3355be$var$load("3HUOM"),
    $cec23ef25e3355be$var$load("dgPly"),
    $cec23ef25e3355be$var$load("eOFeQ"),
    $cec23ef25e3355be$var$load("dgmjH"),
    $cec23ef25e3355be$var$load("gNPMO"),
    $cec23ef25e3355be$var$load("1dC87"),
    $cec23ef25e3355be$var$load("kpdr7"),
    $cec23ef25e3355be$var$load("b0ARW"),
    $cec23ef25e3355be$var$load("fQ34V"),
    $cec23ef25e3355be$var$load("cxCk7"),
    $cec23ef25e3355be$var$load("4Gdnz"),
    $cec23ef25e3355be$var$load("4UAag"),
    $cec23ef25e3355be$var$load("bjgFk"),
    $cec23ef25e3355be$var$load("iEsP0"),
    $cec23ef25e3355be$var$load("k8nz9"),
    $cec23ef25e3355be$var$load("hUbK8"),
    $cec23ef25e3355be$var$load("fqJr7"),
    $cec23ef25e3355be$var$load("7H1j2"),
    $cec23ef25e3355be$var$load("25adb"),
    $cec23ef25e3355be$var$load("glcJK"),
    $cec23ef25e3355be$var$load("5SpB1"),
    $cec23ef25e3355be$var$load("1Gr4q"),
    $cec23ef25e3355be$var$load("agVmZ"),
    $cec23ef25e3355be$var$load("hhss7"),
    $cec23ef25e3355be$var$load("ca0UP"),
    $cec23ef25e3355be$var$load("a92TB"),
    $cec23ef25e3355be$var$load("c7nj5"),
    $cec23ef25e3355be$var$load("1yIye"),
    $cec23ef25e3355be$var$load("iY0Ii"),
    $cec23ef25e3355be$var$load("7EorR"),
    $cec23ef25e3355be$var$load("Wowvf"),
    $cec23ef25e3355be$var$load("cvcNg"),
    $cec23ef25e3355be$var$load("4zz48"),
    $cec23ef25e3355be$var$load("jXM1T"),
    $cec23ef25e3355be$var$load("39XCn"),
    $cec23ef25e3355be$var$load("jw3lv"),
    $cec23ef25e3355be$var$load("7rqWx"),
    $cec23ef25e3355be$var$load("3Cky6"),
    $cec23ef25e3355be$var$load("kG5Ju"),
    $cec23ef25e3355be$var$load("il8bj"),
    $cec23ef25e3355be$var$load("6wr18"),
    $cec23ef25e3355be$var$load("aFLSJ"),
    $cec23ef25e3355be$var$load("6bjEk"),
    $cec23ef25e3355be$var$load("jfSwd"),
    $cec23ef25e3355be$var$load("9vDBp"),
    $cec23ef25e3355be$var$load("96rwC"),
    $cec23ef25e3355be$var$load("6C7Vr"),
    $cec23ef25e3355be$var$load("ef2CU"),
    $cec23ef25e3355be$var$load("VXbA1"),
    $cec23ef25e3355be$var$load("4Pq08"),
    $cec23ef25e3355be$var$load("ffEVr"),
    $cec23ef25e3355be$var$load("jH5Dl")
]).then(()=>parcelRequire('ho4OS'));

});

parcelRegister("5w0mC", function(module, exports) {
/**
 * Reverse-DNS identifier carried in ADF `extension` nodes for a Hub
 * Connect extension. Must remain stable across product releases — changing
 * it is a breaking change to persisted hub content.
 *
 * Mirrors the Help Center Connect module shape so installed Connect apps
 * (Portal header / Portal footer modules) can be shared between Help
 * Center and Hub editors with zero schema translation.
 */ const $ea111247103d173e$export$9739bc39ff578ef = 'com.atlassian.hub-connect';
const $ea111247103d173e$export$3a3256797a873c9d = 'hub-connect';
const $ea111247103d173e$export$a391370883dc60a0 = `${$ea111247103d173e$export$3a3256797a873c9d}-header`;
const $ea111247103d173e$export$6214169031454add = `${$ea111247103d173e$export$3a3256797a873c9d}-footer`;
const $ea111247103d173e$export$2772ad16b9dc4cf1 = (extensionKey)=>extensionKey === $ea111247103d173e$export$a391370883dc60a0;
const $ea111247103d173e$export$5672169d8cc92b0b = (extensionKey)=>extensionKey === $ea111247103d173e$export$6214169031454add;
const $ea111247103d173e$export$cbd6fa0855da1fbd = '1.0.0';
const $ea111247103d173e$export$a7467005470ef946 = {
    HEADER_AND_SUB_HEADER_PANELS: 'headerAndSubheaderPanels',
    FOOTER_PANELS: 'footerPanels'
};
const $ea111247103d173e$export$dc1f825c64ccdff6 = {
    HELP_HUB: 'HELP_HUB'
};
const $ea111247103d173e$export$939aa9ef868c885e = 'hubConnectExtension';
const $ea111247103d173e$export$7bb2524ff74eaaaa = 'hubConnectExtensionConfig';
const $ea111247103d173e$export$88cc63a4344dc0e3 = 'https://developer.atlassian.com/platform/forge/manifest-reference/modules/index-jsm/';
module.exports["HUB_CONNECT_EXTENSION_TYPE"] = $ea111247103d173e$export$9739bc39ff578ef;
module.exports["isFooterExtensionKey"] = $ea111247103d173e$export$5672169d8cc92b0b;
module.exports["HUB_CONNECT_LEARN_MORE_URL"] = $ea111247103d173e$export$88cc63a4344dc0e3;

});

parcelRegister("239dQ", function(module, exports) {
/**
 * Reverse-DNS identifier carried in ADF `extension` nodes for a Hub Forge
 * extension. Must remain stable across product releases — changing it is a
 * breaking change to persisted hub content.
 *
 * Mirrors the Help Center Forge module shape so that Forge UI Kit / Custom UI
 * extensions can be shared between Help Center and Hub editors.
 */ const $cb776784963775a4$export$28815926b67771e7 = 'com.atlassian.hub-forge';
const $cb776784963775a4$export$e1401e10db30b53d = 'hub-forge';
const $cb776784963775a4$export$bbd2284a8b6f23d6 = `${$cb776784963775a4$export$e1401e10db30b53d}-header`;
const $cb776784963775a4$export$9204604618f84769 = `${$cb776784963775a4$export$e1401e10db30b53d}-footer`;
const $cb776784963775a4$export$4fd744a56941aef9 = '1.0.0';
const $cb776784963775a4$export$f351bc2072386324 = {
    HEADER_AND_SUB_HEADER_PANELS: 'headerAndSubheaderPanels',
    FOOTER_PANELS: 'footerPanels'
};
const $cb776784963775a4$export$ed5f67b6b84eb2bf = {
    HELP_HUB: 'HELP_HUB',
    CSM_HELP_CENTER: 'CSM_HELP_CENTER'
};
const $cb776784963775a4$export$a4c5610f6315d2b8 = 'hubForgeExtension';
const $cb776784963775a4$export$10977f18dbecea4f = 'hubForgeExtensionConfig';
const $cb776784963775a4$export$7e8317652605f123 = 'https://developer.atlassian.com/platform/forge/manifest-reference/modules/index-jsm/';
module.exports["HUB_FORGE_EXTENSION_TYPE"] = $cb776784963775a4$export$28815926b67771e7;
module.exports["HUB_FORGE_HEADER_EXTENSION_KEY"] = $cb776784963775a4$export$bbd2284a8b6f23d6;
module.exports["HUB_FORGE_FOOTER_EXTENSION_KEY"] = $cb776784963775a4$export$9204604618f84769;
module.exports["HUB_FORGE_LEARN_MORE_URL"] = $cb776784963775a4$export$7e8317652605f123;

});

parcelRegister("1ovy4", function(module, exports) {
const $cd81dce5d98cc0da$export$62b7ac1cc8a8f8d7 = 'com.atlassian.hub.jsm-help';
const $cd81dce5d98cc0da$export$b5a30704f903627a = 'jsm-help';
const $cd81dce5d98cc0da$export$727d928d273126f1 = 'jsmHelpExtension';
const $cd81dce5d98cc0da$export$5eecea5c34e4d0ec = 'jsmHelpExtensionConfig';
const $cd81dce5d98cc0da$export$42fa33c628980eca = '1.0.0';
const $cd81dce5d98cc0da$export$8ec3d08588d2eeda = 9;
const $cd81dce5d98cc0da$export$93c0382b74e40ff9 = {
    SMALL: 'small',
    LARGE: 'large'
};
const $cd81dce5d98cc0da$export$d95e7684b6658cc2 = {
    COMMON_REQUESTS: 'common-requests',
    KB_ARTICLES: 'kb-articles',
    MANUAL: 'manual',
    PORTAL_CARDS: 'portal-cards',
    PORTAL_GROUPS: 'portal-groups'
};
module.exports["JSM_HELP_EXTENSION_TYPE"] = $cd81dce5d98cc0da$export$62b7ac1cc8a8f8d7;
module.exports["JSM_HELP_EXTENSION_CONFIG_ANALYTIC_SOURCE"] = $cd81dce5d98cc0da$export$5eecea5c34e4d0ec;
module.exports["PAGE_SIZE"] = $cd81dce5d98cc0da$export$8ec3d08588d2eeda;
module.exports["SourceType"] = $cd81dce5d98cc0da$export$d95e7684b6658cc2;

});

parcelRegister("6Q9UP", function(module, exports) {
// Constants are renamed from PAGE_TOPPER prefix to CALLOUT_BANNER in anticipation of the extension rename to callout banner.
// Leaving the extension and type strings as page-topper, however, as the extension has already been added to a few instances
const $d8a24fb3c82801ff$export$5eb13835d9fc35c6 = 'page-topper';
const $d8a24fb3c82801ff$export$1e0076557b3776e7 = 'com.atlassian.confluence.page-topper';
const $d8a24fb3c82801ff$export$bbe74ef6b7213123 = 'calloutBannerExtension';
module.exports["CALLOUT_BANNER_EXTENSION_TYPE"] = $d8a24fb3c82801ff$export$1e0076557b3776e7;
module.exports["CALLOUT_BANNER_EXTENSION_ANALYTIC_SOURCE"] = $d8a24fb3c82801ff$export$bbe74ef6b7213123;

});

parcelRegister("3cB3o", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $03RpJ = parcelRequire("03RpJ");


var $bdpeX = parcelRequire("bdpeX");


var $b8pma = parcelRequire("b8pma");


var $jWbXj = parcelRequire("jWbXj");


var $hjUDQ = parcelRequire("hjUDQ");

var $bktnv = parcelRequire("bktnv");


var $dBD3L = parcelRequire("dBD3L");


var $ikd73 = parcelRequire("ikd73");


var $k6H3Z = parcelRequire("k6H3Z");


const $2d3bd5d3eb9f3cb4$var$CardsExtension = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "JDp8H",
    name: "CardsExtension",
    loader: async ()=>(await (parcelRequire("1eLRV"))).CardsExtension,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "cards-extension-loader"
        })
});
const $2d3bd5d3eb9f3cb4$export$b7316deff43c35f7 = (imageSrc, imageAltText)=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        cardId: (0, $03RpJ.default)(),
        link: '',
        isLinkUserEdited: false,
        title: '',
        isTitleUserEdited: false,
        description: '',
        isDescriptionUserEdited: false,
        imageSrc: imageSrc,
        imagePosition: (0, $ikd73.ImagePosition).MIDDLE,
        imageAltText: imageAltText
    });
let $2d3bd5d3eb9f3cb4$var$cards = null;
const $2d3bd5d3eb9f3cb4$export$adc082ec96ce9cca = ()=>{
    if ($2d3bd5d3eb9f3cb4$var$cards) return $2d3bd5d3eb9f3cb4$var$cards;
    return $2d3bd5d3eb9f3cb4$var$cards = (0, $dBD3L.CARDS_IMAGES_V5).map(({ src: src, alt: alt })=>$2d3bd5d3eb9f3cb4$export$b7316deff43c35f7(src, alt));
};
const $2d3bd5d3eb9f3cb4$export$611063def302f5f2 = ({ extensionTitle: extensionTitle, defaultParameters: defaultParameters })=>{
    const parameters = {
        size: (0, $hjUDQ.Height).MEDIUM,
        cards: $2d3bd5d3eb9f3cb4$export$adc082ec96ce9cca(),
        isAvatarShown: false,
        isPublishDateShown: false,
        extensionTitle: extensionTitle,
        version: (0, $dBD3L.CARDS_EXTENSION_VERSION_5),
        renderVariant: (0, $hjUDQ.RenderVariant).MANUAL,
        isSegmentationShown: false,
        orientation: (0, $ikd73.Orientation).STACKED,
        alignment: (0, $ikd73.Alignment).CENTER,
        isAutoscrollEnabled: false,
        backgroundColor: defaultParameters?.backgroundColor ?? "var(--ds-surface-overlay, #FFFFFF)",
        textColor: defaultParameters?.textColor ?? "var(--ds-text, #292A2E)",
        cornerStyle: (0, $hjUDQ.CornerStyle).ROUNDED,
        isSocialStatsShown: false,
        isIconShown: true,
        layout: (0, $ikd73.CardsLayout).FIXED_IMAGE_HEIGHT,
        isPaddingEnabled: true,
        isLabelShown: true,
        borderColor: (0, $jWbXj.DEFAULT_GRAY_COLOR),
        isDescriptionShown: true
    };
    return parameters;
};

const $2d3bd5d3eb9f3cb4$export$c0798477a3103ad2 = ({ contentId: contentId, propsProvider: propsProvider, mode: mode, defaultParameters: defaultParameters })=>{
    return async ({ editorActions: editorActions, openConfigPanel: openConfigPanel, intl: intl, setUpsellModalSource: setUpsellModalSource })=>{
        const parameters = $2d3bd5d3eb9f3cb4$export$611063def302f5f2({
            extensionTitle: intl.formatMessage((0, $k6H3Z.messages).linkCardsMacroTitle),
            defaultParameters: defaultParameters
        });
        return new (0, $bdpeX.default)([
            (0, $bktnv.getExtensionManifest)({
                title: intl.formatMessage((0, $k6H3Z.messages).linkCardsMacroTitle),
                type: (0, $dBD3L.CARDS_EXTENSION_TYPE),
                key: (0, $dBD3L.CARDS_EXTENSION_KEY),
                description: intl.formatMessage((0, $k6H3Z.messages).linkCardsMacroDescription),
                icons: {
                    '48': ()=>(parcelRequire("hEygB")).then((mod)=>mod.CardsExtensionIcon)
                },
                parameters: parameters,
                update: async ()=>{
                    const selectedNode = editorActions?.getSelectedNode()?.toJSON();
                    const selectedLocalId = selectedNode?.attrs?.localId;
                    if (!!selectedLocalId && openConfigPanel) openConfigPanel(selectedLocalId);
                },
                render: async ()=>({ node: node })=>{
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2d3bd5d3eb9f3cb4$var$CardsExtension, {
                            extensionNode: node,
                            contentId: contentId,
                            propsProvider: propsProvider,
                            mode: mode
                        });
                    },
                quickInsertAction: async ()=>Promise.resolve({
                        type: 'extension',
                        key: (0, $dBD3L.CARDS_EXTENSION_KEY),
                        attrs: {
                            extensionType: (0, $dBD3L.CARDS_EXTENSION_TYPE),
                            extensionKey: (0, $dBD3L.CARDS_EXTENSION_KEY),
                            layout: 'default',
                            parameters: parameters
                        }
                    }),
                source: 'premiumCardsInsert',
                setUpsellModalSource: setUpsellModalSource
            })
        ]);
    };
};
module.exports["getDefaultCards"] = $2d3bd5d3eb9f3cb4$export$adc082ec96ce9cca;
module.exports["getCardsExtensionParameters"] = $2d3bd5d3eb9f3cb4$export$611063def302f5f2;
module.exports["cardsExtensionProvider"] = $2d3bd5d3eb9f3cb4$export$c0798477a3103ad2;

});

parcelRegister("bdpeX", function(module, exports) {

var $54Kws = parcelRequire("54Kws");

class $88516670672fc955$export$2e2bcd8739ae039 {
    getExtensions() {
        return this.manifestsPromise;
    }
    async preload() {
        this.manifestsCache = await this.getExtensions();
        const preloadCalls = [];
        for (const manifest of this.manifestsCache){
            const nodes = manifest?.modules?.nodes;
            if (nodes) Object.values(nodes).forEach((node)=>{
                preloadCalls.push(node?.preloadRender?.());
            });
        }
        await Promise.allSettled(preloadCalls);
    }
    getPreloadedExtension(type, key) {
        if (!this.manifestsCache) return;
        return this.getExtensionFromManifest(this.manifestsCache, type, key);
    }
    async getExtension(type, key) {
        return this.getExtensionFromManifest(await this.manifestsPromise, type, key);
    }
    getExtensionFromManifest(manifests, type, key) {
        const extension = manifests.find((manifest)=>manifest.type === type && manifest.key === key);
        if (!extension) throw new Error(`Extension with type "${type}" and key "${key}" not found!`);
        return extension;
    }
    async search(keyword) {
        const extensions = (await this.manifestsPromise).filter((manifest)=>manifest.title.toLowerCase().includes(keyword.toLowerCase()));
        return extensions;
    }
    async getAutoConverter() {
        if (this.autoConvertHandlers) return this.autoConvertHandlers;
        const autoConverters = (0, $54Kws.getAutoConvertPatternsFromModule)(await this.manifestsPromise);
        return autoConverters;
    }
    constructor(manifests, /**
   * Allows for an optional list of pre compiled auto convert handlers to be passed.
   * Useful for performance improvements or to support legacy converters.
   *
   * Warning: If this attribute is passed, this provider will ignore auto convert patterns from the manifests.
   */ autoConvertHandlers){
        this.manifestsPromise = void 0;
        this.manifestsCache = [];
        this.autoConvertHandlers = void 0;
        this.manifestsPromise = Promise.resolve(manifests);
        this.autoConvertHandlers = autoConvertHandlers;
    }
}
module.exports["default"] = $88516670672fc955$export$2e2bcd8739ae039;

});

parcelRegister("54Kws", function(module, exports) {
async function $4782fc034cf1736f$export$60407594ea5edd1c(extensions) {
    const items = await Promise.all(extensions.map((manifest)=>{
        if (manifest.modules.autoConvert && manifest.modules.autoConvert.url) return manifest.modules.autoConvert.url;
        return [];
    }));
    return [].concat(...items);
}
module.exports["getAutoConvertPatternsFromModule"] = $4782fc034cf1736f$export$60407594ea5edd1c;

});

parcelRegister("jWbXj", function(module, exports) {

var $4sYZY = parcelRequire("4sYZY");

const $11c45b8a95b8a6be$export$47962e37d9fd03c7 = (0, $4sYZY.knownBackgroundColors)[10];
module.exports["DEFAULT_GRAY_COLOR"] = $11c45b8a95b8a6be$export$47962e37d9fd03c7;

});

parcelRegister("hjUDQ", function(module, exports) {
var $3f94275ae089f93c$export$bdc3c19374266b98 = /*#__PURE__*/ function(ButtonStyle) {
    ButtonStyle["DEFAULT"] = "default";
    ButtonStyle["ALTERNATIVE_1"] = "alternative_1";
    return ButtonStyle;
}({});
var $3f94275ae089f93c$export$a6e645fda5339bf8 = /*#__PURE__*/ function(CornerStyle) {
    CornerStyle["ROUNDED"] = "rounded";
    CornerStyle["SQUARED"] = "squared";
    return CornerStyle;
}({});
var $3f94275ae089f93c$export$8954cfac7c08d16a = /*#__PURE__*/ function(Height) {
    Height["MEDIUM"] = "medium";
    Height["SMALL"] = "small";
    Height["LARGE"] = "large";
    return Height;
}({});
var $3f94275ae089f93c$export$9d7927214ed7d2cf = /*#__PURE__*/ function(Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["RIGHT"] = "right";
    Alignment["CENTER"] = "center";
    return Alignment;
}({});
var $3f94275ae089f93c$export$df54d73aa0ec5e82 = /*#__PURE__*/ function(Orientation) {
    Orientation["ROW"] = "row";
    Orientation["STACKED"] = "stacked";
    return Orientation;
}({});
var $3f94275ae089f93c$export$21e76ed09a093e97 = /*#__PURE__*/ function(CardLayout) {
    CardLayout["FOLDERS"] = "folders";
    CardLayout["ACCORDIONS"] = "accordions";
    return CardLayout;
}({});
var $3f94275ae089f93c$export$42809f9f1496f50d = /*#__PURE__*/ function(CommonLayout) {
    CommonLayout["FRAME_ABOVE_IMAGE"] = "frame-above-image";
    CommonLayout["SPLIT_IMAGE_RIGHT"] = "split-image-right";
    CommonLayout["SPLIT_IMAGE_LEFT"] = "split-image-left";
    CommonLayout["FULL_IMAGE_BACKGROUND"] = "full-image-background";
    CommonLayout["NO_IMAGE_BACKGROUND"] = "no-image-background";
    return CommonLayout;
}({});
var $3f94275ae089f93c$export$d4c0482bf980ef26 = /*#__PURE__*/ function(FeedbackType) {
    FeedbackType["CARDS"] = "Cards";
    FeedbackType["CAROUSEL"] = "Carousel";
    FeedbackType["COMPANY_HUB"] = "Company hub";
    FeedbackType["CUSTOMIZE_NAVIGATION"] = "Customize Navigation";
    FeedbackType["LINKS_MENU"] = "Links menu";
    FeedbackType["SPOTLIGHT"] = "Spotlight";
    FeedbackType["SECTION"] = "Section";
    FeedbackType["CUSTOM_SEARCH"] = "Custom search";
    return FeedbackType;
}({});
var $3f94275ae089f93c$export$533ae1c1b7b7ac6 = /*#__PURE__*/ function(ExtensionMode) {
    ExtensionMode["RENDERER"] = "renderer";
    ExtensionMode["EDITOR"] = "editor";
    return ExtensionMode;
}({});
const $3f94275ae089f93c$export$cb307dad255adf47 = 'epic.logout.LOG_OUT';
var $3f94275ae089f93c$export$1f60141b6ce5efed = /*#__PURE__*/ function(RenderVariant) {
    RenderVariant["MANUAL"] = "manual";
    RenderVariant["DYNAMIC"] = "dynamic";
    return RenderVariant;
}({});
var $3f94275ae089f93c$export$f6cd408cac7f930c = /*#__PURE__*/ function(SegmentationTargets) {
    SegmentationTargets["ALL"] = "all";
    SegmentationTargets["EACH"] = "each";
    return SegmentationTargets;
}({});
var $3f94275ae089f93c$export$bf7ebf7fed6e7189 = /*#__PURE__*/ function(ITEM_FIELDS) {
    ITEM_FIELDS["CARD_ID"] = "cardId";
    ITEM_FIELDS["TITLE"] = "title";
    ITEM_FIELDS["IS_TITLE_USER_EDITED"] = "isTitleUserEdited";
    ITEM_FIELDS["DESCRIPTION"] = "description";
    ITEM_FIELDS["IS_DESCRIPTION_USER_EDITED"] = "isDescriptionUserEdited";
    ITEM_FIELDS["IS_DESCRIPTION_SHOWN"] = "isDescriptionShown";
    ITEM_FIELDS["LABEL"] = "label";
    ITEM_FIELDS["IS_LABEL_HIDDEN"] = "isLabelHidden";
    ITEM_FIELDS["LINK"] = "link";
    ITEM_FIELDS["IS_LINK_USER_EDITED"] = "isLinkUserEdited";
    ITEM_FIELDS["IMAGE_SRC"] = "imageSrc";
    ITEM_FIELDS["CONFLUENCE_PAGE_ID"] = "confluencePageId";
    ITEM_FIELDS["IMAGE_ALT_TEXT"] = "imageAltText";
    ITEM_FIELDS["SEGMENTATION_TARGETS"] = "segmentationTarget";
    ITEM_FIELDS["AUDIENCE_SEGMENTATION_GROUP_IDS"] = "audienceSegmentationGroupIds";
    // group preferences stored via this field when segmentationTarget is EACH
    ITEM_FIELDS["LINK_RESOURCE_TYPE"] = "linkResourceType";
    ITEM_FIELDS["BACKGROUND_COLOR"] = "backgroundColor";
    ITEM_FIELDS["TEXT_COLOR"] = "textColor";
    ITEM_FIELDS["LABEL_COLOR"] = "labelColor";
    ITEM_FIELDS["LAYOUT"] = "layout";
    ITEM_FIELDS["IS_BUTTON_SHOWN"] = "isButtonShown";
    ITEM_FIELDS["BUTTON_TEXT"] = "buttonText";
    ITEM_FIELDS["BUTTON_STYLE"] = "buttonStyle";
    ITEM_FIELDS["HEIGHT"] = "height";
    return ITEM_FIELDS;
}({});
module.exports["ButtonStyle"] = $3f94275ae089f93c$export$bdc3c19374266b98;
module.exports["CornerStyle"] = $3f94275ae089f93c$export$a6e645fda5339bf8;
module.exports["Height"] = $3f94275ae089f93c$export$8954cfac7c08d16a;
module.exports["Alignment"] = $3f94275ae089f93c$export$9d7927214ed7d2cf;
module.exports["Orientation"] = $3f94275ae089f93c$export$df54d73aa0ec5e82;
module.exports["CardLayout"] = $3f94275ae089f93c$export$21e76ed09a093e97;
module.exports["CommonLayout"] = $3f94275ae089f93c$export$42809f9f1496f50d;
module.exports["FeedbackType"] = $3f94275ae089f93c$export$d4c0482bf980ef26;
module.exports["ExtensionMode"] = $3f94275ae089f93c$export$533ae1c1b7b7ac6;
module.exports["RenderVariant"] = $3f94275ae089f93c$export$1f60141b6ce5efed;
module.exports["SegmentationTargets"] = $3f94275ae089f93c$export$f6cd408cac7f930c;
module.exports["ITEM_FIELDS"] = $3f94275ae089f93c$export$bf7ebf7fed6e7189;

});

parcelRegister("ikd73", function(module, exports) {

var $hjUDQ = parcelRequire("hjUDQ");

const $c4cfc07151927f65$export$12c9c8946ce83b13 = 3;
var $c4cfc07151927f65$export$df54d73aa0ec5e82 = /*#__PURE__*/ function(Orientation) {
    Orientation["ROW"] = "row";
    Orientation["STACKED"] = "stacked";
    return Orientation;
}({});
var $c4cfc07151927f65$export$9d7927214ed7d2cf = /*#__PURE__*/ function(Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["CENTER"] = "center";
    Alignment["RIGHT"] = "right";
    return Alignment;
}({});
var $c4cfc07151927f65$export$a1ccd8e6c4b447b2 = /*#__PURE__*/ function(ImagePosition) {
    ImagePosition["TOP"] = "top";
    ImagePosition["MIDDLE"] = "middle";
    ImagePosition["BOTTOM"] = "bottom";
    return ImagePosition;
}({});
var $c4cfc07151927f65$export$9eefe1d63a5bbb7e = /*#__PURE__*/ function(CardsLayout) {
    CardsLayout["FIXED_IMAGE_HEIGHT"] = "fixed-image-height";
    CardsLayout["FLEXIBLE_IMAGE_HEIGHT"] = "flexible-image-height";
    return CardsLayout;
}({});
module.exports["DEFAULT_DYNAMIC_CARDS_COUNT"] = $c4cfc07151927f65$export$12c9c8946ce83b13;
module.exports["Orientation"] = $c4cfc07151927f65$export$df54d73aa0ec5e82;
module.exports["Alignment"] = $c4cfc07151927f65$export$9d7927214ed7d2cf;
module.exports["ImagePosition"] = $c4cfc07151927f65$export$a1ccd8e6c4b447b2;
module.exports["CardsLayout"] = $c4cfc07151927f65$export$9eefe1d63a5bbb7e;

});

parcelRegister("k6H3Z", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $fbaae2277b7ffffa$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    linkCardsMacroTitle: {
        id: "company-hub.cards-extension.manifest.macro-title",
        defaultMessage: "Cards"
    },
    linkCardsMacroDescription: {
        id: "company-hub.cards-extension.manifest.macro-description",
        defaultMessage: "Display links as cards"
    }
});
module.exports["messages"] = $fbaae2277b7ffffa$export$defe85febe8b728c;

});

parcelRegister("1eLRV", function(module, exports) {

let $0e6c3affea165f7e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0e6c3affea165f7e$var$load("lya9W"),
    $0e6c3affea165f7e$var$load("gNPMO"),
    $0e6c3affea165f7e$var$load("jfSwd"),
    $0e6c3affea165f7e$var$load("1dC87"),
    $0e6c3affea165f7e$var$load("3fvOY"),
    $0e6c3affea165f7e$var$load("9vDBp"),
    $0e6c3affea165f7e$var$load("ca0UP"),
    $0e6c3affea165f7e$var$load("a92TB"),
    $0e6c3affea165f7e$var$load("c7nj5"),
    $0e6c3affea165f7e$var$load("1yIye"),
    $0e6c3affea165f7e$var$load("4zz48"),
    $0e6c3affea165f7e$var$load("39XCn"),
    $0e6c3affea165f7e$var$load("jw3lv"),
    $0e6c3affea165f7e$var$load("7rqWx"),
    $0e6c3affea165f7e$var$load("aIze1"),
    $0e6c3affea165f7e$var$load("3Cky6"),
    $0e6c3affea165f7e$var$load("kG5Ju"),
    $0e6c3affea165f7e$var$load("il8bj"),
    $0e6c3affea165f7e$var$load("6wr18"),
    $0e6c3affea165f7e$var$load("ffEVr"),
    $0e6c3affea165f7e$var$load("aFLSJ"),
    $0e6c3affea165f7e$var$load("6bjEk"),
    $0e6c3affea165f7e$var$load("iYZAq")
]).then(()=>parcelRequire('bJeU6'));

});

parcelRegister("hEygB", function(module, exports) {

let $cda0c0c6400df198$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cda0c0c6400df198$var$load("auqwj").then(()=>parcelRequire('ndfyJ'));

});

parcelRegister("FSvRW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $bdpeX = parcelRequire("bdpeX");


var $b8pma = parcelRequire("b8pma");


var $hjUDQ = parcelRequire("hjUDQ");

var $bktnv = parcelRequire("bktnv");


var $gXR7h = parcelRequire("gXR7h");


var $cT2iI = parcelRequire("cT2iI");


var $kQY3C = parcelRequire("kQY3C");


const $154eb2ea90f80053$var$CarouselExtension = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "g5PGT",
    name: "CarouselExtension",
    loader: async ()=>(await (parcelRequire("bLH3C"))).CarouselExtension,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "carousel-extension-loader"
        })
});
const $154eb2ea90f80053$var$carouselFrames = [
    {
        imageSrc: (0, $cT2iI.FRAME_V2_DEFAULT_IMAGE_SRC),
        layout: (0, $hjUDQ.CommonLayout).SPLIT_IMAGE_LEFT
    },
    {
        imageSrc: (0, $cT2iI.FRAME_V2_DEFAULT_IMAGE_SRC),
        layout: (0, $hjUDQ.CommonLayout).FRAME_ABOVE_IMAGE
    },
    {
        imageSrc: (0, $cT2iI.FRAME_V2_DEFAULT_IMAGE_SRC),
        layout: (0, $hjUDQ.CommonLayout).SPLIT_IMAGE_RIGHT
    }
];
const $154eb2ea90f80053$var$getV2Frames = ({ intl: intl, defaultParameters: defaultParameters })=>{
    return $154eb2ea90f80053$var$carouselFrames.map(({ imageSrc: imageSrc, layout: layout })=>(0, $cT2iI.createNewFrameWithDefaultParameters)({
            intl: intl,
            defaultParameters: defaultParameters,
            defaultField: {
                imageSrc: imageSrc,
                layout: layout
            }
        }));
};
const $154eb2ea90f80053$export$3339a462074fecc3 = ({ extensionTitle: extensionTitle, intl: intl, defaultParameters: defaultParameters })=>({
        cards: $154eb2ea90f80053$var$getV2Frames({
            intl: intl,
            defaultParameters: defaultParameters
        }),
        extensionTitle: extensionTitle,
        version: (0, $gXR7h.CAROUSEL_VERSION_2),
        ...(0, $cT2iI.carouselNewParametersV2)
    });

const $154eb2ea90f80053$export$e807a589fe0f4d24 = ({ contentId: contentId, propsProvider: propsProvider, defaultParameters: defaultParameters })=>{
    return async ({ editorActions: editorActions, intl: intl, openConfigPanel: openConfigPanel, setUpsellModalSource: setUpsellModalSource })=>{
        const parameters = $154eb2ea90f80053$export$3339a462074fecc3({
            extensionTitle: intl.formatMessage((0, $kQY3C.messages).carouselMacroTitle),
            intl: intl,
            defaultParameters: defaultParameters
        });
        return new (0, $bdpeX.default)([
            (0, $bktnv.getExtensionManifest)({
                title: intl.formatMessage((0, $kQY3C.messages).carouselMacroTitle),
                type: (0, $gXR7h.carouselExtensionType),
                key: (0, $gXR7h.carouselExtensionKey),
                description: intl.formatMessage((0, $kQY3C.messages).carouselMacroDescription),
                icons: {
                    '48': ()=>(parcelRequire("aLOCd")).then((mod)=>mod.CarouselExtensionIcon)
                },
                parameters: parameters,
                update: async ()=>{
                    const selectedNode = editorActions?.getSelectedNode()?.toJSON();
                    const selectedLocalId = selectedNode?.attrs?.localId;
                    if (!!selectedLocalId && openConfigPanel) openConfigPanel(selectedLocalId);
                },
                render: async ()=>({ node: node })=>{
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($154eb2ea90f80053$var$CarouselExtension, {
                            propsProvider: propsProvider,
                            extensionNode: node,
                            contentId: contentId
                        });
                    },
                setUpsellModalSource: setUpsellModalSource,
                source: 'premiumCarouselInsert'
            })
        ]);
    };
};
module.exports["carouselParameters"] = $154eb2ea90f80053$export$3339a462074fecc3;
module.exports["carouselExtensionProvider"] = $154eb2ea90f80053$export$e807a589fe0f4d24;

});

parcelRegister("cT2iI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3AVOh = parcelRequire("3AVOh");


var $kSwu1 = parcelRequire("kSwu1");


var $03RpJ = parcelRequire("03RpJ");


var $9BXp4 = parcelRequire("9BXp4");

var $hiHdh = parcelRequire("hiHdh");

var $bIp5p = parcelRequire("bIp5p");

var $cfM7x = parcelRequire("cfM7x");


var $gXR7h = parcelRequire("gXR7h");


var $hjUDQ = parcelRequire("hjUDQ");

var $4MaGu = parcelRequire("4MaGu");


var $6xHyx = parcelRequire("6xHyx");

const $b4a13313a2d09981$export$3882df2b635374e2 = {
    cornerStyle: (0, $hjUDQ.CornerStyle).ROUNDED,
    isAutoplayEnabled: false,
    navigationStyle: (0, $4MaGu.NavigationStyle).THUMBNAILS
};
const $b4a13313a2d09981$export$b713c3bc8c446d60 = 'https://images.unsplash.com/photo-1488470015861-8bb1317353ef?auto=format&fit=crop&q=80&w=1080';
const $b4a13313a2d09981$export$27643bf44cc02178 = {
    [(0, $hjUDQ.ITEM_FIELDS).BACKGROUND_COLOR]: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    [(0, $hjUDQ.ITEM_FIELDS).TEXT_COLOR]: "var(--ds-text, #292A2E)",
    [(0, $hjUDQ.ITEM_FIELDS).LAYOUT]: (0, $hjUDQ.CommonLayout).SPLIT_IMAGE_RIGHT,
    [(0, $hjUDQ.ITEM_FIELDS).IMAGE_SRC]: $b4a13313a2d09981$export$b713c3bc8c446d60,
    [(0, $hjUDQ.ITEM_FIELDS).IMAGE_ALT_TEXT]: "Close-up of a vibrant green palm leaf\u2019s patterns.",
    buttonText: '',
    buttonStyle: (0, $hjUDQ.ButtonStyle).DEFAULT
};
const $b4a13313a2d09981$export$4f94ab8184143ae6 = {
    imageSrc: 'https://images.unsplash.com/photo-1579547621706-1a9c79d5c9f1?auto=format&fit=crop&q=80&w=1080',
    imageAltText: 'purple and pink light illustration'
};
const $b4a13313a2d09981$export$5d30fc17e786110 = ({ intl: intl, defaultField: defaultField, randomLayout: randomLayout, defaultParameters: defaultParameters })=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        cardId: (0, $03RpJ.default)(),
        link: '',
        isLinkUserEdited: false,
        title: intl.formatMessage((0, $6xHyx.messages).placeholderTitle),
        isTitleUserEdited: false,
        description: intl.formatMessage((0, $6xHyx.messages).placeholderDescription),
        isDescriptionUserEdited: false,
        ...$b4a13313a2d09981$export$4f94ab8184143ae6,
        ...$b4a13313a2d09981$export$27643bf44cc02178,
        ...defaultParameters?.backgroundColor ? {
            [(0, $hjUDQ.ITEM_FIELDS).BACKGROUND_COLOR]: defaultParameters.backgroundColor
        } : {},
        ...defaultParameters?.textColor ? {
            [(0, $hjUDQ.ITEM_FIELDS).TEXT_COLOR]: defaultParameters.textColor
        } : {},
        ...randomLayout && {
            [(0, $hjUDQ.ITEM_FIELDS).LAYOUT]: randomLayout
        },
        ...defaultField
    });
const $b4a13313a2d09981$export$721510bd2cdb9b4f = (link, confluencePageId, isLinkUserEdited)=>{
    return {
        [(0, $hjUDQ.ITEM_FIELDS).LINK]: link,
        [(0, $hjUDQ.ITEM_FIELDS).CONFLUENCE_PAGE_ID]: confluencePageId || '',
        [(0, $hjUDQ.ITEM_FIELDS).IS_LINK_USER_EDITED]: isLinkUserEdited || false
    };
};
const $b4a13313a2d09981$var$fetchLocalIdMacroParameters = ({ editorActions: editorActions, localId: localId })=>{
    var _params, _params1, _params2;
    const localIdNode = editorActions?.getNodeByLocalId?.(localId)?.toJSON();
    let params = localIdNode?.attrs?.parameters;
    if (params === undefined) return undefined;
    // Make a copy of the params object to avoid mutating the original object
    params = {
        ...params
    };
    // If the extension was created prior to removal of type field, remove it from object here
    // This update is/was not done in combination with a feature gate
    delete params['type'];
    params.version = (0, $gXR7h.CAROUSEL_VERSION_2);
    const { cornerStyle: cornerStyle, isAutoplayEnabled: isAutoplayEnabled, navigationStyle: navigationStyle } = $b4a13313a2d09981$export$3882df2b635374e2;
    (_params = params).cornerStyle ?? (_params.cornerStyle = cornerStyle);
    (_params1 = params).isAutoplayEnabled ?? (_params1.isAutoplayEnabled = isAutoplayEnabled);
    (_params2 = params).navigationStyle ?? (_params2.navigationStyle = navigationStyle);
    /* construct frames array with intercepted params */ params.cards = params.cards?.map((frame)=>{
        return {
            ...$b4a13313a2d09981$export$27643bf44cc02178,
            // override BG color back to white for v1 carousels to maintain parity...
            [(0, $hjUDQ.ITEM_FIELDS).BACKGROUND_COLOR]: "var(--ds-background-input, #FFFFFF)",
            // ... but let frame BG color (if already set, eg to default color) override again
            ...(0, (/*@__PURE__*/$parcel$interopDefault($3AVOh)))(frame, [
                'imagePosition'
            ])
        };
    }) || params.cards;
    /* there were card fields added to carousel params that were nonfunctional.
   * reconstructing params to those with them omitted
   */ params = (0, (/*@__PURE__*/$parcel$interopDefault($3AVOh)))(params, [
        'size',
        'isPublishDateShown',
        'isAvatarShown'
    ]);
    return params;
};
const $b4a13313a2d09981$var$updateFrameInList = (frames, cardId, updatedField)=>frames.map((frame)=>{
        if (frame.cardId === cardId) return {
            ...frame,
            ...updatedField
        };
        return frame;
    });
const $b4a13313a2d09981$export$3cf295eeccc933e1 = ({ localId: localId, editorActions: editorActions })=>{
    const { branding: branding } = (0, $cfM7x.useProductDependencies)();
    const defaultParameters = branding?.defaultParameters;
    const [carouselParameters, setCarouselParameters] = (0, $cozmU.useState)($b4a13313a2d09981$var$fetchLocalIdMacroParameters({
        editorActions: editorActions,
        localId: localId
    }));
    const usedLayoutsRef = (0, $cozmU.useRef)(new Set());
    const lastUsedLayoutRef = (0, $cozmU.useRef)(null);
    const { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToEditCardId: setSelectedToEditCardId } = (0, $bIp5p.useExtensionsActions)();
    const { cards: frames } = carouselParameters ?? {};
    const intl = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        const extensionNodeParams = $b4a13313a2d09981$var$fetchLocalIdMacroParameters({
            editorActions: editorActions,
            localId: localId
        });
        setCarouselParameters(extensionNodeParams);
    // we don't want to re-fetch the parameters when the default parameters change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        editorActions,
        localId
    ]);
    const getRandomLayout = (0, $cozmU.useCallback)(()=>{
        const allLayouts = Object.values((0, $hjUDQ.CommonLayout));
        if (usedLayoutsRef.current.size >= allLayouts.length - 1) usedLayoutsRef.current = new Set();
        const availableLayouts = allLayouts.filter((layout)=>!usedLayoutsRef.current.has(layout) && layout !== lastUsedLayoutRef.current);
        const randomIndex = Math.floor(Math.random() * availableLayouts.length);
        const randomLayout = availableLayouts[randomIndex];
        usedLayoutsRef.current.add(randomLayout);
        lastUsedLayoutRef.current = randomLayout;
        return randomLayout;
    }, []);
    const updateExtensionParams = (0, $cozmU.useCallback)((newExtensionParameters)=>{
        setCarouselParameters((prevParams)=>{
            const updatedParams = {
                ...prevParams,
                ...newExtensionParameters
            };
            // Save params to ADF and state
            (0, $hiHdh.updateNodeParameters)(editorActions, updatedParams);
            return updatedParams;
        });
    }, [
        editorActions
    ]);
    const addFrame = (0, $cozmU.useCallback)(()=>{
        const newFrame = $b4a13313a2d09981$export$5d30fc17e786110({
            intl: intl,
            defaultParameters: defaultParameters,
            defaultField: undefined,
            randomLayout: getRandomLayout()
        });
        updateExtensionParams({
            cards: [
                ...(0, $9BXp4.checkItems)(frames) || [],
                newFrame
            ]
        });
        setIsInAutoFocusMode(true);
        setSelectedToEditCardId(newFrame.cardId);
    // no need to re-run when default parameters change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        frames,
        updateExtensionParams,
        setSelectedToEditCardId,
        setIsInAutoFocusMode,
        intl,
        getRandomLayout
    ]);
    const removeFrame = (0, $cozmU.useCallback)((cardId)=>updateExtensionParams({
            cards: frames.filter((frame)=>frame.cardId !== cardId)
        }), [
        frames,
        updateExtensionParams
    ]);
    const updateMainFormField = (0, $cozmU.useCallback)((updatedFields)=>updateExtensionParams(updatedFields), [
        updateExtensionParams
    ]);
    const updateFrameFormField = (0, $cozmU.useCallback)((cardId, updatedField)=>{
        const updatedFrames = $b4a13313a2d09981$var$updateFrameInList(frames, cardId, updatedField);
        updateExtensionParams({
            cards: updatedFrames
        });
    }, [
        frames,
        updateExtensionParams
    ]);
    const carouselActions = (0, $cozmU.useMemo)(()=>({
            addFrame: addFrame,
            removeFrame: removeFrame,
            updateMainFormField: updateMainFormField,
            updateFrameFormField: updateFrameFormField
        }), [
        addFrame,
        removeFrame,
        updateMainFormField,
        updateFrameFormField
    ]);
    return {
        carouselParameters: carouselParameters,
        carouselActions: carouselActions
    };
};
module.exports["carouselNewParametersV2"] = $b4a13313a2d09981$export$3882df2b635374e2;
module.exports["FRAME_V2_DEFAULT_IMAGE_SRC"] = $b4a13313a2d09981$export$b713c3bc8c446d60;
module.exports["frameNewParametersV2"] = $b4a13313a2d09981$export$27643bf44cc02178;
module.exports["createNewFrameWithDefaultParameters"] = $b4a13313a2d09981$export$5d30fc17e786110;
module.exports["updateLinkAndConfluencePageId"] = $b4a13313a2d09981$export$721510bd2cdb9b4f;
module.exports["useCarouselExtensionParametersAndActions"] = $b4a13313a2d09981$export$3cf295eeccc933e1;

});

parcelRegister("9BXp4", function(module, exports) {
const $8d1957872e3de52d$var$validateItemsUrls = (items)=>{
    items.forEach((item)=>{
        if (!!item?.link && !item?.link.startsWith('http')) item.link = '';
    });
};
const $8d1957872e3de52d$export$3831ccf0db7ad748 = (items)=>{
    if (!items || items?.length === 0) return null;
    else if (Array.isArray(items)) {
        $8d1957872e3de52d$var$validateItemsUrls(items);
        return items;
    }
};
module.exports["checkItems"] = $8d1957872e3de52d$export$3831ccf0db7ad748;

});

parcelRegister("cfM7x", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $090373eba5349880$export$49e1053dfc41d188 = /*#__PURE__*/ (0, $cozmU.createContext)({
    // AI and Company Hub
    isCompanyHub: true,
    isHelpHub: false,
    isAdminHubAIEnabled: false,
    enableLinkInputInMediaPicker: false,
    helpCenterAri: '',
    showConfigPreambleSupportLink: false,
    // Shortcuts
    shortcutListener: undefined,
    // Smart cards
    smartCardProviderComponent: undefined,
    // Custom search configuration
    orgId: '',
    userId: '',
    searchConfigProvider: {
        peopleDirectoryUrl: '',
        advancedSearchUrl: '',
        searchSessionId: ''
    },
    displayName: '',
    // Theming
    isSSRProductInDarkMode: undefined,
    branding: undefined,
    hideExtensionBorders: false,
    // Feedback collection
    useFeedbackCollector: undefined,
    // Media providers
    cloudId: '',
    useMediaConfig: undefined,
    createEditorMediaProvider: ()=>Promise.resolve({
            viewMediaClientConfig: {
                authProvider: async ()=>({})
            },
            uploadMediaClientConfig: {
                authProvider: async ()=>({})
            }
        }),
    // Error handling
    submitError: ()=>{},
    markErrorAsHandled: ()=>{},
    errorDisplayComponent: ()=>null,
    errorBoundaryComponent: undefined,
    // Premium upsells
    ConfigUpsellScreen: undefined,
    // Experience tracking
    mediaUploadExperienceTracker: undefined,
    aiDescriptionExperienceTracker: undefined,
    experienceSuccessComponent: ()=>null,
    experienceStopComponent: ()=>null,
    experienceStartComponent: ()=>null,
    // Analytics
    analyticsContext: {},
    // User segmentation
    useSegmentationTargetGroups: ()=>{},
    isTargetAudience: ()=>false,
    // Link picker configuration
    linkPickerConfig: {},
    enableTargeting: false,
    enableUnifiedSearchFeatures: false,
    enableSmartCardsFields: false
});
const $090373eba5349880$export$774887fcc3922763 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    const defaultValue = (0, $cozmU.useContext)($090373eba5349880$export$49e1053dfc41d188);
    let t1;
    if ($[3] !== defaultValue || $[4] !== props) {
        t1 = {
            ...defaultValue,
            ...props
        };
        $[3] = defaultValue;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    const value = t1;
    let t2;
    if ($[6] !== children || $[7] !== value) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($090373eba5349880$export$49e1053dfc41d188.Provider, {
            value: value
        }, children);
        $[6] = children;
        $[7] = value;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ children: children, ...props })=>{
    const defaultValue = (0, $cozmU.useContext)($090373eba5349880$export$49e1053dfc41d188);
    const value = {
        ...defaultValue,
        ...props
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($090373eba5349880$export$49e1053dfc41d188.Provider, {
        value: value
    }, children);
};
const $090373eba5349880$export$8dcbb40932065737 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useProductDependencies() {
    const ctx = (0, $cozmU.useContext)($090373eba5349880$export$49e1053dfc41d188);
    if (!ctx) throw new Error("useProductDependencies must be used within ProductDependenciesProvider");
    return ctx;
} : function useProductDependencies() {
    const ctx = (0, $cozmU.useContext)($090373eba5349880$export$49e1053dfc41d188);
    if (!ctx) throw new Error('useProductDependencies must be used within ProductDependenciesProvider');
    return ctx;
};
module.exports["ProductDependenciesContext"] = $090373eba5349880$export$49e1053dfc41d188;
module.exports["useProductDependencies"] = $090373eba5349880$export$8dcbb40932065737;

});

parcelRegister("4MaGu", function(module, exports) {

var $hjUDQ = parcelRequire("hjUDQ");

var $1c501995ced614fb$export$f8af16d8231e3b4e = /*#__PURE__*/ function(NavigationStyle) {
    NavigationStyle["PROGRESS_CIRCLES"] = "progress-circles";
    NavigationStyle["THUMBNAILS"] = "thumbnails";
    return NavigationStyle;
}({});
var $1c501995ced614fb$export$f34582f4a07dd8dd = /*#__PURE__*/ function(FrameSizes) {
    FrameSizes["NAVIGATION_THUMBNAIL"] = "navigationThumbnail";
    FrameSizes["NAVIGATION_THUMBNAIL_V2"] = "navigationThumbnailV2";
    return FrameSizes;
}({});
const $1c501995ced614fb$export$288376e91ac51845 = {
    ["navigationThumbnailV2"]: {
        minWidth: 200,
        maxWidth: 200,
        height: 40
    },
    ["navigationThumbnail"]: {
        minWidth: 244,
        maxWidth: 250,
        height: 72
    }
};
module.exports["NavigationStyle"] = $1c501995ced614fb$export$f8af16d8231e3b4e;
module.exports["FrameSizes"] = $1c501995ced614fb$export$f34582f4a07dd8dd;
module.exports["framesDimensions"] = $1c501995ced614fb$export$288376e91ac51845;

});

parcelRegister("6xHyx", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $4c669ee071f2a92a$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    placeholderTitle: {
        id: "company-hub.carousel-extension.placeholder.title",
        defaultMessage: "Give your frame a title"
    },
    placeholderDescription: {
        id: "company-hub.carousel-extension.placeholder.description",
        defaultMessage: "Customize this frame to create a rotating carousel."
    }
});
module.exports["messages"] = $4c669ee071f2a92a$export$defe85febe8b728c;

});

parcelRegister("kQY3C", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $7f217df723641388$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    carouselMacroTitle: {
        id: "company-hub.carousel-extension.manifest.macro-title",
        defaultMessage: "Carousel"
    },
    carouselMacroDescription: {
        id: "company-hub.carousel-extension.manifest.macro-description",
        defaultMessage: "Create a rotating trio of dynamic frames."
    }
});
module.exports["messages"] = $7f217df723641388$export$defe85febe8b728c;

});

parcelRegister("bLH3C", function(module, exports) {

let $89157bc534cde35d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $89157bc534cde35d$var$load("1dC87"),
    $89157bc534cde35d$var$load("aQPuI"),
    $89157bc534cde35d$var$load("7i9SF"),
    $89157bc534cde35d$var$load("jfSwd"),
    $89157bc534cde35d$var$load("3fvOY"),
    $89157bc534cde35d$var$load("jgaRb"),
    $89157bc534cde35d$var$load("9vDBp"),
    $89157bc534cde35d$var$load("RI3SR"),
    $89157bc534cde35d$var$load("ca0UP"),
    $89157bc534cde35d$var$load("a92TB"),
    $89157bc534cde35d$var$load("c7nj5"),
    $89157bc534cde35d$var$load("1yIye"),
    $89157bc534cde35d$var$load("6fJCf"),
    $89157bc534cde35d$var$load("duEFL"),
    $89157bc534cde35d$var$load("1pJPT"),
    $89157bc534cde35d$var$load("4zz48"),
    $89157bc534cde35d$var$load("39XCn"),
    $89157bc534cde35d$var$load("jw3lv"),
    $89157bc534cde35d$var$load("7rqWx"),
    $89157bc534cde35d$var$load("aIze1"),
    $89157bc534cde35d$var$load("3Cky6"),
    $89157bc534cde35d$var$load("kG5Ju"),
    $89157bc534cde35d$var$load("il8bj"),
    $89157bc534cde35d$var$load("6wr18"),
    $89157bc534cde35d$var$load("ffEVr"),
    $89157bc534cde35d$var$load("aFLSJ"),
    $89157bc534cde35d$var$load("6bjEk"),
    $89157bc534cde35d$var$load("497bd")
]).then(()=>parcelRequire('8KbPy'));

});

parcelRegister("aLOCd", function(module, exports) {

let $7d758e55020cd90e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7d758e55020cd90e$var$load("9Yv0C").then(()=>parcelRequire('a6YUh'));

});

parcelRegister("6THkE", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $03RpJ = parcelRequire("03RpJ");


var $bdpeX = parcelRequire("bdpeX");


var $b8pma = parcelRequire("b8pma");


var $bktnv = parcelRequire("bktnv");


var $bQmwQ = parcelRequire("bQmwQ");


var $8Yw12 = parcelRequire("8Yw12");


var $da5jE = parcelRequire("da5jE");

const $bbbb0ea9e387a71a$var$LINKS_MENU_VERSION_1 = '1';

const $bbbb0ea9e387a71a$var$LinksMenuExtension = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "l5-_n",
    name: "LinksMenuExtension",
    loader: async ()=>(await (parcelRequire("e7A1R"))).LinksMenuExtension,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "links-menu-extension-loader"
        })
});
const $bbbb0ea9e387a71a$export$e0faacd43528e300 = {
    alignment: (0, $8Yw12.ALIGNMENT).CENTER,
    fillColor: "var(--ds-surface-overlay, #FFFFFF)",
    borderColor: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    border: (0, $8Yw12.BORDER).NONE,
    cornerStyle: (0, $8Yw12.CORNERS).SHARP,
    textColor: "var(--ds-text, #292A2E)",
    highlightColor: "var(--ds-text, #292A2E)"
};
const $bbbb0ea9e387a71a$var$getParameters = ({ formatMessage: formatMessage, defaultParameters: defaultParameters })=>({
        extensionTitle: formatMessage((0, $da5jE.messages).lozengeTitle),
        version: $bbbb0ea9e387a71a$var$LINKS_MENU_VERSION_1,
        styles: {
            ...$bbbb0ea9e387a71a$export$e0faacd43528e300,
            // Pre-v2 behaviour (preserved verbatim from master): when help-center
            // passes `defaultParameters` (legacy `var(--hub-primary-color, ...)`
            // shape), both `fillColor` AND `borderColor` mirror the brand-tinted
            // bg so the menu chip blends visually with the rest of the page chrome.
            ...defaultParameters?.backgroundColor ? {
                fillColor: defaultParameters.backgroundColor,
                borderColor: defaultParameters.backgroundColor
            } : {},
            // Advanced-theming (v2) override: spec says the day-0 border for new
            // links-menu inserts should be the neutral `color.border` hex, not the
            // bg-mirroring shade above. Fires *after* the legacy block so it wins.
            // Gated explicitly on the v2 flag — legacy help-center, Confluence,
            // and CSM all see `isAdvancedThemingEnabled !== true` and skip this.
            ...defaultParameters?.isAdvancedThemingEnabled ? {
                borderColor: '#DCDFE4'
            } : {},
            // Corner default is gate-aware. The legacy default is `CORNERS.SHARP`,
            // which the gated render maps to a 0px *local override* — so a brand-new
            // menu would be pinned to 0px and never follow the hub-wide radius. When
            // advanced theming is on, default to `CORNERS.ROUND` instead: it resolves
            // to "no override", so the menu inherits (and keeps tracking)
            // `--hub-corner-radius` until the admin picks an explicit value on the
            // slider. Gate off (Confluence Company Hub / CSM / legacy) keeps SHARP.
            ...defaultParameters?.isAdvancedThemingEnabled ? {
                cornerStyle: (0, $8Yw12.CORNERS).ROUND
            } : {},
            ...defaultParameters?.textColor ? {
                textColor: defaultParameters.textColor,
                highlightColor: defaultParameters.textColor
            } : {}
        },
        items: [
            {
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                itemId: (0, $03RpJ.default)(),
                type: (0, $8Yw12.ITEM).LINK,
                title: formatMessage((0, $da5jE.messages).firstDefaultItem),
                link: ''
            },
            {
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                itemId: (0, $03RpJ.default)(),
                type: (0, $8Yw12.ITEM).LINK,
                title: formatMessage((0, $da5jE.messages).secondDefaultItem),
                link: ''
            },
            {
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                itemId: (0, $03RpJ.default)(),
                type: (0, $8Yw12.ITEM).MENU,
                title: formatMessage((0, $da5jE.messages).thirdDefaultItem),
                childItems: [
                    {
                        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                        itemId: (0, $03RpJ.default)(),
                        type: (0, $8Yw12.ITEM).LINK,
                        title: formatMessage((0, $da5jE.messages).nestedDefaultItem),
                        link: ''
                    }
                ]
            }
        ]
    });

const $bbbb0ea9e387a71a$export$7c3934f2ad869115 = async ({ contentId: contentId, propsProvider: propsProvider, mode: mode, defaultParameters: defaultParameters })=>{
    return async ({ editorActions: editorActions, openConfigPanel: openConfigPanel, intl: intl })=>{
        const parameters = $bbbb0ea9e387a71a$var$getParameters({
            formatMessage: intl.formatMessage,
            defaultParameters: defaultParameters
        });
        return new (0, $bdpeX.default)([
            (0, $bktnv.getExtensionManifest)({
                title: intl.formatMessage((0, $da5jE.messages).lozengeTitle),
                type: (0, $bQmwQ.LINKS_MENU_EXTENSION_TYPE),
                key: 'links-menu',
                description: intl.formatMessage((0, $da5jE.messages).linksMenuDescription),
                icons: {
                    '48': ()=>(parcelRequire("1rKaD")).then((mod)=>mod.LinksMenuExtensionIcon)
                },
                parameters: parameters,
                update: async ()=>{
                    const selectedNode = editorActions?.getSelectedNode()?.toJSON();
                    const selectedLocalId = selectedNode?.attrs?.localId;
                    if (!!selectedLocalId && openConfigPanel) openConfigPanel(selectedLocalId);
                },
                render: async ()=>({ node: node })=>{
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bbbb0ea9e387a71a$var$LinksMenuExtension, {
                            extensionNode: node,
                            contentId: contentId,
                            propsProvider: propsProvider,
                            mode: mode
                        });
                    },
                // @TODO add links menu upsell in COMPHUB-2408
                setUpsellModalSource: undefined,
                source: 'premiumCarouselInsert'
            })
        ]);
    };
};
module.exports["DEFAULT_STYLES"] = $bbbb0ea9e387a71a$export$e0faacd43528e300;
module.exports["linksMenuExtensionProvider"] = $bbbb0ea9e387a71a$export$7c3934f2ad869115;

});

parcelRegister("8Yw12", function(module, exports) {
var $9938aa9e143976c7$export$25d99ac3e552cf7a = /*#__PURE__*/ function(ITEM) {
    ITEM["LINK"] = "link";
    ITEM["MENU"] = "menu";
    return ITEM;
}({});
var $9938aa9e143976c7$export$470d0905851e47a1 = /*#__PURE__*/ function(ALIGNMENT) {
    ALIGNMENT["LEFT"] = "left";
    ALIGNMENT["CENTER"] = "center";
    ALIGNMENT["RIGHT"] = "right";
    return ALIGNMENT;
}({});
var $9938aa9e143976c7$export$8a9179e387c60c17 = /*#__PURE__*/ function(BORDER) {
    BORDER["NONE"] = "none";
    BORDER["ALL_SIDES"] = "all_sides";
    BORDER["BOTTOM"] = "bottom";
    return BORDER;
}({});
var $9938aa9e143976c7$export$87780c3e8dee494d = /*#__PURE__*/ function(CORNERS) {
    CORNERS["ROUND"] = "round";
    CORNERS["SHARP"] = "sharp";
    return CORNERS;
}({});
module.exports["ITEM"] = $9938aa9e143976c7$export$25d99ac3e552cf7a;
module.exports["ALIGNMENT"] = $9938aa9e143976c7$export$470d0905851e47a1;
module.exports["BORDER"] = $9938aa9e143976c7$export$8a9179e387c60c17;
module.exports["CORNERS"] = $9938aa9e143976c7$export$87780c3e8dee494d;

});

parcelRegister("da5jE", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $4296b183500f3807$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    lozengeTitle: {
        id: "company-hub.links-menu-extension.manifest.extension-lozenge-title",
        defaultMessage: "Links menu"
    },
    linksMenuDescription: {
        id: "company-hub.links-menu-extension.manifest.extension-description",
        defaultMessage: "Add multiple links and sub-menus to Company Hub"
    },
    firstDefaultItem: {
        id: "company-hub.links-menu-extension.manifest.first-default-item",
        defaultMessage: "About us"
    },
    secondDefaultItem: {
        id: "company-hub.links-menu-extension.manifest.second-default-item",
        defaultMessage: "Benefits"
    },
    thirdDefaultItem: {
        id: "company-hub.links-menu-extension.manifest.third-default-item",
        defaultMessage: "Teams"
    },
    nestedDefaultItem: {
        id: "company-hub.links-menu-extension.manifest.nested-default-item",
        defaultMessage: "Team 1"
    }
});
module.exports["messages"] = $4296b183500f3807$export$defe85febe8b728c;

});

parcelRegister("e7A1R", function(module, exports) {

let $a47daab8b7445f49$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a47daab8b7445f49$var$load("6vAHn").then(()=>parcelRequire('1wiCI'));

});

parcelRegister("1rKaD", function(module, exports) {

let $10dc20922be43d56$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $10dc20922be43d56$var$load("hAyMj").then(()=>parcelRequire('jEIhu'));

});

parcelRegister("87QCv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $bdpeX = parcelRequire("bdpeX");


var $b8pma = parcelRequire("b8pma");


var $bktnv = parcelRequire("bktnv");

var $5KWZf = parcelRequire("5KWZf");


var $jDh8Q = parcelRequire("jDh8Q");


var $69Xl7 = parcelRequire("69Xl7");


const $cfc0028c4e22d32a$var$SectionExtension = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "r-pUQ",
    name: "SectionExtension",
    loader: async ()=>(await (parcelRequire("8TuI0"))).SectionExtension,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "section-extension-loader"
        })
});
const $cfc0028c4e22d32a$var$sectionParameters = (intl, defaultBackgroundColor)=>({
        extensionTitle: intl.formatMessage((0, $69Xl7.messages).lozengeTitle),
        backgroundColor: defaultBackgroundColor,
        contentWidth: (0, $jDh8Q.DEFAULT_CONTENT_WIDTH)
    });

const $cfc0028c4e22d32a$export$6775abcfdb3b0453 = ({ getSectionExtensionContents: getSectionExtensionContents, mode: mode, propsProvider: propsProvider, defaultParameters: defaultParameters })=>async ({ contentId: contentId, editorActions: editorActions, openConfigPanel: openConfigPanel, intl: intl })=>{
        const title = intl.formatMessage((0, $69Xl7.messages).lozengeTitle);
        const description = intl.formatMessage((0, $69Xl7.messages).description);
        // Only honour the v2 seed when advanced theming is on. Falls back to the
        // legacy `DEFAULT_BACKGROUND_COLOR` for Confluence/CSM/gate-OFF help-center.
        const defaultBackgroundColor = defaultParameters?.isAdvancedThemingEnabled && defaultParameters.backgroundColor ? defaultParameters.backgroundColor : (0, $jDh8Q.DEFAULT_BACKGROUND_COLOR);
        const parameters = $cfc0028c4e22d32a$var$sectionParameters(intl, defaultBackgroundColor);
        const type = (0, $5KWZf.SECTION_EXTENSION_TYPE);
        const key = (0, $jDh8Q.SECTION_EXTENSION_KEY);
        const initialContentText = {
            header: intl.formatMessage((0, $69Xl7.messages).contentHeader),
            subHeader: intl.formatMessage((0, $69Xl7.messages).contentSubHeader),
            placeholderTitle: intl.formatMessage((0, $69Xl7.messages).placeHolderTitle)
        };
        const icons = {
            '48': ()=>Promise.resolve((parcelRequire("jo8MM"))).then(({ default: PremiumIcon })=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PremiumIcon, {
                            color: "var(--ds-icon-subtle, #505258)",
                            label: "",
                            spacing: "spacious"
                        }))
        };
        const update = async ()=>{
            const selectedNode = editorActions?.getSelectedNode()?.toJSON();
            const selectedLocalId = selectedNode?.attrs?.localId;
            if (!!selectedLocalId && openConfigPanel) openConfigPanel(selectedLocalId);
        };
        const render = async ()=>({ node: node, actions: actions })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cfc0028c4e22d32a$var$SectionExtension, {
                    contentId: contentId,
                    extensionNode: node,
                    editorActions: editorActions,
                    mbeActions: actions,
                    mode: mode,
                    propsProvider: propsProvider
                });
            };
        const additionalModuleNodeProps = {
            __allowBodiedOverride: true
        };
        return new (0, $bdpeX.default)([
            (0, $bktnv.getExtensionManifest)({
                key: key,
                icons: icons,
                parameters: parameters,
                update: update,
                render: render,
                title: title,
                type: type,
                description: description,
                source: 'premiumSectionInsert',
                nodeType: 'multiBodiedExtension',
                quickInsertAction: async ()=>Promise.resolve({
                        type: 'multiBodiedExtension',
                        key: 'hub-section',
                        attrs: {
                            extensionType: type,
                            extensionKey: 'hub-section',
                            layout: 'full-width',
                            parameters: parameters
                        },
                        content: getSectionExtensionContents(initialContentText)
                    }),
                additionalModuleNodeProps: additionalModuleNodeProps
            })
        ]);
    };
module.exports["sectionExtensionProvider"] = $cfc0028c4e22d32a$export$6775abcfdb3b0453;

});

parcelRegister("jDh8Q", function(module, exports) {
const $a848882170411a45$export$bc69bf23ec1f99d5 = 'hub-section';
const $a848882170411a45$export$7a75cc6a69e05549 = 'hub-sectionExtensionConfig';
var $a848882170411a45$export$3130b484681bf8bc = /*#__PURE__*/ function(CONTENT_WIDTH) {
    CONTENT_WIDTH["NARROW"] = "narrow";
    CONTENT_WIDTH["WIDE"] = "wide";
    CONTENT_WIDTH["FULL"] = "full";
    return CONTENT_WIDTH;
}({});
const $a848882170411a45$export$6cccba5fae1d609d = "wide";
const $a848882170411a45$export$617cdcc6afaae4f7 = "var(--ds-surface-overlay, #FFFFFF)";
module.exports["SECTION_EXTENSION_KEY"] = $a848882170411a45$export$bc69bf23ec1f99d5;
module.exports["SECTION_EXTENSION_ANALYTICS_SOURCE"] = $a848882170411a45$export$7a75cc6a69e05549;
module.exports["CONTENT_WIDTH"] = $a848882170411a45$export$3130b484681bf8bc;
module.exports["DEFAULT_CONTENT_WIDTH"] = $a848882170411a45$export$6cccba5fae1d609d;
module.exports["DEFAULT_BACKGROUND_COLOR"] = $a848882170411a45$export$617cdcc6afaae4f7;

});

parcelRegister("69Xl7", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $8fc561d04607119e$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    lozengeTitle: {
        id: "company-hub.section-extension.manifest.extension-lozenge-title",
        defaultMessage: "Section"
    },
    description: {
        id: "company-hub.section-extension.manifest.macro-description",
        defaultMessage: "Group elements together with a background"
    },
    contentHeader: {
        id: "company-hub.section-extension.manifest.content.header",
        defaultMessage: "Give your section a title"
    },
    contentSubHeader: {
        id: "company-hub.section-extension.manifest.content.sub-header",
        defaultMessage: "Organize elements into sections with customizable backgrounds."
    },
    placeHolderTitle: {
        id: "company-hub.section-extension.manifest.content.placeholder-title",
        defaultMessage: "Placeholder"
    }
});
module.exports["messages"] = $8fc561d04607119e$export$defe85febe8b728c;

});

parcelRegister("8TuI0", function(module, exports) {

let $679b47e4f42f59b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $679b47e4f42f59b3$var$load("5NX6D").then(()=>parcelRequire('kkFKP'));

});

parcelRegister("aNrj7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $bdpeX = parcelRequire("bdpeX");


var $b8pma = parcelRequire("b8pma");


var $hjUDQ = parcelRequire("hjUDQ");

var $bktnv = parcelRequire("bktnv");

var $5KWZf = parcelRequire("5KWZf");


var $1NMjw = parcelRequire("1NMjw");


var $3qjtL = parcelRequire("3qjtL");


const $c5740a6cfacb53db$var$SpotlightExtension = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "p5n9G",
    name: "SpotlightExtension",
    loader: async ()=>(await (parcelRequire("5Cqfi"))).Spotlight,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "spotlight-extension-loader"
        })
});
const $c5740a6cfacb53db$export$bc4319ada86b358d = ({ intl: intl, defaultParameters: defaultParameters })=>({
        extensionTitle: intl.formatMessage((0, $3qjtL.i18n).title),
        height: (0, $hjUDQ.Height).MEDIUM,
        backgroundColor: defaultParameters?.backgroundColor ?? "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
        cornerStyle: (0, $hjUDQ.CornerStyle).ROUNDED,
        layout: (0, $hjUDQ.CommonLayout).SPLIT_IMAGE_RIGHT,
        content: {
            text: {
                title: intl.formatMessage((0, $3qjtL.i18n).initialTitleParameter),
                description: intl.formatMessage((0, $3qjtL.i18n).initialDescriptionParameter),
                textColor: defaultParameters?.textColor ?? "var(--ds-text, #292A2E)"
            },
            button: {
                isButtonShown: false,
                text: '',
                link: '',
                style: (0, $hjUDQ.ButtonStyle).DEFAULT
            },
            image: {
                imageSrc: 'https://images.unsplash.com/photo-1527519135413-1e146b552e10?q=80&w=2940&auto=format',
                altText: intl.formatMessage((0, $3qjtL.i18n).initialImageAltTextParameter)
            }
        }
    });

const $c5740a6cfacb53db$export$10b21ce9d2029ff1 = async ({ contentId: contentId, propsProvider: propsProvider, defaultParameters: defaultParameters })=>{
    return async ({ editorActions: editorActions, openConfigPanel: openConfigPanel, setUpsellModalSource: setUpsellModalSource, intl: intl })=>{
        const title = intl.formatMessage((0, $3qjtL.i18n).title);
        const description = intl.formatMessage((0, $3qjtL.i18n).description);
        const type = (0, $5KWZf.SPOTLIGHT_EXTENSION_TYPE);
        const render = async ()=>({ node: node })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c5740a6cfacb53db$var$SpotlightExtension, {
                    isInEditor: true,
                    contentId: contentId,
                    extensionNode: node,
                    PropsProvider: propsProvider
                });
        const icons = {
            // eslint-disable-next-line import/dynamic-import-chunkname
            '48': ()=>Promise.resolve((parcelRequire("jo8MM"))).then(({ default: PremiumIcon })=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PremiumIcon, {
                            color: "var(--ds-icon-subtle, #505258)",
                            label: "",
                            spacing: "spacious"
                        }))
        };
        const parameters = $c5740a6cfacb53db$export$bc4319ada86b358d({
            intl: intl,
            defaultParameters: defaultParameters
        });
        const update = async ()=>{
            const selectedNode = editorActions?.getSelectedNode()?.toJSON();
            const selectedLocalId = selectedNode?.attrs?.localId;
            // missing openConfigPanel and editorActions
            if (!!selectedLocalId && openConfigPanel) openConfigPanel(selectedLocalId);
        };
        return new (0, $bdpeX.default)([
            (0, $bktnv.getExtensionManifest)({
                key: (0, $1NMjw.SPOTLIGHT_EXTENSION_KEY),
                icons: icons,
                parameters: parameters,
                update: update,
                render: render,
                title: title,
                type: type,
                description: description,
                setUpsellModalSource: setUpsellModalSource,
                source: 'premiumSpotlightInsert'
            })
        ]);
    };
};
module.exports["spotlightParameters"] = $c5740a6cfacb53db$export$bc4319ada86b358d;
module.exports["spotlightExtensionProvider"] = $c5740a6cfacb53db$export$10b21ce9d2029ff1;

});

parcelRegister("1NMjw", function(module, exports) {

var $hjUDQ = parcelRequire("hjUDQ");


var $9ltNi = parcelRequire("9ltNi");

const $e794509a5ea2ab20$export$8434ce10552078fe = 'spotlight';
const $e794509a5ea2ab20$export$af1b061943ec63f0 = [
    {
        label: (0, $9ltNi.i18n).splitDesignContentFirstLabel,
        description: (0, $9ltNi.i18n).splitDesignContentFirstDescription,
        value: (0, $hjUDQ.CommonLayout).SPLIT_IMAGE_RIGHT
    },
    {
        label: (0, $9ltNi.i18n).splitDesignImageFirstLabel,
        description: (0, $9ltNi.i18n).splitDesignImageFirstDescription,
        value: (0, $hjUDQ.CommonLayout).SPLIT_IMAGE_LEFT
    },
    {
        label: (0, $9ltNi.i18n).solidColorBackgroundLabel,
        description: (0, $9ltNi.i18n).solidColorBackgroundDescription,
        value: (0, $hjUDQ.CommonLayout).NO_IMAGE_BACKGROUND
    },
    {
        label: (0, $9ltNi.i18n).frameAboveImageLabel,
        description: (0, $9ltNi.i18n).frameAboveImageDescription,
        value: (0, $hjUDQ.CommonLayout).FRAME_ABOVE_IMAGE
    }
];
module.exports["SPOTLIGHT_EXTENSION_KEY"] = $e794509a5ea2ab20$export$8434ce10552078fe;
module.exports["layoutOptions"] = $e794509a5ea2ab20$export$af1b061943ec63f0;

});

parcelRegister("9ltNi", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f98976740a1f360f$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    splitDesignContentFirstLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.label",
        defaultMessage: "Split design (content first)"
    },
    splitDesignContentFirstDescription: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.description",
        defaultMessage: "Large image on the right with lots of room for content"
    },
    splitDesignImageFirstLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.label",
        defaultMessage: "Split design (image first)"
    },
    splitDesignImageFirstDescription: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.description",
        defaultMessage: "Large image on the left with lots of room for content"
    },
    solidColorBackgroundLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.label",
        defaultMessage: "Solid color background"
    },
    solidColorBackgroundDescription: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.description",
        defaultMessage: "Content in front of a full-width color"
    },
    frameAboveImageLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.label",
        defaultMessage: "Content frame inside image"
    },
    frameAboveImageDescription: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.description",
        defaultMessage: "Text box overlay on a large image"
    },
    // We will eventually use these translations when full background layout is properly introduced
    imageBackgroundLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.label",
        defaultMessage: "Image background"
    },
    imageBackgroundDescription: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.description",
        defaultMessage: "Full-size image behind your content"
    }
});
module.exports["i18n"] = $f98976740a1f360f$export$a7357cdd1f0b0168;

});

parcelRegister("3qjtL", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $226565a51fa3f7c4$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    title: {
        id: "company-hub.spotlight-extension.manifest.macro-title",
        defaultMessage: "Spotlight"
    },
    description: {
        id: "company-hub.spotlight-extension.manifest.macro-description",
        defaultMessage: "Highlight important messages with a visual spotlight."
    },
    initialTitleParameter: {
        id: "company-hub.spotlight-extension.manifest.initial-state.text-title",
        defaultMessage: "Give your spotlight a title"
    },
    initialDescriptionParameter: {
        id: "company-hub.spotlight-extension.manifest.initial-state.text-description",
        defaultMessage: "Design a spotlight to highlight your most vital information. Bring the most important messages to life with custom colors, a powerful image, and flexible layouts."
    },
    initialImageAltTextParameter: {
        id: "company-hub.spotlight-extension.manifest.initial-state.alt-image-text",
        defaultMessage: "Landscape photography of desert"
    }
});
module.exports["i18n"] = $226565a51fa3f7c4$export$a7357cdd1f0b0168;

});

parcelRegister("5Cqfi", function(module, exports) {

let $4174dc3a73228665$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4174dc3a73228665$var$load("fQ34V"),
    $4174dc3a73228665$var$load("cxCk7"),
    $4174dc3a73228665$var$load("4Gdnz"),
    $4174dc3a73228665$var$load("4UAag"),
    $4174dc3a73228665$var$load("bjgFk"),
    $4174dc3a73228665$var$load("iEsP0"),
    $4174dc3a73228665$var$load("k8nz9"),
    $4174dc3a73228665$var$load("hUbK8"),
    $4174dc3a73228665$var$load("fqJr7"),
    $4174dc3a73228665$var$load("7H1j2"),
    $4174dc3a73228665$var$load("25adb"),
    $4174dc3a73228665$var$load("glcJK"),
    $4174dc3a73228665$var$load("5SpB1"),
    $4174dc3a73228665$var$load("1Gr4q"),
    $4174dc3a73228665$var$load("agVmZ"),
    $4174dc3a73228665$var$load("hhss7"),
    $4174dc3a73228665$var$load("ef2CU"),
    $4174dc3a73228665$var$load("VXbA1"),
    $4174dc3a73228665$var$load("ca0UP"),
    $4174dc3a73228665$var$load("a92TB"),
    $4174dc3a73228665$var$load("c7nj5"),
    $4174dc3a73228665$var$load("1yIye"),
    $4174dc3a73228665$var$load("iY0Ii"),
    $4174dc3a73228665$var$load("7EorR"),
    $4174dc3a73228665$var$load("Wowvf"),
    $4174dc3a73228665$var$load("cvcNg"),
    $4174dc3a73228665$var$load("4zz48"),
    $4174dc3a73228665$var$load("jXM1T"),
    $4174dc3a73228665$var$load("39XCn"),
    $4174dc3a73228665$var$load("jw3lv"),
    $4174dc3a73228665$var$load("7rqWx"),
    $4174dc3a73228665$var$load("3Cky6"),
    $4174dc3a73228665$var$load("kG5Ju"),
    $4174dc3a73228665$var$load("il8bj"),
    $4174dc3a73228665$var$load("6wr18"),
    $4174dc3a73228665$var$load("aFLSJ"),
    $4174dc3a73228665$var$load("ffEVr"),
    $4174dc3a73228665$var$load("6bjEk"),
    $4174dc3a73228665$var$load("jfSwd"),
    $4174dc3a73228665$var$load("9vDBp"),
    $4174dc3a73228665$var$load("96rwC")
]).then(()=>parcelRequire('fwVKa'));

});

parcelRegister("51qBv", function(module, exports) {

var $561lj = parcelRequire("561lj");


var $dK6bS = parcelRequire("dK6bS");

const $4f3f5baef79264ec$export$a69eee655819c5bd = ({ api: api, config: config })=>{
    return {
        name: 'codeBlockAdvanced',
        nodes () {
            return [
                {
                    name: 'codeBlock',
                    node: (0, $561lj.codeBlockNodeWithFixedToDOM)({
                        allowCodeFolding: config?.allowCodeFolding ?? false
                    })
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'codeBlockAdvancedPlugin',
                    plugin: ({ getIntl: getIntl })=>(0, $dK6bS.createPlugin)({
                            api: api,
                            extensions: config?.extensions ?? [],
                            allowCodeFolding: config?.allowCodeFolding ?? false,
                            getIntl: getIntl
                        })
                }
            ];
        }
    };
};
module.exports["codeBlockAdvancedPlugin"] = $4f3f5baef79264ec$export$a69eee655819c5bd;

});

parcelRegister("561lj", function(module, exports) {

var $jDAs4 = parcelRequire("jDAs4");


var $6gBg9 = parcelRequire("6gBg9");


var $8Dx7s = parcelRequire("8Dx7s");


var $cRhiT = parcelRequire("cRhiT");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");

const $c0e4e9972d346b0c$var$codeBlockClassNames = {
    container: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER,
    start: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_START,
    end: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_END,
    contentWrapper: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER,
    contentWrapped: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPED,
    content: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
};
const $c0e4e9972d346b0c$var$MATCH_NEWLINES = new RegExp('\n', 'gu');
const $c0e4e9972d346b0c$var$getGutterBaseStyle = ()=>({
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        position: 'relative',
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        boxSizing: 'content-box'
    });
const $c0e4e9972d346b0c$var$getGutterPadding = (allowCodeFolding)=>allowCodeFolding ? `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-100, 8px)";
const $c0e4e9972d346b0c$var$getGuttersWithLineNumbers = (content, config)=>[
        'div',
        {
            // Based on packages/editor/editor-common/src/styles/shared/code-block.ts
            // But we can't reuse that class as it adds a ::before that intefers with this approach
            style: (0, $8Dx7s.convertToInlineCss)({
                ...$c0e4e9972d346b0c$var$getGutterBaseStyle(),
                width: 'var(--lineNumberGutterWidth, 2rem)',
                /* top and bottom | left and right */ padding: $c0e4e9972d346b0c$var$getGutterPadding(config.allowCodeFolding)
            }),
            contenteditable: 'false'
        },
        [
            'div',
            {
                class: 'code-block-gutter-pseudo-element',
                style: (0, $8Dx7s.convertToInlineCss)({
                    textAlign: 'right',
                    color: "var(--ds-text-subtlest, #6B6E76)",
                    fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
                    whiteSpace: 'pre-wrap'
                }),
                'data-label': content
            }
        ]
    ];
const $c0e4e9972d346b0c$var$getFoldOnlyGutter = ()=>[
        'div',
        {
            style: (0, $8Dx7s.convertToInlineCss)({
                ...$c0e4e9972d346b0c$var$getGutterBaseStyle(),
                padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
            }),
            contenteditable: 'false'
        }
    ];
const $c0e4e9972d346b0c$var$getGutters = (content, config, hideLineNumbers)=>{
    if (!hideLineNumbers) return [
        $c0e4e9972d346b0c$var$getGuttersWithLineNumbers(content, config)
    ];
    if (config.allowCodeFolding) return [
        $c0e4e9972d346b0c$var$getFoldOnlyGutter()
    ];
    return [];
};
// Based on: `packages/editor/editor-plugin-code-block/src/nodeviews/code-block.ts`
const $c0e4e9972d346b0c$var$toDOM = (node, formattedAriaLabel, config)=>{
    let totalLineCount = 1;
    node.forEach((node)=>{
        const text = node.text;
        if (text) totalLineCount += (node.text.match($c0e4e9972d346b0c$var$MATCH_NEWLINES) || []).length;
    });
    const hideLineNumbers = (0, $6gBg9.areCodeBlockLineNumbersHidden)(node);
    const maxDigits = totalLineCount.toString().length;
    const content = node.textContent.split('\n').map((_, i)=>i + 1).join('\n');
    const gutters = $c0e4e9972d346b0c$var$getGutters(content, config, hideLineNumbers);
    const isCodeBlockWrapped = (0, $anBbz.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && node.attrs.wrap === true;
    const className = [
        $c0e4e9972d346b0c$var$codeBlockClassNames.container,
        isCodeBlockWrapped ? $c0e4e9972d346b0c$var$codeBlockClassNames.contentWrapped : undefined
    ].filter(Boolean).join(' ');
    return [
        'pre',
        {
            class: className,
            style: `--lineNumberGutterWidth:${maxDigits}ch;`,
            'data-language': node.attrs.language || '',
            ...(0, $anBbz.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && {
                'data-wrap': node.attrs.wrap ? 'true' : 'false',
                ...hideLineNumbers && {
                    'data-hide-line-numbers': 'true'
                }
            }
        },
        [
            'div',
            {
                class: $c0e4e9972d346b0c$var$codeBlockClassNames.start,
                contenteditable: 'false'
            }
        ],
        [
            'div',
            {
                class: $c0e4e9972d346b0c$var$codeBlockClassNames.contentWrapper
            },
            ...gutters,
            [
                'div',
                {
                    class: $c0e4e9972d346b0c$var$codeBlockClassNames.content
                },
                [
                    'code',
                    {
                        'data-language': node.attrs.language || '',
                        spellcheck: 'false',
                        'data-testid': 'code-block--code',
                        'aria-label': formattedAriaLabel,
                        ...(0, $iDrrr.fg)('platform_editor_adf_with_localid') && {
                            'data-local-id': node.attrs.localId
                        }
                    },
                    0
                ]
            ]
        ],
        [
            'div',
            {
                class: $c0e4e9972d346b0c$var$codeBlockClassNames.end,
                contenteditable: 'false'
            }
        ]
    ];
};
const $c0e4e9972d346b0c$export$3cf83e71c577e77b = (config)=>{
    return {
        ...(0, $ieeJu.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) ? (0, $jDAs4.codeBlock) : (0, $iDrrr.fg)('platform_editor_adf_with_localid') ? (0, $jDAs4.codeBlockWithLocalId) : (0, $jDAs4.codeBlock),
        toDOM: (node)=>$c0e4e9972d346b0c$var$toDOM(node, '', config)
    };
};
module.exports["codeBlockNodeWithFixedToDOM"] = $c0e4e9972d346b0c$export$3cf83e71c577e77b;

});

parcelRegister("dK6bS", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $ixu0Q = parcelRequire("ixu0Q");


var $kz1SL = parcelRequire("kz1SL");

const $7df39c642c535c5a$export$ae829ec7b2625219 = (props)=>{
    return new (0, $kpCD8.SafePlugin)({
        props: {
            nodeViews: {
                codeBlock: (0, $ixu0Q.lazyCodeBlockView)(props)
            },
            // Custom selection behaviour to fix issues with codeblocks with Shift + Arrow{Up || Down}
            // These issues are also present in the prosemirror codemirror example and @marijnh suggests to
            // use custom event handlers: https://github.com/ProseMirror/website/issues/83
            handleKeyDown (view, event) {
                if (!(event instanceof KeyboardEvent)) return false;
                if (event.key === 'ArrowUp' && event.shiftKey) return (0, $kz1SL.shiftArrowUpWorkaround)(view, event);
                else if (event.key === 'ArrowDown' && event.shiftKey) return (0, $kz1SL.shiftArrowDownWorkaround)(view, event);
            }
        }
    });
};
module.exports["createPlugin"] = $7df39c642c535c5a$export$ae829ec7b2625219;

});

parcelRegister("ixu0Q", function(module, exports) {

var $hMfrQ = parcelRequire("hMfrQ");


const $766d24dab7d8c4dd$export$28da8fbeb01202c6 = (props)=>{
    return (0, $hMfrQ.withLazyLoading)({
        nodeName: 'codeBlock',
        getNodeViewOptions: ()=>{},
        loader: async ()=>{
            const { getCodeBlockAdvancedNodeView: getCodeBlockAdvancedNodeView } = await (parcelRequire("jLcA5"));
            return (node, view, getPos, _decs, _nodeViewOptions, innerDecorations)=>getCodeBlockAdvancedNodeView(props)(node, view, getPos, innerDecorations);
        }
    });
};
module.exports["lazyCodeBlockView"] = $766d24dab7d8c4dd$export$28da8fbeb01202c6;

});

parcelRegister("jLcA5", function(module, exports) {

let $e62c2a6fcd5be4e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e62c2a6fcd5be4e8$var$load("fBohe"),
    $e62c2a6fcd5be4e8$var$load("eMRD3"),
    $e62c2a6fcd5be4e8$var$load("hmrCV")
]).then(()=>parcelRequire('kDxNm'));

});

parcelRegister("kz1SL", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $12e69e2dcfc4bd75$export$d4559115ffe0b372 = (view, event)=>{
    const { doc: doc, selection: { $head: $head, $anchor: $anchor }, tr: tr, schema: { nodes: { codeBlock: codeBlock } } } = view.state;
    // Position we want to check (directly after our current position)
    const pos = Math.max($head.pos - 1, 1);
    const isNodeBefore = doc.resolve(pos).nodeBefore?.type === codeBlock;
    const maybeProblematicNode = isNodeBefore ? doc.resolve(pos).nodeBefore : doc.resolve(pos).node();
    if (maybeProblematicNode?.type === codeBlock) {
        const nodeSize = maybeProblematicNode.nodeSize;
        const startPos = isNodeBefore ? pos : $head.pos;
        tr.setSelection((0, $kCECX.TextSelection).create(doc, $anchor.pos, Math.max(startPos - nodeSize, 0)));
        view.dispatch(tr);
        event.preventDefault();
        return true;
    }
    return false;
};
const $12e69e2dcfc4bd75$export$ba335e235e59f4ed = (view, event)=>{
    const { doc: doc, selection: { $head: $head, $anchor: $anchor }, tr: tr, schema: { nodes: { codeBlock: codeBlock } } } = view.state;
    // Position we want to check (directly after our current position)
    const pos = $head.pos + 1;
    const isNodeAfter = doc.resolve(pos).nodeAfter?.type === codeBlock;
    const maybeProblematicNode = isNodeAfter ? doc.resolve(pos).nodeAfter : doc.resolve(pos).node();
    if (maybeProblematicNode?.type === codeBlock) {
        const nodeSize = maybeProblematicNode.nodeSize;
        const startPos = isNodeAfter ? pos : $head.pos;
        tr.setSelection((0, $kCECX.TextSelection).create(doc, $anchor.pos, Math.min(startPos + nodeSize, doc.content.size)));
        view.dispatch(tr);
        event.preventDefault();
        return true;
    }
    return false;
};
module.exports["shiftArrowUpWorkaround"] = $12e69e2dcfc4bd75$export$d4559115ffe0b372;
module.exports["shiftArrowDownWorkaround"] = $12e69e2dcfc4bd75$export$ba335e235e59f4ed;

});

parcelRegister("k7vUa", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $ldqjS = parcelRequire("ldqjS");


var $83k8i = parcelRequire("83k8i");

var $gx3UZ = parcelRequire("gx3UZ");


var $jGK9e = parcelRequire("jGK9e");


var $kpCD8 = parcelRequire("kpCD8");


var $efqK4 = parcelRequire("efqK4");


var $gZpSA = parcelRequire("gZpSA");


var $kCECX = parcelRequire("kCECX");


var $dtUVl = parcelRequire("dtUVl");

var $kSt8V = parcelRequire("kSt8V");

var $lRQPW = parcelRequire("lRQPW");

var $hfJsy = parcelRequire("hfJsy");

var $9tfSW = parcelRequire("9tfSW");


var $eDtFr = parcelRequire("eDtFr");


var $4o0zT = parcelRequire("4o0zT");


var $jkcNT = parcelRequire("jkcNT");


var $2PMvb = parcelRequire("2PMvb");


var $f5VOy = parcelRequire("f5VOy");


var $g5ewD = parcelRequire("g5ewD");


var $38lAe = parcelRequire("38lAe");


var $6wqCa = parcelRequire("6wqCa");


var $8civN = parcelRequire("8civN");


var $aowZj = parcelRequire("aowZj");

const $080d08f451e47419$export$144d1b98bacb98cc = (emoji, emojiProvider)=>({
        title: emoji.shortName || '',
        key: emoji.id || emoji.shortName,
        render ({ isSelected: isSelected, onClick: onClick, onHover: onHover }) {
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dtUVl.default), {
                emoji: emoji,
                selected: isSelected,
                onMouseMove: onHover,
                onSelection: onClick,
                emojiProvider: emojiProvider
            });
        },
        emoji: emoji
    });
function $080d08f451e47419$export$fc10aeed3a532e2a(fn) {
    // Cache results here
    const seen = new Map();
    function memoized(emoji, emojiProvider) {
        // Check cache for hits
        const hit = seen.get(emoji.id || emoji.shortName);
        if (hit) return hit;
        // Generate new result and cache it
        const result = fn(emoji, emojiProvider);
        seen.set(emoji.id || emoji.shortName, result);
        return result;
    }
    return {
        call: memoized,
        clear: seen.clear.bind(seen)
    };
}
const $080d08f451e47419$var$memoizedToItem = $080d08f451e47419$export$fc10aeed3a532e2a($080d08f451e47419$export$144d1b98bacb98cc);
const $080d08f451e47419$var$defaultListLimit = 50;
const $080d08f451e47419$var$isFullShortName = (query)=>query && query.length > 1 && query.charAt(0) === ':' && query.charAt(query.length - 1) === ':';
const $080d08f451e47419$var$TRIGGER = ':';
function $080d08f451e47419$var$delayUntilIdle(cb) {
    if (typeof window === 'undefined') return;
    // eslint-disable-next-line compat/compat
    if (window.requestIdleCallback !== undefined) // eslint-disable-next-line compat/compat
    return window.requestIdleCallback(()=>cb(), {
        timeout: 500
    });
    return window.requestAnimationFrame(()=>cb());
}
const $080d08f451e47419$export$d1221bd3f80501e0 = ({ config: options, api: api })=>{
    let previousEmojiProvider;
    const typeAhead = {
        id: (0, $efqK4.TypeAheadAvailableNodes).EMOJI,
        trigger: $080d08f451e47419$var$TRIGGER,
        // Custom regex must have a capture group around trigger
        // so it's possible to use it without needing to scan through all triggers again
        customRegex: '\\(?(:)',
        headless: options ? options.headless : undefined,
        getItems ({ query: query, editorState: editorState }) {
            const pluginState = $080d08f451e47419$var$getEmojiPluginState(editorState);
            const emojiProvider = pluginState.emojiProvider;
            if (!emojiProvider) return Promise.resolve([]);
            return new Promise((resolve)=>{
                const emojiProviderChangeHandler = {
                    result (emojiResult) {
                        if (!emojiResult || !emojiResult.emojis) resolve([]);
                        else {
                            const emojiItems = emojiResult.emojis.map((emoji)=>$080d08f451e47419$var$memoizedToItem.call(emoji, emojiProvider));
                            resolve(emojiItems);
                        }
                        emojiProvider.unsubscribe(emojiProviderChangeHandler);
                    }
                };
                emojiProvider.subscribe(emojiProviderChangeHandler);
                emojiProvider.filter($080d08f451e47419$var$TRIGGER.concat(query), {
                    limit: $080d08f451e47419$var$defaultListLimit,
                    skinTone: emojiProvider.getSelectedTone(),
                    sort: !query.length ? (0, $9tfSW.SearchSort).UsageFrequency : (0, $9tfSW.SearchSort).Default
                });
            });
        },
        forceSelect ({ query: query, items: items, editorState: editorState }) {
            const { asciiMap: asciiMap } = $080d08f451e47419$export$e3ef5170578bd8ba.getState(editorState) || {};
            const normalizedQuery = $080d08f451e47419$var$TRIGGER.concat(query);
            // if the query has space at the end
            // check the ascii map for emojis
            if (!options?.disableAutoformat && asciiMap && normalizedQuery.length >= 3 && normalizedQuery.endsWith(' ') && asciiMap.has(normalizedQuery.trim())) {
                const emoji = asciiMap.get(normalizedQuery.trim());
                return {
                    title: emoji?.name || '',
                    emoji: emoji
                };
            }
            const matchedItem = $080d08f451e47419$var$isFullShortName(normalizedQuery) ? items.find((item)=>item.title.toLowerCase() === normalizedQuery) : undefined;
            return matchedItem;
        },
        selectItem (state, item, insert, { mode: mode }) {
            const emojiPluginState = $080d08f451e47419$export$e3ef5170578bd8ba.getState(state);
            if (emojiPluginState.emojiProvider && emojiPluginState.emojiProvider.recordSelection && item.emoji) emojiPluginState.emojiProvider.recordSelection(item.emoji).then((0, $hfJsy.recordSelectionSucceededSli)(item.emoji, {
                createAnalyticsEvent: api?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined
            })).catch((0, $lRQPW.recordSelectionFailedSli)(item.emoji, {
                createAnalyticsEvent: api?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined
            }));
            const fragment = (0, $2PMvb.createEmojiFragment)(state.doc, state.selection.$head, item.emoji);
            const tr = insert(fragment);
            api?.analytics?.actions.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).INSERTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EMOJI,
                attributes: {
                    inputMethod: (0, $krYZG.INPUT_METHOD).TYPEAHEAD
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            })(tr);
            return tr;
        }
    };
    const isRegisteredSlashCommandEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command');
    if (isRegisteredSlashCommandEnabled) api?.uiControlRegistry?.actions.register((0, $aowZj.getEmojiQuickInsertComponents)());
    api?.base?.actions.registerMarks(({ tr: tr, node: node, pos: pos })=>{
        const { doc: doc } = tr;
        const { schema: schema } = doc.type;
        const { emoji: emojiNodeType } = schema.nodes;
        if (node.type === emojiNodeType) {
            const newText = node.attrs.text;
            const currentPos = tr.mapping.map(pos);
            tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
        }
    });
    return {
        name: 'emoji',
        nodes () {
            return [
                {
                    name: 'emoji',
                    node: (0, $f5VOy.emojiNodeSpec)()
                }
            ];
        },
        usePluginHook () {
            (0, $cozmU.useEffect)(()=>{
                $080d08f451e47419$var$delayUntilIdle(()=>{
                    (0, $kSt8V.preloadEmojiPicker)();
                });
            }, []);
        },
        pmPlugins () {
            return [
                {
                    name: 'emoji',
                    plugin: (pmPluginFactoryParams)=>{
                        return $080d08f451e47419$var$createEmojiPlugin(pmPluginFactoryParams, options, api);
                    }
                },
                {
                    name: 'emojiAsciiInputRule',
                    plugin: ({ schema: schema })=>(0, $6wqCa.inputRulePlugin)(schema, api?.analytics?.actions, api, options?.disableAutoformat)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { emojiResourceConfig: emojiResourceConfig, asciiMap: asciiMap, emojiProvider: emojiProvider, inlineEmojiPopupOpen: inlineEmojiPopupOpen, emojiProviderPromise: emojiProviderPromise } = $080d08f451e47419$export$e3ef5170578bd8ba.getState(editorState) ?? {};
            return {
                emojiResourceConfig: emojiResourceConfig,
                asciiMap: asciiMap,
                typeAheadHandler: typeAhead,
                emojiProvider: emojiProvider,
                emojiProviderPromise: emojiProviderPromise,
                inlineEmojiPopupOpen: inlineEmojiPopupOpen
            };
        },
        actions: {
            openTypeAhead: (0, $38lAe.openTypeAhead)(typeAhead, api),
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousEmojiProvider === provider || options?.emojiProvider === providerPromise) return false;
                previousEmojiProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>$080d08f451e47419$var$setProviderTr(provider)(tr)) ?? false;
            }
        },
        commands: {
            insertEmoji: (0, $2PMvb.insertEmoji)(api?.analytics?.actions)
        },
        contentComponent ({ editorView: editorView, popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement }) {
            if (!api || (0, $jkcNT.editorExperiment)('platform_editor_controls', 'control') || !editorView) return null;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8civN.InlineEmojiPopup), {
                api: api,
                contentId: options?.contentId,
                editorView: editorView,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsMountPoint: popupsMountPoint,
                popupsScrollableElement: popupsScrollableElement
            });
        },
        pluginsOptions: {
            ...isRegisteredSlashCommandEnabled ? {} : {
                quickInsert: ({ formatMessage: formatMessage })=>[
                        {
                            id: 'emoji',
                            title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).emoji),
                            description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).emojiDescription),
                            priority: 500,
                            keyshortcut: ':',
                            isDisabledOffline: false,
                            icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconEmoji), {}),
                            action (insert) {
                                if ((0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1', {
                                    exposure: true
                                })) {
                                    // Clear slash
                                    let tr = insert('');
                                    tr = (0, $38lAe.setInlineEmojiPopupOpen)(true)(tr);
                                    return tr;
                                }
                                const tr = insert(undefined);
                                api?.typeAhead?.actions.openAtTransaction({
                                    triggerHandler: typeAhead,
                                    inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT
                                })(tr);
                                return tr;
                            }
                        }
                    ]
            },
            typeAhead: typeAhead,
            floatingToolbar: (state, intl)=>{
                const isViewMode = ()=>api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                if (!isViewMode()) return undefined;
                const onClick = (stateFromClickEvent, dispatch)=>{
                    if (!api?.annotation) return true;
                    if (api?.analytics?.actions) api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $krYZG.ACTION).CLICKED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                        eventType: (0, $krYZG.EVENT_TYPE).UI,
                        attributes: {
                            source: 'highlightActionsMenu',
                            pageMode: 'edit',
                            sourceNode: 'emoji'
                        }
                    });
                    const command = api.annotation?.actions?.setInlineCommentDraftState(true, (0, $krYZG.INPUT_METHOD).TOOLBAR);
                    return command(stateFromClickEvent, dispatch);
                };
                return {
                    title: 'Emoji floating toolbar',
                    nodeType: [
                        state.schema.nodes.emoji
                    ],
                    onPositionCalculated: (0, $gZpSA.calculateToolbarPositionAboveSelection)('Emoji floating toolbar'),
                    items: (node)=>{
                        const annotationState = api?.annotation?.sharedState.currentState();
                        const activeCommentMark = node.marks.find((mark)=>mark.type.name === 'annotation' && annotationState?.annotations[mark.attrs.id] === false);
                        const showAnnotation = annotationState && annotationState.isVisible && !annotationState.bookmark && !annotationState.mouseData.isSelecting && !activeCommentMark && isViewMode();
                        if (showAnnotation) return [
                            {
                                type: 'button',
                                showTitle: true,
                                testId: 'add-comment-emoji-button',
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))),
                                title: intl.formatMessage((0, $83k8i.annotationMessages).createComment),
                                onClick: onClick,
                                tooltipContent: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ldqjS.ToolTipContent), {
                                    description: intl.formatMessage((0, $83k8i.annotationMessages).createComment)
                                }),
                                supportsViewMode: true
                            }
                        ];
                        return [];
                    }
                };
            }
        }
    };
};
/**
 * Actions
 */ const $080d08f451e47419$var$setAsciiMap = (asciiMap)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = (0, $38lAe.setAsciiMap)(asciiMap)(state.tr);
            dispatch(tr);
        }
        return true;
    };
function $080d08f451e47419$export$ae9fa76f15c1e295(fn, limitTime, limitCount, onLimitReached) {
    let lastCallTime = 0;
    let callCount = 0;
    return function wrappedFn(...args) {
        const now = Date.now();
        if (now - lastCallTime < limitTime) {
            if (++callCount > limitCount) onLimitReached?.();
        } else {
            lastCallTime = now;
            callCount = 1;
        }
        return fn(...args);
    };
}
// At this stage console.error only
const $080d08f451e47419$var$logRateWarning = ()=>{};
const $080d08f451e47419$var$setProviderTr = $080d08f451e47419$export$ae9fa76f15c1e295((provider)=>(tr)=>(0, $38lAe.setProvider)(provider)(tr), // If we change the emoji provider more than three times every 5 seconds we should warn.
// This seems like a really long time but the performance can be that laggy that we don't
// even get 3 events in 3 seconds and miss this indicator.
5000, 3, $080d08f451e47419$var$logRateWarning);
const $080d08f451e47419$var$setProvider = (provider)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = $080d08f451e47419$var$setProviderTr(provider)(state.tr);
            dispatch(tr);
        }
        return true;
    };
const $080d08f451e47419$export$e3ef5170578bd8ba = new (0, $kCECX.PluginKey)('emojiPlugin');
function $080d08f451e47419$var$getEmojiPluginState(state) {
    return $080d08f451e47419$export$e3ef5170578bd8ba.getState(state) || {};
}
function $080d08f451e47419$var$createEmojiPlugin(pmPluginFactoryParams, options, api) {
    return new (0, $kpCD8.SafePlugin)({
        key: $080d08f451e47419$export$e3ef5170578bd8ba,
        state: {
            init () {
                if (options?.emojiProvider) return {
                    emojiProviderPromise: options.emojiProvider
                };
                return {};
            },
            apply (tr, pluginState) {
                const { action: action, params: params } = tr.getMeta($080d08f451e47419$export$e3ef5170578bd8ba) || {
                    action: null,
                    params: null
                };
                let newPluginState = pluginState;
                switch(action){
                    case (0, $38lAe.ACTIONS).SET_PROVIDER:
                        newPluginState = {
                            ...pluginState,
                            emojiProvider: params.provider,
                            emojiProviderPromise: Promise.resolve(params.provider)
                        };
                        pmPluginFactoryParams.dispatch($080d08f451e47419$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                    case (0, $38lAe.ACTIONS).SET_ASCII_MAP:
                        newPluginState = {
                            ...pluginState,
                            asciiMap: params.asciiMap
                        };
                        pmPluginFactoryParams.dispatch($080d08f451e47419$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                    case (0, $38lAe.ACTIONS).SET_INLINE_POPUP:
                        newPluginState = {
                            ...pluginState,
                            inlineEmojiPopupOpen: params.open
                        };
                        pmPluginFactoryParams.dispatch($080d08f451e47419$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                }
                return newPluginState;
            }
        },
        props: {
            nodeViews: {
                emoji: (node)=>{
                    return new (0, $g5ewD.EmojiNodeView)(node, {
                        intl: pmPluginFactoryParams.getIntl(),
                        api: api,
                        emojiNodeDataProvider: options?.emojiNodeDataProvider
                    });
                }
            }
        },
        view (editorView) {
            const providerHandler = (name, providerPromise)=>{
                switch(name){
                    case 'emojiProvider':
                        if (!providerPromise) return $080d08f451e47419$var$setProvider?.(undefined)?.(editorView.state, editorView.dispatch);
                        providerPromise.then((provider)=>{
                            $080d08f451e47419$var$setProvider?.(provider)?.(editorView.state, editorView.dispatch);
                            provider.getAsciiMap().then((asciiMap)=>{
                                $080d08f451e47419$var$setAsciiMap(asciiMap)(editorView.state, editorView.dispatch);
                            });
                        }).catch(()=>$080d08f451e47419$var$setProvider?.(undefined)?.(editorView.state, editorView.dispatch));
                        break;
                }
                return;
            };
            if (options?.emojiProvider) providerHandler('emojiProvider', options.emojiProvider);
            return {
                destroy () {
                    if (pmPluginFactoryParams.providerFactory) pmPluginFactoryParams.providerFactory.unsubscribe('emojiProvider', providerHandler);
                }
            };
        }
    });
}
module.exports["emojiPlugin"] = $080d08f451e47419$export$d1221bd3f80501e0;
module.exports["emojiPluginKey"] = $080d08f451e47419$export$e3ef5170578bd8ba;

});

parcelRegister("2PMvb", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $fRYCB = parcelRequire("fRYCB");


var $aPdNQ = parcelRequire("aPdNQ");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");

const $e819716a0e878e7b$export$c62c7770bca4be17 = (doc, pos, emoji)=>{
    const { id: id = '', fallback: fallback, shortName: shortName } = emoji;
    const annotationMarksForPos = (0, $fRYCB.getAnnotationMarksForPos)(pos);
    const emojiNode = doc.type.schema.nodes.emoji.createChecked({
        shortName: shortName,
        id: id,
        text: fallback || shortName
    }, null, annotationMarksForPos);
    const space = doc.type.schema.text(' ', annotationMarksForPos);
    return (0, $aPdNQ.Fragment).fromArray([
        emojiNode,
        space
    ]);
};
const $e819716a0e878e7b$export$8d5c072327044b6f = (editorAnalyticsAPI)=>(emojiId, inputMethod)=>{
        return ({ tr: tr })=>{
            const { doc: doc, selection: selection } = tr;
            const { emoji: emoji } = tr.doc.type.schema.nodes;
            if (emoji && emojiId) {
                const fragment = $e819716a0e878e7b$export$c62c7770bca4be17(doc, selection.$head, emojiId);
                const newTr = (0, $bjg0G.safeInsert)(fragment)(tr);
                if (inputMethod) editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $krYZG.ACTION).INSERTED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EMOJI,
                    attributes: {
                        inputMethod: inputMethod
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                })(newTr);
                newTr.setSelection((0, $kCECX.Selection).near(newTr.doc.resolve(selection.$from.pos + fragment.size)));
                return newTr;
            }
            return null;
        };
    };
module.exports["createEmojiFragment"] = $e819716a0e878e7b$export$c62c7770bca4be17;
module.exports["insertEmoji"] = $e819716a0e878e7b$export$8d5c072327044b6f;

});

parcelRegister("f5VOy", function(module, exports) {

var $kOOm4 = parcelRequire("kOOm4");


var $8Dx7s = parcelRequire("8Dx7s");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");

const $536e450147041236$var$isSSR = Boolean(undefined);
const $536e450147041236$export$d122e24cc43292f6 = ()=>{
    const emojiNode = (0, $iDrrr.fg)('platform_editor_adf_with_localid') ? (0, $kOOm4.emojiWithLocalId) : (0, $kOOm4.emoji);
    if ($536e450147041236$var$isSSR) return emojiNode;
    return {
        ...emojiNode,
        toDOM: (node)=>$536e450147041236$export$9edeb07c311f4561(node)
    };
};
function $536e450147041236$export$9edeb07c311f4561(node) {
    // From packages/elements/emoji/src/components/common/EmojiPlaceholder.tsx
    const { shortName: shortName, id: id, text: text } = node.attrs;
    const isEmojiScalingEnabled = (0, $ieeJu.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true);
    const attrs = {
        'data-emoji-short-name': shortName,
        'data-emoji-id': id,
        'data-emoji-text': text,
        contenteditable: 'false',
        style: (0, $8Dx7s.convertToInlineCss)({
            content: "''",
            fill: "var(--ds-background-neutral, #0515240F)",
            ...isEmojiScalingEnabled ? {
                minWidth: '16.25px',
                minHeight: '16.25px'
            } : {
                minWidth: `20px`,
                width: `20px`,
                height: `20px`
            },
            position: 'relative',
            margin: '-1px 0',
            display: 'inline-block',
            background: "var(--ds-background-neutral, #0515240F)",
            borderRadius: "var(--ds-radius-small, 3px)",
            overflow: 'hidden',
            verticalAlign: 'middle',
            whiteSpace: 'nowrap',
            textAlign: 'center'
        }),
        'aria-busy': 'true',
        'aria-label': shortName,
        class: 'emoji-common-placeholder'
    };
    if ((0, $iDrrr.fg)('platform_editor_adf_with_localid')) attrs['data-local-id'] = node.attrs.localId;
    return [
        'span',
        attrs
    ];
}
module.exports["emojiNodeSpec"] = $536e450147041236$export$d122e24cc43292f6;
module.exports["emojiToDom"] = $536e450147041236$export$9edeb07c311f4561;

});

parcelRegister("g5ewD", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");


var $3u5lg = parcelRequire("3u5lg");


var $9wMFw = parcelRequire("9wMFw");


var $1hQ0e = parcelRequire("1hQ0e");


var $4iudd = parcelRequire("4iudd");


var $l4yrE = parcelRequire("l4yrE");

var $k8ZZN = parcelRequire("k8ZZN");

var $2O2Zk = parcelRequire("2O2Zk");


var $jv11C = parcelRequire("jv11C");


var $2DBsV = parcelRequire("2DBsV");


var $h1Peg = parcelRequire("h1Peg");


var $jaFVy = parcelRequire("jaFVy");


var $aPdNQ = parcelRequire("aPdNQ");


var $4xiow = parcelRequire("4xiow");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $f5VOy = parcelRequire("f5VOy");

/**
 * Emoji node view for renderering emoji nodes
 */ const $144c0f90b58057f8$var$EMOJI_TOOLTIP_CLASS = 'emoji-tooltip-editor';
/**
 * Shared default look plus our own hook, replacing the inline styles the control arm passes.
 */ const $144c0f90b58057f8$var$EMOJI_TOOLTIP_CLASS_NAMES = `${(0, $h1Peg.VANILLA_TOOLTIP_DEFAULT_CLASS)} ${$144c0f90b58057f8$var$EMOJI_TOOLTIP_CLASS}`;
/**
 * Control arm only — `VanillaTooltip` generates its own id when none is supplied.
 * `crypto.randomUUID()` is undefined outside a secure context, hence the `uniqueId` fallback.
 */ const $144c0f90b58057f8$var$nextFallbackTooltipId = ()=>typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function' ? `emoji-tooltip-${crypto.randomUUID()}` : (0, (/*@__PURE__*/$parcel$interopDefault($9wMFw)))('emoji-tooltip-');
class $144c0f90b58057f8$export$cadc6675ce598ba8 {
    destroyTooltip() {
        this.destroyLazyTooltipListeners?.();
        this.tooltipInstance?.destroy();
        // with platform_editor_use_vanilla_components the tooltipInstance?.destroy()
        // will remove the popovertarget and aria-describedby attributes from the tooltipTarget
        if (!(0, $4o0zT.isExperimentEnabled)('platform_editor_use_vanilla_components')) {
            this.tooltipTarget?.removeAttribute('popovertarget');
            this.tooltipTarget?.removeAttribute('aria-describedby');
        }
        this.destroyLazyTooltipListeners = undefined;
        this.tooltipInstance = undefined;
        this.tooltipTarget = undefined;
    }
    static logError(error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-plugin-emoji/EmojiNodeView'
        });
    }
    /** Type guard to check if a Node is an HTMLElement in a safe way. */ isHTMLElement(element) {
        if (element === null) return false;
        // In SSR `HTMLElement` is not defined, so we need to use duck typing here
        return 'innerHTML' in element && 'style' in element && 'classList' in element;
    }
    async updateDom(emojiProvider) {
        try {
            const { shortName: shortName, id: id, text: fallback } = this.node.attrs;
            const emojiDescription = await emojiProvider?.fetchByEmojiId({
                id: id,
                shortName: shortName,
                fallback: fallback
            }, true);
            if (!emojiDescription) {
                $144c0f90b58057f8$export$cadc6675ce598ba8.logError(new Error('Emoji description is not loaded'));
                this.renderFallback();
                return;
            }
            const unicodeEmoji = id && (0, $anBbz.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true) ? (0, $4xiow.emojiIdToEmoji)(id) : undefined;
            const emojiRepresentation = unicodeEmoji ? {
                unicodeEmoji: unicodeEmoji
            } : emojiDescription?.representation;
            if (!$144c0f90b58057f8$export$cadc6675ce598ba8.isEmojiRepresentationSupported(emojiRepresentation)) {
                $144c0f90b58057f8$export$cadc6675ce598ba8.logError(new Error('Emoji representation is not supported'));
                this.renderFallback();
                return;
            }
            this.renderEmoji(emojiDescription, emojiRepresentation);
        } catch (error) {
            $144c0f90b58057f8$export$cadc6675ce598ba8.logError(error instanceof Error ? error : new Error('Unknown error on EmojiNodeView updateDom'));
            this.renderFallback();
        }
    }
    static isEmojiRepresentationSupported(representation) {
        return !!representation && ('sprite' in representation || 'imagePath' in representation || 'mediaPath' in representation || 'unicodeEmoji' in representation);
    }
    static shouldRecordUnicodeEmojiExposure(description, representation) {
        return description.type === 'STANDARD' || 'unicodeEmoji' in representation;
    }
    // Pay attention, this method should be called only when the emoji provider returns
    // emoji data to prevent rendering empty emoji during loading.
    cleanUpAndRenderCommonAttributes() {
        this.destroyTooltip();
        // Clean up the DOM before rendering the new emoji
        if (this.domElement) {
            this.domElement.innerHTML = '';
            this.domElement.style.cssText = '';
            this.domElement.classList.remove((0, $k8ZZN.EmojiSharedCssClassName).EMOJI_PLACEHOLDER);
            this.domElement.removeAttribute('aria-label'); // The label is set in the renderEmoji method
            this.domElement.removeAttribute('aria-busy');
        }
    }
    /**
   * Lazily creates a VanillaTooltip on the given element showing the emoji shortName.
   * Gated behind the platform_editor_emoji_hover_show_tooltip experiment.
   * When the tooltip is active, the native `title` attribute is removed to avoid
   * showing both the browser tooltip and the custom tooltip.
   */ createTooltip(element, shortName) {
        if (!(0, $ieeJu.expValEquals)('platform_editor_emoji_hover_show_tooltip', 'isEnabled', true)) return;
        if ((0, $4iudd.isSSR)()) return;
        const initTooltip = (event)=>{
            this.destroyLazyTooltipListeners?.();
            this.destroyLazyTooltipListeners = undefined;
            // `undefined` lets `VanillaTooltip` generate the id.
            const tooltipId = (0, $4o0zT.isExperimentEnabled)('platform_editor_use_vanilla_components') ? undefined : $144c0f90b58057f8$var$nextFallbackTooltipId();
            // Control arm only — the experiment arm gets the same declarations from
            // `VANILLA_TOOLTIP_DEFAULT_CLASS`.
            const tooltipStyles = (0, $4o0zT.isExperimentEnabled)('platform_editor_use_vanilla_components') ? undefined : {
                boxSizing: 'border-box',
                maxWidth: '240px',
                backgroundColor: "var(--ds-background-neutral-bold, #292A2E)",
                border: 'none',
                borderRadius: "var(--ds-radius-small, 3px)",
                color: "var(--ds-text-inverse, #FFFFFF)",
                font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                insetBlockStart: "var(--ds-space-0, 0px)",
                insetInlineStart: "var(--ds-space-0, 0px)",
                overflowWrap: 'break-word',
                paddingBlockStart: "var(--ds-space-050, 4px)",
                paddingBlockEnd: "var(--ds-space-050, 4px)",
                paddingInlineEnd: "var(--ds-space-075, 6px)",
                paddingInlineStart: "var(--ds-space-075, 6px)",
                whiteSpace: 'normal'
            };
            try {
                // Flag-on (platform-dst-top-layer), positioning is async via a React root;
                // safe here as VanillaTooltip stays hidden until positioned.
                const tooltipInstance = new (0, $h1Peg.VanillaTooltip)(element, shortName, tooltipId, (0, $4o0zT.isExperimentEnabled)('platform_editor_use_vanilla_components') ? $144c0f90b58057f8$var$EMOJI_TOOLTIP_CLASS_NAMES : $144c0f90b58057f8$var$EMOJI_TOOLTIP_CLASS, // default timeout
                300, tooltipStyles);
                this.tooltipInstance = tooltipInstance;
                this.tooltipTarget = element;
                element.removeAttribute('title');
                element.dispatchEvent(new Event(event.type));
            } catch (error) {
                element.removeAttribute('popovertarget');
                element.removeAttribute('aria-describedby');
                $144c0f90b58057f8$export$cadc6675ce598ba8.logError(error instanceof Error ? error : new Error(String(error)));
            }
        };
        const unbindMouseEnter = (0, $cbY7C.bind)(element, {
            type: 'mouseenter',
            listener: initTooltip,
            options: {
                once: true
            }
        });
        const unbindFocus = (0, $cbY7C.bind)(element, {
            type: 'focus',
            listener: initTooltip,
            options: {
                once: true
            }
        });
        this.destroyLazyTooltipListeners = ()=>{
            unbindMouseEnter();
            unbindFocus();
        };
    }
    renderFallback() {
        this.renderingFallback = true;
        this.cleanUpAndRenderCommonAttributes();
        let doc = (0, $1hQ0e.getDocument)();
        if (!doc) // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        doc = document;
        const fallbackElement = doc.createElement('span');
        const { text: text, shortName: shortName } = this.node.attrs;
        // When the gate is enabled and the emoji is "custom" (i.e. its fallback
        // text is not a single standard Unicode emoji), render the Unicode
        // Replacement Character (U+FFFD) instead of the shortName text. Standard
        // emojis continue to fall back to their Unicode text representation.
        const fallbackText = text || shortName;
        const useReplacementChar = (0, $iDrrr.fg)('platform_editor_custom_emoji_unicode_fallback') && !(0, $2DBsV.isSingleEmoji)(fallbackText);
        const renderedFallbackText = useReplacementChar ? '\uFFFD' : fallbackText;
        fallbackElement.innerText = renderedFallbackText;
        fallbackElement.setAttribute('role', 'img');
        fallbackElement.setAttribute('title', shortName);
        fallbackElement.setAttribute('aria-label', shortName);
        fallbackElement.setAttribute('data-testid', `fallback-emoji-${shortName}`);
        fallbackElement.setAttribute('data-emoji-type', 'fallback');
        this.dom.appendChild(fallbackElement);
        this.createTooltip(fallbackElement, shortName);
    }
    renderEmoji(description, representation) {
        this.renderingFallback = false;
        this.cleanUpAndRenderCommonAttributes();
        const emojiType = 'unicodeEmoji' in representation ? 'unicode' : 'sprite' in representation ? 'sprite' : 'image';
        let doc = (0, $1hQ0e.getDocument)();
        if (!doc) // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        doc = document;
        // Add wrapper for the emoji
        const containerElement = doc.createElement('span');
        containerElement.setAttribute('role', 'img');
        containerElement.setAttribute('title', description.shortName);
        containerElement.classList.add((0, $k8ZZN.EmojiSharedCssClassName).EMOJI_CONTAINER);
        containerElement.setAttribute('data-testid', `${emojiType}-emoji-${description.shortName}`);
        containerElement.setAttribute('data-emoji-type', emojiType);
        containerElement.setAttribute('aria-label', `${this.intl.formatMessage((0, $2O2Zk.messages).emojiNodeLabel)} ${description.shortName}`);
        const emojiElement = 'unicodeEmoji' in representation ? this.createUnicodeEmojiElement(representation.unicodeEmoji) : 'sprite' in representation ? this.createSpriteEmojiElement(representation) : this.createImageEmojiElement(description, representation);
        containerElement.appendChild(emojiElement);
        this.dom.appendChild(containerElement);
        if ($144c0f90b58057f8$export$cadc6675ce598ba8.shouldRecordUnicodeEmojiExposure(description, representation)) (0, $ieeJu.expValEquals)('platform_use_unicode_emojis', 'isEnabled', true);
        this.createTooltip(containerElement, description.shortName);
    }
    createUnicodeEmojiElement(emoji) {
        let doc = (0, $1hQ0e.getDocument)();
        if (!doc) // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        doc = document;
        const spanElement = doc.createElement('span');
        spanElement.classList.add((0, $k8ZZN.EmojiSharedCssClassName).EMOJI_UNICODE);
        spanElement.textContent = emoji;
        spanElement.style.display = 'inline-flex';
        spanElement.style.fontSize = `var(--emoji-common-unicode-size, ${0, $l4yrE.defaultEmojiHeight}px)`;
        spanElement.style.alignItems = 'center';
        spanElement.style.aspectRatio = '1/1';
        spanElement.style.lineHeight = '1em';
        spanElement.style.margin = '-1px 0';
        spanElement.style.verticalAlign = 'middle'; // to keep vertical alignment consistent with images
        return spanElement;
    }
    createSpriteEmojiElement(representation) {
        let doc = (0, $1hQ0e.getDocument)();
        if (!doc) // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        doc = document;
        const spriteElement = doc.createElement('span');
        spriteElement.classList.add((0, $k8ZZN.EmojiSharedCssClassName).EMOJI_SPRITE);
        const sprite = representation.sprite;
        const xPositionInPercent = 100 / (sprite.column - 1) * representation.xIndex;
        const yPositionInPercent = 100 / (sprite.row - 1) * representation.yIndex;
        spriteElement.style.backgroundImage = `url(${sprite.url})`;
        spriteElement.style.backgroundPosition = `${xPositionInPercent}% ${yPositionInPercent}%`;
        spriteElement.style.backgroundSize = `${sprite.column * 100}% ${sprite.row * 100}%`;
        spriteElement.style.minWidth = `${0, $l4yrE.defaultEmojiHeight}px`;
        spriteElement.style.minHeight = `${0, $l4yrE.defaultEmojiHeight}px`;
        if (!(0, $ieeJu.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true)) {
            spriteElement.style.width = `${0, $l4yrE.defaultEmojiHeight}px`;
            spriteElement.style.height = `${0, $l4yrE.defaultEmojiHeight}px`;
        }
        return spriteElement;
    }
    createImageEmojiElement(emojiDescription, representation) {
        let doc = (0, $1hQ0e.getDocument)();
        if (!doc) // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        doc = document;
        const imageElement = doc.createElement('img');
        imageElement.classList.add((0, $k8ZZN.EmojiSharedCssClassName).EMOJI_IMAGE);
        imageElement.src = 'imagePath' in representation ? representation.imagePath : representation.mediaPath;
        imageElement.loading = 'lazy';
        imageElement.alt = emojiDescription.name || emojiDescription.shortName;
        imageElement.style.minWidth = `${0, $l4yrE.defaultEmojiHeight}px`;
        imageElement.style.objectFit = 'contain';
        imageElement.height = (0, $l4yrE.defaultEmojiHeight);
        imageElement.onerror = ()=>{
            // If there's an error (ie. offline) render the ascii fallback if possible, otherwise
            // mark the node to refresh when returning online.
            // Create a check that confirms if this.node.attrs.text if an ascii emoji
            if ((0, $2DBsV.isSingleEmoji)(this.node.attrs.text)) this.renderFallback();
            else this.renderingFallback = true;
        };
        return imageElement;
    }
    /**
   * Prosemirror node view for rendering emoji nodes. This class is responsible for
   * rendering emoji nodes in the editor, handling updates, and managing fallback rendering.
   *
   * @param node - The ProseMirror node representing the emoji.
   * @param extraProps - An object containing additional parameters.
   * @param extraProps.intl - The internationalization object for formatting messages.
   * @param extraProps.api - The editor API for accessing shared state and connectivity features.
   * @param extraProps.emojiNodeDataProvider - (Optional) A provider for fetching emoji data.
   *
   * @example
   * const emojiNodeView = new EmojiNodeView(node, { intl, api, emojiNodeDataProvider });
   */ constructor(node, { intl: intl, api: api, emojiNodeDataProvider: emojiNodeDataProvider }){
        this.dom = void 0;
        this.domElement = void 0;
        this.node = void 0;
        this.intl = void 0;
        this.renderingFallback = false;
        this.tooltipInstance = void 0;
        this.tooltipTarget = void 0;
        this.destroyLazyTooltipListeners = void 0;
        this.destroy = ()=>{
            if (this.tooltipInstance || this.tooltipTarget || this.destroyLazyTooltipListeners) this.destroyTooltip();
        };
        this.node = node;
        this.intl = intl;
        const { dom: dom } = (0, $aPdNQ.DOMSerializer).renderSpec(document, (0, $f5VOy.emojiToDom)(this.node));
        this.dom = dom;
        this.domElement = this.isHTMLElement(dom) ? dom : undefined;
        if (emojiNodeDataProvider) {
            let previousEmojiDescription;
            emojiNodeDataProvider.getData(node, (payload)=>{
                if (payload.error) {
                    $144c0f90b58057f8$export$cadc6675ce598ba8.logError(payload.error);
                    this.renderFallback();
                    return;
                }
                const optionalEmojiDescription = payload.data;
                if (!optionalEmojiDescription) {
                    this.renderFallback();
                    return;
                }
                const emojiRepresentation = optionalEmojiDescription?.representation;
                if (!$144c0f90b58057f8$export$cadc6675ce598ba8.isEmojiRepresentationSupported(emojiRepresentation)) {
                    this.renderFallback();
                    return;
                }
                if ((0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(previousEmojiDescription, optionalEmojiDescription)) // Do not re-render if the emoji description is the same as before
                return;
                previousEmojiDescription = optionalEmojiDescription;
                this.renderEmoji(optionalEmojiDescription, emojiRepresentation);
            });
        } else {
            if ((0, $4iudd.isSSR)()) // The provider doesn't work in SSR, and we don't want to render fallback in SSR,
            // that's why we don't need to continue node rendering.
            // In SSR we want to show a placeholder, that `emojiToDom()` returns.
            return;
            // We use the `emojiProvider` from the shared state
            // because it supports the `emojiProvider` prop in the `ComposableEditor` options
            // as well as the `emojiProvider` in the `EmojiPlugin` options.
            const sharedState = api?.emoji?.sharedState;
            if (!sharedState) return;
            let emojiProvider = sharedState.currentState()?.emojiProvider;
            if (emojiProvider) this.updateDom(emojiProvider);
            const unsubscribe = sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                if (emojiProvider === nextSharedState?.emojiProvider) // Do not update if the provider is the same
                return;
                emojiProvider = nextSharedState?.emojiProvider;
                this.updateDom(emojiProvider);
            });
            // Refresh emojis if we go back online
            const subscribeToConnection = api?.connectivity?.sharedState.onChange(({ prevSharedState: prevSharedState, nextSharedState: nextSharedState })=>{
                if ((0, $jaFVy.isOfflineMode)(prevSharedState?.mode) && nextSharedState?.mode === 'online' && this.renderingFallback) this.updateDom(sharedState.currentState()?.emojiProvider);
            });
            this.destroy = ()=>{
                unsubscribe();
                subscribeToConnection?.();
                this.destroyTooltip();
            };
        }
    }
}
module.exports["EmojiNodeView"] = $144c0f90b58057f8$export$cadc6675ce598ba8;

});

parcelRegister("9wMFw", function(module, exports) {

var $dojlP = parcelRequire("dojlP");

/** Used to generate unique IDs. */ var $6efcdace0fb66c85$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $6efcdace0fb66c85$var$uniqueId(prefix) {
    var id = ++$6efcdace0fb66c85$var$idCounter;
    return $dojlP(prefix) + id;
}
module.exports = $6efcdace0fb66c85$var$uniqueId;

});

parcelRegister("2O2Zk", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $373e836c88a63247$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    emojiNodeLabel: {
        id: "fabric.emoji.label",
        defaultMessage: "Emoji"
    }
});
module.exports["messages"] = $373e836c88a63247$export$defe85febe8b728c;

});

parcelRegister("2DBsV", function(module, exports) {
const $cdd07b0bc87acc5f$var$SINGLE_EMOJI_REGEX = // Regular expression to match a single emoji character
RegExp("^(\\p{Emoji_Presentation}(?:[\\u{1F3FB}-\\u{1F3FF}])?|\\p{Extended_Pictographic}\\u{FE0F}(?:[\\u{1F3FB}-\\u{1F3FF}])?(?:\\u{200D}\\p{Extended_Pictographic}\\u{FE0F}?(?:[\\u{1F3FB}-\\u{1F3FF}])?)*|\\p{Extended_Pictographic}\\u{FE0F}?(?:[\\u{1F3FB}-\\u{1F3FF}])?(?:\\u{200D}\\p{Extended_Pictographic}\\u{FE0F}?(?:[\\u{1F3FB}-\\u{1F3FF}])?)+|\\p{Regional_Indicator}\\p{Regional_Indicator})$", "u");
function $cdd07b0bc87acc5f$export$1d677781db73ff20(fallbackText) {
    return $cdd07b0bc87acc5f$var$SINGLE_EMOJI_REGEX.test(fallbackText ?? '');
}
module.exports["isSingleEmoji"] = $cdd07b0bc87acc5f$export$1d677781db73ff20;

});

parcelRegister("38lAe", function(module, exports) {

var $k7vUa = parcelRequire("k7vUa");

const $0ac6ed1cc3df6249$export$92a1a3b7554e9387 = {
    SET_PROVIDER: 'SET_PROVIDER',
    SET_RESULTS: 'SET_RESULTS',
    SET_ASCII_MAP: 'SET_ASCII_MAP',
    SET_INLINE_POPUP: 'SET_INLINE_POPUP'
};
const $0ac6ed1cc3df6249$export$5e8f481ab8296997 = (asciiMap)=>(tr)=>{
        return tr.setMeta((0, $k7vUa.emojiPluginKey), {
            action: $0ac6ed1cc3df6249$export$92a1a3b7554e9387.SET_ASCII_MAP,
            params: {
                asciiMap: asciiMap
            }
        });
    };
const $0ac6ed1cc3df6249$export$adbec20dbbf15a6b = (typeaheadHandler, api)=>(inputMethod)=>{
        return Boolean(api?.typeAhead?.actions.open({
            triggerHandler: typeaheadHandler,
            inputMethod: inputMethod
        }));
    };
const $0ac6ed1cc3df6249$export$1572b3eade6662f9 = (provider)=>(tr)=>{
        return tr.setMeta((0, $k7vUa.emojiPluginKey), {
            action: $0ac6ed1cc3df6249$export$92a1a3b7554e9387.SET_PROVIDER,
            params: {
                provider: provider
            }
        });
    };
const $0ac6ed1cc3df6249$export$f53f9c9a74ec859b = (open)=>(tr)=>tr.setMeta((0, $k7vUa.emojiPluginKey), {
            action: $0ac6ed1cc3df6249$export$92a1a3b7554e9387.SET_INLINE_POPUP,
            params: {
                open: open
            }
        });
module.exports["ACTIONS"] = $0ac6ed1cc3df6249$export$92a1a3b7554e9387;
module.exports["setAsciiMap"] = $0ac6ed1cc3df6249$export$5e8f481ab8296997;
module.exports["openTypeAhead"] = $0ac6ed1cc3df6249$export$adbec20dbbf15a6b;
module.exports["setProvider"] = $0ac6ed1cc3df6249$export$1572b3eade6662f9;
module.exports["setInlineEmojiPopupOpen"] = $0ac6ed1cc3df6249$export$f53f9c9a74ec859b;

});

parcelRegister("6wqCa", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $kpCD8 = parcelRequire("kpCD8");


var $d8RhQ = parcelRequire("d8RhQ");


var $91Kwo = parcelRequire("91Kwo");

var $3brWT = parcelRequire("3brWT");

let $4ed2d201aff988fe$var$matcher;
function $4ed2d201aff988fe$export$568a7ed6897c4817(schema, editorAnalyticsAPI, pluginInjectionApi, disableAutoformat) {
    if (disableAutoformat) return;
    if (schema.nodes.emoji) {
        $4ed2d201aff988fe$var$initMatcher(pluginInjectionApi);
        const asciiEmojiRule = (0, $d8RhQ.createRule)($4ed2d201aff988fe$var$AsciiEmojiMatcher.REGEX, $4ed2d201aff988fe$var$inputRuleHandler(editorAnalyticsAPI));
        return new (0, $kpCD8.SafePlugin)((0, $91Kwo.createPlugin)('emoji', [
            asciiEmojiRule
        ]));
    }
    return;
}
function $4ed2d201aff988fe$var$initMatcher(pluginInjectionApi) {
    pluginInjectionApi?.emoji.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
        const emojiProvider = nextSharedState?.emojiProvider;
        if (emojiProvider) emojiProvider.getAsciiMap().then((map)=>{
            $4ed2d201aff988fe$var$matcher = new $4ed2d201aff988fe$var$RecordingAsciiEmojiMatcher(emojiProvider, map);
        });
    });
}
const $4ed2d201aff988fe$var$inputRuleHandler = (editorAnalyticsAPI)=>(state, matchParts, start, end)=>{
        if (!$4ed2d201aff988fe$var$matcher) return null;
        const match = $4ed2d201aff988fe$var$matcher.match(matchParts);
        if (match) {
            const transactionCreator = new $4ed2d201aff988fe$var$AsciiEmojiTransactionCreator(state, match, start, end, editorAnalyticsAPI);
            return transactionCreator.create();
        }
        return null;
    };
const $4ed2d201aff988fe$var$REGEX_LEADING_CAPTURE_INDEX = 1;
const $4ed2d201aff988fe$var$REGEX_EMOJI_LEADING_PARENTHESES = 2;
const $4ed2d201aff988fe$var$REGEX_EMOJI_ASCII_CAPTURE_INDEX = 3;
const $4ed2d201aff988fe$var$REGEX_TRAILING_CAPTURE_INDEX = 4;
const $4ed2d201aff988fe$var$getLeadingString = (match, withParenthesis = true)=>match[$4ed2d201aff988fe$var$REGEX_LEADING_CAPTURE_INDEX] + (withParenthesis ? match[$4ed2d201aff988fe$var$REGEX_EMOJI_LEADING_PARENTHESES] : '');
const $4ed2d201aff988fe$var$getLeadingStringWithoutParentheses = (match)=>$4ed2d201aff988fe$var$getLeadingString(match, false);
const $4ed2d201aff988fe$var$getAscii = (match, withParentheses = false)=>(withParentheses ? match[$4ed2d201aff988fe$var$REGEX_EMOJI_LEADING_PARENTHESES] : '') + match[$4ed2d201aff988fe$var$REGEX_EMOJI_ASCII_CAPTURE_INDEX].trim();
const $4ed2d201aff988fe$var$getAsciiWithParentheses = (matchParts)=>$4ed2d201aff988fe$var$getAscii(matchParts, true);
const $4ed2d201aff988fe$var$getTrailingString = (match)=>match[$4ed2d201aff988fe$var$REGEX_TRAILING_CAPTURE_INDEX] || '';
class $4ed2d201aff988fe$var$AsciiEmojiMatcher {
    match(matchParts) {
        return this.getAsciiEmojiMatch($4ed2d201aff988fe$var$getLeadingStringWithoutParentheses(matchParts), $4ed2d201aff988fe$var$getAsciiWithParentheses(matchParts), $4ed2d201aff988fe$var$getTrailingString(matchParts)) || this.getAsciiEmojiMatch($4ed2d201aff988fe$var$getLeadingString(matchParts), $4ed2d201aff988fe$var$getAscii(matchParts), $4ed2d201aff988fe$var$getTrailingString(matchParts));
    }
    getAsciiEmojiMatch(leading, ascii, trailing) {
        const emoji = this.asciiToEmojiMap.get(ascii);
        return emoji ? {
            emoji: emoji,
            leadingString: leading,
            trailingString: trailing
        } : undefined;
    }
    constructor(asciiToEmojiMap){
        this.asciiToEmojiMap = void 0;
        this.asciiToEmojiMap = asciiToEmojiMap;
    }
}
/**
 * A matcher that will record ascii matches as usages of the matched emoji.
 */ /**
 * This regex matches 2 scenarios:
 * 1. an emoticon starting with a colon character (e.g. :D => 😃)
 * 2. an emoticon not starting with a colon character (e.g. 8-D => 😎)
 *
 * Explanation (${leafNodeReplacementCharacter} is replaced with character \ufffc)
 *
 *  1st Capturing Group ((?:^|[\s\ufffc])(?:\(*?))
 *    Non-capturing group (?:^|[\s\ufffc])
 *      1st Alternative ^
 *        ^ asserts position at start of the string
 *      2nd Alternative [\s\ufffc]
 *        matches a single character present in [\s\ufffc]
 *    Non-capturing group (?:\(*?)
 *      matches the character ( literally between zero and unlimited times, as few times as possible, expanding as needed (lazy)
 *  2nd Capturing Group (\(?)
 *    matches a single ( if present
 *  3rd Capturing Group ([^:\s\ufffc\(]\S{1,3}|:\S{1,3}( ))
 *    1st Alternative [^:\s\ufffc\(]\S{1,3}
 *      matches a single character not present in [^:\s\ufffc\(] between 1 and 3 times, as many times as possible, giving back as needed (greedy)
 *    2nd Alternative :\S{1,3}( )
 *      : matches the character : literally
 *      \S{1,3} matches any non-whitespace character between 1 and 3 times, as many times as possible, giving back as needed (greedy)
 *  4th Capturing Group ( )
 *
 * See https://regex101.com/r/HRS9O2/4
 */ // New behavior: All emoticons require whitespace after them
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
$4ed2d201aff988fe$var$AsciiEmojiMatcher.REGEX = new RegExp(`((?:^|[\\s${(0, $3brWT.leafNodeReplacementCharacter)}])(?:\\(*?))(\\(?)([^:\\s${(0, $3brWT.leafNodeReplacementCharacter)}\\(]\\S{1,3}|:\\S{1,3})([\\s\\t\\n])$`);
class $4ed2d201aff988fe$var$RecordingAsciiEmojiMatcher extends $4ed2d201aff988fe$var$AsciiEmojiMatcher {
    match(matchParts) {
        const match = super.match(matchParts);
        if (match && this.emojiProvider.recordSelection) this.emojiProvider.recordSelection(match.emoji);
        return match;
    }
    constructor(emojiProvider, asciiToEmojiMap){
        super(asciiToEmojiMap);
        this.emojiProvider = void 0;
        this.emojiProvider = emojiProvider;
    }
}
class $4ed2d201aff988fe$var$AsciiEmojiTransactionCreator {
    create() {
        const tr = this.state.tr.replaceWith(this.from, this.to, this.createNodes());
        this.editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).INSERTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EMOJI,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).ASCII
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }
    get from() {
        return this.start + this.match.leadingString.length;
    }
    get to() {
        return this.end;
    }
    createNodes() {
        const nodes = [
            this.createEmojiNode()
        ];
        if (this.trailingTextNodeRequired()) nodes.push(this.createTrailingTextNode());
        return nodes;
    }
    createEmojiNode() {
        const { emoji: emojiTypeNode } = this.state.schema.nodes;
        return emojiTypeNode.create(this.getEmojiNodeAttrs());
    }
    getEmojiNodeAttrs() {
        const emoji = this.match.emoji;
        return {
            id: emoji.id,
            shortName: emoji.shortName,
            text: emoji.fallback || emoji.shortName
        };
    }
    trailingTextNodeRequired() {
        return this.match.trailingString.length > 0;
    }
    createTrailingTextNode() {
        return this.state.schema.text(this.match.trailingString);
    }
    constructor(state, match, start, end, editorAnalyticsAPI){
        this.state = void 0;
        this.match = void 0;
        this.start = void 0;
        this.end = void 0;
        this.editorAnalyticsAPI = void 0;
        this.state = state;
        this.match = match;
        this.start = start;
        this.end = end;
        this.editorAnalyticsAPI = editorAnalyticsAPI;
    }
}
const $4ed2d201aff988fe$var$plugins = (schema, providerFactory, featureFlags, editorAnalyticsAPI, pluginInjectionApi)=>{
    return [
        $4ed2d201aff988fe$export$568a7ed6897c4817(schema, editorAnalyticsAPI, pluginInjectionApi)
    ].filter((plugin)=>!!plugin);
};
var $4ed2d201aff988fe$export$2e2bcd8739ae039 = $4ed2d201aff988fe$var$plugins;
module.exports["inputRulePlugin"] = $4ed2d201aff988fe$export$568a7ed6897c4817;

});

parcelRegister("8civN", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $krYZG = parcelRequire("krYZG");


var $ajK0g = parcelRequire("ajK0g");


var $4y8CY = parcelRequire("4y8CY");


var $7XIuB = parcelRequire("7XIuB");


var $uyXFl = parcelRequire("uyXFl");

var $9Muxb = parcelRequire("9Muxb");


var $4Qu9h = parcelRequire("4Qu9h");


var $7Y8M5 = parcelRequire("7Y8M5");


var $lAkJe = parcelRequire("lAkJe");


var $iDrrr = parcelRequire("iDrrr");


var $38lAe = parcelRequire("38lAe");

const $fea728d07a1765e1$var$PopupWithListeners = (0, $9Muxb.default)((0, $7XIuB.default));
const $fea728d07a1765e1$var$emojiPopupMessages = {
    emojiPickerAriaLabel: {
        id: 'fabric.emoji.picker.aria.label',
        defaultMessage: 'Emoji picker',
        description: 'Accessible label for the emoji picker popup'
    }
};
const $fea728d07a1765e1$export$b7ec9ebb3bbf8534 = ({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, contentId: contentId, onClose: onClose })=>{
    const { emojiProvider: emojiProvider, inlineEmojiPopupOpen: isOpen } = (0, $4y8CY.useSharedPluginState)(api, [
        'emoji'
    ])?.emojiState ?? {};
    const intl = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        if (isOpen && (0, $iDrrr.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.handleIntentToStartEdit({
            shouldStartTimer: false,
            shouldPersistActiveSession: true
        }));
    }, [
        isOpen,
        api
    ]);
    const handleOnClose = (0, $cozmU.useCallback)(()=>{
        if ((0, $iDrrr.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
        onClose?.();
    }, [
        onClose,
        api
    ]);
    const focusEditor = (0, $cozmU.useCallback)(()=>{
        // use requestAnimationFrame to run this async after the call
        requestAnimationFrame(()=>editorView.focus());
    }, [
        editorView
    ]);
    const handleSelection = (0, $cozmU.useCallback)((emojiId)=>{
        api.core.actions.execute(api.emoji.commands.insertEmoji(emojiId, (0, $krYZG.INPUT_METHOD).PICKER));
        handleOnClose();
    }, [
        api.core.actions,
        api.emoji.commands,
        handleOnClose
    ]);
    if (!isOpen || !emojiProvider) return null;
    const domRef = (0, $ajK0g.getDomRefFromSelection)(editorView, (0, $krYZG.ACTION_SUBJECT_ID).PICKER_EMOJI, api?.analytics?.actions);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($fea728d07a1765e1$var$PopupWithListeners, {
        ariaLabel: intl.formatMessage($fea728d07a1765e1$var$emojiPopupMessages.emojiPickerAriaLabel),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            0,
            12
        ],
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        zIndex: (0, $7Y8M5.akEditorFloatingDialogZIndex),
        fitHeight: 350,
        fitWidth: 350,
        target: domRef,
        onUnmount: focusEditor,
        focusTrap: true,
        preventOverflow: true,
        handleClickOutside: handleOnClose,
        handleEscapeKeydown: handleOnClose,
        captureClick: true,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $uyXFl.OutsideClickTargetRefContext).Consumer, {
            children: (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $lAkJe.EmojiPicker), {
                    contentId: contentId,
                    emojiProvider: Promise.resolve(emojiProvider),
                    onPickerRef: setOutsideClickTargetRef,
                    onSelection: handleSelection
                })
        })
    });
};
const $fea728d07a1765e1$var$InlineEmojiPopupContent = ({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, contentId: contentId })=>{
    const emojiProvider = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'emoji.emojiProvider');
    const intl = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        if ((0, $iDrrr.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.handleIntentToStartEdit({
            shouldStartTimer: false,
            shouldPersistActiveSession: true
        }));
    }, [
        api?.core.actions,
        api?.metrics?.commands
    ]);
    const handleOnClose = (0, $cozmU.useCallback)(()=>{
        editorView.dispatch((0, $38lAe.setInlineEmojiPopupOpen)(false)(editorView.state.tr));
        if ((0, $iDrrr.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
    }, [
        editorView,
        api.core.actions,
        api.metrics?.commands
    ]);
    const focusEditor = (0, $cozmU.useCallback)(()=>{
        // use requestAnimationFrame to run this async after the call
        requestAnimationFrame(()=>editorView.focus());
    }, [
        editorView
    ]);
    const handleSelection = (0, $cozmU.useCallback)((emojiId)=>{
        api.core.actions.execute(api.emoji.commands.insertEmoji(emojiId, (0, $krYZG.INPUT_METHOD).PICKER));
        handleOnClose();
    }, [
        api.core.actions,
        api.emoji.commands,
        handleOnClose
    ]);
    const domRef = (0, $cozmU.useMemo)(()=>(0, $ajK0g.getDomRefFromSelection)(editorView, (0, $krYZG.ACTION_SUBJECT_ID).PICKER_EMOJI, api?.analytics?.actions), [
        editorView,
        api?.analytics?.actions
    ]);
    if (!emojiProvider) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)($fea728d07a1765e1$var$PopupWithListeners, {
        ariaLabel: intl.formatMessage($fea728d07a1765e1$var$emojiPopupMessages.emojiPickerAriaLabel),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            0,
            12
        ],
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        zIndex: (0, $7Y8M5.akEditorFloatingDialogZIndex),
        fitHeight: 350,
        fitWidth: 350,
        target: domRef,
        onUnmount: focusEditor,
        focusTrap: true,
        preventOverflow: true,
        handleClickOutside: handleOnClose,
        handleEscapeKeydown: handleOnClose,
        captureClick: true,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $uyXFl.OutsideClickTargetRefContext).Consumer, {
            children: (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $lAkJe.EmojiPicker), {
                    contentId: contentId,
                    emojiProvider: Promise.resolve(emojiProvider),
                    onPickerRef: setOutsideClickTargetRef,
                    onSelection: handleSelection
                })
        })
    });
};
const $fea728d07a1765e1$export$295b54f3ba0abfa5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, contentId: contentId })=>{
    const isOpen = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'emoji.inlineEmojiPopupOpen');
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)($fea728d07a1765e1$var$InlineEmojiPopupContent, {
        api: api,
        editorView: editorView,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        contentId: contentId
    });
});
module.exports["InlineEmojiPopup"] = $fea728d07a1765e1$export$295b54f3ba0abfa5;

});

parcelRegister("ajK0g", function(module, exports) {

var $bjg0G = parcelRequire("bjg0G");


var $krYZG = parcelRequire("krYZG");

const $c1a12c1d77a0edce$export$49d74ed2464a12b9 = (view, actionSubjectId, editorAnalyticsAPI)=>{
    try {
        const domRef = (0, $bjg0G.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
        if (domRef instanceof HTMLElement) {
            // If element is not a paragraph, we need to find the closest paragraph parent
            if (domRef.nodeName !== 'P') {
                const paragraphRef = domRef.closest('p');
                if (paragraphRef) return paragraphRef;
            }
            return domRef;
        } else throw new Error('Invalid DOM reference');
    } catch (error) {
        if (editorAnalyticsAPI) {
            const payload = {
                action: (0, $krYZG.ACTION).ERRORED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).PICKER,
                actionSubjectId: actionSubjectId,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    error: 'Error getting DOM reference from selection'
                }
            };
            editorAnalyticsAPI.fireAnalyticsEvent(payload);
        }
    }
};
module.exports["getDomRefFromSelection"] = $c1a12c1d77a0edce$export$49d74ed2464a12b9;

});

parcelRegister("aowZj", function(module, exports) {

var $gx3UZ = parcelRequire("gx3UZ");


var $7SMXM = parcelRequire("7SMXM");


var $dCkbP = parcelRequire("dCkbP");


var $dXqu3 = parcelRequire("dXqu3");


var $4hFUk = parcelRequire("4hFUk");

const $e3cd6ae3791803fd$export$cff8c6d3484f6a4c = ()=>[
        {
            key: (0, $dCkbP.EMOJI_MENU_ITEM).key,
            type: (0, $dCkbP.EMOJI_MENU_ITEM).type,
            parents: [
                {
                    key: (0, $dCkbP.MEDIA_SECTION).key,
                    type: (0, $dCkbP.MEDIA_SECTION).type,
                    rank: (0, $dXqu3.MEDIA_SECTION_RANK)[(0, $dCkbP.EMOJI_MENU_ITEM).key]
                }
            ],
            match: (0, $7SMXM.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).emojiDescription),
                    shortcut: ':',
                    title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).emoji)
                })),
            component: (0, $4hFUk.EmojiQuickInsertMenuItem)
        }
    ];
module.exports["getEmojiQuickInsertComponents"] = $e3cd6ae3791803fd$export$cff8c6d3484f6a4c;

});

parcelRegister("4hFUk", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $gx3UZ = parcelRequire("gx3UZ");


var $I2MTF = parcelRequire("I2MTF");


var $6m2p9 = parcelRequire("6m2p9");


var $38lAe = parcelRequire("38lAe");

const $37ac3f787c71ab8c$var$previewImageUrls = {
    dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4jp3h212r4t8s51s7pv58v63gq23lbff.png',
    light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/j6cr4usu4q8iqwlf00157vf6724k1ki7.png'
};
const $37ac3f787c71ab8c$export$436810d83faf90ed = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const onSelect = (0, $cozmU.useCallback)(({ insert: insert })=>(0, $38lAe.setInlineEmojiPopupOpen)(true)(insert('')), []);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I2MTF.QuickInsertMenuItem), {
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6m2p9))), {
            label: ""
        }),
        onSelect: onSelect,
        previewImageUrls: $37ac3f787c71ab8c$var$previewImageUrls,
        shortcut: ":",
        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).emoji)
    });
};
module.exports["EmojiQuickInsertMenuItem"] = $37ac3f787c71ab8c$export$436810d83faf90ed;

});

parcelRegister("1U7Jq", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $1ptyh = parcelRequire("1ptyh");


var $4o0zT = parcelRequire("4o0zT");


var $jkcNT = parcelRequire("jkcNT");


var $ieeJu = parcelRequire("ieeJu");


var $klpad = parcelRequire("klpad");


var $8dubf = parcelRequire("8dubf");


var $lpCJp = parcelRequire("lpCJp");


var $3qA9L = parcelRequire("3qA9L");


var $4KwOr = parcelRequire("4KwOr");


var $cjq97 = parcelRequire("cjq97");


var $9trAT = parcelRequire("9trAT");

const $dc90d7d40da4ba04$export$8751de4ba1d9a8f9 = ({ api: api })=>{
    const editorAnalyticsAPI = api?.analytics?.actions;
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const primaryToolbarComponent = ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, editorView: editorView })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cjq97.PrimaryToolbarHighlightColorWithIntl), {
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            disabled: disabled,
            isToolbarReducedSpacing: isToolbarReducedSpacing,
            pluginInjectionApi: api,
            editorView: editorView
        });
    };
    if (!isToolbarAIFCEnabled) api?.primaryToolbar?.actions.registerComponent({
        name: 'highlight',
        component: primaryToolbarComponent
    });
    else api?.toolbar?.actions.registerComponents((0, $9trAT.getToolbarComponent)(api));
    return {
        name: 'highlight',
        marks () {
            if ((0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_lovability_color_schema_change')) return [
                {
                    name: 'backgroundColor',
                    mark: (0, $1ptyh.backgroundColor)
                }
            ];
            // color is defined in platform/packages/editor/adf-schema/src/next-schema/marks/color.ts
            return [
                {
                    name: 'backgroundColor',
                    mark: {
                        ...(0, $1ptyh.backgroundColor),
                        excludes: 'color'
                    }
                }
            ];
        },
        commands: {
            changeColor: (0, $klpad.changeColor)(editorAnalyticsAPI)
        },
        pmPlugins: ()=>{
            const plugins = [
                {
                    name: 'highlight',
                    plugin: ()=>(0, $3qA9L.createPlugin)()
                },
                {
                    name: 'highlightKeymap',
                    plugin: ()=>(0, $lpCJp.keymapPlugin)({
                            api: api
                        })
                },
                {
                    name: 'highlightPadding',
                    plugin: ()=>(0, $8dubf.createHighlightPaddingPlugin)()
                }
            ];
            return plugins;
        },
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $3qA9L.highlightPluginKey).getState(editorState);
        },
        pluginsOptions: !isToolbarAIFCEnabled ? {
            selectionToolbar () {
                const toolbarDocking = api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition;
                if (toolbarDocking === 'none' && (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                })) {
                    const toolbarCustom = {
                        type: 'custom',
                        render: (view, _idx, dispatchAnalyticsEvent)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $4KwOr.FloatingToolbarHighlightColorWithIntl), {
                                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                                pluginInjectionApi: api,
                                editorView: view
                            }),
                        fallback: []
                    };
                    const rank = (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? 5 : -9;
                    return {
                        rank: rank,
                        isToolbarAbove: true,
                        items: [
                            toolbarCustom
                        ],
                        pluginName: 'highlight'
                    };
                } else return undefined;
            }
        } : {},
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
};
module.exports["highlightPlugin"] = $dc90d7d40da4ba04$export$8751de4ba1d9a8f9;

});

parcelRegister("klpad", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $cZ1Iw = parcelRequire("cZ1Iw");

var $5tsXu = parcelRequire("5tsXu");

var $bhf6v = parcelRequire("bhf6v");


var $2RAus = parcelRequire("2RAus");


var $evFm2 = parcelRequire("evFm2");

var $1jFAi = parcelRequire("1jFAi");


var $4o0zT = parcelRequire("4o0zT");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $3qA9L = parcelRequire("3qA9L");


var $fMLvg = parcelRequire("fMLvg");

const $aab02ab2394ccf36$var$maybeSyncSelectionAfterFormat = (tr)=>{
    if (tr.docChanged) tr.setMeta((0, $2RAus.FORMAT_SELECTION_SYNC_META), true);
};
const $aab02ab2394ccf36$export$917538e4f4eb20f9 = (editorAnalyticsAPI)=>({ color: color, inputMethod: inputMethod })=>({ tr: tr })=>{
            const { marks: marks } = tr.doc.type.schema;
            const { backgroundColor: backgroundColor } = tr.doc.type.schema.marks;
            if (!backgroundColor) return null;
            editorAnalyticsAPI?.attachAnalyticsEvent($aab02ab2394ccf36$var$createAnalyticsEvent(color, inputMethod, tr))(tr);
            tr.scrollIntoView();
            if (color === (0, $evFm2.REMOVE_HIGHLIGHT_COLOR)) (0, $5tsXu.removeMark)(backgroundColor)({
                tr: tr
            });
            else {
                if ((0, $4o0zT.isExperimentEnabled)('platform_editor_lovability_color_schema_change') && !(0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true)) {
                    const overrideMarks = [
                        'textColor'
                    ];
                    overrideMarks.forEach((mark)=>{
                        if (marks[mark]) (0, $5tsXu.removeMark)(marks[mark])({
                            tr: tr
                        });
                    });
                }
                tr.setMeta((0, $3qA9L.highlightPluginKey), {
                    type: (0, $3qA9L.HighlightPluginAction).CHANGE_COLOR,
                    color: color
                });
                (0, $bhf6v.toggleMark)(backgroundColor, {
                    color: color
                })({
                    tr: tr
                });
            }
            $aab02ab2394ccf36$var$maybeSyncSelectionAfterFormat(tr);
            return tr;
        };
const $aab02ab2394ccf36$var$createAnalyticsEvent = (color, inputMethod, tr)=>{
    const previousColor = (0, $fMLvg.getActiveColor)(tr) ?? (0, $evFm2.REMOVE_HIGHLIGHT_COLOR);
    const highlightPalette = (0, $anBbz.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) ? (0, $1jFAi.highlightColorPaletteNew) : (0, $evFm2.highlightColorPalette);
    // get color names from palette
    const newColorFromPalette = highlightPalette.find(({ value: value })=>value === color);
    const previousColorFromPalette = highlightPalette.find(({ value: value })=>value === previousColor);
    const newColorLabel = newColorFromPalette ? newColorFromPalette.label : color;
    const previousColorLabel = previousColorFromPalette ? previousColorFromPalette.label : previousColor;
    const { textColor: textColor, link: link } = tr.doc.type.schema.marks;
    return {
        action: (0, $krYZG.ACTION).FORMATTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            newColor: newColorLabel.toLowerCase(),
            previousColor: previousColorLabel ? previousColorLabel.toLowerCase() : '',
            inputMethod: inputMethod,
            ...color === (0, $evFm2.REMOVE_HIGHLIGHT_COLOR) ? {} : (0, $cZ1Iw.getHadMarkAttributes)(tr, [
                textColor,
                link
            ])
        }
    };
};
module.exports["changeColor"] = $aab02ab2394ccf36$export$917538e4f4eb20f9;

});

parcelRegister("1jFAi", function(module, exports) {

var $1ptyh = parcelRequire("1ptyh");


var $xx2Zf = parcelRequire("xx2Zf");


var $evFm2 = parcelRequire("evFm2");


var $9Av6M = parcelRequire("9Av6M");


var $j1hRT = parcelRequire("j1hRT");

const $db5946739e91a2e0$export$7dee00034afd0ce = [
    {
        value: (0, $evFm2.REMOVE_HIGHLIGHT_COLOR),
        label: 'No color',
        // Mostly informative, only used for analytics
        border: "var(--ds-border, #0B120E24)",
        message: (0, $xx2Zf.default)((0, $j1hRT.default), 'no-color')
    }
];
(0, $1ptyh.backgroundColorPaletteNew).forEach((label, color)=>{
    $db5946739e91a2e0$export$7dee00034afd0ce.push((0, $9Av6M.mapPaletteColor)(label, color));
});
module.exports["highlightColorPaletteNew"] = $db5946739e91a2e0$export$7dee00034afd0ce;

});

parcelRegister("3qA9L", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $fMLvg = parcelRequire("fMLvg");


var $b71zX = parcelRequire("b71zX");

const $f58243ba1921692c$export$b8f1e1e1a4636cb0 = new (0, $kCECX.PluginKey)('highlight');
var $f58243ba1921692c$export$2dfab9d4f3f51423 = /*#__PURE__*/ function(HighlightPluginAction) {
    HighlightPluginAction[HighlightPluginAction["CHANGE_COLOR"] = 0] = "CHANGE_COLOR";
    HighlightPluginAction[HighlightPluginAction["SET_PALETTE"] = 1] = "SET_PALETTE";
    return HighlightPluginAction;
}({});
const $f58243ba1921692c$export$ae829ec7b2625219 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $f58243ba1921692c$export$b8f1e1e1a4636cb0,
        state: {
            init: (_, editorState)=>({
                    activeColor: null,
                    disabled: (0, $b71zX.getDisabledState)(editorState),
                    isPaletteOpen: false
                }),
            apply: (tr, pluginState, _oldState, newState)=>{
                const action = tr.getMeta($f58243ba1921692c$export$b8f1e1e1a4636cb0)?.type;
                switch(action){
                    case 0:
                        const { color: color } = tr.getMeta($f58243ba1921692c$export$b8f1e1e1a4636cb0);
                        return {
                            ...pluginState,
                            activeColor: color
                        };
                    case 1:
                        const { isPaletteOpen: isPaletteOpen } = tr.getMeta($f58243ba1921692c$export$b8f1e1e1a4636cb0);
                        return {
                            ...pluginState,
                            isPaletteOpen: isPaletteOpen
                        };
                    default:
                        const activeColor = (0, $fMLvg.getActiveColor)(tr);
                        return {
                            ...pluginState,
                            activeColor: activeColor,
                            disabled: (0, $b71zX.getDisabledState)(newState)
                        };
                }
            }
        }
    });
};
module.exports["highlightPluginKey"] = $f58243ba1921692c$export$b8f1e1e1a4636cb0;
module.exports["HighlightPluginAction"] = $f58243ba1921692c$export$2dfab9d4f3f51423;
module.exports["createPlugin"] = $f58243ba1921692c$export$ae829ec7b2625219;

});

parcelRegister("fMLvg", function(module, exports) {

var $hXuXM = parcelRequire("hXuXM");


var $kCECX = parcelRequire("kCECX");


var $8HW7o = parcelRequire("8HW7o");

const $cc72b0b788eceff6$export$544437a37c3070a9 = 'multiple';
const $cc72b0b788eceff6$var$getAllUniqueBackgroundColorMarksInRange = (from, to, tr)=>{
    const { doc: doc } = tr;
    const { backgroundColor: backgroundColor } = doc.type.schema.marks;
    const colorMarks = [];
    const colorSet = new Set();
    doc.nodesBetween(from, to, (node)=>{
        if (node.isLeaf) {
            const mark = backgroundColor.isInSet(node.marks);
            if (mark && !colorSet.has(mark.attrs.color)) {
                colorMarks.push(mark);
                colorSet.add(mark.attrs.color);
            }
        }
    });
    return colorMarks;
};
const $cc72b0b788eceff6$var$getAllUniqueBackgroundColorMarksInCellSelection = (selection, tr)=>{
    const colorMarks = [];
    const colorSet = new Set();
    selection.forEachCell((cell, cellPos)=>{
        const from = cellPos;
        const to = cellPos + cell.nodeSize;
        const marks = $cc72b0b788eceff6$var$getAllUniqueBackgroundColorMarksInRange(from, to, tr);
        marks.forEach((mark)=>{
            if (!colorSet.has(mark.attrs.color)) {
                colorMarks.push(mark);
                colorSet.add(mark.attrs.color);
            }
        });
    });
    return colorMarks;
};
// For Cell Selections - find first instance of a backgroundColor mark
// if all cells entirely contain this mark, set the color.
// If the selection contains multiple colors, return null
const $cc72b0b788eceff6$var$getColorFromCellSelection = (selection, tr)=>{
    const marks = $cc72b0b788eceff6$var$getAllUniqueBackgroundColorMarksInCellSelection(selection, tr);
    if (marks.length > 1) return $cc72b0b788eceff6$export$544437a37c3070a9;
    const firstColorMark = marks.at(0);
    if (!firstColorMark) return null;
    let foundUncolouredNode = false;
    selection.forEachCell((cell, cellPos)=>{
        if (foundUncolouredNode) return;
        const from = cellPos;
        const to = cellPos + cell.nodeSize;
        if (!(0, $hXuXM.entireSelectionContainsMark)(firstColorMark, tr.doc, from, to)) foundUncolouredNode = true;
    });
    return foundUncolouredNode ? null : firstColorMark.attrs.color;
};
// All other selections - find the first instance of a backgroundColor mark
// if selection entirely contains this mark, set the color.
// If the selection contains multiple colors, return null
const $cc72b0b788eceff6$var$getColorFromRange = (from, to, tr)=>{
    const marks = $cc72b0b788eceff6$var$getAllUniqueBackgroundColorMarksInRange(from, to, tr);
    if (marks.length > 1) return $cc72b0b788eceff6$export$544437a37c3070a9;
    const firstColorMark = marks.at(0);
    if (firstColorMark && (0, $hXuXM.entireSelectionContainsMark)(firstColorMark, tr.doc, from, to)) return firstColorMark.attrs.color;
    return null;
};
// For Cursor selections - set color if it is found in the storedMarks or $cursor.marks
const $cc72b0b788eceff6$var$getColorFromCursor = (selection, tr)=>{
    if (!selection.$cursor) return null;
    const mark = tr.doc.type.schema.marks.backgroundColor.isInSet([
        ...tr.storedMarks ? tr.storedMarks : [],
        ...selection.$cursor.marks()
    ]);
    return mark?.attrs.color ?? null;
};
const $cc72b0b788eceff6$export$1c6fa8f53a5fb47f = (tr)=>{
    const { selection: selection } = tr;
    let color = null;
    if (selection instanceof (0, $8HW7o.CellSelection)) color = $cc72b0b788eceff6$var$getColorFromCellSelection(selection, tr);
    else if (selection instanceof (0, $kCECX.TextSelection) && selection.$cursor) color = $cc72b0b788eceff6$var$getColorFromCursor(selection, tr);
    else color = $cc72b0b788eceff6$var$getColorFromRange(selection.from, selection.to, tr);
    return color;
};
module.exports["getActiveColor"] = $cc72b0b788eceff6$export$1c6fa8f53a5fb47f;

});

parcelRegister("b71zX", function(module, exports) {

var $kzHT3 = parcelRequire("kzHT3");

var $adJV7 = parcelRequire("adJV7");


var $4EksL = parcelRequire("4EksL");


var $kCECX = parcelRequire("kCECX");

const $e2943e24876b6d57$export$4af1020a67b5ec91 = (state)=>{
    const { backgroundColor: backgroundColor } = state.schema.marks;
    const { empty: empty, ranges: ranges, $cursor: $cursor } = state.selection;
    if (!backgroundColor) return true;
    if (state.selection instanceof (0, $kCECX.NodeSelection) || state.selection instanceof (0, $4EksL.GapCursorSelection)) return true;
    if (empty && !$cursor || (0, $kzHT3.isMarkAllowedInRange)(state.doc, ranges, backgroundColor) === false) return true;
    if ((0, $adJV7.isMarkExcluded)(backgroundColor, state.storedMarks || $cursor && $cursor.marks())) return true;
    return false;
};
module.exports["getDisabledState"] = $e2943e24876b6d57$export$4af1020a67b5ec91;

});

parcelRegister("8dubf", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $8nvEM = parcelRequire("8nvEM");


var $3YhlK = parcelRequire("3YhlK");


var $2Y3yg = parcelRequire("2Y3yg");

const $c486e0fd30b92a7e$export$64079c8b271eeba4 = new (0, $kCECX.PluginKey)('highlightPaddingPluginKey');
const $c486e0fd30b92a7e$export$8d5a971433249768 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $c486e0fd30b92a7e$export$64079c8b271eeba4,
        state: {
            init: (_, state)=>{
                // Initially scan the entire doc to create all highlight padding decorations
                // after which updates will only apply to changed ranges
                const initialDecorationSet = (0, $8nvEM.DecorationSet).empty;
                const decorationSet = (0, $3YhlK.addPaddingDecorations)({
                    decorationSet: initialDecorationSet,
                    state: state,
                    from: 0,
                    to: state.doc.content.size
                });
                return {
                    decorationSet: decorationSet
                };
            },
            apply: (tr, pluginState, _oldState, state)=>{
                if (!tr.docChanged) return pluginState;
                let decorationSet = pluginState.decorationSet.map(tr.mapping, tr.doc);
                tr.mapping.maps.forEach((stepMap)=>{
                    stepMap.forEach((_oldStart, _oldEnd, start, end)=>{
                        decorationSet = (0, $2Y3yg.updatePaddingDecorations)({
                            decorationSet: decorationSet,
                            state: state,
                            start: start,
                            end: end
                        });
                    });
                });
                return {
                    decorationSet: decorationSet
                };
            }
        },
        props: {
            decorations: (state)=>{
                return $c486e0fd30b92a7e$export$64079c8b271eeba4.getState(state).decorationSet;
            }
        }
    });
};
module.exports["createHighlightPaddingPlugin"] = $c486e0fd30b92a7e$export$8d5a971433249768;

});

parcelRegister("3YhlK", function(module, exports) {

var $8nvEM = parcelRequire("8nvEM");


var $kX7j6 = parcelRequire("kX7j6");

const $0dd8ab74fbe19def$var$createPaddingDecoration = ({ pos: pos, node: node, padLeft: padLeft, padRight: padRight })=>{
    const classes = [];
    const baseClass = 'background-color';
    const padLeftClass = `${baseClass}-padding-left`;
    const padRightClass = `${baseClass}-padding-right`;
    if (padLeft) classes.push(padLeftClass);
    if (padRight) classes.push(padRightClass);
    return (0, $8nvEM.Decoration).inline(pos, pos + node.nodeSize, {
        class: classes.join(' ')
    });
};
const $0dd8ab74fbe19def$export$e955b6e659e59713 = ({ decorationSet: decorationSet, state: state, from: from, to: to })=>{
    let newDecorationSet = decorationSet;
    state.doc.nodesBetween(from, to, (node, pos)=>{
        if (!(0, $kX7j6.isHighlightedTextNode)(node)) return;
        const nodeStart = pos;
        const nodeEnd = pos + node.nodeSize;
        const padLeft = (0, $kX7j6.shouldPadLeft)({
            state: state,
            nodeStart: nodeStart
        });
        const padRight = (0, $kX7j6.shouldPadRight)({
            state: state,
            nodeEnd: nodeEnd
        });
        if (padLeft && padRight) {
            const newDecoration = $0dd8ab74fbe19def$var$createPaddingDecoration({
                pos: nodeStart,
                node: node,
                padLeft: padLeft,
                padRight: padRight
            });
            newDecorationSet = newDecorationSet.add(state.doc, [
                newDecoration
            ]);
        }
    });
    return newDecorationSet;
};
module.exports["addPaddingDecorations"] = $0dd8ab74fbe19def$export$e955b6e659e59713;

});

parcelRegister("kX7j6", function(module, exports) {
const $04ef2b2b71a6e383$export$d6f914f85b7b868b = (node)=>{
    return node.isText && node.marks.some((mark)=>mark.type.name === 'backgroundColor');
};
const $04ef2b2b71a6e383$export$48e6e6ce50a6fb39 = ({ state: state, nodeStart: nodeStart })=>{
    const $pos = state.doc.resolve(nodeStart);
    const isAtBlockStart = $pos.parentOffset === 0;
    if (isAtBlockStart) return true;
    const isAtDocStart = nodeStart === 0;
    if (isAtDocStart) return true;
    const isPrevCharSpace = state.doc.textBetween(nodeStart - 1, nodeStart) === ' ';
    if (isPrevCharSpace) return true;
    return false;
};
const $04ef2b2b71a6e383$export$b44b3045e621df46 = ({ state: state, nodeEnd: nodeEnd })=>{
    const $pos = state.doc.resolve(nodeEnd);
    const isAtBlockEnd = $pos.parentOffset === $pos.parent.content.size;
    if (isAtBlockEnd) return true;
    const isAtDocEnd = nodeEnd === state.doc.content.size;
    if (isAtDocEnd) return true;
    const isNextCharSpace = state.doc.textBetween(nodeEnd, nodeEnd + 1) === ' ';
    if (isNextCharSpace) return true;
    return false;
};
module.exports["isHighlightedTextNode"] = $04ef2b2b71a6e383$export$d6f914f85b7b868b;
module.exports["shouldPadLeft"] = $04ef2b2b71a6e383$export$48e6e6ce50a6fb39;
module.exports["shouldPadRight"] = $04ef2b2b71a6e383$export$b44b3045e621df46;

});

parcelRegister("2Y3yg", function(module, exports) {

var $3YhlK = parcelRequire("3YhlK");

const $c292e18cced6f552$export$d9003f1f8089aa99 = ({ decorationSet: prevDecorationSet, state: state, start: start, end: end })=>{
    // First remove any decorations within the range
    // Note that it finds all decorations in the set which touch the given range (including decorations that start or end directly at the boundaries)
    const toRemove = prevDecorationSet.find(start, end);
    const decorationSet = prevDecorationSet.remove(toRemove);
    // Expand the range by 1 on each side to catch adjacent text nodes
    // that may need padding decorations added/removed
    const from = Math.max(0, start - 1);
    const to = Math.min(state.doc.content.size, end + 1);
    return (0, $3YhlK.addPaddingDecorations)({
        decorationSet: decorationSet,
        state: state,
        from: from,
        to: to
    });
};
module.exports["updatePaddingDecorations"] = $c292e18cced6f552$export$d9003f1f8089aa99;

});

parcelRegister("lpCJp", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $ldqjS = parcelRequire("ldqjS");

var $eBSR7 = parcelRequire("eBSR7");


var $aC6bW = parcelRequire("aC6bW");


var $evFm2 = parcelRequire("evFm2");

var $1jFAi = parcelRequire("1jFAi");


var $anBbz = parcelRequire("anBbz");


var $klpad = parcelRequire("klpad");


var $hho3D = parcelRequire("hho3D");

function $96e0040b7d537f88$export$e832373cff8dec22({ api: api }) {
    const list = {};
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    if (!isToolbarAIFCEnabled) (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.toggleHighlightPalette).common, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hho3D.togglePalette)(api)({
        inputMethod: (0, $krYZG.INPUT_METHOD).SHORTCUT
    }), list);
    const analyticsApi = api?.analytics?.actions;
    const highlightPalette = (0, $anBbz.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) ? (0, $1jFAi.highlightColorPaletteNew) : (0, $evFm2.highlightColorPalette);
    const color = highlightPalette.find(({ label: label })=>label === 'Yellow');
    if (color) (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.applyYellowHighlight).common, (0, $aC6bW.editorCommandToPMCommand)((0, $klpad.changeColor)(analyticsApi)({
        color: color.value,
        inputMethod: (0, $krYZG.INPUT_METHOD).SHORTCUT
    })), list);
    return (0, $eBSR7.keymap)(list);
}
module.exports["keymapPlugin"] = $96e0040b7d537f88$export$e832373cff8dec22;

});

parcelRegister("hho3D", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $3qA9L = parcelRequire("3qA9L");

const $2aa1bfdef742e4d8$export$7c9cf3bdfeac3246 = (api)=>({ inputMethod: inputMethod })=>(state, dispatch)=>{
            const isPaletteOpen = (0, $3qA9L.highlightPluginKey).getState(state)?.isPaletteOpen;
            return $2aa1bfdef742e4d8$export$9567774ece486a9(api)({
                isPaletteOpen: !isPaletteOpen,
                inputMethod: inputMethod
            })(state, dispatch);
        };
const $2aa1bfdef742e4d8$export$9567774ece486a9 = (api)=>({ isPaletteOpen: isPaletteOpen, inputMethod: inputMethod })=>(state, dispatch)=>{
            const isDisabled = (0, $3qA9L.highlightPluginKey).getState(state)?.disabled;
            if (!isDisabled) {
                const tr = state.tr;
                tr.setMeta((0, $3qA9L.highlightPluginKey), {
                    type: (0, $3qA9L.HighlightPluginAction).SET_PALETTE,
                    isPaletteOpen: isPaletteOpen
                });
                api.analytics?.actions.attachAnalyticsEvent($2aa1bfdef742e4d8$var$createAnalyticsEvent(isPaletteOpen, inputMethod))(tr);
                tr.setMeta('addToHistory', false);
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };
const $2aa1bfdef742e4d8$var$createAnalyticsEvent = (isPaletteOpen, inputMethod)=>{
    return {
        action: isPaletteOpen ? (0, $krYZG.ACTION).OPENED : (0, $krYZG.ACTION).CLOSED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).TOOLBAR,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: inputMethod
        }
    };
};
module.exports["togglePalette"] = $2aa1bfdef742e4d8$export$7c9cf3bdfeac3246;
module.exports["setPalette"] = $2aa1bfdef742e4d8$export$9567774ece486a9;

});

parcelRegister("4KwOr", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $krYZG = parcelRequire("krYZG");


var $3k5Tv = parcelRequire("3k5Tv");


var $f1UXy = parcelRequire("f1UXy");


var $ldqjS = parcelRequire("ldqjS");


var $hzZPp = parcelRequire("hzZPp");


var $9iFhC = parcelRequire("9iFhC");

var $6DhDg = parcelRequire("6DhDg");


var $aiL0G = parcelRequire("aiL0G");

var $ldbHR = parcelRequire("ldbHR");


var $9Rqjc = parcelRequire("9Rqjc");


var $7sJoX = parcelRequire("7sJoX");


var $58BEn = parcelRequire("58BEn");


var $jkcNT = parcelRequire("jkcNT");


var $hho3D = parcelRequire("hho3D");


var $17Axi = parcelRequire("17Axi");


var $bvwoM = parcelRequire("bvwoM");

const $0f74fcdc8766f2ac$var$selector = (states)=>{
    return {
        isPaletteOpen: states.highlightState?.isPaletteOpen,
        activeColor: states.highlightState?.activeColor,
        disabled: states.highlightState?.disabled
    };
};
const $0f74fcdc8766f2ac$var$FloatingToolbarHighlightColor = ({ pluginInjectionApi: pluginInjectionApi, intl: { formatMessage: formatMessage }, editorView: editorView })=>{
    const toolbarItemRef = (0, $cozmU.useRef)(null);
    const { activeColor: activeColor, disabled: disabled, isPaletteOpen: isPaletteOpen } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'highlight'
    ], $0f74fcdc8766f2ac$var$selector);
    const setDropdownOpen = (isOpen)=>{
        if (!disabled && editorView && pluginInjectionApi) {
            const { state: state, dispatch: dispatch } = editorView;
            (0, $hho3D.setPalette)(pluginInjectionApi)({
                isPaletteOpen: isOpen,
                inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
            })(state, dispatch);
        }
        pluginInjectionApi?.analytics?.actions.fireAnalyticsEvent({
            action: isOpen ? (0, $krYZG.ACTION).OPENED : (0, $krYZG.ACTION).CLOSED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TOOLBAR,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
            }
        });
    };
    const isDropdownOpen = !!isPaletteOpen;
    const { handleClick: handleClick, handleKeyDown: handleKeyDown, handleClickOutside: handleClickOutside, handleEscapeKeydown: handleEscapeKeydown, handleColorChange: handleColorChange, isOpenedByKeyboard: isOpenedByKeyboard } = (0, $bvwoM.useDropdownEvents)({
        toolbarItemRef: toolbarItemRef,
        setIsDropdownOpen: setDropdownOpen,
        isDropdownOpen: isDropdownOpen,
        pluginInjectionApi: pluginInjectionApi
    });
    // Don't render the toolbar option while the plugin is initialising
    if (activeColor === undefined || disabled === undefined) return null;
    const toolbarButtonLabel = formatMessage((0, $hzZPp.highlightMessages).highlight);
    // Get the design token for the  active color (if it exists) to modify the toolbar
    // icon, but show the nice rainbow if none is selected
    const activeColorToken = activeColor === null ? null : (0, $9Rqjc.hexToEditorTextBackgroundPaletteColor)(activeColor);
    const title = (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $ldqjS.tooltip)((0, $ldqjS.toggleHighlightPalette), toolbarButtonLabel) : toolbarButtonLabel;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $17Axi.PaletteDropdown), {
        isOpen: isDropdownOpen && !disabled,
        activeColor: activeColor,
        trigger: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-imported-style-values
            css: (0, $9iFhC.disableBlueBorderStyles),
            buttonId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).BACKGROUND_COLOR,
            spacing: (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? 'default' : 'compact',
            disabled: disabled,
            selected: isDropdownOpen,
            "aria-label": title,
            "aria-keyshortcuts": (0, $ldqjS.getAriaKeyshortcuts)((0, $ldqjS.toggleHighlightPalette)),
            "aria-expanded": isDropdownOpen,
            "aria-haspopup": true,
            title: title,
            onClick: handleClick,
            onKeyDown: handleKeyDown,
            ref: toolbarItemRef,
            iconBefore: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                css: (0, $9iFhC.triggerWrapperStylesWithPadding)
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $f1UXy.DynamicStrokeIconDecoration), {
                selectedColor: activeColorToken,
                disabled: disabled,
                icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($58BEn))), {
                    label: "",
                    color: "currentColor",
                    spacing: "spacious"
                })
            }), // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                css: (0, $6DhDg.expandIconContainerStyle)
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: "",
                color: "currentColor",
                size: "small"
            })))
        }, (0, $jkcNT.editorExperiment)('platform_editor_controls', 'control') && formatMessage((0, $hzZPp.highlightMessages).highlightFloatingToolbar)),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onColorChange: (color)=>handleColorChange({
                color: color,
                inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
            }),
        isOpenedByKeyboard: isOpenedByKeyboard,
        handleClickOutside: handleClickOutside,
        handleEscapeKeydown: handleEscapeKeydown
    });
};
const $0f74fcdc8766f2ac$export$5d201a8e1b725031 = (0, $kSwu1.injectIntl)($0f74fcdc8766f2ac$var$FloatingToolbarHighlightColor);
module.exports["FloatingToolbarHighlightColorWithIntl"] = $0f74fcdc8766f2ac$export$5d201a8e1b725031;

});

parcelRegister("17Axi", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $7xQNd = parcelRequire("7xQNd");

var $3gFnx = parcelRequire("3gFnx");

var $evFm2 = parcelRequire("evFm2");

var $1jFAi = parcelRequire("1jFAi");


var $9RT19 = parcelRequire("9RT19");

var $9GNtS = parcelRequire("9GNtS");


var $9Rqjc = parcelRequire("9Rqjc");


var $7Y8M5 = parcelRequire("7Y8M5");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");

const $beb5a9a099edbe6a$var$HIGHLIGHT_COLOR_PICKER_COLUMNS = 8;
const $beb5a9a099edbe6a$var$HIGHLIGHT_COLOR_PICKER_COLUMNS_NEW = 10;
const $beb5a9a099edbe6a$export$780f86860853be18 = (props)=>{
    const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isOpen: isOpen, activeColor: activeColor, trigger: trigger, onColorChange: onColorChange, isOpenedByKeyboard: isOpenedByKeyboard, handleClickOutside: handleClickOutside, handleEscapeKeydown: handleEscapeKeydown } = props;
    const isNewColorPaletteEnabled = (0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true);
    const isRedHighlightEnabled = (0, $iDrrr.fg)('platform_editor_lovability_text_bg_color_patch_1');
    const highlightPalette = (0, $cozmU.useMemo)(()=>{
        if (isNewColorPaletteEnabled) return (0, $1jFAi.highlightColorPaletteNew).filter((color)=>{
            if (isRedHighlightEnabled) return color.value !== (0, $evFm2.REMOVE_HIGHLIGHT_COLOR);
            return color.label !== 'Red';
        });
        return 0, $evFm2.highlightColorPalette;
    }, [
        isNewColorPaletteEnabled,
        isRedHighlightEnabled
    ]);
    const colorPickerColumns = isNewColorPaletteEnabled ? $beb5a9a099edbe6a$var$HIGHLIGHT_COLOR_PICKER_COLUMNS_NEW : $beb5a9a099edbe6a$var$HIGHLIGHT_COLOR_PICKER_COLUMNS;
    // pixels, used to determine where to horizontally position the dropdown when space is limited
    // this should reflect the width of the dropdown when fully populated with colors, including translations due to layering
    const fitWidth = isNewColorPaletteEnabled ? 338 : 274;
    // 8 cols: 272 = (32 * 8) + (8 + 8)
    // 10 cols: 336 = (32 * 10) + (8 + 8)
    // Not sure where the extra 2px comes from
    const selectedColor = activeColor || (isNewColorPaletteEnabled ? (0, $evFm2.REMOVE_HIGHLIGHT_COLOR) : null);
    const { selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex } = (0, $3gFnx.getSelectedRowAndColumnFromPalette)(highlightPalette, selectedColor, colorPickerColumns);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GNtS.DropdownContainer), {
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        isOpen: isOpen,
        handleClickOutside: handleClickOutside,
        handleEscapeKeydown: handleEscapeKeydown,
        zIndex: (0, $7Y8M5.akEditorMenuZIndex),
        fitWidth: fitWidth,
        closeOnTab: true,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        arrowKeyNavigationProviderOptions: {
            type: (0, $9RT19.ArrowKeyNavigationType).COLOR,
            selectedRowIndex: selectedRowIndex,
            selectedColumnIndex: selectedColumnIndex,
            isOpenedByKeyboard: isOpenedByKeyboard,
            isPopupPositioned: true
        },
        trigger: trigger,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": "highlight-color-palette",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7xQNd.default), {
                cols: colorPickerColumns,
                onClick: onColorChange,
                selectedColor: selectedColor,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                paletteOptions: {
                    palette: highlightPalette,
                    hexToPaletteColor: (0, $9Rqjc.hexToEditorTextBackgroundPaletteColor)
                }
            })
        })
    });
};
module.exports["PaletteDropdown"] = $beb5a9a099edbe6a$export$780f86860853be18;

});

parcelRegister("bvwoM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $klpad = parcelRequire("klpad");

const $c5c096bb56d4fa88$export$98f4eb06acf89919 = (args)=>{
    const { toolbarItemRef: toolbarItemRef, setIsDropdownOpen: setIsDropdownOpen, isDropdownOpen: isDropdownOpen, pluginInjectionApi: pluginInjectionApi } = args;
    const [isOpenedByKeyboard, setIsOpenedByKeyboard] = (0, $cozmU.useState)(false);
    return {
        handleClick: ()=>{
            setIsOpenedByKeyboard(false);
            setIsDropdownOpen(!isDropdownOpen);
        },
        handleKeyDown: (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                setIsOpenedByKeyboard(true);
                setIsDropdownOpen(!isDropdownOpen);
            }
        },
        handleClickOutside: ()=>{
            if (isDropdownOpen) {
                setIsDropdownOpen(false);
                setIsOpenedByKeyboard(false);
            }
        },
        handleEscapeKeydown: ()=>{
            if (isDropdownOpen) {
                setIsDropdownOpen(false);
                setIsOpenedByKeyboard(false);
                toolbarItemRef?.current?.focus();
            }
        },
        handleColorChange: ({ color: color, inputMethod: inputMethod })=>{
            pluginInjectionApi?.core?.actions.execute((0, $klpad.changeColor)(pluginInjectionApi?.analytics?.actions)({
                color: color,
                inputMethod: inputMethod
            }));
            setIsDropdownOpen(false);
        },
        isOpenedByKeyboard: isOpenedByKeyboard
    };
};
module.exports["useDropdownEvents"] = $c5c096bb56d4fa88$export$98f4eb06acf89919;

});

parcelRegister("cjq97", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $krYZG = parcelRequire("krYZG");


var $3k5Tv = parcelRequire("3k5Tv");


var $f1UXy = parcelRequire("f1UXy");


var $ldqjS = parcelRequire("ldqjS");


var $hzZPp = parcelRequire("hzZPp");


var $9iFhC = parcelRequire("9iFhC");

var $6DhDg = parcelRequire("6DhDg");


var $aiL0G = parcelRequire("aiL0G");

var $ldbHR = parcelRequire("ldbHR");


var $9Rqjc = parcelRequire("9Rqjc");


var $7sJoX = parcelRequire("7sJoX");


var $58BEn = parcelRequire("58BEn");


var $4ez2K = parcelRequire("4ez2K");


var $hho3D = parcelRequire("hho3D");


var $17Axi = parcelRequire("17Axi");


var $bvwoM = parcelRequire("bvwoM");

const $0956ebe46a405aea$var$selector = (states)=>{
    return {
        isPaletteOpen: states.highlightState?.isPaletteOpen,
        highlightDisabled: states.highlightState?.disabled,
        activeColor: states.highlightState?.activeColor
    };
};
const $0956ebe46a405aea$var$PrimaryToolbarHighlightColor = ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, disabled: disabled, pluginInjectionApi: pluginInjectionApi, intl: { formatMessage: formatMessage }, editorView: editorView })=>{
    const toolbarItemRef = (0, $cozmU.useRef)(null);
    const { isPaletteOpen: isPaletteOpen, highlightDisabled: highlightDisabled, activeColor: activeColor } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'highlight'
    ], $0956ebe46a405aea$var$selector);
    const setIsDropdownOpen = (isOpen)=>{
        if (!highlightDisabled) {
            const { state: state, dispatch: dispatch } = editorView;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $hho3D.setPalette)(pluginInjectionApi)({
                isPaletteOpen: isOpen,
                inputMethod: (0, $krYZG.INPUT_METHOD).TOOLBAR
            })(state, dispatch);
        }
    };
    const isDropdownOpen = !!isPaletteOpen;
    const { handleClick: handleClick, handleKeyDown: handleKeyDown, handleClickOutside: handleClickOutside, handleEscapeKeydown: handleEscapeKeydown, handleColorChange: handleColorChange, isOpenedByKeyboard: isOpenedByKeyboard } = (0, $bvwoM.useDropdownEvents)({
        toolbarItemRef: toolbarItemRef,
        setIsDropdownOpen: setIsDropdownOpen,
        isDropdownOpen: isDropdownOpen,
        pluginInjectionApi: pluginInjectionApi
    });
    // Don't render the toolbar option while the plugin is initialising
    if (activeColor === undefined || highlightDisabled === undefined) return null;
    const toolbarButtonLabel = formatMessage((0, $hzZPp.highlightMessages).highlight);
    // Get the design token for the  active color (if it exists) to modify the toolbar
    // icon, but show the nice rainbow if none is selected
    const activeColorToken = activeColor === null ? null : (0, $9Rqjc.hexToEditorTextBackgroundPaletteColor)(activeColor);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.Flex), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $17Axi.PaletteDropdown), {
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        isOpen: isDropdownOpen && !highlightDisabled,
        activeColor: activeColor,
        trigger: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-imported-style-values
            css: (0, $9iFhC.disableBlueBorderStyles),
            buttonId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).BACKGROUND_COLOR,
            spacing: isToolbarReducedSpacing ? 'none' : 'default',
            disabled: disabled || highlightDisabled,
            selected: isDropdownOpen,
            "aria-label": (0, $ldqjS.tooltip)((0, $ldqjS.toggleHighlightPalette), toolbarButtonLabel),
            "aria-keyshortcuts": (0, $ldqjS.getAriaKeyshortcuts)((0, $ldqjS.toggleHighlightPalette)),
            "aria-expanded": isDropdownOpen,
            "aria-haspopup": true,
            title: (0, $ldqjS.tooltip)((0, $ldqjS.toggleHighlightPalette), toolbarButtonLabel),
            onClick: handleClick,
            onKeyDown: handleKeyDown,
            ref: toolbarItemRef,
            iconBefore: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                css: (0, $9iFhC.triggerWrapperStylesWithPadding)
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $f1UXy.DynamicStrokeIconDecoration), {
                selectedColor: activeColorToken,
                disabled: highlightDisabled,
                icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($58BEn))), {
                    label: "",
                    color: "currentColor",
                    spacing: "spacious"
                })
            }), //eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                css: (0, $6DhDg.expandIconContainerStyle)
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: "",
                color: "currentColor",
                size: "small"
            })))
        }),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onColorChange: (color)=>handleColorChange({
                color: color,
                inputMethod: (0, $krYZG.INPUT_METHOD).TOOLBAR
            }),
        isOpenedByKeyboard: isOpenedByKeyboard,
        handleClickOutside: handleClickOutside,
        handleEscapeKeydown: handleEscapeKeydown
    }));
};
const $0956ebe46a405aea$export$124ac7b23aa1ea6a = (0, $kSwu1.injectIntl)($0956ebe46a405aea$var$PrimaryToolbarHighlightColor);
module.exports["PrimaryToolbarHighlightColorWithIntl"] = $0956ebe46a405aea$export$124ac7b23aa1ea6a;

});

parcelRegister("9trAT", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $3nacY = parcelRequire("3nacY");

var $hVLmg = parcelRequire("hVLmg");


var $3drJJ = parcelRequire("3drJJ");

const $fa195af61c51f8bd$export$6cd8b101843de8d2 = (api)=>{
    return [
        {
            ...(0, $3nacY.HIGHLIGHT_MENU_ITEM),
            parents: [
                {
                    ...(0, $3nacY.TEXT_COLOR_HIGHLIGHT_MENU_SECTION),
                    rank: (0, $hVLmg.TEXT_COLOR_HIGHLIGHT_MENU_SECTION_RANK)[(0, $3nacY.HIGHLIGHT_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $3drJJ.HighlightColorMenuItem), {
                    api: api,
                    parents: parents
                })
        }
    ];
};
module.exports["getToolbarComponent"] = $fa195af61c51f8bd$export$6cd8b101843de8d2;

});

parcelRegister("3drJJ", function(module, exports) {
/* HighlightColorMenuItem.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $hzZPp = parcelRequire("hzZPp");


var $is7KY = parcelRequire("is7KY");


var $evFm2 = parcelRequire("evFm2");

var $1jFAi = parcelRequire("1jFAi");

var $hEYnV = parcelRequire("hEYnV");


var $4Qu9h = parcelRequire("4Qu9h");


var $9Rqjc = parcelRequire("9Rqjc");

var $g8ETs = parcelRequire("g8ETs");


var $74bCf = parcelRequire("74bCf");

var $kwf4Z = parcelRequire("kwf4Z");


var $I7hWB = parcelRequire("I7hWB");


var $eh6Ml = parcelRequire("eh6Ml");


var $9FyRG = parcelRequire("9FyRG");


var $iDrrr = parcelRequire("iDrrr");


var $22YX5 = parcelRequire("22YX5");

var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");


var $ieeJu = parcelRequire("ieeJu");

const $41e58cb6d3564e2b$var$HIGHLIGHT_COLOR_PICKER_COLUMNS = 10;
const $41e58cb6d3564e2b$var$styles = {
    container: "_2mHwu8gVvo _3138425zaO",
    containerPatch: "_313842Pgdg",
    icon: "_3iDTPbvbI6 _2XsHFMA17z"
};
const $41e58cb6d3564e2b$var$getTextColorIconColor = (defaultColor, textColor, isNewColorPaletteEnabled)=>{
    if (!isNewColorPaletteEnabled) return "var(--ds-icon, #292A2E)";
    if (!textColor || defaultColor && textColor === defaultColor) return "var(--ds-icon, #292A2E)";
    return (0, $g8ETs.hexToEditorTextPaletteColor)(textColor) || "var(--ds-icon, #292A2E)";
};
const $41e58cb6d3564e2b$var$TextColorIconDecorator = ({ label: label, isSelected: isSelected, iconColor: iconColor })=>{
    return isSelected ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        color: "var(--ds-icon, #292A2E)",
        label: label
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        as: "span",
        xcss: $41e58cb6d3564e2b$var$styles.icon,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9FyRG))), {
            label: label,
            color: iconColor,
            shouldRecommendSmallIcon: true,
            spacing: "spacious",
            size: "small"
        })
    });
};
const $41e58cb6d3564e2b$var$NoColorIconDecorator = ({ isSelected: isSelected, iconColor: iconColor })=>/*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
            transform: "translate(-1 -1)",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                    x: "1.70703",
                    y: "1.35383",
                    width: "29.8003",
                    height: "0.5",
                    transform: "rotate(45 1.70703 1.35383)",
                    stroke: "var(--ds-border, #0B120E24)",
                    strokeWidth: "0.5"
                }),
                isSelected ? /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M17.959 7.9707L10.709 16.9707C10.5675 17.1462 10.3544 17.2488 10.1289 17.25C9.90343 17.2512 9.68924 17.1506 9.5459 16.9766L6.0459 12.7266L7.2041 11.7734L10.1182 15.3115L16.791 7.0293L17.959 7.9707Z",
                    fill: "var(--ds-icon, #292A2E)"
                }) : /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M7.80469 16L10.9746 7.26953H12.2637L15.4746 16H14.3027L12.4512 10.8203C12.3379 10.5 12.2051 10.1016 12.0527 9.625C11.9043 9.14453 11.7227 8.5332 11.5078 7.79102H11.7188C11.5078 8.54102 11.3242 9.16016 11.168 9.64844C11.0156 10.1328 10.8887 10.5234 10.7871 10.8203L8.98828 16H7.80469ZM9.39844 13.5625V12.5898H13.8809V13.5625H9.39844Z",
                    fill: iconColor
                })
            ]
        })
    });
function $41e58cb6d3564e2b$export$5b2f3a4c271f0961({ api: api, parents: parents }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const labelId = (0, $cozmU.useId)();
    const activeColor = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'highlight.activeColor');
    const context = (0, $kwf4Z.useToolbarDropdownMenu)();
    const { textColor: textColor, defaultColor: defaultColor } = (0, $hEYnV.useSelectedTextColor)();
    const closeMenu = context?.closeMenu;
    const isNewColorPaletteEnabled = (0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true);
    const selectedColor = activeColor || (isNewColorPaletteEnabled ? (0, $evFm2.REMOVE_HIGHLIGHT_COLOR) : null);
    const handleHighlightColorChange = (0, $cozmU.useCallback)((color, event)=>{
        if (api?.highlight?.commands?.changeColor) {
            api.core.actions.execute(api.highlight.commands.changeColor({
                color: color,
                inputMethod: (0, $is7KY.getInputMethodFromParentKeys)(parents)
            }));
            if (!isNewColorPaletteEnabled) closeMenu?.(event);
        }
    }, [
        api,
        closeMenu,
        isNewColorPaletteEnabled,
        parents
    ]);
    const colorPalette = (0, $cozmU.useMemo)(()=>{
        const isSelected = (color)=>color.value === selectedColor;
        const iconColor = $41e58cb6d3564e2b$var$getTextColorIconColor(defaultColor, textColor, isNewColorPaletteEnabled);
        const highlightPalette = isNewColorPaletteEnabled ? (0, $1jFAi.highlightColorPaletteNew) : (0, $evFm2.highlightColorPalette);
        return highlightPalette.filter((color)=>{
            if (!isNewColorPaletteEnabled || (0, $iDrrr.fg)('platform_editor_lovability_text_bg_color_patch_1')) return color.value !== (0, $evFm2.REMOVE_HIGHLIGHT_COLOR);
            return color.label !== 'Red';
        }).map((color)=>({
                ...color,
                decorator: isNewColorPaletteEnabled && color.value === (0, $evFm2.REMOVE_HIGHLIGHT_COLOR) ? /*#__PURE__*/ (0, $8aG6j.jsx)($41e58cb6d3564e2b$var$NoColorIconDecorator, {
                    isSelected: isSelected(color),
                    iconColor: iconColor
                }) : /*#__PURE__*/ (0, $8aG6j.jsx)($41e58cb6d3564e2b$var$TextColorIconDecorator, {
                    label: color.label,
                    isSelected: isSelected(color),
                    iconColor: iconColor
                })
            }));
    }, [
        defaultColor,
        textColor,
        isNewColorPaletteEnabled,
        selectedColor
    ]);
    const colorPaletteElement = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $74bCf.default), {
        ariaLabelledBy: labelId,
        cols: isNewColorPaletteEnabled ? $41e58cb6d3564e2b$var$HIGHLIGHT_COLOR_PICKER_COLUMNS : undefined,
        gap: isNewColorPaletteEnabled && (0, $iDrrr.fg)('platform_editor_lovability_text_bg_color_patch_1') ? 'space.0' : undefined,
        onClick: (color, _, event)=>{
            handleHighlightColorChange(color, event);
        },
        selectedColor: selectedColor,
        paletteOptions: {
            palette: colorPalette || [],
            hexToPaletteColor: (0, $9Rqjc.hexToEditorTextBackgroundPaletteColor)
        }
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
        xcss: (0, $w6R6I.cx)($41e58cb6d3564e2b$var$styles.container, isNewColorPaletteEnabled && (0, $iDrrr.fg)('platform_editor_lovability_text_bg_color_patch_1') && $41e58cb6d3564e2b$var$styles.containerPatch),
        testId: "highlight-color-menu-item",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                id: labelId,
                size: "xxsmall",
                as: (0, $iDrrr.fg)('platform_editor_a11y_color_palette_radiogroup') ? 'div' : undefined,
                children: formatMessage((0, $hzZPp.highlightMessages).highlight)
            }),
            isNewColorPaletteEnabled && (0, $iDrrr.fg)('platform_editor_lovability_text_bg_color_patch_1') ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $22YX5.Bleed), {
                inline: "space.025",
                children: colorPaletteElement
            }) : colorPaletteElement
        ]
    });
}
module.exports["HighlightColorMenuItem"] = $41e58cb6d3564e2b$export$5b2f3a4c271f0961;

});

parcelRegister("hEYnV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $8xvQD = parcelRequire("8xvQD");

const $903f1392564b5212$export$dbd605ef953212b2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $8xvQD.SelectedTextColorContext));
} : ()=>(0, $cozmU.useContext)((0, $8xvQD.SelectedTextColorContext));
module.exports["useSelectedTextColor"] = $903f1392564b5212$export$dbd605ef953212b2;

});

parcelRegister("HGu9Y", function(module, exports) {

var $7toP7 = parcelRequire("7toP7");


var $fClPf = parcelRequire("fClPf");


var $aOTwp = parcelRequire("aOTwp");


var $gYiLB = parcelRequire("gYiLB");

const $7545ccce0e49e308$export$171e576bb7c729fa = ({ api: api })=>({
        name: 'indentation',
        marks () {
            return [
                {
                    name: 'indentation',
                    mark: (0, $7toP7.indentation)
                }
            ];
        },
        actions: {
            indentParagraphOrHeading: (0, $aOTwp.getIndentCommand)(api?.analytics?.actions),
            outdentParagraphOrHeading: (0, $aOTwp.getOutdentCommand)(api?.analytics?.actions)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { tr: { selection: selection }, schema: { marks: { indentation: indentation } } } = editorState;
            const node = selection.$from.node();
            const indentationMark = node.marks.find((mark)=>mark.type === indentation);
            return {
                isIndentationAllowed: (0, $aOTwp.isIndentationAllowed)(editorState.schema, node),
                // @ts-ignore - TS2869 TypeScript 5.9.2 upgrade
                indentDisabled: (indentationMark?.attrs.level >= (0, $fClPf.MAX_INDENTATION_LEVEL)) ?? false,
                outdentDisabled: !indentationMark
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'indentationKeymap',
                    plugin: ()=>(0, $gYiLB.keymapPlugin)(api?.analytics?.actions)
                }
            ];
        }
    });
module.exports["indentationPlugin"] = $7545ccce0e49e308$export$171e576bb7c729fa;

});

parcelRegister("aOTwp", function(module, exports) {

var $iX5Ka = parcelRequire("iX5Ka");

var $krYZG = parcelRequire("krYZG");


var $9WBFV = parcelRequire("9WBFV");


var $fClPf = parcelRequire("fClPf");


var $fanJz = parcelRequire("fanJz");


var $eFZrs = parcelRequire("eFZrs");

const $8ccb9806c3a6424a$export$54db194d337db321 = (schema, node)=>{
    const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = schema;
    if ([
        paragraph,
        heading
    ].indexOf(node.type) > -1) {
        if (alignment) {
            const hasAlignment = node.marks.filter((mark)=>mark.type === alignment)[0];
            return !hasAlignment;
        }
        return true;
    }
    return false;
};
/**
 * Create new indentation command (Either indent or outdent depend of getArgsFn)
 * @param getNewIndentationAttrs Function to handle new indentation level
 */ function $8ccb9806c3a6424a$var$createIndentationCommand(getNewIndentationAttrs) {
    return (state, dispatch)=>{
        const { indentation: indentation } = state.schema.marks;
        return (0, $9WBFV.toggleBlockMark)(indentation, getNewIndentationAttrs, $8ccb9806c3a6424a$export$54db194d337db321)(state, dispatch);
    };
}
function $8ccb9806c3a6424a$var$createIndentationCommandWithAnalytics({ getNewIndentationAttrs: getNewIndentationAttrs, direction: direction, inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI }) {
    // Create a new getAttrs function to record the changes
    const { getAttrs: getAttrs, getAndResetAttrsChanges: getAndResetAttrsChanges } = (0, $fanJz.default)(getNewIndentationAttrs, {
        direction: direction
    });
    // Use new getAttrs wrapper
    const indentationCommand = $8ccb9806c3a6424a$var$createIndentationCommand(getAttrs);
    // Return a new command where we change dispatch for our analytics dispatch
    return (state, dispatch)=>{
        return indentationCommand(state, (0, $eFZrs.createAnalyticsDispatch)({
            getAttrsChanges: getAndResetAttrsChanges,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI,
            state: state,
            dispatch: dispatch
        }));
    };
}
/**
 * Get new level for outdent
 * @param oldAttr Old attributes for the mark, undefined if the mark doesn't exit
 * @returns  - undefined; No change required
 *           - false; Remove the mark
 *           - object; Update attributes
 */ const $8ccb9806c3a6424a$var$getIndentAttrs = (oldAttr)=>{
    if (!oldAttr) return {
        level: 1
    }; // No mark exist, create a new one with level 1
    const { level: level } = oldAttr;
    if (level >= (0, $fClPf.MAX_INDENTATION_LEVEL)) return undefined; // Max indentation level reached, do nothing.
    return {
        level: level + 1
    }; // Otherwise, increase the level by one
};
const $8ccb9806c3a6424a$export$b294289254b8cdac = (editorAnalyticsAPI)=>(inputMethod = (0, $krYZG.INPUT_METHOD).KEYBOARD)=>$8ccb9806c3a6424a$var$createIndentationCommandWithAnalytics({
            getNewIndentationAttrs: $8ccb9806c3a6424a$var$getIndentAttrs,
            direction: (0, $iX5Ka.INDENT_DIRECTION).INDENT,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
/**
 * Get new level for outdent
 * @param oldAttr Old attributes for the mark, undefined if the mark doesn't exit
 * @returns  - undefined; No change required
 *           - false; Remove the mark
 *           - object; Update attributes
 */ const $8ccb9806c3a6424a$var$getOutdentAttrs = (oldAttr)=>{
    if (!oldAttr) return undefined; // Do nothing;
    const { level: level } = oldAttr;
    if (level <= 1) return false; // Remove the mark
    return {
        level: level - 1
    }; // Decrease the level on other cases
};
const $8ccb9806c3a6424a$export$620b2a1f10eb3a5f = (editorAnalyticsAPI)=>(inputMethod = (0, $krYZG.INPUT_METHOD).KEYBOARD)=>$8ccb9806c3a6424a$var$createIndentationCommandWithAnalytics({
            getNewIndentationAttrs: $8ccb9806c3a6424a$var$getOutdentAttrs,
            direction: (0, $iX5Ka.INDENT_DIRECTION).OUTDENT,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
const $8ccb9806c3a6424a$export$33ad14ed4b6e7a8e = (state, dispatch)=>(0, $9WBFV.toggleBlockMark)(state.schema.marks.indentation, ()=>false)(state, dispatch);
module.exports["isIndentationAllowed"] = $8ccb9806c3a6424a$export$54db194d337db321;
module.exports["getIndentCommand"] = $8ccb9806c3a6424a$export$b294289254b8cdac;
module.exports["getOutdentCommand"] = $8ccb9806c3a6424a$export$620b2a1f10eb3a5f;

});

parcelRegister("fanJz", function(module, exports) {
$parcel$export(module.exports, "default", () => $7dd1315d32deb815$export$2e2bcd8739ae039);
function $7dd1315d32deb815$export$2e2bcd8739ae039(getAttrs, options) {
    let changes = [];
    function getAttrsWithChangesRecorder(prevAttrs, node) {
        const newAttrs = getAttrs(prevAttrs, node);
        changes.push({
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            node: node,
            prevAttrs: prevAttrs,
            newAttrs: newAttrs,
            options: options
        });
        return newAttrs;
    }
    return {
        getAttrs: getAttrsWithChangesRecorder,
        getAndResetAttrsChanges () {
            const oldChanges = changes;
            changes = [];
            return oldChanges;
        }
    };
}

});

parcelRegister("eFZrs", function(module, exports) {

var $krYZG = parcelRequire("krYZG");

var $iX5Ka = parcelRequire("iX5Ka");

const $1736d54b67a5c25e$var$indentTypes = {
    paragraph: (0, $iX5Ka.INDENT_TYPE).PARAGRAPH,
    heading: (0, $iX5Ka.INDENT_TYPE).HEADING
};
function $1736d54b67a5c25e$export$c67aac760a384f96(prevAttrs, newAttrs) {
    if (newAttrs === undefined) return $1736d54b67a5c25e$export$697340b93338bcbd(prevAttrs);
    else if (newAttrs === false) return 0;
    return newAttrs.level;
}
function $1736d54b67a5c25e$export$697340b93338bcbd(prevAttrs) {
    if (prevAttrs === undefined) return 0;
    return prevAttrs.level;
}
function $1736d54b67a5c25e$export$4f15b45384b61427({ getAttrsChanges: getAttrsChanges, inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI, state: state, dispatch: dispatch }) {
    return (tr)=>{
        const currentTr = tr;
        const changes = getAttrsChanges(); // Get all attributes changes
        // Add analytics event for each change stored.
        changes.forEach(({ node: node, prevAttrs: prevAttrs, newAttrs: newAttrs, options: { direction: direction } })=>{
            const indentType = $1736d54b67a5c25e$var$indentTypes[node.type.name];
            if (!indentType) return; // If no valid indent type continue
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).FORMATTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_INDENT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: inputMethod,
                    previousIndentationLevel: $1736d54b67a5c25e$export$697340b93338bcbd(prevAttrs),
                    newIndentLevel: $1736d54b67a5c25e$export$c67aac760a384f96(prevAttrs, newAttrs),
                    direction: direction,
                    indentType: indentType
                }
            })(currentTr);
        });
        // Dispatch analytics if exist
        if (dispatch) dispatch(tr);
    };
}
module.exports["createAnalyticsDispatch"] = $1736d54b67a5c25e$export$4f15b45384b61427;

});

parcelRegister("gYiLB", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $ldqjS = parcelRequire("ldqjS");


var $b9BvQ = parcelRequire("b9BvQ");


var $44cyU = parcelRequire("44cyU");


var $bjg0G = parcelRequire("bjg0G");


var $aOTwp = parcelRequire("aOTwp");

function $1df8e650ca8df6e6$export$e832373cff8dec22(editorAnalyticsAPI) {
    const list = {};
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.indent)), (state, dispatch)=>{
        const { blockTaskItem: blockTaskItem, paragraph: paragraph, doc: doc } = state.schema.nodes;
        if (blockTaskItem) {
            let hasBlockTaskItem = false;
            let hasParagraphAtDocLevel = false;
            // Check if the selection contains a blockTaskItem
            state.doc.nodesBetween(state.selection.from, state.selection.to, (node, _pos, parent)=>{
                if (node.type === blockTaskItem) {
                    hasBlockTaskItem = true;
                    return false; // stop iterating
                }
                if (node.type === paragraph && parent?.type === doc) hasParagraphAtDocLevel = true;
            });
            if (hasBlockTaskItem && !hasParagraphAtDocLevel) return false; // let `editor-plugin-tasks-and-decisions` handle indentation
        }
        return (0, $aOTwp.getIndentCommand)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).KEYBOARD)(state, dispatch);
    }, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.outdent)), (0, $aOTwp.getOutdentCommand)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).KEYBOARD), list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.backspace)), (state, dispatch)=>{
        const { selection: selection } = state;
        const { blockTaskItem: blockTaskItem } = state.schema.nodes;
        // Let `editor-plugin-tasks-and-decisions` handle indentation inside blockTaskItems
        if ((0, $b9BvQ.isTextSelection)(selection) && selection.$cursor && selection.$cursor.parentOffset === 0 && !(0, $bjg0G.hasParentNodeOfType)([
            blockTaskItem
        ])(selection)) return dispatch ? (0, $aOTwp.getOutdentCommand)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).KEYBOARD)(state, dispatch) : false;
        return false;
    }, list);
    return (0, $44cyU.keymap)(list);
}
var $1df8e650ca8df6e6$export$2e2bcd8739ae039 = $1df8e650ca8df6e6$export$e832373cff8dec22;
module.exports["keymapPlugin"] = $1df8e650ca8df6e6$export$e832373cff8dec22;

});

parcelRegister("jdplc", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $4o0zT = parcelRequire("4o0zT");


var $lP4rW = parcelRequire("lP4rW");


var $7Jrsi = parcelRequire("7Jrsi");


var $1aZze = parcelRequire("1aZze");


var $7G1y6 = parcelRequire("7G1y6");


var $28aNf = parcelRequire("28aNf");


var $bnkCY = parcelRequire("bnkCY");

const $93067ab894e7d078$export$c1375d8d7bd75982 = ({ config: config, api: api })=>{
    const editorAnalyticsAPI = api?.analytics?.actions;
    const isNewToolbarEnabled = Boolean(api?.toolbar);
    // Workaround since we want to insert a loom via the `hyperlink` plugin for now.
    // The hyperlink plugin (and the card plugin) are deeply tied into using the Prosemirror Command
    // Ideally one day we refactor those and we can remove this.
    const editorViewRef = {
        current: null
    };
    const primaryToolbarComponent = (0, $1aZze.loomPrimaryToolbarComponent)(config, api);
    const isRegisteredSlashCommandEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command');
    if (config.loomProvider && isRegisteredSlashCommandEnabled) api?.uiControlRegistry?.actions.register((0, $7G1y6.getLoomQuickInsertComponents)({
        api: api
    }));
    if (isNewToolbarEnabled) api?.toolbar?.actions.registerComponents((0, $bnkCY.getToolbarComponents)(config, api));
    else api?.primaryToolbar?.actions.registerComponent({
        name: 'loom',
        component: primaryToolbarComponent
    });
    return {
        name: 'loom',
        actions: {
            recordVideo: $lP4rW.recordVideo,
            insertLoom: (video, positionType)=>(0, $lP4rW.insertLoom)(editorViewRef.current, api, video, positionType),
            initLoom: ({ loomProvider: loomProvider })=>{
                return (0, $lP4rW.setupLoom)(loomProvider, api, editorViewRef.current, true);
            }
        },
        pmPlugins: ()=>[
                {
                    name: 'loom',
                    plugin: ()=>(0, $7Jrsi.createPlugin)({
                            config: config,
                            api: api
                        })
                },
                {
                    name: 'loomViewRefWorkaround',
                    plugin: ()=>{
                        return new (0, $kpCD8.SafePlugin)({
                            view: (editorView)=>{
                                // Do not cleanup the editorViewRef on destroy
                                // because some functions may point to a stale
                                // reference and this means we will return null.
                                // EditorView is assumed to be stable so we do not need to
                                // cleanup.
                                // See: #hot-106316
                                editorViewRef.current = editorView;
                                return {};
                            }
                        });
                    }
                }
            ],
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $7Jrsi.loomPluginKey).getState(editorState);
        },
        pluginsOptions: isRegisteredSlashCommandEnabled ? {} : {
            // Enable inserting Loom recordings through the slash command
            quickInsert: (intl)=>{
                if (config.loomProvider) return (0, $28aNf.getQuickInsertItem)(editorAnalyticsAPI)(intl);
                return [];
            }
        },
        // Enable inserting Loom recordings through main toolbar
        primaryToolbarComponent: !api?.primaryToolbar && !isNewToolbarEnabled ? primaryToolbarComponent : undefined
    };
};
module.exports["loomPlugin"] = $93067ab894e7d078$export$c1375d8d7bd75982;

});

parcelRegister("lP4rW", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $jv11C = parcelRequire("jv11C");


var $28aNf = parcelRequire("28aNf");


var $7Jrsi = parcelRequire("7Jrsi");

const $fa941eae7657c6f0$export$b5c7c74886310ae0 = ({ loomButton: loomButton })=>({ tr: tr })=>{
        tr.setMeta((0, $7Jrsi.loomPluginKey), {
            type: (0, $7Jrsi.LoomPluginAction).ENABLE,
            loomButton: loomButton
        });
        return tr;
    };
const $fa941eae7657c6f0$export$6f61f49dd8b64c45 = ({ error: error })=>({ tr: tr })=>{
        tr.setMeta((0, $7Jrsi.loomPluginKey), {
            type: (0, $7Jrsi.LoomPluginAction).DISABLE,
            error: error
        });
        return tr;
    };
const $fa941eae7657c6f0$export$2d56b03ca3f4ead9 = ({ inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI })=>({ tr: tr })=>{
        tr.setMeta((0, $7Jrsi.loomPluginKey), {
            type: (0, $7Jrsi.LoomPluginAction).RECORD_VIDEO
        });
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).RECORD_VIDEO,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).LOOM,
            attributes: {
                inputMethod: inputMethod
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    };
const $fa941eae7657c6f0$export$3b5a9e613ed2ae87 = ({ inputMethod: inputMethod, error: error, editorAnalyticsAPI: editorAnalyticsAPI })=>({ tr: tr })=>{
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).RECORD_VIDEO_FAILED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).LOOM,
            attributes: {
                inputMethod: inputMethod,
                error: error
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    };
const $fa941eae7657c6f0$export$73a289ac38fc1ec = ({ editorAnalyticsAPI: editorAnalyticsAPI, video: video })=>({ tr: tr })=>{
        tr.setMeta((0, $7Jrsi.loomPluginKey), {
            type: (0, $7Jrsi.LoomPluginAction).INSERT_VIDEO
        });
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).INSERT_VIDEO,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).LOOM,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                duration: video.duration
            }
        })(tr);
        return tr;
    };
const $fa941eae7657c6f0$var$getPositions = (tr, posType)=>{
    const selection = tr.selection;
    switch(posType){
        case 'current':
            return {
                from: selection.from,
                to: selection.from
            };
        case 'start':
            return {
                from: 0,
                to: 0
            };
        case 'end':
            return {
                from: tr.doc.content.size,
                to: tr.doc.content.size
            };
    }
};
const $fa941eae7657c6f0$export$e61f2d2bdaa7ecf4 = (editorView, api, video, positionType)=>{
    if (!editorView) return false;
    const { state: state, dispatch: dispatch } = editorView;
    const { from: from, to: to } = $fa941eae7657c6f0$var$getPositions(state.tr, positionType);
    return api?.hyperlink?.actions.insertLink((0, $krYZG.INPUT_METHOD).TYPEAHEAD, from, to, video.sharedUrl, video.title, undefined, undefined, undefined, 'embed')(state, dispatch) ?? false;
};
const $fa941eae7657c6f0$export$92a5ff9a4d5c2287 = (api)=>{
    api?.core?.actions.execute($fa941eae7657c6f0$export$2d56b03ca3f4ead9({
        inputMethod: (0, $krYZG.INPUT_METHOD).TOOLBAR,
        editorAnalyticsAPI: api?.analytics?.actions
    }));
};
const $fa941eae7657c6f0$export$a39487b0b81d2404 = async (loomProvider, api, editorView, /**
	 * Whether loom initialisation is evoked via `initLoom` command.
	 */ initViaCommand)=>{
    const clientResult = await loomProvider.getClient();
    if (clientResult.status === 'error') {
        api?.core?.actions.execute($fa941eae7657c6f0$export$6f61f49dd8b64c45({
            error: clientResult.message
        }));
        (0, $jv11C.logException)(new Error(clientResult.message), {
            location: 'editor-plugin-loom/sdk-initialisation'
        });
        api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).ERRORED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).LOOM,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: clientResult.message
            }
        });
        return {
            error: clientResult.message
        };
    }
    const { attachToButton: attachToButton } = clientResult.client;
    // Hidden element to work around the SDK API
    const loomButton = document.createElement('button');
    attachToButton({
        button: loomButton,
        onInsert: (video)=>{
            if (!editorView) return;
            const { state: state, dispatch: dispatch } = editorView;
            const pos = state.selection.from;
            api?.hyperlink?.actions.insertLink((0, $krYZG.INPUT_METHOD).TYPEAHEAD, pos, pos, video.sharedUrl, video.title, undefined, undefined, undefined, 'embed')(state, dispatch);
            api?.core?.actions.execute($fa941eae7657c6f0$export$73a289ac38fc1ec({
                editorAnalyticsAPI: api?.analytics?.actions,
                video: video
            }));
        }
    });
    api?.core?.actions.execute(({ tr: tr })=>{
        $fa941eae7657c6f0$export$b5c7c74886310ae0({
            loomButton: loomButton
        })({
            tr: tr
        });
        if (initViaCommand) api?.quickInsert?.commands.addQuickInsertItem((0, $28aNf.getQuickInsertItem)(api?.analytics?.actions))({
            tr: tr
        });
        return tr;
    });
    // We're not combining the analytics steps into the enable / disable commands because the collab-edit plugin
    // filters out any transactions with steps (even analytics) when it's initialising.
    // Even if `initViaCommand` is true, collab-edit might not be ready depending on when `initLoom` is called,
    // hence the analytics step is added separately in both cases
    api?.analytics?.actions.fireAnalyticsEvent({
        action: (0, $krYZG.ACTION).INITIALISED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).LOOM,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
    });
    return {};
};
module.exports["recordVideo"] = $fa941eae7657c6f0$export$2d56b03ca3f4ead9;
module.exports["recordVideoFailed"] = $fa941eae7657c6f0$export$3b5a9e613ed2ae87;
module.exports["insertLoom"] = $fa941eae7657c6f0$export$e61f2d2bdaa7ecf4;
module.exports["executeRecordVideo"] = $fa941eae7657c6f0$export$92a5ff9a4d5c2287;
module.exports["setupLoom"] = $fa941eae7657c6f0$export$a39487b0b81d2404;

});

parcelRegister("28aNf", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $gx3UZ = parcelRequire("gx3UZ");


var $jv11C = parcelRequire("jv11C");


var $60Yxm = parcelRequire("60Yxm");


var $lP4rW = parcelRequire("lP4rW");


var $7Jrsi = parcelRequire("7Jrsi");

const $c5f309acd343d20a$export$3432d7b65cad662d = (editorAnalyticsAPI)=>({ formatMessage: formatMessage })=>[
            {
                id: 'loom',
                title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).recordVideo),
                description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).recordVideoDescription),
                keywords: [
                    'loom',
                    'record',
                    'video'
                ],
                priority: 800,
                isDisabledOffline: true,
                icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($60Yxm))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)",
                        spacing: "spacious"
                    }),
                action (insert, editorState) {
                    const tr = insert(undefined);
                    const loomState = (0, $7Jrsi.loomPluginKey).getState(editorState);
                    if (!loomState?.isEnabled) {
                        const errorMessage = loomState?.error;
                        (0, $jv11C.logException)(new Error(errorMessage), {
                            location: 'editor-plugin-loom/quick-insert-record-video'
                        });
                        return (0, $lP4rW.recordVideoFailed)({
                            inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT,
                            error: errorMessage,
                            editorAnalyticsAPI: editorAnalyticsAPI
                        })({
                            tr: tr
                        }) ?? false;
                    }
                    return (0, $lP4rW.recordVideo)({
                        inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT,
                        editorAnalyticsAPI: editorAnalyticsAPI
                    })({
                        tr: tr
                    }) ?? false;
                }
            }
        ];
module.exports["getQuickInsertItem"] = $c5f309acd343d20a$export$3432d7b65cad662d;

});

parcelRegister("7Jrsi", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $lP4rW = parcelRequire("lP4rW");

var $a44fd40d86cc104a$export$5f9dbfce88541fe5 = /*#__PURE__*/ function(LoomPluginAction) {
    LoomPluginAction[LoomPluginAction["ENABLE"] = 0] = "ENABLE";
    LoomPluginAction[LoomPluginAction["DISABLE"] = 1] = "DISABLE";
    LoomPluginAction[LoomPluginAction["RECORD_VIDEO"] = 2] = "RECORD_VIDEO";
    LoomPluginAction[LoomPluginAction["INSERT_VIDEO"] = 3] = "INSERT_VIDEO";
    return LoomPluginAction;
}({});
const $a44fd40d86cc104a$export$db6b5ebe5a8c279 = new (0, $kCECX.PluginKey)('loom');
const $a44fd40d86cc104a$export$ae829ec7b2625219 = ({ config: config, api: api })=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $a44fd40d86cc104a$export$db6b5ebe5a8c279,
        state: {
            init: ()=>({
                    isEnabled: false,
                    loomButton: null,
                    isRecordingVideo: false,
                    error: undefined
                }),
            apply: (tr, pluginState)=>{
                const action = tr.getMeta($a44fd40d86cc104a$export$db6b5ebe5a8c279)?.type;
                switch(action){
                    case 0:
                        const { loomButton: loomButton } = tr.getMeta($a44fd40d86cc104a$export$db6b5ebe5a8c279);
                        return {
                            ...pluginState,
                            isEnabled: true,
                            loomButton: loomButton
                        };
                    case 1:
                        const { error: error } = tr.getMeta($a44fd40d86cc104a$export$db6b5ebe5a8c279);
                        return {
                            ...pluginState,
                            isEnabled: false,
                            loomButton: null,
                            error: error
                        };
                    case 2:
                        // Click the unmounted button in state that has the Loom SDK attached
                        pluginState?.loomButton?.click();
                        return {
                            ...pluginState,
                            isRecordingVideo: true
                        };
                    case 3:
                        return {
                            ...pluginState,
                            isRecordingVideo: false
                        };
                    default:
                        return pluginState;
                }
            }
        },
        view (editorView) {
            if (config.loomProvider) (0, $lP4rW.setupLoom)(config.loomProvider, api, editorView);
            return {};
        }
    });
};
module.exports["LoomPluginAction"] = $a44fd40d86cc104a$export$5f9dbfce88541fe5;
module.exports["loomPluginKey"] = $a44fd40d86cc104a$export$db6b5ebe5a8c279;
module.exports["createPlugin"] = $a44fd40d86cc104a$export$ae829ec7b2625219;

});

parcelRegister("1aZze", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $3k5Tv = parcelRequire("3k5Tv");


var $jaFVy = parcelRequire("jaFVy");


var $lP4rW = parcelRequire("lP4rW");


var $g00sD = parcelRequire("g00sD");

const $ec640dec66ccb66d$var$selector = (states)=>{
    return {
        loomEnabled: states.loomState?.isEnabled,
        connectivityMode: states.connectivityState?.mode
    };
};
const $ec640dec66ccb66d$var$CustomisableLoomToolbarButton = (disabled, appearance, api)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((props, ref)=>{
        const { onClickBeforeInit: onClickBeforeInit, isDisabled: isDisabled = false, href: href, ...restProps } = props;
        const { loomEnabled: loomEnabled, connectivityMode: connectivityMode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
            'loom',
            'connectivity'
        ], $ec640dec66ccb66d$var$selector);
        const isLoomEnabled = !!loomEnabled;
        const handleOnClick = (0, $cozmU.useCallback)((e)=>{
            if (isLoomEnabled) (0, $lP4rW.executeRecordVideo)(api);
            else onClickBeforeInit && onClickBeforeInit(e);
        }, [
            isLoomEnabled,
            onClickBeforeInit
        ]);
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $g00sD.default), {
            ref: ref,
            hideTooltip: !!(restProps.onMouseEnter || restProps.onMouseLeave),
            // Ignore href if Loom is enabled so that it doesn't interfere with recording
            href: isLoomEnabled ? undefined : href,
            disabled: disabled || isDisabled || (0, $jaFVy.isOfflineMode)(connectivityMode),
            api: api,
            appearance: appearance,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (e)=>handleOnClick(e),
            ...restProps
        });
    });
const $ec640dec66ccb66d$var$LoomToolbarButtonWrapper = ({ disabled: disabled, api: api, appearance: appearance })=>{
    const handleOnClick = (0, $cozmU.useCallback)(()=>(0, $lP4rW.executeRecordVideo)(api), [
        api
    ]);
    const { loomEnabled: loomEnabled, connectivityMode: connectivityMode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'loom',
        'connectivity'
    ], $ec640dec66ccb66d$var$selector);
    if (loomEnabled === undefined) return null;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $g00sD.default), {
        // Disable the icon while the SDK isn't initialised
        disabled: disabled || !loomEnabled || (0, $jaFVy.isOfflineMode)(connectivityMode),
        api: api,
        appearance: appearance,
        onClick: handleOnClick
    });
};
const $ec640dec66ccb66d$export$b7aa095334bc8677 = (config, api)=>({ disabled: disabled, appearance: appearance })=>{
        if (config.shouldShowToolbarButton === false) return null;
        if (config.renderButton) return config.renderButton($ec640dec66ccb66d$var$CustomisableLoomToolbarButton(disabled, appearance, api));
        if (config.shouldShowToolbarButton) return /*#__PURE__*/ (0, $lOiVq.jsx)($ec640dec66ccb66d$var$LoomToolbarButtonWrapper, {
            // Disable the icon while the SDK isn't initialised
            disabled: disabled,
            api: api,
            appearance: appearance
        });
        return null;
    };
module.exports["loomPrimaryToolbarComponent"] = $ec640dec66ccb66d$export$b7aa095334bc8677;

});

parcelRegister("g00sD", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $3k5Tv = parcelRequire("3k5Tv");


var $gx3UZ = parcelRequire("gx3UZ");


var $aiL0G = parcelRequire("aiL0G");

var $ldbHR = parcelRequire("ldbHR");


var $60Yxm = parcelRequire("60Yxm");

function $367060042bbafb1f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// This const is derived from the breakpoint where the toolbar hides its icons. It is used to hide the text in the AI button.
// Derived from values from platform/packages/editor/editor-core/src/ui/Appearance/FullPage/MainToolbar.tsx
const $367060042bbafb1f$var$LOOM_BUTTON_WIDTH_BREAKPOINT = 1076;
const $367060042bbafb1f$var$iconMinWidthStyle = {
    name: "9bmev",
    styles: "min-width:24px"
};
const $367060042bbafb1f$var$selector = (states)=>{
    return {
        width: states.widthState?.width
    };
};
const $367060042bbafb1f$var$LoomToolbarButtonInternal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ disabled: disabled, api: api, appearance: appearance, intl: { formatMessage: formatMessage }, selected: selected, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, 'data-ds--level': dataDsLevel, onClick: onClick, href: href, target: target, hideTooltip: hideTooltip, rel: rel }, ref)=>{
    const { width: width } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'width'
    ], $367060042bbafb1f$var$selector);
    const label = formatMessage(appearance === 'comment' ? (0, $gx3UZ.toolbarInsertBlockMessages).addLoomVideoComment : (0, $gx3UZ.toolbarInsertBlockMessages).addLoomVideo);
    const shouldShowRecordText = (width || 0) > $367060042bbafb1f$var$LOOM_BUTTON_WIDTH_BREAKPOINT;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
        hideTooltip: hideTooltip,
        ref: ref,
        href: href,
        buttonId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).RECORD_VIDEO,
        disabled: disabled,
        title: label,
        iconBefore: /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            css: $367060042bbafb1f$var$iconMinWidthStyle
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($60Yxm))), {
            label: label,
            color: disabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon-subtle, #505258)",
            spacing: "spacious"
        })),
        selected: selected,
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        "data-ds--level": dataDsLevel,
        onClick: onClick,
        target: target,
        rel: rel
    }, shouldShowRecordText && formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).recordLoomShortTitle));
});
const $367060042bbafb1f$var$_default_1 = (0, $kSwu1.injectIntl)($367060042bbafb1f$var$LoomToolbarButtonInternal, {
    forwardRef: true
});
var $367060042bbafb1f$export$2e2bcd8739ae039 = $367060042bbafb1f$var$_default_1;
module.exports["default"] = $367060042bbafb1f$export$2e2bcd8739ae039;

});

parcelRegister("7G1y6", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $gx3UZ = parcelRequire("gx3UZ");


var $7SMXM = parcelRequire("7SMXM");


var $dCkbP = parcelRequire("dCkbP");


var $dXqu3 = parcelRequire("dXqu3");


var $7PIl3 = parcelRequire("7PIl3");

const $d544291d906bb420$export$f6aadb331b1b1790 = ({ api: api })=>[
        {
            key: (0, $dCkbP.LOOM_MENU_ITEM).key,
            type: (0, $dCkbP.LOOM_MENU_ITEM).type,
            parents: [
                {
                    key: (0, $dCkbP.MEDIA_SECTION).key,
                    type: (0, $dCkbP.MEDIA_SECTION).type,
                    rank: (0, $dXqu3.MEDIA_SECTION_RANK)[(0, $dCkbP.LOOM_MENU_ITEM).key]
                }
            ],
            match: (0, $7SMXM.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).recordVideoDescription),
                    keywords: [
                        'loom',
                        'record',
                        'video'
                    ],
                    title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).recordVideo)
                })),
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $7PIl3.LoomQuickInsertMenuItem), {
                    api: api
                })
        }
    ];
module.exports["getLoomQuickInsertComponents"] = $d544291d906bb420$export$f6aadb331b1b1790;

});

parcelRegister("7PIl3", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $krYZG = parcelRequire("krYZG");


var $gx3UZ = parcelRequire("gx3UZ");


var $jv11C = parcelRequire("jv11C");


var $I2MTF = parcelRequire("I2MTF");


var $9wgTc = parcelRequire("9wgTc");


var $60Yxm = parcelRequire("60Yxm");


var $lP4rW = parcelRequire("lP4rW");


var $7Jrsi = parcelRequire("7Jrsi");

const $4be03fc915944ace$export$fac7c79757e2238d = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isOffline: isOffline } = (0, $9wgTc.useQuickInsertContext)();
    const onSelect = (0, $cozmU.useCallback)(({ editorView: editorView, insert: insert })=>{
        const tr = insert(undefined);
        const loomState = (0, $7Jrsi.loomPluginKey).getState(editorView.state);
        if (!loomState?.isEnabled) {
            (0, $jv11C.logException)(new Error(loomState?.error), {
                location: 'editor-plugin-loom/quick-insert-record-video'
            });
            return (0, $lP4rW.recordVideoFailed)({
                inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT,
                error: loomState?.error,
                editorAnalyticsAPI: api?.analytics?.actions
            })({
                tr: tr
            }) ?? false;
        }
        return (0, $lP4rW.recordVideo)({
            inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT,
            editorAnalyticsAPI: api?.analytics?.actions
        })({
            tr: tr
        }) ?? false;
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I2MTF.QuickInsertMenuItem), {
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($60Yxm))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)",
            spacing: "spacious"
        }),
        isDisabled: isOffline,
        onSelect: onSelect,
        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).recordVideo)
    });
};
module.exports["LoomQuickInsertMenuItem"] = $4be03fc915944ace$export$fac7c79757e2238d;

});

parcelRegister("bnkCY", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $3nacY = parcelRequire("3nacY");

var $hVLmg = parcelRequire("hVLmg");


var $akmSK = parcelRequire("akmSK");


var $QhQtc = parcelRequire("QhQtc");

const $abbb8912713cedae$export$a758406ca53b86a5 = (config, api)=>{
    return [
        {
            type: (0, $3nacY.LOOM_MENU_SECTION).type,
            key: (0, $3nacY.LOOM_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $3nacY.OVERFLOW_MENU_PRIMARY_TOOLBAR).type,
                    key: (0, $3nacY.OVERFLOW_MENU_PRIMARY_TOOLBAR).key,
                    rank: (0, $hVLmg.OVERFLOW_MENU_PRIMARY_TOOLBAR_RANK)[(0, $3nacY.LOOM_MENU_SECTION).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $QhQtc.MenuSection), {
                    api: api,
                    children: children
                });
            }
        },
        {
            type: (0, $3nacY.LOOM_MENU_ITEM).type,
            key: (0, $3nacY.LOOM_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $3nacY.LOOM_MENU_SECTION).type,
                    key: (0, $3nacY.LOOM_MENU_SECTION).key,
                    rank: (0, $hVLmg.LOOM_MENU_SECTION_RANK)[(0, $3nacY.LOOM_MENU_ITEM).key]
                },
                {
                    type: (0, $3nacY.OVERFLOW_EXTENSIONS_MENU_SECTION).type,
                    key: (0, $3nacY.OVERFLOW_EXTENSIONS_MENU_SECTION).key,
                    rank: (0, $hVLmg.OVERFLOW_EXTENSIONS_MENU_SECTION_RANK)[(0, $3nacY.LOOM_MENU_ITEM).key]
                }
            ],
            component: ()=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $akmSK.LoomMenuItem), {
                    api: api,
                    renderButton: config.renderButton
                });
            },
            isHidden: ()=>{
                const loomState = api?.loom?.sharedState.currentState();
                const editorViewMode = api?.editorViewMode?.sharedState.currentState() ?? 'edit';
                // if shouldRenderButton is not provided, default to true
                const shouldRenderButton = config?.shouldRenderButton?.() ?? true;
                return 'renderButton' in config && shouldRenderButton === false || loomState?.isEnabled === undefined || editorViewMode !== 'edit';
            }
        }
    ];
};
module.exports["getToolbarComponents"] = $abbb8912713cedae$export$a758406ca53b86a5;

});

parcelRegister("akmSK", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3k5Tv = parcelRequire("3k5Tv");


var $gx3UZ = parcelRequire("gx3UZ");


var $bFSJa = parcelRequire("bFSJa");


var $60Yxm = parcelRequire("60Yxm");

var $dVKvM = parcelRequire("dVKvM");


var $lP4rW = parcelRequire("lP4rW");

const $1c445c5059187b69$var$useLoomEnabled = (api)=>{
    const { loomEnabled: loomEnabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'loom'
    ], (states)=>{
        return {
            loomEnabled: states.loomState?.isEnabled
        };
    });
    return loomEnabled;
};
const $1c445c5059187b69$export$cfd738d449e0a4ef = ({ api: api, renderButton: renderButton })=>{
    const loomEnabled = $1c445c5059187b69$var$useLoomEnabled(api);
    const { editorViewMode: editorViewMode } = (0, $bFSJa.useEditorToolbar)();
    if (editorViewMode !== 'edit') return null;
    if (renderButton) return renderButton($1c445c5059187b69$export$a209d77fd6c75051(api));
    else if (loomEnabled !== undefined) return /*#__PURE__*/ (0, $8aG6j.jsx)($1c445c5059187b69$var$DefaultLoomMenuItem, {
        api: api
    });
};
const $1c445c5059187b69$export$a209d77fd6c75051 = (api)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ isDisabled: isDisabled = false, onClickBeforeInit: onClickBeforeInit, href: href, target: target, rel: rel }, ref)=>{
        const loomEnabled = !!$1c445c5059187b69$var$useLoomEnabled(api);
        const handleOnClick = (0, $cozmU.useCallback)((e)=>{
            if (loomEnabled) (0, $lP4rW.executeRecordVideo)(api);
            else if (onClickBeforeInit && e.type === 'click' && e.target instanceof HTMLElement) onClickBeforeInit(e);
        }, [
            loomEnabled,
            onClickBeforeInit
        ]);
        return /*#__PURE__*/ (0, $8aG6j.jsx)($1c445c5059187b69$var$MenuItemComponent, {
            ref: ref,
            // Ignore href if Loom is enabled so that it doesn't interfere with recording
            href: loomEnabled ? undefined : href,
            disabled: isDisabled,
            onClick: handleOnClick,
            target: target,
            rel: rel
        });
    });
const $1c445c5059187b69$var$DefaultLoomMenuItem = ({ api: api })=>{
    const loomEnabled = $1c445c5059187b69$var$useLoomEnabled(api);
    const handleOnClick = (0, $cozmU.useCallback)(()=>(0, $lP4rW.executeRecordVideo)(api), [
        api
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($1c445c5059187b69$var$MenuItemComponent, {
        disabled: !loomEnabled,
        onClick: handleOnClick
    });
};
const $1c445c5059187b69$var$MenuItemComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(// eslint-disable-next-line no-unused-vars
({ disabled: disabled, onClick: onClick, href: href, target: target, rel: rel }, ref)=>{
    const { editorAppearance: editorAppearance } = (0, $bFSJa.useEditorToolbar)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($60Yxm))), {
            size: "small",
            label: ""
        }),
        isDisabled: disabled,
        href: href,
        target: target,
        rel: rel,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: (e)=>onClick(e),
        children: formatMessage(editorAppearance === 'comment' ? (0, $gx3UZ.toolbarInsertBlockMessages).addLoomVideoComment : (0, $gx3UZ.toolbarInsertBlockMessages).addLoomVideo)
    });
});
module.exports["LoomMenuItem"] = $1c445c5059187b69$export$cfd738d449e0a4ef;

});

parcelRegister("QhQtc", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $bFSJa = parcelRequire("bFSJa");


var $jgJIe = parcelRequire("jgJIe");

const $fc79263a4212ed67$var$usePluginState = (_api)=>{
    const { editorViewMode: editorViewMode } = (0, $bFSJa.useEditorToolbar)();
    return {
        editorViewMode: editorViewMode
    };
};
const $fc79263a4212ed67$export$4b1545b4f2016d26 = ({ children: children, api: api })=>{
    const { editorViewMode: editorViewMode } = $fc79263a4212ed67$var$usePluginState(api);
    const isEdit = editorViewMode === 'edit';
    if (!isEdit) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jgJIe.ToolbarDropdownItemSection), {
        hasSeparator: isEdit,
        children: children
    });
};
module.exports["MenuSection"] = $fc79263a4212ed67$export$4b1545b4f2016d26;

});

parcelRegister("vZEJe", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $cVoAa = parcelRequire("cVoAa");


var $hHzd2 = parcelRequire("hHzd2");

const $b399db01e99f7201$export$62ed72bc21f6b8a6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DropIndicator(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { appearance: t1, edge: edge, gap: gap, indent: indent, type: type } = t0;
    const appearance = t1 === undefined ? "default" : t1;
    const t2 = (0, $hHzd2.presetStrokeColors)[appearance];
    let t3;
    if ($[0] !== edge || $[1] !== gap || $[2] !== indent || $[3] !== t2 || $[4] !== type) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cVoAa.Line), {
            edge: edge,
            gap: gap,
            strokeColor: t2,
            type: type,
            indent: indent
        });
        $[0] = edge;
        $[1] = gap;
        $[2] = indent;
        $[3] = t2;
        $[4] = type;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : function DropIndicator({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cVoAa.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $hHzd2.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
};
var // This default export is intended for usage with React.lazy
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b399db01e99f7201$export$2e2bcd8739ae039 = $b399db01e99f7201$export$62ed72bc21f6b8a6;
module.exports["DropIndicator"] = $b399db01e99f7201$export$62ed72bc21f6b8a6;
module.exports["default"] = $b399db01e99f7201$export$2e2bcd8739ae039;

});

parcelRegister("cVoAa", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $hHzd2 = parcelRequire("hHzd2");

const $06f7f86bfd55e0d2$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $06f7f86bfd55e0d2$var$baseStyles = {
    root: "_3iDTPbvLZJ _1mT5xdWVPG _42Yu6B7dHp _1pp6NdYbGa _0KLXrul0Q1 _1Oimfu715P _0eGJOxOn88 _1nRsHk6wH8 _2KinTkl0Q1 _0OU75rKWn1 _3Ku51Iogpp _3dCYwDWVPG _2DsrY12Njc _3ScelF3U6W _1lBcDc3U6W"
};
const $06f7f86bfd55e0d2$var$orientationStyles = {
    horizontal: "_0jFU0VOn88 _3iC0zdfRAD _1OKFqYdnbC _2jTvwtWjDq",
    vertical: "_39xV02On88 _2IhTonfRAD _0Bm75GdnbC _35I30BWjDq"
};
const $06f7f86bfd55e0d2$var$edgeStyles = {
    top: "_2IhTon5Cwg _35I30BHqe5",
    right: "_4ApkO25Cwg _1D2b5MHqe5",
    bottom: "_0Bm75G5Cwg _31ReDyHqe5",
    left: "_3OE6xY5Cwg _1L3m71Hqe5"
};
const $06f7f86bfd55e0d2$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
const $06f7f86bfd55e0d2$export$17d680238e50603e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Line(t0) {
    const $ = (0, $bDgLe.c)(15);
    const { edge: edge, gap: t1, indent: t2, strokeColor: t3, strokeWidth: t4, type: t5 } = t0;
    const gap = t1 === undefined ? "0px" : t1;
    const indent = t2 === undefined ? "0px" : t2;
    const strokeColor = t3 === undefined ? (0, $hHzd2.presetStrokeColors).default : t3;
    const strokeWidth = t4 === undefined ? (0, $hHzd2.presetStrokeWidth) : t4;
    const type = t5 === undefined ? "terminal" : t5;
    const orientation = $06f7f86bfd55e0d2$var$edgeToOrientationMap[edge];
    const t6 = `calc(-0.5 * (${gap} + var(--stroke-width)))`;
    let t7;
    if ($[0] !== indent || $[1] !== type) {
        t7 = $06f7f86bfd55e0d2$var$lineStartFrom[type]({
            indent: indent
        });
        $[0] = indent;
        $[1] = type;
        $[2] = t7;
    } else t7 = $[2];
    const t8 = type === "no-terminal" ? "none" : "block";
    let t9;
    if ($[3] !== strokeColor || $[4] !== strokeWidth || $[5] !== t6 || $[6] !== t7 || $[7] !== t8) {
        t9 = {
            "--stroke-color": strokeColor,
            "--stroke-width": strokeWidth,
            "--main-axis-offset": t6,
            "--line-main-axis-start": t7,
            "--terminal-display": t8,
            "--terminal-diameter": "calc(var(--stroke-width) * 4)",
            "--terminal-radius": "calc(var(--terminal-diameter) / 2)",
            "--terminal-main-axis-start": "calc(-1 * var(--terminal-diameter))",
            "--terminal-cross-axis-offset": "calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)"
        };
        $[3] = strokeColor;
        $[4] = strokeWidth;
        $[5] = t6;
        $[6] = t7;
        $[7] = t8;
        $[8] = t9;
    } else t9 = $[8];
    const t10 = t9;
    const t11 = $06f7f86bfd55e0d2$var$orientationStyles[orientation];
    const t12 = $06f7f86bfd55e0d2$var$edgeStyles[edge];
    let t13;
    if ($[9] !== t11 || $[10] !== t12) {
        t13 = (0, $hekY6.default)([
            $06f7f86bfd55e0d2$var$baseStyles.root,
            t11,
            t12
        ]);
        $[9] = t11;
        $[10] = t12;
        $[11] = t13;
    } else t13 = $[11];
    let t14;
    if ($[12] !== t10 || $[13] !== t13) {
        t14 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            style: t10,
            className: t13
        });
        $[12] = t10;
        $[13] = t13;
        $[14] = t14;
    } else t14 = $[14];
    return t14;
} : function Line({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $hHzd2.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $hHzd2.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $06f7f86bfd55e0d2$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $06f7f86bfd55e0d2$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $hekY6.default)([
            $06f7f86bfd55e0d2$var$baseStyles.root,
            $06f7f86bfd55e0d2$var$orientationStyles[orientation],
            $06f7f86bfd55e0d2$var$edgeStyles[edge]
        ])
    });
}; // For React.lazy
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$06f7f86bfd55e0d2$export$2e2bcd8739ae039 = $06f7f86bfd55e0d2$export$17d680238e50603e;
module.exports["Line"] = $06f7f86bfd55e0d2$export$17d680238e50603e;

});

parcelRegister("hHzd2", function(module, exports) {
const $4ee2c7f82a7b207c$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #1868DB)",
    warning: "var(--ds-border-warning, #E06C00)"
};
const $4ee2c7f82a7b207c$export$45db03aa04b685e3 = "var(--ds-border-width-selected, 2px)";
module.exports["presetStrokeColors"] = $4ee2c7f82a7b207c$export$477fafec326bfca0;
module.exports["presetStrokeWidth"] = $4ee2c7f82a7b207c$export$45db03aa04b685e3;

});

parcelRegister("7SeeH", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $5bb89e8909dcc61b$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $5bb89e8909dcc61b$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $5bb89e8909dcc61b$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $5bb89e8909dcc61b$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $5bb89e8909dcc61b$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $5bb89e8909dcc61b$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $5bb89e8909dcc61b$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $5bb89e8909dcc61b$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $5bb89e8909dcc61b$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $5bb89e8909dcc61b$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $5bb89e8909dcc61b$var$root = $5bb89e8909dcc61b$var$freeGlobal || $5bb89e8909dcc61b$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $5bb89e8909dcc61b$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $5bb89e8909dcc61b$var$objectToString = $5bb89e8909dcc61b$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5bb89e8909dcc61b$var$nativeMax = Math.max, $5bb89e8909dcc61b$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $5bb89e8909dcc61b$var$now = function() {
    return $5bb89e8909dcc61b$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $5bb89e8909dcc61b$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($5bb89e8909dcc61b$var$FUNC_ERROR_TEXT);
    wait = $5bb89e8909dcc61b$var$toNumber(wait) || 0;
    if ($5bb89e8909dcc61b$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $5bb89e8909dcc61b$var$nativeMax($5bb89e8909dcc61b$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $5bb89e8909dcc61b$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $5bb89e8909dcc61b$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($5bb89e8909dcc61b$var$now());
    }
    function debounced() {
        var time = $5bb89e8909dcc61b$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $5bb89e8909dcc61b$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $5bb89e8909dcc61b$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $5bb89e8909dcc61b$var$isSymbol(value) {
    return typeof value == 'symbol' || $5bb89e8909dcc61b$var$isObjectLike(value) && $5bb89e8909dcc61b$var$objectToString.call(value) == $5bb89e8909dcc61b$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $5bb89e8909dcc61b$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($5bb89e8909dcc61b$var$isSymbol(value)) return $5bb89e8909dcc61b$var$NAN;
    if ($5bb89e8909dcc61b$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $5bb89e8909dcc61b$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($5bb89e8909dcc61b$var$reTrim, '');
    var isBinary = $5bb89e8909dcc61b$var$reIsBinary.test(value);
    return isBinary || $5bb89e8909dcc61b$var$reIsOctal.test(value) ? $5bb89e8909dcc61b$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $5bb89e8909dcc61b$var$reIsBadHex.test(value) ? $5bb89e8909dcc61b$var$NAN : +value;
}
module.exports = $5bb89e8909dcc61b$var$debounce;

});

parcelRegister("eO7Xs", function(module, exports) {
/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize include="noop" exports="npm" -o ./foo`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * A no-operation function that returns `undefined` regardless of the
 * arguments it receives.
 *
 * @static
 * @memberOf _
 * @category Util
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.noop(object) === undefined;
 * // => true
 */ function $ac7be878b65c198f$var$noop() {
// No operation performed.
}
module.exports = $ac7be878b65c198f$var$noop;

});

parcelRegister("4NiRC", function(module, exports) {
'use strict';

var $UV56W = parcelRequire("UV56W");


var $1XKQW = parcelRequire("1XKQW");

var $37da5efad62bea45$var$controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, $37da5efad62bea45$var$CRHTLF = /[\n\r\t]/g, $37da5efad62bea45$var$slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, $37da5efad62bea45$var$port = /:\d+$/, $37da5efad62bea45$var$protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, $37da5efad62bea45$var$windowsDriveLetter = /^[a-zA-Z]:/;
/**
 * Remove control characters and whitespace from the beginning of a string.
 *
 * @param {Object|String} str String to trim.
 * @returns {String} A new string representing `str` stripped of control
 *     characters and whitespace from its beginning.
 * @public
 */ function $37da5efad62bea45$var$trimLeft(str) {
    return (str ? str : '').toString().replace($37da5efad62bea45$var$controlOrWhitespace, '');
}
/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */ var $37da5efad62bea45$var$rules = [
    [
        '#',
        'hash'
    ],
    [
        '?',
        'query'
    ],
    function sanitize(address, url) {
        return $37da5efad62bea45$var$isSpecial(url.protocol) ? address.replace(/\\/g, '/') : address;
    },
    [
        '/',
        'pathname'
    ],
    [
        '@',
        'auth',
        1
    ],
    [
        NaN,
        'host',
        undefined,
        1,
        1
    ],
    [
        /:(\d*)$/,
        'port',
        undefined,
        1
    ],
    [
        NaN,
        'hostname',
        undefined,
        1,
        1
    ] // Set left over.
];
/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */ var $37da5efad62bea45$var$ignore = {
    hash: 1,
    query: 1
};
/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */ function $37da5efad62bea45$var$lolcation(loc) {
    var globalVar;
    if (typeof window !== 'undefined') globalVar = window;
    else if (typeof $parcel$global !== 'undefined') globalVar = $parcel$global;
    else if (typeof self !== 'undefined') globalVar = self;
    else globalVar = {};
    var location = globalVar.location || {};
    loc = loc || location;
    var finaldestination = {}, type = typeof loc, key;
    if ('blob:' === loc.protocol) finaldestination = new $37da5efad62bea45$var$Url(unescape(loc.pathname), {});
    else if ('string' === type) {
        finaldestination = new $37da5efad62bea45$var$Url(loc, {});
        for(key in $37da5efad62bea45$var$ignore)delete finaldestination[key];
    } else if ('object' === type) {
        for(key in loc){
            if (key in $37da5efad62bea45$var$ignore) continue;
            finaldestination[key] = loc[key];
        }
        if (finaldestination.slashes === undefined) finaldestination.slashes = $37da5efad62bea45$var$slashes.test(loc.href);
    }
    return finaldestination;
}
/**
 * Check whether a protocol scheme is special.
 *
 * @param {String} The protocol scheme of the URL
 * @return {Boolean} `true` if the protocol scheme is special, else `false`
 * @private
 */ function $37da5efad62bea45$var$isSpecial(scheme) {
    return scheme === 'file:' || scheme === 'ftp:' || scheme === 'http:' || scheme === 'https:' || scheme === 'ws:' || scheme === 'wss:';
}
/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */ /**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @param {Object} location
 * @return {ProtocolExtract} Extracted information.
 * @private
 */ function $37da5efad62bea45$var$extractProtocol(address, location) {
    address = $37da5efad62bea45$var$trimLeft(address);
    address = address.replace($37da5efad62bea45$var$CRHTLF, '');
    location = location || {};
    var match = $37da5efad62bea45$var$protocolre.exec(address);
    var protocol = match[1] ? match[1].toLowerCase() : '';
    var forwardSlashes = !!match[2];
    var otherSlashes = !!match[3];
    var slashesCount = 0;
    var rest;
    if (forwardSlashes) {
        if (otherSlashes) {
            rest = match[2] + match[3] + match[4];
            slashesCount = match[2].length + match[3].length;
        } else {
            rest = match[2] + match[4];
            slashesCount = match[2].length;
        }
    } else if (otherSlashes) {
        rest = match[3] + match[4];
        slashesCount = match[3].length;
    } else rest = match[4];
    if (protocol === 'file:') {
        if (slashesCount >= 2) rest = rest.slice(2);
    } else if ($37da5efad62bea45$var$isSpecial(protocol)) rest = match[4];
    else if (protocol) {
        if (forwardSlashes) rest = rest.slice(2);
    } else if (slashesCount >= 2 && $37da5efad62bea45$var$isSpecial(location.protocol)) rest = match[4];
    return {
        protocol: protocol,
        slashes: forwardSlashes || $37da5efad62bea45$var$isSpecial(protocol),
        slashesCount: slashesCount,
        rest: rest
    };
}
/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */ function $37da5efad62bea45$var$resolve(relative, base) {
    if (relative === '') return base;
    var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/')), i = path.length, last = path[i - 1], unshift = false, up = 0;
    while(i--){
        if (path[i] === '.') path.splice(i, 1);
        else if (path[i] === '..') {
            path.splice(i, 1);
            up++;
        } else if (up) {
            if (i === 0) unshift = true;
            path.splice(i, 1);
            up--;
        }
    }
    if (unshift) path.unshift('');
    if (last === '.' || last === '..') path.push('');
    return path.join('/');
}
/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */ function $37da5efad62bea45$var$Url(address, location, parser) {
    address = $37da5efad62bea45$var$trimLeft(address);
    address = address.replace($37da5efad62bea45$var$CRHTLF, '');
    if (!(this instanceof $37da5efad62bea45$var$Url)) return new $37da5efad62bea45$var$Url(address, location, parser);
    var relative, extracted, parse, instruction, index, key, instructions = $37da5efad62bea45$var$rules.slice(), type = typeof location, url = this, i = 0;
    //
    // The following if statements allows this module two have compatibility with
    // 2 different API:
    //
    // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
    //    where the boolean indicates that the query string should also be parsed.
    //
    // 2. The `URL` interface of the browser which accepts a URL, object as
    //    arguments. The supplied object will be used as default values / fall-back
    //    for relative paths.
    //
    if ('object' !== type && 'string' !== type) {
        parser = location;
        location = null;
    }
    if (parser && 'function' !== typeof parser) parser = $1XKQW.parse;
    location = $37da5efad62bea45$var$lolcation(location);
    //
    // Extract protocol information before running the instructions.
    //
    extracted = $37da5efad62bea45$var$extractProtocol(address || '', location);
    relative = !extracted.protocol && !extracted.slashes;
    url.slashes = extracted.slashes || relative && location.slashes;
    url.protocol = extracted.protocol || location.protocol || '';
    address = extracted.rest;
    //
    // When the authority component is absent the URL starts with a path
    // component.
    //
    if (extracted.protocol === 'file:' && (extracted.slashesCount !== 2 || $37da5efad62bea45$var$windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !$37da5efad62bea45$var$isSpecial(url.protocol))) instructions[3] = [
        /(.*)/,
        'pathname'
    ];
    for(; i < instructions.length; i++){
        instruction = instructions[i];
        if (typeof instruction === 'function') {
            address = instruction(address, url);
            continue;
        }
        parse = instruction[0];
        key = instruction[1];
        if (parse !== parse) url[key] = address;
        else if ('string' === typeof parse) {
            index = parse === '@' ? address.lastIndexOf(parse) : address.indexOf(parse);
            if (~index) {
                if ('number' === typeof instruction[2]) {
                    url[key] = address.slice(0, index);
                    address = address.slice(index + instruction[2]);
                } else {
                    url[key] = address.slice(index);
                    address = address.slice(0, index);
                }
            }
        } else if (index = parse.exec(address)) {
            url[key] = index[1];
            address = address.slice(0, index.index);
        }
        url[key] = url[key] || (relative && instruction[3] ? location[key] || '' : '');
        //
        // Hostname, host and protocol should be lowercased so they can be used to
        // create a proper `origin`.
        //
        if (instruction[4]) url[key] = url[key].toLowerCase();
    }
    //
    // Also parse the supplied query string in to an object. If we're supplied
    // with a custom parser as function use that instead of the default build-in
    // parser.
    //
    if (parser) url.query = parser(url.query);
    //
    // If the URL is relative, resolve the pathname against the base URL.
    //
    if (relative && location.slashes && url.pathname.charAt(0) !== '/' && (url.pathname !== '' || location.pathname !== '')) url.pathname = $37da5efad62bea45$var$resolve(url.pathname, location.pathname);
    //
    // Default to a / for pathname if none exists. This normalizes the URL
    // to always have a /
    //
    if (url.pathname.charAt(0) !== '/' && $37da5efad62bea45$var$isSpecial(url.protocol)) url.pathname = '/' + url.pathname;
    //
    // We should not add port numbers if they are already the default port number
    // for a given protocol. As the host also contains the port number we're going
    // override it with the hostname which contains no port number.
    //
    if (!$UV56W(url.port, url.protocol)) {
        url.host = url.hostname;
        url.port = '';
    }
    //
    // Parse down the `auth` for the username and password.
    //
    url.username = url.password = '';
    if (url.auth) {
        index = url.auth.indexOf(':');
        if (~index) {
            url.username = url.auth.slice(0, index);
            url.username = encodeURIComponent(decodeURIComponent(url.username));
            url.password = url.auth.slice(index + 1);
            url.password = encodeURIComponent(decodeURIComponent(url.password));
        } else url.username = encodeURIComponent(decodeURIComponent(url.auth));
        url.auth = url.password ? url.username + ':' + url.password : url.username;
    }
    url.origin = url.protocol !== 'file:' && $37da5efad62bea45$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    //
    // The href is just the compiled result.
    //
    url.href = url.toString();
}
/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */ function $37da5efad62bea45$var$set(part, value, fn) {
    var url = this;
    switch(part){
        case 'query':
            if ('string' === typeof value && value.length) value = (fn || $1XKQW.parse)(value);
            url[part] = value;
            break;
        case 'port':
            url[part] = value;
            if (!$UV56W(value, url.protocol)) {
                url.host = url.hostname;
                url[part] = '';
            } else if (value) url.host = url.hostname + ':' + value;
            break;
        case 'hostname':
            url[part] = value;
            if (url.port) value += ':' + url.port;
            url.host = value;
            break;
        case 'host':
            url[part] = value;
            if ($37da5efad62bea45$var$port.test(value)) {
                value = value.split(':');
                url.port = value.pop();
                url.hostname = value.join(':');
            } else {
                url.hostname = value;
                url.port = '';
            }
            break;
        case 'protocol':
            url.protocol = value.toLowerCase();
            url.slashes = !fn;
            break;
        case 'pathname':
        case 'hash':
            if (value) {
                var char = part === 'pathname' ? '/' : '#';
                url[part] = value.charAt(0) !== char ? char + value : value;
            } else url[part] = value;
            break;
        case 'username':
        case 'password':
            url[part] = encodeURIComponent(value);
            break;
        case 'auth':
            var index = value.indexOf(':');
            if (~index) {
                url.username = value.slice(0, index);
                url.username = encodeURIComponent(decodeURIComponent(url.username));
                url.password = value.slice(index + 1);
                url.password = encodeURIComponent(decodeURIComponent(url.password));
            } else url.username = encodeURIComponent(decodeURIComponent(value));
    }
    for(var i = 0; i < $37da5efad62bea45$var$rules.length; i++){
        var ins = $37da5efad62bea45$var$rules[i];
        if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
    }
    url.auth = url.password ? url.username + ':' + url.password : url.username;
    url.origin = url.protocol !== 'file:' && $37da5efad62bea45$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    url.href = url.toString();
    return url;
}
/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */ function $37da5efad62bea45$var$toString(stringify) {
    if (!stringify || 'function' !== typeof stringify) stringify = $1XKQW.stringify;
    var query, url = this, host = url.host, protocol = url.protocol;
    if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';
    var result = protocol + (url.protocol && url.slashes || $37da5efad62bea45$var$isSpecial(url.protocol) ? '//' : '');
    if (url.username) {
        result += url.username;
        if (url.password) result += ':' + url.password;
        result += '@';
    } else if (url.password) {
        result += ':' + url.password;
        result += '@';
    } else if (url.protocol !== 'file:' && $37da5efad62bea45$var$isSpecial(url.protocol) && !host && url.pathname !== '/') //
    // Add back the empty userinfo, otherwise the original invalid URL
    // might be transformed into a valid one with `url.pathname` as host.
    //
    result += '@';
    //
    // Trailing colon is removed from `url.host` when it is parsed. If it still
    // ends with a colon, then add back the trailing colon that was removed. This
    // prevents an invalid URL from being transformed into a valid one.
    //
    if (host[host.length - 1] === ':' || $37da5efad62bea45$var$port.test(url.hostname) && !url.port) host += ':';
    result += host + url.pathname;
    query = 'object' === typeof url.query ? stringify(url.query) : url.query;
    if (query) result += '?' !== query.charAt(0) ? '?' + query : query;
    if (url.hash) result += url.hash;
    return result;
}
$37da5efad62bea45$var$Url.prototype = {
    set: $37da5efad62bea45$var$set,
    toString: $37da5efad62bea45$var$toString
};
//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
$37da5efad62bea45$var$Url.extractProtocol = $37da5efad62bea45$var$extractProtocol;
$37da5efad62bea45$var$Url.location = $37da5efad62bea45$var$lolcation;
$37da5efad62bea45$var$Url.trimLeft = $37da5efad62bea45$var$trimLeft;
$37da5efad62bea45$var$Url.qs = $1XKQW;
module.exports = $37da5efad62bea45$var$Url;

});

parcelRegister("UV56W", function(module, exports) {
'use strict';
/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */ module.exports = function required(port, protocol) {
    protocol = protocol.split(':')[0];
    port = +port;
    if (!port) return false;
    switch(protocol){
        case 'http':
        case 'ws':
            return port !== 80;
        case 'https':
        case 'wss':
            return port !== 443;
        case 'ftp':
            return port !== 21;
        case 'gopher':
            return port !== 70;
        case 'file':
            return false;
    }
    return port !== 0;
};

});

parcelRegister("1XKQW", function(module, exports) {
$parcel$export(module.exports, "stringify", () => $16dfa51e60a0cda0$export$fac44ee5b035f737, (v) => $16dfa51e60a0cda0$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parse", () => $16dfa51e60a0cda0$export$98e6a39c04603d36, (v) => $16dfa51e60a0cda0$export$98e6a39c04603d36 = v);
//
// Expose the module.
//
var $16dfa51e60a0cda0$export$fac44ee5b035f737;
var $16dfa51e60a0cda0$export$98e6a39c04603d36;
'use strict';
var $16dfa51e60a0cda0$var$has = Object.prototype.hasOwnProperty, $16dfa51e60a0cda0$var$undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $16dfa51e60a0cda0$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, ' '));
    } catch (e) {
        return null;
    }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */ function $16dfa51e60a0cda0$var$encode(input) {
    try {
        return encodeURIComponent(input);
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function $16dfa51e60a0cda0$var$querystring(query) {
    var parser = /([^=?#&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = $16dfa51e60a0cda0$var$decode(part[1]), value = $16dfa51e60a0cda0$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function $16dfa51e60a0cda0$var$querystringify(obj, prefix) {
    prefix = prefix || '';
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ('string' !== typeof prefix) prefix = '?';
    for(key in obj)if ($16dfa51e60a0cda0$var$has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === $16dfa51e60a0cda0$var$undef || isNaN(value))) value = '';
        key = $16dfa51e60a0cda0$var$encode(key);
        value = $16dfa51e60a0cda0$var$encode(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + '=' + value);
    }
    return pairs.length ? prefix + pairs.join('&') : '';
}
$16dfa51e60a0cda0$export$fac44ee5b035f737 = $16dfa51e60a0cda0$var$querystringify;
$16dfa51e60a0cda0$export$98e6a39c04603d36 = $16dfa51e60a0cda0$var$querystring;

});

parcelRegister("33jh4", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $7r5Hr = parcelRequire("7r5Hr");


var $1hQ0e = parcelRequire("1hQ0e");


var $lmzCg = parcelRequire("lmzCg");


var $dpsRj = parcelRequire("dpsRj");


var $iDrrr = parcelRequire("iDrrr");


var $dX71b = parcelRequire("dX71b");


var $iCvWJ = parcelRequire("iCvWJ");


var $fPRWc = parcelRequire("fPRWc");


var $2OKnq = parcelRequire("2OKnq");


var $g0IDr = parcelRequire("g0IDr");


var $7DQ7D = parcelRequire("7DQ7D");

const $afd57266bdb0eac4$var$defaultMaxItems = 8;
const $afd57266bdb0eac4$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
const $afd57266bdb0eac4$var$defaultEllipsisLabel = 'Show more breadcrumbs';
const { toArray: $afd57266bdb0eac4$var$toArray } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children;
const $afd57266bdb0eac4$var$analyticsAttributes = {
    componentName: 'breadcrumbs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $afd57266bdb0eac4$var$noop = (0, $dpsRj.default);
const $afd57266bdb0eac4$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
const $afd57266bdb0eac4$var$breadcrumbStylesOld = null;
const $afd57266bdb0eac4$var$breadcrumbStylesNew = null;
const $afd57266bdb0eac4$var$navStylesNew = null;
const $afd57266bdb0eac4$var$ellipsisItemWrapperStyles = null; // items will get collapsed into ellipsis dropdown
// therefore they are no longer rendered in the DOM
// they need to be passed in to the dropdown
function $afd57266bdb0eac4$var$getItemProps(child) {
    const { text: text, href: href, onClick: onClick, target: target } = child.props;
    const wrappedOnClick = onClick ? (event)=>{
        // Collapsed dropdown items can be activated via keyboard, but the
        // original BreadcrumbsItem onClick contract is mouse-based.
        if ('button' in event) onClick(event);
    } : undefined;
    return {
        text: text ?? '',
        href: href,
        onClick: wrappedOnClick,
        target: target
    };
}
function $afd57266bdb0eac4$var$cloneBreadcrumbChild(child, index, itemCount, registerItem) {
    const isLast = index === itemCount - 1;
    const isCurrentItem = child.type === (0, $dX71b.default);
    return(// eslint-disable-next-line @repo/internal/react/no-clone-element
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(child, {
        key: child.key ?? index,
        _overflowRef: registerItem(index),
        ...isLast && !isCurrentItem ? {
            'aria-current': 'page'
        } : {}
    }));
}
const $afd57266bdb0eac4$var$InnerBreadcrumbs = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(6);
    if ((0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh")) {
        let t0;
        if ($[0] !== props || $[1] !== ref) {
            t0 = /*#__PURE__*/ (0, $8aG6j.jsx)($afd57266bdb0eac4$var$InnerBreadcrumbsNew, {
                ...props,
                ref: ref
            });
            $[0] = props;
            $[1] = ref;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    }
    let t0;
    if ($[3] !== props || $[4] !== ref) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)($afd57266bdb0eac4$var$InnerBreadcrumbsOld, {
            ...props,
            ref: ref
        });
        $[3] = props;
        $[4] = ref;
        $[5] = t0;
    } else t0 = $[5];
    return t0;
} : (props, ref)=>{
    if ((0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh')) return /*#__PURE__*/ (0, $8aG6j.jsx)($afd57266bdb0eac4$var$InnerBreadcrumbsNew, {
        ...props,
        ref: ref
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)($afd57266bdb0eac4$var$InnerBreadcrumbsOld, {
        ...props,
        ref: ref
    });
});
const $afd57266bdb0eac4$var$InnerBreadcrumbsOld = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(25);
    const { defaultExpanded: t0, isExpanded: isExpanded, maxItems: t1, itemsBeforeCollapse: t2, itemsAfterCollapse: t3, children: t4, testId: testId, onExpand: t5, analyticsContext: analyticsContext, label: t6, ellipsisLabel: t7, size: t8 } = props;
    const defaultExpanded = t0 === undefined ? false : t0;
    const maxItems = t1 === undefined ? $afd57266bdb0eac4$var$defaultMaxItems : t1;
    const itemsBeforeCollapse = t2 === undefined ? 1 : t2;
    const itemsAfterCollapse = t3 === undefined ? 1 : t3;
    const children = t4 === undefined ? [] : t4;
    const providedExpanse = t5 === undefined ? $afd57266bdb0eac4$var$noop : t5;
    const label = t6 === undefined ? $afd57266bdb0eac4$var$defaultBreadcrumbsLabel : t6;
    const ellipsisLabel = t7 === undefined ? $afd57266bdb0eac4$var$defaultEllipsisLabel : t7;
    const size = t8 === undefined ? "medium" : t8;
    const [expanded, setExpanse] = (0, $cozmU.useState)(defaultExpanded);
    const [isClickedBySpace, setExpansionTrigger] = (0, $cozmU.useState)(false);
    const wrapperRef = (0, $cozmU.useRef)(null);
    const isControlled = typeof isExpanded !== "undefined";
    const isExpansionHandled = providedExpanse !== $afd57266bdb0eac4$var$noop;
    const shouldExpand = isControlled ? isExpanded : expanded;
    let t9;
    if ($[0] !== itemsBeforeCollapse) {
        t9 = ()=>{
            if (wrapperRef.current) {
                const listItems = Array.from(wrapperRef.current.querySelectorAll("li"));
                const interactiveElements = listItems.map($afd57266bdb0eac4$var$_temp);
                const elementToFocus = interactiveElements[itemsBeforeCollapse];
                const firstInteractiveElement = interactiveElements[0];
                if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
                else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
                else wrapperRef.current.focus();
            }
            setExpansionTrigger(false);
        };
        $[0] = itemsBeforeCollapse;
        $[1] = t9;
    } else t9 = $[1];
    const focusFirstRevealedMemoized = t9;
    const t10 = !isClickedBySpace;
    let t11;
    if ($[2] !== shouldExpand || $[3] !== t10) {
        t11 = {
            isExpanded: shouldExpand,
            isDisabled: t10
        };
        $[2] = shouldExpand;
        $[3] = t10;
        $[4] = t11;
    } else t11 = $[4];
    (0, $g0IDr.useOnRevealed)(focusFirstRevealedMemoized, t11);
    let t12;
    if ($[5] !== isControlled || $[6] !== isExpansionHandled || $[7] !== providedExpanse) {
        t12 = (event, analyticsEvent)=>{
            if (!isControlled) setExpanse($afd57266bdb0eac4$var$_temp2);
            if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === (0, $1hQ0e.getDocument)()?.activeElement);
            return providedExpanse(event, analyticsEvent);
        };
        $[5] = isControlled;
        $[6] = isExpansionHandled;
        $[7] = providedExpanse;
        $[8] = t12;
    } else t12 = $[8];
    let t13;
    if ($[9] !== analyticsContext || $[10] !== t12) {
        t13 = {
            fn: t12,
            action: "expanded",
            analyticsData: analyticsContext,
            ...$afd57266bdb0eac4$var$analyticsAttributes
        };
        $[9] = analyticsContext;
        $[10] = t12;
        $[11] = t13;
    } else t13 = $[11];
    const handleExpansion = (0, $7r5Hr.usePlatformLeafEventHandler)(t13);
    const childrenArray = $afd57266bdb0eac4$var$toArray(children);
    const breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(childrenArray, (child, index)=>{
        if (typeof child === "string") return child;
        return childrenArray.length - 1 === index ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(child, {
            "aria-current": "page"
        }) : child;
    });
    const renderItemsWithEllipsis = ()=>{
        const allItems = breadcrumbsArray;
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        const beforeItems = allItems.slice(0, itemsBeforeCollapse);
        const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [
            ...beforeItems,
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iCvWJ.default), {
                testId: testId && `${testId}--breadcrumb-ellipsis`,
                onClick: handleExpansion,
                label: ellipsisLabel
            }, "ellipsis"),
            ...afterItems
        ];
    };
    const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    let t14;
    if ($[12] !== ref) {
        t14 = (0, $lmzCg.default)([
            ref,
            wrapperRef
        ]);
        $[12] = ref;
        $[13] = t14;
    } else t14 = $[13];
    let t15;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _3TGfC9HnLE _1UtDYzKGUX _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg"
        ]);
        $[14] = t15;
    } else t15 = $[14];
    let t16;
    if ($[15] !== breadcrumbsItems || $[16] !== testId) {
        t16 = /*#__PURE__*/ (0, $8aG6j.jsx)("ol", {
            "data-testid": testId,
            className: t15,
            children: breadcrumbsItems
        });
        $[15] = breadcrumbsItems;
        $[16] = testId;
        $[17] = t16;
    } else t16 = $[17];
    let t17;
    if ($[18] !== label || $[19] !== t14 || $[20] !== t16) {
        t17 = /*#__PURE__*/ (0, $8aG6j.jsx)("nav", {
            "aria-label": label,
            ref: t14,
            tabIndex: -1,
            children: t16
        });
        $[18] = label;
        $[19] = t14;
        $[20] = t16;
        $[21] = t17;
    } else t17 = $[21];
    let t18;
    if ($[22] !== size || $[23] !== t17) {
        t18 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fPRWc.BreadcrumbsSizeProvider), {
            value: size,
            children: t17
        });
        $[22] = size;
        $[23] = t17;
        $[24] = t18;
    } else t18 = $[24];
    return t18;
} : (props, ref)=>{
    const { defaultExpanded: defaultExpanded = false, isExpanded: isExpanded, maxItems: maxItems = $afd57266bdb0eac4$var$defaultMaxItems, itemsBeforeCollapse: itemsBeforeCollapse = 1, itemsAfterCollapse: itemsAfterCollapse = 1, children: children = [], testId: testId, onExpand: providedExpanse = $afd57266bdb0eac4$var$noop, analyticsContext: analyticsContext, label: label = $afd57266bdb0eac4$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $afd57266bdb0eac4$var$defaultEllipsisLabel, size: size = 'medium' } = props;
    const [expanded, setExpanse] = (0, $cozmU.useState)(defaultExpanded);
    const [isClickedBySpace, setExpansionTrigger] = (0, $cozmU.useState)(false);
    const wrapperRef = (0, $cozmU.useRef)(null);
    const isControlled = typeof isExpanded !== 'undefined';
    const isExpansionHandled = providedExpanse !== $afd57266bdb0eac4$var$noop;
    const shouldExpand = isControlled ? isExpanded : expanded;
    const focusFirstRevealedMemoized = (0, $cozmU.useCallback)(()=>{
        if (wrapperRef.current) {
            const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
            const interactiveElements = listItems.map((li)=>li.querySelector($afd57266bdb0eac4$var$interactiveElementSelector));
            const elementToFocus = interactiveElements[itemsBeforeCollapse];
            const firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    }, [
        setExpansionTrigger,
        itemsBeforeCollapse,
        wrapperRef
    ]);
    (0, $g0IDr.useOnRevealed)(focusFirstRevealedMemoized, {
        isExpanded: shouldExpand,
        isDisabled: !isClickedBySpace
    });
    const handleExpansion = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isControlled) setExpanse((expanded_0)=>!expanded_0);
            if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === (0, $1hQ0e.getDocument)()?.activeElement);
            return providedExpanse(event, analyticsEvent);
        },
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$afd57266bdb0eac4$var$analyticsAttributes
    });
    const childrenArray = $afd57266bdb0eac4$var$toArray(children);
    const breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(childrenArray, (child, index)=>{
        if (typeof child === 'string') return child;
        return childrenArray.length - 1 === index ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(child, {
            'aria-current': 'page'
        }) : child;
    });
    const renderItemsWithEllipsis = ()=>{
        const allItems = breadcrumbsArray;
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        const beforeItems = allItems.slice(0, itemsBeforeCollapse);
        const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [
            ...beforeItems,
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iCvWJ.default), {
                testId: testId && `${testId}--breadcrumb-ellipsis`,
                onClick: handleExpansion,
                label: ellipsisLabel
            }, "ellipsis"),
            ...afterItems
        ];
    };
    const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fPRWc.BreadcrumbsSizeProvider), {
        value: size,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("nav", {
            "aria-label": label,
            ref: (0, $lmzCg.default)([
                ref,
                wrapperRef
            ]),
            tabIndex: -1,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("ol", {
                "data-testid": testId,
                className: (0, $hekY6.default)([
                    "_3iDTPbQ4SZ _3TGfC9HnLE _1UtDYzKGUX _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg"
                ]),
                children: breadcrumbsItems
            })
        })
    });
});
const $afd57266bdb0eac4$var$InnerBreadcrumbsNew = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(17);
    const { children: t0, testId: testId, analyticsContext: analyticsContext, label: t1, ellipsisLabel: t2, size: t3 } = props;
    const children = t0 === undefined ? [] : t0;
    const label = t1 === undefined ? $afd57266bdb0eac4$var$defaultBreadcrumbsLabel : t1;
    const ellipsisLabel = t2 === undefined ? $afd57266bdb0eac4$var$defaultEllipsisLabel : t2;
    const size = t3 === undefined ? "medium" : t3;
    const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(children).filter($afd57266bdb0eac4$var$_temp3);
    const itemCount = childrenArray.length;
    const { collapsedIndices: collapsedIndices, naturalWidthsReady: naturalWidthsReady, registerItem: registerItem, registerContainer: registerContainer } = (0, $7DQ7D.default)(itemCount);
    let t4;
    if ($[2] !== analyticsContext) {
        t4 = {
            fn: $afd57266bdb0eac4$var$noop,
            action: "expanded",
            analyticsData: analyticsContext,
            ...$afd57266bdb0eac4$var$analyticsAttributes
        };
        $[2] = analyticsContext;
        $[3] = t4;
    } else t4 = $[3];
    const handleOverflowExpansion = (0, $7r5Hr.usePlatformLeafEventHandler)(t4);
    const collapsedItems = Array.from(collapsedIndices).sort($afd57266bdb0eac4$var$_temp4).map((i)=>$afd57266bdb0eac4$var$getItemProps(childrenArray[i]));
    const renderedItems = [];
    let ellipsisInserted = false;
    childrenArray.forEach((child_1, index_0)=>{
        const isCollapsed = collapsedIndices.has(index_0);
        if (isCollapsed) {
            if (!ellipsisInserted) {
                ellipsisInserted = true;
                renderedItems.push(/*#__PURE__*/ (0, $8aG6j.jsx)("li", {
                    className: (0, $hekY6.default)([
                        "_3iDTPbQ4SZ _24h04i2Njc _0hPCNLDIqT _0aFT5v1qpb _3YEZNOdnbC _4xdlr0DIqT _43nrzTPgdg _3S3RSqFQfX _3VnCAF2ADO _2jfUf9Jg58 _1Y703adnbC _446KM5DIqT _2GPglyKGUX _0GBAIrfzt3 _0AG2YuDIqT"
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2OKnq.default), {
                        collapsedItems: collapsedItems,
                        label: ellipsisLabel,
                        onClick: handleOverflowExpansion,
                        testId: testId && `${testId}--breadcrumb-ellipsis`
                    })
                }, "ellipsis"));
            }
            return;
        }
        renderedItems.push($afd57266bdb0eac4$var$cloneBreadcrumbChild(child_1, index_0, itemCount, registerItem));
    });
    const measureItems = !naturalWidthsReady ? childrenArray.map((child_2, index_1)=>$afd57266bdb0eac4$var$cloneBreadcrumbChild(child_2, index_1, itemCount, registerItem)) : null;
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC"
        ]);
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _4ouGXIdnbC _0hPCNLDIqT _3TGfC9LRg7 _0aNu0LYbGa _0rIjykdnbC _43nrzTdnbC _2xTnZxdnbC _0GTcwRdnbC _0xmtkodnbC _46hvQmdnbC _03SyCPdnbC _0LQT5EdnbC"
        ]);
        $[5] = t6;
    } else t6 = $[5];
    const t7 = naturalWidthsReady ? renderedItems : measureItems;
    let t8;
    if ($[6] !== registerContainer || $[7] !== t7 || $[8] !== testId) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)("ol", {
            "data-testid": testId,
            ref: registerContainer,
            className: t6,
            children: t7
        });
        $[6] = registerContainer;
        $[7] = t7;
        $[8] = testId;
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== label || $[11] !== ref || $[12] !== t8) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsx)("nav", {
            "aria-label": label,
            ref: ref,
            tabIndex: -1,
            className: t5,
            children: t8
        });
        $[10] = label;
        $[11] = ref;
        $[12] = t8;
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== size || $[15] !== t9) {
        t10 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fPRWc.BreadcrumbsSizeProvider), {
            value: size,
            children: t9
        });
        $[14] = size;
        $[15] = t9;
        $[16] = t10;
    } else t10 = $[16];
    return t10;
} : (props, ref)=>{
    const { children: children = [], testId: testId, analyticsContext: analyticsContext, label: label = $afd57266bdb0eac4$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $afd57266bdb0eac4$var$defaultEllipsisLabel, size: size = 'medium', createAnalyticsEvent: _createAnalyticsEvent } = props;
    const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(children).filter((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child));
    const itemCount = childrenArray.length;
    const { collapsedIndices: collapsedIndices, naturalWidthsReady: naturalWidthsReady, registerItem: registerItem, registerContainer: registerContainer } = (0, $7DQ7D.default)(itemCount);
    const handleOverflowExpansion = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: $afd57266bdb0eac4$var$noop,
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$afd57266bdb0eac4$var$analyticsAttributes
    });
    const collapsedItems = Array.from(collapsedIndices).sort((a, b)=>a - b).map((i)=>$afd57266bdb0eac4$var$getItemProps(childrenArray[i]));
    const renderedItems = [];
    let ellipsisInserted = false;
    childrenArray.forEach((child_1, index_0)=>{
        const isCollapsed = collapsedIndices.has(index_0);
        if (isCollapsed) {
            if (!ellipsisInserted) {
                ellipsisInserted = true;
                renderedItems.push(/*#__PURE__*/ (0, $8aG6j.jsx)("li", {
                    className: (0, $hekY6.default)([
                        "_3iDTPbQ4SZ _24h04i2Njc _0hPCNLDIqT _0aFT5v1qpb _3YEZNOdnbC _4xdlr0DIqT _43nrzTPgdg _3S3RSqFQfX _3VnCAF2ADO _2jfUf9Jg58 _1Y703adnbC _446KM5DIqT _2GPglyKGUX _0GBAIrfzt3 _0AG2YuDIqT"
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2OKnq.default), {
                        collapsedItems: collapsedItems,
                        label: ellipsisLabel,
                        onClick: handleOverflowExpansion,
                        testId: testId && `${testId}--breadcrumb-ellipsis`
                    })
                }, "ellipsis"));
            }
            return;
        }
        renderedItems.push($afd57266bdb0eac4$var$cloneBreadcrumbChild(child_1, index_0, itemCount, registerItem));
    });
    const measureItems = !naturalWidthsReady ? childrenArray.map((child_2, index_1)=>$afd57266bdb0eac4$var$cloneBreadcrumbChild(child_2, index_1, itemCount, registerItem)) : null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fPRWc.BreadcrumbsSizeProvider), {
        value: size,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("nav", {
            "aria-label": label,
            ref: ref,
            tabIndex: -1,
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("ol", {
                "data-testid": testId,
                ref: registerContainer,
                className: (0, $hekY6.default)([
                    "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _4ouGXIdnbC _0hPCNLDIqT _3TGfC9LRg7 _0aNu0LYbGa _0rIjykdnbC _43nrzTdnbC _2xTnZxdnbC _0GTcwRdnbC _0xmtkodnbC _46hvQmdnbC _03SyCPdnbC _0LQT5EdnbC"
                ]),
                children: naturalWidthsReady ? renderedItems : measureItems
            })
        })
    });
});
const $afd57266bdb0eac4$var$Breadcrumbs = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(31);
    let analyticsContext;
    let children;
    let createAnalyticsEvent;
    let defaultExpanded;
    let ellipsisLabel;
    let isExpanded;
    let itemsAfterCollapse;
    let itemsBeforeCollapse;
    let label;
    let maxItems;
    let onExpand;
    let props;
    let size;
    let testId;
    if ($[0] !== t0) {
        ({ analyticsContext: analyticsContext, children: children, createAnalyticsEvent: createAnalyticsEvent, defaultExpanded: defaultExpanded, ellipsisLabel: ellipsisLabel, isExpanded: isExpanded, itemsAfterCollapse: itemsAfterCollapse, itemsBeforeCollapse: itemsBeforeCollapse, label: label, maxItems: maxItems, onExpand: onExpand, size: size, testId: testId, ...props } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = children;
        $[3] = createAnalyticsEvent;
        $[4] = defaultExpanded;
        $[5] = ellipsisLabel;
        $[6] = isExpanded;
        $[7] = itemsAfterCollapse;
        $[8] = itemsBeforeCollapse;
        $[9] = label;
        $[10] = maxItems;
        $[11] = onExpand;
        $[12] = props;
        $[13] = size;
        $[14] = testId;
    } else {
        analyticsContext = $[1];
        children = $[2];
        createAnalyticsEvent = $[3];
        defaultExpanded = $[4];
        ellipsisLabel = $[5];
        isExpanded = $[6];
        itemsAfterCollapse = $[7];
        itemsBeforeCollapse = $[8];
        label = $[9];
        maxItems = $[10];
        onExpand = $[11];
        props = $[12];
        size = $[13];
        testId = $[14];
    }
    let t1;
    if ($[15] !== analyticsContext || $[16] !== children || $[17] !== createAnalyticsEvent || $[18] !== defaultExpanded || $[19] !== ellipsisLabel || $[20] !== isExpanded || $[21] !== itemsAfterCollapse || $[22] !== itemsBeforeCollapse || $[23] !== label || $[24] !== maxItems || $[25] !== onExpand || $[26] !== props || $[27] !== ref || $[28] !== size || $[29] !== testId) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)($afd57266bdb0eac4$var$InnerBreadcrumbs, {
            ...props,
            analyticsContext: analyticsContext,
            children: children,
            createAnalyticsEvent: createAnalyticsEvent,
            defaultExpanded: defaultExpanded,
            ellipsisLabel: ellipsisLabel,
            isExpanded: isExpanded,
            itemsAfterCollapse: itemsAfterCollapse,
            itemsBeforeCollapse: itemsBeforeCollapse,
            label: label,
            maxItems: maxItems,
            onExpand: onExpand,
            size: size,
            ref: ref,
            testId: testId
        });
        $[15] = analyticsContext;
        $[16] = children;
        $[17] = createAnalyticsEvent;
        $[18] = defaultExpanded;
        $[19] = ellipsisLabel;
        $[20] = isExpanded;
        $[21] = itemsAfterCollapse;
        $[22] = itemsBeforeCollapse;
        $[23] = label;
        $[24] = maxItems;
        $[25] = onExpand;
        $[26] = props;
        $[27] = ref;
        $[28] = size;
        $[29] = testId;
        $[30] = t1;
    } else t1 = $[30];
    return t1;
} : ({ analyticsContext: analyticsContext, children: children, createAnalyticsEvent: createAnalyticsEvent, defaultExpanded: defaultExpanded, ellipsisLabel: ellipsisLabel, isExpanded: isExpanded, itemsAfterCollapse: itemsAfterCollapse, itemsBeforeCollapse: itemsBeforeCollapse, label: label, maxItems: maxItems, onExpand: onExpand, size: size, testId: testId, ...props }, ref)=>/*#__PURE__*/ (0, $8aG6j.jsx)($afd57266bdb0eac4$var$InnerBreadcrumbs, {
        ...props,
        analyticsContext: analyticsContext,
        children: children,
        createAnalyticsEvent: createAnalyticsEvent,
        defaultExpanded: defaultExpanded,
        ellipsisLabel: ellipsisLabel,
        isExpanded: isExpanded,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        label: label,
        maxItems: maxItems,
        onExpand: onExpand,
        size: size,
        ref: ref,
        testId: testId
    }))); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $afd57266bdb0eac4$export$2e2bcd8739ae039 = $afd57266bdb0eac4$var$Breadcrumbs;
function $afd57266bdb0eac4$var$_temp(li) {
    return li.querySelector($afd57266bdb0eac4$var$interactiveElementSelector);
}
function $afd57266bdb0eac4$var$_temp2(expanded_0) {
    return !expanded_0;
}
function $afd57266bdb0eac4$var$_temp3(child) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child);
}
function $afd57266bdb0eac4$var$_temp4(a, b) {
    return a - b;
}
module.exports["default"] = $afd57266bdb0eac4$export$2e2bcd8739ae039;

});

parcelRegister("dX71b", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7r5Hr = parcelRequire("7r5Hr");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $lmzCg = parcelRequire("lmzCg");


var $dpsRj = parcelRequire("dpsRj");


var $kTb7m = parcelRequire("kTb7m");


var $iDrrr = parcelRequire("iDrrr");


var $7vK9E = parcelRequire("7vK9E");


var $lpNn5 = parcelRequire("lpNn5");


var $jiltW = parcelRequire("jiltW");


var $8C5a3 = parcelRequire("8C5a3");

const $f5df9bde6b3e6461$var$analyticsAttributes = {
    componentName: 'breadcrumbsCurrentItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $f5df9bde6b3e6461$var$COPY_RESET_DELAY_MS = 2000;
const $f5df9bde6b3e6461$var$ICON_WIDTH_ESTIMATE = 24;
const $f5df9bde6b3e6461$var$unboundedStyles = {
    container: "_2mHwu81Y8M _0bjKvDKxmn _4c065UFQfX _3iDTPbccYA _0hPCNLDIqT _24h04i2Njc _0jFU0V9DVM _487zM87dHp",
    itemWrapper: "_3iDTPbQ4SZ _24h04i2Njc _1EqgXlN91d _0hPCNLDIqT _4xdlr0DIqT _0aFT5v1qpb _0WKd3G4z3T _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg",
    copyButtonWrapper: "_3iDTPbccYA _1YKVNsdnbC _17c2U47dHp _3Tg68S7dHp",
    iconWrapper: "_1UtDYzWYXf",
    iconWrapperSmall: "_27VeLCey7F _2Qxi4ney7F"
};
const $f5df9bde6b3e6461$var$styles = {
    interactiveContainer: "_2mHwu81Y8M _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _2sNsIgmnOE _3iDTPbccYA _0hPCNLDIqT _24h04i2Njc _1UtDYzy7kJ _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMy7kJ _0CMRbky7kJ",
    interactiveContainerMotion: "_23rrnHWE38 _3xtjKN0Rl6 _00uqCYjOvk _1B4rbIo10F _0DCa9Dy7kJ _3sFUREDdj4 _3WzCGiy7kJ",
    interactiveContainerSmall: "_2sNsIg7NXe",
    interactiveContainerLegacy: "_0jFU0V9DVM",
    interactiveContainerWithTruncation: "_4ouGXIdnbC _3YEZNO7dHp",
    iconWrapper: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbccYA _3YEZNOdnbC _39xV02oWWg _0jFU0VoWWg _0hPCNLDIqT _37wbyuDIqT",
    iconWrapperExternal: "_2xTnZxFQfX",
    iconWrapperExternalSmall: "_2xTnZxPgdg",
    text: "_2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _1UtDYzy7kJ _39HuIbz8Lp _1ANEUSLRg7",
    textSmall: "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _1UtDYzy7kJ _39HuIbz8Lp _1ANEUSLRg7",
    textWithTruncation: "_4ouGXIdnbC _1EqgXlN91d _3YEZNO7dHp"
};
const $f5df9bde6b3e6461$var$BreadcrumbsCurrentItem = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(52);
    const { text: text, href: href, onClick: onClick, target: target, analyticsContext: analyticsContext, elemBefore: elemBefore, iconBefore: iconBefore, truncationWidth: truncationWidth, testId: testId, onCopyLink: onCopyLink, onTooltipShown: onTooltipShown, _overflowRef: _overflowRef } = t0;
    const isSmall = (0, $jiltW.useBreadcrumbsSize)() === "small";
    const t1 = onClick ?? (0, $dpsRj.default);
    let t2;
    if ($[0] !== analyticsContext || $[1] !== t1) {
        t2 = {
            fn: t1,
            action: "clicked",
            analyticsData: analyticsContext,
            ...$f5df9bde6b3e6461$var$analyticsAttributes
        };
        $[0] = analyticsContext;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    const handleClick = (0, $7r5Hr.usePlatformLeafEventHandler)(t2);
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const [copied, setCopied] = (0, $cozmU.useState)(false);
    const [linkElement, setLinkElement] = (0, $cozmU.useState)(null);
    const resetTimerRef = (0, $cozmU.useRef)(null);
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (element)=>{
            setLinkElement(element);
        };
        $[3] = t3;
    } else t3 = $[3];
    const setLinkRef = t3;
    const [, shouldShowTooltip] = (0, $8C5a3.default)(truncationWidth, linkElement, (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") ? 0 : resolvedElemBefore ? $f5df9bde6b3e6461$var$ICON_WIDTH_ESTIMATE : 0);
    let t4;
    if ($[4] !== href || $[5] !== onCopyLink) {
        t4 = ()=>{
            if (!navigator.clipboard) return;
            const url = new URL(href, window.location.href).href;
            navigator.clipboard.writeText(url).then(()=>{
                setCopied(true);
                onCopyLink?.();
                if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
                resetTimerRef.current = setTimeout(()=>{
                    setCopied(false);
                }, $f5df9bde6b3e6461$var$COPY_RESET_DELAY_MS);
            }, (0, $dpsRj.default));
        };
        $[4] = href;
        $[5] = onCopyLink;
        $[6] = t4;
    } else t4 = $[6];
    const handleCopy = t4;
    let t5;
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>()=>{
                if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
            };
        t6 = [];
        $[7] = t5;
        $[8] = t6;
    } else {
        t5 = $[7];
        t6 = $[8];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[9] !== isSmall || $[10] !== resolvedElemBefore || $[11] !== testId) {
        t7 = resolvedElemBefore && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "data-testid": testId && `${testId}--icon-before`,
            className: (0, $hekY6.default)([
                $f5df9bde6b3e6461$var$styles.iconWrapper,
                $f5df9bde6b3e6461$var$unboundedStyles.iconWrapper,
                (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && $f5df9bde6b3e6461$var$styles.iconWrapperExternal,
                isSmall && $f5df9bde6b3e6461$var$styles.iconWrapperExternalSmall,
                isSmall && $f5df9bde6b3e6461$var$unboundedStyles.iconWrapperSmall
            ]),
            children: resolvedElemBefore
        });
        $[9] = isSmall;
        $[10] = resolvedElemBefore;
        $[11] = testId;
        $[12] = t7;
    } else t7 = $[12];
    const iconElement = t7;
    const t8 = isSmall && $f5df9bde6b3e6461$var$styles.textSmall;
    const t9 = !isSmall && $f5df9bde6b3e6461$var$styles.text;
    const t10 = truncationWidth && $f5df9bde6b3e6461$var$styles.textWithTruncation;
    let t11;
    if ($[13] !== t10 || $[14] !== t8 || $[15] !== t9) {
        t11 = (0, $hekY6.default)([
            t8,
            t9,
            t10
        ]);
        $[13] = t10;
        $[14] = t8;
        $[15] = t9;
        $[16] = t11;
    } else t11 = $[16];
    let t12;
    if ($[17] !== t11 || $[18] !== text) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: t11,
            children: text
        });
        $[17] = t11;
        $[18] = text;
        $[19] = t12;
    } else t12 = $[19];
    const textElement = t12;
    let t13;
    if ($[20] !== handleClick || $[21] !== href || $[22] !== iconElement || $[23] !== isSmall || $[24] !== target || $[25] !== testId || $[26] !== textElement || $[27] !== truncationWidth) {
        t13 = (triggerProps)=>{
            const tooltipRef = triggerProps?.ref;
            const handleTriggerClick = (event)=>{
                triggerProps?.onClick?.(event);
                handleClick(event);
            };
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor), {
                href: href,
                target: target,
                rel: target === "_blank" ? "noopener noreferrer" : undefined,
                "aria-current": "page",
                onClick: handleTriggerClick,
                onMouseOver: triggerProps?.onMouseOver,
                onMouseOut: triggerProps?.onMouseOut,
                onMouseMove: triggerProps?.onMouseMove,
                onMouseDown: triggerProps?.onMouseDown,
                onFocus: triggerProps?.onFocus,
                onBlur: triggerProps?.onBlur,
                "aria-describedby": triggerProps?.["aria-describedby"],
                testId: testId,
                ref: tooltipRef ? (0, $lmzCg.default)([
                    setLinkRef,
                    tooltipRef
                ]) : setLinkRef,
                xcss: (0, $w6R6I.cx)($f5df9bde6b3e6461$var$styles.interactiveContainer, !(0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && $f5df9bde6b3e6461$var$styles.interactiveContainerLegacy, isSmall && $f5df9bde6b3e6461$var$styles.interactiveContainerSmall, truncationWidth != null && $f5df9bde6b3e6461$var$styles.interactiveContainerWithTruncation, (0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") && $f5df9bde6b3e6461$var$styles.interactiveContainerMotion),
                style: {
                    maxWidth: truncationWidth
                },
                children: [
                    !(0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && iconElement,
                    textElement
                ]
            });
        };
        $[20] = handleClick;
        $[21] = href;
        $[22] = iconElement;
        $[23] = isSmall;
        $[24] = target;
        $[25] = testId;
        $[26] = textElement;
        $[27] = truncationWidth;
        $[28] = t13;
    } else t13 = $[28];
    const renderLink = t13;
    const t14 = copied ? "Copied!" : "Copy link";
    let t15;
    if ($[29] !== copied || $[30] !== handleCopy || $[31] !== testId) {
        t15 = (tooltipProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                "data-breadcrumbs-copy-link": true,
                "data-copied": copied || undefined,
                className: (0, $hekY6.default)([
                    $f5df9bde6b3e6461$var$unboundedStyles.copyButtonWrapper
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                    ...tooltipProps,
                    appearance: "subtle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))),
                    isTooltipDisabled: true,
                    label: copied ? "Link copied" : "Copy link",
                    onClick: handleCopy,
                    spacing: "compact",
                    testId: testId && `${testId}--copy-link`
                })
            });
        $[29] = copied;
        $[30] = handleCopy;
        $[31] = testId;
        $[32] = t15;
    } else t15 = $[32];
    let t16;
    if ($[33] !== t14 || $[34] !== t15) {
        t16 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            content: t14,
            position: "bottom",
            children: t15
        });
        $[33] = t14;
        $[34] = t15;
        $[35] = t16;
    } else t16 = $[35];
    const copyButton = t16;
    let t17;
    let t18;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = (0, $hekY6.default)([
            $f5df9bde6b3e6461$var$unboundedStyles.itemWrapper
        ]);
        t18 = (0, $hekY6.default)([
            $f5df9bde6b3e6461$var$unboundedStyles.container
        ]);
        $[36] = t17;
        $[37] = t18;
    } else {
        t17 = $[36];
        t18 = $[37];
    }
    let t19;
    if ($[38] !== iconElement) {
        t19 = (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && iconElement;
        $[38] = iconElement;
        $[39] = t19;
    } else t19 = $[39];
    let t20;
    if ($[40] !== onTooltipShown || $[41] !== renderLink || $[42] !== shouldShowTooltip || $[43] !== text) {
        t20 = shouldShowTooltip ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown,
            children: renderLink
        }) : renderLink();
        $[40] = onTooltipShown;
        $[41] = renderLink;
        $[42] = shouldShowTooltip;
        $[43] = text;
        $[44] = t20;
    } else t20 = $[44];
    let t21;
    if ($[45] !== copyButton || $[46] !== t19 || $[47] !== t20) {
        t21 = /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
            className: t18,
            children: [
                t19,
                t20,
                copyButton
            ]
        });
        $[45] = copyButton;
        $[46] = t19;
        $[47] = t20;
        $[48] = t21;
    } else t21 = $[48];
    let t22;
    if ($[49] !== _overflowRef || $[50] !== t21) {
        t22 = /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
            ref: _overflowRef,
            "data-breadcrumbs-current-item": true,
            className: t17,
            children: t21
        });
        $[49] = _overflowRef;
        $[50] = t21;
        $[51] = t22;
    } else t22 = $[51];
    return t22;
} : ({ text: text, href: href, onClick: onClick, target: target, analyticsContext: analyticsContext, elemBefore: elemBefore, iconBefore: iconBefore, truncationWidth: truncationWidth, testId: testId, onCopyLink: onCopyLink, onTooltipShown: onTooltipShown, _overflowRef: _overflowRef })=>{
    const isSmall = (0, $jiltW.useBreadcrumbsSize)() === 'small';
    const handleClick = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onClick ?? (0, $dpsRj.default),
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$f5df9bde6b3e6461$var$analyticsAttributes
    });
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const [copied, setCopied] = (0, $cozmU.useState)(false);
    const [linkElement, setLinkElement] = (0, $cozmU.useState)(null);
    const resetTimerRef = (0, $cozmU.useRef)(null);
    const setLinkRef = (0, $cozmU.useCallback)((element)=>{
        setLinkElement(element);
    }, []);
    const [, shouldShowTooltip] = (0, $8C5a3.default)(truncationWidth, linkElement, (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') ? 0 : resolvedElemBefore ? $f5df9bde6b3e6461$var$ICON_WIDTH_ESTIMATE : 0);
    const handleCopy = (0, $cozmU.useCallback)(()=>{
        if (!navigator.clipboard) return;
        const url = new URL(href, window.location.href).href;
        navigator.clipboard.writeText(url).then(()=>{
            setCopied(true);
            onCopyLink?.();
            if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
            resetTimerRef.current = setTimeout(()=>{
                setCopied(false);
            }, $f5df9bde6b3e6461$var$COPY_RESET_DELAY_MS);
        }, (0, $dpsRj.default));
    }, [
        href,
        onCopyLink
    ]);
    (0, $cozmU.useEffect)(()=>()=>{
            if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
        }, []);
    const iconElement = resolvedElemBefore && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": testId && `${testId}--icon-before`,
        className: (0, $hekY6.default)([
            $f5df9bde6b3e6461$var$styles.iconWrapper,
            $f5df9bde6b3e6461$var$unboundedStyles.iconWrapper,
            (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && $f5df9bde6b3e6461$var$styles.iconWrapperExternal,
            isSmall && $f5df9bde6b3e6461$var$styles.iconWrapperExternalSmall,
            isSmall && $f5df9bde6b3e6461$var$unboundedStyles.iconWrapperSmall
        ]),
        children: resolvedElemBefore
    });
    const textElement = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        className: (0, $hekY6.default)([
            isSmall && $f5df9bde6b3e6461$var$styles.textSmall,
            !isSmall && $f5df9bde6b3e6461$var$styles.text,
            truncationWidth && $f5df9bde6b3e6461$var$styles.textWithTruncation
        ]),
        children: text
    });
    const renderLink = (triggerProps)=>{
        const tooltipRef = triggerProps?.ref;
        const handleTriggerClick = (event)=>{
            triggerProps?.onClick?.(event);
            handleClick(event);
        };
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor), {
            href: href,
            target: target,
            rel: target === '_blank' ? 'noopener noreferrer' : undefined,
            "aria-current": "page",
            onClick: handleTriggerClick,
            onMouseOver: triggerProps?.onMouseOver,
            onMouseOut: triggerProps?.onMouseOut,
            onMouseMove: triggerProps?.onMouseMove,
            onMouseDown: triggerProps?.onMouseDown,
            onFocus: triggerProps?.onFocus,
            onBlur: triggerProps?.onBlur,
            "aria-describedby": triggerProps?.['aria-describedby'],
            testId: testId,
            ref: tooltipRef ? (0, $lmzCg.default)([
                setLinkRef,
                tooltipRef
            ]) : setLinkRef,
            xcss: // @ts-ignore -- Expression produces a union type that is too complex to represent. This matches existing `@atlaskit/primitives` handling for complex `xcss={cx(...)}` composition.
            (0, $w6R6I.cx)($f5df9bde6b3e6461$var$styles.interactiveContainer, !(0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && $f5df9bde6b3e6461$var$styles.interactiveContainerLegacy, isSmall && $f5df9bde6b3e6461$var$styles.interactiveContainerSmall, truncationWidth != null && $f5df9bde6b3e6461$var$styles.interactiveContainerWithTruncation, (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') && $f5df9bde6b3e6461$var$styles.interactiveContainerMotion),
            style: {
                maxWidth: truncationWidth
            },
            children: [
                !(0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && iconElement,
                textElement
            ]
        });
    };
    const copyButton = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
        content: copied ? 'Copied!' : 'Copy link',
        position: "bottom",
        children: (tooltipProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                "data-breadcrumbs-copy-link": true,
                "data-copied": copied || undefined,
                className: (0, $hekY6.default)([
                    $f5df9bde6b3e6461$var$unboundedStyles.copyButtonWrapper
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                    ...tooltipProps,
                    appearance: "subtle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))),
                    isTooltipDisabled: true,
                    label: copied ? 'Link copied' : 'Copy link',
                    onClick: handleCopy,
                    spacing: "compact",
                    testId: testId && `${testId}--copy-link`
                })
            })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
        ref: _overflowRef,
        "data-breadcrumbs-current-item": true,
        className: (0, $hekY6.default)([
            $f5df9bde6b3e6461$var$unboundedStyles.itemWrapper
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
            className: (0, $hekY6.default)([
                $f5df9bde6b3e6461$var$unboundedStyles.container
            ]),
            children: [
                (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && iconElement,
                shouldShowTooltip ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                    content: text,
                    position: "bottom",
                    onShow: onTooltipShown,
                    children: renderLink
                }) : renderLink(),
                copyButton
            ]
        })
    });
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $f5df9bde6b3e6461$export$2e2bcd8739ae039 = $f5df9bde6b3e6461$var$BreadcrumbsCurrentItem;
module.exports["default"] = $f5df9bde6b3e6461$export$2e2bcd8739ae039;

});

parcelRegister("jiltW", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $gaEqB = parcelRequire("gaEqB");

const $b33aea80784c088a$export$c60a2bbc99661fa2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useBreadcrumbsSize() {
    return (0, $cozmU.useContext)((0, $gaEqB.default));
} : function useBreadcrumbsSize() {
    return (0, $cozmU.useContext)((0, $gaEqB.default));
};
module.exports["useBreadcrumbsSize"] = $b33aea80784c088a$export$c60a2bbc99661fa2;

});

parcelRegister("gaEqB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

/**
 * Shared breadcrumbs size context for the primitives API and refreshed composed breadcrumbs.
 */ const $3def2b1530e0149b$var$BreadcrumbsSizeContext = /*#__PURE__*/ (0, $cozmU.createContext)('medium');
var $3def2b1530e0149b$export$2e2bcd8739ae039 = $3def2b1530e0149b$var$BreadcrumbsSizeContext;
module.exports["default"] = $3def2b1530e0149b$export$2e2bcd8739ae039;

});

parcelRegister("8C5a3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

// eslint-disable-next-line @repo/internal/react/require-jsdoc
const $3ef1c5a5d4771e71$var$useOverflowable = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useOverflowable(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
    const $ = (0, $bDgLe.c)(9);
    const shouldCheckWidth = truncationWidth && buttonRefCurrent;
    const [hasOverflow, setOverflow] = (0, $cozmU.useState)(Boolean(shouldCheckWidth));
    const [showTooltip, setShowTooltip] = (0, $cozmU.useState)(false);
    let t0;
    let t1;
    if ($[0] !== buttonRefCurrent || $[1] !== iconWidthAllowance || $[2] !== shouldCheckWidth || $[3] !== truncationWidth) {
        t0 = ()=>{
            if (shouldCheckWidth) {
                const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
                const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
                setOverflow(shouldOverflow);
                setShowTooltip(shouldShowTooltip);
            } else {
                setOverflow(false);
                setShowTooltip(false);
            }
        };
        t1 = [
            truncationWidth,
            buttonRefCurrent,
            iconWidthAllowance,
            shouldCheckWidth
        ];
        $[0] = buttonRefCurrent;
        $[1] = iconWidthAllowance;
        $[2] = shouldCheckWidth;
        $[3] = truncationWidth;
        $[4] = t0;
        $[5] = t1;
    } else {
        t0 = $[4];
        t1 = $[5];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[6] !== hasOverflow || $[7] !== showTooltip) {
        t2 = [
            hasOverflow,
            showTooltip
        ];
        $[6] = hasOverflow;
        $[7] = showTooltip;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : function useOverflowable(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
    const shouldCheckWidth = truncationWidth && buttonRefCurrent;
    // Default to true to match hasOverflow = true default in Step component.
    // This should ensure the icon never appears and then quickly disappears
    const [hasOverflow, setOverflow] = (0, $cozmU.useState)(Boolean(shouldCheckWidth));
    const [showTooltip, setShowTooltip] = (0, $cozmU.useState)(false);
    // Need to recalculate on every render cycle as text/icons/width changing will change the outcome
    (0, $cozmU.useEffect)(()=>{
        if (shouldCheckWidth) {
            // Calculate if the button width will be larger than the truncation width after allowing for icon widths.
            // The button having a width greater than the truncationWidth, with icons, indicates the icons should be hidden to avoid going over the width limit
            const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
            // The button width can already be equal to the truncationWidth which is an indicator that truncation is occurring and a tooltip should be displayed
            const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
            setOverflow(shouldOverflow);
            setShowTooltip(shouldShowTooltip);
        } else {
            setOverflow(false);
            setShowTooltip(false);
        }
    }, [
        truncationWidth,
        buttonRefCurrent,
        iconWidthAllowance,
        shouldCheckWidth
    ]);
    return [
        hasOverflow,
        showTooltip
    ];
};
var $3ef1c5a5d4771e71$export$2e2bcd8739ae039 = $3ef1c5a5d4771e71$var$useOverflowable;
module.exports["default"] = $3ef1c5a5d4771e71$export$2e2bcd8739ae039;

});

parcelRegister("iCvWJ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $w6R6I = parcelRequire("w6R6I");


var $dpsRj = parcelRequire("dpsRj");


var $iDrrr = parcelRequire("iDrrr");


var $hBYtq = parcelRequire("hBYtq");


var $jiltW = parcelRequire("jiltW");

const $839a3575228e0db7$var$noop = (0, $dpsRj.default);
const $839a3575228e0db7$var$itemWrapperStyles = null;
const $839a3575228e0db7$var$styles = {
    root: "_2sNsIgmnOE _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _30huDKYbGa _2mHwu81Y8M _0bjKvDKxmn _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _0KLXru66of _1UtDYzKGUX _3iDTPbccYA _0hPCNLDIqT _4xdlr0DIqT _43nrzTPgdg _32C2rk98eZ _0i9AWAYbGa _0mm6KQ6wH8 _10n1R5KGUX _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMKGUX _0CMRbky7kJ",
    rootSmall: "_2sNsIg7NXe",
    interactiveMotion: "_23rrnHo10F _3xtjKN0Rl6 _00uqCYjOvk _1B4rbIo10F _0DCa9DKGUX _3sFUREDdj4 _3WzCGiy7kJ"
};
const $839a3575228e0db7$var$EllipsisItem = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { label: label, onClick: t1, testId: testId } = t0;
    const onClick = t1 === undefined ? $839a3575228e0db7$var$noop : t1;
    const breadcrumbsSize = (0, $jiltW.useBreadcrumbsSize)();
    const isSmall = breadcrumbsSize === "small";
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _24h04i2Njc _1EqgXlN91d _0jFU0V49iP _0aFT5v1qpb _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg _0n7g92FQfX _3DgaZ22ADO _3hLXwc2ADO _1Xuk08dnbC _2jLjk7KGUX _2IsVYLfzt3 _2YiD5UDIqT"
        ]);
        $[0] = t2;
    } else t2 = $[0];
    const t3 = isSmall && $839a3575228e0db7$var$styles.rootSmall;
    let t4;
    if ($[1] !== t3) {
        t4 = (0, $w6R6I.cx)($839a3575228e0db7$var$styles.root, t3, (0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") && $839a3575228e0db7$var$styles.interactiveMotion);
        $[1] = t3;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== label || $[4] !== onClick || $[5] !== t4 || $[6] !== testId) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
            className: t2,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                "aria-label": label,
                onClick: onClick,
                xcss: t4,
                testId: testId,
                children: "\u2026"
            })
        });
        $[3] = label;
        $[4] = onClick;
        $[5] = t4;
        $[6] = testId;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
} : ({ label: label, onClick: onClick = $839a3575228e0db7$var$noop, testId: testId })=>{
    const breadcrumbsSize = (0, $jiltW.useBreadcrumbsSize)();
    const isSmall = breadcrumbsSize === 'small';
    return /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _24h04i2Njc _1EqgXlN91d _0jFU0V49iP _0aFT5v1qpb _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg _0n7g92FQfX _3DgaZ22ADO _3hLXwc2ADO _1Xuk08dnbC _2jLjk7KGUX _2IsVYLfzt3 _2YiD5UDIqT"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
            "aria-label": label,
            onClick: onClick,
            xcss: (0, $w6R6I.cx)($839a3575228e0db7$var$styles.root, isSmall && $839a3575228e0db7$var$styles.rootSmall, (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') && $839a3575228e0db7$var$styles.interactiveMotion),
            testId: testId,
            children: "\u2026"
        })
    });
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $839a3575228e0db7$export$2e2bcd8739ae039 = $839a3575228e0db7$var$EllipsisItem;
module.exports["default"] = $839a3575228e0db7$export$2e2bcd8739ae039;

});

parcelRegister("fPRWc", function(module, exports) {

var $gaEqB = parcelRequire("gaEqB");

const $23e2c6453ef39b0a$export$2295e777093f3940 = (0, $gaEqB.default).Provider;
module.exports["BreadcrumbsSizeProvider"] = $23e2c6453ef39b0a$export$2295e777093f3940;

});

parcelRegister("2OKnq", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $1sCHt = parcelRequire("1sCHt");


var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $6TaGl = parcelRequire("6TaGl");

const $ec7a344b5ea2223d$var$groupWrapperStyles = null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $ec7a344b5ea2223d$var$EllipsisPopup = (0, $gtMdU.isReactCompilerActivePlatform)() ? function EllipsisPopup(t0) {
    const $ = (0, $bDgLe.c)(12);
    const { collapsedItems: collapsedItems, label: label, onClick: onClick, testId: testId } = t0;
    let t1;
    if ($[0] !== label || $[1] !== onClick || $[2] !== testId) {
        t1 = (t2)=>{
            const { triggerRef: triggerRef, isSelected: isSelected, testId: _triggerTestId, ...triggerProps } = t2;
            const handleClick = (event)=>{
                triggerProps.onClick?.(event);
                onClick?.(event);
            };
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                ...triggerProps,
                ref: triggerRef,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                label: label,
                isSelected: isSelected,
                appearance: "subtle",
                spacing: "compact",
                isTooltipDisabled: true,
                onClick: handleClick,
                testId: testId
            });
        };
        $[0] = label;
        $[1] = onClick;
        $[2] = testId;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_1EqgXlOm3a"
        ]);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== collapsedItems) {
        t3 = collapsedItems.map($ec7a344b5ea2223d$var$_temp);
        $[5] = collapsedItems;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: t2,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9erVg.default), {
                children: t3
            })
        });
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t1 || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3vgx3.default), {
            trigger: t1,
            placement: "bottom-start",
            children: t4
        });
        $[9] = t1;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : function EllipsisPopup({ collapsedItems: collapsedItems, label: label, onClick: onClick, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3vgx3.default), {
        trigger: ({ triggerRef: triggerRef, isSelected: isSelected, testId: _triggerTestId, ...triggerProps })=>{
            const handleClick = (event)=>{
                triggerProps.onClick?.(event);
                onClick?.(event);
            };
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                ...triggerProps,
                ref: triggerRef,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                label: label,
                isSelected: isSelected,
                appearance: "subtle",
                spacing: "compact",
                isTooltipDisabled: true,
                onClick: handleClick,
                testId: testId
            });
        },
        placement: "bottom-start",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: (0, $hekY6.default)([
                "_1EqgXlOm3a"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9erVg.default), {
                children: collapsedItems.map((item, i)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default), {
                        href: item.href,
                        target: item.target,
                        onClick: item.onClick,
                        children: item.text
                    }, i))
            })
        })
    });
};
var $ec7a344b5ea2223d$export$2e2bcd8739ae039 = $ec7a344b5ea2223d$var$EllipsisPopup;
function $ec7a344b5ea2223d$var$_temp(item, i) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default), {
        href: item.href,
        target: item.target,
        onClick: item.onClick,
        children: item.text
    }, i);
}
module.exports["default"] = $ec7a344b5ea2223d$export$2e2bcd8739ae039;

});

parcelRegister("3vgx3", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $ad7Ou = parcelRequire("ad7Ou");


var $fM984 = parcelRequire("fM984");


var $lmzCg = parcelRequire("lmzCg");


var $dpsRj = parcelRequire("dpsRj");


var $5Dlqn = parcelRequire("5Dlqn");


var $aRyr7 = parcelRequire("aRyr7");


var $7sJoX = parcelRequire("7sJoX");


var $4CEP6 = parcelRequire("4CEP6");


var $iDrrr = parcelRequire("iDrrr");


var $4n1IT = parcelRequire("4n1IT");


var $jp2Q3 = parcelRequire("jp2Q3");


var $eLJVM = parcelRequire("eLJVM");


var $iv7mf = parcelRequire("iv7mf");


var $94Dr9 = parcelRequire("94Dr9");


var $ggC1G = parcelRequire("ggC1G");


var $imIsb = parcelRequire("imIsb");


var $eEek6 = parcelRequire("eEek6");

const $53393d8413cfd6c9$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $53393d8413cfd6c9$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $53393d8413cfd6c9$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$53393d8413cfd6c9$var$opposites[crossAxis]}`,
            `${$53393d8413cfd6c9$var$opposites[mainAxis]}-${crossAxis}`,
            `${$53393d8413cfd6c9$var$opposites[mainAxis]}`,
            `${$53393d8413cfd6c9$var$opposites[mainAxis]}-${$53393d8413cfd6c9$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$53393d8413cfd6c9$var$opposites[mainAxis]}`,
        `${$53393d8413cfd6c9$var$opposites[mainAxis]}-start`,
        `${$53393d8413cfd6c9$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
function $53393d8413cfd6c9$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * Legacy Popper/Popup implementation (hooks run unconditionally when this component mounts).
 */ const $53393d8413cfd6c9$var$DropdownMenuLegacy = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DropdownMenuLegacy(t0) {
    const $ = (0, $bDgLe.c)(63);
    const { autoFocus: t1, children: children, defaultOpen: t2, isLoading: t3, isOpen: isOpen, onOpenChange: t4, placement: t5, shouldFitContainer: t6, shouldFlip: t7, shouldRenderToParent: t8, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: t9, label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel, shouldPreventEscapePropagation: t10, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent } = t0;
    const autoFocus = t1 === undefined ? false : t1;
    const defaultOpen = t2 === undefined ? false : t2;
    const isLoading = t3 === undefined ? false : t3;
    const onOpenChange = t4 === undefined ? (0, $dpsRj.default) : t4;
    const placement = t5 === undefined ? "bottom-start" : t5;
    const shouldFitContainer = t6 === undefined ? false : t6;
    const shouldFlip = t7 === undefined ? true : t7;
    const shouldRenderToParent = t8 === undefined ? false : t8;
    let t11;
    if ($[0] !== t9) {
        t11 = t9 === undefined ? (0, $jp2Q3.layers).modal() : t9;
        $[0] = t9;
        $[1] = t11;
    } else t11 = $[1];
    const zIndex = t11;
    const shouldPreventEscapePropagation = t10 === undefined ? false : t10;
    let t12;
    if ($[2] !== defaultOpen) {
        t12 = ()=>defaultOpen;
        $[2] = defaultOpen;
        $[3] = t12;
    } else t12 = $[3];
    const [isLocalOpen, setLocalIsOpen] = (0, $5Dlqn.default)(isOpen, t12);
    const triggerRef = (0, $cozmU.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $cozmU.useState)(false);
    const id = (0, $eEek6.default)();
    const itemRef = (0, $imIsb.default)();
    const { currentLevel: currentLevel } = (0, $4CEP6.useLayering)();
    let t13;
    if ($[4] !== placement) {
        t13 = $53393d8413cfd6c9$var$getFallbackPlacements(placement);
        $[4] = placement;
        $[5] = t13;
    } else t13 = $[5];
    const fallbackPlacements = t13;
    let t14;
    if ($[6] !== isLocalOpen || $[7] !== itemRef || $[8] !== onOpenChange || $[9] !== setLocalIsOpen) {
        t14 = (event)=>{
            const newValue = !isLocalOpen;
            const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
            if (type === "keydown") setTriggeredUsingKeyboard(true);
            else {
                if (clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
                else if (detail === 0) setTriggeredUsingKeyboard(true);
                else {
                    itemRef?.current?.focus();
                    setTriggeredUsingKeyboard(false);
                }
            }
            setLocalIsOpen(newValue);
            onOpenChange({
                isOpen: newValue,
                event: event
            });
        };
        $[6] = isLocalOpen;
        $[7] = itemRef;
        $[8] = onOpenChange;
        $[9] = setLocalIsOpen;
        $[10] = t14;
    } else t14 = $[10];
    const handleTriggerClicked = t14;
    let t15;
    if ($[11] !== itemRef || $[12] !== onOpenChange || $[13] !== returnFocusRef || $[14] !== setLocalIsOpen || $[15] !== shouldPreventEscapePropagation) {
        t15 = (event_0, currentLevel_0)=>{
            const isTabLeftOrEscapeKey = $53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === "Tab" || event_0.key === "Escape" || event_0.key === (0, $fM984.KEY_LEFT));
            if (shouldPreventEscapePropagation && $53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === "Escape" || event_0.key === (0, $fM984.KEY_LEFT))) event_0.stopPropagation();
            if (event_0 !== null && !isTabLeftOrEscapeKey && event_0.target instanceof HTMLElement && event_0.target.closest?.((0, $iDrrr.fg)("platform_dst-a11y_modal-trigger-haspopup") ? `[id^=${0, $eEek6.PREFIX}] [aria-haspopup="menu"], [id^=${0, $eEek6.PREFIX}] [aria-haspopup="true"]` : `[id^=${0, $eEek6.PREFIX}] [aria-haspopup]`)) {
                if (!currentLevel_0) return;
                const toCloseLevel = itemRef.current?.dataset["ds-Level"];
                if (toCloseLevel && Number(toCloseLevel) < currentLevel_0) return;
            }
            if (returnFocusRef) requestAnimationFrame(()=>{
                returnFocusRef.current?.focus();
            });
            else {
                if ($53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === "Tab" && event_0.shiftKey || event_0.key === "Escape" || event_0.key === (0, $fM984.KEY_LEFT))) requestAnimationFrame(()=>{
                    itemRef.current?.focus();
                });
                else if (triggerRef.current) {
                    const isClickOutsideMenu = event_0?.target instanceof HTMLElement && event_0.target.closest?.("[role=\"menu\"]") === null;
                    const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body;
                    if (!shouldPreventFocus) requestAnimationFrame(()=>{
                        triggerRef.current?.focus();
                    });
                }
            }
            setLocalIsOpen(false);
            onOpenChange({
                isOpen: false,
                event: event_0
            });
        };
        $[11] = itemRef;
        $[12] = onOpenChange;
        $[13] = returnFocusRef;
        $[14] = setLocalIsOpen;
        $[15] = shouldPreventEscapePropagation;
        $[16] = t15;
    } else t15 = $[16];
    const handleOnClose = t15;
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $aRyr7.default)();
    let t16;
    let t17;
    if ($[17] !== handleOnClose || $[18] !== handleTriggerClicked || $[19] !== isFocused || $[20] !== isLocalOpen) {
        t16 = ()=>{
            if (!isFocused) return 0, $dpsRj.default;
            if (isLocalOpen) return 0, $dpsRj.default;
            return (0, $cbY7C.bind)(window, {
                type: "keydown",
                listener: function openOnKeyDown(e) {
                    let isNestedTriggerButton;
                    if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest((0, $iDrrr.fg)("platform_dst-a11y_modal-trigger-haspopup") ? `[id^=${0, $eEek6.PREFIX}] [aria-haspopup="menu"], [id^=${0, $eEek6.PREFIX}] [aria-haspopup="true"]` : `[id^=${0, $eEek6.PREFIX}] [aria-haspopup]`);
                    if (e.key === (0, $fM984.KEY_DOWN) && !isNestedTriggerButton) {
                        e.preventDefault();
                        handleTriggerClicked(e);
                    } else {
                        if ((e.code === (0, $fM984.KEY_SPACE) || e.key === (0, $fM984.KEY_ENTER)) && e.detail === 0) setTriggeredUsingKeyboard(true);
                        else if (e.key === (0, $fM984.KEY_TAB) && isNestedTriggerButton) handleOnClose(e);
                    }
                }
            });
        };
        t17 = [
            isFocused,
            isLocalOpen,
            handleTriggerClicked,
            handleOnClose
        ];
        $[17] = handleOnClose;
        $[18] = handleTriggerClicked;
        $[19] = isFocused;
        $[20] = isLocalOpen;
        $[21] = t16;
        $[22] = t17;
    } else {
        t16 = $[21];
        t17 = $[22];
    }
    (0, $cozmU.useEffect)(t16, t17);
    let t18;
    if ($[23] !== shouldFitContainer || $[24] !== shouldRenderToParent || $[25] !== strategy) {
        t18 = shouldFitContainer ? {
            shouldFitContainer: shouldFitContainer,
            strategy: strategy !== "fixed" ? strategy : undefined
        } : {
            shouldRenderToParent: shouldRenderToParent,
            strategy: strategy
        };
        $[23] = shouldFitContainer;
        $[24] = shouldRenderToParent;
        $[25] = strategy;
        $[26] = t18;
    } else t18 = $[26];
    const conditionalProps = t18;
    const t19 = isLocalOpen ? id : undefined;
    const t20 = returnFocusRef === undefined;
    const t21 = shouldRenderToParent && currentLevel > 0 ? "group" : undefined;
    const t22 = testId && `${testId}--content`;
    let t23;
    if ($[27] !== bindFocus || $[28] !== handleTriggerClicked || $[29] !== interactionName || $[30] !== isLocalOpen || $[31] !== itemRef || $[32] !== label || $[33] !== testId || $[34] !== trigger) {
        t23 = (t24)=>{
            const { ref: ref, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, ...rest } = t24;
            if (typeof trigger === "function") return trigger({
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $lmzCg.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                ...bindFocus,
                ref: (0, $lmzCg.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: $53393d8413cfd6c9$var$_temp,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label,
                interactionName: interactionName,
                children: trigger
            });
        };
        $[27] = bindFocus;
        $[28] = handleTriggerClicked;
        $[29] = interactionName;
        $[30] = isLocalOpen;
        $[31] = itemRef;
        $[32] = label;
        $[33] = testId;
        $[34] = trigger;
        $[35] = t23;
    } else t23 = $[35];
    let t24;
    if ($[36] !== autoFocus || $[37] !== children || $[38] !== handleOnClose || $[39] !== isLoading || $[40] !== isTriggeredUsingKeyboard || $[41] !== menuLabel || $[42] !== shouldFitContainer || $[43] !== shouldRenderToParent || $[44] !== spacing || $[45] !== statusLabel || $[46] !== testId) {
        t24 = (t25)=>{
            const { setInitialFocusRef: setInitialFocusRef, update: update } = t25;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iv7mf.default), {
                onClose: handleOnClose,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $94Dr9.default), {
                    spacing: spacing,
                    maxHeight: $53393d8413cfd6c9$var$MAX_HEIGHT,
                    maxWidth: shouldFitContainer ? undefined : 800,
                    onClose: handleOnClose,
                    onUpdate: update,
                    isLoading: isLoading,
                    statusLabel: statusLabel,
                    setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                    shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                    isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                    autoFocus: autoFocus,
                    testId: testId && `${testId}--menu-wrapper`,
                    menuLabel: menuLabel,
                    children: children
                })
            });
        };
        $[36] = autoFocus;
        $[37] = children;
        $[38] = handleOnClose;
        $[39] = isLoading;
        $[40] = isTriggeredUsingKeyboard;
        $[41] = menuLabel;
        $[42] = shouldFitContainer;
        $[43] = shouldRenderToParent;
        $[44] = spacing;
        $[45] = statusLabel;
        $[46] = testId;
        $[47] = t24;
    } else t24 = $[47];
    let t25;
    if ($[48] !== conditionalProps || $[49] !== fallbackPlacements || $[50] !== handleOnClose || $[51] !== isLocalOpen || $[52] !== placement || $[53] !== shouldFlip || $[54] !== shouldIgnoreCloseEvent || $[55] !== t19 || $[56] !== t20 || $[57] !== t21 || $[58] !== t22 || $[59] !== t23 || $[60] !== t24 || $[61] !== zIndex) {
        t25 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ggC1G.default), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4n1IT.Popup), {
                id: t19,
                shouldFlip: shouldFlip,
                isOpen: isLocalOpen,
                shouldReturnFocus: t20,
                onClose: handleOnClose,
                zIndex: zIndex,
                placement: placement,
                role: t21,
                fallbackPlacements: fallbackPlacements,
                testId: t22,
                shouldUseCaptureOnOutsideClick: true,
                shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
                ...conditionalProps,
                shouldDisableFocusLock: true,
                trigger: t23,
                content: t24
            })
        });
        $[48] = conditionalProps;
        $[49] = fallbackPlacements;
        $[50] = handleOnClose;
        $[51] = isLocalOpen;
        $[52] = placement;
        $[53] = shouldFlip;
        $[54] = shouldIgnoreCloseEvent;
        $[55] = t19;
        $[56] = t20;
        $[57] = t21;
        $[58] = t22;
        $[59] = t23;
        $[60] = t24;
        $[61] = zIndex;
        $[62] = t25;
    } else t25 = $[62];
    return t25;
} : function DropdownMenuLegacy({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $dpsRj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $jp2Q3.layers).modal(), label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel, shouldPreventEscapePropagation: shouldPreventEscapePropagation = false, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent }) {
    const [isLocalOpen, setLocalIsOpen] = (0, $5Dlqn.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $cozmU.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $cozmU.useState)(false);
    const id = (0, $eEek6.default)();
    const itemRef = (0, $imIsb.default)();
    const { currentLevel: currentLevel } = (0, $4CEP6.useLayering)();
    const fallbackPlacements = (0, $cozmU.useMemo)(()=>$53393d8413cfd6c9$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $cozmU.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    const handleOnClose = (0, $cozmU.useCallback)((event_0, currentLevel_0)=>{
        const isTabLeftOrEscapeKey = $53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === 'Tab' || event_0.key === 'Escape' || event_0.key === (0, $fM984.KEY_LEFT));
        // Stop propagation on ESCAPE or Left arrow if shouldPreventEscapePropagation is true
        if (shouldPreventEscapePropagation && $53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === 'Escape' || event_0.key === (0, $fM984.KEY_LEFT))) event_0.stopPropagation();
        if (event_0 !== null && !isTabLeftOrEscapeKey && event_0.target instanceof HTMLElement && event_0.target.closest?.((0, $iDrrr.fg)('platform_dst-a11y_modal-trigger-haspopup') ? `[id^=${0, $eEek6.PREFIX}] [aria-haspopup="menu"], [id^=${0, $eEek6.PREFIX}] [aria-haspopup="true"]` : `[id^=${0, $eEek6.PREFIX}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel_0) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel_0) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if ($53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === 'Tab' && event_0.shiftKey || event_0.key === 'Escape' || event_0.key === (0, $fM984.KEY_LEFT))) requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) {
            // Don't focus the trigger if the click was outside of the menu
            const isClickOutsideMenu = event_0?.target instanceof HTMLElement && event_0.target.closest?.('[role="menu"]') === null;
            const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(()=>{
                triggerRef.current?.focus();
            });
        }
        const newValue_0 = false;
        setLocalIsOpen(newValue_0);
        onOpenChange({
            isOpen: newValue_0,
            event: event_0
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen,
        shouldPreventEscapePropagation
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $aRyr7.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $cozmU.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $dpsRj.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $dpsRj.default;
        return (0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest((0, $iDrrr.fg)('platform_dst-a11y_modal-trigger-haspopup') ? `[id^=${0, $eEek6.PREFIX}] [aria-haspopup="menu"], [id^=${0, $eEek6.PREFIX}] [aria-haspopup="true"]` : `[id^=${0, $eEek6.PREFIX}] [aria-haspopup]`);
                if (e.key === (0, $fM984.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $fM984.KEY_SPACE) || e.key === (0, $fM984.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $fM984.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ggC1G.default), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4n1IT.Popup), {
            id: isLocalOpen ? id : undefined,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
            // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
            returnFocusRef === undefined,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            role: shouldRenderToParent && currentLevel > 0 ? 'group' : undefined,
            fallbackPlacements: fallbackPlacements,
            testId: testId && `${testId}--content`,
            shouldUseCaptureOnOutsideClick: true,
            shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
            ...conditionalProps,
            shouldDisableFocusLock: true,
            trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
            ...rest })=>{
                if (typeof trigger === 'function') return trigger({
                    'aria-controls': ariaControls,
                    'aria-expanded': ariaExpanded,
                    'aria-haspopup': ariaHasPopup,
                    ...rest,
                    ...bindFocus,
                    triggerRef: (0, $lmzCg.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    isSelected: isLocalOpen,
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`
                });
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                    ...bindFocus,
                    ref: (0, $lmzCg.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    "aria-controls": ariaControls,
                    "aria-expanded": ariaExpanded,
                    "aria-haspopup": ariaHasPopup,
                    isSelected: isLocalOpen,
                    iconAfter: (iconProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                            ...iconProps,
                            size: "small"
                        }),
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`,
                    "aria-label": label,
                    interactionName: interactionName,
                    children: trigger
                });
            },
            content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iv7mf.default), {
                    onClose: handleOnClose,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $94Dr9.default), {
                        spacing: spacing,
                        maxHeight: $53393d8413cfd6c9$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClose: handleOnClose,
                        onUpdate: update,
                        isLoading: isLoading,
                        statusLabel: statusLabel,
                        setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                        autoFocus: autoFocus,
                        testId: testId && `${testId}--menu-wrapper`,
                        menuLabel: menuLabel,
                        children: children
                    })
                })
        })
    });
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ function $53393d8413cfd6c9$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        ...iconProps,
        size: "small"
    });
}
const $53393d8413cfd6c9$var$DropdownMenu = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(19);
    const { autoFocus: t0, children: children, defaultOpen: t1, isLoading: t2, isOpen: isOpen, onOpenChange: t3, placement: t4, shouldFitContainer: t5, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel } = props;
    const autoFocus = t0 === undefined ? false : t0;
    const defaultOpen = t1 === undefined ? false : t1;
    const isLoading = t2 === undefined ? false : t2;
    const onOpenChange = t3 === undefined ? (0, $dpsRj.default) : t3;
    const placement = t4 === undefined ? "bottom-start" : t4;
    const shouldFitContainer = t5 === undefined ? false : t5;
    if ((0, $iDrrr.fg)("platform-dst-top-layer")) {
        let t6;
        if ($[0] !== autoFocus || $[1] !== children || $[2] !== defaultOpen || $[3] !== interactionName || $[4] !== isLoading || $[5] !== isOpen || $[6] !== label || $[7] !== menuLabel || $[8] !== onOpenChange || $[9] !== placement || $[10] !== returnFocusRef || $[11] !== shouldFitContainer || $[12] !== spacing || $[13] !== statusLabel || $[14] !== testId || $[15] !== trigger) {
            t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eLJVM.default), {
                autoFocus: autoFocus,
                children: children,
                defaultOpen: defaultOpen,
                isLoading: isLoading,
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                placement: placement,
                shouldFitContainer: shouldFitContainer,
                returnFocusRef: returnFocusRef,
                spacing: spacing,
                statusLabel: statusLabel,
                testId: testId,
                trigger: trigger,
                label: label,
                interactionName: interactionName,
                menuLabel: menuLabel
            });
            $[0] = autoFocus;
            $[1] = children;
            $[2] = defaultOpen;
            $[3] = interactionName;
            $[4] = isLoading;
            $[5] = isOpen;
            $[6] = label;
            $[7] = menuLabel;
            $[8] = onOpenChange;
            $[9] = placement;
            $[10] = returnFocusRef;
            $[11] = shouldFitContainer;
            $[12] = spacing;
            $[13] = statusLabel;
            $[14] = testId;
            $[15] = trigger;
            $[16] = t6;
        } else t6 = $[16];
        return t6;
    }
    let t6;
    if ($[17] !== props) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)($53393d8413cfd6c9$var$DropdownMenuLegacy, {
            ...props
        });
        $[17] = props;
        $[18] = t6;
    } else t6 = $[18];
    return t6;
} : (props)=>{
    const { autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $dpsRj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel } = props;
    if ((0, $iDrrr.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eLJVM.default), {
        autoFocus: autoFocus,
        children: children,
        defaultOpen: defaultOpen,
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        placement: placement,
        shouldFitContainer: shouldFitContainer,
        returnFocusRef: returnFocusRef,
        spacing: spacing,
        statusLabel: statusLabel,
        testId: testId,
        trigger: trigger,
        label: label,
        interactionName: interactionName,
        menuLabel: menuLabel
    });
    // Forward full public props to the legacy Popper/Popup implementation unchanged.
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props -- wrapper delegates entire DropdownMenuProps API
    return /*#__PURE__*/ (0, $8aG6j.jsx)($53393d8413cfd6c9$var$DropdownMenuLegacy, {
        ...props
    });
};
var $53393d8413cfd6c9$export$2e2bcd8739ae039 = $53393d8413cfd6c9$var$DropdownMenu;
module.exports["default"] = $53393d8413cfd6c9$export$2e2bcd8739ae039;

});

parcelRegister("5Dlqn", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a527e5bb9222c5e$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $4a527e5bb9222c5e$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $cozmU.useState)(getDefaultPropValue);
    const isControlledRef = (0, $cozmU.useRef)(isControlled);
    (0, $cozmU.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $cozmU.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("aRyr7", function(module, exports) {
$parcel$export(module.exports, "default", () => $09649a4f36a12f35$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $09649a4f36a12f35$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $cozmU.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $cozmU.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $cozmU.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("eLJVM", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $cbY7C = parcelRequire("cbY7C");


var $ad7Ou = parcelRequire("ad7Ou");


var $fM984 = parcelRequire("fM984");


var $dpsRj = parcelRequire("dpsRj");


var $5Dlqn = parcelRequire("5Dlqn");


var $aRyr7 = parcelRequire("aRyr7");


var $7sJoX = parcelRequire("7sJoX");


var $6IL1T = parcelRequire("6IL1T");


var $iDrrr = parcelRequire("iDrrr");


var $lfoFx = parcelRequire("lfoFx");


var $lBMxH = parcelRequire("lBMxH");


var $fb8lP = parcelRequire("fb8lP");


var $aRDbl = parcelRequire("aRDbl");


var $juXYb = parcelRequire("juXYb");


var $kVXS3 = parcelRequire("kVXS3");


var $dV1Zs = parcelRequire("dV1Zs");


var $iNWdN = parcelRequire("iNWdN");


var $1unCm = parcelRequire("1unCm");


var $ggC1G = parcelRequire("ggC1G");

const $f516bc94b8de2bc9$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $f516bc94b8de2bc9$var$styles = {
    spinnerContainer: "_3iDTPbQ4SZ _4ouGXIoaux _37wbyuDIqT _46hvQmkG2W _03SyCPkG2W _0xmtkokG2W _0LQT5EkG2W"
}; /**
    * Event types produced by trigger interactions.
    *
    * - `React.MouseEvent<Element>`: from the trigger's `onClick` handler
    * - `React.KeyboardEvent<Element>`: from the trigger's `onClick` when activated via keyboard
    * - `KeyboardEvent`: native event from the ArrowDown `bind(window, ...)` listener
    */ 
function $f516bc94b8de2bc9$var$getRootMenuPopover({ menu: menu }) {
    const parentMenu = menu.parentElement?.closest('[popover][role="menu"]');
    if (!parentMenu) return menu;
    return $f516bc94b8de2bc9$var$getRootMenuPopover({
        menu: parentMenu
    });
} /**
   * Loading indicator for the dropdown menu.
   */ 
const $f516bc94b8de2bc9$var$LoadingIndicator = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LoadingIndicator(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { statusLabel: t1, testId: testId } = t0;
    const statusLabel = t1 === undefined ? "Loading" : t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $f516bc94b8de2bc9$var$styles.spinnerContainer
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== statusLabel || $[2] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            role: "menuitem",
            className: t2,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
                size: "small",
                label: statusLabel,
                testId: testId
            })
        });
        $[1] = statusLabel;
        $[2] = testId;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : function LoadingIndicator({ statusLabel: statusLabel = 'Loading', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        role: "menuitem",
        className: (0, $hekY6.default)([
            $f516bc94b8de2bc9$var$styles.spinnerContainer
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    });
};
/**
 * Top-layer implementation of DropdownMenu.
 *
 * Replaces the legacy `@atlaskit/popup` + `@atlaskit/portal` + `@atlaskit/layering` pipeline
 * with the native Popover API via `@atlaskit/top-layer`.
 *
 * What is no longer needed:
 * - Portal: top layer handles stacking natively
 * - FocusLock / react-focus-lock: popover=auto provides light dismiss
 * - z-index: top layer is always above everything
 * - FocusManager (ref registration): replaced by DOM-query-based `useArrowNavigation`
 * - handle-focus.tsx: replaced by `useArrowNavigation`
 * - Layering context: top layer nesting is handled by the browser
 * - Fallback placements / Popper: CSS Anchor Positioning handles positioning
 */ function $f516bc94b8de2bc9$var$DropdownMenuTopLayer({ children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpenProp, onOpenChange: onOpenChange = (0, $dpsRj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel }) {
    const [isLocalOpen, setLocalIsOpen] = (0, $5Dlqn.default)(isOpenProp, ()=>defaultOpen);
    const triggerRef = (0, $cozmU.useRef)(null);
    const popoverRef = (0, $cozmU.useRef)(null);
    const popoverId = (0, $1unCm.usePopoverId)();
    const topLayerPlacement = (0, $cozmU.useMemo)(()=>(0, $aRDbl.fromLegacyPlacement)({
            legacy: placement
        }), [
        placement
    ]); // DropdownMenu has no `shouldFitViewport` equivalent, so neither axis ever
    // fits and `blockSize` stays `'content'` - `MenuGroup`'s `maxHeight` owns the
    // block axis.
    (0, $dV1Zs.useAnchoredPopover)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isLocalOpen,
        inlineSize: shouldFitContainer ? 'min-anchor' : 'content'
    }); // Close handling.
    // Focus restoration is handled natively by the Popover API:
    //   - Escape: browser restores focus to the trigger automatically
    //   - Click-outside: browser does NOT restore (correct behavior)
    //
    // The only custom focus handling needed is `returnFocusRef`: when provided,
    // we redirect focus to a different element than the trigger. We do this
    // in the onClose callback via rAF, which runs after the browser's native
    // restoration, effectively overriding it.
    const handleOnClose = (0, $cozmU.useCallback)(()=>{
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        setLocalIsOpen(false);
        onOpenChange({
            isOpen: false,
            event: null
        });
    }, [
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]); // Trigger click handling.
    const handleTriggerClicked = (0, $cozmU.useCallback)((event)=>{
        const nextIsOpen = !isLocalOpen;
        setLocalIsOpen(nextIsOpen); // Extract the native DOM event for onOpenChange
        const nativeEvent = 'nativeEvent' in event ? event.nativeEvent : event;
        onOpenChange({
            isOpen: nextIsOpen,
            event: nativeEvent
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $aRyr7.default)(); // When trigger is focused, open dropdown on ArrowDown (top-level only).
    // Per WAI-ARIA, ArrowDown opens a menu from a menubar/button trigger,
    // but inside a vertical submenu, ArrowDown navigates between siblings
    // and ArrowRight opens nested menus instead.
    (0, $cozmU.useEffect)(()=>{
        if (!isFocused || isLocalOpen) return;
         // Do not open on ArrowDown if this trigger is inside a parent menu.
        // Nested menus should only be opened via ArrowRight or Enter.
        const isNestedTrigger = Boolean(triggerRef.current?.closest('[role="menu"]'));
        return (0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $fM984.KEY_DOWN) && !isNestedTrigger) {
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked
    ]);
    const handleNestedOpen = (0, $cozmU.useCallback)(({ trigger: trigger_0 })=>{
        if ((0, $iDrrr.fg)('platform_dst-a11y_modal-trigger-haspopup') && !trigger_0.matches('[aria-haspopup="menu"], [aria-haspopup="true"]')) return;
        trigger_0.click();
    }, []);
    const handleTabClose = (0, $cozmU.useCallback)(()=>{
        const currentMenu = popoverRef.current;
        if (!currentMenu) return;
         // Hiding the root native popover synchronously closes its descendant popovers and restores
        // focus to the root trigger. The browser can then perform the Tab default action from there.
        $f516bc94b8de2bc9$var$getRootMenuPopover({
            menu: currentMenu
        }).hidePopover();
    }, []);
    (0, $iNWdN.useArrowNavigation)({
        containerRef: popoverRef,
        onClose: handleTabClose,
        onNestedOpen: handleNestedOpen,
        onNestedClose: handleOnClose,
        isEnabled: isLocalOpen,
        filter: (0, $fb8lP.isAtCurrentMenuLevel)
    }); // Close on menu item click.
    // Close when a regular menuitem is clicked, but not checkboxes/radios
    // and not nested submenu triggers.
    const handleMenuClick = (0, $cozmU.useCallback)((e_0)=>{
        if (!(e_0.target instanceof Element)) return;
        const menuItem = e_0.target.closest?.('[role="menuitem"], [role="menuitemcheckbox"], [role="menuitemradio"]');
        if (!menuItem) return;
        const isCheckboxOrRadio = menuItem.getAttribute('role') === 'menuitemcheckbox' || menuItem.getAttribute('role') === 'menuitemradio'; // With dialog semantics enabled, only menu/true popup values identify submenus.
        // The nested dropdown will handle its own open/close.
        const isNestedTrigger_0 = (0, $iDrrr.fg)('platform_dst-a11y_modal-trigger-haspopup') ? menuItem.matches('[aria-haspopup="menu"], [aria-haspopup="true"]') : menuItem.hasAttribute('aria-haspopup');
        if (!isCheckboxOrRadio && !isNestedTrigger_0) {
            setLocalIsOpen(false);
            onOpenChange({
                isOpen: false,
                event: e_0.nativeEvent
            });
        }
    }, [
        setLocalIsOpen,
        onOpenChange
    ]);
    const ariaAttributes = (0, $lBMxH.getAriaForTrigger)({
        // Intentionally fudging the type here to allow the fudged aria-haspopup cast below,
        // without having to use `as unknown as ...` which would lose even more type safety.
        role: 'menu',
        isOpen: isLocalOpen,
        popoverId: popoverId
    }); // FUDGE(top-layer-api): cast `aria-haspopup` to the narrow shape that adopter
    // public types expect. `@atlaskit/top-layer` types `aria-haspopup` as the wider
    // WAI-ARIA union, but the public `CustomTriggerProps` (extending `@atlaskit/popup`
    // `TriggerProps`) is intentionally kept narrow (`boolean | 'dialog'`) because the
    // top-layer API surface is not yet settled. The runtime value is unchanged; only
    // the TypeScript-visible type is narrowed at this boundary.
    const narrowAriaAttributes = ariaAttributes; /**
       * Custom trigger consumers historically receive a callback ref,
       * and their code assumes it is one.
       * Using this wrapper for compatibility...
       */ 
    const setTriggerRef = (0, $cozmU.useCallback)((node)=>{
        triggerRef.current = node;
    }, []);
    const renderTrigger = ()=>{
        if (typeof trigger === 'function') return trigger({
            ...narrowAriaAttributes,
            onFocus: bindFocus.onFocus,
            onBlur: bindFocus.onBlur,
            triggerRef: setTriggerRef,
            isSelected: isLocalOpen,
            onClick: handleTriggerClicked,
            testId: testId && `${testId}--trigger`
        });
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
            onFocus: bindFocus.onFocus,
            onBlur: bindFocus.onBlur,
            ref: setTriggerRef,
            ...narrowAriaAttributes,
            isSelected: isLocalOpen,
            iconAfter: (iconProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    ...iconProps,
                    size: "small"
                }),
            onClick: handleTriggerClicked,
            testId: testId && `${testId}--trigger`,
            "aria-label": label,
            interactionName: interactionName,
            children: trigger
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $ggC1G.default), {
        children: [
            renderTrigger(),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kVXS3.Popover), {
                ref: popoverRef,
                id: popoverId,
                role: "menu",
                label: menuLabel ?? label ?? (typeof trigger === 'string' ? trigger : 'Menu'),
                isOpen: isLocalOpen,
                onClose: handleOnClose,
                shouldAnimate: true,
                placement: topLayerPlacement,
                testId: testId && `${testId}--content`,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $juXYb.PopoverSurface), {
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6IL1T.default), {
                        maxHeight: $f516bc94b8de2bc9$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClick: handleMenuClick,
                        spacing: spacing,
                        testId: testId && `${testId}--menu-wrapper--menu-group`,
                        children: isLoading ? /*#__PURE__*/ (0, $8aG6j.jsx)($f516bc94b8de2bc9$var$LoadingIndicator, {
                            statusLabel: statusLabel,
                            testId: testId && `${testId}--menu-wrapper--loading-indicator`
                        }) : children
                    })
                })
            })
        ]
    });
}
var $f516bc94b8de2bc9$export$2e2bcd8739ae039 = $f516bc94b8de2bc9$var$DropdownMenuTopLayer;
module.exports["default"] = $f516bc94b8de2bc9$export$2e2bcd8739ae039;

});

parcelRegister("fb8lP", function(module, exports) {
const $6bfdddcadf7826ef$var$menuScope = '[role="menu"]';
/**
 * Recursively walks from `node` toward `container`, returning `true` when
 * `container` is reached without crossing another `role="menu"` ancestor.
 *
 * Used by `isAtCurrentMenuLevel` (pattern 2) to determine if the
 * `closestMenu` is owned by the wrapper container directly. Recursion
 * avoids a mutable `let parent` walk and keeps the function body linear.
 */ function $6bfdddcadf7826ef$var$reachesContainerWithoutNestedMenu(node, container) {
    if (!node || node === container) return node === container;
    if (node.getAttribute('role') === 'menu') return false;
    return $6bfdddcadf7826ef$var$reachesContainerWithoutNestedMenu(node.parentElement, container);
}
function $6bfdddcadf7826ef$export$f1bba0ef464d60af(element, container) {
    const closestMenu = element.closest($6bfdddcadf7826ef$var$menuScope);
    // Container itself has role="menu". Element belongs to this level
    // if its closest menu is the container.
    if (container.getAttribute('role') === 'menu') return closestMenu === container;
    // Container is a wrapper without role="menu" (e.g. dropdown-menu
    // wraps a MenuGroup). The element belongs to the top level if its
    // closest role="menu" ancestor is a direct child of the container,
    // i.e. there is no nested role="menu" between them.
    if (closestMenu === null) return true;
    // Walk up from the closest menu to see if it is "owned" by this
    // container without passing through another role="menu" first.
    return $6bfdddcadf7826ef$var$reachesContainerWithoutNestedMenu(closestMenu.parentElement, container);
}
module.exports["isAtCurrentMenuLevel"] = $6bfdddcadf7826ef$export$f1bba0ef464d60af;

});

parcelRegister("iNWdN", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $1hQ0e = parcelRequire("1hQ0e");


var $fM984 = parcelRequire("fM984");


var $3hJ5V = parcelRequire("3hJ5V");


var $7MWxP = parcelRequire("7MWxP");


var $jzRXW = parcelRequire("jzRXW");

const $341d868aa0ec42f2$var$menuScope = '[role="menu"]';
const $341d868aa0ec42f2$export$23dfbae28e0cc453 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useArrowNavigation(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { containerRef: containerRef, onClose: onClose, onNestedOpen: onNestedOpen, onNestedClose: onNestedClose, isEnabled: t1, filter: filter } = t0;
    const isEnabled = t1 === undefined ? true : t1;
    let t2;
    if ($[0] !== containerRef || $[1] !== filter || $[2] !== onClose || $[3] !== onNestedClose || $[4] !== onNestedOpen) {
        t2 = (event)=>{
            const container = containerRef.current;
            if (!container) return;
            const focused = (0, $1hQ0e.getDocument)()?.activeElement;
            if (focused instanceof HTMLElement) {
                if (filter) {
                    if (!filter(focused, container)) return;
                }
                if (!filter && container.getAttribute("role") === "menu" && focused.closest($341d868aa0ec42f2$var$menuScope) !== container) return;
            }
            if (event.key === (0, $fM984.KEY_DOWN)) {
                event.preventDefault();
                (0, $jzRXW.getNextFocusable)({
                    container: container,
                    direction: "forwards",
                    filter: filter
                })?.focus();
                return;
            }
            if (event.key === (0, $fM984.KEY_UP)) {
                event.preventDefault();
                (0, $jzRXW.getNextFocusable)({
                    container: container,
                    direction: "backwards",
                    filter: filter
                })?.focus();
                return;
            }
            if (event.key === (0, $fM984.KEY_HOME)) {
                event.preventDefault();
                (0, $3hJ5V.getFirstFocusable)({
                    container: container,
                    filter: filter
                })?.focus();
                return;
            }
            if (event.key === (0, $fM984.KEY_END)) {
                event.preventDefault();
                (0, $7MWxP.getLastFocusable)({
                    container: container,
                    filter: filter
                })?.focus();
                return;
            }
            if (event.key === (0, $fM984.KEY_TAB)) {
                onClose();
                return;
            }
            if (event.key === "ArrowRight") {
                if (onNestedOpen && focused instanceof HTMLElement && focused.hasAttribute("aria-haspopup")) {
                    event.preventDefault();
                    onNestedOpen({
                        trigger: focused
                    });
                }
                return;
            }
            if (event.key === "ArrowLeft") {
                if (onNestedClose) {
                    const isNested = container.parentElement?.closest($341d868aa0ec42f2$var$menuScope) !== null;
                    if (isNested) {
                        event.preventDefault();
                        onNestedClose();
                    }
                }
                return;
            }
        };
        $[0] = containerRef;
        $[1] = filter;
        $[2] = onClose;
        $[3] = onNestedClose;
        $[4] = onNestedOpen;
        $[5] = t2;
    } else t2 = $[5];
    const handleKeyDown = t2;
    let t3;
    let t4;
    if ($[6] !== containerRef || $[7] !== handleKeyDown || $[8] !== isEnabled) {
        t3 = ()=>{
            const container_0 = containerRef.current;
            if (!container_0 || !isEnabled) return;
            return (0, $cbY7C.bind)(container_0, {
                type: "keydown",
                listener: handleKeyDown
            });
        };
        t4 = [
            containerRef,
            handleKeyDown,
            isEnabled
        ];
        $[6] = containerRef;
        $[7] = handleKeyDown;
        $[8] = isEnabled;
        $[9] = t3;
        $[10] = t4;
    } else {
        t3 = $[9];
        t4 = $[10];
    }
    (0, $cozmU.useEffect)(t3, t4);
} : function useArrowNavigation({ containerRef: containerRef, onClose: onClose, onNestedOpen: onNestedOpen, onNestedClose: onNestedClose, isEnabled: isEnabled = true, filter: filter }) {
    const handleKeyDown = (0, $cozmU.useCallback)((event)=>{
        const container = containerRef.current;
        if (!container) return;
        // Guard: only handle the event if the currently focused element
        // belongs to this menu level. The focused element's closest
        // [role="menu"] must be this container (not a nested sub-menu).
        // When no filter is provided, fall back to the closest-menu check
        // if the container has role="menu".
        const focused = (0, $1hQ0e.getDocument)()?.activeElement;
        if (focused instanceof HTMLElement) {
            if (filter) {
                if (!filter(focused, container)) return;
            }
            if (!filter && container.getAttribute('role') === 'menu' && focused.closest($341d868aa0ec42f2$var$menuScope) !== container) return;
        }
        if (event.key === (0, $fM984.KEY_DOWN)) {
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (0, $jzRXW.getNextFocusable)({
                container: container,
                direction: 'forwards',
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $fM984.KEY_UP)) {
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (0, $jzRXW.getNextFocusable)({
                container: container,
                direction: 'backwards',
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $fM984.KEY_HOME)) {
            // Prevent browser default (e.g. scrolling to top of page).
            event.preventDefault();
            (0, $3hJ5V.getFirstFocusable)({
                container: container,
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $fM984.KEY_END)) {
            // Prevent browser default (e.g. scrolling to bottom of page).
            event.preventDefault();
            (0, $7MWxP.getLastFocusable)({
                container: container,
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $fM984.KEY_TAB)) {
            onClose();
            return;
        }
        // ── Nested menu navigation (WAI-ARIA menu pattern) ──
        // ArrowRight on a menuitem with aria-haspopup opens the submenu.
        if (event.key === 'ArrowRight') {
            if (onNestedOpen && focused instanceof HTMLElement && focused.hasAttribute('aria-haspopup')) {
                event.preventDefault();
                onNestedOpen({
                    trigger: focused
                });
            }
            return;
        }
        // ArrowLeft closes the current menu if it is nested inside a parent menu.
        if (event.key === 'ArrowLeft') {
            if (onNestedClose) {
                // Only close if this container is inside another role="menu"
                // (i.e. it is a submenu, not the top-level menu).
                // Walk up from the parent to avoid matching the container itself.
                const isNested = container.parentElement?.closest($341d868aa0ec42f2$var$menuScope) !== null;
                if (isNested) {
                    event.preventDefault();
                    onNestedClose();
                }
            }
            return;
        }
    }, [
        containerRef,
        onClose,
        onNestedOpen,
        onNestedClose,
        filter
    ]);
    (0, $cozmU.useEffect)(()=>{
        const container_0 = containerRef.current;
        if (!container_0 || !isEnabled) return;
        return (0, $cbY7C.bind)(container_0, {
            type: 'keydown',
            listener: handleKeyDown
        });
    }, [
        containerRef,
        handleKeyDown,
        isEnabled
    ]);
};
module.exports["useArrowNavigation"] = $341d868aa0ec42f2$export$23dfbae28e0cc453;

});

parcelRegister("ggC1G", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lOWpM = parcelRequire("lOWpM");

/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $885bea270958798f$var$SelectionStore = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = props;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {};
        $[0] = t0;
    } else t0 = $[0];
    const store = (0, $cozmU.useRef)(t0);
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group_0, id_0)=>{
                if (!store.current[group_0]) return;
                return store.current[group_0][id_0];
            },
            setGroupState: (group_1, value_0)=>{
                store.current[group_1] = value_0;
            },
            getGroupState: (group_2)=>store.current[group_2] || {}
        };
        $[1] = t1;
    } else t1 = $[1];
    const context = t1;
    let t2;
    if ($[2] !== children) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lOWpM.SelectionStoreContext).Provider, {
            value: context,
            children: children
        });
        $[2] = children;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : (props)=>{
    const { children: children } = props;
    const store = (0, $cozmU.useRef)({});
    const context = (0, $cozmU.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group_0, id_0)=>{
                if (!store.current[group_0]) return undefined;
                return store.current[group_0][id_0];
            },
            setGroupState: (group_1, value_0)=>{
                store.current[group_1] = value_0;
            },
            getGroupState: (group_2)=>{
                return store.current[group_2] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lOWpM.SelectionStoreContext).Provider, {
        value: context,
        children: children
    });
};
var $885bea270958798f$export$2e2bcd8739ae039 = $885bea270958798f$var$SelectionStore;
module.exports["default"] = $885bea270958798f$export$2e2bcd8739ae039;

});

parcelRegister("lOWpM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");

const $db8a5bf4c7b230f3$export$756f795847463ebd = /*#__PURE__*/ (0, $cozmU.createContext)({
    setItemState: (0, $dpsRj.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $dpsRj.default),
    getGroupState: ()=>({})
});
module.exports["SelectionStoreContext"] = $db8a5bf4c7b230f3$export$756f795847463ebd;

});

parcelRegister("iv7mf", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $4CEP6 = parcelRequire("4CEP6");


var $2Bag3 = parcelRequire("2Bag3");


var $6nHMa = parcelRequire("6nHMa");

/**
 * Focus manager logic.
 */ const $f5a399746fdfd30b$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $cozmU.useRef)([]);
    // Used to force a re-render only
    const [refresh, setRefresh] = (0, $cozmU.useState)(0);
    const registerMode = (0, $cozmU.useRef)('ordered');
    registerMode.current = 'ordered';
    const registerRef = (0, $cozmU.useCallback)((ref)=>{
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error(`Unexpected case of ${registerMode.current}`);
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $4CEP6.useLayering)();
    // Root menu (from a button) is at level 1; first submenu is at level 2. ARIA: Left only closes submenus.
    const isNestedMenu = currentLevel > 1;
    // Intentionally rebinding on each render
    (0, $cozmU.useEffect)(()=>{
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $cozmU.useEffect)(()=>(0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: (0, $2Bag3.default)(menuItemRefs, isLayerDisabled, onClose, isNestedMenu)
        }), [
        isLayerDisabled,
        onClose,
        isNestedMenu
    ]);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6nHMa.FocusManagerContext).Provider, {
        value: contextValue,
        children: children
    });
};
var $f5a399746fdfd30b$export$2e2bcd8739ae039 = $f5a399746fdfd30b$var$FocusManager;
module.exports["default"] = $f5a399746fdfd30b$export$2e2bcd8739ae039;

});

parcelRegister("2Bag3", function(module, exports) {
$parcel$export(module.exports, "default", () => $b55ec80e24a5f4b9$export$2e2bcd8739ae039);

var $fM984 = parcelRequire("fM984");


var $iDrrr = parcelRequire("iDrrr");


var $eEek6 = parcelRequire("eEek6");

const $b55ec80e24a5f4b9$var$actionMap = {
    [(0, $fM984.KEY_DOWN)]: 'next',
    [(0, $fM984.KEY_UP)]: 'prev',
    [(0, $fM984.KEY_HOME)]: 'first',
    [(0, $fM984.KEY_END)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $b55ec80e24a5f4b9$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $b55ec80e24a5f4b9$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $b55ec80e24a5f4b9$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose, isNestedMenu = false) {
    return (e)=>{
        const currentRefs = refs.current ?? [];
        const currentFocusedIdx = currentRefs.findIndex(({ current: el })=>el && document.activeElement?.isSameNode(el));
        if ((0, $iDrrr.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $eEek6.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $fM984.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $fM984.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        // Left arrow: only in a submenu — close and return focus to parent. No navigation within menu.
        if (e.key === (0, $fM984.KEY_LEFT)) {
            e.preventDefault();
            if (isNestedMenu) onClose(e);
            return;
        }
        // Right arrow: only when item has submenu — open it. No navigation within menu.
        if (e.key === (0, $fM984.KEY_RIGHT)) {
            const activeElement = document.activeElement;
            if (activeElement instanceof HTMLElement && (activeElement.getAttribute('aria-haspopup') === 'true' || activeElement.getAttribute('aria-haspopup') === 'menu')) {
                e.preventDefault();
                activeElement.click();
            }
            return;
        }
        const action = $b55ec80e24a5f4b9$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const nextFocusableElement = $b55ec80e24a5f4b9$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement?.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const prevFocusableElement = $b55ec80e24a5f4b9$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement?.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const firstFocusableElement = $b55ec80e24a5f4b9$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const lastFocusableElement = $b55ec80e24a5f4b9$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});

parcelRegister("eEek6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $6JrSr = parcelRequire("6JrSr");

const $bcf8a6c8e532b2af$export$8a682ae47622dbb9 = 'ds--dropdown--';
/**
 * useGeneratedId generates a random string which remains constant across
 * renders when called without any parameter.
 */ const $bcf8a6c8e532b2af$var$useGeneratedId = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useGeneratedId() {
    const id = (0, $6JrSr.useId)();
    return `${$bcf8a6c8e532b2af$export$8a682ae47622dbb9}${id}`;
} : function useGeneratedId() {
    const id = (0, $6JrSr.useId)();
    return `${$bcf8a6c8e532b2af$export$8a682ae47622dbb9}${id}`;
};
var $bcf8a6c8e532b2af$export$2e2bcd8739ae039 = $bcf8a6c8e532b2af$var$useGeneratedId;
module.exports["PREFIX"] = $bcf8a6c8e532b2af$export$8a682ae47622dbb9;
module.exports["default"] = $bcf8a6c8e532b2af$export$2e2bcd8739ae039;

});

parcelRegister("6nHMa", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");

const $f526bd1b7b92569a$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $cozmU.createContext)({
    menuItemRefs: [],
    registerRef: (0, $dpsRj.default)
});
module.exports["FocusManagerContext"] = $f526bd1b7b92569a$export$f18c1d4fc7326096;

});

parcelRegister("94Dr9", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6IL1T = parcelRequire("6IL1T");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $lfoFx = parcelRequire("lfoFx");


var $gsYt4 = parcelRequire("gsYt4");


var $2zAfh = parcelRequire("2zAfh");


var $6nHMa = parcelRequire("6nHMa");

const $9c09f45d8ede8a3c$var$styles = {
    spinnerContainer: "_3iDTPbQ4SZ _4ouGXIoaux _37wbyuDIqT _46hvQmkG2W _03SyCPkG2W _0xmtkokG2W _0LQT5EkG2W"
};
const $9c09f45d8ede8a3c$var$LoadingIndicator = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { statusLabel: t1, testId: testId } = t0;
    const statusLabel = t1 === undefined ? "Loading" : t1;
    let t2;
    if ($[0] !== statusLabel || $[1] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $9c09f45d8ede8a3c$var$styles.spinnerContainer,
            role: "menuitem",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
                size: "small",
                label: statusLabel,
                testId: testId
            })
        });
        $[0] = statusLabel;
        $[1] = testId;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $9c09f45d8ede8a3c$var$styles.spinnerContainer,
        role: "menuitem",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    }); /**
          *
          * MenuWrapper wraps all the menu items.
          * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
          * if a CheckboxItem or RadioItem is clicked.
          * It also sets focus to the first menu item when opened.
          */ 
const $9c09f45d8ede8a3c$var$MenuWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel } = t0;
    const { menuItemRefs: menuItemRefs } = (0, $cozmU.useContext)((0, $6nHMa.FocusManagerContext));
    let t1;
    if ($[0] !== menuItemRefs || $[1] !== onClose) {
        t1 = (e)=>{
            const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
                const { current: menuItem } = menuItemRef;
                if (!menuItem) return false;
                const isCheckboxOrRadio = (0, $gsYt4.default)(menuItem) || (0, $2zAfh.default)(menuItem);
                return menuItem.contains(e.target) && !isCheckboxOrRadio;
            });
            if (isTargetMenuItemOrDescendant && onClose) onClose(e);
        };
        $[0] = menuItemRefs;
        $[1] = onClose;
        $[2] = t1;
    } else t1 = $[2];
    const closeOnMenuItemClick = t1;
    let t2;
    if ($[3] !== onUpdate) {
        t2 = ()=>{
            onUpdate();
        };
        $[3] = onUpdate;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== isLoading || $[6] !== onUpdate) {
        t3 = [
            isLoading,
            onUpdate
        ];
        $[5] = isLoading;
        $[6] = onUpdate;
        $[7] = t3;
    } else t3 = $[7];
    (0, $cozmU.useLayoutEffect)(t2, t3);
    let t4;
    let t5;
    if ($[8] !== autoFocus || $[9] !== isTriggeredUsingKeyboard || $[10] !== menuItemRefs || $[11] !== setInitialFocusRef || $[12] !== shouldRenderToParent) {
        t4 = ()=>{
            const firstFocusableRef = menuItemRefs.map($9c09f45d8ede8a3c$var$_temp).find($9c09f45d8ede8a3c$var$_temp2) ?? null;
            if (((0, $iDrrr.fg)("platform_dst_menu_item_focus") || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
            setInitialFocusRef?.(firstFocusableRef);
        };
        t5 = [
            menuItemRefs,
            setInitialFocusRef,
            autoFocus,
            shouldRenderToParent,
            isTriggeredUsingKeyboard
        ];
        $[8] = autoFocus;
        $[9] = isTriggeredUsingKeyboard;
        $[10] = menuItemRefs;
        $[11] = setInitialFocusRef;
        $[12] = shouldRenderToParent;
        $[13] = t4;
        $[14] = t5;
    } else {
        t4 = $[13];
        t5 = $[14];
    }
    (0, $cozmU.useEffect)(t4, t5);
    const t6 = testId && `${testId}--menu-group`;
    let t7;
    if ($[15] !== children || $[16] !== isLoading || $[17] !== statusLabel || $[18] !== testId) {
        t7 = isLoading ? /*#__PURE__*/ (0, $8aG6j.jsx)($9c09f45d8ede8a3c$var$LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && `${testId}--loading-indicator`
        }) : children;
        $[15] = children;
        $[16] = isLoading;
        $[17] = statusLabel;
        $[18] = testId;
        $[19] = t7;
    } else t7 = $[19];
    let t8;
    if ($[20] !== closeOnMenuItemClick || $[21] !== isLoading || $[22] !== maxHeight || $[23] !== maxWidth || $[24] !== menuLabel || $[25] !== spacing || $[26] !== t6 || $[27] !== t7) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6IL1T.default), {
            isLoading: isLoading,
            maxHeight: maxHeight,
            maxWidth: maxWidth,
            onClick: closeOnMenuItemClick,
            role: "menu",
            spacing: spacing,
            testId: t6,
            menuLabel: menuLabel,
            children: t7
        });
        $[20] = closeOnMenuItemClick;
        $[21] = isLoading;
        $[22] = maxHeight;
        $[23] = maxWidth;
        $[24] = menuLabel;
        $[25] = spacing;
        $[26] = t6;
        $[27] = t7;
        $[28] = t8;
    } else t8 = $[28];
    return t8;
} : ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel })=>{
    const { menuItemRefs: menuItemRefs } = (0, $cozmU.useContext)((0, $6nHMa.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
            const { current: menuItem } = menuItemRef;
            if (!menuItem) return false;
            const isCheckboxOrRadio = (0, $gsYt4.default)(menuItem) || (0, $2zAfh.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        }); // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $cozmU.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $cozmU.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.map(({ current: current })=>current).find((el)=>!!el && !el.hasAttribute('disabled')) ?? null;
        if (((0, $iDrrr.fg)('platform_dst_menu_item_focus') || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6IL1T.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`,
        menuLabel: menuLabel,
        children: isLoading ? /*#__PURE__*/ (0, $8aG6j.jsx)($9c09f45d8ede8a3c$var$LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && `${testId}--loading-indicator`
        }) : children
    });
};
var $9c09f45d8ede8a3c$export$2e2bcd8739ae039 = $9c09f45d8ede8a3c$var$MenuWrapper;
function $9c09f45d8ede8a3c$var$_temp(t0) {
    const { current: current } = t0;
    return current;
}
function $9c09f45d8ede8a3c$var$_temp2(el) {
    return !!el && !el.hasAttribute("disabled");
}
module.exports["default"] = $9c09f45d8ede8a3c$export$2e2bcd8739ae039;

});

parcelRegister("gsYt4", function(module, exports) {
$parcel$export(module.exports, "default", () => $363009d7887a30e5$export$2e2bcd8739ae039);
function $363009d7887a30e5$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("2zAfh", function(module, exports) {
$parcel$export(module.exports, "default", () => $364a1a3a4c98073c$export$2e2bcd8739ae039);
function $364a1a3a4c98073c$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});

parcelRegister("imIsb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $6nHMa = parcelRequire("6nHMa");

// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
const $ab7ed338ade85dc7$var$useRegisterItemWithFocusManager = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRegisterItemWithFocusManager(t0) {
    const $ = (0, $bDgLe.c)(4);
    const hasPopup = t0 === undefined ? false : t0;
    const { registerRef: registerRef } = (0, $cozmU.useContext)((0, $6nHMa.FocusManagerContext));
    const itemRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== hasPopup || $[1] !== registerRef) {
        t1 = ()=>{
            if (hasPopup && (0, $iDrrr.fg)("select-avoid-duplicated-registered-ref")) return;
            registerRef(itemRef);
        };
        t2 = [
            registerRef,
            hasPopup
        ];
        $[0] = hasPopup;
        $[1] = registerRef;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return itemRef;
} : function useRegisterItemWithFocusManager(hasPopup = false) {
    const { registerRef: registerRef } = (0, $cozmU.useContext)((0, $6nHMa.FocusManagerContext));
    const itemRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (hasPopup && (0, $iDrrr.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
};
var $ab7ed338ade85dc7$export$2e2bcd8739ae039 = $ab7ed338ade85dc7$var$useRegisterItemWithFocusManager;
module.exports["default"] = $ab7ed338ade85dc7$export$2e2bcd8739ae039;

});

parcelRegister("is1T6", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $lmzCg = parcelRequire("lmzCg");


var $9d7Pd = parcelRequire("9d7Pd");


var $kD4eB = parcelRequire("kD4eB");


var $8oBbn = parcelRequire("8oBbn");


var $iDrrr = parcelRequire("iDrrr");


var $imIsb = parcelRequire("imIsb");

/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ const $94fa0e4252415620$var$DropdownMenuItem = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, role: role, ...rest }, ref)=>{
    // Nested submenu triggers register with the focus manager inside DropdownMenu.
    // Dialog triggers must register here so arrow navigation can reach them.
    const isNestedTrigger = (0, $iDrrr.fg)('platform_dst-a11y_modal-trigger-haspopup') ? !!rest['aria-haspopup'] && rest['aria-haspopup'] !== 'dialog' : !!rest['aria-haspopup'];
    const itemRef = (0, $imIsb.default)(isNestedTrigger);
    const handleItemClick = (0, $cozmU.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kD4eB.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $lmzCg.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else if (href) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8oBbn.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $lmzCg.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9d7Pd.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $lmzCg.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        ...isNestedTrigger && (0, $iDrrr.fg)('platform_dst_dropdown_nested_trigger_aria_current') ? {
            'aria-current': undefined
        } : {},
        children: children
    });
});
var $94fa0e4252415620$export$2e2bcd8739ae039 = $94fa0e4252415620$var$DropdownMenuItem;
module.exports["default"] = $94fa0e4252415620$export$2e2bcd8739ae039;

});

parcelRegister("9erVg", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");


var $8FgJC = parcelRequire("8FgJC");


var $eiIYc = parcelRequire("eiIYc");

/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $e544827bc46159a5$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(23);
    let children;
    let hasSeparator;
    let id;
    let isList;
    let isScrollable;
    let rest;
    let testId;
    let title;
    if ($[0] !== t0) {
        ({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = hasSeparator;
        $[3] = id;
        $[4] = isList;
        $[5] = isScrollable;
        $[6] = rest;
        $[7] = testId;
        $[8] = title;
    } else {
        children = $[1];
        hasSeparator = $[2];
        id = $[3];
        isList = $[4];
        isScrollable = $[5];
        rest = $[6];
        testId = $[7];
        title = $[8];
    }
    const uid = (0, $6JrSr.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    const t1 = title ? titleId : undefined;
    let t2;
    if ($[9] !== title || $[10] !== titleId) {
        t2 = title && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eiIYc.default), {
            id: titleId,
            title: title
        });
        $[9] = title;
        $[10] = titleId;
        $[11] = t2;
    } else t2 = $[11];
    let t3;
    if ($[12] !== children || $[13] !== hasSeparator || $[14] !== id || $[15] !== isList || $[16] !== isScrollable || $[17] !== ref || $[18] !== rest || $[19] !== t1 || $[20] !== t2 || $[21] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8FgJC.default), {
            id: id,
            ref: ref,
            isList: isList,
            isScrollable: isScrollable,
            hasSeparator: hasSeparator,
            testId: testId,
            titleId: t1,
            ...rest,
            children: [
                t2,
                children
            ]
        });
        $[12] = children;
        $[13] = hasSeparator;
        $[14] = id;
        $[15] = isList;
        $[16] = isScrollable;
        $[17] = ref;
        $[18] = rest;
        $[19] = t1;
        $[20] = t2;
        $[21] = testId;
        $[22] = t3;
    } else t3 = $[22];
    return t3;
} : ({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest }, ref)=>{
    const uid = (0, $6JrSr.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8FgJC.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest,
        children: [
            title && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eiIYc.default), {
                id: titleId,
                title: title
            }),
            children
        ]
    });
});
var $e544827bc46159a5$export$2e2bcd8739ae039 = $e544827bc46159a5$var$DropdownMenuItemGroup;
module.exports["default"] = $e544827bc46159a5$export$2e2bcd8739ae039;

});

parcelRegister("eiIYc", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $c2ad6d0f9690e679$var$styles = {
    heading: "_2sNsIgd8bj _4c065UPgdg _2Y7lL45zaO _1UtDYzZpcK"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups.
 *
 * Pre-existing a11y note: uses `role="menuitem"` with `aria-hidden="true"`.
 * WAI-ARIA APG recommends `role="presentation"` for non-interactive group
 * headings, with the group linked via `aria-labelledby`. Out of scope for
 * the top-layer migration — this is legacy behavior.
 *
 * @internal
 */ const $c2ad6d0f9690e679$var$GroupTitle = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { id: id, title: title } = t0;
    let t1;
    if ($[0] !== id || $[1] !== title) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            "data-ds--menu--heading-item": true,
            role: "menuitem",
            id: id,
            "aria-hidden": "true",
            xcss: $c2ad6d0f9690e679$var$styles.heading,
            children: title
        });
        $[0] = id;
        $[1] = title;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ id: id, title: title })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $c2ad6d0f9690e679$var$styles.heading,
        children: title
    });
var $c2ad6d0f9690e679$export$2e2bcd8739ae039 = $c2ad6d0f9690e679$var$GroupTitle;
module.exports["default"] = $c2ad6d0f9690e679$export$2e2bcd8739ae039;

});

parcelRegister("g0IDr", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6iJ3v = parcelRequire("6iJ3v");

const $f40788a777bec402$export$e9c4922b2ecf808a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useOnRevealed(callback, t0) {
    const $ = (0, $bDgLe.c)(6);
    const { isExpanded: isExpanded, isDisabled: isDisabled } = t0;
    const prevExtended = (0, $6iJ3v.default)(isExpanded);
    let t1;
    let t2;
    if ($[0] !== callback || $[1] !== isDisabled || $[2] !== isExpanded || $[3] !== prevExtended) {
        t1 = ()=>{
            const hasBeenRevealed = !prevExtended && isExpanded;
            if (!isDisabled && hasBeenRevealed) callback();
        };
        t2 = [
            isExpanded,
            isDisabled,
            callback,
            prevExtended
        ];
        $[0] = callback;
        $[1] = isDisabled;
        $[2] = isExpanded;
        $[3] = prevExtended;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
} : function useOnRevealed(callback, { isExpanded: isExpanded, isDisabled: isDisabled }) {
    const prevExtended = (0, $6iJ3v.default)(isExpanded);
    (0, $cozmU.useEffect)(()=>{
        const hasBeenRevealed = !prevExtended && isExpanded;
        if (!isDisabled && hasBeenRevealed) callback();
    }, [
        isExpanded,
        isDisabled,
        callback,
        prevExtended
    ]);
};
module.exports["useOnRevealed"] = $f40788a777bec402$export$e9c4922b2ecf808a;

});

parcelRegister("7DQ7D", function(module, exports) {
$parcel$export(module.exports, "default", () => $84c50e72db23da4d$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

// The ellipsis trigger is a compact IconButton (24px) plus the trailing separator (24px).
const $84c50e72db23da4d$var$ELLIPSIS_WIDTH_ESTIMATE = 48;
// Measurements need layout timing in the browser, but should be a no-op for SSR.
const $84c50e72db23da4d$var$useLayoutEffect = typeof window === 'undefined' ? (0, $cozmU.useEffect) : (0, $cozmU.useLayoutEffect);
function $84c50e72db23da4d$var$setsEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const v of a){
        if (!b.has(v)) return false;
    }
    return true;
}
function $84c50e72db23da4d$var$getMiddleOutCollapseOrder(itemCount) {
    const lastIndex = itemCount - 1;
    const middleIndex = Math.floor((itemCount - 1) / 2);
    const collapseOrder = [];
    if (middleIndex > 0 && middleIndex < lastIndex) collapseOrder.push(middleIndex);
    for(let distance = 1; distance < itemCount; distance++){
        const leftIndex = middleIndex - distance;
        const rightIndex = middleIndex + distance;
        if (leftIndex > 0) collapseOrder.push(leftIndex);
        if (rightIndex < lastIndex) collapseOrder.push(rightIndex);
    }
    return collapseOrder;
}
function $84c50e72db23da4d$export$2e2bcd8739ae039(itemCount) {
    const itemRefs = (0, $cozmU.useRef)([]);
    const containerRef = (0, $cozmU.useRef)(null);
    const naturalWidths = (0, $cozmU.useRef)([]);
    const naturalWidthsReady = (0, $cozmU.useRef)(false);
    const [naturalWidthsReadyState, setNaturalWidthsReadyState] = (0, $cozmU.useState)(false);
    const [collapsedIndices, setCollapsedIndices] = (0, $cozmU.useState)(new Set());
    // Intentionally runs after each render until refs have committed and natural widths are measured.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $84c50e72db23da4d$var$useLayoutEffect(()=>{
        if (naturalWidthsReady.current) return;
        const widths = itemRefs.current.map((el)=>el?.offsetWidth ?? 0);
        if (widths.some((w)=>w > 0)) {
            naturalWidths.current = widths;
            naturalWidthsReady.current = true;
            setNaturalWidthsReadyState(true);
        }
    });
    const recalculate = (0, $cozmU.useCallback)(()=>{
        const container = containerRef.current;
        if (!container || !naturalWidthsReady.current) return;
        const availableWidth = container.offsetWidth;
        const widths = naturalWidths.current;
        if (itemCount <= 2) {
            setCollapsedIndices((prev)=>prev.size === 0 ? prev : new Set());
            return;
        }
        const totalWidth = widths.reduce((sum, w)=>sum + w, 0);
        if (totalWidth <= availableWidth) {
            setCollapsedIndices((prev)=>prev.size === 0 ? prev : new Set());
            return;
        }
        let usedWidth = totalWidth;
        const newCollapsed = new Set();
        for (const index of $84c50e72db23da4d$var$getMiddleOutCollapseOrder(itemCount)){
            if (newCollapsed.size === 0) usedWidth += $84c50e72db23da4d$var$ELLIPSIS_WIDTH_ESTIMATE;
            newCollapsed.add(index);
            usedWidth -= widths[index] ?? 0;
            if (usedWidth <= availableWidth) break;
        }
        // At the smallest sizes, even first + ellipsis + last may not fit.
        // In that case, also collapse the first item so only ellipsis + last is shown.
        // Note: this branch is only reachable when itemCount > 2 (the early return above
        // handles itemCount <= 2), so collapsing index 0 here always leaves at least one
        // visible item (the last) plus the ellipsis trigger.
        if (usedWidth > availableWidth) newCollapsed.add(0);
        setCollapsedIndices((prev)=>$84c50e72db23da4d$var$setsEqual(prev, newCollapsed) ? prev : newCollapsed);
    }, [
        itemCount
    ]);
    const registerItem = (0, $cozmU.useCallback)((index)=>(el)=>{
            itemRefs.current[index] = el;
        }, []);
    const observerRef = (0, $cozmU.useRef)(null);
    const registerContainer = (0, $cozmU.useCallback)((el)=>{
        // Disconnect any existing observer
        observerRef.current?.disconnect();
        containerRef.current = el;
        if (!el) return;
        if (typeof ResizeObserver === 'undefined') return;
        // Set up ResizeObserver immediately when container mounts
        const observer = new ResizeObserver(()=>{
            recalculate();
        });
        observer.observe(el);
        observerRef.current = observer;
    }, [
        recalculate
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (naturalWidthsReadyState) recalculate();
    }, [
        naturalWidthsReadyState,
        recalculate
    ]);
    // Cleanup observer on unmount
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            observerRef.current?.disconnect();
        };
    }, []);
    (0, $cozmU.useEffect)(()=>{
        naturalWidthsReady.current = false;
        naturalWidths.current = [];
        setNaturalWidthsReadyState(false);
        setCollapsedIndices(new Set());
    }, [
        itemCount
    ]);
    return {
        collapsedIndices: collapsedIndices,
        naturalWidthsReady: naturalWidthsReadyState,
        registerItem: registerItem,
        registerContainer: registerContainer
    };
}

});

parcelRegister("6cA3O", function(module, exports) {
/* breadcrumbs-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $lpNn5 = parcelRequire("lpNn5");


var $g4h89 = parcelRequire("g4h89");


var $aKleR = parcelRequire("aKleR");


var $bggFv = parcelRequire("bggFv");


var $8C5a3 = parcelRequire("8C5a3");

const $be0fad57d9cedf06$var$itemWrapperStyles = null;
const $be0fad57d9cedf06$var$VAR_STEP_TRUNCATION_WIDTH = '--max-width';
const $be0fad57d9cedf06$var$ICON_WIDTH_ESTIMATE = 24;
const $be0fad57d9cedf06$var$staticItemStyles = null;
const $be0fad57d9cedf06$var$staticItemWithTruncationStyles = null;
const $be0fad57d9cedf06$var$staticItemWithoutTruncationStyles = null;
const $be0fad57d9cedf06$var$motionItemStyles = null;
const $be0fad57d9cedf06$var$BreadcrumbsItem = /*#__PURE__*/ (0, $cozmU.memo)(({ analyticsContext: analyticsContext, component: component, // Analytics event creation comes from context via usePlatformLeafEventHandler.
// Strip this prop so it cannot leak onto DOM-backed controls.
createAnalyticsEvent: _createAnalyticsEvent, href: href, elemBefore: elemBefore, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, // This is overridden by the `buttonRef` below
ref: _ref, target: target, testId: testId, text: text, title: title, truncationWidth: truncationWidth, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-current': ariaCurrent, _overflowRef: _overflowRef, ...rest })=>{
    const [stepElement, setStepElement] = (0, $cozmU.useState)(null);
    const setStepRef = (0, $cozmU.useCallback)((element)=>{
        setStepElement(element);
    }, []);
    const resolvedElemBefore = elemBefore ?? iconBefore;
    let iconWidthAllowance = 0;
    if (resolvedElemBefore) iconWidthAllowance += $be0fad57d9cedf06$var$ICON_WIDTH_ESTIMATE;
    if (iconAfter) iconWidthAllowance += $be0fad57d9cedf06$var$ICON_WIDTH_ESTIMATE;
    const [hasOverflow, shouldShowTooltip] = (0, $8C5a3.default)(truncationWidth, stepElement, (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') ? 0 : iconWidthAllowance);
    if (!component && (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $g4h89.default), {
        ref: _overflowRef,
        analyticsContext: analyticsContext,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        elemBefore: resolvedElemBefore,
        href: href,
        // `BreadcrumbsItem.iconAfter` in `src/packages/polaris/component-ideas-idea-view/tests/IssueKey.test.tsx`
        // and `src/packages/polaris/component-ideas-idea-view/tests/IssueBreadcrumbs.test.tsx`.
        // Those consumers need to move the copy-link affordance out of `BreadcrumbsItem` first.
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        onTooltipShown: onTooltipShown,
        shouldShowTooltip: shouldShowTooltip,
        stepRef: setStepRef,
        target: target,
        testId: testId,
        text: text,
        title: title,
        truncationWidth: truncationWidth,
        "aria-current": ariaCurrent
    });
    const buttonOverrideStyles = {
        paddingBlock: "var(--ds-space-025, 2px)",
        fontWeight: "var(--ds-font-weight-regular, 400)"
    }; // Note: cast to `any` is required to type verification - see https://github.com/frenic/csstype#what-should-i-do-when-i-get-type-errors
    const dynamicItemStyles = {
        [$be0fad57d9cedf06$var$VAR_STEP_TRUNCATION_WIDTH]: typeof truncationWidth !== 'undefined' && `${truncationWidth}px`
    };
    const step = !component ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aKleR.default), {
        analyticsContext: analyticsContext,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-current": ariaCurrent,
        elemBefore: resolvedElemBefore,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        ref: setStepRef,
        target: target,
        testId: testId,
        title: title,
        truncationWidth: truncationWidth,
        ...rest,
        children: text
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bggFv.default), {
        analyticsContext: analyticsContext,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-current": ariaCurrent,
        component: component,
        hasOverflow: hasOverflow,
        href: href,
        iconAfter: iconAfter,
        iconBefore: resolvedElemBefore,
        onClick: onClick,
        ref: setStepRef,
        target: target,
        testId: testId,
        title: title,
        style: truncationWidth ? {
            ...dynamicItemStyles,
            ...buttonOverrideStyles
        } : buttonOverrideStyles,
        ...rest,
        className: (0, $hekY6.default)([
            "_26BoRwPcut",
            truncationWidth ? "_1EqgXlKIuT" : "_4ouGXIAASz _3YEZNO3mKv",
            (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') && "_23rrnHo10F _00uqCYjOvk _3xtjKN0Rl6 _1B4rbIo10F _0DCa9DKGUX _3sFUREDdj4 _3WzCGiy7kJ"
        ]),
        children: text
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
        ref: _overflowRef,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _24h04i2Njc _1EqgXlN91d _0jFU0V49iP _0hPCNLDIqT _0aFT5v1qpb _0WKd3G4z3T _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg _0n7g92FQfX _3DgaZ22ADO _3hLXwcJg58 _1Xuk08dnbC _2jLjk7KGUX _2IsVYLfzt3 _2YiD5UDIqT"
        ]),
        children: shouldShowTooltip ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown,
            children: step
        }) : step
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$be0fad57d9cedf06$export$2e2bcd8739ae039 = $be0fad57d9cedf06$var$BreadcrumbsItem;
module.exports["default"] = $be0fad57d9cedf06$export$2e2bcd8739ae039;

});

parcelRegister("g4h89", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lmzCg = parcelRequire("lmzCg");


var $lpNn5 = parcelRequire("lpNn5");


var $aKleR = parcelRequire("aKleR");

const $940cd9b04c8fc3c8$var$itemWrapperStyles = null;
const $940cd9b04c8fc3c8$var$BreadcrumbsItemBase = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(30);
    const { analyticsContext: analyticsContext, elemBefore: elemBefore, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, target: target, testId: testId, text: text, title: title, truncationWidth: truncationWidth, shouldShowTooltip: shouldShowTooltip, stepRef: stepRef, xcss: xcss, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-current": ariaCurrent } = t0;
    const resolvedElemBefore = elemBefore ?? iconBefore;
    let t1;
    if ($[0] !== analyticsContext || $[1] !== ariaCurrent || $[2] !== ariaLabel || $[3] !== ariaLabelledBy || $[4] !== href || $[5] !== iconAfter || $[6] !== iconBefore || $[7] !== onClick || $[8] !== resolvedElemBefore || $[9] !== stepRef || $[10] !== target || $[11] !== testId || $[12] !== text || $[13] !== title || $[14] !== truncationWidth) {
        t1 = (triggerProps)=>{
            const { ref: tooltipRef, testId: _testId, ...tooltipTriggerProps } = triggerProps ?? {};
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aKleR.default), {
                ref: tooltipRef ? (0, $lmzCg.default)([
                    stepRef,
                    tooltipRef
                ]) : stepRef,
                analyticsContext: analyticsContext,
                "aria-label": ariaLabel,
                "aria-labelledby": ariaLabelledBy,
                "aria-current": ariaCurrent,
                elemBefore: resolvedElemBefore,
                href: href,
                iconAfter: iconAfter,
                iconBefore: iconBefore,
                onClick: onClick,
                target: target,
                testId: testId,
                title: title,
                triggerProps: triggerProps ? tooltipTriggerProps : undefined,
                truncationWidth: truncationWidth,
                children: text
            });
        };
        $[0] = analyticsContext;
        $[1] = ariaCurrent;
        $[2] = ariaLabel;
        $[3] = ariaLabelledBy;
        $[4] = href;
        $[5] = iconAfter;
        $[6] = iconBefore;
        $[7] = onClick;
        $[8] = resolvedElemBefore;
        $[9] = stepRef;
        $[10] = target;
        $[11] = testId;
        $[12] = text;
        $[13] = title;
        $[14] = truncationWidth;
        $[15] = t1;
    } else t1 = $[15];
    const renderStep = t1;
    let t2;
    if ($[16] !== renderStep) {
        t2 = renderStep();
        $[16] = renderStep;
        $[17] = t2;
    } else t2 = $[17];
    const step = t2;
    let t3;
    if ($[18] !== xcss) {
        t3 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _24h04i2Njc _1EqgXlN91d _0hPCNLDIqT _0aFT5v1qpb _4xdlr0DIqT _0WKd3G4z3T _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg _3S3RSqFQfX _3VnCAF2ADO _2jfUf9Jg58 _1Y703adnbC _446KM5Qame _2GPglyKGUX _0GBAIrfzt3 _0AG2YuDIqT",
            xcss
        ]);
        $[18] = xcss;
        $[19] = t3;
    } else t3 = $[19];
    let t4;
    if ($[20] !== onTooltipShown || $[21] !== renderStep || $[22] !== shouldShowTooltip || $[23] !== step || $[24] !== text) {
        t4 = shouldShowTooltip ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown,
            children: renderStep
        }) : step;
        $[20] = onTooltipShown;
        $[21] = renderStep;
        $[22] = shouldShowTooltip;
        $[23] = step;
        $[24] = text;
        $[25] = t4;
    } else t4 = $[25];
    let t5;
    if ($[26] !== ref || $[27] !== t3 || $[28] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
            ref: ref,
            className: t3,
            children: t4
        });
        $[26] = ref;
        $[27] = t3;
        $[28] = t4;
        $[29] = t5;
    } else t5 = $[29];
    return t5;
} : ({ analyticsContext: analyticsContext, elemBefore: elemBefore, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, target: target, testId: testId, text: text, title: title, truncationWidth: truncationWidth, shouldShowTooltip: shouldShowTooltip, stepRef: stepRef, xcss: xcss, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-current': ariaCurrent }, ref)=>{
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const renderStep = (triggerProps)=>{
        const { ref: tooltipRef, testId: _testId, ...tooltipTriggerProps } = triggerProps ?? {};
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aKleR.default), {
            ref: tooltipRef ? (0, $lmzCg.default)([
                stepRef,
                tooltipRef
            ]) : stepRef,
            analyticsContext: analyticsContext,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            "aria-current": ariaCurrent,
            elemBefore: resolvedElemBefore,
            href: href,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            onClick: onClick,
            target: target,
            testId: testId,
            title: title,
            triggerProps: triggerProps ? tooltipTriggerProps : undefined,
            truncationWidth: truncationWidth,
            children: text
        });
    };
    const step = renderStep();
    return /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
        ref: ref,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _24h04i2Njc _1EqgXlN91d _0hPCNLDIqT _0aFT5v1qpb _4xdlr0DIqT _0WKd3G4z3T _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg _3S3RSqFQfX _3VnCAF2ADO _2jfUf9Jg58 _1Y703adnbC _446KM5Qame _2GPglyKGUX _0GBAIrfzt3 _0AG2YuDIqT",
            xcss
        ]),
        children: shouldShowTooltip ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown,
            children: renderStep
        }) : step
    });
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $940cd9b04c8fc3c8$export$2e2bcd8739ae039 = $940cd9b04c8fc3c8$var$BreadcrumbsItemBase;
module.exports["default"] = $940cd9b04c8fc3c8$export$2e2bcd8739ae039;

});

parcelRegister("aKleR", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7r5Hr = parcelRequire("7r5Hr");


var $w6R6I = parcelRequire("w6R6I");


var $dpsRj = parcelRequire("dpsRj");


var $iDrrr = parcelRequire("iDrrr");


var $7vK9E = parcelRequire("7vK9E");

var $hBYtq = parcelRequire("hBYtq");


var $jiltW = parcelRequire("jiltW");

const $145f806ee7333746$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $145f806ee7333746$var$noop = (0, $dpsRj.default);
const $145f806ee7333746$var$styles = {
    root: "_2sNsIgmnOE _30huDKYbGa _2mHwu81Y8M _0bjKvDcjp5 _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _2Y7lL4Pgdg _0KLXru66of _1UtDYzKGUX _3iDTPbccYA _0hPCNLDIqT _32C2rk98eZ _0i9AWAYbGa _0mm6KQ6wH8 _10n1R5KGUX _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMKGUX _0CMRbky7kJ",
    rootSmall: "_2sNsIg7NXe",
    rootRefresh: "_24h04i2Njc _0jFU0V9DVM",
    interactiveMotion: "_23rrnHo10F _3xtjKN0Rl6 _00uqCYjOvk _1B4rbIo10F _0DCa9DKGUX _3sFUREDdj4 _3WzCGiy7kJ",
    withoutTruncation: "_4ouGXIdnbC _3YEZNO7dHp",
    withTruncation: "_4ouGXIdnbC",
    iconWrapper: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbccYA _3YEZNOdnbC _39xV02oWWg _0jFU0VoWWg _0hPCNLDIqT _37wbyuDIqT",
    iconWrapperExternal: "_2xTnZxFQfX",
    iconWrapperExternalSmall: "_2xTnZxPgdg",
    text: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7",
    textWithTruncation: "_4ouGXIdnbC _1EqgXlN91d _3YEZNO7dHp"
};
const $145f806ee7333746$var$unboundedStyles = {
    iconWrapperSmall: "_27VeLCey7F _2Qxi4ney7F",
    iconWrapper: "_1UtDYzWYXf"
}; /**
    * __Step__
    *
    * A button that represents a single step in a breadcrumbs component.
    */ 
const $145f806ee7333746$var$Step = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(112);
    let analyticsContext;
    let ariaCurrent;
    let ariaDescribedBy;
    let ariaLabel;
    let ariaLabelledBy;
    let children;
    let elemBefore;
    let href;
    let iconAfter;
    let iconBefore;
    let onBlur;
    let onFocus;
    let onMouseDown;
    let onMouseMove;
    let onMouseOut;
    let onMouseOver;
    let rest;
    let t1;
    let target;
    let testId;
    let title;
    let triggerProps;
    let truncationWidth;
    if ($[0] !== t0) {
        ({ analyticsContext: analyticsContext, elemBefore: elemBefore, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: t1, target: target, testId: testId, children: children, title: title, truncationWidth: truncationWidth, triggerProps: triggerProps, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-current": ariaCurrent, "aria-describedby": ariaDescribedBy, onBlur: onBlur, onFocus: onFocus, onMouseDown: onMouseDown, onMouseMove: onMouseMove, onMouseOut: onMouseOut, onMouseOver: onMouseOver, ...rest } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = ariaCurrent;
        $[3] = ariaDescribedBy;
        $[4] = ariaLabel;
        $[5] = ariaLabelledBy;
        $[6] = children;
        $[7] = elemBefore;
        $[8] = href;
        $[9] = iconAfter;
        $[10] = iconBefore;
        $[11] = onBlur;
        $[12] = onFocus;
        $[13] = onMouseDown;
        $[14] = onMouseMove;
        $[15] = onMouseOut;
        $[16] = onMouseOver;
        $[17] = rest;
        $[18] = t1;
        $[19] = target;
        $[20] = testId;
        $[21] = title;
        $[22] = triggerProps;
        $[23] = truncationWidth;
    } else {
        analyticsContext = $[1];
        ariaCurrent = $[2];
        ariaDescribedBy = $[3];
        ariaLabel = $[4];
        ariaLabelledBy = $[5];
        children = $[6];
        elemBefore = $[7];
        href = $[8];
        iconAfter = $[9];
        iconBefore = $[10];
        onBlur = $[11];
        onFocus = $[12];
        onMouseDown = $[13];
        onMouseMove = $[14];
        onMouseOut = $[15];
        onMouseOver = $[16];
        rest = $[17];
        t1 = $[18];
        target = $[19];
        testId = $[20];
        title = $[21];
        triggerProps = $[22];
        truncationWidth = $[23];
    }
    const onClickProvided = t1 === undefined ? $145f806ee7333746$var$noop : t1;
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const breadcrumbsSize = (0, $jiltW.useBreadcrumbsSize)();
    const isSmall = breadcrumbsSize === "small";
    let t2;
    if ($[24] !== analyticsContext || $[25] !== onClickProvided) {
        t2 = {
            fn: onClickProvided,
            action: "clicked",
            analyticsData: analyticsContext,
            ...$145f806ee7333746$var$analyticsAttributes
        };
        $[24] = analyticsContext;
        $[25] = onClickProvided;
        $[26] = t2;
    } else t2 = $[26];
    const handleClick = (0, $7r5Hr.usePlatformLeafEventHandler)(t2);
    let t3;
    if ($[27] !== handleClick || $[28] !== triggerProps) {
        t3 = (event)=>{
            triggerProps?.onClick?.(event);
            handleClick(event);
        };
        $[27] = handleClick;
        $[28] = triggerProps;
        $[29] = t3;
    } else t3 = $[29];
    const handleTriggerClick = t3;
    const controlRef = (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") ? ref : undefined;
    const textRef = (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") ? undefined : ref;
    let t4;
    if ($[30] !== isSmall || $[31] !== resolvedElemBefore || $[32] !== testId) {
        t4 = resolvedElemBefore && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "data-testid": testId && `${testId}--icon-before`,
            className: (0, $hekY6.default)([
                $145f806ee7333746$var$styles.iconWrapper,
                $145f806ee7333746$var$unboundedStyles.iconWrapper,
                (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && $145f806ee7333746$var$styles.iconWrapperExternal,
                isSmall && $145f806ee7333746$var$styles.iconWrapperExternalSmall,
                isSmall && $145f806ee7333746$var$unboundedStyles.iconWrapperSmall
            ]),
            children: resolvedElemBefore
        });
        $[30] = isSmall;
        $[31] = resolvedElemBefore;
        $[32] = testId;
        $[33] = t4;
    } else t4 = $[33];
    const iconElement = t4;
    let t5;
    if ($[34] !== isSmall || $[35] !== resolvedElemBefore) {
        t5 = !(0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && !isSmall && resolvedElemBefore;
        $[34] = isSmall;
        $[35] = resolvedElemBefore;
        $[36] = t5;
    } else t5 = $[36];
    let t6;
    if ($[37] !== iconElement || $[38] !== isSmall) {
        t6 = !(0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && isSmall && iconElement;
        $[37] = iconElement;
        $[38] = isSmall;
        $[39] = t6;
    } else t6 = $[39];
    let t7;
    if ($[40] !== truncationWidth) {
        t7 = (0, $hekY6.default)([
            $145f806ee7333746$var$styles.text,
            truncationWidth != null && (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && $145f806ee7333746$var$styles.textWithTruncation
        ]);
        $[40] = truncationWidth;
        $[41] = t7;
    } else t7 = $[41];
    let t8;
    if ($[42] !== children || $[43] !== t7 || $[44] !== textRef) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            ref: textRef,
            className: t7,
            children: children
        });
        $[42] = children;
        $[43] = t7;
        $[44] = textRef;
        $[45] = t8;
    } else t8 = $[45];
    let t9;
    if ($[46] !== iconAfter || $[47] !== t5 || $[48] !== t6 || $[49] !== t8) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
            children: [
                t5,
                t6,
                t8,
                iconAfter
            ]
        });
        $[46] = iconAfter;
        $[47] = t5;
        $[48] = t6;
        $[49] = t8;
        $[50] = t9;
    } else t9 = $[50];
    const content = t9;
    if (href) {
        let t10;
        if ($[51] !== iconElement) {
            t10 = (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && iconElement;
            $[51] = iconElement;
            $[52] = t10;
        } else t10 = $[52];
        const t11 = controlRef;
        const t12 = triggerProps?.onMouseOver ?? onMouseOver;
        const t13 = triggerProps?.onMouseOut ?? onMouseOut;
        const t14 = triggerProps?.onMouseMove ?? onMouseMove;
        const t15 = triggerProps?.onMouseDown ?? onMouseDown;
        const t16 = triggerProps?.onFocus ?? onFocus;
        const t17 = triggerProps?.onBlur ?? onBlur;
        const t18 = triggerProps?.["aria-describedby"] ?? ariaDescribedBy;
        const t19 = target === "_blank" ? "noopener noreferrer" : undefined;
        let t20;
        if ($[53] !== isSmall || $[54] !== truncationWidth) {
            t20 = (0, $w6R6I.cx)($145f806ee7333746$var$styles.root, isSmall && $145f806ee7333746$var$styles.rootSmall, (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && $145f806ee7333746$var$styles.rootRefresh, truncationWidth != null && (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && $145f806ee7333746$var$styles.withTruncation, truncationWidth == null && $145f806ee7333746$var$styles.withoutTruncation, (0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") && $145f806ee7333746$var$styles.interactiveMotion);
            $[53] = isSmall;
            $[54] = truncationWidth;
            $[55] = t20;
        } else t20 = $[55];
        let t21;
        if ($[56] !== truncationWidth) {
            t21 = {
                maxWidth: truncationWidth
            };
            $[56] = truncationWidth;
            $[57] = t21;
        } else t21 = $[57];
        let t22;
        if ($[58] !== ariaCurrent || $[59] !== ariaLabel || $[60] !== ariaLabelledBy || $[61] !== content || $[62] !== handleTriggerClick || $[63] !== href || $[64] !== rest || $[65] !== t11 || $[66] !== t12 || $[67] !== t13 || $[68] !== t14 || $[69] !== t15 || $[70] !== t16 || $[71] !== t17 || $[72] !== t18 || $[73] !== t19 || $[74] !== t20 || $[75] !== t21 || $[76] !== target || $[77] !== testId || $[78] !== title) {
            t22 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
                ...rest,
                ref: t11,
                "aria-current": ariaCurrent,
                "aria-label": ariaLabel,
                "aria-labelledby": ariaLabelledBy,
                href: href,
                onClick: handleTriggerClick,
                onMouseOver: t12,
                onMouseOut: t13,
                onMouseMove: t14,
                onMouseDown: t15,
                onFocus: t16,
                onBlur: t17,
                "aria-describedby": t18,
                target: target,
                rel: t19,
                testId: testId,
                title: title,
                xcss: t20,
                style: t21,
                children: content
            });
            $[58] = ariaCurrent;
            $[59] = ariaLabel;
            $[60] = ariaLabelledBy;
            $[61] = content;
            $[62] = handleTriggerClick;
            $[63] = href;
            $[64] = rest;
            $[65] = t11;
            $[66] = t12;
            $[67] = t13;
            $[68] = t14;
            $[69] = t15;
            $[70] = t16;
            $[71] = t17;
            $[72] = t18;
            $[73] = t19;
            $[74] = t20;
            $[75] = t21;
            $[76] = target;
            $[77] = testId;
            $[78] = title;
            $[79] = t22;
        } else t22 = $[79];
        let t23;
        if ($[80] !== t10 || $[81] !== t22) {
            t23 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
                children: [
                    t10,
                    t22
                ]
            });
            $[80] = t10;
            $[81] = t22;
            $[82] = t23;
        } else t23 = $[82];
        return t23;
    }
    let t10;
    if ($[83] !== iconElement) {
        t10 = (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && iconElement;
        $[83] = iconElement;
        $[84] = t10;
    } else t10 = $[84];
    const t11 = controlRef;
    const t12 = triggerProps?.onMouseOver ?? onMouseOver;
    const t13 = triggerProps?.onMouseOut ?? onMouseOut;
    const t14 = triggerProps?.onMouseMove ?? onMouseMove;
    const t15 = triggerProps?.onMouseDown ?? onMouseDown;
    const t16 = triggerProps?.onFocus ?? onFocus;
    const t17 = triggerProps?.onBlur ?? onBlur;
    const t18 = triggerProps?.["aria-describedby"] ?? ariaDescribedBy;
    let t19;
    if ($[85] !== isSmall || $[86] !== truncationWidth) {
        t19 = (0, $w6R6I.cx)($145f806ee7333746$var$styles.root, isSmall && $145f806ee7333746$var$styles.rootSmall, (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && $145f806ee7333746$var$styles.rootRefresh, truncationWidth != null && (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && $145f806ee7333746$var$styles.withTruncation, truncationWidth == null && $145f806ee7333746$var$styles.withoutTruncation, (0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") && $145f806ee7333746$var$styles.interactiveMotion);
        $[85] = isSmall;
        $[86] = truncationWidth;
        $[87] = t19;
    } else t19 = $[87];
    let t20;
    if ($[88] !== truncationWidth) {
        t20 = {
            maxWidth: truncationWidth
        };
        $[88] = truncationWidth;
        $[89] = t20;
    } else t20 = $[89];
    let t21;
    if ($[90] !== ariaCurrent || $[91] !== ariaLabel || $[92] !== ariaLabelledBy || $[93] !== content || $[94] !== handleTriggerClick || $[95] !== rest || $[96] !== t11 || $[97] !== t12 || $[98] !== t13 || $[99] !== t14 || $[100] !== t15 || $[101] !== t16 || $[102] !== t17 || $[103] !== t18 || $[104] !== t19 || $[105] !== t20 || $[106] !== testId || $[107] !== title) {
        t21 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
            ...rest,
            ref: t11,
            "aria-current": ariaCurrent,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            onClick: handleTriggerClick,
            onMouseOver: t12,
            onMouseOut: t13,
            onMouseMove: t14,
            onMouseDown: t15,
            onFocus: t16,
            onBlur: t17,
            "aria-describedby": t18,
            testId: testId,
            title: title,
            xcss: t19,
            style: t20,
            children: content
        });
        $[90] = ariaCurrent;
        $[91] = ariaLabel;
        $[92] = ariaLabelledBy;
        $[93] = content;
        $[94] = handleTriggerClick;
        $[95] = rest;
        $[96] = t11;
        $[97] = t12;
        $[98] = t13;
        $[99] = t14;
        $[100] = t15;
        $[101] = t16;
        $[102] = t17;
        $[103] = t18;
        $[104] = t19;
        $[105] = t20;
        $[106] = testId;
        $[107] = title;
        $[108] = t21;
    } else t21 = $[108];
    let t22;
    if ($[109] !== t10 || $[110] !== t21) {
        t22 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
            children: [
                t10,
                t21
            ]
        });
        $[109] = t10;
        $[110] = t21;
        $[111] = t22;
    } else t22 = $[111];
    return t22;
} : ({ analyticsContext: analyticsContext, elemBefore: elemBefore, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $145f806ee7333746$var$noop, target: target, testId: testId, children: children, title: title, truncationWidth: truncationWidth, triggerProps: triggerProps, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-current': ariaCurrent, 'aria-describedby': ariaDescribedBy, onBlur: onBlur, onFocus: onFocus, onMouseDown: onMouseDown, onMouseMove: onMouseMove, onMouseOut: onMouseOut, onMouseOver: onMouseOver, ...rest }, ref)=>{
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const breadcrumbsSize = (0, $jiltW.useBreadcrumbsSize)();
    const isSmall = breadcrumbsSize === 'small';
    const handleClick = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$145f806ee7333746$var$analyticsAttributes
    });
    const handleTriggerClick = (event)=>{
        triggerProps?.onClick?.(event);
        handleClick(event);
    };
    const controlRef = (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') ? ref : undefined;
    const textRef = (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') ? undefined : ref;
    const iconElement = resolvedElemBefore && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": testId && `${testId}--icon-before`,
        className: (0, $hekY6.default)([
            $145f806ee7333746$var$styles.iconWrapper,
            $145f806ee7333746$var$unboundedStyles.iconWrapper,
            (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && $145f806ee7333746$var$styles.iconWrapperExternal,
            isSmall && $145f806ee7333746$var$styles.iconWrapperExternalSmall,
            isSmall && $145f806ee7333746$var$unboundedStyles.iconWrapperSmall
        ]),
        children: resolvedElemBefore
    });
    const content = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
        children: [
            !(0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && !isSmall && resolvedElemBefore,
            !(0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && isSmall && iconElement,
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                ref: textRef,
                className: (0, $hekY6.default)([
                    $145f806ee7333746$var$styles.text,
                    truncationWidth != null && (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && $145f806ee7333746$var$styles.textWithTruncation
                ]),
                children: children
            }),
            iconAfter
        ]
    });
    if (href) return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
        children: [
            (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && iconElement,
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
                ...rest,
                ref: controlRef,
                "aria-current": ariaCurrent,
                "aria-label": ariaLabel,
                "aria-labelledby": ariaLabelledBy,
                href: href,
                onClick: handleTriggerClick,
                onMouseOver: triggerProps?.onMouseOver ?? onMouseOver,
                onMouseOut: triggerProps?.onMouseOut ?? onMouseOut,
                onMouseMove: triggerProps?.onMouseMove ?? onMouseMove,
                onMouseDown: triggerProps?.onMouseDown ?? onMouseDown,
                onFocus: triggerProps?.onFocus ?? onFocus,
                onBlur: triggerProps?.onBlur ?? onBlur,
                "aria-describedby": triggerProps?.['aria-describedby'] ?? ariaDescribedBy,
                target: target,
                rel: target === '_blank' ? 'noopener noreferrer' : undefined,
                testId: testId,
                title: title,
                xcss: (0, $w6R6I.cx)($145f806ee7333746$var$styles.root, isSmall && $145f806ee7333746$var$styles.rootSmall, (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && $145f806ee7333746$var$styles.rootRefresh, truncationWidth != null && (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && $145f806ee7333746$var$styles.withTruncation, truncationWidth == null && $145f806ee7333746$var$styles.withoutTruncation, (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') && $145f806ee7333746$var$styles.interactiveMotion),
                style: {
                    maxWidth: truncationWidth
                },
                children: content
            })
        ]
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
        children: [
            (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && iconElement,
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                ...rest,
                ref: controlRef,
                "aria-current": ariaCurrent,
                "aria-label": ariaLabel,
                "aria-labelledby": ariaLabelledBy,
                onClick: handleTriggerClick,
                onMouseOver: triggerProps?.onMouseOver ?? onMouseOver,
                onMouseOut: triggerProps?.onMouseOut ?? onMouseOut,
                onMouseMove: triggerProps?.onMouseMove ?? onMouseMove,
                onMouseDown: triggerProps?.onMouseDown ?? onMouseDown,
                onFocus: triggerProps?.onFocus ?? onFocus,
                onBlur: triggerProps?.onBlur ?? onBlur,
                "aria-describedby": triggerProps?.['aria-describedby'] ?? ariaDescribedBy,
                testId: testId,
                title: title,
                xcss: (0, $w6R6I.cx)($145f806ee7333746$var$styles.root, isSmall && $145f806ee7333746$var$styles.rootSmall, (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && $145f806ee7333746$var$styles.rootRefresh, truncationWidth != null && (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && $145f806ee7333746$var$styles.withTruncation, truncationWidth == null && $145f806ee7333746$var$styles.withoutTruncation, (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') && $145f806ee7333746$var$styles.interactiveMotion),
                style: {
                    maxWidth: truncationWidth
                },
                children: content
            })
        ]
    });
});
var $145f806ee7333746$export$2e2bcd8739ae039 = $145f806ee7333746$var$Step;
module.exports["default"] = $145f806ee7333746$export$2e2bcd8739ae039;

});

parcelRegister("bggFv", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7r5Hr = parcelRequire("7r5Hr");


var $7ZB0A = parcelRequire("7ZB0A");


var $dpsRj = parcelRequire("dpsRj");


var $iDrrr = parcelRequire("iDrrr");

const $2ab552b1d511ed22$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $2ab552b1d511ed22$var$noop = (0, $dpsRj.default);
/**
 * __Step__
 *
 * A button that represents a single step in a breadcrumbs component.
 */ const $2ab552b1d511ed22$var$StepOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(24);
    let analyticsContext;
    let component;
    let iconAfter;
    let iconBefore;
    let props;
    let t1;
    let t2;
    let t3;
    let target;
    let testId;
    if ($[0] !== t0) {
        ({ analyticsContext: analyticsContext, component: component, hasOverflow: t1, href: t2, iconAfter: iconAfter, iconBefore: iconBefore, onClick: t3, target: target, testId: testId, ...props } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = component;
        $[3] = iconAfter;
        $[4] = iconBefore;
        $[5] = props;
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
        $[9] = target;
        $[10] = testId;
    } else {
        analyticsContext = $[1];
        component = $[2];
        iconAfter = $[3];
        iconBefore = $[4];
        props = $[5];
        t1 = $[6];
        t2 = $[7];
        t3 = $[8];
        target = $[9];
        testId = $[10];
    }
    const hasOverflow = t1 === undefined ? true : t1;
    const href = t2 === undefined ? "#" : t2;
    const onClickProvided = t3 === undefined ? $2ab552b1d511ed22$var$noop : t3;
    let t4;
    if ($[11] !== analyticsContext || $[12] !== onClickProvided) {
        t4 = {
            fn: onClickProvided,
            action: "clicked",
            analyticsData: analyticsContext,
            ...$2ab552b1d511ed22$var$analyticsAttributes
        };
        $[11] = analyticsContext;
        $[12] = onClickProvided;
        $[13] = t4;
    } else t4 = $[13];
    const handleClicked = (0, $7r5Hr.usePlatformLeafEventHandler)(t4);
    const resolvedIconAfter = (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") ? undefined : hasOverflow ? undefined : iconAfter;
    const t5 = hasOverflow ? undefined : iconBefore;
    let t6;
    if ($[14] !== component || $[15] !== handleClicked || $[16] !== href || $[17] !== props || $[18] !== ref || $[19] !== resolvedIconAfter || $[20] !== t5 || $[21] !== target || $[22] !== testId) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZB0A.default), {
            ...props,
            appearance: "subtle-link",
            component: component,
            href: href,
            iconAfter: resolvedIconAfter,
            iconBefore: t5,
            onClick: handleClicked,
            ref: ref,
            spacing: "none",
            target: target,
            testId: testId
        });
        $[14] = component;
        $[15] = handleClicked;
        $[16] = href;
        $[17] = props;
        $[18] = ref;
        $[19] = resolvedIconAfter;
        $[20] = t5;
        $[21] = target;
        $[22] = testId;
        $[23] = t6;
    } else t6 = $[23];
    return t6;
} : ({ analyticsContext: analyticsContext, component: component, hasOverflow: hasOverflow = true, href: href = '#', iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $2ab552b1d511ed22$var$noop, target: target, testId: testId, ...props }, ref)=>{
    const handleClicked = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$2ab552b1d511ed22$var$analyticsAttributes
    });
    const resolvedIconAfter = (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') ? undefined : hasOverflow ? undefined : iconAfter;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZB0A.default), {
        ...props,
        appearance: "subtle-link",
        component: component,
        href: href,
        iconAfter: resolvedIconAfter,
        iconBefore: hasOverflow ? undefined : iconBefore,
        onClick: handleClicked,
        ref: ref,
        spacing: "none",
        target: target,
        testId: testId
    });
});
var $2ab552b1d511ed22$export$2e2bcd8739ae039 = $2ab552b1d511ed22$var$StepOld;
module.exports["default"] = $2ab552b1d511ed22$export$2e2bcd8739ae039;

});

parcelRegister("a9aSv", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $5EzLH = parcelRequire("5EzLH");


var $iDrrr = parcelRequire("iDrrr");

const $19ad0c297e7cfe22$var$shimmerKeyframes = null;
const $19ad0c297e7cfe22$var$skeletonStyles = null;
const $19ad0c297e7cfe22$var$activeShimmerStyles = null; /**
                                   * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
                                   * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
                                   * which makes things simpler than doing an `isServer` check or a `null` check.
                                   *
                                   * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
                                   */ 
const $19ad0c297e7cfe22$var$useLayoutEffect = typeof window === 'undefined' ? (0, $cozmU.useEffect) : (0, $cozmU.useLayoutEffect); /**
                                                                                          * __Skeleton__
                                                                                          *
                                                                                          * A skeleton acts as a placeholder for content, usually while the content loads.
                                                                                          *
                                                                                          * - [Examples](https://atlassian.design/components/skeleton/examples)
                                                                                          * - [Code](https://atlassian.design/components/skeleton/code)
                                                                                          */ 
const $19ad0c297e7cfe22$var$Skeleton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { width: width, height: height, borderRadius: t1, color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: t2, groupName: groupName, interactionName: interactionName, testId: testId } = t0;
    const borderRadius = t1 === undefined ? "var(--ds-radius-small, 4px)" : t1;
    const isShimmering = t2 === undefined ? false : t2;
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $cozmU.useContext)((0, $5EzLH.default));
    let t3;
    let t4;
    if ($[0] !== context || $[1] !== interactionName) {
        t3 = ()=>{
            if (context != null && (0, $iDrrr.fg)("platform-dst-skeleton-ufo-hold")) return context.hold(interactionName);
        };
        t4 = [
            context,
            interactionName
        ];
        $[0] = context;
        $[1] = interactionName;
        $[2] = t3;
        $[3] = t4;
    } else {
        t3 = $[2];
        t4 = $[3];
    }
    $19ad0c297e7cfe22$var$useLayoutEffect(t3, t4);
    const t5 = color && ShimmeringEndColor ? color : undefined;
    const t6 = color && ShimmeringEndColor ? ShimmeringEndColor : undefined;
    let t7;
    if ($[4] !== borderRadius || $[5] !== color || $[6] !== height || $[7] !== t5 || $[8] !== t6 || $[9] !== width) {
        t7 = {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            "--ds-skeleton-from-color": t5,
            "--ds-skeleton-to-color": t6
        };
        $[4] = borderRadius;
        $[5] = color;
        $[6] = height;
        $[7] = t5;
        $[8] = t6;
        $[9] = width;
        $[10] = t7;
    } else t7 = $[10];
    const t8 = t7;
    let t9;
    if ($[11] !== groupDataAttribute) {
        t9 = groupDataAttribute && {
            [groupDataAttribute]: "true"
        };
        $[11] = groupDataAttribute;
        $[12] = t9;
    } else t9 = $[12];
    const t10 = isShimmering && "";
    const t11 = isShimmering && "_1gBibyKB6V";
    let t12;
    if ($[13] !== t10 || $[14] !== t11) {
        t12 = (0, $hekY6.default)([
            "_0uDzWjkSs3 _0nFVCGfONH _03m2nySHWH _43vdfTHVQb _0KLXruGsB2",
            t10,
            t11
        ]);
        $[13] = t10;
        $[14] = t11;
        $[15] = t12;
    } else t12 = $[15];
    let t13;
    if ($[16] !== t12 || $[17] !== t8 || $[18] !== t9 || $[19] !== testId) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": testId,
            style: t8,
            ...t9,
            className: t12
        });
        $[16] = t12;
        $[17] = t8;
        $[18] = t9;
        $[19] = testId;
        $[20] = t13;
    } else t13 = $[20];
    return t13;
} : ({ width: width, height: height, borderRadius: borderRadius = "var(--ds-radius-small, 4px)", color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, interactionName: interactionName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $cozmU.useContext)((0, $5EzLH.default));
    $19ad0c297e7cfe22$var$useLayoutEffect(()=>{
        if (context != null && (0, $iDrrr.fg)('platform-dst-skeleton-ufo-hold')) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": testId,
        style: {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        },
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        },
        className: (0, $hekY6.default)([
            "_0uDzWjkSs3 _0nFVCGfONH _03m2nySHWH _43vdfTHVQb _0KLXruGsB2",
            isShimmering && "",
            isShimmering && "_1gBibyKB6V"
        ])
    });
};
var $19ad0c297e7cfe22$export$2e2bcd8739ae039 = $19ad0c297e7cfe22$var$Skeleton;
module.exports["default"] = $19ad0c297e7cfe22$export$2e2bcd8739ae039;

});

parcelRegister("4HuLY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $r8hvx = parcelRequire("r8hvx");

var $196c0e198225aa23$export$49ecbc2ec404bcce = /*#__PURE__*/ function(HUB_FEATURES) {
    HUB_FEATURES["BREADCRUMBS"] = "BREADCRUMBS";
    HUB_FEATURES["CONFIGURABLE_SITE_TREE"] = "CONFIGURABLE_SITE_TREE";
    HUB_FEATURES["DRAFT_MODE"] = "DRAFT_MODE";
    return HUB_FEATURES;
}({});
const $196c0e198225aa23$var$HUB_FEATURE_CONFIG = {
    ["BREADCRUMBS"]: {
        contextKey: 'enable_hub_breadcrumbs',
        isPlatformEnabled: ()=>(0, $iDrrr.fg)('enable_hub_breadcrumbs')
    },
    ["CONFIGURABLE_SITE_TREE"]: {
        contextKey: 'help_hubs_configurable_site_tree',
        isPlatformEnabled: ()=>(0, $iDrrr.fg)('help_hubs_configurable_site_tree')
    },
    ["DRAFT_MODE"]: {
        contextKey: 'help_hubs_draft_mode',
        isPlatformEnabled: ()=>(0, $iDrrr.fg)('help_hubs_draft_mode')
    }
};
function $196c0e198225aa23$export$5a7b13b33b3b4bc8(features) {
    const ctx = (0, $cozmU.useContext)((0, $r8hvx.HubContext));
    const next = features.map((feature)=>{
        const { contextKey: contextKey, isPlatformEnabled: isPlatformEnabled } = $196c0e198225aa23$var$HUB_FEATURE_CONFIG[feature];
        const isContextEnabled = ctx?.featureFlags?.[contextKey] === true;
        return isContextEnabled && isPlatformEnabled();
    });
    // Reuse the previous array when values match so deps on the return value
    // do not re-fire every render.
    const cachedRef = (0, $cozmU.useRef)(next);
    const cached = cachedRef.current;
    if (cached.length !== next.length || next.some((value, index)=>value !== cached[index])) cachedRef.current = next;
    return cachedRef.current;
}
module.exports["HUB_FEATURES"] = $196c0e198225aa23$export$49ecbc2ec404bcce;
module.exports["useIsHubFeatureEnabled"] = $196c0e198225aa23$export$5a7b13b33b3b4bc8;

});

parcelRegister("fMvIa", function(module, exports) {
$parcel$export(module.exports, "useRouter", () => (parcelRequire("fcvZw")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("idnP4")).useRouterActions);
$parcel$export(module.exports, "Link", () => (parcelRequire("8Dc6h")).default);
$parcel$export(module.exports, "RouterStore", () => (parcelRequire("hFkZi")).RouterStore);
$parcel$export(module.exports, "useRouterStoreActions", () => (parcelRequire("hFkZi")).useRouterStoreActions);

parcelRequire("cKmxI");
var $fcvZw = parcelRequire("fcvZw");
var $idnP4 = parcelRequire("idnP4");

parcelRequire("eCzAr");
var $8Dc6h = parcelRequire("8Dc6h");

parcelRequire("htyBH");
var $ac1eE = parcelRequire("ac1eE");
var $jwQVI = parcelRequire("jwQVI");
var $epPJ3 = parcelRequire("epPJ3");
var $htyBH = parcelRequire("htyBH");


var $3xrKK = parcelRequire("3xrKK");


var $hFkZi = parcelRequire("hFkZi");


var $jjIOx = parcelRequire("jjIOx");

parcelRequire("9Nkr4");
var $97ZVl = parcelRequire("97ZVl");
var $RNy7H = parcelRequire("RNy7H");
var $3ct2F = parcelRequire("3ct2F");


});

parcelRegister("2lscT", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");














var $5SGpQ = parcelRequire("5SGpQ");


var $lpNn5 = parcelRequire("lpNn5");


var $1sXWi = parcelRequire("1sXWi");

const $bd8e48c4edd6c1ef$export$f32bddcb857301f3 = ({ mode: { iconButton: iconButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                borderRadius: "var(--ds-radius-full, 100%)",
                display: 'flex',
                margin: `0 ${"var(--ds-space-025, 2px)"}`,
                padding: "var(--ds-space-050, 4px)",
                height: 'auto',
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ...iconButton.default,
                ':hover': iconButton.hover,
                ':focus': iconButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                '&&': {
                    ...props.state === 'active' && iconButton.active
                },
                ...props.state === 'selected' && iconButton.selected,
                '> span': {
                    margin: 0
                }
            },
            spinnerStyles: spinnerStyles
        };
    };


const $9a8122532f332b44$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(48);
    let component;
    let href;
    let icon;
    let id;
    let isDisabled;
    let isSelected;
    let label;
    let onBlur;
    let onClick;
    let onFocus;
    let onMouseDown;
    let onMouseEnter;
    let onMouseLeave;
    let onMouseUp;
    let rest;
    let t0;
    let target;
    let testId;
    let theme;
    let tooltip;
    if ($[0] !== props) {
        ({ icon: icon, label: label, testId: testId, tooltip: tooltip, component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, theme: theme, isTooltipAnnouncementDisabled: t0, ...rest } = props);
        $[0] = props;
        $[1] = component;
        $[2] = href;
        $[3] = icon;
        $[4] = id;
        $[5] = isDisabled;
        $[6] = isSelected;
        $[7] = label;
        $[8] = onBlur;
        $[9] = onClick;
        $[10] = onFocus;
        $[11] = onMouseDown;
        $[12] = onMouseEnter;
        $[13] = onMouseLeave;
        $[14] = onMouseUp;
        $[15] = rest;
        $[16] = t0;
        $[17] = target;
        $[18] = testId;
        $[19] = theme;
        $[20] = tooltip;
    } else {
        component = $[1];
        href = $[2];
        icon = $[3];
        id = $[4];
        isDisabled = $[5];
        isSelected = $[6];
        label = $[7];
        onBlur = $[8];
        onClick = $[9];
        onFocus = $[10];
        onMouseDown = $[11];
        onMouseEnter = $[12];
        onMouseLeave = $[13];
        onMouseUp = $[14];
        rest = $[15];
        t0 = $[16];
        target = $[17];
        testId = $[18];
        theme = $[19];
        tooltip = $[20];
    }
    const isTooltipAnnouncementDisabled = t0 === undefined ? false : t0;
    const themeFromContext = (0, $1sXWi.useTheme)();
    let t1;
    if ($[21] !== theme || $[22] !== themeFromContext) {
        t1 = theme || (0, $bd8e48c4edd6c1ef$export$f32bddcb857301f3)(themeFromContext);
        $[21] = theme;
        $[22] = themeFromContext;
        $[23] = t1;
    } else t1 = $[23];
    let t2;
    if ($[24] !== component || $[25] !== href || $[26] !== icon || $[27] !== id || $[28] !== isDisabled || $[29] !== isSelected || $[30] !== label || $[31] !== onBlur || $[32] !== onClick || $[33] !== onFocus || $[34] !== onMouseDown || $[35] !== onMouseEnter || $[36] !== onMouseLeave || $[37] !== onMouseUp || $[38] !== ref || $[39] !== rest || $[40] !== t1 || $[41] !== target || $[42] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5SGpQ.default), {
            appearance: "primary",
            "aria-label": label,
            component: component,
            href: href,
            iconBefore: icon,
            id: id,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onBlur: onBlur,
            onClick: onClick,
            onFocus: onFocus,
            onMouseDown: onMouseDown,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseUp: onMouseUp,
            ref: ref,
            target: target,
            testId: testId,
            theme: t1,
            ...rest
        });
        $[24] = component;
        $[25] = href;
        $[26] = icon;
        $[27] = id;
        $[28] = isDisabled;
        $[29] = isSelected;
        $[30] = label;
        $[31] = onBlur;
        $[32] = onClick;
        $[33] = onFocus;
        $[34] = onMouseDown;
        $[35] = onMouseEnter;
        $[36] = onMouseLeave;
        $[37] = onMouseUp;
        $[38] = ref;
        $[39] = rest;
        $[40] = t1;
        $[41] = target;
        $[42] = testId;
        $[43] = t2;
    } else t2 = $[43];
    const button = t2;
    if (tooltip) {
        let t3;
        if ($[44] !== button || $[45] !== isTooltipAnnouncementDisabled || $[46] !== tooltip) {
            t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                content: tooltip,
                hideTooltipOnClick: true,
                isScreenReaderAnnouncementDisabled: isTooltipAnnouncementDisabled,
                children: button
            });
            $[44] = button;
            $[45] = isTooltipAnnouncementDisabled;
            $[46] = tooltip;
            $[47] = t3;
        } else t3 = $[47];
        return t3;
    }
    return button;
} : (props, ref)=>{
    const { icon: icon, label: label, testId: testId, tooltip: tooltip, component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, theme: theme, isTooltipAnnouncementDisabled: isTooltipAnnouncementDisabled = false, ...rest } = props;
    const themeFromContext = (0, $1sXWi.useTheme)();
    const button = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5SGpQ.default), {
        appearance: "primary",
        "aria-label": label,
        component: component,
        href: href,
        iconBefore: icon,
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $bd8e48c4edd6c1ef$export$f32bddcb857301f3)(themeFromContext),
        ...rest
    });
    if (tooltip) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
        content: tooltip,
        hideTooltipOnClick: true,
        isScreenReaderAnnouncementDisabled: isTooltipAnnouncementDisabled,
        children: button
    });
    return button;
});


const $98c741ba5769fc1f$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(41);
    let component;
    let href;
    let icon;
    let id;
    let isDisabled;
    let isSelected;
    let labelProp;
    let onBlur;
    let onClick;
    let onFocus;
    let onMouseDown;
    let onMouseEnter;
    let onMouseLeave;
    let onMouseUp;
    let rest;
    let target;
    let testId;
    let theme;
    let tooltip;
    if ($[0] !== props) {
        ({ component: component, href: href, icon: icon, id: id, isDisabled: isDisabled, isSelected: isSelected, label: labelProp, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props);
        $[0] = props;
        $[1] = component;
        $[2] = href;
        $[3] = icon;
        $[4] = id;
        $[5] = isDisabled;
        $[6] = isSelected;
        $[7] = labelProp;
        $[8] = onBlur;
        $[9] = onClick;
        $[10] = onFocus;
        $[11] = onMouseDown;
        $[12] = onMouseEnter;
        $[13] = onMouseLeave;
        $[14] = onMouseUp;
        $[15] = rest;
        $[16] = target;
        $[17] = testId;
        $[18] = theme;
        $[19] = tooltip;
    } else {
        component = $[1];
        href = $[2];
        icon = $[3];
        id = $[4];
        isDisabled = $[5];
        isSelected = $[6];
        labelProp = $[7];
        onBlur = $[8];
        onClick = $[9];
        onFocus = $[10];
        onMouseDown = $[11];
        onMouseEnter = $[12];
        onMouseLeave = $[13];
        onMouseUp = $[14];
        rest = $[15];
        target = $[16];
        testId = $[17];
        theme = $[18];
        tooltip = $[19];
    }
    const label = labelProp || (typeof tooltip === "string" ? tooltip : "Your profile and settings");
    let t0;
    if ($[20] !== component || $[21] !== href || $[22] !== icon || $[23] !== id || $[24] !== isDisabled || $[25] !== isSelected || $[26] !== label || $[27] !== onBlur || $[28] !== onClick || $[29] !== onFocus || $[30] !== onMouseDown || $[31] !== onMouseEnter || $[32] !== onMouseLeave || $[33] !== onMouseUp || $[34] !== ref || $[35] !== rest || $[36] !== target || $[37] !== testId || $[38] !== theme || $[39] !== tooltip) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            role: "listitem",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9a8122532f332b44$export$c25acd513dcc8062), {
                component: component,
                href: href,
                icon: icon,
                id: id,
                isDisabled: isDisabled,
                isSelected: isSelected,
                label: label,
                onBlur: onBlur,
                onClick: onClick,
                onFocus: onFocus,
                onMouseDown: onMouseDown,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseUp: onMouseUp,
                ref: ref,
                target: target,
                testId: testId,
                theme: theme,
                tooltip: tooltip,
                isTooltipAnnouncementDisabled: true,
                ...rest
            })
        });
        $[20] = component;
        $[21] = href;
        $[22] = icon;
        $[23] = id;
        $[24] = isDisabled;
        $[25] = isSelected;
        $[26] = label;
        $[27] = onBlur;
        $[28] = onClick;
        $[29] = onFocus;
        $[30] = onMouseDown;
        $[31] = onMouseEnter;
        $[32] = onMouseLeave;
        $[33] = onMouseUp;
        $[34] = ref;
        $[35] = rest;
        $[36] = target;
        $[37] = testId;
        $[38] = theme;
        $[39] = tooltip;
        $[40] = t0;
    } else t0 = $[40];
    return t0;
} : (props, ref)=>{
    const { component: component, href: href, icon: icon, id: id, isDisabled: isDisabled, isSelected: isSelected, label: labelProp, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    const label = labelProp || (typeof tooltip === 'string' ? tooltip : 'Your profile and settings');
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        role: "listitem",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9a8122532f332b44$export$c25acd513dcc8062), {
            component: component,
            href: href,
            icon: icon,
            id: id,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            onBlur: onBlur,
            onClick: onClick,
            onFocus: onFocus,
            onMouseDown: onMouseDown,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseUp: onMouseUp,
            ref: ref,
            target: target,
            testId: testId,
            // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
            theme: theme,
            tooltip: tooltip,
            isTooltipAnnouncementDisabled: true,
            ...rest
        })
    });
});
module.exports["Profile"] = $98c741ba5769fc1f$export$5120f2d0b8d4cab8;

});

parcelRegister("1sXWi", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $caBeY = parcelRequire("caBeY");

const $0c1aad5e33f23526$export$93d4e7f90805808f = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $caBeY.ThemeContext));
} : ()=>(0, $cozmU.useContext)((0, $caBeY.ThemeContext));
module.exports["useTheme"] = $0c1aad5e33f23526$export$93d4e7f90805808f;

});

parcelRegister("caBeY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $R7iGI = parcelRequire("R7iGI");

const $a725a8ada4f727cc$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $cozmU.createContext)((0, $R7iGI.defaultTheme));
module.exports["ThemeContext"] = $a725a8ada4f727cc$export$2c657da244d00bd6;

});

parcelRegister("R7iGI", function(module, exports) {

var $esp18 = parcelRequire("esp18");

const $86ec0bf94787f7c8$export$164de7ab8df77ef0 = (0, $esp18.atlassianTheme);
module.exports["defaultTheme"] = $86ec0bf94787f7c8$export$164de7ab8df77ef0;

});

parcelRegister("esp18", function(module, exports) {

var $jY2LF = parcelRequire("jY2LF");


var $3QMns = parcelRequire("3QMns");

const $e836efa0898b03ba$export$eeee8619e1b91cb0 = (0, $3QMns.generateTheme)({
    name: (0, $jY2LF.DEFAULT_THEME_NAME),
    backgroundColor: '#FFFFFF',
    highlightColor: '#0052CC'
});
module.exports["atlassianTheme"] = $e836efa0898b03ba$export$eeee8619e1b91cb0;

});

parcelRegister("jY2LF", function(module, exports) {
const $fa3ed95e05138600$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-pressed, #144794)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-hovered, #1558BC)",
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: ''
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: "var(--ds-surface, #FFFFFF)",
            color: "var(--ds-text-subtlest, #6B6E76)"
        },
        productHome: {
            backgroundColor: "var(--ds-text-brand, #1868DB)",
            color: "var(--ds-text, #292A2E)",
            borderRight: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
            // TODO: replace with token after brand refresh
            iconColor: '#357DE8',
            textColor: "var(--ds-text, #292A2E)"
        },
        primaryButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            }
        },
        search: {
            default: {
                backgroundColor: "var(--ds-background-input, #FFFFFF)",
                color: "var(--ds-text-subtlest, #6B6E76)",
                borderColor: "var(--ds-border-input, #8C8F97)"
            },
            focus: {
                borderColor: "var(--ds-border-focused, #4688EC)"
            },
            hover: {
                backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
            }
        },
        skeleton: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            opacity: 1
        }
    }
};
// Create deep copy of defaultTheme
const $fa3ed95e05138600$var$defaultThemeCopy = JSON.parse(JSON.stringify($fa3ed95e05138600$var$defaultTheme));
// Update iconColor and textColor in defaultThemeBrandRefresh
$fa3ed95e05138600$var$defaultThemeCopy.mode.productHome.iconColor = undefined;
$fa3ed95e05138600$var$defaultThemeCopy.mode.productHome.textColor = undefined;
const $fa3ed95e05138600$export$2491e13b198e597d = 'atlassian';
var $fa3ed95e05138600$export$2e2bcd8739ae039 = $fa3ed95e05138600$var$defaultTheme;
module.exports["DEFAULT_THEME_NAME"] = $fa3ed95e05138600$export$2491e13b198e597d;
module.exports["default"] = $fa3ed95e05138600$export$2e2bcd8739ae039;

});

parcelRegister("3QMns", function(module, exports) {

var $jY2LF = parcelRequire("jY2LF");


var $7hcrB = parcelRequire("7hcrB");


var $jIkZX = parcelRequire("jIkZX");


var $6DrQc = parcelRequire("6DrQc");


var $dZ8SJ = parcelRequire("dZ8SJ");


var $8T7KI = parcelRequire("8T7KI");

const $42bc0c8ea2a74a92$var$generateOpacityValue = (color)=>color === '#000000' ? 0.3 : 0.6;
const $42bc0c8ea2a74a92$var$generateButtonCSSStates = (colors, buttonType)=>{
    const { backgroundColor: backgroundColor, color: color, highlightColor: highlightColor } = colors;
    // Add less opacity for white text so it is still legible.
    const opacityValue = $42bc0c8ea2a74a92$var$generateOpacityValue(color);
    const isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $8T7KI.hexToRGBA)(backgroundColor, 0.65) : (0, $dZ8SJ.getContrastColor)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $6DrQc.getBoxShadow)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $6DrQc.getBoxShadow)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $8T7KI.hexToRGBA)(backgroundColor, 0.8) : (0, $dZ8SJ.getContrastColor)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $6DrQc.getBoxShadow)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $dZ8SJ.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $6DrQc.getBoxShadow)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $dZ8SJ.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $6DrQc.getBoxShadow)('transparent')
        }
    };
};
const $42bc0c8ea2a74a92$var$generateCreateButtonColors = (_themeBackground, themeHighlight)=>({
        backgroundColor: themeHighlight,
        color: (0, $jIkZX.generateTextColor)(themeHighlight),
        highlightColor: themeHighlight
    });
const $42bc0c8ea2a74a92$export$2e4ecffaca289a18 = (themeColors)=>{
    const { backgroundColor: backgroundColor, highlightColor: highlightColor, name: name } = themeColors;
    const color = (0, $jIkZX.generateTextColor)(backgroundColor);
    const colors = {
        ...themeColors,
        color: color
    };
    if (name === (0, $jY2LF.DEFAULT_THEME_NAME)) return 0, $7hcrB.defaultThemeBrandRefresh;
    return {
        mode: {
            create: $42bc0c8ea2a74a92$var$generateButtonCSSStates($42bc0c8ea2a74a92$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $42bc0c8ea2a74a92$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $42bc0c8ea2a74a92$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                iconColor: color,
                textColor: color,
                backgroundColor: highlightColor,
                borderRight: `${"var(--ds-border-width, 1px)"} solid ${(0, $8T7KI.hexToRGBA)(color, 0.5)}`
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $8T7KI.hexToRGBA)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $8T7KI.hexToRGBA)(highlightColor, 0.8),
                    boxShadow: (0, $6DrQc.getBoxShadow)((0, $8T7KI.hexToRGBA)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $dZ8SJ.getContrastColor)(0.1, $42bc0c8ea2a74a92$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};
module.exports["generateTheme"] = $42bc0c8ea2a74a92$export$2e4ecffaca289a18;

});

parcelRegister("7hcrB", function(module, exports) {

var $jY2LF = parcelRequire("jY2LF");

const $a303abd91c32b08e$var$defaultThemeCopy = JSON.parse(JSON.stringify((0, $jY2LF.default)));
const $a303abd91c32b08e$export$77823bc9863eaa03 = $a303abd91c32b08e$var$defaultThemeCopy;
module.exports["defaultThemeBrandRefresh"] = $a303abd91c32b08e$export$77823bc9863eaa03;

});

parcelRegister("jIkZX", function(module, exports) {

var $aELWC = parcelRequire("aELWC");


var $bDWMn = parcelRequire("bDWMn");

const $d156dcf17fd40e8f$export$10a10e7cd1193377 = (color)=>{
    const converted = (0, $bDWMn.convertHexShorthand)(color);
    return (0, $aELWC.default).contrastRatio(converted).hex;
};
module.exports["generateTextColor"] = $d156dcf17fd40e8f$export$10a10e7cd1193377;

});

parcelRegister("bDWMn", function(module, exports) {
const $00e839f9891a322a$var$hex = '[a-z0-9]';
const $00e839f9891a322a$var$shortHandHexColorPattern = new RegExp(`#(${$00e839f9891a322a$var$hex})(${$00e839f9891a322a$var$hex})(${$00e839f9891a322a$var$hex})`, 'i');
const $00e839f9891a322a$var$repeat = (str, times)=>[
        ...Array(times)
    ].map(()=>str).join('');
const $00e839f9891a322a$var$isShortHexColor = (color)=>color && color.length === 4;
const $00e839f9891a322a$var$completeHexColor = (colors)=>{
    const hex = colors.map((color)=>$00e839f9891a322a$var$repeat(color, 2)).join('');
    return `#${hex}`;
};
const $00e839f9891a322a$var$completeTriplet = (colors)=>`#${$00e839f9891a322a$var$repeat(colors[1], 6)}`;
const $00e839f9891a322a$var$isTriplet = (colors)=>colors[0] === colors[1] && colors[1] === colors[2];
const $00e839f9891a322a$export$db8d2130677f868c = (color)=>{
    if ($00e839f9891a322a$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        const matches = color.match($00e839f9891a322a$var$shortHandHexColorPattern);
        if (matches) {
            const colors = matches.slice(1, 4);
            if ($00e839f9891a322a$var$isTriplet(colors)) return $00e839f9891a322a$var$completeTriplet(colors);
            else return $00e839f9891a322a$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};
module.exports["convertHexShorthand"] = $00e839f9891a322a$export$db8d2130677f868c;

});

parcelRegister("6DrQc", function(module, exports) {
const $39c046d81b46dcab$export$bba5a971afe05444 = (color)=>`0 0 0 2px ${color}`;
module.exports["getBoxShadow"] = $39c046d81b46dcab$export$bba5a971afe05444;

});

parcelRegister("dZ8SJ", function(module, exports) {

var $aELWC = parcelRequire("aELWC");


var $8T7KI = parcelRequire("8T7KI");

const $51a91b894a1b5a60$export$77a1051494882576 = (contrastValue, opacityValue, color)=>(0, $8T7KI.hexToRGBA)((0, $aELWC.default).contrast(contrastValue, color).hex, opacityValue);
module.exports["getContrastColor"] = $51a91b894a1b5a60$export$77a1051494882576;

});

parcelRegister("8T7KI", function(module, exports) {

var $aELWC = parcelRequire("aELWC");

const $93f364b8cdab62de$export$7229be6d7219ee6a = (hex, opacity = 1)=>{
    const rgba = {
        ...(0, $aELWC.default).convert(hex).rgb,
        a: opacity
    };
    return `rgba(${Object.values(rgba).join(', ')})`;
};
module.exports["hexToRGBA"] = $93f364b8cdab62de$export$7229be6d7219ee6a;

});

parcelRegister("untPk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ebf482a6988f6298a86299ac42fdfe98>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05b5041c5b068c03$var$_react = $05b5041c5b068c03$var$_interopRequireDefault((parcelRequire("cozmU")));

var $05b5041c5b068c03$var$_iconNew = $05b5041c5b068c03$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $05b5041c5b068c03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Home".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/home
 * Usage guidance:
 * Single purpose - Reserved for home in navigation. When a user clicks on this, they should return to the homepage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $05b5041c5b068c03$var$HomeIcon = (props)=>/*#__PURE__*/ $05b5041c5b068c03$var$_react.default.createElement($05b5041c5b068c03$var$_iconNew.default, Object.assign({
        name: "HomeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.646.727a2 2 0 0 1 2.708 0l5 4.6A2 2 0 0 1 15 6.799V13a2 2 0 0 1-2 2H9.75a.75.75 0 0 1-.75-.75V9.5H7v4.75a.75.75 0 0 1-.75.75H3a2 2 0 0 1-2-2V6.799a2 2 0 0 1 .646-1.472zM8.339 1.83a.5.5 0 0 0-.678 0l-5 4.6a.5.5 0 0 0-.161.368V13a.5.5 0 0 0 .5.5h2.5V8.75A.75.75 0 0 1 6.25 8h3.5a.75.75 0 0 1 .75.75v4.75H13a.5.5 0 0 0 .5-.5V6.799a.5.5 0 0 0-.162-.368z" clip-rule="evenodd"/>`
    }, props));
$05b5041c5b068c03$var$HomeIcon.displayName = 'HomeIcon';
var $05b5041c5b068c03$var$_default = module.exports.default = $05b5041c5b068c03$var$HomeIcon;

});

parcelRegister("lskrC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9fa04d7bec8552f7cf5d65f57f0111e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f9ec1258c694af78$var$_react = $f9ec1258c694af78$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f9ec1258c694af78$var$_iconNew = $f9ec1258c694af78$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $f9ec1258c694af78$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Inbox".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/inbox
 * Usage guidance:
 * Multi purpose - Known uses: 'Your work' in Confluence, inbox, mail.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f9ec1258c694af78$var$InboxIcon = (props)=>/*#__PURE__*/ $f9ec1258c694af78$var$_react.default.createElement($f9ec1258c694af78$var$_iconNew.default, Object.assign({
        name: "InboxIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v5h3a.75.75 0 0 1 .75.75 1.75 1.75 0 1 0 3.5 0A.75.75 0 0 1 10.5 8h3V3a.5.5 0 0 0-.5-.5zm10.5 7h-2.337a3.251 3.251 0 0 1-6.326 0H2.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM12 6H4V4.5h8z" clip-rule="evenodd"/>`
    }, props));
$f9ec1258c694af78$var$InboxIcon.displayName = 'InboxIcon';
var $f9ec1258c694af78$var$_default = module.exports.default = $f9ec1258c694af78$var$InboxIcon;

});

parcelRegister("7Mix9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::113cd4523810e6c9fe05d0e52a1ca1f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a9b647a96a0e4d7$var$_react = $5a9b647a96a0e4d7$var$_interopRequireDefault((parcelRequire("cozmU")));

var $5a9b647a96a0e4d7$var$_iconNew = $5a9b647a96a0e4d7$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $5a9b647a96a0e4d7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Menu".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/menu
 * Usage guidance:
 * Single purpose - Reserved for accessing the menu in global app navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5a9b647a96a0e4d7$var$MenuIcon = (props)=>/*#__PURE__*/ $5a9b647a96a0e4d7$var$_react.default.createElement($5a9b647a96a0e4d7$var$_iconNew.default, Object.assign({
        name: "MenuIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M15 12.5V14H1v-1.5zm0-5.25v1.5H1v-1.5zM15 2v1.5H1V2z"/>`
    }, props));
$5a9b647a96a0e4d7$var$MenuIcon.displayName = 'MenuIcon';
var $5a9b647a96a0e4d7$var$_default = module.exports.default = $5a9b647a96a0e4d7$var$MenuIcon;

});

parcelRegister("d7SWg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $60458bc9967d0c01$var$noop = ()=>{};
const $60458bc9967d0c01$export$2c6067e95d1be081 = (0, $cozmU.createContext)({
    options: null,
    setOptions: $60458bc9967d0c01$var$noop
});
const $60458bc9967d0c01$export$ce205152a61c4e11 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($60458bc9967d0c01$export$2c6067e95d1be081);
} : ()=>(0, $cozmU.useContext)($60458bc9967d0c01$export$2c6067e95d1be081);
module.exports["useNavigationStyle"] = $60458bc9967d0c01$export$ce205152a61c4e11;

});

parcelRegister("67z7B", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lI7ls = parcelRequire("lI7ls");

parcelRequire("cvj4z");
var $imtAv = parcelRequire("imtAv");
var $aO6HO = parcelRequire("aO6HO");

const $735fd5e1bb83b60f$export$d3010bc2e9cc1386 = (to, currentLocation)=>(0, $lI7ls.createLocation)(to, null, undefined, currentLocation);
const $735fd5e1bb83b60f$var$isModifiedEvent = (event)=>event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
/**
 * React Resource Router does not apply the base URL when `to` is a string. because we do not pass basePath to the router, we instead pass it to the history.
 * Keep the displayed URL base-aware while navigating with the relative router location.
 */ // The server case is intentionally not handled until platform can safely access AJS metadata.
const $735fd5e1bb83b60f$var$getHref = (history, location)=>history.createHref(location);
const $735fd5e1bb83b60f$var$BaseUrlRespectedLink = ({ to: to, onClick: onClick, history: history, location: location, target: target, replace: replace, children: children, ...rest })=>{
    const toAsLocation = $735fd5e1bb83b60f$export$d3010bc2e9cc1386(to, location);
    const href = toAsLocation ? $735fd5e1bb83b60f$var$getHref(history, toAsLocation) : '';
    const wrappedOnClick = (0, $cozmU.useCallback)((event)=>{
        try {
            onClick?.(event);
        } catch (error) {
            event.preventDefault();
            throw error;
        }
        const isPrimaryClick = 'button' in event && event.button === 0;
        const isEnterKey = 'key' in event && event.key === 'Enter';
        if (!event.defaultPrevented && (isPrimaryClick || isEnterKey) && (!target || target === '_self') && !$735fd5e1bb83b60f$var$isModifiedEvent(event)) {
            event.preventDefault();
            const method = replace ? history.replace : history.push;
            method($735fd5e1bb83b60f$export$d3010bc2e9cc1386(to, location));
        }
    }, [
        history,
        location,
        onClick,
        replace,
        target,
        to
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $imtAv.default), {
        href: href,
        ...rest,
        target: target,
        onClick: wrappedOnClick
    }, children);
};
const $735fd5e1bb83b60f$var$BaseUrlRespectedLinkWithRouter = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ $cozmU.createElement((0, $aO6HO.RouterSubscriber), null, (router)=>{
            const { location: location } = router;
            const { history: history } = router;
            return /*#__PURE__*/ $cozmU.createElement($735fd5e1bb83b60f$var$BaseUrlRespectedLink, {
                location: location,
                history: history,
                ...props
            });
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ $cozmU.createElement((0, $aO6HO.RouterSubscriber), null, (router)=>{
        const { location: location } = router;
        const { history: history } = router;
        return /*#__PURE__*/ $cozmU.createElement($735fd5e1bb83b60f$var$BaseUrlRespectedLink, {
            location: location,
            history: history,
            ...props
        });
    });
var $735fd5e1bb83b60f$export$2e2bcd8739ae039 = $735fd5e1bb83b60f$var$BaseUrlRespectedLinkWithRouter;
module.exports["default"] = $735fd5e1bb83b60f$export$2e2bcd8739ae039;

});

parcelRegister("dS16R", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $1d6b90709e3afd07$var$_default_1 = (0, $kSwu1.defineMessages)({
    editSite: {
        id: "hub-app-shell.avatar-menu.edit-site",
        defaultMessage: "Edit site"
    },
    profile: {
        id: "hub-app-shell.avatar-menu.profile",
        defaultMessage: "Profile"
    },
    logout: {
        id: "hub-app-shell.avatar-menu.logout",
        defaultMessage: "Logout"
    }
});
var $1d6b90709e3afd07$export$2e2bcd8739ae039 = $1d6b90709e3afd07$var$_default_1;
module.exports["default"] = $1d6b90709e3afd07$export$2e2bcd8739ae039;

});

parcelRegister("iK7lw", function(module, exports) {
const $58563c9d63e704c0$var$MODELS_API_URL = '/rest/servicedesk/1/customer/models';
const $58563c9d63e704c0$export$9aabeb09177df765 = async (cloudUrl, helpCenterAri)=>{
    const response = await fetch(`${cloudUrl}${$58563c9d63e704c0$var$MODELS_API_URL}`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: {
                clientBasePath: cloudUrl,
                helpCenterAri: helpCenterAri
            },
            models: [
                'userRequestsCounts'
            ]
        })
    });
    return response.json();
};
module.exports["getRequestCount"] = $58563c9d63e704c0$export$9aabeb09177df765;

});

parcelRegister("7TPw9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

/**
 * @generated SignedSource<<0b420321b8f0e6761b0f1e413d38c4e4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d32cd3ca5e3f8abd$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "moreDropdown_AtlassianHubAppShell",
    "selections": [
        {
            "alias": "customPages",
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                        "ids": [],
                        "type": "CUSTOM"
                    }
                }
            ],
            "concreteType": "HelpCenterPage",
            "kind": "LinkedField",
            "name": "pages",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "HelpCenterPageName",
                    "kind": "LinkedField",
                    "name": "name",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "default"
                        }
                    ]
                }
            ],
            "storageKey": "pages(filter:{\"ids\":[],\"type\":\"CUSTOM\"})"
        }
    ],
    "type": "HelpCenter"
};
$d32cd3ca5e3f8abd$var$node.hash = "bdf2ee4c0e7d81a58ea6f6250d6f062a";
var $d32cd3ca5e3f8abd$export$2e2bcd8739ae039 = $d32cd3ca5e3f8abd$var$node;



var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");

parcelRequire("fMvIa");
var $idnP4 = parcelRequire("idnP4");


var $7ZB0A = parcelRequire("7ZB0A");


var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");


var $hMaHH = parcelRequire("hMaHH");


var $9d7Pd = parcelRequire("9d7Pd");


var $8FgJC = parcelRequire("8FgJC");


var $iFlah = parcelRequire("iFlah");


var $iODl6 = parcelRequire("iODl6");


var $6Pqow = parcelRequire("6Pqow");


var $geKL9 = parcelRequire("geKL9");




const $ded1358e0c6181df$var$messages = (0, $kSwu1.defineMessages)({
    more: {
        id: "company-hub.hub-app-shell.navbar.nav-links.more",
        defaultMessage: "More"
    },
    moreDownIcon: {
        id: "company-hub.hub-app-shell.navbar.nav-links.more.chevron-down",
        defaultMessage: "Open more dropdown"
    },
    moreUpIcon: {
        id: "company-hub.hub-app-shell.navbar.nav-links.more.chevron-up",
        defaultMessage: "Close more dropdown"
    },
    pageIconLabel: {
        id: "company-hub.hub-app-shell.navbar.nav-links.more.page-icon-label",
        defaultMessage: "Page icon"
    }
});
var $ded1358e0c6181df$export$2e2bcd8739ae039 = $ded1358e0c6181df$var$messages;


const $5ef9cadcd9035e1b$var$styles = {
    overflowHidden: "_4bt5LAnQyn _2WAcuGnQyn",
    dropdownItems: "_2Zuz6Q2ADO"
};
const $5ef9cadcd9035e1b$var$motionStyles = {
    slideEntering: "_1gBibyJtnr _0nFVCGLrT7 _43vdfTjwM9",
    slideExiting: "_1gBibyMmpp _0nFVCGLrT7 _43vdfTyNAO"
};
const $5ef9cadcd9035e1b$export$6d7fd1d1521d3638 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(40);
    const { queryRef: queryRef, textColor: textColor, isMobile: isMobile } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { push: push } = (0, $idnP4.useRouterActions)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const data = (0, $6SsN4.useFragment)((0, $d32cd3ca5e3f8abd$export$2e2bcd8739ae039), queryRef);
    const customPages = data?.customPages;
    if (!customPages || customPages.length === 0) return null;
    if (isMobile) {
        let t1;
        if ($[0] !== formatMessage || $[1] !== isExpanded) {
            t1 = isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                label: formatMessage((0, $ded1358e0c6181df$export$2e2bcd8739ae039).moreUpIcon)
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: formatMessage((0, $ded1358e0c6181df$export$2e2bcd8739ae039).moreDownIcon)
            });
            $[0] = formatMessage;
            $[1] = isExpanded;
            $[2] = t1;
        } else t1 = $[2];
        let t2;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = ()=>setIsExpanded($5ef9cadcd9035e1b$var$_temp);
            $[3] = t2;
        } else t2 = $[3];
        let t3;
        if ($[4] !== formatMessage) {
            t3 = formatMessage((0, $ded1358e0c6181df$export$2e2bcd8739ae039).more);
            $[4] = formatMessage;
            $[5] = t3;
        } else t3 = $[5];
        let t4;
        if ($[6] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
                weight: "medium"
            }, t3);
            $[6] = t3;
            $[7] = t4;
        } else t4 = $[7];
        let t5;
        if ($[8] !== isExpanded || $[9] !== t1 || $[10] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                iconAfter: t1,
                onClick: t2,
                "aria-expanded": isExpanded
            }, t4);
            $[8] = isExpanded;
            $[9] = t1;
            $[10] = t4;
            $[11] = t5;
        } else t5 = $[11];
        let t6;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = (0, $hekY6.default)([
                $5ef9cadcd9035e1b$var$styles.overflowHidden
            ]);
            $[12] = t6;
        } else t6 = $[12];
        let t7;
        if ($[13] !== customPages || $[14] !== isExpanded || $[15] !== push) {
            t7 = isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iFlah.default), {
                enteringAnimationXcss: $5ef9cadcd9035e1b$var$motionStyles.slideEntering,
                exitingAnimationXcss: $5ef9cadcd9035e1b$var$motionStyles.slideExiting
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-testid": "more-dropdown-items",
                className: (0, $hekY6.default)([
                    $5ef9cadcd9035e1b$var$styles.dropdownItems
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), null, customPages.map((page)=>{
                const pageId = page?.id ? (0, $geKL9.HelpPageAri).parse(page.id).pageId : "";
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                    key: pageId,
                    testId: `nav-custom-page-${pageId}`,
                    onClick: ()=>{
                        push(`/page/${pageId}`);
                    }
                }, page?.name?.default);
            }))));
            $[13] = customPages;
            $[14] = isExpanded;
            $[15] = push;
            $[16] = t7;
        } else t7 = $[16];
        let t8;
        if ($[17] !== t7) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
                appear: true
            }, t7);
            $[17] = t7;
            $[18] = t8;
        } else t8 = $[18];
        let t9;
        if ($[19] !== t6 || $[20] !== t8) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: t6
            }, t8);
            $[19] = t6;
            $[20] = t8;
            $[21] = t9;
        } else t9 = $[21];
        let t10;
        if ($[22] !== t5 || $[23] !== t9) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t5, t9);
            $[22] = t5;
            $[23] = t9;
            $[24] = t10;
        } else t10 = $[24];
        return t10;
    }
    let t1;
    if ($[25] !== formatMessage || $[26] !== textColor) {
        t1 = (t2)=>{
            const { triggerRef: triggerRef, ...props } = t2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                ...props,
                appearance: "subtle",
                style: {
                    color: props.isSelected ? undefined : textColor
                },
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    label: formatMessage((0, $ded1358e0c6181df$export$2e2bcd8739ae039).moreDownIcon)
                }),
                ref: triggerRef
            }, formatMessage((0, $ded1358e0c6181df$export$2e2bcd8739ae039).more));
        };
        $[25] = formatMessage;
        $[26] = textColor;
        $[27] = t1;
    } else t1 = $[27];
    let t2;
    if ($[28] !== customPages || $[29] !== formatMessage || $[30] !== push) {
        let t3;
        if ($[32] !== formatMessage || $[33] !== push) {
            t3 = (page_0)=>{
                const pageId_0 = page_0?.id ? (0, $geKL9.HelpPageAri).parse(page_0.id).pageId : "";
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                    key: pageId_0,
                    testId: `nav-custom-page-${pageId_0}`,
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
                        label: formatMessage((0, $ded1358e0c6181df$export$2e2bcd8739ae039).pageIconLabel)
                    }),
                    onClick: ()=>{
                        push(`/page/${pageId_0}`);
                    }
                }, page_0?.name?.default);
            };
            $[32] = formatMessage;
            $[33] = push;
            $[34] = t3;
        } else t3 = $[34];
        t2 = customPages.map(t3);
        $[28] = customPages;
        $[29] = formatMessage;
        $[30] = push;
        $[31] = t2;
    } else t2 = $[31];
    let t3;
    if ($[35] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, t2);
        $[35] = t2;
        $[36] = t3;
    } else t3 = $[36];
    let t4;
    if ($[37] !== t1 || $[38] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            trigger: t1,
            shouldRenderToParent: true
        }, t3);
        $[37] = t1;
        $[38] = t3;
        $[39] = t4;
    } else t4 = $[39];
    return t4;
} : ({ queryRef: queryRef, textColor: textColor, isMobile: isMobile })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { push: push } = (0, $idnP4.useRouterActions)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const data = (0, $6SsN4.useFragment)((0, $d32cd3ca5e3f8abd$export$2e2bcd8739ae039), queryRef);
    const customPages = data?.customPages;
    if (!customPages || customPages.length === 0) return null;
    if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        iconAfter: isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
            label: formatMessage((0, $ded1358e0c6181df$export$2e2bcd8739ae039).moreUpIcon)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: formatMessage((0, $ded1358e0c6181df$export$2e2bcd8739ae039).moreDownIcon)
        }),
        onClick: ()=>setIsExpanded((prev)=>!prev),
        "aria-expanded": isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        weight: "medium"
    }, formatMessage((0, $ded1358e0c6181df$export$2e2bcd8739ae039).more))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $5ef9cadcd9035e1b$var$styles.overflowHidden
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
        appear: true
    }, isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iFlah.default), {
        enteringAnimationXcss: $5ef9cadcd9035e1b$var$motionStyles.slideEntering,
        exitingAnimationXcss: $5ef9cadcd9035e1b$var$motionStyles.slideExiting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "more-dropdown-items",
        className: (0, $hekY6.default)([
            $5ef9cadcd9035e1b$var$styles.dropdownItems
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), null, customPages.map((page)=>{
        const pageId = page?.id ? (0, $geKL9.HelpPageAri).parse(page.id).pageId : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            key: pageId,
            testId: `nav-custom-page-${pageId}`,
            onClick: ()=>{
                push(`/page/${pageId}`);
            }
        }, page?.name?.default);
    })))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                ...props,
                appearance: "subtle",
                style: {
                    color: props.isSelected ? undefined : textColor
                },
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    label: formatMessage((0, $ded1358e0c6181df$export$2e2bcd8739ae039).moreDownIcon)
                }),
                ref: triggerRef
            }, formatMessage((0, $ded1358e0c6181df$export$2e2bcd8739ae039).more)),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, customPages.map((page_0)=>{
        const pageId_0 = page_0?.id ? (0, $geKL9.HelpPageAri).parse(page_0.id).pageId : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            key: pageId_0,
            testId: `nav-custom-page-${pageId_0}`,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
                label: formatMessage((0, $ded1358e0c6181df$export$2e2bcd8739ae039).pageIconLabel)
            }),
            onClick: ()=>{
                push(`/page/${pageId_0}`);
            }
        }, page_0?.name?.default);
    })));
};
function $5ef9cadcd9035e1b$var$_temp(prev) {
    return !prev;
}
module.exports["MoreDropdown"] = $5ef9cadcd9035e1b$export$6d7fd1d1521d3638;

});

parcelRegister("59YRu", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

/**
 * @generated SignedSource<<5f1bffc73ab190c3ed149645d865f273>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ed886607e5376318$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "portalDropdown_AtlassianHubAppShell",
    "selections": [
        {
            "concreteType": "HelpCenterPortals",
            "kind": "LinkedField",
            "name": "portals",
            "plural": false,
            "selections": [
                {
                    "concreteType": "HelpCenterPortal",
                    "kind": "LinkedField",
                    "name": "portalsList",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "HelpCenter"
};
$ed886607e5376318$var$node.hash = "9321e563780af8e8cdc6d16d81e1564c";
var $ed886607e5376318$export$2e2bcd8739ae039 = $ed886607e5376318$var$node;



var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");

parcelRequire("fMvIa");
var $idnP4 = parcelRequire("idnP4");


var $7ZB0A = parcelRequire("7ZB0A");


var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");


var $hMaHH = parcelRequire("hMaHH");


var $9d7Pd = parcelRequire("9d7Pd");


var $8FgJC = parcelRequire("8FgJC");


var $iFlah = parcelRequire("iFlah");


var $iODl6 = parcelRequire("iODl6");


var $6Pqow = parcelRequire("6Pqow");


var $4HuLY = parcelRequire("4HuLY");




const $d97399a84a7f3dc6$var$messages = (0, $kSwu1.defineMessages)({
    pageIcon: {
        id: "company-hub.hub-app-shell.navbar.nav-links.portal-dropdown.page-icon.non-final",
        defaultMessage: "Page icon"
    },
    portalDownIcon: {
        defaultMessage: "Open portals dropdown",
        id: "company-hub.hub-app-shell.navbar.nav-links.portal-dropdown.chevron-down.non-final"
    },
    portalUpIcon: {
        defaultMessage: "Close portals dropdown",
        id: "company-hub.hub-app-shell.navbar.nav-links.portal-dropdown.chevron-up.non-final"
    },
    portals: {
        id: "company-hub.hub-app-shell.navbar.nav-links.portals",
        defaultMessage: "Portals"
    }
});
var $d97399a84a7f3dc6$export$2e2bcd8739ae039 = $d97399a84a7f3dc6$var$messages;


const $94a12285eaa7eea3$var$styles = {
    overflowHidden: "_4bt5LAnQyn _2WAcuGnQyn",
    dropdownItems: "_2Zuz6Q2ADO"
};
const $94a12285eaa7eea3$var$motionStyles = {
    slideEntering: "_1gBibyJtnr _0nFVCGLrT7 _43vdfTjwM9",
    slideExiting: "_1gBibyMmpp _0nFVCGLrT7 _43vdfTyNAO"
};
const $94a12285eaa7eea3$export$32e0c0d1c2f88773 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(54);
    const { queryRef: queryRef, textColor: textColor, isMobile: isMobile } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { push: push } = (0, $idnP4.useRouterActions)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            (0, $4HuLY.HUB_FEATURES).CONFIGURABLE_SITE_TREE
        ];
        $[0] = t1;
    } else t1 = $[0];
    const [isConfigurableSiteTreeEnabled] = (0, $4HuLY.useIsHubFeatureEnabled)(t1);
    const data = (0, $6SsN4.useFragment)((0, $ed886607e5376318$export$2e2bcd8739ae039), queryRef);
    const portalPages = data?.portals?.portalsList;
    if (!portalPages || portalPages.length === 0) return null;
    const hasSinglePortal = portalPages.length === 1;
    if (isMobile) {
        if (hasSinglePortal) {
            let t2;
            if ($[1] !== portalPages[0]?.id || $[2] !== push) {
                t2 = ()=>{
                    push(`/portal/${portalPages[0]?.id}`);
                };
                $[1] = portalPages[0]?.id;
                $[2] = push;
                $[3] = t2;
            } else t2 = $[3];
            const t3 = portalPages[0]?.name;
            let t4;
            if ($[4] !== t2 || $[5] !== t3) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                    onClick: t2
                }, t3);
                $[4] = t2;
                $[5] = t3;
                $[6] = t4;
            } else t4 = $[6];
            return t4;
        }
        let t2;
        if ($[7] !== formatMessage || $[8] !== isExpanded) {
            t2 = isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                label: formatMessage((0, $d97399a84a7f3dc6$export$2e2bcd8739ae039).portalUpIcon)
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: formatMessage((0, $d97399a84a7f3dc6$export$2e2bcd8739ae039).portalDownIcon)
            });
            $[7] = formatMessage;
            $[8] = isExpanded;
            $[9] = t2;
        } else t2 = $[9];
        let t3;
        if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = ()=>setIsExpanded($94a12285eaa7eea3$var$_temp);
            $[10] = t3;
        } else t3 = $[10];
        let t4;
        if ($[11] !== formatMessage) {
            t4 = formatMessage((0, $d97399a84a7f3dc6$export$2e2bcd8739ae039).portals);
            $[11] = formatMessage;
            $[12] = t4;
        } else t4 = $[12];
        let t5;
        if ($[13] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
                weight: "medium"
            }, t4);
            $[13] = t4;
            $[14] = t5;
        } else t5 = $[14];
        let t6;
        if ($[15] !== isExpanded || $[16] !== t2 || $[17] !== t5) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                iconAfter: t2,
                onClick: t3,
                "aria-expanded": isExpanded
            }, t5);
            $[15] = isExpanded;
            $[16] = t2;
            $[17] = t5;
            $[18] = t6;
        } else t6 = $[18];
        let t7;
        if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = (0, $hekY6.default)([
                $94a12285eaa7eea3$var$styles.overflowHidden
            ]);
            $[19] = t7;
        } else t7 = $[19];
        let t8;
        if ($[20] !== isExpanded || $[21] !== portalPages || $[22] !== push) {
            t8 = isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iFlah.default), {
                enteringAnimationXcss: $94a12285eaa7eea3$var$motionStyles.slideEntering,
                exitingAnimationXcss: $94a12285eaa7eea3$var$motionStyles.slideExiting
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-testid": "portal-dropdown-items",
                className: (0, $hekY6.default)([
                    $94a12285eaa7eea3$var$styles.dropdownItems
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), null, portalPages?.map((portal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                    key: portal?.id,
                    onClick: ()=>{
                        push(`/portal/${portal?.id}`);
                    }
                }, portal?.name)))));
            $[20] = isExpanded;
            $[21] = portalPages;
            $[22] = push;
            $[23] = t8;
        } else t8 = $[23];
        let t9;
        if ($[24] !== t8) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
                appear: true
            }, t8);
            $[24] = t8;
            $[25] = t9;
        } else t9 = $[25];
        let t10;
        if ($[26] !== t7 || $[27] !== t9) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: t7
            }, t9);
            $[26] = t7;
            $[27] = t9;
            $[28] = t10;
        } else t10 = $[28];
        let t11;
        if ($[29] !== t10 || $[30] !== t6) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t6, t10);
            $[29] = t10;
            $[30] = t6;
            $[31] = t11;
        } else t11 = $[31];
        return t11;
    }
    if (hasSinglePortal) {
        let t2;
        if ($[32] !== portalPages[0]?.id || $[33] !== push) {
            t2 = ()=>{
                push(`/portal/${portalPages[0]?.id}`);
            };
            $[32] = portalPages[0]?.id;
            $[33] = push;
            $[34] = t2;
        } else t2 = $[34];
        let t3;
        if ($[35] !== textColor) {
            t3 = {
                color: textColor
            };
            $[35] = textColor;
            $[36] = t3;
        } else t3 = $[36];
        const t4 = portalPages[0]?.name;
        let t5;
        if ($[37] !== t2 || $[38] !== t3 || $[39] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                appearance: "subtle",
                onClick: t2,
                style: t3
            }, t4);
            $[37] = t2;
            $[38] = t3;
            $[39] = t4;
            $[40] = t5;
        } else t5 = $[40];
        return t5;
    }
    let t2;
    if ($[41] !== formatMessage || $[42] !== textColor) {
        t2 = (t3)=>{
            const { triggerRef: triggerRef, ...props } = t3;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                ...props,
                appearance: "subtle",
                style: {
                    color: props.isSelected ? undefined : textColor
                },
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    label: formatMessage((0, $d97399a84a7f3dc6$export$2e2bcd8739ae039).portalDownIcon)
                }),
                ref: triggerRef
            }, formatMessage((0, $d97399a84a7f3dc6$export$2e2bcd8739ae039).portals));
        };
        $[41] = formatMessage;
        $[42] = textColor;
        $[43] = t2;
    } else t2 = $[43];
    let t3;
    if ($[44] !== formatMessage || $[45] !== isConfigurableSiteTreeEnabled || $[46] !== portalPages || $[47] !== push) {
        t3 = portalPages?.map((portal_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                key: portal_0?.id,
                onClick: ()=>{
                    push(`/portal/${portal_0?.id}`);
                },
                elemBefore: isConfigurableSiteTreeEnabled ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
                    label: formatMessage((0, $d97399a84a7f3dc6$export$2e2bcd8739ae039).pageIcon)
                })
            }, portal_0?.name));
        $[44] = formatMessage;
        $[45] = isConfigurableSiteTreeEnabled;
        $[46] = portalPages;
        $[47] = push;
        $[48] = t3;
    } else t3 = $[48];
    let t4;
    if ($[49] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, t3);
        $[49] = t3;
        $[50] = t4;
    } else t4 = $[50];
    let t5;
    if ($[51] !== t2 || $[52] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            trigger: t2,
            shouldRenderToParent: true
        }, t4);
        $[51] = t2;
        $[52] = t4;
        $[53] = t5;
    } else t5 = $[53];
    return t5;
} : ({ queryRef: queryRef, textColor: textColor, isMobile: isMobile })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { push: push } = (0, $idnP4.useRouterActions)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const [isConfigurableSiteTreeEnabled] = (0, $4HuLY.useIsHubFeatureEnabled)([
        (0, $4HuLY.HUB_FEATURES).CONFIGURABLE_SITE_TREE
    ]);
    const data = (0, $6SsN4.useFragment)((0, $ed886607e5376318$export$2e2bcd8739ae039), queryRef);
    const portalPages = data?.portals?.portalsList;
    if (!portalPages || portalPages.length === 0) return null;
    const hasSinglePortal = portalPages.length === 1;
    if (isMobile) {
        if (hasSinglePortal) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            onClick: ()=>{
                push(`/portal/${portalPages[0]?.id}`);
            }
        }, portalPages[0]?.name);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            iconAfter: isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                label: formatMessage((0, $d97399a84a7f3dc6$export$2e2bcd8739ae039).portalUpIcon)
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: formatMessage((0, $d97399a84a7f3dc6$export$2e2bcd8739ae039).portalDownIcon)
            }),
            onClick: ()=>setIsExpanded((prev)=>!prev),
            "aria-expanded": isExpanded
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
            weight: "medium"
        }, formatMessage((0, $d97399a84a7f3dc6$export$2e2bcd8739ae039).portals))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $94a12285eaa7eea3$var$styles.overflowHidden
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
            appear: true
        }, isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iFlah.default), {
            enteringAnimationXcss: $94a12285eaa7eea3$var$motionStyles.slideEntering,
            exitingAnimationXcss: $94a12285eaa7eea3$var$motionStyles.slideExiting
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "portal-dropdown-items",
            className: (0, $hekY6.default)([
                $94a12285eaa7eea3$var$styles.dropdownItems
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), null, portalPages?.map((portal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                key: portal?.id,
                onClick: ()=>{
                    push(`/portal/${portal?.id}`);
                }
            }, portal?.name))))))));
    }
    if (hasSinglePortal) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        onClick: ()=>{
            push(`/portal/${portalPages[0]?.id}`);
        },
        style: {
            color: textColor
        }
    }, portalPages[0]?.name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                ...props,
                appearance: "subtle",
                style: {
                    color: props.isSelected ? undefined : textColor
                },
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    label: formatMessage((0, $d97399a84a7f3dc6$export$2e2bcd8739ae039).portalDownIcon)
                }),
                ref: triggerRef
            }, formatMessage((0, $d97399a84a7f3dc6$export$2e2bcd8739ae039).portals)),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, portalPages?.map((portal_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            key: portal_0?.id,
            onClick: ()=>{
                push(`/portal/${portal_0?.id}`);
            },
            elemBefore: isConfigurableSiteTreeEnabled ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
                label: formatMessage((0, $d97399a84a7f3dc6$export$2e2bcd8739ae039).pageIcon)
            })
        }, portal_0?.name))));
};
function $94a12285eaa7eea3$var$_temp(prev) {
    return !prev;
}
module.exports["PortalDropdown"] = $94a12285eaa7eea3$export$32e0c0d1c2f88773;

});

parcelRegister("i4PiE", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

/**
 * @generated SignedSource<<1c0759b364a6890ded896701bb942cb0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f4e1b1d1c8ca412d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "topicDropdown_AtlassianHubAppShell",
    "selections": [
        {
            "alias": "topicPages",
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                        "ids": [],
                        "type": "TOPIC"
                    }
                }
            ],
            "concreteType": "HelpCenterPage",
            "kind": "LinkedField",
            "name": "pages",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "HelpCenterPageName",
                    "kind": "LinkedField",
                    "name": "name",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "default"
                        }
                    ]
                }
            ],
            "storageKey": "pages(filter:{\"ids\":[],\"type\":\"TOPIC\"})"
        }
    ],
    "type": "HelpCenter"
};
$f4e1b1d1c8ca412d$var$node.hash = "9aa0d54a463ddf69b87af168a98c5079";
var $f4e1b1d1c8ca412d$export$2e2bcd8739ae039 = $f4e1b1d1c8ca412d$var$node;



var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");

parcelRequire("fMvIa");
var $idnP4 = parcelRequire("idnP4");


var $7ZB0A = parcelRequire("7ZB0A");


var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");


var $9d7Pd = parcelRequire("9d7Pd");


var $8FgJC = parcelRequire("8FgJC");


var $iFlah = parcelRequire("iFlah");


var $iODl6 = parcelRequire("iODl6");


var $iDrrr = parcelRequire("iDrrr");


var $4aRua = parcelRequire("4aRua");


var $geKL9 = parcelRequire("geKL9");




const $9c7bf96141f104f4$var$messages = (0, $kSwu1.defineMessages)({
    topics: {
        id: "hub-app-shell.navbar.nav-links.topic-dropdown.topics",
        defaultMessage: "Topics"
    },
    topicDownIcon: {
        id: "hub-app-shell.navbar.nav-links.topic-dropdown.topicDownIcon",
        defaultMessage: "Open topics dropdown"
    },
    topicUpIcon: {
        id: "hub-app-shell.navbar.nav-links.topic-dropdown.topicUpIcon",
        defaultMessage: "Close topics dropdown"
    }
});
var $9c7bf96141f104f4$export$2e2bcd8739ae039 = $9c7bf96141f104f4$var$messages;


const $0b604717a3654663$var$styles = {
    overflowHidden: "_4bt5LAnQyn _2WAcuGnQyn",
    dropdownItems: "_2Zuz6Q2ADO"
};
const $0b604717a3654663$var$motionStyles = {
    slideEntering: "_1gBibyJtnr _0nFVCGLrT7 _43vdfTjwM9",
    slideExiting: "_1gBibyMmpp _0nFVCGLrT7 _43vdfTyNAO"
};
const $0b604717a3654663$var$getPageIdFromAri = (pageAri)=>{
    try {
        return (0, $geKL9.HelpPageAri).parse(pageAri).pageId;
    } catch  {
        return null;
    }
}; /**
    * The navbar's Topics menu.
    *
    * Unlike `PortalDropdown`, a single topic still renders as the `Topics` menu
    * rather than collapsing to the topic's own name: "Topics" is a category, so
    * collapsing it would put one topic's title in the navbar and reshape the nav as
    * topics come and go.
    *
    * Draft handling needs nothing here — `helpCenterById` is already resolved with
    * `isDraft`, so the parent query decides whether draft or live topics come back,
    * exactly as it does for the custom pages in `MoreDropdown`.
    */ 
const $0b604717a3654663$export$ffcc4c72ae603c4e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(40);
    const { queryRef: queryRef, textColor: textColor, isMobile: isMobile } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { push: push } = (0, $idnP4.useRouterActions)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const data = (0, $6SsN4.useFragment)((0, $f4e1b1d1c8ca412d$export$2e2bcd8739ae039), queryRef);
    const topicPages = data?.topicPages;
    if (!(0, $iDrrr.fg)("hubs_premium_upsell") || !topicPages || topicPages.length === 0) return null;
    let t1;
    if ($[0] !== push) {
        t1 = (pageAri)=>{
            const pageId = pageAri ? $0b604717a3654663$var$getPageIdFromAri(pageAri) : null;
            if (pageId) push(`/page/${pageId}`);
        };
        $[0] = push;
        $[1] = t1;
    } else t1 = $[1];
    const openTopic = t1;
    const topicTestId = $0b604717a3654663$var$_temp;
    if (isMobile) {
        let t2;
        if ($[2] !== formatMessage || $[3] !== isExpanded) {
            t2 = isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                label: formatMessage((0, $9c7bf96141f104f4$export$2e2bcd8739ae039).topicUpIcon)
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: formatMessage((0, $9c7bf96141f104f4$export$2e2bcd8739ae039).topicDownIcon)
            });
            $[2] = formatMessage;
            $[3] = isExpanded;
            $[4] = t2;
        } else t2 = $[4];
        let t3;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = ()=>setIsExpanded($0b604717a3654663$var$_temp2);
            $[5] = t3;
        } else t3 = $[5];
        let t4;
        if ($[6] !== formatMessage) {
            t4 = formatMessage((0, $9c7bf96141f104f4$export$2e2bcd8739ae039).topics);
            $[6] = formatMessage;
            $[7] = t4;
        } else t4 = $[7];
        let t5;
        if ($[8] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                weight: "medium"
            }, t4);
            $[8] = t4;
            $[9] = t5;
        } else t5 = $[9];
        let t6;
        if ($[10] !== isExpanded || $[11] !== t2 || $[12] !== t5) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                iconAfter: t2,
                onClick: t3,
                "aria-expanded": isExpanded
            }, t5);
            $[10] = isExpanded;
            $[11] = t2;
            $[12] = t5;
            $[13] = t6;
        } else t6 = $[13];
        let t7;
        if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = (0, $hekY6.default)([
                $0b604717a3654663$var$styles.overflowHidden
            ]);
            $[14] = t7;
        } else t7 = $[14];
        let t8;
        if ($[15] !== isExpanded || $[16] !== openTopic || $[17] !== topicPages) {
            t8 = isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iFlah.default), {
                enteringAnimationXcss: $0b604717a3654663$var$motionStyles.slideEntering,
                exitingAnimationXcss: $0b604717a3654663$var$motionStyles.slideExiting
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-testid": "topic-dropdown-items",
                className: (0, $hekY6.default)([
                    $0b604717a3654663$var$styles.dropdownItems
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), null, topicPages.map((topic)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                    key: topic?.id,
                    testId: topicTestId(topic?.id),
                    onClick: ()=>openTopic(topic?.id)
                }, topic?.name?.default ?? "")))));
            $[15] = isExpanded;
            $[16] = openTopic;
            $[17] = topicPages;
            $[18] = t8;
        } else t8 = $[18];
        let t9;
        if ($[19] !== t8) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
                appear: true
            }, t8);
            $[19] = t8;
            $[20] = t9;
        } else t9 = $[20];
        let t10;
        if ($[21] !== t7 || $[22] !== t9) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: t7
            }, t9);
            $[21] = t7;
            $[22] = t9;
            $[23] = t10;
        } else t10 = $[23];
        let t11;
        if ($[24] !== t10 || $[25] !== t6) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t6, t10);
            $[24] = t10;
            $[25] = t6;
            $[26] = t11;
        } else t11 = $[26];
        return t11;
    }
    let t2;
    if ($[27] !== formatMessage || $[28] !== textColor) {
        t2 = (t3)=>{
            const { triggerRef: triggerRef, ...props } = t3;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                ...props,
                appearance: "subtle",
                style: {
                    color: props.isSelected ? undefined : textColor
                },
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    label: formatMessage((0, $9c7bf96141f104f4$export$2e2bcd8739ae039).topicDownIcon)
                }),
                ref: triggerRef,
                testId: "topic-dropdown-trigger"
            }, formatMessage((0, $9c7bf96141f104f4$export$2e2bcd8739ae039).topics));
        };
        $[27] = formatMessage;
        $[28] = textColor;
        $[29] = t2;
    } else t2 = $[29];
    let t3;
    if ($[30] !== openTopic || $[31] !== topicPages) {
        let t4;
        if ($[33] !== openTopic) {
            t4 = (topic_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                    key: topic_0?.id,
                    testId: topicTestId(topic_0?.id),
                    onClick: ()=>openTopic(topic_0?.id)
                }, topic_0?.name?.default ?? "");
            $[33] = openTopic;
            $[34] = t4;
        } else t4 = $[34];
        t3 = topicPages.map(t4);
        $[30] = openTopic;
        $[31] = topicPages;
        $[32] = t3;
    } else t3 = $[32];
    let t4;
    if ($[35] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, t3);
        $[35] = t3;
        $[36] = t4;
    } else t4 = $[36];
    let t5;
    if ($[37] !== t2 || $[38] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            trigger: t2,
            shouldRenderToParent: true
        }, t4);
        $[37] = t2;
        $[38] = t4;
        $[39] = t5;
    } else t5 = $[39];
    return t5;
} : ({ queryRef: queryRef, textColor: textColor, isMobile: isMobile })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { push: push } = (0, $idnP4.useRouterActions)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const data = (0, $6SsN4.useFragment)((0, $f4e1b1d1c8ca412d$export$2e2bcd8739ae039), queryRef);
    const topicPages = data?.topicPages; // Nothing to open onto, so the menu stays out of the navbar entirely.
    if (!(0, $iDrrr.fg)('hubs_premium_upsell') || !topicPages || topicPages.length === 0) return null;
    const openTopic = (pageAri)=>{
        const pageId = pageAri ? $0b604717a3654663$var$getPageIdFromAri(pageAri) : null;
        if (pageId) push(`/page/${pageId}`);
    };
    const topicTestId = (pageAri_0)=>`nav-topic-page-${(pageAri_0 ? $0b604717a3654663$var$getPageIdFromAri(pageAri_0) : null) ?? ''}`;
    if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        iconAfter: isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
            label: formatMessage((0, $9c7bf96141f104f4$export$2e2bcd8739ae039).topicUpIcon)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: formatMessage((0, $9c7bf96141f104f4$export$2e2bcd8739ae039).topicDownIcon)
        }),
        onClick: ()=>setIsExpanded((prev)=>!prev),
        "aria-expanded": isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium"
    }, formatMessage((0, $9c7bf96141f104f4$export$2e2bcd8739ae039).topics))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $0b604717a3654663$var$styles.overflowHidden
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
        appear: true
    }, isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iFlah.default), {
        enteringAnimationXcss: $0b604717a3654663$var$motionStyles.slideEntering,
        exitingAnimationXcss: $0b604717a3654663$var$motionStyles.slideExiting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "topic-dropdown-items",
        className: (0, $hekY6.default)([
            $0b604717a3654663$var$styles.dropdownItems
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), null, topicPages.map((topic)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            key: topic?.id,
            testId: topicTestId(topic?.id),
            onClick: ()=>openTopic(topic?.id)
        }, topic?.name?.default ?? ''))))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                ...props,
                appearance: "subtle",
                style: {
                    color: props.isSelected ? undefined : textColor
                },
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    label: formatMessage((0, $9c7bf96141f104f4$export$2e2bcd8739ae039).topicDownIcon)
                }),
                ref: triggerRef,
                testId: "topic-dropdown-trigger"
            }, formatMessage((0, $9c7bf96141f104f4$export$2e2bcd8739ae039).topics)),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, topicPages.map((topic_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            key: topic_0?.id,
            testId: topicTestId(topic_0?.id),
            onClick: ()=>openTopic(topic_0?.id)
        }, topic_0?.name?.default ?? ''))));
};
function $0b604717a3654663$var$_temp(pageAri_0) {
    return `nav-topic-page-${(pageAri_0 ? $0b604717a3654663$var$getPageIdFromAri(pageAri_0) : null) ?? ""}`;
}
function $0b604717a3654663$var$_temp2(prev) {
    return !prev;
}
module.exports["TopicDropdown"] = $0b604717a3654663$export$ffcc4c72ae603c4e;

});

parcelRegister("kPBMe", function(module, exports) {

let $f2a5dfc27bbdb7ec$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f2a5dfc27bbdb7ec$var$load("5pIPD").then(()=>parcelRequire('5B0UD'));

});

parcelRegister("bT8wR", function(module, exports) {

let $8a7b726e8299be77$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8a7b726e8299be77$var$load("3yj2i"),
    $8a7b726e8299be77$var$load("fEbOv"),
    $8a7b726e8299be77$var$load("Mp0pM"),
    $8a7b726e8299be77$var$load("5sZTx"),
    $8a7b726e8299be77$var$load("deTdD"),
    $8a7b726e8299be77$var$load("1JeTB"),
    $8a7b726e8299be77$var$load("7SteV"),
    $8a7b726e8299be77$var$load("zUKwV"),
    $8a7b726e8299be77$var$load("fUeur"),
    $8a7b726e8299be77$var$load("ce05o"),
    $8a7b726e8299be77$var$load("fpd4t"),
    $8a7b726e8299be77$var$load("3Wy8Y"),
    $8a7b726e8299be77$var$load("hVmYa"),
    $8a7b726e8299be77$var$load("5iXyL"),
    $8a7b726e8299be77$var$load("e80av"),
    $8a7b726e8299be77$var$load("h9JXU"),
    $8a7b726e8299be77$var$load("kMhLQ"),
    $8a7b726e8299be77$var$load("5nbvZ"),
    $8a7b726e8299be77$var$load("2yRsH"),
    $8a7b726e8299be77$var$load("3pUic"),
    $8a7b726e8299be77$var$load("yIsjX"),
    $8a7b726e8299be77$var$load("6wr18"),
    $8a7b726e8299be77$var$load("4g6rd"),
    $8a7b726e8299be77$var$load("5dkX4"),
    $8a7b726e8299be77$var$load("4CyIY"),
    $8a7b726e8299be77$var$load("dlm6q"),
    $8a7b726e8299be77$var$load("2F69B"),
    $8a7b726e8299be77$var$load("hBTro"),
    $8a7b726e8299be77$var$load("iY1NC"),
    $8a7b726e8299be77$var$load("4Ve5N"),
    $8a7b726e8299be77$var$load("7Y0AX"),
    $8a7b726e8299be77$var$load("1GCFv"),
    $8a7b726e8299be77$var$load("aROXU"),
    $8a7b726e8299be77$var$load("3CBDb"),
    $8a7b726e8299be77$var$load("eW2qV"),
    $8a7b726e8299be77$var$load("cxCk7"),
    $8a7b726e8299be77$var$load("ezYRV"),
    $8a7b726e8299be77$var$load("8d6BA"),
    $8a7b726e8299be77$var$load("Jyh1v"),
    $8a7b726e8299be77$var$load("dxcsb"),
    $8a7b726e8299be77$var$load("jqoep"),
    $8a7b726e8299be77$var$load("7EorR"),
    $8a7b726e8299be77$var$load("hhss7"),
    $8a7b726e8299be77$var$load("Wowvf"),
    $8a7b726e8299be77$var$load("aEiTV"),
    $8a7b726e8299be77$var$load("VXbA1"),
    $8a7b726e8299be77$var$load("1qlDN"),
    $8a7b726e8299be77$var$load("1yVM6"),
    $8a7b726e8299be77$var$load("2K7Mk"),
    $8a7b726e8299be77$var$load("jIqhU"),
    $8a7b726e8299be77$var$load("lya9W"),
    $8a7b726e8299be77$var$load("ffEVr"),
    $8a7b726e8299be77$var$load("hy9kW")
]).then(()=>parcelRequire('88o1o'));

});

parcelRegister("aVKfT", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c1cdb40c21dd0ca3$export$6e2f6a8db94682b4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "93O33",
    name: "ForgeGlobalSettingsExtensionPoint",
    loader: async ()=>(await (parcelRequire("a9FjG"))).GlobalSettings
});
module.exports["ForgeGlobalSettingsExtensionPoint"] = $c1cdb40c21dd0ca3$export$6e2f6a8db94682b4;

});

parcelRegister("a9FjG", function(module, exports) {

let $764acb37d8e5f7c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $764acb37d8e5f7c9$var$load("c6fAG").then(()=>parcelRequire('jOztW'));

});

parcelRegister("imDYW", function(module, exports) {

let $d5e94ba94ae41f5b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d5e94ba94ae41f5b$var$load("iVLHX").then(()=>parcelRequire('7DYe9'));

});

parcelRegister("aF1vZ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $47940fef216e9562$export$2709da4acd7d0aec = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Q3Ruy",
    name: "AdvancedSearch",
    loader: async ()=>(await (parcelRequire("iA1IY"))).AdvancedSearch
});
module.exports["AdvancedSearch"] = $47940fef216e9562$export$2709da4acd7d0aec;

});

parcelRegister("iA1IY", function(module, exports) {

let $d86ced33316bd36f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d86ced33316bd36f$var$load("kT6dz"),
    $d86ced33316bd36f$var$load("7JO34"),
    $d86ced33316bd36f$var$load("cxCk7"),
    $d86ced33316bd36f$var$load("ksOjm"),
    $d86ced33316bd36f$var$load("jAsJw"),
    $d86ced33316bd36f$var$load("bPC3R"),
    $d86ced33316bd36f$var$load("bHb1X"),
    $d86ced33316bd36f$var$load("6gMrU"),
    $d86ced33316bd36f$var$load("iECXC"),
    $d86ced33316bd36f$var$load("5sZTx"),
    $d86ced33316bd36f$var$load("deTdD"),
    $d86ced33316bd36f$var$load("hUbK8"),
    $d86ced33316bd36f$var$load("6B7IY"),
    $d86ced33316bd36f$var$load("g3ghC"),
    $d86ced33316bd36f$var$load("1GCFv"),
    $d86ced33316bd36f$var$load("5KHgm"),
    $d86ced33316bd36f$var$load("alg5Q"),
    $d86ced33316bd36f$var$load("hZsD1"),
    $d86ced33316bd36f$var$load("8OWSU"),
    $d86ced33316bd36f$var$load("2mGc6"),
    $d86ced33316bd36f$var$load("kccW9"),
    $d86ced33316bd36f$var$load("4dKZ4"),
    $d86ced33316bd36f$var$load("aGpvE"),
    $d86ced33316bd36f$var$load("fqrmE"),
    $d86ced33316bd36f$var$load("8yk9S"),
    $d86ced33316bd36f$var$load("iOfkQ"),
    $d86ced33316bd36f$var$load("eeYoU"),
    $d86ced33316bd36f$var$load("7SteV"),
    $d86ced33316bd36f$var$load("k8nz9"),
    $d86ced33316bd36f$var$load("agVmZ"),
    $d86ced33316bd36f$var$load("dxcsb"),
    $d86ced33316bd36f$var$load("jqoep"),
    $d86ced33316bd36f$var$load("3YRzU"),
    $d86ced33316bd36f$var$load("ca0UP"),
    $d86ced33316bd36f$var$load("a92TB"),
    $d86ced33316bd36f$var$load("c7nj5"),
    $d86ced33316bd36f$var$load("1yIye"),
    $d86ced33316bd36f$var$load("fKQ9j"),
    $d86ced33316bd36f$var$load("90SZm"),
    $d86ced33316bd36f$var$load("crfrC"),
    $d86ced33316bd36f$var$load("4x9Jx"),
    $d86ced33316bd36f$var$load("ea3NB"),
    $d86ced33316bd36f$var$load("6wr18"),
    $d86ced33316bd36f$var$load("59hV4"),
    $d86ced33316bd36f$var$load("iTOzX"),
    $d86ced33316bd36f$var$load("ipkwd"),
    $d86ced33316bd36f$var$load("ffEVr"),
    $d86ced33316bd36f$var$load("lya9W"),
    $d86ced33316bd36f$var$load("do0Fh"),
    $d86ced33316bd36f$var$load("4Gdnz"),
    $d86ced33316bd36f$var$load("4UAag"),
    $d86ced33316bd36f$var$load("dIY7W"),
    $d86ced33316bd36f$var$load("zUKwV"),
    $d86ced33316bd36f$var$load("fUeur"),
    $d86ced33316bd36f$var$load("Wowvf"),
    $d86ced33316bd36f$var$load("4g6rd"),
    $d86ced33316bd36f$var$load("1JeTB"),
    $d86ced33316bd36f$var$load("hhss7"),
    $d86ced33316bd36f$var$load("7EorR"),
    $d86ced33316bd36f$var$load("mK22p")
]).then(()=>parcelRequire('luNAU'));

});

parcelRegister("g9BPs", function(module, exports) {

let $bc2ad4a7952a917f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bc2ad4a7952a917f$var$load("ezYRV"),
    $bc2ad4a7952a917f$var$load("hDfPU")
]).then(()=>parcelRequire('2mD8T'));

});

parcelRegister("kb9X9", function(module, exports) {

var $lmggZ = parcelRequire("lmggZ");


var $1lO7z = parcelRequire("1lO7z");


var $f14Rr = parcelRequire("f14Rr");


var $1i7uI = parcelRequire("1i7uI");

const $eb0c8e33e0268c1c$export$d17bd3fb4432c2eb = (a, b)=>{
    // lodash reduce can reduce over objects, not just arrays
    /* istanbul ignore next */ const results = (0, (/*@__PURE__*/$parcel$interopDefault($lmggZ)))(a, (result, value, key)=>value === b[key] ? result : result.concat([
            `Prop name: '${key}'`,
            '1:',
            value,
            '2:',
            b[key]
        ], '=========='), []);
    /* istanbul ignore next */ if (!results || results.length === 0) return 'No change!';
    return results;
};
const $eb0c8e33e0268c1c$export$2225b4c39d37f8b3 = (obj1, obj2, omitProps = [])=>{
    if (obj1 === obj2) return true;
    const allKeys = (0, (/*@__PURE__*/$parcel$interopDefault($1lO7z)))((0, (/*@__PURE__*/$parcel$interopDefault($f14Rr)))(obj1), (0, (/*@__PURE__*/$parcel$interopDefault($f14Rr)))(obj2));
    for (const key of allKeys){
        if (omitProps.indexOf(key) >= 0) continue;
        if (obj1[key] !== obj2[key]) return false;
    }
    return true;
};
const $eb0c8e33e0268c1c$export$e3a9c512dde3781c = (name)=>{};
const $eb0c8e33e0268c1c$export$1b1e26e4583cf9d2 = (names)=>{};
const $eb0c8e33e0268c1c$export$948fe58907adae7d = (markA, markB)=>{
    return 'N/A';
};
const $eb0c8e33e0268c1c$export$76909ea6fcdbea03 = (name, markA, markB)=>{};
const $eb0c8e33e0268c1c$export$34e34130f1d9d12c = (mark)=>{
    return 'N/A';
};
const $eb0c8e33e0268c1c$export$a1e5925b5910cb4 = (mark)=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).performance) return;
    (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).performance.mark(mark);
};
module.exports["performanceMarkInProd"] = $eb0c8e33e0268c1c$export$a1e5925b5910cb4;

});

parcelRegister("lmggZ", function(module, exports) {

var $1XwR6 = parcelRequire("1XwR6");


var $bNHBU = parcelRequire("bNHBU");


var $j6gAQ = parcelRequire("j6gAQ");


var $cQ8Hi = parcelRequire("cQ8Hi");


var $1ScXu = parcelRequire("1ScXu");

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $f8c846851f588b54$var$reduce(collection, iteratee, accumulator) {
    var func = $1ScXu(collection) ? $1XwR6 : $cQ8Hi, initAccum = arguments.length < 3;
    return func(collection, $j6gAQ(iteratee, 4), accumulator, initAccum, $bNHBU);
}
module.exports = $f8c846851f588b54$var$reduce;

});

parcelRegister("bNHBU", function(module, exports) {

var $lFjE5 = parcelRequire("lFjE5");


var $923lQ = parcelRequire("923lQ");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $8976196cdeddb1dc$var$baseEach = $923lQ($lFjE5);
module.exports = $8976196cdeddb1dc$var$baseEach;

});

parcelRegister("lFjE5", function(module, exports) {

var $comu1 = parcelRequire("comu1");


var $f14Rr = parcelRequire("f14Rr");

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $fc5caa85fb423e25$var$baseForOwn(object, iteratee) {
    return object && $comu1(object, iteratee, $f14Rr);
}
module.exports = $fc5caa85fb423e25$var$baseForOwn;

});

parcelRegister("923lQ", function(module, exports) {

var $9pMwd = parcelRequire("9pMwd");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $6936e67b6e4d0605$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$9pMwd(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $6936e67b6e4d0605$var$createBaseEach;

});

parcelRegister("cQ8Hi", function(module, exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $9591167375c6fe4f$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = $9591167375c6fe4f$var$baseReduce;

});

parcelRegister("1lO7z", function(module, exports) {

var $avFJ9 = parcelRequire("avFJ9");


var $kxLmQ = parcelRequire("kxLmQ");


var $1Rned = parcelRequire("1Rned");


var $5RsFr = parcelRequire("5RsFr");

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var $0fbea1a47b097dd2$var$union = $kxLmQ(function(arrays) {
    return $1Rned($avFJ9(arrays, 1, $5RsFr, true));
});
module.exports = $0fbea1a47b097dd2$var$union;

});

parcelRegister("lSd9S", function(module, exports) {

let $fec8d915ac2b7d55$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fec8d915ac2b7d55$var$load("dMWJp").then(()=>parcelRequire('eTW2b'));

});

parcelRegister("dOgQ2", function(module, exports) {

let $a0dd01a080c82fb8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a0dd01a080c82fb8$var$load("amygy").then(()=>parcelRequire('iMfxO'));

});

parcelRegister("6tpf2", function(module, exports) {

let $4b6907f447ed4d1f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4b6907f447ed4d1f$var$load("erzsl"),
    $4b6907f447ed4d1f$var$load("arG0U"),
    $4b6907f447ed4d1f$var$load("jnr1d"),
    $4b6907f447ed4d1f$var$load("9YlTA"),
    $4b6907f447ed4d1f$var$load("bRqDI"),
    $4b6907f447ed4d1f$var$load("dVLeP"),
    $4b6907f447ed4d1f$var$load("j5Kob"),
    $4b6907f447ed4d1f$var$load("LWh5V"),
    $4b6907f447ed4d1f$var$load("6XCf4"),
    $4b6907f447ed4d1f$var$load("ebvEF"),
    $4b6907f447ed4d1f$var$load("aEiTV"),
    $4b6907f447ed4d1f$var$load("8SLfD"),
    $4b6907f447ed4d1f$var$load("6xN9r"),
    $4b6907f447ed4d1f$var$load("1qlDN"),
    $4b6907f447ed4d1f$var$load("1yVM6"),
    $4b6907f447ed4d1f$var$load("1inbB"),
    $4b6907f447ed4d1f$var$load("l0dd5"),
    $4b6907f447ed4d1f$var$load("dbQ5m"),
    $4b6907f447ed4d1f$var$load("bm0oR"),
    $4b6907f447ed4d1f$var$load("4fYzp"),
    $4b6907f447ed4d1f$var$load("1GCFv"),
    $4b6907f447ed4d1f$var$load("30b92"),
    $4b6907f447ed4d1f$var$load("h4Nf7"),
    $4b6907f447ed4d1f$var$load("90SZm"),
    $4b6907f447ed4d1f$var$load("crfrC"),
    $4b6907f447ed4d1f$var$load("hhss7"),
    $4b6907f447ed4d1f$var$load("4x9Jx"),
    $4b6907f447ed4d1f$var$load("ea3NB"),
    $4b6907f447ed4d1f$var$load("6wr18"),
    $4b6907f447ed4d1f$var$load("59hV4"),
    $4b6907f447ed4d1f$var$load("excC5"),
    $4b6907f447ed4d1f$var$load("fuOfV"),
    $4b6907f447ed4d1f$var$load("jL1Ke"),
    $4b6907f447ed4d1f$var$load("5MQ0D"),
    $4b6907f447ed4d1f$var$load("ffEVr"),
    $4b6907f447ed4d1f$var$load("fwbNS"),
    $4b6907f447ed4d1f$var$load("zUKwV"),
    $4b6907f447ed4d1f$var$load("fUeur"),
    $4b6907f447ed4d1f$var$load("Wowvf"),
    $4b6907f447ed4d1f$var$load("4g6rd"),
    $4b6907f447ed4d1f$var$load("ayJxT"),
    $4b6907f447ed4d1f$var$load("7EorR"),
    $4b6907f447ed4d1f$var$load("hA2SB"),
    $4b6907f447ed4d1f$var$load("4Scjl"),
    $4b6907f447ed4d1f$var$load("6ExNy")
]).then(()=>parcelRequire('iIJIO'));

});

parcelRegister("agglT", function(module, exports) {
var $585d52ec7db54bb4$export$e0a694ad492b37fe = /*#__PURE__*/ function(CompanyHubSettingsPageTabsType) {
    CompanyHubSettingsPageTabsType[CompanyHubSettingsPageTabsType["GENERAL"] = 0] = "GENERAL";
    CompanyHubSettingsPageTabsType[CompanyHubSettingsPageTabsType["ANALYTICS"] = 1] = "ANALYTICS";
    CompanyHubSettingsPageTabsType[CompanyHubSettingsPageTabsType["USERS"] = 2] = "USERS";
    return CompanyHubSettingsPageTabsType;
}({});
module.exports["CompanyHubSettingsPageTabsType"] = $585d52ec7db54bb4$export$e0a694ad492b37fe;

});

parcelRegister("69fdq", function(module, exports) {

let $479f62d8eca57811$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $479f62d8eca57811$var$load("fJvLh"),
    $479f62d8eca57811$var$load("aYkj4"),
    $479f62d8eca57811$var$load("6wr18"),
    $479f62d8eca57811$var$load("iLqgZ"),
    $479f62d8eca57811$var$load("kwgtb"),
    $479f62d8eca57811$var$load("49rXL"),
    $479f62d8eca57811$var$load("4RHRd"),
    $479f62d8eca57811$var$load("FJgmQ"),
    $479f62d8eca57811$var$load("4fYzp"),
    $479f62d8eca57811$var$load("ffEVr"),
    $479f62d8eca57811$var$load("7EorR"),
    $479f62d8eca57811$var$load("1fLz7")
]).then(()=>parcelRequire('eBAks'));

});

parcelRegister("iquRY", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $24WXz = parcelRequire("24WXz");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $cccaa992351fdb79$export$dcac763621aee435 = ()=>{
    const $ = (0, $bDgLe.c)(9);
    const { cloudId: cloudId, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            cloudId: cloudId
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = !isLoggedIn;
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
        t2 = {
            variables: t0,
            skip: t1,
            onError: $cccaa992351fdb79$var$_temp
        };
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $24WXz.default), {
        ...t2,
        __callerPackage__: "space-utils"
    });
    const isNotPreRoles = data?.confluence_spaceRoleMode ? data.confluence_spaceRoleMode !== "PRE_ROLES" : false;
    const t3 = data?.confluence_spaceRoleMode;
    let t4;
    if ($[5] !== isNotPreRoles || $[6] !== loading || $[7] !== t3) {
        t4 = {
            spaceRoleMode: t3,
            isRbacEnabled: isNotPreRoles,
            loading: loading
        };
        $[5] = isNotPreRoles;
        $[6] = loading;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
};
function $cccaa992351fdb79$var$_temp(error) {
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    });
    (0, $7Sm4c.markErrorAsHandled)(error);
}
module.exports["useSpaceRoleMode"] = $cccaa992351fdb79$export$dcac763621aee435;

});

parcelRegister("24WXz", function(module, exports) {
/**
 * @generated SignedSource<<2ff02ee1cce578f61d9a435abf2def2c>>
 * @relayHash 60ed41889a4cd98154a0419dcf1f59f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82
const $016cc5cc0310f39a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_spaceRoleMode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "60ed41889a4cd98154a0419dcf1f59f5",
            "id": "568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82",
            "metadata": {},
            "name": "useSpaceRoleModeQuery",
            "operationKind": "query",
            "text": "query useSpaceRoleModeQuery($cloudId:ID!){confluence_spaceRoleMode(cloudId:$cloudId)}"
        }
    };
}();
$016cc5cc0310f39a$var$node.hash = "88c4ae8983cc6692099b2b1e1d7a4379";
var $016cc5cc0310f39a$export$2e2bcd8739ae039 = $016cc5cc0310f39a$var$node;
module.exports["default"] = $016cc5cc0310f39a$export$2e2bcd8739ae039;

});

parcelRegister("7q2U7", function(module, exports) {

let $566d36d46307ad26$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $566d36d46307ad26$var$load("jGTjO"),
    $566d36d46307ad26$var$load("cpYhM"),
    $566d36d46307ad26$var$load("jmpki"),
    $566d36d46307ad26$var$load("fJvLh"),
    $566d36d46307ad26$var$load("dbQ5m"),
    $566d36d46307ad26$var$load("bm0oR"),
    $566d36d46307ad26$var$load("1GCFv"),
    $566d36d46307ad26$var$load("2NFUs"),
    $566d36d46307ad26$var$load("8qpwN"),
    $566d36d46307ad26$var$load("2xKrc"),
    $566d36d46307ad26$var$load("iOfkQ"),
    $566d36d46307ad26$var$load("6wr18"),
    $566d36d46307ad26$var$load("6xN9r"),
    $566d36d46307ad26$var$load("bRqDI"),
    $566d36d46307ad26$var$load("dVLeP"),
    $566d36d46307ad26$var$load("j5Kob"),
    $566d36d46307ad26$var$load("4fYzp"),
    $566d36d46307ad26$var$load("LWh5V"),
    $566d36d46307ad26$var$load("6XCf4"),
    $566d36d46307ad26$var$load("ebvEF"),
    $566d36d46307ad26$var$load("ffEVr"),
    $566d36d46307ad26$var$load("7EorR"),
    $566d36d46307ad26$var$load("aEiTV"),
    $566d36d46307ad26$var$load("8SLfD"),
    $566d36d46307ad26$var$load("jV9Gs"),
    $566d36d46307ad26$var$load("1qlDN"),
    $566d36d46307ad26$var$load("1yVM6"),
    $566d36d46307ad26$var$load("7DSUW")
]).then(()=>parcelRequire('54mQG'));

});

parcelRegister("91mzO", function(module, exports) {

let $6915b84cbdcc8f26$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6915b84cbdcc8f26$var$load("fJvLh"),
    $6915b84cbdcc8f26$var$load("6wr18"),
    $6915b84cbdcc8f26$var$load("9UeKl"),
    $6915b84cbdcc8f26$var$load("jGTjO"),
    $6915b84cbdcc8f26$var$load("2fgvC"),
    $6915b84cbdcc8f26$var$load("4fYzp"),
    $6915b84cbdcc8f26$var$load("2NFUs"),
    $6915b84cbdcc8f26$var$load("ffEVr"),
    $6915b84cbdcc8f26$var$load("h2QcJ"),
    $6915b84cbdcc8f26$var$load("iOfkQ"),
    $6915b84cbdcc8f26$var$load("iN26T"),
    $6915b84cbdcc8f26$var$load("w3Gc8"),
    $6915b84cbdcc8f26$var$load("amPsT"),
    $6915b84cbdcc8f26$var$load("6XCf4"),
    $6915b84cbdcc8f26$var$load("ebvEF"),
    $6915b84cbdcc8f26$var$load("aEiTV"),
    $6915b84cbdcc8f26$var$load("hhss7"),
    $6915b84cbdcc8f26$var$load("bU3dV"),
    $6915b84cbdcc8f26$var$load("1qlDN"),
    $6915b84cbdcc8f26$var$load("1yVM6"),
    $6915b84cbdcc8f26$var$load("kBatH"),
    $6915b84cbdcc8f26$var$load("96X3r")
]).then(()=>parcelRequire('9FcLT'));

});

parcelRegister("eCuyg", function(module, exports) {

let $aa4c503a2eca5f2e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $aa4c503a2eca5f2e$var$load("6wr18"),
    $aa4c503a2eca5f2e$var$load("dbQ5m"),
    $aa4c503a2eca5f2e$var$load("bm0oR"),
    $aa4c503a2eca5f2e$var$load("ffEVr"),
    $aa4c503a2eca5f2e$var$load("7EorR"),
    $aa4c503a2eca5f2e$var$load("9vDBp"),
    $aa4c503a2eca5f2e$var$load("RI3SR"),
    $aa4c503a2eca5f2e$var$load("5ZaO3")
]).then(()=>parcelRequire('dpLKi'));

});

parcelRegister("9cEOX", function(module, exports) {

let $6b34e6374c09244a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6b34e6374c09244a$var$load("lRwjQ"),
    $6b34e6374c09244a$var$load("iIfud")
]).then(()=>parcelRequire('fi3dY'));

});

parcelRegister("8RCcR", function(module, exports) {

let $6740e8f9ebd2f06a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6740e8f9ebd2f06a$var$load("l0dd5"),
    $6740e8f9ebd2f06a$var$load("7EorR"),
    $6740e8f9ebd2f06a$var$load("4uUio")
]).then(()=>parcelRequire('ayZRr'));

});

parcelRegister("bD1dS", function(module, exports) {

let $8774491230342370$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8774491230342370$var$load("ezYRV"),
    $8774491230342370$var$load("8YxM8"),
    $8774491230342370$var$load("5sZTx"),
    $8774491230342370$var$load("deTdD"),
    $8774491230342370$var$load("ce05o"),
    $8774491230342370$var$load("7l358"),
    $8774491230342370$var$load("3Wy8Y"),
    $8774491230342370$var$load("3yj2i"),
    $8774491230342370$var$load("hVmYa"),
    $8774491230342370$var$load("e80av"),
    $8774491230342370$var$load("h9JXU"),
    $8774491230342370$var$load("kMhLQ"),
    $8774491230342370$var$load("yIsjX"),
    $8774491230342370$var$load("5dkX4"),
    $8774491230342370$var$load("4CyIY"),
    $8774491230342370$var$load("dlm6q"),
    $8774491230342370$var$load("dKSCs"),
    $8774491230342370$var$load("2F69B"),
    $8774491230342370$var$load("bd3TA"),
    $8774491230342370$var$load("jgNUQ"),
    $8774491230342370$var$load("hBTro"),
    $8774491230342370$var$load("iY1NC"),
    $8774491230342370$var$load("4Ve5N"),
    $8774491230342370$var$load("7Y0AX"),
    $8774491230342370$var$load("cJsay"),
    $8774491230342370$var$load("1GCFv"),
    $8774491230342370$var$load("8d6BA"),
    $8774491230342370$var$load("jqoep"),
    $8774491230342370$var$load("2K7Mk"),
    $8774491230342370$var$load("h5t0Y"),
    $8774491230342370$var$load("4Gdnz"),
    $8774491230342370$var$load("4UAag"),
    $8774491230342370$var$load("zUKwV"),
    $8774491230342370$var$load("fUeur"),
    $8774491230342370$var$load("1JeTB"),
    $8774491230342370$var$load("6wr18"),
    $8774491230342370$var$load("3fdX4"),
    $8774491230342370$var$load("VYd77"),
    $8774491230342370$var$load("9Oxea"),
    $8774491230342370$var$load("b0ARW"),
    $8774491230342370$var$load("cxCk7"),
    $8774491230342370$var$load("7SteV"),
    $8774491230342370$var$load("dxcsb"),
    $8774491230342370$var$load("Wowvf"),
    $8774491230342370$var$load("4g6rd"),
    $8774491230342370$var$load("fq1gG"),
    $8774491230342370$var$load("hhss7"),
    $8774491230342370$var$load("7EorR"),
    $8774491230342370$var$load("1gUNx"),
    $8774491230342370$var$load("jIqhU"),
    $8774491230342370$var$load("lya9W"),
    $8774491230342370$var$load("ffEVr"),
    $8774491230342370$var$load("27cgC")
]).then(()=>parcelRequire('fp8N8'));

});

parcelRegister("4Yv1J", function(module, exports) {
$parcel$export(module.exports, "ContentExtensionsProvider", () => (parcelRequire("f5aR2")).ContentExtensionsProvider);

var $f5aR2 = parcelRequire("f5aR2");


});

parcelRegister("f5aR2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7okiz = parcelRequire("7okiz");


var $69aHU = parcelRequire("69aHU");


var $hFueH = parcelRequire("hFueH");


var $hMRhJ = parcelRequire("hMRhJ");


const $cc34c55db5a1bcbb$var$getLegacyContentExtensions = ()=>({
        loadSortableTable: ()=>(parcelRequire("b0g2B"))
    });
const $cc34c55db5a1bcbb$var$providers = {
    getExtensionHandlers: $7okiz.getExtensionHandlers,
    getLegacyContentExtensions: $cc34c55db5a1bcbb$var$getLegacyContentExtensions,
    populateExtensionProviders: $69aHU.populateExtensionProviders,
    EditorLoaderLoader: $hFueH.default
};
const $cc34c55db5a1bcbb$export$2a88d3b468decd4a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMRhJ.RendererExtensionContext).Provider, {
        value: $cc34c55db5a1bcbb$var$providers
    }, children);
module.exports["ContentExtensionsProvider"] = $cc34c55db5a1bcbb$export$2a88d3b468decd4a;

});

parcelRegister("b0g2B", function(module, exports) {

let $802c233669065fa8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $802c233669065fa8$var$load("kuPgl").then(()=>parcelRequire('5byen'));

});

parcelRegister("crTA1", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("iqZzD")).default);

var $iqZzD = parcelRequire("iqZzD");


});

parcelRegister("iqZzD", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6ba6afbc5717c4a$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $iqPBi = parcelRequire("iqPBi");

var $d6ba6afbc5717c4a$export$2e2bcd8739ae039 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqPBi.SpaceBase), props);
};

});

parcelRegister("1zUsX", function(module, exports) {

let $1264dc55a6b41a3a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1264dc55a6b41a3a$var$load("alg5Q"),
    $1264dc55a6b41a3a$var$load("ik9rg")
]).then(()=>parcelRequire('dg3UC'));

});

parcelRegister("fb73Z", function(module, exports) {

let $b0cd5cbbe8284250$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b0cd5cbbe8284250$var$load("4RHRd"),
    $b0cd5cbbe8284250$var$load("FJgmQ"),
    $b0cd5cbbe8284250$var$load("61Bv2"),
    $b0cd5cbbe8284250$var$load("6wr18"),
    $b0cd5cbbe8284250$var$load("7pwvN"),
    $b0cd5cbbe8284250$var$load("bm0oR"),
    $b0cd5cbbe8284250$var$load("8eGGc"),
    $b0cd5cbbe8284250$var$load("iy0x4"),
    $b0cd5cbbe8284250$var$load("hG5oc"),
    $b0cd5cbbe8284250$var$load("fK7gg"),
    $b0cd5cbbe8284250$var$load("av0nn"),
    $b0cd5cbbe8284250$var$load("3VBIf"),
    $b0cd5cbbe8284250$var$load("81e2B"),
    $b0cd5cbbe8284250$var$load("ffEVr"),
    $b0cd5cbbe8284250$var$load("i0Zk0"),
    $b0cd5cbbe8284250$var$load("aEiTV"),
    $b0cd5cbbe8284250$var$load("7EorR"),
    $b0cd5cbbe8284250$var$load("hKiFG"),
    $b0cd5cbbe8284250$var$load("eVJyV")
]).then(()=>parcelRequire('9yrtR'));

});

parcelRegister("d6uSg", function(module, exports) {

let $98a3c8e73ead0721$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $98a3c8e73ead0721$var$load("fJvLh"),
    $98a3c8e73ead0721$var$load("6unZM")
]).then(()=>parcelRequire('c0oNl'));

});

parcelRegister("7oqPI", function(module, exports) {

let $561f96cd2cf3d537$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $561f96cd2cf3d537$var$load("7UdVV").then(()=>parcelRequire('kCK7c'));

});

parcelRegister("anIt2", function(module, exports) {

let $78ee8bac1cbfe29b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $78ee8bac1cbfe29b$var$load("ge3AN").then(()=>parcelRequire('iiG61'));

});

parcelRegister("3X0K1", function(module, exports) {

let $2e0774f819384cb9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2e0774f819384cb9$var$load("4Yemz").then(()=>parcelRequire('3R3rh'));

});

parcelRegister("bNraL", function(module, exports) {

let $8969593ec3262c58$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8969593ec3262c58$var$load("8prF9").then(()=>parcelRequire('aJ0Cr'));

});

parcelRegister("7ce46", function(module, exports) {

let $53d49075535890ac$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $53d49075535890ac$var$load("fJvLh"),
    $53d49075535890ac$var$load("4fYzp"),
    $53d49075535890ac$var$load("8qpwN"),
    $53d49075535890ac$var$load("2xKrc"),
    $53d49075535890ac$var$load("jV9Gs"),
    $53d49075535890ac$var$load("aIuOE")
]).then(()=>parcelRequire('56n4X'));

});

parcelRegister("6NpxL", function(module, exports) {

let $4f2b221de9aded3d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4f2b221de9aded3d$var$load("fV7Cf").then(()=>parcelRequire('gkSJt'));

});

parcelRegister("JHU7C", function(module, exports) {

let $0896428aa8e47ff4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0896428aa8e47ff4$var$load("fJvLh"),
    $0896428aa8e47ff4$var$load("6wr18"),
    $0896428aa8e47ff4$var$load("lyBPy"),
    $0896428aa8e47ff4$var$load("8dxGd"),
    $0896428aa8e47ff4$var$load("8R7DY"),
    $0896428aa8e47ff4$var$load("9q6b6"),
    $0896428aa8e47ff4$var$load("6XCf4"),
    $0896428aa8e47ff4$var$load("ebvEF"),
    $0896428aa8e47ff4$var$load("hSDwk"),
    $0896428aa8e47ff4$var$load("CfmiU"),
    $0896428aa8e47ff4$var$load("cxCk7"),
    $0896428aa8e47ff4$var$load("fvcK2"),
    $0896428aa8e47ff4$var$load("4BjK2"),
    $0896428aa8e47ff4$var$load("i7mZp"),
    $0896428aa8e47ff4$var$load("13WcH"),
    $0896428aa8e47ff4$var$load("h5t0Y"),
    $0896428aa8e47ff4$var$load("ly931"),
    $0896428aa8e47ff4$var$load("1b3GG"),
    $0896428aa8e47ff4$var$load("c9Px9"),
    $0896428aa8e47ff4$var$load("3Rnfs"),
    $0896428aa8e47ff4$var$load("2j57H"),
    $0896428aa8e47ff4$var$load("2mGc6"),
    $0896428aa8e47ff4$var$load("ezYRV"),
    $0896428aa8e47ff4$var$load("eeYoU"),
    $0896428aa8e47ff4$var$load("176bM"),
    $0896428aa8e47ff4$var$load("17OeC"),
    $0896428aa8e47ff4$var$load("5J0xW"),
    $0896428aa8e47ff4$var$load("aJFlE"),
    $0896428aa8e47ff4$var$load("k6TzV"),
    $0896428aa8e47ff4$var$load("2bJoN"),
    $0896428aa8e47ff4$var$load("ji2ex"),
    $0896428aa8e47ff4$var$load("l9Ivm"),
    $0896428aa8e47ff4$var$load("dxcsb"),
    $0896428aa8e47ff4$var$load("99ObF"),
    $0896428aa8e47ff4$var$load("jqoep"),
    $0896428aa8e47ff4$var$load("3YRzU"),
    $0896428aa8e47ff4$var$load("7EorR"),
    $0896428aa8e47ff4$var$load("4ZTRc"),
    $0896428aa8e47ff4$var$load("kDdlJ"),
    $0896428aa8e47ff4$var$load("8iGBb"),
    $0896428aa8e47ff4$var$load("11hpF"),
    $0896428aa8e47ff4$var$load("eMRD3"),
    $0896428aa8e47ff4$var$load("aEiTV"),
    $0896428aa8e47ff4$var$load("VXbA1"),
    $0896428aa8e47ff4$var$load("1qlDN"),
    $0896428aa8e47ff4$var$load("1yVM6"),
    $0896428aa8e47ff4$var$load("8GFi1"),
    $0896428aa8e47ff4$var$load("7S2Sh"),
    $0896428aa8e47ff4$var$load("ffEVr"),
    $0896428aa8e47ff4$var$load("7UvpM")
]).then(()=>parcelRequire('hQDgX'));

});

parcelRegister("dVOc4", function(module, exports) {

let $a24788a84c17bd0d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a24788a84c17bd0d$var$load("fJvLh"),
    $a24788a84c17bd0d$var$load("4fYzp"),
    $a24788a84c17bd0d$var$load("8qpwN"),
    $a24788a84c17bd0d$var$load("2xKrc"),
    $a24788a84c17bd0d$var$load("jV9Gs"),
    $a24788a84c17bd0d$var$load("dezv5")
]).then(()=>parcelRequire('hD4yV'));

});

parcelRegister("dJYdT", function(module, exports) {

let $a00e31643aebbc97$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a00e31643aebbc97$var$load("LWh5V"),
    $a00e31643aebbc97$var$load("eNXrl"),
    $a00e31643aebbc97$var$load("2yRsH"),
    $a00e31643aebbc97$var$load("8d6BA"),
    $a00e31643aebbc97$var$load("6wr18"),
    $a00e31643aebbc97$var$load("cAbXt"),
    $a00e31643aebbc97$var$load("1X4na"),
    $a00e31643aebbc97$var$load("ffEVr"),
    $a00e31643aebbc97$var$load("2eiOk")
]).then(()=>parcelRequire('do0K0'));

});

parcelRegister("hS5Ee", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11d8f8248981ae6bf03d86b5f7b6d803>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d02bdc63cc831cb8$var$_react = $d02bdc63cc831cb8$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d02bdc63cc831cb8$var$_iconNew = $d02bdc63cc831cb8$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $d02bdc63cc831cb8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Location".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/location
 * Usage guidance:
 * Multi purpose - Known uses: location in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d02bdc63cc831cb8$var$LocationIcon = (props)=>/*#__PURE__*/ $d02bdc63cc831cb8$var$_react.default.createElement($d02bdc63cc831cb8$var$_iconNew.default, Object.assign({
        name: "LocationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5c-3.627 0-5.764 4.07-3.705 7.056L8 13.93l3.705-5.373C13.765 5.57 11.627 1.5 8 1.5M3.06 9.408C.314 5.427 3.164 0 8 0s7.686 5.427 4.94 9.408l-4.323 6.268a.75.75 0 0 1-1.234 0zM8 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M5.5 6a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0" clip-rule="evenodd"/>`
    }, props));
$d02bdc63cc831cb8$var$LocationIcon.displayName = 'LocationIcon';
var $d02bdc63cc831cb8$var$_default = module.exports.default = $d02bdc63cc831cb8$var$LocationIcon;

});

parcelRegister("a6t12", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kNIYN = parcelRequire("kNIYN");


var $9DHhW = parcelRequire("9DHhW");


var $hSs5g = parcelRequire("hSs5g");


var $9zU5G = parcelRequire("9zU5G");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $jyPfN = parcelRequire("jyPfN");


var $jlIaF = parcelRequire("jlIaF");


var $bQm3c = parcelRequire("bQm3c");


var $gqqjz = parcelRequire("gqqjz");

parcelRequire("6OL2O");
var $5t3NX = parcelRequire("5t3NX");

parcelRequire("dD7ks");
var $4N3op = parcelRequire("4N3op");


var $bedVD = parcelRequire("bedVD");


var $l7wqU = parcelRequire("l7wqU");


var $4GlQ9 = parcelRequire("4GlQ9");


var $bumSD = parcelRequire("bumSD");


var $4qzKl = parcelRequire("4qzKl");


var $gj42z = parcelRequire("gj42z");

const $3d0f3ea3171aff68$var$i18n = (0, $kSwu1.defineMessages)({
    viewProfile: {
        id: "profile.card.viewProfile",
        defaultMessage: "View profile"
    }
});
const $3d0f3ea3171aff68$export$98f80b73da7beaf4 = ({ push: push, userId: userId })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: ()=>(0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(userId).then(push),
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, '', (0, $jlIaF.CONTEXT_PATH))
    });
const $3d0f3ea3171aff68$export$4f94384af0327320 = ({ navigate: navigate, url: url })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: navigate,
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: url
    });
const $3d0f3ea3171aff68$export$d114163e55e8b2c5 = ({ loggedInUserId: loggedInUserId, getToggleFollowUser: getToggleFollowUser, renderFeedFollow: renderFeedFollow, userId: userId, followedUsers: followedUsers })=>{
    const followed = !!(userId && followedUsers?.includes(userId));
    return {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bedVD.FeedFollow), {
            followed: followed
        }),
        id: 'feed-follow-user',
        callback: getToggleFollowUser(userId, followed, 'profileCard'),
        shouldRender: (userData)=>renderFeedFollow && Boolean(userId) && userId !== loggedInUserId && userData?.status === 'active'
    };
};
const $3d0f3ea3171aff68$export$ba990269c861f33b = ({ loggedInUserId: loggedInUserId, getToggleFollowUser: getToggleFollowUser, renderFeedFollow: renderFeedFollow, followedRef: followedRef, userId: userId })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l7wqU.FeedFollowAction), {
            userId: userId
        }),
        id: 'feed-follow-user',
        callback: ()=>getToggleFollowUser(userId, followedRef.current, 'profileCard')(),
        shouldRender: ()=>renderFeedFollow && Boolean(userId) && userId !== loggedInUserId
    });
const $3d0f3ea3171aff68$export$59abd6feb7dc8540 = ({ position: position = 'bottom-start', userId: userId, isAnonymous: isAnonymous = false, canViewProfile: canViewProfile = true, children: children, trigger: trigger = 'hover', fullName: fullName, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, ariaLabel: ariaLabel, agent: agent, fullWidthTrigger: fullWidthTrigger })=>{
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const { userId: loggedInUserId, cloudId: cloudId, featureFlags: featureFlags, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const reportingLines = (0, $4N3op.useNavigateToTeamsApp)({
        type: 'LANDING'
    });
    const getReportingLinesUserProfile = (clickedUserId)=>(0, $5t3NX.getNavigateToTeamsApp)(orgId || '', {
            type: 'USER',
            payload: {
                userId: clickedUserId
            }
        });
    const userProfile = (0, $4N3op.useNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId || ''
        }
    });
    const reportingLinesProfileUrl = reportingLines.href;
    const { feedConfigError: feedConfigError, followedUsers: followedUsers, getToggleFollowUser: getToggleFollowUser, mutationError: mutationError, renderFeedFollow: renderFeedFollow } = (0, $4GlQ9.useFeedFollow)();
    const viewProfileAction = (0, $cozmU.useMemo)(()=>$3d0f3ea3171aff68$export$4f94384af0327320({
            navigate: userProfile.onNavigate,
            url: userProfile.href
        }), [
        userProfile
    ]);
    const followUserAction = (0, $cozmU.useMemo)(()=>$3d0f3ea3171aff68$export$d114163e55e8b2c5({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            userId: userId,
            followedUsers: followedUsers
        }), [
        loggedInUserId,
        getToggleFollowUser,
        renderFeedFollow,
        userId,
        followedUsers
    ]);
    // The card snapshots the actions, so the follow callback reads the latest follow state
    // from this ref (updated on every render) instead of a value captured when the action
    // was built. This keeps repeated follow/unfollow toggles in the correct direction.
    const followedRef = (0, $cozmU.useRef)(false);
    followedRef.current = !!(userId && followedUsers?.includes(userId));
    const followUserActionNext = (0, $cozmU.useMemo)(()=>$3d0f3ea3171aff68$export$ba990269c861f33b({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            followedRef: followedRef,
            userId: userId
        }), [
        loggedInUserId,
        getToggleFollowUser,
        renderFeedFollow,
        userId
    ]);
    // Should display profile?
    if (isAnonymous || !canViewProfile || !userId || !loggedInUserId || !hasViewUserProfilePermission) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    const reportingLinesClickCallback = (clickedUserId_0)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'profileCardWrapper',
                action: 'clicked',
                actionSubject: 'viewProfile',
                actionSubjectId: 'userProfileCard',
                attributes: {
                    clickTarget: 'userReportingLine'
                }
            }
        }).fire();
        getReportingLinesUserProfile(clickedUserId_0).onNavigate();
        return false;
    };
    if ((0, $9wGTI.fg)('people-teams_migrate-user-profile-card') || (0, $6mKj3.expValEquals)('pt_user_profile_card_migration_exp', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
        feedConfigError: feedConfigError,
        mutationError: mutationError,
        showErrorFlag: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9zU5G.UserProfileCardWithTrigger), {
        cloudId: cloudId,
        orgId: orgId || '',
        userId: userId,
        viewerId: loggedInUserId,
        placement: position,
        offset: offset,
        trigger: trigger,
        fullWidthTrigger: fullWidthTrigger,
        actions: [
            followUserActionNext
        ],
        agent: agent ? {
            ...agent,
            resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags)
        } : undefined,
        ...disabledAriaAttributes ? {} : {
            ariaLabel: ariaLabel
        },
        testId: "profileCardTrigger"
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
            feedConfigError: feedConfigError,
            mutationError: mutationError,
            showErrorFlag: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSs5g.default), {
            cloudId: cloudId,
            userId: userId,
            resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags),
            position: position,
            trigger: trigger,
            actions: [
                viewProfileAction,
                followUserAction
            ],
            reportingLinesProfileUrl: reportingLinesProfileUrl,
            onReportingLinesClick: (user)=>reportingLinesClickCallback(user.accountIdentifier),
            addFlag: (flag)=>flags.showFlag(flag),
            prepopulatedData: {
                fullName: fullName
            },
            disabledAriaAttributes: disabledAriaAttributes,
            onVisibilityChange: onVisibilityChange,
            offset: offset,
            testId: "profileCardTrigger",
            viewingUserId: loggedInUserId,
            ...disabledAriaAttributes ? {} : {
                ariaLabel: ariaLabel
            }
        }, children)));
};
module.exports["ProfileCardWrapper"] = $3d0f3ea3171aff68$export$59abd6feb7dc8540;

});

parcelRegister("jyPfN", function(module, exports) {

var $foQ4a = parcelRequire("foQ4a");

const $10d1e40b190a4139$export$5a38a817745a0c6f = ()=>{
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    return {
        canViewUserProfile: !isExternalCollaborator
    };
};
module.exports["useViewUserProfile"] = $10d1e40b190a4139$export$5a38a817745a0c6f;

});

parcelRegister("foQ4a", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};
module.exports["useIsExternalCollaborator"] = $19052bf55936e796$export$e581bd1f88227e0a;

});

parcelRegister("6OL2O", function(module, exports) {
$parcel$export(module.exports, "getNavigateToTeamsApp", () => (parcelRequire("5t3NX")).getNavigateToTeamsApp);

var $5t3NX = parcelRequire("5t3NX");


});

parcelRegister("5t3NX", function(module, exports) {

var $hMCZS = parcelRequire("hMCZS");

const $57c6b51502cb940c$export$cfadab73fb247145 = (orgId, navActionPayload, shouldOpenInSameTab)=>{
    return (0, $hMCZS.navigateToTeamsApp)({
        hostProduct: 'confluence',
        orgId: orgId,
        userHasNav4Enabled: true,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["getNavigateToTeamsApp"] = $57c6b51502cb940c$export$cfadab73fb247145;

});

parcelRegister("dD7ks", function(module, exports) {
$parcel$export(module.exports, "useNavigateToTeamsApp", () => (parcelRequire("4N3op")).useNavigateToTeamsApp);

var $4N3op = parcelRequire("4N3op");


});

parcelRegister("4N3op", function(module, exports) {

var $hMCZS = parcelRequire("hMCZS");


var $bQm3c = parcelRequire("bQm3c");


var $dPJCf = parcelRequire("dPJCf");

const $bf6b29a56d69bf9f$export$520a42ab062954ec = (navActionPayload, shouldOpenInSameTab)=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    return (0, $hMCZS.navigateToTeamsApp)({
        push: push,
        hostProduct: 'confluence',
        orgId: orgId,
        cloudId: cloudId,
        userHasNav4Enabled: true,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["useNavigateToTeamsApp"] = $bf6b29a56d69bf9f$export$520a42ab062954ec;

});

parcelRegister("bedVD", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $lpNn5 = parcelRequire("lpNn5");

const $e4e11ee9fe4a88c9$var$i18n = (0, $kSwu1.defineMessages)({
    follow: {
        id: "profile.card.follow",
        defaultMessage: "Follow"
    },
    unfollow: {
        id: "profile.card.unfollow",
        defaultMessage: "Unfollow"
    },
    followTooltip: {
        id: "profile.card.follow.tooltip",
        defaultMessage: "See activity in feed"
    },
    unfollowTooltip: {
        id: "profile.card.unfollow.tooltip",
        defaultMessage: "Stop seeing activity in feed"
    }
});
const $e4e11ee9fe4a88c9$export$d258f317c876c5dc = (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { followed: followed } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== followed || $[1] !== intl) {
        t1 = intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollowTooltip : $e4e11ee9fe4a88c9$var$i18n.followTooltip);
        $[0] = followed;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== followed || $[4] !== intl) {
        t2 = intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollow : $e4e11ee9fe4a88c9$var$i18n.follow);
        $[3] = followed;
        $[4] = intl;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, t2);
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t1 || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t1,
            position: "bottom",
            testId: "feed-follow-tooltip"
        }, t3);
        $[8] = t1;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
};
module.exports["FeedFollow"] = $e4e11ee9fe4a88c9$export$d258f317c876c5dc;

});

parcelRegister("l7wqU", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bedVD = parcelRequire("bedVD");


var $4GlQ9 = parcelRequire("4GlQ9");

const $460a3972eab8fd69$export$38809e1c08e05a16 = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { userId: userId } = t0;
    const { followedUsers: followedUsers } = (0, $4GlQ9.useFeedFollow)();
    let t1;
    if ($[0] !== followedUsers || $[1] !== userId) {
        t1 = userId && followedUsers?.includes(userId);
        $[0] = followedUsers;
        $[1] = userId;
        $[2] = t1;
    } else t1 = $[2];
    const followed = !!t1;
    let t2;
    if ($[3] !== followed) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bedVD.FeedFollow), {
            followed: followed
        });
        $[3] = followed;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
module.exports["FeedFollowAction"] = $460a3972eab8fd69$export$38809e1c08e05a16;

});

parcelRegister("4GlQ9", function(module, exports) {

var $k7Nop = parcelRequire("k7Nop");


var $hOSkW = parcelRequire("hOSkW");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $bQm3c = parcelRequire("bQm3c");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");

const $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery = (0, $hOSkW.default);
const $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowMutation = (0, $k7Nop.default);
const $e2d6f47b8e3454eb$var$isUserHasNoAccessError = (error)=>error?.graphQLErrors?.some((gqlError)=>gqlError?.path?.includes('getFeedUserConfig') && gqlError?.message?.includes('User not permitted to access Confluence'));
let $e2d6f47b8e3454eb$export$8631e45fce8db7c6 = false;
function $e2d6f47b8e3454eb$export$438df56e0ed352e6() {
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { data: data, loading: queryLoading, error: feedConfigError } = (0, $jMyy4.useQueryInterop)($e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery, {
        skip: !isLicensed || $e2d6f47b8e3454eb$export$8631e45fce8db7c6,
        onError: (error)=>$e2d6f47b8e3454eb$export$8631e45fce8db7c6 = $e2d6f47b8e3454eb$var$isUserHasNoAccessError(error),
        __callerPackage__: "profile"
    });
    const [mutateFeedFollow, { error: mutationError }] = (0, $308Wd.useMutationInterop)($e2d6f47b8e3454eb$var$useFeedFollowFeedFollowMutation, {
        refetchQueries: [
            {
                query: $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery
            }
        ],
        __callerPackage__: "profile"
    });
    const followedUsersRaw = data?.getFeedUserConfig?.accountIds;
    const followedUsers = (0, $cozmU.useMemo)(()=>followedUsersRaw?.map((id)=>id ?? null) ?? [], [
        followedUsersRaw
    ]);
    const getToggleFollowUser = (0, $cozmU.useCallback)((accountId, following, source)=>async ()=>{
            if (!accountId) return;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'feedFollow',
                    source: source,
                    attributes: {
                        id: accountId,
                        settingType: 'user',
                        actionType: following ? 'unfollow' : 'follow'
                    }
                }
            }).fire();
            try {
                if (following) await mutateFeedFollow({
                    variables: {
                        unfollow: [
                            accountId
                        ]
                    }
                });
                else await mutateFeedFollow({
                    variables: {
                        follow: [
                            accountId
                        ]
                    }
                });
            } catch  {
            // noop since the hook consumer logs the error through <ErrorDisplay>
            // mutateFeedFollow() has the potential to throw an error;
            // since we do not provide an onError callback to the useMutation hook
            // we need to catch the error here as a safety net.
            }
        }, [
        mutateFeedFollow,
        createAnalyticsEvent
    ]);
    return (0, $cozmU.useMemo)(()=>({
            renderFeedFollow: !(queryLoading || feedConfigError || $e2d6f47b8e3454eb$export$8631e45fce8db7c6) && isLicensed,
            loading: queryLoading,
            getToggleFollowUser: getToggleFollowUser,
            feedConfigError: feedConfigError,
            mutationError: mutationError,
            followedUsers: followedUsers
        }), [
        queryLoading,
        feedConfigError,
        isLicensed,
        getToggleFollowUser,
        mutationError,
        followedUsers
    ]);
}
module.exports["useFeedFollow"] = $e2d6f47b8e3454eb$export$438df56e0ed352e6;

});

parcelRegister("k7Nop", function(module, exports) {
/**
 * @generated SignedSource<<faabaa80182918f5d00c229b25800acb>>
 * @relayHash 564d8ad9d36377c3d791529bbbb8a24b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d32fc5b6758b0cdbd537bc59e7432e83998cce61163ae34755c64a402dc367c
const $2274f77c1a29b092$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "follow"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "unfollow"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "followUsers",
                            "variableName": "follow"
                        },
                        {
                            "kind": "Variable",
                            "name": "unfollowUsers",
                            "variableName": "unfollow"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "SetFeedUserConfigPayload",
            "kind": "LinkedField",
            "name": "setFeedUserConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFeedFollowFeedFollowMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFeedFollowFeedFollowMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "564d8ad9d36377c3d791529bbbb8a24b",
            "id": "5d32fc5b6758b0cdbd537bc59e7432e83998cce61163ae34755c64a402dc367c",
            "metadata": {},
            "name": "useFeedFollowFeedFollowMutation",
            "operationKind": "mutation",
            "text": "mutation useFeedFollowFeedFollowMutation($follow:[ID],$unfollow:[ID]){setFeedUserConfig(input:{followUsers:$follow,unfollowUsers:$unfollow}){success}}"
        }
    };
}();
$2274f77c1a29b092$var$node.hash = "7ecf9b28db7400fffab67e3a3c52027c";
var $2274f77c1a29b092$export$2e2bcd8739ae039 = $2274f77c1a29b092$var$node;
module.exports["default"] = $2274f77c1a29b092$export$2e2bcd8739ae039;

});

parcelRegister("hOSkW", function(module, exports) {
/**
 * @generated SignedSource<<597a7b2d7b3333c8532a887f4cdcbd48>>
 * @relayHash bc87c04b481deeaeaae914ab875dc44e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 11f28c2ff5a1dd7dd27036b76ee213cfc4cc4dc180b6462f1906390361cc096b
const $eeb53afb4cc8b670$var$node = function() {
    var v0 = [
        {
            "concreteType": "FollowingFeedGetUserConfig",
            "kind": "LinkedField",
            "name": "getFeedUserConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "accountIds"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useFeedFollowFeedFollowQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useFeedFollowFeedFollowQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "bc87c04b481deeaeaae914ab875dc44e",
            "id": "11f28c2ff5a1dd7dd27036b76ee213cfc4cc4dc180b6462f1906390361cc096b",
            "metadata": {},
            "name": "useFeedFollowFeedFollowQuery",
            "operationKind": "query",
            "text": "query useFeedFollowFeedFollowQuery{getFeedUserConfig{accountIds}}"
        }
    };
}();
$eeb53afb4cc8b670$var$node.hash = "73bdcd7f6c8309a4d0a16e77fd4c5fed";
var $eeb53afb4cc8b670$export$2e2bcd8739ae039 = $eeb53afb4cc8b670$var$node;
module.exports["default"] = $eeb53afb4cc8b670$export$2e2bcd8739ae039;

});

parcelRegister("bumSD", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $5hJlu = parcelRequire("5hJlu");


var $bp86Z = parcelRequire("bp86Z");

const $226eb0cd9c5c41b1$var$DIRECTORY_GRAPHQL_PATH = '/gateway/api/directory/graphql';
const $226eb0cd9c5c41b1$var$USER_PROFILE_CONFIG = {
    url: $226eb0cd9c5c41b1$var$DIRECTORY_GRAPHQL_PATH,
    cacheSize: 100,
    cacheMaxAge: 300000 // - 5 minutes
};
const $226eb0cd9c5c41b1$export$441fd008df03d370 = (0, $dOBRD.default)((cloudId, _)=>{
    const profileClientConfig = {
        ...$226eb0cd9c5c41b1$var$USER_PROFILE_CONFIG,
        productIdentifier: 'confluence',
        cloudId: cloudId
    };
    return new (0, $5hJlu.ProfileClient)(profileClientConfig, {
        userClient: new (0, $bp86Z.UserProfileClientForConfluence)(profileClientConfig)
    });
});
module.exports["getProfileClient"] = $226eb0cd9c5c41b1$export$441fd008df03d370;

});

parcelRegister("bp86Z", function(module, exports) {

var $34knR = parcelRequire("34knR");


var $9fywD = parcelRequire("9fywD");


var $7lu50 = parcelRequire("7lu50");


var $ldOrZ = parcelRequire("ldOrZ");


var $2A84u = parcelRequire("2A84u");


var $9jSPN = parcelRequire("9jSPN");


var $c0rhi = parcelRequire("c0rhi");

class $e0ed8187aad1d5de$export$8e0680112f77975e extends (0, $34knR.default) {
    async makeRequest(cloudId, userId) {
        // Note because we are only subclassing "makeRequest()", we are still using UserProfileClient's
        // default "getProfile()" function - which means we automatically get the standard
        // UserProfileClient caching of the full user profile data, including our added properties
        (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).start();
        const UserProfileClientForConfluencePromise = (0, $c0rhi.queryInterop)({
            query: (0, $2A84u.UserProfileClientForConfluenceQuery),
            variables: {
                userId: userId
            },
            __callerPackage__: "profile"
        });
        // If the standard user data query fails, we want to reject the returned promise because there
        // won't be any data for the caller to make a useful ProfileCard.  But if the standard user
        // data query succeeds but External Collaboration data query fails, we want to still display
        // the ProfileCard with the standard user data (that is, we don't want to reject).  In order to
        // do this, we can't use "Promise.all()" because it will return immediately when any of its
        // requests fail.  Instead we need to wait until all of the requests complete or fail, and that
        // means using "Promise.allSettled()", which has a much more complicated return object.
        const [userProfileClientForConfluenceQueryResult, standardUserDataResult] = await Promise.allSettled([
            UserProfileClientForConfluencePromise,
            super.makeRequest(cloudId, userId)
        ]);
        if (standardUserDataResult.status === 'rejected') {
            (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).stop({
                customData: {
                    success: false
                }
            });
            return Promise.reject(standardUserDataResult.reason);
        }
        // If the External Collaboration query was successful and External Collaboration is entitled
        // and this user is an External user, then add our custom Lozenge to the standard user profile
        // data
        const customLozenges = [];
        if (userProfileClientForConfluenceQueryResult.status === 'fulfilled') {
            const confluenceUserResponse = userProfileClientForConfluenceQueryResult.value.data;
            if ((0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(confluenceUserResponse) && confluenceUserResponse?.user?.confluence?.permissionType === (0, $ldOrZ.SitePermissionType).EXTERNAL) customLozenges.push({
                ...(0, $9fywD.ExternalUserLozengeProps),
                key: 'ExternalUserLozenge'
            });
        }
        (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).stop({
            customData: {
                success: true
            }
        });
        return {
            ...standardUserDataResult.value,
            customLozenges: customLozenges
        };
    }
}
module.exports["UserProfileClientForConfluence"] = $e0ed8187aad1d5de$export$8e0680112f77975e;

});

parcelRegister("9fywD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9KSWX = parcelRequire("9KSWX");


var $lpNn5 = parcelRequire("lpNn5");

const $43aed8c383cce8da$var$i18n = (0, $kSwu1.defineMessages)({
    externalUserLozengeText: {
        id: "external-collab-ui.user-guest-lozenge",
        defaultMessage: "Guest"
    },
    guestUserTooltip: {
        id: "external-collab-ui.user-guest-lozenge.tooltip",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    }
});
const $43aed8c383cce8da$export$4de00d985a23014d = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $43aed8c383cce8da$var$i18n.guestUserTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $43aed8c383cce8da$var$i18n.externalUserLozengeText)),
    appearance: 'default',
    isBold: false
};
const $43aed8c383cce8da$export$aa87bb37f13b8b5 = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $43aed8c383cce8da$export$4de00d985a23014d;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalUserLozengeProps"] = $43aed8c383cce8da$export$4de00d985a23014d;
module.exports["ExternalUserLozenge"] = $43aed8c383cce8da$export$aa87bb37f13b8b5;

});

parcelRegister("7lu50", function(module, exports) {
// old definition from tysy - not a real query being used
const $a928a12ca5fd59f3$export$adaf854818ff0d42 = (queryData)=>{
    return queryData?.entitlements?.externalCollaborator.isEntitled;
};
module.exports["getExternalCollaboratorEntitlementFromQuery"] = $a928a12ca5fd59f3$export$adaf854818ff0d42;

});

parcelRegister("ldOrZ", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $0709253cacc9fe3a$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $0709253cacc9fe3a$export$8995abb8169b2cb8;

});

parcelRegister("2A84u", function(module, exports) {

var $ay9Uu = parcelRequire("ay9Uu");

const $ab1c6257ac115bcc$export$8322eea6a290b246 = (0, $ay9Uu.default);
module.exports["UserProfileClientForConfluenceQuery"] = $ab1c6257ac115bcc$export$8322eea6a290b246;

});

parcelRegister("ay9Uu", function(module, exports) {
/**
 * @generated SignedSource<<c8072e566be2615c9f169051b183f1d7>>
 * @relayHash e3b7fcde55b949bf8d80bddd9a0ac180
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ee7894fc24fdc7e2f211db85d0b9ca04c99930331a3373b4aec2e287d771850d
const $bb661b120eec94ae$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        }
    ], v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": false
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "userId"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ExternalCollaboratorFeature",
                    "kind": "LinkedField",
                    "name": "externalCollaborator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "UserProfileClientForConfluenceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "UserProfileClientForConfluenceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "e3b7fcde55b949bf8d80bddd9a0ac180",
            "id": "ee7894fc24fdc7e2f211db85d0b9ca04c99930331a3373b4aec2e287d771850d",
            "metadata": {},
            "name": "UserProfileClientForConfluenceQuery",
            "operationKind": "query",
            "text": "query UserProfileClientForConfluenceQuery($userId:ID){user:confluence_atlassianUser(current:false,id:$userId){id,confluence{permissionType}},entitlements{externalCollaborator{isEntitled}}}"
        }
    };
}();
$bb661b120eec94ae$var$node.hash = "f636f7ede64e4c0d1757767b061d53b5";
var $bb661b120eec94ae$export$2e2bcd8739ae039 = $bb661b120eec94ae$var$node;
module.exports["default"] = $bb661b120eec94ae$export$2e2bcd8739ae039;

});

parcelRegister("9jSPN", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $5487d57e41530957$export$c2710940b43dcf08 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.PROFILE_CARD_QUERY_CUSTOM_KEY)
});
module.exports["PROFILE_CARD_QUERY_METRIC"] = $5487d57e41530957$export$c2710940b43dcf08;

});

parcelRegister("4qzKl", function(module, exports) {
// TODO: remove once @confluence-classic/confluence-urls is added to next

var $jlIaF = parcelRequire("jlIaF");

const $7b986e69785602e5$export$3b6a64cfeda8b00 = (accountId, src, context = '')=>{
    if (!accountId) return '';
    return `${context}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$5f1a0e9946984804 = async (accountId, src)=>{
    if (!accountId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$cb80ef5511478588 = (teamId, src, context = '')=>{
    if (!teamId) return '';
    return `${context}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$470c1413f7223a06 = async (teamId, src)=>{
    if (!teamId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
// Replacement for the getAttributeNames DOM API since it's not supported by IE
const $7b986e69785602e5$var$getAttributeNames = (element)=>Array.from(element.attributes).map((attribute)=>attribute.name);
// Return only DOM elements that have the data-account-id attribute
const $7b986e69785602e5$var$withAccountId = (element)=>element.getAttribute('data-account-id');
// Returns React props that can be used to recreate a DOM element
const $7b986e69785602e5$var$getReactPropsFromDOMElement = (element)=>{
    const attributeToProp = {
        class: 'className'
    };
    const props = {};
    $7b986e69785602e5$var$getAttributeNames(element).forEach((attribute)=>{
        props[attributeToProp[attribute] || attribute] = element.getAttribute(attribute);
    });
    props.dangerouslySetInnerHTML = {
        __html: element.innerHTML
    };
    return props;
};
function $7b986e69785602e5$export$a98860edfb97e545(userElements) {
    return userElements.filter($7b986e69785602e5$var$withAccountId).map((element)=>{
        const props = $7b986e69785602e5$var$getReactPropsFromDOMElement(element);
        // Set this attribute to stop the old user profile hovers from binding
        props['data-user-hover-bound'] = 'true';
        // Ensure that links go to the same location as the profile card
        props.href = $7b986e69785602e5$export$3b6a64cfeda8b00(props['data-account-id'], null);
        const placeholder = window.document.createElement('span');
        if (!element.parentNode) return {};
        element.parentNode.replaceChild(placeholder, element);
        return {
            props: props,
            placeholder: placeholder
        };
    });
}
module.exports["getAtlassianPeopleProfileUrl"] = $7b986e69785602e5$export$3b6a64cfeda8b00;
module.exports["getAtlassianPeopleProfileUrlAsync"] = $7b986e69785602e5$export$5f1a0e9946984804;
module.exports["getTeamUrl"] = $7b986e69785602e5$export$cb80ef5511478588;
module.exports["replaceUserElementsWithPlaceholders"] = $7b986e69785602e5$export$a98860edfb97e545;

});

parcelRegister("gj42z", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $kSwu1 = parcelRequire("kSwu1");


var $b3j2Y = parcelRequire("b3j2Y");


var $gqqjz = parcelRequire("gqqjz");

const $3ade761a05c1a959$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    followMutationErrorTitle: {
        id: "profile.card.feed.follow.mutation.error.title",
        defaultMessage: "We\u2019re having trouble doing that"
    },
    followMutationErrorDescription: {
        id: "profile.card.feed.follow.mutation.error.description",
        defaultMessage: "Try following or unfollowing this user again "
    }
});
const $3ade761a05c1a959$export$cb92340e76dc7cda = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { feedConfigError: feedConfigError, mutationError: mutationError, showErrorFlag: showErrorFlag } = t0;
    let t1;
    if ($[0] !== feedConfigError) {
        t1 = feedConfigError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: feedConfigError
        }) : null;
        $[0] = feedConfigError;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== mutationError || $[3] !== showErrorFlag) {
        t2 = mutationError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: mutationError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: [
                (0, $gqqjz.FlagsStateContainer)
            ]
        }, (flags)=>{
            if (showErrorFlag) flags.showErrorFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorDescription)
            });
            return null;
        })) : null;
        $[2] = mutationError;
        $[3] = showErrorFlag;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
module.exports["FeedFollowErrorDisplay"] = $3ade761a05c1a959$export$cb92340e76dc7cda;

});

parcelRegister("h3iF6", function(module, exports) {

let $c6a1315adc5c1fa4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c6a1315adc5c1fa4$var$load("6wr18"),
    $c6a1315adc5c1fa4$var$load("k6TzV"),
    $c6a1315adc5c1fa4$var$load("2bJoN"),
    $c6a1315adc5c1fa4$var$load("ffEVr"),
    $c6a1315adc5c1fa4$var$load("8GFi1"),
    $c6a1315adc5c1fa4$var$load("15nOL")
]).then(()=>parcelRequire('kI3Qk'));

});

parcelRegister("eJcP8", function(module, exports) {

let $ab8f373255be3cf6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ab8f373255be3cf6$var$load("6wr18"),
    $ab8f373255be3cf6$var$load("2bJoN"),
    $ab8f373255be3cf6$var$load("ffEVr"),
    $ab8f373255be3cf6$var$load("aCcKJ")
]).then(()=>parcelRequire('fbIrw'));

});

parcelRegister("knHrR", function(module, exports) {

let $ed67a897b71e5a1a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ed67a897b71e5a1a$var$load("EEHCI").then(()=>parcelRequire('dtJ3H'));

});

parcelRegister("8VPuN", function(module, exports) {

let $680b97922621c20d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $680b97922621c20d$var$load("gABRh").then(()=>parcelRequire('3JgtQ'));

});

parcelRegister("h1QnW", function(module, exports) {

let $c65b2a41aae0265c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c65b2a41aae0265c$var$load("fAUr9").then(()=>parcelRequire('7EJ9w'));

});

parcelRegister("9C1qb", function(module, exports) {

let $6ff8c3e9516d9b80$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6ff8c3e9516d9b80$var$load("8d6BA"),
    $6ff8c3e9516d9b80$var$load("6wr18"),
    $6ff8c3e9516d9b80$var$load("7QQL7"),
    $6ff8c3e9516d9b80$var$load("ffEVr"),
    $6ff8c3e9516d9b80$var$load("4pYLw")
]).then(()=>parcelRequire('i9E8j'));

});

parcelRegister("lEzA0", function(module, exports) {

let $fc38eeccef075a15$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fc38eeccef075a15$var$load("evWu5").then(()=>parcelRequire('8foBH'));

});

parcelRegister("6O2BV", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4f497007dae01ffa$export$25fb473e92ff8332 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "PT7yD",
    name: "ClassicEditorContextProviderLoader",
    loader: ()=>(parcelRequire("lIlQR"))
});
module.exports["ClassicEditorContextProviderLoader"] = $4f497007dae01ffa$export$25fb473e92ff8332;

});

parcelRegister("lIlQR", function(module, exports) {

let $fceea848896375c0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fceea848896375c0$var$load("kT6dz"),
    $fceea848896375c0$var$load("cL90P"),
    $fceea848896375c0$var$load("fob67"),
    $fceea848896375c0$var$load("hUbK8"),
    $fceea848896375c0$var$load("53Y0O"),
    $fceea848896375c0$var$load("kYlwR"),
    $fceea848896375c0$var$load("1tqsw"),
    $fceea848896375c0$var$load("9cVML"),
    $fceea848896375c0$var$load("aGpvE"),
    $fceea848896375c0$var$load("fqrmE"),
    $fceea848896375c0$var$load("7SteV"),
    $fceea848896375c0$var$load("52ZTT"),
    $fceea848896375c0$var$load("eNgZ8"),
    $fceea848896375c0$var$load("lAHCT"),
    $fceea848896375c0$var$load("b5lq6"),
    $fceea848896375c0$var$load("hs6P3"),
    $fceea848896375c0$var$load("1cQg7"),
    $fceea848896375c0$var$load("a9LoI"),
    $fceea848896375c0$var$load("8MaGw"),
    $fceea848896375c0$var$load("ksOjm"),
    $fceea848896375c0$var$load("jAsJw"),
    $fceea848896375c0$var$load("eUsnQ"),
    $fceea848896375c0$var$load("jisiR"),
    $fceea848896375c0$var$load("icVON"),
    $fceea848896375c0$var$load("bPC3R"),
    $fceea848896375c0$var$load("bHb1X"),
    $fceea848896375c0$var$load("90SZm"),
    $fceea848896375c0$var$load("crfrC"),
    $fceea848896375c0$var$load("4x9Jx"),
    $fceea848896375c0$var$load("7gL7H"),
    $fceea848896375c0$var$load("ea3NB"),
    $fceea848896375c0$var$load("6wr18"),
    $fceea848896375c0$var$load("59hV4"),
    $fceea848896375c0$var$load("aNyWk"),
    $fceea848896375c0$var$load("gSKF7"),
    $fceea848896375c0$var$load("dtNxV"),
    $fceea848896375c0$var$load("iTOzX"),
    $fceea848896375c0$var$load("ipkwd"),
    $fceea848896375c0$var$load("a7sEM"),
    $fceea848896375c0$var$load("aLbuU"),
    $fceea848896375c0$var$load("ffEVr"),
    $fceea848896375c0$var$load("ctxM8"),
    $fceea848896375c0$var$load("8Jd6S"),
    $fceea848896375c0$var$load("4Gdnz"),
    $fceea848896375c0$var$load("4UAag"),
    $fceea848896375c0$var$load("zUKwV"),
    $fceea848896375c0$var$load("fUeur"),
    $fceea848896375c0$var$load("ckGjo"),
    $fceea848896375c0$var$load("1sii7"),
    $fceea848896375c0$var$load("6gMrU"),
    $fceea848896375c0$var$load("iECXC"),
    $fceea848896375c0$var$load("Wowvf"),
    $fceea848896375c0$var$load("4g6rd"),
    $fceea848896375c0$var$load("fq1gG"),
    $fceea848896375c0$var$load("fWCBZ"),
    $fceea848896375c0$var$load("5sZTx"),
    $fceea848896375c0$var$load("deTdD"),
    $fceea848896375c0$var$load("1JeTB"),
    $fceea848896375c0$var$load("4UHov"),
    $fceea848896375c0$var$load("hhss7"),
    $fceea848896375c0$var$load("cWL7t"),
    $fceea848896375c0$var$load("gbJtu"),
    $fceea848896375c0$var$load("86OhX"),
    $fceea848896375c0$var$load("7EorR"),
    $fceea848896375c0$var$load("lsb09")
]).then(()=>parcelRequire('gnN3I'));

});

parcelRegister("3d5UI", function(module, exports) {
function $28507a73a7688e48$var$isDefined(path) {
    return path.split('.').reduce((object, pathPart)=>{
        return object && object[pathPart] ? object[pathPart] : null;
    }, window);
}
const $28507a73a7688e48$var$lines = {};
function $28507a73a7688e48$var$logOnce(message) {}
function $28507a73a7688e48$export$d2adf65b87e47523() {
    for(const key in $28507a73a7688e48$var$lines)delete $28507a73a7688e48$var$lines[key];
}
function $28507a73a7688e48$export$88d492d47be57a7e({ listener: listener, globalProperty: globalProperty, interval: interval = 250 }, callback) {
    if ($28507a73a7688e48$var$isDefined(globalProperty)) {
        $28507a73a7688e48$var$logOnce(`window.${globalProperty} is already available for use by ${listener}.`);
        callback();
        return null;
    }
    const waitForGlobalInterval = setInterval(()=>{
        $28507a73a7688e48$var$logOnce(`${listener} is waiting for window.${globalProperty} to be available`);
        if ($28507a73a7688e48$var$isDefined(globalProperty)) {
            $28507a73a7688e48$var$logOnce(`window.${globalProperty} now available!`);
            clearInterval(waitForGlobalInterval);
            callback();
        }
    }, interval);
}
module.exports["waitForGlobal"] = $28507a73a7688e48$export$88d492d47be57a7e;

});

parcelRegister("7EX8o", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");

var $2w2Hu = parcelRequire("2w2Hu");


const $1c44eab82f88f298$export$3717da370a5be6bc = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "NLJVG",
    name: "EmbeddedViewPageLoader",
    loader: async ()=>(await (parcelRequire("9e0mk"))).EmbeddedViewPage,
    _mustPreloadWhenRenderingSPA: [
        (0, $2w2Hu.MustPreloadLoadableNames).ViewPageRouteComponentLoader
    ]
});
module.exports["EmbeddedViewPageLoader"] = $1c44eab82f88f298$export$3717da370a5be6bc;

});

parcelRegister("9e0mk", function(module, exports) {

let $6b75b32d1366ea5a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6b75b32d1366ea5a$var$load("ezYRV"),
    $6b75b32d1366ea5a$var$load("8YxM8"),
    $6b75b32d1366ea5a$var$load("ca0UP"),
    $6b75b32d1366ea5a$var$load("a92TB"),
    $6b75b32d1366ea5a$var$load("5sZTx"),
    $6b75b32d1366ea5a$var$load("deTdD"),
    $6b75b32d1366ea5a$var$load("ce05o"),
    $6b75b32d1366ea5a$var$load("7l358"),
    $6b75b32d1366ea5a$var$load("3Wy8Y"),
    $6b75b32d1366ea5a$var$load("3yj2i"),
    $6b75b32d1366ea5a$var$load("h9JXU"),
    $6b75b32d1366ea5a$var$load("yIsjX"),
    $6b75b32d1366ea5a$var$load("5dkX4"),
    $6b75b32d1366ea5a$var$load("4CyIY"),
    $6b75b32d1366ea5a$var$load("dlm6q"),
    $6b75b32d1366ea5a$var$load("dKSCs"),
    $6b75b32d1366ea5a$var$load("2F69B"),
    $6b75b32d1366ea5a$var$load("bd3TA"),
    $6b75b32d1366ea5a$var$load("jgNUQ"),
    $6b75b32d1366ea5a$var$load("hBTro"),
    $6b75b32d1366ea5a$var$load("iY1NC"),
    $6b75b32d1366ea5a$var$load("4Ve5N"),
    $6b75b32d1366ea5a$var$load("7Y0AX"),
    $6b75b32d1366ea5a$var$load("1GCFv"),
    $6b75b32d1366ea5a$var$load("8d6BA"),
    $6b75b32d1366ea5a$var$load("el56J"),
    $6b75b32d1366ea5a$var$load("jqoep"),
    $6b75b32d1366ea5a$var$load("2K7Mk"),
    $6b75b32d1366ea5a$var$load("jIqhU"),
    $6b75b32d1366ea5a$var$load("lya9W"),
    $6b75b32d1366ea5a$var$load("mUfsl"),
    $6b75b32d1366ea5a$var$load("jZryg"),
    $6b75b32d1366ea5a$var$load("h5t0Y"),
    $6b75b32d1366ea5a$var$load("4Gdnz"),
    $6b75b32d1366ea5a$var$load("4UAag"),
    $6b75b32d1366ea5a$var$load("zUKwV"),
    $6b75b32d1366ea5a$var$load("fUeur"),
    $6b75b32d1366ea5a$var$load("1JeTB"),
    $6b75b32d1366ea5a$var$load("6wr18"),
    $6b75b32d1366ea5a$var$load("3fdX4"),
    $6b75b32d1366ea5a$var$load("VYd77"),
    $6b75b32d1366ea5a$var$load("9Oxea"),
    $6b75b32d1366ea5a$var$load("b0ARW"),
    $6b75b32d1366ea5a$var$load("cxCk7"),
    $6b75b32d1366ea5a$var$load("7SteV"),
    $6b75b32d1366ea5a$var$load("dxcsb"),
    $6b75b32d1366ea5a$var$load("ffEVr"),
    $6b75b32d1366ea5a$var$load("Wowvf"),
    $6b75b32d1366ea5a$var$load("4g6rd"),
    $6b75b32d1366ea5a$var$load("fq1gG"),
    $6b75b32d1366ea5a$var$load("hhss7"),
    $6b75b32d1366ea5a$var$load("7EorR"),
    $6b75b32d1366ea5a$var$load("1gUNx"),
    $6b75b32d1366ea5a$var$load("WXYxI")
]).then(()=>parcelRequire('6N2H2'));

});

parcelRegister("4H46k", function(module, exports) {
// These exports are using the .default prop of the module because we're mixing ES6 and ES5. This is required for
// webpack to be able to correctly split bundles.

var $jmjWc = parcelRequire("jmjWc");


const $36ae5bfcf92491af$export$2f32c75fff716fcc = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "b7m6n",
    name: "LazySpaceBlogRedirect",
    loader: async ()=>(await (parcelRequire("aSorL"))).SpaceBlogRedirect
});

const $36ae5bfcf92491af$export$5590c410e7d0a293 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "LfHUf",
    name: "LazySpaceCreatePage",
    loader: ()=>(parcelRequire("kYEtj"))
});

const $36ae5bfcf92491af$export$e650af616d3a92cf = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Z1eTA",
    name: "LazyMobileWebContainer",
    loader: ()=>(parcelRequire("gpdJM"))
});

const $36ae5bfcf92491af$export$dcf40c4d983a3b1f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "TnNDX",
    name: "LazyDwellTime",
    loader: ()=>(parcelRequire("3NGbz"))
});

const $36ae5bfcf92491af$export$a804be9097757ef8 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "GCYkT",
    name: "LazyConsumptionViewedAndCompletedEventTracker",
    loader: async ()=>(await (parcelRequire("2b91E"))).ConsumptionViewedAndCompletedEventTracker
});

const $36ae5bfcf92491af$export$33256e23669f7955 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AaHry",
    name: "LazyConfluenceNotFound",
    loader: ()=>(parcelRequire("44sbU"))
});
module.exports["LazySpaceBlogRedirect"] = $36ae5bfcf92491af$export$2f32c75fff716fcc;
module.exports["LazySpaceCreatePage"] = $36ae5bfcf92491af$export$5590c410e7d0a293;
module.exports["LazyMobileWebContainer"] = $36ae5bfcf92491af$export$e650af616d3a92cf;
module.exports["LazyDwellTime"] = $36ae5bfcf92491af$export$dcf40c4d983a3b1f;
module.exports["LazyConsumptionViewedAndCompletedEventTracker"] = $36ae5bfcf92491af$export$a804be9097757ef8;
module.exports["LazyConfluenceNotFound"] = $36ae5bfcf92491af$export$33256e23669f7955;

});

parcelRegister("aSorL", function(module, exports) {

let $7eb1e928c024f4bd$var$load = (parcelRequire("6dFT0"))(5);



module.exports = Promise.all([
    (parcelRequire("aZWbq"))((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve("kzRPH"), 5)),
    $7eb1e928c024f4bd$var$load("gaXhw")
]).then(()=>parcelRequire('4bW1i'));

});

parcelRegister("aZWbq", function(module, exports) {
"use strict";

var $87Wxe = parcelRequire("87Wxe");

module.exports = $87Wxe(function loadCSSBundle(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        let existingLinks = document.getElementsByTagName('link');
        let isCurrentBundle = function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        };
        if ([].concat(existingLinks).some(isCurrentBundle)) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});

parcelRegister("87Wxe", function(module, exports) {
"use strict";
let $5eac61fceb5317f9$var$cachedBundles = {};
let $5eac61fceb5317f9$var$cachedPreloads = {};
let $5eac61fceb5317f9$var$cachedPrefetches = {};
function $5eac61fceb5317f9$var$getCache(type) {
    switch(type){
        case 'preload':
            return $5eac61fceb5317f9$var$cachedPreloads;
        case 'prefetch':
            return $5eac61fceb5317f9$var$cachedPrefetches;
        default:
            return $5eac61fceb5317f9$var$cachedBundles;
    }
}
module.exports = function cacheLoader(loader, type) {
    return function(bundle) {
        let cache = $5eac61fceb5317f9$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});

parcelRegister("kYEtj", function(module, exports) {

let $f458ce1537781522$var$load = (parcelRequire("6dFT0"))(5);



module.exports = Promise.all([
    $f458ce1537781522$var$load("9t4mJ"),
    $f458ce1537781522$var$load("cL90P"),
    $f458ce1537781522$var$load("fob67"),
    $f458ce1537781522$var$load("86OhX"),
    $f458ce1537781522$var$load("hUbK8"),
    (parcelRequire("aZWbq"))((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve("meCbt"), 5)),
    $f458ce1537781522$var$load("ddsSQ"),
    $f458ce1537781522$var$load("2F69B"),
    $f458ce1537781522$var$load("e1cuZ"),
    $f458ce1537781522$var$load("fE5au"),
    $f458ce1537781522$var$load("lK9vp"),
    $f458ce1537781522$var$load("53Y0O"),
    $f458ce1537781522$var$load("kYlwR"),
    $f458ce1537781522$var$load("1GCFv"),
    $f458ce1537781522$var$load("1tqsw"),
    $f458ce1537781522$var$load("9cVML"),
    $f458ce1537781522$var$load("hZsD1"),
    $f458ce1537781522$var$load("1Gr4q"),
    $f458ce1537781522$var$load("aGpvE"),
    $f458ce1537781522$var$load("fqrmE"),
    $f458ce1537781522$var$load("6wr18"),
    $f458ce1537781522$var$load("7gL7H"),
    $f458ce1537781522$var$load("52ZTT"),
    $f458ce1537781522$var$load("Wowvf"),
    $f458ce1537781522$var$load("4AElS"),
    $f458ce1537781522$var$load("b5lq6"),
    $f458ce1537781522$var$load("a9LoI"),
    $f458ce1537781522$var$load("8MaGw"),
    $f458ce1537781522$var$load("el56J"),
    $f458ce1537781522$var$load("kHDuB"),
    $f458ce1537781522$var$load("eiCsS"),
    $f458ce1537781522$var$load("ariuh"),
    $f458ce1537781522$var$load("eUsnQ"),
    $f458ce1537781522$var$load("jisiR"),
    $f458ce1537781522$var$load("icVON"),
    $f458ce1537781522$var$load("7EorR"),
    $f458ce1537781522$var$load("bPC3R"),
    $f458ce1537781522$var$load("bHb1X"),
    $f458ce1537781522$var$load("kHXvF"),
    $f458ce1537781522$var$load("hhss7"),
    $f458ce1537781522$var$load("aNyWk"),
    $f458ce1537781522$var$load("gSKF7"),
    $f458ce1537781522$var$load("dtNxV"),
    $f458ce1537781522$var$load("ffEVr"),
    $f458ce1537781522$var$load("ctxM8"),
    $f458ce1537781522$var$load("8Jd6S"),
    $f458ce1537781522$var$load("4Gdnz"),
    $f458ce1537781522$var$load("4UAag"),
    $f458ce1537781522$var$load("6zCMk"),
    $f458ce1537781522$var$load("ckGjo"),
    $f458ce1537781522$var$load("1sii7"),
    $f458ce1537781522$var$load("6gMrU"),
    $f458ce1537781522$var$load("kGmwI"),
    $f458ce1537781522$var$load("fq1gG"),
    $f458ce1537781522$var$load("fWCBZ"),
    $f458ce1537781522$var$load("cWL7t"),
    $f458ce1537781522$var$load("gbJtu"),
    $f458ce1537781522$var$load("6UKHF")
]).then(()=>parcelRequire('lJvEZ'));

});

parcelRegister("gpdJM", function(module, exports) {

let $bf19a31bfe5bddbb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bf19a31bfe5bddbb$var$load("6wr18"),
    $bf19a31bfe5bddbb$var$load("kOWvR"),
    $bf19a31bfe5bddbb$var$load("ffEVr"),
    $bf19a31bfe5bddbb$var$load("fq1gG"),
    $bf19a31bfe5bddbb$var$load("4D7T2")
]).then(()=>parcelRequire('1x5LM'));

});

parcelRegister("3NGbz", function(module, exports) {

let $2c46abe44c9a4d38$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2c46abe44c9a4d38$var$load("9HjYv").then(()=>parcelRequire('7SYCP'));

});

parcelRegister("2b91E", function(module, exports) {

let $19639c244e61a02c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $19639c244e61a02c$var$load("f2uDI").then(()=>parcelRequire('3deqg'));

});

parcelRegister("44sbU", function(module, exports) {

let $2f6d6750936bac7a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2f6d6750936bac7a$var$load("kOWvR").then(()=>parcelRequire('4uiGD'));

});

parcelRegister("9pOEz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9jl6v = parcelRequire("9jl6v");

const $1adfb96e71037064$export$1d04f0e8aa57d594 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9jl6v.InlineCommentsProvider), null, children);
};
module.exports["CommentContextWrapper"] = $1adfb96e71037064$export$1d04f0e8aa57d594;

});

parcelRegister("9jl6v", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $cozmU = parcelRequire("cozmU");


var $l0zDh = parcelRequire("l0zDh");


var $aHcFH = parcelRequire("aHcFH");


var $9FoVw = parcelRequire("9FoVw");


var $i49vP = parcelRequire("i49vP");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");

const $427c50c01d3953e2$export$87eb11c3f8007b3b = /*#__PURE__*/ (0, $cozmU.createContext)({
    createComment: ()=>{},
    clearCreateHighlight: ()=>{},
    onHighlightClick: ()=>{},
    toggleSidebar: ()=>{},
    setResolvedComment: ()=>{},
    setActiveHighlight: ()=>{},
    navigateToInlineComment: ()=>{}
});
$427c50c01d3953e2$export$87eb11c3f8007b3b.displayName = 'InlineCommentsDispatchContext';
const $427c50c01d3953e2$export$e6352a1cdc05c52c = /*#__PURE__*/ (0, $cozmU.createContext)({
    newCommentHighlight: undefined,
    highlightOrigin: 'userHighlight',
    activeHighlight: null,
    firstHighlightClicked: false,
    shouldDisplaySidebar: false,
    resolvedComment: null
});
$427c50c01d3953e2$export$e6352a1cdc05c52c.displayName = 'InlineCommentsContext';
const $427c50c01d3953e2$export$f54686667fb05777 = ({ children: children })=>{
    const [newCommentHighlight, setNewCommentHighlight] = (0, $cozmU.useState)();
    const [highlightOrigin, setHighlightOrigin] = (0, $cozmU.useState)('userHighlight');
    /**
   * We eventually want this value to be the official state for loading/displaying
   * the UI for inline comments. InlineCommentSidebar and some child components have created
   * stateful logic (active highlight, isSidebarShown, etc) that assumes
   * the code is always loaded which we will eventually adjust.
   */ const [shouldDisplaySidebar, setShouldDisplaySidebar] = (0, $cozmU.useState)(false);
    const firstHighlightClicked = (0, $cozmU.useRef)(false);
    const [activeHighlight, setActiveHighlight] = (0, $cozmU.useState)(null);
    const [resolvedComment, setResolvedComment] = (0, $cozmU.useState)(null);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const providerValue = (0, $cozmU.useMemo)(()=>({
            newCommentHighlight: newCommentHighlight,
            highlightOrigin: highlightOrigin,
            activeHighlight: activeHighlight,
            resolvedComment: resolvedComment,
            firstHighlightClicked: firstHighlightClicked.current,
            shouldDisplaySidebar: shouldDisplaySidebar
        }), [
        activeHighlight,
        highlightOrigin,
        newCommentHighlight,
        resolvedComment,
        shouldDisplaySidebar,
        firstHighlightClicked
    ]);
    const dispatchProviderValue = (0, $cozmU.useMemo)(()=>({
            createComment: (newHighlight, origin = 'userHighlight')=>{
                /**
       * Creating a comment is one of the three user explicit scenarios
       * where we want to load inline comments code.
       */ setShouldDisplaySidebar(true);
                setNewCommentHighlight(newHighlight);
                setHighlightOrigin(origin);
                if (resolvedComment) setResolvedComment(null);
            },
            clearCreateHighlight: ()=>setNewCommentHighlight(undefined),
            onHighlightClick: (markerRef)=>{
                if (!firstHighlightClicked.current) firstHighlightClicked.current = true;
                /**
       * Clicking on a highlight is one of the three user explicit scenarios
       * where we want to load inline comments code.
       */ if (markerRef) setShouldDisplaySidebar(true);
                else setShouldDisplaySidebar(false);
                setActiveHighlight(markerRef);
            },
            setResolvedComment: setResolvedComment,
            toggleSidebar: (shouldDisplay)=>setShouldDisplaySidebar(shouldDisplay),
            setActiveHighlight: setActiveHighlight,
            navigateToInlineComment: ({ action: action, triggeredByKeyboardShortcut: triggeredByKeyboardShortcut, currentCommentIndex: currentCommentIndex, onNavigationClick: onNavigationClick, getCommentIndex: getCommentIndex, isEditor: isEditor, removeCommentQueryParams: removeCommentQueryParams, unresolvedInlineComments: unresolvedInlineComments, createAnalyticsEvent: createAnalyticsEvent, contentId: contentId, isNavigateToNextUnread: isNavigateToNextUnread, unreadInlineComments: unreadInlineComments = [], unreadGeneralComments: unreadGeneralComments = [], footerComments: footerComments = [], scrollToFooterComment: scrollToFooterComment, commentsDataMap: commentsDataMap })=>{
                (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                    navigationAction: action
                });
                const couldBeNavigatingToFooterComment = triggeredByKeyboardShortcut && footerComments?.length > 0;
                if (unresolvedInlineComments?.length < 2 && !couldBeNavigatingToFooterComment) {
                    (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.abort({
                        abortReason: 'Comment navigation when only one comment'
                    });
                    experienceTracker.abort({
                        name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                        reason: 'Comment navigation when only one comment',
                        checkForTimeout: true,
                        publishDebugPoints: true,
                        attributes: {
                            stopPoint: 'comment-context/InlineCommentsContext'
                        }
                    });
                    return;
                }
                // Clear the focusedCommentId queryParams so that reply does not opens up if any...
                removeCommentQueryParams();
                const combinedInlineFooterComments = [
                    ...unresolvedInlineComments,
                    ...footerComments
                ];
                let nextThreadKey = '';
                let currentThreadKey = '';
                if (triggeredByKeyboardShortcut) {
                    if (isNavigateToNextUnread) {
                        // Add 1 to currentCommentIndex to move to the next comment, otherwise it gets stuck on the current comment
                        const nextIndex = currentCommentIndex + 1;
                        nextThreadKey = (0, $aHcFH.getNextUnreadThreadKey)(nextIndex, combinedInlineFooterComments, [
                            ...unreadInlineComments,
                            ...unreadGeneralComments
                        ]) ?? '';
                    } else nextThreadKey = (0, $aHcFH.getNextMarkerRef)(action, currentCommentIndex, combinedInlineFooterComments) ?? '';
                    currentThreadKey = combinedInlineFooterComments[currentCommentIndex];
                } else {
                    nextThreadKey = (0, $aHcFH.getNextMarkerRef)(action, currentCommentIndex, unresolvedInlineComments) ?? '';
                    currentThreadKey = unresolvedInlineComments[currentCommentIndex];
                }
                if (!nextThreadKey) {
                    (0, $4EKKB.selectInlineComment).debug(`Couldn't find next annotation to select in document`);
                    return;
                }
                (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                    annotationId: nextThreadKey
                });
                if (triggeredByKeyboardShortcut) {
                    if (footerComments.includes(nextThreadKey) && scrollToFooterComment && commentsDataMap?.general?.[nextThreadKey]) {
                        setActiveHighlight(null);
                        scrollToFooterComment(nextThreadKey);
                        (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.abort({
                            abortReason: 'Navigating to general comment'
                        });
                        return;
                    }
                }
                const nextCommentElement = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.getElementById(nextThreadKey) || // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.getElementById(`footer-comment-thread-${nextThreadKey}-container`);
                if (nextCommentElement) (0, $i49vP.checkElementExpandInEditor)(nextCommentElement);
                else (0, $4EKKB.selectInlineComment).debug('No annotation found in doc to check if in expand');
                onNavigationClick(nextThreadKey);
                const nextCommentIndex = getCommentIndex(nextThreadKey);
                const enableOnArrowNavigation = !triggeredByKeyboardShortcut;
                // Handle scrolling navigation
                if (enableOnArrowNavigation) (0, $9FoVw.handleInlineHeaderArrowsNavigation)({
                    previousMarkerRef: currentThreadKey,
                    nextMarkerRef: nextThreadKey,
                    context: isEditor ? (0, $9FoVw.NavigationContext).EDITOR : (0, $9FoVw.NavigationContext).RENDERER,
                    action: action,
                    nextCommentIndex: nextCommentIndex,
                    totalComments: unresolvedInlineComments.length
                });
                if (nextCommentElement) {
                    // As we navigate inline comments with arrow icons, we want to update the cursor location to where the open inline comment is
                    // unless it is a media node in which case, we want our selection to be the media node element.
                    const media = nextCommentElement.querySelector(`.${(0, $l0zDh.ClassNames).MEDIA_CONTAINER}`);
                    if (media) {
                        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                            commentType: 'block',
                            blockType: 'media'
                        });
                        enableOnArrowNavigation && window.getSelection()?.setPosition(media);
                    } else {
                        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                            commentType: 'inline'
                        });
                        enableOnArrowNavigation && window.getSelection()?.setPosition(nextCommentElement);
                    }
                }
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'navigate',
                        actionSubjectId: 'inlineCommentArrowsNavigate',
                        attributes: {
                            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                            action: action
                        },
                        objectType: 'inlineComment',
                        objectId: contentId,
                        source: isEditor ? 'editPageScreen' : 'renderPageScreen'
                    }
                }).fire();
            }
        }), [
        resolvedComment,
        firstHighlightClicked,
        setShouldDisplaySidebar,
        setHighlightOrigin,
        setResolvedComment,
        setActiveHighlight,
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($427c50c01d3953e2$export$e6352a1cdc05c52c.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($427c50c01d3953e2$export$87eb11c3f8007b3b.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $427c50c01d3953e2$export$89bc450b4e1563a9 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($427c50c01d3953e2$export$e6352a1cdc05c52c);
} : ()=>{
    return (0, $cozmU.useContext)($427c50c01d3953e2$export$e6352a1cdc05c52c);
};
const $427c50c01d3953e2$export$43e36990fc9d516b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($427c50c01d3953e2$export$87eb11c3f8007b3b);
} : ()=>{
    return (0, $cozmU.useContext)($427c50c01d3953e2$export$87eb11c3f8007b3b);
};
module.exports["InlineCommentsProvider"] = $427c50c01d3953e2$export$f54686667fb05777;
module.exports["useInlineCommentsContext"] = $427c50c01d3953e2$export$89bc450b4e1563a9;
module.exports["useInlineCommentsDispatchContext"] = $427c50c01d3953e2$export$43e36990fc9d516b;

});

parcelRegister("aHcFH", function(module, exports) {

var $1d2ww = parcelRequire("1d2ww");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $cD1qu = parcelRequire("cD1qu");


var $i49vP = parcelRequire("i49vP");

const $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7 = 'inline-create-comment-selection';
const $a78c261c3211f7d6$export$b803c692fbaaa5a4 = 'inline-highlight';
const $a78c261c3211f7d6$export$fb3d0eebfe85522a = 'active-highlight';
const $a78c261c3211f7d6$export$b899b07e3f725968 = ()=>{
    const commentData = {
        commentIndex: undefined,
        totalComments: undefined
    };
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) {
        commentData['commentIndex'] = Number(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['position']);
        commentData['totalComments'] = Number(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['totalComments']);
    }
    return commentData;
};
const $a78c261c3211f7d6$export$1f7acceb752add79 = (pageMode)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const marks = Array.from(document.querySelectorAll($a78c261c3211f7d6$export$8c7b048437c01388(pageMode))).map((node)=>{
        if (pageMode === 'edit') return node.id;
        else return $a78c261c3211f7d6$export$8f4213b45c05ab5d(node);
    });
    /* In case of overlapping comments there will be multiple tags with the same markerRefs. We need to remove
  duplicates in that case so we can navigate between comments correctly */ return new Set(marks);
};
const $a78c261c3211f7d6$export$9b48c18cc387f791 = (markerRefList, pageMode = 'view')=>{
    const distinctMarks = [
        ...$a78c261c3211f7d6$export$1f7acceb752add79(pageMode)
    ];
    return distinctMarks.filter((mark)=>mark && markerRefList.includes(mark));
};
const $a78c261c3211f7d6$export$8c7b048437c01388 = (pageMode = 'view')=>{
    if (pageMode === 'edit') return "[annotationtype='inlineComment']";
    else return '[data-mark-annotation-type="inlineComment"], .inline-comment-marker';
};
const $a78c261c3211f7d6$export$f7ceeb7ba8156450 = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const activeHighlights = document.querySelectorAll(`.${$a78c261c3211f7d6$export$fb3d0eebfe85522a}`);
    activeHighlights.forEach((activeHighlight)=>{
        activeHighlight.classList.remove($a78c261c3211f7d6$export$fb3d0eebfe85522a);
    });
};
const $a78c261c3211f7d6$var$getNextTextNodeOld = (node, boundingParentNode)=>{
    let currentNode = node;
    let nextTextNode = currentNode?.nextSibling;
    // If the node has no next sibling, grab it's parent's next sibling until we find a node
    while(!nextTextNode){
        nextTextNode = currentNode?.parentElement?.nextSibling;
        if (nextTextNode) {
            // WS-2551 - If the bounding parent exists and we're out of bounds of it, we're done looking
            if (boundingParentNode && !boundingParentNode.contains(nextTextNode)) {
                nextTextNode = null;
                break;
            }
            // If we've landed on a text node, then break out
            if (nextTextNode.nodeType === Node.TEXT_NODE) break;
            // If the node exists and it's a hard break (<br />), we do one of two things:
            //   1. If it has a bounding parent, break out because the <br /> signifies the end of the selection
            //   2. If not, then move to the next sibling because we don't count hard breaks in selections
            if (nextTextNode?.tagName === 'BR') {
                if (boundingParentNode) break;
                else nextTextNode = nextTextNode.nextSibling;
            }
        } else // If the text node we tried to access is null, we need to jump up a generation
        currentNode = currentNode?.parentNode;
    }
    // Search for the first text node in the next node
    while(nextTextNode && nextTextNode.nodeType !== Node.TEXT_NODE)nextTextNode = nextTextNode.firstChild;
    return nextTextNode;
};
const $a78c261c3211f7d6$export$3e98291f1f032a77 = (currentNode, boundingNode, isInlineMark)=>{
    let nextTextNode = isInlineMark ? currentNode : currentNode?.nextSibling;
    while(nextTextNode && nextTextNode.nodeType !== Node.TEXT_NODE){
        // If the text node is the bounding node, return that node
        if (boundingNode && nextTextNode?.isSameNode(boundingNode)) return nextTextNode;
        // Check if the node is a hard break (<br />) or an element with role="presentation" we do one of two things:
        if (nextTextNode?.tagName === 'BR') {
            // If it has a bounding parent, break out because the <br /> signifies the end of the selection
            if (boundingNode) return nextTextNode;
            // If not, then move to the next sibling because we don't count hard breaks in selections
            nextTextNode = nextTextNode.nextSibling;
        } else if (nextTextNode?.attributes?.getNamedItem('role')?.value === 'presentation') // If the element has role="presentation", move to the parent element's sibling because this current node does not contain a text node
        nextTextNode = nextTextNode.parentNode?.nextSibling;
        else if ($a78c261c3211f7d6$var$isEmojiNode(nextTextNode)) {
            // If we encounter an emoji and it's also the bounding node, return nothing
            if (boundingNode && nextTextNode?.isSameNode(boundingNode)) return null;
            // Otherwise, just return the node after it and keep going
            nextTextNode = nextTextNode.nextSibling;
        } else // Otherwise, search for the first text node in the next node
        nextTextNode = nextTextNode.firstChild;
    }
    // If we've found the text node, return that node
    if (nextTextNode?.nodeType === Node.TEXT_NODE) return nextTextNode;
    // If the text node we tried to access is null, we need to jump up a generation
    if (!nextTextNode) return $a78c261c3211f7d6$export$3e98291f1f032a77(currentNode?.parentNode, boundingNode);
};
const $a78c261c3211f7d6$var$extractTextNodesIntoRangesOld = (selectedRange)=>{
    const rangesToHighlight = [];
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = selectedRange;
    // NOTE: It's not possible for us to get here with anything other than "#text" nodes
    //       for the start container due to our highlighting restrictions, so we only
    //       need to check the type for endContainer when we get a selected range
    // WS-2551 - Triple clicks are the only thing that can cause the endContainer to be a non-text node
    const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
    // If the start and end containers don't match, we need to loop through and extract
    // the text nodes out all common elements and create ranges to represent each of them
    if (!startContainer.isSameNode(endContainer)) {
        let boundingParentNode;
        // Push the starting node into a range
        const startingRange = new Range();
        startingRange.setStart(startContainer, startOffset);
        startingRange.setEnd(startContainer, startContainer.length);
        rangesToHighlight.push(startingRange);
        // WS-2551 - In the case of a triple click, we only want to contain our selection to the
        // first non-comment parent wrapping the starting container to ensure we don't over select
        if (isTripleClick) {
            boundingParentNode = startContainer.parentNode;
            while(!boundingParentNode || boundingParentNode.nodeType === Node.TEXT_NODE || $a78c261c3211f7d6$export$8f4213b45c05ab5d(boundingParentNode) !== null)boundingParentNode = boundingParentNode?.parentNode;
        } else {
            // Push the ending node into a range only if it's not a triple click
            const endingRange = new Range();
            endingRange.setStart(endContainer, 0);
            endingRange.setEnd(endContainer, endOffset);
            rangesToHighlight.push(endingRange);
        }
        // Iterate through all the inner nodes and extract the text ranges
        let node = $a78c261c3211f7d6$var$getNextTextNodeOld(startContainer, boundingParentNode);
        while(node && !node.isSameNode(endContainer) && node.nodeType === Node.TEXT_NODE){
            if (node.length) {
                const range = new Range();
                range.selectNodeContents(node);
                rangesToHighlight.push(range);
            }
            node = $a78c261c3211f7d6$var$getNextTextNodeOld(node, boundingParentNode);
        }
    } else // If they are the same container it's much simpler and we can just use the range
    rangesToHighlight.push(selectedRange);
    return rangesToHighlight;
};
const $a78c261c3211f7d6$var$isEmojiNode = (node)=>{
    if (!node) return false;
    const attributes = node?.attributes;
    const classList = node?.classList;
    return attributes && attributes.getNamedItem('data-emoji-id') || classList && classList.contains('emoji-common-node');
};
const $a78c261c3211f7d6$var$extractTextNodesIntoRanges = (selectedRange)=>{
    const rangesToHighlight = [];
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = selectedRange;
    // NOTE: It's not possible for us to get here with anything other than "#text" nodes
    //       for the start container due to our highlighting restrictions, so we only
    //       need to check the type for endContainer when we get a selected range
    // The endContainer is a non-text node when the user either:
    // 1. Triple clicks a node
    // 2. Highlights a header
    // 3. The highlight goes to the next node but does not actually highlight anything (offset === 0)
    const isNonTextNodeEndContainer = endContainer.nodeType !== Node.TEXT_NODE;
    // If highlight is just one node (i.e. same containers), it's much simpler and we can just use the range
    if (startContainer.isSameNode(endContainer)) {
        rangesToHighlight.push(selectedRange);
        return rangesToHighlight;
    }
    // If the start and end containers don't match, we need to loop through and extract
    // the text nodes out all common elements and create ranges to represent each of them
    let boundingNode;
    // Push the starting node into a range
    const startingRange = new Range();
    startingRange.setStart(startContainer, startOffset);
    startingRange.setEnd(startContainer, startContainer.length);
    rangesToHighlight.push(startingRange);
    // In the case of a non-text node endContainer, we want to set a bounding node to the endContainer so we know
    // to stop traversing the DOM when hidding that bounding node
    if (isNonTextNodeEndContainer) {
        // If the end container is non-text and an emoji, we need to jump up a level or else it is
        // going to be bound to a node that we will never be able to check and thus never exit
        if ($a78c261c3211f7d6$var$isEmojiNode(endContainer)) boundingNode = endContainer.parentNode;
        else boundingNode = endContainer;
    } else {
        // Push the ending node into a range
        const endingRange = new Range();
        endingRange.setStart(endContainer, 0);
        endingRange.setEnd(endContainer, endOffset);
        rangesToHighlight.push(endingRange);
    }
    // Get the first "inner" node between the start and end containers
    let node = $a78c261c3211f7d6$export$3e98291f1f032a77(startContainer, boundingNode);
    // Iterate through all the inner nodes and extract the text ranges
    while(node && !node.isSameNode(endContainer) && node.nodeType === Node.TEXT_NODE){
        if (node.length) {
            const range = new Range();
            range.selectNodeContents(node);
            rangesToHighlight.push(range);
        }
        node = $a78c261c3211f7d6$export$3e98291f1f032a77(node, boundingNode);
    }
    return rangesToHighlight;
};
const $a78c261c3211f7d6$export$739c145b6a07c076 = (isFabricPage, isCreateDialogOpen = false, markerRef = '')=>{
    const highlightClass = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
    let markOffsetTop = 0;
    // Measure the offset of the highlight from the renderer wrapper
    // WS-2618 We have old macros that render tiny inline comments so we need to look for both fabric and tiny marker refs
    if (markerRef) {
        const highlight = $a78c261c3211f7d6$export$21445ab787d3b446(markerRef);
        markOffsetTop = $a78c261c3211f7d6$export$331805bfbe18b1c0(highlight);
    } else {
        const selection = window.getSelection();
        // If there is a user selection, we need to create a new temp "highlight" for this
        // new selection as it is removed when the temp "highlight" is created
        const isNewSelection = selection && selection.type == 'Range' && !isCreateDialogOpen;
        if (isNewSelection) {
            // Reset any existing DOM selections
            $a78c261c3211f7d6$export$743373b19993e2b0();
            // Mark the selection in the DOM temporarily
            $a78c261c3211f7d6$export$4147ba71ff179432(false);
        }
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const createCommentHighlight = document.querySelector(`.${highlightClass}`);
        markOffsetTop = $a78c261c3211f7d6$export$331805bfbe18b1c0(createCommentHighlight);
    }
    // On a fabric page, the highlight is positioned relative to the renderer
    // wrapper. To correctly position the sidebar we need to measure the offset
    // of the renderer wrapper and the offset of the highlight from the wrapper
    if (isFabricPage) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const rendererWrapper = document.querySelector('#content .ak-renderer-wrapper');
        if (rendererWrapper) markOffsetTop += rendererWrapper.offsetTop;
    } else {
        // In tiny, we need to remove the title and author info offset to position it correctly
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const pageMetadata = document.querySelector('#content-body .page-metadata-modification-info');
        if (pageMetadata) markOffsetTop -= pageMetadata.offsetTop - pageMetadata.offsetHeight;
    }
    return markOffsetTop;
};
const $a78c261c3211f7d6$export$4147ba71ff179432 = (useNewHighlightLogic)=>{
    const highlightClass = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
    const selection = window.getSelection();
    if (!selection || selection.type !== 'Range') // Throw error?
    return;
    // Extract the range
    const selectedRange = selection.getRangeAt(0);
    // Get an array of the ranges to make highlights
    const rangesToHighlight = useNewHighlightLogic ? $a78c261c3211f7d6$var$extractTextNodesIntoRanges(selectedRange) : $a78c261c3211f7d6$var$extractTextNodesIntoRangesOld(selectedRange);
    rangesToHighlight.forEach((range)=>{
        // Create a new wrapper element with the correct class
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const highlightWrapper = document.createElement('span');
        highlightWrapper.classList.add(highlightClass);
        // Extract the contents of the range and add it to the new wrapper
        highlightWrapper.appendChild(range.extractContents());
        // Re-insert the wrapper back into the range
        range.insertNode(highlightWrapper);
    });
    // Clear the selection
    selection.removeAllRanges();
};
const $a78c261c3211f7d6$var$unwrapTextNodes = (wrappedNodes)=>{
    while(wrappedNodes.length){
        const node = wrappedNodes.shift();
        if (!node) return;
        const { parentNode: parentNode } = node;
        // Extract the text contents of the selection node out of the temp wrapper
        while(node.firstChild)parentNode?.insertBefore(node.firstChild, node);
        // After the text has been extracted, delete the wrapper
        parentNode?.removeChild(node);
        // Normalize the parent to fix any text node fragmentation
        parentNode?.normalize();
    }
};
const $a78c261c3211f7d6$export$743373b19993e2b0 = ()=>{
    const highlightClass = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
    // Grab all the newly created selection nodes
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const tempSelectionNodes = Array.from(document.querySelectorAll(`.${highlightClass}`));
    $a78c261c3211f7d6$var$unwrapTextNodes(tempSelectionNodes);
};
const $a78c261c3211f7d6$export$a160a5110cbadcb8 = (isFabricPage, markerRef, isActive = true)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const createCommentSelectionNodes = document.querySelectorAll(`.${$a78c261c3211f7d6$export$d2bdbdaa2c26e7f7}`);
    const ref = markerRef || '';
    // If we find selection nodes in the DOM, we need to add some attributes to them,
    // based on the page type, so they behave correctly when the user clicks a highlight
    if (createCommentSelectionNodes.length) createCommentSelectionNodes.forEach((selectionNode)=>{
        if (isFabricPage) {
            selectionNode.setAttribute($a78c261c3211f7d6$export$98471574bfa5228e, ref);
            selectionNode.setAttribute('data-mark-annotation-type', 'inlineComment');
        } else {
            selectionNode.setAttribute($a78c261c3211f7d6$export$90ee95b6cd79c832, ref);
            selectionNode.classList.add('inline-comment-marker');
        }
        const classesToAdd = [
            $a78c261c3211f7d6$export$b803c692fbaaa5a4
        ];
        if (isActive) classesToAdd.push($a78c261c3211f7d6$export$fb3d0eebfe85522a);
        // Add the classes needed
        selectionNode.classList.add(...classesToAdd);
        // Finally, remove the selection class to make it a full mark
        selectionNode.classList.remove($a78c261c3211f7d6$export$d2bdbdaa2c26e7f7);
    });
};
const $a78c261c3211f7d6$var$setHighlightsAsActive = (highlightElement, skipClassCheck = false)=>{
    if (skipClassCheck || highlightElement.classList.contains($a78c261c3211f7d6$export$b803c692fbaaa5a4)) highlightElement.classList.add($a78c261c3211f7d6$export$fb3d0eebfe85522a);
    // We need to set all the children of this highlight to active as well
    const { children: children } = highlightElement;
    for(let i = 0; i < children.length; ++i)$a78c261c3211f7d6$var$setHighlightsAsActive(children[i], skipClassCheck);
};
const $a78c261c3211f7d6$export$fd55463aeed84830 = (markerRef, skipClassCheck = false)=>{
    const highlightMarks = $a78c261c3211f7d6$export$6dfccc77fe608546(markerRef) || [];
    highlightMarks.forEach((highlight)=>$a78c261c3211f7d6$var$setHighlightsAsActive(highlight, skipClassCheck));
};
const $a78c261c3211f7d6$export$280edc47a64130be = (markerRef)=>{
    const highlight = $a78c261c3211f7d6$export$21445ab787d3b446(markerRef || '');
    return Boolean(highlight && highlight.classList.contains($a78c261c3211f7d6$export$fb3d0eebfe85522a));
};
const $a78c261c3211f7d6$export$a26c4eafef12029f = (markerRef)=>{
    const highlightMarksToRemove = Array.from($a78c261c3211f7d6$export$6dfccc77fe608546(markerRef));
    $a78c261c3211f7d6$var$unwrapTextNodes(highlightMarksToRemove);
    $a78c261c3211f7d6$export$f7ceeb7ba8156450();
};
const $a78c261c3211f7d6$export$a0939f064b367798 = ()=>{
    const highlightedAnnotations = Array.from(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelectorAll('.ak-editor-annotation-blur, .ak-editor-annotation-focus'));
    const highlightedAnnotationIds = highlightedAnnotations.map((annotation)=>annotation?.closest('.annotationView-content-wrap')?.id).filter((id)=>Boolean(id));
    return new Set(highlightedAnnotationIds);
};
const $a78c261c3211f7d6$export$98471574bfa5228e = 'data-id';
const $a78c261c3211f7d6$export$90ee95b6cd79c832 = 'data-ref';
const $a78c261c3211f7d6$var$hasAdfContent = (input)=>{
    const content = input && input.content;
    return content && content.some($a78c261c3211f7d6$var$validateContent);
};
// Check to make sure if we have item.type as paragraph content is not empty (user did not type anything)
// or user has put in blank spaces(empty string) and clicked save
// Any type other than paragraph is valid (e.g:- when user inserts divider, status etc without content)
const $a78c261c3211f7d6$var$validateContent = (item)=>item.type !== 'paragraph' || $a78c261c3211f7d6$var$validateParagraph(item);
const $a78c261c3211f7d6$var$validateParagraph = (item)=>{
    if (item.content) return item.content.some($a78c261c3211f7d6$var$isParagraphNotEmpty);
    return false;
};
const $a78c261c3211f7d6$var$isParagraphNotEmpty = (item)=>item.type !== 'text' || item.text.trim() !== '';
const $a78c261c3211f7d6$export$915f03d46d87bfd4 = (adf)=>!adf || !$a78c261c3211f7d6$var$hasAdfContent(adf);
const $a78c261c3211f7d6$export$d204c0ea9b3f0d7d = (isFabricPage)=>isFabricPage ? $a78c261c3211f7d6$export$98471574bfa5228e : $a78c261c3211f7d6$export$90ee95b6cd79c832;
const $a78c261c3211f7d6$export$8f4213b45c05ab5d = (element)=>{
    let markerRef = null;
    if (element) {
        markerRef = element.getAttribute($a78c261c3211f7d6$export$98471574bfa5228e);
        if (!markerRef) markerRef = element.getAttribute($a78c261c3211f7d6$export$90ee95b6cd79c832);
    }
    return markerRef;
};
const $a78c261c3211f7d6$export$21445ab787d3b446 = (markerRef, additionalQueryScope = '')=>{
    if (!markerRef) return null;
    // We need to allow for additional query scope to be added to specify particular markerRef comments
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    return document.querySelector(`${additionalQueryScope} [${$a78c261c3211f7d6$export$98471574bfa5228e}="${markerRef}"], ${additionalQueryScope} [${$a78c261c3211f7d6$export$90ee95b6cd79c832}="${markerRef}"]`);
};
const $a78c261c3211f7d6$export$6dfccc77fe608546 = (markerRef)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    return document.querySelectorAll(`[${$a78c261c3211f7d6$export$98471574bfa5228e}="${markerRef}"], [${$a78c261c3211f7d6$export$90ee95b6cd79c832}="${markerRef}"]`);
};
const $a78c261c3211f7d6$var$isHighlightCandidateVisible = (element)=>{
    const rect = element.getBoundingClientRect();
    const computedStyle = window.getComputedStyle(element);
    return element.isConnected && computedStyle.display !== 'none' && computedStyle.visibility !== 'hidden' && element.getAttribute('aria-hidden') !== 'true' && (rect.width > 0 || rect.height > 0);
};
const $a78c261c3211f7d6$export$c36aa9f15eddb765 = (markerRef)=>{
    if (!markerRef) return null;
    const allHighlights = Array.from($a78c261c3211f7d6$export$6dfccc77fe608546(markerRef));
    const visibleHighlight = allHighlights.find((element)=>$a78c261c3211f7d6$var$isHighlightCandidateVisible(element));
    return visibleHighlight || $a78c261c3211f7d6$export$21445ab787d3b446(markerRef);
};
const $a78c261c3211f7d6$export$6d23af9d8c2844b1 = [
    'enter',
    'escape'
];
const $a78c261c3211f7d6$var$getDimensions = ()=>{
    try {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const nav4ScrollParent = document.getElementById('AkMainContent');
        const currentPageOffset = !!nav4ScrollParent ? nav4ScrollParent.scrollTop : window.scrollY || (window.top?.scrollY ?? 0);
        return {
            currentWindowHeight: window.innerHeight || (window.top?.innerHeight ?? 0),
            currentPageOffset: currentPageOffset
        };
    } catch  {
        // Catch cross origin iframe error https://hello.atlassian.net/browse/CBT-907
        return {
            currentWindowHeight: 0,
            currentPageOffset: 0
        };
    }
};
const $a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET = 350;
const $a78c261c3211f7d6$export$858fd2398afb28e4 = (commentElement, useInstantScroll = false, isAbove = false)=>{
    if (!commentElement) return;
    const { currentWindowHeight: currentWindowHeight, currentPageOffset: currentPageOffset } = $a78c261c3211f7d6$var$getDimensions();
    const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement) + commentElement.offsetHeight + (isAbove ? -$a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET : 0);
    // If the position of the comment box is more than halfway down the screen, reposition it to the center
    if (offset <= currentPageOffset || offset > currentPageOffset + currentWindowHeight * (2 / 3)) {
        const windowOffset = currentWindowHeight / 5;
        window.scrollTo({
            top: offset - windowOffset,
            behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
        });
    }
};
const $a78c261c3211f7d6$export$b451b837f5309ae9 = ({ commentId: commentId, targetCommentId: targetCommentId, isEditor: isEditor, viewingRoomOffset: viewingRoomOffset = -150, useInstantScroll: useInstantScroll = false })=>{
    if (commentId !== targetCommentId) return;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const commentElement = document.querySelector(`[data-comment-id="${commentId}"]`);
    if (isEditor && commentElement) (0, $i49vP.scrollToElementInEditor)({
        targetElement: commentElement,
        viewingRoomOffset: viewingRoomOffset
    });
    else $a78c261c3211f7d6$export$fc9b5eebad60b835({
        element: commentElement,
        viewingRoomOffset: viewingRoomOffset,
        useInstantScroll: useInstantScroll
    });
};
const $a78c261c3211f7d6$export$e5d4e097ce63febc = ({ commentElement: commentElement, scrollRootElement: scrollRootElement, currentPageOffset: currentPageOffset, currentWindowHeight: currentWindowHeight, isAbove: isAbove, isFabricPage: isFabricPage, useInstantScroll: useInstantScroll })=>{
    if (!commentElement) return;
    // We may be in an iframe so use window.top
    const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement) + commentElement.offsetHeight + (isAbove ? -$a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET : 0);
    const rendererOffset = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector('#content .ak-renderer-wrapper')?.offsetTop || 0;
    // If the position of the highlight is more than halfway down the screen, reposition it to the center
    if (offset + rendererOffset <= currentPageOffset || offset + rendererOffset > currentPageOffset + currentWindowHeight * (2 / 3)) {
        const windowOffset = isFabricPage ? currentWindowHeight / 5 : currentWindowHeight / 3;
        scrollRootElement.scrollTo({
            top: offset - windowOffset,
            behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
        });
    }
};
const $a78c261c3211f7d6$export$c7436bd0a15f3e7e = ({ commentElement: commentElement, isFabricPage: isFabricPage, useInstantScroll: useInstantScroll = false, isAbove: isAbove = false, isCommentsPanel: isCommentsPanel })=>{
    if (!commentElement) return;
    const nodeToConsider = $a78c261c3211f7d6$export$ee0755cb593feed6(commentElement) || commentElement;
    const targetCommentHighlight = nodeToConsider.getBoundingClientRect();
    const { scrollRootElement: scrollRootElement, getDimensions: getDimensionsFromScrollRootContext } = $a78c261c3211f7d6$var$getScrollRootContext();
    const { currentWindowHeight: currentWindowHeight, currentPageOffset: currentPageOffset } = getDimensionsFromScrollRootContext();
    if (isCommentsPanel) {
        const commentHighlightAboveViewPort = Math.floor(targetCommentHighlight.bottom) < currentPageOffset;
        const commentHighlightBelowViewPort = targetCommentHighlight.top + 200 > window.innerHeight;
        // Scroll the highlight into view in the main content body
        if (commentHighlightAboveViewPort || commentHighlightBelowViewPort) $a78c261c3211f7d6$export$e5d4e097ce63febc({
            commentElement: commentElement,
            scrollRootElement: scrollRootElement,
            currentPageOffset: currentPageOffset,
            currentWindowHeight: currentWindowHeight,
            isAbove: isAbove,
            isFabricPage: !!isFabricPage,
            useInstantScroll: useInstantScroll
        });
    } else $a78c261c3211f7d6$export$e5d4e097ce63febc({
        commentElement: commentElement,
        scrollRootElement: scrollRootElement,
        currentPageOffset: currentPageOffset,
        currentWindowHeight: currentWindowHeight,
        isAbove: isAbove,
        isFabricPage: !!isFabricPage,
        useInstantScroll: useInstantScroll
    });
    //If comment is in expand, open respective expand
    $a78c261c3211f7d6$export$876171b9c9b54aab(commentElement, isFabricPage);
};
const $a78c261c3211f7d6$export$66b4d1e3b6633573 = (target, scrollContainer)=>{
    const rect = target.getBoundingClientRect();
    const parentRect = scrollContainer.getBoundingClientRect();
    let moveY = 0;
    // The distance (in pixels) between the target and the end of the visible viewport at which point,
    // when scrolling the target into view, scrolling takes place.
    const SCROLL_THRESHOLD = 60;
    // The extra space (in pixels) that is left above or below the target when it is scrolled into view.
    const SCROLL_MARGIN = 120;
    // Note: visible area of the container refers to parentRect.top/bottom +/- SCROLL_THRESHOLD
    if (rect.top < parentRect.top + SCROLL_THRESHOLD) // If the target is above the top of the visible area of the container, moveY should be negative to bring target down into view
    moveY = -(parentRect.top - rect.top + SCROLL_MARGIN);
    else if (rect.bottom > parentRect.bottom - SCROLL_THRESHOLD) // If the target's bottom is below the bottom of the visible area of the container, move Y should be positive to bring target up into view
    moveY = rect.bottom - parentRect.bottom + SCROLL_MARGIN;
    if (moveY) scrollContainer.scrollTop += moveY;
};
const $a78c261c3211f7d6$export$fb40c5e75b82df8 = (isEditor, isViewCommentMode)=>{
    if (isEditor && isViewCommentMode) return 'editor-comments-sidebar';
    else if (isEditor && !isViewCommentMode) return 'editor-create-sidebar';
    else if (!isEditor && isViewCommentMode) return 'renderer-comments-sidebar';
    else return 'renderer-create-sidebar';
};
const $a78c261c3211f7d6$export$59a770a0e59b0dd2 = (container)=>{
    const selector = [
        'button:not([disabled])',
        'a[href]',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[contenteditable="true"]',
        '[tabindex]:not([tabindex="-1"])'
    ].join(',');
    return Array.from(container.querySelectorAll(selector)).filter((element)=>!element.hasAttribute('disabled') && element.getAttribute('aria-hidden') !== 'true');
};
const $a78c261c3211f7d6$export$642e21ba866d02df = (container, element)=>{
    if (!element) return false;
    return $a78c261c3211f7d6$export$59a770a0e59b0dd2(container)[0] === element;
};
const $a78c261c3211f7d6$export$876aeb5dffd449af = (container, element)=>{
    if (!element) return false;
    const tabbableElements = $a78c261c3211f7d6$export$59a770a0e59b0dd2(container);
    return tabbableElements[tabbableElements.length - 1] === element;
};
const $a78c261c3211f7d6$export$cfa8eefe354167cd = (element, focusOptions)=>{
    element.setAttribute('tabIndex', '-1');
    element.focus(focusOptions);
};
const $a78c261c3211f7d6$export$db9eae89818590a4 = (commentElement, previousCommentElement, isFabricPage, isEditor)=>{
    if (!commentElement) return;
    const { scrollRootElement: scrollRootElement, scrollRootOffset: scrollRootOffset } = $a78c261c3211f7d6$var$getScrollRootContext();
    // if current open comment is out of viewport, we need to scroll so that the next comment is in viewport
    const sidebarId = $a78c261c3211f7d6$export$fb40c5e75b82df8(isEditor, true); // Hard-coding isViewCommentMode to true because navigation only exists in the view scenario
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const inlineCommentSidebar = document.getElementById(sidebarId);
    const inlineCommentPosition = inlineCommentSidebar?.getBoundingClientRect();
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const documentContent = document.getElementById('content');
    const documentContentTopPosition = documentContent?.getBoundingClientRect().top;
    const commentAboveViewport = inlineCommentPosition && documentContentTopPosition && inlineCommentPosition.top < documentContentTopPosition + scrollRootOffset;
    const commentBelowViewport = inlineCommentPosition && inlineCommentPosition.top + 200 > window.innerHeight;
    if (commentAboveViewport || commentBelowViewport) {
        $a78c261c3211f7d6$export$c7436bd0a15f3e7e({
            commentElement: commentElement,
            isFabricPage: isFabricPage
        });
        return;
    }
    const previousOffset = previousCommentElement ? $a78c261c3211f7d6$export$331805bfbe18b1c0(previousCommentElement) : 0;
    const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement);
    const differenceOffset = offset - previousOffset;
    scrollRootElement.scrollBy({
        top: differenceOffset,
        behavior: 'smooth' // navigation uses a smooth scroll
    });
    // If comment is in expand, open respective expand
    $a78c261c3211f7d6$export$876171b9c9b54aab(commentElement, isFabricPage);
};
const $a78c261c3211f7d6$var$adjustNodeForStickyHeader = (stickyHeaderElement)=>{
    let adjustedElement = stickyHeaderElement;
    const markerRef = $a78c261c3211f7d6$export$8f4213b45c05ab5d(adjustedElement);
    // If this is exists it's a commited comment, look for its counterpart in the real table
    // TODO: Support new highlights when we allow it
    if (markerRef) // WS-2618 We have old macros that render tiny inline comments so we need to look for both fabric and tiny marker refs
    adjustedElement = $a78c261c3211f7d6$export$21445ab787d3b446(markerRef, '.pm-table-wrapper');
    return adjustedElement;
};
const $a78c261c3211f7d6$export$ee0755cb593feed6 = (element)=>{
    let nodeToReturn = element;
    // Sticky table headers duplicate the elements in the DOM so we need to check if this is the real one or not
    // If the highlight has a parent with the class .pm-table-sticky-wrapper it is the fake one
    if (nodeToReturn && nodeToReturn.closest && nodeToReturn.closest('.pm-table-sticky-wrapper')) nodeToReturn = $a78c261c3211f7d6$var$adjustNodeForStickyHeader(nodeToReturn);
    if (nodeToReturn) {
        // WS-2718 - If a comment is in an extension macro
        const extensionParent = nodeToReturn.closest('.ak-renderer-extension');
        if (extensionParent) nodeToReturn = extensionParent;
    }
    return nodeToReturn;
};
const $a78c261c3211f7d6$export$331805bfbe18b1c0 = (element, relativeToElement, isRendererAnnotationProviderEnabled)=>{
    let elementOffsetTop = 0;
    let nodeToMeasure = element;
    // new sticky header implementation
    if ((0, $6mKj3.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow')) {
        if (relativeToElement && nodeToMeasure && nodeToMeasure.closest && nodeToMeasure.closest('tr.pm-table-row-native-sticky-active')) {
            const elementRect = nodeToMeasure.getBoundingClientRect();
            const containerRect = relativeToElement.getBoundingClientRect();
            return elementRect.top - containerRect.top;
        }
    }
    // Sticky table headers duplicate the elements in the DOM so we need to check if this is the real one or not
    // If the highlight has a parent with the class .pm-table-sticky-wrapper it is the fake one
    if (nodeToMeasure && nodeToMeasure.closest && nodeToMeasure.closest('.pm-table-sticky-wrapper')) // The RAP annotation draft mark is applied to the both pm-table-sticky-wrapper as well as the pm-table-wrapper.
    // Need to check only pm-table-wrapper annotation draft mark for the RAP enabled
    nodeToMeasure = isRendererAnnotationProviderEnabled ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector(`.pm-table-wrapper [data-annotation-draft-mark="true"]`) : $a78c261c3211f7d6$var$adjustNodeForStickyHeader(nodeToMeasure);
    // Iterate through the offset parents until we are back to the ak-renderer-wrapper to get the
    // proper offset Fabric Pages wrap the content in a .ak-renderer-wrapper element, but Tiny
    // pages do not have anything like that, but will return null when we get to <body>
    while(nodeToMeasure && !nodeToMeasure.classList.contains('ak-renderer-wrapper') && nodeToMeasure !== relativeToElement){
        elementOffsetTop += nodeToMeasure.offsetTop;
        nodeToMeasure = nodeToMeasure.offsetParent;
    }
    // WS-2718 - If a comment is in an extension macro, we need to add its container offset as well
    if (nodeToMeasure) {
        const extensionParent = nodeToMeasure.closest('.ak-renderer-extension');
        if (extensionParent) elementOffsetTop += extensionParent.offsetTop;
    }
    return elementOffsetTop;
};
const $a78c261c3211f7d6$export$d0d02dc9adb82d62 = (element, isFabricPage)=>{
    //get the child of element passed in
    const expandElement = element?.hasChildNodes() ? element?.firstChild : element;
    //check if element is expand button and return element if so
    if (isFabricPage) {
        if (expandElement?.tagName?.toLowerCase() === 'button') return expandElement;
    } else if (expandElement?.classList?.contains('expand-control')) return expandElement?.firstChild; //it's one child down for tiny pages
    return null;
};
const $a78c261c3211f7d6$export$1a2319f5c2109ee1 = (element, options)=>{
    const { expandSelectors: expandSelectors, getExpandButton: getExpandButton, isExpanded: isExpanded, onExpand: onExpand } = options;
    const nodeToCheck = element;
    // Check if comment is in any expand
    const isInExpand = expandSelectors.some((selector)=>nodeToCheck?.closest?.(selector));
    if (!isInExpand) return;
    // Find all expand buttons that need to be opened, starting from the innermost
    const expandButtonsToOpen = [];
    let currentNode = nodeToCheck;
    while(currentNode){
        // Check if current node has an expand button
        const expandButton = getExpandButton(currentNode);
        if (expandButton) // Check if this expand is already opened
        {
            if (!isExpanded(expandButton)) expandButtonsToOpen.push(expandButton);
        }
        currentNode = currentNode?.parentElement;
    }
    // Open all expand buttons from innermost to outermost
    const buttonsToClick = [
        ...expandButtonsToOpen
    ].reverse();
    buttonsToClick.forEach((expandButton)=>{
        if (onExpand) onExpand(expandButton);
        expandButton.click();
    });
};
const $a78c261c3211f7d6$export$d2685a53bf6957f4 = (element, isFabricPage)=>{
    const expandElementClassname = isFabricPage ? '.expand-content-wrapper' : '.expand-content';
    const nestedExpandElementClassname = '.nestedExpand-content-wrapper';
    const expandSelectors = [
        expandElementClassname,
        nestedExpandElementClassname
    ];
    const getExpandButton = (node)=>$a78c261c3211f7d6$export$d0d02dc9adb82d62(node, isFabricPage);
    const isExpanded = (button)=>{
        return isFabricPage ? button.getAttribute('aria-expanded') === 'true' : button.className.includes('expanded');
    };
    $a78c261c3211f7d6$export$1a2319f5c2109ee1(element, {
        isFabricPage: isFabricPage,
        expandSelectors: expandSelectors,
        getExpandButton: getExpandButton,
        isExpanded: isExpanded
    });
};
const $a78c261c3211f7d6$export$876171b9c9b54aab = (element, isFabricPage)=>{
    $a78c261c3211f7d6$export$d2685a53bf6957f4(element, isFabricPage);
};
const $a78c261c3211f7d6$export$187f977414e8342c = (action, index, markerRefList)=>{
    if (markerRefList.length === 0 || index === undefined || index === -1) return;
    let commentIndex = -1;
    //Navigate to first inline comment if we're on the last comment and the user clicks next,
    // or to the last comment if we're on the first comment and the user clicks previous
    if (action === 'next') commentIndex = index === markerRefList.length - 1 ? 0 : index + 1;
    else if (action === 'previous') commentIndex = index === 0 ? markerRefList.length - 1 : index - 1;
    return markerRefList[commentIndex];
};
const $a78c261c3211f7d6$export$883ebc059dd86e88 = (index, markerRefList, unreadMarkerRefList)=>{
    if (index === undefined || markerRefList.length === 0 || index === -1 || !unreadMarkerRefList || unreadMarkerRefList.length === 0) return;
    let commentIndex = index % markerRefList.length; // Handle case where index is beyond array length
    const refListLength = markerRefList.length;
    let iterations = 0;
    while(markerRefList[commentIndex] !== undefined && !unreadMarkerRefList.includes(markerRefList[commentIndex]) && iterations < refListLength){
        commentIndex = (commentIndex + 1) % markerRefList.length;
        iterations++;
    }
    return markerRefList[commentIndex];
};
const $a78c261c3211f7d6$export$b401b3c3a0774fd7 = ()=>// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
const $a78c261c3211f7d6$export$2cdf1b96a9f86d16 = async (text)=>{
    if ($a78c261c3211f7d6$export$b401b3c3a0774fd7()) // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    await navigator.clipboard.writeText(text);
};
const $a78c261c3211f7d6$export$ab567600730c0b3b = (annotationElement, scrollParentSelector)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const scrollParent = document.querySelector(scrollParentSelector);
    return $a78c261c3211f7d6$export$331805bfbe18b1c0(annotationElement, scrollParent);
};
const $a78c261c3211f7d6$export$3cdeee3ea1732782 = (annotationElement, scrollParentSelector, isView)=>{
    let offset = 0;
    if (annotationElement) {
        // If the annotation is the wrapperDOM, we actually need #content to be the scrollParent
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const scrollParent = document.querySelector('div#content[data-inline-comments-target="true"]');
        if (scrollParent) {
            let annotationOffset;
            if (isView) annotationOffset = $a78c261c3211f7d6$export$331805bfbe18b1c0(annotationElement);
            else {
                // If the annotation is the wrapperDOM, we need to find the actual highlight instead
                const actualHiglightElement = scrollParent.querySelector(scrollParentSelector);
                annotationOffset = $a78c261c3211f7d6$export$331805bfbe18b1c0(actualHiglightElement, undefined, true);
            }
            offset = annotationOffset + scrollParent.offsetTop;
        }
    }
    return offset;
};
const $a78c261c3211f7d6$export$9f8164812b21bc7a = (entries)=>{
    const windowHeight = window.innerHeight;
    if ((0, $6mKj3.expValEquals)('confluence_unify_footer_comments_space_width', 'isEnabled', true) || (0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_space_ld')) {
        if (!(0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_space_ld')) {
            // When fg is ON, we would have verified that there's no
            // endOfPageRecommendations before adding this ResizeObserver.
            // So no need to check it here.
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const endOfPageRecommendations = document.querySelector('.end-of-page-rec-wrapper');
            if (endOfPageRecommendations) return 0;
        }
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const editorTextArea = document.getElementById('ak-editor-textarea');
        const editorBottom = editorTextArea?.getBoundingClientRect().bottom;
        if (editorBottom && windowHeight) {
            // The minimum spacing between bottom of editor content and top of footer is 120px
            const minimumSpacing = 120;
            // - There's an existing fixed 24px margin below editor content.
            // - ObjectAddCommentContainer.tsx has a 64px height.
            // - We lift footer comment top by 14px to make it visually distinct
            //   when a short LiveDoc has some vs zero existing footer comment.
            const editorBottomMargin = 24;
            const addFooterCommentHeight = 64;
            const extraFooterCommentHeightToShow = 14;
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const editorScrollParent = document.querySelector('.fabric-editor-popup-scroll-parent');
            const currentScroll = editorScrollParent?.scrollTop ?? 0;
            const editorBottomUnscrolled = editorBottom + currentScroll;
            const verticalDistanceFromWindowBottomUnscrolled = windowHeight - editorBottomUnscrolled;
            return Math.max(verticalDistanceFromWindowBottomUnscrolled - editorBottomMargin - addFooterCommentHeight - extraFooterCommentHeightToShow, minimumSpacing);
        }
    } else {
        // The calculation is
        // 15px of marginTop on the comment container
        // 2px full-page-editor-style bottom which above the viewport
        // 1px border which is cumulates to 120px
        const thresholdTop = 102;
        const editorEntry = entries.find((entry)=>entry.target.id === 'ak-editor-textarea');
        const editorBottom = editorEntry?.target.getBoundingClientRect().bottom;
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const editorContentHeight = document.querySelector(`.ak-editor-content-area .ProseMirror`)?.getBoundingClientRect().height;
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const documentContentBottom = document.querySelector(`[data-testid='full-page-editor-style']`)?.getBoundingClientRect().bottom;
        if (editorContentHeight) {
            // If the document content is larger than the window height, just set it to a static 120 to keep the proper spacing
            if (editorContentHeight > windowHeight) return 120;
            if (documentContentBottom && editorBottom) {
                const verticalDistance = documentContentBottom - editorBottom;
                if (verticalDistance >= thresholdTop && editorContentHeight <= windowHeight) return verticalDistance - thresholdTop;
                else if (verticalDistance <= thresholdTop) return thresholdTop;
            }
        }
    }
};
const $a78c261c3211f7d6$export$e3a17b46d43aa5f6 = ()=>{
    // This is deprecated, and will be replaced by a new approach that works in SSR.
    let newTop = 0;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const endOfPageRecommendations = document.querySelector('.end-of-page-rec-wrapper');
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const legacyLabels = document.querySelector('[data-vc="view-page-labels-container"]');
    // no extra spacing if the page shows end-of-page recommendations or legacy labels
    if (!endOfPageRecommendations && !legacyLabels) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const rendererContent = document.getElementById('main-content');
        const rendererContentBottom = rendererContent?.getBoundingClientRect()?.bottom ?? 0;
        if (rendererContentBottom) {
            // - There's an existing fixed 80px margin below Page content (See
            //   next/packages/view-page-common/src/ViewPageContent.tsx).
            // - ObjectAddCommentContainer.tsx has a 64px height.
            // - We lift footer comment top by 14px (matching Editor version ^)
            //   to make it visually distinct when a short Page has some vs zero
            //   existing footer comment.
            const contentBottomMargin = 80;
            const addFooterCommentHeight = 64;
            const extraFooterCommentHeightToShow = 14;
            // Find the current scroll offset on the Page.
            // This is similar to implementation in getDimensionsForNav4(),
            // but when the window is very narrow, nav4ScrollParent.scrollTop
            // can be 0 (nav4ScrollParent element itself exists on page) while
            // window.scrollY is positive.
            // So this is a more robust implementation. Will explore whether
            // getDimensionsForNav4() can be updated to use this implementation
            // in a separate PR.
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const nav4ScrollParent = document.getElementById('AkMainContent');
            const currentPageOffset = (nav4ScrollParent?.scrollTop ?? 0) + (window.scrollY ?? window.top?.scrollY ?? 0);
            const rendererContentBottomUnscrolled = rendererContentBottom + currentPageOffset;
            const windowHeight = window.innerHeight;
            const verticalDistanceFromWindowBottomUnscrolled = windowHeight - rendererContentBottomUnscrolled - contentBottomMargin;
            newTop = Math.max(verticalDistanceFromWindowBottomUnscrolled - addFooterCommentHeight - extraFooterCommentHeightToShow, 0);
        }
    }
    return newTop;
};
const $a78c261c3211f7d6$export$fc9b5eebad60b835 = ({ element: element, viewingRoomOffset: viewingRoomOffset = -150, useInstantScroll: useInstantScroll = false })=>{
    if (!element) return;
    const { scrollRootElement: scrollRootElement, scrollRootOffset: scrollRootOffset } = $a78c261c3211f7d6$var$getScrollRootContext();
    const elementRect = element.getBoundingClientRect();
    const elementTopViewport = elementRect.top;
    const scrollRootTopViewport = scrollRootElement instanceof Window ? 0 // Window doesn't have a bounding rect; its top is always 0
     : scrollRootElement.getBoundingClientRect().top;
    const elementTopFromScrollRoot = elementTopViewport - scrollRootTopViewport;
    const targetScrollPosition = elementTopFromScrollRoot + scrollRootOffset + viewingRoomOffset;
    scrollRootElement.scrollTo({
        top: targetScrollPosition,
        behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
    });
    // open expand if the element is inside an expand
    $a78c261c3211f7d6$export$876171b9c9b54aab(element, true);
};
const $a78c261c3211f7d6$export$b3ba907d5759e257 = (commentId, annotationId)=>{
    let isDisconnected = false;
    let commentFound = false;
    // Find the most specific container to observe
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const commentsPanelListContainer = document.querySelector('[data-testid="comments-panel-list-container"]');
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const targetContainer = commentsPanelListContainer || document.body;
    const observer = new MutationObserver(()=>{
        if (isDisconnected || commentFound) return;
        const commentElement = targetContainer.querySelector(`[data-comment-id="${commentId}"]`) || (annotationId ? targetContainer.querySelector(`[data-testid="comment-thread-${annotationId}-container"]`) : null);
        if (commentElement) {
            commentFound = true;
            commentElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center'
            });
            isDisconnected = true;
            observer.disconnect();
        }
    });
    // Start observing only the specific container
    observer.observe(targetContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: annotationId ? [
            'data-comment-id',
            'data-testid'
        ] : [
            'data-comment-id'
        ]
    });
    // Return cleanup function
    return ()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
        }
    };
};
const $a78c261c3211f7d6$export$b1b7c9bcc75c855d = ({ targetCommentId: targetCommentId, onScrollReady: onScrollReady, onFallback: onFallback, timeoutMs: timeoutMs = 10000, markElement: markElement, containerId: containerId })=>{
    if ((0, $6mKj3.expValEquals)('confluence_comments_use_new_observer', 'isEnabled', true)) return $a78c261c3211f7d6$export$4d09fb2a10e54800({
        targetCommentId: targetCommentId,
        onScrollReady: onScrollReady,
        onFallback: onFallback,
        timeoutMs: timeoutMs,
        markElement: markElement,
        containerId: containerId
    });
    let commentFound = false;
    let isDisconnected = false;
    const observer = new MutationObserver((mutations)=>{
        if (isDisconnected) return;
        // First, look for the comment element if we haven't found it yet
        if (!commentFound) {
            for (const mutation of mutations)if (mutation.type === 'childList') {
                for (const addedNode of Array.from(mutation.addedNodes))if (addedNode.nodeType === Node.ELEMENT_NODE) {
                    const element = addedNode;
                    // Check if this element or any of its descendants has the specific data-comment-id
                    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                    const containerElement = containerId ? document.getElementById(containerId) : null;
                    const commentElement = containerElement || element.querySelector?.(`[data-comment-id="${targetCommentId}"]`) || (element.matches?.(`[data-comment-id="${targetCommentId}"]`) ? element : null);
                    if (commentElement) {
                        commentFound = true;
                        // Early return if the comment is in the container element
                        if (containerElement) {
                            onScrollReady(containerElement);
                            isDisconnected = true;
                            observer.disconnect();
                            return;
                        }
                        markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                        // Check the initial state of the show more button
                        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                        const showMoreButton = document.querySelector('[data-testid="show-hidden-replies"]');
                        if (!showMoreButton) {
                            onScrollReady(commentElement);
                            isDisconnected = true;
                            observer.disconnect();
                            return;
                        } else // Trigger click on the show more button to expand all replies
                        showMoreButton.click();
                        break;
                    }
                }
            }
        }
        // If comment is found, watch for the show more button to disappear
        if (commentFound) {
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const commentElement = document.querySelector(`[data-comment-id="${targetCommentId}"]`);
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const showMoreButton = document.querySelector('[data-testid="show-hidden-replies"]');
            if (commentElement && !showMoreButton) {
                markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                onScrollReady(commentElement);
                isDisconnected = true;
                observer.disconnect();
                return;
            }
        }
    });
    // Start observing
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    // Clean up observer after specified timeout to prevent memory leaks
    const timeoutId = setTimeout(()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            // Fallback behavior if comment was found but button never disappeared
            if (commentFound) {
                // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                const commentElement = document.querySelector(`[data-comment-id="${targetCommentId}"]`);
                if (commentElement) {
                    // Check and open expand sections if needed before scrolling
                    markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                    onScrollReady(commentElement);
                }
            } else if (onFallback) onFallback();
        }
    }, timeoutMs);
    // Return cleanup function
    return ()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            clearTimeout(timeoutId);
        }
    };
};
/**
 * Find the comment element by ID or data-comment-id attribute
 */ const $a78c261c3211f7d6$var$findCommentElement = (targetCommentId, containerId, isFooterCommentInPanel)=>{
    // If isFooterCommentInPanel is true, use comment-thread-${targetCommentId}-container
    if (isFooterCommentInPanel) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const panelContainer = document.getElementById(`comment-thread-${targetCommentId}-container`);
        if (panelContainer) return panelContainer;
    }
    // Try container element first if containerId is provided
    if (containerId) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const container = document.getElementById(containerId);
        if (container) return container;
    }
    // Fall back to finding by data-comment-id
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    return document.querySelector(`[data-comment-id="${targetCommentId}"]`);
};
const $a78c261c3211f7d6$export$5eaef9e6a0975768 = (commentElement, targetCommentId)=>{
    if (!commentElement) return null;
    // 1. Check within commentElement (descendants)
    const buttonInComment = commentElement.querySelector('[data-testid="show-hidden-replies"]');
    if (buttonInComment) return buttonInComment;
    // 2. Check in parent element (siblings)
    const parentElement = commentElement.parentElement;
    const buttonInParent = parentElement?.querySelector('[data-testid="show-hidden-replies"]');
    if (buttonInParent) return buttonInParent;
    // 3. Check in replies container (specific to this comment thread)
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const repliesContainer = document.querySelector(`[data-testid="comment-thread-${targetCommentId}-replies"]`);
    const buttonInReplies = repliesContainer?.querySelector('[data-testid="show-hidden-replies"]');
    if (buttonInReplies) return buttonInReplies;
    return null;
};
/**
 * Handle the comment element being found
 * Checks for show more button and either scrolls immediately or clicks to expand
 */ const $a78c261c3211f7d6$var$handleCommentFound = (commentElement, targetCommentId, containerId, markElement, onScrollReady)=>{
    // If container element exists and we're using it, scroll immediately
    if (containerId && commentElement.id === containerId) {
        markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
        onScrollReady(commentElement);
        return true; // Indicates we should disconnect
    }
    // Expand mark element if needed
    markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
    // Check for show more button
    const showMoreButton = $a78c261c3211f7d6$export$5eaef9e6a0975768(commentElement, targetCommentId);
    if (!showMoreButton) {
        // No show more button, scroll immediately
        onScrollReady(commentElement);
        return true; // Indicates we should disconnect
    } else {
        // Show more button exists, click it to expand replies
        showMoreButton.click();
        return false; // Keep watching for button to disappear
    }
};
/**
 * Check if comment element exists in newly added nodes
 */ const $a78c261c3211f7d6$var$checkAddedNodes = (addedNodes, targetCommentId, containerId, isFooterCommentInPanel, onCommentFound)=>{
    for (const addedNode of Array.from(addedNodes)){
        if (addedNode.nodeType !== Node.ELEMENT_NODE) continue;
        const element = addedNode;
        // Check if this element or its descendants contains the comment
        let commentElement = null;
        // First check for container element
        if (containerId) {
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const container = document.getElementById(containerId);
            if (container) commentElement = container;
        }
        // If not found, check for comment by data-comment-id
        if (!commentElement) commentElement = element.querySelector?.(`[data-comment-id="${targetCommentId}"]`) || (element.matches?.(`[data-comment-id="${targetCommentId}"]`) ? element : null);
        // If isFooterCommentInPanel, also check for panel container
        if (!commentElement && isFooterCommentInPanel) {
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const panelContainer = document.getElementById(`comment-thread-${targetCommentId}-container`);
            if (panelContainer) commentElement = panelContainer;
        }
        if (commentElement) {
            const shouldDisconnect = onCommentFound(commentElement);
            if (shouldDisconnect) return true; // Indicates we should stop processing
        }
    }
    return false;
};
const $a78c261c3211f7d6$export$4d09fb2a10e54800 = ({ targetCommentId: targetCommentId, onScrollReady: onScrollReady, onFallback: onFallback, timeoutMs: timeoutMs = 10000, markElement: markElement, containerId: containerId, isFooterCommentInPanel: isFooterCommentInPanel = false })=>{
    let commentFound = false;
    let isDisconnected = false;
    const handleCommentFoundWrapper = (commentElement)=>{
        commentFound = true;
        return $a78c261c3211f7d6$var$handleCommentFound(commentElement, targetCommentId, containerId, markElement, onScrollReady);
    };
    const observer = new MutationObserver((mutations)=>{
        if (isDisconnected) return;
        // First, look for the comment element if we haven't found it yet
        if (!commentFound) {
            for (const mutation of mutations)if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                const shouldStop = $a78c261c3211f7d6$var$checkAddedNodes(mutation.addedNodes, targetCommentId, containerId, isFooterCommentInPanel, handleCommentFoundWrapper);
                if (shouldStop) {
                    isDisconnected = true;
                    observer.disconnect();
                    return;
                }
            }
        }
        // If comment is found, watch for the show more button to disappear
        if (commentFound) {
            const commentElement = $a78c261c3211f7d6$var$findCommentElement(targetCommentId, containerId, isFooterCommentInPanel);
            const showMoreButton = $a78c261c3211f7d6$export$5eaef9e6a0975768(commentElement, targetCommentId);
            // If comment exists and show more button is gone, we're ready to scroll
            if (commentElement && !showMoreButton) {
                markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                onScrollReady(commentElement);
                isDisconnected = true;
                observer.disconnect();
                return;
            }
        }
    });
    // Start observing
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    // Clean up observer after specified timeout to prevent memory leaks
    const timeoutId = setTimeout(()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            // Fallback behavior if comment was found but button never disappeared
            if (commentFound) {
                const commentElement = $a78c261c3211f7d6$var$findCommentElement(targetCommentId, containerId, isFooterCommentInPanel);
                if (commentElement) {
                    // Check and open expand sections if needed before scrolling
                    markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                    onScrollReady(commentElement);
                }
            } else if (onFallback) onFallback();
        }
    }, timeoutMs);
    // Return cleanup function
    return ()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            clearTimeout(timeoutId);
        }
    };
};
/**
 * Returns the HTMLElement or window that should be used as the scroll root. By default,
 *  this is the div with id=AkMainContent, if the id exists in the DOM
 */ function $a78c261c3211f7d6$var$getScrollRootContext() {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const nav4ScrollRootElement = document.getElementById('AkMainContent');
    const scrollRootElement = nav4ScrollRootElement || window;
    const scrollRootOffset = nav4ScrollRootElement ? nav4ScrollRootElement.scrollTop : window.scrollY;
    return {
        scrollRootElement: scrollRootElement,
        scrollRootOffset: scrollRootOffset,
        getDimensions: $a78c261c3211f7d6$var$getDimensions
    };
}
// Constants for comment thread visibility
const $a78c261c3211f7d6$var$SCROLLED_COMMENTS_HEADER_GAP_SIZE_IN_PIXELS = 8;
const $a78c261c3211f7d6$var$NUM_HIDDEN_PIXELS_TO_BE_CONSIDERED_OUT_OF_VIEW = 60;
const $a78c261c3211f7d6$var$getTotalOffsetAboveCommentsPanelThreads = (generalCommentsHeaderHeight)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    let objectSidebarPanelHeader = document.querySelector("[data-testid='object-sidebar-panel-header']");
    let additionalOffset = 0;
    if (!objectSidebarPanelHeader) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        objectSidebarPanelHeader = document.querySelector("[data-testid='scrolled-object-sidebar-panel-header']");
        additionalOffset = $a78c261c3211f7d6$var$SCROLLED_COMMENTS_HEADER_GAP_SIZE_IN_PIXELS;
    }
    const objectSidebarPanelHeaderHeight = objectSidebarPanelHeader?.getBoundingClientRect().height ?? 0;
    const objectHeaderHeight = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='object-header-container']")?.getBoundingClientRect().height ?? 0;
    const topNavContainerHeight = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='grid-topNav']")?.getBoundingClientRect().height ?? 0;
    const bannerContainerHeight = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='banner-container']")?.getBoundingClientRect().height ?? 0;
    const editorControlsOnboardingBannerHeight = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='editor-controls-onboarding-banner']")?.getBoundingClientRect().height ?? 0;
    const announcementBannerHeight = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[id='AkBanner']")?.getBoundingClientRect().height ?? 0;
    return objectSidebarPanelHeaderHeight + objectHeaderHeight + topNavContainerHeight + bannerContainerHeight + additionalOffset + generalCommentsHeaderHeight + editorControlsOnboardingBannerHeight + announcementBannerHeight;
};
const $a78c261c3211f7d6$export$4d211f4974dcf196 = (commentThreadElement, commentType)=>{
    const commentThreadRect = commentThreadElement.getBoundingClientRect();
    const generalCommentsHeaderHeight = commentType === 'general' ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='comment-section-separator']")?.getBoundingClientRect().height ?? 0 : 0;
    const totalPaddingAboveCommentThreadView = $a78c261c3211f7d6$var$getTotalOffsetAboveCommentsPanelThreads(generalCommentsHeaderHeight);
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const objectSidebarPanelFooter = document.querySelector("[data-testid='object-sidebar-panel-footer']");
    const objectSidebarPanelFooterHeight = objectSidebarPanelFooter?.getBoundingClientRect().height ?? 0;
    const viewportTop = totalPaddingAboveCommentThreadView;
    const viewportBottom = window.innerHeight - objectSidebarPanelFooterHeight;
    const commentTopInView = commentThreadRect.top >= viewportTop;
    const commentBottomInView = commentThreadRect.bottom <= viewportBottom;
    if (commentTopInView && commentBottomInView) // Comment is 100% in view
    return false;
    else if (!commentTopInView && commentBottomInView) // Comment is <100% in view and the hidden part is the top part of the comment
    return true;
    else if (commentTopInView && !commentBottomInView) {
        // Comment is <100% in view and the hidden part is the bottom of the comment
        const hiddenBottomHeight = commentThreadRect.bottom - viewportBottom;
        if (hiddenBottomHeight <= $a78c261c3211f7d6$var$NUM_HIDDEN_PIXELS_TO_BE_CONSIDERED_OUT_OF_VIEW) // The hidden part is <= 60 pixels
        return false;
        else // The hidden part is > 60 pixels
        return true;
    } else // Comment is <100% in view and the hidden part is the top part of the comment
    return true;
};
const $a78c261c3211f7d6$export$9c5b7a3c864ae31b = (commentThreadElement, commentType)=>{
    const commentThreadRect = commentThreadElement.getBoundingClientRect();
    const generalCommentsHeaderHeight = commentType === 'general' ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='comment-section-separator']")?.getBoundingClientRect().height ?? 0 : 0;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const objectSidebarPanelFooter = document.querySelector("[data-testid='object-sidebar-panel-footer']");
    const objectSidebarPanelFooterHeight = objectSidebarPanelFooter?.getBoundingClientRect().height ?? 0;
    return(// Element is partially out of view below the comments panel viewport
    commentThreadRect.bottom + generalCommentsHeaderHeight > window.innerHeight - objectSidebarPanelFooterHeight);
};
const $a78c261c3211f7d6$export$e3c287b6d80b16ce = ({ pageMode: pageMode, pageWidthType: pageWidthType, hasEndOfPageRecommendations: hasEndOfPageRecommendations })=>{
    const endOfPageRecommendationsMaxWidth = '1000px';
    if (pageMode === (0, $cD1qu.PageMode).VIEW && ((0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_width') || (0, $6mKj3.expValEquals)('confluence_unify_footer_comments_space_width', 'isEnabled', true))) {
        // pageWidthType is a string like '"default"' / '"full-width"' in renderer mode, and is undefined in live doc mode
        const isDefaultWidth = pageWidthType && JSON.parse(pageWidthType) === (0, $1d2ww.ContentAppearanceType).DEFAULT;
        if (hasEndOfPageRecommendations) // when end-of-page recommendations is present, always match its width (see EndOfPageRecContainer.tsx)
        return {
            width: isDefaultWidth ? '87.5%' : '100%',
            maxWidth: endOfPageRecommendationsMaxWidth
        };
        else return {
            width: '100%',
            maxWidth: isDefaultWidth ? '760px' : '1800px' // if not defaultWidth, use full page width
        };
    }
    if (pageMode !== (0, $cD1qu.PageMode).VIEW && ((0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_width_ld') || (0, $6mKj3.expValEquals)('confluence_unify_footer_comments_space_width', 'isEnabled', true))) return {
        width: '100%',
        maxWidth: hasEndOfPageRecommendations && (0, $6mKj3.expValEquals)('confluence_ai_related_content_for_live_pages', 'isEnabled', true) ? endOfPageRecommendationsMaxWidth : '100%'
    };
    // Base case: when the fg for the current pageMode isn't ON, i.e. either of:
    // - pageMode === PageMode.VIEW && !fg('confluence_frontend_unify_footer_comment_width') && !expValEquals('confluence_unify_footer_comments_space_width', 'isEnabled', true)
    // - pageMode !== PageMode.VIEW && !fg('confluence_frontend_unify_footer_comment_width_ld') && !expValEquals('confluence_unify_footer_comments_space_width', 'isEnabled', true)
    // This block can be removed entirely once both fgs are rolled out.
    let maxWidth = '100%';
    if (pageWidthType) maxWidth = JSON.parse(pageWidthType) === (0, $1d2ww.ContentAppearanceType).DEFAULT ? '1000px' : 'unset';
    return {
        width: '100%',
        maxWidth: maxWidth
    };
};
module.exports["CREATE_COMMENT_SELECTION_CLASS"] = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
module.exports["HIGHLIGHT_CLASS"] = $a78c261c3211f7d6$export$b803c692fbaaa5a4;
module.exports["ACTIVE_CLASS"] = $a78c261c3211f7d6$export$fb3d0eebfe85522a;
module.exports["getCommentIndexAndCount"] = $a78c261c3211f7d6$export$b899b07e3f725968;
module.exports["getInlineMarkSelector"] = $a78c261c3211f7d6$export$8c7b048437c01388;
module.exports["getMarkerRef"] = $a78c261c3211f7d6$export$8f4213b45c05ab5d;
module.exports["getSortedMarkerRefs"] = $a78c261c3211f7d6$export$9b48c18cc387f791;
module.exports["clearActiveHighlight"] = $a78c261c3211f7d6$export$f7ceeb7ba8156450;
module.exports["getNextTextNode"] = $a78c261c3211f7d6$export$3e98291f1f032a77;
module.exports["getHighlightOffset"] = $a78c261c3211f7d6$export$739c145b6a07c076;
module.exports["getHighlightFromMarkerRef"] = $a78c261c3211f7d6$export$21445ab787d3b446;
module.exports["calculateElementOffset"] = $a78c261c3211f7d6$export$331805bfbe18b1c0;
module.exports["resetTemporaryDOMHighlight"] = $a78c261c3211f7d6$export$743373b19993e2b0;
module.exports["convertDOMHighlightToMark"] = $a78c261c3211f7d6$export$a160a5110cbadcb8;
module.exports["setCommentAsActive"] = $a78c261c3211f7d6$export$fd55463aeed84830;
module.exports["removeMarkInDOM"] = $a78c261c3211f7d6$export$a26c4eafef12029f;
module.exports["isEmptyAdf"] = $a78c261c3211f7d6$export$915f03d46d87bfd4;
module.exports["getFocusableElementFromMarkerRef"] = $a78c261c3211f7d6$export$c36aa9f15eddb765;
module.exports["keyPropagationList"] = $a78c261c3211f7d6$export$6d23af9d8c2844b1;
module.exports["scrollToElementWithViewingRoom"] = $a78c261c3211f7d6$export$fc9b5eebad60b835;
module.exports["scrollCommentIntoView"] = $a78c261c3211f7d6$export$c7436bd0a15f3e7e;
module.exports["getNodeForTableORMacro"] = $a78c261c3211f7d6$export$ee0755cb593feed6;
module.exports["checkElementExpand"] = $a78c261c3211f7d6$export$876171b9c9b54aab;
module.exports["getSidebarId"] = $a78c261c3211f7d6$export$fb40c5e75b82df8;
module.exports["isFirstTabbableElement"] = $a78c261c3211f7d6$export$642e21ba866d02df;
module.exports["isLastTabbableElement"] = $a78c261c3211f7d6$export$876aeb5dffd449af;
module.exports["focusElementAndUpdateTabIndex"] = $a78c261c3211f7d6$export$cfa8eefe354167cd;
module.exports["scrollToComment"] = $a78c261c3211f7d6$export$db9eae89818590a4;
module.exports["checkElementExpandMultiLevelCommon"] = $a78c261c3211f7d6$export$1a2319f5c2109ee1;
module.exports["getNextMarkerRef"] = $a78c261c3211f7d6$export$187f977414e8342c;
module.exports["getNextUnreadThreadKey"] = $a78c261c3211f7d6$export$883ebc059dd86e88;
module.exports["copyToClipboard"] = $a78c261c3211f7d6$export$2cdf1b96a9f86d16;
module.exports["calculateEditorOffsetFromParent"] = $a78c261c3211f7d6$export$ab567600730c0b3b;
module.exports["calculateRendererOffsetFromParent"] = $a78c261c3211f7d6$export$3cdeee3ea1732782;
module.exports["getCommentPositionTopOfSectionEditor"] = $a78c261c3211f7d6$export$9f8164812b21bc7a;
module.exports["getCommentPositionTopOfSectionRenderer"] = $a78c261c3211f7d6$export$e3a17b46d43aa5f6;
module.exports["watchForCommentContainerAndScroll"] = $a78c261c3211f7d6$export$b3ba907d5759e257;
module.exports["watchForCommentRepliesAndScroll"] = $a78c261c3211f7d6$export$b1b7c9bcc75c855d;
module.exports["shouldScrollCommentThreadToTop"] = $a78c261c3211f7d6$export$4d211f4974dcf196;
module.exports["isCommentThreadReplyOutOfView"] = $a78c261c3211f7d6$export$9c5b7a3c864ae31b;
module.exports["getWidthAndMaxWidth"] = $a78c261c3211f7d6$export$e3c287b6d80b16ce;

});

parcelRegister("cD1qu", function(module, exports) {
var $7825447594ee3eb0$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}({});
var $7825447594ee3eb0$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "current";
    ContentStatus["DRAFT"] = "draft";
    ContentStatus["ARCHIVED"] = "archived";
    return ContentStatus;
}({});
const $7825447594ee3eb0$export$5d7c5e13dde1e9b8 = [
    "draft"
];
const $7825447594ee3eb0$export$c75005e52070dee = [
    "current"
];
module.exports["PageMode"] = $7825447594ee3eb0$export$6ea4b0c62affbe44;
module.exports["ContentStatus"] = $7825447594ee3eb0$export$b2be22e9d5dd3927;
module.exports["DRAFT_STATUS"] = $7825447594ee3eb0$export$5d7c5e13dde1e9b8;
module.exports["CURRENT_STATUS"] = $7825447594ee3eb0$export$c75005e52070dee;

});

parcelRegister("i49vP", function(module, exports) {

var $gfqXk = parcelRequire("gfqXk");


var $4EKKB = parcelRequire("4EKKB");


var $aHcFH = parcelRequire("aHcFH");

const $36cd0189b09a46b6$var$getElementOffsetFromTopOfPage = (element)=>{
    let elementOffsetTop = 0;
    let nodeToMeasure = element;
    while(nodeToMeasure && !nodeToMeasure.classList.contains('fabric-editor-popup-scroll-parent')){
        elementOffsetTop += nodeToMeasure.offsetTop;
        nodeToMeasure = nodeToMeasure.offsetParent;
    }
    return elementOffsetTop;
};
const $36cd0189b09a46b6$export$cc3d34287540b287 = (element)=>{
    const expandSelectors = [
        '.ak-editor-expand'
    ];
    const getExpandButton = (node)=>{
        if (node.classList.contains('ak-editor-expand')) {
            const button = node.querySelector('.ak-editor-expand__icon-container');
            return button;
        }
        return null;
    };
    const isExpanded = (button)=>{
        const expandContainer = button.closest('.ak-editor-expand');
        return expandContainer?.classList.contains('ak-editor-expand__expanded') || false;
    };
    const onExpand = ()=>{
        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
            isInExpand: true
        });
    };
    (0, $aHcFH.checkElementExpandMultiLevelCommon)(element, {
        isEditor: true,
        expandSelectors: expandSelectors,
        getExpandButton: getExpandButton,
        isExpanded: isExpanded,
        onExpand: onExpand
    });
};
const $36cd0189b09a46b6$export$a1bb3d68e0c3dbb8 = (element)=>{
    $36cd0189b09a46b6$export$cc3d34287540b287(element);
};
const $36cd0189b09a46b6$export$2163ce5a75e4a465 = ({ targetElement: targetElement, targetElementID: targetElementID, shouldScroll: shouldScroll = true })=>{
    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    $36cd0189b09a46b6$export$a1bb3d68e0c3dbb8(targetElement);
    emitter.emit('setselectedannotation', targetElementID);
    window.getSelection()?.setPosition(targetElement);
    shouldScroll && $36cd0189b09a46b6$export$4ee22c4fac4681d8({
        targetElement: targetElement,
        viewingRoomOffset: -100
    });
};
const $36cd0189b09a46b6$export$4ee22c4fac4681d8 = ({ targetElement: targetElement, viewingRoomOffset: viewingRoomOffset = 0 })=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const editorScrollableContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
    if (editorScrollableContainer) editorScrollableContainer.scrollTo(0, $36cd0189b09a46b6$var$getElementOffsetFromTopOfPage(targetElement) + viewingRoomOffset // add viewing room
    );
};
const $36cd0189b09a46b6$export$443ba0c8d1b21569 = ({ data: data, previousAnnotations: previousAnnotations })=>{
    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const topLevelCommentMarkerRefs = data?.comments?.nodes?.map((node)=>(node?.location).inlineMarkerRef);
    if (topLevelCommentMarkerRefs && topLevelCommentMarkerRefs.length > 0) {
        const newAnnotationsSet = new Set(topLevelCommentMarkerRefs);
        const removedMarkerRefs = [];
        previousAnnotations.forEach((item)=>{
            if (!newAnnotationsSet.has(item)) removedMarkerRefs.push(item);
        });
        let updatedAnnotations = [
            ...previousAnnotations
        ];
        const addedMarkerRefs = [];
        newAnnotationsSet.forEach((item)=>{
            if (!previousAnnotations.includes(item)) addedMarkerRefs.push(item);
        });
        for (const markerRef of addedMarkerRefs){
            emitter.emit('create', markerRef);
            updatedAnnotations.push(markerRef);
        }
        for (const markerRef of removedMarkerRefs){
            emitter.emit('resolve', markerRef);
            updatedAnnotations = updatedAnnotations.filter((annotation)=>annotation !== markerRef);
        }
        return updatedAnnotations;
    }
    return [];
};
module.exports["checkElementExpandInEditor"] = $36cd0189b09a46b6$export$a1bb3d68e0c3dbb8;
module.exports["openInlineCommentInEditor"] = $36cd0189b09a46b6$export$2163ce5a75e4a465;
module.exports["scrollToElementInEditor"] = $36cd0189b09a46b6$export$4ee22c4fac4681d8;

});

parcelRegister("gfqXk", function(module, exports) {

var $cz6eP = parcelRequire("cz6eP");

let $d97010bba34874b5$var$editorEmitter = undefined;
const $d97010bba34874b5$export$60921b94e11f8e19 = ()=>{
    if (!$d97010bba34874b5$var$editorEmitter) $d97010bba34874b5$var$editorEmitter = new (0, $cz6eP.AnnotationUpdateEmitter)();
    return $d97010bba34874b5$var$editorEmitter;
};
module.exports["getEditorAnnotationEventEmitter"] = $d97010bba34874b5$export$60921b94e11f8e19;

});

parcelRegister("cz6eP", function(module, exports) {

var $eSa5t = parcelRequire("eSa5t");


var $5uEm7 = parcelRequire("5uEm7");

class $91ffffc20e95f4c4$export$7cc60aa9ef845515 extends (0, $eSa5t.EventEmitter) {
    on(event, listener) {
        return super.on(event, listener);
    }
    off(event, listener) {
        return super.removeListener(event, listener);
    }
}
function $91ffffc20e95f4c4$export$3238f27f6e07aed2() {
    return new (0, $5uEm7.SharedAnnotationManager)();
}
module.exports["AnnotationUpdateEmitter"] = $91ffffc20e95f4c4$export$7cc60aa9ef845515;
module.exports["createAnnotationManager"] = $91ffffc20e95f4c4$export$3238f27f6e07aed2;

});

parcelRegister("5uEm7", function(module, exports) {

var $eSa5t = parcelRequire("eSa5t");

class $ca65321d79324be4$export$c7aecf09b7cf478f {
    setPreemptiveGate(handler) {
        this.preemptiveGate = handler;
        return this;
    }
    checkPreemptiveGate() {
        if (this.activePreemptiveGate) // If the preemptive gate check already in flight then just return the promise
        // and don't call the preemptive gate again.
        // This is to prevent multiple calls to the preemptive gate creating multiple
        // promises that will resolve at different times.
        return Promise.resolve(this.activePreemptiveGate);
        const gate = this.activePreemptiveGate = this.preemptiveGate().then((result)=>{
            this.activePreemptiveGate = undefined;
            return result;
        });
        return gate;
    }
    onDraftAnnotationStarted(handler) {
        this.emitter.on('draftAnnotationStarted', handler);
        return this;
    }
    offDraftAnnotationStarted(handler) {
        this.emitter.off('draftAnnotationStarted', handler);
        return this;
    }
    onAnnotationSelectionChange(handler) {
        this.emitter.on('annotationSelectionChanged', handler);
        return this;
    }
    offAnnotationSelectionChange(handler) {
        this.emitter.off('annotationSelectionChanged', handler);
        return this;
    }
    emit(event) {
        this.emitter.emit(event.name, 'data' in event ? event.data : undefined);
        return this;
    }
    hook(method, handler) {
        this.hooks.set(method, handler);
        return this;
    }
    unhook(method, handler) {
        if (!this.hooks.has(method) || this.hooks.get(method) !== handler) return this;
        this.hooks.delete(method);
        return this;
    }
    allowAnnotation() {
        const fn = this.hooks.get('allowAnnotation');
        if (!fn) return false;
        try {
            return fn();
        } catch  {
            return false;
        }
    }
    startDraft() {
        const fn = this.hooks.get('startDraft');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn();
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    clearDraft() {
        const fn = this.hooks.get('clearDraft');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn();
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    applyDraft(id) {
        const fn = this.hooks.get('applyDraft');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn(id);
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    getDraft() {
        const fn = this.hooks.get('getDraft');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn();
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    setIsAnnotationSelected(id, isSelected) {
        const fn = this.hooks.get('setIsAnnotationSelected');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            // NOTE: The hook needs to manage the firing the annotationSelectionChanged event when a change is made. This is
            // because the hook is responsible for the state of the selection. The manager is not responsible for the state of
            // the selection.
            return fn(id, isSelected);
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    setIsAnnotationHovered(id, isHovered) {
        const fn = this.hooks.get('setIsAnnotationHovered');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn(id, isHovered);
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    clearAnnotation(id) {
        const fn = this.hooks.get('clearAnnotation');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn(id);
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    constructor(){
        /**
     * This is the event emitter that is used to emit events from the manager. It is used to communicate with
     * other parts of the application.
     */ this.emitter = new (0, $eSa5t.EventEmitter)();
        /**
     * This is the map of hooks that can be added to the manager. Hooks are a 1:1 mapping of methods that can be
     * called on the manager. They are used to extend the functionality of the manager.
     */ this.hooks = new Map();
        this.preemptiveGate = ()=>Promise.resolve(true);
        this.activePreemptiveGate = undefined;
    }
}
module.exports["SharedAnnotationManager"] = $ca65321d79324be4$export$c7aecf09b7cf478f;

});

parcelRegister("4EKKB", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $gykrH = parcelRequire("gykrH");


var $irVI7 = parcelRequire("irVI7");


var $aJPUt = parcelRequire("aJPUt");


var $fGzMp = parcelRequire("fGzMp");


var $8Ss4E = parcelRequire("8Ss4E");

let $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
function $d671aa981fcb4da6$var$getSelectInlineCommentExperienceDebug(_experienceName, experienceStage) {
    function createInlineCommentExperienceDebug({ error: error, extraAttributes: extraAttributes }) {
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `Legacy select debug message: ${error.message || String(error)}`,
            attributes: {
                ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes,
                ...extraAttributes,
                experienceStage: experienceStage
            }
        });
    }
    return createInlineCommentExperienceDebug;
}
var $d671aa981fcb4da6$var$ExperienceType = /*#__PURE__*/ function(ExperienceType) {
    ExperienceType["DOCUMENT"] = "document";
    ExperienceType["DOCUMENT_WITH_PANEL"] = "documentWithPanel";
    ExperienceType["PANEL"] = "panel";
    return ExperienceType;
}($d671aa981fcb4da6$var$ExperienceType || {});
function $d671aa981fcb4da6$var$getExperienceType(entryPoint, sidebarOpenAtStart) {
    switch(entryPoint){
        case 'create-comment':
        case 'comment-navigation':
        case 'unknown:InlineComment':
            return "document";
        case 'annotation-change':
        case 'keyboard-navigation':
        case 'unknown:RendererFocus':
            return sidebarOpenAtStart ? "documentWithPanel" : "document";
        case 'sidebar':
        case 'unknown:CommentsPanelList':
            return "panel";
        default:
            return "document";
    }
}
const $d671aa981fcb4da6$export$e2b3aff7888f2745 = {
    _start: (startAttributes, _options)=>{
        if (startAttributes.pageClass === 'tinyMCE' || startAttributes.pageClass === 'database' || startAttributes.pageClass === 'whiteboard' || startAttributes.pageClass === 'slide') return;
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        const experienceState = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE));
        const runningExperienceAttributes = experienceState?.attributes;
        if (!experienceState?.hasStopped && runningExperienceAttributes?.annotationId !== undefined && runningExperienceAttributes?.annotationId === startAttributes.annotationId) {
            // If there is an existing (unstopped) experience
            // - and that experience has an annotationId
            //   - keyboard and comment navigation will start experiences without an annotationId -- and these should be restarted on an new start
            // - and that annotationId matches the one in the startAttributes
            // we assume the experience is still active, and don't start a new one.
            // the reason we can hit this is because the selectInlineCommentCompoundExperience._start is called when there is a "select inline comment"
            // signal, and individual signals fire in different orders (sometimes they are the first signal, sometimes they are later).
            // However -- if the second signal has a clearer entry point
            // we update the entry point attribute of the existing experience.
            if (runningExperienceAttributes?.entryPoint?.startsWith('unknown') && !startAttributes.entryPoint.startsWith('unknown')) {
                $d671aa981fcb4da6$export$e2b3aff7888f2745.addCommonAttributes({
                    entryPoint: startAttributes.entryPoint
                });
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    message: `After starting from ${runningExperienceAttributes.entryPoint}, received signal from ${startAttributes.entryPoint}`
                });
            }
            return;
        }
        if (// When the side bar is open, and the user selects a comment using the keyboard,
        // the keyboard navigation triggers a select annotation first (without an annotationId),
        // followed by the show comment start or select annotation complete (with an annotationId.
        startAttributes.entryPoint === 'unknown:CommentsPanelList' && runningExperienceAttributes?.entryPoint === 'keyboard-navigation' && runningExperienceAttributes?.annotationId === undefined) {
            $d671aa981fcb4da6$export$e2b3aff7888f2745.addCommonAttributes({
                annotationId: startAttributes.annotationId
            });
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: `After starting from ${runningExperienceAttributes.entryPoint}, received signal from ${startAttributes.entryPoint} with annotationId ${startAttributes.annotationId}`
            });
            return;
        }
        // First prepare the new attributes without modifying the global state
        // This ensures that any abort of current experiences will use their original attributes
        const newAttributes = {
            pageClass: startAttributes.pageClass,
            commentType: startAttributes.commentType,
            annotationId: 'annotationId' in startAttributes ? startAttributes.annotationId : undefined,
            entryPoint: startAttributes.entryPoint,
            version: 'single-experience'
        };
        // We check if there is a dom element with a testId of "object-sidebar-panel-body" and if so mark the
        // experience as being during a sidebar open experience.
        newAttributes.sidebarOpenAtStart = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.querySelector('[data-testid="object-sidebar-panel-body"]') !== null;
        newAttributes.experienceType = $d671aa981fcb4da6$var$getExperienceType(startAttributes.entryPoint, newAttributes.sidebarOpenAtStart);
        // If the create inline comment experience is running, we want to link the two experiences
        const createInlineCommentExperienceState = experienceTracker.getExperienceState((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE));
        if (createInlineCommentExperienceState && !createInlineCommentExperienceState.hasStopped) newAttributes.linkedCompoundTaskId = createInlineCommentExperienceState.attributes?.compoundTaskId;
        // Adds a debug point to the last running experience (debug points are only added if there is a running experience)
        // Note:
        // A new experience is followed after this is fired -- so this should always be the last debug point (as the new experience will trigger a fail or abort).
        // In the case there is no running experience, the experience tracker will discard the debugPoint.
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `Restarted from ${startAttributes.entryPoint} with annotationId: ${startAttributes.annotationId} (sidebarOpenAtStart: ${newAttributes.sidebarOpenAtStart})`
        });
        // Start press trace if no trace is currently active
        (0, $8Ss4E.startUFOPressTrace)((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE));
        // Then start a new compound experience with the new attributes
        // This will abort any running experiences with the same name, but they'll keep their original attributes
        experienceTracker.start({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                ...newAttributes
            },
            // If the annotation is not selected and comment shown to the user within 12 seconds -- we assume there has been a failure to select the inline comment
            timeout: (0, $aJPUt.ExperienceTimeout).SELECT_INLINE_COMMMENT,
            collect: (events)=>{
                const isThisCommentBeingResolved = (event)=>{
                    return event.name === (0, $irVI7.RESOLVE_INLINE_COMMENT_EXPERIENCE) && event.action === 'taskStart' && (0, $gykrH.hasAttribute)(event, 'annotationId', $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId);
                };
                events.forEach((event)=>{
                    if (isThisCommentBeingResolved(event)) $d671aa981fcb4da6$export$e2b3aff7888f2745.abort({
                        abortReason: 'Comment being resolved'
                    });
                });
            }
        });
        if (startAttributes.annotationId === undefined) experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `selectInlineCommentCompoundExperience._start started from ${startAttributes.entryPoint} with unknown annotationId`
        });
        else experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `selectInlineCommentCompoundExperience._start started from ${startAttributes.entryPoint} with annotationId ${startAttributes.annotationId}`
        });
        // Now it's safe to update the global state since any aborts have already happened
        // We reset experience state if we are starting a new experience
        $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {
            ...newAttributes
        };
        // By the time we get a task fail (particularly for timeout aborts) -- the contentId may have changed
        const originalContentId = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE))?.attributes?.contentId;
        $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.originalContentId = originalContentId;
        experienceTracker.updateAttributes({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                originalContentId: originalContentId
            }
        });
    },
    debugPoint: (message, attributes)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: message,
            attributes: attributes
        });
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            message: message,
            attributes: attributes
        });
    },
    addCommonAttributes: (additionalCommonAttributes)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {
            ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes,
            ...additionalCommonAttributes
        };
        experienceTracker.updateAttributes({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            attributes: additionalCommonAttributes
        });
    },
    abort: ({ abortReason: abortReason })=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.abort({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            reason: abortReason,
            checkForTimeout: true
        });
        $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
    },
    selectAnnotation: {
        debug: $d671aa981fcb4da6$var$getSelectInlineCommentExperienceDebug((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE), 'selectAnnotation'),
        /**
     * This is currently used to start from
     * - annotationId unknown
     *   - comment navigation
     *   - keyboard navigation
     * - annotationId known
     *   - create comment
     *   - comment sidebar comment selection
     *
     * These should be separate signals once the multi experience is deprecated.
     */ start: (startAttributes)=>{
            function isUnknownAnnotationId(startAttributes) {
                return startAttributes.entryPoint === 'keyboard-navigation' || startAttributes.entryPoint === 'comment-navigation';
            }
            if (isUnknownAnnotationId(startAttributes)) {
                $d671aa981fcb4da6$export$e2b3aff7888f2745._start(startAttributes, {
                    annotationUnknown: true
                });
                return;
            }
            $d671aa981fcb4da6$export$e2b3aff7888f2745._start(startAttributes);
        },
        abort: ({ abortReason: abortReason })=>{
            $d671aa981fcb4da6$export$e2b3aff7888f2745.abort({
                abortReason: // @ts-ignore the abort reasons have mismatch due to type from the old multi experience. and once that is removed we can remove this cast
                abortReason
            });
            $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
        },
        /**
     * Note -- the selectAnnotation does not trigger a completion of the selectInlineComment experience.
     * Instead -- the selectInlineComment experience is completed when the showComment experience completes
     * (which looks for the selected annotation as part of its completion logic).
     *
     * With the single experience -- this is less a complete and rather just an indirect signal that a selection has been made (in case it's not detected by the showComment experience).
     * When the multi selectInlineCommentCompoundExperience is deprecated, this can be renamed to indicate it's a "annotationSelection" signal rather than a "completed" signal.
     */ complete: (startAttributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            const experienceState = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE));
            // There can be cases where no start has been called for the select experience.
            // - When a product consumer of the editor setselectedannotation api calls the select experience
            //   and has not been instrumented.
            // - When the annotation selection is via editor logic (ie. editor selection being moved onto
            //   an annotation).
            if (experienceState === null) {
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    message: 'selectAnnotation completed from no experience - no explicit start point',
                    attributes: startAttributes
                });
                $d671aa981fcb4da6$export$e2b3aff7888f2745._start(startAttributes);
            }
        }
    },
    showComment: {
        debug: $d671aa981fcb4da6$var$getSelectInlineCommentExperienceDebug((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE), 'showComment'),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        },
        start: (startAttributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            $d671aa981fcb4da6$export$e2b3aff7888f2745._start(startAttributes);
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: 'showComment start triggered',
                attributes: startAttributes
            });
        },
        abort: ({ abortReason: abortReason })=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.abort({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                reason: abortReason
            });
            $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
        },
        fail: (error, extraAttributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                error: error,
                attributes: {
                    ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes,
                    ...extraAttributes
                }
            });
            $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
        },
        complete: (completedFrom)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.succeed({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                attributes: {
                    completedFrom: completedFrom,
                    ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                }
            });
            $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
        },
        standaloneSidebarComplete: (commentUIVerticalDistanceFromAnnotation)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: `standaloneSidebarComplete triggered`
            });
            if (commentUIVerticalDistanceFromAnnotation > 40) experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: `Comment UI is misaligned by >40px pixels`,
                attributes: {
                    misalignedBy: commentUIVerticalDistanceFromAnnotation
                }
            });
            if (typeof $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId !== 'string') {
                experienceTracker.fail({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    error: new Error('selectInlineCommentCompoundExperience.standaloneSidebarComplete called when no annotationId was known'),
                    attributes: $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                });
                return;
            }
            if (!$d671aa981fcb4da6$var$__checkAnnotationVisibleAndFocused($d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId)) experienceTracker.fail({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                error: new Error(`selectInlineCommentCompoundExperience.standaloneSidebarComplete ended without a focused and in viewport annotation.`),
                attributes: $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
            });
            experienceTracker.succeed({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                attributes: {
                    completedFrom: 'Standalone sidebar inline comment selection completed',
                    ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                }
            });
        },
        sidePanelComplete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: `sidePanelComplete triggered`
            });
            if (typeof $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId !== 'string') {
                experienceTracker.fail({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    error: new Error('selectInlineCommentCompoundExperience.sidePanelComplete called when no annotationId was known'),
                    attributes: $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                });
                return;
            }
            if (!$d671aa981fcb4da6$var$__checkAnnotationVisibleAndFocused($d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId)) experienceTracker.fail({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                error: new Error('selectInlineCommentCompoundExperience.sidePanelComplete did not result in a visible and focused annotation'),
                attributes: $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
            });
            experienceTracker.succeed({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                attributes: {
                    completedFrom: 'Side Panel inline comment selection completed',
                    ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                }
            });
        }
    }
};
/**
 *
 * Checks if there is an annotation currently visible in the document.
 *
 * The comment UI is currently opinionated about the comment UI being attached to the first instance of the focused annotation element.
 *
 * So we can safely skip checking if the initial focused annotation is not visible
 *
 * Note: this method causes reflow, and should not be used in performance sensitive code.
 *
 */ function $d671aa981fcb4da6$var$__checkAnnotationVisibleAndFocused(annotationId) {
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const possibleFocusedAnnotationElements = document.querySelectorAll(// This will match the annotation id in either the Editor or Renderer
    `[data-id="${annotationId}"][data-mark-annotation-type="inlineComment"][data-has-focus="true"],
		[data-id="${annotationId}"][data-mark-annotation-type="inlineComment"] .ak-editor-annotation-focus`);
    if (possibleFocusedAnnotationElements.length === 0) {
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `No annotation element found`
        });
        return false;
    }
    /**
   * Annotations can have multiple elements in the dom, with each of the elements having the focus state set to true.
   * Ie. Comments spanning multiple lines will have multiple elements with the focus state set to true.
   *
   * In addition to this -- sometimes there will be "hidden" focused annotation elements where the dom is duplicated
   * such as for annotations on table header cells in the renderer.
   *
   * If the first element is not visible due to being hidden, we continue checking until we reach a visible element, and then check whether it is in the viewport.
   *
   */ for(let i = 0; i < possibleFocusedAnnotationElements.length; i++){
        const element = possibleFocusedAnnotationElements[i];
        if (element instanceof HTMLElement) {
            if (!element.checkVisibility()) {
                // Skip to the next element if the current one is not visible
                // This can happen in scenarios where the dom is duplicated, such as for annotations on table header cells in the renderer.
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    message: `Annotation element had a hidden focused element, skipping to next element`
                });
                continue;
            }
            const rect = element.getBoundingClientRect();
            const isVisible = rect.top >= 0 && rect.left >= 0 && // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            rect.right <= (window.innerWidth || document.documentElement.clientWidth);
            // This is the first visible element -- which should be focused and
            // in the viewport
            if (isVisible) return true;
            else {
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    message: `Annotation element found - but not in viewport`
                });
                return false;
            }
        }
    }
    return false;
}
const $d671aa981fcb4da6$export$b65d55854b7eb069 = {
    debug: $d671aa981fcb4da6$export$e2b3aff7888f2745.debugPoint
};
module.exports["selectInlineCommentCompoundExperience"] = $d671aa981fcb4da6$export$e2b3aff7888f2745;
module.exports["selectInlineComment"] = $d671aa981fcb4da6$export$b65d55854b7eb069;

});

parcelRegister("9FoVw", function(module, exports) {
/**
 * @fileoverview Unified comment navigation utilities for scrolling to different comment types
 * and handling various navigation scenarios across editor and renderer contexts.
 */ 
var $fJCU9 = parcelRequire("fJCU9");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $6mKj3 = parcelRequire("6mKj3");


var $4L9ve = parcelRequire("4L9ve");


var $kgNLQ = parcelRequire("kgNLQ");


var $i49vP = parcelRequire("i49vP");


var $aHcFH = parcelRequire("aHcFH");

var $0343eaf78527fd4c$export$99058db374262376 = /*#__PURE__*/ function(ShortcutType) {
    ShortcutType["NEXT"] = "next";
    ShortcutType["PREVIOUS"] = "previous";
    ShortcutType["UNREAD"] = "unread";
    return ShortcutType;
}({});
var $0343eaf78527fd4c$export$ca559f4ef107f965 = /*#__PURE__*/ function(ViewValues) {
    ViewValues["OPEN"] = "OPEN";
    ViewValues["UNREAD"] = "UNREAD";
    ViewValues["DELETED_CONTENT"] = "DELETED_CONTENT";
    ViewValues["RESOLVED"] = "RESOLVED";
    ViewValues["MENTIONS_ME"] = "MENTIONS_ME";
    return ViewValues;
}({});
// Navigation types based on comment scrolling architecture
var $0343eaf78527fd4c$var$NavigationType = /*#__PURE__*/ function(NavigationType) {
    NavigationType["INLINE_ANNOTATION"] = "inline_annotation";
    NavigationType["COMMENTS_PANEL"] = "comments_panel";
    NavigationType["FOOTER_COMMENTS"] = "footer_comments";
    NavigationType["DEEP_LINK"] = "deep_link";
    NavigationType["KEYBOARD_SHORTCUT"] = "keyboard_shortcut";
    NavigationType["INLINE_HEADER_ARROWS"] = "inline_header_arrows";
    return NavigationType;
}($0343eaf78527fd4c$var$NavigationType || {});
var $0343eaf78527fd4c$export$e6e360ac7d345e5 = /*#__PURE__*/ function(ScrollBehavior) {
    ScrollBehavior["INSTANT"] = "instant";
    ScrollBehavior["SMOOTH"] = "smooth";
    return ScrollBehavior;
}({});
var $0343eaf78527fd4c$export$3044ab7fdabeaee6 = /*#__PURE__*/ function(NavigationContext) {
    NavigationContext["EDITOR"] = "editor";
    NavigationContext["RENDERER"] = "renderer";
    NavigationContext["PANEL"] = "panel";
    NavigationContext["REPLY"] = "reply";
    return NavigationContext;
}({});
var $0343eaf78527fd4c$export$368ed1d84e0ae668 = /*#__PURE__*/ function(CommentNavigationStatus) {
    CommentNavigationStatus["FOUND_IN_DOM"] = "FOUND_IN_DOM";
    CommentNavigationStatus["DELETED_CONTENT"] = "DELETED_CONTENT";
    CommentNavigationStatus["RESOLVED"] = "RESOLVED";
    CommentNavigationStatus["UNKNOWN"] = "UNKNOWN";
    CommentNavigationStatus["REMOVED_BY_ANOTHER_USER"] = "REMOVED_BY_ANOTHER_USER";
    return CommentNavigationStatus;
}({});
var $0343eaf78527fd4c$export$352adda3721e4ee = /*#__PURE__*/ function(CommentNavigationCategory) {
    CommentNavigationCategory["FOUND"] = "FOUND";
    CommentNavigationCategory["ANNOTATION_FOUND_COMMENT_MISSING"] = "ANNOTATION_FOUND_COMMENT_MISSING";
    CommentNavigationCategory["ANNOTATION_MISSING_COMMENT_FOUND"] = "ANNOTATION_MISSING_COMMENT_FOUND";
    CommentNavigationCategory["ANNOTATION_AND_COMMENT_MISSING"] = "ANNOTATION_AND_COMMENT_MISSING";
    CommentNavigationCategory["COMMENTS_DATA_NOT_LOADED"] = "COMMENTS_DATA_NOT_LOADED";
    CommentNavigationCategory["COMMENTS_DATA_ERROR"] = "COMMENTS_DATA_ERROR";
    CommentNavigationCategory["COMMENT_RESOLVED"] = "COMMENT_RESOLVED";
    CommentNavigationCategory["COMMENT_REMOVED_BY_ANOTHER_USER"] = "COMMENT_REMOVED_BY_ANOTHER_USER";
    return CommentNavigationCategory;
}({});
const $0343eaf78527fd4c$export$9f32f1ed184088e0 = (options)=>{
    const { scrollBehavior: scrollBehavior, context: context, block: block, inline: inline, markElement: markElement, annotationId: annotationId } = options;
    if (!markElement) return false;
    // Handle different contexts
    switch(context){
        case "editor":
            // Check if element needs to be expanded in editor
            (0, $i49vP.checkElementExpandInEditor)(markElement);
            // Emit the setselectedannotation event
            const editorEmitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
            editorEmitter.emit('setselectedannotation', markElement.id);
            // Scroll to the element in editor
            (0, $i49vP.scrollToElementInEditor)({
                targetElement: markElement,
                viewingRoomOffset: -100
            });
            return true;
        case "renderer":
            // Renderer-specific logic with improved focus management
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const focusedMarkerRef = document.querySelector("[data-has-focus='true']");
            if (focusedMarkerRef?.id !== markElement.id) {
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                emitter.emit((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                    annotationId: markElement.id
                });
                // Check if element needs to be expanded
                (0, $aHcFH.checkElementExpand)(markElement, true);
            }
            // Scroll to the annotation mark
            markElement.scrollIntoView({
                behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
                block: block,
                inline: inline
            });
            return true;
        case "panel":
            // For panel context, ensure annotation is visible and highlighted
            if (annotationId) {
                // Emit events to ensure the annotation is properly focused
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                emitter.emit((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                    annotationId: annotationId
                });
            }
            // Scroll the annotation into view
            markElement.scrollIntoView({
                behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
                block: block,
                inline: inline
            });
            return true;
        default:
            return false;
    }
};
/**
 * Wait for the comments panel to be rendered in the DOM
 * Returns a Promise that resolves when the panel is available or times out after 5 seconds
 */ const $0343eaf78527fd4c$var$waitForCommentsPanel = ()=>{
    const commentsPanelListContainerId = 'comments-panel-list-container';
    return new Promise((resolve)=>{
        const observer = new MutationObserver(()=>{
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const panel = document.querySelector(`[data-testid='${commentsPanelListContainerId}']`);
            if (panel) {
                observer.disconnect();
                resolve(true);
            }
        });
        // Start observing the document body for changes
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        // Set a timeout to avoid infinite waiting
        setTimeout(()=>{
            observer.disconnect();
            resolve(false);
        }, 5000); // 5 second timeout
    });
};
/**
 * Wait for the comments panel view/filter to change to the specified view
 * Returns a Promise that resolves when the view change is complete or times out after 3 seconds
 */ const $0343eaf78527fd4c$var$waitForViewChange = (expectedView)=>{
    return new Promise((resolve)=>{
        // Check if the view has already changed by checking the data-current-view attribute on the container
        const checkView = ()=>{
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const container = document.querySelector('[data-testid="comments-panel-list-container"]');
            if (container && container.getAttribute('data-current-view') === expectedView) return true;
        };
        if (checkView()) {
            resolve(true);
            return;
        }
        // Observe document body for both container creation and attribute changes
        // This handles cases where the container gets unmounted/remounted
        const observer = new MutationObserver(()=>{
            if (checkView()) {
                observer.disconnect();
                resolve(true);
            }
        });
        // Observe the entire document body to catch:
        // 1. Container being created/removed
        // 2. Attribute changes on the container when it exists
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: [
                'data-current-view'
            ]
        });
        // Set a timeout to avoid infinite waiting
        setTimeout(()=>{
            observer.disconnect();
            resolve(false);
        }, 3000); // 3 second timeout
    });
};
/**
 * Check if the top edge of an element is visible in the viewport
 * Used to determine if scrolling is needed based on element visibility
 */ const $0343eaf78527fd4c$var$isElementTopVisible = (element)=>{
    const rect = element.getBoundingClientRect();
    return rect.top >= 0;
};
/**
 * Wait for an element to finish scrolling into view
 * Returns a Promise that resolves when the element is reasonably visible or times out
 */ const $0343eaf78527fd4c$var$waitForScrollCompletion = (element, timeout = 3000)=>{
    return new Promise((resolve)=>{
        const startTime = Date.now();
        const check = ()=>{
            if ($0343eaf78527fd4c$var$isElementTopVisible(element)) // Add a small delay after element becomes visible to let scrolling settle
            setTimeout(()=>resolve(true), 150);
            else if (Date.now() - startTime > timeout) resolve(false);
            else requestAnimationFrame(check);
        };
        // Small delay to let scroll animation start
        setTimeout(check, 16);
    });
};
/**
 * Helper function for viewport checking - returns true if should skip scrolling due to viewport visibility
 */ const $0343eaf78527fd4c$var$checkAndHandleViewportVisibility = (element, shouldScrollIfCommentIsInViewport)=>{
    if (!shouldScrollIfCommentIsInViewport) {
        const commentIsInViewport = $0343eaf78527fd4c$var$isElementTopVisible(element);
        if (commentIsInViewport) return true;
    }
    return false;
};
/**
 * Handle scroll completion based on awaitScrollCompletion flag and scroll behavior
 */ const $0343eaf78527fd4c$var$handleScrollCompletion = (awaitScrollCompletion, scrollBehavior, element)=>{
    if (awaitScrollCompletion) return scrollBehavior === "smooth" ? $0343eaf78527fd4c$var$waitForScrollCompletion(element) : Promise.resolve(true);
    return true;
};
/**
 * Check if an element is already fully visible within the panel
 * Avoids unnecessary scrolling if the element is already in view
 */ const $0343eaf78527fd4c$var$isElementFullyVisible = (element)=>{
    const elementRect = element.getBoundingClientRect();
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const panelContainer = document.querySelector('[data-testid="comments-panel-list-container"]');
    const panelRect = panelContainer?.getBoundingClientRect();
    if (!panelRect) return false;
    return elementRect.top >= panelRect.top && elementRect.bottom <= panelRect.bottom;
};
/**
 * Determine the optimal scroll position based on context and comment type
 * Considers whether to scroll to start, center, or end based on various factors
 */ const $0343eaf78527fd4c$var$determineScrollPosition = (element, block, scrollToEnd, commentType)=>{
    let scrollBlock = block;
    if (scrollToEnd) {
        // Check if the comment thread reply is out of view
        // Map CommentsType to CommentType enum for domUtils functions
        const commentTypeEnum = commentType === 'INLINE' ? (0, $kgNLQ.CommentType).INLINE : (0, $kgNLQ.CommentType).GENERAL;
        const isOutOfView = (0, $aHcFH.isCommentThreadReplyOutOfView)(element, commentTypeEnum);
        if (isOutOfView) scrollBlock = 'end';
    } else {
        // Check if we should scroll to top
        // Map CommentsType to CommentType enum for domUtils functions
        const commentTypeEnum = commentType === 'INLINE' ? (0, $kgNLQ.CommentType).INLINE : (0, $kgNLQ.CommentType).GENERAL;
        const shouldScrollToTop = (0, $aHcFH.shouldScrollCommentThreadToTop)(element, commentTypeEnum);
        if (shouldScrollToTop) scrollBlock = 'start';
    }
    return scrollBlock;
};
/**
 * Perform the actual scrolling operation with optimized behavior
 * Handles different scroll scenarios based on user interaction context
 */ const $0343eaf78527fd4c$var$performScrollToElement = (element, scrollBehavior, block, scrollToEnd, hasKeyPressed, annotationClicked, scrollOnLoad, commentType)=>{
    // Skip scrolling if element is already fully visible
    if ($0343eaf78527fd4c$var$isElementFullyVisible(element)) return;
    // Determine scroll behavior based on trigger type
    if (hasKeyPressed || annotationClicked || scrollOnLoad) {
        const scrollBlock = $0343eaf78527fd4c$var$determineScrollPosition(element, block, scrollToEnd, commentType);
        element.scrollIntoView({
            behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
            block: scrollBlock
        });
    } else // Default scroll behavior
    element.scrollIntoView({
        behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
        block: block
    });
};
const $0343eaf78527fd4c$export$390f6df30bfcd812 = (options)=>{
    const { scrollBehavior: scrollBehavior, context: context, block: block, commentId: commentId, annotationId: annotationId, commentType: commentType, scrollToEnd: scrollToEnd = false, hasKeyPressed: hasKeyPressed = false, annotationClicked: annotationClicked = false, scrollOnLoad: scrollOnLoad = false, shouldScrollIfCommentIsInViewport: shouldScrollIfCommentIsInViewport = true, awaitScrollCompletion: awaitScrollCompletion = false } = options;
    // Only handle panel context navigation
    if (context !== "panel") return false;
    // Define panel container and thread selectors
    const commentsPanelListContainerId = 'comments-panel-list-container';
    // annotationId is used for DOM selectors, commentId is the actual comment identifier
    const commentThreadContainerId = `comment-thread-${annotationId}-container`;
    // Check if panel is available, wait if not
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const panelContainer = document.querySelector(`[data-testid='${commentsPanelListContainerId}']`);
    if (!panelContainer) // Panel is not rendered yet, wait for it to appear
    return $0343eaf78527fd4c$var$waitForCommentsPanel().then((panelAvailable)=>{
        if (panelAvailable) // Recursively call the function now that panel is available
        return $0343eaf78527fd4c$export$390f6df30bfcd812(options);
        return false;
    });
    // Look for the specific comment thread container
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const commentThreadElement = document.querySelector(`[data-testid='${commentThreadContainerId}']`);
    // If comment thread exists, scroll immediately
    if (commentThreadElement) {
        const skipScrollDueToViewport = $0343eaf78527fd4c$var$checkAndHandleViewportVisibility(commentThreadElement, shouldScrollIfCommentIsInViewport);
        if (skipScrollDueToViewport) return true;
        $0343eaf78527fd4c$var$performScrollToElement(commentThreadElement, scrollBehavior, block, scrollToEnd, hasKeyPressed, annotationClicked, scrollOnLoad, commentType);
        // For panel navigation, always return Promise when awaitScrollCompletion is true
        return $0343eaf78527fd4c$var$handleScrollCompletion(awaitScrollCompletion, scrollBehavior, commentThreadElement);
    }
    // Use optimized observer to watch for comment thread container creation
    if (commentId) (0, $aHcFH.watchForCommentContainerAndScroll)(commentId);
    else if (annotationId) (0, $aHcFH.watchForCommentContainerAndScroll)('', annotationId);
    return true;
};
const $0343eaf78527fd4c$export$dcd3c0d6a66d0412 = async (options)=>{
    const { expectedView: expectedView, commentId: commentId, annotationId: annotationId, ...navigationOptions } = options;
    // Only wait for view change for panel context
    if (navigationOptions.context === "panel" && expectedView) await $0343eaf78527fd4c$var$waitForViewChange(expectedView);
    // Then perform the navigation - pass both commentId and annotationId
    return $0343eaf78527fd4c$export$390f6df30bfcd812({
        ...navigationOptions,
        commentId: commentId,
        annotationId: annotationId
    });
};
const $0343eaf78527fd4c$export$34fd7e98d0739b5c = (options)=>{
    const { block: block, inline: inline, commentId: commentId, scrollBehavior: scrollBehavior, navigationContext: navigationContext, shouldScrollIfCommentIsInViewport: shouldScrollIfCommentIsInViewport = true, awaitScrollCompletion: awaitScrollCompletion = false } = options;
    let containerId;
    if (!commentId) return false;
    // Check if comment already exists in DOM
    // Determine container ID based on navigation context:
    // - PANEL: uses comment-thread container
    // - REPLY: uses data-comment-id attribute selector
    // - Default (footer): uses footer-comment-thread container
    if (navigationContext === "panel") containerId = `comment-thread-${commentId}-container`;
    else if (navigationContext === "reply") containerId = `[data-comment-id="${commentId}"]`;
    else containerId = `footer-comment-thread-${commentId}-container`;
    // Use querySelector for REPLY context (attribute selector), getElementById for others (ID)
    const existingComment = navigationContext === "reply" ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector(containerId) : // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.getElementById(containerId);
    if (existingComment) {
        const skipScrollDueToViewport = $0343eaf78527fd4c$var$checkAndHandleViewportVisibility(existingComment, shouldScrollIfCommentIsInViewport);
        if (skipScrollDueToViewport) return true;
        // Comment is already rendered, scroll to it immediately
        existingComment.scrollIntoView({
            behavior: scrollBehavior,
            block: block,
            inline: inline
        });
        // Wait for scroll completion when awaitScrollCompletion is true, otherwise return true
        return $0343eaf78527fd4c$var$handleScrollCompletion(awaitScrollCompletion, scrollBehavior, existingComment);
    } else {
        // Comment not yet rendered, use DOM resolver to watch for it
        (0, $aHcFH.watchForCommentRepliesAndScroll)({
            targetCommentId: commentId,
            onScrollReady: (commentElement)=>{
                // Find the container element by ID or selector based on navigation context
                const containerElement = navigationContext === "reply" ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.querySelector(containerId) : // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.getElementById(containerId);
                const elementToScroll = containerElement || commentElement;
                elementToScroll.scrollIntoView({
                    behavior: scrollBehavior,
                    block: block,
                    inline: inline
                });
            },
            containerId: containerId
        });
        return true;
    }
};
const $0343eaf78527fd4c$export$ea1c337d9000e2 = (options)=>{
    const { scrollBehavior: scrollBehavior, block: block, inline: inline, commentId: commentId, markElement: markElement, context: context } = options;
    if (!commentId || !markElement) return false;
    // Check if comment already exists in DOM
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const existingComment = document.querySelector(`[data-comment-id="${commentId}"]`);
    if (existingComment) {
        // Comment is already rendered, scroll to it immediately
        existingComment.scrollIntoView({
            behavior: scrollBehavior,
            block: block,
            inline: inline
        });
        return true;
    }
    // we need to click on the annotation in the editor if the comment is not yet rendered
    if (context === "editor" && markElement) (0, $i49vP.openInlineCommentInEditor)({
        targetElement: markElement,
        targetElementID: markElement.id,
        shouldScroll: false
    });
    // Comment not yet rendered, use DOM resolver to watch for it
    (0, $aHcFH.watchForCommentRepliesAndScroll)({
        targetCommentId: commentId,
        onScrollReady: (commentElement)=>{
            commentElement.scrollIntoView({
                behavior: scrollBehavior,
                block: block,
                inline: inline
            });
        },
        markElement: markElement
    });
    return true;
};
const $0343eaf78527fd4c$export$807107038899c351 = (options)=>{
    const { scrollBehavior: scrollBehavior, block: block, inline: inline, annotationId: annotationId, commentId: commentId, commentType: commentType, isCommentsPanelOpen: isCommentsPanelOpen, hasKeyPressed: hasKeyPressed = true, scrollToEnd: scrollToEnd = false, context: context, shortcutType: shortcutType, isResolved: isResolved, previousAnnotationId: previousAnnotationId } = options;
    // Get the mark element for both inline navigation and annotation events
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    let markElement = document.getElementById(annotationId);
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const commentElement = document.querySelector(`[data-comment-id="${commentId}"]`);
    // Get the previous comment element for difference-based scrolling
    const previousCommentElement = previousAnnotationId ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.getElementById(previousAnnotationId) : null;
    // Check if the mark element is in a sticky table header and adjust if needed
    const isInStickyTableHeader = markElement?.closest && markElement.closest('.pm-table-sticky-wrapper');
    if (isInStickyTableHeader && markElement && (0, $6mKj3.expValEquals)('confluence_comment_enable_table_header_navigation', 'isEnabled', true)) // Get the real element from the non-sticky table using getNodeForTableORMacro
    markElement = (0, $aHcFH.getNodeForTableORMacro)(markElement) || markElement;
    if (commentType === 'FOOTER') $0343eaf78527fd4c$export$34fd7e98d0739b5c({
        scrollBehavior: scrollBehavior,
        block: block,
        inline: inline || 'center',
        commentId: annotationId
    });
    // If comments panel is open, use panel navigation
    if (isCommentsPanelOpen) {
        // For inline comments, also call handleInlineAnnotationNavigation to ensure proper inline comment behavior
        if (commentType === 'INLINE' && !isResolved) $0343eaf78527fd4c$export$9f32f1ed184088e0({
            scrollBehavior: scrollBehavior,
            context: context || "panel",
            block: block,
            inline: inline || 'center',
            markElement: markElement,
            annotationId: annotationId
        });
        // This ensure the ViewComponent useEffect is not triggered
        if (markElement && !isResolved) {
            // Emit annotation events for panel navigation
            if (context === "editor") {
                const editorEmitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
                editorEmitter.emit('setselectedannotation', annotationId);
            } else if (context === "renderer") {
                const rendererEmitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                rendererEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                    annotationIds: [
                        annotationId
                    ],
                    eventTarget: null
                });
            }
        }
        // Use the existing panel navigation logic
        const result = $0343eaf78527fd4c$export$390f6df30bfcd812({
            scrollBehavior: scrollBehavior,
            context: "panel",
            block: block,
            inline: inline,
            annotationId: annotationId,
            commentType: commentType,
            hasKeyPressed: hasKeyPressed,
            scrollToEnd: scrollToEnd
        });
        if (result instanceof Promise) // For async panel navigation, return true immediately
        // The actual navigation will happen asynchronously
        return true;
        return result;
    }
    if (!markElement) return false;
    // For standalone navigation (comments panel closed), expand the element if needed
    if (commentType === 'INLINE' && context === "renderer") (0, $aHcFH.checkElementExpand)(markElement, true);
    // Use difference-based scrolling if we have both previous and next elements
    if (previousCommentElement && markElement && previousCommentElement !== markElement && (0, $6mKj3.expValEquals)('confluence_comment_use_kbs_exp', 'isEnabled', true)) {
        if (context === "editor") {
            // For editor: use scrollableContainer.scrollBy with difference offset
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const scrollableContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            if (scrollableContainer) {
                // Calculate difference between next and previous comment positions
                const nextRect = markElement.getBoundingClientRect();
                const previousRect = previousCommentElement.getBoundingClientRect();
                const differenceOffset = nextRect.top - previousRect.top;
                scrollableContainer.scrollBy(0, differenceOffset);
            }
        } else // For renderer: use scrollToComment with difference-based scrolling
        (0, $aHcFH.scrollToComment)(markElement, previousCommentElement, true, false);
        return true;
    }
    // For unread navigation, scroll to the comment element with data-comment-id instead of markElement
    if (shortcutType === "unread" && commentElement) commentElement.scrollIntoView({
        behavior: scrollBehavior,
        block: block,
        inline: inline || 'nearest'
    });
    else // For standalone navigation, we don't emit events - just scroll to the element
    markElement.scrollIntoView({
        behavior: scrollBehavior,
        block: block,
        inline: inline || 'nearest'
    });
    return true;
};
/**
 * Calculate the height of media comment placeholder to adjust scroll offset.
 * When the media comment placeholder is visible, it pushes the contents of the page down,
 * so we need to scroll a bit less to keep the cursor over the navigation arrow icon.
 */ const $0343eaf78527fd4c$var$getMediaCommentPlaceholderHeight = (options)=>{
    const { previousCommentElement: previousCommentElement, action: action, nextCommentIndex: nextCommentIndex, totalComments: totalComments } = options;
    const isCurrentCommentContentMediaComment = previousCommentElement?.closest('.media-single-node');
    const isNavigatingToLastCommentFromPreviousAction = action === 'previous' && nextCommentIndex === totalComments - 1;
    const isNavigatingToFirstCommentFromNextAction = action === 'next' && nextCommentIndex === 0;
    if (isCurrentCommentContentMediaComment && (action === 'next' || isNavigatingToLastCommentFromPreviousAction || isNavigatingToFirstCommentFromNextAction)) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const mediaCommentSelectedPlaceholder = document.querySelector('[data-id="caption-placeholder"]');
        return mediaCommentSelectedPlaceholder ? mediaCommentSelectedPlaceholder.offsetHeight : 0;
    }
    return 0;
};
const $0343eaf78527fd4c$export$36dad1a923539611 = (options)=>{
    const { previousMarkerRef: previousMarkerRef, nextMarkerRef: nextMarkerRef, context: context, action: action, nextCommentIndex: nextCommentIndex, totalComments: totalComments } = options;
    // Get the next comment element
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const nextMarkElement = document.getElementById(nextMarkerRef);
    if (!nextMarkElement) return false;
    // Get the previous and next comment elements
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const previousCommentElement = document.getElementById(previousMarkerRef);
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const nextCommentElement = document.getElementById(nextMarkerRef);
    if (previousCommentElement && nextCommentElement) {
        const heightOfMediaCommentSelectedPlaceholder = $0343eaf78527fd4c$var$getMediaCommentPlaceholderHeight({
            previousCommentElement: previousCommentElement,
            action: action,
            nextCommentIndex: nextCommentIndex,
            totalComments: totalComments
        });
        if (context === "editor") {
            // For editor: use scrollableContainer.scrollBy with difference offset
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const scrollableContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            if (scrollableContainer) {
                // Calculate difference between current and previous comment positions using calculateElementOffset
                // This handles special cases like sticky table headers
                const previousOffset = (0, $aHcFH.calculateElementOffset)(previousCommentElement);
                const nextOffset = (0, $aHcFH.calculateElementOffset)(nextCommentElement);
                const differenceOffset = nextOffset - previousOffset - heightOfMediaCommentSelectedPlaceholder;
                scrollableContainer.scrollBy(0, differenceOffset);
            }
        } else // For renderer: use scrollToComment
        (0, $aHcFH.scrollToComment)(nextCommentElement, previousCommentElement, true, false);
    }
    return true;
};
/**
 * Wait for a comment marker element to appear in the DOM.
 * Resolves immediately if the element already exists, otherwise waits via MutationObserver until timeout.
 */ const $0343eaf78527fd4c$var$waitForCommentElement = ({ markerRef: markerRef, timeoutMs: timeoutMs })=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const existingElement = document.getElementById(markerRef);
    if (existingElement) return Promise.resolve(existingElement);
    return new Promise((resolve)=>{
        const observer = new MutationObserver(()=>{
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const element = document.getElementById(markerRef);
            if (!element) return;
            observer.disconnect();
            resolve(element);
        });
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        setTimeout(()=>{
            observer.disconnect();
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const fallbackElement = document.getElementById(markerRef);
            resolve(fallbackElement);
        }, timeoutMs);
    });
};
const $0343eaf78527fd4c$export$6591627df1eb1f44 = async ({ markerRef: markerRef, commentId: commentId, timeoutMs: timeoutMs = 3000, getCommentThreadsRemovedByOtherUsers: getCommentThreadsRemovedByOtherUsers })=>{
    let element = null;
    const waitStartedAt = Date.now();
    if (markerRef) element = await $0343eaf78527fd4c$var$waitForCommentElement({
        markerRef: markerRef,
        timeoutMs: timeoutMs
    });
    const annotationWaitMs = Date.now() - waitStartedAt;
    // Read processed state after DOM wait to avoid stale classification.
    const state = (0, $4L9ve.getProcessedCommentsDataState)();
    const rootComment = state.isDataProcessed && markerRef ? state.flatMarkerRefMap[markerRef] : undefined;
    const commentFoundInData = Boolean(rootComment || commentId && state.flatCommentsMap[commentId]);
    const diagnosticsFor = (navigationCategory)=>({
            navigationCategory: navigationCategory,
            annotationFoundInDom: Boolean(element),
            commentFoundInData: commentFoundInData,
            commentsDataLoaded: state.isDataProcessed,
            commentsDataFailed: Boolean(state.error),
            commentsDataCount: state.commentCount,
            annotationWaitMs: annotationWaitMs
        });
    // NOTE - we can't import the official type here due to circular dep concerns
    if (commentId) {
        const commentThreadsRemovedByOtherUsers = getCommentThreadsRemovedByOtherUsers?.();
        if (commentThreadsRemovedByOtherUsers?.[commentId] === 'deleted') return {
            status: "REMOVED_BY_ANOTHER_USER",
            element: undefined,
            diagnostics: diagnosticsFor("COMMENT_REMOVED_BY_ANOTHER_USER")
        };
    }
    if (element) {
        if (rootComment && (0, $kgNLQ.isCommentResolved)(rootComment)) return {
            status: "RESOLVED",
            element: undefined,
            diagnostics: diagnosticsFor("COMMENT_RESOLVED")
        };
        return {
            status: "FOUND_IN_DOM",
            element: element,
            diagnostics: diagnosticsFor(commentFoundInData ? "FOUND" : "ANNOTATION_FOUND_COMMENT_MISSING")
        };
    }
    if (!state.isDataProcessed) return {
        status: "UNKNOWN",
        element: undefined,
        diagnostics: diagnosticsFor(state.error ? "COMMENTS_DATA_ERROR" : "COMMENTS_DATA_NOT_LOADED")
    };
    if (commentFoundInData) return {
        status: "DELETED_CONTENT",
        element: undefined,
        diagnostics: diagnosticsFor("ANNOTATION_MISSING_COMMENT_FOUND")
    };
    return {
        status: "UNKNOWN",
        element: undefined,
        diagnostics: diagnosticsFor(state.error ? "COMMENTS_DATA_ERROR" : "ANNOTATION_AND_COMMENT_MISSING")
    };
};
module.exports["ShortcutType"] = $0343eaf78527fd4c$export$99058db374262376;
module.exports["ScrollBehavior"] = $0343eaf78527fd4c$export$e6e360ac7d345e5;
module.exports["NavigationContext"] = $0343eaf78527fd4c$export$3044ab7fdabeaee6;
module.exports["CommentNavigationStatus"] = $0343eaf78527fd4c$export$368ed1d84e0ae668;
module.exports["handleInlineAnnotationNavigation"] = $0343eaf78527fd4c$export$9f32f1ed184088e0;
module.exports["handleCommentsPanelNavigation"] = $0343eaf78527fd4c$export$390f6df30bfcd812;
module.exports["handleCommentsPanelNavigationWithViewChange"] = $0343eaf78527fd4c$export$dcd3c0d6a66d0412;
module.exports["handleFooterCommentsNavigation"] = $0343eaf78527fd4c$export$34fd7e98d0739b5c;
module.exports["handleDeepLinkNavigation"] = $0343eaf78527fd4c$export$ea1c337d9000e2;
module.exports["handleKeyboardShortcutNavigation"] = $0343eaf78527fd4c$export$807107038899c351;
module.exports["handleInlineHeaderArrowsNavigation"] = $0343eaf78527fd4c$export$36dad1a923539611;
module.exports["waitForCommentStatus"] = $0343eaf78527fd4c$export$6591627df1eb1f44;

});

parcelRegister("gczDe", function(module, exports) {

var $cz6eP = parcelRequire("cz6eP");

let $d31fe98ca852fa54$var$rendererEmitter = undefined;
const $d31fe98ca852fa54$export$894d051c63add88c = ()=>{
    if (!$d31fe98ca852fa54$var$rendererEmitter) $d31fe98ca852fa54$var$rendererEmitter = new (0, $cz6eP.AnnotationUpdateEmitter)();
    return $d31fe98ca852fa54$var$rendererEmitter;
};
module.exports["getRendererAnnotationEventEmitter"] = $d31fe98ca852fa54$export$894d051c63add88c;

});

parcelRegister("4L9ve", function(module, exports) {
/**
 * Sweet state store for processed comments data.
 * This store should ONLY be updated by CommentsDataBackgroundLoader.
 * All other consumers should use the state/actions hooks to read data.
 */ 
var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");


var $kgNLQ = parcelRequire("kgNLQ");

const $20eb19f7ec5706e8$export$53ac33307b5acee9 = ()=>({
        lastProcessedData: null,
        allComments: [],
        allFilteredComments: [],
        openInlineComments: [],
        openFooterComments: [],
        resolvedComments: [],
        openComments: [],
        commentsDataMap: {
            inline: {},
            general: {}
        },
        flatCommentsMap: {},
        flatMarkerRefMap: {},
        hasNestedComments: false,
        isDataProcessed: false,
        commentCount: 0,
        hasAnyComments: false,
        error: undefined,
        refetch: undefined
    });
const $20eb19f7ec5706e8$export$e324594224ef24da = {
    /**
	 * Updates all processed comments data.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 * Note: refetch is set separately via setRefetch, so it's not included here.
	 */ setProcessedData: (data)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...data,
                error: undefined,
                // Keep existing refetch if it exists, don't overwrite it
                refetch: currentState.refetch
            });
        },
    /**
	 * Sets an error state for processed comments data.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ setError: (error)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                error: error,
                isDataProcessed: true
            });
        },
    /**
	 * Clears error and resets isDataProcessed to initial values.
	 * Skips setState when already at initial values to avoid unnecessary re-renders.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ clearErrorAndResetIsDataProcessed: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const initialState = $20eb19f7ec5706e8$export$53ac33307b5acee9();
            if (currentState.error === initialState.error && currentState.isDataProcessed === initialState.isDataProcessed) return;
            setState({
                ...currentState,
                error: initialState.error,
                isDataProcessed: initialState.isDataProcessed
            });
        },
    /**
	 * Sets isDataProcessed to true without changing other state.
	 * Only updates if isDataProcessed is currently false to prevent unnecessary re-renders.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ setDataToProcessed: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isDataProcessed) return;
            setState({
                ...currentState,
                isDataProcessed: true
            });
        },
    /**
	 * Sets the refetch function from useAllCommentsData.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ setRefetch: (refetch)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                refetch: refetch
            });
        },
    /**
	 * Clears all processed comments data and resets to initial state.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ clearProcessedData: ()=>({ setState: setState })=>{
            setState($20eb19f7ec5706e8$export$53ac33307b5acee9());
        },
    /**
	 * Processes the raw comments data if it hasn't already been processed and updates the store with
	 * categorized comments. Can be used with output from useAllCommentsData() hook (that is, the full
	 * comments data query result) or the full comments data cache (for when we need to synchronously
	 * process updated cache data).
	 *
	 * Note that for Apollo GQL, if the data hasn't changed then readQuery() will return the same
	 * data reference as the full comment query does. So it is safe to compare data references from
	 * real queries and cache reads to avoid unnecessary reprocessing.
	 *
	 */ // TODO: Verify the data reference behavior for Relay GQL when we start enabling Relay support.
    processCommentsData: ({ data: data, pageMode: pageMode })=>({ setState: setState, getState: getState })=>{
            // Nothing to process if data is null
            if (!data) return null;
            // Don't process the same data twice - if the data reference is the same as the last processed
            const currentState = getState();
            if (currentState.isDataProcessed && currentState.lastProcessedData === data) return null;
            // Filter out null nodes and create array (empty array if no data)
            const allComments = (data?.comments?.nodes || []).filter((node)=>node !== null);
            // Categorize comments using default contentStatus filters
            const contentStatusFilters = (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode);
            const categorizedData = (0, $kgNLQ.categorizeComments)(allComments, contentStatusFilters);
            // Update the store with categorized comments
            setState({
                ...currentState,
                ...categorizedData,
                allComments: allComments,
                lastProcessedData: data,
                error: undefined,
                isDataProcessed: true
            });
            return {
                total: categorizedData.allFilteredComments.length,
                openInline: categorizedData.openInlineComments.length,
                openFooter: categorizedData.openFooterComments.length,
                open: categorizedData.openComments.length,
                resolved: categorizedData.resolvedComments.length,
                totalIncludingReplies: Object.keys(categorizedData.flatCommentsMap).length,
                markerRef: Object.keys(categorizedData.flatMarkerRefMap).length
            };
        }
};
const $20eb19f7ec5706e8$export$4be6ac988c62a591 = (0, $8s9DV.createStore)({
    initialState: $20eb19f7ec5706e8$export$53ac33307b5acee9(),
    actions: $20eb19f7ec5706e8$export$e324594224ef24da,
    name: 'ProcessedCommentsDataStore'
});
const $20eb19f7ec5706e8$export$421cff7071854c91 = (0, $kBr4q.createHook)($20eb19f7ec5706e8$export$4be6ac988c62a591);
const $20eb19f7ec5706e8$export$2919c8d01260d4fe = (0, $kBr4q.createActionsHook)($20eb19f7ec5706e8$export$4be6ac988c62a591);
const $20eb19f7ec5706e8$export$93d43ef0fc9d136b = (0, $kBr4q.createStateHook)($20eb19f7ec5706e8$export$4be6ac988c62a591);
// Non-React utility for accessing store outside of React components
const $20eb19f7ec5706e8$var$processedCommentsDataStoreInstance = (0, $c6StJ.defaultRegistry).getStore($20eb19f7ec5706e8$export$4be6ac988c62a591);
const $20eb19f7ec5706e8$export$db6951977b558d4d = ()=>{
    return $20eb19f7ec5706e8$var$processedCommentsDataStoreInstance.storeState.getState();
};
const $20eb19f7ec5706e8$export$ae4b56ccf0bbe776 = ()=>{
    return $20eb19f7ec5706e8$var$processedCommentsDataStoreInstance.actions;
};
module.exports["useProcessedCommentsData"] = $20eb19f7ec5706e8$export$421cff7071854c91;
module.exports["useProcessedCommentsDataActions"] = $20eb19f7ec5706e8$export$2919c8d01260d4fe;
module.exports["useProcessedCommentsDataState"] = $20eb19f7ec5706e8$export$93d43ef0fc9d136b;
module.exports["getProcessedCommentsDataState"] = $20eb19f7ec5706e8$export$db6951977b558d4d;
module.exports["getProcessedCommentsDataActions"] = $20eb19f7ec5706e8$export$ae4b56ccf0bbe776;

});

parcelRegister("kgNLQ", function(module, exports) {

var $cD1qu = parcelRequire("cD1qu");


var $6mKj3 = parcelRequire("6mKj3");


var $jbF1h = parcelRequire("jbF1h");

var $344a24116515d334$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    return CommentType;
}({});
const $344a24116515d334$export$4883f94fcd5fa7aa = {
    ari: '',
    containerAri: '',
    reactionsCount: 0,
    reactionsSummaryForEmoji: [],
    __typename: 'ReactionsSummaryResponse'
};
const $344a24116515d334$export$99a332599a946905 = '998765432100';
const $344a24116515d334$export$c6a7031105fdebc = (commentData, commentId)=>{
    // Search in retreived comments and their replies
    for (const comment of commentData){
        // Check if this is the comment we're looking for
        if (comment?.id === commentId) return comment;
        // Check if it's in the replies
        if (comment?.replies) {
            const foundReply = comment.replies.find((reply)=>reply?.id === commentId);
            if (foundReply) return foundReply;
        }
    }
    // else comment not found
    return undefined;
};
const $344a24116515d334$export$6ba3a6375d12d24f = (commentData, replyParentId)=>{
    // Search through each root level comment's replies
    for (const comment of commentData){
        // Return this comment if it is the parent of the reply, else check if this comment has replies
        // and if any of them have the matching parentId
        if (comment?.id === replyParentId || comment?.replies.find((reply)=>reply?.id === replyParentId)) return comment;
    }
    // else comment not found
    return undefined;
};
const $344a24116515d334$export$3e4a472ec0de2dc6 = (commentData, markerRef)=>{
    // Search in retrieved comments and their replies
    for (const comment of commentData){
        // Check if this comment's marker ref matches
        const location = comment?.location;
        if (location?.inlineMarkerRef === markerRef) return comment;
    }
    return undefined;
};
const $344a24116515d334$export$499492f953d5abba = (comments, commentId, markerRef, contentStatus)=>{
    if (comments.length === 0) return undefined;
    let foundComment;
    if (commentId) foundComment = $344a24116515d334$export$c6a7031105fdebc(comments, commentId);
    else if (markerRef) foundComment = $344a24116515d334$export$3e4a472ec0de2dc6(comments, markerRef);
    if (!foundComment) return undefined;
    // Filter by contentStatus before returning
    const matchesContentStatusFilter = (comment)=>{
        if (!comment || !comment.contentStatus) return false;
        // Convert comment's contentStatus to uppercase to match GraphQLContentStatus format
        const commentStatus = comment.contentStatus.toUpperCase();
        return contentStatus.includes(commentStatus);
    };
    if (matchesContentStatusFilter(foundComment)) return foundComment;
    return undefined;
};
const $344a24116515d334$export$4d95f4b945556294 = (comment, mutationResult)=>{
    const resolveInlineComment = mutationResult?.data?.resolveInlineComment;
    const mutationStatus = resolveInlineComment?.status ?? false;
    const resolveProperties = resolveInlineComment?.resolveProperties ?? undefined;
    return (0, $jbF1h.resolveCommentInCache)({
        comment: comment,
        mutationStatus: mutationStatus,
        resolveProperties: resolveProperties
    });
};
const $344a24116515d334$export$d81a62b32f0e420f = (comment, mutationResult)=>{
    const commentResolutionStates = mutationResult?.data?.confluence_resolveComments?.commentResolutionStates;
    if ((commentResolutionStates?.length ?? 0) > 1) throw new Error('resolveCommentInCacheCallback() only supports one comment resolution state per mutation call');
    const firstResolutionState = commentResolutionStates?.[0] ?? undefined;
    const mutationStatus = firstResolutionState?.status ?? false;
    const partialResolveProperties = firstResolutionState?.resolveProperties ?? undefined;
    // We need to ensure that resolveProperties contains all non-optional properties so we can safely
    // spread it into the comment location resolve properties, so choose defaults for any missing
    // ones.  This is needed because some of the mutations don't request all the properties in their
    // responses.
    const resolveProperties = partialResolveProperties ? {
        resolved: true,
        isDangling: false,
        // These are nullable in the schema, but included to make Typescript happy
        resolvedUser: undefined,
        resolvedFriendlyDate: undefined,
        resolvedTime: undefined,
        // Add any non-null/undefined properties from the mutation result
        ...partialResolveProperties
    } : undefined;
    return (0, $jbF1h.resolveCommentInCache)({
        comment: comment,
        mutationStatus: mutationStatus,
        resolveProperties: resolveProperties
    });
};
const $344a24116515d334$export$aa65246494e3c3e0 = (comment, mutationResult)=>{
    // (The property is called "commentResolutionStates" but there is only one item per mutation call)
    const commentResolutionStates = mutationResult?.data?.confluence_reopenComment?.commentResolutionStates;
    if (commentResolutionStates) {
        const mutationStatus = commentResolutionStates.status ?? false;
        const partialResolveProperties = commentResolutionStates.resolveProperties ?? undefined;
        // We need to ensure that resolveProperties contains all non-optional properties so we can safely
        // spread it into the comment location resolve properties, so choose defaults for any missing
        // ones. This is needed because some of the mutations don't request all the properties - or even
        // the commentResolutionStates property at all in their responses.
        const resolveProperties = {
            resolved: false,
            isDangling: false,
            // These are nullable in the schema, but included to make Typescript happy
            resolvedUser: undefined,
            resolvedFriendlyDate: undefined,
            resolvedTime: undefined,
            // Add any non-null/undefined properties from the mutation result
            ...partialResolveProperties
        };
        return (0, $jbF1h.resolveCommentInCache)({
            comment: comment,
            mutationStatus: mutationStatus,
            resolveProperties: resolveProperties
        });
    }
    // Else commentResolutionStates wasn't returned - assume failure to reopen
    return (0, $jbF1h.resolveCommentInCache)({
        comment: comment,
        mutationStatus: false,
        resolveProperties: undefined
    });
};
const $344a24116515d334$export$e237bdee87974d46 = (pageMode)=>{
    // On view pages, exclude draft comments
    if (pageMode === (0, $cD1qu.PageMode).VIEW) return [
        'CURRENT',
        'ARCHIVED'
    ];
    // On edit and live pages, include all statuses
    return [
        'CURRENT',
        'ARCHIVED',
        'DRAFT'
    ];
};
const $344a24116515d334$export$70df9f207ee9869d = (comment)=>{
    const location = comment?.location;
    if (location) {
        if ('inlineResolveProperties' in location) return location.inlineResolveProperties?.resolved ?? false;
        else if ('commentResolveProperties' in location) return location.commentResolveProperties?.resolved ?? false;
    }
    return false;
};
const $344a24116515d334$export$6036c2c532b2fa41 = (commentsDataMap)=>{
    try {
        const allGeneralComments = Object.values(commentsDataMap.general);
        // To see if there are nested comments, we need to check whether there are any replies whose parentID is not equal to the parent Comment's ID
        // This is because commentsDataMap.general is a flat map of parent comment --> everything below it
        // But each comment has it's own parent id which may be different from it's top level parent
        return allGeneralComments.some((comment)=>{
            return comment?.replies?.some((reply)=>reply && reply.parentId !== comment.id);
        });
    } catch  {
        // Default to false if somehow something goes wrong
        return false;
    }
};
const $344a24116515d334$export$2fa0b601110c277b = (comments, contentStatusFilters)=>{
    const allFilteredComments = [];
    const openComments = [];
    const openInlineComments = [];
    const openFooterComments = [];
    const resolvedComments = [];
    // Transform array-based data to map structure for legacy compatibility
    const commentsDataMap = {
        inline: {},
        general: {}
    };
    // Build flat map of all comments (including replies) for O(1) lookup by commentId
    const flatCommentsMap = {};
    // Build flat map of inline comments keyed by markerRef for O(1) lookup
    const flatMarkerRefMap = {};
    for (const comment of comments)// Filter by content status, which is a string literal type (that is, a set of allowed
    // strings), so be cautious if the definitions or schema change
    if (comment && contentStatusFilters.includes(comment.contentStatus?.toUpperCase())) {
        allFilteredComments.push(comment);
        // Add comment to flat map by commentId
        if (comment?.id) flatCommentsMap[comment.id] = comment;
        // Add inline parent comment to flatMarkerRefMap by markerRef (only parent comments, not replies)
        if (comment?.location?.type === 'INLINE' && !comment?.parentId) {
            const location = comment.location;
            if (location?.inlineMarkerRef) flatMarkerRefMap[location.inlineMarkerRef] = comment;
        }
        // Add all replies to flat map
        if (comment?.replies) {
            for (const reply of comment.replies)if (reply?.id) flatCommentsMap[reply.id] = reply;
        }
        const isOpen = !$344a24116515d334$export$70df9f207ee9869d(comment);
        const commentType = comment.location?.type === 'INLINE' ? "inline" : "general";
        const commentWithProperties = {
            ...comment,
            type: commentType,
            isOpen: isOpen,
            replies: comment.replies?.filter((reply)=>reply !== null && reply !== undefined).map((reply)=>({
                    ...reply
                }))
        };
        if (isOpen) {
            openComments.push(comment);
            if (comment?.location?.type === 'INLINE') openInlineComments.push(comment);
            else if (comment?.location?.type === 'FOOTER') openFooterComments.push(comment);
        // else unknown or missing location type, do nothing
        } else resolvedComments.push(comment);
        if (comment.location?.type === 'INLINE') {
            const threadKey = 'inlineMarkerRef' in comment.location ? comment.location.inlineMarkerRef || comment.id : comment.id;
            commentsDataMap.inline[threadKey] = commentWithProperties;
        } else if (comment.location?.type === 'FOOTER') commentsDataMap.general[comment.id] = commentWithProperties;
    }
    const hasNestedComments = $344a24116515d334$export$6036c2c532b2fa41(commentsDataMap);
    const commentCount = allFilteredComments.length;
    const hasAnyComments = commentCount > 0;
    return {
        allFilteredComments: allFilteredComments,
        openComments: openComments,
        openInlineComments: openInlineComments,
        openFooterComments: openFooterComments,
        resolvedComments: resolvedComments,
        commentsDataMap: commentsDataMap,
        flatCommentsMap: flatCommentsMap,
        flatMarkerRefMap: flatMarkerRefMap,
        hasNestedComments: hasNestedComments,
        commentCount: commentCount,
        hasAnyComments: hasAnyComments
    };
};
const $344a24116515d334$export$5c24224d7e29c719 = ()=>{
    return {
        context: {
            fetchOptions: {
                ignoreNoNetworkError: (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_offline_fix', 'isEnabled', true)
            }
        }
    };
};
module.exports["CommentType"] = $344a24116515d334$export$ffa1150e6a48f9cd;
module.exports["emptyReactionsSummary"] = $344a24116515d334$export$4883f94fcd5fa7aa;
module.exports["OPTIMISTIC_SAVE_COMMENT_ID"] = $344a24116515d334$export$99a332599a946905;
module.exports["findCommentInData"] = $344a24116515d334$export$c6a7031105fdebc;
module.exports["findRootCommentForReply"] = $344a24116515d334$export$6ba3a6375d12d24f;
module.exports["findAndFilterComment"] = $344a24116515d334$export$499492f953d5abba;
module.exports["resolveInlineCommentInCacheCallback"] = $344a24116515d334$export$4d95f4b945556294;
module.exports["resolveCommentInCacheCallback"] = $344a24116515d334$export$d81a62b32f0e420f;
module.exports["reopenCommentInCacheCallback"] = $344a24116515d334$export$aa65246494e3c3e0;
module.exports["buildDefaultCommentsContentStatusFilters"] = $344a24116515d334$export$e237bdee87974d46;
module.exports["isCommentResolved"] = $344a24116515d334$export$70df9f207ee9869d;
module.exports["categorizeComments"] = $344a24116515d334$export$2fa0b601110c277b;
module.exports["buildMutationContextForNoNetworkError"] = $344a24116515d334$export$5c24224d7e29c719;

});

parcelRegister("jbF1h", function(module, exports) {

var $82R8R = parcelRequire("82R8R");


var $6nYhN = parcelRequire("6nYhN");


var $cozmU = parcelRequire("cozmU");


var $ij4CE = parcelRequire("ij4CE");


var $fFmJj = parcelRequire("fFmJj");







// Unfortunately our Relay-friendly type generation tools don't support GQL fragments yet - but in
// order to keep the definition of the comment fields in sync (so the cache update fragment is
// always in sync with the full query) we will need to manually make any changes to one definition
// in any others as well, until our tooling supports fragments and then we move to a more
// fragmented-based approach.  Note there are also comment queries or fragments in the following
// files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data-manager/src/useCommentById.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineReplyMutation.ts
// - next/packages/object-comments/src/components/ObjectCommentContainer.tsx
// TODO: Replace with the exported fragment from useAllCommentsData.ts when our tooling supports
// it, if we are allowed to share fragments between packages/files.  If we are not allowed to share
// fragments, we should move this function - or at least the cache updating parts for the function
// - into the useAllCommentsData.ts file.
const $bd790562493588ff$var$updateCommentInCacheFragment = (0, $6nYhN.default);
// Fragment for reply comments (matches the replies schema from the main fragment)
const $bd790562493588ff$var$updateReplyInCacheFragment = (0, $82R8R.default);
// Type guard to check if a comment is a top-level comment (has replies field)
const $bd790562493588ff$var$isTopLevelComment = (comment)=>{
    return 'replies' in comment;
};
const $bd790562493588ff$export$8ce65958c48a9ac3 = ()=>{
    const readFragment = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: $bd790562493588ff$var$updateCommentInCacheFragment,
        __callerPackage__: "comments-data-manager"
    });
    const writeFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $6nYhN.default),
        fragmentSpec: $bd790562493588ff$var$updateCommentInCacheFragment,
        __callerPackage__: "comments-data-manager"
    });
    const readReplyFragment = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: $bd790562493588ff$var$updateReplyInCacheFragment,
        __callerPackage__: "comments-data-manager"
    });
    const writeReplyFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $82R8R.default),
        fragmentSpec: $bd790562493588ff$var$updateReplyInCacheFragment,
        __callerPackage__: "comments-data-manager"
    });
    /**
   * Function to update a comment in the Apollo cache.
   * @param mutationResult - The result of the mutation that triggered the cache update
   * @param commentId - ID of the comment to update
   * @param updateCallback - Callback function that receives the current comment data
   *                         and returns the updated comment data
   * @param onError - Optional error callback to handle errors during the update process
   * @param isReply - Whether this comment is a reply (true) or top-level comment (false)
   */ const updateCommentInCache = (0, $cozmU.useCallback)(({ mutationResult: mutationResult, commentId: commentId, updateCallback: updateCallback, onError: onError, isReply: isReply = false })=>{
        if (!commentId) {
            onError?.(new Error('Cannot update comment in cache: comment ID is missing'));
            return;
        }
        try {
            // The fragment ID format for Apollo cache
            const fragmentId = `Comment:${commentId}`;
            let cachedComment = null;
            if (isReply) cachedComment = readReplyFragment({
                id: fragmentId
            });
            else cachedComment = readFragment({
                id: fragmentId
            });
            if (!cachedComment) {
                // (There is a slight chance the comment is not in cache - but the mutation that calls
                // this function would have to completed successfully to call us, so presumably the
                // comment existed then. Thus the only legit reason for it to be missing from the cache
                // now is if another user deleted the comment in between the mutation and this cache
                // update call. That is unlikely, so let's log this as an error and return. If in
                // the future we find the legit use case is happening more often, we can change to a
                // warning instead.)
                onError?.(new Error(`Cannot update comment in cache: comment with ID ${commentId} not found in cache`));
                return;
            }
            // Apply the update callback on a copy of the cached comment
            // (Note that the updateCallback should return a new object, not mutate the original - so
            //  make copies of any nested objects you need to change also)
            const updatedComment = updateCallback({
                ...cachedComment
            }, mutationResult);
            // Write the updated comment back to cache using appropriate fragment
            if (isReply) writeReplyFragment({
                fragmentId: fragmentId,
                data: updatedComment
            });
            else writeFragment({
                fragmentId: fragmentId,
                data: updatedComment
            });
        } catch (err) {
            onError?.(new Error(`An error occurred when updating cached comment data: ${err}`));
            return;
        }
    }, [
        readFragment,
        writeFragment,
        readReplyFragment,
        writeReplyFragment
    ]);
    return {
        updateCommentInCache: updateCommentInCache
    };
};
const $bd790562493588ff$export$9e04af313e7174f4 = ({ comment: comment, mutationStatus: mutationStatus, resolveProperties: resolveProperties })=>{
    if (!mutationStatus || !resolveProperties) // Mutation result is missing or incomplete - so just return the comment unchanged
    return comment;
    // Extract isDangling separately since it is handled differently, and exclude __typename since we
    // don't need it and Typescript would complain about it being included in the spread below.
    const { __typename: __typename, isDangling: isDangling, ...otherResolveProperties } = resolveProperties;
    // Defaults for the nullable resolve fields. A partial mutation response (e.g. a reopen that only
    // returns `resolved: false`) leaves these `undefined` in the write data. The interop fragment
    // writer skips `undefined` scalars (setRelayScalarValue), so those fields would be absent in the
    // store and Relay warns "Missing field resolvedFriendlyDate/..." on the next read. Seeding them
    // as explicit `null` (their unresolved value) keeps the resolve-properties record complete; any
    // real value from the mutation response still overrides via the spread below.
    const resolvePropertyDefaults = {
        resolvedUser: null,
        resolvedFriendlyDate: null,
        resolvedTime: null
    };
    // Mark the comment as resolved in the cache, but how to do that depends on the comment type
    const location = comment.location;
    const newLocation = {
        ...location,
        ...'commentResolveProperties' in location ? {
            commentResolveProperties: {
                ...location.commentResolveProperties,
                ...resolvePropertyDefaults,
                ...otherResolveProperties
            }
        } : {},
        ...'inlineResolveProperties' in location ? {
            inlineResolveProperties: {
                ...location.inlineResolveProperties,
                ...resolvePropertyDefaults,
                ...otherResolveProperties,
                isDangling: isDangling
            }
        } : {}
    };
    // @ts-expect-error - FIXME: This error was surfaced after enabling the `typescriptExcludeUndefinedFromNullableUnion`
    // Relay compiler option. Previously, `undefined` was incorrectly included in nullable unions in generated types; this option removes it. The owning team should fix this properly.
    return {
        ...comment,
        location: newLocation
    };
};
const $bd790562493588ff$export$df3d27666bd765d5 = (comment, mutationResult)=>{
    const newBodyValue = mutationResult?.data?.updateComment?.body?.value;
    const updatedBody = {
        ...comment.body,
        // Remember that an empty string is a valid body value, so only skip updating if newBodyValue
        // is null or undefined
        ...newBodyValue || newBodyValue === '' ? {
            value: newBodyValue
        } : {}
    };
    const newVersion = mutationResult?.data?.updateComment?.version;
    const newDisplayName = newVersion?.by?.displayName;
    // If the existing comment's version doesn't have a "by" field, we don't want to add just part
    // of it - so set it to undefined so it won't be included in the updated comment. This probably
    // won't actually ever happen, but it makes Typescript happy just in case.
    const updatedBy = comment.version?.by ? {
        ...comment.version?.by,
        ...newDisplayName ? {
            displayName: newDisplayName
        } : {}
    } : undefined;
    const updatedVersion = {
        ...comment.version,
        ...newVersion?.number ? {
            number: newVersion.number
        } : {},
        ...newVersion?.when ? {
            when: newVersion.when
        } : {},
        ...updatedBy ? {
            by: {
                ...updatedBy
            }
        } : {}
    };
    const baseUpdatedComment = {
        ...comment,
        body: updatedBody,
        version: {
            ...updatedVersion
        }
    };
    // Return with appropriate type casting based on comment type
    return $bd790562493588ff$var$isTopLevelComment(comment) ? baseUpdatedComment : baseUpdatedComment;
};
module.exports["useUpdateCommentInCache"] = $bd790562493588ff$export$8ce65958c48a9ac3;
module.exports["resolveCommentInCache"] = $bd790562493588ff$export$9e04af313e7174f4;
module.exports["updateCommentBodyInCacheCallback"] = $bd790562493588ff$export$df3d27666bd765d5;

});

parcelRegister("82R8R", function(module, exports) {
/**
 * @generated SignedSource<<b6af2e5e8b1c672924f300605e9d9ac3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6ee66e0478f0211a$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v2 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v4 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v5 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v6 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useUpdateCommentInCacheReplyFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "permissionType"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "accountId"
                            }
                        ],
                        "type": "KnownUser"
                    },
                    {
                        "concreteType": "Icon",
                        "kind": "LinkedField",
                        "name": "profilePicture",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "path"
                            }
                        ]
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "representation",
                        "value": "ATLAS_DOC_FORMAT"
                    }
                ],
                "concreteType": "DocumentBody",
                "kind": "LinkedField",
                "name": "body",
                "plural": false,
                "selections": v2 /*: any*/ ,
                "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
            },
            {
                "kind": "ScalarField",
                "name": "contentStatus"
            },
            {
                "concreteType": "ConfluenceDate",
                "kind": "LinkedField",
                "name": "createdAt",
                "plural": false,
                "selections": v2 /*: any*/ 
            },
            {
                "kind": "ScalarField",
                "name": "createdAtNonLocalized"
            },
            {
                "concreteType": "Map_LinkType_String",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "editui"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "webui"
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "name": "location",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "InlineCommentResolveProperties",
                                "kind": "LinkedField",
                                "name": "commentResolveProperties",
                                "plural": false,
                                "selections": [
                                    v3 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v5 /*: any*/ ,
                                    v6 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "FooterComment"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "inlineMarkerRef"
                            },
                            {
                                "concreteType": "InlineCommentResolveProperties",
                                "kind": "LinkedField",
                                "name": "inlineResolveProperties",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "isDangling"
                                    },
                                    v3 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v5 /*: any*/ ,
                                    v6 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "inlineText"
                            }
                        ],
                        "type": "InlineComment"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "parentId"
            },
            {
                "concreteType": "CommentPermissions",
                "kind": "LinkedField",
                "name": "permissions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isEditable"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isRemovable"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isResolvable"
                    }
                ]
            },
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            v1 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "number"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "when"
                    }
                ]
            }
        ],
        "type": "Comment"
    };
}();
$6ee66e0478f0211a$var$node.hash = "d793bb57d64855b11bf515ef7082e802";
var $6ee66e0478f0211a$export$2e2bcd8739ae039 = $6ee66e0478f0211a$var$node;
module.exports["default"] = $6ee66e0478f0211a$export$2e2bcd8739ae039;

});

parcelRegister("6nYhN", function(module, exports) {
/**
 * @generated SignedSource<<776c1b585ba7040195aa55b4ce020277>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1d633d5b65e9f4e8$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v3 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v4 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v8 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v7 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v9 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v10 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v11 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v12 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v14 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v17 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v1 /*: any*/ ,
            v5 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v13 /*: any*/ ,
                            v14 /*: any*/ ,
                            v15 /*: any*/ ,
                            v16 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v13 /*: any*/ ,
                            v14 /*: any*/ ,
                            v15 /*: any*/ ,
                            v16 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v19 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v20 = {
        "kind": "LinkedField",
        "name": "contributors",
        "plural": true,
        "selections": [
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v4 /*: any*/ ,
            v6 /*: any*/ 
        ]
    }, v21 = {
        "kind": "ScalarField",
        "name": "number"
    }, v22 = {
        "kind": "ScalarField",
        "name": "when"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useUpdateCommentInCacheFragment",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    v3 /*: any*/ ,
                    v4 /*: any*/ ,
                    v5 /*: any*/ ,
                    v6 /*: any*/ 
                ]
            },
            v8 /*: any*/ ,
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "container",
                "plural": false,
                "selections": [
                    v0 /*: any*/ 
                ]
            },
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ ,
            v20 /*: any*/ ,
            {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "replies",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v2 /*: any*/ ,
                            v3 /*: any*/ ,
                            v6 /*: any*/ ,
                            v4 /*: any*/ 
                        ]
                    },
                    v8 /*: any*/ ,
                    v9 /*: any*/ ,
                    v10 /*: any*/ ,
                    v11 /*: any*/ ,
                    v12 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ ,
                    v19 /*: any*/ ,
                    v20 /*: any*/ ,
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "by",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ ,
                                    v2 /*: any*/ 
                                ]
                            },
                            v21 /*: any*/ ,
                            v22 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v5 /*: any*/ ,
                            v2 /*: any*/ ,
                            v6 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "friendlyWhen"
                    },
                    v21 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            }
        ],
        "type": "Comment"
    };
}();
$1d633d5b65e9f4e8$var$node.hash = "3eaa0227f14e77a83748a865f02fa321";
var $1d633d5b65e9f4e8$export$2e2bcd8739ae039 = $1d633d5b65e9f4e8$var$node;
module.exports["default"] = $1d633d5b65e9f4e8$export$2e2bcd8739ae039;

});

parcelRegister("g6gor", function(module, exports) {

let $bb89ec37245aaadc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bb89ec37245aaadc$var$load("5J2Yz").then(()=>parcelRequire('gJcNU'));

});

parcelRegister("8zMP3", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $65DSU = parcelRequire("65DSU");


var $hZpML = parcelRequire("hZpML");


var $cemw8 = parcelRequire("cemw8");


var $8zKDl = parcelRequire("8zKDl");


var $dAPGk = parcelRequire("dAPGk");

const $5cfe2edd168ef31e$export$b17d024ed060ce0b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $dAPGk.useSuspenseBoundaryName)();
} : ()=>(0, $dAPGk.useSuspenseBoundaryName)();
const $5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader = (0, $3u0dr.isReactCompilerActiveV2)() ? function SuspenseWithDataFetcherReader(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { dataFetcher: dataFetcher, children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function SuspenseWithDataFetcherReader({ dataFetcher: dataFetcher, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
function $5cfe2edd168ef31e$export$553ede96e278ba94({ dataFetcherName: dataFetcherName, fallback: fallback = null, children: children }) {
    // Capture the SSR streaming value on initial render using useRef
    // This ensures the component tree doesn't change when the global variable
    // is deleted during route navigation
    const isSSRStreaming = (0, $cozmU.useRef)(window.__SSR_REACT_STREAMING__);
    // Get the current boundary chain from parent context
    const parentBoundaryChain = (0, $cozmU.useContext)((0, $dAPGk.SuspenseBoundaryNameContext));
    // Create new chain by appending current boundary to parent chain
    const currentBoundaryChain = (0, $cozmU.useMemo)(()=>[
            ...parentBoundaryChain,
            dataFetcherName
        ], [
        parentBoundaryChain,
        dataFetcherName
    ]);
    if (isSSRStreaming.current) {
        const dataFetcher = (0, $8zKDl.getDataFetcherForSuspense)(dataFetcherName, isSSRStreaming.current);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dAPGk.SuspenseBoundaryNameContext).Provider, {
            value: currentBoundaryChain
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cemw8.HydrationSafeSuspense), {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader, {
            dataFetcher: dataFetcher
        }, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SUSPENSE}/${dataFetcherName}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
            name: `stream-suspense-${dataFetcherName}`
        }, children), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SUSPENSE}/${dataFetcherName}.end`))));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
}
module.exports["SuspenseWithDataFetcher"] = $5cfe2edd168ef31e$export$553ede96e278ba94;

});

parcelRegister("cemw8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $e4o8D = parcelRequire("e4o8D");

const $28f120e398482486$var$HydrationSafeSuspenseContent = /*#__PURE__*/ (0, $cozmU.memo)(function HydrationSafeSuspenseContent({ children: children, fallback: fallback }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: fallback
    }, children);
}, (_prevProps, nextProps)=>{
    // Block updates while locked (during hydration)
    return nextProps.isLocked;
});
function $28f120e398482486$export$a0bfcafd6d556141({ fallback: fallback = null, children: children }) {
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28f120e398482486$var$HydrationSafeSuspenseContent, {
        isLocked: renderServerPlaceholder,
        fallback: fallback
    }, children);
}
module.exports["HydrationSafeSuspense"] = $28f120e398482486$export$a0bfcafd6d556141;

});

parcelRegister("8zKDl", function(module, exports) {
function $2b2227915da27313$export$63116239d47be9ca(dataFetcherName, isSSRStreaming = true) {
    if (!isSSRStreaming || !dataFetcherName) return null;
    return window.__dataFetcherForSuspense__?.[dataFetcherName] ?? null;
}
module.exports["getDataFetcherForSuspense"] = $2b2227915da27313$export$63116239d47be9ca;

});

parcelRegister("2VZOl", function(module, exports) {

var $j8on0 = parcelRequire("j8on0");

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $9HkI0 = parcelRequire("9HkI0");

const $a3221c0e46c131d6$export$cd763072e62a98fa = (0, $j8on0.createContainer)();
const $a3221c0e46c131d6$var$Store = (0, $8s9DV.createStore)({
    containedBy: $a3221c0e46c131d6$export$cd763072e62a98fa,
    initialState: {
        presenceId: ''
    },
    actions: {},
    handlers: {
        onInit: ()=>({ setState: setState })=>{
                setState({
                    presenceId: (0, $9HkI0.v4)()
                });
            }
    }
});
const $a3221c0e46c131d6$export$f529db6cceb299f5 = (0, $kBr4q.createHook)($a3221c0e46c131d6$var$Store);
module.exports["NativeCollabPresenceStateContainer"] = $a3221c0e46c131d6$export$cd763072e62a98fa;
module.exports["useNativeCollabPresenceState"] = $a3221c0e46c131d6$export$f529db6cceb299f5;

});

parcelRegister("8KbKw", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $04e9M = parcelRequire("04e9M");


var $9137z = parcelRequire("9137z");


var $j8hiR = parcelRequire("j8hiR");


var $6mKj3 = parcelRequire("6mKj3");


var $7Sm4c = parcelRequire("7Sm4c");


var $c0rhi = parcelRequire("c0rhi");


var $aMcHK = parcelRequire("aMcHK");


var $6fil2 = parcelRequire("6fil2");


var $lR7wI = parcelRequire("lR7wI");


var $1sAC2 = parcelRequire("1sAC2");

const $6f395e426fb151a0$var$isContentNotFoundError = (error)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some((graphQLError)=>graphQLError.message.includes('Invalid content id'));
    return false;
};
const $6f395e426fb151a0$var$shouldRetryUnknownStatusNetworkError = (error)=>{
    const isNetworkError = (0, $6fil2.containsNetworkError)(error);
    const networkError = error?.networkError ?? error;
    const isCausedByAbortError = networkError instanceof (0, $6fil2.NetworkError) && (0, $6fil2.causedByAbortError)(networkError);
    const isOnline = typeof navigator === 'undefined' || navigator.onLine;
    const statusCode = (0, $aMcHK.getStatusCodeError)(error);
    return isNetworkError && !isCausedByAbortError && isOnline && statusCode === undefined;
};
const $6f395e426fb151a0$var$emitRetryCompleted = (outcome)=>{
    (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
        client.sendOperationalEvent({
            action: 'retryCompleted',
            actionSubject: 'collabPermissionToken',
            source: 'fetchCollabPermissionToken',
            attributes: {
                outcome: outcome
            }
        });
    });
};
const $6f395e426fb151a0$var$getTokenFromQueryResult = (result)=>{
    (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_PERMS_TOKEN_FETCH);
    const token = result.data?.collabToken?.token ?? null; // if token is null, collab service will fall back to permissions service check
    if (token === null && (0, $6mKj3.expVal)('platform_editor_emit_null_token_event', 'isEnabled', false)) (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
        client.sendOperationalEvent({
            action: 'nullTokenReturned',
            actionSubject: 'collabPermissionToken',
            source: 'fetchCollabPermissionToken',
            attributes: {
                reason: 'emptyResponse'
            }
        });
    });
    return token;
};
const $6f395e426fb151a0$export$e344958ab47793df = (0, $dOBRD.default)((contentId, draftShareId)=>async ()=>{
        const permissionsTokenState = (0, $1sAC2.nativeCollabPermissionsTokenState).getPermissionsTokenState(contentId);
        if (permissionsTokenState) {
            const { getToken: getToken, isUsedForDraftFetch: isUsedForDraftFetch, isUsedForWSInitialization: isUsedForWSInitialization } = permissionsTokenState;
            // fetchCollabPermissionToken should only return the token if it is valid and has successfully been passed to the getDraft call
            if (isUsedForDraftFetch && !isUsedForWSInitialization) {
                const token = await getToken;
                if (token) {
                    (0, $1sAC2.nativeCollabPermissionsTokenState).setIsUsedForWSInitialization(contentId, true);
                    return token;
                }
            }
        }
        const query = ()=>(0, $c0rhi.queryInterop)({
                query: (0, $lR7wI.default),
                variables: {
                    contentId: contentId,
                    ...draftShareId && {
                        draftShareId: draftShareId
                    }
                },
                fetchPolicy: 'network-only',
                context: {
                    fetchOptions: {
                        // If we have a "no network error" this will never resolve and subsequent calls will
                        // be in limbo. This means we are unable to ever connect to NCS again (requiring a page reset)
                        ignoreNoNetworkError: true
                    }
                },
                __callerPackage__: "native-collab"
            });
        try {
            (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_PERMS_TOKEN_FETCH);
            const result = await query();
            return $6f395e426fb151a0$var$getTokenFromQueryResult(result);
        } catch (e) {
            if ((0, $6mKj3.expVal)('platform_editor_retry_collab_token_query', 'isEnabled', false)) {
                if ($6f395e426fb151a0$var$shouldRetryUnknownStatusNetworkError(e)) try {
                    const result = await query();
                    const token = $6f395e426fb151a0$var$getTokenFromQueryResult(result);
                    $6f395e426fb151a0$var$emitRetryCompleted(token === null ? 'emptyResponse' : 'tokenReturned');
                    return token;
                } catch (retryError) {
                    $6f395e426fb151a0$var$emitRetryCompleted('fetchError');
                    e = retryError;
                }
            }
            (0, $7Sm4c.markErrorAsHandled)(e);
            if ($6f395e426fb151a0$var$isContentNotFoundError(e)) // nasty fragile hack, mimic 404 exception which goes through collab-provider, then gets wrapped and emitted and handled in `useError`.
            // collab provider simply emits errors thrown in permissionTokenRefresh directly on its internal channel, so we have to conform to their error type
            // prettier-ignore
            throw {
                message: "Content not found",
                data: {
                    status: 404,
                    code: "INSUFFICIENT_EDITING_PERMISSION",
                    meta: {
                        description: "RESOURCE_DELETED",
                        reason: "RESOURCE_DELETED"
                    }
                }
            };
            else if (e?.networkError?.response?.status === 503) // prettier-ignore
            throw {
                message: "Service unavailable",
                data: {
                    meta: {
                        reason: "RESOURCE_DELETED"
                    }
                }
            }; // temporary hack to ensure draft cannot be edited during tenant migration, but we should throw TENANT_INSTANCE_MAINTENANCE once supported by collab-provider
            if ((0, $6mKj3.expVal)('platform_editor_emit_null_token_event', 'isEnabled', false)) {
                const statusCode = (0, $aMcHK.getStatusCodeError)(e);
                (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                    client.sendOperationalEvent({
                        action: 'nullTokenReturned',
                        actionSubject: 'collabPermissionToken',
                        source: 'fetchCollabPermissionToken',
                        attributes: {
                            reason: 'fetchError',
                            statusCode: statusCode ?? 'unknown'
                        }
                    });
                });
            }
            return null;
        }
    });
module.exports["fetchCollabPermissionToken"] = $6f395e426fb151a0$export$e344958ab47793df;

});

parcelRegister("9137z", function(module, exports) {

var $kGrzq = parcelRequire("kGrzq");

const $e77725a58fc80757$export$d93492bf620814be = new (0, $kGrzq.BaseMeasures)();
module.exports["CollabEditProviderMeasures"] = $e77725a58fc80757$export$d93492bf620814be;

});

parcelRegister("j8hiR", function(module, exports) {
var $fbca710eb28c4147$export$d0a57beabaefb993 = /*#__PURE__*/ function(COLLAB_EDIT_PROVIDER_MEASURES) {
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_FETCH"] = "collabEditProviderAnalyticsFetch";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_CREATED"] = "collabEditProviderCreated";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_DISABLED"] = "collabEditProviderDisabled";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_INIT"] = "collabEditProviderInitialized";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRE_CONNECTED"] = "collabEditProviderPreconnected";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_CONNECTED"] = "collabEditProviderConnected";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_INIT_DOC"] = "collabEditProviderInitDoc";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_FETCH_NCS_DRAFT"] = "collabEditProviderFetchNCSDraft";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRELOAD_NCS_DRAFT"] = "collabEditProviderPreloadNCSDraft";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRELOAD_NCS_DRAFT_TIMEOUT"] = "collabEditProviderPreloadNCSDraftTimeout";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_PERMS_TOKEN_FETCH"] = "collabEditProviderPermsTokenFetch";
    return COLLAB_EDIT_PROVIDER_MEASURES;
}({});
module.exports["COLLAB_EDIT_PROVIDER_MEASURES"] = $fbca710eb28c4147$export$d0a57beabaefb993;

});

parcelRegister("lR7wI", function(module, exports) {
/**
 * @generated SignedSource<<a61063136e57f7cd39e5b8a983d46e87>>
 * @relayHash bd2d61cdca16378a4f1f566700b1fb56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d8d52b5f773a7bba3b6756bcb3b14fd5aaf52c1ee303a82c5d4a9aaccc6af69
const $4abe7e20c4ebe0be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "draftShareId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "CollabTokenResponse",
            "kind": "LinkedField",
            "name": "collabToken",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "token"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CollabPermissionTokenQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CollabPermissionTokenQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "bd2d61cdca16378a4f1f566700b1fb56",
            "id": "5d8d52b5f773a7bba3b6756bcb3b14fd5aaf52c1ee303a82c5d4a9aaccc6af69",
            "metadata": {},
            "name": "CollabPermissionTokenQuery",
            "operationKind": "query",
            "text": "query CollabPermissionTokenQuery($contentId:ID!,$draftShareId:String){collabToken(id:$contentId,draftShareId:$draftShareId){token}}"
        }
    };
}();
$4abe7e20c4ebe0be$var$node.hash = "f88c8dd0f4e61065305cc9c5b9a3253b";
var $4abe7e20c4ebe0be$export$2e2bcd8739ae039 = $4abe7e20c4ebe0be$var$node;
module.exports["default"] = $4abe7e20c4ebe0be$export$2e2bcd8739ae039;

});

parcelRegister("1sAC2", function(module, exports) {
class $3f756fb591e8330c$export$88b5d10ee0ed72d9 {
    getPermissionsTokenState(contentId) {
        return this.tokenState[contentId];
    }
    setToken(contentId, tokenPromise = Promise.resolve(null)) {
        // clear any existing tokens/bools in state
        this.tokenState[contentId] = {
            getToken: tokenPromise,
            isUsedForDraftFetch: false,
            isUsedForWSInitialization: false
        };
    }
    setIsUsedForDraftFetch(contentId, isUsedForDraftFetch) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].isUsedForDraftFetch = isUsedForDraftFetch;
    }
    setIsUsedForWSInitialization(contentId, isUsedForWSInitialization) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].isUsedForWSInitialization = isUsedForWSInitialization;
    }
    setTimestamp(contentId) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].timestamp = performance.now();
    }
    clearPermissionsTokenState(contentId) {
        if (this.tokenState[contentId]) delete this.tokenState[contentId];
    }
    constructor(){
        this.tokenState = {};
    }
}
const $3f756fb591e8330c$export$8e63d30e585828b3 = new $3f756fb591e8330c$export$88b5d10ee0ed72d9();
module.exports["nativeCollabPermissionsTokenState"] = $3f756fb591e8330c$export$8e63d30e585828b3;

});

parcelRegister("hQm1C", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $a8b418da1bc27466$export$871388fb833dfa56 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "2M0Zq",
    name: "NativeCollabLoader",
    loader: async ()=>{
        const { NativeCollabComponent: NativeCollabComponent } = await (parcelRequire("cYoco"));
        return NativeCollabComponent;
    }
});
module.exports["NativeCollabLoader"] = $a8b418da1bc27466$export$871388fb833dfa56;

});

parcelRegister("cYoco", function(module, exports) {

let $971ddc0a9a9f0b24$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $971ddc0a9a9f0b24$var$load("4Gdnz"),
    $971ddc0a9a9f0b24$var$load("4UAag"),
    $971ddc0a9a9f0b24$var$load("8o6IC"),
    $971ddc0a9a9f0b24$var$load("4izLy"),
    $971ddc0a9a9f0b24$var$load("5sZTx"),
    $971ddc0a9a9f0b24$var$load("deTdD"),
    $971ddc0a9a9f0b24$var$load("1JeTB"),
    $971ddc0a9a9f0b24$var$load("86OhX"),
    $971ddc0a9a9f0b24$var$load("8d6BA"),
    $971ddc0a9a9f0b24$var$load("el56J"),
    $971ddc0a9a9f0b24$var$load("5zDuS"),
    $971ddc0a9a9f0b24$var$load("hh642"),
    $971ddc0a9a9f0b24$var$load("Jyh1v"),
    $971ddc0a9a9f0b24$var$load("l9Ivm"),
    $971ddc0a9a9f0b24$var$load("7sjI9"),
    $971ddc0a9a9f0b24$var$load("02yT2"),
    $971ddc0a9a9f0b24$var$load("excC5"),
    $971ddc0a9a9f0b24$var$load("hhss7"),
    $971ddc0a9a9f0b24$var$load("btqFK")
]).then(()=>parcelRequire('03pNx'));

});

parcelRegister("8Hqv7", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7koGn = parcelRequire("7koGn");

const $6f5a0d3cf76b2edb$export$c4004a2b66cea884 = 'ssr-app/render/render-full-cycle';
function $6f5a0d3cf76b2edb$var$createFullCycleRenderRegistry() {
    const registry = new Set();
    function register(callback) {
        registry.add(callback);
    }
    function unregister(callback) {
        registry.delete(callback);
    }
    function notifyRenderComplete() {
        registry.forEach((callback)=>callback());
    }
    return {
        register: register,
        unregister: unregister,
        notifyRenderComplete: notifyRenderComplete
    };
}
const $6f5a0d3cf76b2edb$export$b5e41f7d0cd23eac = $6f5a0d3cf76b2edb$var$createFullCycleRenderRegistry();
const $6f5a0d3cf76b2edb$export$31f6ed9cad4c2da0 = ({ name: name, children: children })=>{
    const fullCycleSSRState = window.__FULLCYCLE_SSR__;
    const containerRef = (0, $cozmU.useRef)(null);
    const onFullCycleRenderComplete = (0, $cozmU.useCallback)(()=>{
        if (containerRef.current && fullCycleSSRState) {
            const html = (0, $7koGn.sanitizeInputLoadablesForSSR)(containerRef.current.innerHTML);
            fullCycleSSRState.htmlOutput[name] = html;
        }
    }, [
        name,
        fullCycleSSRState
    ]);
    (0, $cozmU.useEffect)(()=>{
        $6f5a0d3cf76b2edb$export$b5e41f7d0cd23eac.register(onFullCycleRenderComplete);
        return ()=>$6f5a0d3cf76b2edb$export$b5e41f7d0cd23eac.unregister(onFullCycleRenderComplete);
    }, [
        onFullCycleRenderComplete
    ]);
    return null;
};
const $6f5a0d3cf76b2edb$export$f81c4bd5356d97f8 = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-test-id": "fullCycleOutput"
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
module.exports["FullCycleRender"] = $6f5a0d3cf76b2edb$export$31f6ed9cad4c2da0;
module.exports["FullCycleRenderWrapper"] = $6f5a0d3cf76b2edb$export$f81c4bd5356d97f8;

});

parcelRegister("7koGn", function(module, exports) {
const $a4af1bafcd952bf9$var$MARKER_REGEX = /<input(?:\s?type="hidden")? data-loadable-(begin|end)="([^"]*)"(?:\sdata-ssr-placeholder-id="([^"]*)")?(?:\sdata-debug-name="([^"]*)")?\s*?(?:\s?type="hidden")?\s*>(?!\s*<\/input>)/g;
function $a4af1bafcd952bf9$export$7400f7b8afb970c2(html) {
    return html.replace($a4af1bafcd952bf9$var$MARKER_REGEX, (inputTag)=>{
        return `${inputTag.slice(0, -1)} />`;
    });
}
module.exports["sanitizeInputLoadablesForSSR"] = $a4af1bafcd952bf9$export$7400f7b8afb970c2;

});

parcelRegister("6gETM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");

const $5ed14ae7f856df1d$export$204c1449657d49fd = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
const $5ed14ae7f856df1d$export$ae764d691d5f37c6 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "3loHF",
    name: "TreeRootForServerPlaceholder",
    loader: async ()=>$5ed14ae7f856df1d$export$204c1449657d49fd,
    _reactTreeRootForServerPlaceholderId: true
});
const $5ed14ae7f856df1d$export$4279728e9b12d235 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5ed14ae7f856df1d$export$ae764d691d5f37c6, null, children);
};
module.exports["TreeRootForServerPlaceholderWrapper"] = $5ed14ae7f856df1d$export$4279728e9b12d235;

});

parcelRegister("8jRXE", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");




const $ba942ead23497767$export$d49c8c8cf1b10f7e = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ynpC3",
    name: "FullPageEditorLoader",
    loader: async ()=>{
        if (!(0, $9wGTI.fg)('rovo_chat_fix_confluence_chunk_loading')) {
            const { FullPageEditorComponent: FullPageEditorComponent } = await (parcelRequire("7jpId"));
            return FullPageEditorComponent;
        }
        // Fetch the outer editor chunk AND the AI-mate @atlassian/conversation-
        // assistant chunk in parallel. Both `import()` calls live inside this
        // LoadablePaint object expression, so LoadableMetaBabelPlugin tags them
        // BOTH with this loadable's id — which causes parcel-reporter-loadable
        // to union both bundle groups into preloadAssets for this loadable.
        // Without the second `import()`, the register chunk that owns modules
        // like platform/…/atlassian-project-status-update-action-renderer/main.tsx
        // (module id 'iuVKP' on CDN / '2xPvv' locally) is not in this
        // loadable's chunk set, and the runtime throws
        //   `Cannot find module 'iuVKP'`
        // when FullPageEditorComponent's compiled
        //   `.then(() => parcelRequire('iuVKP'))` fires.
        const [outer] = await Promise.all([
            (parcelRequire("7jpId")),
            // eslint-disable-next-line import/dynamic-import-chunkname
            (parcelRequire("7t3um"))
        ]);
        return outer.FullPageEditorComponent;
    }
});
module.exports["FullPageEditorLoader"] = $ba942ead23497767$export$d49c8c8cf1b10f7e;

});

parcelRegister("7jpId", function(module, exports) {

let $552e40abfe1d4a15$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $552e40abfe1d4a15$var$load("i2NNN"),
    $552e40abfe1d4a15$var$load("4g6rd"),
    $552e40abfe1d4a15$var$load("lya9W"),
    $552e40abfe1d4a15$var$load("kT6dz"),
    $552e40abfe1d4a15$var$load("cxCk7"),
    $552e40abfe1d4a15$var$load("ce05o"),
    $552e40abfe1d4a15$var$load("hUbK8"),
    $552e40abfe1d4a15$var$load("6wr18"),
    $552e40abfe1d4a15$var$load("8dxGd"),
    $552e40abfe1d4a15$var$load("3pUic"),
    $552e40abfe1d4a15$var$load("3fdX4"),
    $552e40abfe1d4a15$var$load("2F69B"),
    $552e40abfe1d4a15$var$load("iGGuG"),
    $552e40abfe1d4a15$var$load("hRENL"),
    $552e40abfe1d4a15$var$load("dBFMy"),
    $552e40abfe1d4a15$var$load("9q6b6"),
    $552e40abfe1d4a15$var$load("b0ARW"),
    $552e40abfe1d4a15$var$load("fNwGw"),
    $552e40abfe1d4a15$var$load("i7mZp"),
    $552e40abfe1d4a15$var$load("c9Px9"),
    $552e40abfe1d4a15$var$load("3Xf9v"),
    $552e40abfe1d4a15$var$load("4xGtR"),
    $552e40abfe1d4a15$var$load("iy7LF"),
    $552e40abfe1d4a15$var$load("bSWYL"),
    $552e40abfe1d4a15$var$load("fgnsT"),
    $552e40abfe1d4a15$var$load("4dKZ4"),
    $552e40abfe1d4a15$var$load("aGpvE"),
    $552e40abfe1d4a15$var$load("fqrmE"),
    $552e40abfe1d4a15$var$load("7SteV"),
    $552e40abfe1d4a15$var$load("17OeC"),
    $552e40abfe1d4a15$var$load("5J0xW"),
    $552e40abfe1d4a15$var$load("Nnc5n"),
    $552e40abfe1d4a15$var$load("gd133"),
    $552e40abfe1d4a15$var$load("eNgZ8"),
    $552e40abfe1d4a15$var$load("lAHCT"),
    $552e40abfe1d4a15$var$load("a9LoI"),
    $552e40abfe1d4a15$var$load("8MaGw"),
    $552e40abfe1d4a15$var$load("dxcsb"),
    $552e40abfe1d4a15$var$load("eMRD3"),
    $552e40abfe1d4a15$var$load("jisiR"),
    $552e40abfe1d4a15$var$load("icVON"),
    $552e40abfe1d4a15$var$load("c7nj5"),
    $552e40abfe1d4a15$var$load("1yIye"),
    $552e40abfe1d4a15$var$load("bPC3R"),
    $552e40abfe1d4a15$var$load("bHb1X"),
    $552e40abfe1d4a15$var$load("90SZm"),
    $552e40abfe1d4a15$var$load("crfrC"),
    $552e40abfe1d4a15$var$load("iTOzX"),
    $552e40abfe1d4a15$var$load("ipkwd"),
    $552e40abfe1d4a15$var$load("ffEVr"),
    $552e40abfe1d4a15$var$load("4Gdnz"),
    $552e40abfe1d4a15$var$load("4UAag"),
    $552e40abfe1d4a15$var$load("zUKwV"),
    $552e40abfe1d4a15$var$load("fUeur"),
    $552e40abfe1d4a15$var$load("Wowvf"),
    $552e40abfe1d4a15$var$load("fq1gG"),
    $552e40abfe1d4a15$var$load("j0mEJ"),
    $552e40abfe1d4a15$var$load("cRrl7"),
    $552e40abfe1d4a15$var$load("5sZTx"),
    $552e40abfe1d4a15$var$load("deTdD"),
    $552e40abfe1d4a15$var$load("1JeTB"),
    $552e40abfe1d4a15$var$load("hhss7"),
    $552e40abfe1d4a15$var$load("cWL7t"),
    $552e40abfe1d4a15$var$load("gbJtu"),
    $552e40abfe1d4a15$var$load("7EorR"),
    $552e40abfe1d4a15$var$load("7x00I")
]).then(()=>parcelRequire('h1Y8a'));

});

parcelRegister("34NZw", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d52b69b4dbbb4bb4$export$e6747c633274762a = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "UL-jW",
    name: "PageShownPublicLinksEventLoader",
    loader: async ()=>{
        const { PageShownPublicLinksEvent: PageShownPublicLinksEvent } = await (parcelRequire("6Endl"));
        return PageShownPublicLinksEvent;
    }
});
module.exports["PageShownPublicLinksEventLoader"] = $d52b69b4dbbb4bb4$export$e6747c633274762a;

});

parcelRegister("6Endl", function(module, exports) {

let $4d787c5c8e7aefc1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4d787c5c8e7aefc1$var$load("bRqDI"),
    $4d787c5c8e7aefc1$var$load("63zHi")
]).then(()=>parcelRequire('jvel0'));

});

parcelRegister("cZa7r", function(module, exports) {

var $9HkI0 = parcelRequire("9HkI0");


var $cozmU = parcelRequire("cozmU");


var $cz6eP = parcelRequire("cz6eP");


var $fJCU9 = parcelRequire("fJCU9");


var $epbW8 = parcelRequire("epbW8");


var $afGoD = parcelRequire("afGoD");


var $9QIM2 = parcelRequire("9QIM2");


var $gczDe = parcelRequire("gczDe");


var $4EKKB = parcelRequire("4EKKB");


var $3YBks = parcelRequire("3YBks");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $8WQTF = parcelRequire("8WQTF");

const $d99a6317060f344e$export$4162754b616020bc = 2000;
const $d99a6317060f344e$export$a428e87cc7038c56 = 3500;
const $d99a6317060f344e$export$39085f26fb4d6afa = /*#__PURE__*/ (0, $cozmU.createContext)({
    selectionProps: null,
    hoverProps: null,
    viewProps: null,
    editorCreateProps: null,
    editorViewProps: null,
    showCreateComponent: false,
    showHighlightActions: false,
    selectionOptions: undefined,
    stepGenerationError: false,
    newlyCreatedAnnotationId: undefined,
    commentSidebarContext: null,
    isOffline: false,
    storedCommentData: null
});
$d99a6317060f344e$export$39085f26fb4d6afa.displayName = 'AnnotationsContext';
const $d99a6317060f344e$export$57d1b2fe9544d93c = /*#__PURE__*/ (0, $cozmU.createContext)(false);
$d99a6317060f344e$export$57d1b2fe9544d93c.displayName = 'AnnotationsOfflineContext';
const $d99a6317060f344e$export$6e641cb791644965 = /*#__PURE__*/ (0, $cozmU.createContext)({
    requestCloseEditorComment: ()=>Promise.resolve(true),
    setEditorCommentCloseGuard: ()=>{},
    setSelectionProps: ()=>{},
    setHoverProps: ()=>{},
    setViewProps: ()=>{},
    setEditorCreateProps: ()=>{},
    setEditorViewProps: ()=>{},
    setShowCreateComponent: ()=>{},
    setShowHighlightActions: ()=>{},
    setSelectionOptions: ()=>{},
    setStepGenerationError: ()=>{},
    setSelectionOptionsForCreateEditor: ()=>{},
    setNewlyCreatedAnnotationId: ()=>{},
    setCommentSidebarContext: ()=>{},
    handleSaveSuccess: ()=>{},
    handleClose: ()=>{},
    setIsOffline: ()=>{},
    setStoredCommentData: ()=>{},
    clearStoredCommentData: ()=>{},
    waitForAnnotationElementAndEmit: ()=>{},
    applyDraftModeRef: {
        current: null
    }
});
$d99a6317060f344e$export$6e641cb791644965.displayName = 'AnnotationDispatchContext';
const $d99a6317060f344e$export$567c82ef93e7d5a1 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
$d99a6317060f344e$export$567c82ef93e7d5a1.displayName = 'AnnotationManagerContext';
const $d99a6317060f344e$export$22e6290b4a8e41d3 = ({ children: children })=>{
    const editorCommentCloseGuardRef = (0, $cozmU.useRef)(()=>Promise.resolve(true));
    const setEditorCommentCloseGuard = (0, $cozmU.useCallback)((guard)=>{
        editorCommentCloseGuardRef.current = guard;
    }, []);
    const [selectionProps, setSelectionProps] = (0, $cozmU.useState)(null);
    const selectionPropsRef = (0, $cozmU.useRef)(null);
    /** Stable ref to applyDraftMode — never cleared, so nudge click can call it synchronously
   *  without waiting for the 100ms selectionchange debounce. */ const applyDraftModeRef = (0, $cozmU.useRef)(null);
    // Keep refs in sync with state — useEffect so it never runs during render
    (0, $cozmU.useEffect)(()=>{
        selectionPropsRef.current = selectionProps;
        if (selectionProps?.applyDraftMode) applyDraftModeRef.current = selectionProps.applyDraftMode;
    }, [
        selectionProps
    ]);
    const [hoverProps, setHoverProps] = (0, $cozmU.useState)(null);
    const [viewProps, setViewProps] = (0, $cozmU.useState)(null);
    const [editorCreateProps, setEditorCreateProps] = (0, $cozmU.useState)(null);
    const [editorViewProps, setEditorViewProps] = (0, $cozmU.useState)(null);
    const editorCreatePropsRef = (0, $cozmU.useRef)(null);
    editorCreatePropsRef.current = editorCreateProps;
    const requestCloseEditorComment = (0, $cozmU.useCallback)(async ()=>{
        const editorCreatePropsAtRequest = editorCreatePropsRef.current;
        const canClose = await editorCommentCloseGuardRef.current();
        if (!canClose) return false;
        if (editorCreatePropsAtRequest) {
            if (!editorCreatePropsAtRequest.onClose) return false;
            editorCreatePropsAtRequest.onClose();
        } else setEditorViewProps(null);
        return true;
    }, []);
    const [showCreateComponent, setShowCreateComponent] = (0, $cozmU.useState)(false);
    const [showHighlightActions, setShowHighlightActions] = (0, $cozmU.useState)(false);
    const [selectionOptions, setSelectionOptions] = (0, $cozmU.useState)();
    const [stepGenerationError, setStepGenerationError] = (0, $cozmU.useState)(false);
    const [newlyCreatedAnnotationId, setNewlyCreatedAnnotationId] = (0, $cozmU.useState)();
    const [commentSidebarContext, setCommentSidebarContext] = (0, $cozmU.useState)(null);
    const [prevContentId, setPrevContentId] = (0, $cozmU.useState)(null);
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const annotationManager = (0, $cozmU.useMemo)(()=>(0, $9wGTI.fg)('platform_editor_comments_api_manager') ? (0, $cz6eP.createAnnotationManager)() : undefined, []);
    // This is effectively used with editorCreateProps and editorViewProps but we're tracking it independently as it doesn't really tie into the same lifecycle events
    const [isOffline, setIsOffline] = (0, $cozmU.useState)(false);
    // Stored comment data for direct data flow
    const [storedCommentData, setStoredCommentData] = (0, $cozmU.useState)(null);
    // Track active MutationObserver and timeout for cleanup on unmount
    const activeObserverRef = (0, $cozmU.useRef)(null);
    const activeTimeoutRef = (0, $cozmU.useRef)(null);
    /**
   * Waits for an annotation element to appear in the DOM using MutationObserver,
   * then emits annotation selection events. If element doesn't appear within the wait
   * timeout, fails the VIEW_INLINE_COMMENT_EXPERIENCE.
   */ const waitForAnnotationElementAndEmit = (0, $cozmU.useCallback)((annotationId, emitter)=>{
        const waitTimeoutMs = (0, $6mKj3.expValEquals)('cc_comments_fix_annotation_element_timeout', 'isEnabled', true) ? $d99a6317060f344e$export$a428e87cc7038c56 : $d99a6317060f344e$export$4162754b616020bc;
        // Clean up any existing observer/timeout before creating new ones
        if (activeObserverRef.current) activeObserverRef.current.disconnect();
        if (activeTimeoutRef.current) clearTimeout(activeTimeoutRef.current);
        // Use MutationObserver to wait for element to appear in DOM
        activeObserverRef.current = new MutationObserver(()=>{
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const element = document.getElementById(annotationId);
            if (element) {
                if (activeObserverRef.current) activeObserverRef.current.disconnect();
                if (activeTimeoutRef.current) clearTimeout(activeTimeoutRef.current);
                activeObserverRef.current = null;
                activeTimeoutRef.current = null;
                // Emit annotation events and check if listeners exist
                if (emitter.emit((0, $fJCU9.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                    annotationIds: [
                        annotationId
                    ],
                    eventTarget: element
                })) {
                    emitter.emit((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                        annotationId: annotationId
                    });
                    setNewlyCreatedAnnotationId(annotationId);
                } else // No listeners registered - fail the experience
                experienceTracker.fail({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    error: new Error('Failed to emit annotation click')
                });
            }
        });
        // Observe the renderer wrapper for child additions (fallback to document.body for safety)
        const rendererWrapper = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.querySelector('#content .ak-renderer-wrapper') || document.body;
        activeObserverRef.current.observe(rendererWrapper, {
            childList: true,
            subtree: true
        });
        // Fallback: If element doesn't appear within timeout, fail the experience
        // This almost always happens due to super slow re-renders (slow client on large page)
        activeTimeoutRef.current = setTimeout(()=>{
            if (activeObserverRef.current) activeObserverRef.current.disconnect();
            activeObserverRef.current = null;
            activeTimeoutRef.current = null;
            experienceTracker.fail({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                error: new Error(`Annotation element not found in DOM after ${waitTimeoutMs}ms`)
            });
        }, waitTimeoutMs);
    }, [
        experienceTracker,
        setNewlyCreatedAnnotationId
    ]);
    // Cleanup observer and timeout on unmount
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (activeObserverRef.current) {
                activeObserverRef.current.disconnect();
                activeObserverRef.current = null;
            }
            if (activeTimeoutRef.current) {
                clearTimeout(activeTimeoutRef.current);
                activeTimeoutRef.current = null;
            }
        };
    }, []);
    // Get rendererActions for renderer mode (always call hook, but only use when feature gate is enabled)
    const rendererActionsHook = (0, $8WQTF.useRendererActions)();
    const rendererActions = rendererActionsHook?.rendererActions;
    (0, $cozmU.useEffect)(()=>{
        const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
        function handleAnnotationFocus({ annotationId: annotationId }) {
            // The fact annotations is an array here is meaningless at this time - Confluence
            // always picks the top annotation
            const focusedAnnotation = annotationId;
            if (!focusedAnnotation) {
                // If there is no running experience -- then this is a noop.
                (0, $4EKKB.selectInlineComment).debug('Renderer emitted event indicating no focused annotation.');
                return;
            }
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.complete({
                pageClass: pageClass,
                entryPoint: 'unknown:RendererFocus',
                annotationId: focusedAnnotation
            });
        }
        // Fired when an annotation is focused (ie. comment navigation, comment click)
        emitter.on((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, handleAnnotationFocus);
        return ()=>{
            emitter.off((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, handleAnnotationFocus);
        };
    }, [
        pageClass
    ]);
    const resetProviderState = (0, $cozmU.useCallback)(()=>{
        setSelectionProps(null);
        setHoverProps(null);
        setViewProps(null);
        setEditorCreateProps(null);
        setEditorViewProps(null);
        setShowCreateComponent(false);
        setShowHighlightActions(false);
        setSelectionOptions(undefined);
        setStepGenerationError(false);
        setNewlyCreatedAnnotationId(undefined);
        setCommentSidebarContext(null);
        setStoredCommentData(null);
    }, []);
    // When the content ID changes, reset the provider state
    (0, $cozmU.useEffect)(()=>{
        if (!contentId) return;
        if (prevContentId && contentId !== prevContentId) {
            resetProviderState();
            // Deselect any currently selected annotations
            (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
        }
        setPrevContentId(contentId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    // Stable ref for selectionOptions — updated synchronously alongside every setSelectionOptions call
    // so handleSaveSuccess always reads the latest step even when its useCallback closure is stale.
    const selectionOptionsRef = (0, $cozmU.useRef)(undefined);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        setShowCreateComponent(false);
        setStepGenerationError(false);
        if ((0, $6mKj3.expVal)('confluence_inline_comments_fix_stale_selection', 'isEnabled', false)) selectionOptionsRef.current = undefined;
        setSelectionOptions(undefined);
        if (annotationManager) annotationManager.clearDraft();
        else selectionProps && selectionProps.onClose();
        setSelectionProps(null);
    }, [
        setShowCreateComponent,
        setStepGenerationError,
        setSelectionOptions,
        selectionProps,
        annotationManager
    ]);
    /*
   * NOTE: This function will not be calling setShowCreateComponent because it's
   *       consumers will not be refreshing themselves with new selectionOptions.
   *       It will now be the responsibility of the consumers of this function to call
   *       setShowCreateComponent(true). See SelectionComponent.tsx (~line 132)
   */ const setSelectionOptionsForCreateEditor = (0, $cozmU.useCallback)(({ experienceAttributes: experienceAttributes } = {})=>{
        setShowCreateComponent(false); // Hide an existing create component if it exists
        const annotationId = (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
        // Narrow pageClass to 'renderer' | 'editor' for the experience attributes
        const pageClassAttr = pageClass === 'renderer' ? 'renderer' : 'editor';
        (0, $3YBks.createInlineCommentCompoundExperience).start({
            attributes: {
                pageClass: pageClassAttr,
                commentType: 'inline',
                annotationId: annotationId,
                ...experienceAttributes
            }
        });
        (0, $3YBks.createInlineCommentCompoundExperience).initExperience.start();
        let result = undefined;
        if (annotationManager) {
            const startDraftResult = annotationManager.startDraft();
            if (startDraftResult.success) result = startDraftResult.actionResult;
        } else {
            /* selectionPropsRef fallback: selectionProps (React state) may be null immediately
         after a sidebar close due to a render-cycle gap, while the ref holds the last-known
         value. Prefer the ref (updated synchronously) so nudge click always gets the freshest
         value. For experiment-OFF callers, selectionProps is non-null so ref vs state is moot. */ const currentSelectionProps = selectionPropsRef.current ?? selectionProps;
            if (!currentSelectionProps) {
                // selectionProps is not defined. This may occur if a comment sidebar box was just closed, which
                // unsets selectionProps. In this case, we treat this as no-op, and unselect any annotation.
                (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
                // We soft-fail create-inline-comment/init experience here to track how often this occurs.
                (0, $3YBks.createInlineCommentCompoundExperience).initExperience.softFail(new Error('Attempted to create inline comment when no selection was present'));
                return;
            }
            // Reset ref before applyDraftMode so handleSaveSuccess reads the fresh step (COMMENTS-6594).
            if ((0, $6mKj3.expVal)('confluence_inline_comments_fix_stale_selection', 'isEnabled', false)) selectionOptionsRef.current = undefined;
            result = currentSelectionProps.applyDraftMode({
                annotationId: annotationId,
                keepNativeSelection: false
            });
        }
        const ancestorNodeTypes = result?.ancestorNodeTypes ?? [];
        const alphabeticalAncestorNodeTypes = [
            ...ancestorNodeTypes
        ].sort();
        (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
            inlineNodeTypes: result?.inlineNodeTypes ?? [],
            ancestorNodeTypes: ancestorNodeTypes,
            alphabeticalAncestorNodeTypes: alphabeticalAncestorNodeTypes,
            // @ts-ignore
            initialPosition: [
                result?.step?.from,
                result?.step?.to
            ]
        });
        if (result) {
            const newSelectionOptions = {
                step: result.step,
                inlineNodeTypes: result.inlineNodeTypes,
                originalSelection: result.originalSelection,
                numMatches: result.numMatches,
                matchIndex: result.matchIndex,
                createdFrom: (0, $afGoD.CommentCreationLocation).RENDERER,
                pos: result.pos,
                targetNodeType: result.targetNodeType
            };
            // Update ref synchronously BEFORE setSelectionOptions so handleSaveSuccess
            // always reads the latest step even if its closure captured a stale value.
            selectionOptionsRef.current = newSelectionOptions;
            setSelectionOptions(newSelectionOptions);
            // Tell the renderer to close any currently-open comments
            (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            setShowHighlightActions(false);
        } else {
            setStepGenerationError(true);
            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.fail(new Error('Failed to generate step'));
        }
    }, [
        selectionProps,
        setShowCreateComponent,
        setShowHighlightActions,
        setStepGenerationError,
        annotationManager,
        pageClass
    ]);
    const handleSaveSuccess = (0, $cozmU.useCallback)((annotationId, commentData)=>{
        setStepGenerationError(false);
        setCommentSidebarContext('create');
        // Set stored comment data for direct data flow when experiment is enabled
        if (commentData) setStoredCommentData(commentData);
        let result = false;
        if (annotationManager) {
            const result = annotationManager.applyDraft(annotationId);
            if (result.success && !!result.actionResult?.doc) {
                selectionProps.updateDocument && selectionProps.updateDocument(result.actionResult.doc);
                setNewlyCreatedAnnotationId(annotationId);
            } else throw new Error('Error ocurred when applying the step to the active document');
        } else {
            // When the experiment is on, read from ref to get the latest selectionOptions regardless of
            // closure staleness — the create panel may hold an old handleSaveSuccess reference from before
            // setSelectionOptions was called for the new selection, causing the stale step to be used.
            const currentSelectionOptions = selectionOptions && (0, $6mKj3.expVal)('confluence_inline_comments_fix_stale_selection', 'isEnabled', false) ? selectionOptionsRef.current ?? selectionOptions : selectionOptions;
            // Renderer mode: Try using rendererActions.applyAnnotation() first (similar to editor's annotationManager.applyDraft())
            // This provides more reliable annotation application, matching the editor implementation
            if (rendererActions && currentSelectionOptions?.step) {
                const step = currentSelectionOptions.step;
                // Extract position from step - use pos if available, otherwise use from/to
                const position = currentSelectionOptions.pos ? {
                    to: currentSelectionOptions.pos,
                    from: currentSelectionOptions.pos
                } : {
                    to: step.to,
                    from: step.from
                };
                const annotationResult = rendererActions.applyAnnotation(position, {
                    annotationId: annotationId,
                    annotationType: (0, $epbW8.AnnotationTypes).INLINE_COMMENT
                });
                if (annotationResult && annotationResult.doc) {
                    const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                    if (!storedCommentData) selectionProps.removeDraftMode();
                    selectionProps.updateDocument && selectionProps.updateDocument(annotationResult.doc);
                    waitForAnnotationElementAndEmit(annotationId, emitter);
                } else throw new Error('Error ocurred when applying the step to the active document');
            } else {
                // Fallback to original onCreate method
                // Since we generated the uuid ourselves, we need to replace the document generated with
                // the annotationId that we received from the backend so things line up correctly
                result = selectionProps.onCreate(annotationId);
                if (result) {
                    const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                    if (!storedCommentData) selectionProps.removeDraftMode();
                    selectionProps.updateDocument && selectionProps.updateDocument(result.doc);
                    waitForAnnotationElementAndEmit(annotationId, emitter);
                } else throw new Error('Error ocurred when applying the step to the active document');
            }
        }
    }, [
        annotationManager,
        setStepGenerationError,
        setNewlyCreatedAnnotationId,
        selectionProps,
        setStoredCommentData,
        storedCommentData,
        rendererActions,
        selectionOptions,
        waitForAnnotationElementAndEmit
    ]);
    const providerValue = (0, $cozmU.useMemo)(()=>({
            selectionProps: selectionProps,
            hoverProps: hoverProps,
            viewProps: viewProps,
            editorCreateProps: editorCreateProps,
            editorViewProps: editorViewProps,
            showCreateComponent: showCreateComponent,
            showHighlightActions: showHighlightActions,
            selectionOptions: selectionOptions,
            stepGenerationError: stepGenerationError,
            newlyCreatedAnnotationId: newlyCreatedAnnotationId,
            commentSidebarContext: commentSidebarContext,
            isOffline: isOffline,
            storedCommentData: storedCommentData
        }), [
        selectionProps,
        hoverProps,
        viewProps,
        editorCreateProps,
        editorViewProps,
        showCreateComponent,
        showHighlightActions,
        selectionOptions,
        stepGenerationError,
        newlyCreatedAnnotationId,
        commentSidebarContext,
        isOffline,
        storedCommentData
    ]);
    const dispatchProviderValue = (0, $cozmU.useMemo)(()=>({
            requestCloseEditorComment: requestCloseEditorComment,
            setEditorCommentCloseGuard: setEditorCommentCloseGuard,
            setSelectionProps: setSelectionProps,
            setHoverProps: setHoverProps,
            setViewProps: setViewProps,
            setEditorCreateProps: setEditorCreateProps,
            setEditorViewProps: setEditorViewProps,
            setShowCreateComponent: setShowCreateComponent,
            setShowHighlightActions: setShowHighlightActions,
            setSelectionOptions: setSelectionOptions,
            setStepGenerationError: setStepGenerationError,
            setSelectionOptionsForCreateEditor: setSelectionOptionsForCreateEditor,
            setNewlyCreatedAnnotationId: setNewlyCreatedAnnotationId,
            setCommentSidebarContext: setCommentSidebarContext,
            handleSaveSuccess: handleSaveSuccess,
            handleClose: handleClose,
            setIsOffline: setIsOffline,
            // Stored comment data management functions
            setStoredCommentData: (commentData)=>setStoredCommentData(commentData ?? null),
            clearStoredCommentData: ()=>setStoredCommentData(null),
            waitForAnnotationElementAndEmit: waitForAnnotationElementAndEmit,
            applyDraftModeRef: applyDraftModeRef
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        requestCloseEditorComment,
        setEditorCommentCloseGuard,
        setSelectionProps,
        setHoverProps,
        setViewProps,
        setEditorCreateProps,
        setEditorViewProps,
        setShowCreateComponent,
        setShowHighlightActions,
        setSelectionOptions,
        setStepGenerationError,
        setSelectionOptionsForCreateEditor,
        setNewlyCreatedAnnotationId,
        setCommentSidebarContext,
        handleSaveSuccess,
        handleClose,
        setIsOffline,
        // Stored comment data management functions
        setStoredCommentData,
        waitForAnnotationElementAndEmit
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d99a6317060f344e$export$567c82ef93e7d5a1.Provider, {
        value: annotationManager
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d99a6317060f344e$export$39085f26fb4d6afa.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d99a6317060f344e$export$6e641cb791644965.Provider, {
        value: dispatchProviderValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d99a6317060f344e$export$57d1b2fe9544d93c.Provider, {
        value: isOffline
    }, children))));
};
const $d99a6317060f344e$export$ede9be424e8ef89a = ()=>{
    return (0, $cozmU.useContext)($d99a6317060f344e$export$39085f26fb4d6afa);
};
const $d99a6317060f344e$export$3be336e5c3e78567 = ()=>{
    return (0, $cozmU.useContext)($d99a6317060f344e$export$6e641cb791644965);
};
const $d99a6317060f344e$export$3998d49469d13f97 = ()=>{
    return (0, $cozmU.useContext)($d99a6317060f344e$export$567c82ef93e7d5a1);
};
const $d99a6317060f344e$export$3757730e05e42ee2 = ()=>{
    return (0, $cozmU.useContext)($d99a6317060f344e$export$57d1b2fe9544d93c);
};
module.exports["AnnotationsProvider"] = $d99a6317060f344e$export$22e6290b4a8e41d3;
module.exports["useAnnotations"] = $d99a6317060f344e$export$ede9be424e8ef89a;
module.exports["useAnnotationsDispatch"] = $d99a6317060f344e$export$3be336e5c3e78567;
module.exports["useAnnotationManager"] = $d99a6317060f344e$export$3998d49469d13f97;
module.exports["useAnnotationsIsOffline"] = $d99a6317060f344e$export$3757730e05e42ee2;

});

parcelRegister("afGoD", function(module, exports) {
/**
 * @generated SignedSource<<71be4194137313c8ff0872a3df259dda>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $f8b43d46712cd783$export$cdccd0683766be81 = /*#__PURE__*/ function(CommentCreationLocation) {
    CommentCreationLocation["DATABASE"] = "DATABASE";
    CommentCreationLocation["EDITOR"] = "EDITOR";
    CommentCreationLocation["LIVE"] = "LIVE";
    CommentCreationLocation["RENDERER"] = "RENDERER";
    CommentCreationLocation["WHITEBOARD"] = "WHITEBOARD";
    return CommentCreationLocation;
}({});
var $f8b43d46712cd783$export$f4016897b165b6d5 = /*#__PURE__*/ function(ContentRepresentation) {
    ContentRepresentation["ATLAS_DOC_FORMAT"] = "ATLAS_DOC_FORMAT";
    ContentRepresentation["EDITOR"] = "EDITOR";
    ContentRepresentation["EDITOR2"] = "EDITOR2";
    ContentRepresentation["EXPORT_VIEW"] = "EXPORT_VIEW";
    ContentRepresentation["PLAIN"] = "PLAIN";
    ContentRepresentation["RAW"] = "RAW";
    ContentRepresentation["STORAGE"] = "STORAGE";
    ContentRepresentation["STYLED_VIEW"] = "STYLED_VIEW";
    ContentRepresentation["VIEW"] = "VIEW";
    ContentRepresentation["WIKI"] = "WIKI";
    return ContentRepresentation;
}({});
var $f8b43d46712cd783$export$2dffd0b5373a4389 = /*#__PURE__*/ function(Platform) {
    Platform["ANDROID"] = "ANDROID";
    Platform["IOS"] = "IOS";
    Platform["WEB"] = "WEB";
    return Platform;
}({});
var $f8b43d46712cd783$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["CommentCreationLocation"] = $f8b43d46712cd783$export$cdccd0683766be81;
module.exports["ContentRepresentation"] = $f8b43d46712cd783$export$f4016897b165b6d5;

});

parcelRegister("9QIM2", function(module, exports) {

var $de2j9 = parcelRequire("de2j9");


var $3jwuS = parcelRequire("3jwuS");


var $dPJCf = parcelRequire("dPJCf");


var $gEtAQ = parcelRequire("gEtAQ");

function $06d23c10422abe2f$export$d9ae12e82c9f2aba() {
    // Note -- this hook does not inform the consumer if they are on a live doc page which
    // is using the editor.
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const isCurrentPageLive = (0, $3jwuS.useIsCurrentPageLive)();
    // useRouteName use RoutesContext which is more reliable than reading window.location.pathname directly.
    const routeName = (0, $dPJCf.useRouteName)({
        selector: (name)=>name
    });
    if (isEditorPage) return 'editor';
    if (isCurrentPageLive) return 'editor';
    const isTinyMCEPage = $06d23c10422abe2f$var$__checkIfTinyMCEEditorPage();
    if (isTinyMCEPage) // TinyMCE pages are not considered editor pages or docs in the context of this hook
    return 'tinyMCE';
    // Pass routeName to isDatabase/isWhiteboard - they will use it to avoid race conditions during SPA transitions
    if ((0, $gEtAQ.isDatabase)(routeName)) return 'database';
    if ((0, $gEtAQ.isWhiteboard)(routeName)) return 'whiteboard';
    if ((0, $gEtAQ.isSlides)(routeName)) return 'slide';
    return 'renderer';
}
function $06d23c10422abe2f$var$__checkIfTinyMCEEditorPage() {
    const possibleTinyMCESelectors = [
        `[data-testid="TinyMCERendererTestId"]`,
        '.tinymce-editor'
    ];
    // This check is only relevant in the context of comment experiences
    // and so if we are in an environment without a document -- we
    // can safely treat it as not a tinymce page.
    if (typeof document === 'undefined') return false;
    const isTinyMCEPage = possibleTinyMCESelectors.some(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    (selector)=>document.querySelector(selector) !== null);
    return isTinyMCEPage;
}
module.exports["usePageClass"] = $06d23c10422abe2f$export$d9ae12e82c9f2aba;

});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name || routeName === (0, $1NBp8.SPACE_SETTINGS_AGENT_CONTEXT).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
};
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("3YBks", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");


var $1A7bE = parcelRequire("1A7bE");

let $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {};
let $3ac00da98b683ca3$var$runningExperiences = [];
// Note: The soft failure is set on the first soft failure not updated following
let $3ac00da98b683ca3$var$softFailure = undefined;
let $3ac00da98b683ca3$var$publishFailed = false;
let $3ac00da98b683ca3$var$publishSuccessCount = 0;
function $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug(experienceName) {
    function createInlineCommentExperienceDebug({ error: error, createAnalyticsEvent: createAnalyticsEvent, extraAttributes: extraAttributes }) {
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        const experienceAttributes = experienceTracker.getExperienceState((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE));
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'error',
                actionSubject: (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE),
                source: experienceName,
                attributes: {
                    ...experienceAttributes,
                    ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes,
                    ...extraAttributes,
                    error: error.message || String(error),
                    stack: error.stack
                }
            }
        }).fire();
    }
    return createInlineCommentExperienceDebug;
}
const $3ac00da98b683ca3$export$90894e50be2305e9 = {
    start: function createInlineCommentCompoundExperience({ attributes: attributes }) {
        // reset common experience state when starting a new parent experience
        $3ac00da98b683ca3$var$runningExperiences = [
            (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE)
        ];
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {};
        $3ac00da98b683ca3$var$softFailure = undefined;
        $3ac00da98b683ca3$var$publishFailed = false;
        $3ac00da98b683ca3$var$publishSuccessCount = 0;
        const compoundTaskId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.start({
            name: (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE),
            id: compoundTaskId,
            attributes: {
                ...attributes,
                compoundTaskId: compoundTaskId
            },
            collect: (events, experience)=>{
                (0, $1A7bE.collectAll)([
                    (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                    (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)
                ])(events, experience);
            }
        });
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {
            compoundTaskId: compoundTaskId,
            annotationId: attributes.annotationId,
            pageClass: attributes.pageClass,
            entryPoint: attributes.entryPoint,
            edition: attributes.edition
        };
    },
    debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE)),
    addCommonAttributes: (commonAttributes)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {
            ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes,
            ...commonAttributes
        };
        for (const runningExperience of $3ac00da98b683ca3$var$runningExperiences)experienceTracker.updateAttributes({
            name: runningExperience,
            attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
        });
    },
    attachCommonAttributes: (experienceName)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.updateAttributes({
            name: experienceName,
            attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
        });
    },
    initExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                timeout: 5000,
                attributes: {
                    ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
                }
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE));
        },
        fail: (error)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                error: error
            });
        },
        softFail: (error)=>{
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'init'
            };
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                attributes: {
                    softFailure: error.message
                }
            });
        },
        abort: ({ abortReason: abortReason, attributes: attributes })=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                reason: abortReason,
                attributes: attributes
            });
        },
        /**
     * This completes the init experience and starts the draft to publish experience.
     */ complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    },
    draftToPublishExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE));
        },
        publishFailed: (error)=>{
            $3ac00da98b683ca3$var$publishFailed = true;
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'publish-failed'
            };
        },
        publishSucceeded: ()=>{
            $3ac00da98b683ca3$var$publishSuccessCount += 1;
        },
        abort: ({ abortReason: abortReason, attributes: attributes })=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                reason: abortReason,
                attributes: attributes
            });
        },
        fail: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        stopOnError: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.stopOnError({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        dismissed: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$publishSuccessCount > 0) experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: new Error('Draft comment dismissed after publish success')
            });
            else if ($3ac00da98b683ca3$var$publishFailed) experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: new Error('Draft comment dismissed after publish attempt')
            });
            else experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                reason: 'Draft comment dismissed'
            });
        },
        softFail: (error)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'multiple-saves-without-error'
            };
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                attributes: {
                    softFailure: error.message
                }
            });
        },
        complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$softFailure) {
                experienceTracker.succeed({
                    name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                    attributes: {
                        softFailure: $3ac00da98b683ca3$var$softFailure.error.message,
                        pointOfFailure: $3ac00da98b683ca3$var$softFailure.pointOfFailure
                    }
                });
                return;
            }
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    },
    attachCommentExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                // If the view comment does not load in 6 seconds, it's
                // an indicator something has gone wrong.
                timeout: 6000,
                attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE));
        },
        fail: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$softFailure) {
                experienceTracker.succeed({
                    name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                    attributes: {
                        softFailure: $3ac00da98b683ca3$var$softFailure.error.message,
                        pointOfFailure: $3ac00da98b683ca3$var$softFailure.pointOfFailure
                    }
                });
                return;
            }
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    }
};
module.exports["createInlineCommentCompoundExperience"] = $3ac00da98b683ca3$export$90894e50be2305e9;

});

parcelRegister("8WQTF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $4677820b18a14e4d$export$66feffbad722f9d4 = /*#__PURE__*/ (0, $cozmU.createContext)({
    rendererActions: null,
    pageId: undefined,
    pageAdf: undefined
});
$4677820b18a14e4d$export$66feffbad722f9d4.displayName = 'RendererActionsContext';
const $4677820b18a14e4d$export$c7c5640cf8aff722 = /*#__PURE__*/ (0, $cozmU.createContext)({
    setRendererActions: ()=>{},
    setPageAdf: ()=>{}
});
$4677820b18a14e4d$export$c7c5640cf8aff722.displayName = 'RendererActionsDispatchContext';
const $4677820b18a14e4d$export$a41bfe8d4028fb59 = ({ children: children })=>{
    const [rendererActions, setRendererActions] = (0, $cozmU.useState)(null);
    const [pageId, setPageId] = (0, $cozmU.useState)(undefined);
    const [pageAdf, setPageAdf] = (0, $cozmU.useState)(undefined);
    const providerValue = (0, $cozmU.useMemo)(()=>({
            rendererActions: rendererActions,
            pageId: pageId,
            pageAdf: pageAdf
        }), [
        rendererActions,
        pageId,
        pageAdf
    ]);
    const dispatchProviderValue = (0, $cozmU.useMemo)(()=>({
            setRendererActions: (actions, newPageId)=>{
                setRendererActions(actions);
                setPageId(newPageId);
            },
            setPageAdf: (newPageAdf)=>{
                setPageAdf(newPageAdf);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4677820b18a14e4d$export$66feffbad722f9d4.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4677820b18a14e4d$export$c7c5640cf8aff722.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $4677820b18a14e4d$export$55249bdd00e8a5d6 = ()=>{
    return (0, $cozmU.useContext)($4677820b18a14e4d$export$66feffbad722f9d4);
};
const $4677820b18a14e4d$export$6e9863dfedeaae60 = ()=>{
    return (0, $cozmU.useContext)($4677820b18a14e4d$export$c7c5640cf8aff722);
};
module.exports["RendererActionsProvider"] = $4677820b18a14e4d$export$a41bfe8d4028fb59;
module.exports["useRendererActions"] = $4677820b18a14e4d$export$55249bdd00e8a5d6;
module.exports["useRendererActionsDispatch"] = $4677820b18a14e4d$export$6e9863dfedeaae60;

});

parcelRegister("aJzDd", function(module, exports) {

let $7d09bf0b8f33d0e4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7d09bf0b8f33d0e4$var$load("2K7Mk"),
    $7d09bf0b8f33d0e4$var$load("fEMSy"),
    $7d09bf0b8f33d0e4$var$load("1lDWJ"),
    $7d09bf0b8f33d0e4$var$load("6wr18"),
    $7d09bf0b8f33d0e4$var$load("6damH"),
    $7d09bf0b8f33d0e4$var$load("bb3WM"),
    $7d09bf0b8f33d0e4$var$load("hEj0j"),
    $7d09bf0b8f33d0e4$var$load("i35vr"),
    $7d09bf0b8f33d0e4$var$load("1GCFv"),
    $7d09bf0b8f33d0e4$var$load("lCkJt"),
    $7d09bf0b8f33d0e4$var$load("32NHR"),
    $7d09bf0b8f33d0e4$var$load("glmO2"),
    $7d09bf0b8f33d0e4$var$load("ffEVr"),
    $7d09bf0b8f33d0e4$var$load("aDjtG")
]).then(()=>parcelRequire('fJXL7'));

});

parcelRegister("hzmgd", function(module, exports) {

let $cca6f90cef71afe1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cca6f90cef71afe1$var$load("6wr18"),
    $cca6f90cef71afe1$var$load("9Q8Ik"),
    $cca6f90cef71afe1$var$load("3FG3M"),
    $cca6f90cef71afe1$var$load("cAbXt"),
    $cca6f90cef71afe1$var$load("irTwo"),
    $cca6f90cef71afe1$var$load("1X4na"),
    $cca6f90cef71afe1$var$load("6XCf4"),
    $cca6f90cef71afe1$var$load("ebvEF"),
    $cca6f90cef71afe1$var$load("4h9Y1"),
    $cca6f90cef71afe1$var$load("w3Gc8"),
    $cca6f90cef71afe1$var$load("6C7Vr"),
    $cca6f90cef71afe1$var$load("aEiTV"),
    $cca6f90cef71afe1$var$load("1qlDN"),
    $cca6f90cef71afe1$var$load("1yVM6"),
    $cca6f90cef71afe1$var$load("ffEVr"),
    $cca6f90cef71afe1$var$load("651dU")
]).then(()=>parcelRequire('gDZU2'));

});

parcelRegister("lt6Lx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $d5RCH = parcelRequire("d5RCH");


var $1ytiN = parcelRequire("1ytiN");


var $gSgn8 = parcelRequire("gSgn8");


var $8vxJi = parcelRequire("8vxJi");

const $5a5ab99dc3af9e56$var$i18n = (0, $kSwu1.defineMessages)({
    notFound: {
        id: "document-title.not.found",
        defaultMessage: "Page Not Found"
    }
});
const $5a5ab99dc3af9e56$export$8f4c40b84dd15d46 = ({ titlePrefix: titlePrefix = '', contentTitle: contentTitle = '', contentSpace: contentSpace = '', siteTitleOnly: siteTitleOnly = false, notFound: notFound = false, isHomePage: isHomePage = false })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { siteTitle: siteTitle } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            window['__DOCUMENT_TITLE_TAG__'] = '';
        };
    }, []);
    // In the case when page is rendered by SSR, the __DOCUMENT_TITLE_TAG__ will be
    // populated and we can skip document title — but only when this render has no
    // meaningful content to contribute. If contentTitle, titlePrefix, notFound,
    // isHomePage, or siteTitleOnly are set, we must still update the title
    // (e.g. relay race: new page renders before old cleanup effect runs).
    if (window['__DOCUMENT_TITLE_TAG__'] && window['__SSR_RENDERED__'] && // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.title && !contentTitle && !titlePrefix && !notFound && !isHomePage && !siteTitleOnly) return null;
    const title = [
        titlePrefix || (notFound ? intl.formatMessage($5a5ab99dc3af9e56$var$i18n.notFound) : ''),
        siteTitleOnly ? undefined : contentTitle,
        siteTitleOnly ? undefined : contentSpace,
        siteTitle
    ].filter((part)=>part).join(' - ');
    // Don't override an existing title with a less specific one (e.g., don't set "Confluence"
    // when there's already a title with content like "Page Title - Space - Confluence").
    // This prevents components with empty contentTitle from overriding titles set by components
    // with actual content during navigation/rendering transitions.
    // Note: This check happens during render, so it may not catch titles set in the same render cycle,
    // but useLayoutEffect in PageTitle ensures the last component to render wins.
    // A title is considered "specific" if it provides either a contentTitle or a titlePrefix.
    // Pages like the advanced search page pass a titlePrefix (e.g. "Search") without a
    // contentTitle, and we must still allow that title to replace the previous page's title
    // during client-side navigation. notFound, isHomePage, and siteTitleOnly are also
    // meaningful signals that must always be allowed to update the title.
    if (typeof document !== 'undefined' && document.title && !contentTitle && !titlePrefix && !notFound && !isHomePage && !siteTitleOnly) {
        // If contentTitle, titlePrefix, notFound, isHomePage, and siteTitleOnly are all empty/false,
        // we're likely setting a generic title (just siteTitle or siteTitle with space).
        // If there's already a more specific title (3+ parts, or 2 parts where first isn't siteTitle), skip.
        const existingTitleParts = document.title.split(' - ');
        const hasMoreSpecificContent = existingTitleParts.length > 2 || existingTitleParts.length === 2 && existingTitleParts[0] !== siteTitle;
        // Skip if we're trying to set a less specific title when a more specific one exists and it is not the home page
        if (hasMoreSpecificContent && title !== document.title) return null;
    }
    // Set for SSR document title
    window['__DOCUMENT_TITLE_TAG__'] = title;
    if (window.__SSR_REACT_STREAMING__) {
        const inject = (0, $gSgn8.getStreamInject)();
        inject(()=>`document.title=${(0, $8vxJi.stringifyForSSR)(title)}`);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5RCH.PageTitle), {
        title: title
    });
};
module.exports["DocumentContentTitle"] = $5a5ab99dc3af9e56$export$8f4c40b84dd15d46;

});

parcelRegister("6ymI6", function(module, exports) {

let $4c5788d3a5793a3d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4c5788d3a5793a3d$var$load("6kXh6"),
    $4c5788d3a5793a3d$var$load("kKNsN")
]).then(()=>parcelRequire('1vSpd'));

});

parcelRegister("9gpO8", function(module, exports) {

let $6be9a08d8a4f29e9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6be9a08d8a4f29e9$var$load("c9Px9"),
    $6be9a08d8a4f29e9$var$load("2mGc6"),
    $6be9a08d8a4f29e9$var$load("cxCk7"),
    $6be9a08d8a4f29e9$var$load("8d6BA"),
    $6be9a08d8a4f29e9$var$load("2K7Mk"),
    $6be9a08d8a4f29e9$var$load("6wr18"),
    $6be9a08d8a4f29e9$var$load("8R7DY"),
    $6be9a08d8a4f29e9$var$load("io60f"),
    $6be9a08d8a4f29e9$var$load("9t4mJ"),
    $6be9a08d8a4f29e9$var$load("h3v7G"),
    $6be9a08d8a4f29e9$var$load("2M3d5"),
    $6be9a08d8a4f29e9$var$load("ejABk"),
    $6be9a08d8a4f29e9$var$load("dkoen"),
    $6be9a08d8a4f29e9$var$load("j5Kob"),
    $6be9a08d8a4f29e9$var$load("flDQJ"),
    $6be9a08d8a4f29e9$var$load("ba41x"),
    $6be9a08d8a4f29e9$var$load("6XCf4"),
    $6be9a08d8a4f29e9$var$load("ebvEF"),
    $6be9a08d8a4f29e9$var$load("hSDwk"),
    $6be9a08d8a4f29e9$var$load("3Rnfs"),
    $6be9a08d8a4f29e9$var$load("2j57H"),
    $6be9a08d8a4f29e9$var$load("ezYRV"),
    $6be9a08d8a4f29e9$var$load("aJFlE"),
    $6be9a08d8a4f29e9$var$load("lIsma"),
    $6be9a08d8a4f29e9$var$load("aoih9"),
    $6be9a08d8a4f29e9$var$load("3evar"),
    $6be9a08d8a4f29e9$var$load("5zDuS"),
    $6be9a08d8a4f29e9$var$load("hh642"),
    $6be9a08d8a4f29e9$var$load("Mp0pM"),
    $6be9a08d8a4f29e9$var$load("agVmZ"),
    $6be9a08d8a4f29e9$var$load("aEiTV"),
    $6be9a08d8a4f29e9$var$load("VXbA1"),
    $6be9a08d8a4f29e9$var$load("1qlDN"),
    $6be9a08d8a4f29e9$var$load("1yVM6"),
    $6be9a08d8a4f29e9$var$load("ffEVr"),
    $6be9a08d8a4f29e9$var$load("lya9W"),
    $6be9a08d8a4f29e9$var$load("gA528"),
    $6be9a08d8a4f29e9$var$load("j6RYV")
]).then(()=>parcelRequire('5y7xd'));

});

parcelRegister("5xPzo", function(module, exports) {

let $409809845ef3606c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $409809845ef3606c$var$load("cxCk7"),
    $409809845ef3606c$var$load("8d6BA"),
    $409809845ef3606c$var$load("3YRzU"),
    $409809845ef3606c$var$load("7k9oy"),
    $409809845ef3606c$var$load("6wr18"),
    $409809845ef3606c$var$load("3ZwzI"),
    $409809845ef3606c$var$load("jxLUH"),
    $409809845ef3606c$var$load("lmRBB"),
    $409809845ef3606c$var$load("hafZt"),
    $409809845ef3606c$var$load("g8ky2"),
    $409809845ef3606c$var$load("hohnS"),
    $409809845ef3606c$var$load("4WTdS"),
    $409809845ef3606c$var$load("8eGGc"),
    $409809845ef3606c$var$load("bWtlo"),
    $409809845ef3606c$var$load("eW2qV"),
    $409809845ef3606c$var$load("2vRcz"),
    $409809845ef3606c$var$load("8X7OO"),
    $409809845ef3606c$var$load("4BjK2"),
    $409809845ef3606c$var$load("i7mZp"),
    $409809845ef3606c$var$load("1b3GG"),
    $409809845ef3606c$var$load("2j57H"),
    $409809845ef3606c$var$load("2mGc6"),
    $409809845ef3606c$var$load("ezYRV"),
    $409809845ef3606c$var$load("Mp0pM"),
    $409809845ef3606c$var$load("lrXQY"),
    $409809845ef3606c$var$load("kQNKW"),
    $409809845ef3606c$var$load("agVmZ"),
    $409809845ef3606c$var$load("dxcsb"),
    $409809845ef3606c$var$load("7EorR"),
    $409809845ef3606c$var$load("jqoep"),
    $409809845ef3606c$var$load("hhss7"),
    $409809845ef3606c$var$load("aEiTV"),
    $409809845ef3606c$var$load("VXbA1"),
    $409809845ef3606c$var$load("1qlDN"),
    $409809845ef3606c$var$load("1yVM6"),
    $409809845ef3606c$var$load("9BBvG"),
    $409809845ef3606c$var$load("zUKwV"),
    $409809845ef3606c$var$load("fUeur"),
    $409809845ef3606c$var$load("cYv6T"),
    $409809845ef3606c$var$load("11yNG"),
    $409809845ef3606c$var$load("gQYVn"),
    $409809845ef3606c$var$load("cpTbC"),
    $409809845ef3606c$var$load("fhT77"),
    $409809845ef3606c$var$load("jvUhP"),
    $409809845ef3606c$var$load("7Ysw6"),
    $409809845ef3606c$var$load("3xL2F"),
    $409809845ef3606c$var$load("kMyku"),
    $409809845ef3606c$var$load("hG1ar"),
    $409809845ef3606c$var$load("jIqhU"),
    $409809845ef3606c$var$load("lya9W"),
    $409809845ef3606c$var$load("ffEVr"),
    $409809845ef3606c$var$load("dkIUD")
]).then(()=>parcelRequire('l2J3i'));

});

parcelRegister("2pjLv", function(module, exports) {

let $1c0d3f8d5bda0538$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1c0d3f8d5bda0538$var$load("9t4mJ"),
    $1c0d3f8d5bda0538$var$load("3yj2i"),
    $1c0d3f8d5bda0538$var$load("izROg"),
    $1c0d3f8d5bda0538$var$load("4fYzp"),
    $1c0d3f8d5bda0538$var$load("4Ve5N"),
    $1c0d3f8d5bda0538$var$load("7Y0AX"),
    $1c0d3f8d5bda0538$var$load("1GCFv"),
    $1c0d3f8d5bda0538$var$load("7EorR"),
    $1c0d3f8d5bda0538$var$load("jqoep"),
    $1c0d3f8d5bda0538$var$load("aRnD4")
]).then(()=>parcelRequire('fgp6d'));

});

parcelRegister("aTtll", function(module, exports) {

let $7ee5cd650884bd4f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7ee5cd650884bd4f$var$load("6wr18"),
    $7ee5cd650884bd4f$var$load("dkoen"),
    $7ee5cd650884bd4f$var$load("4WTdS"),
    $7ee5cd650884bd4f$var$load("da1f1"),
    $7ee5cd650884bd4f$var$load("9q6b6"),
    $7ee5cd650884bd4f$var$load("6XCf4"),
    $7ee5cd650884bd4f$var$load("ebvEF"),
    $7ee5cd650884bd4f$var$load("hSDwk"),
    $7ee5cd650884bd4f$var$load("CfmiU"),
    $7ee5cd650884bd4f$var$load("cxCk7"),
    $7ee5cd650884bd4f$var$load("fvcK2"),
    $7ee5cd650884bd4f$var$load("4BjK2"),
    $7ee5cd650884bd4f$var$load("i7mZp"),
    $7ee5cd650884bd4f$var$load("h5t0Y"),
    $7ee5cd650884bd4f$var$load("ly931"),
    $7ee5cd650884bd4f$var$load("1b3GG"),
    $7ee5cd650884bd4f$var$load("c9Px9"),
    $7ee5cd650884bd4f$var$load("3Rnfs"),
    $7ee5cd650884bd4f$var$load("2j57H"),
    $7ee5cd650884bd4f$var$load("2mGc6"),
    $7ee5cd650884bd4f$var$load("ezYRV"),
    $7ee5cd650884bd4f$var$load("eeYoU"),
    $7ee5cd650884bd4f$var$load("176bM"),
    $7ee5cd650884bd4f$var$load("17OeC"),
    $7ee5cd650884bd4f$var$load("aJFlE"),
    $7ee5cd650884bd4f$var$load("lIsma"),
    $7ee5cd650884bd4f$var$load("2bJoN"),
    $7ee5cd650884bd4f$var$load("kfhZM"),
    $7ee5cd650884bd4f$var$load("ji2ex"),
    $7ee5cd650884bd4f$var$load("l9Ivm"),
    $7ee5cd650884bd4f$var$load("agVmZ"),
    $7ee5cd650884bd4f$var$load("dxcsb"),
    $7ee5cd650884bd4f$var$load("jqoep"),
    $7ee5cd650884bd4f$var$load("3YRzU"),
    $7ee5cd650884bd4f$var$load("aEiTV"),
    $7ee5cd650884bd4f$var$load("VXbA1"),
    $7ee5cd650884bd4f$var$load("1qlDN"),
    $7ee5cd650884bd4f$var$load("1yVM6"),
    $7ee5cd650884bd4f$var$load("8GFi1"),
    $7ee5cd650884bd4f$var$load("hhss7"),
    $7ee5cd650884bd4f$var$load("7EorR"),
    $7ee5cd650884bd4f$var$load("ffEVr"),
    $7ee5cd650884bd4f$var$load("cS7dz")
]).then(()=>parcelRequire('ec8HN'));

});

parcelRegister("99E45", function(module, exports) {

let $6aa4086548892de5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6aa4086548892de5$var$load("IyjLX").then(()=>parcelRequire('esu8h'));

});

parcelRegister("dVA4j", function(module, exports) {

let $a23c93aed97776be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a23c93aed97776be$var$load("7S9EX").then(()=>parcelRequire('3VmKy'));

});

parcelRegister("hwzJf", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $a0c1672298304318$export$c34c105fee6e8977 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "JsB5i",
    name: "GoToHomeLoader",
    loader: async ()=>(await (parcelRequire("2kNNv"))).GoToHome
});
module.exports["GoToHomeLoader"] = $a0c1672298304318$export$c34c105fee6e8977;

});

parcelRegister("2kNNv", function(module, exports) {

let $1b3413cb4d71dd58$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1b3413cb4d71dd58$var$load("c0lrw").then(()=>parcelRequire('7QGXJ'));

});

parcelRegister("idSff", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d4a3e046810f681f$export$1fe963e8f052ccbb = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "VM3qQ",
    name: "SiteHomepageRedirectLoader",
    loader: async ()=>(await (parcelRequire("hrkl2"))).SiteHomepageRedirect
});
module.exports["SiteHomepageRedirectLoader"] = $d4a3e046810f681f$export$1fe963e8f052ccbb;

});

parcelRegister("hrkl2", function(module, exports) {

let $cb24bc114e1af585$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cb24bc114e1af585$var$load("cgZOp").then(()=>parcelRequire('kkwpp'));

});

parcelRegister("8MiHL", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $664150cfb8454085$export$325f108b642b51d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EdgKX",
    name: "LazyRouteToRightEditor",
    loader: ()=>(parcelRequire("9C4Th"))
});
module.exports["LazyRouteToRightEditor"] = $664150cfb8454085$export$325f108b642b51d;

});

parcelRegister("9C4Th", function(module, exports) {

let $6ffb74d421c83421$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6ffb74d421c83421$var$load("4NoAV").then(()=>parcelRequire('kZVh7'));

});

parcelRegister("3W396", function(module, exports) {

let $2dd93a8f15abb3e7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2dd93a8f15abb3e7$var$load("awOLN"),
    $2dd93a8f15abb3e7$var$load("8d6BA"),
    $2dd93a8f15abb3e7$var$load("2K7Mk"),
    $2dd93a8f15abb3e7$var$load("4X1QD"),
    $2dd93a8f15abb3e7$var$load("io60f"),
    $2dd93a8f15abb3e7$var$load("h3v7G"),
    $2dd93a8f15abb3e7$var$load("ejABk"),
    $2dd93a8f15abb3e7$var$load("2F69B"),
    $2dd93a8f15abb3e7$var$load("iGGuG"),
    $2dd93a8f15abb3e7$var$load("dkoen"),
    $2dd93a8f15abb3e7$var$load("flDQJ"),
    $2dd93a8f15abb3e7$var$load("ba41x"),
    $2dd93a8f15abb3e7$var$load("da1f1"),
    $2dd93a8f15abb3e7$var$load("9q6b6"),
    $2dd93a8f15abb3e7$var$load("4BjK2"),
    $2dd93a8f15abb3e7$var$load("i7mZp"),
    $2dd93a8f15abb3e7$var$load("h5t0Y"),
    $2dd93a8f15abb3e7$var$load("ly931"),
    $2dd93a8f15abb3e7$var$load("1b3GG"),
    $2dd93a8f15abb3e7$var$load("c9Px9"),
    $2dd93a8f15abb3e7$var$load("2j57H"),
    $2dd93a8f15abb3e7$var$load("2mGc6"),
    $2dd93a8f15abb3e7$var$load("ezYRV"),
    $2dd93a8f15abb3e7$var$load("eeYoU"),
    $2dd93a8f15abb3e7$var$load("176bM"),
    $2dd93a8f15abb3e7$var$load("17OeC"),
    $2dd93a8f15abb3e7$var$load("aJFlE"),
    $2dd93a8f15abb3e7$var$load("lIsma"),
    $2dd93a8f15abb3e7$var$load("3evar"),
    $2dd93a8f15abb3e7$var$load("1jVx9"),
    $2dd93a8f15abb3e7$var$load("5zDuS"),
    $2dd93a8f15abb3e7$var$load("hh642"),
    $2dd93a8f15abb3e7$var$load("Mp0pM"),
    $2dd93a8f15abb3e7$var$load("agVmZ"),
    $2dd93a8f15abb3e7$var$load("dxcsb"),
    $2dd93a8f15abb3e7$var$load("3Kg3S"),
    $2dd93a8f15abb3e7$var$load("3YRzU"),
    $2dd93a8f15abb3e7$var$load("aEiTV"),
    $2dd93a8f15abb3e7$var$load("VXbA1"),
    $2dd93a8f15abb3e7$var$load("1qlDN"),
    $2dd93a8f15abb3e7$var$load("1yVM6"),
    $2dd93a8f15abb3e7$var$load("hhss7"),
    $2dd93a8f15abb3e7$var$load("lya9W"),
    $2dd93a8f15abb3e7$var$load("gA528"),
    $2dd93a8f15abb3e7$var$load("6wr18"),
    $2dd93a8f15abb3e7$var$load("i2NNN"),
    $2dd93a8f15abb3e7$var$load("cxCk7"),
    $2dd93a8f15abb3e7$var$load("ffEVr"),
    $2dd93a8f15abb3e7$var$load("7EorR"),
    $2dd93a8f15abb3e7$var$load("aHCaB"),
    $2dd93a8f15abb3e7$var$load("lwNze")
]).then(()=>parcelRequire('dJsyi'));

});

parcelRegister("9kowg", function(module, exports) {

let $6ca900606f29167b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6ca900606f29167b$var$load("hh642"),
    $6ca900606f29167b$var$load("2K7Mk"),
    $6ca900606f29167b$var$load("3yj2i"),
    $6ca900606f29167b$var$load("8R7DY"),
    $6ca900606f29167b$var$load("io60f"),
    $6ca900606f29167b$var$load("ejABk"),
    $6ca900606f29167b$var$load("dkoen"),
    $6ca900606f29167b$var$load("1GCFv"),
    $6ca900606f29167b$var$load("da1f1"),
    $6ca900606f29167b$var$load("9q6b6"),
    $6ca900606f29167b$var$load("cxCk7"),
    $6ca900606f29167b$var$load("4BjK2"),
    $6ca900606f29167b$var$load("i7mZp"),
    $6ca900606f29167b$var$load("h5t0Y"),
    $6ca900606f29167b$var$load("ly931"),
    $6ca900606f29167b$var$load("1b3GG"),
    $6ca900606f29167b$var$load("c9Px9"),
    $6ca900606f29167b$var$load("2j57H"),
    $6ca900606f29167b$var$load("2mGc6"),
    $6ca900606f29167b$var$load("eeYoU"),
    $6ca900606f29167b$var$load("176bM"),
    $6ca900606f29167b$var$load("17OeC"),
    $6ca900606f29167b$var$load("5J0xW"),
    $6ca900606f29167b$var$load("aJFlE"),
    $6ca900606f29167b$var$load("lIsma"),
    $6ca900606f29167b$var$load("3evar"),
    $6ca900606f29167b$var$load("agVmZ"),
    $6ca900606f29167b$var$load("dxcsb"),
    $6ca900606f29167b$var$load("jqoep"),
    $6ca900606f29167b$var$load("3YRzU"),
    $6ca900606f29167b$var$load("VXbA1"),
    $6ca900606f29167b$var$load("lya9W"),
    $6ca900606f29167b$var$load("gA528"),
    $6ca900606f29167b$var$load("8d6BA"),
    $6ca900606f29167b$var$load("iECXC"),
    $6ca900606f29167b$var$load("5sZTx"),
    $6ca900606f29167b$var$load("deTdD"),
    $6ca900606f29167b$var$load("6wr18"),
    $6ca900606f29167b$var$load("h8pkh"),
    $6ca900606f29167b$var$load("dlm6q"),
    $6ca900606f29167b$var$load("ezYRV"),
    $6ca900606f29167b$var$load("1cQg7"),
    $6ca900606f29167b$var$load("el56J"),
    $6ca900606f29167b$var$load("5zDuS"),
    $6ca900606f29167b$var$load("ffEVr"),
    $6ca900606f29167b$var$load("7EorR"),
    $6ca900606f29167b$var$load("ea3NB"),
    $6ca900606f29167b$var$load("aLbuU"),
    $6ca900606f29167b$var$load("hhss7"),
    $6ca900606f29167b$var$load("dUTj8"),
    $6ca900606f29167b$var$load("5MpJT")
]).then(()=>parcelRequire('7cCRg'));

});

parcelRegister("1TygC", function(module, exports) {

let $1615823d8ff102a7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1615823d8ff102a7$var$load("eW2qV"),
    $1615823d8ff102a7$var$load("8d6BA"),
    $1615823d8ff102a7$var$load("eeYoU"),
    $1615823d8ff102a7$var$load("03fWQ")
]).then(()=>parcelRequire('ePNbS'));

});

parcelRegister("7uit2", function(module, exports) {

let $5739a8fccfa43a06$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5739a8fccfa43a06$var$load("6wr18"),
    $5739a8fccfa43a06$var$load("lRwjQ"),
    $5739a8fccfa43a06$var$load("6XCf4"),
    $5739a8fccfa43a06$var$load("ebvEF"),
    $5739a8fccfa43a06$var$load("ffEVr"),
    $5739a8fccfa43a06$var$load("aEiTV"),
    $5739a8fccfa43a06$var$load("1qlDN"),
    $5739a8fccfa43a06$var$load("1yVM6"),
    $5739a8fccfa43a06$var$load("iO7VA")
]).then(()=>parcelRequire('4CchY'));

});

parcelRegister("cov6Y", function(module, exports) {

let $905fdc04d0bc106a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $905fdc04d0bc106a$var$load("3cI3U").then(()=>parcelRequire('5CzWQ'));

});

parcelRegister("cKOYh", function(module, exports) {

let $949151bf367337c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $949151bf367337c3$var$load("LWh5V"),
    $949151bf367337c3$var$load("eNXrl"),
    $949151bf367337c3$var$load("1sii7"),
    $949151bf367337c3$var$load("lnKog"),
    $949151bf367337c3$var$load("7EorR"),
    $949151bf367337c3$var$load("5n2uM")
]).then(()=>parcelRequire('bexnX'));

});

parcelRegister("lR1Cm", function(module, exports) {

let $fe8fcd7298f5c91b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fe8fcd7298f5c91b$var$load("lHNSl").then(()=>parcelRequire('8fbPW'));

});

parcelRegister("hlyKe", function(module, exports) {

let $ca0f59653dc0e0f2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ca0f59653dc0e0f2$var$load("vlZ5n").then(()=>parcelRequire('i5MLu'));

});

parcelRegister("4AgSW", function(module, exports) {

let $35679f3ca0102d46$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $35679f3ca0102d46$var$load("ejYwx").then(()=>parcelRequire('2X92e'));

});

parcelRegister("im0Dk", function(module, exports) {

let $d5cac5d2f54b1d1a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d5cac5d2f54b1d1a$var$load("6nNce").then(()=>parcelRequire('iPlli'));

});

parcelRegister("CCF2O", function(module, exports) {

let $074189fecca542b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $074189fecca542b3$var$load("gI35P").then(()=>parcelRequire('grc8F'));

});

parcelRegister("eYhV2", function(module, exports) {

let $ae6491a247a08493$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae6491a247a08493$var$load("hMGc2").then(()=>parcelRequire('fOnOH'));

});

parcelRegister("5D5gD", function(module, exports) {

let $4194ae3d43672016$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4194ae3d43672016$var$load("l0dd5"),
    $4194ae3d43672016$var$load("dbQ5m"),
    $4194ae3d43672016$var$load("bm0oR"),
    $4194ae3d43672016$var$load("4fYzp"),
    $4194ae3d43672016$var$load("1GCFv"),
    $4194ae3d43672016$var$load("30b92"),
    $4194ae3d43672016$var$load("h4Nf7"),
    $4194ae3d43672016$var$load("90SZm"),
    $4194ae3d43672016$var$load("crfrC"),
    $4194ae3d43672016$var$load("hhss7"),
    $4194ae3d43672016$var$load("4x9Jx"),
    $4194ae3d43672016$var$load("ea3NB"),
    $4194ae3d43672016$var$load("6wr18"),
    $4194ae3d43672016$var$load("59hV4"),
    $4194ae3d43672016$var$load("excC5"),
    $4194ae3d43672016$var$load("fuOfV"),
    $4194ae3d43672016$var$load("jL1Ke"),
    $4194ae3d43672016$var$load("5MQ0D"),
    $4194ae3d43672016$var$load("ffEVr"),
    $4194ae3d43672016$var$load("fwbNS"),
    $4194ae3d43672016$var$load("zUKwV"),
    $4194ae3d43672016$var$load("fUeur"),
    $4194ae3d43672016$var$load("Wowvf"),
    $4194ae3d43672016$var$load("4g6rd"),
    $4194ae3d43672016$var$load("ayJxT"),
    $4194ae3d43672016$var$load("7EorR"),
    $4194ae3d43672016$var$load("hA2SB"),
    $4194ae3d43672016$var$load("8Dgzr")
]).then(()=>parcelRequire('bhsbE'));

});

parcelRegister("fi2Nx", function(module, exports) {

let $b21ab510773f0e7f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b21ab510773f0e7f$var$load("eT0Md").then(()=>parcelRequire('y0ZZq'));

});

parcelRegister("6Crlg", function(module, exports) {

let $4d1b803699758c78$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4d1b803699758c78$var$load("1PNUT").then(()=>parcelRequire('8qhuK'));

});

parcelRegister("gYtMe", function(module, exports) {

let $c5b9590ab1806dbf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c5b9590ab1806dbf$var$load("h2HOa").then(()=>parcelRequire('3C4B7'));

});

parcelRegister("WDJHu", function(module, exports) {

let $0b043da80fd3d1e5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0b043da80fd3d1e5$var$load("hsAS2").then(()=>parcelRequire('6PsK0'));

});

parcelRegister("aZGfx", function(module, exports) {

let $80105fc925481490$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $80105fc925481490$var$load("6wr18"),
    $80105fc925481490$var$load("diMTQ"),
    $80105fc925481490$var$load("iN26T"),
    $80105fc925481490$var$load("ffEVr"),
    $80105fc925481490$var$load("kBatH"),
    $80105fc925481490$var$load("2NgQt")
]).then(()=>parcelRequire('cPinp'));

});

parcelRegister("01i9E", function(module, exports) {

let $003e2d40636de1b9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $003e2d40636de1b9$var$load("2xc83"),
    $003e2d40636de1b9$var$load("6wr18"),
    $003e2d40636de1b9$var$load("7ZdE9"),
    $003e2d40636de1b9$var$load("9cgaG"),
    $003e2d40636de1b9$var$load("awOLN"),
    $003e2d40636de1b9$var$load("6XCf4"),
    $003e2d40636de1b9$var$load("ebvEF"),
    $003e2d40636de1b9$var$load("1gATC"),
    $003e2d40636de1b9$var$load("ffEVr"),
    $003e2d40636de1b9$var$load("c9Px9"),
    $003e2d40636de1b9$var$load("3Rnfs"),
    $003e2d40636de1b9$var$load("2j57H"),
    $003e2d40636de1b9$var$load("2mGc6"),
    $003e2d40636de1b9$var$load("6C7Vr"),
    $003e2d40636de1b9$var$load("aEiTV"),
    $003e2d40636de1b9$var$load("1qlDN"),
    $003e2d40636de1b9$var$load("1yVM6"),
    $003e2d40636de1b9$var$load("faxwR")
]).then(()=>parcelRequire('eHKVU'));

});

parcelRegister("jdXW8", function(module, exports) {

let $dfedb961d5b9a61c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $dfedb961d5b9a61c$var$load("e80av"),
    $dfedb961d5b9a61c$var$load("aYkj4"),
    $dfedb961d5b9a61c$var$load("6wr18"),
    $dfedb961d5b9a61c$var$load("iLqgZ"),
    $dfedb961d5b9a61c$var$load("kwgtb"),
    $dfedb961d5b9a61c$var$load("i84Fm"),
    $dfedb961d5b9a61c$var$load("49rXL"),
    $dfedb961d5b9a61c$var$load("4RHRd"),
    $dfedb961d5b9a61c$var$load("FJgmQ"),
    $dfedb961d5b9a61c$var$load("6XCf4"),
    $dfedb961d5b9a61c$var$load("ebvEF"),
    $dfedb961d5b9a61c$var$load("46phv"),
    $dfedb961d5b9a61c$var$load("diMTQ"),
    $dfedb961d5b9a61c$var$load("hKFtK"),
    $dfedb961d5b9a61c$var$load("aEiTV"),
    $dfedb961d5b9a61c$var$load("1qlDN"),
    $dfedb961d5b9a61c$var$load("1yVM6"),
    $dfedb961d5b9a61c$var$load("kBatH"),
    $dfedb961d5b9a61c$var$load("ffEVr"),
    $dfedb961d5b9a61c$var$load("gYbv6")
]).then(()=>parcelRequire('9qsRH'));

});

parcelRegister("3VOtu", function(module, exports) {

let $2dcdd92ed453e280$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2dcdd92ed453e280$var$load("83Dnz").then(()=>parcelRequire('1e8Au'));

});

parcelRegister("9TVBV", function(module, exports) {
/**
 * @generated SignedSource<<585ff00e08b16fb246b11138f7d89006>>
 * @relayHash 6e460ac038e243dbc74984a7e17a7720
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6d8a1c1432dd78a309529a8426e9f0e759b0e202139621c928d8dab8a2de74c7
const $d5416dce4c756c64$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spacePermissions"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceTypes"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "subjectId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "subjectType"
        }
    ], v1 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "spacePermissions",
                    "variableName": "spacePermissions"
                },
                {
                    "kind": "Variable",
                    "name": "spaceTypes",
                    "variableName": "spaceTypes"
                },
                {
                    "kind": "Variable",
                    "name": "subjectId",
                    "variableName": "subjectId"
                },
                {
                    "kind": "Variable",
                    "name": "subjectType",
                    "variableName": "subjectType"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "taskId"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BulkSetSpacePermissionAsyncPayload",
                    "kind": "LinkedField",
                    "name": "bulkSetSpacePermissionAsync",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BulkSetSpacePermissionAsyncPayload",
                    "kind": "LinkedField",
                    "name": "bulkSetSpacePermissionAsync",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        },
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "6e460ac038e243dbc74984a7e17a7720",
            "id": "6d8a1c1432dd78a309529a8426e9f0e759b0e202139621c928d8dab8a2de74c7",
            "metadata": {},
            "name": "BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation",
            "operationKind": "mutation",
            "text": "mutation BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation($spacePermissions:[SpacePermissionType]!,$spaceTypes:[BulkSetSpacePermissionSpaceType]!,$subjectId:ID!,$subjectType:BulkSetSpacePermissionSubjectType!){bulkSetSpacePermissionAsync(input:{spacePermissions:$spacePermissions,spaceTypes:$spaceTypes,subjectId:$subjectId,subjectType:$subjectType}){success,errors{message,extensions{__typename,errorType,statusCode,...on BulkMutationErrorExtension{id}}},taskId}}"
        }
    };
}();
$d5416dce4c756c64$var$node.hash = "3a45909974779c48b1ef1a6ec89f783e";
var $d5416dce4c756c64$export$2e2bcd8739ae039 = $d5416dce4c756c64$var$node;



var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iW7aI = parcelRequire("iW7aI");


var $ad7Ou = parcelRequire("ad7Ou");


var $eKMV3 = parcelRequire("eKMV3");


var $9DHhW = parcelRequire("9DHhW");


var $3izAL = parcelRequire("3izAL");


var $kz1Yj = parcelRequire("kz1Yj");


var $buxP3 = parcelRequire("buxP3");


var $1BYn9 = parcelRequire("1BYn9");


var $hpRYU = parcelRequire("hpRYU");


var $euL71 = parcelRequire("euL71");


var $1NBp8 = parcelRequire("1NBp8");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $7aRa9 = parcelRequire("7aRa9");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $iquRY = parcelRequire("iquRY");

parcelRequire("cp4jg");
var $9phVF = parcelRequire("9phVF");


var $308Wd = parcelRequire("308Wd");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");

/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $70228f3077c41fe6$export$e57870671ec2468e = /*#__PURE__*/ function(BulkSetSpacePermissionSpaceType) {
    BulkSetSpacePermissionSpaceType["COLLABORATION"] = "COLLABORATION";
    BulkSetSpacePermissionSpaceType["GLOBAL"] = "GLOBAL";
    BulkSetSpacePermissionSpaceType["KNOWLEDGE_BASE"] = "KNOWLEDGE_BASE";
    BulkSetSpacePermissionSpaceType["PERSONAL"] = "PERSONAL";
    return BulkSetSpacePermissionSpaceType;
}({});
var $70228f3077c41fe6$export$8b2051573ac4b3d5 = /*#__PURE__*/ function(BulkSetSpacePermissionSubjectType) {
    BulkSetSpacePermissionSubjectType["GROUP"] = "GROUP";
    BulkSetSpacePermissionSubjectType["USER"] = "USER";
    return BulkSetSpacePermissionSubjectType;
}({});
var $70228f3077c41fe6$export$a99f5dae9c149910 = /*#__PURE__*/ function(SpacePermissionType) {
    SpacePermissionType["ADMINISTER_SPACE"] = "ADMINISTER_SPACE";
    SpacePermissionType["ARCHIVE_PAGE"] = "ARCHIVE_PAGE";
    SpacePermissionType["COMMENT"] = "COMMENT";
    SpacePermissionType["CREATE_ATTACHMENT"] = "CREATE_ATTACHMENT";
    SpacePermissionType["CREATE_EDIT_PAGE"] = "CREATE_EDIT_PAGE";
    SpacePermissionType["EDIT_BLOG"] = "EDIT_BLOG";
    SpacePermissionType["EXPORT_PAGE"] = "EXPORT_PAGE";
    SpacePermissionType["EXPORT_SPACE"] = "EXPORT_SPACE";
    SpacePermissionType["REMOVE_ATTACHMENT"] = "REMOVE_ATTACHMENT";
    SpacePermissionType["REMOVE_BLOG"] = "REMOVE_BLOG";
    SpacePermissionType["REMOVE_COMMENT"] = "REMOVE_COMMENT";
    SpacePermissionType["REMOVE_MAIL"] = "REMOVE_MAIL";
    SpacePermissionType["REMOVE_OWN_CONTENT"] = "REMOVE_OWN_CONTENT";
    SpacePermissionType["REMOVE_PAGE"] = "REMOVE_PAGE";
    SpacePermissionType["SET_PAGE_PERMISSIONS"] = "SET_PAGE_PERMISSIONS";
    SpacePermissionType["VIEW_SPACE"] = "VIEW_SPACE";
    return SpacePermissionType;
}({});









var $1VhsF = parcelRequire("1VhsF");


var $iMnC5 = parcelRequire("iMnC5");

const $0d65445224ec1da1$export$ebaaa2fd42680a02 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingBlockEnd: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: 'bulk-permissions.space.removal-warning.non-final',
        defaultMessage: '<b>Permission to view is not selected. This will remove the user or group from all spaces.</b>',
        description: 'Warning text telling the user that they are removing permissions for a user or group.',
        values: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks)
        }
    })));



var $ilq3G = parcelRequire("ilq3G");


var $8A6YM = parcelRequire("8A6YM");













/* BulkSpacePermissionsTable.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $hekY6 = parcelRequire("hekY6");





var $lU1vD = parcelRequire("lU1vD");


var $2uDbg = parcelRequire("2uDbg");





var $eicAg = parcelRequire("eicAg");


var $yuLaV = parcelRequire("yuLaV");


var $jhwJP = parcelRequire("jhwJP");



var $9TVBV = parcelRequire("9TVBV");

const $7a1206d786c0ab1b$var$groupI18nBase = (0, $kSwu1.defineMessages)({
    selectAll: {
        id: "bulk-permissions.space.table.header.group.select-all",
        defaultMessage: "Select all"
    },
    all: {
        id: "bulk-permissions.space.table.header.group.all",
        defaultMessage: "All"
    },
    pages: {
        id: "bulk-permissions.space.table.header.group.pages",
        defaultMessage: "Pages"
    },
    pagesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-embeds",
        defaultMessage: "Pages and Smart Links"
    },
    pagesWhiteboardsDatabases: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-databases",
        defaultMessage: "Pages, whiteboards, and databases"
    },
    pagesWhiteboardsEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-embeds",
        defaultMessage: "Pages, whiteboards, and Smart Links"
    },
    pagesDatabasesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-databases-embeds",
        defaultMessage: "Pages, databases, and Smart Links"
    },
    pagesWhiteboardsDatabasesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-databases-embeds",
        defaultMessage: "Pages, whiteboards, databases, and Smart Links"
    },
    blogs: {
        id: "bulk-permissions.space.table.header.group.blogs",
        defaultMessage: "Blogs"
    },
    comments: {
        id: "bulk-permissions.space.table.header.group.comments",
        defaultMessage: "Comments"
    },
    attachments: {
        id: "bulk-permissions.space.table.header.group.attachments",
        defaultMessage: "Attachments"
    },
    restrictions: {
        id: "bulk-permissions.space.table.header.group.restrictions",
        defaultMessage: "Restrictions"
    },
    mail: {
        id: "bulk-permissions.space.table.header.group.mail",
        defaultMessage: "Mail"
    },
    space: {
        id: "bulk-permissions.space.table.header.group.space",
        defaultMessage: "Space"
    }
});
const $7a1206d786c0ab1b$var$groupI18nLiveDocs = (0, $kSwu1.defineMessages)({
    pages: {
        id: "bulk-permissions.space.table.header.group.pages.livedocs",
        defaultMessage: "Pages and live docs"
    },
    pagesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-embeds.livedocs",
        defaultMessage: "Pages, live docs, and Smart Links"
    },
    pagesWhiteboardsDatabases: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-databases.livedocs",
        defaultMessage: "Pages, live docs, whiteboards, and databases"
    },
    pagesWhiteboardsEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-embeds.livedocs",
        defaultMessage: "Pages, live docs, whiteboards, databases, and Smart Links"
    },
    pagesDatabasesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-databases-embeds.livedocs",
        defaultMessage: "Pages, live docs, databases, and Smart Links"
    },
    pagesWhiteboardsDatabasesEmbeds: {
        id: "bulk-permissions.space.table.header.group.pages-whiteboards-databases-embeds.livedocs",
        defaultMessage: "Pages, live docs, whiteboards, databases, and Smart Links"
    }
});
const $7a1206d786c0ab1b$var$groupI18n = (0, $jhwJP.mergeLiveDocI18n)($7a1206d786c0ab1b$var$groupI18nBase, $7a1206d786c0ab1b$var$groupI18nLiveDocs);
const $7a1206d786c0ab1b$var$columnI18n = (0, $kSwu1.defineMessages)({
    view: {
        id: "bulk-permissions.space.table.header.column.view",
        defaultMessage: "View"
    },
    deleteOwn: {
        id: "bulk-permissions.space.table.header.column.delete-own",
        defaultMessage: "Delete own"
    },
    add: {
        id: "bulk-permissions.space.table.header.column.Add",
        defaultMessage: "Add"
    },
    delete: {
        id: "bulk-permissions.space.table.header.column.delete",
        defaultMessage: "Delete"
    },
    archive: {
        id: "bulk-permissions.space.table.header.column.archive",
        defaultMessage: "Archive"
    },
    addDelete: {
        id: "bulk-permissions.space.table.header.column.add-delete",
        defaultMessage: "Add/Delete"
    },
    export: {
        id: "bulk-permissions.space.table.header.column.export",
        defaultMessage: "Export"
    },
    admin: {
        id: "bulk-permissions.space.table.header.column.admin",
        defaultMessage: "Admin"
    }
});
const $7a1206d786c0ab1b$var$i18n = (0, $kSwu1.defineMessages)({
    allViewTooltipContent: {
        id: "bulk-permissions.space.table.header.allViewTooltipContent",
        defaultMessage: "View permission determines who has access to the space."
    },
    allViewTooltipIconLabel: {
        id: "bulk-permissions.space.table.header.allViewTooltipIconLabel",
        defaultMessage: "Learn more about view permissions"
    },
    deleteOwnTooltipContent: {
        id: "bulk-permissions.space.table.header.deleteOwnTooltipContent",
        defaultMessage: "Lets users delete their own content and attachments. (For comments, the \u201CAdd\u201D permission includes \u201CDelete Own\u201D)"
    },
    deleteOwnTooltipIconLabel: {
        id: "bulk-permissions.space.table.header.deleteOwnTooltipIconLabel",
        defaultMessage: "Learn more about delete own"
    },
    restrictionsTooltipContent: {
        id: "bulk-permissions.space.table.header.restrictionsTooltipContent",
        defaultMessage: "Lets users add and remove restrictions directly on content. Does not affect inherited restrictions."
    },
    restrictionsTooltipIconLabel: {
        id: "bulk-permissions.space.table.header.restrictionsTooltipIconLabel",
        defaultMessage: "Restrictions Add/Delete tooltip"
    }
});
const $7a1206d786c0ab1b$var$COLUMN_KEY_SELECT_ALL = 'SELECT_ALL';
const $7a1206d786c0ab1b$var$CELL_BORDER = {
    borderLeft: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7a1206d786c0ab1b$var$TableWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAIZbP _313842kG2W",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7a1206d786c0ab1b$var$CheckboxWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuDIqT",
            __cmplp.className
        ])
    });
});
const $7a1206d786c0ab1b$export$92f022c5db01744 = {
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_OWN_CONTENT]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_EDIT_PAGE]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).ARCHIVE_PAGE]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_PAGE]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).EDIT_BLOG]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_BLOG]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).COMMENT]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_COMMENT]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_ATTACHMENT]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_ATTACHMENT]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).SET_PAGE_PERMISSIONS]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).EXPORT_SPACE]: false,
    [(0, $70228f3077c41fe6$export$a99f5dae9c149910).ADMINISTER_SPACE]: false
};
const $7a1206d786c0ab1b$export$2f227e4ea23eeffd = ({ spacePermissions: spacePermissions, setSpacePermissions: setSpacePermissions, isDisabled: isTableDisabled = false })=>{
    const isWhiteboardsEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isDatabasesEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isSelectAllCheckbox, setSelectAllCheckbox] = (0, $cozmU.useState)(false);
    spacePermissions.forEach((val)=>{
        $7a1206d786c0ab1b$export$92f022c5db01744[val] = true;
    });
    const [checkboxValues, setCheckboxValues] = (0, $cozmU.useState)($7a1206d786c0ab1b$export$92f022c5db01744);
    (0, $cozmU.useEffect)(()=>{
        Object.keys(checkboxValues).forEach((val)=>{
            checkboxValues[val] = false;
        });
        spacePermissions.forEach((val)=>{
            checkboxValues[val] = true;
        });
        setCheckboxValues(checkboxValues);
        checkSelectAllCheckbox(checkboxValues);
    }, [
        spacePermissions,
        checkboxValues
    ]);
    const getContentGroupName = (_isWhiteboardsEnabled, _isDatabasesEnabled)=>{
        if (!_isWhiteboardsEnabled && !_isDatabasesEnabled) return formatMessage($7a1206d786c0ab1b$var$groupI18n.pagesEmbeds);
        else if (_isWhiteboardsEnabled && !_isDatabasesEnabled) return formatMessage($7a1206d786c0ab1b$var$groupI18n.pagesWhiteboardsEmbeds);
        else if (!_isWhiteboardsEnabled && _isDatabasesEnabled) return formatMessage($7a1206d786c0ab1b$var$groupI18n.pagesDatabasesEmbeds);
        else return formatMessage($7a1206d786c0ab1b$var$groupI18n.pagesWhiteboardsDatabasesEmbeds);
    };
    const groupNames = {
        SELECT_ALL: formatMessage($7a1206d786c0ab1b$var$groupI18n.selectAll),
        ALL: formatMessage($7a1206d786c0ab1b$var$groupI18n.all),
        CONTENT: getContentGroupName(isWhiteboardsEnabled, isDatabasesEnabled),
        BLOGS: formatMessage($7a1206d786c0ab1b$var$groupI18n.blogs),
        COMMENTS: formatMessage($7a1206d786c0ab1b$var$groupI18n.comments),
        ATTACHMENTS: formatMessage($7a1206d786c0ab1b$var$groupI18n.attachments),
        RESTRICTIONS: formatMessage($7a1206d786c0ab1b$var$groupI18n.restrictions),
        MAIL: formatMessage($7a1206d786c0ab1b$var$groupI18n.mail),
        SPACE: formatMessage($7a1206d786c0ab1b$var$groupI18n.space)
    };
    const columnNames = {
        VIEW: formatMessage($7a1206d786c0ab1b$var$columnI18n.view),
        DELETE_OWN: formatMessage($7a1206d786c0ab1b$var$columnI18n.deleteOwn),
        ADD: formatMessage($7a1206d786c0ab1b$var$columnI18n.add),
        DELETE: formatMessage($7a1206d786c0ab1b$var$columnI18n.delete),
        ARCHIVE: formatMessage($7a1206d786c0ab1b$var$columnI18n.archive),
        ADD_DELETE: formatMessage($7a1206d786c0ab1b$var$columnI18n.addDelete),
        EXPORT: formatMessage($7a1206d786c0ab1b$var$columnI18n.export),
        ADMIN: formatMessage($7a1206d786c0ab1b$var$columnI18n.admin)
    };
    const permissionsTableHeaders = [
        {
            key: $7a1206d786c0ab1b$var$COLUMN_KEY_SELECT_ALL,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eicAg.HeaderCell), {
                groupName: "",
                columnName: groupNames.SELECT_ALL
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.ALL,
                columnName: columnNames.VIEW,
                tooltipContent: $7a1206d786c0ab1b$var$i18n.allViewTooltipContent,
                tooltipIconLabel: $7a1206d786c0ab1b$var$i18n.allViewTooltipIconLabel,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_OWN_CONTENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.ALL,
                columnName: columnNames.DELETE_OWN,
                tooltipContent: $7a1206d786c0ab1b$var$i18n.deleteOwnTooltipContent,
                tooltipIconLabel: $7a1206d786c0ab1b$var$i18n.deleteOwnTooltipIconLabel
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_EDIT_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.CONTENT,
                columnName: columnNames.ADD
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).ARCHIVE_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eicAg.HeaderCell), {
                showGroupName: true,
                groupName: groupNames.CONTENT,
                columnName: columnNames.ARCHIVE,
                centerGroupName: true,
                setWidth: true
            }),
            inlineStyles: {
                maxWidth: "var(--ds-space-1000, 80px)"
            }
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.CONTENT,
                columnName: columnNames.DELETE
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).EDIT_BLOG,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.BLOGS,
                columnName: columnNames.ADD,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_BLOG,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.BLOGS,
                columnName: columnNames.DELETE
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).COMMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.COMMENTS,
                columnName: columnNames.ADD,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_COMMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.COMMENTS,
                columnName: columnNames.DELETE
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_ATTACHMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.ATTACHMENTS,
                columnName: columnNames.ADD,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_ATTACHMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.ATTACHMENTS,
                columnName: columnNames.DELETE
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).SET_PAGE_PERMISSIONS,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.RESTRICTIONS,
                columnName: columnNames.ADD_DELETE,
                tooltipContent: $7a1206d786c0ab1b$var$i18n.restrictionsTooltipContent,
                tooltipIconLabel: $7a1206d786c0ab1b$var$i18n.restrictionsTooltipIconLabel,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).EXPORT_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.SPACE,
                columnName: columnNames.EXPORT,
                showGroupName: true
            }),
            inlineStyles: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).ADMINISTER_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eicAg.HeaderCell), {
                groupName: groupNames.SPACE,
                columnName: columnNames.ADMIN
            })
        }
    ];
    const updateSpacePermissions = (checkboxValues)=>{
        setSpacePermissions(Object.keys(checkboxValues).filter((val)=>checkboxValues[val]));
    };
    const checkSelectAllCheckbox = (valuesObject)=>{
        if (Object.values(valuesObject).every((v)=>{
            return v;
        })) setSelectAllCheckbox(true);
        else setSelectAllCheckbox(false);
    };
    const getAriaLabel = (checkBox)=>{
        switch(checkBox){
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE:
                return `${columnNames.VIEW} ${groupNames.ALL}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_OWN_CONTENT:
                return `${columnNames.DELETE_OWN} ${groupNames.ALL}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_EDIT_PAGE:
                return `${columnNames.ADD} ${groupNames.CONTENT}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).ARCHIVE_PAGE:
                return `${columnNames.ARCHIVE} ${groupNames.CONTENT}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_PAGE:
                return `${columnNames.DELETE} ${groupNames.CONTENT}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).EDIT_BLOG:
                return `${columnNames.ADD} ${groupNames.BLOGS}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_BLOG:
                return `${columnNames.DELETE} ${groupNames.BLOGS}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).COMMENT:
                return `${columnNames.ADD} ${groupNames.COMMENTS}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_COMMENT:
                return `${columnNames.DELETE} ${groupNames.COMMENTS}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_ATTACHMENT:
                return `${columnNames.ADD} ${groupNames.ATTACHMENTS}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_ATTACHMENT:
                return `${columnNames.DELETE} ${groupNames.ATTACHMENTS}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).SET_PAGE_PERMISSIONS:
                return `${columnNames.ADD_DELETE} ${groupNames.RESTRICTIONS}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).EXPORT_SPACE:
                return `${columnNames.EXPORT} ${groupNames.SPACE}`;
            case (0, $70228f3077c41fe6$export$a99f5dae9c149910).ADMINISTER_SPACE:
                return `${columnNames.ADMIN} ${groupNames.SPACE}`;
        }
    };
    const PermissionsTableCheckBox = ({ spacePermission: spacePermission })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7a1206d786c0ab1b$var$CheckboxWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            testId: `bulk-space-permissions-table-checkbox-${spacePermission}`,
            "aria-label": getAriaLabel(spacePermission),
            isChecked: getCheckedValue(spacePermission),
            isDisabled: isTableDisabled || (spacePermission === (0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE ? false : isViewSpaceDisabled()),
            onChange: ()=>{
                checkboxValues[spacePermission] = !checkboxValues[spacePermission];
                setCheckboxValues(checkboxValues);
                checkSelectAllCheckbox(checkboxValues);
                updateSpacePermissions(checkboxValues);
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        actionSubject: 'checkbox',
                        action: 'clicked',
                        actionSubjectId: spacePermission,
                        source: (0, $9TVBV.ANALYTICS_SOURCE),
                        attributes: {
                            value: checkboxValues[spacePermission]
                        }
                    }
                }).fire();
            }
        }));
    };
    const handleSelectAllChange = ()=>{
        setSelectAllCheckbox(!isSelectAllCheckbox);
        Object.keys(checkboxValues).map((val)=>{
            checkboxValues[val] = !isSelectAllCheckbox;
        });
        setCheckboxValues(checkboxValues);
        updateSpacePermissions(checkboxValues);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'checkbox',
                action: 'clicked',
                actionSubjectId: 'COLUMN_KEY_SELECT_ALL',
                source: (0, $9TVBV.ANALYTICS_SOURCE),
                attributes: {
                    value: isSelectAllCheckbox
                }
            }
        }).fire();
    };
    const isViewSpaceDisabled = ()=>{
        return !checkboxValues[(0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE];
    };
    const getCheckedValue = (itemId)=>{
        return checkboxValues[itemId];
    };
    const checkboxes = [
        {
            key: $7a1206d786c0ab1b$var$COLUMN_KEY_SELECT_ALL,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7a1206d786c0ab1b$var$CheckboxWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
                testId: "bulk-space-permissions-table-checkbox-SELECT_ALL",
                "aria-label": groupNames.SELECT_ALL,
                isChecked: isSelectAllCheckbox,
                isDisabled: isTableDisabled,
                onChange: handleSelectAllChange
            }))
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_OWN_CONTENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_OWN_CONTENT
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_EDIT_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_EDIT_PAGE
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).ARCHIVE_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).ARCHIVE_PAGE
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_PAGE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_PAGE
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).EDIT_BLOG,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).EDIT_BLOG
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_BLOG,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_BLOG
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).COMMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).COMMENT
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_COMMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_COMMENT
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_ATTACHMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).CREATE_ATTACHMENT
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_ATTACHMENT,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).REMOVE_ATTACHMENT
            })
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).SET_PAGE_PERMISSIONS,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).SET_PAGE_PERMISSIONS
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).EXPORT_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).EXPORT_SPACE
            }),
            style: $7a1206d786c0ab1b$var$CELL_BORDER
        },
        {
            key: (0, $70228f3077c41fe6$export$a99f5dae9c149910).ADMINISTER_SPACE,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PermissionsTableCheckBox, {
                spacePermission: (0, $70228f3077c41fe6$export$a99f5dae9c149910).ADMINISTER_SPACE
            })
        }
    ];
    const rowData = [
        checkboxValues
    ].map(()=>({
            key: `checkboxes`,
            cells: checkboxes
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7a1206d786c0ab1b$var$TableWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lU1vD.default), {
        head: {
            cells: permissionsTableHeaders
        },
        rows: rowData,
        testId: "bulk-space-permissions-table"
    }));
};


const $ac9ac80a1cd63f38$var$i18n = (0, $kSwu1.defineMessages)({
    permissionsSelectionHeader: {
        id: "bulk-permissions.space.permissions-selection-header",
        defaultMessage: "Choose space permissions"
    },
    permissionsSelectionSubtext: {
        id: "bulk-permissions.space.permissions-selection-subtext",
        defaultMessage: "Select which permissions the user or group should have in all spaces. This will overwrite any existing permissions they have. <b>This can\u2019t be undone</b> so make sure to double check who you\u2019re adding and what permissions they should have."
    },
    permissionsWithTeamsSelectionSubtext: {
        id: "bulk-permissions.space.permissions-selection-subtext-with-teams",
        defaultMessage: "Select which permissions the user, team or group should have in all spaces. This will overwrite any existing permissions they have. <b>This can\u2019t be undone</b> so make sure to double check who you\u2019re adding and what permissions they should have."
    },
    permissionsSelectionSubtextAdditional: {
        id: "bulk-permissions.space.permissions-selection-subtext-additional",
        defaultMessage: "To remove permissions from all spaces, uncheck the view permission."
    }
});
const $ac9ac80a1cd63f38$var$permissionSelectionHeaderStyle = (0, $buxP3.xcss)({
    font: 'font.body.large',
    fontWeight: 'font.weight.medium',
    paddingBottom: 'space.100',
    paddingTop: 'space.300'
});
const $ac9ac80a1cd63f38$var$subtextStyle = (0, $buxP3.xcss)({
    font: 'font.body'
});
const $ac9ac80a1cd63f38$export$15775f46ef52c627 = ({ spacePermissions: spacePermissions, setSpacePermissions: setSpacePermissions, isDisabled: isDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $ac9ac80a1cd63f38$var$permissionSelectionHeaderStyle
    }, formatMessage($ac9ac80a1cd63f38$var$i18n.permissionsSelectionHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $ac9ac80a1cd63f38$var$subtextStyle
    }, formatMessage($ac9ac80a1cd63f38$var$i18n.permissionsWithTeamsSelectionSubtext, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        paddingBlockStart: "space.200"
    }, formatMessage($ac9ac80a1cd63f38$var$i18n.permissionsSelectionSubtextAdditional))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7a1206d786c0ab1b$export$2f227e4ea23eeffd), {
        spacePermissions: spacePermissions,
        setSpacePermissions: setSpacePermissions,
        isDisabled: isDisabled
    }));
};



var $eIwUX = parcelRequire("eIwUX");





var $aRGok = parcelRequire("aRGok");


var $lsxnT = parcelRequire("lsxnT");


var $67Foi = parcelRequire("67Foi");


var $lM2MU = parcelRequire("lM2MU");








var $7ZB0A = parcelRequire("7ZB0A");


var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");





var $2wCqQ = parcelRequire("2wCqQ");







const $e9f437038d263d04$var$i18n = (0, $kSwu1.defineMessages)({
    addConfirmationDialogTitle: {
        id: "bulk-permissions.space.add.confirmation-dialog",
        defaultMessage: "Add {principalName} to selected spaces?"
    },
    addAllExcludingPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-exclude-personal.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all spaces</b> (excluding personal) on your site with the selected permissions."
    },
    addAllConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-all.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all spaces</b> on your site with the selected permissions."
    },
    addAllPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-personal.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all personal spaces</b>  on your site with the selected permissions."
    },
    confirmationDialogWarning: {
        id: "bulk-permissions.space.confirmation-dialog-warning",
        defaultMessage: "<b>This can\u2019t be undone.</b>"
    },
    removeConfirmationDialogTitle: {
        id: "bulk-permissions.space.remove.confirmation-dialog",
        defaultMessage: "Remove {principalName} from selected spaces?"
    },
    removeAllExcludingPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-exclude-personal.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all spaces</b> (excluding personal) on your site."
    },
    removeAllConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-all.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all spaces</b> on your site."
    },
    removeAllPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-personal.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all personal spaces</b> on your site."
    },
    cancelButtonText: {
        id: "bulk-permissions.space.cancel-button-text",
        defaultMessage: "Cancel"
    },
    addButtonText: {
        id: "bulk-permissions.space.add-button-text",
        defaultMessage: "Add to all"
    },
    removeButtonText: {
        id: "bulk-permissions.space.remove-button-text",
        defaultMessage: "Remove from all"
    }
});
const $e9f437038d263d04$var$ConfirmatonSubSection = (0, $buxP3.xcss)({
    paddingTop: 'space.300'
});
const $e9f437038d263d04$var$boldString = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks);
const $e9f437038d263d04$export$b8704437d11c7fe7 = ({ principalName: principalName, isRemoval: isRemoval, spaceSelection: spaceSelection, onConfirm: onConfirm, onCancel: onCancel })=>{
    const getConfirmationDialogDescription = ()=>{
        if (isRemoval) switch(spaceSelection){
            case (0, $8A6YM.SpaceSelection).AllExcludingPersonal:
                return $e9f437038d263d04$var$i18n.removeAllExcludingPersonalConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).AllIncludingPersonal:
                return $e9f437038d263d04$var$i18n.removeAllConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).OnlyPersonal:
                return $e9f437038d263d04$var$i18n.removeAllPersonalConfirmationDialogDescription;
        }
        else switch(spaceSelection){
            case (0, $8A6YM.SpaceSelection).AllExcludingPersonal:
                return $e9f437038d263d04$var$i18n.addAllExcludingPersonalConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).AllIncludingPersonal:
                return $e9f437038d263d04$var$i18n.addAllConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).OnlyPersonal:
                return $e9f437038d263d04$var$i18n.addAllPersonalConfirmationDialogDescription;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), {
        appearance: isRemoval ? 'warning' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...isRemoval ? $e9f437038d263d04$var$i18n.removeConfirmationDialogTitle : $e9f437038d263d04$var$i18n.addConfirmationDialogTitle,
        values: {
            principalName: principalName
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...getConfirmationDialogDescription(),
        values: {
            b: $e9f437038d263d04$var$boldString
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        xcss: $e9f437038d263d04$var$ConfirmatonSubSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$e9f437038d263d04$var$i18n.confirmationDialogWarning,
        values: {
            b: $e9f437038d263d04$var$boldString
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        onClick: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e9f437038d263d04$var$i18n.cancelButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        testId: "confirmation-dialog-confirm-button",
        appearance: isRemoval ? 'warning' : 'primary',
        onClick: onConfirm
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), isRemoval ? $e9f437038d263d04$var$i18n.removeButtonText : $e9f437038d263d04$var$i18n.addButtonText))));
};


const $0e3e25b83ca7a775$export$a9b83e32db9bc573 = ({ principalName: principalName, isLoading: isLoading, isRemoval: isRemoval, spaceSelection: spaceSelection, onCancel: onCancel, onConfirm: onConfirm })=>{
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $67Foi.ScreenEvent), {
        name: "bulk-space-permissions-dialog",
        id: "bulk-space-permissions-dialog",
        attributes: isRemoval ? {
            action: 'remove'
        } : {
            action: 'add'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
        testId: "bulk-space-permissions-confirmation",
        onClose: // Don't allow the dialog to close while mutation is loading
        isLoading ? undefined : onCancel
    }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lM2MU.LoadingDialog), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e9f437038d263d04$export$b8704437d11c7fe7), {
        principalName: principalName,
        isRemoval: isRemoval,
        spaceSelection: spaceSelection,
        onCancel: onCancel,
        onConfirm: onConfirm
    })));
};



var $kAGh9 = parcelRequire("kAGh9");

const $eb8c51b94819be10$var$BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation = (0, $d5416dce4c756c64$export$2e2bcd8739ae039);
const $eb8c51b94819be10$export$f7109619a5e9e0d6 = 'bulkSpacePermissionsScreen';
const $eb8c51b94819be10$export$c4b5d6610bc5fc6e = (0, $kSwu1.defineMessages)({
    backToSpacePermissions: {
        id: "bulk-permissions.space-permissions-link",
        defaultMessage: "Space permissions"
    },
    bulkAddHeader: {
        id: "bulk-permissions.space.header",
        defaultMessage: "Add people to all spaces"
    },
    titleSubtext: {
        id: "bulk-permissions.space.title-subtext",
        defaultMessage: "Quickly add (or remove) an individual user or group to all spaces on your Confluence site. This will overwrite any existing access they have, which means it can also be a good way to change access for a user or group in all spaces."
    },
    titleSubtextWithTeams: {
        id: "bulk-permissions.space.title-subtext-teams",
        defaultMessage: "Quickly add (or remove) an individual user, team or group to all spaces on your Confluence site. This will overwrite any existing access they have, which means it can also be a good way to change access for a user or group in all spaces."
    },
    userPickerHeader: {
        id: "bulk-permissions.space.user-picker-header",
        defaultMessage: "Choose who to add or remove<asterisk>*</asterisk>"
    },
    userPickerSubtext: {
        id: "bulk-permissions.space.user-picker-subtext",
        defaultMessage: "You may only select one for this action."
    },
    asyncSuccessFlagTitle: {
        id: "bulk-permissions.space.async.update.success-flag-title",
        defaultMessage: "Bulk permissions change processing"
    },
    asyncSuccessFlagDescription: {
        id: "bulk-permissions.space.async.update.success-flag-description",
        defaultMessage: "These changes can take a while. We\u2019ll notify you when it\u2019s finished."
    },
    errorFlagTitle: {
        id: "bulk-permissions.space.error-flag-title",
        defaultMessage: "Bulk permissions change failed"
    },
    errorFlagDescription: {
        id: "bulk-permissions.space.error-flag-description",
        defaultMessage: "We ran into a problem completing your bulk permissions change. Try again."
    },
    userPickerPlaceholder: {
        id: "bulk-permissions.space.user-picker-placeholder",
        defaultMessage: "Enter a person or group"
    },
    userPickerWithTeamsPlaceholder: {
        id: "bulk-permissions.space.user-picker-with-teams-placeholder",
        defaultMessage: "Enter a person, team or group"
    },
    requirementMessage: {
        id: "bulk-permissions.space.requirement-message",
        defaultMessage: "<asterisk>* </asterisk> Required to perform action"
    },
    applyButtonTextAdd: {
        id: "bulk-permissions.space.apply-button-text-add",
        defaultMessage: "Add to all"
    },
    applyButtonTextRemove: {
        id: "bulk-permissions.space.apply-button-text-remove",
        defaultMessage: "Remove from all"
    }
});
const $eb8c51b94819be10$var$bulkAddHeaderStyle = (0, $buxP3.xcss)({
    font: 'font.heading.large',
    paddingBottom: 'space.100',
    paddingTop: 'space.300'
});
const $eb8c51b94819be10$var$bulkSubtextStyle = (0, $buxP3.xcss)({
    font: 'font.body'
});
const $eb8c51b94819be10$var$userPickerHeaderStyle = (0, $buxP3.xcss)({
    font: 'font.body.large',
    fontWeight: 'font.weight.medium',
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 'space.300',
    paddingBottom: 'space.100'
});
const $eb8c51b94819be10$var$asteriskStyle = (0, $buxP3.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
    color: 'color.text.accent.red'
});
const $eb8c51b94819be10$var$userPickerFineTextStyle = (0, $buxP3.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
    color: 'color.text.accent.gray',
    marginTop: 'space.050',
    font: 'font.body.small'
});
const $eb8c51b94819be10$var$contentStyle = (0, $buxP3.xcss)({
    marginLeft: 'space.1000',
    marginRight: 'space.1000'
});
const $eb8c51b94819be10$var$backButtonStyle = (0, $buxP3.xcss)({
    marginLeft: 'space.negative.200',
    paddingTop: 'space.300'
});
const $eb8c51b94819be10$var$userPickerStyle = (0, $buxP3.xcss)({
    paddingBottom: 'space.050'
});
const $eb8c51b94819be10$var$requirementMessageStyle = (0, $buxP3.xcss)({
    font: 'font.body',
    paddingTop: 'space.300'
});
const $eb8c51b94819be10$var$getPrincipalId = (principal)=>{
    if (!principal || Array.isArray(principal)) return '';
    const principalData = principal;
    return principalData.id || '';
};
const $eb8c51b94819be10$export$405a6cc8f1c994c8 = (0, $7aRa9.withFlags)((0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
})(({ flags: flags })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { isProductAdmin: isProductAdmin, isAdminCheckLoading: isAdminCheckLoading } = (0, $1BYn9.useIsProductAdmin)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    const { pickerProps: teamPickerProps } = (0, $9phVF.useTeamPicker)();
    const isFreeEdition = edition === (0, $euL71.ConfluenceEdition).FREE;
    const [spacePermissions, setSpacePermissions] = (0, $cozmU.useState)([
        (0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE
    ]);
    const [stagedPrincipal, setStagedPrincipal] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(undefined);
    const [spaceSelection, setSpaceSelection] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState((0, $8A6YM.SpaceSelection).AllExcludingPersonal);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [showDialog, setShowDialog] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const isRemoval = !spacePermissions.includes((0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE);
    const closeDialog = (0, $cozmU.useCallback)(()=>{
        setShowDialog(false);
    }, [
        setShowDialog
    ]);
    const setInitState = (0, $cozmU.useCallback)(()=>{
        setStagedPrincipal(undefined);
        setSpaceSelection((0, $8A6YM.SpaceSelection).AllExcludingPersonal);
        setSpacePermissions([
            (0, $70228f3077c41fe6$export$a99f5dae9c149910).VIEW_SPACE
        ]);
    }, []);
    const onMutationErrored = (0, $cozmU.useCallback)((error)=>{
        closeDialog();
        flags.showErrorFlag({
            id: 'bulk-space-permissions.add.error',
            title: intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.errorFlagTitle),
            description: intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.errorFlagDescription),
            isAutoDismiss: true
        });
        experienceTracker.stopOnError({
            name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE),
            error: error
        });
    }, [
        closeDialog,
        flags,
        intl,
        experienceTracker
    ]);
    const onAsyncMutationSubmitted = (0, $cozmU.useCallback)((data)=>{
        closeDialog();
        /**
     * The backend is counting the mutation as a success for some exceptions
     * but returning an error in the mutation response.  We need to check for
     * these here.
     */ if (data?.bulkSetSpacePermissionAsync?.errors?.length > 0) onMutationErrored(new Error('Bulk space permissions mutation failed', data?.bulkSetSpacePermissionAsync?.errors));
        else {
            flags.showSuccessFlag({
                id: 'bulk-space-permissions.async.update.success',
                title: intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.asyncSuccessFlagTitle),
                description: intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.asyncSuccessFlagDescription),
                isAutoDismiss: true
            });
            experienceTracker.succeed({
                name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE)
            });
        }
        setInitState();
    }, [
        closeDialog,
        setInitState,
        onMutationErrored,
        flags,
        intl,
        experienceTracker
    ]);
    const getBulkSpacePermissionSubjectType = (0, $cozmU.useCallback)(()=>{
        if (!stagedPrincipal || Array.isArray(stagedPrincipal)) return (0, $70228f3077c41fe6$export$8b2051573ac4b3d5).USER;
        const principalData = stagedPrincipal;
        return principalData.type === 'user' ? (0, $70228f3077c41fe6$export$8b2051573ac4b3d5).USER : (0, $70228f3077c41fe6$export$8b2051573ac4b3d5).GROUP;
    }, [
        stagedPrincipal
    ]);
    const getBulkSpacePermissionSpaceType = (0, $cozmU.useCallback)(()=>{
        switch(spaceSelection){
            case (0, $8A6YM.SpaceSelection).AllExcludingPersonal:
                return [
                    (0, $70228f3077c41fe6$export$e57870671ec2468e).GLOBAL,
                    (0, $70228f3077c41fe6$export$e57870671ec2468e).COLLABORATION,
                    (0, $70228f3077c41fe6$export$e57870671ec2468e).KNOWLEDGE_BASE
                ];
            case (0, $8A6YM.SpaceSelection).AllIncludingPersonal:
                return [
                    (0, $70228f3077c41fe6$export$e57870671ec2468e).PERSONAL,
                    (0, $70228f3077c41fe6$export$e57870671ec2468e).GLOBAL,
                    (0, $70228f3077c41fe6$export$e57870671ec2468e).COLLABORATION,
                    (0, $70228f3077c41fe6$export$e57870671ec2468e).KNOWLEDGE_BASE
                ];
            case (0, $8A6YM.SpaceSelection).OnlyPersonal:
                return [
                    (0, $70228f3077c41fe6$export$e57870671ec2468e).PERSONAL
                ];
            default:
                return [
                    null
                ];
        }
    }, [
        spaceSelection
    ]);
    const [bulkUpdateAsync, { loading: asyncLoading, error: asyncError }] = (0, $308Wd.useMutationInterop)($eb8c51b94819be10$var$BulkSpacePermissionsPageBulkSetSpacePermissionAsyncMutation, {
        onCompleted: onAsyncMutationSubmitted,
        onError: (err)=>{
            closeDialog();
            onMutationErrored(err);
        },
        variables: {
            spacePermissions: spacePermissions,
            subjectType: getBulkSpacePermissionSubjectType(),
            subjectId: $eb8c51b94819be10$var$getPrincipalId(stagedPrincipal),
            spaceTypes: getBulkSpacePermissionSpaceType()
        },
        __callerPackage__: "bulk-permissions"
    });
    const openDialog = (0, $cozmU.useCallback)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE)
        });
        setShowDialog(true);
    }, [
        setShowDialog,
        experienceTracker
    ]);
    const handleBackClick = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'defaultspaceperms',
                source: $eb8c51b94819be10$export$f7109619a5e9e0d6
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onSpaceRadioChange = (0, $cozmU.useCallback)((e)=>{
        setSpaceSelection(e.target.value);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'radio',
                action: 'selected',
                actionSubjectId: 'bulkSpacePermissionsType',
                source: $eb8c51b94819be10$export$f7109619a5e9e0d6,
                attributes: {
                    spaceSelection: e.target.value
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onPrincipalChange = (0, $cozmU.useCallback)((received)=>{
        // Only send an analytic event if a principal isn't deselected
        if (received && !Array.isArray(received)) {
            const principalData = received;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    actionSubject: 'principal',
                    action: 'selected',
                    actionSubjectId: 'bulkSpacePermissionsPrincipal',
                    source: $eb8c51b94819be10$export$f7109619a5e9e0d6,
                    attributes: {
                        principal: principalData.type,
                        verified: principalData.type === 'team' ? principalData.verified : 'N/A'
                    }
                }
            }).fire();
        }
        setStagedPrincipal(received);
    }, [
        createAnalyticsEvent
    ]);
    const onDialogConfirm = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'bulkSpacePermissionsConfirm',
                source: $eb8c51b94819be10$export$f7109619a5e9e0d6,
                attributes: {
                    verified: stagedPrincipal?.type === 'team' ? stagedPrincipal?.verified : 'N/A',
                    principalType: stagedPrincipal?.type || 'N/A',
                    principal: stagedPrincipal?.type,
                    action: isRemoval ? 'remove' : 'add'
                }
            }
        }).fire();
        bulkUpdateAsync();
    }, [
        createAnalyticsEvent,
        bulkUpdateAsync,
        isRemoval,
        stagedPrincipal
    ]);
    const onDialogCancel = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'bulkSpacePermissionsCancel',
                source: $eb8c51b94819be10$export$f7109619a5e9e0d6
            }
        }).fire();
        closeDialog();
        experienceTracker.abort({
            name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE),
            reason: 'User closed the dialog'
        });
    }, [
        createAnalyticsEvent,
        experienceTracker,
        closeDialog
    ]);
    // Don't render the page until we know if the user is a product admin
    // to avoid a flicker of the restricted view.
    if (isAdminCheckLoading) return null;
    if (!isProductAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eIwUX.RestrictedView), null);
    const pickerResultsFilter = (options)=>{
        // TEMPORARY WORKAROUND:
        // Smart User Picker does not currently expose a reliable field to identify guest users.
        // We're using the presence of the "GUEST" lozenge as a proxy to filter out guest users.
        // This should be revisited once the platform team adds a proper field
        // to accurately indicate guest status.
        return options.filter((option)=>{
            const { lozenge: lozenge } = option;
            const isGuest = typeof lozenge === 'object' && lozenge !== null && 'text' in lozenge && lozenge.text === 'GUEST';
            return !isGuest;
        });
    };
    const placeholderText = intl.formatMessage(teamPickerProps.includeTeamsUpdates ? $eb8c51b94819be10$export$c4b5d6610bc5fc6e.userPickerWithTeamsPlaceholder : $eb8c51b94819be10$export$c4b5d6610bc5fc6e.userPickerPlaceholder);
    return isRbacEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kAGh9.BulkAccessManagementPage), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, asyncError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: asyncError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: (0, $6mKj3.expVal)('cc_perms_enable_rbac_admin_modernization', 'isEnabled', false) ? undefined : $eb8c51b94819be10$var$contentStyle
    }, !(0, $6mKj3.expVal)('cc_perms_enable_rbac_admin_modernization', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $eb8c51b94819be10$var$backButtonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        appearance: "subtle",
        onClick: handleBackClick,
        href: (0, $1NBp8.ADMIN_SITE_SPACE_PERMISSIONS).toUrl({
            tab: 'allspaces'
        }),
        iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
                ...iconProps,
                size: "small"
            })
    }, intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.backToSpacePermissions))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $eb8c51b94819be10$var$bulkAddHeaderStyle
    }, intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.bulkAddHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $eb8c51b94819be10$var$bulkSubtextStyle
    }, intl.formatMessage(teamPickerProps.includeTeamsUpdates ? $eb8c51b94819be10$export$c4b5d6610bc5fc6e.titleSubtextWithTeams : $eb8c51b94819be10$export$c4b5d6610bc5fc6e.titleSubtext)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $eb8c51b94819be10$var$userPickerHeaderStyle
    }, intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.userPickerHeader, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $eb8c51b94819be10$var$asteriskStyle
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $eb8c51b94819be10$var$userPickerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpRYU.UserAndGroupSearchPicker), {
        ariaLabel: placeholderText,
        "data-test-id": "user-and-group-search",
        fieldId: "bulk-permissions-user-picker",
        includeGroup: true,
        withUsers: true,
        isMulti: false,
        smart: true,
        placeholder: placeholderText,
        noOptionsMessage: null,
        onChange: onPrincipalChange,
        value: stagedPrincipal || [],
        smartFilterOptions: pickerResultsFilter,
        isDisabled: isFreeEdition,
        includeTeams: teamPickerProps.includeTeams,
        includeTeamsUpdates: teamPickerProps.includeTeamsUpdates,
        verifiedTeams: teamPickerProps.verifiedTeams
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ilq3G.AgentAccessWarning), {
        stagedPrincipals: stagedPrincipal && !Array.isArray(stagedPrincipal) ? [
            stagedPrincipal
        ] : []
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $eb8c51b94819be10$var$userPickerFineTextStyle
    }, intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.userPickerSubtext)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8A6YM.SpaceSelectionRadioButtons), {
        spaceSelection: spaceSelection,
        onRadioChange: onSpaceRadioChange,
        isDisabled: isFreeEdition
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ac9ac80a1cd63f38$export$15775f46ef52c627), {
        spacePermissions: spacePermissions,
        setSpacePermissions: setSpacePermissions,
        isDisabled: isFreeEdition
    }), isRemoval && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0d65445224ec1da1$export$ebaaa2fd42680a02), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: openDialog,
        isDisabled: isFreeEdition || stagedPrincipal === undefined
    }, intl.formatMessage(isRemoval ? $eb8c51b94819be10$export$c4b5d6610bc5fc6e.applyButtonTextRemove : $eb8c51b94819be10$export$c4b5d6610bc5fc6e.applyButtonTextAdd)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        xcss: $eb8c51b94819be10$var$requirementMessageStyle
    }, intl.formatMessage($eb8c51b94819be10$export$c4b5d6610bc5fc6e.requirementMessage, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $eb8c51b94819be10$var$asteriskStyle
            }, chunks)
    }))), showDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0e3e25b83ca7a775$export$a9b83e32db9bc573), {
        principalName: !stagedPrincipal || Array.isArray(stagedPrincipal) ? '' : stagedPrincipal.name || '',
        isRemoval: isRemoval,
        spaceSelection: spaceSelection,
        isLoading: asyncLoading,
        onConfirm: onDialogConfirm,
        onCancel: onDialogCancel
    }));
}));
module.exports["ANALYTICS_SOURCE"] = $eb8c51b94819be10$export$f7109619a5e9e0d6;
module.exports["i18nBulk"] = $eb8c51b94819be10$export$c4b5d6610bc5fc6e;
module.exports["BulkSpacePermissionsPage"] = $eb8c51b94819be10$export$405a6cc8f1c994c8;

});

parcelRegister("1BYn9", function(module, exports) {

var $3TDto = parcelRequire("3TDto");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $fWkVZ = parcelRequire("fWkVZ");


var $1JEqL = parcelRequire("1JEqL");


var $jMyy4 = parcelRequire("jMyy4");

const $141bd073c52fec74$export$44f5b9746e66da9 = ()=>{
    const { data: data, error: error, loading: isAdminCheckLoading } = (0, $jMyy4.useQueryInterop)((0, $3TDto.default), {
        __callerPackage__: "current-user"
    });
    if (error) {
        if (!(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    const isProductAdmin = (0, $fWkVZ.getIsProductAdminFromQuery)(data);
    const isProductOrSiteAdmin = (0, $1JEqL.getIsProductOrSiteAdminFromQuery)(data);
    return {
        isProductAdmin: isProductAdmin,
        isProductOrSiteAdmin: isProductOrSiteAdmin,
        isAdminCheckLoading: isAdminCheckLoading
    };
};
module.exports["useIsProductAdmin"] = $141bd073c52fec74$export$44f5b9746e66da9;

});

parcelRegister("3TDto", function(module, exports) {
/**
 * @generated SignedSource<<5ad29dfea09a4ca6925d754e625f4e3a>>
 * @relayHash d40e79986defbb74ee71a42460f4e593
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fe516d70b362da33d2c9dc8e98f7d27b5868b10eb9ecfdd545bfad6f07fa6622
const $7c2c3a08c3ad61f2$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        },
        {
            "kind": "ScalarField",
            "name": "isSiteAdmin"
        },
        {
            "kind": "ScalarField",
            "name": "hasUserAccessAdminRole"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIsProductAdminUseIsProductAdminQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIsProductAdminUseIsProductAdminQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "d40e79986defbb74ee71a42460f4e593",
            "id": "fe516d70b362da33d2c9dc8e98f7d27b5868b10eb9ecfdd545bfad6f07fa6622",
            "metadata": {},
            "name": "useIsProductAdminUseIsProductAdminQuery",
            "operationKind": "query",
            "text": "query useIsProductAdminUseIsProductAdminQuery{user:confluence_atlassianUser(current:true){id,confluence{operations{operation,targetType}}},isSiteAdmin,hasUserAccessAdminRole}"
        }
    };
}();
$7c2c3a08c3ad61f2$var$node.hash = "179058bf05f0f539ac360b7a899d6923";
var $7c2c3a08c3ad61f2$export$2e2bcd8739ae039 = $7c2c3a08c3ad61f2$var$node;
module.exports["default"] = $7c2c3a08c3ad61f2$export$2e2bcd8739ae039;

});

parcelRegister("fWkVZ", function(module, exports) {
const $b7fc105cb96f63fd$export$7ed4faccc7e85b7f = (queryData)=>Boolean(queryData?.user?.confluence?.operations?.some((o)=>o?.operation === 'administer' && o?.targetType === 'application'));
module.exports["getIsProductAdminFromQuery"] = $b7fc105cb96f63fd$export$7ed4faccc7e85b7f;

});

parcelRegister("1JEqL", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $eJhXX = parcelRequire("eJhXX");


var $icMDs = parcelRequire("icMDs");

function $e18808c613ab8370$export$138f02318593ab4(queryData) {
    const userPrivilege = (0, $eJhXX.getUserPrivilegeFromQuery)(queryData);
    return userPrivilege === (0, $icMDs.UserPrivilege).PRODUCT_ADMIN || userPrivilege === (0, $icMDs.UserPrivilege).SITE_ADMIN;
}
module.exports["getIsProductOrSiteAdminFromQuery"] = $e18808c613ab8370$export$138f02318593ab4;

});

parcelRegister("eJhXX", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $fWkVZ = parcelRequire("fWkVZ");


var $w033M = parcelRequire("w033M");


var $icMDs = parcelRequire("icMDs");

function $a7000458c02582d2$export$d036114e4ad5c4c3(queryData) {
    const isSiteAdmin = (0, $w033M.getIsSiteAdminFromQuery)(queryData);
    const isProductAdmin = (0, $fWkVZ.getIsProductAdminFromQuery)(queryData);
    return typeof queryData === 'undefined' ? undefined : isSiteAdmin ? (0, $icMDs.UserPrivilege).SITE_ADMIN : isProductAdmin ? (0, $icMDs.UserPrivilege).PRODUCT_ADMIN : (0, $icMDs.UserPrivilege).NON_ADMIN;
}
module.exports["getUserPrivilegeFromQuery"] = $a7000458c02582d2$export$d036114e4ad5c4c3;

});

parcelRegister("w033M", function(module, exports) {
const $ea2c8f52a33264f1$export$4782acb2cb5b7c11 = (queryData)=>Boolean(queryData?.isSiteAdmin);
module.exports["getIsSiteAdminFromQuery"] = $ea2c8f52a33264f1$export$4782acb2cb5b7c11;

});

parcelRegister("icMDs", function(module, exports) {
var $296e2d91f769f195$export$fa8745fb6d256802 = /*#__PURE__*/ function(UserPrivilege) {
    UserPrivilege["NON_ADMIN"] = "nonAdmin";
    UserPrivilege["PRODUCT_ADMIN"] = "productAdmin";
    UserPrivilege["SITE_ADMIN"] = "siteAdmin";
    return UserPrivilege;
}({});
module.exports["UserPrivilege"] = $296e2d91f769f195$export$fa8745fb6d256802;

});

parcelRegister("hpRYU", function(module, exports) {

var $1dUJk = parcelRequire("1dUJk");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kfLla = parcelRequire("kfLla");


var $l9ukq = parcelRequire("l9ukq");


var $24tIi = parcelRequire("24tIi");


var $bQm3c = parcelRequire("bQm3c");


var $iMnC5 = parcelRequire("iMnC5");


var $b3j2Y = parcelRequire("b3j2Y");


var $7lu50 = parcelRequire("7lu50");


var $7Sm4c = parcelRequire("7Sm4c");


var $83Z6R = parcelRequire("83Z6R");


var $jjoF2 = parcelRequire("jjoF2");


var $VQdE0 = parcelRequire("VQdE0");


var $g3p2i = parcelRequire("g3p2i");


var $jMyy4 = parcelRequire("jMyy4");

const $4cbf051190fe8573$var$MIN_SEARCH_LENGTH = 2;
const $4cbf051190fe8573$export$1434adfffc17371d = 200;
const $4cbf051190fe8573$var$withoutAriaLabelledBy = (props)=>{
    const { 'aria-labelledby': _ariaLabelledBy, ...inputProps } = props;
    return inputProps;
};
const $4cbf051190fe8573$var$LabelledInput = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Input, $4cbf051190fe8573$var$withoutAriaLabelledBy(props));
const $4cbf051190fe8573$var$wrapWithLabelledInput = (InputComponent)=>{
    const WrappedLabelledInput = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InputComponent, $4cbf051190fe8573$var$withoutAriaLabelledBy(props));
    return WrappedLabelledInput;
};
const $4cbf051190fe8573$var$getLabelledComponents = (components)=>{
    return {
        ...components,
        Input: components?.Input ? $4cbf051190fe8573$var$wrapWithLabelledInput(components.Input) : $4cbf051190fe8573$var$LabelledInput
    };
};
function $4cbf051190fe8573$export$e11674744930cd15(error) {
    if ('statusCode' in error && error['statusCode'] === 403 || error.message?.includes('403') || error.message?.includes('not allowed')) return true;
    return false;
}
const $4cbf051190fe8573$var$DefaultWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, children);
const $4cbf051190fe8573$export$fd4159eb872f73c6 = ({ appearance: appearance, fieldId: fieldId, isMulti: isMulti, includeGroup: includeGroup, onSelect: onSelect, onChange: onChange, onClear: onClear, onFocus: onFocus, onBlur: onBlur, onOpen: onOpen, onClose: onClose, onInputChange: onInputChange, onKeyDown: onKeyDown, filterSearchResults: filterSearchResults, smartFilterOptions: smartFilterOptions, value: value, defaultValue: defaultValue, noOptionsMessage: noOptionsMessage, addMoreMessage: addMoreMessage, menuPortalTarget: menuPortalTarget, autoFocus: autoFocus, width: width, maxPickerHeight: maxPickerHeight, smart: smart, styles: styles, placeholder: placeholder, sitePermissionTypeFilter: sitePermissionTypeFilter = (0, $g3p2i.SitePermissionTypeFilter).NONE, displayEmailInByline: displayEmailInByline, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, enableEmailSearch: enableEmailSearch, allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched, includeTeams: includeTeams, includeTeamsUpdates: includeTeamsUpdates, verifiedTeams: verifiedTeams, menuPosition: menuPosition, customInclusion: customInclusion = [], ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, 'aria-labelledby': ariaLabelledByFromField, ariaDescribedBy: ariaDescribedBy, role: role, isDisabled: isDisabled = false, isLoading: isLoading = false, bootstrapOptions: bootstrapOptions = [], inputId: inputId, withUsers: withUsers = true, Wrapper: Wrapper = $4cbf051190fe8573$var$DefaultWrapper, header: header, open: open, userpickerDescribedbyId: userpickerDescribedbyId, isClearable: isClearable = true, includeUsers: includeUsers = true, transformOptions: transformOptions, userResolvers: userResolvers, components: components, isHeaderFocused: isHeaderFocused, setIsHeaderFocused: setIsHeaderFocused })=>{
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const queryUserAndGroupSearch = (0, $83Z6R.useLazyQueryPromiseInterop)((0, $VQdE0.default), {
        __callerPackage__: "user-and-group-search"
    });
    const { loading: searchPickerLoading, data: searchPickerData } = (0, $jMyy4.useQueryInterop)((0, $1dUJk.default), {
        __callerPackage__: "user-and-group-search"
    });
    const handleError = (searchError)=>{
        if (searchError) {
            setError(searchError);
            // mark error as handled so we don't have ui unhandled errors
            (0, $7Sm4c.markErrorAsHandled)(searchError);
        }
    };
    const promiseOptions = (searchTerm)=>!searchTerm || searchTerm.length < $4cbf051190fe8573$var$MIN_SEARCH_LENGTH ? [] : (0, $jjoF2.userGroupSearchPromise)({
            searchTerm: searchTerm,
            queryData: queryUserAndGroupSearch({
                variables: {
                    withGroups: includeGroup,
                    searchTerm: searchTerm,
                    sitePermissionTypeFilter: sitePermissionTypeFilter,
                    withUsers: withUsers
                }
            }),
            customInclusion: customInclusion,
            setError: setError,
            filterResults: filterSearchResults
        });
    const searchErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "user-and-group-search.search.error",
        defaultMessage: "Sorry, we\u2019re having trouble loading search results right now."
    });
    const permissionErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "user-and-group-search.permission.error",
        defaultMessage: "We couldn\u2019t find any results because you don't have permission to search the user directory."
    });
    // TODO: <UserPicker> expects `noOptionsMessage` to return string | null
    // but this callback returns JSX.Element | string | null, so error message must be string.
    const emptyResultsMessage = (input)=>{
        if (error) {
            if ($4cbf051190fe8573$export$e11674744930cd15(error)) return permissionErrorMessage;
            return searchErrorMessage;
        } else if (typeof noOptionsMessage === 'function') return noOptionsMessage(input);
        return noOptionsMessage;
    };
    const isEntitledExternalCollaboration = (0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(searchPickerData) ?? false;
    const finalPlaceholder = placeholder || (includeGroup ? allowEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "user-and-group-search.placeholder.text.users.groups.and.email",
        defaultMessage: "Add people by name, email, or group"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "user-and-group-search.placeholder.text.users.and.groups",
        // TODO: a content designer should check this case. This isn't the usual sentence structure for placeholders.
        defaultMessage: "Type a user name or group"
    }) : allowEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "user-and-group-search.placeholder.text.users.and.email",
        defaultMessage: "Add people, emails"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "user-and-group-search.placeholder.text.users",
        // TODO: a content designer should check this case. This isn't the usual sentence structure for placeholders.
        defaultMessage: "Type a user name"
    }));
    const pickerAriaLabelledBy = ariaLabel ? undefined : ariaLabelledBy || ariaLabelledByFromField || `react-select-${fieldId}-placeholder`;
    const pickerComponents = (0, $cozmU.useMemo)(()=>ariaLabel ? $4cbf051190fe8573$var$getLabelledComponents(components) : components, [
        ariaLabel,
        components
    ]);
    const commonProps = {
        appearance: appearance,
        placeholder: finalPlaceholder,
        addMoreMessage: addMoreMessage,
        isMulti: isMulti,
        defaultValue: defaultValue,
        fieldId: fieldId,
        menuPortalTarget: menuPortalTarget,
        noOptionsMessage: emptyResultsMessage,
        onChange: onChange,
        onClear: onClear,
        onFocus: onFocus,
        onOpen: onOpen,
        onClose: onClose,
        onInputChange: onInputChange,
        onSelection: onSelect,
        value: value,
        width: width,
        maxPickerHeight: maxPickerHeight,
        displayEmailInByline: displayEmailInByline,
        allowEmail: allowEmail,
        suggestEmailsForDomain: suggestEmailsForDomain,
        enableEmailSearch: enableEmailSearch,
        allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched,
        styles: styles,
        menuPosition: menuPosition,
        isDisabled: isDisabled,
        inputId: inputId,
        components: pickerComponents,
        withUsers: // Type assertion: runtime receives Option, but UserPicker types expect OptionData
        withUsers,
        header: header,
        open: open,
        ariaLabel: ariaLabel,
        ariaLabelledBy: pickerAriaLabelledBy,
        'aria-describedby': userpickerDescribedbyId,
        isHeaderFocused: isHeaderFocused,
        setIsHeaderFocused: setIsHeaderFocused
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Wrapper, {
        "aria-label": ariaLabel,
        "aria-describedby": ariaDescribedBy,
        role: role
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }) : null, !smart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kfLla.UserPicker), {
        ...commonProps,
        inputId: inputId,
        autoFocus: autoFocus,
        loadOptions: promiseOptions,
        // bug with UserPicker forces us to use a callback rather than just pass in a string
        onBlur: onBlur,
        isLoading: isLoading,
        appearance: appearance,
        isClearable: isClearable
    }), smart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $24tIi.default), {
        ...commonProps,
        inputId: inputId,
        debounceTime: $4cbf051190fe8573$export$1434adfffc17371d,
        includeGroups: includeGroup,
        includeUsers: includeUsers,
        isLoading: searchPickerLoading || isLoading,
        maxOptions: 60,
        onError: handleError,
        filterOptions: smartFilterOptions,
        productAttributes: {
            isEntitledConfluenceExternalCollaborator: isEntitledExternalCollaboration
        },
        principalId: "context",
        productKey: "confluence",
        autoFocus: autoFocus,
        siteId: cloudId,
        orgId: orgId,
        includeTeams: includeTeams,
        includeTeamsUpdates: includeTeamsUpdates,
        verifiedTeams: verifiedTeams,
        bootstrapOptions: bootstrapOptions,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        isClearable: isClearable,
        transformOptions: transformOptions,
        userResolvers: userResolvers,
        displayEmailInByline: true,
        enableEmailSearch: true,
        allowEmailSelectionWhenEmailMatched: false,
        isTeamSyncedToGroupDirectoryFilter: true
    }));
};
const $4cbf051190fe8573$export$ca514d5352bb0171 = $4cbf051190fe8573$export$fd4159eb872f73c6;
module.exports["UserAndGroupSearchPicker"] = $4cbf051190fe8573$export$ca514d5352bb0171;

});

parcelRegister("1dUJk", function(module, exports) {
/**
 * @generated SignedSource<<b63c5c1bb2388ba01c0f335df08966f1>>
 * @relayHash 55f887ce338962f3d231967eb05baaf5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f5f3ec7358095a4d557e0d2edf4c5f6fa4971b5401acfcdacb83cc07f551b55a
const $a7eff2b640cdd5ac$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ExternalCollaboratorFeature",
                    "kind": "LinkedField",
                    "name": "externalCollaborator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "UserAndGroupSearchPickerQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "UserAndGroupSearchPickerQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "55f887ce338962f3d231967eb05baaf5",
            "id": "f5f3ec7358095a4d557e0d2edf4c5f6fa4971b5401acfcdacb83cc07f551b55a",
            "metadata": {},
            "name": "UserAndGroupSearchPickerQuery",
            "operationKind": "query",
            "text": "query UserAndGroupSearchPickerQuery{entitlements{externalCollaborator{isEntitled}}}"
        }
    };
}();
$a7eff2b640cdd5ac$var$node.hash = "6fe67cddff8056d8e38840c5214712ee";
var $a7eff2b640cdd5ac$export$2e2bcd8739ae039 = $a7eff2b640cdd5ac$var$node;
module.exports["default"] = $a7eff2b640cdd5ac$export$2e2bcd8739ae039;

});

parcelRegister("83Z6R", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7EPz1 = parcelRequire("7EPz1");


var $6SsN4 = parcelRequire("6SsN4");


var $422HI = parcelRequire("422HI");


var $zXpxJ = parcelRequire("zXpxJ");


var $iffSy = parcelRequire("iffSy");


var $7q7rs = parcelRequire("7q7rs");


var $7M67g = parcelRequire("7M67g");


var $86okN = parcelRequire("86okN");


var $iF5wn = parcelRequire("iF5wn");

/**
 * Coerce an unknown thrown value into an ApolloErrorInterop, so a rejection carries Apollo's
 * `graphQLErrors` / `networkError` fields on both branches. Mirrors the helper in
 * `useLazyQueryInterop`.
 */ function $b847dc1d37d68706$var$toApolloError(err) {
    if ((0, $422HI.isApolloError)(err)) return err;
    const networkError = err instanceof Error ? err : new Error(String(err));
    return new (0, $422HI.ApolloErrorInterop)({
        networkError: networkError
    });
}
function $b847dc1d37d68706$export$dcf9d4e77de27956(query, options) {
    const operationName = (0, $7M67g.getRelayOperationName)(query);
    if ((0, $iffSy.isRelayEnabled)(options?.__callerPackage__, {
        operationName: operationName,
        phase: 'lazy'
    })) // eslint-disable-next-line react-hooks/rules-of-hooks -- Apollo/Relay route is branch-stable for a given caller package.
    return $b847dc1d37d68706$var$useLazyQueryPromiseInteropRelay(query, options);
    // eslint-disable-next-line react-hooks/rules-of-hooks -- Apollo/Relay route is branch-stable for a given caller package.
    return $b847dc1d37d68706$var$useLazyQueryPromiseInteropApollo(query, options);
}
const $b847dc1d37d68706$var$useLazyQueryPromiseInteropApollo = (0, $3u0dr.isReactCompilerActiveV2)() ? function useLazyQueryPromiseInteropApollo(query, options) {
    const $ = (0, $bDgLe.c)(13);
    const resolversRef = (0, $cozmU.useRef)();
    let t0;
    if ($[0] !== query) {
        t0 = (0, $86okN.toDocumentNode)(query);
        $[0] = query;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== options) {
        t1 = options && {
            ...options,
            fetchPolicy: (0, $7q7rs.mapFetchPolicyForApollo)(options.fetchPolicy),
            ...options.nextFetchPolicy ? {
                nextFetchPolicy: (0, $7q7rs.mapFetchPolicyForApollo)(options.nextFetchPolicy)
            } : {}
        };
        $[2] = options;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = [
            t0,
            t1
        ];
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    const [doQuery, t3] = (0, $7EPz1.useLazyQuery)(...t2);
    const { data: data, error: error } = t3;
    let t4;
    let t5;
    if ($[7] !== data || $[8] !== error) {
        t4 = ()=>{
            if (data) resolversRef.current?.resolve?.(data);
            if (error) resolversRef.current?.reject?.(error);
        };
        t5 = [
            data,
            error
        ];
        $[7] = data;
        $[8] = error;
        $[9] = t4;
        $[10] = t5;
    } else {
        t4 = $[9];
        t5 = $[10];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[11] !== doQuery) {
        t6 = (vars)=>{
            let resolve;
            let reject;
            const promise = new Promise((res, rej)=>{
                resolve = res;
                reject = rej;
            });
            resolversRef.current = {
                resolve: resolve,
                reject: reject
            };
            doQuery(vars);
            return promise;
        };
        $[11] = doQuery;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : function useLazyQueryPromiseInteropApollo(query, options) {
    const resolversRef = (0, $cozmU.useRef)();
    /**
   * NOTE: Using `onCompleted` and `onError` callbacks does not work as expected due to Apollo bug which is present in both v2 and v3 - https://github.com/apollographql/apollo-client/issues/9338
   */ // Interop-only fetch policies must be translated or they reach Apollo untranslated and silently
    // degrade to its default cache behaviour. That matters for `'no-store'` specifically: Apollo's
    // `'no-cache'` is its exact equivalent, and without this mapping a query that is correct today
    // would start writing to the cache.
    const [doQuery, { data: data, error: error }] = (0, $7EPz1.useLazyQuery)(...[
        (0, $86okN.toDocumentNode)(query),
        options && {
            ...options,
            fetchPolicy: (0, $7q7rs.mapFetchPolicyForApollo)(options.fetchPolicy),
            ...options.nextFetchPolicy ? {
                nextFetchPolicy: (0, $7q7rs.mapFetchPolicyForApollo)(options.nextFetchPolicy)
            } : {}
        }
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (data) resolversRef.current?.resolve?.(data);
        if (error) resolversRef.current?.reject?.(error);
    }, [
        data,
        error
    ]);
    return (0, $cozmU.useCallback)((vars)=>{
        let resolve;
        let reject;
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        // @ts-expect-error `resolve` and `reject` *will* be assigned via the Promise constructor, but TS can't guarantee that. This should be replaced with `Promise.withResolvers` once out jest setup properly supports that
        resolversRef.current = {
            resolve: resolve,
            reject: reject
        };
        doQuery(vars);
        return promise;
    }, [
        doQuery
    ]);
};
function $b847dc1d37d68706$var$useLazyQueryPromiseInteropRelay(query, options) {
    // Validate before any hook call so the throw isn't masked by useRelayEnvironment().
    if (!('params' in query)) throw new Error(`[Relay migration] unsupported tagged node provided for operation "${(0, $7M67g.getRelayOperationName)(query) ?? 'unknown'}". Please make sure you generated Relay artifacts for your operation`);
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const operationName = (0, $7M67g.getRelayOperationName)(query) ?? undefined;
    const hookVariables = (0, $iF5wn.useMemoObj)(options?.variables, options?.__callerPackage__, {
        operationName: operationName,
        phase: 'memo'
    });
    // Read through refs rather than closing over these directly, so the returned callback keeps a
    // `[environment, query]` dependency list. Every current caller drives it from a `useEffect`
    // dependency array, so a new identity per render would re-fire the query on each render.
    // `context` in particular is usually an inline object and would change identity every time.
    const latestOptionsRef = (0, $cozmU.useRef)(options);
    latestOptionsRef.current = options;
    const hookVariablesRef = (0, $cozmU.useRef)(hookVariables);
    hookVariablesRef.current = hookVariables;
    return (0, $cozmU.useCallback)((callOptions)=>{
        const hookOptions = latestOptionsRef.current;
        // Per-call options win over hook-level ones, and variables merge rather than replace —
        // matching Apollo, which merges the variables handed to its lazy `doQuery` over the ones
        // given to the hook.
        const variables = {
            ...hookVariablesRef.current,
            ...callOptions?.variables
        };
        // Shared with `queryInterop` so the fetch-policy mapping and the `noStore` derivation have
        // one home. `noStore` is load-bearing for this hook specifically: `PagePanelContentQuery`
        // runs through it and is one of the operations whose response carries two `Content` objects
        // sharing an id, so a missed flag reintroduces the record collision.
        return (0, $zXpxJ.executeRelayQuery)({
            environment: environment,
            query: query,
            variables: variables,
            fetchPolicy: callOptions?.fetchPolicy ?? hookOptions?.fetchPolicy,
            errorPolicy: callOptions?.errorPolicy ?? hookOptions?.errorPolicy ?? 'none',
            context: callOptions?.context ?? hookOptions?.context
        }).then((result)=>{
            // Diverges from `queryInterop`, which hands `{ data, error }` back: this hook mirrors
            // Apollo's promise, which rejects. Under `errorPolicy: 'all'` a result carries both
            // data and error, and Apollo's effect resolves before it rejects — a promise settles
            // once — so data being present means resolve.
            if (result.error && result.data === undefined) throw result.error;
            return result.data;
        }).catch((err)=>{
            // Reject with an ApolloErrorInterop on both branches, so callers can read
            // `graphQLErrors` / `networkError` without knowing which branch ran.
            throw $b847dc1d37d68706$var$toApolloError(err);
        });
    }, [
        environment,
        query
    ]);
}
module.exports["useLazyQueryPromiseInterop"] = $b847dc1d37d68706$export$dcf9d4e77de27956;

});

parcelRegister("jjoF2", function(module, exports) {

var $9fywD = parcelRequire("9fywD");


var $11dKl = parcelRequire("11dKl");


var $9eE57 = parcelRequire("9eE57");


var $g3p2i = parcelRequire("g3p2i");

const $9d3a4572140e810a$export$c139484855007019 = ({ searchTerm: searchTerm, queryData: queryData, customInclusion: customInclusion, setError: setError, filterResults: filterResults })=>{
    const subject = 'userAndGroupSearchQuery';
    (0, $9eE57.perfMarkStart)({
        subject: subject
    });
    return queryData.then((data)=>{
        const { users: users = [], groups: groups = [] } = data.userGroupSearch ?? {};
        const userList = users.map((item)=>({
                id: `user-${item && 'accountId' in item ? item.accountId : ''}`,
                name: item?.displayName || '',
                extra: item,
                type: 'user',
                avatarUrl: item?.profilePicture ? item.profilePicture.path : '',
                lozenge: // ExternalUserLozengeProps type has same name as the one provided by @atlaskit/user-picker but different properties.
                // casting for now to avoid TS error, no change to original properties
                item?.permissionType === (0, $g3p2i.SitePermissionType).EXTERNAL ? (0, $9fywD.ExternalUserLozengeProps) : null
            }));
        const groupList = groups.map((item)=>({
                id: `group-${item?.id}`,
                name: item?.name || '',
                type: 'group',
                extra: item,
                lozenge: // ExternalUserLozengeProps type has same name as the one provided by @atlaskit/user-picker but different properties.
                // casting for now to avoid TS error, no change to original properties
                item?.permissionType === (0, $g3p2i.SitePermissionType).EXTERNAL ? (0, $11dKl.ExternalGroupLozengeProps) : null
            }));
        const customInclusionList = [];
        const cleanedSearchTerm = searchTerm.replace(/\s/g, '').toLowerCase();
        customInclusion.forEach((inclusionObj)=>{
            Object.keys(inclusionObj).forEach((key)=>{
                if (key.toLowerCase().includes(cleanedSearchTerm)) customInclusionList.push(inclusionObj[key]);
            });
        });
        const usersGroupsAndAccessClasses = [
            ...customInclusionList,
            ...userList,
            ...groupList
        ];
        (0, $9eE57.perfMarkEnd)({
            subject: subject
        });
        return filterResults ? usersGroupsAndAccessClasses.filter(filterResults) : usersGroupsAndAccessClasses;
    }).catch((error)=>{
        setError(error);
        return [];
    });
};
module.exports["userGroupSearchPromise"] = $9d3a4572140e810a$export$c139484855007019;

});

parcelRegister("11dKl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9KSWX = parcelRequire("9KSWX");


var $lpNn5 = parcelRequire("lpNn5");

const $f9006b515271a00f$var$i18n = (0, $kSwu1.defineMessages)({
    externalGroupLozengeText: {
        id: "external-collab-ui.group-guest-lozenge",
        defaultMessage: "Guest"
    },
    externalGroupTooltip: {
        id: "external-collab-ui.group-guest-lozenge.tooltip",
        defaultMessage: "Guest groups can only access certain spaces and have limited access to user info."
    }
});
const $f9006b515271a00f$export$fef38ba78dbe85a6 = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f9006b515271a00f$var$i18n.externalGroupTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f9006b515271a00f$var$i18n.externalGroupLozengeText)),
    appearance: 'new',
    isBold: false
};
const $f9006b515271a00f$export$e899659b70340bcf = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $f9006b515271a00f$export$fef38ba78dbe85a6;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalGroupLozengeProps"] = $f9006b515271a00f$export$fef38ba78dbe85a6;

});

parcelRegister("g3p2i", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $fc6a2e7c662c45f6$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
var $fc6a2e7c662c45f6$export$3347a7c058a0368a = /*#__PURE__*/ function(SitePermissionTypeFilter) {
    SitePermissionTypeFilter["ALL"] = "ALL";
    SitePermissionTypeFilter["EXTERNALCOLLABORATOR"] = "EXTERNALCOLLABORATOR";
    SitePermissionTypeFilter["NONE"] = "NONE";
    return SitePermissionTypeFilter;
}({});
module.exports["SitePermissionType"] = $fc6a2e7c662c45f6$export$8995abb8169b2cb8;
module.exports["SitePermissionTypeFilter"] = $fc6a2e7c662c45f6$export$3347a7c058a0368a;

});

parcelRegister("VQdE0", function(module, exports) {
/**
 * @generated SignedSource<<d8c13f003578e6757b54483ce7e2bebb>>
 * @relayHash 8824351f0529abac5573900b2bee2db5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f8b43e5b1993f0813a23a44917516743e194299c3565ccbf17994b391776751
const $3fbecf5b2b9bf0ac$var$node = function() {
    var v0 = {
        "defaultValue": 50,
        "kind": "LocalArgument",
        "name": "maxResults"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchTerm"
    }, v2 = {
        "defaultValue": "NONE",
        "kind": "LocalArgument",
        "name": "sitePermissionTypeFilter"
    }, v3 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "withGroups"
    }, v4 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "withUsers"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "maxResults",
            "variableName": "maxResults"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "searchTerm"
        },
        {
            "kind": "Variable",
            "name": "sitePermissionTypeFilter",
            "variableName": "sitePermissionTypeFilter"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v11 = {
        "condition": "withGroups",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "Group",
                "kind": "LinkedField",
                "name": "groups",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    v8 /*: any*/ 
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "UserAndGroupSearchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "GraphQLUserAndGroupSearchResults",
                    "kind": "LinkedField",
                    "name": "userGroupSearch",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "withUsers",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "users",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v11 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "UserAndGroupSearchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "GraphQLUserAndGroupSearchResults",
                    "kind": "LinkedField",
                    "name": "userGroupSearch",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "withUsers",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "users",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v11 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "8824351f0529abac5573900b2bee2db5",
            "id": "2f8b43e5b1993f0813a23a44917516743e194299c3565ccbf17994b391776751",
            "metadata": {},
            "name": "UserAndGroupSearchQuery",
            "operationKind": "query",
            "text": "query UserAndGroupSearchQuery($searchTerm:String!,$maxResults:Int=50,$withGroups:Boolean=true,$withUsers:Boolean=true,$sitePermissionTypeFilter:SitePermissionTypeFilter=NONE){userGroupSearch(query:$searchTerm,maxResults:$maxResults,sitePermissionTypeFilter:$sitePermissionTypeFilter){users@include(if:$withUsers){__typename,type,displayName,permissionType,profilePicture{path},...on KnownUser{accountId}},groups@include(if:$withGroups){id,name,permissionType}}}"
        }
    };
}();
$3fbecf5b2b9bf0ac$var$node.hash = "52200fecbeb2441b36c8ceb106bad130";
var $3fbecf5b2b9bf0ac$export$2e2bcd8739ae039 = $3fbecf5b2b9bf0ac$var$node;
module.exports["default"] = $3fbecf5b2b9bf0ac$export$2e2bcd8739ae039;

});

parcelRegister("aJv6Q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("cp4jg", function(module, exports) {
$parcel$export(module.exports, "useTeamPicker", () => (parcelRequire("9phVF")).useTeamPicker);

var $9phVF = parcelRequire("9phVF");


});

parcelRegister("9phVF", function(module, exports) {

var $dSrQ9 = parcelRequire("dSrQ9");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");

const $61edd6b4188abea2$var$useTeamPickerQuery = (0, $dSrQ9.default);
function $61edd6b4188abea2$var$modeToPickerProps(mode) {
    switch(mode){
        case 'ALL_TEAMS':
            return {
                includeTeams: true,
                verifiedTeams: false,
                includeTeamsUpdates: true
            };
        case 'VERIFIED_TEAMS':
            return {
                includeTeams: true,
                verifiedTeams: true,
                includeTeamsUpdates: true
            };
        case null:
            return {
                includeTeams: false,
                verifiedTeams: false,
                includeTeamsUpdates: false
            };
        case undefined:
            return {
                includeTeams: false,
                verifiedTeams: false,
                includeTeamsUpdates: false
            };
        default:
            return {
                includeTeams: false,
                verifiedTeams: false,
                includeTeamsUpdates: true
            };
    }
}
const $61edd6b4188abea2$export$45e9f296b7c501d5 = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data } = (0, $jMyy4.useQueryInterop)($61edd6b4188abea2$var$useTeamPickerQuery, {
        variables: {
            cloudId: cloudId
        },
        fetchPolicy: 'network-only',
        onError: (error)=>{
            (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "permissions-principals"
    });
    const pickerProps = (0, $cozmU.useMemo)(()=>{
        // If admin controls data is available (mode is a valid string), use it to determine team picker props
        const mode = data?.confluence_teamAdminControlsSettings?.teamAdminControlsMode;
        if (mode !== undefined && mode !== null) return $61edd6b4188abea2$var$modeToPickerProps(mode);
        // Fallback: TaP is enabled - show all teams
        return {
            includeTeams: true,
            verifiedTeams: false,
            includeTeamsUpdates: true
        };
    }, [
        data?.confluence_teamAdminControlsSettings?.teamAdminControlsMode
    ]);
    return {
        pickerProps: pickerProps
    };
};
module.exports["useTeamPicker"] = $61edd6b4188abea2$export$45e9f296b7c501d5;

});

parcelRegister("dSrQ9", function(module, exports) {
/**
 * @generated SignedSource<<829e3b77762a8f9c571a6ef3da4b4aac>>
 * @relayHash 2e65e91f973b80aa33359c025ddf81a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 77dcf45d142c697ffdd43103256587365d38330f7009874092b2ee7f4a8216ce
const $5dc9ca3ab5de68d7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceTeamAdminControlsSettings",
            "kind": "LinkedField",
            "name": "confluence_teamAdminControlsSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "teamAdminControlsMode"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTeamPickerQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTeamPickerQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2e65e91f973b80aa33359c025ddf81a0",
            "id": "77dcf45d142c697ffdd43103256587365d38330f7009874092b2ee7f4a8216ce",
            "metadata": {},
            "name": "useTeamPickerQuery",
            "operationKind": "query",
            "text": "query useTeamPickerQuery($cloudId:ID!){confluence_teamAdminControlsSettings(cloudId:$cloudId){teamAdminControlsMode}}"
        }
    };
}();
$5dc9ca3ab5de68d7$var$node.hash = "f35bcbb3a9ec452df1f7352ea21732d6";
var $5dc9ca3ab5de68d7$export$2e2bcd8739ae039 = $5dc9ca3ab5de68d7$var$node;
module.exports["default"] = $5dc9ca3ab5de68d7$export$2e2bcd8739ae039;

});

parcelRegister("4ikjJ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7r5Hr = parcelRequire("7r5Hr");


var $dpsRj = parcelRequire("dpsRj");

const $f465330fb8737fdd$var$packageName = "platform-pkg";
const $f465330fb8737fdd$var$packageVersion = "0.0.0-use.local";
const $f465330fb8737fdd$var$noop = (0, $dpsRj.default);
const $f465330fb8737fdd$var$labelPaddingStyles = null;
const $f465330fb8737fdd$var$labelStyles = null;
const $f465330fb8737fdd$var$labelDisabledStyles = null;
const $f465330fb8737fdd$var$radioBaseStyles = null;
const $f465330fb8737fdd$var$radioInteractiveStyles = null;
const $f465330fb8737fdd$var$radioDisabledStyles = null;
const $f465330fb8737fdd$var$radioDisabledCheckedStyles = null;
const $f465330fb8737fdd$var$radioInvalidStyles = null;
const $f465330fb8737fdd$var$InnerRadio = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Radio(props, ref) {
    const $ = (0, $bDgLe.c)(47);
    let analyticsContext;
    let ariaLabel;
    let ariaLabelledBy;
    let isRequired;
    let label;
    let labelId;
    let name;
    let rest;
    let t0;
    let t1;
    let t2;
    let t3;
    let testId;
    let value;
    if ($[0] !== props) {
        ({ ariaLabel: ariaLabel, "aria-labelledby": ariaLabelledBy, isDisabled: t0, isRequired: isRequired, isInvalid: t1, isChecked: t2, label: label, labelId: labelId, name: name, onChange: t3, value: value, testId: testId, analyticsContext: analyticsContext, ...rest } = props);
        $[0] = props;
        $[1] = analyticsContext;
        $[2] = ariaLabel;
        $[3] = ariaLabelledBy;
        $[4] = isRequired;
        $[5] = label;
        $[6] = labelId;
        $[7] = name;
        $[8] = rest;
        $[9] = t0;
        $[10] = t1;
        $[11] = t2;
        $[12] = t3;
        $[13] = testId;
        $[14] = value;
    } else {
        analyticsContext = $[1];
        ariaLabel = $[2];
        ariaLabelledBy = $[3];
        isRequired = $[4];
        label = $[5];
        labelId = $[6];
        name = $[7];
        rest = $[8];
        t0 = $[9];
        t1 = $[10];
        t2 = $[11];
        t3 = $[12];
        testId = $[13];
        value = $[14];
    }
    const isDisabled = t0 === undefined ? false : t0;
    const isInvalid = t1 === undefined ? false : t1;
    const isChecked = t2 === undefined ? false : t2;
    const onChange = t3 === undefined ? $f465330fb8737fdd$var$noop : t3;
    let t4;
    if ($[15] !== analyticsContext || $[16] !== onChange) {
        t4 = {
            fn: onChange,
            action: "changed",
            analyticsData: analyticsContext,
            componentName: "radio",
            packageName: $f465330fb8737fdd$var$packageName,
            packageVersion: $f465330fb8737fdd$var$packageVersion
        };
        $[15] = analyticsContext;
        $[16] = onChange;
        $[17] = t4;
    } else t4 = $[17];
    const onChangeAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t4);
    const t5 = testId && `${testId}--radio-label`;
    const t6 = isDisabled ? "true" : undefined;
    const t7 = isDisabled && "_1UtDYzot27 _0wOv4Qsyl5";
    let t8;
    if ($[18] !== t7) {
        t8 = (0, $hekY6.default)([
            "_2sNsIgmnOE _3iDTPbQ4SZ _24h04i2Njc _1mT5xdRAKS _0hPCNLchRC _1UtDYzy7kJ",
            t7
        ]);
        $[18] = t7;
        $[19] = t8;
    } else t8 = $[19];
    const t9 = labelId || ariaLabelledBy;
    const t10 = testId && `${testId}--radio-input`;
    const t11 = isInvalid ? "true" : undefined;
    const t12 = !isDisabled && "_1etv9ykLmD _2tFSPOkLmD _0ZLH27HZdu _2fqI0WXzJH _38a67R4Y4b _0rUt1uXzJH _0IDPPJ4Y4b _4dpqOVqWX3 _42HvB4HKt7 _2bmooNXLOx _3CIMOkXLOx _1SLx5PutHW _1hb6ILPSfI _3i4XoaHKt7 _0oAkhw6BYM";
    const t13 = isDisabled && "_0wOv4Qsyl5 _46tpOUVrZW _2rYKcAhQC5 _07ionzoM2E";
    const t14 = isDisabled && isChecked && "_1XF9ANHZdu";
    const t15 = isInvalid && !isDisabled && "_2rYKcA7j8z _2tFSPO7j8z";
    let t16;
    if ($[20] !== t12 || $[21] !== t13 || $[22] !== t14 || $[23] !== t15) {
        t16 = (0, $hekY6.default)([
            "_2XghbEPgdg _30huDKUwEI _0bjKvDaaQb _2xIroY98eZ _497WNwYbGa _2zndICT6kp _23rrnHWkmS _3iDTPbQ4SZ _39xV02oWWg _0jFU0VoWWg _1mT5xdRAKS _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _0KLXruG2s3 _2B7VO8YbGa _46tpOU7Cj1 _2rYKcAHKt7 _07ionz6BYM _1XF9ANdnbC _1VJPcaGquZ _1RrJLiBwqQ _2adT7gYbGa _2OWEWsdaW3 _2Gfj6iaaQb _1JM8vvueoN _2jfUf9yaFJ _47eTBtyaFJ _2WYcYGWVPG _0GBAIrogpp _43i6GSTJun",
            t12,
            t13,
            t14,
            t15
        ]);
        $[20] = t12;
        $[21] = t13;
        $[22] = t14;
        $[23] = t15;
        $[24] = t16;
    } else t16 = $[24];
    let t17;
    if ($[25] !== ariaLabel || $[26] !== isChecked || $[27] !== isDisabled || $[28] !== isRequired || $[29] !== name || $[30] !== onChangeAnalytics || $[31] !== ref || $[32] !== rest || $[33] !== t10 || $[34] !== t11 || $[35] !== t16 || $[36] !== t9 || $[37] !== value) {
        t17 = /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
            ...rest,
            tabIndex: 0,
            "aria-label": ariaLabel,
            "aria-labelledby": t9,
            checked: isChecked,
            disabled: isDisabled,
            name: name,
            onChange: onChangeAnalytics,
            required: isRequired,
            type: "radio",
            value: value,
            "data-testid": t10,
            "data-invalid": t11,
            ref: ref,
            className: t16
        });
        $[25] = ariaLabel;
        $[26] = isChecked;
        $[27] = isDisabled;
        $[28] = isRequired;
        $[29] = name;
        $[30] = onChangeAnalytics;
        $[31] = ref;
        $[32] = rest;
        $[33] = t10;
        $[34] = t11;
        $[35] = t16;
        $[36] = t9;
        $[37] = value;
        $[38] = t17;
    } else t17 = $[38];
    let t18;
    if ($[39] !== label) {
        t18 = label ? /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: (0, $hekY6.default)([
                "_0xmtkoFQfX _46hvQmFQfX _03SyCP1Y8M _0LQT5E1Y8M"
            ]),
            children: label
        }) : null;
        $[39] = label;
        $[40] = t18;
    } else t18 = $[40];
    let t19;
    if ($[41] !== t17 || $[42] !== t18 || $[43] !== t5 || $[44] !== t6 || $[45] !== t8) {
        t19 = /*#__PURE__*/ (0, $8aG6j.jsxs)("label", {
            "data-testid": t5,
            "data-disabled": t6,
            className: t8,
            children: [
                t17,
                t18
            ]
        });
        $[41] = t17;
        $[42] = t18;
        $[43] = t5;
        $[44] = t6;
        $[45] = t8;
        $[46] = t19;
    } else t19 = $[46];
    return t19;
} : function Radio(props, ref) {
    const { ariaLabel: ariaLabel, 'aria-labelledby': ariaLabelledBy, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, labelId: labelId, name: name, onChange: onChange = $f465330fb8737fdd$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $f465330fb8737fdd$var$packageName,
        packageVersion: $f465330fb8737fdd$var$packageVersion
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _3iDTPbQ4SZ _24h04i2Njc _1mT5xdRAKS _0hPCNLchRC _1UtDYzy7kJ",
            isDisabled && "_1UtDYzot27 _0wOv4Qsyl5"
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                ...rest,
                tabIndex: 0,
                "aria-label": ariaLabel,
                "aria-labelledby": labelId || ariaLabelledBy,
                checked: isChecked,
                disabled: isDisabled,
                name: name,
                onChange: onChangeAnalytics,
                required: isRequired,
                type: "radio",
                value: value,
                "data-testid": testId && `${testId}--radio-input`,
                // use :invalid selector
                "data-invalid": isInvalid ? 'true' : undefined,
                ref: ref,
                className: (0, $hekY6.default)([
                    "_2XghbEPgdg _30huDKUwEI _0bjKvDaaQb _2xIroY98eZ _497WNwYbGa _2zndICT6kp _23rrnHWkmS _3iDTPbQ4SZ _39xV02oWWg _0jFU0VoWWg _1mT5xdRAKS _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _0KLXruG2s3 _2B7VO8YbGa _46tpOU7Cj1 _2rYKcAHKt7 _07ionz6BYM _1XF9ANdnbC _1VJPcaGquZ _1RrJLiBwqQ _2adT7gYbGa _2OWEWsdaW3 _2Gfj6iaaQb _1JM8vvueoN _2jfUf9yaFJ _47eTBtyaFJ _2WYcYGWVPG _0GBAIrogpp _43i6GSTJun",
                    !isDisabled && "_1etv9ykLmD _2tFSPOkLmD _0ZLH27HZdu _2fqI0WXzJH _38a67R4Y4b _0rUt1uXzJH _0IDPPJ4Y4b _4dpqOVqWX3 _42HvB4HKt7 _2bmooNXLOx _3CIMOkXLOx _1SLx5PutHW _1hb6ILPSfI _3i4XoaHKt7 _0oAkhw6BYM",
                    isDisabled && "_0wOv4Qsyl5 _46tpOUVrZW _2rYKcAhQC5 _07ionzoM2E",
                    isDisabled && isChecked && "_1XF9ANHZdu",
                    isInvalid && !isDisabled && "_2rYKcA7j8z _2tFSPO7j8z"
                ])
            }),
            label ? /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: (0, $hekY6.default)([
                    "_0xmtkoFQfX _46hvQmFQfX _03SyCP1Y8M _0LQT5E1Y8M"
                ]),
                children: label
            }) : null
        ]
    });
}); /**
     * __Radio__
     *
     * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
     *
     * - [Examples](https://atlassian.design/components/radio/examples)
     * - [Code](https://atlassian.design/components/radio/code)
     * - [Usage](https://atlassian.design/components/radio/usage)
     */ 
const $f465330fb8737fdd$var$Radio = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Radio(props, ref) {
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)($f465330fb8737fdd$var$InnerRadio, {
            ...props,
            ref: ref
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : function Radio(props, ref) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)($f465330fb8737fdd$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $f465330fb8737fdd$export$2e2bcd8739ae039 = $f465330fb8737fdd$var$Radio;
module.exports["default"] = $f465330fb8737fdd$export$2e2bcd8739ae039;

});

parcelRegister("lU1vD", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7r5Hr = parcelRequire("7r5Hr");


var $dpsRj = parcelRequire("dpsRj");


var $iHoAR = parcelRequire("iHoAR");


var $jfLxM = parcelRequire("jfLxM");


var $iHx0I = parcelRequire("iHx0I");


var $juWh1 = parcelRequire("juWh1");


var $7CS0L = parcelRequire("7CS0L");


var $175U1 = parcelRequire("175U1");


var $3cMdt = parcelRequire("3cMdt");


var $5Tlsn = parcelRequire("5Tlsn");


var $brLiE = parcelRequire("brLiE");


var $2cPI0 = parcelRequire("2cPI0");


var $3TQFr = parcelRequire("3TQFr");


var $lfEfd = parcelRequire("lfEfd");


var $deAmT = parcelRequire("deAmT");


var $3B2WR = parcelRequire("3B2WR");

function $271a161443bda400$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 'DESC':
            return 'ASC';
        case 'ASC':
            return 'DESC';
        default:
            return currentSortOrder;
    }
}
const $271a161443bda400$var$DynamicTable = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(97);
    const { caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: t1, isFixedSize: t2, rowsPerPage: t3, onSetPage: t4, onSort: t5, page: t6, emptyView: emptyView, isRankable: t7, isRankingDisabled: t8, onRankStart: t9, onRankEnd: t10, loadingSpinnerSize: loadingSpinnerSize, paginationi18n: t11 } = t0;
    const isLoading = t1 === undefined ? false : t1;
    const isFixedSize = t2 === undefined ? false : t2;
    const rowsPerPage = t3 === undefined ? Infinity : t3;
    const onSetPage = t4 === undefined ? (0, $dpsRj.default) : t4;
    const providedOnSort = t5 === undefined ? (0, $dpsRj.default) : t5;
    const page = t6 === undefined ? 1 : t6;
    const isRankable = t7 === undefined ? false : t7;
    const isRankingDisabled = t8 === undefined ? false : t8;
    const onRankStart = t9 === undefined ? (0, $dpsRj.default) : t9;
    const providedOnRankEnd = t10 === undefined ? (0, $dpsRj.default) : t10;
    let t12;
    if ($[0] !== t11) {
        t12 = t11 === undefined ? {
            prev: "Previous Page",
            next: "Next Page",
            label: "Pagination",
            pageLabel: "Page"
        } : t11;
        $[0] = t11;
        $[1] = t12;
    } else t12 = $[1];
    const paginationi18n = t12;
    const [isRanking, setIsRanking] = (0, $cozmU.useState)(false);
    const tableBodyRef = (0, $cozmU.useRef)(null);
    let t13;
    if ($[2] !== providedOnSort) {
        t13 = {
            fn: providedOnSort,
            action: "sorted",
            componentName: "dynamicTable",
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        };
        $[2] = providedOnSort;
        $[3] = t13;
    } else t13 = $[3];
    const onSort = (0, $7r5Hr.usePlatformLeafEventHandler)(t13);
    let t14;
    if ($[4] !== providedOnRankEnd) {
        t14 = {
            fn: providedOnRankEnd,
            action: "ranked",
            componentName: "dynamicTable",
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        };
        $[4] = providedOnRankEnd;
        $[5] = t14;
    } else t14 = $[5];
    const onRankEnd = (0, $7r5Hr.usePlatformLeafEventHandler)(t14);
    let t15;
    let t16;
    if ($[6] !== head || $[7] !== sortKey) {
        t15 = ()=>{
            (0, $iHx0I.validateSortKey)(sortKey, head);
            (0, $iHoAR.assertIsSortable)(head);
        };
        t16 = [
            sortKey,
            head
        ];
        $[6] = head;
        $[7] = sortKey;
        $[8] = t15;
        $[9] = t16;
    } else {
        t15 = $[8];
        t16 = $[9];
    }
    (0, $cozmU.useEffect)(t15, t16);
    let t17;
    if ($[10] !== isRankable || $[11] !== onSort || $[12] !== sortKey || $[13] !== sortOrder) {
        t17 = (item)=>()=>{
                const { key: key } = item;
                if (!key) return;
                if (onSort && isRankable && key === sortKey && sortOrder === "DESC") {
                    onSort({
                        key: null,
                        sortOrder: null,
                        item: item
                    });
                    return;
                }
                const sortOrderFormatted = key !== sortKey ? "ASC" : $271a161443bda400$var$toggleSortOrder(sortOrder);
                if (onSort) onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrderFormatted
                });
            };
        $[10] = isRankable;
        $[11] = onSort;
        $[12] = sortKey;
        $[13] = sortOrder;
        $[14] = t17;
    } else t17 = $[14];
    const onSortHandler = t17;
    let t18;
    if ($[15] !== onSetPage) {
        t18 = (page_0, event)=>{
            onSetPage(page_0, event);
        };
        $[15] = onSetPage;
        $[16] = t18;
    } else t18 = $[16];
    const onSetPageHandler = t18;
    let t19;
    if ($[17] !== onRankStart) {
        t19 = (params)=>{
            setIsRanking(true);
            onRankStart(params);
        };
        $[17] = onRankStart;
        $[18] = t19;
    } else t19 = $[18];
    const onRankStartHandler = t19;
    let t20;
    if ($[19] !== onRankEnd) {
        t20 = (params_0)=>{
            setIsRanking(false);
            onRankEnd(params_0);
        };
        $[19] = onRankEnd;
        $[20] = t20;
    } else t20 = $[20];
    const onRankEndHandler = t20;
    let t21;
    if ($[21] !== loadingSpinnerSize || $[22] !== page || $[23] !== rows || $[24] !== rowsPerPage) {
        t21 = ()=>{
            if (loadingSpinnerSize) return loadingSpinnerSize;
            return (0, $jfLxM.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? "large" : "small";
        };
        $[21] = loadingSpinnerSize;
        $[22] = page;
        $[23] = rows;
        $[24] = rowsPerPage;
        $[25] = t21;
    } else t21 = $[25];
    const getSpinnerSize = t21;
    let t22;
    if ($[26] !== emptyView || $[27] !== isLoading || $[28] !== testId) {
        t22 = ()=>{
            if (isLoading) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $175U1.EmptyViewWithFixedHeight), {
                testId: testId
            });
            return emptyView && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7CS0L.EmptyViewContainer), {
                testId: testId,
                children: emptyView
            });
        };
        $[26] = emptyView;
        $[27] = isLoading;
        $[28] = testId;
        $[29] = t22;
    } else t22 = $[29];
    const renderEmptyBody = t22;
    const rowsLength = rows && rows.length;
    let totalPages;
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page;
    const rowsExist = !!rowsLength;
    let t23;
    if ($[30] !== getSpinnerSize) {
        t23 = getSpinnerSize();
        $[30] = getSpinnerSize;
        $[31] = t23;
    } else t23 = $[31];
    const spinnerSize = t23;
    let t24;
    if ($[32] !== renderEmptyBody) {
        t24 = renderEmptyBody();
        $[32] = renderEmptyBody;
        $[33] = t24;
    } else t24 = $[33];
    const emptyBody = t24;
    const t25 = isLoading && rowsExist;
    let t26;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
        t26 = ()=>tableBodyRef.current;
        $[34] = t26;
    } else t26 = $[34];
    let t27;
    if ($[35] !== caption) {
        t27 = !!caption && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $juWh1.Caption), {
            children: caption
        });
        $[35] = caption;
        $[36] = t27;
    } else t27 = $[36];
    let t28;
    if ($[37] !== head || $[38] !== isFixedSize || $[39] !== isRankable || $[40] !== isRanking || $[41] !== onSortHandler || $[42] !== sortKey || $[43] !== sortOrder || $[44] !== testId) {
        t28 = head && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3B2WR.default), {
            head: head,
            onSort: onSortHandler,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRanking: isRanking,
            isRankable: isRankable,
            isFixedSize: isFixedSize,
            testId: testId
        });
        $[37] = head;
        $[38] = isFixedSize;
        $[39] = isRankable;
        $[40] = isRanking;
        $[41] = onSortHandler;
        $[42] = sortKey;
        $[43] = sortOrder;
        $[44] = testId;
        $[45] = t28;
    } else t28 = $[45];
    let t29;
    if ($[46] !== getPageNumber || $[47] !== head || $[48] !== highlightedRowIndex || $[49] !== isFixedSize || $[50] !== isLoading || $[51] !== isRankable || $[52] !== isRanking || $[53] !== isRankingDisabled || $[54] !== isTotalPagesControlledExternally || $[55] !== onPageRowsUpdate || $[56] !== onRankEndHandler || $[57] !== onRankStartHandler || $[58] !== rows || $[59] !== rowsExist || $[60] !== rowsPerPage || $[61] !== sortKey || $[62] !== sortOrder || $[63] !== testId) {
        t29 = rowsExist && /*#__PURE__*/ (0, $8aG6j.jsx)($271a161443bda400$var$TableBody, {
            ref: tableBodyRef,
            highlightedRowIndex: highlightedRowIndex,
            rows: rows,
            head: head,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rowsPerPage: rowsPerPage,
            page: getPageNumber,
            isFixedSize: isFixedSize || false,
            onPageRowsUpdate: onPageRowsUpdate,
            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
            testId: testId,
            isRankable: isRankable,
            isRanking: isRanking,
            onRankStart: onRankStartHandler,
            onRankEnd: onRankEndHandler,
            isRankingDisabled: isRankingDisabled || isLoading || false
        });
        $[46] = getPageNumber;
        $[47] = head;
        $[48] = highlightedRowIndex;
        $[49] = isFixedSize;
        $[50] = isLoading;
        $[51] = isRankable;
        $[52] = isRanking;
        $[53] = isRankingDisabled;
        $[54] = isTotalPagesControlledExternally;
        $[55] = onPageRowsUpdate;
        $[56] = onRankEndHandler;
        $[57] = onRankStartHandler;
        $[58] = rows;
        $[59] = rowsExist;
        $[60] = rowsPerPage;
        $[61] = sortKey;
        $[62] = sortOrder;
        $[63] = testId;
        $[64] = t29;
    } else t29 = $[64];
    let t30;
    if ($[65] !== isFixedSize || $[66] !== isLoading || $[67] !== label || $[68] !== rowsExist || $[69] !== t27 || $[70] !== t28 || $[71] !== t29 || $[72] !== testId) {
        t30 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $5Tlsn.Table), {
            isFixedSize: isFixedSize,
            "aria-label": label,
            hasDataRow: rowsExist,
            testId: testId,
            isLoading: isLoading,
            children: [
                t27,
                t28,
                t29
            ]
        });
        $[65] = isFixedSize;
        $[66] = isLoading;
        $[67] = label;
        $[68] = rowsExist;
        $[69] = t27;
        $[70] = t28;
        $[71] = t29;
        $[72] = testId;
        $[73] = t30;
    } else t30 = $[73];
    let t31;
    if ($[74] !== loadingLabel || $[75] !== spinnerSize || $[76] !== t25 || $[77] !== t30 || $[78] !== testId) {
        t31 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfEfd.default), {
            isLoading: t25,
            spinnerSize: spinnerSize,
            targetRef: t26,
            testId: testId,
            loadingLabel: loadingLabel,
            children: t30
        });
        $[74] = loadingLabel;
        $[75] = spinnerSize;
        $[76] = t25;
        $[77] = t30;
        $[78] = testId;
        $[79] = t31;
    } else t31 = $[79];
    let t32;
    if ($[80] !== getPageNumber || $[81] !== isLoading || $[82] !== onSetPageHandler || $[83] !== paginationi18n || $[84] !== testId || $[85] !== totalPages) {
        t32 = totalPages <= 1 ? null : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3cMdt.PaginationWrapper), {
            testId: testId,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $deAmT.default), {
                value: getPageNumber,
                onChange: onSetPageHandler,
                total: totalPages,
                i18n: paginationi18n,
                isDisabled: isLoading,
                testId: testId
            })
        });
        $[80] = getPageNumber;
        $[81] = isLoading;
        $[82] = onSetPageHandler;
        $[83] = paginationi18n;
        $[84] = testId;
        $[85] = totalPages;
        $[86] = t32;
    } else t32 = $[86];
    let t33;
    if ($[87] !== emptyBody || $[88] !== isLoading || $[89] !== loadingLabel || $[90] !== rowsExist || $[91] !== testId) {
        t33 = !rowsExist && emptyBody && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3TQFr.default), {
            isLoading: isLoading,
            spinnerSize: "large",
            testId: testId,
            loadingLabel: loadingLabel,
            children: emptyBody
        });
        $[87] = emptyBody;
        $[88] = isLoading;
        $[89] = loadingLabel;
        $[90] = rowsExist;
        $[91] = testId;
        $[92] = t33;
    } else t33 = $[92];
    let t34;
    if ($[93] !== t31 || $[94] !== t32 || $[95] !== t33) {
        t34 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                t31,
                t32,
                t33
            ]
        });
        $[93] = t31;
        $[94] = t32;
        $[95] = t33;
        $[96] = t34;
    } else t34 = $[96];
    return t34;
} : ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $dpsRj.default), onSort: providedOnSort = (0, $dpsRj.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $dpsRj.default), onRankEnd: providedOnRankEnd = (0, $dpsRj.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous Page',
    next: 'Next Page',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $cozmU.useState)(false);
    const tableBodyRef = (0, $cozmU.useRef)(null);
    const onSort = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $cozmU.useEffect)(()=>{
        (0, $iHx0I.validateSortKey)(sortKey, head);
        (0, $iHoAR.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === 'DESC') {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? 'ASC' : $271a161443bda400$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page_0, event)=>{
        onSetPage(page_0, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params_0)=>{
        setIsRanking(false);
        onRankEnd(params_0);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $jfLxM.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? 'large' : 'small';
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $175U1.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7CS0L.EmptyViewContainer), {
            testId: testId,
            children: emptyView
        });
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfEfd.default), {
                isLoading: isLoading && rowsExist,
                spinnerSize: spinnerSize,
                targetRef: ()=>tableBodyRef.current,
                testId: testId,
                loadingLabel: loadingLabel,
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $5Tlsn.Table), {
                    isFixedSize: isFixedSize,
                    "aria-label": label,
                    hasDataRow: rowsExist,
                    testId: testId,
                    isLoading: isLoading,
                    children: [
                        !!caption && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $juWh1.Caption), {
                            children: caption
                        }),
                        head && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3B2WR.default), {
                            head: head,
                            onSort: onSortHandler,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            isRanking: isRanking,
                            isRankable: isRankable,
                            isFixedSize: isFixedSize,
                            testId: testId
                        }),
                        rowsExist && /*#__PURE__*/ (0, $8aG6j.jsx)($271a161443bda400$var$TableBody, {
                            ref: tableBodyRef,
                            highlightedRowIndex: highlightedRowIndex,
                            rows: rows,
                            head: head,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            rowsPerPage: rowsPerPage,
                            page: getPageNumber,
                            isFixedSize: isFixedSize || false,
                            onPageRowsUpdate: onPageRowsUpdate,
                            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
                            testId: testId,
                            isRankable: isRankable,
                            isRanking: isRanking,
                            onRankStart: onRankStartHandler,
                            onRankEnd: onRankEndHandler,
                            isRankingDisabled: isRankingDisabled || isLoading || false
                        })
                    ]
                })
            }),
            totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3cMdt.PaginationWrapper), {
                testId: testId,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $deAmT.default), {
                    value: getPageNumber,
                    onChange: onSetPageHandler,
                    total: totalPages,
                    i18n: paginationi18n,
                    isDisabled: isLoading,
                    testId: testId
                })
            }),
            !rowsExist && emptyBody && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3TQFr.default), {
                isLoading: isLoading,
                spinnerSize: "large",
                testId: testId,
                loadingLabel: loadingLabel,
                children: emptyBody
            })
        ]
    });
};

const $271a161443bda400$var$RankableTableBody = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("b6DGi")));
const $271a161443bda400$var$TableBody = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function TableBody(t0, ref) {
    const $ = (0, $bDgLe.c)(23);
    let bodyProps;
    let isRanking;
    let isRankingDisabled;
    let onRankEnd;
    let onRankStart;
    let t1;
    if ($[0] !== t0) {
        ({ isRankable: t1, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps } = t0);
        $[0] = t0;
        $[1] = bodyProps;
        $[2] = isRanking;
        $[3] = isRankingDisabled;
        $[4] = onRankEnd;
        $[5] = onRankStart;
        $[6] = t1;
    } else {
        bodyProps = $[1];
        isRanking = $[2];
        isRankingDisabled = $[3];
        onRankEnd = $[4];
        onRankStart = $[5];
        t1 = $[6];
    }
    const isRankable = t1 === undefined ? false : t1;
    const canRank = isRankable && !bodyProps.sortKey;
    const [canRenderRankable, setCanRenderRankable] = (0, $cozmU.useState)(false);
    let t2;
    let t3;
    if ($[7] !== canRank) {
        t2 = ()=>{
            if (canRank) setCanRenderRankable(true);
        };
        t3 = [
            canRank
        ];
        $[7] = canRank;
        $[8] = t2;
        $[9] = t3;
    } else {
        t2 = $[8];
        t3 = $[9];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[10] !== bodyProps || $[11] !== ref) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $brLiE.default), {
            ref: ref,
            ...bodyProps
        });
        $[10] = bodyProps;
        $[11] = ref;
        $[12] = t4;
    } else t4 = $[12];
    const nonRankableBody = t4;
    let t5;
    if ($[13] !== bodyProps || $[14] !== canRank || $[15] !== canRenderRankable || $[16] !== isRanking || $[17] !== isRankingDisabled || $[18] !== nonRankableBody || $[19] !== onRankEnd || $[20] !== onRankStart || $[21] !== ref) {
        t5 = canRank && canRenderRankable ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2cPI0.ErrorBoundary), {
            fallback: nonRankableBody,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
                fallback: nonRankableBody,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)($271a161443bda400$var$RankableTableBody, {
                    ref: ref,
                    ...bodyProps,
                    isRanking: isRanking,
                    onRankStart: onRankStart,
                    onRankEnd: onRankEnd,
                    isRankingDisabled: isRankingDisabled
                })
            })
        }) : nonRankableBody;
        $[13] = bodyProps;
        $[14] = canRank;
        $[15] = canRenderRankable;
        $[16] = isRanking;
        $[17] = isRankingDisabled;
        $[18] = nonRankableBody;
        $[19] = onRankEnd;
        $[20] = onRankStart;
        $[21] = ref;
        $[22] = t5;
    } else t5 = $[22];
    return t5;
} : function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $brLiE.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2cPI0.ErrorBoundary), {
        fallback: nonRankableBody,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: nonRankableBody,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($271a161443bda400$var$RankableTableBody, {
                ref: ref,
                ...bodyProps,
                isRanking: isRanking,
                onRankStart: onRankStart,
                onRankEnd: onRankEnd,
                isRankingDisabled: isRankingDisabled
            })
        })
    }) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$271a161443bda400$export$2e2bcd8739ae039 = $271a161443bda400$var$DynamicTable;
module.exports["default"] = $271a161443bda400$export$2e2bcd8739ae039;

});

parcelRegister("iHoAR", function(module, exports) {
const $8d7cd7e0bba12695$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
module.exports["assertIsSortable"] = $8d7cd7e0bba12695$export$5eb35a4771ec4090;

});

parcelRegister("jfLxM", function(module, exports) {
const $50674326dbf0d161$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
module.exports["getPageRows"] = $50674326dbf0d161$export$3987dc24b734dcab;

});

parcelRegister("iHx0I", function(module, exports) {
const $b652594310ea9151$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
module.exports["validateSortKey"] = $b652594310ea9151$export$9133f5a8bfe8a200;

});

parcelRegister("juWh1", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $5c26b05e4fb09102$var$captionStyles = null;
const $5c26b05e4fb09102$export$32fbfacc5d962e0c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_2sNsIgWSk4 _0rIjyk2ADO _43nrzTNHnM _1sLQ8qC67X"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("caption", {
            className: t1,
            children: children
        });
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)("caption", {
        className: (0, $hekY6.default)([
            "_2sNsIgWSk4 _0rIjyk2ADO _43nrzTNHnM _1sLQ8qC67X"
        ]),
        children: children
    });
module.exports["Caption"] = $5c26b05e4fb09102$export$32fbfacc5d962e0c;

});

parcelRegister("7CS0L", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $e2f07650fad02bf8$var$emptyViewContainerStyles = null;
const $e2f07650fad02bf8$export$381ea436de119582 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, testId: testId } = props;
    const t0 = testId && `${testId}--empty-view-container`;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _0Of8r2uFDC _1ZnuxbuFDC _1wydGWuFDC _2Zuz6QuFDC _39xV02715P _2fwxA5DIqT"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== t0) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": t0,
            className: t1,
            children: children
        });
        $[1] = children;
        $[2] = t0;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-container`,
        className: (0, $hekY6.default)([
            "_313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _0Of8r2uFDC _1ZnuxbuFDC _1wydGWuFDC _2Zuz6QuFDC _39xV02715P _2fwxA5DIqT"
        ]),
        children: children
    });
};
module.exports["EmptyViewContainer"] = $e2f07650fad02bf8$export$381ea436de119582;

});

parcelRegister("175U1", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $f90c20e8ccf48851$var$fixedHeightStyles = null;
const $f90c20e8ccf48851$export$8f45b9407d4090d7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, testId: testId } = t0;
    const t1 = testId && `${testId}--empty-view-with-fixed-height`;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_0jFU0VB34T"
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== children || $[2] !== t1) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": t1,
            className: t2,
            children: children
        });
        $[1] = children;
        $[2] = t1;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`,
        className: (0, $hekY6.default)([
            "_0jFU0VB34T"
        ]),
        children: children
    });
module.exports["EmptyViewWithFixedHeight"] = $f90c20e8ccf48851$export$8f45b9407d4090d7;

});

parcelRegister("3cMdt", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $2fd7e9f40e2b519d$var$paginationWrapperStyles = null;
const $2fd7e9f40e2b519d$export$3e5e12dc01f20a43 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, testId: testId } = t0;
    const t1 = testId && `${testId}--pagination--container`;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuDIqT"
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== children || $[2] !== t1) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": t1,
            className: t2,
            children: children
        });
        $[1] = children;
        $[2] = t1;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": testId && `${testId}--pagination--container`,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuDIqT"
        ]),
        children: children
    });
module.exports["PaginationWrapper"] = $2fd7e9f40e2b519d$export$3e5e12dc01f20a43;

});

parcelRegister("5Tlsn", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $7f9cc963fb218178$var$fixedSizeTableStyles = null;
const $7f9cc963fb218178$var$tableStyles = null;
const $7f9cc963fb218178$var$bodyBorder = null;
const $7f9cc963fb218178$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(20);
    let children;
    let hasDataRow;
    let isFixedSize;
    let isLoading;
    let rest;
    let testId;
    if ($[0] !== t0) {
        ({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = hasDataRow;
        $[3] = isFixedSize;
        $[4] = isLoading;
        $[5] = rest;
        $[6] = testId;
    } else {
        children = $[1];
        hasDataRow = $[2];
        isFixedSize = $[3];
        isLoading = $[4];
        rest = $[5];
        testId = $[6];
    }
    const t1 = isLoading ? "" : undefined;
    let t2;
    if ($[7] !== t1) {
        t2 = {
            inert: t1
        };
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            "--local-dynamic-table-hover-bg": "var(--ds-background-neutral-subtle-hovered, #0515240F)",
            "--local-dynamic-table-highlighted-bg": "var(--ds-background-selected, #E9F2FE)",
            "--local-dynamic-table-hover-highlighted-bg": "var(--ds-background-selected-hovered, #CFE1FD)",
            "--local-dynamic-table-row-focus-outline": "var(--ds-border-focused, #4688EC)"
        };
        $[9] = t3;
    } else t3 = $[9];
    const t4 = testId && `${testId}--table`;
    const t5 = isFixedSize && "_3Kbj8ay1CL";
    const t6 = hasDataRow && "_2R4pr31z4g";
    let t7;
    if ($[10] !== t5 || $[11] !== t6) {
        t7 = (0, $hekY6.default)([
            "_39xV02N91d _2i6rxZWTl1 _0Mq23cdnbC _0WKd3G4z3T",
            t5,
            t6
        ]);
        $[10] = t5;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== children || $[14] !== ref || $[15] !== rest || $[16] !== t2 || $[17] !== t4 || $[18] !== t7) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)("table", {
            ...t2,
            style: t3,
            ref: ref,
            ...rest,
            "data-testid": t4,
            className: t7,
            children: children
        });
        $[13] = children;
        $[14] = ref;
        $[15] = rest;
        $[16] = t2;
        $[17] = t4;
        $[18] = t7;
        $[19] = t8;
    } else t8 = $[19];
    return t8;
} : ({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("table" // React and Typescript do not yet support the inert attribute https://github.com/facebook/react/pull/24730
    , {
        inert: isLoading ? '' : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-bg': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-highlighted-bg': "var(--ds-background-selected, #E9F2FE)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-highlighted-bg': "var(--ds-background-selected-hovered, #CFE1FD)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-row-focus-outline': "var(--ds-border-focused, #4688EC)"
        },
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`,
        className: (0, $hekY6.default)([
            "_39xV02N91d _2i6rxZWTl1 _0Mq23cdnbC _0WKd3G4z3T",
            isFixedSize && "_3Kbj8ay1CL",
            hasDataRow && "_2R4pr31z4g"
        ]),
        children: children
    });
});
module.exports["Table"] = $7f9cc963fb218178$export$54ec01a60f47d33d;

});

parcelRegister("brLiE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6LhkM = parcelRequire("6LhkM");


var $j2lQ7 = parcelRequire("j2lQ7");

// eslint-disable-next-line @repo/internal/react/no-class-components
class $cc2c87abcc03b65c$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, $8aG6j.jsx)("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef,
            children: pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $j2lQ7.default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                }, row.key || rowIndex))
        });
    }
}
const $cc2c87abcc03b65c$var$Body = (0, $6LhkM.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)($cc2c87abcc03b65c$var$BodyComponent, {
            ...props,
            forwardedRef: ref
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($cc2c87abcc03b65c$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cc2c87abcc03b65c$export$2e2bcd8739ae039 = $cc2c87abcc03b65c$var$Body;
module.exports["default"] = $cc2c87abcc03b65c$export$2e2bcd8739ae039;

});

parcelRegister("6LhkM", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7cbe3c10c3705da$export$2e2bcd8739ae039);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jfLxM = parcelRequire("jfLxM");


var $iHx0I = parcelRequire("iHx0I");

const $f7cbe3c10c3705da$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $f7cbe3c10c3705da$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === 'ASC' ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $f7cbe3c10c3705da$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $f7cbe3c10c3705da$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $f7cbe3c10c3705da$export$2e2bcd8739ae039(WrappedComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $iHx0I.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $f7cbe3c10c3705da$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $jfLxM.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, $8aG6j.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
        const $ = (0, $bDgLe.c)(3);
        let t0;
        if ($[0] !== props || $[1] !== ref) {
            t0 = /*#__PURE__*/ (0, $8aG6j.jsx)(WithSortedPageRows, {
                ...props,
                forwardedRef: ref
            });
            $[0] = props;
            $[1] = ref;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    } : (props, ref)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
        return /*#__PURE__*/ (0, $8aG6j.jsx)(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("j2lQ7", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $3Cyjf = parcelRequire("3Cyjf");


var $fNX95 = parcelRequire("fNX95");

const $e244a0d606afa77b$var$Row = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted } = t0;
    let cells;
    let restRowProps;
    if ($[0] !== row) {
        ({ cells: cells, ...restRowProps } = row);
        $[0] = row;
        $[1] = cells;
        $[2] = restRowProps;
    } else {
        cells = $[1];
        restRowProps = $[2];
    }
    let t1;
    if ($[3] !== isHighlighted) {
        t1 = isHighlighted ? {
            "data-ts--dynamic-table--table-row--highlighted": true
        } : null;
        $[3] = isHighlighted;
        $[4] = t1;
    } else t1 = $[4];
    const t2 = row.testId || testId && `${testId}--row-${restRowProps.key}`;
    let t3;
    if ($[5] !== cells || $[6] !== head || $[7] !== isFixedSize || $[8] !== testId) {
        let t4;
        if ($[10] !== head || $[11] !== isFixedSize || $[12] !== testId) {
            t4 = (cell, cellIndex)=>{
                const { content: content, testId: cellTestId, ...restCellProps } = cell;
                const { shouldTruncate: shouldTruncate, width: width } = (head || {
                    cells: []
                }).cells[cellIndex] || {};
                return /*#__PURE__*/ (0, $cozmU.createElement)((0, $3Cyjf.TableBodyCell), {
                    "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                    ...restCellProps,
                    isFixedSize: isFixedSize,
                    key: cellIndex,
                    shouldTruncate: shouldTruncate,
                    width: width
                }, content);
            };
            $[10] = head;
            $[11] = isFixedSize;
            $[12] = testId;
            $[13] = t4;
        } else t4 = $[13];
        t3 = cells.map(t4);
        $[5] = cells;
        $[6] = head;
        $[7] = isFixedSize;
        $[8] = testId;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[14] !== isHighlighted || $[15] !== restRowProps || $[16] !== t1 || $[17] !== t2 || $[18] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fNX95.TableBodyRow), {
            ...restRowProps,
            isHighlighted: isHighlighted,
            ...t1,
            testId: t2,
            children: t3
        });
        $[14] = isHighlighted;
        $[15] = restRowProps;
        $[16] = t1;
        $[17] = t2;
        $[18] = t3;
        $[19] = t4;
    } else t4 = $[19];
    return t4;
} : ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fNX95.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`,
        children: cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return /*#__PURE__*/ (0, $cozmU.createElement)((0, $3Cyjf.TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e244a0d606afa77b$export$2e2bcd8739ae039 = $e244a0d606afa77b$var$Row;
module.exports["default"] = $e244a0d606afa77b$export$2e2bcd8739ae039;

});

parcelRegister("3Cyjf", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $aKm7d = parcelRequire("aKm7d");

const $cf3a304d4ce74d69$var$fixedSizeTruncateStyles = null;
const $cf3a304d4ce74d69$var$overflowTruncateStyles = null;
const $cf3a304d4ce74d69$var$truncationWidthStyles = null;
const $cf3a304d4ce74d69$var$cellStyles = null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $cf3a304d4ce74d69$export$948e91fcef170792 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    let props;
    let t1;
    let t2;
    let t3;
    if ($[0] !== t0) {
        const { width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...t4 } = t0;
        props = t4;
        let t5;
        if ($[5] !== width) {
            t5 = (0, $aKm7d.getTruncationStyleVars)({
                width: width
            });
            $[5] = width;
            $[6] = t5;
        } else t5 = $[6];
        t1 = t5;
        t2 = innerRef;
        t3 = (0, $hekY6.default)([
            "_39xV02SBlE",
            isFixedSize && shouldTruncate && "_39HuIbz8Lp _1ANEUSLRg7",
            isFixedSize && "_4bt5LAnQyn _2WAcuGnQyn",
            "_30huDKYbGa _0xmtko1Y8M _46hvQm1Y8M _03SyCP2ADO _0LQT5E2ADO _2fwxA5ecOK _4efXyCPgdg _22fNSnPgdg",
            props.className
        ]);
        $[0] = t0;
        $[1] = props;
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
    } else {
        props = $[1];
        t1 = $[2];
        t2 = $[3];
        t3 = $[4];
    }
    let t4;
    if ($[7] !== props || $[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)("td", {
            style: t1,
            ref: t2,
            className: t3,
            ...props
        });
        $[7] = props;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $8aG6j.jsx)("td" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    , {
        style: (0, $aKm7d.getTruncationStyleVars)({
            width: width
        }),
        // @ts-ignore
        ref: innerRef,
        className: (0, $hekY6.default)([
            "_39xV02SBlE",
            isFixedSize && shouldTruncate && "_39HuIbz8Lp _1ANEUSLRg7",
            isFixedSize && "_4bt5LAnQyn _2WAcuGnQyn",
            "_30huDKYbGa _0xmtko1Y8M _46hvQm1Y8M _03SyCP2ADO _0LQT5E2ADO _2fwxA5ecOK _4efXyCPgdg _22fNSnPgdg",
            props.className
        ]),
        ...props
    });
module.exports["TableBodyCell"] = $cf3a304d4ce74d69$export$948e91fcef170792;

});

parcelRegister("aKm7d", function(module, exports) {
const $d6beda0451d041ee$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $d6beda0451d041ee$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$d6beda0451d041ee$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;
module.exports["getTruncationStyleVars"] = $d6beda0451d041ee$export$5e6497a652ae30b5;

});

parcelRegister("fNX95", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $bc6f4bd33d2d03cf$var$rowStyles = null;
const $bc6f4bd33d2d03cf$var$rowBackgroundStyles = null;
const $bc6f4bd33d2d03cf$var$rowHighlightedBackgroundStyles = null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $bc6f4bd33d2d03cf$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(17);
    let children;
    let className;
    let isHighlighted;
    let rest;
    let style;
    let testId;
    if ($[0] !== t0) {
        ({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, className: className, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = className;
        $[3] = isHighlighted;
        $[4] = rest;
        $[5] = style;
        $[6] = testId;
    } else {
        children = $[1];
        className = $[2];
        isHighlighted = $[3];
        rest = $[4];
        style = $[5];
        testId = $[6];
    }
    const t1 = isHighlighted ? "_0KLXruY9q9 _1eOmH6sumd" : "_1eOmH6o126";
    let t2;
    if ($[7] !== className || $[8] !== t1) {
        t2 = (0, $hekY6.default)([
            "_0KLXru66of _4EiLyUXzJH _34b3D2pgTj",
            t1,
            className
        ]);
        $[7] = className;
        $[8] = t1;
        $[9] = t2;
    } else t2 = $[9];
    let t3;
    if ($[10] !== children || $[11] !== ref || $[12] !== rest || $[13] !== style || $[14] !== t2 || $[15] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("tr", {
            style: style,
            className: t2,
            ...rest,
            ref: ref,
            "data-testid": testId,
            children: children
        });
        $[10] = children;
        $[11] = ref;
        $[12] = rest;
        $[13] = style;
        $[14] = t2;
        $[15] = testId;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
} : ({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, className: className, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("tr", {
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hekY6.default)([
            "_0KLXru66of _4EiLyUXzJH _34b3D2pgTj",
            isHighlighted ? "_0KLXruY9q9 _1eOmH6sumd" : "_1eOmH6o126",
            className
        ]),
        ...rest,
        ref: ref,
        "data-testid": testId,
        children: children
    });
});
module.exports["TableBodyRow"] = $bc6f4bd33d2d03cf$export$45f39d9c38b886d5;

});

parcelRegister("2cPI0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

class $adc4070934df864d$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
module.exports["ErrorBoundary"] = $adc4070934df864d$export$e926676385687eaf;

});

parcelRegister("3TQFr", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");


var $eeh1A = parcelRequire("eeh1A");


var $6phLN = parcelRequire("6phLN");


var $4hoBP = parcelRequire("4hoBP");

class $1f3230d9ef7343db$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $eeh1A.Container), {
            testId: testId,
            children: [
                !isLoading ? children : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6phLN.ContentsContainer), {
                    contentsOpacity: contentsOpacity,
                    testId: testId,
                    children: children
                }),
                isLoading && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hoBP.SpinnerContainer), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
                        size: spinnerSize,
                        testId: testId && `${testId}--loadingSpinner`,
                        label: loadingLabel
                    })
                })
            ]
        });
    }
}
$1f3230d9ef7343db$export$2e2bcd8739ae039.defaultProps = {
    isLoading: true,
    spinnerSize: 'large',
    contentsOpacity: 0.22,
    loadingLabel: 'Loading table'
};
module.exports["default"] = $1f3230d9ef7343db$export$2e2bcd8739ae039;

});

parcelRegister("eeh1A", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $3c9150da0589227a$var$containerStyles = null;
const $3c9150da0589227a$export$42a852a2b6b56249 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, testId: testId } = t0;
    const t1 = testId && `${testId}--container`;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_1mT5xdRAKS"
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== children || $[2] !== t1) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": t1,
            className: t2,
            children: children
        });
        $[1] = children;
        $[2] = t1;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": testId && `${testId}--container`,
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS"
        ]),
        children: children
    });
module.exports["Container"] = $3c9150da0589227a$export$42a852a2b6b56249;

});

parcelRegister("6phLN", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $843bd93869a044cb$var$CSS_VAR_CONTENTS_OPACITY = '--contents-opacity';
const $843bd93869a044cb$var$contentsContainerStyles = null;
const $843bd93869a044cb$export$67c29eae8ae2137a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, contentsOpacity: contentsOpacity, testId: testId } = t0;
    let t1;
    if ($[0] !== contentsOpacity) {
        t1 = {
            [$843bd93869a044cb$var$CSS_VAR_CONTENTS_OPACITY]: contentsOpacity
        };
        $[0] = contentsOpacity;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = t1;
    const t3 = testId && `${testId}--contents--container`;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_1YKVNsLjGI _1pp6NdYbGa"
        ]);
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== children || $[4] !== t2 || $[5] !== t3) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            style: t2,
            "data-testid": t3,
            className: t4,
            children: children
        });
        $[3] = children;
        $[4] = t2;
        $[5] = t3;
        $[6] = t5;
    } else t5 = $[6];
    return t5;
} : ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        style: {
            [$843bd93869a044cb$var$CSS_VAR_CONTENTS_OPACITY]: contentsOpacity
        },
        "data-testid": testId && `${testId}--contents--container`,
        className: (0, $hekY6.default)([
            "_1YKVNsLjGI _1pp6NdYbGa"
        ]),
        children: children
    });
module.exports["ContentsContainer"] = $843bd93869a044cb$export$67c29eae8ae2137a;

});

parcelRegister("4hoBP", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $7b568d22405749aa$var$spinnerContainerStyles = null;
const $7b568d22405749aa$export$a5e06607a5ac6158 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, testId: testId } = t0;
    const t1 = testId && `${testId}--spinner--container`;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_49OCfRdnbC _3iDTPbQ4SZ _1mT5xdWVPG _0hPCNLDIqT _37wbyuDIqT"
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== children || $[2] !== t1) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": t1,
            className: t2,
            children: children
        });
        $[1] = children;
        $[2] = t1;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": testId && `${testId}--spinner--container`,
        className: (0, $hekY6.default)([
            "_49OCfRdnbC _3iDTPbQ4SZ _1mT5xdWVPG _0hPCNLDIqT _37wbyuDIqT"
        ]),
        children: children
    });
module.exports["SpinnerContainer"] = $7b568d22405749aa$export$a5e06607a5ac6158;

});

parcelRegister("lfEfd", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");

function $894542bbf1d55048$var$_defineProperty(e, r, t) {
    return (r = $894542bbf1d55048$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $894542bbf1d55048$var$_toPropertyKey(t) {
    var i = $894542bbf1d55048$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $894542bbf1d55048$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $894542bbf1d55048$var$containerStyles = null;
const $894542bbf1d55048$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(10);
    let children;
    let rest;
    let testId;
    if ($[0] !== props) {
        ({ children: children, testId: testId, ...rest } = props);
        $[0] = props;
        $[1] = children;
        $[2] = rest;
        $[3] = testId;
    } else {
        children = $[1];
        rest = $[2];
        testId = $[3];
    }
    let t0;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_1mT5xdRAKS _0rIjykNHnM"
        ]);
        $[4] = t0;
    } else t0 = $[4];
    let t1;
    if ($[5] !== children || $[6] !== ref || $[7] !== rest || $[8] !== testId) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ...rest,
            "data-testid": testId,
            ref: ref,
            className: t0,
            children: children
        });
        $[5] = children;
        $[6] = ref;
        $[7] = rest;
        $[8] = testId;
        $[9] = t1;
    } else t1 = $[9];
    return t1;
} : (props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ...rest,
        "data-testid": testId,
        ref: ref,
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS _0rIjykNHnM"
        ]),
        children: children
    });
});
const $894542bbf1d55048$var$spinnerBackdropStyles = null;
const $894542bbf1d55048$var$SpinnerBackdrop = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, testId: testId } = t0;
    const t1 = testId && `${testId}--spinner-backdrop`;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_49OCfRdnbC _3iDTPbQ4SZ _1mT5xdWVPG _0hPCNLDIqT _37wbyuDIqT _1pp6NdYbGa"
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== children || $[2] !== t1) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": t1,
            className: t2,
            children: children
        });
        $[1] = children;
        $[2] = t1;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": testId && `${testId}--spinner-backdrop`,
        className: (0, $hekY6.default)([
            "_49OCfRdnbC _3iDTPbQ4SZ _1mT5xdWVPG _0hPCNLDIqT _37wbyuDIqT _1pp6NdYbGa"
        ]),
        children: children
    });
const $894542bbf1d55048$var$spinnerContainerStyles = null;
const $894542bbf1d55048$var$SpinnerContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1mT5xdRAKS _2I62gzdnbC"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== ref) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ref: ref,
            className: t1,
            children: children
        });
        $[1] = children;
        $[2] = ref;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ children: children }, ref)=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ref: ref,
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS _2I62gzdnbC"
        ]),
        children: children
    }));
class $894542bbf1d55048$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        } // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $8aG6j.jsxs)($894542bbf1d55048$var$Container, {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $8aG6j.jsx)($894542bbf1d55048$var$SpinnerBackdrop, {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)($894542bbf1d55048$var$SpinnerContainer, {
                        ref: this.spinnerRef,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
                            size: spinnerSize,
                            testId: testId && `${testId}--loadingSpinner`,
                            label: loadingLabel
                        })
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        $894542bbf1d55048$var$_defineProperty(this, "spinnerRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef());
        $894542bbf1d55048$var$_defineProperty(this, "containerRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef());
        $894542bbf1d55048$var$_defineProperty(this, "componentDidMount", ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        });
        $894542bbf1d55048$var$_defineProperty(this, "UNSAFE_componentWillReceiveProps", (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        });
        $894542bbf1d55048$var$_defineProperty(this, "componentDidUpdate", ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        });
        $894542bbf1d55048$var$_defineProperty(this, "componentWillUnmount", ()=>{
            this.detachListeners();
        });
        $894542bbf1d55048$var$_defineProperty(this, "getTargetNode", (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        });
        $894542bbf1d55048$var$_defineProperty(this, "hasTargetNode", (nextProps)=>!!this.getTargetNode(nextProps));
        $894542bbf1d55048$var$_defineProperty(this, "isVerticallyVisible", (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        });
        $894542bbf1d55048$var$_defineProperty(this, "isFullyVerticallyVisible", (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        });
        $894542bbf1d55048$var$_defineProperty(this, "handleResize", ()=>{
            this.updateSpinnerPosition();
        });
        $894542bbf1d55048$var$_defineProperty(this, "handleScroll", ()=>{
            this.updateSpinnerPosition();
        });
        $894542bbf1d55048$var$_defineProperty(this, "translateSpinner", (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        });
        $894542bbf1d55048$var$_defineProperty(this, "updateTargetAppearance", ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        });
    }
}
$894542bbf1d55048$var$_defineProperty($894542bbf1d55048$export$2e2bcd8739ae039, "defaultProps", {
    isLoading: true,
    spinnerSize: 'large',
    contentsOpacity: "var(--ds-opacity-loading, 0.2)",
    loadingLabel: 'Loading table'
});
module.exports["default"] = $894542bbf1d55048$export$2e2bcd8739ae039;

});

parcelRegister("deAmT", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $4kJeN = parcelRequire("4kJeN");

class $057a9e1bf87f03b7$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4kJeN.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args);
        this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}
module.exports["default"] = $057a9e1bf87f03b7$export$2e2bcd8739ae039;

});

parcelRegister("4kJeN", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7r5Hr = parcelRequire("7r5Hr");


var $dpsRj = parcelRequire("dpsRj");


var $5Dlqn = parcelRequire("5Dlqn");


var $iW7aI = parcelRequire("iW7aI");


var $aDSIl = parcelRequire("aDSIl");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $9yPZa = parcelRequire("9yPZa");


var $diVBb = parcelRequire("diVBb");


var $gV0FQ = parcelRequire("gV0FQ");


var $3VKbs = parcelRequire("3VKbs");


var $jQ9pN = parcelRequire("jQ9pN");

const $58ee79fc5bef7c86$var$styles = {
    paginationMenu: "_46hvQmPgdg _03SyCPPgdg _0xmtkoPgdg _0LQT5EPgdg _43nrzTPgdg _2xTnZxPgdg _0rIjykPgdg _0GTcwRPgdg",
    paginationMenuItem: "_43nrzTPgdg _0WKd3G4z3T",
    navigatorIconWrapper: "_2Y7lL4gVvo"
};
const $58ee79fc5bef7c86$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $58ee79fc5bef7c86$var$NavigatorIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? function NavigatorIcon(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { chevronDirection: chevronDirection } = t0;
    const Chevron = chevronDirection === "left" ? (0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    let t1;
    if ($[0] !== Chevron) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "span",
            xcss: $58ee79fc5bef7c86$var$styles.navigatorIconWrapper,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)(Chevron, {
                label: "",
                color: "currentColor",
                size: "small"
            })
        });
        $[0] = Chevron;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        as: "span",
        xcss: $58ee79fc5bef7c86$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)(Chevron, {
            label: "",
            color: "currentColor",
            size: "small"
        })
    });
};
const $58ee79fc5bef7c86$var$InnerPagination = (0, $gtMdU.isReactCompilerActivePlatform)() ? function InnerPagination(t0, ref) {
    const $ = (0, $bDgLe.c)(57);
    const { components: t1, defaultSelectedIndex: t2, selectedIndex: selectedIndex, label: t3, pageLabel: t4, previousLabel: t5, nextLabel: t6, style: t7, max: t8, onChange: t9, pages: pages, getPageLabel: getPageLabel, renderEllipsis: t10, analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled } = t0;
    const components = t1 === undefined ? (0, $3VKbs.emptyObject) : t1;
    const defaultSelectedIndex = t2 === undefined ? 0 : t2;
    const label = t3 === undefined ? "pagination" : t3;
    const pageLabel = t4 === undefined ? "page" : t4;
    const previousLabel = t5 === undefined ? "previous" : t5;
    const nextLabel = t6 === undefined ? "next" : t6;
    const style = t7 === undefined ? (0, $3VKbs.emptyObject) : t7;
    const max = t8 === undefined ? 7 : t8;
    const onChange = t9 === undefined ? (0, $dpsRj.default) : t9;
    const renderEllipsis = t10 === undefined ? (0, $gV0FQ.default) : t10;
    let t11;
    if ($[0] !== defaultSelectedIndex) {
        t11 = ()=>defaultSelectedIndex || 0;
        $[0] = defaultSelectedIndex;
        $[1] = t11;
    } else t11 = $[1];
    const [selectedIndexValue, setSelectedIndexValue] = (0, $5Dlqn.default)(selectedIndex, t11);
    let t12;
    if ($[2] !== onChange || $[3] !== pages || $[4] !== selectedIndex || $[5] !== setSelectedIndexValue) {
        t12 = (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        };
        $[2] = onChange;
        $[3] = pages;
        $[4] = selectedIndex;
        $[5] = setSelectedIndexValue;
        $[6] = t12;
    } else t12 = $[6];
    let t13;
    if ($[7] !== analyticsContext || $[8] !== t12) {
        t13 = {
            fn: t12,
            action: "changed",
            actionSubject: "pageNumber",
            analyticsData: analyticsContext,
            ...$58ee79fc5bef7c86$var$analyticsAttributes
        };
        $[7] = analyticsContext;
        $[8] = t12;
        $[9] = t13;
    } else t13 = $[9];
    const onChangeWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t13);
    let t14;
    if ($[10] !== components.Page || $[11] !== getPageLabel || $[12] !== isDisabled || $[13] !== onChangeWithAnalytics || $[14] !== pageLabel || $[15] !== pages || $[16] !== selectedIndexValue) {
        t14 = (page, currPageIndex, testId_0)=>{
            const selectedPage = pages[selectedIndexValue];
            const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
            const isCurrentPage = page === selectedPage;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
                as: "li",
                xcss: $58ee79fc5bef7c86$var$styles.paginationMenuItem,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $diVBb.default), {
                    component: components.Page,
                    onClick: (event_0)=>onChangeWithAnalytics({
                            event: event_0,
                            selectedPageIndex: currPageIndex
                        }),
                    "aria-current": isCurrentPage ? "page" : undefined,
                    "aria-label": pageIndexLabel,
                    isSelected: isCurrentPage,
                    isDisabled: isDisabled,
                    page: page,
                    testId: testId_0 && `${testId_0}--${isCurrentPage ? "current-" : ""}page-${currPageIndex}`,
                    children: getPageLabel ? getPageLabel(page, currPageIndex) : page
                })
            }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
        };
        $[10] = components.Page;
        $[11] = getPageLabel;
        $[12] = isDisabled;
        $[13] = onChangeWithAnalytics;
        $[14] = pageLabel;
        $[15] = pages;
        $[16] = selectedIndexValue;
        $[17] = t14;
    } else t14 = $[17];
    const transform = t14;
    let t15;
    if ($[18] !== onChangeWithAnalytics || $[19] !== selectedIndexValue) {
        t15 = (event_1)=>onChangeWithAnalytics({
                event: event_1,
                selectedPageIndex: selectedIndexValue - 1
            });
        $[18] = onChangeWithAnalytics;
        $[19] = selectedIndexValue;
        $[20] = t15;
    } else t15 = $[20];
    const t16 = isDisabled || selectedIndexValue === 0;
    let t17;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = /*#__PURE__*/ (0, $8aG6j.jsx)($58ee79fc5bef7c86$var$NavigatorIcon, {
            chevronDirection: "left"
        });
        $[21] = t17;
    } else t17 = $[21];
    const t18 = testId && `${testId}--left-navigator`;
    let t19;
    if ($[22] !== components.Previous || $[23] !== previousLabel || $[24] !== t15 || $[25] !== t16 || $[26] !== t18) {
        t19 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9yPZa.default), {
            component: components.Previous,
            onClick: t15,
            isDisabled: t16,
            iconBefore: t17,
            "aria-label": previousLabel,
            testId: t18
        }, "left-navigator");
        $[22] = components.Previous;
        $[23] = previousLabel;
        $[24] = t15;
        $[25] = t16;
        $[26] = t18;
        $[27] = t19;
    } else t19 = $[27];
    let t20;
    if ($[28] !== max || $[29] !== pages || $[30] !== renderEllipsis || $[31] !== selectedIndexValue || $[32] !== testId || $[33] !== transform) {
        t20 = (0, $jQ9pN.default)(pages, selectedIndexValue, {
            max: max,
            ellipsis: renderEllipsis,
            transform: transform
        }, testId);
        $[28] = max;
        $[29] = pages;
        $[30] = renderEllipsis;
        $[31] = selectedIndexValue;
        $[32] = testId;
        $[33] = transform;
        $[34] = t20;
    } else t20 = $[34];
    let t21;
    if ($[35] !== t20) {
        t21 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
            space: "space.0",
            alignBlock: "baseline",
            as: "ul",
            xcss: $58ee79fc5bef7c86$var$styles.paginationMenu,
            children: t20
        });
        $[35] = t20;
        $[36] = t21;
    } else t21 = $[36];
    let t22;
    if ($[37] !== onChangeWithAnalytics || $[38] !== selectedIndexValue) {
        t22 = (event_2)=>onChangeWithAnalytics({
                event: event_2,
                selectedPageIndex: selectedIndexValue + 1
            });
        $[37] = onChangeWithAnalytics;
        $[38] = selectedIndexValue;
        $[39] = t22;
    } else t22 = $[39];
    const t23 = isDisabled || selectedIndexValue === pages.length - 1;
    let t24;
    if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
        t24 = /*#__PURE__*/ (0, $8aG6j.jsx)($58ee79fc5bef7c86$var$NavigatorIcon, {
            chevronDirection: "right"
        });
        $[40] = t24;
    } else t24 = $[40];
    const t25 = testId && `${testId}--right-navigator`;
    let t26;
    if ($[41] !== components.Next || $[42] !== nextLabel || $[43] !== t22 || $[44] !== t23 || $[45] !== t25) {
        t26 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9yPZa.default), {
            component: components.Next,
            onClick: t22,
            isDisabled: t23,
            iconBefore: t24,
            "aria-label": nextLabel,
            testId: t25
        }, "right-navigator");
        $[41] = components.Next;
        $[42] = nextLabel;
        $[43] = t22;
        $[44] = t23;
        $[45] = t25;
        $[46] = t26;
    } else t26 = $[46];
    let t27;
    if ($[47] !== t19 || $[48] !== t21 || $[49] !== t26) {
        t27 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            space: "space.0",
            alignBlock: "center",
            children: [
                t19,
                t21,
                t26
            ]
        });
        $[47] = t19;
        $[48] = t21;
        $[49] = t26;
        $[50] = t27;
    } else t27 = $[50];
    let t28;
    if ($[51] !== label || $[52] !== ref || $[53] !== style || $[54] !== t27 || $[55] !== testId) {
        t28 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            testId: testId,
            style: style,
            ref: ref,
            "aria-label": label,
            as: "nav",
            children: t27
        });
        $[51] = label;
        $[52] = ref;
        $[53] = style;
        $[54] = t27;
        $[55] = testId;
        $[56] = t28;
    } else t28 = $[56];
    return t28;
} : function InnerPagination({ components: components = (0, $3VKbs.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $3VKbs.emptyObject), max: max = 7, onChange: onChange = (0, $dpsRj.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $gV0FQ.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $5Dlqn.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$58ee79fc5bef7c86$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId_0)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
            as: "li",
            xcss: $58ee79fc5bef7c86$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $diVBb.default), {
                component: components.Page,
                onClick: (event_0)=>onChangeWithAnalytics({
                        event: event_0,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId_0 && `${testId_0}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9yPZa.default), {
                    component: components.Previous,
                    onClick: (event_1)=>onChangeWithAnalytics({
                            event: event_1,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)($58ee79fc5bef7c86$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $58ee79fc5bef7c86$var$styles.paginationMenu,
                    children: (0, $jQ9pN.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9yPZa.default), {
                    component: components.Next,
                    onClick: (event_2)=>onChangeWithAnalytics({
                            event: event_2,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)($58ee79fc5bef7c86$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
};
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $58ee79fc5bef7c86$var$Pagination = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)($58ee79fc5bef7c86$var$InnerPagination));
var $58ee79fc5bef7c86$export$2e2bcd8739ae039 = $58ee79fc5bef7c86$var$Pagination;
module.exports["default"] = $58ee79fc5bef7c86$export$2e2bcd8739ae039;

});

parcelRegister("9yPZa", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $7ZB0A = parcelRequire("7ZB0A");

const $17f3d644edf8e222$var$Navigator = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Navigator(props) {
    const $ = (0, $bDgLe.c)(7);
    const t0 = props["aria-label"];
    let t1;
    if ($[0] !== props.component || $[1] !== props.iconBefore || $[2] !== props.isDisabled || $[3] !== props.onClick || $[4] !== props.testId || $[5] !== t0) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZB0A.default), {
            "aria-label": t0,
            isDisabled: props.isDisabled,
            iconBefore: props.iconBefore,
            testId: props.testId,
            onClick: props.onClick,
            component: props.component,
            appearance: "subtle"
        });
        $[0] = props.component;
        $[1] = props.iconBefore;
        $[2] = props.isDisabled;
        $[3] = props.onClick;
        $[4] = props.testId;
        $[5] = t0;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : function Navigator(props) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZB0A.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
};
var $17f3d644edf8e222$export$2e2bcd8739ae039 = $17f3d644edf8e222$var$Navigator;
module.exports["default"] = $17f3d644edf8e222$export$2e2bcd8739ae039;

});

parcelRegister("diVBb", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $7ZB0A = parcelRequire("7ZB0A");

const $c982ffc605b50884$var$Page = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Page(props) {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZB0A.default), {
            ...props,
            appearance: "subtle"
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function Page(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZB0A.default), {
        ...props,
        appearance: "subtle"
    });
};
var $c982ffc605b50884$export$2e2bcd8739ae039 = $c982ffc605b50884$var$Page;
module.exports["default"] = $c982ffc605b50884$export$2e2bcd8739ae039;

});

parcelRegister("gV0FQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $704f330cc7acd87d$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $9GVkD = parcelRequire("9GVkD");

const $704f330cc7acd87d$var$styles = {
    container: "_3iDTPbQ4SZ _1mT5xdRAKS"
};
function $704f330cc7acd87d$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        as: "li",
        testId: testId,
        xcss: $704f330cc7acd87d$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4aRua.Text), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $9GVkD.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("3VKbs", function(module, exports) {
const $4a66713043ed72c4$export$3f860eba1218f8d3 = {};
module.exports["emptyObject"] = $4a66713043ed72c4$export$3f860eba1218f8d3;

});

parcelRegister("jQ9pN", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");

// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $a160bbcb7aa35a3d$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $dOBRD.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $a160bbcb7aa35a3d$export$2e2bcd8739ae039 = $a160bbcb7aa35a3d$var$collapseRange;
module.exports["default"] = $a160bbcb7aa35a3d$export$2e2bcd8739ae039;

});

parcelRegister("3B2WR", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $iHx0I = parcelRequire("iHx0I");


var $jdz9l = parcelRequire("jdz9l");


var $1iBum = parcelRequire("1iBum");


var $bhume = parcelRequire("bhume");

// eslint-disable-next-line @repo/internal/react/no-class-components
class $5be55afeb6489ab2$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    UNSAFE_componentWillMount() {
        (0, $iHx0I.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $iHx0I.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        const { activeSortButtonId: activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponent = isRankable ? (0, $1iBum.default) : (0, $bhume.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jdz9l.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("tr", {
                children: cells.map((cell, index)=>{
                    const { ascendingSortTooltip: ascendingSortTooltip, buttonAriaRoleDescription: buttonAriaRoleDescription, colSpan: colSpan, content: content, descendingSortTooltip: descendingSortTooltip, isIconOnlyHeader: isIconOnlyHeader, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
                    // the API.
                    ...restCellProps } = cell;
                    const headCellId = `head-cell-${index}`;
                    const handleClick = ()=>{
                        this.setState({
                            activeSortButtonId: headCellId
                        });
                        if (isSortable) onSort(cell)();
                    };
                    return /*#__PURE__*/ (0, $8aG6j.jsx)(HeadCellComponent, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isIconOnlyHeader: isIconOnlyHeader,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        headCellId: headCellId,
                        activeSortButtonId: activeSortButtonId,
                        onClick: handleClick,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ascendingSortTooltip: ascendingSortTooltip,
                        descendingSortTooltip: descendingSortTooltip,
                        buttonAriaRoleDescription: buttonAriaRoleDescription,
                        ...restCellProps
                    }, key || index);
                })
            })
        });
    }
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5be55afeb6489ab2$export$2e2bcd8739ae039 = $5be55afeb6489ab2$var$TableHead;
module.exports["default"] = $5be55afeb6489ab2$export$2e2bcd8739ae039;

});

parcelRegister("jdz9l", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $43f63a491f547623$var$rankingStyles = null;
const $43f63a491f547623$var$headStyles = null;
const $43f63a491f547623$export$e93312b7773dfcac = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    let isRanking;
    let props;
    let testId;
    if ($[0] !== t0) {
        ({ isRanking: isRanking, testId: testId, ...props } = t0);
        $[0] = t0;
        $[1] = isRanking;
        $[2] = props;
        $[3] = testId;
    } else {
        isRanking = $[1];
        props = $[2];
        testId = $[3];
    }
    const t1 = isRanking && "_3iDTPbvLZJ";
    let t2;
    if ($[4] !== t1) {
        t2 = (0, $hekY6.default)([
            "_2R4pr3YbGa",
            t1
        ]);
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== props || $[7] !== t2 || $[8] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("thead", {
            "data-testid": testId,
            ...props,
            className: t2
        });
        $[6] = props;
        $[7] = t2;
        $[8] = testId;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("thead", {
        "data-testid": testId,
        ...props,
        className: (0, $hekY6.default)([
            "_2R4pr3YbGa",
            isRanking && "_3iDTPbvLZJ"
        ])
    });
};
module.exports["Head"] = $43f63a491f547623$export$e93312b7773dfcac;

});

parcelRegister("1iBum", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $f3XUw = parcelRequire("f3XUw");


var $igC1g = parcelRequire("igC1g");


var $bhume = parcelRequire("bhume");

// eslint-disable-next-line @repo/internal/react/no-class-components
class $53506f791efc14b8$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $igC1g.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bhume.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $53506f791efc14b8$var$RankableTableHeadCell = (0, $f3XUw.default)($53506f791efc14b8$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$53506f791efc14b8$export$2e2bcd8739ae039 = $53506f791efc14b8$var$RankableTableHeadCell;
module.exports["default"] = $53506f791efc14b8$export$2e2bcd8739ae039;

});

parcelRegister("f3XUw", function(module, exports) {
$parcel$export(module.exports, "default", () => $49115eaa34d5ed39$export$2e2bcd8739ae039);

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");

function $49115eaa34d5ed39$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, $8aG6j.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args);
            this.ref = void 0;
            this.state = {
                refWidth: 0,
                refHeight: 0
            };
            this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            };
            this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("igC1g", function(module, exports) {
const $0c1730be0d1593e6$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
module.exports["inlineStylesIfRanking"] = $0c1730be0d1593e6$export$a601f1775e10043f;

});

parcelRegister("bhume", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $fS8Zl = parcelRequire("fS8Zl");


var $f6cdQ = parcelRequire("f6cdQ");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");


var $lpNn5 = parcelRequire("lpNn5");


var $2ixp5 = parcelRequire("2ixp5");

const $a8e3c673927cc478$var$styles = {
    buttonWrapper: "_3iDTPbQ4SZ _0KLXrujOvk _0hPCNLDIqT _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _0ReiIH7zJH",
    truncateButtonWrapper: "_3iDTPbQ4SZ _0KLXrujOvk _0hPCNLDIqT _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _4ouGXIdnbC _1EqgXlN91d _0ReiIH7zJH",
    sortIconHiddenWrapper: "_3iDTPbQ4SZ _1YKVNsdnbC _0KLXrujOvk _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M _3vJpeh7dHp",
    sortIconVisibleWrapper: "_3iDTPbQ4SZ _1YKVNs7dHp _0KLXrujOvk _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M",
    hideIconHeaderWrapper: "_1YKVNsdnbC _2XsHFMQRM5",
    visibleHeaderWrapper: "_1YKVNs7dHp _1Znuxb1Y8M",
    truncateHeaderWrapper: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _1YKVNs7dHp _1Znuxb1Y8M _4ouGXIdnbC",
    truncateHiddenIconHeaderWrapper: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _1YKVNsdnbC _2XsHFMQRM5 _4ouGXIdnbC",
    truncateTooltipWrapper: "_4ouGXIdnbC _1EqgXlN91d"
};
const $a8e3c673927cc478$var$headCellStyles = {
    headCellContainer: "_3iDTPbQ4SZ _0hPCNLDIqT",
    text: "_2sNsIg7NXe _1UtDYzZpcK _1kk5Tkmb2E",
    truncateText: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _4ouGXIdnbC _39HuIbz8Lp _1ANEUSLRg7"
};
const $a8e3c673927cc478$var$TableHeadCell = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(45);
    let activeSortButtonId;
    let content;
    let headCellId;
    let inlineStyles;
    let innerRef;
    let isFixedSize;
    let isIconOnlyHeader;
    let isSortable;
    let onClick;
    let rest;
    let shouldTruncate;
    let sortOrder;
    let t1;
    let t2;
    let t3;
    let testId;
    if ($[0] !== t0) {
        const { content: t4, inlineStyles: t5, testId: t6, isRanking: isRanking, innerRef: t7, isSortable: t8, sortOrder: t9, onClick: t10, headCellId: t11, activeSortButtonId: t12, ascendingSortTooltip: t13, descendingSortTooltip: t14, buttonAriaRoleDescription: t15, isIconOnlyHeader: t16, isFixedSize: t17, shouldTruncate: t18, ...t19 } = t0;
        content = t4;
        inlineStyles = t5;
        testId = t6;
        innerRef = t7;
        isSortable = t8;
        sortOrder = t9;
        onClick = t10;
        headCellId = t11;
        activeSortButtonId = t12;
        t1 = t13;
        t2 = t14;
        t3 = t15;
        isIconOnlyHeader = t16;
        isFixedSize = t17;
        shouldTruncate = t18;
        rest = t19;
        $[0] = t0;
        $[1] = activeSortButtonId;
        $[2] = content;
        $[3] = headCellId;
        $[4] = inlineStyles;
        $[5] = innerRef;
        $[6] = isFixedSize;
        $[7] = isIconOnlyHeader;
        $[8] = isSortable;
        $[9] = onClick;
        $[10] = rest;
        $[11] = shouldTruncate;
        $[12] = sortOrder;
        $[13] = t1;
        $[14] = t2;
        $[15] = t3;
        $[16] = testId;
    } else {
        activeSortButtonId = $[1];
        content = $[2];
        headCellId = $[3];
        inlineStyles = $[4];
        innerRef = $[5];
        isFixedSize = $[6];
        isIconOnlyHeader = $[7];
        isSortable = $[8];
        onClick = $[9];
        rest = $[10];
        shouldTruncate = $[11];
        sortOrder = $[12];
        t1 = $[13];
        t2 = $[14];
        t3 = $[15];
        testId = $[16];
    }
    const ascendingSortTooltip = t1 === undefined ? "Sort ascending" : t1;
    const descendingSortTooltip = t2 === undefined ? "Sort descending" : t2;
    const buttonAriaRoleDescription = t3 === undefined ? "Sort button" : t3;
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const [isFocused, setIsFocused] = (0, $cozmU.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    let t4;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            setIsFocused?.(true);
        };
        $[17] = t4;
    } else t4 = $[17];
    const handleFocus = t4;
    let t5;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>{
            setIsFocused?.(false);
        };
        $[18] = t5;
    } else t5 = $[18];
    const handleBlur = t5;
    let t6;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setIsHovered(true);
        };
        $[19] = t6;
    } else t6 = $[19];
    const handleMouseEnter = t6;
    let t7;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>{
            setIsHovered(false);
        };
        $[20] = t7;
    } else t7 = $[20];
    const handleMouseLeave = t7;
    const t8 = sortOrder === "ASC" ? ascendingSortTooltip : descendingSortTooltip;
    let t9;
    if ($[21] !== buttonAriaRoleDescription || $[22] !== content || $[23] !== isFixedSize || $[24] !== isSortIconVisible || $[25] !== isVisibleIconOnlyHeader || $[26] !== onClick || $[27] !== shouldRenderSortIcon || $[28] !== shouldTruncate || $[29] !== sortOrder || $[30] !== testId) {
        t9 = (tooltipProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                role: "presentation",
                xcss: isFixedSize && shouldTruncate ? $a8e3c673927cc478$var$styles.truncateTooltipWrapper : undefined,
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hBYtq.Pressable), {
                    ...tooltipProps,
                    onClick: onClick,
                    xcss: isFixedSize && shouldTruncate ? $a8e3c673927cc478$var$styles.truncateButtonWrapper : $a8e3c673927cc478$var$styles.buttonWrapper,
                    "aria-roledescription": buttonAriaRoleDescription,
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
                            xcss: isFixedSize && shouldTruncate ? isVisibleIconOnlyHeader ? $a8e3c673927cc478$var$styles.truncateHiddenIconHeaderWrapper : $a8e3c673927cc478$var$styles.truncateHeaderWrapper : isVisibleIconOnlyHeader ? $a8e3c673927cc478$var$styles.hideIconHeaderWrapper : $a8e3c673927cc478$var$styles.visibleHeaderWrapper,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                                className: (0, $hekY6.default)([
                                    $a8e3c673927cc478$var$headCellStyles.text,
                                    isFixedSize && shouldTruncate && $a8e3c673927cc478$var$headCellStyles.truncateText
                                ]),
                                children: content
                            })
                        }),
                        shouldRenderSortIcon && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
                            xcss: isSortIconVisible ? $a8e3c673927cc478$var$styles.sortIconVisibleWrapper : $a8e3c673927cc478$var$styles.sortIconHiddenWrapper,
                            children: sortOrder === "ASC" ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))), {
                                label: "",
                                color: "var(--ds-text-subtle, #505258)",
                                testId: testId && `${testId}--up--icon`
                            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fS8Zl))), {
                                label: "",
                                color: "var(--ds-text-subtle, #505258)",
                                testId: testId && `${testId}--down--icon`
                            })
                        })
                    ]
                })
            });
        $[21] = buttonAriaRoleDescription;
        $[22] = content;
        $[23] = isFixedSize;
        $[24] = isSortIconVisible;
        $[25] = isVisibleIconOnlyHeader;
        $[26] = onClick;
        $[27] = shouldRenderSortIcon;
        $[28] = shouldTruncate;
        $[29] = sortOrder;
        $[30] = testId;
        $[31] = t9;
    } else t9 = $[31];
    let t10;
    if ($[32] !== t8 || $[33] !== t9) {
        t10 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $a8e3c673927cc478$var$headCellStyles.headCellContainer,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            onFocus: handleFocus,
            onBlur: handleBlur,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                content: t8,
                children: t9
            })
        });
        $[32] = t8;
        $[33] = t9;
        $[34] = t10;
    } else t10 = $[34];
    const visuallyRefreshedButton = t10;
    const t11 = testId && `${testId}--head--cell`;
    const t12 = typeof innerRef !== "string" ? innerRef : null;
    const t13 = isSortable ? visuallyRefreshedButton : content;
    let t14;
    if ($[35] !== inlineStyles || $[36] !== isFixedSize || $[37] !== isSortable || $[38] !== rest || $[39] !== shouldTruncate || $[40] !== sortOrder || $[41] !== t11 || $[42] !== t12 || $[43] !== t13) {
        t14 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2ixp5.HeadCell), {
            style: inlineStyles,
            testId: t11,
            ref: t12,
            ...rest,
            isFixedSize: isFixedSize,
            isSortable: isSortable,
            sortOrder: sortOrder,
            shouldTruncate: shouldTruncate,
            children: t13
        });
        $[35] = inlineStyles;
        $[36] = isFixedSize;
        $[37] = isSortable;
        $[38] = rest;
        $[39] = shouldTruncate;
        $[40] = sortOrder;
        $[41] = t11;
        $[42] = t12;
        $[43] = t13;
        $[44] = t14;
    } else t14 = $[44];
    return t14;
} : ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, sortOrder: sortOrder, onClick: onClick, headCellId: headCellId, activeSortButtonId: activeSortButtonId, ascendingSortTooltip: ascendingSortTooltip = 'Sort ascending', descendingSortTooltip: descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription: buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader: isIconOnlyHeader, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, ...rest })=>{
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const [isFocused, setIsFocused] = (0, $cozmU.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, $cozmU.useCallback)(()=>{
        setIsFocused?.(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, $cozmU.useCallback)(()=>{
        setIsFocused?.(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, $cozmU.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, $cozmU.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $a8e3c673927cc478$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            content: sortOrder === 'ASC' ? ascendingSortTooltip : descendingSortTooltip,
            children: (tooltipProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    role: "presentation",
                    xcss: isFixedSize && shouldTruncate ? $a8e3c673927cc478$var$styles.truncateTooltipWrapper : undefined,
                    children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hBYtq.Pressable), {
                        ...tooltipProps,
                        onClick: onClick,
                        xcss: isFixedSize && shouldTruncate ? $a8e3c673927cc478$var$styles.truncateButtonWrapper : $a8e3c673927cc478$var$styles.buttonWrapper,
                        "aria-roledescription": buttonAriaRoleDescription,
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
                                xcss: isFixedSize && shouldTruncate ? isVisibleIconOnlyHeader ? $a8e3c673927cc478$var$styles.truncateHiddenIconHeaderWrapper : $a8e3c673927cc478$var$styles.truncateHeaderWrapper : isVisibleIconOnlyHeader ? $a8e3c673927cc478$var$styles.hideIconHeaderWrapper : $a8e3c673927cc478$var$styles.visibleHeaderWrapper,
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                                    className: (0, $hekY6.default)([
                                        $a8e3c673927cc478$var$headCellStyles.text,
                                        isFixedSize && shouldTruncate && $a8e3c673927cc478$var$headCellStyles.truncateText
                                    ]),
                                    children: content
                                })
                            }),
                            shouldRenderSortIcon && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
                                xcss: isSortIconVisible ? $a8e3c673927cc478$var$styles.sortIconVisibleWrapper : $a8e3c673927cc478$var$styles.sortIconHiddenWrapper,
                                children: sortOrder === 'ASC' ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))), {
                                    label: "",
                                    color: "var(--ds-text-subtle, #505258)",
                                    testId: testId && `${testId}--up--icon`
                                }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fS8Zl))), {
                                    label: "",
                                    color: "var(--ds-text-subtle, #505258)",
                                    testId: testId && `${testId}--down--icon`
                                })
                            })
                        ]
                    })
                })
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2ixp5.HeadCell // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ), {
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        isFixedSize: isFixedSize,
        isSortable: isSortable,
        sortOrder: sortOrder,
        shouldTruncate: shouldTruncate,
        children: isSortable ? visuallyRefreshedButton : content
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $a8e3c673927cc478$export$2e2bcd8739ae039 = $a8e3c673927cc478$var$TableHeadCell;
module.exports["default"] = $a8e3c673927cc478$export$2e2bcd8739ae039;

});

parcelRegister("2ixp5", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $aKm7d = parcelRequire("aKm7d");

const $198075616c813fb7$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $198075616c813fb7$var$overflowTruncateStyles = null;
const $198075616c813fb7$var$truncationWidthStyles = null;
const $198075616c813fb7$var$fixedSizeTruncateStyles = null;
const $198075616c813fb7$var$cellStyles = null;
const $198075616c813fb7$var$headCellBaseStyles = null;
const $198075616c813fb7$export$4e8024263ace498b = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(29);
    let children;
    let isFixedSize;
    let rest;
    let shouldTruncate;
    let sortOrder;
    let style;
    let testId;
    let width;
    if ($[0] !== t0) {
        const { width: t1, children: t2, isSortable: isSortable, sortOrder: t3, isFixedSize: t4, shouldTruncate: t5, onClick: onClick, style: t6, testId: t7, ...t8 } = t0;
        width = t1;
        children = t2;
        sortOrder = t3;
        isFixedSize = t4;
        shouldTruncate = t5;
        style = t6;
        testId = t7;
        rest = t8;
        $[0] = t0;
        $[1] = children;
        $[2] = isFixedSize;
        $[3] = rest;
        $[4] = shouldTruncate;
        $[5] = sortOrder;
        $[6] = style;
        $[7] = testId;
        $[8] = width;
    } else {
        children = $[1];
        isFixedSize = $[2];
        rest = $[3];
        shouldTruncate = $[4];
        sortOrder = $[5];
        style = $[6];
        testId = $[7];
        width = $[8];
    }
    let t1;
    if ($[9] !== width) {
        t1 = width && (0, $aKm7d.getTruncationStyleVars)({
            width: width
        });
        $[9] = width;
        $[10] = t1;
    } else t1 = $[10];
    let t2;
    if ($[11] !== style || $[12] !== t1) {
        t2 = {
            ...style,
            ...t1,
            [$198075616c813fb7$var$CSS_VAR_TEXT_COLOR]: "var(--ds-text-subtlest, #6B6E76)"
        };
        $[11] = style;
        $[12] = t1;
        $[13] = t2;
    } else t2 = $[13];
    const mergedStyles = t2;
    const isASC = sortOrder === "ASC";
    const isDESC = sortOrder === "DESC";
    let t3;
    if ($[14] !== isASC || $[15] !== isDESC) {
        t3 = ()=>{
            if (isASC) return "ascending";
            else {
                if (isDESC) return "descending";
            }
        };
        $[14] = isASC;
        $[15] = isDESC;
        $[16] = t3;
    } else t3 = $[16];
    const getFormattedSortOrder = t3;
    const Component = children ? "th" : "td";
    const t4 = getFormattedSortOrder();
    const t5 = isFixedSize && shouldTruncate && "_39HuIbz8Lp _1ANEUSLRg7";
    const t6 = isFixedSize && "_4bt5LAnQyn _2WAcuGnQyn";
    let t7;
    if ($[17] !== t5 || $[18] !== t6) {
        t7 = (0, $hekY6.default)([
            "_029LLIYbGa _18otpjYbGa _0xmtko1Y8M _46hvQm1Y8M _03SyCP2ADO _0LQT5E2ADO _2fwxA5ecOK _4efXyCPgdg _22fNSnPgdg",
            "_2sNsIg7NXe _2R4pr31z4g _1v3aPqYbGa _1mT5xdRAKS _1UtDYzZpcK _1kk5Tkmb2E _2fwxA5ecOK _1RrJLit2nV _4EiLyUfNHp",
            "_39xV02SBlE",
            t5,
            t6
        ]);
        $[17] = t5;
        $[18] = t6;
        $[19] = t7;
    } else t7 = $[19];
    let t8;
    if ($[20] !== Component || $[21] !== children || $[22] !== mergedStyles || $[23] !== ref || $[24] !== rest || $[25] !== t4 || $[26] !== t7 || $[27] !== testId) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
            "aria-sort": t4,
            style: mergedStyles,
            onClick: undefined,
            ref: ref,
            "data-testid": testId,
            ...rest,
            className: t7,
            children: children
        });
        $[20] = Component;
        $[21] = children;
        $[22] = mergedStyles;
        $[23] = ref;
        $[24] = rest;
        $[25] = t4;
        $[26] = t7;
        $[27] = testId;
        $[28] = t8;
    } else t8 = $[28];
    return t8;
} : ({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $aKm7d.getTruncationStyleVars)({
            width: width
        }),
        [$198075616c813fb7$var$CSS_VAR_TEXT_COLOR]: "var(--ds-text-subtlest, #6B6E76)"
    };
    const isASC = sortOrder === 'ASC';
    const isDESC = sortOrder === 'DESC';
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
        return;
    }; // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    return /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        style: mergedStyles,
        onClick: undefined,
        ref: ref,
        "data-testid": testId,
        ...rest,
        className: (0, $hekY6.default)([
            "_029LLIYbGa _18otpjYbGa _0xmtko1Y8M _46hvQm1Y8M _03SyCP2ADO _0LQT5E2ADO _2fwxA5ecOK _4efXyCPgdg _22fNSnPgdg",
            "_2sNsIg7NXe _2R4pr31z4g _1v3aPqYbGa _1mT5xdRAKS _1UtDYzZpcK _1kk5Tkmb2E _2fwxA5ecOK _1RrJLit2nV _4EiLyUfNHp",
            "_39xV02SBlE",
            isFixedSize && shouldTruncate && "_39HuIbz8Lp _1ANEUSLRg7",
            isFixedSize && "_4bt5LAnQyn _2WAcuGnQyn"
        ]),
        children: children
    });
});
module.exports["HeadCell"] = $198075616c813fb7$export$4e8024263ace498b;

});

parcelRegister("b6DGi", function(module, exports) {

let $815f0920299cc140$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $815f0920299cc140$var$load("iQvHF"),
    $815f0920299cc140$var$load("2lAWD")
]).then(()=>parcelRequire('61gNL'));

});

parcelRegister("2uDbg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7r5Hr = parcelRequire("7r5Hr");


var $lmzCg = parcelRequire("lmzCg");


var $8c6io = parcelRequire("8c6io");


var $2hGAN = parcelRequire("2hGAN");


var $cAK2R = parcelRequire("cAK2R");


var $kbRVk = parcelRequire("kbRVk");

const $5e9458ef4430c05f$var$checkboxStyles = {
    root: "_30huDKYbGa _1xC2CJsLaB _2xIroY98eZ _497WNwYbGa _2zndICT6kp _39xV02N91d _0jFU0VN91d _034jHtYbGa _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _1YKVNsdnbC"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $5e9458ef4430c05f$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Checkbox(t0, ref) {
    const $ = (0, $bDgLe.c)(59);
    let analyticsContext;
    let className;
    let isCheckedProp;
    let isRequired;
    let label;
    let name;
    let onChangeProps;
    let rest;
    let t1;
    let t2;
    let t3;
    let t4;
    let testId;
    let value;
    let xcss;
    if ($[0] !== t0) {
        ({ isChecked: isCheckedProp, isDisabled: t1, isInvalid: t2, defaultChecked: t3, isIndeterminate: t4, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = className;
        $[3] = isCheckedProp;
        $[4] = isRequired;
        $[5] = label;
        $[6] = name;
        $[7] = onChangeProps;
        $[8] = rest;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
        $[13] = testId;
        $[14] = value;
        $[15] = xcss;
    } else {
        analyticsContext = $[1];
        className = $[2];
        isCheckedProp = $[3];
        isRequired = $[4];
        label = $[5];
        name = $[6];
        onChangeProps = $[7];
        rest = $[8];
        t1 = $[9];
        t2 = $[10];
        t3 = $[11];
        t4 = $[12];
        testId = $[13];
        value = $[14];
        xcss = $[15];
    }
    const isDisabled = t1 === undefined ? false : t1;
    const isInvalid = t2 === undefined ? false : t2;
    const defaultChecked = t3 === undefined ? false : t3;
    const isIndeterminate = t4 === undefined ? false : t4;
    const [isCheckedState, setIsCheckedState] = (0, $cozmU.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    let t5;
    if ($[16] !== onChangeProps) {
        t5 = (e, analyticsEvent)=>{
            setIsCheckedState(e.target.checked);
            if (onChangeProps) onChangeProps(e, analyticsEvent);
        };
        $[16] = onChangeProps;
        $[17] = t5;
    } else t5 = $[17];
    const onChange = t5;
    let t6;
    if ($[18] !== analyticsContext || $[19] !== onChange) {
        t6 = {
            fn: onChange,
            action: "changed",
            analyticsData: analyticsContext,
            componentName: "checkbox",
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        };
        $[18] = analyticsContext;
        $[19] = onChange;
        $[20] = t6;
    } else t6 = $[20];
    const onChangeAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t6);
    const internalRef = (0, $cozmU.useRef)(null);
    const mergedRefs = (0, $lmzCg.default)([
        internalRef,
        ref
    ]);
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    let t7;
    if ($[21] !== internalRef || $[22] !== isIndeterminate) {
        t7 = ()=>{
            if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
        };
        $[21] = internalRef;
        $[22] = isIndeterminate;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== isIndeterminate) {
        t8 = [
            isIndeterminate
        ];
        $[24] = isIndeterminate;
        $[25] = t8;
    } else t8 = $[25];
    (0, $cozmU.useEffect)(t7, t8);
    const t9 = label;
    const t10 = rest.id ? `${rest.id}-label` : undefined;
    const t11 = testId && `${testId}--checkbox-label`;
    let t12;
    if ($[26] !== className) {
        t12 = (0, $hekY6.default)([
            $5e9458ef4430c05f$var$checkboxStyles.root,
            className
        ]);
        $[26] = className;
        $[27] = t12;
    } else t12 = $[27];
    const t13 = isInvalid ? "true" : undefined;
    const t14 = testId && `${testId}--hidden-checkbox`;
    const t15 = isInvalid ? "true" : undefined;
    let t16;
    if ($[28] !== isChecked || $[29] !== isDisabled || $[30] !== isRequired || $[31] !== mergedRefs || $[32] !== name || $[33] !== onChangeAnalytics || $[34] !== rest || $[35] !== t12 || $[36] !== t13 || $[37] !== t14 || $[38] !== t15 || $[39] !== value) {
        t16 = /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
            tabIndex: 0,
            ...rest,
            type: "checkbox",
            ref: mergedRefs,
            disabled: isDisabled,
            checked: isChecked,
            value: value,
            name: name,
            required: isRequired,
            className: t12,
            onChange: onChangeAnalytics,
            "aria-invalid": t13,
            "data-testid": t14,
            "data-invalid": t15
        });
        $[28] = isChecked;
        $[29] = isDisabled;
        $[30] = isRequired;
        $[31] = mergedRefs;
        $[32] = name;
        $[33] = onChangeAnalytics;
        $[34] = rest;
        $[35] = t12;
        $[36] = t13;
        $[37] = t14;
        $[38] = t15;
        $[39] = value;
        $[40] = t16;
    } else t16 = $[40];
    let t17;
    if ($[41] !== isChecked || $[42] !== isIndeterminate) {
        t17 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8c6io.default), {
            isIndeterminate: isIndeterminate,
            isChecked: isChecked
        });
        $[41] = isChecked;
        $[42] = isIndeterminate;
        $[43] = t17;
    } else t17 = $[43];
    let t18;
    if ($[44] !== isRequired || $[45] !== label) {
        t18 = label && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cAK2R.default), {
            children: [
                label,
                isRequired && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kbRVk.default), {})
            ]
        });
        $[44] = isRequired;
        $[45] = label;
        $[46] = t18;
    } else t18 = $[46];
    let t19;
    if ($[47] !== isChecked || $[48] !== isDisabled || $[49] !== isIndeterminate || $[50] !== isInvalid || $[51] !== t10 || $[52] !== t11 || $[53] !== t16 || $[54] !== t17 || $[55] !== t18 || $[56] !== t9 || $[57] !== xcss) {
        t19 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $2hGAN.default), {
            isDisabled: isDisabled,
            isChecked: isChecked,
            isIndeterminate: isIndeterminate,
            isInvalid: isInvalid,
            label: t9,
            id: t10,
            testId: t11,
            xcss: xcss,
            children: [
                t16,
                t17,
                t18
            ]
        });
        $[47] = isChecked;
        $[48] = isDisabled;
        $[49] = isIndeterminate;
        $[50] = isInvalid;
        $[51] = t10;
        $[52] = t11;
        $[53] = t16;
        $[54] = t17;
        $[55] = t18;
        $[56] = t9;
        $[57] = xcss;
        $[58] = t19;
    } else t19 = $[58];
    return t19;
} : function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $cozmU.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $cozmU.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $cozmU.useRef)(null);
    const mergedRefs = (0, $lmzCg.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $cozmU.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $2hGAN.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $hekY6.default)([
                    $5e9458ef4430c05f$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8c6io.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cAK2R.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kbRVk.default), {})
                ]
            })
        ]
    });
}));
$5e9458ef4430c05f$export$48513f6b9f8ce62d.displayName = 'Checkbox'; // keep the default export for backwards compatibility
var $5e9458ef4430c05f$export$2e2bcd8739ae039 = $5e9458ef4430c05f$export$48513f6b9f8ce62d;
module.exports["Checkbox"] = $5e9458ef4430c05f$export$48513f6b9f8ce62d;
module.exports["default"] = $5e9458ef4430c05f$export$2e2bcd8739ae039;

});

parcelRegister("8c6io", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $ef6550583d45a5c6$var$svgStyles = {
    root: "_1xC2CJsLaB _4bt5LAnQyn _2WAcuGnQyn _23rrnHXVX0 _0bjKvDKxmn _32BiAhDfsT _1pp6NdYbGa _1UtDYzQPq5 _1rdFvh1XeA _3e6OgrLl21",
    rect: "_23rrnHFqy6 _4gxJYwNvrM _4e1TYvUkr1"
};
function $ef6550583d45a5c6$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
     // No icon
    return null;
}
const $ef6550583d45a5c6$var$CheckboxIcon = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { isIndeterminate: isIndeterminate, isChecked: isChecked } = t0;
    let t1;
    if ($[0] !== isChecked || $[1] !== isIndeterminate) {
        t1 = $ef6550583d45a5c6$var$getIcon(isIndeterminate, isChecked);
        $[0] = isChecked;
        $[1] = isIndeterminate;
        $[2] = t1;
    } else t1 = $[2];
    const icon = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $ef6550583d45a5c6$var$svgStyles.root
        ]);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
            fill: "currentColor",
            x: "5.5",
            y: "5.5",
            width: "13",
            height: "13",
            rx: "1.5",
            className: (0, $hekY6.default)([
                $ef6550583d45a5c6$var$svgStyles.rect
            ])
        });
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== icon) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            role: "presentation",
            className: t2,
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
                fillRule: "evenodd",
                children: [
                    t3,
                    icon
                ]
            })
        });
        $[5] = icon;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $cozmU.useMemo)(()=>$ef6550583d45a5c6$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $hekY6.default)([
            $ef6550583d45a5c6$var$svgStyles.root
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    className: (0, $hekY6.default)([
                        $ef6550583d45a5c6$var$svgStyles.rect
                    ])
                }),
                icon
            ]
        })
    });
});
var $ef6550583d45a5c6$export$2e2bcd8739ae039 = $ef6550583d45a5c6$var$CheckboxIcon;
module.exports["default"] = $ef6550583d45a5c6$export$2e2bcd8739ae039;

});

parcelRegister("2hGAN", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $1634ca3e0554fde5$var$baseStyles = null;
const $1634ca3e0554fde5$var$textLabelLayoutStyles = null; // Checked/Indeterminate state
const $1634ca3e0554fde5$var$checkedStyles = null; // Invalid state - must override hover/active to maintain red border
const $1634ca3e0554fde5$var$invalidStyles = null; // Disabled state - must override hover/active to maintain disabled appearance
const $1634ca3e0554fde5$var$disabledStyles = null; // Disabled + Checked/Indeterminate
const $1634ca3e0554fde5$var$disabledCheckedStyles = null;
const $1634ca3e0554fde5$var$Label = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Label(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss } = t0;
    const t1 = label && "_2mHwu8RsfN _2iEGP2a3NQ";
    const t2 = (isChecked || isIndeterminate) && "_49q2vakLmD _0ZqVxakLmD _3jFxiY6BYM _4slB72XLOx _1IEstyXLOx _01wY7FutHW _0R5xzg9r67 _2m1JOU6BYM _1ixXUak5Cz _4dUVtQTxK4 _2o2XD9TxK4";
    const t3 = isInvalid && "_0ZqVxanod9 _1IEstynod9 _0R5xzgnod9 _4dUVtQBvTi";
    const t4 = isDisabled && "_49q2vaVrZW _0ZqVxaVrZW _1UtDYzot27 _0wOv4Qsyl5 _4slB72VrZW _1IEstyVrZW _01wY7FVrZW _0R5xzgVrZW _1ixXUak5Cz _4dUVtQ5l5r _2o2XD95l5r";
    const t5 = isDisabled && (isChecked || isIndeterminate) && "_3jFxiYoM2E _0D4MlqoM2E _2m1JOUoM2E";
    let t6;
    if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5 || $[5] !== xcss) {
        t6 = (0, $hekY6.default)([
            "_2sNsIgmnOE _3iDTPbgBM8 _3kOVpyUfmU _21ioM3BY1A _49q2va7Cj1 _0ZqVxaHKt7 _3b00HoYbGa _3jFxiYjOvk _1UtDYzy7kJ _0wOv4Q18ZR _1q8flZXzJH _4slB72qWX3 _01wY7FutHW _0R5xzg9r67 _1ixXUak5Cz _4dUVtQTxK4 _2o2XD9TxK4",
            t1,
            t2,
            t3,
            t4,
            t5,
            xcss
        ]);
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = xcss;
        $[6] = t6;
    } else t6 = $[6];
    const t7 = isDisabled || undefined;
    let t8;
    if ($[7] !== children || $[8] !== id || $[9] !== t6 || $[10] !== t7 || $[11] !== testId) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)("label", {
            className: t6,
            "data-testid": testId,
            "data-disabled": t7,
            id: id,
            children: children
        });
        $[7] = children;
        $[8] = id;
        $[9] = t6;
        $[10] = t7;
        $[11] = testId;
        $[12] = t8;
    } else t8 = $[12];
    return t8;
} : function Label({ children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("label", {
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _3iDTPbgBM8 _3kOVpyUfmU _21ioM3BY1A _49q2va7Cj1 _0ZqVxaHKt7 _3b00HoYbGa _3jFxiYjOvk _1UtDYzy7kJ _0wOv4Q18ZR _1q8flZXzJH _4slB72qWX3 _01wY7FutHW _0R5xzg9r67 _1ixXUak5Cz _4dUVtQTxK4 _2o2XD9TxK4",
            label && "_2mHwu8RsfN _2iEGP2a3NQ",
            (isChecked || isIndeterminate) && "_49q2vakLmD _0ZqVxakLmD _3jFxiY6BYM _4slB72XLOx _1IEstyXLOx _01wY7FutHW _0R5xzg9r67 _2m1JOU6BYM _1ixXUak5Cz _4dUVtQTxK4 _2o2XD9TxK4",
            isInvalid && "_0ZqVxanod9 _1IEstynod9 _0R5xzgnod9 _4dUVtQBvTi",
            isDisabled && "_49q2vaVrZW _0ZqVxaVrZW _1UtDYzot27 _0wOv4Qsyl5 _4slB72VrZW _1IEstyVrZW _01wY7FVrZW _0R5xzgVrZW _1ixXUak5Cz _4dUVtQ5l5r _2o2XD95l5r",
            isDisabled && (isChecked || isIndeterminate) && "_3jFxiYoM2E _0D4MlqoM2E _2m1JOUoM2E",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
};
var $1634ca3e0554fde5$export$2e2bcd8739ae039 = $1634ca3e0554fde5$var$Label;
module.exports["default"] = $1634ca3e0554fde5$export$2e2bcd8739ae039;

});

parcelRegister("cAK2R", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $4870a5341200be20$var$labelTextStyles = null;
const $4870a5341200be20$var$LabelText = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LabelText(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1xC2CJvmHw _4xdlr0DIqT"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: t1,
            children: children
        });
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : function LabelText({ children: children }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        className: (0, $hekY6.default)([
            "_1xC2CJvmHw _4xdlr0DIqT"
        ]),
        children: children
    });
};
var $4870a5341200be20$export$2e2bcd8739ae039 = $4870a5341200be20$var$LabelText;
module.exports["default"] = $4870a5341200be20$export$2e2bcd8739ae039;

});

parcelRegister("kbRVk", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $126a273b3177dba3$var$requiredIndicatorStyles = null;
const $126a273b3177dba3$var$RequiredIndicator = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RequiredIndicator() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "aria-hidden": true,
            className: (0, $hekY6.default)([
                "_1UtDYzAyGJ _0LQT5EFQfX"
            ]),
            children: "*"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function RequiredIndicator() {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "aria-hidden": true,
        className: (0, $hekY6.default)([
            "_1UtDYzAyGJ _0LQT5EFQfX"
        ]),
        children: "*"
    });
};
var $126a273b3177dba3$export$2e2bcd8739ae039 = $126a273b3177dba3$var$RequiredIndicator;
module.exports["default"] = $126a273b3177dba3$export$2e2bcd8739ae039;

});

parcelRegister("eicAg", function(module, exports) {
/* HeaderCell.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $fodiz = parcelRequire("fodiz");


var $lpNn5 = parcelRequire("lpNn5");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $7ZB0A = parcelRequire("7ZB0A");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1734009c6c243aaa$var$HeaderWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { center: center, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _37wbyuz9WS _42d1HAFQfX _2fwxA5DIqT _4ouGXIVa5s _0jFU0VIZbP",
            __cmplp.center ? "_0hPCNLDIqT" : "_0hPCNLchRC",
            __cmplp.className
        ])
    });
});
const $1734009c6c243aaa$var$GroupNameWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { setWidth: setWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgd8bj _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _4bt5LAYvD1 _1ANEUSLRg7 _4kiQYAe65H _2fwxA5DIqT _1UtDYzy7kJ",
            __cmplp.setWidth ? "_1EqgXlYbGa" : "_1EqgXlp0Oa",
            __cmplp.setWidth ? "_39xV023ScF" : "_39xV02IZbP",
            __cmplp.className
        ])
    });
});
const $1734009c6c243aaa$var$largeGroupNameStyle = (0, $buxP3.xcss)({
    whiteSpace: 'normal',
    wordBreak: 'keep-all'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1734009c6c243aaa$var$ColumnNameWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _3iDTPbQ4SZ _1ANEUSLRg7 _1UtDYzZpcK _4xdlr0DIqT",
            __cmplp.className
        ])
    });
});
const $1734009c6c243aaa$var$IconWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDS5Zs _0jFU0VOFcS _1RrJLit2nV _1iJnp6OFcS _2FH9z4OFcS _1eOmH6Vva3 _1DbipI2kP3",
            __cmplp.className
        ])
    });
});
const $1734009c6c243aaa$export$efcbfab786023e1a = ({ groupName: groupName, columnName: columnName, showGroupName: showGroupName = false, testKey: testKey, tooltipContent: tooltipContent, tooltipIconLabel: tooltipIconLabel, centerGroupName: centerGroupName = false, setMaxWidth: setMaxWidth = false, setWidth: setWidth = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1734009c6c243aaa$var$HeaderWrapper, {
        center: centerGroupName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1734009c6c243aaa$var$GroupNameWrapper, {
        "data-testid": testKey ? `space-table-header-${testKey}` : undefined,
        "aria-label": `${groupName}`,
        setMaxWidth: setMaxWidth,
        setWidth: setWidth
    }, showGroupName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: [
            setWidth ? $1734009c6c243aaa$var$largeGroupNameStyle : false
        ]
    }, groupName) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        "aria-label": `${groupName}`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1734009c6c243aaa$var$ColumnNameWrapper, {
        key: groupName + columnName,
        "aria-label": `${columnName}`
    }, columnName, tooltipContent && tooltipIconLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), tooltipContent)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1734009c6c243aaa$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            ...tooltipProps,
            appearance: "subtle-link",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
                label: formatMessage(tooltipIconLabel),
                color: "var(--ds-icon, #292A2E)",
                size: "small"
            })
        })))));
};
module.exports["HeaderCell"] = $1734009c6c243aaa$export$efcbfab786023e1a;

});

parcelRegister("jhwJP", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $8e78cdefc122a0a9$export$d1326a8d9df930b6 = (i18nBase, i18nLiveDocs)=>{
    const initializeData = (targetObj)=>{
        targetObj._data = (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? {
            ...i18nBase,
            ...i18nLiveDocs
        } : i18nBase;
        targetObj._initialized = true;
    };
    return new Proxy({}, {
        get: (targetObj, prop)=>{
            // Ensures retrieval of properties on i18n object use i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return targetObj._data[prop];
        },
        ownKeys: (targetObj)=>{
            // ensures `.keys` uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return Reflect.ownKeys(targetObj._data);
        },
        has: (targetObj, prop)=>{
            // Ensures for...in uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return prop in targetObj._data;
        },
        getOwnPropertyDescriptor: (targetObj, prop)=>{
            // Ensures i18n props are enumerable, required for ownKeys/etc to work
            if (!targetObj._initialized) initializeData(targetObj);
            const descriptor = Object.getOwnPropertyDescriptor(targetObj._data, prop);
            return descriptor ? {
                ...descriptor,
                enumerable: true
            } : undefined;
        }
    });
};
module.exports["mergeLiveDocI18n"] = $8e78cdefc122a0a9$export$d1326a8d9df930b6;

});

parcelRegister("auKqk", function(module, exports) {
/* ErrorPageComponent.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $ad7Ou = parcelRequire("ad7Ou");


var $eKMV3 = parcelRequire("eKMV3");


var $buxP3 = parcelRequire("buxP3");


var $3izAL = parcelRequire("3izAL");


var $hhzGx = parcelRequire("hhzGx");


var $iNQQp = parcelRequire("iNQQp");

const $ae2504483138c997$var$ErrorContainerStyles = null;
const $ae2504483138c997$var$ErrorContainerMobileStyles = null;
const $ae2504483138c997$var$ErrorContainer = ({ isMobile: isMobile, isCenteredLayout: isCenteredLayout, resizeContainerRef: resizeContainerRef, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: resizeContainerRef,
        "data-vc": "not-found-container",
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _0hPCNLDIqT _0KLXrulfZc _0jFU0V3DHH _1EqgXlqUim",
            isMobile && "_0jFU0VWP8C",
            isCenteredLayout && "_2Y7lL4NHnM _4c065US40j _4kiQYA3DHH _0jFU0VIZbP _24h04i2Njc"
        ])
    }, children);
};
const $ae2504483138c997$var$ErrorPageWrapperStyles = null;
const $ae2504483138c997$var$ErrorPageWrapperMobileStyles = null;
const $ae2504483138c997$var$ErrorPageWrapper = ({ isMobile: isMobile, isCenteredLayout: isCenteredLayout, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuDIqT _1EqgXlELL6 _0aFT5v1qpb",
            isMobile && "_0aFT5vbt8w",
            isCenteredLayout && "_2mHwu8NHnM _0aFT5vbt8w _0hPCNLDIqT _39xV02N91d _1EqgXlfqQP"
        ])
    }, children);
};
const $ae2504483138c997$var$AlignContentStyles = null;
const $ae2504483138c997$var$AlignContentMobileStyles = null;
const $ae2504483138c997$var$AlignContent = ({ isMobile: isMobile, isCenteredLayout: isCenteredLayout, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2XghbEkG2W _4xdlr0DIqT _2fwxA5ecOK",
            isMobile && "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2fwxA5DIqT",
            isCenteredLayout && "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2fwxA5DIqT _39xV02N91d"
        ])
    }, children);
};
const $ae2504483138c997$var$ErrorTitleStyles = null;
const $ae2504483138c997$var$ErrorTitleMobileStyles = null;
const $ae2504483138c997$var$ErrorTitle = ({ isMobile: isMobile, isCenteredLayout: isCenteredLayout, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("h1", {
        className: (0, $hekY6.default)([
            "_2XghbEdVAt _2sNsIgJ6H4 _1kk5Tku7m9 _39xV028WQH _1UtDYzy7kJ",
            isMobile && "_2sNsIgXwEm _39xV02Axt1",
            isCenteredLayout && "_2XghbEpjyN _2sNsIgJ6H4 _1kk5Tkmb2E _1UtDYzy7kJ _2fwxA5DIqT _39xV02N91d",
            isCenteredLayout && isMobile && "_2sNsIgJ6H4 _1kk5Tkmb2E _39xV02N91d"
        ])
    }, children);
};
const $ae2504483138c997$var$ErrorMessageStyles = null;
const $ae2504483138c997$var$ErrorMessageMobileStyles = null;
const $ae2504483138c997$var$ErrorMessage = ({ isMobile: isMobile, isCenteredLayout: isCenteredLayout, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _313842ZqHV _0adFHsZqHV _1DCdHiZqHV _2XsHFMZqHV _1kk5Tku7m9 _1UtDYzy7kJ _1EqgXlcTmy",
            isMobile && "_2sNsIg20Hp _313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _1EqgXlAxt1",
            isCenteredLayout && "_2sNsIg20Hp _313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _1kk5Tku7m9 _3C14nsjBF4 _1UtDYzy7kJ _2fwxA5DIqT _1EqgXlfqQP",
            isMobile && isCenteredLayout && "_1EqgXlfqQP"
        ])
    }, children);
};
const $ae2504483138c997$var$ButtonContainerStyles = null;
const $ae2504483138c997$var$ButtonContainerMobileStyles = null;
const $ae2504483138c997$var$ButtonContainer = ({ isMobile: isMobile, isCenteredLayout: isCenteredLayout, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuecOK",
            isMobile && "_37wbyuDIqT",
            isCenteredLayout && "_2mHwu85zaO _37wbyuDIqT _3TGfC9HnLE"
        ])
    }, children);
};
const $ae2504483138c997$var$primaryButtonStyles = (0, $buxP3.xcss)({
    cursor: 'pointer',
    marginTop: 'space.250'
});
const $ae2504483138c997$var$mobilePrimaryButtonStyles = (0, $buxP3.xcss)({
    cursor: 'pointer',
    marginTop: 'space.200'
});
const $ae2504483138c997$var$secondaryButtonStyles = (0, $buxP3.xcss)({
    cursor: 'pointer',
    marginTop: 'space.250',
    marginLeft: 'space.200'
});
const $ae2504483138c997$var$mobileSecondaryButtonStyles = (0, $buxP3.xcss)({
    cursor: 'pointer',
    marginTop: 'space.200',
    marginLeft: 'space.100'
});
const $ae2504483138c997$var$childrenStyles = (0, $buxP3.xcss)({
    // @ts-ignore TODO: refactor to remove need for hardcoded `-90px`
    marginTop: '-90px',
    marginInline: 'space.250',
    marginBottom: 'space.250',
    maxWidth: '700px'
});
const $ae2504483138c997$var$mobileChildrenStyles = (0, $buxP3.xcss)({
    // @ts-ignore TODO: refactor to remove need for hardcoded `-74px`
    marginTop: '-74px',
    marginInline: 'space.250',
    marginBottom: 'space.250',
    maxWidth: '700px'
});
const $ae2504483138c997$var$centeredErrorContainerStyles = null;
const $ae2504483138c997$var$centeredErrorPageWrapperStyles = null;
const $ae2504483138c997$var$centeredAlignContentStyles = null;
const $ae2504483138c997$var$centeredErrorTitleStyles = null;
const $ae2504483138c997$var$centeredErrorTitleMobileStyles = null;
const $ae2504483138c997$var$centeredErrorMessageStyles = null;
const $ae2504483138c997$var$centeredErrorMessageMobileStyles = null;
const $ae2504483138c997$var$centeredButtonContainerStyles = null;
const $ae2504483138c997$var$centeredButtonStyles = (0, $buxP3.xcss)({
    marginTop: 'space.300'
});
const $ae2504483138c997$var$centeredChildrenStyles = (0, $buxP3.xcss)({
    marginTop: 'space.500',
    marginInline: 'space.250',
    marginBottom: 'space.250',
    maxWidth: '640px',
    width: '100%'
});
const $ae2504483138c997$var$centeredChildrenMobileStyles = (0, $buxP3.xcss)({
    marginTop: 'space.400',
    marginInline: 'space.250',
    marginBottom: 'space.250',
    maxWidth: '640px',
    width: '100%'
});
const $ae2504483138c997$var$ErrorPageChildren = ({ isMobile: isMobile, isCenteredLayout: isCenteredLayout, children: children })=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children)) return null;
    if (isCenteredLayout) {
        if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $ae2504483138c997$var$centeredChildrenMobileStyles
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $ae2504483138c997$var$centeredChildrenStyles
        }, children);
    }
    if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $ae2504483138c997$var$mobileChildrenStyles
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $ae2504483138c997$var$childrenStyles
    }, children);
};
const $ae2504483138c997$export$8350f8038f1a598b = ({ errorImage: errorImage, errorImageDark: errorImageDark, errorTitle: errorTitle, errorMessage: errorMessage, primaryButtonProps: primaryButtonProps, secondaryButtonProps: secondaryButtonProps, primaryButtonWrapper: primaryButtonWrapper, secondaryButtonWrapper: secondaryButtonWrapper, children: children, layout: layout = 'default' })=>{
    const { resizeContainerRef: resizeContainerRef, shouldUseMobileLayout: shouldUseMobileLayout } = (0, $iNQQp.useErrorPageMobileLayout)();
    const isMobile = shouldUseMobileLayout; // CCCEMAU-2938: keep the centered layout added for Mohiti as an explicit opt-in so
    // legacy error pages continue using the existing shared layout until each consumer is
    // intentionally migrated.
    const isCenteredLayout = layout === 'centered';
    const renderPrimaryButton = ()=>{
        if (!primaryButtonProps?.children) return null;
        const button = 'href' in primaryButtonProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
            appearance: "primary",
            ...primaryButtonProps
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            ...primaryButtonProps
        });
        const wrappedButton = primaryButtonWrapper ? primaryButtonWrapper(button) : button;
        if (isCenteredLayout && !isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $ae2504483138c997$var$centeredButtonStyles
        }, wrappedButton);
        if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $ae2504483138c997$var$mobilePrimaryButtonStyles
        }, wrappedButton);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $ae2504483138c997$var$primaryButtonStyles
        }, wrappedButton);
    };
    const renderSecondaryButton = ()=>{
        if (!secondaryButtonProps?.children) return null;
        const button = 'href' in secondaryButtonProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
            appearance: "default",
            ...secondaryButtonProps
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "default",
            ...secondaryButtonProps
        });
        const wrappedButton = secondaryButtonWrapper ? secondaryButtonWrapper(button) : button;
        if (isCenteredLayout && !isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $ae2504483138c997$var$centeredButtonStyles
        }, wrappedButton);
        if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $ae2504483138c997$var$mobileSecondaryButtonStyles
        }, wrappedButton);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $ae2504483138c997$var$secondaryButtonStyles
        }, wrappedButton);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2504483138c997$var$ErrorContainer, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout,
        resizeContainerRef: resizeContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2504483138c997$var$ErrorPageWrapper, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2504483138c997$var$AlignContent, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    }, errorImage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hhzGx.ErrorPageImage), {
        src: errorImage,
        srcDark: errorImageDark,
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2504483138c997$var$AlignContent, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2504483138c997$var$ErrorTitle, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    }, errorTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2504483138c997$var$ErrorMessage, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    }, errorMessage), (primaryButtonProps?.children || secondaryButtonProps?.children) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2504483138c997$var$ButtonContainer, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    }, renderPrimaryButton(), renderSecondaryButton()))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2504483138c997$var$ErrorPageChildren, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    }, children));
};
module.exports["ErrorPageComponent"] = $ae2504483138c997$export$8350f8038f1a598b;

});

parcelRegister("hhzGx", function(module, exports) {
/* ErrorPageImage.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $cJ0FD = parcelRequire("cJ0FD");

const $c32ae4d4c06d56af$var$imageStylesMobile = null;
const $c32ae4d4c06d56af$var$imageStylesDesktop = null;
const $c32ae4d4c06d56af$var$centeredImageStyles = null;
const $c32ae4d4c06d56af$var$imageStyles = null;
function $c32ae4d4c06d56af$export$9afbc24a6b683cb2({ src: src, srcDark: srcDark, isMobile: isMobile, isCenteredLayout: isCenteredLayout }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        alt: "",
        src: src,
        srcDark: srcDark || src,
        className: (0, $hekY6.default)([
            isCenteredLayout && "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _3iDTPbvLZJ _39xV02NGHM _1EqgXlTTQh",
            !isCenteredLayout && isMobile && "_39xV02lIjS",
            !isCenteredLayout && !isMobile && "_39xV02ZqHV",
            !isCenteredLayout && "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _1EqgXlS2te"
        ])
    });
}
module.exports["ErrorPageImage"] = $c32ae4d4c06d56af$export$9afbc24a6b683cb2;

});

parcelRegister("iNQQp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8dwdz = parcelRequire("8dwdz");

const $5359ea5c70f1dd78$export$78b0da9378bc7a2d = ()=>{
    const MOBILE_BREAKPOINT = 700;
    const [isContainerNarrow, setIsContainerNarrow] = (0, $cozmU.useState)(false);
    const lastIsNarrowRef = (0, $cozmU.useRef)(null);
    const resizeObserverRef = (0, $cozmU.useRef)(null);
    const handleResize = ([entry])=>{
        const nextIsNarrow = entry.contentRect.width < MOBILE_BREAKPOINT;
        if (lastIsNarrowRef.current !== nextIsNarrow) {
            lastIsNarrowRef.current = nextIsNarrow;
            setIsContainerNarrow(nextIsNarrow);
        }
    };
    const resizeContainerRef = (element)=>{
        // Clean up previous observer
        if (resizeObserverRef.current) {
            resizeObserverRef.current.disconnect();
            resizeObserverRef.current = null;
        }
        // Set up new observer if element exists
        if (element) {
            const resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(element);
            resizeObserverRef.current = resizeObserver;
        }
    };
    // Combine existing mobile detection with container width detection
    const shouldUseMobileLayout = isContainerNarrow || (0, $8dwdz.shouldShowMobileWeb)();
    return {
        resizeContainerRef: resizeContainerRef,
        shouldUseMobileLayout: shouldUseMobileLayout
    };
};
module.exports["useErrorPageMobileLayout"] = $5359ea5c70f1dd78$export$78b0da9378bc7a2d;

});

parcelRegister("ig7dg", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $116c5e27ebbb6682$var$MIN_VALUE = 0;
const $116c5e27ebbb6682$var$MAX_VALUE = 1;
const $116c5e27ebbb6682$var$increasingBarAnimation = null;
const $116c5e27ebbb6682$var$decreasingBarAnimation = null;
const $116c5e27ebbb6682$var$containerStyles = null;
const $116c5e27ebbb6682$var$containerAppearance = {
    default: "_0KLXruDMqu",
    success: "_0KLXruDMqu",
    inverse: "_0KLXruB4sa"
};
const $116c5e27ebbb6682$var$barAppearance = {
    default: "_0KLXrugozt",
    success: "_0KLXruhbjP",
    inverse: "_0KLXrulfZc"
};
const $116c5e27ebbb6682$var$barStyles = null;
const $116c5e27ebbb6682$var$determinateBarStyles = null;
const $116c5e27ebbb6682$var$increasingBarStyles = null;
const $116c5e27ebbb6682$var$decreasingBarStyles = null; /**
                                   * __Progress bar__
                                   *
                                   * A progress bar displays the status of a given process.
                                   *
                                   * - [Examples](https://atlassian.design/components/progress-bar/examples)
                                   * - [Code](https://atlassian.design/components/progress-bar/code)
                                   * - [Usage](https://atlassian.design/components/progress-bar/usage)
                                   */ 
const $116c5e27ebbb6682$var$ProgressBar = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { appearance: t1, ariaLabel: ariaLabel, isIndeterminate: t2, testId: t3, value: t4 } = t0;
    const appearance = t1 === undefined ? "default" : t1;
    const isIndeterminate = t2 === undefined ? false : t2;
    const testId = t3 === undefined ? "progress-bar" : t3;
    const value = t4 === undefined ? 0 : t4;
    const valueParsed = isIndeterminate ? $116c5e27ebbb6682$var$MIN_VALUE : Math.max($116c5e27ebbb6682$var$MIN_VALUE, Math.min(value, $116c5e27ebbb6682$var$MAX_VALUE));
    const t5 = $116c5e27ebbb6682$var$containerAppearance[appearance];
    let t6;
    if ($[0] !== t5) {
        t6 = (0, $hekY6.default)([
            "_0bjKvDS5Zs _4bt5LAnQyn _2WAcuGnQyn _39xV02N91d _0jFU0VZimw _1mT5xdRAKS _0KLXruDMqu",
            t5
        ]);
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    let t7;
    if ($[2] !== appearance || $[3] !== isIndeterminate || $[4] !== value) {
        t7 = isIndeterminate ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    className: (0, $hekY6.default)([
                        "_0bjKvDS5Zs _3iDTPbvLZJ _0jFU0VZimw _1mT5xdWVPG",
                        $116c5e27ebbb6682$var$barAppearance[appearance],
                        "_0nFVCGFSlo _03m2nySHWH _1gBibytvPq"
                    ])
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    className: (0, $hekY6.default)([
                        "_0bjKvDS5Zs _3iDTPbvLZJ _0jFU0VZimw _1mT5xdWVPG",
                        $116c5e27ebbb6682$var$barAppearance[appearance],
                        "_1jakNnwiJJ _0nFVCGFSlo _03m2nySHWH _1gBibyo5Iu"
                    ])
                })
            ]
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            style: {
                width: `${Number(value) * 100}%`
            },
            className: (0, $hekY6.default)([
                "_0bjKvDS5Zs _3iDTPbvLZJ _0jFU0VZimw _1mT5xdWVPG",
                $116c5e27ebbb6682$var$barAppearance[appearance],
                "_23rrnHjh6t"
            ])
        });
        $[2] = appearance;
        $[3] = isIndeterminate;
        $[4] = value;
        $[5] = t7;
    } else t7 = $[5];
    let t8;
    if ($[6] !== ariaLabel || $[7] !== t6 || $[8] !== t7 || $[9] !== testId || $[10] !== valueParsed) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            role: "progressbar",
            "aria-label": ariaLabel,
            "aria-valuemin": $116c5e27ebbb6682$var$MIN_VALUE,
            "aria-valuenow": valueParsed,
            "aria-valuemax": $116c5e27ebbb6682$var$MAX_VALUE,
            "data-testid": testId,
            className: t6,
            children: t7
        });
        $[6] = ariaLabel;
        $[7] = t6;
        $[8] = t7;
        $[9] = testId;
        $[10] = valueParsed;
        $[11] = t8;
    } else t8 = $[11];
    return t8;
} : ({ appearance: appearance = 'default', ariaLabel: ariaLabel, isIndeterminate: isIndeterminate = false, testId: testId = 'progress-bar', value: value = 0 })=>{
    const valueParsed = isIndeterminate ? $116c5e27ebbb6682$var$MIN_VALUE : Math.max($116c5e27ebbb6682$var$MIN_VALUE, Math.min(value, $116c5e27ebbb6682$var$MAX_VALUE));
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": $116c5e27ebbb6682$var$MIN_VALUE,
        "aria-valuenow": valueParsed,
        "aria-valuemax": $116c5e27ebbb6682$var$MAX_VALUE,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_0bjKvDS5Zs _4bt5LAnQyn _2WAcuGnQyn _39xV02N91d _0jFU0VZimw _1mT5xdRAKS _0KLXruDMqu",
            $116c5e27ebbb6682$var$containerAppearance[appearance]
        ]),
        children: isIndeterminate ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    className: (0, $hekY6.default)([
                        "_0bjKvDS5Zs _3iDTPbvLZJ _0jFU0VZimw _1mT5xdWVPG",
                        $116c5e27ebbb6682$var$barAppearance[appearance],
                        "_0nFVCGFSlo _03m2nySHWH _1gBibytvPq"
                    ])
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    className: (0, $hekY6.default)([
                        "_0bjKvDS5Zs _3iDTPbvLZJ _0jFU0VZimw _1mT5xdWVPG",
                        $116c5e27ebbb6682$var$barAppearance[appearance],
                        "_1jakNnwiJJ _0nFVCGFSlo _03m2nySHWH _1gBibyo5Iu"
                    ])
                })
            ]
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            style: {
                width: `${Number(value) * 100}%`
            },
            className: (0, $hekY6.default)([
                "_0bjKvDS5Zs _3iDTPbvLZJ _0jFU0VZimw _1mT5xdWVPG",
                $116c5e27ebbb6682$var$barAppearance[appearance],
                "_23rrnHjh6t"
            ])
        })
    });
};
var $116c5e27ebbb6682$export$2e2bcd8739ae039 = $116c5e27ebbb6682$var$ProgressBar;
module.exports["default"] = $116c5e27ebbb6682$export$2e2bcd8739ae039;

});

parcelRegister("2ZJmt", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $caa92877b3f564cd$export$e2ddff3a4a4594f0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "gjoA6",
    name: "NavigationLockout",
    loader: async ()=>(await (parcelRequire("ki0qk"))).NavigationLockout
});
module.exports["NavigationLockout"] = $caa92877b3f564cd$export$e2ddff3a4a4594f0;

});

parcelRegister("ki0qk", function(module, exports) {

let $ec55d139e213cdf9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ec55d139e213cdf9$var$load("hwiu3").then(()=>parcelRequire('jUOfU'));

});

parcelRegister("kAGh9", function(module, exports) {
/* BulkAccessManagementPage.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iW7aI = parcelRequire("iW7aI");


var $ad7Ou = parcelRequire("ad7Ou");


var $eKMV3 = parcelRequire("eKMV3");


var $9DHhW = parcelRequire("9DHhW");


var $I7hWB = parcelRequire("I7hWB");


var $3izAL = parcelRequire("3izAL");


var $kz1Yj = parcelRequire("kz1Yj");


var $buxP3 = parcelRequire("buxP3");


var $49jU7 = parcelRequire("49jU7");


var $6mKj3 = parcelRequire("6mKj3");


var $1BYn9 = parcelRequire("1BYn9");


var $g3p2i = parcelRequire("g3p2i");


var $hpRYU = parcelRequire("hpRYU");


var $euL71 = parcelRequire("euL71");


var $1NBp8 = parcelRequire("1NBp8");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $7aRa9 = parcelRequire("7aRa9");


var $c6lYi = parcelRequire("c6lYi");


var $6sX6R = parcelRequire("6sX6R");

var $bYvQP = parcelRequire("bYvQP");

parcelRequire("cp4jg");
var $9phVF = parcelRequire("9phVF");


var $bQm3c = parcelRequire("bQm3c");


var $8A6YM = parcelRequire("8A6YM");














var $4ikjJ = parcelRequire("4ikjJ");

const $8799edea050578d8$var$i18n = (0, $kSwu1.defineMessages)({
    actionSelectionHeader: {
        id: "bulk-permissions.space.action-selection-header",
        defaultMessage: "Action to perform<asterisk>*</asterisk>"
    },
    actionSelectionAdd: {
        id: "bulk-permissions.space.action-selection-add",
        defaultMessage: "Add or change access"
    },
    actionSelectionRemove: {
        id: "bulk-permissions.space.action-selection-remove",
        defaultMessage: "Remove access"
    }
});
var $8799edea050578d8$export$19d9f94347fa723d = /*#__PURE__*/ function(ActionSelection) {
    ActionSelection["AddOrChangeAccess"] = "add-or-change-access";
    ActionSelection["RemoveAccess"] = "remove-access";
    return ActionSelection;
}({});
const $8799edea050578d8$var$actionSelectionHeaderStyle = (0, $buxP3.xcss)({
    font: 'font.body.large',
    fontWeight: 'font.weight.medium',
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 'space.300',
    paddingBottom: 'space.100'
});
const $8799edea050578d8$var$asteriskStyle = (0, $buxP3.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
    color: 'color.text.accent.red'
});
const $8799edea050578d8$export$321778e99f9fd257 = ({ actionSelection: actionSelection, onRadioChange: onRadioChange, isDisabled: isDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $8799edea050578d8$var$actionSelectionHeaderStyle,
        testId: "action-selection-radio-buttons"
    }, formatMessage($8799edea050578d8$var$i18n.actionSelectionHeader, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $8799edea050578d8$var$asteriskStyle
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ikjJ.default), {
        value: "add-or-change-access",
        onChange: onRadioChange,
        isChecked: actionSelection === "add-or-change-access",
        isDisabled: isDisabled,
        name: "action-selection",
        label: formatMessage($8799edea050578d8$var$i18n.actionSelectionAdd)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ikjJ.default), {
        value: "remove-access",
        onChange: onRadioChange,
        isChecked: actionSelection === "remove-access",
        isDisabled: isDisabled,
        name: "action-selection",
        label: formatMessage($8799edea050578d8$var$i18n.actionSelectionRemove)
    })));
};


/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $2fd747c2df30bd9d$export$dc2a111abcc46324 = /*#__PURE__*/ function(BulkRoleAssignmentSpaceType) {
    BulkRoleAssignmentSpaceType["COLLABORATION"] = "COLLABORATION";
    BulkRoleAssignmentSpaceType["GLOBAL"] = "GLOBAL";
    BulkRoleAssignmentSpaceType["KNOWLEDGE_BASE"] = "KNOWLEDGE_BASE";
    BulkRoleAssignmentSpaceType["PERSONAL"] = "PERSONAL";
    return BulkRoleAssignmentSpaceType;
}({});
var $2fd747c2df30bd9d$export$4e2d5448f3fd8728 = /*#__PURE__*/ function(RoleAssignmentPrincipalType) {
    RoleAssignmentPrincipalType["ACCESS_CLASS"] = "ACCESS_CLASS";
    RoleAssignmentPrincipalType["GROUP"] = "GROUP";
    RoleAssignmentPrincipalType["TEAM"] = "TEAM";
    RoleAssignmentPrincipalType["USER"] = "USER";
    return RoleAssignmentPrincipalType;
}({});


/**
 * @generated SignedSource<<20a9c4df2f36d65a8ff761b6589d70b2>>
 * @relayHash bd7c883ca62fec8638ba84ea336b2321
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 949dc2fd39019cf39ada8cacca907201f62bbe585e7daaae9c36adfb838b5f6d
const $60adf85299dca4dd$var$node = function() {
    var v0 = [
        {
            "concreteType": "SpaceRoleConnection",
            "kind": "LinkedField",
            "name": "spaceRolesByCriteria",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SpaceRole",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "roleId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "roleDisplayName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "roleDescription"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "roleType"
                        },
                        {
                            "concreteType": "SpacePermissionInfo",
                            "kind": "LinkedField",
                            "name": "spacePermissionList",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "priority"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayName"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "requiredSpacePermissions"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "RoleSelectionSectionRolesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "RoleSelectionSectionRolesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "bd7c883ca62fec8638ba84ea336b2321",
            "id": "949dc2fd39019cf39ada8cacca907201f62bbe585e7daaae9c36adfb838b5f6d",
            "metadata": {},
            "name": "RoleSelectionSectionRolesQuery",
            "operationKind": "query",
            "text": "query RoleSelectionSectionRolesQuery{spaceRolesByCriteria{nodes{roleId,roleDisplayName,roleDescription,roleType,spacePermissionList{id,priority,displayName,description,requiredSpacePermissions}}}}"
        }
    };
}();
$60adf85299dca4dd$var$node.hash = "cc445348302affe2962240cd1154aad8";
var $60adf85299dca4dd$export$2e2bcd8739ae039 = $60adf85299dca4dd$var$node;















var $6Pqow = parcelRequire("6Pqow");


var $kB5K2 = parcelRequire("kB5K2");


var $1kHsc = parcelRequire("1kHsc");


var $ku6MO = parcelRequire("ku6MO");


var $3EH2D = parcelRequire("3EH2D");


var $jMyy4 = parcelRequire("jMyy4");








var $iMnC5 = parcelRequire("iMnC5");


var $9rnOu = parcelRequire("9rnOu");


var $g26MG = parcelRequire("g26MG");

/**
 * @generated SignedSource<<1f74a5836cf333e34a3b589bcb62cb6c>>
 * @relayHash fe5341c7119ce6b48784ed36451a3ad5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 92726285efdd6e37384c9e6e8ed615f4bed51619568bbfa43f845a7fbf98b969
const $1476e0968a56b5c7$var$node = function() {
    var v0 = [
        {
            "concreteType": "SpaceRoleConnection",
            "kind": "LinkedField",
            "name": "spaceRolesByCriteria",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SpaceRole",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "roleId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "roleDisplayName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "roleDescription"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "roleType"
                        },
                        {
                            "concreteType": "SpacePermissionInfo",
                            "kind": "LinkedField",
                            "name": "spacePermissionList",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "priority"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayName"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hubDisplayName"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hubDescription"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "requiredSpacePermissions"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "SpaceRolePageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useViewPermissionsModalRolesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useViewPermissionsModalRolesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "fe5341c7119ce6b48784ed36451a3ad5",
            "id": "92726285efdd6e37384c9e6e8ed615f4bed51619568bbfa43f845a7fbf98b969",
            "metadata": {},
            "name": "useViewPermissionsModalRolesQuery",
            "operationKind": "query",
            "text": "query useViewPermissionsModalRolesQuery{spaceRolesByCriteria{nodes{roleId,roleDisplayName,roleDescription,roleType,spacePermissionList{id,priority,displayName,description,hubDisplayName,hubDescription,requiredSpacePermissions}},pageInfo{endCursor,hasNextPage}}}"
        }
    };
}();
$1476e0968a56b5c7$var$node.hash = "0d3baeae35295e4523feb5527dc2a3d3";
var $1476e0968a56b5c7$export$2e2bcd8739ae039 = $1476e0968a56b5c7$var$node;


/**
 * @generated SignedSource<<ab690981298f6411b3f046f43a909dd6>>
 * @relayHash 647398da5f046eab487178776f59ec6d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 29ca9ec3b6d7be7170e2da0e8662dc06bfdaf4762282d10e71dbefcbed8ec3ee
const $b4360d56b570d73b$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v1 = {
        "kind": "ScalarField",
        "name": "priority"
    }, v2 = [
        {
            "concreteType": "SpacePermissionConnection",
            "kind": "LinkedField",
            "name": "spacePermissionsAll",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SpacePermissionInfo",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        v0 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "description"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hubDisplayName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hubDescription"
                        },
                        v1 /*: any*/ ,
                        {
                            "concreteType": "SpacePermissionGroup",
                            "kind": "LinkedField",
                            "name": "group",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                v1 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "requiredSpacePermissions"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useViewPermissionsModalPermissionsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useViewPermissionsModalPermissionsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "647398da5f046eab487178776f59ec6d",
            "id": "29ca9ec3b6d7be7170e2da0e8662dc06bfdaf4762282d10e71dbefcbed8ec3ee",
            "metadata": {},
            "name": "useViewPermissionsModalPermissionsQuery",
            "operationKind": "query",
            "text": "query useViewPermissionsModalPermissionsQuery{spacePermissionsAll{nodes{id,displayName,description,hubDisplayName,hubDescription,priority,group{displayName,priority},requiredSpacePermissions}}}"
        }
    };
}();
$b4360d56b570d73b$var$node.hash = "e4a3c349162ebabf09288d398062a645";
var $b4360d56b570d73b$export$2e2bcd8739ae039 = $b4360d56b570d73b$var$node;






var $irVI7 = parcelRequire("irVI7");










const $5b8a2a030512dd5e$var$ENFORCE_DSP_LEARN_MORE_LINK = 'https://support.atlassian.com/security-and-access-policies/docs/what-is-a-data-security-policy/';
const $5b8a2a030512dd5e$var$i18n = (0, $kSwu1.defineMessages)({
    errorIconLabel: {
        id: "bulk-permissions.flag-message.error-icon-label",
        defaultMessage: "Error"
    },
    processingFlagTitle: {
        id: "bulk-permissions.flag-message.processing",
        defaultMessage: "Bulk change processing"
    },
    processingFlagContent: {
        id: "bulk-permissions.flag-message.processing-content",
        defaultMessage: "This can take a while. We\u2019ll notify you by email when it\u2019s finished."
    },
    errorFlagTitle: {
        id: "bulk-permissions.flag-message.error",
        defaultMessage: "Bulk access change failed"
    },
    errorFlagContent: {
        id: "bulk-permissions.flag-message.error-content",
        defaultMessage: "We ran into a problem completing your bulk access change. Try again."
    },
    warningTitle: {
        id: "bulk-permissions.flag-message.warning-title",
        defaultMessage: "Policy prohibits external sharing"
    },
    warningMessage: {
        id: "bulk-permissions.flag-message.warning-message",
        defaultMessage: "Even if a role includes permission to enable anonymous access or public links, your organization's security policy will prevent it."
    },
    learnMore: {
        id: "bulk-permissions.flag-messagelearn-more",
        defaultMessage: "Learn about policies"
    }
});
const $5b8a2a030512dd5e$export$4b081a83cd5f1b6f = ({ flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const showErrorFlag = ()=>flags.showErrorFlag({
            id: `error-${Date.now()}`,
            title: formatMessage($5b8a2a030512dd5e$var$i18n.errorFlagTitle),
            description: formatMessage($5b8a2a030512dd5e$var$i18n.errorFlagContent),
            isAutoDismiss: true
        });
    const showProcessingFlag = ()=>flags.showInfoFlag({
            id: `processing-${Date.now()}`,
            title: formatMessage($5b8a2a030512dd5e$var$i18n.processingFlagTitle),
            description: formatMessage($5b8a2a030512dd5e$var$i18n.processingFlagContent),
            isAutoDismiss: true
        });
    const showInfoFlag = ()=>flags.showInfoFlag({
            id: `processing-${Date.now()}`,
            title: formatMessage($5b8a2a030512dd5e$var$i18n.warningTitle),
            description: formatMessage($5b8a2a030512dd5e$var$i18n.warningMessage),
            actions: [
                {
                    content: formatMessage($5b8a2a030512dd5e$var$i18n.learnMore),
                    href: $5b8a2a030512dd5e$var$ENFORCE_DSP_LEARN_MORE_LINK
                }
            ],
            isAutoDismiss: true
        });
    return {
        showErrorFlag: showErrorFlag,
        showProcessingFlag: showProcessingFlag,
        showInfoFlag: showInfoFlag
    };
};


const $838f830302a4f6f5$var$useViewPermissionsModalPermissionsQuery = (0, $b4360d56b570d73b$export$2e2bcd8739ae039);
const $838f830302a4f6f5$var$useViewPermissionsModalRolesQuery = (0, $1476e0968a56b5c7$export$2e2bcd8739ae039);
const $838f830302a4f6f5$export$aec138b16dafcc0a = ({ flags: flags })=>{
    const [experienceStarted, setExperienceStarted] = (0, $cozmU.useState)(false);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { showErrorFlag: showErrorFlag } = (0, $5b8a2a030512dd5e$export$4b081a83cd5f1b6f)({
        flags: flags
    });
    const fail = (error)=>{
        const experienceFailure = error || new Error('An error occurred');
        experienceTracker.fail({
            name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE),
            error: experienceFailure
        });
        showErrorFlag();
    };
    const { data: permissionsData, loading: loading } = (0, $jMyy4.useQueryInterop)($838f830302a4f6f5$var$useViewPermissionsModalPermissionsQuery, {
        onCompleted: ()=>{
            setExperienceStarted(false);
            experienceTracker.succeed({
                name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE)
            });
        },
        onError: (error)=>{
            setExperienceStarted(false);
            fail(error);
        },
        __callerPackage__: "bulk-permissions"
    });
    const { data: rolesData, loading: rolesLoading } = (0, $jMyy4.useQueryInterop)($838f830302a4f6f5$var$useViewPermissionsModalRolesQuery, {
        onCompleted: ()=>{
            setExperienceStarted(false);
            experienceTracker.succeed({
                name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE)
            });
        },
        onError: (error)=>{
            setExperienceStarted(false);
            fail(error);
        },
        __callerPackage__: "bulk-permissions"
    });
    (0, $cozmU.useEffect)(()=>{
        if (loading || rolesLoading && !experienceStarted) experienceTracker.start({
            name: (0, $irVI7.BULK_SPACE_PERMISSIONS_EXPERIENCE)
        });
    }, [
        loading,
        rolesLoading,
        experienceStarted,
        experienceTracker
    ]);
    return {
        loading: loading,
        permissions: permissionsData?.spacePermissionsAll?.nodes || [],
        roles: rolesData?.spaceRolesByCriteria?.nodes || []
    };
};









var $fodiz = parcelRequire("fodiz");





var $lsxnT = parcelRequire("lsxnT");

const $710ea738a38b5734$export$1a3c335d7dca645d = ({ content: content, isOpen: isOpen, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Popup, {
        isOpen: isOpen,
        content: ()=>content,
        placement: "bottom",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ...triggerProps,
                appearance: "subtle",
                "aria-haspopup": true,
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($fodiz))),
                onClick: onClick,
                "aria-label": formatMessage({
                    id: "bulk-access.role-select.info-popup",
                    defaultMessage: "View info"
                })
            }, null),
        shouldRenderToParent: true
    }));
};












var $2wCqQ = parcelRequire("2wCqQ");
















const $5e889a2aa3054314$var$i18n = (0, $kSwu1.defineMessages)({
    viewRolePermissionsLabel: {
        id: "bulk-permissions.info-popup.view-role-permissions-label",
        defaultMessage: "View role permissions"
    }
});
const $5e889a2aa3054314$var$contentStyle = (0, $buxP3.xcss)({
    width: '315px',
    padding: 'space.300'
});
const $5e889a2aa3054314$var$headerStyle = (0, $buxP3.xcss)({
    marginBottom: 'space.100'
});
const $5e889a2aa3054314$var$buttonStyle = (0, $buxP3.xcss)({
    paddingTop: 'space.150',
    display: 'flex',
    alignItems: 'center'
});
const $5e889a2aa3054314$var$usePermissionsSummary = ({ roleId: roleId, roleLookup: roleLookup })=>{
    const role = roleLookup.find((lookup)=>lookup.id === roleId);
    // Role access
    return {
        heading: role?.name,
        description: role?.description
    };
};
const $5e889a2aa3054314$export$90dae7b611e581b7 = ({ onCtaClick: onCtaClick, roleId: roleId, roleLookup: roleLookup })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { heading: heading, description: description } = $5e889a2aa3054314$var$usePermissionsSummary({
        roleId: roleId,
        roleLookup: roleLookup
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        xcss: $5e889a2aa3054314$var$contentStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $5e889a2aa3054314$var$headerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), null, description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        xcss: $5e889a2aa3054314$var$buttonStyle
    }, roleId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: onCtaClick
    }, formatMessage($5e889a2aa3054314$var$i18n.viewRolePermissionsLabel)) : null)));
};


const $117ed3de9d2a23fd$export$5bafd35f9dc9151a = ({ analyticsSource: analyticsSource, currentRole: currentRole, roleLookup: roleLookup, flags: flags })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isPopupOpen, setIsPopupOpen] = (0, $cozmU.useState)(false);
    const [isViewPermissionsModalOpen, setIsViewPermissionsModalOpen] = (0, $cozmU.useState)(false);
    const { permissions: permissions, roles: roles } = (0, $838f830302a4f6f5$export$aec138b16dafcc0a)({
        flags: flags
    });
    const systemRoles = roles.filter((role)=>role?.roleType === 'SYSTEM');
    const customRoles = roles.filter((role)=>role?.roleType === 'CUSTOM');
    const onInfoButtonClick = (0, $cozmU.useCallback)(()=>{
        setIsPopupOpen(!isPopupOpen);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'role-select-info-button',
                source: analyticsSource,
                attributes: {
                    roleId: currentRole?.id
                }
            }
        }).fire();
    }, [
        isPopupOpen,
        currentRole?.id,
        analyticsSource,
        createAnalyticsEvent
    ]);
    const onPopupContentCtaClick = (0, $cozmU.useCallback)(()=>{
        setIsPopupOpen(false);
        setIsViewPermissionsModalOpen(true);
    }, []);
    const popupRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    (0, $cozmU.useEffect)(()=>{
        if (popupRef.current) {
            const handleClickOutside = (e)=>{
                if (popupRef.current && !popupRef.current.contains(e.target)) setIsPopupOpen(false);
            };
            document.addEventListener('click', handleClickOutside);
            return ()=>document.removeEventListener('click', handleClickOutside);
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isViewPermissionsModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9rnOu.ViewRolePermissionModal), {
        systemRoles: (0, $g26MG.normalizeSpaceRoleList)(systemRoles.filter((r)=>r !== null)),
        customRoles: (0, $g26MG.normalizeSpaceRoleList)(customRoles.filter((r)=>r !== null)),
        allPermissions: (0, $g26MG.normalizeSpacePermissionAll)(permissions),
        initialActiveRoleId: currentRole?.id,
        analyticsSource: analyticsSource,
        onClose: ()=>setIsViewPermissionsModalOpen(false)
    }), currentRole ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: popupRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $710ea738a38b5734$export$1a3c335d7dca645d), {
        "data-testid": "role-selector-info-button",
        isOpen: isPopupOpen,
        onClick: onInfoButtonClick,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5e889a2aa3054314$export$90dae7b611e581b7), {
            onCtaClick: onPopupContentCtaClick,
            roleId: currentRole.id,
            permissions: currentRole.permissions,
            roleLookup: roleLookup
        })
    })) : null);
};


const $0c8581713df69b2f$var$i18n = (0, $kSwu1.defineMessages)({
    roleSelectionHeader: {
        id: "bulk-permissions.space.role-selection-header",
        defaultMessage: "With what access<asterisk>*</asterisk>"
    },
    roleSelectionSubHeader: {
        id: "bulk-permissions.space.role-selection-sub-header",
        defaultMessage: "Choose the role they should have."
    },
    roleSelectionWarning: {
        id: "bulk-permissions.space.role-selection-warning",
        defaultMessage: "This will overwrite any existing access they have. <b>This can\u2019t be undone,</b> so make sure to double check your selections."
    },
    roleSelectLabel: {
        id: "bulk-permissions.space.role-select-label",
        defaultMessage: "Role"
    },
    roleSelectPlaceholder: {
        id: "bulk-permissions.space-role.select-placeholder",
        defaultMessage: "Select a role"
    }
});
const $0c8581713df69b2f$var$roleSelectionHeaderStyle = (0, $buxP3.xcss)({
    font: 'font.body.large',
    fontWeight: 'font.weight.medium',
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: 'space.100'
});
const $0c8581713df69b2f$var$asteriskStyle = (0, $buxP3.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
    color: 'color.text.accent.red'
});
const $0c8581713df69b2f$var$roleSelectionContainer = (0, $buxP3.xcss)({
    marginTop: 'space.150',
    marginBottom: 'space.300'
});
const $0c8581713df69b2f$var$sectionContainer = (0, $buxP3.xcss)({
    marginBottom: 'space.300'
});
const $0c8581713df69b2f$var$roleSelectInfoButtonStyle = (0, $buxP3.xcss)({
    display: 'flex',
    minWidth: '500px',
    alignItems: 'center'
});
const $0c8581713df69b2f$var$roleSelectStyle = (0, $buxP3.xcss)({
    minWidth: '300px'
});
const $0c8581713df69b2f$var$roleSelectionSectionRolesQuery = (0, $60adf85299dca4dd$export$2e2bcd8739ae039);
const $0c8581713df69b2f$export$884fc60bd42d0abd = ({ onRoleChange: onRoleChange, roleAssignment: roleAssignment, analyticsSource: analyticsSource, flags: flags, isDisabled: isDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [experienceStarted, setExperienceStarted] = (0, $cozmU.useState)(false);
    //TODO: update this and add it to experience tracker once the experience is created
    const BULK_ROLES_VIEW_EXPERIENCE = 'bulk-roles-view-experience';
    const placeholder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        color: "color.text"
    }, formatMessage($0c8581713df69b2f$var$i18n.roleSelectPlaceholder));
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($0c8581713df69b2f$var$roleSelectionSectionRolesQuery, {
        onCompleted: ()=>{
            setExperienceStarted(false);
            experienceTracker.succeed({
                name: BULK_ROLES_VIEW_EXPERIENCE
            });
        },
        onError: (error)=>{
            experienceTracker.stopOnError({
                name: BULK_ROLES_VIEW_EXPERIENCE,
                error: error
            });
        },
        __callerPackage__: "bulk-permissions"
    });
    const roleOptions = data?.spaceRolesByCriteria?.nodes?.map((role)=>({
            id: role?.roleId || '',
            name: role?.roleDisplayName || '',
            permissions: role?.spacePermissionList.map((permission)=>permission.id) || [],
            description: role?.roleDescription || '',
            roleType: role?.roleType ?? (0, $3EH2D.SpaceRoleType).SYSTEM
        })) || [];
    (0, $cozmU.useEffect)(()=>{
        if (loading && !experienceStarted) setExperienceStarted(true);
    }, [
        loading,
        experienceStarted
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $0c8581713df69b2f$var$sectionContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $0c8581713df69b2f$var$roleSelectionHeaderStyle
    }, formatMessage($0c8581713df69b2f$var$i18n.roleSelectionHeader, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $0c8581713df69b2f$var$asteriskStyle
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), null, formatMessage($0c8581713df69b2f$var$i18n.roleSelectionSubHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $0c8581713df69b2f$var$roleSelectionContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
        htmlFor: "role-selector"
    }, formatMessage($0c8581713df69b2f$var$i18n.roleSelectLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $0c8581713df69b2f$var$roleSelectInfoButtonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $0c8581713df69b2f$var$roleSelectStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ku6MO.RoleSelector), {
        inputId: "role-selector",
        value: roleAssignment?.id || null,
        onChange: onRoleChange,
        placeholder: placeholder,
        isLoading: loading,
        isDisabled: isDisabled,
        spaceRoleOptions: roleOptions,
        appearance: "default"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $117ed3de9d2a23fd$export$5bafd35f9dc9151a), {
        currentRole: roleAssignment,
        roleLookup: roleOptions,
        analyticsSource: analyticsSource,
        flags: flags
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), null, formatMessage($0c8581713df69b2f$var$i18n.roleSelectionWarning, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks)
    })));
};



var $ilq3G = parcelRequire("ilq3G");


var $eIwUX = parcelRequire("eIwUX");





var $aRGok = parcelRequire("aRGok");





var $lM2MU = parcelRequire("lM2MU");








var $7ZB0A = parcelRequire("7ZB0A");


var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");











var $67Foi = parcelRequire("67Foi");




const $d771d120872e42c7$var$i18n = (0, $kSwu1.defineMessages)({
    addConfirmationDialogTitle: {
        id: "bulk-permissions.space.add.confirmation-dialog",
        defaultMessage: "Add {principalName} to all spaces?"
    },
    addAllExcludingPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-exclude-personal.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all spaces (excluding personal)</b> on your site as <b>{roleName}</b>."
    },
    addAllConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-all.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all spaces</b> on your site as <b>{roleName}</b>."
    },
    addAllPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.add-personal.confirmation-dialog-description",
        defaultMessage: "This will give them access to <b>all personal spaces</b> on your site as <b>{roleName}</b>."
    },
    confirmationDialogWarning: {
        id: "bulk-permissions.space.confirmation-dialog-warning",
        defaultMessage: "<b>This can\u2019t be undone.</b>"
    },
    removeConfirmationDialogTitle: {
        id: "bulk-permissions.space.remove.confirmation-dialog",
        defaultMessage: "Remove {principalName} from all spaces?"
    },
    removeAllExcludingPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-exclude-personal.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all spaces</b> (excluding personal) on your site."
    },
    removeAllConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-all.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all spaces</b> on your site."
    },
    removeAllPersonalConfirmationDialogDescription: {
        id: "bulk-permissions.space.remove-personal.confirmation-dialog-description",
        defaultMessage: "This will remove them from <b>all personal spaces</b> on your site."
    },
    cancelButtonText: {
        id: "bulk-permissions.space.cancel-button-text",
        defaultMessage: "Cancel"
    },
    addButtonText: {
        id: "bulk-permissions.space.add-button-text",
        defaultMessage: "Add to all"
    },
    removeButtonText: {
        id: "bulk-permissions.space.remove-button-text",
        defaultMessage: "Remove access"
    }
});
const $d771d120872e42c7$var$ConfirmatonSubSection = (0, $buxP3.xcss)({
    paddingTop: 'space.300'
});
const $d771d120872e42c7$var$boldString = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks);
const $d771d120872e42c7$export$6daa4510cb54b507 = ({ principalName: principalName, isRemoval: isRemoval, spaceSelection: spaceSelection, roleName: roleName, onConfirm: onConfirm, onCancel: onCancel })=>{
    const getConfirmationDialogDescription = ()=>{
        if (isRemoval) switch(spaceSelection){
            case (0, $8A6YM.SpaceSelection).AllExcludingPersonal:
                return $d771d120872e42c7$var$i18n.removeAllExcludingPersonalConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).AllIncludingPersonal:
                return $d771d120872e42c7$var$i18n.removeAllConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).OnlyPersonal:
                return $d771d120872e42c7$var$i18n.removeAllPersonalConfirmationDialogDescription;
        }
        else switch(spaceSelection){
            case (0, $8A6YM.SpaceSelection).AllExcludingPersonal:
                return $d771d120872e42c7$var$i18n.addAllExcludingPersonalConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).AllIncludingPersonal:
                return $d771d120872e42c7$var$i18n.addAllConfirmationDialogDescription;
            case (0, $8A6YM.SpaceSelection).OnlyPersonal:
                return $d771d120872e42c7$var$i18n.addAllPersonalConfirmationDialogDescription;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $67Foi.ScreenEvent), {
        name: "bulk-access-dialog",
        id: "bulk-access-dialog",
        attributes: {
            action: isRemoval ? 'remove' : 'add',
            spaceType: spaceSelection
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), {
        appearance: isRemoval ? 'warning' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...isRemoval ? $d771d120872e42c7$var$i18n.removeConfirmationDialogTitle : $d771d120872e42c7$var$i18n.addConfirmationDialogTitle,
        values: {
            principalName: principalName
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...getConfirmationDialogDescription(),
        values: {
            b: $d771d120872e42c7$var$boldString,
            roleName: roleName
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        xcss: $d771d120872e42c7$var$ConfirmatonSubSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$d771d120872e42c7$var$i18n.confirmationDialogWarning,
        values: {
            b: $d771d120872e42c7$var$boldString
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        onClick: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $d771d120872e42c7$var$i18n.cancelButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        testId: "confirmation-dialog-confirm-button",
        appearance: isRemoval ? 'warning' : 'primary',
        onClick: onConfirm
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), isRemoval ? $d771d120872e42c7$var$i18n.removeButtonText : $d771d120872e42c7$var$i18n.addButtonText))));
};


const $1d76093de32754c2$export$9297639d67b5de69 = ({ principalName: principalName, roleName: roleName, isLoading: isLoading, isRemoval: isRemoval, spaceSelection: spaceSelection, onCancel: onCancel, onConfirm: onConfirm })=>{
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
        testId: "bulk-access-confirmation",
        onClose: // Don't allow the dialog to close while mutation is loading
        isLoading ? undefined : onCancel
    }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lM2MU.LoadingDialog), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d771d120872e42c7$export$6daa4510cb54b507), {
        principalName: principalName,
        roleName: roleName,
        isRemoval: isRemoval,
        spaceSelection: spaceSelection,
        onCancel: onCancel,
        onConfirm: onConfirm
    })));
};


/**
 * @generated SignedSource<<bc511fec044cdb93180934791f2c11bc>>
 * @relayHash 0dc51d4e6b21d806122d9dcffa795bcf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ad25d5510f09dfa2653e56b9d7b9d15e81bd26b00f4b66aa0374e8710435b010
const $1d4c1eba0eff269c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "principalId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "principalType"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceTypes"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "principalId",
                                    "variableName": "principalId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "principalType",
                                    "variableName": "principalType"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "principal"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceTypes",
                            "variableName": "spaceTypes"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "BulkRemoveRoleAssignmentFromSpacesPayload",
            "kind": "LinkedField",
            "name": "bulkRemoveRoleAssignmentFromSpaces",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "taskId"
                },
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0dc51d4e6b21d806122d9dcffa795bcf",
            "id": "ad25d5510f09dfa2653e56b9d7b9d15e81bd26b00f4b66aa0374e8710435b010",
            "metadata": {},
            "name": "useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation",
            "operationKind": "mutation",
            "text": "mutation useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation($principalId:ID!,$principalType:RoleAssignmentPrincipalType!,$spaceTypes:[BulkRoleAssignmentSpaceType]!){bulkRemoveRoleAssignmentFromSpaces(input:{principal:{principalId:$principalId,principalType:$principalType},spaceTypes:$spaceTypes}){taskId,success,errors{message}}}"
        }
    };
}();
$1d4c1eba0eff269c$var$node.hash = "a5efdd94809c62d366be293748749bcb";
var $1d4c1eba0eff269c$export$2e2bcd8739ae039 = $1d4c1eba0eff269c$var$node;


/**
 * @generated SignedSource<<ee6d1883a74fad02da6582faa97e8392>>
 * @relayHash a5b790ed65d0de142da6e4d1622295fa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 16056f05f1e48cfbfc1a00a65f23a9f7adf9a12f7a15ad4d1d6d21505a8c51a2
const $0639403282a4d5d2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "principalId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "principalType"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "roleId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceTypes"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "fields": [
                                {
                                    "fields": [
                                        {
                                            "kind": "Variable",
                                            "name": "principalId",
                                            "variableName": "principalId"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "principalType",
                                            "variableName": "principalType"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "principal"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "roleId",
                                    "variableName": "roleId"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "roleAssignment"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceTypes",
                            "variableName": "spaceTypes"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "BulkSetRoleAssignmentToSpacesPayload",
            "kind": "LinkedField",
            "name": "bulkSetRoleAssignmentToSpaces",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "taskId"
                },
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "a5b790ed65d0de142da6e4d1622295fa",
            "id": "16056f05f1e48cfbfc1a00a65f23a9f7adf9a12f7a15ad4d1d6d21505a8c51a2",
            "metadata": {},
            "name": "useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation",
            "operationKind": "mutation",
            "text": "mutation useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation($principalId:ID!,$principalType:RoleAssignmentPrincipalType!,$roleId:ID!,$spaceTypes:[BulkRoleAssignmentSpaceType]!){bulkSetRoleAssignmentToSpaces(input:{roleAssignment:{principal:{principalId:$principalId,principalType:$principalType},roleId:$roleId},spaceTypes:$spaceTypes}){taskId,success,errors{message}}}"
        }
    };
}();
$0639403282a4d5d2$var$node.hash = "ed136028da75a75da2fb263f31962138";
var $0639403282a4d5d2$export$2e2bcd8739ae039 = $0639403282a4d5d2$var$node;






var $cXkvk = parcelRequire("cXkvk");


var $308Wd = parcelRequire("308Wd");


const $754fc52bc3b4de65$var$useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation = (0, $0639403282a4d5d2$export$2e2bcd8739ae039);
const $754fc52bc3b4de65$var$useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation = (0, $1d4c1eba0eff269c$export$2e2bcd8739ae039);
const $754fc52bc3b4de65$export$667fffd9e35f2dcd = ({ closeDialog: closeDialog, flags: flags, rolePermissions: rolePermissions })=>{
    const { showErrorFlag: showErrorFlag, showProcessingFlag: showProcessingFlag, showInfoFlag: showInfoFlag } = (0, $5b8a2a030512dd5e$export$4b081a83cd5f1b6f)({
        flags: flags
    });
    const showDSPWarning = (0, $cXkvk.useShouldShowDSPWarningForWorkspaceRole)(rolePermissions);
    const onMutationErrored = (0, $cozmU.useCallback)(()=>{
        closeDialog();
        showErrorFlag();
    }, [
        closeDialog,
        showErrorFlag
    ]);
    const onAsyncMutationSubmitted = (0, $cozmU.useCallback)((data)=>{
        closeDialog();
        /**
     * The backend is counting the mutation as a success for some exceptions
     * but returning an error in the mutation response.  We need to check for
     * these here.
     */ if (data?.bulkSetRoleAssignmentToSpaces?.errors?.length > 0 || data?.bulkRemoveRoleAssignmentFromSpaces?.errors?.length > 0) onMutationErrored();
        else if (data.bulkSetRoleAssignmentToSpaces?.taskId || data.bulkRemoveRoleAssignmentFromSpaces?.taskId) {
            if (showDSPWarning) showInfoFlag();
            else // show the progress flag
            showProcessingFlag();
        }
    }, [
        closeDialog,
        onMutationErrored,
        showDSPWarning,
        showInfoFlag,
        showProcessingFlag
    ]);
    const [bulkSetRoleAssignmentToSpaces, { data: bulkAssignmentData }] = (0, $308Wd.useMutationInterop)($754fc52bc3b4de65$var$useBulkRoleSetAssignmentBulkSetRoleAssignmentToSpacesMutation, {
        onCompleted: onAsyncMutationSubmitted,
        onError: ()=>{
            closeDialog();
            onMutationErrored();
        },
        __callerPackage__: "bulk-permissions"
    });
    const [bulkRemoveRoleAssignment, { data: bulkRemoveAssignmentData }] = (0, $308Wd.useMutationInterop)($754fc52bc3b4de65$var$useBulkRoleSetAssignmentBulkRemoveRoleAssignmentFromSpacesMutation, {
        onCompleted: onAsyncMutationSubmitted,
        onError: ()=>{
            closeDialog();
            onMutationErrored();
        },
        __callerPackage__: "bulk-permissions"
    });
    return {
        bulkSetRoleAssignmentToSpaces: bulkSetRoleAssignmentToSpaces,
        bulkRemoveRoleAssignment: bulkRemoveRoleAssignment,
        bulkAssignmentData: bulkAssignmentData,
        bulkRemoveAssignmentData: bulkRemoveAssignmentData
    };
};


const $1f40f2edcedc8ce5$export$f7109619a5e9e0d6 = 'bulkAccessManagementScreen';
const $1f40f2edcedc8ce5$var$i18n = (0, $kSwu1.defineMessages)({
    bulkRoleAccessHeader: {
        id: "bulk-permissions.space.role-access-header",
        defaultMessage: "Manage space access in bulk"
    },
    bulkRoleAccessSubtext: {
        id: "bulk-permissions.space.role-access-subtext",
        defaultMessage: "Quickly add, change, or remove access for individual users or groups across spaces on your Confluence site."
    },
    bulkRoleAccessTeamsSubtext: {
        id: "bulk-permissions.space.role-access-subtext-teams",
        defaultMessage: "Quickly add, change, or remove access for individual users, teams, or groups across spaces on your Confluence site."
    },
    warningSubtext: {
        id: "bulk-permissions.space.warning-subtext",
        defaultMessage: "<b>This can\u2019t be undone</b> so make sure to double check your selections."
    },
    userPickerAccessHeader: {
        id: "bulk-permissions.space.user-picker-access-header",
        defaultMessage: "Who<asterisk>*</asterisk>"
    },
    userPickerPlaceholder: {
        id: "bulk-permissions.space.user-picker-placeholder",
        defaultMessage: "Add a user, group, or user class"
    },
    userPickerTeamsPlaceholder: {
        id: "bulk-permissions.space.user-picker-teams-placeholder",
        defaultMessage: "Add a user, team, group, or user class"
    },
    backToSpacePermissions: {
        id: "bulk-permissions.space-permissions-link.role-access",
        defaultMessage: "Space permissions"
    },
    userPickerSubtext: {
        id: "bulk-permissions.space.user-picker-subtext.role-access",
        defaultMessage: "You may only select one for this action."
    },
    applyButtonTextAdd: {
        id: "bulk-permissions.space.apply-button-text-add.role-access",
        defaultMessage: "Add to all"
    },
    applyButtonTextRemoveRolesOnly: {
        id: "bulk-permissions.space.apply-button-text-remove-roles-only.role-access",
        defaultMessage: "Remove access"
    },
    requirementMessage: {
        id: "bulk-permissions.space.requirement-message.role-access",
        defaultMessage: "<asterisk>* </asterisk> Required to perform action"
    }
});
const $1f40f2edcedc8ce5$var$bulkAddRolesHeaderStyle = (0, $buxP3.xcss)({
    font: 'font.heading.large',
    fontWeight: 'font.weight.medium',
    paddingBottom: 'space.100',
    paddingTop: 'space.300'
});
const $1f40f2edcedc8ce5$var$bulkAddRolesHeaderModernizedWrapperStyle = (0, $buxP3.xcss)({
    paddingBottom: 'space.100'
});
const $1f40f2edcedc8ce5$var$bulkRolesSubtextStyle = (0, $buxP3.xcss)({
    font: 'font.body',
    width: '75%'
});
const $1f40f2edcedc8ce5$var$bulkRolesSubtextStyleModernized = (0, $buxP3.xcss)({
    font: 'font.body',
    width: '100%'
});
const $1f40f2edcedc8ce5$var$principlePickerHeaderStyle = (0, $buxP3.xcss)({
    font: 'font.body.large',
    fontWeight: 'font.weight.medium',
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 'space.300',
    paddingBottom: 'space.100'
});
const $1f40f2edcedc8ce5$var$asteriskStyle = (0, $buxP3.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
    color: 'color.text.accent.red'
});
const $1f40f2edcedc8ce5$var$principlePickerFineTextStyle = (0, $buxP3.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
    color: 'color.text.accent.gray',
    marginTop: 'space.050',
    font: 'font.body.small'
});
const $1f40f2edcedc8ce5$var$contentStyle = (0, $buxP3.xcss)({
    marginLeft: 'space.1000',
    marginRight: 'space.1000',
    paddingBottom: 'space.1000'
});
const $1f40f2edcedc8ce5$var$contentStyleModernized = (0, $buxP3.xcss)({
    paddingBottom: 'space.1000'
});
const $1f40f2edcedc8ce5$var$backAndFeedbackButtonsStyle = (0, $buxP3.xcss)({
    width: '100%',
    marginLeft: 'space.negative.200',
    paddingTop: 'space.300',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
});
const $1f40f2edcedc8ce5$var$principlePickerStyle = (0, $buxP3.xcss)({
    paddingBottom: 'space.050'
});
const $1f40f2edcedc8ce5$var$requirementTextStyle = (0, $buxP3.xcss)({
    font: 'font.body',
    paddingTop: 'space.300',
    paddingBottom: 'space.1000',
    marginBottom: 'space.1000'
});
const $1f40f2edcedc8ce5$var$requirementTextStyleModernized = (0, $buxP3.xcss)({
    font: 'font.body',
    paddingTop: 'space.300'
});
const $1f40f2edcedc8ce5$var$styles = {
    removalWarningSubtext: "_1wydGWNHnM"
};
const $1f40f2edcedc8ce5$export$554dd5f0355b3be6 = (principal)=>{
    if (principal?.type === 'group') return principal?.id;
    return principal?.id;
};
const $1f40f2edcedc8ce5$export$9c91ebd69562789f = (options)=>{
    // TEMPORARY WORKAROUND https://product-fabric.atlassian.net/browse/CPE-3651:
    // Smart User Picker does not currently expose a reliable field to identify guest users.
    // We're using the presence of the "GUEST" lozenge as a proxy to filter out guest users.
    // This should be revisited once the platform team adds a proper field
    // to accurately indicate guest status.
    return options.filter((option)=>{
        const { lozenge: lozenge } = option;
        const isGuest = typeof lozenge === 'object' && lozenge !== null && 'text' in lozenge && lozenge.text === 'GUEST';
        return !isGuest;
    });
};
const $1f40f2edcedc8ce5$export$db2035bfb5892b74 = (0, $7aRa9.withFlags)((0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
})(({ flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { isProductAdmin: isProductAdmin, isAdminCheckLoading: isAdminCheckLoading } = (0, $1BYn9.useIsProductAdmin)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const accessClassInclusion = (0, $6sX6R.useAccessClassInclusion)();
    const { pickerProps: teamPickerProps } = (0, $9phVF.useTeamPicker)();
    const isFreeEdition = edition === (0, $euL71.ConfluenceEdition).FREE;
    const [showDialog, setShowDialog] = (0, $cozmU.useState)(false);
    const [stagedPrincipal, setStagedPrincipal] = (0, $cozmU.useState)(undefined);
    const [spaceSelection, setSpaceSelection] = (0, $cozmU.useState)((0, $8A6YM.SpaceSelection).AllExcludingPersonal);
    const { setSearchQuery: setSearchQuery, transformOptions: transformOptions } = (0, $bYvQP.useAccessClassTransformer)();
    const [actionSelection, setActionSelection] = (0, $cozmU.useState)((0, $8799edea050578d8$export$19d9f94347fa723d).AddOrChangeAccess);
    const [roleAssignment, setRoleAssignment] = (0, $cozmU.useState)(null);
    const isRemoval = actionSelection === (0, $8799edea050578d8$export$19d9f94347fa723d).RemoveAccess;
    const closeDialog = (0, $cozmU.useCallback)(()=>{
        setShowDialog(false);
    }, [
        setShowDialog
    ]);
    const { bulkSetRoleAssignmentToSpaces: bulkSetRoleAssignmentToSpaces, bulkRemoveRoleAssignment: bulkRemoveRoleAssignment } = (0, $754fc52bc3b4de65$export$667fffd9e35f2dcd)({
        closeDialog: closeDialog,
        flags: flags,
        rolePermissions: roleAssignment?.permissions || []
    });
    const getSpaceTypes = (targetValue)=>{
        const spaceTypesArray = [
            (0, $2fd747c2df30bd9d$export$dc2a111abcc46324).PERSONAL,
            (0, $2fd747c2df30bd9d$export$dc2a111abcc46324).COLLABORATION,
            (0, $2fd747c2df30bd9d$export$dc2a111abcc46324).GLOBAL,
            (0, $2fd747c2df30bd9d$export$dc2a111abcc46324).KNOWLEDGE_BASE
        ];
        if (targetValue === (0, $8A6YM.SpaceSelection).AllExcludingPersonal) return spaceTypesArray.filter((type)=>type !== (0, $2fd747c2df30bd9d$export$dc2a111abcc46324).PERSONAL);
        else if (targetValue === (0, $8A6YM.SpaceSelection).AllIncludingPersonal) return spaceTypesArray;
        else if (targetValue === (0, $8A6YM.SpaceSelection).OnlyPersonal) return [
            (0, $2fd747c2df30bd9d$export$dc2a111abcc46324).PERSONAL
        ];
    };
    const getPrincipalType = (principalType)=>{
        if (principalType === 'group') return (0, $2fd747c2df30bd9d$export$4e2d5448f3fd8728).GROUP;
        else if (principalType === 'team') return (0, $2fd747c2df30bd9d$export$4e2d5448f3fd8728).GROUP;
        else if (principalType === 'custom') return (0, $2fd747c2df30bd9d$export$4e2d5448f3fd8728).ACCESS_CLASS;
        else return (0, $2fd747c2df30bd9d$export$4e2d5448f3fd8728).USER;
    };
    const onDialogConfirm = (0, $cozmU.useCallback)(async ()=>{
        closeDialog();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'bulk-access-management-confirm',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
                attributes: {
                    principalType: stagedPrincipal?.type === 'group' ? stagedPrincipal?.extra?.usageType : stagedPrincipal?.type,
                    verified: stagedPrincipal?.type === 'team' ? stagedPrincipal?.verified : 'N/A',
                    selectedRole: roleAssignment?.name,
                    spaceTypes: getSpaceTypes(spaceSelection),
                    action: isRemoval ? 'remove' : 'add'
                }
            }
        }).fire();
        isRemoval ? await bulkRemoveRoleAssignment({
            variables: {
                principalId: $1f40f2edcedc8ce5$export$554dd5f0355b3be6(stagedPrincipal),
                principalType: getPrincipalType(stagedPrincipal.type),
                spaceTypes: getSpaceTypes(spaceSelection)
            }
        }) : await bulkSetRoleAssignmentToSpaces({
            variables: {
                principalId: $1f40f2edcedc8ce5$export$554dd5f0355b3be6(stagedPrincipal),
                principalType: getPrincipalType(stagedPrincipal.type),
                roleId: roleAssignment.id,
                spaceTypes: getSpaceTypes(spaceSelection)
            }
        });
    }, [
        closeDialog,
        isRemoval,
        bulkRemoveRoleAssignment,
        stagedPrincipal,
        spaceSelection,
        bulkSetRoleAssignmentToSpaces,
        roleAssignment,
        createAnalyticsEvent
    ]);
    const handleBackToDefaultSpaceAccessClick = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'defaultspaceperms',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onSpaceTypeRadioChange = (0, $cozmU.useCallback)((e)=>{
        setSpaceSelection(e.target.value);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'radio',
                action: 'selected',
                actionSubjectId: 'bulkAccessManagementSpace',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
                attributes: {
                    spaceSelection: e.target.value,
                    isRBACEnabled: true
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onActionRadioChange = (0, $cozmU.useCallback)((e)=>{
        setActionSelection(e.target.value);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'radio',
                action: 'selected',
                actionSubjectId: 'bulkAccessManagementAction',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
                attributes: {
                    actionSelection: e.target.value,
                    isRBACEnabled: true
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]); //Only passing roleId to the analytics event to avoid leaking UGC
    //Ticket to audit rest of analytics events: https://product-fabric.atlassian.net/browse/RBAC-1552
    const onRoleChange = (0, $cozmU.useCallback)((role)=>{
        setRoleAssignment(role);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'role picker',
                action: 'selected',
                actionSubjectId: 'bulkAccessManagement',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
                attributes: {
                    roleAssignment: role.id
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onPrincipalChange = (0, $cozmU.useCallback)((received)=>{
        // Only send an analytic event if a principal isn't deselected
        if (received) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'principal',
                action: 'selected',
                actionSubjectId: 'bulkAccessManagementPrincipal',
                source: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
                attributes: {
                    principal: received.type,
                    verified: received.type === 'team' ? received.verified : 'N/A',
                    isRBACEnabled: true
                }
            }
        }).fire();
        setStagedPrincipal(received);
    }, [
        createAnalyticsEvent
    ]);
    const openDialog = (0, $cozmU.useCallback)(()=>{
        setShowDialog(true);
    }, [
        setShowDialog
    ]); // Don't render the page until we know if the user is a product admin
    // to avoid a flicker of the restricted view.
    if (isAdminCheckLoading) return null;
    if (!isProductAdmin || isFreeEdition && !(0, $6mKj3.expVal)('cc_perms_enable_rbac_admin_modernization', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eIwUX.RestrictedView), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $49jU7.FlexContainer), {
        id: "SpaceSelectionPanel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: (0, $6mKj3.expVal)('cc_perms_enable_rbac_admin_modernization', 'isEnabled', false) ? $1f40f2edcedc8ce5$var$contentStyleModernized : $1f40f2edcedc8ce5$var$contentStyle
    }, (0, $6mKj3.expVal)('cc_perms_enable_rbac_admin_modernization', 'isEnabled', false) ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $1f40f2edcedc8ce5$var$backAndFeedbackButtonsStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        appearance: "subtle",
        onClick: handleBackToDefaultSpaceAccessClick,
        href: (0, $1NBp8.ADMIN_SITE_SPACE_PERMISSIONS).toUrl({
            tab: 'allspaces'
        }),
        iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
                ...iconProps,
                size: "small"
            })
    }, formatMessage($1f40f2edcedc8ce5$var$i18n.backToSpacePermissions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c6lYi.FeedbackCollectorButton), {
        source: "Bulk Space Roles"
    })), (0, $6mKj3.expVal)('cc_perms_enable_rbac_admin_modernization', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $1f40f2edcedc8ce5$var$bulkAddRolesHeaderModernizedWrapperStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h1",
        size: "large"
    }, formatMessage($1f40f2edcedc8ce5$var$i18n.bulkRoleAccessHeader))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $1f40f2edcedc8ce5$var$bulkAddRolesHeaderStyle
    }, formatMessage($1f40f2edcedc8ce5$var$i18n.bulkRoleAccessHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: (0, $6mKj3.expVal)('cc_perms_enable_rbac_admin_modernization', 'isEnabled', false) ? $1f40f2edcedc8ce5$var$bulkRolesSubtextStyleModernized : $1f40f2edcedc8ce5$var$bulkRolesSubtextStyle
    }, formatMessage(teamPickerProps.includeTeamsUpdates ? $1f40f2edcedc8ce5$var$i18n.bulkRoleAccessTeamsSubtext : $1f40f2edcedc8ce5$var$i18n.bulkRoleAccessSubtext)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $1f40f2edcedc8ce5$var$principlePickerHeaderStyle
    }, formatMessage($1f40f2edcedc8ce5$var$i18n.userPickerAccessHeader, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $1f40f2edcedc8ce5$var$asteriskStyle
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $1f40f2edcedc8ce5$var$principlePickerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpRYU.UserAndGroupSearchPicker), {
        ariaLabel: formatMessage($1f40f2edcedc8ce5$var$i18n.userPickerPlaceholder),
        "data-test-id": "user-and-group-search",
        fieldId: "bulk-permissions-user-picker",
        includeGroup: true,
        withUsers: true,
        isMulti: false,
        smart: true,
        customInclusion: accessClassInclusion,
        placeholder: formatMessage(teamPickerProps.includeTeamsUpdates ? $1f40f2edcedc8ce5$var$i18n.userPickerTeamsPlaceholder : $1f40f2edcedc8ce5$var$i18n.userPickerPlaceholder),
        sitePermissionTypeFilter: (0, $g3p2i.SitePermissionTypeFilter).NONE,
        noOptionsMessage: null,
        onChange: (received)=>{
            onPrincipalChange(received);
        },
        value: stagedPrincipal || [],
        filterSearchResults: (value)=>value?.extra?.permissionType !== (0, $g3p2i.SitePermissionType).EXTERNAL,
        onInputChange: (searchQuery)=>setSearchQuery(searchQuery || ''),
        transformOptions: transformOptions,
        smartFilterOptions: $1f40f2edcedc8ce5$export$9c91ebd69562789f,
        isDisabled: isFreeEdition,
        includeTeams: teamPickerProps.includeTeams,
        includeTeamsUpdates: teamPickerProps.includeTeamsUpdates,
        verifiedTeams: teamPickerProps.verifiedTeams
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ilq3G.AgentAccessWarning), {
        stagedPrincipals: stagedPrincipal ? [
            stagedPrincipal
        ] : []
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $1f40f2edcedc8ce5$var$principlePickerFineTextStyle
    }, formatMessage($1f40f2edcedc8ce5$var$i18n.userPickerSubtext)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8799edea050578d8$export$321778e99f9fd257), {
        actionSelection: actionSelection,
        onRadioChange: onActionRadioChange,
        isDisabled: isFreeEdition
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8A6YM.SpaceSelectionRadioButtons), {
        spaceSelection: spaceSelection,
        onRadioChange: onSpaceTypeRadioChange,
        isDisabled: isFreeEdition
    }), isRemoval ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $1f40f2edcedc8ce5$var$styles.removalWarningSubtext
    }, formatMessage($1f40f2edcedc8ce5$var$i18n.warningSubtext, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0c8581713df69b2f$export$884fc60bd42d0abd), {
        onRoleChange: onRoleChange,
        roleAssignment: roleAssignment,
        analyticsSource: $1f40f2edcedc8ce5$export$f7109619a5e9e0d6,
        flags: flags,
        isDisabled: isFreeEdition
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: isRemoval ? 'danger' : 'primary',
        onClick: ()=>openDialog(),
        isDisabled: isFreeEdition || stagedPrincipal === undefined || !isRemoval && roleAssignment === null
    }, formatMessage(isRemoval ? $1f40f2edcedc8ce5$var$i18n.applyButtonTextRemoveRolesOnly : $1f40f2edcedc8ce5$var$i18n.applyButtonTextAdd)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        xcss: (0, $6mKj3.expVal)('cc_perms_enable_rbac_admin_modernization', 'isEnabled', false) ? $1f40f2edcedc8ce5$var$requirementTextStyleModernized : $1f40f2edcedc8ce5$var$requirementTextStyle
    }, formatMessage($1f40f2edcedc8ce5$var$i18n.requirementMessage, {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $1f40f2edcedc8ce5$var$asteriskStyle
            }, chunks)
    }))), showDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1d76093de32754c2$export$9297639d67b5de69), {
        principalName: stagedPrincipal?.name || '',
        isRemoval: isRemoval,
        spaceSelection: spaceSelection,
        isLoading: false,
        onConfirm: onDialogConfirm,
        onCancel: closeDialog,
        roleName: roleAssignment?.name
    })));
}));
module.exports["ANALYTICS_SOURCE"] = $1f40f2edcedc8ce5$export$f7109619a5e9e0d6;
module.exports["getPrincipalId"] = $1f40f2edcedc8ce5$export$554dd5f0355b3be6;
module.exports["pickerResultsFilter"] = $1f40f2edcedc8ce5$export$9c91ebd69562789f;
module.exports["BulkAccessManagementPage"] = $1f40f2edcedc8ce5$export$db2035bfb5892b74;

});

parcelRegister("49jU7", function(module, exports) {
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $hekY6 = parcelRequire("hekY6");

parcelRequire("cozmU");

const $9716eea9b65ec5b1$var$flexContainerStyles = null;
const $9716eea9b65ec5b1$export$124d4c7bf7db9715 = ({ id: id, children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        id: id,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ"
        ]),
        children: children
    });
const $9716eea9b65ec5b1$var$contentWrapperStyles = null;
const $9716eea9b65ec5b1$export$6ce170286acaa8d3 = ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _1mT5xdRAKS _4ouGXIdnbC _4bt5LAnQyn"
        ]),
        children: children
    });
module.exports["FlexContainer"] = $9716eea9b65ec5b1$export$124d4c7bf7db9715;
module.exports["ContentWrapper"] = $9716eea9b65ec5b1$export$6ce170286acaa8d3;

});

parcelRegister("c6lYi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $gVrmv = parcelRequire("gVrmv");


var $7aRa9 = parcelRequire("7aRa9");


var $iquRY = parcelRequire("iquRY");


var $cNkvT = parcelRequire("cNkvT");

const $fa5a2619efb2e23a$export$396d041cc2808022 = (0, $kSwu1.defineMessages)({
    buttonText: {
        id: "space-roles.feedback-collector.button-text",
        defaultMessage: "Give feedback"
    },
    flagTitle: {
        id: "space-roles.feedback-collector.flag-title",
        defaultMessage: "Feedback submitted, thank you!"
    }
});
const $fa5a2619efb2e23a$var$FeedbackCollectorButtonComponent = ({ flags: flags, source: source, appearance: appearance = 'default' })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    return isRbacEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($gVrmv))),
        appearance: appearance,
        onClick: ()=>setIsOpen(true)
    }, formatMessage($fa5a2619efb2e23a$export$396d041cc2808022.buttonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cNkvT.SpaceRolesFeedbackCollector), {
        isOpen: isOpen,
        onClose: ()=>{
            setIsOpen(false);
        },
        onSubmit: ()=>{
            flags.showSuccessFlag({
                title: formatMessage($fa5a2619efb2e23a$export$396d041cc2808022.flagTitle),
                isAutoDismiss: true
            });
        },
        source: source
    })) : null;
};
const $fa5a2619efb2e23a$export$b39479f42d974760 = (0, $7aRa9.withFlags)($fa5a2619efb2e23a$var$FeedbackCollectorButtonComponent);
module.exports["feedbackCollectorMessages"] = $fa5a2619efb2e23a$export$396d041cc2808022;
module.exports["FeedbackCollectorButton"] = $fa5a2619efb2e23a$export$b39479f42d974760;

});

parcelRegister("cNkvT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $2eX69 = parcelRequire("2eX69");


var $bQm3c = parcelRequire("bQm3c");


var $iquRY = parcelRequire("iquRY");

const $fe7fcc34e2e5b785$var$i18n = (0, $kSwu1.defineMessages)({
    feedbackTitle: {
        id: "space-roles.feedback-collector.title",
        defaultMessage: "Give feedback"
    },
    feedbackTitleDetails: {
        id: "space-roles.feedback-collector.title-details",
        defaultMessage: "How satisfied or dissatisfied are you overall with your experience using roles to manage access in Confluence?"
    }
});
const $fe7fcc34e2e5b785$var$FEEDBACK_CONTEXT_ID = 'customfield_10047';
const $fe7fcc34e2e5b785$var$ENTRYPOINT_ID = 'ba8149f4-b7d4-4f55-9e72-683a444d3b27';
const $fe7fcc34e2e5b785$export$91e87cfcc7a6c95d = ({ isOpen: isOpen, onClose: onClose, onSubmit: onSubmit, source: source })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const { displayName: displayName, userId: userId, cloudId: cloudId, edition: edition, environment: environment } = (0, $bQm3c.useSessionData)();
    const { spaceRoleMode: spaceRoleMode } = (0, $iquRY.useSpaceRoleMode)();
    const getFeedbackMetadata = ()=>{
        const feedbackMetadata = {
            userId: userId,
            cloudId: cloudId,
            edition: edition,
            environment: environment,
            source: source,
            spaceRoleMode: spaceRoleMode
        };
        return JSON.stringify(feedbackMetadata, null, 2);
    };
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2eX69.default), {
        onClose: onClose,
        onSubmit: onSubmit,
        entrypointId: $fe7fcc34e2e5b785$var$ENTRYPOINT_ID,
        locale: locale,
        name: displayName ?? '',
        atlassianAccountId: userId ?? undefined,
        showTypeField: false,
        feedbackTitle: formatMessage($fe7fcc34e2e5b785$var$i18n.feedbackTitle),
        feedbackTitleDetails: formatMessage($fe7fcc34e2e5b785$var$i18n.feedbackTitleDetails),
        additionalFields: [
            {
                id: $fe7fcc34e2e5b785$var$FEEDBACK_CONTEXT_ID,
                value: getFeedbackMetadata()
            }
        ]
    });
};
module.exports["SpaceRolesFeedbackCollector"] = $fe7fcc34e2e5b785$export$91e87cfcc7a6c95d;

});

parcelRegister("2eX69", function(module, exports) {

var $e9nC3 = parcelRequire("e9nC3");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $5BnIc = parcelRequire("5BnIc");


var $9C5oc = parcelRequire("9C5oc");


var $h45y6 = parcelRequire("h45y6");

const $a45798977a968ec1$var$MAX_SUMMARY_LENGTH_CHARS = 100;
const $a45798977a968ec1$var$singleLineTruncatedText = (text, length = $a45798977a968ec1$var$MAX_SUMMARY_LENGTH_CHARS)=>{
    const singleLineText = text.replace(/\n/g, ' ');
    return (0, $9C5oc.default)(singleLineText, length);
};
class $a45798977a968ec1$export$2e2bcd8739ae039 extends (0, $cozmU.Component) {
    async componentDidMount() {
        const anonymousFeedback = !await this.shouldShowOptInCheckboxesNew();
        this.setState({
            anonymousFeedback: anonymousFeedback
        });
    }
    getGatewayUrl() {
        const { customGatewayUrl: customGatewayUrl, url: url } = this.props;
        if (customGatewayUrl) return customGatewayUrl;
        if (url) return url;
        return $a45798977a968ec1$export$2e2bcd8739ae039.defaultProps.url;
    }
    getFeedbackUrl() {
        const { customFeedbackUrl: customFeedbackUrl, url: url } = this.props;
        if (customFeedbackUrl) return customFeedbackUrl;
        if (url) return url;
        return $a45798977a968ec1$export$2e2bcd8739ae039.defaultProps.url;
    }
    getPackageVersion() {
        return "0.0.0-use.local";
    }
    async getEntitlementInformation() {
        const url = this.getGatewayUrl();
        // jira / confluence / bitbucket / trello
        let productName;
        let productEntitlement;
        let entitlementDetails;
        let productKey;
        if (window.location.host.includes('bitbucket.org')) {
            productName = 'Bitbucket';
            productKey = 'bitbucket';
            entitlementDetails = JSON.parse(JSON.stringify(document.querySelector('meta[id="bb-bootstrap"]')?.getAttribute('data-current-user')));
            const hasPremium = entitlementDetails['hasPremium'];
            productEntitlement = hasPremium ? 'PREMIUM' : 'STANDARD';
        } else if ([
            'trellis.coffee',
            'trello.com'
        ].includes(window.location.host)) {
            productName = 'Trello';
            productKey = 'trello';
        } else {
            if (document.querySelector('meta[id="confluence-context-path"]')) {
                productName = 'Confluence';
                productKey = 'pricingplan.confluence.ondemand';
            } else {
                productName = 'Jira';
                productKey = 'jira-software.ondemand';
            }
            try {
                entitlementDetails = await fetch(`${url}/customer-context/entitlements/${window.location.host}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    ...(0, $5BnIc.isApiGatewayUrl)(url) ? {
                        credentials: 'include'
                    } : {}
                });
            } catch (e) {
                entitlementDetails = undefined;
            }
        }
        let entitlement;
        const entitlementInformation = [];
        const cloudSiteId = entitlementDetails?.cloudSiteId || '';
        if (entitlementDetails?.children) entitlement = entitlementDetails?.children.find((entitlement)=>{
            return entitlement.key === productKey;
        });
        entitlementInformation.push({
            id: 'product',
            value: productName ? productName?.toLowerCase() : ''
        }, {
            id: 'hostingType',
            value: entitlement?.product ? entitlement.product.hostingType : 'CLOUD'
        }, {
            id: 'entitlementEdition',
            value: productEntitlement ?? ''
        }, {
            id: 'cloudId',
            value: cloudSiteId
        });
        return entitlementInformation;
    }
    getTypeFieldValue(dtype) {
        switch(dtype){
            case 'bug':
                return this.props.typeBugDefaultValue;
            case 'comment':
                return this.props.typeCommentDefaultValue;
            case 'suggestion':
                return this.props.typeSuggestionDefaultValue;
            case 'question':
                return this.props.typeQuestionDefaultValue;
            case 'empty':
            default:
                return this.props.typeEmptyDefaultValue;
        }
    }
    async getAtlassianID() {
        const { atlassianAccountId: atlassianAccountId, shouldGetEntitlementDetails: shouldGetEntitlementDetails } = this.props;
        try {
            if (atlassianAccountId || !shouldGetEntitlementDetails) return atlassianAccountId;
            const url = this.getGatewayUrl();
            const result = await fetch(`${url}/me`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                ...(0, $5BnIc.isApiGatewayUrl)(url) ? {
                    credentials: 'include'
                } : {}
            });
            const json = await result.json();
            return json.account_id;
        } catch (e) {
            return undefined;
        }
    }
    shouldShowOptInCheckboxes() {
        if (this.props.anonymousFeedback) return !this.props.anonymousFeedback;
        if (this.props.atlassianAccountId) return true;
        let response;
        this.getAtlassianID().then((result)=>{
            response = result !== undefined;
        }).catch(()=>{
            response = false;
        });
        // @ts-ignore
        return response;
    }
    shouldShowOptInCheckboxesNew() {
        return new Promise((resolve)=>{
            if (this.props.anonymousFeedback) resolve(!this.props.anonymousFeedback);
            if (this.props.atlassianAccountId) resolve(true);
            this.getAtlassianID().then((result)=>{
                resolve(result !== undefined);
            }).catch(()=>{
                resolve(false);
            });
        });
    }
    getDescription(formValues) {
        return formValues.description || this.props.descriptionDefaultValue;
    }
    getSummary(formValues) {
        return $a45798977a968ec1$var$singleLineTruncatedText(formValues.description, this.props.summaryTruncateLength) || this.props.summaryDefaultValue;
    }
    getCustomerName() {
        return this.props.name ?? this.props.customerNameDefaultValue;
    }
    addEmailToContext() {
        const contextField = this.props.additionalFields.find((field)=>{
            return field.id === 'customfield_10047';
        });
        if (contextField) contextField.value = `${contextField.value}
        email: ${this.props.email}`;
        else this.props.additionalFields.push({
            id: 'customfield_10047',
            value: `email: ${this.props.email}`
        });
    }
    addAccountIdToContext(atlassianID) {
        if (atlassianID) {
            const contextField = this.props.additionalFields.find((field)=>{
                return field.id === 'customfield_10047';
            });
            if (contextField) contextField.value = `${contextField.value}
			atlassian-account-id: ${atlassianID}`;
        }
    }
    async mapFormToJSD(formValues) {
        let entitlementInformation = null;
        if (this.props?.shouldGetEntitlementDetails) entitlementInformation = await this.getEntitlementInformation();
        if (this.props?.email) this.addEmailToContext();
        const atlassianID = await this.getAtlassianID();
        this.addAccountIdToContext(atlassianID);
        return {
            fields: [
                ...entitlementInformation !== null && entitlementInformation || [],
                this.props.showTypeField ? {
                    id: this.props.typeFieldId,
                    value: this.getTypeFieldValue(formValues.type)
                } : undefined,
                {
                    id: this.props.summaryFieldId,
                    value: this.getSummary(formValues)
                },
                {
                    id: this.props.descriptionFieldId,
                    value: this.getDescription(formValues)
                },
                {
                    id: 'aaidOrHash',
                    value: formValues.canBeContacted ? atlassianID : undefined
                },
                {
                    id: this.props.customerNameFieldId,
                    value: this.getCustomerName()
                },
                formValues.canBeContacted ? {
                    id: this.props.canBeContactedFieldId,
                    value: this.props.canBeContactedAgreeValue
                } : {
                    id: this.props.canBeContactedFieldId,
                    value: this.props.canBeContactedDeclineValue
                },
                formValues.enrollInResearchGroup ? {
                    id: this.props.enrollInResearchFieldId,
                    value: this.props.enrollInResearchAgreeValue
                } : {
                    id: this.props.enrollInResearchFieldId,
                    value: this.props.enrollInResearchDeclineValue
                },
                ...this.props.additionalFields
            ].filter(Boolean)
        };
    }
    render() {
        const anonymousFeedback = !this.shouldShowOptInCheckboxes();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h45y6.default), {
            customContent: this.props.customContent,
            feedbackTitle: this.props.feedbackTitle,
            feedbackTitleDetails: this.props.feedbackTitleDetails,
            showTypeField: this.props.showTypeField,
            showDefaultTextFields: this.props.showDefaultTextFields,
            hasDescriptionDefaultValue: !!this.props.descriptionDefaultValue,
            canBeContactedLabel: this.props.canBeContactedLabel,
            enrolInResearchLabel: this.props.enrolInResearchLabel,
            summaryPlaceholder: this.props.summaryPlaceholder,
            submitButtonLabel: this.props.submitButtonLabel,
            cancelButtonLabel: this.props.cancelButtonLabel,
            feedbackGroupLabels: this.props.feedbackGroupLabels,
            onSubmit: this.postFeedback,
            onClose: this.props.onClose,
            onCancel: this.props.onCancel,
            locale: this.props.locale,
            anonymousFeedback: (0, $iDrrr.fg)('platform.proforma-form-builder-feedback_hupaz') ? this.state.anonymousFeedback : anonymousFeedback,
            selectLabel: this.props.selectLabel,
            customTextAreaLabel: this.props.customTextAreaLabel,
            customFeedbackOptions: this.props.customFeedbackOptions,
            shouldReturnFocusRef: this.props.shouldReturnFocusRef,
            dialogRef: this.props.dialogRef,
            disableSubmitButton: this.props.disableSubmitButton,
            ...(0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                enrolInResearchLink: this.props.enrolInResearchLink,
                canBeContactedLink: this.props.canBeContactedLink
            },
            showRequiredFieldsSummary: this.props.showRequiredFieldsSummary
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            anonymousFeedback: true
        };
        this.postFeedback = async (formValues)=>{
            const entrypointId = this.props.entrypointId;
            let fetchUrl = this.getFeedbackUrl();
            // Don't dispatch unless we have suitable props (allows tests to pass through empty strings and avoid redundant network calls)
            if (entrypointId) {
                const formData = await this.mapFormToJSD(formValues);
                const body = {
                    feedback: {
                        entrypointId: this.props.entrypointId,
                        entrypointUiVersion: this.getPackageVersion(),
                        ...formData
                    }
                };
                if ((0, $5BnIc.isApiGatewayUrl)(fetchUrl)) fetchUrl += '/feedback-collector-api';
                else if (!this.props.customFeedbackUrl) fetchUrl = 'https://feedback-collector-api.services.atlassian.com';
                const postData = (0, $e9nC3.Buffer).from(JSON.stringify(body)).toString('base64');
                fetch(`${fetchUrl}/v2/feedback`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        data: postData
                    }),
                    credentials: 'include'
                });
            }
            this.props.onClose();
            // slightly delay confirming submit since we don't wait for the REST call to succeed
            //
            // Because `onClose` is invoked prior to this timeout triggering, the `componentWillUnmount`
            // may occur before the `onSubmit` is called. To prevent prematurely cancelling the
            // network request, we deliberately don't clear this timeout inside `componentWillUnmount`.
            //
            setTimeout(()=>this.props.onSubmit(formValues), this.props.timeoutOnSubmit);
        };
    }
}
$a45798977a968ec1$export$2e2bcd8739ae039.defaultProps = {
    locale: 'en',
    url: '/gateway/api',
    shouldGetEntitlementDetails: true,
    canBeContactedFieldId: 'customfield_10043',
    canBeContactedAgreeValue: [
        {
            id: '10109'
        }
    ],
    canBeContactedDeclineValue: [
        {
            id: '10111'
        }
    ],
    additionalFields: [],
    customerNameFieldId: 'customfield_10045',
    customerNameDefaultValue: 'unknown',
    descriptionFieldId: 'description',
    descriptionDefaultValue: '',
    enrollInResearchFieldId: 'customfield_10044',
    enrollInResearchAgreeValue: [
        {
            id: '10110'
        }
    ],
    enrollInResearchDeclineValue: [
        {
            id: '10112'
        }
    ],
    summaryFieldId: 'summary',
    summaryDefaultValue: '',
    summaryTruncateLength: 100,
    timeoutOnSubmit: 700,
    typeFieldId: 'customfield_10042',
    typeBugDefaultValue: {
        id: '10105'
    },
    typeCommentDefaultValue: {
        id: '10106'
    },
    typeSuggestionDefaultValue: {
        id: '10107'
    },
    typeQuestionDefaultValue: {
        id: '10108'
    },
    typeEmptyDefaultValue: {
        id: 'empty'
    },
    showTypeField: true,
    showDefaultTextFields: true,
    anonymousFeedback: false,
    onClose: ()=>{},
    onSubmit: ()=>{}
};
module.exports["default"] = $a45798977a968ec1$export$2e2bcd8739ae039;

});

parcelRegister("5BnIc", function(module, exports) {
const $db292a71bf6452ef$export$f0f6fc934288a17c = (url)=>[
        '/gateway/api'
    ].includes(url);
module.exports["isApiGatewayUrl"] = $db292a71bf6452ef$export$f0f6fc934288a17c;

});

parcelRegister("9C5oc", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c5409c9e56ee67a$export$2e2bcd8739ae039);
function $0c5409c9e56ee67a$export$2e2bcd8739ae039(text, maxLength) {
    if (!text || !maxLength) return text;
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
}

});

parcelRegister("h45y6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $2uDbg = parcelRequire("2uDbg");


var $7BfeF = parcelRequire("7BfeF");


var $dUI0h = parcelRequire("dUI0h");


var $2Nu0e = parcelRequire("2Nu0e");


var $dTHYM = parcelRequire("dTHYM");


var $dQLwo = parcelRequire("dQLwo");


var $hpa99 = parcelRequire("hpa99");


var $i1t43 = parcelRequire("i1t43");


var $fEPJS = parcelRequire("fEPJS");


var $7aRdF = parcelRequire("7aRdF");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $iDrrr = parcelRequire("iDrrr");


var $1VhsF = parcelRequire("1VhsF");


var $6wGOF = parcelRequire("6wGOF");


var $e3Wrf = parcelRequire("e3Wrf");


var $5r21M = parcelRequire("5r21M");


var $hTUp6 = parcelRequire("hTUp6");

const $dcf72f8838f67ff8$var$LinkWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            paddingInlineStart: "var(--ds-space-300, 24px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginInlineStart: "var(--ds-space-050, 4px)"
        }
    }, children);
};
const $dcf72f8838f67ff8$var$FeedbackForm = ({ showTypeField: showTypeField = true, showDefaultTextFields: showDefaultTextFields = true, customContent: customContent, onClose: onClose, onCancel: onCancel, onSubmit: onSubmit, feedbackTitle: feedbackTitle, feedbackTitleDetails: feedbackTitleDetails, feedbackGroupLabels: feedbackGroupLabels, summaryPlaceholder: summaryPlaceholder, canBeContactedLabel: canBeContactedLabel, canBeContactedLink: canBeContactedLink, enrolInResearchLabel: enrolInResearchLabel, enrolInResearchLink: enrolInResearchLink, submitButtonLabel: submitButtonLabel, cancelButtonLabel: cancelButtonLabel, anonymousFeedback: anonymousFeedback, hasDescriptionDefaultValue: hasDescriptionDefaultValue, selectLabel: selectLabel, customTextAreaLabel: customTextAreaLabel, customFeedbackOptions: customFeedbackOptions = [], shouldReturnFocusRef: shouldReturnFocusRef, dialogRef: dialogRef, disableSubmitButton: disableSubmitButton, showRequiredFieldsSummary: showRequiredFieldsSummary = true })=>{
    const [canBeContacted, setCanBeContacted] = (0, $cozmU.useState)(false);
    const [description, setDescription] = (0, $cozmU.useState)('');
    const [enrollInResearchGroup, setEnrollInResearchGroup] = (0, $cozmU.useState)(false);
    const [type, setType] = (0, $cozmU.useState)('empty');
    const [isSubmitting, setIsSubmitting] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isTypeSelected = ()=>type !== 'empty';
    const validateType = (value)=>showTypeField && (!value || value === 'empty') ? formatMessage((0, $5r21M.messages).validationErrorTypeRequired) : undefined;
    const validateDescription = (value)=>{
        if (!showDefaultTextFields || hasDescriptionDefaultValue) return undefined;
        return !value || !value.trim() ? formatMessage((0, $5r21M.messages).validationErrorDescriptionRequired) : undefined;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleCancel = (...args)=>{
        onCancel?.(...args);
        // Forward every arg the click handler received so consumers retain the full
        // pre-change runtime contract (originating event + Atlaskit UI analytics event).
        onClose(...args);
    };
    const canShowTextField = isTypeSelected() || !showTypeField;
    const isDisabled = isSubmitting || disableSubmitButton;
    const getFieldLabels = (record)=>({
            bug: record?.bug?.fieldLabel || formatMessage((0, $5r21M.messages).formBugLabel),
            comment: record?.comment?.fieldLabel || formatMessage((0, $5r21M.messages).formCommentLabel),
            suggestion: record?.suggestion?.fieldLabel || formatMessage((0, $5r21M.messages).formSuggestionLabel),
            question: record?.question?.fieldLabel || formatMessage((0, $5r21M.messages).formQuestionLabel),
            empty: record?.empty?.fieldLabel || formatMessage((0, $5r21M.messages).formEmptyLabel),
            not_relevant: record?.not_relevant?.fieldLabel || formatMessage((0, $5r21M.messages).formNotRelevantLabel),
            not_accurate: record?.not_accurate?.fieldLabel || formatMessage((0, $5r21M.messages).formNotAccurateLabel),
            too_slow: record?.too_slow?.fieldLabel || formatMessage((0, $5r21M.messages).formTooSlowLabel),
            unhelpful_links: record?.unhelpful_links?.fieldLabel || formatMessage((0, $5r21M.messages).formUnhelpfulLinksLabel),
            other: record?.other?.fieldLabel || formatMessage((0, $5r21M.messages).formOtherLabel)
        });
    const getSelectOptions = (record)=>[
            {
                label: record?.question?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionQuestionLabel),
                value: 'question'
            },
            {
                label: record?.comment?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionCommentLabel),
                value: 'comment'
            },
            {
                label: record?.bug?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionBugLabel),
                value: 'bug'
            },
            {
                label: record?.suggestion?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionSuggestionLabel),
                value: 'suggestion'
            }
        ];
    const getDefaultPlaceholder = (record)=>record?.empty?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionDefaultPlaceholder);
    const focusRef = (0, $cozmU.useRef)();
    const selectOptions = customFeedbackOptions.length > 0 ? customFeedbackOptions : getSelectOptions(feedbackGroupLabels);
    const renderContactLabelAppify = ()=>{
        if ((0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, $5r21M.messages).canBeContactedLabelAppifyWithResponseWithoutLink;
        return (0, $5r21M.messages).canBeContactedLabelAppifyWithResponse;
    };
    const renderContactLabel = ()=>{
        if ((0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, $5r21M.messages).canBeContactedLabelWithResponseWithoutLink;
        return (0, $5r21M.messages).canBeContactedLabelWithResponse;
    };
    const requiredFieldsSummary = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("p", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: "var(--ds-text-subtle, #505258)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: "var(--ds-space-300, 24px)"
        }
    }, formatMessage((0, $5r21M.messages).requiredFieldsSummary), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpa99.RequiredAsterisk), null));
    const feedbackIsAnonymous = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("p", null, formatMessage((0, $5r21M.messages).feedbackIsAnonymous));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        ref: dialogRef,
        shouldCloseOnOverlayClick: false,
        onClose: onClose,
        testId: "feedbackCollectorModalDialog",
        shouldReturnFocus: shouldReturnFocusRef,
        shouldScrollInViewport: true
    }, (0, $iDrrr.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: async ()=>{
            setIsSubmitting(true);
            try {
                await onSubmit({
                    canBeContacted: canBeContacted,
                    description: description,
                    enrollInResearchGroup: enrollInResearchGroup,
                    type: type
                });
            } finally{
                setIsSubmitting(false);
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, feedbackTitle || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).feedbackTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, (0, $iDrrr.fg)('ak_feedback_collector_hide_required_summary') ? showRequiredFieldsSummary && requiredFieldsSummary : requiredFieldsSummary, feedbackTitleDetails, customContent, showTypeField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "topic",
        id: "topic",
        label: selectLabel || formatMessage((0, $5r21M.messages).selectionOptionDefaultLabel),
        isRequired: true,
        validate: validateType
    }, ({ fieldProps: { id: id, ...restProps }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
            ...restProps,
            value: selectOptions.find((opt)=>opt.value === type) ?? null,
            onChange: (option)=>{
                if (!option || option instanceof Array) return;
                setType(option.value);
                restProps.onChange?.(option.value);
            },
            menuPosition: "fixed",
            options: selectOptions,
            shouldPreventEscapePropagation: true,
            // @ts-ignore
            ref: focusRef,
            placeholder: getDefaultPlaceholder(feedbackGroupLabels),
            inputId: id,
            isInvalid: !!error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error)))) : null, showDefaultTextFields && canShowTextField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage((0, $5r21M.messages).defaultCustomTextAreaLabel),
        isRequired: true,
        name: "description",
        id: "description",
        validate: validateDescription
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
            ...fieldProps,
            name: "foo",
            minimumRows: 6,
            placeholder: summaryPlaceholder || undefined,
            onChange: (e)=>{
                setDescription(e.target.value);
                fieldProps.onChange(e.target.value);
            },
            value: description
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error)))), !anonymousFeedback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Nu0e.Fieldset), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("legend", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).optInOptionsLegend)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "can-be-contacted"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            ...fieldProps,
            "aria-describedby": undefined,
            label: canBeContactedLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...(0, $iDrrr.fg)('product-terminology-refresh') ? renderContactLabelAppify() : renderContactLabel(),
                ...!(0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                    values: {
                        a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                                href: "https://www.atlassian.com/legal/privacy-policy",
                                target: "_blank"
                            }, chunks)
                    }
                }
            }),
            onChange: (event)=>setCanBeContacted(event.target.checked)
        }), canBeContactedLabel && canBeContactedLink && (0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, canBeContactedLink), !canBeContactedLabel && (0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: "https://www.atlassian.com/legal/privacy-policy",
            target: "_blank"
        }, formatMessage((0, $5r21M.messages).privacyPolicy))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "enroll-in-research-group"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            ...fieldProps,
            "aria-describedby": undefined,
            label: enrolInResearchLabel || formatMessage((0, $5r21M.messages).enrolInResearchLabel),
            onChange: (event)=>setEnrollInResearchGroup(event.target.checked)
        }), enrolInResearchLabel && enrolInResearchLink && (0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, enrolInResearchLink)))) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: 'anonymousFeedback'
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
            title: formatMessage((0, $5r21M.messages).feedbackIsAnonymousTitle),
            appearance: 'information'
        }, feedbackIsAnonymous))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        onClick: handleCancel
    }, cancelButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).cancelButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "primary",
        type: "submit",
        isDisabled: isSubmitting || isDisabled,
        testId: "feedbackCollectorSubmitBtn"
    }, submitButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).submitButtonLabel)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: async ()=>{
            setIsSubmitting(true);
            try {
                await onSubmit({
                    canBeContacted: canBeContacted,
                    description: description,
                    enrollInResearchGroup: enrollInResearchGroup,
                    type: type
                });
            } finally{
                setIsSubmitting(false);
            }
        }
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, feedbackTitle || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).feedbackTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, (0, $iDrrr.fg)('ak_feedback_collector_hide_required_summary') ? showRequiredFieldsSummary && requiredFieldsSummary : requiredFieldsSummary, feedbackTitleDetails, customContent, showTypeField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "topic",
            id: "topic",
            label: selectLabel || formatMessage((0, $5r21M.messages).selectionOptionDefaultLabel),
            isRequired: true,
            validate: validateType
        }, ({ fieldProps: { id: id, ...restProps }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
                ...restProps,
                value: selectOptions.find((opt)=>opt.value === type) ?? null,
                onChange: (option)=>{
                    if (!option || option instanceof Array) return;
                    setType(option.value);
                    restProps.onChange?.(option.value);
                },
                menuPosition: "fixed",
                options: selectOptions,
                shouldPreventEscapePropagation: true,
                // @ts-ignore
                ref: focusRef,
                placeholder: getDefaultPlaceholder(feedbackGroupLabels),
                inputId: id,
                isInvalid: !!error
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error)))) : null, showDefaultTextFields && canShowTextField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage((0, $5r21M.messages).defaultCustomTextAreaLabel),
            isRequired: true,
            name: "description",
            id: "description",
            validate: validateDescription
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
                ...fieldProps,
                name: "foo",
                minimumRows: 6,
                placeholder: summaryPlaceholder || undefined,
                onChange: (e)=>{
                    setDescription(e.target.value);
                    fieldProps.onChange(e.target.value);
                },
                value: description
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error)))), !anonymousFeedback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Nu0e.Fieldset), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("legend", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).optInOptionsLegend)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "can-be-contacted"
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
                ...fieldProps,
                "aria-describedby": undefined,
                label: canBeContactedLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $iDrrr.fg)('product-terminology-refresh') ? renderContactLabelAppify() : renderContactLabel(),
                    ...!(0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                        values: {
                            a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                                    href: "https://www.atlassian.com/legal/privacy-policy",
                                    target: "_blank"
                                }, chunks)
                        }
                    }
                }),
                onChange: (event)=>setCanBeContacted(event.target.checked)
            }), canBeContactedLabel && canBeContactedLink && (0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, canBeContactedLink), !canBeContactedLabel && (0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                href: "https://www.atlassian.com/legal/privacy-policy",
                target: "_blank"
            }, formatMessage((0, $5r21M.messages).privacyPolicy))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "enroll-in-research-group"
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
                ...fieldProps,
                "aria-describedby": undefined,
                label: enrolInResearchLabel || formatMessage((0, $5r21M.messages).enrolInResearchLabel),
                onChange: (event)=>setEnrollInResearchGroup(event.target.checked)
            }), enrolInResearchLabel && enrolInResearchLink && (0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, enrolInResearchLink)))) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: 'anonymousFeedback'
        }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
                title: formatMessage((0, $5r21M.messages).feedbackIsAnonymousTitle),
                appearance: 'information'
            }, feedbackIsAnonymous))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: "subtle",
            onClick: handleCancel
        }, cancelButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).cancelButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: "primary",
            type: "submit",
            isDisabled: isSubmitting || isDisabled,
            testId: "feedbackCollectorSubmitBtn"
        }, submitButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).submitButtonLabel))))));
};
const $dcf72f8838f67ff8$var$FeedbackFormWithIntl = ({ locale: locale, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hTUp6.IntlProviderWithResolvedMessages), {
        locale: locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$FeedbackForm, props));
};
var $dcf72f8838f67ff8$export$2e2bcd8739ae039 = $dcf72f8838f67ff8$var$FeedbackFormWithIntl;
module.exports["default"] = $dcf72f8838f67ff8$export$2e2bcd8739ae039;

});

parcelRegister("e3Wrf", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $cozmU = parcelRequire("cozmU");


var $7r5Hr = parcelRequire("7r5Hr");


var $iDrrr = parcelRequire("iDrrr");

const $f7ddda300dd34381$var$packageName = "platform-pkg";
const $f7ddda300dd34381$var$packageVersion = "0.0.0-use.local";
const $f7ddda300dd34381$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $f7ddda300dd34381$var$packageName,
    packageVersion: $f7ddda300dd34381$var$packageVersion
};
const $f7ddda300dd34381$var$lineHeightBase = 20;
const $f7ddda300dd34381$var$lineHeightCompact = 16;
const $f7ddda300dd34381$var$compactVerticalPadding = 2;
const $f7ddda300dd34381$var$verticalPadding = 6;
const $f7ddda300dd34381$var$transitionDuration = '0.2s';
const $f7ddda300dd34381$var$borderWidth = 2;
const $f7ddda300dd34381$var$baseStyles = null;
const $f7ddda300dd34381$var$finessePlaceholderStyles = null;
const $f7ddda300dd34381$var$appearanceStyles = {
    standard: "_3hxITi6wH8 _1mHXSFHKt7 _3OEoix7Cj1 _39nh0ghQC5 _2jpXBkVrZW _31SgFAHKt7 _2zr3nGqWX3 _3LfWyLFQfX _2vsVfZFQfX _2DQpWtXJux _0SosFGXJux _1CDq3qgVvo _2FTXAcgVvo _0tVs2sXJux _3JVwBfXJux _0xkEdpnXvL _1iy5hxutHW _0ui43CPhRM _2UNgvCnXvL _1LO7QkVrZW",
    subtle: "_3hxITi6wH8 _1mHXSFjOvk _3OEoixjOvk _31SgFAHKt7 _2zr3nGqWX3 _3LfWyLFQfX _2vsVfZFQfX _2DQpWtXJux _0SosFGXJux _1CDq3qgVvo _2FTXAcgVvo _3JVwBfXJux _0tVs2sXJux _0xkEdpnXvL _1iy5hxutHW _0ui43CPhRM",
    none: "_3hxITiYbGa _1mHXSFjOvk _3OEoixjOvk _31SgFAjOvk _2zr3nGjOvk _3LfWyLFQfX _0SosFGgVvo _2vsVfZFQfX _2DQpWtgVvo _1CDq3qgVvo _3JVwBfgVvo _2FTXAcgVvo _0tVs2sgVvo _0xkEdpjOvk _1iy5hxjOvk _0ui43Cw5zn"
}; // iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on touch devices with small viewports, the textarea uses font.body (default),
// and font.body.large (16px) for touch devices (pointer: coarse) with screens narrower than 30rem.
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $f7ddda300dd34381$var$fontStyles = {
    default: "_2sNsIgmnOE _1gitD220Hp",
    monospace: "_2sNsIgmnOE _0WKd3Gfx9v _1gitD220Hp _3n0EfXdh5F"
};
const $f7ddda300dd34381$var$resizeStyles = {
    horizontal: "_2HIj7GD4qA",
    vertical: "_2HIj7GbI28",
    auto: "_2HIj7GZSoF",
    smart: "_2HIj7GYbGa",
    none: "_2HIj7GYbGa"
};
const $f7ddda300dd34381$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $f7ddda300dd34381$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $f7ddda300dd34381$var$InnerTextArea = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(63);
    const ourRef = (0, $cozmU.useRef)(null);
    let onBlur;
    let onChange;
    let onFocus;
    let rest;
    let style;
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    let testId;
    let value;
    if ($[0] !== props) {
        ({ resize: t0, appearance: t1, isCompact: t2, isRequired: t3, isReadOnly: t4, isDisabled: t5, isInvalid: t6, isMonospaced: t7, minimumRows: t8, testId: testId, maxHeight: t9, onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props);
        $[0] = props;
        $[1] = onBlur;
        $[2] = onChange;
        $[3] = onFocus;
        $[4] = rest;
        $[5] = style;
        $[6] = t0;
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
        $[14] = t8;
        $[15] = t9;
        $[16] = testId;
        $[17] = value;
    } else {
        onBlur = $[1];
        onChange = $[2];
        onFocus = $[3];
        rest = $[4];
        style = $[5];
        t0 = $[6];
        t1 = $[7];
        t2 = $[8];
        t3 = $[9];
        t4 = $[10];
        t5 = $[11];
        t6 = $[12];
        t7 = $[13];
        t8 = $[14];
        t9 = $[15];
        testId = $[16];
        value = $[17];
    }
    const resize = t0 === undefined ? "smart" : t0;
    const appearance = t1 === undefined ? "standard" : t1;
    const isCompact = t2 === undefined ? false : t2;
    const isRequired = t3 === undefined ? false : t3;
    const isReadOnly = t4 === undefined ? false : t4;
    const isDisabled = t5 === undefined ? false : t5;
    const isInvalid = t6 === undefined ? false : t6;
    const isMonospaced = t7 === undefined ? false : t7;
    const minimumRows = t8 === undefined ? 2 : t8;
    const maxHeight = t9 === undefined ? "50vh" : t9;
    const borderHeight = appearance === "none" ? 2 : 1;
    let t10;
    if ($[18] !== resize) {
        t10 = ()=>{
            const el = ourRef.current;
            if (resize === "smart" && el) $f7ddda300dd34381$var$setSmartHeight(el);
        };
        $[18] = resize;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== resize || $[21] !== value) {
        t11 = [
            resize,
            value
        ];
        $[20] = resize;
        $[21] = value;
        $[22] = t11;
    } else t11 = $[22];
    (0, $cozmU.useEffect)(t10, t11);
    let t12;
    if ($[23] !== onBlur) {
        t12 = {
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: "blurred",
            ...$f7ddda300dd34381$var$analyticsParams
        };
        $[23] = onBlur;
        $[24] = t12;
    } else t12 = $[24];
    const onBlurWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t12);
    let t13;
    if ($[25] !== onFocus) {
        t13 = {
            fn: (event_0)=>{
                onFocus && onFocus(event_0);
            },
            action: "focused",
            ...$f7ddda300dd34381$var$analyticsParams
        };
        $[25] = onFocus;
        $[26] = t13;
    } else t13 = $[26];
    const onFocusWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t13);
    let t14;
    if ($[27] !== ref) {
        t14 = (elementRef)=>{
            ourRef.current = elementRef;
            if (ref && typeof ref === "object") ref.current = elementRef;
            if (ref && typeof ref === "function") ref(elementRef);
        };
        $[27] = ref;
        $[28] = t14;
    } else t14 = $[28];
    const getTextAreaRef = t14;
    let t15;
    if ($[29] !== onChange || $[30] !== resize) {
        t15 = (e)=>{
            const el_0 = ourRef.current;
            if (resize === "smart" && el_0) $f7ddda300dd34381$var$setSmartHeight(el_0);
            onChange && onChange(e);
        };
        $[29] = onChange;
        $[30] = resize;
        $[31] = t15;
    } else t15 = $[31];
    const handleOnChange = t15;
    const t16 = isInvalid ? isInvalid : undefined;
    const t17 = isCompact ? isCompact : undefined;
    const t18 = testId ? testId : undefined;
    let t19;
    if ($[32] !== t16 || $[33] !== t17 || $[34] !== t18) {
        t19 = {
            "data-invalid": t16,
            "data-compact": t17,
            "data-testid": t18
        };
        $[32] = t16;
        $[33] = t17;
        $[34] = t18;
        $[35] = t19;
    } else t19 = $[35];
    const controlProps = t19;
    let t20;
    if ($[36] !== appearance || $[37] !== isMonospaced || $[38] !== resize) {
        t20 = (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _0bjKvDKTcp _2sNsIgmnOE _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAIZbP _2WAcuGIZbP _23rrnH5Vpu _2V7sgONvrM _3iDTPbvLZJ _24h04i2Njc _39xV02N91d _4ouGXIdnbC _1EqgXlN91d _1mT5xdRAKS _1UtDYzy7kJ _1T2N03wPeg _2IasYonod9 _03v5H87Cj1 _32yk65FKgL _24bGaTot27 _02aXbKsyl5 _0OS5PY7dHp _1kg4OzZqHV _3tCyJvYbGa _2DoaPjYbGa _3pNDujnod9 _1cY5OfqWX3 _0sBZ7MFKgL _30pU6CVrZW _3AxjleKGUX _3MV4MUot27 _1yFQeXQWvZ _3TNCtG1AUN _3OInhJnXvL _1xHRfPutHW _4skx3vPhRM",
            (0, $iDrrr.fg)("platform-dst-tokens-finesse") && "_3AxjleZpcK",
            $f7ddda300dd34381$var$appearanceStyles[appearance],
            $f7ddda300dd34381$var$fontStyles[isMonospaced ? "monospace" : "default"],
            $f7ddda300dd34381$var$resizeStyles[resize],
            "_22P5CgPgdP _2Ombu6q5bj"
        ]);
        $[36] = appearance;
        $[37] = isMonospaced;
        $[38] = resize;
        $[39] = t20;
    } else t20 = $[39];
    const t21 = $f7ddda300dd34381$var$lineHeightCompact * minimumRows + $f7ddda300dd34381$var$compactVerticalPadding * 2 + borderHeight * 2;
    let t22;
    if ($[40] !== t21) {
        t22 = (0, $9aYkv.default)(t21, "px");
        $[40] = t21;
        $[41] = t22;
    } else t22 = $[41];
    const t23 = $f7ddda300dd34381$var$lineHeightBase * minimumRows + $f7ddda300dd34381$var$verticalPadding * 2 + borderHeight * 2;
    let t24;
    if ($[42] !== t23) {
        t24 = (0, $9aYkv.default)(t23, "px");
        $[42] = t23;
        $[43] = t24;
    } else t24 = $[43];
    let t25;
    if ($[44] !== maxHeight || $[45] !== style || $[46] !== t22 || $[47] !== t24) {
        t25 = {
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": t22,
            "--_eorxnz": t24
        };
        $[44] = maxHeight;
        $[45] = style;
        $[46] = t22;
        $[47] = t24;
        $[48] = t25;
    } else t25 = $[48];
    let t26;
    if ($[49] !== controlProps || $[50] !== getTextAreaRef || $[51] !== handleOnChange || $[52] !== isDisabled || $[53] !== isReadOnly || $[54] !== isRequired || $[55] !== minimumRows || $[56] !== onBlurWithAnalytics || $[57] !== onFocusWithAnalytics || $[58] !== rest || $[59] !== t20 || $[60] !== t25 || $[61] !== value) {
        t26 = /*#__PURE__*/ (0, $8aG6j.jsx)("textarea", {
            ...controlProps,
            value: value,
            disabled: isDisabled,
            readOnly: isReadOnly,
            required: isRequired,
            ref: getTextAreaRef,
            onChange: handleOnChange,
            onBlur: onBlurWithAnalytics,
            onFocus: onFocusWithAnalytics,
            rows: minimumRows,
            ...rest,
            className: t20,
            style: t25
        });
        $[49] = controlProps;
        $[50] = getTextAreaRef;
        $[51] = handleOnChange;
        $[52] = isDisabled;
        $[53] = isReadOnly;
        $[54] = isRequired;
        $[55] = minimumRows;
        $[56] = onBlurWithAnalytics;
        $[57] = onFocusWithAnalytics;
        $[58] = rest;
        $[59] = t20;
        $[60] = t25;
        $[61] = value;
        $[62] = t26;
    } else t26 = $[62];
    return t26;
} : (props, ref)=>{
    const ourRef = (0, $cozmU.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $cozmU.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $cozmU.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $f7ddda300dd34381$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$f7ddda300dd34381$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (event_0)=>{
            onFocus && onFocus(event_0);
        },
        action: 'focused',
        ...$f7ddda300dd34381$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $cozmU.useCallback)((e)=>{
        const el_0 = ourRef.current;
        if (resize === 'smart' && el_0) $f7ddda300dd34381$var$setSmartHeight(el_0);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _0bjKvDKTcp _2sNsIgmnOE _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAIZbP _2WAcuGIZbP _23rrnH5Vpu _2V7sgONvrM _3iDTPbvLZJ _24h04i2Njc _39xV02N91d _4ouGXIdnbC _1EqgXlN91d _1mT5xdRAKS _1UtDYzy7kJ _1T2N03wPeg _2IasYonod9 _03v5H87Cj1 _32yk65FKgL _24bGaTot27 _02aXbKsyl5 _0OS5PY7dHp _1kg4OzZqHV _3tCyJvYbGa _2DoaPjYbGa _3pNDujnod9 _1cY5OfqWX3 _0sBZ7MFKgL _30pU6CVrZW _3AxjleKGUX _3MV4MUot27 _1yFQeXQWvZ _3TNCtG1AUN _3OInhJnXvL _1xHRfPutHW _4skx3vPhRM",
            (0, $iDrrr.fg)('platform-dst-tokens-finesse') && "_3AxjleZpcK",
            $f7ddda300dd34381$var$appearanceStyles[appearance],
            $f7ddda300dd34381$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $f7ddda300dd34381$var$resizeStyles[resize],
            "_22P5CgPgdP _2Ombu6q5bj"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $9aYkv.default)($f7ddda300dd34381$var$lineHeightCompact * minimumRows + $f7ddda300dd34381$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $9aYkv.default)($f7ddda300dd34381$var$lineHeightBase * minimumRows + $f7ddda300dd34381$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $f7ddda300dd34381$var$TextArea = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)($f7ddda300dd34381$var$InnerTextArea, {
            ref: ref,
            ...props
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, $8aG6j.jsx)($f7ddda300dd34381$var$InnerTextArea, {
        ref: ref,
        ...props
    })));
$f7ddda300dd34381$var$TextArea.displayName = 'TextArea';
var $f7ddda300dd34381$export$2e2bcd8739ae039 = $f7ddda300dd34381$var$TextArea;
module.exports["default"] = $f7ddda300dd34381$export$2e2bcd8739ae039;

});

parcelRegister("5r21M", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $0eef762dd50d9f91$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    feedbackTitle: {
        id: "feedback-collector.feedback-title",
        defaultMessage: "Share your thoughts"
    },
    enrolInResearchLabel: {
        id: "feedback-collector.enrol-in-research.label",
        defaultMessage: "I'd like to participate in product research"
    },
    canBeContactedLabelWithResponse: {
        id: "feedback-collector.can-be-contacted.label-with-response",
        defaultMessage: "Yes, Atlassian teams can reply to my feedback and ask for more details about my experience to improve Atlassian products and services. Without this, I won't get a response. I acknowledge the <a>Atlassian Privacy Policy</a>."
    },
    canBeContactedLabelWithResponseWithoutLink: {
        id: "feedback-collector.can-be-contacted.label-with-response-without-link",
        defaultMessage: "Yes, Atlassian teams can reply to my feedback and ask for more details about my experience to improve Atlassian products and services. Without this, I won't get a response. I acknowledge the Atlassian Privacy Policy."
    },
    privacyPolicy: {
        id: "feedback-collector.privacy-policy",
        defaultMessage: "Atlassian Privacy Policy"
    },
    summaryPlaceholder: {
        id: "feedback-collector.summary-placeholder",
        defaultMessage: "Let us know what's on your mind"
    },
    formCommentLabel: {
        id: "feedback-collector.form.comment.label",
        defaultMessage: "Let us know what's on your mind"
    },
    submitButtonLabel: {
        id: "feedback-collector.submit-button.label",
        defaultMessage: "Send feedback"
    },
    cancelButtonLabel: {
        id: "feedback-collector.cancel-button.label",
        defaultMessage: "Cancel"
    },
    giveFeedback: {
        id: "proforma-form-builder.give-feedback",
        defaultMessage: "Give feedback"
    },
    formBugLabel: {
        id: "feedback-collector.form.bug.label",
        defaultMessage: "Describe the bug or issue"
    },
    formSuggestionLabel: {
        id: "feedback-collector.form.suggestion.label",
        defaultMessage: "Let us know what you'd like to improve"
    },
    formQuestionLabel: {
        id: "feedback-collector.form.question.label",
        defaultMessage: "What would you like to know?"
    },
    formEmptyLabel: {
        id: "feedback-collector.form.empty.label",
        defaultMessage: "Select an option"
    },
    formNotRelevantLabel: {
        id: "feedback-collector.form.not-relevant.label",
        defaultMessage: "Wasn't relevant"
    },
    formNotAccurateLabel: {
        id: "feedback-collector.form.not-accurate.label",
        defaultMessage: "Wasn't accurate"
    },
    formTooSlowLabel: {
        id: "feedback-collector.form.too-slow.label",
        defaultMessage: "Too slow"
    },
    formUnhelpfulLinksLabel: {
        id: "feedback-collector.form.unhelpful-links.label",
        defaultMessage: "Unhelpful links"
    },
    formOtherLabel: {
        id: "feedback-collector.form.other.label",
        defaultMessage: "Other"
    },
    selectionOptionQuestionLabel: {
        id: "feedback-collector.option.question.label",
        defaultMessage: "Ask a question"
    },
    selectionOptionCommentLabel: {
        id: "feedback-collector.option.comment.label",
        defaultMessage: "Leave a comment"
    },
    selectionOptionBugLabel: {
        id: "feedback-collector.option.bug.label",
        defaultMessage: "Report a bug"
    },
    selectionOptionSuggestionLabel: {
        id: "feedback-collector.option.suggestion.label",
        defaultMessage: "Suggest an improvement"
    },
    selectionOptionDefaultLabel: {
        id: "feedback-collector.option.default.label",
        defaultMessage: "Select feedback"
    },
    selectionOptionDefaultPlaceholder: {
        id: "feedback-collector.option.default.placeholder",
        defaultMessage: "Choose one"
    },
    feedbackIconLabel: {
        id: "proforma-form-builder.feedback-icon-label",
        defaultMessage: "Feedback"
    },
    feedbackSuccessFlagDescription: {
        id: "feedback-collector.success-flag.description",
        defaultMessage: "Your valuable feedback helps us continually improve our products."
    },
    feedbackSuccessFlagTitle: {
        id: "feedback-collector.success-flag.title",
        defaultMessage: "Thanks!"
    },
    feedbackIsAnonymousTitle: {
        id: "feedback-collector.anonymous.title",
        defaultMessage: "Anonymous feedback"
    },
    feedbackIsAnonymous: {
        id: "feedback-collector.anonymous",
        defaultMessage: "This feedback is being submitted anonymously. Atlassian will not be able to contact you directly regarding this feedback"
    },
    requiredFieldsSummary: {
        id: "feedback-collector.required.fields.summary",
        defaultMessage: "Required fields are marked with an asterisk"
    },
    defaultCustomTextAreaLabel: {
        id: "feedback-collector.default.custom.textarea.label",
        defaultMessage: "What's on your mind?"
    },
    canBeContactedLabelAppifyWithResponse: {
        id: "feedback-collector.can-be-contacted.label-appify-with-response",
        defaultMessage: "Yes, Atlassian teams can reply to my feedback and ask for more details about my experience to improve Atlassian apps and services. Without this, I won't get a response. I acknowledge the <a>Atlassian Privacy Policy</a>."
    },
    canBeContactedLabelAppifyWithResponseWithoutLink: {
        id: "feedback-collector.can-be-contacted.label-appify-with-response-without-link",
        defaultMessage: "Yes, Atlassian teams can reply to my feedback and ask for more details about my experience to improve Atlassian apps and services. Without this, I won't get a response. I acknowledge the Atlassian Privacy Policy."
    },
    feedbackSuccessFlagDescriptionAppify: {
        id: "feedback-collector.success-flag.description-appify",
        defaultMessage: "Your valuable feedback helps us continually improve our apps."
    },
    validationErrorTypeRequired: {
        id: "feedback-collector.validation.type.required",
        defaultMessage: "Please select a feedback type"
    },
    validationErrorDescriptionRequired: {
        id: "feedback-collector.validation.description.required",
        defaultMessage: "Please provide a description"
    },
    optInOptionsLegend: {
        id: "feedback-collector.opt-in.options.legend",
        defaultMessage: "Atlassian opt-in options"
    }
});
module.exports["messages"] = $0eef762dd50d9f91$export$defe85febe8b728c;

});

parcelRegister("hTUp6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $b2A1s = parcelRequire("b2A1s");

const $fb8b4f9502ba72fc$export$f793de1293176fe6 = ({ children: children, locale: locale })=>{
    const [resolvedMessagesForLocale, setResolvedMessagesForLocale] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        const fetchMessageLocale = async ()=>{
            if (locale) {
                const messages = await (0, $b2A1s.getMessagesForLocale)(locale);
                setResolvedMessagesForLocale(messages);
            }
        };
        fetchMessageLocale();
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: locale || 'en',
        defaultLocale: "en",
        messages: resolvedMessagesForLocale
    }, children);
};
module.exports["IntlProviderWithResolvedMessages"] = $fb8b4f9502ba72fc$export$f793de1293176fe6;

});

parcelRegister("b2A1s", function(module, exports) {
const $e1a3f1d7e16f1235$var$isNestedMessagesModule = (value)=>'default' in value && typeof value.default === 'object' && value.default !== null;
const $e1a3f1d7e16f1235$var$unwrapMessages = (messages)=>{
    const defaultExport = messages.default;
    return $e1a3f1d7e16f1235$var$isNestedMessagesModule(defaultExport) ? defaultExport.default : defaultExport;
};





























const $e1a3f1d7e16f1235$var$messagesLoaders = {
    cs: ()=>(parcelRequire("gR4U1")),
    da: ()=>(parcelRequire("f1jrk")),
    de: ()=>(parcelRequire("aOLRB")),
    en: ()=>(parcelRequire("6kEFl")),
    en_GB: ()=>(parcelRequire("bjsxN")),
    en_ZZ: ()=>(parcelRequire("9DhD6")),
    es: ()=>(parcelRequire("ddpWy")),
    fi: ()=>(parcelRequire("5XvgX")),
    fr: ()=>(parcelRequire("cZf5E")),
    hr: ()=>(parcelRequire("CsODP")),
    hu: ()=>(parcelRequire("hPRyr")),
    it: ()=>(parcelRequire("z7zpe")),
    ja: ()=>(parcelRequire("8pzcT")),
    ko: ()=>(parcelRequire("1I2b8")),
    nb: ()=>(parcelRequire("gPBz3")),
    nl: ()=>(parcelRequire("78iTh")),
    pl: ()=>(parcelRequire("gHYE1")),
    pt_BR: ()=>(parcelRequire("9qN1z")),
    ru: ()=>(parcelRequire("dNwJi")),
    sl: ()=>(parcelRequire("fXweJ")),
    sr_RS: ()=>(parcelRequire("nFTVL")),
    sr_YR: ()=>(parcelRequire("bsw4B")),
    sv: ()=>(parcelRequire("97qPc")),
    th: ()=>(parcelRequire("bZmWu")),
    tr: ()=>(parcelRequire("aspSd")),
    uk: ()=>(parcelRequire("kWvvj")),
    vi: ()=>(parcelRequire("c5Sph")),
    zh: ()=>(parcelRequire("ecWO0")),
    zh_TW: ()=>(parcelRequire("dpkEO"))
};
const $e1a3f1d7e16f1235$var$getMessages = async (locale)=>{
    const loadMessages = $e1a3f1d7e16f1235$var$messagesLoaders[locale];
    if (!loadMessages) return undefined;
    try {
        const messages = await loadMessages();
        return $e1a3f1d7e16f1235$var$unwrapMessages(messages);
    } catch  {
        return undefined;
    }
};
const $e1a3f1d7e16f1235$export$d0a3169680473b6c = async (locale)=>{
    const localeKey = locale.replace('-', '_');
    const messages = await $e1a3f1d7e16f1235$var$getMessages(localeKey);
    return messages ?? $e1a3f1d7e16f1235$var$getMessages(localeKey.split(/[-_]/)[0]);
};
module.exports["getMessagesForLocale"] = $e1a3f1d7e16f1235$export$d0a3169680473b6c;

});

parcelRegister("gR4U1", function(module, exports) {

let $c455661dc243c654$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c455661dc243c654$var$load("iGnEn").then(()=>parcelRequire('6S4lG'));

});

parcelRegister("f1jrk", function(module, exports) {

let $aef60752586d2f07$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aef60752586d2f07$var$load("81CwI").then(()=>parcelRequire('9Q7ky'));

});

parcelRegister("aOLRB", function(module, exports) {

let $7e03b39534ef9cf9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7e03b39534ef9cf9$var$load("coMdg").then(()=>parcelRequire('4ELWT'));

});

parcelRegister("6kEFl", function(module, exports) {

let $49c427b32ae5dc71$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $49c427b32ae5dc71$var$load("4t3GG").then(()=>parcelRequire('aPmYJ'));

});

parcelRegister("bjsxN", function(module, exports) {

let $83c79c54c6feadd2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $83c79c54c6feadd2$var$load("lJDHR").then(()=>parcelRequire('fYO3Z'));

});

parcelRegister("9DhD6", function(module, exports) {

let $70356e70b5fecfa6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $70356e70b5fecfa6$var$load("izI99").then(()=>parcelRequire('fcttw'));

});

parcelRegister("ddpWy", function(module, exports) {

let $99f09d110267a62d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $99f09d110267a62d$var$load("3LmH0").then(()=>parcelRequire('iTEZG'));

});

parcelRegister("5XvgX", function(module, exports) {

let $456ab880bb5ad2de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $456ab880bb5ad2de$var$load("9nUzh").then(()=>parcelRequire('jCyLN'));

});

parcelRegister("cZf5E", function(module, exports) {

let $9746e31b2d06b6ef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9746e31b2d06b6ef$var$load("b0H0M").then(()=>parcelRequire('sjYCD'));

});

parcelRegister("CsODP", function(module, exports) {

let $0739e6f0f7a8ce09$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0739e6f0f7a8ce09$var$load("rlX60").then(()=>parcelRequire('kdtG9'));

});

parcelRegister("hPRyr", function(module, exports) {

let $cfc0bde35e1c9468$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cfc0bde35e1c9468$var$load("8XGfa").then(()=>parcelRequire('9cMV0'));

});

parcelRegister("z7zpe", function(module, exports) {

let $0699244176860d72$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0699244176860d72$var$load("kX4YP").then(()=>parcelRequire('65zeK'));

});

parcelRegister("8pzcT", function(module, exports) {

let $61fbf7e9b29a6824$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $61fbf7e9b29a6824$var$load("cYuG5").then(()=>parcelRequire('amjcb'));

});

parcelRegister("1I2b8", function(module, exports) {

let $13eb9721d58dad03$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $13eb9721d58dad03$var$load("5bV9Q").then(()=>parcelRequire('3z1HI'));

});

parcelRegister("gPBz3", function(module, exports) {

let $c40e8c41f36f3f1d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c40e8c41f36f3f1d$var$load("gjrov").then(()=>parcelRequire('ePp5T'));

});

parcelRegister("78iTh", function(module, exports) {

let $5317ef0d88303541$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5317ef0d88303541$var$load("ekD3q").then(()=>parcelRequire('3sPeQ'));

});

parcelRegister("gHYE1", function(module, exports) {

let $c29fb436da7f42d1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c29fb436da7f42d1$var$load("CRIov").then(()=>parcelRequire('21Pza'));

});

parcelRegister("9qN1z", function(module, exports) {

let $6ddc91febcf834c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6ddc91febcf834c3$var$load("kLzqf").then(()=>parcelRequire('2YIPE'));

});

parcelRegister("dNwJi", function(module, exports) {

let $a0b93d651cd2386e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a0b93d651cd2386e$var$load("89F7K").then(()=>parcelRequire('lXD2K'));

});

parcelRegister("fXweJ", function(module, exports) {

let $b9e55f3b28230681$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b9e55f3b28230681$var$load("5ZUDB").then(()=>parcelRequire('16fIE'));

});

parcelRegister("nFTVL", function(module, exports) {

let $0472a6c8d6c4c707$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0472a6c8d6c4c707$var$load("h2pVk").then(()=>parcelRequire('byreT'));

});

parcelRegister("bsw4B", function(module, exports) {

let $857b304eeac06c5e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $857b304eeac06c5e$var$load("hKNph").then(()=>parcelRequire('diuUZ'));

});

parcelRegister("97qPc", function(module, exports) {

let $6a39935eb8b824b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6a39935eb8b824b7$var$load("bEB1L").then(()=>parcelRequire('57pGr'));

});

parcelRegister("bZmWu", function(module, exports) {

let $8ba730127f966548$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8ba730127f966548$var$load("1DxcO").then(()=>parcelRequire('grvEM'));

});

parcelRegister("aspSd", function(module, exports) {

let $79d096d1d3432597$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $79d096d1d3432597$var$load("4KHc0").then(()=>parcelRequire('13DVp'));

});

parcelRegister("kWvvj", function(module, exports) {

let $f3f1a976fda4a8c1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f3f1a976fda4a8c1$var$load("fWsCx").then(()=>parcelRequire('im5if'));

});

parcelRegister("c5Sph", function(module, exports) {

let $8ce027b238ed199c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8ce027b238ed199c$var$load("eVExC").then(()=>parcelRequire('1U1j1'));

});

parcelRegister("ecWO0", function(module, exports) {

let $a57fcd3be5a7543a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a57fcd3be5a7543a$var$load("BGq3S").then(()=>parcelRequire('kBazV'));

});

parcelRegister("dpkEO", function(module, exports) {

let $9c2da245872fb648$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9c2da245872fb648$var$load("1BBYh").then(()=>parcelRequire('3tROA'));

});

parcelRegister("6sX6R", function(module, exports) {
/**
 * @generated SignedSource<<5781cbccd1c8eecb1569c5f9b0c8dc09>>
 * @relayHash 2bb1694d71660b70c596688bc417d3f0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d3c1e078b8f837f9aa0d463343faa2b58625974fee0bd1da388729d4349cb736
const $3b5c116e02c56723$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceUserClassConnection",
            "kind": "LinkedField",
            "name": "confluence_userClasses",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceUserClass",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "principalId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "displayName"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAccessClassInclusionClassesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAccessClassInclusionClassesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2bb1694d71660b70c596688bc417d3f0",
            "id": "d3c1e078b8f837f9aa0d463343faa2b58625974fee0bd1da388729d4349cb736",
            "metadata": {},
            "name": "useAccessClassInclusionClassesQuery",
            "operationKind": "query",
            "text": "query useAccessClassInclusionClassesQuery($cloudId:ID!){confluence_userClasses(cloudId:$cloudId){nodes{principalId,displayName}}}"
        }
    };
}();
$3b5c116e02c56723$var$node.hash = "b9df1c827cf7bec061b12334b26b99d9";
var $3b5c116e02c56723$export$2e2bcd8739ae039 = $3b5c116e02c56723$var$node;



var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $bQm3c = parcelRequire("bQm3c");


var $jMyy4 = parcelRequire("jMyy4");

const $fed355c8c6dd10eb$var$useAccessClassInclusionClassesQuery = (0, $3b5c116e02c56723$export$2e2bcd8739ae039);
const $fed355c8c6dd10eb$var$toLowerWithoutSpaces = (str)=>str?.toLowerCase().replace(/ /g, '');


const $fed355c8c6dd10eb$export$3084d470555a4d72 = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($fed355c8c6dd10eb$var$useAccessClassInclusionClassesQuery, {
        variables: {
            cloudId: cloudId
        },
        onError: (e)=>{
            (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            });
            (0, $7Sm4c.markErrorAsHandled)(e);
        },
        __callerPackage__: "space-roles"
    });
    const allConfluenceUsers = data?.confluence_userClasses?.nodes?.find((userClass)=>userClass?.principalId === 'all-licensed-users');
    const allConfluenceAdmins = data?.confluence_userClasses?.nodes?.find((userClass)=>userClass?.principalId === 'all-product-admins');
    if (loading || error) return [];
    return [
        {
            ...allConfluenceUsers?.principalId && allConfluenceUsers?.displayName && {
                [$fed355c8c6dd10eb$var$toLowerWithoutSpaces(allConfluenceUsers.displayName)]: {
                    id: allConfluenceUsers.principalId,
                    name: allConfluenceUsers.displayName,
                    type: 'custom',
                    avatarUrl: (parcelRequire("kbDJp"))
                }
            },
            ...allConfluenceAdmins?.principalId && allConfluenceAdmins?.displayName && {
                [$fed355c8c6dd10eb$var$toLowerWithoutSpaces(allConfluenceAdmins.displayName)]: {
                    id: allConfluenceAdmins.principalId,
                    name: allConfluenceAdmins.displayName,
                    type: 'custom',
                    avatarUrl: (parcelRequire("kbDJp"))
                }
            }
        }
    ];
};
module.exports["useAccessClassInclusion"] = $fed355c8c6dd10eb$export$3084d470555a4d72;

});

parcelRegister("kbDJp", function(module, exports) {
module.exports = new URL("atlassian-icon.1175e11b.svg", import.meta.url).toString();

});

parcelRegister("bYvQP", function(module, exports) {
/**
 * @generated SignedSource<<62b0bbc683f6d381ee0b038d7be56a15>>
 * @relayHash 99c9b559039c583547ef40e7402826a6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cea427276cf747ecdd5141ecc68b95890eaafd7ffc2a1a5f883ee10092d34ab1
const $4214be3f4cede243$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceUserClassConnection",
            "kind": "LinkedField",
            "name": "confluence_userClasses",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceUserClass",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "principalId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "displayName"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAccessClassTransformerQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAccessClassTransformerQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "99c9b559039c583547ef40e7402826a6",
            "id": "cea427276cf747ecdd5141ecc68b95890eaafd7ffc2a1a5f883ee10092d34ab1",
            "metadata": {},
            "name": "useAccessClassTransformerQuery",
            "operationKind": "query",
            "text": "query useAccessClassTransformerQuery($cloudId:ID!){confluence_userClasses(cloudId:$cloudId){nodes{principalId,displayName}}}"
        }
    };
}();
$4214be3f4cede243$var$node.hash = "a336baeeba530d71a57fedc023a9b7eb";
var $4214be3f4cede243$export$2e2bcd8739ae039 = $4214be3f4cede243$var$node;



var $cozmU = parcelRequire("cozmU");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $bQm3c = parcelRequire("bQm3c");


var $jMyy4 = parcelRequire("jMyy4");

const $eef51719bd266cea$var$useAccessClassTransformerQuery = (0, $4214be3f4cede243$export$2e2bcd8739ae039);
const $eef51719bd266cea$var$toLowerWithoutSpaces = (str)=>str?.toLowerCase().replace(/ /g, '');

const $eef51719bd266cea$export$8981ed613e05500d = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data } = (0, $jMyy4.useQueryInterop)($eef51719bd266cea$var$useAccessClassTransformerQuery, {
        variables: {
            cloudId: cloudId
        },
        onError: (e)=>{
            (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            });
            (0, $7Sm4c.markErrorAsHandled)(e);
        },
        __callerPackage__: "space-roles"
    });
    const [searchQuery, setSearchQuery] = (0, $cozmU.useState)('');
    const allConfluenceUsers = data?.confluence_userClasses?.nodes?.find((userClass)=>userClass?.principalId === 'all-licensed-users');
    const allConfluenceAdmins = data?.confluence_userClasses?.nodes?.find((userClass)=>userClass?.principalId === 'all-product-admins');
    const transformOptions = async (options)=>{
        const cleanedSearchTerm = $eef51719bd266cea$var$toLowerWithoutSpaces(searchQuery);
        const customInclusionList = [];
        [
            allConfluenceUsers,
            allConfluenceAdmins
        ].forEach((userClass)=>{
            if (userClass && $eef51719bd266cea$var$toLowerWithoutSpaces(userClass.displayName || '').includes(cleanedSearchTerm)) customInclusionList.push({
                id: userClass.principalId,
                name: userClass.displayName,
                type: 'custom',
                avatarUrl: (parcelRequire("kbDJp"))
            });
        });
        return [
            ...options,
            ...customInclusionList
        ];
    };
    return {
        setSearchQuery: setSearchQuery,
        transformOptions: transformOptions
    };
};
module.exports["useAccessClassTransformer"] = $eef51719bd266cea$export$8981ed613e05500d;

});

parcelRegister("ku6MO", function(module, exports) {
/* RoleSelector.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $6wGOF = parcelRequire("6wGOF");


var $l9ukq = parcelRequire("l9ukq");


var $iMnC5 = parcelRequire("iMnC5");


var $4aRua = parcelRequire("4aRua");


var $9DHhW = parcelRequire("9DHhW");


var $jp2Q3 = parcelRequire("jp2Q3");


var $kSwu1 = parcelRequire("kSwu1");

const $d5c5d64568180920$var$i18n = (0, $kSwu1.defineMessages)({
    noRolesAvailable: {
        id: "space-roles.role-selector.no-roles-available",
        defaultMessage: "No roles are currently available"
    }
});
const $d5c5d64568180920$var$styles = {
    menuItem: "_2mHwu81Y8M _3iDTPbQ4SZ _0aFT5vbt8w",
    menuContainer: "_3iDTPbQ4SZ _0aFT5vbt8w _0NUa3rsz7G",
    menuScrollable: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _2WAcuGIZbP _4kiQYAdnbC",
    optionWithSuffixOuter: "_3iDTPbQ4SZ _0aFT5v1qpb _37wbyuchRC _0hPCNLDIqT _4ouGXIdnbC _39xV02N91d",
    optionWithSuffixCluster: "_2mHwu82ADO _3iDTPbccYA _0aFT5v1qpb _0hPCNLDIqT _1EqgXlN91d _4ouGXIdnbC",
    optionLabelTruncate: "_4bt5LAnQyn _2WAcuGnQyn _2O5VijdnbC _3YEZNO7dHp _1bHrqEIZbP _4ouGXIdnbC _39HuIbz8Lp _1ANEUSLRg7",
    optionSuffixContainer: "_3YEZNOdnbC"
};
const $d5c5d64568180920$export$7b32174eb7b60a13 = ({ initialRoleId: initialRoleId, value: value, isLoading: isLoading, isDisabled: isDisabled = false, onChange: onChange, placeholder: placeholder, spaceRoleOptions: spaceRoleOptions, onMenuClose: onMenuClose, onMenuOpen: onMenuOpen, menuPlacement: menuPlacement = 'auto', appearance: appearance = 'subtle', noOptionsMessage: noOptionsMessage, spacing: spacing = 'default', menuPortalTarget: menuPortalTarget, maxMenuHeight: maxMenuHeight = 320, renderOptionSuffix: renderOptionSuffix, menuFooter: menuFooter, inputId: inputId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [internalVal, setInternalVal] = (0, $cozmU.useState)((value === undefined ? initialRoleId : value) || null);
    const [isMenuOpen, setIsMenuOpen] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const resolvedNoOptionsMessage = noOptionsMessage ?? formatMessage($d5c5d64568180920$var$i18n.noRolesAvailable);
    const closeMenu = (0, $cozmU.useCallback)(()=>{
        setIsMenuOpen(false);
    }, []); // The component is controlled if value is not `undefined`. `initialRole` will ignored in controlled mode.
    const isControlledComponent = value !== undefined;
    const options = (0, $cozmU.useMemo)(()=>spaceRoleOptions.map((role)=>({
                id: role?.id ?? '',
                label: role?.name ?? '',
                value: role?.id ?? '',
                description: role?.description ?? '',
                ariaLabel: `${role?.name} - ${role?.description ?? ''}`,
                optionColor: role?.optionColor
            })), [
        spaceRoleOptions
    ]);
    const getOptionFromValue = (0, $cozmU.useCallback)((val)=>{
        if (!val) return null;
        return typeof val === 'string' ? options.find((option)=>option.value === val) || null : {
            id: val.value.toString(),
            label: val.label,
            value: val.value.toString(),
            description: '',
            ariaLabel: `${val.label} - ${val.description ?? ''}`
        };
    }, [
        options
    ]);
    const CustomSingleValue = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((props)=>{
        const suffix = renderOptionSuffix?.(props.data.id);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).SingleValue, {
            ...props,
            "aria-label": props.data.ariaLabel
        }, suffix ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d5c5d64568180920$var$styles.optionWithSuffixOuter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d5c5d64568180920$var$styles.optionWithSuffixCluster
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d5c5d64568180920$var$styles.optionLabelTruncate
        }, props.data.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d5c5d64568180920$var$styles.optionSuffixContainer
        }, suffix))) : props.data.label);
    });
    const CustomOption = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((props)=>{
        const suffix = renderOptionSuffix?.(props.data.id);
        const optionColor = props.data.optionColor;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Option, {
            ...props,
            "aria-label": props.data.ariaLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d5c5d64568180920$var$styles.menuItem
        }, suffix ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d5c5d64568180920$var$styles.optionWithSuffixOuter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d5c5d64568180920$var$styles.optionWithSuffixCluster
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d5c5d64568180920$var$styles.optionLabelTruncate
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: optionColor
        }, props.data.label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d5c5d64568180920$var$styles.optionSuffixContainer
        }, suffix))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: optionColor
        }, props.data.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: optionColor ?? 'color.text.subtlest'
        }, props.data.description)));
    }); // Resolve menuFooter - call it if it's a function
    const resolvedMenuFooter = (0, $cozmU.useMemo)(()=>{
        if (!menuFooter) return null;
        return typeof menuFooter === 'function' ? menuFooter(closeMenu) : menuFooter;
    }, [
        menuFooter,
        closeMenu
    ]); // Custom Menu component with optional footer
    const CustomMenu = (0, $cozmU.useMemo)(()=>{
        if (!resolvedMenuFooter) return undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Menu, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $d5c5d64568180920$var$styles.menuContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $d5c5d64568180920$var$styles.menuScrollable
            }, props.children), resolvedMenuFooter)));
    }, [
        resolvedMenuFooter
    ]);
    const handleChange = (newSelection)=>{
        const newSelectionType = spaceRoleOptions.find((role)=>role?.id === newSelection?.value)?.roleType;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'change',
                source: 'spaceRoles-roleSelector',
                attributes: {
                    newSelection: newSelection?.id,
                    newSelectionType: newSelectionType
                }
            }
        }).fire();
        setInternalVal(newSelection?.value || null); // Guard the unsafe `as SpaceRole` cast: if the option list and the new selection ever
        // diverge (e.g. a stale option fires after the list was filtered, or a disabled SYSTEM
        // role is no longer in the list), `.find(...)` returns undefined, and downstream
        // consumers that do `newRole.id` would NPE. Mirrors the guard pattern used by the
        // site-permissions local copy of this component.
        const matchedRole = spaceRoleOptions.find((role)=>role?.id === newSelection?.value);
        if (matchedRole) onChange?.(matchedRole);
    };
    const handleMenuOpen = (0, $cozmU.useCallback)((currentRoleSelection)=>{
        onMenuOpen?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'open',
                source: 'spaceRoles-roleSelector',
                attributes: {
                    currentRoleSelection: currentRoleSelection?.id
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        onMenuOpen
    ]);
    const SELECT_STYLE_PROPS = {
        isSearchable: false,
        styles: {
            menu: (base)=>({
                    ...base,
                    width: '320px',
                    padding: 0,
                    margin: 0,
                    zIndex: (0, $jp2Q3.layers).modal() + 1 // Higher than modal to appear above modal content
                }),
            menuPortal: (base)=>({
                    ...base,
                    zIndex: (0, $jp2Q3.layers).modal() + 1 // Higher than modal to appear above modal content
                })
        }
    };
    const selectValue = isControlledComponent ? getOptionFromValue(value) : getOptionFromValue(internalVal);
    const handleMenuOpenInternal = (0, $cozmU.useCallback)(()=>{
        setIsMenuOpen(true);
        handleMenuOpen(getOptionFromValue(isControlledComponent ? value : internalVal));
    }, [
        getOptionFromValue,
        handleMenuOpen,
        isControlledComponent,
        value,
        internalVal
    ]);
    const handleMenuCloseInternal = (0, $cozmU.useCallback)(()=>{
        setIsMenuOpen(false);
        onMenuClose?.();
    }, [
        onMenuClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
        "data-testid": "space-roles-table-role-selector",
        inputId: inputId,
        placeholder: isLoading ? '' : placeholder,
        options: options,
        appearance: appearance,
        isLoading: isLoading,
        isDisabled: isDisabled,
        onChange: handleChange,
        onMenuOpen: handleMenuOpenInternal,
        onMenuClose: handleMenuCloseInternal,
        menuIsOpen: isMenuOpen,
        components: {
            SingleValue: CustomSingleValue,
            Option: CustomOption,
            ...CustomMenu ? {
                Menu: CustomMenu
            } : {}
        },
        menuPosition: "fixed",
        menuPlacement: menuPlacement,
        menuPortalTarget: menuPortalTarget,
        maxMenuHeight: maxMenuHeight,
        scrollBehavior: "outside",
        defaultValue: getOptionFromValue(initialRoleId),
        value: selectValue,
        noOptionsMessage: ()=>resolvedNoOptionsMessage,
        spacing: spacing,
        ...SELECT_STYLE_PROPS
    });
};
module.exports["RoleSelector"] = $d5c5d64568180920$export$7b32174eb7b60a13;

});

parcelRegister("3EH2D", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $6573ae76580eb783$export$fa4e386dd79a7949 = /*#__PURE__*/ function(ConfluenceRoleAssignabilityCode) {
    ConfluenceRoleAssignabilityCode["ASSIGNABLE"] = "ASSIGNABLE";
    ConfluenceRoleAssignabilityCode["DEFAULT_ROLE_ASSIGNMENT_NOT_SUPPORTED"] = "DEFAULT_ROLE_ASSIGNMENT_NOT_SUPPORTED";
    ConfluenceRoleAssignabilityCode["ESCALATION_NOT_ASSIGNABLE"] = "ESCALATION_NOT_ASSIGNABLE";
    ConfluenceRoleAssignabilityCode["GUEST_EXISTING_SPACE_ACCESS"] = "GUEST_EXISTING_SPACE_ACCESS";
    ConfluenceRoleAssignabilityCode["GUEST_SYSTEM_SPACE_ACCESS"] = "GUEST_SYSTEM_SPACE_ACCESS";
    ConfluenceRoleAssignabilityCode["NOT_ASSIGNABLE"] = "NOT_ASSIGNABLE";
    ConfluenceRoleAssignabilityCode["NO_MANAGE_GUEST_USERS_PERM_NOT_ASSIGNABLE"] = "NO_MANAGE_GUEST_USERS_PERM_NOT_ASSIGNABLE";
    ConfluenceRoleAssignabilityCode["NO_MANAGE_NONLICENSED_USERS_PERM_NOT_ASSIGNABLE"] = "NO_MANAGE_NONLICENSED_USERS_PERM_NOT_ASSIGNABLE";
    ConfluenceRoleAssignabilityCode["PRINCIPAL_INVALID_ROLE"] = "PRINCIPAL_INVALID_ROLE";
    return ConfluenceRoleAssignabilityCode;
}({});
var $6573ae76580eb783$export$4e2d5448f3fd8728 = /*#__PURE__*/ function(RoleAssignmentPrincipalType) {
    RoleAssignmentPrincipalType["ACCESS_CLASS"] = "ACCESS_CLASS";
    RoleAssignmentPrincipalType["APP"] = "APP";
    RoleAssignmentPrincipalType["GROUP"] = "GROUP";
    RoleAssignmentPrincipalType["USER"] = "USER";
    return RoleAssignmentPrincipalType;
}({});
var $6573ae76580eb783$export$69bdd9d16ab8ed0f = /*#__PURE__*/ function(SpaceRoleType) {
    SpaceRoleType["CUSTOM"] = "CUSTOM";
    SpaceRoleType["SYSTEM"] = "SYSTEM";
    return SpaceRoleType;
}({})// Note: Original file contained additional custom exports that need manual review:
// RoleAssignmentPrincipalInput
// Please verify these are handled correctly in your codebase.
;
module.exports["ConfluenceRoleAssignabilityCode"] = $6573ae76580eb783$export$fa4e386dd79a7949;
module.exports["SpaceRoleType"] = $6573ae76580eb783$export$69bdd9d16ab8ed0f;

});

parcelRegister("9rnOu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $kuBjO = parcelRequire("kuBjO");


var $75A8F = parcelRequire("75A8F");





var $kSwu1 = parcelRequire("kSwu1");


var $145zT = parcelRequire("145zT");


var $iDdJP = parcelRequire("iDdJP");


var $3izAL = parcelRequire("3izAL");


var $kz1Yj = parcelRequire("kz1Yj");


var $buxP3 = parcelRequire("buxP3");


var $bsSbN = parcelRequire("bsSbN");


var $5BMKF = parcelRequire("5BMKF");

const $d78f8d894583618b$var$navContainerStyles = (0, $buxP3.xcss)({
    width: '202px'
});
const $d78f8d894583618b$export$fa002117b34ac07e = ({ systemRoles: systemRoles, customRoles: customRoles, activeRoleId: activeRoleId, setActiveRoleId: setActiveRoleId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $d78f8d894583618b$var$navContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iDdJP.MenuList), null, [
        ...systemRoles,
        ...customRoles || []
    ].map((role)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $145zT.ButtonMenuItem), {
            key: role.id,
            isSelected: role.id === activeRoleId,
            onClick: ()=>setActiveRoleId(role.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            space: "space.100",
            alignBlock: "center",
            spread: "space-between"
        }, role.name, role.isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), {
            label: formatMessage((0, $5BMKF.viewRolePermissionsMessages).roleDisabledLabel),
            color: "var(--ds-icon-danger, #C9372C)",
            size: "small",
            spacing: "none"
        }))))));
};


const $b296da749f5cb895$export$5cfd4e5ecf699324 = ({ systemRoles: systemRoles, customRoles: customRoles, allPermissions: allPermissions, onClose: onClose, initialActiveRoleId: initialActiveRoleId, analyticsSource: analyticsSource, onClickEdit: onClickEdit })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [activeRoleId, setActiveRoleId] = (0, $cozmU.useState)(initialActiveRoleId || systemRoles[0]?.id || '');
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'viewRolePermissionsModal',
                attributes: {
                    source: analyticsSource
                }
            }
        }).fire();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $75A8F.ViewRolePermissionsWrapper), {
        systemRoles: systemRoles,
        customRoles: customRoles,
        allPermissions: allPermissions,
        activeRoleId: activeRoleId,
        setActiveRoleId: setActiveRoleId,
        analyticsSource: analyticsSource,
        onClose: onClose,
        onClickEdit: onClickEdit,
        extraPermissionContent: (0, $kuBjO.buildPermissionDescriptionTooltips)(allPermissions ?? [])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d78f8d894583618b$export$fa002117b34ac07e), {
        systemRoles: systemRoles,
        customRoles: customRoles || [],
        activeRoleId: activeRoleId,
        setActiveRoleId: setActiveRoleId
    }));
};
module.exports["ViewRolePermissionModal"] = $b296da749f5cb895$export$5cfd4e5ecf699324;

});

parcelRegister("kuBjO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4eaa9 = parcelRequire("4eaa9");

const $d0043c7e7d457c98$export$957155b70cf06c14 = (allPermissions)=>Object.fromEntries(allPermissions.filter((p)=>p.description?.trim()).map((p)=>[
            p.key,
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4eaa9.PermissionDescriptionTooltip), {
                key: p.key,
                description: p.description
            })
        ]));
module.exports["buildPermissionDescriptionTooltips"] = $d0043c7e7d457c98$export$957155b70cf06c14;

});

parcelRegister("4eaa9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fodiz = parcelRequire("fodiz");


var $lpNn5 = parcelRequire("lpNn5");

const $d78324f06e782280$var$hasNonEmptyDescription = (value)=>{
    if (value == null || typeof value !== 'string') return false;
    // Treat whitespace-only (including \n, \t, etc.) as empty
    return !/^\s*$/.test(value);
};
const $d78324f06e782280$export$6b4b0e8b29cb3d9 = ({ description: description })=>{
    if (!$d78324f06e782280$var$hasNonEmptyDescription(description)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: "right",
        content: description?.trim() ?? ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
        label: "",
        size: "small"
    }));
};
module.exports["PermissionDescriptionTooltip"] = $d78324f06e782280$export$6b4b0e8b29cb3d9;

});

parcelRegister("75A8F", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $I7hWB = parcelRequire("I7hWB");


var $chu6R = parcelRequire("chu6R");


var $5avUB = parcelRequire("5avUB");


var $gC2EJ = parcelRequire("gC2EJ");


var $bsSbN = parcelRequire("bsSbN");


var $9KSWX = parcelRequire("9KSWX");


var $5BMKF = parcelRequire("5BMKF");


var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $aRGok = parcelRequire("aRGok");


var $cDs9S = parcelRequire("cDs9S");


var $3izAL = parcelRequire("3izAL");


var $9iaFM = parcelRequire("9iaFM");


var $kz1Yj = parcelRequire("kz1Yj");


var $buxP3 = parcelRequire("buxP3");


var $2wCqQ = parcelRequire("2wCqQ");


var $6Pqow = parcelRequire("6Pqow");


var $kA6Zo = parcelRequire("kA6Zo");


var $gnKXs = parcelRequire("gnKXs");


var $lsxnT = parcelRequire("lsxnT");


var $9wGTI = parcelRequire("9wGTI");


var $1ytiN = parcelRequire("1ytiN");


var $1NBp8 = parcelRequire("1NBp8");


var $eiDGO = parcelRequire("eiDGO");


var $8Eh39 = parcelRequire("8Eh39");

const $1e059f1575c38760$var$i18n = (0, $kSwu1.defineMessages)({
    title: {
        id: "space-roles.view-role-permissions-modal.title",
        defaultMessage: "Role permissions"
    },
    doneButtonText: {
        id: "space-roles.view-role-permissions-modal.done-button-text",
        defaultMessage: "Done"
    },
    permissionEnabled: {
        id: "space-roles.view-role-permissions-modal.permission-enabled",
        defaultMessage: "Enabled"
    },
    permissionDisabled: {
        id: "space-roles.view-role-permissions-modal.permission-disabled",
        defaultMessage: "Disabled"
    },
    editButtonLabel: {
        id: "space-roles.view-role-permissions-modal.edit-button-label",
        defaultMessage: "Edit role permissions"
    }
});
// -- Styles --
const $1e059f1575c38760$var$detailViewStyles = (0, $buxP3.xcss)({
    marginLeft: 'space.600'
});
const $1e059f1575c38760$var$rolePermissionDetailContainerStyle = (0, $buxP3.xcss)({
    marginTop: 'space.400',
    rowGap: 'space.400',
    columnGap: 'space.1000',
    [(0, $gnKXs.media).above.sm]: {
        gridTemplateColumns: 'repeat(2, 1fr)'
    }
});
const $1e059f1575c38760$var$contentStyles = (0, $buxP3.xcss)({
    paddingTop: 'space.200',
    paddingBottom: 'space.200'
});
const $1e059f1575c38760$var$checkboxGroupStyles = (0, $buxP3.xcss)({
    gap: 'space.100',
    justifyContent: 'start'
});
const $1e059f1575c38760$var$modalHeaderStyle = (0, $buxP3.xcss)({
    marginBottom: 'space.150',
    justifyContent: 'flex-end',
    gap: 'space.100',
    width: '100%'
});
const $1e059f1575c38760$var$headingInlineStyle = (0, $buxP3.xcss)({
    marginBlock: 'space.negative.150'
});
const $1e059f1575c38760$var$modalHeaderSpacing = (0, $buxP3.xcss)({
    height: '100%',
    alignItems: 'center',
    width: '100%'
});
const $1e059f1575c38760$export$8008a8193747f6f5 = ({ systemRoles: systemRoles, customRoles: customRoles, allPermissions: allPermissions, onClose: onClose, onClickEdit: onClickEdit, activeRoleId: activeRoleId, analyticsSource: analyticsSource, title: title, children: children, footer: footer, extraPermissionContent: extraPermissionContent })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const defaultOnClickEdit = (0, $cozmU.useCallback)(()=>{
        onClose();
        window.location.href = (0, $1NBp8.ADMIN_SITE_SPACE_PERMISSIONS).toUrl({
            tab: 'roles'
        });
    }, [
        onClose
    ]);
    const handleClickEdit = onClickEdit || defaultOnClickEdit;
    const activeRole = [
        ...systemRoles,
        ...customRoles || []
    ].find((role)=>role.id === activeRoleId);
    // Right side detail view
    // Build a dictionary for the active role to look up if a permission is enabled or not
    const activeRolePermissionDict = (0, $8Eh39.buildPermissionDictionary)(activeRole?.permissions || []);
    // Get all permissions and group them by group name
    const sortedPermissionGroupDict = (0, $8Eh39.getNormalizedPermissionItems)(undefined, allPermissions || []);
    const permissionListComps = Object.values(sortedPermissionGroupDict).map((group)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            space: "space.150",
            key: group.group.name,
            xcss: $1e059f1575c38760$var$checkboxGroupStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, group.group.name), group.group.checkboxes.map((item)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
                space: "space.100",
                alignBlock: "center",
                key: item.id
            }, activeRolePermissionDict[item.id] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                label: formatMessage($1e059f1575c38760$var$i18n.permissionEnabled),
                color: "var(--ds-icon-success, #6A9A23)",
                spacing: "none"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                label: formatMessage($1e059f1575c38760$var$i18n.permissionDisabled),
                color: "var(--ds-icon-disabled, #080F214A)",
                spacing: "none"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), null, item.displayName), extraPermissionContent?.[item.id] && extraPermissionContent[item.id]);
        }));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
        width: 1000,
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        xcss: $1e059f1575c38760$var$modalHeaderSpacing
    }, (0, $9wGTI.fg)('platform_dst_modal-dialog-use-modal-title') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, title || formatMessage($1e059f1575c38760$var$i18n.title)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "medium"
    }, title || formatMessage($1e059f1575c38760$var$i18n.title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        xcss: $1e059f1575c38760$var$modalHeaderStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eiDGO.ModalHeaderActionsMenu), {
        source: analyticsSource
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cDs9S.CloseButton), {
        onClick: onClose
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        xcss: $1e059f1575c38760$var$contentStyles
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $1e059f1575c38760$var$detailViewStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "medium"
    }, activeRole?.name || ''), activeRole?.isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "danger"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), {
        label: "",
        color: "currentColor"
    }), formatMessage((0, $5BMKF.viewRolePermissionsMessages).roleDisabledLabel))), (onClickEdit || isSiteAdmin) && activeRole && customRoles?.some((role)=>role.id === activeRole.id) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $1e059f1575c38760$var$headingInlineStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
        label: formatMessage($1e059f1575c38760$var$i18n.editButtonLabel),
        onClick: ()=>handleClickEdit(activeRole.id),
        testId: "edit-role-permissions-button"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), null, activeRole?.description || '')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9iaFM.Grid), {
        xcss: $1e059f1575c38760$var$rolePermissionDetailContainerStyle
    }, permissionListComps)))), footer || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onClose
    }, formatMessage($1e059f1575c38760$var$i18n.doneButtonText))))));
};
module.exports["ViewRolePermissionsWrapper"] = $1e059f1575c38760$export$8008a8193747f6f5;

});

parcelRegister("9iaFM", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $1tDzb = parcelRequire("1tDzb");


var $3LWAs = parcelRequire("3LWAs");

function $f21d3adc78722ef1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f21d3adc78722ef1$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
const $f21d3adc78722ef1$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
const $f21d3adc78722ef1$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
const $f21d3adc78722ef1$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $f21d3adc78722ef1$var$justifyItemsMap = {
    start: {
        name: "lno2ya",
        styles: "justify-items:start"
    },
    center: {
        name: "1wg53za",
        styles: "justify-items:center"
    },
    end: {
        name: "3f7lhf",
        styles: "justify-items:end"
    },
    stretch: {
        name: "16hnylu",
        styles: "justify-items:stretch"
    }
};
const $f21d3adc78722ef1$var$alignContentMap = {
    start: {
        name: "iqu4as",
        styles: "align-content:start"
    },
    center: {
        name: "13vy23x",
        styles: "align-content:center"
    },
    end: {
        name: "1fj2toh",
        styles: "align-content:end"
    },
    'space-between': {
        name: "1pem0lx",
        styles: "align-content:space-between"
    },
    'space-around': {
        name: "127p7gk",
        styles: "align-content:space-around"
    },
    'space-evenly': {
        name: "kcqjal",
        styles: "align-content:space-evenly"
    },
    stretch: {
        name: "1f8yzab",
        styles: "align-content:stretch"
    }
};
const $f21d3adc78722ef1$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    }
};
const $f21d3adc78722ef1$var$baseStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: `var(${$f21d3adc78722ef1$var$gridTemplateAreasVar})`,
    gridTemplateColumns: `var(${$f21d3adc78722ef1$var$gridTemplateColumnsVar})`,
    gridTemplateRows: `var(${$f21d3adc78722ef1$var$gridTemplateRowsVar})`
});
const $f21d3adc78722ef1$var$gridAutoFlowMap = {
    row: {
        name: "k3yepi",
        styles: "grid-auto-flow:row"
    },
    column: {
        name: "qu4z1d",
        styles: "grid-auto-flow:column"
    },
    dense: {
        name: "mgx7bc",
        styles: "grid-auto-flow:dense"
    },
    'row dense': {
        name: "1u50cee",
        styles: "grid-auto-flow:row dense"
    },
    'column dense': {
        name: "5ak4pc",
        styles: "grid-auto-flow:column dense"
    }
};
const $f21d3adc78722ef1$export$ef2184bd89960b14 = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, templateAreas: gridTemplateAreas, templateRows: gridTemplateRows, templateColumns: gridTemplateColumns, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    const resolvedStyles = (0, $1tDzb.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ const style = (0, $cozmU.useMemo)(()=>({
            [$f21d3adc78722ef1$var$gridTemplateAreasVar]: gridTemplateAreas ? gridTemplateAreas.map((str)=>`"${str}"`).join('\n') || 'initial' : 'initial',
            [$f21d3adc78722ef1$var$gridTemplateColumnsVar]: gridTemplateColumns || 'initial',
            [$f21d3adc78722ef1$var$gridTemplateRowsVar]: gridTemplateRows || 'initial'
        }), [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $f21d3adc78722ef1$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $3LWAs.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $3LWAs.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $3LWAs.spaceStylesMap).rowGap[rowGap],
            alignItems && $f21d3adc78722ef1$var$alignItemsMap[alignItems],
            alignContent && $f21d3adc78722ef1$var$alignContentMap[alignContent],
            justifyContent && $f21d3adc78722ef1$var$justifyContentMap[justifyContent],
            autoFlow && $f21d3adc78722ef1$var$gridAutoFlowMap[autoFlow],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$f21d3adc78722ef1$export$ef2184bd89960b14.displayName = 'Grid';
module.exports["Grid"] = $f21d3adc78722ef1$export$ef2184bd89960b14;

});

parcelRegister("gnKXs", function(module, exports) {
const $cd9ae1db5a8ec9c9$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
module.exports["media"] = $cd9ae1db5a8ec9c9$export$987d49ffe1b0900f;

});

parcelRegister("eiDGO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $gVrmv = parcelRequire("gVrmv");


var $6TaGl = parcelRequire("6TaGl");


var $c6lYi = parcelRequire("c6lYi");


var $4crmM = parcelRequire("4crmM");

const $75df59866e641445$var$LEARN_MORE_ROLES = 'https://support.atlassian.com/confluence-cloud/docs/what-are-confluences-roles/';
const $75df59866e641445$var$i18n = (0, $kSwu1.defineMessages)({
    learnMoreLink: {
        id: "space-roles.modal-header-actions-menu.learn-more-link",
        defaultMessage: "Learn more about roles"
    },
    moreOptionsLabel: {
        id: "space-roles.modal-header-actions-menu.more-options-label",
        defaultMessage: "More options"
    }
});
const $75df59866e641445$export$aa109f8e75bb5322 = ({ source: source })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isFeedbackOpen, setIsFeedbackOpen] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4crmM.PageActionsFeedbackCollector), {
        isOpen: isFeedbackOpen,
        onClose: ()=>setIsFeedbackOpen(false),
        source: source
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        placement: "bottom-end",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...props,
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                label: formatMessage($75df59866e641445$var$i18n.moreOptionsLabel),
                ref: triggerRef
            }),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        onClick: ()=>window.open($75df59866e641445$var$LEARN_MORE_ROLES, '_blank')
    }, formatMessage($75df59866e641445$var$i18n.learnMoreLink)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gVrmv))), {
            label: ""
        }),
        onClick: ()=>setIsFeedbackOpen(true)
    }, formatMessage((0, $c6lYi.feedbackCollectorMessages).buttonText)))));
};
module.exports["ModalHeaderActionsMenu"] = $75df59866e641445$export$aa109f8e75bb5322;

});

parcelRegister("4crmM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7aRa9 = parcelRequire("7aRa9");


var $c6lYi = parcelRequire("c6lYi");


var $cNkvT = parcelRequire("cNkvT");

const $3e7b218d6d093227$var$PageActionsFeedbackCollectorComponent = ({ flags: flags, isOpen: isOpen, onClose: onClose, source: source })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cNkvT.SpaceRolesFeedbackCollector), {
        isOpen: isOpen,
        onClose: onClose,
        onSubmit: ()=>{
            flags.showSuccessFlag({
                title: formatMessage((0, $c6lYi.feedbackCollectorMessages).flagTitle),
                isAutoDismiss: true
            });
        },
        source: source
    });
};
const $3e7b218d6d093227$export$3d9328cf4afd15b8 = (0, $7aRa9.withFlags)($3e7b218d6d093227$var$PageActionsFeedbackCollectorComponent);
module.exports["PageActionsFeedbackCollector"] = $3e7b218d6d093227$export$3d9328cf4afd15b8;

});

parcelRegister("8Eh39", function(module, exports) {
const $00348e3352156ed0$export$dbc5bcb243a11b25 = (permissions, allSpacePermissions, assignablePermissions)=>{
    // Permission groups are sorted here, then checkboxes of permissions are sorted below
    const sortedSpacePermissions = [
        ...allSpacePermissions
    ].sort((a, b)=>a.groupPriority - b.groupPriority);
    return Object.values(sortedSpacePermissions).reduce((acc, permission)=>{
        const isChecked = Boolean(permissions?.includes(permission.key));
        const checkbox = {
            id: permission.key,
            displayName: permission.actionName,
            priority: permission.priority,
            description: permission.description || '',
            isAssignable: !!assignablePermissions ? assignablePermissions.includes(permission.key) : true,
            isChecked: isChecked,
            isDisabled: false
        };
        const group = {
            groupName: permission.groupName,
            groupPriority: permission.groupPriority
        };
        if (!acc[group.groupName]) acc[group.groupName] = {
            group: {
                name: group.groupName,
                priority: group.groupPriority,
                checkboxes: []
            }
        };
        acc[group.groupName].group.checkboxes.push(checkbox);
        acc[group.groupName].group.checkboxes.sort((a, b)=>a.priority - b.priority);
        return acc;
    }, {});
};
const $00348e3352156ed0$export$eda4a295c95572c4 = (allowedPermissions)=>{
    return allowedPermissions.reduce((acc, permission)=>{
        acc[permission] = true;
        return acc;
    }, {});
};
module.exports["getNormalizedPermissionItems"] = $00348e3352156ed0$export$dbc5bcb243a11b25;
module.exports["buildPermissionDictionary"] = $00348e3352156ed0$export$eda4a295c95572c4;

});

parcelRegister("145zT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $KuePV = parcelRequire("KuePV");


var $h11I1 = parcelRequire("h11I1");

const $7d2b10ee608cb4d3$export$6dc09b7c0ec1dfcd = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, forwardedRef)=>{
    const $ = (0, $bDgLe.c)(24);
    const { testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, isSelected: isSelected, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator } = t0;
    const t1 = isDisabled ? undefined : actions;
    const t2 = isDisabled ? undefined : actionsOnHover;
    let t3;
    if ($[0] !== ariaControls || $[1] !== ariaExpanded || $[2] !== ariaHasPopup || $[3] !== children || $[4] !== description || $[5] !== dropIndicator || $[6] !== elemAfter || $[7] !== elemBefore || $[8] !== forwardedRef || $[9] !== hasDragIndicator || $[10] !== interactionName || $[11] !== isContentTooltipDisabled || $[12] !== isDisabled || $[13] !== isDragging || $[14] !== isSelected || $[15] !== onClick || $[16] !== t1 || $[17] !== t2 || $[18] !== testId || $[19] !== visualContentRef) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $KuePV.MenuItemBase), {
            testId: testId,
            description: description,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            isDisabled: isDisabled,
            actions: t1,
            actionsOnHover: t2,
            onClick: onClick,
            ariaControls: ariaControls,
            ariaExpanded: ariaExpanded,
            ariaHasPopup: ariaHasPopup,
            isSelected: isSelected,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator
        }, children);
        $[0] = ariaControls;
        $[1] = ariaExpanded;
        $[2] = ariaHasPopup;
        $[3] = children;
        $[4] = description;
        $[5] = dropIndicator;
        $[6] = elemAfter;
        $[7] = elemBefore;
        $[8] = forwardedRef;
        $[9] = hasDragIndicator;
        $[10] = interactionName;
        $[11] = isContentTooltipDisabled;
        $[12] = isDisabled;
        $[13] = isDragging;
        $[14] = isSelected;
        $[15] = onClick;
        $[16] = t1;
        $[17] = t2;
        $[18] = testId;
        $[19] = visualContentRef;
        $[20] = t3;
    } else t3 = $[20];
    let t4;
    if ($[21] !== listItemRef || $[22] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h11I1.MenuListItem), {
            ref: listItemRef
        }, t3);
        $[21] = listItemRef;
        $[22] = t3;
        $[23] = t4;
    } else t4 = $[23];
    return t4;
} : ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, isSelected: isSelected, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h11I1.MenuListItem), {
        ref: listItemRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $KuePV.MenuItemBase), {
        testId: testId,
        description: description,
        elemAfter: elemAfter,
        elemBefore: elemBefore,
        isDisabled: isDisabled,
        /**
     * Not passing `actions` and `actionsOnHover` to MenuItemBase when `isDisabled`,
     * so they aren't rendered in the disabled state.
     */ actions: isDisabled ? undefined : actions,
        actionsOnHover: isDisabled ? undefined : actionsOnHover,
        onClick: onClick,
        ariaControls: ariaControls,
        ariaExpanded: ariaExpanded,
        ariaHasPopup: ariaHasPopup,
        isSelected: isSelected,
        ref: forwardedRef,
        visualContentRef: visualContentRef,
        interactionName: interactionName,
        isContentTooltipDisabled: isContentTooltipDisabled,
        isDragging: isDragging,
        hasDragIndicator: hasDragIndicator,
        dropIndicator: dropIndicator
    }, children));
});
module.exports["ButtonMenuItem"] = $7d2b10ee608cb4d3$export$6dc09b7c0ec1dfcd;

});

parcelRegister("KuePV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $3v3yD = parcelRequire("3v3yD");


var $4Qc44 = parcelRequire("4Qc44");


var $lmzCg = parcelRequire("lmzCg");


var $iDrrr = parcelRequire("iDrrr");


var $7vK9E = parcelRequire("7vK9E");

var $hBYtq = parcelRequire("hBYtq");

var $4aRua = parcelRequire("4aRua");


var $lpNn5 = parcelRequire("lpNn5");


var $5BGbo = parcelRequire("5BGbo");


var $8VFFa = parcelRequire("8VFFa");


var $8AWCX = parcelRequire("8AWCX");


var $1TBPy = parcelRequire("1TBPy");


var $3TF4i = parcelRequire("3TF4i");

function $5638831521affcfb$var$isTextClamped(element) {
    // Checking for vertical height rather than horizontal height.
    // When text is "clamped", it's technically being clamped vertically! 🤯
    return element.scrollHeight > element.clientHeight;
}
const $5638831521affcfb$var$defaultAvatarValues = {
    size: 'small'
}; // Stable reference for the anchor's text-decoration reset.
const $5638831521affcfb$var$anchorTextDecorationResetStyle = {
    textDecoration: 'none'
};
const $5638831521affcfb$var$elemAfterDisplayVar = '--elem-after-display';
const $5638831521affcfb$var$actionsOnHoverOpacityVar = '--actions-on-hover-opacity';
const $5638831521affcfb$var$actionsOnHoverWidthVar = '--actions-on-hover-width';
const $5638831521affcfb$var$actionsOnHoverPaddingInlineEndVar = '--actions-on-hover-padding';
const $5638831521affcfb$var$notchColorVar = '--notch-color'; // Note: this is also used in `drag-handle.tsx`
const $5638831521affcfb$var$dragHandleDisplayVar = '--drag-handle-display';
const $5638831521affcfb$var$dragCursorAnimation = null; /**
                                   * ## 🤹 `position:relative`
                                   *
                                   * We need `position:relative` on an element that takes
                                   * up the full size of the interactive element so we
                                   * can correctly use `position:absolute` to place:
                                   * 1. the notch for links
                                   * 2. drop indicators for drag and drop
                                   * 3. a child of button / anchor to stretch it out to
                                   *    increase it's pressable area.
                                   *
                                   * ⛔️ We cannot add `position:relative` _only_ on the
                                   * button / anchor as that will cause sibling elements
                                   * to be rendered under the button / anchor when setting
                                   * a background color on the button / anchor.
                                   *
                                   * 📖 Note: `position:relative` elements are painted after
                                   * elements with `position:static` (the default)
                                   * https://drafts.csswg.org/css-position-4/#painting-order
                                   *
                                   * ⛔️ We cannot add `position:relative` to the container
                                   * element, as then the `:focus` ring styles on the
                                   * button / anchor can be cut off by the next sibling if it has
                                   * has a background color set (eg when selected)
                                   *
                                   * ✅ Add `position:relative` to all first level descendants
                                   * of the container element so that we don't impact DOM ordered
                                   * paint ordering within the item and the button / anchor focus
                                   * ring can still bleed over siblings
                                   *
                                   * 📖 We could use `> * { position: relative; }` on the container,
                                   * but that would violate our styling standard.
                                   */ 
const $5638831521affcfb$var$topLevelSiblingStyles = {
    root: "_1mT5xdRAKS"
}; /**
    * All slots on the menu item (eg `elemBefore`) are rendered as siblings
    * of our main button / anchor element and they are visually placed on
    * top of the main button / anchor.
    *
    * 📖 This is done so that we don't nest interactive elements in our markup.
    *
    * ✅ This is great when element in the slot is an interactive element
    * as we don't want the main menu item button / anchor to be triggered
    * when interacting with the element in the slot.
    *
    * ⛔️ When the element in the slot is static content (eg an `<Icon>`) it will
    * prevent the main button / anchor (that is visually behind the element in
    * the slot) from being clicked. The element in the slot is a sibling of our
    * main button / anchor (not a child of it) so clicking on the element in the
    * slot will not bubble up to the button / anchor.
    *
    * 🚀 We set `pointer-events:none` on a slot if it does not contain and interactive
    * element so that static content in a slot does not prevent clicking on the main
    * button / anchor.
    */ 
const $5638831521affcfb$var$onTopOfButtonOrAnchorStyles = {
    root: "_2XwD3GYbGa"
}; /**
    * This is being _internally_ exported so it can be used in other menu item wrapper components, like
    * ExpandableMenuItemTrigger.
    *
    * This selector is used to apply hover styling on the menu item if it contains an open nested popup.
    * It's looking for a popup trigger with `aria-hasexpanded` and `aria-haspopup` attributes. The
    * reason for targeting the _trigger_ instead of the popup itself, is the popup might be rendered
    * outside the menu item, e.g. if rendered in a portal.
    *
    * An alternative solution might involve wrapping it with a popup context and listening to the popup
    * events through it (and applying the hover style when the popup is open). Exploring this has been
    * captured in [BLU-3354](https://jplat.atlassian.net/browse/BLU-3354).
    */ 
const $5638831521affcfb$export$91f7cd3f990d8a52 = '&:has([aria-expanded="true"][aria-haspopup])';
const $5638831521affcfb$var$containerStyles = {
    root: "_0bjKvDKTcp _24h04i2Njc _3iDTPbgBM8 _2iEGP2dBcB _0ca6V7UfmU _3NN0tOjIhD _4ouGXIL04q _0jFU0VZ49V _0hPCNLDIqT _20VacPYbGa _1UtDYzZpcK _4Gpka1jOvk _0B0jWhQ4SZ _21yOJEdnbC _1GUorvdnbC _0StjZVdnbC _1eOmH6d1Zr _1VxRtD7dHp _13ZyZA7dHp _0B13sOIZbP _2hQYYBIZbP _1fxveC1Y8M _23nUkX1Y8M",
    rootFinesse: "_1eOmH6o126",
    rootMotion: "_23rrnHo10F _1B4rbIo10F _3sFUREDdj4",
    removeElemAfter: "_0B0jWhYbGa",
    showHoverActions: "_21yOJE7dHp _1GUorvIZbP _0StjZV1Y8M",
    removeElemAfterOnHoverOrOpenNestedPopup: "_3R5mzfYbGa _4g9hZtYbGa",
    selected: "_0KLXruY9q9 _1UtDYzjTy9 _4Gpka1kLmD _0clgaMjTy9 _1eOmH6sumd",
    selectedMotion: "_23rrnHWE38 _1B4rbIo10F _3sFUREDdj4",
    disabled: "_1UtDYzot27 _0KLXruZqHV _1eOmH6ZqHV _0clgaMot27",
    hasDescription: "_0jFU0VDuDI",
    dragging: "_1YKVNsWOAI"
};
const $5638831521affcfb$var$nestedOpenPopupStyles = {
    root: "_2QSzKR7dHp _3eEnT0IZbP _1q1Zsn1Y8M _3pCGbVd1Zr",
    rootFinesse: "_3pCGbVo126",
    removeElemAfterOnHoverOrOpenNestedPopup: "_1wwaXwYbGa",
    selected: "_3pCGbVsumd"
};
const $5638831521affcfb$var$buttonOrAnchorStyles = {
    root: "_0bjKvDKTcp _2j3gqAg8pm _3B2K2Q7dHp _3iDTPbgBM8 _2iEGP2qccN _0ca6V7qccN _03SyCP1Y8M _0LQT5E1Y8M _46hvQm1Y8M _0xmtko1Y8M _0KLXrujOvk _1UtDYzZpcK _0hPCNLDIqT _2fwxA57p2s _2FPiMbJNoT",
    rootFinesse: "_2FPiMbN4oS",
    rootMotion: "_23rrnHo10F _1B4rbIo10F _3sFUREDdj4",
    selected: "_1UtDYzjTy9 _2FPiMbXsxn",
    selectedMotion: "_23rrnHWE38 _1B4rbIo10F _3sFUREDdj4",
    hasDragIndicator: "_3AKos1YbGa _3elJEbYbGa _2b6wcOQ4SZ _2ucLKKOIol _0vzPdeUiLg _4pWA4uMcca _0L8XzkgRhm"
};
const $5638831521affcfb$var$extendButtonOrAnchorStyles = {
    root: "_49OCfRPgdg _1mT5xdWVPG"
};
const $5638831521affcfb$var$notchStyles = {
    root: "_1mT5xdWVPG _2I62gz715P _3iC0zdPgdg _39xV024Jdh _0jFU0VxpxF _1VJPcakruI _0KLXruzNEo"
};
const $5638831521affcfb$var$actionStyles = {
    root: "_2mHwu81Y8M _1xC2CJnO1v _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0hPCNLDIqT _03SyCP1Y8M _3uh4XpyL8i _2yI6tSyL8i"
};
const $5638831521affcfb$var$actionsOnHoverStyles = {
    root: "_1xC2CJoUfk _2mHwu81Y8M _4bt5LAnQyn _2WAcuGnQyn _0hPCNLDIqT _3iDTPbQ4SZ _1YKVNsXcXg _39xV02xqYT _03SyCPk5xR _3uh4XpyL8i _2yI6tSyL8i"
};
const $5638831521affcfb$var$textStyles = {
    root: "_2mHwu8FQfX _4bt5LAnQyn _2WAcuGnQyn _03SyCP1Y8M _0LQT5E1Y8M _3iDTPbQ4SZ _0aFT5vbt8w _4ouGXIw0fc _3uh4XpyL8i _2yI6tSyL8i",
    noElemBeforeIndent: "_0LQT5EgVvo"
};
const $5638831521affcfb$var$elemBeforeStyles = {
    root: "_1xC2CJZyOa _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _3YEZNOdnbC _39xV02oWWg _0jFU0VoWWg _0hPCNLDIqT _37wbyuDIqT _0LQT5E1Y8M _24h04iPvdi _3uh4XpyL8i _2yI6tSyL8i"
};
const $5638831521affcfb$var$elemAfterStyles = {
    root: "_1xC2CJoUfk _4bt5LAnQyn _2WAcuGnQyn _3iDTPbx0Ks _3YEZNOdnbC _0jFU0VoWWg _0hPCNLDIqT _03SyCP1Y8M _3uh4XpyL8i _2yI6tSyL8i"
}; /**
    * We are using a wrapping element for our interactive content
    * even though only the `Text` element is the only thing not using `position:absolute`
    *
    * Rationale:
    * - Super clear that everything inside the interactive content should be in a specific slot in the grid
    * - To work around a browser bug in Safari where it does not work well with `position:absolute`
    *   on a subgrid child.
    *   Safari bug: https://bugs.webkit.org/show_bug.cgi?id=292516
    */ 
const $5638831521affcfb$var$interactiveContentStyles = {
    root: "_1xC2CJxFwi _3iDTPbQ4SZ _0aFT5vbt8w _0GwItXDIqT"
};
function $5638831521affcfb$var$getTextColor({ isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'color.text.disabled';
    if (isSelected) return 'color.text.selected';
    return 'color.text.subtle';
} /**
   * Includes all props that are used by any menu item, as MenuItembase is the base component for all menu item components.
   *
   * We also include additional `aria` props to support the menu item being a trigger for the FlyoutMenuItem popup and for the
   * expanded content for ExpandableMenuItem.
   */ 
const $5638831521affcfb$var$MenuItemBaseNoRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, forwardedRef)=>{
    const $ = (0, $bDgLe.c)(82);
    const { id: id, testId: testId, actions: actions, actionsOnHover: actionsOnHover, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaHasPopup: ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator } = t0;
    const level = (0, $8AWCX.useLevel)();
    const setFlyoutMenuOpen = (0, $1TBPy.useSetFlyoutMenuOpen)();
    const isFlyoutMenuOpen = (0, $1TBPy.useFlyoutMenuOpen)();
    const isLink = typeof href !== "undefined";
    const isFinesseEnabled = (0, $iDrrr.fg)("platform-dst-tokens-finesse");
    const labelRef = (0, $cozmU.useRef)(null);
    const descriptionRef = (0, $cozmU.useRef)(null);
    const tooltipOnClick = (0, $cozmU.useRef)(null);
    let t1;
    if ($[0] !== isFlyoutMenuOpen || $[1] !== onClick || $[2] !== setFlyoutMenuOpen) {
        t1 = (event, analyticsEvent)=>{
            onClick?.(event, analyticsEvent);
            setFlyoutMenuOpen(!isFlyoutMenuOpen);
            tooltipOnClick.current?.(event);
        };
        $[0] = isFlyoutMenuOpen;
        $[1] = onClick;
        $[2] = setFlyoutMenuOpen;
        $[3] = t1;
    } else t1 = $[3];
    const handleClick = t1;
    let t2;
    if ($[4] !== isContentTooltipDisabled) {
        t2 = ()=>{
            if (isContentTooltipDisabled) return false;
            const label = labelRef.current;
            const description_0 = descriptionRef.current;
            if (label && $5638831521affcfb$var$isTextClamped(label)) return true;
            return Boolean(description_0 && $5638831521affcfb$var$isTextClamped(description_0));
        };
        $[4] = isContentTooltipDisabled;
        $[5] = t2;
    } else t2 = $[5];
    const canTooltipAppear = t2;
    const showElemBefore = elemBefore !== (0, $3TF4i.COLLAPSE_ELEM_BEFORE);
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            $5638831521affcfb$var$interactiveContentStyles.root
        ]);
        $[6] = t3;
    } else t3 = $[6];
    const t4 = `calc(-1 * ${level} * ${(0, $5BGbo.expandableMenuItemIndentation)})`;
    let t5;
    if ($[7] !== t4) {
        t5 = {
            insetInlineStart: t4
        };
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            $5638831521affcfb$var$extendButtonOrAnchorStyles.root
        ]);
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t5) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: t5,
            "aria-hidden": "true",
            className: t6
        });
        $[10] = t5;
        $[11] = t7;
    } else t7 = $[11];
    const t8 = !showElemBefore && $5638831521affcfb$var$textStyles.noElemBeforeIndent;
    let t9;
    if ($[12] !== t8) {
        t9 = (0, $hekY6.default)([
            $5638831521affcfb$var$textStyles.root,
            t8
        ]);
        $[12] = t8;
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== isDisabled || $[15] !== isSelected) {
        t10 = $5638831521affcfb$var$getTextColor({
            isDisabled: isDisabled,
            isSelected: isSelected
        });
        $[14] = isDisabled;
        $[15] = isSelected;
        $[16] = t10;
    } else t10 = $[16];
    let t11;
    if ($[17] !== children || $[18] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "medium",
            maxLines: 1,
            color: t10,
            ref: labelRef
        }, children);
        $[17] = children;
        $[18] = t10;
        $[19] = t11;
    } else t11 = $[19];
    let t12;
    if ($[20] !== description || $[21] !== isDisabled || $[22] !== isSelected) {
        t12 = description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: $5638831521affcfb$var$getTextColor({
                isDisabled: isDisabled,
                isSelected: isSelected
            }),
            size: "small",
            maxLines: 1,
            ref: descriptionRef
        }, description);
        $[20] = description;
        $[21] = isDisabled;
        $[22] = isSelected;
        $[23] = t12;
    } else t12 = $[23];
    let t13;
    if ($[24] !== t11 || $[25] !== t12 || $[26] !== t9) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t9
        }, t11, t12);
        $[24] = t11;
        $[25] = t12;
        $[26] = t9;
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[28] !== hasDragIndicator) {
        t14 = hasDragIndicator ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8VFFa.DragHandle), null) : null;
        $[28] = hasDragIndicator;
        $[29] = t14;
    } else t14 = $[29];
    let t15;
    if ($[30] !== dropIndicator || $[31] !== t13 || $[32] !== t14 || $[33] !== t7) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t3
        }, t7, t13, t14, dropIndicator);
        $[30] = dropIndicator;
        $[31] = t13;
        $[32] = t14;
        $[33] = t7;
        $[34] = t15;
    } else t15 = $[34];
    const interactiveElemContent = t15;
    const showHoverActionsWhenNotHovered = Boolean(ariaExpanded && actionsOnHover);
    const t16 = (0, $3v3yD.AvatarContext);
    const t17 = $5638831521affcfb$var$defaultAvatarValues;
    const t18 = testId ? `${testId}-container` : undefined;
    const t19 = (0, $hekY6.default)([
        $5638831521affcfb$var$containerStyles.root,
        (0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") && $5638831521affcfb$var$containerStyles.rootMotion,
        $5638831521affcfb$var$nestedOpenPopupStyles.root,
        isFinesseEnabled && $5638831521affcfb$var$containerStyles.rootFinesse,
        isFinesseEnabled && $5638831521affcfb$var$nestedOpenPopupStyles.rootFinesse,
        isSelected && $5638831521affcfb$var$containerStyles.selected,
        isSelected && (0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") && $5638831521affcfb$var$containerStyles.selectedMotion,
        isSelected && $5638831521affcfb$var$nestedOpenPopupStyles.selected,
        isDragging && $5638831521affcfb$var$containerStyles.dragging,
        description && $5638831521affcfb$var$containerStyles.hasDescription,
        showHoverActionsWhenNotHovered && $5638831521affcfb$var$containerStyles.showHoverActions,
        showHoverActionsWhenNotHovered && elemAfter && $5638831521affcfb$var$containerStyles.removeElemAfter,
        actionsOnHover && elemAfter && $5638831521affcfb$var$containerStyles.removeElemAfterOnHoverOrOpenNestedPopup,
        actionsOnHover && elemAfter && $5638831521affcfb$var$nestedOpenPopupStyles.removeElemAfterOnHoverOrOpenNestedPopup,
        isDisabled && $5638831521affcfb$var$containerStyles.disabled
    ]);
    let t20;
    if ($[35] !== children || $[36] !== description) {
        t20 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, children), description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, description) : null);
        $[35] = children;
        $[36] = description;
        $[37] = t20;
    } else t20 = $[37];
    let t21;
    if ($[38] !== ariaControls || $[39] !== ariaExpanded || $[40] !== ariaHasPopup || $[41] !== forwardedRef || $[42] !== handleClick || $[43] !== hasDragIndicator || $[44] !== href || $[45] !== id || $[46] !== interactionName || $[47] !== interactiveElemContent || $[48] !== isDisabled || $[49] !== isFinesseEnabled || $[50] !== isLink || $[51] !== isSelected || $[52] !== target || $[53] !== testId) {
        t21 = (tooltipProps)=>{
            tooltipOnClick.current = tooltipProps.onClick;
            const sharedProps = {
                ...tooltipProps,
                "aria-controls": ariaControls,
                "aria-haspopup": ariaHasPopup,
                ref: (0, $lmzCg.default)([
                    forwardedRef,
                    tooltipProps.ref
                ]),
                id: id,
                testId: testId,
                interactionName: interactionName
            };
            return isLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
                ...sharedProps,
                onClick: handleClick,
                xcss: (0, $k12R1.cx)($5638831521affcfb$var$buttonOrAnchorStyles.root, (0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") && $5638831521affcfb$var$buttonOrAnchorStyles.rootMotion, isFinesseEnabled && $5638831521affcfb$var$buttonOrAnchorStyles.rootFinesse, $5638831521affcfb$var$topLevelSiblingStyles.root, isSelected && $5638831521affcfb$var$buttonOrAnchorStyles.selected, isSelected && (0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") && $5638831521affcfb$var$buttonOrAnchorStyles.selectedMotion, hasDragIndicator && $5638831521affcfb$var$buttonOrAnchorStyles.hasDragIndicator),
                style: $5638831521affcfb$var$anchorTextDecorationResetStyle,
                "aria-current": isSelected ? "page" : undefined,
                href: href,
                target: target,
                draggable: hasDragIndicator ? undefined : false
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "aria-hidden": "true",
                className: (0, $hekY6.default)([
                    $5638831521affcfb$var$notchStyles.root
                ])
            }), interactiveElemContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                ...sharedProps,
                onClick: handleClick,
                xcss: (0, $k12R1.cx)($5638831521affcfb$var$buttonOrAnchorStyles.root, (0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") && $5638831521affcfb$var$buttonOrAnchorStyles.rootMotion, isFinesseEnabled && $5638831521affcfb$var$buttonOrAnchorStyles.rootFinesse, $5638831521affcfb$var$topLevelSiblingStyles.root, isSelected && $5638831521affcfb$var$buttonOrAnchorStyles.selected, isSelected && (0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") && $5638831521affcfb$var$buttonOrAnchorStyles.selectedMotion, hasDragIndicator && $5638831521affcfb$var$buttonOrAnchorStyles.hasDragIndicator),
                "aria-expanded": ariaExpanded,
                isDisabled: isDisabled
            }, interactiveElemContent);
        };
        $[38] = ariaControls;
        $[39] = ariaExpanded;
        $[40] = ariaHasPopup;
        $[41] = forwardedRef;
        $[42] = handleClick;
        $[43] = hasDragIndicator;
        $[44] = href;
        $[45] = id;
        $[46] = interactionName;
        $[47] = interactiveElemContent;
        $[48] = isDisabled;
        $[49] = isFinesseEnabled;
        $[50] = isLink;
        $[51] = isSelected;
        $[52] = target;
        $[53] = testId;
        $[54] = t21;
    } else t21 = $[54];
    let t22;
    if ($[55] !== canTooltipAppear || $[56] !== t20 || $[57] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t20,
            position: "right-start",
            ignoreTooltipPointerEvents: true,
            hideTooltipOnMouseDown: true,
            isScreenReaderAnnouncementDisabled: true,
            canAppear: canTooltipAppear
        }, t21);
        $[55] = canTooltipAppear;
        $[56] = t20;
        $[57] = t21;
        $[58] = t22;
    } else t22 = $[58];
    let t23;
    if ($[59] !== elemBefore || $[60] !== showElemBefore) {
        t23 = showElemBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $5638831521affcfb$var$elemBeforeStyles.root,
                $5638831521affcfb$var$topLevelSiblingStyles.root,
                $5638831521affcfb$var$onTopOfButtonOrAnchorStyles.root
            ])
        }, elemBefore);
        $[59] = elemBefore;
        $[60] = showElemBefore;
        $[61] = t23;
    } else t23 = $[61];
    let t24;
    if ($[62] !== actionsOnHover) {
        t24 = actionsOnHover && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $5638831521affcfb$var$actionsOnHoverStyles.root
            ])
        }, actionsOnHover);
        $[62] = actionsOnHover;
        $[63] = t24;
    } else t24 = $[63];
    let t25;
    if ($[64] !== elemAfter) {
        t25 = elemAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $5638831521affcfb$var$elemAfterStyles.root,
                $5638831521affcfb$var$topLevelSiblingStyles.root,
                $5638831521affcfb$var$onTopOfButtonOrAnchorStyles.root
            ])
        }, elemAfter);
        $[64] = elemAfter;
        $[65] = t25;
    } else t25 = $[65];
    let t26;
    if ($[66] !== actions) {
        t26 = actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $5638831521affcfb$var$actionStyles.root,
                $5638831521affcfb$var$topLevelSiblingStyles.root,
                $5638831521affcfb$var$onTopOfButtonOrAnchorStyles.root
            ])
        }, actions);
        $[66] = actions;
        $[67] = t26;
    } else t26 = $[67];
    let t27;
    if ($[68] !== isSelected || $[69] !== t18 || $[70] !== t19 || $[71] !== t22 || $[72] !== t23 || $[73] !== t24 || $[74] !== t25 || $[75] !== t26 || $[76] !== visualContentRef) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: visualContentRef,
            "data-testid": t18,
            "data-selected": isSelected,
            className: t19
        }, t22, t23, t24, t25, t26);
        $[68] = isSelected;
        $[69] = t18;
        $[70] = t19;
        $[71] = t22;
        $[72] = t23;
        $[73] = t24;
        $[74] = t25;
        $[75] = t26;
        $[76] = visualContentRef;
        $[77] = t27;
    } else t27 = $[77];
    let t28;
    if ($[78] !== t16.Provider || $[79] !== t17 || $[80] !== t27) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(t16.Provider, {
            value: t17
        }, t27);
        $[78] = t16.Provider;
        $[79] = t17;
        $[80] = t27;
        $[81] = t28;
    } else t28 = $[81];
    return t28;
} : ({ id: id, testId: testId, actions: actions, actionsOnHover: actionsOnHover, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaHasPopup: ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const level = (0, $8AWCX.useLevel)();
    const setFlyoutMenuOpen = (0, $1TBPy.useSetFlyoutMenuOpen)();
    const isFlyoutMenuOpen = (0, $1TBPy.useFlyoutMenuOpen)();
    const isLink = typeof href !== 'undefined';
    const isFinesseEnabled = (0, $iDrrr.fg)('platform-dst-tokens-finesse');
    const labelRef = (0, $cozmU.useRef)(null);
    const descriptionRef = (0, $cozmU.useRef)(null);
    const tooltipOnClick = (0, $cozmU.useRef)(null);
    const handleClick = (0, $cozmU.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent); // Toggle flyout menu open state when inside a flyout context provider
        setFlyoutMenuOpen(!isFlyoutMenuOpen);
        tooltipOnClick.current?.(event);
    }, [
        onClick,
        setFlyoutMenuOpen,
        isFlyoutMenuOpen
    ]); /**
                                                       * Show the tooltip if _either_ label or description is truncated
                                                       */ 
    const canTooltipAppear = (0, $cozmU.useCallback)(()=>{
        if (isContentTooltipDisabled) return false;
         // Show tooltip if _either_ label or description are clamped
        const label = labelRef.current;
        const description_0 = descriptionRef.current;
        if (label && $5638831521affcfb$var$isTextClamped(label)) return true;
        return Boolean(description_0 && $5638831521affcfb$var$isTextClamped(description_0));
    }, [
        isContentTooltipDisabled
    ]); // By default provide the spacing for `elemBefore` to have good
    // vertical alignment of labels and to give clear indentation between levels
    // in the side navigation (even when items don't use elemBefore).
    const showElemBefore = elemBefore !== (0, $3TF4i.COLLAPSE_ELEM_BEFORE);
    const interactiveElemContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $5638831521affcfb$var$interactiveContentStyles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // This extends the clickable area of nested menu items to the width
    , {
        // of the root level menu items, while being visually indented.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            insetInlineStart: `calc(-1 * ${level} * ${(0, $5BGbo.expandableMenuItemIndentation)})`
        },
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            $5638831521affcfb$var$extendButtonOrAnchorStyles.root
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $5638831521affcfb$var$textStyles.root,
            !showElemBefore && $5638831521affcfb$var$textStyles.noElemBeforeIndent
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium",
        maxLines: 1,
        color: $5638831521affcfb$var$getTextColor({
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        ref: labelRef
    }, children), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: $5638831521affcfb$var$getTextColor({
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        size: "small",
        maxLines: 1,
        ref: descriptionRef
    }, description)), hasDragIndicator ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8VFFa.DragHandle), null) : null, dropIndicator); /**
           *  If the [expandable] menu item is expanded, show hover actions even when *not* hovered.
           *
           * Note: we also remove the `elemAfter` when showing `actionsOnHover`
           */ 
    const showHoverActionsWhenNotHovered = Boolean(ariaExpanded && actionsOnHover);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3v3yD.AvatarContext).Provider, {
        value: $5638831521affcfb$var$defaultAvatarValues
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: visualContentRef,
        "data-testid": testId ? `${testId}-container` : undefined,
        "data-selected": isSelected,
        className: (0, $hekY6.default)([
            $5638831521affcfb$var$containerStyles.root,
            (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') && $5638831521affcfb$var$containerStyles.rootMotion,
            $5638831521affcfb$var$nestedOpenPopupStyles.root,
            isFinesseEnabled && $5638831521affcfb$var$containerStyles.rootFinesse,
            isFinesseEnabled && $5638831521affcfb$var$nestedOpenPopupStyles.rootFinesse,
            isSelected && $5638831521affcfb$var$containerStyles.selected,
            isSelected && (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') && $5638831521affcfb$var$containerStyles.selectedMotion,
            isSelected && $5638831521affcfb$var$nestedOpenPopupStyles.selected,
            isDragging && $5638831521affcfb$var$containerStyles.dragging,
            description && $5638831521affcfb$var$containerStyles.hasDescription,
            showHoverActionsWhenNotHovered && $5638831521affcfb$var$containerStyles.showHoverActions,
            showHoverActionsWhenNotHovered && elemAfter && $5638831521affcfb$var$containerStyles.removeElemAfter,
            actionsOnHover && elemAfter && $5638831521affcfb$var$containerStyles.removeElemAfterOnHoverOrOpenNestedPopup,
            actionsOnHover && elemAfter && $5638831521affcfb$var$nestedOpenPopupStyles.removeElemAfterOnHoverOrOpenNestedPopup,
            isDisabled && $5638831521affcfb$var$containerStyles.disabled
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, children), description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, description) : null),
        position: "right-start",
        ignoreTooltipPointerEvents: true,
        hideTooltipOnMouseDown: true // We don't need a duplicate hidden element containing tooltip content
        ,
        // as the content of the tooltip matches what is rendered for the menu item.
        isScreenReaderAnnouncementDisabled: true,
        canAppear: canTooltipAppear
    }, (tooltipProps)=>{
        // Putting the tooltip onClick into a ref.
        // This way we don't need to create a new `onClick` function on each
        // render (as we would need to merge `tooltipProps.onClick` and our `handleClick`)
        tooltipOnClick.current = tooltipProps.onClick;
        const sharedProps = {
            ...tooltipProps,
            'aria-controls': ariaControls,
            'aria-haspopup': ariaHasPopup,
            ref: (0, $lmzCg.default)([
                forwardedRef,
                tooltipProps.ref
            ]),
            id: id,
            testId: testId,
            interactionName: interactionName
        };
        return isLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
            ...sharedProps,
            onClick: handleClick,
            xcss: (0, $k12R1.cx)($5638831521affcfb$var$buttonOrAnchorStyles.root, (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') && $5638831521affcfb$var$buttonOrAnchorStyles.rootMotion, isFinesseEnabled && $5638831521affcfb$var$buttonOrAnchorStyles.rootFinesse, $5638831521affcfb$var$topLevelSiblingStyles.root, isSelected && $5638831521affcfb$var$buttonOrAnchorStyles.selected, isSelected && (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') && $5638831521affcfb$var$buttonOrAnchorStyles.selectedMotion, hasDragIndicator && $5638831521affcfb$var$buttonOrAnchorStyles.hasDragIndicator),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: $5638831521affcfb$var$anchorTextDecorationResetStyle,
            "aria-current": isSelected ? 'page' : undefined,
            href: href,
            target: target,
            draggable: hasDragIndicator ? undefined : false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "aria-hidden": "true",
            className: (0, $hekY6.default)([
                $5638831521affcfb$var$notchStyles.root
            ])
        }), interactiveElemContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            ...sharedProps,
            onClick: handleClick,
            xcss: (0, $k12R1.cx)($5638831521affcfb$var$buttonOrAnchorStyles.root, (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') && $5638831521affcfb$var$buttonOrAnchorStyles.rootMotion, isFinesseEnabled && $5638831521affcfb$var$buttonOrAnchorStyles.rootFinesse, $5638831521affcfb$var$topLevelSiblingStyles.root, isSelected && $5638831521affcfb$var$buttonOrAnchorStyles.selected, isSelected && (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') && $5638831521affcfb$var$buttonOrAnchorStyles.selectedMotion, hasDragIndicator && $5638831521affcfb$var$buttonOrAnchorStyles.hasDragIndicator),
            "aria-expanded": ariaExpanded,
            isDisabled: isDisabled
        }, interactiveElemContent);
    }), showElemBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $5638831521affcfb$var$elemBeforeStyles.root,
            $5638831521affcfb$var$topLevelSiblingStyles.root,
            $5638831521affcfb$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, elemBefore), actionsOnHover && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $5638831521affcfb$var$actionsOnHoverStyles.root
        ])
    }, actionsOnHover), elemAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $5638831521affcfb$var$elemAfterStyles.root,
            $5638831521affcfb$var$topLevelSiblingStyles.root,
            $5638831521affcfb$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, elemAfter), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $5638831521affcfb$var$actionStyles.root,
            $5638831521affcfb$var$topLevelSiblingStyles.root,
            $5638831521affcfb$var$onTopOfButtonOrAnchorStyles.root
        ])
    }, actions)));
}; /**
    * __MenuItemBase__
    *
    * The base menu item component used to compose ButtonMenuItem and LinkMenuItem.
    *
    * It contains a type argument `<T>`, to specify the type of the interactive element (`button` or `a`).
    * This can be inferred from the type of the `onClick` prop.
    */ 
const $5638831521affcfb$export$859b390bf71e044e = (0, $4Qc44.default)($5638831521affcfb$var$MenuItemBaseNoRef);
module.exports["MenuItemBase"] = $5638831521affcfb$export$859b390bf71e044e;

});

parcelRegister("4Qc44", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5936b606760a760$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $e5936b606760a760$export$2e2bcd8739ae039 = (0, $cozmU.forwardRef);

});

parcelRegister("5BGbo", function(module, exports) {
/**
 * _Internally_ shared value for the menu item indentation. Used in:
 * - Expandable menu item content, to add padding for each expandable level
 * - The base menu item, to set the negative inset to extend the clickable area of nested menu items
 * to the root level menu items.
 *
 * Internal to the package only. Should not be exported from the package.
 *
 * Note: We're unable to use a token() call here, as Compiled complains about function calls in imported
 * values - it requires statically defined values only.
 *
 * @private
 * @internal
 */ const $45ab1e0d57f7b75e$export$d492445a79a49b48 = '12px';
module.exports["expandableMenuItemIndentation"] = $45ab1e0d57f7b75e$export$d492445a79a49b48;

});

parcelRegister("8VFFa", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $8LYsc = parcelRequire("8LYsc");

const $8987a63c5c396e33$var$styles = {
    root: "_1UtDYzZpcK _3iDTPblSYR _0aFT5vbt8w _37wbyuDIqT _1mT5xdWVPG _2I62gzdnbC _1ZB6UydnbC _3iC0zddnbC _0GTcwRB0rP"
};
const $8987a63c5c396e33$export$a0c24614540b0efb = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DragHandle() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("div", {
            "aria-hidden": "true",
            className: (0, $hekY6.default)([
                $8987a63c5c396e33$var$styles.root
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8LYsc))), {
            label: "",
            size: "small"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function DragHandle() {
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            $8987a63c5c396e33$var$styles.root
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8LYsc))), {
        label: "",
        size: "small"
    }));
};
module.exports["DragHandle"] = $8987a63c5c396e33$export$a0c24614540b0efb;

});

parcelRegister("8AWCX", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");


var $6q25I = parcelRequire("6q25I");

const $bcae43b5e5d77907$export$9c01e0e6a504d553 = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $bcae43b5e5d77907$export$c856e5885cc34d81 = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $bcae43b5e5d77907$export$48cb11cb8691f597 = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $bcae43b5e5d77907$export$572ce188c913ceba = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $bcae43b5e5d77907$export$650d12d3c2ddb8fc = (0, $6q25I.ExpandableMenuItemLevelContext);
const $bcae43b5e5d77907$export$37e565a09598825e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)($bcae43b5e5d77907$export$c856e5885cc34d81);
    (0, $bB0i2.default)(context !== null, "useIsExpanded must be used within an ExpandableMenuItem");
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)($bcae43b5e5d77907$export$c856e5885cc34d81);
    (0, $bB0i2.default)(context !== null, 'useIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
const $bcae43b5e5d77907$export$c9a171ea8de5861b = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)($bcae43b5e5d77907$export$48cb11cb8691f597);
    (0, $bB0i2.default)(context !== null, "useSetIsExpanded must be used within an ExpandableMenuItem");
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)($bcae43b5e5d77907$export$48cb11cb8691f597);
    (0, $bB0i2.default)(context !== null, 'useSetIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
const $bcae43b5e5d77907$export$56c8438498b72c7a = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($bcae43b5e5d77907$export$572ce188c913ceba);
} : ()=>(0, $cozmU.useContext)($bcae43b5e5d77907$export$572ce188c913ceba);
const $bcae43b5e5d77907$export$fdfe9e5e8183d4f2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($bcae43b5e5d77907$export$650d12d3c2ddb8fc);
} : ()=>(0, $cozmU.useContext)($bcae43b5e5d77907$export$650d12d3c2ddb8fc);
const $bcae43b5e5d77907$export$57108b5f08ae5194 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($bcae43b5e5d77907$export$9c01e0e6a504d553) ?? true;
} : ()=>(0, $cozmU.useContext)($bcae43b5e5d77907$export$9c01e0e6a504d553) ?? true;
module.exports["AreAllAncestorsExpandedContext"] = $bcae43b5e5d77907$export$9c01e0e6a504d553;
module.exports["IsExpandedContext"] = $bcae43b5e5d77907$export$c856e5885cc34d81;
module.exports["SetIsExpandedContext"] = $bcae43b5e5d77907$export$48cb11cb8691f597;
module.exports["OnExpansionToggleContext"] = $bcae43b5e5d77907$export$572ce188c913ceba;
module.exports["LevelContext"] = $bcae43b5e5d77907$export$650d12d3c2ddb8fc;
module.exports["useIsExpanded"] = $bcae43b5e5d77907$export$37e565a09598825e;
module.exports["useSetIsExpanded"] = $bcae43b5e5d77907$export$c9a171ea8de5861b;
module.exports["useOnExpansionToggle"] = $bcae43b5e5d77907$export$56c8438498b72c7a;
module.exports["useLevel"] = $bcae43b5e5d77907$export$fdfe9e5e8183d4f2;
module.exports["useAreAllAncestorsExpanded"] = $bcae43b5e5d77907$export$57108b5f08ae5194;

});

parcelRegister("6q25I", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $0b23dba5ac65c5d1$export$f8d6463f9b5ca897 = /*#__PURE__*/ (0, $cozmU.createContext)(0);
module.exports["ExpandableMenuItemLevelContext"] = $0b23dba5ac65c5d1$export$f8d6463f9b5ca897;

});

parcelRegister("1TBPy", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");

const $e3ebb2a554993ae8$export$efa4d9670e96ac31 = /*#__PURE__*/ (0, $cozmU.createContext)(false);
const $e3ebb2a554993ae8$export$4c55b1c61a116b42 = /*#__PURE__*/ (0, $cozmU.createContext)((0, $dpsRj.default));
const $e3ebb2a554993ae8$export$6927118f874a49aa = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e3ebb2a554993ae8$export$efa4d9670e96ac31);
} : ()=>(0, $cozmU.useContext)($e3ebb2a554993ae8$export$efa4d9670e96ac31);
const $e3ebb2a554993ae8$export$538ac1aa421adb94 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e3ebb2a554993ae8$export$4c55b1c61a116b42);
} : ()=>(0, $cozmU.useContext)($e3ebb2a554993ae8$export$4c55b1c61a116b42);
const $e3ebb2a554993ae8$export$aca29900ef2078d3 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $e3ebb2a554993ae8$export$c768f9564e21558a = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $e3ebb2a554993ae8$export$7376ab1fc7707bdd = /*#__PURE__*/ (0, $cozmU.createContext)({
    current: null
});
const $e3ebb2a554993ae8$export$fb4c7299c436068c = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $e3ebb2a554993ae8$export$761b237ca835a288 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e3ebb2a554993ae8$export$fb4c7299c436068c);
} : ()=>(0, $cozmU.useContext)($e3ebb2a554993ae8$export$fb4c7299c436068c);
const $e3ebb2a554993ae8$export$9abe8108f4bc916 = $e3ebb2a554993ae8$export$fb4c7299c436068c.Provider;
module.exports["IsOpenContext"] = $e3ebb2a554993ae8$export$efa4d9670e96ac31;
module.exports["SetIsOpenContext"] = $e3ebb2a554993ae8$export$4c55b1c61a116b42;
module.exports["useFlyoutMenuOpen"] = $e3ebb2a554993ae8$export$6927118f874a49aa;
module.exports["useSetFlyoutMenuOpen"] = $e3ebb2a554993ae8$export$538ac1aa421adb94;
module.exports["SetInitialFocusRefContext"] = $e3ebb2a554993ae8$export$aca29900ef2078d3;
module.exports["InitialFocusOriginContext"] = $e3ebb2a554993ae8$export$c768f9564e21558a;
module.exports["OnCloseContext"] = $e3ebb2a554993ae8$export$7376ab1fc7707bdd;
module.exports["useTitleId"] = $e3ebb2a554993ae8$export$761b237ca835a288;
module.exports["TitleIdContextProvider"] = $e3ebb2a554993ae8$export$9abe8108f4bc916;

});

parcelRegister("3TF4i", function(module, exports) {
/**
 * A symbol to collapse the `elemBefore` slot.
 * This should be placed in the `elemBefore` prop of supported menu items.
 */ const $5a71eb42bbdc1a68$export$f4b8e24fae579c6f = Symbol('collapse-elem-before');
module.exports["COLLAPSE_ELEM_BEFORE"] = $5a71eb42bbdc1a68$export$f4b8e24fae579c6f;

});

parcelRegister("h11I1", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $hLtfj = parcelRequire("hLtfj");

const $3bcb034fbc52807a$export$6c2f3257abc4825b = (0, $hLtfj.ListItem);
module.exports["MenuListItem"] = $3bcb034fbc52807a$export$6c2f3257abc4825b;

});

parcelRegister("hLtfj", function(module, exports) {
/* list-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");

function $0210a31b93b69349$var$_ListItem({ children: children, testId: testId, xcss: xcss }, ref) {
    return /*#__PURE__*/ $cozmU.createElement("div", {
        role: "listitem",
        ref: ref,
        className: xcss,
        "data-testid": testId
    }, children);
}
const $0210a31b93b69349$export$a7b06bfba60a8a78 = /*#__PURE__*/ (0, $cozmU.forwardRef)($0210a31b93b69349$var$_ListItem);
module.exports["ListItem"] = $0210a31b93b69349$export$a7b06bfba60a8a78;

});

parcelRegister("iDdJP", function(module, exports) {

var $k27u5 = parcelRequire("k27u5");

const $c514d668c0af497d$export$d4c4e98c5044dc8 = (0, $k27u5.List);
module.exports["MenuList"] = $c514d668c0af497d$export$d4c4e98c5044dc8;

});

parcelRegister("k27u5", function(module, exports) {
/* list.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");

function $3028fcb6dba16eaa$var$_List({ children: children, testId: testId, xcss: xcss }, forwardedRef) {
    return(/**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ /*#__PURE__*/ $cozmU.createElement("div", {
        role: "list",
        ref: forwardedRef,
        className: xcss,
        "data-testid": testId
    }, children));
}
const $3028fcb6dba16eaa$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $cozmU.forwardRef)($3028fcb6dba16eaa$var$_List);
module.exports["List"] = $3028fcb6dba16eaa$export$54c2e3dc7acea9f5;

});

parcelRegister("g26MG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fBqzD = parcelRequire("fBqzD");


var $5lkNm = parcelRequire("5lkNm");


var $krxYo = parcelRequire("krxYo");


var $fGLQm = parcelRequire("fGLQm");

var $itlCX = parcelRequire("itlCX");

const $bab3f5eb7fd997b5$var$AccessClassIcon = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5lkNm.ConfluenceIcon), {
        appearance: 'brand'
    });
const $bab3f5eb7fd997b5$var$getPrincipalIcon = (principal)=>{
    switch(principal.__typename){
        case 'SpaceRoleGroupPrincipal':
            return 0, (/*@__PURE__*/$parcel$interopDefault($fBqzD));
        case 'SpaceRoleAccessClassPrincipal':
            return principal.principalId === 'anonymous-users' ? (0, (/*@__PURE__*/$parcel$interopDefault($krxYo))) : $bab3f5eb7fd997b5$var$AccessClassIcon;
        case 'ConfluenceSpaceRoleAgentPrincipal':
        case 'ConfluenceSpaceRoleAppPrincipal':
        case 'SpaceRoleGuestPrincipal':
        case 'SpaceRoleUserPrincipal':
        default:
            return null;
    }
};
const $bab3f5eb7fd997b5$export$4b3b0188cc9d39a8 = (data, isCompanyHub = false)=>{
    return data.map((item)=>({
            key: item.id,
            groupName: item.group.displayName,
            groupPriority: item.group.priority,
            // Use hubDisplayName if in companyhub context, otherwise fall back to displayName
            actionName: isCompanyHub && item.hubDisplayName || item.displayName,
            priority: item.priority,
            // Use hubDescription if in companyhub context, otherwise fall back to description
            description: isCompanyHub && item.hubDescription || item.description,
            requiredPermissions: item.requiredSpacePermissions ? [
                ...item.requiredSpacePermissions
            ].map((p)=>p ?? null) : null
        }))// Filter out all actions without display names before the deprecation of some permissions is completed
    .filter((item)=>!!item.actionName);
};
const $bab3f5eb7fd997b5$export$429eba48f8769b83 = (rawData)=>{
    return rawData.filter((d)=>d != null).map((item)=>({
            id: item.roleId,
            name: item.roleDisplayName,
            description: item.roleDescription,
            permissions: item.spacePermissionList.map((permission)=>permission.id),
            roleType: item.roleType,
            confluenceRoleAssignabilityCode: item.confluenceRoleAssignabilityCode,
            isDisabled: !!('disabled' in item && item.disabled)
        }));
};
const $bab3f5eb7fd997b5$export$8bdeeb44c9ac0591 = (type)=>{
    switch(type){
        case 'SpaceRoleGuestPrincipal':
            // Guests are users.
            return (0, $itlCX.RoleAssignmentPrincipalType).USER;
        case 'ConfluenceSpaceRoleAppPrincipal':
        case 'ConfluenceSpaceRoleAgentPrincipal':
            return (0, $itlCX.RoleAssignmentPrincipalType).APP;
        case 'SpaceRoleGroupPrincipal':
            // Teams are groups.
            return (0, $itlCX.RoleAssignmentPrincipalType).GROUP;
        case 'SpaceRoleUserPrincipal':
            return (0, $itlCX.RoleAssignmentPrincipalType).USER;
        case 'SpaceRoleAccessClassPrincipal':
            return (0, $itlCX.RoleAssignmentPrincipalType).ACCESS_CLASS;
        default:
            return (0, $itlCX.RoleAssignmentPrincipalType).GROUP;
    }
};
const $bab3f5eb7fd997b5$export$bf16ef98b7c6b580 = (type)=>{
    switch(type){
        case 'user':
            return (0, $itlCX.RoleAssignmentPrincipalType).USER;
        case 'team':
            return (0, $itlCX.RoleAssignmentPrincipalType).GROUP;
        case 'group':
            return (0, $itlCX.RoleAssignmentPrincipalType).GROUP;
        case 'external_user':
            return (0, $itlCX.RoleAssignmentPrincipalType).USER;
        case 'custom':
            return (0, $itlCX.RoleAssignmentPrincipalType).ACCESS_CLASS;
        default:
            return (0, $itlCX.RoleAssignmentPrincipalType).USER;
    }
};
/**
 * Only users have profile cards for now. Apps/agents are excluded until the backend
 * distinguishes agents from apps (agents should show a card, plain apps should not);
 * groups, teams, and access classes never have cards. Guests are additionally excluded
 * at the call site because their cards are incomplete and not resolvable in the Teams app.
 */ const $bab3f5eb7fd997b5$var$HOVER_CARD_ELIGIBLE_PRINCIPAL_TYPES = new Set([
    (0, $itlCX.RoleAssignmentPrincipalType).USER
]);
const $bab3f5eb7fd997b5$export$62cb41ae198d08e7 = (type)=>$bab3f5eb7fd997b5$var$HOVER_CARD_ELIGIBLE_PRINCIPAL_TYPES.has(type);
const $bab3f5eb7fd997b5$export$6ca93df05f268de9 = (type)=>$bab3f5eb7fd997b5$export$62cb41ae198d08e7($bab3f5eb7fd997b5$export$bf16ef98b7c6b580(type));
const $bab3f5eb7fd997b5$export$1c34a8ae4dfc585c = (rawData)=>{
    if (!rawData) return [];
    return rawData.map((item)=>{
        const { principal: principal, role: role } = item;
        const isTeam = principal.__typename === 'SpaceRoleGroupPrincipal' && principal.usageType === (0, $fGLQm.ConfluenceGroupUsageType).TEAM_COLLABORATION;
        return {
            assignmentId: principal.principalId,
            // BE will support the assignmentId in the future
            principal: {
                id: principal.principalId,
                displayName: principal.displayName,
                type: $bab3f5eb7fd997b5$export$8bdeeb44c9ac0591(principal.__typename),
                isAgent: principal.__typename === 'ConfluenceSpaceRoleAgentPrincipal',
                email: 'email' in principal ? principal?.email : undefined,
                avatarUrl: 'profilePicture' in principal ? principal.profilePicture?.path : undefined,
                icon: isTeam ? null : $bab3f5eb7fd997b5$var$getPrincipalIcon(principal),
                isGuest: principal.__typename === 'SpaceRoleGuestPrincipal',
                isTeam: isTeam
            },
            roleId: role?.roleId || null,
            roleLabel: role?.roleDisplayName || null,
            roleDescription: role?.roleDescription || null,
            // Principal can either be assigned granular space permissions, or permissions through a role
            permissions: item?.permissions?.map((permission)=>permission.id) || role?.spacePermissionList.map((permission)=>permission.id) || [],
            availableRoles: [],
            unavailableRoles: [],
            assignablePermissions: item.assignablePermissions?.map((permission)=>permission).filter(Boolean) || []
        };
    });
};
const $bab3f5eb7fd997b5$export$f41b22015074a487 = (groupCountRecords, assignments)=>{
    const groupCountMap = groupCountRecords.reduce((acc, { key: key, value: value })=>{
        if (key !== null && key !== undefined) acc[key] = value;
        return acc;
    }, {});
    return assignments.map((assignment)=>({
            ...assignment,
            principal: assignment.principal.type === (0, $itlCX.RoleAssignmentPrincipalType).GROUP ? {
                ...assignment.principal,
                groupCount: groupCountMap[assignment.principal.id] ?? undefined
            } : assignment.principal
        }));
};
const $bab3f5eb7fd997b5$export$89b4246717b63b9f = (assignments, teamData)=>{
    if (!teamData || !teamData.teamsV2 || teamData.teamsV2?.length === 0) return assignments;
    // Pre-compute a map of team IDs to team info for O(1) lookup
    const teamInfoMap = new Map();
    for (const team of teamData.teamsV2)if (team?.id) teamInfoMap.set(team.id, team);
    return assignments.map((row)=>{
        const teamInfo = teamInfoMap.get(row.principal.id);
        if (!teamInfo) return row;
        return {
            ...row,
            principal: {
                ...row.principal,
                icon: null,
                avatarUrl: teamInfo.largeAvatarImageUrl ?? undefined,
                isTeam: true,
                isVerified: teamInfo.type?.verified ?? undefined,
                teamData: teamInfo,
                teamTypeName: teamInfo.type?.name
            }
        };
    });
};
const $bab3f5eb7fd997b5$var$UNLICENSED_USERS_ID = 'authenticated-users';
const $bab3f5eb7fd997b5$export$b3299b59e278e268 = (assignments)=>assignments.filter((record)=>record.principal.id !== $bab3f5eb7fd997b5$var$UNLICENSED_USERS_ID);
const $bab3f5eb7fd997b5$export$2fed59ad085105af = (displayTypes)=>{
    return displayTypes.filter((type)=>type !== 'TEAM').concat(displayTypes.includes('TEAM') ? [
        (0, $fGLQm.PrincipalFilterType).GROUP
    ] : []);
};
const $bab3f5eb7fd997b5$export$cc79220753e2d98a = (filterTypes)=>{
    if (filterTypes.length === 0) return [];
    const typesToFilterOut = [];
    if (!filterTypes.includes((0, $fGLQm.PrincipalFilterType).GROUP)) typesToFilterOut.push((0, $fGLQm.ConfluenceGroupUsageType).USERBASE_GROUP);
    if (!filterTypes.includes('TEAM')) typesToFilterOut.push((0, $fGLQm.ConfluenceGroupUsageType).TEAM_COLLABORATION);
    if (!filterTypes.includes((0, $fGLQm.PrincipalFilterType).USER_CLASS)) typesToFilterOut.push((0, $fGLQm.ConfluenceGroupUsageType).ADMIN_OVERSIGHT);
    return typesToFilterOut;
};
module.exports["normalizeSpacePermissionAll"] = $bab3f5eb7fd997b5$export$4b3b0188cc9d39a8;
module.exports["normalizeSpaceRoleList"] = $bab3f5eb7fd997b5$export$429eba48f8769b83;
module.exports["getPrincipalTypeFromUserPickerType"] = $bab3f5eb7fd997b5$export$bf16ef98b7c6b580;
module.exports["isHoverCardEligiblePrincipalType"] = $bab3f5eb7fd997b5$export$62cb41ae198d08e7;
module.exports["isHoverCardEligibleUserPickerType"] = $bab3f5eb7fd997b5$export$6ca93df05f268de9;
module.exports["normalizeAssignments"] = $bab3f5eb7fd997b5$export$1c34a8ae4dfc585c;
module.exports["mergeGroupCountWithAssignments"] = $bab3f5eb7fd997b5$export$f41b22015074a487;
module.exports["mergeTeamDataWithAssignments"] = $bab3f5eb7fd997b5$export$89b4246717b63b9f;
module.exports["filterOutUnlicensedUsersAssignment"] = $bab3f5eb7fd997b5$export$b3299b59e278e268;
module.exports["displayPrincipalTypesToAPIPrincipalFilterTypes"] = $bab3f5eb7fd997b5$export$2fed59ad085105af;
module.exports["getTypesToFilterOut"] = $bab3f5eb7fd997b5$export$cc79220753e2d98a;

});

parcelRegister("fGLQm", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 *
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $4556f39c84e2f302$export$83836e07b7a1797e = /*#__PURE__*/ function(ConfluenceGroupManagementType) {
    ConfluenceGroupManagementType["ADMINS"] = "ADMINS";
    ConfluenceGroupManagementType["EXTERNAL"] = "EXTERNAL";
    ConfluenceGroupManagementType["OPEN"] = "OPEN";
    ConfluenceGroupManagementType["TEAM_MEMBERS"] = "TEAM_MEMBERS";
    return ConfluenceGroupManagementType;
}({});
var $4556f39c84e2f302$export$e7c9280c9da1cc0a = /*#__PURE__*/ function(ConfluenceGroupUsageType) {
    ConfluenceGroupUsageType["ADMIN_OVERSIGHT"] = "ADMIN_OVERSIGHT";
    ConfluenceGroupUsageType["TEAM_COLLABORATION"] = "TEAM_COLLABORATION";
    ConfluenceGroupUsageType["USERBASE_GROUP"] = "USERBASE_GROUP";
    return ConfluenceGroupUsageType;
}({});
var $4556f39c84e2f302$export$c68cf5b85bcf89b0 = /*#__PURE__*/ function(PrincipalFilterType) {
    PrincipalFilterType["APP"] = "APP";
    PrincipalFilterType["GROUP"] = "GROUP";
    PrincipalFilterType["GUEST"] = "GUEST";
    PrincipalFilterType["USER"] = "USER";
    PrincipalFilterType["USER_CLASS"] = "USER_CLASS";
    return PrincipalFilterType;
}({});
var $4556f39c84e2f302$export$69bdd9d16ab8ed0f = /*#__PURE__*/ function(SpaceRoleType) {
    SpaceRoleType["CUSTOM"] = "CUSTOM";
    SpaceRoleType["SYSTEM"] = "SYSTEM";
    return SpaceRoleType;
}({});
module.exports["ConfluenceGroupUsageType"] = $4556f39c84e2f302$export$e7c9280c9da1cc0a;
module.exports["PrincipalFilterType"] = $4556f39c84e2f302$export$c68cf5b85bcf89b0;

});

parcelRegister("itlCX", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $d794298446e7cdbe$export$4e2d5448f3fd8728 = /*#__PURE__*/ function(RoleAssignmentPrincipalType) {
    RoleAssignmentPrincipalType["ACCESS_CLASS"] = "ACCESS_CLASS";
    RoleAssignmentPrincipalType["APP"] = "APP";
    RoleAssignmentPrincipalType["GROUP"] = "GROUP";
    RoleAssignmentPrincipalType["USER"] = "USER";
    return RoleAssignmentPrincipalType;
}({});
module.exports["RoleAssignmentPrincipalType"] = $d794298446e7cdbe$export$4e2d5448f3fd8728;

});

parcelRegister("cXkvk", function(module, exports) {

var $6iz6M = parcelRequire("6iz6M");

const $89f97fd25aadbe4e$export$15fb7df3b09f81b2 = (rolePermissions)=>{
    const hasPublicLinksPermission = rolePermissions.includes('MANAGE_PUBLIC_LINKS');
    const hasAnonymousAccessPermission = rolePermissions.includes('NONLICENSED_USER_MANAGEMENT');
    const isPublicLinksActionDisabled = (0, $6iz6M.useIsActionDisabledForWorkspace)({
        action: 'PUBLIC_LINKS',
        skip: !hasPublicLinksPermission
    });
    const isAnonymousAccessActionDisabled = (0, $6iz6M.useIsActionDisabledForWorkspace)({
        action: 'ANONYMOUS_ACCESS',
        skip: !hasAnonymousAccessPermission
    });
    return isPublicLinksActionDisabled && hasPublicLinksPermission || isAnonymousAccessActionDisabled && hasAnonymousAccessPermission;
};
module.exports["useShouldShowDSPWarningForWorkspaceRole"] = $89f97fd25aadbe4e$export$15fb7df3b09f81b2;

});

parcelRegister("6iz6M", function(module, exports) {
/**
 * @generated SignedSource<<a38c20b3df79e9a32e89807d67a3d742>>
 * @relayHash 93f071a13614e9b1cac311dde06f99b5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c699bfb84a21ff66c9f3ec0304f078aaf4311194166f6949aaaedb9e7e376aa7
const $0a04cb25b81afab7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "action"
        }
    ], v1 = [
        {
            "concreteType": "Confluence_dataSecurityPolicy",
            "kind": "LinkedField",
            "name": "dataSecurityPolicy",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "action",
                            "variableName": "action"
                        }
                    ],
                    "concreteType": "DataSecurityPolicyDecision",
                    "kind": "LinkedField",
                    "name": "isActionEnabledForWorkspace",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "action"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "allowed"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsActionDisabledForWorkspaceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsActionDisabledForWorkspaceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "93f071a13614e9b1cac311dde06f99b5",
            "id": "c699bfb84a21ff66c9f3ec0304f078aaf4311194166f6949aaaedb9e7e376aa7",
            "metadata": {},
            "name": "useIsActionDisabledForWorkspaceQuery",
            "operationKind": "query",
            "text": "query useIsActionDisabledForWorkspaceQuery($action:DataSecurityPolicyAction!){dataSecurityPolicy{isActionEnabledForWorkspace(action:$action){action,allowed}}}"
        }
    };
}();
$0a04cb25b81afab7$var$node.hash = "5548aa746f7031f0532e6507c978135c";
var $0a04cb25b81afab7$export$2e2bcd8739ae039 = $0a04cb25b81afab7$var$node;



var $jMyy4 = parcelRequire("jMyy4");

const $84df5a84e221158e$export$cc4f507e54133df3 = (0, $0a04cb25b81afab7$export$2e2bcd8739ae039);
const $84df5a84e221158e$export$1e86459cb60ae95 = ({ action: action, skip: skip = false })=>{
    const { data: data } = (0, $jMyy4.useQueryInterop)($84df5a84e221158e$export$cc4f507e54133df3, {
        variables: {
            action: action
        },
        fetchPolicy: 'cache-and-network',
        skip: skip,
        __callerPackage__: "data-security"
    });
    if (skip) return false;
    const allowedResp = data?.dataSecurityPolicy?.isActionEnabledForWorkspace?.allowed;
    // Defaults to disabled if we don't have a definitive answer
    return allowedResp === undefined || allowedResp === null ? true : !allowedResp;
};
module.exports["useIsActionDisabledForWorkspace"] = $84df5a84e221158e$export$1e86459cb60ae95;

});

parcelRegister("7siXU", function(module, exports) {
/* AdminSecurityPageWrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $I7hWB = parcelRequire("I7hWB");


var $iMnC5 = parcelRequire("iMnC5");


var $dinVW = parcelRequire("dinVW");


var $1VhsF = parcelRequire("1VhsF");


var $a9aSv = parcelRequire("a9aSv");


var $lfoFx = parcelRequire("lfoFx");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $1BYn9 = parcelRequire("1BYn9");


var $lt6Lx = parcelRequire("lt6Lx");


var $jmjWc = parcelRequire("jmjWc");


var $4VuiN = parcelRequire("4VuiN");


var $dV8WM = parcelRequire("dV8WM");

const $d1833dcdda5c7ac3$var$UpsellBannerPlaceholder = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "40%",
        height: "var(--ds-space-300, 24px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "var(--ds-space-200, 16px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "80%",
        height: "var(--ds-space-200, 16px)"
    })));

const $d1833dcdda5c7ac3$var$ChangeEditionSectionMessageAdminGlobalV2Loadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "qLEMU",
    name: "ChangeEditionSectionMessageAdminGlobalV2Loadable",
    loader: async ()=>(await (parcelRequire("3SfF4"))).ChangeEditionSectionMessageAdminGlobalV2,
    loading: $d1833dcdda5c7ac3$var$UpsellBannerPlaceholder
});

const $d1833dcdda5c7ac3$var$ChangeEditionSectionMessageAdminSpaceV2Loadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "5GUNJ",
    name: "ChangeEditionSectionMessageAdminSpaceV2Loadable",
    loader: async ()=>(await (parcelRequire("e3F4K"))).ChangeEditionSectionMessageAdminSpaceV2,
    loading: $d1833dcdda5c7ac3$var$UpsellBannerPlaceholder
});
const $d1833dcdda5c7ac3$var$styles = {
    spinnerContainer: "_4FKVYEyFLW _3iDTPbQ4SZ _37wbyuDIqT",
    headerContainer: "_3iDTPbQ4SZ _37wbyuI7V3 _0rIjykNHnM",
    bannerContainer: "_0rIjykS40j"
};
const $d1833dcdda5c7ac3$export$2491da3a335cfdb = ({ title: title, documentTitle: documentTitle, bannerVariant: bannerVariant = 'global', titleAction: titleAction, fullWidth: fullWidth, children: children })=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { isProductAdmin: isProductAdmin, isAdminCheckLoading: isAdminCheckLoading } = (0, $1BYn9.useIsProductAdmin)();
    const isFreeEdition = edition === (0, $euL71.ConfluenceEdition).FREE;
    if (isAdminCheckLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d1833dcdda5c7ac3$var$styles.spinnerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "large"
    }));
    if (!isProductAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dV8WM.RestrictedPage), null);
    const banner = isFreeEdition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d1833dcdda5c7ac3$var$styles.bannerContainer
    }, bannerVariant === 'space' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d1833dcdda5c7ac3$var$ChangeEditionSectionMessageAdminSpaceV2Loadable, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d1833dcdda5c7ac3$var$ChangeEditionSectionMessageAdminGlobalV2Loadable, null)) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4VuiN.AdminPageLayout), {
        banner: banner,
        fullWidth: fullWidth
    }, documentTitle !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lt6Lx.DocumentContentTitle), {
        titlePrefix: documentTitle
    }), title !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d1833dcdda5c7ac3$var$styles.headerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h1",
        size: "large"
    }, title), titleAction), children);
};
module.exports["AdminSecurityPageWrapper"] = $d1833dcdda5c7ac3$export$2491da3a335cfdb;

});

parcelRegister("4VuiN", function(module, exports) {
/* AdminPageLayout.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

/**
 * Canonical layout for an admin page in Confluence. Every admin-shell
 * page renders inside a centred, max-1024px column with consistent padding.
 */ const $0e52f7509d59c259$var$styles = {
    outer: "_39xV02N91d _1EqgXlN91d _3iDTPbQ4SZ _37wbyuDIqT _4bt5LAnQyn _2WAcuGnQyn",
    inner: "_46hvQmp0Oa _0xmtkoS40j _39xV02N91d _4ouGXIyQC8 _1EqgXljClk _3iDTPbQ4SZ _0aFT5vbt8w"
};
// Matches Mission Control's ContentContainer for consistency.
const $0e52f7509d59c259$var$innerInlineStyle = {
    paddingInlineStart: '112px',
    // Forced px sizing to match Mission Control's ContentContainer padding
    paddingInlineEnd: '112px',
    containerType: 'inline-size',
    containerName: 'AdminPage',
    boxSizing: 'content-box'
};
const $0e52f7509d59c259$var$fullWidthInnerInlineStyle = {
    ...$0e52f7509d59c259$var$innerInlineStyle,
    paddingInlineStart: "var(--ds-space-400, 32px)",
    paddingInlineEnd: "var(--ds-space-400, 32px)",
    paddingBlockStart: "var(--ds-space-400, 32px)",
    maxWidth: 'none'
};
const $0e52f7509d59c259$export$a2627d382ba9038 = ({ children: children, banner: banner, fullWidth: fullWidth })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0e52f7509d59c259$var$styles.outer,
        as: "main"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0e52f7509d59c259$var$styles.inner,
        style: fullWidth ? $0e52f7509d59c259$var$fullWidthInnerInlineStyle : $0e52f7509d59c259$var$innerInlineStyle,
        testId: "admin-page-layout-inner"
    }, banner, children));
module.exports["AdminPageLayout"] = $0e52f7509d59c259$export$a2627d382ba9038;

});

parcelRegister("dV8WM", function(module, exports) {
/* RestrictedPage.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");

var $00f9acf06d9a785a$exports = {};
$00f9acf06d9a785a$exports = new URL("RestrictedContentIcon.39ea6b58.svg", import.meta.url).toString();


// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c29d0256b2906de1$var$RestrictedPageContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT",
            __cmplp.className
        ])
    });
});
const $c29d0256b2906de1$var$RestrictedPageContentWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_39xV02do8e _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _0jFU0VuViK",
            __cmplp.className
        ])
    });
});
const $c29d0256b2906de1$var$CenteredContent = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2fwxA5DIqT",
            __cmplp.className
        ])
    });
});
const $c29d0256b2906de1$var$RestrictedMessageTitle = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2XghbELmNS _1kk5Tkf7mX",
            __cmplp.className
        ])
    });
});
const $c29d0256b2906de1$var$RestrictedContentImage = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _39xV02b1xp",
            __cmplp.className
        ])
    });
});
const $c29d0256b2906de1$export$4242cfff65d64b16 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c29d0256b2906de1$var$RestrictedPageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c29d0256b2906de1$var$RestrictedPageContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c29d0256b2906de1$var$CenteredContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c29d0256b2906de1$var$RestrictedContentImage, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($00f9acf06d9a785a$exports)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c29d0256b2906de1$var$RestrictedMessageTitle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "site-permissions.restricted.page.view.title",
        defaultMessage: "This is a restricted page"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "site-permissions.restricted.page.manual.request.access.from.author",
        defaultMessage: "If you think you should have access, try asking the person who sent you here for help."
    }))));
module.exports["RestrictedPage"] = $c29d0256b2906de1$export$4242cfff65d64b16;

});

parcelRegister("3SfF4", function(module, exports) {

let $2d22904b1100b109$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2d22904b1100b109$var$load("6XCf4"),
    $2d22904b1100b109$var$load("ebvEF"),
    $2d22904b1100b109$var$load("aEiTV"),
    $2d22904b1100b109$var$load("1qlDN"),
    $2d22904b1100b109$var$load("1yVM6"),
    $2d22904b1100b109$var$load("eUAdQ")
]).then(()=>parcelRequire('rN8w9'));

});

parcelRegister("e3F4K", function(module, exports) {

let $a3c13541858a3cf6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a3c13541858a3cf6$var$load("6XCf4"),
    $a3c13541858a3cf6$var$load("ebvEF"),
    $a3c13541858a3cf6$var$load("aEiTV"),
    $a3c13541858a3cf6$var$load("1qlDN"),
    $a3c13541858a3cf6$var$load("1yVM6"),
    $a3c13541858a3cf6$var$load("gc0jz")
]).then(()=>parcelRequire('cJgGV'));

});

parcelRegister("7akNQ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $a2foB = parcelRequire("a2foB");


var $FKQbh = parcelRequire("FKQbh");


var $iXRmn = parcelRequire("iXRmn");


var $lqtHz = parcelRequire("lqtHz");

const $08beb25a8c4ef160$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
const $08beb25a8c4ef160$export$a4270ab432ac8a58 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FlagsProvider(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { children: children, shouldRenderToParent: shouldRenderToParent } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [flags, setFlags] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (id)=>{
            setFlags((current)=>current.slice(0).filter((flag)=>flag.id !== id));
        };
        $[1] = t2;
    } else t2 = $[1];
    const removeFlag = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $08beb25a8c4ef160$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        };
        $[2] = t3;
    } else t3 = $[2];
    const api = t3;
    let t4;
    if ($[3] !== children) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iXRmn.FlagContext).Provider, {
            value: api,
            children: children
        });
        $[3] = children;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== flags) {
        t5 = flags.map($08beb25a8c4ef160$var$_temp);
        $[5] = flags;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== shouldRenderToParent || $[8] !== t5) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
            onDismissed: removeFlag,
            shouldRenderToParent: shouldRenderToParent,
            children: t5
        });
        $[7] = shouldRenderToParent;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t4 || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                t4,
                t6
            ]
        });
        $[10] = t4;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    return t7;
} : function FlagsProvider({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $cozmU.useState)([]);
    const removeFlag = (0, $cozmU.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $cozmU.useMemo)(()=>({
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $08beb25a8c4ef160$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iXRmn.FlagContext).Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag_1)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
                    const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
                    return /*#__PURE__*/ (0, $cozmU.createElement)(FlagType, {
                        ...restProps,
                        key: flag_1.id
                    });
                })
            })
        ]
    });
};
function $08beb25a8c4ef160$var$_temp(flag_1) {
    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
    const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
    return /*#__PURE__*/ (0, $cozmU.createElement)(FlagType, {
        ...restProps,
        key: flag_1.id
    });
}
module.exports["FlagsProvider"] = $08beb25a8c4ef160$export$a4270ab432ac8a58;

});

parcelRegister("iXRmn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $bbe556224ecd1c1b$export$2eb95677cf2465e1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(null);
module.exports["FlagContext"] = $bbe556224ecd1c1b$export$2eb95677cf2465e1;

});

parcelRegister("6V36D", function(module, exports) {
$parcel$export(module.exports, "VerifiedTeamLozenge", () => (parcelRequire("hVSC8")).VerifiedTeamLozenge);

var $hVSC8 = parcelRequire("hVSC8");


});

parcelRegister("hVSC8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $d2UzA = parcelRequire("d2UzA");


var $lpNn5 = parcelRequire("lpNn5");

const $2e5b5aad519af945$var$i18n = (0, $kSwu1.defineMessages)({
    teamVerifiedLozengeTooltip: {
        id: "permissions-principals.team-verified-lozenge.tooltip",
        defaultMessage: "This team is verified because it is controlled by an organization admin."
    },
    groupVerifiedLozengeTooltip: {
        id: "permissions-principals.group-verified-lozenge.tooltip",
        defaultMessage: "This group is verified because it is controlled by an organization admin."
    }
});
const $2e5b5aad519af945$export$ba3ff7dd3e281a6b = ({ isTeam: isTeam = true, spacing: spacing = 'compact' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: isTeam ? formatMessage($2e5b5aad519af945$var$i18n.teamVerifiedLozengeTooltip) : formatMessage($2e5b5aad519af945$var$i18n.groupVerifiedLozengeTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
        label: "verified team",
        color: "var(--ds-icon-accent-blue, #357DE8)",
        size: "small",
        spacing: spacing
    }));
};
module.exports["VerifiedTeamLozenge"] = $2e5b5aad519af945$export$ba3ff7dd3e281a6b;

});

parcelRegister("6MSEP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $9387550ed869acb8$export$4242cfff65d64b16 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "M3-19",
    name: "RestrictedPage",
    loader: async ()=>(await (parcelRequire("16tfx"))).RestrictedPage
});
module.exports["RestrictedPage"] = $9387550ed869acb8$export$4242cfff65d64b16;

});

parcelRegister("16tfx", function(module, exports) {

let $0cdd0a563510eeb0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0cdd0a563510eeb0$var$load("ezYRV"),
    $0cdd0a563510eeb0$var$load("6wr18"),
    $0cdd0a563510eeb0$var$load("ffEVr"),
    $0cdd0a563510eeb0$var$load("zUKwV"),
    $0cdd0a563510eeb0$var$load("fUeur"),
    $0cdd0a563510eeb0$var$load("7EorR"),
    $0cdd0a563510eeb0$var$load("2OcM6"),
    $0cdd0a563510eeb0$var$load("hhss7"),
    $0cdd0a563510eeb0$var$load("kUiwW")
]).then(()=>parcelRequire('3kPYw'));

});

parcelRegister("4MnFz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $iXRmn = parcelRequire("iXRmn");

const $878d7a55fd1744f7$export$2879604e6aec4ab = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useFlags() {
    const api = (0, $cozmU.useContext)((0, $iXRmn.FlagContext));
    if (api == null) throw new Error("Unable to find FlagProviderContext");
    return api;
} : function useFlags() {
    const api = (0, $cozmU.useContext)((0, $iXRmn.FlagContext));
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
};
module.exports["useFlags"] = $878d7a55fd1744f7$export$2879604e6aec4ab;

});

parcelRegister("jBoKV", function(module, exports) {

let $e454ad095b915084$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e454ad095b915084$var$load("6wr18"),
    $e454ad095b915084$var$load("251nM"),
    $e454ad095b915084$var$load("ffEVr"),
    $e454ad095b915084$var$load("9vDBp"),
    $e454ad095b915084$var$load("RI3SR"),
    $e454ad095b915084$var$load("7uWW8")
]).then(()=>parcelRequire('1c1P5'));

});

parcelRegister("go5PI", function(module, exports) {
const $a85703dfa4960dc8$export$6efc679b5f68edbb = 'adminConfiguration';
const $a85703dfa4960dc8$export$29494bfe5045193 = 'https://support.atlassian.com/confluence-cloud/docs/insert-confluence-wiki-markup/';
const $a85703dfa4960dc8$export$68fe928f91262da7 = 'https://support.atlassian.com/confluence-cloud/docs/convert-pages-to-the-new-editor/';
const $a85703dfa4960dc8$export$d1b15eb7eed612ff = 'https://support.atlassian.com/confluence-cloud/docs/configure-time-and-date-formats/';
const $a85703dfa4960dc8$export$4facdf667af1c221 = 'https://confluence.atlassian.com/x/A41jL';
const $a85703dfa4960dc8$export$c6b232dd07adf3e8 = 'https://support.atlassian.com/confluence-cloud/docs/view-a-page/';
module.exports["ADMIN_CONFIGURATION_ANALYTICS_SOURCE"] = $a85703dfa4960dc8$export$6efc679b5f68edbb;
module.exports["WIKI_LEARN_MORE_LINK"] = $a85703dfa4960dc8$export$29494bfe5045193;
module.exports["CONVERT_PAGES_LEARN_MORE_LINK"] = $a85703dfa4960dc8$export$68fe928f91262da7;
module.exports["DATE_TIME_FORMAT_LEARN_MORE_LINK"] = $a85703dfa4960dc8$export$d1b15eb7eed612ff;
module.exports["PRESENCE_LEARN_MORE_LINK"] = $a85703dfa4960dc8$export$c6b232dd07adf3e8;

});

parcelRegister("jcorh", function(module, exports) {

let $dfa2186686ec5964$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $dfa2186686ec5964$var$load("9vDBp"),
    $dfa2186686ec5964$var$load("RI3SR"),
    $dfa2186686ec5964$var$load("hMzlw")
]).then(()=>parcelRequire('lkTIR'));

});

parcelRegister("87xWZ", function(module, exports) {
const $9a9bb38d8a0d9d21$export$dd8dbc63482d3d52 = 'adminDefaultSpaceLogoConfig';
const $9a9bb38d8a0d9d21$export$a6c9f5ac24569a0a = [
    '.gif',
    '.jpg',
    '.jpeg',
    '.png',
    '.svg',
    '.webp'
];
module.exports["ADMIN_DEFAULT_SPACE_LOGO_CONFIG_ANALYTICS_SOURCE"] = $9a9bb38d8a0d9d21$export$dd8dbc63482d3d52;
module.exports["ALLOWED_LOGO_FILE_EXTENSIONS"] = $9a9bb38d8a0d9d21$export$a6c9f5ac24569a0a;

});

parcelRegister("iPL9h", function(module, exports) {

let $db6190250983dace$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $db6190250983dace$var$load("lh6fT").then(()=>parcelRequire('f9aTe'));

});

parcelRegister("9VF1g", function(module, exports) {
const $3395fdb7c7788386$export$f57d5d3f8ce40ac2 = 'adminHeaderAndFooterConfig';
const $3395fdb7c7788386$export$6dbb84b06e78ca9 = '/admin/header-and-footer';
module.exports["ADMIN_MIGRATION_HEADER_AND_FOOTER_ANALYTICS_SOURCE"] = $3395fdb7c7788386$export$f57d5d3f8ce40ac2;
module.exports["ADMIN_MIGRATION_HEADER_AND_FOOTER_PATH_NAME"] = $3395fdb7c7788386$export$6dbb84b06e78ca9;

});

parcelRegister("3OVbT", function(module, exports) {

let $2c82678811b156a6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2c82678811b156a6$var$load("8iU4E").then(()=>parcelRequire('46IN4'));

});

parcelRegister("kzcPl", function(module, exports) {

var $irVI7 = parcelRequire("irVI7");

const $a85fb93a41cf2970$export$e7cba70eb2004729 = 'adminTemplatesAndBlueprints';
const $a85fb93a41cf2970$export$59e8eaf2c1cf7d28 = '/admin/templates-and-blueprints';
const $a85fb93a41cf2970$export$8726b5b334ad0749 = [
    (0, $irVI7.ADMIN_TEMPLATES_AND_BLUEPRINTS_PAGE_TEMPLATES_LOAD_EXPERIENCE),
    (0, $irVI7.ADMIN_TEMPLATES_AND_BLUEPRINTS_PAGE_BLUEPRINTS_LOAD_EXPERIENCE),
    (0, $irVI7.ADMIN_TEMPLATES_AND_BLUEPRINTS_SYSTEM_TEMPLATES_LOAD_EXPERIENCE)
];
module.exports["ADMIN_MIGRATION_TEMPLATES_AND_BLUEPRINTS_ANALYTICS_SOURCE"] = $a85fb93a41cf2970$export$e7cba70eb2004729;
module.exports["PATH_NAME"] = $a85fb93a41cf2970$export$59e8eaf2c1cf7d28;
module.exports["ADMIN_TEMPLATES_AND_BLUEPRINTS_SUB_EXPERIENCES"] = $a85fb93a41cf2970$export$8726b5b334ad0749;

});

parcelRegister("97Mow", function(module, exports) {

let $6a4a4eaad8eef828$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6a4a4eaad8eef828$var$load("dCPNW").then(()=>parcelRequire('bHNfF'));

});

parcelRegister("3Tdyk", function(module, exports) {
const $b18a48086d5c5e91$export$fa039ba6a22ab542 = 'adminNotifications';
module.exports["ADMIN_NOTIFICATIONS_ANALYTICS_SOURCE"] = $b18a48086d5c5e91$export$fa039ba6a22ab542;

});

parcelRegister("kL15w", function(module, exports) {

let $f1c90a8601e68bb1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f1c90a8601e68bb1$var$load("ibz38").then(()=>parcelRequire('cgobV'));

});

parcelRegister("1fUU3", function(module, exports) {
const $763ac6d5da789755$export$b6ddaabddf4de465 = 'adminCreateWithRovo';
module.exports["ADMIN_CREATE_WITH_ROVO_ANALYTICS_SOURCE"] = $763ac6d5da789755$export$b6ddaabddf4de465;

});

parcelRegister("fraUx", function(module, exports) {

let $b3d1d7529d758666$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b3d1d7529d758666$var$load("6wr18"),
    $b3d1d7529d758666$var$load("2C3m1"),
    $b3d1d7529d758666$var$load("4h9Y1"),
    $b3d1d7529d758666$var$load("iGzmZ"),
    $b3d1d7529d758666$var$load("ffEVr"),
    $b3d1d7529d758666$var$load("hfgHR"),
    $b3d1d7529d758666$var$load("5GZhs"),
    $b3d1d7529d758666$var$load("dbmJd"),
    $b3d1d7529d758666$var$load("cT9w0"),
    $b3d1d7529d758666$var$load("jT1qh"),
    $b3d1d7529d758666$var$load("aYkj4"),
    $b3d1d7529d758666$var$load("1fiCx"),
    $b3d1d7529d758666$var$load("4POoz"),
    $b3d1d7529d758666$var$load("dwezT"),
    $b3d1d7529d758666$var$load("w3Gc8"),
    $b3d1d7529d758666$var$load("6C7Vr"),
    $b3d1d7529d758666$var$load("7EorR"),
    $b3d1d7529d758666$var$load("1a59G"),
    $b3d1d7529d758666$var$load("dcntv")
]).then(()=>parcelRequire('gLYG4'));

});

parcelRegister("1QKcJ", function(module, exports) {

let $158e7d00f90ef8ec$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $158e7d00f90ef8ec$var$load("LWh5V"),
    $158e7d00f90ef8ec$var$load("krOJz")
]).then(()=>parcelRequire('lMhQj'));

});

parcelRegister("i6ccO", function(module, exports) {
const $5030b4f7b6082c77$export$40d649ebb84b67da = 'spaceReportsSiteSettings';
module.exports["ADMIN_SPACE_REPORT_SCREEN"] = $5030b4f7b6082c77$export$40d649ebb84b67da;

});

parcelRegister("k0EFK", function(module, exports) {

let $e9135b6962471e24$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e9135b6962471e24$var$load("lQHJf").then(()=>parcelRequire('2nzCJ'));

});

parcelRegister("jPtik", function(module, exports) {
const $877d602a9e3b74d4$export$3b900d9a0f807a35 = 'adminConfigureCodeMacro';
const $877d602a9e3b74d4$export$99fd23db6b16a233 = 'Confluence';
const $877d602a9e3b74d4$export$c73844cf6c80166 = 'Java';
module.exports["ADMIN_CONFIGURE_CODE_MACRO_ANALYTICS_SOURCE"] = $877d602a9e3b74d4$export$3b900d9a0f807a35;
module.exports["DEFAULT_THEME_VALUE"] = $877d602a9e3b74d4$export$99fd23db6b16a233;
module.exports["DEFAULT_LANGUAGE_VALUE"] = $877d602a9e3b74d4$export$c73844cf6c80166;

});

parcelRegister("iMyEa", function(module, exports) {

let $dac795d8a5007402$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $dac795d8a5007402$var$load("2mGc6"),
    $dac795d8a5007402$var$load("7EorR"),
    $dac795d8a5007402$var$load("BhLxx")
]).then(()=>parcelRequire('d4Lz2'));

});

parcelRegister("bDmqn", function(module, exports) {

let $8784bb3e0ae634fe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8784bb3e0ae634fe$var$load("lMnCe").then(()=>parcelRequire('5XJaz'));

});

parcelRegister("5vGLM", function(module, exports) {
const $18527396bdb04510$export$5ab36823e88567de = 'securityConfiguration';
const $18527396bdb04510$export$40326e81f7c56c6a = 'https://support.atlassian.com/confluence-cloud/docs/hide-external-links-from-search-engines/';
const $18527396bdb04510$export$f7de0eba11e77fd5 = 'https://support.atlassian.com/confluence-cloud/docs/turn-on-privacy-mode-for-analytics-data/';
const $18527396bdb04510$export$8802c1db742ad689 = 2147483647;
module.exports["ADMIN_SECURITY_CONFIGURATION_ANALYTICS_SOURCE"] = $18527396bdb04510$export$5ab36823e88567de;
module.exports["EXTERNAL_LINKS_LEARN_MORE_LINK"] = $18527396bdb04510$export$40326e81f7c56c6a;
module.exports["PRIVACY_IN_ANALYTICS_LINK"] = $18527396bdb04510$export$f7de0eba11e77fd5;
module.exports["MAX_SAFE_JAVA_INTEGER"] = $18527396bdb04510$export$8802c1db742ad689;

});

parcelRegister("lSstv", function(module, exports) {

let $fed4baa99a0753bf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fed4baa99a0753bf$var$load("6wr18"),
    $fed4baa99a0753bf$var$load("7Alab"),
    $fed4baa99a0753bf$var$load("jh0RP"),
    $fed4baa99a0753bf$var$load("4fYzp"),
    $fed4baa99a0753bf$var$load("4h9Y1"),
    $fed4baa99a0753bf$var$load("iGzmZ"),
    $fed4baa99a0753bf$var$load("ffEVr"),
    $fed4baa99a0753bf$var$load("1a59G"),
    $fed4baa99a0753bf$var$load("lp1L9")
]).then(()=>parcelRequire('gmEnb'));

});

parcelRegister("4tdkm", function(module, exports) {

let $34143568078a5ba9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $34143568078a5ba9$var$load("jh0RP"),
    $34143568078a5ba9$var$load("j98o0")
]).then(()=>parcelRequire('dlYPV'));

});

parcelRegister("f1bqy", function(module, exports) {

let $aeefd03d6dc724c2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aeefd03d6dc724c2$var$load("kaFPr").then(()=>parcelRequire('2C4l7'));

});

parcelRegister("dWfBt", function(module, exports) {
const $3252933457ee5bfd$export$1c3a7fb1674ebcd2 = 'adminApplicationNavigator';
const $3252933457ee5bfd$export$59e8eaf2c1cf7d28 = '/admin/application-navigator';
module.exports["ADMIN_APPLICATION_NAVIGATOR_ANALYTICS_SOURCE"] = $3252933457ee5bfd$export$1c3a7fb1674ebcd2;

});

parcelRegister("ldb17", function(module, exports) {

let $f7135b9be2cdaaa8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f7135b9be2cdaaa8$var$load("f4DD6").then(()=>parcelRequire('6JHmj'));

});

parcelRegister("9JmJC", function(module, exports) {
const $3381874ada981275$export$4ad87fa408071f9e = 'adminMacroUsage';
module.exports["ADMIN_MACRO_USAGE_ANALYTICS_SOURCE"] = $3381874ada981275$export$4ad87fa408071f9e;

});

parcelRegister("lsdAl", function(module, exports) {

let $f9e6c0389c8194a3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f9e6c0389c8194a3$var$load("6wr18"),
    $f9e6c0389c8194a3$var$load("7ZdE9"),
    $f9e6c0389c8194a3$var$load("ffEVr"),
    $f9e6c0389c8194a3$var$load("3YiRE")
]).then(()=>parcelRequire('iR5x9'));

});

parcelRegister("4l9JY", function(module, exports) {
// Server expects the "after" parameter as a string index
const $bd0500c03ad06aff$export$eb9c69e3a09b9217 = '-1';
const $bd0500c03ad06aff$export$5716e8bcb003888d = 20;
const $bd0500c03ad06aff$export$717a6bceadab3608 = 'trashed';
const $bd0500c03ad06aff$export$ee14340141c11674 = 5000;
const $bd0500c03ad06aff$export$43b26519b9b8a3e = 'adminTrashedSpaces';
module.exports["DEFAULT_START_INDEX"] = $bd0500c03ad06aff$export$eb9c69e3a09b9217;
module.exports["DEFAULT_PAGE_SIZE"] = $bd0500c03ad06aff$export$5716e8bcb003888d;
module.exports["SPACE_STATUS_TRASHED"] = $bd0500c03ad06aff$export$717a6bceadab3608;
module.exports["POLL_INTERVAL_MS"] = $bd0500c03ad06aff$export$ee14340141c11674;
module.exports["ADMIN_TRASHED_SPACES_ANALYTICS_SOURCE"] = $bd0500c03ad06aff$export$43b26519b9b8a3e;

});

parcelRegister("6hRE4", function(module, exports) {

let $493df173bc9bfc7a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $493df173bc9bfc7a$var$load("c1IkM"),
    $493df173bc9bfc7a$var$load("7S2Sh"),
    $493df173bc9bfc7a$var$load("knHTK")
]).then(()=>parcelRequire('8CcG8'));

});

parcelRegister("5LuQ6", function(module, exports) {

let $4329439a5417f6ac$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4329439a5417f6ac$var$load("1jfrR").then(()=>parcelRequire('fz6lB'));

});

parcelRegister("kmD3E", function(module, exports) {

let $ed3428d47a4161e5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ed3428d47a4161e5$var$load("4fYzp"),
    $ed3428d47a4161e5$var$load("iOJdB")
]).then(()=>parcelRequire('452sv'));

});

parcelRegister("434W4", function(module, exports) {
// XMLs or CSVs should be in a zip file
const $b6c44f979bbed03e$export$417e5fe1d0de6e47 = [
    '.zip'
];
const $b6c44f979bbed03e$export$42f152cabc617ec2 = 1500;
const $b6c44f979bbed03e$export$5f9abcd3ce58c0ab = 'adminImportSpaces';
const $b6c44f979bbed03e$export$61387ee612136e90 = 300000;
const $b6c44f979bbed03e$export$9e3220b2979f5262 = 'https://marketplace.atlassian.com/apps/1219672/cloud-migration-assistant-for-confluence';
const $b6c44f979bbed03e$export$ebe1d3a4348867c4 = 'https://confluence.atlassian.com/doc/export-content-to-word-pdf-html-and-xml-139475.html#ExportContenttoWord,PDF,HTMLandXML-ExportmultiplepagestoHTML,XML,orPDF';
module.exports["ALLOWED_FILE_EXTENSIONS"] = $b6c44f979bbed03e$export$417e5fe1d0de6e47;
module.exports["IMPORT_STATUS_CHECK_POLL_INTERVAL_MS"] = $b6c44f979bbed03e$export$42f152cabc617ec2;
module.exports["ADMIN_IMPORT_SPACES_ANALYTICS_SOURCE"] = $b6c44f979bbed03e$export$5f9abcd3ce58c0ab;
module.exports["MEDIA_AUTH_PROVIDER_FIVE_MIN_TIMEOUT"] = $b6c44f979bbed03e$export$61387ee612136e90;
module.exports["CLOUD_MIGRATION_ASSISTANT_LINK"] = $b6c44f979bbed03e$export$9e3220b2979f5262;
module.exports["EXPORT_HELP_LINK"] = $b6c44f979bbed03e$export$ebe1d3a4348867c4;

});

parcelRegister("42aQi", function(module, exports) {

let $2effc26a2b7219d5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2effc26a2b7219d5$var$load("4Z5Uh").then(()=>parcelRequire('f10rR'));

});

parcelRegister("2i0P8", function(module, exports) {
const $ffc87555304a609f$export$8b897d36b093ccf1 = 'adminJiraMacroRepair';
const $ffc87555304a609f$export$ee14340141c11674 = 1000;
const $ffc87555304a609f$export$765b83ed862a0ed = '/wiki/plugins/servlet/applinks/listApplicationLinks';
module.exports["ADMIN_JIRA_MACRO_REPAIR_ANALYTICS_SOURCE"] = $ffc87555304a609f$export$8b897d36b093ccf1;
module.exports["POLL_INTERVAL_MS"] = $ffc87555304a609f$export$ee14340141c11674;
module.exports["APP_LINKS_URL"] = $ffc87555304a609f$export$765b83ed862a0ed;

});

parcelRegister("aFVWt", function(module, exports) {

let $7c5aadcd663b79ed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7c5aadcd663b79ed$var$load("6KDUv").then(()=>parcelRequire('iiqL3'));

});

parcelRegister("ft9Jc", function(module, exports) {
const $5b008143e5994a1d$export$5b9a48b5dd6a4ea2 = 'adminThemes';
module.exports["ADMIN_THEMES_ANALYTICS_SOURCE"] = $5b008143e5994a1d$export$5b9a48b5dd6a4ea2;

});

parcelRegister("9uVbY", function(module, exports) {

let $6ea34791770d6095$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6ea34791770d6095$var$load("Wowvf"),
    $6ea34791770d6095$var$load("fKQ9j"),
    $6ea34791770d6095$var$load("9BxhS")
]).then(()=>parcelRequire('5JXtG'));

});

parcelRegister("fmC2G", function(module, exports) {
const $2d4e85d5268f55f9$export$546ba186ec91e3c9 = 'adminPdfExport';
const $2d4e85d5268f55f9$export$dec669626e46bbfe = 'https://support.atlassian.com/confluence-cloud/docs/customize-exports-to-pdf/';
module.exports["ADMIN_PDF_EXPORT_ANALYTICS_SOURCE"] = $2d4e85d5268f55f9$export$546ba186ec91e3c9;
module.exports["STYLESHEET_SUPPORT_DOC_URL"] = $2d4e85d5268f55f9$export$dec669626e46bbfe;

});

parcelRegister("3EZ1I", function(module, exports) {

let $2aa47226ac7d961d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2aa47226ac7d961d$var$load("3JOx9"),
    $2aa47226ac7d961d$var$load("6mLKo")
]).then(()=>parcelRequire('jmxIE'));

});

parcelRegister("8Nhaa", function(module, exports) {
const $1ede882b6a23a4b1$export$fa5f102b28968fd8 = 'spaceManager';
module.exports["SPACE_MANAGER_ANALYTICS_SOURCE"] = $1ede882b6a23a4b1$export$fa5f102b28968fd8;

});

parcelRegister("hPrtH", function(module, exports) {

let $cfac83a04a20ea54$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cfac83a04a20ea54$var$load("irTwo"),
    $cfac83a04a20ea54$var$load("4h9Y1"),
    $cfac83a04a20ea54$var$load("2YlyO")
]).then(()=>parcelRequire('753aK'));

});

parcelRegister("35CyX", function(module, exports) {

let $23ffc086c5bf671c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $23ffc086c5bf671c$var$load("3mFs6"),
    $23ffc086c5bf671c$var$load("1atBh"),
    $23ffc086c5bf671c$var$load("lK4Zk"),
    $23ffc086c5bf671c$var$load("9UeKl"),
    $23ffc086c5bf671c$var$load("cpYhM"),
    $23ffc086c5bf671c$var$load("2fgvC"),
    $23ffc086c5bf671c$var$load("dbQ5m"),
    $23ffc086c5bf671c$var$load("bm0oR"),
    $23ffc086c5bf671c$var$load("4fYzp"),
    $23ffc086c5bf671c$var$load("1GCFv"),
    $23ffc086c5bf671c$var$load("6XCf4"),
    $23ffc086c5bf671c$var$load("ebvEF"),
    $23ffc086c5bf671c$var$load("2NFUs"),
    $23ffc086c5bf671c$var$load("iOfkQ"),
    $23ffc086c5bf671c$var$load("aEiTV"),
    $23ffc086c5bf671c$var$load("1qlDN"),
    $23ffc086c5bf671c$var$load("1yVM6"),
    $23ffc086c5bf671c$var$load("7EorR"),
    $23ffc086c5bf671c$var$load("kBatH"),
    $23ffc086c5bf671c$var$load("6gpUD")
]).then(()=>parcelRequire('dTw2J'));

});

parcelRegister("d73E7", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $61e340fdd81a37ab$export$eb67fd6afe5bdfc8 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "X7rQv",
    name: "WhiteboardRouteComponentLoader",
    loader: ()=>(parcelRequire("1YFKh"))
});
module.exports["WhiteboardRouteComponentLoader"] = $61e340fdd81a37ab$export$eb67fd6afe5bdfc8;

});

parcelRegister("1YFKh", function(module, exports) {

let $170bc6d512d1682a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $170bc6d512d1682a$var$load("kT6dz"),
    $170bc6d512d1682a$var$load("Mp0pM"),
    $170bc6d512d1682a$var$load("bPC3R"),
    $170bc6d512d1682a$var$load("bHb1X"),
    $170bc6d512d1682a$var$load("4Gdnz"),
    $170bc6d512d1682a$var$load("4UAag"),
    $170bc6d512d1682a$var$load("fpd4t"),
    $170bc6d512d1682a$var$load("3yj2i"),
    $170bc6d512d1682a$var$load("5iXyL"),
    $170bc6d512d1682a$var$load("5nbvZ"),
    $170bc6d512d1682a$var$load("2yRsH"),
    $170bc6d512d1682a$var$load("fEbOv"),
    $170bc6d512d1682a$var$load("3pUic"),
    $170bc6d512d1682a$var$load("yIsjX"),
    $170bc6d512d1682a$var$load("4CyIY"),
    $170bc6d512d1682a$var$load("2F69B"),
    $170bc6d512d1682a$var$load("iY1NC"),
    $170bc6d512d1682a$var$load("aROXU"),
    $170bc6d512d1682a$var$load("eW2qV"),
    $170bc6d512d1682a$var$load("cxCk7"),
    $170bc6d512d1682a$var$load("ezYRV"),
    $170bc6d512d1682a$var$load("7SteV"),
    $170bc6d512d1682a$var$load("eNgZ8"),
    $170bc6d512d1682a$var$load("lAHCT"),
    $170bc6d512d1682a$var$load("hs6P3"),
    $170bc6d512d1682a$var$load("8d6BA"),
    $170bc6d512d1682a$var$load("Jyh1v"),
    $170bc6d512d1682a$var$load("dxcsb"),
    $170bc6d512d1682a$var$load("ksOjm"),
    $170bc6d512d1682a$var$load("jAsJw"),
    $170bc6d512d1682a$var$load("aEiTV"),
    $170bc6d512d1682a$var$load("VXbA1"),
    $170bc6d512d1682a$var$load("90SZm"),
    $170bc6d512d1682a$var$load("crfrC"),
    $170bc6d512d1682a$var$load("1qlDN"),
    $170bc6d512d1682a$var$load("1yVM6"),
    $170bc6d512d1682a$var$load("iWnyc"),
    $170bc6d512d1682a$var$load("ea3NB"),
    $170bc6d512d1682a$var$load("59hV4"),
    $170bc6d512d1682a$var$load("iTOzX"),
    $170bc6d512d1682a$var$load("ipkwd"),
    $170bc6d512d1682a$var$load("a7sEM"),
    $170bc6d512d1682a$var$load("aLbuU"),
    $170bc6d512d1682a$var$load("zUKwV"),
    $170bc6d512d1682a$var$load("fUeur"),
    $170bc6d512d1682a$var$load("iECXC"),
    $170bc6d512d1682a$var$load("5sZTx"),
    $170bc6d512d1682a$var$load("deTdD"),
    $170bc6d512d1682a$var$load("1JeTB"),
    $170bc6d512d1682a$var$load("4UHov"),
    $170bc6d512d1682a$var$load("6wr18"),
    $170bc6d512d1682a$var$load("ffEVr"),
    $170bc6d512d1682a$var$load("Wowvf"),
    $170bc6d512d1682a$var$load("4g6rd"),
    $170bc6d512d1682a$var$load("5dkX4"),
    $170bc6d512d1682a$var$load("hhss7"),
    $170bc6d512d1682a$var$load("86OhX"),
    $170bc6d512d1682a$var$load("7EorR"),
    $170bc6d512d1682a$var$load("jZkQK")
]).then(()=>parcelRequire('ib0d9'));

});

parcelRegister("kY72s", function(module, exports) {

let $f43edef9cf1ff990$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f43edef9cf1ff990$var$load("3yj2i"),
    $f43edef9cf1ff990$var$load("kMhLQ"),
    $f43edef9cf1ff990$var$load("5nbvZ"),
    $f43edef9cf1ff990$var$load("2yRsH"),
    $f43edef9cf1ff990$var$load("fVspZ"),
    $f43edef9cf1ff990$var$load("a3s2T"),
    $f43edef9cf1ff990$var$load("2zUQc"),
    $f43edef9cf1ff990$var$load("6Q5bc"),
    $f43edef9cf1ff990$var$load("6damH"),
    $f43edef9cf1ff990$var$load("3pUic"),
    $f43edef9cf1ff990$var$load("9t4mJ"),
    $f43edef9cf1ff990$var$load("yIsjX"),
    $f43edef9cf1ff990$var$load("6wr18"),
    $f43edef9cf1ff990$var$load("4g6rd"),
    $f43edef9cf1ff990$var$load("5dkX4"),
    $f43edef9cf1ff990$var$load("bRqDI"),
    $f43edef9cf1ff990$var$load("4CyIY"),
    $f43edef9cf1ff990$var$load("2F69B"),
    $f43edef9cf1ff990$var$load("hBTro"),
    $f43edef9cf1ff990$var$load("iY1NC"),
    $f43edef9cf1ff990$var$load("4fYzp"),
    $f43edef9cf1ff990$var$load("4Ve5N"),
    $f43edef9cf1ff990$var$load("1GCFv"),
    $f43edef9cf1ff990$var$load("ezYRV"),
    $f43edef9cf1ff990$var$load("w3Gc8"),
    $f43edef9cf1ff990$var$load("8d6BA"),
    $f43edef9cf1ff990$var$load("Jyh1v"),
    $f43edef9cf1ff990$var$load("jqoep"),
    $f43edef9cf1ff990$var$load("hhss7"),
    $f43edef9cf1ff990$var$load("Wowvf"),
    $f43edef9cf1ff990$var$load("i1I18"),
    $f43edef9cf1ff990$var$load("2K7Mk"),
    $f43edef9cf1ff990$var$load("7EorR"),
    $f43edef9cf1ff990$var$load("dxKHc"),
    $f43edef9cf1ff990$var$load("i8lZ0"),
    $f43edef9cf1ff990$var$load("iDrFi"),
    $f43edef9cf1ff990$var$load("jxGqt"),
    $f43edef9cf1ff990$var$load("ffEVr"),
    $f43edef9cf1ff990$var$load("iOr1f")
]).then(()=>parcelRequire('58rkb'));

});

parcelRegister("iWviJ", function(module, exports) {

let $dca5ec8cf0449018$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $dca5ec8cf0449018$var$load("1BcpX"),
    $dca5ec8cf0449018$var$load("3yj2i"),
    $dca5ec8cf0449018$var$load("5nbvZ"),
    $dca5ec8cf0449018$var$load("2yRsH"),
    $dca5ec8cf0449018$var$load("6damH"),
    $dca5ec8cf0449018$var$load("3pUic"),
    $dca5ec8cf0449018$var$load("9t4mJ"),
    $dca5ec8cf0449018$var$load("yIsjX"),
    $dca5ec8cf0449018$var$load("4g6rd"),
    $dca5ec8cf0449018$var$load("5dkX4"),
    $dca5ec8cf0449018$var$load("bRqDI"),
    $dca5ec8cf0449018$var$load("4CyIY"),
    $dca5ec8cf0449018$var$load("2F69B"),
    $dca5ec8cf0449018$var$load("hBTro"),
    $dca5ec8cf0449018$var$load("iY1NC"),
    $dca5ec8cf0449018$var$load("4fYzp"),
    $dca5ec8cf0449018$var$load("1GCFv"),
    $dca5ec8cf0449018$var$load("ezYRV"),
    $dca5ec8cf0449018$var$load("hS8gF"),
    $dca5ec8cf0449018$var$load("g8A75"),
    $dca5ec8cf0449018$var$load("w3Gc8"),
    $dca5ec8cf0449018$var$load("8d6BA"),
    $dca5ec8cf0449018$var$load("Jyh1v"),
    $dca5ec8cf0449018$var$load("agVmZ"),
    $dca5ec8cf0449018$var$load("ef2CU"),
    $dca5ec8cf0449018$var$load("2K7Mk"),
    $dca5ec8cf0449018$var$load("zUKwV"),
    $dca5ec8cf0449018$var$load("fUeur"),
    $dca5ec8cf0449018$var$load("1JeTB"),
    $dca5ec8cf0449018$var$load("6wr18"),
    $dca5ec8cf0449018$var$load("7EorR"),
    $dca5ec8cf0449018$var$load("Wowvf"),
    $dca5ec8cf0449018$var$load("hhss7"),
    $dca5ec8cf0449018$var$load("gnocL"),
    $dca5ec8cf0449018$var$load("dxKHc"),
    $dca5ec8cf0449018$var$load("i8lZ0"),
    $dca5ec8cf0449018$var$load("iDrFi"),
    $dca5ec8cf0449018$var$load("ffEVr"),
    $dca5ec8cf0449018$var$load("kZzff")
]).then(()=>parcelRequire('2rALa'));

});

parcelRegister("5IJBK", function(module, exports) {

let $42a47094bd68a18d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $42a47094bd68a18d$var$load("eW2qV"),
    $42a47094bd68a18d$var$load("k8nz9"),
    $42a47094bd68a18d$var$load("3yj2i"),
    $42a47094bd68a18d$var$load("7fJS0"),
    $42a47094bd68a18d$var$load("5nbvZ"),
    $42a47094bd68a18d$var$load("2yRsH"),
    $42a47094bd68a18d$var$load("6damH"),
    $42a47094bd68a18d$var$load("fEbOv"),
    $42a47094bd68a18d$var$load("3pUic"),
    $42a47094bd68a18d$var$load("9t4mJ"),
    $42a47094bd68a18d$var$load("yIsjX"),
    $42a47094bd68a18d$var$load("6wr18"),
    $42a47094bd68a18d$var$load("4g6rd"),
    $42a47094bd68a18d$var$load("5dkX4"),
    $42a47094bd68a18d$var$load("bRqDI"),
    $42a47094bd68a18d$var$load("4CyIY"),
    $42a47094bd68a18d$var$load("2F69B"),
    $42a47094bd68a18d$var$load("hBTro"),
    $42a47094bd68a18d$var$load("iY1NC"),
    $42a47094bd68a18d$var$load("4fYzp"),
    $42a47094bd68a18d$var$load("1GCFv"),
    $42a47094bd68a18d$var$load("8LtYa"),
    $42a47094bd68a18d$var$load("cxCk7"),
    $42a47094bd68a18d$var$load("ezYRV"),
    $42a47094bd68a18d$var$load("iEsP0"),
    $42a47094bd68a18d$var$load("w3Gc8"),
    $42a47094bd68a18d$var$load("la2FE"),
    $42a47094bd68a18d$var$load("8d6BA"),
    $42a47094bd68a18d$var$load("Jyh1v"),
    $42a47094bd68a18d$var$load("7EorR"),
    $42a47094bd68a18d$var$load("hhss7"),
    $42a47094bd68a18d$var$load("Wowvf"),
    $42a47094bd68a18d$var$load("2K7Mk"),
    $42a47094bd68a18d$var$load("dxKHc"),
    $42a47094bd68a18d$var$load("i8lZ0"),
    $42a47094bd68a18d$var$load("iDrFi"),
    $42a47094bd68a18d$var$load("ffEVr"),
    $42a47094bd68a18d$var$load("bT0I9")
]).then(()=>parcelRequire('1hCZf'));

});

parcelRegister("bwC5h", function(module, exports) {

var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");


var $4b4iP = parcelRequire("4b4iP");

const $864039964f3f4398$var$SpaceRestriction = ({ spaceKey: spaceKey, contentId: contentId, children: children })=>{
    if (!spaceKey) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4b4iP.SpaceRestrictionHandler), {
        spaceKey: spaceKey,
        contentId: contentId
    }, children);
};
$864039964f3f4398$var$SpaceRestriction.propTypes = {
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).node.isRequired
};
var $864039964f3f4398$export$2e2bcd8739ae039 = $864039964f3f4398$var$SpaceRestriction;
module.exports["default"] = $864039964f3f4398$export$2e2bcd8739ae039;

});

parcelRegister("332hs", function(module, exports) {

let $23836bcb30de9893$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $23836bcb30de9893$var$load("hmUGS").then(()=>parcelRequire('1azj7'));

});

parcelRegister("iufgB", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ef29e49aacc3ecbc$export$80e55c7cff6cb8a = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "IPyzb",
    name: "CreateContentRouteComponentLoader",
    loader: async ()=>(await (parcelRequire("8DP6l"))).CreateContentRouteComponentWrapper
});
module.exports["CreateContentRouteComponentLoader"] = $ef29e49aacc3ecbc$export$80e55c7cff6cb8a;

});

parcelRegister("8DP6l", function(module, exports) {

let $019fa387d2a70443$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $019fa387d2a70443$var$load("g8ky2"),
    $019fa387d2a70443$var$load("ezYRV"),
    $019fa387d2a70443$var$load("8d6BA"),
    $019fa387d2a70443$var$load("aC3bY"),
    $019fa387d2a70443$var$load("fq1gG"),
    $019fa387d2a70443$var$load("5sZTx"),
    $019fa387d2a70443$var$load("deTdD"),
    $019fa387d2a70443$var$load("1JeTB"),
    $019fa387d2a70443$var$load("86OhX"),
    $019fa387d2a70443$var$load("6wr18"),
    $019fa387d2a70443$var$load("loo2r"),
    $019fa387d2a70443$var$load("gbDLp"),
    $019fa387d2a70443$var$load("eNgZ8"),
    $019fa387d2a70443$var$load("lAHCT"),
    $019fa387d2a70443$var$load("Wowvf"),
    $019fa387d2a70443$var$load("aLwQm"),
    $019fa387d2a70443$var$load("excC5"),
    $019fa387d2a70443$var$load("ffEVr"),
    $019fa387d2a70443$var$load("ctxM8"),
    $019fa387d2a70443$var$load("fwbNS"),
    $019fa387d2a70443$var$load("6zCMk"),
    $019fa387d2a70443$var$load("zUKwV"),
    $019fa387d2a70443$var$load("fUeur"),
    $019fa387d2a70443$var$load("ckGjo"),
    $019fa387d2a70443$var$load("iECXC"),
    $019fa387d2a70443$var$load("4g6rd"),
    $019fa387d2a70443$var$load("hhss7"),
    $019fa387d2a70443$var$load("7EorR"),
    $019fa387d2a70443$var$load("lrKPf")
]).then(()=>parcelRequire('79aVL'));

});

parcelRegister("6CEg5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $9eE57 = parcelRequire("9eE57");

class $dc6daeb5b2d3b455$export$616e8efc277d5c6 extends (0, $cozmU.Component) {
    componentDidMount() {
        const { markBeforeMount: markBeforeMount, subject: subject, subjectId: subjectId } = this.props;
        if (!markBeforeMount) (0, $9eE57.perfMarkStart)({
            subject: subject,
            subjectId: subjectId
        });
    }
    render() {
        return null;
    }
    constructor(props){
        super(props);
        if (props.markBeforeMount) {
            const { subject: subject, subjectId: subjectId } = this.props;
            (0, $9eE57.perfMarkStart)({
                subject: subject,
                subjectId: subjectId
            });
        }
    }
}
$dc6daeb5b2d3b455$export$616e8efc277d5c6.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    markBeforeMount: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
};
$dc6daeb5b2d3b455$export$616e8efc277d5c6.defaultProps = {
    subjectId: '',
    markBeforeMount: false
};
module.exports["PerformanceStart"] = $dc6daeb5b2d3b455$export$616e8efc277d5c6;

});

parcelRegister("4Y6DR", function(module, exports) {

let $39e1eaf9f8edca46$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $39e1eaf9f8edca46$var$load("7k9oy"),
    $39e1eaf9f8edca46$var$load("6wr18"),
    $39e1eaf9f8edca46$var$load("ffEVr"),
    $39e1eaf9f8edca46$var$load("8VHGu")
]).then(()=>parcelRequire('7mbVv'));

});

parcelRegister("ko9Ek", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4cd8f2daf274114d$export$2312ebab360877df = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "HinAE",
    // Name is used in next/packages/view-page/src/index.ts must match
    name: "ViewPageRouteComponentLoader",
    loader: async ()=>(await (parcelRequire("8OWXf"))).ViewPageRouteComponent
});
module.exports["ViewPageRouteComponentLoader"] = $4cd8f2daf274114d$export$2312ebab360877df;

});

parcelRegister("8OWXf", function(module, exports) {

let $66c0b9671867dbb6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $66c0b9671867dbb6$var$load("kT6dz"),
    $66c0b9671867dbb6$var$load("cL90P"),
    $66c0b9671867dbb6$var$load("fob67"),
    $66c0b9671867dbb6$var$load("hUbK8"),
    $66c0b9671867dbb6$var$load("53Y0O"),
    $66c0b9671867dbb6$var$load("kYlwR"),
    $66c0b9671867dbb6$var$load("1tqsw"),
    $66c0b9671867dbb6$var$load("9cVML"),
    $66c0b9671867dbb6$var$load("aGpvE"),
    $66c0b9671867dbb6$var$load("fqrmE"),
    $66c0b9671867dbb6$var$load("7SteV"),
    $66c0b9671867dbb6$var$load("52ZTT"),
    $66c0b9671867dbb6$var$load("eNgZ8"),
    $66c0b9671867dbb6$var$load("lAHCT"),
    $66c0b9671867dbb6$var$load("b5lq6"),
    $66c0b9671867dbb6$var$load("hs6P3"),
    $66c0b9671867dbb6$var$load("a9LoI"),
    $66c0b9671867dbb6$var$load("8MaGw"),
    $66c0b9671867dbb6$var$load("ksOjm"),
    $66c0b9671867dbb6$var$load("jAsJw"),
    $66c0b9671867dbb6$var$load("eUsnQ"),
    $66c0b9671867dbb6$var$load("jisiR"),
    $66c0b9671867dbb6$var$load("icVON"),
    $66c0b9671867dbb6$var$load("bPC3R"),
    $66c0b9671867dbb6$var$load("bHb1X"),
    $66c0b9671867dbb6$var$load("90SZm"),
    $66c0b9671867dbb6$var$load("crfrC"),
    $66c0b9671867dbb6$var$load("4x9Jx"),
    $66c0b9671867dbb6$var$load("7gL7H"),
    $66c0b9671867dbb6$var$load("ea3NB"),
    $66c0b9671867dbb6$var$load("6wr18"),
    $66c0b9671867dbb6$var$load("59hV4"),
    $66c0b9671867dbb6$var$load("aNyWk"),
    $66c0b9671867dbb6$var$load("gSKF7"),
    $66c0b9671867dbb6$var$load("dtNxV"),
    $66c0b9671867dbb6$var$load("iTOzX"),
    $66c0b9671867dbb6$var$load("ipkwd"),
    $66c0b9671867dbb6$var$load("a7sEM"),
    $66c0b9671867dbb6$var$load("aLbuU"),
    $66c0b9671867dbb6$var$load("ffEVr"),
    $66c0b9671867dbb6$var$load("ctxM8"),
    $66c0b9671867dbb6$var$load("8Jd6S"),
    $66c0b9671867dbb6$var$load("4Gdnz"),
    $66c0b9671867dbb6$var$load("4UAag"),
    $66c0b9671867dbb6$var$load("1sii7"),
    $66c0b9671867dbb6$var$load("6gMrU"),
    $66c0b9671867dbb6$var$load("iECXC"),
    $66c0b9671867dbb6$var$load("Wowvf"),
    $66c0b9671867dbb6$var$load("4g6rd"),
    $66c0b9671867dbb6$var$load("fq1gG"),
    $66c0b9671867dbb6$var$load("fWCBZ"),
    $66c0b9671867dbb6$var$load("zUKwV"),
    $66c0b9671867dbb6$var$load("fUeur"),
    $66c0b9671867dbb6$var$load("ckGjo"),
    $66c0b9671867dbb6$var$load("5sZTx"),
    $66c0b9671867dbb6$var$load("deTdD"),
    $66c0b9671867dbb6$var$load("aDgIB"),
    $66c0b9671867dbb6$var$load("1JeTB"),
    $66c0b9671867dbb6$var$load("4UHov"),
    $66c0b9671867dbb6$var$load("hhss7"),
    $66c0b9671867dbb6$var$load("cWL7t"),
    $66c0b9671867dbb6$var$load("gbJtu"),
    $66c0b9671867dbb6$var$load("86OhX"),
    $66c0b9671867dbb6$var$load("7EorR"),
    $66c0b9671867dbb6$var$load("2dt2D")
]).then(()=>parcelRequire('bkGU6'));

});

parcelRegister("4D2qK", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d5ef270b375fd8a7$export$9a7f1112e3576698 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Nmdfv",
    name: "ViewPageLiteLoader",
    loader: async ()=>(await (parcelRequire("a8OIh"))).ViewPageLite
});
module.exports["ViewPageLiteLoader"] = $d5ef270b375fd8a7$export$9a7f1112e3576698;

});

parcelRegister("a8OIh", function(module, exports) {

let $7621fd546a8ec0c1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7621fd546a8ec0c1$var$load("kT6dz"),
    $7621fd546a8ec0c1$var$load("ezYRV"),
    $7621fd546a8ec0c1$var$load("8d6BA"),
    $7621fd546a8ec0c1$var$load("jisiR"),
    $7621fd546a8ec0c1$var$load("icVON"),
    $7621fd546a8ec0c1$var$load("ca0UP"),
    $7621fd546a8ec0c1$var$load("a92TB"),
    $7621fd546a8ec0c1$var$load("4UHov"),
    $7621fd546a8ec0c1$var$load("86OhX"),
    $7621fd546a8ec0c1$var$load("5sZTx"),
    $7621fd546a8ec0c1$var$load("deTdD"),
    $7621fd546a8ec0c1$var$load("ce05o"),
    $7621fd546a8ec0c1$var$load("3Wy8Y"),
    $7621fd546a8ec0c1$var$load("3yj2i"),
    $7621fd546a8ec0c1$var$load("h9JXU"),
    $7621fd546a8ec0c1$var$load("yIsjX"),
    $7621fd546a8ec0c1$var$load("4CyIY"),
    $7621fd546a8ec0c1$var$load("dlm6q"),
    $7621fd546a8ec0c1$var$load("iY1NC"),
    $7621fd546a8ec0c1$var$load("4Ve5N"),
    $7621fd546a8ec0c1$var$load("eNgZ8"),
    $7621fd546a8ec0c1$var$load("lAHCT"),
    $7621fd546a8ec0c1$var$load("ksOjm"),
    $7621fd546a8ec0c1$var$load("jAsJw"),
    $7621fd546a8ec0c1$var$load("90SZm"),
    $7621fd546a8ec0c1$var$load("crfrC"),
    $7621fd546a8ec0c1$var$load("2K7Mk"),
    $7621fd546a8ec0c1$var$load("7gL7H"),
    $7621fd546a8ec0c1$var$load("59hV4"),
    $7621fd546a8ec0c1$var$load("iTOzX"),
    $7621fd546a8ec0c1$var$load("ipkwd"),
    $7621fd546a8ec0c1$var$load("a7sEM"),
    $7621fd546a8ec0c1$var$load("jIqhU"),
    $7621fd546a8ec0c1$var$load("lya9W"),
    $7621fd546a8ec0c1$var$load("1sii7"),
    $7621fd546a8ec0c1$var$load("iECXC"),
    $7621fd546a8ec0c1$var$load("5dkX4"),
    $7621fd546a8ec0c1$var$load("h5t0Y"),
    $7621fd546a8ec0c1$var$load("4Gdnz"),
    $7621fd546a8ec0c1$var$load("4UAag"),
    $7621fd546a8ec0c1$var$load("zUKwV"),
    $7621fd546a8ec0c1$var$load("fUeur"),
    $7621fd546a8ec0c1$var$load("1JeTB"),
    $7621fd546a8ec0c1$var$load("6wr18"),
    $7621fd546a8ec0c1$var$load("3fdX4"),
    $7621fd546a8ec0c1$var$load("VYd77"),
    $7621fd546a8ec0c1$var$load("9Oxea"),
    $7621fd546a8ec0c1$var$load("b0ARW"),
    $7621fd546a8ec0c1$var$load("cxCk7"),
    $7621fd546a8ec0c1$var$load("7SteV"),
    $7621fd546a8ec0c1$var$load("dxcsb"),
    $7621fd546a8ec0c1$var$load("ffEVr"),
    $7621fd546a8ec0c1$var$load("Wowvf"),
    $7621fd546a8ec0c1$var$load("4g6rd"),
    $7621fd546a8ec0c1$var$load("fq1gG"),
    $7621fd546a8ec0c1$var$load("hhss7"),
    $7621fd546a8ec0c1$var$load("7EorR"),
    $7621fd546a8ec0c1$var$load("1gUNx"),
    $7621fd546a8ec0c1$var$load("h9zFU")
]).then(()=>parcelRequire('kcroh'));

});

parcelRegister("1ptJE", function(module, exports) {

let $106f3113c21e55b9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $106f3113c21e55b9$var$load("e00ow"),
    $106f3113c21e55b9$var$load("7Xau5")
]).then(()=>parcelRequire('aUago'));

});

parcelRegister("8pBIa", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("6Evf5")).default);

var $6Evf5 = parcelRequire("6Evf5");


});

parcelRegister("6Evf5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $ep3mz = parcelRequire("ep3mz");


var $hl1Kw = parcelRequire("hl1Kw");


var $3GP6F = parcelRequire("3GP6F");


var $aeLio = parcelRequire("aeLio");


var $jMyy4 = parcelRequire("jMyy4");

parcelRequire("hAOSI");
var $9LzHv = parcelRequire("9LzHv");


var $fJp8a = parcelRequire("fJp8a");

const $4d7eb68e35a8590f$var$dayInMilliseconds = 86400000; // hours*minutes*seconds*milliseconds
const $4d7eb68e35a8590f$var$NO_DATE_DEFINED = -1;
const $4d7eb68e35a8590f$var$ARCHIVED = 'archived';
const $4d7eb68e35a8590f$export$10ab27af88aafb56 = (pastDateStr, currentDate = new Date())=>{
    const pastDate = new Date(pastDateStr);
    // days since creation
    return Math.round((currentDate.getTime() - pastDate.getTime()) / $4d7eb68e35a8590f$var$dayInMilliseconds);
};
const $4d7eb68e35a8590f$var$_getDaysSinceCreated = (node)=>{
    const createdDateStr = node?.history?.createdDate;
    return createdDateStr ? $4d7eb68e35a8590f$export$10ab27af88aafb56(createdDateStr) : $4d7eb68e35a8590f$var$NO_DATE_DEFINED;
};
const $4d7eb68e35a8590f$var$_getDaysSinceUpdated = (node)=>{
    const lastUpdatedStr = node?.history?.lastUpdated?.when;
    return lastUpdatedStr ? $4d7eb68e35a8590f$export$10ab27af88aafb56(lastUpdatedStr) : $4d7eb68e35a8590f$var$NO_DATE_DEFINED;
};
const $4d7eb68e35a8590f$export$f8668f0d8d89d19c = (currentDate = new Date())=>{
    const hours = currentDate.getHours();
    return hours >= 15 && hours <= 23;
};
const $4d7eb68e35a8590f$export$35de754c0b3b58bd = ()=>{
    if (document && document.visibilityState) return document.visibilityState;
    return 'unset';
};
const $4d7eb68e35a8590f$var$SendTrackViewPageEvent = ({ pageType: pageType, source: source = 'viewPageScreen' })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [{ searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics }] = (0, $hl1Kw.useSearchSessionId)();
    const featureCodes = (0, $3GP6F.useFeatureCodesInURL)();
    const commentLink = (0, $aeLio.useGetCommentLinkType)();
    const lastFiredKeyRef = (0, $cozmU.useRef)(null);
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $fJp8a.default), {
        variables: {
            contentId: contentId
        },
        __callerPackage__: "confluence-frontend-server"
    });
    const space = data?.content?.nodes?.[0]?.space;
    const fabricEditorSupported = data?.content?.nodes?.[0]?.metadata?.frontend?.fabricEditorSupported;
    const fabricEditorEligibility = data?.content?.nodes?.[0]?.metadata?.frontend?.fabricEditorEligibility;
    if (error || loading || !space) return null;
    const dedupeKey = `${source}:${contentId}`;
    if (lastFiredKeyRef.current === dedupeKey) return null;
    lastFiredKeyRef.current = dedupeKey;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9LzHv.default), {
        action: "viewed",
        actionSubject: "page",
        source: source,
        containerType: "space",
        containerId: space.id,
        objectType: "page",
        objectId: contentId,
        attributes: {
            pageType: pageType,
            daysSinceCreated: $4d7eb68e35a8590f$var$_getDaysSinceCreated(data.content.nodes[0]),
            daysSinceModified: $4d7eb68e35a8590f$var$_getDaysSinceUpdated(data.content.nodes[0]),
            searchReferrer: searchSessionId,
            ...additionalAnalytics,
            isArchivedPage: data.content.nodes[0].status === $4d7eb68e35a8590f$var$ARCHIVED,
            viewedScreenAfter3PM: $4d7eb68e35a8590f$export$f8668f0d8d89d19c(),
            pageVisibility: $4d7eb68e35a8590f$export$35de754c0b3b58bd(),
            fabricEditorEligibility: fabricEditorEligibility,
            fabricEditorSupported: fabricEditorSupported,
            ...featureCodes && featureCodes.from ? {
                from: featureCodes.from
            } : {},
            ...commentLink && {
                commentLink: commentLink
            }
        }
    });
};
$4d7eb68e35a8590f$var$SendTrackViewPageEvent.propTypes = {
    pageType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).oneOf([
        'page',
        'blogpost'
    ]),
    source: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).oneOf([
        'viewPageScreen',
        'mobileWebView'
    ])
};
var $4d7eb68e35a8590f$export$2e2bcd8739ae039 = $4d7eb68e35a8590f$var$SendTrackViewPageEvent;
module.exports["default"] = $4d7eb68e35a8590f$export$2e2bcd8739ae039;

});

parcelRegister("3GP6F", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $KDAt0 = parcelRequire("KDAt0");


var $dPJCf = parcelRequire("dPJCf");


var $lpPVE = parcelRequire("lpPVE");


var $71GjD = parcelRequire("71GjD");




const $9bc3195b956679d5$export$eddc138581adbc11 = ()=>{
    const history = (0, $dPJCf.useHistory)();
    const location = (0, $KDAt0.useLocation)();
    const queryParams = location?.search;
    const queryParamsFeatureCodes = (0, $lpPVE.getFeatureCodes)(new URLSearchParams(queryParams));
    const [featureCodes, setFeatureCodes] = (0, $cozmU.useState)(queryParamsFeatureCodes);
    (0, $cozmU.useEffect)(()=>{
        if (queryParams && queryParams.includes((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) {
            setFeatureCodes(queryParamsFeatureCodes);
            (0, $lpPVE.hideFeatureCodesQueryParam)(history, location);
        }
    }, [
        history,
        location,
        queryParams,
        queryParamsFeatureCodes
    ]);
    return featureCodes;
};
module.exports["useFeatureCodesInURL"] = $9bc3195b956679d5$export$eddc138581adbc11;

});

parcelRegister("lpPVE", function(module, exports) {

var $71GjD = parcelRequire("71GjD");

const $d9de10c6417158bd$export$d347e131abf45bea = (href, featureCodes)=>{
    if (!featureCodes.length) return href;
    const [path, queryString] = href.split('?');
    const searchParams = new URLSearchParams(queryString);
    // If the query param already exists, append the new feature codes to the existing ones
    if (searchParams.has((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) {
        const existingFeatureCodes = searchParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM)) || '';
        const newFeatureCodes = [
            ...new Set([
                ...existingFeatureCodes.split(','),
                ...featureCodes
            ])
        ];
        searchParams.set((0, $71GjD.FEATURE_CODES_QUERY_PARAM), newFeatureCodes.join(','));
    } else searchParams.append((0, $71GjD.FEATURE_CODES_QUERY_PARAM), featureCodes.join(','));
    const newQueryString = searchParams.toString();
    return newQueryString ? `${path}?${newQueryString}` : path;
};
const $d9de10c6417158bd$export$3c2127388df02347 = (queryParams)=>{
    const featureCodes = queryParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM))?.split(',');
    const fromCode = featureCodes?.find((code)=>Object.values((0, $71GjD.FeatureCode)).includes(code));
    return {
        from: fromCode
    };
};
const $d9de10c6417158bd$export$241f453208292937 = (history, location)=>{
    if (!location?.search?.includes((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) return;
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete((0, $71GjD.FEATURE_CODES_QUERY_PARAM));
    const search = searchParams.toString();
    history?.replace?.({
        ...location,
        search: search ? `?${search}` : ''
    });
};
const $d9de10c6417158bd$export$866aaa0a921ee13d = (existingFeatureCodes, featureCodeToCheck)=>{
    return existingFeatureCodes.includes(featureCodeToCheck);
};
const $d9de10c6417158bd$export$84f5742c2ddda28f = (existingFeatureCodes, featureCodeToAdd)=>{
    if ($d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToAdd)) return existingFeatureCodes;
    return [
        ...existingFeatureCodes,
        featureCodeToAdd
    ];
};
const $d9de10c6417158bd$export$f2b1b8a892016485 = (existingFeatureCodes, featureCodeToRemove)=>{
    if (!$d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToRemove)) return existingFeatureCodes;
    return existingFeatureCodes.filter((code)=>code !== featureCodeToRemove);
};
module.exports["generatePathWithFeatureCodesQueryParam"] = $d9de10c6417158bd$export$d347e131abf45bea;
module.exports["getFeatureCodes"] = $d9de10c6417158bd$export$3c2127388df02347;
module.exports["hideFeatureCodesQueryParam"] = $d9de10c6417158bd$export$241f453208292937;

});

parcelRegister("71GjD", function(module, exports) {
/**
 * Feature attribution enum for tracking feature usage/attribution
 *
 * @note All feature codes are intended to be 8 characters or less in length
 *
 * @see https://hello.atlassian.net/wiki/x/lQxt9Q
 */ var $9d2fac30cbee1d6f$export$661babcb078ff919 = /*#__PURE__*/ function(FeatureCode) {
    /** Confluence Home Feeds (Following and Popular) **/ FeatureCode["HOME_FEED"] = "HOMEFEED";
    /** Confluence End of Page Recommendations (Related Pages) **/ FeatureCode["EOP_REC"] = "EOPREC";
    /** Confluence End of Page Recommendations (Related Pages) Hover Card **/ FeatureCode["EOP_REC_CARD"] = "EOPCARD";
    /** Confluence Page Tree **/ FeatureCode["PAGE_TREE"] = "PAGETREE";
    /** Confluence Page Tree Card **/ FeatureCode["PAGE_TREE_CARD"] = "TREECARD";
    /** Following Feed email **/ FeatureCode["FOLLOWING_FEED_EMAIL"] = "FLLWEML";
    /** Popular Feed email **/ FeatureCode["POPULAR_FEED_EMAIL"] = "PPLREML";
    FeatureCode["ADMIN_KEY_EMAIL"] = "ADMINEML";
    FeatureCode["ATTACHMENT_EMAILS"] = "ATTCHEML";
    FeatureCode["BATCH_EMAIL"] = "BATCHEML";
    FeatureCode["BLOG_CREATED_EMAIL"] = "BLOGEML";
    FeatureCode["BULK_ARCHIVE_EMAIL"] = "BLKAREML";
    FeatureCode["BULK_OWNER_CHANGE_EMAIL"] = "BLKOWEML";
    FeatureCode["CONFLUENCE_WRAPPED_EMAIL"] = "WRAPEML";
    FeatureCode["CONTACT_ADMINISTRATORS_EMAIL"] = "CTADMEML";
    FeatureCode["CONTENT_OWNER_CHANGE_EMAIL"] = "OWNREML";
    FeatureCode["CONTENT_REDACTION_EMAIL"] = "RDCTDEML";
    FeatureCode["EXCO_ADDED_TO_SPACE_EMAIL"] = "EXCASEML";
    FeatureCode["EXCO_REQUEST_ACCESS_EMAIL"] = "EXCRAEML";
    FeatureCode["EXCO_SPACE_READY_EMAIL"] = "EXCSREML";
    FeatureCode["IMPORTER_NOTIFICATIONS"] = "IMPRTNTF";
    FeatureCode["LIVE_PAGE_PUBLISHED_EMAIL"] = "LPPEML";
    FeatureCode["MENTIONS_EMAIL"] = "MNTNEML";
    FeatureCode["PAGE_CREATED_EMAIL"] = "PAGEEML";
    FeatureCode["REMINDER_EMAIL"] = "RMNDREML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_EMAILS"] = "REQACEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_SLACK"] = "REQACSLK";
    FeatureCode["TASKS_EMAIL"] = "TASKEML";
    FeatureCode["TEAM_CALENDAR_EMAIL"] = "CLNDREML";
    FeatureCode["WHITEBOARD_CREATED_EMAIL"] = "WTBRDEML";
    FeatureCode["CONTENT_REDACTION_IN_APP"] = "RDCTDAPP";
    FeatureCode["DAILY_DIGEST_EMAIL"] = "DIGSTEML";
    FeatureCode["MENTIONS_REMINDER_EMAIL"] = "MNTNREML";
    FeatureCode["PUBLIC_LINK_EMAIL"] = "PBLNKEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_IN_APP"] = "REQACAPP";
    FeatureCode["SHARE_AND_RESTRICT_DIALOG"] = "SRDIALOG";
    FeatureCode["ROVO_CHAT_LINK"] = "ROVOCHAT";
    FeatureCode["ROVO_EXTENSION_LINK"] = "ROVOEXT";
    FeatureCode["SEND_TO_DESKTOP_EMAIL"] = "SNDDSKEML";
    return FeatureCode;
}({});
const $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd = 'atl_f';
module.exports["FeatureCode"] = $9d2fac30cbee1d6f$export$661babcb078ff919;
module.exports["FEATURE_CODES_QUERY_PARAM"] = $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd;

});

parcelRegister("aeLio", function(module, exports) {

var $dPJCf = parcelRequire("dPJCf");

const $741319b101f491d9$var$useFocusedCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedCommentId');
const $741319b101f491d9$var$useReplyToCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('replyToComment');
const $741319b101f491d9$export$f4b5305c973a36dc = ()=>{
    const focusedCommentId = $741319b101f491d9$var$useFocusedCommentIdQueryParam();
    const replyToCommentId = $741319b101f491d9$var$useReplyToCommentIdQueryParam();
    if (focusedCommentId) return 'isFocusedComment';
    else if (replyToCommentId) return 'isReplyToComment';
    return undefined;
};
module.exports["useGetCommentLinkType"] = $741319b101f491d9$export$f4b5305c973a36dc;

});

parcelRegister("hAOSI", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("9LzHv")).default);

var $9LzHv = parcelRequire("9LzHv");


});

parcelRegister("9LzHv", function(module, exports) {
$parcel$export(module.exports, "default", () => $71c43243f3d11279$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $lzgC6 = parcelRequire("lzgC6");

const $71c43243f3d11279$var$sendTrackEvent = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = props;
    const analyticsData = {
        action: props.action,
        actionSubject: props.actionSubject,
        attributes: props.attributes,
        containerId: props.containerId,
        containerType: props.containerType,
        objectId: props.objectId,
        objectType: props.objectType,
        source: props.source
    };
    const analyticsEvent = createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: analyticsData
    });
    analyticsEvent.fire();
};
function $71c43243f3d11279$var$SendTrackEventComponent(props) {
    const { action: action, actionSubject: actionSubject, attributes: attributes = {}, containerId: containerId, containerType: containerType, objectId: objectId, objectType: objectType, source: source } = props;
    (0, $cozmU.useEffect)(()=>{
        $71c43243f3d11279$var$sendTrackEvent({
            ...props,
            attributes: attributes
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        action,
        actionSubject,
        attributes,
        containerId,
        containerType,
        objectId,
        objectType,
        source
    ]);
    return null;
}
$71c43243f3d11279$var$SendTrackEventComponent.propTypes = {
    action: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    actionSubject: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    containerId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    containerType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    objectId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    objectType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    source: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    createAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired
};
var $71c43243f3d11279$export$2e2bcd8739ae039 = (0, $lzgC6.default)()($71c43243f3d11279$var$SendTrackEventComponent);

});

parcelRegister("fJp8a", function(module, exports) {
/**
 * @generated SignedSource<<a06a8a013af654ab7c26aeab2b65cf59>>
 * @relayHash 32571b6f378434b18a3f7ffd275bf6d4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7b9659f35a7eec8367641693f458f5b2681600dc7f00ef95a9271421a2154a8c
const $2483e127b5e3d8b1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "createdDate"
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "lastUpdated",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "when"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fabricEditorSupported"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fabricEditorEligibility"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SendTrackViewPageEventQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SendTrackViewPageEventQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "32571b6f378434b18a3f7ffd275bf6d4",
            "id": "7b9659f35a7eec8367641693f458f5b2681600dc7f00ef95a9271421a2154a8c",
            "metadata": {},
            "name": "SendTrackViewPageEventQuery",
            "operationKind": "query",
            "text": "query SendTrackViewPageEventQuery($contentId:ID){content(id:$contentId){nodes{id,history{createdDate,lastUpdated{when}},metadata{frontend{fabricEditorSupported,fabricEditorEligibility}},space{id},status}}}"
        }
    };
}();
$2483e127b5e3d8b1$var$node.hash = "19847917790449aae265767493366eb2";
var $2483e127b5e3d8b1$export$2e2bcd8739ae039 = $2483e127b5e3d8b1$var$node;
module.exports["default"] = $2483e127b5e3d8b1$export$2e2bcd8739ae039;

});

parcelRegister("agrhv", function(module, exports) {

let $77908f87a29aef82$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $77908f87a29aef82$var$load("eOkWq"),
    $77908f87a29aef82$var$load("7EorR"),
    $77908f87a29aef82$var$load("iCuQy")
]).then(()=>parcelRequire('4Shbp'));

});

parcelRegister("i0WZi", function(module, exports) {

let $d1d5fbce5f1704fa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d1d5fbce5f1704fa$var$load("ckx79").then(()=>parcelRequire('eGJ8h'));

});

parcelRegister("dY5Vp", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $41efc32f19d16eca$export$aeb070a9ba92094e = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "UtR1u",
    name: "LazyQuestions",
    loader: async ()=>(await (parcelRequire("2ToV8"))).Questions
});
module.exports["LazyQuestions"] = $41efc32f19d16eca$export$aeb070a9ba92094e;

});

parcelRegister("2ToV8", function(module, exports) {

let $21b40c8508f208c6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $21b40c8508f208c6$var$load("6wr18"),
    $21b40c8508f208c6$var$load("7NQuo"),
    $21b40c8508f208c6$var$load("1GCFv"),
    $21b40c8508f208c6$var$load("awOLN"),
    $21b40c8508f208c6$var$load("9w623"),
    $21b40c8508f208c6$var$load("c9Px9"),
    $21b40c8508f208c6$var$load("3Rnfs"),
    $21b40c8508f208c6$var$load("2j57H"),
    $21b40c8508f208c6$var$load("2mGc6"),
    $21b40c8508f208c6$var$load("9vDBp"),
    $21b40c8508f208c6$var$load("RI3SR"),
    $21b40c8508f208c6$var$load("hhss7"),
    $21b40c8508f208c6$var$load("7EorR"),
    $21b40c8508f208c6$var$load("ffEVr"),
    $21b40c8508f208c6$var$load("5xtwP")
]).then(()=>parcelRequire('gCU3O'));

});

parcelRegister("7c80G", function(module, exports) {

let $53cfde09da032b2e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $53cfde09da032b2e$var$load("e80av"),
    $53cfde09da032b2e$var$load("6wr18"),
    $53cfde09da032b2e$var$load("gYJBG"),
    $53cfde09da032b2e$var$load("2bnqk"),
    $53cfde09da032b2e$var$load("gMuW5"),
    $53cfde09da032b2e$var$load("jmpki"),
    $53cfde09da032b2e$var$load("4RHRd"),
    $53cfde09da032b2e$var$load("4Ve5N"),
    $53cfde09da032b2e$var$load("7Y0AX"),
    $53cfde09da032b2e$var$load("hKFtK"),
    $53cfde09da032b2e$var$load("aYkj4"),
    $53cfde09da032b2e$var$load("1fiCx"),
    $53cfde09da032b2e$var$load("4POoz"),
    $53cfde09da032b2e$var$load("dwezT"),
    $53cfde09da032b2e$var$load("w3Gc8"),
    $53cfde09da032b2e$var$load("jqoep"),
    $53cfde09da032b2e$var$load("6C7Vr"),
    $53cfde09da032b2e$var$load("7EorR"),
    $53cfde09da032b2e$var$load("ffEVr"),
    $53cfde09da032b2e$var$load("hLE8r")
]).then(()=>parcelRequire('9Gz8W'));

});

parcelRegister("1nBet", function(module, exports) {

let $1014d1ffb7ad7452$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1014d1ffb7ad7452$var$load("jmpki"),
    $1014d1ffb7ad7452$var$load("2NFUs"),
    $1014d1ffb7ad7452$var$load("iOfkQ"),
    $1014d1ffb7ad7452$var$load("2sCab")
]).then(()=>parcelRequire('3GuAz'));

});

parcelRegister("4pwh9", function(module, exports) {

let $3362887873d439b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3362887873d439b8$var$load("6wr18"),
    $3362887873d439b8$var$load("gYJBG"),
    $3362887873d439b8$var$load("gMuW5"),
    $3362887873d439b8$var$load("jmpki"),
    $3362887873d439b8$var$load("1CIjy"),
    $3362887873d439b8$var$load("e80av"),
    $3362887873d439b8$var$load("4RHRd"),
    $3362887873d439b8$var$load("5nbvZ"),
    $3362887873d439b8$var$load("5zHCN"),
    $3362887873d439b8$var$load("4fYzp"),
    $3362887873d439b8$var$load("4Ve5N"),
    $3362887873d439b8$var$load("7Y0AX"),
    $3362887873d439b8$var$load("kpdr7"),
    $3362887873d439b8$var$load("hKFtK"),
    $3362887873d439b8$var$load("5GZhs"),
    $3362887873d439b8$var$load("dbmJd"),
    $3362887873d439b8$var$load("cT9w0"),
    $3362887873d439b8$var$load("aYkj4"),
    $3362887873d439b8$var$load("1fiCx"),
    $3362887873d439b8$var$load("4POoz"),
    $3362887873d439b8$var$load("dwezT"),
    $3362887873d439b8$var$load("jqoep"),
    $3362887873d439b8$var$load("6C7Vr"),
    $3362887873d439b8$var$load("7EorR"),
    $3362887873d439b8$var$load("ffEVr"),
    $3362887873d439b8$var$load("6sFkE")
]).then(()=>parcelRequire('1T0Cv'));

});

parcelRegister("iXYvb", function(module, exports) {

let $dcecab1ace98cc56$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $dcecab1ace98cc56$var$load("6wr18"),
    $dcecab1ace98cc56$var$load("2bnqk"),
    $dcecab1ace98cc56$var$load("gMuW5"),
    $dcecab1ace98cc56$var$load("jmpki"),
    $dcecab1ace98cc56$var$load("e80av"),
    $dcecab1ace98cc56$var$load("4RHRd"),
    $dcecab1ace98cc56$var$load("5zHCN"),
    $dcecab1ace98cc56$var$load("4Ve5N"),
    $dcecab1ace98cc56$var$load("7Y0AX"),
    $dcecab1ace98cc56$var$load("hKFtK"),
    $dcecab1ace98cc56$var$load("aYkj4"),
    $dcecab1ace98cc56$var$load("1fiCx"),
    $dcecab1ace98cc56$var$load("4POoz"),
    $dcecab1ace98cc56$var$load("dwezT"),
    $dcecab1ace98cc56$var$load("w3Gc8"),
    $dcecab1ace98cc56$var$load("jqoep"),
    $dcecab1ace98cc56$var$load("6C7Vr"),
    $dcecab1ace98cc56$var$load("7EorR"),
    $dcecab1ace98cc56$var$load("ffEVr"),
    $dcecab1ace98cc56$var$load("bYnOS")
]).then(()=>parcelRequire('3EzW0'));

});

parcelRegister("jK9jP", function(module, exports) {

let $e5f98ab562f00263$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e5f98ab562f00263$var$load("ioTV7").then(()=>parcelRequire('9wYcO'));

});

parcelRegister("lHEvX", function(module, exports) {

let $fccd0a6f72aaa1ba$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fccd0a6f72aaa1ba$var$load("2QH3d").then(()=>parcelRequire('flSU2'));

});

parcelRegister("kR2MJ", function(module, exports) {

let $f2eaeae8eecea107$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f2eaeae8eecea107$var$load("1qAcJ").then(()=>parcelRequire('66lXR'));

});

parcelRegister("kI5BG", function(module, exports) {

let $f13c44158af359bd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f13c44158af359bd$var$load("gUrlb"),
    $f13c44158af359bd$var$load("6wr18"),
    $f13c44158af359bd$var$load("cvw7S"),
    $f13c44158af359bd$var$load("jzPyj"),
    $f13c44158af359bd$var$load("ffEVr"),
    $f13c44158af359bd$var$load("ht9O7")
]).then(()=>parcelRequire('eTYeK'));

});

parcelRegister("lGHR2", function(module, exports) {

let $fc9f89d0d3bb493f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fc9f89d0d3bb493f$var$load("gkVge"),
    $fc9f89d0d3bb493f$var$load("6wr18"),
    $fc9f89d0d3bb493f$var$load("kVHWO"),
    $fc9f89d0d3bb493f$var$load("4fYzp"),
    $fc9f89d0d3bb493f$var$load("LWh5V"),
    $fc9f89d0d3bb493f$var$load("1GCFv"),
    $fc9f89d0d3bb493f$var$load("6XCf4"),
    $fc9f89d0d3bb493f$var$load("ebvEF"),
    $fc9f89d0d3bb493f$var$load("l3CW5"),
    $fc9f89d0d3bb493f$var$load("251nM"),
    $fc9f89d0d3bb493f$var$load("aEiTV"),
    $fc9f89d0d3bb493f$var$load("1qlDN"),
    $fc9f89d0d3bb493f$var$load("1yVM6"),
    $fc9f89d0d3bb493f$var$load("ffEVr"),
    $fc9f89d0d3bb493f$var$load("5mKg8")
]).then(()=>parcelRequire('fyrrY'));

});

parcelRegister("l5PUQ", function(module, exports) {
const $794cae3221ca3442$export$ccc7dd6c48bfb65d = 'adminUserAccess';
const $794cae3221ca3442$export$728435b9c77444c = 500;
var $794cae3221ca3442$export$37d3310174fb25af = /*#__PURE__*/ function(PermissionResultType) {
    PermissionResultType["ALLOWED"] = "ALLOWED";
    PermissionResultType["DENIED"] = "DENIED";
    PermissionResultType["INHERITED"] = "INHERITED";
    PermissionResultType["IRRELEVANT"] = "IRRELEVANT";
    return PermissionResultType;
}({});
module.exports["ADMIN_USER_ACCESS_ANALYTICS_SOURCE"] = $794cae3221ca3442$export$ccc7dd6c48bfb65d;
module.exports["SPACE_PERMS_REPORT_POLL_INTERVAL_MS"] = $794cae3221ca3442$export$728435b9c77444c;
module.exports["PermissionResultType"] = $794cae3221ca3442$export$37d3310174fb25af;

});

parcelRegister("11Lo8", function(module, exports) {

let $0bfaa4bf31545584$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0bfaa4bf31545584$var$load("kbzD1").then(()=>parcelRequire('aFOyu'));

});

parcelRegister("j983T", function(module, exports) {

let $df051c82ca5dad1e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $df051c82ca5dad1e$var$load("irTwo"),
    $df051c82ca5dad1e$var$load("4h9Y1"),
    $df051c82ca5dad1e$var$load("kIX5g"),
    $df051c82ca5dad1e$var$load("2jEbr")
]).then(()=>parcelRequire('gaL8X'));

});

parcelRegister("8Uy7i", function(module, exports) {

let $67ce04894684cd36$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $67ce04894684cd36$var$load("jmpki"),
    $67ce04894684cd36$var$load("irTwo"),
    $67ce04894684cd36$var$load("4fYzp"),
    $67ce04894684cd36$var$load("LWh5V"),
    $67ce04894684cd36$var$load("4h9Y1"),
    $67ce04894684cd36$var$load("iGzmZ"),
    $67ce04894684cd36$var$load("kDdlJ"),
    $67ce04894684cd36$var$load("cfsnG"),
    $67ce04894684cd36$var$load("aCER5"),
    $67ce04894684cd36$var$load("8iGBb"),
    $67ce04894684cd36$var$load("11hpF"),
    $67ce04894684cd36$var$load("eMRD3"),
    $67ce04894684cd36$var$load("hhss7"),
    $67ce04894684cd36$var$load("7EorR"),
    $67ce04894684cd36$var$load("1a59G"),
    $67ce04894684cd36$var$load("1jGw5")
]).then(()=>parcelRequire('8XK0M'));

});

parcelRegister("7MqK7", function(module, exports) {

let $5aa1c2a9ed0bfc7c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5aa1c2a9ed0bfc7c$var$load("aFUSO").then(()=>parcelRequire('8Cf2W'));

});

parcelRegister("hSLUF", function(module, exports) {

let $d04ca556b65a495f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d04ca556b65a495f$var$load("la2FE"),
    $d04ca556b65a495f$var$load("9vDBp"),
    $d04ca556b65a495f$var$load("3Wy8Y"),
    $d04ca556b65a495f$var$load("3yj2i"),
    $d04ca556b65a495f$var$load("izROg"),
    $d04ca556b65a495f$var$load("hVmYa"),
    $d04ca556b65a495f$var$load("5nbvZ"),
    $d04ca556b65a495f$var$load("2yRsH"),
    $d04ca556b65a495f$var$load("6damH"),
    $d04ca556b65a495f$var$load("8PJsv"),
    $d04ca556b65a495f$var$load("3pUic"),
    $d04ca556b65a495f$var$load("9t4mJ"),
    $d04ca556b65a495f$var$load("yIsjX"),
    $d04ca556b65a495f$var$load("6wr18"),
    $d04ca556b65a495f$var$load("4g6rd"),
    $d04ca556b65a495f$var$load("5dkX4"),
    $d04ca556b65a495f$var$load("bRqDI"),
    $d04ca556b65a495f$var$load("4CyIY"),
    $d04ca556b65a495f$var$load("2F69B"),
    $d04ca556b65a495f$var$load("izO5t"),
    $d04ca556b65a495f$var$load("hBTro"),
    $d04ca556b65a495f$var$load("iY1NC"),
    $d04ca556b65a495f$var$load("4fYzp"),
    $d04ca556b65a495f$var$load("1GCFv"),
    $d04ca556b65a495f$var$load("koD3t"),
    $d04ca556b65a495f$var$load("1sii7"),
    $d04ca556b65a495f$var$load("lnKog"),
    $d04ca556b65a495f$var$load("ezYRV"),
    $d04ca556b65a495f$var$load("w3Gc8"),
    $d04ca556b65a495f$var$load("8d6BA"),
    $d04ca556b65a495f$var$load("Jyh1v"),
    $d04ca556b65a495f$var$load("7EorR"),
    $d04ca556b65a495f$var$load("hhss7"),
    $d04ca556b65a495f$var$load("Wowvf"),
    $d04ca556b65a495f$var$load("2K7Mk"),
    $d04ca556b65a495f$var$load("dxKHc"),
    $d04ca556b65a495f$var$load("i8lZ0"),
    $d04ca556b65a495f$var$load("iDrFi"),
    $d04ca556b65a495f$var$load("ffEVr"),
    $d04ca556b65a495f$var$load("42uV7")
]).then(()=>parcelRequire('i6Ad2'));

});

parcelRegister("6Ah2q", function(module, exports) {

let $4cb3524bac0b6057$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4cb3524bac0b6057$var$load("5sZTx"),
    $4cb3524bac0b6057$var$load("deTdD"),
    $4cb3524bac0b6057$var$load("1JeTB"),
    $4cb3524bac0b6057$var$load("6wr18"),
    $4cb3524bac0b6057$var$load("cxCk7"),
    $4cb3524bac0b6057$var$load("7SteV"),
    $4cb3524bac0b6057$var$load("ffEVr"),
    $4cb3524bac0b6057$var$load("Wowvf"),
    $4cb3524bac0b6057$var$load("zUKwV"),
    $4cb3524bac0b6057$var$load("fUeur"),
    $4cb3524bac0b6057$var$load("hhss7"),
    $4cb3524bac0b6057$var$load("7EorR"),
    $4cb3524bac0b6057$var$load("ce05o"),
    $4cb3524bac0b6057$var$load("1GCFv"),
    $4cb3524bac0b6057$var$load("kI4kR")
]).then(()=>parcelRequire('2W3Ag'));

});

parcelRegister("8INZr", function(module, exports) {

let $659935c87389ad73$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $659935c87389ad73$var$load("6wr18"),
    $659935c87389ad73$var$load("ffEVr"),
    $659935c87389ad73$var$load("2zIki")
]).then(()=>parcelRequire('8Htp5'));

});

parcelRegister("lhsIn", function(module, exports) {

let $f7e175ac529b036a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f7e175ac529b036a$var$load("lUNmR").then(()=>parcelRequire('94Gnj'));

});

parcelRegister("01pje", function(module, exports) {

let $0043ba0245f7b704$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0043ba0245f7b704$var$load("9UeKl"),
    $0043ba0245f7b704$var$load("6wr18"),
    $0043ba0245f7b704$var$load("bJkEE"),
    $0043ba0245f7b704$var$load("4fYzp"),
    $0043ba0245f7b704$var$load("2NFUs"),
    $0043ba0245f7b704$var$load("4h9Y1"),
    $0043ba0245f7b704$var$load("iGzmZ"),
    $0043ba0245f7b704$var$load("h2QcJ"),
    $0043ba0245f7b704$var$load("5GZhs"),
    $0043ba0245f7b704$var$load("dbmJd"),
    $0043ba0245f7b704$var$load("cT9w0"),
    $0043ba0245f7b704$var$load("aYkj4"),
    $0043ba0245f7b704$var$load("1fiCx"),
    $0043ba0245f7b704$var$load("4POoz"),
    $0043ba0245f7b704$var$load("iOfkQ"),
    $0043ba0245f7b704$var$load("251nM"),
    $0043ba0245f7b704$var$load("iN26T"),
    $0043ba0245f7b704$var$load("ffEVr"),
    $0043ba0245f7b704$var$load("7EorR"),
    $0043ba0245f7b704$var$load("1a59G"),
    $0043ba0245f7b704$var$load("92cXH")
]).then(()=>parcelRequire('bmWlW'));

});

parcelRegister("ejpdO", function(module, exports) {

let $a6b6678ab9eb9ca2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a6b6678ab9eb9ca2$var$load("hG5oc"),
    $a6b6678ab9eb9ca2$var$load("hMnvy")
]).then(()=>parcelRequire('bn8ZY'));

});

parcelRegister("4u39n", function(module, exports) {

let $343c68514be499c1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $343c68514be499c1$var$load("Mp0pM"),
    $343c68514be499c1$var$load("lya9W"),
    $343c68514be499c1$var$load("6wr18"),
    $343c68514be499c1$var$load("7ZdE9"),
    $343c68514be499c1$var$load("2C3m1"),
    $343c68514be499c1$var$load("9KCOJ"),
    $343c68514be499c1$var$load("4h9Y1"),
    $343c68514be499c1$var$load("iGzmZ"),
    $343c68514be499c1$var$load("1gATC"),
    $343c68514be499c1$var$load("8KP5u"),
    $343c68514be499c1$var$load("fo4nX"),
    $343c68514be499c1$var$load("7EorR"),
    $343c68514be499c1$var$load("ffEVr"),
    $343c68514be499c1$var$load("9RiRQ"),
    $343c68514be499c1$var$load("jt9eA"),
    $343c68514be499c1$var$load("5pK3l"),
    $343c68514be499c1$var$load("9UGFj"),
    $343c68514be499c1$var$load("4bzNN"),
    $343c68514be499c1$var$load("8j0Oy"),
    $343c68514be499c1$var$load("6vUJB"),
    $343c68514be499c1$var$load("eqAkJ"),
    $343c68514be499c1$var$load("3zwpG"),
    $343c68514be499c1$var$load("6C7Vr"),
    $343c68514be499c1$var$load("1a59G"),
    $343c68514be499c1$var$load("aez9w")
]).then(()=>parcelRequire('cjovp'));

});

parcelRegister("bAoUu", function(module, exports) {

let $86f661263b97657d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $86f661263b97657d$var$load("6wr18"),
    $86f661263b97657d$var$load("7Alab"),
    $86f661263b97657d$var$load("jh0RP"),
    $86f661263b97657d$var$load("4fYzp"),
    $86f661263b97657d$var$load("4h9Y1"),
    $86f661263b97657d$var$load("iGzmZ"),
    $86f661263b97657d$var$load("ffEVr"),
    $86f661263b97657d$var$load("7EorR"),
    $86f661263b97657d$var$load("1a59G"),
    $86f661263b97657d$var$load("dpKl1")
]).then(()=>parcelRequire('gTSd0'));

});

parcelRegister("aUXwM", function(module, exports) {

let $7f2d4f52e9773c85$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7f2d4f52e9773c85$var$load("jh0RP"),
    $7f2d4f52e9773c85$var$load("c8GnP")
]).then(()=>parcelRequire('145h7'));

});

parcelRegister("gjZQ9", function(module, exports) {

let $be1e63d9dcc8f6f9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $be1e63d9dcc8f6f9$var$load("exvU8").then(()=>parcelRequire('9ZXTU'));

});

parcelRegister("aTktW", function(module, exports) {

let $7edeedb4491b472e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7edeedb4491b472e$var$load("9EI97").then(()=>parcelRequire('ivpO0'));

});

parcelRegister("7PF1e", function(module, exports) {

let $5b3d1d4c3a7b93c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5b3d1d4c3a7b93c3$var$load("2n8AT").then(()=>parcelRequire('cv3PF'));

});

parcelRegister("hSMRQ", function(module, exports) {

let $d04d62d960e85d39$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d04d62d960e85d39$var$load("7k9oy"),
    $d04d62d960e85d39$var$load("jczTu")
]).then(()=>parcelRequire('bnpc5'));

});

parcelRegister("eieXD", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $02af7510cb9721a1$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("a2lmi")));

var $fbwmZ = parcelRequire("fbwmZ");


var $dcw8o = parcelRequire("dcw8o");


var $ilRwI = parcelRequire("ilRwI");


var $6NrTk = parcelRequire("6NrTk");


var $eIjjl = parcelRequire("eIjjl");


var $a2lmi = parcelRequire("a2lmi");

var $02af7510cb9721a1$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $02af7510cb9721a1$var$_window = (0, $6NrTk.getGlobalObject)();
if ($02af7510cb9721a1$var$_window.Sentry && $02af7510cb9721a1$var$_window.Sentry.Integrations) $02af7510cb9721a1$var$windowIntegrations = $02af7510cb9721a1$var$_window.Sentry.Integrations;
var $02af7510cb9721a1$export$99d02219d259eb94 = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, $02af7510cb9721a1$var$windowIntegrations), (0, $ilRwI)), $eIjjl);
 //# sourceMappingURL=index.js.map
$parcel$exportWildcard(module.exports, $dcw8o);

});

parcelRegister("dcw8o", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("dtZ6d")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("hkv0W")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("9HPf3")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("9HPf3")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("9HPf3")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("9HPf3")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("9HPf3")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("amM2J")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("amM2J")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("amM2J")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("amM2J")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("hkv0W")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("dQl3s")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("9HPf3")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("a953x")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("9HPf3")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("9HPf3")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("9HPf3")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("9HPf3")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("9HPf3")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("9HPf3")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("9HPf3")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("e9HlS")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("9whyS")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("l17tw")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("l17tw")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("eAdCn")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("eAdCn")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("eAdCn")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("eAdCn")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("eAdCn")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("eAdCn")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("eAdCn")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("eAdCn")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("eAdCn")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("7iBHc")).SDK_NAME);

var $dtZ6d = parcelRequire("dtZ6d");


var $9HPf3 = parcelRequire("9HPf3");

var $hkv0W = parcelRequire("hkv0W");

var $amM2J = parcelRequire("amM2J");

var $a953x = parcelRequire("a953x");

var $dQl3s = parcelRequire("dQl3s");


var $e9HlS = parcelRequire("e9HlS");


var $9whyS = parcelRequire("9whyS");


var $l17tw = parcelRequire("l17tw");


var $eAdCn = parcelRequire("eAdCn");


var $7iBHc = parcelRequire("7iBHc");

 //# sourceMappingURL=exports.js.map

});

parcelRegister("7iBHc", function(module, exports) {
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $55077470b8523cd3$export$ca61d37259221480 = 'sentry.javascript.browser'; //# sourceMappingURL=version.js.map
module.exports["SDK_NAME"] = $55077470b8523cd3$export$ca61d37259221480;

});

parcelRegister("eIjjl", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("cEELl")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("51FBI")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("bNfZ4")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("6oUta")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("aMh6Y")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("lBiNe")).Dedupe);

var $cEELl = parcelRequire("cEELl");


var $51FBI = parcelRequire("51FBI");


var $bNfZ4 = parcelRequire("bNfZ4");


var $6oUta = parcelRequire("6oUta");


var $aMh6Y = parcelRequire("aMh6Y");


var $lBiNe = parcelRequire("lBiNe");

 //# sourceMappingURL=index.js.map

});

parcelRegister("a2lmi", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("l2hU1")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("9yqZL")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("5a5jw")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("hu9Hi")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("3FUEv")).makeNewXHRTransport);

var $l2hU1 = parcelRequire("l2hU1");


var $9yqZL = parcelRequire("9yqZL");


var $5a5jw = parcelRequire("5a5jw");


var $hu9Hi = parcelRequire("hu9Hi");


var $3FUEv = parcelRequire("3FUEv");

 //# sourceMappingURL=index.js.map

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

const $abc73c6f5c74c436$export$6d558eab13290f59 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
module.exports["useRouterLink"] = $abc73c6f5c74c436$export$6d558eab13290f59;

});

parcelRegister("ac2J9", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1,
            children: children
        });
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("gTPfK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");

const $6057e25d3e7f93e3$var$withAnalyticsContext = (defaultData)=>(WrappedComponent)=>{
        const WithAnalyticsContext = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
            const $ = (0, $bDgLe.c)(11);
            let analyticsContext;
            let rest;
            if ($[0] !== t0) {
                ({ analyticsContext: analyticsContext, ...rest } = t0);
                $[0] = t0;
                $[1] = analyticsContext;
                $[2] = rest;
            } else {
                analyticsContext = $[1];
                rest = $[2];
            }
            let t1;
            if ($[3] !== analyticsContext) {
                t1 = {
                    ...defaultData,
                    ...analyticsContext
                };
                $[3] = analyticsContext;
                $[4] = t1;
            } else t1 = $[4];
            const analyticsData = t1;
            const t2 = rest;
            let t3;
            if ($[5] !== ref || $[6] !== t2) {
                t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                    ...t2,
                    ref: ref
                });
                $[5] = ref;
                $[6] = t2;
                $[7] = t3;
            } else t3 = $[7];
            let t4;
            if ($[8] !== analyticsData || $[9] !== t3) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                    data: analyticsData
                }, t3);
                $[8] = analyticsData;
                $[9] = t3;
                $[10] = t4;
            } else t4 = $[10];
            return t4;
        } : ({ analyticsContext: analyticsContext, ...rest }, ref)=>{
            const analyticsData = (0, $cozmU.useMemo)(()=>({
                    ...defaultData,
                    ...analyticsContext
                }), [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                ...rest,
                ref: ref
            }));
        });
        WithAnalyticsContext.displayName = `WithAnalyticsContext(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsContext;
    };
var $6057e25d3e7f93e3$export$2e2bcd8739ae039 = $6057e25d3e7f93e3$var$withAnalyticsContext;
module.exports["default"] = $6057e25d3e7f93e3$export$2e2bcd8739ae039;

});

parcelRegister("4Uejl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jlWUB = parcelRequire("jlWUB");


var $lrDw7 = parcelRequire("lrDw7");


var $7BVQi = parcelRequire("7BVQi");


var $g3XYx = parcelRequire("g3XYx");


var $1U6E9 = parcelRequire("1U6E9");


var $jhrdR = parcelRequire("jhrdR");

/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $8b8583a0a90649e3$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $8b8583a0a90649e3$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $8b8583a0a90649e3$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $8b8583a0a90649e3$export$a300664a1a230956 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion } = t0;
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            cleanup: "next-effect"
        };
        $[0] = t1;
    } else t1 = $[0];
    const setTimeout = (0, $1U6E9.useSetTimeout)(t1);
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    let t2;
    if ($[1] !== element) {
        t2 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element) return;
            const rect = element.getBoundingClientRect();
            prevDimensions.current = {
                width: rect.width,
                height: rect.height
            };
        };
        $[1] = element;
        $[2] = t2;
    } else t2 = $[2];
    (0, $jhrdR.useSnapshotBeforeUpdate)(t2);
    let t3;
    if ($[3] !== dimension || $[4] !== duration || $[5] !== easing || $[6] !== element || $[7] !== onFinishMotion || $[8] !== requestAnimationFrame || $[9] !== setTimeout) {
        t3 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element || !prevDimensions.current) return;
            element.setAttribute("style", "");
            const rect_0 = element.getBoundingClientRect();
            const nextDimensions = {
                width: rect_0.width,
                height: rect_0.height
            };
            if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
                onFinishMotion?.();
                return;
            }
            const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
            const newStyles = {
                willChange: propertyList,
                transitionProperty: propertyList,
                transitionDuration: duration,
                boxSizing: "border-box",
                transitionTimingFunction: easing
            };
            if (dimension === "width" || dimension === "both") newStyles.width = `${prevDimensions.current.width}px`;
            if (dimension === "height" || dimension === "both") newStyles.height = `${prevDimensions.current.height}px`;
            Object.assign(element.style, newStyles);
            const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (!element) return;
                    if (dimension === "width" || dimension === "both") element.style.width = `${nextDimensions.width}px`;
                    if (dimension === "height" || dimension === "both") element.style.height = `${nextDimensions.height}px`;
                    setTimeout(()=>{
                        if (!element) return;
                        element.setAttribute("style", "");
                        onFinishMotion?.();
                    }, resolvedDuration);
                });
            });
        };
        $[3] = dimension;
        $[4] = duration;
        $[5] = easing;
        $[6] = element;
        $[7] = onFinishMotion;
        $[8] = requestAnimationFrame;
        $[9] = setTimeout;
        $[10] = t3;
    } else t3 = $[10];
    (0, $7BVQi.useLayoutEffect)(t3);
    let t4;
    if ($[11] !== setElementRef) {
        t4 = {
            ref: setElementRef
        };
        $[11] = setElementRef;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion })=>{
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    const setTimeout = (0, $1U6E9.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    (0, $jhrdR.useSnapshotBeforeUpdate)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $7BVQi.useLayoutEffect)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect_0 = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect_0.width,
            height: rect_0.height
        };
        if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
module.exports["useResizing"] = $8b8583a0a90649e3$export$a300664a1a230956;

});

parcelRegister("lrDw7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6a66563ef19581ba$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $cozmU.useRef)(null);
    const setRef = (0, $cozmU.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $6a66563ef19581ba$export$ff879f35a69d56b7;

});

parcelRegister("g3XYx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $f8fe10123ae9dc81$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $f8fe10123ae9dc81$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $cozmU.useRef)([]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $f8fe10123ae9dc81$var$getHookDeps(opts));
    return (0, $cozmU.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
module.exports["useRequestAnimationFrame"] = $f8fe10123ae9dc81$export$1775f27e7c8051ca;

});

parcelRegister("jhrdR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7BVQi = parcelRequire("7BVQi");

const $8584e1bffd64d1d0$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $cozmU.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $7BVQi.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $8584e1bffd64d1d0$export$9e95200239cd148b;

});

parcelRegister("iU5Yo", function(module, exports) {
/**
 * @generated SignedSource<<af2660d441125c4e4bac2f96e801c03d>>
 * @relayHash 87bd514c61c54056c9bc44eb7829f5c1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6034f67e4acab424f0f79800b863701f550bb75dfbd479611f493b8bffc2205c
const $1361d756abf1f7da$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldIncludeJobTitle"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v5 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "args": [
            v5 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "status",
                "value": [
                    "current",
                    "draft",
                    "archived"
                ]
            }
        ],
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v6 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "status"
                    }
                ]
            }
        ]
    }, v8 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "spaceKey"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "concreteType": "SpaceUserMetadata",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isAdmin"
                    }
                ]
            }
        ]
    }, v9 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v5 /*: any*/ 
    ], v10 = {
        "kind": "ScalarField",
        "name": "count"
    }, v11 = {
        "kind": "ScalarField",
        "name": "type"
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v14 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            v14 /*: any*/ ,
            {
                "condition": "shouldIncludeJobTitle",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jobTitle"
                    }
                ]
            }
        ],
        "type": "KnownUser"
    }, v16 = {
        "concreteType": "ConfluenceAgent",
        "kind": "LinkedField",
        "name": "agent",
        "plural": false,
        "selections": [
            v12 /*: any*/ ,
            v14 /*: any*/ ,
            v13 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PageOwnershipByLineWithCollaboratorsDropdownContentQuery",
            "selections": [
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "ConfluenceCollaboratorConnection",
                    "kind": "LinkedField",
                    "name": "confluence_contentCollaborators",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceCollaborator",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "person",
                                    "plural": false,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v15 /*: any*/ 
                                    ]
                                },
                                v16 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PageOwnershipByLineWithCollaboratorsDropdownContentQuery",
            "selections": [
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "ConfluenceCollaboratorConnection",
                    "kind": "LinkedField",
                    "name": "confluence_contentCollaborators",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceCollaborator",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "person",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v15 /*: any*/ 
                                    ]
                                },
                                v16 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "87bd514c61c54056c9bc44eb7829f5c1",
            "id": "6034f67e4acab424f0f79800b863701f550bb75dfbd479611f493b8bffc2205c",
            "metadata": {},
            "name": "PageOwnershipByLineWithCollaboratorsDropdownContentQuery",
            "operationKind": "query",
            "text": "query PageOwnershipByLineWithCollaboratorsDropdownContentQuery($cloudId:ID!,$id:ID!,$spaceKey:String!,$first:Int!,$shouldIncludeJobTitle:Boolean!){content(id:$id,status:[\"current\",\"draft\",\"archived\"]){nodes{id,status}},space(key:$spaceKey){id,currentUser{isAdmin}},confluence_contentCollaborators(cloudId:$cloudId,id:$id,first:$first){count,nodes{person{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId,jobTitle@include(if:$shouldIncludeJobTitle)}},agent{displayName,accountId,profilePicture{path}}}}}"
        }
    };
}();
$1361d756abf1f7da$var$node.hash = "c0bda5775ae1a53e6d90777fe11b5bc2";
var $1361d756abf1f7da$export$2e2bcd8739ae039 = $1361d756abf1f7da$var$node;
module.exports["default"] = $1361d756abf1f7da$export$2e2bcd8739ae039;

});

parcelRegister("jBVey", function(module, exports) {
// GraphQL Int is signed 32-bit; retain the existing request limit for all collaborators.
const $a8ef658bbe571a90$var$MAX_GRAPHQL_INT = 2147483647;
const $a8ef658bbe571a90$export$2ca5f942f8975c8a = ({ cloudId: cloudId, contentId: contentId, spaceKey: spaceKey, shouldIncludeJobTitle: shouldIncludeJobTitle })=>({
        cloudId: cloudId,
        id: contentId,
        spaceKey: spaceKey,
        first: $a8ef658bbe571a90$var$MAX_GRAPHQL_INT,
        shouldIncludeJobTitle: shouldIncludeJobTitle
    });
module.exports["getContentCollaboratorsQueryVariables"] = $a8ef658bbe571a90$export$2ca5f942f8975c8a;

});

parcelRegister("4YBSq", function(module, exports) {
/**
 * @generated SignedSource<<9700b2b14bf1783e20ed515703a9c457>>
 * @relayHash f85bb73042ebe75e2cb50dec93f9b7c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ea06e652012418baf02c0133f828dbef03e488a63e53403257a821a52af7d139
const $16e983e3bee16ecd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fabricEditorSupported"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "embedded"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "collabService"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subType"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditContentButtonQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditContentButtonQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f85bb73042ebe75e2cb50dec93f9b7c4",
            "id": "ea06e652012418baf02c0133f828dbef03e488a63e53403257a821a52af7d139",
            "metadata": {},
            "name": "EditContentButtonQuery",
            "operationKind": "query",
            "text": "query EditContentButtonQuery($contentId:ID!){content(id:$contentId){nodes{id,type,operations{operation,targetType},metadata{frontend{fabricEditorSupported,embedded,collabService}},subType,space{id,key}}}}"
        }
    };
}();
$16e983e3bee16ecd$var$node.hash = "94b096c536d2633f3df010c4409c1c2a";
var $16e983e3bee16ecd$export$2e2bcd8739ae039 = $16e983e3bee16ecd$var$node;
module.exports["default"] = $16e983e3bee16ecd$export$2e2bcd8739ae039;

});

parcelRegister("kwDQA", function(module, exports) {
/**
 * @generated SignedSource<<c4c634ffb5984138b240a2bcc61996d1>>
 * @relayHash 68505bc224ec19edfba49afd43c7d907
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7618a04782001a87f52f617aa9203459f640bc016a7615579a83c2dc59caaf99
const $377c093245c44338$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentAnalyticsViewers",
            "kind": "LinkedField",
            "name": "contentAnalyticsViewers",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "count"
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAnalyticsByLineQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAnalyticsByLineQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "68505bc224ec19edfba49afd43c7d907",
            "id": "7618a04782001a87f52f617aa9203459f640bc016a7615579a83c2dc59caaf99",
            "metadata": {},
            "name": "useAnalyticsByLineQuery",
            "operationKind": "query",
            "text": "query useAnalyticsByLineQuery($contentId:ID!){contentAnalyticsViewers(contentId:$contentId){count},user:confluence_atlassianUser(current:true){id,confluence{permissionType}}}"
        }
    };
}();
$377c093245c44338$var$node.hash = "1059930ceaf11a1fca0cb8f2f9d20c27";
var $377c093245c44338$export$2e2bcd8739ae039 = $377c093245c44338$var$node;
module.exports["default"] = $377c093245c44338$export$2e2bcd8739ae039;

});

parcelRegister("8EyOs", function(module, exports) {
/**
 * @generated SignedSource<<dd6200b047aed134b0d9af6a992daf7b>>
 * @relayHash 0c7e59589b279881378fc2baf2dcf71b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0dfd28d4a6a045f36efbb873be6de601dedb01632d322cff86c74287f8c186bb
const $231a29dfed7a7165$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "format"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isDraft",
                            "variableName": "isDraft"
                        }
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "color"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "restrictionLevel"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "format",
                            "variableName": "format"
                        }
                    ],
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "contentStateLastUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RendererContentStateQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RendererContentStateQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "0c7e59589b279881378fc2baf2dcf71b",
            "id": "0dfd28d4a6a045f36efbb873be6de601dedb01632d322cff86c74287f8c186bb",
            "metadata": {},
            "name": "RendererContentStateQuery",
            "operationKind": "query",
            "text": "query RendererContentStateQuery($contentId:ID!,$isDraft:Boolean!,$format:GraphQLDateFormat){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel},contentStateLastUpdated(format:$format){value}}}"
        }
    };
}();
$231a29dfed7a7165$var$node.hash = "a7f67982771d8fe760ba232b1260bced";
var $231a29dfed7a7165$export$2e2bcd8739ae039 = $231a29dfed7a7165$var$node;
module.exports["default"] = $231a29dfed7a7165$export$2e2bcd8739ae039;

});

parcelRegister("euq7N", function(module, exports) {

var $7Ndnw = parcelRequire("7Ndnw");


var $grspz = parcelRequire("grspz");

const $6dc423d8105f54f8$export$f11fa81fda7aba5a = (extensions = window.__SSR_FORGE_EXTENSIONS__?.[0, $7Ndnw.FORGE_MODULE_BYLINE]?.extensions ?? [])=>{
    const keys = new Set();
    for (const extension of extensions){
        const contentPropertyKey = extension.properties.contentPropertyKey;
        if (!contentPropertyKey) continue;
        // Forge UI Kit namespaces useContentProperty keys, while apps using the REST API can
        // persist the manifest key directly. Query both exact forms and keep the response bounded.
        keys.add(contentPropertyKey);
        keys.add(`forge-${(0, $grspz.getLocalId)(extension.id)}-${contentPropertyKey}`);
    }
    return [
        ...keys
    ].sort();
};
module.exports["getBylineAppContentPropertyKeys"] = $6dc423d8105f54f8$export$f11fa81fda7aba5a;

});

parcelRegister("grspz", function(module, exports) {
const $cdcead6f01277136$export$957229695d10ea4a = (extensionId)=>{
    return extensionId.replace(/[^a-zA-Z0-9-]/g, '-');
};
module.exports["getLocalId"] = $cdcead6f01277136$export$957229695d10ea4a;

});

parcelRegister("7sf7C", function(module, exports) {
/**
 * @generated SignedSource<<fedf2e7c613e909441ea794a19d16f08>>
 * @relayHash 8547d0f98c831317a8e1f099d9dd5e48
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 287cd399384b3669f9337addcc127ff0da7c0f662eea8cff6a77161d92893bcf
const $7d674aec1e0705be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "keys"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "keys",
                                    "variableName": "keys"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "number"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ByLineForgeAppGeneralContentPropertyQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ByLineForgeAppGeneralContentPropertyQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "8547d0f98c831317a8e1f099d9dd5e48",
            "id": "287cd399384b3669f9337addcc127ff0da7c0f662eea8cff6a77161d92893bcf",
            "metadata": {},
            "name": "ByLineForgeAppGeneralContentPropertyQuery",
            "operationKind": "query",
            "text": "query ByLineForgeAppGeneralContentPropertyQuery($contentId:ID!,$keys:[String!]){content(id:$contentId){nodes{id,properties(keys:$keys){nodes{id,key,version{number},value}}}}}"
        }
    };
}();
$7d674aec1e0705be$var$node.hash = "66eca16603f88617f8c995c6596e989e";
var $7d674aec1e0705be$export$2e2bcd8739ae039 = $7d674aec1e0705be$var$node;
module.exports["default"] = $7d674aec1e0705be$export$2e2bcd8739ae039;

});

parcelRegister("568fA", function(module, exports) {
/**
 * @generated SignedSource<<edb2a48d5268bebed303963270db4c3a>>
 * @relayHash b647ff34a22d9e67b3330f440f310bb5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8e540b0c89e30ec6f141235a6f4e47d93b9ce22a39faec34b35e59dfd7657f73
const $0dc90704ec36fa39$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "archived",
                "current",
                "draft"
            ]
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v9 = {
        "kind": "ScalarField",
        "name": "status"
    }, v10 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "smartFolderProperties"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"smartFolderProperties\"])"
    }, v11 = {
        "kind": "ScalarField",
        "name": "contentTypeModified"
    }, v12 = {
        "kind": "ScalarField",
        "name": "number"
    }, v13 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v14 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v15 = {
        "kind": "ScalarField",
        "name": "when"
    }, v16 = [
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                v14 /*: any*/ 
            ]
        },
        v15 /*: any*/ 
    ], v17 = [
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                v14 /*: any*/ 
            ]
        },
        v15 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentTypesHeaderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": v16 /*: any*/ 
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "draftVersion",
                                    "plural": false,
                                    "selections": v16 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentTypesHeaderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": v17 /*: any*/ 
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "draftVersion",
                                    "plural": false,
                                    "selections": v17 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b647ff34a22d9e67b3330f440f310bb5",
            "id": "8e540b0c89e30ec6f141235a6f4e47d93b9ce22a39faec34b35e59dfd7657f73",
            "metadata": {},
            "name": "ContentTypesHeaderQuery",
            "operationKind": "query",
            "text": "query ContentTypesHeaderQuery($contentId:ID){content(id:$contentId,status:[\"archived\",\"current\",\"draft\"]){nodes{id,title,operations{operation,targetType},space{id,name,key,alias},type,subType,status,properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when}}}}"
        }
    };
}();
$0dc90704ec36fa39$var$node.hash = "1e8693f245d726bc820bbd0bffbc0cff";
var $0dc90704ec36fa39$export$2e2bcd8739ae039 = $0dc90704ec36fa39$var$node;
module.exports["default"] = $0dc90704ec36fa39$export$2e2bcd8739ae039;

});

parcelRegister("lPNkm", function(module, exports) {
/**
 * @generated SignedSource<<fcf122e4a0dd12a263fab6061b3a36dd>>
 * @relayHash 19081691cac2c634716f82092efd5e14
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3d5dc74f8943db901b65da9952c21aedcb442dbab7bde8fc78fddd85434811f3
const $98f50c7d6961f0d8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "html"
        },
        {
            "kind": "ScalarField",
            "name": "js"
        },
        {
            "kind": "ScalarField",
            "name": "css"
        },
        {
            "concreteType": "SpaUnfriendlyMacro",
            "kind": "LinkedField",
            "name": "spaUnfriendlyMacros",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceSettings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SpaceSettingsMetadata",
                            "kind": "LinkedField",
                            "name": "customHeaderAndFooter",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "HtmlMeta",
                                    "kind": "LinkedField",
                                    "name": "header",
                                    "plural": false,
                                    "selections": v1 /*: any*/ 
                                },
                                {
                                    "concreteType": "HtmlMeta",
                                    "kind": "LinkedField",
                                    "name": "footer",
                                    "plural": false,
                                    "selections": v1 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CustomHeaderFooterQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CustomHeaderFooterQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "19081691cac2c634716f82092efd5e14",
            "id": "3d5dc74f8943db901b65da9952c21aedcb442dbab7bde8fc78fddd85434811f3",
            "metadata": {},
            "name": "CustomHeaderFooterQuery",
            "operationKind": "query",
            "text": "query CustomHeaderFooterQuery($spaceKey:String){space(key:$spaceKey){id,settings{customHeaderAndFooter{header{html,js,css,spaUnfriendlyMacros{name}},footer{html,js,css,spaUnfriendlyMacros{name}}}}}}"
        }
    };
}();
$98f50c7d6961f0d8$var$node.hash = "deed3f087b4973bd7d276b1389cfb125";
var $98f50c7d6961f0d8$export$2e2bcd8739ae039 = $98f50c7d6961f0d8$var$node;
module.exports["default"] = $98f50c7d6961f0d8$export$2e2bcd8739ae039;

});

parcelRegister("k5dl6", function(module, exports) {
/**
 * @generated SignedSource<<6dc466aba14c78f3432cf6d35f092a95>>
 * @relayHash 9f9cb3b101c0d783a0151d795ee8a444
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 97db17732754f14f8a0a3024abfd1a748e416b71742d827d0bfd273f20b59b06
const $bff977656480fdfe$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v3 = {
        "args": [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "contentId"
            }
        ],
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v2 /*: any*/ 
                        ]
                    },
                    v2 /*: any*/ 
                ]
            }
        ]
    }, v4 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        },
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ALL"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "UNRESOLVED"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "value"
    }, v6 = [
        v5 /*: any*/ 
    ], v7 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v6 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v8 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v6 /*: any*/ 
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v10 = {
        "kind": "ScalarField",
        "name": "isInlineComment"
    }, v11 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "kind": "ScalarField",
        "name": "when"
    }, v14 = {
        "kind": "ScalarField",
        "name": "number"
    }, v15 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v12 /*: any*/ 
                ]
            },
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ]
    }, v16 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v17 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v20 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v21 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replies",
        "plural": true,
        "selections": [
            v1 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v15 /*: any*/ ,
            v16 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v22 = {
        "alias": "user",
        "args": [
            {
                "kind": "Literal",
                "name": "current",
                "value": true
            }
        ],
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
            v1 /*: any*/ ,
            v12 /*: any*/ ,
            {
                "concreteType": "AtlassianUserPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isPrimary"
                    }
                ]
            }
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
    }, v23 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v24 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v23 /*: any*/ ,
                    v12 /*: any*/ 
                ]
            },
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ]
    }, v25 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v23 /*: any*/ ,
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v26 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replies",
        "plural": true,
        "selections": [
            v1 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v24 /*: any*/ ,
            v16 /*: any*/ ,
            v25 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "InlineCommentsFocusedInlineCommentQuery",
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                },
                                v1 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ 
                            ]
                        }
                    ]
                },
                v22 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "InlineCommentsFocusedInlineCommentQuery",
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ 
                                    ]
                                },
                                v1 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v24 /*: any*/ ,
                                v16 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ 
                            ]
                        }
                    ]
                },
                v22 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "9f9cb3b101c0d783a0151d795ee8a444",
            "id": "97db17732754f14f8a0a3024abfd1a748e416b71742d827d0bfd273f20b59b06",
            "metadata": {},
            "name": "InlineCommentsFocusedInlineCommentQuery",
            "operationKind": "query",
            "text": "query InlineCommentsFocusedInlineCommentQuery($commentId:ID!,$contentId:ID){content(id:$contentId){nodes{id,type,space{id,operations{operation,targetType}},operations{operation,targetType}}},comments(commentId:$commentId,depth:ALL,type:UNRESOLVED){nodes{ancestors{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}},id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}}},user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary}}}"
        }
    };
}();
$bff977656480fdfe$var$node.hash = "c6bc55705b1b90c4e9cb60ee0b5a4650";
var $bff977656480fdfe$export$2e2bcd8739ae039 = $bff977656480fdfe$var$node;
module.exports["default"] = $bff977656480fdfe$export$2e2bcd8739ae039;

});

parcelRegister("5CUwy", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $gXfti = parcelRequire("gXfti");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $8999o = parcelRequire("8999o");


var $lnyJf = parcelRequire("lnyJf");


var $3uzFB = parcelRequire("3uzFB");


var $2gAEP = parcelRequire("2gAEP");

var $9633e2f0bea217d1$export$ebe749be4eb13ac4 = /*#__PURE__*/ function(LoomTenantProvisionStatus) {
    LoomTenantProvisionStatus["PROVISIONED"] = "provisioned";
    LoomTenantProvisionStatus["NOT_PROVISIONED"] = "not-provisioned";
    LoomTenantProvisionStatus["ERROR"] = "error,";
    return LoomTenantProvisionStatus;
}({});
var $9633e2f0bea217d1$export$7909e54672d1c423 = /*#__PURE__*/ function(LoomUserPermissionStatus) {
    LoomUserPermissionStatus["PERMITTED"] = "permitted";
    LoomUserPermissionStatus["NOT_PERMITTED"] = "not-permitted";
    LoomUserPermissionStatus["ERROR"] = "error,";
    return LoomUserPermissionStatus;
}({});
const $9633e2f0bea217d1$var$getLoomTenantProvisionStatus = async ()=>{
    try {
        const licensedProducts = await (0, $c0rhi.queryInterop)({
            query: (0, $2gAEP.default),
            __callerPackage__: "loom-utils"
        });
        const isTenantLicensed = licensedProducts.data.confluence_tenantContext?.licensedProducts.some((product)=>product.productKey === 'loom' && product.licenseStatus === 'ACTIVE');
        return isTenantLicensed ? "provisioned" : "not-provisioned";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$export$85de6c803181afa9 = async (cloudId, userId)=>{
    if (!userId) return "not-permitted";
    const variables = (0, $3uzFB.getLoomUserPermissionQueryVariables)(cloudId, userId);
    try {
        const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
            query: (0, $3uzFB.LoomUserPermissionQuery),
            variables: variables,
            errorPolicy: 'all',
            interopApolloAggClient: true,
            __callerPackage__: "loom-utils"
        });
        if (error) throw error;
        return (0, $3uzFB.hasExactLoomUserPermission)(data, variables) ? "permitted" : "not-permitted";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$var$initialState = {
    loomEntryPointVariant: window.__SSR_LOOM_ENTRY_POINT__ ? window.__SSR_LOOM_ENTRY_POINT__ : {
        entryPointVariant: 'NONE'
    }
};
const $9633e2f0bea217d1$export$cbb01c57ec9c933e = {
    initLoomEntryPointVariant: (cloudId, userId)=>async ({ getState: getState, setState: setState })=>{
            const state = getState();
            if (state.loomEntryPointVariant.entryPointVariant !== 'NONE') return;
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_FLOW',
                    loading: true
                }
            });
            const loomTenantProvisionStatus = await $9633e2f0bea217d1$var$getLoomTenantProvisionStatus();
            if (loomTenantProvisionStatus === "not-provisioned") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW'
                    }
                });
                return;
            }
            if (loomTenantProvisionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_JOIN',
                    loading: true
                }
            });
            const loomUserPermissionStatus = await $9633e2f0bea217d1$export$85de6c803181afa9(cloudId, userId);
            if (loomUserPermissionStatus === "not-permitted") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN'
                    }
                });
                return;
            }
            if (loomUserPermissionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CO_USE'
                }
            });
        },
    // No preloader counterpart needed: setCrossJoinSuccess is a runtime-only action
    // triggered after a user completes the interactive cross-join flow (navigates to
    // Loom, gets provisioned, and returns). This cannot occur during SSR. The
    // window.__SSR_LOOM_ENTRY_POINT__ write updates the cached signal so that
    // useLoomEntryPointVariant sees CO_USE on subsequent client-side navigations
    // without re-running the permissions fetch — same pattern as crossFlowSuccessCheck.
    setCrossJoinSuccess: ()=>({ setState: setState })=>{
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CO_USE'
                }
            });
            window.__SSR_LOOM_ENTRY_POINT__ = {
                entryPointVariant: 'CO_USE'
            };
        },
    crossFlowSuccessCheck: ({ cloudId: cloudId, onCrossflowFailure: onCrossflowFailure, createAnalyticsEvent: createAnalyticsEvent, sourceComponent: sourceComponent })=>async ({ setState: setState })=>{
            // refetch license information since TCS doesn't update automatically
            try {
                const { ok: hasLoom, tries: tries } = await (0, $8999o.waitUntil)({
                    fn: ()=>(0, $lnyJf.fetchLicenseInformation)(cloudId),
                    condition: (info)=>info.products['loom']?.state === 'ACTIVE',
                    maxTries: 2,
                    // arbitrarily deciding on just 1 retry until we have more data to understand the eventual consistency here
                    retryWait: 500
                });
                (0, $gXfti.addUFOCustomData)({
                    pollingTries: tries,
                    hasLoom: hasLoom
                });
                if (hasLoom) {
                    // don't bother getLoomUserPermissionStatus here, we assume if the site has loom, the admin will have been given a license during provisioning
                    setState({
                        loomEntryPointVariant: {
                            entryPointVariant: 'CO_USE'
                        }
                    });
                    //This is needed for SSR to work correctly, since we skip logic in useLoomEntryPointVariant.ts if the entry point was SSR-ed
                    window.__SSR_LOOM_ENTRY_POINT__ = {
                        entryPointVariant: 'CO_USE'
                    };
                } else onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'success',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            hasLoom: hasLoom,
                            tries: tries,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            } catch (error) {
                onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'fail',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            error: error.message,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            }
        }
};
const $9633e2f0bea217d1$var$loomEntryPointVariantStore = (0, $8s9DV.createStore)({
    initialState: $9633e2f0bea217d1$var$initialState,
    actions: $9633e2f0bea217d1$export$cbb01c57ec9c933e,
    name: 'loomEntryPointVariantState'
});
const $9633e2f0bea217d1$export$9d93351985de2290 = (0, $kBr4q.createHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
const $9633e2f0bea217d1$export$fd0650c7a15c6ef2 = (0, $kBr4q.createActionsHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
module.exports["LoomTenantProvisionStatus"] = $9633e2f0bea217d1$export$ebe749be4eb13ac4;
module.exports["LoomUserPermissionStatus"] = $9633e2f0bea217d1$export$7909e54672d1c423;
module.exports["useLoomEntryPointVariantState"] = $9633e2f0bea217d1$export$9d93351985de2290;
module.exports["useLoomEntryPointVariantActions"] = $9633e2f0bea217d1$export$fd0650c7a15c6ef2;

});

parcelRegister("8999o", function(module, exports) {
const $887bf6ed89c38788$export$4e57ed416e50788e = async ({ fn: fn, condition: condition, retryWait: retryWait, maxTries: maxTries })=>{
    let tries = 0;
    while(true){
        tries++;
        const result = await fn();
        const ok = condition(result);
        if (tries === maxTries || ok) return {
            ok: ok,
            result: result,
            tries: tries
        };
        await new Promise((resolve)=>setTimeout(resolve, retryWait));
    }
};
module.exports["waitUntil"] = $887bf6ed89c38788$export$4e57ed416e50788e;

});

parcelRegister("lnyJf", function(module, exports) {

var $8J8QJ = parcelRequire("8J8QJ");

const $1f2e3e69723febb9$export$a573b79a27d213cc = (cloudId)=>(0, $8J8QJ.fetchJSON)(`/gateway/api/xflow/${cloudId}/license-information`);
module.exports["fetchLicenseInformation"] = $1f2e3e69723febb9$export$a573b79a27d213cc;

});

parcelRegister("8J8QJ", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $d6NtA = parcelRequire("d6NtA");

const $a326082f26863093$export$c776284ef4b1209a = (url, data)=>{
    const fetchOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
const $a326082f26863093$export$81bec6e38e8b706b = (url)=>{
    const fetchOptions = {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ...Boolean(undefined) && Boolean(undefined) && !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': 'identity-platform'
            } : {}
        }
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
module.exports["fetchJSON"] = $a326082f26863093$export$81bec6e38e8b706b;

});

parcelRegister("3uzFB", function(module, exports) {

var $keH2u = parcelRequire("keH2u");

const $9ee481529bbe8b4d$export$a4bb6b905bc500e2 = (0, $keH2u.default);
const $9ee481529bbe8b4d$export$8d50de945dbf45ca = (cloudId, userId)=>({
        principalId: `ari:cloud:identity::user/${userId}`,
        loomResourceId: `ari:cloud:loom::site/${cloudId}`
    });
const $9ee481529bbe8b4d$export$b048e9c33b8e482 = (data, variables)=>{
    const matchingRows = data?.bulkPermitted?.filter((row)=>row?.principalId === variables.principalId && row?.resourceId === variables.loomResourceId && row?.permissionId === 'write') ?? [];
    if (matchingRows.length < 1) return false;
    return matchingRows.every((row)=>row?.permitted === true);
};
module.exports["LoomUserPermissionQuery"] = $9ee481529bbe8b4d$export$a4bb6b905bc500e2;
module.exports["getLoomUserPermissionQueryVariables"] = $9ee481529bbe8b4d$export$8d50de945dbf45ca;
module.exports["hasExactLoomUserPermission"] = $9ee481529bbe8b4d$export$b048e9c33b8e482;

});

parcelRegister("keH2u", function(module, exports) {
/**
 * @generated SignedSource<<9936c66f475f5b5cae80af06b548f8cb>>
 * @relayHash 1246767ea7fb9149278e67c3ec09752c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b59faaba67fb092ef603e9f684b1d3e070c6185add127d90ea41320066a6b1e5
const $ebcff904befcd9cb$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "loomResourceId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "principalId"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "permissionIds",
                    "value": [
                        "write"
                    ]
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "principalIds.0",
                            "variableName": "principalId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "principalIds"
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "resourceIds.0",
                            "variableName": "loomResourceId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "resourceIds"
                }
            ],
            "concreteType": "BulkPermittedResponse",
            "kind": "LinkedField",
            "name": "bulkPermitted",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "principalId"
                },
                {
                    "kind": "ScalarField",
                    "name": "resourceId"
                },
                {
                    "kind": "ScalarField",
                    "name": "permissionId"
                },
                {
                    "kind": "ScalarField",
                    "name": "permitted"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "loomUserPermissionQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "loomUserPermissionQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "1246767ea7fb9149278e67c3ec09752c",
            "id": "b59faaba67fb092ef603e9f684b1d3e070c6185add127d90ea41320066a6b1e5",
            "metadata": {},
            "name": "loomUserPermissionQuery",
            "operationKind": "query",
            "text": "query loomUserPermissionQuery($principalId:String!,$loomResourceId:String!){bulkPermitted(principalIds:[$principalId],resourceIds:[$loomResourceId],permissionIds:[\"write\"]){principalId,resourceId,permissionId,permitted}}"
        }
    };
}();
$ebcff904befcd9cb$var$node.hash = "714c5537c580f754bda23bcf99534b30";
var $ebcff904befcd9cb$export$2e2bcd8739ae039 = $ebcff904befcd9cb$var$node;
module.exports["default"] = $ebcff904befcd9cb$export$2e2bcd8739ae039;

});

parcelRegister("2gAEP", function(module, exports) {
/**
 * @generated SignedSource<<7e1563bf12c221b07284eee871d1f539>>
 * @relayHash e7355c15b066e2e1bf0badd5083ad1e0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af
const $936b36fbe81f4fb7$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "e7355c15b066e2e1bf0badd5083ad1e0",
            "id": "828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af",
            "metadata": {},
            "name": "useLoomTenantProvisionStatusQuery",
            "operationKind": "query",
            "text": "query useLoomTenantProvisionStatusQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
        }
    };
}();
$936b36fbe81f4fb7$var$node.hash = "21c387cdafea215b61e4183319580a69";
var $936b36fbe81f4fb7$export$2e2bcd8739ae039 = $936b36fbe81f4fb7$var$node;
module.exports["default"] = $936b36fbe81f4fb7$export$2e2bcd8739ae039;

});

parcelRegister("dHiKK", function(module, exports) {
/**
 * @generated SignedSource<<6bffa4411017429251cce91466f25b2c>>
 * @relayHash f7bb335b70d26ad812bfb3643de03577
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f7ffa147cd1d4533462f1fb2c3c994f63b873577cc20f9e4875b94343191953c
const $dc96dcb71a986382$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeMeetingRecorderEligibility"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "siteId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceLoomEntryPoints",
            "kind": "LinkedField",
            "name": "confluence_loomEntryPoints",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isLoomEntryPointsEnabled"
                }
            ]
        },
        {
            "condition": "includeMeetingRecorderEligibility",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "LoomSettings",
                    "kind": "LinkedField",
                    "name": "loom_settings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "meetingRecordingsAvailable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "meetingNotesEligible"
                        }
                    ]
                },
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "LoomConnectedCalendar",
                    "kind": "LinkedField",
                    "name": "loom_connectedCalendars",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "guid"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f7bb335b70d26ad812bfb3643de03577",
            "id": "f7ffa147cd1d4533462f1fb2c3c994f63b873577cc20f9e4875b94343191953c",
            "metadata": {},
            "name": "useIsLoomEntryPointsEnabledQuery",
            "operationKind": "query",
            "text": "query useIsLoomEntryPointsEnabledQuery($cloudId:ID!,$includeMeetingRecorderEligibility:Boolean!){confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled},loom_settings(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){meetingRecordingsAvailable,meetingNotesEligible}\n  loom_connectedCalendars(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){guid}}"
        }
    };
}();
$dc96dcb71a986382$var$node.hash = "992c3639759f7aa3511f220e9547ecc6";
var $dc96dcb71a986382$export$2e2bcd8739ae039 = $dc96dcb71a986382$var$node;
module.exports["default"] = $dc96dcb71a986382$export$2e2bcd8739ae039;

});

parcelRegister("i8Ofl", function(module, exports) {
const $bde9a1914731baf3$var$PRODUCT = 'Confluence Cloud';
const $bde9a1914731baf3$var$buildWorkspaceId = (tenantId, activationId)=>{
    return `ari:cloud:confluence:${tenantId}:workspace/${activationId}`;
};
const $bde9a1914731baf3$export$14ef296862e3705e = (tenantId, activationId)=>{
    const atlAttributionHeader = {
        atlWorkspaceId: $bde9a1914731baf3$var$buildWorkspaceId(tenantId, activationId),
        tenantId: tenantId,
        product: $bde9a1914731baf3$var$PRODUCT,
        service: 'cc-fe-bifrost'
    };
    return {
        'atl-attribution': JSON.stringify(atlAttributionHeader)
    };
};
module.exports["createAtlAttributionHeader"] = $bde9a1914731baf3$export$14ef296862e3705e;

});

parcelRegister("c5JFM", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $c8d6014c9c636b97$export$7c5b1b3e3108671e = ()=>(0, $9wGTI.fg)('twcg-2202-loom-meeting-nudge-ht-gate') || (0, $9wGTI.fg)('twcg-2202-loom-meeting-nudge-lt-gate');
module.exports["isMeetingRecorderEligibilityEnabled"] = $c8d6014c9c636b97$export$7c5b1b3e3108671e;

});

parcelRegister("8wyJO", function(module, exports) {

var $ibGN4 = parcelRequire("ibGN4");


var $3V1KT = parcelRequire("3V1KT");

const $01eec1a417789222$export$17ab88ef0193bb4 = (data)=>{
    if (!data) return data;
    if ($01eec1a417789222$var$isConfluenceContentReactions(data)) return data?.confluence_contentReactionsSummary?.contentReactionsSummary?.[0];
    if ($01eec1a417789222$var$isContentReactions(data)) return data?.content?.nodes?.[0]?.contentReactionsSummary;
    if ($01eec1a417789222$var$isCommentReactions(data)) return data?.comments?.nodes?.[0]?.reactionsSummary;
};
const $01eec1a417789222$var$isConfluenceContentReactions = (data)=>Boolean(data.confluence_contentReactionsSummary);
const $01eec1a417789222$var$isContentReactions = (data)=>Boolean(data.content);
const $01eec1a417789222$var$isCommentReactions = (data)=>Boolean(data.comments);
const $01eec1a417789222$var$getReactionsContentQuery = ()=>{
    return 0, $3V1KT.ReactionsContentQuery;
};
const $01eec1a417789222$export$d765e1092b1f36ff = (isComment, contentId, containerId)=>{
    const query = isComment ? (0, $ibGN4.ReactionsCommentsQuery) : $01eec1a417789222$var$getReactionsContentQuery();
    const queryVariables = isComment ? {
        contentId: contentId,
        containerId: containerId
    } : {
        contentId: contentId
    };
    return {
        query: query,
        queryVariables: queryVariables
    };
};
module.exports["getReactionsSummary"] = $01eec1a417789222$export$17ab88ef0193bb4;
module.exports["getReactionsQueryInfo"] = $01eec1a417789222$export$d765e1092b1f36ff;

});

parcelRegister("ibGN4", function(module, exports) {

var $bcPqk = parcelRequire("bcPqk");


var $hMpSP = parcelRequire("hMpSP");

const $0c4d3fd1a40dc0de$export$ea32e9ef3caf8ce7 = (0, $hMpSP.default);
const $0c4d3fd1a40dc0de$export$c0002d0cc70e364a = (0, $bcPqk.default);
module.exports["ReactionsCommentsQuery"] = $0c4d3fd1a40dc0de$export$c0002d0cc70e364a;

});

parcelRegister("bcPqk", function(module, exports) {
/**
 * @generated SignedSource<<d1f71583f1da07d7d25964da546e340a>>
 * @relayHash cbefab13307a82cf7144a0c0749ceeba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 856749e0bcac9514035b3ed1c7488b61824433724d4eda1d05cbcff973b7dcce
const $6247a0815b189874$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "contentStatus",
                    "value": [
                        "DRAFT",
                        "CURRENT"
                    ]
                }
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "childType",
                                    "value": "comment"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "contentType",
                                    "value": "page"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "pageId",
                                    "variableName": "containerId"
                                }
                            ],
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "reactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "reactionsCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "containerAri"
                                },
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "emojiId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reacted"
                                        },
                                        v2 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ReactionsCommentsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ReactionsCommentsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "cbefab13307a82cf7144a0c0749ceeba",
            "id": "856749e0bcac9514035b3ed1c7488b61824433724d4eda1d05cbcff973b7dcce",
            "metadata": {},
            "name": "ReactionsCommentsQuery",
            "operationKind": "query",
            "text": "query ReactionsCommentsQuery($contentId:ID!,$containerId:ID!){comments(commentId:$contentId,contentStatus:[DRAFT,CURRENT]){nodes{id,reactionsSummary(pageId:$containerId,contentType:\"page\",childType:\"comment\"){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}}}"
        }
    };
}();
$6247a0815b189874$var$node.hash = "44a0a66242011ccb75c569988c203697";
var $6247a0815b189874$export$2e2bcd8739ae039 = $6247a0815b189874$var$node;
module.exports["default"] = $6247a0815b189874$export$2e2bcd8739ae039;

});

parcelRegister("hMpSP", function(module, exports) {
/**
 * @generated SignedSource<<eb7ea3f49a5750a597b7cccc9d474194>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $31e432aaf867a396$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "containerId"
            }
        ],
        "kind": "Fragment",
        "name": "ReactionsCommentsQuery_comment",
        "selections": [
            v0 /*: any*/ ,
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "childType",
                        "value": "comment"
                    },
                    {
                        "kind": "Literal",
                        "name": "contentType",
                        "value": "page"
                    },
                    {
                        "kind": "Variable",
                        "name": "pageId",
                        "variableName": "containerId"
                    }
                ],
                "concreteType": "ReactionsSummaryResponse",
                "kind": "LinkedField",
                "name": "reactionsSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "reactionsCount"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "ari"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "containerAri"
                    },
                    {
                        "concreteType": "ReactionsSummaryForEmoji",
                        "kind": "LinkedField",
                        "name": "reactionsSummaryForEmoji",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "emojiId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "count"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "reacted"
                            },
                            v0 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "Comment"
    };
}();
$31e432aaf867a396$var$node.hash = "af213ff403659043868c02fbd688a22c";
var $31e432aaf867a396$export$2e2bcd8739ae039 = $31e432aaf867a396$var$node;
module.exports["default"] = $31e432aaf867a396$export$2e2bcd8739ae039;

});

parcelRegister("9inwL", function(module, exports) {
/**
 * @generated SignedSource<<f8edd74a2bf0cef86303775c92f6818c>>
 * @relayHash f92419f4eae7659107884daf44afe353
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c5083034f862ac3ea960cfc4592f08715470b77981a4653cdbbd9dc1f12df8a1
const $5791e6e7c338c837$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "missingSpaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "missingSpaceKey",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "key",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentPrerequisitesQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentPrerequisitesQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f92419f4eae7659107884daf44afe353",
            "id": "c5083034f862ac3ea960cfc4592f08715470b77981a4653cdbbd9dc1f12df8a1",
            "metadata": {},
            "name": "ContentPrerequisitesQuery",
            "operationKind": "query",
            "text": "query ContentPrerequisitesQuery($contentId:ID!,$missingSpaceKey:Boolean=false,$spaceKey:String,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,space{id,key,alias}}},space(key:$spaceKey)@skip(if:$missingSpaceKey){id,name}}"
        }
    };
}();
$5791e6e7c338c837$var$node.hash = "96ae26a7fa99861b8e368c368e56f6cc";
var $5791e6e7c338c837$export$2e2bcd8739ae039 = $5791e6e7c338c837$var$node;
module.exports["default"] = $5791e6e7c338c837$export$2e2bcd8739ae039;

});

parcelRegister("4uNpa", function(module, exports) {
/**
 * @generated SignedSource<<d7fe2a7a66643bd9c72401c8da9b795f>>
 * @relayHash 81e3b75d8ec7e8341dfb9fe5d7c36fac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9df42f2f20f0917766b188fd5cf2b943f7c14748bf3e7fc1c3a1ae1f61a77911
const $2411ee21620b66c4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionOverride"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "versionOverride"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "homepageId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        },
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "createdDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentRedirectQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentRedirectQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "81e3b75d8ec7e8341dfb9fe5d7c36fac",
            "id": "9df42f2f20f0917766b188fd5cf2b943f7c14748bf3e7fc1c3a1ae1f61a77911",
            "metadata": {},
            "name": "ContentRedirectQuery",
            "operationKind": "query",
            "text": "query ContentRedirectQuery($contentId:ID,$versionOverride:Int){content(id:$contentId,version:$versionOverride){nodes{id,title,space{id,homepageId,key,alias},history{createdDate}}}}"
        }
    };
}();
$2411ee21620b66c4$var$node.hash = "440c7fc38cc16d750fa69bd87e3ba7c2";
var $2411ee21620b66c4$export$2e2bcd8739ae039 = $2411ee21620b66c4$var$node;
module.exports["default"] = $2411ee21620b66c4$export$2e2bcd8739ae039;

});

parcelRegister("98Fgg", function(module, exports) {
/**
 * @generated SignedSource<<9e3e16b02d7e839cb28fafbd9cc22027>>
 * @relayHash 1eef94f086d4818dc81396289138687a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 57138c5ec4f8edfbd221571e7278778f53d34a1487ac2bb480000f3f99715f09
const $314d226daa5f5ce2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isBlog"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = [
        {
            "condition": "isBlog",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Literal",
                            "name": "status",
                            "value": [
                                "CURRENT"
                            ]
                        }
                    ],
                    "concreteType": "PTPage",
                    "kind": "LinkedField",
                    "name": "ptpage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 1
                                }
                            ],
                            "concreteType": "PTPaginatedPageList",
                            "kind": "LinkedField",
                            "name": "nearestAncestors",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PTPageEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "PTPage",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "nearestAncestors(first:1)"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                v1 /*: any*/ 
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v4 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                v4 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadLegacyBridgeQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadLegacyBridgeQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "1eef94f086d4818dc81396289138687a",
            "id": "57138c5ec4f8edfbd221571e7278778f53d34a1487ac2bb480000f3f99715f09",
            "metadata": {},
            "name": "preloadLegacyBridgeQuery",
            "operationKind": "query",
            "text": "query preloadLegacyBridgeQuery($contentId:ID!,$isBlog:Boolean!){ptpage(id:$contentId,status:[CURRENT])@skip(if:$isBlog){id,nearestAncestors(first:1){edges{node{id,title}}}},content(id:$contentId){nodes{id,type,title,version{number},space{id,key,name,type},operations{operation,targetType}}}}"
        }
    };
}();
$314d226daa5f5ce2$var$node.hash = "6d396d281028b16cc64fd39e7d8cd3db";
var $314d226daa5f5ce2$export$2e2bcd8739ae039 = $314d226daa5f5ce2$var$node;
module.exports["default"] = $314d226daa5f5ce2$export$2e2bcd8739ae039;

});

parcelRegister("2rapj", function(module, exports) {
/**
 * @generated SignedSource<<ecf2ccf6da6891e95b8c24bfee1ef6f6>>
 * @relayHash c4c4095c882cb71b80fdf7c511e33e69
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e1d623029b3f50e0253d05074cea0ec94b1f823ad4c4b61177f50d160b5886b2
const $029fef3d04f7e0c0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cypherQuery"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "keyString"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "keyString"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": v2 /*: any*/ 
    }, v4 = {
        "args": [
            {
                "kind": "Variable",
                "name": "entityId",
                "variableName": "key"
            }
        ],
        "concreteType": "RecommendedPagesSpaceStatus",
        "kind": "LinkedField",
        "name": "getRecommendedPagesSpaceStatus",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "recommendedPagesEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "defaultBehavior"
            }
        ]
    }, v5 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "cypherQuery"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "key"
    }, v7 = {
        "kind": "ScalarField",
        "name": "pageId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "title"
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "ScalarField",
        "name": "subtype"
    }, v11 = {
        "alias": "pageStatus",
        "kind": "ScalarField",
        "name": "status"
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "webUi"
        }
    ], v13 = {
        "concreteType": "ConfluencePageLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v12 /*: any*/ 
    }, v14 = {
        "kind": "ScalarField",
        "name": "name"
    }, v15 = {
        "concreteType": "ConfluenceSpace",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v1 /*: any*/ ,
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            v14 /*: any*/ 
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v17 = {
        "concreteType": "ConfluenceUserInfo",
        "kind": "LinkedField",
        "name": "owner",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v14 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ]
    }, v18 = [
        {
            "kind": "Literal",
            "name": "keys",
            "value": [
                "emoji-title-published"
            ]
        }
    ], v19 = {
        "kind": "ScalarField",
        "name": "value"
    }, v20 = [
        v6 /*: any*/ ,
        v19 /*: any*/ 
    ], v21 = {
        "kind": "ScalarField",
        "name": "blogPostId"
    }, v22 = {
        "alias": "blogPostStatus",
        "kind": "ScalarField",
        "name": "status"
    }, v23 = {
        "concreteType": "ConfluenceBlogPostLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v12 /*: any*/ 
    }, v24 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v25 = {
        "concreteType": "ConfluenceUserInfo",
        "kind": "LinkedField",
        "name": "owner",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v24 /*: any*/ ,
                    v14 /*: any*/ ,
                    v16 /*: any*/ ,
                    v1 /*: any*/ 
                ]
            },
            v1 /*: any*/ 
        ]
    }, v26 = [
        v6 /*: any*/ ,
        v19 /*: any*/ ,
        v1 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EndOfPageRecommendationTwgQuery",
            "selections": [
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "GraphStoreCypherQueryV2Connection",
                    "kind": "LinkedField",
                    "name": "graphStore_cypherQueryV2",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphStoreCypherQueryV2Edge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreCypherQueryV2Node",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreCypherQueryV2Column",
                                            "kind": "LinkedField",
                                            "name": "columns",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "value",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                v10 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                v13 /*: any*/ ,
                                                                                v15 /*: any*/ ,
                                                                                v17 /*: any*/ ,
                                                                                {
                                                                                    "args": v18 /*: any*/ ,
                                                                                    "concreteType": "ConfluencePageProperty",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "properties",
                                                                                    "plural": true,
                                                                                    "selections": v20 /*: any*/ ,
                                                                                    "storageKey": "properties(keys:[\"emoji-title-published\"])"
                                                                                }
                                                                            ],
                                                                            "type": "ConfluencePage"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v21 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                v22 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v15 /*: any*/ ,
                                                                                v17 /*: any*/ ,
                                                                                {
                                                                                    "args": v18 /*: any*/ ,
                                                                                    "concreteType": "ConfluenceBlogPostProperty",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "properties",
                                                                                    "plural": true,
                                                                                    "selections": v20 /*: any*/ ,
                                                                                    "storageKey": "properties(keys:[\"emoji-title-published\"])"
                                                                                }
                                                                            ],
                                                                            "type": "ConfluenceBlogPost"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "GraphStoreCypherQueryV2AriNode"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EndOfPageRecommendationTwgQuery",
            "selections": [
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "GraphStoreCypherQueryV2Connection",
                    "kind": "LinkedField",
                    "name": "graphStore_cypherQueryV2",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphStoreCypherQueryV2Edge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreCypherQueryV2Node",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreCypherQueryV2Column",
                                            "kind": "LinkedField",
                                            "name": "columns",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "value",
                                                    "plural": false,
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v24 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                v10 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                v13 /*: any*/ ,
                                                                                v15 /*: any*/ ,
                                                                                v25 /*: any*/ ,
                                                                                {
                                                                                    "args": v18 /*: any*/ ,
                                                                                    "concreteType": "ConfluencePageProperty",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "properties",
                                                                                    "plural": true,
                                                                                    "selections": v26 /*: any*/ ,
                                                                                    "storageKey": "properties(keys:[\"emoji-title-published\"])"
                                                                                }
                                                                            ],
                                                                            "type": "ConfluencePage"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v21 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                v22 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v15 /*: any*/ ,
                                                                                v25 /*: any*/ ,
                                                                                {
                                                                                    "args": v18 /*: any*/ ,
                                                                                    "concreteType": "ConfluenceBlogPostProperty",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "properties",
                                                                                    "plural": true,
                                                                                    "selections": v26 /*: any*/ ,
                                                                                    "storageKey": "properties(keys:[\"emoji-title-published\"])"
                                                                                }
                                                                            ],
                                                                            "type": "ConfluenceBlogPost"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "Node",
                                                                            "abstractKey": "__isNode"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "AppUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "AtlassianAccountUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "CustomerUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsFeatureFlag"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsOperationsComponentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsOperationsIncidentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsOperationsPostIncidentReviewDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsProjectDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsRepository"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsSecurityVulnerabilityDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "JiraAutodevJob"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "JiraConfluenceRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "JiraCustomRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "JiraIssueRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "JiraWebRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "TeamCustomFieldValue"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "TeamType"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "ThirdPartyUser"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "GraphStoreCypherQueryV2AriNode"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "c4c4095c882cb71b80fdf7c511e33e69",
            "id": "e1d623029b3f50e0253d05074cea0ec94b1f823ad4c4b61177f50d160b5886b2",
            "metadata": {},
            "name": "EndOfPageRecommendationTwgQuery",
            "operationKind": "query",
            "text": "query EndOfPageRecommendationTwgQuery($cypherQuery:String!,$first:Int,$key:ID!,$keyString:String!){space(key:$keyString){id},getRecommendedPagesSpaceStatus(entityId:$key){recommendedPagesEnabled,defaultBehavior},graphStore_cypherQueryV2(query:$cypherQuery,first:$first)@optIn(to:\"GraphStoreCypherQueryV2\"){edges{node{columns{key,value{__typename,...on GraphStoreCypherQueryV2AriNode{id,data{__typename,...on ConfluencePage{pageId,title,type,subtype,pageStatus:status,links{webUi},space{id,key,alias,name},owner{user{__typename,name,accountId,id},id},properties(keys:[\"emoji-title-published\"]){key,value,id}},...on ConfluenceBlogPost{blogPostId,title,type,blogPostStatus:status,links{webUi},space{id,key,alias,name},owner{user{__typename,name,accountId,id},id},properties(keys:[\"emoji-title-published\"]){key,value,id}},...on Node{__isNode:__typename,id},...on AppUser{id},...on AtlassianAccountUser{id},...on CustomerUser{id},...on DevOpsFeatureFlag{id},...on DevOpsOperationsComponentDetails{id},...on DevOpsOperationsIncidentDetails{id},...on DevOpsOperationsPostIncidentReviewDetails{id},...on DevOpsProjectDetails{id},...on DevOpsPullRequestDetails{id},...on DevOpsRepository{id},...on DevOpsSecurityVulnerabilityDetails{id},...on JiraAutodevJob{id},...on JiraConfluenceRemoteIssueLink{id},...on JiraCustomRemoteIssueLink{id},...on JiraIssueRemoteIssueLink{id},...on JiraWebRemoteIssueLink{id},...on TeamCustomFieldValue{id},...on TeamType{id},...on ThirdPartyUser{id}}}}}}}}}"
        }
    };
}();
$029fef3d04f7e0c0$var$node.hash = "fde8f13a8c898c317f96538ff58fec17";
var $029fef3d04f7e0c0$export$2e2bcd8739ae039 = $029fef3d04f7e0c0$var$node;
module.exports["default"] = $029fef3d04f7e0c0$export$2e2bcd8739ae039;

});

parcelRegister("ky8L5", function(module, exports) {
// Shared query config + variable builders for the TWG recs query. Used by both the
// client hook and the SSR preloader so they issue byte-identical variables (needed
// for the client's cache-first read to hit the SSR-primed entry).
// TWG relationship for related Confluence content (spec: CA3).
const $5282e58fea25450f$var$TWG_RELATIONSHIP = 'confluence_content_has_related_confluence_content';
// Relationship from a content node to its authority-score node.
const $5282e58fea25450f$var$TWG_AUTHORITY_RELATIONSHIP = 'confluence_content_has_confluence_content_authority_score';
const $5282e58fea25450f$export$fe20e5d4b8358f61 = 12;
const $5282e58fea25450f$export$5bb8653eb6cf29f = (cloudId)=>`ari:cloud:platform::site/${cloudId}`;
const $5282e58fea25450f$export$46c71f7bb38c3d98 = (cloudId, contentId, contentType)=>`ari:cloud:confluence:${cloudId}:${contentType === 'blogpost' ? 'blogpost' : 'page'}/${contentId}`;
const $5282e58fea25450f$export$7135c395d1f4b359 = (pageAri)=>[
        `MATCH (page {ari: "${pageAri}"})-[:${$5282e58fea25450f$var$TWG_RELATIONSHIP}]->(entity)`,
        `OPTIONAL MATCH (entity)-[:${$5282e58fea25450f$var$TWG_AUTHORITY_RELATIONSHIP}]->(auth)`,
        `RETURN DISTINCT entity, auth`
    ].join('\n');
const $5282e58fea25450f$export$8d8ea6a33dea6f1f = (contentType)=>contentType === 'page' || contentType === 'blogpost';
module.exports["MAX_TWG_RECS"] = $5282e58fea25450f$export$fe20e5d4b8358f61;
module.exports["buildTwgQueryContext"] = $5282e58fea25450f$export$5bb8653eb6cf29f;
module.exports["buildTwgContentAri"] = $5282e58fea25450f$export$46c71f7bb38c3d98;
module.exports["buildTwgRecsCypher"] = $5282e58fea25450f$export$7135c395d1f4b359;
module.exports["isTwgSupportedContentType"] = $5282e58fea25450f$export$8d8ea6a33dea6f1f;

});

parcelRegister("eq95w", function(module, exports) {
/**
 * @generated SignedSource<<663f21e6dfcd4d4c24754e54b45772e8>>
 * @relayHash 8b133e3996bec5b3feff733a500f3451
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1205b4c053e3bf1a11112543759ae8178f8f0e4161f42e7f549b3c8cdcd56847
const $9206d19da4400201$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "location"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locations"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "location",
                    "variableName": "location"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "locations"
                }
            ],
            "concreteType": "WebPanel",
            "kind": "LinkedField",
            "name": "webPanels",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "moduleKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "completeKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "html"
                },
                {
                    "kind": "ScalarField",
                    "name": "location"
                },
                {
                    "kind": "ScalarField",
                    "name": "label"
                },
                {
                    "kind": "ScalarField",
                    "name": "weight"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WebPanelLocationQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WebPanelLocationQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "8b133e3996bec5b3feff733a500f3451",
            "id": "1205b4c053e3bf1a11112543759ae8178f8f0e4161f42e7f549b3c8cdcd56847",
            "metadata": {},
            "name": "WebPanelLocationQuery",
            "operationKind": "query",
            "text": "query WebPanelLocationQuery($location:String,$locations:[String],$contentId:ID,$spaceKey:String){webPanels(location:$location,locations:$locations,contentId:$contentId,key:$spaceKey){moduleKey,completeKey,html,location,label,weight,name}}"
        }
    };
}();
$9206d19da4400201$var$node.hash = "c9e0e68be80f814df706b6c0d828dae1";
var $9206d19da4400201$export$2e2bcd8739ae039 = $9206d19da4400201$var$node;
module.exports["default"] = $9206d19da4400201$export$2e2bcd8739ae039;

});

parcelRegister("8G3G6", function(module, exports) {
/**
 * @generated SignedSource<<e1177a1d3670ae73598e531cc663b738>>
 * @relayHash 4454a52ea4ab532f76ee4e80586f3a56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b93f6dc06e9898ae5a96da49582122e7834ced458f11ee2b79ed14f9d9b3a87
const $3a0ab9c788e793cd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentType"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "CatchupLastViewedTimeResponse",
            "kind": "LinkedField",
            "name": "catchupGetLastViewedTime",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "lastViewedTimeISO"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4454a52ea4ab532f76ee4e80586f3a56",
            "id": "1b93f6dc06e9898ae5a96da49582122e7834ced458f11ee2b79ed14f9d9b3a87",
            "metadata": {},
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "operationKind": "query",
            "text": "query useDynamicSplitButtonCatchupLastViewedTimeQuery($contentId:ID!,$contentType:CatchupContentType!){catchupGetLastViewedTime(contentId:$contentId,contentType:$contentType){lastViewedTimeISO}}"
        }
    };
}();
$3a0ab9c788e793cd$var$node.hash = "ca230a2a5e683b85178d392f9c872c98";
var $3a0ab9c788e793cd$export$2e2bcd8739ae039 = $3a0ab9c788e793cd$var$node;
module.exports["default"] = $3a0ab9c788e793cd$export$2e2bcd8739ae039;

});

parcelRegister("38Ncj", function(module, exports) {
/**
 * @generated SignedSource<<97620748d8d680bcf5801bcd64a5c19f>>
 * @relayHash 21cebd3db50676fd19d57554f2f4d6fc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fcc453c87e447898e23b0fd063f4631ca349fe93580bd0dea45de46209594904
const $630a58f9ca4672ab$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isContentTypePublicLinkEligible"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasInheritedRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasViewRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        },
        {
            "condition": "isContentTypePublicLinkEligible",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "contentId"
                        }
                    ],
                    "concreteType": "PublicLinkPage",
                    "kind": "LinkedField",
                    "name": "publicLinkPage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "pageId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "pageStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "accessType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useShareAndRestrictButtonDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useShareAndRestrictButtonDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "21cebd3db50676fd19d57554f2f4d6fc",
            "id": "fcc453c87e447898e23b0fd063f4631ca349fe93580bd0dea45de46209594904",
            "metadata": {},
            "name": "useShareAndRestrictButtonDataQuery",
            "operationKind": "query",
            "text": "query useShareAndRestrictButtonDataQuery($contentId:ID!,$isContentTypePublicLinkEligible:Boolean!){singleContent(id:$contentId){id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title},publicLinkPage(pageId:$contentId)@include(if:$isContentTypePublicLinkEligible){pageId,pageStatus,accessType}}"
        }
    };
}();
$630a58f9ca4672ab$var$node.hash = "336fe7f51ff27baeb231379611028a5d";
var $630a58f9ca4672ab$export$2e2bcd8739ae039 = $630a58f9ca4672ab$var$node;
module.exports["default"] = $630a58f9ca4672ab$export$2e2bcd8739ae039;

});

parcelRegister("1ydBT", function(module, exports) {
/**
 * @generated SignedSource<<8bf3e558a6ab7f9cbe727ebec14e7660>>
 * @relayHash 6268a05e132ec3982e53079d2aba0f1b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ce1d7cffa61983594faed4d537e36e9aeef26539ed557ceaf1f6c2812ed8f78f
const $4edc52e24113851d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "focusedCommentId"
    }, v3 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "includeCommentReactions"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeCommentThreads"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeConversationData"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeFocusedComment"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v8 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v9 = [
        {
            "kind": "Literal",
            "name": "confluenceCommentFilter",
            "value": {
                "commentState": "UNRESOLVED",
                "commentType": "FOOTER"
            }
        },
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ROOT"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v8 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "type",
            "value": [
                "FOOTER"
            ]
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v14 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "type"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v17 = {
        "kind": "LinkedField",
        "name": "contributors",
        "plural": true,
        "selections": [
            v11 /*: any*/ ,
            v12 /*: any*/ ,
            v14 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "value"
    }, v19 = [
        v18 /*: any*/ 
    ], v20 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v19 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v21 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v22 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v19 /*: any*/ 
    }, v23 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v24 = {
        "kind": "ScalarField",
        "name": "editui"
    }, v25 = {
        "kind": "ScalarField",
        "name": "webui"
    }, v26 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            v24 /*: any*/ ,
            v25 /*: any*/ 
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v28 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v29 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v30 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v31 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            v15 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v27 /*: any*/ ,
                            v28 /*: any*/ ,
                            v29 /*: any*/ ,
                            v30 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v27 /*: any*/ ,
                            v28 /*: any*/ ,
                            v29 /*: any*/ ,
                            v30 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v32 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v33 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v34 = {
        "condition": "includeCommentReactions",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "childType",
                        "value": "comment"
                    },
                    {
                        "kind": "Literal",
                        "name": "contentType",
                        "value": "page"
                    },
                    v8 /*: any*/ 
                ],
                "concreteType": "ReactionsSummaryResponse",
                "kind": "LinkedField",
                "name": "reactionsSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "ari"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "containerAri"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reactionsCount"
                    },
                    {
                        "concreteType": "ReactionsSummaryForEmoji",
                        "kind": "LinkedField",
                        "name": "reactionsSummaryForEmoji",
                        "plural": true,
                        "selections": [
                            v10 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "count"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "emojiId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "reacted"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v35 = {
        "kind": "LinkedField",
        "name": "by",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            v12 /*: any*/ 
        ]
    }, v36 = {
        "kind": "ScalarField",
        "name": "number"
    }, v37 = {
        "kind": "ScalarField",
        "name": "when"
    }, v38 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
            v10 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    v11 /*: any*/ ,
                    v12 /*: any*/ ,
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            },
            v17 /*: any*/ ,
            v20 /*: any*/ ,
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "container",
                "plural": false,
                "selections": [
                    v10 /*: any*/ 
                ]
            },
            v21 /*: any*/ ,
            v22 /*: any*/ ,
            v23 /*: any*/ ,
            v26 /*: any*/ ,
            v31 /*: any*/ ,
            v32 /*: any*/ ,
            v33 /*: any*/ ,
            {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "replies",
                "plural": true,
                "selections": [
                    v10 /*: any*/ ,
                    {
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                            v11 /*: any*/ ,
                            v12 /*: any*/ ,
                            v13 /*: any*/ ,
                            v16 /*: any*/ ,
                            v14 /*: any*/ 
                        ]
                    },
                    v20 /*: any*/ ,
                    v21 /*: any*/ ,
                    v22 /*: any*/ ,
                    v23 /*: any*/ ,
                    v26 /*: any*/ ,
                    v31 /*: any*/ ,
                    v32 /*: any*/ ,
                    v33 /*: any*/ ,
                    v34 /*: any*/ ,
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            v35 /*: any*/ ,
                            v36 /*: any*/ ,
                            v37 /*: any*/ 
                        ]
                    },
                    v17 /*: any*/ 
                ]
            },
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": [
                            v11 /*: any*/ ,
                            v15 /*: any*/ ,
                            v12 /*: any*/ ,
                            v16 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "friendlyWhen"
                    },
                    v36 /*: any*/ ,
                    v37 /*: any*/ 
                ]
            },
            v34 /*: any*/ 
        ]
    }, v39 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v40 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "pageId"
    }, v41 = [
        v40 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "current",
                "archived",
                "draft"
            ]
        }
    ], v42 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "focusedCommentId"
        },
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ALL"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "UNRESOLVED"
        }
    ], v43 = [
        {
            "kind": "Literal",
            "name": "current",
            "value": true
        }
    ], v44 = {
        "kind": "ScalarField",
        "name": "isPrimary"
    }, v45 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v46 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v10 /*: any*/ ,
            v45 /*: any*/ 
        ]
    }, v47 = {
        "kind": "ScalarField",
        "name": "isInlineComment"
    }, v48 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            v35 /*: any*/ ,
            v37 /*: any*/ ,
            v36 /*: any*/ 
        ]
    }, v49 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            v24 /*: any*/ 
        ]
    }, v50 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            v12 /*: any*/ ,
            v14 /*: any*/ ,
            v13 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v51 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replies",
        "plural": true,
        "selections": [
            v10 /*: any*/ ,
            v20 /*: any*/ ,
            v22 /*: any*/ ,
            v23 /*: any*/ ,
            v47 /*: any*/ ,
            v33 /*: any*/ ,
            v48 /*: any*/ ,
            v49 /*: any*/ ,
            v50 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "selections": [
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v38 /*: any*/ ,
                        v39 /*: any*/ ,
                        v11 /*: any*/ ,
                        {
                            "condition": "includeCommentThreads",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ViewPageConversation_commentThreads"
                                            }
                                        ],
                                        "type": "PaginatedCommentList"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "conversationCommentThreads"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeConversationData",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "ViewPageConversation_currentUser"
                                    }
                                ],
                                "type": "Query"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "conversationCurrentUser"
                        },
                        {
                            "args": v41 /*: any*/ ,
                            "concreteType": "PaginatedContentListWithChild",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ViewPageConversation_contentPermission"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeFocusedComment",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "focusedInlineComment",
                            "args": v42 /*: any*/ ,
                            "concreteType": "PaginatedCommentList",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ViewPageConversation_focusedInlineComment"
                                }
                            ]
                        },
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "ViewPageConversation_focusedInlineCommentContext"
                                    }
                                ],
                                "type": "Query"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "focusedInlineCommentContext"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v7 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "selections": [
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v38 /*: any*/ ,
                        v39 /*: any*/ ,
                        v11 /*: any*/ 
                    ]
                },
                {
                    "condition": "includeConversationData",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "user",
                            "args": v43 /*: any*/ ,
                            "concreteType": "AtlassianUser",
                            "kind": "LinkedField",
                            "name": "confluence_atlassianUser",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                v12 /*: any*/ ,
                                {
                                    "concreteType": "AtlassianUserPhoto",
                                    "kind": "LinkedField",
                                    "name": "photos",
                                    "plural": true,
                                    "selections": [
                                        v44 /*: any*/ ,
                                        v18 /*: any*/ 
                                    ]
                                }
                            ],
                            "storageKey": "confluence_atlassianUser(current:true)"
                        },
                        {
                            "args": v41 /*: any*/ ,
                            "concreteType": "PaginatedContentListWithChild",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v45 /*: any*/ ,
                                        v46 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v16 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeFocusedComment",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "focusedInlineComment",
                            "args": v42 /*: any*/ ,
                            "concreteType": "PaginatedCommentList",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "Comment",
                                            "kind": "LinkedField",
                                            "name": "ancestors",
                                            "plural": true,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                v47 /*: any*/ ,
                                                v33 /*: any*/ ,
                                                v48 /*: any*/ ,
                                                v49 /*: any*/ ,
                                                v50 /*: any*/ ,
                                                v51 /*: any*/ 
                                            ]
                                        },
                                        v10 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ ,
                                        v47 /*: any*/ ,
                                        v33 /*: any*/ ,
                                        v48 /*: any*/ ,
                                        v49 /*: any*/ ,
                                        v50 /*: any*/ ,
                                        v51 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "focusedContent",
                            "args": [
                                v40 /*: any*/ 
                            ],
                            "concreteType": "PaginatedContentListWithChild",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v46 /*: any*/ ,
                                        v45 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "user",
                            "args": v43 /*: any*/ ,
                            "concreteType": "AtlassianUser",
                            "kind": "LinkedField",
                            "name": "confluence_atlassianUser",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                v12 /*: any*/ ,
                                {
                                    "concreteType": "AtlassianUserPhoto",
                                    "kind": "LinkedField",
                                    "name": "photos",
                                    "plural": true,
                                    "selections": [
                                        v18 /*: any*/ ,
                                        v44 /*: any*/ 
                                    ]
                                }
                            ],
                            "storageKey": "confluence_atlassianUser(current:true)"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "6268a05e132ec3982e53079d2aba0f1b",
            "id": "ce1d7cffa61983594faed4d537e36e9aeef26539ed557ceaf1f6c2812ed8f78f",
            "metadata": {},
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "operationKind": "query",
            "text": "query ObjectCommentContainerPreloadObjectCommentsQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$first:Long,$includeCommentReactions:Boolean=true,$includeConversationData:Boolean=false,$includeCommentThreads:Boolean=false,$focusedCommentId:ID,$includeFocusedComment:Boolean=false){...ViewPageConversation_currentUser@include(if:$includeConversationData)\n  content(id:$pageId,status:[\"current\",\"archived\",\"draft\"])@include(if:$includeConversationData){nodes{...ViewPageConversation_contentPermission,id}},comments(pageId:$pageId,contentStatus:$contentStatus,depth:ROOT,first:$first,type:[FOOTER],confluenceCommentFilter:{commentState:UNRESOLVED,commentType:FOOTER}){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeCommentReactions){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeCommentReactions){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}},totalCount,__typename,...ViewPageConversation_commentThreads@include(if:$includeCommentThreads)},focusedInlineComment:comments(commentId:$focusedCommentId,depth:ALL,type:UNRESOLVED)@include(if:$includeFocusedComment){...ViewPageConversation_focusedInlineComment}\n  ...ViewPageConversation_focusedInlineCommentContext@include(if:$includeFocusedComment)}fragment ViewPageConversation_commentThreads on PaginatedCommentList{nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeCommentReactions){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeCommentReactions){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}},totalCount,__typename}fragment ViewPageConversation_contentPermission on Content{id,type,operations{operation,targetType},space{id,operations{operation,targetType}},history{createdBy{__typename,...on KnownUser{accountId}}}}fragment ViewPageConversation_currentUser on Query{user:confluence_atlassianUser(current:true){id,displayName,photos{isPrimary,value}}}fragment ViewPageConversation_focusedInlineComment on PaginatedCommentList{nodes{ancestors{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}},id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}}}fragment ViewPageConversation_focusedInlineCommentContext on Query{focusedContent:content(id:$pageId){nodes{id,type,space{id,operations{operation,targetType}},operations{operation,targetType}}},user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary}}}"
        }
    };
}();
$4edc52e24113851d$var$node.hash = "2cfe5fc37f71ef70f39b17155896292b";
var $4edc52e24113851d$export$2e2bcd8739ae039 = $4edc52e24113851d$var$node;
module.exports["default"] = $4edc52e24113851d$export$2e2bcd8739ae039;

});

parcelRegister("MJaSd", function(module, exports) {

var $kgNLQ = parcelRequire("kgNLQ");

const $eeebfa790a4a25a5$export$533048ab2aed5b1a = -1;
// Default empty preload data structure (can be spread and isDataProcessed overridden)
const $eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA = {
    allComments: [],
    allFilteredComments: [],
    openInlineComments: [],
    openFooterComments: [],
    resolvedComments: [],
    openComments: [],
    commentsDataMap: {
        inline: {},
        general: {}
    },
    flatCommentsMap: {},
    hasNestedComments: false,
    commentCount: null,
    hasAnyComments: false,
    isDataProcessed: false
};
const $eeebfa790a4a25a5$export$7cc295d5a932445b = (processedPreloadData, preloadCacheData)=>{
    if (!processedPreloadData.isDataProcessed || !preloadCacheData?.comments) return false;
    const totalCount = preloadCacheData.comments.totalCount;
    // If totalCount is the loading flag, we're still loading
    if (totalCount === $eeebfa790a4a25a5$export$533048ab2aed5b1a) return false;
    // Calculate loaded comment count (parent comments + replies)
    const loadedCommentCount = preloadCacheData.comments.nodes?.reduce((acc, comment)=>{
        if (!comment) return acc;
        return acc + (comment?.replies?.length || 0) + 1; // parent + reply count
    }, 0) ?? 0;
    // Check if we've loaded all available comments
    return loadedCommentCount === totalCount;
};
const $eeebfa790a4a25a5$export$e229b0e2973dcb38 = (processedCommentsData, preloadCacheData, contentStatus)=>{
    // Check cache value to determine if we're in a loading state (totalCount === -1)
    const isPreloadLoadingFromCache = preloadCacheData?.comments?.totalCount === $eeebfa790a4a25a5$export$533048ab2aed5b1a;
    // Process preload data
    // Don't process if we're loading (check cache value, not loading state)
    let processedPreloadData;
    if (isPreloadLoadingFromCache) processedPreloadData = {
        ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
        isDataProcessed: false
    };
    else if (preloadCacheData?.comments) {
        if (preloadCacheData.comments.nodes) {
            // This preloader explicitly opts in to reactions above, so its nodes satisfy the legacy
            // Comment model even though Relay correctly makes conditionally selected fields optional.
            const allComments = (preloadCacheData.comments.nodes || []).filter((node)=>node !== null);
            // Filter preload comments by the contentStatus prop (same as CommentsDataBackgroundLoader does)
            // This ensures we only show comments that match the current page's content status
            const categorized = (0, $kgNLQ.categorizeComments)(allComments, contentStatus);
            processedPreloadData = {
                allComments: allComments,
                ...categorized,
                isDataProcessed: true
            };
        } else processedPreloadData = {
            ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
            isDataProcessed: true
        };
    } else processedPreloadData = {
        ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
        isDataProcessed: false
    };
    // Determine which data source to use
    // If ProcessedCommentsDataStore has processed data, use that
    // Otherwise, use the preload query data
    const hasFullData = processedCommentsData.isDataProcessed;
    // Calculate if all data has been preloaded
    const allDataPreloaded = $eeebfa790a4a25a5$export$7cc295d5a932445b(processedPreloadData, preloadCacheData);
    // Dynamically determine the data to return based on current state
    // isDataProcessed always comes from ProcessedCommentsDataStore
    // Only the comment data itself comes from preload when full data isn't available
    const finalData = hasFullData ? processedCommentsData : {
        ...processedCommentsData,
        // Override comment data with preload data, but keep isDataProcessed from store
        ...processedPreloadData,
        isDataProcessed: processedCommentsData.isDataProcessed,
        error: processedCommentsData.error
    };
    return {
        ...finalData,
        // Keep separate vars for preload loading status so we don't have to assert isPreloading && ... everywhere
        isPreloadLoading: isPreloadLoadingFromCache,
        isPreloadDataProcessed: processedPreloadData.isDataProcessed,
        // Indicate whether preload completed with comments (for SSR placeholder display)
        preloadCompletedWithComments: processedPreloadData.isDataProcessed && processedPreloadData.allFilteredComments.length > 0,
        allDataPreloaded: // Indicate whether the preload contained ALL comments
        allDataPreloaded,
        // Indicate whether we're currently using full data or preload data
        isUsingFullData: hasFullData
    };
};
module.exports["PRELOAD_LOADING_FLAG"] = $eeebfa790a4a25a5$export$533048ab2aed5b1a;
module.exports["getPreloadAwareObjectComments"] = $eeebfa790a4a25a5$export$e229b0e2973dcb38;

});

parcelRegister("cQbnm", function(module, exports) {
const $a2901bd3596bb581$export$c6ff0a0df62acf44 = 3;
const $a2901bd3596bb581$export$fa19d42490144c8 = (contentId, includeConversationData = false, includeCommentThreads = false, focusedCommentId, includeFocusedComment = false)=>({
        pageId: contentId,
        contentStatus: [
            'DRAFT',
            'CURRENT',
            'ARCHIVED'
        ],
        first: $a2901bd3596bb581$export$c6ff0a0df62acf44,
        includeCommentReactions: true,
        includeConversationData: includeConversationData,
        includeCommentThreads: includeCommentThreads,
        focusedCommentId: focusedCommentId ?? null,
        includeFocusedComment: includeFocusedComment
    });
module.exports["buildPreloadObjectCommentsQueryVariables"] = $a2901bd3596bb581$export$fa19d42490144c8;

});

parcelRegister("lj2R9", function(module, exports) {
/**
 * @generated SignedSource<<1e72b221db30c6dd58d4a18a3c908cd9>>
 * @relayHash 667db9b1207176451cb2198029bc1794
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 263c5187fe4d45dd66f4564bd6f052b5aa2b86c867264433913ce3020f843c0c
const $0d0305ae4f6822bb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "externalCollaboratorCount"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ViewSpaceExternalCollaboratorsDialogQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ViewSpaceExternalCollaboratorsDialogQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "667db9b1207176451cb2198029bc1794",
            "id": "263c5187fe4d45dd66f4564bd6f052b5aa2b86c867264433913ce3020f843c0c",
            "metadata": {},
            "name": "ViewSpaceExternalCollaboratorsDialogQuery",
            "operationKind": "query",
            "text": "query ViewSpaceExternalCollaboratorsDialogQuery($spaceKey:String){space(key:$spaceKey){id,name,externalCollaboratorCount,currentUser{isAdmin}}}"
        }
    };
}();
$0d0305ae4f6822bb$var$node.hash = "722ca76340bcbe86e394e6f8663add12";
var $0d0305ae4f6822bb$export$2e2bcd8739ae039 = $0d0305ae4f6822bb$var$node;
module.exports["default"] = $0d0305ae4f6822bb$export$2e2bcd8739ae039;

});

parcelRegister("BrMrN", function(module, exports) {
/**
 * @generated SignedSource<<6f8fac148313e50a2a47839f6fce409e>>
 * @relayHash fd1963a9d2faefb7e31ad7e80c7ff686
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8fb85cfc50d17c92cb1806272faa77a6beba4ed8917f6a91ae784e3059fca725
const $e8059ce1e4b75624$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipLicenseQuery"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipSpaceQuery"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = [
        {
            "condition": "skipSpaceQuery",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "key",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "SpaceUserMetadata",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isAnonymouslyAuthorized"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "skipLicenseQuery",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "concreteType": "License",
                    "kind": "LinkedField",
                    "name": "license",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseConsumingUserCount"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "trialEndDate"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PersistentInviteEligibleQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PersistentInviteEligibleQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "fd1963a9d2faefb7e31ad7e80c7ff686",
            "id": "8fb85cfc50d17c92cb1806272faa77a6beba4ed8917f6a91ae784e3059fca725",
            "metadata": {},
            "name": "PersistentInviteEligibleQuery",
            "operationKind": "query",
            "text": "query PersistentInviteEligibleQuery($spaceKey:String,$skipLicenseQuery:Boolean!,$skipSpaceQuery:Boolean!){space(key:$spaceKey)@skip(if:$skipSpaceQuery){id,currentUser{isAnonymouslyAuthorized}},license@skip(if:$skipLicenseQuery){licenseConsumingUserCount,trialEndDate}}"
        }
    };
}();
$e8059ce1e4b75624$var$node.hash = "364b36bbc5d65271345dded2654a0688";
var $e8059ce1e4b75624$export$2e2bcd8739ae039 = $e8059ce1e4b75624$var$node;
module.exports["default"] = $e8059ce1e4b75624$export$2e2bcd8739ae039;

});

parcelRegister("eKTWO", function(module, exports) {

var $hU1C8 = parcelRequire("hU1C8");


var $jwbRi = parcelRequire("jwbRi");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $6mKj3 = parcelRequire("6mKj3");


var $hBkCm = parcelRequire("hBkCm");

var $f7B1p = parcelRequire("f7B1p");


var $jMyy4 = parcelRequire("jMyy4");

const $862814430f69e6aa$export$47d4842719bdb071 = (0, $jwbRi.default);
const $862814430f69e6aa$export$aad7e27ed56b51fc = (0, $hU1C8.default);
const $862814430f69e6aa$export$ba9e49b520a30a69 = ({ spaceKey: spaceKey, cloudId: cloudId })=>$862814430f69e6aa$var$useFetchSuggestionCountInternal({
        spaceKey: spaceKey,
        cloudId: cloudId
    }, (0, $6mKj3.expVal)('confluence_autonomous_space_curation_ssr_streaming', 'isEnabled', false));
const $862814430f69e6aa$export$d39f13847aa08df3 = ({ spaceKey: spaceKey, cloudId: cloudId, suggestionCountFragmentRef: suggestionCountFragmentRef })=>{
    const fragmentData = (0, $6SsN4.useFragment)($862814430f69e6aa$export$47d4842719bdb071, suggestionCountFragmentRef);
    return $862814430f69e6aa$var$useFetchSuggestionCountInternal({
        spaceKey: spaceKey,
        cloudId: cloudId
    }, (0, $6mKj3.expVal)('confluence_autonomous_space_curation_ssr_streaming', 'isEnabled', false), fragmentData);
};
const $862814430f69e6aa$var$useFetchSuggestionCountInternal = ({ spaceKey: spaceKey, cloudId: cloudId }, isStreamingEnabled, fragmentData)=>{
    const usesRouteData = fragmentData !== undefined;
    // Apollo path — runs when experiment is on. useQueryInterop must be called
    // unconditionally; the skip option prevents network activity when unused.
    const { data: apolloData, loading: apolloLoading, refetch: apolloRefetch } = (0, $jMyy4.useQueryInterop)($862814430f69e6aa$export$aad7e27ed56b51fc, {
        variables: {
            cloudId: cloudId,
            spaceKey: spaceKey ?? ''
        },
        skip: !isStreamingEnabled || !spaceKey || usesRouteData,
        interopApolloAggClient: true,
        __callerPackage__: "space-curation"
    });
    const apolloResult = (0, $cozmU.useMemo)(()=>{
        if (!isStreamingEnabled) return null;
        const hasChildQueryData = apolloData != null;
        const raw = hasChildQueryData ? apolloData.confluence_remoteObjectSuggestionCount : fragmentData?.confluence_remoteObjectSuggestionCount;
        const isLoading = usesRouteData && !hasChildQueryData ? false : apolloLoading;
        // null data is the suppression signal — this includes the case where the
        // backend returns errors alongside null data (e.g. NotFoundException when
        // the user has been permanently suppressed). Do not gate on apolloError.
        const apolloIsSuppressed = !isLoading && raw == null;
        return {
            count: raw ?? 0,
            isLoading: isLoading,
            isSuppressed: apolloIsSuppressed,
            refetch: ()=>{
                apolloRefetch();
            }
        };
    }, [
        apolloData,
        apolloLoading,
        apolloRefetch,
        fragmentData,
        isStreamingEnabled,
        usesRouteData
    ]);
    // cfetch path — used when experiment is off
    const [count, setCount] = (0, $cozmU.useState)(0);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const [isSuppressed, setIsSuppressed] = (0, $cozmU.useState)(false);
    const fetchCount = (0, $cozmU.useCallback)(async ()=>{
        if (isStreamingEnabled) return;
        if (!spaceKey) {
            setCount(0);
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        try {
            const response = await (0, $f7B1p.cfetch)(`/wiki/rest/internal/1.0/spaces/${spaceKey}/remote-objects/suggestions/count`, {
                method: 'GET'
            });
            const text = await response.text();
            const parsed = parseInt(text, 10);
            if (isNaN(parsed)) setIsSuppressed(true);
            else {
                setCount(parsed);
                setIsSuppressed(false);
            }
        } catch (error) {
            if ((0, $hBkCm.BadStatusError).isBadStatusError(error) && error.response.status === 404) setIsSuppressed(true);
        // silently fail on other errors
        } finally{
            setIsLoading(false);
        }
    }, [
        isStreamingEnabled,
        spaceKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        fetchCount();
    }, [
        fetchCount
    ]);
    if (isStreamingEnabled) return apolloResult ?? {
        count: count,
        isLoading: isLoading,
        isSuppressed: isSuppressed,
        refetch: fetchCount
    };
    return {
        count: count,
        isLoading: isLoading,
        isSuppressed: isSuppressed,
        refetch: fetchCount
    };
};
module.exports["RemoteObjectSuggestionCountQuery"] = $862814430f69e6aa$export$aad7e27ed56b51fc;
module.exports["useFetchSuggestionCount"] = $862814430f69e6aa$export$ba9e49b520a30a69;
module.exports["useFetchSuggestionCountFromFragment"] = $862814430f69e6aa$export$d39f13847aa08df3;

});

parcelRegister("hU1C8", function(module, exports) {
/**
 * @generated SignedSource<<7ed3a2785ef14914cca4babcea9ce45a>>
 * @relayHash 2928057d03b4f5d5a1a268a9759b926b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2a667fff01500eb3e9307529089fae38f8ffbfdb7afefb552f82585ed918492
const $41493c5c0e5e4e0b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_remoteObjectSuggestionCount"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFetchSuggestionCountQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFetchSuggestionCountQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2928057d03b4f5d5a1a268a9759b926b",
            "id": "e2a667fff01500eb3e9307529089fae38f8ffbfdb7afefb552f82585ed918492",
            "metadata": {},
            "name": "useFetchSuggestionCountQuery",
            "operationKind": "query",
            "text": "query useFetchSuggestionCountQuery($cloudId:ID!,$spaceKey:String!){confluence_remoteObjectSuggestionCount(cloudId:$cloudId,spaceKey:$spaceKey)}"
        }
    };
}();
$41493c5c0e5e4e0b$var$node.hash = "050919681608acb31690dce800b52bae";
var $41493c5c0e5e4e0b$export$2e2bcd8739ae039 = $41493c5c0e5e4e0b$var$node;
module.exports["default"] = $41493c5c0e5e4e0b$export$2e2bcd8739ae039;

});

parcelRegister("jwbRi", function(module, exports) {
/**
 * @generated SignedSource<<38626ff8705a6c0de9b2d1e6d56973af>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b18ce3bc11082c03$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "spaceKey"
        }
    ],
    "kind": "Fragment",
    "name": "useFetchSuggestionCount_query",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_remoteObjectSuggestionCount"
        }
    ],
    "type": "Query"
};
$b18ce3bc11082c03$var$node.hash = "b4d0196e6c2004ac771cb71891cd74af";
var $b18ce3bc11082c03$export$2e2bcd8739ae039 = $b18ce3bc11082c03$var$node;
module.exports["default"] = $b18ce3bc11082c03$export$2e2bcd8739ae039;

});

parcelRegister("2fQCH", function(module, exports) {
/**
 * @generated SignedSource<<bb240b22e09d0e349cbdc3cc16e0e4d3>>
 * @relayHash 5841807a4e3bf2a59de617588db23f8f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1590a2caf1a18e2c8f39c97c955bfbcd2ed31d253f236ac687f9d10cfa2a64f8
const $3b3e50e8050cb646$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isLivePagesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isWhiteboardsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isDatabasesEnabled"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "didContainUserContent"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FooterCreateButtonsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FooterCreateButtonsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5841807a4e3bf2a59de617588db23f8f",
            "id": "1590a2caf1a18e2c8f39c97c955bfbcd2ed31d253f236ac687f9d10cfa2a64f8",
            "metadata": {},
            "name": "FooterCreateButtonsQuery",
            "operationKind": "query",
            "text": "query FooterCreateButtonsQuery($spaceKey:String){space(key:$spaceKey){id,key,spaceTypeSettings{enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled}},didContainUserContent,operations{operation,targetType}}}"
        }
    };
}();
$3b3e50e8050cb646$var$node.hash = "8f908e5cb8da1d069802e69ea3d7f563";
var $3b3e50e8050cb646$export$2e2bcd8739ae039 = $3b3e50e8050cb646$var$node;
module.exports["default"] = $3b3e50e8050cb646$export$2e2bcd8739ae039;

});

parcelRegister("gsSsC", function(module, exports) {
/**
 * @generated SignedSource<<22eb52565a522d08d6ca261a792fda3a>>
 * @relayHash 1b389961e5e66b422fc68105162ea2a7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8852b3b3e2fe5695e392f9303e5a9bb51e986824492b6578223f976d6e0fdf05
const $64636a4927b33bd4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAnonymouslyAuthorized"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsUserViewingSpaceAsAnonQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsUserViewingSpaceAsAnonQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1b389961e5e66b422fc68105162ea2a7",
            "id": "8852b3b3e2fe5695e392f9303e5a9bb51e986824492b6578223f976d6e0fdf05",
            "metadata": {},
            "name": "useIsUserViewingSpaceAsAnonQuery",
            "operationKind": "query",
            "text": "query useIsUserViewingSpaceAsAnonQuery($spaceKey:String){space(key:$spaceKey){id,currentUser{isAnonymouslyAuthorized}}}"
        }
    };
}();
$64636a4927b33bd4$var$node.hash = "298be37d19bd8e07f912f849fbe70f5a";
var $64636a4927b33bd4$export$2e2bcd8739ae039 = $64636a4927b33bd4$var$node;
module.exports["default"] = $64636a4927b33bd4$export$2e2bcd8739ae039;

});

parcelRegister("30Qx8", function(module, exports) {

var $cEGBg = parcelRequire("cEGBg");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/navigation/setting/manifest.ts
var $231a1f3f133ad522$var$navigationSettingAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $cEGBg.NavigationSettingAriResourceOwner),
    resourceType: (0, $cEGBg.NavigationSettingAriResourceType),
    resourceIdSlug: "{firstPartyApp}/{siteId}/{activationId}/{settingId}",
    resourceIdSegmentFormats: {
        firstPartyApp: /[a-z0-9-]{1,100}/,
        siteId: /[a-zA-Z0-9_\-.]{1,255}/,
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        settingId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/navigation/setting/index.ts
var $231a1f3f133ad522$export$d9494d14fa8a72a2 = class _NavigationSettingAri extends (0, $1gKSA.RegisteredAri) {
    get firstPartyApp() {
        return this._firstPartyApp;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get settingId() {
        return this._settingId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $231a1f3f133ad522$var$navigationSettingAriStaticOpts.qualifier,
            platformQualifier: $231a1f3f133ad522$var$navigationSettingAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $231a1f3f133ad522$var$navigationSettingAriStaticOpts.resourceOwner,
            resourceType: $231a1f3f133ad522$var$navigationSettingAriStaticOpts.resourceType,
            resourceId: `${opts.firstPartyApp}/${opts.siteId}/${opts.activationId}/${opts.settingId}`,
            resourceIdSegmentValues: {
                firstPartyApp: opts.firstPartyApp,
                siteId: opts.siteId,
                activationId: opts.activationId,
                settingId: opts.settingId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $231a1f3f133ad522$var$navigationSettingAriStaticOpts);
        return new _NavigationSettingAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $231a1f3f133ad522$var$navigationSettingAriStaticOpts);
        return new _NavigationSettingAri(opts);
    }
    getVariables() {
        return {
            firstPartyApp: this.firstPartyApp,
            siteId: this.siteId,
            activationId: this.activationId,
            settingId: this.settingId
        };
    }
    constructor(opts){
        super(opts), this._firstPartyApp = opts.resourceIdSegmentValues.firstPartyApp, this._siteId = opts.resourceIdSegmentValues.siteId, this._activationId = opts.resourceIdSegmentValues.activationId, this._settingId = opts.resourceIdSegmentValues.settingId;
    }
};
module.exports["NavigationSettingAri"] = $231a1f3f133ad522$export$d9494d14fa8a72a2;

});

parcelRegister("cEGBg", function(module, exports) {
// src/navigation/setting/types.ts
var $936a43f66cf48d67$export$efad67ea8db3f12e = "navigation", $936a43f66cf48d67$export$fd28c74ac3f5b728 = "setting";
module.exports["NavigationSettingAriResourceOwner"] = $936a43f66cf48d67$export$efad67ea8db3f12e;
module.exports["NavigationSettingAriResourceType"] = $936a43f66cf48d67$export$fd28c74ac3f5b728;

});

parcelRegister("dGmBZ", function(module, exports) {
/**
 * @generated SignedSource<<33661c089697f9ed030018921b8e7871>>
 * @relayHash d7f6546b4bd4d94740e5b2b8dcd92251
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 188f29876873cb9149ae5fc40015e854f42ac38aca338ea9e892ab562d24f0f5
const $819504ce5ddad46c$var$node = function() {
    var v0 = {
        "defaultValue": 40,
        "kind": "LocalArgument",
        "name": "blogFirst"
    }, v1 = {
        "defaultValue": "metadata.createdDate desc",
        "kind": "LocalArgument",
        "name": "blogOrderBy"
    }, v2 = {
        "defaultValue": [
            "current",
            "draft"
        ],
        "kind": "LocalArgument",
        "name": "blogStatuses"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeBlogTree"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeHomepageTreeVariant"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includePageTree"
    }, v8 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includePersistentInviteLicense"
    }, v9 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeSpaceCurationCount"
    }, v10 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeSpaceViewsPersistence"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLicensed"
    }, v12 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isSuperAdmin"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "paginationLimit"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ptStatuses"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v16 = {
        "kind": "ScalarField",
        "name": "id"
    }, v17 = {
        "alias": "user",
        "args": [
            {
                "kind": "Literal",
                "name": "current",
                "value": true
            }
        ],
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
            v16 /*: any*/ ,
            {
                "concreteType": "ConfluenceUser",
                "kind": "LinkedField",
                "name": "confluence",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "permissionType"
                    }
                ]
            }
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
    }, v18 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v19 = [
        v18 /*: any*/ 
    ], v20 = [
        {
            "kind": "Literal",
            "name": "includeHidden",
            "value": true
        }
    ], v21 = {
        "kind": "ScalarField",
        "name": "webItemKey"
    }, v22 = {
        "kind": "ScalarField",
        "name": "webItemCompleteKey"
    }, v23 = {
        "kind": "ScalarField",
        "name": "title"
    }, v24 = {
        "kind": "ScalarField",
        "name": "url"
    }, v25 = {
        "kind": "ScalarField",
        "name": "position"
    }, v26 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v27 = {
        "kind": "ScalarField",
        "name": "path"
    }, v28 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
            v27 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "width"
            },
            {
                "kind": "ScalarField",
                "name": "height"
            },
            {
                "kind": "ScalarField",
                "name": "isDefault"
            }
        ]
    }, v29 = {
        "kind": "ScalarField",
        "name": "iconClass"
    }, v30 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v31 = {
        "kind": "ScalarField",
        "name": "canHide"
    }, v32 = {
        "kind": "ScalarField",
        "name": "tooltip"
    }, v33 = {
        "kind": "ScalarField",
        "name": "linkIdentifier"
    }, v34 = {
        "kind": "ScalarField",
        "name": "type"
    }, v35 = {
        "concreteType": "SpaceSidebarLink",
        "kind": "LinkedField",
        "name": "quick",
        "plural": true,
        "selections": [
            v16 /*: any*/ ,
            v24 /*: any*/ ,
            v25 /*: any*/ ,
            v23 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v36 = [
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "spaceKey"
        }
    ], v37 = {
        "kind": "ScalarField",
        "name": "key"
    }, v38 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "homepage",
        "plural": false,
        "selections": [
            v16 /*: any*/ 
        ]
    }, v39 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v40 = {
        "kind": "ScalarField",
        "name": "didContainUserContent"
    }, v41 = {
        "kind": "ScalarField",
        "name": "name"
    }, v42 = {
        "kind": "ScalarField",
        "name": "status"
    }, v43 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
            v27 /*: any*/ 
        ]
    }, v44 = {
        "kind": "ScalarField",
        "name": "homepageId"
    }, v45 = {
        "kind": "ScalarField",
        "name": "isAdmin"
    }, v46 = {
        "kind": "ScalarField",
        "name": "isFavourited"
    }, v47 = {
        "kind": "ScalarField",
        "name": "isWatched"
    }, v48 = {
        "kind": "ScalarField",
        "name": "containsExternalCollaborators"
    }, v49 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v50 = {
        "concreteType": "SpaceHistory",
        "kind": "LinkedField",
        "name": "history",
        "plural": false,
        "selections": [
            v49 /*: any*/ 
        ]
    }, v51 = {
        "kind": "Literal",
        "name": "enablePaging",
        "value": true
    }, v52 = {
        "kind": "Variable",
        "name": "pageTree",
        "variableName": "paginationLimit"
    }, v53 = {
        "kind": "Variable",
        "name": "status",
        "variableName": "ptStatuses"
    }, v54 = [
        v51 /*: any*/ ,
        v52 /*: any*/ ,
        v53 /*: any*/ 
    ], v55 = {
        "kind": "FragmentSpread",
        "name": "PageTreeQuery_ptpage"
    }, v56 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v57 = [
        v56 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "endCursor"
        }
    ], v58 = {
        "concreteType": "PTPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": v57 /*: any*/ 
    }, v59 = {
        "concreteType": "PTPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v56 /*: any*/ 
        ]
    }, v60 = [
        {
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v55 /*: any*/ 
            ]
        },
        v59 /*: any*/ 
    ], v61 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "previousSiblings",
        "plural": false,
        "selections": v60 /*: any*/ 
    }, v62 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "followingSiblings",
        "plural": false,
        "selections": v60 /*: any*/ 
    }, v63 = [
        v55 /*: any*/ ,
        {
            "concreteType": "PTPaginatedPageList",
            "kind": "LinkedField",
            "name": "nearestAncestors",
            "plural": false,
            "selections": [
                v58 /*: any*/ ,
                {
                    "concreteType": "PTPage",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v55 /*: any*/ ,
                        v61 /*: any*/ ,
                        v62 /*: any*/ 
                    ]
                }
            ]
        },
        v61 /*: any*/ ,
        v62 /*: any*/ ,
        {
            "concreteType": "PTPaginatedPageList",
            "kind": "LinkedField",
            "name": "children",
            "plural": false,
            "selections": v60 /*: any*/ 
        }
    ], v64 = [
        v51 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        v52 /*: any*/ ,
        v18 /*: any*/ ,
        v53 /*: any*/ 
    ], v65 = [
        v51 /*: any*/ ,
        v52 /*: any*/ ,
        v18 /*: any*/ ,
        v53 /*: any*/ 
    ], v66 = [
        v55 /*: any*/ ,
        v62 /*: any*/ 
    ], v67 = [
        v18 /*: any*/ ,
        v53 /*: any*/ 
    ], v68 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "blogFirst"
        },
        {
            "kind": "Variable",
            "name": "orderby",
            "variableName": "blogOrderBy"
        },
        v18 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "status",
            "variableName": "blogStatuses"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "blogpost"
        }
    ], v69 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": v57 /*: any*/ 
    }, v70 = {
        "kind": "ScalarField",
        "name": "value"
    }, v71 = {
        "args": [
            {
                "kind": "Literal",
                "name": "format",
                "value": "MILLIS"
            }
        ],
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdDate",
        "plural": false,
        "selections": [
            v70 /*: any*/ 
        ],
        "storageKey": "createdDate(format:\"MILLIS\")"
    }, v72 = {
        "kind": "ScalarField",
        "name": "hasChildren"
    }, v73 = {
        "kind": "ScalarField",
        "name": "blank"
    }, v74 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v75 = [
        {
            "kind": "ScalarField",
            "name": "webui"
        }
    ], v76 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v75 /*: any*/ 
    }, v77 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "emoji-title-draft",
                    "editor",
                    "jira-planner-connection"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v16 /*: any*/ ,
                    v37 /*: any*/ ,
                    v70 /*: any*/ ,
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"])"
    }, v78 = {
        "condition": "isSuperAdmin",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasRestrictions"
            },
            {
                "kind": "ScalarField",
                "name": "hasInheritedRestrictions"
            }
        ]
    }, v79 = [
        {
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v16 /*: any*/ ,
                v23 /*: any*/ ,
                v42 /*: any*/ ,
                v71 /*: any*/ ,
                v72 /*: any*/ ,
                v73 /*: any*/ ,
                v34 /*: any*/ ,
                v74 /*: any*/ ,
                v76 /*: any*/ ,
                v77 /*: any*/ ,
                v78 /*: any*/ 
            ]
        },
        v59 /*: any*/ 
    ], v80 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "previousSiblings",
        "plural": false,
        "selections": v79 /*: any*/ 
    }, v81 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "followingSiblings",
        "plural": false,
        "selections": v79 /*: any*/ 
    }, v82 = [
        v16 /*: any*/ ,
        v23 /*: any*/ ,
        v42 /*: any*/ ,
        v71 /*: any*/ ,
        v72 /*: any*/ ,
        v73 /*: any*/ ,
        v34 /*: any*/ ,
        v74 /*: any*/ ,
        v76 /*: any*/ ,
        v77 /*: any*/ ,
        v78 /*: any*/ ,
        {
            "concreteType": "PTPaginatedPageList",
            "kind": "LinkedField",
            "name": "nearestAncestors",
            "plural": false,
            "selections": [
                v58 /*: any*/ ,
                {
                    "concreteType": "PTPage",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v16 /*: any*/ ,
                        v23 /*: any*/ ,
                        v42 /*: any*/ ,
                        v71 /*: any*/ ,
                        v72 /*: any*/ ,
                        v73 /*: any*/ ,
                        v34 /*: any*/ ,
                        v74 /*: any*/ ,
                        v76 /*: any*/ ,
                        v77 /*: any*/ ,
                        v78 /*: any*/ ,
                        v80 /*: any*/ ,
                        v81 /*: any*/ 
                    ]
                }
            ]
        },
        v80 /*: any*/ ,
        v81 /*: any*/ ,
        {
            "concreteType": "PTPaginatedPageList",
            "kind": "LinkedField",
            "name": "children",
            "plural": false,
            "selections": v79 /*: any*/ 
        }
    ], v83 = [
        v16 /*: any*/ ,
        v23 /*: any*/ ,
        v42 /*: any*/ ,
        v71 /*: any*/ ,
        v72 /*: any*/ ,
        v73 /*: any*/ ,
        v34 /*: any*/ ,
        v74 /*: any*/ ,
        v76 /*: any*/ ,
        v77 /*: any*/ ,
        v78 /*: any*/ ,
        v81 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SpaceNavigationQuery",
            "selections": [
                v17 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeHomepageTreeVariant",
                            "variableName": "includeHomepageTreeVariant"
                        },
                        {
                            "kind": "Variable",
                            "name": "includePageTree",
                            "variableName": "includePageTree"
                        },
                        {
                            "kind": "Variable",
                            "name": "isSuperAdmin",
                            "variableName": "isSuperAdmin"
                        },
                        {
                            "kind": "Variable",
                            "name": "paginationLimit",
                            "variableName": "paginationLimit"
                        },
                        {
                            "kind": "Variable",
                            "name": "ptStatuses",
                            "variableName": "ptStatuses"
                        },
                        v18 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "PageTreeInitialData_query"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "blogFirst",
                            "variableName": "blogFirst"
                        },
                        {
                            "kind": "Variable",
                            "name": "blogOrderBy",
                            "variableName": "blogOrderBy"
                        },
                        {
                            "kind": "Variable",
                            "name": "blogStatuses",
                            "variableName": "blogStatuses"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeBlogTree",
                            "variableName": "includeBlogTree"
                        },
                        v18 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "BlogTreeInitialData_query"
                },
                {
                    "condition": "includeSpaceCurationCount",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "useFetchSuggestionCount_query"
                                    }
                                ],
                                "type": "Query"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "spaceCurationSuggestionCount"
                        }
                    ]
                },
                {
                    "condition": "includePersistentInviteLicense",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "License",
                            "kind": "LinkedField",
                            "name": "license",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "PersistentInviteEligibleQuery_license"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v19 /*: any*/ ,
                    "concreteType": "SpaceSidebarLinks",
                    "kind": "LinkedField",
                    "name": "spaceSidebarLinks",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "SpaceLinks_spaceSidebarLinks"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "ShortcutsSection_spaceSidebarLinks"
                        },
                        {
                            "args": v20 /*: any*/ ,
                            "concreteType": "SpaceSidebarLink",
                            "kind": "LinkedField",
                            "name": "main",
                            "plural": true,
                            "selections": [
                                v16 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ ,
                                v28 /*: any*/ ,
                                v29 /*: any*/ ,
                                v30 /*: any*/ ,
                                v31 /*: any*/ ,
                                v32 /*: any*/ ,
                                v33 /*: any*/ ,
                                v34 /*: any*/ 
                            ],
                            "storageKey": "main(includeHidden:true)"
                        },
                        v35 /*: any*/ 
                    ]
                },
                {
                    "args": v36 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "useIsUserViewingSpaceAsAnon_space"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "PersistentInviteEligibleQuery_space"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "ExternalCollaboratorsSpaceInformationMessage_space"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "isLicensed",
                                    "variableName": "isLicensed"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "SpaceHeader_space"
                        },
                        v16 /*: any*/ ,
                        v37 /*: any*/ ,
                        v38 /*: any*/ ,
                        v39 /*: any*/ ,
                        {
                            "kind": "FragmentSpread",
                            "name": "SpaceOperationsFragment"
                        },
                        v40 /*: any*/ ,
                        {
                            "kind": "FragmentSpread",
                            "name": "useSpaceViewsData_space"
                        },
                        v41 /*: any*/ ,
                        v34 /*: any*/ ,
                        v42 /*: any*/ ,
                        v43 /*: any*/ ,
                        v44 /*: any*/ ,
                        {
                            "condition": "isLicensed",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "SpaceUserMetadata",
                                    "kind": "LinkedField",
                                    "name": "currentUser",
                                    "plural": false,
                                    "selections": [
                                        v45 /*: any*/ ,
                                        v46 /*: any*/ ,
                                        v47 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v48 /*: any*/ ,
                        v50 /*: any*/ ,
                        {
                            "condition": "includeHomepageTreeVariant",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v54 /*: any*/ ,
                                    "concreteType": "PTPage",
                                    "kind": "LinkedField",
                                    "name": "pageTree",
                                    "plural": false,
                                    "selections": v63 /*: any*/ 
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includePageTree",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "currentPage",
                            "args": v64 /*: any*/ ,
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "ptpage",
                            "plural": false,
                            "selections": v63 /*: any*/ 
                        },
                        {
                            "alias": "rootPageTree",
                            "args": v65 /*: any*/ ,
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "ptpage",
                            "plural": false,
                            "selections": v66 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "includeHomepageTreeVariant",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "homepageRootPageTree",
                            "args": v67 /*: any*/ ,
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "ptpage",
                            "plural": false,
                            "selections": v66 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "includeBlogTree",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "blogPosts",
                            "args": v68 /*: any*/ ,
                            "concreteType": "PaginatedContentListWithChild",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v69 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "BlogTreeRootComponent_content"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeSpaceViewsPersistence",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "UserPreferences",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "useSpaceViewsOptionsPersistence_userPreferences"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v15 /*: any*/ ,
                v11 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v4 /*: any*/ ,
                v14 /*: any*/ ,
                v13 /*: any*/ ,
                v12 /*: any*/ ,
                v7 /*: any*/ ,
                v6 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v10 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SpaceNavigationQuery",
            "selections": [
                v17 /*: any*/ ,
                {
                    "args": v36 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v16 /*: any*/ ,
                        v38 /*: any*/ ,
                        v39 /*: any*/ ,
                        {
                            "concreteType": "SpaceUserMetadata",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isAnonymouslyAuthorized"
                                },
                                v45 /*: any*/ 
                            ]
                        },
                        v41 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "externalCollaboratorCount"
                        },
                        v37 /*: any*/ ,
                        v34 /*: any*/ ,
                        v42 /*: any*/ ,
                        v43 /*: any*/ ,
                        v48 /*: any*/ ,
                        v40 /*: any*/ ,
                        v44 /*: any*/ ,
                        v50 /*: any*/ ,
                        {
                            "condition": "includeHomepageTreeVariant",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v54 /*: any*/ ,
                                    "concreteType": "PTPage",
                                    "kind": "LinkedField",
                                    "name": "pageTree",
                                    "plural": false,
                                    "selections": v82 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "condition": "isLicensed",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "SpaceUserMetadata",
                                    "kind": "LinkedField",
                                    "name": "currentUser",
                                    "plural": false,
                                    "selections": [
                                        v46 /*: any*/ ,
                                        v47 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v19 /*: any*/ ,
                    "concreteType": "SpaceSidebarLinks",
                    "kind": "LinkedField",
                    "name": "spaceSidebarLinks",
                    "plural": false,
                    "selections": [
                        {
                            "args": v20 /*: any*/ ,
                            "concreteType": "SpaceSidebarLink",
                            "kind": "LinkedField",
                            "name": "main",
                            "plural": true,
                            "selections": [
                                v16 /*: any*/ ,
                                v22 /*: any*/ ,
                                v25 /*: any*/ ,
                                v30 /*: any*/ ,
                                v21 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v26 /*: any*/ ,
                                v28 /*: any*/ ,
                                v29 /*: any*/ ,
                                v31 /*: any*/ ,
                                v32 /*: any*/ ,
                                v33 /*: any*/ ,
                                v34 /*: any*/ 
                            ],
                            "storageKey": "main(includeHidden:true)"
                        },
                        v35 /*: any*/ 
                    ]
                },
                {
                    "condition": "includePageTree",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "currentPage",
                            "args": v64 /*: any*/ ,
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "ptpage",
                            "plural": false,
                            "selections": v82 /*: any*/ 
                        },
                        {
                            "alias": "rootPageTree",
                            "args": v65 /*: any*/ ,
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "ptpage",
                            "plural": false,
                            "selections": v83 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "includeHomepageTreeVariant",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "homepageRootPageTree",
                            "args": v67 /*: any*/ ,
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "ptpage",
                            "plural": false,
                            "selections": v83 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "includeBlogTree",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "blogPosts",
                            "args": v68 /*: any*/ ,
                            "concreteType": "PaginatedContentListWithChild",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v69 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        v23 /*: any*/ ,
                                        v42 /*: any*/ ,
                                        v73 /*: any*/ ,
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "keys",
                                                    "value": [
                                                        "emoji-title-published",
                                                        "emoji-title-draft",
                                                        "editor"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "PaginatedJsonContentPropertyList",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JsonContentProperty",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v16 /*: any*/ ,
                                                        v37 /*: any*/ ,
                                                        v70 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
                                        },
                                        {
                                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                            "kind": "LinkedField",
                                            "name": "links",
                                            "plural": false,
                                            "selections": v75 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "ContentMetadata",
                                            "kind": "LinkedField",
                                            "name": "metadata",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "lastModifiedDate"
                                                },
                                                v49 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeSpaceCurationCount",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                v18 /*: any*/ 
                            ],
                            "kind": "ScalarField",
                            "name": "confluence_remoteObjectSuggestionCount"
                        }
                    ]
                },
                {
                    "condition": "includePersistentInviteLicense",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "License",
                            "kind": "LinkedField",
                            "name": "license",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "licenseConsumingUserCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "trialEndDate"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeSpaceViewsPersistence",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "UserPreferences",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v19 /*: any*/ ,
                                    "kind": "ScalarField",
                                    "name": "spaceViewsPersistence"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "d7f6546b4bd4d94740e5b2b8dcd92251",
            "id": "188f29876873cb9149ae5fc40015e854f42ac38aca338ea9e892ab562d24f0f5",
            "metadata": {},
            "name": "SpaceNavigationQuery",
            "operationKind": "query",
            "text": "query SpaceNavigationQuery($cloudId:ID!,$spaceKey:String!,$isLicensed:Boolean!,$includePersistentInviteLicense:Boolean=false,$includeSpaceCurationCount:Boolean=false,$contentId:ID,$ptStatuses:[PTGraphQLPageStatus],$paginationLimit:Int,$isSuperAdmin:Boolean=false,$includePageTree:Boolean=false,$includeHomepageTreeVariant:Boolean=false,$includeBlogTree:Boolean=false,$blogFirst:Int=40,$blogOrderBy:String=\"metadata.createdDate desc\",$blogStatuses:[String]=[\"current\",\"draft\"],$includeSpaceViewsPersistence:Boolean=false){user:confluence_atlassianUser(current:true){id,confluence{permissionType}},...PageTreeInitialData_query_4jV106,...BlogTreeInitialData_query_2C9WBt,...useFetchSuggestionCount_query@include(if:$includeSpaceCurationCount),license@include(if:$includePersistentInviteLicense){...PersistentInviteEligibleQuery_license},spaceSidebarLinks(spaceKey:$spaceKey){...SpaceLinks_spaceSidebarLinks,...ShortcutsSection_spaceSidebarLinks,main(includeHidden:true){id,webItemKey,webItemCompleteKey,title,url,position,styleClass,icon{path,width,height,isDefault},iconClass,hidden,canHide,tooltip,linkIdentifier,type},quick{id,url,position,title,styleClass}},space(key:$spaceKey){...useIsUserViewingSpaceAsAnon_space,...PersistentInviteEligibleQuery_space,...ExternalCollaboratorsSpaceInformationMessage_space,...SpaceHeader_space_3F1fcg,id,key,homepage{id},operations{operation,targetType},...SpaceOperationsFragment,didContainUserContent,...useSpaceViewsData_space,name,type,status,icon{path},homepageId,currentUser@include(if:$isLicensed){isAdmin,isFavourited,isWatched},containsExternalCollaborators,history{createdDate},pageTree(pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includeHomepageTreeVariant){...PageTreeQuery_ptpage,nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{...PageTreeQuery_ptpage,previousSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}},previousSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},children{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}},currentPage:ptpage(id:$contentId,spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includePageTree){...PageTreeQuery_ptpage,nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{...PageTreeQuery_ptpage,previousSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}},previousSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},children{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}\n  rootPageTree:ptpage(spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includePageTree){...PageTreeQuery_ptpage,followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id},homepageRootPageTree:ptpage(spaceKey:$spaceKey,status:$ptStatuses)@include(if:$includeHomepageTreeVariant){...PageTreeQuery_ptpage,followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id},blogPosts:content(spaceKey:$spaceKey,type:\"blogpost\",first:$blogFirst,orderby:$blogOrderBy,status:$blogStatuses)@include(if:$includeBlogTree){pageInfo{hasNextPage,endCursor},nodes{...BlogTreeRootComponent_content,id}},userPreferences@include(if:$includeSpaceViewsPersistence){...useSpaceViewsOptionsPersistence_userPreferences}}fragment BlogTreeInitialData_query_2C9WBt on Query{blogPosts:content(spaceKey:$spaceKey,type:\"blogpost\",first:$blogFirst,orderby:$blogOrderBy,status:$blogStatuses)@include(if:$includeBlogTree){pageInfo{hasNextPage,endCursor},nodes{id,title,status,blank,properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value}},links{webui},metadata{lastModifiedDate,createdDate}}}}fragment BlogTreeRootComponent_content on Content{id,title,status,blank,properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value}},links{webui},metadata{lastModifiedDate,createdDate}}fragment ExternalCollaboratorsSpaceInformationMessage_space on Space{id,name,externalCollaboratorCount,currentUser{isAdmin}}fragment PageTreeInitialData_query_4jV106 on Query{currentPage:ptpage(id:$contentId,spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includePageTree){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}},children{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}}}\n  rootPageTree:ptpage(spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includePageTree){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}}},space(key:$spaceKey){id,homepage{id},operations{operation,targetType},pageTree(pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includeHomepageTreeVariant){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n      hasInheritedRestrictions@include(if:$isSuperAdmin),nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n          hasInheritedRestrictions@include(if:$isSuperAdmin),previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n              hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n              hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n          hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n          hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}},children{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n          hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}}}},homepageRootPageTree:ptpage(spaceKey:$spaceKey,status:$ptStatuses)@include(if:$includeHomepageTreeVariant){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}}}}fragment PageTreeQuery_ptpage on PTPage{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n  hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}}fragment PersistentInviteEligibleQuery_license on License{licenseConsumingUserCount,trialEndDate}fragment PersistentInviteEligibleQuery_space on Space{id,currentUser{isAnonymouslyAuthorized}}fragment ShortcutsSection_spaceSidebarLinks on SpaceSidebarLinks{quick{id,url,position,title,styleClass}}fragment SpaceHeader_space_3F1fcg on Space{id,key,name,type,status,icon{path},homepage{id},currentUser@include(if:$isLicensed){isAdmin,isFavourited,isWatched},operations{operation,targetType},containsExternalCollaborators}fragment SpaceLinks_spaceSidebarLinks on SpaceSidebarLinks{main(includeHidden:true){id,webItemCompleteKey,position,hidden}}fragment SpaceOperationsFragment on Space{id,operations{operation,targetType}}fragment useFetchSuggestionCount_query on Query{confluence_remoteObjectSuggestionCount(cloudId:$cloudId,spaceKey:$spaceKey)}fragment useIsUserViewingSpaceAsAnon_space on Space{id,currentUser{isAnonymouslyAuthorized}}fragment useSpaceViewsData_space on Space{id,homepage{id},operations{operation,targetType}}fragment useSpaceViewsOptionsPersistence_userPreferences on UserPreferences{spaceViewsPersistence(spaceKey:$spaceKey)}"
        }
    };
}();
$819504ce5ddad46c$var$node.hash = "ba6e15068464a55bd81c7c1242c03802";
var $819504ce5ddad46c$export$2e2bcd8739ae039 = $819504ce5ddad46c$var$node;
module.exports["default"] = $819504ce5ddad46c$export$2e2bcd8739ae039;

});

parcelRegister("3AeIf", function(module, exports) {
/**
 * @generated SignedSource<<30433c300b34114d28e5a73869e7e5f1>>
 * @relayHash f18661cc7a1d2d55f19018b453d74e49
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5b9f82627568e61d5a48e4bdd045a30d7fc6ac7b992beec39feead5b18838e62
const $ca580f7b974eac2e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "spaceViewsPersistence"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f18661cc7a1d2d55f19018b453d74e49",
            "id": "5b9f82627568e61d5a48e4bdd045a30d7fc6ac7b992beec39feead5b18838e62",
            "metadata": {},
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "operationKind": "query",
            "text": "query useSpaceViewsOptionsPersistenceQuery($spaceKey:String!){userPreferences{spaceViewsPersistence(spaceKey:$spaceKey)}}"
        }
    };
}();
$ca580f7b974eac2e$var$node.hash = "ed56952e91ea2d83611b306fd16f1677";
var $ca580f7b974eac2e$export$2e2bcd8739ae039 = $ca580f7b974eac2e$var$node;
module.exports["default"] = $ca580f7b974eac2e$export$2e2bcd8739ae039;

});

parcelRegister("e5i8U", function(module, exports) {
/**
 * @generated SignedSource<<5a7cafa777379c54dbddb23ee36a1082>>
 * @relayHash e2df23bdc78f713de65477722c69e437
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a39b7f0aab0b5e8324355dad0345b8cded996fb24379f7510a65f6a6f61c1c54
const $352d8776ce9e612e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceViewsDataSpaceRootQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceViewsDataSpaceRootQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "e2df23bdc78f713de65477722c69e437",
            "id": "a39b7f0aab0b5e8324355dad0345b8cded996fb24379f7510a65f6a6f61c1c54",
            "metadata": {},
            "name": "useSpaceViewsDataSpaceRootQuery",
            "operationKind": "query",
            "text": "query useSpaceViewsDataSpaceRootQuery($spaceKey:String!){space(key:$spaceKey){id,homepage{id},operations{operation,targetType}}}"
        }
    };
}();
$352d8776ce9e612e$var$node.hash = "cf7ed5a52874f0b9ce129552e428e0b7";
var $352d8776ce9e612e$export$2e2bcd8739ae039 = $352d8776ce9e612e$var$node;
module.exports["default"] = $352d8776ce9e612e$export$2e2bcd8739ae039;

});

parcelRegister("1oGPE", function(module, exports) {
const $00840277cc5ce9b5$export$90091b93f6cf4241 = 80;
const $00840277cc5ce9b5$export$3cf9a7263d7d2d28 = 100; // INITIAL_PAGE_SIZE was previously 160 but we reduced it to 80. Should we also reduce this?
module.exports["INITIAL_PAGE_SIZE"] = $00840277cc5ce9b5$export$90091b93f6cf4241;
module.exports["CHILDREN_PAGE_SIZE"] = $00840277cc5ce9b5$export$3cf9a7263d7d2d28;

});

parcelRegister("9eCf8", function(module, exports) {
/**
 * @generated SignedSource<<65ddc58d625028461cf53f05076a93e9>>
 * @relayHash 661233a47ecadf36bf6b55db313a301e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 606baac6ffac521e762bb6b0a6f0aebbd60f1bd9366f43f4a561b5a0c55143c9
const $b0adf32477ccbbfa$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isSuperAdmin"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "paginationLimit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ptStatuses"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v5 = {
        "kind": "Literal",
        "name": "enablePaging",
        "value": true
    }, v6 = {
        "kind": "Variable",
        "name": "pageTree",
        "variableName": "paginationLimit"
    }, v7 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v8 = {
        "kind": "Variable",
        "name": "status",
        "variableName": "ptStatuses"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "title"
    }, v11 = {
        "kind": "ScalarField",
        "name": "status"
    }, v12 = {
        "kind": "ScalarField",
        "name": "value"
    }, v13 = {
        "args": [
            {
                "kind": "Literal",
                "name": "format",
                "value": "MILLIS"
            }
        ],
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdDate",
        "plural": false,
        "selections": [
            v12 /*: any*/ 
        ],
        "storageKey": "createdDate(format:\"MILLIS\")"
    }, v14 = {
        "kind": "ScalarField",
        "name": "hasChildren"
    }, v15 = {
        "kind": "ScalarField",
        "name": "blank"
    }, v16 = {
        "condition": "isSuperAdmin",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasRestrictions"
            },
            {
                "kind": "ScalarField",
                "name": "hasInheritedRestrictions"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "type"
    }, v18 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v19 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v20 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "emoji-title-draft",
                    "editor",
                    "jira-planner-connection"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v9 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    v12 /*: any*/ ,
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"])"
    }, v21 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v22 = [
        {
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ 
            ]
        },
        {
            "concreteType": "PTPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                v21 /*: any*/ 
            ]
        }
    ], v23 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "previousSiblings",
        "plural": false,
        "selections": v22 /*: any*/ 
    }, v24 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "followingSiblings",
        "plural": false,
        "selections": v22 /*: any*/ 
    }, v25 = [
        {
            "alias": "currentPage",
            "args": [
                v5 /*: any*/ ,
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "nearestAncestors",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PTPageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                v21 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ 
                            ]
                        }
                    ]
                },
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": false,
                    "selections": v22 /*: any*/ 
                }
            ]
        },
        {
            "args": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v24 /*: any*/ 
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v9 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PageTreeQuery",
            "selections": v25 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PageTreeQuery",
            "selections": v25 /*: any*/ 
        },
        "params": {
            "cacheID": "661233a47ecadf36bf6b55db313a301e",
            "id": "606baac6ffac521e762bb6b0a6f0aebbd60f1bd9366f43f4a561b5a0c55143c9",
            "metadata": {},
            "name": "PageTreeQuery",
            "operationKind": "query",
            "text": "query PageTreeQuery($spaceKey:String!,$ptStatuses:[PTGraphQLPageStatus],$contentId:ID!,$paginationLimit:Int,$isSuperAdmin:Boolean!){currentPage:ptpage(id:$contentId,spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},children{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}},ptpage(spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}},space(key:$spaceKey){id,homepage{id},operations{operation,targetType}}}"
        }
    };
}();
$b0adf32477ccbbfa$var$node.hash = "f7e2a69b86e03d256ceaf9a0f482bed1";
var $b0adf32477ccbbfa$export$2e2bcd8739ae039 = $b0adf32477ccbbfa$var$node;
module.exports["default"] = $b0adf32477ccbbfa$export$2e2bcd8739ae039;

});

parcelRegister("fL5TY", function(module, exports) {
/**
 * @generated SignedSource<<e2be3df7e36c1a69e702384a7f29b58e>>
 * @relayHash 32d094adde43b53166e21c73e0e18466
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8ba3ae6faaa2b1672d7eef93310782aed4bc09c157af62ec4f49eb5fa49b05db
const $b517e71d543026da$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "endCursor"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orderBy"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "statuses"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "endCursor"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "orderby",
                    "variableName": "orderBy"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "statuses"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "blogpost"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        }
                    ]
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "blank"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "emoji-title-published",
                                        "emoji-title-draft",
                                        "editor"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
                        },
                        {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastModifiedDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "createdDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "BlogTreeRootComponentQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "BlogTreeRootComponentQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "32d094adde43b53166e21c73e0e18466",
            "id": "8ba3ae6faaa2b1672d7eef93310782aed4bc09c157af62ec4f49eb5fa49b05db",
            "metadata": {},
            "name": "BlogTreeRootComponentQuery",
            "operationKind": "query",
            "text": "query BlogTreeRootComponentQuery($spaceKey:String!,$first:Int,$endCursor:String,$statuses:[String],$orderBy:String){content(spaceKey:$spaceKey,type:\"blogpost\",first:$first,orderby:$orderBy,after:$endCursor,status:$statuses){pageInfo{hasNextPage,endCursor},nodes{id,title,status,blank,properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value}},links{webui},metadata{lastModifiedDate,createdDate}}}}"
        }
    };
}();
$b517e71d543026da$var$node.hash = "d3491fdf4e3b619ed45b83d834c8fb95";
var $b517e71d543026da$export$2e2bcd8739ae039 = $b517e71d543026da$var$node;
module.exports["default"] = $b517e71d543026da$export$2e2bcd8739ae039;

});

parcelRegister("6DMfJ", function(module, exports) {
const $4d5bd09a97238678$export$e3c11860ad35ba05 = [
    'current',
    'draft'
];
const $4d5bd09a97238678$export$70918a400db2b6af = 'VIRTUAL_ROOT_ID';
const $4d5bd09a97238678$export$8ec3d08588d2eeda = 40;
const $4d5bd09a97238678$export$130b26c73bb9d040 = 16;
module.exports["BLOG_STATUSES"] = $4d5bd09a97238678$export$e3c11860ad35ba05;
module.exports["VIRTUAL_ROOT_ID"] = $4d5bd09a97238678$export$70918a400db2b6af;
module.exports["PAGE_SIZE"] = $4d5bd09a97238678$export$8ec3d08588d2eeda;
module.exports["INDENT_PER_LEVEL"] = $4d5bd09a97238678$export$130b26c73bb9d040;

});

parcelRegister("ivyMZ", function(module, exports) {
var $4eb170397cdf11a9$export$bcac0c74873fee96 = /*#__PURE__*/ function(GraphQLPageStatus) {
    GraphQLPageStatus["CURRENT"] = "CURRENT";
    GraphQLPageStatus["DRAFT"] = "DRAFT";
    return GraphQLPageStatus;
}({});
const $4eb170397cdf11a9$export$48ccce95f626ae31 = [
    "CURRENT",
    "DRAFT"
];
const $4eb170397cdf11a9$export$5522fe3493552101 = [
    'current',
    'draft'
];
module.exports["PAGE_TREE_STATUSES"] = $4eb170397cdf11a9$export$48ccce95f626ae31;

});

parcelRegister("gRzR4", function(module, exports) {
/**
 * @generated SignedSource<<437e2fd324fdb1225cb122ee838aa6a2>>
 * @relayHash b761690351fd38a63053eefb2d1de3c0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8983e89338e9db4549f597c6a2f7f4aa36777c139be8c74459f3b001a0c76de2
const $7836e6257492ac35$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "generatedBy"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "kind": "ScalarField",
                    "name": "creatorId"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                },
                {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "createdDate"
                        }
                    ]
                },
                {
                    "concreteType": "ContentProperties",
                    "kind": "LinkedField",
                    "name": "contentProperties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "DraftContentProperties",
                            "kind": "LinkedField",
                            "name": "draft",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        },
                        {
                            "concreteType": "PublishedContentProperties",
                            "kind": "LinkedField",
                            "name": "latest",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SmartCreateFeedbackBannerQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SmartCreateFeedbackBannerQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "b761690351fd38a63053eefb2d1de3c0",
            "id": "8983e89338e9db4549f597c6a2f7f4aa36777c139be8c74459f3b001a0c76de2",
            "metadata": {},
            "name": "SmartCreateFeedbackBannerQuery",
            "operationKind": "query",
            "text": "query SmartCreateFeedbackBannerQuery($contentId:ID!){singleContent(id:$contentId){title,id,type,creatorId,version{number},history{createdDate},contentProperties{draft{generatedBy},latest{generatedBy}}}}"
        }
    };
}();
$7836e6257492ac35$var$node.hash = "3b6aed693a868f37a0f80c27a28586a0";
var $7836e6257492ac35$export$2e2bcd8739ae039 = $7836e6257492ac35$var$node;
module.exports["default"] = $7836e6257492ac35$export$2e2bcd8739ae039;

});

parcelRegister("dd33Q", function(module, exports) {
/**
 * @generated SignedSource<<79c814000abc51a87825021048515fd1>>
 * @relayHash 10a6e74201e75f7fd05257845e870e22
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2
const $b17ca59e188f1f50$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isBlogsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isDatabasesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isEmbedsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isLivePagesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSlidesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isWhiteboardsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFoldersEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceEnabledContentTypesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceEnabledContentTypesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "10a6e74201e75f7fd05257845e870e22",
            "id": "5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2",
            "metadata": {},
            "name": "useSpaceEnabledContentTypesQuery",
            "operationKind": "query",
            "text": "query useSpaceEnabledContentTypesQuery($spaceKey:String){space(key:$spaceKey){id,key,spaceTypeSettings{enabledContentTypes{isBlogsEnabled,isDatabasesEnabled,isEmbedsEnabled,isLivePagesEnabled,isSlidesEnabled,isWhiteboardsEnabled,isFoldersEnabled}}}}"
        }
    };
}();
$b17ca59e188f1f50$var$node.hash = "031eb89bf77537fd501cf18345136db8";
var $b17ca59e188f1f50$export$2e2bcd8739ae039 = $b17ca59e188f1f50$var$node;
module.exports["default"] = $b17ca59e188f1f50$export$2e2bcd8739ae039;

});

parcelRegister("47TZD", function(module, exports) {

var $6B1vK = parcelRequire("6B1vK");

const $fb0dcbfe669881ea$export$8f6fbf7ac56d5471 = 3;
const $fb0dcbfe669881ea$var$SOURCE_COLUMN = 'source';
const $fb0dcbfe669881ea$export$6bfcbd8be080e9d0 = (contentId, status)=>Object.freeze({
        contentId: contentId,
        status: status
    });
const $fb0dcbfe669881ea$var$buildIncomingLinksCypher = (targetAri)=>[
        `MATCH (source)-[:content_referenced_entity]->(target:ConfluencePage {ari: "${targetAri}"})`,
        'WHERE source <> target',
        'RETURN source',
        `LIMIT ${$fb0dcbfe669881ea$export$8f6fbf7ac56d5471}`
    ].join('\n');
const $fb0dcbfe669881ea$export$5ecfd95d81f175ce = (cloudId, contentId)=>{
    if (!cloudId.trim() || !/^[1-9]\d*$/.test(contentId)) return undefined;
    let targetAri;
    try {
        targetAri = (0, $6B1vK.ConfluencePageAri).create({
            siteId: cloudId,
            pageId: contentId
        }).toString();
    } catch  {
        return undefined;
    }
    return {
        cypherQuery: $fb0dcbfe669881ea$var$buildIncomingLinksCypher(targetAri),
        first: $fb0dcbfe669881ea$export$8f6fbf7ac56d5471
    };
};
const $fb0dcbfe669881ea$export$ea0577b4a4a51553 = (data)=>{
    const edges = data?.graphStore_cypherQueryV2?.edges;
    if (!edges || edges.length > $fb0dcbfe669881ea$export$8f6fbf7ac56d5471) return {
        status: 'unavailable',
        reason: 'malformed-response'
    };
    for (const edge of edges){
        const columns = edge.node.columns;
        if (columns.length !== 1) return {
            status: 'unavailable',
            reason: 'malformed-response'
        };
        const column = columns[0];
        if (column.key !== $fb0dcbfe669881ea$var$SOURCE_COLUMN || column.value?.__typename !== 'GraphStoreCypherQueryV2AriNode' || typeof column.value.id !== 'string' || !column.value.id.startsWith('ari:')) return {
            status: 'unavailable',
            reason: 'malformed-response'
        };
    }
    return {
        status: 'available',
        count: edges.length
    };
};
const $fb0dcbfe669881ea$export$2f3db422bbda5145 = (contentId, data)=>{
    const result = $fb0dcbfe669881ea$export$ea0577b4a4a51553(data);
    if (result.status === 'unavailable') return $fb0dcbfe669881ea$export$6bfcbd8be080e9d0(contentId, 'unavailable');
    return $fb0dcbfe669881ea$export$6bfcbd8be080e9d0(contentId, result.count > 0 ? 'present' : 'empty');
};
module.exports["INCOMING_LINKS_SAMPLE_LIMIT"] = $fb0dcbfe669881ea$export$8f6fbf7ac56d5471;
module.exports["createIncomingLinksSsrState"] = $fb0dcbfe669881ea$export$6bfcbd8be080e9d0;
module.exports["buildIncomingLinksSampleVariables"] = $fb0dcbfe669881ea$export$5ecfd95d81f175ce;
module.exports["normalizeIncomingLinksSampleData"] = $fb0dcbfe669881ea$export$ea0577b4a4a51553;
module.exports["normalizeIncomingLinksSsrState"] = $fb0dcbfe669881ea$export$2f3db422bbda5145;

});

parcelRegister("6U179", function(module, exports) {
/**
 * @generated SignedSource<<ae7b4939fdea464930e0f014fce7c3a3>>
 * @relayHash 5ebf1285eea0f6e277ccc1791c349170
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 83f26dc21ea579fed2d0d4ec2f290a108314a7d06a83cc5b9fbf80b01a76c7b9
const $784926291035c30b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cypherQuery"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "query",
                    "variableName": "cypherQuery"
                }
            ],
            "concreteType": "GraphStoreCypherQueryV2Connection",
            "kind": "LinkedField",
            "name": "graphStore_cypherQueryV2",
            "plural": false,
            "selections": [
                {
                    "concreteType": "GraphStoreCypherQueryV2Edge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "GraphStoreCypherQueryV2Node",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreCypherQueryV2Column",
                                    "kind": "LinkedField",
                                    "name": "columns",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "value",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "GraphStoreCypherQueryV2AriNode"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadIncomingLinksSampleQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadIncomingLinksSampleQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5ebf1285eea0f6e277ccc1791c349170",
            "id": "83f26dc21ea579fed2d0d4ec2f290a108314a7d06a83cc5b9fbf80b01a76c7b9",
            "metadata": {},
            "name": "preloadIncomingLinksSampleQuery",
            "operationKind": "query",
            "text": "query preloadIncomingLinksSampleQuery($cypherQuery:String!,$first:Int!){graphStore_cypherQueryV2(query:$cypherQuery,first:$first)@optIn(to:\"GraphStoreCypherQueryV2\"){edges{node{columns{key,value{__typename,...on GraphStoreCypherQueryV2AriNode{id}}}}}}}"
        }
    };
}();
$784926291035c30b$var$node.hash = "60d2b49af10374001914afa2e5cda7a3";
var $784926291035c30b$export$2e2bcd8739ae039 = $784926291035c30b$var$node;
module.exports["default"] = $784926291035c30b$export$2e2bcd8739ae039;

});

parcelRegister("66MEr", function(module, exports) {
/**
 * @generated SignedSource<<9f25470e51da80e6750dd1882868cfe2>>
 * @relayHash d52e66d12a0624aac2fdbfe49ab48ab1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8c1dd07ac639cb5bde54983be5bcee1631624741f1f5249dd51307802eefc42d
const $f3a6ef2390da2925$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 3
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "OutgoingLinks",
                            "kind": "LinkedField",
                            "name": "outgoingLinks",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "ConfluenceExternalLinkConnection",
                                    "kind": "LinkedField",
                                    "name": "externalOutgoingLinks",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceExternalLink",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "url"
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "externalOutgoingLinks(first:3)"
                                },
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "PaginatedContentList",
                                    "kind": "LinkedField",
                                    "name": "internalOutgoingLinks",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                                    "kind": "LinkedField",
                                                    "name": "links",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "base"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "webui"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "internalOutgoingLinks(first:3)"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadOutboundBylineSsrStateQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadOutboundBylineSsrStateQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "d52e66d12a0624aac2fdbfe49ab48ab1",
            "id": "8c1dd07ac639cb5bde54983be5bcee1631624741f1f5249dd51307802eefc42d",
            "metadata": {},
            "name": "preloadOutboundBylineSsrStateQuery",
            "operationKind": "query",
            "text": "query preloadOutboundBylineSsrStateQuery($contentId:ID!){content(id:$contentId){nodes{id,outgoingLinks{externalOutgoingLinks(first:3){nodes{url}},internalOutgoingLinks(first:3){nodes{id,links{base,webui}}}}}}}"
        }
    };
}();
$f3a6ef2390da2925$var$node.hash = "aadfb15d662296b74dd0622642b547bf";
var $f3a6ef2390da2925$export$2e2bcd8739ae039 = $f3a6ef2390da2925$var$node;
module.exports["default"] = $f3a6ef2390da2925$export$2e2bcd8739ae039;

});

parcelRegister("3C8hL", function(module, exports) {

var $jJhQa = parcelRequire("jJhQa");

function $55debb7a67d5b98d$export$f1091f4b134fe3fc(contentId, status, iconCount) {
    if (status === 'present') return Object.freeze({
        contentId: contentId,
        status: status,
        iconCount: iconCount ?? 0
    });
    return Object.freeze({
        contentId: contentId,
        status: status
    });
}
const $55debb7a67d5b98d$export$e84841b18fa82831 = (outboundState, hasDevDocsConnection)=>{
    // Only 'present' and Dev Docs are positive signals. 'unavailable' means the preload could not
    // tell us anything, so it reserves nothing: that trades a layout shift on pages which do have
    // links for never painting a byline on pages which have none.
    const hasOutboundSignal = outboundState?.status === 'present' || hasDevDocsConnection;
    // Without an outbound signal the placeholder is logo-and-label only, so reserve no app tiles.
    if (!hasOutboundSignal) return 0;
    const outboundIconCount = outboundState?.status === 'present' ? outboundState.iconCount : 0;
    const devDocsIconCount = hasDevDocsConnection ? 1 : 0;
    return Math.min(Math.max(outboundIconCount + devDocsIconCount, 1), (0, $jJhQa.MAX_BYLINE_CONNECTION_ICONS));
};
const $55debb7a67d5b98d$var$isNullOrUndefined = (value)=>{
    if (value === null) return true;
    return value === undefined;
};
const $55debb7a67d5b98d$var$getHostname = (url)=>{
    try {
        return new URL(url).hostname;
    } catch  {
        return undefined;
    }
};
const $55debb7a67d5b98d$var$countDistinctDomains = (externalNodes, internalNodes)=>{
    const domains = new Set();
    for (const node of externalNodes){
        const url = node?.url;
        if (typeof url !== 'string') continue;
        // Skip host-less schemes (mailto:, tel:) whose empty hostname would count as a domain.
        const hostname = $55debb7a67d5b98d$var$getHostname(url);
        if (hostname) domains.add(hostname);
    }
    if (internalNodes.length > 0) domains.add('__internal__');
    return Math.min(domains.size, (0, $jJhQa.MAX_BYLINE_CONNECTION_ICONS));
};
const $55debb7a67d5b98d$var$isValidOutgoingLinksResponse = (actualContentId, expectedContentId, collections)=>{
    if (actualContentId !== expectedContentId) return false;
    if ($55debb7a67d5b98d$var$isNullOrUndefined(collections.externalNodes)) return false;
    if ($55debb7a67d5b98d$var$isNullOrUndefined(collections.internalNodes)) return false;
    return true;
};
const $55debb7a67d5b98d$export$6a56c90936a4d835 = (contentId, data)=>{
    const contentNodes = data?.content?.nodes;
    if ($55debb7a67d5b98d$var$isNullOrUndefined(contentNodes) || contentNodes.length !== 1) return $55debb7a67d5b98d$export$f1091f4b134fe3fc(contentId, 'unavailable');
    const content = contentNodes[0];
    const collections = {
        externalNodes: content?.outgoingLinks?.externalOutgoingLinks?.nodes,
        internalNodes: content?.outgoingLinks?.internalOutgoingLinks?.nodes
    };
    if (!$55debb7a67d5b98d$var$isValidOutgoingLinksResponse(content?.id, contentId, collections)) return $55debb7a67d5b98d$export$f1091f4b134fe3fc(contentId, 'unavailable');
    const { externalNodes: externalNodes, internalNodes: internalNodes } = collections;
    const hasMalformedExternalNode = externalNodes.some((node)=>typeof node?.url !== 'string' || node.url.length === 0);
    const hasMalformedInternalNode = internalNodes.some((node)=>{
        const base = node?.links?.base;
        const webui = node?.links?.webui;
        return !(typeof base === 'string' && base.length > 0 || typeof webui === 'string' && webui.length > 0);
    });
    if (hasMalformedExternalNode || hasMalformedInternalNode) return $55debb7a67d5b98d$export$f1091f4b134fe3fc(contentId, 'unavailable');
    const nonSelfInternalNodes = internalNodes.filter((node)=>node?.id !== contentId);
    if (externalNodes.length === 0 && nonSelfInternalNodes.length === 0) return $55debb7a67d5b98d$export$f1091f4b134fe3fc(contentId, 'empty');
    return $55debb7a67d5b98d$export$f1091f4b134fe3fc(contentId, 'present', $55debb7a67d5b98d$var$countDistinctDomains(externalNodes, nonSelfInternalNodes));
};
module.exports["createOutboundBylineSsrState"] = $55debb7a67d5b98d$export$f1091f4b134fe3fc;
module.exports["getReservedBylineIconCount"] = $55debb7a67d5b98d$export$e84841b18fa82831;
module.exports["normalizeOutboundBylineSsrState"] = $55debb7a67d5b98d$export$6a56c90936a4d835;

});

parcelRegister("jJhQa", function(module, exports) {

var $hDf5o = parcelRequire("hDf5o");


var $eyzEJ = parcelRequire("eyzEJ");


var $9pUdg = parcelRequire("9pUdg");


var $5b9Ab = parcelRequire("5b9Ab");

const $414ed69874d93138$export$391068ad89fee276 = 3;
const $414ed69874d93138$var$isUnconnectedSmartLink = (link)=>link.access !== 'granted';
const $414ed69874d93138$var$toIcon = (link, icon)=>{
    const product = (0, $hDf5o.formatLabel)(link.product);
    const isAppLogo = icon.kind === 'logo';
    return {
        // App logos collapse Jira / Jira Software and Atlas apps onto one chip.
        key: isAppLogo ? icon.key : product || icon.key,
        label: (isAppLogo ? (0, $eyzEJ.formatProduct)(link.product) : product) ?? icon.label ?? '',
        icon: icon
    };
};
const $414ed69874d93138$var$dedupeIcons = (icons)=>{
    const seenKeys = new Set();
    const dedupedIcons = [];
    for (const icon of icons)if (!seenKeys.has(icon.key)) {
        seenKeys.add(icon.key);
        dedupedIcons.push(icon);
    }
    return dedupedIcons;
};
const $414ed69874d93138$var$sortRankedIcons = (left, right)=>{
    if (left.isUnconnected !== right.isUnconnected) return Number(right.isUnconnected) - Number(left.isUnconnected);
    return left.occurrenceIndex - right.occurrenceIndex;
};
const $414ed69874d93138$export$a95e00393b41fca9 = (links, additionalIcons = [])=>{
    const rankedIcons = [];
    for (const link of links){
        const icon = (0, $9pUdg.getProductAppIcon)(link) ?? (0, $5b9Ab.getSmartLinkIcon)(link);
        if (!icon) continue;
        rankedIcons.push({
            icon: $414ed69874d93138$var$toIcon(link, icon),
            isUnconnected: $414ed69874d93138$var$isUnconnectedSmartLink(link),
            occurrenceIndex: link.occurrenceIndex
        });
    }
    rankedIcons.sort($414ed69874d93138$var$sortRankedIcons);
    const sortedIcons = [
        ...additionalIcons,
        ...rankedIcons.map(({ icon: icon })=>icon)
    ];
    return $414ed69874d93138$var$dedupeIcons(sortedIcons).slice(0, $414ed69874d93138$export$391068ad89fee276);
};
module.exports["MAX_BYLINE_CONNECTION_ICONS"] = $414ed69874d93138$export$391068ad89fee276;
module.exports["getBylineConnectionIcons"] = $414ed69874d93138$export$a95e00393b41fca9;

});

parcelRegister("hDf5o", function(module, exports) {
function $1f3713d3e01cb733$export$957d7daebd899f12(value) {
    if (!value || !Number.isNaN(Number(value))) return undefined;
    return value.replace(/([a-z])([A-Z])/g, '$1 $2').split(' ').map((word)=>word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
}
module.exports["formatLabel"] = $1f3713d3e01cb733$export$957d7daebd899f12;

});

parcelRegister("eyzEJ", function(module, exports) {

var $hDf5o = parcelRequire("hDf5o");


var $giSsj = parcelRequire("giSsj");

const $e6477f7a4fe60a65$export$dfedf783fc78a20b = (product)=>{
    if (!product) return undefined;
    if ((0, $giSsj.groupsUnderGoals)(product)) return 0, $giSsj.TOWNSQUARE_GROUP_LABEL;
    if (/^[A-Z]/.test(product)) return product;
    return (0, $hDf5o.formatLabel)(product) ?? product;
};
module.exports["formatProduct"] = $e6477f7a4fe60a65$export$dfedf783fc78a20b;

});

parcelRegister("giSsj", function(module, exports) {
/**
 * Internal platform codename ORS returns in `meta.product` for Atlas surfaces
 * (Projects, Goals, Focus). It is not a customer-facing product name.
 */ const $c0ba95e47527c98f$export$cd8157ef8480dd6e = 'townsquare';
const $c0ba95e47527c98f$export$7dcfe620b740d488 = 'Goals';
const $c0ba95e47527c98f$export$a2347c5c71d8b747 = (product)=>product?.toLowerCase().trim() === $c0ba95e47527c98f$export$cd8157ef8480dd6e;
/**
 * Atlas app names that can surface as the product itself — via `data.generator.name`
 * — when the response carries no `townsquare` `meta.product` (e.g. Focus links,
 * which resolve through mercury-object-provider without a product). They collapse
 * under the same "Goals" group as the codename, with the app shown per-row.
 */ const $c0ba95e47527c98f$var$ATLAS_APP_PRODUCTS = new Set([
    'focus',
    'goals',
    'projects'
]);
const $c0ba95e47527c98f$export$93f5f4f2e1b01303 = (product)=>{
    if ($c0ba95e47527c98f$export$a2347c5c71d8b747(product)) return true;
    const normalized = product?.toLowerCase().trim();
    return normalized != null && $c0ba95e47527c98f$var$ATLAS_APP_PRODUCTS.has(normalized);
};
module.exports["TOWNSQUARE_GROUP_LABEL"] = $c0ba95e47527c98f$export$7dcfe620b740d488;
module.exports["isTownsquareProduct"] = $c0ba95e47527c98f$export$a2347c5c71d8b747;
module.exports["groupsUnderGoals"] = $c0ba95e47527c98f$export$93f5f4f2e1b01303;

});

parcelRegister("9pUdg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fxqZn = parcelRequire("fxqZn");


var $hZx6a = parcelRequire("hZx6a");


var $5lkNm = parcelRequire("5lkNm");


var $5k2zo = parcelRequire("5k2zo");


var $ldJ1U = parcelRequire("ldJ1U");


var $lb2PL = parcelRequire("lb2PL");


var $8JGXU = parcelRequire("8JGXU");


var $eyzEJ = parcelRequire("eyzEJ");


var $giSsj = parcelRequire("giSsj");

const $7dfc51a40edbd36a$var$FIRST_PARTY_LOGOS = {
    bitbucket: (0, $fxqZn.BitbucketIcon),
    compass: (0, $hZx6a.CompassIcon),
    confluence: (0, $5lkNm.ConfluenceIcon),
    jira: (0, $ldJ1U.JiraIcon),
    loom: (0, $lb2PL.LoomIcon),
    trello: (0, $8JGXU.TrelloIcon)
};
const $7dfc51a40edbd36a$var$getAppIconId = (product)=>{
    if ((0, $giSsj.groupsUnderGoals)(product)) return 'goals';
    const key = product?.toLowerCase().trim();
    if (!key) return undefined;
    if (key === 'jira' || key.startsWith('jira ') || key.startsWith('jira-')) return 'jira';
    return $7dfc51a40edbd36a$var$FIRST_PARTY_LOGOS[key] ? key : undefined;
};
const $7dfc51a40edbd36a$export$86510ddd964a8ddd = (source)=>{
    const appIconId = $7dfc51a40edbd36a$var$getAppIconId(source.product);
    if (!appIconId) return undefined;
    const Logo = appIconId === 'goals' ? (0, $5k2zo.GoalsIcon) : $7dfc51a40edbd36a$var$FIRST_PARTY_LOGOS[appIconId];
    if (!Logo) return undefined;
    return {
        node: (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Logo, {
            appearance: 'brand',
            size: 'xxsmall',
            testId: `${appIconId}-app-icon`
        }),
        key: `product:${appIconId}`,
        label: (0, $eyzEJ.formatProduct)(source.product) ?? source.product,
        kind: 'logo'
    };
};
module.exports["getProductAppIcon"] = $7dfc51a40edbd36a$export$86510ddd964a8ddd;

});

parcelRegister("fxqZn", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $d28d5aedb34440f3$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582"/>
</svg>
`;
const $d28d5aedb34440f3$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z"/>
</svg>
`;
const $d28d5aedb34440f3$export$5fc1066e677788d4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BitbucketIcon(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { iconColor: iconColor, size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Bitbucket" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== iconColor || $[2] !== label || $[3] !== size || $[4] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $d28d5aedb34440f3$var$svg,
            customThemeSvg: $d28d5aedb34440f3$var$customThemeSvg,
            iconColor: iconColor,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = iconColor;
        $[2] = label;
        $[3] = size;
        $[4] = testId;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function BitbucketIcon({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Bitbucket', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $d28d5aedb34440f3$var$svg,
        customThemeSvg: $d28d5aedb34440f3$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["BitbucketIcon"] = $d28d5aedb34440f3$export$5fc1066e677788d4;

});

parcelRegister("aR3ec", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $1f4e40c711db0c72$var$styles = {
    root: "_3iDTPbvbI6",
    TEMP_assets: "_0C0F9q1qiM"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$cloudLightAppearanceMap = {
    brand: "_36J4jyyL8i _0C0F9qyL8i",
    neutral: "_36J4jyBRVV _0C0F9q1qiM",
    inverse: "_36J4jyCl79 _0C0F9qt28M",
    legacy: "_36J4jyt28M _0C0F9q2bHZ"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$cloudDarkAppearanceMap = {
    brand: "_36J4jyyL8i _0C0F9qyL8i",
    neutral: "_36J4jynrF4 _0C0F9qMlgR",
    inverse: "_36J4jyt28M _0C0F9qCl79",
    legacy: "_36J4jyt28M _0C0F9q2bHZ"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$dataCenterLightAppearanceMap = {
    brand: "_36J4jy2bHZ _0C0F9qt28M _0g0wFM1qiM",
    neutral: "_36J4jyBRVV _0C0F9q1qiM _0g0wFMBRVV",
    inverse: "_36J4jyt28M _0C0F9qRvDB _0g0wFMt28M",
    legacy: "_36J4jy2bHZ _0C0F9qt28M _0g0wFM1qiM"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$dataCenterDarkAppearanceMap = {
    brand: "_36J4jy2bHZ _0C0F9qRvDB _0g0wFMMlgR",
    neutral: "_36J4jynrF4 _0C0F9qMlgR _0g0wFMnrF4",
    inverse: "_36J4jyMmzW _0C0F9qt28M _0g0wFMMmzW",
    legacy: "_36J4jy2bHZ _0C0F9qRvDB _0g0wFMMlgR"
};
const $1f4e40c711db0c72$var$rovoDarkAppearanceMap = {
    brand: "_2PY8Z6yL8i _05MzPYyL8i _0Yajk0yL8i _40KAGSyL8i",
    neutral: "_2PY8Z6nrF4 _05MzPYnrF4 _0Yajk0nrF4 _40KAGSnrF4",
    inverse: "_2PY8Z6RvDB _05MzPYRvDB _0Yajk0RvDB _40KAGSRvDB",
    legacy: "_2PY8Z62bHZ _05MzPY2bHZ _0Yajk02bHZ _40KAGS2bHZ"
};
const $1f4e40c711db0c72$var$rovoLightAppearanceMap = {
    brand: "_2PY8Z6yL8i _05MzPYyL8i _0Yajk0yL8i _40KAGSyL8i",
    neutral: "_2PY8Z6BRVV _05MzPYBRVV _0Yajk0BRVV _40KAGSBRVV",
    inverse: "_2PY8Z6t28M _05MzPYt28M _0Yajk0t28M _40KAGSt28M",
    legacy: "_2PY8Z62bHZ _05MzPY2bHZ _0Yajk02bHZ _40KAGS2bHZ"
}; /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$sizeMap = {
    xxsmall: "_0jFU0Vey7F",
    xsmall: "_0jFU0VSPN1",
    small: "_0jFU0VoWWg",
    medium: "_0jFU0VUofl",
    large: "_0jFU0VUF4f",
    xlarge: "_0jFU0VpJKa",
    '12': "_0jFU0VxpxF",
    '16': "_0jFU0Vey7F",
    '20': "_0jFU0VSPN1",
    '24': "_0jFU0VoWWg",
    '32': "_0jFU0VUofl"
};
const $1f4e40c711db0c72$export$be58b4326e23250f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IconWrapper(t0) {
    const $ = (0, $bDgLe.c)(18);
    const { size: t1, label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: t2, iconColor: customIconColor, isAssets: t3, type: t4 } = t0;
    const size = t1 === undefined ? "20" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const isAssets = t3 === undefined ? false : t3;
    const type = t4 === undefined ? "tile" : t4;
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const t5 = customIconColor || "initial";
    let t6;
    if ($[0] !== t5) {
        t6 = {
            "--themed-icon-color": t5
        };
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const t7 = t6;
    const t8 = label ? label : undefined;
    const t9 = label ? "img" : undefined;
    const t10 = label === "" ? true : undefined;
    const t11 = isCustomThemed ? customThemeSvg : svg;
    let t12;
    if ($[2] !== t11) {
        t12 = {
            __html: t11
        };
        $[2] = t11;
        $[3] = t12;
    } else t12 = $[3];
    const t13 = $1f4e40c711db0c72$var$sizeMap[size];
    const t14 = colorMode === "dark" ? $1f4e40c711db0c72$var$dataCenterDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$dataCenterLightAppearanceMap[appearance];
    const t15 = type === "rovo" ? colorMode === "dark" ? $1f4e40c711db0c72$var$rovoDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$rovoLightAppearanceMap[appearance] : colorMode === "dark" ? $1f4e40c711db0c72$var$cloudDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$cloudLightAppearanceMap[appearance];
    let t16;
    if ($[4] !== appearance || $[5] !== isAssets || $[6] !== t13 || $[7] !== t14 || $[8] !== t15) {
        t16 = (0, $hekY6.default)([
            $1f4e40c711db0c72$var$styles.root,
            t13,
            t14,
            t15,
            isAssets && appearance === "brand" && ((0, $iDrrr.fg)("assets-platform-branding") || (0, $iDrrr.fg)("assets-platform-branding-v2")) && $1f4e40c711db0c72$var$styles.TEMP_assets
        ]);
        $[4] = appearance;
        $[5] = isAssets;
        $[6] = t13;
        $[7] = t14;
        $[8] = t15;
        $[9] = t16;
    } else t16 = $[9];
    let t17;
    if ($[10] !== t10 || $[11] !== t12 || $[12] !== t16 || $[13] !== t7 || $[14] !== t8 || $[15] !== t9 || $[16] !== testId) {
        t17 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "data-testid": testId,
            style: t7,
            "aria-label": t8,
            role: t9,
            "aria-hidden": t10,
            dangerouslySetInnerHTML: t12,
            className: t16
        });
        $[10] = t10;
        $[11] = t12;
        $[12] = t16;
        $[13] = t7;
        $[14] = t8;
        $[15] = t9;
        $[16] = testId;
        $[17] = t17;
    } else t17 = $[17];
    return t17;
} : function IconWrapper({ size: size = '20', label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: appearance = 'brand', iconColor: customIconColor, isAssets: isAssets = false, type: type = 'tile' }) {
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $hekY6.default)([
            $1f4e40c711db0c72$var$styles.root,
            $1f4e40c711db0c72$var$sizeMap[size],
            colorMode === 'dark' ? $1f4e40c711db0c72$var$dataCenterDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $1f4e40c711db0c72$var$rovoDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $1f4e40c711db0c72$var$cloudDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $iDrrr.fg)('assets-platform-branding') || (0, $iDrrr.fg)('assets-platform-branding-v2')) && $1f4e40c711db0c72$var$styles.TEMP_assets
        ])
    });
};
module.exports["IconWrapper"] = $1f4e40c711db0c72$export$be58b4326e23250f;

});

parcelRegister("hZx6a", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $08074ca1ab8ce06c$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z"/>
</svg>
`;
const $08074ca1ab8ce06c$export$f7857fe64d7161d9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CompassIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Compass" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $08074ca1ab8ce06c$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function CompassIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Compass', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $08074ca1ab8ce06c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["CompassIcon"] = $08074ca1ab8ce06c$export$f7857fe64d7161d9;

});

parcelRegister("5k2zo", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $ad20b5467f7f9ada$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0" clip-rule="evenodd"/>
</svg>
`;
const $ad20b5467f7f9ada$export$9eb74917ea768ed4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GoalsIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Goals" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $ad20b5467f7f9ada$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function GoalsIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Goals', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $ad20b5467f7f9ada$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["GoalsIcon"] = $ad20b5467f7f9ada$export$9eb74917ea768ed4;

});

parcelRegister("lb2PL", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $c420f5a156d6b7cf$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302"/>
</svg>
`;
const $c420f5a156d6b7cf$export$8d789f76fde3e05 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LoomIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Loom" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $c420f5a156d6b7cf$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function LoomIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Loom', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $c420f5a156d6b7cf$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["LoomIcon"] = $c420f5a156d6b7cf$export$8d789f76fde3e05;

});

parcelRegister("8JGXU", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $24d0e9af25866402$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1558bc)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z"/>
</svg>
`;
const $24d0e9af25866402$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z"/>
</svg>
`;
const $24d0e9af25866402$export$4384da9b8b140bf4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TrelloIcon(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { iconColor: iconColor, size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Trello" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== iconColor || $[2] !== label || $[3] !== size || $[4] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $24d0e9af25866402$var$svg,
            customThemeSvg: $24d0e9af25866402$var$customThemeSvg,
            iconColor: iconColor,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = iconColor;
        $[2] = label;
        $[3] = size;
        $[4] = testId;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function TrelloIcon({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Trello', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $24d0e9af25866402$var$svg,
        customThemeSvg: $24d0e9af25866402$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["TrelloIcon"] = $24d0e9af25866402$export$4384da9b8b140bf4;

});

parcelRegister("5b9Ab", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kTb7m = parcelRequire("kTb7m");


var $3Xkfu = parcelRequire("3Xkfu");


var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");

const $8753b7baffe8fa69$var$getUrlOrigin = (url)=>{
    try {
        return new URL(url).origin;
    } catch  {
        return url;
    }
};
const $8753b7baffe8fa69$var$isUrlLabelTuple = (icon)=>Array.isArray(icon) && typeof icon[0] === 'string';
const $8753b7baffe8fa69$var$normalizeInlineIcon = (source, inlineIcon, label)=>{
    if (typeof inlineIcon === 'string') return {
        src: inlineIcon,
        key: `url:${$8753b7baffe8fa69$var$getUrlOrigin(source.url)}:${inlineIcon}`,
        label: label,
        kind: 'image'
    };
    // Link extractors returns [url, label] for entity icons behind platform_lp_use_entity_icon_url_for_icon.
    if ($8753b7baffe8fa69$var$isUrlLabelTuple(inlineIcon)) {
        const [iconUrl, iconLabel] = inlineIcon;
        return {
            src: iconUrl,
            key: `url:${$8753b7baffe8fa69$var$getUrlOrigin(source.url)}:${iconUrl}`,
            label: iconLabel ?? label,
            kind: 'image'
        };
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(inlineIcon)) return {
        node: inlineIcon,
        key: `node:${source.product ?? $8753b7baffe8fa69$var$getUrlOrigin(source.url)}:${source.ari ?? source.occurrenceIndex}`,
        label: label ?? source.product,
        kind: 'element'
    };
    return undefined;
};
// extractSmartLinkInlineIcon throws on malformed JSON-LD (e.g. a string `generator`, or an entity
// `meta.generator` missing name/icon). Fall back to a neutral link icon so one bad response doesn't
// break icon building for the whole byline — mirrors the failed-image fallback in SmartLinkIconRenderer.
const $8753b7baffe8fa69$var$createFallbackIcon = (source)=>({
        node: (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
            label: '',
            color: "var(--ds-icon-subtle, #505258)"
        }),
        key: `fallback:${$8753b7baffe8fa69$var$getUrlOrigin(source.url)}:${source.ari ?? source.occurrenceIndex}`,
        label: source.product,
        kind: 'element'
    });
const $8753b7baffe8fa69$export$d1801a90e60dadcf = (url, source)=>$8753b7baffe8fa69$var$normalizeInlineIcon(source, url, source.product);
const $8753b7baffe8fa69$export$35040aed9264b11c = (response, source)=>{
    let inlineIcon;
    try {
        inlineIcon = (0, $3Xkfu.extractSmartLinkInlineIcon)(response ?? undefined, false);
    } catch (err) {
        const errorObj = err instanceof Error ? err : new Error(String(err));
        (0, $5ZqQS.getMonitoringClient)().submitError(errorObj, {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS
        });
        return $8753b7baffe8fa69$var$createFallbackIcon(source);
    }
    return $8753b7baffe8fa69$var$normalizeInlineIcon(source, inlineIcon, source.product);
};
const $8753b7baffe8fa69$export$1d1e77a71ad0be9f = (link)=>{
    // Keep iconUrl as a compatibility fallback for EnhancedSmartLink objects built before icon normalization.
    return link.icon ?? (link.iconUrl ? $8753b7baffe8fa69$var$normalizeInlineIcon(link, link.iconUrl, link.product) : undefined);
};
module.exports["buildImageIcon"] = $8753b7baffe8fa69$export$d1801a90e60dadcf;
module.exports["extractSmartLinkIcon"] = $8753b7baffe8fa69$export$35040aed9264b11c;
module.exports["getSmartLinkIcon"] = $8753b7baffe8fa69$export$1d1e77a71ad0be9f;

});

parcelRegister("3Xkfu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kkFbH = parcelRequire("kkFbH");


var $fBqzD = parcelRequire("fBqzD");


var $iMQz5 = parcelRequire("iMQz5");


var $fHe6f = parcelRequire("fHe6f");


var $ahlZa = parcelRequire("ahlZa");


var $3CYX0 = parcelRequire("3CYX0");


var $39Mwn = parcelRequire("39Mwn");


var $6MsAF = parcelRequire("6MsAF");


var $38zdI = parcelRequire("38zdI");


var $cVpj0 = parcelRequire("cVpj0");


var $gITbz = parcelRequire("gITbz");


var $bvjEB = parcelRequire("bvjEB");


var $jMFOf = parcelRequire("jMFOf");


var $a5G9M = parcelRequire("a5G9M");


var $S7fVP = parcelRequire("S7fVP");


var $iDrrr = parcelRequire("iDrrr");


var $hhrxw = parcelRequire("hhrxw");


var $kku4L = parcelRequire("kku4L");


var $g0csk = parcelRequire("g0csk");


var $2A177 = parcelRequire("2A177");


var $jqhMF = parcelRequire("jqhMF");


var $2GG3F = parcelRequire("2GG3F");


var $jrSlu = parcelRequire("jrSlu");


var $c1Kdq = parcelRequire("c1Kdq");


var $kAdyG = parcelRequire("kAdyG");

const $f1ce3764841d3d06$var$extractorPriorityMap = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};
const $f1ce3764841d3d06$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $f1ce3764841d3d06$var$getEmptyJsonLd = ()=>$f1ce3764841d3d06$var$emptyData;
const $f1ce3764841d3d06$var$prioritiseIcon = ({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon })=>urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
const $f1ce3764841d3d06$var$extractTaskType = (jsonLd)=>{
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $2GG3F.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};
const $f1ce3764841d3d06$var$extractFileFormat = (jsonLd)=>jsonLd['schema:fileFormat'];
const $f1ce3764841d3d06$var$documentLabel = (opts, label)=>{
    if (!opts.showIconLabel) return '';
    return (0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? label : opts.title || label;
};

const $f1ce3764841d3d06$var$getBlogIconWrapped = ()=>(parcelRequire("6kJW0")).default;

const $f1ce3764841d3d06$var$getDocumentIcon = ()=>(parcelRequire("9v3GN")).default;

const $f1ce3764841d3d06$var$getFileIcon = ()=>(parcelRequire("4Emmj")).default;

const $f1ce3764841d3d06$var$getLiveDocumentIconWrapped = ()=>(parcelRequire("dGdE6")).default;

const $f1ce3764841d3d06$var$getPresentationIcon = ()=>(parcelRequire("b5Dss")).default;

const $f1ce3764841d3d06$var$getSpreadsheetIcon = ()=>(parcelRequire("7vzLW")).default;
const $f1ce3764841d3d06$var$digitalDocumentToIcon = (opts)=>{
    if (opts.provider?.id && (0, $c1Kdq.isConfluenceGenerator)(opts.provider.id)) {
        const LiveDocumentIconWrapped = $f1ce3764841d3d06$var$getLiveDocumentIconWrapped();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LiveDocumentIconWrapped, {
            label: $f1ce3764841d3d06$var$documentLabel(opts, 'live document'),
            testId: "live-doc-icon"
        });
    }
    const FileIcon = $f1ce3764841d3d06$var$getFileIcon();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(FileIcon, {
        label: $f1ce3764841d3d06$var$documentLabel(opts, 'file'),
        testId: "file-icon"
    });
};
const $f1ce3764841d3d06$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            {
                const BlogIconWrapped = $f1ce3764841d3d06$var$getBlogIconWrapped();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BlogIconWrapped, {
                    label: $f1ce3764841d3d06$var$documentLabel(opts, 'blog'),
                    testId: "blog-icon"
                });
            }
        case 'schema:DigitalDocument':
            return $f1ce3764841d3d06$var$digitalDocumentToIcon(opts);
        case 'schema:TextDigitalDocument':
            {
                const DocumentIcon = $f1ce3764841d3d06$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DocumentIcon, {
                    label: $f1ce3764841d3d06$var$documentLabel(opts, 'document'),
                    testId: "document-icon"
                });
            }
        case 'schema:PresentationDigitalDocument':
            {
                const PresentationIcon = $f1ce3764841d3d06$var$getPresentationIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PresentationIcon, {
                    label: $f1ce3764841d3d06$var$documentLabel(opts, 'presentation'),
                    testId: "presentation-icon"
                });
            }
        case 'schema:SpreadsheetDigitalDocument':
            {
                const SpreadsheetIcon = $f1ce3764841d3d06$var$getSpreadsheetIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SpreadsheetIcon, {
                    label: $f1ce3764841d3d06$var$documentLabel(opts, 'spreadsheet'),
                    testId: "spreadsheet-icon"
                });
            }
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), {
                color: "currentColor",
                label: $f1ce3764841d3d06$var$documentLabel(opts, 'template'),
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            {
                const DocumentIcon = $f1ce3764841d3d06$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DocumentIcon, {
                    label: $f1ce3764841d3d06$var$documentLabel(opts, 'document'),
                    testId: "document-icon"
                });
            }
    }
};
const $f1ce3764841d3d06$var$extractIconFromDocument = (type, opts)=>{
    const iconFromType = $f1ce3764841d3d06$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $jrSlu.getIconForFileType)(opts.fileFormat, (0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? opts.showIconLabel : undefined) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return $f1ce3764841d3d06$var$prioritiseIcon({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $f1ce3764841d3d06$var$extractIconFromTask = (opts)=>{
    const { taskType: taskType, provider: provider } = opts;
    const legacyTaskLabel = opts.title || 'task';
    const getLabel = (semantic)=>(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? semantic : legacyTaskLabel;
    const defaultIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5G9M.default), {
        label: getLabel('Task'),
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $hhrxw.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $hhrxw.JIRA_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5G9M.default), {
                    label: getLabel('Task'),
                    testId: "jira-task-icon"
                });
            case 0, $hhrxw.JIRA_SUB_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jMFOf.default), {
                    label: getLabel('Sub-task'),
                    testId: "jira-subtask-icon"
                });
            case 0, $hhrxw.JIRA_STORY:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bvjEB.default), {
                    label: getLabel('Story'),
                    testId: "jira-story-icon"
                });
            case 0, $hhrxw.JIRA_BUG:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fHe6f.default), {
                    label: getLabel('Bug'),
                    testId: "jira-bug-icon"
                });
            case 0, $hhrxw.JIRA_EPIC:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6MsAF.default), {
                    label: getLabel('Epic'),
                    testId: "jira-epic-icon"
                });
            case 0, $hhrxw.JIRA_INCIDENT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38zdI.default), {
                    label: getLabel('Incident'),
                    testId: "jira-incident-icon"
                });
            case 0, $hhrxw.JIRA_SERVICE_REQUEST:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $S7fVP.default), {
                    label: getLabel('Service request'),
                    testId: "jira-service-request-icon"
                });
            case 0, $hhrxw.JIRA_CHANGE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ahlZa.default), {
                    label: getLabel('Change'),
                    testId: "jira-change-icon"
                });
            case 0, $hhrxw.JIRA_PROBLEM:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cVpj0.default), {
                    label: getLabel('Problem'),
                    testId: "jira-problem-icon"
                });
            case 0, $hhrxw.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};
const $f1ce3764841d3d06$var$typeToIcon = (type, opts)=>{
    const getLabel = (title)=>(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? title : opts.title || title;
    switch(type){
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39Mwn.default), {
                label: getLabel('commit'),
                testId: "commit-icon"
            });
        case 'atlassian:Project':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBqzD))), {
                label: getLabel('project'),
                testId: "project-icon",
                color: "currentColor"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gITbz.default), {
                label: getLabel('pull request'),
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMQz5.default), {
                label: getLabel('reference'),
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3CYX0.default), {
                label: getLabel('repository'),
                testId: "repo-icon"
            });
        case 'atlassian:Goal':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5G9M.default), {
                label: getLabel('goal'),
                testId: "task-icon"
            });
        case 'atlassian:Task':
            return $f1ce3764841d3d06$var$extractIconFromTask(opts);
        default:
            return undefined;
    }
};
const $f1ce3764841d3d06$var$standardisedExtractIcon = (type, opts)=>{
    const iconFromType = $f1ce3764841d3d06$var$typeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $jrSlu.getIconForFileType)(opts.fileFormat, (0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? opts.showIconLabel : undefined) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return $f1ce3764841d3d06$var$prioritiseIcon({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $f1ce3764841d3d06$var$extractIconByType = (type, opts)=>{
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return $f1ce3764841d3d06$var$extractIconFromDocument(type, opts);
        default:
            return type ? $f1ce3764841d3d06$var$standardisedExtractIcon(type, opts) : undefined;
    }
};
const $f1ce3764841d3d06$var$extractIcon = (jsonLd, priority = 'type', showIconLabel = true)=>{
    const type = jsonLd['@type'];
    const opts = {
        ...(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? {} : {
            title: (0, $jqhMF.extractTitle)(jsonLd)
        },
        provider: (0, $2A177.extractProvider)(jsonLd),
        fileFormat: $f1ce3764841d3d06$var$extractFileFormat(jsonLd),
        taskType: $f1ce3764841d3d06$var$extractTaskType(jsonLd),
        icon: jsonLd.icon && (0, $2GG3F.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority,
        showIconLabel: showIconLabel
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>$f1ce3764841d3d06$var$extractorPriorityMap[b] - $f1ce3764841d3d06$var$extractorPriorityMap[a])[0];
        return $f1ce3764841d3d06$var$extractIconByType(highestPriorityType, opts);
    } else return $f1ce3764841d3d06$var$extractIconByType(type, opts);
};
const $f1ce3764841d3d06$var$extractInlineIcon = (jsonLd, showIconLabel = true)=>{
    const provider = (0, $2A177.extractProvider)(jsonLd);
    if (provider && provider.id) {
        if (provider.id === (0, $hhrxw.CONFLUENCE_GENERATOR_ID) || provider.id === (0, $hhrxw.JIRA_GENERATOR_ID)) return $f1ce3764841d3d06$var$extractIcon(jsonLd, 'type', showIconLabel);
    }
    return $f1ce3764841d3d06$var$extractIcon(jsonLd, 'provider', showIconLabel);
};
const $f1ce3764841d3d06$export$643db2ee2409e635 = (response, showLabel = true)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) {
        const entityIcon = (0, $kku4L.extractEntityIcon)(response);
        if (entityIcon) return [
            entityIcon.url,
            entityIcon.label
        ];
        const provider = (0, $g0csk.extractEntityProvider)(response);
        if (provider) return provider.icon;
    }
    return $f1ce3764841d3d06$var$extractInlineIcon(response?.data || $f1ce3764841d3d06$var$getEmptyJsonLd(), showLabel);
};
module.exports["extractSmartLinkInlineIcon"] = $f1ce3764841d3d06$export$643db2ee2409e635;

});

parcelRegister("iMQz5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $gIfnJ = parcelRequire("gIfnJ");


var $4hmAW = parcelRequire("4hmAW");

const $6e22e7dea691eafe$var$BranchObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BranchObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Branch" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function BranchObject({ label: label = 'Branch', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $6e22e7dea691eafe$export$2e2bcd8739ae039 = $6e22e7dea691eafe$var$BranchObject;
module.exports["default"] = $6e22e7dea691eafe$export$2e2bcd8739ae039;

});

parcelRegister("fHe6f", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6spAz = parcelRequire("6spAz");


var $4hmAW = parcelRequire("4hmAW");

const $344e992330cc90e5$var$BugObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BugObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Bug" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function BugObject({ label: label = 'Bug', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $344e992330cc90e5$export$2e2bcd8739ae039 = $344e992330cc90e5$var$BugObject;
module.exports["default"] = $344e992330cc90e5$export$2e2bcd8739ae039;

});

parcelRegister("ahlZa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lCTy3 = parcelRequire("lCTy3");


var $4hmAW = parcelRequire("4hmAW");

const $4e5aedb3fb5b2488$var$ChangesObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ChangesObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Changes" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
            color: "var(--ds-icon-accent-yellow, #B38600)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function ChangesObject({ label: label = 'Changes', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
};
var $4e5aedb3fb5b2488$export$2e2bcd8739ae039 = $4e5aedb3fb5b2488$var$ChangesObject;
module.exports["default"] = $4e5aedb3fb5b2488$export$2e2bcd8739ae039;

});

parcelRegister("3CYX0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6YkHb = parcelRequire("6YkHb");


var $4hmAW = parcelRequire("4hmAW");

const $ff9912959f94fce6$var$CodeObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CodeObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Code" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function CodeObject({ label: label = 'Code', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $ff9912959f94fce6$export$2e2bcd8739ae039 = $ff9912959f94fce6$var$CodeObject;
module.exports["default"] = $ff9912959f94fce6$export$2e2bcd8739ae039;

});

parcelRegister("39Mwn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lepke = parcelRequire("lepke");


var $4hmAW = parcelRequire("4hmAW");

const $29a7acb65f94e0ba$var$CommitObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CommitObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Commit" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
            color: "var(--ds-icon-accent-yellow, #B38600)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function CommitObject({ label: label = 'Commit', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
};
var $29a7acb65f94e0ba$export$2e2bcd8739ae039 = $29a7acb65f94e0ba$var$CommitObject;
module.exports["default"] = $29a7acb65f94e0ba$export$2e2bcd8739ae039;

});

parcelRegister("6MsAF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $7vAVv = parcelRequire("7vAVv");


var $4hmAW = parcelRequire("4hmAW");

const $caa0390e0439cdc5$var$EpicObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function EpicObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Epic" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function EpicObject({ label: label = 'Epic', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $caa0390e0439cdc5$export$2e2bcd8739ae039 = $caa0390e0439cdc5$var$EpicObject;
module.exports["default"] = $caa0390e0439cdc5$export$2e2bcd8739ae039;

});

parcelRegister("38zdI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $ipvL3 = parcelRequire("ipvL3");


var $4hmAW = parcelRequire("4hmAW");

const $021e642953ecdf56$var$IncidentObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IncidentObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Incident" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function IncidentObject({ label: label = 'Incident', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $021e642953ecdf56$export$2e2bcd8739ae039 = $021e642953ecdf56$var$IncidentObject;
module.exports["default"] = $021e642953ecdf56$export$2e2bcd8739ae039;

});

parcelRegister("cVpj0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $7EFpK = parcelRequire("7EFpK");


var $4hmAW = parcelRequire("4hmAW");

const $c45be7d7373a5bd1$var$ProblemObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProblemObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Problem" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function ProblemObject({ label: label = 'Problem', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $c45be7d7373a5bd1$export$2e2bcd8739ae039 = $c45be7d7373a5bd1$var$ProblemObject;
module.exports["default"] = $c45be7d7373a5bd1$export$2e2bcd8739ae039;

});

parcelRegister("gITbz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hQhpy = parcelRequire("hQhpy");


var $4hmAW = parcelRequire("4hmAW");

const $d9b76c60fcca1e74$var$PullRequestObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PullRequestObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Pull Request" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
            color: "var(--ds-icon-accent-green, #22A06B)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PullRequestObject({ label: label = 'Pull Request', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
};
var $d9b76c60fcca1e74$export$2e2bcd8739ae039 = $d9b76c60fcca1e74$var$PullRequestObject;
module.exports["default"] = $d9b76c60fcca1e74$export$2e2bcd8739ae039;

});

parcelRegister("bvjEB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $jrU5N = parcelRequire("jrU5N");


var $4hmAW = parcelRequire("4hmAW");

const $1e23ddd70a37a65a$var$StoryObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function StoryObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Story" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
            color: "var(--ds-icon-accent-green, #22A06B)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function StoryObject({ label: label = 'Story', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
};
var $1e23ddd70a37a65a$export$2e2bcd8739ae039 = $1e23ddd70a37a65a$var$StoryObject;
module.exports["default"] = $1e23ddd70a37a65a$export$2e2bcd8739ae039;

});

parcelRegister("jMFOf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lSw2p = parcelRequire("lSw2p");


var $4hmAW = parcelRequire("4hmAW");

const $08adce465a629da4$var$SubtaskObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SubtaskObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Subtask" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function SubtaskObject({ label: label = 'Subtask', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $08adce465a629da4$export$2e2bcd8739ae039 = $08adce465a629da4$var$SubtaskObject;
module.exports["default"] = $08adce465a629da4$export$2e2bcd8739ae039;

});

parcelRegister("a5G9M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iAaYd = parcelRequire("iAaYd");


var $4hmAW = parcelRequire("4hmAW");

const $dcf12dc0efc2d892$var$TaskObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TaskObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Task" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function TaskObject({ label: label = 'Task', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $dcf12dc0efc2d892$export$2e2bcd8739ae039 = $dcf12dc0efc2d892$var$TaskObject;
module.exports["default"] = $dcf12dc0efc2d892$export$2e2bcd8739ae039;

});

parcelRegister("S7fVP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iRFKG = parcelRequire("iRFKG");


var $4hmAW = parcelRequire("4hmAW");

const $ae65607ca2739f04$var$WorkItemObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WorkItemObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Work Item" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function WorkItemObject({ label: label = 'Work Item', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $ae65607ca2739f04$export$2e2bcd8739ae039 = $ae65607ca2739f04$var$WorkItemObject;
module.exports["default"] = $ae65607ca2739f04$export$2e2bcd8739ae039;

});

parcelRegister("jrSlu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $iDrrr = parcelRequire("iDrrr");


var $hhrxw = parcelRequire("hhrxw");


var $l8WFq = parcelRequire("l8WFq");























const $73d439951cf388f8$var$getLazyIcons = ()=>({
        [(0, $hhrxw.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("9v3GN")))
        },
        [(0, $hhrxw.IconType).Audio]: {
            default: ()=>(parcelRequire("kPWC0"))
        },
        [(0, $hhrxw.IconType).Code]: {
            default: ()=>(parcelRequire("7nVQ2"))
        },
        [(0, $hhrxw.IconType).File]: {
            default: ()=>Promise.resolve((parcelRequire("4Emmj")))
        },
        [(0, $hhrxw.IconType).Folder]: {
            default: ()=>(parcelRequire("9VLzs"))
        },
        [(0, $hhrxw.IconType).Generic]: {
            default: ()=>Promise.resolve((parcelRequire("4Emmj")))
        },
        [(0, $hhrxw.IconType).Image]: {
            default: ()=>(parcelRequire("j9LJx"))
        },
        [(0, $hhrxw.IconType).Presentation]: {
            default: ()=>Promise.resolve((parcelRequire("b5Dss")))
        },
        [(0, $hhrxw.IconType).Spreadsheet]: {
            default: ()=>Promise.resolve((parcelRequire("7vzLW")))
        },
        [(0, $hhrxw.IconType).Video]: {
            default: ()=>(parcelRequire("96zb4"))
        },
        [(0, $hhrxw.IconType).Archive]: {
            default: ()=>(parcelRequire("8KvsV"))
        },
        [(0, $hhrxw.IconType).Executable]: {
            default: ()=>(parcelRequire("kKj89"))
        },
        [(0, $hhrxw.IconType).GIF]: {
            default: ()=>(parcelRequire("1N5Ke"))
        },
        [(0, $hhrxw.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("7KlQ2"))
        },
        [(0, $hhrxw.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("4D6tQ"))
        },
        [(0, $hhrxw.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("30pMN"))
        },
        [(0, $hhrxw.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("hbVly"))
        },
        [(0, $hhrxw.IconType).MSExcel]: {
            default: ()=>(parcelRequire("5eRas"))
        },
        [(0, $hhrxw.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("bmQsw"))
        },
        [(0, $hhrxw.IconType).MSWord]: {
            default: ()=>(parcelRequire("3tCrI"))
        },
        [(0, $hhrxw.IconType).PDF]: {
            default: ()=>(parcelRequire("eiZGU"))
        },
        [(0, $hhrxw.IconType).Sketch]: {
            default: ()=>(parcelRequire("ldRXm"))
        }
    });
const $73d439951cf388f8$var$getTypeToIconMap = (fileFormat)=>{
    const iconDescriptor = (0, $l8WFq.default)(fileFormat);
    if (!iconDescriptor?.icon) return null;
    const lazyIcons = $73d439951cf388f8$var$getLazyIcons();
    if ((0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y')) return [
        lazyIcons[iconDescriptor.icon]?.default,
        iconDescriptor.label ?? ''
    ];
    return [
        lazyIcons[iconDescriptor.icon]?.default
    ];
};
const $73d439951cf388f8$export$4d685c85ebc7a1e3 = (fileMimeType, showIconLabel)=>{
    if (!fileMimeType) return;
    const icon = $73d439951cf388f8$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "hbd6r",
        name: "Icon",
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    });
    if ((0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y')) {
        const descriptorLabel = icon[1] || '';
        const label = showIconLabel ?? true ? descriptorLabel : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            testId: "document-file-format-icon",
            label: label
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        testId: "document-file-format-icon"
    });
};
module.exports["getIconForFileType"] = $73d439951cf388f8$export$4d685c85ebc7a1e3;

});

parcelRegister("l8WFq", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $hhrxw = parcelRequire("hhrxw");

const $eb169b73453c71b7$var$extractFileFormatIcon = (fileFormat)=>{
    const getIconDescriptor = (icon, label)=>(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? {
            icon: icon,
            label: label
        } : {
            icon: icon
        };
    switch(fileFormat){
        case 'folder':
            return getIconDescriptor((0, $hhrxw.IconType).Folder, 'folder');
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return getIconDescriptor((0, $hhrxw.IconType).Document, 'document');
        case 'application/pdf':
            return getIconDescriptor((0, $hhrxw.IconType).PDF, 'pdf');
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return getIconDescriptor((0, $hhrxw.IconType).Presentation, 'presentation');
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return getIconDescriptor((0, $hhrxw.IconType).Spreadsheet, 'spreadsheet');
        case 'application/vnd.google-apps.document':
            return getIconDescriptor((0, $hhrxw.IconType).GoogleDocs, 'google document');
        case 'application/vnd.google-apps.form':
            return getIconDescriptor((0, $hhrxw.IconType).GoogleForms, 'google form');
        case 'application/vnd.google-apps.spreadsheet':
            return getIconDescriptor((0, $hhrxw.IconType).GoogleSheets, 'google sheet');
        case 'application/vnd.google-apps.presentation':
            return getIconDescriptor((0, $hhrxw.IconType).GoogleSlides, 'google slide');
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return getIconDescriptor((0, $hhrxw.IconType).MSExcel, 'excel spreadsheet');
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return getIconDescriptor((0, $hhrxw.IconType).MSPowerpoint, 'powerpoint');
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return getIconDescriptor((0, $hhrxw.IconType).MSWord, 'word document');
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return getIconDescriptor((0, $hhrxw.IconType).Image, 'image');
        case 'image/gif':
            return getIconDescriptor((0, $hhrxw.IconType).GIF, 'gif');
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return getIconDescriptor((0, $hhrxw.IconType).Audio, 'audio');
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return getIconDescriptor((0, $hhrxw.IconType).Video, 'video');
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return getIconDescriptor((0, $hhrxw.IconType).Code, 'code');
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return getIconDescriptor((0, $hhrxw.IconType).Archive, 'archive');
        case 'application/dmg':
            return getIconDescriptor((0, $hhrxw.IconType).Executable, 'disk image');
        case 'application/sketch':
            return getIconDescriptor((0, $hhrxw.IconType).Sketch, 'sketch');
        case 'application/octet-stream':
        case 'application/invision.prototype':
            return getIconDescriptor((0, $hhrxw.IconType).Generic, 'file');
        default:
            return undefined;
    }
};
var $eb169b73453c71b7$export$2e2bcd8739ae039 = $eb169b73453c71b7$var$extractFileFormatIcon;
module.exports["default"] = $eb169b73453c71b7$export$2e2bcd8739ae039;

});

parcelRegister("kPWC0", function(module, exports) {

let $f2b60935c73a6c05$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f2b60935c73a6c05$var$load("gkVge"),
    $f2b60935c73a6c05$var$load("hLbGw")
]).then(()=>parcelRequire('hyaPI'));

});

parcelRegister("7nVQ2", function(module, exports) {

let $56078bdb4bba4b6f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $56078bdb4bba4b6f$var$load("kDfOJ").then(()=>parcelRequire('gMML3'));

});

parcelRegister("9VLzs", function(module, exports) {

let $73ae5688c13ac7f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $73ae5688c13ac7f1$var$load("6wr18"),
    $73ae5688c13ac7f1$var$load("ffEVr"),
    $73ae5688c13ac7f1$var$load("iN2uJ")
]).then(()=>parcelRequire('giuMD'));

});

parcelRegister("j9LJx", function(module, exports) {

let $df23e277716dc04b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $df23e277716dc04b$var$load("6wr18"),
    $df23e277716dc04b$var$load("ffEVr"),
    $df23e277716dc04b$var$load("6aZeI")
]).then(()=>parcelRequire('4b38C'));

});

parcelRegister("96zb4", function(module, exports) {

let $6a0ff61f5e39486f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6a0ff61f5e39486f$var$load("6wr18"),
    $6a0ff61f5e39486f$var$load("ffEVr"),
    $6a0ff61f5e39486f$var$load("8TGE7")
]).then(()=>parcelRequire('8aT6O'));

});

parcelRegister("8KvsV", function(module, exports) {

let $65eb06ff5571b2cc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $65eb06ff5571b2cc$var$load("5JWJI").then(()=>parcelRequire('iqehY'));

});

parcelRegister("kKj89", function(module, exports) {

let $f1a6f16f6403b629$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f1a6f16f6403b629$var$load("aQ5uu").then(()=>parcelRequire('3OVVx'));

});

parcelRegister("1N5Ke", function(module, exports) {

let $14ded2ce3ce05390$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $14ded2ce3ce05390$var$load("geXPZ").then(()=>parcelRequire('EhIdb'));

});

parcelRegister("7KlQ2", function(module, exports) {

let $5a3dc4e9d091ba35$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a3dc4e9d091ba35$var$load("b4nm1").then(()=>parcelRequire('hmd8r'));

});

parcelRegister("4D6tQ", function(module, exports) {

let $35efd4ccf002d2a8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $35efd4ccf002d2a8$var$load("jfYeU").then(()=>parcelRequire('lLxTI'));

});

parcelRegister("30pMN", function(module, exports) {

let $23055fbb4908668b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $23055fbb4908668b$var$load("kYkz1").then(()=>parcelRequire('kUQwC'));

});

parcelRegister("hbVly", function(module, exports) {

let $c83ff29c592bd62f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c83ff29c592bd62f$var$load("5kI0b").then(()=>parcelRequire('1G3Dq'));

});

parcelRegister("5eRas", function(module, exports) {

let $3d078090de5174e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3d078090de5174e1$var$load("3i44s").then(()=>parcelRequire('1kVaD'));

});

parcelRegister("bmQsw", function(module, exports) {

let $846a710eb4b35adb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $846a710eb4b35adb$var$load("4QwAJ").then(()=>parcelRequire('aeJll'));

});

parcelRegister("3tCrI", function(module, exports) {

let $2881e71a7d44971f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2881e71a7d44971f$var$load("fHlIz").then(()=>parcelRequire('8If3N'));

});

parcelRegister("eiZGU", function(module, exports) {

let $a6a299b1e4e47c5f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a6a299b1e4e47c5f$var$load("aaRXj").then(()=>parcelRequire('8B1YK'));

});

parcelRegister("ldRXm", function(module, exports) {

let $f734aa7c232eacf4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f734aa7c232eacf4$var$load("6OMo6").then(()=>parcelRequire('AzmWu'));

});

parcelRegister("c1Kdq", function(module, exports) {

var $hhrxw = parcelRequire("hhrxw");

const $b2f43b4ca89bcf94$export$38df542ff03a4183 = (id)=>{
    return id === (0, $hhrxw.CONFLUENCE_GENERATOR_ID);
};
module.exports["isConfluenceGenerator"] = $b2f43b4ca89bcf94$export$38df542ff03a4183;

});

parcelRegister("6kJW0", function(module, exports) {

var $iW3KC = parcelRequire("iW3KC");


var $ai0Ge = parcelRequire("ai0Ge");


var $eqhrF = parcelRequire("eqhrF");

// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $616e4ede6f48d352$var$BlogIconWithColor = (0, $eqhrF.renderIconPerSize)((0, $iW3KC.default), (0, $ai0Ge.default));
$616e4ede6f48d352$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $616e4ede6f48d352$export$2e2bcd8739ae039 = $616e4ede6f48d352$var$BlogIconWithColor;
module.exports["default"] = $616e4ede6f48d352$export$2e2bcd8739ae039;

});

parcelRegister("ai0Ge", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $d4GYd = parcelRequire("d4GYd");


var $gEyoZ = parcelRequire("gEyoZ");

const $36820b590bf4d8fd$var$BlogObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BlogObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Blog" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BlogObjectTile({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $36820b590bf4d8fd$export$2e2bcd8739ae039 = $36820b590bf4d8fd$var$BlogObjectTile;
module.exports["default"] = $36820b590bf4d8fd$export$2e2bcd8739ae039;

});

parcelRegister("gEyoZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");


var $9NPFC = parcelRequire("9NPFC");

/**
 * __Object tile base__
 *
 * An object tile represents an Atlassian-specific content type.
 *
 */ const $e64fa8a7fc69b505$var$ObjectTileBase = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ObjectTileBase(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { label: t1, size: t2, testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const validSizes = [
        "xsmall",
        "small",
        "medium",
        "large",
        "xlarge"
    ];
    (0, $bB0i2.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(", ")}`);
    let t3;
    if ($[0] !== Icon || $[1] !== color || $[2] !== label || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            shouldScale: true
        });
        $[0] = Icon;
        $[1] = color;
        $[2] = label;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== backgroundColor || $[6] !== size || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9NPFC.default), {
            label: "",
            backgroundColor: backgroundColor,
            size: size,
            children: t3
        });
        $[5] = backgroundColor;
        $[6] = size;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : function ObjectTileBase({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $bB0i2.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9NPFC.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            // @ts-expect-error - Internal, undocumented prop
            shouldScale: true
        })
    });
};
var $e64fa8a7fc69b505$export$2e2bcd8739ae039 = $e64fa8a7fc69b505$var$ObjectTileBase;
module.exports["default"] = $e64fa8a7fc69b505$export$2e2bcd8739ae039;

});

parcelRegister("9NPFC", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


const $60cc37ad75899268$var$tileSizePx = {
    xxsmall: 16,
    xsmall: 20,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 48
};
const $60cc37ad75899268$var$styles = {
    root: "_0bjKvD0O7w _4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS _3iDTPbccYA _24h04i2Njc _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _2O5VijdnbC _4ouGXIdnbC _4kiQYAdnbC _1RrJLit2nV",
    border: "_2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67",
    inset: "_3B3jB1IZbP _0LETLXIZbP _4ACwSfIZbP _2Qxi4nIZbP",
    nonInset: "_49oNbqN91d _1tJeXfN91d _0VARMJN91d _27VeLCN91d _3B3jB1N91d _0LETLXN91d _4ACwSfN91d _2Qxi4nN91d _3G0Ib8iObl"
};
const $60cc37ad75899268$var$sizeMap = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F _4ya3eEuFDC",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1 _4ya3eExpxF",
    small: "_39xV02oWWg _0jFU0VoWWg _4ya3eEEbN9",
    medium: "_39xV02Uofl _0jFU0VUofl _4ya3eEey7F",
    large: "_39xV02UF4f _0jFU0VUF4f _4ya3eESPN1",
    xlarge: "_39xV02pJKa _0jFU0VpJKa _4ya3eEoWWg"
};
const $60cc37ad75899268$var$insetSizeMap = {
    xxsmall: "_49oNbquFDC _1tJeXfuFDC _0VARMJuFDC _27VeLCuFDC _0mzAWiNKBH _3woHNtNKBH _430i96NKBH _1GBPVvNKBH",
    xsmall: "_49oNbqxpxF _1tJeXfxpxF _0VARMJxpxF _27VeLCxpxF _0mzAWiqBG1 _3woHNtqBG1 _430i96qBG1 _1GBPVvqBG1",
    small: "_49oNbqEbN9 _1tJeXfEbN9 _0VARMJEbN9 _27VeLCEbN9 _0mzAWif9wp _3woHNtf9wp _430i96f9wp _1GBPVvf9wp",
    medium: "_49oNbqey7F _1tJeXfey7F _0VARMJey7F _27VeLCey7F _0mzAWiIRC9 _3woHNtIRC9 _430i96IRC9 _1GBPVvIRC9",
    large: "_49oNbqSPN1 _1tJeXfSPN1 _0VARMJSPN1 _27VeLCSPN1 _0mzAWiPcut _3woHNtPcut _430i96Pcut _1GBPVvPcut",
    xlarge: "_49oNbqoWWg _1tJeXfoWWg _0VARMJoWWg _27VeLCoWWg _0mzAWiY6u9 _3woHNtY6u9 _430i96Y6u9 _1GBPVvY6u9"
};
const $60cc37ad75899268$var$backgroundColorMap = {
    white: "_0KLXrut28M",
    black: "_0KLXru52mJ",
    transparent: "_0KLXrujOvk",
    'color.background.accent.lime.subtlest': "_0KLXruXL80",
    'color.background.accent.lime.subtler': "_0KLXruuKDS",
    'color.background.accent.lime.subtle': "_0KLXruZcd0",
    'color.background.accent.lime.bolder': "_0KLXrubYhN",
    'color.background.accent.red.subtlest': "_0KLXrusDFP",
    'color.background.accent.red.subtler': "_0KLXrubV9i",
    'color.background.accent.red.subtle': "_0KLXru0cUQ",
    'color.background.accent.red.bolder': "_0KLXruQrW1",
    'color.background.accent.orange.subtlest': "_0KLXru2QQR",
    'color.background.accent.orange.subtler': "_0KLXruwJ86",
    'color.background.accent.orange.subtle': "_0KLXruuwVU",
    'color.background.accent.orange.bolder': "_0KLXrux4f7",
    'color.background.accent.yellow.subtlest': "_0KLXru56u3",
    'color.background.accent.yellow.subtler': "_0KLXruLv9B",
    'color.background.accent.yellow.subtle': "_0KLXruC29w",
    'color.background.accent.yellow.bolder': "_0KLXruYB6L",
    'color.background.accent.green.subtlest': "_0KLXruV6wL",
    'color.background.accent.green.subtler': "_0KLXruNUep",
    'color.background.accent.green.subtle': "_0KLXru50ZN",
    'color.background.accent.green.bolder': "_0KLXrude1t",
    'color.background.accent.teal.subtlest': "_0KLXruuBpz",
    'color.background.accent.teal.subtler': "_0KLXrunfgW",
    'color.background.accent.teal.subtle': "_0KLXrufjGw",
    'color.background.accent.teal.bolder': "_0KLXruzHaB",
    'color.background.accent.blue.subtlest': "_0KLXruVva3",
    'color.background.accent.blue.subtler': "_0KLXrup9dS",
    'color.background.accent.blue.subtle': "_0KLXru28sy",
    'color.background.accent.blue.bolder': "_0KLXrutfbE",
    'color.background.accent.purple.subtlest': "_0KLXruB8KG",
    'color.background.accent.purple.subtler': "_0KLXruWOdT",
    'color.background.accent.purple.subtle': "_0KLXruf89Q",
    'color.background.accent.purple.bolder': "_0KLXruhdss",
    'color.background.accent.magenta.subtlest': "_0KLXru8frT",
    'color.background.accent.magenta.subtler': "_0KLXruXM4x",
    'color.background.accent.magenta.subtle': "_0KLXrupmfs",
    'color.background.accent.magenta.bolder': "_0KLXruxE6Y",
    'color.background.accent.gray.subtlest': "_0KLXrumhAQ",
    'color.background.accent.gray.subtler': "_0KLXruG6qS",
    'color.background.accent.gray.subtle': "_0KLXrueZ10",
    'color.background.accent.gray.bolder': "_0KLXrurxgm",
    'color.background.inverse.subtle': "_0KLXruB4sa",
    'color.background.neutral': "_0KLXruDMqu",
    'color.background.neutral.bold': "_0KLXrugozt",
    'color.background.brand.subtlest': "_0KLXrunl7T",
    'color.background.brand.bold': "_0KLXruDM2k",
    'color.background.brand.boldest': "_0KLXru2o0p",
    'color.background.danger': "_0KLXruhH7k",
    'color.background.danger.bold': "_0KLXruqsXs",
    'color.background.warning': "_0KLXruhxIM",
    'color.background.warning.bold': "_0KLXruKLKE",
    'color.background.success': "_0KLXruzaZe",
    'color.background.success.bold': "_0KLXruhbjP",
    'color.background.discovery': "_0KLXru94rk",
    'color.background.discovery.bold': "_0KLXruqjHC",
    'color.background.information': "_0KLXrugNg3",
    'color.background.information.bold': "_0KLXruASYT"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
const $60cc37ad75899268$var$Tile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Tile(props) {
    const $ = (0, $bDgLe.c)(17);
    const { children: children, label: label, size: t0, backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: t1, testId: testId } = props;
    const size = t0 === undefined ? "medium" : t0;
    const isInset = t1 === undefined ? true : t1;
    const containerRef = (0, $cozmU.useRef)(null);
    let t2;
    if ($[0] !== size) {
        t2 = ()=>{
            return;
        };
        $[0] = size;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== size) {
        t3 = [
            children,
            size
        ];
        $[2] = children;
        $[3] = size;
        $[4] = t3;
    } else t3 = $[4];
    (0, $cozmU.useEffect)(t2, t3);
    const t4 = label !== "" ? label : undefined;
    const t5 = label !== "" ? "img" : undefined;
    const t6 = $60cc37ad75899268$var$sizeMap[size];
    const t7 = isInset ? $60cc37ad75899268$var$styles.inset : $60cc37ad75899268$var$styles.nonInset;
    const t8 = isInset && $60cc37ad75899268$var$insetSizeMap[size];
    const t9 = $60cc37ad75899268$var$backgroundColorMap[backgroundColor || "color.background.neutral"];
    const t10 = hasBorder && $60cc37ad75899268$var$styles.border;
    let t11;
    if ($[5] !== t10 || $[6] !== t6 || $[7] !== t7 || $[8] !== t8 || $[9] !== t9) {
        t11 = (0, $hekY6.default)([
            $60cc37ad75899268$var$styles.root,
            t6,
            t7,
            t8,
            t9,
            t10
        ]);
        $[5] = t10;
        $[6] = t6;
        $[7] = t7;
        $[8] = t8;
        $[9] = t9;
        $[10] = t11;
    } else t11 = $[10];
    let t12;
    if ($[11] !== children || $[12] !== t11 || $[13] !== t4 || $[14] !== t5 || $[15] !== testId) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            ref: containerRef,
            "data-testid": testId,
            "aria-label": t4,
            role: t5,
            className: t11,
            children: children
        });
        $[11] = children;
        $[12] = t11;
        $[13] = t4;
        $[14] = t5;
        $[15] = testId;
        $[16] = t12;
    } else t12 = $[16];
    return t12;
} : function Tile(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    const containerRef = (0, $cozmU.useRef)(null); // Dev-mode only: validate that raster images passed into the tile
    // are square and retina-compatible (at least 2x the rendered tile size).
    (0, $cozmU.useEffect)(()=>{
        return;
    }, [
        children,
        size
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        ref: containerRef,
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $hekY6.default)([
            $60cc37ad75899268$var$styles.root,
            $60cc37ad75899268$var$sizeMap[size],
            isInset ? $60cc37ad75899268$var$styles.inset : $60cc37ad75899268$var$styles.nonInset,
            isInset && $60cc37ad75899268$var$insetSizeMap[size],
            $60cc37ad75899268$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $60cc37ad75899268$var$styles.border
        ]),
        children: children
    });
};
var $60cc37ad75899268$export$2e2bcd8739ae039 = $60cc37ad75899268$var$Tile;
function $60cc37ad75899268$var$_temp(fn) {
    return fn();
}
module.exports["default"] = $60cc37ad75899268$export$2e2bcd8739ae039;

});

parcelRegister("eqhrF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hhrxw = parcelRequire("hhrxw");

const $ef7997acb045a8f6$var$isIconSizeLarge = (size)=>size && [
        (0, $hhrxw.SmartLinkSize).Large,
        (0, $hhrxw.SmartLinkSize).XLarge
    ].includes(size);
const $ef7997acb045a8f6$export$28dd5ad82647c000 = (ObjectIcon, ObjectTileIcon)=>{
    return ({ size: size, ...props })=>{
        if ($ef7997acb045a8f6$var$isIconSizeLarge(size)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ObjectTileIcon, {
            ...props,
            size: "small"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ObjectIcon, props);
    };
};
module.exports["renderIconPerSize"] = $ef7997acb045a8f6$export$28dd5ad82647c000;

});

parcelRegister("9v3GN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $hMaHH = parcelRequire("hMaHH");


var $9D4WS = parcelRequire("9D4WS");

const $fc0d527adbaaccfa$var$PageIconWithColor = (0, $9D4WS.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), 'blueBold');
$fc0d527adbaaccfa$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $fc0d527adbaaccfa$export$2e2bcd8739ae039 = $fc0d527adbaaccfa$var$PageIconWithColor;
module.exports["default"] = $fc0d527adbaaccfa$export$2e2bcd8739ae039;

});

parcelRegister("9D4WS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lSQgn = parcelRequire("lSQgn");


var $6nWVS = parcelRequire("6nWVS");

const $eb6ec3e0096439cb$var$appearanceToStandaloneIconColor = {
    blue: "var(--ds-icon-accent-blue, #357DE8)",
    blueBold: "var(--ds-icon-accent-blue, #357DE8)",
    gray: "var(--ds-icon-accent-gray, #7D818A)",
    grayBold: "var(--ds-icon-accent-gray, #7D818A)",
    green: "var(--ds-icon-accent-green, #22A06B)",
    greenBold: "var(--ds-icon-accent-green, #22A06B)",
    lime: "var(--ds-icon-accent-lime, #6A9A23)",
    limeBold: "var(--ds-icon-accent-lime, #6A9A23)",
    magenta: "var(--ds-icon-accent-magenta, #CD519D)",
    magentaBold: "var(--ds-icon-accent-magenta, #CD519D)",
    orange: "var(--ds-icon-accent-orange, #E06C00)",
    orangeBold: "var(--ds-icon-accent-orange, #E06C00)",
    purple: "var(--ds-icon-accent-purple, #AF59E1)",
    purpleBold: "var(--ds-icon-accent-purple, #AF59E1)",
    red: "var(--ds-icon-accent-red, #C9372C)",
    redBold: "var(--ds-icon-accent-red, #C9372C)",
    teal: "var(--ds-icon-accent-teal, #2898BD)",
    tealBold: "var(--ds-icon-accent-teal, #2898BD)",
    yellow: "var(--ds-icon-accent-yellow, #B38600)",
    yellowBold: "var(--ds-icon-accent-yellow, #B38600)"
};
const $eb6ec3e0096439cb$export$87c3646d0e299cfe = (Icon, appearance)=>{
    return ({ size: size, isTiledIcon: isTiledIcon, ...props })=>{
        const tileSize = (0, $6nWVS.transformSmartLinkSizeToIconTileSize)(size);
        if (tileSize === undefined) {
            const label = props.label ?? '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                role: label ? 'img' : undefined,
                "aria-label": label || undefined,
                "data-testid": props.testId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                color: $eb6ec3e0096439cb$var$appearanceToStandaloneIconColor[appearance],
                label: ""
            }));
        }
        const { ...tileProps } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            appearance: appearance,
            icon: isTiledIcon ? (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                    ...iconProps,
                    spacing: "spacious"
                }) : Icon,
            size: tileSize,
            ...tileProps
        });
    };
};
module.exports["renderIconTile"] = $eb6ec3e0096439cb$export$87c3646d0e299cfe;

});

parcelRegister("6nWVS", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $hhrxw = parcelRequire("hhrxw");

const $7fb62870d007a2a2$export$3acc3fb10995f020 = (size)=>{
    if ((0, $iDrrr.fg)('platform_sl_icons_refactor')) switch(size){
        case (0, $hhrxw.SmartLinkSize).Small:
        case (0, $hhrxw.SmartLinkSize).Medium:
            return undefined;
        case (0, $hhrxw.SmartLinkSize).XLarge:
        case (0, $hhrxw.SmartLinkSize).Large:
            return 'small';
        default:
            return undefined;
    }
    switch(size){
        case (0, $hhrxw.SmartLinkSize).XLarge:
        case (0, $hhrxw.SmartLinkSize).Large:
            return 'small';
        default:
            return undefined;
    }
};
module.exports["transformSmartLinkSizeToIconTileSize"] = $7fb62870d007a2a2$export$3acc3fb10995f020;

});

parcelRegister("4Emmj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $kkFbH = parcelRequire("kkFbH");


var $9D4WS = parcelRequire("9D4WS");

const $30795df12c6626e4$var$FileIconWithColor = (0, $9D4WS.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), 'grayBold');
$30795df12c6626e4$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $30795df12c6626e4$export$2e2bcd8739ae039 = $30795df12c6626e4$var$FileIconWithColor;
module.exports["default"] = $30795df12c6626e4$export$2e2bcd8739ae039;

});

parcelRegister("dGdE6", function(module, exports) {

var $7pJjg = parcelRequire("7pJjg");


var $dipyx = parcelRequire("dipyx");


var $eqhrF = parcelRequire("eqhrF");

// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $c10f705a5270d647$var$LiveDocumentIconWithColor = (0, $eqhrF.renderIconPerSize)((0, $7pJjg.default), (0, $dipyx.default));
$c10f705a5270d647$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $c10f705a5270d647$export$2e2bcd8739ae039 = $c10f705a5270d647$var$LiveDocumentIconWithColor;
module.exports["default"] = $c10f705a5270d647$export$2e2bcd8739ae039;

});

parcelRegister("7pJjg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kLlYX = parcelRequire("kLlYX");


var $4hmAW = parcelRequire("4hmAW");

const $5d24b7fd99811061$var$PageLiveDocObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageLiveDocObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
            color: "var(--ds-icon-accent-magenta, #CD519D)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PageLiveDocObject({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
};
var $5d24b7fd99811061$export$2e2bcd8739ae039 = $5d24b7fd99811061$var$PageLiveDocObject;
module.exports["default"] = $5d24b7fd99811061$export$2e2bcd8739ae039;

});

parcelRegister("kLlYX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::80e1615540ac9d82a9937150e7cfa4ab>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1d93fa86ac2ebd2$var$_react = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f1d93fa86ac2ebd2$var$_iconNew = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $f1d93fa86ac2ebd2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/page-live-doc
 * Usage guidance:
 * Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f1d93fa86ac2ebd2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $f1d93fa86ac2ebd2$var$_react.default.createElement($f1d93fa86ac2ebd2$var$_iconNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$f1d93fa86ac2ebd2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $f1d93fa86ac2ebd2$var$_default = module.exports.default = $f1d93fa86ac2ebd2$var$PageLiveDocIcon;

});

parcelRegister("dipyx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kLlYX = parcelRequire("kLlYX");


var $gEyoZ = parcelRequire("gEyoZ");

const $5d01faeb97b0ed22$var$PageLiveDocObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageLiveDocObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)";
    const t3 = isBold ? "color.background.accent.magenta.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function PageLiveDocObjectTile({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
};
var $5d01faeb97b0ed22$export$2e2bcd8739ae039 = $5d01faeb97b0ed22$var$PageLiveDocObjectTile;
module.exports["default"] = $5d01faeb97b0ed22$export$2e2bcd8739ae039;

});

parcelRegister("b5Dss", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gJ798 = parcelRequire("gJ798");


var $9D4WS = parcelRequire("9D4WS");

// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $77093538826d7e25$var$ChartBarIconWithColor = (0, $9D4WS.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($gJ798))), 'purpleBold');
$77093538826d7e25$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $77093538826d7e25$export$2e2bcd8739ae039 = $77093538826d7e25$var$ChartBarIconWithColor;
module.exports["default"] = $77093538826d7e25$export$2e2bcd8739ae039;

});

parcelRegister("7vzLW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $3fO5l = parcelRequire("3fO5l");


var $9D4WS = parcelRequire("9D4WS");

const $7d25c80ed1a76c0d$var$ListBulletedIconWithColor = (0, $9D4WS.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), 'greenBold');
$7d25c80ed1a76c0d$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $7d25c80ed1a76c0d$export$2e2bcd8739ae039 = $7d25c80ed1a76c0d$var$ListBulletedIconWithColor;
module.exports["default"] = $7d25c80ed1a76c0d$export$2e2bcd8739ae039;

});

parcelRegister("9UEKm", function(module, exports) {
module.exports = JSON.parse('{"app-switcher-discovery-section.atlassian-store":[{"type":0,"value":"Marketplace apps"}],"app-switcher-discovery-section.discover-more-products":[{"type":0,"value":"Discover more apps"}],"app-switcher-discovery-section.more-atlassian-products":[{"type":0,"value":"More Atlassian apps"}],"app-switcher-discovery-section.recommended-for-your-team":[{"type":0,"value":"Recommended for your team"}],"confluence-inline-reactions-nudge.description.many-reactions":[{"type":1,"value":"user1"},{"type":0,"value":", "},{"type":1,"value":"user2"},{"type":0,"value":" and "},{"type":1,"value":"count"},{"type":0,"value":" other"},{"offset":0,"options":{"one":{"value":[]},"other":{"value":[{"type":0,"value":"s"}]}},"pluralType":"cardinal","type":6,"value":"count"},{"type":0,"value":" reacted to this page"}],"confluence-inline-reactions-nudge.description.no-reactions":[{"type":0,"value":"Be the first one to react"}],"confluence-inline-reactions-nudge.description.one-reaction":[{"type":1,"value":"user"},{"type":0,"value":" reacted to this page"}],"confluence-inline-reactions-nudge.description.two-reactions":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" reacted to this page"}],"confluence-inline-reactions-nudge.title":[{"type":0,"value":"Love this page? Let "},{"type":1,"value":"authorName"},{"type":0,"value":" know"}],"confluence.continue.reading.body":[{"children":[{"type":0,"value":"Related reading from "},{"type":1,"value":"pageOwnerName"}],"type":8,"value":"text"}],"confluence.continue.reading.read-now":[{"type":0,"value":"Read now"}],"continue-reading.ai-footer.content-quality":[{"children":[{"type":0,"value":"Content quality may vary"}],"type":8,"value":"text"}],"continue-reading.ai-footer.powered-by-ai":[{"children":[{"type":0,"value":"Powered by AI"}],"type":8,"value":"text"}],"cross-flow-itsm-template.jsm.title":[{"type":0,"value":"Collect IT requests"}],"cross-flow-product-prioritization-template.jpd.title":[{"type":0,"value":"Prioritize ideas"}],"cross-flow-product-request-pending.jpd.title":[{"type":0,"value":"Product roadmap"}],"cross-flow-product-request-pending.jsm.title":[{"type":0,"value":"Work requests"}],"cross-flow-product-roadmap-template.jpd.title":[{"type":0,"value":"Create a roadmap"}],"cross-flow-work-requests-template.jsm.title":[{"type":0,"value":"Collect requests"}],"first-party-recommendation.reason-1":[{"type":0,"value":"the size of your team"}],"first-party-recommendation.reason-2":[{"type":0,"value":"your existing Atlassian products"}],"growth.app-switcher-discovery-section.flag.description":[{"type":0,"value":"You won\u2019t see this here as often."}],"growth.app-switcher-discovery-section.flag.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"growth.app-switcher-discovery-section.wac-toast.close.aria-label":[{"type":0,"value":"Dismiss toast"}],"growth.confluence-nudge-for-jira.action":[{"type":0,"value":"Accept invitation"}],"growth.confluence-nudge-for-jira.description":[{"type":0,"value":"Accept your invitation to make sure you\'re not missing any project updates."}],"growth.confluence-nudge-for-jira.title":[{"type":0,"value":"Your team invited you to Jira"}],"growth.confluenceNudgeFlag.flagHeadline.commentedOnPage.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" commented on your page"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.flagHeadline.mentionedInComment.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" mentioned you in a comment"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.flagHeadline.mentionedInPage.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" mentioned you on a page"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.repliedSuccessFlagTitle.text":[{"type":0,"value":"Reply sent to "},{"type":1,"value":"mentionerName"}],"growth.confluenceNudgeFlag.reply-cancel-button":[{"type":0,"value":"Cancel"}],"growth.confluenceNudgeFlag.reply-confirm-button":[{"type":0,"value":"Reply"}],"growth.confluenceNudgeFlag.reply-on-page-confirm-button.text":[{"children":[{"type":0,"value":"Reply on page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.replyFieldGenericError":[{"type":0,"value":"Failed to send comment. Please try again later."}],"growth.confluenceNudgeFlag.see-page-confirm-button":[{"children":[{"type":0,"value":"See page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.see-page-confirm-button.success.flag":[{"children":[{"type":0,"value":"See page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.viewReactionsError":[{"type":0,"value":"Reactions failed to load"}],"growth.placement-v2.atlas-side-nav-app-recommendation-menu-item.try-new-product":[{"type":0,"value":"TRY"}],"growth.recommendation-atlas.app-switcher-discovery-section.app-name":[{"type":0,"value":"Atlas"}],"growth.recommendation-atlas.value-proposition":[{"type":0,"value":"Your company\'s teamwork directory"}],"growth.recommendation-confluence.app-switcher-discovery-section.app-name":[{"type":0,"value":"Confluence"}],"growth.recommendation-confluence.cta.label":[{"type":0,"value":"Try Confluence"}],"growth.recommendation-confluence.jira-your-work.description":[{"type":0,"value":"Create a centralized space to organize requirements, release notes, goals, and more."}],"growth.recommendation-confluence.jira-your-work.header":[{"type":0,"value":"Get everyone on the same page"}],"growth.recommendation-confluence.jira-your-work.header-image-alt-text":[{"type":0,"value":"Multiple people collaborating and commenting on the same page at the same time"}],"growth.recommendation-confluence.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"confluence"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-confluence.product-alt-text":[{"type":0,"value":"A document titled quarterly planning. The document has details like mission, scope and a monthly plan."}],"growth.recommendation-confluence.product-heading":[{"type":0,"value":"Create one source of truth, for all"}],"growth.recommendation-confluence.product-name.header":[{"type":0,"value":"Collaborate on pages in real-time"}],"growth.recommendation-confluence.product-subheading":[{"type":0,"value":"Create and link documents like release notes, product requirements, and roadmaps from a single place."}],"growth.recommendation-confluence.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"confluence"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-confluence.value-proposition":[{"type":0,"value":"Document collaboration"}],"growth.recommendation-jira.product-alt-text":[{"type":0,"value":"A board view to move tasks from to do, to in progress to done"}],"growth.recommendation-jira.product-heading":[{"type":0,"value":"Plan and track work across teams"}],"growth.recommendation-jira.product-subheading":[{"type":0,"value":"Break big ideas down into achievable steps. Organize work, create milestones, map dependencies, and get visibility across all teams."}],"growth.recommendation-jpd-product-roadmap.value-proposition":[{"type":0,"value":"Align everyone with custom roadmaps"}],"growth.recommendation-jpd.admin-hub-recommendation-value-proposition":[{"type":0,"value":"Plan and deliver all on the same platform"}],"growth.recommendation-jpd.app-switcher-discovery-section.app-name":[{"type":0,"value":"Jira Product Discovery"}],"growth.recommendation-jpd.app-switcher-discovery-section.template-name":[{"type":0,"value":"Product roadmap"}],"growth.recommendation-jpd.cta.label":[{"type":0,"value":"Try Jira Product Discovery"}],"growth.recommendation-jpd.jira-your-work.description":[{"type":0,"value":"Prioritize your ideas then easily move them into delivery, without losing any details on the way."}],"growth.recommendation-jpd.jira-your-work.header":[{"type":0,"value":"Build right features, the right way"}],"growth.recommendation-jpd.jira-your-work.header-image-alt-text":[{"type":0,"value":"An idea in Jira Product Discovery automatically turning into an Epic in Jira"}],"growth.recommendation-jpd.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jpd"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jpd.product-alt-text":[{"type":0,"value":"Five ideas are all organized into now, next and later groups, with a goal, score and effort ranking connected to each idea."}],"growth.recommendation-jpd.product-heading":[{"type":0,"value":"Build the right features, the right way"}],"growth.recommendation-jpd.product-name.header":[{"type":0,"value":"Transform insights into action plans"}],"growth.recommendation-jpd.product-subheading":[{"type":0,"value":"Capture and prioritize your ideas, then easily move them into delivery, without losing any details on the way."}],"growth.recommendation-jpd.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jpd"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jpd.value-proposition":[{"type":0,"value":"Prioritize, collaborate, and deliver new ideas"}],"growth.recommendation-jsm-work-request.value-proposition":[{"type":0,"value":"Create one place to manage requests"}],"growth.recommendation-jsm.admin-hub-recommendation-value-prop":[{"type":0,"value":"Bring your developers, IT, and operations onto the same platform."}],"growth.recommendation-jsm.app-switcher-discovery-section.app-name":[{"type":0,"value":"Jira Service Management"}],"growth.recommendation-jsm.app-switcher-discovery-section.template-name":[{"type":0,"value":"Work requests"}],"growth.recommendation-jsm.cta.label":[{"type":0,"value":"Try Jira Service Management"}],"growth.recommendation-jsm.jira-your-work.description":[{"type":0,"value":"Connect support teams with development teams to get the full picture, from request to resolution."}],"growth.recommendation-jsm.jira-your-work.header":[{"type":0,"value":"Link your teams, make work visible"}],"growth.recommendation-jsm.jira-your-work.header-image-alt-text":[{"type":0,"value":"Requests from Slack, Teams and email turning into a Jira Service Management request automatically"}],"growth.recommendation-jsm.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jsm"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsm.product-alt-text":[{"type":0,"value":"Seven requests are all organized in one place, with a status and project connected to each request."}],"growth.recommendation-jsm.product-heading":[{"type":0,"value":"Make your work more visible"}],"growth.recommendation-jsm.product-name.header":[{"type":0,"value":"Automate workflows for faster resolutions"}],"growth.recommendation-jsm.product-subheading":[{"type":0,"value":"Connect Dev and Ops teams on a single platform to collaborate and connect the whole picture, from request to resolution."}],"growth.recommendation-jsm.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jsm"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsm.value-proposition":[{"type":0,"value":"Collaborative IT service management"}],"growth.recommendation-jsw-visualize-work.cta.label":[{"type":0,"value":"Try Jira"}],"growth.recommendation-jsw-visualize-work.product-name.header":[{"type":0,"value":"Visualize your projects in lists, boards, and more"}],"growth.recommendation-jsw-visualize-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"product"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsw.app-switcher-discovery-section.app-name":[{"type":0,"value":"Jira"}],"growth.recommendation-jsw.recommendations.dropdown-menu-trigger.aria-label":[{"type":1,"value":"productName"},{"type":0,"value":" options"}],"growth.recommendation-jsw.value-proposition":[{"type":0,"value":"Project and issue tracking"}],"growth.recommendation-jwm.app-switcher-discovery-section.app-name":[{"type":0,"value":"Jira Work Management"}],"growth.recommendation-jwm.value-proposition":[{"type":0,"value":"ITSM that unlocks high-velocity teams"}],"growth.recommendation-loom.app-switcher-discovery-section.app-name":[{"type":0,"value":"Loom"}],"growth.recommendation-loom.cta.label":[{"type":0,"value":"Try Loom"}],"growth.recommendation-loom.product-name.header":[{"type":0,"value":"Record and share videos easily"}],"growth.recommendation-loom.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"product"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-loom.value-proposition":[{"type":0,"value":"Record and share videos easily"}],"growth.recommendation-opsgenie.app-switcher-discovery-section.app-name":[{"type":0,"value":"Opsgenie"}],"growth.recommendation-opsgenie.value-proposition":[{"type":0,"value":"Modern incident management"}],"growth.recommendation-product-store.learn-cta-button-text":[{"type":0,"value":"Learn more"}],"growth.recommendation-product-store.try-cta-button-text":[{"type":0,"value":"Try it now"}],"growth.recommendation-twc.twc-apps-lozenge":[{"type":0,"value":"New"}],"growth.recommendation-twc.twc-apps-product-benefits-description":[{"type":0,"value":"Run your whole project seamlessly"}],"growth.recommendation-twc.twc-apps-product-benefits-title":[{"type":0,"value":"1 collection, 4 tools"}],"growth.recommendation-twc.twc-image-alt-text":[{"type":0,"value":"Teamwork Collection"}],"growth.team-25-ipm.jira-your-work.call-to-action.watch-now.text":[{"type":0,"value":"Watch now"}],"growth.team-25-ipm.jira-your-work.description":[{"type":0,"value":"See how Rovo can improve the way you work with AI search, chat, and agents."}],"growth.team-25-ipm.jira-your-work.header-image-alt-text":[{"type":0,"value":"See the Rovo announcement!"}],"growth.team-25-ipm.jira-your-work.reasons-modal.message":[{"type":0,"value":"Atlassian recently shared multiple announcements at Team \'25, and we wanted to make sure you know about our new capabilities."}],"growth.team-25-ipm.jira-your-work.title":[{"type":0,"value":"Work better with Rovo"}],"post-office.ad-controls.confluence-continue-reading-nudge.reason.activity-in-product":[{"type":0,"value":"Your activity in Confluence"}],"post-office.ad-controls.confluence-continue-reading-nudge.reason.suggested-next-steps":[{"type":0,"value":"Suggested next steps to help you get more value out of Atlassian"}],"post-office.ad-controls.confluence-continue-reading-nudge.why-am-i-seeing-this.message":[{"type":0,"value":"You\'re seeing a personalized recommendation based on:"}],"post-office.ad-controls.confluence-continue-reading-nudge.why-am-i-seeing-this.title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.confluence-mcu-nudge-flag-message.recommendation-basis":[{"type":0,"value":"You\u2019re seeing a personalized recommendation based on:"}],"post-office.ad-controls.confluence-mcu-nudge-flag-reason.activity-in-product":[{"type":0,"value":"Your activity in Confluence"}],"post-office.ad-controls.confluence-mcu-nudge-flag-title.why-am-i-seeing-this":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.confluence-mcu-nudge-flag.suggestions":[{"type":0,"value":"Suggested next steps to help you get more value out of Atlassian"}],"post-office.ad-controls.custom-dropdown-item.1.no-translate":[{"type":0,"value":"the first custom dropdown item"}],"post-office.ad-controls.custom-dropdown-item.2.no-translate":[{"type":0,"value":"the second custom dropdown item"}],"post-office.ad-controls.custom-reason.existing-products.no-translate":[{"type":0,"value":"the second reason for displaying the message to the customer"}],"post-office.ad-controls.custom-reason.team-size.no-translate":[{"type":0,"value":"the first reason for displaying the message to the customer"}],"post-office.ad-controls.default-reason.existing-products":[{"type":0,"value":"your existing Atlassian products"}],"post-office.ad-controls.default-reason.team-size":[{"type":0,"value":"the size of your team"}],"post-office.ad-controls.dismiss-flag.feedback.title":[{"type":0,"value":"Thanks for your feedback"}],"post-office.ad-controls.dropdown-item.not-interested.label":[{"type":0,"value":"Not interested"}],"post-office.ad-controls.dropdown-item.remind-me-later.label":[{"type":0,"value":"Remind me later"}],"post-office.ad-controls.dropdown-item.why-am-i-seeing-this.label":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.dropdown-menu-trigger.aria-label":[{"type":1,"value":"messageInstanceId"},{"type":0,"value":" options menu"}],"post-office.ad-controls.dropdown-menu-trigger.tooltip":[{"type":0,"value":"More actions"}],"post-office.ad-controls.next-best-action-message.recommendation-basis":[{"type":0,"value":"This recommendation is based on:"}],"post-office.ad-controls.next-best-action-reason.actions-done-so-far":[{"type":0,"value":"What you\u2019ve done so far in the product"}],"post-office.ad-controls.next-best-action-reason.suggestions":[{"type":0,"value":"What we suggest to help you get the most value from Atlassian"}],"post-office.ad-controls.next-best-action-title.why-am-i-seeing-this":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.reasons-modal.accept-button.label-ok":[{"type":0,"value":"OK"}],"post-office.ad-controls.reasons-modal.body":[{"type":0,"value":"We think you\'d find this relevant. This is based on:"}],"post-office.ad-controls.reasons-modal.privacy-policy-link.text":[{"type":0,"value":"Learn more about your data privacy with Atlassian"}],"post-office.ad-controls.reasons-modal.title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.close-button.tooltip":[{"type":0,"value":"Close"}],"post-office.confluence-banner-first-party-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"post-office.confluence-side-nav.next-best-action.craete-space-header":[{"type":0,"value":"Centralize your team\'s projects, and docs."}],"post-office.confluence-side-nav.next-best-action.create-page-cta-message":[{"type":0,"value":"Create page"}],"post-office.confluence-side-nav.next-best-action.create-page-header":[{"type":0,"value":"Plan projects, take notes, and track tasks."}],"post-office.confluence-side-nav.next-best-action.create-space-cta-message":[{"type":0,"value":"Create space"}],"post-office.confluence-side-nav.next-best-action.create-whiteboard-cta-message":[{"type":0,"value":"Create whiteboard"}],"post-office.confluence-side-nav.next-best-action.create-whiteboard-header":[{"type":0,"value":"Dream up new ideas, and visualize your work."}],"post-office.example-message-template.example-placement.cta-button.no-translate":[{"type":0,"value":"Try now"}],"post-office.example-placement-advanced.learn-more-modal.done-button-text.no-translate":[{"type":0,"value":"Done"}],"post-office.example-placement-quick-start.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}],"post-office.growth.jira-activation-project-recommendation.check-jira":[{"type":0,"value":"Check Jira"}],"post-office.growth.jira-activation-project-recommendation.hello-message":[{"type":0,"value":":wave: Hey "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"post-office.growth.jira-activation-project-recommendation.message-text":[{"type":0,"value":"Have you checked Jira lately? You may be missing out on important updates. Take a quick look to see if your team is using it to track any of your projects."}],"post-office.growth.jira-activation-project-recommendation.messages-exist":[{"type":0,"value":"Don\u2019t forget to get caught up on your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"project"}]},"other":{"value":[{"type":0,"value":"projects"}]}},"pluralType":"cardinal","type":6,"value":"numberOfProjects"},{"type":0,"value":" in Jira! Take a quick look to get up-to-date on your teammates\u2019 progress."}],"post-office.growth.jira-activation-project-recommendation.see-projects":[{"type":0,"value":"See all projects"}],"post-office.growth.jira-activation-project-recommendation.you-have-messages":[{"offset":0,"options":{"=0":{"value":[]},"=1":{"value":[]},"=2":{"value":[{"type":0,"value":"You have *two projects*:"}]},"=3":{"value":[{"type":0,"value":"You have *three projects*:"}]},"other":{"value":[{"type":0,"value":"You have *"},{"options":{"4":{"value":[{"type":0,"value":"four"}]},"5":{"value":[{"type":0,"value":"five"}]},"6":{"value":[{"type":0,"value":"six"}]},"7":{"value":[{"type":0,"value":"seven"}]},"8":{"value":[{"type":0,"value":"eight"}]},"9":{"value":[{"type":0,"value":"nine"}]},"other":{"value":[{"type":1,"value":"numberOfProjects"}]}},"type":5,"value":"numberOfProjects"},{"type":0,"value":" projects*. Here are three to get you started:"}]}},"pluralType":"cardinal","type":6,"value":"numberOfProjects"}],"post-office.growth.jira-assigned-nudge-digest.hello-message-for-multiple-projects":[{"type":0,"value":":wave: Just a heads up \u2014 you have *"},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"one project"}]},"other":{"value":[{"options":{"2":{"value":[{"type":0,"value":"two"}]},"3":{"value":[{"type":0,"value":"three"}]},"4":{"value":[{"type":0,"value":"four"}]},"5":{"value":[{"type":0,"value":"five"}]},"6":{"value":[{"type":0,"value":"six"}]},"7":{"value":[{"type":0,"value":"seven"}]},"8":{"value":[{"type":0,"value":"eight"}]},"9":{"value":[{"type":0,"value":"nine"}]},"other":{"value":[{"type":1,"value":"numberOfProjects"}]}},"type":5,"value":"numberOfProjects"},{"type":0,"value":" projects"}]}},"pluralType":"cardinal","type":6,"value":"numberOfProjects"},{"type":0,"value":"* assigned to you with new work items you haven\'t checked out yet."}],"post-office.growth.jira-assigned-nudge-digest.hello-message-for-one-project-work-items":[{"type":0,"value":":wave: Just a heads up \u2014 you were assigned "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"a work item in *<"},{"type":1,"value":"projectUrl"},{"type":0,"value":"|"},{"type":1,"value":"projectName"},{"type":0,"value":">*"}]},"other":{"value":[{"type":0,"value":"some work items in *<"},{"type":1,"value":"projectUrl"},{"type":0,"value":"|"},{"type":1,"value":"projectName"},{"type":0,"value":">*"}]}},"pluralType":"cardinal","type":6,"value":"numberOfWorkItems"},{"type":0,"value":" over three days ago."}],"post-office.growth.jira-assigned-nudge-digest.max-top-work-items-message":[{"type":0,"value":"You\'ve got *"},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"one item"}]},"other":{"value":[{"options":{"2":{"value":[{"type":0,"value":"two"}]},"3":{"value":[{"type":0,"value":"three"}]},"4":{"value":[{"type":0,"value":"four"}]},"5":{"value":[{"type":0,"value":"five"}]},"6":{"value":[{"type":0,"value":"six"}]},"7":{"value":[{"type":0,"value":"seven"}]},"8":{"value":[{"type":0,"value":"eight"}]},"9":{"value":[{"type":0,"value":"nine"}]},"other":{"value":[{"type":1,"value":"numberOfWorkItems"}]}},"type":5,"value":"numberOfWorkItems"},{"type":0,"value":" items"}]}},"pluralType":"cardinal","type":6,"value":"numberOfWorkItems"},{"type":0,"value":"* to check on \u2014 here are three:"}],"post-office.growth.jira-assigned-nudge-digest.plural-cta-message":[{"type":0,"value":"See inactive "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"item"}]},"other":{"value":[{"type":0,"value":"items"}]}},"pluralType":"cardinal","type":6,"value":"numberOfWorkItems"}],"post-office.growth.jira-assigned-nudge-digest.top-projects-message":[{"type":0,"value":"Here are three to get you started:"}],"post-office.growth.jira-board-catch-up-rovo-nudge.secondary-title":[{"type":0,"value":"Get a quick summary of new issues and important activity."}],"post-office.growth.jira-board-catch-up-rovo-nudge.static-prompt":[{"type":0,"value":"Summarize the most recent activity on this Jira board. Create an executive-ready update (max ~8 bullets total) using this structure:\\n\\n1. Sprint / timeline context\\n- Current sprint or time window, dates, and high-level status (e.g. \\"on track / at risk / off track\\").\\n\\n2. Key progress / wins (2-4 bullets)\\n- Focus on issues that moved into In Progress, In Review / Pending Review, or Done in the selected period.\\n- For each, include: issue key, short description (3-7 words), and current status only (no technical deep dive).\\n\\n3. Blockers / risks (1-3 bullets)\\n- Call out any flagged issues, long-running items stuck in In Progress or In Review, or dependencies that could impact delivery for this sprint / period.\\n\\n4. Scope & pipeline (1-3 bullets)\\n- Highlight important newly created or To Do issues that are not yet started but are significant for upcoming milestones.\\n- Note if work is skewed toward setup/foundations vs user-visible outcomes.\\n\\n5. Next-focus recommendation (1-2 bullets)\\n- Recommend the 1-2 highest-leverage next actions to keep the team\'s objectives on track, referencing specific issue keys.\\n\\nOutput the answer as concise markdown bullets, optimized for an executive audience (outcomes, risks, and next moves over implementation details)."}],"post-office.growth.jira-board-catch-up-rovo-nudge.title":[{"type":0,"value":"Catch up on recent changes"}],"post-office.growth.recommendation-jpd.confluence-home-banner.description":[{"type":0,"value":"Make sure your team is building the right things with Jira Product Discovery."}],"post-office.growth.recommendation-jpd.confluence-home-banner.header":[{"type":0,"value":"Capture your ideas and customer feedback all in one place"}],"post-office.growth.recommendation-jpd.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Discovery Product Logo"}],"post-office.growth.recommendation-jsm.confluence-home-banner.description":[{"type":0,"value":"Automatically turn Slack, Teams, and email requests into tickets."}],"post-office.growth.recommendation-jsm.confluence-home-banner.header":[{"type":0,"value":"See the whole picture, from request to resolution"}],"post-office.growth.recommendation-jsm.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Service Management Product Logo"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.description":[{"type":0,"value":"See analytics and insights about what your team is working on at any moment"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.header":[{"type":0,"value":"Sync real-time data from Jira to any document in Confluence"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.description":[{"type":0,"value":"76% customers shipped projects faster after adding Confluence and Jira."}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.header":[{"type":0,"value":"Build world-class products, fast"}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.description":[{"type":0,"value":"Jira lets you view your project and tasks in a way that works for you and your team."}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.header":[{"type":0,"value":"Visualize any project in a list, board, backlog, and more"}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.jira-side-nav-first-party-recommendation.try-product":[{"type":0,"value":"Try Product"}],"post-office.jira-your-work-first-party-recommendation.learn-more":[{"type":0,"value":"Learn more"}],"post-office.jira-your-work-first-party-recommendation.learn-more.alt-text":[{"type":0,"value":"Discover more about "},{"type":1,"value":"product"}],"post-office.jira-your-work-first-party-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"post-office.jira-your-work-first-party-recommendation.try-product":[{"type":0,"value":"Try Product"}],"post-office.nav-4-projects-recommendations.cta-button-lozenge-try":[{"type":0,"value":"Try"}],"post-office.nav-4-projects-recommendations.reasons-modal-bullet-one-spork":[{"type":0,"value":"the tools you use (Jira)"}],"post-office.nav-4-projects-recommendations.reasons-modal-bullet-two-appify":[{"type":0,"value":"the way you use your existing tools and apps"}],"post-office.nav-4-projects-recommendations.reasons-modal-explanation":[{"type":0,"value":"We think "},{"type":1,"value":"productName"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"post-office.nav-4-projects-recommendations.section-heading":[{"type":0,"value":"Recommended"}],"post-office.nav-4-requested-item.cta-button-dimissal":[{"type":0,"value":"Dismiss"}],"post-office.nav-4-requested-item.cta-button-lozenge-pending":[{"type":0,"value":"Pending"}],"post-office.nav-4-requested-item.product-roadmap-icon-alt-text":[{"type":0,"value":"Icon for product roadmap"}],"post-office.nav-4-requested-item.work-requests-icon-alt-text":[{"type":0,"value":"Icon for work requests"}],"post-office.placement-v2-nav-4-section.requested-main-heading":[{"type":0,"value":"Requested"}],"post-office.test-placement.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}],"post-office.test-placement.test-message.dismiss-button.no-translate":[{"type":0,"value":"Dismiss"}],"post-office.test-placement.test-message.learn-more-button.no-translate":[{"type":0,"value":"Learn more"}],"recommendation-controls.existing-products":[{"type":0,"value":"your existing Atlassian products"}],"recommendation-controls.team-size":[{"type":0,"value":"the size of your team"}],"recommendations.ad-controls.dismiss-flag.not-interested.subtitle":[{"type":0,"value":"You won\u2019t see this here as often."}],"recommendations.ad-controls.dismiss-flag.not-interested.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"recommendations.ad-controls.reasons-modal.accept-button.label":[{"type":0,"value":"Ok"}],"recommendations.ad-controls.reasons-modal.accept-button.label-ok":[{"type":0,"value":"OK"}],"recommendations.ad-controls.reasons-modal.body":[{"type":0,"value":"We think that "},{"type":1,"value":"productName"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"recommendations.ad-controls.reasons-modal.privacy-policy-link.text":[{"type":0,"value":"Learn more about your data privacy with Atlassian"}],"recommendations.ad-controls.reasons-modal.title":[{"type":0,"value":"Why am I seeing this?"}],"rovo-3p-party-integration-admin-nudge.action.connect":[{"type":0,"value":"Connect now"}],"rovo-3p-party-integration-admin-nudge.action.learnMore":[{"type":0,"value":"Learn more"}],"rovo-3p-party-integration-admin-nudge.description.high-percentage-and-less-than-two-apps":[{"type":0,"value":"Over 90% of your team works with shared content. Connecting makes search and chat more useful for everyone."}],"rovo-3p-party-integration-admin-nudge.description.low-percentage":[{"type":0,"value":"Most of your team works with shared content. Connecting makes search and chat more useful for everyone."}],"rovo-3p-party-integration-admin-nudge.description.one-app":[{"type":1,"value":"percUsersConnected"},{"type":0,"value":"% of your team works with shared content. Connecting makes search and chat more useful for everyone."}],"rovo-3p-party-integration-admin-nudge.more-apps-label":[{"type":0,"value":"More apps"}],"rovo-3p-party-integration-admin-nudge.title.one-app":[{"type":0,"value":"Connect "},{"type":1,"value":"appName"}],"switcher.ad-controls.dropdown-item.not-interested.label":[{"type":0,"value":"Not interested"}],"switcher.ad-controls.dropdown-item.why-am-i-seeing-this.label":[{"type":0,"value":"Why am I seeing this?"}],"test":[{"type":0,"value":"default message"}]}');

});

parcelRegister("fBPjM", function(module, exports) {
module.exports = JSON.parse('{"cc-flywheel-feature-discovery.rovo-awareness-survey.question":[{"type":0,"value":"To what extent do you agree or disagree with the following statement?"}],"cc-flywheel-feature-discovery.rovo-awareness-survey.statement":[{"type":0,"value":"I\'m aware of Atlassian Rovo and its functionalities."}],"confluence-home-rovo-awareness.banner.ask-anything-cta":[{"type":0,"value":"Ask Rovo"}],"confluence-home-rovo-awareness.banner.description":[{"type":0,"value":"Let your AI teammate do the heavy lifting so you can focus on what matters. Just ask."}],"confluence-home-rovo-awareness.banner.dismiss-banner-cta":[{"type":0,"value":"Close banner"}],"confluence-home-rovo-awareness.banner.header":[{"type":0,"value":"Ask Rovo to get you up to speed, create automations, brainstorm ideas, and more."}],"confluence-home-rovo-awareness.banner.more-ideas-cta":[{"type":0,"value":"More ideas"}],"confluence-home-rovo-awareness.banner.search-bar-image-text":[{"type":0,"value":"If you Rovo, you know..."}],"confluence-home-rovo-awareness.carousel-modal.audio-description":[{"type":0,"value":"Rovo\u2032s audio briefings can fill you in on key information from your team.Just hit play and go for a walk."}],"confluence-home-rovo-awareness.carousel-modal.audio-title":[{"type":0,"value":"Get briefed on the go"}],"confluence-home-rovo-awareness.carousel-modal.carousel-image-alt":[{"type":0,"value":"New Feature"}],"confluence-home-rovo-awareness.carousel-modal.create-description":[{"type":0,"value":"You describe, Rovo creates. Pages, live docs, whiteboards, databases \u2014 Rovo does it all."}],"confluence-home-rovo-awareness.carousel-modal.create-title":[{"type":0,"value":"Bye-bye blank page"}],"confluence-home-rovo-awareness.carousel-modal.description":[{"type":0,"value":"Discover how you can use Rovo to make your life easier."}],"confluence-home-rovo-awareness.carousel-modal.diagram-description":[{"type":0,"value":"Rovo can draw the diagrams for you that clearly communicate your ideas."}],"confluence-home-rovo-awareness.carousel-modal.diagram-title":[{"type":0,"value":"Let flow charts flow"}],"confluence-home-rovo-awareness.carousel-modal.lozenge-coming-soon":[{"type":0,"value":"Coming soon"}],"confluence-home-rovo-awareness.carousel-modal.lozenge-new":[{"type":0,"value":"New"}],"confluence-home-rovo-awareness.carousel-modal.next-label":[{"type":0,"value":"Next"}],"confluence-home-rovo-awareness.carousel-modal.previous-label":[{"type":0,"value":"Previous"}],"confluence-home-rovo-awareness.carousel-modal.title":[{"type":0,"value":"More ways to Rovo"}],"post-office.confluence-create-with-rovo-side-nav-nudge.body":[{"type":0,"value":"With a simple prompt, Rovo can draft a page or whiteboard."}],"post-office.confluence-create-with-rovo-side-nav-nudge.call.to.action":[{"type":0,"value":"Show me how"}],"post-office.confluence-create-with-rovo-side-nav-nudge.dismiss":[{"type":0,"value":"Dismiss"}],"post-office.confluence-create-with-rovo-side-nav-nudge.heading":[{"type":0,"value":"You describe, Rovo creates"}],"post-office.confluence-maui-changeboarding.remix.spotlight-button":[{"type":0,"value":"Ok"}],"post-office.confluence-maui-changeboarding.remix.spotlight-header":[{"type":0,"value":"Transform your content"}],"post-office.confluence-maui-changeboarding.remix.spotlight-image-alt":[{"type":0,"value":"Remix content illustration"}],"post-office.confluence-maui-changeboarding.remix.spotlight-new-description":[{"type":0,"value":"Create charts, diagrams, and other content inspired by existing work."}],"post-office.confluence-maui-changeboarding.remix.spotlight-new-header":[{"type":0,"value":"Create custom visuals"}],"post-office.confluence-maui-changeboarding.remix.spotlight-tour-done-button":[{"type":0,"value":"Done"}],"post-office.confluence-maui-changeboarding.remix.spotlight-tour-next-button":[{"type":0,"value":"Next"}],"post-office.confluence-maui-changeboarding.remix.spotlight-tour-step-1-description":[{"type":0,"value":"Ask Rovo to make adjustments to your remix."}],"post-office.confluence-maui-changeboarding.remix.spotlight-tour-step-1-header":[{"type":0,"value":"Refine with Rovo"}],"post-office.confluence-maui-changeboarding.remix.spotlight-tour-step-2-copy-description":[{"type":0,"value":"Then paste it somewhere else in Confluence to view it later."}],"post-office.confluence-maui-changeboarding.remix.spotlight-tour-step-2-copy-header":[{"type":0,"value":"Copy this remix"}],"post-office.confluence-maui-changeboarding.remix.spotlight-tour-step-2-insert-description":[{"type":0,"value":"Add your remix directly to this content, or copy and paste it somewhere else."}],"post-office.confluence-maui-changeboarding.remix.spotlight-tour-step-2-insert-header":[{"type":0,"value":"Insert this remix"}],"post-office.confluence-maui-slides-create-spotlight.spotlight-button":[{"type":0,"value":"Ok"}],"post-office.confluence-maui-slides-create-spotlight.spotlight-description":[{"type":0,"value":"Turn rough ideas and existing content into polished slides in seconds."}],"post-office.confluence-maui-slides-create-spotlight.spotlight-header":[{"type":0,"value":"Create stunning presentations"}],"post-office.confluence-maui-slides-create-spotlight.spotlight-image-alt":[{"type":0,"value":"Create slides illustration"}],"post-office.confluence-maui-slides-edit-spotlight.spotlight-button":[{"type":0,"value":"Ok"}],"post-office.confluence-maui-slides-edit-spotlight.spotlight-description":[{"type":0,"value":"Use Rovo to add or remove slides, edit sections, change the tone, and more."}],"post-office.confluence-maui-slides-edit-spotlight.spotlight-header":[{"type":0,"value":"Refine slides with Rovo"}],"post-office.confluence-maui-slides-modal.description":[{"type":0,"value":"Create polished presentations with Rovo."}],"post-office.confluence-maui-slides-modal.dismiss":[{"type":0,"value":"Dismiss"}],"post-office.confluence-maui-slides-modal.feature-add-sources":[{"type":0,"value":"Add sources or links for context"}],"post-office.confluence-maui-slides-modal.feature-describe-presentation":[{"type":0,"value":"Start by describing your ideal presentation"}],"post-office.confluence-maui-slides-modal.feature-refine-slides":[{"type":0,"value":"Refine your slides with Rovo"}],"post-office.confluence-maui-slides-modal.got-it":[{"type":0,"value":"Got it"}],"post-office.confluence-maui-slides-modal.media-alt":[{"type":0,"value":"Slides feature illustration"}],"post-office.confluence-maui-slides-modal.title":[{"type":0,"value":"Welcome to Slides"}],"post-office.confluence-maui-slides-modal.try-it-out":[{"type":0,"value":"Create my own"}],"post-office.confluence-maui-slides-toolbar-spotlight.spotlight-button":[{"type":0,"value":"Ok"}],"post-office.confluence-maui-slides-toolbar-spotlight.spotlight-description":[{"type":0,"value":"Ask Rovo to rewrite, adjust tone, shorten or lengthen text, or apply other changes."}],"post-office.confluence-maui-slides-toolbar-spotlight.spotlight-header":[{"type":0,"value":"Make edits with Rovo"}],"post-office.confluence-object-sidebar-remix-changeboarding.spotlight-button":[{"type":0,"value":"Ok"}],"post-office.confluence-object-sidebar-remix-changeboarding.spotlight-description":[{"type":0,"value":"Transform content into slides, infographics, whiteboards, and more."}],"post-office.confluence-object-sidebar-remix-changeboarding.spotlight-header":[{"type":0,"value":"Remix this content"}],"post-office.confluence-object-sidebar-remix-changeboarding.spotlight-image-alt":[{"type":0,"value":"Remix content illustration"}]}');

});

parcelRegister("l90AK", function(module, exports) {
module.exports = JSON.parse("{\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.ctaMessageForIssueComment\":[{\"type\":0,\"value\":\"Try\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.descriptionForIssuecomment\":[{\"type\":0,\"value\":\"Use video to explain the work\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.loom\":[{\"type\":0,\"value\":\"Loom\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.titleForIssueComment\":[{\"type\":0,\"value\":\"Record your screen\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.ctaMessageForIssueDescription\":[{\"type\":0,\"value\":\"Try\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.descriptionForIssueDescription\":[{\"type\":0,\"value\":\"Use video to explain the work\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.loom\":[{\"type\":0,\"value\":\"Loom\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.titleForIssueDescription\":[{\"type\":0,\"value\":\"Record your screen\"}],\"post-office-template.app-switcher-discovery-section.description.no-translate\":[{\"type\":0,\"value\":\"Post Office app-switcher-discovery-section template message.\"}],\"post-office-template.app-switcher-discovery-section.title.no-translate\":[{\"type\":0,\"value\":\"Jira Software\"}],\"post-office-template.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"post-office-template.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"post-office-template.message-template.microsoft-teams.hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office-template.message-template.notification-drawer.message.no-translate\":[{\"type\":1,\"value\":\"actorName\"},{\"type\":0,\"value\":\" updated your page\"}],\"post-office-template.screen-space-flags.description.no-translate\":[{\"type\":0,\"value\":\"Replace this with a short summary of what this message tells the recipient.\"}],\"post-office-template.screen-space-flags.title.no-translate\":[{\"type\":0,\"value\":\"This is a Post Office Test Message\"}],\"post-office-template.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"post-office-template.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"post-office-template.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"post-office-template.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"post-office-template.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.components.{component-name}.{location-name}.{message-name}\":[{\"type\":0,\"value\":\"Example\"}],\"post-office.post-office-template.browser-push-body.no-translate\":[{\"type\":0,\"value\":\"You are a lovely\"}],\"post-office.post-office-template.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.post-office-template.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}]}");

});

parcelRegister("azX2I", function(module, exports) {
module.exports = JSON.parse('{"admin-hub.ci-test.message-template-template-hello-world":[{"type":0,"value":"Hello "},{"type":1,"value":"propA"},{"type":0,"value":". Is is a lovely "},{"type":1,"value":"propB"}],"ci-generation.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"ci-generation.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"ci-generation.email.body.img.alt":[{"type":0,"value":"This is the alt text for the image"}],"ci-generation.email.body.regards":[{"type":0,"value":"Team Post Office"}],"ci-generation.email.body.signoff":[{"type":0,"value":"Regards,"}],"ci-generation.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"ci-generation.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"post-office.test-message-digest-email-template.test-message.email.body.digest-title":[{"type":0,"value":"You have "},{"type":1,"value":"numberOfMsg"},{"type":0,"value":" new messages!"}],"post-office.test-message-digest-email-template.test-message.email.body.message-body":[{"type":1,"value":"defaultMessage"}],"post-office.test-message-digest-local-template.test-message.email.body.digest-title":[{"type":0,"value":"You have "},{"type":1,"value":"numberOfMsg"},{"type":0,"value":" new messages!"}],"post-office.test-message-digest-local-template.test-message.email.body.message-body":[{"type":1,"value":"defaultMessage"}],"post-office.test-message-microsoft-teams.sample-hello-message":[{"type":0,"value":"Hello, this is test message from Post Office: "},{"type":1,"value":"text"}],"post-office.test-message.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"},{"type":0,"value":"."}],"post-office.test-messages.test-message-config-sets.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-messages.test-message-digest-slack-v2.heading.no-translate":[{"type":0,"value":"Post Office Slack digest v2 delivered "},{"type":1,"value":"count"},{"type":0,"value":" messages"}],"post-office.test-messages.test-message-digest-slack-v2.item.no-translate":[{"type":0,"value":"V2 item: "},{"type":1,"value":"message"}],"post-office.test-messages.test-message-lifecycle-email-recipients.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-messages.test-message-lifecycle.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-messages.test-message-load-test-push-flow-email-mobile-push.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.test-messages.test-message-mobile-push-jira-ugc.redacted.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a redacted test mobile push notification from post office."}],"post-office.test-messages.test-message-mobile-push-jira-ugc.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.test-messages.test-message-mobile-push.greeting.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.test-messages.test-message-mobile-push.redacted.greeting.no-translate":[{"type":0,"value":"Hello, this is a redacted mobile push notification test from post office."}],"post-office.test-messages.test-message-no-tracking.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-messages.test-message-slack-experiment-exposure.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-messages.test-message-transform-metadata.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-messages.test-slack-notification-v2.sample-hello-message.no-translate":[{"type":0,"value":"Post Office Slack digest v2 source: "},{"type":1,"value":"message"}],"post-office.test-slack-notification.sample-hello-message":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"product-store-personal-use-case.hello-world":[{"type":0,"value":"Hello. Is is a lovely"}],"test-message.test-message-email-onboarding-test.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-message.test-message-email-onboarding-test.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-message.test-message-email-onboarding-test.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-message.test-message-email-onboarding-test.test-message.email.body.no-translate":[{"type":0,"value":"This is an test onboarding message for "},{"type":1,"value":"team"},{"type":0,"value":" team from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-message.test-message-email-onboarding-test.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-message.test-message-email-onboarding-test.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-message.test-message-email-onboarding-test.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.app-switcher-discovery-section.dismiss":[{"type":0,"value":"Dismiss"}],"test-messages.app-switcher-discovery-section.test-content":[{"type":0,"value":"This is a test message."}],"test-messages.app-switcher-upgrade-section.dismiss":[{"type":0,"value":"Dismiss"}],"test-messages.app-switcher-upgrade-section.test-content":[{"type":0,"value":"This is a test message."}],"test-messages.email.body.regards":[{"type":0,"value":"Team Post Office"}],"test-messages.in-app-example.hello-world":[{"type":0,"value":"Hello "},{"type":1,"value":"propA"},{"type":0,"value":". Is is a lovely "},{"type":1,"value":"propB"}],"test-messages.in-app-notification-comment-rollup.second-comment":[{"type":1,"value":"actor"},{"type":0,"value":" commented on a page"}],"test-messages.in-app-notification-mention-rollup.first-comment":[{"type":1,"value":"reactor"},{"type":0,"value":" mentioned you in a comment"}],"test-messages.in-app-notification-reaction-rollup.many-actors":[{"type":1,"value":"actor1Name"},{"type":0,"value":" and "},{"type":1,"value":"otherActorsCount"},{"type":0,"value":" others reacted to your page"}],"test-messages.in-app-notification-reaction-rollup.one-actor":[{"type":1,"value":"actor1Name"},{"type":0,"value":" reacted to your page"}],"test-messages.in-app-notification-reaction-rollup.two-actors":[{"type":1,"value":"actor1Name"},{"type":0,"value":" and "},{"type":1,"value":"actor2Name"},{"type":0,"value":" reacted to your page"}],"test-messages.in-app-notification.email-onboarding.body":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":", This is an onboarding test message for "},{"type":1,"value":"team"},{"type":0,"value":" team."}],"test-messages.in-app-notification.email-onboarding.title":[{"type":0,"value":"Welcome!"}],"test-messages.in-app-notification.title":[{"type":0,"value":"Test Notification "},{"type":1,"value":"title"}],"test-messages.jira-navigation-topbar-edition-awareness.hello-world":[{"type":0,"value":"Hello "},{"type":1,"value":"propA"},{"type":0,"value":". Is is a lovely "},{"type":1,"value":"propB"}],"test-messages.post-office-gold-1.description.no-translate":[{"type":0,"value":"Post Office Gold test message."}],"test-messages.post-office-gold-1.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"test-messages.redacted-email.body.regards":[{"type":0,"value":"Team Post Office"}],"test-messages.team-message-email-ugc.message-template.email.redacted.subject.no-translate":[{"type":0,"value":"Post Office Redacted Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-client-generation.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-client-generation.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-client-generation.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-client-generation.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-client-generation.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-client-generation.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-client-generation.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-config-sets.in-app.cs-0.flag.body.no-translate":[{"type":0,"value":"This is the cs-0 test message body"}],"test-messages.test-message-config-sets.in-app.cs-0.flag.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message (cs-0)"}],"test-messages.test-message-config-sets.in-app.cs-0.learn-more.no-translate":[{"type":0,"value":"Learn more"}],"test-messages.test-message-config-sets.in-app.flag.body.no-translate":[{"type":0,"value":"This is the test message body"}],"test-messages.test-message-config-sets.in-app.flag.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"test-messages.test-message-config-sets.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-config-sets.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-config-sets.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-config-sets.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-config-sets.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-config-sets.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-config-sets.test-message.email.body.tracked-link.no-translate":[{"type":0,"value":"Click here to visit Atlassian"}],"test-messages.test-message-config-sets.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-content-diffing.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-content-diffing.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-content-diffing.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-content-diffing.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-content-diffing.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-content-diffing.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-content-diffing.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-delivery-control.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-delivery-control.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-delivery-control.message-template.in-app-notification.body.no-translate":[{"type":1,"value":"body"}],"test-messages.test-message-delivery-control.message-template.in-app-notification.title.no-translate":[{"type":0,"value":"Template Notification "},{"type":1,"value":"title"}],"test-messages.test-message-delivery-control.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-delivery-control.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-delivery-control.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-delivery-control.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-delivery-control.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-digest-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-digest-email.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-digest-email.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hey "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-digest-email.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment. Here is your daily digest (rick) rollup for the "},{"type":1,"value":"site"},{"type":0,"value":" workspace"}],"test-messages.test-message-digest-email.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-digest-email.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-digest-email.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-digest-local.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-digest-local.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-digest-local.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hey "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-digest-local.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment. Here is your daily digest (rick) rollup for the "},{"type":1,"value":"site"},{"type":0,"value":" workspace"}],"test-messages.test-message-digest-local.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-digest-local.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-digest-local.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-cdn.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-cdn.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-cdn.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-cdn.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-cdn.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-cdn.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-cdn.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-experiment-exposure.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-experiment-exposure.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-experiment-exposure.test-message.email.body.button.no-translate":[{"type":0,"value":"Click me!"}],"test-messages.test-message-email-experiment-exposure.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-experiment-exposure.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-experiment-exposure.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-experiment-exposure.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-experiment-exposure.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-high-priority.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-high-priority.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-high-priority.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-high-priority.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-high-priority.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-high-priority.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-high-priority.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-log-dropping.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-log-dropping.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-log-dropping.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-log-dropping.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-log-dropping.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-log-dropping.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-log-dropping.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-low-priority.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-low-priority.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-low-priority.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-low-priority.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-low-priority.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-low-priority.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-low-priority.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-mfc.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-mfc.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-mfc.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-mfc.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-mfc.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-mfc.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-mfc.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-ugc.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-ugc.message-template-template.email.redacted.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-ugc.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-ugc.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-ugc.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-ugc.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-ugc.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-ugc.test-message.email.redacted.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-ugc.test-message.email.redacted.body.no-translate":[{"type":0,"value":"This is a redacted test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-ugc.test-message.email.redacted.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-ugc.test-message.email.redacted.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-ugc.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-grouped-recipients.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"test-messages.test-message-grouped-recipients.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-grouped-recipients.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-grouped-recipients.test-message.email.body.hello":[{"type":0,"value":"Hello"}],"test-messages.test-message-grouped-recipients.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-grouped-recipients.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"test-messages.test-message-grouped-recipients.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-in-app-notification-comment-rollup.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-in-app-notification-comment-rollup.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office test-message-in-app-notification-comment-rollup "},{"type":1,"value":"env"}],"test-messages.test-message-in-app-notification-comment-rollup.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-in-app-notification-comment-rollup.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-in-app-notification-comment-rollup.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-in-app-notification-comment-rollup.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-in-app-notification-comment-rollup.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-in-app-notification-mention-rollup.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-in-app-notification-mention-rollup.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office test-message-in-app-notification-mention-rollup "},{"type":1,"value":"env"}],"test-messages.test-message-in-app-notification-mention-rollup.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-in-app-notification-mention-rollup.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-in-app-notification-mention-rollup.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-in-app-notification-mention-rollup.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-in-app-notification-mention-rollup.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-in-app-notification-reaction-rollup.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-in-app-notification-reaction-rollup.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office test-message-in-app-notification-reaction-rollup "},{"type":1,"value":"env"}],"test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-in-app-notification.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-in-app-notification.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office test-message-in-app-notification "},{"type":1,"value":"env"}],"test-messages.test-message-in-app-notification.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-in-app-notification.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-in-app-notification.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-in-app-notification.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-in-app-notification.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-inapp-engagement.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-inapp-engagement.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-inapp-engagement.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-inapp-engagement.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-inapp-engagement.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-inapp-engagement.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-inapp-engagement.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-inapp-ep-modal.confirm.no-translate":[{"type":0,"value":"OK"}],"test-messages.test-message-inapp-ep-modal.description.no-translate":[{"type":0,"value":"We\'re also improving how we incorporate the terms you use to define work, so that Jira speaks your language \u2014 no matter what you\'re working on."}],"test-messages.test-message-inapp-ep-modal.read-more.no-translate":[{"type":0,"value":"Read more"}],"test-messages.test-message-inapp-ep-modal.title.no-translate":[{"type":0,"value":"\'Work\' is the new term for items tracked in Jira"}],"test-messages.test-message-inapp-implicit-pendo.description.no-translate":[{"type":0,"value":"Implicit Pendo test message."}],"test-messages.test-message-inapp-implicit-pendo.title.no-translate":[{"type":0,"value":"Conquering "},{"type":1,"value":"planet"},{"type":0,"value":" is "},{"type":1,"value":"status"}],"test-messages.test-message-inapp.description.no-translate":[{"type":0,"value":"Post Office in-app test message."}],"test-messages.test-message-inapp.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"test-messages.test-message-lifecycle-email-recipients.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-lifecycle-email-recipients.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-lifecycle-email-recipients.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-lifecycle-email-recipients.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-lifecycle-email-recipients.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-lifecycle-email-recipients.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-lifecycle-email-recipients.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-lifecycle.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-lifecycle.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-lifecycle.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-lifecycle.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-lifecycle.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-lifecycle.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Kind Regards,"}],"test-messages.test-message-lifecycle.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-link-tracking.email.heading.no-translate":[{"type":0,"value":"Origin Tracing \u2014 Tracked Link Test ("},{"type":1,"value":"env"},{"type":0,"value":")"}],"test-messages.test-message-link-tracking.email.intro.no-translate":[{"type":0,"value":"This email tests Post Office tracked links. Tracked links go through the Post Office redirect service; plain links do not. Click each link and inspect the redirect URL to verify origin tracing."}],"test-messages.test-message-link-tracking.email.tracked-link-atl-origin.no-translate":[{"type":0,"value":"TrackedLink with atlOrigin param"}],"test-messages.test-message-link-tracking.email.tracked-link-atlassian.no-translate":[{"type":0,"value":"TrackedLink to https://atlassian.com"}],"test-messages.test-message-link-tracking.email.tracked-link-external.no-translate":[{"type":0,"value":"TrackedLink to https://www.example.com (non-Atlassian)"}],"test-messages.test-message-link-tracking.email.tracked-link-pdf.no-translate":[{"type":0,"value":"TrackedLink to PDF"}],"test-messages.test-message-link-tracking.email.tracked-link-tenanted.no-translate":[{"type":0,"value":"TrackedLink to https://hello.atlassian.net/wiki/home (tenanted)"}],"test-messages.test-message-link-tracking.email.tracked-section.no-translate":[{"type":0,"value":"Tracked links"}],"test-messages.test-message-link-tracking.email.unsubscribe.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-link-tracking.email.untracked-link-atl-origin.no-translate":[{"type":0,"value":"Plain link with atlOrigin param"}],"test-messages.test-message-link-tracking.email.untracked-link-atlassian.no-translate":[{"type":0,"value":"Plain link to https://atlassian.com"}],"test-messages.test-message-link-tracking.email.untracked-link-external.no-translate":[{"type":0,"value":"Plain link to https://www.example.com (non-Atlassian)"}],"test-messages.test-message-link-tracking.email.untracked-link-pdf.no-translate":[{"type":0,"value":"Plain link to PDF"}],"test-messages.test-message-link-tracking.email.untracked-link-tenanted.no-translate":[{"type":0,"value":"Plain link to https://hello.atlassian.net/wiki/home (tenanted)"}],"test-messages.test-message-link-tracking.email.untracked-section.no-translate":[{"type":0,"value":"Plain (untracked) links"}],"test-messages.test-message-load-test-push-flow-email-mobile-push.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-load-test-push-flow-email-mobile-push.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-marketing.app-switcher-discovery-section.description.no-translate":[{"type":0,"value":"Post Office app-switcher-discovery-section marketing test message."}],"test-messages.test-message-marketing.app-switcher-discovery-section.title.no-translate":[{"type":0,"value":"Jira Software"}],"test-messages.test-message-marketing.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-marketing.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-marketing.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-marketing.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-marketing.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-marketing.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-marketing.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-message-failures.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-message-failures.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-message-failures.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-message-failures.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-message-failures.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-message-failures.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-message-failures.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-nd-ni-influents-mapper.influents.message-main.no-translate":[{"type":0,"value":"Main line ("},{"type":1,"value":"text"},{"type":0,"value":")"}],"test-messages.test-message-nd-ni-influents-mapper.ingestion.action.no-translate":[{"type":0,"value":"Open ("},{"type":1,"value":"emoji"},{"type":0,"value":")"}],"test-messages.test-message-nd-ni-influents-mapper.ingestion.entity.no-translate":[{"type":0,"value":"Entity for "},{"type":1,"value":"team"}],"test-messages.test-message-nd-ni-influents-mapper.ingestion.path.no-translate":[{"type":0,"value":"Path ("},{"type":1,"value":"team"},{"type":0,"value":")"}],"test-messages.test-message-nd-ni-influents-mapper.ingestion.title.no-translate":[{"type":0,"value":"Team "},{"type":1,"value":"teamName"},{"type":0,"value":" update"}],"test-messages.test-message-no-tracking.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-no-tracking.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-no-tracking.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-no-tracking.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-no-tracking.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-no-tracking.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-no-tracking.test-message.email.body.tracked-link.no-translate":[{"type":0,"value":"This is a TrackedLink that isn\'t being tracked!"}],"test-messages.test-message-no-tracking.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-notifications-platform.message-template.notification-drawer.message.no-translate":[{"type":1,"value":"actorName"},{"type":0,"value":" updated your page"}],"test-messages.test-message-persona-email.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"test-messages.test-message-persona-email.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-persona-email.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-persona-email.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-persona-email.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"test-messages.test-message-persona-email.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-raw-recipients.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-raw-recipients.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-raw-recipients.test-message.email.body.greeting.no-translate":[{"type":1,"value":"greeting"}],"test-messages.test-message-raw-recipients.test-message.email.body.hello.name.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-raw-recipients.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi,"}],"test-messages.test-message-raw-recipients.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-raw-recipients.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-raw-recipients.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-raw-recipients.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-tap-ingestion-trigger-subscription.description.no-translate":[{"type":0,"value":"TAP ingestion trigger subscription test message."}],"test-messages.test-message-tap-ingestion-trigger-subscription.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-tap-ingestion-trigger-subscription.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-tap-ingestion-trigger-subscription.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-tap-ingestion-trigger-subscription.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-tap-ingestion-trigger-subscription.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-tap-ingestion-trigger-subscription.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-tap-ingestion-trigger-subscription.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-tap-ingestion-trigger-subscription.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"test-messages.test-message-transform-metadata.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-transform-metadata.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-transform-metadata.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-transform-metadata.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-transform-metadata.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-transform-metadata.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-transform-metadata.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message.app.img.alt.large":[{"type":0,"value":"test image 2"}],"test-messages.test-message.app.img.alt.plant":[{"type":0,"value":"test image 1"}],"test-messages.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment. "},{"type":1,"value":"additionalBody"}],"test-messages.test-message.email.body.hello":[{"type":0,"value":"Hi Atlassian,"}],"test-messages.test-message.email.body.img.alt":[{"type":0,"value":"this is the alt for the test-message-email message template"}],"test-messages.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"test-messages.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message.redacted-email.body":[{"type":0,"value":"This is the redacted version of the test email message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment. "},{"type":1,"value":"additionalBody"}],"test-messages.test-message.redacted-email.body.hello":[{"type":0,"value":"Hi Atlassian,"}],"test-messages.test-message.redacted-email.body.img.alt":[{"type":0,"value":"this is the alt for the test-message-email message template"}],"test-messages.test-message.redacted-email.body.signoff":[{"type":0,"value":"Regards,"}],"test-messages.test-message.redacted-email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"wac-global-nav-product-recommendation.hello-world":[{"type":0,"value":"Hello. Is is a lovely"}]}');

});

parcelRegister("gkHoc", function(module, exports) {
$parcel$export(module.exports, "default", () => $be402bcc938fe0c2$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $be402bcc938fe0c2$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("58FyF", function(module, exports) {
$parcel$export(module.exports, "default", () => $3bddefb3ed7cf5f3$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $3bddefb3ed7cf5f3$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});

parcelRegister("fGXGw", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");


var $bl5yp = parcelRequire("bl5yp");

function $3ba3c538e2294e67$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $3ba3c538e2294e67$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $3ba3c538e2294e67$var$start() {
    $3ba3c538e2294e67$var$cleanup();
    $3ba3c538e2294e67$var$unbindEvents = (0, $cbY7C.bindAll)(window, [
        {
            type: 'dragover',
            listener: $3ba3c538e2294e67$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $3ba3c538e2294e67$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $3ba3c538e2294e67$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $3ba3c538e2294e67$var$cleanup
        },
        ...(0, $bl5yp.getBindingsForBrokenDrags)({
            onDragEnd: $3ba3c538e2294e67$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $3ba3c538e2294e67$var$cleanup() {
    $3ba3c538e2294e67$var$unbindEvents?.();
    $3ba3c538e2294e67$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $3ba3c538e2294e67$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $3ba3c538e2294e67$var$cleanup();
}
const $3ba3c538e2294e67$export$453c0582481cc59d = {
    start: $3ba3c538e2294e67$var$start,
    stop: $3ba3c538e2294e67$var$stop
};
module.exports["preventUnhandled"] = $3ba3c538e2294e67$export$453c0582481cc59d;

});

parcelRegister("etoPX", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $63a5cd591bbe1860$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z" clip-rule="evenodd"/>
</svg>
`;
const $63a5cd591bbe1860$export$e23ae35269442b4f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Rovo" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $63a5cd591bbe1860$var$svg,
            label: label,
            type: "rovo",
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function RovoIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $63a5cd591bbe1860$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["RovoIcon"] = $63a5cd591bbe1860$export$e23ae35269442b4f;

});

parcelRegister("lkYE1", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $1eVGO = parcelRequire("1eVGO");

//      
var $f88a81f3886ec3a5$var$charCodeOfDot = ".".charCodeAt(0);
var $f88a81f3886ec3a5$var$reEscapeChar = /\\(\\)?/g;
var $f88a81f3886ec3a5$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f88a81f3886ec3a5$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $f88a81f3886ec3a5$var$charCodeOfDot) result.push("");
    string.replace($f88a81f3886ec3a5$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($f88a81f3886ec3a5$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $f88a81f3886ec3a5$var$keysCache = {};
var $f88a81f3886ec3a5$var$keysRegex = /[.[\]]+/;
var $f88a81f3886ec3a5$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($f88a81f3886ec3a5$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $f88a81f3886ec3a5$var$keysCache[key] = key.split($f88a81f3886ec3a5$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $f88a81f3886ec3a5$var$keysCache[key] = $f88a81f3886ec3a5$var$stringToPath(key);
    }
    return $f88a81f3886ec3a5$var$keysCache[key];
};
//      
var $f88a81f3886ec3a5$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $f88a81f3886ec3a5$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $f88a81f3886ec3a5$var$_toPropertyKey(arg) {
    var key = $f88a81f3886ec3a5$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f88a81f3886ec3a5$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f88a81f3886ec3a5$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $1eVGO.default)(current, [
                key
            ].map($f88a81f3886ec3a5$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $eb3ax.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $f88a81f3886ec3a5$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $f88a81f3886ec3a5$var$setInRecursor(state, 0, $f88a81f3886ec3a5$var$toPath(key), value1, destroyArrays);
};
var $f88a81f3886ec3a5$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $f88a81f3886ec3a5$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $f88a81f3886ec3a5$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $f88a81f3886ec3a5$export$c52e5867d5879e24(values, name);
    var error = $f88a81f3886ec3a5$export$c52e5867d5879e24(errors, name);
    if (error && error[$f88a81f3886ec3a5$export$735bebc8ffabf28a]) error = error[$f88a81f3886ec3a5$export$735bebc8ffabf28a];
    var submitError = submitErrors && $f88a81f3886ec3a5$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $f88a81f3886ec3a5$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f88a81f3886ec3a5$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $f88a81f3886ec3a5$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $f88a81f3886ec3a5$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $f88a81f3886ec3a5$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f88a81f3886ec3a5$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $f88a81f3886ec3a5$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $f88a81f3886ec3a5$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $f88a81f3886ec3a5$var$subscriptionFilter(result, state, previousState, subscription, $f88a81f3886ec3a5$export$41e855cb628c1b55, $f88a81f3886ec3a5$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $f88a81f3886ec3a5$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $f88a81f3886ec3a5$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $f88a81f3886ec3a5$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $f88a81f3886ec3a5$var$subscriptionFilter(result, state, previousState, subscription, $f88a81f3886ec3a5$export$f1ff97b9d1c7a3c3, $f88a81f3886ec3a5$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $f88a81f3886ec3a5$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$f88a81f3886ec3a5$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $f88a81f3886ec3a5$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $f88a81f3886ec3a5$export$83d89fbfd8236492 = "4.20.10";
var $f88a81f3886ec3a5$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $f88a81f3886ec3a5$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $f88a81f3886ec3a5$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $f88a81f3886ec3a5$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $f88a81f3886ec3a5$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $f88a81f3886ec3a5$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $f88a81f3886ec3a5$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $f88a81f3886ec3a5$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($f88a81f3886ec3a5$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $f88a81f3886ec3a5$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $eb3ax.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $eb3ax.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $eb3ax.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $eb3ax.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $eb3ax.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $f88a81f3886ec3a5$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $f88a81f3886ec3a5$export$e6bdf135a54e021b,
                    shallowEqual: $f88a81f3886ec3a5$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $eb3ax.default)({}, state.formState.values)); // clone to avoid writing
            if ($f88a81f3886ec3a5$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f88a81f3886ec3a5$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $f88a81f3886ec3a5$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $eb3ax.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $eb3ax.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $f88a81f3886ec3a5$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $f88a81f3886ec3a5$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $f88a81f3886ec3a5$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$f88a81f3886ec3a5$export$735bebc8ffabf28a]) {
                    var existing = $f88a81f3886ec3a5$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$f88a81f3886ec3a5$export$735bebc8ffabf28a] = error[$f88a81f3886ec3a5$export$735bebc8ffabf28a];
                    merged = $f88a81f3886ec3a5$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$f88a81f3886ec3a5$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$f88a81f3886ec3a5$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $eb3ax.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $f88a81f3886ec3a5$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $f88a81f3886ec3a5$var$notify(fieldSubscriber, fieldState, lastFieldState, $f88a81f3886ec3a5$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $f88a81f3886ec3a5$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $eb3ax.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, key), $f88a81f3886ec3a5$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, key), $f88a81f3886ec3a5$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$f88a81f3886ec3a5$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f88a81f3886ec3a5$var$hasAnyError(formState.submitErrors));
        var nextFormState = $f88a81f3886ec3a5$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $f88a81f3886ec3a5$var$notify(state.subscribers, nextFormState, lastFormState, $f88a81f3886ec3a5$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $eb3ax.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $eb3ax.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $eb3ax.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, key), $f88a81f3886ec3a5$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $f88a81f3886ec3a5$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $f88a81f3886ec3a5$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, name) === $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $eb3ax.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $eb3ax.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $eb3ax.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $f88a81f3886ec3a5$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$f88a81f3886ec3a5$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $eb3ax.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $f88a81f3886ec3a5$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $f88a81f3886ec3a5$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $f88a81f3886ec3a5$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f88a81f3886ec3a5$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}
module.exports["getIn"] = $f88a81f3886ec3a5$export$c52e5867d5879e24;
module.exports["FORM_ERROR"] = $f88a81f3886ec3a5$export$97cd7fc25dd32915;
module.exports["fieldSubscriptionItems"] = $f88a81f3886ec3a5$export$41e855cb628c1b55;
module.exports["formSubscriptionItems"] = $f88a81f3886ec3a5$export$f1ff97b9d1c7a3c3;
module.exports["version"] = $f88a81f3886ec3a5$export$83d89fbfd8236492;
module.exports["createForm"] = $f88a81f3886ec3a5$export$f681a8129d2e9d28;

});

parcelRegister("19ZlF", function(module, exports) {

var $lkYE1 = parcelRequire("lkYE1");

//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $0d863840e9077425$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $0d863840e9077425$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($0d863840e9077425$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $0d863840e9077425$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $lkYE1.getIn)(errors, input.name);
    });
};
//      
var $0d863840e9077425$var$noop = function noop() {};
var $0d863840e9077425$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $0d863840e9077425$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $0d863840e9077425$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $0d863840e9077425$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $0d863840e9077425$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($0d863840e9077425$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$0d863840e9077425$export$2e2bcd8739ae039 = $0d863840e9077425$var$createDecorator;
module.exports["default"] = $0d863840e9077425$export$2e2bcd8739ae039;

});

parcelRegister("lSFbL", function(module, exports) {

var $2itBe = parcelRequire("2itBe");

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $fede975c1f302c4c$var$set(object, path, value) {
    return object == null ? object : $2itBe(object, path, value);
}
module.exports = $fede975c1f302c4c$var$set;

});

parcelRegister("bcDqz", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $arQY7 = parcelRequire("arQY7");


var $fM984 = parcelRequire("fM984");


var $dpsRj = parcelRequire("dpsRj");


var $aRyr7 = parcelRequire("aRyr7");


var $6JrSr = parcelRequire("6JrSr");


var $8FgJC = parcelRequire("8FgJC");


var $iFlah = parcelRequire("iFlah");


var $iDrrr = parcelRequire("iDrrr");


var $4n1IT = parcelRequire("4n1IT");


var $lpNn5 = parcelRequire("lpNn5");


var $flNGL = parcelRequire("flNGL");


var $j9iLd = parcelRequire("j9iLd");


var $91JJR = parcelRequire("91JJR");


var $f4ONb = parcelRequire("f4ONb");


var $6oFjM = parcelRequire("6oFjM");


var $eyQF5 = parcelRequire("eyQF5");


var $942TG = parcelRequire("942TG");


var $68jmg = parcelRequire("68jmg");


var $g2o3j = parcelRequire("g2o3j");

const $6574fd66b51c7dea$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $6574fd66b51c7dea$var$AvatarGroup = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { appearance: t1, avatar: t2, borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: t3, size: t4, testId: testId, label: t5, moreIndicatorLabel: moreIndicatorLabel, tooltipPosition: t6, shouldPopupRenderToParent: t7 } = t0;
    const appearance = t1 === undefined ? "stack" : t1;
    const avatar = t2 === undefined ? (0, $arQY7.default) : t2;
    const showMoreButtonProps = t3 === undefined ? {} : t3;
    const size = t4 === undefined ? "medium" : t4;
    const label = t5 === undefined ? "avatar group" : t5;
    const tooltipPosition = t6 === undefined ? "bottom" : t6;
    const shouldPopupRenderToParent = t7 === undefined ? false : t7;
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $cozmU.useState)(false);
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    let t8;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = ()=>setIsOpen(false);
        $[0] = t8;
    } else t8 = $[0];
    const onClose = t8;
    let t9;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (event)=>{
            const { clientX: clientX, clientY: clientY, type: type } = event;
            if (type === "keydown" || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
            setIsOpen($6574fd66b51c7dea$var$_temp);
        };
        $[1] = t9;
    } else t9 = $[1];
    const handleTriggerClicked = t9;
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $aRyr7.default)();
    const { AvatarGroupItem: avatarGroupItemOverrides, Avatar: avatarOverrides, MoreIndicator: moreIndicatorOverrides } = (0, $91JJR.getOverrides)(overrides);
    let t10;
    let t11;
    if ($[2] !== isFocused || $[3] !== isOpen) {
        t10 = ()=>{
            if (!isOpen) setTriggeredUsingKeyboard(false);
            if ((0, $iDrrr.fg)("platform-dst-top-layer")) return 0, $dpsRj.default;
            if (!isFocused) return 0, $dpsRj.default;
            if (isOpen) return 0, $dpsRj.default;
            (0, $cbY7C.bind)(window, {
                type: "keydown",
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $fM984.KEY_DOWN)) {
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
            const unbind = ()=>{
                (0, $cbY7C.bind)(window, {
                    type: "keydown",
                    listener: function openOnKeyDown(e_0) {
                        if (e_0.key === (0, $fM984.KEY_DOWN)) {
                            e_0.preventDefault();
                            handleTriggerClicked(e_0);
                        }
                    }
                });
            };
            return unbind;
        };
        t11 = [
            isFocused,
            isOpen,
            handleTriggerClicked
        ];
        $[2] = isFocused;
        $[3] = isOpen;
        $[4] = t10;
        $[5] = t11;
    } else {
        t10 = $[4];
        t11 = $[5];
    }
    (0, $cozmU.useEffect)(t10, t11);
    const renderMoreDropdown = function renderMoreDropdown(max, total, labelId) {
        if (total <= max) return null;
        const renderMoreButton = (t12)=>{
            const { "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, onClick: onClick, ...props } = t12;
            return moreIndicatorOverrides.render((0, $942TG.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                moreIndicatorLabel: moreIndicatorLabel,
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                onClick: onClick,
                ...props
            });
        };
        if (typeof onMoreClick === "function") return renderMoreButton({
            onClick: onMoreClick
        });
        if ((0, $iDrrr.fg)("platform-dst-top-layer")) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $j9iLd.MoreDropdownTopLayer), {
            isOpen: isOpen,
            onClose: onClose,
            isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
            data: data,
            max: max,
            overrides: overrides,
            onAvatarClick: onAvatarClick,
            testId: testId,
            labelId: labelId,
            renderMoreButton: renderMoreButton,
            handleTriggerClicked: handleTriggerClicked,
            bindFocus: bindFocus
        });
        const boundary = boundariesElement === "scrollParent" ? "clippingParents" : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === "scrollParent") return;
            return boundariesElement === "window" ? "document" : "viewport";
        })();
        const avatarComponent = avatar ?? undefined;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4n1IT.Popup), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: 510,
            shouldRenderToParent: shouldPopupRenderToParent,
            content: (t13)=>{
                const { setInitialFocusRef: setInitialFocusRef } = t13;
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6oFjM.default), {
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eyQF5.default), {
                        onClick: $6574fd66b51c7dea$var$_temp2,
                        minWidth: 250,
                        maxHeight: 300,
                        setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8FgJC.default), {
                            titleId: labelId,
                            testId: `${testId}--section`,
                            children: data.slice(max).map((avatarData, index)=>avatarGroupItemOverrides.render((0, $flNGL.default), {
                                    avatar: avatarData,
                                    avatarComponent: avatarComponent,
                                    onAvatarClick: onAvatarClick,
                                    avatarOverrides: avatarOverrides,
                                    testId: testId && `${testId}--avatar-group-item-${index + max}`,
                                    index: index + max
                                }, index + max))
                        })
                    })
                });
            },
            trigger: (triggerProps)=>(0, $iDrrr.fg)("platform-dst-motion-uplift") ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iFlah.default), {
                    enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                    children: renderMoreButton({
                        ...triggerProps,
                        ...bindFocus,
                        onClick: handleTriggerClicked
                    })
                }) : renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    };
    const max_0 = maxCount === undefined || maxCount === 0 ? $6574fd66b51c7dea$var$MAX_COUNT[appearance] : maxCount;
    const total_0 = data.length;
    const maxAvatar = total_0 > max_0 ? max_0 - 1 : max_0;
    const groupId = (0, $6JrSr.useId)();
    return appearance === "stack" ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $68jmg.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        size: size,
        children: [
            data.slice(0, maxAvatar).map((avatarData_0, idx)=>{
                const callback = avatarData_0.onClick || onAvatarClick;
                const finalAvatar = avatarOverrides.render(avatar, {
                    ...avatarData_0,
                    size: size,
                    borderColor: borderColor || avatarData_0.borderColor,
                    testId: testId && `${testId}--avatar-${idx}`,
                    onClick: callback ? (event_0, analyticsEvent)=>{
                        callback(event_0, analyticsEvent, idx);
                    } : undefined,
                    stackIndex: max_0 - idx
                }, idx);
                if ((0, $iDrrr.fg)("platform-dst-motion-uplift")) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iFlah.default), {
                    enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                    children: !isTooltipDisabled && !avatarData_0.isDisabled ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                        content: avatarData_0.name,
                        testId: testId && `${testId}--tooltip-${idx}`,
                        position: tooltipPosition,
                        children: finalAvatar
                    }) : finalAvatar
                }, (0, $g2o3j.composeUniqueKey)(avatarData_0, idx));
                else return !isTooltipDisabled && !avatarData_0.isDisabled ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                    content: avatarData_0.name,
                    testId: testId && `${testId}--tooltip-${idx}`,
                    position: tooltipPosition,
                    children: finalAvatar
                }, (0, $g2o3j.composeUniqueKey)(avatarData_0, idx)) : finalAvatar;
            }),
            renderMoreDropdown(+maxAvatar, total_0, groupId)
        ]
    }) : /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $f4ONb.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        children: [
            data.slice(0, maxAvatar).map((avatarData_1, idx_0)=>{
                const callback_0 = avatarData_1.onClick || onAvatarClick;
                const finalAvatar_0 = avatarOverrides.render(avatar, {
                    ...avatarData_1,
                    size: size,
                    borderColor: borderColor || avatarData_1.borderColor,
                    testId: testId && `${testId}--avatar-${idx_0}`,
                    onClick: callback_0 ? (event_1, analyticsEvent_0)=>{
                        callback_0(event_1, analyticsEvent_0, idx_0);
                    } : undefined,
                    stackIndex: max_0 - idx_0
                }, idx_0);
                if ((0, $iDrrr.fg)("platform-dst-motion-uplift")) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iFlah.default), {
                    enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                    children: !isTooltipDisabled && !avatarData_1.isDisabled ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                        content: avatarData_1.name,
                        testId: testId && `${testId}--tooltip-${idx_0}`,
                        position: tooltipPosition,
                        children: finalAvatar_0
                    }) : finalAvatar_0
                }, (0, $g2o3j.composeUniqueKey)(avatarData_1, idx_0));
                else return !isTooltipDisabled && !avatarData_1.isDisabled ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                    content: avatarData_1.name,
                    testId: testId && `${testId}--tooltip-${idx_0}`,
                    position: tooltipPosition,
                    children: finalAvatar_0
                }, (0, $g2o3j.composeUniqueKey)(avatarData_1, idx_0)) : finalAvatar_0;
            }),
            renderMoreDropdown(+maxAvatar, total_0, groupId)
        ]
    });
} : ({ appearance: appearance = 'stack', avatar: avatar = (0, $arQY7.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', moreIndicatorLabel: moreIndicatorLabel, tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $cozmU.useState)(false);
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const onClose = (0, $cozmU.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $cozmU.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen_0)=>!isOpen_0);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $aRyr7.default)();
    const { AvatarGroupItem: avatarGroupItemOverrides, Avatar: avatarOverrides, MoreIndicator: moreIndicatorOverrides } = (0, $91JJR.getOverrides)(overrides);
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow.
    // Skipped when top-layer is enabled — DropdownMenu/top-layer handles
    // ArrowDown-to-open and arrow key navigation internally.
    (0, $cozmU.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Top-layer path: ArrowDown-to-open is handled by the menu's
        // own focus management, so skip the parent's ArrowDown handler.
        if ((0, $iDrrr.fg)('platform-dst-top-layer')) return 0, $dpsRj.default;
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $dpsRj.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $dpsRj.default;
        (0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $fM984.KEY_DOWN)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $cbY7C.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e_0) {
                    if (e_0.key === (0, $fM984.KEY_DOWN)) {
                        // prevent page scroll
                        e_0.preventDefault();
                        handleTriggerClicked(e_0);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total, labelId) {
        if (total <= max) return null;
        const renderMoreButton = ({ 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, onClick: onClick, ...props })=>moreIndicatorOverrides.render((0, $942TG.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                moreIndicatorLabel: moreIndicatorLabel,
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                onClick: onClick,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        if ((0, $iDrrr.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $j9iLd.MoreDropdownTopLayer), {
            isOpen: isOpen,
            onClose: onClose,
            isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
            data: data,
            max: max,
            // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
            overrides: overrides,
            onAvatarClick: onAvatarClick,
            testId: testId,
            labelId: labelId,
            renderMoreButton: renderMoreButton,
            handleTriggerClicked: handleTriggerClicked,
            bindFocus: bindFocus
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        const avatarComponent = avatar ?? undefined;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4n1IT.Popup), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: 510,
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $6oFjM.default), {
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eyQF5.default), {
                        onClick: (e_1)=>e_1.stopPropagation(),
                        minWidth: 250,
                        maxHeight: 300,
                        setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8FgJC.default), {
                            titleId: labelId,
                            testId: `${testId}--section`,
                            children: data.slice(max).map((avatarData, index)=>avatarGroupItemOverrides.render((0, $flNGL.default), {
                                    avatar: avatarData,
                                    avatarComponent: avatarComponent,
                                    onAvatarClick: onAvatarClick,
                                    avatarOverrides: avatarOverrides,
                                    testId: testId && `${testId}--avatar-group-item-${index + max}`,
                                    index: index + max
                                }, // This index holds the true index,
                                // adding up the index of non-overflowed avatars and overflowed avatars.
                                index + max))
                        })
                    })
                }),
            trigger: (triggerProps)=>(0, $iDrrr.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iFlah.default), {
                    enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                    children: renderMoreButton({
                        ...triggerProps,
                        ...bindFocus,
                        onClick: handleTriggerClicked
                    })
                }) : renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max_0 = maxCount === undefined || maxCount === 0 ? $6574fd66b51c7dea$var$MAX_COUNT[appearance] : maxCount;
    const total_0 = data.length;
    const maxAvatar = total_0 > max_0 ? max_0 - 1 : max_0;
    const groupId = (0, $6JrSr.useId)();
    return appearance === 'stack' ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $68jmg.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        size: size,
        children: [
            data.slice(0, maxAvatar).map((avatarData_0, idx)=>{
                const callback = avatarData_0.onClick || onAvatarClick;
                const finalAvatar = avatarOverrides.render(avatar, {
                    ...avatarData_0,
                    size: size,
                    borderColor: borderColor || avatarData_0.borderColor,
                    testId: testId && `${testId}--avatar-${idx}`,
                    onClick: callback ? (event_0, analyticsEvent)=>{
                        callback(event_0, analyticsEvent, idx);
                    } : undefined,
                    stackIndex: max_0 - idx
                }, idx);
                if ((0, $iDrrr.fg)('platform-dst-motion-uplift')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iFlah.default), {
                    enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                    children: !isTooltipDisabled && !avatarData_0.isDisabled ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                        content: avatarData_0.name,
                        testId: testId && `${testId}--tooltip-${idx}`,
                        position: tooltipPosition,
                        children: finalAvatar
                    }) : finalAvatar
                }, (0, $g2o3j.composeUniqueKey)(avatarData_0, idx));
                else return !isTooltipDisabled && !avatarData_0.isDisabled ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                    content: avatarData_0.name,
                    testId: testId && `${testId}--tooltip-${idx}`,
                    position: tooltipPosition,
                    children: finalAvatar
                }, (0, $g2o3j.composeUniqueKey)(avatarData_0, idx)) : finalAvatar;
            }),
            renderMoreDropdown(+maxAvatar, total_0, groupId)
        ]
    }) : /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $f4ONb.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        children: [
            data.slice(0, maxAvatar).map((avatarData_1, idx_0)=>{
                const callback_0 = avatarData_1.onClick || onAvatarClick;
                const finalAvatar_0 = avatarOverrides.render(avatar, {
                    ...avatarData_1,
                    size: size,
                    borderColor: borderColor || avatarData_1.borderColor,
                    testId: testId && `${testId}--avatar-${idx_0}`,
                    onClick: callback_0 ? (event_1, analyticsEvent_0)=>{
                        callback_0(event_1, analyticsEvent_0, idx_0);
                    } : undefined,
                    stackIndex: max_0 - idx_0
                }, idx_0);
                if ((0, $iDrrr.fg)('platform-dst-motion-uplift')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iFlah.default), {
                    enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                    children: !isTooltipDisabled && !avatarData_1.isDisabled ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                        content: avatarData_1.name,
                        testId: testId && `${testId}--tooltip-${idx_0}`,
                        position: tooltipPosition,
                        children: finalAvatar_0
                    }) : finalAvatar_0
                }, (0, $g2o3j.composeUniqueKey)(avatarData_1, idx_0));
                else return !isTooltipDisabled && !avatarData_1.isDisabled ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                    content: avatarData_1.name,
                    testId: testId && `${testId}--tooltip-${idx_0}`,
                    position: tooltipPosition,
                    children: finalAvatar_0
                }, (0, $g2o3j.composeUniqueKey)(avatarData_1, idx_0)) : finalAvatar_0;
            }),
            renderMoreDropdown(+maxAvatar, total_0, groupId)
        ]
    });
};
var $6574fd66b51c7dea$export$2e2bcd8739ae039 = $6574fd66b51c7dea$var$AvatarGroup;
function $6574fd66b51c7dea$var$_temp(isOpen_0) {
    return !isOpen_0;
}
function $6574fd66b51c7dea$var$_temp2(e_1) {
    return e_1.stopPropagation();
}
module.exports["default"] = $6574fd66b51c7dea$export$2e2bcd8739ae039;

});

parcelRegister("flNGL", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $arQY7 = parcelRequire("arQY7");


var $lmzCg = parcelRequire("lmzCg");


var $9d7Pd = parcelRequire("9d7Pd");


var $kD4eB = parcelRequire("kD4eB");


var $8oBbn = parcelRequire("8oBbn");


var $81Xw1 = parcelRequire("81Xw1");

const $74934c00a5cc9b19$var$AvatarGroupItem = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(24);
    const { avatar: avatar, avatarComponent: avatarComponent, index: index, onAvatarClick: onAvatarClick, testId: testId, avatarOverrides: avatarOverrides, role: role } = props;
    const { analyticsContext: analyticsContext, appearance: appearance, as: as, borderColor: _borderColor, children: children, href: href, isDisabled: isDisabled, key: _key, label: label, name: name, onClick: onClick, presence: presence, size: _size, src: src, stackIndex: stackIndex, status: status, tabIndex: tabIndex, target: target, testId: _groupItemTestId, ...rest } = avatar;
    const itemRef = (0, $81Xw1.default)();
    let t0;
    if ($[0] !== role) {
        t0 = (t1)=>{
            const { children: children_0, className: className, disabled: disabled, draggable: draggable, onClick: onClick_0, onDragStart: onDragStart, onMouseDown: onMouseDown, ref: ref_0, tabIndex: tabIndex_0, "data-testid": testId_0, ...props_0 } = t1;
            return /*#__PURE__*/ (0, $8aG6j.jsx)("button", {
                type: "button",
                className: className,
                disabled: disabled,
                draggable: draggable,
                onClick: onClick_0,
                onDragStart: onDragStart,
                onMouseDown: onMouseDown,
                ref: ref_0,
                tabIndex: tabIndex_0,
                "data-testid": testId_0,
                role: role,
                ...props_0,
                children: children_0
            });
        };
        $[0] = role;
        $[1] = t0;
    } else t0 = $[1];
    const CustomComponent = t0;
    const AvatarComponent = avatarComponent ?? (0, $arQY7.default);
    const AvatarIcon = avatarOverrides ? avatarOverrides.render(AvatarComponent, {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: "transparent",
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: "",
        presence: presence,
        size: "small",
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    }, 0) : /*#__PURE__*/ (0, $8aG6j.jsx)(AvatarComponent, {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: "transparent",
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: "",
        presence: presence,
        size: "small",
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    });
    const callback = onClick || onAvatarClick;
    let t1;
    if ($[2] !== AvatarIcon || $[3] !== callback || $[4] !== href || $[5] !== index || $[6] !== itemRef || $[7] !== name || $[8] !== ref || $[9] !== role || $[10] !== target || $[11] !== testId) {
        t1 = Symbol.for("react.early_return_sentinel");
        bb0: {
            if (href) {
                let t2;
                if ($[13] !== callback || $[14] !== index) {
                    t2 = (event)=>callback && callback(event, undefined, index);
                    $[13] = callback;
                    $[14] = index;
                    $[15] = t2;
                } else t2 = $[15];
                t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8oBbn.default), {
                    ref: (0, $lmzCg.default)([
                        ref,
                        itemRef
                    ]),
                    href: href,
                    target: target,
                    rel: target === "_blank" ? "noopener noreferrer" : undefined,
                    iconBefore: AvatarIcon,
                    testId: testId,
                    role: role,
                    onClick: t2,
                    children: name
                });
                break bb0;
            }
            if (typeof callback === "function") {
                let t2;
                if ($[16] !== callback || $[17] !== index) {
                    t2 = (event_0)=>callback && callback(event_0, undefined, index);
                    $[16] = callback;
                    $[17] = index;
                    $[18] = t2;
                } else t2 = $[18];
                t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9d7Pd.default), {
                    ref: (0, $lmzCg.default)([
                        ref,
                        itemRef
                    ]),
                    onClick: t2,
                    iconBefore: AvatarIcon,
                    testId: testId,
                    role: role,
                    children: name
                });
                break bb0;
            }
        }
        $[2] = AvatarIcon;
        $[3] = callback;
        $[4] = href;
        $[5] = index;
        $[6] = itemRef;
        $[7] = name;
        $[8] = ref;
        $[9] = role;
        $[10] = target;
        $[11] = testId;
        $[12] = t1;
    } else t1 = $[12];
    if (t1 !== Symbol.for("react.early_return_sentinel")) return t1;
    let t2;
    if ($[19] !== AvatarIcon || $[20] !== CustomComponent || $[21] !== name || $[22] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kD4eB.default), {
            iconBefore: AvatarIcon,
            component: CustomComponent,
            testId: testId,
            children: name
        });
        $[19] = AvatarIcon;
        $[20] = CustomComponent;
        $[21] = name;
        $[22] = testId;
        $[23] = t2;
    } else t2 = $[23];
    return t2;
} : (props, ref)=>{
    const { avatar: avatar, avatarComponent: avatarComponent, index: index, onAvatarClick: onAvatarClick, testId: testId, avatarOverrides: avatarOverrides, role: role } = props;
    const { analyticsContext: analyticsContext, appearance: appearance, as: as, borderColor: _borderColor, children: children, href: href, isDisabled: isDisabled, key: _key, label: label, name: name, onClick: onClick, presence: presence, size: _size, src: src, stackIndex: stackIndex, status: status, tabIndex: tabIndex, target: target, testId: _groupItemTestId, ...rest } = avatar;
    const itemRef = (0, $81Xw1.default)();
    const CustomComponent = ({ children: children_0, className: className, disabled: disabled, draggable: draggable, onClick: onClick_0, onDragStart: onDragStart, onMouseDown: onMouseDown, ref: ref_0, tabIndex: tabIndex_0, 'data-testid': testId_0, ...props_0 })=>{
        return /*#__PURE__*/ (0, $8aG6j.jsx)("button", {
            type: "button",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            disabled: disabled,
            draggable: draggable,
            onClick: onClick_0,
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            onDragStart: onDragStart,
            onMouseDown: onMouseDown,
            ref: ref_0,
            tabIndex: tabIndex_0,
            "data-testid": testId_0,
            role: role,
            ...props_0,
            children: children_0
        });
    };
    const AvatarComponent = avatarComponent ?? (0, $arQY7.default);
    const AvatarIcon = avatarOverrides ? avatarOverrides.render(AvatarComponent, {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: 'transparent',
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: '',
        presence: presence,
        size: 'small',
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    }, 0) : /*#__PURE__*/ (0, $8aG6j.jsx)(AvatarComponent, {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: "transparent",
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: "",
        presence: presence,
        size: "small",
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8oBbn.default), {
        ref: (0, $lmzCg.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        role: role,
        onClick: (event)=>callback && callback(event, undefined, index),
        children: name
    });
    if (typeof callback === 'function') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9d7Pd.default), {
        ref: (0, $lmzCg.default)([
            ref,
            itemRef
        ]),
        onClick: (event_0)=>callback && callback(event_0, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId,
        role: role,
        children: name
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kD4eB.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId,
        children: name
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$74934c00a5cc9b19$export$2e2bcd8739ae039 = $74934c00a5cc9b19$var$AvatarGroupItem;
module.exports["default"] = $74934c00a5cc9b19$export$2e2bcd8739ae039;

});

parcelRegister("81Xw1", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kVHjt = parcelRequire("kVHjt");

// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
const $f5ac5fe41e50defd$var$useRegisterItemWithFocusManager = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRegisterItemWithFocusManager() {
    const $ = (0, $bDgLe.c)(3);
    const { registerRef: registerRef } = (0, $cozmU.useContext)((0, $kVHjt.FocusManagerContext));
    const itemRef = (0, $cozmU.useRef)(null);
    let t0;
    let t1;
    if ($[0] !== registerRef) {
        t0 = ()=>{
            if (itemRef.current !== null) registerRef(itemRef.current);
        };
        t1 = [
            registerRef
        ];
        $[0] = registerRef;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return itemRef;
} : function useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $cozmU.useContext)((0, $kVHjt.FocusManagerContext));
    const itemRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
};
var $f5ac5fe41e50defd$export$2e2bcd8739ae039 = $f5ac5fe41e50defd$var$useRegisterItemWithFocusManager;
module.exports["default"] = $f5ac5fe41e50defd$export$2e2bcd8739ae039;

});

parcelRegister("kVHjt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");

const $b95dd4fa661016c8$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $cozmU.createContext)({
    menuItemRefs: [],
    registerRef: (0, $dpsRj.default)
});
module.exports["FocusManagerContext"] = $b95dd4fa661016c8$export$f18c1d4fc7326096;

});

parcelRegister("j9iLd", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $fM984 = parcelRequire("fM984");


var $6IL1T = parcelRequire("6IL1T");


var $8FgJC = parcelRequire("8FgJC");


var $lBMxH = parcelRequire("lBMxH");


var $aRDbl = parcelRequire("aRDbl");


var $juXYb = parcelRequire("juXYb");


var $kVXS3 = parcelRequire("kVXS3");


var $dV1Zs = parcelRequire("dV1Zs");


var $iNWdN = parcelRequire("iNWdN");


var $1unCm = parcelRequire("1unCm");


var $flNGL = parcelRequire("flNGL");

const $d2c81e37a1471dd1$var$topLayerPlacement = (0, $aRDbl.fromLegacyPlacement)({
    legacy: 'bottom-end'
});
function $d2c81e37a1471dd1$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                    ...props
                }, index),
            ...overrides?.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                    ...props
                }, index),
            ...overrides?.Avatar
        },
        MoreIndicator: {
            render: (Component, props)=>/*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                    ...props
                }),
            ...overrides?.MoreIndicator
        }
    };
}
function $d2c81e37a1471dd1$export$36ea40361987a72d({ isOpen: isOpen, onClose: onClose, isTriggeredUsingKeyboard: _isTriggeredUsingKeyboard, data: data, max: max, overrides: overrides, onAvatarClick: onAvatarClick, testId: testId, labelId: labelId, renderMoreButton: renderMoreButton, handleTriggerClicked: handleTriggerClicked, bindFocus: _bindFocus }) {
    const handleOnClose = (0, $cozmU.useCallback)(({ reason: _reason })=>{
        onClose();
    }, [
        onClose
    ]);
    const triggerRef = (0, $cozmU.useRef)(null);
    const popoverRef = (0, $cozmU.useRef)(null);
    const menuRef = (0, $cozmU.useRef)(null);
    const overflowMenuTestId = testId ? `${testId}--overflow-menu` : undefined;
    const popoverId = (0, $1unCm.usePopoverId)();
    (0, $dV1Zs.useAnchoredPopover)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: $d2c81e37a1471dd1$var$topLayerPlacement,
        isOpen: isOpen
    });
    // Arrow key navigation inside the open menu
    (0, $iNWdN.useArrowNavigation)({
        containerRef: menuRef,
        onClose: onClose,
        isEnabled: isOpen
    });
    // ArrowDown-to-open: when the trigger is focused and the menu is closed,
    // pressing ArrowDown opens the menu (WAI-ARIA menu button pattern).
    //
    // Bind the keydown listener directly to the trigger element via its ref so
    // that opening the menu does not trigger a focus-driven re-render of the
    // host component, which would unmount and remount the menu items and drop
    // menuitem focus.
    (0, $cozmU.useEffect)(()=>{
        const trigger = triggerRef.current;
        if (!trigger || isOpen) return;
        return (0, $cbY7C.bind)(trigger, {
            type: 'keydown',
            listener: function openOnArrowDown(event) {
                if (event.key === (0, $fM984.KEY_DOWN)) {
                    // Prevent page scroll when opening the menu via ArrowDown.
                    event.preventDefault();
                    handleTriggerClicked(event);
                }
            }
        });
    }, [
        isOpen,
        handleTriggerClicked
    ]);
    const triggerAria = (0, $lBMxH.getAriaForTrigger)({
        role: 'menu',
        isOpen: isOpen,
        popoverId: popoverId
    });
    const setTriggerRef = (0, $cozmU.useCallback)((node)=>{
        triggerRef.current = node;
    }, []);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            renderMoreButton({
                ref: setTriggerRef,
                ...triggerAria,
                onClick: handleTriggerClicked
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kVXS3.Popover), {
                ref: popoverRef,
                id: popoverId,
                role: "menu",
                label: "avatar group",
                isOpen: isOpen,
                onClose: handleOnClose,
                shouldAnimate: true,
                placement: $d2c81e37a1471dd1$var$topLayerPlacement,
                testId: overflowMenuTestId ? `${overflowMenuTestId}--content` : undefined,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $juXYb.PopoverSurface), {
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                        ref: menuRef,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6IL1T.default), {
                            minWidth: 250,
                            maxHeight: 300,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8FgJC.default), {
                                titleId: labelId,
                                testId: testId ? `${testId}--section` : undefined,
                                children: data.slice(max).map((avatar, index)=>$d2c81e37a1471dd1$var$getOverrides(overrides).AvatarGroupItem.render((0, $flNGL.default), {
                                        avatar: avatar,
                                        onAvatarClick: onAvatarClick,
                                        testId: testId ? `${testId}--avatar-group-item-${index + max}` : undefined,
                                        index: index + max,
                                        role: 'menuitem'
                                    }, index + max))
                            })
                        })
                    })
                })
            })
        ]
    });
}
module.exports["MoreDropdownTopLayer"] = $d2c81e37a1471dd1$export$36ea40361987a72d;

});

parcelRegister("91JJR", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $g2o3j = parcelRequire("g2o3j");

function $5c29a548ea0a79f9$export$f525cc57d37ca574(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $cozmU.createElement)(Component, {
                    ...props,
                    key: (0, $g2o3j.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $cozmU.createElement)(Component, {
                    ...props,
                    key: (0, $g2o3j.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        },
        MoreIndicator: {
            render: (Component, props)=>/*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                    ...props
                }),
            ...overrides && overrides.MoreIndicator
        }
    };
}
module.exports["getOverrides"] = $5c29a548ea0a79f9$export$f525cc57d37ca574;

});

parcelRegister("g2o3j", function(module, exports) {
const $c51da9a7df49a1b0$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};
module.exports["composeUniqueKey"] = $c51da9a7df49a1b0$export$b067756944994c79;

});

parcelRegister("f4ONb", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iODl6 = parcelRequire("iODl6");


var $iDrrr = parcelRequire("iDrrr");

const $1c9c95ebce1b3e9c$var$gutter = "var(--ds-space-negative-050, -4px)";
const $1c9c95ebce1b3e9c$var$listStyles = null;
const $1c9c95ebce1b3e9c$var$listStylesFlagged = null;
const $1c9c95ebce1b3e9c$var$listItemStyles = null;
const $1c9c95ebce1b3e9c$var$Grid = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { id: id, children: children, testId: testId, "aria-label": label } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuchRC _3TGfC9HnLE _2YgrGrP0S5 _26BoRw7dHp _0aNu0LOiJt _0rIjykPgdg _43nrzTPgdg _2xTnZx5UaJ _0GTcwR5UaJ _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg",
            "_0rIjyk1Y8M _03SyCPFQfX _0LQT5EFQfX"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = (0, $iDrrr.fg)("platform-dst-motion-uplift") ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iODl6.default), {
            exitThenEnter: true,
            children: (0, $cozmU.Children).map(children, $1c9c95ebce1b3e9c$var$_temp)
        }) : (0, $cozmU.Children).map(children, $1c9c95ebce1b3e9c$var$_temp2);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== id || $[4] !== label || $[5] !== t2 || $[6] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("ul", {
            id: id,
            "data-testid": testId,
            "aria-label": label,
            className: t1,
            children: t2
        });
        $[3] = id;
        $[4] = label;
        $[5] = t2;
        $[6] = testId;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ id: id, children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $8aG6j.jsx)("ul", {
        id: id,
        "data-testid": testId,
        "aria-label": label,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuchRC _3TGfC9HnLE _2YgrGrP0S5 _26BoRw7dHp _0aNu0LOiJt _0rIjykPgdg _43nrzTPgdg _2xTnZx5UaJ _0GTcwR5UaJ _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg",
            "_0rIjyk1Y8M _03SyCPFQfX _0LQT5EFQfX"
        ]),
        children: (0, $iDrrr.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iODl6.default), {
            exitThenEnter: true,
            children: (0, $cozmU.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
                    className: (0, $hekY6.default)([
                        "_0rIjyk2ADO _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _03SyCP1Y8M _0LQT5E1Y8M"
                    ]),
                    children: child
                }))
        }) : (0, $cozmU.Children).map(children, (child_0)=>child_0 && /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
                className: (0, $hekY6.default)([
                    "_0rIjyk2ADO _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _03SyCP1Y8M _0LQT5E1Y8M"
                ]),
                children: child_0
            }))
    }); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $1c9c95ebce1b3e9c$export$2e2bcd8739ae039 = $1c9c95ebce1b3e9c$var$Grid;
function $1c9c95ebce1b3e9c$var$_temp(child) {
    return child && /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
        className: (0, $hekY6.default)([
            "_0rIjyk2ADO _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _03SyCP1Y8M _0LQT5E1Y8M"
        ]),
        children: child
    });
}
function $1c9c95ebce1b3e9c$var$_temp2(child_0) {
    return child_0 && /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
        className: (0, $hekY6.default)([
            "_0rIjyk2ADO _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _03SyCP1Y8M _0LQT5E1Y8M"
        ]),
        children: child_0
    });
}
module.exports["default"] = $1c9c95ebce1b3e9c$export$2e2bcd8739ae039;

});

parcelRegister("6oFjM", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $7Dop9 = parcelRequire("7Dop9");


var $kVHjt = parcelRequire("kVHjt");

// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Focus manager__
 *
 * A focus manager {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ const $c01bf7a5c9b76ffa$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $cozmU.useRef)([]);
    const registerRef = (0, $cozmU.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $cozmU.useEffect)(()=>{
        (0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: (0, $7Dop9.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $cbY7C.bind)(window, {
                type: 'keydown',
                listener: (0, $7Dop9.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kVHjt.FocusManagerContext).Provider, {
        value: contextValue,
        children: children
    });
};
var $c01bf7a5c9b76ffa$export$2e2bcd8739ae039 = $c01bf7a5c9b76ffa$var$FocusManager;
module.exports["default"] = $c01bf7a5c9b76ffa$export$2e2bcd8739ae039;

});

parcelRegister("7Dop9", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b50f6255090ed60$export$2e2bcd8739ae039);

var $fM984 = parcelRequire("fM984");

const $7b50f6255090ed60$var$actionMap = {
    [(0, $fM984.KEY_DOWN)]: 'next',
    [(0, $fM984.KEY_UP)]: 'prev',
    [(0, $fM984.KEY_HOME)]: 'first',
    [(0, $fM984.KEY_END)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $7b50f6255090ed60$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
    return;
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $7b50f6255090ed60$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
    return;
};
function $7b50f6255090ed60$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $7b50f6255090ed60$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $7b50f6255090ed60$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $7b50f6255090ed60$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $7b50f6255090ed60$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $7b50f6255090ed60$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});

parcelRegister("eyQF5", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6IL1T = parcelRequire("6IL1T");


var $kVHjt = parcelRequire("kVHjt");

/**
 * It sets focus to the first avatar when popup is open.
 */ const $949efbfeb67fe748$var$PopupAvatarGroup = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    let children;
    let isLoading;
    let maxHeight;
    let minHeight;
    let onClick;
    let rest;
    let role;
    let setInitialFocusRef;
    let spacing;
    let t1;
    let t2;
    let testId;
    if ($[0] !== t0) {
        ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: t1, minHeight: minHeight, minWidth: t2, onClick: onClick, role: role, setInitialFocusRef: setInitialFocusRef, spacing: spacing, testId: testId, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = isLoading;
        $[3] = maxHeight;
        $[4] = minHeight;
        $[5] = onClick;
        $[6] = rest;
        $[7] = role;
        $[8] = setInitialFocusRef;
        $[9] = spacing;
        $[10] = t1;
        $[11] = t2;
        $[12] = testId;
    } else {
        children = $[1];
        isLoading = $[2];
        maxHeight = $[3];
        minHeight = $[4];
        onClick = $[5];
        rest = $[6];
        role = $[7];
        setInitialFocusRef = $[8];
        spacing = $[9];
        t1 = $[10];
        t2 = $[11];
        testId = $[12];
    }
    const maxWidth = t1 === undefined ? 800 : t1;
    const minWidth = t2 === undefined ? 320 : t2;
    const { menuItemRefs: menuItemRefs } = (0, $cozmU.useContext)((0, $kVHjt.FocusManagerContext));
    let t3;
    let t4;
    if ($[13] !== menuItemRefs || $[14] !== setInitialFocusRef) {
        t3 = ()=>{
            setInitialFocusRef?.(menuItemRefs[0]);
        };
        t4 = [
            menuItemRefs,
            setInitialFocusRef
        ];
        $[13] = menuItemRefs;
        $[14] = setInitialFocusRef;
        $[15] = t3;
        $[16] = t4;
    } else {
        t3 = $[15];
        t4 = $[16];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[17] !== children || $[18] !== isLoading || $[19] !== maxHeight || $[20] !== maxWidth || $[21] !== minHeight || $[22] !== minWidth || $[23] !== onClick || $[24] !== rest || $[25] !== role || $[26] !== spacing || $[27] !== testId) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6IL1T.default), {
            isLoading: isLoading,
            maxHeight: maxHeight,
            maxWidth: maxWidth,
            minHeight: minHeight,
            minWidth: minWidth,
            onClick: onClick,
            role: role,
            spacing: spacing,
            testId: testId,
            ...rest,
            children: children
        });
        $[17] = children;
        $[18] = isLoading;
        $[19] = maxHeight;
        $[20] = maxWidth;
        $[21] = minHeight;
        $[22] = minWidth;
        $[23] = onClick;
        $[24] = rest;
        $[25] = role;
        $[26] = spacing;
        $[27] = testId;
        $[28] = t5;
    } else t5 = $[28];
    return t5;
} : ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth = 800, minHeight: minHeight, minWidth: minWidth = 320, onClick: onClick, role: role, setInitialFocusRef: setInitialFocusRef, spacing: spacing, testId: testId, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $cozmU.useContext)((0, $kVHjt.FocusManagerContext));
    (0, $cozmU.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6IL1T.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        minHeight: minHeight,
        minWidth: minWidth,
        onClick: onClick,
        role: role,
        spacing: spacing,
        testId: testId,
        ...rest,
        children: children
    });
};
var $949efbfeb67fe748$export$2e2bcd8739ae039 = $949efbfeb67fe748$var$PopupAvatarGroup;
module.exports["default"] = $949efbfeb67fe748$export$2e2bcd8739ae039;

});

parcelRegister("942TG", function(module, exports) {
/* more-indicator.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");

const $de57968bf9fddf7d$var$boxShadowCssVar = '--avatar-box-shadow';
const $de57968bf9fddf7d$var$styles = {
    root: "_30huDKYbGa _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAnQyn _2WAcuGnQyn _23rrnHyKLB _3iDTPbQ4SZ _24h04iPvdi _43nrzTFQfX _2xTnZxFQfX _0rIjykFQfX _0GTcwRFQfX _46hvQmPgdg _03SyCPPgdg _0xmtkoPgdg _0LQT5EPgdg _0hPCNLFlnN _37wbyuDIqT _0aFT5vbt8w _0wOv4Q7zJH _0KLXruDMqu _1UtDYzy7kJ _2OUyjtrcoi _1VJPcaeKTE _3kPd40YbGa _1ubuxonXvL _1NDpvb6wH8 _34b3D24Jdh _2wtOC94Jdh _1eOmH6KcZT _0clgaMy7kJ _3sFUREiSCN _3gzVzLnpTK _0CMRbky7kJ _1if2KaHZdu",
    circle: "_0bjKvDaaQb",
    active: "_23rrnHyKLB _0KLXruY9q9 _2OUyjt0hf4 _1UtDYzjTy9 _1eOmH6sumd _0clgaMjTy9 _3sFUREiSCN _3gzVzLXsxn _0CMRbkjTy9",
    disabled: "_0wOv4Qsyl5 _43i6GSVx3j _3wEj0XlfZc",
    motion: "_23rrnHyKLB"
};
const $de57968bf9fddf7d$var$widthHeightMap = {
    xsmall: "_39xV02ey7F _0jFU0Vey7F",
    small: "_39xV02oWWg _0jFU0VoWWg",
    medium: "_39xV02Uofl _0jFU0VUofl",
    large: "_39xV02UF4f _0jFU0VUF4f",
    xlarge: "_39xV02JgOI _0jFU0VJgOI",
    xxlarge: "_39xV02NNui _0jFU0VNNui"
};
const $de57968bf9fddf7d$var$borderRadiusMap = {
    xsmall: "_0bjKvDcjp5 _2Gfj6icjp5",
    small: "_0bjKvDcjp5 _2Gfj6icjp5",
    medium: "_0bjKvDzXzM _2Gfj6izXzM",
    large: "_0bjKvDzXzM _2Gfj6izXzM",
    xlarge: "_0bjKvDKTcp _2Gfj6iKTcp",
    xxlarge: "_0bjKvDyzSk _2Gfj6iyzSk"
};
const $de57968bf9fddf7d$var$fontMap = {
    small: "_2sNsIg7NXe",
    medium: "_2sNsIg7NXe",
    large: "_2sNsIg7NXe",
    xlarge: "_2sNsIg20Hp",
    xxlarge: "_2sNsIg20Hp"
};
const $de57968bf9fddf7d$var$MAX_DISPLAY_COUNT = 99;
const $de57968bf9fddf7d$var$MoreIndicator = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = "var(--ds-surface, #FFFFFF)", size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, moreIndicatorLabel: moreIndicatorLabel, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $cozmU.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    const displayCount = count > $de57968bf9fddf7d$var$MAX_DISPLAY_COUNT ? $de57968bf9fddf7d$var$MAX_DISPLAY_COUNT : count;
    const providedAriaLabel = moreIndicatorLabel || buttonProps['aria-label'];
    const ariaLabel = providedAriaLabel ? providedAriaLabel : `${displayCount} more people`;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("button", {
        type: "submit",
        ...buttonProps,
        onClick: onClickHander,
        ref: ref,
        "data-testid": testId,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        "aria-label": ariaLabel,
        style: {
            [$de57968bf9fddf7d$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        className: (0, $hekY6.default)([
            $de57968bf9fddf7d$var$styles.root,
            $de57968bf9fddf7d$var$borderRadiusMap[size],
            appearance === 'circle' && $de57968bf9fddf7d$var$styles.circle,
            $de57968bf9fddf7d$var$widthHeightMap[size],
            $de57968bf9fddf7d$var$fontMap[size],
            isActive && $de57968bf9fddf7d$var$styles.active,
            (0, $iDrrr.fg)('platform-dst-motion-uplift-custom-button') && $de57968bf9fddf7d$var$styles.motion
        ]),
        children: [
            "+",
            displayCount
        ]
    });
});
$de57968bf9fddf7d$var$MoreIndicator.displayName = 'MoreIndicator'; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $de57968bf9fddf7d$export$2e2bcd8739ae039 = $de57968bf9fddf7d$var$MoreIndicator;
module.exports["default"] = $de57968bf9fddf7d$export$2e2bcd8739ae039;

});

parcelRegister("68jmg", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iODl6 = parcelRequire("iODl6");


var $iDrrr = parcelRequire("iDrrr");

const $ca3d6afcd04eeed9$var$listStyles = null;
const $ca3d6afcd04eeed9$var$listSmallStyles = null;
const $ca3d6afcd04eeed9$var$listItemStyles = null;
const $ca3d6afcd04eeed9$var$listItemSmallStyles = null;
const $ca3d6afcd04eeed9$var$Stack = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { id: id, children: children, testId: testId, "aria-label": label, size: size } = t0;
    const t1 = size === "small" && "_2xTnZx1Y8M";
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _2YgrGrP0S5 _26BoRw7dHp _0aNu0LOiJt _0rIjykPgdg _43nrzTPgdg _2xTnZx2ADO _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg",
            t1
        ]);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== size) {
        t3 = (0, $iDrrr.fg)("platform-dst-motion-uplift") ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iODl6.default), {
            exitThenEnter: true,
            children: (0, $cozmU.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
                    className: (0, $hekY6.default)([
                        "_0rIjykPgdg _43nrzTPgdg _2xTnZx4F84 _0GTcwRPgdg",
                        size === "small" && "_2xTnZx5UaJ"
                    ]),
                    children: child
                }))
        }) : (0, $cozmU.Children).map(children, (child_0)=>child_0 && /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
                className: (0, $hekY6.default)([
                    "_0rIjykPgdg _43nrzTPgdg _2xTnZx4F84 _0GTcwRPgdg",
                    size === "small" && "_2xTnZx5UaJ"
                ]),
                children: child_0
            }));
        $[2] = children;
        $[3] = size;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== id || $[6] !== label || $[7] !== t2 || $[8] !== t3 || $[9] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)("ul", {
            id: id,
            "data-testid": testId,
            "aria-label": label,
            className: t2,
            children: t3
        });
        $[5] = id;
        $[6] = label;
        $[7] = t2;
        $[8] = t3;
        $[9] = testId;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ({ id: id, children: children, testId: testId, 'aria-label': label, size: size })=>/*#__PURE__*/ (0, $8aG6j.jsx)("ul", {
        id: id,
        "data-testid": testId,
        "aria-label": label,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _2YgrGrP0S5 _26BoRw7dHp _0aNu0LOiJt _0rIjykPgdg _43nrzTPgdg _2xTnZx2ADO _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg",
            size === 'small' && "_2xTnZx1Y8M"
        ]),
        children: (0, $iDrrr.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iODl6.default), {
            exitThenEnter: true,
            children: (0, $cozmU.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
                    className: (0, $hekY6.default)([
                        "_0rIjykPgdg _43nrzTPgdg _2xTnZx4F84 _0GTcwRPgdg",
                        size === 'small' && "_2xTnZx5UaJ"
                    ]),
                    children: child
                }))
        }) : (0, $cozmU.Children).map(children, (child_0)=>child_0 && /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
                className: (0, $hekY6.default)([
                    "_0rIjykPgdg _43nrzTPgdg _2xTnZx4F84 _0GTcwRPgdg",
                    size === 'small' && "_2xTnZx5UaJ"
                ]),
                children: child_0
            }))
    }); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $ca3d6afcd04eeed9$export$2e2bcd8739ae039 = $ca3d6afcd04eeed9$var$Stack;
module.exports["default"] = $ca3d6afcd04eeed9$export$2e2bcd8739ae039;

});

parcelRegister("64VTj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fKN6m = parcelRequire("fKN6m");


var $471nw = parcelRequire("471nw");

const $8ae958986c8c799d$var$IntlMessagesProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IntlMessagesProvider(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { loaderFn: loaderFn, children: children, defaultMessages: defaultMessages } = t0;
    const intl = (0, $471nw.useSafeIntl)();
    const messages = (0, $fKN6m.useMessages)(intl.locale, loaderFn);
    let t1;
    if ($[0] !== defaultMessages || $[1] !== intl.messages || $[2] !== messages) {
        t1 = {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
        $[0] = defaultMessages;
        $[1] = intl.messages;
        $[2] = messages;
        $[3] = t1;
    } else t1 = $[3];
    const mergedMessages = t1;
    let t2;
    if ($[4] !== children || $[5] !== intl.locale || $[6] !== intl.onError || $[7] !== mergedMessages) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            defaultLocale: "en",
            locale: intl.locale,
            onError: intl.onError,
            messages: mergedMessages
        }, children);
        $[4] = children;
        $[5] = intl.locale;
        $[6] = intl.onError;
        $[7] = mergedMessages;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : function IntlMessagesProvider({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $471nw.useSafeIntl)();
    const messages = (0, $fKN6m.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
   * This prevents the missing messages error.
   */ const mergedMessages = (0, $cozmU.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages
    }, children);
};
var $8ae958986c8c799d$export$2e2bcd8739ae039 = $8ae958986c8c799d$var$IntlMessagesProvider;
module.exports["default"] = $8ae958986c8c799d$export$2e2bcd8739ae039;

});

parcelRegister("fKN6m", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ezgjU = parcelRequire("ezgjU");

const $8781597542fb3a9a$export$4d17e2d9c5348842 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useMessages(locale, loaderFn) {
    const $ = (0, $bDgLe.c)(4);
    const [localeState, setLocaleState] = (0, $cozmU.useState)((0, $ezgjU.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $cozmU.useRef)(localeState.locale);
    let t0;
    let t1;
    if ($[0] !== loaderFn || $[1] !== locale) {
        t0 = ()=>{
            if (locale === loadedLocaleRef.current) return;
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) {
                    loadedLocaleRef.current = locale;
                    setLocaleState({
                        locale: locale,
                        messages: messages ?? {}
                    });
                }
            }, $8781597542fb3a9a$var$_temp);
            return ()=>{
                current = false;
            };
        };
        t1 = [
            loaderFn,
            locale
        ];
        $[0] = loaderFn;
        $[1] = locale;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return localeState.messages;
} : function useMessages(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $cozmU.useState)((0, $ezgjU.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $cozmU.useRef)(localeState.locale);
    (0, $cozmU.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
};
function $8781597542fb3a9a$var$_temp(error) {
    console.error("Failed to load i18n messages via intl-messages-provider", error);
}
module.exports["useMessages"] = $8781597542fb3a9a$export$4d17e2d9c5348842;

});

parcelRegister("ezgjU", function(module, exports) {
const $c69670c8f17f7b27$export$79618bef82c02d4c = {
    locale: 'en-US',
    messages: undefined
};
module.exports["DEFAULT_LOCALE_STATE"] = $c69670c8f17f7b27$export$79618bef82c02d4c;

});

parcelRegister("471nw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ezgjU = parcelRequire("ezgjU");

// Prevents memory leaks
const $2a38add47fc8c1ad$var$cache = (0, $kSwu1.createIntlCache)();
const $2a38add47fc8c1ad$export$f752ac21ea3960a5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    const context = (0, $cozmU.useContext)((0, $kSwu1.IntlContext));
    if (!context) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = (0, $kSwu1.createIntl)((0, $ezgjU.DEFAULT_LOCALE_STATE), $2a38add47fc8c1ad$var$cache);
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)((0, $kSwu1.IntlContext));
    if (!context) return (0, $kSwu1.createIntl)((0, $ezgjU.DEFAULT_LOCALE_STATE), $2a38add47fc8c1ad$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $2a38add47fc8c1ad$export$f752ac21ea3960a5;

});

parcelRegister("i1agE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::251f5452f3f0754765959a05130502fa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d1e048e4b12a2678$var$_react = $d1e048e4b12a2678$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d1e048e4b12a2678$var$_iconNew = $d1e048e4b12a2678$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $d1e048e4b12a2678$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WarningOutline".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/warning-outline
 * Usage guidance:
 * Low-impact warnings. Overdue dates in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d1e048e4b12a2678$var$WarningOutlineIcon = (props)=>/*#__PURE__*/ $d1e048e4b12a2678$var$_react.default.createElement($d1e048e4b12a2678$var$_iconNew.default, Object.assign({
        name: "WarningOutlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.7 1.383c.996-1.816 3.605-1.817 4.602-.002l5.35 9.73C16.612 12.86 15.346 15 13.35 15H2.667C.67 15-.594 12.862.365 11.113zm3.288.72a1.125 1.125 0 0 0-1.972.002L1.68 11.834c-.41.75.132 1.666.987 1.666H13.35c.855 0 1.398-.917.986-1.667z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.25 9V4h1.5v5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$d1e048e4b12a2678$var$WarningOutlineIcon.displayName = 'WarningOutlineIcon';
var $d1e048e4b12a2678$var$_default = module.exports.default = $d1e048e4b12a2678$var$WarningOutlineIcon;

});

parcelRegister("emZLc", function(module, exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $a763071343fcb354$var$isUndefined(value) {
    return value === undefined;
}
module.exports = $a763071343fcb354$var$isUndefined;

});

parcelRegister("hcOES", function(module, exports) {

var $gO1os = parcelRequire("gO1os");


var $jYwtP = parcelRequire("jYwtP");


var $5sm3M = parcelRequire("5sm3M");

const $2b7c6f2b383d7d91$export$34ac71ce24cddec2 = (event, type, payload)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const clonedEvent = castedEvent.clone();
    if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
    clonedEvent.update({
        ...payload,
        analyticsType: type
    }).fire((0, $jYwtP.ANALYTICS_BRIDGE_CHANNEL));
};
const $2b7c6f2b383d7d91$var$getActionSubjectFromContext = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    return (0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
};
const $2b7c6f2b383d7d91$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
    const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $5sm3M.getImperativeAnalyticsDataFromArguments)(rest);
    const castedEvent = event;
    const action = event.payload && event.payload.action || argumentsAction;
    const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $2b7c6f2b383d7d91$var$getActionSubjectFromContext(castedEvent);
    if (!action) throw new Error('Mandatory "action" field is missing from UI event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
    $2b7c6f2b383d7d91$export$34ac71ce24cddec2(event, (0, $jYwtP.UI_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $2b7c6f2b383d7d91$export$13990ad4625571ed = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $5sm3M.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Track event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
    $2b7c6f2b383d7d91$export$34ac71ce24cddec2(event, (0, $jYwtP.TRACK_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $2b7c6f2b383d7d91$export$79f423cc3fd39762 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $5sm3M.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
    $2b7c6f2b383d7d91$export$34ac71ce24cddec2(event, (0, $jYwtP.OPERATIONAL_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $2b7c6f2b383d7d91$export$6f46fb37ad7d962b = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
    const { attributes: attributes } = (0, $5sm3M.getImperativeAnalyticsDataFromArguments)(rest);
    $2b7c6f2b383d7d91$export$34ac71ce24cddec2(event, (0, $jYwtP.SCREEN_EVENT_TYPE), {
        attributes: attributes
    });
};
module.exports["fireAnalytics"] = $2b7c6f2b383d7d91$export$34ac71ce24cddec2;
module.exports["fireUIAnalytics"] = $2b7c6f2b383d7d91$export$5d00cd31b1bf8e94;
module.exports["fireTrackAnalytics"] = $2b7c6f2b383d7d91$export$13990ad4625571ed;
module.exports["fireOperationalAnalytics"] = $2b7c6f2b383d7d91$export$79f423cc3fd39762;

});

parcelRegister("jYwtP", function(module, exports) {
const $fec988d562d5bfbb$export$f636b5b56f1d624a = 'Screen';
const $fec988d562d5bfbb$export$9d2de6eebf7462b5 = 'Drawer';
const $fec988d562d5bfbb$export$1171103ea9083ffa = 'Modal';
const $fec988d562d5bfbb$export$cae2783c9279926 = 'InlineDialog';
const $fec988d562d5bfbb$export$d1123261ca8831d2 = 'Dropdown';
const $fec988d562d5bfbb$export$a1562d08625f5d7e = 'UI';
const $fec988d562d5bfbb$export$947dac6c72b26f81 = 'TRACK';
const $fec988d562d5bfbb$export$f1d537d508d2945a = 'SCREEN';
const $fec988d562d5bfbb$export$12346a674644c156 = 'OPERATIONAL';
const $fec988d562d5bfbb$export$2ceccf177fae277c = 'analyticsBridge';
module.exports["SCREEN"] = $fec988d562d5bfbb$export$f636b5b56f1d624a;
module.exports["MODAL"] = $fec988d562d5bfbb$export$1171103ea9083ffa;
module.exports["UI_EVENT_TYPE"] = $fec988d562d5bfbb$export$a1562d08625f5d7e;
module.exports["TRACK_EVENT_TYPE"] = $fec988d562d5bfbb$export$947dac6c72b26f81;
module.exports["SCREEN_EVENT_TYPE"] = $fec988d562d5bfbb$export$f1d537d508d2945a;
module.exports["OPERATIONAL_EVENT_TYPE"] = $fec988d562d5bfbb$export$12346a674644c156;
module.exports["ANALYTICS_BRIDGE_CHANNEL"] = $fec988d562d5bfbb$export$2ceccf177fae277c;

});

parcelRegister("5sm3M", function(module, exports) {
const $8f4a194f3d46df20$var$extractDataFromStringAttribute = (string)=>{
    const arr = string.split(' ');
    switch(arr.length){
        case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $8f4a194f3d46df20$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $8f4a194f3d46df20$var$extractDataFromStringAttribute(one);
    if (typeof one === 'object') return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
    throw Error('Event of this type is not supported');
};
const $8f4a194f3d46df20$var$extractDataFromTwoAttribute = (one, two)=>{
    if (typeof one === 'string' && typeof two === 'string') {
        const { action: action, actionSubject: actionSubject } = $8f4a194f3d46df20$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    if (typeof one === 'string' && typeof two === 'object') {
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $8f4a194f3d46df20$var$extractDataFromStringAttribute(one);
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: two
        };
    }
    throw Error('Event of this type is not supported');
};
const $8f4a194f3d46df20$var$extractDataFromThreeAttribute = (one, two, three)=>{
    if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
        const { action: action, actionSubject: actionSubject } = $8f4a194f3d46df20$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: three
        };
    }
    throw Error('Event of this type is not supported');
};
const $8f4a194f3d46df20$export$e6baab532ef8c6bf = (args)=>{
    switch(args.length){
        case 0:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: undefined,
                attributes: undefined
            };
        case 1:
            return $8f4a194f3d46df20$var$extractDataFromOneAttribute(args[0]);
        case 2:
            return $8f4a194f3d46df20$var$extractDataFromTwoAttribute(args[0], args[1]);
        case 3:
            return $8f4a194f3d46df20$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};
module.exports["getImperativeAnalyticsDataFromArguments"] = $8f4a194f3d46df20$export$e6baab532ef8c6bf;

});

parcelRegister("1LXnB", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $69NJe = parcelRequire("69NJe");

const $12a75cc47e499450$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props.offscreen || $[1] !== props.setWidth) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $69NJe.WidthDetectorObserver), {
            setWidth: props.setWidth,
            offscreen: props.offscreen
        });
        $[0] = props.offscreen;
        $[1] = props.setWidth;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $69NJe.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
module.exports["WidthObserver"] = $12a75cc47e499450$export$b2ad68b9bc407b80;

});

parcelRegister("69NJe", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1zgpZ = parcelRequire("1zgpZ");

const $00e8152189e344b1$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { setWidth: setWidth, offscreen: offscreen } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            threshold: 0
        };
        $[0] = t1;
    } else t1 = $[0];
    const [inViewRef, inView, target] = (0, $1zgpZ.useInView)(t1);
    let t2;
    if ($[1] !== setWidth) {
        t2 = ()=>{
            if (typeof window === "undefined") return null;
            return new ResizeObserver((entries)=>{
                if (!Array.isArray(entries) || !entries.length) return;
                const { width: width } = entries[0].contentRect;
                setWidth(Math.round(width));
            });
        };
        $[1] = setWidth;
        $[2] = t2;
    } else t2 = $[2];
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(t2);
    let t3;
    let t4;
    if ($[3] !== inView || $[4] !== offscreen || $[5] !== target) {
        t3 = ()=>{
            const { current: currentObserver } = observer;
            const resizeObserver = currentObserver();
            if (resizeObserver === null) return;
            if (target) {
                if (inView || offscreen) resizeObserver.observe(target);
                else resizeObserver.unobserve(target);
            }
            return ()=>{
                resizeObserver.disconnect();
            };
        };
        t4 = [
            target,
            inView,
            offscreen
        ];
        $[3] = inView;
        $[4] = offscreen;
        $[5] = target;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t3, t4);
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            display: "block",
            width: "100%",
            position: "absolute"
        };
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== inViewRef) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            style: t5,
            ref: inViewRef
        });
        $[9] = inViewRef;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
} : ({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $1zgpZ.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});
module.exports["WidthDetectorObserver"] = $00e8152189e344b1$export$ff983d2a2b6112ea;

});

parcelRegister("1zgpZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $cbd0258ef583969a$export$2f62ee6831462844 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useInView(t0) {
    const $ = (0, $bDgLe.c)(14);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const options = t1;
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            inView: false,
            entry: undefined,
            target: undefined
        };
        $[2] = t2;
    } else t2 = $[2];
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(t2);
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    let t3;
    if ($[3] !== root || $[4] !== rootMargin || $[5] !== threshold) {
        t3 = (node)=>{
            observerInstance.current = new IntersectionObserver((entries)=>{
                if (entries && entries.length) {
                    const intersection = entries[0];
                    const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                    if (intersectionRatio >= 0) {
                        const numericThreshold = typeof threshold === "number" ? threshold : 0;
                        let inView = intersectionRatio >= numericThreshold;
                        if (isIntersecting !== undefined) inView = inView && isIntersecting;
                        setState({
                            inView: inView,
                            entry: intersection,
                            target: node
                        });
                    }
                }
            }, {
                threshold: threshold,
                root: root,
                rootMargin: rootMargin
            });
            if (ref.current) observerInstance.current.unobserve(ref.current);
            if (node) observerInstance.current.observe(node);
            ref.current = node;
        };
        $[3] = root;
        $[4] = rootMargin;
        $[5] = threshold;
        $[6] = t3;
    } else t3 = $[6];
    const setRef = t3;
    let t4;
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>()=>{
                if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
            };
        t5 = [];
        $[7] = t4;
        $[8] = t5;
    } else {
        t4 = $[7];
        t5 = $[8];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t4, t5);
    let t6;
    if ($[9] !== setRef || $[10] !== state.entry || $[11] !== state.inView || $[12] !== state.target) {
        t6 = [
            setRef,
            state.inView,
            state.target,
            state.entry
        ];
        $[9] = setRef;
        $[10] = state.entry;
        $[11] = state.inView;
        $[12] = state.target;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
} : function useInView(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
};
module.exports["useInView"] = $cbd0258ef583969a$export$2f62ee6831462844;

});

parcelRegister("8m50u", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

function $fb7caad66dba5065$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
        const $ = (0, $bDgLe.c)(3);
        let t0;
        if ($[0] !== props || $[1] !== ref) {
            t0 = condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentTrue, {
                ...props,
                ref: ref
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentFalse, {
                ...props,
                ref: ref
            });
            $[0] = props;
            $[1] = ref;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    } : (props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $fb7caad66dba5065$export$6e8ea24b15199873;

});

parcelRegister("iyIOY", function(module, exports) {
parcelRequire("95IFc");
var $142hz = parcelRequire("142hz");
var $eC9tI = parcelRequire("eC9tI");
var $niMUw = parcelRequire("niMUw");
var $4RrPd = parcelRequire("4RrPd");
var $bJv8O = parcelRequire("bJv8O");

var $d82e2b7f9d9ed58c$var$global = (0, $niMUw.getGlobalObject)();
/** Send Console API calls as Sentry Events */ var $d82e2b7f9d9ed58c$export$25a43cb5b5c58c08 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function CaptureConsole(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = CaptureConsole.id;
        /**
         * @inheritDoc
         */ this._levels = (0, $142hz.CONSOLE_LEVELS);
        if (options.levels) this._levels = options.levels;
    }
    /**
     * @inheritDoc
     */ CaptureConsole.prototype.setupOnce = function(_, getCurrentHub) {
        if (!('console' in $d82e2b7f9d9ed58c$var$global)) return;
        this._levels.forEach(function(level) {
            if (!(level in $d82e2b7f9d9ed58c$var$global.console)) return;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $eC9tI.fill)($d82e2b7f9d9ed58c$var$global.console, level, function(originalConsoleMethod) {
                return function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    var hub = getCurrentHub();
                    if (hub.getIntegration(CaptureConsole)) hub.withScope(function(scope) {
                        scope.setLevel((0, $bJv8O.severityFromString)(level));
                        scope.setExtra('arguments', args);
                        scope.addEventProcessor(function(event) {
                            event.logger = 'console';
                            return event;
                        });
                        var message = (0, $4RrPd.safeJoin)(args, ' ');
                        if (level === 'assert') {
                            if (args[0] === false) {
                                message = "Assertion failed: " + ((0, $4RrPd.safeJoin)(args.slice(1), ' ') || 'console.assert');
                                scope.setExtra('arguments', args.slice(1));
                                hub.captureMessage(message);
                            }
                        } else if (level === 'error' && args[0] instanceof Error) hub.captureException(args[0]);
                        else hub.captureMessage(message);
                    });
                    // this fails for some browsers. :(
                    if (originalConsoleMethod) originalConsoleMethod.apply($d82e2b7f9d9ed58c$var$global.console, args);
                };
            });
        });
    };
    /**
     * @inheritDoc
     */ CaptureConsole.id = 'CaptureConsole';
    return CaptureConsole;
}();
 //# sourceMappingURL=captureconsole.js.map
module.exports["CaptureConsole"] = $d82e2b7f9d9ed58c$export$25a43cb5b5c58c08;

});

parcelRegister("95IFc", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("niMUw")).getGlobalObject);
$parcel$export(module.exports, "isError", () => (parcelRequire("h6HKI")).isError);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("h6HKI")).isPlainObject);
$parcel$export(module.exports, "CONSOLE_LEVELS", () => (parcelRequire("142hz")).CONSOLE_LEVELS);
$parcel$export(module.exports, "logger", () => (parcelRequire("142hz")).logger);
$parcel$export(module.exports, "normalize", () => (parcelRequire("11Kkv")).normalize);
$parcel$export(module.exports, "fill", () => (parcelRequire("eC9tI")).fill);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("bJv8O")).severityFromString);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("4RrPd")).safeJoin);





parcelRequire("niMUw");


parcelRequire("h6HKI");

parcelRequire("142hz");




var $5kreq = parcelRequire("5kreq");

parcelRequire("11Kkv");

parcelRequire("eC9tI");



parcelRequire("bJv8O");



parcelRequire("4RrPd");




var $6pmA9 = parcelRequire("6pmA9");






 //# sourceMappingURL=index.js.map
$parcel$exportWildcard(module.exports, $5kreq);
$parcel$exportWildcard(module.exports, $6pmA9);

});

parcelRegister("lIxjW", function(module, exports) {

var $niMUw = parcelRequire("niMUw");


var $h6HKI = parcelRequire("h6HKI");

function $fcf78dd05a1f2799$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $fcf78dd05a1f2799$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $fcf78dd05a1f2799$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $h6HKI.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $fcf78dd05a1f2799$export$1cfafeee2987818b() {
    var global = (0, $niMUw.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
} //# sourceMappingURL=browser.js.map
module.exports["htmlTreeAsString"] = $fcf78dd05a1f2799$export$5647df6b7814ac86;

});

parcelRegister("niMUw", function(module, exports) {
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $5kreq = parcelRequire("5kreq");

var $0460b8fabe4a64c2$var$fallbackGlobalObject = {};
function $0460b8fabe4a64c2$export$256479dc0cea61c4() {
    return (0, $5kreq.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $0460b8fabe4a64c2$var$fallbackGlobalObject;
}
function $0460b8fabe4a64c2$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $0460b8fabe4a64c2$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
} //# sourceMappingURL=global.js.map
module.exports["getGlobalObject"] = $0460b8fabe4a64c2$export$256479dc0cea61c4;
module.exports["getGlobalSingleton"] = $0460b8fabe4a64c2$export$7e223ec222791509;

});

parcelRegister("5kreq", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $3HxeM = parcelRequire("3HxeM");


var $1P2f3 = parcelRequire("1P2f3");

function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $3HxeM.isBrowserBundle)() && Object.prototype.toString.call(typeof $1P2f3 !== 'undefined' ? $1P2f3 : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
} //# sourceMappingURL=node.js.map

});

parcelRegister("3HxeM", function(module, exports) {
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $2b1f2b7c68d97ced$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
} //# sourceMappingURL=env.js.map
module.exports["isBrowserBundle"] = $2b1f2b7c68d97ced$export$2928c40372e623c0;

});

parcelRegister("h6HKI", function(module, exports) {
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $c744ef8efbbea969$var$objectToString = Object.prototype.toString;
function $c744ef8efbbea969$export$e6127cc7fe7395c3(wat) {
    switch($c744ef8efbbea969$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $c744ef8efbbea969$export$49034edbe6b62415(wat, Error);
    }
}
function $c744ef8efbbea969$var$isBuiltin(wat, ty) {
    return $c744ef8efbbea969$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $c744ef8efbbea969$export$9f9636d330b71954(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'ErrorEvent');
}
function $c744ef8efbbea969$export$ef9e2056653f0c8e(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'DOMError');
}
function $c744ef8efbbea969$export$12e869b2a583f783(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'DOMException');
}
function $c744ef8efbbea969$export$844ec244b1367d54(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'String');
}
function $c744ef8efbbea969$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $c744ef8efbbea969$export$53b83ca8eaab0383(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'Object');
}
function $c744ef8efbbea969$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $c744ef8efbbea969$export$49034edbe6b62415(wat, Event);
}
function $c744ef8efbbea969$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $c744ef8efbbea969$export$49034edbe6b62415(wat, Element);
}
function $c744ef8efbbea969$export$49841c62b9eff15(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'RegExp');
}
function $c744ef8efbbea969$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $c744ef8efbbea969$export$bc2894c7158efbac(wat) {
    return $c744ef8efbbea969$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $c744ef8efbbea969$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $c744ef8efbbea969$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
} //# sourceMappingURL=is.js.map
module.exports["isError"] = $c744ef8efbbea969$export$e6127cc7fe7395c3;
module.exports["isInstanceOf"] = $c744ef8efbbea969$export$49034edbe6b62415;
module.exports["isString"] = $c744ef8efbbea969$export$844ec244b1367d54;
module.exports["isPrimitive"] = $c744ef8efbbea969$export$c3825b437cbdea5c;
module.exports["isPlainObject"] = $c744ef8efbbea969$export$53b83ca8eaab0383;
module.exports["isEvent"] = $c744ef8efbbea969$export$9671ea99bd126ace;
module.exports["isElement"] = $c744ef8efbbea969$export$45a5e7f76e0caa8d;
module.exports["isRegExp"] = $c744ef8efbbea969$export$49841c62b9eff15;
module.exports["isSyntheticEvent"] = $c744ef8efbbea969$export$bc2894c7158efbac;
module.exports["isNaN"] = $c744ef8efbbea969$export$c9f5652083b8129d;

});

parcelRegister("2Q8PY", function(module, exports) {
var $21174afd68a919a2$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
]; //# sourceMappingURL=enums.js.map
module.exports["SeverityLevels"] = $21174afd68a919a2$export$484b1ea9aec914c;

});

parcelRegister("142hz", function(module, exports) {
$parcel$export(module.exports, "logger", () => $0c67ef66515853ff$export$af88d00dbe7f521);

var $fbwmZ = parcelRequire("fbwmZ");


var $4O82D = parcelRequire("4O82D");


var $niMUw = parcelRequire("niMUw");

// TODO: Implement different loggers for different environments
var $0c67ef66515853ff$var$global = (0, $niMUw.getGlobalObject)();
/** Prefix for logging strings */ var $0c67ef66515853ff$var$PREFIX = 'Sentry Logger ';
var $0c67ef66515853ff$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $0c67ef66515853ff$export$cda52e2a8927a2ca(callback) {
    var global = (0, $niMUw.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $0c67ef66515853ff$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $0c67ef66515853ff$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $4O82D.IS_DEBUG_BUILD) $0c67ef66515853ff$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $0c67ef66515853ff$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $0c67ef66515853ff$var$global.console)[name].apply(_a, (0, $fbwmZ.__spread)([
                    $0c67ef66515853ff$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $0c67ef66515853ff$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $0c67ef66515853ff$export$af88d00dbe7f521;
if (0, $4O82D.IS_DEBUG_BUILD) $0c67ef66515853ff$export$af88d00dbe7f521 = (0, $niMUw.getGlobalSingleton)('logger', $0c67ef66515853ff$var$makeLogger);
else $0c67ef66515853ff$export$af88d00dbe7f521 = $0c67ef66515853ff$var$makeLogger();
 //# sourceMappingURL=logger.js.map
module.exports["CONSOLE_LEVELS"] = $0c67ef66515853ff$export$2a2b1d2252a69ecb;

});

parcelRegister("4O82D", function(module, exports) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $380211d076ff50e5$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__; //# sourceMappingURL=flags.js.map
module.exports["IS_DEBUG_BUILD"] = $380211d076ff50e5$export$48a8984ec0bf2e44;

});

parcelRegister("aY4rC", function(module, exports) {
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $7fc2f48fbe1d088a$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
} //# sourceMappingURL=memo.js.map
module.exports["memoBuilder"] = $7fc2f48fbe1d088a$export$8115b0b78e956ab3;

});

parcelRegister("11Kkv", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $h6HKI = parcelRequire("h6HKI");


var $aY4rC = parcelRequire("aY4rC");


var $eC9tI = parcelRequire("eC9tI");


var $fgmiz = parcelRequire("fgmiz");

function $0bf9d29200a37024$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $0bf9d29200a37024$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $0bf9d29200a37024$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $0bf9d29200a37024$export$a3295358bff77e(object, depth);
    if ($0bf9d29200a37024$var$jsonSize(normalized) > maxSize) return $0bf9d29200a37024$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $0bf9d29200a37024$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $aY4rC.memoBuilder)();
    var _a = (0, $fbwmZ.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $h6HKI.isNaN)(value)) return value;
    var stringified = $0bf9d29200a37024$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $h6HKI.isError)(value) || (0, $h6HKI.isEvent)(value) ? (0, $eC9tI.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $0bf9d29200a37024$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $0bf9d29200a37024$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $h6HKI.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, $fgmiz.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $0bf9d29200a37024$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $0bf9d29200a37024$var$jsonSize(value) {
    return $0bf9d29200a37024$var$utf8Length(JSON.stringify(value));
} //# sourceMappingURL=normalize.js.map
module.exports["normalize"] = $0bf9d29200a37024$export$a3295358bff77e;

});

parcelRegister("eC9tI", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $lIxjW = parcelRequire("lIxjW");


var $h6HKI = parcelRequire("h6HKI");


var $4RrPd = parcelRequire("4RrPd");

function $aa3bf77b99750f4a$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $aa3bf77b99750f4a$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $aa3bf77b99750f4a$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $aa3bf77b99750f4a$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $aa3bf77b99750f4a$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $aa3bf77b99750f4a$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $aa3bf77b99750f4a$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $aa3bf77b99750f4a$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $h6HKI.isError)(value)) newObj = (0, $fbwmZ.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $aa3bf77b99750f4a$var$getOwnProperties(value));
    else if ((0, $h6HKI.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $fbwmZ.__assign)({
            type: event_1.type,
            target: $aa3bf77b99750f4a$var$serializeEventTarget(event_1.target),
            currentTarget: $aa3bf77b99750f4a$var$serializeEventTarget(event_1.currentTarget)
        }, $aa3bf77b99750f4a$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $h6HKI.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $aa3bf77b99750f4a$var$serializeEventTarget(target) {
    try {
        return (0, $h6HKI.isElement)(target) ? (0, $lIxjW.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $aa3bf77b99750f4a$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $aa3bf77b99750f4a$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($aa3bf77b99750f4a$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $4RrPd.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $4RrPd.truncate)(serialized, maxLength);
    }
    return '';
}
function $aa3bf77b99750f4a$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $h6HKI.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $fbwmZ.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $aa3bf77b99750f4a$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($aa3bf77b99750f4a$export$d25f2688db1bb433);
    return val;
}
function $aa3bf77b99750f4a$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $h6HKI.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
} //# sourceMappingURL=object.js.map
module.exports["fill"] = $aa3bf77b99750f4a$export$9563e054e6f787fb;
module.exports["convertToPlainObject"] = $aa3bf77b99750f4a$export$62ff257738bf57f5;

});

parcelRegister("4RrPd", function(module, exports) {

var $h6HKI = parcelRequire("h6HKI");

function $38a1b21eefbb9b2d$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $38a1b21eefbb9b2d$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $38a1b21eefbb9b2d$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $38a1b21eefbb9b2d$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $h6HKI.isString)(value)) return false;
    if ((0, $h6HKI.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $38a1b21eefbb9b2d$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
} //# sourceMappingURL=string.js.map
module.exports["truncate"] = $38a1b21eefbb9b2d$export$6a506b36fdea397d;
module.exports["safeJoin"] = $38a1b21eefbb9b2d$export$465e9d514283d4fd;

});

parcelRegister("fgmiz", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");

var $b1c9a5aa64b78b97$var$STACKTRACE_LIMIT = 50;
function $b1c9a5aa64b78b97$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $fbwmZ.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $fbwmZ.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $b1c9a5aa64b78b97$export$c55c24c0eeba0205(frames);
    };
}
function $b1c9a5aa64b78b97$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $b1c9a5aa64b78b97$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var $b1c9a5aa64b78b97$var$defaultFunctionName = '<anonymous>';
function $b1c9a5aa64b78b97$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $b1c9a5aa64b78b97$var$defaultFunctionName;
        return fn.name || $b1c9a5aa64b78b97$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $b1c9a5aa64b78b97$var$defaultFunctionName;
    }
} //# sourceMappingURL=stacktrace.js.map
module.exports["getFunctionName"] = $b1c9a5aa64b78b97$export$aad197c7121a6651;

});

parcelRegister("bJv8O", function(module, exports) {

var $dtZ6d = parcelRequire("dtZ6d");


var $2Q8PY = parcelRequire("2Q8PY");

function $88ac0da36f058dd3$var$isSupportedSeverity(level) {
    return (0, $2Q8PY.SeverityLevels).indexOf(level) !== -1;
}
function $88ac0da36f058dd3$export$e01cef29b4327697(level) {
    if (level === 'warn') return (0, $dtZ6d.Severity).Warning;
    if ($88ac0da36f058dd3$var$isSupportedSeverity(level)) return level;
    return (0, $dtZ6d.Severity).Log;
} //# sourceMappingURL=severity.js.map
module.exports["severityFromString"] = $88ac0da36f058dd3$export$e01cef29b4327697;

});

parcelRegister("6pmA9", function(module, exports) {

var $niMUw = parcelRequire("niMUw");


var $5kreq = parcelRequire("5kreq");

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $niMUw.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $5kreq.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $5kreq.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $niMUw.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}(); //# sourceMappingURL=time.js.map

});

parcelRegister("6W0Xl", function(module, exports) {
parcelRequire("95IFc");
var $142hz = parcelRequire("142hz");


var $c9L3v = parcelRequire("c9L3v");

/** Deduplication filter */ var $50c8e6bccf5bbb5e$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($50c8e6bccf5bbb5e$export$3c6361fddf6cd929(currentEvent, self._previousEvent)) {
                        (0, $c9L3v.IS_DEBUG_BUILD) && (0, $142hz.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
function $50c8e6bccf5bbb5e$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($50c8e6bccf5bbb5e$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($50c8e6bccf5bbb5e$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$50c8e6bccf5bbb5e$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$50c8e6bccf5bbb5e$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $50c8e6bccf5bbb5e$var$_getExceptionFromEvent(previousEvent);
    var currentException = $50c8e6bccf5bbb5e$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$50c8e6bccf5bbb5e$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$50c8e6bccf5bbb5e$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $50c8e6bccf5bbb5e$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $50c8e6bccf5bbb5e$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
} //# sourceMappingURL=dedupe.js.map
module.exports["Dedupe"] = $50c8e6bccf5bbb5e$export$688d98c249d31ad3;

});

parcelRegister("c9L3v", function(module, exports) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $8d9ad39358b035f4$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__; //# sourceMappingURL=flags.js.map
module.exports["IS_DEBUG_BUILD"] = $8d9ad39358b035f4$export$48a8984ec0bf2e44;

});

parcelRegister("fa95z", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");

parcelRequire("95IFc");
var $h6HKI = parcelRequire("h6HKI");
var $142hz = parcelRequire("142hz");
var $11Kkv = parcelRequire("11Kkv");


var $c9L3v = parcelRequire("c9L3v");

/** Patch toString calls to return proper name for wrapped functions */ var $b09ed70491c36903$export$56d961ef3a52a072 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function ExtraErrorData(options) {
        /**
         * @inheritDoc
         */ this.name = ExtraErrorData.id;
        this._options = (0, $fbwmZ.__assign)({
            depth: 3
        }, options);
    }
    /**
     * @inheritDoc
     */ ExtraErrorData.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event, hint) {
            var self = getCurrentHub().getIntegration(ExtraErrorData);
            if (!self) return event;
            return self.enhanceEventWithErrorData(event, hint);
        });
    };
    /**
     * Attaches extracted information from the Error object to extra field in the Event
     */ ExtraErrorData.prototype.enhanceEventWithErrorData = function(event, hint) {
        var _a;
        if (!hint || !hint.originalException || !(0, $h6HKI.isError)(hint.originalException)) return event;
        var name = hint.originalException.name || hint.originalException.constructor.name;
        var errorData = this._extractErrorData(hint.originalException);
        if (errorData) {
            var contexts = (0, $fbwmZ.__assign)({}, event.contexts);
            var normalizedErrorData = (0, $11Kkv.normalize)(errorData, this._options.depth);
            if ((0, $h6HKI.isPlainObject)(normalizedErrorData)) contexts = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, event.contexts), (_a = {}, _a[name] = (0, $fbwmZ.__assign)({}, normalizedErrorData), _a));
            return (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, event), {
                contexts: contexts
            });
        }
        return event;
    };
    /**
     * Extract extra information from the Error object
     */ ExtraErrorData.prototype._extractErrorData = function(error) {
        var e_1, _a, e_2, _b;
        // We are trying to enhance already existing event, so no harm done if it won't succeed
        try {
            var nativeKeys = [
                'name',
                'message',
                'stack',
                'line',
                'column',
                'fileName',
                'lineNumber',
                'columnNumber',
                'toJSON'
            ];
            var extraErrorInfo = {};
            try {
                // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
                for(var _c = (0, $fbwmZ.__values)(Object.keys(error)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var key = _d.value;
                    if (nativeKeys.indexOf(key) !== -1) continue;
                    var value = error[key];
                    extraErrorInfo[key] = (0, $h6HKI.isError)(value) ? value.toString() : value;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
            if (typeof error.toJSON === 'function') {
                var serializedError = error.toJSON();
                try {
                    for(var _e = (0, $fbwmZ.__values)(Object.keys(serializedError)), _f = _e.next(); !_f.done; _f = _e.next()){
                        var key = _f.value;
                        var value = serializedError[key];
                        extraErrorInfo[key] = (0, $h6HKI.isError)(value) ? value.toString() : value;
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            return extraErrorInfo;
        } catch (oO) {
            (0, $c9L3v.IS_DEBUG_BUILD) && (0, $142hz.logger).error('Unable to extract extra data from the Error object:', oO);
        }
        return null;
    };
    /**
     * @inheritDoc
     */ ExtraErrorData.id = 'ExtraErrorData';
    return ExtraErrorData;
}();
 //# sourceMappingURL=extraerrordata.js.map
module.exports["ExtraErrorData"] = $b09ed70491c36903$export$56d961ef3a52a072;

});

parcelRegister("hLq0X", function(module, exports) {
/** Add node transaction to the event */ var $ceeb015bb088f872$export$febc5573c75cefb0 = /** @class */ function() {
    function Transaction() {
        /**
         * @inheritDoc
         */ this.name = Transaction.id;
    }
    /**
     * @inheritDoc
     */ Transaction.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var self = getCurrentHub().getIntegration(Transaction);
            if (self) return self.process(event);
            return event;
        });
    };
    /**
     * @inheritDoc
     */ Transaction.prototype.process = function(event) {
        var frames = this._getFramesFromEvent(event);
        // use for loop so we don't have to reverse whole frames array
        for(var i = frames.length - 1; i >= 0; i--){
            var frame = frames[i];
            if (frame.in_app === true) {
                event.transaction = this._getTransaction(frame);
                break;
            }
        }
        return event;
    };
    /** JSDoc */ Transaction.prototype._getFramesFromEvent = function(event) {
        var exception = event.exception && event.exception.values && event.exception.values[0];
        return exception && exception.stacktrace && exception.stacktrace.frames || [];
    };
    /** JSDoc */ Transaction.prototype._getTransaction = function(frame) {
        return frame.module || frame.function ? (frame.module || '?') + "/" + (frame.function || '?') : '<unknown>';
    };
    /**
     * @inheritDoc
     */ Transaction.id = 'Transaction';
    return Transaction;
}();
 //# sourceMappingURL=transaction.js.map
module.exports["Transaction"] = $ceeb015bb088f872$export$febc5573c75cefb0;

});

parcelRegister("mr7nI", function(module, exports) {
$parcel$export(module.exports, "default", () => $0437174526e2cd74$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $0437174526e2cd74$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var dateToCompare = (0, $dkBOe.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("fhdGv", function(module, exports) {
/* Status.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lzgC6 = parcelRequire("lzgC6");


var $9KSWX = parcelRequire("9KSWX");


var $ftY7H = parcelRequire("ftY7H");


var $jDboD = parcelRequire("jDboD");


var $fB42n = parcelRequire("fB42n");

function $ba35a2a9fe36df5b$var$_defineProperty(e, r, t) {
    return (r = $ba35a2a9fe36df5b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ba35a2a9fe36df5b$var$_toPropertyKey(t) {
    var i = $ba35a2a9fe36df5b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ba35a2a9fe36df5b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $ba35a2a9fe36df5b$var$MAX_WIDTH = 200; /**
                        * This is to account for a bug in android chromium and should be removed
                        * when the editor fixes its focus handling with respect to Status.
                        *
                        * See DSP-7701 for additional context.
                        */ 
const $ba35a2a9fe36df5b$var$inlineBlockStyles = null; // Bound the Lozenge to its parent while keeping short statuses content-sized.
const $ba35a2a9fe36df5b$var$constrainedToParentStyles = null; // eg. Version/4.0 Chrome/95.0.4638.50
const $ba35a2a9fe36df5b$var$isAndroidChromium = typeof window !== 'undefined' && /Version\/.* Chrome\/.*/.test(window.navigator.userAgent);
class $ba35a2a9fe36df5b$var$StatusInternal extends (0, $cozmU.PureComponent) {
    componentWillUnmount() {
        this.hoverStartTime = 0;
    }
    render() {
        const { text: text, color: color, style: style, role: role, onClick: onClick, isBold: isBold, isConstrainedToParent: isConstrainedToParent } = this.props;
        if (text.trim().length === 0) return null;
        const appearance = (0, $fB42n.getLozengeAppearance)(color); // Note: ommitted data-local-id attribute to avoid copying/pasting the same localId
        return /*#__PURE__*/ $cozmU.createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: (0, $hekY6.default)([
                $ba35a2a9fe36df5b$var$isAndroidChromium && "_0ReY56US2K _3HdVfPey7F _3pS3pEt2nV",
                isConstrainedToParent && "_3iDTPbvbI6 _1EqgXlN91d",
                "status-lozenge-span"
            ]),
            onClick: onClick,
            onKeyDown: onClick ? this.handleKeyDown : undefined,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            tabIndex: onClick ? -1 : undefined,
            "data-node-type": "status",
            "data-color": (0, $fB42n.normalizeColor)(color),
            "data-style": style,
            role: role
        }, /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
            appearance: appearance,
            maxWidth: $ba35a2a9fe36df5b$var$MAX_WIDTH,
            isBold: isBold
        }, text));
    }
    constructor(...args){
        super(...args);
        $ba35a2a9fe36df5b$var$_defineProperty(this, "hoverStartTime", 0);
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleMouseEnter", (_e)=>{
            this.hoverStartTime = Date.now();
        });
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleMouseLeave", (_e)=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $jDboD.ANALYTICS_HOVER_DELAY) && onHover) onHover();
            this.hoverStartTime = 0;
        });
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleKeyDown", (e)=>{
            const { onClick: onClick } = this.props;
            if (onClick && (e.key === 'Enter' || e.key === ' ')) {
                e.preventDefault();
                onClick(e);
            }
        });
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleFocus", (_e)=>{
            this.hoverStartTime = Date.now();
        });
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleBlur", (_e)=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $jDboD.ANALYTICS_HOVER_DELAY) && onHover) onHover();
            this.hoverStartTime = 0;
        });
    }
}
$ba35a2a9fe36df5b$var$_defineProperty($ba35a2a9fe36df5b$var$StatusInternal, "displayName", 'StatusInternal');
const $ba35a2a9fe36df5b$export$96e9906d6d93a972 = (0, $lzgC6.default)({
    onClick: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $ftY7H.createStatusAnalyticsAndFire)(createEvent)({
            action: 'clicked',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    },
    onHover: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $ftY7H.createStatusAnalyticsAndFire)(createEvent)({
            action: 'hovered',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    }
})($ba35a2a9fe36df5b$var$StatusInternal);
module.exports["Status"] = $ba35a2a9fe36df5b$export$96e9906d6d93a972;

});

parcelRegister("ftY7H", function(module, exports) {
const $63d299faa378dc1a$export$d821aa4c8afb384e = 'fabric-elements';
const $63d299faa378dc1a$var$packageName = "platform-pkg";
const $63d299faa378dc1a$var$packageVersion = "0.0.0-use.local";
const $63d299faa378dc1a$export$aa98853957f9f5aa = (createAnalyticsEvent)=>(payload)=>{
        const statusPayload = {
            ...payload,
            eventType: 'ui'
        };
        if (!statusPayload.attributes) statusPayload.attributes = {};
        statusPayload.attributes.packageName = $63d299faa378dc1a$var$packageName;
        statusPayload.attributes.packageVersion = $63d299faa378dc1a$var$packageVersion;
        statusPayload.attributes.componentName = 'status';
        const event = createAnalyticsEvent(statusPayload);
        event.fire($63d299faa378dc1a$export$d821aa4c8afb384e);
        return event;
    };
module.exports["createStatusAnalyticsAndFire"] = $63d299faa378dc1a$export$aa98853957f9f5aa;

});

parcelRegister("jDboD", function(module, exports) {
const $92130f7ce8b5e3de$export$7452d7062a4d0634 = 1000;
module.exports["ANALYTICS_HOVER_DELAY"] = $92130f7ce8b5e3de$export$7452d7062a4d0634;

});

parcelRegister("fB42n", function(module, exports) {

var $2pQiO = parcelRequire("2pQiO");


var $iDrrr = parcelRequire("iDrrr");

const $7f74d498381e9123$export$c6adb6b4e776f0d5 = [
    'neutral',
    'purple',
    'blue',
    'red',
    'yellow',
    'green'
];
const $7f74d498381e9123$export$ccac7cd631a2cc0f = [
    '#B3F5FF',
    // Teal
    '#ABF5D1',
    // Green
    '#D3F1A7',
    // Lime — named `green` renders identically
    '#FFF0B3',
    // Yellow
    '#FCE4A6',
    // Orange — named `yellow` renders identically
    '#FDD0EC' // Magenta
];
const $7f74d498381e9123$export$acfdfc8c64e6747 = 'neutral';
const $7f74d498381e9123$export$645e10b5a408e986 = {
    neutral: 'neutral',
    purple: 'discovery',
    blue: 'information',
    red: 'danger',
    yellow: 'warning',
    green: 'success'
};
const $7f74d498381e9123$export$692279d423b4caab = "var(--ds-icon, #292A2E)";
const $7f74d498381e9123$export$56d196d2844d1ca1 = {
    neutral: {
        appearance: 'neutral',
        labelKey: 'neutralColor',
        swatch: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            borderColor: "var(--ds-border, #0B120E24)"
        }
    },
    blue: {
        appearance: 'accent-blue',
        labelKey: 'blueColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
            borderColor: "var(--ds-border-accent-blue-subtle, #8FB8F6)"
        }
    },
    '#B3F5FF': {
        appearance: 'accent-teal',
        labelKey: 'tealColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
            borderColor: "var(--ds-border-accent-teal-subtle, #9DD9EE)"
        }
    },
    '#ABF5D1': {
        appearance: 'accent-green',
        labelKey: 'greenColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
            borderColor: "var(--ds-border-accent-green-subtle, #7EE2B8)"
        }
    },
    '#D3F1A7': {
        appearance: 'accent-lime',
        labelKey: 'limeColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
            borderColor: "var(--ds-border-accent-lime-subtle, #B3DF72)"
        }
    },
    '#FFF0B3': {
        appearance: 'accent-yellow',
        labelKey: 'yellowColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
            borderColor: "var(--ds-border-accent-yellow-subtle, #EED12B)"
        }
    },
    '#FCE4A6': {
        appearance: 'accent-orange',
        labelKey: 'orangeColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
            borderColor: "var(--ds-border-accent-orange-subtle, #FBC828)"
        }
    },
    red: {
        appearance: 'accent-red',
        labelKey: 'redColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
            borderColor: "var(--ds-border-accent-red-subtle, #FD9891)"
        }
    },
    '#FDD0EC': {
        appearance: 'accent-magenta',
        labelKey: 'magentaColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
            borderColor: "var(--ds-border-accent-magenta-subtle, #F797D2)"
        }
    },
    purple: {
        appearance: 'accent-purple',
        labelKey: 'purpleColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)",
            borderColor: "var(--ds-border-accent-purple-subtle, #D8A0F7)"
        }
    },
    yellow: {
        appearance: 'accent-orange',
        labelKey: 'yellowColor'
    },
    green: {
        appearance: 'accent-lime',
        labelKey: 'greenColor'
    }
};
const $7f74d498381e9123$export$d42d7c94d7629c23 = [
    'neutral',
    // Gray
    'blue',
    // Blue
    '#B3F5FF',
    // Teal
    '#ABF5D1',
    // Green
    '#D3F1A7',
    // Lime
    '#FFF0B3',
    // Yellow
    '#FCE4A6',
    // Orange
    'red',
    // Red
    '#FDD0EC',
    // Magenta
    'purple' // Purple
];
const $7f74d498381e9123$export$ee5a21461d1db57c = (color)=>$7f74d498381e9123$export$c6adb6b4e776f0d5.includes(color);
const $7f74d498381e9123$export$4cde5df63f53f473 = (color)=>color.startsWith('#') ? color.toUpperCase() : color;
const $7f74d498381e9123$var$specFor = (color)=>$7f74d498381e9123$export$56d196d2844d1ca1[$7f74d498381e9123$export$4cde5df63f53f473(color)];
const $7f74d498381e9123$export$4bc90a066e1dabc3 = (color)=>$7f74d498381e9123$var$specFor(color)?.labelKey ?? 'neutralColor';
const $7f74d498381e9123$export$13752f03fbf881b8 = (swatchValue, selectedColor)=>{
    if (!selectedColor) return false;
    if ($7f74d498381e9123$export$4cde5df63f53f473(swatchValue) === $7f74d498381e9123$export$4cde5df63f53f473(selectedColor)) return true;
    // A swatch also counts as selected when it renders the same hue under a different
    // id — legacy named `green`/`yellow` share the Lime/Orange swatches. Unknown values
    // have no spec, so they never collide on the neutral fallback.
    const swatchAppearance = $7f74d498381e9123$var$specFor(swatchValue)?.appearance;
    return swatchAppearance !== undefined && swatchAppearance === $7f74d498381e9123$var$specFor(selectedColor)?.appearance;
};
const $7f74d498381e9123$export$4d9e331cafeacb9d = (color)=>{
    const isUpdateStatusColorsEnabled = (0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_update_status_colors', 'isEnabled', false);
    // Named colours are recoloured only by the experiment. `gracefully_render_status_color`
    // is a read-path gate for hex written by another cohort, so it must never reach here.
    if ($7f74d498381e9123$export$ee5a21461d1db57c(color)) return isUpdateStatusColorsEnabled ? $7f74d498381e9123$export$56d196d2844d1ca1[color].appearance : $7f74d498381e9123$export$645e10b5a408e986[color];
    if (isUpdateStatusColorsEnabled || (0, $iDrrr.fg)('platform_editor_gracefully_render_status_color')) return $7f74d498381e9123$var$specFor(color)?.appearance ?? $7f74d498381e9123$export$acfdfc8c64e6747;
    return $7f74d498381e9123$export$acfdfc8c64e6747;
};
module.exports["SWATCH_ICON_COLOR"] = $7f74d498381e9123$export$692279d423b4caab;
module.exports["COLORS"] = $7f74d498381e9123$export$56d196d2844d1ca1;
module.exports["PICKER_SWATCHES"] = $7f74d498381e9123$export$d42d7c94d7629c23;
module.exports["normalizeColor"] = $7f74d498381e9123$export$4cde5df63f53f473;
module.exports["getColorLabelKey"] = $7f74d498381e9123$export$4bc90a066e1dabc3;
module.exports["isSwatchSelected"] = $7f74d498381e9123$export$13752f03fbf881b8;
module.exports["getLozengeAppearance"] = $7f74d498381e9123$export$4d9e331cafeacb9d;

});

parcelRegister("aHoC6", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fc71b9d8c80c48f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $5X6fy = parcelRequire("5X6fy");


var $7Y8M5 = parcelRequire("7Y8M5");


var $iDrrr = parcelRequire("iDrrr");


var $5o4s6 = parcelRequire("5o4s6");


var $4G6PK = parcelRequire("4G6PK");


var $95Vjg = parcelRequire("95Vjg");


var $ihn0W = parcelRequire("ihn0W");


var $hNvnn = parcelRequire("hNvnn");

function $7fc71b9d8c80c48f$export$2e2bcd8739ae039({ layout: layout, width: width, height: height, containerWidth: containerWidth = width, isLoading: isLoading = false, pctWidth: pctWidth, size: size, className: className, children: propsChildren, nodeType: nodeType = 'mediaSingle', fullWidthMode: fullWidthMode, lineLength: editorWidth, hasFallbackContainer: hasFallbackContainer = true, handleMediaSingleRef: handleMediaSingleRef, isInsideOfInlineExtension: isInsideOfInlineExtension = false, dataAttributes: dataAttributes, isInRenderer: isInRenderer = false }) {
    const isPixelWidth = size?.widthType === 'pixel';
    let mediaSingleWidth = size?.width || pctWidth;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(propsChildren);
    if (!mediaSingleWidth && (0, $ihn0W.shouldAddDefaultWrappedWidth)(layout, width, editorWidth)) // if width is not available, set to half of editor width
    mediaSingleWidth = isPixelWidth ? editorWidth / 2 : 50;
    // When width is not set we have an absolute height for a given embed.
    // When both width and height are set we use them to determine ratio and use that to define
    // embed height in relation to whatever width of an dom element is in runtime.
    const isHeightOnly = width === undefined;
    // Preserve the absolute height before it is scaled below, so we can fall back to it if the
    // pixel-width computation yields a non-finite value (e.g. editorWidth/lineLength is 0 or
    // undefined in some host renderers such as Jira issue view).
    const absoluteHeight = height;
    if (mediaSingleWidth) {
        const pxWidth = (0, $95Vjg.getMediaSinglePixelWidth)(mediaSingleWidth, editorWidth, size?.widthType, (0, $4G6PK.MEDIA_SINGLE_GUTTER_SIZE));
        if (isHeightOnly) width = pxWidth - (0, $7Y8M5.akEditorMediaResizeHandlerPaddingWide);
        else if (width !== undefined) {
            height = height / width * pxWidth;
            width = pxWidth;
        }
    } else if (isHeightOnly) // No mediaSingleWidth can be found on already existing pages with existing embeds
    // It's ok to use Embed specific width, because width can be not set only in embed card.
    // This value will be used only in the case of non `wide` and non `full-width` cases inside MediaSingleDimensionHelper.
    width = (0, $7Y8M5.DEFAULT_EMBED_CARD_WIDTH) - (0, $7Y8M5.akEditorMediaResizeHandlerPaddingWide);
    // Media wrapper controls the height of the box.
    // We can define this height
    // - via height directly
    // - via paddingBottom (if we have both height and width) which is a css trick to represent a ratio
    let mediaWrapperHeight;
    let paddingBottom;
    if (isHeightOnly) mediaWrapperHeight = height;
    else if (width !== undefined && !Number.isFinite(height / width * 100) && (0, $iDrrr.fg)('platform_editor_embed_height_only_fallback')) // The aspect-ratio (padding-bottom) trick collapses to 0 when the ratio is non-finite,
    // which happens when the resolved pixel width is 0/NaN (e.g. editorWidth/lineLength is
    // unavailable in the host renderer). Fall back to the embed's absolute height so the box
    // keeps a usable height instead of collapsing.
    // For embedCard nodes the `height` prop is the iframe height only; the normal ratio path
    // adds 32px for the embed header (see `calc(... + 32px)` below), so add it here too to
    // avoid clipping the header.
    mediaWrapperHeight = Number.isFinite(absoluteHeight) ? absoluteHeight + (nodeType === 'embedCard' ? 32 : 0) : undefined;
    else if (width !== undefined) {
        const mediaWrapperRatio = height / width * 100;
        paddingBottom = `${mediaWrapperRatio.toFixed(3)}%`;
        if (nodeType === 'embedCard') // we want to set ratio of whole box (including header) buy knowing ratio of iframe itself
        // For some reason importing `embedHeaderHeight` from '@atlaskit/smart-card' breaks
        // packages/editor/editor-core/src/plugins/table/__tests__/unit/toolbar.ts 🤷‍️, but we have a test
        // that uses imported value, so it's should be good.
        paddingBottom = `calc(${paddingBottom} + 32px)`;
    }
    const [media, caption] = children;
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        ref: handleMediaSingleRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $hNvnn.MediaSingleDimensionHelper)({
            width: width,
            layout: layout,
            containerWidth: containerWidth,
            mediaSingleWidth: mediaSingleWidth,
            fullWidthMode: fullWidthMode,
            isExtendedResizeExperienceOn: isPixelWidth,
            isInsideOfInlineExtension: isInsideOfInlineExtension,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isInRenderer: isInRenderer && (0, $iDrrr.fg)('media-perf-uplift-mutation-fix')
        }),
        "data-layout": layout,
        "data-width": mediaSingleWidth,
        "data-width-type": size?.widthType || 'percentage',
        "data-node-type": nodeType,
        "data-vc": "media-single",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('rich-media-item mediaSingleView-content-wrap', `image-${layout}`, className, {
            'is-loading': isLoading,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        }),
        ...dataAttributes,
        ...(0, $5o4s6.VcMediaWrapperProps)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $hNvnn.MediaWrapper), {
        hasFallbackContainer: hasFallbackContainer,
        height: mediaWrapperHeight,
        paddingBottom: paddingBottom
    }, media), caption);
}

});

parcelRegister("95Vjg", function(module, exports) {
/**
 * Convert media node width to pixel
 *
 * for legacy experience, image is aligned inside resize handle bar with a gap. So gutterOffset is used to for this use case.
 * for new experience, image is aligned with resize handle bar, so gutterOffset is 0
 *
 * @param width - media single node width
 * @param editorWidth - width of editor
 * @param widthType - width type is defined in the adf document for mediaSingle node, and it is associated with the `width`
 * @param gutterOffset - resize handle bar offset, determines whether align with resize handle bar
 * @returns pixel number for media single node
 */ function $69e3419be6a9274a$export$a6f4ec2edd25b07e(width, editorWidth, widthType = 'percentage', gutterOffset = 0) {
    if (widthType === 'pixel') return width;
    return Math.ceil((editorWidth + gutterOffset) * (width / 100) - gutterOffset);
}
module.exports["getMediaSinglePixelWidth"] = $69e3419be6a9274a$export$a6f4ec2edd25b07e;

});

parcelRegister("hNvnn", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $7Y8M5 = parcelRequire("7Y8M5");


var $8qft0 = parcelRequire("8qft0");


var $h9Lux = parcelRequire("h9Lux");


var $5y9Nl = parcelRequire("5y9Nl");


var $fuDKy = parcelRequire("fuDKy");

function $640d411acbc53708$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $640d411acbc53708$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
function $640d411acbc53708$var$getWidthIfFullWidthMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $7Y8M5.akEditorFullWidthLayoutWidth) ? `${Math.min(containerWidth, (0, $7Y8M5.akEditorFullWidthLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $7Y8M5.akEditorFullWidthLayoutWidth) ? '100%' : `${originalWidth}px`;
}
function $640d411acbc53708$var$getWidthIfDefaultMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $7Y8M5.akEditorFullPageMaxWidth) ? `${Math.min(containerWidth, (0, $7Y8M5.akEditorDefaultLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $7Y8M5.akEditorFullPageMaxWidth) ? '100%' : `${originalWidth}px`;
}
function $640d411acbc53708$export$326222fa0d211f8e(layout, width, containerWidth = 0, fullWidthMode, isResized, isInsideOfInlineExtension) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return isInsideOfInlineExtension ? (0, $h9Lux.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`) : (0, $h9Lux.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $h9Lux.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $640d411acbc53708$var$getWidthIfFullWidthMode(width, containerWidth, isInsideOfInlineExtension) : $640d411acbc53708$var$getWidthIfDefaultMode(width, containerWidth, isInsideOfInlineExtension);
    }
}
function $640d411acbc53708$export$e4db998a333a342e(layout, width, containerWidth = 0, fullWidthMode, isResized) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return (0, $h9Lux.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`);
        case 'full-width':
            return (0, $h9Lux.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $640d411acbc53708$var$getWidthIfFullWidthMode(width, containerWidth) : $640d411acbc53708$var$getWidthIfDefaultMode(width, containerWidth);
    }
}
function $640d411acbc53708$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
function $640d411acbc53708$var$calcMaxCssForPercentageTypeMedia(layout) {
    switch(layout){
        case 'wide':
            return `min(var(--ak-editor--breakout-wide-layout-width), var(--ak-editor-max-container-width))`;
        case 'full-width':
            return `min(var(--ak-editor--full-width-layout-width), var(--ak-editor-max-container-width))`;
        default:
            return 'var(--ak-editor-max-container-width)';
    }
}
function $640d411acbc53708$var$isImageAligned(layout) {
    switch(layout){
        case 'align-end':
            return 'margin-right: 0';
        case 'align-start':
            return 'margin-left: 0';
        default:
            return '';
    }
}
/**
 * Can't use `.attrs` to handle highly dynamic styles because we are still
 * supporting `styled-components` v1.
 * @param root0
 * @param root0.containerWidth
 * @param root0.fullWidthMode
 * @param root0.isResized
 * @param root0.layout
 * @param root0.mediaSingleWidth
 * @param root0.width
 * @param root0.isExtendedResizeExperienceOn
 * @param root0.isNestedNode
 * @param root0.isInsideOfInlineExtension
 * @param root0.isInRenderer
 * @example
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $640d411acbc53708$var$_ref = {
    name: "1il1ars",
    styles: "@container ak-renderer-wrapper (min-width: 1px){max-width:100cqw;}"
};
var $640d411acbc53708$var$_ref2 = {
    name: "1bxycju",
    styles: "min-width:100%"
};
const $640d411acbc53708$export$2b2737a2ef2f5b46 = ({ containerWidth: containerWidth = 0, fullWidthMode: fullWidthMode, isResized: isResized, layout: layout, mediaSingleWidth: mediaSingleWidth, width: width, isExtendedResizeExperienceOn: // original media width
isExtendedResizeExperienceOn, isNestedNode: isNestedNode = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false, isInRenderer: isInRenderer = false })=>{
    const calculatedWidth = (0, $fuDKy.roundToClosestEvenPxValue)(isExtendedResizeExperienceOn ? `${mediaSingleWidth || width}px` : mediaSingleWidth ? (0, $5y9Nl.calcResizedWidth)(layout, width || 0, containerWidth) : $640d411acbc53708$export$326222fa0d211f8e(layout, width || 0, containerWidth, fullWidthMode, isResized, isInsideOfInlineExtension));
    const cssMaxWidth = isExtendedResizeExperienceOn ? 'var(--ak-editor-max-container-width)' : $640d411acbc53708$var$calcMaxCssForPercentageTypeMedia(layout);
    // jest warning: JSDOM version (22) doesn't support the new @container CSS rule
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    return /*#__PURE__*/ (0, $lOiVq.css)("tr &,[data-layout-column] &,[data-node-type='expand'] &,[data-panel-type] &,li &,[data-prosemirror-node-name='bodiedSyncBlock'] &,[data-prosemirror-node-name='syncBlock'] &,[data-sync-block-renderer] &,[data-bodied-sync-block] &{max-width:100%;}width:", calculatedWidth, ";", layout === 'full-width' && /* This causes issues for new experience where we don't strip layout attributes
   when copying top-level node and pasting into a table/layout,
   because full-width layout will remain, causing node to be edge-to-edge */ !isExtendedResizeExperienceOn && $640d411acbc53708$var$_ref2, " ", isInRenderer ? $640d411acbc53708$var$_ref : `max-width: ${cssMaxWidth};`, " ", isExtendedResizeExperienceOn && `&[class*='is-resizing'] {
    .new-file-experience-wrapper {
      box-shadow: none !important;
    }

    ${!isNestedNode && (0, $8qft0.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
      transform: translateX(-50%);`}
  }`, " &:not(.is-resizing){transition:width 100ms ease-in;}float:", $640d411acbc53708$var$float(layout), ";margin:", $640d411acbc53708$var$calcMargin(layout), ";&[class*='not-resizing']{", isNestedNode ? /* Make nested node appear responsive when resizing table cell */ `max-width: 100%;` : (0, $8qft0.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
        transform: translateX(-50%);`, ";}", $640d411acbc53708$var$isImageAligned(layout), ";");
};
const $640d411acbc53708$var$RenderFallbackContainer = ({ hasFallbackContainer: hasFallbackContainer, paddingBottom: paddingBottom, height: height })=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    (0, $lOiVq.css)(hasFallbackContainer ? `
  &::after {
    content: '';
    display: block;
    ${height ? `height: ${height}px;` : paddingBottom ? `padding-bottom: ${paddingBottom};` : ''}

    /* Fixes extra padding problem in Firefox */
    font-size: 0;
    line-height: 0;
  }
  ` : '', ";");
const $640d411acbc53708$export$9e3fd9f6215dd7b6 = (props)=>/*#__PURE__*/ (0, $lOiVq.css)("position:relative;", $640d411acbc53708$var$RenderFallbackContainer(props), "&>figure{position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}&>div:not([data-media-badges='true']){position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}& * [data-mark-annotation-type='inlineComment']{width:100%;height:100%;}&[data-node-type='embedCard']>div{width:100%;}[data-node-type='media']{position:static!important;height:auto!important;>div{position:absolute;height:100%;}}");
const $640d411acbc53708$export$542000db99cecf28 = ({ children: children, ...rest })=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $640d411acbc53708$export$9e3fd9f6215dd7b6(rest)
    }, children);
$640d411acbc53708$export$542000db99cecf28.displayName = 'WrapperMediaSingle';
const $640d411acbc53708$export$e18e95249d813157 = ({ borderColor: borderColor })=>{
    const borderRadius = "var(--ds-radius-large, 8px)";
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            inset: '0px',
            border: `0.5px solid ${borderColor}`,
            borderRadius: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius
        }
    });
};
module.exports["MediaSingleDimensionHelper"] = $640d411acbc53708$export$2b2737a2ef2f5b46;
module.exports["MediaWrapper"] = $640d411acbc53708$export$542000db99cecf28;
module.exports["MediaBorderGapFiller"] = $640d411acbc53708$export$e18e95249d813157;

});

parcelRegister("5y9Nl", function(module, exports) {

var $h9Lux = parcelRequire("h9Lux");

function $a736c0097336f0f5$export$d48e8f24f681763e(layout, width, containerWidth = 0) {
    switch(layout){
        case 'wide':
            return (0, $h9Lux.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $h9Lux.calcBreakoutWidth)(layout, containerWidth);
        default:
            return `${width}px`;
    }
}
module.exports["calcResizedWidth"] = $a736c0097336f0f5$export$d48e8f24f681763e;

});

parcelRegister("fuDKy", function(module, exports) {
/**
 * Reduces the given CSS width value to the next lowest even pixel value if the value is in px.
 * This is to mitigate subpixel rendering issues of embedded smart links.
 *
 * @param widthValue CSS width value to be rounded
 * @returns Reduced CSS width value where px value given, or otherwise the original value
 * @example
 */ // widthValue could be a string in px, rem or percentage, e.g. "800px", "100%", etc.
function $e6d228c4639d9fdf$export$c832331b07480714(widthValue) {
    try {
        if (widthValue.endsWith('px')) {
            const pxWidth = parseInt(widthValue.slice(0, -2));
            return `${pxWidth - pxWidth % 2}px`;
        }
        return widthValue;
    } catch  {
        return widthValue;
    }
}
module.exports["roundToClosestEvenPxValue"] = $e6d228c4639d9fdf$export$c832331b07480714;

});

parcelRegister("iIYTj", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $cbY7C = parcelRequire("cbY7C");


var $7YvXl = parcelRequire("7YvXl");


var $bI14T = parcelRequire("bI14T");


var $imtNr = parcelRequire("imtNr");


var $4Vdlk = parcelRequire("4Vdlk");


var $1bRPL = parcelRequire("1bRPL");


var $deUyp = parcelRequire("deUyp");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $7jfHQ = parcelRequire("7jfHQ");

var $a1a722d55501d95d$export$89741becde3d0e54 = /*#__PURE__*/ function(SMART_LINK_DRAG_TYPES) {
    SMART_LINK_DRAG_TYPES["EDITOR"] = "smart-link-from-editor";
    SMART_LINK_DRAG_TYPES["RENDERER"] = "smart-link-from-renderer";
    return SMART_LINK_DRAG_TYPES;
}({});
var $a1a722d55501d95d$export$a4a3cf1d43312764 = /*#__PURE__*/ function(SMART_LINK_APPEARANCE) {
    SMART_LINK_APPEARANCE["INLINE"] = "inline";
    SMART_LINK_APPEARANCE["BLOCK"] = "block";
    SMART_LINK_APPEARANCE["EMBED"] = "embed";
    return SMART_LINK_APPEARANCE;
}({});
function $a1a722d55501d95d$export$ac5f6dc1cb5b8db6(type) {
    return type === "smart-link-from-editor" || type === "smart-link-from-renderer";
} /**
   * Checks if a ProseMirror node type is a smart link card.
   */ 
function $a1a722d55501d95d$export$250eee508686c799(nodeType) {
    return nodeType === 'inlineCard' || nodeType === 'blockCard' || nodeType === 'embedCard';
}
const $a1a722d55501d95d$var$idleState = {
    type: 'idle'
};
const $a1a722d55501d95d$var$draggingState = {
    type: 'dragging'
};
const $a1a722d55501d95d$var$styles = {
    preview: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDKxmn _4c065U1Y8M _2Y7lL42ADO _3hxITi6wH8 _3vBAKH9r67 _0KLXrulfZc _1EqgXle7g8 _2OUyjtGk8v",
    previewText: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7",
    draggableBlock: "_0wOv4QAxrc"
};
const $a1a722d55501d95d$var$previewIconStyles = null;
const $a1a722d55501d95d$var$draggableInlineStyles = null;
const $a1a722d55501d95d$var$SmartLinkDragPreview = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SmartLinkDragPreview(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { title: title, url: url, iconUrl: iconUrl } = t0;
    let t1;
    if ($[0] !== iconUrl) {
        t1 = iconUrl && /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            src: iconUrl,
            alt: "",
            className: (0, $hekY6.default)([
                "_39xV025zaO _0jFU0V5zaO _3YEZNOdnbC"
            ])
        });
        $[0] = iconUrl;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = title || url;
    let t3;
    if ($[2] !== t2) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "span",
            xcss: $a1a722d55501d95d$var$styles.previewText,
            children: t2
        });
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t1 || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $a1a722d55501d95d$var$styles.preview,
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                alignBlock: "center",
                space: "space.075",
                children: [
                    t1,
                    t3
                ]
            })
        });
        $[4] = t1;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function SmartLinkDragPreview({ title: title, url: url, iconUrl: iconUrl }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $a1a722d55501d95d$var$styles.preview,
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.075",
            children: [
                iconUrl && /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
                    src: iconUrl,
                    alt: "",
                    className: (0, $hekY6.default)([
                        "_39xV025zaO _0jFU0V5zaO _3YEZNOdnbC"
                    ])
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    as: "span",
                    xcss: $a1a722d55501d95d$var$styles.previewText,
                    children: title || url
                })
            ]
        })
    });
};
function $a1a722d55501d95d$var$getIconUrl(details) {
    if (details?.data && 'icon' in details.data && typeof details?.data?.icon === 'string') return details.data.icon;
    const objectIconUrl = (0, $7jfHQ.getObjectIconUrl)(details);
    if (objectIconUrl) return objectIconUrl;
     // Confluence/Jira content-type specific icons (page, blog, whiteboard, issue, etc.)
    if (details?.entityData && 'iconUrl' in details.entityData && typeof details.entityData.iconUrl === 'string') return details.entityData.iconUrl;
     // Fallback to provider/generator icon (product logo)
    if (typeof details?.meta?.generator?.icon?.url === 'string') return details.meta.generator.icon.url;
    return undefined;
} /**
   * Inner component that handles the actual drag behavior.
   * Must be rendered within a SmartCardProvider context.
   */ 
const $a1a722d55501d95d$var$SmartLinkDraggableInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SmartLinkDraggableInner(t0) {
    const $ = (0, $bDgLe.c)(35);
    const { url: url, title: propTitle, appearance: appearance, source: source, isChangeboardTarget: t1, children: children } = t0;
    const isChangeboardTarget = t1 === undefined ? false : t1;
    const ref = (0, $cozmU.useRef)(null);
    const { store: store } = (0, $bI14T.useSmartLinkContext)();
    const [state, setState] = (0, $cozmU.useState)($a1a722d55501d95d$var$idleState);
    let t2;
    if ($[0] !== appearance || $[1] !== propTitle || $[2] !== source || $[3] !== store || $[4] !== url) {
        t2 = (targetEl)=>({
                element: targetEl,
                getInitialData: ()=>{
                    const cardState = store.getState()[url];
                    const details = cardState?.details;
                    const title = propTitle || (0, $7YvXl.extractSmartLinkTitle)(details);
                    const iconUrl = $a1a722d55501d95d$var$getIconUrl(details);
                    return {
                        type: source,
                        url: url,
                        title: title,
                        iconUrl: iconUrl,
                        appearance: appearance
                    };
                },
                onGenerateDragPreview: (t3)=>{
                    const { nativeSetDragImage: nativeSetDragImage } = t3;
                    const cardState_0 = store.getState()[url];
                    const details_0 = cardState_0?.details;
                    const title_0 = propTitle || (0, $7YvXl.extractSmartLinkTitle)(details_0);
                    const iconUrl_0 = $a1a722d55501d95d$var$getIconUrl(details_0);
                    (0, $deUyp.setCustomNativeDragPreview)({
                        getOffset: (0, $1bRPL.pointerOutsideOfPreview)({
                            x: "16px",
                            y: "8px"
                        }),
                        render (t4) {
                            const { container: container } = t4;
                            setState({
                                type: "preview",
                                container: container,
                                title: title_0,
                                iconUrl: iconUrl_0
                            });
                            return ()=>setState($a1a722d55501d95d$var$draggingState);
                        },
                        nativeSetDragImage: nativeSetDragImage
                    });
                },
                onDragStart: ()=>setState($a1a722d55501d95d$var$draggingState),
                onDrop: ()=>setState($a1a722d55501d95d$var$idleState)
            });
        $[0] = appearance;
        $[1] = propTitle;
        $[2] = source;
        $[3] = store;
        $[4] = url;
        $[5] = t2;
    } else t2 = $[5];
    const getDragConfig = t2;
    let t3;
    if ($[6] !== appearance || $[7] !== getDragConfig) {
        t3 = ()=>{
            const el = ref.current;
            if (!el) return;
            let cleanupDraggable = null;
            let observer = null;
            if (appearance !== "inline") {
                const setupSmartElementLink = ()=>{
                    el.querySelectorAll("[data-smart-element-link]").forEach($a1a722d55501d95d$var$_temp);
                };
                setupSmartElementLink();
                observer = new MutationObserver(setupSmartElementLink);
                observer.observe(el, {
                    childList: true,
                    subtree: true
                });
            }
            const unbindPointerDown = (0, $cbY7C.bind)(el, {
                type: "pointerdown",
                listener: (event)=>{
                    const selectionAtPointerDown = window.getSelection();
                    if (appearance === "inline" && selectionAtPointerDown?.type === "Range" && selectionAtPointerDown.toString().length > 0) selectionAtPointerDown.removeAllRanges();
                    cleanupDraggable?.();
                    const target = event.target;
                    let dragTarget = el;
                    if (appearance === "inline") {
                        const targetElement = target instanceof Element ? target : null;
                        const hostInlineCardRoot = el.closest("[data-prosemirror-node-name=\"inlineCard\"][draggable=\"true\"]");
                        const inlineCardRoot = targetElement?.closest("[data-prosemirror-node-name=\"inlineCard\"][draggable=\"true\"]") ?? null;
                        const closestInlineAnchor = targetElement?.closest("a[href], [data-smart-element-link]") ?? null;
                        if (closestInlineAnchor instanceof HTMLElement && (el.contains(closestInlineAnchor) || hostInlineCardRoot instanceof HTMLElement && hostInlineCardRoot.contains(closestInlineAnchor))) dragTarget = closestInlineAnchor;
                        else if (inlineCardRoot instanceof HTMLElement && hostInlineCardRoot instanceof HTMLElement && inlineCardRoot === hostInlineCardRoot) dragTarget = inlineCardRoot;
                    } else dragTarget = target instanceof HTMLElement && el.contains(target) ? target : el;
                    cleanupDraggable = (0, $4Vdlk.draggable)(getDragConfig(dragTarget));
                }
            });
            return ()=>{
                cleanupDraggable?.();
                unbindPointerDown();
                observer?.disconnect();
            };
        };
        $[6] = appearance;
        $[7] = getDragConfig;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== appearance || $[10] !== getDragConfig || $[11] !== propTitle || $[12] !== source || $[13] !== store || $[14] !== url) {
        t4 = [
            url,
            propTitle,
            appearance,
            source,
            store,
            getDragConfig
        ];
        $[9] = appearance;
        $[10] = getDragConfig;
        $[11] = propTitle;
        $[12] = source;
        $[13] = store;
        $[14] = url;
        $[15] = t4;
    } else t4 = $[15];
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[16] !== state.container || $[17] !== state.iconUrl || $[18] !== state.title || $[19] !== state.type || $[20] !== url) {
        t5 = state.type === "preview" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ (0, $8aG6j.jsx)($a1a722d55501d95d$var$SmartLinkDragPreview, {
            title: state.title,
            url: url,
            iconUrl: state.iconUrl
        }), state.container) : null;
        $[16] = state.container;
        $[17] = state.iconUrl;
        $[18] = state.title;
        $[19] = state.type;
        $[20] = url;
        $[21] = t5;
    } else t5 = $[21];
    const preview = t5;
    if (appearance === "inline") {
        const t6 = isChangeboardTarget ? "smart-link-draggable-changeboard" : undefined;
        let t7;
        if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = (0, $hekY6.default)([
                "_0wOv4QAxrc _3iDTPbS8kF"
            ]);
            $[22] = t7;
        } else t7 = $[22];
        let t8;
        if ($[23] !== children || $[24] !== t6 || $[25] !== t7) {
            t8 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                ref: ref,
                "data-testid": "smart-link-draggable-inline",
                "data-spotlight-target": t6,
                className: t7,
                children: children
            });
            $[23] = children;
            $[24] = t6;
            $[25] = t7;
            $[26] = t8;
        } else t8 = $[26];
        let t9;
        if ($[27] !== preview || $[28] !== t8) {
            t9 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                children: [
                    t8,
                    preview
                ]
            });
            $[27] = preview;
            $[28] = t8;
            $[29] = t9;
        } else t9 = $[29];
        return t9;
    }
    let t6;
    if ($[30] !== children) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            ref: ref,
            xcss: $a1a722d55501d95d$var$styles.draggableBlock,
            testId: "smart-link-draggable-block",
            children: children
        });
        $[30] = children;
        $[31] = t6;
    } else t6 = $[31];
    let t7;
    if ($[32] !== preview || $[33] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            children: [
                t6,
                preview
            ]
        });
        $[32] = preview;
        $[33] = t6;
        $[34] = t7;
    } else t7 = $[34];
    return t7;
} : function SmartLinkDraggableInner({ url: url, title: propTitle, appearance: appearance, source: source, isChangeboardTarget: isChangeboardTarget = false, children: children }) {
    const ref = (0, $cozmU.useRef)(null);
    const { store: store } = (0, $bI14T.useSmartLinkContext)();
    const [state, setState] = (0, $cozmU.useState)($a1a722d55501d95d$var$idleState); // Store the draggable config so we can re-register on different elements
    // when the browser picks a child as the drag target.
    const getDragConfig = (0, $cozmU.useCallback)((targetEl)=>({
            element: targetEl,
            getInitialData: ()=>{
                const cardState = store.getState()[url];
                const details = cardState?.details;
                const title = propTitle || (0, $7YvXl.extractSmartLinkTitle)(details);
                const iconUrl = $a1a722d55501d95d$var$getIconUrl(details);
                return {
                    type: source,
                    url: url,
                    title: title,
                    iconUrl: iconUrl,
                    appearance: appearance
                };
            },
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                const cardState_0 = store.getState()[url];
                const details_0 = cardState_0?.details;
                const title_0 = propTitle || (0, $7YvXl.extractSmartLinkTitle)(details_0);
                const iconUrl_0 = $a1a722d55501d95d$var$getIconUrl(details_0);
                (0, $deUyp.setCustomNativeDragPreview)({
                    getOffset: (0, $1bRPL.pointerOutsideOfPreview)({
                        x: '16px',
                        y: '8px'
                    }),
                    render ({ container: container }) {
                        setState({
                            type: 'preview',
                            container: container,
                            title: title_0,
                            iconUrl: iconUrl_0
                        });
                        return ()=>setState($a1a722d55501d95d$var$draggingState);
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            onDragStart: ()=>setState($a1a722d55501d95d$var$draggingState),
            onDrop: ()=>setState($a1a722d55501d95d$var$idleState)
        }), [
        url,
        propTitle,
        appearance,
        source,
        store
    ]);
    // On pointerdown, determine the drag element and register it with Pragmatic DnD.
    // Uses pointerdown because the drag source may not exist at mount time as smart cards resolve.
    // For inline cards inside ProseMirror, prefer the inner anchor because the browser fires
    // dragstart from that element rather than from the inline card wrapper.
    (0, $cozmU.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const inlineCardRootSelector = '[data-prosemirror-node-name="inlineCard"][draggable="true"]'; // In contentEditable editors (ProseMirror), the browser may pick a child
        // element (e.g., an <a> tag) as the drag target instead of our element.
        // On pointerdown, we find the likely drag target and register draggable()
        // on it so pragmatic-drag-and-drop recognizes the drag.
        let cleanupDraggable = null; // In contentEditable="true" contexts (block/embed cards), the browser treats
        // the smart-element-link as editable text rather than a draggable element.
        // Not needed for inline cards since the wrapper is already not editable
        let observer = null;
        if (appearance !== "inline") {
            const setupSmartElementLink = ()=>{
                el.querySelectorAll('[data-smart-element-link]').forEach((link)=>{
                    link.contentEditable = 'false';
                    link.setAttribute('draggable', 'true');
                });
            };
            setupSmartElementLink();
            observer = new MutationObserver(setupSmartElementLink);
            observer.observe(el, {
                childList: true,
                subtree: true
            });
        }
        const unbindPointerDown = (0, $cbY7C.bind)(el, {
            type: 'pointerdown',
            listener: (event)=>{
                const selectionAtPointerDown = window.getSelection();
                if (appearance === "inline" && selectionAtPointerDown?.type === 'Range' && selectionAtPointerDown.toString().length > 0) selectionAtPointerDown.removeAllRanges();
                cleanupDraggable?.();
                const target = event.target; // Find the nearest draggable ancestor within the card to match
                // the element the browser will use as the dragstart target.
                let dragTarget = el;
                if (appearance === "inline") {
                    const targetElement = target instanceof Element ? target : null;
                    const hostInlineCardRoot = el.closest(inlineCardRootSelector);
                    const inlineCardRoot = targetElement?.closest(inlineCardRootSelector) ?? null;
                    const closestInlineAnchor = targetElement?.closest('a[href], [data-smart-element-link]') ?? null;
                    if (closestInlineAnchor instanceof HTMLElement && (el.contains(closestInlineAnchor) || hostInlineCardRoot instanceof HTMLElement && hostInlineCardRoot.contains(closestInlineAnchor))) dragTarget = closestInlineAnchor;
                    else if (inlineCardRoot instanceof HTMLElement && hostInlineCardRoot instanceof HTMLElement && inlineCardRoot === hostInlineCardRoot) dragTarget = inlineCardRoot;
                } else dragTarget = target instanceof HTMLElement && el.contains(target) ? target : el;
                cleanupDraggable = (0, $4Vdlk.draggable)(getDragConfig(dragTarget));
            }
        });
        return ()=>{
            cleanupDraggable?.();
            unbindPointerDown();
            observer?.disconnect();
        };
    }, [
        url,
        propTitle,
        appearance,
        source,
        store,
        getDragConfig
    ]);
    const preview = state.type === 'preview' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ (0, $8aG6j.jsx)($a1a722d55501d95d$var$SmartLinkDragPreview, {
        title: state.title,
        url: url,
        iconUrl: state.iconUrl
    }), state.container) : null; // Use span with inline display for inline cards to preserve text flow.
    if (appearance === "inline") return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                ref: ref,
                "data-testid": "smart-link-draggable-inline",
                "data-spotlight-target": isChangeboardTarget ? 'smart-link-draggable-changeboard' : undefined,
                className: (0, $hekY6.default)([
                    "_0wOv4QAxrc _3iDTPbS8kF"
                ]),
                children: children
            }),
            preview
        ]
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                ref: ref,
                xcss: $a1a722d55501d95d$var$styles.draggableBlock,
                testId: "smart-link-draggable-block",
                children: children
            }),
            preview
        ]
    });
};
/**
 * Wraps a smart link card to make it draggable into the content tree.
 * Extracts the resolved title and icon from the smart link data store at drag start time.
 * Falls back to rendering children directly when the feature flag is off or url is missing.
 */ function $a1a722d55501d95d$var$_temp(link) {
    link.contentEditable = "false";
    link.setAttribute("draggable", "true");
}
const $a1a722d55501d95d$export$c67c8f76ce4436c = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SmartLinkDraggable(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { url: url, title: title, appearance: appearance, source: source, isChangeboardTarget: isChangeboardTarget, children: children } = t0;
    if (!url || !(0, $imtNr.isSafeUrl)(url)) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                children: children
            });
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== appearance || $[3] !== children || $[4] !== isChangeboardTarget || $[5] !== source || $[6] !== title || $[7] !== url) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)($a1a722d55501d95d$var$SmartLinkDraggableInner, {
            url: url,
            title: title,
            appearance: appearance,
            source: source,
            isChangeboardTarget: isChangeboardTarget,
            children: children
        });
        $[2] = appearance;
        $[3] = children;
        $[4] = isChangeboardTarget;
        $[5] = source;
        $[6] = title;
        $[7] = url;
        $[8] = t1;
    } else t1 = $[8];
    return t1;
} : function SmartLinkDraggable({ url: url, title: title, appearance: appearance, source: source, isChangeboardTarget: isChangeboardTarget, children: children }) {
    if (!url || !(0, $imtNr.isSafeUrl)(url)) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)($a1a722d55501d95d$var$SmartLinkDraggableInner, {
        url: url,
        title: title,
        appearance: appearance,
        source: source,
        isChangeboardTarget: isChangeboardTarget,
        children: children
    });
};
module.exports["SMART_LINK_DRAG_TYPES"] = $a1a722d55501d95d$export$89741becde3d0e54;
module.exports["SMART_LINK_APPEARANCE"] = $a1a722d55501d95d$export$a4a3cf1d43312764;
module.exports["isSmartLinkDrag"] = $a1a722d55501d95d$export$ac5f6dc1cb5b8db6;
module.exports["SmartLinkDraggable"] = $a1a722d55501d95d$export$c67c8f76ce4436c;

});

parcelRegister("1bRPL", function(module, exports) {

var $dJ9DS = parcelRequire("dJ9DS");


var $fYxCA = parcelRequire("fYxCA");


var $beJwy = parcelRequire("beJwy");

function $c244e860353a6e68$export$427e20518819fabc(point) {
    return function getOffset({ container: container }) {
        /**
		 * **Approach: transparent borders.**
		 *
		 * The only reliable cross browser technique found to push a
		 * drag preview away from the cursor is to use transparent borders on the container.
		 *
		 * **🙅📱 Not pushing the preview away on touch devices**
		 *
		 * _On iOS_
		 *
		 * Safari will set the transparent border color to be black
		 *
		 * `iOS@18.4.1` on May 7th 2025:
		 * - If you set the background color on the `container` the border color will be that
		 * - Setting a transparent background color on the `container` still results in a
		 *   black border
		 * - The `<body>` text or background color does not change the black border color
		 *
		 * While dragging, the drag preview will shift under the center of the users pointer.
		 * So if you start at {x: 0, y: 0} (top left), almost immediately the preview will move
		 * to be under the middle of the users pointer.
		 *
		 * _On Android_
		 *
		 * Chrome will put the center of the drag preview under the users pointer immediately.
		 *
		 * Tested on `Chrome@137` on `Android 14` on June 20th 2025
		 *
		 * _What we do_
		 *
		 * We don't add the transparent border
		 *
		 * - Avoid the black color on iOS
		 * - It isn't needed on Android anyway as the preview will be under the center
		 *   of the users pointer
		 *
		 * We put the center of the drag preview under the users pointer
		 *
		 * - Avoids the drag preview quickly moving from a top corner to be centered under
		 *   the users pointer on iOS
		 * - It will be under the center on Android no matter what we do
		 *
		 * We previously had a isTouchDevice() check, but it felt safer for now
		 * to have a more targeted check, as these are the devices that have been
		 * tested on.
		 */ if ((0, $fYxCA.isSafariOnIOS)() || (0, $dJ9DS.isAndroid)()) return (0, $beJwy.centerUnderPointer)({
            container: container
        });
        Object.assign(container.style, {
            borderInlineStart: `${point.x} solid transparent`,
            borderTop: `${point.y} solid transparent`
        });
        // Unfortunate that we need to use `getComputedStyle`,
        // but it's only a single call when the drag is starting.
        const computed = window.getComputedStyle(container);
        if (computed.direction === 'rtl') {
            // The DOMRect will include the new border we added
            const box = container.getBoundingClientRect();
            // Use the top right corner (including the new border) as the offset.
            // The border will push the preview away from the pointer.
            return {
                x: box.width,
                y: 0
            };
        }
        // Use the top left corner as the offset. The border will
        // push the preview away from the pointer.
        return {
            x: 0,
            y: 0
        };
    };
}
module.exports["pointerOutsideOfPreview"] = $c244e860353a6e68$export$427e20518819fabc;

});

parcelRegister("fYxCA", function(module, exports) {

var $gEZCs = parcelRequire("gEZCs");


var $kc8B9 = parcelRequire("kc8B9");

const $e0d278f731546dca$export$52fc40c68fea4952 = (0, $gEZCs.once)(function isSafariOnIOS() {
    return (0, $kc8B9.isSafari)() && 'ontouchend' in document;
});
module.exports["isSafariOnIOS"] = $e0d278f731546dca$export$52fc40c68fea4952;

});

parcelRegister("beJwy", function(module, exports) {
const $d5bf326c593d3c52$export$81d8e72a15eef435 = function centerUnderPointer({ container: container }) {
    const rect = container.getBoundingClientRect();
    return {
        x: rect.width / 2,
        y: rect.height / 2
    };
};
module.exports["centerUnderPointer"] = $d5bf326c593d3c52$export$81d8e72a15eef435;

});

parcelRegister("deUyp", function(module, exports) {

var $4Vdlk = parcelRequire("4Vdlk");


var $kc8B9 = parcelRequire("kc8B9");


var $f0WuI = parcelRequire("f0WuI");


var $7nhOg = parcelRequire("7nhOg");


var $fbx9a = parcelRequire("fbx9a");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $0a7192879c73e22c$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $0a7192879c73e22c$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $0a7192879c73e22c$var$defaultOffset }) {
    const container = document.createElement('div');
    // Using popover="manual" to place the element in the browser's top layer.
    // This ensures the drag preview container is visually on top of everything else,
    // including elements using z-index and other stacking contexts.
    // "manual" means no light dismiss — we manage the lifecycle ourselves.
    // This element is only created for a single frame for the browser to take a
    // photo of it, and then it is destroyed.
    // Falls back to position:fixed + maxZIndex when the popover API is not available.
    // Note: the popover attribute must be set before the element is in the DOM.
    // `.showPopover()` is called further below after the element is appended to the body.
    if ((0, $fbx9a.supportsPopover)()) container.setAttribute('popover', 'manual');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        ...(0, $fbx9a.supportsPopover)() ? // needs to be overridden by our top / left values
        (0, $7nhOg.popoverResetUserAgentStyles) : {
            // Fallback: using maximum possible z-index so that this element
            // will always be on top of other positioned content.
            zIndex: (0, $f0WuI.maxZIndex)
        },
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    // `.showPopover()` must be called after the element is in the DOM.
    if ((0, $fbx9a.supportsPopover)()) container.showPopover();
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ /**
		 * Update: this bug fix is no longer needed in `Safari@26.4` (and maybe earlier)
		 * We can remove it in a future release
		 */ if ((0, $kc8B9.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        // No need to call `.hidePopover()`.
        // Removing the element from the DOM dismisses the popover
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $4Vdlk.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}
module.exports["setCustomNativeDragPreview"] = $0a7192879c73e22c$export$52d889c66db0f96e;

});

parcelRegister("7jfHQ", function(module, exports) {
const $dc3179d69ab4f7dc$export$bcf275804417edda = (details)=>{
    if (details?.data && 'icon' in details.data && details.data.icon) {
        if (typeof details.data.icon === 'object' && 'url' in details.data.icon && details.data.icon.url && typeof details.data.icon.url === 'string') return details.data.icon.url;
    }
    return undefined;
};
module.exports["getObjectIconUrl"] = $dc3179d69ab4f7dc$export$bcf275804417edda;

});

parcelRegister("jZuR8", function(module, exports) {

var $fLtAn = parcelRequire("fLtAn");

const $bbb41cf47ef9db08$export$143af22820ae9de = (baseUriWithNoTrailingSlash = '')=>(0, $fLtAn.currentSiteCloudIdService).get(baseUriWithNoTrailingSlash);
module.exports["getCurrentSiteCloudId"] = $bbb41cf47ef9db08$export$143af22820ae9de;

});

parcelRegister("fLtAn", function(module, exports) {

var $aPG8c = parcelRequire("aPG8c");


var $dWxvX = parcelRequire("dWxvX");

const $aff19b92c38e9221$export$b4b75b5ce5d33ae5 = (0, $dWxvX.getCurrentSiteCloudIdLocalStorageKey)();
const $aff19b92c38e9221$export$1956112846aa829e = new (0, $aPG8c.CurrentSiteCloudIdService)();
module.exports["currentSiteCloudIdService"] = $aff19b92c38e9221$export$1956112846aa829e;

});

parcelRegister("aPG8c", function(module, exports) {

var $f9XbP = parcelRequire("f9XbP");


var $j39Hd = parcelRequire("j39Hd");


var $70pj3 = parcelRequire("70pj3");


var $8RXRs = parcelRequire("8RXRs");


var $jcfU0 = parcelRequire("jcfU0");

const $e53a9d084474949f$var$smartCardStorage = new (0, $f9XbP.StorageClient)((0, $8RXRs.currentSiteCloudIdConstants).SMART_CARD_STORAGE_SCOPE);
class $e53a9d084474949f$export$a15da722a3b05509 {
    readStoredCloudId(baseUriWithNoTrailingSlash = '') {
        try {
            const cloudId = $e53a9d084474949f$var$smartCardStorage.getItem((0, $70pj3.cloudIdStorageItemKey)(baseUriWithNoTrailingSlash));
            if (typeof cloudId !== 'string' || !cloudId || cloudId === 'undefined') return undefined;
            return cloudId;
        } catch  {
            return undefined;
        }
    }
    writeStoredCloudId(baseUriWithNoTrailingSlash, cloudId) {
        if (!cloudId) return;
        try {
            $e53a9d084474949f$var$smartCardStorage.setItemWithExpiry((0, $70pj3.cloudIdStorageItemKey)(baseUriWithNoTrailingSlash), cloudId, (0, $8RXRs.currentSiteCloudIdConstants).CURRENT_SITE_CLOUD_ID_TTL_MS);
        } catch  {
        // Quota, private-mode, SSR, etc. — same intent as personalization-service.
        }
    }
    ensureTenantInfoInflightStarted(baseUriWithNoTrailingSlash) {
        const baseUri = (0, $jcfU0.normalizeBaseUri)(baseUriWithNoTrailingSlash);
        const existing = this.tenantInfoInflightPromises.get(baseUri);
        if (existing) return existing;
        const promise = (async ()=>{
            try {
                const response = await (0, $j39Hd.request)('get', `${baseUri}/_edge/tenant_info`);
                const cloudId = response?.cloudId;
                if (cloudId) this.writeStoredCloudId(baseUri, cloudId);
                return cloudId ? cloudId : this.readStoredCloudId(baseUri);
            } catch  {
                return this.readStoredCloudId(baseUri);
            } finally{
                this.tenantInfoInflightPromises.delete(baseUri);
            }
        })();
        this.tenantInfoInflightPromises.set(baseUri, promise);
        return promise;
    }
    /** Pure synchronous read scoped to the given base URI. */ getStoredCloudId(baseUriWithNoTrailingSlash = '') {
        return this.readStoredCloudId(baseUriWithNoTrailingSlash);
    }
    /** Writes tenant cloud id for tests or callers that intentionally warm storage before edge resolves. */ persistStoredCloudId(cloudId, baseUriWithNoTrailingSlash = '') {
        this.writeStoredCloudId(baseUriWithNoTrailingSlash, cloudId);
    }
    async get(baseUriWithNoTrailingSlash = '') {
        const fromStorage = this.readStoredCloudId(baseUriWithNoTrailingSlash);
        if (fromStorage) return fromStorage;
        return this.ensureTenantInfoInflightStarted(baseUriWithNoTrailingSlash);
    }
    /** Clears session pin and persisted storage so the next {@link get} is a fresh tenant_info fetch. */ clearCache() {
        this.tenantInfoInflightPromises.clear();
    }
    constructor(){
        this.tenantInfoInflightPromises = new Map();
    }
}
module.exports["CurrentSiteCloudIdService"] = $e53a9d084474949f$export$a15da722a3b05509;

});

parcelRegister("70pj3", function(module, exports) {

var $8RXRs = parcelRequire("8RXRs");


var $jcfU0 = parcelRequire("jcfU0");

function $9ab1e04492b578dd$export$87f317e381996380(baseUriWithNoTrailingSlash = '') {
    return `${(0, $8RXRs.currentSiteCloudIdConstants).CURRENT_SITE_CLOUD_ID_STORAGE_ITEM_KEY_PREFIX}${encodeURIComponent((0, $jcfU0.normalizeBaseUri)(baseUriWithNoTrailingSlash))}`;
}
module.exports["cloudIdStorageItemKey"] = $9ab1e04492b578dd$export$87f317e381996380;

});

parcelRegister("8RXRs", function(module, exports) {
const $144f2fcd8359dd2a$export$a05eb2f7d4daba17 = {
    SMART_CARD_STORAGE_SCOPE: 'smart-card-social-proof',
    CURRENT_SITE_CLOUD_ID_STORAGE_ITEM_KEY_PREFIX: 'site-cloud-id:v1:',
    CURRENT_SITE_CLOUD_ID_TTL_MS: 86400000
};
module.exports["currentSiteCloudIdConstants"] = $144f2fcd8359dd2a$export$a05eb2f7d4daba17;

});

parcelRegister("jcfU0", function(module, exports) {
function $b9978992253e250c$export$d01aa4af38c023bb(baseUriWithNoTrailingSlash = '') {
    return baseUriWithNoTrailingSlash.replace(/\/$/, '');
}
module.exports["normalizeBaseUri"] = $b9978992253e250c$export$d01aa4af38c023bb;

});

parcelRegister("dWxvX", function(module, exports) {

var $70pj3 = parcelRequire("70pj3");


var $8RXRs = parcelRequire("8RXRs");

const $67e1c748f74c28e2$export$dea1a8bc5840f118 = (baseUriWithNoTrailingSlash = '')=>`${(0, $8RXRs.currentSiteCloudIdConstants).SMART_CARD_STORAGE_SCOPE}_${(0, $70pj3.cloudIdStorageItemKey)(baseUriWithNoTrailingSlash)}`;
module.exports["getCurrentSiteCloudIdLocalStorageKey"] = $67e1c748f74c28e2$export$dea1a8bc5840f118;

});

parcelRegister("ipz0N", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $kkFbH = parcelRequire("kkFbH");


var $ebRBT = parcelRequire("ebRBT");

const $c358709489b4576e$var$FileIconWithColor = (0, $ebRBT.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), 'grayBold');
$c358709489b4576e$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $c358709489b4576e$export$2e2bcd8739ae039 = $c358709489b4576e$var$FileIconWithColor;
module.exports["default"] = $c358709489b4576e$export$2e2bcd8739ae039;

});

parcelRegister("f49me", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gJ798 = parcelRequire("gJ798");


var $ebRBT = parcelRequire("ebRBT");

const $3736b97729106be6$var$ChartBarIconWithColor = (0, $ebRBT.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($gJ798))), 'purpleBold');
$3736b97729106be6$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $3736b97729106be6$export$2e2bcd8739ae039 = $3736b97729106be6$var$ChartBarIconWithColor;
module.exports["default"] = $3736b97729106be6$export$2e2bcd8739ae039;

});

parcelRegister("jBJvN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $3fO5l = parcelRequire("3fO5l");


var $ebRBT = parcelRequire("ebRBT");

const $a7d4397f4d39d7f1$var$ListBulletedIconWithColor = (0, $ebRBT.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), 'greenBold');
$a7d4397f4d39d7f1$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $a7d4397f4d39d7f1$export$2e2bcd8739ae039 = $a7d4397f4d39d7f1$var$ListBulletedIconWithColor;
module.exports["default"] = $a7d4397f4d39d7f1$export$2e2bcd8739ae039;

});

parcelRegister("f7FiQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $gIfnJ = parcelRequire("gIfnJ");


var $gEyoZ = parcelRequire("gEyoZ");

const $b8829d8a161753f9$var$BranchObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BranchObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Branch" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BranchObjectTile({ label: label = 'Branch', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $b8829d8a161753f9$export$2e2bcd8739ae039 = $b8829d8a161753f9$var$BranchObjectTile;
module.exports["default"] = $b8829d8a161753f9$export$2e2bcd8739ae039;

});

parcelRegister("6gVpf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lepke = parcelRequire("lepke");


var $gEyoZ = parcelRequire("gEyoZ");

const $90d14fc97efa5c87$var$CommitObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CommitObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Commit" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)";
    const t3 = isBold ? "color.background.accent.yellow.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function CommitObjectTile({ label: label = 'Commit', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)",
        backgroundColor: isBold ? 'color.background.accent.yellow.subtle' : undefined
    });
};
var $90d14fc97efa5c87$export$2e2bcd8739ae039 = $90d14fc97efa5c87$var$CommitObjectTile;
module.exports["default"] = $90d14fc97efa5c87$export$2e2bcd8739ae039;

});

parcelRegister("lvsY2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hQhpy = parcelRequire("hQhpy");


var $gEyoZ = parcelRequire("gEyoZ");

const $c843d2b7ba70d597$var$PullRequestObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PullRequestObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Pull Request" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)";
    const t3 = isBold ? "color.background.accent.green.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function PullRequestObjectTile({ label: label = 'Pull Request', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)",
        backgroundColor: isBold ? 'color.background.accent.green.subtle' : undefined
    });
};
var $c843d2b7ba70d597$export$2e2bcd8739ae039 = $c843d2b7ba70d597$var$PullRequestObjectTile;
module.exports["default"] = $c843d2b7ba70d597$export$2e2bcd8739ae039;

});

parcelRegister("2z1Cx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6YkHb = parcelRequire("6YkHb");


var $gEyoZ = parcelRequire("gEyoZ");

const $3fba6eb33cac86c2$var$CodeObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CodeObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Code" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)";
    const t3 = isBold ? "color.background.accent.purple.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function CodeObjectTile({ label: label = 'Code', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
};
var $3fba6eb33cac86c2$export$2e2bcd8739ae039 = $3fba6eb33cac86c2$var$CodeObjectTile;
module.exports["default"] = $3fba6eb33cac86c2$export$2e2bcd8739ae039;

});

parcelRegister("ix7Nw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6spAz = parcelRequire("6spAz");


var $gEyoZ = parcelRequire("gEyoZ");

const $e3c6782640cca582$var$BugObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BugObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Bug" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BugObjectTile({ label: label = 'Bug', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $e3c6782640cca582$export$2e2bcd8739ae039 = $e3c6782640cca582$var$BugObjectTile;
module.exports["default"] = $e3c6782640cca582$export$2e2bcd8739ae039;

});

parcelRegister("lfmf4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lCTy3 = parcelRequire("lCTy3");


var $gEyoZ = parcelRequire("gEyoZ");

const $d8f6dc54ca6872bb$var$ChangesObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ChangesObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Changes" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)";
    const t3 = isBold ? "color.background.accent.yellow.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function ChangesObjectTile({ label: label = 'Changes', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)",
        backgroundColor: isBold ? 'color.background.accent.yellow.subtle' : undefined
    });
};
var $d8f6dc54ca6872bb$export$2e2bcd8739ae039 = $d8f6dc54ca6872bb$var$ChangesObjectTile;
module.exports["default"] = $d8f6dc54ca6872bb$export$2e2bcd8739ae039;

});

parcelRegister("bht3M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $7vAVv = parcelRequire("7vAVv");


var $gEyoZ = parcelRequire("gEyoZ");

const $ff1c12598ed3ba74$var$EpicObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function EpicObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Epic" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)";
    const t3 = isBold ? "color.background.accent.purple.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function EpicObjectTile({ label: label = 'Epic', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
};
var $ff1c12598ed3ba74$export$2e2bcd8739ae039 = $ff1c12598ed3ba74$var$EpicObjectTile;
module.exports["default"] = $ff1c12598ed3ba74$export$2e2bcd8739ae039;

});

parcelRegister("tBrWH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $ipvL3 = parcelRequire("ipvL3");


var $gEyoZ = parcelRequire("gEyoZ");

const $d409ccda82578191$var$IncidentObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IncidentObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Incident" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function IncidentObjectTile({ label: label = 'Incident', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $d409ccda82578191$export$2e2bcd8739ae039 = $d409ccda82578191$var$IncidentObjectTile;
module.exports["default"] = $d409ccda82578191$export$2e2bcd8739ae039;

});

parcelRegister("e9ExL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $7EFpK = parcelRequire("7EFpK");


var $gEyoZ = parcelRequire("gEyoZ");

const $70d7bc77e47e0fe4$var$ProblemObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProblemObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Problem" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function ProblemObjectTile({ label: label = 'Problem', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $70d7bc77e47e0fe4$export$2e2bcd8739ae039 = $70d7bc77e47e0fe4$var$ProblemObjectTile;
module.exports["default"] = $70d7bc77e47e0fe4$export$2e2bcd8739ae039;

});

parcelRegister("2hwbE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iRFKG = parcelRequire("iRFKG");


var $gEyoZ = parcelRequire("gEyoZ");

const $0c8c4b462cd0e972$var$WorkItemObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WorkItemObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Work Item" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function WorkItemObjectTile({ label: label = 'Work Item', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $0c8c4b462cd0e972$export$2e2bcd8739ae039 = $0c8c4b462cd0e972$var$WorkItemObjectTile;
module.exports["default"] = $0c8c4b462cd0e972$export$2e2bcd8739ae039;

});

parcelRegister("bnm2b", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $jrU5N = parcelRequire("jrU5N");


var $gEyoZ = parcelRequire("gEyoZ");

const $54244c8cd22493dc$var$StoryObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function StoryObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Story" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)";
    const t3 = isBold ? "color.background.accent.green.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function StoryObjectTile({ label: label = 'Story', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)",
        backgroundColor: isBold ? 'color.background.accent.green.subtle' : undefined
    });
};
var $54244c8cd22493dc$export$2e2bcd8739ae039 = $54244c8cd22493dc$var$StoryObjectTile;
module.exports["default"] = $54244c8cd22493dc$export$2e2bcd8739ae039;

});

parcelRegister("h3uhG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lSw2p = parcelRequire("lSw2p");


var $gEyoZ = parcelRequire("gEyoZ");

const $35e12172f066a32d$var$SubtaskObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SubtaskObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Subtask" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function SubtaskObjectTile({ label: label = 'Subtask', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $35e12172f066a32d$export$2e2bcd8739ae039 = $35e12172f066a32d$var$SubtaskObjectTile;
module.exports["default"] = $35e12172f066a32d$export$2e2bcd8739ae039;

});

parcelRegister("glDuG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iAaYd = parcelRequire("iAaYd");


var $gEyoZ = parcelRequire("gEyoZ");

const $41a316049a2a2c13$var$TaskObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TaskObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Task" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function TaskObjectTile({ label: label = 'Task', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $41a316049a2a2c13$export$2e2bcd8739ae039 = $41a316049a2a2c13$var$TaskObjectTile;
module.exports["default"] = $41a316049a2a2c13$export$2e2bcd8739ae039;

});

parcelRegister("rECdA", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $8m50u = parcelRequire("8m50u");

const $71deccf66348f07d$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $8m50u.componentWithCondition)(()=>(0, $iDrrr.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $71deccf66348f07d$export$cf56d0f54cfcce4;

});

parcelRegister("3jjX7", function(module, exports) {
// WARNING: This value is shared between @atlaskit/analytics-cross-product and
// @atlassiansox/analytics-cross-product-interaction-client. Take care when updating.
const $6e6234f2764332e7$export$7bc189309d2ad463 = 'analyticsInteractionSesssionTrackingClient';
class $6e6234f2764332e7$export$2e2bcd8739ae039 {
    static getInstance() {
        let interactionSessionTracking;
        try {
            // Check if InteractionSessionTracking in global window object
            if ($6e6234f2764332e7$export$7bc189309d2ad463 in window) interactionSessionTracking = window[$6e6234f2764332e7$export$7bc189309d2ad463];
        } catch (err) {
        // Silently swallow exception
        }
        return interactionSessionTracking;
    }
}
module.exports["default"] = $6e6234f2764332e7$export$2e2bcd8739ae039;

});

parcelRegister("c3xon", function(module, exports) {

var $2zVsi = parcelRequire("2zVsi");

function $98c7b2cae218afe1$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return (0, $2zVsi.functionWithCondition)(condition, functionTrue, functionFalse);
}
module.exports["functionUnionWithCondition"] = $98c7b2cae218afe1$export$c41c28c1d883fcd5;

});

parcelRegister("2zVsi", function(module, exports) {
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ function $70b08b83582e8047$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}
module.exports["functionWithCondition"] = $70b08b83582e8047$export$af3c0e82a18fc057;

});

parcelRegister("7LPcf", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $367262c04ca8598b$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $9EREa.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $9EREa.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
module.exports["extractPersonOwnedBy"] = $367262c04ca8598b$export$19ee667f3f7a6ec3;

});

parcelRegister("9EREa", function(module, exports) {

var $2GG3F = parcelRequire("2GG3F");

const $9cbb96c910c4c39f$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && (0, $2GG3F.extractUrlFromIconJsonLd)(person.icon)
        };
    }
    return undefined;
};
module.exports["extractPersonFromJsonLd"] = $9cbb96c910c4c39f$export$c471ae5fddcf1392;

});

parcelRegister("303LV", function(module, exports) {
$parcel$export(module.exports, "default", () => $22f44c32aa84ec90$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $22f44c32aa84ec90$var$t() {
    return $22f44c32aa84ec90$var$t = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }, $22f44c32aa84ec90$var$t.apply(this, arguments);
}
const $22f44c32aa84ec90$var$n = [
    "children",
    "options"
], $22f44c32aa84ec90$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
};
var $22f44c32aa84ec90$var$i;
!function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($22f44c32aa84ec90$var$i || ($22f44c32aa84ec90$var$i = {}));
const $22f44c32aa84ec90$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "className",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, t)=>(e[t.toLowerCase()] = t, e), {
    for: "htmlFor"
}), $22f44c32aa84ec90$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $22f44c32aa84ec90$var$o = [
    "style",
    "script"
], $22f44c32aa84ec90$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $22f44c32aa84ec90$var$s = /mailto:/i, $22f44c32aa84ec90$var$d = /\n{2,}$/, $22f44c32aa84ec90$var$u = /^(\s*>[\s\S]*?)(?=\n{2,})/, $22f44c32aa84ec90$var$p = /^ *> ?/gm, $22f44c32aa84ec90$var$f = /^ {2,}\n/, $22f44c32aa84ec90$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $22f44c32aa84ec90$var$m = /^\s*(`{3,}|~{3,}) *(\S+)?([^\n]*?)?\n([\s\S]+?)\s*\1 *(?:\n *)*\n?/, $22f44c32aa84ec90$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $22f44c32aa84ec90$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $22f44c32aa84ec90$var$k = /^(?:\n *)*\n/, $22f44c32aa84ec90$var$x = /\r\n?/g, $22f44c32aa84ec90$var$b = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $22f44c32aa84ec90$var$v = /^\[\^([^\]]+)]/, $22f44c32aa84ec90$var$S = /\f/g, $22f44c32aa84ec90$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $22f44c32aa84ec90$var$$ = /^\s*?\[(x|\s)\]/, $22f44c32aa84ec90$var$w = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $22f44c32aa84ec90$var$C = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $22f44c32aa84ec90$var$z = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $22f44c32aa84ec90$var$L = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $22f44c32aa84ec90$var$A = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $22f44c32aa84ec90$var$T = /^<!--[\s\S]*?(?:-->)/, $22f44c32aa84ec90$var$O = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $22f44c32aa84ec90$var$B = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $22f44c32aa84ec90$var$M = /^\{.*\}$/, $22f44c32aa84ec90$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $22f44c32aa84ec90$var$I = /^<([^ >]+@[^ >]+)>/, $22f44c32aa84ec90$var$U = /^<([^ >]+:\/[^ >]+)>/, $22f44c32aa84ec90$var$D = /-([a-z])?/gi, $22f44c32aa84ec90$var$j = /^(.*\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $22f44c32aa84ec90$var$N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $22f44c32aa84ec90$var$H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $22f44c32aa84ec90$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $22f44c32aa84ec90$var$P = /(\[|\])/g, $22f44c32aa84ec90$var$_ = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $22f44c32aa84ec90$var$W = /\t/g, $22f44c32aa84ec90$var$G = /(^ *\||\| *$)/g, $22f44c32aa84ec90$var$Z = /^ *:-+: *$/, $22f44c32aa84ec90$var$q = /^ *:-+ *$/, $22f44c32aa84ec90$var$Q = /^ *-+: *$/, $22f44c32aa84ec90$var$V = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $22f44c32aa84ec90$var$X = new RegExp(`^([*_])\\1${$22f44c32aa84ec90$var$V}\\1\\1(?!\\1)`), $22f44c32aa84ec90$var$J = new RegExp(`^([*_])${$22f44c32aa84ec90$var$V}\\1(?!\\1|\\w)`), $22f44c32aa84ec90$var$K = new RegExp(`^==${$22f44c32aa84ec90$var$V}==`), $22f44c32aa84ec90$var$Y = new RegExp(`^~~${$22f44c32aa84ec90$var$V}~~`), $22f44c32aa84ec90$var$ee = /^\\([^0-9A-Za-z\s])/, $22f44c32aa84ec90$var$te = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $22f44c32aa84ec90$var$ne = /^\n+/, $22f44c32aa84ec90$var$re = /^([ \t]*)/, $22f44c32aa84ec90$var$ie = /\\([^\\])/g, $22f44c32aa84ec90$var$le = / *\n+$/, $22f44c32aa84ec90$var$ae = /(?:^|\n)( *)$/, $22f44c32aa84ec90$var$oe = "(?:\\d+\\.)", $22f44c32aa84ec90$var$ce = "(?:[*+-])";
function $22f44c32aa84ec90$var$se(e) {
    return "( *)(" + (1 === e ? $22f44c32aa84ec90$var$oe : $22f44c32aa84ec90$var$ce) + ") +";
}
const $22f44c32aa84ec90$var$de = $22f44c32aa84ec90$var$se(1), $22f44c32aa84ec90$var$ue = $22f44c32aa84ec90$var$se(2);
function $22f44c32aa84ec90$var$pe(e) {
    return new RegExp("^" + (1 === e ? $22f44c32aa84ec90$var$de : $22f44c32aa84ec90$var$ue));
}
const $22f44c32aa84ec90$var$fe = $22f44c32aa84ec90$var$pe(1), $22f44c32aa84ec90$var$he = $22f44c32aa84ec90$var$pe(2);
function $22f44c32aa84ec90$var$me(e) {
    return new RegExp("^" + (1 === e ? $22f44c32aa84ec90$var$de : $22f44c32aa84ec90$var$ue) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $22f44c32aa84ec90$var$oe : $22f44c32aa84ec90$var$ce) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $22f44c32aa84ec90$var$ge = $22f44c32aa84ec90$var$me(1), $22f44c32aa84ec90$var$ye = $22f44c32aa84ec90$var$me(2);
function $22f44c32aa84ec90$var$ke(e) {
    const t = 1 === e ? $22f44c32aa84ec90$var$oe : $22f44c32aa84ec90$var$ce;
    return new RegExp("^( *)(" + t + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + t + " (?!" + t + " ))\\n*|\\s*\\n*$)");
}
const $22f44c32aa84ec90$var$xe = $22f44c32aa84ec90$var$ke(1), $22f44c32aa84ec90$var$be = $22f44c32aa84ec90$var$ke(2);
function $22f44c32aa84ec90$var$ve(e, t) {
    const n = 1 === t, i = n ? $22f44c32aa84ec90$var$xe : $22f44c32aa84ec90$var$be, l = n ? $22f44c32aa84ec90$var$ge : $22f44c32aa84ec90$var$ye, a = n ? $22f44c32aa84ec90$var$fe : $22f44c32aa84ec90$var$he;
    return {
        match (e, t, n) {
            const r = $22f44c32aa84ec90$var$ae.exec(n);
            return r && (t.list || !t.inline && !t.simple) ? i.exec(e = r[1] + e) : null;
        },
        order: 1,
        parse (e, t, r) {
            const i = n ? +e[2] : void 0, o = e[0].replace($22f44c32aa84ec90$var$d, "\n").match(l);
            let c = !1;
            return {
                items: o.map(function(e, n) {
                    const i = a.exec(e)[0].length, l = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(l, "").replace(a, ""), d = n === o.length - 1, u = -1 !== s.indexOf("\n\n") || d && c;
                    c = u;
                    const p = r.inline, f = r.list;
                    let h;
                    r.list = !0, u ? (r.inline = !1, h = s.replace($22f44c32aa84ec90$var$le, "\n\n")) : (r.inline = !0, h = s.replace($22f44c32aa84ec90$var$le, ""));
                    const m = t(h, r);
                    return r.inline = p, r.list = f, m;
                }),
                ordered: n,
                start: i
            };
        },
        render: (t, n, i)=>e(t.ordered ? "ol" : "ul", {
                key: i.key,
                start: t.type === $22f44c32aa84ec90$export$e0aa44767d8750d5.orderedList ? t.start : void 0
            }, t.items.map(function(t, r) {
                return e("li", {
                    key: r
                }, n(t, i));
            }))
    };
}
const $22f44c32aa84ec90$var$Se = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $22f44c32aa84ec90$var$Ee = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $22f44c32aa84ec90$var$$e = [
    $22f44c32aa84ec90$var$u,
    $22f44c32aa84ec90$var$m,
    $22f44c32aa84ec90$var$g,
    $22f44c32aa84ec90$var$w,
    $22f44c32aa84ec90$var$z,
    $22f44c32aa84ec90$var$C,
    $22f44c32aa84ec90$var$T,
    $22f44c32aa84ec90$var$j,
    $22f44c32aa84ec90$var$ge,
    $22f44c32aa84ec90$var$xe,
    $22f44c32aa84ec90$var$ye,
    $22f44c32aa84ec90$var$be
], $22f44c32aa84ec90$var$we = [
    ...$22f44c32aa84ec90$var$$e,
    /^[^\n]+(?:  \n|\n{2,})/,
    $22f44c32aa84ec90$var$L,
    $22f44c32aa84ec90$var$B
];
function $22f44c32aa84ec90$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $22f44c32aa84ec90$var$ze(e) {
    return $22f44c32aa84ec90$var$Q.test(e) ? "right" : $22f44c32aa84ec90$var$Z.test(e) ? "center" : $22f44c32aa84ec90$var$q.test(e) ? "left" : null;
}
function $22f44c32aa84ec90$var$Le(e, t, n, i) {
    const l = n.inTable;
    n.inTable = !0;
    let a = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((e, l)=>("|" === l.trim() ? e.push(i ? {
            type: $22f44c32aa84ec90$export$e0aa44767d8750d5.tableSeparator
        } : {
            type: $22f44c32aa84ec90$export$e0aa44767d8750d5.text,
            text: l
        }) : "" !== l && e.push.apply(e, t(l, n)), e), []);
    n.inTable = l;
    let o = [
        []
    ];
    return a.forEach(function(e, t) {
        e.type === $22f44c32aa84ec90$export$e0aa44767d8750d5.tableSeparator ? 0 !== t && t !== a.length - 1 && o.push([]) : (e.type !== $22f44c32aa84ec90$export$e0aa44767d8750d5.text || null != a[t + 1] && a[t + 1].type !== $22f44c32aa84ec90$export$e0aa44767d8750d5.tableSeparator || (e.text = e.text.trimEnd()), o[o.length - 1].push(e));
    }), o;
}
function $22f44c32aa84ec90$var$Ae(e, t, n) {
    n.inline = !0;
    const i = e[2] ? e[2].replace($22f44c32aa84ec90$var$G, "").split("|").map($22f44c32aa84ec90$var$ze) : [], l = e[3] ? function(e, t, n) {
        return e.trim().split("\n").map(function(e) {
            return $22f44c32aa84ec90$var$Le(e, t, n, !0);
        });
    }(e[3], t, n) : [], a = $22f44c32aa84ec90$var$Le(e[1], t, n, !!l.length);
    return n.inline = !1, l.length ? {
        align: i,
        cells: l,
        header: a,
        type: $22f44c32aa84ec90$export$e0aa44767d8750d5.table
    } : {
        children: a,
        type: $22f44c32aa84ec90$export$e0aa44767d8750d5.paragraph
    };
}
function $22f44c32aa84ec90$var$Te(e, t) {
    return null == e.align[t] ? {} : {
        textAlign: e.align[t]
    };
}
function $22f44c32aa84ec90$var$Oe(e) {
    return function(t, n) {
        return n.inline ? e.exec(t) : null;
    };
}
function $22f44c32aa84ec90$var$Be(e) {
    return function(t, n) {
        return n.inline || n.simple ? e.exec(t) : null;
    };
}
function $22f44c32aa84ec90$var$Me(e) {
    return function(t, n) {
        return n.inline || n.simple ? null : e.exec(t);
    };
}
function $22f44c32aa84ec90$var$Re(e) {
    return function(t) {
        return e.exec(t);
    };
}
function $22f44c32aa84ec90$var$Ie(e, t, n) {
    if (t.inline || t.simple) return null;
    if (n && !n.endsWith("\n")) return null;
    let r = "";
    e.split("\n").every((e)=>!$22f44c32aa84ec90$var$$e.some((t)=>t.test(e)) && (r += e + "\n", e.trim()));
    const i = r.trimEnd();
    return "" == i ? null : [
        r,
        i
    ];
}
function $22f44c32aa84ec90$export$3e2338ea76b578c9(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $22f44c32aa84ec90$var$De(e) {
    return e.replace($22f44c32aa84ec90$var$ie, "$1");
}
function $22f44c32aa84ec90$var$je(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !0, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $22f44c32aa84ec90$var$Ne(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !1, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $22f44c32aa84ec90$var$He(e, t, n) {
    const r = n.inline || !1;
    n.inline = !1;
    const i = e(t, n);
    return n.inline = r, i;
}
const $22f44c32aa84ec90$var$Fe = (e, t, n)=>({
        children: $22f44c32aa84ec90$var$je(t, e[1], n)
    });
function $22f44c32aa84ec90$var$Pe() {
    return {};
}
function $22f44c32aa84ec90$var$_e() {
    return null;
}
function $22f44c32aa84ec90$var$We(...e) {
    return e.filter(Boolean).join(" ");
}
function $22f44c32aa84ec90$var$Ge(e, t, n) {
    let r = e;
    const i = t.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || n;
}
function $22f44c32aa84ec90$export$69f434acfbdb0b32(n = "", i = {}) {
    function d(e, n, ...r) {
        const l = $22f44c32aa84ec90$var$Ge(i.overrides, `${e}.props`, {});
        return i.createElement(function(e, t) {
            const n = $22f44c32aa84ec90$var$Ge(t, e);
            return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $22f44c32aa84ec90$var$Ge(t, `${e}.component`, e) : e;
        }(e, i.overrides), $22f44c32aa84ec90$var$t({}, n, l, {
            className: $22f44c32aa84ec90$var$We(null == n ? void 0 : n.className, l.className) || void 0
        }), ...r);
    }
    function G(t) {
        t = t.replace($22f44c32aa84ec90$var$E, "");
        let n = !1;
        i.forceInline ? n = !0 : i.forceBlock || (n = !1 === $22f44c32aa84ec90$var$_.test(t));
        const r = le(ie(n ? t : `${t.trimEnd().replace($22f44c32aa84ec90$var$ne, "")}\n\n`, {
            inline: n
        }));
        for(; "string" == typeof r[r.length - 1] && !r[r.length - 1].trim();)r.pop();
        if (null === i.wrapper) return r;
        const l = i.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || i.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? d("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $cozmU.createElement(l, {
            key: "outer"
        }, a);
    }
    function Z(t, n) {
        const r = n.match($22f44c32aa84ec90$var$c);
        return r ? r.reduce(function(n, r, a) {
            const o = r.indexOf("=");
            if (-1 !== o) {
                const c = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($22f44c32aa84ec90$var$O) && (e = e.replace($22f44c32aa84ec90$var$D, function(e, t) {
                        return t.toUpperCase();
                    })), e;
                })(r.slice(0, o)).trim(), s = function(e) {
                    const t = e[0];
                    return ('"' === t || "'" === t) && e.length >= 2 && e[e.length - 1] === t ? e.slice(1, -1) : e;
                }(r.slice(o + 1).trim()), d = $22f44c32aa84ec90$var$l[c] || c, u = n[d] = function(e, t, n, r) {
                    return "style" === t ? n.split(/;\s?/).reduce(function(e, t) {
                        const n = t.slice(0, t.indexOf(":"));
                        return e[n.trim().replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t.slice(n.length + 1).trim(), e;
                    }, {}) : "href" === t || "src" === t ? r(n, e, t) : (n.match($22f44c32aa84ec90$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(t, c, s, i.sanitizer);
                "string" == typeof u && ($22f44c32aa84ec90$var$L.test(u) || $22f44c32aa84ec90$var$B.test(u)) && (n[d] = $cozmU.cloneElement(G(u.trim()), {
                    key: a
                }));
            } else "style" !== r && (n[$22f44c32aa84ec90$var$l[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    i.overrides = i.overrides || {}, i.sanitizer = i.sanitizer || $22f44c32aa84ec90$export$3e2338ea76b578c9, i.slugify = i.slugify || $22f44c32aa84ec90$export$c383cdd2a518017a, i.namedCodesToUnicode = i.namedCodesToUnicode ? $22f44c32aa84ec90$var$t({}, $22f44c32aa84ec90$var$a, i.namedCodesToUnicode) : $22f44c32aa84ec90$var$a, i.createElement = i.createElement || $cozmU.createElement;
    const q = [], Q = {}, V = {
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.blockQuote]: {
            match: $22f44c32aa84ec90$var$Me($22f44c32aa84ec90$var$u),
            order: 1,
            parse: (e, t, n)=>({
                    children: t(e[0].replace($22f44c32aa84ec90$var$p, ""), n)
                }),
            render: (e, t, n)=>d("blockquote", {
                    key: n.key
                }, t(e.children, n))
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.breakLine]: {
            match: $22f44c32aa84ec90$var$Re($22f44c32aa84ec90$var$f),
            order: 1,
            parse: $22f44c32aa84ec90$var$Pe,
            render: (e, t, n)=>d("br", {
                    key: n.key
                })
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.breakThematic]: {
            match: $22f44c32aa84ec90$var$Me($22f44c32aa84ec90$var$h),
            order: 1,
            parse: $22f44c32aa84ec90$var$Pe,
            render: (e, t, n)=>d("hr", {
                    key: n.key
                })
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.codeBlock]: {
            match: $22f44c32aa84ec90$var$Me($22f44c32aa84ec90$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, n, r)=>d("pre", {
                    key: r.key
                }, d("code", $22f44c32aa84ec90$var$t({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.codeFenced]: {
            match: $22f44c32aa84ec90$var$Me($22f44c32aa84ec90$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: Z("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: $22f44c32aa84ec90$export$e0aa44767d8750d5.codeBlock
                })
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.codeInline]: {
            match: $22f44c32aa84ec90$var$Be($22f44c32aa84ec90$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, t, n)=>d("code", {
                    key: n.key
                }, e.text)
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.footnote]: {
            match: $22f44c32aa84ec90$var$Me($22f44c32aa84ec90$var$b),
            order: 0,
            parse: (e)=>(q.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $22f44c32aa84ec90$var$_e
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.footnoteReference]: {
            match: $22f44c32aa84ec90$var$Oe($22f44c32aa84ec90$var$v),
            order: 1,
            parse: (e)=>({
                    target: `#${i.slugify(e[1], $22f44c32aa84ec90$export$c383cdd2a518017a)}`,
                    text: e[1]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href")
                }, d("sup", {
                    key: n.key
                }, e.text))
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.gfmTask]: {
            match: $22f44c32aa84ec90$var$Oe($22f44c32aa84ec90$var$$),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, t, n)=>d("input", {
                    checked: e.completed,
                    key: n.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.heading]: {
            match: $22f44c32aa84ec90$var$Me(i.enforceAtxHeadings ? $22f44c32aa84ec90$var$C : $22f44c32aa84ec90$var$w),
            order: 1,
            parse: (e, t, n)=>({
                    children: $22f44c32aa84ec90$var$je(t, e[2], n),
                    id: i.slugify(e[2], $22f44c32aa84ec90$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            render: (e, t, n)=>d(`h${e.level}`, {
                    id: e.id,
                    key: n.key
                }, t(e.children, n))
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.headingSetext]: {
            match: $22f44c32aa84ec90$var$Me($22f44c32aa84ec90$var$z),
            order: 0,
            parse: (e, t, n)=>({
                    children: $22f44c32aa84ec90$var$je(t, e[1], n),
                    level: "=" === e[2] ? 1 : 2,
                    type: $22f44c32aa84ec90$export$e0aa44767d8750d5.heading
                })
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.htmlBlock]: {
            match: $22f44c32aa84ec90$var$Re($22f44c32aa84ec90$var$L),
            order: 1,
            parse (e, t, n) {
                const [, r] = e[3].match($22f44c32aa84ec90$var$re), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), a = (c = l, $22f44c32aa84ec90$var$we.some((e)=>e.test(c)) ? $22f44c32aa84ec90$var$He : $22f44c32aa84ec90$var$je);
                var c;
                const s = e[1].toLowerCase(), d = -1 !== $22f44c32aa84ec90$var$o.indexOf(s), u = (d ? s : e[1]).trim(), p = {
                    attrs: Z(u, e[2]),
                    noInnerParse: d,
                    tag: u
                };
                return n.inAnchor = n.inAnchor || "a" === s, d ? p.text = e[3] : p.children = a(t, l, n), n.inAnchor = !1, p;
            },
            render: (e, n, r)=>d(e.tag, $22f44c32aa84ec90$var$t({
                    key: r.key
                }, e.attrs), e.text || n(e.children, r))
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.htmlSelfClosing]: {
            match: $22f44c32aa84ec90$var$Re($22f44c32aa84ec90$var$B),
            order: 1,
            parse (e) {
                const t = e[1].trim();
                return {
                    attrs: Z(t, e[2] || ""),
                    tag: t
                };
            },
            render: (e, n, r)=>d(e.tag, $22f44c32aa84ec90$var$t({}, e.attrs, {
                    key: r.key
                }))
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.htmlComment]: {
            match: $22f44c32aa84ec90$var$Re($22f44c32aa84ec90$var$T),
            order: 1,
            parse: ()=>({}),
            render: $22f44c32aa84ec90$var$_e
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.image]: {
            match: $22f44c32aa84ec90$var$Be($22f44c32aa84ec90$var$Ee),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $22f44c32aa84ec90$var$De(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("img", {
                    key: n.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: i.sanitizer(e.target, "img", "src")
                })
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.link]: {
            match: $22f44c32aa84ec90$var$Oe($22f44c32aa84ec90$var$Se),
            order: 3,
            parse: (e, t, n)=>({
                    children: $22f44c32aa84ec90$var$Ne(t, e[1], n),
                    target: $22f44c32aa84ec90$var$De(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href"),
                    title: e.title
                }, t(e.children, n))
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.linkAngleBraceStyleDetector]: {
            match: $22f44c32aa84ec90$var$Oe($22f44c32aa84ec90$var$U),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $22f44c32aa84ec90$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    type: $22f44c32aa84ec90$export$e0aa44767d8750d5.link
                })
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.linkBareUrlDetector]: {
            match: (e, t)=>t.inAnchor ? null : $22f44c32aa84ec90$var$Oe($22f44c32aa84ec90$var$R)(e, t),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $22f44c32aa84ec90$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: $22f44c32aa84ec90$export$e0aa44767d8750d5.link
                })
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.linkMailtoDetector]: {
            match: $22f44c32aa84ec90$var$Oe($22f44c32aa84ec90$var$I),
            order: 0,
            parse (e) {
                let t = e[1], n = e[1];
                return $22f44c32aa84ec90$var$s.test(n) || (n = "mailto:" + n), {
                    children: [
                        {
                            text: t.replace("mailto:", ""),
                            type: $22f44c32aa84ec90$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: n,
                    type: $22f44c32aa84ec90$export$e0aa44767d8750d5.link
                };
            }
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.orderedList]: $22f44c32aa84ec90$var$ve(d, 1),
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.unorderedList]: $22f44c32aa84ec90$var$ve(d, 2),
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.newlineCoalescer]: {
            match: $22f44c32aa84ec90$var$Me($22f44c32aa84ec90$var$k),
            order: 3,
            parse: $22f44c32aa84ec90$var$Pe,
            render: ()=>"\n"
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.paragraph]: {
            match: $22f44c32aa84ec90$var$Ie,
            order: 3,
            parse: $22f44c32aa84ec90$var$Fe,
            render: (e, t, n)=>d("p", {
                    key: n.key
                }, t(e.children, n))
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.ref]: {
            match: $22f44c32aa84ec90$var$Oe($22f44c32aa84ec90$var$N),
            order: 0,
            parse: (e)=>(Q[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $22f44c32aa84ec90$var$_e
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.refImage]: {
            match: $22f44c32aa84ec90$var$Be($22f44c32aa84ec90$var$H),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, t, n)=>Q[e.ref] ? d("img", {
                    key: n.key,
                    alt: e.alt,
                    src: i.sanitizer(Q[e.ref].target, "img", "src"),
                    title: Q[e.ref].title
                }) : null
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.refLink]: {
            match: $22f44c32aa84ec90$var$Oe($22f44c32aa84ec90$var$F),
            order: 0,
            parse: (e, t, n)=>({
                    children: t(e[1], n),
                    fallbackChildren: t(e[0].replace($22f44c32aa84ec90$var$P, "\\$1"), n),
                    ref: e[2]
                }),
            render: (e, t, n)=>Q[e.ref] ? d("a", {
                    key: n.key,
                    href: i.sanitizer(Q[e.ref].target, "a", "href"),
                    title: Q[e.ref].title
                }, t(e.children, n)) : d("span", {
                    key: n.key
                }, t(e.fallbackChildren, n))
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.table]: {
            match: $22f44c32aa84ec90$var$Me($22f44c32aa84ec90$var$j),
            order: 1,
            parse: $22f44c32aa84ec90$var$Ae,
            render (e, t, n) {
                const r = e;
                return d("table", {
                    key: n.key
                }, d("thead", null, d("tr", null, r.header.map(function(e, i) {
                    return d("th", {
                        key: i,
                        style: $22f44c32aa84ec90$var$Te(r, i)
                    }, t(e, n));
                }))), d("tbody", null, r.cells.map(function(e, i) {
                    return d("tr", {
                        key: i
                    }, e.map(function(e, i) {
                        return d("td", {
                            key: i,
                            style: $22f44c32aa84ec90$var$Te(r, i)
                        }, t(e, n));
                    }));
                })));
            }
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.text]: {
            match: $22f44c32aa84ec90$var$Re($22f44c32aa84ec90$var$te),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($22f44c32aa84ec90$var$A, (e, t)=>i.namedCodesToUnicode[t] ? i.namedCodesToUnicode[t] : e)
                }),
            render: (e)=>e.text
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.textBolded]: {
            match: $22f44c32aa84ec90$var$Be($22f44c32aa84ec90$var$X),
            order: 2,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("strong", {
                    key: n.key
                }, t(e.children, n))
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.textEmphasized]: {
            match: $22f44c32aa84ec90$var$Be($22f44c32aa84ec90$var$J),
            order: 3,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("em", {
                    key: n.key
                }, t(e.children, n))
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.textEscaped]: {
            match: $22f44c32aa84ec90$var$Be($22f44c32aa84ec90$var$ee),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: $22f44c32aa84ec90$export$e0aa44767d8750d5.text
                })
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.textMarked]: {
            match: $22f44c32aa84ec90$var$Be($22f44c32aa84ec90$var$K),
            order: 3,
            parse: $22f44c32aa84ec90$var$Fe,
            render: (e, t, n)=>d("mark", {
                    key: n.key
                }, t(e.children, n))
        },
        [$22f44c32aa84ec90$export$e0aa44767d8750d5.textStrikethroughed]: {
            match: $22f44c32aa84ec90$var$Be($22f44c32aa84ec90$var$Y),
            order: 3,
            parse: $22f44c32aa84ec90$var$Fe,
            render: (e, t, n)=>d("del", {
                    key: n.key
                }, t(e.children, n))
        }
    };
    !0 === i.disableParsingRawHTML && (delete V[$22f44c32aa84ec90$export$e0aa44767d8750d5.htmlBlock], delete V[$22f44c32aa84ec90$export$e0aa44767d8750d5.htmlSelfClosing]);
    const ie = function(e) {
        let t = Object.keys(e);
        function n(r, i) {
            let l = [], a = "";
            for(; r;){
                let o = 0;
                for(; o < t.length;){
                    const c = t[o], s = e[c], d = s.match(r, i, a);
                    if (d) {
                        const e = d[0];
                        r = r.substring(e.length);
                        const t = s.parse(d, n, i);
                        null == t.type && (t.type = c), l.push(t), a = e;
                        break;
                    }
                    o++;
                }
            }
            return l;
        }
        return t.sort(function(t, n) {
            let r = e[t].order, i = e[n].order;
            return r !== i ? r - i : t < n ? -1 : 1;
        }), function(e, t) {
            return n(function(e) {
                return e.replace($22f44c32aa84ec90$var$x, "\n").replace($22f44c32aa84ec90$var$S, "").replace($22f44c32aa84ec90$var$W, "    ");
            }(e), t);
        };
    }(V), le = (ae = function(e, t) {
        return function(n, r, i) {
            const l = e[n.type].render;
            return t ? t(()=>l(n, r, i), n, r, i) : l(n, r, i);
        };
    }(V, i.renderRule), function e(t, n = {}) {
        if (Array.isArray(t)) {
            const r = n.key, i = [];
            let l = !1;
            for(let r = 0; r < t.length; r++){
                n.key = r;
                const a = e(t[r], n), o = "string" == typeof a;
                o && l ? i[i.length - 1] += a : null !== a && i.push(a), l = o;
            }
            return n.key = r, i;
        }
        return ae(t, e, n);
    });
    var ae;
    const oe = G(n);
    return q.length ? d("div", null, oe, d("footer", {
        key: "footer"
    }, q.map(function(e) {
        return d("div", {
            id: i.slugify(e.identifier, $22f44c32aa84ec90$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, le(ie(e.footnote, {
            inline: !0
        })));
    }))) : oe;
}
var $22f44c32aa84ec90$export$2e2bcd8739ae039 = (t)=>{
    let { children: r = "", options: i } = t, l = function(e, t) {
        if (null == e) return {};
        var n, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)t.indexOf(n = l[r]) >= 0 || (i[n] = e[n]);
        return i;
    }(t, $22f44c32aa84ec90$var$n);
    return $cozmU.cloneElement($22f44c32aa84ec90$export$69f434acfbdb0b32(r, i), l);
};
 //# sourceMappingURL=index.modern.js.map

});

parcelRegister("d4O2g", function(module, exports) {

var $1kPn4 = parcelRequire("1kPn4");

const $b61bca3ca7bdd7f0$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $1kPn4.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $1kPn4.extractUrlFromLinkJsonLd)(image.url);
        }
    }
    return undefined;
};
module.exports["extractImage"] = $b61bca3ca7bdd7f0$export$4c753a1297cb9805;

});

parcelRegister("lXmY5", function(module, exports) {

var $hiX3M = parcelRequire("hiX3M");


var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");

const $652810c159b94aae$export$16b02be3e2bb31ad = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.ari || (0, $8YE7G.extractEntity)(response)?.thirdPartyAri;
    const data = response?.data;
    return (0, $hiX3M.extractAri)(data);
};
module.exports["extractSmartLinkAri"] = $652810c159b94aae$export$16b02be3e2bb31ad;

});

parcelRegister("cLyLO", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $htsh0 = parcelRequire("htsh0");


var $kAdyG = parcelRequire("kAdyG");

const $b816614c9f5e4543$export$41fc716e1bc2dc90 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $kAdyG.isEntityPresent)(response)) {
        const entity = (0, $8YE7G.extractEntity)(response);
        const owners = entity?.owners;
        if (owners) return owners.map((owner)=>({
                name: owner.displayName,
                src: owner.picture
            })).filter((item)=>!!item);
    }
    return (0, $htsh0.extractPersonCreatedBy)(response.data);
};
module.exports["extractSmartLinkAuthorGroup"] = $b816614c9f5e4543$export$41fc716e1bc2dc90;

});

parcelRegister("htsh0", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $94cdde39bec9c233$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map((0, $9EREa.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $9EREa.extractPersonFromJsonLd)(attributedTo);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
module.exports["extractPersonCreatedBy"] = $94cdde39bec9c233$export$a66235cba0c9d11a;

});

parcelRegister("ddzkt", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $htsh0 = parcelRequire("htsh0");


var $kAdyG = parcelRequire("kAdyG");

const $8118f7b98ace9299$export$242875b46118beb2 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.createdBy?.displayName;
    const persons = (0, $htsh0.extractPersonCreatedBy)(response.data);
    return !!persons?.length ? persons[0].name : undefined;
};
module.exports["extractSmartLinkCreatedBy"] = $8118f7b98ace9299$export$242875b46118beb2;

});

parcelRegister("cbT5r", function(module, exports) {

var $04wHu = parcelRequire("04wHu");


var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");

const $0016e53066bcc8e1$export$7a685df468cbf38f = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.createdAt;
    return response?.data && (0, $04wHu.extractDateCreated)(response.data);
};
module.exports["extractSmartLinkCreatedOn"] = $0016e53066bcc8e1$export$7a685df468cbf38f;

});

parcelRegister("04wHu", function(module, exports) {
const $cb783639b44cd885$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
    return undefined;
};
module.exports["extractDateCreated"] = $cb783639b44cd885$export$e1226a5e0bbbf862;

});

parcelRegister("e1RBl", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $JTvZe = parcelRequire("JTvZe");


var $kAdyG = parcelRequire("kAdyG");

const $0ec810a5f5f35d9a$export$7f099a839071a190 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.lastUpdatedBy?.displayName;
    const person = (0, $JTvZe.extractPersonUpdatedBy)(response.data);
    return person ? person.name : undefined;
};
module.exports["extractSmartLinkModifiedBy"] = $0ec810a5f5f35d9a$export$7f099a839071a190;

});

parcelRegister("JTvZe", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $a5f06d98edfcf1aa$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return (0, $9EREa.extractPersonFromJsonLd)(updatedBy);
    return undefined;
};
module.exports["extractPersonUpdatedBy"] = $a5f06d98edfcf1aa$export$8a2d1ed7e6f336f0;

});

parcelRegister("ltT9o", function(module, exports) {

var $hltP6 = parcelRequire("hltP6");


var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");

const $42cf6b151797d39e$export$75047940e157fd1f = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.lastUpdatedAt;
    return response?.data && (0, $hltP6.extractDateUpdated)(response.data);
};
module.exports["extractSmartLinkModifiedOn"] = $42cf6b151797d39e$export$75047940e157fd1f;

});

parcelRegister("hltP6", function(module, exports) {
const $57fe09cd1e375acc$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
    return undefined;
};
module.exports["extractDateUpdated"] = $57fe09cd1e375acc$export$7fc2f5e6f9d22ae7;

});

parcelRegister("hoB2R", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");

const $dedbbfb6fd3975a3$export$96ed4c1b14ac210a = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) {
        const entity = (0, $8YE7G.extractEntity)(response);
        return entity && 'exportLinks' in entity && Array.isArray(entity.exportLinks) && entity.exportLinks.length > 0 ? entity?.exportLinks?.[0].url : undefined;
    }
    return response?.data?.['atlassian:downloadUrl'];
};
module.exports["extractSmartLinkDownloadUrl"] = $dedbbfb6fd3975a3$export$96ed4c1b14ac210a;

});

parcelRegister("dSs0x", function(module, exports) {

var $fcaWu = parcelRequire("fcaWu");

const $8838e9e9c5b34afb$export$736a7b9a8e50ca01 = (previewUrl, { hostProduct: hostProduct, themeState: themeState })=>{
    try {
        const url = new URL(previewUrl);
        if (themeState) url.searchParams.append('themeState', (0, $fcaWu.themeObjectToString)(themeState));
        if (hostProduct) url.searchParams.set('hostProduct', hostProduct);
        return url.href;
    } catch  {
        return previewUrl;
    }
};
const $8838e9e9c5b34afb$export$4470f298c61a79da = (previewUrl, themeState)=>$8838e9e9c5b34afb$export$736a7b9a8e50ca01(previewUrl, {
        themeState: themeState
    });
module.exports["getPreviewUrlWithEmbedContext"] = $8838e9e9c5b34afb$export$736a7b9a8e50ca01;
module.exports["getPreviewUrlWithTheme"] = $8838e9e9c5b34afb$export$4470f298c61a79da;

});

parcelRegister("di1bl", function(module, exports) {
const $7def949369507160$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};
module.exports["getIframeSandboxAttribute"] = $7def949369507160$export$9b7e6a102056a387;

});

parcelRegister("gJj3k", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $19zon = parcelRequire("19zon");


var $f24cK = parcelRequire("f24cK");


var $bhs2L = parcelRequire("bhs2L");

const $5b6c9e2393a4e885$var$LazyEmbeddedConfluencePage = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(0, $bhs2L.loadEmbeddedConfluencePage)().then((Page)=>({
            default: Page
        })));
const $5b6c9e2393a4e885$export$b32b5f1ee4493319 = ({ childRef: childRef, className: className, extensionKey: extensionKey, ...props })=>{
    const confluencePageData = (0, $19zon.useConfluencePageData)(props.src || '', extensionKey || '');
    const InjectedPage = (0, $f24cK.useEmbeddedConfluencePage)();
    const Page = InjectedPage ?? $5b6c9e2393a4e885$var$LazyEmbeddedConfluencePage;
    const fallbackIframe = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("iframe", {
        className: className,
        ...props,
        ref: childRef,
        title: props.title
    });
    // Conditional rendering: Page component for lp-cc-embed URLs, iframe for everything else
    return confluencePageData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: fallbackIframe
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Page, {
        hostname: confluencePageData.hostname,
        spaceKey: confluencePageData.spaceKey,
        contentId: confluencePageData.contentId,
        parentProduct: confluencePageData.parentProduct,
        hash: confluencePageData.hash,
        mode: confluencePageData.mode,
        locale: confluencePageData.locale,
        iframeRef: childRef,
        onLoad: props.onLoad,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        sandbox: props.sandbox,
        allowedFeatures: confluencePageData.allowedFeatures,
        themeState: confluencePageData.themeStateObject,
        userInfo: confluencePageData.userInfo
    })) : fallbackIframe;
};
module.exports["IFrame"] = $5b6c9e2393a4e885$export$b32b5f1ee4493319;

});

parcelRegister("19zon", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $k4lqb = parcelRequire("k4lqb");


var $jIrdU = parcelRequire("jIrdU");

var $0848f0766ba8a46c$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $0848f0766ba8a46c$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
var $0848f0766ba8a46c$export$dc091dbfc779121b = /*#__PURE__*/ function(CONFLUENCE_EXTENSION_KEYS) {
    CONFLUENCE_EXTENSION_KEYS["PAGE"] = "integration-confluence-object-provider";
    CONFLUENCE_EXTENSION_KEYS["CANVAS"] = "canvas-native-object-provider";
    return CONFLUENCE_EXTENSION_KEYS;
}({});
const $0848f0766ba8a46c$export$10fb2803bc7b79fc = (url, extensionKey)=>{
    const parsedData = (0, $cozmU.useMemo)(()=>{
        if (!url || typeof url !== 'string' || !url.startsWith('http://') && !url.startsWith('https://') || !extensionKey || !Object.values($0848f0766ba8a46c$export$dc091dbfc779121b).find((key)=>key === extensionKey)) return undefined;
        let urlObj;
        try {
            urlObj = new URL(url);
        } catch  {
            return undefined;
        }
        const { searchParams: searchParams, hash: hash } = urlObj;
        const hostname = searchParams?.get('hostname') || '';
        const contentId = searchParams?.get('contentId') || '';
        const spaceKey = searchParams?.get('spaceKey') || '';
        // Early return for invalid URLs
        if (!contentId || !hostname) return undefined;
        const themeState = searchParams?.get('themeState') || '';
        const themeMode = searchParams?.get('themeMode');
        const enableInlineComments = searchParams?.get('enableInlineComments') === 'true';
        const enablePageComments = searchParams?.get('enablePageComments') === 'true';
        const userId = searchParams?.get('userId') || '';
        const userIdType = searchParams?.get('userInfo') || undefined;
        const parentProduct = searchParams?.get('parentProduct') || '';
        const inlineComments = enableInlineComments ? [
            'inline-comments'
        ] : [];
        const pageComments = enablePageComments ? [
            'page-comments'
        ] : [];
        // Calculate theme state object here
        let calculatedThemeStateObject;
        if (themeState) calculatedThemeStateObject = (0, $jIrdU.themeStringToObject)(decodeURIComponent(themeState));
        else if (themeMode) calculatedThemeStateObject = {
            colorMode: themeMode
        };
        const calculatedUserInfo = userId && userIdType ? {
            userId: userId,
            userIdType: userIdType
        } : undefined;
        return {
            hostname: hostname,
            spaceKey: spaceKey,
            contentId: contentId,
            parentProduct: parentProduct,
            userInfo: calculatedUserInfo,
            hash: hash || '',
            enableInlineComments: enableInlineComments,
            enablePageComments: enablePageComments,
            themeStateObject: calculatedThemeStateObject,
            allowedFeatures: {
                edit: [
                    'delete-draft'
                ],
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-reactions',
                    ...pageComments,
                    ...inlineComments
                ]
            },
            mode: "view",
            locale: 'en'
        };
    }, [
        url,
        extensionKey
    ]);
    // Handle theme side effect - only when theme object changes
    (0, $cozmU.useEffect)(()=>{
        if (parsedData?.themeStateObject) (0, $k4lqb.setGlobalTheme)(parsedData.themeStateObject);
    }, [
        parsedData?.themeStateObject
    ]);
    return parsedData;
};
module.exports["useConfluencePageData"] = $0848f0766ba8a46c$export$10fb2803bc7b79fc;

});

parcelRegister("f24cK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $aa21c625d0c25974$var$EmbeddedConfluencePageContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $aa21c625d0c25974$export$542af7a009641f95 = $aa21c625d0c25974$var$EmbeddedConfluencePageContext.Provider;
const $aa21c625d0c25974$export$95a59d66783a54b3 = ()=>(0, $cozmU.useContext)($aa21c625d0c25974$var$EmbeddedConfluencePageContext);
module.exports["useEmbeddedConfluencePage"] = $aa21c625d0c25974$export$95a59d66783a54b3;

});

parcelRegister("bhs2L", function(module, exports) {
/**
 * Async factory for the Confluence embed `Page` component.
 *
 * Kept in its own module so `@atlaskit/embedded-confluence/page` is a dynamic
 * import only — hosts that never render a Confluence embed URL do not
 * download this chunk.
 */ 
async function $b32c583ef23c7f79$export$61cc2a15eefecd0b() {
    const { Page: Page } = await (parcelRequire("7yCpq"));
    return Page;
}
module.exports["loadEmbeddedConfluencePage"] = $b32c583ef23c7f79$export$61cc2a15eefecd0b;

});

parcelRegister("7yCpq", function(module, exports) {

let $580980a38ccb7918$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $580980a38ccb7918$var$load("iECXC"),
    $580980a38ccb7918$var$load("6wr18"),
    $580980a38ccb7918$var$load("ffEVr"),
    $580980a38ccb7918$var$load("bm0AN"),
    $580980a38ccb7918$var$load("Wowvf"),
    $580980a38ccb7918$var$load("7k9oy"),
    $580980a38ccb7918$var$load("hhss7"),
    $580980a38ccb7918$var$load("24IOT")
]).then(()=>parcelRequire('jpl1A'));

});

parcelRegister("cuq2s", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $q9Cpn = parcelRequire("q9Cpn");

const $cc5224b9f28cd9ed$export$a54013f0d02a8f82 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children, locale: t1, fetchTranslations: fetchTranslations } = t0;
    const incomingLocale = t1 === undefined ? (0, $q9Cpn.DEFAULT_LOCALE) : t1;
    const [messages, setMessages] = (0, $cozmU.useState)();
    let t2;
    if ($[0] !== incomingLocale) {
        t2 = (0, $q9Cpn.normalizeLocale)(incomingLocale);
        $[0] = incomingLocale;
        $[1] = t2;
    } else t2 = $[1];
    const locale = t2;
    let t3;
    let t4;
    if ($[2] !== fetchTranslations || $[3] !== locale) {
        t3 = ()=>{
            const loadTranslations = async ()=>{
                const localeMessages = await fetchTranslations(locale);
                setMessages(localeMessages);
            };
            loadTranslations();
        };
        t4 = [
            fetchTranslations,
            locale
        ];
        $[2] = fetchTranslations;
        $[3] = locale;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $cozmU.useEffect)(t3, t4);
    if (!messages) return null;
    let t5;
    if ($[6] !== children || $[7] !== locale || $[8] !== messages) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            locale: locale,
            messages: messages,
            defaultLocale: (0, $q9Cpn.DEFAULT_LOCALE)
        }, children);
        $[6] = children;
        $[7] = locale;
        $[8] = messages;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : ({ children: children, locale: incomingLocale = (0, $q9Cpn.DEFAULT_LOCALE), fetchTranslations: fetchTranslations })=>{
    const [messages, setMessages] = (0, $cozmU.useState)();
    const locale = (0, $cozmU.useMemo)(()=>(0, $q9Cpn.normalizeLocale)(incomingLocale), [
        incomingLocale
    ]);
    (0, $cozmU.useEffect)(()=>{
        const loadTranslations = async ()=>{
            const localeMessages = await fetchTranslations(locale);
            setMessages(localeMessages);
        };
        loadTranslations();
    }, [
        fetchTranslations,
        locale
    ]);
    if (!messages) return null;
    // Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
    // They will not function correctly due to a lack of I18n context.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: locale,
        messages: messages,
        defaultLocale: (0, $q9Cpn.DEFAULT_LOCALE)
    }, children);
};
module.exports["I18nProvider"] = $cc5224b9f28cd9ed$export$a54013f0d02a8f82;

});

parcelRegister("q9Cpn", function(module, exports) {
const $bacd93d5d71e2df6$var$DEFAULT_LANGUAGE = 'en';
const $bacd93d5d71e2df6$var$DEFAULT_REGION = 'US';
const $bacd93d5d71e2df6$export$1af4c7e47ad72f44 = `${$bacd93d5d71e2df6$var$DEFAULT_LANGUAGE}-${$bacd93d5d71e2df6$var$DEFAULT_REGION}`;
const $bacd93d5d71e2df6$var$languageToLongLocaleCode = {
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hu: 'hu-HU',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    // Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
    no: 'no-NO',
    nb: 'no-NO',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN'
};
const $bacd93d5d71e2df6$export$dca0327c9b9c6498 = (locale)=>{
    if (!locale) return $bacd93d5d71e2df6$export$1af4c7e47ad72f44;
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from the supplied locale.');
    const [, language, region] = match;
    const normalizedLanguage = (language ?? '').toLowerCase();
    const normalizedRegion = (region ?? '').toUpperCase();
    if (normalizedLanguage && normalizedRegion) return [
        normalizedLanguage,
        normalizedRegion
    ].join('-');
    const longLocaleCode = $bacd93d5d71e2df6$var$languageToLongLocaleCode[normalizedLanguage];
    return longLocaleCode ?? $bacd93d5d71e2df6$export$1af4c7e47ad72f44;
};
module.exports["DEFAULT_LOCALE"] = $bacd93d5d71e2df6$export$1af4c7e47ad72f44;
module.exports["normalizeLocale"] = $bacd93d5d71e2df6$export$dca0327c9b9c6498;

});

parcelRegister("bVevd", function(module, exports) {
var $3914485ee940289d$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
module.exports["EMBEDDED_CONFLUENCE_MODE"] = $3914485ee940289d$export$816ef638e478449a;

});

parcelRegister("bIcvA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $jKLZ2 = parcelRequire("jKLZ2");

const $1ec3abac0f6c1bfe$export$865423e6f8e2e839 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $jKLZ2.PerformanceMetricsContext));
} : ()=>{
    return (0, $cozmU.useContext)((0, $jKLZ2.PerformanceMetricsContext));
};
module.exports["usePerformanceMetrics"] = $1ec3abac0f6c1bfe$export$865423e6f8e2e839;

});

parcelRegister("jKLZ2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $67682ba06b731a04$export$57c7d895214badd4 = /*#__PURE__*/ (0, $cozmU.createContext)({
    isInitialized: false,
    cancelIframeLoadMetrics: ()=>{},
    markIframeLoadMetrics: ()=>{},
    setContentType: ()=>{}
});
module.exports["PerformanceMetricsContext"] = $67682ba06b731a04$export$57c7d895214badd4;

});

parcelRegister("gyfUL", function(module, exports) {

var $fcaWu = parcelRequire("fcaWu");

const $8eb929a208703a52$export$6e43e60d51b79331 = (themeState)=>{
    const themeString = (0, $fcaWu.themeObjectToString)(themeState);
    return encodeURIComponent(themeString);
};
module.exports["themeStateObjectToQueryString"] = $8eb929a208703a52$export$6e43e60d51b79331;

});

parcelRegister("4ZxtP", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $4dbfd7f5dbf19ca5$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>(0, $9EREa.extractPersonFromJsonLd)(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = (0, $9EREa.extractPersonFromJsonLd)(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
    return undefined;
};
module.exports["extractMembers"] = $4dbfd7f5dbf19ca5$export$6281d080d62a0719;

});

parcelRegister("6CHZa", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $e6695a46069ee43e$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return (0, $9EREa.extractPersonFromJsonLd)(assignedTo);
    return undefined;
};
module.exports["extractPersonAssignedTo"] = $e6695a46069ee43e$export$38a0979ebf273662;

});

parcelRegister("hQVHS", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $87b9bf478c0c1673$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546" clip-rule="evenodd"/>
</svg>
`;
const $87b9bf478c0c1673$export$5ed3e1bb3b04fc02 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProjectsIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Projects" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $87b9bf478c0c1673$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function ProjectsIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Projects', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $87b9bf478c0c1673$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["ProjectsIcon"] = $87b9bf478c0c1673$export$5ed3e1bb3b04fc02;

});

parcelRegister("11zX6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $fa07988e74fc1b7d$export$8f5a73ba0d077b01 = 32;
class $fa07988e74fc1b7d$export$3482036c37e627f4 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidMount() {
        window.addEventListener('message', this.messageCallback);
    }
    componentWillUnmount() {
        window.removeEventListener('message', this.messageCallback);
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.messageCallback = (event)=>{
            const { embedIframeRef: embedIframeRef } = this.props;
            const isFromExpectedIframe = embedIframeRef.current && event.source === embedIframeRef.current.contentWindow;
            const isStringData = typeof event.data === 'string';
            if (isFromExpectedIframe && isStringData) try {
                const data = JSON.parse(event.data);
                if (data.method === 'resize' && typeof data.height === 'number') this.onEmbedHeightChange({
                    height: data.height
                });
            } catch (e) {}
        };
        this.onEmbedHeightChange = (data)=>{
            const { onHeightUpdate: onHeightUpdate } = this.props;
            const height = data.height + $fa07988e74fc1b7d$export$8f5a73ba0d077b01;
            onHeightUpdate(height);
        };
    }
}
module.exports["embedHeaderHeight"] = $fa07988e74fc1b7d$export$8f5a73ba0d077b01;
module.exports["EmbedResizeMessageListener"] = $fa07988e74fc1b7d$export$3482036c37e627f4;

});

parcelRegister("gbf0M", function(module, exports) {
const $5ba4766046c2d106$export$1de3504963fc32f2 = (datasource, url)=>{
    return {
        type: 'blockCard',
        attrs: {
            url: url,
            datasource: datasource
        }
    };
};
module.exports["buildDatasourceAdf"] = $5ba4766046c2d106$export$1de3504963fc32f2;

});

parcelRegister("3u1Hp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lPEt0 = parcelRequire("lPEt0");


var $bI14T = parcelRequire("bI14T");


var $j39Hd = parcelRequire("j39Hd");


var $c7dFC = parcelRequire("c7dFC");

const $adf5b0efff0513f5$var$URL_RESPONSE_CACHE_SIZE = 50;
const $adf5b0efff0513f5$export$f82fcd766a8daa7f = new (0, $lPEt0.LRUMap)($adf5b0efff0513f5$var$URL_RESPONSE_CACHE_SIZE);
const $adf5b0efff0513f5$export$40b1dd31340bd5c2 = new (0, $lPEt0.LRUMap)($adf5b0efff0513f5$var$URL_RESPONSE_CACHE_SIZE);
const $adf5b0efff0513f5$export$15cd58682efec5a5 = new (0, $lPEt0.LRUMap)($adf5b0efff0513f5$var$URL_RESPONSE_CACHE_SIZE);
const $adf5b0efff0513f5$export$5e074c0b68e2ce03 = 20;
const $adf5b0efff0513f5$export$7d812bb756889442 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(13);
    const { connections: t0 } = (0, $bI14T.useSmartLinkContext)();
    const { client: client } = t0;
    const resolverUrl = (0, $c7dFC.useResolverUrl)(client);
    const cachedRequest = $adf5b0efff0513f5$var$_temp;
    const uncachedRequest = $adf5b0efff0513f5$var$_temp2;
    let t1;
    if ($[0] !== resolverUrl) {
        t1 = async (datasourceId, data_1, t2)=>{
            const force_0 = t2 === undefined ? false : t2;
            return cachedRequest(datasourceId, data_1, `${resolverUrl}/datasource/${datasourceId}/fetch/details`, $adf5b0efff0513f5$export$f82fcd766a8daa7f, force_0);
        };
        $[0] = resolverUrl;
        $[1] = t1;
    } else t1 = $[1];
    const getDatasourceDetails = t1;
    let t2;
    if ($[2] !== resolverUrl) {
        t2 = async (datasourceId_0, data_2, t3)=>{
            const force_1 = t3 === undefined ? false : t3;
            return cachedRequest(datasourceId_0, data_2, `${resolverUrl}/datasource/${datasourceId_0}/fetch/data`, $adf5b0efff0513f5$export$40b1dd31340bd5c2, force_1);
        };
        $[2] = resolverUrl;
        $[3] = t2;
    } else t2 = $[3];
    const getDatasourceData = t2;
    let t3;
    if ($[4] !== resolverUrl) {
        t3 = async (data_3, t4)=>{
            const force_2 = t4 === undefined ? false : t4;
            const resolvedCacheIdKey = "datasourceId" in data_3 ? data_3.datasourceId : data_3.integrationKey;
            if (!resolvedCacheIdKey) throw new Error("No target was supplied to retrieve actions for");
            return cachedRequest(resolvedCacheIdKey, data_3, `${resolverUrl}/actions`, $adf5b0efff0513f5$export$15cd58682efec5a5, force_2);
        };
        $[4] = resolverUrl;
        $[5] = t3;
    } else t3 = $[5];
    const getDatasourceActionsAndPermissions = t3;
    let t4;
    if ($[6] !== resolverUrl) {
        t4 = async (data_4)=>uncachedRequest(data_4, `${resolverUrl}/actions/execute`);
        $[6] = resolverUrl;
        $[7] = t4;
    } else t4 = $[7];
    const executeAtomicAction = t4;
    const invalidateDatasourceDataCacheByAri = $adf5b0efff0513f5$var$_temp3;
    let t5;
    if ($[8] !== executeAtomicAction || $[9] !== getDatasourceActionsAndPermissions || $[10] !== getDatasourceData || $[11] !== getDatasourceDetails) {
        t5 = {
            getDatasourceDetails: getDatasourceDetails,
            getDatasourceData: getDatasourceData,
            getDatasourceActionsAndPermissions: getDatasourceActionsAndPermissions,
            executeAtomicAction: executeAtomicAction,
            invalidateDatasourceDataCacheByAri: invalidateDatasourceDataCacheByAri
        };
        $[8] = executeAtomicAction;
        $[9] = getDatasourceActionsAndPermissions;
        $[10] = getDatasourceData;
        $[11] = getDatasourceDetails;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ()=>{
    const { connections: { client: client } } = (0, $bI14T.useSmartLinkContext)();
    const resolverUrl = (0, $c7dFC.useResolverUrl)(client);
    const cachedRequest = async (cacheKeyId, data, url, lruMap, force)=>{
        const cacheKeyData = {
            ...data,
            // Sort fields to use cached version of response regardless of the order
            ...'fields' in data ? {
                fields: [
                    ...data.fields || []
                ].sort()
            } : {},
            ...'fieldKeys' in data ? {
                fieldKeys: [
                    ...data.fieldKeys || []
                ].sort()
            } : {}
        };
        const cacheKey = JSON.stringify({
            cacheKeyId: cacheKeyId,
            cacheKeyData: cacheKeyData
        });
        if (force) lruMap.delete(cacheKey);
        let responsePromise = lruMap.get(cacheKey);
        if (responsePromise) return responsePromise;
        const headers = {
            /**
       * This header exists to enable the backend to process relative time, eg: "today", with respect to user timezone.
       * eg: used in "confluence-object-provider" to process confluence SLLV requests to filter data for relative time.
       */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone
        };
        try {
            responsePromise = (0, $j39Hd.request)('post', url, data, headers, [
                200,
                201,
                202,
                203,
                204
            ]);
            lruMap.set(cacheKey, responsePromise);
            return await responsePromise;
        } catch (e) {
            lruMap.delete(cacheKey);
            throw e;
        }
    };
    const uncachedRequest = async (data_0, url_0)=>{
        const responsePromise_0 = (0, $j39Hd.request)('post', url_0, data_0, undefined, [
            200,
            201,
            202,
            203,
            204
        ]);
        return responsePromise_0;
    };
    const getDatasourceDetails = (0, $cozmU.useCallback)(async (datasourceId, data_1, force_0 = false)=>cachedRequest(datasourceId, data_1, `${resolverUrl}/datasource/${datasourceId}/fetch/details`, $adf5b0efff0513f5$export$f82fcd766a8daa7f, force_0), [
        resolverUrl
    ]);
    const getDatasourceData = (0, $cozmU.useCallback)(async (datasourceId_0, data_2, force_1 = false)=>cachedRequest(datasourceId_0, data_2, `${resolverUrl}/datasource/${datasourceId_0}/fetch/data`, $adf5b0efff0513f5$export$40b1dd31340bd5c2, force_1), [
        resolverUrl
    ]);
    const getDatasourceActionsAndPermissions = (0, $cozmU.useCallback)(async (data_3, force_2 = false)=>{
        const resolvedCacheIdKey = 'datasourceId' in data_3 ? data_3.datasourceId : data_3.integrationKey;
        // This is just to prevent empty string being passed up to ORS and causing issues.
        if (!resolvedCacheIdKey) throw new Error('No target was supplied to retrieve actions for');
        return cachedRequest(resolvedCacheIdKey, data_3, `${resolverUrl}/actions`, $adf5b0efff0513f5$export$15cd58682efec5a5, force_2);
    }, [
        resolverUrl
    ]);
    const executeAtomicAction = (0, $cozmU.useCallback)(async (data_4)=>uncachedRequest(data_4, `${resolverUrl}/actions/execute`), [
        resolverUrl
    ]);
    const invalidateDatasourceDataCacheByAri = (0, $cozmU.useCallback)((ari)=>{
        $adf5b0efff0513f5$export$40b1dd31340bd5c2.forEach(async (value, key)=>{
            const response = await value;
            const targetFound = response.data.items.some((item)=>{
                return item['ari']?.data === ari;
            });
            if (targetFound) $adf5b0efff0513f5$export$40b1dd31340bd5c2.delete(key);
        });
    }, []);
    return (0, $cozmU.useMemo)(()=>({
            getDatasourceDetails: getDatasourceDetails,
            getDatasourceData: getDatasourceData,
            getDatasourceActionsAndPermissions: getDatasourceActionsAndPermissions,
            executeAtomicAction: executeAtomicAction,
            invalidateDatasourceDataCacheByAri: invalidateDatasourceDataCacheByAri
        }), [
        getDatasourceDetails,
        getDatasourceData,
        getDatasourceActionsAndPermissions,
        executeAtomicAction,
        invalidateDatasourceDataCacheByAri
    ]);
};
async function $adf5b0efff0513f5$var$_temp(cacheKeyId, data, url, lruMap, force) {
    const cacheKeyData = {
        ...data,
        ..."fields" in data ? {
            fields: [
                ...data.fields || []
            ].sort()
        } : {},
        ..."fieldKeys" in data ? {
            fieldKeys: [
                ...data.fieldKeys || []
            ].sort()
        } : {}
    };
    const cacheKey = JSON.stringify({
        cacheKeyId: cacheKeyId,
        cacheKeyData: cacheKeyData
    });
    if (force) lruMap.delete(cacheKey);
    let responsePromise = lruMap.get(cacheKey);
    if (responsePromise) return responsePromise;
    const headers = {
        "origin-timezone": Intl?.DateTimeFormat().resolvedOptions().timeZone
    };
    try {
        responsePromise = (0, $j39Hd.request)("post", url, data, headers, [
            200,
            201,
            202,
            203,
            204
        ]);
        lruMap.set(cacheKey, responsePromise);
        return await responsePromise;
    } catch (t0) {
        const e = t0;
        lruMap.delete(cacheKey);
        throw e;
    }
}
async function $adf5b0efff0513f5$var$_temp2(data_0, url_0) {
    const responsePromise_0 = (0, $j39Hd.request)("post", url_0, data_0, undefined, [
        200,
        201,
        202,
        203,
        204
    ]);
    return responsePromise_0;
}
function $adf5b0efff0513f5$var$_temp3(ari) {
    $adf5b0efff0513f5$export$40b1dd31340bd5c2.forEach(async (value, key)=>{
        const response = await value;
        const targetFound = response.data.items.some((item)=>item.ari?.data === ari);
        if (targetFound) $adf5b0efff0513f5$export$40b1dd31340bd5c2.delete(key);
    });
}
module.exports["DEFAULT_GET_DATASOURCE_DATA_PAGE_SIZE"] = $adf5b0efff0513f5$export$5e074c0b68e2ce03;
module.exports["useDatasourceClientExtension"] = $adf5b0efff0513f5$export$7d812bb756889442;

});

parcelRegister("9f1Yt", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cMyWi = parcelRequire("cMyWi");

const $ec1ab019c54e6386$var$useContextMemoized = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useContextMemoized(reactContext) {
    const $ = (0, $bDgLe.c)(4);
    const value = (0, $cozmU.useContext)(reactContext);
    let t0;
    if ($[0] !== reactContext.Consumer || $[1] !== reactContext.Provider || $[2] !== value) {
        t0 = {
            Provider: reactContext.Provider,
            Consumer: reactContext.Consumer,
            value: value
        };
        $[0] = reactContext.Consumer;
        $[1] = reactContext.Provider;
        $[2] = value;
        $[3] = t0;
    } else t0 = $[3];
    const context = t0;
    return context;
} : function useContextMemoized(reactContext) {
    const value = (0, $cozmU.useContext)(reactContext);
    const context = (0, $cozmU.useMemo)(()=>({
            Provider: reactContext.Provider,
            Consumer: reactContext.Consumer,
            value: value
        }), [
        value,
        reactContext
    ]);
    return context;
};
const $ec1ab019c54e6386$export$10e9cca30e50f657 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $ec1ab019c54e6386$var$useContextMemoized((0, $cMyWi.SmartCardContext));
} : ()=>$ec1ab019c54e6386$var$useContextMemoized((0, $cMyWi.SmartCardContext));
module.exports["useSmartCardContext"] = $ec1ab019c54e6386$export$10e9cca30e50f657;

});

parcelRegister("dqxOF", function(module, exports) {
function $9c67ef4150ae4cb3$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $9c67ef4150ae4cb3$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $9c67ef4150ae4cb3$export$967a6b9924a689f7(a, b);
    return $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c(a, b);
}
 //# sourceMappingURL=index.modern.mjs.map
module.exports["shallowEqualObjects"] = $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c;

});

parcelRegister("dDboE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");

const $92e077c22efcc597$export$6be90bcb437e928f = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, postfix: postfix = '', prefix: prefix = '' }, ref)=>{
    const id = `${prefix}${(0, $6JrSr.useId)()}${postfix}`;
    (0, $cozmU.useEffect)(()=>{
        if (!ref) return;
        switch(typeof ref){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error(`Unreachable case for unsupported type of ref "${typeof ref}"`);
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: typeof children === 'function' ? children({
            id: id
        }) : children
    });
});
module.exports["IdProvider"] = $92e077c22efcc597$export$6be90bcb437e928f;

});

parcelRegister("1TlML", function(module, exports) {
function $cc70dd2ba0f00d0d$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
module.exports["mergeStyles"] = $cc70dd2ba0f00d0d$export$e618dc39ac9ad607;

});

parcelRegister("ez93V", function(module, exports) {

var $aqP4n = parcelRequire("aqP4n");

function $1d3bee4bc8d0b319$export$945a571f3b658bf(userData) {
    return userData[0, $aqP4n.uniqueKey] ?? null;
}
module.exports["extractClosestEdge"] = $1d3bee4bc8d0b319$export$945a571f3b658bf;

});

parcelRegister("aqP4n", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 

const $03a217ae6d97834d$export$4032e2468b38573b = Symbol('closestEdge');
module.exports["uniqueKey"] = $03a217ae6d97834d$export$4032e2468b38573b;

});

parcelRegister("endUL", function(module, exports) {

var $aqP4n = parcelRequire("aqP4n");

const $027caaee38fbe080$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
function $027caaee38fbe080$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $027caaee38fbe080$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [(0, $aqP4n.uniqueKey)]: addClosestEdge
    };
}
module.exports["attachClosestEdge"] = $027caaee38fbe080$export$f0cafff222395e89;

});

parcelRegister("4nIKB", function(module, exports) {

var $7ZH1D = parcelRequire("7ZH1D");


var $04KxR = parcelRequire("04KxR");

function $330c05f262f9f947$export$c9058316764c140e(refs) {
    return (0, $04KxR.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $7ZH1D.assignRef)(ref, newValue)));
}
module.exports["mergeRefs"] = $330c05f262f9f947$export$c9058316764c140e;

});

parcelRegister("04KxR", function(module, exports) {
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $00e47aba7bcb22e2$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}
module.exports["createCallbackRef"] = $00e47aba7bcb22e2$export$35a19128eb4acba4;

});

parcelRegister("cIWiw", function(module, exports) {
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $8d2daf016c36a388$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $8d2daf016c36a388$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $8d2daf016c36a388$var$tinyTransparentImage) nativeSetDragImage($8d2daf016c36a388$var$tinyTransparentImage, 0, 0);
}
module.exports["disableNativeDragPreview"] = $8d2daf016c36a388$export$c588cb30ff3b876e;

});

parcelRegister("1Ltep", function(module, exports) {
$parcel$export(module.exports, "default", () => $1490daf4e920e8da$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $1490daf4e920e8da$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("2iY37", function(module, exports) {
$parcel$export(module.exports, "default", () => $1adbd7c5d1b8dbaa$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $1Ltep = parcelRequire("1Ltep");


var $WeoLw = parcelRequire("WeoLw");


var $3yGK6 = parcelRequire("3yGK6");

function $1adbd7c5d1b8dbaa$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    return (0, $1Ltep.default)(date).getTime() === (0, $WeoLw.default)(date).getTime();
}

});

parcelRegister("WeoLw", function(module, exports) {
$parcel$export(module.exports, "default", () => $0af0962005736f62$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $0af0962005736f62$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("f21H2", function(module, exports) {

var $2xwXF = parcelRequire("2xwXF");


var $9H66G = parcelRequire("9H66G");


var $dz9dk = parcelRequire("dz9dk");

/**
 * Returns the resolved destination URL for a Smart Link, with cross-product analytics
 * parameters appended when applicable.
 *
 * This is the same URL that SmartCard would navigate to when clicked. Use this as an `href`
 * wherever you render a link to a Smart Link URL outside of the SmartCard component itself
 * (e.g. toolbar buttons, overlays).
 *
 * Falls back to the raw `url` when:
 * - The link has not yet resolved
 * - The link is not a first-party Atlassian link
 *
 * @example
 * const href = useSmartLinkDestinationUrl(url);
 *
 * Use as <a href={href} target="_blank">Open link</a>
 */ const $4f8ab10692e6efbc$export$30500dfe8339eafd = (url)=>{
    const state = (0, $9H66G.useSmartCardState)(url);
    const appendCrossProductAnalyticsParams = (0, $dz9dk.useSmartLinkCrossProductUrlWrapper)({
        details: state.details
    });
    const resolvedUrl = (0, $2xwXF.getClickUrl)(url, state.details);
    return appendCrossProductAnalyticsParams(resolvedUrl);
};
module.exports["useSmartLinkDestinationUrl"] = $4f8ab10692e6efbc$export$30500dfe8339eafd;

});

parcelRegister("kpg4X", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $kC6NK = parcelRequire("kC6NK");

const $277e2498b554872e$export$56ccbea3229cc4c3 = async (isProductInUnitsRollout)=>{
    // 1. Units GA killswitch.
    if (!(0, $iDrrr.fg)('cc-units-ga')) return false;
    // 2. This product's own rollout gates.
    if (!isProductInUnitsRollout()) return false;
    // 3. This organisation's actual units state, read from AGG once per page load.
    const { boundaryEnforced: boundaryEnforced, endUsersLaunched: endUsersLaunched } = await (0, $kC6NK.getUnitsRolloutSettings)();
    return endUsersLaunched && boundaryEnforced;
};
module.exports["shouldUseUnitCompliantApi"] = $277e2498b554872e$export$56ccbea3229cc4c3;

});

parcelRegister("kC6NK", function(module, exports) {
/**
 * Reads where the current organisation is in the units migration from AGG.
 *
 * It takes two queries, because the settings are keyed by org id and the browser only knows the
 * host it is served from: first resolve the host to an org id, then read that org's unit settings.
 *
 * Only `shouldUseUnitCompliantApi` should need this - see that file for how the result is used.
 */ 
var $j39Hd = parcelRequire("j39Hd");


var $9uAJX = parcelRequire("9uAJX");

const $09ebff3e34cc36dc$var$AGG_URL = '/gateway/api/graphql';
/**
 * The operation names are the ones `@atlaskit/link-datasource` already sends from production, and
 * they are deliberately kept as they are now that the caller has moved into this package: AGG side
 * observability - dashboards, per operation traffic and rate limiting - is keyed off them, so
 * renaming them would silently orphan it.
 */ const $09ebff3e34cc36dc$var$TENANT_CONTEXT_OPERATION_NAME = 'link_datasource_tenantContext';
const $09ebff3e34cc36dc$var$UNITS_ROLLOUT_SETTINGS_OPERATION_NAME = 'link_datasource_unitSettings';
/**
 * `Query.admin_unitSettings` is keyed by org id, which the browser does not know, so the org id
 * is resolved from the host the product is currently served from.
 */ const $09ebff3e34cc36dc$var$tenantContextQuery = `
	query ${$09ebff3e34cc36dc$var$TENANT_CONTEXT_OPERATION_NAME}($hostNames: [String!]) {
		tenantContexts(hostNames: $hostNames) {
			orgId
		}
	}
`;
/**
 * `admin_unitSettings` exposes both flags of the rollout and is callable with the session of the
 * end user, so no opt-in directive or admin OAuth scope is needed from the browser.
 */ const $09ebff3e34cc36dc$var$unitsRolloutSettingsQuery = `
	query ${$09ebff3e34cc36dc$var$UNITS_ROLLOUT_SETTINGS_OPERATION_NAME}($orgId: ID!) {
		admin_unitSettings(orgId: $orgId) {
			boundaryEnforced
			endUsersLaunched
		}
	}
`;
/**
 * When the rollout settings cannot be resolved we keep the pre-isolation behaviour, which is
 * what every org gets today while the unit settings are unset. The settings are only
 * written when an org is activated - they are not backfilled - so `null` is expected for orgs
 * that have not been activated yet and must be read as `false`.
 */ const $09ebff3e34cc36dc$var$DEFAULT_SETTINGS = {
    boundaryEnforced: false,
    endUsersLaunched: false
};
/**
 * AGG answers with a 200 and an `errors` array for query level failures, so those have to be
 * turned into a rejection explicitly rather than being read as an empty response.
 */ const $09ebff3e34cc36dc$var$requestGraphQL = async (operationName, query, variables)=>{
    const response = await (0, $j39Hd.request)('post', $09ebff3e34cc36dc$var$AGG_URL, {
        operationName: operationName,
        query: query,
        variables: variables
    });
    if (response?.errors?.length) {
        const messages = response.errors.map((error)=>error?.message).filter(Boolean).join(', ');
        throw new Error(`${operationName} failed: ${messages || 'unknown error'}`);
    }
    return response?.data ?? undefined;
};
const $09ebff3e34cc36dc$var$fetchOrgId = async ()=>{
    const hostName = typeof window !== 'undefined' ? window.location?.hostname : undefined;
    if (!hostName) return undefined;
    const data = await $09ebff3e34cc36dc$var$requestGraphQL($09ebff3e34cc36dc$var$TENANT_CONTEXT_OPERATION_NAME, $09ebff3e34cc36dc$var$tenantContextQuery, {
        hostNames: [
            hostName
        ]
    });
    for (const tenantContext of data?.tenantContexts ?? []){
        if (tenantContext?.orgId) return tenantContext.orgId;
    }
    return undefined;
};
const $09ebff3e34cc36dc$var$fetchUnitsRolloutSettings = async ()=>{
    const orgId = await $09ebff3e34cc36dc$var$fetchOrgId();
    if (!orgId) return $09ebff3e34cc36dc$var$DEFAULT_SETTINGS;
    const data = await $09ebff3e34cc36dc$var$requestGraphQL($09ebff3e34cc36dc$var$UNITS_ROLLOUT_SETTINGS_OPERATION_NAME, $09ebff3e34cc36dc$var$unitsRolloutSettingsQuery, {
        orgId: orgId
    });
    const settings = data?.admin_unitSettings;
    return {
        boundaryEnforced: settings?.boundaryEnforced ?? false,
        endUsersLaunched: settings?.endUsersLaunched ?? false
    };
};
const $09ebff3e34cc36dc$export$2523e3b63c956620 = ()=>{
    if (!(0, $9uAJX.cache).promise) (0, $9uAJX.cache).promise = $09ebff3e34cc36dc$var$fetchUnitsRolloutSettings().catch(()=>{
        (0, $9uAJX.cache).promise = undefined;
        return $09ebff3e34cc36dc$var$DEFAULT_SETTINGS;
    });
    return (0, $9uAJX.cache).promise;
};
module.exports["getUnitsRolloutSettings"] = $09ebff3e34cc36dc$export$2523e3b63c956620;

});

parcelRegister("9uAJX", function(module, exports) {
const $6f4e12ab20c1322c$export$69a3209f1a06c04d = {};
module.exports["cache"] = $6f4e12ab20c1322c$export$69a3209f1a06c04d;

});

parcelRegister("k5sGX", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9fa87e3de3aa88c$export$2e2bcd8739ae039);

var $jO73f = parcelRequire("jO73f");


var $3yGK6 = parcelRequire("3yGK6");


var $kr6hK = parcelRequire("kr6hK");

function $e9fa87e3de3aa88c$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $3yGK6.default)(1, arguments);
    var additionalDigits = (0, $kr6hK.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $e9fa87e3de3aa88c$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $e9fa87e3de3aa88c$var$parseYear(dateStrings.date, additionalDigits);
        date = $e9fa87e3de3aa88c$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $e9fa87e3de3aa88c$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $e9fa87e3de3aa88c$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $e9fa87e3de3aa88c$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $e9fa87e3de3aa88c$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $e9fa87e3de3aa88c$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $e9fa87e3de3aa88c$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $e9fa87e3de3aa88c$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($e9fa87e3de3aa88c$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($e9fa87e3de3aa88c$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($e9fa87e3de3aa88c$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $e9fa87e3de3aa88c$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $e9fa87e3de3aa88c$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $e9fa87e3de3aa88c$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($e9fa87e3de3aa88c$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $e9fa87e3de3aa88c$var$parseDateUnit(captures[1]);
    var month = $e9fa87e3de3aa88c$var$parseDateUnit(captures[2]) - 1;
    var day = $e9fa87e3de3aa88c$var$parseDateUnit(captures[3]);
    var week = $e9fa87e3de3aa88c$var$parseDateUnit(captures[4]);
    var dayOfWeek = $e9fa87e3de3aa88c$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$e9fa87e3de3aa88c$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $e9fa87e3de3aa88c$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$e9fa87e3de3aa88c$var$validateDate(year, month, day) || !$e9fa87e3de3aa88c$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $e9fa87e3de3aa88c$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $e9fa87e3de3aa88c$var$parseTime(timeString) {
    var captures = timeString.match($e9fa87e3de3aa88c$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $e9fa87e3de3aa88c$var$parseTimeUnit(captures[1]);
    var minutes = $e9fa87e3de3aa88c$var$parseTimeUnit(captures[2]);
    var seconds = $e9fa87e3de3aa88c$var$parseTimeUnit(captures[3]);
    if (!$e9fa87e3de3aa88c$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jO73f.millisecondsInHour) + minutes * (0, $jO73f.millisecondsInMinute) + seconds * 1000;
}
function $e9fa87e3de3aa88c$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $e9fa87e3de3aa88c$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($e9fa87e3de3aa88c$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$e9fa87e3de3aa88c$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jO73f.millisecondsInHour) + minutes * (0, $jO73f.millisecondsInMinute));
}
function $e9fa87e3de3aa88c$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $e9fa87e3de3aa88c$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $e9fa87e3de3aa88c$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $e9fa87e3de3aa88c$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($e9fa87e3de3aa88c$var$daysInMonths[month] || ($e9fa87e3de3aa88c$var$isLeapYearIndex(year) ? 29 : 28));
}
function $e9fa87e3de3aa88c$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($e9fa87e3de3aa88c$var$isLeapYearIndex(year) ? 366 : 365);
}
function $e9fa87e3de3aa88c$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $e9fa87e3de3aa88c$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $e9fa87e3de3aa88c$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("jO73f", function(module, exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e6b828148d99ab2b$export$dfd9b671c89acc8e = 7;
var $e6b828148d99ab2b$export$3913210603d8e9ae = 365.2425;
var $e6b828148d99ab2b$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e6b828148d99ab2b$export$91246f0b9bd9beff = 60000;
var $e6b828148d99ab2b$export$7f72910d6dfd237a = 3600000;
var $e6b828148d99ab2b$export$397c2d5776aa9055 = 1000;
var $e6b828148d99ab2b$export$4dec998e48f9c246 = -$e6b828148d99ab2b$export$81caae6e1cc7a622;
var $e6b828148d99ab2b$export$f2f5ae5a8e2d8f9f = 60;
var $e6b828148d99ab2b$export$3c58128db900d44e = 3;
var $e6b828148d99ab2b$export$80d7e435f744f319 = 12;
var $e6b828148d99ab2b$export$4db7641526e3241f = 4;
var $e6b828148d99ab2b$export$698aec755e92c695 = 3600;
var $e6b828148d99ab2b$export$a77c1a7ebebe2a5a = 60;
var $e6b828148d99ab2b$export$815a9362476d2fe3 = $e6b828148d99ab2b$export$698aec755e92c695 * 24;
var $e6b828148d99ab2b$export$34804a017b31e2fe = $e6b828148d99ab2b$export$815a9362476d2fe3 * 7;
var $e6b828148d99ab2b$export$7271e9e3478110d1 = $e6b828148d99ab2b$export$815a9362476d2fe3 * $e6b828148d99ab2b$export$3913210603d8e9ae;
var $e6b828148d99ab2b$export$8e6600bbdee7dabb = $e6b828148d99ab2b$export$7271e9e3478110d1 / 12;
var $e6b828148d99ab2b$export$be1dccf2de902d31 = $e6b828148d99ab2b$export$8e6600bbdee7dabb * 3;
module.exports["millisecondsInMinute"] = $e6b828148d99ab2b$export$91246f0b9bd9beff;
module.exports["millisecondsInHour"] = $e6b828148d99ab2b$export$7f72910d6dfd237a;
module.exports["millisecondsInSecond"] = $e6b828148d99ab2b$export$397c2d5776aa9055;

});

parcelRegister("3vMGL", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $5vwoh = parcelRequire("5vwoh");


var $bdgrV = parcelRequire("bdgrV");


var $gcCeq = parcelRequire("gcCeq");


var $a7dWT = parcelRequire("a7dWT");

const $a25ace4035d13584$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $5vwoh.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>getDays(weekStartDay, 'short');
    const getDaysLong = (weekStartDay = 0)=>getDays(weekStartDay, 'long');
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $bdgrV.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
     * Safari has a bug that returns the wrong month for years 2005 and before.
     * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
     * Not all the months fail in each year. To ensure the correct output,
     * we select 2020 as the base year for the whole date,
     * then we replace in the result the original input year
     */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $a7dWT.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $a7dWT.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
     * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
     * We fix it by detecting the real time with getHours method
     */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    let intlLocale;
    const getFirstDayOfWeek = ()=>{
        if (!(0, $iDrrr.fg)('platform-dst-locale-week-start-day')) return 0;
        if (!intlLocale) intlLocale = new Intl.Locale(normalizedLocale);
        const weekInfo = (0, $gcCeq.getWeekInfo)(intlLocale);
        // Intl uses ISO weekdays (1 = Monday … 7 = Sunday).
        // Calendar / getDays* use JS weekdays (0 = Sunday … 6 = Saturday).
        return weekInfo.firstDay % 7;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts,
        getFirstDayOfWeek: getFirstDayOfWeek
    };
};
module.exports["createLocalizationProvider"] = $a25ace4035d13584$export$ea56ca58f08ffa52;

});

parcelRegister("5vwoh", function(module, exports) {
const $f2dacbe0eea831b8$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');
module.exports["normalizeLocale"] = $f2dacbe0eea831b8$export$dca0327c9b9c6498;

});

parcelRegister("bdgrV", function(module, exports) {

var $5vwoh = parcelRequire("5vwoh");


var $kGZoG = parcelRequire("kGZoG");


var $8w4cs = parcelRequire("8w4cs");


var $cafP2 = parcelRequire("cafP2");

const $8d32407758572e3f$var$INVALID_DATE = new Date(NaN);
const $8d32407758572e3f$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $8d32407758572e3f$var$INVARIANT_DATE = (0, $cafP2.toDate)($8d32407758572e3f$var$INVARIANT);
const $8d32407758572e3f$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $8d32407758572e3f$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $8d32407758572e3f$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $8d32407758572e3f$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $8d32407758572e3f$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $5vwoh.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($8d32407758572e3f$var$INVARIANT_DATE);
    const shortDate = $8d32407758572e3f$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($8d32407758572e3f$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $8d32407758572e3f$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($8d32407758572e3f$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($8d32407758572e3f$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($8d32407758572e3f$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $8d32407758572e3f$var$stripExtras(date).match($8d32407758572e3f$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $8d32407758572e3f$var$INVALID_DATE;
        const dateParts = $8d32407758572e3f$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $8w4cs.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $kGZoG.isValid)(normalizedDate)) return $8d32407758572e3f$var$INVALID_DATE;
        return (0, $cafP2.toDate)(normalizedDate);
    };
};
module.exports["createDateParser"] = $8d32407758572e3f$export$cfa2ef2687faeda2;

});

parcelRegister("kGZoG", function(module, exports) {

var $aDvYS = parcelRequire("aDvYS");

const $8985e2fc067d563b$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = (0, $aDvYS.getDaysInMonth)(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
module.exports["isValid"] = $8985e2fc067d563b$export$1ea939691cdc45b8;

});

parcelRegister("aDvYS", function(module, exports) {

var $6NKSh = parcelRequire("6NKSh");

const $e96e8b0ab312aaba$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && (0, $6NKSh.isLeapYear)(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
module.exports["getDaysInMonth"] = $e96e8b0ab312aaba$export$f645ddd439eb259d;

});

parcelRegister("6NKSh", function(module, exports) {
const $04f001925dc3d06f$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
module.exports["isLeapYear"] = $04f001925dc3d06f$export$553d7fa8e3805fc0;

});

parcelRegister("8w4cs", function(module, exports) {

var $9tavx = parcelRequire("9tavx");

const $7e5174e81eb823af$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = (0, $9tavx.toDateObj)(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};
module.exports["normalizeDate"] = $7e5174e81eb823af$export$fcc71269590ba0a8;

});

parcelRegister("9tavx", function(module, exports) {
const $4b828859bff16031$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
module.exports["toDateObj"] = $4b828859bff16031$export$abe96da78d4f59dd;

});

parcelRegister("cafP2", function(module, exports) {
const $70268879eaf1b092$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
module.exports["toDate"] = $70268879eaf1b092$export$e67a095c620b86fe;

});

parcelRegister("gcCeq", function(module, exports) {
// Regional exceptions from Unicode CLDR 48; all other regions use Monday.
// https://github.com/unicode-org/cldr-json/blob/48.0.0/cldr-json/cldr-core/supplemental/weekData.json
const $afacfd87857de827$var$firstDays = {
    AF: 6,
    AG: 7,
    AS: 7,
    BD: 7,
    BH: 6,
    BR: 7,
    BS: 7,
    BT: 7,
    BW: 7,
    BZ: 7,
    CA: 7,
    CO: 7,
    DJ: 6,
    DM: 7,
    DO: 7,
    DZ: 6,
    EG: 6,
    ET: 7,
    GT: 7,
    GU: 7,
    HK: 7,
    HN: 7,
    ID: 7,
    IL: 7,
    IN: 7,
    IQ: 6,
    IR: 6,
    IS: 7,
    JM: 7,
    JO: 6,
    JP: 7,
    KE: 7,
    KH: 7,
    KR: 7,
    KW: 6,
    LA: 7,
    LY: 6,
    MH: 7,
    MM: 7,
    MO: 7,
    MT: 7,
    MV: 5,
    MX: 7,
    MZ: 7,
    NI: 7,
    NP: 7,
    OM: 6,
    PA: 7,
    PE: 7,
    PH: 7,
    PK: 7,
    PR: 7,
    PT: 7,
    PY: 7,
    QA: 6,
    SA: 7,
    SD: 6,
    SG: 7,
    SV: 7,
    SY: 6,
    TH: 7,
    TT: 7,
    TW: 7,
    UM: 7,
    US: 7,
    VE: 7,
    VI: 7,
    WS: 7,
    YE: 7,
    ZA: 7,
    ZW: 7
};
// Only regular territories may override a locale's region (CLDR 48 region validity data).
// https://github.com/unicode-org/cldr/blob/release-48/common/validity/region.xml
const $afacfd87857de827$var$regularRegions = new Set([
    'AC AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF',
    'BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH',
    'CI CK CL CM CN CO CP CQ CR CU CV CW CX CY CZ DE DG DJ DK DM DO DZ',
    'EA EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI',
    'GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU IC ID IE IL IM',
    'IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA',
    'LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO',
    'MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU',
    'NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW',
    'SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TA',
    'TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ',
    'VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW'
].join(' ').split(' '));
// Read only Unicode keywords, excluding other extensions and private-use subtags.
const $afacfd87857de827$var$getUnicodeKeyword = (locale, key)=>{
    const extensions = locale.toString().split('-');
    const start = extensions.indexOf('u');
    const privateUse = extensions.indexOf('x');
    if (start === -1 || privateUse !== -1 && privateUse < start) return undefined;
    for(let index = start + 1; index < extensions.length; index++){
        if (extensions[index].length === 1) break;
        if (extensions[index] === key) {
            const value = [];
            while(extensions[index + 1]?.length > 2)value.push(extensions[++index]);
            return value.join('-');
        }
    }
    return undefined;
};
// Canonicalize aliases before rejecting unknown, private-use, and macroregion overrides.
const $afacfd87857de827$var$getOverrideRegion = (value)=>{
    if (!value) return undefined;
    const region = new Intl.Locale(`und-${value}`).region;
    return region && $afacfd87857de827$var$regularRegions.has(region) ? region : undefined;
};
const $afacfd87857de827$export$837830ce0c77272 = (locale)=>{
    if (typeof locale.getWeekInfo === 'function') return locale.getWeekInfo();
    const legacyWeekInfo = locale.weekInfo;
    if (legacyWeekInfo) return legacyWeekInfo;
    const regionOverride = $afacfd87857de827$var$getOverrideRegion($afacfd87857de827$var$getUnicodeKeyword(locale, 'rg')?.match(/^([a-z]{2}|[0-9]{3})zzzz$/)?.[1]);
    const subdivision = $afacfd87857de827$var$getOverrideRegion($afacfd87857de827$var$getUnicodeKeyword(locale, 'sd')?.match(/^([a-z]{2}|[0-9]{3})[a-z0-9]+$/)?.[1]);
    const region = regionOverride || locale.region || subdivision || locale.maximize().region || '001';
    const preferredDay = [
        'mon',
        'tue',
        'wed',
        'thu',
        'fri',
        'sat',
        'sun'
    ].indexOf($afacfd87857de827$var$getUnicodeKeyword(locale, 'fw') || '');
    const firstDay = preferredDay !== -1 ? preferredDay + 1 : !regionOverride && locale.calendar === 'iso8601' ? 1 : $afacfd87857de827$var$firstDays[region] || 1;
    return {
        firstDay: firstDay
    };
};
module.exports["getWeekInfo"] = $afacfd87857de827$export$837830ce0c77272;

});

parcelRegister("a7dWT", function(module, exports) {
const $13d20959c22b69ba$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});
module.exports["toFormattedParts"] = $13d20959c22b69ba$export$9b7ca29af37c192;

});

parcelRegister("hSoEi", function(module, exports) {
$parcel$export(module.exports, "default", () => $d03a99980e3dbd9b$export$2e2bcd8739ae039);

var $68pA8 = parcelRequire("68pA8");


var $aTPTV = parcelRequire("aTPTV");


var $8SGej = parcelRequire("8SGej");


var $5Q0Vq = parcelRequire("5Q0Vq");


var $dkBOe = parcelRequire("dkBOe");


var $jrCh2 = parcelRequire("jrCh2");


var $761RI = parcelRequire("761RI");


var $j90Gh = parcelRequire("j90Gh");


var $itDH4 = parcelRequire("itDH4");


var $kr6hK = parcelRequire("kr6hK");


var $3yGK6 = parcelRequire("3yGK6");


var $5KqMf = parcelRequire("5KqMf");


var $erRVM = parcelRequire("erRVM");


var $4m74k = parcelRequire("4m74k");

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $d03a99980e3dbd9b$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $d03a99980e3dbd9b$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $d03a99980e3dbd9b$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $d03a99980e3dbd9b$var$doubleQuoteRegExp = /''/g;
var $d03a99980e3dbd9b$var$notWhitespaceRegExp = /\S/;
var $d03a99980e3dbd9b$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $d03a99980e3dbd9b$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $3yGK6.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $4m74k.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $8SGej.default);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, $kr6hK.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $kr6hK.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $dkBOe.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $5KqMf.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match($d03a99980e3dbd9b$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $761RI.default)) {
            var longFormatter = (0, $761RI.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($d03a99980e3dbd9b$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $aTPTV.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $itDH4.isProtectedWeekYearToken)(token)) (0, $itDH4.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $itDH4.isProtectedDayOfYearToken)(token)) (0, $itDH4.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $erRVM.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($d03a99980e3dbd9b$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $d03a99980e3dbd9b$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $68pA8.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $d03a99980e3dbd9b$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $dkBOe.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $5Q0Vq.default)(date, (0, $j90Gh.default)(date));
    var flags = {};
    var _iterator2 = (0, $aTPTV.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $jrCh2.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $d03a99980e3dbd9b$var$cleanEscapedString(input) {
    return input.match($d03a99980e3dbd9b$var$escapedStringRegExp)[1].replace($d03a99980e3dbd9b$var$doubleQuoteRegExp, "'");
}

});

parcelRegister("aTPTV", function(module, exports) {

var $ivJm4 = parcelRequire("ivJm4");

function $7ef74ce90da10ddf$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $ivJm4.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
module.exports["default"] = $7ef74ce90da10ddf$export$2e2bcd8739ae039;

});

parcelRegister("ivJm4", function(module, exports) {

var $kL2zH = parcelRequire("kL2zH");

function $d79e4dd1e790fb08$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $kL2zH.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $kL2zH.default)(r, a) : void 0;
    }
}
module.exports["default"] = $d79e4dd1e790fb08$export$2e2bcd8739ae039;

});

parcelRegister("kL2zH", function(module, exports) {
function $f1ca31bcf83fc566$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports["default"] = $f1ca31bcf83fc566$export$2e2bcd8739ae039;

});

parcelRegister("jrCh2", function(module, exports) {
$parcel$export(module.exports, "default", () => $e27e3a4c5ffdab0c$export$2e2bcd8739ae039);
function $e27e3a4c5ffdab0c$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

});

parcelRegister("5KqMf", function(module, exports) {

var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $ccS36 = parcelRequire("ccS36");

var $42f6050afbbf6d25$var$TIMEZONE_UNIT_PRIORITY = 10;
var $42f6050afbbf6d25$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $g6rNx.default)(this, Setter);
        (0, $ccS36.default)(this, "priority", void 0);
        (0, $ccS36.default)(this, "subPriority", 0);
    }
    (0, $61VNy.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $42f6050afbbf6d25$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $8Npt5.default)(ValueSetter, _Setter);
    var _super = (0, $kUYG8.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $g6rNx.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $61VNy.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($42f6050afbbf6d25$export$81d53e3678089a6);
var $42f6050afbbf6d25$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $8Npt5.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $kUYG8.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $g6rNx.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this2), "priority", $42f6050afbbf6d25$var$TIMEZONE_UNIT_PRIORITY);
        (0, $ccS36.default)((0, $fPHWO.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $61VNy.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($42f6050afbbf6d25$export$81d53e3678089a6);
module.exports["ValueSetter"] = $42f6050afbbf6d25$export$9a09e32dd4990fd5;
module.exports["DateToSystemTimezoneSetter"] = $42f6050afbbf6d25$export$5aaf7ff7f09ea4ee;

});

parcelRegister("fPHWO", function(module, exports) {
function $b86db58908ab3a21$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports["default"] = $b86db58908ab3a21$export$2e2bcd8739ae039;

});

parcelRegister("8Npt5", function(module, exports) {

var $1o91h = parcelRequire("1o91h");

function $6676a7c55fc90fae$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $1o91h.default)(t, e);
}
module.exports["default"] = $6676a7c55fc90fae$export$2e2bcd8739ae039;

});

parcelRegister("kUYG8", function(module, exports) {

var $3LZzv = parcelRequire("3LZzv");


var $1nPNx = parcelRequire("1nPNx");


var $3luEO = parcelRequire("3luEO");

function $f3a81b1c3407c48d$export$2e2bcd8739ae039(t) {
    var r = (0, $1nPNx.default)();
    return function() {
        var e, o = (0, $3LZzv.default)(t);
        if (r) {
            var s = (0, $3LZzv.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $3luEO.default)(this, e);
    };
}
module.exports["default"] = $f3a81b1c3407c48d$export$2e2bcd8739ae039;

});

parcelRegister("3LZzv", function(module, exports) {
$parcel$export(module.exports, "default", () => $2bf585bebcf0d07d$export$2e2bcd8739ae039);
function $2bf585bebcf0d07d$export$2e2bcd8739ae039(t) {
    return $2bf585bebcf0d07d$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $2bf585bebcf0d07d$export$2e2bcd8739ae039(t);
}

});

parcelRegister("1nPNx", function(module, exports) {
$parcel$export(module.exports, "default", () => $10201e6b86fc7175$export$2e2bcd8739ae039);
function $10201e6b86fc7175$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($10201e6b86fc7175$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("3luEO", function(module, exports) {

var $68pA8 = parcelRequire("68pA8");


var $fPHWO = parcelRequire("fPHWO");

function $26fb1d235b43c874$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $68pA8.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $fPHWO.default)(t);
}
module.exports["default"] = $26fb1d235b43c874$export$2e2bcd8739ae039;

});

parcelRegister("g6rNx", function(module, exports) {
function $bb92c4fc742f9d95$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports["default"] = $bb92c4fc742f9d95$export$2e2bcd8739ae039;

});

parcelRegister("61VNy", function(module, exports) {

var $kSfw9 = parcelRequire("kSfw9");

function $463fab9b5f038fe4$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $kSfw9.default)(o.key), o);
    }
}
function $463fab9b5f038fe4$export$2e2bcd8739ae039(e, r, t) {
    return r && $463fab9b5f038fe4$var$_defineProperties(e.prototype, r), t && $463fab9b5f038fe4$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports["default"] = $463fab9b5f038fe4$export$2e2bcd8739ae039;

});

parcelRegister("erRVM", function(module, exports) {

var $eC4Z9 = parcelRequire("eC4Z9");


var $712Vg = parcelRequire("712Vg");


var $dxXTH = parcelRequire("dxXTH");


var $88ORV = parcelRequire("88ORV");


var $gZ5xM = parcelRequire("gZ5xM");


var $jHpOc = parcelRequire("jHpOc");


var $hKLEL = parcelRequire("hKLEL");


var $2osza = parcelRequire("2osza");


var $eoc6L = parcelRequire("eoc6L");


var $9P2ZO = parcelRequire("9P2ZO");


var $6zqt8 = parcelRequire("6zqt8");


var $gaEPf = parcelRequire("gaEPf");


var $2zfZV = parcelRequire("2zfZV");


var $iSCOI = parcelRequire("iSCOI");


var $6ku3j = parcelRequire("6ku3j");


var $gxgDD = parcelRequire("gxgDD");


var $jE6Oy = parcelRequire("jE6Oy");


var $j28KI = parcelRequire("j28KI");


var $djpXE = parcelRequire("djpXE");


var $7Nf6S = parcelRequire("7Nf6S");


var $9UQOD = parcelRequire("9UQOD");


var $ael3l = parcelRequire("ael3l");


var $6M1cG = parcelRequire("6M1cG");


var $cAMvE = parcelRequire("cAMvE");


var $4mDmT = parcelRequire("4mDmT");


var $bLXDl = parcelRequire("bLXDl");


var $1kRDS = parcelRequire("1kRDS");


var $iRtG4 = parcelRequire("iRtG4");


var $62f5E = parcelRequire("62f5E");


var $bQs8D = parcelRequire("bQs8D");


var $26OJt = parcelRequire("26OJt");

var $a84d6be113196c14$export$19131010e7fd8373 = {
    G: new (0, $eC4Z9.EraParser)(),
    y: new (0, $712Vg.YearParser)(),
    Y: new (0, $dxXTH.LocalWeekYearParser)(),
    R: new (0, $88ORV.ISOWeekYearParser)(),
    u: new (0, $gZ5xM.ExtendedYearParser)(),
    Q: new (0, $jHpOc.QuarterParser)(),
    q: new (0, $hKLEL.StandAloneQuarterParser)(),
    M: new (0, $2osza.MonthParser)(),
    L: new (0, $eoc6L.StandAloneMonthParser)(),
    w: new (0, $9P2ZO.LocalWeekParser)(),
    I: new (0, $6zqt8.ISOWeekParser)(),
    d: new (0, $gaEPf.DateParser)(),
    D: new (0, $2zfZV.DayOfYearParser)(),
    E: new (0, $iSCOI.DayParser)(),
    e: new (0, $6ku3j.LocalDayParser)(),
    c: new (0, $gxgDD.StandAloneLocalDayParser)(),
    i: new (0, $jE6Oy.ISODayParser)(),
    a: new (0, $j28KI.AMPMParser)(),
    b: new (0, $djpXE.AMPMMidnightParser)(),
    B: new (0, $7Nf6S.DayPeriodParser)(),
    h: new (0, $9UQOD.Hour1to12Parser)(),
    H: new (0, $ael3l.Hour0to23Parser)(),
    K: new (0, $6M1cG.Hour0To11Parser)(),
    k: new (0, $cAMvE.Hour1To24Parser)(),
    m: new (0, $4mDmT.MinuteParser)(),
    s: new (0, $bLXDl.SecondParser)(),
    S: new (0, $1kRDS.FractionOfSecondParser)(),
    X: new (0, $iRtG4.ISOTimezoneWithZParser)(),
    x: new (0, $62f5E.ISOTimezoneParser)(),
    t: new (0, $bQs8D.TimestampSecondsParser)(),
    T: new (0, $26OJt.TimestampMillisecondsParser)()
};
module.exports["parsers"] = $a84d6be113196c14$export$19131010e7fd8373;

});

parcelRegister("eC4Z9", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");

var $aa387b4ba4d3e124$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(EraParser, _Parser);
    var _super = (0, $kUYG8.default)(EraParser);
    function EraParser() {
        var _this;
        (0, $g6rNx.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 140);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $27tFE.Parser));
module.exports["EraParser"] = $aa387b4ba4d3e124$export$8e5a1d3f85a9688;

});

parcelRegister("27tFE", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $ccS36 = parcelRequire("ccS36");


var $5KqMf = parcelRequire("5KqMf");

var $18b340333eececf0$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $g6rNx.default)(this, Parser);
        (0, $ccS36.default)(this, "incompatibleTokens", void 0);
        (0, $ccS36.default)(this, "priority", void 0);
        (0, $ccS36.default)(this, "subPriority", void 0);
    }
    (0, $61VNy.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $5KqMf.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();
module.exports["Parser"] = $18b340333eececf0$export$7acfa6ed01010e37;

});

parcelRegister("712Vg", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $51bae4cb1fda6d08$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(YearParser, _Parser);
    var _super = (0, $kUYG8.default)(YearParser);
    function YearParser() {
        var _this;
        (0, $g6rNx.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 130);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNDigits)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, $5GO7m.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $5GO7m.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $27tFE.Parser));
module.exports["YearParser"] = $51bae4cb1fda6d08$export$48d352de7cd4a988;

});

parcelRegister("5GO7m", function(module, exports) {

var $jO73f = parcelRequire("jO73f");


var $f50NU = parcelRequire("f50NU");

function $4247c0569b65af7c$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $4247c0569b65af7c$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $4247c0569b65af7c$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $jO73f.millisecondsInHour) + minutes * (0, $jO73f.millisecondsInMinute) + seconds * (0, $jO73f.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $4247c0569b65af7c$export$d931c43c4608a164(dateString) {
    return $4247c0569b65af7c$export$cc7cc9e2a3ff9388((0, $f50NU.numericPatterns).anyDigitsSigned, dateString);
}
function $4247c0569b65af7c$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388((0, $f50NU.numericPatterns).singleDigit, dateString);
        case 2:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388((0, $f50NU.numericPatterns).twoDigits, dateString);
        case 3:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388((0, $f50NU.numericPatterns).threeDigits, dateString);
        case 4:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388((0, $f50NU.numericPatterns).fourDigits, dateString);
        default:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function $4247c0569b65af7c$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388((0, $f50NU.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388((0, $f50NU.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388((0, $f50NU.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388((0, $f50NU.numericPatterns).fourDigitsSigned, dateString);
        default:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function $4247c0569b65af7c$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $4247c0569b65af7c$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $4247c0569b65af7c$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
module.exports["mapValue"] = $4247c0569b65af7c$export$4f84e3a82c7b538;
module.exports["parseNumericPattern"] = $4247c0569b65af7c$export$cc7cc9e2a3ff9388;
module.exports["parseTimezonePattern"] = $4247c0569b65af7c$export$6497f4c0ecdfba8e;
module.exports["parseAnyDigitsSigned"] = $4247c0569b65af7c$export$d931c43c4608a164;
module.exports["parseNDigits"] = $4247c0569b65af7c$export$513bb01536146ab6;
module.exports["parseNDigitsSigned"] = $4247c0569b65af7c$export$2c9307b2e29c533c;
module.exports["dayPeriodEnumToHours"] = $4247c0569b65af7c$export$fb506d2676e7f207;
module.exports["normalizeTwoDigitYear"] = $4247c0569b65af7c$export$29126f735cbf69f7;
module.exports["isLeapYearIndex"] = $4247c0569b65af7c$export$3d50627710b84d75;

});

parcelRegister("f50NU", function(module, exports) {
var $afa7f24e905606cc$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $afa7f24e905606cc$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
module.exports["numericPatterns"] = $afa7f24e905606cc$export$c123ee06d9da8480;
module.exports["timezonePatterns"] = $afa7f24e905606cc$export$a7ee192b982af9c1;

});

parcelRegister("dxXTH", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");


var $a8KF2 = parcelRequire("a8KF2");


var $37zWd = parcelRequire("37zWd");

var $9dccd1cb7e1e332d$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(LocalWeekYearParser, _Parser);
    var _super = (0, $kUYG8.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $g6rNx.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 130);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNDigits)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, $5GO7m.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $a8KF2.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $5GO7m.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $37zWd.default)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $37zWd.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $27tFE.Parser));
module.exports["LocalWeekYearParser"] = $9dccd1cb7e1e332d$export$b8ef38dfcf05d5db;

});

parcelRegister("88ORV", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");


var $87l2G = parcelRequire("87l2G");

var $5ed68794bfbcfe16$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(ISOWeekYearParser, _Parser);
    var _super = (0, $kUYG8.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $g6rNx.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 130);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, $5GO7m.parseNDigitsSigned)(4, dateString);
                return (0, $5GO7m.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $87l2G.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $27tFE.Parser));
module.exports["ISOWeekYearParser"] = $5ed68794bfbcfe16$export$951d1df011fde06f;

});

parcelRegister("gZ5xM", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $c5d6a4ba42a42bbe$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(ExtendedYearParser, _Parser);
    var _super = (0, $kUYG8.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $g6rNx.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 130);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, $5GO7m.parseNDigitsSigned)(4, dateString);
                return (0, $5GO7m.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $27tFE.Parser));
module.exports["ExtendedYearParser"] = $c5d6a4ba42a42bbe$export$bad9d2ea38e8f1a;

});

parcelRegister("jHpOc", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $e5760d85672313f9$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(QuarterParser, _Parser);
    var _super = (0, $kUYG8.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $g6rNx.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 120);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $27tFE.Parser));
module.exports["QuarterParser"] = $e5760d85672313f9$export$5cb0f701186dde1d;

});

parcelRegister("hKLEL", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $cecbb3253193993a$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, $kUYG8.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $g6rNx.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 120);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $27tFE.Parser));
module.exports["StandAloneQuarterParser"] = $cecbb3253193993a$export$300c0c2990e20e6d;

});

parcelRegister("2osza", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $5GO7m = parcelRequire("5GO7m");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");

var $1be3fb4bd2727d42$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(MonthParser, _Parser);
    var _super = (0, $kUYG8.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $g6rNx.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 110);
        return _this;
    }
    (0, $61VNy.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, $5GO7m.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $27tFE.Parser));
module.exports["MonthParser"] = $1be3fb4bd2727d42$export$400dd8b40ef138a3;

});

parcelRegister("eoc6L", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $a79cb2fe3699b3ad$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(StandAloneMonthParser, _Parser);
    var _super = (0, $kUYG8.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $g6rNx.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 110);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, $5GO7m.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $27tFE.Parser));
module.exports["StandAloneMonthParser"] = $a79cb2fe3699b3ad$export$1d7eaa53eaa5deba;

});

parcelRegister("9P2ZO", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");


var $2lVoT = parcelRequire("2lVoT");


var $37zWd = parcelRequire("37zWd");

var $726b33645464efcb$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(LocalWeekParser, _Parser);
    var _super = (0, $kUYG8.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $g6rNx.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 100);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $37zWd.default)((0, $2lVoT.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $27tFE.Parser));
module.exports["LocalWeekParser"] = $726b33645464efcb$export$c4005ffc174e07c0;

});

parcelRegister("2lVoT", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b6a117e7c1f54a1$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $dkBOe = parcelRequire("dkBOe");


var $5QkXN = parcelRequire("5QkXN");


var $3yGK6 = parcelRequire("3yGK6");

function $1b6a117e7c1f54a1$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var week = (0, $kr6hK.default)(dirtyWeek);
    var diff = (0, $5QkXN.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});

parcelRegister("6zqt8", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");


var $dnRFE = parcelRequire("dnRFE");


var $87l2G = parcelRequire("87l2G");

var $4c8a8b2857ddf8f8$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(ISOWeekParser, _Parser);
    var _super = (0, $kUYG8.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $g6rNx.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 100);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $87l2G.default)((0, $dnRFE.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $27tFE.Parser));
module.exports["ISOWeekParser"] = $4c8a8b2857ddf8f8$export$6fc8dbedd560a6af;

});

parcelRegister("dnRFE", function(module, exports) {
$parcel$export(module.exports, "default", () => $9be70e3cbf57652f$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $dkBOe = parcelRequire("dkBOe");


var $f46XZ = parcelRequire("f46XZ");


var $3yGK6 = parcelRequire("3yGK6");

function $9be70e3cbf57652f$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var isoWeek = (0, $kr6hK.default)(dirtyISOWeek);
    var diff = (0, $f46XZ.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});

parcelRegister("gaEPf", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $5GO7m = parcelRequire("5GO7m");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");

var $bc5d3f9bf50740b1$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $bc5d3f9bf50740b1$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $bc5d3f9bf50740b1$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(DateParser, _Parser);
    var _super = (0, $kUYG8.default)(DateParser);
    function DateParser() {
        var _this;
        (0, $g6rNx.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 90);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "subPriority", 1);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $5GO7m.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $bc5d3f9bf50740b1$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $bc5d3f9bf50740b1$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $27tFE.Parser));
module.exports["DateParser"] = $bc5d3f9bf50740b1$export$e8d4b28a20981dd2;

});

parcelRegister("2zfZV", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $1deb4275d03bcc29$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(DayOfYearParser, _Parser);
    var _super = (0, $kUYG8.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $g6rNx.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 90);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "subpriority", 1);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $5GO7m.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $27tFE.Parser));
module.exports["DayOfYearParser"] = $1deb4275d03bcc29$export$6cfe0d613455f615;

});

parcelRegister("iSCOI", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $7EDfs = parcelRequire("7EDfs");

var $dbeb6164992582c5$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(DayParser, _Parser);
    var _super = (0, $kUYG8.default)(DayParser);
    function DayParser() {
        var _this;
        (0, $g6rNx.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 90);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $7EDfs.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $27tFE.Parser));
module.exports["DayParser"] = $dbeb6164992582c5$export$1b03c8b76262f7bd;

});

parcelRegister("7EDfs", function(module, exports) {
$parcel$export(module.exports, "default", () => $592ab6bea6499494$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");


var $kr6hK = parcelRequire("kr6hK");


var $4m74k = parcelRequire("4m74k");

function $592ab6bea6499494$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $3yGK6.default)(2, arguments);
    var defaultOptions = (0, $4m74k.getDefaultOptions)();
    var weekStartsOn = (0, $kr6hK.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $dkBOe.default)(dirtyDate);
    var day = (0, $kr6hK.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});

parcelRegister("6ku3j", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");


var $7EDfs = parcelRequire("7EDfs");

var $49bbec1a392484db$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(LocalDayParser, _Parser);
    var _super = (0, $kUYG8.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $g6rNx.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 90);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, $5GO7m.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $7EDfs.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $27tFE.Parser));
module.exports["LocalDayParser"] = $49bbec1a392484db$export$44d1c127ab42c480;

});

parcelRegister("gxgDD", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");


var $7EDfs = parcelRequire("7EDfs");

var $c09ca268b6399ac1$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $kUYG8.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $g6rNx.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 90);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, $5GO7m.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $7EDfs.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $27tFE.Parser));
module.exports["StandAloneLocalDayParser"] = $c09ca268b6399ac1$export$e447a647caaaec1d;

});

parcelRegister("jE6Oy", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");


var $kxXlL = parcelRequire("kxXlL");

var $e4d709f3bfa22a1b$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(ISODayParser, _Parser);
    var _super = (0, $kUYG8.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $g6rNx.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 90);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, $5GO7m.mapValue)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, $5GO7m.mapValue)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, $5GO7m.mapValue)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, $5GO7m.mapValue)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $kxXlL.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $27tFE.Parser));
module.exports["ISODayParser"] = $e4d709f3bfa22a1b$export$693fb1e525095b2a;

});

parcelRegister("kxXlL", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef54ed65fb65360f$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");


var $kr6hK = parcelRequire("kr6hK");

function $ef54ed65fb65360f$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $3yGK6.default)(2, arguments);
    var day = (0, $kr6hK.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $dkBOe.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});

parcelRegister("j28KI", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $ddb4fe47873dbecf$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(AMPMParser, _Parser);
    var _super = (0, $kUYG8.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $g6rNx.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 80);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $5GO7m.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $27tFE.Parser));
module.exports["AMPMParser"] = $ddb4fe47873dbecf$export$8d1e08492351df91;

});

parcelRegister("djpXE", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $9b1130103b9ec382$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(AMPMMidnightParser, _Parser);
    var _super = (0, $kUYG8.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $g6rNx.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 80);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $5GO7m.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $27tFE.Parser));
module.exports["AMPMMidnightParser"] = $9b1130103b9ec382$export$73ca2bd0a17d273;

});

parcelRegister("7Nf6S", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $5ac8d485ed59c619$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(DayPeriodParser, _Parser);
    var _super = (0, $kUYG8.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $g6rNx.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 80);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $5GO7m.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $27tFE.Parser));
module.exports["DayPeriodParser"] = $5ac8d485ed59c619$export$bb9212adf05373db;

});

parcelRegister("9UQOD", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $7382502015b26245$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(Hour1to12Parser, _Parser);
    var _super = (0, $kUYG8.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $g6rNx.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 70);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $27tFE.Parser));
module.exports["Hour1to12Parser"] = $7382502015b26245$export$8a04050a727a1756;

});

parcelRegister("ael3l", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $772b8adf69b218c7$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(Hour0to23Parser, _Parser);
    var _super = (0, $kUYG8.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $g6rNx.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 70);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $27tFE.Parser));
module.exports["Hour0to23Parser"] = $772b8adf69b218c7$export$e56f4dea2c3e56dd;

});

parcelRegister("6M1cG", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $4ee828c00f7373ac$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(Hour0To11Parser, _Parser);
    var _super = (0, $kUYG8.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $g6rNx.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 70);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $27tFE.Parser));
module.exports["Hour0To11Parser"] = $4ee828c00f7373ac$export$cbbe855312f87d77;

});

parcelRegister("cAMvE", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $92ae79c7d88a2f90$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(Hour1To24Parser, _Parser);
    var _super = (0, $kUYG8.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $g6rNx.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 70);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $27tFE.Parser));
module.exports["Hour1To24Parser"] = $92ae79c7d88a2f90$export$6008046d2b34b6a5;

});

parcelRegister("4mDmT", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $32d7c12f76c50723$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(MinuteParser, _Parser);
    var _super = (0, $kUYG8.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $g6rNx.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 60);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $27tFE.Parser));
module.exports["MinuteParser"] = $32d7c12f76c50723$export$2b52670d9e2be53;

});

parcelRegister("bLXDl", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $8922577c9d0d3a05$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(SecondParser, _Parser);
    var _super = (0, $kUYG8.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $g6rNx.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 50);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $27tFE.Parser));
module.exports["SecondParser"] = $8922577c9d0d3a05$export$94d46d540cf1366a;

});

parcelRegister("1kRDS", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $0f9144ee890f4d12$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(FractionOfSecondParser, _Parser);
    var _super = (0, $kUYG8.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $g6rNx.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 30);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $5GO7m.mapValue)((0, $5GO7m.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $27tFE.Parser));
module.exports["FractionOfSecondParser"] = $0f9144ee890f4d12$export$b8e6f8b2d70893b1;

});

parcelRegister("iRtG4", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $dbb43294a2aa850b$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $kUYG8.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $g6rNx.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 10);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, $61VNy.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).basic, dateString);
                    case 'XXXX':
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $27tFE.Parser));
module.exports["ISOTimezoneWithZParser"] = $dbb43294a2aa850b$export$104d901d49fea29b;

});

parcelRegister("62f5E", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $464ea28c4b2b8db5$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(ISOTimezoneParser, _Parser);
    var _super = (0, $kUYG8.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $g6rNx.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 10);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, $61VNy.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).basic, dateString);
                    case 'xxxx':
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $27tFE.Parser));
module.exports["ISOTimezoneParser"] = $464ea28c4b2b8db5$export$12910e5204b52b9;

});

parcelRegister("bQs8D", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $89fa60b9e72bd0e2$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(TimestampSecondsParser, _Parser);
    var _super = (0, $kUYG8.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $g6rNx.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 40);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $61VNy.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $5GO7m.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $27tFE.Parser));
module.exports["TimestampSecondsParser"] = $89fa60b9e72bd0e2$export$2cd8bf877a05e96;

});

parcelRegister("26OJt", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $18937eb5d5c6e05e$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $kUYG8.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $g6rNx.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 20);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $61VNy.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $5GO7m.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $27tFE.Parser));
module.exports["TimestampMillisecondsParser"] = $18937eb5d5c6e05e$export$6d8f69c6906d6368;

});

parcelRegister("nStJY", function(module, exports) {

var $gO7n9 = parcelRequire("gO7n9");


var $jPzTX = parcelRequire("jPzTX");

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $047c686ddfb588a6$var$pick = $jPzTX(function(object, paths) {
    return object == null ? {} : $gO7n9(object, paths);
});
module.exports = $047c686ddfb588a6$var$pick;

});

parcelRegister("gO7n9", function(module, exports) {

var $3Bix5 = parcelRequire("3Bix5");


var $h7loT = parcelRequire("h7loT");

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $c3c708e20cb40f59$var$basePick(object, paths) {
    return $3Bix5(object, paths, function(value, path) {
        return $h7loT(object, path);
    });
}
module.exports = $c3c708e20cb40f59$var$basePick;

});

parcelRegister("8Bx1z", function(module, exports) {
"use strict";
var $643b655b3a668be3$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

/* tslint:enable:max-line-length */ /**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */ function $643b655b3a668be3$var$filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new $643b655b3a668be3$var$FilterOperator(predicate, thisArg));
    };
}
module.exports.filter = $643b655b3a668be3$var$filter;
var $643b655b3a668be3$var$FilterOperator = function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $643b655b3a668be3$var$FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $643b655b3a668be3$var$FilterSubscriber = function(_super) {
    $643b655b3a668be3$var$__extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.count = 0;
    }
    // the try catch block below is left specifically for
    // optimization and perf reasons. a tryCatcher is not necessary here.
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=filter.js.map

});

parcelRegister("eeWDH", function(module, exports) {
"use strict";
var $a5dfdc0a1bdb1c58$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $atSr0 = parcelRequire("atSr0");


var $kjYch = parcelRequire("kjYch");

/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */ function $a5dfdc0a1bdb1c58$var$take(count) {
    return function(source) {
        if (count === 0) return new $kjYch.EmptyObservable();
        else return source.lift(new $a5dfdc0a1bdb1c58$var$TakeOperator(count));
    };
}
module.exports.take = $a5dfdc0a1bdb1c58$var$take;
var $a5dfdc0a1bdb1c58$var$TakeOperator = function() {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $atSr0.ArgumentOutOfRangeError;
    }
    TakeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a5dfdc0a1bdb1c58$var$TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a5dfdc0a1bdb1c58$var$TakeSubscriber = function(_super) {
    $a5dfdc0a1bdb1c58$var$__extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    TakeSubscriber.prototype._next = function(value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=take.js.map

});

parcelRegister("atSr0", function(module, exports) {
"use strict";
var $7a16d669c235c821$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an element was queried at a certain index of an
 * Observable, but no such index or position exists in that sequence.
 *
 * @see {@link elementAt}
 * @see {@link take}
 * @see {@link takeLast}
 *
 * @class ArgumentOutOfRangeError
 */ var $7a16d669c235c821$var$ArgumentOutOfRangeError = function(_super) {
    $7a16d669c235c821$var$__extends(ArgumentOutOfRangeError, _super);
    function ArgumentOutOfRangeError() {
        var err = _super.call(this, 'argument out of range');
        this.name = err.name = 'ArgumentOutOfRangeError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ArgumentOutOfRangeError;
}(Error);
module.exports.ArgumentOutOfRangeError = $7a16d669c235c821$var$ArgumentOutOfRangeError; //# sourceMappingURL=ArgumentOutOfRangeError.js.map

});

parcelRegister("34cAP", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $23bb83863f0fc948$export$45b10814cc054894, (v) => $23bb83863f0fc948$export$45b10814cc054894 = v);
var $23bb83863f0fc948$export$45b10814cc054894;
"use strict";

var $7bBVm = parcelRequire("7bBVm");

function $23bb83863f0fc948$var$toArrayReducer(arr, item, index) {
    if (index === 0) return [
        item
    ];
    arr.push(item);
    return arr;
}
function $23bb83863f0fc948$var$toArray() {
    return $7bBVm.reduce($23bb83863f0fc948$var$toArrayReducer, []);
}
$23bb83863f0fc948$export$45b10814cc054894 = $23bb83863f0fc948$var$toArray; //# sourceMappingURL=toArray.js.map

});

parcelRegister("7bBVm", function(module, exports) {
$parcel$export(module.exports, "reduce", () => $53b6fa7559558246$export$533b26079ad0b4b, (v) => $53b6fa7559558246$export$533b26079ad0b4b = v);
var $53b6fa7559558246$export$533b26079ad0b4b;
"use strict";

var $bbCp3 = parcelRequire("bbCp3");


var $lQvgf = parcelRequire("lQvgf");


var $dTFgb = parcelRequire("dTFgb");


var $kPZwo = parcelRequire("kPZwo");

/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns the
 * accumulated result when the source completes, given an optional seed value.
 *
 * <span class="informal">Combines together all values emitted on the source,
 * using an accumulator function that knows how to join a new source value into
 * the accumulation from the past.</span>
 *
 * <img src="./img/reduce.png" width="100%">
 *
 * Like
 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
 * `reduce` applies an `accumulator` function against an accumulation and each
 * value of the source Observable (from the past) to reduce it to a single
 * value, emitted on the output Observable. Note that `reduce` will only emit
 * one value, only when the source Observable completes. It is equivalent to
 * applying operator {@link scan} followed by operator {@link last}.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
 *   .takeUntil(Rx.Observable.interval(5000));
 * var ones = clicksInFiveSeconds.mapTo(1);
 * var seed = 0;
 * var count = ones.reduce((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link count}
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link scan}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
 * called on each source value.
 * @param {R} [seed] The initial accumulation value.
 * @return {Observable<R>} An Observable that emits a single value that is the
 * result of accumulating the values emitted by the source Observable.
 * @method reduce
 * @owner Observable
 */ function $53b6fa7559558246$var$reduce(accumulator, seed) {
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) return function reduceOperatorFunctionWithSeed(source) {
        return $kPZwo.pipe($bbCp3.scan(accumulator, seed), $lQvgf.takeLast(1), $dTFgb.defaultIfEmpty(seed))(source);
    };
    return function reduceOperatorFunction(source) {
        return $kPZwo.pipe($bbCp3.scan(function(acc, value, index) {
            return accumulator(acc, value, index + 1);
        }), $lQvgf.takeLast(1))(source);
    };
}
$53b6fa7559558246$export$533b26079ad0b4b = $53b6fa7559558246$var$reduce; //# sourceMappingURL=reduce.js.map

});

parcelRegister("bbCp3", function(module, exports) {
"use strict";
var $824e82d9ed0a6633$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns each
 * intermediate result, with an optional seed value.
 *
 * <span class="informal">It's like {@link reduce}, but emits the current
 * accumulation whenever the source emits a value.</span>
 *
 * <img src="./img/scan.png" width="100%">
 *
 * Combines together all values emitted on the source, using an accumulator
 * function that knows how to join a new source value into the accumulation from
 * the past. Is similar to {@link reduce}, but emits the intermediate
 * accumulations.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var ones = clicks.mapTo(1);
 * var seed = 0;
 * var count = ones.scan((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link reduce}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator
 * The accumulator function called on each source value.
 * @param {T|R} [seed] The initial accumulation value.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method scan
 * @owner Observable
 */ function $824e82d9ed0a6633$var$scan(accumulator, seed) {
    var hasSeed = false;
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) hasSeed = true;
    return function scanOperatorFunction(source) {
        return source.lift(new $824e82d9ed0a6633$var$ScanOperator(accumulator, seed, hasSeed));
    };
}
module.exports.scan = $824e82d9ed0a6633$var$scan;
var $824e82d9ed0a6633$var$ScanOperator = function() {
    function ScanOperator(accumulator, seed, hasSeed) {
        if (hasSeed === void 0) hasSeed = false;
        this.accumulator = accumulator;
        this.seed = seed;
        this.hasSeed = hasSeed;
    }
    ScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $824e82d9ed0a6633$var$ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
    };
    return ScanOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $824e82d9ed0a6633$var$ScanSubscriber = function(_super) {
    $824e82d9ed0a6633$var$__extends(ScanSubscriber, _super);
    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this._seed = _seed;
        this.hasSeed = hasSeed;
        this.index = 0;
    }
    Object.defineProperty(ScanSubscriber.prototype, "seed", {
        get: function() {
            return this._seed;
        },
        set: function(value) {
            this.hasSeed = true;
            this._seed = value;
        },
        enumerable: true,
        configurable: true
    });
    ScanSubscriber.prototype._next = function(value) {
        if (!this.hasSeed) {
            this.seed = value;
            this.destination.next(value);
        } else return this._tryNext(value);
    };
    ScanSubscriber.prototype._tryNext = function(value) {
        var index = this.index++;
        var result;
        try {
            result = this.accumulator(this.seed, value, index);
        } catch (err) {
            this.destination.error(err);
        }
        this.seed = result;
        this.destination.next(result);
    };
    return ScanSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=scan.js.map

});

parcelRegister("lQvgf", function(module, exports) {
"use strict";
var $fe76b4167e522f00$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $atSr0 = parcelRequire("atSr0");


var $kjYch = parcelRequire("kjYch");

/**
 * Emits only the last `count` values emitted by the source Observable.
 *
 * <span class="informal">Remembers the latest `count` values, then emits those
 * only when the source completes.</span>
 *
 * <img src="./img/takeLast.png" width="100%">
 *
 * `takeLast` returns an Observable that emits at most the last `count` values
 * emitted by the source Observable. If the source emits fewer than `count`
 * values then all of its values are emitted. This operator must wait until the
 * `complete` notification emission from the source in order to emit the `next`
 * values on the output Observable, because otherwise it is impossible to know
 * whether or not more values will be emitted on the source. For this reason,
 * all values are emitted synchronously, followed by the complete notification.
 *
 * @example <caption>Take the last 3 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 100);
 * var lastThree = many.takeLast(3);
 * lastThree.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of values to emit from the end of
 * the sequence of values emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits at most the last count
 * values emitted by the source Observable.
 * @method takeLast
 * @owner Observable
 */ function $fe76b4167e522f00$var$takeLast(count) {
    return function takeLastOperatorFunction(source) {
        if (count === 0) return new $kjYch.EmptyObservable();
        else return source.lift(new $fe76b4167e522f00$var$TakeLastOperator(count));
    };
}
module.exports.takeLast = $fe76b4167e522f00$var$takeLast;
var $fe76b4167e522f00$var$TakeLastOperator = function() {
    function TakeLastOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $atSr0.ArgumentOutOfRangeError;
    }
    TakeLastOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $fe76b4167e522f00$var$TakeLastSubscriber(subscriber, this.total));
    };
    return TakeLastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $fe76b4167e522f00$var$TakeLastSubscriber = function(_super) {
    $fe76b4167e522f00$var$__extends(TakeLastSubscriber, _super);
    function TakeLastSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.ring = new Array();
        this.count = 0;
    }
    TakeLastSubscriber.prototype._next = function(value) {
        var ring = this.ring;
        var total = this.total;
        var count = this.count++;
        if (ring.length < total) ring.push(value);
        else {
            var index = count % total;
            ring[index] = value;
        }
    };
    TakeLastSubscriber.prototype._complete = function() {
        var destination = this.destination;
        var count = this.count;
        if (count > 0) {
            var total = this.count >= this.total ? this.total : this.count;
            var ring = this.ring;
            for(var i = 0; i < total; i++){
                var idx = count++ % total;
                destination.next(ring[idx]);
            }
        }
        destination.complete();
    };
    return TakeLastSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=takeLast.js.map

});

parcelRegister("dTFgb", function(module, exports) {
"use strict";
var $a1e06aced5e020ea$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

/* tslint:enable:max-line-length */ /**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */ function $a1e06aced5e020ea$var$defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) defaultValue = null;
    return function(source) {
        return source.lift(new $a1e06aced5e020ea$var$DefaultIfEmptyOperator(defaultValue));
    };
}
module.exports.defaultIfEmpty = $a1e06aced5e020ea$var$defaultIfEmpty;
var $a1e06aced5e020ea$var$DefaultIfEmptyOperator = function() {
    function DefaultIfEmptyOperator(defaultValue) {
        this.defaultValue = defaultValue;
    }
    DefaultIfEmptyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a1e06aced5e020ea$var$DefaultIfEmptySubscriber(subscriber, this.defaultValue));
    };
    return DefaultIfEmptyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a1e06aced5e020ea$var$DefaultIfEmptySubscriber = function(_super) {
    $a1e06aced5e020ea$var$__extends(DefaultIfEmptySubscriber, _super);
    function DefaultIfEmptySubscriber(destination, defaultValue) {
        _super.call(this, destination);
        this.defaultValue = defaultValue;
        this.isEmpty = true;
    }
    DefaultIfEmptySubscriber.prototype._next = function(value) {
        this.isEmpty = false;
        this.destination.next(value);
    };
    DefaultIfEmptySubscriber.prototype._complete = function() {
        if (this.isEmpty) this.destination.next(this.defaultValue);
        this.destination.complete();
    };
    return DefaultIfEmptySubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=defaultIfEmpty.js.map

});

parcelRegister("lv9Cv", function(module, exports) {
$parcel$export(module.exports, "of", () => $fa73f494791b08e6$export$ba255e9e49e00608, (v) => $fa73f494791b08e6$export$ba255e9e49e00608 = v);
var $fa73f494791b08e6$export$ba255e9e49e00608;
"use strict";

var $hmT2x = parcelRequire("hmT2x");

$fa73f494791b08e6$export$ba255e9e49e00608 = $hmT2x.ArrayObservable.of; //# sourceMappingURL=of.js.map

});

parcelRegister("hrJHY", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $zAMIg = parcelRequire("zAMIg");


var $fEWBj = parcelRequire("fEWBj");


var $fNVRJ = parcelRequire("fNVRJ");


var $1XTds = parcelRequire("1XTds");

/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */ function delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = $zAMIg.async;
    var absoluteDelay = $fEWBj.isDate(delay);
    var delayFor = absoluteDelay ? +delay - scheduler.now() : Math.abs(delay);
    return function(source) {
        return source.lift(new DelayOperator(delayFor, scheduler));
    };
}
exports.delay = delay;
var DelayOperator = function() {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var DelaySubscriber = function(_super) {
    __extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        _super.call(this, destination);
        this.delay = delay;
        this.scheduler = scheduler;
        this.queue = [];
        this.active = false;
        this.errored = false;
    }
    DelaySubscriber.dispatch = function(state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while(queue.length > 0 && queue[0].time - scheduler.now() <= 0)queue.shift().notification.observe(destination);
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        } else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function(scheduler) {
        this.active = true;
        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this,
            destination: this.destination,
            scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function(notification) {
        if (this.errored === true) return;
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) this._schedule(scheduler);
    };
    DelaySubscriber.prototype._next = function(value) {
        this.scheduleNotification($1XTds.Notification.createNext(value));
    };
    DelaySubscriber.prototype._error = function(err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
    };
    DelaySubscriber.prototype._complete = function() {
        this.scheduleNotification($1XTds.Notification.createComplete());
    };
    return DelaySubscriber;
}($fNVRJ.Subscriber);
var DelayMessage = function() {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}(); //# sourceMappingURL=delay.js.map

});

parcelRegister("zAMIg", function(module, exports) {
$parcel$export(module.exports, "async", () => $06afcdac526dbf67$export$12af436354f1a4f7, (v) => $06afcdac526dbf67$export$12af436354f1a4f7 = v);
/**
 *
 * Async Scheduler
 *
 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
 *
 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
 * in intervals.
 *
 * If you just want to "defer" task, that is to perform it right after currently
 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
 * better choice will be the {@link asap} scheduler.
 *
 * @example <caption>Use async scheduler to delay task</caption>
 * const task = () => console.log('it works!');
 *
 * Rx.Scheduler.async.schedule(task, 2000);
 *
 * // After 2 seconds logs:
 * // "it works!"
 *
 *
 * @example <caption>Use async scheduler to repeat task in intervals</caption>
 * function task(state) {
 *   console.log(state);
 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
 *                                   // which we reschedule with new state and delay
 * }
 *
 * Rx.Scheduler.async.schedule(task, 3000, 0);
 *
 * // Logs:
 * // 0 after 3s
 * // 1 after 4s
 * // 2 after 5s
 * // 3 after 6s
 *
 * @static true
 * @name async
 * @owner Scheduler
 */ var $06afcdac526dbf67$export$12af436354f1a4f7;
"use strict";

var $1HJiA = parcelRequire("1HJiA");


var $fJ8RQ = parcelRequire("fJ8RQ");

$06afcdac526dbf67$export$12af436354f1a4f7 = new $fJ8RQ.AsyncScheduler($1HJiA.AsyncAction); //# sourceMappingURL=async.js.map

});

parcelRegister("fEWBj", function(module, exports) {
$parcel$export(module.exports, "isDate", () => $b6680c598ae7a287$export$871608497c498473, (v) => $b6680c598ae7a287$export$871608497c498473 = v);
var $b6680c598ae7a287$export$871608497c498473;
"use strict";
function $b6680c598ae7a287$var$isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
$b6680c598ae7a287$export$871608497c498473 = $b6680c598ae7a287$var$isDate; //# sourceMappingURL=isDate.js.map

});

parcelRegister("9Hb6D", function(module, exports) {
$parcel$export(module.exports, "merge", () => $70f0bea37c3dd158$export$4950aa0f605343fb, (v) => $70f0bea37c3dd158$export$4950aa0f605343fb = v);
var $70f0bea37c3dd158$export$4950aa0f605343fb;
"use strict";

var $1pK8e = parcelRequire("1pK8e");


var $hmT2x = parcelRequire("hmT2x");


var $lRrDg = parcelRequire("lRrDg");


var $c9SbF = parcelRequire("c9SbF");

/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (as arguments), and simply
 * forwards (without doing any transformation) all the values from all the input
 * Observables to the output Observable. The output Observable only completes
 * once all input Observables have completed. Any error delivered by an input
 * Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = Rx.Observable.merge(clicks, timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // timer will emit ascending values, one every second(1000ms) to console
 * // clicks logs MouseEvents to console everytime the "document" is clicked
 * // Since the two streams are merged you see these happening
 * // as they occur.
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = Rx.Observable.merge(timer1, timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - First timer1 and timer2 will run concurrently
 * // - timer1 will emit a value every 1000ms for 10 iterations
 * // - timer2 will emit a value every 2000ms for 6 iterations
 * // - after timer1 hits it's max iteration, timer2 will
 * //   continue, and timer3 will start to run concurrently with timer2
 * // - when timer2 hits it's max iteration it terminates, and
 * //   timer3 will continue to emit a value every 500ms until it is complete
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {...ObservableInput} observables Input Observables to merge together.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} an Observable that emits items that are the result of
 * every input Observable.
 * @static true
 * @name merge
 * @owner Observable
 */ function $70f0bea37c3dd158$var$merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if ($lRrDg.isScheduler(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') concurrent = observables.pop();
    } else if (typeof last === 'number') concurrent = observables.pop();
    if (scheduler === null && observables.length === 1 && observables[0] instanceof $1pK8e.Observable) return observables[0];
    return $c9SbF.mergeAll(concurrent)(new $hmT2x.ArrayObservable(observables, scheduler));
}
$70f0bea37c3dd158$export$4950aa0f605343fb = $70f0bea37c3dd158$var$merge; //# sourceMappingURL=merge.js.map

});

parcelRegister("c9SbF", function(module, exports) {
$parcel$export(module.exports, "mergeAll", () => $8da05bbe9f24d995$export$18aef43295bbe906, (v) => $8da05bbe9f24d995$export$18aef43295bbe906 = v);
var $8da05bbe9f24d995$export$18aef43295bbe906;
"use strict";

var $inXGV = parcelRequire("inXGV");


var $lIS42 = parcelRequire("lIS42");

/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */ function $8da05bbe9f24d995$var$mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $inXGV.mergeMap($lIS42.identity, null, concurrent);
}
$8da05bbe9f24d995$export$18aef43295bbe906 = $8da05bbe9f24d995$var$mergeAll; //# sourceMappingURL=mergeAll.js.map

});

parcelRegister("lIS42", function(module, exports) {
$parcel$export(module.exports, "identity", () => $fd07a50b5336926a$export$f0954fd7d5368655, (v) => $fd07a50b5336926a$export$f0954fd7d5368655 = v);
var $fd07a50b5336926a$export$f0954fd7d5368655;
"use strict";
function $fd07a50b5336926a$var$identity(x) {
    return x;
}
$fd07a50b5336926a$export$f0954fd7d5368655 = $fd07a50b5336926a$var$identity; //# sourceMappingURL=identity.js.map

});

parcelRegister("aK1EY", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $4o0zT = parcelRequire("4o0zT");


const $f1b26a0986b97fb7$var$LazyDatasourceTableView = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("evLbl")).then((module)=>({
            default: module.DatasourceTableView
        })));
// Equivalent renderer props must not update a Suspense boundary that is still hydrating.
const $f1b26a0986b97fb7$var$StableDatasourceTableView = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? function StableDatasourceTableView(props) {
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": "datasource-table-view-suspense"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: t0,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($f1b26a0986b97fb7$var$LazyDatasourceTableView, {
                ...props
            })
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function StableDatasourceTableView(props) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": 'datasource-table-view-suspense'
        }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($f1b26a0986b97fb7$var$LazyDatasourceTableView, {
            ...props
        })
    });
}, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
const $f1b26a0986b97fb7$export$2f5bdb66685d3fb4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    if ((0, $4o0zT.isExperimentEnabled)("platform_datasource_hydration_stability")) {
        let t0;
        if ($[0] !== props) {
            t0 = /*#__PURE__*/ (0, $8aG6j.jsx)($f1b26a0986b97fb7$var$StableDatasourceTableView, {
                ...props
            });
            $[0] = props;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    let t0;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": "datasource-table-view-suspense"
        });
        $[2] = t0;
    } else t0 = $[2];
    let t1;
    if ($[3] !== props) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: t0,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($f1b26a0986b97fb7$var$LazyDatasourceTableView, {
                ...props
            })
        });
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    if ((0, $4o0zT.isExperimentEnabled)('platform_datasource_hydration_stability')) return /*#__PURE__*/ (0, $8aG6j.jsx)($f1b26a0986b97fb7$var$StableDatasourceTableView, {
        ...props
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": 'datasource-table-view-suspense'
        }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($f1b26a0986b97fb7$var$LazyDatasourceTableView, {
            ...props
        })
    });
};
module.exports["DatasourceTableViewWithWrappers"] = $f1b26a0986b97fb7$export$2f5bdb66685d3fb4;

});

parcelRegister("evLbl", function(module, exports) {

let $a9088f4d427a069b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a9088f4d427a069b$var$load("dJVzt"),
    $a9088f4d427a069b$var$load("lya9W"),
    $a9088f4d427a069b$var$load("1JeTB"),
    $a9088f4d427a069b$var$load("6wr18"),
    $a9088f4d427a069b$var$load("jisiR"),
    $a9088f4d427a069b$var$load("icVON"),
    $a9088f4d427a069b$var$load("aEiTV"),
    $a9088f4d427a069b$var$load("iQvHF"),
    $a9088f4d427a069b$var$load("ef2CU"),
    $a9088f4d427a069b$var$load("iWnyc"),
    $a9088f4d427a069b$var$load("ffEVr"),
    $a9088f4d427a069b$var$load("hhss7"),
    $a9088f4d427a069b$var$load("Wowvf"),
    $a9088f4d427a069b$var$load("4g6rd"),
    $a9088f4d427a069b$var$load("7EorR"),
    $a9088f4d427a069b$var$load("3WGfe")
]).then(()=>parcelRequire('khl4A'));

});

parcelRegister("fbHl6", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


const $14d0cd645fed394d$var$LazyDatasourceRenderFailedAnalyticsWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("cueDJ")));
const $14d0cd645fed394d$export$f386473e8f104bcb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($14d0cd645fed394d$var$LazyDatasourceRenderFailedAnalyticsWrapper, {
                ...props
            })
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($14d0cd645fed394d$var$LazyDatasourceRenderFailedAnalyticsWrapper, {
            ...props
        })
    });
module.exports["LazyLoadedDatasourceRenderFailedAnalyticsWrapper"] = $14d0cd645fed394d$export$f386473e8f104bcb;

});

parcelRegister("cueDJ", function(module, exports) {

let $9173a48e434958c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9173a48e434958c3$var$load("bzl94").then(()=>parcelRequire('j30TZ'));

});

parcelRegister("b2XFx", function(module, exports) {
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $kCECX = parcelRequire("kCECX");


var $7Y8M5 = parcelRequire("7Y8M5");


var $8VfSP = parcelRequire("8VfSP");


var $V3JOP = parcelRequire("V3JOP");


var $gDx2k = parcelRequire("gDx2k");


var $4o0zT = parcelRequire("4o0zT");


var $l8Rhq = parcelRequire("l8Rhq");

var $3izAL = parcelRequire("3izAL");

var $6Pqow = parcelRequire("6Pqow");

var $buxP3 = parcelRequire("buxP3");


var $ieeJu = parcelRequire("ieeJu");


var $eaCAt = parcelRequire("eaCAt");

var $krYZG = parcelRequire("krYZG");


var $bI2nS = parcelRequire("bI2nS");

function $4e976cfe241fa7a6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Dynamic padding value that adjusts based on the editor's base font size.
 * When base font size is <= akEditorFullPageDenseFontSize (13px), uses 1px padding.
 * Otherwise, uses default value with token('space.025').
 */ const $4e976cfe241fa7a6$var$DYNAMIC_PADDING_BLOCK = `clamp(1px, calc((var(--ak-editor-base-font-size, ${(0, $7Y8M5.akEditorFullPageDefaultFontSize)}px) - ${(0, $7Y8M5.akEditorFullPageDenseFontSize)}px) * 999), ${"var(--ds-space-025, 2px)"})`;
const $4e976cfe241fa7a6$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $4e976cfe241fa7a6$var$iconWrapperStyles = (0, $buxP3.xcss)({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '17px',
    width: '17px'
});
const $4e976cfe241fa7a6$var$hiddenTextStyle = {
    name: "1hr6gib",
    styles: "overflow:hidden;white-space:nowrap;position:absolute;visibility:hidden"
};
const $4e976cfe241fa7a6$var$linkStylesCommon = (0, $buxP3.xcss)({
    position: 'absolute',
    left: 'space.025',
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
    paddingBlock: 'space.025',
    paddingInline: 'space.050',
    gap: 'space.025',
    overflow: 'hidden',
    zIndex: 'card',
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: "var(--ds-radius-small, 3px)",
    color: 'color.text.subtle',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    top: '0px',
    height: '1.2em',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered',
        color: 'color.text.subtle',
        textDecoration: 'none'
    }
});
const $4e976cfe241fa7a6$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY = 45;
const $4e976cfe241fa7a6$var$ICON_WIDTH = 16;
const $4e976cfe241fa7a6$var$DEFAULT_OPEN_TEXT_WIDTH = 28; // Default open text width in English
const $4e976cfe241fa7a6$var$visitCardLinkAnalytics = (editorAnalyticsApi, inputMethod)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $kCECX.NodeSelection))) return false;
        const { type: type } = state.selection.node;
        if (dispatch) {
            const { tr: tr } = state;
            editorAnalyticsApi?.attachAnalyticsEvent((0, $eaCAt.buildVisitedNonHyperLinkPayload)(type.name, inputMethod))(tr);
            dispatch(tr);
        }
        return true;
    };
const $4e976cfe241fa7a6$var$HoverLinkOverlay = ({ children: children, isVisible: isVisible = false, url: url, destinationUrl: destinationUrl, compactPadding: compactPadding = false, editorAnalyticsApi: editorAnalyticsApi, view: view, onClick: onClick, showPanelButton: showPanelButton = false, showPanelButtonIcon: showPanelButtonIcon })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const containerRef = (0, $cozmU.useRef)(null);
    const hoverLinkButtonRef = (0, $cozmU.useRef)(null);
    const hiddenTextRef = (0, $cozmU.useRef)(null);
    const [showLabel, setShowLabel] = (0, $cozmU.useState)(true);
    const [isHovered, setHovered] = (0, $cozmU.useState)(false);
    const openTextWidthRef = (0, $cozmU.useRef)(null);
    const regularPadding = $4e976cfe241fa7a6$var$DYNAMIC_PADDING_BLOCK;
    const memoizedHoverLinkStyles = (0, $cozmU.useMemo)(()=>({
            paddingBlock: compactPadding ? '1px' : regularPadding
        }), [
        compactPadding,
        regularPadding
    ]);
    const hoverLinkStyles = (0, $4o0zT.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? memoizedHoverLinkStyles : {
        paddingBlock: compactPadding ? '1px' : $4e976cfe241fa7a6$var$DYNAMIC_PADDING_BLOCK
    };
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!isVisible || !isHovered) return;
        const cardWidth = containerRef.current?.offsetWidth;
        const openButtonWidth = hoverLinkButtonRef.current?.offsetWidth;
        // Get the hidden text width
        if (!openTextWidthRef.current) {
            const hiddenText = hiddenTextRef.current;
            if (hiddenText) {
                // Measure the width of the hidden text
                // Temporarily make the element visible to measure its width
                hiddenText.style.visibility = 'hidden';
                hiddenText.style.display = 'inline';
                openTextWidthRef.current = hiddenText.offsetWidth;
                // Reset the hiddenText's display property
                hiddenText.style.display = 'none';
                hiddenText.style.visibility = 'inherit';
            } else openTextWidthRef.current = $4e976cfe241fa7a6$var$DEFAULT_OPEN_TEXT_WIDTH;
        }
        if (!cardWidth || !openButtonWidth) return;
        const openTextWidth = openTextWidthRef.current || $4e976cfe241fa7a6$var$DEFAULT_OPEN_TEXT_WIDTH;
        let canShowLabel = cardWidth - openTextWidth > $4e976cfe241fa7a6$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY + $4e976cfe241fa7a6$var$ICON_WIDTH;
        // When a smart link wraps to multiple lines in a constrained container (e.g. table cell),
        // the hover button can overflow beyond the container bounds. We detect this by comparing
        // the button's right edge to the container's right edge, and hide the label if it overflows.
        if (containerRef.current && hoverLinkButtonRef.current) {
            const containerRight = containerRef.current.getBoundingClientRect().right;
            const buttonRight = hoverLinkButtonRef.current.getBoundingClientRect().right;
            if (buttonRight > containerRight) canShowLabel = false;
        }
        setShowLabel(canShowLabel);
    }, [
        isVisible,
        isHovered
    ]);
    const handleOverlayChange = (isHovered)=>{
        setHovered(isHovered);
        // Reset label visibility on hover start so we can measure if it overflows.
        // Without this, the label stays hidden from a previous hover and won't be re-measured.
        if (isHovered) setShowLabel(true);
    };
    const sendVisitLinkAnalytics = (inputMethod)=>{
        if (editorAnalyticsApi && view) $4e976cfe241fa7a6$var$visitCardLinkAnalytics(editorAnalyticsApi, inputMethod)(view.state, view.dispatch);
    };
    const handleDoubleClick = ()=>{
        if (!showPanelButton) {
            sendVisitLinkAnalytics((0, $krYZG.INPUT_METHOD).DOUBLE_CLICK);
            // Double click opens the link in a new tab
            window.open(destinationUrl ?? url, '_blank');
        }
    };
    const handleClick = (event)=>{
        if (showPanelButton && onClick) onClick(event);
        else sendVisitLinkAnalytics((0, $krYZG.INPUT_METHOD).BUTTON);
    };
    const label = showPanelButton ? formatMessage((0, $bI2nS.messages).previewButtonTitle) : formatMessage((0, $bI2nS.messages).openButtonTitle);
    let icon = null;
    if (showPanelButton && showPanelButtonIcon === 'panel') icon = /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gDx2k))), {
        label: ""
    });
    else if (showPanelButton && showPanelButtonIcon === 'modal') icon = /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))), {
        label: ""
    });
    else icon = /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
        label: ""
    });
    return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        ref: containerRef,
        css: $4e976cfe241fa7a6$var$containerStyles,
        onDoubleClick: handleDoubleClick,
        onMouseEnter: ()=>handleOverlayChange(true),
        onMouseLeave: ()=>handleOverlayChange(false),
        // No-op focus/blur handlers to satisfy a11y/mouse-events-have-key-events rule.
        // The hover overlay is a mouse convenience — keyboard users can access link actions
        // (open, preview) via the floating toolbar that appears on selection.
        onFocus: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onBlur: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined
    }, children, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: $4e976cfe241fa7a6$var$hiddenTextStyle,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $6Pqow.Text), {
        ref: hiddenTextRef,
        size: "small",
        maxLines: 1
    }, label)), isHovered && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $l8Rhq.Anchor), {
        ref: hoverLinkButtonRef,
        xcss: $4e976cfe241fa7a6$var$linkStylesCommon,
        href: destinationUrl ?? url,
        target: "_blank",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic paddingBlock value based on experiment flags
        style: hoverLinkStyles,
        onClick: handleClick,
        testId: "inline-card-hoverlink-overlay"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.Box), {
        xcss: $4e976cfe241fa7a6$var$iconWrapperStyles,
        "data-inlinecard-button-overlay": "icon-wrapper-line-height",
        testId: "inline-card-hoverlink-overlay-icon"
    }, icon), showLabel && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $6Pqow.Text), {
        size: "small",
        color: "color.text.subtle",
        maxLines: 1,
        testId: "inline-card-hoverlink-overlay-label"
    }, label)));
};
var $4e976cfe241fa7a6$export$2e2bcd8739ae039 = $4e976cfe241fa7a6$var$HoverLinkOverlay;
module.exports["default"] = $4e976cfe241fa7a6$export$2e2bcd8739ae039;

});

parcelRegister("gybyF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $03RpJ = parcelRequire("03RpJ");


var $bI14T = parcelRequire("bI14T");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $6Vsq4 = parcelRequire("6Vsq4");


var $apFwO = parcelRequire("apFwO");


var $jINxM = parcelRequire("jINxM");


var $2FmJb = parcelRequire("2FmJb");


var $dM7c5 = parcelRequire("dM7c5");


var $kG7AM = parcelRequire("kG7AM");


var $kfxZm = parcelRequire("kfxZm");


var $cEvdy = parcelRequire("cEvdy");


var $dz9dk = parcelRequire("dz9dk");


var $9H66G = parcelRequire("9H66G");

function $f78fd23812cb38dc$export$a95296ded9241771({ url: url, appearance: appearance, origin: origin, actionOptions: actionOptions, prefetch: prefetch }) {
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $cozmU.useMemo)(()=>(0, $03RpJ.default)(), []);
    const linkState = (0, $9H66G.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const { isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel } = (0, $bI14T.useSmartLinkContext)();
    const invokeClientAction = (0, $kfxZm.default)({
        fireEvent: fireEvent
    });
    const resolve = (0, $cEvdy.default)();
    const appendCrossProductAnalyticsParams = (0, $dz9dk.useSmartLinkCrossProductUrlWrapper)({
        details: linkState.details
    });
    if ((0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && prefetch && !linkState.details) resolve({
        url: url
    });
    if (linkState.details && !actionOptions?.hide) {
        const actions = [];
        const invokeParam = {
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: linkState.details
        };
        const downloadActionProps = (0, $apFwO.extractInvokeDownloadAction)(invokeParam);
        if (downloadActionProps) actions.push((0, $kG7AM.toAction)(downloadActionProps, invokeClientAction, (0, $dM7c5.messages).download, 'download-content'));
        const viewActionProps = (0, $2FmJb.extractInvokeViewAction)({
            ...invokeParam,
            transformUrl: (destinationUrl = url)=>appendCrossProductAnalyticsParams(destinationUrl)
        });
        if (viewActionProps) actions.push((0, $kG7AM.toAction)(viewActionProps, invokeClientAction, (0, $dM7c5.messages).view, 'view-content'));
        const previewActionProps = (0, $jINxM.extractInvokePreviewAction)({
            ...invokeParam,
            fireEvent: fireEvent,
            origin: origin,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            ...(0, $iDrrr.fg)('preview_panel_unit_check') ? {
                isPreviewRestricted: isPreviewRestricted
            } : undefined,
            openPreviewPanel: openPreviewPanel,
            transformUrl: (destinationUrl = url)=>appendCrossProductAnalyticsParams(destinationUrl)
        });
        if (previewActionProps) actions.push((0, $kG7AM.toAction)(previewActionProps.invokeAction, invokeClientAction, (0, $dM7c5.messages).preview_improved, 'preview-content'));
        return actions;
    }
    return [];
}
module.exports["useSmartLinkActions"] = $f78fd23812cb38dc$export$a95296ded9241771;

});

parcelRegister("kG7AM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $658c5c09596e5d2b$export$9d52be0dab870c7 = (action, invokeClientAction, message, id)=>{
    return {
        id: id,
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), message),
        invoke: ()=>invokeClientAction(action)
    };
};
module.exports["toAction"] = $658c5c09596e5d2b$export$9d52be0dab870c7;

});

parcelRegister("1SZMn", function(module, exports) {
var $420fd782fb031b11$export$ecd1fed429542b49 = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}({});
var $420fd782fb031b11$export$9cf3651d97128b9c = /*#__PURE__*/ function(VIEW_METHOD) {
    VIEW_METHOD["BADGE"] = "badge";
    VIEW_METHOD["COMMENT_BUTTON"] = "commentButton";
    return VIEW_METHOD;
}({});
module.exports["RESOLVE_METHOD"] = $420fd782fb031b11$export$ecd1fed429542b49;
module.exports["VIEW_METHOD"] = $420fd782fb031b11$export$9cf3651d97128b9c;

});

parcelRegister("294Sp", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $eDtFr = parcelRequire("eDtFr");


var $4o0zT = parcelRequire("4o0zT");


var $kh0hi = parcelRequire("kh0hi");

var $buxP3 = parcelRequire("buxP3");


var $lpNn5 = parcelRequire("lpNn5");


var $ImNkk = parcelRequire("ImNkk");

const $55b84b299399ca35$var$baseStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.small'
});
const $55b84b299399ca35$var$mediumBadgeStyles = (0, $buxP3.xcss)({
    height: 'space.300',
    width: 'space.300'
});
const $55b84b299399ca35$export$d5da84b0136a0cc4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { status: t1, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave } = t0;
    const status = t1 === undefined ? "default" : t1;
    const intl = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== intl) {
        t2 = intl.formatMessage((0, $ImNkk.commentMessages).viewCommentsOnMedia);
        $[0] = intl;
        $[1] = t2;
    } else t2 = $[1];
    const title = t2;
    let t3;
    bb0: switch(status){
        case "active":
            t3 = "color.background.accent.yellow.subtlest.pressed";
            break bb0;
        case "entered":
            t3 = "color.background.accent.yellow.subtlest.hovered";
            break bb0;
        default:
            t3 = "color.background.accent.yellow.subtlest";
    }
    const colourToken = t3;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = [
            $55b84b299399ca35$var$baseStyles,
            $55b84b299399ca35$var$mediumBadgeStyles
        ];
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== title) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
            label: title,
            spacing: "spacious",
            color: (0, $4o0zT.isExperimentEnabled)("cc_comments_media_viewer_sidebar") ? "var(--ds-icon-accent-yellow, #B38600)" : "currentColor"
        });
        $[3] = title;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== colourToken || $[6] !== onClick || $[7] !== onMouseEnter || $[8] !== onMouseLeave || $[9] !== t5) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kh0hi.Pressable), {
            xcss: t4,
            padding: "space.0",
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            backgroundColor: colourToken,
            children: t5
        });
        $[5] = colourToken;
        $[6] = onClick;
        $[7] = onMouseEnter;
        $[8] = onMouseLeave;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== t6 || $[12] !== title) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            position: "top",
            content: title,
            children: t6
        });
        $[11] = t6;
        $[12] = title;
        $[13] = t7;
    } else t7 = $[13];
    return t7;
} : ({ status: status = 'default', onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave })=>{
    const intl = (0, $kSwu1.useIntl)();
    const title = intl.formatMessage((0, $ImNkk.commentMessages).viewCommentsOnMedia);
    const colourToken = (0, $cozmU.useMemo)(()=>{
        switch(status){
            case 'active':
                return 'color.background.accent.yellow.subtlest.pressed';
            case 'entered':
                return 'color.background.accent.yellow.subtlest.hovered';
            default:
                return 'color.background.accent.yellow.subtlest';
        }
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
        position: "top",
        content: title,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kh0hi.Pressable), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            xcss: [
                $55b84b299399ca35$var$baseStyles,
                $55b84b299399ca35$var$mediumBadgeStyles
            ],
            padding: "space.0",
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            backgroundColor: colourToken,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
                label: title,
                spacing: "spacious",
                color: (0, $4o0zT.isExperimentEnabled)('cc_comments_media_viewer_sidebar') ? "var(--ds-icon-accent-yellow, #B38600)" : 'currentColor'
            })
        })
    });
};
module.exports["CommentBadgeNext"] = $55b84b299399ca35$export$d5da84b0136a0cc4;

});

parcelRegister("ImNkk", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a3dbe84aa3c3621f$export$4c0d145df60cfb04 = (0, $kSwu1.defineMessages)({
    addCommentOnMedia: {
        id: "fabric.editor.addCommentOnMedia",
        defaultMessage: "Add comment"
    },
    viewCommentsOnMedia: {
        id: "fabric.editor.viewCommentOnMedia",
        defaultMessage: "View comments"
    },
    viewAndAddCommentsOnMedia: {
        id: "fabric.editor.viewAndAddCommentsOnMedia",
        defaultMessage: "View and add comments"
    }
});
module.exports["commentMessages"] = $a3dbe84aa3c3621f$export$4c0d145df60cfb04;

});

parcelRegister("2G2MI", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fodiz = parcelRequire("fodiz");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");


var $ieeJu = parcelRequire("ieeJu");


var $lpNn5 = parcelRequire("lpNn5");


var $gR535 = parcelRequire("gR535");

const $ccec193f181caf27$var$baseStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.small',
    backgroundColor: 'elevation.surface',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    cursor: 'pointer'
});
const $ccec193f181caf27$var$NO_EXTERNAL_BADGE_HOSTS = [
    'atlassian.com',
    'loom.com',
    'dam-cdn.atl.orangelogic.com'
];
const $ccec193f181caf27$var$NO_EXTERNAL_BADGE_HOSTS_NEW = [
    'atlassian.com',
    'loom.com',
    'dam-cdn.atl.orangelogic.com',
    'bitbucket.org'
];
const $ccec193f181caf27$export$babb68fb5c212c90 = (url)=>{
    if (!url) return false;
    // Check if URL is valid
    try {
        new URL(url);
    } catch  {
        return false;
    }
    const parsedUrl = new URL(url || '');
    const { hostname: hostname, pathname: pathname, protocol: protocol } = parsedUrl;
    if (protocol === 'data:') return pathname?.startsWith('image/');
    if ((0, $ieeJu.expValEquals)('platform_editor_media_external_badge_bbc_fix', 'isEnabled', true)) return Boolean(hostname && $ccec193f181caf27$var$NO_EXTERNAL_BADGE_HOSTS_NEW.some((host)=>hostname === host || hostname.endsWith(`.${host}`)));
    return Boolean(hostname && $ccec193f181caf27$var$NO_EXTERNAL_BADGE_HOSTS.some((host)=>hostname === host || hostname.endsWith(`.${host}`)));
};
const $ccec193f181caf27$export$66bf2ed7a5d4691f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { type: type, url: url } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== intl) {
        t1 = intl.formatMessage((0, $gR535.externalMediaMessages).externalMediaFile);
        $[0] = intl;
        $[1] = t1;
    } else t1 = $[1];
    const message = t1;
    if (type !== "external" || $ccec193f181caf27$export$babb68fb5c212c90(url)) return null;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": "external-image-badge"
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== message) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
            label: message
        });
        $[3] = message;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== message || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $3izAL.Box), {
            padding: "space.050",
            xcss: $ccec193f181caf27$var$baseStyles,
            tabIndex: 0,
            children: [
                t2,
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                    content: message,
                    position: "top",
                    children: t3
                })
            ]
        });
        $[5] = message;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ type: type, url: url })=>{
    const intl = (0, $kSwu1.useIntl)();
    const message = intl.formatMessage((0, $gR535.externalMediaMessages).externalMediaFile);
    if (type !== 'external' || $ccec193f181caf27$export$babb68fb5c212c90(url)) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $3izAL.Box), {
        padding: "space.050",
        xcss: $ccec193f181caf27$var$baseStyles,
        tabIndex: 0,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                "data-testid": "external-image-badge"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                content: message,
                position: "top",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
                    label: message
                })
            })
        ]
    });
};
module.exports["ExternalImageBadge"] = $ccec193f181caf27$export$66bf2ed7a5d4691f;

});

parcelRegister("gR535", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $211a5f48c385cec9$export$8e36294abfabe45e = (0, $kSwu1.defineMessages)({
    externalMediaFile: {
        id: "fabric.editor.externalMediaFile",
        defaultMessage: "External media file"
    }
});
module.exports["externalMediaMessages"] = $211a5f48c385cec9$export$8e36294abfabe45e;

});

parcelRegister("7UxJ0", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $55fM8 = parcelRequire("55fM8");


var $iDrrr = parcelRequire("iDrrr");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");

const $a2c23c75d9cad129$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT = 200;
const $a2c23c75d9cad129$var$containerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    gap: 'space.025',
    zIndex: 'card',
    height: 'fit-content',
    width: 'fit-content',
    margin: 'space.075'
});
// The above styles are used for both editor and renderer, and in renderer the
// document body is the main scroll area. This means it overscrolls the primary
// toolbar, where the z-index is "2". We have to hack in our own z-index less
// than that to ensure our badge appears under the toolbar when scrolled.
const $a2c23c75d9cad129$var$hackedZIndexStyles = (0, $buxP3.xcss)({
    zIndex: '1'
});
const $a2c23c75d9cad129$var$resizeOffsetStyles = (0, $buxP3.xcss)({
    right: 'space.150'
});
const $a2c23c75d9cad129$var$getBadgeVisible = (width, height)=>{
    return width && width < $a2c23c75d9cad129$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT || height && height < $a2c23c75d9cad129$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT ? false : true;
};
const $a2c23c75d9cad129$export$6a31fc38737d0e58 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    let { children: children, mediaElement: mediaElement, mediaWidth: mediaWidth, mediaHeight: mediaHeight, extendedResizeOffset: extendedResizeOffset, useMinimumZIndex: t1 } = t0;
    const useMinimumZIndex = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== mediaHeight || $[1] !== mediaWidth) {
        t2 = $a2c23c75d9cad129$var$getBadgeVisible(mediaWidth, mediaHeight);
        $[0] = mediaHeight;
        $[1] = mediaWidth;
        $[2] = t2;
    } else t2 = $[2];
    const [visible, setVisible] = (0, $cozmU.useState)(t2);
    let t3;
    let t4;
    if ($[3] !== mediaElement) {
        t3 = ()=>{
            const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))((entries)=>{
                const [entry] = entries;
                const { width: width, height: height } = entry.contentRect;
                setVisible($a2c23c75d9cad129$var$getBadgeVisible(width, height));
            }));
            if (mediaElement) observer.observe(mediaElement);
            return ()=>{
                observer.disconnect();
            };
        };
        t4 = [
            mediaElement
        ];
        $[3] = mediaElement;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $cozmU.useEffect)(t3, t4);
    if (typeof children === "function") {
        let t5;
        if ($[6] !== children || $[7] !== visible) {
            t5 = children({
                visible: visible
            });
            $[6] = children;
            $[7] = visible;
            $[8] = t5;
        } else t5 = $[8];
        children = t5;
    }
    if (!(0, $iDrrr.fg)("media-perf-uplift-mutation-fix")) {
        if (!mediaElement || (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) === 0) return null;
    }
    const t5 = useMinimumZIndex && $a2c23c75d9cad129$var$hackedZIndexStyles;
    const t6 = extendedResizeOffset && $a2c23c75d9cad129$var$resizeOffsetStyles;
    let t7;
    if ($[9] !== t5 || $[10] !== t6) {
        t7 = [
            $a2c23c75d9cad129$var$containerStyles,
            t5,
            t6
        ];
        $[9] = t5;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== children || $[13] !== t7) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.Box), {
            as: "div",
            testId: "media-badges",
            "data-media-badges": "true",
            contentEditable: false,
            xcss: t7,
            children: children
        });
        $[12] = children;
        $[13] = t7;
        $[14] = t8;
    } else t8 = $[14];
    return t8;
} : ({ children: children, mediaElement: mediaElement, mediaWidth: mediaWidth, mediaHeight: mediaHeight, extendedResizeOffset: extendedResizeOffset, useMinimumZIndex: useMinimumZIndex = false })=>{
    const [visible, setVisible] = (0, $cozmU.useState)($a2c23c75d9cad129$var$getBadgeVisible(mediaWidth, mediaHeight));
    (0, $cozmU.useEffect)(()=>{
        const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))((entries)=>{
            const [entry] = entries;
            const { width: width, height: height } = entry.contentRect;
            setVisible($a2c23c75d9cad129$var$getBadgeVisible(width, height));
        }));
        if (mediaElement) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        observer.observe(mediaElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaElement
    ]);
    if (typeof children === 'function') children = children({
        visible: visible
    });
    // delete this block on cleanup of media-perf-uplift-mutation-fix
    if (!(0, $iDrrr.fg)('media-perf-uplift-mutation-fix')) {
        // becuase it is wrapped in a fragment, React.Children.count(children) will always be 1.
        // That makes this check a source of late mutations that we don't need.
        if (!mediaElement || (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) === 0) return null;
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.Box), {
        as: "div",
        testId: "media-badges",
        "data-media-badges": "true",
        contentEditable: false,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        xcss: [
            $a2c23c75d9cad129$var$containerStyles,
            useMinimumZIndex && $a2c23c75d9cad129$var$hackedZIndexStyles,
            extendedResizeOffset && $a2c23c75d9cad129$var$resizeOffsetStyles
        ],
        children: children
    });
};
module.exports["MediaBadges"] = $a2c23c75d9cad129$export$6a31fc38737d0e58;

});

parcelRegister("czp8P", function(module, exports) {
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $185ef2202d608231$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $185ef2202d608231$export$aa000893c5e2b9c2[hexColor.toUpperCase()];
}
const $185ef2202d608231$export$aa000893c5e2b9c2 = {
    // gray
    /** gray - subtle */ ['#091E4224']: "var(--ds-border, #0B120E24)",
    /** gray */ ['#758195']: "var(--ds-border-bold, #7D818A)",
    /** gray - bold */ ['#172B4D']: "var(--ds-text, #292A2E)"
};
module.exports["hexToEditorBorderPaletteColor"] = $185ef2202d608231$export$bad3c41dd33cb4bc;

});

parcelRegister("1pEse", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $ew4xH = parcelRequire("ew4xH");

const $edacca4f67c5c3ed$export$e6dfd72ab29f8598 = (props)=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: (0, $ew4xH.wrapperStyles)({
            dimensions: props.dimensions
        }),
        ...props
    }, props.children));
};
module.exports["Wrapper"] = $edacca4f67c5c3ed$export$e6dfd72ab29f8598;

});

parcelRegister("ew4xH", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $9AILw = parcelRequire("9AILw");

const $b57e90473f867d52$export$491e6397d7c1480b = ({ dimensions: dimensions })=>/*#__PURE__*/ (0, $lOiVq.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $9AILw.center), "position:relative;background:var(--ds-surface-sunken, #F8F8F8);color:var(--ds-icon, #292A2E);", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $9AILw.borderRadius), {
        maxHeight: '100%',
        maxWidth: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: dimensions.width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: dimensions.height
    });
module.exports["wrapperStyles"] = $b57e90473f867d52$export$491e6397d7c1480b;

});

parcelRegister("9AILw", function(module, exports) {
const $1086bc1f8c9770f0$export$3481c78889e8fbe8 = `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $1086bc1f8c9770f0$export$7a57f79000377ca2 = `
  border-radius: ${"var(--ds-radius-small, 3px)"};
`;
const $1086bc1f8c9770f0$export$a98155aef1bfd63 = `
  border-bottom-left-radius: ${"var(--ds-radius-small, 3px)"};
  border-bottom-right-radius: ${"var(--ds-radius-small, 3px)"};
`;
const $1086bc1f8c9770f0$export$24656b269d8df7d6 = 'cubic-bezier(0.645, 0.045, 0.355, 1)';
module.exports["center"] = $1086bc1f8c9770f0$export$3481c78889e8fbe8;
module.exports["borderRadius"] = $1086bc1f8c9770f0$export$7a57f79000377ca2;

});

parcelRegister("17wiG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $iDrrr = parcelRequire("iDrrr");


var $65DSU = parcelRequire("65DSU");


var $3lbOc = parcelRequire("3lbOc");

const $7f8f90030369ae01$var$MediaCardContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({});
const $7f8f90030369ae01$var$CardLoadingWithContext = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const props = (0, $cozmU.useContext)($7f8f90030369ae01$var$MediaCardContext);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3lbOc.CardLoading), {
            ...props,
            interactionName: "media-card-async-loading"
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const props = (0, $cozmU.useContext)($7f8f90030369ae01$var$MediaCardContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3lbOc.CardLoading), {
        ...props,
        interactionName: "media-card-async-loading"
    });
};

function $7f8f90030369ae01$var$loadCardWithMediaClient() {
    return (parcelRequire("dy2pT"));
}
const $7f8f90030369ae01$var$MediaCardWithMediaClientLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "a0IPb",
    name: "MediaCardWithMediaClientLoadable",
    loader: ()=>$7f8f90030369ae01$var$loadCardWithMediaClient().then((mod)=>mod.CardWithMediaClient),
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$CardLoadingWithContext, null)
});
const $7f8f90030369ae01$var$MediaCardWithMediaClientLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>$7f8f90030369ae01$var$loadCardWithMediaClient().then((mod)=>({
            default: mod.CardWithMediaClient
        })));
const $7f8f90030369ae01$var$CardLoader = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $iDrrr.fg)("platform_media_react19_support") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$CardLoadingWithContext, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardWithMediaClientLazy, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardWithMediaClientLoadable, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props || $[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
            name: "media-card",
            mode: "list"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardContext.Provider, {
            value: props
        }, t0));
        $[2] = props;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
        name: "media-card",
        mode: "list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardContext.Provider, {
        value: props
    }, (0, $iDrrr.fg)('platform_media_react19_support') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$CardLoadingWithContext, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardWithMediaClientLazy, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardWithMediaClientLoadable, props)));
};
$7f8f90030369ae01$var$CardLoader.preload = ()=>{
    if ((0, $iDrrr.fg)('platform_media_react19_support')) $7f8f90030369ae01$var$loadCardWithMediaClient().then(()=>{});
    else $7f8f90030369ae01$var$MediaCardWithMediaClientLoadable.preload?.();
};
var $7f8f90030369ae01$export$2e2bcd8739ae039 = $7f8f90030369ae01$var$CardLoader;
module.exports["default"] = $7f8f90030369ae01$export$2e2bcd8739ae039;

});

parcelRegister("3lbOc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $97Pj3 = parcelRequire("97Pj3");


var $8quKc = parcelRequire("8quKc");


var $1pEse = parcelRequire("1pEse");

const $9010bd9f06816b06$export$5d25853fd6bdf402 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { dimensions: dimensionsProp, testId: testId, interactionName: interactionName } = t0;
    let t1;
    if ($[0] !== dimensionsProp) {
        t1 = (0, $8quKc.getDimensionsWithDefault)(dimensionsProp);
        $[0] = dimensionsProp;
        $[1] = t1;
    } else t1 = $[1];
    const dimensions = t1;
    const t2 = testId || "media-card-loading";
    const t3 = interactionName || "media-card-loading";
    let t4;
    if ($[2] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97Pj3.LoadingBar), {
            interactionName: t3
        });
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== dimensions || $[5] !== t2 || $[6] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1pEse.Wrapper), {
            "data-testid": t2,
            "data-test-loading": true,
            dimensions: dimensions,
            "data-vc": "media-card-loading"
        }, t4);
        $[4] = dimensions;
        $[5] = t2;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
} : ({ dimensions: dimensionsProp, testId: testId, interactionName: interactionName })=>{
    const dimensions = (0, $8quKc.getDimensionsWithDefault)(dimensionsProp);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1pEse.Wrapper), {
        "data-testid": testId || 'media-card-loading',
        "data-test-loading": true,
        dimensions: dimensions,
        "data-vc": "media-card-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97Pj3.LoadingBar), {
        interactionName: interactionName || 'media-card-loading'
    }));
};
module.exports["CardLoading"] = $9010bd9f06816b06$export$5d25853fd6bdf402;

});

parcelRegister("97Pj3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $5EzLH = parcelRequire("5EzLH");

const $9d658d6460d574ed$var$TICK_INTERVAL_MS = 1000;
const $9d658d6460d574ed$var$STATIC_PROGRESS_VALUE = 0.9; /**
                                    * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
                                    * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
                                    * which makes things simpler than doing an `isServer` check or a `null` check.
                                    *
                                    * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
                                    */ 
const $9d658d6460d574ed$var$useLayoutEffect = typeof window === 'undefined' ? (0, $cozmU.useEffect) : (0, $cozmU.useLayoutEffect);
const $9d658d6460d574ed$var$messages = (0, $kSwu1.defineMessages)({
    loadingBarLabel: {
        id: "fabric.media.loading_bar_label",
        defaultMessage: "Loading"
    }
});
const $9d658d6460d574ed$var$trackStyles = null;
const $9d658d6460d574ed$var$fillStyles = null;
const $9d658d6460d574ed$var$clampToPercent = (progress)=>Math.min(1, Math.max(0, progress)) * 100;
const $9d658d6460d574ed$export$6665614bc5d690f6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { animationDisabled: t1, testId: testId, interactionName: interactionName } = t0;
    const animationDisabled = t1 === undefined ? false : t1;
    const intl = (0, $kSwu1.useIntl)();
    const [progress, setProgress] = (0, $cozmU.useState)(animationDisabled ? $9d658d6460d574ed$var$STATIC_PROGRESS_VALUE : 0);
    const intervalRef = (0, $cozmU.useRef)();
    const interactionContext = (0, $cozmU.useContext)((0, $5EzLH.default));
    let t2;
    let t3;
    if ($[0] !== interactionContext || $[1] !== interactionName) {
        t2 = ()=>{
            if (interactionContext != null) return interactionContext.hold(interactionName);
        };
        t3 = [
            interactionContext,
            interactionName
        ];
        $[0] = interactionContext;
        $[1] = interactionName;
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    $9d658d6460d574ed$var$useLayoutEffect(t2, t3);
    let t4;
    let t5;
    if ($[4] !== animationDisabled) {
        t4 = ()=>{
            if (animationDisabled) {
                setProgress($9d658d6460d574ed$var$STATIC_PROGRESS_VALUE);
                return;
            }
            intervalRef.current = setInterval(()=>{
                setProgress((prev)=>{
                    if (prev < 0.1) return prev + 0.1;
                    else {
                        if (prev < 0.6) return prev + 0.35;
                        else {
                            if (prev < 0.9) return prev + 0.1;
                        }
                    }
                    clearInterval(intervalRef.current);
                    return prev;
                });
            }, $9d658d6460d574ed$var$TICK_INTERVAL_MS);
            return ()=>clearInterval(intervalRef.current);
        };
        t5 = [
            animationDisabled
        ];
        $[4] = animationDisabled;
        $[5] = t4;
        $[6] = t5;
    } else {
        t4 = $[5];
        t5 = $[6];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[7] !== intl) {
        t6 = intl.formatMessage($9d658d6460d574ed$var$messages.loadingBarLabel);
        $[7] = intl;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDS5Zs _1mT5xdWVPG _0Bm75G2ADO _39xV02wOVE _3OE6xYOiLO _0jFU0VZimw _0KLXruDMqu"
        ]);
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== progress) {
        t8 = $9d658d6460d574ed$var$clampToPercent(progress);
        $[10] = progress;
        $[11] = t8;
    } else t8 = $[11];
    const t9 = `${t8}%`;
    let t10;
    if ($[12] !== t9) {
        t10 = {
            width: t9
        };
        $[12] = t9;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (0, $hekY6.default)([
            "_0bjKvDS5Zs _23rrnHUdC3 _3iDTPbvLZJ _0jFU0VN91d _0KLXruXljP"
        ]);
        $[14] = t11;
    } else t11 = $[14];
    let t12;
    if ($[15] !== t10) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: t10,
            className: t11
        });
        $[15] = t10;
        $[16] = t12;
    } else t12 = $[16];
    let t13;
    if ($[17] !== progress || $[18] !== t12 || $[19] !== t6 || $[20] !== testId) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            role: "progressbar",
            "aria-valuenow": progress,
            "aria-label": t6,
            "data-testid": testId,
            className: t7
        }, t12);
        $[17] = progress;
        $[18] = t12;
        $[19] = t6;
        $[20] = testId;
        $[21] = t13;
    } else t13 = $[21];
    return t13;
} : ({ animationDisabled: animationDisabled = false, testId: testId, interactionName: interactionName })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [progress, setProgress] = (0, $cozmU.useState)(animationDisabled ? $9d658d6460d574ed$var$STATIC_PROGRESS_VALUE : 0);
    const intervalRef = (0, $cozmU.useRef)();
    const interactionContext = (0, $cozmU.useContext)((0, $5EzLH.default));
    $9d658d6460d574ed$var$useLayoutEffect(()=>{
        if (interactionContext != null) return interactionContext.hold(interactionName);
    }, [
        interactionContext,
        interactionName
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (animationDisabled) {
            setProgress($9d658d6460d574ed$var$STATIC_PROGRESS_VALUE);
            return;
        }
        intervalRef.current = setInterval(()=>{
            setProgress((prev)=>{
                if (prev < 0.1) return prev + 0.1;
                else if (prev < 0.6) return prev + 0.35;
                else if (prev < 0.9) return prev + 0.1;
                clearInterval(intervalRef.current);
                return prev;
            });
        }, $9d658d6460d574ed$var$TICK_INTERVAL_MS);
        return ()=>clearInterval(intervalRef.current);
    }, [
        animationDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "progressbar",
        "aria-valuenow": progress,
        "aria-label": intl.formatMessage($9d658d6460d574ed$var$messages.loadingBarLabel),
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDS5Zs _1mT5xdWVPG _0Bm75G2ADO _39xV02wOVE _3OE6xYOiLO _0jFU0VZimw _0KLXruDMqu"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            width: `${$9d658d6460d574ed$var$clampToPercent(progress)}%`
        },
        className: (0, $hekY6.default)([
            "_0bjKvDS5Zs _23rrnHUdC3 _3iDTPbvLZJ _0jFU0VN91d _0KLXruXljP"
        ])
    }));
};
module.exports["LoadingBar"] = $9d658d6460d574ed$export$6665614bc5d690f6;

});

parcelRegister("dy2pT", function(module, exports) {

let $9dd0533caefee647$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9dd0533caefee647$var$load("4Gdnz"),
    $9dd0533caefee647$var$load("4UAag"),
    $9dd0533caefee647$var$load("1JeTB"),
    $9dd0533caefee647$var$load("aaRXj"),
    $9dd0533caefee647$var$load("fHlIz"),
    $9dd0533caefee647$var$load("4QwAJ"),
    $9dd0533caefee647$var$load("3i44s"),
    $9dd0533caefee647$var$load("geXPZ"),
    $9dd0533caefee647$var$load("aQ5uu"),
    $9dd0533caefee647$var$load("6wr18"),
    $9dd0533caefee647$var$load("deB8t"),
    $9dd0533caefee647$var$load("10DpY"),
    $9dd0533caefee647$var$load("cTsbB"),
    $9dd0533caefee647$var$load("9vDBp"),
    $9dd0533caefee647$var$load("18FPo"),
    $9dd0533caefee647$var$load("ffEVr"),
    $9dd0533caefee647$var$load("gkVge"),
    $9dd0533caefee647$var$load("7EorR"),
    $9dd0533caefee647$var$load("7gPXS")
]).then(()=>parcelRequire('gnpwR'));

});

parcelRegister("hEt1x", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $g9ZnD = parcelRequire("g9ZnD");


var $IY7Mb = parcelRequire("IY7Mb");

const $2ddf178f2decc0e9$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(undefined);
const $2ddf178f2decc0e9$export$57164260bc1f1218 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings } = t0;
    let t1;
    if ($[0] !== mediaClientConfig) {
        t1 = (0, $g9ZnD.getMediaClient)(mediaClientConfig);
        $[0] = mediaClientConfig;
        $[1] = t1;
    } else t1 = $[1];
    const mediaClient = t1;
    const settings = (0, $IY7Mb.useMediaParsedSettings)(mediaSettings);
    let t2;
    if ($[2] !== mediaClient || $[3] !== settings) {
        t2 = {
            mediaClient: mediaClient,
            settings: settings
        };
        $[2] = mediaClient;
        $[3] = settings;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== children || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2ddf178f2decc0e9$export$c94ff18a59d4c4d.Provider, {
            value: t2
        }, children);
        $[5] = children;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $cozmU.useMemo)(()=>(0, $g9ZnD.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $IY7Mb.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2ddf178f2decc0e9$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        }
    }, children);
};
module.exports["MediaContext"] = $2ddf178f2decc0e9$export$c94ff18a59d4c4d;
module.exports["MediaProvider"] = $2ddf178f2decc0e9$export$57164260bc1f1218;

});

parcelRegister("IY7Mb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gYqFD = parcelRequire("gYqFD");

const $a0017e6c99530c15$export$d54af28440a5efc0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const mediaSettings = t1;
    let newSettings;
    if ($[2] !== mediaSettings) {
        newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $gYqFD.defaultMediaUserPreferences);
        $[2] = mediaSettings;
        $[3] = newSettings;
    } else newSettings = $[3];
    const settings = newSettings;
    return settings;
} : (mediaSettings = {})=>{
    const settings = (0, $cozmU.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $gYqFD.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};
module.exports["useMediaParsedSettings"] = $a0017e6c99530c15$export$d54af28440a5efc0;

});

parcelRegister("gYqFD", function(module, exports) {
// Currently only supports boolean, string. Uncomment below to support number
const $c55cff04bbd4c82d$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $c55cff04bbd4c82d$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($c55cff04bbd4c82d$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $c55cff04bbd4c82d$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $c55cff04bbd4c82d$export$2d23ed2854ac1650 = $c55cff04bbd4c82d$export$7e209e67b965bc63($c55cff04bbd4c82d$var$defaultUserPreferences);
module.exports["defaultMediaUserPreferences"] = $c55cff04bbd4c82d$export$2d23ed2854ac1650;

});

parcelRegister("jmmTp", function(module, exports) {
const $ad0c18c377a101ba$export$7695387cd66cf5b5 = (identifier)=>{
    return identifier.mediaItemType === 'file';
};
module.exports["isFileIdentifier"] = $ad0c18c377a101ba$export$7695387cd66cf5b5;

});

parcelRegister("1tBud", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $2mOOd = parcelRequire("2mOOd");


var $717N0 = parcelRequire("717N0");


const $4cc16dba49469f3f$var$MediaViewer = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("GurLW")).then(({ MediaViewerWithErrorBoundary: MediaViewerWithErrorBoundary })=>({
            default: MediaViewerWithErrorBoundary
        })));
const $4cc16dba49469f3f$var$AsyncMediaViewer = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AsyncMediaViewer(props) {
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2mOOd.default), null);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: t0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $717N0.MediaViewerPortal), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4cc16dba49469f3f$var$MediaViewer, props)));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function AsyncMediaViewer(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2mOOd.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $717N0.MediaViewerPortal), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4cc16dba49469f3f$var$MediaViewer, props)));
};
var $4cc16dba49469f3f$export$2e2bcd8739ae039 = $4cc16dba49469f3f$var$AsyncMediaViewer;
module.exports["default"] = $4cc16dba49469f3f$export$2e2bcd8739ae039;

});

parcelRegister("2mOOd", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $imqjG = parcelRequire("imqjG");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $6ffa2f80eb372db6$export$442b7be89436c101 = '#101214';
const $6ffa2f80eb372db6$var$ModalSpinner = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const t0 = colorMode !== "dark";
    let t1;
    if ($[0] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $imqjG.default), {
            blankedColor: $6ffa2f80eb372db6$export$442b7be89436c101,
            invertSpinnerColor: t0
        });
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ()=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $imqjG.default), {
        blankedColor: $6ffa2f80eb372db6$export$442b7be89436c101,
        invertSpinnerColor: colorMode !== 'dark'
    });
};
var $6ffa2f80eb372db6$export$2e2bcd8739ae039 = $6ffa2f80eb372db6$var$ModalSpinner;
module.exports["default"] = $6ffa2f80eb372db6$export$2e2bcd8739ae039;

});

parcelRegister("imqjG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $knkYU = parcelRequire("knkYU");

const $75f640d6e866ba35$var$ModalSpinner = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $knkYU.default), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $knkYU.default), props);
var $75f640d6e866ba35$export$2e2bcd8739ae039 = $75f640d6e866ba35$var$ModalSpinner;
module.exports["default"] = $75f640d6e866ba35$export$2e2bcd8739ae039;

});

parcelRegister("knkYU", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ea0f137a8e557bc$export$2e2bcd8739ae039);
/* modalSpinner-compiled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lfoFx = parcelRequire("lfoFx");

const $1ea0f137a8e557bc$var$blanketStyles = null;
const $1ea0f137a8e557bc$var$spinnerStyles = null;
const $1ea0f137a8e557bc$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $1ea0f137a8e557bc$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            backgroundColor: blankedColor || $1ea0f137a8e557bc$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        className: (0, $hekY6.default)([
            "_1mT5xdy1CL _2IhTondnbC _3OE6xYdnbC _0Bm75GdnbC _4ApkO2dnbC _42Yu6BEvR7"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _2IhTon715P _3OE6xY715P _1VJPcaiDnZ"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        size: "large",
        appearance: invertSpinnerColor || $1ea0f137a8e557bc$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
        testId: 'media-modal-spinner'
    })));

});

parcelRegister("717N0", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cK21K = parcelRequire("cK21K");

const $60b53ae22e9372b5$export$51aee4c01b17acde = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
            zIndex: 510
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>// This zIndex matches with zIndex used by DS Modal and Jira Issue View Modal.
    // This value makes layers stack work correctly:
    //  -> Issue View -> Media Viewer -> DS Modal
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
        zIndex: 510
    }, children);
module.exports["MediaViewerPortal"] = $60b53ae22e9372b5$export$51aee4c01b17acde;

});

parcelRegister("GurLW", function(module, exports) {

let $07fb8a7c87c8cc79$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $07fb8a7c87c8cc79$var$load("1JeTB"),
    $07fb8a7c87c8cc79$var$load("6OMo6"),
    $07fb8a7c87c8cc79$var$load("aaRXj"),
    $07fb8a7c87c8cc79$var$load("fHlIz"),
    $07fb8a7c87c8cc79$var$load("4QwAJ"),
    $07fb8a7c87c8cc79$var$load("3i44s"),
    $07fb8a7c87c8cc79$var$load("5kI0b"),
    $07fb8a7c87c8cc79$var$load("kYkz1"),
    $07fb8a7c87c8cc79$var$load("jfYeU"),
    $07fb8a7c87c8cc79$var$load("b4nm1"),
    $07fb8a7c87c8cc79$var$load("geXPZ"),
    $07fb8a7c87c8cc79$var$load("aQ5uu"),
    $07fb8a7c87c8cc79$var$load("6wr18"),
    $07fb8a7c87c8cc79$var$load("60PUI"),
    $07fb8a7c87c8cc79$var$load("1xeJ3"),
    $07fb8a7c87c8cc79$var$load("deB8t"),
    $07fb8a7c87c8cc79$var$load("10DpY"),
    $07fb8a7c87c8cc79$var$load("cTsbB"),
    $07fb8a7c87c8cc79$var$load("9vDBp"),
    $07fb8a7c87c8cc79$var$load("18FPo"),
    $07fb8a7c87c8cc79$var$load("RI3SR"),
    $07fb8a7c87c8cc79$var$load("ffEVr"),
    $07fb8a7c87c8cc79$var$load("e3OZZ"),
    $07fb8a7c87c8cc79$var$load("2XRLb"),
    $07fb8a7c87c8cc79$var$load("4MePG"),
    $07fb8a7c87c8cc79$var$load("io0qR"),
    $07fb8a7c87c8cc79$var$load("3MJxZ"),
    $07fb8a7c87c8cc79$var$load("cuNBo"),
    $07fb8a7c87c8cc79$var$load("kHMR7"),
    $07fb8a7c87c8cc79$var$load("4Ldt2"),
    $07fb8a7c87c8cc79$var$load("cL682"),
    $07fb8a7c87c8cc79$var$load("gkVge"),
    $07fb8a7c87c8cc79$var$load("jTOhL"),
    $07fb8a7c87c8cc79$var$load("jOE2W"),
    $07fb8a7c87c8cc79$var$load("5JWJI"),
    $07fb8a7c87c8cc79$var$load("hhss7"),
    $07fb8a7c87c8cc79$var$load("4jXCC")
]).then(()=>parcelRequire('9vMzD'));

});

parcelRegister("46ZX8", function(module, exports) {
const $d9d47302881512fd$export$2782f2fbff82f0c9 = (identifier)=>{
    return identifier.mediaItemType === 'external-image';
};
module.exports["isExternalImageIdentifier"] = $d9d47302881512fd$export$2782f2fbff82f0c9;

});

parcelRegister("lNvN4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $gIMcb = parcelRequire("gIMcb");


var $hEt1x = parcelRequire("hEt1x");

const $e5ff9295aa55af63$export$8b3e87ea56c3a345 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $gIMcb.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $hEt1x.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error("No MediaClient set, use MediaClientProvider or MediaProvider to set one");
    return mediaClient || altMediaClient;
} : ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $gIMcb.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $hEt1x.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};
module.exports["useMediaClient"] = $e5ff9295aa55af63$export$8b3e87ea56c3a345;

});

parcelRegister("4fGOw", function(module, exports) {

var $jx5V5 = parcelRequire("jx5V5");


var $lNvN4 = parcelRequire("lNvN4");

const $dc2272ad9447ddc9$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $jx5V5.useStore)(store, selector, equals);
function $dc2272ad9447ddc9$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $lNvN4.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $dc2272ad9447ddc9$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}
module.exports["useMediaStore"] = $dc2272ad9447ddc9$export$8a9cc8c330400af8;

});

parcelRegister("jx5V5", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $e385b0e7bfdc7f87$export$6ccbb43953eebf8);

var $3xeSM = parcelRequire("3xeSM");


var $cozmU = parcelRequire("cozmU");


var $aSzLn = parcelRequire("aSzLn");

var $e385b0e7bfdc7f87$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $e385b0e7bfdc7f87$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU)));
const { useSyncExternalStoreWithSelector: $e385b0e7bfdc7f87$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($aSzLn)));
let $e385b0e7bfdc7f87$var$didWarnAboutEqualityFn = false;
const $e385b0e7bfdc7f87$var$identity = (arg)=>arg;
function $e385b0e7bfdc7f87$export$6ccbb43953eebf8(api, selector = $e385b0e7bfdc7f87$var$identity, equalityFn) {
    if (($e385b0e7bfdc7f87$import_meta.env ? $e385b0e7bfdc7f87$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$e385b0e7bfdc7f87$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $e385b0e7bfdc7f87$var$didWarnAboutEqualityFn = true;
    }
    const slice = $e385b0e7bfdc7f87$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $e385b0e7bfdc7f87$var$useDebugValue(slice);
    return slice;
}
const $e385b0e7bfdc7f87$var$createImpl = (createState)=>{
    if (($e385b0e7bfdc7f87$import_meta.env ? $e385b0e7bfdc7f87$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $3xeSM.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$e385b0e7bfdc7f87$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $e385b0e7bfdc7f87$export$185802fd694ee1f5 = (createState)=>createState ? $e385b0e7bfdc7f87$var$createImpl(createState) : $e385b0e7bfdc7f87$var$createImpl;
var $e385b0e7bfdc7f87$export$2e2bcd8739ae039 = (createState)=>{
    if (($e385b0e7bfdc7f87$import_meta.env ? $e385b0e7bfdc7f87$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $e385b0e7bfdc7f87$export$185802fd694ee1f5(createState);
};

});

parcelRegister("fA65V", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c226a72f375a9da1$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    click_to_join: {
        id: "fabric.media.click_to_join",
        defaultMessage: "Join {context}"
    },
    click_to_join_description: {
        id: "fabric.media.click_to_join_description",
        defaultMessage: "You've been approved, so you can join {context} right away."
    },
    request_access: {
        id: "fabric.media.request_access",
        defaultMessage: "Request access"
    },
    request_access_description: {
        id: "fabric.media.request_access_description",
        defaultMessage: "Request access to {context} view this preview."
    },
    request_access_pending: {
        id: "fabric.media.request_access_pending",
        defaultMessage: "Access pending"
    },
    request_access_pending_description: {
        id: "fabric.media.request_access_pending_description",
        defaultMessage: "Your access request is pending."
    },
    forbidden_description: {
        id: "fabric.media.forbidden_description",
        defaultMessage: "You don\u2019t have access to this preview. Contact the site admin if you need access."
    },
    request_denied_description: {
        id: "fabric.media.request_denied_description",
        defaultMessage: "Your access request was denied. Contact the site admin if you still need access."
    },
    retry: {
        id: "fabric.media.retry",
        defaultMessage: "Retry"
    },
    failed_to_load: {
        id: "fabric.media.failed_to_load",
        defaultMessage: "Failed to load"
    },
    failed_to_upload: {
        id: "fabric.media.failed_to_upload",
        defaultMessage: "Failed to upload"
    },
    check_internet_connection: {
        id: "fabric.media.check_internet_connection",
        defaultMessage: "Failed to load. Please check your internet connection"
    },
    recent_uploads: {
        id: "fabric.media.recent_uploads",
        defaultMessage: "Recent uploads"
    },
    upload_file: {
        id: "fabric.media.upload_file",
        defaultMessage: "Upload a file"
    },
    drag_and_drop_your_files: {
        id: "fabric.media.drag_and_drop_your_files",
        defaultMessage: "Drag and drop your files anywhere or"
    },
    drag_and_drop_your_files_and_folders: {
        id: "fabric.media.drag_and_drop_your_files_and_folders",
        defaultMessage: "Drag and drop your files and folders anywhere or"
    },
    drop_your_files: {
        id: "fabric.media.drop_your_files",
        defaultMessage: "Drop your files to upload"
    },
    upload: {
        id: "fabric.media.upload",
        defaultMessage: "Upload"
    },
    cancel: {
        id: "fabric.media.cancel",
        defaultMessage: "Cancel"
    },
    delete: {
        id: "fabric.media.delete",
        defaultMessage: "Delete"
    },
    success: {
        id: "fabric.media.success",
        defaultMessage: "Success"
    },
    error: {
        id: "fabric.media.error",
        defaultMessage: "Error"
    },
    search_all_gifs: {
        id: "fabric.media.search_all_gifs",
        defaultMessage: "Search all the GIFs!"
    },
    cant_retrieve_gifs: {
        id: "fabric.media.cant_retrieve_gifs",
        defaultMessage: "Ouch! We could not retrieve any GIFs"
    },
    cant_retrieve_files: {
        id: "fabric.media.cant_retrieve_files",
        defaultMessage: "Ouch! We could not retrieve any files"
    },
    check_your_network: {
        id: "fabric.media.check_your_network",
        defaultMessage: "Check your network connection"
    },
    try_again: {
        id: "fabric.media.try_again",
        defaultMessage: "Try again"
    },
    try_another_account: {
        id: "fabric.media.try_another_account",
        defaultMessage: "Try another account"
    },
    no_gifs_found: {
        id: "fabric.media.no_gifs_found",
        defaultMessage: "Hello? Was it me you're looking for?"
    },
    no_gifs_found_suggestion: {
        id: "fabric.media.no_gifs_found_suggestion",
        defaultMessage: "We couldn't find anything for \"{query}\""
    },
    load_more_gifs: {
        id: "fabric.media.load_more_gifs",
        defaultMessage: "Load more GIFs"
    },
    add_account: {
        id: "fabric.media.add_account",
        defaultMessage: "Add account"
    },
    unlink_account: {
        id: "fabric.media.unlink_account",
        defaultMessage: "Unlink Account"
    },
    upload_file_from: {
        id: "fabric.media.upload_file_from",
        defaultMessage: "Upload a file from {name}"
    },
    connect_to: {
        id: "fabric.media.connect_to",
        defaultMessage: "Connect to {name}"
    },
    connect_account_description: {
        id: "fabric.media.connect_account_description",
        defaultMessage: "We'll open a new page to help you connect your {name} account"
    },
    connect_link_account: {
        id: "fabric.media.connect_link_account",
        defaultMessage: "Connect to preview"
    },
    connect_link_account_card: {
        id: "fabric.media.connect_link_account_card_view",
        defaultMessage: "Connect"
    },
    connect_link_account_card_name: {
        id: "fabric.media.connect_link_account_card_view_name",
        defaultMessage: "Connect your {context} account"
    },
    connect_link_account_card_description: {
        id: "fabric.media.connect_link_account_card_view_description",
        defaultMessage: "To show a preview of this link, connect your {context} account."
    },
    invalid_permissions: {
        id: "fabric.media.invalid_permissions",
        defaultMessage: "Restricted link"
    },
    invalid_permissions_description: {
        id: "fabric.media.invalid_permissions_description",
        defaultMessage: "You'll need to request access or try a different account to view this preview."
    },
    select_an_avatar: {
        id: "fabric.media.select_an_avatar",
        defaultMessage: "Select a default avatar"
    },
    upload_an_avatar: {
        id: "fabric.media.upload_an_avatar",
        defaultMessage: "Upload an avatar"
    },
    select_an_avatar_from_all_defaults: {
        id: "fabric.media.select_an_avatar_from_all_defaults",
        defaultMessage: "Select from all default options"
    },
    select_an_avatar_option: {
        id: "fabric.media.select_an_avatar_option",
        defaultMessage: "Default avatar option {number}"
    },
    show_more_avatars_btn_label: {
        id: "fabric.media.show_more_avatars_btn_label",
        defaultMessage: "Show more"
    },
    or_select_default_avatars: {
        id: "fabric.media.or_select_default_avatars",
        defaultMessage: "Upload a photo or select from some default options"
    },
    loading: {
        id: "fabric.media.loading",
        defaultMessage: "Loading..."
    },
    loading_file: {
        id: "fabric.media.loading_file",
        defaultMessage: "Loading file..."
    },
    save: {
        id: "fabric.media.save",
        defaultMessage: "Save"
    },
    or: {
        id: "fabric.media.or",
        defaultMessage: "or"
    },
    upload_photo: {
        id: "fabric.media.upload_photo",
        defaultMessage: "Upload a photo"
    },
    default_avatars: {
        id: "fabric.media.default_avatars",
        defaultMessage: "Default avatars"
    },
    avatar_picker_back_btn_label: {
        id: "fabric.media.avatar_picker_back_btn_label",
        defaultMessage: "Go Back"
    },
    drag_and_drop_images_here: {
        id: "fabric.media.drag_and_drop_images_here",
        defaultMessage: "Drag and drop your images here"
    },
    alt_text: {
        id: "fabric.media.alt_text_label",
        defaultMessage: "Alt text"
    },
    alt_text_description: {
        id: "fabric.media.alt_text_helper_message",
        defaultMessage: "How would you describe the selected image to someone with low vision?"
    },
    image_url_invalid_error: {
        id: "fabric.media.image_url_invalid_error",
        defaultMessage: "Could not load image, the url is invalid."
    },
    image_format_invalid_error: {
        id: "fabric.media.image_format_invalid_error",
        defaultMessage: "Could not load image, the format is invalid."
    },
    image_size_too_large_error: {
        id: "fabric.media.image_size_too_large_error",
        defaultMessage: "Image is too large, must be no larger than {MAX_SIZE_MB}Mb"
    },
    something_went_wrong: {
        id: "fabric.media.something_went_wrong",
        defaultMessage: "Something went wrong."
    },
    might_be_a_hiccup: {
        id: "fabric.media.might_be_a_hiccup",
        defaultMessage: "It might just be a hiccup."
    },
    couldnt_generate_preview: {
        id: "fabric.media.couldnt_generate_preview",
        defaultMessage: "We couldn't generate a preview for this file."
    },
    couldnt_generate_encrypted_entry_preview: {
        id: "fabric.media.couldnt_generate_encrypted_entry_preview",
        defaultMessage: "We can't preview encrypted or password protected files."
    },
    cant_preview_file_type: {
        id: "fabric.media.cant_preview_file_type",
        defaultMessage: "We can't preview this file type."
    },
    item_not_found_in_list: {
        id: "fabric.media.item_not_found_in_list",
        defaultMessage: "The selected item was not found on the list."
    },
    not_found_title: {
        id: "fabric.media.not_found_title",
        defaultMessage: "Uh oh. We can't find this link!"
    },
    not_found_description: {
        id: "fabric.media.not_found_description",
        defaultMessage: "We couldn't find the link. Check the url and try editing or paste again."
    },
    no_pdf_artifacts: {
        id: "fabric.media.no_pdf_artifacts",
        defaultMessage: "No PDF artifacts found for this file."
    },
    password_protected_pdf: {
        id: "fabric.media.password_protected_pdf",
        defaultMessage: "This file is password protected."
    },
    password: {
        id: "fabric.media.password",
        defaultMessage: "Password"
    },
    enter_password: {
        id: "fabric.media.enter_password",
        defaultMessage: "Enter password"
    },
    incorrect_password: {
        id: "fabric.media.incorrect_password",
        defaultMessage: "Incorrect password. Please try again."
    },
    submit: {
        id: "fabric.media.submit",
        defaultMessage: "Submit"
    },
    give_feedback: {
        id: "fabric.media.give_feedback",
        defaultMessage: "Give feedback"
    },
    try_downloading_file: {
        id: "fabric.media.try_downloading_file",
        defaultMessage: "Try downloading the file to view it."
    },
    archive_format_not_supported: {
        id: "fabric.media.archive_format_not_supported",
        defaultMessage: "Preview is not available for this file type."
    },
    unsupported_file_format: {
        id: "fabric.media.unsupported_file_format",
        defaultMessage: "Unsupported file format"
    },
    file_too_large_to_preview: {
        id: "fabric.media.file_too_large_to_preview",
        defaultMessage: "File is too large to preview"
    },
    file_too_large_description: {
        id: "fabric.media.file_too_large_description",
        defaultMessage: "Preview isn't available for files of this size."
    },
    webgl_warning_description: {
        id: "fabric.media.webgl_warning_description",
        defaultMessage: "Your browser does not support WebGL. Use a WebGL enabled browser to annotate images."
    },
    unable_to_annotate_image: {
        id: "fabric.media.unable_to_annotate_image",
        defaultMessage: "You're unable to annotate this image"
    },
    learn_more: {
        id: "fabric.media.learn_more",
        defaultMessage: "Learn More"
    },
    accounts: {
        id: "fabric.media.accounts",
        defaultMessage: "Accounts"
    },
    actions: {
        id: "fabric.media.actions",
        defaultMessage: "Actions"
    },
    error_hint_retry: {
        id: "fabric.media.error_hint_retry",
        defaultMessage: "Try again and we'll give it another shot."
    },
    error_hint_critical: {
        id: "fabric.media.error_hint_critical",
        defaultMessage: "If the problem keeps happening contact support."
    },
    close: {
        id: "fabric.media.close",
        defaultMessage: "Close"
    },
    could_not_load_editor: {
        id: "fabric.media.could_not_load_editor",
        defaultMessage: "Ouch! We could not load the editor"
    },
    could_not_save_image: {
        id: "fabric.media.could_not_save_image",
        defaultMessage: "Ouch! We could not save the image"
    },
    could_not_load_link: {
        id: "fabric.media.couldnt_load_link",
        defaultMessage: "We couldn't load this link for an unknown reason."
    },
    annotate: {
        id: "fabric.media.annotate",
        defaultMessage: "Annotate"
    },
    annotate_tool_arrow: {
        id: "fabric.media.annotate.tool.arrow",
        defaultMessage: "Arrow"
    },
    annotate_tool_text: {
        id: "fabric.media.annotate.tool.text",
        defaultMessage: "Text"
    },
    annotate_tool_shape: {
        id: "fabric.media.annotate.tool.shape",
        defaultMessage: "Shape"
    },
    annotate_tool_brush: {
        id: "fabric.media.annotate.tool.brush",
        defaultMessage: "Brush"
    },
    annotate_tool_blur: {
        id: "fabric.media.annotate.tool.blur",
        defaultMessage: "Blur"
    },
    annotate_tool_line_thickness: {
        id: "fabric.media.annotate.tool.line.thickness",
        defaultMessage: "Line thickness"
    },
    annotate_tool_color: {
        id: "fabric.media.annotate.tool.color",
        defaultMessage: "Color"
    },
    annotate_confirmation_close_anyway: {
        id: "fabric.media.annotate.confirmation.close.anyway",
        defaultMessage: "Close anyway"
    },
    annotate_confirmation_heading: {
        id: "fabric.media.annotate.confirmation.heading",
        defaultMessage: "Unsaved changes"
    },
    annotate_confirmation_content: {
        id: "fabric.media.annotate.confirmation.content",
        defaultMessage: "You have some unsaved changes. Are you sure you want to leave?"
    },
    drop_your_files_here: {
        id: "fabric.media.drop_your_files_here",
        defaultMessage: "Drop your files here"
    },
    share_files_instantly: {
        id: "fabric.media.share_files_instantly",
        defaultMessage: "We'll share them instantly"
    },
    insert_files: {
        id: "fabric.media.insert_files",
        defaultMessage: "Insert {0, plural, one {a file} other {{0} files}}"
    },
    zoom_out: {
        id: "fabric.media.zoom_out",
        defaultMessage: "zoom out"
    },
    zoom_in: {
        id: "fabric.media.zoom_in",
        defaultMessage: "zoom in"
    },
    remove_image: {
        id: "fabric.media.remove_image",
        defaultMessage: "Remove image"
    },
    play: {
        id: "fabric.media.play",
        defaultMessage: "Play"
    },
    pause: {
        id: "fabric.media.pause",
        defaultMessage: "Pause"
    },
    disable_fullscreen: {
        id: "fabric.media.disable_fullscreen",
        defaultMessage: "disable fullscreen"
    },
    enable_fullscreen: {
        id: "fabric.media.enable_fullscreen",
        defaultMessage: "enable fullscreen"
    },
    error_loading_file: {
        id: "fabric.media.error_loading_file",
        defaultMessage: "Error loading file"
    },
    error_generating_preview: {
        id: "fabric.media.error_generating_preview",
        defaultMessage: "Error generating preview"
    },
    download: {
        id: "fabric.media.download",
        defaultMessage: "Download"
    },
    download_disabled_security_policy: {
        id: "fabric.media.download_disabled_security_policy",
        defaultMessage: "Download is blocked by your organization's security policy."
    },
    unknown: {
        id: "fabric.media.unknown",
        defaultMessage: "unknown"
    },
    document: {
        id: "fabric.media.document",
        defaultMessage: "document"
    },
    audio: {
        id: "fabric.media.audio",
        defaultMessage: "audio"
    },
    video: {
        id: "fabric.media.video",
        defaultMessage: "video"
    },
    image: {
        id: "fabric.media.image",
        defaultMessage: "image"
    },
    archive: {
        id: "fabric.media.archive",
        defaultMessage: "archive"
    },
    email: {
        id: "fabric.media.email",
        defaultMessage: "email"
    },
    text: {
        id: "fabric.media.text",
        defaultMessage: "text"
    },
    displayThumbnail: {
        id: "fabric.media.display_thumbnail",
        defaultMessage: "Display thumbnail"
    },
    search: {
        id: "fabric.media.search",
        defaultMessage: "search"
    },
    view: {
        id: "fabric.media.view",
        defaultMessage: "View"
    },
    viewIn: {
        id: "fabric.media.srclink",
        defaultMessage: "View in"
    },
    viewOriginal: {
        id: "fabric.media.srclinkunknown",
        defaultMessage: "View Original"
    },
    changeView: {
        id: "fabric.media.change_view",
        defaultMessage: "Change view"
    },
    playbackSpeed: {
        id: "fabric.media.playback_speed",
        defaultMessage: "Playback speed"
    },
    video_captions_enable: {
        id: "fabric.media.video_captions_enable",
        defaultMessage: "Closed Captions"
    },
    video_captions_select_captions: {
        id: "fabric.media.video_captions_select_captions",
        defaultMessage: "Select Captions"
    },
    video_captions_upload_captions_form_header: {
        id: "fabric.media.video_captions_upload_captions_form_header",
        defaultMessage: "Upload Captions"
    },
    video_captions_upload_captions_form_language_picker: {
        id: "fabric.media.video_captions_upload_captions_form_language_picker",
        defaultMessage: "Select the file language"
    },
    video_captions_upload_success_description: {
        id: "fabric.media.video_captions_upload_success_description",
        defaultMessage: "The caption was successfully uploaded for this video."
    },
    video_captions_upload_error_description: {
        id: "fabric.media.video_captions_upload_error_description",
        defaultMessage: "The caption failed to upload."
    },
    video_captions_delete_captions_confirmation_header: {
        id: "fabric.media.video_captions_delete_captions_confirmation_header",
        defaultMessage: "Delete Caption"
    },
    video_captions_delete_captions_confirmation_description: {
        id: "fabric.media.video_captions_delete_captions_confirmation_description",
        defaultMessage: "Please confirm that you want to delete this caption."
    },
    video_captions_delete_success_description: {
        id: "fabric.media.video_captions_delete_success_description",
        defaultMessage: "The caption was successfully removed from this video."
    },
    video_captions_delete_error_description: {
        id: "fabric.media.video_captions_delete_error_description",
        defaultMessage: "The caption failed to delete."
    },
    manage_captions: {
        id: "fabric.media.manage_captions",
        defaultMessage: "Manage Captions"
    },
    add_captions: {
        id: "fabric.media.add_captions",
        defaultMessage: "Add Captions"
    },
    skipBackward: {
        id: "fabric.media.skip_backward",
        defaultMessage: "Back 10 seconds"
    },
    skipForward: {
        id: "fabric.media.skip_forward",
        defaultMessage: "Forward 10 seconds"
    },
    sizeOptions: {
        id: "fabric.media.size_options",
        defaultMessage: "Size options"
    },
    fileDisplayOptions: {
        id: "fabric.media.file.display_options",
        defaultMessage: "Display options"
    },
    volumeLevelControlAria: {
        id: "fabric.media.volume_level",
        defaultMessage: "volume"
    },
    volumeMuteButtonAria: {
        id: "fabric.media.volume_level",
        defaultMessage: "mute"
    },
    playbackDefaultSpeed: {
        id: "fabric.media.playback_default_speed",
        defaultMessage: "Default"
    },
    expand: {
        id: "fabric.media.expand",
        defaultMessage: "Expand"
    },
    preview: {
        id: "fabric.media.preview",
        defaultMessage: "Preview"
    },
    creating_preview: {
        id: "fabric.media.creating_preview",
        defaultMessage: "Creating preview..."
    },
    preview_unavailable: {
        id: "fabric.media.preview_unavailable",
        defaultMessage: "Preview unavailable"
    },
    couldnt_load_file: {
        id: "fabric.media.couldnt_load_file",
        defaultMessage: "We couldn't load the file."
    },
    error_429: {
        id: "fabric.media.error_429",
        defaultMessage: "Error 429"
    },
    close_and_reopen: {
        id: "fabric.media.close_and_reopen",
        defaultMessage: "Try closing this file and reopening."
    },
    viewer_rateLimited: {
        id: "fabric.media.viewer_rateLimited",
        defaultMessage: "We're having difficulties loading your file."
    },
    zip_entry_load_fail: {
        id: "fabric.media.zip_entry_load_failed",
        defaultMessage: "We couldn't load that zip file item to preview"
    },
    file_image_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Image {name} is selected"
    },
    file_video_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Video {name} is selected"
    },
    file_audio_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Audio {name} is selected"
    },
    file_doc_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Document {name} is selected"
    },
    file_archive_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Archive {name} is selected"
    },
    file_unknown_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "File {name} is selected"
    },
    open_file_in_viewer: {
        id: "fabric.media.open_file_in_viewer",
        defaultMessage: "Open {name}"
    },
    open_file_in_viewer_aria_label: {
        id: "fabric.media.open_file_in_viewer_aria_label",
        defaultMessage: "Open {name} in fullscreen"
    },
    video_seeker_assistive_text_time_value: {
        id: "fabric.media.video_seeker_assistive_text_time_value",
        defaultMessage: "{currentTimeHours} {currentTimeMinutes} {currentTimeSeconds} of {videoTotalHours} {videoTotalMinutes} {videoTotalSeconds}"
    },
    video_seeker_label_assistive_text: {
        id: "fabric.media.video_seeker_label_assistive_text",
        defaultMessage: "Seek slider"
    },
    abuse_modal_body: {
        id: "fabric.media.abuse_modal_body",
        defaultMessage: "For your security, our system automatically scans all uploaded files. The file you are about to download potentially contains malicious content"
    },
    abuse_modal_title: {
        id: "fabric.media.abuse_modal_title",
        defaultMessage: "Warning"
    },
    abuse_modal_submit: {
        id: "fabric.media.abuse_modal_submit",
        defaultMessage: "Proceed with download"
    },
    image_cropper_arrow_keys_label: {
        id: "media.media-avatar-picker.image-cropper.arrow-keys.label",
        defaultMessage: "Draggable Image, Ensure your screen reader is not in browse mode. use arrow keys to move & crop the image"
    },
    image_cropper_image_moved: {
        id: "media.media-avatar-picker.image-cropper.arrow-keys.action",
        defaultMessage: "You have moved the image from {key, select, left {left to right} right {right to left} top {top to bottom} other {bottom to top} }, use arrow keys to move & crop the image"
    },
    image_cropper_zoom_out: {
        id: "media.media-avatar-picker.image-cropper.zoom_out",
        defaultMessage: "Zoom out"
    },
    image_cropper_zoom_in: {
        id: "media.media-avatar-picker.image-cropper.zoom_in",
        defaultMessage: "Zoom in"
    },
    image_cropper_zoom_slider: {
        id: "media.media-avatar-picker.image-cropper.zoom_slider",
        defaultMessage: "set zoom"
    },
    image_placer_img_alt: {
        id: "media.media-avatar-picker.image-placer.image-alt",
        defaultMessage: "Image preview"
    },
    svg_base_alt: {
        id: "media.media-viewer.base-svg.alt",
        defaultMessage: "Svg Image"
    },
    archive_download_label_assistive_text: {
        id: "media.media-viewer.archive-sidebar.wrapper.label_assistive_text",
        defaultMessage: "Download Media"
    }
});
module.exports["messages"] = $c226a72f375a9da1$export$defe85febe8b728c;

});

parcelRegister("c2smn", function(module, exports) {

var $iC5Q5 = parcelRequire("iC5Q5");


var $hsnIS = parcelRequire("hsnIS");


var $adEwt = parcelRequire("adEwt");

const $a3703bbade11fb84$export$b79c645ae6a0e5c7 = (flags)=>{
    const pairs = Object.entries(flags);
    return pairs.filter(([_key, value])=>!!value).map(([key])=>key);
};
const $a3703bbade11fb84$export$c8bcd5e6111ea1f3 = ()=>{
    const productKeys = (0, $hsnIS.getProductKeys)();
    let ldFeatureFlags = [];
    (0, $adEwt.supportedProducts).forEach((product)=>{
        ldFeatureFlags = [
            ...ldFeatureFlags,
            ...Object.values(productKeys[product])
        ];
    });
    return ldFeatureFlags.filter((flag)=>flag !== '');
};
const $a3703bbade11fb84$export$836625761e76d373 = {
    mediaInline: false
};
function $a3703bbade11fb84$export$383e8f51978266d(flagName, featureFlags) {
    return (0, $iC5Q5.getGenericFeatureFlag)(flagName, $a3703bbade11fb84$export$836625761e76d373, featureFlags);
}
module.exports["getFeatureFlagKeysAllProducts"] = $a3703bbade11fb84$export$c8bcd5e6111ea1f3;
module.exports["getMediaFeatureFlag"] = $a3703bbade11fb84$export$383e8f51978266d;

});

parcelRegister("iC5Q5", function(module, exports) {

var $2hYl7 = parcelRequire("2hYl7");

function $cf2104adc10a7224$export$f2687d0de19e4973(flagName, defaults, featureFlags) {
    const devOverride = (0, $2hYl7.getLocalMediaFeatureFlag)(flagName);
    if (devOverride !== null) try {
        return JSON.parse(devOverride);
    } catch (e) {}
    if (featureFlags) return flagName in featureFlags ? featureFlags[flagName] : defaults[flagName];
    return defaults[flagName];
}
module.exports["getGenericFeatureFlag"] = $cf2104adc10a7224$export$f2687d0de19e4973;

});

parcelRegister("2hYl7", function(module, exports) {
// window.localStorage is easier to mock in tests if wrapped in this module
const $8ed9ff59a41a6857$export$d125817a2695dbc9 = (key)=>{
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return typeof window !== 'undefined' && window.localStorage ? // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        window.localStorage.getItem(key) : null;
    } catch (e) {
    // do nothing, return null by default
    }
    return null;
};
module.exports["getLocalMediaFeatureFlag"] = $8ed9ff59a41a6857$export$d125817a2695dbc9;

});

parcelRegister("hsnIS", function(module, exports) {
const $642951ddc1f8ae05$var$productKeys = {
    confluence: {
        mediaInline: ''
    },
    jira: {
        // Manged by Linking Platform. No Rollout plan found for Jira
        mediaInline: ''
    }
};
const $642951ddc1f8ae05$export$189fe120be7e73fc = ()=>$642951ddc1f8ae05$var$productKeys;
module.exports["getProductKeys"] = $642951ddc1f8ae05$export$189fe120be7e73fc;

});

parcelRegister("adEwt", function(module, exports) {
// Media feature flags - type and defaults defined here in one source of truth
const $55eb57bebd45f4d3$export$2db74afa1ef496f1 = [
    'confluence',
    'jira'
];
module.exports["supportedProducts"] = $55eb57bebd45f4d3$export$2db74afa1ef496f1;

});

parcelRegister("cvZVo", function(module, exports) {
const $b878f2b45b924d24$export$4e33ccde53b4f0bf = (fileState)=>{
    switch(fileState.status){
        case 'processing':
        case 'processed':
        case 'failed-processing':
            return !!(fileState.representations && fileState.representations.image);
        default:
            return false;
    }
};
module.exports["isImageRepresentationReady"] = $b878f2b45b924d24$export$4e33ccde53b4f0bf;

});

parcelRegister("gjPL4", function(module, exports) {
const $2cc17340c0c1baf9$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $2cc17340c0c1baf9$export$aeb48196afcd236a = {
    width: 435,
    height: 125
};
const $2cc17340c0c1baf9$export$1ad38773a5cc4cb0 = {
    width: 300,
    height: 300
};
const $2cc17340c0c1baf9$export$ed7b8a4728e9c63 = (appearance)=>{
    if (appearance === 'image') return $2cc17340c0c1baf9$export$d87a47989c00f322;
    if (appearance === 'square') return $2cc17340c0c1baf9$export$1ad38773a5cc4cb0;
    if (appearance === 'horizontal') return $2cc17340c0c1baf9$export$aeb48196afcd236a;
    return $2cc17340c0c1baf9$export$d87a47989c00f322;
};
module.exports["defaultImageCardDimensions"] = $2cc17340c0c1baf9$export$d87a47989c00f322;
module.exports["getDefaultCardDimensions"] = $2cc17340c0c1baf9$export$ed7b8a4728e9c63;

});

parcelRegister("8TTbR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $j3UOY = parcelRequire("j3UOY");


var $gWRZb = parcelRequire("gWRZb");

const $75428e9db26defa4$var$DURATION_MIN = 0.5;
const $75428e9db26defa4$var$DURATION_MAX = 1.0;
const $75428e9db26defa4$var$EXTRA_PADDING = 4;
const $75428e9db26defa4$export$ba458cf715b18bd1 = {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true
};
const $75428e9db26defa4$export$9f2ec2b609810bce = 'media-filmstrip-list-item';
class $75428e9db26defa4$export$817db220b90d8024 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    get offset() {
        const { offset: offset } = this.props;
        if (!offset) return 0;
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    get minOffset() {
        return 0;
    }
    /**
   * The furthest we can scroll, where the end of the buffer is just in view
   */ get maxOffset() {
        const { bufferWidth: bufferWidth, windowWidth: windowWidth } = this.state;
        return Math.max(this.minOffset, bufferWidth - windowWidth - 1);
    }
    get canGoLeft() {
        return this.offset > this.minOffset;
    }
    get canGoRight() {
        return this.offset < this.maxOffset;
    }
    get transitionDuration() {
        const { animate: animate } = this.props;
        const { windowWidth: windowWidth } = this.state;
        if (!animate) return 0;
        if (Math.abs(this.offset - this.previousOffset) < 1e-6) return $75428e9db26defa4$var$DURATION_MIN;
        else {
            const diff = Math.abs(this.offset - this.previousOffset);
            const relativeOffset = diff / windowWidth;
            const duration = $75428e9db26defa4$var$DURATION_MAX - $75428e9db26defa4$var$DURATION_MIN * relativeOffset;
            return Math.max(Math.min(duration, $75428e9db26defa4$var$DURATION_MAX), $75428e9db26defa4$var$DURATION_MIN);
        }
    }
    initMutationObserver() {
        const { mutationObserver: mutationObserver } = this;
        if (mutationObserver && this.bufferElement) {
            mutationObserver.disconnect();
            mutationObserver.observe(this.bufferElement, $75428e9db26defa4$export$ba458cf715b18bd1);
        }
    }
    // find the child that is cut off on the left edge of the window and change the window offset to
    // start to the left of that child
    getClosestForLeft(offset) {
        const leftWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset));
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (leftWindowEdge >= childBounds.left && leftWindowEdge <= childBounds.right) {
                const newOffset = i === 0 ? childBounds.left : childBounds.right;
                if (newOffset >= $75428e9db26defa4$var$EXTRA_PADDING) return newOffset - $75428e9db26defa4$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    // find the child that is cut off on the right edge of the window and change the window offset
    // to finish at start of the next child
    getClosestForRight(offset) {
        const { windowWidth: windowWidth } = this.state;
        const rightWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset)) + windowWidth;
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (rightWindowEdge >= childBounds.left && rightWindowEdge <= childBounds.right) {
                const newOffset = (i === this.childOffsets.length - 1 ? childBounds.right : childBounds.left) - windowWidth;
                if (newOffset + $75428e9db26defa4$var$EXTRA_PADDING <= this.maxOffset) return newOffset + $75428e9db26defa4$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    renderLeftArrow() {
        const { canGoLeft: canGoLeft } = this;
        if (!canGoLeft) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.LeftArrow), {
            onClick: this.handleLeftClick
        });
    }
    renderRightArrow() {
        const { canGoRight: canGoRight } = this;
        if (!canGoRight) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.RightArrow), {
            onClick: this.handleRightClick
        });
    }
    componentDidMount() {
        this.previousOffset = this.offset;
        window.addEventListener('resize', this.handleSizeChange);
    }
    componentWillUnmount() {
        const { mutationObserver: mutationObserver } = this;
        window.removeEventListener('resize', this.handleSizeChange);
        if (mutationObserver) mutationObserver.disconnect();
    }
    componentDidUpdate() {
        this.previousOffset = this.offset;
    }
    render() {
        const { animate: animate, children: children, testId: testId } = this.props;
        const transform = `translateX(${-this.offset}px)`;
        const transitionProperty = animate ? 'transform' : 'none';
        const transitionDuration = `${this.transitionDuration}s`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.FilmStripViewWrapper), {
            "data-testid": testId
        }, this.renderLeftArrow(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.FilmStripListWrapper), {
            ref: this.handleWindowElementChange,
            onWheel: this.handleScroll,
            onTouchStart: this.handleTouchStart,
            onTouchMove: this.handleTouchMove,
            onTouchEnd: this.handleTouchEnd,
            "data-testid": "filmstrip-list-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.FilmStripList), {
            ref: this.handleBufferElementChange,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                transform: transform,
                transitionProperty: transitionProperty,
                transitionDuration: transitionDuration
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, $75428e9db26defa4$var$mapReactChildToReactNode))), this.renderRightArrow());
    }
    constructor(props){
        super(props);
        this.bufferElement = void 0;
        this.windowElement = void 0;
        this.mutationObserver = void 0;
        this.childOffsets = void 0;
        this.previousOffset = 0;
        this.state = {
            bufferWidth: 0,
            windowWidth: 0,
            touchMoveStartPosition: 0,
            isTouchMoveInProgress: false
        };
        this.handleSizeChange = ()=>{
            // get the new widths
            const { windowElement: windowElement, bufferElement: bufferElement } = this;
            let bufferWidth = 0;
            let windowWidth = 0;
            let childOffsets = [];
            if (windowElement && bufferElement) {
                bufferWidth = bufferElement.getBoundingClientRect().width;
                windowWidth = windowElement.getBoundingClientRect().width;
                // we're calculating `left` based on `width` because `rect.left` can be a negative value after resizing the window (considered scrolled??)
                const children = Array.prototype.slice.call(bufferElement.children, 0);
                let left = 0;
                childOffsets = children.map((child, _index)=>{
                    const width = child.getBoundingClientRect().width;
                    const offset = {
                        left: left,
                        right: left + width - 1
                    };
                    left += width;
                    return offset;
                });
            }
            // make sure the state has changed before we update state and notify the integrator
            // (otherwise, since this method() is called in componentDidUpdate() we'll recurse until the stack size is exceeded)
            const { bufferWidth: prevBufferWidth, windowWidth: prevWindowWidth } = this.state;
            if (bufferWidth === prevBufferWidth && windowWidth === prevWindowWidth) // NOTE: we're not checking here if childOffsets has changed... if the children change size but
            // result in the exact same size buffer, we're not going to update, resulting in incorrect navigations
            return;
            // store the widths
            this.setState({
                bufferWidth: bufferWidth,
                windowWidth: windowWidth
            }, ()=>{
                this.childOffsets = childOffsets;
                // notify the integrator
                const { onSize: onSize } = this.props;
                if (onSize) onSize({
                    offset: Math.min(this.maxOffset, this.offset),
                    offsets: childOffsets,
                    width: windowWidth,
                    minOffset: this.minOffset,
                    maxOffset: this.maxOffset
                });
            });
        };
        this.handleWindowElementChange = (windowElement)=>{
            this.windowElement = windowElement;
            this.handleSizeChange();
        };
        this.handleBufferElementChange = (bufferElement)=>{
            if (!bufferElement) return;
            this.bufferElement = bufferElement;
            this.handleSizeChange();
            this.initMutationObserver();
        };
        this.handleMutation = (_mutationList)=>{
            // there are edge cases where the DOM may change outside of the normal React life-cycle
            // https://product-fabric.atlassian.net/browse/MSW-425
            this.handleSizeChange();
        };
        this.handleLeftClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForLeft(this.offset - windowWidth);
                if (newOffset >= this.offset) // if for some reason we tried to scroll left but it didn't scroll or scrolls right instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.max(this.offset - windowWidth, this.minOffset);
                onScroll({
                    direction: 'left',
                    offset: newOffset,
                    animate: true
                });
            }
        };
        this.handleRightClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForRight(this.offset + windowWidth);
                if (newOffset <= this.offset) // if for some reason we tried to scroll right but it didn't scroll or scrolls left instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.min(this.offset + windowWidth, this.maxOffset);
                onScroll({
                    direction: 'right',
                    offset: newOffset,
                    animate: true
                });
            }
        };
        this.handleScroll = (event)=>{
            const isHorizontalScroll = Math.abs(event.deltaX) > Math.abs(event.deltaY);
            if (!isHorizontalScroll) return;
            // don't actually let the element scroll because we'll fake scrolling with `transform: translateX()`
            event.preventDefault();
            // notify the integrator of the offset change
            const { onScroll: onScroll } = this.props;
            if (onScroll && isHorizontalScroll) {
                const newOffset = Math.max(this.minOffset, Math.min(this.maxOffset, this.offset + event.deltaX));
                onScroll({
                    direction: event.deltaX < 0 ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.handleTouchStart = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: true
            });
        };
        this.handleTouchEnd = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: false
            });
        };
        this.handleTouchMove = (event)=>{
            const { onScroll: onScroll } = this.props;
            if (this.state.isTouchMoveInProgress && onScroll) {
                const currentPosition = event.touches[0].clientX;
                const newOffset = this.state.touchMoveStartPosition ? this.offset - (currentPosition - this.state.touchMoveStartPosition) : this.offset;
                onScroll({
                    direction: newOffset > this.offset ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.childOffsets = [];
        try {
            this.mutationObserver = new MutationObserver((0, (/*@__PURE__*/$parcel$interopDefault($j3UOY)))(this.handleMutation, 30, true));
        // eslint-disable-next-line no-unused-vars
        } catch (e) {
        // in the case where we are running on an unsupported browser,
        // or where tests include the FilmstripView but do not mock the MutationObserver - we catch it and handle safely here.
        // NOTE: this won't effect the component, it just means mutations won't be observerd
        }
    }
}
$75428e9db26defa4$export$817db220b90d8024.defaultProps = {
    animate: false,
    offset: 0
};
function $75428e9db26defa4$var$mapReactChildToReactNode(child, index) {
    const key = $75428e9db26defa4$var$isReactElement(child) && child.key || index;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.FilmStripListItem), {
        key: key,
        index: key
    }, child);
}
function $75428e9db26defa4$var$isReactElement(child) {
    return !!child.type;
}
module.exports["MediaFilmStripListItemSelector"] = $75428e9db26defa4$export$9f2ec2b609810bce;
module.exports["FilmstripView"] = $75428e9db26defa4$export$817db220b90d8024;

});

parcelRegister("j3UOY", function(module, exports) {
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function $de0a5fa3d60c62bd$var$debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}
// Adds compatibility for ES modules
$de0a5fa3d60c62bd$var$debounce.debounce = $de0a5fa3d60c62bd$var$debounce;
module.exports = $de0a5fa3d60c62bd$var$debounce;

});

parcelRegister("gWRZb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jXJyv = parcelRequire("jXJyv");

const $8dba4ca83cef8f6b$export$924abd21043fc000 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ArrowLeftWrapper), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ArrowLeftWrapper), props);
const $8dba4ca83cef8f6b$export$a5ffe38c17bbc0a1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ShadowRight), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ShadowRight), props);
const $8dba4ca83cef8f6b$export$abf07652016c7e56 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ArrowRightWrapper), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ArrowRightWrapper), props);
const $8dba4ca83cef8f6b$export$b39b1b86b48b621f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.LeftArrow), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.LeftArrow), props);
const $8dba4ca83cef8f6b$export$6208675820d4cc50 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.RightArrow), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.RightArrow), props);
const $8dba4ca83cef8f6b$export$d37eb83491863cbb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripViewWrapper), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripViewWrapper), props);
const $8dba4ca83cef8f6b$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripListWrapper), {
            ...props,
            ref: ref
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripListWrapper), {
        ...props,
        ref: ref
    }));
const $8dba4ca83cef8f6b$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripList), {
            ...props,
            ref: ref
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripList), {
        ...props,
        ref: ref
    }));
const $8dba4ca83cef8f6b$export$54cfc70c184c0713 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripListItem), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripListItem), props);
module.exports["LeftArrow"] = $8dba4ca83cef8f6b$export$b39b1b86b48b621f;
module.exports["RightArrow"] = $8dba4ca83cef8f6b$export$6208675820d4cc50;
module.exports["FilmStripViewWrapper"] = $8dba4ca83cef8f6b$export$d37eb83491863cbb;
module.exports["FilmStripListWrapper"] = $8dba4ca83cef8f6b$export$4b7fe5339e3afada;
module.exports["FilmStripList"] = $8dba4ca83cef8f6b$export$710ee13c74b7a1f0;
module.exports["FilmStripListItem"] = $8dba4ca83cef8f6b$export$54cfc70c184c0713;

});

parcelRegister("jXJyv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kdlgT = parcelRequire("kdlgT");


var $aRvnq = parcelRequire("aRvnq");


var $iDrrr = parcelRequire("iDrrr");


var $8TTbR = parcelRequire("8TTbR");

const $b735c99c0da4e1ae$var$filmStripViewStyles = null;
const $b735c99c0da4e1ae$var$filmStripListWrapperStyles = null;
const $b735c99c0da4e1ae$var$filmStripListStyles = null;
const $b735c99c0da4e1ae$var$filmStripListItemStyles = null;
const $b735c99c0da4e1ae$var$arrowWrapperStyles = null;
const $b735c99c0da4e1ae$var$arrowWrapperMotionStyles = null;
const $b735c99c0da4e1ae$var$arrowLeftWrapperStyles = null;
const $b735c99c0da4e1ae$var$arrowRightWrapperStyles = null;
const $b735c99c0da4e1ae$var$shadowStyles = null;
const $b735c99c0da4e1ae$var$resetButtonStyle = null;
const $b735c99c0da4e1ae$var$shadowLeftStyles = null;
const $b735c99c0da4e1ae$var$shadowRightStyles = null;
const $b735c99c0da4e1ae$var$ShadowLeft = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1mT5xdWVPG _42Yu6B3p0A _0jFU0VN91d _2IhTondnbC _39xV024Jdh _0KLXru9r67",
            "_3OE6xYdnbC"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _42Yu6B3p0A _0jFU0VN91d _2IhTondnbC _39xV024Jdh _0KLXru9r67",
            "_3OE6xYdnbC"
        ])
    }, children);
const $b735c99c0da4e1ae$export$924abd21043fc000 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, onClick: onClick } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1mb4UnZqHV _3iDTPbvLZJ",
            "_0bjKvDS5Zs _23rrnHyKLB _1mT5xdWVPG _2IhTon715P _1VJPcakruI _0KLXruoI2d _3iDTPbQ4SZ _0wOv4Q7zJH _2OUyjtGk8v _1UtDYz8ujp _39xV02uNcX _0jFU0VuNcX _37wbyuDIqT _1YKVNsdnbC _2Qxi4nuNcX _27VeLCSPN1 _0clgaMZpcK _1eOmH6hWTW _3sFUREiSCN _0CMRbkjTy9 _3gzVzLY9q9",
            "_3OE6xY2ADO _20JdpsFQfX",
            (0, $iDrrr.fg)("platform-dst-motion-uplift-custom-button") && "_23rrnHyKLB _3sFUREiSCN",
            "arrow"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onClick) {
        t2 = (event)=>onClick && onClick(event);
        $[1] = onClick;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== children || $[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
            className: t1,
            onClick: t2
        }, children);
        $[3] = children;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ children: children, onClick: onClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            "_1mb4UnZqHV _3iDTPbvLZJ",
            "_0bjKvDS5Zs _23rrnHyKLB _1mT5xdWVPG _2IhTon715P _1VJPcakruI _0KLXruoI2d _3iDTPbQ4SZ _0wOv4Q7zJH _2OUyjtGk8v _1UtDYz8ujp _39xV02uNcX _0jFU0VuNcX _37wbyuDIqT _1YKVNsdnbC _2Qxi4nuNcX _27VeLCSPN1 _0clgaMZpcK _1eOmH6hWTW _3sFUREiSCN _0CMRbkjTy9 _3gzVzLY9q9",
            "_3OE6xY2ADO _20JdpsFQfX",
            (0, $iDrrr.fg)('platform-dst-motion-uplift-custom-button') && "_23rrnHyKLB _3sFUREiSCN",
            "arrow"
        ]),
        onClick: (event)=>onClick && onClick(event)
    }, children);
};
const $b735c99c0da4e1ae$export$a5ffe38c17bbc0a1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1mT5xdWVPG _42Yu6B3p0A _0jFU0VN91d _2IhTondnbC _39xV024Jdh _0KLXru9r67",
            "_4ApkO2dnbC"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _42Yu6B3p0A _0jFU0VN91d _2IhTondnbC _39xV024Jdh _0KLXru9r67",
            "_4ApkO2dnbC"
        ])
    }, children);
const $b735c99c0da4e1ae$export$abf07652016c7e56 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, onClick: onClick } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1mb4UnZqHV _3iDTPbvLZJ",
            "_0bjKvDS5Zs _23rrnHyKLB _1mT5xdWVPG _2IhTon715P _1VJPcakruI _0KLXruoI2d _3iDTPbQ4SZ _0wOv4Q7zJH _2OUyjtGk8v _1UtDYz8ujp _39xV02uNcX _0jFU0VuNcX _37wbyuDIqT _1YKVNsdnbC _2Qxi4nuNcX _27VeLCSPN1 _0clgaMZpcK _1eOmH6hWTW _3sFUREiSCN _0CMRbkjTy9 _3gzVzLY9q9",
            "_4ApkO22ADO _0woc9oFQfX",
            (0, $iDrrr.fg)("platform-dst-motion-uplift-custom-button") && "_23rrnHyKLB _3sFUREiSCN",
            "arrow"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onClick) {
        t2 = (event)=>onClick && onClick(event);
        $[1] = onClick;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== children || $[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
            className: t1,
            onClick: t2
        }, children);
        $[3] = children;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ children: children, onClick: onClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            "_1mb4UnZqHV _3iDTPbvLZJ",
            "_0bjKvDS5Zs _23rrnHyKLB _1mT5xdWVPG _2IhTon715P _1VJPcakruI _0KLXruoI2d _3iDTPbQ4SZ _0wOv4Q7zJH _2OUyjtGk8v _1UtDYz8ujp _39xV02uNcX _0jFU0VuNcX _37wbyuDIqT _1YKVNsdnbC _2Qxi4nuNcX _27VeLCSPN1 _0clgaMZpcK _1eOmH6hWTW _3sFUREiSCN _0CMRbkjTy9 _3gzVzLY9q9",
            "_4ApkO22ADO _0woc9oFQfX",
            (0, $iDrrr.fg)('platform-dst-motion-uplift-custom-button') && "_23rrnHyKLB _3sFUREiSCN",
            "arrow"
        ]),
        onClick: (event)=>onClick && onClick(event)
    }, children);
};
const $b735c99c0da4e1ae$export$b39b1b86b48b621f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { onClick: onClick } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))), {
            color: "currentColor",
            spacing: "spacious",
            label: "left"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onClick) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$var$ShadowLeft, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$924abd21043fc000, {
            onClick: onClick
        }, t1));
        $[1] = onClick;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$var$ShadowLeft, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$924abd21043fc000, {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))), {
        color: "currentColor",
        spacing: "spacious",
        label: "left"
    })));
const $b735c99c0da4e1ae$export$6208675820d4cc50 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { onClick: onClick } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
            color: "currentColor",
            spacing: "spacious",
            label: "right"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onClick) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$a5ffe38c17bbc0a1, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$abf07652016c7e56, {
            onClick: onClick
        }, t1));
        $[1] = onClick;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$a5ffe38c17bbc0a1, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$abf07652016c7e56, {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
        color: "currentColor",
        spacing: "spacious",
        label: "right"
    })));
const $b735c99c0da4e1ae$export$d37eb83491863cbb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, "data-testid": dataTestId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_0bjKvDzXzM _1mT5xdRAKS _0Of8r2FQfX _1ZnuxbdnbC _1wydGWFQfX _2Zuz6QdnbC _4FvuRP7dHp _05i3wkzUZr"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== dataTestId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": dataTestId,
            className: t1
        }, children);
        $[1] = children;
        $[2] = dataTestId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ children: children, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": dataTestId,
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _1mT5xdRAKS _0Of8r2FQfX _1ZnuxbdnbC _1wydGWFQfX _2Zuz6QdnbC _4FvuRP7dHp _05i3wkzUZr"
        ])
    }, children);
const $b735c99c0da4e1ae$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(9);
    const { children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, "data-testid": dataTestId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _39xV02OLYo _0Of8r2FQfX _1ZnuxbFQfX _1wydGWFQfX _2Zuz6QFQfX"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== dataTestId || $[3] !== onTouchEnd || $[4] !== onTouchMove || $[5] !== onTouchStart || $[6] !== onWheel || $[7] !== ref) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: ref,
            onWheel: onWheel,
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd,
            "data-testid": dataTestId,
            className: t1
        }, children);
        $[1] = children;
        $[2] = dataTestId;
        $[3] = onTouchEnd;
        $[4] = onTouchMove;
        $[5] = onTouchStart;
        $[6] = onWheel;
        $[7] = ref;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, 'data-testid': dataTestId }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref,
        onWheel: onWheel,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        "data-testid": dataTestId,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _39xV02OLYo _0Of8r2FQfX _1ZnuxbFQfX _1wydGWFQfX _2Zuz6QFQfX"
        ])
    }, children));
const $b735c99c0da4e1ae$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, style: style } = t0;
    const t1 = ref;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2AASz _1ZnuxbAASz _1wydGWAASz _2Zuz6QAASz _1kOSYtC67X _0qk6IKBr0D _1ANEUSLRg7 _3iDTPbvbI6"
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== children || $[2] !== style || $[3] !== t1) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
            ref: t1,
            style: style,
            className: t2
        }, children);
        $[1] = children;
        $[2] = style;
        $[3] = t1;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ children: children, style: style }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
        ref: ref,
        style: style,
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2AASz _1ZnuxbAASz _1wydGWAASz _2Zuz6QAASz _1kOSYtC67X _0qk6IKBr0D _1ANEUSLRg7 _3iDTPbvbI6"
        ])
    }, children));
const $b735c99c0da4e1ae$export$54cfc70c184c0713 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, index: index } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0aNu0LYbGa _0Of8r2dnbC _1Znuxb1Y8M _1wydGWdnbC _2Zuz6Q1Y8M _3iDTPbvbI6 _1RrJLit2nV _4ya3eEdnbC _3NdKS6dnbC",
            (0, $8TTbR.MediaFilmStripListItemSelector)
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== index) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
            className: t1,
            "data-testid": "media-filmstrip-list-item",
            key: index
        }, children);
        $[1] = children;
        $[2] = index;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ children: children, index: index })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0aNu0LYbGa _0Of8r2dnbC _1Znuxb1Y8M _1wydGWdnbC _2Zuz6Q1Y8M _3iDTPbvbI6 _1RrJLit2nV _4ya3eEdnbC _3NdKS6dnbC",
            (0, $8TTbR.MediaFilmStripListItemSelector)
        ]),
        "data-testid": "media-filmstrip-list-item",
        key: index
    }, children);
module.exports["ArrowLeftWrapper"] = $b735c99c0da4e1ae$export$924abd21043fc000;
module.exports["ShadowRight"] = $b735c99c0da4e1ae$export$a5ffe38c17bbc0a1;
module.exports["ArrowRightWrapper"] = $b735c99c0da4e1ae$export$abf07652016c7e56;
module.exports["LeftArrow"] = $b735c99c0da4e1ae$export$b39b1b86b48b621f;
module.exports["RightArrow"] = $b735c99c0da4e1ae$export$6208675820d4cc50;
module.exports["FilmStripViewWrapper"] = $b735c99c0da4e1ae$export$d37eb83491863cbb;
module.exports["FilmStripListWrapper"] = $b735c99c0da4e1ae$export$4b7fe5339e3afada;
module.exports["FilmStripList"] = $b735c99c0da4e1ae$export$710ee13c74b7a1f0;
module.exports["FilmStripListItem"] = $b735c99c0da4e1ae$export$54cfc70c184c0713;

});

parcelRegister("cLgZp", function(module, exports) {
const $01246376cedc8400$export$4369c812aac99591 = (p)=>!!(p && p.then);
module.exports["isPromise"] = $01246376cedc8400$export$4369c812aac99591;

});

parcelRegister("lUcpS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $k78uC = parcelRequire("k78uC");


var $8IfK6 = parcelRequire("8IfK6");

const $91b0a64470223be6$export$5bf35293e545f20c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (...t1)=>{
            const params = t1;
            const event = createAnalyticsEvent((0, $8IfK6.default)(...params));
            event.fire((0, $k78uC.EVENT_CHANNEL));
        };
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const fireEvent = t0;
    let t1;
    if ($[2] !== fireEvent) {
        t1 = {
            fireEvent: fireEvent
        };
        $[2] = fireEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireEvent = (0, $cozmU.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $8IfK6.default)(...params));
        event.fire((0, $k78uC.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};
module.exports["useAnalyticsEvents"] = $91b0a64470223be6$export$5bf35293e545f20c;

});

parcelRegister("k78uC", function(module, exports) {
const $0de3cce3bcdfa361$export$3f072f06b90c3985 = 'peopleTeams';
module.exports["EVENT_CHANNEL"] = $0de3cce3bcdfa361$export$3f072f06b90c3985;

});

parcelRegister("8IfK6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::378c0a04d2cca8641793d5a92fac3d1a>>
 * @codegenCommand afm workspace @atlassian/analytics-tooling analytics:codegen teams-app-internal-analytics
 */ const $fcb00cbaaafbad36$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $fcb00cbaaafbad36$export$2e2bcd8739ae039 = $fcb00cbaaafbad36$var$createEventPayload;
module.exports["default"] = $fcb00cbaaafbad36$export$2e2bcd8739ae039;

});

parcelRegister("cSSWJ", function(module, exports) {
const $e8b102093dcaac45$export$849551cf61929d4f = {
    packageName: "platform-pkg" ?? '',
    packageVersion: "0.0.0-use.local" ?? ''
};
const $e8b102093dcaac45$export$efd16d9cf43b6e97 = 'teamProfileCard';
const $e8b102093dcaac45$export$7611b3e6899481f9 = 'profilecard';
const $e8b102093dcaac45$export$4c23d6e68fa71371 = 'rovoAgentProfilecard';
module.exports["PACKAGE_META_DATA"] = $e8b102093dcaac45$export$849551cf61929d4f;
module.exports["TEAM_SUBJECT"] = $e8b102093dcaac45$export$efd16d9cf43b6e97;
module.exports["USER_SUBJECT"] = $e8b102093dcaac45$export$7611b3e6899481f9;
module.exports["AGENT_SUBJECT"] = $e8b102093dcaac45$export$4c23d6e68fa71371;

});

parcelRegister("4PAHv", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $7G50J = parcelRequire("7G50J");


var $hMCZS = parcelRequire("hMCZS");


var $lUcpS = parcelRequire("lUcpS");


var $dSW04 = parcelRequire("dSW04");


var $dRAjC = parcelRequire("dRAjC");


var $4k5Wq = parcelRequire("4k5Wq");


var $kb2tZ = parcelRequire("kb2tZ");


var $hIwXM = parcelRequire("hIwXM");

const $fe1c8bc12e81e628$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $cozmU.useState)();
    // Initialize as true when fix is enabled since we fetch immediately on mount,
    // avoiding a brief error screen flash before the useEffect fires.
    const [isLoading, setIsLoading] = (0, $cozmU.useState)((0, $iDrrr.fg)('confluence_fix_agent_profile_card_flash'));
    const [error, setError] = (0, $cozmU.useState)();
    const [isPermitted, setIsPermitted] = (0, $cozmU.useState)(true);
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const creatorUserId = (0, $cozmU.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $dRAjC.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const navResult = (0, $hMCZS.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: creatorUserId || ''
        },
        cloudId: props.cloudId
    });
    let profileHref = navResult.href;
    const getCreator = (0, $cozmU.useCallback)(async ({ creator_type: creator_type, creator: creator, authoringTeam: authoringTeam })=>{
        try {
            let userCreatorInfo;
            const currentCreatorUserId = (0, $iDrrr.fg)('confluence_fix_agent_profile_card_flash') ? creator_type === 'CUSTOMER' && creator ? (0, $dRAjC.getAAIDFromARI)(creator) : undefined : creatorUserId;
            if (currentCreatorUserId && props.cloudId) {
                userCreatorInfo = await props.resourceClient.getProfile(props.cloudId, currentCreatorUserId, fireEvent);
                if ((0, $iDrrr.fg)('confluence_fix_agent_profile_card_flash')) profileHref = (0, $hMCZS.navigateToTeamsApp)({
                    type: 'USER',
                    payload: {
                        userId: currentCreatorUserId
                    },
                    cloudId: props.cloudId
                }).href;
            }
            const creatorInfo = (0, $7G50J.getAgentCreator)({
                creatorType: creator_type,
                authoringTeam: authoringTeam ? {
                    displayName: authoringTeam.displayName ?? '',
                    profileLink: authoringTeam.profileUrl ?? undefined
                } : undefined,
                userCreator: userCreatorInfo ? {
                    name: userCreatorInfo.fullName ?? '',
                    profileLink: (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? profileHref : `/people/${currentCreatorUserId}`
                } : undefined,
                forgeCreator: creator ?? undefined
            });
            return creatorInfo;
        } catch  {
            return undefined;
        }
    }, [
        creatorUserId,
        fireEvent,
        props.cloudId,
        props.resourceClient,
        profileHref
    ]);
    const fetchData = (0, $cozmU.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileResult = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireEvent);
            const profileData = profileResult.restData;
            const creatorInfoProps = {
                creator_type: profileData?.creator_type,
                creator: profileData?.creator || undefined,
                authoringTeam: profileResult.aggData?.authoringTeam ?? undefined
            };
            const agentCreatorInfo = await getCreator(creatorInfoProps);
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            if (err instanceof (0, $dSW04.AgentForbiddenError) && (0, $cXtTj.default).getExperimentValue('platform_editor_reduced_agent_profile_cards', 'isEnabled', false)) setIsPermitted(false);
            else setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireEvent,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    // Depend on accountId rather than fetchData to avoid a re-fetch loop:
    // agentData changes → creatorUserId → getCreator → fetchData ref changes → useEffect re-fires.
    // Reset state on accountId change so stale data from the previous agent isn't briefly shown.
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('confluence_fix_agent_profile_card_flash')) return;
        setAgentData(undefined);
        setError(undefined);
        setIsLoading(true);
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.accountId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $iDrrr.fg)('confluence_fix_agent_profile_card_flash')) return;
        fetchData();
    }, [
        fetchData
    ]);
    const forbiddenAgent = (0, $cozmU.useMemo)(()=>(0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') ? {
            id: '',
            named_id: '',
            name: props.agentName ?? '',
            description: '\u00A0',
            creator_type: 'CUSTOMER',
            is_default: false,
            actor_type: 'AGENT',
            user_defined_conversation_starters: null,
            favourite: false,
            favourite_count: 0,
            identity_account_id: props.accountId,
            creatorInfo: undefined
        } : undefined, [
        props.agentName,
        props.accountId
    ]);
    if (!isPermitted && (0, $cXtTj.default).getExperimentValue('platform_editor_reduced_agent_profile_cards', 'isEnabled', false)) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kb2tZ.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hIwXM.AgentProfileCardLazy), {
                agent: (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') ? forbiddenAgent : {
                    id: '',
                    named_id: '',
                    name: props.agentName ?? '',
                    description: '\u00A0',
                    creator_type: 'CUSTOMER',
                    is_default: false,
                    actor_type: 'AGENT',
                    user_defined_conversation_starters: null,
                    favourite: false,
                    favourite_count: 0,
                    identity_account_id: props.accountId,
                    creatorInfo: undefined
                },
                isLoading: false,
                resourceClient: props.resourceClient,
                cloudId: props.cloudId,
                hideAgentActions: true,
                hideConversationStarters: true,
                hideAiDisclaimer: true,
                hideStarButton: props.hideStarButton,
                showCreatorNameWithoutLink: props.showCreatorNameWithoutLink,
                footerComponent: props.footerComponent
            })
        })
    });
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kb2tZ.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4k5Wq.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: fireEvent
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hIwXM.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId,
            onDeleteAgent: props.onDeleteAgent,
            hideMoreActions: props.hideMoreActions,
            hideAiDisclaimer: props.hideAiDisclaimer,
            hideConversationStarters: props.hideConversationStarters,
            hideAgentActions: props.hideAgentActions,
            hideStarButton: props.hideStarButton,
            showCreatorNameWithoutLink: props.showCreatorNameWithoutLink,
            footerComponent: props.footerComponent
        })
    });
};
module.exports["AgentProfileCardResourced"] = $fe1c8bc12e81e628$export$4b013ffffcb40af8;

});

parcelRegister("7G50J", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $i1t43 = parcelRequire("i1t43");


var $etoPX = parcelRequire("etoPX");


var $NlHoa = parcelRequire("NlHoa");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");


var $ieeJu = parcelRequire("ieeJu");


var $lpNn5 = parcelRequire("lpNn5");


var $6h4xM = parcelRequire("6h4xM");


var $i4kCF = parcelRequire("i4kCF");


var $hq9Cp = parcelRequire("hq9Cp");


var $fNIRw = parcelRequire("fNIRw");

const $f5fec235121c7193$var$styles = {
    clickableItem: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT",
    rovoIconWrapper: "_3iDTPbQ4SZ",
    name: "_37wbyuI7V3 _0hPCNLchRC",
    description: "_3SamIHPgdg _3zvHkHdC7N _3W2Oc8wPeg",
    headingWrapper: "_1mT5xdRAKS",
    hiddenIconWrapper: "_313842FQfX"
};
const $f5fec235121c7193$export$7cbebf266a9bcc3c = ({ creatorType: creatorType, authoringTeam: authoringTeam, userCreator: userCreator, forgeCreator: forgeCreator })=>{
    if (creatorType === 'SYSTEM') return {
        type: 'SYSTEM'
    };
    if ((0, $iDrrr.fg)('rovo_agent_support_a2a_avatar') ? (0, $hq9Cp.isForgeAgentByCreatorType)(creatorType) : creatorType === 'FORGE' || creatorType === 'THIRD_PARTY' // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
    ) return {
        // @todo: remove cast in rovo_agent_support_a2a_avatar cleanup
        type: (0, $iDrrr.fg)('jira_improve_agent_profile_for_a2a') ? creatorType : 'FORGE',
        name: forgeCreator ?? ''
    };
    if (creatorType === 'OOTB') return {
        type: 'OOTB'
    };
    if (creatorType === 'CUSTOMER') {
        if (authoringTeam) return {
            type: 'CUSTOMER',
            name: authoringTeam.displayName,
            profileLink: authoringTeam.profileLink ?? ''
        };
        if (!userCreator?.profileLink) return undefined;
        return {
            type: 'CUSTOMER',
            name: userCreator.name,
            profileLink: userCreator.profileLink,
            status: userCreator.status
        };
    }
    return;
};
const $f5fec235121c7193$export$f35b2eeaa7e3db15 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading, showCreatorNameWithoutLink: t1 } = t0;
    const showCreatorNameWithoutLink = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== creator || $[1] !== formatMessage || $[2] !== isLoading || $[3] !== onCreatorLinkClick || $[4] !== showCreatorNameWithoutLink) {
        const getCreatorRender = ()=>{
            if (isLoading) return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                    testId: "agent-profile-creator-skeleton",
                    isShimmering: true,
                    height: 18,
                    width: 100
                })
            });
            if (!creator) return null;
            if (creator.type === "SYSTEM" || creator.type === "OOTB") return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    alignBlock: "center",
                    testId: "atlassian-icon"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                    label: "",
                    size: "small",
                    appearance: "brand"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, "Atlassian"))
            });
            if (creator.type === "CUSTOMER") {
                const creatorName = `${creator.name} ${creator.status === "inactive" ? formatMessage((0, $fNIRw.messages).agentDeactivated) : ""}`;
                return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                    creatorNameWithLink: showCreatorNameWithoutLink ? creatorName : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                        href: creator.profileLink,
                        onClick: ()=>onCreatorLinkClick(),
                        target: "_blank"
                    }, creatorName)
                });
            }
            if (creator.type === "REMOTE_A2A") return formatMessage((0, $fNIRw.messages).remoteAgentCreatedBy, {
                creatorNameWithLink: creator.name
            });
            if (creator.type === "THIRD_PARTY" || creator.type === "FORGE") return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: creator.name
            });
            return null;
        };
        t2 = getCreatorRender();
        $[0] = creator;
        $[1] = formatMessage;
        $[2] = isLoading;
        $[3] = onCreatorLinkClick;
        $[4] = showCreatorNameWithoutLink;
        $[5] = t2;
    } else t2 = $[5];
    const creatorRender = t2;
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $ieeJu.expValEquals)("platform_editor_agent_mentions", "isEnabled", true) && (0, $iDrrr.fg)("platform_editor_agent_mentions_drop_one_fixes") || (0, $iDrrr.fg)("platform_editor_agent_card_fixes");
        $[6] = t3;
    } else t3 = $[6];
    const hideCreatorIcon = t3;
    if ((0, $iDrrr.fg)("jira_improve_agent_profile_for_a2a")) {
        const showRovoIcon = !hideCreatorIcon && creator?.type !== "REMOTE_A2A";
        let t4;
        if ($[7] !== creatorRender || $[8] !== showRovoIcon) {
            t4 = creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f5fec235121c7193$var$styles.clickableItem
            }, showRovoIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
                testId: "rovo-icon-wrapper",
                "aria-hidden": "true"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
                appearance: "brand",
                size: "small"
            })) : null, creatorRender) : null;
            $[7] = creatorRender;
            $[8] = showRovoIcon;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    let t4;
    if ($[10] !== creatorRender) {
        t4 = creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.clickableItem
        }, !hideCreatorIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
            testId: "rovo-icon-wrapper",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
            appearance: "brand",
            size: "small"
        })), creatorRender) : null;
        $[10] = creatorRender;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : ({ creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading, showCreatorNameWithoutLink: showCreatorNameWithoutLink = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const getCreatorRender = ()=>{
        if (isLoading) return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                testId: "agent-profile-creator-skeleton",
                isShimmering: true,
                height: 18,
                width: 100
            })
        });
        if (!creator) return null;
        if (creator.type === 'SYSTEM' || creator.type === 'OOTB') return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignBlock: "center",
                testId: "atlassian-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                label: "",
                size: "small",
                appearance: "brand"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, "Atlassian"))
        });
        if (creator.type === 'CUSTOMER') {
            const creatorName = `${creator.name} ${creator.status === 'inactive' ? formatMessage((0, $fNIRw.messages).agentDeactivated) : ''}`;
            return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: showCreatorNameWithoutLink ? creatorName : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: creator.profileLink,
                    onClick: ()=>onCreatorLinkClick(),
                    target: "_blank"
                }, creatorName)
            });
        }
        if (creator.type === 'REMOTE_A2A') return formatMessage((0, $fNIRw.messages).remoteAgentCreatedBy, {
            creatorNameWithLink: creator.name
        });
         // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
        if (creator.type === 'THIRD_PARTY' || creator.type === 'FORGE') return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: creator.name
        });
        return null;
    };
    const creatorRender = getCreatorRender();
    const hideCreatorIcon = (0, $ieeJu.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') || (0, $iDrrr.fg)('platform_editor_agent_card_fixes');
    if ((0, $iDrrr.fg)('jira_improve_agent_profile_for_a2a')) {
        const showRovoIcon = !hideCreatorIcon && creator?.type !== 'REMOTE_A2A';
        return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.clickableItem
        }, showRovoIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
            testId: "rovo-icon-wrapper",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
            appearance: "brand",
            size: "small"
        })) : null, creatorRender) : null;
    }
    return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.clickableItem
    }, !hideCreatorIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
        testId: "rovo-icon-wrapper",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
        appearance: "brand",
        size: "small"
    })), creatorRender) : null;
};
const $f5fec235121c7193$export$e02348ba0b01a210 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, headingRender: headingRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle, showStarButton: t1, renderAdditionalContent: renderAdditionalContent } = t0;
    const showStarButton = t1 === undefined ? true : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== agentName) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h2",
            size: "medium"
        }, agentName);
        $[0] = agentName;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== formatMessage || $[3] !== isHidden) {
        t3 = isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.hiddenIconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: formatMessage((0, $fNIRw.messages).hiddenTooltip),
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6h4xM.HiddenIcon), {
            label: formatMessage((0, $fNIRw.messages).hiddenIcon)
        })));
        $[2] = formatMessage;
        $[3] = isHidden;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== headingRender || $[6] !== t2 || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.075",
            xcss: $f5fec235121c7193$var$styles.headingWrapper
        }, t2, headingRender, t3);
        $[5] = headingRender;
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== agentName || $[10] !== isStarred || $[11] !== onStarToggle || $[12] !== showStarButton) {
        t5 = showStarButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i4kCF.StarIconButton), {
            isStarred: isStarred,
            handleToggle: onStarToggle,
            agentName: agentName
        });
        $[9] = agentName;
        $[10] = isStarred;
        $[11] = onStarToggle;
        $[12] = showStarButton;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== t4 || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $f5fec235121c7193$var$styles.name,
            space: "space.100",
            alignBlock: "center"
        }, t4, t5);
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== agentDescription) {
        t7 = !!agentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.description,
            as: "p"
        }, agentDescription);
        $[17] = agentDescription;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== renderAdditionalContent) {
        t8 = !!renderAdditionalContent && renderAdditionalContent();
        $[19] = renderAdditionalContent;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== creatorRender || $[22] !== starCountRender || $[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t6, creatorRender, t7, starCountRender, t8);
        $[21] = creatorRender;
        $[22] = starCountRender;
        $[23] = t6;
        $[24] = t7;
        $[25] = t8;
        $[26] = t9;
    } else t9 = $[26];
    return t9;
} : ({ agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, headingRender: headingRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle, showStarButton: showStarButton = true, renderAdditionalContent: renderAdditionalContent })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $f5fec235121c7193$var$styles.name,
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075",
        xcss: $f5fec235121c7193$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h2",
        size: "medium"
    }, agentName), headingRender, isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.hiddenIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage((0, $fNIRw.messages).hiddenTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6h4xM.HiddenIcon), {
        label: formatMessage((0, $fNIRw.messages).hiddenIcon)
    })))), showStarButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i4kCF.StarIconButton), {
        isStarred: isStarred,
        handleToggle: onStarToggle,
        agentName: agentName
    })), creatorRender, !!agentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.description,
        as: "p"
    }, agentDescription), starCountRender, !!renderAdditionalContent && renderAdditionalContent());
};
module.exports["getAgentCreator"] = $f5fec235121c7193$export$7cbebf266a9bcc3c;
module.exports["AgentProfileCreator"] = $f5fec235121c7193$export$f35b2eeaa7e3db15;
module.exports["AgentProfileInfo"] = $f5fec235121c7193$export$e02348ba0b01a210;

});

parcelRegister("6h4xM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bsSbN = parcelRequire("bsSbN");

const $fc7d462f5dd0deaa$export$bce21421c351deb1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), props);
module.exports["HiddenIcon"] = $fc7d462f5dd0deaa$export$bce21421c351deb1;

});

parcelRegister("i4kCF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $6Cex3 = parcelRequire("6Cex3");


var $lbT4j = parcelRequire("lbT4j");


var $iMnC5 = parcelRequire("iMnC5");


var $4ssVW = parcelRequire("4ssVW");

const $fbe2d7b3097e2d22$var$styles = {
    hidden: "_1YKVNsdnbC"
};
const $fbe2d7b3097e2d22$export$703abb8bd2abdfa5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { isStarred: isStarred, handleToggle: handleToggle, visible: t1, agentName: agentName } = t0;
    const visible = t1 === undefined ? true : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const t2 = !visible && $fbe2d7b3097e2d22$var$styles.hidden;
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $w6R6I.cx)(t2);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== isHovered || $[3] !== isStarred) {
        t4 = (iconProps)=>isStarred || isHovered ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
                ...iconProps,
                color: "var(--ds-icon-accent-orange, #E06C00)"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)"
            });
        $[2] = isHovered;
        $[3] = isStarred;
        $[4] = t4;
    } else t4 = $[4];
    const t5 = isStarred ? (0, $4ssVW.default).removeFromFavouritesLabel : (0, $4ssVW.default).clickToFavouriteLabel;
    let t6;
    if ($[5] !== agentName || $[6] !== formatMessage || $[7] !== t5) {
        t6 = formatMessage(t5, {
            agentName: agentName
        });
        $[5] = agentName;
        $[6] = formatMessage;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    let t8;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>setIsHovered(true);
        t8 = ()=>setIsHovered(false);
        $[9] = t7;
        $[10] = t8;
    } else {
        t7 = $[9];
        t8 = $[10];
    }
    let t9;
    if ($[11] !== handleToggle || $[12] !== t4 || $[13] !== t6) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            icon: t4,
            label: t6,
            onClick: handleToggle,
            onMouseEnter: t7,
            onMouseLeave: t8
        });
        $[11] = handleToggle;
        $[12] = t4;
        $[13] = t6;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== t3 || $[16] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: t3
        }, t9);
        $[15] = t3;
        $[16] = t9;
        $[17] = t10;
    } else t10 = $[17];
    return t10;
} : ({ isStarred: isStarred, handleToggle: handleToggle, visible: visible = true, agentName: agentName })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)(!visible && $fbe2d7b3097e2d22$var$styles.hidden)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (iconProps)=>isStarred || isHovered ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
                ...iconProps,
                color: "var(--ds-icon-accent-orange, #E06C00)"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)"
            }),
        label: formatMessage(isStarred ? (0, $4ssVW.default).removeFromFavouritesLabel : (0, $4ssVW.default).clickToFavouriteLabel, {
            agentName: agentName
        }),
        onClick: handleToggle,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    }));
};
module.exports["StarIconButton"] = $fbe2d7b3097e2d22$export$703abb8bd2abdfa5;

});

parcelRegister("4ssVW", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a47d9a7d981bdb91$var$message = (0, $kSwu1.defineMessages)({
    removeFromFavouritesLabel: {
        id: "rovo-chat.browse-agents.remove-from-favourites-label",
        defaultMessage: "Remove {agentName} from favourites"
    },
    clickToFavouriteLabel: {
        id: "rovo-chat.browse-agents.click-to-favourite-label",
        defaultMessage: "Add {agentName} to favourites"
    }
});
var $a47d9a7d981bdb91$export$2e2bcd8739ae039 = $a47d9a7d981bdb91$var$message;
module.exports["default"] = $a47d9a7d981bdb91$export$2e2bcd8739ae039;

});

parcelRegister("hq9Cp", function(module, exports) {
const $84118747f7725463$export$3055eac4de8cbd2b = (creatorType)=>creatorType === 'THIRD_PARTY' || creatorType === 'FORGE' || creatorType === 'REMOTE_A2A';
module.exports["isForgeAgentByCreatorType"] = $84118747f7725463$export$3055eac4de8cbd2b;

});

parcelRegister("fNIRw", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $246a354bdf98d3ad$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    agentCreatedBy: {
        id: "ai-mate.agent-profile-info.created-by",
        defaultMessage: "Rovo Agent by {creatorNameWithLink}"
    },
    remoteAgentCreatedBy: {
        id: "ai-mate.agent-profile-info.agent-by",
        defaultMessage: "Agent by {creatorNameWithLink}"
    },
    agentDeactivated: {
        id: "ai-mate.agent-profile-info.deactivated",
        defaultMessage: "(deactivated)"
    },
    starredCount: {
        id: "ai-mate.agent-profile-info.starred-count",
        defaultMessage: "{count} starred"
    },
    hiddenIcon: {
        id: "ai-mate.agent-profile-info.hidden-icon",
        defaultMessage: "Hidden"
    },
    hiddenTooltip: {
        id: "ai-mate.agent-profile-info.hidden-tooltip",
        defaultMessage: "Agent won't show in search results"
    },
    starAgentTooltip: {
        id: "ai-mate.agent-profile-info.star-agent-tooltip",
        defaultMessage: "Star Agent"
    },
    creatorLabel: {
        id: "ai-mate.agent-profile-info.creator",
        defaultMessage: "Creator"
    }
});
module.exports["messages"] = $246a354bdf98d3ad$export$defe85febe8b728c;

});

parcelRegister("dSW04", function(module, exports) {
class $99c5d70c0df67415$export$a6d78d75d03919f1 extends Error {
    constructor(){
        super('Agent access forbidden');
        this.status = 403;
        this.name = 'AgentForbiddenError';
    }
}
module.exports["AgentForbiddenError"] = $99c5d70c0df67415$export$a6d78d75d03919f1;

});

parcelRegister("dRAjC", function(module, exports) {
const $d2643a1af3062f27$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $d2643a1af3062f27$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($d2643a1af3062f27$export$470b0d72e4fdc43a, '');
};
module.exports["USER_ARI_PREFIX"] = $d2643a1af3062f27$export$470b0d72e4fdc43a;
module.exports["getAAIDFromARI"] = $d2643a1af3062f27$export$3761e66a04602cbd;

});

parcelRegister("4k5Wq", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $5avUB = parcelRequire("5avUB");


var $4aRua = parcelRequire("4aRua");


var $eU2tf = parcelRequire("eU2tf");


var $hHYlx = parcelRequire("hHYlx");


var $cSSWJ = parcelRequire("cSSWJ");

const $0f12e30f7425acf6$var$ErrorMessage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(18);
    let t0;
    if ($[0] !== props.errorType) {
        t0 = props.errorType || {
            reason: "default"
        };
        $[0] = props.errorType;
        $[1] = t0;
    } else t0 = $[1];
    const errorType = t0;
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    let t1;
    let t2;
    if ($[2] !== errorReason || $[3] !== fireAnalytics || $[4] !== hasRetry) {
        t1 = ()=>{
            fireAnalytics("ui.profilecard.rendered.error", {
                hasRetry: hasRetry,
                errorType: errorReason,
                firedAt: Math.round(performance.now()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
        };
        t2 = [
            errorReason,
            fireAnalytics,
            hasRetry
        ];
        $[2] = errorReason;
        $[3] = fireAnalytics;
        $[4] = hasRetry;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[7] !== errorReason || $[8] !== reload) {
        t3 = ()=>{
            if (errorReason === "NotFound") return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hHYlx.ErrorTitle), {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorUserNotFound
                })
            });
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorTitle), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                        ...(0, $eU2tf.default).errorGeneric
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("br", {}),
                    reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        color: "color.text.subtlest",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                            ...(0, $eU2tf.default).errorRetrySuggestion
                        })
                    })
                ]
            });
        };
        $[7] = errorReason;
        $[8] = reload;
        $[9] = t3;
    } else t3 = $[9];
    const errorContent = t3;
    let t4;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
            label: "icon error"
        });
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== errorContent) {
        t5 = errorContent();
        $[11] = errorContent;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== reload) {
        t6 = reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
            onClick: reload,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                ...(0, $eU2tf.default).errorTryAgain
            })
        });
        $[13] = reload;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t5 || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorWrapper), {
            testId: "profilecard-error",
            children: [
                t4,
                t5,
                t6
            ]
        });
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $cozmU.useEffect)(()=>{
        fireAnalytics('ui.profilecard.rendered.error', {
            hasRetry: hasRetry,
            errorType: errorReason,
            firedAt: Math.round(performance.now()),
            ...(0, $cSSWJ.PACKAGE_META_DATA)
        });
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hHYlx.ErrorTitle), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                ...(0, $eU2tf.default).errorUserNotFound
            })
        });
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorTitle), {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorGeneric
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("br", {}),
                reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    color: "color.text.subtlest",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                        ...(0, $eU2tf.default).errorRetrySuggestion
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorWrapper), {
        testId: "profilecard-error",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                label: "icon error"
            }),
            errorContent(),
            reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                onClick: reload,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorTryAgain
                })
            })
        ]
    });
};
var $0f12e30f7425acf6$export$2e2bcd8739ae039 = $0f12e30f7425acf6$var$ErrorMessage;
module.exports["default"] = $0f12e30f7425acf6$export$2e2bcd8739ae039;

});

parcelRegister("eU2tf", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $fe57f9d19e98fdc0$var$messages = (0, $kSwu1.defineMessages)({
    inactiveAccountMsg: {
        id: "pt.profile-card.inactive.account",
        defaultMessage: "Account deactivated"
    },
    generalDescMsgForDisabledUser: {
        id: "pt.profile-card.general.msg.disabled.user",
        defaultMessage: "You can no longer collaborate with this person."
    },
    inactiveAccountDescMsgNoDate: {
        id: "pt.profile-card.inactive.account.no.date",
        defaultMessage: "Their account has been deactivated."
    },
    inactiveAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.inactive.account.has.date.this.week",
        defaultMessage: "Their account was deactivated this week."
    },
    inactiveAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.inactive.account.has.date.this.month",
        defaultMessage: "Their account was deactivated this month."
    },
    inactiveAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.inactive.account.has.date.last.month",
        defaultMessage: "Their account was deactivated last month."
    },
    inactiveAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.inactive.account.has.date.a.few.months",
        defaultMessage: "Their account has been deactivated for a few months."
    },
    inactiveAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.inactive.account.has.date.several.months",
        defaultMessage: "Their account has been deactivated for several months."
    },
    inactiveAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.inactive.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deactivated for more than a year."
    },
    closedAccountMsg: {
        id: "pt.profile-card.closed.account",
        defaultMessage: "Account deleted"
    },
    closedAccountDescMsgNoDate: {
        id: "pt.profile-card.closed.account.no.date",
        defaultMessage: "Their account has been deleted."
    },
    closedAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.closed.account.has.date.this.week",
        defaultMessage: "Their account was deleted this week."
    },
    closedAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.closed.account.has.date.this.month",
        defaultMessage: "Their account was deleted this month."
    },
    closedAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.closed.account.has.date.last.month",
        defaultMessage: "Their account was deleted last month."
    },
    closedAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.closed.account.has.date.a.few.months",
        defaultMessage: "Their account has been deleted for a few months."
    },
    closedAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.closed.account.has.date.several.months",
        defaultMessage: "Their account has been deleted for several months."
    },
    closedAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.closed.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deleted for more than a year."
    },
    disabledAccountDefaultName: {
        id: "pt.profile-card.disabled.account.default.name",
        defaultMessage: "Former user"
    },
    teamViewProfile: {
        id: "pt.team-profile-card.team.action.view-profile",
        defaultMessage: "View profile"
    },
    memberCount: {
        id: "pt.team-profile-card.team.member.count",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}"
    },
    memberCountIncludingYou: {
        id: "pt.team-profile-card.team.member.count-including-you",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you"
    },
    membersMoreThan50: {
        id: "pt.team-profile-card.team.member.many",
        defaultMessage: "Team \u2022 50+ members"
    },
    membersMoreThan50IncludingYou: {
        id: "pt.team-profile-card.team.member.many-including-you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    teamErrorTitle: {
        id: "pt.team-profile-card.error.title",
        defaultMessage: "We\u2019re having trouble retrieving this teams information"
    },
    teamErrorText: {
        id: "pt.team-profile-card.error.suggestion",
        defaultMessage: "Wait a few moments, then try again."
    },
    teamErrorButton: {
        id: "pt.team-profile-card.error.refresh-button",
        defaultMessage: "Try again"
    },
    teamForbiddenErrorStateTitle: {
        id: "pt.team-profile-card.forbidden-error-state.title",
        defaultMessage: "We can\u2019t show you this team"
    },
    teamForbiddenErrorStateDescription: {
        id: "pt.team-profile-card.forbidden-error-state.description",
        defaultMessage: "You don\u2019t have access to view this team."
    },
    managerSectionHeading: {
        id: "pt.team-profile-card.manager.heading",
        defaultMessage: "Manager"
    },
    directReportsSectionHeading: {
        id: "pt.team-profile-card.directReports.heading",
        defaultMessage: "Direct reports"
    },
    teamProfileCardAriaLabel: {
        id: "pt.team-profile-card.aria-label",
        defaultMessage: "More information about this team"
    },
    giveKudosButton: {
        id: "pt.profile-card.give-kudos",
        defaultMessage: "Give kudos"
    },
    // Remove this as part of the FG Cleanup for jfp_a11y_team_profile_card_actions_label
    profileCardMoreIconLabel: {
        id: "pt.profile-card.more-icon-label",
        defaultMessage: "More"
    },
    profileCardMoreIconLabelWithName: {
        id: "pt.profile-card.more-icon-label-with-name",
        defaultMessage: "More actions for {fullName}"
    },
    profileCardMoreReportingLinesLabel: {
        id: "pt.user-profile-card.reporting-lines.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {profile} other {profiles}}"
    },
    profileCardMoreMembersLabel: {
        id: "pt.team.profile-card.members.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {members} other {members}}"
    },
    archivedLozenge: {
        id: "pt.team-profile-card.archived-lozenge",
        defaultMessage: "Archived"
    },
    errorUserNotFound: {
        id: "pt.profile-card.error.user-not-found",
        defaultMessage: "The user is no longer available for the site"
    },
    errorGeneric: {
        id: "pt.profile-card.error.generic",
        defaultMessage: "Oops, looks like we\u2019re having issues"
    },
    errorRetrySuggestion: {
        id: "pt.profile-card.error.retry-suggestion",
        defaultMessage: "Try again and we\u2019ll give it another shot"
    },
    errorTryAgain: {
        id: "pt.profile-card.error.try-again-button",
        defaultMessage: "Try again"
    },
    errorDialogLabel: {
        id: "pt.profile-card.error.dialog-label",
        defaultMessage: "Profile card error"
    },
    loadingDialogLabel: {
        id: "pt.profile-card.loading.dialog-label",
        defaultMessage: "Loading profile card"
    },
    serviceAccountLabel: {
        id: "pt.profile-card.service-account.label",
        defaultMessage: "SERVICE ACCOUNT"
    },
    botAccountLabel: {
        id: "pt.profile-card.bot-account.label",
        defaultMessage: "APP"
    },
    viewManagerProfile: {
        id: "pt.profile-card.view-manager-profile",
        defaultMessage: "View {name} profile"
    }
});
var $fe57f9d19e98fdc0$export$2e2bcd8739ae039 = $fe57f9d19e98fdc0$var$messages;
module.exports["default"] = $fe57f9d19e98fdc0$export$2e2bcd8739ae039;

});

parcelRegister("hHYlx", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");

const $3b2daa1fed2d9894$var$styles = {
    errorWrapper: "_2fwxA5DIqT _0Of8r2NHnM _1ZnuxbNHnM _1wydGWNHnM _2Zuz6QNHnM",
    errorTitle: "_3138422ADO",
    teamErrorText: "_1UtDYzKGUX _3138422ADO"
};
const $3b2daa1fed2d9894$export$bb27b7e39840238f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.errorWrapper);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t0,
            ...props
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.errorWrapper),
        ...props
    });
const $3b2daa1fed2d9894$export$b065fd053267ec81 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props.children) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $3b2daa1fed2d9894$var$styles.errorTitle,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                color: "color.text",
                children: props.children
            })
        });
        $[0] = props.children;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $3b2daa1fed2d9894$var$styles.errorTitle,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            color: "color.text",
            children: props.children
        })
    });
const $3b2daa1fed2d9894$export$90d92ccfb27352c6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.teamErrorText);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props.children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t0,
            children: props.children
        });
        $[1] = props.children;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.teamErrorText),
        children: props.children
    });
module.exports["ErrorWrapper"] = $3b2daa1fed2d9894$export$bb27b7e39840238f;
module.exports["ErrorTitle"] = $3b2daa1fed2d9894$export$b065fd053267ec81;

});

parcelRegister("kb2tZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $ieeJu = parcelRequire("ieeJu");

const $d107d3e886647d93$var$styles = {
    wrapper: "_0bjKvD8fU6 _39xV02wBC3 _0KLXruoI2d _2OUyjtGk8v",
    wrapperLegacy: "_0bjKvD8fU6 _39xV02wBC3 _0KLXruoI2d"
};
const $d107d3e886647d93$export$2c6604b50c274e6f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = t0;
    if ((0, $ieeJu.expValEquals)("platform_editor_agent_mentions", "isEnabled", true) && (0, $iDrrr.fg)("platform_editor_agent_mentions_drop_one_fixes") || (0, $iDrrr.fg)("platform_editor_agent_card_fixes")) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $d107d3e886647d93$var$styles.wrapper,
                children: children
            });
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $d107d3e886647d93$var$styles.wrapperLegacy,
            children: children
        });
        $[2] = children;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ children: children })=>{
    if ((0, $ieeJu.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') || (0, $iDrrr.fg)('platform_editor_agent_card_fixes')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $d107d3e886647d93$var$styles.wrapper,
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $d107d3e886647d93$var$styles.wrapperLegacy,
        children: children
    });
};
module.exports["AgentProfileCardWrapper"] = $d107d3e886647d93$export$2c6604b50c274e6f;

});

parcelRegister("hIwXM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $795534535f4e0b8b$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("et8dH")));
module.exports["AgentProfileCardLazy"] = $795534535f4e0b8b$export$ed0ca9c1d49ea0bf;

});

parcelRegister("et8dH", function(module, exports) {

let $a88a266ede21e6e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a88a266ede21e6e1$var$load("zUKwV"),
    $a88a266ede21e6e1$var$load("fUeur"),
    $a88a266ede21e6e1$var$load("6wr18"),
    $a88a266ede21e6e1$var$load("fe1dp"),
    $a88a266ede21e6e1$var$load("bWBvX"),
    $a88a266ede21e6e1$var$load("jqoep"),
    $a88a266ede21e6e1$var$load("7EorR"),
    $a88a266ede21e6e1$var$load("ea3NB"),
    $a88a266ede21e6e1$var$load("ffEVr"),
    $a88a266ede21e6e1$var$load("hhss7"),
    $a88a266ede21e6e1$var$load("68aog")
]).then(()=>parcelRequire('ark00'));

});

parcelRegister("jgqX6", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0646b18c90b3a18$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3c3I9 = parcelRequire("3c3I9");


var $eYSi7 = parcelRequire("eYSi7");


var $3yGK6 = parcelRequire("3yGK6");


var $2iY37 = parcelRequire("2iY37");

function $e0646b18c90b3a18$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var sign = (0, $eYSi7.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $3c3I9.default)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $eYSi7.default)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $2iY37.default)((0, $dkBOe.default)(dirtyDateLeft)) && difference === 1 && (0, $eYSi7.default)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("3c3I9", function(module, exports) {
$parcel$export(module.exports, "default", () => $25355f04f79cc351$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $25355f04f79cc351$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("eYSi7", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae80c86a80ef7d08$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $ae80c86a80ef7d08$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});

parcelRegister("cSuwJ", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $7Y8M5 = parcelRequire("7Y8M5");

function $4a8c68f17b3fe31c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4a8c68f17b3fe31c$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    loading: {
        id: "fabric.editor.expand.loading",
        defaultMessage: "Loading..."
    },
    collapseNode: {
        id: "fabric.editor.collapseNode",
        defaultMessage: "Collapse content"
    },
    expandDefaultTitle: {
        id: "fabric.editor.expandDefaultTitle",
        defaultMessage: "Click here to expand..."
    },
    expandNode: {
        id: "fabric.editor.expandNode",
        defaultMessage: "Expand content"
    },
    expandPlaceholderText: {
        id: "fabric.editor.expandPlaceholder",
        defaultMessage: "Give this expand a title..."
    },
    expandArialabel: {
        id: "fabric.editor.expandAriaLabel",
        defaultMessage: "Give this expand a title"
    },
    // Clean up with platform_editor_expand_content_a11y_2.
    expandBodyAriaLabelOriginal: {
        id: "fabric.editor.expandBodyAriaLabel",
        defaultMessage: "Expand body content"
    },
    expandBodyAriaLabel: {
        id: "editor-common.Expand.expandBodyAriaLabel",
        defaultMessage: "Body content for {title}"
    },
    expandBodyAriaLabelUntitled: {
        id: "editor-common.Expand.expandBodyAriaLabelUntitled",
        defaultMessage: "untitled expand"
    },
    expandBodyAriaDescription: {
        id: "fabric.editor.expandBodyAriaDescription",
        defaultMessage: "Enter the content that will be revealed when this expand is opened."
    },
    expandBodyRoleDescription: {
        id: "fabric.editor.expandBodyRoleDescription",
        defaultMessage: "macro"
    }
});
const $4a8c68f17b3fe31c$export$4eeef63d68e77552 = ({ children: children, expanded: expanded })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: ()=>expanded ? [
                $4a8c68f17b3fe31c$var$expandIconWrapperStyle(),
                $4a8c68f17b3fe31c$var$expandIconWrapperExpandedStyle
            ] : $4a8c68f17b3fe31c$var$expandIconWrapperStyle()
    }, children);
};
const $4a8c68f17b3fe31c$var$expandIconWrapperStyle = ()=>/*#__PURE__*/ (0, $lOiVq.css)({
        cursor: 'pointer',
        display: 'flex',
        color: "var(--ds-icon, #292A2E)",
        borderRadius: "var(--ds-radius-small, 4px)",
        width: '24px',
        height: '24px',
        '&:hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        svg: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transition: `transform 0.2s ${(0, $7Y8M5.akEditorSwoopCubicBezier)}`
        }
    });
const $4a8c68f17b3fe31c$var$expandIconWrapperExpandedStyle = {
    name: "1uoxr6z",
    styles: "svg{transform:rotate(90deg);}"
};
const $4a8c68f17b3fe31c$export$a7ed6bf20867161a = {
    name: "ljflj6",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
};
const $4a8c68f17b3fe31c$export$c67faf67c1185cba = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, ...otherProps }, ref)=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        css: $4a8c68f17b3fe31c$export$a7ed6bf20867161a,
        ref: ref,
        ...otherProps
    }, children);
});
module.exports["messages"] = $4a8c68f17b3fe31c$export$defe85febe8b728c;
module.exports["ExpandIconWrapper"] = $4a8c68f17b3fe31c$export$4eeef63d68e77552;
module.exports["expandLayoutWrapperStyle"] = $4a8c68f17b3fe31c$export$a7ed6bf20867161a;
module.exports["ExpandLayoutWrapperWithRef"] = $4a8c68f17b3fe31c$export$c67faf67c1185cba;

});

parcelRegister("h9r4d", function(module, exports) {
$parcel$export(module.exports, "captureException", () => (parcelRequire("lIkvQ")).captureException);
$parcel$export(module.exports, "fireErrorAnalytics", () => (parcelRequire("kFTt2")).default);

var $lIkvQ = parcelRequire("lIkvQ");


var $kFTt2 = parcelRequire("kFTt2");


var $4sTW6 = parcelRequire("4sTW6");


});

parcelRegister("lIkvQ", function(module, exports) {

var $l54O9 = parcelRequire("l54O9");

const $34ee97725f8181a5$export$7da675e3dd1bd6b5 = (sentryUrl, config, getExtraContext)=>(0, $l54O9.default).installGlobalHandler(sentryUrl, config, getExtraContext);
const $34ee97725f8181a5$export$f5282963edea4a68 = (location, error, details = {})=>(0, $l54O9.default).captureException(location, error, details);
module.exports["captureException"] = $34ee97725f8181a5$export$f5282963edea4a68;

});

parcelRegister("l54O9", function(module, exports) {
// This is the only file that should directly import Raven.

var $9HPf3 = parcelRequire("9HPf3");

var $amM2J = parcelRequire("amM2J");

var $eAdCn = parcelRequire("eAdCn");


var $iyIOY = parcelRequire("iyIOY");

var $6W0Xl = parcelRequire("6W0Xl");

var $fa95z = parcelRequire("fa95z");

var $hLq0X = parcelRequire("hLq0X");


var $1wIeS = parcelRequire("1wIeS");

const $15510fe24ae0eb31$var$getFragmentNames = (stackTrace)=>{
    const re = /(?:src\/entry|src|assets)\/([^,./]+)/g;
    const fragmentNames = [];
    let fragmentName = re.exec(stackTrace);
    while(fragmentName){
        fragmentNames.push(fragmentName[1]);
        fragmentName = re.exec(stackTrace);
    }
    const distinctfragmentNames = (0, (/*@__PURE__*/$parcel$interopDefault($1wIeS)))(fragmentNames);
    return distinctfragmentNames;
};
// Add custom tags based on stack trace
const $15510fe24ae0eb31$var$getTaggedData = (data, hint)=>{
    if (!hint) return data;
    const exception = hint.originalException || hint.syntheticException;
    if (!exception) return data;
    const stackTrace = exception.stack;
    if (!stackTrace) return data;
    const taggedData = data;
    const fragmentNames = $15510fe24ae0eb31$var$getFragmentNames(stackTrace);
    if (!fragmentNames.length) taggedData.tags = {
        ...taggedData.tags,
        fragment: 'unknown'
    };
    else {
        taggedData.tags = {
            ...taggedData.tags,
            fragment: fragmentNames[0]
        };
        if (fragmentNames.length > 1) taggedData.extra = {
            ...taggedData.extra,
            allRelevantFragments: fragmentNames
        };
    }
    return taggedData;
};
// https://docs.sentry.io/platforms/javascript/#removing-an-integration
const $15510fe24ae0eb31$var$getFilteredIntegrations = (integrations)=>integrations.filter(({ name: name })=>name !== 'Breadcrumbs');
const $15510fe24ae0eb31$var$installGlobalHandler = (sentryUrl, config, getExtraContext)=>{
    // Check for sentry already enabled to be defensive in case two fragments are loaded in the same page, we
    // don't want duplicated error reports
    const sentryClient = $amM2J.getCurrentHub().getClient();
    if (sentryClient && sentryClient.getOptions().enabled) return;
    const defaultConfig = {
        dsn: sentryUrl,
        environment: "production",
        // This adds our tags to the data sent to sentry
        beforeSend: (event, hint)=>{
            // Yes, we're mutating the argument, but at this point in the error handling lifecycle
            // immutability is not important and it simplifies the logic
            // Event type is documented here: https://github.com/getsentry/sentry-javascript/blob/master/packages/types/src/event.ts
            const extraBeforeSend = config.beforeSend || (()=>null);
            let updatedData = extraBeforeSend(event, hint);
            updatedData = $15510fe24ae0eb31$var$getTaggedData(updatedData, hint);
            return updatedData;
        },
        //Integration typing doesn't seem to work well so I'm just typing it to any
        integrations: (integrations)=>[
                ...$15510fe24ae0eb31$var$getFilteredIntegrations(integrations),
                new $6W0Xl.Dedupe(),
                new $fa95z.ExtraErrorData(),
                new $hLq0X.Transaction(),
                new $iyIOY.CaptureConsole({
                    levels: [
                        'error'
                    ]
                }),
                // not supporting the case where config.integrations is a function that returns an array
                ...config.integrations && config.integrations instanceof Array ? config.integrations : []
            ]
    };
    // Because we don't want to completely override the platform defaults remove them from the config object.
    // They've been integrated into the defaultConfig above.
    config.beforeSend = undefined;
    config.integrations = undefined;
    $eAdCn.init({
        ...defaultConfig,
        ...config
    });
    try {
        $9HPf3.setExtras(getExtraContext());
    } catch (e) {
        $9HPf3.captureException(e);
    }
};
// structured tags that we send to Sentry
// everything else from details object will go into "extras"
const $15510fe24ae0eb31$var$tags = [
    'packageName',
    'teamName'
];
const $15510fe24ae0eb31$var$captureException = (location, error, details)=>{
    $9HPf3.configureScope((scope)=>{
        scope.setTag('logger', location);
        if (details) Object.keys(details).forEach((key)=>{
            if ($15510fe24ae0eb31$var$tags.includes(key)) scope.setTag(key, details[key]);
            else scope.setExtra(key, details[key]);
        });
    });
    $9HPf3.captureException(error);
};
const $15510fe24ae0eb31$var$sentryErrorHandler = {
    installGlobalHandler: $15510fe24ae0eb31$var$installGlobalHandler,
    captureException: $15510fe24ae0eb31$var$captureException
};
var $15510fe24ae0eb31$export$2e2bcd8739ae039 = $15510fe24ae0eb31$var$sentryErrorHandler;
module.exports["default"] = $15510fe24ae0eb31$export$2e2bcd8739ae039;

});

parcelRegister("1wIeS", function(module, exports) {

var $1Rned = parcelRequire("1Rned");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $11cb188fd562c44b$var$uniq(array) {
    return array && array.length ? $1Rned(array) : [];
}
module.exports = $11cb188fd562c44b$var$uniq;

});

parcelRegister("kFTt2", function(module, exports) {

var $huGTe = parcelRequire("huGTe");


var $66Bcq = parcelRequire("66Bcq");


var $k8V2e = parcelRequire("k8V2e");

var $hcOES = parcelRequire("hcOES");


var $lIkvQ = parcelRequire("lIkvQ");

let $1fc2285692461264$var$analyticsClient;
const $1fc2285692461264$export$d4079397f9611138 = (client)=>{
    $1fc2285692461264$var$analyticsClient = client;
};
const $1fc2285692461264$export$bf406c01a195b215 = ()=>{
    $1fc2285692461264$var$analyticsClient = undefined;
};
const $1fc2285692461264$var$fireErrorAnalytics = ({ event: event, error: error, errorInfo: errorInfo, meta: meta, attributes: attributes })=>{
    const { id: id, packageName: packageName, teamName: teamName } = meta;
    if (__SERVER__) {
        if (error) throw error;
        else {
            const payload = event && (0, $k8V2e.extractAWCDataFromEvent)(event).payload;
            throw new Error(JSON.stringify({
                event: payload,
                errorInfo: errorInfo,
                meta: meta,
                attributes: attributes
            }));
        }
    }
    const fullAnalyticsId = `${packageName}.${id}`;
    if (error) {
        const details = (0, (/*@__PURE__*/$parcel$interopDefault($66Bcq)))({
            ...attributes,
            packageName: packageName,
            teamName: teamName,
            errorInfo: errorInfo
        }, (0, (/*@__PURE__*/$parcel$interopDefault($huGTe))));
        if (event && event.context) {
            const fullEvent = (0, $k8V2e.extractAWCDataFromEvent)(event);
            (0, $lIkvQ.captureException)(fullAnalyticsId, error, {
                ...details,
                ...fullEvent.payload
            });
        } else (0, $lIkvQ.captureException)(fullAnalyticsId, error, details);
    }
    if (event && event.handlers && event.handlers.length > 0) {
        const attrs = attributes || {};
        (0, $hcOES.fireOperationalAnalytics)(event, `${fullAnalyticsId} failed`, attrs);
    } else //Allow this to pass in a promise so that we can avoid blocking render for firing these events.
    if ($1fc2285692461264$var$analyticsClient && $1fc2285692461264$var$analyticsClient.sendOperationalEvent) {
        const gasV3Event = {
            action: 'failed',
            actionSubject: fullAnalyticsId,
            source: 'unknownErrorSource',
            attributes: attributes
        };
        $1fc2285692461264$var$analyticsClient.sendOperationalEvent(gasV3Event);
    } else {
        const analyticsClientUninitialisedError = new Error("Analytics client hasn't been initialised, unable to fire error operational event");
        (0, $lIkvQ.captureException)(fullAnalyticsId, analyticsClientUninitialisedError);
    }
};
const $1fc2285692461264$export$706c486c6b5abdfb = async ({ error: error, id: id, packageName: packageName })=>{
    if (error.statusCode) {
        const { statusCode: statusCode } = error;
        let statusCodeGroup;
        if (statusCode >= 300 && statusCode < 400) statusCodeGroup = '3xx';
        else if (statusCode >= 400 && statusCode < 500) statusCodeGroup = '4xx';
        else if (statusCode >= 500 && statusCode < 600) statusCodeGroup = '5xx';
        else statusCodeGroup = 'unknown';
        await $1fc2285692461264$var$fireErrorAnalytics({
            meta: {
                id: id,
                packageName: packageName
            },
            attributes: {
                statusCodeGroup: statusCodeGroup
            }
        });
    } else await $1fc2285692461264$var$fireErrorAnalytics({
        error: error,
        meta: {
            id: id,
            packageName: packageName
        }
    });
};
var $1fc2285692461264$export$2e2bcd8739ae039 = $1fc2285692461264$var$fireErrorAnalytics;
module.exports["default"] = $1fc2285692461264$export$2e2bcd8739ae039;

});

parcelRegister("huGTe", function(module, exports) {

var $4rtI4 = parcelRequire("4rtI4");


var $jOCrv = parcelRequire("jOCrv");


var $bZ5J1 = parcelRequire("bZ5J1");


var $1ScXu = parcelRequire("1ScXu");


var $9pMwd = parcelRequire("9pMwd");


var $6DVFM = parcelRequire("6DVFM");


var $bAfjw = parcelRequire("bAfjw");


var $5J1xO = parcelRequire("5J1xO");

/** `Object#toString` result references. */ var $cbc68209f80e3755$var$mapTag = '[object Map]', $cbc68209f80e3755$var$setTag = '[object Set]';
/** Used for built-in method references. */ var $cbc68209f80e3755$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cbc68209f80e3755$var$hasOwnProperty = $cbc68209f80e3755$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $cbc68209f80e3755$var$isEmpty(value) {
    if (value == null) return true;
    if ($9pMwd(value) && ($1ScXu(value) || typeof value == 'string' || typeof value.splice == 'function' || $6DVFM(value) || $5J1xO(value) || $bZ5J1(value))) return !value.length;
    var tag = $jOCrv(value);
    if (tag == $cbc68209f80e3755$var$mapTag || tag == $cbc68209f80e3755$var$setTag) return !value.size;
    if ($bAfjw(value)) return !$4rtI4(value).length;
    for(var key in value){
        if ($cbc68209f80e3755$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
module.exports = $cbc68209f80e3755$var$isEmpty;

});

parcelRegister("k8V2e", function(module, exports) {
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $emZLc = parcelRequire("emZLc");


var $66Bcq = parcelRequire("66Bcq");


var $jYwtP = parcelRequire("jYwtP");


var $8El2z = parcelRequire("8El2z");

const $035dbde6912e4d4c$export$1c850cf68c053906 = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const analyticsType = (0, $8El2z.getAnalyticsType)(castedEvent);
    const attributes = (0, $8El2z.getAttributes)(castedEvent);
    const source = (0, $8El2z.getSource)(castedEvent);
    const actionSubject = (0, $8El2z.getActionSubject)(castedEvent);
    if (analyticsType === (0, $jYwtP.SCREEN_EVENT_TYPE)) return {
        type: (0, $jYwtP.SCREEN_EVENT_TYPE),
        payload: {
            name: source,
            attributes: attributes
        }
    };
    switch(analyticsType){
        case 0, $jYwtP.UI_EVENT_TYPE:
        case 0, $jYwtP.TRACK_EVENT_TYPE:
        case 0, $jYwtP.OPERATIONAL_EVENT_TYPE:
            {
                const action = (0, $8El2z.getAction)(castedEvent);
                const actionSubjectId = (0, $8El2z.getActionSubjectId)(castedEvent);
                const containerId = (0, $8El2z.getContainerId)(castedEvent);
                const containerType = (0, $8El2z.getContainerType)(castedEvent);
                const objectId = (0, $8El2z.getObjectId)(castedEvent);
                const objectType = (0, $8El2z.getObjectType)(castedEvent);
                const tags = (0, $8El2z.getTags)(castedEvent);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($66Bcq)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerType: containerType,
                        containerId: containerId,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($emZLc))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes
                },
                type: undefined
            };
    }
};
module.exports["extractAWCDataFromEvent"] = $035dbde6912e4d4c$export$1c850cf68c053906;

});

parcelRegister("8El2z", function(module, exports) {

var $lyW2B = parcelRequire("lyW2B");


var $emZLc = parcelRequire("emZLc");


var $gO1os = parcelRequire("gO1os");


var $lYpJw = parcelRequire("lYpJw");


var $66Bcq = parcelRequire("66Bcq");


var $1wIeS = parcelRequire("1wIeS");

const $c9f6533ef6431d6e$var$extractFromContext = (event, property)=>event.context.map((item)=>item[property]);
const $c9f6533ef6431d6e$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
const $c9f6533ef6431d6e$export$fe94072fee8a6976 = (event)=>{
    const contextAttributes = $c9f6533ef6431d6e$var$extractFromContext(event, 'attributes');
    const payloadAttributes = event.payload.attributes;
    const allAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lYpJw)))(contextAttributes.reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($lYpJw)))(result, extraAttributes), {}), payloadAttributes);
    const sources = $c9f6533ef6431d6e$var$extractFromContext(event, 'source');
    const namespaces = sources.filter(Boolean).join('.');
    return (0, (/*@__PURE__*/$parcel$interopDefault($66Bcq)))({
        ...allAttributes,
        namespaces: namespaces
    }, (0, (/*@__PURE__*/$parcel$interopDefault($emZLc))));
};
const $c9f6533ef6431d6e$export$dd2b6e807fb37ba3 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'source').filter(Boolean));
const $c9f6533ef6431d6e$export$6f40cdf6d42c018d = (event)=>{
    const { actionSubject: actionSubject } = event.payload;
    if (actionSubject) return actionSubject;
    const component = (0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'component').filter(Boolean)) || (0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'componentName').filter(Boolean));
    return component;
};
const $c9f6533ef6431d6e$export$6ca3170acb89054 = (event)=>event.payload.action;
const $c9f6533ef6431d6e$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
const $c9f6533ef6431d6e$export$7c8178cc9001d237 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'containerId').filter(Boolean));
const $c9f6533ef6431d6e$export$acc6f3e19803b3dc = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'containerType').filter(Boolean));
const $c9f6533ef6431d6e$export$fa986b91291934c7 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'objectId').filter(Boolean));
const $c9f6533ef6431d6e$export$11cc42aebef2ef3a = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'objectType').filter(Boolean));
const $c9f6533ef6431d6e$export$af63d7414243dad3 = (event)=>{
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($1wIeS)))((0, (/*@__PURE__*/$parcel$interopDefault($lyW2B)))($c9f6533ef6431d6e$var$extractFromContext(event, 'tags'))).filter(Boolean);
    return tags.length ? tags : undefined;
};
module.exports["getAnalyticsType"] = $c9f6533ef6431d6e$export$a3569ac53b82a914;
module.exports["getAttributes"] = $c9f6533ef6431d6e$export$fe94072fee8a6976;
module.exports["getSource"] = $c9f6533ef6431d6e$export$dd2b6e807fb37ba3;
module.exports["getActionSubject"] = $c9f6533ef6431d6e$export$6f40cdf6d42c018d;
module.exports["getAction"] = $c9f6533ef6431d6e$export$6ca3170acb89054;
module.exports["getActionSubjectId"] = $c9f6533ef6431d6e$export$b6f8db3ad0711b02;
module.exports["getContainerId"] = $c9f6533ef6431d6e$export$7c8178cc9001d237;
module.exports["getContainerType"] = $c9f6533ef6431d6e$export$acc6f3e19803b3dc;
module.exports["getObjectId"] = $c9f6533ef6431d6e$export$fa986b91291934c7;
module.exports["getObjectType"] = $c9f6533ef6431d6e$export$11cc42aebef2ef3a;
module.exports["getTags"] = $c9f6533ef6431d6e$export$af63d7414243dad3;

});

parcelRegister("4sTW6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lzgC6 = parcelRequire("lzgC6");


var $kFTt2 = parcelRequire("kFTt2");

class $28efc9af7e790139$var$CatchAndReportErrors extends (0, $cozmU.Component) {
    componentDidCatch(error, errorInfo) {
        const { packageName: packageName, id: id, attributes: attributes, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const analyticsEvent = createAnalyticsEvent({
            action: 'failed'
        });
        (0, $kFTt2.default)({
            event: analyticsEvent,
            errorInfo: errorInfo,
            error: error,
            meta: {
                id: id,
                packageName: packageName
            },
            attributes: attributes
        });
        throw error;
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    }
}
const $28efc9af7e790139$var$reportingErrorBoundary = (0, $lzgC6.default)()($28efc9af7e790139$var$CatchAndReportErrors);
var $28efc9af7e790139$export$2e2bcd8739ae039 = $28efc9af7e790139$var$reportingErrorBoundary;

});

parcelRegister("cuWGz", function(module, exports) {

var $e66dL = parcelRequire("e66dL");


var $aO6uT = parcelRequire("aO6uT");

function $61987beec044a597$export$57570b1603cf6adb(env) {
    if (env) return env;
    if (typeof window === 'undefined' || !window.location) return (0, $aO6uT.Environment).Unknown;
    const host = window.location.hostname.toLowerCase();
    // Fast path: exact hostname matches
    const exactMatch = (0, $e66dL.EXACT_HOST_MAP)[host];
    if (exactMatch) return exactMatch;
    // Extract TLD for efficient branching (find last dot position)
    const lastDot = host.lastIndexOf('.');
    if (lastDot === -1) return (0, $aO6uT.Environment).Unknown;
    const tld = host.slice(lastDot + 1); // 'com', 'net', etc.
    // Branch by TLD to reduce checks
    switch(tld){
        case 'com':
            return $61987beec044a597$var$classifyComDomain(host);
        case 'net':
            return $61987beec044a597$var$classifyNetDomain(host);
        default:
            return (0, $aO6uT.Environment).Unknown;
    }
}
/**
 * Classify .com domains
 */ function $61987beec044a597$var$classifyComDomain(host) {
    // jira-dev.com (staging)
    if (host.endsWith('.jira-dev.com')) return (0, $aO6uT.Environment).Staging;
    // atlassian-us-gov-mod.com (FedRAMP)
    if (host.endsWith('.atlassian-us-gov-mod.com')) {
        // FedRAMP Bifrost CDN: check most specific first
        if (host.endsWith('.frontend.cdn.atlassian-us-gov-mod.com')) return host.includes('.stg.') ? (0, $aO6uT.Environment).Staging : (0, $aO6uT.Environment).Prod;
        if (host.endsWith('.stg.atlassian-us-gov-mod.com')) return (0, $aO6uT.Environment).Staging;
        return (0, $aO6uT.Environment).Prod;
    }
    // atlassian.com domains
    if (host.endsWith('.atlassian.com')) {
        // services.atlassian.com vanity domains (check most specific first)
        if (host.endsWith('.dev.services.atlassian.com')) return (0, $aO6uT.Environment).Development;
        if (host.endsWith('.staging.services.atlassian.com')) return (0, $aO6uT.Environment).Staging;
        if (host.endsWith('.services.atlassian.com')) return (0, $aO6uT.Environment).Prod;
        // Environment-specific subdomains
        if (host.endsWith('.dev.atlassian.com')) return (0, $aO6uT.Environment).Development;
        if (host.endsWith('.stg.atlassian.com')) return (0, $aO6uT.Environment).Staging;
        return (0, $aO6uT.Environment).Prod;
    }
    return (0, $aO6uT.Environment).Unknown;
}
/**
 * Classify .net domains
 */ function $61987beec044a597$var$classifyNetDomain(host) {
    // atlassian.net (prod tenants)
    if (host.endsWith('.atlassian.net')) return (0, $aO6uT.Environment).Prod;
    // atl-paas-us-gov-mod.net (FedRAMP Micros)
    if (host.endsWith('.atl-paas-us-gov-mod.net')) {
        if (host.includes('.staging.')) return (0, $aO6uT.Environment).Staging;
        if (host.includes('.prod.')) return (0, $aO6uT.Environment).Prod;
        return (0, $aO6uT.Environment).Unknown;
    }
    // atl-paas.net (commercial Micros and Bifrost)
    if (host.endsWith('.atl-paas.net')) {
        // Bifrost commercial: check most specific first
        if (host.endsWith('.frontend.public.atl-paas.net')) {
            if (host.includes('.ddev.') || host.includes('.dev-west2.')) return (0, $aO6uT.Environment).Development;
            if (host.includes('.stg-east.')) return (0, $aO6uT.Environment).Staging;
            if (host.includes('.prod-east.')) return (0, $aO6uT.Environment).Prod;
            return (0, $aO6uT.Environment).Development;
        }
        // Micros commercial
        if (host.includes('.dev.') || host.includes('.platdev.')) return (0, $aO6uT.Environment).Development;
        if (host.includes('.staging.')) return (0, $aO6uT.Environment).Staging;
        if (host.includes('.prod.')) return (0, $aO6uT.Environment).Prod;
    }
    return (0, $aO6uT.Environment).Unknown;
}
module.exports["getEnvironment"] = $61987beec044a597$export$57570b1603cf6adb;

});

parcelRegister("e66dL", function(module, exports) {

var $aO6uT = parcelRequire("aO6uT");

const $1c6adf460a912312$export$636c0c57a2ce36e9 = {
    localhost: (0, $aO6uT.Environment).Development,
    '127.0.0.1': (0, $aO6uT.Environment).Development,
    'id.atlassian.com': (0, $aO6uT.Environment).Prod,
    'admin.atlassian.com': (0, $aO6uT.Environment).Prod,
    'id.stg.internal.atlassian.com': (0, $aO6uT.Environment).Staging,
    'admin.stg.atlassian.com': (0, $aO6uT.Environment).Staging
};
module.exports["EXACT_HOST_MAP"] = $1c6adf460a912312$export$636c0c57a2ce36e9;

});

parcelRegister("aO6uT", function(module, exports) {
var $cf10c8edb5d48b94$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["Development"] = "development";
    Environment["Staging"] = "staging";
    Environment["Prod"] = "prod";
    Environment["Unknown"] = "unknown";
    return Environment;
}({});
module.exports["Environment"] = $cf10c8edb5d48b94$export$7dc6752a22ab011a;

});

parcelRegister("4GGNn", function(module, exports) {

var $jhbO3 = parcelRequire("jhbO3");


var $GLgaM = parcelRequire("GLgaM");


var $bjeS8 = parcelRequire("bjeS8");

async function $aeaa62655b9da260$export$4199ef03ec2aea3f({ url: url, method: method, headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError }) {
    const fetchData = async ()=>{
        const json = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, variables);
        return await parseResult(json, variables);
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $jhbO3.apolloCompatibleMutation)({
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalMutate"] = $aeaa62655b9da260$export$4199ef03ec2aea3f;

});

parcelRegister("8Lx5S", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

/**
 * Checks if the user has any licensed access (either admin or use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin or use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensed = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user has licensed admin access.
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin access, otherwise false.
 */ const $30f02aa82d7102bc$var$isAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
};
/**
 * Checks if the user has licensed non-admin access (use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensedNonAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user is a guest (external collaborator).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user is an external collaborator, otherwise false.
 */ const $30f02aa82d7102bc$var$isGuest = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
};
const $30f02aa82d7102bc$export$ac4f65b11c57a33b = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensed(accessStatus);
};
const $30f02aa82d7102bc$export$99a5e4bc80d231ca = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$a67466804611d2db = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$f9ffae90e66d63e = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isGuest(accessStatus);
};
const $30f02aa82d7102bc$export$41f8700aabec6a40 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isGuest: $30f02aa82d7102bc$var$isGuest(accessStatus),
        isLicensed: $30f02aa82d7102bc$var$isLicensed(accessStatus),
        isAdmin: $30f02aa82d7102bc$var$isAdmin(accessStatus),
        isLicensedNonAdmin: $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus)
    };
};
module.exports["useIsLicensed"] = $30f02aa82d7102bc$export$ac4f65b11c57a33b;
module.exports["useIsAdmin"] = $30f02aa82d7102bc$export$99a5e4bc80d231ca;
module.exports["useIsGuest"] = $30f02aa82d7102bc$export$f9ffae90e66d63e;
module.exports["useAccessStatus"] = $30f02aa82d7102bc$export$41f8700aabec6a40;

});

parcelRegister("hYoU4", function(module, exports) {

var $nStJY = parcelRequire("nStJY");


var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");

const $cf3a2c4e252823d7$export$79b973328ab6a08a = {
    collabEditProvider: null,
    collabEditInitialized: false,
    hasInitialDraft: false,
    isDraftSyncPending: false,
    collabEditConnected: false
};
const $cf3a2c4e252823d7$export$e324594224ef24da = {
    setCollabEditProvider: (collabEditProvider)=>({ setState: setState })=>{
            setState({
                collabEditProvider: collabEditProvider
            });
        },
    setCollabEditInitialized: (collabEditInitialized)=>({ setState: setState })=>{
            setState({
                collabEditInitialized: collabEditInitialized
            });
        },
    setHasInitialDraft: (hasInitialDraft)=>({ setState: setState })=>{
            setState({
                hasInitialDraft: hasInitialDraft
            });
        },
    setIsDraftSyncPending: // PGXT-3849 Remove this if we update lodash to 5.0+ and use debounce.pending() instead
    (isDraftSyncPending)=>({ setState: setState })=>{
            setState({
                isDraftSyncPending: isDraftSyncPending
            });
        },
    setCollabEditConnected: (collabEditConnected)=>({ setState: setState })=>{
            setState({
                collabEditConnected: collabEditConnected
            });
        },
    resetNativeCollabState: ()=>({ setState: setState })=>{
            setState({
                collabEditProvider: null,
                collabEditInitialized: false,
                hasInitialDraft: false,
                isDraftSyncPending: false,
                collabEditConnected: false
            });
        }
};
const $cf3a2c4e252823d7$export$a3d4598f4626641c = (0, $8s9DV.createStore)({
    initialState: {
        ...$cf3a2c4e252823d7$export$79b973328ab6a08a
    },
    actions: $cf3a2c4e252823d7$export$e324594224ef24da,
    name: 'nativeCollabState'
});
const $cf3a2c4e252823d7$export$8af37259b4604092 = (0, $j8on0.createContainer)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    onInit: ()=>async ({ dispatch: dispatch }, { initialCollabState: initialCollabState })=>{
            initialCollabState?.collabEditProvider && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditProvider(initialCollabState?.collabEditProvider));
            initialCollabState?.collabEditInitialized && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditInitialized(initialCollabState?.collabEditInitialized));
            initialCollabState?.hasInitialDraft && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setHasInitialDraft(initialCollabState?.hasInitialDraft));
            initialCollabState?.isDraftSyncPending && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setIsDraftSyncPending(initialCollabState?.isDraftSyncPending));
            initialCollabState?.collabEditConnected && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditConnected(initialCollabState?.collabEditConnected));
        }
});
const $cf3a2c4e252823d7$export$b01c6ac62a4aed2c = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'collabEditProvider', 'collabEditInitialized', 'hasInitialDraft')
});
const $cf3a2c4e252823d7$export$3f0287ea828df991 = (0, $kBr4q.createActionsHook)($cf3a2c4e252823d7$export$a3d4598f4626641c);
const $cf3a2c4e252823d7$export$31e00ebc52451b8e = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'isDraftSyncPending')
});
const $cf3a2c4e252823d7$export$4bfbf4dd405bc207 = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'collabEditConnected')
});
module.exports["useNativeCollabState"] = $cf3a2c4e252823d7$export$b01c6ac62a4aed2c;
module.exports["useNativeCollabActions"] = $cf3a2c4e252823d7$export$3f0287ea828df991;
module.exports["useNativeCollabDraftSync"] = $cf3a2c4e252823d7$export$31e00ebc52451b8e;
module.exports["useNativeCollabConnected"] = $cf3a2c4e252823d7$export$4bfbf4dd405bc207;

});

parcelRegister("jTKfH", function(module, exports) {

var $5rzIE = parcelRequire("5rzIE");

const $93101e1e1df3fd55$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-trace-id') ?? response?.headers?.get('atl-traceid') ?? response?.headers?.get('x-b3-traceid') ?? undefined;
class $93101e1e1df3fd55$export$26e841bcf1aeb894 extends Error {
    constructor(message, errorAttributes){
        super(message), this.errorAttributes = errorAttributes;
        this.name = 'FetchError';
    }
}
class $93101e1e1df3fd55$var$HttpApiError extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $93101e1e1df3fd55$export$a38d93aa782475f6 = async ({ path: path, options: options })=>{
    const startedAt = (0, $5rzIE.hasRequestObservationSubscribers)() ? (0, $5rzIE.requestObservationNow)() : undefined;
    try {
        const response = await fetch(path, options);
        if (!response.ok || response.status >= 400) await $93101e1e1df3fd55$var$processHttpErrorResponse({
            response: response
        });
        const result = await response.json();
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'http',
            method: (options.method ?? 'GET').toUpperCase(),
            route: (0, $5rzIE.normalizeRequestRoute)(path),
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: 'success',
            status: response.status
        });
        return result;
    } catch (err) {
        const outcome = err instanceof $93101e1e1df3fd55$var$HttpApiError ? 'httpError' : err instanceof Error && err.name === 'AbortError' ? 'abort' : 'networkError';
        const statusCode = err instanceof $93101e1e1df3fd55$var$HttpApiError ? err.errorAttributes.statusCode : undefined;
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'http',
            method: (options.method ?? 'GET').toUpperCase(),
            route: (0, $5rzIE.normalizeRequestRoute)(path),
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: outcome,
            status: statusCode
        });
        const originalErrorMessage = err instanceof Error ? 'Original error: ' + err.message : 'Unknown error';
        throw new $93101e1e1df3fd55$export$26e841bcf1aeb894(`performHttpFetch error while fetching ${path}. ${originalErrorMessage}`, {
            errorCode: 'performHttpFetchError',
            statusCode: statusCode
        });
    }
};
const $93101e1e1df3fd55$var$processHttpErrorResponse = async ({ response: response })=>{
    throw new $93101e1e1df3fd55$var$HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
        statusCode: response.status,
        traceId: $93101e1e1df3fd55$export$9f229e40eb65abfc(response)
    });
};
module.exports["getTraceIdFromResponse"] = $93101e1e1df3fd55$export$9f229e40eb65abfc;
module.exports["FetchError"] = $93101e1e1df3fd55$export$26e841bcf1aeb894;
module.exports["performHttpFetch"] = $93101e1e1df3fd55$export$a38d93aa782475f6;

});

parcelRegister("5rzIE", function(module, exports) {
const $40a8b1f594239208$var$listeners = new Set();
const $40a8b1f594239208$var$UUID_SEGMENT_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const $40a8b1f594239208$var$NUMERIC_SEGMENT_PATTERN = /\/\d+(?=\/|$)/g;
const $40a8b1f594239208$export$eb91308c925b64ce = ()=>{
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') return performance.now();
    return Date.now();
};
const $40a8b1f594239208$export$327998895df08b85 = (startedAt)=>Math.max(0, Math.round($40a8b1f594239208$export$eb91308c925b64ce() - startedAt));
const $40a8b1f594239208$export$c805539eac489f93 = (path)=>{
    try {
        const parsed = new URL(path, 'https://conversation-assistant.invalid');
        return parsed.pathname.replace($40a8b1f594239208$var$UUID_SEGMENT_PATTERN, '{id}').replace($40a8b1f594239208$var$NUMERIC_SEGMENT_PATTERN, '/{id}');
    } catch  {
        return '/unparseable';
    }
};
const $40a8b1f594239208$export$d23c16bc33c579b9 = (listener)=>{
    $40a8b1f594239208$var$listeners.add(listener);
    return ()=>{
        $40a8b1f594239208$var$listeners.delete(listener);
    };
};
const $40a8b1f594239208$export$1914d1896389da95 = ()=>$40a8b1f594239208$var$listeners.size > 0;
const $40a8b1f594239208$export$58e155918d09bf5f = (observation)=>{
    for (const listener of Array.from($40a8b1f594239208$var$listeners))try {
        listener(observation);
    } catch  {
    // Observability must never change the request's result or error behavior.
    }
};
const $40a8b1f594239208$export$ef42b2d680ea8d8d = ()=>{
    $40a8b1f594239208$var$listeners.clear();
};
module.exports["requestObservationNow"] = $40a8b1f594239208$export$eb91308c925b64ce;
module.exports["requestObservationDuration"] = $40a8b1f594239208$export$327998895df08b85;
module.exports["normalizeRequestRoute"] = $40a8b1f594239208$export$c805539eac489f93;
module.exports["subscribeToRequestObservations"] = $40a8b1f594239208$export$d23c16bc33c579b9;
module.exports["hasRequestObservationSubscribers"] = $40a8b1f594239208$export$1914d1896389da95;
module.exports["publishRequestObservation"] = $40a8b1f594239208$export$58e155918d09bf5f;

});

parcelRegister("cFVPs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3U8XR = parcelRequire("3U8XR");


var $iTJtk = parcelRequire("iTJtk");


var $9DHhW = parcelRequire("9DHhW");


var $jU6s6 = parcelRequire("jU6s6");


var $4dW9D = parcelRequire("4dW9D");


var $96Ikf = parcelRequire("96Ikf");


var $iCEWf = parcelRequire("iCEWf");


var $jLdbZ = parcelRequire("jLdbZ");

const $a12da25560425c44$export$ddf49ad062368ad2 = (customConfig)=>{
    let context = (0, $cozmU.useContext)((0, $jU6s6.AIEventsInstrumentationContext));
    const aiEventAttributesOverride = (0, $cozmU.useRef)({});
    if (customConfig) context = {
        config: {
            ...(0, $4dW9D.defaultAIEventsInstrumentationConfigValues),
            ...customConfig
        },
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ...(0, $jLdbZ.useAIInstrumentationSetup)(customConfig.singleInstrumentationID, customConfig.cookieSingleInstrumentationConfig)
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    if (context === null) throw new Error('useAIEventsInstrumentation must be used within a AIEventsInstrumentationProvider');
    const { config: { source: source, aiExperienceName: aiExperienceName, aiFeatureName: aiFeatureName, aiFeatureId: aiFeatureId, proactiveGeneratedAI: proactiveGeneratedAI, userGeneratedAI: userGeneratedAI, isAIFeature: isAIFeature, channel: channel, subproduct: subproduct, actionSubjectId: actionSubjectId, tags: tags, product: product, eventDispatcherSource: eventDispatcherSource, skipAISessionValidation: skipAISessionValidation, customAnalyticsFire: customAnalyticsFire, additionalAttributes: additionalAttributes, useDefaultGASv3EventSchema: useDefaultGASv3EventSchema, enablePlatformEvents: enablePlatformEvents }, refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = context;
    const validateAndUpdateAISession = (0, $cozmU.useCallback)((nextState)=>{
        const currentAISessionState = getAISessionState();
        return (0, $3U8XR.match)({
            currentState: currentAISessionState,
            nextState: nextState,
            skipAISessionValidation: skipAISessionValidation
        }).with({
            skipAISessionValidation: true
        }, ()=>true).with({
            currentState: (0, $iCEWf.AISessionState).unset,
            nextState: (0, $3U8XR.P).union((0, $iCEWf.AISessionState).viewed, (0, $iCEWf.AISessionState).error, (0, $iCEWf.AISessionState).dismissed)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIInteractionInit()`);
            return false;
        }).with({
            currentState: (0, $iCEWf.AISessionState).initiated,
            nextState: (0, $3U8XR.P).union((0, $iCEWf.AISessionState).submitted, (0, $iCEWf.AISessionState).actioned, (0, $iCEWf.AISessionState).adopted, (0, $iCEWf.AISessionState).discarded)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIResultView()`);
            return false;
        }).otherwise(()=>{
            setAISessionState(nextState);
            return true;
        });
    }, [
        setAISessionState,
        getAISessionState,
        skipAISessionValidation
    ]);
    const fireEventWithOptionalChannel = (0, $cozmU.useCallback)((event)=>{
        if (typeof customAnalyticsFire === 'function') {
            customAnalyticsFire(event, createAnalyticsEvent({}));
            return;
        }
        if (enablePlatformEvents) {
            // it goes thru the aiMate analytics listener to avoid validation per prodcut listener
            // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
            createAnalyticsEvent(event).fire((0, $iTJtk.FabricChannel).aiMate);
            return;
        }
        if (channel) {
            createAnalyticsEvent(event).fire(channel);
            return;
        }
        createAnalyticsEvent(event).fire();
    }, [
        channel,
        customAnalyticsFire,
        createAnalyticsEvent,
        enablePlatformEvents
    ]);
    const createAndMergeEventPayload = (0, $cozmU.useCallback)((payload, partialPayload)=>{
        const singleInstrumentationID = getSingleInstrumentationID();
        const eventPayload = {
            action: payload.action,
            actionSubject: payload.actionSubject,
            actionSubjectId: partialPayload?.actionSubjectId ?? actionSubjectId,
            attributes: {
                aiExperienceName: aiExperienceName,
                aiFeatureName: aiFeatureName,
                aiFeatureId: aiFeatureId,
                proactiveGeneratedAI: proactiveGeneratedAI,
                userGeneratedAI: userGeneratedAI,
                isAIFeature: isAIFeature,
                eventDispatcherSource: eventDispatcherSource,
                singleInstrumentationID: singleInstrumentationID,
                ...payload.attributes,
                ...partialPayload?.attributes,
                ...additionalAttributes,
                ...aiEventAttributesOverride.current
            }
        };
        return (0, $3U8XR.match)({
            product: product,
            channel: channel,
            useDefaultGASv3EventSchema: useDefaultGASv3EventSchema,
            enablePlatformEvents: enablePlatformEvents
        }).with({
            enablePlatformEvents: true
        }, ()=>{
            return {
                eventType: 'track',
                ...eventPayload,
                tags: (0, $96Ikf.getTagsWithPlatformTag)(tags),
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        }).with({
            product: 'confluence',
            channel: (0, $3U8XR.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // confluence event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
            return {
                type: 'sendTrackEvent',
                data: {
                    ...eventPayload,
                    tags: partialPayload?.tags ?? tags,
                    source: partialPayload?.source ?? source,
                    subproduct: subproduct
                }
            };
        }).with({
            product: 'jira',
            channel: (0, $3U8XR.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // jira event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
            // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
            return eventPayload;
        }).otherwise(()=>{
            // for any other product type we should use the default event shape
            // also if there is a custom event channel, we also should use the default event shape
            return {
                eventType: 'track',
                ...eventPayload,
                tags: partialPayload?.tags ?? tags,
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        });
    }, [
        subproduct,
        channel,
        product,
        getSingleInstrumentationID,
        useDefaultGASv3EventSchema,
        source,
        tags,
        eventDispatcherSource,
        actionSubjectId,
        additionalAttributes,
        enablePlatformEvents,
        aiExperienceName,
        aiFeatureName,
        aiFeatureId,
        proactiveGeneratedAI,
        userGeneratedAI,
        isAIFeature
    ]);
    const trackAIInteractionInit = (0, $cozmU.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).initiated)) return;
        refreshSingleInstrumentationID(payload?.attributes?.singleInstrumentationID);
        const event = createAndMergeEventPayload({
            action: 'initiated',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        refreshSingleInstrumentationID,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel,
        validateAndUpdateAISession
    ]);
    const trackAIResultView = (0, $cozmU.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).viewed)) return;
        const { doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, attributes: attributes, ...payloadRest } = payload || {};
        const event = createAndMergeEventPayload({
            action: 'viewed',
            actionSubject: 'aiResult'
        }, {
            ...payloadRest,
            attributes: {
                ...attributes,
                doesNotMeetMAUCriteria: !!doesNotMeetMAUCriteria
            }
        });
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultError = (0, $cozmU.useCallback)((error, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).error)) return;
        const event = createAndMergeEventPayload({
            action: 'error',
            actionSubject: 'aiResult',
            attributes: {
                ...error
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIInteractionDismiss = (0, $cozmU.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).dismissed)) return;
        const event = createAndMergeEventPayload({
            action: 'dismissed',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAction = (0, $cozmU.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).actioned)) return;
        const event = createAndMergeEventPayload({
            action: 'actioned',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultDiscarded = (0, $cozmU.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).discarded)) return;
        const event = createAndMergeEventPayload({
            action: 'discarded',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAdopted = (0, $cozmU.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).adopted)) return;
        const event = createAndMergeEventPayload({
            action: 'adopted',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIFeedbackSubmit = (0, $cozmU.useCallback)((aiFeedbackResult, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).submitted)) return;
        const event = createAndMergeEventPayload({
            action: 'submitted',
            actionSubject: 'aiFeedback',
            attributes: {
                aiFeedbackResult: aiFeedbackResult
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const updateAIAttributes = (0, $cozmU.useCallback)((newAttributes)=>{
        aiEventAttributesOverride.current = {
            ...aiEventAttributesOverride.current,
            ...newAttributes
        };
    }, []);
    const baseReturn = {
        updateAIAttributes: updateAIAttributes,
        trackAIInteractionInit: trackAIInteractionInit,
        trackAIResultView: trackAIResultView,
        trackAIResultError: trackAIResultError,
        trackAIResultDiscarded: trackAIResultDiscarded,
        trackAIInteractionDismiss: trackAIInteractionDismiss,
        trackAIResultAction: trackAIResultAction,
        trackAIResultAdopted: trackAIResultAdopted,
        trackAIFeedbackSubmit: trackAIFeedbackSubmit,
        refreshSingleInstrumentationID: refreshSingleInstrumentationID
    };
    return $a12da25560425c44$var$useStableMethods(baseReturn);
};
/**
 * Returns an object with the same shape as `methods`, but with every method
 * replaced by a stable wrapper that delegates to the latest version. The
 * wrappers are created once on mount; they always read the freshest closure
 * via a ref, so calls observe the same behaviour as calling the unstable
 * methods directly.
 */ function $a12da25560425c44$var$useStableMethods(methods) {
    const ref = (0, $cozmU.useRef)(methods);
    ref.current = methods;
    return (0, $cozmU.useMemo)(()=>{
        const out = {};
        for (const key of Object.keys(ref.current))out[key] = (...args)=>ref.current[key](...args);
        return out;
    // Wrappers always read from `ref.current`; no deps needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useAIEventsInstrumentation"] = $a12da25560425c44$export$ddf49ad062368ad2;

});

parcelRegister("3U8XR", function(module, exports) {
const $2d7d8e3cc345803e$var$t = Symbol.for("@ts-pattern/matcher"), $2d7d8e3cc345803e$var$e = Symbol.for("@ts-pattern/isVariadic"), $2d7d8e3cc345803e$var$n = "@ts-pattern/anonymous-select-key", $2d7d8e3cc345803e$var$r = (t)=>Boolean(t && "object" == typeof t), $2d7d8e3cc345803e$var$i = (e)=>e && !!e[$2d7d8e3cc345803e$var$t], $2d7d8e3cc345803e$var$o = (n, s, c)=>{
    if ($2d7d8e3cc345803e$var$i(n)) {
        const e = n[$2d7d8e3cc345803e$var$t](), { matched: r, selections: i } = e.match(s);
        return r && i && Object.keys(i).forEach((t)=>c(t, i[t])), r;
    }
    if ($2d7d8e3cc345803e$var$r(n)) {
        if (!$2d7d8e3cc345803e$var$r(s)) return !1;
        if (Array.isArray(n)) {
            if (!Array.isArray(s)) return !1;
            let t = [], r = [], a = [];
            for (const o of n.keys()){
                const s = n[o];
                $2d7d8e3cc345803e$var$i(s) && s[$2d7d8e3cc345803e$var$e] ? a.push(s) : a.length ? r.push(s) : t.push(s);
            }
            if (a.length) {
                if (a.length > 1) throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
                if (s.length < t.length + r.length) return !1;
                const e = s.slice(0, t.length), n = 0 === r.length ? [] : s.slice(-r.length), i = s.slice(t.length, 0 === r.length ? Infinity : -r.length);
                return t.every((t, n)=>$2d7d8e3cc345803e$var$o(t, e[n], c)) && r.every((t, e)=>$2d7d8e3cc345803e$var$o(t, n[e], c)) && (0 === a.length || $2d7d8e3cc345803e$var$o(a[0], i, c));
            }
            return n.length === s.length && n.every((t, e)=>$2d7d8e3cc345803e$var$o(t, s[e], c));
        }
        return Reflect.ownKeys(n).every((e)=>{
            const r = n[e];
            var a;
            return (e in s || $2d7d8e3cc345803e$var$i(a = r) && "optional" === a[$2d7d8e3cc345803e$var$t]().matcherType) && $2d7d8e3cc345803e$var$o(r, s[e], c);
        });
    }
    return Object.is(s, n);
}, $2d7d8e3cc345803e$var$s = (e)=>{
    var n, o, a;
    return $2d7d8e3cc345803e$var$r(e) ? $2d7d8e3cc345803e$var$i(e) ? null != (n = null == (o = (a = e[$2d7d8e3cc345803e$var$t]()).getSelectionKeys) ? void 0 : o.call(a)) ? n : [] : Array.isArray(e) ? $2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s) : $2d7d8e3cc345803e$var$c(Object.values(e), $2d7d8e3cc345803e$var$s) : [];
}, $2d7d8e3cc345803e$var$c = (t, e)=>t.reduce((t, n)=>t.concat(e(n)), []);
function $2d7d8e3cc345803e$export$ce1e7a33533a73d9(...t) {
    if (1 === t.length) {
        const [e] = t;
        return (t)=>$2d7d8e3cc345803e$var$o(e, t, ()=>{});
    }
    if (2 === t.length) {
        const [e, n] = t;
        return $2d7d8e3cc345803e$var$o(e, n, ()=>{});
    }
    throw new Error(`isMatching wasn't given the right number of arguments: expected 1 or 2, received ${t.length}.`);
}
function $2d7d8e3cc345803e$var$u(t) {
    return Object.assign(t, {
        optional: ()=>$2d7d8e3cc345803e$var$l(t),
        and: (e)=>$2d7d8e3cc345803e$var$m(t, e),
        or: (e)=>$2d7d8e3cc345803e$var$d(t, e),
        select: (e)=>void 0 === e ? $2d7d8e3cc345803e$var$y(t) : $2d7d8e3cc345803e$var$y(e, t)
    });
}
function $2d7d8e3cc345803e$var$h(t) {
    return Object.assign(((t)=>Object.assign(t, {
            [Symbol.iterator] () {
                let n = 0;
                const r = [
                    {
                        value: Object.assign(t, {
                            [$2d7d8e3cc345803e$var$e]: !0
                        }),
                        done: !1
                    },
                    {
                        done: !0,
                        value: void 0
                    }
                ];
                return {
                    next: ()=>{
                        var t;
                        return null != (t = r[n++]) ? t : r.at(-1);
                    }
                };
            }
        }))(t), {
        optional: ()=>$2d7d8e3cc345803e$var$h($2d7d8e3cc345803e$var$l(t)),
        select: (e)=>$2d7d8e3cc345803e$var$h(void 0 === e ? $2d7d8e3cc345803e$var$y(t) : $2d7d8e3cc345803e$var$y(e, t))
    });
}
function $2d7d8e3cc345803e$var$l(e) {
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return void 0 === t ? ($2d7d8e3cc345803e$var$s(e).forEach((t)=>r(t, void 0)), {
                        matched: !0,
                        selections: n
                    }) : {
                        matched: $2d7d8e3cc345803e$var$o(e, t, r),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2d7d8e3cc345803e$var$s(e),
                matcherType: "optional"
            })
    });
}
const $2d7d8e3cc345803e$var$f = (t, e)=>{
    for (const n of t)if (!e(n)) return !1;
    return !0;
}, $2d7d8e3cc345803e$var$g = (t, e)=>{
    for (const [n, r] of t.entries())if (!e(r, n)) return !1;
    return !0;
};
function $2d7d8e3cc345803e$var$m(...e) {
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return {
                        matched: e.every((e)=>$2d7d8e3cc345803e$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s),
                matcherType: "and"
            })
    });
}
function $2d7d8e3cc345803e$var$d(...e) {
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return $2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s).forEach((t)=>r(t, void 0)), {
                        matched: e.some((e)=>$2d7d8e3cc345803e$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s),
                matcherType: "or"
            })
    });
}
function $2d7d8e3cc345803e$var$p(e) {
    return {
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>({
                        matched: Boolean(e(t))
                    })
            })
    };
}
function $2d7d8e3cc345803e$var$y(...e) {
    const r = "string" == typeof e[0] ? e[0] : void 0, i = 2 === e.length ? e[1] : "string" == typeof e[0] ? void 0 : e[0];
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let e = {
                        [null != r ? r : $2d7d8e3cc345803e$var$n]: t
                    };
                    return {
                        matched: void 0 === i || $2d7d8e3cc345803e$var$o(i, t, (t, n)=>{
                            e[t] = n;
                        }),
                        selections: e
                    };
                },
                getSelectionKeys: ()=>[
                        null != r ? r : $2d7d8e3cc345803e$var$n
                    ].concat(void 0 === i ? [] : $2d7d8e3cc345803e$var$s(i))
            })
    });
}
function $2d7d8e3cc345803e$var$v(t) {
    return "number" == typeof t;
}
function $2d7d8e3cc345803e$var$b(t) {
    return "string" == typeof t;
}
function $2d7d8e3cc345803e$var$w(t) {
    return "bigint" == typeof t;
}
const $2d7d8e3cc345803e$var$S = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return !0;
})), $2d7d8e3cc345803e$var$O = $2d7d8e3cc345803e$var$S, $2d7d8e3cc345803e$var$j = (t)=>Object.assign($2d7d8e3cc345803e$var$u(t), {
        startsWith: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && t.startsWith(n)))));
        },
        endsWith: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && t.endsWith(n)))));
        },
        minLength: (e)=>$2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$b(e) && e.length >= t))(e))),
        length: (e)=>$2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$b(e) && e.length === t))(e))),
        maxLength: (e)=>$2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$b(e) && e.length <= t))(e))),
        includes: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && t.includes(n)))));
        },
        regex: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && Boolean(t.match(n))))));
        }
    }), $2d7d8e3cc345803e$var$K = $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$var$b)), $2d7d8e3cc345803e$var$x = (t)=>Object.assign($2d7d8e3cc345803e$var$u(t), {
        between: (e, n)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t, e)=>$2d7d8e3cc345803e$var$p((n)=>$2d7d8e3cc345803e$var$v(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e < t))(e))),
        gt: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e > t))(e))),
        lte: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e <= t))(e))),
        gte: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e >= t))(e))),
        int: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && Number.isInteger(t)))),
        finite: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && Number.isFinite(t)))),
        positive: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && t > 0))),
        negative: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && t < 0)))
    }), $2d7d8e3cc345803e$var$E = $2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$var$v)), $2d7d8e3cc345803e$var$A = (t)=>Object.assign($2d7d8e3cc345803e$var$u(t), {
        between: (e, n)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t, e)=>$2d7d8e3cc345803e$var$p((n)=>$2d7d8e3cc345803e$var$w(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e < t))(e))),
        gt: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e > t))(e))),
        lte: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e <= t))(e))),
        gte: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e >= t))(e))),
        positive: ()=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$w(t) && t > 0))),
        negative: ()=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$w(t) && t < 0)))
    }), $2d7d8e3cc345803e$var$P = $2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$var$w)), $2d7d8e3cc345803e$var$T = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return "boolean" == typeof t;
})), $2d7d8e3cc345803e$var$B = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return "symbol" == typeof t;
})), $2d7d8e3cc345803e$var$_ = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return null == t;
})), $2d7d8e3cc345803e$var$k = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return null != t;
}));
var $2d7d8e3cc345803e$export$56c0d5a1e737357d = {
    __proto__: null,
    matcher: $2d7d8e3cc345803e$var$t,
    optional: $2d7d8e3cc345803e$var$l,
    array: function(...e) {
        return $2d7d8e3cc345803e$var$h({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>{
                        if (!Array.isArray(t)) return {
                            matched: !1
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const n = e[0];
                        let r = {};
                        if (0 === t.length) return $2d7d8e3cc345803e$var$s(n).forEach((t)=>{
                            r[t] = [];
                        }), {
                            matched: !0,
                            selections: r
                        };
                        const i = (t, e)=>{
                            r[t] = (r[t] || []).concat([
                                e
                            ]);
                        };
                        return {
                            matched: t.every((t)=>$2d7d8e3cc345803e$var$o(n, t, i)),
                            selections: r
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $2d7d8e3cc345803e$var$s(e[0])
                })
        });
    },
    set: function(...e) {
        return $2d7d8e3cc345803e$var$u({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Set)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        }, i = e[0];
                        return {
                            matched: $2d7d8e3cc345803e$var$f(t, (t)=>$2d7d8e3cc345803e$var$o(i, t, r)),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $2d7d8e3cc345803e$var$s(e[0])
                })
        });
    },
    map: function(...e) {
        return $2d7d8e3cc345803e$var$u({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Map)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        var i;
                        if (1 === e.length) throw new Error(`\`P.map\` wasn't given enough arguments. Expected (key, value), received ${null == (i = e[0]) ? void 0 : i.toString()}`);
                        const [s, c] = e;
                        return {
                            matched: $2d7d8e3cc345803e$var$g(t, (t, e)=>{
                                const n = $2d7d8e3cc345803e$var$o(s, e, r), i = $2d7d8e3cc345803e$var$o(c, t, r);
                                return n && i;
                            }),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : [
                            ...$2d7d8e3cc345803e$var$s(e[0]),
                            ...$2d7d8e3cc345803e$var$s(e[1])
                        ]
                })
        });
    },
    intersection: $2d7d8e3cc345803e$var$m,
    union: $2d7d8e3cc345803e$var$d,
    not: function(e) {
        return $2d7d8e3cc345803e$var$u({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>({
                            matched: !$2d7d8e3cc345803e$var$o(e, t, ()=>{})
                        }),
                    getSelectionKeys: ()=>[],
                    matcherType: "not"
                })
        });
    },
    when: $2d7d8e3cc345803e$var$p,
    select: $2d7d8e3cc345803e$var$y,
    any: $2d7d8e3cc345803e$var$S,
    _: $2d7d8e3cc345803e$var$O,
    string: $2d7d8e3cc345803e$var$K,
    number: $2d7d8e3cc345803e$var$E,
    bigint: $2d7d8e3cc345803e$var$P,
    boolean: $2d7d8e3cc345803e$var$T,
    symbol: $2d7d8e3cc345803e$var$B,
    nullish: $2d7d8e3cc345803e$var$_,
    nonNullable: $2d7d8e3cc345803e$var$k,
    instanceOf: function(t) {
        return $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
            return (e)=>e instanceof t;
        }(t)));
    },
    shape: function(t) {
        return $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$export$ce1e7a33533a73d9(t)));
    }
};
class $2d7d8e3cc345803e$export$6c1467edb54d3773 extends Error {
    constructor(t){
        let e;
        try {
            e = JSON.stringify(t);
        } catch (n) {
            e = t;
        }
        super(`Pattern matching error: no pattern matches value ${e}`), this.input = void 0, this.input = t;
    }
}
const $2d7d8e3cc345803e$var$$ = {
    matched: !1,
    value: void 0
};
function $2d7d8e3cc345803e$export$4659b591c19bdf3d(t) {
    return new $2d7d8e3cc345803e$var$I(t, $2d7d8e3cc345803e$var$$);
}
class $2d7d8e3cc345803e$var$I {
    with(...t) {
        if (this.state.matched) return this;
        const e = t[t.length - 1], r = [
            t[0]
        ];
        let i;
        3 === t.length && "function" == typeof t[1] ? i = t[1] : t.length > 2 && r.push(...t.slice(1, t.length - 1));
        let s = !1, c = {};
        const a = (t, e)=>{
            s = !0, c[t] = e;
        }, u = !r.some((t)=>$2d7d8e3cc345803e$var$o(t, this.input, a)) || i && !Boolean(i(this.input)) ? $2d7d8e3cc345803e$var$$ : {
            matched: !0,
            value: e(s ? $2d7d8e3cc345803e$var$n in c ? c[$2d7d8e3cc345803e$var$n] : c : this.input, this.input)
        };
        return new $2d7d8e3cc345803e$var$I(this.input, u);
    }
    when(t, e) {
        if (this.state.matched) return this;
        const n = Boolean(t(this.input));
        return new $2d7d8e3cc345803e$var$I(this.input, n ? {
            matched: !0,
            value: e(this.input, this.input)
        } : $2d7d8e3cc345803e$var$$);
    }
    otherwise(t) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    exhaustive(t = $2d7d8e3cc345803e$var$L) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    run() {
        return this.exhaustive();
    }
    returnType() {
        return this;
    }
    narrow() {
        return this;
    }
    constructor(t, e){
        this.input = void 0, this.state = void 0, this.input = t, this.state = e;
    }
}
function $2d7d8e3cc345803e$var$L(t) {
    throw new $2d7d8e3cc345803e$export$6c1467edb54d3773(t);
}
 //# sourceMappingURL=index.js.map
module.exports["P"] = $2d7d8e3cc345803e$export$56c0d5a1e737357d;
module.exports["match"] = $2d7d8e3cc345803e$export$4659b591c19bdf3d;

});

parcelRegister("jU6s6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $1f90c1a79bae927c$export$4f059feb37b5835e = (0, $cozmU.createContext)(null);
module.exports["AIEventsInstrumentationContext"] = $1f90c1a79bae927c$export$4f059feb37b5835e;

});

parcelRegister("4dW9D", function(module, exports) {

var $iCEWf = parcelRequire("iCEWf");

const $7545c0c100898f47$export$5013b36eeed4ec19 = {
    isAIFeature: 1,
    actionSubjectId: 'client',
    eventDispatcherSource: (0, $iCEWf.EventDispatcherSources).JSLib,
    skipAISessionValidation: false,
    useDefaultGASv3EventSchema: false,
    enablePlatformEvents: false
};
module.exports["defaultAIEventsInstrumentationConfigValues"] = $7545c0c100898f47$export$5013b36eeed4ec19;

});

parcelRegister("iCEWf", function(module, exports) {
var $d6416e2c87d11da8$export$af92e0e920a45719 = /*#__PURE__*/ function(AISessionState) {
    AISessionState["unset"] = "[AIInteraction]:UNSET";
    AISessionState["initiated"] = "[AIInteraction]:INITIATED";
    AISessionState["viewed"] = "[AIInteraction]:VIEWED";
    AISessionState["error"] = "[AIInteraction]:ERROR";
    AISessionState["dismissed"] = "[AIInteraction]:DISMISSED";
    AISessionState["actioned"] = "[AIInteraction]:ACTIONED";
    AISessionState["adopted"] = "[AIInteraction]:ADOPTED";
    AISessionState["discarded"] = "[AIInteraction]:DISCARDED";
    AISessionState["submitted"] = "[AIInteraction]:SUBMITTED";
    return AISessionState;
}({});
var $d6416e2c87d11da8$export$7052d5b66e36f60f = /*#__PURE__*/ function(EventDispatcherSources) {
    EventDispatcherSources["JSLib"] = "name:@atlassian/ai-analytics|language:javascript";
    return EventDispatcherSources;
}({});
module.exports["AISessionState"] = $d6416e2c87d11da8$export$af92e0e920a45719;
module.exports["EventDispatcherSources"] = $d6416e2c87d11da8$export$7052d5b66e36f60f;

});

parcelRegister("96Ikf", function(module, exports) {
const $3836d38b50a38c42$export$e053e424fcbfebe9 = (tags)=>{
    const defaultTags = [
        'atlaskit'
    ];
    if (!tags) return defaultTags;
    return defaultTags.concat(tags);
};
module.exports["getTagsWithPlatformTag"] = $3836d38b50a38c42$export$e053e424fcbfebe9;

});

parcelRegister("jLdbZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1r1cI = parcelRequire("1r1cI");


var $7mJer = parcelRequire("7mJer");


var $iCEWf = parcelRequire("iCEWf");

const $e5d5cfe1f6d4c858$export$259576f4e7ac6488 = (customSingleInstrumentationIDFromUserConfig, cookieSingleInstrumentationConfig)=>{
    const singleInstrumentationIDRef = (0, $cozmU.useRef)(undefined);
    const aiSessionStateRef = (0, $cozmU.useRef)((0, $iCEWf.AISessionState).unset);
    const setAISessionState = (0, $cozmU.useCallback)((nextState)=>{
        aiSessionStateRef.current = nextState;
    }, []);
    const getAISessionState = (0, $cozmU.useCallback)(()=>{
        return aiSessionStateRef.current;
    }, []);
    const refreshSingleInstrumentationID = (0, $cozmU.useCallback)((customSingleInstrumentationIDFromEvent)=>{
        const nextSingleInstrumentationID = (0, $1r1cI.getNewSingleInstrumentationID)(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig);
        singleInstrumentationIDRef.current = nextSingleInstrumentationID;
        if (cookieSingleInstrumentationConfig) (0, $7mJer.setSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName, nextSingleInstrumentationID);
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig
    ]);
    const getSingleInstrumentationID = (0, $cozmU.useCallback)(()=>{
        // this handles a race condition when we have a new singleInstrumentationID from the user config
        // but Provider knows only about the initial singleInstrumentationID. In this case we need to update
        // singleInstrumentationID at first step and then return a new one.
        if (customSingleInstrumentationIDFromUserConfig && customSingleInstrumentationIDFromUserConfig !== singleInstrumentationIDRef.current) {
            refreshSingleInstrumentationID();
            return singleInstrumentationIDRef.current;
        }
        if (cookieSingleInstrumentationConfig) return (0, $7mJer.readSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName);
        return singleInstrumentationIDRef.current;
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig,
        refreshSingleInstrumentationID
    ]);
    return {
        refreshSingleInstrumentationID: refreshSingleInstrumentationID,
        getSingleInstrumentationID: getSingleInstrumentationID,
        setAISessionState: setAISessionState,
        getAISessionState: getAISessionState
    };
};
module.exports["useAIInstrumentationSetup"] = $e5d5cfe1f6d4c858$export$259576f4e7ac6488;

});

parcelRegister("1r1cI", function(module, exports) {

var $3U8XR = parcelRequire("3U8XR");


var $03RpJ = parcelRequire("03RpJ");

function $d83e4e74e28b2b37$export$cee2a1482be61648(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig) {
    // priority for setting singleInstrumentationID override rule
    // 1. from consumer event attribute
    // 2. from consumer configuration
    // 3. from cookie lib
    // 4. default behaviour generates through the crypto API
    return (0, $3U8XR.match)({
        customSingleInstrumentationIDFromEvent: customSingleInstrumentationIDFromEvent,
        customSingleInstrumentationIDFromUserConfig: customSingleInstrumentationIDFromUserConfig
    }).with({
        customSingleInstrumentationIDFromEvent: (0, $3U8XR.P).string
    }, (result)=>result.customSingleInstrumentationIDFromEvent).with({
        customSingleInstrumentationIDFromUserConfig: (0, $3U8XR.P).string
    }, (result)=>result.customSingleInstrumentationIDFromUserConfig)// we can't use the crypto API in the browser due to SSR issues?
    // https://atlassian.slack.com/archives/C051ARA9QGH/p1749587419868869
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    .otherwise(()=>(0, $03RpJ.default)());
}
module.exports["getNewSingleInstrumentationID"] = $d83e4e74e28b2b37$export$cee2a1482be61648;

});

parcelRegister("7mJer", function(module, exports) {

var $1Qi0Q = parcelRequire("1Qi0Q");

var $lnexi = parcelRequire("lnexi");

const $0ca840bf5f9ee98d$export$72d8c154d3f75075 = 'SINGLE_INSTRUMENTATION_ID_IS_NOT_SET';
const $0ca840bf5f9ee98d$export$35ae1861d13fb6c8 = (uniqueCookieFeatureName)=>`AI_INSTRUMENTATION_FEATURE_ID_${uniqueCookieFeatureName}`;
const $0ca840bf5f9ee98d$export$9a4eaf99327c19fe = (uniqueCookieFeatureName, nextSingleInstrumentationID)=>(0, $lnexi.setCookie)($0ca840bf5f9ee98d$export$35ae1861d13fb6c8(uniqueCookieFeatureName), nextSingleInstrumentationID, {
        expires: 7,
        domain: location.hostname,
        sameSite: 'strict'
    });
const $0ca840bf5f9ee98d$export$d6fb1caea334c7c7 = (uniqueCookieFeatureName)=>(0, $1Qi0Q.getCookie)($0ca840bf5f9ee98d$export$35ae1861d13fb6c8(uniqueCookieFeatureName)) || $0ca840bf5f9ee98d$export$72d8c154d3f75075;
module.exports["setSingleInstrumentationIDCookie"] = $0ca840bf5f9ee98d$export$9a4eaf99327c19fe;
module.exports["readSingleInstrumentationIDCookie"] = $0ca840bf5f9ee98d$export$d6fb1caea334c7c7;

});

parcelRegister("4tOXV", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $w6R6I = parcelRequire("w6R6I");


var $fZAJP = parcelRequire("fZAJP");

const $05ef07480c610d29$export$9ac100e40613ea10 = ()=>{
    let userAgent = '';
    if (window?.__SSR_USER_AGENT__) userAgent = window.__SSR_USER_AGENT__;
    else userAgent = window?.navigator?.userAgent ?? '';
    return userAgent.indexOf('Mac') > -1;
};
const $05ef07480c610d29$var$styles = {
    flexCenter: "_4c065UFQfX _3iDTPbQ4SZ _0hPCNLDIqT",
    base: "_0bjKvDKxmn _4c065UFQfX _2Y7lL42ADO _3iDTPbvbI6 _2XsHFMFQfX _0adFHsFQfX",
    contentBefore: "_2XsHFM1Y8M _0adFHsPgdg",
    darkBackground: "_0KLXrueZ10",
    lightBackground: "_0KLXrumhAQ"
};
const $05ef07480c610d29$var$i18n = (0, $kSwu1.defineMessages)({
    keyboardShortcutShift: {
        id: "shortcuts.shift",
        defaultMessage: "Shift"
    },
    keyboardShortcutCtrl: {
        id: "shortcuts.ctrl",
        defaultMessage: "Ctrl"
    },
    keyboardShortcutCommandWin: {
        id: "shortcuts.cmd.win",
        defaultMessage: "Ctrl"
    },
    keyboardShortcutCommandMac: {
        id: "shortcuts.cmd.mac",
        defaultMessage: "Cmd"
    },
    keyboardShortcutOptionMac: {
        id: "shortcuts.opt.mac",
        defaultMessage: "Opt"
    },
    keyboardShortcutOptionWin: {
        id: "shortcuts.opt.win",
        defaultMessage: "Alt"
    },
    keyboardShortcutPlus: {
        id: "shortcuts.plus",
        defaultMessage: "+"
    },
    keyboardShortcutMinus: {
        id: "shortcuts.minus",
        defaultMessage: "-"
    },
    keyboardShortcutEnter: {
        id: "shortcuts.enter",
        defaultMessage: "Enter"
    },
    keyboardShortcutMeta: {
        id: "shortcuts.meta",
        defaultMessage: "Meta"
    }
});
const $05ef07480c610d29$var$processKey = (key, formatMessage)=>{
    const mac = $05ef07480c610d29$export$9ac100e40613ea10();
    const lowerCaseKey = key.toLowerCase();
    switch(lowerCaseKey){
        case 'shift':
            return '\u21E7';
        // ⇧
        case 'cmd':
        case 'mod':
            return mac ? '\u2318' // ⌘
             : formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutCommandWin);
        case 'ctrl':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutCtrl);
        case 'opt':
        case 'option':
            return mac ? formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutOptionMac) : formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutOptionWin);
        case 'enter':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutEnter);
        case 'meta':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutMeta);
        case 'uparrow':
            return '\u2191';
        // ↑
        case 'downarrow':
            return '\u2193';
        // ↓
        case 'leftarrow':
            return '\u2190';
        // ←
        case 'rightarrow':
            return '\u2192';
        // →
        case 'plus':
            return '+';
        case 'minus':
            return '-';
        default:
            return key;
    }
};
const $05ef07480c610d29$var$getShortcutStrings = (accelerator, formatMessage)=>{
    const shortcutKeys = accelerator.includes(' ') ? accelerator.split(' ') : accelerator.split('+');
    return shortcutKeys.map((key)=>{
        const processedKey = $05ef07480c610d29$var$processKey(key, formatMessage);
        if (processedKey.length === 1) return processedKey.toUpperCase();
        else return processedKey;
    });
};
const $05ef07480c610d29$export$7571b974b8c6ca70 = (accelerator, formatMessage)=>{
    return $05ef07480c610d29$var$getShortcutStrings(accelerator, formatMessage).join(' ');
};
const $05ef07480c610d29$export$7005a48098466b5d = (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { shortcut: shortcut, contentBefore: contentBefore, isEditorShortcut: isEditorShortcut, isTooltip: t1 } = t0;
    const isTooltip = t1 === undefined ? false : t1;
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    const intl = (0, $kSwu1.useIntl)();
    let T0;
    let t2;
    let t3;
    let t4;
    let t5;
    if ($[0] !== areKeyboardShortcutsEnabled || $[1] !== contentBefore || $[2] !== intl.formatMessage || $[3] !== isEditorShortcut || $[4] !== isTooltip || $[5] !== shortcut) {
        const shortcutStrings = $05ef07480c610d29$var$getShortcutStrings(shortcut, intl.formatMessage);
        const shouldRenderShortcutSegment = areKeyboardShortcutsEnabled || isEditorShortcut;
        T0 = (0, $iMnC5.Box);
        t2 = "span";
        t3 = $05ef07480c610d29$var$styles.flexCenter;
        t4 = contentBefore;
        t5 = shouldRenderShortcutSegment && shortcutStrings.map((shortcutSegment, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "span",
                key: `${shortcutSegment}-${index}`,
                xcss: (0, $w6R6I.cx)($05ef07480c610d29$var$styles.base, Boolean(contentBefore) && $05ef07480c610d29$var$styles.contentBefore, isTooltip ? $05ef07480c610d29$var$styles.darkBackground : $05ef07480c610d29$var$styles.lightBackground)
            }, shortcutSegment));
        $[0] = areKeyboardShortcutsEnabled;
        $[1] = contentBefore;
        $[2] = intl.formatMessage;
        $[3] = isEditorShortcut;
        $[4] = isTooltip;
        $[5] = shortcut;
        $[6] = T0;
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else {
        T0 = $[6];
        t2 = $[7];
        t3 = $[8];
        t4 = $[9];
        t5 = $[10];
    }
    let t6;
    if ($[11] !== T0 || $[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            as: t2,
            xcss: t3
        }, t4, t5);
        $[11] = T0;
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
}; /**
    * Converts shortcut strings like "ctrl+[" to an array of strings like ["Ctrl", "["].
    *
    * This is used for mapping the shortcut constants in `confluence-shortcuts.ts` to the
    * format expected by the ADS Tooltip `shortcut` prop.
    *
    * It checks if keyboard shortcuts are enabled and returns undefined if they are not.
    *
    * @example
    * ```
    * const shortcut = useShortcutStrings({ shortcut: 'ctrl+[' });
    * <Tooltip content="My tooltip" shortcut={shortcut} />
    * ```
    */ 
const $05ef07480c610d29$export$e84ae736f9706c5d = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { shortcut: shortcut, isEditorShortcut: t1 } = t0;
    const isEditorShortcut = t1 === undefined ? false : t1;
    const intl = (0, $kSwu1.useIntl)();
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    if (!shortcut) return;
    let t2;
    if ($[0] !== intl.formatMessage || $[1] !== shortcut) {
        t2 = $05ef07480c610d29$var$getShortcutStrings(shortcut, intl.formatMessage);
        $[0] = intl.formatMessage;
        $[1] = shortcut;
        $[2] = t2;
    } else t2 = $[2];
    const shortcutStrings = t2;
    const shouldDisplayShortcut = areKeyboardShortcutsEnabled || isEditorShortcut;
    if (!shouldDisplayShortcut) return;
    return shortcutStrings;
};
module.exports["isMac"] = $05ef07480c610d29$export$9ac100e40613ea10;
module.exports["getShortcutString"] = $05ef07480c610d29$export$7571b974b8c6ca70;
module.exports["ShortcutVisualizer"] = $05ef07480c610d29$export$7005a48098466b5d;
module.exports["useShortcutStrings"] = $05ef07480c610d29$export$e84ae736f9706c5d;

});

parcelRegister("fZAJP", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $3y1ko = parcelRequire("3y1ko");

let $640354b193201be7$var$inflightPromise = null;
const $640354b193201be7$var$updaters = new Set();
const $640354b193201be7$export$130f87a5d53e682d = ()=>{
    const $ = (0, $bDgLe.c)(6);
    const { isLoggedIn: isLoggedIn, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const [enabled, setEnabled] = (0, $cozmU.useState)(window.__SHORTCUT_ENABLED__ ?? false);
    let t0;
    let t1;
    if ($[0] !== isLicensed || $[1] !== isLoggedIn) {
        t0 = ()=>{
            if (typeof window.__SHORTCUT_ENABLED__ !== "boolean") {
                if (!$640354b193201be7$var$inflightPromise) $640354b193201be7$var$inflightPromise = isLoggedIn && isLicensed ? (0, $3y1ko.fetchShortcutEnabledState)() : Promise.resolve(false);
                $640354b193201be7$var$inflightPromise.then(setEnabled);
            }
            $640354b193201be7$var$updaters.add(setEnabled);
            return ()=>{
                $640354b193201be7$var$updaters.delete(setEnabled);
            };
        };
        t1 = [
            isLoggedIn,
            isLicensed
        ];
        $[0] = isLicensed;
        $[1] = isLoggedIn;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    const notify = $640354b193201be7$var$_temp;
    const t2 = Boolean(enabled);
    let t3;
    if ($[4] !== t2) {
        t3 = [
            t2,
            notify
        ];
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
};
async function $640354b193201be7$var$_temp(enabled_0) {
    try {
        const res = await (0, $f7B1p.cfetch)("/wiki/rest/confluenceshortcuts/latest/enabled", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                enabled: enabled_0
            })
        });
        if (res.ok) {
            const newEnabled = await res.text() === "true";
            window.__SHORTCUT_ENABLED__ = newEnabled;
            $640354b193201be7$var$updaters.forEach((updater)=>updater(newEnabled));
        }
    } catch (t0) {
        const e = t0;
        (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Error updating keyboard shortcuts enabled state: ${e.message}`), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        });
    }
}
module.exports["useKeyboardShortcutsEnabled"] = $640354b193201be7$export$130f87a5d53e682d;

});

parcelRegister("8i27m", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $3u5lg = parcelRequire("3u5lg");

var $33a0cfbfba499043$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    return CommentType;
}({});
var $33a0cfbfba499043$export$74159dff405238c0 = /*#__PURE__*/ function(CommentActionType) {
    CommentActionType["DELETE_COMMENT"] = "deleted";
    // If you ever update this, please also update commentsNavigationUtils, which relies on the string to avoid circular deps
    CommentActionType["RESOLVE_COMMENT_THREAD"] = "resolved";
    return CommentActionType;
}({});
const $33a0cfbfba499043$export$53ac33307b5acee9 = ()=>({
        orderedActiveAnnotationIdList: [],
        commentThreadsRemovedByOtherUsers: {}
    });
const $33a0cfbfba499043$export$e324594224ef24da = {
    setOrderedActiveAnnotationIdList: (newCommentsList)=>({ getState: getState, setState: setState })=>{
            const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = getState();
            if (!newCommentsList || newCommentsList.length === 0) {
                // Only update state if the current list is not already empty
                if (orderedActiveAnnotationIdList.length > 0) setState({
                    orderedActiveAnnotationIdList: []
                });
                return;
            }
            // Create a map of existing annotationId to their isLoaded states for quick lookup
            const existingAnnotationsMap = new Map(orderedActiveAnnotationIdList.map(({ threadKey: threadKey, isLoaded: isLoaded })=>[
                    threadKey,
                    isLoaded
                ]));
            // Use a Set to ensure unique annotation IDs
            const uniqueCommentsSet = new Set(newCommentsList);
            // Map the unique comments set to the new state, preserving isLoaded where possible
            const updatedAnnotationList = Array.from(uniqueCommentsSet).map((threadKey)=>({
                    threadKey: threadKey,
                    isLoaded: existingAnnotationsMap.get(threadKey) ?? false // Preserve existing isLoaded or default to false
                }));
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(orderedActiveAnnotationIdList, updatedAnnotationList)) setState({
                orderedActiveAnnotationIdList: updatedAnnotationList
            });
        },
    getCurrentCommentsPanelState: ()=>({ getState: getState })=>{
            return getState();
        },
    // keep track of removed annotations
    updateRemovedCommentIdsMap: ({ commentId: commentId, commentActionType: commentActionType })=>({ setState: setState, getState: getState })=>{
            const { commentThreadsRemovedByOtherUsers: commentThreadsRemovedByOtherUsers } = getState();
            // Update commentThreadsRemovedByOtherUsers map
            const updatedRemovedComments = {
                ...commentThreadsRemovedByOtherUsers
            };
            updatedRemovedComments[commentId] = commentActionType;
            // Update the removed-by-other-users map.
            setState({
                commentThreadsRemovedByOtherUsers: updatedRemovedComments
            });
        },
    reopenParentComment: ({ parentCommentId: parentCommentId })=>({ setState: setState, getState: getState })=>{
            // Records a reopened parent comment in the commentThreadsRemovedByOtherUsers map.
            if (!parentCommentId) return;
            const { commentThreadsRemovedByOtherUsers: currentRemovedComments } = getState();
            const updatedRemovedComments = {
                ...currentRemovedComments
            };
            delete updatedRemovedComments[parentCommentId];
            setState({
                commentThreadsRemovedByOtherUsers: updatedRemovedComments
            });
        },
    clearRemovedComments: ()=>({ setState: setState })=>{
            setState({
                commentThreadsRemovedByOtherUsers: {}
            });
        },
    clearCommentsData: ()=>({ setState: setState })=>{
            setState($33a0cfbfba499043$export$53ac33307b5acee9());
        }
};
const $33a0cfbfba499043$export$13b7c646235a7fd4 = (0, $8s9DV.createStore)({
    initialState: $33a0cfbfba499043$export$53ac33307b5acee9(),
    actions: $33a0cfbfba499043$export$e324594224ef24da,
    name: 'CommentsDataStore'
});
const $33a0cfbfba499043$export$80f09eb388fa70f9 = (0, $kBr4q.createHook)($33a0cfbfba499043$export$13b7c646235a7fd4);
const $33a0cfbfba499043$export$b5e3986841a4e13f = (0, $kBr4q.createActionsHook)($33a0cfbfba499043$export$13b7c646235a7fd4);
const $33a0cfbfba499043$export$c14a8182bd597724 = (0, $kBr4q.createStateHook)($33a0cfbfba499043$export$13b7c646235a7fd4);
module.exports["CommentType"] = $33a0cfbfba499043$export$ffa1150e6a48f9cd;
module.exports["CommentActionType"] = $33a0cfbfba499043$export$74159dff405238c0;
module.exports["useCommentsData"] = $33a0cfbfba499043$export$80f09eb388fa70f9;
module.exports["useCommentsDataActions"] = $33a0cfbfba499043$export$b5e3986841a4e13f;
module.exports["useCommentsDataState"] = $33a0cfbfba499043$export$c14a8182bd597724;

});

parcelRegister("aWwYt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $lRhY3 = parcelRequire("lRhY3");

const $5371993c50b87836$export$c0cd7aea5be0e780 = 40;
const $5371993c50b87836$export$9e0a6941e0e87c97 = 400;
const $5371993c50b87836$export$21f0d255469350e0 = 3840;
const $5371993c50b87836$export$70e5631b7ec2f387 = Math.max($5371993c50b87836$export$9e0a6941e0e87c97, 368) + $5371993c50b87836$export$c0cd7aea5be0e780;
const $5371993c50b87836$export$d4c72bab9d6cc13a = {
    isPanelScrolled: false,
    isObjectSidebarShown: false,
    behavior: 'push',
    panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
    panel: undefined,
    updatedPanelHeaderComponentElements: undefined,
    sidebarControlState: window.__SSR_RENDERED__ ? 'shown' : 'hidden',
    sidebarControlExpandCollapsedState: window.__SSR_RENDERED__ ? 'expanded' : 'collapsed',
    activeActionInPanel: undefined
};
const $5371993c50b87836$export$e324594224ef24da = {
    setIsPanelScrolled: (isPanelScrolled)=>({ setState: setState })=>{
            setState({
                isPanelScrolled: isPanelScrolled
            });
        },
    setSidebarControlState: (sidebarControlState)=>({ setState: setState })=>{
            setState({
                sidebarControlState: sidebarControlState
            });
        },
    showSidebarControlIfNoPanel: ()=>({ setState: setState, getState: getState })=>{
            // Read the store at dispatch time rather than relying on a React render snapshot.
            // A deeplink can open the panel between render and a passive effect being flushed.
            if (!getState().isObjectSidebarShown) setState({
                sidebarControlState: 'shown'
            });
        },
    setSidebarControlExpandCollapsedState: (sidebarControlExpandCollapsedState)=>({ setState: setState })=>{
            setState({
                sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState
            });
        },
    toggleObjectSidebarControl: ()=>({ setState: setState, getState: getState })=>{
            const { sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState } = getState();
            if (sidebarControlExpandCollapsedState === 'collapsed') setState({
                sidebarControlExpandCollapsedState: 'expanded'
            });
            else setState({
                sidebarControlExpandCollapsedState: 'collapsed'
            });
        },
    showObjectSidebar: (panel, behavior, panelWidth)=>({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: currentPanel, behavior: currentBehavior, panelWidth: currentPanelWidth } = getState();
            // Check if panel is open
            if (isObjectSidebarShown) {
                // If it's the same panel do nothing
                if (currentPanel?.id === panel.id) return;
                // Otherwise change it
                setState({
                    panel: panel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: behavior ?? currentBehavior,
                    panelWidth: panelWidth ?? currentPanelWidth,
                    isPanelScrolled: false
                });
            }
            // Set the panel to be open
            setState({
                isObjectSidebarShown: true,
                panel: panel,
                updatedPanelHeaderComponentElements: undefined,
                behavior: behavior ?? currentBehavior,
                panelWidth: panelWidth ?? currentPanelWidth,
                sidebarControlState: 'hidden',
                isPanelScrolled: false
            });
            // Close the global panel
            window.dispatchEvent(new Event('closeGlobalSidebar'));
        },
    hideObjectSidebar: (afterCloseCallback)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            // If we're not showing a panel, don't do anything
            if (!isObjectSidebarShown || !panel) return;
            // If the user has provided closeOptions check them
            if (panel.closeOptions) {
                const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                // If the panel closing check returns false, do nothing
                if (canClosePanel) {
                    const panelCanClose = await canClosePanel();
                    if (!panelCanClose) return;
                }
                // Call the onClose callback
                onPanelClose && onPanelClose();
            }
            // Close the panel
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
            if (afterCloseCallback) afterCloseCallback();
        },
    hideObjectSidebarByPanelId: (id)=>({ getState: getState, dispatch: dispatch })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) dispatch($5371993c50b87836$export$e324594224ef24da.hideObjectSidebar());
        },
    /**
   * Hide the sidebar immediately, bypassing the canClosePanel guard.
   * Use only when the caller has already confirmed with the user that it is
   * safe to discard any draft (e.g. after showing their own warning dialog).
   */ hideObjectSidebarForce: ()=>({ getState: getState, setState: setState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            if (!isObjectSidebarShown || !panel) return;
            panel.closeOptions?.onPanelClose?.();
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
        },
    /**
   * Legacy writer used by `ObjectSidebarPushPlaceholder`'s ResizeObserver
   * loop, which reports the inner content width (without push padding).
   * Prefer `setVisiblePanelWidth` from drag-resize call sites.
   */ setPanelWidth: (newPanelWidth)=>({ setState: setState })=>{
            const clamped = Math.min(Math.max(newPanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97), $5371993c50b87836$export$21f0d255469350e0);
            setState({
                panelWidth: clamped + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    /**
   * Drag-resize writer. Takes the *visible* panel width directly (no
   * `−CONTENT_RIGHT_PADDING` at the call site). Same encoding as
   * `setPanelWidth`, so `panelWidth` consistently represents
   * "visible + push padding" regardless of which writer set it.
   */ setVisiblePanelWidth: (visiblePanelWidth)=>({ setState: setState })=>{
            const clamped = Math.min(Math.max(visiblePanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97), $5371993c50b87836$export$21f0d255469350e0);
            setState({
                panelWidth: clamped + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    changePanelBehavior: (newBehavior)=>({ setState: setState, getState: getState })=>{
            const { panelWidth: panelWidth } = getState();
            // When we set the new state, if it's set to cover, we no longer have a
            // component that will size the panel accordingly so we just use the default
            setState({
                behavior: newBehavior,
                panelWidth: newBehavior === 'cover' ? $5371993c50b87836$export$70e5631b7ec2f387 : panelWidth
            });
        },
    changePanel: (newPanel, newBehavior, newPanelWidth)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel, behavior: behavior, panelWidth: panelWidth } = getState();
            // Only change panels if the panel is open
            if (isObjectSidebarShown && panel) {
                // If it's the same panel do nothing
                if (panel.id === newPanel.id) return;
                // If the user has provided closeOptions check them
                if (panel.closeOptions) {
                    const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                    // If the panel closing check returns false, do nothing
                    if (canClosePanel) {
                        const panelCanClose = await canClosePanel();
                        if (!panelCanClose) return;
                    }
                    // Call the onClose callback
                    onPanelClose && onPanelClose();
                }
                setState({
                    panel: newPanel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: newBehavior ?? behavior,
                    panelWidth: newPanelWidth ?? panelWidth,
                    isPanelScrolled: false
                });
            }
        // Otherwise do nothing
        },
    changeHeaderElements: (id, headerComponentElements)=>({ setState: setState, getState: getState })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) setState({
                updatedPanelHeaderComponentElements: headerComponentElements
            });
        },
    setActiveActionInPanel: (activeActionInPanel)=>({ setState: setState, getState: getState })=>{
            const { activeActionInPanel: currentActiveAction } = getState();
            // If the active action is the same, do nothing
            if (currentActiveAction?.title === activeActionInPanel?.title) return;
            setState({
                activeActionInPanel: activeActionInPanel
            });
        }
};
const $5371993c50b87836$export$8930ecd60eb3f136 = (0, $8s9DV.createStore)({
    initialState: $5371993c50b87836$export$d4c72bab9d6cc13a,
    actions: $5371993c50b87836$export$e324594224ef24da,
    name: 'ObjectSidebarStore'
});
const $5371993c50b87836$var$useObjectSidebarActionsInternal = (0, $kBr4q.createActionsHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$export$332594c77a860a26 = ()=>{
    const internalActions = $5371993c50b87836$var$useObjectSidebarActionsInternal();
    const { close: close } = (0, $lRhY3.usePreviewPanelsActions)();
    const showObjectSidebarWrapper = (0, $cozmU.useCallback)((panel, behavior, panelWidth)=>{
        internalActions.showObjectSidebar(panel, behavior, panelWidth);
        close();
    }, [
        internalActions,
        close
    ]);
    const showObjectSidebar = showObjectSidebarWrapper;
    const memoizedActions = (0, $cozmU.useMemo)(()=>({
            ...internalActions,
            showObjectSidebar: showObjectSidebar
        }), [
        internalActions,
        showObjectSidebar
    ]);
    return (0, $cozmU.useMemo)(()=>memoizedActions, [
        memoizedActions
    ]);
};
const $5371993c50b87836$export$41c5dcc793387db5 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$var$getIsObjectSidebarShown = (state)=>state.isObjectSidebarShown;
const $5371993c50b87836$var$getPanel = (state)=>state.panel;
const $5371993c50b87836$var$getBehavior = (state)=>state.behavior;
const $5371993c50b87836$var$isPanelScrolled = (state)=>state.isPanelScrolled;
const $5371993c50b87836$var$getPanelWidth = (state)=>state.panelWidth;
const $5371993c50b87836$var$getUpdatedHeaderComponentElements = (state)=>state.updatedPanelHeaderComponentElements;
const $5371993c50b87836$var$getSidebarControlState = (state)=>state.sidebarControlState;
const $5371993c50b87836$var$getSidebarControlExpandCollapsedState = (state)=>state.sidebarControlExpandCollapsedState;
const $5371993c50b87836$var$getActiveAction = (state)=>state.activeActionInPanel;
const $5371993c50b87836$export$a572d51222d5ea45 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getIsObjectSidebarShown
});
const $5371993c50b87836$export$9168a42f32e3d071 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanel
});
const $5371993c50b87836$export$8b43142d6fd506da = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getBehavior
});
const $5371993c50b87836$export$ec8631e69ae8c803 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$isPanelScrolled
});
const $5371993c50b87836$export$82b270f291af5a5 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanelWidth
});
const $5371993c50b87836$export$bc4f8f2fe52e3d40 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getUpdatedHeaderComponentElements
});
const $5371993c50b87836$export$d4d7180dad517777 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlState
});
const $5371993c50b87836$export$b00fb66a9723fc58 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlExpandCollapsedState
});
const $5371993c50b87836$export$8ae0b1fffb30adb6 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getActiveAction
});
module.exports["CONTENT_RIGHT_PADDING"] = $5371993c50b87836$export$c0cd7aea5be0e780;
module.exports["MIN_PANEL_WIDTH"] = $5371993c50b87836$export$9e0a6941e0e87c97;
module.exports["useObjectSidebarActions"] = $5371993c50b87836$export$332594c77a860a26;
module.exports["useObjectSidebarState"] = $5371993c50b87836$export$41c5dcc793387db5;
module.exports["useIsObjectSidebarShown"] = $5371993c50b87836$export$a572d51222d5ea45;
module.exports["usePanel"] = $5371993c50b87836$export$9168a42f32e3d071;
module.exports["useBehavior"] = $5371993c50b87836$export$8b43142d6fd506da;
module.exports["useIsPanelScrolled"] = $5371993c50b87836$export$ec8631e69ae8c803;
module.exports["usePanelWidth"] = $5371993c50b87836$export$82b270f291af5a5;
module.exports["useUpdatedHeaderComponentElements"] = $5371993c50b87836$export$bc4f8f2fe52e3d40;
module.exports["useSidebarControlState"] = $5371993c50b87836$export$d4d7180dad517777;
module.exports["useSidebarControlExpandCollapsedState"] = $5371993c50b87836$export$b00fb66a9723fc58;
module.exports["useActiveActionInPanel"] = $5371993c50b87836$export$8ae0b1fffb30adb6;

});

parcelRegister("lRhY3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $3Ap09 = parcelRequire("3Ap09");

const $bc35f8d5f81a3a68$var$noop = (props)=>{};
const $bc35f8d5f81a3a68$export$5f5debba1692bf40 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (!context) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                open: $bc35f8d5f81a3a68$var$noop,
                close: $bc35f8d5f81a3a68$var$noop,
                setPanelWidth: $bc35f8d5f81a3a68$var$noop
            };
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    let t0;
    if ($[1] !== context.close || $[2] !== context.open || $[3] !== context.setPanelWidth) {
        t0 = {
            open: context.open,
            close: context.close,
            setPanelWidth: context.setPanelWidth
        };
        $[1] = context.close;
        $[2] = context.open;
        $[3] = context.setPanelWidth;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : ()=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (!context) return {
        open: $bc35f8d5f81a3a68$var$noop,
        close: $bc35f8d5f81a3a68$var$noop,
        setPanelWidth: $bc35f8d5f81a3a68$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};
module.exports["usePreviewPanelsActions"] = $bc35f8d5f81a3a68$export$5f5debba1692bf40;

});

parcelRegister("3Ap09", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cha5E = parcelRequire("cha5E");


var $iDrrr = parcelRequire("iDrrr");


var $63gyv = parcelRequire("63gyv");


var $7ssWV = parcelRequire("7ssWV");

const $4db84584556d15be$var$noop = ()=>{};
const $4db84584556d15be$var$initialState = {
    // Configured when opening a panel.
    panel: null,
    onOpen: $4db84584556d15be$var$noop,
    onClose: $4db84584556d15be$var$noop
};
const $4db84584556d15be$export$f473d225913e225d = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $4db84584556d15be$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.panel && state?.onPreviewPanelClose?.(state.panel);
            return {
                ...state,
                panel: null,
                onOpen: $4db84584556d15be$var$noop,
                onClose: $4db84584556d15be$var$noop
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            /*
      	When opening a new preview panel, if the current panel is of the same type we don't
      	want to close the panel, but rather swap out the content. If the panel types don't match
      	we close the current panel and open the new one.
      	ex: A Goals panel is already open, and user tries to open a different Goals panel.
      	Parent Products must pass their preview panel close functions to the Preview Panel provider
      	via the `onPreviewPanelClose` prop.
      */ if (state.panel && !(0, $7ssWV.doPreviewPanelTypesMatch)(state.panel, params.panel)) // Close the active panel.
            state.onPreviewPanelClose?.(state.panel);
            state.panel && state.onClose();
            // Open the new panel.
            params.onOpen?.();
            state?.onPreviewPanelOpen?.(params.panel);
            return {
                ...state,
                panel: params.panel,
                onOpen: params.onOpen || $4db84584556d15be$var$initialState.onOpen,
                onClose: params.onClose || $4db84584556d15be$var$initialState.onClose
            };
        default:
            return state;
    }
};
const $4db84584556d15be$export$65ae37e9c61321f9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth } = t0;
    let t1;
    if ($[0] !== initialWidth) {
        t1 = (0, $cha5E.expVal)("nin_glance_panel", "isEnabled", false) ? {
            initialWidth: initialWidth
        } : undefined;
        $[0] = initialWidth;
        $[1] = t1;
    } else t1 = $[1];
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $63gyv.usePanelWidth)(t1);
    let t2;
    if ($[2] !== initialPanel) {
        t2 = initialPanel && (0, $iDrrr.fg)("preview_panel_initial_state") ? {
            panel: initialPanel
        } : {};
        $[2] = initialPanel;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== onPreviewPanelClose || $[5] !== onPreviewPanelOpen || $[6] !== t2) {
        t3 = {
            ...$4db84584556d15be$var$initialState,
            ...t2,
            onPreviewPanelOpen: onPreviewPanelOpen,
            onPreviewPanelClose: onPreviewPanelClose
        };
        $[4] = onPreviewPanelClose;
        $[5] = onPreviewPanelOpen;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    const [state, dispatch] = (0, $cozmU.useReducer)($4db84584556d15be$var$previewPanelsReducer, t3);
    let t4;
    if ($[8] !== onPanelWidthChanged || $[9] !== parentProduct || $[10] !== state) {
        t4 = (width)=>{
            onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
        };
        $[8] = onPanelWidthChanged;
        $[9] = parentProduct;
        $[10] = state;
        $[11] = t4;
    } else t4 = $[11];
    const setPanelWidth = t4;
    let t5;
    if ($[12] !== onPanelClosed) {
        t5 = (onClose)=>{
            dispatch?.({
                type: "CLOSE",
                onClose: onClose
            });
            onPanelClosed();
        };
        $[12] = onPanelClosed;
        $[13] = t5;
    } else t5 = $[13];
    const close = t5;
    let t6;
    if ($[14] !== onPanelOpened) {
        t6 = (params)=>{
            dispatch?.({
                type: "OPEN",
                params: params
            });
            onPanelOpened(params.width);
        };
        $[14] = onPanelOpened;
        $[15] = t6;
    } else t6 = $[15];
    const open = t6;
    let t7;
    if ($[16] !== close || $[17] !== open || $[18] !== panelWidth || $[19] !== setPanelWidth || $[20] !== state) {
        t7 = {
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        };
        $[16] = close;
        $[17] = open;
        $[18] = panelWidth;
        $[19] = setPanelWidth;
        $[20] = state;
        $[21] = t7;
    } else t7 = $[21];
    const context = t7;
    let t8;
    if ($[22] !== children || $[23] !== context) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4db84584556d15be$export$f473d225913e225d.Provider, {
            value: context
        }, children);
        $[22] = children;
        $[23] = context;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
} : ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth })=>{
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $63gyv.usePanelWidth)((0, $cha5E.expVal)('nin_glance_panel', 'isEnabled', false) ? {
        initialWidth: initialWidth
    } : undefined);
    const [state, dispatch] = (0, $cozmU.useReducer)($4db84584556d15be$var$previewPanelsReducer, {
        ...$4db84584556d15be$var$initialState,
        ...initialPanel && (0, $iDrrr.fg)('preview_panel_initial_state') ? {
            panel: initialPanel
        } : {},
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    });
    const setPanelWidth = (0, $cozmU.useCallback)((width)=>{
        onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
    }, [
        onPanelWidthChanged,
        parentProduct,
        state
    ]);
    const close = (0, $cozmU.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
        onPanelClosed();
    }, [
        dispatch,
        onPanelClosed
    ]);
    const open = (0, $cozmU.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
        onPanelOpened(params.width);
    }, [
        dispatch,
        onPanelOpened
    ]);
    const context = (0, $cozmU.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        }), [
        close,
        panelWidth,
        open,
        setPanelWidth,
        state
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4db84584556d15be$export$f473d225913e225d.Provider, {
        value: context
    }, children);
};
const $4db84584556d15be$export$609db4be92d0fad8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($4db84584556d15be$export$f473d225913e225d);
} : ()=>{
    return (0, $cozmU.useContext)($4db84584556d15be$export$f473d225913e225d);
};
module.exports["PreviewPanelsProvider"] = $4db84584556d15be$export$65ae37e9c61321f9;
module.exports["usePreviewPanelsContext"] = $4db84584556d15be$export$609db4be92d0fad8;

});

parcelRegister("63gyv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $55fM8 = parcelRequire("55fM8");


var $9DHhW = parcelRequire("9DHhW");


var $7y9ez = parcelRequire("7y9ez");

const $4ad8ebf5df3a3b12$export$82b270f291af5a5 = ({ initialWidth: initialWidth } = {})=>{
    const [defaultWidth, setDefaultWidth] = (0, $cozmU.useState)((0, $7y9ez.getDefaultPanelWidth));
    const [panelWidth, setPanelWidth] = (0, $cozmU.useState)(initialWidth ?? defaultWidth);
    const [manuallyResized, setManuallyResized] = (0, $cozmU.useState)(false);
    const [panelOpen, setPanelOpen] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onPanelWidthChanged = (0, $cozmU.useCallback)((newPanelWidth, panelProduct, panelType, parentProduct)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: panelProduct,
                source: 'preview-panel',
                action: 'resize',
                actionSubject: 'resizer',
                actionSubjectId: 'previewPanelResizer',
                attributes: {
                    initialPanelWidth: panelWidth,
                    newPanelWidth: newPanelWidth,
                    newWidthSmaller: newPanelWidth < panelWidth,
                    parentProduct: parentProduct,
                    panelType: panelType,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                }
            }
        }).fire();
        setPanelWidth(newPanelWidth);
        setManuallyResized(true);
    }, [
        createAnalyticsEvent,
        panelWidth
    ]);
    const onPanelOpened = (0, $cozmU.useCallback)((openWidth)=>{
        const width = openWidth ?? (manuallyResized ? panelWidth : defaultWidth);
        setPanelWidth(width);
        setPanelOpen(true);
    }, [
        defaultWidth,
        manuallyResized,
        panelWidth
    ]);
    const onPanelClosed = (0, $cozmU.useCallback)(()=>{
        setPanelOpen(false);
    }, []);
    // getDefaultPanelWidth does not dependencies related to this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const windowResizeListener = (0, $cozmU.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
        if (!panelOpen) {
            setDefaultWidth((0, $7y9ez.getDefaultPanelWidth)());
            setManuallyResized(false);
        }
    }, 500), [
        panelOpen
    ]);
    (0, $cozmU.useEffect)(()=>{
        const unbind = (0, $cbY7C.bind)(window, {
            type: 'resize',
            listener: windowResizeListener
        });
        return ()=>{
            unbind();
        };
    }, [
        windowResizeListener
    ]);
    return {
        panelWidth: panelWidth,
        onPanelWidthChanged: onPanelWidthChanged,
        onPanelOpened: onPanelOpened,
        onPanelClosed: onPanelClosed
    };
};
module.exports["usePanelWidth"] = $4ad8ebf5df3a3b12$export$82b270f291af5a5;

});

parcelRegister("7y9ez", function(module, exports) {
const $c1ed100d044a4357$var$PANEL_DEFAULT_WIDTH = 400;
const $c1ed100d044a4357$var$PANEL_MAX_WIDTH = 1000;
const $c1ed100d044a4357$var$MINIMUM_WIDTH = 1800;
const $c1ed100d044a4357$var$PANEL_TO_WINDOW_WITH_RATIO = 0.3;
const $c1ed100d044a4357$export$29ceecbfeef33bfc = ()=>{
    const windowWidth = window.innerWidth;
    let width = $c1ed100d044a4357$var$PANEL_DEFAULT_WIDTH;
    if (windowWidth >= $c1ed100d044a4357$var$MINIMUM_WIDTH) {
        const proposedPanelWidth = Math.round(windowWidth * $c1ed100d044a4357$var$PANEL_TO_WINDOW_WITH_RATIO);
        width = proposedPanelWidth < $c1ed100d044a4357$var$PANEL_MAX_WIDTH ? proposedPanelWidth : $c1ed100d044a4357$var$PANEL_MAX_WIDTH;
    }
    return width;
};
module.exports["getDefaultPanelWidth"] = $c1ed100d044a4357$export$29ceecbfeef33bfc;

});

parcelRegister("7ssWV", function(module, exports) {

var $7avaU = parcelRequire("7avaU");

const $2fea0aef81deca52$export$eb89e687f2b278d7 = (currPanel, nextPanel)=>{
    // if both panels have their types set, we will check if they match
    if (currPanel?.type && nextPanel?.type) return currPanel.type === nextPanel.type;
    // else check against both panels' ari values
    if (currPanel?.ari && nextPanel?.ari) try {
        const currAri = (0, $7avaU.AnyAri).parse(currPanel.ari);
        const nextAri = (0, $7avaU.AnyAri).parse(nextPanel.ari);
        // ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
        return `${currAri.resourceOwner}-${currAri.resourceType}` === `${nextAri.resourceOwner}-${nextAri.resourceType}`;
    } catch (error) {
        // If parsing fails, we assume the ARI values do not match.
        return false;
    }
    // If neither panel has a type or ari, we assume they do not match.
    return false;
};
module.exports["doPreviewPanelTypesMatch"] = $2fea0aef81deca52$export$eb89e687f2b278d7;

});

parcelRegister("jvYFk", function(module, exports) {
var $d9aaea339f75cad2$export$328a8baf694e5d32 = /*#__PURE__*/ function(PanelName) {
    PanelName["CommentsPanel"] = "commentsPanel";
    PanelName["DetailsPanel"] = "detailsPanel";
    PanelName["AgentReceiptPanel"] = "agentReceiptPanel";
    PanelName["WorkflowsPanel"] = "workflowsPanel";
    PanelName["SpaceSuggestionReviewPanel"] = "space-suggestion-review-panel";
    PanelName["SuggestionsPanel"] = "suggestionsPanel";
    return PanelName;
}({});
const $d9aaea339f75cad2$var$MIGRATED_PANEL_IDS = new Set([
    "commentsPanel",
    "detailsPanel",
    "agentReceiptPanel",
    "space-suggestion-review-panel",
    "suggestionsPanel",
    'jiraWorkItemsPanel'
]);
function $d9aaea339f75cad2$export$a9799883e6d611cc(panelId) {
    return !!panelId && $d9aaea339f75cad2$var$MIGRATED_PANEL_IDS.has(panelId);
}
module.exports["PanelName"] = $d9aaea339f75cad2$export$328a8baf694e5d32;
module.exports["isMigratedToPanelSystem"] = $d9aaea339f75cad2$export$a9799883e6d611cc;

});

parcelRegister("8aF6s", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $cozmU = parcelRequire("cozmU");


var $2BAFx = parcelRequire("2BAFx");

const $ff30daea9524db5f$var$onChildClose = (key, ...args)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        setState({
            stack: state.stack.map((frame)=>frame === childFrame ? {
                    ...frame,
                    alive: false
                } : frame)
        });
    };
const $ff30daea9524db5f$var$onChildCloseComplete = (key, ...args)=>({ getState: getState, setState: setState })=>{
        // A child dialog called its onCloseComplete prop
        const state = getState();
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        setState({
            stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
        });
    };
const $ff30daea9524db5f$var$actions = {
    showModal: (componentClass, originalProps, children)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const onClose = (...args)=>dispatch($ff30daea9524db5f$var$onChildClose(key, ...args));
            const onCloseComplete = (...args)=>dispatch($ff30daea9524db5f$var$onChildCloseComplete(key, ...args));
            const component = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(componentClass, {
                ...props,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, children);
            const state = getState();
            setState({
                stack: [
                    ...state.stack,
                    {
                        key: key,
                        component: component,
                        alive: true,
                        originalProps: {
                            onClose: props?.onClose,
                            onCloseComplete: props?.onCloseComplete
                        }
                    }
                ]
            });
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return onClose;
        }
};
const $ff30daea9524db5f$var$store = (0, $8s9DV.createStore)({
    initialState: {
        stack: []
    },
    actions: $ff30daea9524db5f$var$actions,
    name: 'DialogsStore'
});
/**
 * This is a work around to enforce the type requirement for the modal component.
 * For some reason the types don't resolve correctly in the bound actions
 */ const $ff30daea9524db5f$var$getTypedActions = (actions)=>{
    const showModal = (component, originalProps)=>{
        actions.showModal(component, originalProps);
    };
    return {
        showModal: showModal
    };
};
const $ff30daea9524db5f$var$useDialogActions = (0, $kBr4q.createActionsHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$f3af872d774d3d3f = ()=>{
    const actions = $ff30daea9524db5f$var$useDialogActions();
    return (0, $cozmU.useMemo)(()=>$ff30daea9524db5f$var$getTypedActions(actions), [
        actions
    ]);
};
const $ff30daea9524db5f$var$useDialogsStore = (0, $kBr4q.createHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$ecef86e74aed0d6b = ()=>{
    const [state, actions] = $ff30daea9524db5f$var$useDialogsStore();
    return (0, $cozmU.useMemo)(()=>({
            state: state,
            ...$ff30daea9524db5f$var$getTypedActions(actions)
        }), [
        actions,
        state
    ]);
};
module.exports["useDialogs"] = $ff30daea9524db5f$export$f3af872d774d3d3f;
module.exports["useDialogsState"] = $ff30daea9524db5f$export$ecef86e74aed0d6b;

});

parcelRegister("2BAFx", function(module, exports) {
class $d32907502a426d2e$var$DialogKeyState {
    get nextKey() {
        return this._nextKey++;
    }
    set nextKey(newKey) {
        if (newKey > this._nextKey) this._nextKey = newKey;
    }
    constructor(){
        this._nextKey = 0;
    }
}
const $d32907502a426d2e$export$2e170616461fb3b6 = new $d32907502a426d2e$var$DialogKeyState();
module.exports["dialogKeyState"] = $d32907502a426d2e$export$2e170616461fb3b6;

});

parcelRegister("g8bbY", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6ohxN = parcelRequire("6ohxN");


var $bGjLa = parcelRequire("bGjLa");

const $ed6d952ef1a68788$export$4153d6fbc2386422 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CommentEditor(props) {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6ohxN.CoreEditor), {
            ...props,
            appearance: "comment",
            AppearanceComponent: (0, $bGjLa.CommentEditorWithIntl)
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function CommentEditor(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6ohxN.CoreEditor), {
        ...props,
        appearance: "comment",
        AppearanceComponent: (0, $bGjLa.CommentEditorWithIntl)
    });
};
module.exports["CommentEditor"] = $ed6d952ef1a68788$export$4153d6fbc2386422;

});

parcelRegister("eRn3r", function(module, exports) {
$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("9aUDG")).lazyForPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("9aUDG")).lazy);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("3QYdZ")).LazySuspense);
parcelRequire("jxKH9");
var $3Pobi = parcelRequire("3Pobi");


var $5a3Es = parcelRequire("5a3Es");


var $9aUDG = parcelRequire("9aUDG");

parcelRequire("6VSrF");
var $86UVJ = parcelRequire("86UVJ");
var $dHqFW = parcelRequire("dHqFW");

parcelRequire("hZz7i");
var $3QYdZ = parcelRequire("3QYdZ");


var $itHHy = parcelRequire("itHHy");


var $bvYi1 = parcelRequire("bvYi1");


});

parcelRegister("jxKH9", function(module, exports) {
$parcel$export(module.exports, "MODE", () => (parcelRequire("3Pobi")).MODE);

var $3Pobi = parcelRequire("3Pobi");

const $e3a55206c71bac9e$var$DEFAULT_CROSS_ORIGIN = undefined;
const $e3a55206c71bac9e$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $e3a55206c71bac9e$var$DEFAULT_MODE = (0, $3Pobi.MODE).HYDRATE;
const $e3a55206c71bac9e$var$DEFAULT_RETRY = 2;
const $e3a55206c71bac9e$var$config = {
    crossOrigin: $e3a55206c71bac9e$var$DEFAULT_CROSS_ORIGIN,
    manifest: $e3a55206c71bac9e$var$DEFAULT_MANIFEST,
    mode: $e3a55206c71bac9e$var$DEFAULT_MODE,
    retry: $e3a55206c71bac9e$var$DEFAULT_RETRY
};
const $e3a55206c71bac9e$export$44487a86467333c3 = ()=>$e3a55206c71bac9e$var$config;
const $e3a55206c71bac9e$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $e3a55206c71bac9e$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $e3a55206c71bac9e$var$DEFAULT_CROSS_ORIGIN;
    $e3a55206c71bac9e$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $e3a55206c71bac9e$var$DEFAULT_MANIFEST;
    $e3a55206c71bac9e$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $e3a55206c71bac9e$var$DEFAULT_MODE;
    $e3a55206c71bac9e$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $e3a55206c71bac9e$var$DEFAULT_RETRY;
};
module.exports["getConfig"] = $e3a55206c71bac9e$export$44487a86467333c3;
module.exports["setConfig"] = $e3a55206c71bac9e$export$940a7873bb071df8;

});

parcelRegister("3Pobi", function(module, exports) {
const $2c98e46ce94c4b5d$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};
module.exports["MODE"] = $2c98e46ce94c4b5d$export$e48589d9e4824227;

});

parcelRegister("5a3Es", function(module, exports) {

var $eegtN = parcelRequire("eegtN");


var $jxKH9 = parcelRequire("jxKH9");

parcelRequire("itHHy");
var $ehkpF = parcelRequire("ehkpF");
var $8r5Wf = parcelRequire("8r5Wf");


var $hBrZE = parcelRequire("hBrZE");

const $3c20b80e9e8d3df3$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $jxKH9.setConfig)(config);
        (0, $ehkpF.LISTENERS).length = 0;
        (0, $8r5Wf.setCurrent)(0);
        if (!(0, $hBrZE.isNodeEnvironment)()) (0, $eegtN.collect)();
    }
};

});

parcelRegister("eegtN", function(module, exports) {

var $jxKH9 = parcelRequire("jxKH9");
var $3Pobi = parcelRequire("3Pobi");


var $gy5kI = parcelRequire("gy5kI");


var $4qzp5 = parcelRequire("4qzp5");


var $8WAU6 = parcelRequire("8WAU6");

const $a5bf27f95a5c4338$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $jxKH9.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $3Pobi.MODE).RENDER ? (0, $4qzp5.cloneElements)(markers[i], lazyBegin) : (0, $8WAU6.refElements)(markers[i], lazyBegin);
        if ((0, $gy5kI.COLLECTED).has(lazyBegin)) (0, $gy5kI.COLLECTED).get(lazyBegin).push(value);
        else (0, $gy5kI.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};
module.exports["collect"] = $a5bf27f95a5c4338$export$bb44f104e3c54dae;

});

parcelRegister("gy5kI", function(module, exports) {
const $c0c3f558a37c633a$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $c0c3f558a37c633a$export$4831ef3968ea94ef = new Map();
module.exports["PHASE"] = $c0c3f558a37c633a$export$2cc7a2eaaea7809f;
module.exports["COLLECTED"] = $c0c3f558a37c633a$export$4831ef3968ea94ef;

});

parcelRegister("4qzp5", function(module, exports) {
const $33950d892bd67505$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};
module.exports["cloneElements"] = $33950d892bd67505$export$c42217d53a7ebafb;

});

parcelRegister("8WAU6", function(module, exports) {
const $68305ddfb331b362$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};
module.exports["refElements"] = $68305ddfb331b362$export$c69443129766a7fc;

});

parcelRegister("itHHy", function(module, exports) {
$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("8r5Wf")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("8r5Wf")).setCurrent);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("ehkpF")).LISTENERS);

var $8r5Wf = parcelRequire("8r5Wf");


var $ehkpF = parcelRequire("ehkpF");


var $6h5l4 = parcelRequire("6h5l4");


});

parcelRegister("8r5Wf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gy5kI = parcelRequire("gy5kI");


var $ehkpF = parcelRequire("ehkpF");


var $6h5l4 = parcelRequire("6h5l4");

let $6245739e6eaab8ef$var$CURRENT_PHASE = (0, $gy5kI.PHASE).PAINT;
const $6245739e6eaab8ef$export$5f80f094fd31fffd = (phase)=>{
    $6245739e6eaab8ef$var$CURRENT_PHASE = phase;
    (0, $ehkpF.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $6245739e6eaab8ef$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $cozmU.createContext)({
    subscribe: (0, $6h5l4.createSubscribe)((0, $ehkpF.LISTENERS)),
    currentValue: ()=>$6245739e6eaab8ef$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $6245739e6eaab8ef$export$5f80f094fd31fffd((0, $gy5kI.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$6245739e6eaab8ef$export$5f80f094fd31fffd((0, $gy5kI.PHASE).PAINT)
    }
});
const $6245739e6eaab8ef$export$1dc361b277327f88 = ()=>{
    const v = (0, $cozmU.useContext)($6245739e6eaab8ef$export$5a25eca35e5debcb);
    return v.api;
};
module.exports["setCurrent"] = $6245739e6eaab8ef$export$5f80f094fd31fffd;
module.exports["LazyPhaseContext"] = $6245739e6eaab8ef$export$5a25eca35e5debcb;

});

parcelRegister("ehkpF", function(module, exports) {
const $a6527ccf54714552$export$81b9c458a026d68f = [];
module.exports["LISTENERS"] = $a6527ccf54714552$export$81b9c458a026d68f;

});

parcelRegister("6h5l4", function(module, exports) {
const $491878cc97587aa1$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };
module.exports["createSubscribe"] = $491878cc97587aa1$export$364097d812234b3f;

});

parcelRegister("hBrZE", function(module, exports) {
$parcel$export(module.exports, "hash", () => (parcelRequire("9fFjP")).default);

var $9fFjP = parcelRequire("9fFjP");

const $cd0b9b420a47cee1$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $cd0b9b420a47cee1$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $cd0b9b420a47cee1$export$283635c04a02cc36 = ()=>{
    if (typeof window === "undefined" || window.name === 'nodejs') return true;
    return globalThis !== globalThis.window;
};
function $cd0b9b420a47cee1$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}
module.exports["getExport"] = $cd0b9b420a47cee1$export$d4c07b1daf44a7f;
module.exports["displayNameFromId"] = $cd0b9b420a47cee1$export$4429f98ef60d2d87;
module.exports["isNodeEnvironment"] = $cd0b9b420a47cee1$export$283635c04a02cc36;
module.exports["attrToProp"] = $cd0b9b420a47cee1$export$62bf630d0de3d781;

});

parcelRegister("9fFjP", function(module, exports) {
$parcel$export(module.exports, "default", () => $6bc590d7746b5907$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $6bc590d7746b5907$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});

parcelRegister("9aUDG", function(module, exports) {

var $hXfAR = parcelRequire("hXfAR");


var $jxKH9 = parcelRequire("jxKH9");


var $gy5kI = parcelRequire("gy5kI");


var $hBrZE = parcelRequire("hBrZE");
var $9fFjP = parcelRequire("9fFjP");


var $aH9lN = parcelRequire("aH9lN");


var $ilEj6 = parcelRequire("ilEj6");


var $lJ3sU = parcelRequire("lJ3sU");


var $ajpr4 = parcelRequire("ajpr4");


var $67Nku = parcelRequire("67Nku");


var $edTIv = parcelRequire("edTIv");


var $17PxK = parcelRequire("17PxK");

function $6ae0fb8adbd87448$var$_extends() {
    $6ae0fb8adbd87448$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6ae0fb8adbd87448$var$_extends.apply(this, arguments);
}
function $6ae0fb8adbd87448$var$lazyProxy(_loader, { defer: defer = (0, $gy5kI.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $hBrZE.isNodeEnvironment)();
    const dataLazyId = (0, $9fFjP.default)(moduleId);
    const LazyInternal = isServer ? (0, $lJ3sU.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $ilEj6.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $ajpr4.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $jxKH9.getConfig)();
                return (0, $edTIv.retry)(_loader, {
                    delay: (0, $aH9lN.RETRY_DELAY),
                    factor: (0, $aH9lN.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $hBrZE.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $jxKH9.getConfig)();
        return (0, $hXfAR.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $gy5kI.PHASE).PAINT ? (0, $aH9lN.PRIORITY).HIGH : (0, $aH9lN.PRIORITY).LOW;
        return (0, $67Nku.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $6ae0fb8adbd87448$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $gy5kI.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $gy5kI.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $gy5kI.PHASE).LAZY
    }
};
function $6ae0fb8adbd87448$export$c952e5f94576010e(loader, opts) {
    return $6ae0fb8adbd87448$var$lazyProxy(loader, $6ae0fb8adbd87448$var$_extends({}, $6ae0fb8adbd87448$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $6ae0fb8adbd87448$export$291dd592399bdafa(loader, opts) {
    return $6ae0fb8adbd87448$var$lazyProxy(loader, $6ae0fb8adbd87448$var$_extends({}, $6ae0fb8adbd87448$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $6ae0fb8adbd87448$export$488013bae63b21da(loader, opts) {
    return $6ae0fb8adbd87448$var$lazyProxy(loader, $6ae0fb8adbd87448$var$_extends({}, $6ae0fb8adbd87448$export$93ca5d3f8675ae4c.lazy, opts || {}));
}
module.exports["lazyForPaint"] = $6ae0fb8adbd87448$export$c952e5f94576010e;
module.exports["lazy"] = $6ae0fb8adbd87448$export$488013bae63b21da;

});

parcelRegister("hXfAR", function(module, exports) {
const $d1240ae4295f4288$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};
module.exports["getAssetUrlsFromId"] = $d1240ae4295f4288$export$303f43e55cf1ef2f;

});

parcelRegister("aH9lN", function(module, exports) {
const $7c952c608ad2380e$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $7c952c608ad2380e$export$a339266ad71b2447 = 300;
const $7c952c608ad2380e$export$ba64c908e55507fe = 1;
module.exports["PRIORITY"] = $7c952c608ad2380e$export$bb34f3538ba26c7e;
module.exports["RETRY_DELAY"] = $7c952c608ad2380e$export$a339266ad71b2447;
module.exports["RETRY_FACTOR"] = $7c952c608ad2380e$export$ba64c908e55507fe;

});

parcelRegister("ilEj6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jxKH9 = parcelRequire("jxKH9");
var $3Pobi = parcelRequire("3Pobi");


var $gy5kI = parcelRequire("gy5kI");

parcelRequire("6VSrF");
var $dHqFW = parcelRequire("dHqFW");

parcelRequire("itHHy");
var $8r5Wf = parcelRequire("8r5Wf");

parcelRequire("hZz7i");
var $aZNtm = parcelRequire("aZNtm");


var $aH9lN = parcelRequire("aH9lN");


var $17PxK = parcelRequire("17PxK");


var $6adGO = parcelRequire("6adGO");


var $jl5l1 = parcelRequire("jl5l1");


var $67Nku = parcelRequire("67Nku");


var $bvYi1 = parcelRequire("bvYi1");


var $aiyJe = parcelRequire("aiyJe");

function $d5b97455f4530d40$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const { requestIdleCallback: requestIdleCallback = setTimeout } = window;
    const ResolvedLazy = /*#__PURE__*/ (0, $cozmU.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $cozmU.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $gy5kI.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $gy5kI.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $cozmU.useContext)((0, $bvYi1.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $17PxK.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        // Subscribe to LazyWait context, triggering load when until is true
        (0, $aiyJe.useSubscription)({
            context: (0, $dHqFW.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $gy5kI.PHASE).AFTER_PAINT) {
            // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $aiyJe.useSubscription)({
                context: (0, $8r5Wf.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
            // Schedule preloading as will be needed soon
            (0, $cozmU.useMemo)(()=>{
                if (!status.preloaded) {
                    status.preloaded = true;
                    requestIdleCallback(()=>{
                        if (status.started) return;
                        (0, $67Nku.preloadAsset)({
                            loader: deferred.preload,
                            moduleId: moduleId,
                            priority: (0, $aH9lN.PRIORITY).LOW
                        });
                    });
                }
            }, [
                status
            ]);
        }
        const { setFallback: setFallback } = (0, $cozmU.useContext)((0, $aZNtm.LazySuspenseContext));
        (0, $cozmU.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $gy5kI.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $jxKH9.getConfig)().mode === (0, $3Pobi.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6adGO.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jl5l1.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ResolvedLazy, props);
    };
}
module.exports["createComponentClient"] = $d5b97455f4530d40$export$6898b5504b58699a;

});

parcelRegister("6VSrF", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => (parcelRequire("dHqFW")).WaitContext);

var $dHqFW = parcelRequire("dHqFW");


var $86UVJ = parcelRequire("86UVJ");


});

parcelRegister("dHqFW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $eYtLL = parcelRequire("eYtLL");

const $9f93fbb489094a52$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $cozmU.createContext)({
    subscribe: ()=>(0, $eYtLL.noopCleanup),
    currentValue: ()=>1
});
module.exports["WaitContext"] = $9f93fbb489094a52$export$9ba3fe09d15de47b;

});

parcelRegister("eYtLL", function(module, exports) {
const $ae6dc2e0431b9395$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};
module.exports["noopCleanup"] = $ae6dc2e0431b9395$export$276c7dbda7675aec;

});

parcelRegister("86UVJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dHqFW = parcelRequire("dHqFW");

const $5e7b0b64cd38d641$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $cozmU.useContext)((0, $dHqFW.WaitContext));
    const value = (0, $cozmU.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $cozmU.useRef)(new Set());
    const api = (0, $cozmU.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $cozmU.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dHqFW.WaitContext).Provider, {
        value: api.current
    }, children);
};

});

parcelRegister("hZz7i", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("3QYdZ")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("aZNtm")).LazySuspenseContext);

var $3QYdZ = parcelRequire("3QYdZ");


var $aZNtm = parcelRequire("aZNtm");


});

parcelRegister("3QYdZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hBrZE = parcelRequire("hBrZE");


var $aZNtm = parcelRequire("aZNtm");

class $2ce4f1cfa8b44b57$export$256c542058532d6f extends (0, $cozmU.Component) {
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this;
        // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZNtm.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZNtm.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $hBrZE.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback;
                // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            }
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $cozmU.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
}
module.exports["LazySuspense"] = $2ce4f1cfa8b44b57$export$256c542058532d6f;

});

parcelRegister("aZNtm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $8015fa1bd12f3c41$export$c33990e84065970c = /*#__PURE__*/ (0, $cozmU.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});
module.exports["LazySuspenseContext"] = $8015fa1bd12f3c41$export$c33990e84065970c;

});

parcelRegister("17PxK", function(module, exports) {
const $0d1e6d5848f254be$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $0d1e6d5848f254be$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$0d1e6d5848f254be$export$6aa69c1258005366]: true
    });
    return error;
};
const $0d1e6d5848f254be$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($0d1e6d5848f254be$export$6aa69c1258005366);
module.exports["createLoaderError"] = $0d1e6d5848f254be$export$c73a6a6f0bf7d425;

});

parcelRegister("6adGO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $47ce4bb11269d032$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $47ce4bb11269d032$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $cozmU.useRef)(null);
    const { current: ssrDomNodes } = (0, $cozmU.useRef)(content || []);
    (0, $cozmU.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($47ce4bb11269d032$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $47ce4bb11269d032$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $47ce4bb11269d032$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};
module.exports["PlaceholderFallbackRender"] = $47ce4bb11269d032$export$d55db778a3e1446b;

});

parcelRegister("jl5l1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hBrZE = parcelRequire("hBrZE");

function $e1441e868bb78192$var$_extends() {
    $e1441e868bb78192$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e1441e868bb78192$var$_extends.apply(this, arguments);
}
const $e1441e868bb78192$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $hBrZE.attrToProp), {
            key: String(i)
        });
        // text node
        if (!tagName) return /*#__PURE__*/ (0, $cozmU.createElement)((0, $cozmU.Fragment), props, el.textContent);
        // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $cozmU.createElement)(tagName.toLowerCase(), props);
        // tag with content
        return /*#__PURE__*/ (0, $cozmU.createElement)(tagName.toLowerCase(), $e1441e868bb78192$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};
module.exports["PlaceholderFallbackHydrate"] = $e1441e868bb78192$export$ca5b8fbc835d95e4;

});

parcelRegister("67Nku", function(module, exports) {

var $hXfAR = parcelRequire("hXfAR");


var $eYtLL = parcelRequire("eYtLL");


var $jxKH9 = parcelRequire("jxKH9");


var $hBrZE = parcelRequire("hBrZE");


var $aH9lN = parcelRequire("aH9lN");


var $2mjKV = parcelRequire("2mjKV");


var $bvYi1 = parcelRequire("bvYi1");

function $4759a958e17e309b$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $jxKH9.getConfig)();
    const assets = (0, $hXfAR.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $2mjKV.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $4759a958e17e309b$var$fakePromise = {
    then: ()=>$4759a958e17e309b$var$fakePromise,
    catch: ()=>$4759a958e17e309b$var$fakePromise,
    finally: ()=>$4759a958e17e309b$var$fakePromise
};
function $4759a958e17e309b$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $2mjKV.insertLinkTag)(href, rel));
        return $4759a958e17e309b$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $4759a958e17e309b$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $eYtLL.noopCleanup;
}
function $4759a958e17e309b$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $hBrZE.isNodeEnvironment)()) return 0, $eYtLL.noopCleanup;
    (_GlobalReactLooselyLa = (0, $bvYi1.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $aH9lN.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $4759a958e17e309b$export$3af04dbcb01bad4d,
        $4759a958e17e309b$export$1046fd6a49d5e7a,
        $4759a958e17e309b$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $eYtLL.noopCleanup;
}
module.exports["preloadAsset"] = $4759a958e17e309b$export$25bad4aa00c45355;

});

parcelRegister("2mjKV", function(module, exports) {

var $bvYi1 = parcelRequire("bvYi1");


var $eYtLL = parcelRequire("eYtLL");


var $jxKH9 = parcelRequire("jxKH9");

function $1b7cf5f1f73f5f76$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $eYtLL.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $jxKH9.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $bvYi1.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}
module.exports["insertLinkTag"] = $1b7cf5f1f73f5f76$export$6610512821c8a4ce;

});

parcelRegister("bvYi1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $86215b3df1759e88$export$e2d53c0cbedd2710 = {
    current: null
};
const $86215b3df1759e88$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $cozmU.createContext)($86215b3df1759e88$export$e2d53c0cbedd2710);
module.exports["GlobalReactLooselyLazyProfiler"] = $86215b3df1759e88$export$e2d53c0cbedd2710;
module.exports["ProfilerContext"] = $86215b3df1759e88$export$8146ab57a3f7a7cb;

});

parcelRegister("aiyJe", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $77f6862aa953f5ea$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $cozmU.useContext)(context);
    (0, $cozmU.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useSubscription"] = $77f6862aa953f5ea$export$368b4214baeb914c;

});

parcelRegister("lJ3sU", function(module, exports) {

var $hXfAR = parcelRequire("hXfAR");


var $cozmU = parcelRequire("cozmU");


var $jxKH9 = parcelRequire("jxKH9");


var $gy5kI = parcelRequire("gy5kI");

parcelRequire("hZz7i");
var $aZNtm = parcelRequire("aZNtm");


var $hBrZE = parcelRequire("hBrZE");


var $17PxK = parcelRequire("17PxK");

function $fd107d191750b962$var$load(moduleId, loader) {
    try {
        return (0, $hBrZE.getExport)(loader());
    } catch (err) {
        throw (0, $17PxK.createLoaderError)(err);
    }
}
function $fd107d191750b962$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $fd107d191750b962$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $cozmU.useContext)((0, $aZNtm.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $jxKH9.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $gy5kI.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $hXfAR.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("link", {
                key: url,
                rel: defer === (0, $gy5kI.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}
module.exports["createComponentServer"] = $fd107d191750b962$export$eb2e4b04351cdd9e;

});

parcelRegister("ajpr4", function(module, exports) {
const $781f68b739b0ef47$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};
module.exports["createDeferred"] = $781f68b739b0ef47$export$e673efccd97e4223;

});

parcelRegister("edTIv", function(module, exports) {
const $a5ad7fc44a458961$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $a5ad7fc44a458961$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $a5ad7fc44a458961$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $a5ad7fc44a458961$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $a5ad7fc44a458961$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $a5ad7fc44a458961$var$calculateDelay(context, policy);
        if (delay) await $a5ad7fc44a458961$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}
module.exports["retry"] = $a5ad7fc44a458961$export$9369b12211e1fce4;

});

parcelRegister("koEBx", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6ohxN = parcelRequire("6ohxN");


var $eJlpI = parcelRequire("eJlpI");

const $6173d76fe85d4dd6$export$5252bd745392dcde = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ChromelessEditor(props) {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6ohxN.CoreEditor), {
            ...props,
            appearance: "chromeless",
            AppearanceComponent: (0, $eJlpI.default)
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function ChromelessEditor(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6ohxN.CoreEditor), {
        ...props,
        appearance: "chromeless",
        AppearanceComponent: (0, $eJlpI.default)
    });
};
module.exports["ChromelessEditor"] = $6173d76fe85d4dd6$export$5252bd745392dcde;

});

parcelRegister("9EemN", function(module, exports) {
/*global define:false */ /**
 * Copyright 2012-2017 Craig Campbell
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Mousetrap is a simple keyboard shortcut library for Javascript with
 * no external dependencies
 *
 * @version 1.6.5
 * @url craig.is/killing/mice
 */ (function(window1, document1, undefined) {
    // Check if mousetrap is used inside browser, if not, return
    if (!window1) return;
    /**
     * mapping of special keycodes to their corresponding keys
     *
     * everything in this dictionary cannot use keypress events
     * so it has to be here to map to the correct keycodes for
     * keyup/keydown events
     *
     * @type {Object}
     */ var _MAP = {
        8: 'backspace',
        9: 'tab',
        13: 'enter',
        16: 'shift',
        17: 'ctrl',
        18: 'alt',
        20: 'capslock',
        27: 'esc',
        32: 'space',
        33: 'pageup',
        34: 'pagedown',
        35: 'end',
        36: 'home',
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down',
        45: 'ins',
        46: 'del',
        91: 'meta',
        93: 'meta',
        224: 'meta'
    };
    /**
     * mapping for special characters so they can support
     *
     * this dictionary is only used incase you want to bind a
     * keyup or keydown event to one of these keys
     *
     * @type {Object}
     */ var _KEYCODE_MAP = {
        106: '*',
        107: '+',
        109: '-',
        110: '.',
        111: '/',
        186: ';',
        187: '=',
        188: ',',
        189: '-',
        190: '.',
        191: '/',
        192: '`',
        219: '[',
        220: '\\',
        221: ']',
        222: '\''
    };
    /**
     * this is a mapping of keys that require shift on a US keypad
     * back to the non shift equivelents
     *
     * this is so you can use keyup events with these keys
     *
     * note that this will only work reliably on US keyboards
     *
     * @type {Object}
     */ var _SHIFT_MAP = {
        '~': '`',
        '!': '1',
        '@': '2',
        '#': '3',
        '$': '4',
        '%': '5',
        '^': '6',
        '&': '7',
        '*': '8',
        '(': '9',
        ')': '0',
        '_': '-',
        '+': '=',
        ':': ';',
        '\"': '\'',
        '<': ',',
        '>': '.',
        '?': '/',
        '|': '\\'
    };
    /**
     * this is a list of special strings you can use to map
     * to modifier keys when you specify your keyboard shortcuts
     *
     * @type {Object}
     */ var _SPECIAL_ALIASES = {
        'option': 'alt',
        'command': 'meta',
        'return': 'enter',
        'escape': 'esc',
        'plus': '+',
        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
    };
    /**
     * variable to store the flipped version of _MAP from above
     * needed to check if we should use keypress or not when no action
     * is specified
     *
     * @type {Object|undefined}
     */ var _REVERSE_MAP;
    /**
     * loop through the f keys, f1 to f19 and add them to the map
     * programatically
     */ for(var i = 1; i < 20; ++i)_MAP[111 + i] = 'f' + i;
    /**
     * loop through to map numbers on the numeric keypad
     */ for(i = 0; i <= 9; ++i)// This needs to use a string cause otherwise since 0 is falsey
    // mousetrap will never fire for numpad 0 pressed as part of a keydown
    // event.
    //
    // @see https://github.com/ccampbell/mousetrap/pull/258
    _MAP[i + 96] = i.toString();
    /**
     * cross browser add event method
     *
     * @param {Element|HTMLDocument} object
     * @param {string} type
     * @param {Function} callback
     * @returns void
     */ function _addEvent(object, type, callback) {
        if (object.addEventListener) {
            object.addEventListener(type, callback, false);
            return;
        }
        object.attachEvent('on' + type, callback);
    }
    /**
     * takes the event and returns the key character
     *
     * @param {Event} e
     * @return {string}
     */ function _characterFromEvent(e) {
        // for keypress events we should return the character as is
        if (e.type == 'keypress') {
            var character = String.fromCharCode(e.which);
            // if the shift key is not pressed then it is safe to assume
            // that we want the character to be lowercase.  this means if
            // you accidentally have caps lock on then your key bindings
            // will continue to work
            //
            // the only side effect that might not be desired is if you
            // bind something like 'A' cause you want to trigger an
            // event when capital A is pressed caps lock will no longer
            // trigger the event.  shift+a will though.
            if (!e.shiftKey) character = character.toLowerCase();
            return character;
        }
        // for non keypress events the special maps are needed
        if (_MAP[e.which]) return _MAP[e.which];
        if (_KEYCODE_MAP[e.which]) return _KEYCODE_MAP[e.which];
        // if it is not in the special map
        // with keydown and keyup events the character seems to always
        // come in as an uppercase character whether you are pressing shift
        // or not.  we should make sure it is always lowercase for comparisons
        return String.fromCharCode(e.which).toLowerCase();
    }
    /**
     * checks if two arrays are equal
     *
     * @param {Array} modifiers1
     * @param {Array} modifiers2
     * @returns {boolean}
     */ function _modifiersMatch(modifiers1, modifiers2) {
        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
    }
    /**
     * takes a key event and figures out what the modifiers are
     *
     * @param {Event} e
     * @returns {Array}
     */ function _eventModifiers(e) {
        var modifiers = [];
        if (e.shiftKey) modifiers.push('shift');
        if (e.altKey) modifiers.push('alt');
        if (e.ctrlKey) modifiers.push('ctrl');
        if (e.metaKey) modifiers.push('meta');
        return modifiers;
    }
    /**
     * prevents default for this event
     *
     * @param {Event} e
     * @returns void
     */ function _preventDefault(e) {
        if (e.preventDefault) {
            e.preventDefault();
            return;
        }
        e.returnValue = false;
    }
    /**
     * stops propogation for this event
     *
     * @param {Event} e
     * @returns void
     */ function _stopPropagation(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
            return;
        }
        e.cancelBubble = true;
    }
    /**
     * determines if the keycode specified is a modifier key or not
     *
     * @param {string} key
     * @returns {boolean}
     */ function _isModifier(key) {
        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
    }
    /**
     * reverses the map lookup so that we can look for specific keys
     * to see what can and can't use keypress
     *
     * @return {Object}
     */ function _getReverseMap() {
        if (!_REVERSE_MAP) {
            _REVERSE_MAP = {};
            for(var key in _MAP){
                // pull out the numeric keypad from here cause keypress should
                // be able to detect the keys from the character
                if (key > 95 && key < 112) continue;
                if (_MAP.hasOwnProperty(key)) _REVERSE_MAP[_MAP[key]] = key;
            }
        }
        return _REVERSE_MAP;
    }
    /**
     * picks the best action based on the key combination
     *
     * @param {string} key - character for key
     * @param {Array} modifiers
     * @param {string=} action passed in
     */ function _pickBestAction(key, modifiers, action) {
        // if no action was picked in we should try to pick the one
        // that we think would work best for this key
        if (!action) action = _getReverseMap()[key] ? 'keydown' : 'keypress';
        // modifier keys don't work as expected with keypress,
        // switch to keydown
        if (action == 'keypress' && modifiers.length) action = 'keydown';
        return action;
    }
    /**
     * Converts from a string key combination to an array
     *
     * @param  {string} combination like "command+shift+l"
     * @return {Array}
     */ function _keysFromString(combination) {
        if (combination === '+') return [
            '+'
        ];
        combination = combination.replace(/\+{2}/g, '+plus');
        return combination.split('+');
    }
    /**
     * Gets info for a specific key combination
     *
     * @param  {string} combination key combination ("command+s" or "a" or "*")
     * @param  {string=} action
     * @returns {Object}
     */ function _getKeyInfo(combination, action) {
        var keys;
        var key;
        var i;
        var modifiers = [];
        // take the keys from this pattern and figure out what the actual
        // pattern is all about
        keys = _keysFromString(combination);
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            // normalize key names
            if (_SPECIAL_ALIASES[key]) key = _SPECIAL_ALIASES[key];
            // if this is not a keypress event then we should
            // be smart about using shift keys
            // this will only work for US keyboards however
            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
                key = _SHIFT_MAP[key];
                modifiers.push('shift');
            }
            // if this key is a modifier then add it to the list of modifiers
            if (_isModifier(key)) modifiers.push(key);
        }
        // depending on what the key combination is
        // we will try to pick the best event for it
        action = _pickBestAction(key, modifiers, action);
        return {
            key: key,
            modifiers: modifiers,
            action: action
        };
    }
    function _belongsTo(element, ancestor) {
        if (element === null || element === document1) return false;
        if (element === ancestor) return true;
        return _belongsTo(element.parentNode, ancestor);
    }
    function Mousetrap(targetElement) {
        var self = this;
        targetElement = targetElement || document1;
        if (!(self instanceof Mousetrap)) return new Mousetrap(targetElement);
        /**
         * element to attach key events to
         *
         * @type {Element}
         */ self.target = targetElement;
        /**
         * a list of all the callbacks setup via Mousetrap.bind()
         *
         * @type {Object}
         */ self._callbacks = {};
        /**
         * direct map of string combinations to callbacks used for trigger()
         *
         * @type {Object}
         */ self._directMap = {};
        /**
         * keeps track of what level each sequence is at since multiple
         * sequences can start out with the same sequence
         *
         * @type {Object}
         */ var _sequenceLevels = {};
        /**
         * variable to store the setTimeout call
         *
         * @type {null|number}
         */ var _resetTimer;
        /**
         * temporary state where we will ignore the next keyup
         *
         * @type {boolean|string}
         */ var _ignoreNextKeyup = false;
        /**
         * temporary state where we will ignore the next keypress
         *
         * @type {boolean}
         */ var _ignoreNextKeypress = false;
        /**
         * are we currently inside of a sequence?
         * type of action ("keyup" or "keydown" or "keypress") or false
         *
         * @type {boolean|string}
         */ var _nextExpectedAction = false;
        /**
         * resets all sequence counters except for the ones passed in
         *
         * @param {Object} doNotReset
         * @returns void
         */ function _resetSequences(doNotReset) {
            doNotReset = doNotReset || {};
            var activeSequences = false, key;
            for(key in _sequenceLevels){
                if (doNotReset[key]) {
                    activeSequences = true;
                    continue;
                }
                _sequenceLevels[key] = 0;
            }
            if (!activeSequences) _nextExpectedAction = false;
        }
        /**
         * finds all callbacks that match based on the keycode, modifiers,
         * and action
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event|Object} e
         * @param {string=} sequenceName - name of the sequence we are looking for
         * @param {string=} combination
         * @param {number=} level
         * @returns {Array}
         */ function _getMatches(character, modifiers, e, sequenceName, combination, level) {
            var i;
            var callback;
            var matches = [];
            var action = e.type;
            // if there are no events related to this keycode
            if (!self._callbacks[character]) return [];
            // if a modifier key is coming up on its own we should allow it
            if (action == 'keyup' && _isModifier(character)) modifiers = [
                character
            ];
            // loop through all callbacks for the key that was pressed
            // and see if any of them match
            for(i = 0; i < self._callbacks[character].length; ++i){
                callback = self._callbacks[character][i];
                // if a sequence name is not specified, but this is a sequence at
                // the wrong level then move onto the next match
                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) continue;
                // if the action we are looking for doesn't match the action we got
                // then we should keep going
                if (action != callback.action) continue;
                // if this is a keypress event and the meta key and control key
                // are not pressed that means that we need to only look at the
                // character, otherwise check the modifiers as well
                //
                // chrome will not fire a keypress if meta or control is down
                // safari will fire a keypress if meta or meta+shift is down
                // firefox will fire a keypress if meta or control is down
                if (action == 'keypress' && !e.metaKey && !e.ctrlKey || _modifiersMatch(modifiers, callback.modifiers)) {
                    // when you bind a combination or sequence a second time it
                    // should overwrite the first one.  if a sequenceName or
                    // combination is specified in this call it does just that
                    //
                    // @todo make deleting its own method?
                    var deleteCombo = !sequenceName && callback.combo == combination;
                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
                    if (deleteCombo || deleteSequence) self._callbacks[character].splice(i, 1);
                    matches.push(callback);
                }
            }
            return matches;
        }
        /**
         * actually calls the callback function
         *
         * if your callback function returns false this will use the jquery
         * convention - prevent default and stop propogation on the event
         *
         * @param {Function} callback
         * @param {Event} e
         * @returns void
         */ function _fireCallback(callback, e, combo, sequence) {
            // if this event should not happen stop here
            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) return;
            if (callback(e, combo) === false) {
                _preventDefault(e);
                _stopPropagation(e);
            }
        }
        /**
         * handles a character key event
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event} e
         * @returns void
         */ self._handleKey = function(character, modifiers, e) {
            var callbacks = _getMatches(character, modifiers, e);
            var i;
            var doNotReset = {};
            var maxLevel = 0;
            var processedSequenceCallback = false;
            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
            for(i = 0; i < callbacks.length; ++i)if (callbacks[i].seq) maxLevel = Math.max(maxLevel, callbacks[i].level);
            // loop through matching callbacks for this key event
            for(i = 0; i < callbacks.length; ++i){
                // fire for all sequence callbacks
                // this is because if for example you have multiple sequences
                // bound such as "g i" and "g t" they both need to fire the
                // callback for matching g cause otherwise you can only ever
                // match the first one
                if (callbacks[i].seq) {
                    // only fire callbacks for the maxLevel to prevent
                    // subsequences from also firing
                    //
                    // for example 'a option b' should not cause 'option b' to fire
                    // even though 'option b' is part of the other sequence
                    //
                    // any sequences that do not match here will be discarded
                    // below by the _resetSequences call
                    if (callbacks[i].level != maxLevel) continue;
                    processedSequenceCallback = true;
                    // keep a list of which sequences were matches for later
                    doNotReset[callbacks[i].seq] = 1;
                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
                    continue;
                }
                // if there were no sequence matches but we are still here
                // that means this is a regular match so we should fire that
                if (!processedSequenceCallback) _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
            }
            // if the key you pressed matches the type of sequence without
            // being a modifier (ie "keyup" or "keypress") then we should
            // reset all sequences that were not matched by this event
            //
            // this is so, for example, if you have the sequence "h a t" and you
            // type "h e a r t" it does not match.  in this case the "e" will
            // cause the sequence to reset
            //
            // modifier keys are ignored because you can have a sequence
            // that contains modifiers such as "enter ctrl+space" and in most
            // cases the modifier key will be pressed before the next key
            //
            // also if you have a sequence such as "ctrl+b a" then pressing the
            // "b" key will trigger a "keypress" and a "keydown"
            //
            // the "keydown" is expected when there is a modifier, but the
            // "keypress" ends up matching the _nextExpectedAction since it occurs
            // after and that causes the sequence to reset
            //
            // we ignore keypresses in a sequence that directly follow a keydown
            // for the same character
            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) _resetSequences(doNotReset);
            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
        };
        /**
         * handles a keydown event
         *
         * @param {Event} e
         * @returns void
         */ function _handleKeyEvent(e) {
            // normalize e.which for key events
            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
            if (typeof e.which !== 'number') e.which = e.keyCode;
            var character = _characterFromEvent(e);
            // no character found then stop
            if (!character) return;
            // need to use === for the character check because the character can be 0
            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
                _ignoreNextKeyup = false;
                return;
            }
            self.handleKey(character, _eventModifiers(e), e);
        }
        /**
         * called to set a 1 second timeout on the specified sequence
         *
         * this is so after each key press in the sequence you have 1 second
         * to press the next key before you have to start over
         *
         * @returns void
         */ function _resetSequenceTimer() {
            clearTimeout(_resetTimer);
            _resetTimer = setTimeout(_resetSequences, 1000);
        }
        /**
         * binds a key sequence to an event
         *
         * @param {string} combo - combo specified in bind call
         * @param {Array} keys
         * @param {Function} callback
         * @param {string=} action
         * @returns void
         */ function _bindSequence(combo, keys, callback, action) {
            // start off by adding a sequence level record for this combination
            // and setting the level to 0
            _sequenceLevels[combo] = 0;
            /**
             * callback to increase the sequence level for this sequence and reset
             * all other sequences that were active
             *
             * @param {string} nextAction
             * @returns {Function}
             */ function _increaseSequence(nextAction) {
                return function() {
                    _nextExpectedAction = nextAction;
                    ++_sequenceLevels[combo];
                    _resetSequenceTimer();
                };
            }
            /**
             * wraps the specified callback inside of another function in order
             * to reset all sequence counters as soon as this sequence is done
             *
             * @param {Event} e
             * @returns void
             */ function _callbackAndReset(e) {
                _fireCallback(callback, e, combo);
                // we should ignore the next key up if the action is key down
                // or keypress.  this is so if you finish a sequence and
                // release the key the final key will not trigger a keyup
                if (action !== 'keyup') _ignoreNextKeyup = _characterFromEvent(e);
                // weird race condition if a sequence ends with the key
                // another sequence begins with
                setTimeout(_resetSequences, 10);
            }
            // loop through keys one at a time and bind the appropriate callback
            // function.  for any key leading up to the final one it should
            // increase the sequence. after the final, it should reset all sequences
            //
            // if an action is specified in the original bind call then that will
            // be used throughout.  otherwise we will pass the action that the
            // next key in the sequence should match.  this allows a sequence
            // to mix and match keypress and keydown events depending on which
            // ones are better suited to the key provided
            for(var i = 0; i < keys.length; ++i){
                var isFinal = i + 1 === keys.length;
                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
                _bindSingle(keys[i], wrappedCallback, action, combo, i);
            }
        }
        /**
         * binds a single keyboard combination
         *
         * @param {string} combination
         * @param {Function} callback
         * @param {string=} action
         * @param {string=} sequenceName - name of sequence if part of sequence
         * @param {number=} level - what part of the sequence the command is
         * @returns void
         */ function _bindSingle(combination, callback, action, sequenceName, level) {
            // store a direct mapped reference for use with Mousetrap.trigger
            self._directMap[combination + ':' + action] = callback;
            // make sure multiple spaces in a row become a single space
            combination = combination.replace(/\s+/g, ' ');
            var sequence = combination.split(' ');
            var info;
            // if this pattern is a sequence of keys then run through this method
            // to reprocess each pattern one key at a time
            if (sequence.length > 1) {
                _bindSequence(combination, sequence, callback, action);
                return;
            }
            info = _getKeyInfo(combination, action);
            // make sure to initialize array if this is the first time
            // a callback is added for this key
            self._callbacks[info.key] = self._callbacks[info.key] || [];
            // remove an existing match if there is one
            _getMatches(info.key, info.modifiers, {
                type: info.action
            }, sequenceName, combination, level);
            // add this call back to the array
            // if it is a sequence put it at the beginning
            // if not put it at the end
            //
            // this is important because the way these are processed expects
            // the sequence ones to come first
            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
                callback: callback,
                modifiers: info.modifiers,
                action: info.action,
                seq: sequenceName,
                level: level,
                combo: combination
            });
        }
        /**
         * binds multiple combinations to the same callback
         *
         * @param {Array} combinations
         * @param {Function} callback
         * @param {string|undefined} action
         * @returns void
         */ self._bindMultiple = function(combinations, callback, action) {
            for(var i = 0; i < combinations.length; ++i)_bindSingle(combinations[i], callback, action);
        };
        // start!
        _addEvent(targetElement, 'keypress', _handleKeyEvent);
        _addEvent(targetElement, 'keydown', _handleKeyEvent);
        _addEvent(targetElement, 'keyup', _handleKeyEvent);
    }
    /**
     * binds an event to mousetrap
     *
     * can be a single key, a combination of keys separated with +,
     * an array of keys, or a sequence of keys separated by spaces
     *
     * be sure to list the modifier keys first to make sure that the
     * correct key ends up getting bound (the last key in the pattern)
     *
     * @param {string|Array} keys
     * @param {Function} callback
     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
     * @returns void
     */ Mousetrap.prototype.bind = function(keys, callback, action) {
        var self = this;
        keys = keys instanceof Array ? keys : [
            keys
        ];
        self._bindMultiple.call(self, keys, callback, action);
        return self;
    };
    /**
     * unbinds an event to mousetrap
     *
     * the unbinding sets the callback function of the specified key combo
     * to an empty function and deletes the corresponding key in the
     * _directMap dict.
     *
     * TODO: actually remove this from the _callbacks dictionary instead
     * of binding an empty function
     *
     * the keycombo+action has to be exactly the same as
     * it was defined in the bind method
     *
     * @param {string|Array} keys
     * @param {string} action
     * @returns void
     */ Mousetrap.prototype.unbind = function(keys, action) {
        var self = this;
        return self.bind.call(self, keys, function() {}, action);
    };
    /**
     * triggers an event that has already been bound
     *
     * @param {string} keys
     * @param {string=} action
     * @returns void
     */ Mousetrap.prototype.trigger = function(keys, action) {
        var self = this;
        if (self._directMap[keys + ':' + action]) self._directMap[keys + ':' + action]({}, keys);
        return self;
    };
    /**
     * resets the library back to its initial state.  this is useful
     * if you want to clear out the current keyboard shortcuts and bind
     * new ones - for example if you switch to another page
     *
     * @returns void
     */ Mousetrap.prototype.reset = function() {
        var self = this;
        self._callbacks = {};
        self._directMap = {};
        return self;
    };
    /**
     * should we stop this event before firing off callbacks
     *
     * @param {Event} e
     * @param {Element} element
     * @return {boolean}
     */ Mousetrap.prototype.stopCallback = function(e, element) {
        var self = this;
        // if the element has the class "mousetrap" then no need to stop
        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) return false;
        if (_belongsTo(element, self.target)) return false;
        // Events originating from a shadow DOM are re-targetted and `e.target` is the shadow host,
        // not the initial event target in the shadow tree. Note that not all events cross the
        // shadow boundary.
        // For shadow trees with `mode: 'open'`, the initial event target is the first element in
        // the event’s composed path. For shadow trees with `mode: 'closed'`, the initial event
        // target cannot be obtained.
        if ('composedPath' in e && typeof e.composedPath === 'function') {
            // For open shadow trees, update `element` so that the following check works.
            var initialEventTarget = e.composedPath()[0];
            if (initialEventTarget !== e.target) element = initialEventTarget;
        }
        // stop for input, select, and textarea
        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
    };
    /**
     * exposes _handleKey publicly so it can be overwritten by extensions
     */ Mousetrap.prototype.handleKey = function() {
        var self = this;
        return self._handleKey.apply(self, arguments);
    };
    /**
     * allow custom key mappings
     */ Mousetrap.addKeycodes = function(object) {
        for(var key in object)if (object.hasOwnProperty(key)) _MAP[key] = object[key];
        _REVERSE_MAP = null;
    };
    /**
     * Init the global mousetrap functions
     *
     * This method is needed to allow the global mousetrap functions to work
     * now that mousetrap is a constructor function.
     */ Mousetrap.init = function() {
        var documentMousetrap = Mousetrap(document1);
        for(var method in documentMousetrap)if (method.charAt(0) !== '_') Mousetrap[method] = function(method) {
            return function() {
                return documentMousetrap[method].apply(documentMousetrap, arguments);
            };
        }(method);
    };
    Mousetrap.init();
    // expose mousetrap to the global object
    window1.Mousetrap = Mousetrap;
    // expose as a common js module
    if (module.exports) module.exports = Mousetrap;
    // expose mousetrap as an AMD module
    if (typeof define === 'function' && define.amd) define(function() {
        return Mousetrap;
    });
})(typeof window !== 'undefined' ? window : null, typeof window !== 'undefined' ? document : null);

});

parcelRegister("7rOWN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2sp5n = parcelRequire("2sp5n");


var $iDrrr = parcelRequire("iDrrr");


var $anBbz = parcelRequire("anBbz");


var $eVG6Y = parcelRequire("eVG6Y");


var $dWoVg = parcelRequire("dWoVg");


var $iwIwp = parcelRequire("iwIwp");


var $99TtX = parcelRequire("99TtX");


var $1NFwk = parcelRequire("1NFwk");


var $9F0bu = parcelRequire("9F0bu");


var $85cI7 = parcelRequire("85cI7");


var $7tMWI = parcelRequire("7tMWI");


var $8iBLq = parcelRequire("8iBLq");


var $aaqIB = parcelRequire("aaqIB");

/**
 * IDs of the MAUI-specific experiences (the AI "Remix"/malleable diagram flow).
 *
 * These are gated on the `cc-maui-experiment` experiment rather than the
 * product-specific non-MAUI rollout gates, so that a rollback of
 * `cc-maui-experiment` disables the MAUI experiences without affecting generic
 * native embeds (Pages, Databases, Slides, non-MAUI Whiteboards).
 *
 * `MauiWhiteboardExperienceManifest` only matches whiteboard URLs with
 * `isRemixDiagram=true` (i.e. diagrams created via the MAUI flow). When it is
 * disabled, such URLs fall through to the generic `WhiteboardExperienceManifest`
 * (which matches the same whiteboard path without the `isRemixDiagram` param), so
 * the board still renders as a plain native-embed whiteboard.
 */ const $ab76b84281e6545b$var$mauiExperienceIds = new Set([
    (0, $9F0bu.MAUI_EXPERIENCE_MANIFEST_ID),
    (0, $85cI7.MAUI_WHITEBOARD_EXPERIENCE_MANIFEST_ID)
]);
const $ab76b84281e6545b$var$allExperiences = [
    (0, $eVG6Y.ArtifactsExperienceManifest),
    (0, $dWoVg.AvpvizExperienceManifest),
    (0, $1NFwk.DBEntryExperienceManifest),
    (0, $99TtX.DBExperienceManifest),
    (0, $9F0bu.MauiExperienceManifest),
    (0, $7tMWI.PageExperienceManifest),
    (0, $8iBLq.SlideExperienceManifest),
    // MauiWhiteboardExperienceManifest must come before WhiteboardExperienceManifest
    // so its more specific isUrlMatch (requiring isRemixDiagram=true) is checked first.
    (0, $85cI7.MauiWhiteboardExperienceManifest),
    (0, $aaqIB.WhiteboardExperienceManifest)
];
const $ab76b84281e6545b$var$gatedExperiences = $ab76b84281e6545b$var$allExperiences.map((experience)=>({
        ...experience,
        isUrlMatch: (url)=>{
            if ($ab76b84281e6545b$var$mauiExperienceIds.has(experience.id)) return (0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) && experience.isUrlMatch(url);
            // Feature-flag names must remain static literals for static feature-flag tooling.
            return ((0, $iDrrr.fg)('platform_native_embeds_rollout_non_maui_experience') || (0, $iDrrr.fg)('platform_native_embeds_rollout_jira_non_maui')) && experience.isUrlMatch(url);
        }
    }));
// Register all experience manifests at module-load time.
// This is intentionally module-level (not inside a React lifecycle) because the
// facade must be available before any child embed loads.
(0, $iwIwp.getNativeEmbedFacade)().setup({
    experiences: $ab76b84281e6545b$var$gatedExperiences
});

const $ab76b84281e6545b$var$createRenderFn = (isPublishedPage, api, renderOverlay, analyticsPageContext)=>async ()=>{
        const { default: Ui } = await (parcelRequire("4vjt0"));
        return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Ui, {
                ...props,
                api: api,
                isPublishedPage: isPublishedPage,
                renderOverlay: renderOverlay,
                analyticsPageContext: analyticsPageContext
            });
    };
const $ab76b84281e6545b$export$622e7486b3a76ca4 = (isPublishedPage, api, cardClient, renderOverlay, analyticsPageContext)=>{
    // Wire up the CardClient for short-link URL resolution when provided.
    // This is a separate call from setup() because the CardClient may not be
    // available at module-load time when setup() is called.
    if (cardClient) (0, $iwIwp.getNativeEmbedFacade)().setCardClient(cardClient);
    return {
        title: 'Native Embed',
        type: (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE),
        key: (0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY),
        description: 'Embed native Atlassian content',
        modules: {
            nodes: {
                default: {
                    type: 'extension',
                    render: $ab76b84281e6545b$var$createRenderFn(isPublishedPage, api, renderOverlay, analyticsPageContext),
                    // @ts-expect-error This option is experimental and not reflected in the manifest type definition
                    __hideFrame: true
                },
                ...Object.fromEntries((0, $iwIwp.getNativeEmbedFacade)().getAllExperienceIds().map((experienceId)=>[
                        experienceId,
                        {
                            type: 'extension',
                            render: $ab76b84281e6545b$var$createRenderFn(isPublishedPage, api, renderOverlay, analyticsPageContext),
                            __hideFrame: true
                        }
                    ]))
            }
        }
    };
};
module.exports["createManifest"] = $ab76b84281e6545b$export$622e7486b3a76ca4;

});

parcelRegister("eVG6Y", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $jxqsh = parcelRequire("jxqsh");


var $k9wGn = parcelRequire("k9wGn");


var $ljOiP = parcelRequire("ljOiP");


var $iDrrr = parcelRequire("iDrrr");


var $hjJUc = parcelRequire("hjJUc");


var $1xINT = parcelRequire("1xINT");


var $iPlb2 = parcelRequire("iPlb2");


var $f67nD = parcelRequire("f67nD");

const $df8c795159f25904$var$artifactsIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($jxqsh)))
];
const $df8c795159f25904$var$UUID = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}'; /**
                                                                                             * Claims Artifacts app URLs in either of two forms:
                                                                                             *
                                                                                             *   `<host>/artifacts/<artifactId>/*`
                                                                                             *   `<host>/apps/<installationId>/<artifactId>/*?smartlink=artifact`
                                                                                             *
                                                                                             * Only the path and query components participate in matching. The URL origin
                                                                                             * and fragment are intentionally ignored.
                                                                                             */ 
const $df8c795159f25904$var$ARTIFACT_URL_PATTERNS = [
    new RegExp(`/artifacts/${$df8c795159f25904$var$UUID}(?:[/?#].*)?$`),
    new RegExp(`/apps/${$df8c795159f25904$var$UUID}/${$df8c795159f25904$var$UUID}/[^?#]*\\?(?:[^#]*&)?smartlink=artifact`)
];
const $df8c795159f25904$var$isArtifactsUrl = (url)=>// Gated behind the Forge UI artifact Confluence integration flag: the Artifacts
    // experience only claims URLs when the flag is enabled.
    (0, $iDrrr.fg)('platform_forge_ui_artifact_confluence_integration') && $df8c795159f25904$var$ARTIFACT_URL_PATTERNS.some((pattern)=>pattern.test(url)); /**
                                                                                                                      * Experience manifest for an Artifacts embed.
                                                                                                                      * Registered via `getNativeEmbedFacade().setup({ experiences: [...] })` in
                                                                                                                      * `@atlassian/native-embeds-editor-extension`.
                                                                                                                      */ 
const $df8c795159f25904$export$d40f5b752a00056c = {
    id: (0, $f67nD.ARTIFACTS_EXPERIENCE_MANIFEST_ID),
    handleChildCommands: (_experience, _cmd)=>{},
    isUrlMatch: $df8c795159f25904$var$isArtifactsUrl,
    isActive: ()=>true,
    // Route through the Smart Card / linking-platform resolver so the embed renders
    // via `<Card appearance="embed">` (EmbedFrameWrapper uses `useBasicIframe: false`).
    // Requires the Object Resolver Service to resolve Artifacts share URLs and return a
    // `preview`. Set to `false` to render a basic iframe directly from `transformUrl`.
    resolveViaLinkingPlatform: true,
    supportedFeatures: new Set([
        ...(0, $iPlb2.allNativeEmbedCoreFeatures)
    ]),
    transformUrl: (url, isFullScreen)=>{
        const urlObj = new URL(url);
        if (!isFullScreen) urlObj.searchParams.set('hideBorder', 'true');
         // Identifies the native embed view to the Artifacts app.
        urlObj.searchParams.set('nativeEmbedView', 'true');
        const initialTheme = (0, $1xINT.getInitialThemeParam)();
        if (initialTheme) urlObj.searchParams.set('themeState', initialTheme);
        return urlObj.toString();
    },
    uiConfig: {
        // Header edit button intentionally disabled for now. Re-add an `editButton`
        // entry here (using `swapArtifactsRoute`) to restore the inline edit flow.
        headerControls: {},
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                items: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT
                ],
                moreItems: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
                ]
            }),
        editorToolbarHandlers: {},
        renderLoadingComponent: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
                animationDisabled: props.animationDisabled,
                icons: $df8c795159f25904$var$artifactsIcons,
                testId: props.testId
            }),
        titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jxqsh))),
        // Use the linking-platform-resolved icon (the artifact's own icon) in the
        // header, falling back to ShapesIcon until it resolves.
        useResolvedTitleIcon: true,
        appearance: 'overlay',
        waitForContentReady: false
    }
};
module.exports["ArtifactsExperienceManifest"] = $df8c795159f25904$export$d40f5b752a00056c;

});

parcelRegister("hjJUc", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d31de4816ebba09$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $bJ0qH = parcelRequire("bJ0qH");


var $39SCI = parcelRequire("39SCI");

function $3d31de4816ebba09$export$2e2bcd8739ae039(props) {
    if (props.variant === 'simple-bar') {
        const { variant: _variant, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39SCI.default), rest);
    }
    const { variant: _variant, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bJ0qH.default), rest);
}

});

parcelRegister("bJ0qH", function(module, exports) {
$parcel$export(module.exports, "default", () => $5675a156d46f0f78$export$2e2bcd8739ae039);
/* icon-carousel-variant.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $b5sDq = parcelRequire("b5sDq");


var $h5uPL = parcelRequire("h5uPL");


var $jxqsh = parcelRequire("jxqsh");


var $bDjVc = parcelRequire("bDjVc");


var $g3Ghj = parcelRequire("g3Ghj");


var $bUupk = parcelRequire("bUupk");


var $7lIlR = parcelRequire("7lIlR");


var $cr8hb = parcelRequire("cr8hb");

const $5675a156d46f0f78$var$containerStyles = null;
const $5675a156d46f0f78$var$innerStyles = null;
const $5675a156d46f0f78$var$progressBarWrapperStyles = null;
const $5675a156d46f0f78$var$defaultIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b5sDq))),
    (0, (/*@__PURE__*/$parcel$interopDefault($jxqsh))),
    (0, (/*@__PURE__*/$parcel$interopDefault($h5uPL)))
];
function $5675a156d46f0f78$export$2e2bcd8739ae039({ animationDisabled: animationDisabled = false, icons: icons, testId: testId }) {
    const progress = (0, $cr8hb.useFakeProgress)(animationDisabled);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_49OCfRdnbC _1mT5xdWVPG _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0KLXrunmFW"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2mHwu8kG2W _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $7lIlR.default), {
        animationDisabled: animationDisabled,
        icons: icons ?? $5675a156d46f0f78$var$defaultIcons,
        testId: testId ? `${testId}--${0, $g3Ghj.SLIDE_MORPH_TEST_ID_SUFFIX}` : undefined,
        cycleDirection: "right"
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_39xV02lyjw"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $bUupk.default), {
        ariaLabel: "Loading",
        testId: testId ? `${testId}--${0, $g3Ghj.PROGRESS_BAR_TEST_ID_SUFFIX}` : undefined,
        value: progress
    }))));
}

});

parcelRegister("b5sDq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7c17957e788935e20cad1a731882f109>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81265fa4dab37321$var$_react = $81265fa4dab37321$var$_interopRequireDefault((parcelRequire("cozmU")));

var $81265fa4dab37321$var$_iconNew = $81265fa4dab37321$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $81265fa4dab37321$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DiagramSymbolMindMap".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/diagram-symbol-mind-map
 * Usage guidance:
 * Reserved for mind map diagram symbol.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $81265fa4dab37321$var$DiagramSymbolMindMapIcon = (props)=>/*#__PURE__*/ $81265fa4dab37321$var$_react.default.createElement($81265fa4dab37321$var$_iconNew.default, Object.assign({
        name: "DiagramSymbolMindMapIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12 13.5h2.5v-2H12zM1.5 9H4V7H1.5zM12 4.5h2.5v-2H12zm4 .125C16 5.385 15.384 6 14.625 6h-2.75c-.76 0-1.375-.616-1.375-1.375V4.25h-1a.5.5 0 0 0-.5.5v6.5a.5.5 0 0 0 .5.5h1v-.375c0-.76.616-1.375 1.375-1.375h2.75c.76 0 1.375.616 1.375 1.375v2.25c0 .76-.616 1.375-1.375 1.375h-2.75c-.76 0-1.375-.616-1.375-1.375v-.375h-1a2 2 0 0 1-2-2v-2.5h-2v.375c0 .76-.616 1.375-1.375 1.375h-2.75C.615 10.5 0 9.884 0 9.125v-2.25C0 6.115.616 5.5 1.375 5.5h2.75c.76 0 1.375.616 1.375 1.375v.375h2v-2.5a2 2 0 0 1 2-2h1v-.375c0-.76.616-1.375 1.375-1.375h2.75l.14.007c.694.07 1.235.656 1.235 1.368z"/>`
    }, props));
$81265fa4dab37321$var$DiagramSymbolMindMapIcon.displayName = 'DiagramSymbolMindMapIcon';
var $81265fa4dab37321$var$_default = module.exports.default = $81265fa4dab37321$var$DiagramSymbolMindMapIcon;

});

parcelRegister("h5uPL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::85bf979e8232abe8de3866571ef3fc76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c70ad24a32d9055c$var$_react = $c70ad24a32d9055c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c70ad24a32d9055c$var$_iconNew = $c70ad24a32d9055c$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $c70ad24a32d9055c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sticker".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/sticker
 * Usage guidance:
 * Used for sticker tool in Whiteboards
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c70ad24a32d9055c$var$StickerIcon = (props)=>/*#__PURE__*/ $c70ad24a32d9055c$var$_react.default.createElement($c70ad24a32d9055c$var$_iconNew.default, Object.assign({
        name: "StickerIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-1.998 12.687L6 14c0-1.102.223-2.153.627-3.11a8 8 0 0 1 7.56-4.888A6.5 6.5 0 0 0 8 1.5m5.413 6.026a6.5 6.5 0 0 0-5.404 3.947 6.5 6.5 0 0 0-.483 1.94zM0 8a8 8 0 0 1 15.899-1.277.75.75 0 0 1-.21.65l-8.317 8.315a.75.75 0 0 1-.649.21A8 8 0 0 1 0 8" clip-rule="evenodd"/>`
    }, props));
$c70ad24a32d9055c$var$StickerIcon.displayName = 'StickerIcon';
var $c70ad24a32d9055c$var$_default = module.exports.default = $c70ad24a32d9055c$var$StickerIcon;

});

parcelRegister("g3Ghj", function(module, exports) {
const $f9469b1871c63b69$export$422c871edd75db5 = 'progress-bar';
const $f9469b1871c63b69$export$eb09afb535a4cb18 = 'slide-morph';
const $f9469b1871c63b69$export$7442c4c7574447bc = 50;
module.exports["PROGRESS_BAR_TEST_ID_SUFFIX"] = $f9469b1871c63b69$export$422c871edd75db5;
module.exports["SLIDE_MORPH_TEST_ID_SUFFIX"] = $f9469b1871c63b69$export$eb09afb535a4cb18;
module.exports["STATIC_PROGRESS_VALUE"] = $f9469b1871c63b69$export$7442c4c7574447bc;

});

parcelRegister("bUupk", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9ce3cf2ba109470$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $e9ce3cf2ba109470$var$MIN_VALUE = 0;
const $e9ce3cf2ba109470$var$MAX_VALUE = 100;
const $e9ce3cf2ba109470$var$containerStyles = null;
const $e9ce3cf2ba109470$var$barStyles = null; /**
                         * This is a progress bar component that was built to match the atlaskit component `@atlaskit/progress-bar`.
                         * We couldn't use the atlaskit component due to the colour requirements for this progress bar not being supported,
                         * hence, a custom component was required.
                         */ 
function $e9ce3cf2ba109470$export$2e2bcd8739ae039({ ariaLabel: ariaLabel, testId: testId, value: value = 0 }) {
    const valueParsed = Math.max($e9ce3cf2ba109470$var$MIN_VALUE, Math.min(value, $e9ce3cf2ba109470$var$MAX_VALUE));
    return /*#__PURE__*/ $cozmU.createElement("div", {
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": $e9ce3cf2ba109470$var$MIN_VALUE,
        "aria-valuenow": valueParsed,
        "aria-valuemax": $e9ce3cf2ba109470$var$MAX_VALUE,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_0bjKvDS5Zs _4bt5LAnQyn _2WAcuGnQyn _39xV02N91d _0jFU0VZimw _1mT5xdRAKS _0KLXruDMqu"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("span", {
        style: {
            width: `${valueParsed}%`
        },
        "data-testid": `${testId}--progress-value-bar`,
        className: (0, $hekY6.default)([
            "_0bjKvDS5Zs _23rrnHUdC3 _3iDTPbvLZJ _0jFU0VZimw _1mT5xdWVPG _0KLXruXljP"
        ])
    }));
}

});

parcelRegister("7lIlR", function(module, exports) {
$parcel$export(module.exports, "default", () => $948620dedd13543d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $9NPFC = parcelRequire("9NPFC");


var $kVbnn = parcelRequire("kVbnn");


var $fEVaZ = parcelRequire("fEVaZ");

// so we override the background via a wrapper targeting the tile's root <span>.
const $948620dedd13543d$var$tileWrapperStyles = null;
function $948620dedd13543d$export$2e2bcd8739ae039({ animationDisabled: animationDisabled = false, icons: icons, testId: testId, cycleDirection: cycleDirection = 'right' }) {
    const iconsWithProps = icons.map((Icon)=>(props)=>/*#__PURE__*/ $cozmU.createElement(Icon, {
                color: "var(--ds-icon-subtle, #505258)",
                ...props
            }));
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_0FoN3I7Cj1"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $9NPFC.default), {
        label: "",
        backgroundColor: "color.background.neutral",
        hasBorder: true,
        size: "xlarge",
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement((0, $fEVaZ.default), {
        animationDisabled: animationDisabled,
        icons: iconsWithProps,
        cycleDirection: cycleDirection,
        testId: testId ? `${testId}--${0, $kVbnn.ICON_CYCLER_TEST_ID_SUFFIX}` : undefined
    })));
}

});

parcelRegister("kVbnn", function(module, exports) {
const $b041427678c4fb7b$export$a87bbf852b8799e2 = 'icon-cycler';
module.exports["ICON_CYCLER_TEST_ID_SUFFIX"] = $b041427678c4fb7b$export$a87bbf852b8799e2;

});

parcelRegister("fEVaZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $fded74c4bd3b5f47$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $fded74c4bd3b5f47$var$ICON_CYCLE_DELAY_MS = 900;
const $fded74c4bd3b5f47$var$ICON_CYCLE_TRANSITION_MS = 400;
const $fded74c4bd3b5f47$var$ICON_CYCLE_EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';
const $fded74c4bd3b5f47$var$enteringAnimations = {
    left: "_1mT5xdRAKS _1gBibyJfTW",
    right: "_1mT5xdRAKS _1gBibyn5Jh"
};
const $fded74c4bd3b5f47$var$exitingAnimations = {
    left: "_1mT5xdWVPG _1gBibyGowt",
    right: "_1mT5xdWVPG _1gBiby958d"
};
const $fded74c4bd3b5f47$var$commonAnimationStyles = null;
const $fded74c4bd3b5f47$var$containerStyles = null;
const $fded74c4bd3b5f47$var$iconSlotStyles = null; /**
                              * Cycles through a list of icon components with a vertical slide transition.
                              *
                              * Each icon is shown for ICON_CYCLE_DELAY_MS, then the current icon slides
                              * out upward while the next icon slides in from below over ICON_CYCLE_TRANSITION_MS.
                              */ 
function $fded74c4bd3b5f47$export$2e2bcd8739ae039({ animationDisabled: animationDisabled = false, icons: icons, cycleDirection: cycleDirection = 'left', testId: testId }) {
    const [currentIndex, setCurrentIndex] = (0, $cozmU.useState)(0);
    const [isTransitioning, setIsTransitioning] = (0, $cozmU.useState)(false);
    const timerRef = (0, $cozmU.useRef)(null);
    const nextIndex = (currentIndex + 1) % icons.length;
    const scheduleNextTransition = (0, $cozmU.useCallback)(()=>{
        timerRef.current = setTimeout(()=>{
            setIsTransitioning(true);
        }, $fded74c4bd3b5f47$var$ICON_CYCLE_DELAY_MS);
    }, []);
    const handleAnimationEnd = (0, $cozmU.useCallback)(()=>{
        setIsTransitioning(false);
        setCurrentIndex((prev)=>(prev + 1) % icons.length);
    }, [
        icons.length
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (animationDisabled || icons.length <= 1) return;
        if (!isTransitioning) scheduleNextTransition();
        return ()=>{
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, [
        animationDisabled,
        icons.length,
        isTransitioning,
        scheduleNextTransition
    ]);
    if (icons.length === 0) return null;
    const CurrentIcon = icons[currentIndex];
    const NextIcon = icons[nextIndex];
    if (animationDisabled || icons.length === 1 || !isTransitioning) return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
        ])
    }, /*#__PURE__*/ $cozmU.createElement(CurrentIcon, {
        label: ""
    })));
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
            "_0nFVCGpFbM _43vdfTBhmJ _3Y6bKpgRhm",
            $fded74c4bd3b5f47$var$exitingAnimations[cycleDirection]
        ])
    }, /*#__PURE__*/ $cozmU.createElement(CurrentIcon, {
        label: ""
    })), /*#__PURE__*/ $cozmU.createElement("div", {
        onAnimationEnd: handleAnimationEnd,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
            "_0nFVCGpFbM _43vdfTBhmJ _3Y6bKpgRhm",
            $fded74c4bd3b5f47$var$enteringAnimations[cycleDirection]
        ])
    }, /*#__PURE__*/ $cozmU.createElement(NextIcon, {
        label: ""
    })));
}

});

parcelRegister("cr8hb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $g3Ghj = parcelRequire("g3Ghj");

function $e3f0b09e8c39256e$export$966e81c93dd9c110(animationDisabled) {
    const [progress, setProgress] = (0, $cozmU.useState)(animationDisabled ? (0, $g3Ghj.STATIC_PROGRESS_VALUE) : 0);
    (0, $cozmU.useEffect)(()=>{
        if (animationDisabled) return;
        const interval = setInterval(()=>{
            setProgress((prev)=>{
                if (prev < 10) return prev + 10;
                if (prev < 60) return prev + 35;
                if (prev < 90) return prev + 10;
                return prev;
            });
        }, 1000);
        return ()=>clearInterval(interval);
    }, [
        animationDisabled
    ]);
    return progress;
}
module.exports["useFakeProgress"] = $e3f0b09e8c39256e$export$966e81c93dd9c110;

});

parcelRegister("39SCI", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f0a885121af4f63$export$2e2bcd8739ae039);
/* simple-bar-variant.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $g3Ghj = parcelRequire("g3Ghj");


var $bUupk = parcelRequire("bUupk");


var $cr8hb = parcelRequire("cr8hb");

const $4f0a885121af4f63$var$messages = (0, $kSwu1.defineMessages)({
    loadingLabel: {
        id: "native-embeds-core.common.loading-overlay.simple-bar-variant.loadingLabel",
        defaultMessage: "Loading"
    }
});
const $4f0a885121af4f63$var$containerStyles = null;
const $4f0a885121af4f63$var$blanketStyles = null;
const $4f0a885121af4f63$var$progressBarWrapperStyles = null;
function $4f0a885121af4f63$export$2e2bcd8739ae039({ animationDisabled: animationDisabled = false, showBlanket: showBlanket = false, testId: testId }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const progress = (0, $cr8hb.useFakeProgress)(animationDisabled);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_49OCfRdnbC _1mT5xdWVPG _3iDTPbQ4SZ _0hPCNLz9WS _37wbyuDIqT _0xmtko8HPE _0KLXrunmFW _42Yu6B7dHp"
        ])
    }, showBlanket && /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_49OCfRdnbC _1mT5xdWVPG _0KLXruA5lS"
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_39xV02wOVE _1mT5xdRAKS _42Yu6B7dHp"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $bUupk.default), {
        ariaLabel: formatMessage($4f0a885121af4f63$var$messages.loadingLabel),
        testId: testId ? `${testId}--${0, $g3Ghj.PROGRESS_BAR_TEST_ID_SUFFIX}` : undefined,
        value: progress
    })));
}

});

parcelRegister("1xINT", function(module, exports) {

var $gqUuL = parcelRequire("gqUuL");


var $fcaWu = parcelRequire("fcaWu");

const $d5e4138f0844ba8b$export$6f4b285026a87b72 = ()=>{
    const theme = (0, $gqUuL.getGlobalTheme)();
    if (Object.keys(theme).length === 0) return undefined;
    return (0, $fcaWu.themeObjectToString)(theme);
};
module.exports["getInitialThemeParam"] = $d5e4138f0844ba8b$export$6f4b285026a87b72;

});

parcelRegister("iPlb2", function(module, exports) {
/**
 * Core features that are supported by all native embeds.
 *
 * All native embed must either support the feature or respond in
 * the feature handshake that its not supported.
 */ const $9ebc30870bad8c95$export$189dc4df3d8f1369 = {
    /** When agreed, the parent sends selected-change events to the child when the embed's selection state changes. */ SelectedChange: 'selected-change',
    /** When agreed, the parent sends view-mode-change events to the child when the embed switches between regular and maximize (e.g. full screen). */ ViewModeChange: 'view-mode-change',
    /** When agreed, the parent sends header-visibility-change events to the child when the host native embed controls/chrome visibility changes. */ HeaderVisibilityChange: 'header-visibility-change',
    /** When agreed, the child captures click events and notifies the host via the bridge. */ NotifyHostClick: 'notify-host-click',
    /** When agreed, the child can request the host to toggle the full-screen dialog. */ ToggleFullScreen: 'toggle-full-screen',
    /**
	 * When agreed, the child can request the host to resize the embed container. */ RequestResize: 'request-resize',
    /**
	 * When agreed, the host sends `on-full-screen-changed` events to the child whenever
	 * the inline full-screen preview opens or closes WITHOUT remounting the iframe.
	 *
	 * This handshake is only ever negotiated when the host runs the shared-iframe
	 * code path (i.e. `Element.prototype.moveBefore` is supported). On any other
	 * host path the embed is torn down and re-created across the full-screen
	 * toggle, so a child has no need for this event.
	 */ NoRefreshFullScreenPreview: 'no-refresh-full-screen-preview',
    /**
	 * When agreed, the child sends a `content-ready` event to the host once its
	 * content is fully rendered and visible to the user. The host holds its own
	 * loading overlay visible until this event fires (or a safety timeout elapses),
	 * preventing a flash of the child's internal loading state between the iframe
	 * `load` event and the child's first painted frame.
	 *
	 * Only negotiated for embed types that set `waitForContentReady: true` in their
	 * `uiConfig`.
	 */ ContentReady: 'content-ready'
};
const $9ebc30870bad8c95$export$75135a796fe6e3e2 = Object.values($9ebc30870bad8c95$export$189dc4df3d8f1369);
module.exports["NativeEmbedCoreFeature"] = $9ebc30870bad8c95$export$189dc4df3d8f1369;
module.exports["allNativeEmbedCoreFeatures"] = $9ebc30870bad8c95$export$75135a796fe6e3e2;

});

parcelRegister("f67nD", function(module, exports) {

var $8fPlA = parcelRequire("8fPlA");

const $abb3595e1b1957dc$export$9721a12c6baf7e39 = (0, $8fPlA.experienceManifestId)('artifacts');
module.exports["ARTIFACTS_EXPERIENCE_MANIFEST_ID"] = $abb3595e1b1957dc$export$9721a12c6baf7e39;

});

parcelRegister("8fPlA", function(module, exports) {
const $63ee794f4378af50$export$32c943c51c185af3 = (s)=>s;
module.exports["experienceManifestId"] = $63ee794f4378af50$export$32c943c51c185af3;

});

parcelRegister("dWoVg", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $gJ798 = parcelRequire("gJ798");


var $k9wGn = parcelRequire("k9wGn");


var $ljOiP = parcelRequire("ljOiP");


var $iDrrr = parcelRequire("iDrrr");


var $hjJUc = parcelRequire("hjJUc");


var $1xINT = parcelRequire("1xINT");


var $iPlb2 = parcelRequire("iPlb2");


var $kljdr = parcelRequire("kljdr");

const $9f7493673e5a94a1$var$avpvizIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($gJ798)))
];
const $9f7493673e5a94a1$var$UUID = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';
const $9f7493673e5a94a1$var$AVPVIZ_CHART_URL_PATTERN = new RegExp(`/(?:avpviz|dashboards)/c/${$9f7493673e5a94a1$var$UUID}/w/${$9f7493673e5a94a1$var$UUID}/d/${$9f7493673e5a94a1$var$UUID}/(?:chart|widget)/${$9f7493673e5a94a1$var$UUID}/?(?:[?#].*)?$`);
const $9f7493673e5a94a1$var$isAvpvizChartUrl = (url)=>(0, $iDrrr.fg)('platform_avp_viz_confluence_native_embed') && $9f7493673e5a94a1$var$AVPVIZ_CHART_URL_PATTERN.test(url); /**
                                                                                                                                          * Experience manifest for a shared AVPViz chart.
                                                                                                                                          *
                                                                                                                                          * This claims only canonical shared chart URLs while its rollout gate is enabled.
                                                                                                                                          * The linking-platform resolver supplies the title and preview used by the host overlay.
                                                                                                                                          */ 
const $9f7493673e5a94a1$export$c3e28fef372cacbf = {
    id: (0, $kljdr.AVPVIZ_EXPERIENCE_MANIFEST_ID),
    handleChildCommands: (_experience, _command)=>{},
    isUrlMatch: $9f7493673e5a94a1$var$isAvpvizChartUrl,
    isActive: ()=>true,
    resolveViaLinkingPlatform: true,
    supportedFeatures: new Set([
        ...(0, $iPlb2.allNativeEmbedCoreFeatures)
    ]),
    transformUrl: (url, isFullScreen)=>{
        const urlObj = new URL(url);
        if (!isFullScreen) urlObj.searchParams.set('hideBorder', 'true');
        urlObj.searchParams.set('nativeEmbedView', 'true');
        const initialTheme = (0, $1xINT.getInitialThemeParam)();
        if (initialTheme) urlObj.searchParams.set('themeState', initialTheme);
        return urlObj.toString();
    },
    uiConfig: {
        headerControls: {},
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                items: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT
                ],
                moreItems: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
                ]
            }),
        editorToolbarHandlers: {},
        renderLoadingComponent: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
                animationDisabled: props.animationDisabled,
                icons: $9f7493673e5a94a1$var$avpvizIcons,
                testId: props.testId
            }),
        titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($gJ798))),
        useResolvedTitleIcon: true,
        appearance: 'overlay'
    }
};
module.exports["AvpvizExperienceManifest"] = $9f7493673e5a94a1$export$c3e28fef372cacbf;

});

parcelRegister("kljdr", function(module, exports) {

var $8fPlA = parcelRequire("8fPlA");

const $b14058f365e47627$export$9000ddb06e520b63 = (0, $8fPlA.experienceManifestId)('avpviz');
module.exports["AVPVIZ_EXPERIENCE_MANIFEST_ID"] = $b14058f365e47627$export$9000ddb06e520b63;

});

parcelRegister("iwIwp", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $6Iq0g = parcelRequire("6Iq0g");


var $h2POc = parcelRequire("h2POc");

/**
 * Matches Confluence short-link URLs of the form /wiki/x/<token>.
 * These URLs do not map to a specific experience until resolved via ORS.
 */ const $3b2da6bf08d8f744$var$CONFLUENCE_SHORT_LINK_PATTERN = /\/wiki\/x\/[^/]+/;
let $3b2da6bf08d8f744$var$nativeEmbedFacade;
function $3b2da6bf08d8f744$export$31739795deb20347() {
    if (!$3b2da6bf08d8f744$var$nativeEmbedFacade) $3b2da6bf08d8f744$var$nativeEmbedFacade = new $3b2da6bf08d8f744$export$3aace7af5e09b157((0, $6Iq0g.getExperienceManifestRegistry)(), (0, $h2POc.getSurfaceService)());
    return $3b2da6bf08d8f744$var$nativeEmbedFacade;
}





class $3b2da6bf08d8f744$export$3aace7af5e09b157 {
    /**
   * Registers an experience manifest so it can be matched by URL via {@link resolveManifestForUrl}.
   */ registerExperienceManifest(manifest) {
        this.experienceManifestRegistry.registerExperienceManifest(manifest);
    }
    /**
   * One-shot convenience method that registers experience manifests and
   * optionally configures the host surface in a single call.
   *
   * Prefer `setup()` over calling `registerExperienceManifest` /
   * `setSurface` individually — it makes the configuration declarative,
   * validates inputs eagerly, and guards against accidental double-setup.
   *
   * The low-level methods remain available for advanced use cases
   * (conditional registration, dynamic surface changes, etc.).
   *
   * @param config - The setup configuration.
   * @param config.experiences - Non-empty array of experience manifests to register.
   * @param config.surface - Optional surface configuration.
   *
   * Logs a warning and returns early if `setup()` has already been called.
   *
   * @example
   * ```ts
   * import { getNativeEmbedFacade } from '@atlassian/native-embeds-core';
   *
   * getNativeEmbedFacade().setup({
   *   experiences: [WhiteboardExperienceManifest, DBExperienceManifest],
   * });
   * ```
   */ setup(config) {
        if (this.isSetUp) {
            // eslint-disable-next-line no-console
            console.warn("NativeEmbedFacade.setup() has already been called. This call will be ignored. Use the low-level registerExperienceManifest() and setSurface() methods if you need to modify configuration after initial setup.");
            return;
        }
        for (const manifest of config.experiences)this.registerExperienceManifest(manifest);
        if (config.surface) this.setSurface(config.surface);
        if (config.cardClient) this.cardClient = config.cardClient;
        this.isSetUp = true;
    }
    /**
   * Sets the {@link CardClient} instance used for short-link URL resolution.
   *
   * This is useful when the `CardClient` is not available at the time `setup()`
   * is called (e.g. when the facade is initialised at module-load time before
   * the card provider is ready). Calling this after `setup()` replaces any
   * previously configured client.
   *
   * @param cardClient - The CardClient instance to use for ORS requests.
   */ setCardClient(cardClient) {
        this.cardClient = cardClient;
    }
    /**
   * Synchronous function that verifies if the URL matches any registered experience, and returns the experience ID if it does.
   * @param url - The URL to get the experience from.
   * @returns
   */ getExperienceIdFromUrl(url) {
        return this.experienceManifestRegistry.getExperienceIdFromUrl(url);
    }
    /**
   * Async variant of {@link getExperienceIdFromUrl} that handles Confluence
   * short-link URLs (e.g. `/wiki/x/<token>`).
   *
   * When the URL is a Confluence short link and a `cardClient` has been
   * configured (via `setup({ cardClient })` or `setCardClient()`), this method
   * resolves the short link to its canonical URL via the Object Resolver
   * Service and then matches the expanded URL against registered experience
   * manifests.
   *
   * Falls back to the synchronous {@link getExperienceIdFromUrl} for all
   * non-short-link URLs, or when no `cardClient` is available.
   *
   * @param url - The URL to resolve and match.
   * @returns The matched experience manifest ID, or `undefined` if no match.
   */ async getExperienceIdFromUrlAsync(url) {
        // Fast path: direct synchronous match (works for all non-short-link URLs)
        const syncResult = this.experienceManifestRegistry.getExperienceIdFromUrl(url);
        if (syncResult) return syncResult;
        // Expand Confluence short links via ORS when a cardClient is available
        const expandedUrl = await this.expandShortLink(url);
        if (!expandedUrl) return undefined;
        return this.experienceManifestRegistry.getExperienceIdFromUrl(expandedUrl);
    }
    /**
   * If `url` is a Confluence short link and a `cardClient` is configured,
   * resolves it to its canonical expanded URL via the Object Resolver Service.
   *
   * Returns `undefined` when:
   * - the feature gate `platform_native_embeds_rollout_non_maui_experience` is off,
   * - the URL is not a short link,
   * - no `cardClient` is available, or
   * - resolution fails or returns the same URL.
   */ async expandShortLink(url) {
        if (!(0, $iDrrr.fg)('platform_native_embeds_rollout_non_maui_experience')) return undefined;
        const isShortLink = $3b2da6bf08d8f744$var$CONFLUENCE_SHORT_LINK_PATTERN.test(url);
        if (!isShortLink || !this.cardClient) return undefined;
        try {
            const response = await this.cardClient.fetchData(url);
            const data = response?.data;
            if (!data || typeof data !== 'object') return undefined;
            const resolvedUrl = data['url'];
            if (typeof resolvedUrl === 'string' && resolvedUrl !== url) return resolvedUrl;
            // url can also be an object with an @id (JsonLd Link type)
            if (resolvedUrl && typeof resolvedUrl === 'object') {
                const id = resolvedUrl['@id'];
                if (typeof id === 'string' && id !== url) return id;
            }
        } catch  {
        // Short-link expansion is best-effort; fall through to return undefined.
        }
        return undefined;
    }
    /**
   * Synchronous function that returns the manifest for a URL if it matches any registered experience.
   * Uses `isUrlMatch` to find the matching manifest.
   * @param url - The URL to get the manifest for.
   * @returns The matching manifest, or undefined if no match is found.
   */ getManifestByUrl(url) {
        return this.experienceManifestRegistry.getManifestByUrl(url);
    }
    /**
   * Synchronous function that returns the manifest for a given experience ID.
   * @param id - The experience manifest ID to look up.
   * @returns The matching manifest, or undefined if no match is found.
   */ getManifestById(id) {
        return this.experienceManifestRegistry.getManifestById(id);
    }
    /**
   * Returns a list of all registered experience IDs.
   */ getAllExperienceIds() {
        return this.experienceManifestRegistry.getAllExperienceIds();
    }
    /**
   * Register or replace the active host surface.
   *
   * The surface provides capabilities that differ per host (editor, renderer,
   * etc.). The {@link Surface} interface will grow as new surface concerns
   * are identified.
   *
   * - Replaces any previously registered surface (last-write-wins).
   * - Pass `null` to clear the surface (e.g. on unmount).
   *
   * @param surface - The surface configuration, or `null` to clear.
   */ setSurface(surface) {
        this.surfaceService.setSurface(surface);
    }
    /**
   * Finds the matching manifest for a URL and creates an experience.
   * Title metadata will be resolved later by Smart Card.
   *
   * When the URL is a Confluence short link (e.g. `/wiki/x/<token>`) and a
   * `cardClient` has been configured, the short link is expanded to its
   * canonical URL via the Object Resolver Service before manifest matching.
   * The experience is created with the expanded URL.
   */ async createExperienceForUrl(url) {
        // Reject non-URL strings early. macroParams.url may contain prose text
        // with an embedded link rather than a bare URL (e.g. after a bad paste).
        try {
            new URL(url);
        } catch  {
            return undefined;
        }
        const resolvedUrl = await this.expandShortLink(url) ?? url;
        const manifest = this.experienceManifestRegistry.getManifestByUrl(resolvedUrl);
        if (!manifest) return undefined;
        const urlMeta = {
            url: resolvedUrl,
            title: ''
        };
        // Lazy import — ExperienceService transitively pulls in
        // rovo-content-bridge-api which uses uuid/randomBytes. Keeping it out of
        // the static import graph prevents the SSR pre-compile crash.
        const { getExperienceService: getExperienceService } = await (parcelRequire("eoNlM"));
        const experience = getExperienceService().registerExperience({
            manifest: manifest,
            urlMeta: urlMeta
        });
        return {
            experience: experience,
            manifest: manifest
        };
    }
    /**
   * Unregister an experience and dispose its event listeners.
   *
   * Call when the embed is removed from the host surface (e.g. editor node
   * deleted, component unmount). This prevents memory leaks from stale
   * listener references.
   *
   * Safe to call with an ID that was never registered — it's a no-op.
   */ async destroyExperience(experienceId) {
        const { getExperienceService: getExperienceService } = await (parcelRequire("eoNlM"));
        getExperienceService().unregisterExperience(experienceId);
    }
    /** Notify the child embed that its selection state changed. */ async sendSelectedChange(experienceId, selected) {
        const { getExperienceService: getExperienceService } = await (parcelRequire("eoNlM"));
        getExperienceService().sendSelectedChange(experienceId, selected);
    }
    /** Notify the child embed that the embedded content should be read. */ async sendReadContent(experienceId) {
        if (!(0, $iDrrr.fg)('maui_remixable_page_native_embeds')) return undefined;
        const { getExperienceService: getExperienceService } = await (parcelRequire("eoNlM"));
        return getExperienceService().sendReadContent(experienceId);
    }
    /** Register `aliasId` as a secondary ID for `experienceId`. Overwrites any previous mapping for `aliasId`. */ async addAlias(aliasId, experienceId) {
        const { getExperienceService: getExperienceService } = await (parcelRequire("eoNlM"));
        getExperienceService().addAlias(aliasId, experienceId);
    }
    constructor(experienceManifestRegistry, surfaceService){
        this.experienceManifestRegistry = void 0;
        this.surfaceService = void 0;
        this.cardClient = void 0;
        this.isSetUp = false;
        this.experienceManifestRegistry = experienceManifestRegistry;
        this.surfaceService = surfaceService;
    }
}
module.exports["getNativeEmbedFacade"] = $3b2da6bf08d8f744$export$31739795deb20347;

});

parcelRegister("6Iq0g", function(module, exports) {
let $7626500f872d820e$var$experienceService;
function $7626500f872d820e$export$1b2983209f90e067() {
    if ($7626500f872d820e$var$experienceService) return $7626500f872d820e$var$experienceService;
    $7626500f872d820e$var$experienceService = new $7626500f872d820e$export$21c7ca9c95b7ce6b();
    return $7626500f872d820e$var$experienceService;
}
class $7626500f872d820e$export$21c7ca9c95b7ce6b {
    registerExperienceManifest(experienceManifest) {
        this.experienceManifests.push(experienceManifest);
    }
    safeIsUrlMatch(experience, url) {
        try {
            return experience.isUrlMatch(url);
        } catch  {
            return false;
        }
    }
    getExperienceIdFromUrl(url) {
        return this.experienceManifests.find((experience)=>this.safeIsUrlMatch(experience, url))?.id;
    }
    getManifestByUrl(url) {
        return this.experienceManifests.find((experience)=>this.safeIsUrlMatch(experience, url));
    }
    getManifestById(id) {
        return this.experienceManifests.find((experience)=>experience.id === id);
    }
    getAllExperienceIds() {
        return this.experienceManifests.map((experience)=>experience.id);
    }
    async getExperienceById(id) {
        return this.experienceManifests.find((experience)=>experience.id === id);
    }
    constructor(){
        this.experienceManifests = [];
    }
}
module.exports["getExperienceManifestRegistry"] = $7626500f872d820e$export$1b2983209f90e067;

});

parcelRegister("h2POc", function(module, exports) {
let $761c278f71652274$var$surfaceServiceInstance;
function $761c278f71652274$export$a019fb3db45daa2b() {
    if (!$761c278f71652274$var$surfaceServiceInstance) $761c278f71652274$var$surfaceServiceInstance = new $761c278f71652274$export$f9308bd8ae7f0c97();
    return $761c278f71652274$var$surfaceServiceInstance;
}
class $761c278f71652274$export$f9308bd8ae7f0c97 {
    /**
   * Register or replace the active host surface.
   *
   * @param surface - The surface configuration, or `null` to clear.
   */ setSurface(surface) {
        this._surface = surface;
    }
    /**
   * Returns the currently active surface, or `null` if none is set.
   */ getSurface() {
        return this._surface;
    }
    constructor(){
        this._surface = null;
    }
}
module.exports["getSurfaceService"] = $761c278f71652274$export$a019fb3db45daa2b;

});

parcelRegister("eoNlM", function(module, exports) {

let $a7b996873e1209d3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a7b996873e1209d3$var$load("9njOW").then(()=>parcelRequire('ddI8y'));

});

parcelRegister("99TtX", function(module, exports) {

var $ljOiP = parcelRequire("ljOiP");


var $8fPlA = parcelRequire("8fPlA");


var $dx0Kw = parcelRequire("dx0Kw");

const $0232ad9c82d62a25$export$6dc7663b60a7f493 = (0, $8fPlA.experienceManifestId)('database');
const $0232ad9c82d62a25$var$isDatabaseUrl = (url)=>{
    return url.match(/\/wiki\/spaces\/~?[\d\w]+\/database\/\d+(\?.*)?$/) !== null;
};
const $0232ad9c82d62a25$var$isDatabaseEntryUrl = (url)=>{
    try {
        return $0232ad9c82d62a25$var$isDatabaseUrl(url) && new URL(url).searchParams.has('entryId');
    } catch  {
        return false;
    }
};
const $0232ad9c82d62a25$var$isDatabaseNonEntryUrl = (url)=>{
    return $0232ad9c82d62a25$var$isDatabaseUrl(url) && !$0232ad9c82d62a25$var$isDatabaseEntryUrl(url);
};
const $0232ad9c82d62a25$export$3db4c20f17f55c0a = {
    ...(0, $dx0Kw.dbSharedManifestFields),
    id: $0232ad9c82d62a25$export$6dc7663b60a7f493,
    isUrlMatch: $0232ad9c82d62a25$var$isDatabaseNonEntryUrl,
    parameterDefaults: {
        alwaysShowTitle: true
    },
    uiConfig: {
        ...(0, $dx0Kw.dbSharedUiConfig),
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                items: [
                    ...(0, $dx0Kw.getDbToolbarItems)()
                ],
                moreItems: (0, $dx0Kw.dbMoreItems)
            })
    }
};
module.exports["DBExperienceManifest"] = $0232ad9c82d62a25$export$3db4c20f17f55c0a;

});

parcelRegister("dx0Kw", function(module, exports) {
/* shared.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $4MdqE = parcelRequire("4MdqE");


var $lBKFk = parcelRequire("lBKFk");


var $k0CUL = parcelRequire("k0CUL");


var $1bzO2 = parcelRequire("1bzO2");


var $k9wGn = parcelRequire("k9wGn");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $iPlb2 = parcelRequire("iPlb2");


var $hjJUc = parcelRequire("hjJUc");

const $95d7871f626fca16$var$dbIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
    (0, (/*@__PURE__*/$parcel$interopDefault($1bzO2))),
    (0, (/*@__PURE__*/$parcel$interopDefault($k0CUL))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4MdqE)))
];
const $95d7871f626fca16$var$dbHandleChildCommands = (_experience, _command)=>{};
const $95d7871f626fca16$var$dbTransformUrl = (url, _isFullScreen)=>{
    const urlObj = new URL(url);
    urlObj.searchParams.set('presentationMode', 'nativeEmbedEditorPlugin');
    return urlObj.toString();
};
const $95d7871f626fca16$var$dbRenderLoadingComponent = (props)=>/*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
        animationDisabled: props.animationDisabled,
        icons: $95d7871f626fca16$var$dbIcons,
        testId: props.testId
    });
const $95d7871f626fca16$export$8f59efcb9ee755ea = ()=>{
    const itemsBeforeUpdate = [
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
    ];
    const itemsAfterUpdate = [
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT
    ];
    return (0, $iDrrr.fg)('cc-maui-toolbar-separators-update') ? itemsAfterUpdate : itemsBeforeUpdate;
};
const $95d7871f626fca16$export$828ffb167e211671 = [
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
]; /**
                                                                                                                                                                         * Returns the "More options" dropdown items for the DB Entry embed.
                                                                                                                                                                         *
                                                                                                                                                                         * The "Always show title" toggle is gated on the `databases-native-embeds-v2`
                                                                                                                                                                         * experiment: it is only included when the experiment is enabled. Evaluated
                                                                                                                                                                         * lazily (rather than at module-load time) because the manifest is registered
                                                                                                                                                                         * before Statsig is bootstrapped.
                                                                                                                                                                         */ 
const $95d7871f626fca16$export$c84eb7789dc18 = ()=>{
    const items = [];
    if ((0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) && (0, $ieeJu.expValEquals)('databases-native-embeds-v2', 'isEnabled', true)) items.push((0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE);
    items.push((0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY, (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE);
    return items;
};
const $95d7871f626fca16$export$2ef16a6e7258368a = {
    editorToolbarHandlers: {},
    renderLoadingComponent: $95d7871f626fca16$var$dbRenderLoadingComponent,
    titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
    appearance: 'minimal',
    showHeader: false,
    showBorder: false,
    waitForContentReady: true
};
const $95d7871f626fca16$export$28b94c65c51f8734 = {
    allowVerticalResize: true,
    isActive: ()=>true,
    handleChildCommands: $95d7871f626fca16$var$dbHandleChildCommands,
    lockResizeAspectRatio: ()=>false,
    supportedFeatures: new Set((0, $iPlb2.allNativeEmbedCoreFeatures)),
    transformUrl: $95d7871f626fca16$var$dbTransformUrl
};
module.exports["getDbToolbarItems"] = $95d7871f626fca16$export$8f59efcb9ee755ea;
module.exports["dbMoreItems"] = $95d7871f626fca16$export$828ffb167e211671;
module.exports["getDbEntryMoreItems"] = $95d7871f626fca16$export$c84eb7789dc18;
module.exports["dbSharedUiConfig"] = $95d7871f626fca16$export$2ef16a6e7258368a;
module.exports["dbSharedManifestFields"] = $95d7871f626fca16$export$28b94c65c51f8734;

});

parcelRegister("1NFwk", function(module, exports) {

var $ljOiP = parcelRequire("ljOiP");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $8fPlA = parcelRequire("8fPlA");


var $dx0Kw = parcelRequire("dx0Kw");

const $2b4557ff3d43825b$var$isDbEntryV2Enabled = ()=>(0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) && (0, $ieeJu.expValEquals)('databases-native-embeds-v2', 'isEnabled', true);
/**
 * Returns the parameter defaults for the DB Entry embed.
 *
 * When v2 is enabled (see {@link isDbEntryV2Enabled}), new entry embeds
 * default to having the title visible (`alwaysShowTitle: true`),
 * matching the regular DB embed behaviour. Otherwise no override is
 * applied.
 */ const $2b4557ff3d43825b$var$getDbEntryParameterDefaults = ()=>$2b4557ff3d43825b$var$isDbEntryV2Enabled() ? {
        alwaysShowTitle: true
    } : {};
const $2b4557ff3d43825b$export$a8c9f0f28b60cece = (0, $8fPlA.experienceManifestId)('database-entry');
const $2b4557ff3d43825b$var$isDatabaseEntryUrl = (url)=>{
    try {
        return url.match(/\/wiki\/spaces\/~?[\d\w]+\/database\/\d+(\?.*)?$/) !== null && new URL(url).searchParams.has('entryId');
    } catch  {
        return false;
    }
};
const $2b4557ff3d43825b$export$b0c2faa0f9dece58 = {
    ...(0, $dx0Kw.dbSharedManifestFields),
    id: $2b4557ff3d43825b$export$a8c9f0f28b60cece,
    isUrlMatch: $2b4557ff3d43825b$var$isDatabaseEntryUrl,
    get parameterDefaults () {
        return $2b4557ff3d43825b$var$getDbEntryParameterDefaults();
    },
    uiConfig: {
        ...(0, $dx0Kw.dbSharedUiConfig),
        get appearance () {
            return $2b4557ff3d43825b$var$isDbEntryV2Enabled() ? 'overlay' : 'minimal';
        },
        get showBorder () {
            return $2b4557ff3d43825b$var$isDbEntryV2Enabled();
        },
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                items: [
                    ...(0, $dx0Kw.getDbToolbarItems)()
                ],
                moreItems: (0, $dx0Kw.getDbEntryMoreItems)()
            })
    }
};
module.exports["DBEntryExperienceManifest"] = $2b4557ff3d43825b$export$b0c2faa0f9dece58;

});

parcelRegister("9F0bu", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $6Ec6w = parcelRequire("6Ec6w");


var $k9wGn = parcelRequire("k9wGn");

var $ljOiP = parcelRequire("ljOiP");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $gqUuL = parcelRequire("gqUuL");


var $iPlb2 = parcelRequire("iPlb2");


var $hjJUc = parcelRequire("hjJUc");


var $8fPlA = parcelRequire("8fPlA");

const $d2e69b3762c8c591$export$b0111d5aa9d78690 = (0, $8fPlA.experienceManifestId)('maui');
const $d2e69b3762c8c591$var$MAUI_DEFAULT_WIDTH_KILLSWITCH = 'native_embeds_maui_default_width_killswitch';
const $d2e69b3762c8c591$var$isMauiUrl = (url)=>/\/remix\/ui\/[A-Za-z0-9_-]+/.test(url); /**
                                                                                      * Experience manifest for a MAUI embed.
                                                                                      * Register with getNativeEmbedFacade().registerExperienceManifest(MauiExperienceManifest),
                                                                                      * then call getNativeEmbedFacade().createExperienceForUrl(url) to obtain an Experience for EmbedFrameUI.
                                                                                      */ 
const $d2e69b3762c8c591$export$f519d88de7ad4d5e = {
    allowMaxWidth: true,
    id: $d2e69b3762c8c591$export$b0111d5aa9d78690,
    handleChildCommands: (_experience, _cmd)=>{},
    isUrlMatch: $d2e69b3762c8c591$var$isMauiUrl,
    supportedFeatures: new Set((0, $iPlb2.allNativeEmbedCoreFeatures)),
    isActive: ()=>true,
    lockResizeAspectRatio: ()=>!(0, $iDrrr.fg)('cc_maui_resize'),
    narrowEmbedThreshold: 50,
    parameterDefaults: {
        get width () {
            return (0, $iDrrr.fg)($d2e69b3762c8c591$var$MAUI_DEFAULT_WIDTH_KILLSWITCH) ? 760 : undefined;
        }
    },
    shouldFocusOnClick: (_url, _meta, options)=>!(0, $iDrrr.fg)('cc_maui_editing') || options?.isSelected !== true,
    transformUrl: (url, _isFullScreen, options)=>{
        const urlObj = new URL(url);
        const { colorMode: colorMode } = (0, $gqUuL.getGlobalTheme)();
        if (colorMode) urlObj.searchParams.set('theme', colorMode);
         // When the host Confluence page is in edit mode, forward an
        // `enable-edits=` query param (empty value) so the embedded MAUI app
        // can render its edit-only affordances.
        if (options?.isEditMode) urlObj.searchParams.set('enable-edits', '');
        return urlObj.toString();
    },
    // remove this when MAUI is onboarded to the Linking Platform. This is here to allow testing before it is onboarded.
    resolveViaLinkingPlatform: false,
    uiConfig: {
        trackViewed: true,
        // Holds core's loading state until the app reports its first painted frame; the iframe's
        // `load` event fires while the app is still starting. The reveal in `editor-common` waits on
        // that signal. A getter, because the manifest is a module constant and the gate is read per
        // render. Applies to every MAUI embed; an app that never sends the signal keeps its overlay
        // until core's 10s timeout.
        get waitForContentReady () {
            return (0, $iDrrr.fg)('aifc_page_create_defer_generated_visuals');
        },
        showBorder: false,
        showExpandButton: false,
        renderLoadingComponent: (props)=>{
            return /*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
                variant: "simple-bar",
                animationDisabled: props.animationDisabled,
                showBlanket: props.source === 'ai-edit',
                testId: props.testId
            });
        },
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                customActions: {},
                items: [
                    ...(0, $iDrrr.fg)('cc-maui-phase-2') ? (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).REMIX_VARIANT,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ] : [],
                    ...(0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true) ? (0, $iDrrr.fg)('cc-maui-toolbar-separators-update') ? [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).BORDER
                    ] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).BORDER,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ] : [],
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
                    ...(0, $iDrrr.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ],
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EXPAND,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
                ],
                moreItems: []
            }),
        editorToolbarHandlers: {
            onAskRovoClick: (_parameters, context)=>{
                const editorApi = context?.editorApi; // Stage the embed as the inline-Rovo streaming target. The overlay
                // is NOT triggered here — `RovoPromptScreenWithLogic.onSubmit`
                // promotes this on prompt submit. `expValEquals` (NOT NoExposure)
                // because this toolbar click is the designated `cc-maui-experiment`
                // exposure point.
                if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning -- gate + experiment layering for MAUI rollout (cc-maui-experiment + cc-maui-phase-2); will simplify post-rollout
                (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true) && (0, $iDrrr.fg)('cc-maui-phase-2')) {
                    const localId = context?.selectedNodeLocalId;
                    if (localId) editorApi?.aiExperience?.actions?.stageInlineRovoStreaming?.(localId);
                }
                editorApi?.aiExperience?.actions?.openAIModal?.({
                    invokedFrom: 'floatingToolbar'
                });
            }
        },
        fullScreenDialogControls: {
            hideOpenInNewTab: true,
            hideTitleIcon: true
        },
        headerControls: {
            hideMoreMenu: true,
            hideTitle: true
        },
        titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6Ec6w))),
        appearance: 'overlay'
    }
};
module.exports["MAUI_EXPERIENCE_MANIFEST_ID"] = $d2e69b3762c8c591$export$b0111d5aa9d78690;
module.exports["MauiExperienceManifest"] = $d2e69b3762c8c591$export$f519d88de7ad4d5e;

});

parcelRegister("85cI7", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $cXtTj = parcelRequire("cXtTj");


var $b5sDq = parcelRequire("b5sDq");


var $h5uPL = parcelRequire("h5uPL");


var $jxqsh = parcelRequire("jxqsh");


var $bDjVc = parcelRequire("bDjVc");


var $k9wGn = parcelRequire("k9wGn");

var $ljOiP = parcelRequire("ljOiP");


var $5FKld = parcelRequire("5FKld");


var $iDrrr = parcelRequire("iDrrr");


var $iPlb2 = parcelRequire("iPlb2");


var $hjJUc = parcelRequire("hjJUc");


var $1xINT = parcelRequire("1xINT");


var $8fPlA = parcelRequire("8fPlA");

const $ec6282bd715404c7$export$7bda1cade81459d3 = (0, $8fPlA.experienceManifestId)('maui-whiteboard'); /**
                                                                                                                      * Dynamic-config killswitch for sending `disableCanvasScroll` conditionally in
                                                                                                                      * legacy full screen. Default `false` = change enabled (param omitted from the
                                                                                                                      * legacy full-screen URL so the blown-up board scrolls); set to `true` to roll
                                                                                                                      * back to the pre-EPS8-40 behavior (param sent everywhere).
                                                                                                                      */ 
const $ec6282bd715404c7$var$LEGACY_FS_CANVAS_SCROLL_KILLSWITCH = 'platform_native_embed_legacy_fs_canvas_scroll';
const $ec6282bd715404c7$var$ROVO_REMIX_TITLE_KILLSWITCH = 'platform_native_embed_rovo_remix_title';
const $ec6282bd715404c7$var$RELATIVE_URL_PARSE_BASE = 'https://native-embeds.invalid';
const $ec6282bd715404c7$var$whiteboardIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b5sDq))),
    (0, (/*@__PURE__*/$parcel$interopDefault($jxqsh))),
    (0, (/*@__PURE__*/$parcel$interopDefault($h5uPL)))
]; /**
                                                                                              * Captures the whiteboard resource id from a Confluence whiteboard URL. Numeric
                                                                                              * ids and UUIDs are both in use.
                                                                                              */ 
// eslint-disable-next-line require-unicode-regexp
const $ec6282bd715404c7$var$WHITEBOARD_RESOURCE_ID_REGEX = /\/whiteboard\/([^/?#]+)/; /**
                                                                 * A whiteboard embed's identity is its content id. The space segment is vanity
                                                                 * (the rendered canvas URL is `/canvas-embed/whiteboard/{referenceId}` and has no
                                                                 * space key), and the streaming params are transient, so neither changes which
                                                                 * board is being shown.
                                                                 *
                                                                 * Scoped to the MAUI experience on purpose. The in-editor Remix finalize keeps
                                                                 * `isRemixDiagram=true` on the rewritten URL, so both the streaming and finalized
                                                                 * URLs still match this manifest — which `main.tsx` registers ahead of the generic
                                                                 * whiteboard one — and identity resolves from here on both sides of the rewrite.
                                                                 *
                                                                 * The paste path is deliberately not covered: `buildMovedUrl` strips
                                                                 * `isRemixDiagram`, so its finalized URL falls through to the generic `whiteboard`
                                                                 * manifest, which has no identity and therefore keeps the existing URL-keyed
                                                                 * teardown. That path's reload is already largely masked because the move fires on
                                                                 * the tick after paste, while the board is still loading. Extending identity to
                                                                 * the generic manifest would change behaviour for every non-MAUI Confluence
                                                                 * whiteboard embed, which is not worth it for this fix.
                                                                 */ 
const $ec6282bd715404c7$var$getWhiteboardContentIdentity = (url)=>{
    const resourceId = $ec6282bd715404c7$var$WHITEBOARD_RESOURCE_ID_REGEX.exec(url)?.[1];
    if (!resourceId) return undefined;
    try {
        return `whiteboard:${decodeURIComponent(resourceId)}`;
    } catch  {
        return `whiteboard:${resourceId}`;
    }
};
const $ec6282bd715404c7$var$isMauiWhiteboardUrl = (url)=>{
    const isWhiteboardPath = url.match(RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>\\d+)(\\?\\/)?")) || url.match(RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})(\\?\\/)?"));
    if (!isWhiteboardPath) return false;
    try {
        return new URL(url).searchParams.get('isRemixDiagram') === 'true';
    } catch  {
        return false;
    }
}; /**
    * Reads search params from either an absolute embed URL or a relative iframe
    * src such as `/canvas-embed/whiteboard/...`. The placeholder base is only
    * used by `URL` to parse relative URLs; absolute URLs keep their own origin
    * and nothing is requested from this host.
    */ 
const $ec6282bd715404c7$var$getSearchParamFromEmbedUrl = (url, param)=>{
    try {
        return new URL(url, $ec6282bd715404c7$var$RELATIVE_URL_PARSE_BASE).searchParams.get(param);
    } catch  {
        return null;
    }
};
const $ec6282bd715404c7$var$shouldHideRovoRemixTitle = (url)=>{
    // Killswitch: platform_native_embed_rovo_remix_title
    // false (default) = hide intermediary Rovo remix titles; true = rollback
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    if ((0, $cXtTj.default).getExperimentValue($ec6282bd715404c7$var$ROVO_REMIX_TITLE_KILLSWITCH, 'value', false)) return false;
    return $ec6282bd715404c7$var$getSearchParamFromEmbedUrl(url, 'parentProduct') === 'rovo';
}; /**
    * Experience manifest for a MAUI whiteboard embed — a whiteboard created through
    * the MAUI (remix diagram) flow.
    *
    * Register with getNativeEmbedFacade().registerExperience(MauiWhiteboardExperienceManifest)
    * to obtain an Experience for EmbedFrameUI.
    */ 
const $ec6282bd715404c7$export$72612bab14c2e7fe = {
    id: $ec6282bd715404c7$export$7bda1cade81459d3,
    getContentIdentity: $ec6282bd715404c7$var$getWhiteboardContentIdentity,
    isUrlMatch: $ec6282bd715404c7$var$isMauiWhiteboardUrl,
    supportedFeatures: new Set([
        ...(0, $iPlb2.allNativeEmbedCoreFeatures),
        (0, $5FKld.WHITEBOARD_VIEWPORT_ALIGNMENT_FEATURE)
    ]),
    // Thunk so the killswitch is read at URL-build time (after Statsig init), and
    // so the conditional behavior is gated at its source: when rolled back the
    // manifest emits the pre-EPS8-40 plain-string value, which `resolveQueryParams`
    // passes through unchanged at every build site.
    //
    // `disableCanvasScroll` is correct inline (and in shared-iframe full screen,
    // which reuses the inline URL) but makes the blown-up board feel broken in the
    // legacy full-screen iframe, so by default it is omitted from that build site
    // only. `hideCursors` applies everywhere (plain string === appliesTo: 'always').
    queryParams: ()=>{
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const rolledBack = (0, $cXtTj.default).getExperimentValue($ec6282bd715404c7$var$LEGACY_FS_CANVAS_SCROLL_KILLSWITCH, 'value', false);
        return rolledBack ? {
            disableCanvasScroll: 'true',
            hideCursors: 'true'
        } : {
            disableCanvasScroll: {
                value: 'true',
                appliesTo: 'exceptLegacyFullscreen'
            },
            hideCursors: 'true'
        };
    },
    transformUrl: (url, isFullScreen)=>{
        const urlObj = new URL(url);
        if (!isFullScreen) urlObj.searchParams.set('hideBorder', 'true');
         // this is used to identify the native embed view in the whiteboard app
        urlObj.searchParams.set('nativeEmbedView', 'true'); // Default the parent product for MAUI whiteboards when the native embed
        // URL doesn't already specify one. native-embeds-core re-applies this
        // onto the ORS-resolved iframe src (which otherwise defaults to
        // `smartlink`). An existing value (e.g. `rovo`) is preserved.
        if (!urlObj.searchParams.has('parentProduct')) urlObj.searchParams.set('parentProduct', 'nativeEmbedDiagram');
        const initialTheme = (0, $1xINT.getInitialThemeParam)();
        if (initialTheme) urlObj.searchParams.set('themeState', initialTheme);
        return urlObj.toString();
    },
    isActive: ()=>{
        return true;
    },
    uiConfig: {
        trackViewed: true,
        isAskRovoEnabled: ()=>(0, $iDrrr.fg)('cc-maui-phase-2'),
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                items: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
                    ...(0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).REMIX_VARIANT
                    ] : [],
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT,
                    ...(0, $iDrrr.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ],
                    // BUILTIN_TOOLBAR_KEYS.BORDER, // Border option is yet to be implemented.
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
                    ...(0, $iDrrr.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ]
                ],
                moreItems: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
                ]
            }),
        editorToolbarHandlers: {},
        headerControls: {
            hideTitle: ({ url: url })=>$ec6282bd715404c7$var$shouldHideRovoRemixTitle(url)
        },
        renderLoadingComponent: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
                animationDisabled: props.animationDisabled,
                icons: $ec6282bd715404c7$var$whiteboardIcons,
                testId: props.testId
            }),
        titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        appearance: 'overlay',
        waitForContentReady: true
    },
    handleChildCommands: (_experience, _cmd)=>{}
};
module.exports["MAUI_WHITEBOARD_EXPERIENCE_MANIFEST_ID"] = $ec6282bd715404c7$export$7bda1cade81459d3;
module.exports["MauiWhiteboardExperienceManifest"] = $ec6282bd715404c7$export$72612bab14c2e7fe;

});

parcelRegister("5FKld", function(module, exports) {
const $0debf512440368ae$export$2e20e907dc949166 = 'whiteboard-viewport-alignment';
const $0debf512440368ae$export$47b7df6411961030 = 'whiteboard-viewport-alignment-change';
function $0debf512440368ae$export$ac67ecac1191542d(alignment) {
    switch(alignment){
        case 'left':
        case 'wrap-left':
            return 'left';
        case 'center':
            return 'center';
        case 'right':
        case 'wrap-right':
            return 'right';
    }
}
module.exports["WHITEBOARD_VIEWPORT_ALIGNMENT_FEATURE"] = $0debf512440368ae$export$2e20e907dc949166;
module.exports["WHITEBOARD_VIEWPORT_ALIGNMENT_CHANGE_COMMAND"] = $0debf512440368ae$export$47b7df6411961030;
module.exports["normalizeWhiteboardViewportAlignment"] = $0debf512440368ae$export$ac67ecac1191542d;

});

parcelRegister("7tMWI", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kLlYX = parcelRequire("kLlYX");


var $gC2EJ = parcelRequire("gC2EJ");


var $hMaHH = parcelRequire("hMaHH");


var $4GyjL = parcelRequire("4GyjL");


var $d4GYd = parcelRequire("d4GYd");


var $UL6rM = parcelRequire("UL6rM");


var $k9wGn = parcelRequire("k9wGn");

var $ljOiP = parcelRequire("ljOiP");


var $iDrrr = parcelRequire("iDrrr");


var $iPlb2 = parcelRequire("iPlb2");


var $hjJUc = parcelRequire("hjJUc");


var $8fPlA = parcelRequire("8fPlA");

const $f5f0a9f7a4b49836$export$7870b2bb7b39809b = (0, $8fPlA.experienceManifestId)('page');
const $f5f0a9f7a4b49836$var$pageIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
    (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
    (0, (/*@__PURE__*/$parcel$interopDefault($UL6rM))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4GyjL)))
]; // Match page URLs: /wiki/spaces/<key>/pages/<id>
// Match blog URLs: /wiki/spaces/<key>/blog/<id> or /wiki/spaces/<key>/blog/<year>/<month>/<day>/<id>
const $f5f0a9f7a4b49836$var$pagePathPattern = /\/wiki\/spaces\/[^/]+\/(pages\/\d+|blog\/(\d+\/){0,3}\d+)/;
const $f5f0a9f7a4b49836$var$pageShortLinkUrlPattern = /^https:\/\/[^/?#]+\/wiki\/x\/[A-Za-z0-9_-]+\/?(?:[?#].*)?$/;
const $f5f0a9f7a4b49836$var$isPageUrl = (url)=>{
    if ($f5f0a9f7a4b49836$var$pagePathPattern.test(url)) return true;
     // Preserve the legacy Page native embed match until the EditorCardProvider shortlink flow is
    // rolled out. Removing it while the gate is off would regress existing shortlink native embeds.
    return $f5f0a9f7a4b49836$var$pageShortLinkUrlPattern.test(url) && !(0, $iDrrr.fg)('platform_native_embeds_enable_shortlink_resolution');
};
const $f5f0a9f7a4b49836$var$isEditUrl = (url)=>/\/wiki\/spaces\/[^/]+\/(pages|blog)\/(edit-embed|edit-v2)\/\d+/.test(url); // PGXT-10098: keep blog icons correct before resolved metadata is available.
const $f5f0a9f7a4b49836$var$blogPathPattern = /\/wiki\/spaces\/[^/]+\/blog\//;
const $f5f0a9f7a4b49836$var$isBlogUrl = (url)=>{
    try {
        return $f5f0a9f7a4b49836$var$blogPathPattern.test(new URL(url).pathname);
    } catch  {
        return $f5f0a9f7a4b49836$var$blogPathPattern.test(url);
    }
};
const $f5f0a9f7a4b49836$var$resolveTitleIcon = (meta, url)=>{
    if (meta.documentType === 'schema:DigitalDocument') return 0, (/*@__PURE__*/$parcel$interopDefault($kLlYX));
    if (meta.documentType === 'schema:BlogPosting' || $f5f0a9f7a4b49836$var$isBlogUrl(url)) return 0, (/*@__PURE__*/$parcel$interopDefault($d4GYd));
    return 0, (/*@__PURE__*/$parcel$interopDefault($hMaHH));
}; /**
    * Experience manifest for a page embed.
    * Register with getNativeEmbedFacade().registerExperienceManifest(PageExperienceManifest),
    * then call getNativeEmbedFacade().createExperienceForUrl(url) to obtain an Experience for EmbedFrameUI.
    */ 
const $f5f0a9f7a4b49836$export$f85d1a9111fa6dfc = {
    enforceQueryParams: true,
    id: $f5f0a9f7a4b49836$export$7870b2bb7b39809b,
    handleChildCommands: (_experience, _cmd)=>{},
    isUrlMatch: $f5f0a9f7a4b49836$var$isPageUrl,
    supportedFeatures: new Set((0, $iPlb2.allNativeEmbedCoreFeatures)),
    isActive: ()=>true,
    shouldFocusOnClick: (url, meta)=>{
        // Don't steal focus for live docs (documentType === 'schema:DigitalDocument')
        if (meta.documentType === 'schema:DigitalDocument') return false;
         // Don't steal focus when the page is in edit mode
        if ($f5f0a9f7a4b49836$var$isEditUrl(url)) return false;
        return true;
    },
    transformUrl: (url, _isFullScreen)=>{
        const urlObj = new URL(url);
        urlObj.searchParams.set('sample-param', 'true');
        return urlObj.toString();
    },
    uiConfig: {
        showHeader: (_meta, url)=>!$f5f0a9f7a4b49836$var$isEditUrl(url),
        headerControls: {
            editButton: {
                show: (meta)=>meta.documentType !== 'schema:DigitalDocument',
                // Don't show edit button for live docs
                onSwitchToEditing: (currentUrl, originalUrl)=>{
                    const url = new URL(currentUrl); // Detect whether this is originally a blog URL. The iframe's internal
                    // SPA router may resolve blog URLs (e.g. /blog/2026/04/29/<id>) to
                    // their canonical /pages/<id> form, so iframeSrc (currentUrl) may
                    // show /pages/<id> even for blogs. We check the originalUrl (the URL
                    // before iframe navigation) to detect blogs reliably; fall back to
                    // the current URL when no originalUrl is provided.
                    const contentIsBlog = $f5f0a9f7a4b49836$var$isBlogUrl(originalUrl ?? currentUrl);
                    if (contentIsBlog) {
                        // Blogs use /blog/edit-v2/<id> because there is no /blog/edit-embed/ route,
                        // which would cause a redirect that strips native embed query params.
                        // Extract the content ID from either the blog URL or the resolved /pages/<id> URL.
                        const blogMatch = url.pathname.match(/\/blog\/(?:\d+\/\d+\/\d+\/)?(\d+)(?:\/[^/]*)?$/);
                        const pagesMatch = url.pathname.match(/\/pages\/(\d+)/);
                        const contentId = blogMatch?.[1] ?? pagesMatch?.[1];
                        if (contentId) // Replace the path portion after /spaces/<key>/ with /blog/edit-v2/<id>
                        url.pathname = url.pathname.replace(/\/spaces\/([^/]+)\/.*$/, `/spaces/$1/blog/edit-v2/${contentId}`);
                    } else // Pages use /pages/edit-embed/<id> (dedicated embedded editor route).
                    url.pathname = url.pathname.replace(/\/pages\/(\d+)/, '/pages/edit-embed/$1');
                    url.searchParams.set('initialAllowedFeatures', 'delete-draft');
                    return url.toString();
                },
                onSwitchToViewing: (currentUrl, _originalUrl)=>{
                    const url = new URL(currentUrl); // Reverse the edit URL transforms back to view URLs
                    url.pathname = url.pathname.replace(/\/pages\/edit-embed\/(\d+)/, '/pages/$1').replace(/\/blog\/edit-v2\/(\d+)/, '/blog/$1');
                    url.searchParams.delete('initialAllowedFeatures');
                    return url.toString();
                }
            }
        },
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                items: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
                    ...(0, $iDrrr.fg)('maui_remixable_page_native_embeds') ? [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).REMIX
                    ] : [],
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT,
                    ...(0, $iDrrr.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ],
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
                    ...(0, $iDrrr.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ]
                ],
                moreItems: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
                ]
            }),
        editorToolbarHandlers: {},
        renderLoadingComponent: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
                animationDisabled: props.animationDisabled,
                icons: $f5f0a9f7a4b49836$var$pageIcons,
                testId: props.testId
            }),
        resolveTitleIcon: $f5f0a9f7a4b49836$var$resolveTitleIcon,
        titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        appearance: 'overlay'
    }
};
module.exports["PageExperienceManifest"] = $f5f0a9f7a4b49836$export$f85d1a9111fa6dfc;

});

parcelRegister("8iBLq", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $8kONW = parcelRequire("8kONW");


var $kWSTb = parcelRequire("kWSTb");


var $fZ5ji = parcelRequire("fZ5ji");


var $bYNUA = parcelRequire("bYNUA");


var $cFvoT = parcelRequire("cFvoT");


var $k9wGn = parcelRequire("k9wGn");

var $ljOiP = parcelRequire("ljOiP");


var $iDrrr = parcelRequire("iDrrr");


var $anBbz = parcelRequire("anBbz");


var $iPlb2 = parcelRequire("iPlb2");


var $hjJUc = parcelRequire("hjJUc");


var $8fPlA = parcelRequire("8fPlA");

const $dc247be55b77c9b0$var$slideIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))),
    (0, (/*@__PURE__*/$parcel$interopDefault($bYNUA))),
    (0, (/*@__PURE__*/$parcel$interopDefault($cFvoT))),
    (0, (/*@__PURE__*/$parcel$interopDefault($fZ5ji)))
];
const $dc247be55b77c9b0$export$7f3e59c853b03788 = (0, $8fPlA.experienceManifestId)('slide'); /**
                                                                                                  * Experience manifest for a slide embed.
                                                                                                  * Register with getNativeEmbedFacade().registerExperience(SlideExperienceManifest)
                                                                                                  * to obtain a Experience for EmbedFrameUI.
                                                                                                  */ 
const $dc247be55b77c9b0$export$513ec3204bdf9ec = {
    id: $dc247be55b77c9b0$export$7f3e59c853b03788,
    handleChildCommands: (_experience, _cmd)=>{},
    isUrlMatch: (url)=>(0, $8kONW.isConfluenceSlideUrl)(url) && !(0, $iDrrr.fg)('cc-mui-slides-opted-out') && (0, $anBbz.expValEqualsNoExposure)('cc-mui-slides-experiment', 'isEnabled', true),
    supportedFeatures: new Set((0, $iPlb2.allNativeEmbedCoreFeatures)),
    queryParams: {
        disableCanvasScroll: 'true'
    },
    isActive: ()=>!(0, $iDrrr.fg)('cc-mui-slides-opted-out') && (0, $anBbz.expValEqualsNoExposure)('cc-mui-slides-experiment', 'isEnabled', true),
    // Slides have a 16:9 canvas; set the default embed dimensions to 16:10 with a little extra height cause it looks nicer.
    parameterDefaults: {
        width: 960,
        height: 600
    },
    uiConfig: {
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                items: [
                    // BUILTIN_TOOLBAR_KEYS.ASK_ROVO, // Removed until correct context from embed is provided https://product-fabric.atlassian.net/browse/CNS-29056
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
                    ...(0, $iDrrr.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ],
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
                    ...(0, $iDrrr.fg)('cc-maui-toolbar-separators-update') ? [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT_URL
                    ] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT_URL,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ]
                ],
                moreItems: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
                ]
            }),
        editorToolbarHandlers: {},
        renderLoadingComponent: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
                animationDisabled: props.animationDisabled,
                icons: $dc247be55b77c9b0$var$slideIcons,
                testId: props.testId
            }),
        titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))),
        appearance: 'overlay'
    }
};
module.exports["SlideExperienceManifest"] = $dc247be55b77c9b0$export$513ec3204bdf9ec;

});

parcelRegister("kWSTb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9feda705e9481f913d0df858359ce6d6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f403cd42107c74dc$var$_react = $f403cd42107c74dc$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f403cd42107c74dc$var$_iconNew = $f403cd42107c74dc$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $f403cd42107c74dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeSlides".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-generative-slides
 * Usage guidance:
 * Reserved for Confluence Slides
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f403cd42107c74dc$var$AiGenerativeSlidesIcon = (props)=>/*#__PURE__*/ $f403cd42107c74dc$var$_react.default.createElement($f403cd42107c74dc$var$_iconNew.default, Object.assign({
        name: "AiGenerativeSlidesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 10V3.5H0V2h8v1.5H2.5V10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5H15V10a2 2 0 0 1-2 2h-1.376l1.822 2.139-1.142.972L9.654 12H8.75v3h-1.5v-3h-.903l-2.65 3.111-1.143-.972L4.376 12H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M13.115.009a.75.75 0 0 1 .541.378l.05.106.4 1.102c.051.138.16.248.3.299l1.1.4a.75.75 0 0 1 0 1.411l-1.1.401a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.411 0l-.401-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.485-.59L10 3l.009-.116a.75.75 0 0 1 .484-.59l1.102-.4a.5.5 0 0 0 .299-.3l.4-1.1.05-.107A.75.75 0 0 1 12.999 0z"/>`
    }, props));
$f403cd42107c74dc$var$AiGenerativeSlidesIcon.displayName = 'AiGenerativeSlidesIcon';
var $f403cd42107c74dc$var$_default = module.exports.default = $f403cd42107c74dc$var$AiGenerativeSlidesIcon;

});

parcelRegister("fZ5ji", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cb7bb57bd8240848dd583248edb04670>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba30ac06fca117d5$var$_react = $ba30ac06fca117d5$var$_interopRequireDefault((parcelRequire("cozmU")));

var $ba30ac06fca117d5$var$_iconNew = $ba30ac06fca117d5$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $ba30ac06fca117d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoMiniplayer".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/video-miniplayer
 * Usage guidance:
 * Reserved for picture-in-picture functionality for videos.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ba30ac06fca117d5$var$VideoMiniplayerIcon = (props)=>/*#__PURE__*/ $ba30ac06fca117d5$var$_react.default.createElement($ba30ac06fca117d5$var$_iconNew.default, Object.assign({
        name: "VideoMiniplayerIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zm4.75 4a.75.75 0 0 1 .75-.75h4.75a.75.75 0 0 1 .75.75v2.75a.75.75 0 0 1-.75.75H7.5a.75.75 0 0 1-.75-.75z" clip-rule="evenodd"/>`
    }, props));
$ba30ac06fca117d5$var$VideoMiniplayerIcon.displayName = 'VideoMiniplayerIcon';
var $ba30ac06fca117d5$var$_default = module.exports.default = $ba30ac06fca117d5$var$VideoMiniplayerIcon;

});

parcelRegister("bYNUA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6aaf5db72242d392e688c8c721d1e0da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8b8c03b563f282f7$var$_react = $8b8c03b563f282f7$var$_interopRequireDefault((parcelRequire("cozmU")));

var $8b8c03b563f282f7$var$_iconNew = $8b8c03b563f282f7$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $8b8c03b563f282f7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPlayCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/video-play-circle
 * Usage guidance:
 * Known uses: play video in Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8b8c03b563f282f7$var$VideoPlayCircleIcon = (props)=>/*#__PURE__*/ $8b8c03b563f282f7$var$_react.default.createElement($8b8c03b563f282f7$var$_iconNew.default, Object.assign({
        name: "VideoPlayCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m5-2.694c0-.808.866-1.32 1.574-.931l4.958 2.722a1.062 1.062 0 0 1 0 1.862l-4.958 2.722A1.063 1.063 0 0 1 5 10.75zm1.5.74v3.965l3.611-1.983z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 10.01V6.046l3.611 1.983z"/>`
    }, props));
$8b8c03b563f282f7$var$VideoPlayCircleIcon.displayName = 'VideoPlayCircleIcon';
var $8b8c03b563f282f7$var$_default = module.exports.default = $8b8c03b563f282f7$var$VideoPlayCircleIcon;

});

parcelRegister("aaqIB", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $cXtTj = parcelRequire("cXtTj");


var $b5sDq = parcelRequire("b5sDq");


var $h5uPL = parcelRequire("h5uPL");


var $jxqsh = parcelRequire("jxqsh");


var $bDjVc = parcelRequire("bDjVc");


var $k9wGn = parcelRequire("k9wGn");

var $ljOiP = parcelRequire("ljOiP");


var $5FKld = parcelRequire("5FKld");


var $iDrrr = parcelRequire("iDrrr");


var $iPlb2 = parcelRequire("iPlb2");


var $hjJUc = parcelRequire("hjJUc");


var $1xINT = parcelRequire("1xINT");


var $8fPlA = parcelRequire("8fPlA");


var $7wdoX = parcelRequire("7wdoX");

const $af71dcb44dbd21c6$export$571bdd0f87630d48 = (0, $8fPlA.experienceManifestId)('whiteboard'); /**
                                                                                                            * Dynamic-config killswitch for sending `disableCanvasScroll` conditionally in
                                                                                                            * legacy full screen. Default `false` = change enabled (param omitted from the
                                                                                                            * legacy full-screen URL so the blown-up board scrolls); set to `true` to roll
                                                                                                            * back to the pre-EPS8-40 behavior (param sent everywhere).
                                                                                                            */ 
const $af71dcb44dbd21c6$var$LEGACY_FS_CANVAS_SCROLL_KILLSWITCH = 'platform_native_embed_legacy_fs_canvas_scroll';
const $af71dcb44dbd21c6$var$whiteboardIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b5sDq))),
    (0, (/*@__PURE__*/$parcel$interopDefault($jxqsh))),
    (0, (/*@__PURE__*/$parcel$interopDefault($h5uPL)))
];
const $af71dcb44dbd21c6$var$isWhiteboardUrl = (url)=>// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    url.match(RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>\\d+)(\\?\\/)?")) || url.match(RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})(\\?\\/)?")); /**
                                                                                                                                                                                                                                     * Experience manifest for a whiteboard embed.
                                                                                                                                                                                                                                     * Register with getNativeEmbedFacade().registerExperience(WhiteboardExperienceManifest)
                                                                                                                                                                                                                                     * to obtain a Experience for EmbedFrameUI.
                                                                                                                                                                                                                                     */ 
const $af71dcb44dbd21c6$export$257420b954ccf94c = {
    id: $af71dcb44dbd21c6$export$571bdd0f87630d48,
    handleChildCommands: (_experience, cmd)=>{
        switch(cmd.type){
            case (0, $7wdoX.NativeEmbedChildCommandType).FreezeFrameResponse:
                break;
            case (0, $7wdoX.NativeEmbedChildCommandType).UnfreezeFrameResponse:
                break;
        }
    },
    isUrlMatch: $af71dcb44dbd21c6$var$isWhiteboardUrl,
    supportedFeatures: new Set([
        ...(0, $iPlb2.allNativeEmbedCoreFeatures),
        (0, $5FKld.WHITEBOARD_VIEWPORT_ALIGNMENT_FEATURE)
    ]),
    // Thunk so the killswitch is read at URL-build time (after Statsig init), and
    // so the conditional behavior is gated at its source: when rolled back the
    // manifest emits the pre-EPS8-40 plain-string value, which `resolveQueryParams`
    // passes through unchanged at every build site.
    //
    // `disableCanvasScroll` is correct inline (and in shared-iframe full screen,
    // which reuses the inline URL) but makes the blown-up board feel broken in the
    // legacy full-screen iframe, so by default it is omitted from that build site
    // only. `hideCursors` applies everywhere (plain string === appliesTo: 'always').
    queryParams: ()=>{
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const rolledBack = (0, $cXtTj.default).getExperimentValue($af71dcb44dbd21c6$var$LEGACY_FS_CANVAS_SCROLL_KILLSWITCH, 'value', false);
        return rolledBack ? {
            disableCanvasScroll: 'true',
            hideCursors: 'true'
        } : {
            disableCanvasScroll: {
                value: 'true',
                appliesTo: 'exceptLegacyFullscreen'
            },
            hideCursors: 'true'
        };
    },
    transformUrl: (url, isFullScreen)=>{
        const urlObj = new URL(url);
        if (!isFullScreen) urlObj.searchParams.set('hideBorder', 'true');
         // this is used to identify the native embed view in the whiteboard app
        urlObj.searchParams.set('nativeEmbedView', 'true');
        const initialTheme = (0, $1xINT.getInitialThemeParam)();
        if (initialTheme) urlObj.searchParams.set('themeState', initialTheme);
        return urlObj.toString();
    },
    isActive: ()=>{
        return true;
    },
    uiConfig: {
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                items: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT,
                    ...(0, $iDrrr.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ],
                    // BUILTIN_TOOLBAR_KEYS.BORDER, // Border option is yet to be implemented.
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
                    ...(0, $iDrrr.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ]
                ],
                moreItems: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
                ]
            }),
        editorToolbarHandlers: {},
        renderLoadingComponent: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
                animationDisabled: props.animationDisabled,
                icons: $af71dcb44dbd21c6$var$whiteboardIcons,
                testId: props.testId
            }),
        titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        appearance: 'overlay',
        waitForContentReady: true
    }
};
module.exports["WhiteboardExperienceManifest"] = $af71dcb44dbd21c6$export$257420b954ccf94c;

});

parcelRegister("7wdoX", function(module, exports) {
var $3d7fb527228d62f2$export$e02855afa78b2d37 = /*#__PURE__*/ function(NativeEmbedCommandType) {
    NativeEmbedCommandType["FreezeFrameRequest"] = "freezeFrameRequest";
    NativeEmbedCommandType["UnfreezeFrame"] = "unfreezeFrame";
    return NativeEmbedCommandType;
}({});
var $3d7fb527228d62f2$export$f17561b95ea7b258 = /*#__PURE__*/ function(NativeEmbedChildCommandType) {
    NativeEmbedChildCommandType["FreezeFrameResponse"] = "freezeFrameResponse";
    NativeEmbedChildCommandType["UnfreezeFrameResponse"] = "unfreezeFrameResponse";
    return NativeEmbedChildCommandType;
}({});
module.exports["NativeEmbedChildCommandType"] = $3d7fb527228d62f2$export$f17561b95ea7b258;

});

parcelRegister("4vjt0", function(module, exports) {

let $3479286416731d73$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3479286416731d73$var$load("6wr18"),
    $3479286416731d73$var$load("3evar"),
    $3479286416731d73$var$load("9njOW"),
    $3479286416731d73$var$load("k8nz9"),
    $3479286416731d73$var$load("7EorR"),
    $3479286416731d73$var$load("ffEVr"),
    $3479286416731d73$var$load("bY4kf")
]).then(()=>parcelRequire('htIUR'));

});

parcelRegister("erHVE", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $786700e92aa2b215$export$31b2b7ff910ba1f3 = new (0, $kCECX.PluginKey)('editorToolbarPluginKey');
module.exports["editorToolbarPluginKey"] = $786700e92aa2b215$export$31b2b7ff910ba1f3;

});

parcelRegister("8bRAb", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $dWfVs = parcelRequire("dWfVs");


var $aJNFh = parcelRequire("aJNFh");


var $2TWQD = parcelRequire("2TWQD");

async function $22de9e431e2baedb$export$af16a73460e35e28(cloudId, config) {
    const allSkills = await (0, $aJNFh.fetchSkills)(cloudId);
    const filteredSkills = (0, $2TWQD.filterSkills)(allSkills, config);
    return (0, $dWfVs.buildSkillsManifest)(filteredSkills, {
        // Skills should appear below native editor elements in the slash menu.
        // A high priority value (lower importance) ensures native items rank
        // higher when search scores are equal. Skills are identified by their
        // extensionType property (set by buildMenuItem for all extension items)
        // in the reranker at
        // platform/packages/editor/editor-common/src/quick-insert/boost-native-results-above-skills.ts
        priority: config.priority ?? 9000,
        onAction: (skill)=>{
            config.onAnalyticsEvent?.({
                action: (0, $krYZG.ACTION).INSERTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TYPEAHEAD,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TYPEAHEAD_QUICK_INSERT,
                attributes: {
                    skillSlug: skill.slug,
                    skillName: skill.name,
                    isAiSkill: true
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            });
            return config.onSkillSelected?.(`/${skill.slug}`, skill);
        }
    });
}
module.exports["createRovoSkillsExtensionManifest"] = $22de9e431e2baedb$export$af16a73460e35e28;

});

parcelRegister("dWfVs", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $8lhhf = parcelRequire("8lhhf");


var $9OqBj = parcelRequire("9OqBj");


var $9MCKh = parcelRequire("9MCKh");

const $ad58f4ad7597918e$var$DEFAULT_CATEGORY = 'AI';
const $ad58f4ad7597918e$var$MAX_DESCRIPTION_LENGTH = 150;
/**
 * Truncate description to a maximum length.
 * Used to keep insert menu items readable when skill descriptions are long.
 */ function $ad58f4ad7597918e$var$truncateDescription(description) {
    if (description.length <= $ad58f4ad7597918e$var$MAX_DESCRIPTION_LENGTH) return description;
    return description.slice(0, $ad58f4ad7597918e$var$MAX_DESCRIPTION_LENGTH).trim() + "\u2026";
}
/**
 * Returns the skill-specific icon with its configured color.
 * Falls back to the default skill icon if no match is found.
 */ const $ad58f4ad7597918e$var$getSkillIcon = (skill)=>{
    const iconName = skill.iconName;
    const loadIcon = iconName && (0, $9MCKh.skillIcon)[iconName] ? (0, $9MCKh.skillIcon)[iconName] : (0, $9MCKh.defaultIcon);
    const iconColor = (0, $9OqBj.getIconColor)(skill.color);
    return async ()=>{
        const { default: Icon } = await loadIcon();
        const IconComponent = Icon;
        const ColoredSkillIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
            const $ = (0, $bDgLe.c)(2);
            let t0;
            if ($[0] !== props) {
                t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
                    ...props,
                    color: iconColor
                });
                $[0] = props;
                $[1] = t0;
            } else t0 = $[1];
            return t0;
        } : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
                ...props,
                color: iconColor
            });
        return {
            default: ColoredSkillIcon
        };
    };
};
function $ad58f4ad7597918e$export$d76981760c7a9606(skills, options = {}) {
    const { onAction: onAction, categories: categories = [
        $ad58f4ad7597918e$var$DEFAULT_CATEGORY
    ], priority: priority, getLozenge: getLozenge, nodes: nodes } = options;
    const quickInsertModules = skills.map((skill)=>{
        const keywords = [
            skill.slug,
            skill.product,
            skill.name,
            'skill',
            'skills'
        ].filter((k)=>typeof k === 'string' && k.length > 0);
        return {
            key: skill.slug,
            title: skill.name,
            description: $ad58f4ad7597918e$var$truncateDescription(skill.helpText ?? skill.description ?? ''),
            keywords: keywords,
            categories: categories,
            ...priority !== undefined && {
                priority: priority
            },
            icon: $ad58f4ad7597918e$var$getSkillIcon(skill),
            ...getLozenge && {
                lozenge: getLozenge(skill)
            },
            action: async ()=>onAction?.(skill)
        };
    });
    return {
        title: 'Rovo Skills',
        description: 'AI-powered skills from Rovo',
        type: (0, $8lhhf.ROVO_SKILL_EXTENSION_TYPE),
        key: (0, $8lhhf.ROVO_SKILL_EXTENSION_KEY),
        icons: {
            '16': (0, $9MCKh.defaultIcon),
            '24': (0, $9MCKh.defaultIcon),
            '48': (0, $9MCKh.defaultIcon)
        },
        modules: {
            quickInsert: quickInsertModules,
            ...nodes && {
                nodes: nodes
            }
        }
    };
}
module.exports["buildSkillsManifest"] = $ad58f4ad7597918e$export$d76981760c7a9606;

});

parcelRegister("8lhhf", function(module, exports) {
const $57d7e56ed333ab64$export$d0e832101df0ac96 = 'com.atlassian.rovo.skill';
const $57d7e56ed333ab64$export$d4f002c79ea2ad20 = 'skill';
const $57d7e56ed333ab64$export$e4d0b30afd49f7df = 'skillTag';
const $57d7e56ed333ab64$export$18f911e214c46d8 = /\/([a-zA-Z0-9-]+)/g;
const $57d7e56ed333ab64$export$aae1b80712c1b67b = `${$57d7e56ed333ab64$export$d4f002c79ea2ad20}:${$57d7e56ed333ab64$export$e4d0b30afd49f7df}`;
const $57d7e56ed333ab64$export$b22d8560058c60e1 = (extensionType, extensionKey)=>{
    return extensionType === $57d7e56ed333ab64$export$d0e832101df0ac96 && extensionKey === $57d7e56ed333ab64$export$aae1b80712c1b67b;
};
const $57d7e56ed333ab64$export$f88fd0c0ee7d509a = (skill)=>{
    return [
        {
            type: 'inlineExtension',
            attrs: {
                extensionKey: $57d7e56ed333ab64$export$aae1b80712c1b67b,
                extensionType: $57d7e56ed333ab64$export$d0e832101df0ac96,
                parameters: skill
            }
        },
        // render an empty space after the skill tag
        {
            type: 'text',
            text: ' '
        }
    ];
};
const $57d7e56ed333ab64$export$a425ebfe740d9932 = (skill)=>({
        type: 'doc',
        version: 1,
        content: [
            {
                type: 'paragraph',
                content: $57d7e56ed333ab64$export$f88fd0c0ee7d509a(skill)
            }
        ]
    });
module.exports["ROVO_SKILL_EXTENSION_TYPE"] = $57d7e56ed333ab64$export$d0e832101df0ac96;
module.exports["ROVO_SKILL_EXTENSION_KEY"] = $57d7e56ed333ab64$export$d4f002c79ea2ad20;
module.exports["ROVO_SKILL_TAG_PATTERN"] = $57d7e56ed333ab64$export$18f911e214c46d8;
module.exports["ROVO_SKILL_COMBINED_EXTENSION_KEY"] = $57d7e56ed333ab64$export$aae1b80712c1b67b;
module.exports["isSkillTagExtension"] = $57d7e56ed333ab64$export$b22d8560058c60e1;
module.exports["createSkillNode"] = $57d7e56ed333ab64$export$f88fd0c0ee7d509a;
module.exports["createSkillAdf"] = $57d7e56ed333ab64$export$a425ebfe740d9932;

});

parcelRegister("9OqBj", function(module, exports) {
const $e3eab036398f830e$export$3056677f7f7d8f5d = {
    LIME: {
        default: "var(--ds-border-accent-lime, #6A9A23)",
        icon: "var(--ds-icon-accent-lime, #6A9A23)"
    },
    RED: {
        default: "var(--ds-border-accent-red, #E2483D)",
        icon: "var(--ds-icon-accent-red, #C9372C)"
    },
    ORANGE: {
        default: "var(--ds-border-accent-orange, #E06C00)",
        icon: "var(--ds-icon-accent-orange, #E06C00)"
    },
    YELLOW: {
        default: "var(--ds-border-accent-yellow, #B38600)",
        icon: "var(--ds-icon-accent-yellow, #B38600)"
    },
    GREEN: {
        default: "var(--ds-border-accent-green, #22A06B)",
        icon: "var(--ds-icon-accent-green, #22A06B)"
    },
    TEAL: {
        default: "var(--ds-border-accent-teal, #2898BD)",
        icon: "var(--ds-icon-accent-teal, #2898BD)"
    },
    BLUE: {
        default: "var(--ds-border-accent-blue, #357DE8)",
        icon: "var(--ds-icon-accent-blue, #357DE8)"
    },
    PURPLE: {
        default: "var(--ds-border-accent-purple, #AF59E1)",
        icon: "var(--ds-icon-accent-purple, #AF59E1)"
    },
    MAGENTA: {
        default: "var(--ds-border-accent-magenta, #CD519D)",
        icon: "var(--ds-icon-accent-magenta, #CD519D)"
    },
    GRAY: {
        default: "var(--ds-border-accent-gray, #7D818A)",
        icon: "var(--ds-icon-accent-gray, #7D818A)"
    },
    DEFAULT: {
        default: "var(--ds-border, #0B120E24)",
        inverse: "var(--ds-border-inverse, #FFFFFF)",
        icon: "var(--ds-icon-subtle, #505258)"
    }
};
const $e3eab036398f830e$export$dbc6cfecd630bcea = (color, invertColors)=>{
    if (color) {
        const colorObject = $e3eab036398f830e$export$3056677f7f7d8f5d[color];
        const colorType = invertColors ? 'inverse' : 'default';
        return colorObject?.[colorType] ?? colorObject?.default ?? "var(--ds-border, #0B120E24)";
    }
    return invertColors ? "var(--ds-border-inverse, #FFFFFF)" : "var(--ds-border, #0B120E24)";
};
const $e3eab036398f830e$export$bb417e0702eb86b5 = (color, invertColors)=>{
    if (color) {
        const colorObject = $e3eab036398f830e$export$3056677f7f7d8f5d[color];
        if (invertColors && color === 'DEFAULT') return "var(--ds-icon-inverse, #FFFFFF)";
        return colorObject?.icon ?? "var(--ds-icon-subtle, #505258)";
    }
    return invertColors ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon-subtle, #505258)";
};
module.exports["SKILL_COLOR_MAP"] = $e3eab036398f830e$export$3056677f7f7d8f5d;
module.exports["getBorderColor"] = $e3eab036398f830e$export$dbc6cfecd630bcea;
module.exports["getIconColor"] = $e3eab036398f830e$export$bb417e0702eb86b5;

});

parcelRegister("9MCKh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");






































const $d0265bb51b10f57e$export$dce8bc0f04f0d915 = {
    skill: ()=>(parcelRequire("d7YwR")),
    assets: ()=>Promise.resolve((parcelRequire("437ur"))),
    add: ()=>Promise.resolve((parcelRequire("gFEZF"))),
    'chart-bar-line': ()=>(parcelRequire("kU1Yt")),
    'ai-generative-text': ()=>(parcelRequire("44fpQ")),
    'work-item': ()=>Promise.resolve((parcelRequire("iRFKG"))),
    'lock-locked': ()=>Promise.resolve((parcelRequire("4efpo"))),
    'chart-pie': ()=>(parcelRequire("e8Ghu")),
    plan: ()=>(parcelRequire("fhtzK")),
    settings: ()=>Promise.resolve((parcelRequire("11OF7"))),
    'project-status': ()=>(parcelRequire("duNV8")),
    'merge-success': ()=>(parcelRequire("3pUsI")),
    'person-add': ()=>(parcelRequire("1ORsb")),
    'people-group': ()=>Promise.resolve((parcelRequire("fBqzD"))),
    'person-added': ()=>(parcelRequire("1VVw9")),
    login: ()=>(parcelRequire("lp0Ka")),
    'ai-generative-text-summary': ()=>Promise.resolve((parcelRequire("f0b2F"))),
    transition: ()=>(parcelRequire("lPrvY")),
    board: ()=>Promise.resolve((parcelRequire("4MdqE"))),
    release: ()=>Promise.resolve((parcelRequire("2F2yY"))),
    'app-switcher': ()=>(parcelRequire("gfpxd")),
    search: ()=>Promise.resolve((parcelRequire("hAgam"))),
    'playlist-add': ()=>(parcelRequire("lJQ5X")),
    'playlist-remove': ()=>(parcelRequire("bYXrx")),
    summary: ()=>Promise.resolve((parcelRequire("f0b2F"))),
    clock: ()=>Promise.resolve((parcelRequire("5ZtfK"))),
    'ai-generative-chapters': ()=>(parcelRequire("62FON")),
    talent: ()=>(parcelRequire("j74pS")),
    incident: ()=>Promise.resolve((parcelRequire("ipvL3"))),
    form: ()=>(parcelRequire("e3rWd")),
    ticket: ()=>(parcelRequire("fS7mD")),
    alert: ()=>(parcelRequire("hBRNG")),
    pulse: ()=>(parcelRequire("4SYP6")),
    'text-lengthen': ()=>(parcelRequire("4Rd0H")),
    'ai-generative-cleanup': ()=>(parcelRequire("ivYfD")),
    survey: ()=>(parcelRequire("eNJEs")),
    'text-review': ()=>(parcelRequire("9ImZK"))
};
const $d0265bb51b10f57e$export$ca2f546e21dcce87 = $d0265bb51b10f57e$export$dce8bc0f04f0d915.skill;
const $d0265bb51b10f57e$export$f7883dcc9f65479a = Object.fromEntries(Object.entries($d0265bb51b10f57e$export$dce8bc0f04f0d915).map(([key, loader])=>[
        key,
        (0, $cozmU.lazy)(loader)
    ]));
const $d0265bb51b10f57e$export$78596fa6083c04d1 = $d0265bb51b10f57e$export$f7883dcc9f65479a.skill;
module.exports["skillIcon"] = $d0265bb51b10f57e$export$dce8bc0f04f0d915;
module.exports["defaultIcon"] = $d0265bb51b10f57e$export$ca2f546e21dcce87;
module.exports["skillIconMap"] = $d0265bb51b10f57e$export$f7883dcc9f65479a;
module.exports["DefaultSkillIcon"] = $d0265bb51b10f57e$export$78596fa6083c04d1;

});

parcelRegister("d7YwR", function(module, exports) {

let $98eae1a14b896567$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $98eae1a14b896567$var$load("ji2ex").then(()=>parcelRequire('h5LaW'));

});

parcelRegister("kU1Yt", function(module, exports) {

let $f37a91b0c5a24fd5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f37a91b0c5a24fd5$var$load("hrkGn").then(()=>parcelRequire('5kuIA'));

});

parcelRegister("44fpQ", function(module, exports) {

let $2f637e6c42f731d0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2f637e6c42f731d0$var$load("5k22f").then(()=>parcelRequire('9V507'));

});

parcelRegister("e8Ghu", function(module, exports) {

let $a4b29c33d05c1a9b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a4b29c33d05c1a9b$var$load("c6nMJ").then(()=>parcelRequire('eVhjN'));

});

parcelRegister("fhtzK", function(module, exports) {

let $b1ff629eca57471a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b1ff629eca57471a$var$load("i1I18").then(()=>parcelRequire('dIT3V'));

});

parcelRegister("duNV8", function(module, exports) {

let $9d34ccdd49f0003a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9d34ccdd49f0003a$var$load("bSZcP").then(()=>parcelRequire('6fcYF'));

});

parcelRegister("3pUsI", function(module, exports) {

let $27cf81197ca52259$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $27cf81197ca52259$var$load("3GLMP").then(()=>parcelRequire('bAdTB'));

});

parcelRegister("1ORsb", function(module, exports) {

let $1533ecb52c97b893$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1533ecb52c97b893$var$load("kBatH").then(()=>parcelRequire('am3XR'));

});

parcelRegister("1VVw9", function(module, exports) {

let $1687bb1e68c06fb7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1687bb1e68c06fb7$var$load("iN26T").then(()=>parcelRequire('4s4Os'));

});

parcelRegister("lp0Ka", function(module, exports) {

let $f94c827133a4a8ea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f94c827133a4a8ea$var$load("85Ack").then(()=>parcelRequire('hPGQU'));

});

parcelRegister("lPrvY", function(module, exports) {

let $fe43b4375d61c3d3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fe43b4375d61c3d3$var$load("jjuzw").then(()=>parcelRequire('iJGPY'));

});

parcelRegister("gfpxd", function(module, exports) {

let $bd41dab43722c8d5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bd41dab43722c8d5$var$load("dnVmf").then(()=>parcelRequire('9ib3C'));

});

parcelRegister("lJQ5X", function(module, exports) {

let $fd3635f2e5aabac0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fd3635f2e5aabac0$var$load("glmO2").then(()=>parcelRequire('3yAls'));

});

parcelRegister("bYXrx", function(module, exports) {

let $8b93687e70d55260$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8b93687e70d55260$var$load("32NHR").then(()=>parcelRequire('e3DmL'));

});

parcelRegister("62FON", function(module, exports) {

let $46635e3aa0f21791$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $46635e3aa0f21791$var$load("8GFi1").then(()=>parcelRequire('dQeg1'));

});

parcelRegister("j74pS", function(module, exports) {

let $dea218c262683901$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dea218c262683901$var$load("iWYx4").then(()=>parcelRequire('f1G8J'));

});

parcelRegister("e3rWd", function(module, exports) {

let $a3b7046b3b58e574$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a3b7046b3b58e574$var$load("cXTJH").then(()=>parcelRequire('bFnmR'));

});

parcelRegister("fS7mD", function(module, exports) {

let $b8e19c809ca15790$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b8e19c809ca15790$var$load("kMmm1").then(()=>parcelRequire('2ZUqo'));

});

parcelRegister("hBRNG", function(module, exports) {

let $cd1f9ffc4306ed9a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cd1f9ffc4306ed9a$var$load("k25pB").then(()=>parcelRequire('QrYx2'));

});

parcelRegister("4SYP6", function(module, exports) {

let $38eb62ceae487952$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $38eb62ceae487952$var$load("aWKP7").then(()=>parcelRequire('dK3CB'));

});

parcelRegister("4Rd0H", function(module, exports) {

let $3896343509561fa9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3896343509561fa9$var$load("kfhZM").then(()=>parcelRequire('2xJ2w'));

});

parcelRegister("ivYfD", function(module, exports) {

let $d7a9dbdfd2c52ad4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d7a9dbdfd2c52ad4$var$load("2bJoN").then(()=>parcelRequire('7Jde4'));

});

parcelRegister("eNJEs", function(module, exports) {

let $ac690dbfdd63bd67$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ac690dbfdd63bd67$var$load("bGOwY").then(()=>parcelRequire('2WCju'));

});

parcelRegister("9ImZK", function(module, exports) {

let $712a0f72ca3115b0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $712a0f72ca3115b0$var$load("k6TzV").then(()=>parcelRequire('4u3xL'));

});

parcelRegister("aJNFh", function(module, exports) {

var $f6VI9 = parcelRequire("f6VI9");

const $71f78acdff7635c4$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
/**
 * Unified GraphQL query — convoai_availableSkills.
 */ const $71f78acdff7635c4$var$UNIFIED_SKILLS_QUERY = `
  query ConvoAiAvailableSkillsQuery(
    $first: Int
    $cloudId: ID!
  ) {
    convoai_availableSkills(
      first: $first
      cloudId: $cloudId
    )
    @optIn(to: "ConvoAiAvailableSkills")
    {
      edges {
        node {
          __typename
          ... on ConvoAiSkill {
            id
            name
            description
            displayName
            slashCommand
						helpText
            iconUrl
            iconKey
            color
            source
            tags
            category
            integrationKeys
          }
        }
      }
      errors {
        message
      }
    }
  }
`;
/**
 * Session-level cache for fetched skills.
 * Keyed by `${cloudId}` to avoid redundant network requests.
 * Skills are cached for the lifetime of the page (matching Relay store behavior).
 * A page refresh will fetch fresh data.
 */ const $71f78acdff7635c4$var$skillsCache = new Map();
function $71f78acdff7635c4$export$e6cf70cf6554c856() {
    $71f78acdff7635c4$var$skillsCache.clear();
}
/**
 * Fetch skills using the new unified convoai_availableSkills endpoint.
 */ async function $71f78acdff7635c4$var$fetchSkillsUnified(cloudId) {
    const response = await fetch($71f78acdff7635c4$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({
            query: $71f78acdff7635c4$var$UNIFIED_SKILLS_QUERY,
            variables: {
                cloudId: cloudId,
                first: 150
            }
        })
    });
    if (!response.ok) return [];
    const json = await response.json();
    if (json.errors?.length || json.data?.convoai_availableSkills?.errors?.length) return [];
    const edges = json.data?.convoai_availableSkills?.edges;
    return (0, $f6VI9.parseConvoAiSkillEdges)(edges);
}
async function $71f78acdff7635c4$export$268d57ae88e7df66(cloudId) {
    const cacheKey = cloudId;
    const cached = $71f78acdff7635c4$var$skillsCache.get(cacheKey);
    if (cached) return cached;
    try {
        const skills = await $71f78acdff7635c4$var$fetchSkillsUnified(cloudId);
        $71f78acdff7635c4$var$skillsCache.set(cacheKey, skills);
        return skills;
    } catch  {
        // Silently fail — the insert menu will just not show skills
        return [];
    }
}
module.exports["clearSkillsCache"] = $71f78acdff7635c4$export$e6cf70cf6554c856;
module.exports["fetchSkills"] = $71f78acdff7635c4$export$268d57ae88e7df66;

});

parcelRegister("f6VI9", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $ae2233479ab8cd62$var$ROVO_SPACE_ALLOWED_STRATUS_SKILL_NAMES = new Set([
    'WorkItemWorkflowContextMinion',
    'JiraWorkItemCreateMinion',
    'JiraPermissionsSkill',
    'JiraNavigationMinion'
]);
/**
 * Rovo Space conversations support Anthropic skills plus a small set of
 * Stratus skills that provide the Jira capabilities required in that context.
 */ function $ae2233479ab8cd62$var$isSkillAllowedInRovoSpace(node) {
    return node.source === 'ANTHROPIC' || node.source === 'STRATUS' && Boolean(node.name && $ae2233479ab8cd62$var$ROVO_SPACE_ALLOWED_STRATUS_SKILL_NAMES.has(node.name));
}
function $ae2233479ab8cd62$export$db36004670a5626e(node) {
    return node?.__typename === 'GraphIntegrationSkillDirectoryItem';
}
function $ae2233479ab8cd62$export$7d1ba2a7b9e1a07(node) {
    return node?.__typename === 'ConvoAiSkill';
}
function $ae2233479ab8cd62$export$74ea09dd5afceb60(node) {
    if (!node || node.__typename !== 'GraphIntegrationSkillDirectoryItem') return null;
    const displayName = node.integrationKey?.displayName ?? '';
    const tagDisplayNames = node.tags?.map((t)=>t.displayName) ?? [];
    const trimmedDescription = node.description && node.description?.length > 150 ? `${node.description?.slice(0, 147)}...` : node.description ?? '';
    return {
        id: node.id,
        slug: node.slashCommand?.split('/')?.[1] ?? '',
        name: node.name ?? '',
        description: trimmedDescription,
        iconName: node.iconUrl?.split('name/')?.[1],
        product: displayName ? displayName.charAt(0).toUpperCase() + displayName.slice(1) : '',
        productIconUrl: node.integrationKey?.iconUrl ?? '',
        ...node.color ? {
            color: node.color
        } : {},
        ...tagDisplayNames.length > 0 ? {
            tags: [
                ...tagDisplayNames
            ]
        } : {}
    };
}
function $ae2233479ab8cd62$export$fd76a94f4a001a14(node) {
    if (!node || node.__typename !== 'ConvoAiSkill') return null;
    const primaryIntegration = node.integrations?.[0];
    let productDisplayName = '';
    let productIconUrl = '';
    // If the skill has integrations, else use the legacy integrationKeys.
    if (primaryIntegration) {
        productDisplayName = primaryIntegration.displayName ?? '';
        productIconUrl = primaryIntegration.iconUrl ?? '';
    } else {
        const product = node.integrationKeys?.[0] ?? '';
        productDisplayName = product ? product.charAt(0).toUpperCase() + product.slice(1) : '';
    }
    return {
        id: node.id,
        slug: node.slashCommand?.split('/')?.[1] || ((0, $iDrrr.fg)('rovo_skill_tag_label_wrapping') ? node.name : '') || '',
        name: node.displayName ?? node.name ?? '',
        description: node.helpText ?? node.description ?? '',
        iconName: node.iconKey || node.iconUrl?.split('name/')?.[1],
        product: productDisplayName,
        productIconUrl: productIconUrl,
        ...node.color ? {
            color: node.color
        } : {},
        ...node.tags && node.tags.length > 0 ? {
            tags: [
                ...node.tags
            ]
        } : {}
    };
}
function $ae2233479ab8cd62$export$2cffb029ea623d71(edges) {
    if (!edges) return [];
    return edges.map((edge)=>$ae2233479ab8cd62$export$db36004670a5626e(edge?.node) ? $ae2233479ab8cd62$export$74ea09dd5afceb60(edge.node) : null).filter((skill)=>skill !== null);
}
function $ae2233479ab8cd62$export$554aac7da67453f5(edges) {
    if (!edges) return [];
    return edges.map((edge)=>$ae2233479ab8cd62$export$7d1ba2a7b9e1a07(edge?.node) ? $ae2233479ab8cd62$export$fd76a94f4a001a14(edge.node) : null).filter((skill)=>skill !== null);
}
function $ae2233479ab8cd62$export$faef8b68e529d4a7(edges, options = {}) {
    if (!edges) return [];
    return edges.map((edge)=>{
        const node = edge?.node;
        if (!node || !node.__typename) return null;
        // Route to appropriate parser based on typename
        if ($ae2233479ab8cd62$export$db36004670a5626e(node)) {
            // Legacy directory items do not expose the source needed to establish
            // eligibility for a Rovo Space conversation.
            if (options.restrictToRovoSpaceSkills) return null;
            return $ae2233479ab8cd62$export$74ea09dd5afceb60(node);
        }
        if ($ae2233479ab8cd62$export$7d1ba2a7b9e1a07(node)) {
            if (options.restrictToRovoSpaceSkills && !$ae2233479ab8cd62$var$isSkillAllowedInRovoSpace(node)) return null;
            return $ae2233479ab8cd62$export$fd76a94f4a001a14(node);
        }
        return null;
    }).filter((skill)=>skill !== null);
}
module.exports["parseSkillNode"] = $ae2233479ab8cd62$export$74ea09dd5afceb60;
module.exports["parseConvoAiSkillEdges"] = $ae2233479ab8cd62$export$554aac7da67453f5;
module.exports["parseUniversalSkillEdges"] = $ae2233479ab8cd62$export$faef8b68e529d4a7;

});

parcelRegister("2TWQD", function(module, exports) {
function $e8e957862ffce1cf$export$757808344f89f413(skills, config) {
    if (config.showAllSkills) return skills;
    const allowedSlugs = config.allowedSkills ?? [];
    if (allowedSlugs.length === 0) return [];
    const skillsBySlug = new Map(skills.map((skill)=>[
            skill.slug,
            skill
        ]));
    return allowedSlugs.map((slug)=>skillsBySlug.get(slug)).filter((skill)=>skill !== undefined);
}
module.exports["filterSkills"] = $e8e957862ffce1cf$export$757808344f89f413;

});

parcelRegister("9cGsb", function(module, exports) {
"use strict";
var $6b362a72760d8152$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
function $6b362a72760d8152$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bAWmc = parcelRequire("bAWmc");


$6b362a72760d8152$var$__export((parcelRequire("5ixmT")));
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ var $6b362a72760d8152$var$InvalidAriError = /** @class */ function(_super) {
    $6b362a72760d8152$var$__extends(InvalidAriError, _super);
    /**
   * Construct an InvalidAriError given an error message
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {string|undefined} description - The error message
   */ function InvalidAriError(ariString, description) {
        var _this = _super.call(this, "Invalid ari string: " + ariString + (description ? '. ' + description : '')) || this;
        _this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(_this, InvalidAriError.prototype);
        return _this;
    }
    /**
   * Construct an InvalidAriError given some constraint violations
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
   */ InvalidAriError.withConstraintViolations = function(ariString, violations) {
        return new InvalidAriError(ariString, violations.map(function(v) {
            return v.toString();
        }).join('\n'));
    };
    return InvalidAriError;
}(Error);
module.exports.InvalidAriError = $6b362a72760d8152$var$InvalidAriError;
function $6b362a72760d8152$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
var $6b362a72760d8152$var$basicCharConstraint = $bAWmc.pattern(/^[a-z][a-z.-]*$/);
var $6b362a72760d8152$var$resourceOwnerConstraints = [
    $bAWmc.lengthBetween(3, 255),
    $6b362a72760d8152$var$basicCharConstraint
];
var $6b362a72760d8152$var$resourceTypeConstraints = [
    $bAWmc.lengthBetween(3, 255),
    $6b362a72760d8152$var$basicCharConstraint
];
var $6b362a72760d8152$var$cloudIdConstraints = [
    $bAWmc.lengthBetween(36, 255)
];
var $6b362a72760d8152$var$siteResourceType = 'site';
var $6b362a72760d8152$var$resourceIdChars = /[\w-._~:@#]/.source;
var $6b362a72760d8152$var$resourceIdConstraints = [
    $bAWmc.pattern(new RegExp("^" + $6b362a72760d8152$var$resourceIdChars + "+(/" + $6b362a72760d8152$var$resourceIdChars + "*)*(;v=" + $6b362a72760d8152$var$resourceIdChars + "*)*$"))
];
/**
 * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
 * (like those for site wide ARIs) are upgraded to their latest form.
 */ function $6b362a72760d8152$var$upgrade(values) {
    var resourceId = values.resourceId, resourceOwner = values.resourceOwner, cloudId = values.cloudId;
    // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $6b362a72760d8152$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
var $6b362a72760d8152$var$ResourceIdentifier = /** @class */ function() {
    /**
   * Create a new Ari
   *
   * Only the resourceOwner is a required field, any other field can be omitted.
   * Older format types are converted on creation
   *
   * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
   * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
   * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
   * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
   *
   * @throws {InvalidAriError} if the provided segments fail to pass validation
   */ function ResourceIdentifier(values) {
        var _a = $6b362a72760d8152$var$upgrade(values), resourceId = _a.resourceId, resourceOwner = _a.resourceOwner, resourceType = _a.resourceType, cloudId = _a.cloudId;
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    Object.defineProperty(ResourceIdentifier.prototype, "cloudId", {
        get: function() {
            if (this.resourceType === $6b362a72760d8152$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
            return this.internalCloudId;
        },
        enumerable: true,
        configurable: true
    });
    /**
  * Parse a string as an Ari
  *
  * @param {string} ariString - the string to parse
  * @returns {Ari} the parsed ari
  * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
  */ ResourceIdentifier.parse = function(ariString) {
        if (!ariString) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        var match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        var terms = match.map(function(a) {
            return a && a.length > 0 ? a : undefined;
        });
        var resourceOwner = terms[1];
        if (!resourceOwner) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        return new ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    };
    ResourceIdentifier.parseEncoded = function(encodedAriString) {
        return $6b362a72760d8152$var$parse(decodeURIComponent(encodedAriString));
    };
    /**
   * Converts this Ari to a string.
   */ ResourceIdentifier.prototype.toString = function() {
        if (!this.ariString) {
            var resourceId = this.resourceType === $6b362a72760d8152$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            var resourceType = this.resourceType || '';
            var sanitizedCloudId = this.resourceType === $6b362a72760d8152$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = "ari:cloud:" + this.resourceOwner + ":" + sanitizedCloudId + ":" + resourceType + "/" + resourceId;
        }
        return this.ariString;
    };
    /**
   * Converts this object to its json representation
   */ ResourceIdentifier.prototype.toJSON = function() {
        return this.toString();
    };
    /**
   * Checks if this context is the same as another context
   *
   * @param {Ari} other - the other parameter to match with
   * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
   */ ResourceIdentifier.prototype.equals = function(other) {
        return other instanceof ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    };
    /**
   * This method checks if the current context contains the other context.
   *
   * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
   * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
   *
   * @param {Ari} other
   * @returns {boolean}
   */ ResourceIdentifier.prototype.contains = function(other) {
        return this.matches(new ResourceIdentifier(other));
    };
    /**
   * Checks if this context is the same as or contains the provided context.
   *
   * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
   *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
   *
   * e.g.
   * ```
   * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
   * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
   *
   * @param {Ari} other - the other parameter to match with
   * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
   */ ResourceIdentifier.prototype.matches = function(other) {
        return $6b362a72760d8152$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $6b362a72760d8152$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $6b362a72760d8152$var$siteResourceType && !!other.resourceType || $6b362a72760d8152$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $6b362a72760d8152$var$siteResourceType && !!other.resourceType || $6b362a72760d8152$var$matchesSegment(this.resourceId, other.resourceId));
    };
    ResourceIdentifier.prototype.validateSiteWide = function() {
        var _a = this, resourceType = _a.resourceType, cloudId = _a.cloudId;
        if (resourceType === $6b362a72760d8152$var$siteResourceType && !cloudId) return new $bAWmc.GeneralValidationError('site wide ARIs must have a cloudId');
    };
    ResourceIdentifier.prototype.validate = function() {
        var constraintViolations = [
            $bAWmc.validateField(this, 'resourceOwner', $6b362a72760d8152$var$resourceOwnerConstraints),
            $bAWmc.validateField(this, 'resourceType', $6b362a72760d8152$var$resourceTypeConstraints),
            $bAWmc.validateField(this, 'resourceId', $6b362a72760d8152$var$resourceIdConstraints),
            $bAWmc.validateField(this, 'cloudId', $6b362a72760d8152$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter(function(v) {
            return v;
        });
        if (constraintViolations.length > 0) throw $6b362a72760d8152$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $6b362a72760d8152$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    };
    ResourceIdentifier.prototype.urlEncode = function() {
        return encodeURIComponent(this.toString());
    };
    ResourceIdentifier.prototype.urlDecode = function() {
        return decodeURIComponent(this.toString());
    };
    return ResourceIdentifier;
}();
module.exports.ResourceIdentifier = $6b362a72760d8152$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $6b362a72760d8152$var$parse(ariString) {
    return $6b362a72760d8152$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $6b362a72760d8152$var$parse;
/**
 * Parse a URL encoded string as an Ari
 *
 * @param {string} encodedAriString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $6b362a72760d8152$var$parseEncoded(encodedAriString) {
    return $6b362a72760d8152$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $6b362a72760d8152$var$parseEncoded;

});

parcelRegister("bAWmc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $871053056dfd3da9$var$LengthConstraint = /** @class */ function() {
    function LengthConstraint(min, max) {
        this.min = min;
        this.max = max;
    }
    Object.defineProperty(LengthConstraint.prototype, "description", {
        get: function() {
            return "length must be between " + this.min + " and " + this.max;
        },
        enumerable: true,
        configurable: true
    });
    LengthConstraint.prototype.isValid = function(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    };
    return LengthConstraint;
}();
module.exports.LengthConstraint = $871053056dfd3da9$var$LengthConstraint;
var $871053056dfd3da9$var$RegexConstraint = /** @class */ function() {
    function RegexConstraint(regex) {
        this.regex = regex;
    }
    Object.defineProperty(RegexConstraint.prototype, "description", {
        get: function() {
            return "value must match regex " + this.regex.source;
        },
        enumerable: true,
        configurable: true
    });
    RegexConstraint.prototype.isValid = function(value) {
        return !value || this.regex.test(value);
    };
    return RegexConstraint;
}();
module.exports.RegexConstraint = $871053056dfd3da9$var$RegexConstraint;
var $871053056dfd3da9$var$GeneralValidationError = /** @class */ function() {
    function GeneralValidationError(error) {
        this.error = error;
    }
    GeneralValidationError.prototype.toString = function() {
        return this.error;
    };
    return GeneralValidationError;
}();
module.exports.GeneralValidationError = $871053056dfd3da9$var$GeneralValidationError;
var $871053056dfd3da9$var$ConstraintViolation = /** @class */ function() {
    function ConstraintViolation(fieldName, value, constraints) {
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    ConstraintViolation.prototype.toString = function() {
        var constraintSummary = this.constraints.map(function(c) {
            return "  - " + c.description;
        }).join('\n');
        return "'" + this.value + "' is not a valid value for " + this.fieldName + " as it violates the following constraints:\n" + constraintSummary;
    };
    return ConstraintViolation;
}();
module.exports.ConstraintViolation = $871053056dfd3da9$var$ConstraintViolation;
function $871053056dfd3da9$var$lengthBetween(min, max) {
    return new $871053056dfd3da9$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $871053056dfd3da9$var$lengthBetween;
function $871053056dfd3da9$var$pattern(regex) {
    return new $871053056dfd3da9$var$RegexConstraint(regex);
}
module.exports.pattern = $871053056dfd3da9$var$pattern;
function $871053056dfd3da9$var$validateField(object, fieldName, constraints) {
    var value = object[fieldName];
    var violatedConstraints = constraints.map(function(c) {
        return c.isValid(value) ? undefined : c;
    }).filter(function(c) {
        return c;
    });
    return violatedConstraints.length > 0 ? new $871053056dfd3da9$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $871053056dfd3da9$var$validateField;

});

parcelRegister("5ixmT", function(module, exports) {
"use strict";
var $3db8846e4ba8de9f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $199iK = parcelRequire("199iK");

var $3db8846e4ba8de9f$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($3db8846e4ba8de9f$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
var $3db8846e4ba8de9f$var$AppFamilyAriError = /** @class */ function(_super) {
    $3db8846e4ba8de9f$var$__extends(AppFamilyAriError, _super);
    function AppFamilyAriError(message, cause) {
        var _this = _super.call(this, message) || this;
        _this.cause = cause;
        return _this;
    }
    return AppFamilyAriError;
}(Error);
module.exports.AppFamilyAriError = $3db8846e4ba8de9f$var$AppFamilyAriError;
var $3db8846e4ba8de9f$var$NotAppFamilyAriError = /** @class */ function(_super) {
    $3db8846e4ba8de9f$var$__extends(NotAppFamilyAriError, _super);
    function NotAppFamilyAriError(ari, reason) {
        var _this = _super.call(this, "ari is not a valid App family ari: " + ari.toString() + " as " + reason) || this;
        _this.reason = reason;
        return _this;
    }
    return NotAppFamilyAriError;
}($3db8846e4ba8de9f$var$AppFamilyAriError);
module.exports.NotAppFamilyAriError = $3db8846e4ba8de9f$var$NotAppFamilyAriError;
var $3db8846e4ba8de9f$var$NotExpectedAppFamilyAriTypeError = /** @class */ function(_super) {
    $3db8846e4ba8de9f$var$__extends(NotExpectedAppFamilyAriTypeError, _super);
    function NotExpectedAppFamilyAriTypeError(type, ari, cause) {
        var _this = _super.call(this, "App family ari (" + ari.toString() + ") is not of expected type: " + type, cause) || this;
        _this.cause = cause;
        return _this;
    }
    return NotExpectedAppFamilyAriTypeError;
}($3db8846e4ba8de9f$var$AppFamilyAriError);
module.exports.NotExpectedAppFamilyAriTypeError = $3db8846e4ba8de9f$var$NotExpectedAppFamilyAriTypeError;
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */ function $3db8846e4ba8de9f$var$parseAppAri(ari) {
    return $199iK.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $3db8846e4ba8de9f$var$parseAppAri;
function $3db8846e4ba8de9f$var$createAppAri(json) {
    return new $199iK.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $3db8846e4ba8de9f$var$createAppAri;

});

parcelRegister("199iK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5ixmT = parcelRequire("5ixmT");


var $9cGsb = parcelRequire("9cGsb");

var $0d5dd8c916c95343$var$versionPrefix = ';v=';
var $0d5dd8c916c95343$var$AppFamilyAriImpl = /** @class */ function() {
    function AppFamilyAriImpl(json) {
        this.json = json;
    }
    Object.defineProperty(AppFamilyAriImpl.prototype, "appId", {
        get: function() {
            return this.json.appId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "environmentId", {
        get: function() {
            return this.json.environmentId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "version", {
        get: function() {
            return this.json.version;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionGroupId", {
        get: function() {
            return this.json.extensionGroupId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionKey", {
        get: function() {
            return this.json.extensionKey;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toJSON = function() {
        return this.json;
    };
    AppFamilyAriImpl.parse = function(ari) {
        var resourceOwner = ari.resourceOwner, resourceType = ari.resourceType, resourceId = ari.resourceId;
        if (resourceOwner !== $5ixmT.AppFamilyAri.resourceOwner) throw new $5ixmT.NotAppFamilyAriError(ari, "resourceOwner (" + resourceOwner + ") must be " + $5ixmT.AppFamilyAri.resourceOwner);
        if (!resourceType || $5ixmT.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $5ixmT.NotAppFamilyAriError(ari, "resourceType must be one of " + $5ixmT.AppFamilyAri.appFamilyResourceTypes);
        if (!resourceId) throw new $5ixmT.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        var versionIndex = resourceId.indexOf($0d5dd8c916c95343$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($0d5dd8c916c95343$var$versionPrefix) > versionIndex) throw new $5ixmT.NotAppFamilyAriError(ari, 'can only include one version suffix');
        var _a = resourceId.split($0d5dd8c916c95343$var$versionPrefix), mainResourceId = _a[0], version = _a[1];
        var segments = mainResourceId.split('/').map($0d5dd8c916c95343$var$stripToUndefined);
        if (segments.length > 4) throw new $5ixmT.NotAppFamilyAriError(ari, "no path segments can be added after extensionKey " + segments.slice(4));
        var _b = segments[0], appId = _b === void 0 ? undefined : _b, _c = segments[1], environmentId = _c === void 0 ? undefined : _c, _d = segments[2], providedExtensionGroupId = _d === void 0 ? undefined : _d, _e = segments[3], extensionKey = _e === void 0 ? undefined : _e;
        if (!appId) throw new $5ixmT.NotAppFamilyAriError(ari, 'appId must be included');
        var extensionGroupId = providedExtensionGroupId || (resourceType === $5ixmT.AppFamilyAri.extensionGroupResourceType || resourceType === $5ixmT.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $5ixmT.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId, extensionGroupId, extensionKey must all be provided for resourceType " + $5ixmT.AppFamilyAri.extensionResourceType);
        else if (resourceType === $5ixmT.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId, extensionGroupId must all be provided for resourceType " + $5ixmT.AppFamilyAri.extensionGroupResourceType);
        else if (resourceType === $5ixmT.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $5ixmT.AppFamilyAri.environmentResourceType);
        else if (resourceType === $5ixmT.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $5ixmT.AppFamilyAri.environmentResourceType);
        return new AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    };
    AppFamilyAriImpl.prototype.asAppAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppAri();
        }, 'app');
    };
    AppFamilyAriImpl.prototype.asAppEnvironmentAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppEnvironmentAri();
        }, 'environment');
    };
    AppFamilyAriImpl.prototype.asExtensionGroupAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionGroupAri();
        }, 'extension-group');
    };
    AppFamilyAriImpl.prototype.asExtensionAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionAri();
        }, 'extension');
    };
    AppFamilyAriImpl.prototype.isAppAri = function() {
        return !this.isAtLeastAppEnvironmentAri;
    };
    AppFamilyAriImpl.prototype.isAppEnvironmentAri = function() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    };
    AppFamilyAriImpl.prototype.isExtensionGroupAri = function() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    };
    AppFamilyAriImpl.prototype.isExtensionAri = function() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    };
    AppFamilyAriImpl.prototype.returnIf = function(check, type) {
        if (!check()) throw new $5ixmT.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    };
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastAppEnvironmentAri", {
        get: function() {
            return this.environmentId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastExtensionGroupAri", {
        get: function() {
            return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toAri = function() {
        var resourceOwner = $5ixmT.AppFamilyAri.resourceOwner;
        var _a = this.toJSON(), appId = _a.appId, environmentId = _a.environmentId, extensionGroupId = _a.extensionGroupId, extensionKey = _a.extensionKey, version = _a.version;
        function withVersion(segments) {
            var path = segments.join('/');
            if (!version) return path;
            else return "" + path + $0d5dd8c916c95343$var$versionPrefix + version;
        }
        if (this.isExtensionAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    };
    AppFamilyAriImpl.prototype.toString = function() {
        return this.toAri().toString();
    };
    return AppFamilyAriImpl;
}();
module.exports.AppFamilyAriImpl = $0d5dd8c916c95343$var$AppFamilyAriImpl;
function $0d5dd8c916c95343$var$stripToUndefined(str) {
    if (!str) return undefined;
    var trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});

parcelRegister("cOau5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9iGS2 = parcelRequire("9iGS2");


var $F4YLX = parcelRequire("F4YLX");

const $831f4393e6328081$export$8c5d88a1b5304a38 = ({ contentId: contentId, isCommentContext: isCommentContext = false })=>{
    const baseExtension = (0, $9iGS2.getRedactionExtension)();
    const baseNodes = baseExtension.modules.nodes ?? {};
    return {
        ...baseExtension,
        modules: {
            ...baseExtension.modules,
            nodes: {
                ...baseNodes,
                default: {
                    ...baseNodes.default,
                    render: async ()=>(args)=>{
                            const node = args.node;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $F4YLX.TourableRedactionExtensionLoader), {
                                contentId: contentId,
                                extensionNode: node,
                                isCommentContext: isCommentContext
                            });
                        }
                }
            }
        }
    };
};
module.exports["createTourableRedactionExtension"] = $831f4393e6328081$export$8c5d88a1b5304a38;

});

parcelRegister("9iGS2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8Iwqw = parcelRequire("8Iwqw");


var $2W6JM = parcelRequire("2W6JM");

const $18242b0ae588a593$var$EXTENSION_TYPE = 'com.atlassian.guard-premium';
const $18242b0ae588a593$export$fd010a581322717b = (getSpotlightKey)=>({
        [$18242b0ae588a593$var$EXTENSION_TYPE]: ()=>{
            if (getSpotlightKey) {
                const key = getSpotlightKey();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Iwqw.default), {
                    name: `redaction-marker-${key}`
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2W6JM.RedactionMarker), null));
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2W6JM.RedactionMarker), null);
        }
    });

const $18242b0ae588a593$export$12bebc06194b8864 = ()=>{
    return {
        title: 'Redaction',
        type: $18242b0ae588a593$var$EXTENSION_TYPE,
        key: 'redaction',
        description: 'Inserts redacted block.',
        icons: {
            '48': ()=>(parcelRequire("b4ALZ"))
        },
        modules: {
            nodes: {
                default: {
                    type: 'inlineExtension',
                    render: async ()=>(0, $2W6JM.RedactionMarker),
                    // Redacted content must not be copyable; hide the copy button
                    // from the selection toolbar (delete-only).
                    hideCopyButton: true
                }
            }
        }
    };
};
module.exports["getRedactionExtension"] = $18242b0ae588a593$export$12bebc06194b8864;

});

parcelRegister("2W6JM", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $kSwu1 = parcelRequire("kSwu1");


var $iDrrr = parcelRequire("iDrrr");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");


var $biXSc = parcelRequire("biXSc");

const $41ad4d5eece5004a$var$redactionBarStyles = (0, $buxP3.xcss)({
    display: 'inline-flex',
    aspectRatio: '3.4/1',
    height: '1lh',
    '@supports not (height: 1lh)': {
        height: '1.5em'
    },
    backgroundColor: 'color.background.neutral.bold.pressed',
    verticalAlign: 'middle',
    position: 'relative',
    // Redacted content must not be selectable/copyable.
    userSelect: 'none'
});
function $41ad4d5eece5004a$export$5d1828a8b51af09e() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if ((0, $iDrrr.fg)('jira-redaction-accessibility-followup')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($41ad4d5eece5004a$var$RedactionBar, {
        "aria-label": formatMessage((0, $biXSc.default).redactionMarker)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        as: "span",
        xcss: $41ad4d5eece5004a$var$redactionBarStyles
    });
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $41ad4d5eece5004a$var$RedactionBar = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_16fwhxg": (0, $9aYkv.default)(CSS.supports('height', '1lh') ? '1lh' : '1.5em')
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbccYA _3v5uP0XfP4 _0jFU0VAamP _0KLXruy7kJ _1RrJLit2nV _1mT5xdRAKS _20VacPYbGa",
            __cmplp.className
        ])
    });
});
module.exports["RedactionMarker"] = $41ad4d5eece5004a$export$5d1828a8b51af09e;

});

parcelRegister("biXSc", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $309f8ed8a1d2a206$var$_default_1 = (0, $kSwu1.defineMessages)({
    redactionMarker: {
        id: "editor-extensions.redaction-extension.redaction-marker-aria-label",
        defaultMessage: "Redacted content. Your organization has removed sensitive data."
    }
});
var $309f8ed8a1d2a206$export$2e2bcd8739ae039 = $309f8ed8a1d2a206$var$_default_1;
module.exports["default"] = $309f8ed8a1d2a206$export$2e2bcd8739ae039;

});

parcelRegister("b4ALZ", function(module, exports) {

let $80fc97cf3f3f4d02$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $80fc97cf3f3f4d02$var$load("gCHto").then(()=>parcelRequire('47bbw'));

});

parcelRegister("ivb8S", function(module, exports) {

var $209pV = parcelRequire("209pV");


var $e6fvz = parcelRequire("e6fvz");


var $cozmU = parcelRequire("cozmU");


var $7Sm4c = parcelRequire("7Sm4c");


var $8Lx5S = parcelRequire("8Lx5S");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $ij4CE = parcelRequire("ij4CE");


var $cbOce = parcelRequire("cbOce");


var $8Z78B = parcelRequire("8Z78B");

const $6fc4b7bb962289cc$export$75d6c00965e77c = (0, $e6fvz.default);
const $6fc4b7bb962289cc$export$7ca8667598519375 = (data)=>{
    const state = {};
    // new graphQL call returns onboardingState array
    const { onboardingState: onboardingState } = data || {};
    // parse data and populate state accordingly
    if (onboardingState !== undefined && onboardingState !== null) for (const { key: key, value: value } of onboardingState){
        // key comes back as "{prefix}:{property}" format
        // split by ':' to get parsed {property}
        // some keys don't have a prefix, which is why we have the ||
        const parsedKey = key.split(':')[1] || key;
        if (!value) continue;
        if (/(true|false)/g.test(value)) state[parsedKey] = value === 'true';
        else state[parsedKey] = value;
    }
    return state;
};
const $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf = ()=>{
    const [setState, { error: error, called: called }] = (0, $308Wd.useMutationInterop)((0, $209pV.default), {
        update (_cache, { data: data }) {
            const states = data.setOnboardingState;
            (states ?? []).forEach(({ key: key, value: value })=>{
                // writeFragment can only handle a single data item at a time
                (0, $ij4CE.writeFragmentInterop)({
                    fragmentId: `OnboardingState:${key}`,
                    data: {
                        key: key,
                        value: value ?? null,
                        __typename: 'OnboardingState'
                    },
                    __callerPackage__: "onboarding-helpers"
                });
            });
        },
        onError: (error)=>{
            if ((0, $cbOce.isExpectedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "onboarding-helpers"
    });
    const setOnboardingState = (0, $cozmU.useCallback)((newOnboardingState)=>{
        let states;
        if (Array.isArray(newOnboardingState)) // supports batch updates
        states = newOnboardingState;
        else // backwards compability for single key-value pair
        states = [
            newOnboardingState
        ];
        setState({
            variables: {
                states: states
            },
            optimisticResponse: {
                setOnboardingState: states.map(({ key: key, value: value })=>({
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }))
            }
        });
    }, [
        setState
    ]);
    return {
        setOnboardingState: setOnboardingState,
        error: error,
        called: called
    };
};
// safeguards against empty arrays or strings
const $6fc4b7bb962289cc$var$hasValidKeysToFetch = (key)=>{
    if (Array.isArray(key)) return key.length > 0;
    if (typeof key === 'string') return key.length > 0;
    return false;
};
const $6fc4b7bb962289cc$export$d5e7611ac338ec84 = (key, skip = false)=>{
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const isAllowed = isLicensed || isGuest;
    const hasKeysToFetch = $6fc4b7bb962289cc$var$hasValidKeysToFetch(key);
    const skipQuery = skip || !isAllowed || !hasKeysToFetch;
    const { data: data, error: error, loading: loading, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $8Z78B.default), {
        variables: {
            key: key
        },
        skip: skipQuery,
        __callerPackage__: "onboarding-helpers"
    });
    return {
        data: data,
        error: error,
        loading: loading,
        refetch: refetch
    };
};
module.exports["deserializeState"] = $6fc4b7bb962289cc$export$7ca8667598519375;
module.exports["useSetOnboardingState"] = $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf;
module.exports["useGetOnboardingState"] = $6fc4b7bb962289cc$export$d5e7611ac338ec84;

});

parcelRegister("209pV", function(module, exports) {
/**
 * @generated SignedSource<<a83598c413cebc1d8cb2388f4b0ca41c>>
 * @relayHash 3faa5f50f8c511a1bae008881ee58062
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed
const $4f605ad876f6c5d9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "states"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "states",
                    "variableName": "states"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "setOnboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3faa5f50f8c511a1bae008881ee58062",
            "id": "1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed",
            "metadata": {},
            "name": "onboardingStateSetOnboardingStateMutation",
            "operationKind": "mutation",
            "text": "mutation onboardingStateSetOnboardingStateMutation($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key,value}}"
        }
    };
}();
$4f605ad876f6c5d9$var$node.hash = "90b0af82da00eefb44f28228419e7c9e";
var $4f605ad876f6c5d9$export$2e2bcd8739ae039 = $4f605ad876f6c5d9$var$node;
module.exports["default"] = $4f605ad876f6c5d9$export$2e2bcd8739ae039;

});

parcelRegister("e6fvz", function(module, exports) {
/**
 * @generated SignedSource<<0c17cade527e0c98b3a6d07d61bdb0ec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6eba286460e57a30$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "onboardingState_state",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ],
    "type": "OnboardingState"
};
$6eba286460e57a30$var$node.hash = "4458ec6e78736741d79615a29b68de83";
var $6eba286460e57a30$export$2e2bcd8739ae039 = $6eba286460e57a30$var$node;
module.exports["default"] = $6eba286460e57a30$export$2e2bcd8739ae039;

});

parcelRegister("cbOce", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $1uFM6 = parcelRequire("1uFM6");

function $2f49c1e50cca9335$export$8715824c16ceeca0(error) {
    const isUnauthorized = error?.graphQLErrors?.[0]?.message === 'unauthorized' || (0, $1uFM6.isUnauthorizedError)(error);
    return isUnauthorized || (0, $6fil2.containsNetworkError)(error);
}
module.exports["isExpectedError"] = $2f49c1e50cca9335$export$8715824c16ceeca0;

});

parcelRegister("kLzei", function(module, exports) {
/* getSmartCardRenderers.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $dOBRD = parcelRequire("dOBRD");


var $3ricL = parcelRequire("3ricL");


var $4hCFw = parcelRequire("4hCFw");


var $di8q4 = parcelRequire("di8q4");


var $9wGTI = parcelRequire("9wGTI");


var $ge2sX = parcelRequire("ge2sX");


var $f7i8j = parcelRequire("f7i8j");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");

const $1431e51c33a3f61c$var$emojiWrapperStyles = null;
const $1431e51c33a3f61c$var$SmartCardEmojiWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _3iDTPbvbI6 _37wbyuDIqT _4ouGXIey7F"
        ])
    }, children); // Custom render wrapper for AISnippet providing session data
const $1431e51c33a3f61c$var$AISnippetRenderer = (props)=>{
    const { displayName: displayName, userId: userId, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const isAIFeatureEnabled = (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-ai');
    if (!isAdminHubAIEnabled || !isAIFeatureEnabled || !(0, $6mKj3.expVal)('confluence-ai-linking-ai-snippets', 'should_render_ai_snippet', false)) return props.fallbackComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hCFw.AISnippetWithRelayEnvironment), {
        ...props,
        userId: userId ?? undefined,
        displayName: displayName ?? undefined
    });
};
const $1431e51c33a3f61c$export$61bc672a900b57f = (0, $dOBRD.default)(()=>({
        renderers: {
            emoji: (emojiId, _parentComponent = 'SmartCard', contentType = 'page')=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ge2sX.SessionData), null, (sessionData)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7i8j.SessionDataContext).Provider, {
                        value: sessionData
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                        emoji: emojiId,
                        height: 16,
                        context: "smartCard",
                        wrapper: $1431e51c33a3f61c$var$SmartCardEmojiWrapper,
                        contentType: contentType
                    }))),
            snippet: (0, $9wGTI.fg)('cc-ai-snippet-renderer-gate') ? $1431e51c33a3f61c$var$AISnippetRenderer : undefined
        }
    }));
module.exports["getSmartCardRenderers"] = $1431e51c33a3f61c$export$61bc672a900b57f;

});

parcelRegister("4hCFw", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $6SsN4 = parcelRequire("6SsN4");


var $w6R6I = parcelRequire("w6R6I");


var $cXtTj = parcelRequire("cXtTj");


var $7akNQ = parcelRequire("7akNQ");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $fNTq8 = parcelRequire("fNTq8");

var $cFVPs = parcelRequire("cFVPs");


var $5JhlM = parcelRequire("5JhlM");

var $bBIvl = parcelRequire("bBIvl");


var $d5gEx = parcelRequire("d5gEx");


var $gZFfs = parcelRequire("gZFfs");


var $i8aB6 = parcelRequire("i8aB6");


var $a7t2v = parcelRequire("a7t2v");


var $lgull = parcelRequire("lgull");


var $iTtzC = parcelRequire("iTtzC");

const $2795fb4dc781be1d$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $2795fb4dc781be1d$var$ANALYTICS_FROM_CODE = 'SMARTLINK';
const $2795fb4dc781be1d$var$DEFAULT_MAX_LINES = 4;
const $2795fb4dc781be1d$var$styles = {
    container: "_2sNsIg7NXe"
};
const $2795fb4dc781be1d$var$getContentTypeParam = (contentType)=>contentType === 'page' ? 'PAGE' : contentType === 'blogpost' ? 'BLOGPOST' : null;
const $2795fb4dc781be1d$var$getAnalyticsConfig = (props)=>({
        product: 'confluence',
        subproduct: 'confluence',
        source: 'confluencePage',
        aiFeatureName: 'aiSnippet',
        proactiveGeneratedAI: 1,
        userGeneratedAI: 0,
        additionalAttributes: {
            contentId: props.contentId,
            contentType: props.contentType,
            from: props.from ?? $2795fb4dc781be1d$var$ANALYTICS_FROM_CODE,
            productAttributionOverride: 'confluence'
        },
        enablePlatformEvents: true,
        skipAISessionValidation: true
    }); /**
     * Main AI Snippet component. Fetches the AI snippet data from the server and displays it.
     * If the snippet data type is not supported, it will display the fallback component.
     * If the AI snippet data is not found or another error occurs it will display the AISnippet component,
     * but with the fallback text in place of the response text.
     *
     * @param contentId - The content ID of the AI snippet
     * @param contentType - The content type of the AI snippet
     * @param cloudId - The cloud ID of the AI snippet
     * @param fallbackText - The text to display if the AI snippet fails to load
     * @param fallbackComponent - The component to display if the AI snippet is not supported
     * @param source [optional] - The source for where the AI snippet was triggered from defaults to 'smartlink'
     * @param onLoadComplete [optional] - The callback function that executes when loading has completed
     * @returns
     */ 
const $2795fb4dc781be1d$export$1b2af18ca4bb327b = (props)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $fNTq8.AIEventsInstrumentationProvider), {
        config: $2795fb4dc781be1d$var$getAnalyticsConfig(props)
    }, /*#__PURE__*/ $cozmU.createElement($2795fb4dc781be1d$export$ac90160f7ae1e32f, props));
};
const $2795fb4dc781be1d$export$ac90160f7ae1e32f = ({ contentId: contentId, contentType: contentType, cloudId: cloudId, fallbackText: fallbackText, fallbackComponent: fallbackComponent, userId: userId, displayName: displayName, source: source = 'smartlink', maxLines: maxLines = $2795fb4dc781be1d$var$DEFAULT_MAX_LINES, isHidden: isHidden = false, onLoadComplete: onLoadComplete, showFooter: showFooter, showAwareness: showAwareness })=>{
    const [queryRef, loadQuery] = (0, $6SsN4.useQueryLoader)((0, $iTtzC.default));
    const isLoadingRef = (0, $cozmU.useRef)(true);
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $cFVPs.useAIEventsInstrumentation)();
    const { start: start, success: success, failure: failure } = (0, $i8aB6.useUFOExperience)({
        id: 'ai-snippet-load',
        component: 'ai-snippet',
        type: (0, $gZFfs.ExperienceTypes).Load,
        performanceType: (0, $gZFfs.ExperiencePerformanceTypes).InlineResult
    });
    const contentTypeParam = $2795fb4dc781be1d$var$getContentTypeParam(contentType);
    const isValidQuery = contentType && cloudId && contentId && contentTypeParam;
    const isEnabledForJira = (0, $iDrrr.fg)('jira-cc-ai-snippet-gate');
    const isTrackingEnabled = (0, $cXtTj.default).getExperimentValue('cc-ai-snippet-experiment-tracking', 'isEnabled', false);
    (0, $cozmU.useEffect)(()=>{
        if (!isHidden) trackAIInteractionInit();
        return ()=>{
            if (isLoadingRef.current && !isHidden) trackAIInteractionDismiss();
        }; // Only on component mount/unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $cozmU.useEffect)(()=>{
        isLoadingRef.current = !queryRef;
        if (queryRef) {
            if (isTrackingEnabled) success();
            onLoadComplete?.();
        }
    }, [
        queryRef,
        onLoadComplete,
        success,
        isTrackingEnabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isValidQuery) // Skip query if we don't have valid params as we'll just return the fallback component
        return;
        if (isTrackingEnabled) start();
        loadQuery({
            contentId: contentId,
            contentType: contentTypeParam,
            cloudId: cloudId,
            includeMe: isEnabledForJira
        });
    }, [
        contentId,
        contentTypeParam,
        cloudId,
        loadQuery,
        isValidQuery,
        isEnabledForJira,
        start,
        isTrackingEnabled
    ]);
    if (!isValidQuery) return fallbackComponent;
    const content = /*#__PURE__*/ $cozmU.createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $a7t2v.AISnippetContent), {
            text: fallbackText,
            contentId: contentId,
            showFooter: false,
            showAwareness: showAwareness,
            source: source,
            isHidden: isHidden,
            maxLines: maxLines
        }),
        onError: (error)=>{
            if (!isHidden) {
                if (isTrackingEnabled) failure({
                    metadata: {
                        errorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                        errorMessage: error.message || 'Unknown error'
                    }
                });
                trackAIResultError({
                    aiErrorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                    aiErrorMessage: error.message || 'Unknown error'
                });
            }
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($2795fb4dc781be1d$var$styles.container)
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $bBIvl.AIStreamLoading), null)
    }, queryRef ? /*#__PURE__*/ $cozmU.createElement((0, $lgull.AISnippetLoader), {
        queryRef: queryRef,
        fallbackText: fallbackText,
        contentId: contentId,
        source: source,
        isHidden: isHidden,
        maxLines: maxLines,
        showFooter: showFooter,
        showAwareness: showAwareness
    }) : /*#__PURE__*/ $cozmU.createElement((0, $bBIvl.AIStreamLoading), null))));
    return /*#__PURE__*/ $cozmU.createElement((0, $7akNQ.FlagsProvider), null, isEnabledForJira ? content : /*#__PURE__*/ $cozmU.createElement((0, $5JhlM.AIFeedbackPropertiesProvider), {
        entrypointId: $2795fb4dc781be1d$var$SNIPPET_ENTRYPOINT_ID,
        userId: userId,
        displayName: displayName
    }, content));
};
const $2795fb4dc781be1d$export$c9a07cebec67e951 = (props)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $d5gEx.RelayEnvironmentProvider), null, /*#__PURE__*/ $cozmU.createElement($2795fb4dc781be1d$export$1b2af18ca4bb327b, props));
};
module.exports["AISnippetWithRelayEnvironment"] = $2795fb4dc781be1d$export$c9a07cebec67e951;

});

parcelRegister("fNTq8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jU6s6 = parcelRequire("jU6s6");


var $4dW9D = parcelRequire("4dW9D");


var $jLdbZ = parcelRequire("jLdbZ");

const $8a30b5a238fd1faa$var$validateAIEventsConfig = (config)=>{
    if (!config.aiFeatureName.match(/^[a-z][A-Za-z]*$/)) // eslint-disable-next-line no-console
    console.error('[@atlassian/ai-analytics]: please set aiFeatureName in camelCase');
};
const $8a30b5a238fd1faa$export$b5d4bc85dfbaa4f8 = ({ children: children, config: config })=>{
    const { refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = (0, $jLdbZ.useAIInstrumentationSetup)(config.singleInstrumentationID);
    const contextValue = (0, $cozmU.useMemo)(()=>{
        $8a30b5a238fd1faa$var$validateAIEventsConfig(config);
        return {
            config: {
                ...(0, $4dW9D.defaultAIEventsInstrumentationConfigValues),
                ...config,
                product: config.product.toLowerCase()
            },
            refreshSingleInstrumentationID: refreshSingleInstrumentationID,
            getSingleInstrumentationID: getSingleInstrumentationID,
            setAISessionState: setAISessionState,
            getAISessionState: getAISessionState
        };
    }, [
        config,
        refreshSingleInstrumentationID,
        getSingleInstrumentationID,
        setAISessionState,
        getAISessionState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jU6s6.AIEventsInstrumentationContext).Provider, {
        value: contextValue
    }, children);
};
module.exports["AIEventsInstrumentationProvider"] = $8a30b5a238fd1faa$export$b5d4bc85dfbaa4f8;

});

parcelRegister("5JhlM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $2eafd2f31cb677aa$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $2eafd2f31cb677aa$export$f906c21bacdb2d8e = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $2eafd2f31cb677aa$export$e9e654940dee103b = ({ children: children, entrypointId: entrypointId, locale: locale, feedbackContextId: feedbackContextId = $2eafd2f31cb677aa$var$FEEDBACK_CONTEXT_CF, feedbackContext: feedbackContext = {}, userId: userId, displayName: displayName })=>{
    const { locale: intlLocale } = (0, $kSwu1.useIntl)();
    const feedbackContextString = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${JSON.stringify(value)}`).join(' ');
    const contextValue = (0, $cozmU.useMemo)(()=>({
            entrypointId: entrypointId,
            feedbackContextId: feedbackContextId,
            feedbackContext: feedbackContextString,
            locale: locale || intlLocale,
            userId: userId,
            displayName: displayName
        }), [
        entrypointId,
        feedbackContextId,
        feedbackContextString,
        locale,
        intlLocale,
        userId,
        displayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2eafd2f31cb677aa$export$f906c21bacdb2d8e.Provider, {
        value: contextValue
    }, children);
};
const $2eafd2f31cb677aa$export$ff3deb4415ee32e3 = ()=>{
    const context = (0, $cozmU.useContext)($2eafd2f31cb677aa$export$f906c21bacdb2d8e);
    if (context === undefined) throw new Error('useAIFeedbackProperties must be used within a AIFeedbackPropertiesProvider');
    return context;
};
module.exports["AIFeedbackPropertiesProvider"] = $2eafd2f31cb677aa$export$e9e654940dee103b;
module.exports["useAIFeedbackProperties"] = $2eafd2f31cb677aa$export$ff3deb4415ee32e3;

});

parcelRegister("bBIvl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");

var $kz1Yj = parcelRequire("kz1Yj");

var $buxP3 = parcelRequire("buxP3");


var $7m1U4 = parcelRequire("7m1U4");

const $b089d8c6b56c64f6$var$styles = (0, $buxP3.xcss)({
    color: 'color.text.subtle'
});
const $b089d8c6b56c64f6$var$i18n = (0, $kSwu1.defineMessages)({
    generatingSummaryText: {
        id: "ai-stream-loading.title",
        defaultMessage: "AI is working..."
    },
    generatingSummaryAnimationAlt: {
        id: "ai-stream-loading.generation-animation",
        defaultMessage: "Generating"
    }
});
const $b089d8c6b56c64f6$export$47a62cbf3ee79fef = ({ padding: padding = 'space.300', titleMessage: titleMessage })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const title = titleMessage ?? $b089d8c6b56c64f6$var$i18n.generatingSummaryText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        padding: padding,
        xcss: $b089d8c6b56c64f6$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignBlock: "center",
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7m1U4.GeneratingStreamAnimation), {
        alt: formatMessage($b089d8c6b56c64f6$var$i18n.generatingSummaryAnimationAlt)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), title)));
};
module.exports["AIStreamLoading"] = $b089d8c6b56c64f6$export$47a62cbf3ee79fef;

});

parcelRegister("7m1U4", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $cozmU = parcelRequire("cozmU");

const $c344a4b7f3959518$export$3709887a1be0e305 = ({ alt: alt })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("title", null, alt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "5.5",
        cy: "12.5",
        r: "1.5",
        fill: "#0C66E4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "11.5",
        cy: "10.5",
        r: "1.5",
        fill: "#1D7AFC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.2s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "17.5",
        cy: "12.5",
        r: "1.5",
        fill: "#388BFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.4s"
    })));
};
module.exports["GeneratingStreamAnimation"] = $c344a4b7f3959518$export$3709887a1be0e305;

});

parcelRegister("i8aB6", function(module, exports) {
/* eslint-disable perfectionist/sort-object-types */ 
var $cozmU = parcelRequire("cozmU");


var $34VCg = parcelRequire("34VCg");

const $89c606f0d1f4dfb4$export$fade2d05a6320d49 = ({ id: id, component: component, type: type, performanceType: performanceType })=>{
    const ufoExperience = (0, $cozmU.useRef)(new (0, $34VCg.UFOExperience)(id, {
        type: type,
        performanceType: performanceType,
        platform: {
            component: component
        }
    }));
    const start = (0, $cozmU.useCallback)((startTime)=>{
        return ufoExperience.current.start(startTime);
    }, []);
    const success = (0, $cozmU.useCallback)((config)=>{
        return ufoExperience.current.success(config);
    }, []);
    const mark = (0, $cozmU.useCallback)((name, timestamp)=>{
        ufoExperience.current.mark(name, timestamp);
    }, []);
    const addMetadata = (0, $cozmU.useCallback)((data)=>{
        ufoExperience.current.addMetadata(data);
    }, []);
    const markFMP = (0, $cozmU.useCallback)((timestamp)=>{
        ufoExperience.current.markFMP(timestamp);
    }, []);
    const markInlineResponse = (0, $cozmU.useCallback)((timestamp)=>{
        ufoExperience.current.markInlineResponse(timestamp);
    }, []);
    const failure = (0, $cozmU.useCallback)((config)=>{
        return ufoExperience.current.failure(config);
    }, []);
    const abort = (0, $cozmU.useCallback)((config)=>{
        return ufoExperience.current.abort(config);
    }, []);
    return {
        start: start,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        addMetadata: addMetadata,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};
module.exports["useUFOExperience"] = $89c606f0d1f4dfb4$export$fade2d05a6320d49;

});

parcelRegister("a7t2v", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $303LV = parcelRequire("303LV");


var $cXtTj = parcelRequire("cXtTj");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $cFVPs = parcelRequire("cFVPs");


var $cAiYt = parcelRequire("cAiYt");

var $aIn0d = parcelRequire("aIn0d");

var $cHkK6 = parcelRequire("cHkK6");


var $5GgqH = parcelRequire("5GgqH");

const $24521ba341a214c8$var$MAU_CRITERIA_DWELL_TIME = 3000;
const $24521ba341a214c8$var$sanitizeMarkdown = (text)=>{
    if (!text) return '';
    return text.replace(/={4,}/g, '===') // h1 headers
    .replace(/-{4,}/g, '---'); // h2 headers
};
const $24521ba341a214c8$export$3cf37822a11d3ff3 = ({ text: text, contentId: contentId, showFooter: showFooter = true, showAwareness: showAwareness = false, source: source, isHidden: isHidden, maxLines: maxLines, renderAsMarkdown: renderAsMarkdown = true })=>{
    const ref = (0, $cozmU.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $5GgqH.usePopupDwellTime)(ref, 250);
    const { trackAIResultView: trackAIResultView, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $cFVPs.useAIEventsInstrumentation)();
    // This is needed to keep the snippet value in scope when running the unmount effect
    const snippetValueRef = (0, $cozmU.useRef)(text);
    const isExperimentEnabled = (0, $cXtTj.default).getExperimentValue('cc-ai-snippet-fixes-1025', 'isEnabled', false);
    const isFeedbackEnabled = (0, $cXtTj.default).getExperimentValue('cc-ai-snippet-experiment-feedback', 'isEnabled', false);
    const handleLikeClicked = (0, $cozmU.useCallback)(()=>{
        trackAIFeedbackSubmit('up');
    }, [
        trackAIFeedbackSubmit
    ]);
    const handleDislikeClicked = (0, $cozmU.useCallback)(()=>{
        trackAIFeedbackSubmit('down');
    }, [
        trackAIFeedbackSubmit
    ]);
    (0, $cozmU.useEffect)(()=>{
        const currentText = snippetValueRef.current;
        return ()=>{
            const dwellTime = getDwellTime();
            if (!isHidden) {
                if (showFooter && currentText && dwellTime >= $24521ba341a214c8$var$MAU_CRITERIA_DWELL_TIME) trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: true
                    }
                });
                else trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: showFooter && !!currentText
                    },
                    doesNotMeetMAUCriteria: true
                });
            }
        };
    // we only want to run this effect on un-mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        ref: ref
    }, showAwareness && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cAiYt.AIAwareness), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        maxLines: maxLines
    }, renderAsMarkdown ? isExperimentEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $303LV.default), {
        options: {
            disableParsingRawHTML: true
        }
    }, $24521ba341a214c8$var$sanitizeMarkdown(text || '')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $303LV.default), null, text || '') : text || ''), showFooter && text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aIn0d.AIDisclaimer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cHkK6.AIFeedbackComponent), {
        contentId: contentId,
        onLikeClicked: isFeedbackEnabled ? handleLikeClicked : undefined,
        onDislikeClicked: isFeedbackEnabled ? handleDislikeClicked : undefined
    })));
};
module.exports["AISnippetContent"] = $24521ba341a214c8$export$3cf37822a11d3ff3;

});

parcelRegister("cAiYt", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $etoPX = parcelRequire("etoPX");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $1kxSE = parcelRequire("1kxSE");

const $b6dbb4b671decd4a$var$styles = {
    text: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8"
};
const $b6dbb4b671decd4a$export$fde99ed387d90f1 = ({ variant: variant = 'summary' })=>{
    const MESSAGE_MAP = {
        summary: (0, $1kxSE.i18n).rovoAwarenessMessage,
        define: (0, $1kxSE.i18n).rovoAwarenessDefineMessage
    };
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const message = MESSAGE_MAP[variant];
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($b6dbb4b671decd4a$var$styles.text)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $etoPX.RovoIcon), {
        size: "xxsmall",
        appearance: "brand"
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage(message))));
};
module.exports["AIAwareness"] = $b6dbb4b671decd4a$export$fde99ed387d90f1;

});

parcelRegister("1kxSE", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c8fb6889a2026e6c$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    rovoAwarenessMessage: {
        id: "ai-awareness.rovoAwarenessMessage",
        defaultMessage: "Summary by Rovo"
    },
    rovoAwarenessDefineMessage: {
        id: "ai-awareness-define.message",
        defaultMessage: "Definition by Rovo"
    }
});
module.exports["i18n"] = $c8fb6889a2026e6c$export$a7357cdd1f0b0168;

});

parcelRegister("aIn0d", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $10I6z = parcelRequire("10I6z");

const $5f85a79aee555eb3$var$AI_DISCLAIMER_LINK = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $5f85a79aee555eb3$var$styles = {
    text: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8"
};
const $5f85a79aee555eb3$export$e0542ba0c737fe5c = ({ onLinkClick: onLinkClick, withLink: withLink = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const disclaimerContent = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $10I6z.i18n).disclaimerMessage));
    if (withLink) return /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
        appearance: "subtle",
        href: $5f85a79aee555eb3$var$AI_DISCLAIMER_LINK,
        target: "_blank",
        onClick: onLinkClick
    }, disclaimerContent);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($5f85a79aee555eb3$var$styles.text)
    }, disclaimerContent);
};
module.exports["AIDisclaimer"] = $5f85a79aee555eb3$export$e0542ba0c737fe5c;

});

parcelRegister("10I6z", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $1ae8fb340800d3e1$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    disclaimerMessage: {
        id: "ai-disclaimer.disclaimerMessage",
        defaultMessage: "Uses AI. Verify results."
    }
});
module.exports["i18n"] = $1ae8fb340800d3e1$export$a7357cdd1f0b0168;

});

parcelRegister("cHkK6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $91uAX = parcelRequire("91uAX");


var $4MnFz = parcelRequire("4MnFz");


var $chu6R = parcelRequire("chu6R");


var $i1t43 = parcelRequire("i1t43");


var $iDrrr = parcelRequire("iDrrr");


var $3izAL = parcelRequire("3izAL");

var $kz1Yj = parcelRequire("kz1Yj");

var $buxP3 = parcelRequire("buxP3");


var $lpNn5 = parcelRequire("lpNn5");


var $5JhlM = parcelRequire("5JhlM");


var $gecH2 = parcelRequire("gecH2");

const $2e66c8b5b2928379$var$LINK_TO_PRIVACY_POLICY = 'https://www.atlassian.com/legal/privacy-policy';
const $2e66c8b5b2928379$var$LINK_TO_RESEARCH_GROUP = 'https://www.atlassian.com/research-group';
const $2e66c8b5b2928379$var$i18n = (0, $kSwu1.defineMessages)({
    flagTitle: {
        id: "quick-summary.feedback.flag.title",
        defaultMessage: "Thanks!"
    },
    flagDescription: {
        id: "quick-summary.feedback.flag.description",
        defaultMessage: "We appreciate you taking the time to send this feedback."
    },
    likeTooltip: {
        id: "quick-summary.like.tooltip",
        defaultMessage: "Helpful"
    },
    dislikeTooltip: {
        id: "quick-summary.dislike.tooltip",
        defaultMessage: "Not helpful"
    },
    feedbackTitle: {
        id: "quick-summary.feedback.title",
        defaultMessage: "Help us improve Atlassian Intelligence"
    },
    feedbackSummaryTitle: {
        id: "quick-summary.feedback.summary.title",
        defaultMessage: "Tell us about your experience"
    },
    feedbackSummaryPlaceholder: {
        id: "quick-summary.feedback.summary.placeholder",
        defaultMessage: "What did Atlassian Intelligence do well? What could be improved?"
    },
    canContactText: {
        id: "quick-summary.feedback.can-contact.label",
        defaultMessage: "Atlassian can contact me about this feedback. See our {privacyPolicyLink}."
    },
    privacyPolicyLink: {
        id: "quick-summary.feedback.privacy-policy.link",
        defaultMessage: "privacy policy"
    },
    improveAtlassianText: {
        id: "quick-summary.feedback.improve-atlassian",
        defaultMessage: "I\u2019d like to help improve Atlassian products by joining the {researchGroupLink}."
    },
    improveAtlassianTextAppify: {
        id: "quick-summary.feedback.improve-atlassian-appify",
        defaultMessage: "I\u2019d like to help improve Atlassian apps by joining the {researchGroupLink}."
    },
    researchGroupLink: {
        id: "quick-summary.feedback.research-group.link",
        defaultMessage: "Atlassian Research Group"
    }
});
const $2e66c8b5b2928379$var$PrivacyPolicyLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2e66c8b5b2928379$var$i18n.privacyPolicyLink));
const $2e66c8b5b2928379$var$ResearchGroupLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2e66c8b5b2928379$var$i18n.researchGroupLink));
const $2e66c8b5b2928379$var$CanContactLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$2e66c8b5b2928379$var$i18n.canContactText,
        values: {
            privacyPolicyLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$PrivacyPolicyLink, {
                link: $2e66c8b5b2928379$var$LINK_TO_PRIVACY_POLICY
            })
        }
    });
};
const $2e66c8b5b2928379$var$EnrolLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $iDrrr.fg)('product-terminology-refresh') ? $2e66c8b5b2928379$var$i18n.improveAtlassianTextAppify : $2e66c8b5b2928379$var$i18n.improveAtlassianText,
        values: {
            researchGroupLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$ResearchGroupLink, {
                link: $2e66c8b5b2928379$var$LINK_TO_RESEARCH_GROUP
            })
        }
    });
};
const $2e66c8b5b2928379$var$DislikeIconWrapperXCSS = (0, $buxP3.xcss)({
    transform: 'rotate(180deg)'
});
const $2e66c8b5b2928379$var$ButtonWrapperXCSS = (0, $buxP3.xcss)({
    height: '24px',
    width: '24px'
});
const $2e66c8b5b2928379$export$f9f34317e5bc3551 = ({ contentId: contentId, onLikeClicked: onLikeClicked, onDislikeClicked: onDislikeClicked })=>{
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isFeedbackOpen, setIsFeedbackOpen] = (0, $cozmU.useState)(false);
    const feedbackCollectorProperties = (0, $5JhlM.useAIFeedbackProperties)();
    const [sentiment, setSentiment] = (0, $cozmU.useState)('');
    const [hasGoodFeedbackBeenSubmitted, setHasGoodFeedbackBeenSubmitted] = (0, $cozmU.useState)(false);
    const [hasBadFeedbackBeenSubmitted, setHasBadFeedbackBeenSubmitted] = (0, $cozmU.useState)(false);
    const feedbackContextString = `contentId: ${contentId} sentiment: ${sentiment}${feedbackCollectorProperties.feedbackContext.length > 0 ? ` ${feedbackCollectorProperties.feedbackContext}` : ''}`;
    const showFeedbackFlag = ()=>{
        showFlag({
            title: formatMessage($2e66c8b5b2928379$var$i18n.flagTitle),
            description: formatMessage($2e66c8b5b2928379$var$i18n.flagDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                spacing: "spacious",
                color: "var(--ds-icon-success, #6A9A23)",
                label: "success"
            }),
            isAutoDismiss: true
        });
    };
    const handleLikeClicked = ()=>{
        onLikeClicked?.();
        setIsFeedbackOpen(true);
        setSentiment('good');
    };
    const handleDislikeClicked = ()=>{
        onDislikeClicked?.();
        setIsFeedbackOpen(true);
        setSentiment('bad');
    };
    const onFeedbackSubmit = ()=>{
        showFeedbackFlag();
        setIsFeedbackOpen(false);
        if (sentiment === 'good') {
            setHasGoodFeedbackBeenSubmitted(true);
            setHasBadFeedbackBeenSubmitted(false);
        } else {
            setHasBadFeedbackBeenSubmitted(true);
            setHasGoodFeedbackBeenSubmitted(false);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        role: "none",
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage($2e66c8b5b2928379$var$i18n.likeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $2e66c8b5b2928379$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        "aria-label": formatMessage($2e66c8b5b2928379$var$i18n.likeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gecH2.ThumbIcon), {
            isSelected: hasGoodFeedbackBeenSubmitted
        }),
        onClick: handleLikeClicked,
        testId: "feedback-like-button",
        isDisabled: hasGoodFeedbackBeenSubmitted
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage($2e66c8b5b2928379$var$i18n.dislikeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $2e66c8b5b2928379$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        "aria-label": formatMessage($2e66c8b5b2928379$var$i18n.dislikeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $2e66c8b5b2928379$var$DislikeIconWrapperXCSS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gecH2.ThumbIcon), {
            isSelected: hasBadFeedbackBeenSubmitted
        })),
        onClick: handleDislikeClicked,
        testId: "feedback-dislike-button",
        isDisabled: hasBadFeedbackBeenSubmitted
    }))), isFeedbackOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91uAX.default), {
        locale: feedbackCollectorProperties.locale,
        onSubmit: onFeedbackSubmit,
        onClose: ()=>setIsFeedbackOpen(false),
        atlassianAccountId: feedbackCollectorProperties.userId,
        name: feedbackCollectorProperties.displayName,
        entrypointId: feedbackCollectorProperties.entrypointId,
        summaryPlaceholder: formatMessage($2e66c8b5b2928379$var$i18n.feedbackSummaryPlaceholder),
        additionalFields: [
            {
                id: feedbackCollectorProperties.feedbackContextId,
                value: feedbackContextString
            }
        ],
        feedbackTitle: formatMessage($2e66c8b5b2928379$var$i18n.feedbackTitle),
        showTypeField: false,
        customTextAreaLabel: formatMessage($2e66c8b5b2928379$var$i18n.feedbackSummaryTitle),
        canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$CanContactLabel, null),
        enrolInResearchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$EnrolLabel, null)
    })));
};
module.exports["AIFeedbackComponent"] = $2e66c8b5b2928379$export$f9f34317e5bc3551;

});

parcelRegister("91uAX", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb4dd8e62f46596b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FeedbackFlag", () => (parcelRequire("7MfQo")).default);


var $2eX69 = parcelRequire("2eX69");


var $7MfQo = parcelRequire("7MfQo");


var $eb4dd8e62f46596b$export$2e2bcd8739ae039 = (0, $2eX69.default);

});

parcelRegister("7MfQo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $a2foB = parcelRequire("a2foB");


var $chu6R = parcelRequire("chu6R");


var $iDrrr = parcelRequire("iDrrr");


var $5r21M = parcelRequire("5r21M");


var $hTUp6 = parcelRequire("hTUp6");

const $cf0d91eb970c8b8a$var$FeedbackFlag = ({ description: description, title: title })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a2foB.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
            spacing: "spacious",
            color: "var(--ds-icon-success, #6A9A23)",
            label: "Success"
        }),
        id: "feedbackSent",
        description: description || formatMessage((0, $iDrrr.fg)('product-terminology-refresh') ? (0, $5r21M.messages).feedbackSuccessFlagDescriptionAppify : (0, $5r21M.messages).feedbackSuccessFlagDescription),
        title: title || formatMessage((0, $5r21M.messages).feedbackSuccessFlagTitle)
    });
};
const $cf0d91eb970c8b8a$var$FeedbackFlagWithIntl = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hTUp6.IntlProviderWithResolvedMessages), {
        locale: props.locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cf0d91eb970c8b8a$var$FeedbackFlag, props));
var $cf0d91eb970c8b8a$export$2e2bcd8739ae039 = $cf0d91eb970c8b8a$var$FeedbackFlagWithIntl;
module.exports["default"] = $cf0d91eb970c8b8a$export$2e2bcd8739ae039;

});

parcelRegister("gecH2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $c8bBH = parcelRequire("c8bBH");

const $62e24cf344a5b8b1$export$ec2ba0e929740f73 = ({ isSelected: isSelected })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)",
        label: ""
    });
module.exports["ThumbIcon"] = $62e24cf344a5b8b1$export$ec2ba0e929740f73;

});

parcelRegister("5GgqH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $44sV7 = parcelRequire("44sV7");

const $518681ac338b53b3$export$15dda63faa44a0df = (ref, interval = 500)=>{
    const isOnScreen = (0, $44sV7.useOnScreen)(ref);
    const dwellTimeRef = (0, $cozmU.useRef)(0);
    (0, $cozmU.useEffect)(()=>{
        const incremental = setInterval(()=>{
            if (isOnScreen) dwellTimeRef.current += interval;
        }, interval);
        return ()=>{
            clearInterval(incremental);
        };
    }, [
        isOnScreen,
        interval
    ]);
    const getDwellTime = ()=>dwellTimeRef.current;
    return {
        getDwellTime: getDwellTime
    };
};
module.exports["usePopupDwellTime"] = $518681ac338b53b3$export$15dda63faa44a0df;

});

parcelRegister("44sV7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $9f61f2cd2c8e0202$export$edb9b52ab3f1abbb = (ref)=>{
    const [isIntersecting, setIntersecting] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!ref.current) return;
        const observer = new IntersectionObserver(([entry])=>setIntersecting(entry.isIntersecting));
        if (ref.current) observer.observe(ref.current);
        return ()=>{
            if (observer) observer.disconnect();
        };
    });
    return isIntersecting;
};
module.exports["useOnScreen"] = $9f61f2cd2c8e0202$export$edb9b52ab3f1abbb;

});

parcelRegister("lgull", function(module, exports) {

var $iTtzC = parcelRequire("iTtzC");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $iDrrr = parcelRequire("iDrrr");


var $5JhlM = parcelRequire("5JhlM");


var $a7t2v = parcelRequire("a7t2v");

const $a1264e7348edcdb0$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $a1264e7348edcdb0$export$f50b64530422ea99 = ({ contentId: contentId, fallbackText: fallbackText, queryRef: queryRef, source: source, isHidden: isHidden, maxLines: maxLines, showFooter: showFooter, showAwareness: showAwareness })=>{
    const data = (0, $6SsN4.usePreloadedQuery)((0, $iTtzC.default), queryRef);
    const aiSnippetText = data?.confluence_latestKnowledgeGraphObjectV2?.objectData;
    const content = /*#__PURE__*/ $cozmU.createElement((0, $a7t2v.AISnippetContent), {
        text: aiSnippetText || fallbackText,
        contentId: contentId,
        showFooter: !!aiSnippetText && showFooter,
        showAwareness: !!aiSnippetText && showAwareness,
        source: source,
        isHidden: isHidden,
        maxLines: maxLines,
        renderAsMarkdown: !!aiSnippetText
    });
    if ((0, $iDrrr.fg)('jira-cc-ai-snippet-gate')) return /*#__PURE__*/ $cozmU.createElement((0, $5JhlM.AIFeedbackPropertiesProvider), {
        entrypointId: $a1264e7348edcdb0$var$SNIPPET_ENTRYPOINT_ID,
        userId: data?.me?.user?.accountId,
        displayName: data?.me?.user?.name
    }, content);
    return content;
};
module.exports["AISnippetLoader"] = $a1264e7348edcdb0$export$f50b64530422ea99;

});

parcelRegister("iTtzC", function(module, exports) {
/**
 * @generated SignedSource<<77586322f750ae0b68f16053ceaefeac>>
 * @relayHash 83b5f9dcca400199c020ae8cd7e6e7c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40
const $34c51f4beec18331$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeMe"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "contentId",
                "variableName": "contentId"
            },
            {
                "kind": "Variable",
                "name": "contentType",
                "variableName": "contentType"
            },
            {
                "kind": "Literal",
                "name": "objectType",
                "value": "snippet_v2"
            }
        ],
        "concreteType": "KnowledgeGraphObjectResponseV2",
        "kind": "LinkedField",
        "name": "confluence_latestKnowledgeGraphObjectV2",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "objectData"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40",
            "metadata": {},
            "name": "aiSnippetLoaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$34c51f4beec18331$var$node.hash = "9d618230ccff7c19cd4e4fee2e2c0a2c";
var $34c51f4beec18331$export$2e2bcd8739ae039 = $34c51f4beec18331$var$node;
module.exports["default"] = $34c51f4beec18331$export$2e2bcd8739ae039;

});

parcelRegister("di8q4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("9fCck"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("crLHf", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $57p4j = parcelRequire("57p4j");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const PLACEHOLDER_SIZE = props.height || 26;
    let t0;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== props.loadingMargin) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $hekY6.default)([
                    "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _39Ohv4YbGa _1SdfoHYbGa"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: props.loadingMargin
                },
                className: (0, $hekY6.default)([
                    "_2uo31fGsB2 _0bjKvDzXzM _2XghbEPgdg _3iDTPbvbI6 _0Of8r2Pgdg"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = props.loadingMargin;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("9fCck", function(module, exports) {

let $6bc3250fbf5c8235$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6bc3250fbf5c8235$var$load("4Gdnz"),
    $6bc3250fbf5c8235$var$load("4UAag"),
    $6bc3250fbf5c8235$var$load("zUKwV"),
    $6bc3250fbf5c8235$var$load("fUeur"),
    $6bc3250fbf5c8235$var$load("5sZTx"),
    $6bc3250fbf5c8235$var$load("deTdD"),
    $6bc3250fbf5c8235$var$load("1JeTB"),
    $6bc3250fbf5c8235$var$load("6wr18"),
    $6bc3250fbf5c8235$var$load("ffEVr"),
    $6bc3250fbf5c8235$var$load("4Ldt2"),
    $6bc3250fbf5c8235$var$load("4izLy"),
    $6bc3250fbf5c8235$var$load("ayJxT"),
    $6bc3250fbf5c8235$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("2yWJZ", function(module, exports) {

var $as9lu = parcelRequire("as9lu");

const $7f640ed30a5677e6$export$62a80b577b02c670 = 'ai_mate_agent';
const $7f640ed30a5677e6$export$eaedd3c4d259c3db = 'f3a534d9-1498-e0d4-8b50-e058a8fb8156';
const $7f640ed30a5677e6$export$d4e191820de5cb9e = $7f640ed30a5677e6$export$62a80b577b02c670;
const $7f640ed30a5677e6$export$cf40b355c500b3f7 = $7f640ed30a5677e6$export$eaedd3c4d259c3db;
const $7f640ed30a5677e6$export$84f2221dfd1486e2 = 'SYSTEM';
const $7f640ed30a5677e6$export$d54b716922cade63 = (value)=>{
    const trimmed = value?.trim();
    return trimmed ? trimmed : undefined;
};
const $7f640ed30a5677e6$export$4529494ee013eb50 = ({ agentId: agentId, agentNamedId: agentNamedId })=>$7f640ed30a5677e6$export$d54b716922cade63(agentId) === $7f640ed30a5677e6$export$eaedd3c4d259c3db || $7f640ed30a5677e6$export$d54b716922cade63(agentNamedId) === $7f640ed30a5677e6$export$62a80b577b02c670;
const $7f640ed30a5677e6$export$71c4912d3c1bf3e3 = (value)=>{
    const normalizedValue = $7f640ed30a5677e6$export$d54b716922cade63(value);
    if (!normalizedValue) return undefined;
    if (!normalizedValue.includes('ari:')) return normalizedValue;
    try {
        return $7f640ed30a5677e6$export$d54b716922cade63((0, $as9lu.IdentityUserAri).parse(normalizedValue).userId);
    } catch  {
        return undefined;
    }
};
module.exports["ROVO_AGENT_NAMED_ID"] = $7f640ed30a5677e6$export$62a80b577b02c670;
module.exports["ROVO_AGENT_UUID"] = $7f640ed30a5677e6$export$eaedd3c4d259c3db;
module.exports["DEFAULT_AGENT_NAMED_ID"] = $7f640ed30a5677e6$export$d4e191820de5cb9e;
module.exports["DEFAULT_AGENT_UUID"] = $7f640ed30a5677e6$export$cf40b355c500b3f7;
module.exports["DEFAULT_AGENT_CREATOR_TYPE"] = $7f640ed30a5677e6$export$84f2221dfd1486e2;
module.exports["trimToUndefined"] = $7f640ed30a5677e6$export$d54b716922cade63;
module.exports["isDefaultRovoChat"] = $7f640ed30a5677e6$export$4529494ee013eb50;
module.exports["normalizeAccountIdFromIdentityAri"] = $7f640ed30a5677e6$export$71c4912d3c1bf3e3;

});

parcelRegister("4IoVL", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $204vt = parcelRequire("204vt");


var $hfrng = parcelRequire("hfrng");


var $3kI72 = parcelRequire("3kI72");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $1NBp8 = parcelRequire("1NBp8");


var $2TuWI = parcelRequire("2TuWI");


var $cga1x = parcelRequire("cga1x");


var $kzNtP = parcelRequire("kzNtP");


var $c4QoG = parcelRequire("c4QoG");


var $I0A3i = parcelRequire("I0A3i");


var $kQiXs = parcelRequire("kQiXs");

const $17b0f8a5b73de479$var$DEFAULT_CONFIG = {
    clientId: '',
    fileStoreUrl: ''
};
const $17b0f8a5b73de479$var$cachedGetDownloadData = (0, $kzNtP.cacheWithExp)(async ({ contentId: contentId, contentAri: contentAri, contentProduct: contentProduct, isExternalShare: isExternalShare, shareToken: shareToken })=>{
    if ((0, $3kI72.requiresCrossProductAuth)({
        hostProduct: 'confluence-page',
        sourceProduct: contentProduct
    })) return (0, $3kI72.fetchTokenForSourceProduct)({
        contentAri: contentAri ?? contentId,
        contentId: contentId,
        sourceProduct: contentProduct
    });
    if (isExternalShare && shareToken && (0, $6mKj3.expValEquals)('add_anonid_in_media_token', 'cohort', 'test')) {
        const tokenResponse = await (0, $I0A3i.fetchExternalContentMediaSessionToken)(shareToken);
        const tokenData = tokenResponse?.data;
        return {
            token: tokenData?.externalContentMediaSession?.accessTokens?.readOnlyToken?.value || '',
            config: tokenData?.externalContentMediaSession?.configuration || $17b0f8a5b73de479$var$DEFAULT_CONFIG
        };
    }
    // Fallback to existing logic for backward compatibility
    const response = await (isExternalShare ? (0, $I0A3i.fetchExternalShareMediaToken) : (0, $I0A3i.fetchMediaToken))(contentId);
    const data = response?.data;
    const externalData = data?.['singleContent'];
    const content = isExternalShare ? externalData : data?.['content']?.nodes?.[0];
    return {
        token: content?.body?.atlas_doc_format?.mediaToken?.token || '',
        config: data?.mediaConfiguration || $17b0f8a5b73de479$var$DEFAULT_CONFIG
    };
}, (json)=>json.token);
const $17b0f8a5b73de479$var$getContentIdFromCollection = (authContext)=>{
    const match = /^contentId-(\d+)$/.exec(authContext?.collectionName ?? '');
    return match?.[1];
};
const $17b0f8a5b73de479$export$6176af039388fdbf = (dataGetter)=>async (authContext)=>{
        const data = await dataGetter(authContext);
        return {
            token: data?.token || '',
            clientId: data?.config?.clientId || '',
            baseUrl: data?.config?.fileStoreUrl || ''
        };
    };
const $17b0f8a5b73de479$export$da46cefd33160c4d = (viewDataGetter, uploadDataGetter)=>async (params)=>{
        // Currently, supplying upload token only for file and collection update action.
        // If no params are provided, the view token is returned.
        const isUpdateAction = !!params?.access?.find(({ type: type, actions: actions })=>(type === 'file' || type == 'collection') && actions.includes('update'));
        const data = await (isUpdateAction ? uploadDataGetter() : viewDataGetter(params));
        return {
            token: data?.token || '',
            clientId: data?.config?.clientId || '',
            baseUrl: data?.config?.fileStoreUrl || ''
        };
    };
const $17b0f8a5b73de479$export$6cb774192b5cd093 = (contextId)=>{
    try {
        const { snippetId: snippetId, scope: scope } = JSON.parse(contextId);
        return snippetId ? {
            snippetId: snippetId,
            scope: scope
        } : undefined;
    } catch  {} // not JSON or not a SnippetContextId.
};
const $17b0f8a5b73de479$export$724cb324eb7535cd = async (contextId, contentProduct, contentAri)=>{
    if ((0, $3kI72.requiresCrossProductAuth)({
        hostProduct: 'confluence-page',
        sourceProduct: contentProduct
    })) {
        const auth = await (0, $3kI72.fetchTokenForSourceProduct)({
            contentAri: contentAri ?? contextId,
            contentId: contextId,
            sourceProduct: contentProduct
        });
        return {
            clientId: auth.config.clientId || '',
            token: auth.token || '',
            baseUrl: auth.config.fileStoreUrl || ''
        };
    }
    if ((0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false)) {
        const snippetContext = $17b0f8a5b73de479$export$6cb774192b5cd093(contextId);
        if (snippetContext && snippetContext.scope !== (0, $cga1x.SnippetScope).GLOBAL) {
            const auth = await (0, $2TuWI.fetchSnippetMediaToken)(snippetContext.snippetId);
            return {
                clientId: auth.clientId,
                token: auth.token,
                baseUrl: auth.baseUrl
            };
        }
    }
    const { collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = (0, $c4QoG.getTemplateMediaContextValues)(contextId);
    // template media informtion is stored slightly different in the context
    // to be able to discern which call to make
    if (collectionId || templateId) return (0, $c4QoG.getTemplateMediaAuth)({
        collectionId: collectionId,
        spaceKey: spaceKey,
        templateId: templateId
    });
    const response = await (0, $I0A3i.fetchMediaToken)(contextId);
    const { clientId: clientId = '', fileStoreUrl: fileStoreUrl = '' } = response?.data?.mediaConfiguration || {};
    return {
        clientId: clientId,
        token: response?.data?.content?.nodes?.[0]?.body?.atlas_doc_format?.mediaToken?.token || '',
        baseUrl: fileStoreUrl || ''
    };
};
const $17b0f8a5b73de479$var$cachedGetUploadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = options.contentType === 'comment' && options.cloudId ? await (0, $I0A3i.getCommentUploadToken)(options.contentId, options.cloudId) : await (0, $I0A3i.getUploadToken)(options.contentId);
    const session = response?.data?.contentMediaSession;
    return {
        token: session?.token?.value || '',
        config: session?.configuration || $17b0f8a5b73de479$var$DEFAULT_CONFIG,
        collectionId: session?.collection || ''
    };
}, (json)=>json.token);
const $17b0f8a5b73de479$var$getUploadCollectionId = async (options)=>{
    const uploadData = await $17b0f8a5b73de479$var$cachedGetUploadData.getValue(options);
    return uploadData.collectionId;
};
const $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter = (options)=>()=>$17b0f8a5b73de479$var$cachedGetUploadData.getValue(options);
const $17b0f8a5b73de479$var$getUploadMediaClientConfig = async (options)=>({
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)),
        getAuthFromContext: $17b0f8a5b73de479$export$724cb324eb7535cd,
        useSha256ForUploads: true
    });
const $17b0f8a5b73de479$var$createRenameFile = (mediaClientConfig, getCollection)=>{
    const mediaClient = new (0, $204vt.MediaClient)(mediaClientConfig);
    return async (fileId, name)=>{
        const collection = getCollection();
        if (!collection) throw new Error('Cannot rename media file without a collection');
        await mediaClient.mediaStore.request('/files/rename', {
            method: 'PUT',
            endpoint: '/files/rename',
            authContext: {
                collectionName: collection
            },
            params: {
                collection: collection
            },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                collection: collection,
                files: [
                    {
                        fileId: fileId,
                        fileName: name,
                        oldFileName: ''
                    }
                ]
            })
        });
    };
};
const $17b0f8a5b73de479$var$cachedGetExportDspData = (0, $kzNtP.cacheWithExp)(async ({ contentId: contentId, spaceKey: spaceKey })=>{
    const response = await (0, $I0A3i.getIsExportEnabledForContent)(contentId, spaceKey);
    const isExportAllowed = response?.data?.dataSecurityPolicy?.isActionEnabledForContent?.allowed;
    return {
        isExportAllowed: isExportAllowed,
        exp: Date.now() + 60000
    };
}, (json)=>json.exp);
const $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy = async (options)=>{
    if (!(0, $9wGTI.fg)('dlp_attachment_download_respects_data_export_dsp')) return false;
    const { contentId: contentId, spaceKey: spaceKey, mediaDspContentId: mediaDspContentId } = options;
    try {
        const relevantContentId = mediaDspContentId || contentId;
        const response = await $17b0f8a5b73de479$var$cachedGetExportDspData.getValue({
            contentId: relevantContentId,
            spaceKey: spaceKey
        });
        const isExportAllowed = response?.isExportAllowed;
        return !isExportAllowed;
    } catch  {
        // Fails CLOSED
        return true;
    }
};
const $17b0f8a5b73de479$var$createViewAuthProviderDataGetter = (options)=>async (authContext)=>{
        const contentIdFromCollection = options.resolveContentIdFromCollection && !options.isExternalShare && !options.mediaToken && options.contentProduct !== 'jira-work-item' && (0, $6mKj3.expValEquals)('platform_media_token_nested_macro', 'isEnabled', true) ? $17b0f8a5b73de479$var$getContentIdFromCollection(authContext) : undefined;
        const contentId = contentIdFromCollection ?? options.contentId;
        // Only pass contentId, isExternalShare, and shareToken to the cacheWithExp function
        // to avoid unnecessary re-fetching of the token if other options differ
        const authQueryOptions = {
            contentId: contentId,
            contentAri: options.contentAri,
            contentProduct: options.contentProduct,
            isExternalShare: options.isExternalShare,
            shareToken: options.shareToken
        };
        let data = await $17b0f8a5b73de479$var$cachedGetDownloadData.getValue(authQueryOptions);
        if (options.mediaToken) data = {
            ...data,
            token: options.mediaToken
        };
        // For drafts mediaToken by default is null and created once any media added to them
        // So, once publishing draft that just got media but token was cached before as `null`
        // we need to re-fetch the token without the cache
        if (!data.token) data = await $17b0f8a5b73de479$var$cachedGetDownloadData.forceGetValue(authQueryOptions);
        return data;
    };
const $17b0f8a5b73de479$export$9891be2d4fea1436 = async (options)=>{
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options)),
        getAuthFromContext: (contextId)=>$17b0f8a5b73de479$export$724cb324eb7535cd(contextId, options.contentProduct, options.contentAri)
    };
};
const $17b0f8a5b73de479$export$e43b4f8676d4deae = async (options)=>({
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$da46cefd33160c4d($17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options), $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)),
        getAuthFromContext: (contextId)=>$17b0f8a5b73de479$export$724cb324eb7535cd(contextId, options.contentProduct, options.contentAri)
    });
const $17b0f8a5b73de479$export$39c5d94533971b79 = async (options)=>({
        viewMediaClientConfig: await $17b0f8a5b73de479$export$9891be2d4fea1436(options)
    });
const $17b0f8a5b73de479$export$4887a1cde0f552dc = async (options)=>{
    $17b0f8a5b73de479$var$registerGlobalFileAddedListener(options);
    const [viewMediaClientConfig, uploadMediaClientConfig, viewAndUploadMediaClientConfig, collection] = await Promise.all([
        $17b0f8a5b73de479$export$9891be2d4fea1436(options),
        $17b0f8a5b73de479$var$getUploadMediaClientConfig(options),
        (0, $9wGTI.fg)('platform_media_video_captions') ? $17b0f8a5b73de479$export$e43b4f8676d4deae(options) : undefined,
        $17b0f8a5b73de479$var$getUploadCollectionId(options)
    ]);
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        uploadParams: {
            collection: collection,
            onUploadRejection: options.onUploadRejection
        },
        uploadMediaClientConfig: uploadMediaClientConfig,
        viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig,
        ...(0, $6mKj3.expValEquals)('platform_editor_media_file_rename_on_fallback', 'isEnabled', true) ? {
            renameFile: $17b0f8a5b73de479$var$createRenameFile(uploadMediaClientConfig, ()=>collection)
        } : {}
    };
};
const $17b0f8a5b73de479$export$c64cc28e06e9eda = (pathname)=>{
    return !!(0, $1NBp8.PDF_EXPORT_PAGE).match(pathname);
};
let $17b0f8a5b73de479$var$previousAttachUploadedMediaListener;
const $17b0f8a5b73de479$var$registerGlobalFileAddedListener = (options)=>{
    if ($17b0f8a5b73de479$var$previousAttachUploadedMediaListener) (0, $hfrng.globalMediaEventEmitter).off('file-added', $17b0f8a5b73de479$var$previousAttachUploadedMediaListener);
    $17b0f8a5b73de479$var$previousAttachUploadedMediaListener = (0, $kQiXs.attachUploadedMedia)(options);
    (0, $hfrng.globalMediaEventEmitter).on('file-added', $17b0f8a5b73de479$var$previousAttachUploadedMediaListener);
};
const $17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic = (getOptions)=>async (authContext)=>{
        const options = getOptions();
        return $17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options)(authContext);
    };
const $17b0f8a5b73de479$var$createUploadAuthProviderDataGetterDynamic = (getOptions)=>async ()=>{
        const options = getOptions();
        return $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)();
    };
const $17b0f8a5b73de479$export$af68076132bb2083 = async (getOptions)=>{
    const options = getOptions();
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic(getOptions)),
        getAuthFromContext: (contextId)=>$17b0f8a5b73de479$export$724cb324eb7535cd(contextId, getOptions().contentProduct, getOptions().contentAri)
    };
};
const $17b0f8a5b73de479$export$de798661504725b9 = async (getOptions)=>{
    const options = getOptions();
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$da46cefd33160c4d($17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic(getOptions), $17b0f8a5b73de479$var$createUploadAuthProviderDataGetterDynamic(getOptions)),
        getAuthFromContext: (contextId)=>$17b0f8a5b73de479$export$724cb324eb7535cd(contextId, getOptions().contentProduct, getOptions().contentAri)
    };
};
const $17b0f8a5b73de479$export$221251ab27f63f41 = async (getOptions)=>({
        viewMediaClientConfig: await $17b0f8a5b73de479$export$af68076132bb2083(getOptions)
    });
const $17b0f8a5b73de479$export$e6a9b44aa174a3d4 = async (getOptions)=>{
    const initialOptions = getOptions();
    $17b0f8a5b73de479$var$registerGlobalFileAddedListener(initialOptions);
    // Register the global file-added listener dynamically so that SPA navigations always
    // register the attachment callback against the current page's contentId.
    const registerDynamicFileAddedListener = ()=>{
        $17b0f8a5b73de479$var$registerGlobalFileAddedListener(getOptions());
    };
    // Track the last contentId we fetched upload data for, and the cached result.
    // This lets us detect a contentId change and eagerly re-fetch before any upload.
    let lastFetchedContentId = initialOptions.contentId;
    let latestUploadData;
    // Deduplicate concurrent calls to refreshUploadDataIfNeeded — if a refresh is already
    // in-flight (e.g. from useMediaOptions and authProvider both calling simultaneously),
    // subsequent callers share the same promise rather than racing to write latestUploadData.
    let inFlightRefresh;
    // Refresh upload data for the current options if contentId has changed since the
    // last fetch. Concurrent calls are deduplicated via inFlightRefresh.
    // Called by useMediaOptions on navigation so all uploadParams.collection read sites
    // get the correct collection without needing to do anything special themselves.
    const refreshUploadDataIfNeeded = async ()=>{
        const currentOptions = getOptions();
        if (currentOptions.contentId !== lastFetchedContentId) {
            if (inFlightRefresh) return inFlightRefresh;
            inFlightRefresh = (async ()=>{
                registerDynamicFileAddedListener();
                latestUploadData = await $17b0f8a5b73de479$var$cachedGetUploadData.getValue(currentOptions);
                lastFetchedContentId = currentOptions.contentId;
                inFlightRefresh = undefined;
            })();
            return inFlightRefresh;
        }
    };
    // Build a fully-dynamic uploadMediaClientConfig whose authProvider always fetches
    // upload data for the CURRENT options so tokens stay correct across SPA navigations.
    // Note: we do NOT call registerDynamicFileAddedListener here — the listener is only
    // re-registered in refreshUploadDataIfNeeded (on actual navigation), not on every
    // token fetch, to avoid unnecessary teardown/rebuild of the module-level singleton.
    const dynamicUploadMediaClientConfig = {
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf(async ()=>{
            const currentOptions = getOptions();
            const uploadData = await $17b0f8a5b73de479$var$cachedGetUploadData.getValue(currentOptions);
            latestUploadData = uploadData;
            lastFetchedContentId = currentOptions.contentId;
            return uploadData;
        }),
        getAuthFromContext: $17b0f8a5b73de479$export$724cb324eb7535cd,
        useSha256ForUploads: true
    };
    // Fetch all async dependencies in parallel — no waterfall.
    const [viewMediaClientConfig, viewAndUploadMediaClientConfig, initialUploadData] = await Promise.all([
        $17b0f8a5b73de479$export$af68076132bb2083(()=>getOptions()),
        (0, $9wGTI.fg)('platform_media_video_captions') ? $17b0f8a5b73de479$export$de798661504725b9(()=>getOptions()) : undefined,
        $17b0f8a5b73de479$var$cachedGetUploadData.getValue(getOptions())
    ]);
    latestUploadData = initialUploadData;
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        // uploadParams is resolved via a getter so SPA navigations don't leave the collection
        // frozen to the page that was active when this provider was first created.
        get uploadParams () {
            return {
                collection: latestUploadData.collectionId,
                onUploadRejection: getOptions().onUploadRejection
            };
        },
        refreshUploadDataIfNeeded: refreshUploadDataIfNeeded,
        uploadMediaClientConfig: dynamicUploadMediaClientConfig,
        viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig,
        ...(0, $6mKj3.expValEquals)('platform_editor_media_file_rename_on_fallback', 'isEnabled', true) ? {
            renameFile: $17b0f8a5b73de479$var$createRenameFile(dynamicUploadMediaClientConfig, ()=>latestUploadData.collectionId)
        } : {}
    };
}; /**
 * Usage sketch (React):
 * const liveOptionsRef = useRef(currentOptions);
 * liveOptionsRef.current = currentOptions; // update on changes
 * const providerPromise = useMemo(() => createEditorMediaProviderDynamic(() => liveOptionsRef.current), []);
 * editorApi.media.actions.setProvider(providerPromise);
 */ 
module.exports["createAuthProvider"] = $17b0f8a5b73de479$export$6176af039388fdbf;
module.exports["getAuthFromContext"] = $17b0f8a5b73de479$export$724cb324eb7535cd;
module.exports["getViewMediaClientConfig"] = $17b0f8a5b73de479$export$9891be2d4fea1436;
module.exports["createRendererMediaProvider"] = $17b0f8a5b73de479$export$39c5d94533971b79;
module.exports["createEditorMediaProvider"] = $17b0f8a5b73de479$export$4887a1cde0f552dc;
module.exports["controlDataExportOnCertainFeatures"] = $17b0f8a5b73de479$export$c64cc28e06e9eda;
module.exports["createRendererMediaProviderDynamic"] = $17b0f8a5b73de479$export$221251ab27f63f41;
module.exports["createEditorMediaProviderDynamic"] = $17b0f8a5b73de479$export$e6a9b44aa174a3d4;

});

parcelRegister("3kI72", function(module, exports) {

var $oWJUu = parcelRequire("oWJUu");


var $55mlV = parcelRequire("55mlV");

const $515968ab7e772985$export$8953ee4427cc19a2 = ({ hostProduct: hostProduct, sourceProduct: sourceProduct })=>{
    return !!sourceProduct && sourceProduct !== hostProduct;
};
const $515968ab7e772985$export$9f88fc74c33fbfe = ({ contentAri: contentAri, contentId: contentId, sourceProduct: sourceProduct })=>{
    switch(sourceProduct){
        case 'confluence-page':
            return (0, $oWJUu.fetchMediaToken)(contentId);
        case 'jira-work-item':
            return (0, $55mlV.fetchJiraMediaToken)(contentAri);
        default:
            throw new Error(`Unsupported source product for token fetch: ${sourceProduct}`);
    }
};
module.exports["requiresCrossProductAuth"] = $515968ab7e772985$export$8953ee4427cc19a2;
module.exports["fetchTokenForSourceProduct"] = $515968ab7e772985$export$9f88fc74c33fbfe;

});

parcelRegister("oWJUu", function(module, exports) {

var $jv11C = parcelRequire("jv11C");


var $48FpT = parcelRequire("48FpT");

const $61ef070287c5800f$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $61ef070287c5800f$var$AGG_HEADERS = {
    'X-ExperimentalApi': 'confluence-agg-beta'
};
const $61ef070287c5800f$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $61ef070287c5800f$var$GET_CONTENT_MEDIA_SESSION_OPERATION_NAME = 'MediaUploadTokenQuery';
const $61ef070287c5800f$var$GET_CONTENT_MEDIA_SESSION_QUERY = `query ${$61ef070287c5800f$var$GET_CONTENT_MEDIA_SESSION_OPERATION_NAME}($contentId: ID!) {
	contentMediaSession(contentId: $contentId) {
		token {
			value
		}
		configuration {
			clientId
			fileStoreUrl
		}
		collection
	}
}`;
const $61ef070287c5800f$var$getContentMediaSession = async (contentId)=>{
    const bodyData = {
        query: $61ef070287c5800f$var$GET_CONTENT_MEDIA_SESSION_QUERY,
        operationName: $61ef070287c5800f$var$GET_CONTENT_MEDIA_SESSION_OPERATION_NAME,
        variables: {
            contentId: contentId
        }
    };
    const response = await (0, $48FpT.fetchWithRetry)($61ef070287c5800f$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            ...$61ef070287c5800f$var$COMMON_HEADERS,
            ...$61ef070287c5800f$var$AGG_HEADERS
        },
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new Error(`Failed to get content media session: ${response.statusText}`);
    const result = await response.json();
    return result;
};
const $61ef070287c5800f$export$2b7fb70f168591f8 = async (contentId)=>{
    try {
        const response = await $61ef070287c5800f$var$getContentMediaSession(contentId);
        const contentData = response.data?.contentMediaSession;
        const token = contentData?.token?.value;
        const configuration = contentData?.configuration;
        const collection = contentData?.collection;
        if (!token || !configuration || !collection) throw new Error('Failed to get content media session data');
        return {
            config: configuration,
            token: token,
            collectionId: collection
        };
    } catch (error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-synced-block-provider/fetchMediaToken'
        });
        const errorMsg = error instanceof Error ? error.message : String(error);
        throw new Error(`Failed to get content media session: ${errorMsg}`);
    }
};
module.exports["fetchMediaToken"] = $61ef070287c5800f$export$2b7fb70f168591f8;

});

parcelRegister("55mlV", function(module, exports) {

var $jv11C = parcelRequire("jv11C");


var $48FpT = parcelRequire("48FpT");


var $EBNuL = parcelRequire("EBNuL");

const $05854aa166d857a3$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $05854aa166d857a3$var$AGG_HEADERS = {
    'X-ExperimentalApi': 'confluence-agg-beta'
};
const $05854aa166d857a3$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $05854aa166d857a3$var$JIRA_MEDIA_READ_TOKEN_MAX_TOKEN_LENGTH = 2048;
const $05854aa166d857a3$var$GET_JIRA_MEDIA_READ_TOKEN_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_JIRA_MEDIA_TOKEN';
const $05854aa166d857a3$var$GET_JIRA_MEDIA_READ_TOKEN_QUERY = `query ${$05854aa166d857a3$var$GET_JIRA_MEDIA_READ_TOKEN_OPERATION_NAME}($issueAri: ID!, $maxTokenLength: Int!) {
  jira {
    issueById(id: $issueAri) {
      mediaReadToken(maxTokenLength: $maxTokenLength) @optIn(to: "JiraMediaReadTokenInIssue") {
        clientId
        endpointUrl
        tokenLifespanInSeconds
        tokensWithFiles {
          edges {
            node {
              token
            }
          }
        }
      }
    }
  }
}`;
const $05854aa166d857a3$var$getJiraMediaReadToken = async (issueAri)=>{
    const bodyData = {
        query: $05854aa166d857a3$var$GET_JIRA_MEDIA_READ_TOKEN_QUERY,
        operationName: $05854aa166d857a3$var$GET_JIRA_MEDIA_READ_TOKEN_OPERATION_NAME,
        variables: {
            issueAri: issueAri,
            maxTokenLength: $05854aa166d857a3$var$JIRA_MEDIA_READ_TOKEN_MAX_TOKEN_LENGTH
        }
    };
    const response = await (0, $48FpT.fetchWithRetry)($05854aa166d857a3$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            ...$05854aa166d857a3$var$COMMON_HEADERS,
            ...$05854aa166d857a3$var$AGG_HEADERS
        },
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new Error(`Failed to get Jira media read token: ${response.statusText}`);
    return await response.json();
};
const $05854aa166d857a3$export$5bc7dcc953e26849 = async (sourceAri)=>{
    try {
        const issueAri = (0, $EBNuL.getJiraIssueAriFromSourceAri)({
            ari: sourceAri
        });
        const response = await $05854aa166d857a3$var$getJiraMediaReadToken(issueAri);
        const mediaReadToken = response.data?.jira?.issueById?.mediaReadToken;
        const clientId = mediaReadToken?.clientId;
        const endpointUrl = mediaReadToken?.endpointUrl;
        // Use the first available token from tokensWithFiles, or fall back to empty string.
        // A generic read token (without specific file IDs) is sufficient for rendering.
        const token = mediaReadToken?.tokensWithFiles?.edges?.[0]?.node?.token ?? '';
        if (!clientId || !endpointUrl) throw new Error('Missing clientId or endpointUrl');
        return {
            config: {
                clientId: clientId,
                fileStoreUrl: endpointUrl
            },
            token: token
        };
    } catch (error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-synced-block-provider/fetchJiraMediaToken'
        });
        const errorMsg = error instanceof Error ? error.message : String(error);
        throw new Error(`Failed to get Jira media read token: ${errorMsg}`);
    }
};
module.exports["fetchJiraMediaToken"] = $05854aa166d857a3$export$5bc7dcc953e26849;

});

parcelRegister("2TuWI", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $15f98e0699368f56$var$BLOCK_SERVICE_SNIPPETS_MEDIA_TOKEN_URL = '/gateway/api/blocks/v1/snippets';
const $15f98e0699368f56$export$73c71f9590626082 = async (snippetId)=>{
    try {
        const response = await (0, $f7B1p.cfetch)(`${$15f98e0699368f56$var$BLOCK_SERVICE_SNIPPETS_MEDIA_TOKEN_URL}/${snippetId}/media-token`, {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        });
        const data = await response.json();
        const collectionId = data.collectionNames?.[snippetId];
        return {
            clientId: data.config.clientId,
            token: data.token,
            baseUrl: data.config.fileStoreUrl,
            ...collectionId !== undefined && {
                collectionId: collectionId
            }
        };
    } catch (error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS
        });
        throw error;
    }
};
module.exports["fetchSnippetMediaToken"] = $15f98e0699368f56$export$73c71f9590626082;

});

parcelRegister("cga1x", function(module, exports) {
/** Define the source of the snippets */ var $bd320fc30ef678ce$export$100829e61c5df591 = /*#__PURE__*/ function(SnippetScope) {
    SnippetScope["GLOBAL"] = "GLOBAL";
    SnippetScope["USER"] = "USER";
    SnippetScope["SITE"] = "SITE";
    return SnippetScope;
}({});
module.exports["SnippetScope"] = $bd320fc30ef678ce$export$100829e61c5df591;

});

parcelRegister("kzNtP", function(module, exports) {

var $6AroL = parcelRequire("6AroL");


var $3u5lg = parcelRequire("3u5lg");

const $852f3734fd3706d8$var$BUFFER_MS = 60000; // refresh token 60 seconds before it expires
const $852f3734fd3706d8$var$EMPTY = [
    -Infinity,
    null,
    null
];
function $852f3734fd3706d8$export$d18015d30d3c28a4(asyncFunction, tokenOrExpInMsAccessor, tokenExpBufferInMs = $852f3734fd3706d8$var$BUFFER_MS) {
    const cache = {};
    async function getValue(arg, force) {
        // It is ok to have clashing hash because we are going to check args anyway
        // Worse case is calling fn() more often than it should
        let hash = '';
        try {
            hash = JSON.stringify(arg);
        } catch  {}
        const [exp, lastArg, lastValue] = cache[hash] || $852f3734fd3706d8$var$EMPTY;
        if (force || exp <= Date.now() || !(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(lastArg, arg)) {
            const value = await asyncFunction(arg);
            let tokenOrExp = null;
            try {
                tokenOrExp = tokenOrExpInMsAccessor(value);
            } catch (e) {}
            let exp = null;
            if (tokenOrExp) {
                if (!isNaN(tokenOrExp)) exp = Number(tokenOrExp);
                else if (typeof tokenOrExp === 'string') try {
                    exp = (0, $6AroL.default)(tokenOrExp).exp * 1000 - tokenExpBufferInMs;
                } catch (e) {}
            }
            cache[hash] = exp === null ? $852f3734fd3706d8$var$EMPTY : [
                exp,
                arg,
                value
            ];
            return value;
        }
        return lastValue;
    }
    return {
        forceGetValue: (arg)=>{
            return getValue(arg, true);
        },
        getValue: (arg)=>{
            return getValue(arg, false);
        }
    };
}
module.exports["cacheWithExp"] = $852f3734fd3706d8$export$d18015d30d3c28a4;

});

parcelRegister("6AroL", function(module, exports) {
function $4cbb5ba451601f11$var$e(e) {
    this.message = e;
}
$4cbb5ba451601f11$var$e.prototype = new Error, $4cbb5ba451601f11$var$e.prototype.name = "InvalidCharacterError";
var $4cbb5ba451601f11$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $4cbb5ba451601f11$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $4cbb5ba451601f11$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($4cbb5ba451601f11$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $4cbb5ba451601f11$var$r(t);
    }
}
function $4cbb5ba451601f11$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $4cbb5ba451601f11$var$o(e, r) {
    if ("string" != typeof e) throw new $4cbb5ba451601f11$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($4cbb5ba451601f11$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $4cbb5ba451601f11$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$4cbb5ba451601f11$export$b9721ef022f71a68.prototype = new Error, $4cbb5ba451601f11$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $4cbb5ba451601f11$export$2e2bcd8739ae039 = $4cbb5ba451601f11$var$o;
 //# sourceMappingURL=jwt-decode.esm.js.map
module.exports["default"] = $4cbb5ba451601f11$export$2e2bcd8739ae039;

});

parcelRegister("c4QoG", function(module, exports) {

var $kzNtP = parcelRequire("kzNtP");


var $4IoVL = parcelRequire("4IoVL");


var $7EQEd = parcelRequire("7EQEd");

// blueprints/templates in uuid form are technically a new template
const $30f3da79b755ac50$var$isBlueprint = (templateId)=>!/^[0-9]+$/.test(templateId);
const $30f3da79b755ac50$var$isNewTemplate = (templateId)=>!templateId || templateId === '';
const $30f3da79b755ac50$var$shouldUseTemplateId = (templateIds)=>templateIds.length;
const $30f3da79b755ac50$var$formatTemplateId = (templateId, isFirstLoad, isUpload)=>{
    if ($30f3da79b755ac50$var$isNewTemplate(templateId) || $30f3da79b755ac50$var$isBlueprint(templateId) && isUpload || !isFirstLoad) return [];
    else return [
        templateId
    ];
};
const $30f3da79b755ac50$var$cachedGetTemplateUploadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = await (0, $7EQEd.getTemplateUploadToken)({
        spaceKey: options.spaceKey,
        templateIds: options.templateIds,
        collectionId: options.collectionId
    });
    const session = response?.data?.templateMediaSession;
    const collectionId = session?.collections?.[0]?.value || '';
    return {
        token: session?.uploadToken?.value || '',
        config: session?.configuration || {
            fileStoreUrl: '',
            clientId: ''
        },
        collectionId: collectionId
    };
}, (json)=>json.token);
const $30f3da79b755ac50$var$cachedGetTemplateDownloadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = await (0, $7EQEd.getTemplateDownloadToken)({
        spaceKey: options.spaceKey,
        templateIds: options.templateIds,
        collectionId: options.collectionId
    });
    return {
        token: response?.data?.templateMediaSession?.downloadToken?.value || '',
        config: response?.data?.templateMediaSession?.configuration || {
            fileStoreUrl: '',
            clientId: ''
        }
    };
}, (json)=>json.token);
const $30f3da79b755ac50$export$ea5d75839efa2930 = async (editorOptions)=>{
    const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, !editorOptions.collectionId, true);
    const uploadData = await $30f3da79b755ac50$var$cachedGetTemplateUploadData.getValue({
        ...editorOptions,
        templateIds: templateIds,
        collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : editorOptions.collectionId
    });
    return uploadData.collectionId;
};
const $30f3da79b755ac50$export$8867d7a854cea94a = (contextId)=>{
    let collectionId, templateId, spaceKey = null;
    try {
        ({ collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = JSON.parse(contextId));
    } catch (_) {}
    return {
        collectionId: collectionId,
        templateId: templateId,
        spaceKey: spaceKey
    };
};
const $30f3da79b755ac50$export$c52d46b5239d3052 = async ({ templateId: templateId, collectionId: collectionId, spaceKey: spaceKey })=>{
    // if given a templateId the source is the renderer, otherwise it's the editor
    const response = await (0, $7EQEd.getTemplateDownloadToken)({
        templateIds: templateId ? [
            templateId
        ] : [],
        collectionId: templateId ? null : collectionId,
        spaceKey: spaceKey
    });
    const { clientId: clientId = '', fileStoreUrl: fileStoreUrl = '' } = response?.data?.templateMediaSession?.configuration || {};
    return {
        clientId: clientId,
        token: response?.data?.templateMediaSession?.downloadToken?.value || '',
        baseUrl: fileStoreUrl
    };
};
const $30f3da79b755ac50$var$getAuthFromContext = async (contextId)=>{
    const { collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = $30f3da79b755ac50$export$8867d7a854cea94a(contextId);
    // templateID = null/undefined -> not template type
    // templateId = "" -> new template
    // templateId = "2394234324" -> user modified template
    // templateId = "23j4h-23jk4h-kj2h34-kj23h4" -> new template
    if (typeof collectionId !== 'string' && typeof templateId !== 'string') // copy source is page contentType
    return (0, $4IoVL.getAuthFromContext)(contextId);
    return $30f3da79b755ac50$export$c52d46b5239d3052({
        collectionId: collectionId,
        spaceKey: spaceKey,
        templateId: templateId
    });
};
const $30f3da79b755ac50$export$e7a68a11bc740f17 = (options)=>{
    return {
        authProvider: (0, $4IoVL.createAuthProvider)(async ()=>$30f3da79b755ac50$var$cachedGetTemplateDownloadData.getValue(options)),
        getAuthFromContext: $30f3da79b755ac50$var$getAuthFromContext
    };
};
const $30f3da79b755ac50$export$4f3a63958bc8e871 = (options)=>{
    return Promise.resolve({
        viewMediaClientConfig: $30f3da79b755ac50$export$e7a68a11bc740f17(options)
    });
};
const $30f3da79b755ac50$export$582e7673a587f23a = async (options)=>{
    let isFirstDownload = true;
    let collectionId = options.collectionId;
    const getEditorViewTemplateMediaClientConfig = (editorOptions)=>{
        return {
            authProvider: (0, $4IoVL.createAuthProvider)(async ()=>{
                const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, isFirstDownload, false);
                isFirstDownload = false;
                return $30f3da79b755ac50$var$cachedGetTemplateDownloadData.getValue({
                    ...editorOptions,
                    templateIds: templateIds,
                    collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : collectionId
                });
            }),
            getAuthFromContext: (context)=>{
                isFirstDownload = false;
                return $30f3da79b755ac50$var$getAuthFromContext(context);
            }
        };
    };
    const getTemplateMediaUploadMediaClientConfig = (editorOptions)=>{
        return {
            authProvider: (0, $4IoVL.createAuthProvider)(()=>{
                const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, !collectionId, true);
                return $30f3da79b755ac50$var$cachedGetTemplateUploadData.getValue({
                    ...editorOptions,
                    templateIds: templateIds,
                    collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : collectionId
                });
            }),
            getAuthFromContext: (context)=>{
                return $30f3da79b755ac50$var$getAuthFromContext(context);
            }
        };
    };
    const viewMediaClientConfig = getEditorViewTemplateMediaClientConfig(options);
    const uploadMediaClientConfig = getTemplateMediaUploadMediaClientConfig(options);
    const collection = await $30f3da79b755ac50$export$ea5d75839efa2930(options);
    collectionId = collection || null;
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        uploadParams: {
            collection: collection,
            onUploadRejection: options.onUploadRejection
        },
        uploadMediaClientConfig: uploadMediaClientConfig
    };
};
module.exports["getTemplateUploadCollectionId"] = $30f3da79b755ac50$export$ea5d75839efa2930;
module.exports["getTemplateMediaContextValues"] = $30f3da79b755ac50$export$8867d7a854cea94a;
module.exports["getTemplateMediaAuth"] = $30f3da79b755ac50$export$c52d46b5239d3052;
module.exports["createRendererTemplateMediaProvider"] = $30f3da79b755ac50$export$4f3a63958bc8e871;
module.exports["createTemplateEditorMediaProvider"] = $30f3da79b755ac50$export$582e7673a587f23a;

});

parcelRegister("7EQEd", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $6UhpO = parcelRequire("6UhpO");


var $23pnW = parcelRequire("23pnW");


var $c0rhi = parcelRequire("c0rhi");

const $bced78bb0973f66e$export$852d9acd488f2352 = async ({ spaceKey: spaceKey, templateIds: templateIds, collectionId: collectionId = null })=>{
    return (0, $c0rhi.queryInterop)({
        query: (0, $6UhpO.default),
        variables: {
            spaceKey: spaceKey || null,
            templateIds: templateIds,
            collectionId: collectionId
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "fabric-media-support"
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
const $bced78bb0973f66e$export$779a7b38112a4dbb = async ({ spaceKey: spaceKey, templateIds: templateIds, collectionId: collectionId = null })=>{
    return (0, $c0rhi.queryInterop)({
        query: (0, $23pnW.default),
        variables: {
            spaceKey: spaceKey || null,
            templateIds: templateIds,
            collectionId: collectionId
        },
        fetchPolicy: 'no-cache',
        __callerPackage__: "fabric-media-support"
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
module.exports["getTemplateDownloadToken"] = $bced78bb0973f66e$export$852d9acd488f2352;
module.exports["getTemplateUploadToken"] = $bced78bb0973f66e$export$779a7b38112a4dbb;

});

parcelRegister("6UhpO", function(module, exports) {
/**
 * @generated SignedSource<<6f71e30a6f3ff9ae17bdb70469621c47>>
 * @relayHash 7da80c4186ab379cb41cda405bebee65
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b087f1d76c63fdcc9767cdf0710dfa4efaf3f7db7a96f39d1b7b4eef575b40c1
const $ba0dcc1d393f4102$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "collectionId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "templateIds"
    }, v3 = {
        "kind": "ScalarField",
        "name": "value"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "collectionId",
                    "variableName": "collectionId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "templateIds",
                    "variableName": "templateIds"
                }
            ],
            "concreteType": "TemplateMediaSession",
            "kind": "LinkedField",
            "name": "templateMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MapOfStringToString",
                    "kind": "LinkedField",
                    "name": "collections",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        }
                    ]
                },
                {
                    "concreteType": "TemplateMediaToken",
                    "kind": "LinkedField",
                    "name": "downloadToken",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "duration"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "TemplateMediaSessionDownloadQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "TemplateMediaSessionDownloadQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "7da80c4186ab379cb41cda405bebee65",
            "id": "b087f1d76c63fdcc9767cdf0710dfa4efaf3f7db7a96f39d1b7b4eef575b40c1",
            "metadata": {},
            "name": "TemplateMediaSessionDownloadQuery",
            "operationKind": "query",
            "text": "query TemplateMediaSessionDownloadQuery($spaceKey:String,$templateIds:[String]!,$collectionId:String){templateMediaSession(spaceKey:$spaceKey,templateIds:$templateIds,collectionId:$collectionId){collections{key,value},configuration{fileStoreUrl,clientId},downloadToken{value,duration}}}"
        }
    };
}();
$ba0dcc1d393f4102$var$node.hash = "cb69ec0c674b12c3415c2289771f970f";
var $ba0dcc1d393f4102$export$2e2bcd8739ae039 = $ba0dcc1d393f4102$var$node;
module.exports["default"] = $ba0dcc1d393f4102$export$2e2bcd8739ae039;

});

parcelRegister("23pnW", function(module, exports) {
/**
 * @generated SignedSource<<d8493d612cba7ab67c2663a1ef2f2968>>
 * @relayHash f5528f55bdab5a02587ef6cd5262334d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7ce5237137eaa73015ff248d0a763c44e037f18ed58c1bb4ff3b73e41cc13059
const $d22835c5674bcb0e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "collectionId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "templateIds"
    }, v3 = {
        "kind": "ScalarField",
        "name": "value"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "collectionId",
                    "variableName": "collectionId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "templateIds",
                    "variableName": "templateIds"
                }
            ],
            "concreteType": "TemplateMediaSession",
            "kind": "LinkedField",
            "name": "templateMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MapOfStringToString",
                    "kind": "LinkedField",
                    "name": "collections",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        }
                    ]
                },
                {
                    "concreteType": "TemplateMediaToken",
                    "kind": "LinkedField",
                    "name": "uploadToken",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "duration"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "TemplateMediaSessionUploadQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "TemplateMediaSessionUploadQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "f5528f55bdab5a02587ef6cd5262334d",
            "id": "7ce5237137eaa73015ff248d0a763c44e037f18ed58c1bb4ff3b73e41cc13059",
            "metadata": {},
            "name": "TemplateMediaSessionUploadQuery",
            "operationKind": "query",
            "text": "query TemplateMediaSessionUploadQuery($spaceKey:String,$templateIds:[String]!,$collectionId:String){templateMediaSession(spaceKey:$spaceKey,templateIds:$templateIds,collectionId:$collectionId){collections{key,value},configuration{fileStoreUrl,clientId},uploadToken{value,duration}}}"
        }
    };
}();
$d22835c5674bcb0e$var$node.hash = "1d0108dcbf48addfcc8b1c4145c7178d";
var $d22835c5674bcb0e$export$2e2bcd8739ae039 = $d22835c5674bcb0e$var$node;
module.exports["default"] = $d22835c5674bcb0e$export$2e2bcd8739ae039;

});

parcelRegister("I0A3i", function(module, exports) {

var $6IsMq = parcelRequire("6IsMq");


var $3j8TZ = parcelRequire("3j8TZ");


var $iTcHJ = parcelRequire("iTcHJ");


var $bS81H = parcelRequire("bS81H");


var $1UWNP = parcelRequire("1UWNP");


var $6AroL = parcelRequire("6AroL");


var $7Sm4c = parcelRequire("7Sm4c");


var $aMcHK = parcelRequire("aMcHK");


var $9wGTI = parcelRequire("9wGTI");


var $c0rhi = parcelRequire("c0rhi");


var $lUobS = parcelRequire("lUobS");


var $62FVQ = parcelRequire("62FVQ");


var $6mmMU = parcelRequire("6mmMU");


var $egLSs = parcelRequire("egLSs");


var $dqLCu = parcelRequire("dqLCu");

const $1fd47ba2b01e31e6$var$DSPIsActionEnabledForContentQuery = (0, $bS81H.default);
const $1fd47ba2b01e31e6$var$FetchMediaTokenQuery = (0, $iTcHJ.default);
const $1fd47ba2b01e31e6$export$96b44174d5bb0faa = (0, $3j8TZ.default);
const $1fd47ba2b01e31e6$var$JiraFetchMediaTokenQuery = (0, $6IsMq.default);
let $1fd47ba2b01e31e6$var$isFirstLoad = true;
const $1fd47ba2b01e31e6$export$f3bf3f7b03608218 = (requestBody)=>{
    if (requestBody.contentType === 'comment') // Hard disable drag-and-drop upload functionality for comments
    return;
    // Normal uploads (file browser, copy-paste, etc.) go through the regular upload mutation.
    return (0, $egLSs.experimentalFileUploadMutate)({
        variables: requestBody
    });
};
const $1fd47ba2b01e31e6$export$2b7fb70f168591f8 = (contentId)=>(0, $c0rhi.queryInterop)({
        query: $1fd47ba2b01e31e6$var$FetchMediaTokenQuery,
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft',
                'archived'
            ],
            missingContentId: !contentId
        },
        context: {
            allowOnExternalPage: true
        },
        // If SSR has populated the cache then we want to use the cache when rendering SPA-over-SSR
        fetchPolicy: $1fd47ba2b01e31e6$var$isFirstLoad ? 'cache-first' : 'network-only',
        __callerPackage__: "fabric-media-support"
    }).then(/* onFulfilled */ (value)=>{
        $1fd47ba2b01e31e6$var$isFirstLoad = false;
        try {
            $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors(contentId)(value?.error?.graphQLErrors);
        } catch  {}
        return value;
    }, /* onRejected */ (reason)=>{
        try {
            $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors(contentId)(reason?.graphQLErrors, reason?.networkError);
        } catch  {}
        throw reason;
    });
let $1fd47ba2b01e31e6$var$isFirstLoadJira = true;
const $1fd47ba2b01e31e6$export$5bc7dcc953e26849 = (issueAri)=>(0, $c0rhi.queryInterop)({
        query: $1fd47ba2b01e31e6$var$JiraFetchMediaTokenQuery,
        variables: {
            issueAri: issueAri,
            maxTokenLength: 65536
        },
        context: {
            allowOnExternalPage: true
        },
        // If SSR has populated the cache then we want to use the cache when rendering SPA-over-SSR
        fetchPolicy: $1fd47ba2b01e31e6$var$isFirstLoadJira ? 'cache-first' : 'network-only',
        __callerPackage__: "fabric-media-support"
    }).then(/* onFulfilled */ (value)=>{
        $1fd47ba2b01e31e6$var$isFirstLoadJira = false;
        try {
            $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors(issueAri)(value?.error?.graphQLErrors);
        } catch  {}
        return value;
    }, /* onRejected */ (reason)=>{
        try {
            $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors(issueAri)(reason?.graphQLErrors, reason?.networkError);
        } catch  {}
        throw reason;
    });
/**
 * `fetchMediaToken` is called repetitively to renew the token before it
 * expires. If an error condition arises (because of frontend or backend), the
 * same error(s) may be reported as unhandled to our analytics and monitoring at
 * a very high rate/volume. Such repetitive reporting fron one user in one tab
 * is noisy. `throttleFetchMediaTokenErrors` attempts to reduce the noise.
 */ const $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((_cacheKey)=>{
    /**
   * The errors that happened last time. The `GraphQLError` instances are big
   * and are not trivial to compare so `prevErrors` caches partial info.
   */ let prevErrors = undefined;
    return (graphQLErrors, networkError)=>{
        // Each of `graphQLErrors` and `networkError` are reported to analytics and
        // monitoring so type of `Error` does not matter to what follows and
        // `GraphQLError` is the most convenient TypeScript type to deal with.
        if (networkError) graphQLErrors = (graphQLErrors || []).concat(networkError);
        if (graphQLErrors) {
            /**
       * The new/current errors which will become `prevErrors` at the end of
       * this iteration.
       */ const nextErrors = {};
            for (const graphQLError of graphQLErrors){
                // Extract the partial, easy-to-compare, cachable info from the big
                // `GraphQLError` instance:
                const message = graphQLError.message || String(graphQLError) || graphQLError.originalError?.message || String(graphQLError.originalError);
                const { path: path } = graphQLError;
                const key = Array.isArray(path) && path.join('.') || message;
                if (key) {
                    const value = (0, $aMcHK.getStatusCode)(graphQLError) || message;
                    if (value) {
                        nextErrors[key] = value;
                        // If a similar error happened in the previous iteration, do not
                        // report it to analytics and monitoring again:
                        if (prevErrors?.[key] === value) (0, $7Sm4c.markErrorAsHandled)(graphQLError);
                    }
                }
            }
            prevErrors = nextErrors;
        } else // If `MediaDownloadTokenQuery` succeeds, report subsequent/future errors
        // even if similar ones occurred and were reported before the current
        // success - there is a meaningful change in state and it may be useful in
        // debugging.
        prevErrors = undefined;
    };
});
const $1fd47ba2b01e31e6$export$e5e77dc812ab6e52 = (contentId)=>(0, $c0rhi.queryInterop)({
        query: (0, $lUobS.default),
        variables: {
            contentId: contentId
        },
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "fabric-media-support"
    });
const $1fd47ba2b01e31e6$export$db4c125247d46dd = (shareToken)=>(0, $c0rhi.queryInterop)({
        query: (0, $dqLCu.default),
        variables: {
            shareToken: shareToken
        },
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "fabric-media-support"
    });
const $1fd47ba2b01e31e6$export$2b96f2ad626f63d2 = (contentId)=>(0, $c0rhi.queryInterop)({
        query: (0, $62FVQ.default),
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'no-cache',
        __callerPackage__: "fabric-media-support"
    });
const $1fd47ba2b01e31e6$export$de87322aceb1e609 = async (contentId)=>{
    if (!(0, $9wGTI.fg)('confluence-media-upload-token-cache')) return $1fd47ba2b01e31e6$export$2b96f2ad626f63d2(contentId);
    try {
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: (0, $62FVQ.default),
            variables: {
                contentId: contentId
            },
            fetchPolicy: 'cache-first',
            __callerPackage__: "fabric-media-support"
        });
        const token = data?.contentMediaSession?.token?.value;
        if (token) {
            const { exp: exp } = (0, $6AroL.default)(token);
            const currentTime = Math.floor(Date.now() / 1000);
            // Check if the token has not expired
            if (exp > currentTime) return {
                data: data
            };
        }
    } catch  {
    // Fall through to refetch on decode failure
    }
    // Refetch with network-only policy if token is expired, or invalid
    return (0, $c0rhi.queryInterop)({
        query: (0, $62FVQ.default),
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "fabric-media-support"
    });
};
const $1fd47ba2b01e31e6$export$4205291ac54c446e = async (contentId, cloudId)=>{
    try {
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: (0, $6mmMU.default),
            variables: {
                cloudId: cloudId,
                contentId: contentId
            },
            fetchPolicy: 'cache-first',
            __callerPackage__: "fabric-media-support"
        });
        const token = data?.contentMediaSession?.token?.value;
        if (token) {
            const { exp: exp } = (0, $6AroL.default)(token);
            const currentTime = Math.floor(Date.now() / 1000);
            // Check if the token has not expired
            if (exp > currentTime) return {
                data: data
            };
        }
    } catch  {
    // Fall through to refetch on decode failure
    }
    // Refetch with network-only policy if token is expired, or invalid
    return (0, $c0rhi.queryInterop)({
        query: (0, $6mmMU.default),
        variables: {
            cloudId: cloudId,
            contentId: contentId
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "fabric-media-support"
    });
};
const $1fd47ba2b01e31e6$export$4777fc7c5d601381 = (contentId, spaceKey)=>{
    const action = (0, $9wGTI.fg)('cc-dlp_split-attachment-dl-from-export-dsp') ? 'ATTACHMENT_DOWNLOAD' : 'PAGE_EXPORT';
    const variables = {
        action: action,
        contentId: contentId,
        contentStatus: 'CURRENT',
        contentVersion: 1,
        ...spaceKey && {
            spaceKey: spaceKey
        }
    };
    /* Note -> a relay-compatible replacement is available in the @confluence/data-security package.
   * Using queryInterop for compatibility with Relay migration
   */ return (0, $c0rhi.queryInterop)({
        query: $1fd47ba2b01e31e6$var$DSPIsActionEnabledForContentQuery,
        variables: variables,
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'cache-first',
        __callerPackage__: "fabric-media-support"
    });
};
module.exports["setAttachment"] = $1fd47ba2b01e31e6$export$f3bf3f7b03608218;
module.exports["fetchMediaToken"] = $1fd47ba2b01e31e6$export$2b7fb70f168591f8;
module.exports["fetchExternalShareMediaToken"] = $1fd47ba2b01e31e6$export$e5e77dc812ab6e52;
module.exports["fetchExternalContentMediaSessionToken"] = $1fd47ba2b01e31e6$export$db4c125247d46dd;
module.exports["getUploadToken"] = $1fd47ba2b01e31e6$export$de87322aceb1e609;
module.exports["getCommentUploadToken"] = $1fd47ba2b01e31e6$export$4205291ac54c446e;
module.exports["getIsExportEnabledForContent"] = $1fd47ba2b01e31e6$export$4777fc7c5d601381;

});

parcelRegister("lUobS", function(module, exports) {
/**
 * @generated SignedSource<<57e8668d9fe3c9f67ee75bb15b6e474f>>
 * @relayHash ea7172d4f00c5846ec23ab207abff057
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID def5df9707285fd6e6ce8403c4b6e14be14ec1bc83092c3a8315bd1cae3d8b6e
const $2624e38a54eebf0f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "atlas_doc_format",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "EmbeddedMediaToken",
                                    "kind": "LinkedField",
                                    "name": "mediaToken",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "token"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "mediaConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ExternalShareMediaDownloadTokenQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ExternalShareMediaDownloadTokenQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "ea7172d4f00c5846ec23ab207abff057",
            "id": "def5df9707285fd6e6ce8403c4b6e14be14ec1bc83092c3a8315bd1cae3d8b6e",
            "metadata": {},
            "name": "ExternalShareMediaDownloadTokenQuery",
            "operationKind": "query",
            "text": "query ExternalShareMediaDownloadTokenQuery($contentId:ID!){singleContent(id:$contentId){id,body{atlas_doc_format{mediaToken{token}}}},mediaConfiguration{clientId,fileStoreUrl}}"
        }
    };
}();
$2624e38a54eebf0f$var$node.hash = "3592e1b2dcd3aa2c38a177d9b363dafe";
var $2624e38a54eebf0f$export$2e2bcd8739ae039 = $2624e38a54eebf0f$var$node;
module.exports["default"] = $2624e38a54eebf0f$export$2e2bcd8739ae039;

});

parcelRegister("62FVQ", function(module, exports) {
/**
 * @generated SignedSource<<025b00e9b31b73f237130d2a69699587>>
 * @relayHash 20688ce23e5e858cfc82d72bb57f43b8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6675bb1797e9ac9206231ded11f5893e0128fe48eaeb5c3ee4b3024ed69be54c
const $15e95f80a91466f9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "contentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaToken",
                    "kind": "LinkedField",
                    "name": "token",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "collection"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MediaUploadTokenQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MediaUploadTokenQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "20688ce23e5e858cfc82d72bb57f43b8",
            "id": "6675bb1797e9ac9206231ded11f5893e0128fe48eaeb5c3ee4b3024ed69be54c",
            "metadata": {},
            "name": "MediaUploadTokenQuery",
            "operationKind": "query",
            "text": "query MediaUploadTokenQuery($contentId:ID!){contentMediaSession(contentId:$contentId){token{value},configuration{clientId,fileStoreUrl},collection}}"
        }
    };
}();
$15e95f80a91466f9$var$node.hash = "1f89a4aaada59e040e6317ae1cdc704c";
var $15e95f80a91466f9$export$2e2bcd8739ae039 = $15e95f80a91466f9$var$node;
module.exports["default"] = $15e95f80a91466f9$export$2e2bcd8739ae039;

});

parcelRegister("6mmMU", function(module, exports) {
/**
 * @generated SignedSource<<daf984ad5eaae28ba5768f141c1480ac>>
 * @relayHash c06482aa2ab100620d21019ae889668d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6f18fbd3655dc7d982b17a901a58731161062354f5b6b10a2c133f035fcb7e37
const $39c17bb60e74ced3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "alias": "contentMediaSession",
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "confluence_commentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaToken",
                    "kind": "LinkedField",
                    "name": "token",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "collection"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MediaUploadTokenQueryCommentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MediaUploadTokenQueryCommentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c06482aa2ab100620d21019ae889668d",
            "id": "6f18fbd3655dc7d982b17a901a58731161062354f5b6b10a2c133f035fcb7e37",
            "metadata": {},
            "name": "MediaUploadTokenQueryCommentQuery",
            "operationKind": "query",
            "text": "query MediaUploadTokenQueryCommentQuery($cloudId:ID!,$contentId:ID!){contentMediaSession:confluence_commentMediaSession(cloudId:$cloudId,contentId:$contentId){token{value},configuration{clientId,fileStoreUrl},collection}}"
        }
    };
}();
$39c17bb60e74ced3$var$node.hash = "ecbc3538cd4e4434bac2e03ab7969cd8";
var $39c17bb60e74ced3$export$2e2bcd8739ae039 = $39c17bb60e74ced3$var$node;
module.exports["default"] = $39c17bb60e74ced3$export$2e2bcd8739ae039;

});

parcelRegister("egLSs", function(module, exports) {

var $4GGNn = parcelRequire("4GGNn");


var $aBfpe = parcelRequire("aBfpe");

const $7fce44bdcdfe3fe8$export$1b01a64a392afa44 = ({ variables: variables })=>{
    return (0, $4GGNn.experimentalMutate)({
        url: `/wiki/rest/drag-and-drop/1/filestore/upload`,
        method: 'POST',
        body: JSON.stringify(variables),
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        variables: variables,
        parseResult: ()=>({
                experimentalFileUpload: true
            })
    });
};
module.exports["experimentalFileUploadMutate"] = $7fce44bdcdfe3fe8$export$1b01a64a392afa44;

});

parcelRegister("dqLCu", function(module, exports) {
/**
 * @generated SignedSource<<4edd735d079b37bb48067afaa74a4066>>
 * @relayHash c64eff3bdc2352e89d29fc9d40e39f79
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0383b95992e0b08fce6e9726b252b827c2a925f54a0ef8d6bdc7d88c65deb255
const $b85e553ccc70de04$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shareToken"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "shareToken",
                    "variableName": "shareToken"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "externalContentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaAccessTokens",
                    "kind": "LinkedField",
                    "name": "accessTokens",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MediaToken",
                            "kind": "LinkedField",
                            "name": "readOnlyToken",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        },
                        {
                            "concreteType": "MediaToken",
                            "kind": "LinkedField",
                            "name": "readWriteToken",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ExternalContentMediaSessionQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ExternalContentMediaSessionQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "c64eff3bdc2352e89d29fc9d40e39f79",
            "id": "0383b95992e0b08fce6e9726b252b827c2a925f54a0ef8d6bdc7d88c65deb255",
            "metadata": {},
            "name": "ExternalContentMediaSessionQuery",
            "operationKind": "query",
            "text": "query ExternalContentMediaSessionQuery($shareToken:String!){externalContentMediaSession(shareToken:$shareToken){accessTokens{readOnlyToken{value},readWriteToken{value}},configuration{fileStoreUrl,clientId}}}"
        }
    };
}();
$b85e553ccc70de04$var$node.hash = "73d645a33a55cbb7625d57b6d5cf2a1a";
var $b85e553ccc70de04$export$2e2bcd8739ae039 = $b85e553ccc70de04$var$node;
module.exports["default"] = $b85e553ccc70de04$export$2e2bcd8739ae039;

});

parcelRegister("kQiXs", function(module, exports) {

var $I0A3i = parcelRequire("I0A3i");

const $c59debd6932d7898$var$noop = ()=>{};
const $c59debd6932d7898$export$ad897c91dfb246e9 = (options)=>{
    if (options.contentId && options.contentType) return (file)=>{
        const { id: id, name: name, size: size, mimeType: mimeType } = file;
        const { contentId: contentId, contentType: contentType } = options;
        const requestBody = {
            size: size,
            contentType: contentType,
            mimeType: mimeType,
            fileName: name,
            pageId: contentId,
            fileStoreId: id,
            minorEdit: true,
            renderEditorHTML: false,
            collectionName: `contentId-${contentId}`,
            uploadSource: 'fabric-editor'
        };
        (0, $I0A3i.setAttachment)(requestBody);
    };
    else return $c59debd6932d7898$var$noop;
};
module.exports["attachUploadedMedia"] = $c59debd6932d7898$export$ad897c91dfb246e9;

});

parcelRegister("b6fxF", function(module, exports) {
/* UserProfileCardForMention.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $6SsN4 = parcelRequire("6SsN4");


var $lQV5m = parcelRequire("lQV5m");


var $cK21K = parcelRequire("cK21K");


var $iMnC5 = parcelRequire("iMnC5");


var $jp2Q3 = parcelRequire("jp2Q3");


var $bPFqZ = parcelRequire("bPFqZ");


var $d5gEx = parcelRequire("d5gEx");


var $1koI0 = parcelRequire("1koI0");


var $g0RaX = parcelRequire("g0RaX");


var $3Z1Pc = parcelRequire("3Z1Pc");


var $fxdou = parcelRequire("fxdou");


var $9zU5G = parcelRequire("9zU5G");

const $0b67b0fc1e6d3033$var$ENTRY_POINT_ID = 'user-profile-card-for-mention';
const $0b67b0fc1e6d3033$var$mentionPopupStyles = {
    hidden: "_0fKRyPnQyn _1pp6NdYbGa"
};
function $0b67b0fc1e6d3033$var$PopperContent({ entryPointReference: entryPointReference, entryPointErrorFallback: entryPointErrorFallback, cloudId: cloudId, testId: testId, agent: agent, customerCardDataLoader: customerCardDataLoader, isReduced: isReduced }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bPFqZ.InternalEntryPointContainer), {
        id: $0b67b0fc1e6d3033$var$ENTRY_POINT_ID,
        entryPointReference: entryPointReference,
        fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fxdou.CardLoading), {
            isReduced: isReduced
        }),
        errorFallback: entryPointErrorFallback,
        runtimeProps: {
            cloudId: cloudId,
            testId: testId,
            agent: agent,
            customerCardDataLoader: customerCardDataLoader,
            isReduced: isReduced
        }
    });
} /**
   * Props common to both render paths.
   */ 
function $0b67b0fc1e6d3033$export$b3a703a1f8ebb0c8(props) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d5gEx.AtlassianRelayEnvironmentProvider), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($0b67b0fc1e6d3033$var$UserProfileCardForMentionInner, {
            ...props
        })
    });
} /** Inner implementation of {@link UserProfileCardForMention}. */ 
function $0b67b0fc1e6d3033$var$UserProfileCardForMentionInner({ userId: userId, cloudId: cloudId, orgId: orgId, viewerId: viewerId, children: children, referenceElement: referenceElement, placement: placement = 'bottom-start', trigger: trigger, testId: testId, agent: agent, isReduced: isReduced, analyticsAttributes: analyticsAttributes, prefilledProfileData: prefilledProfileData, customerCardDataLoader: customerCardDataLoader, onOpen: onOpen }) {
    const environmentProvider = (0, $d5gEx.useRelayEnvironmentProvider)();
    const onErrorBoundary = (0, $cozmU.useCallback)(()=>{
        (0, $g0RaX.getPageTime)();
    }, []);
    const entryPointErrorFallback = (0, $cozmU.useCallback)((_props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $3Z1Pc.CardError), {
            testId: testId
        }), [
        testId
    ]);
    const [entryPointReference, setEntryPointReference] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!referenceElement || !userId || !cloudId || !orgId || !viewerId) return;
        const reference = (0, $6SsN4.loadEntryPoint)(environmentProvider, (0, $1koI0.entryPoint), {
            userId: userId,
            cloudId: cloudId,
            orgId: orgId,
            viewerId: viewerId,
            isReduced: isReduced
        });
        setEntryPointReference(reference);
        return ()=>{
            reference.dispose();
            setEntryPointReference(null);
        };
    }, [
        referenceElement,
        userId,
        cloudId,
        orgId,
        viewerId,
        isReduced,
        environmentProvider
    ]); // Both render paths require these identifiers to make a valid API call. Bail out to
    // the plain children (mention chip without a card) when any are missing - the editor
    // path also needs this guard before its popper renders.
    if (!userId || !cloudId || !orgId || !viewerId) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    if (!referenceElement) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9zU5G.UserProfileCardWithTrigger), {
        userId: userId,
        cloudId: cloudId,
        orgId: orgId,
        viewerId: viewerId,
        placement: placement,
        trigger: trigger,
        testId: testId,
        agent: agent,
        isReduced: isReduced,
        analyticsAttributes: analyticsAttributes,
        prefilledProfileData: prefilledProfileData,
        customerCardDataLoader: customerCardDataLoader,
        onOpen: onOpen,
        shouldRenderToParent: false,
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            children,
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9EOlJ.ErrorBoundary), {
                onError: onErrorBoundary,
                fallback: null,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cK21K.default), {
                    zIndex: (0, $jp2Q3.layers).modal(),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lQV5m.Popper), {
                        referenceElement: referenceElement,
                        placement: placement,
                        children: ({ ref: ref, style: style, isReferenceHidden: isReferenceHidden })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                ref: ref,
                                style: style,
                                xcss: isReferenceHidden ? $0b67b0fc1e6d3033$var$mentionPopupStyles.hidden : undefined,
                                testId: testId ? `${testId}--mention-popup` : undefined,
                                children: entryPointReference ? /*#__PURE__*/ (0, $8aG6j.jsx)($0b67b0fc1e6d3033$var$PopperContent, {
                                    entryPointReference: entryPointReference,
                                    entryPointErrorFallback: entryPointErrorFallback,
                                    cloudId: cloudId,
                                    testId: testId,
                                    agent: agent,
                                    customerCardDataLoader: customerCardDataLoader,
                                    isReduced: isReduced
                                }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fxdou.CardLoading), {
                                    isReduced: isReduced
                                })
                            })
                    })
                })
            })
        ]
    });
}
module.exports["UserProfileCardForMention"] = $0b67b0fc1e6d3033$export$b3a703a1f8ebb0c8;

});

parcelRegister("eLV9q", function(module, exports) {
$parcel$export(module.exports, "useGetNavigateToTeamsApp", () => (parcelRequire("eWzPA")).useGetNavigateToTeamsApp);

var $eWzPA = parcelRequire("eWzPA");


});

parcelRegister("eWzPA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hMCZS = parcelRequire("hMCZS");


var $bQm3c = parcelRequire("bQm3c");

const $8c3fac113683eb0d$export$bb1230c0e6efa9dc = ()=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const getNavigateToTeamsApp = (navActionPayload, shouldOpenInSameTab)=>{
        return (0, $hMCZS.navigateToTeamsApp)({
            hostProduct: 'confluence',
            orgId: orgId,
            cloudId: cloudId,
            userHasNav4Enabled: true,
            shouldOpenInSameTab: shouldOpenInSameTab,
            ...navActionPayload
        });
    };
    return (0, $cozmU.useCallback)(getNavigateToTeamsApp, [
        cloudId,
        orgId
    ]);
};
module.exports["useGetNavigateToTeamsApp"] = $8c3fac113683eb0d$export$bb1230c0e6efa9dc;

});

parcelRegister("hcnuR", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");

const $62bc818b780bdfc1$export$68a914b05fdf9ed1 = (classification)=>{
    if (!(0, $4o0zT.isExperimentEnabled)('platform_editor_non_production_build_analytics')) return {};
    const isNonProductionBuild = typeof classification === 'function' ? classification() : classification;
    return isNonProductionBuild !== undefined ? {
        isNonProductionBuild: isNonProductionBuild
    } : {};
};
module.exports["getNonProductionBuildAnalyticsAttributes"] = $62bc818b780bdfc1$export$68a914b05fdf9ed1;

});

parcelRegister("2SowE", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ function $3c96f0e6009ebcf8$export$dc64ca688fb64c26(payload, newAttributes) {
    return {
        ...payload,
        attributes: {
            ...payload.attributes,
            ...newAttributes
        }
    };
}
const $3c96f0e6009ebcf8$export$a9a68a8b41555f13 = (startTime, duration)=>{
    return Number.isFinite(startTime) && Number.isFinite(duration) ? Math.round(startTime + duration) : undefined;
};
const $3c96f0e6009ebcf8$export$7ed9e23d68ab9aa6 = (context)=>{
    return context.filter((obj)=>obj.attributes && typeof obj.attributes === 'object' && !Array.isArray(obj.attributes)).reduce((acc, obj)=>({
            ...acc,
            ...obj.attributes
        }), {});
};
module.exports["extendPayloadAttributes"] = $3c96f0e6009ebcf8$export$dc64ca688fb64c26;
module.exports["getProseMirrorFMPTimestamp"] = $3c96f0e6009ebcf8$export$a9a68a8b41555f13;
module.exports["extractAttributesFromContext"] = $3c96f0e6009ebcf8$export$7ed9e23d68ab9aa6;

});

parcelRegister("8ld8H", function(module, exports) {

var $eSuZj = parcelRequire("eSuZj");


var $68uaC = parcelRequire("68uaC");

const $ca70a3574c04adc8$var$BRANCH_COOKIE = 'useFrontendBranch';
const $ca70a3574c04adc8$var$BIFROST_OVERRIDE_COOKIE = 'bifrost-override';
const $ca70a3574c04adc8$var$isActiveBranchCookie = (value)=>Boolean(value && value !== 'off');
const $ca70a3574c04adc8$var$isActiveBifrostOverride = (value)=>{
    if (!value || value === 'off') return false;
    const override = JSON.parse(value);
    if (!override || typeof override !== 'object' || Array.isArray(override)) return undefined;
    const version = override?.['cc-fe-bifrost']?.version ?? override?.version;
    if (version === undefined) return false;
    return typeof version === 'string' ? Boolean(version && version !== 'off' && version !== 'CLASSIC-off-off') : undefined;
};
const $ca70a3574c04adc8$export$89ba981936f5422e = ()=>{
    try {
        const { RELEASE_TRACK: RELEASE_TRACK } = (0, $eSuZj.getBuildInfo)();
        if (RELEASE_TRACK === 'dev' || RELEASE_TRACK === 'staging') return true;
        if (![
            'prod',
            'hello',
            'canary'
        ].includes(RELEASE_TRACK)) return undefined;
        return window.__IS_BIFROST__ ? $ca70a3574c04adc8$var$isActiveBifrostOverride((0, $68uaC.Cookies).get($ca70a3574c04adc8$var$BIFROST_OVERRIDE_COOKIE)) : $ca70a3574c04adc8$var$isActiveBranchCookie((0, $68uaC.Cookies).get($ca70a3574c04adc8$var$BRANCH_COOKIE));
    } catch  {
        return undefined;
    }
};
module.exports["getConfluenceNonProductionBuild"] = $ca70a3574c04adc8$export$89ba981936f5422e;

});

parcelRegister("gnkil", function(module, exports) {
// Note: When modifying shortcut settings, make sure to test across all input fields on the page.
// Some input fields may not have shortcuts fully disabled, which could cause conflicts with shortcuts.
// Ensure that the new shortcuts do not interfere with normal input field operations.
// When making change in this file, make sure the corresponding tab in @confluence/keyboard-shortcuts-dialog is also updated
// Shortcuts for editor2
const $e13bb5c64c0a0eec$export$170fefa3f8a9258a = {
    PUBLISH: 'mod+enter',
    PUBLISH_WITH_COMMENT: 'mod+shift+enter',
    EDIT: 'e',
    PREVIEW: 'mod+shift+e',
    UNDO: 'mod+z',
    REDO: 'mod+shift+z',
    FIND_REPLACE: 'mod+f'
};
const $e13bb5c64c0a0eec$export$1cbe44c5850db728 = 'mod+s';
const $e13bb5c64c0a0eec$export$73148f05a63f43f = 'command+enter';
const $e13bb5c64c0a0eec$export$67c56ed34ece0f2a = 'mod+enter';
const $e13bb5c64c0a0eec$export$c19d729632cce38f = 'b';
const $e13bb5c64c0a0eec$export$e896f39257754358 = 'c';
const $e13bb5c64c0a0eec$export$c9d367283380f242 = 'f';
const $e13bb5c64c0a0eec$export$44da7c32f8b979f6 = 'm';
const $e13bb5c64c0a0eec$export$f10fe393178b1b45 = 'k';
const $e13bb5c64c0a0eec$export$3837d28de95f38e = 'e';
const $e13bb5c64c0a0eec$export$99088c948bf0270f = 'r';
const $e13bb5c64c0a0eec$export$ddb528ae2130e6f3 = 'w';
const $e13bb5c64c0a0eec$export$95a205588c16f013 = 's';
const $e13bb5c64c0a0eec$export$f7fab4391dadca28 = 'l';
const $e13bb5c64c0a0eec$export$2f62883c954429eb = 't';
const $e13bb5c64c0a0eec$export$96f161bee6b4340d = 'n';
const $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172 = 'p';
const $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031 = 'g f';
const $e13bb5c64c0a0eec$export$b947af6524920798 = 'g g';
const $e13bb5c64c0a0eec$export$53e346b715d2b7c7 = 'g d';
const $e13bb5c64c0a0eec$export$8cb32cdc75719ad2 = 'g n';
const $e13bb5c64c0a0eec$export$b4842d8ad92c38a3 = 'g r';
const $e13bb5c64c0a0eec$export$298e62593d4ef85 = 'g s';
const $e13bb5c64c0a0eec$export$5d4720de35488ecb = 'g s';
const $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7 = 'g o';
const $e13bb5c64c0a0eec$export$f5473855a7a167a7 = 'g c';
const $e13bb5c64c0a0eec$export$cee4257b1a828f0d = '/';
const $e13bb5c64c0a0eec$export$159e447a25b21930 = '[';
const $e13bb5c64c0a0eec$export$922297bddc2a63e6 = 'mod+z';
const $e13bb5c64c0a0eec$export$420825475f86fe8d = 'left';
const $e13bb5c64c0a0eec$export$db9252a2db2b8e9e = 'right';
const $e13bb5c64c0a0eec$export$faa4136cec2aa7a0 = '?';
const $e13bb5c64c0a0eec$export$362c0171844ea600 = 'a';
const $e13bb5c64c0a0eec$export$5d80e625aa457659 = ']';
const $e13bb5c64c0a0eec$export$cc9bab4159e8aec9 = 'e';
const $e13bb5c64c0a0eec$export$285e80cf6c078ba6 = 'mod+shift+e';
const $e13bb5c64c0a0eec$export$8d0081a3f70f258c = 'ctrl+.';
const $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14 = 'ctrl+,';
const $e13bb5c64c0a0eec$export$de4065c6a68e4031 = 'mod+option+c';
const $e13bb5c64c0a0eec$export$b5f3b4e8358360b3 = 'ctrl+shift+d';
const $e13bb5c64c0a0eec$export$9cee57908df99565 = 'ctrl+option+n';
const $e13bb5c64c0a0eec$export$b0a212f4fb6d9350 = 'mod+shift+u';
const $e13bb5c64c0a0eec$export$986cc862e5f6eec1 = 'mod+option+r';
const $e13bb5c64c0a0eec$export$d3b6b270c6770b4f = 'ctrl+option+r';
const $e13bb5c64c0a0eec$export$adb85b0fd79d17f8 = 'ctrl+]';
const $e13bb5c64c0a0eec$export$1822b04007c39b0c = 'mod+option+shift+b';
const $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99 = 'ctrl+option+c';
const $e13bb5c64c0a0eec$export$f5ba0af3c65d3125 = 'meta+alt+c';
const $e13bb5c64c0a0eec$export$c372eed375f60e68 = 'ctrl+shift+/';
const $e13bb5c64c0a0eec$export$406fcfa6807667 = 'ctrl+[';
const $e13bb5c64c0a0eec$export$4ec29504bd71f204 = 'ctrl+option+f';
const $e13bb5c64c0a0eec$export$4148526d63a5bc01 = 'mod+option+o';
const $e13bb5c64c0a0eec$export$b7088d9be4883093 = 'ctrl+option+z';
const $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c = 'alt+shift+z';
const $e13bb5c64c0a0eec$export$2bdd2e57d23976c4 = 'mod+option+h';
const $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899 = 'mod+option+g';
const $e13bb5c64c0a0eec$export$18a9bb0de7844bb6 = 'mod+option+8';
const $e13bb5c64c0a0eec$export$3fe2d0f3fe115364 = 'mod+option+v';
const $e13bb5c64c0a0eec$export$a3e38cca130cbc49 = 'mod+option+w';
const $e13bb5c64c0a0eec$export$a769ea2ac46f94da = 'ctrl+option+w';
const $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd = 'mod+option+s';
const $e13bb5c64c0a0eec$export$4bc8c55d04859f5a = 'ctrl+shift+i';
const $e13bb5c64c0a0eec$export$1f53991bf9b208a0 = 'ctrl+option+a';
const $e13bb5c64c0a0eec$export$650d7b87402f841f = 'ctrl+option+t';
const $e13bb5c64c0a0eec$export$dc2c2f2eed832016 = 'meta+alt+t';
const $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d = 'mod+.';
const $e13bb5c64c0a0eec$export$c252fe6b173dfad3 = 'ctrl+meta+.';
const $e13bb5c64c0a0eec$export$a1552937ff7cca64 = 'mod+option+k';
const $e13bb5c64c0a0eec$export$f7727b957c03a88b = 'mod+option+e';
const $e13bb5c64c0a0eec$export$f0043475aa91a151 = 'alt+meta+x';
const $e13bb5c64c0a0eec$export$bc654500edb91b60 = 'mod+shift+x';
module.exports["EDITOR2_SHORTCUTS"] = $e13bb5c64c0a0eec$export$170fefa3f8a9258a;
module.exports["BROWSER_SAVE_SHORTCUT"] = $e13bb5c64c0a0eec$export$1cbe44c5850db728;
module.exports["COMMENT_EDITOR_SHORTCUT"] = $e13bb5c64c0a0eec$export$73148f05a63f43f;
module.exports["INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$67c56ed34ece0f2a;
module.exports["BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$c19d729632cce38f;
module.exports["GLOBAL_CREATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$e896f39257754358;
module.exports["STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$c9d367283380f242;
module.exports["CREATE_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$44da7c32f8b979f6;
module.exports["LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f10fe393178b1b45;
module.exports["EDIT_SHORTCUT"] = $e13bb5c64c0a0eec$export$3837d28de95f38e;
module.exports["PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$99088c948bf0270f;
module.exports["WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddb528ae2130e6f3;
module.exports["SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$95a205588c16f013;
module.exports["LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7fab4391dadca28;
module.exports["VIEW_ATTACHMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$2f62883c954429eb;
module.exports["NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$96f161bee6b4340d;
module.exports["PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172;
module.exports["SUBMIT_FEEDBACK_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031;
module.exports["NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$b947af6524920798;
module.exports["GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$53e346b715d2b7c7;
module.exports["NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$8cb32cdc75719ad2;
module.exports["GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b4842d8ad92c38a3;
module.exports["GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$298e62593d4ef85;
module.exports["SPACE_OVERVIEW_SHORTCUT_NAV_3"] = $e13bb5c64c0a0eec$export$5d4720de35488ecb;
module.exports["SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7;
module.exports["AI_MATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f5473855a7a167a7;
module.exports["NAVIGATION_SLASH_SHORTCUT"] = $e13bb5c64c0a0eec$export$cee4257b1a828f0d;
module.exports["SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$159e447a25b21930;
module.exports["UNDO_SHORTCUT"] = $e13bb5c64c0a0eec$export$922297bddc2a63e6;
module.exports["PREV_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$420825475f86fe8d;
module.exports["NEXT_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$db9252a2db2b8e9e;
module.exports["HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$faa4136cec2aa7a0;
module.exports["AUTOMATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$362c0171844ea600;
module.exports["TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER"] = $e13bb5c64c0a0eec$export$5d80e625aa457659;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_EDIT"] = $e13bb5c64c0a0eec$export$cc9bab4159e8aec9;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_VIEW"] = $e13bb5c64c0a0eec$export$285e80cf6c078ba6;
module.exports["UNIVERSAL_NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$8d0081a3f70f258c;
module.exports["UNIVERSAL_PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14;
module.exports["UNIVERSAL_OPEN_COMMENT_EDITOR"] = $e13bb5c64c0a0eec$export$de4065c6a68e4031;
module.exports["UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT"] = $e13bb5c64c0a0eec$export$b5f3b4e8358360b3;
module.exports["UNIVERSAL_CREATE_NOTE_SHORTCUT"] = $e13bb5c64c0a0eec$export$9cee57908df99565;
module.exports["UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b0a212f4fb6d9350;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$986cc862e5f6eec1;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$d3b6b270c6770b4f;
module.exports["UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$adb85b0fd79d17f8;
module.exports["UNIVERSAL_BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$1822b04007c39b0c;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$f5ba0af3c65d3125;
module.exports["UNIVERSAL_HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$c372eed375f60e68;
module.exports["UNIVERSAL_SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$406fcfa6807667;
module.exports["UNIVERSAL_STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$4ec29504bd71f204;
module.exports["UNIVERSAL_NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$4148526d63a5bc01;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$b7088d9be4883093;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c;
module.exports["UNIVERSAL_GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$2bdd2e57d23976c4;
module.exports["UNIVERSAL_GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899;
module.exports["UNIVERSAL_GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$18a9bb0de7844bb6;
module.exports["UNIVERSAL_SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$3fe2d0f3fe115364;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$a3e38cca130cbc49;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$a769ea2ac46f94da;
module.exports["UNIVERSAL_SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd;
module.exports["UNIVERSAL_OPEN_DETAILS_PANEL_SHORTCUT"] = $e13bb5c64c0a0eec$export$4bc8c55d04859f5a;
module.exports["UNIVERSAL_LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$1f53991bf9b208a0;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$650d7b87402f841f;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$dc2c2f2eed832016;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$c252fe6b173dfad3;
module.exports["UNIVERSAL_LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$a1552937ff7cca64;
module.exports["UNIVERSAL_SELECT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7727b957c03a88b;
module.exports["UNIVERSAL_OPEN_DEVTOOLS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0043475aa91a151;
module.exports["UNIVERSAL_TOGGLE_MARKDOWN_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$bc654500edb91b60;

});

parcelRegister("isuYJ", function(module, exports) {

var $d5Ozc = parcelRequire("d5Ozc");

function $a1048cda8104f400$export$691e93bad45e6f07(condition, newHook, oldHook) {
    const hookFn = (...args)=>{
        // call each time so we can track exposures
        const conditionResult = condition();
        const cache = globalThis[0, $d5Ozc.CACHE_MAP_KEY];
        if (!cache.has(hookFn)) cache.set(hookFn, conditionResult);
        if (cache.get(hookFn)) return newHook(...args);
        else return oldHook(...args);
    };
    return hookFn;
}
module.exports["conditionalHooksFactory"] = $a1048cda8104f400$export$691e93bad45e6f07;

});

parcelRegister("d5Ozc", function(module, exports) {
const $dacf5aee5e6a9a5a$export$3c82709bf1b7e3a = '__conditionalHooksFactory_conditionCacheMap_dont_modify_this_manually_unless_you_want_react_to_blow_up';
globalThis[$dacf5aee5e6a9a5a$export$3c82709bf1b7e3a] = globalThis[$dacf5aee5e6a9a5a$export$3c82709bf1b7e3a] || new WeakMap();
module.exports["CACHE_MAP_KEY"] = $dacf5aee5e6a9a5a$export$3c82709bf1b7e3a;

});

parcelRegister("2qJQZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hMaHH = parcelRequire("hMaHH");


var $4hmAW = parcelRequire("4hmAW");

const $f3e0d6c6400f29a4$var$PageObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Page" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PageObject({ label: label = 'Page', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $f3e0d6c6400f29a4$export$2e2bcd8739ae039 = $f3e0d6c6400f29a4$var$PageObject;
module.exports["default"] = $f3e0d6c6400f29a4$export$2e2bcd8739ae039;

});

parcelRegister("bwuOg", function(module, exports) {
const $74d2fe053a191110$export$85183a312807388d = 'media';
const $74d2fe053a191110$export$60efea3f80310017 = 'wide';
module.exports["ANALYTICS_CHANNEL"] = $74d2fe053a191110$export$85183a312807388d;
module.exports["DATASOURCE_DEFAULT_LAYOUT"] = $74d2fe053a191110$export$60efea3f80310017;

});

parcelRegister("6S5EB", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");

const $d5074feaeb7f756a$export$50d92d69a5c05c70 = ()=>{
    if ((0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false)) return !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname) || !!(0, $1NBp8.ACCESS_LINK).match(window.location.pathname);
    return !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname);
};
module.exports["isExternalShareRequest"] = $d5074feaeb7f756a$export$50d92d69a5c05c70;

});

parcelRegister("1w4hj", function(module, exports) {
class $7d33ebf4b0fcc5c6$export$7edca8cfa9634e37 {
    static extractErrorMessage(error) {
        if (error instanceof Error) return $7d33ebf4b0fcc5c6$export$7edca8cfa9634e37.redactSensitiveInfo(error.message || 'unknown-error');
        else return $7d33ebf4b0fcc5c6$export$7edca8cfa9634e37.redactSensitiveInfo(String(error));
    }
}
$7d33ebf4b0fcc5c6$export$7edca8cfa9634e37.redactSensitiveInfo = (str)=>{
    const redacted = str// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/[^,\s]+\@[^,\s]+/g, '[REDACTED EMAIL]')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/[^,\s]+\.[^,\s]+/g, '[REDACTED URL]');
    return redacted;
};
module.exports["ErrorUtils"] = $7d33ebf4b0fcc5c6$export$7edca8cfa9634e37;

});

parcelRegister("6M71K", function(module, exports) {

var $c7nnh = parcelRequire("c7nnh");


var $2TQy9 = parcelRequire("2TQy9");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $9DHhW = parcelRequire("9DHhW");


var $c2Doe = parcelRequire("c2Doe");


var $c3xon = parcelRequire("c3xon");


var $5e2GM = parcelRequire("5e2GM");


var $d5gEx = parcelRequire("d5gEx");


var $9wGTI = parcelRequire("9wGTI");


var $9HB34 = parcelRequire("9HB34");


var $btIEy = parcelRequire("btIEy");


var $i6Ps3 = parcelRequire("i6Ps3");


var $7W8i8 = parcelRequire("7W8i8");


var $ep3mz = parcelRequire("ep3mz");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $jr2Xf = parcelRequire("jr2Xf");


var $6JLuV = parcelRequire("6JLuV");


var $27fJD = parcelRequire("27fJD");


var $cEgMD = parcelRequire("cEgMD");


var $e4o8D = parcelRequire("e4o8D");


var $fFmJj = parcelRequire("fFmJj");


var $ij4CE = parcelRequire("ij4CE");





var $3PnE6 = parcelRequire("3PnE6");


var $cknyY = parcelRequire("cknyY");

const $3c75c8f77ed4b940$var$MaybeConditionalRelayEnvironmentProvider = ({ children: children })=>(0, $9wGTI.fg)('ccp-9584-remove-relay-environment-provider') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6SsN4.RelayEnvironmentProvider), {
        environment: (0, $9HB34.getRelayEnvironment)()
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.ConditionalRelayEnvironmentProvider), null, children);
// Only log first error to console, to prevent spamming console with resolver errors
let $3c75c8f77ed4b940$var$hasLoggedResolverError = false;
const $3c75c8f77ed4b940$var$defaultConfluenceResolveHandler = (createAnalyticsEvent, readFragmentInterop, writeFragmentInterop, data)=>{
    try {
        // NOTE FOR DEVS OF RESOLVERS: The `data` object comes from linking platform's content resolver service which is an UNSTABLE API SCHEMA.
        // Ensure your resolver logic handles invalid schemas gracefully and is able to notify your team if the schema changes and your code needs to be updated.
        (0, $cknyY.liveDocSmartCardResolver)(createAnalyticsEvent, readFragmentInterop, writeFragmentInterop, data);
    } catch (resolverError) {
        // prevent errors from causing smart card provider issues
        if (!$3c75c8f77ed4b940$var$hasLoggedResolverError) {
            const logger = (0, $7W8i8.getLogger)('ConfluenceSmartCardProvider');
            logger.error`resolver error: ${resolverError}`;
            $3c75c8f77ed4b940$var$hasLoggedResolverError = true;
        }
    }
};
const $3c75c8f77ed4b940$var$computeInitialStateFromCache = (smartCardClient)=>{
    // On page transition create the initial CardStore from Cache
    return !(0, $i6Ps3.isPageSSRd)() && smartCardClient instanceof (0, $3PnE6.ConfluenceSmartCardClient) ? smartCardClient.getInitialCardStoreFromCache() : null;
};
const $3c75c8f77ed4b940$var$ConsolidatedSmartCardProvider = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $2TQy9.default),
        __callerPackage__: "smart-card-provider"
    });
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $c7nnh.default),
        fragmentSpec: (0, $c7nnh.default),
        __callerPackage__: "smart-card-provider"
    });
    const smartCardClient = (0, $cozmU.useMemo)(()=>props?.client || new (0, $3PnE6.ConfluenceSmartCardClient)({
            onResolve: (data)=>$3c75c8f77ed4b940$var$defaultConfluenceResolveHandler(createAnalyticsEvent, readFragmentInterop, writeFragmentInterop, data)
        }), [
        props?.client,
        createAnalyticsEvent,
        readFragmentInterop,
        writeFragmentInterop
    ]);
    const initialStateFromCache = (0, $cozmU.useRef)($3c75c8f77ed4b940$var$computeInitialStateFromCache(smartCardClient));
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const { children: children, ...restProps } = props;
    const isPageSSR = (0, $i6Ps3.isPageSSRd)();
    const ssrInitialState = window['__SSR_SMARTLINKS__'];
    (0, $cozmU.useEffect)(()=>{
        if (isPageSSR && ssrInitialState && smartCardClient instanceof (0, $3PnE6.ConfluenceSmartCardClient)) smartCardClient.seedSSRSmartLinks(ssrInitialState);
    }, [
        isPageSSR,
        ssrInitialState,
        smartCardClient
    ]);
    const initialState = initialStateFromCache?.current ?? ssrInitialState;
    const internalStoreOptions = (0, $btIEy.useStoreOptions)(initialState, isPageSSR);
    // Merge smartlink SSR data with any passed-in storeOptions (e.g. from shortcuts preloader)
    const presetInitialState = {
        ...internalStoreOptions,
        ...props.storeOptions ? {
            storeOptions: {
                ...props.storeOptions,
                ...internalStoreOptions.storeOptions?.initialState ? {
                    initialState: {
                        ...internalStoreOptions.storeOptions.initialState,
                        ...props.storeOptions.initialState
                    }
                } : {}
            }
        } : {}
    };
    const shouldControlDataExport = (0, $dPJCf.useIsOnRoute)((0, $1NBp8.PDF_EXPORT_PAGE));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c2Doe.SmartCardProvider), {
        product: "CONFLUENCE",
        client: smartCardClient,
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        shouldControlDataExport: shouldControlDataExport,
        isPreviewPanelAvailable: restProps.isPreviewPanelAvailable,
        openPreviewPanel: restProps.openPreviewPanel,
        ...restProps,
        ...presetInitialState
    }, children);
};
const $3c75c8f77ed4b940$var$PreviewPanelSmartCardProvider = ({ children: children, ...restProps })=>{
    const { open: open } = (0, $6JLuV.useOpenPreviewPanel)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    // Create a wrapper function that updates the preview panel URL
    // This is used for custom domains to update to the correct content URL and avoid CSP issues
    const openPreviewPanelWithModifiedURL = (0, $cozmU.useMemo)(()=>{
        if (!cloudId) return open;
        return ({ url: url, ari: ari, ...rest })=>open({
                url: (0, $5e2GM.getCorrectContentURL)(cloudId, url, ari),
                ari: ari,
                ...rest
            });
    }, [
        open,
        cloudId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3c75c8f77ed4b940$var$ConsolidatedSmartCardProvider, {
        openPreviewPanel: openPreviewPanelWithModifiedURL,
        isPreviewPanelAvailable: renderServerPlaceholder ? (_ari)=>false : (0, $27fJD.isPreviewPanelAvailable),
        ...restProps
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jr2Xf.PreviewPanelsPostMessageListener), null));
};
const $3c75c8f77ed4b940$var$ConsolidatedPreviewPanelSmartCardProvider = (props)=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { children: children, doNotUsePreviewPanels: doNotUsePreviewPanels, ...restProps } = props;
    return (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) || doNotUsePreviewPanels ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3c75c8f77ed4b940$var$ConsolidatedSmartCardProvider, restProps, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3c75c8f77ed4b940$var$MaybeConditionalRelayEnvironmentProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3c75c8f77ed4b940$var$PreviewPanelSmartCardProvider, restProps, children));
};
const $3c75c8f77ed4b940$export$a56ebeb3c828cd38 = (props)=>{
    let updatedProps = props;
    const useSessionDataGated = (0, $c3xon.functionUnionWithCondition)(()=>(0, $9wGTI.fg)('platform_sl_3p_auth_rovo_entitlement'), (0, $bQm3c.useSessionData), ()=>undefined);
    const sessionData = useSessionDataGated();
    updatedProps = (0, $cozmU.useMemo)(()=>({
            ...props,
            ...(!!sessionData && (0, $9wGTI.fg)('platform_sl_3p_auth_rovo_entitlement') ? {
                rovoOptions: {
                    isRovoEnabled: sessionData?.isRovoEnabled ?? false,
                    isRovoLLMEnabled: sessionData?.isRovoLLMEnabled ?? false
                }
            } : undefined) || {}
        }), [
        props,
        sessionData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3c75c8f77ed4b940$var$ConsolidatedPreviewPanelSmartCardProvider, updatedProps);
};
module.exports["ConfluenceSmartCardProvider"] = $3c75c8f77ed4b940$export$a56ebeb3c828cd38;

});

parcelRegister("c7nnh", function(module, exports) {
/**
 * @generated SignedSource<<fb4cbf9baf031942480cc631faeb9c5f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ecbb6e526a968754$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ConfluenceSmartCardProviderConsolidatedSmartCardProviderWriteFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "Content"
};
$ecbb6e526a968754$var$node.hash = "f4093e7916c35c0c1b9141fd35c3dbe3";
var $ecbb6e526a968754$export$2e2bcd8739ae039 = $ecbb6e526a968754$var$node;
module.exports["default"] = $ecbb6e526a968754$export$2e2bcd8739ae039;

});

parcelRegister("2TQy9", function(module, exports) {
/**
 * @generated SignedSource<<b883f85a798a72a16cc53c5b93cb214f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2114907496ee9554$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ConfluenceSmartCardProviderConsolidatedSmartCardProviderReadFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "Content"
};
$2114907496ee9554$var$node.hash = "3fd9bcac35b412a193a9c2f2d5df8b3c";
var $2114907496ee9554$export$2e2bcd8739ae039 = $2114907496ee9554$var$node;
module.exports["default"] = $2114907496ee9554$export$2e2bcd8739ae039;

});

parcelRegister("5e2GM", function(module, exports) {

var $6B1vK = parcelRequire("6B1vK");

const $e6f6530fea1b5195$var$ATLASSIAN_DOMAINS = [
    '.atlassian.com',
    '.atlassian.net',
    '.jira-dev.com',
    '.jira.com',
    '.atlassian-stg-fedm.net',
    '.atlassian-us-gov-mod.net',
    '.atlassian-us-gov-mod.com'
];
const $e6f6530fea1b5195$export$97f4c254b641e719 = (hostname)=>!$e6f6530fea1b5195$var$ATLASSIAN_DOMAINS.some((domain)=>hostname.endsWith(domain));
const $e6f6530fea1b5195$var$isValidUrl = (urlString)=>{
    if (typeof urlString !== 'string') return false;
    try {
        return Boolean(new URL(urlString));
    } catch (e) {
        return false;
    }
};
const $e6f6530fea1b5195$export$280e79c794cf814e = (url)=>$e6f6530fea1b5195$var$isValidUrl(url) ? new URL(url)?.hostname : '';
const $e6f6530fea1b5195$export$33c8f371dcc1b989 = (ari)=>{
    if (!ari || typeof ari !== 'string') return null;
    try {
        const parsedAri = (0, $6B1vK.ConfluencePageAri).parse(ari);
        return parsedAri && parsedAri.cloudId ? parsedAri.cloudId : null;
    } catch (err) {
        return null;
    }
};
const $e6f6530fea1b5195$export$193bb0d0d16ee7a7 = (parentCloudId, url, ari)=>{
    const parentHost = $e6f6530fea1b5195$export$280e79c794cf814e(window?.location?.href) || '';
    const contentHost = $e6f6530fea1b5195$export$280e79c794cf814e(url);
    if (parentHost === contentHost) return url;
    const cloudId = $e6f6530fea1b5195$export$33c8f371dcc1b989(ari);
    if (!cloudId || !parentCloudId || parentCloudId !== cloudId || !$e6f6530fea1b5195$export$97f4c254b641e719(parentHost)) return url;
    // Swap the URL hostname to use the parent's hostname
    try {
        const urlObj = new URL(url);
        urlObj.hostname = parentHost;
        return urlObj.toString();
    } catch (error) {
        // If URL parsing fails, return original URL
        return url;
    }
};
module.exports["getCorrectContentURL"] = $e6f6530fea1b5195$export$193bb0d0d16ee7a7;

});

parcelRegister("btIEy", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");

const $e1de24b738f0d933$export$53d21446ea17fdf1 = (initialState, _isPageSSRd)=>{
    const $ = (0, $bDgLe.c)(2);
    let result;
    if ($[0] !== initialState) {
        result = {};
        if (initialState) result.storeOptions = {
            initialState: initialState
        };
        $[0] = initialState;
        $[1] = result;
    } else result = $[1];
    return result;
};
module.exports["useStoreOptions"] = $e1de24b738f0d933$export$53d21446ea17fdf1;

});

parcelRegister("i6Ps3", function(module, exports) {
// Returns true on SSR and SPA if page was SSR'd
const $70ad96d323d38e4d$export$a8c2f05884e8c7a1 = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return Boolean(window.__SSR_RENDERED__);
};
module.exports["isPageSSRd"] = $70ad96d323d38e4d$export$a8c2f05884e8c7a1;

});

parcelRegister("jr2Xf", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6JLuV = parcelRequire("6JLuV");

const $7ac1c4b85cd786d3$export$d48d5704d1181ce6 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const { open: open } = (0, $6JLuV.useOpenPreviewPanel)();
    let t0;
    let t1;
    if ($[0] !== open) {
        t0 = ()=>{
            const handleMessage = (event)=>{
                const { payload: payload } = event.data;
                if (event.data?.type !== "OPEN_PREVIEW_PANEL") return;
                if (payload?.url) open(payload);
            };
            window.addEventListener("message", handleMessage);
            return ()=>{
                window.removeEventListener("message", handleMessage);
            };
        };
        t1 = [
            open
        ];
        $[0] = open;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return null;
} : ()=>{
    const { open: open } = (0, $6JLuV.useOpenPreviewPanel)();
    // Listen for messages from iframes to open preview panels
    (0, $cozmU.useEffect)(()=>{
        const handleMessage = (event)=>{
            const { payload: payload } = event.data;
            // Only handle messages with the expected type
            if (event.data?.type !== 'OPEN_PREVIEW_PANEL') return;
            if (payload?.url) open(payload);
        };
        window.addEventListener('message', handleMessage);
        return ()=>{
            window.removeEventListener('message', handleMessage);
        };
    }, [
        open
    ]);
    return null;
};
module.exports["PreviewPanelsPostMessageListener"] = $7ac1c4b85cd786d3$export$d48d5704d1181ce6;

});

parcelRegister("3PnE6", function(module, exports) {

var $iyuxZ = parcelRequire("iyuxZ");


var $4yccB = parcelRequire("4yccB");


var $ggGdk = parcelRequire("ggGdk");


var $9wGTI = parcelRequire("9wGTI");


var $6GQtz = parcelRequire("6GQtz");


var $6mKj3 = parcelRequire("6mKj3");


var $3y0Sn = parcelRequire("3y0Sn");


var $eaaOs = parcelRequire("eaaOs");

const $de526bdbda89b480$var$deferIdle = (cb)=>{
    if ('requestIdleCallback' in window) requestIdleCallback(cb, {
        timeout: 5000
    });
    else requestAnimationFrame(cb);
};
class $de526bdbda89b480$export$385f1396b754ac80 extends (0, $4yccB.default) {
    // Called once per page load
    prefetchData(url, appearance) {
        return super.prefetchData(url, appearance).then((data)=>{
            // Using deferIdle(requestIdleCallback) to ensure our onResolve callback doesn't interrupt the smart card client.
            // This means there's a chance under heavy browser load that the delay between client (pre)fetch and onResolve invocation will be >1s, but usually it shouldn't be.
            // Given the data schema is unstable, we're setting the type as unknown and expecting individual resolvers to be mindful.
            data && $de526bdbda89b480$var$deferIdle(()=>this.onResolve(data));
            return data;
        });
    }
    // Called on load and on click of each smart card link
    async fetchData(url, force, appearance) {
        // Keep inline resolves on the editor provider path only while the inline resolve
        // optimization is active. Disabling the experiment restores the previous
        // appearance-based parent fetch path without needing a code rollback.
        const shouldUseParentFetchData = appearance !== undefined && (appearance !== 'inline' || !(0, $9wGTI.fg)('platform_smartlink_inline_resolve_optimization'));
        if (!shouldUseParentFetchData && (!force || this.smartCardLocalCacheClient.isUrlInCache(url))) return this.editorCardProvider.getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS({
            // It's ok to cast any resourceUrl to inlineCard here, because only URL is important for the request.
            type: 'inlineCard',
            attrs: {
                url: url
            }
        }).then((data)=>{
            data && $de526bdbda89b480$var$deferIdle(()=>this.onResolve(data));
            return data;
        });
        return super.fetchData(url, force, appearance).then((data)=>{
            data && $de526bdbda89b480$var$deferIdle(()=>this.onResolve(data));
            return data;
        });
    }
    // Called after hydration, never during SSR. Seed each snapshot once so remounting
    // a provider cannot overwrite responses fetched after the initial page load.
    seedSSRSmartLinks(initialState) {
        if (!(0, $9wGTI.fg)('cc_preserve_smart_link_anchor_content') || $de526bdbda89b480$export$385f1396b754ac80.hydratedSSRStates.has(initialState)) return;
        $de526bdbda89b480$export$385f1396b754ac80.hydratedSSRStates.add(initialState);
        for (const [url, { status: status, details: details }] of Object.entries(initialState))if ((0, $3y0Sn.hasUrlFragment)(url) && status === 'resolved' && details?.meta && (0, $ggGdk.getStatus)(details) === 'resolved') {
            const cacheKey = this.editorCardProvider.nodeDataKey({
                type: 'inlineCard',
                attrs: {
                    url: url
                }
            });
            // eslint-disable-next-line check-set-storage-usage/no-unimported-storage-set -- SmartCardLocalCacheClient writes through the platform StorageClient using its existing cache key.
            this.smartCardLocalCacheClient.setItem(cacheKey, details);
        }
    }
    constructor(props){
        const { onResolve: onResolve, envKey: envKey } = props;
        super(envKey);
        this.onResolve = void 0;
        this.editorCardProvider = void 0;
        this.smartCardLocalCacheClient = void 0;
        this.getInitialCardStoreFromCache = ()=>{
            const initialStateCardStore = {};
            const timestamps = {};
            const cachedData = this.smartCardLocalCacheClient.getCache();
            Object.entries(cachedData).forEach(([cacheKey, value])=>{
                const { metadataStatus: metadataStatus, url: url } = (0, $eaaOs.getUrlAndMetadataStatus)(cacheKey);
                const timestamp = value.timestamp ?? 0;
                const hasFragment = (0, $3y0Sn.hasUrlFragment)(url);
                // Prefer fresh anchor content over older full metadata. Inline SSR responses
                // remain pending so hovering can still fetch complete metadata.
                if (hasFragment && timestamp < timestamps[url] && (0, $9wGTI.fg)('cc_preserve_smart_link_anchor_content')) return;
                if (initialStateCardStore[url]?.metadataStatus === 'resolved' && metadataStatus !== 'resolved' && (!(0, $9wGTI.fg)('cc_preserve_smart_link_anchor_content') || !hasFragment || timestamp <= timestamps[url])) return;
                const details = value.data;
                // NAVX-4712: Handle responses with non-resolved statuses that were previously cached
                const status = details && details.meta ? (0, $ggGdk.getStatus)(details) : undefined;
                if (status === 'resolved') {
                    // When FG is on, preserve metadataStatus from the cache key (e.g. 'pending' for inline)
                    // so hover cards can trigger a full block fetch. When FG is off, always use 'resolved'.
                    const resolvedMetadataStatus = (0, $9wGTI.fg)('platform_smartlink_inline_resolve_optimization') ? metadataStatus : 'resolved';
                    initialStateCardStore[url] = {
                        status: status,
                        details: details,
                        metadataStatus: resolvedMetadataStatus
                    };
                    timestamps[url] = timestamp;
                } else if (status !== undefined) {
                    // Include forbidden/unauthorized responses so the card can render the correct error state
                    initialStateCardStore[url] = {
                        status: status,
                        details: details,
                        metadataStatus: 'resolved'
                    };
                    timestamps[url] = timestamp;
                }
            });
            return initialStateCardStore;
        };
        this.onResolve = onResolve;
        // Because Card components uses data from client and it's super hard to pass ConfluenceEditorCardProvider to them,
        // we will create a new ConfluenceEditorCardProvider instance here and use it for SSR support.
        this.editorCardProvider = new (0, $6GQtz.ConfluenceEditorCardProvider)(this.envKey, this.baseUrlOverride);
        this.smartCardLocalCacheClient = (0, $iyuxZ.SmartCardLocalCacheClient).getInstance();
        // Fire a client-side exposure for the SSR preload experiment. The experiment is only
        // evaluated in SSR preload code where the Statsig JS SDK is not initialized, so exposures
        // never reach Statsig from SSR alone. Calling manuallyLogExpExposure here — at the exact
        // point where the SSR-preloaded data is consumed on the client — ensures every page load
        // records an exposure, allowing us to measure the experiment's effect accurately.
        // Once the optimal value is found, this will be converted to a permanent Statsig config.
        (0, $6mKj3.manuallyLogExpExposure)('cc_editor_node_data_providers_preload_config');
        const ssrProvidersData = window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] || {};
        const ssrData = ssrProvidersData[this.editorCardProvider.name];
        this.editorCardProvider.setSSRData(ssrData);
    }
}
$de526bdbda89b480$export$385f1396b754ac80.hydratedSSRStates = new WeakSet();
module.exports["ConfluenceSmartCardClient"] = $de526bdbda89b480$export$385f1396b754ac80;

});

parcelRegister("eaaOs", function(module, exports) {
const $170225c35268fd68$var$CARD_APPEARANCE_CACHE_KEY_SUFFIXES = [
    '|inline',
    '|block',
    '|embed'
];
const $170225c35268fd68$var$isValidUrl = (url)=>{
    try {
        new URL(url);
        return true;
    } catch  {
        return false;
    }
};
const $170225c35268fd68$export$b2650c09ef142a71 = (cacheKey)=>{
    for (const suffix of $170225c35268fd68$var$CARD_APPEARANCE_CACHE_KEY_SUFFIXES)if (cacheKey.endsWith(suffix)) {
        const strippedUrl = cacheKey.slice(0, -suffix.length);
        // Only treat as appearance-keyed if the remainder is a valid URL,
        // preventing false positives for URLs that legitimately end with |inline etc.
        if ($170225c35268fd68$var$isValidUrl(strippedUrl)) return {
            metadataStatus: suffix === '|inline' ? 'pending' : 'resolved',
            url: strippedUrl
        };
    }
    return {
        metadataStatus: 'resolved',
        url: cacheKey
    };
};
module.exports["getUrlAndMetadataStatus"] = $170225c35268fd68$export$b2650c09ef142a71;

});

parcelRegister("cknyY", function(module, exports) {

var $9sGCn = parcelRequire("9sGCn");

const $901e3ce3ee925fd9$var$getContentIdFromResolvedData = (resolvedData)=>{
    const ari = resolvedData.data['atlassian:ari'];
    return ari?.substring?.(ari?.lastIndexOf?.('/') + 1);
};
// data.data['@type'] will have two elements, for example ['schema:DigitalDocument', 'Document'], where 'schema:DigitalDocument' specifically denotes a live doc
// The resolve logic doesn't consistently position these two elements in the @type array, so the schema we need to validate may be in the 0th or 1st element
const $901e3ce3ee925fd9$var$isResolvedDataUnarchivedLiveDoc = (resolvedData)=>{
    const typeArr = resolvedData.data['@type'];
    const isLiveDoc = typeArr?.[0] === 'schema:DigitalDocument' || typeArr?.[1] === 'schema:DigitalDocument';
    const isArchived = resolvedData.data['atlassian:state'] === 'archived';
    return isLiveDoc && !isArchived;
};
const $901e3ce3ee925fd9$var$isResolvedDataValid = (resolvedData)=>{
    if (!resolvedData || typeof resolvedData !== 'object') return false;
    const data = resolvedData.data;
    const meta = resolvedData.meta;
    if (!data || !meta) return false;
    if (!('@context' in data)) return false;
    const type = data['@type'];
    if (typeof type !== 'string' && !Array.isArray(type)) return false;
    return true;
};
let $901e3ce3ee925fd9$var$hasInvalidResolverDataAnalyticsEventTriggered = false;
const $901e3ce3ee925fd9$export$e1f1443d16a1c263 = (createAnalyticsEvent, readFragmentInterop, writeFragmentInterop, resolvedData)=>{
    if ($901e3ce3ee925fd9$var$isResolvedDataValid(resolvedData)) {
        if ($901e3ce3ee925fd9$var$isResolvedDataUnarchivedLiveDoc(resolvedData)) {
            const contentId = $901e3ce3ee925fd9$var$getContentIdFromResolvedData(resolvedData);
            if (contentId) {
                let existingCachedData;
                try {
                    existingCachedData = readFragmentInterop({
                        id: `Content:${contentId}`
                    });
                } catch  {
                // readFragment throws an error if no data is found
                }
                // Reads are cheaper than writes, so only write if we don't already have the correct data in cache.
                if (!existingCachedData || existingCachedData?.subType !== 'live' || existingCachedData?.status !== 'current') {
                    writeFragmentInterop({
                        fragmentId: `Content:${contentId}`,
                        // status is current if we are an unarchived live doc
                        data: {
                            __typename: 'Content',
                            id: contentId,
                            subType: 'live',
                            status: 'current'
                        }
                    });
                    // Since graphql cache has been updated, make sure the memoization cache for getCachedPageData is cleared
                    // So if getCachedPageData is called again with the same content id, it will read the updated graphql cache instead of returning the memoized data
                    (0, $9sGCn.clearMemoizedCachedPageData)();
                }
            }
        }
    } else // If resolved data schema is invalid, we likely need to update it ASAP as Linking Platform's content resolver service API may have changed
    if (!$901e3ce3ee925fd9$var$hasInvalidResolverDataAnalyticsEventTriggered) {
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'invalidResolverData',
                actionSubject: 'liveDocSmartCardResolver',
                source: 'confluenceSmartCardProvider'
            }
        }).fire();
        // Only send this event once per load to reduce load on analytics pipeline
        $901e3ce3ee925fd9$var$hasInvalidResolverDataAnalyticsEventTriggered = true;
    }
};
module.exports["liveDocSmartCardResolver"] = $901e3ce3ee925fd9$export$e1f1443d16a1c263;

});

parcelRegister("iJxD8", function(module, exports) {

var $15uL0 = parcelRequire("15uL0");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/identity/team/manifest.ts
var $da3684392924794e$var$identityTeamAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $15uL0.IdentityTeamAriResourceOwner),
    resourceType: (0, $15uL0.IdentityTeamAriResourceType),
    resourceIdSlug: "{teamId}",
    resourceIdSegmentFormats: {
        teamId: /[a-zA-Z0-9.\-_~]+/
    }
};
// src/identity/team/index.ts
var $da3684392924794e$export$33bbb2d79e520118 = class _IdentityTeamAri extends (0, $1gKSA.RegisteredAri) {
    get teamId() {
        return this._teamId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $da3684392924794e$var$identityTeamAriStaticOpts.qualifier,
            platformQualifier: $da3684392924794e$var$identityTeamAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $da3684392924794e$var$identityTeamAriStaticOpts.resourceOwner,
            resourceType: $da3684392924794e$var$identityTeamAriStaticOpts.resourceType,
            resourceId: `${opts.teamId}`,
            resourceIdSegmentValues: {
                teamId: opts.teamId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $da3684392924794e$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $da3684392924794e$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(opts);
    }
    getVariables() {
        return {
            teamId: this.teamId
        };
    }
    constructor(opts){
        super(opts), this._teamId = opts.resourceIdSegmentValues.teamId;
    }
};
module.exports["IdentityTeamAri"] = $da3684392924794e$export$33bbb2d79e520118;

});

parcelRegister("15uL0", function(module, exports) {
// src/identity/team/types.ts
var $0cae1dd2c8cb7865$export$49beddf48ffb3f35 = "identity", $0cae1dd2c8cb7865$export$b2079a2a841afe32 = "team";
module.exports["IdentityTeamAriResourceOwner"] = $0cae1dd2c8cb7865$export$49beddf48ffb3f35;
module.exports["IdentityTeamAriResourceType"] = $0cae1dd2c8cb7865$export$b2079a2a841afe32;

});

parcelRegister("fjKr7", function(module, exports) {

var $lGE71 = parcelRequire("lGE71");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/jira/issue/manifest.ts
var $b26ca6a6a4ea6688$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $lGE71.JiraIssueAriResourceOwner),
    resourceType: (0, $lGE71.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $b26ca6a6a4ea6688$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $b26ca6a6a4ea6688$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $b26ca6a6a4ea6688$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $b26ca6a6a4ea6688$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $b26ca6a6a4ea6688$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $b26ca6a6a4ea6688$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $b26ca6a6a4ea6688$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
};
module.exports["JiraIssueAri"] = $b26ca6a6a4ea6688$export$1da6808e89ee03e;

});

parcelRegister("lGE71", function(module, exports) {
// src/jira/issue/types.ts
var $fc9ca2abfea94195$export$665a39f1b4e29e0a = "jira", $fc9ca2abfea94195$export$76beb4d0da177ad4 = "issue";
module.exports["JiraIssueAriResourceOwner"] = $fc9ca2abfea94195$export$665a39f1b4e29e0a;
module.exports["JiraIssueAriResourceType"] = $fc9ca2abfea94195$export$76beb4d0da177ad4;

});

parcelRegister("1RQo0", function(module, exports) {

var $lyqUH = parcelRequire("lyqUH");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/townsquare/goal/manifest.ts
var $15c3607bf04229f4$var$townsquareGoalAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $lyqUH.TownsquareGoalAriResourceOwner),
    resourceType: (0, $lyqUH.TownsquareGoalAriResourceType),
    resourceIdSlug: "{goalUuid}",
    resourceIdSegmentFormats: {
        goalUuid: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/townsquare/goal/index.ts
var $15c3607bf04229f4$export$e45ea1bd9a289a4f = class _TownsquareGoalAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get goalUuid() {
        return this._goalUuid;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $15c3607bf04229f4$var$townsquareGoalAriStaticOpts.qualifier,
            platformQualifier: $15c3607bf04229f4$var$townsquareGoalAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $15c3607bf04229f4$var$townsquareGoalAriStaticOpts.resourceOwner,
            resourceType: $15c3607bf04229f4$var$townsquareGoalAriStaticOpts.resourceType,
            resourceId: `${opts.goalUuid}`,
            resourceIdSegmentValues: {
                goalUuid: opts.goalUuid
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $15c3607bf04229f4$var$townsquareGoalAriStaticOpts);
        return new _TownsquareGoalAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $15c3607bf04229f4$var$townsquareGoalAriStaticOpts);
        return new _TownsquareGoalAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            goalUuid: this.goalUuid
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._goalUuid = opts.resourceIdSegmentValues.goalUuid;
    }
};
module.exports["TownsquareGoalAri"] = $15c3607bf04229f4$export$e45ea1bd9a289a4f;

});

parcelRegister("lyqUH", function(module, exports) {
// src/townsquare/goal/types.ts
var $fb11a66b9944d017$export$947838268868cc57 = "townsquare", $fb11a66b9944d017$export$935b9c2af9d62e80 = "goal";
module.exports["TownsquareGoalAriResourceOwner"] = $fb11a66b9944d017$export$947838268868cc57;
module.exports["TownsquareGoalAriResourceType"] = $fb11a66b9944d017$export$935b9c2af9d62e80;

});

parcelRegister("aLUFu", function(module, exports) {

var $ilC9E = parcelRequire("ilC9E");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/townsquare/project/manifest.ts
var $7d7a404ac451d38c$var$townsquareProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $ilC9E.TownsquareProjectAriResourceOwner),
    resourceType: (0, $ilC9E.TownsquareProjectAriResourceType),
    resourceIdSlug: "{projectUuid}",
    resourceIdSegmentFormats: {
        projectUuid: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/townsquare/project/index.ts
var $7d7a404ac451d38c$export$41215e8d01921e7d = class _TownsquareProjectAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get projectUuid() {
        return this._projectUuid;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7d7a404ac451d38c$var$townsquareProjectAriStaticOpts.qualifier,
            platformQualifier: $7d7a404ac451d38c$var$townsquareProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7d7a404ac451d38c$var$townsquareProjectAriStaticOpts.resourceOwner,
            resourceType: $7d7a404ac451d38c$var$townsquareProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectUuid}`,
            resourceIdSegmentValues: {
                projectUuid: opts.projectUuid
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $7d7a404ac451d38c$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $7d7a404ac451d38c$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectUuid: this.projectUuid
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._projectUuid = opts.resourceIdSegmentValues.projectUuid;
    }
};
module.exports["TownsquareProjectAri"] = $7d7a404ac451d38c$export$41215e8d01921e7d;

});

parcelRegister("ilC9E", function(module, exports) {
// src/townsquare/project/types.ts
var $d5b7c8e3ddea6aee$export$a258bc824c789b17 = "townsquare", $d5b7c8e3ddea6aee$export$aa8900dadffaa32a = "project";
module.exports["TownsquareProjectAriResourceOwner"] = $d5b7c8e3ddea6aee$export$a258bc824c789b17;
module.exports["TownsquareProjectAriResourceType"] = $d5b7c8e3ddea6aee$export$aa8900dadffaa32a;

});

parcelRegister("5WTxQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $dinVW = parcelRequire("dinVW");


var $2oyXR = parcelRequire("2oyXR");

const $e01be1a23d2a446d$var$styles = {
    wrapper: "_0jFU0VN91d _0KLXrulfZc"
};
const $e01be1a23d2a446d$export$9520f072db304aa0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, testId: testId } = t0;
    if ((0, $iDrrr.fg)("ads-panel-system-gpp")) {
        let t1;
        if ($[0] !== children || $[1] !== testId) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2oyXR.PanelContainer), {
                testId: testId
            }, children);
            $[0] = children;
            $[1] = testId;
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    let t1;
    if ($[3] !== children || $[4] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $e01be1a23d2a446d$var$styles.wrapper,
            testId: testId
        }, children);
        $[3] = children;
        $[4] = testId;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ({ children: children, testId: testId })=>{
    if ((0, $iDrrr.fg)('ads-panel-system-gpp')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2oyXR.PanelContainer), {
        testId: testId
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $e01be1a23d2a446d$var$styles.wrapper,
        testId: testId
    }, children);
};
module.exports["PreviewPanel"] = $e01be1a23d2a446d$export$9520f072db304aa0;

});

parcelRegister("2oyXR", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $biqj4 = parcelRequire("biqj4");

const $6ccdb3d7b226a54f$var$styles = {
    wrapper: "_0jFU0VN91d _0KLXrulfZc _3iDTPbQ4SZ _0aFT5vbt8w _1mT5xdRAKS",
    content: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _0jFU0VN91d _4kiQYAdnbC"
}; /**
    * The PanelContainer component provides a standardized container for displaying content
    * in a side panel layout. It follows the design system patterns and integrates
    * with the navigation system for consistent styling and behavior.
    *
    * Compose it with a fixed `PanelHeader` / `PanelFooter` and a scrollable `PanelContent`
    * (wrapping `PanelSubheader` and `PanelBody`).
    *
    * For resizable panels, use the `PanelSplitter` from `@atlaskit/navigation-system/layout/panel-splitter`
    * alongside the `Panel` slot from `@atlaskit/navigation-system/layout/panel`.
    */ 
const $6ccdb3d7b226a54f$export$7c4d2b536147788a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelContainer(t0) {
    const $ = (0, $bDgLe.c)(8);
    const { children: children, testId: testId, isFocusLockEnabled: t1 } = t0;
    const isFocusLockEnabled = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== children) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $6ccdb3d7b226a54f$var$styles.content,
            children: children
        });
        $[0] = children;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== t2 || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "section",
            testId: testId,
            xcss: $6ccdb3d7b226a54f$var$styles.wrapper,
            children: t2
        });
        $[2] = t2;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isFocusLockEnabled || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $biqj4.PanelFocusLock), {
            isFocusLockEnabled: isFocusLockEnabled,
            children: t3
        });
        $[5] = isFocusLockEnabled;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : function PanelContainer({ children: children, testId: testId, isFocusLockEnabled: isFocusLockEnabled = false }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $biqj4.PanelFocusLock), {
        isFocusLockEnabled: isFocusLockEnabled,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "section",
            testId: testId,
            xcss: $6ccdb3d7b226a54f$var$styles.wrapper,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $6ccdb3d7b226a54f$var$styles.content,
                children: children
            })
        })
    });
};
module.exports["PanelContainer"] = $6ccdb3d7b226a54f$export$7c4d2b536147788a;

});

parcelRegister("biqj4", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $1enXm = parcelRequire("1enXm");


var $1hQ0e = parcelRequire("1hQ0e");

// box model so PanelContainer's own height/flex styles work exactly as if this wrapper
// were not there. This avoids breaking resize and full-height layouts.
const $2153848f433e7d96$var$contentsStyle = {
    display: 'contents'
};
const $2153848f433e7d96$var$containerStyles = null; /**
                               * Module-level count of currently-mounted PanelFocusLock instances.
                               *
                               * Used to suppress the return-focus restore when one panel is replaced by
                               * another (e.g. Jira admin sidebar swaps Sidebar A → Sidebar B by changing
                               * the Provider component, which unmounts/remounts PanelFocusLock). Without
                               * this guard, the unmounting panel's queued double-rAF restore would fire
                               * AFTER the new panel's autofocus, snapping focus back to the original
                               * trigger while a replacement panel is on screen.
                               *
                               * The counter is decremented synchronously on cleanup BEFORE the new
                               * instance's mount effect runs, then re-checked inside the deferred restore.
                               * If another instance has mounted by the time the double-rAF fires, the
                               * restore is skipped.
                               */ 
let $2153848f433e7d96$var$panelFocusLockMountCount = 0; /**
                                   * Module-level handoff for the "previously focused" element across an
                                   * unmount → mount swap.
                                   *
                                   * When one PanelFocusLock unmounts and is immediately replaced by another
                                   * because a button INSIDE the unmounting panel triggered the swap (e.g.
                                   * Sidebar A's footer "Add spaces" button opens Sidebar B), the replacement's
                                   * mount effect sees `document.activeElement === document.body` because the
                                   * previously-focused element lived inside the panel that just unmounted.
                                   * Without a handoff, the replacement would capture `body` as its "previously
                                   * focused" snapshot and on close would restore focus to nothing / blur.
                                   *
                                   * The unmounting instance writes its own previously-focused snapshot here,
                                   * and the next mounting instance reads + clears it. The handoff is used
                                   * ONLY when the replacement's `document.activeElement` is `body` (or null) —
                                   * meaning focus disappeared because it lived inside the unmounting panel.
                                   * If `document.activeElement` is a real element (e.g. the user clicked a
                                   * different page-level trigger to open this panel), that element wins
                                   * because it's a more accurate "where focus came from" signal than the
                                   * previous panel's snapshot. Cleared either by the next mount or by the
                                   * deferred restore when no replacement appears, so a stale value can't leak
                                   * across unrelated open cycles.
                                   */ 
let $2153848f433e7d96$var$pendingPreviouslyFocused = null; /**
                                                          * Selector for all focusable elements inside a container, in LTR tab order.
                                                          */ 
const $2153848f433e7d96$var$FOCUSABLE_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
    'details > summary',
    'audio[controls]',
    'video[controls]'
].join(', ');
const $2153848f433e7d96$export$85d112ac7df5c04f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelFocusLock(t0) {
    const $ = (0, $bDgLe.c)(12);
    const { children: children, isFocusLockEnabled: t1 } = t0;
    const isFocusLockEnabled = t1 === undefined ? false : t1;
    const containerRef = (0, $cozmU.useRef)(null);
    const previouslyFocusedRef = (0, $cozmU.useRef)(null);
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            const doc = (0, $1hQ0e.getDocument)();
            $2153848f433e7d96$var$pendingPreviouslyFocused = null;
            const activeElement = doc?.activeElement ?? null;
            const activeIsBodyOrNull = !activeElement || activeElement === doc?.body;
            const activeIsInsideOwnContainer = !!activeElement && !!containerRef.current?.contains(activeElement);
            const shouldUseHandoff = activeIsBodyOrNull || activeIsInsideOwnContainer;
            const handoffIsAttached = !!$2153848f433e7d96$var$pendingPreviouslyFocused && !!doc?.body?.contains($2153848f433e7d96$var$pendingPreviouslyFocused);
            previouslyFocusedRef.current = shouldUseHandoff && handoffIsAttached ? $2153848f433e7d96$var$pendingPreviouslyFocused : activeElement;
            $2153848f433e7d96$var$panelFocusLockMountCount = $2153848f433e7d96$var$panelFocusLockMountCount + 1;
            return ()=>{
                $2153848f433e7d96$var$panelFocusLockMountCount = $2153848f433e7d96$var$panelFocusLockMountCount - 1;
                $2153848f433e7d96$var$pendingPreviouslyFocused = previouslyFocusedRef.current;
                const toFocus = previouslyFocusedRef.current;
                setTimeout(()=>{
                    setTimeout(()=>{
                        if ($2153848f433e7d96$var$panelFocusLockMountCount > 0) return;
                        $2153848f433e7d96$var$pendingPreviouslyFocused = null;
                        toFocus?.focus();
                    }, 0);
                }, 0);
            };
        };
        t3 = [];
        $[0] = t2;
        $[1] = t3;
    } else {
        t2 = $[0];
        t3 = $[1];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[2] !== isFocusLockEnabled) {
        t4 = ()=>{
            if (isFocusLockEnabled) return;
            const container = containerRef.current;
            if (!container) return;
            const firstFocusable = container.querySelector($2153848f433e7d96$var$FOCUSABLE_SELECTOR);
            if (firstFocusable) firstFocusable.focus({
                preventScroll: true
            });
        };
        t5 = [
            isFocusLockEnabled
        ];
        $[2] = isFocusLockEnabled;
        $[3] = t4;
        $[4] = t5;
    } else {
        t4 = $[3];
        t5 = $[4];
    }
    (0, $cozmU.useEffect)(t4, t5);
    if (isFocusLockEnabled) {
        let t6;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = {
                style: $2153848f433e7d96$var$contentsStyle
            };
            $[5] = t6;
        } else t6 = $[5];
        let t7;
        if ($[6] !== children) {
            t7 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1enXm.default), {
                autoFocus: true,
                returnFocus: false,
                lockProps: t6,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    ref: containerRef,
                    style: $2153848f433e7d96$var$contentsStyle,
                    children: children
                })
            });
            $[6] = children;
            $[7] = t7;
        } else t7 = $[7];
        return t7;
    }
    let t6;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            "_0jFU0VN91d"
        ]);
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== children || $[10] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ref: containerRef,
            className: t6,
            children: children
        });
        $[9] = children;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    return t7;
} : function PanelFocusLock({ children: children, isFocusLockEnabled: isFocusLockEnabled = false }) {
    const containerRef = (0, $cozmU.useRef)(null); // Capture the element that was focused before the panel opened so we can
    // restore focus to it when the panel closes — regardless of which close
    // path is taken (X button, footer Close, programmatic close, etc.).
    const previouslyFocusedRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        // Determine the element focus should return to when this panel closes.
        //
        // Default: use the element that was focused at the moment we mount —
        // this is the natural "page trigger" the user just clicked.
        //
        // Edge case (handoff): when one panel unmounts and is immediately
        // replaced by another because a button INSIDE the previous panel
        // triggered the swap (e.g. Sidebar A's footer "Add spaces" button
        // opens Sidebar B), focus has nowhere to go: the trigger button just
        // unmounted with the previous panel, so `document.activeElement`
        // falls back to `body`. In that specific case we adopt the previous
        // panel's snapshot via the module-level handoff slot — it's typically
        // the original page-level trigger that opened the chain.
        //
        // Edge case (StrictMode): in development, React double-invokes
        // effects (setup → cleanup → setup). The second setup runs AFTER
        // Effect 2 below has already moved focus to our own first focusable,
        // so `document.activeElement` is inside our own container — but the
        // DOM was never actually unmounted, so the focused element is still
        // attached. We treat this case the same as body: the user never
        // "came from" our own input, so we should fall back to the handoff
        // (which was just set by Pass 1's cleanup). Without this guard,
        // `previouslyFocused` would be set to our own first focusable, and
        // on close `focus()` would target an element that is by then detached.
        //
        // Always clear the handoff slot regardless of whether we used it, so
        // a stale value can't leak forward into an unrelated future mount.
        const doc = (0, $1hQ0e.getDocument)();
        const handoff = $2153848f433e7d96$var$pendingPreviouslyFocused;
        $2153848f433e7d96$var$pendingPreviouslyFocused = null;
        const activeElement = doc?.activeElement ?? null;
        const activeIsBodyOrNull = !activeElement || activeElement === doc?.body;
        const activeIsInsideOwnContainer = !!activeElement && !!containerRef.current?.contains(activeElement);
        const shouldUseHandoff = activeIsBodyOrNull || activeIsInsideOwnContainer;
        const handoffIsAttached = !!handoff && !!doc?.body?.contains(handoff);
        previouslyFocusedRef.current = shouldUseHandoff && handoffIsAttached ? handoff : activeElement;
        $2153848f433e7d96$var$panelFocusLockMountCount += 1;
        return ()=>{
            $2153848f433e7d96$var$panelFocusLockMountCount -= 1; // Hand our snapshot off in case a replacement instance is about to
            // mount in the same commit — it will consume this and use it as its
            // own return-focus target, preserving the original trigger across the
            // swap. The slot is cleared either by the next mount or by the
            // deferred restore below if no replacement appears.
            $2153848f433e7d96$var$pendingPreviouslyFocused = previouslyFocusedRef.current; // Capture the target locally so it survives even if something else
            // mutates the ref between now and when the deferred callback fires.
            const toFocus = previouslyFocusedRef.current; // Restore focus on unmount (panel close). Two chained `setTimeout(0)`
            // ensure this fires after react-focus-lock's own deactivation logic
            // when the lock is active, and after React has finished applying any
            // commit that mounted a replacement panel.
            //
            // We use setTimeout rather than requestAnimationFrame here because
            // the latter is unreliable under jsdom + the React 18 concurrent
            // scheduler in unit tests: rAF callbacks scheduled inside a passive
            // effect cleanup don't always flush even when `jest.runAllTimers`
            // is called inside an `act` block (the scheduler uses MessageChannel,
            // which fake timers don't drive). setTimeout(0) flushes reliably with
            // both fake and real timers.
            setTimeout(()=>{
                setTimeout(()=>{
                    // Skip restore if another PanelFocusLock instance has mounted in
                    // the meantime — e.g. a sidebar swap where the consumer unmounts
                    // the current panel and mounts a replacement. The new instance's
                    // autofocus already moved focus into the replacement; restoring
                    // here would yank focus back to this panel's previously-focused
                    // element (typically the original page trigger) and visibly steal
                    // focus away from the replacement panel.
                    if ($2153848f433e7d96$var$panelFocusLockMountCount > 0) return;
                     // We're the last one out — clear the handoff so a future,
                    // unrelated panel open doesn't inherit a stale snapshot.
                    $2153848f433e7d96$var$pendingPreviouslyFocused = null;
                    toFocus?.focus();
                }, 0);
            }, 0);
        };
    }, []);
    // When the lock is NOT enabled, handle auto-focus ourselves — do NOT use
    // react-focus-lock even in disabled mode as it causes layout recalculations
    // that causes animation jank when the panel is inside a CSS transform animation
    // (e.g. SlideIn from @atlaskit/motion).
    (0, $cozmU.useEffect)(()=>{
        if (isFocusLockEnabled) return;
        const container = containerRef.current;
        if (!container) return;
         // Focus synchronously in useEffect (post-paint) with preventScroll to avoid
        // the browser calling scrollIntoView on a mid-animation element.
        const firstFocusable = container.querySelector($2153848f433e7d96$var$FOCUSABLE_SELECTOR);
        if (firstFocusable) firstFocusable.focus({
            preventScroll: true
        });
    }, [
        isFocusLockEnabled
    ]); // When the lock IS enabled, use react-focus-lock for both autoFocus and the trap.
    if (isFocusLockEnabled) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1enXm.default), {
        autoFocus: true,
        returnFocus: false,
        lockProps: {
            style: $2153848f433e7d96$var$contentsStyle
        },
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ref: containerRef,
            style: $2153848f433e7d96$var$contentsStyle,
            children: children
        })
    });
     // Default (no lock): plain wrapper div, auto-focus handled by useEffect above.
    // We deliberately avoid react-focus-lock here to prevent animation jank.
    // height: 100% ensures PanelContainer's own height: 100% resolves correctly.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ref: containerRef,
        className: (0, $hekY6.default)([
            "_0jFU0VN91d"
        ]),
        children: children
    });
};
module.exports["PanelFocusLock"] = $2153848f433e7d96$export$85d112ac7df5c04f;

});

parcelRegister("7ZxlY", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $2d2f9566579f7703$var$styles = {
    group: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT"
}; /**
    * The PanelActionGroup component provides a container for grouping
    * panel actions together with consistent spacing and layout.
    */ 
const $2d2f9566579f7703$export$9546bd4ca18522f9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelActionGroup(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children, testId: testId } = t0;
    let t1;
    if ($[0] !== children || $[1] !== testId) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            testId: testId,
            xcss: $2d2f9566579f7703$var$styles.group,
            children: children
        });
        $[0] = children;
        $[1] = testId;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function PanelActionGroup({ children: children, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        testId: testId,
        xcss: $2d2f9566579f7703$var$styles.group,
        children: children
    });
};
module.exports["PanelActionGroup"] = $2d2f9566579f7703$export$9546bd4ca18522f9;

});

parcelRegister("kMhHg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $aio9r = parcelRequire("aio9r");


var $2Emkv = parcelRequire("2Emkv");

const $f9d4da2be7611286$var$panelSystemStyles = {
    fillParent: "_0jFU0VN91d _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $f9d4da2be7611286$export$cda5e69749e7aeee = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { children: children, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes, styles: consumerStyles } = t0;
    const bodyRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== analyticsAttributes || $[1] !== analyticsClient || $[2] !== panelType || $[3] !== parentProduct) {
        t1 = ()=>{
            if (analyticsClient) {
                analyticsClient.sendTrackEvent({
                    action: "viewed",
                    actionSubject: "preview-panel",
                    actionSubjectId: "preview-panel-view",
                    source: "preview-panel",
                    attributes: {
                        parentProduct: parentProduct,
                        panelType: panelType,
                        ...(0, $iDrrr.fg)("add_capacity_tab_to_the_board_horizontal_nav") || (0, $iDrrr.fg)("add-trigger-point-key-attribute-to-preview-panel") || (0, $cXtTj.default).getExperimentValue("individual_capacity_planning_ga", "isEnabled", false, {
                            fireExperimentExposure: false
                        }) ? analyticsAttributes : {}
                    }
                });
                analyticsClient?.startUIViewedEvent();
            }
        };
        t2 = [
            analyticsClient,
            parentProduct,
            panelType,
            analyticsAttributes
        ];
        $[0] = analyticsAttributes;
        $[1] = analyticsClient;
        $[2] = panelType;
        $[3] = parentProduct;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[6] !== children || $[7] !== consumerStyles) {
        t3 = (0, $iDrrr.fg)("ads-panel-system-gpp") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($f9d4da2be7611286$var$panelSystemStyles.fillParent, !!consumerStyles && consumerStyles),
            ref: bodyRef
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)(!!consumerStyles && consumerStyles),
            ref: bodyRef
        }, children);
        $[6] = children;
        $[7] = consumerStyles;
        $[8] = t3;
    } else t3 = $[8];
    const panelBodyContent = t3;
    if ((0, $iDrrr.fg)("ads-panel-system-gpp")) {
        let t4;
        if ($[9] !== panelBodyContent) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aio9r.PanelBody), {
                spacing: "none"
            }, panelBodyContent);
            $[9] = panelBodyContent;
            $[10] = t4;
        } else t4 = $[10];
        const wrappedBody = t4;
        let t5;
        if ($[11] !== analyticsAttributes || $[12] !== analyticsClient || $[13] !== panelType || $[14] !== parentProduct || $[15] !== wrappedBody) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Emkv.PreviewPanelSniffer), {
                containerRef: bodyRef,
                analyticsClient: analyticsClient,
                parentProduct: parentProduct,
                panelType: panelType,
                analyticsAttributes: analyticsAttributes
            }, wrappedBody);
            $[11] = analyticsAttributes;
            $[12] = analyticsClient;
            $[13] = panelType;
            $[14] = parentProduct;
            $[15] = wrappedBody;
            $[16] = t5;
        } else t5 = $[16];
        return t5;
    }
    let t4;
    if ($[17] !== analyticsAttributes || $[18] !== analyticsClient || $[19] !== panelBodyContent || $[20] !== panelType || $[21] !== parentProduct) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Emkv.PreviewPanelSniffer), {
            containerRef: bodyRef,
            analyticsClient: analyticsClient,
            parentProduct: parentProduct,
            panelType: panelType,
            analyticsAttributes: analyticsAttributes
        }, panelBodyContent);
        $[17] = analyticsAttributes;
        $[18] = analyticsClient;
        $[19] = panelBodyContent;
        $[20] = panelType;
        $[21] = parentProduct;
        $[22] = t4;
    } else t4 = $[22];
    return t4;
} : ({ children: children, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes, styles: consumerStyles })=>{
    const bodyRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (analyticsClient) {
            analyticsClient.sendTrackEvent({
                action: 'viewed',
                actionSubject: 'preview-panel',
                actionSubjectId: 'preview-panel-view',
                source: 'preview-panel',
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType,
                    // Availability check only — this decides whether to decorate the preview-panel
                    // "viewed" track event with analyticsAttributes, NOT whether the user is
                    // accessing the Capacity planning experience. We therefore read the GA
                    // experiment WITHOUT firing a Statsig exposure (fireExperimentExposure: false);
                    // exposure is fired at the point the user actually opens the Capacity
                    // experience, keeping the GA experiment's population clean.
                    //
                    // The OR (now 3-way) still short-circuits: when either the legacy EAP gate or
                    // the `add-trigger-point-key-attribute-to-preview-panel` gate is ON, the GA
                    // experiment is never read at all. EAP customers remain unconditionally enabled.
                    ...(0, $iDrrr.fg)('add_capacity_tab_to_the_board_horizontal_nav') || (0, $iDrrr.fg)('add-trigger-point-key-attribute-to-preview-panel') || (0, $cXtTj.default).getExperimentValue('individual_capacity_planning_ga', 'isEnabled', false, {
                        fireExperimentExposure: false
                    }) ? analyticsAttributes : {}
                }
            });
            // https://developer.atlassian.com/platform/analytics-pipeline/guides/deep-dive/cloud-mau/
            // Fires at most once per hour, per product.
            // Requires tenantInfo and userInfo to be set
            analyticsClient?.startUIViewedEvent();
        }
    }, [
        analyticsClient,
        parentProduct,
        panelType,
        analyticsAttributes
    ]);
    // ignoring the rule as we have so many consumers of this that we need to be able to pass in styles
    /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ const panelBodyContent = (0, $iDrrr.fg)('ads-panel-system-gpp') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($f9d4da2be7611286$var$panelSystemStyles.fillParent, !!consumerStyles && consumerStyles),
        ref: bodyRef
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)(!!consumerStyles && consumerStyles),
        ref: bodyRef
    }, children); /* eslint-enable @atlaskit/design-system/consistent-css-prop-usage */ 
    if ((0, $iDrrr.fg)('ads-panel-system-gpp')) {
        const wrappedBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aio9r.PanelBody), {
            spacing: "none"
        }, panelBodyContent);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Emkv.PreviewPanelSniffer), {
            containerRef: bodyRef,
            analyticsClient: analyticsClient,
            parentProduct: parentProduct,
            panelType: panelType,
            analyticsAttributes: analyticsAttributes
        }, wrappedBody);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Emkv.PreviewPanelSniffer), {
        containerRef: bodyRef,
        analyticsClient: analyticsClient,
        parentProduct: parentProduct,
        panelType: panelType,
        analyticsAttributes: analyticsAttributes
    }, panelBodyContent);
};
module.exports["PreviewPanelBody"] = $f9d4da2be7611286$export$cda5e69749e7aeee;

});

parcelRegister("aio9r", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

const $d35068f09c7abc33$var$styles = {
    body: "_2O5Vij7dHp _3zvHkHdC7N _1mT5xdRAKS",
    defaultSpacing: "_4c065UPgdg _0LQT5ENHnM _03SyCPNHnM"
}; /**
    * The PanelBody component provides the main content area for panels
    * with consistent styling and scroll behavior.
    */ 
const $d35068f09c7abc33$export$3ac6fba5a6f84a87 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelBody(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { children: children, spacing: t1, testId: testId } = t0;
    const spacing = t1 === undefined ? "default" : t1;
    const t2 = spacing === "default" && $d35068f09c7abc33$var$styles.defaultSpacing;
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $w6R6I.cx)($d35068f09c7abc33$var$styles.body, t2);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== children || $[3] !== t3 || $[4] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            testId: testId,
            xcss: t3,
            children: children
        });
        $[2] = children;
        $[3] = t3;
        $[4] = testId;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function PanelBody({ children: children, spacing: spacing = 'default', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        testId: testId,
        xcss: (0, $w6R6I.cx)($d35068f09c7abc33$var$styles.body, spacing === 'default' && $d35068f09c7abc33$var$styles.defaultSpacing),
        children: children
    });
};
module.exports["PanelBody"] = $d35068f09c7abc33$export$3ac6fba5a6f84a87;

});

parcelRegister("2Emkv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");

const $75ef0261b167901c$export$93a96f69a5c679de = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { children: children, containerRef: containerRef, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes } = t0;
    const hasSentOverflowEventRef = (0, $cozmU.useRef)(false);
    let t1;
    if ($[0] !== containerRef) {
        t1 = (event, contentSizePayload)=>{
            if (contentSizePayload.type !== "contentSize" || typeof contentSizePayload.width !== "number" || contentSizePayload.width <= 0 || typeof contentSizePayload.height !== "number" || contentSizePayload.height <= 0) return false;
            const panelIframe = containerRef.current?.querySelector("iframe");
            const panelIframeWindow = panelIframe?.contentWindow;
            if (!panelIframeWindow || event.source !== panelIframeWindow) return false;
            if (event.origin && event.origin !== "null" && panelIframe?.src) try {
                const iframeOrigin = new URL(panelIframe.src, window.location.href).origin;
                if (event.origin !== iframeOrigin) return false;
            } catch  {
                return false;
            }
            return true;
        };
        $[0] = containerRef;
        $[1] = t1;
    } else t1 = $[1];
    const isValidContentSizeMessage = t1;
    let t2;
    if ($[2] !== analyticsAttributes || $[3] !== analyticsClient || $[4] !== panelType || $[5] !== parentProduct) {
        t2 = (t3)=>{
            const { clientWidth: clientWidth, detectionMethod: detectionMethod, scrollWidth: scrollWidth } = t3;
            if (!analyticsClient || hasSentOverflowEventRef.current) return;
            hasSentOverflowEventRef.current = true;
            const overflowPx = typeof clientWidth === "number" && typeof scrollWidth === "number" ? Math.max(scrollWidth - clientWidth, 0) : undefined;
            analyticsClient.sendOperationalEvent({
                action: "detected",
                actionSubject: "layoutOverflow",
                actionSubjectId: "preview-panel-horizontal-overflow",
                source: "preview-panel",
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType,
                    detectionMethod: detectionMethod,
                    clientWidth: clientWidth,
                    scrollWidth: scrollWidth,
                    overflowPx: overflowPx,
                    ...(0, $iDrrr.fg)("add_capacity_tab_to_the_board_horizontal_nav") || (0, $cXtTj.default).getExperimentValue("individual_capacity_planning_ga", "isEnabled", false, {
                        fireExperimentExposure: false
                    }) ? analyticsAttributes : {}
                }
            });
        };
        $[2] = analyticsAttributes;
        $[3] = analyticsClient;
        $[4] = panelType;
        $[5] = parentProduct;
        $[6] = t2;
    } else t2 = $[6];
    const sendOverflowEvent = t2;
    let t3;
    let t4;
    if ($[7] !== containerRef || $[8] !== sendOverflowEvent) {
        t3 = ()=>{
            const bodyElement = containerRef.current;
            if (!bodyElement || typeof ResizeObserver === "undefined") return;
            const detectBodyOverflow = ()=>{
                const clientWidth_0 = bodyElement.clientWidth;
                const scrollWidth_0 = bodyElement.scrollWidth;
                if (scrollWidth_0 > clientWidth_0) sendOverflowEvent({
                    detectionMethod: "body-observer",
                    clientWidth: clientWidth_0,
                    scrollWidth: scrollWidth_0
                });
            };
            detectBodyOverflow();
            const observer = new ResizeObserver(detectBodyOverflow);
            observer.observe(bodyElement);
            return ()=>{
                observer.disconnect();
            };
        };
        t4 = [
            containerRef,
            sendOverflowEvent
        ];
        $[7] = containerRef;
        $[8] = sendOverflowEvent;
        $[9] = t3;
        $[10] = t4;
    } else {
        t3 = $[9];
        t4 = $[10];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[11] !== containerRef || $[12] !== isValidContentSizeMessage || $[13] !== sendOverflowEvent) {
        t5 = ()=>{
            const handleMessage = (event_0)=>{
                const contentSizePayload_0 = event_0.data;
                if (!isValidContentSizeMessage(event_0, contentSizePayload_0)) return;
                const panelIframe_0 = containerRef.current?.querySelector("iframe");
                const iframeClientWidth = panelIframe_0?.clientWidth ?? 0;
                const clientWidth_1 = iframeClientWidth > 0 ? iframeClientWidth : containerRef.current?.clientWidth;
                if (typeof clientWidth_1 !== "number" || contentSizePayload_0.width <= clientWidth_1) return;
                sendOverflowEvent({
                    detectionMethod: "iframe-content-size-message",
                    clientWidth: clientWidth_1,
                    scrollWidth: contentSizePayload_0.width
                });
            };
            return (0, $cbY7C.bind)(window, {
                type: "message",
                listener: handleMessage
            });
        };
        t6 = [
            containerRef,
            isValidContentSizeMessage,
            sendOverflowEvent
        ];
        $[11] = containerRef;
        $[12] = isValidContentSizeMessage;
        $[13] = sendOverflowEvent;
        $[14] = t5;
        $[15] = t6;
    } else {
        t5 = $[14];
        t6 = $[15];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[16] !== children) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[16] = children;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : ({ children: children, containerRef: containerRef, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes })=>{
    const hasSentOverflowEventRef = (0, $cozmU.useRef)(false);
    const isValidContentSizeMessage = (0, $cozmU.useCallback)((event, contentSizePayload)=>{
        if (contentSizePayload.type !== 'contentSize' || typeof contentSizePayload.width !== 'number' || contentSizePayload.width <= 0 || typeof contentSizePayload.height !== 'number' || contentSizePayload.height <= 0) return false;
        const panelIframe = containerRef.current?.querySelector('iframe');
        const panelIframeWindow = panelIframe?.contentWindow;
        if (!panelIframeWindow || event.source !== panelIframeWindow) return false;
        // If both origins are known, ensure the message comes from the iframe's origin.
        if (event.origin && event.origin !== 'null' && panelIframe?.src) try {
            const iframeOrigin = new URL(panelIframe.src, window.location.href).origin;
            if (event.origin !== iframeOrigin) return false;
        } catch  {
            return false;
        }
        return true;
    }, [
        containerRef
    ]);
    const sendOverflowEvent = (0, $cozmU.useCallback)(({ clientWidth: clientWidth, detectionMethod: detectionMethod, scrollWidth: scrollWidth })=>{
        if (!analyticsClient || hasSentOverflowEventRef.current) return;
        hasSentOverflowEventRef.current = true;
        const overflowPx = typeof clientWidth === 'number' && typeof scrollWidth === 'number' ? Math.max(scrollWidth - clientWidth, 0) : undefined;
        analyticsClient.sendOperationalEvent({
            action: 'detected',
            actionSubject: 'layoutOverflow',
            actionSubjectId: 'preview-panel-horizontal-overflow',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType,
                detectionMethod: detectionMethod,
                clientWidth: clientWidth,
                scrollWidth: scrollWidth,
                overflowPx: overflowPx,
                // Availability check only — this decides whether to decorate the overflow
                // operational event with analyticsAttributes, NOT whether the user is
                // accessing the Capacity planning experience. We therefore read the GA
                // experiment WITHOUT firing a Statsig exposure
                // (fireExperimentExposure: false); exposure is fired at the point the user
                // actually opens the Capacity experience, keeping the GA experiment's
                // population clean.
                //
                // The OR still short-circuits: when the legacy EAP gate is ON the experiment
                // is never read at all. EAP customers remain unconditionally enabled.
                ...(0, $iDrrr.fg)('add_capacity_tab_to_the_board_horizontal_nav') || (0, $cXtTj.default).getExperimentValue('individual_capacity_planning_ga', 'isEnabled', false, {
                    fireExperimentExposure: false
                }) ? analyticsAttributes : {}
            }
        });
    }, [
        analyticsClient,
        parentProduct,
        panelType,
        analyticsAttributes
    ]);
    (0, $cozmU.useEffect)(()=>{
        const bodyElement = containerRef.current;
        if (!bodyElement || typeof ResizeObserver === 'undefined') return;
        const detectBodyOverflow = ()=>{
            const clientWidth_0 = bodyElement.clientWidth;
            const scrollWidth_0 = bodyElement.scrollWidth;
            if (scrollWidth_0 > clientWidth_0) sendOverflowEvent({
                detectionMethod: 'body-observer',
                clientWidth: clientWidth_0,
                scrollWidth: scrollWidth_0
            });
        };
        detectBodyOverflow();
        const observer = new ResizeObserver(detectBodyOverflow);
        observer.observe(bodyElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        containerRef,
        sendOverflowEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        const handleMessage = (event_0)=>{
            const contentSizePayload_0 = event_0.data;
            if (!isValidContentSizeMessage(event_0, contentSizePayload_0)) return;
            const panelIframe_0 = containerRef.current?.querySelector('iframe');
            const iframeClientWidth = panelIframe_0?.clientWidth ?? 0;
            const clientWidth_1 = iframeClientWidth > 0 ? iframeClientWidth : containerRef.current?.clientWidth;
            if (typeof clientWidth_1 !== 'number' || contentSizePayload_0.width <= clientWidth_1) return;
            sendOverflowEvent({
                detectionMethod: 'iframe-content-size-message',
                clientWidth: clientWidth_1,
                scrollWidth: contentSizePayload_0.width
            });
        };
        return (0, $cbY7C.bind)(window, {
            type: 'message',
            listener: handleMessage
        });
    }, [
        containerRef,
        isValidContentSizeMessage,
        sendOverflowEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
module.exports["PreviewPanelSniffer"] = $75ef0261b167901c$export$93a96f69a5c679de;

});

parcelRegister("7ZpVx", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $7WEaj = parcelRequire("7WEaj");


var $7vK9E = parcelRequire("7vK9E");

const $2efd2cd3ca9e912b$export$2a18e3520151503 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(43);
    const { children: children, onClick: onClick, href: href, testId: testId, target: target, rel: rel, "aria-label": ariaLabel, "aria-haspopup": ariaHaspopup, "aria-expanded": ariaExpanded, icon: icon, label: label, appearance: t1, spacing: t2 } = t0;
    const appearance = t1 === undefined ? "subtle" : t1;
    const spacing = t2 === undefined ? "default" : t2;
    if (icon && href) {
        const t3 = ref;
        const t4 = onClick;
        const t5 = label || ariaLabel;
        let t6;
        if ($[0] !== appearance || $[1] !== ariaExpanded || $[2] !== ariaHaspopup || $[3] !== href || $[4] !== icon || $[5] !== rel || $[6] !== spacing || $[7] !== t3 || $[8] !== t4 || $[9] !== t5 || $[10] !== target || $[11] !== testId) {
            t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7WEaj.default), {
                ref: t3,
                href: href,
                onClick: t4,
                testId: testId,
                target: target,
                rel: rel,
                icon: icon,
                label: t5,
                appearance: appearance,
                "aria-haspopup": ariaHaspopup,
                "aria-expanded": ariaExpanded,
                isTooltipDisabled: false,
                spacing: spacing
            });
            $[0] = appearance;
            $[1] = ariaExpanded;
            $[2] = ariaHaspopup;
            $[3] = href;
            $[4] = icon;
            $[5] = rel;
            $[6] = spacing;
            $[7] = t3;
            $[8] = t4;
            $[9] = t5;
            $[10] = target;
            $[11] = testId;
            $[12] = t6;
        } else t6 = $[12];
        return t6;
    }
    if (icon) {
        const t3 = ref;
        const t4 = onClick;
        const t5 = label || ariaLabel;
        let t6;
        if ($[13] !== appearance || $[14] !== ariaExpanded || $[15] !== ariaHaspopup || $[16] !== icon || $[17] !== spacing || $[18] !== t3 || $[19] !== t4 || $[20] !== t5 || $[21] !== testId) {
            t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                ref: t3,
                onClick: t4,
                testId: testId,
                icon: icon,
                label: t5,
                appearance: appearance,
                "aria-haspopup": ariaHaspopup,
                "aria-expanded": ariaExpanded,
                isTooltipDisabled: false,
                spacing: spacing
            });
            $[13] = appearance;
            $[14] = ariaExpanded;
            $[15] = ariaHaspopup;
            $[16] = icon;
            $[17] = spacing;
            $[18] = t3;
            $[19] = t4;
            $[20] = t5;
            $[21] = testId;
            $[22] = t6;
        } else t6 = $[22];
        return t6;
    }
    if (href) {
        const t3 = ref;
        const t4 = onClick;
        let t5;
        if ($[23] !== ariaExpanded || $[24] !== ariaHaspopup || $[25] !== ariaLabel || $[26] !== children || $[27] !== href || $[28] !== rel || $[29] !== t3 || $[30] !== t4 || $[31] !== target || $[32] !== testId) {
            t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
                ref: t3,
                href: href,
                onClick: t4,
                testId: testId,
                target: target,
                rel: rel,
                "aria-label": ariaLabel,
                "aria-haspopup": ariaHaspopup,
                "aria-expanded": ariaExpanded,
                children: children
            });
            $[23] = ariaExpanded;
            $[24] = ariaHaspopup;
            $[25] = ariaLabel;
            $[26] = children;
            $[27] = href;
            $[28] = rel;
            $[29] = t3;
            $[30] = t4;
            $[31] = target;
            $[32] = testId;
            $[33] = t5;
        } else t5 = $[33];
        return t5;
    }
    const t3 = ref;
    const t4 = onClick;
    let t5;
    if ($[34] !== appearance || $[35] !== ariaExpanded || $[36] !== ariaHaspopup || $[37] !== ariaLabel || $[38] !== children || $[39] !== t3 || $[40] !== t4 || $[41] !== testId) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
            ref: t3,
            onClick: t4,
            testId: testId,
            "aria-label": ariaLabel,
            "aria-haspopup": ariaHaspopup,
            "aria-expanded": ariaExpanded,
            appearance: appearance,
            children: children
        });
        $[34] = appearance;
        $[35] = ariaExpanded;
        $[36] = ariaHaspopup;
        $[37] = ariaLabel;
        $[38] = children;
        $[39] = t3;
        $[40] = t4;
        $[41] = testId;
        $[42] = t5;
    } else t5 = $[42];
    return t5;
} : ({ children: children, onClick: onClick, href: href, testId: testId, target: target, rel: rel, 'aria-label': ariaLabel, 'aria-haspopup': ariaHaspopup, 'aria-expanded': ariaExpanded, icon: icon, label: label, appearance: appearance = 'subtle', spacing: spacing = 'default' }, ref)=>{
    if (icon && href) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7WEaj.default), {
        ref: ref,
        href: href,
        onClick: onClick,
        testId: testId,
        target: target,
        rel: rel,
        icon: icon,
        label: label || ariaLabel,
        appearance: appearance,
        "aria-haspopup": ariaHaspopup,
        "aria-expanded": ariaExpanded,
        isTooltipDisabled: false,
        spacing: spacing
    });
    if (icon) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
        ref: ref,
        onClick: onClick,
        testId: testId,
        icon: icon,
        label: label || ariaLabel,
        appearance: appearance,
        "aria-haspopup": ariaHaspopup,
        "aria-expanded": ariaExpanded,
        isTooltipDisabled: false,
        spacing: spacing
    });
    if (href) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
        ref: ref,
        href: href,
        onClick: onClick,
        testId: testId,
        target: target,
        rel: rel,
        "aria-label": ariaLabel,
        "aria-haspopup": ariaHaspopup,
        "aria-expanded": ariaExpanded,
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
        ref: ref,
        onClick: onClick,
        testId: testId,
        "aria-label": ariaLabel,
        "aria-haspopup": ariaHaspopup,
        "aria-expanded": ariaExpanded,
        appearance: appearance,
        children: children
    });
});
module.exports["PanelAction"] = $2efd2cd3ca9e912b$export$2a18e3520151503;

});

parcelRegister("Emr0i", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $e1da37ec0a029195$var$_default_1 = (0, $kSwu1.defineMessages)({
    previewPanelCloseButtonLabel: {
        id: "navigation.preview-panel.preview-panel-header.close-button-label",
        defaultMessage: "Close"
    },
    previewPanelExpandActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-expand.expand-action-label",
        defaultMessage: "Expand"
    },
    previewPanelNewTabActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-new-tab.new-tab-action-label",
        defaultMessage: "Open in new tab"
    },
    previewPanelMoreDropdownActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-more-dropdown.more-dropdown-action-label",
        defaultMessage: "More"
    },
    previewPanelOpenInNewWindowLabel: {
        id: "navigation.preview-panel.preview-panel-header.open-in-new-window-label",
        defaultMessage: "Open in new window"
    },
    previewPanelNavigateBackLabel: {
        id: "navigation.preview-panel.preview-panel-header.navigate-back-label",
        defaultMessage: "Go back to previous panel"
    }
});
var $e1da37ec0a029195$export$2e2bcd8739ae039 = $e1da37ec0a029195$var$_default_1;
module.exports["default"] = $e1da37ec0a029195$export$2e2bcd8739ae039;

});

parcelRegister("6GBgL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1sCHt = parcelRequire("1sCHt");


var $7WEaj = parcelRequire("7WEaj");


var $iDrrr = parcelRequire("iDrrr");


var $7ZpVx = parcelRequire("7ZpVx");

const $e48bc72cc4b3f1f2$export$a37cb5f447b2cf16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? function PreviewPanelAction(t0, ref) {
    const $ = (0, $bDgLe.c)(22);
    const { icon: icon, label: label, onClick: onClick, href: href, testId: testId, analyticsContext: analyticsContext } = t0;
    if ((0, $iDrrr.fg)("ads-panel-system-gpp")) {
        if (analyticsContext || href) {
            let t1;
            if ($[0] !== analyticsContext || $[1] !== href || $[2] !== icon || $[3] !== label || $[4] !== onClick || $[5] !== ref || $[6] !== testId) {
                t1 = href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
                    icon: icon,
                    label: label,
                    onClick: onClick,
                    href: href,
                    testId: testId,
                    analyticsContext: analyticsContext,
                    appearance: "subtle",
                    target: "_blank",
                    ref: ref,
                    role: "button"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                    icon: icon,
                    label: label,
                    onClick: onClick,
                    testId: testId,
                    analyticsContext: analyticsContext,
                    appearance: "subtle",
                    ref: ref,
                    role: "button"
                });
                $[0] = analyticsContext;
                $[1] = href;
                $[2] = icon;
                $[3] = label;
                $[4] = onClick;
                $[5] = ref;
                $[6] = testId;
                $[7] = t1;
            } else t1 = $[7];
            return t1;
        }
        let t1;
        if ($[8] !== icon || $[9] !== label || $[10] !== onClick || $[11] !== ref || $[12] !== testId) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
                ref: ref,
                icon: icon,
                label: label,
                onClick: onClick,
                testId: testId,
                appearance: "subtle"
            });
            $[8] = icon;
            $[9] = label;
            $[10] = onClick;
            $[11] = ref;
            $[12] = testId;
            $[13] = t1;
        } else t1 = $[13];
        return t1;
    }
    let t1;
    if ($[14] !== analyticsContext || $[15] !== href || $[16] !== icon || $[17] !== label || $[18] !== onClick || $[19] !== ref || $[20] !== testId) {
        t1 = href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
            icon: icon,
            label: label,
            onClick: onClick,
            href: href,
            testId: testId,
            analyticsContext: analyticsContext,
            appearance: "subtle",
            target: "_blank",
            ref: ref,
            role: "button"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: icon,
            label: label,
            onClick: onClick,
            testId: testId,
            analyticsContext: analyticsContext,
            appearance: "subtle",
            ref: ref,
            role: "button"
        });
        $[14] = analyticsContext;
        $[15] = href;
        $[16] = icon;
        $[17] = label;
        $[18] = onClick;
        $[19] = ref;
        $[20] = testId;
        $[21] = t1;
    } else t1 = $[21];
    return t1;
} : function PreviewPanelAction({ icon: icon, label: label, onClick: onClick, href: href, testId: testId, analyticsContext: analyticsContext }, ref) {
    if ((0, $iDrrr.fg)('ads-panel-system-gpp')) {
        if (analyticsContext || href) return href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
            icon: icon,
            label: label,
            onClick: onClick,
            href: href,
            testId: testId,
            analyticsContext: analyticsContext,
            appearance: "subtle",
            target: "_blank",
            ref: ref,
            role: "button"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: icon,
            label: label,
            onClick: onClick,
            testId: testId,
            analyticsContext: analyticsContext,
            appearance: "subtle",
            ref: ref,
            role: "button"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
            ref: ref,
            icon: icon,
            label: label,
            onClick: onClick,
            testId: testId,
            appearance: "subtle"
        });
    }
    return href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
        icon: icon,
        label: label,
        onClick: onClick,
        href: href,
        testId: testId,
        analyticsContext: analyticsContext,
        appearance: "subtle",
        target: "_blank",
        ref: ref,
        role: "button"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: icon,
        label: label,
        onClick: onClick,
        testId: testId,
        analyticsContext: analyticsContext,
        appearance: "subtle",
        ref: ref,
        role: "button"
    });
});
module.exports["PreviewPanelAction"] = $e48bc72cc4b3f1f2$export$a37cb5f447b2cf16;

});

parcelRegister("fE1YT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aIlZA = parcelRequire("aIlZA");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $kdlgT = parcelRequire("kdlgT");


var $l3wuH = parcelRequire("l3wuH");


var $V3JOP = parcelRequire("V3JOP");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");


var $7ZpVx = parcelRequire("7ZpVx");

var $i68yG = parcelRequire("i68yG");

var $7ZxlY = parcelRequire("7ZxlY");

var $1jpZo = parcelRequire("1jpZo");


var $Emr0i = parcelRequire("Emr0i");


var $7Yky3 = parcelRequire("7Yky3");

const $30b8761d1cee2886$export$e1ea1fbf111a14fe = (url, paramToRemove)=>{
    try {
        const urlObj = new URL(url);
        urlObj.searchParams.delete(paramToRemove);
        return urlObj.toString();
    } catch  {
        // If URL parsing fails, return the original URL
        return url;
    }
};
const $30b8761d1cee2886$var$styles = {
    header: "_3vBAKH9r67 _0LQT5ENHnM _03SyCPNHnM _46hvQm5zaO _0xmtko5zaO _2yjt2x6wH8 _4auqkJNvrM _0jFU0VmdCj",
    childWrapper: "_2O5Vij7dHp",
    titleRegion: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _37wbyuI7V3 _2O5Vij7dHp _4ouGXIdnbC"
}; /**
    * @private
    * @deprecated `@atlassian/preview-panel` is deprecated. Use `@atlassian/panel-system` instead.
    * {@link https://atlassian.design/components/panel-system/examples}
    */ 
const $30b8761d1cee2886$export$426d4171de44bac0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(72);
    const { children: children, onClose: onClose, onOpenInNewTab: onOpenInNewTab, onNavigateBack: onNavigateBack, testId: testId, url: url, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, moreActions: moreActions } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $iDrrr.fg)("platform_preview_panels_cross_app_interaction");
        $[0] = t1;
    } else t1 = $[0];
    const enableCrossMAUUsage = t1;
    const t2 = parentProduct ?? "unknown";
    let t3;
    if ($[1] !== t2) {
        t3 = {
            bridge: "preview-panels",
            product: t2
        };
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    const buildUrlWithAnalyticsParams = (0, $aIlZA.default)(t3);
    let t4;
    if ($[3] !== analyticsClient || $[4] !== onClose || $[5] !== panelType || $[6] !== parentProduct) {
        t4 = ()=>{
            analyticsClient?.sendTrackEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "preview-panel-close",
                source: "preview-panel",
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType
                }
            });
            onClose?.();
        };
        $[3] = analyticsClient;
        $[4] = onClose;
        $[5] = panelType;
        $[6] = parentProduct;
        $[7] = t4;
    } else t4 = $[7];
    const onPanelClose = t4;
    let t5;
    if ($[8] !== analyticsClient || $[9] !== buildUrlWithAnalyticsParams || $[10] !== onOpenInNewTab || $[11] !== panelType || $[12] !== parentProduct || $[13] !== url) {
        t5 = ()=>{
            analyticsClient?.sendTrackEvent({
                action: "clicked",
                actionSubject: "link",
                actionSubjectId: "preview-panel-open-in-new-window",
                source: "preview-panel",
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType
                }
            });
            onOpenInNewTab?.();
            if (url) window.open(enableCrossMAUUsage ? buildUrlWithAnalyticsParams($30b8761d1cee2886$export$e1ea1fbf111a14fe(url, "previewPanels")) : $30b8761d1cee2886$export$e1ea1fbf111a14fe(url, "previewPanels"));
        };
        $[8] = analyticsClient;
        $[9] = buildUrlWithAnalyticsParams;
        $[10] = onOpenInNewTab;
        $[11] = panelType;
        $[12] = parentProduct;
        $[13] = url;
        $[14] = t5;
    } else t5 = $[14];
    const onOpenInNewWindow = t5;
    let t6;
    if ($[15] !== analyticsClient || $[16] !== onNavigateBack || $[17] !== panelType || $[18] !== parentProduct) {
        t6 = ()=>{
            analyticsClient?.sendTrackEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "preview-panel-navigate-back",
                source: "preview-panel",
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType
                }
            });
            onNavigateBack?.();
        };
        $[15] = analyticsClient;
        $[16] = onNavigateBack;
        $[17] = panelType;
        $[18] = parentProduct;
        $[19] = t6;
    } else t6 = $[19];
    const onPanelNavigateBack = t6;
    if ((0, $iDrrr.fg)("ads-panel-system-gpp")) {
        let t7;
        if ($[20] !== formatMessage || $[21] !== onNavigateBack || $[22] !== onPanelNavigateBack || $[23] !== testId) {
            t7 = onNavigateBack && (0, $iDrrr.fg)("jivtech-1920-back-navigation-gpp") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
                label: formatMessage((0, $Emr0i.default).previewPanelNavigateBackLabel),
                onClick: onPanelNavigateBack,
                testId: testId && `${testId}.navigate-back-button`,
                appearance: "default"
            });
            $[20] = formatMessage;
            $[21] = onNavigateBack;
            $[22] = onPanelNavigateBack;
            $[23] = testId;
            $[24] = t7;
        } else t7 = $[24];
        let t8;
        if ($[25] !== children) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $30b8761d1cee2886$var$styles.titleRegion
            }, children);
            $[25] = children;
            $[26] = t8;
        } else t8 = $[26];
        let t9;
        if ($[27] !== formatMessage || $[28] !== onOpenInNewWindow || $[29] !== testId || $[30] !== url) {
            t9 = url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
                label: formatMessage((0, $Emr0i.default).previewPanelOpenInNewWindowLabel),
                onClick: onOpenInNewWindow,
                testId: testId && `${testId}.open-in-new-window-button`,
                appearance: "subtle"
            });
            $[27] = formatMessage;
            $[28] = onOpenInNewWindow;
            $[29] = testId;
            $[30] = url;
            $[31] = t9;
        } else t9 = $[31];
        let t10;
        if ($[32] !== formatMessage || $[33] !== onClose || $[34] !== onPanelClose || $[35] !== testId) {
            t10 = onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i68yG.PanelActionClose), {
                onClick: onPanelClose,
                testId: testId && `${testId}.close-button`,
                label: formatMessage((0, $Emr0i.default).previewPanelCloseButtonLabel)
            });
            $[32] = formatMessage;
            $[33] = onClose;
            $[34] = onPanelClose;
            $[35] = testId;
            $[36] = t10;
        } else t10 = $[36];
        let t11;
        if ($[37] !== moreActions || $[38] !== t10 || $[39] !== t9) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZxlY.PanelActionGroup), null, t9, moreActions, t10);
            $[37] = moreActions;
            $[38] = t10;
            $[39] = t9;
            $[40] = t11;
        } else t11 = $[40];
        let t12;
        if ($[41] !== t11 || $[42] !== t7 || $[43] !== t8 || $[44] !== testId) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1jpZo.PanelHeader), {
                testId: testId
            }, t7, t8, t11);
            $[41] = t11;
            $[42] = t7;
            $[43] = t8;
            $[44] = testId;
            $[45] = t12;
        } else t12 = $[45];
        return t12;
    }
    let t7;
    if ($[46] !== formatMessage || $[47] !== onNavigateBack || $[48] !== onPanelNavigateBack || $[49] !== testId) {
        t7 = onNavigateBack && (0, $iDrrr.fg)("jivtech-1920-back-navigation-gpp") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: $30b8761d1cee2886$var$_temp,
            label: formatMessage((0, $Emr0i.default).previewPanelNavigateBackLabel),
            onClick: onPanelNavigateBack,
            testId: testId && `${testId}.navigate-back-button`
        });
        $[46] = formatMessage;
        $[47] = onNavigateBack;
        $[48] = onPanelNavigateBack;
        $[49] = testId;
        $[50] = t7;
    } else t7 = $[50];
    let t8;
    if ($[51] !== children) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $30b8761d1cee2886$var$styles.childWrapper,
            spread: "space-between",
            alignBlock: "center",
            space: "space.100"
        }, children);
        $[51] = children;
        $[52] = t8;
    } else t8 = $[52];
    let t9;
    if ($[53] !== formatMessage || $[54] !== onOpenInNewWindow || $[55] !== testId || $[56] !== url) {
        t9 = url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7Yky3.PreviewPanelNewTabLink), {
            label: formatMessage((0, $Emr0i.default).previewPanelOpenInNewWindowLabel),
            onClick: onOpenInNewWindow,
            testId: testId && `${testId}.open-in-new-window-button`
        });
        $[53] = formatMessage;
        $[54] = onOpenInNewWindow;
        $[55] = testId;
        $[56] = url;
        $[57] = t9;
    } else t9 = $[57];
    let t10;
    if ($[58] !== formatMessage || $[59] !== onClose || $[60] !== onPanelClose || $[61] !== testId) {
        t10 = onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: $30b8761d1cee2886$var$_temp2,
            label: formatMessage((0, $Emr0i.default).previewPanelCloseButtonLabel),
            onClick: onPanelClose,
            testId: testId && `${testId}.close-button`,
            role: "button"
        });
        $[58] = formatMessage;
        $[59] = onClose;
        $[60] = onPanelClose;
        $[61] = testId;
        $[62] = t10;
    } else t10 = $[62];
    let t11;
    if ($[63] !== moreActions || $[64] !== t10 || $[65] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            gap: "space.100"
        }, t9, moreActions, t10);
        $[63] = moreActions;
        $[64] = t10;
        $[65] = t9;
        $[66] = t11;
    } else t11 = $[66];
    let t12;
    if ($[67] !== t11 || $[68] !== t7 || $[69] !== t8 || $[70] !== testId) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $30b8761d1cee2886$var$styles.header,
            testId: testId,
            alignBlock: "center",
            space: "space.100"
        }, t7, t8, t11);
        $[67] = t11;
        $[68] = t7;
        $[69] = t8;
        $[70] = testId;
        $[71] = t12;
    } else t12 = $[71];
    return t12;
} : ({ children: children, onClose: onClose, onOpenInNewTab: onOpenInNewTab, onNavigateBack: onNavigateBack, testId: testId, url: url, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, moreActions: moreActions })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const enableCrossMAUUsage = (0, $iDrrr.fg)('platform_preview_panels_cross_app_interaction');
    const buildUrlWithAnalyticsParams = (0, $aIlZA.default)({
        bridge: 'preview-panels',
        product: parentProduct ?? 'unknown'
    });
    const onPanelClose = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preview-panel-close',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onClose?.();
    };
    const onOpenInNewWindow = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'preview-panel-open-in-new-window',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onOpenInNewTab?.();
        if (url) window.open(enableCrossMAUUsage ? buildUrlWithAnalyticsParams($30b8761d1cee2886$export$e1ea1fbf111a14fe(url, 'previewPanels')) : $30b8761d1cee2886$export$e1ea1fbf111a14fe(url, 'previewPanels'));
    };
    const onPanelNavigateBack = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preview-panel-navigate-back',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onNavigateBack?.();
    };
    if ((0, $iDrrr.fg)('ads-panel-system-gpp')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1jpZo.PanelHeader), {
        testId: testId
    }, onNavigateBack && (0, $iDrrr.fg)('jivtech-1920-back-navigation-gpp') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
        label: formatMessage((0, $Emr0i.default).previewPanelNavigateBackLabel),
        onClick: onPanelNavigateBack,
        testId: testId && `${testId}.navigate-back-button`,
        appearance: "default"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $30b8761d1cee2886$var$styles.titleRegion
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZxlY.PanelActionGroup), null, url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
        label: formatMessage((0, $Emr0i.default).previewPanelOpenInNewWindowLabel),
        onClick: onOpenInNewWindow,
        testId: testId && `${testId}.open-in-new-window-button`,
        appearance: "subtle"
    }), moreActions, onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i68yG.PanelActionClose), {
        onClick: onPanelClose,
        testId: testId && `${testId}.close-button`,
        label: formatMessage((0, $Emr0i.default).previewPanelCloseButtonLabel)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $30b8761d1cee2886$var$styles.header,
        testId: testId,
        alignBlock: "center",
        space: "space.100"
    }, onNavigateBack && (0, $iDrrr.fg)('jivtech-1920-back-navigation-gpp') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $Emr0i.default).previewPanelNavigateBackLabel),
        onClick: onPanelNavigateBack,
        testId: testId && `${testId}.navigate-back-button`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $30b8761d1cee2886$var$styles.childWrapper,
        spread: "space-between",
        alignBlock: "center",
        space: "space.100"
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        gap: "space.100"
    }, url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7Yky3.PreviewPanelNewTabLink), {
        label: formatMessage((0, $Emr0i.default).previewPanelOpenInNewWindowLabel),
        onClick: onOpenInNewWindow,
        testId: testId && `${testId}.open-in-new-window-button`
    }), moreActions, onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...iconProps_0,
                size: "small"
            }),
        label: formatMessage((0, $Emr0i.default).previewPanelCloseButtonLabel),
        onClick: onPanelClose,
        testId: testId && `${testId}.close-button`,
        role: "button"
    })));
};
function $30b8761d1cee2886$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))), {
        ...iconProps,
        size: "small"
    });
}
function $30b8761d1cee2886$var$_temp2(iconProps_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        ...iconProps_0,
        size: "small"
    });
}
module.exports["PreviewPanelHeader"] = $30b8761d1cee2886$export$426d4171de44bac0;

});

parcelRegister("i68yG", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $l3wuH = parcelRequire("l3wuH");


var $7ZpVx = parcelRequire("7ZpVx");

const $837042f62dde5900$export$75d0a5a5f71a1ab1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(8);
    const { onClick: onClick, onBeforeClose: onBeforeClose, testId: testId, label: label } = t0;
    let t1;
    if ($[0] !== onBeforeClose || $[1] !== onClick) {
        t1 = async (event, analyticsEvent)=>{
            if (onBeforeClose) {
                const canClose = await onBeforeClose();
                if (!canClose) return;
            }
            if (onClick) onClick(event, analyticsEvent);
        };
        $[0] = onBeforeClose;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const handleClick = t1;
    const t2 = label || "Close panel";
    let t3;
    if ($[3] !== handleClick || $[4] !== ref || $[5] !== t2 || $[6] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZpVx.PanelAction), {
            ref: ref,
            onClick: handleClick,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
            label: t2,
            spacing: "compact",
            appearance: "subtle"
        });
        $[3] = handleClick;
        $[4] = ref;
        $[5] = t2;
        $[6] = testId;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ onClick: onClick, onBeforeClose: onBeforeClose, testId: testId, label: label }, ref)=>{
    const handleClick = async (event, analyticsEvent)=>{
        if (onBeforeClose) {
            const canClose = await onBeforeClose();
            if (!canClose) return;
        }
        if (onClick) onClick(event, analyticsEvent);
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZpVx.PanelAction), {
        ref: ref,
        onClick: handleClick,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: label || 'Close panel',
        spacing: "compact",
        appearance: "subtle"
    });
});
module.exports["PanelActionClose"] = $837042f62dde5900$export$75d0a5a5f71a1ab1;

});

parcelRegister("1jpZo", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

const $2747dc4177a5f32c$var$styles = {
    header: "_0jFU0V36Ow _3iDTPbQ4SZ _0hPCNLDIqT _0LQT5EkG2W _03SyCPkG2W _46hvQm5zaO _0xmtko5zaO",
    headerContent: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _39xV02N91d"
}; /**
    * The PanelHeader component provides a standardized header area for panels
    * containing the title, actions, and other header-specific content.
    * It automatically organizes content into left (back button + title) and right (actions) sections
    * using flexbox layout. Place PanelActionGroup as the last child to position it on the right.
    */ 
const $2747dc4177a5f32c$export$968713404ca1c9aa = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelHeader(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { children: children, testId: testId } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
            xcss: $2747dc4177a5f32c$var$styles.headerContent,
            children: children
        });
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1 || $[3] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "header",
            testId: testId,
            xcss: $2747dc4177a5f32c$var$styles.header,
            children: t1
        });
        $[2] = t1;
        $[3] = testId;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : function PanelHeader({ children: children, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        as: "header",
        testId: testId,
        xcss: $2747dc4177a5f32c$var$styles.header,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
            xcss: $2747dc4177a5f32c$var$styles.headerContent,
            children: children
        })
    });
};
module.exports["PanelHeader"] = $2747dc4177a5f32c$export$968713404ca1c9aa;

});

parcelRegister("7Yky3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $V3JOP = parcelRequire("V3JOP");


var $Emr0i = parcelRequire("Emr0i");


var $6GBgL = parcelRequire("6GBgL");

const $3d98d316d4b42e83$export$d05dda6f1d91eaad = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { href: href, label: label, onClick: onClick, testId: testId, analyticsContext: analyticsContext } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage || $[1] !== label) {
        t1 = label || formatMessage((0, $Emr0i.default).previewPanelNewTabActionLabel);
        $[0] = formatMessage;
        $[1] = label;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== analyticsContext || $[4] !== href || $[5] !== onClick || $[6] !== t1 || $[7] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GBgL.PreviewPanelAction), {
            label: t1,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
            onClick: onClick,
            href: href,
            testId: testId,
            analyticsContext: analyticsContext
        });
        $[3] = analyticsContext;
        $[4] = href;
        $[5] = onClick;
        $[6] = t1;
        $[7] = testId;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ href: href, label: label, onClick: onClick, testId: testId, analyticsContext: analyticsContext })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GBgL.PreviewPanelAction), {
        label: label || formatMessage((0, $Emr0i.default).previewPanelNewTabActionLabel),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
        onClick: onClick,
        href: href,
        testId: testId,
        analyticsContext: analyticsContext
    });
};
module.exports["PreviewPanelNewTabLink"] = $3d98d316d4b42e83$export$d05dda6f1d91eaad;

});

parcelRegister("bRCqW", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $aMRlV = parcelRequire("aMRlV");

const $33c23c71035fcd90$export$92a58681483f4529 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { title: title, icon: icon, color: color } = t0;
    if ((0, $iDrrr.fg)("ads-panel-system-gpp")) {
        let t1;
        if ($[0] !== icon || $[1] !== title) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aMRlV.PanelTitle), {
                icon: icon
            }, title);
            $[0] = icon;
            $[1] = title;
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    let t1;
    if ($[3] !== color || $[4] !== title) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "bold",
            maxLines: 1,
            color: color
        }, title);
        $[3] = color;
        $[4] = title;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== icon || $[7] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, icon, t1);
        $[6] = icon;
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ title: title, icon: icon, color: color })=>{
    if ((0, $iDrrr.fg)('ads-panel-system-gpp')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aMRlV.PanelTitle), {
        icon: icon
    }, title);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        maxLines: 1,
        color: color
    }, title));
};
module.exports["PreviewPanelTitle"] = $33c23c71035fcd90$export$92a58681483f4529;

});

parcelRegister("aMRlV", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $I7hWB = parcelRequire("I7hWB");


var $iMnC5 = parcelRequire("iMnC5");

const $4105ecb3e4516dff$var$styles = {
    title: "_3iDTPbQ4SZ _0hPCNLDIqT _2O5Vij7dHp",
    titleText: "_0LQT5E1Y8M",
    icon: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV029DVM _0jFU0V9DVM"
}; /**
    * The PanelTitle component provides a standardized title display for panels
    * with optional icon support and consistent typography.
    */ 
const $4105ecb3e4516dff$export$86de09faaa70680d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelTitle(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { children: children, icon: icon, testId: testId } = t0;
    let t1;
    if ($[0] !== icon) {
        t1 = icon && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $4105ecb3e4516dff$var$styles.icon,
            children: icon
        });
        $[0] = icon;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $4105ecb3e4516dff$var$styles.titleText
        ]);
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: t2,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                size: "small",
                as: "h2",
                children: children
            })
        });
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== t1 || $[6] !== t3 || $[7] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            testId: testId,
            xcss: $4105ecb3e4516dff$var$styles.title,
            children: [
                t1,
                t3
            ]
        });
        $[5] = t1;
        $[6] = t3;
        $[7] = testId;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : function PanelTitle({ children: children, icon: icon, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        testId: testId,
        xcss: $4105ecb3e4516dff$var$styles.title,
        children: [
            icon && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $4105ecb3e4516dff$var$styles.icon,
                children: icon
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: (0, $hekY6.default)([
                    $4105ecb3e4516dff$var$styles.titleText
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                    size: "small",
                    as: "h2",
                    children: children
                })
            })
        ]
    });
};
module.exports["PanelTitle"] = $4105ecb3e4516dff$export$86de09faaa70680d;

});

parcelRegister("28WJb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $3Ap09 = parcelRequire("3Ap09");

const $065389573511adac$export$5351114e92b31bc6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (context?.state.panel == null) return null;
    let t0;
    if ($[0] !== context.setPanelWidth || $[1] !== context.state.panel || $[2] !== context.width) {
        t0 = {
            ...context.state.panel,
            width: context.width,
            setWidth: context.setPanelWidth
        };
        $[0] = context.setPanelWidth;
        $[1] = context.state.panel;
        $[2] = context.width;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : ()=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (context?.state.panel == null) return null;
    return {
        ...context.state.panel,
        width: context.width,
        setWidth: context.setPanelWidth
    };
};
module.exports["useCurrentPreviewPanel"] = $065389573511adac$export$5351114e92b31bc6;

});

parcelRegister("8OpiN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::48df6a4b08988964a6c19ca298fb7fa6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66a69eb8c574d02b$var$_react = $66a69eb8c574d02b$var$_interopRequireDefault((parcelRequire("cozmU")));

var $66a69eb8c574d02b$var$_iconNew = $66a69eb8c574d02b$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $66a69eb8c574d02b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsObject".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/assets-object
 * Usage guidance:
 * Reserved for representing objects in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66a69eb8c574d02b$var$AssetsObjectIcon = (props)=>/*#__PURE__*/ $66a69eb8c574d02b$var$_react.default.createElement($66a69eb8c574d02b$var$_iconNew.default, Object.assign({
        name: "AssetsObjectIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.5v3.75a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75V2.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM7 5.5h2v-3H7zm8 7.5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$66a69eb8c574d02b$var$AssetsObjectIcon.displayName = 'AssetsObjectIcon';
var $66a69eb8c574d02b$var$_default = module.exports.default = $66a69eb8c574d02b$var$AssetsObjectIcon;

});

parcelRegister("df5DJ", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $7avaU = parcelRequire("7avaU");

var $2yWyb = parcelRequire("2yWyb");

var $ljnYz = parcelRequire("ljnYz");


var $8Yift = parcelRequire("8Yift");

const $3d79566ecfd5a94d$var$SITE_RESOURCE_TYPE = 'site';
const $3d79566ecfd5a94d$var$siteIdOf = (siteIdOrAri)=>{
    try {
        const ari = (0, $7avaU.AnyAri).parse(siteIdOrAri);
        return ari.resourceType === $3d79566ecfd5a94d$var$SITE_RESOURCE_TYPE ? ari.resourceId : siteIdOrAri;
    } catch  {
        return siteIdOrAri;
    }
};
const $3d79566ecfd5a94d$var$createSiteAri = (siteAriType, siteId)=>{
    try {
        return siteAriType.create({
            siteId: siteId
        }).toString();
    } catch  {
        return '';
    }
};
const $3d79566ecfd5a94d$var$getAppSiteAri = (siteIdOrAri, siteAriType)=>{
    const siteId = $3d79566ecfd5a94d$var$siteIdOf(siteIdOrAri);
    if (!(0, $iDrrr.fg)('townsquare_goal_project_site_aris')) // Pre-migration behaviour: site ARIs are passed through untouched, bare site ids
    // are turned into the deprecated townsquare-owned site ARI.
    return siteId === siteIdOrAri ? $3d79566ecfd5a94d$var$createSiteAri((0, $8Yift.TownsquareSiteAri), siteId) : siteIdOrAri;
    return $3d79566ecfd5a94d$var$createSiteAri(siteAriType, siteId);
};
const $3d79566ecfd5a94d$export$20d6ddd0cf2f686b = (siteIdOrAri)=>$3d79566ecfd5a94d$var$getAppSiteAri(siteIdOrAri, (0, $2yWyb.GoalSiteAri));
const $3d79566ecfd5a94d$export$565bf3b5b10d78e9 = (siteIdOrAri)=>$3d79566ecfd5a94d$var$getAppSiteAri(siteIdOrAri, (0, $ljnYz.ProjectSiteAri));
module.exports["getGoalSiteAri"] = $3d79566ecfd5a94d$export$20d6ddd0cf2f686b;
module.exports["getProjectSiteAri"] = $3d79566ecfd5a94d$export$565bf3b5b10d78e9;

});

parcelRegister("2yWyb", function(module, exports) {

var $ei2P9 = parcelRequire("ei2P9");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/goal/site/manifest.ts
var $1ddc2ca6a2b3f032$var$goalSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $ei2P9.GoalSiteAriResourceOwner),
    resourceType: (0, $ei2P9.GoalSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/goal/site/index.ts
var $1ddc2ca6a2b3f032$export$25f6e07f2c803459 = class _GoalSiteAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $1ddc2ca6a2b3f032$var$goalSiteAriStaticOpts.qualifier,
            platformQualifier: $1ddc2ca6a2b3f032$var$goalSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $1ddc2ca6a2b3f032$var$goalSiteAriStaticOpts.resourceOwner,
            resourceType: $1ddc2ca6a2b3f032$var$goalSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $1ddc2ca6a2b3f032$var$goalSiteAriStaticOpts);
        return new _GoalSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $1ddc2ca6a2b3f032$var$goalSiteAriStaticOpts);
        return new _GoalSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["GoalSiteAri"] = $1ddc2ca6a2b3f032$export$25f6e07f2c803459;

});

parcelRegister("ei2P9", function(module, exports) {
// src/goal/site/types.ts
var $a674efe79f341c4b$export$856c52490bfaa1d5 = "goal", $a674efe79f341c4b$export$21b302361b3c545e = "site";
module.exports["GoalSiteAriResourceOwner"] = $a674efe79f341c4b$export$856c52490bfaa1d5;
module.exports["GoalSiteAriResourceType"] = $a674efe79f341c4b$export$21b302361b3c545e;

});

parcelRegister("ljnYz", function(module, exports) {

var $5isyS = parcelRequire("5isyS");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/project/site/manifest.ts
var $f83df876348716aa$var$projectSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $5isyS.ProjectSiteAriResourceOwner),
    resourceType: (0, $5isyS.ProjectSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/project/site/index.ts
var $f83df876348716aa$export$ac5d12d294f83be4 = class _ProjectSiteAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f83df876348716aa$var$projectSiteAriStaticOpts.qualifier,
            platformQualifier: $f83df876348716aa$var$projectSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $f83df876348716aa$var$projectSiteAriStaticOpts.resourceOwner,
            resourceType: $f83df876348716aa$var$projectSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $f83df876348716aa$var$projectSiteAriStaticOpts);
        return new _ProjectSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $f83df876348716aa$var$projectSiteAriStaticOpts);
        return new _ProjectSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["ProjectSiteAri"] = $f83df876348716aa$export$ac5d12d294f83be4;

});

parcelRegister("5isyS", function(module, exports) {
// src/project/site/types.ts
var $3db4c9e7774a7202$export$9eea0d5b157c61be = "project", $3db4c9e7774a7202$export$cbe80ac90c61c70d = "site";
module.exports["ProjectSiteAriResourceOwner"] = $3db4c9e7774a7202$export$9eea0d5b157c61be;
module.exports["ProjectSiteAriResourceType"] = $3db4c9e7774a7202$export$cbe80ac90c61c70d;

});

parcelRegister("8Yift", function(module, exports) {

var $4Yksf = parcelRequire("4Yksf");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/townsquare/site/manifest.ts
var $6882151697c9008c$var$townsquareSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $4Yksf.TownsquareSiteAriResourceOwner),
    resourceType: (0, $4Yksf.TownsquareSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/townsquare/site/index.ts
var $6882151697c9008c$export$87ae3de5f1f7725a = class _TownsquareSiteAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $6882151697c9008c$var$townsquareSiteAriStaticOpts.qualifier,
            platformQualifier: $6882151697c9008c$var$townsquareSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $6882151697c9008c$var$townsquareSiteAriStaticOpts.resourceOwner,
            resourceType: $6882151697c9008c$var$townsquareSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $6882151697c9008c$var$townsquareSiteAriStaticOpts);
        return new _TownsquareSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $6882151697c9008c$var$townsquareSiteAriStaticOpts);
        return new _TownsquareSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["TownsquareSiteAri"] = $6882151697c9008c$export$87ae3de5f1f7725a;

});

parcelRegister("4Yksf", function(module, exports) {
// src/townsquare/site/types.ts
var $39eca1dd131685dd$export$9ee8c46ef1f3e6a8 = "townsquare", $39eca1dd131685dd$export$44737bde24f3bac1 = "site";
module.exports["TownsquareSiteAriResourceOwner"] = $39eca1dd131685dd$export$9ee8c46ef1f3e6a8;
module.exports["TownsquareSiteAriResourceType"] = $39eca1dd131685dd$export$44737bde24f3bac1;

});

parcelRegister("4slsU", function(module, exports) {

var $1RQo0 = parcelRequire("1RQo0");

var $aLUFu = parcelRequire("aLUFu");

var $8Yift = parcelRequire("8Yift");

function $4caae11b2ff1f088$export$3ae2d1e732b25194(entity, ari) {
    try {
        if (entity === 'goal') return (0, $1RQo0.TownsquareGoalAri).parse(ari).siteId;
        if (entity === 'project') return (0, $aLUFu.TownsquareProjectAri).parse(ari).siteId;
        if (entity === 'site') return (0, $8Yift.TownsquareSiteAri).parse(ari).siteId;
    } catch (error) {
        //TODO: send error metrics/monitoring https://product-fabric.atlassian.net/browse/TC-13492
        //We try to extract the siteId manually: ari:cloud:townsquare:${siteId}:{entity}/{uuid}
        if (entity === 'goal' || entity === 'project') return ari.split(':')[3] ?? '';
    }
    return '';
}
module.exports["getSiteId"] = $4caae11b2ff1f088$export$3ae2d1e732b25194;

});

parcelRegister("fvoKJ", function(module, exports) {

var $8Yift = parcelRequire("8Yift");

const $e160175aa6804997$export$792aeacb7990bc6 = (containerId)=>{
    // we wrap in a try/catch incase there are any issues with creating the site ari
    try {
        return (0, $8Yift.TownsquareSiteAri).create({
            siteId: containerId
        }).toString();
    } catch  {
        return '';
    }
};
module.exports["getSiteAri"] = $e160175aa6804997$export$792aeacb7990bc6;

});

parcelRegister("g93kp", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc101184c63d7a7a$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $bc101184c63d7a7a$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $3yGK6.default)(2, arguments);
    return (0, $dkBOe.default)(dateLeft).getTime() - (0, $dkBOe.default)(dateRight).getTime();
}

});

parcelRegister("byLBW", function(module, exports) {
var $86a7cd36e9b99950$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $86a7cd36e9b99950$var$defaultRoundingMethod = 'trunc';
function $86a7cd36e9b99950$export$b6474a47258c1211(method) {
    return method ? $86a7cd36e9b99950$var$roundingMap[method] : $86a7cd36e9b99950$var$roundingMap[$86a7cd36e9b99950$var$defaultRoundingMethod];
}
module.exports["getRoundingMethod"] = $86a7cd36e9b99950$export$b6474a47258c1211;

});

parcelRegister("gQEZd", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4414baec8e12e18$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $7D31j = parcelRequire("7D31j");


var $3yGK6 = parcelRequire("3yGK6");

function $c4414baec8e12e18$export$2e2bcd8739ae039(date, options) {
    var _options$format, _options$representati;
    (0, $3yGK6.default)(1, arguments);
    var originalDate = (0, $dkBOe.default)(date);
    if (isNaN(originalDate.getTime())) throw new RangeError('Invalid time value');
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
    if (format !== 'extended' && format !== 'basic') throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== 'date' && representation !== 'time' && representation !== 'complete') throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = '';
    var tzOffset = '';
    var dateDelimiter = format === 'extended' ? '-' : '';
    var timeDelimiter = format === 'extended' ? ':' : '';
    // Representation is either 'date' or 'complete'
    if (representation !== 'time') {
        var day = (0, $7D31j.default)(originalDate.getDate(), 2);
        var month = (0, $7D31j.default)(originalDate.getMonth() + 1, 2);
        var year = (0, $7D31j.default)(originalDate.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== 'date') {
        // Add the timezone.
        var offset = originalDate.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, $7D31j.default)(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = (0, $7D31j.default)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? '+' : '-';
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = 'Z';
        var hour = (0, $7D31j.default)(originalDate.getHours(), 2);
        var minute = (0, $7D31j.default)(originalDate.getMinutes(), 2);
        var second = (0, $7D31j.default)(originalDate.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        var separator = result === '' ? '' : 'T';
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}

});

parcelRegister("5pkPF", function(module, exports) {

var $1eVGO = parcelRequire("1eVGO");


var $cgTkH = parcelRequire("cgTkH");



var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $amotT = parcelRequire("amotT");



var $hA0li = parcelRequire("hA0li");


var $eoR7w = parcelRequire("eoR7w");

var $3eff726f85d07655$export$bb38bb9a1161268 = 'unmounted';
var $3eff726f85d07655$export$84cbff306f539230 = 'exited';
var $3eff726f85d07655$export$df38205c966be359 = 'entering';
var $3eff726f85d07655$export$78e9e6e3e014d60a = 'entered';
var $3eff726f85d07655$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $3eff726f85d07655$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $cgTkH.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $3eff726f85d07655$export$84cbff306f539230;
                _this.appearStatus = $3eff726f85d07655$export$df38205c966be359;
            } else initialStatus = $3eff726f85d07655$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $3eff726f85d07655$export$bb38bb9a1161268;
        else initialStatus = $3eff726f85d07655$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $3eff726f85d07655$export$bb38bb9a1161268) return {
            status: $3eff726f85d07655$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $3eff726f85d07655$export$df38205c966be359 && status !== $3eff726f85d07655$export$78e9e6e3e014d60a) nextStatus = $3eff726f85d07655$export$df38205c966be359;
            } else if (status === $3eff726f85d07655$export$df38205c966be359 || status === $3eff726f85d07655$export$78e9e6e3e014d60a) nextStatus = $3eff726f85d07655$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $3eff726f85d07655$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $eoR7w.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $3eff726f85d07655$export$84cbff306f539230) this.setState({
            status: $3eff726f85d07655$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $amotT.default).disabled) {
            this.safeSetState({
                status: $3eff726f85d07655$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $3eff726f85d07655$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $3eff726f85d07655$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $amotT.default).disabled) {
            this.safeSetState({
                status: $3eff726f85d07655$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $3eff726f85d07655$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $3eff726f85d07655$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $3eff726f85d07655$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $1eVGO.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hA0li.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component);
$3eff726f85d07655$var$Transition.contextType = (0, $hA0li.default);
$3eff726f85d07655$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $3eff726f85d07655$var$noop() {}
$3eff726f85d07655$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $3eff726f85d07655$var$noop,
    onEntering: $3eff726f85d07655$var$noop,
    onEntered: $3eff726f85d07655$var$noop,
    onExit: $3eff726f85d07655$var$noop,
    onExiting: $3eff726f85d07655$var$noop,
    onExited: $3eff726f85d07655$var$noop
};
$3eff726f85d07655$var$Transition.UNMOUNTED = $3eff726f85d07655$export$bb38bb9a1161268;
$3eff726f85d07655$var$Transition.EXITED = $3eff726f85d07655$export$84cbff306f539230;
$3eff726f85d07655$var$Transition.ENTERING = $3eff726f85d07655$export$df38205c966be359;
$3eff726f85d07655$var$Transition.ENTERED = $3eff726f85d07655$export$78e9e6e3e014d60a;
$3eff726f85d07655$var$Transition.EXITING = $3eff726f85d07655$export$4aacc83d4d59139f;
var $3eff726f85d07655$export$2e2bcd8739ae039 = $3eff726f85d07655$var$Transition;
module.exports["default"] = $3eff726f85d07655$export$2e2bcd8739ae039;

});

parcelRegister("amotT", function(module, exports) {
$parcel$export(module.exports, "default", () => $78aef2ed8b5cba44$export$2e2bcd8739ae039);
var $78aef2ed8b5cba44$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("hA0li", function(module, exports) {
$parcel$export(module.exports, "default", () => $ccc6107deb85fdd7$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

var $ccc6107deb85fdd7$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(null);

});

parcelRegister("eoR7w", function(module, exports) {
var $a7bc833148928009$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};
module.exports["forceReflow"] = $a7bc833148928009$export$7d26bbb1236dafd6;

});

parcelRegister("eO7Q2", function(module, exports) {
/**
 * URL to the Atlassian support documentation for synced blocks in Confluence Cloud.
 */ const $9b8564145c0d1038$export$81b3a92cdfa3191b = 'https://support.atlassian.com/confluence-cloud/docs/reuse-content-with-synced-blocks';
module.exports["SYNCED_BLOCKS_DOCUMENTATION_URL"] = $9b8564145c0d1038$export$81b3a92cdfa3191b;

});

parcelRegister("fuSOM", function(module, exports) {
parcelRequire("eRn3r");
var $9aUDG = parcelRequire("9aUDG");


var $lA6N5 = parcelRequire("lA6N5");


const $cb5189150b488f78$var$LazyLinkPickerComponent = (0, $9aUDG.lazyForPaint)(()=>(parcelRequire("2i9TA")).then(({ LinkPicker: LinkPicker })=>({
            default: LinkPicker
        })));
// Must be a default export to be able to support prop docs
// eslint-disable-next-line import/no-default-export
const $cb5189150b488f78$var$_default_1 = (0, $lA6N5.composeLinkPicker)($cb5189150b488f78$var$LazyLinkPickerComponent);
var $cb5189150b488f78$export$2e2bcd8739ae039 = $cb5189150b488f78$var$_default_1;
module.exports["default"] = $cb5189150b488f78$export$2e2bcd8739ae039;

});

parcelRegister("lA6N5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

parcelRequire("eRn3r");
var $3QYdZ = parcelRequire("3QYdZ");


var $gBjHb = parcelRequire("gBjHb");


var $kJo8F = parcelRequire("kJo8F");


var $eg7eG = parcelRequire("eg7eG");


var $fCO8c = parcelRequire("fCO8c");


var $k5YvC = parcelRequire("k5YvC");


var $lg1Gp = parcelRequire("lg1Gp");

const $12f35d08bde2472f$export$800daf5fbbe96aff = {
    linkPickerRoot: 'link-picker-root'
};
const $12f35d08bde2472f$export$a2495bb1f182689d = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: (0, $kJo8F.COMPONENT_NAME),
    source: (0, $kJo8F.COMPONENT_NAME)
};
const $12f35d08bde2472f$var$DefaultRootComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": $12f35d08bde2472f$export$800daf5fbbe96aff.linkPickerRoot
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": $12f35d08bde2472f$export$800daf5fbbe96aff.linkPickerRoot
    }, children);
};
const $12f35d08bde2472f$var$fixedWidthContainerStyles = null;
const $12f35d08bde2472f$var$FixedWidthContainer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_39xV02oEu0"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            role: "dialog",
            "aria-modal": "false",
            "aria-label": "link-picker",
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "dialog",
        "aria-modal": "false",
        "aria-label": "link-picker",
        ...props,
        className: (0, $hekY6.default)([
            "_39xV02oEu0"
        ])
    });
};
const $12f35d08bde2472f$export$922eb685ceb4a294 = (Component)=>{
    return /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
        const { component: component } = props;
        const RootComponent = component ?? $12f35d08bde2472f$var$DefaultRootComponent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
            data: $12f35d08bde2472f$export$a2495bb1f182689d
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eg7eG.LinkPickerSessionProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lg1Gp.MessagesProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                ['--link-picker-width']: props.disableWidth ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                `${0, $kJo8F.LINK_PICKER_WIDTH_IN_PX}px`,
                ['--link-picker-padding-left']: props.paddingLeft ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-right']: props.paddingRight ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-top']: props.paddingTop ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-bottom']: props.paddingBottom ?? "var(--ds-space-200, 16px)"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($12f35d08bde2472f$var$FixedWidthContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fCO8c.ErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3QYdZ.LazySuspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k5YvC.LoaderFallback), {
                url: props.url,
                hideDisplayText: props.hideDisplayText,
                isLoadingPlugins: props.isLoadingPlugins,
                plugins: props.plugins
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RootComponent, {
            ...props,
            "data-testid": $12f35d08bde2472f$export$800daf5fbbe96aff.linkPickerRoot
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props)))))))));
    });
};
module.exports["composeLinkPicker"] = $12f35d08bde2472f$export$922eb685ceb4a294;

});

parcelRegister("kJo8F", function(module, exports) {
const $001c95c8c9eb30f1$export$85183a312807388d = 'media';
const $001c95c8c9eb30f1$export$fc44104665f4d1e5 = 'linkPicker';
const $001c95c8c9eb30f1$export$452f1062ecf44be7 = 5;
const $001c95c8c9eb30f1$export$bf31a09f182d5584 = 342;
const $001c95c8c9eb30f1$export$542fb16962bf430c = '290px';
module.exports["ANALYTICS_CHANNEL"] = $001c95c8c9eb30f1$export$85183a312807388d;
module.exports["COMPONENT_NAME"] = $001c95c8c9eb30f1$export$fc44104665f4d1e5;
module.exports["RECENT_SEARCH_LIST_SIZE"] = $001c95c8c9eb30f1$export$452f1062ecf44be7;
module.exports["LINK_PICKER_WIDTH_IN_PX"] = $001c95c8c9eb30f1$export$bf31a09f182d5584;
module.exports["LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK"] = $001c95c8c9eb30f1$export$542fb16962bf430c;

});

parcelRegister("eg7eG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $03RpJ = parcelRequire("03RpJ");


var $gt5Em = parcelRequire("gt5Em");

const $c7635a085ba363f5$export$c07727f5eddb98f = 'SESSION_UNINITIALIZED';
const $c7635a085ba363f5$export$3285420c698bc605 = /*#__PURE__*/ (0, $cozmU.createContext)($c7635a085ba363f5$export$c07727f5eddb98f);
const $c7635a085ba363f5$export$2f19832fd2d620ca = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const { current: sessionId } = (0, $cozmU.useRef)((0, $03RpJ.default)());
    (0, $cozmU.useEffect)(()=>{
        (0, $gt5Em.startUfoExperience)((0, $gt5Em.ufoExperience).mounted, sessionId);
        return ()=>(0, $gt5Em.abortUfoExperience)((0, $gt5Em.ufoExperience).mounted, sessionId);
    }, [
        sessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c7635a085ba363f5$export$3285420c698bc605.Provider, {
        value: sessionId
    }, children);
};
const $c7635a085ba363f5$export$36ecc935abdc3636 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($c7635a085ba363f5$export$3285420c698bc605);
} : ()=>(0, $cozmU.useContext)($c7635a085ba363f5$export$3285420c698bc605);
module.exports["LinkPickerSessionProvider"] = $c7635a085ba363f5$export$2f19832fd2d620ca;
module.exports["useLinkPickerSessionId"] = $c7635a085ba363f5$export$36ecc935abdc3636;

});

parcelRegister("gt5Em", function(module, exports) {

var $fh15z = parcelRequire("fh15z");


var $4MiWC = parcelRequire("4MiWC");

const $64cb77453c568c86$export$f9c7780c574346a2 = {
    mounted: 'component-mounted'
};
const $64cb77453c568c86$var$ufoExperiences = {
    [$64cb77453c568c86$export$f9c7780c574346a2.mounted]: new (0, $fh15z.ConcurrentExperience)($64cb77453c568c86$export$f9c7780c574346a2.mounted, {
        type: (0, $4MiWC.ExperienceTypes).Load,
        performanceType: (0, $4MiWC.ExperiencePerformanceTypes).PageSegmentLoad,
        platform: {
            component: 'link-picker'
        }
    })
};
const $64cb77453c568c86$export$5e9287b6a10f8075 = (experienceName, id, metadata)=>{
    const experience = $64cb77453c568c86$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (metadata) experience.addMetadata(metadata);
};
const $64cb77453c568c86$export$c5a5cf072c836c0e = (experienceName, id, metadata)=>{
    const experience = $64cb77453c568c86$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: metadata
    });
};
const $64cb77453c568c86$export$8dda83bafca11b77 = (experienceName, id, metadata)=>{
    const experience = $64cb77453c568c86$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: metadata
    });
};
const $64cb77453c568c86$export$b1021040eb94cdca = (experienceName, id, metadata)=>{
    const experience = $64cb77453c568c86$var$ufoExperiences[experienceName].getInstance(id);
    experience.abort({
        metadata: metadata
    });
};
module.exports["ufoExperience"] = $64cb77453c568c86$export$f9c7780c574346a2;
module.exports["startUfoExperience"] = $64cb77453c568c86$export$5e9287b6a10f8075;
module.exports["succeedUfoExperience"] = $64cb77453c568c86$export$c5a5cf072c836c0e;
module.exports["failUfoExperience"] = $64cb77453c568c86$export$8dda83bafca11b77;
module.exports["abortUfoExperience"] = $64cb77453c568c86$export$b1021040eb94cdca;

});

parcelRegister("fCO8c", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $gt5Em = parcelRequire("gt5Em");


var $kJo8F = parcelRequire("kJo8F");


var $779pE = parcelRequire("779pE");


var $eg7eG = parcelRequire("eg7eG");


var $aRBFH = parcelRequire("aRBFH");


var $f3GZb = parcelRequire("f3GZb");

const $96adf85769963d68$export$e926676385687eaf = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ErrorBoundary(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { children: children } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $eg7eG.useLinkPickerSessionId)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== linkPickerSessionId) {
        t1 = (error, info)=>{
            createAnalyticsEvent((0, $779pE.default)("ui.linkPicker.unhandledErrorCaught", {
                browserInfo: window?.navigator?.userAgent || "unknown",
                error: error.toString(),
                componentStack: info?.componentStack ?? ""
            })).fire((0, $kJo8F.ANALYTICS_CHANNEL));
            (0, $gt5Em.failUfoExperience)((0, $gt5Em.ufoExperience).mounted, linkPickerSessionId);
        };
        $[0] = createAnalyticsEvent;
        $[1] = linkPickerSessionId;
        $[2] = t1;
    } else t1 = $[2];
    const handleError = t1;
    let t2;
    if ($[3] !== children || $[4] !== handleError) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRBFH.BaseErrorBoundary), {
            onError: handleError,
            ErrorComponent: (0, $f3GZb.ErrorBoundaryFallback)
        }, children);
        $[3] = children;
        $[4] = handleError;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : function ErrorBoundary({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $eg7eG.useLinkPickerSessionId)();
    const handleError = (0, $cozmU.useCallback)((error, info)=>{
        // Fire Analytics event
        createAnalyticsEvent((0, $779pE.default)('ui.linkPicker.unhandledErrorCaught', {
            browserInfo: window?.navigator?.userAgent || 'unknown',
            error: error.toString(),
            componentStack: info?.componentStack ?? ''
        })).fire((0, $kJo8F.ANALYTICS_CHANNEL));
        // Fire UFO failed experience
        (0, $gt5Em.failUfoExperience)((0, $gt5Em.ufoExperience).mounted, linkPickerSessionId);
    }, [
        createAnalyticsEvent,
        linkPickerSessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRBFH.BaseErrorBoundary), {
        onError: handleError,
        ErrorComponent: (0, $f3GZb.ErrorBoundaryFallback)
    }, children);
};
module.exports["ErrorBoundary"] = $96adf85769963d68$export$e926676385687eaf;

});

parcelRegister("779pE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::590b9da528f0d0b88cea1feaa1815283>>
 * @codegenCommand yarn workspace @atlaskit/link-picker run codegen-analytics
 */ function $eafc2c5357085519$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $eafc2c5357085519$export$2e2bcd8739ae039 = $eafc2c5357085519$var$createEventPayload;
module.exports["default"] = $eafc2c5357085519$export$2e2bcd8739ae039;

});

parcelRegister("aRBFH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

class $baa71a56a1d588bd$export$688779ac61ee945f extends (0, $cozmU.Component) {
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && ErrorComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ErrorComponent, null);
        return children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
module.exports["BaseErrorBoundary"] = $baa71a56a1d588bd$export$688779ac61ee945f;

});

parcelRegister("f3GZb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $kJo8F = parcelRequire("kJo8F");


var $bXDzR = parcelRequire("bXDzR");


var $k3ncb = parcelRequire("k3ncb");


var $dOXsL = parcelRequire("dOXsL");

const $66e5302c045c6e9e$var$errorBoundaryFallbackStyles = null;
const $66e5302c045c6e9e$var$messages = (0, $kSwu1.defineMessages)({
    heading: {
        defaultMessage: "Something went wrong!",
        id: "fabric.linkPicker.unhandledError.heading"
    },
    description: {
        defaultMessage: "Try reloading the page.",
        id: "fabric.linkPicker.unhandledError.description"
    }
});
const $66e5302c045c6e9e$export$8a28b7e38e4685dd = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(8);
    const intl = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage($66e5302c045c6e9e$var$messages.heading);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    const header = t0;
    let t1;
    if ($[2] !== intl) {
        t1 = intl.formatMessage($66e5302c045c6e9e$var$messages.description);
        $[2] = intl;
        $[3] = t1;
    } else t1 = $[3];
    const description = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_2sNsIgd8bj"
        ]);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== description || $[6] !== header) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
            minHeight: (0, $kJo8F.LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK),
            "data-testid": "link-picker-root-error-boundary-ui",
            className: t2
        }, /*#__PURE__*/ $cozmU.createElement((0, $k3ncb.EmptyState), {
            header: header,
            renderImage: $66e5302c045c6e9e$var$_temp,
            description: description
        }));
        $[5] = description;
        $[6] = header;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ()=>{
    const intl = (0, $kSwu1.useIntl)();
    const header = intl.formatMessage($66e5302c045c6e9e$var$messages.heading);
    const description = intl.formatMessage($66e5302c045c6e9e$var$messages.description);
    return /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
        minHeight: (0, $kJo8F.LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK),
        "data-testid": "link-picker-root-error-boundary-ui",
        className: (0, $hekY6.default)([
            "_2sNsIgd8bj"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $k3ncb.EmptyState), {
        header: header,
        renderImage: ()=>/*#__PURE__*/ $cozmU.createElement((0, $bXDzR.GenericErrorSVG), null),
        description: description
    }));
};
function $66e5302c045c6e9e$var$_temp() {
    return /*#__PURE__*/ $cozmU.createElement((0, $bXDzR.GenericErrorSVG), null);
}
module.exports["ErrorBoundaryFallback"] = $66e5302c045c6e9e$export$8a28b7e38e4685dd;

});

parcelRegister("bXDzR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $efcb4a3aca6e9417$var$SIZE = 96;
const $efcb4a3aca6e9417$var$genericErrorStyles = null;
const $efcb4a3aca6e9417$export$e54420a1a27457a4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(10);
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_39xV02JgOI _0jFU0VJgOI _3iDTPbvLZJ"
        ]);
        t1 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#fff",
            d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
        });
        t2 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
        });
        t3 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
        });
        t4 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
        });
        t5 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#B7B9BE",
            d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
        });
        t6 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            fillRule: "evenodd",
            d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
            clipRule: "evenodd"
        });
        t7 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            fillRule: "evenodd",
            d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
            clipRule: "evenodd"
        });
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
        $[7] = t7;
    } else {
        t0 = $[0];
        t1 = $[1];
        t2 = $[2];
        t3 = $[3];
        t4 = $[4];
        t5 = $[5];
        t6 = $[6];
        t7 = $[7];
    }
    let t8;
    if ($[8] !== props) {
        t8 = /*#__PURE__*/ $cozmU.createElement("svg", {
            viewBox: "0 0 96 96",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            className: t0
        }, t1, t2, t3, t4, t5, t6, t7);
        $[8] = props;
        $[9] = t8;
    } else t8 = $[9];
    return t8;
} : (props)=>{
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        className: (0, $hekY6.default)([
            "_39xV02JgOI _0jFU0VJgOI _3iDTPbvLZJ"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#fff",
        d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#B7B9BE",
        d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        fillRule: "evenodd",
        d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        fillRule: "evenodd",
        d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
        clipRule: "evenodd"
    }));
};
module.exports["GenericErrorSVG"] = $efcb4a3aca6e9417$export$e54420a1a27457a4;

});

parcelRegister("k3ncb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $I7hWB = parcelRequire("I7hWB");


var $iDrrr = parcelRequire("iDrrr");


var $4ez2K = parcelRequire("4ez2K");

var $4aRua = parcelRequire("4aRua");

const $abc7c062eda24665$var$styles = {
    containerV2: "_0Of8r2NHnM _1Znuxbp0Oa _2Zuz6Qp0Oa _1wydGWS40j _2fwxA5DIqT",
    whiteSpaceNormal: "_1ANEUSzUZr"
};
const $abc7c062eda24665$export$fddf379e22a74b00 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { testId: testId, header: header, description: description, action: action, renderImage: renderImage } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $w6R6I.cx)($abc7c062eda24665$var$styles.containerV2, (0, $iDrrr.fg)("platform_link_picker_fix_error_state_text_overflow") && $abc7c062eda24665$var$styles.whiteSpaceNormal);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== renderImage) {
        t2 = renderImage?.();
        $[1] = renderImage;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== header) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "small",
            as: "h2"
        }, header);
        $[3] = header;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== description) {
        t4 = description && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            as: "p",
            color: "color.text"
        }, description);
        $[5] = description;
        $[6] = t4;
    } else t4 = $[6];
    const t5 = action && action;
    let t6;
    if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== t5 || $[11] !== testId) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            xcss: t1,
            testId: testId,
            direction: "column",
            alignItems: "center",
            gap: "space.200"
        }, t2, t3, t4, t5);
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
        $[11] = testId;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ testId: testId, header: header, description: description, action: action, renderImage: renderImage })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        xcss: (0, $w6R6I.cx)($abc7c062eda24665$var$styles.containerV2, (0, $iDrrr.fg)('platform_link_picker_fix_error_state_text_overflow') && $abc7c062eda24665$var$styles.whiteSpaceNormal),
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.200"
    }, renderImage?.(), /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "small",
        as: "h2"
    }, header), description && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        as: "p",
        color: "color.text"
    }, description), action && action);
};
module.exports["EmptyState"] = $abc7c062eda24665$export$fddf379e22a74b00;

});

parcelRegister("dOXsL", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $1bc658963d2888d5$var$minHeightComponentStyles = null;
const $1bc658963d2888d5$export$42134e2a251518b3 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ className: className, minHeight: minHeight, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLFlnN _37wbyuDIqT _4kiQYAjtAN",
            className
        ]),
        ...props,
        style: {
            ['--link-picker-min-height']: minHeight
        }
    });
});
module.exports["MinHeightContainer"] = $1bc658963d2888d5$export$42134e2a251518b3;

});

parcelRegister("k5YvC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lfoFx = parcelRequire("lfoFx");


var $dOXsL = parcelRequire("dOXsL");

const $9e6da8c9bb613998$var$styles = null;
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT = '495px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT = '590px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT = '545px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT = '450px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT = '252px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT = '155px';
const $9e6da8c9bb613998$var$getEstimatedMinHeight = ({ hideDisplayText: hideDisplayText, isLoadingPlugins: isLoadingPlugins, plugins: plugins, url: url })=>{
    /**
   * "Insert mode" (search results shown initially)
   */ if (!url) {
        /**
     * With tabs
     */ if (plugins && plugins.length > 1 || isLoadingPlugins) return hideDisplayText ? $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT : $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT;
         /**
       * Without tabs
       */ 
        if (plugins?.length === 1) return hideDisplayText ? $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT : $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT;
    }
    return hideDisplayText ? $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT : $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT;
};
const $9e6da8c9bb613998$export$d96e921133238c41 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(8);
    let t0;
    if ($[0] !== props) {
        t0 = $9e6da8c9bb613998$var$getEstimatedMinHeight(props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    const minHeight = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_0hPCNLDIqT"
        ]);
        $[2] = t1;
    } else t1 = $[2];
    const t2 = props.name || "link-picker-loading";
    let t3;
    if ($[3] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            testId: "link-picker.component-loading-indicator",
            interactionName: t2,
            size: "medium"
        });
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== minHeight || $[6] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
            minHeight: minHeight,
            "data-testid": "link-picker-root-loader-boundary-ui",
            className: t1
        }, t3);
        $[5] = minHeight;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : (props)=>{
    const minHeight = $9e6da8c9bb613998$var$getEstimatedMinHeight(props);
    return /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
        minHeight: minHeight,
        "data-testid": "link-picker-root-loader-boundary-ui",
        className: (0, $hekY6.default)([
            "_0hPCNLDIqT"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        testId: "link-picker.component-loading-indicator",
        interactionName: props.name || 'link-picker-loading',
        size: "medium"
    }));
};
module.exports["LoaderFallback"] = $9e6da8c9bb613998$export$d96e921133238c41;

});

parcelRegister("lg1Gp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $Vh5j9 = parcelRequire("Vh5j9");

const $f169ae6f19f5b49d$export$54320b51a950d54a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Vh5j9.LazyMessagesProvider), null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Vh5j9.LazyMessagesProvider), null, children);
};
module.exports["MessagesProvider"] = $f169ae6f19f5b49d$export$54320b51a950d54a;

});

parcelRegister("Vh5j9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $64VTj = parcelRequire("64VTj");


var $935R1 = parcelRequire("935R1");


var $2H5my = parcelRequire("2H5my");

const $550b5e1058020e28$export$d013d33430f9fb4b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $64VTj.default), {
            defaultMessages: (0, $935R1.default),
            loaderFn: (0, $2H5my.fetchMessagesForLocale)
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $64VTj.default), {
        defaultMessages: (0, $935R1.default),
        loaderFn: (0, $2H5my.fetchMessagesForLocale)
    }, children);
};
module.exports["LazyMessagesProvider"] = $550b5e1058020e28$export$d013d33430f9fb4b;

});

parcelRegister("2H5my", function(module, exports) {

var $b3upr = parcelRequire("b3upr");

const $d0c1d8c70ea117ba$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const localeKey = locale.replace('-', '_');
        if (localeKey in (0, $b3upr.locales)) {
            const messages = await (0, $b3upr.locales)[localeKey]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $b3upr.locales)) {
            const messages = await (0, $b3upr.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
};
module.exports["fetchMessagesForLocale"] = $d0c1d8c70ea117ba$export$2b153a2030b0feb2;

});

parcelRegister("b3upr", function(module, exports) {

























const $f5a6a4ca12953b28$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("8xpUG")),
    da: ()=>(parcelRequire("ZDEny")),
    de: ()=>(parcelRequire("dhENg")),
    en_GB: ()=>(parcelRequire("10Huk")),
    en_ZZ: ()=>(parcelRequire("b8fyv")),
    en: ()=>Promise.resolve((parcelRequire("935R1"))),
    es: ()=>(parcelRequire("kviqL")),
    fi: ()=>(parcelRequire("kEGGx")),
    fr: ()=>(parcelRequire("3I7Hw")),
    hu: ()=>(parcelRequire("8VE62")),
    it: ()=>(parcelRequire("l8IkB")),
    ja: ()=>(parcelRequire("1kFuU")),
    ko: ()=>(parcelRequire("luWhw")),
    nb: ()=>(parcelRequire("fMQtL")),
    nl: ()=>(parcelRequire("7GM7G")),
    pl: ()=>(parcelRequire("1LETb")),
    pt_BR: ()=>(parcelRequire("4th1C")),
    ru: ()=>(parcelRequire("unThT")),
    sv: ()=>(parcelRequire("hXIzt")),
    th: ()=>(parcelRequire("5e2PY")),
    tr: ()=>(parcelRequire("11CPA")),
    uk: ()=>(parcelRequire("hRtvo")),
    vi: ()=>(parcelRequire("9PM3y")),
    zh_TW: ()=>(parcelRequire("cB9tL")),
    zh: ()=>(parcelRequire("kA90v"))
};
module.exports["locales"] = $f5a6a4ca12953b28$export$df1c34db1371eeed;

});

parcelRegister("8xpUG", function(module, exports) {

let $637581a007704468$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $637581a007704468$var$load("1JYrd"),
    $637581a007704468$var$load("cip6w"),
    $637581a007704468$var$load("gAG2n"),
    $637581a007704468$var$load("hFpP9"),
    $637581a007704468$var$load("3feYV"),
    $637581a007704468$var$load("cwjU2"),
    $637581a007704468$var$load("3Ff1R"),
    $637581a007704468$var$load("423Ga")
]).then(()=>parcelRequire('ksVtB'));

});

parcelRegister("ZDEny", function(module, exports) {

let $0b9474569ed7489d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0b9474569ed7489d$var$load("30242"),
    $0b9474569ed7489d$var$load("3qBwQ"),
    $0b9474569ed7489d$var$load("cYGDU"),
    $0b9474569ed7489d$var$load("ddSTH"),
    $0b9474569ed7489d$var$load("7Q1SM"),
    $0b9474569ed7489d$var$load("33Iaa"),
    $0b9474569ed7489d$var$load("blA7x"),
    $0b9474569ed7489d$var$load("gJroP")
]).then(()=>parcelRequire('1VdaT'));

});

parcelRegister("dhENg", function(module, exports) {

let $9abc819fdf737828$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9abc819fdf737828$var$load("15aAJ"),
    $9abc819fdf737828$var$load("8rREG"),
    $9abc819fdf737828$var$load("dgXJL"),
    $9abc819fdf737828$var$load("9d8JZ"),
    $9abc819fdf737828$var$load("7JdzX"),
    $9abc819fdf737828$var$load("6681T"),
    $9abc819fdf737828$var$load("3dn3H"),
    $9abc819fdf737828$var$load("cYXvt")
]).then(()=>parcelRequire('h2ceo'));

});

parcelRegister("10Huk", function(module, exports) {

let $0bc7865c2a7d50be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0bc7865c2a7d50be$var$load("l5BBd"),
    $0bc7865c2a7d50be$var$load("93ASN"),
    $0bc7865c2a7d50be$var$load("htu5t"),
    $0bc7865c2a7d50be$var$load("1A450"),
    $0bc7865c2a7d50be$var$load("24LNf"),
    $0bc7865c2a7d50be$var$load("iYQCc"),
    $0bc7865c2a7d50be$var$load("nBJth")
]).then(()=>parcelRequire('6VGGT'));

});

parcelRegister("b8fyv", function(module, exports) {

let $81ac821635a16fcc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $81ac821635a16fcc$var$load("bbv9t"),
    $81ac821635a16fcc$var$load("9fQoJ"),
    $81ac821635a16fcc$var$load("lTboH"),
    $81ac821635a16fcc$var$load("gBDXQ"),
    $81ac821635a16fcc$var$load("cnlNg"),
    $81ac821635a16fcc$var$load("d3Phe"),
    $81ac821635a16fcc$var$load("lASLx"),
    $81ac821635a16fcc$var$load("bIXgz")
]).then(()=>parcelRequire('glan9'));

});

parcelRegister("kviqL", function(module, exports) {

let $03da2528a320066d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $03da2528a320066d$var$load("7p4je"),
    $03da2528a320066d$var$load("8SZbD"),
    $03da2528a320066d$var$load("iE05k"),
    $03da2528a320066d$var$load("lv5aU"),
    $03da2528a320066d$var$load("9Uf61"),
    $03da2528a320066d$var$load("3Yk1e"),
    $03da2528a320066d$var$load("5lJyy"),
    $03da2528a320066d$var$load("9w9df")
]).then(()=>parcelRequire('jIUdy'));

});

parcelRegister("kEGGx", function(module, exports) {

let $f098a771ad5da940$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f098a771ad5da940$var$load("1jQRQ"),
    $f098a771ad5da940$var$load("5pOQA"),
    $f098a771ad5da940$var$load("5GSny"),
    $f098a771ad5da940$var$load("cQump"),
    $f098a771ad5da940$var$load("fJSEb"),
    $f098a771ad5da940$var$load("ajzkj"),
    $f098a771ad5da940$var$load("eyysG"),
    $f098a771ad5da940$var$load("27gvR")
]).then(()=>parcelRequire('j6sWj'));

});

parcelRegister("3I7Hw", function(module, exports) {

let $2b3b746f45ad8ded$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2b3b746f45ad8ded$var$load("km37l"),
    $2b3b746f45ad8ded$var$load("gbksI"),
    $2b3b746f45ad8ded$var$load("j2X7f"),
    $2b3b746f45ad8ded$var$load("fE8pi"),
    $2b3b746f45ad8ded$var$load("9TeWr"),
    $2b3b746f45ad8ded$var$load("kUZ7k"),
    $2b3b746f45ad8ded$var$load("dJQL7"),
    $2b3b746f45ad8ded$var$load("czj6d")
]).then(()=>parcelRequire('6POS4'));

});

parcelRegister("8VE62", function(module, exports) {

let $6802bfe54235dc57$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6802bfe54235dc57$var$load("lTbXI"),
    $6802bfe54235dc57$var$load("a98cw"),
    $6802bfe54235dc57$var$load("e40mE"),
    $6802bfe54235dc57$var$load("btBGI"),
    $6802bfe54235dc57$var$load("fOGnR"),
    $6802bfe54235dc57$var$load("cDQOq"),
    $6802bfe54235dc57$var$load("8upye"),
    $6802bfe54235dc57$var$load("GlmUM")
]).then(()=>parcelRequire('5BZIn'));

});

parcelRegister("l8IkB", function(module, exports) {

let $f63cbb96448b4116$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f63cbb96448b4116$var$load("iUyZj"),
    $f63cbb96448b4116$var$load("4PDaO"),
    $f63cbb96448b4116$var$load("lMhbw"),
    $f63cbb96448b4116$var$load("amTTV"),
    $f63cbb96448b4116$var$load("8nEeY"),
    $f63cbb96448b4116$var$load("kLZKK"),
    $f63cbb96448b4116$var$load("c7GMc"),
    $f63cbb96448b4116$var$load("bnhJ1")
]).then(()=>parcelRequire('dkwKE'));

});

parcelRegister("1kFuU", function(module, exports) {

let $0f87d939a93b0ed6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0f87d939a93b0ed6$var$load("kPlMQ"),
    $0f87d939a93b0ed6$var$load("ervs7"),
    $0f87d939a93b0ed6$var$load("8CX31"),
    $0f87d939a93b0ed6$var$load("kYd4i"),
    $0f87d939a93b0ed6$var$load("fzzMQ"),
    $0f87d939a93b0ed6$var$load("33S6H"),
    $0f87d939a93b0ed6$var$load("kFae4"),
    $0f87d939a93b0ed6$var$load("iZWpE")
]).then(()=>parcelRequire('4VLhA'));

});

parcelRegister("luWhw", function(module, exports) {

let $fa699bd45bb3ceae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fa699bd45bb3ceae$var$load("iT2sv"),
    $fa699bd45bb3ceae$var$load("iMMtn"),
    $fa699bd45bb3ceae$var$load("23VWs"),
    $fa699bd45bb3ceae$var$load("e1KaU"),
    $fa699bd45bb3ceae$var$load("3gNEO"),
    $fa699bd45bb3ceae$var$load("93obY"),
    $fa699bd45bb3ceae$var$load("6Y9jE"),
    $fa699bd45bb3ceae$var$load("cUTaY")
]).then(()=>parcelRequire('gVcgA'));

});

parcelRegister("fMQtL", function(module, exports) {

let $b7e40befcab5209b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b7e40befcab5209b$var$load("lyPpF"),
    $b7e40befcab5209b$var$load("eX5n7"),
    $b7e40befcab5209b$var$load("aiYuN"),
    $b7e40befcab5209b$var$load("gqMCT"),
    $b7e40befcab5209b$var$load("gvylW"),
    $b7e40befcab5209b$var$load("bxfRe"),
    $b7e40befcab5209b$var$load("ed6s8"),
    $b7e40befcab5209b$var$load("lAuJd")
]).then(()=>parcelRequire('6B7wN'));

});

parcelRegister("7GM7G", function(module, exports) {

let $5991c8dd95c32a4d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5991c8dd95c32a4d$var$load("iN3cj"),
    $5991c8dd95c32a4d$var$load("3nHdy"),
    $5991c8dd95c32a4d$var$load("gDEvm"),
    $5991c8dd95c32a4d$var$load("5MwHB"),
    $5991c8dd95c32a4d$var$load("80OLx"),
    $5991c8dd95c32a4d$var$load("1EVcg"),
    $5991c8dd95c32a4d$var$load("96q1k"),
    $5991c8dd95c32a4d$var$load("XQtfV")
]).then(()=>parcelRequire('6e51k'));

});

parcelRegister("1LETb", function(module, exports) {

let $1499e5f0554eb549$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1499e5f0554eb549$var$load("eC1OL"),
    $1499e5f0554eb549$var$load("ilL9c"),
    $1499e5f0554eb549$var$load("64nco"),
    $1499e5f0554eb549$var$load("9cx6P"),
    $1499e5f0554eb549$var$load("e4s0V"),
    $1499e5f0554eb549$var$load("28EXy"),
    $1499e5f0554eb549$var$load("7RZp5"),
    $1499e5f0554eb549$var$load("leyTH")
]).then(()=>parcelRequire('guLr4'));

});

parcelRegister("4th1C", function(module, exports) {

let $341713af82211ab1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $341713af82211ab1$var$load("4NJ49"),
    $341713af82211ab1$var$load("bfOZL"),
    $341713af82211ab1$var$load("jLbRX"),
    $341713af82211ab1$var$load("5g0HW"),
    $341713af82211ab1$var$load("4dPO1"),
    $341713af82211ab1$var$load("gg8tK"),
    $341713af82211ab1$var$load("eF54W"),
    $341713af82211ab1$var$load("3hnPt")
]).then(()=>parcelRequire('9NY5A'));

});

parcelRegister("unThT", function(module, exports) {

let $05b555a8c041f647$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $05b555a8c041f647$var$load("g9gkE"),
    $05b555a8c041f647$var$load("jYdbS"),
    $05b555a8c041f647$var$load("6ncWv"),
    $05b555a8c041f647$var$load("gFneG"),
    $05b555a8c041f647$var$load("ltrgi"),
    $05b555a8c041f647$var$load("fu25G"),
    $05b555a8c041f647$var$load("iQGcz"),
    $05b555a8c041f647$var$load("ar4uw")
]).then(()=>parcelRequire('l7nLc'));

});

parcelRegister("hXIzt", function(module, exports) {

let $d13a853c637a3ee8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d13a853c637a3ee8$var$load("jhikU"),
    $d13a853c637a3ee8$var$load("f0i3H"),
    $d13a853c637a3ee8$var$load("bvBAp"),
    $d13a853c637a3ee8$var$load("9kqmW"),
    $d13a853c637a3ee8$var$load("69YlM"),
    $d13a853c637a3ee8$var$load("cyTsc"),
    $d13a853c637a3ee8$var$load("kXCsp"),
    $d13a853c637a3ee8$var$load("disCG")
]).then(()=>parcelRequire('ijDRq'));

});

parcelRegister("5e2PY", function(module, exports) {

let $3ce075fd9818b53d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3ce075fd9818b53d$var$load("e2Idi").then(()=>parcelRequire('fC7VU'));

});

parcelRegister("11CPA", function(module, exports) {

let $0bf4017cfd787023$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0bf4017cfd787023$var$load("3gdIo").then(()=>parcelRequire('4USSX'));

});

parcelRegister("hRtvo", function(module, exports) {

let $d00e46120947d0cd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d00e46120947d0cd$var$load("1uCJj").then(()=>parcelRequire('dWB8a'));

});

parcelRegister("9PM3y", function(module, exports) {

let $728e27781bf035cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $728e27781bf035cb$var$load("crqMH").then(()=>parcelRequire('qL2MH'));

});

parcelRegister("cB9tL", function(module, exports) {

let $92c04b0f0ee0966d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $92c04b0f0ee0966d$var$load("d91RK"),
    $92c04b0f0ee0966d$var$load("f7hfJ"),
    $92c04b0f0ee0966d$var$load("QI1kr"),
    $92c04b0f0ee0966d$var$load("5LvhC"),
    $92c04b0f0ee0966d$var$load("brdRT"),
    $92c04b0f0ee0966d$var$load("lWBlc"),
    $92c04b0f0ee0966d$var$load("s2EmI"),
    $92c04b0f0ee0966d$var$load("jc0YL")
]).then(()=>parcelRequire('ayAwo'));

});

parcelRegister("kA90v", function(module, exports) {

let $efbe28143b8faa30$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $efbe28143b8faa30$var$load("708J7"),
    $efbe28143b8faa30$var$load("kVqUf"),
    $efbe28143b8faa30$var$load("2IMxh"),
    $efbe28143b8faa30$var$load("98tcg"),
    $efbe28143b8faa30$var$load("j03Pa"),
    $efbe28143b8faa30$var$load("kke1I"),
    $efbe28143b8faa30$var$load("gOwMq"),
    $efbe28143b8faa30$var$load("6GfaN")
]).then(()=>parcelRequire('3x4gn'));

});

parcelRegister("2i9TA", function(module, exports) {

let $1ab4f04681ba5f3a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1ab4f04681ba5f3a$var$load("zUKwV"),
    $1ab4f04681ba5f3a$var$load("fUeur"),
    $1ab4f04681ba5f3a$var$load("1JeTB"),
    $1ab4f04681ba5f3a$var$load("6wr18"),
    $1ab4f04681ba5f3a$var$load("ffEVr"),
    $1ab4f04681ba5f3a$var$load("7EorR"),
    $1ab4f04681ba5f3a$var$load("Wowvf"),
    $1ab4f04681ba5f3a$var$load("hhss7"),
    $1ab4f04681ba5f3a$var$load("gnocL")
]).then(()=>parcelRequire('8mHp9'));

});

parcelRegister("bR6es", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $b2jdX = parcelRequire("b2jdX");


var $gMrzi = parcelRequire("gMrzi");


var $jEaFE = parcelRequire("jEaFE");


var $2Wuyj = parcelRequire("2Wuyj");

const $726c97f63f4e2017$var$styles = {
    toolbarBase: "_0bjKvDKTcp _2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT",
    toolbar: "_0KLXruoI2d _0jFU0VnlTt _1Znuxb1Y8M _2Zuz6Q1Y8M _2OUyjtGk8v",
    toolbarResponsive: "_2YLqiK5zaO",
    primaryToolbar: "_0KLXrulfZc _4kiQYAUofl",
    toolbarSeparator: "_3RwxbwnlTt",
    hiddenSelectors: "_13h9R7YbGa _2XhVcfYbGa _2kQ26MYbGa",
    hiddenSelectorsPatch: "_2jRqDdYbGa"
};
const $726c97f63f4e2017$export$4c260019440d418f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { children: children, label: label, actionSubjectId: actionSubjectId, testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $w6R6I.cx)($726c97f63f4e2017$var$styles.toolbarBase, $726c97f63f4e2017$var$styles.toolbar, $726c97f63f4e2017$var$styles.toolbarResponsive, $726c97f63f4e2017$var$styles.hiddenSelectors, $726c97f63f4e2017$var$styles.toolbarSeparator, $726c97f63f4e2017$var$styles.hiddenSelectorsPatch);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== actionSubjectId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2Wuyj.ViewEventEmitter), {
            actionSubject: (0, $2Wuyj.ACTION_SUBJECT).TOOLBAR,
            actionSubjectId: actionSubjectId
        });
        $[1] = actionSubjectId;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== children || $[4] !== label || $[5] !== t2 || $[6] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            xcss: t1,
            "aria-label": label,
            testId: testId,
            "data-toolbar-type": "inline",
            children: [
                t2,
                children
            ]
        });
        $[3] = children;
        $[4] = label;
        $[5] = t2;
        $[6] = testId;
        $[7] = t3;
    } else t3 = $[7];
    const toolbar = t3;
    let wrappedToolbar = toolbar;
    const { keyboardNavigation: keyboardNavigation } = (0, $b2jdX.useToolbarUI)();
    if (keyboardNavigation) {
        const { childComponentSelector: childComponentSelector, dom: dom, handleEscape: handleEscape, handleFocus: handleFocus, isShortcutToFocusToolbar: isShortcutToFocusToolbar, ariaControls: ariaControls, ariaLabel: ariaLabel } = keyboardNavigation;
        let t4;
        if ($[8] !== ariaControls || $[9] !== ariaLabel || $[10] !== childComponentSelector || $[11] !== dom || $[12] !== handleEscape || $[13] !== handleFocus || $[14] !== isShortcutToFocusToolbar || $[15] !== toolbar) {
            t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jEaFE.ToolbarKeyboardNavigationProvider), {
                childComponentSelector: childComponentSelector,
                dom: dom,
                isShortcutToFocusToolbar: isShortcutToFocusToolbar,
                handleEscape: handleEscape,
                handleFocus: handleFocus,
                ariaControls: ariaControls,
                ariaLabel: ariaLabel,
                children: toolbar
            });
            $[8] = ariaControls;
            $[9] = ariaLabel;
            $[10] = childComponentSelector;
            $[11] = dom;
            $[12] = handleEscape;
            $[13] = handleFocus;
            $[14] = isShortcutToFocusToolbar;
            $[15] = toolbar;
            $[16] = t4;
        } else t4 = $[16];
        wrappedToolbar = t4;
    }
    let t4;
    if ($[17] !== wrappedToolbar) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gMrzi.ResponsiveWrapper), {
            children: wrappedToolbar
        });
        $[17] = wrappedToolbar;
        $[18] = t4;
    } else t4 = $[18];
    return t4;
} : ({ children: children, label: label, actionSubjectId: actionSubjectId, testId: testId })=>{
    const toolbar = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($726c97f63f4e2017$var$styles.toolbarBase, $726c97f63f4e2017$var$styles.toolbar, $726c97f63f4e2017$var$styles.toolbarResponsive, $726c97f63f4e2017$var$styles.hiddenSelectors, $726c97f63f4e2017$var$styles.toolbarSeparator, $726c97f63f4e2017$var$styles.hiddenSelectorsPatch),
        "aria-label": label,
        testId: testId,
        "data-toolbar-type": "inline",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2Wuyj.ViewEventEmitter), {
                actionSubject: (0, $2Wuyj.ACTION_SUBJECT).TOOLBAR,
                actionSubjectId: actionSubjectId
            }),
            children
        ]
    });
    let wrappedToolbar = toolbar;
    const { keyboardNavigation: keyboardNavigation } = (0, $b2jdX.useToolbarUI)();
    if (keyboardNavigation) {
        const { childComponentSelector: childComponentSelector, dom: dom, handleEscape: handleEscape, handleFocus: handleFocus, isShortcutToFocusToolbar: isShortcutToFocusToolbar, ariaControls: ariaControls, ariaLabel: ariaLabel } = keyboardNavigation;
        wrappedToolbar = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jEaFE.ToolbarKeyboardNavigationProvider), {
            childComponentSelector: childComponentSelector,
            dom: dom,
            isShortcutToFocusToolbar: isShortcutToFocusToolbar,
            handleEscape: handleEscape,
            handleFocus: handleFocus,
            ariaControls: ariaControls,
            ariaLabel: ariaLabel,
            children: toolbar
        });
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gMrzi.ResponsiveWrapper), {
        children: wrappedToolbar
    });
};
const $726c97f63f4e2017$export$7469f9986edfc2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, breakpointPreset: breakpointPreset, testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $w6R6I.cx)($726c97f63f4e2017$var$styles.toolbarBase, $726c97f63f4e2017$var$styles.primaryToolbar, $726c97f63f4e2017$var$styles.hiddenSelectors);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t1,
            "data-toolbar-type": "primary",
            testId: testId,
            children: children
        });
        $[1] = children;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== breakpointPreset || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gMrzi.ResponsiveContainer), {
            breakpointPreset: breakpointPreset,
            children: t2
        });
        $[4] = breakpointPreset;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ children: children, breakpointPreset: breakpointPreset, testId: testId })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gMrzi.ResponsiveContainer), {
        breakpointPreset: breakpointPreset,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($726c97f63f4e2017$var$styles.toolbarBase, $726c97f63f4e2017$var$styles.primaryToolbar, $726c97f63f4e2017$var$styles.hiddenSelectors),
            "data-toolbar-type": "primary",
            testId: testId,
            children: children
        })
    });
};
module.exports["Toolbar"] = $726c97f63f4e2017$export$4c260019440d418f;
module.exports["PrimaryToolbar"] = $726c97f63f4e2017$export$7469f9986edfc2;

});

parcelRegister("gMrzi", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $2pQiO = parcelRequire("2pQiO");


var $iMnC5 = parcelRequire("iMnC5");


var $ieeJu = parcelRequire("ieeJu");

const $a746760df070e426$var$styles = {
    responsiveContainer: "_39xV02N91d _0u2WMmrU95 _3n40gWGjUA _3a6JJVvLZJ _3kAwDdvLZJ _40ffbvvLZJ _4BExMVvLZJ _2l4xMaYbGa _32vblKYbGa _1U3CxmYbGa _4tvqstYbGa _3C3owgYbGa _4t1h0mYbGa _3jMGqTYbGa _0FIqsbYbGa",
    responsiveContainerFullPage: "_39xV02E6Kk _3a6JJVvLZJ _3kAwDdvLZJ _40ffbvvLZJ _4BExMVvLZJ _2l4xMaYbGa _32vblKYbGa _1U3CxmYbGa _4tvqstYbGa _3C3owgYbGa _4t1h0mYbGa _3jMGqTYbGa _0FIqsbYbGa",
    fullpage: "_1rq8jLYbGa _0aYpZQvLZJ _2uUPwdYbGa _0032uovLZJ _3WuWXSYbGa _1hfhOsvLZJ _1UwYfAYbGa _12th9UvLZJ _3EFhkHvLZJ _39JjOcvLZJ _0L5H27vLZJ _34STP7vLZJ",
    fullpageUpdated: "_3x54HuYbGa _01WCBwvLZJ _3mkwgcYbGa _4sC1oWvLZJ _2uUPwdYbGa _0032uovLZJ _3WuWXSYbGa _1hfhOsvLZJ _3B0hPZvLZJ _0BUt8zvLZJ _39JjOcvLZJ _2bfXdIvLZJ",
    reduced: "_1mdU70YbGa _3gHiHXvLZJ _3cgyzIvLZJ _1gaO6tYbGa _2cYx2vvLZJ _1CnDTDvLZJ _2CNPNSYbGa _0j4V1pvLZJ _2afuuivLZJ _1YIAQDYbGa _1nd9NrvLZJ _0xzigGvLZJ",
    jiraIssue: "_2I6R9qYbGa _3d33AUvLZJ _0hNaxovLZJ _0GIckyYbGa _1EftZivLZJ _27RrwMvLZJ _3QLJlTYbGa _1MMVXavLZJ _4EWOPkvLZJ _1YIAQDYbGa _1nd9NrvLZJ _0xzigGvLZJ",
    jiraIssueUpdated: "_2I6R9qYbGa _3d33AUvLZJ _3DyQwZvLZJ _3U0x9yYbGa _3UVUXivLZJ _1pEq9LvLZJ _2nGSpMYbGa _41Ji6pvLZJ _149pM8vLZJ _1YIAQDYbGa _1nd9NrvLZJ _0xzigGvLZJ",
    jsmComment: "_1QRAXcYbGa _1AFPIdvLZJ _3GGyPKvLZJ _1p8ZHhYbGa _4BiRXLvLZJ _4tAAtIvLZJ _36lPUiYbGa _3QZ1XdvLZJ _39lxztvLZJ _1YIAQDYbGa _1nd9NrvLZJ _0xzigGvLZJ",
    jsmCommentUpdated: "_1QRAXcYbGa _1AFPIdvLZJ _4mq0TavLZJ _1ZCm13YbGa _0NVVnzvLZJ _2GrInovLZJ _36lPUiYbGa _3QZ1XdvLZJ _39lxztvLZJ _1YIAQDYbGa _1nd9NrvLZJ _0xzigGvLZJ",
    confluenceComment: "_2KtBBnYbGa _0PCBjdvLZJ _0vF73WvLZJ _2BIo24YbGa _0AeybuvLZJ _0PYKuevLZJ _2Y6dwmYbGa _4oeWH5vLZJ _40xblwvLZJ _1YIAQDYbGa _1nd9NrvLZJ _0xzigGvLZJ",
    responsiveRulesWrapper: "_3a6JJVvLZJ _3kAwDdvLZJ _40ffbvvLZJ _4BExMVvLZJ _2l4xMaYbGa _32vblKYbGa _1U3CxmYbGa _4tvqstYbGa _0cHb2BYbGa _3hCVfsvLZJ _1ZeYDsYbGa _1PZiqKvLZJ _11yBoBYbGa _0obMtNvLZJ _1aaAVJYbGa _4cWoU5vLZJ _223UMPYbGa _3X9hbPvLZJ _2ZXGV7YbGa _4aIPGovLZJ"
};
const $a746760df070e426$var$presetStyleMap = {
    fullpage: $a746760df070e426$var$styles.fullpage,
    reduced: $a746760df070e426$var$styles.reduced,
    'jira-issue': $a746760df070e426$var$styles.jiraIssue,
    'jsm-comment': $a746760df070e426$var$styles.jsmComment,
    'confluence-comment': $a746760df070e426$var$styles.confluenceComment
};
const $a746760df070e426$var$updatedPresetStyleMap = {
    fullpage: $a746760df070e426$var$styles.fullpageUpdated,
    'jira-issue': $a746760df070e426$var$styles.jiraIssueUpdated,
    'jsm-comment': $a746760df070e426$var$styles.jsmCommentUpdated
};
const $a746760df070e426$export$e60a4704009a0009 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, breakpointPreset: breakpointPreset } = t0;
    let t1;
    bb0: {
        if (breakpointPreset === "fullpage") {
            t1 = (0, $2pQiO.UNSAFE_expValNoExposure)("platform_editor_ai_content_suggested_edits", "isEnabled", false);
            break bb0;
        }
        t1 = (0, $ieeJu.expValEquals)("platform_editor_toolbar_update_jira_config", "isEnabled", true) && breakpointPreset in $a746760df070e426$var$updatedPresetStyleMap;
    }
    const isUpdatedConfig = t1;
    const t2 = breakpointPreset === "fullpage" ? $a746760df070e426$var$styles.responsiveContainerFullPage : $a746760df070e426$var$styles.responsiveContainer;
    const t3 = isUpdatedConfig ? $a746760df070e426$var$updatedPresetStyleMap[breakpointPreset] : $a746760df070e426$var$presetStyleMap[breakpointPreset];
    let t4;
    if ($[0] !== t2 || $[1] !== t3) {
        t4 = (0, $w6R6I.cx)(t2, t3);
        $[0] = t2;
        $[1] = t3;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== children || $[4] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t4,
            children: children
        });
        $[3] = children;
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    return t5;
} : ({ children: children, breakpointPreset: breakpointPreset })=>{
    const isUpdatedConfig = (()=>{
        if (breakpointPreset === 'fullpage') return (0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_ai_content_suggested_edits', 'isEnabled', false);
        return (0, $ieeJu.expValEquals)('platform_editor_toolbar_update_jira_config', 'isEnabled', true) && breakpointPreset in $a746760df070e426$var$updatedPresetStyleMap;
    })();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)(breakpointPreset === 'fullpage' ? $a746760df070e426$var$styles.responsiveContainerFullPage : $a746760df070e426$var$styles.responsiveContainer, isUpdatedConfig ? $a746760df070e426$var$updatedPresetStyleMap[breakpointPreset] : $a746760df070e426$var$presetStyleMap[breakpointPreset]),
        children: children
    });
}; /**
    * A wrapper that supports responsiveness with media queries. It needs to used together with Show component
    */ 
const $a746760df070e426$export$fa6e408d6a7d6214 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $a746760df070e426$var$styles.responsiveRulesWrapper,
            children: children
        });
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $a746760df070e426$var$styles.responsiveRulesWrapper,
        children: children
    });
};
module.exports["ResponsiveContainer"] = $a746760df070e426$export$e60a4704009a0009;
module.exports["ResponsiveWrapper"] = $a746760df070e426$export$fa6e408d6a7d6214;

});

parcelRegister("jEaFE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1hQ0e = parcelRequire("1hQ0e");

const $3dd4b47fb9e5cae4$export$881345eb2554ea9e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { children: children, childComponentSelector: childComponentSelector, dom: dom, isShortcutToFocusToolbar: isShortcutToFocusToolbar, handleFocus: handleFocus, handleEscape: handleEscape, ariaLabel: ariaLabel, ariaControls: ariaControls } = t0;
    const wrapperRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== childComponentSelector || $[1] !== dom || $[2] !== handleEscape || $[3] !== handleFocus || $[4] !== isShortcutToFocusToolbar) {
        t1 = ()=>{
            if (!wrapperRef.current) return;
            const { current: element } = wrapperRef;
            const getFocusableElements = ()=>{
                if (!element) return [];
                const focusableSelectors = [
                    "button:not([disabled])",
                    "[role=\"button\"]:not([disabled])",
                    "[tabindex]:not([tabindex=\"-1\"])"
                ].join(",");
                const allFocusable = Array.from(element.querySelectorAll(focusableSelectors));
                return allFocusable.filter((el)=>{
                    if (el.closest("[data-keyboard-navigation-independent]")) return false;
                    if (!el.closest(`${childComponentSelector}`)) return false;
                    let currentEl = el;
                    while(currentEl && currentEl !== element){
                        const computedStyle = window.getComputedStyle(currentEl);
                        if (computedStyle.display === "none" || computedStyle.visibility === "hidden") return false;
                        currentEl = currentEl.parentElement;
                    }
                    return true;
                });
            };
            const moveFocus = (direction)=>{
                const focusableElements = getFocusableElements();
                if (focusableElements.length === 0) return;
                const doc = (0, $1hQ0e.getDocument)();
                const currentIndex = focusableElements.findIndex((el_0)=>el_0 === doc?.activeElement);
                let nextIndex;
                if (currentIndex === -1) nextIndex = 0;
                else if (direction === "right") nextIndex = (currentIndex + 1) % focusableElements.length;
                else nextIndex = currentIndex === 0 ? focusableElements.length - 1 : currentIndex - 1;
                focusableElements[nextIndex]?.focus();
            };
            const handleTab = ()=>{
                const focusableElements_0 = getFocusableElements();
                if (focusableElements_0.length === 0) return;
                const doc_0 = (0, $1hQ0e.getDocument)();
                let index = doc_0?.activeElement ? focusableElements_0.findIndex((el_1)=>el_1 === doc_0?.activeElement) : 0;
                if (index < 0) index = 0;
                focusableElements_0.forEach($3dd4b47fb9e5cae4$var$_temp);
                focusableElements_0[index].setAttribute("tabindex", "0");
            };
            const handleKeyDown = (event)=>{
                const targetElement = event.target;
                if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
                if (targetElement instanceof HTMLElement && targetElement.closest("[data-keyboard-navigation-independent]")) return;
                bb96: switch(event.key){
                    case "Escape":
                        handleEscape(event);
                        break bb96;
                    case "ArrowLeft":
                        event.preventDefault();
                        moveFocus("left");
                        break bb96;
                    case "ArrowRight":
                        event.preventDefault();
                        moveFocus("right");
                        break bb96;
                    case "Tab":
                        handleTab();
                        break bb96;
                    default:
                }
            };
            const globalKeyDownHandler = (event_0)=>{
                if (isShortcutToFocusToolbar && isShortcutToFocusToolbar(event_0)) handleFocus(event_0);
            };
            element?.addEventListener("keydown", handleKeyDown);
            dom?.addEventListener("keydown", globalKeyDownHandler);
            return ()=>{
                element?.removeEventListener("keydown", handleKeyDown);
                dom?.removeEventListener("keydown", globalKeyDownHandler);
            };
        };
        t2 = [
            wrapperRef,
            childComponentSelector,
            dom,
            isShortcutToFocusToolbar,
            handleFocus,
            handleEscape
        ];
        $[0] = childComponentSelector;
        $[1] = dom;
        $[2] = handleEscape;
        $[3] = handleFocus;
        $[4] = isShortcutToFocusToolbar;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    if ($[7] !== ariaControls || $[8] !== ariaLabel || $[9] !== children) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: "custom-key-handler-wrapper",
            ref: wrapperRef,
            role: "toolbar",
            "aria-label": ariaLabel,
            "aria-controls": ariaControls,
            children: children
        });
        $[7] = ariaControls;
        $[8] = ariaLabel;
        $[9] = children;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ children: children, childComponentSelector: childComponentSelector, dom: dom, isShortcutToFocusToolbar: isShortcutToFocusToolbar, handleFocus: handleFocus, handleEscape: handleEscape, ariaLabel: ariaLabel, ariaControls: ariaControls })=>{
    const wrapperRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!wrapperRef.current) return;
        const { current: element } = wrapperRef;
        const getFocusableElements = ()=>{
            if (!element) return [];
            // Find all focusable elements within the toolbar that match the child component selector
            const focusableSelectors = [
                'button:not([disabled])',
                '[role="button"]:not([disabled])',
                '[tabindex]:not([tabindex="-1"])'
            ].join(',');
            const allFocusable = Array.from(element.querySelectorAll(focusableSelectors));
            // Filter to only include elements that are:
            // 1. Within the child component selector
            // 2. Visible (not hidden by display:none on itself or any parent)
            return allFocusable.filter((el)=>{
                // Independent containers own their key handling and tab stops.
                if (el.closest('[data-keyboard-navigation-independent]')) return false;
                if (!el.closest(`${childComponentSelector}`)) return false;
                // Check if the element or any of its parents have display: none
                let currentEl = el;
                while(currentEl && currentEl !== element){
                    const computedStyle = window.getComputedStyle(currentEl);
                    if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden') return false;
                    currentEl = currentEl.parentElement;
                }
                return true;
            });
        };
        const moveFocus = (direction)=>{
            const focusableElements = getFocusableElements();
            if (focusableElements.length === 0) return;
            const doc = (0, $1hQ0e.getDocument)();
            const currentIndex = focusableElements.findIndex((el_0)=>el_0 === doc?.activeElement);
            let nextIndex;
            if (currentIndex === -1) // No element currently focused, focus the first one
            nextIndex = 0;
            else if (direction === 'right') // Move right, wrap to beginning if at end
            nextIndex = (currentIndex + 1) % focusableElements.length;
            else // Move left, wrap to end if at beginning
            nextIndex = currentIndex === 0 ? focusableElements.length - 1 : currentIndex - 1;
            focusableElements[nextIndex]?.focus();
        };
        const handleTab = ()=>{
            const focusableElements_0 = getFocusableElements();
            if (focusableElements_0.length === 0) return;
            const doc_0 = (0, $1hQ0e.getDocument)();
            let index = doc_0?.activeElement ? focusableElements_0.findIndex((el_1)=>el_1 === doc_0?.activeElement) : 0;
            if (index < 0) index = 0;
            focusableElements_0.forEach((el_2)=>el_2.setAttribute('tabindex', '-1'));
            focusableElements_0[index].setAttribute('tabindex', '0');
        };
        const handleKeyDown = (event)=>{
            const targetElement = event.target;
            if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
            if (targetElement instanceof HTMLElement && targetElement.closest('[data-keyboard-navigation-independent]')) return;
            switch(event.key){
                case 'Escape':
                    handleEscape(event);
                    break;
                case 'ArrowLeft':
                    event.preventDefault();
                    moveFocus('left');
                    break;
                case 'ArrowRight':
                    event.preventDefault();
                    moveFocus('right');
                    break;
                case 'Tab':
                    handleTab();
                    break;
                default:
            }
        };
        const globalKeyDownHandler = (event_0)=>{
            if (isShortcutToFocusToolbar && isShortcutToFocusToolbar(event_0)) handleFocus(event_0);
        };
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        dom?.addEventListener('keydown', globalKeyDownHandler);
        return ()=>{
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            dom?.removeEventListener('keydown', globalKeyDownHandler);
        };
    }, [
        wrapperRef,
        childComponentSelector,
        dom,
        isShortcutToFocusToolbar,
        handleFocus,
        handleEscape
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- ignored via go/DSP-18766
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        role: "toolbar",
        "aria-label": ariaLabel,
        "aria-controls": ariaControls,
        children: children
    });
};
function $3dd4b47fb9e5cae4$var$_temp(el_2) {
    return el_2.setAttribute("tabindex", "-1");
}
module.exports["ToolbarKeyboardNavigationProvider"] = $3dd4b47fb9e5cae4$export$881345eb2554ea9e;

});

parcelRegister("2Wuyj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $b2jdX = parcelRequire("b2jdX");

const $171e330111381e98$export$7525482b5931e326 = {
    TOOLBAR: 'toolbar',
    TOOLBAR_DROPDOWN_MENU: 'toolbarDropdownMenu'
};
const $171e330111381e98$export$58d0f383acf77599 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { actionSubjectId: actionSubjectId, actionSubject: actionSubject } = t0;
    const isMountedRef = (0, $cozmU.useRef)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $b2jdX.useToolbarUI)();
    let t1;
    let t2;
    if ($[0] !== actionSubject || $[1] !== actionSubjectId || $[2] !== fireAnalyticsEvent) {
        t1 = ()=>{
            if (isMountedRef.current) return;
            isMountedRef.current = true;
            const payload = {
                action: "viewed",
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                eventType: "ui"
            };
            fireAnalyticsEvent && fireAnalyticsEvent(payload);
        };
        t2 = [
            actionSubjectId,
            actionSubject,
            fireAnalyticsEvent
        ];
        $[0] = actionSubject;
        $[1] = actionSubjectId;
        $[2] = fireAnalyticsEvent;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
} : ({ actionSubjectId: actionSubjectId, actionSubject: actionSubject })=>{
    const isMountedRef = (0, $cozmU.useRef)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $b2jdX.useToolbarUI)();
    (0, $cozmU.useEffect)(()=>{
        if (isMountedRef.current) return;
        isMountedRef.current = true;
        const payload = {
            action: 'viewed',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            eventType: 'ui'
        };
        fireAnalyticsEvent && fireAnalyticsEvent(payload);
    }, [
        actionSubjectId,
        actionSubject,
        fireAnalyticsEvent
    ]);
    return null;
};
module.exports["ACTION_SUBJECT"] = $171e330111381e98$export$7525482b5931e326;
module.exports["ViewEventEmitter"] = $171e330111381e98$export$58d0f383acf77599;

});

parcelRegister("Igylv", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $4o0zT = parcelRequire("4o0zT");


var $krYZG = parcelRequire("krYZG");


var $4iudd = parcelRequire("4iudd");


var $fGIRV = parcelRequire("fGIRV");


var $h75sz = parcelRequire("h75sz");


var $iAPNA = parcelRequire("iAPNA");

var $aTBle = parcelRequire("aTBle");


var $6pnwK = parcelRequire("6pnwK");


var $4HBuC = parcelRequire("4HBuC");


var $3k3tn = parcelRequire("3k3tn");


var $g9sVl = parcelRequire("g9sVl");

class $f03b41aa25e7d4ac$export$2e2bcd8739ae039 {
    /**
   * This method exists to move initialization logic out of the constructor,
   * so object can be initialized properly before calling render first time.
   *
   * Example:
   * Instance properties get added to an object only after super call in
   * constructor, which leads to some methods being undefined during the
   * first render.
   */ init(shouldSkipInitRender = false) {
        this.domRef = this.createDomRef();
        this.setDomAttrs(this.node, this.domRef);
        const { dom: contentDOMWrapper, contentDOM: contentDOM } = this.getContentDOM() || {
            dom: undefined,
            contentDOM: undefined
        };
        if (this.domRef && contentDOMWrapper) {
            this.domRef.appendChild(contentDOMWrapper);
            this.contentDOM = contentDOM ? contentDOM : contentDOMWrapper;
            this.contentDOMWrapper = contentDOMWrapper || contentDOM;
        }
        // @see ED-3790
        // something gets messed up during mutation processing inside of a
        // nodeView if DOM structure has nested plain "div"s, it doesn't see the
        // difference between them and it kills the nodeView
        this.domRef.classList.add(`${this.node.type.name}View-content-wrap`);
        const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $iAPNA.getPerformanceOptions)(this.view);
        trackingEnabled && (0, $aTBle.startMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name
        });
        if (!shouldSkipInitRender) {
            this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
            // During SSR, renderToStaticMarkup + container.innerHTML (in portal) clobbers the
            // contentDOMWrapper that was appended above. The React ref callback
            // (forwardRef) never fires in renderToStaticMarkup, so contentDOM is
            // left detached. Re-attach it by finding the marked SSR ref target.
            if ((0, $4iudd.isSSR)() && this.domRef) {
                const refTarget = this.domRef.querySelector('[data-ssr-content-dom-ref]');
                if (refTarget) {
                    this.handleRef(refTarget);
                    // The marker is only needed to locate the re-attach target during
                    // this SSR pass. Remove it so it doesn't leak into the streamed
                    // HTML (it has no meaning on the client).
                    refTarget.removeAttribute('data-ssr-content-dom-ref');
                }
            }
        }
        trackingEnabled && (0, $iAPNA.stopMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name,
            dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
            samplingRate: samplingRate,
            slowThreshold: slowThreshold
        });
        return this;
    }
    // Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderReactComponent(component) {
        if (!this.domRef || !component) return;
        // React 18 does event delegation per portal container: `createPortal` calls
        // `listenToAllSupportedEvents(container)`, which registers a bubble *and* a capture
        // listener for every supported event type — roughly 130 real `addEventListener` calls
        // on the container element. Those listeners are never removed (React has no
        // un-listen path), so mounting a portal for a node view that renders nothing is pure
        // overhead that scales with the number of such nodes in the document.
        //
        // `PortalProviderAPI.render` already invokes the thunk eagerly (see
        // `getPortalProviderAPI`), so evaluating the element here does not change *when*
        // `render()` runs — the pre-evaluated element is handed to the same render call below.
        // If a node view starts out empty and later renders something, `update()` calls back into
        // this method and the portal is mounted at that point.
        let renderComponent = component;
        if ((0, $4o0zT.isExperimentEnabled)('platform_editor_reduce_event_listener_count')) {
            const element = component();
            if (element === null) {
                if (this.hasMountedPortal) {
                    this.portalProviderAPI.remove(this.key);
                    this.hasMountedPortal = false;
                }
                return;
            }
            this.hasMountedPortal = true;
            renderComponent = ()=>element;
        }
        const componentWithErrorBoundary = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $h75sz.ErrorBoundary), {
                component: (0, $krYZG.ACTION_SUBJECT).REACT_NODE_VIEW,
                componentId: this?.node?.type?.name ?? (0, $krYZG.ACTION_SUBJECT_ID).UNKNOWN_NODE,
                dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
                children: renderComponent()
            });
        this.portalProviderAPI.render(componentWithErrorBoundary, // Spreading props to pass through dynamic component props
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.domRef, this.key, undefined, this.shouldRenderImmediatelyInPortal);
    }
    createDomRef() {
        if (!this.node.isInline) return document.createElement('div');
        const htmlElement = document.createElement('span');
        return htmlElement;
    }
    getContentDOM() {
        return undefined;
    }
    _handleRef(node) {
        const contentDOM = this.contentDOMWrapper || this.contentDOM;
        // Spreading props to pass through dynamic component props
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let oldIgnoreMutation;
        let selectionBookmark;
        let mutationsIgnored = false;
        // move the contentDOM node inside the inner reference after rendering
        if (node && contentDOM && !node.contains(contentDOM)) {
            // @ts-ignore - ignoreMutation may not be declared
            oldIgnoreMutation = this.ignoreMutation; // store ref to previous ignoreMutation
            // ignore all mutations caused by ProseMirror's MutationObserver triggering
            // after DOM change, except selection changes
            // @ts-ignore ProseMirror adds selection type to MutationRecord
            this.ignoreMutation = (m)=>{
                const isSelectionMutation = m.type === 'selection';
                if (!isSelectionMutation) mutationsIgnored = true;
                return !isSelectionMutation;
            };
            // capture document selection state before React DOM changes triggers ProseMirror selection change transaction
            if (this.view.state.selection.visible) selectionBookmark = this.view.state.selection.getBookmark();
            node.appendChild(contentDOM);
            // After the next frame:
            requestAnimationFrame(()=>{
                // Restore the original mutation handler
                // @ts-ignore - this may not have been declared by implementing class
                this.ignoreMutation = oldIgnoreMutation;
                // Restore the selection only if:
                // - We have a selection bookmark
                // - Mutations were ignored during the table move
                // - The bookmarked selection is different from the current selection.
                if (selectionBookmark && mutationsIgnored) {
                    const resolvedSelection = selectionBookmark.resolve(this.view.state.tr.doc);
                    // Don't set the selection if it's the same as the current selection.
                    if (!resolvedSelection.eq(this.view.state.selection)) {
                        const tr = this.view.state.tr.setSelection(resolvedSelection);
                        tr.setMeta('source', 'ReactNodeView:_handleRef:selection-resync');
                        this.view.dispatch(tr);
                    }
                }
            });
        }
    }
    // Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    render(props, forwardRef) {
        return this.reactComponent ? /*#__PURE__*/ (0, $8aG6j.jsx)(this.reactComponent, {
            view: this.view,
            getPos: this.getPos,
            node: this.node,
            forwardRef: forwardRef,
            ...props
        }) : null;
    }
    update(node, decorations, _innerDecorations, validUpdate = ()=>true) {
        // @see https://github.com/ProseMirror/prosemirror/issues/648
        const isValidUpdate = this.node.type === node.type && validUpdate(this.node, node);
        this.decorations = decorations;
        if (!isValidUpdate) return false;
        if (this.domRef && !this.node.sameMarkup(node)) this.setDomAttrs(node, this.domRef);
        // View should not process a re-render if this is false.
        // We dont want to destroy the view, so we return true.
        // TODO: ED-13910 - Fix viewShouldUpdate readonly decoration array
        if (!this.viewShouldUpdate(node, decorations)) {
            this.node = node;
            return true;
        }
        this.node = node;
        this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
        return true;
    }
    viewShouldUpdate(nextNode, _decorations) {
        if (this._viewShouldUpdate) return this._viewShouldUpdate(nextNode);
        return true;
    }
    /**
   * Copies the attributes from a ProseMirror Node to a DOM node.
   * @param node The Prosemirror Node from which to source the attributes
   */ setDomAttrs(node, element) {
        Object.keys(node.attrs || {}).forEach((attr)=>{
            element.setAttribute(attr, node.attrs[attr]);
        });
    }
    get dom() {
        // Only return reference if domRef is defined
        if (this.domRef === undefined) //raise an error
        throw new Error('domRef is not defined or may have been destroyed');
        // Spreading props to pass through dynamic component props
        return this.domRef;
    }
    destroy() {
        if (!this.domRef) return;
        this.portalProviderAPI.remove(this.key);
        this.domRef = undefined;
        this.contentDOM = undefined;
    }
    static fromComponent(// Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component, portalProviderAPI, eventDispatcher, props, viewShouldUpdate) {
        return (node, view, getPos)=>new $f03b41aa25e7d4ac$export$2e2bcd8739ae039(node, view, getPos, portalProviderAPI, eventDispatcher, props, component, viewShouldUpdate).init();
    }
    constructor(_node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, // Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reactComponent, viewShouldUpdate, shouldRenderImmediatelyInPortal){
        this.domRef = void 0;
        this.contentDOMWrapper = void 0;
        // Spreading props to pass through dynamic component props
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.reactComponent = void 0;
        this.portalProviderAPI = void 0;
        this._viewShouldUpdate = void 0;
        /**
     * Tracks whether a React portal is currently mounted into `domRef`. Only used under
     * `platform_editor_reduce_event_listener_count`, where a node view whose `render()`
     * returns `null` does not mount one at all.
     */ this.hasMountedPortal = false;
        this.eventDispatcher = void 0;
        this.decorations = [];
        this.reactComponentProps = void 0;
        this.view = void 0;
        this.getPos = void 0;
        this.contentDOM = void 0;
        this.node = void 0;
        this.key = void 0;
        this.shouldRenderImmediatelyInPortal = void 0;
        this.handleRef = (node)=>this._handleRef(node);
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $fGIRV.createDispatch)(this.eventDispatcher);
                dispatch((0, $6pnwK.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        this.node = _node;
        this.view = view;
        this.getPos = getPos;
        this.portalProviderAPI = portalProviderAPI;
        this.reactComponentProps = reactComponentProps || {};
        this.reactComponent = reactComponent;
        this._viewShouldUpdate = viewShouldUpdate;
        this.eventDispatcher = eventDispatcher;
        this.key = (0, $4HBuC.generateUniqueNodeKey)();
        this.shouldRenderImmediatelyInPortal = shouldRenderImmediatelyInPortal || false;
    }
}
module.exports["default"] = $f03b41aa25e7d4ac$export$2e2bcd8739ae039;

});

parcelRegister("4HBuC", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $03RpJ = parcelRequire("03RpJ");

const $1746cd4e14fa5645$export$4a323a0542a1e4d1 = ()=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    return (0, $03RpJ.default)();
};
module.exports["generateUniqueNodeKey"] = $1746cd4e14fa5645$export$4a323a0542a1e4d1;

});

parcelRegister("3k3tn", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $aPdNQ = parcelRequire("aPdNQ");


var $iDrrr = parcelRequire("iDrrr");


var $krYZG = parcelRequire("krYZG");


var $4iudd = parcelRequire("4iudd");


var $h75sz = parcelRequire("h75sz");


var $6pnwK = parcelRequire("6pnwK");

var $iAPNA = parcelRequire("iAPNA");

var $aTBle = parcelRequire("aTBle");


var $8dxef = parcelRequire("8dxef");


var $fngNp = parcelRequire("fngNp");


var $4HBuC = parcelRequire("4HBuC");


var $6EnhY = parcelRequire("6EnhY");

const $d2b8a7e0987cd11a$export$dfb58b577a6f1cd9 = 'inlineNodeView';
const $d2b8a7e0987cd11a$var$canRenderFallback = (node)=>{
    return node.type.isInline && node.type.isAtom && node.type.isLeaf;
};
// list of inline nodes with toDOM fallback implementations that can be virtualized. As
// additional nodes are converted they should be added here
const $d2b8a7e0987cd11a$var$virtualizedNodeAllowlist = [
    'inlineCard'
];
function $d2b8a7e0987cd11a$var$createNodeView({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $4HBuC.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $d2b8a7e0987cd11a$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$d2b8a7e0987cd11a$export$dfb58b577a6f1cd9}`);
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $6pnwK.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($d2b8a7e0987cd11a$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key);
    }
    const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $iAPNA.getPerformanceOptions)(nodeViewParams.view);
    trackingEnabled && (0, $aTBle.startMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name
    });
    // We render the component while creating the node view
    renderComponent();
    trackingEnabled && (0, $iAPNA.stopMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        samplingRate: samplingRate,
        slowThreshold: slowThreshold
    });
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $d2b8a7e0987cd11a$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            renderComponent();
            return true;
        },
        destroy () {
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
function $d2b8a7e0987cd11a$var$createNodeViewVirtualized({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $4HBuC.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $d2b8a7e0987cd11a$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$d2b8a7e0987cd11a$export$dfb58b577a6f1cd9}`);
    function onBeforeReactDomRender() {
        if (!fallbackRef.current) return;
        domRef.removeChild(fallbackRef.current);
        fallbackRef.current = null;
    }
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $6pnwK.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($d2b8a7e0987cd11a$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key, onBeforeReactDomRender);
    }
    let didRenderComponentWithIntersectionObserver = false;
    let destroyed = false;
    let removeIntersectionObserver = ()=>{};
    function renderFallback() {
        if (!$d2b8a7e0987cd11a$var$canRenderFallback(currentNode) || typeof currentNode.type?.spec?.toDOM !== 'function') return;
        const fallback = (0, $aPdNQ.DOMSerializer).renderSpec(document, currentNode.type.spec.toDOM(currentNode));
        const dom = fallback.dom;
        fallbackRef.current = dom;
        domRef.replaceChildren(dom);
    }
    function attachNodeViewObserver() {
        const observer = (0, $6EnhY.getOrCreateOnVisibleObserver)(nodeViewParams.view);
        if (domRef) removeIntersectionObserver = observer.observe(domRef, ()=>{
            if (!didRenderComponentWithIntersectionObserver && !destroyed) {
                renderComponent();
                didRenderComponentWithIntersectionObserver = true;
            }
        });
    }
    renderFallback();
    // allow the fallback to render first before attaching the observer.
    // Will tweak this in a follow up PR to optimise rendering of visible
    // nodes without fallback rendering.
    setTimeout(()=>{
        attachNodeViewObserver();
    }, 0);
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps,
        stopEvent: (event)=>{
            const maybeStopEvent = extraNodeViewProps?.stopEvent;
            if (typeof maybeStopEvent === 'function') return maybeStopEvent(event);
            return false;
        }
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $d2b8a7e0987cd11a$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            if (didRenderComponentWithIntersectionObserver) renderComponent();
            return true;
        },
        destroy () {
            removeIntersectionObserver();
            destroyed = true;
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
/**
 * Copies the attributes from a ProseMirror Node to a DOM node.
 * @param node The Prosemirror Node from which to source the attributes
 */ function $d2b8a7e0987cd11a$var$setDomAttrs(node, element) {
    Object.keys(node.attrs || {}).forEach((attr)=>{
        element.setAttribute(attr, node.attrs[attr]);
    });
}
function $d2b8a7e0987cd11a$var$getPortalChildren({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, currentNode: currentNode, nodeViewParams: nodeViewParams, Component: Component, extraComponentProps: extraComponentProps }) {
    return function portalChildren() {
        //  All inline nodes use `display: inline` to allow for multi-line
        //  wrapping. This does produce an issue in Chrome where it is not
        //  possible to click select the position after the node,
        //  see: https://product-fabric.atlassian.net/browse/ED-12003
        //  however this is only a problem for node views that use
        //  `display: inline-block` somewhere within the Component.
        //  Looking at the below structure, spans with className
        //  `inlineNodeViewAddZeroWidthSpace` have pseudo elements that
        //  add a zero width space which fixes the problem.
        //  Without the additional zero width space before the Component,
        //  it is not possible to use the keyboard to range select in Safari.
        //
        //  Zero width spaces on either side of the Component also prevent
        //  the cursor from appearing inside the node view on all browsers.
        //
        //  Note:
        //  In future it is worth considering prohibiting the use of `display: inline-block`
        //  within inline node view Components however would require a sizable
        //  refactor. A test suite to catch any instances of this is ideal however
        //  the refactor required is currently out of scope for https://product-fabric.atlassian.net/browse/ED-14176
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $h75sz.ErrorBoundary), {
            component: (0, $krYZG.ACTION_SUBJECT).REACT_NODE_VIEW,
            componentId: currentNode?.type?.name ?? (0, $krYZG.ACTION_SUBJECT_ID).UNKNOWN_NODE,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
                    className: `zeroWidthSpaceContainer`,
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                            className: `${$d2b8a7e0987cd11a$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
                        }),
                        (0, $fngNp.ZERO_WIDTH_SPACE)
                    ]
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                    view: nodeViewParams.view,
                    // TODO: ED-13910 - Remove the boolean to fix the prosemirror view type
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    getPos: nodeViewParams.getPos,
                    node: currentNode,
                    ...extraComponentProps
                }),
                (0, $8dxef.getBrowserInfo)().android ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
                    className: `zeroWidthSpaceContainer`,
                    contentEditable: "false",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                            className: `${$d2b8a7e0987cd11a$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
                        }),
                        (0, $fngNp.ZERO_WIDTH_SPACE)
                    ]
                }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    className: `${$d2b8a7e0987cd11a$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
                })
            ]
        });
    };
}
const $d2b8a7e0987cd11a$var$counterPerEditorViewMap = new WeakMap();
function $d2b8a7e0987cd11a$export$17a8c3162956317d({ pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    function nodeViewProducer(...nodeViewProducerParameters) {
        const view = nodeViewProducerParameters[1];
        const node = nodeViewProducerParameters[0];
        const parameters = {
            nodeViewParams: {
                node: node,
                view: view,
                getPos: nodeViewProducerParameters[2],
                decorations: nodeViewProducerParameters[3]
            },
            pmPluginFactoryParams: pmPluginFactoryParams,
            Component: Component,
            extraComponentProps: extraComponentProps,
            extraNodeViewProps: extraNodeViewProps
        };
        const isNodeTypeAllowedToBeVirtualized = $d2b8a7e0987cd11a$var$virtualizedNodeAllowlist.includes(node?.type?.name || '');
        if (!isNodeTypeAllowedToBeVirtualized || (0, $4iudd.isSSR)()) return $d2b8a7e0987cd11a$var$createNodeView(parameters);
        if ((0, $iDrrr.fg)('platform_editor_inline_node_virt_threshold_override')) return $d2b8a7e0987cd11a$var$createNodeViewVirtualized(parameters);
        let inlineNodeViewsVirtualizationCounter = $d2b8a7e0987cd11a$var$counterPerEditorViewMap.get(view) || 0;
        inlineNodeViewsVirtualizationCounter += 1;
        $d2b8a7e0987cd11a$var$counterPerEditorViewMap.set(view, inlineNodeViewsVirtualizationCounter);
        // We never virtualize the 100th first elements
        if (inlineNodeViewsVirtualizationCounter <= 100) return $d2b8a7e0987cd11a$var$createNodeView(parameters);
        return $d2b8a7e0987cd11a$var$createNodeViewVirtualized(parameters);
    }
    return nodeViewProducer;
}
module.exports["getInlineNodeViewProducer"] = $d2b8a7e0987cd11a$export$17a8c3162956317d;

});

parcelRegister("6EnhY", function(module, exports) {
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $1UWNP = parcelRequire("1UWNP");

// Use this selector to set the intersection observer boundary for editor's inline node views
// If this does not exist, it will use the IntersectionObserver's default root
const $756975148395f764$var$INTERSECTION_OBSERVER_ROOT_SELECTOR = '[data-editor-scroll-container="true"]';
const $756975148395f764$var$INTERSECTION_OBSERVER_OPTIONS = {
    rootMargin: '0px 0px 100px 0px',
    threshold: 0
};
const $756975148395f764$export$d73c873f0a6a03c3 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((view)=>{
    const intersectionObserverOptions = {
        root: view.dom.closest($756975148395f764$var$INTERSECTION_OBSERVER_ROOT_SELECTOR),
        ...$756975148395f764$var$INTERSECTION_OBSERVER_OPTIONS
    };
    const callbackMap = new WeakMap();
    const observer = new IntersectionObserver((entries)=>{
        entries.filter((entry)=>entry.isIntersecting) // Only process visible entries
        .map((entry)=>callbackMap.get(entry.target))// Invoke callbacks together to group browser rendering
        // Avoiding requestAnimationFrame to reduce visual flickering
        .forEach((cb)=>cb?.());
    }, intersectionObserverOptions);
    return {
        observe: (el, callback)=>{
            callbackMap.set(el, callback);
            observer.observe(el);
            return ()=>observer.unobserve(el);
        }
    };
});
module.exports["getOrCreateOnVisibleObserver"] = $756975148395f764$export$d73c873f0a6a03c3;

});

parcelRegister("g9sVl", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4iudd = parcelRequire("4iudd");

const $b7122d1a9520547e$export$27292f9d0a2a0aef = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ...props,
            ref: ref,
            "data-ssr-content-dom-ref": (0, $4iudd.isSSR)() ? "" : undefined
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ...props,
        ref: ref,
        "data-ssr-content-dom-ref": (0, $4iudd.isSSR)() ? '' : undefined
    }));
module.exports["NodeViewContentHole"] = $b7122d1a9520547e$export$27292f9d0a2a0aef;

});

parcelRegister("6PfjN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::c64352804e2dc1a0b65a6765b7979b51>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen link-analytics
 */ const $43bfeda8ce4963c3$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $43bfeda8ce4963c3$export$2e2bcd8739ae039 = $43bfeda8ce4963c3$var$createEventPayload;
module.exports["default"] = $43bfeda8ce4963c3$export$2e2bcd8739ae039;

});

parcelRegister("liM9D", function(module, exports) {
const $805653e9c9be0b26$export$3f072f06b90c3985 = 'media';
module.exports["EVENT_CHANNEL"] = $805653e9c9be0b26$export$3f072f06b90c3985;

});

parcelRegister("lqRBm", function(module, exports) {
/* eslint-disable compat/compat */ const $b136b9ae0024c8d8$export$51d09170c61ebe04 = (callback)=>window.requestIdleCallback ? window.requestIdleCallback(callback, {
        timeout: 5000
    }) : window.requestAnimationFrame(callback);
module.exports["runWhenIdle"] = $b136b9ae0024c8d8$export$51d09170c61ebe04;

});

parcelRegister("8hDyr", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2iGHk = parcelRequire("2iGHk");


var $9DHhW = parcelRequire("9DHhW");


var $bI14T = parcelRequire("bI14T");


var $6PfjN = parcelRequire("6PfjN");


var $liM9D = parcelRequire("liM9D");


var $lqRBm = parcelRequire("lqRBm");


const $e5274b30bf01d8e7$export$612752b1e088a45e = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { store: store, connections: { client: client } } = (0, $bI14T.useSmartLinkContext)();
    return (0, $cozmU.useMemo)(()=>{
        const factory = (action)=>(...args)=>{
                try {
                    (0, $lqRBm.runWhenIdle)(()=>{
                        (0, $2iGHk.default)((0, $liM9D.EVENT_CHANNEL))((0, $6PfjN.default)('operational.fireAnalyticEvent.commenced', {
                            action: action
                        }))(createAnalyticsEvent);
                    });
                    (0, $lqRBm.runWhenIdle)(async ()=>{
                        const { default: fireEvent } = await (parcelRequire("6lqqS"));
                        fireEvent(action, createAnalyticsEvent, client, store)(...args);
                    });
                } catch (error) {
                    (0, $2iGHk.default)((0, $liM9D.EVENT_CHANNEL))((0, $6PfjN.default)('operational.fireAnalyticEvent.failed', {
                        error: error instanceof Error ? error.toString() : '',
                        action: action
                    }))(createAnalyticsEvent);
                }
            };
        return {
            linkCreated: factory('created'),
            linkUpdated: factory('updated'),
            linkDeleted: factory('deleted')
        };
    }, [
        client,
        store,
        createAnalyticsEvent
    ]);
};
module.exports["useSmartLinkLifecycleAnalytics"] = $e5274b30bf01d8e7$export$612752b1e088a45e;

});

parcelRegister("6lqqS", function(module, exports) {

let $49e935329c0ad884$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $49e935329c0ad884$var$load("zUKwV"),
    $49e935329c0ad884$var$load("fUeur"),
    $49e935329c0ad884$var$load("1JeTB"),
    $49e935329c0ad884$var$load("axcf5")
]).then(()=>parcelRequire('3hbWh'));

});

parcelRegister("19KQj", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $cozmU = parcelRequire("cozmU");


var $g4Dow = parcelRequire("g4Dow");


function $dc3ded826fe771fd$export$ed70996d478e16d3() {
    /**
   * this utility maybe extended in the future to include
   * more contextual info about SLs
   */ const events = (0, $cozmU.useMemo)(()=>new (0, $g4Dow.SmartLinkEvents)(), []);
    return events;
}
module.exports["useSmartLinkEvents"] = $dc3ded826fe771fd$export$ed70996d478e16d3;

});

parcelRegister("g4Dow", function(module, exports) {

var $NRi3o = parcelRequire("NRi3o");

class $bcf6771165225992$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        (0, $NRi3o.fireSmartLinkEvent)({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
module.exports["SmartLinkEvents"] = $bcf6771165225992$export$b91e0203b928470c;

});

parcelRegister("NRi3o", function(module, exports) {

var $6GOAK = parcelRequire("6GOAK");

const $43c279dc5065c317$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire((0, $6GOAK.ANALYTICS_CHANNEL));
};
module.exports["fireSmartLinkEvent"] = $43c279dc5065c317$export$2a123f7ee48a122c;

});

parcelRegister("fDAOo", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6270d9b7fedaa79$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $58FyF = parcelRequire("58FyF");


var $3yGK6 = parcelRequire("3yGK6");

function $b6270d9b7fedaa79$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    return (0, $58FyF.default)(dirtyDate, amount * 12);
}

});

parcelRegister("5ZJRm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");



class $928d71b7a1b056f3$export$3ce634ac4a869e2c extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    componentDidMount() {
        this.mounted = true;
        if (!this.state.Browser) Promise.all([
            (parcelRequire("gLZqH")),
            (parcelRequire("b7FkK"))
        ]).then(([mediaClient, browserModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $928d71b7a1b056f3$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
            if (this.mounted) this.setState({
                Browser: $928d71b7a1b056f3$export$3ce634ac4a869e2c.Browser
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        if (!this.state.Browser) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(this.state.Browser, this.props);
    }
    constructor(...args){
        super(...args);
        this.mounted = false;
        this.state = {
            Browser: $928d71b7a1b056f3$export$3ce634ac4a869e2c.Browser
        };
    }
}
$928d71b7a1b056f3$export$3ce634ac4a869e2c.displayName = 'AsyncBrowser';
$928d71b7a1b056f3$export$3ce634ac4a869e2c.Browser = void 0;
module.exports["BrowserLoader"] = $928d71b7a1b056f3$export$3ce634ac4a869e2c;

});

parcelRegister("gLZqH", function(module, exports) {

let $c360afc884decf86$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c360afc884decf86$var$load("RI3SR").then(()=>parcelRequire('g0fSg'));

});

parcelRegister("b7FkK", function(module, exports) {

let $8190692a267ba8df$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8190692a267ba8df$var$load("9vDBp"),
    $8190692a267ba8df$var$load("18FPo"),
    $8190692a267ba8df$var$load("10DpY"),
    $8190692a267ba8df$var$load("5ouIR")
]).then(()=>parcelRequire('e7T2P'));

});

parcelRegister("7ZL6d", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $96bd972ec1007d07$export$480e55f805d7990f = (0, $kSwu1.defineMessages)({
    // Event hub messages
    eventHubfallbackSuggestedTitle: {
        id: "fabric.editor.ai.eventHub.fallbackSuggestedTitle",
        defaultMessage: "Page title"
    },
    eventHubfallbackSuggestedTitlePrefix: {
        id: "fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix",
        defaultMessage: "Page"
    },
    // Toolbar messages
    aiToolbarTitle: {
        id: "fabric.editor.ai.toolbar.titleText",
        defaultMessage: "Atlassian Intelligence"
    },
    improveWritingToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.improveWriting.title",
        defaultMessage: "Improve writing"
    },
    improveWritingToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.improveWriting.tooltip",
        defaultMessage: "Tell Atlassian Intelligence to improve the writing of your selection"
    },
    askAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.askAI.title",
        defaultMessage: "Ask AI"
    },
    askRovoToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.askRovo.title",
        defaultMessage: "Ask Rovo"
    },
    askRovoToolbarRemixAppTitle: {
        id: "fabric.editor.ai.toolbar.askRovo.remixApp.title",
        defaultMessage: "Edit"
    },
    askRovoToolbarImageTitle: {
        id: "fabric.editor.ai.toolbar.askRovo.image.title",
        defaultMessage: "Edit image"
    },
    moreRovoOptionsMenuLabel: {
        id: "fabric.editor.ai.toolbar.moreRovoOptions.label",
        defaultMessage: "More Rovo options"
    },
    askRovoAiSplitButtonLabel: {
        id: "fabric.editor.ai.toolbar.askRovoAiSplitButton.label",
        defaultMessage: "Ask Rovo AI"
    },
    askAIToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip",
        defaultMessage: "Open Atlassian Intelligence"
    },
    askAIToolbarIconTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip.quickCommand",
        defaultMessage: "Ask AI {key}+'"
    },
    askRovoToolbarIconTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.askRovo.tooltip.quickCommand",
        defaultMessage: "Ask Rovo {key}+'"
    },
    askRovoToolbarRemixAppTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.askRovo.remixApp.tooltip.quickCommand",
        defaultMessage: "Edit {key}+'"
    },
    askRovoToolbarImageTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.askRovo.image.tooltip.quickCommand",
        defaultMessage: "Edit image {key}+'"
    },
    tryAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.tryAI.title",
        defaultMessage: "Try AI"
    },
    tryAIToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip",
        defaultMessage: "Open Atlassian Intelligence"
    },
    simplifiedAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.simplifiedAI.title",
        defaultMessage: "AI"
    },
    rovoToolbarDropdownChevronLabel: {
        id: "fabric.editor.ai.toolbar.rovoDropdownChevron.label",
        defaultMessage: "More Ask Rovo options"
    },
    summarizeToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.summarize.title",
        defaultMessage: "Summarize"
    },
    translateToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.translate.title",
        defaultMessage: "Translate"
    },
    translateOptionsIconLabel: {
        id: "fabric.editor.ai.toolbar.translateOptions.label",
        defaultMessage: "Translate options"
    },
    spellingAndGrammarToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.spellingAndGrammar.title",
        defaultMessage: "Fix spelling and grammar"
    },
    makeLongerToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.makeLonger.title",
        defaultMessage: "Make longer"
    },
    makeShorterToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.makeShorter.title",
        defaultMessage: "Make shorter"
    },
    changeToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.changeTone.title",
        defaultMessage: "Change tone"
    },
    changeToneOptionsIconLabel: {
        id: "fabric.editor.ai.toolbar.changeToneOptions.title",
        defaultMessage: "Change tone options"
    },
    moreProfessionalToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreProfessionalTone.title",
        defaultMessage: "More professional"
    },
    moreCasualToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreCasualTone.title",
        defaultMessage: "More casual"
    },
    moreEmpatheticToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreEmpatheticTone.title",
        defaultMessage: "More empathetic"
    },
    adjustLengthToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.adjustLength.title",
        defaultMessage: "Adjust length"
    },
    DefineDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.DefineDropdownIconTitle.title",
        defaultMessage: "Define"
    },
    // Prebuilt messages
    atlasGenerateContentConfigItemDescription: {
        id: "fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription",
        defaultMessage: "Generates content to be inserted into the update"
    },
    atlasSummarizePageConfigItemDescription: {
        id: "fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription",
        defaultMessage: "Summarizes the content of the update"
    },
    confluenceChangeToneSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Change tone"
    },
    confluenceRewriteSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Rewrite"
    },
    confluenceTranslateSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Translate"
    },
    // AI Panel Action items messages
    actionItemsPageTitle: {
        id: "fabric.editor.ai.ai-panels.actionItemsPageTitle",
        defaultMessage: "Action items panel (Beta)"
    },
    actionItemsPageDescription: {
        id: "fabric.editor.ai.ai-panels.actionItemsPageDescription",
        defaultMessage: "Use Atlassian Intelligence to find action items and display in a panel"
    },
    // AI Panel Summarise page messages
    summarizePageTitle: {
        id: "fabric.editor.ai.ai-panels.summarizePageTitle",
        defaultMessage: "Page summary panel (Beta)"
    },
    summarisePageDescription: {
        id: "fabric.editor.ai.ai-panels.summarizePageDescription",
        defaultMessage: "Use Atlassian Intelligence to summarize this page and display in a panel"
    },
    // Agent messages
    agentsDropdownTitle: {
        id: "rovo.agents.dropdown.title",
        defaultMessage: "Agents"
    },
    agentsViewAgentsLabel: {
        id: "rovo.agents.dropdown.viewAgents.label",
        defaultMessage: "View all agents"
    },
    // Error messages
    unhandledErrorMessage: {
        id: "fabric.editor.ai.experience-application.unhandledErrorMessage",
        defaultMessage: "We're having trouble. Close the dialog and try again."
    },
    cmdPaletteUnhandledErrorMessage: {
        id: "fabric.editor.ai.experience-application.cmdPaletteUnhandledErrorMessage",
        defaultMessage: "We're having issues and can't generate a response right now. Try again later."
    },
    markdownErrorMessage: {
        id: "fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage",
        defaultMessage: "We're having trouble generating the preview. Close the dialog and try again."
    },
    // Prompt Builder messages
    promptbuilderAriaLabel: {
        id: "fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel",
        defaultMessage: "Ask Atlassian Intelligence"
    },
    promptBuilderFromButton: {
        id: "fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit",
        defaultMessage: "Generate"
    },
    // AI Smart button messages
    aiSmartButtonDynamicSurfaceSelectedContent: {
        id: "fabric.editor.ai.ai-smart-button.context.reference",
        defaultMessage: "Selected content"
    },
    // Telepointer
    aiPlannerTelepointer: {
        id: "fabric.editor.ai.telepointer.planner",
        defaultMessage: "Planner"
    },
    aiRovoTelepointer: {
        id: "fabric.editor.ai.telepointer.rovo",
        defaultMessage: "Rovo"
    },
    // On-paste menu messages
    pasteMenuActionsTitle: {
        id: "fabric.editor.ai.paste-menu.section-title",
        defaultMessage: "Actions"
    },
    // Block menu messages
    blockMenuNestedMenuTitle: {
        id: "fabric.editor.ai.config.item.blockMenuNestedMenu.title",
        defaultMessage: "View more actions"
    },
    // Smartlink action messages
    smartlinkListKeyTopics: {
        id: "fabric.editor.ai.smartlink.action.listKeyTopics",
        defaultMessage: "List key topics"
    },
    smartlinkListKeyThemes: {
        id: "fabric.editor.ai.smartlink.action.listKeyThemes",
        defaultMessage: "List key themes"
    },
    smartlinkExtractInsights: {
        id: "fabric.editor.ai.smartlink.action.extractInsights",
        defaultMessage: "Extract insights"
    },
    smartlinkExtractUserQuotes: {
        id: "fabric.editor.ai.smartlink.action.extractUserQuotes",
        defaultMessage: "Extract user quotes"
    },
    smartlinkAddDecisions: {
        id: "fabric.editor.ai.smartlink.action.addDecisions",
        defaultMessage: "Add decisions"
    },
    smartlinkDefineActionItems: {
        id: "fabric.editor.ai.smartlink.action.defineActionItems",
        defaultMessage: "Define action items"
    },
    smartlinkSummarizeChanges: {
        id: "fabric.editor.ai.smartlink.action.summarizeChanges",
        defaultMessage: "Summarize changes"
    },
    smartlinkAddRelatedWorkItems: {
        id: "fabric.editor.ai.smartlink.action.addRelatedWorkItems",
        defaultMessage: "Add related work items"
    },
    smartlinkListTodos: {
        id: "fabric.editor.ai.smartlink.action.listTodos",
        defaultMessage: "List to-dos"
    }
});
module.exports["aiMessages"] = $96bd972ec1007d07$export$480e55f805d7990f;

});

parcelRegister("c5jT4", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $kSwu1 = parcelRequire("kSwu1");

const $fb80bfa16650ce97$export$21be832820f3e6e6 = (0, $kSwu1.defineMessages)({
    aupViolationMessage: {
        id: "fabric.editor.ai.experience.aupViolationMessage",
        defaultMessage: "Your prompt or content might not comply with our Acceptable Use Policy. Please review both and refer to our <link>Acceptable Use Policy</link> if needed. If the problem persists, consider trying a different prompt or content."
    },
    documentInsertError: {
        id: "fabric.editor.ai.experience-application.documentInsertError",
        defaultMessage: "We're having trouble inserting the response. Close the dialog and try again."
    },
    tokenLimitExceeded: {
        id: "fabric.editor.ai.experience-application.tokenLimitExceeded",
        defaultMessage: "We couldn't get a response. Your prompt or response was over the limit for this request. Close the dialog and try again."
    },
    rateLimitEnforced: {
        id: "fabric.editor.ai.experience-application.rateLimitEnforced",
        defaultMessage: "We\u2019ve received too many recent requests for Atlassian Intelligence (AI). Try again in a few minutes or read about <link>excessive use of AI</link>."
    },
    apiError: {
        id: "fabric.editor.ai.experience.apiError",
        defaultMessage: "We couldn\u2019t get a response, please try again."
    },
    elevateDisabledGenerateError: {
        id: "fabric.editor.ai.experience.elevateDisabledGenetateError",
        defaultMessage: "Free generate is disabled in Elevate at this time."
    },
    internalServerError: {
        id: "fabric.editor.ai.experience.internalServerError",
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <link>check the status of AI</link>."
    },
    inputTooShortError: {
        id: "fabric.editor.ai.experience.inputTooShortError",
        defaultMessage: "The content is too short to summarize. Please add more and try again."
    },
    hipaaContentError: {
        id: "fabric.editor.ai.experience.hipaaContentError",
        defaultMessage: "Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content. Please remove these links and try again."
    },
    adfStreamingError: {
        id: "fabric.editor.ai.experience.adfStreamingError",
        defaultMessage: "Our apologies, we couldn't get a response."
    },
    aifcAupViolationMessage: {
        id: "fabric.editor.ai.experience.aifcAupViolationMessage",
        defaultMessage: "Content does not comply with our <link>Acceptable Use Policy</link>."
    },
    aifcApiError: {
        id: "fabric.editor.ai.experience.aifcApiError",
        defaultMessage: "An unknown error occurred."
    },
    aifcApiErrorRetry: {
        id: "fabric.editor.ai.experience.aifcApiErrorRetry",
        defaultMessage: "An unknown error occurred. Please reload and try again."
    },
    aifcTokenLimitExceeded: {
        id: "fabric.editor.ai.experience.aifcTokenLimitExceeded",
        defaultMessage: "There\u2019s too much content to process. Select less content and try again."
    },
    aifcInputTooShortError: {
        id: "fabric.editor.ai.experience.aifcInputTooShortError",
        defaultMessage: "More content needed to complete your request. Please select more content and try again."
    },
    aifcHipaaContentError: {
        id: "fabric.editor.ai.experience.aifcHipaaContentError",
        defaultMessage: "Your content contains links to HIPAA restricted content. Remove links and try again."
    },
    aifcRateLimitEnforced: {
        id: "fabric.editor.ai.experience.aifcRateLimitEnforced",
        defaultMessage: "You\u2019ve reached the <link>maximum number of requests</link>. Try again in 5 minutes."
    },
    aifcInternalServerError: {
        id: "fabric.editor.ai.experience.aifcInternalServerError",
        defaultMessage: "Our apologies, we couldn\u2019t get a response. Try again in 5 minutes or <link>check Rovo status</link>."
    },
    aifcAdfStreamingError: {
        id: "fabric.editor.ai.experience.aifcAdfStreamingError",
        defaultMessage: "Our apologies, we couldn\u2019t get a response."
    },
    noTextualContentError: {
        id: "fabric.editor.ai.experience.noTextualContentError",
        defaultMessage: "More content needed to complete your request. Please select more content and try again."
    }
});
module.exports["aiFailedStateMessages"] = $fb80bfa16650ce97$export$21be832820f3e6e6;

});

parcelRegister("k9SFD", function(module, exports) {

var $drRzc = parcelRequire("drRzc");

const $00f984e1ee672b7a$var$getAppType = (userType)=>userType === 'APP' || userType === 'AGENT' ? 'agent' : 'user';
const $00f984e1ee672b7a$var$enrichMentionNodeData = (mention, data)=>({
        ...data,
        appType: data?.appType ?? $00f984e1ee672b7a$var$getAppType(mention.userType)
    });
const $00f984e1ee672b7a$var$toMentionNode = ({ id: id, userType: userType })=>({
        attrs: {
            id: id,
            // NodeDataProvider uses an ADF node internally, so normalize the runtime-only value.
            userType: userType === 'AGENT' ? 'APP' : userType
        },
        type: 'mention'
    });
const $00f984e1ee672b7a$var$isMentionNode = (node)=>node.type === 'mention' && node.attrs !== undefined && 'id' in node.attrs && typeof node.attrs.id === 'string';
const $00f984e1ee672b7a$var$SUBSCRIPTION_KEY_PREFIX = 'mention-node-data-provider';
let $00f984e1ee672b7a$var$subscriptionKeyCounter = 0;
const $00f984e1ee672b7a$var$cacheMentionData = (cache, mentions)=>{
    mentions.forEach((mention)=>{
        if (mention.isPlaceholder || !mention.avatarUrl) {
            cache.delete(mention.id);
            return;
        }
        cache.set(mention.id, {
            avatarUrl: mention.avatarUrl,
            appType: mention.appType
        });
    });
};
class $00f984e1ee672b7a$export$d2331d8e30b7662 extends (0, $drRzc.NodeDataProvider) {
    isNodeSupported(node) {
        return $00f984e1ee672b7a$var$isMentionNode(node) && node.attrs.userType !== 'SPECIAL';
    }
    nodeDataKey(node) {
        return node.attrs.id;
    }
    async fetchNodesData(nodes) {
        const accountIds = Array.from(new Set(nodes.map(({ attrs: attrs })=>attrs.id)));
        const dataByAccountId = await this.enqueueFetch(accountIds);
        return nodes.map(({ attrs: attrs })=>$00f984e1ee672b7a$var$enrichMentionNodeData(attrs, dataByAccountId[attrs.id]));
    }
    getMentionData(mention, callback) {
        const resolvedData = this.resolveMentionNodeDataFromCache(mention);
        if (resolvedData) {
            callback({
                data: $00f984e1ee672b7a$var$enrichMentionNodeData(mention, resolvedData)
            });
            return;
        }
        this.getData($00f984e1ee672b7a$var$toMentionNode(mention), callback);
    }
    getMentionDataFromCache(mention) {
        const resolvedData = this.resolveMentionNodeDataFromCache(mention);
        if (resolvedData) return $00f984e1ee672b7a$var$enrichMentionNodeData(mention, resolvedData);
        const data = this.getNodeDataFromCache($00f984e1ee672b7a$var$toMentionNode(mention))?.data;
        return data ? $00f984e1ee672b7a$var$enrichMentionNodeData(mention, data) : undefined;
    }
    connect(mentionResource) {
        if (this.lastMentionResource && this.lastMentionResource !== mentionResource) {
            this.emittedMentionCache.clear();
            this.resetCache();
        }
        this.lastMentionResource = mentionResource;
        if (this.abortControllerRef.current.signal.aborted) this.abortControllerRef.current = new AbortController();
        let isDisconnected = false;
        let subscribedMentionProvider;
        mentionResource.then((mentionProvider)=>{
            if (isDisconnected) return;
            subscribedMentionProvider = mentionProvider;
            mentionProvider.subscribe(this.subscriptionKey, (mentions)=>{
                $00f984e1ee672b7a$var$cacheMentionData(this.emittedMentionCache, mentions);
            });
        }).catch(()=>undefined);
        return ()=>{
            isDisconnected = true;
            this.abortControllerRef.current.abort();
            subscribedMentionProvider?.unsubscribe(this.subscriptionKey);
            subscribedMentionProvider = undefined;
        };
    }
    resolveMentionNodeDataFromCache(mention) {
        return this.resolveMentionNodeData?.(mention) ?? this.emittedMentionCache.get(mention.id);
    }
    enqueueFetch(accountIds) {
        const result = new Promise((resolve, reject)=>{
            this.queuedFetches.push({
                accountIds: accountIds,
                reject: reject,
                resolve: resolve
            });
        });
        if (!this.isFlushScheduled) {
            this.isFlushScheduled = true;
            Promise.resolve().then(()=>this.flushFetches());
        }
        return result;
    }
    async flushFetches() {
        this.isFlushScheduled = false;
        const queuedFetches = this.queuedFetches;
        this.queuedFetches = [];
        const accountIds = Array.from(new Set(queuedFetches.flatMap((request)=>request.accountIds)));
        try {
            const data = await this.fetchMentionNodeData(accountIds, this.abortControllerRef.current.signal);
            queuedFetches.forEach(({ resolve: resolve })=>resolve(data));
        } catch (error) {
            queuedFetches.forEach(({ reject: reject })=>reject(error));
        }
    }
    constructor(fetchMentionNodeData, resolveMentionNodeData){
        super(), this.fetchMentionNodeData = fetchMentionNodeData, this.resolveMentionNodeData = resolveMentionNodeData;
        this.name = 'mentionNodeDataProvider';
        this.abortControllerRef = {
            current: new AbortController()
        };
        this.emittedMentionCache = new Map();
        this.subscriptionKey = `${$00f984e1ee672b7a$var$SUBSCRIPTION_KEY_PREFIX}:${++$00f984e1ee672b7a$var$subscriptionKeyCounter}`;
        this.lastMentionResource = void 0;
        this.queuedFetches = [];
        this.isFlushScheduled = false;
    }
}
module.exports["MentionNodeDataProvider"] = $00f984e1ee672b7a$export$d2331d8e30b7662;

});

parcelRegister("iSvYs", function(module, exports) {

var $bUA3T = parcelRequire("bUA3T");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/jira/site/manifest.ts
var $dbe612872f014897$var$jiraSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $bUA3T.JiraSiteAriResourceOwner),
    resourceType: (0, $bUA3T.JiraSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/jira/site/index.ts
var $dbe612872f014897$export$6c0f81f222d09301 = class _JiraSiteAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $dbe612872f014897$var$jiraSiteAriStaticOpts.qualifier,
            platformQualifier: $dbe612872f014897$var$jiraSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $dbe612872f014897$var$jiraSiteAriStaticOpts.resourceOwner,
            resourceType: $dbe612872f014897$var$jiraSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $dbe612872f014897$var$jiraSiteAriStaticOpts);
        return new _JiraSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $dbe612872f014897$var$jiraSiteAriStaticOpts);
        return new _JiraSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["JiraSiteAri"] = $dbe612872f014897$export$6c0f81f222d09301;

});

parcelRegister("bUA3T", function(module, exports) {
// src/jira/site/types.ts
var $8ac0e5c8b2cbf8ed$export$b7d590981b504412 = "jira", $8ac0e5c8b2cbf8ed$export$886165a991f21644 = "site";
module.exports["JiraSiteAriResourceOwner"] = $8ac0e5c8b2cbf8ed$export$b7d590981b504412;
module.exports["JiraSiteAriResourceType"] = $8ac0e5c8b2cbf8ed$export$886165a991f21644;

});

parcelRegister("dhtsm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::32f92d4b4659c87427bca36d4cc14c22>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ab3b6586bd7bdc0$var$_react = $9ab3b6586bd7bdc0$var$_interopRequireDefault((parcelRequire("cozmU")));

var $9ab3b6586bd7bdc0$var$_iconNew = $9ab3b6586bd7bdc0$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $9ab3b6586bd7bdc0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FieldText".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/field-text
 * Usage guidance:
 * Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9ab3b6586bd7bdc0$var$FieldTextIcon = (props)=>/*#__PURE__*/ $9ab3b6586bd7bdc0$var$_react.default.createElement($9ab3b6586bd7bdc0$var$_iconNew.default, Object.assign({
        name: "FieldTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.75 2.5H8V1h5v1.5h-1.75v2H14a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2.75v2H13V15H8v-1.5h1.75zm1.5 7.5H14a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 0 14 6h-2.75zM2 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h6v1.5H2a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h6V6z" clip-rule="evenodd"/>`
    }, props));
$9ab3b6586bd7bdc0$var$FieldTextIcon.displayName = 'FieldTextIcon';
var $9ab3b6586bd7bdc0$var$_default = module.exports.default = $9ab3b6586bd7bdc0$var$FieldTextIcon;

});

parcelRegister("38vK5", function(module, exports) {

var $4Vdlk = parcelRequire("4Vdlk");


var $50k8e = parcelRequire("50k8e");

const $13b62b9fdabf1049$var$api = (0, $50k8e.makeApi)({
    monitor: (0, $4Vdlk.monitorForElements)
});
const $13b62b9fdabf1049$export$4b66ee8317094cdb = $13b62b9fdabf1049$var$api.autoScroll;
const $13b62b9fdabf1049$export$c9168f41de61f525 = $13b62b9fdabf1049$var$api.autoScrollWindow;
module.exports["autoScrollForElements"] = $13b62b9fdabf1049$export$4b66ee8317094cdb;

});

parcelRegister("50k8e", function(module, exports) {

var $4QfFX = parcelRequire("4QfFX");


var $gEZCs = parcelRequire("gEZCs");


var $bTXWf = parcelRequire("bTXWf");


var $4SoL4 = parcelRequire("4SoL4");


var $1UuSE = parcelRequire("1UuSE");

function $f5382ac96223be68$export$b8fa21320a811083({ monitor: monitor }) {
    const elementRegistry = new Map();
    const windowRegistry = new Set();
    function autoScroll(args) {
        elementRegistry.set(args.element, args);
        const cleanup = (0, $4QfFX.combine)((0, $4SoL4.addScrollableAttribute)(args.element), ()=>elementRegistry.delete(args.element));
        return (0, $gEZCs.once)(cleanup);
    }
    function autoScrollWindow(args = {}) {
        // Putting `args` in a unique object so that
        // each call will create a unique entry, even if a consumer
        // shares the `args` object between calls.
        // Just being safe here.
        const unique = {
            ...args
        };
        windowRegistry.add(unique);
        function cleanup() {
            windowRegistry.delete(unique);
        }
        return (0, $gEZCs.once)(cleanup);
    }
    function findEntry(element) {
        return elementRegistry.get(element) ?? null;
    }
    function getWindowScrollEntries() {
        return Array.from(windowRegistry);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $1UuSE.tryScroll)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            findEntry: findEntry,
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame,
            getWindowScrollEntries: getWindowScrollEntries
        });
    }
    (0, $bTXWf.getScheduler)(monitor).onFrame(onFrame);
    return {
        autoScroll: autoScroll,
        autoScrollWindow: autoScrollWindow
    };
}
module.exports["makeApi"] = $f5382ac96223be68$export$b8fa21320a811083;

});

parcelRegister("bTXWf", function(module, exports) {

var $31Y6I = parcelRequire("31Y6I");


var $5Mj3f = parcelRequire("5Mj3f");

// We keep this map so that "over element" scrolling and "overflow" scrolling
// can leverage the same scheduler.
// The 'monitor' is the key for looking up schedulers
const $d27a3192f501902b$var$schedulers = new Map();
function $d27a3192f501902b$export$5cff7ac265db316a(monitor) {
    const scheduler = $d27a3192f501902b$var$schedulers.get(monitor);
    if (scheduler) // @ts-expect-error: I don't know how to link the DragType generic between the key and the value when the
    // monitor itself is the key
    return scheduler;
    const created = $d27a3192f501902b$var$makeScheduler(monitor);
    $d27a3192f501902b$var$schedulers.set(monitor, created);
    return created;
}
function $d27a3192f501902b$var$makeScheduler(monitor) {
    let state = {
        type: 'idle'
    };
    const callbacks = [];
    function loop(timeLastFrameFinished) {
        if (state.type !== 'running') return;
        const timeSinceLastFrame = timeLastFrameFinished - state.timeLastFrameFinished;
        const { latestArgs: latestArgs } = state;
        // A common starting lookup point for determining
        // which auto scroller should be used, and what should be scrolled.
        const underUsersPointer = (0, $31Y6I.getElementFromPointWithoutHoneypot)({
            x: latestArgs.location.current.input.clientX,
            y: latestArgs.location.current.input.clientY
        });
        (0, $5Mj3f.clearUnusedEngagements)(()=>{
            callbacks.forEach((onFrame)=>onFrame({
                    underUsersPointer: underUsersPointer,
                    latestArgs: latestArgs,
                    timeSinceLastFrame: timeSinceLastFrame
                }));
        });
        state.timeLastFrameFinished = timeLastFrameFinished;
        state.frameId = requestAnimationFrame(loop);
    }
    function reset() {
        if (state.type === 'idle') return;
        cancelAnimationFrame(state.frameId);
        (0, $5Mj3f.clearEngagementHistory)();
        state = {
            type: 'idle'
        };
    }
    function start(args) {
        if (state.type !== 'idle') return;
        state = {
            // Waiting a frame so we can accurately determine `timeSinceLastFrame`.
            type: 'initializing',
            latestArgs: args,
            frameId: requestAnimationFrame((timeLastFrameFinished)=>{
                if (state.type !== 'initializing') return;
                state = {
                    type: 'running',
                    timeLastFrameFinished: timeLastFrameFinished,
                    latestArgs: state.latestArgs,
                    frameId: requestAnimationFrame(loop)
                };
            })
        };
    }
    // this module might have been imported after a drag has started
    // We are starting the auto scroller if we get an update event and
    // the auto scroller has not started yet
    function update(args) {
        if (state.type === 'idle') {
            start(args);
            return;
        }
        state.latestArgs = args;
    }
    // Not exposing a way to stop listening
    monitor({
        onDragStart: start,
        onDropTargetChange: update,
        onDrag: update,
        onDrop: reset
    });
    const api = {
        onFrame (fn) {
            callbacks.push(fn);
        }
    };
    return api;
}
module.exports["getScheduler"] = $d27a3192f501902b$export$5cff7ac265db316a;

});

parcelRegister("5Mj3f", function(module, exports) {
const $b507fa4d63a4635b$var$ledger = new Map();
const $b507fa4d63a4635b$var$requested = new Set();
function $b507fa4d63a4635b$export$8c764c3f2fc3d2d2(element) {
    $b507fa4d63a4635b$export$1cb7cbb266b6f6fa(element);
    const entry = $b507fa4d63a4635b$var$ledger.get(element);
    if (entry) return entry;
    const fresh = {
        timeOfEngagementStart: Date.now()
    };
    $b507fa4d63a4635b$var$ledger.set(element, fresh);
    return fresh;
}
function $b507fa4d63a4635b$export$1cb7cbb266b6f6fa(element) {
    $b507fa4d63a4635b$var$requested.add(element);
}
function $b507fa4d63a4635b$export$991e77dd347f3df1(fn) {
    // make sure previous engagement requests don't linger
    $b507fa4d63a4635b$var$requested.clear();
    // perform the required work
    fn();
    // if engagements where not requested, purge it
    $b507fa4d63a4635b$var$ledger.forEach((_, element)=>{
        if (!$b507fa4d63a4635b$var$requested.has(element)) $b507fa4d63a4635b$var$ledger.delete(element);
    });
    // cleaning up after ourselves
    $b507fa4d63a4635b$var$requested.clear();
}
function $b507fa4d63a4635b$export$13ae770ed39b71ea() {
    $b507fa4d63a4635b$var$ledger.clear();
}
module.exports["markAndGetEngagement"] = $b507fa4d63a4635b$export$8c764c3f2fc3d2d2;
module.exports["clearUnusedEngagements"] = $b507fa4d63a4635b$export$991e77dd347f3df1;
module.exports["clearEngagementHistory"] = $b507fa4d63a4635b$export$13ae770ed39b71ea;

});

parcelRegister("4SoL4", function(module, exports) {
const $35c4ac2061d5f133$export$4b152ab55cad4fd6 = 'data-auto-scrollable';
const $35c4ac2061d5f133$export$aea217a45095ce11 = `[${$35c4ac2061d5f133$export$4b152ab55cad4fd6}="true"]`;
function $35c4ac2061d5f133$export$4ec12fb57dfebd53(element) {
    element.setAttribute($35c4ac2061d5f133$export$4b152ab55cad4fd6, 'true');
    return ()=>element.removeAttribute($35c4ac2061d5f133$export$4b152ab55cad4fd6);
}
module.exports["selector"] = $35c4ac2061d5f133$export$aea217a45095ce11;
module.exports["addScrollableAttribute"] = $35c4ac2061d5f133$export$4ec12fb57dfebd53;

});

parcelRegister("1UuSE", function(module, exports) {

var $9r8oV = parcelRequire("9r8oV");


var $5Mj3f = parcelRequire("5Mj3f");


var $4SoL4 = parcelRequire("4SoL4");


var $j0x5d = parcelRequire("j0x5d");

function $c48f25f499b57242$var$isScrollingAvailable(value) {
    return Boolean(value.top || value.left);
}
function $c48f25f499b57242$var$tryScrollElements({ target: target, input: input, source: source, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, available: available = {
    top: true,
    left: true
} }) {
    // we cannot do any more scrolling
    if (!$c48f25f499b57242$var$isScrollingAvailable(available)) return available;
    // run out of parents to search
    if (!target) return available;
    const element = target.closest((0, $4SoL4.selector));
    // cannot find any more scroll containers
    if (!element) return available;
    const container = findEntry(element);
    // cannot find registration, this is bad.
    // fail and just exit
    if (!container) return available;
    function continueSearchUp() {
        return $c48f25f499b57242$var$tryScrollElements({
            target: element?.parentElement ?? null,
            findEntry: findEntry,
            source: source,
            timeSinceLastFrame: timeSinceLastFrame,
            input: input,
            available: available
        });
    }
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    // Engagement is not marked if scrolling is explicitly not allowed
    if (container.canScroll && !container.canScroll(feedback)) return continueSearchUp();
    // Marking engagement even if no edges are scrollable.
    // We are marking engagement as soon as the element is scrolled over
    const engagement = (0, $5Mj3f.markAndGetEngagement)(element);
    const config = (0, $9r8oV.getInternalConfig)(container.getConfiguration?.(feedback));
    const allowedAxis = container.getAllowedAxis?.(feedback) ?? 'all';
    const scrollBy = (0, $j0x5d.getScrollBy)({
        element: element,
        engagement: engagement,
        input: input,
        timeSinceLastFrame: timeSinceLastFrame,
        allowedAxis: allowedAxis,
        config: config
    });
    // Only allow scrolling in directions that have not already been used
    const scroll = {
        top: 0,
        left: 0
    };
    if (available.top && scrollBy.top !== 0) {
        scroll.top = scrollBy.top;
        // can no longer scroll on the top after this
        available.top = false;
    }
    if (available.left && scrollBy.left !== 0) {
        scroll.left = scrollBy.left;
        // can no longer scroll on the left after this
        available.left = false;
    }
    // Only scroll if there is something to scroll
    if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
    return continueSearchUp();
}
function $c48f25f499b57242$var$tryScrollWindow({ input: input, timeSinceLastFrame: timeSinceLastFrame, available: available, source: source, entries: entries }) {
    const element = document.documentElement;
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    for (const entry of entries){
        // this entry is not allowing scrolling, we need to look for another
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        // Note: if we had an event for when the user is leaving a tab
        // we _could_ conceptually reset the engagement
        const engagement = (0, $5Mj3f.markAndGetEngagement)(element);
        const config = (0, $9r8oV.getInternalConfig)(entry.getConfiguration?.(feedback));
        const allowedAxis = entry.getAllowedAxis?.(feedback) ?? 'all';
        const scrollBy = (0, $j0x5d.getScrollBy)({
            element: element,
            engagement: engagement,
            input: input,
            config: config,
            allowedAxis: allowedAxis,
            getRect: (element)=>DOMRect.fromRect({
                    y: 0,
                    x: 0,
                    width: element.clientWidth,
                    height: element.clientHeight
                }),
            timeSinceLastFrame: timeSinceLastFrame
        });
        const scroll = {
            top: available.top ? scrollBy.top : 0,
            left: available.left ? scrollBy.left : 0
        };
        // only trigger a scroll if we are actually scrolling
        if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
        break;
    }
}
function $c48f25f499b57242$export$233199807749476d({ input: input, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, source: source, getWindowScrollEntries: getWindowScrollEntries, underUsersPointer: underUsersPointer }) {
    // We are matching browser behaviour and scrolling inner elements
    // before outer ones. So we try to scroll scroller containers before
    // the window.
    const remainder = $c48f25f499b57242$var$tryScrollElements({
        target: underUsersPointer,
        timeSinceLastFrame: timeSinceLastFrame,
        input: input,
        source: source,
        findEntry: findEntry
    });
    // Check if we can do any window scrolling
    if (!$c48f25f499b57242$var$isScrollingAvailable(remainder)) return;
    $c48f25f499b57242$var$tryScrollWindow({
        input: input,
        source: source,
        entries: getWindowScrollEntries(),
        timeSinceLastFrame: timeSinceLastFrame,
        available: remainder
    });
}
module.exports["tryScroll"] = $c48f25f499b57242$export$233199807749476d;

});

parcelRegister("9r8oV", function(module, exports) {
const $a7ed1bcd13597f53$var$baseConfig = {
    startHitboxAtPercentageRemainingOfElement: {
        top: 0.25,
        right: 0.25,
        bottom: 0.25,
        left: 0.25
    },
    maxScrollAtPercentageRemainingOfHitbox: {
        top: 0.5,
        right: 0.5,
        bottom: 0.5,
        left: 0.5
    },
    timeDampeningDurationMs: 400,
    // Too big and it's too easy to trigger auto scrolling
    // Too small and it's too hard 😅
    maxMainAxisHitboxSize: 180
};
/** What the max scroll should be per second. Using "per second" rather than "per frame"
 * as we want a consistent scroll speed regardless of frame rate.
 *
 *
 * I explored trying to make the max scroll speed dynamic based on particular factors.
 * However, it ended up being difficult to find a _perfect_ formula.
 *
 * Likely the perfect answer would involve:
 * - the size of the scrollable element
 * - the size of the scrollable element relative to the screen size
 * - the size of the drag preview
 * - the size of elements being scrolled in scrollable elements (expensive and difficult to compute)
 */ const $a7ed1bcd13597f53$var$maxPixelScrollPerSecond = {
    // What the value would be if we were scrolling at 15px per frame at 60fps.
    // This is the default as it works well for most experiences.
    // In certain scenarios though it can feel a bit slow.
    standard: 900,
    // What the value would be if we were scrolling at 25px per frame at 60fps.
    // This is not the default as it feels too fast for a lot of experiences.
    fast: 1500
};
function $a7ed1bcd13597f53$export$e96028ec7ff9d079(provided) {
    return {
        ...$a7ed1bcd13597f53$var$baseConfig,
        // only allowing limited control over the config at this stage
        maxPixelScrollPerSecond: $a7ed1bcd13597f53$var$maxPixelScrollPerSecond[provided?.maxScrollSpeed ?? 'standard']
    };
}
module.exports["getInternalConfig"] = $a7ed1bcd13597f53$export$e96028ec7ff9d079;

});

parcelRegister("j0x5d", function(module, exports) {

var $4PtQA = parcelRequire("4PtQA");


var $iqmUH = parcelRequire("iqmUH");


var $lIDh1 = parcelRequire("lIDh1");


var $drwMb = parcelRequire("drwMb");


var $75xM4 = parcelRequire("75xM4");


var $jNg3h = parcelRequire("jNg3h");

function $510e86c1df38ba68$var$getRectDefault(element) {
    return element.getBoundingClientRect();
}
function $510e86c1df38ba68$export$6cfa6dfe6898b98f({ element: element, input: input, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, config: config, allowedAxis: allowedAxis, getRect: getRect = $510e86c1df38ba68$var$getRectDefault }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const clientRect = getRect(element);
    const scrollableEdges = (0, $iqmUH.edges).reduce((map, edge)=>{
        const hitbox = (0, $lIDh1.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        const axis = (0, $iqmUH.edgeAxisLookup)[edge];
        // Note: changing the allowed axis during a drag will not
        // reset time dampening. It was decided it would be too
        // complex to implement initially, and we can add it
        // later if needed.
        if (!(0, $75xM4.isAxisAllowed)(axis, allowedAxis)) return map;
        if (!(0, $jNg3h.isWithin)({
            client: client,
            clientRect: hitbox
        })) return map;
        if (!(0, $4PtQA.canScrollOnEdge)[edge](element)) return map;
        map.set(edge, {
            edge: edge,
            hitbox: hitbox
        });
        return map;
    }, new Map());
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = scrollableEdges.get('left');
        if (leftEdge) return (0, $drwMb.getScrollChange)({
            client: client,
            edge: leftEdge.edge,
            hitbox: leftEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const rightEdge = scrollableEdges.get('right');
        if (rightEdge) return (0, $drwMb.getScrollChange)({
            client: client,
            edge: rightEdge.edge,
            hitbox: rightEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = scrollableEdges.get('bottom');
        if (bottomEdge) return (0, $drwMb.getScrollChange)({
            client: client,
            edge: bottomEdge.edge,
            hitbox: bottomEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const topEdge = scrollableEdges.get('top');
        if (topEdge) return (0, $drwMb.getScrollChange)({
            client: client,
            edge: topEdge.edge,
            hitbox: topEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}
module.exports["getScrollBy"] = $510e86c1df38ba68$export$6cfa6dfe6898b98f;

});

parcelRegister("4PtQA", function(module, exports) {
const $5318802fe51175c6$export$ccd6d9407403fcad = {
    // Notes:
    //
    // 🌏 Chrome 115.0: uses fractional units for `scrollLeft` and `scrollTop`
    //    (and fractional units don't reach true integer maximum when zoomed in / out)
    // 🍎 Safari 16.5.2: no fractional units
    // 🦊 Firefox 115.0: no fractional units
    // we have some scroll we can move backwards into
    top: (element)=>element.scrollTop > 0,
    // We have some scroll we can move forward into
    right: (element)=>Math.ceil(element.scrollLeft) + element.clientWidth < element.scrollWidth,
    // We have some scroll we can move forwards into
    bottom: (element)=>Math.ceil(element.scrollTop) + element.clientHeight < element.scrollHeight,
    // we have some scroll we can move back into.
    left: (element)=>element.scrollLeft > 0
};
module.exports["canScrollOnEdge"] = $5318802fe51175c6$export$ccd6d9407403fcad;

});

parcelRegister("iqmUH", function(module, exports) {
const $abc8f89ed9b7940d$export$4544a00f8eb65eb2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $abc8f89ed9b7940d$export$7fc144124ccf8292 = {
    top: 'vertical',
    right: 'horizontal',
    bottom: 'vertical',
    left: 'horizontal'
};
module.exports["edges"] = $abc8f89ed9b7940d$export$4544a00f8eb65eb2;
module.exports["edgeAxisLookup"] = $abc8f89ed9b7940d$export$7fc144124ccf8292;

});

parcelRegister("lIDh1", function(module, exports) {

var $eU390 = parcelRequire("eU390");


var $k6QYd = parcelRequire("k6QYd");

function $516f0b1290892600$var$makeGetHitbox({ edge: edge, axis: axis }) {
    return function hitbox({ clientRect: clientRect, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $eU390.axisLookup)[axis];
        const side = (0, $k6QYd.mainAxisSideLookup)[edge];
        const mainAxisHitboxSize = Math.min(// scale the size of the hitbox down for smaller elements
        config.startHitboxAtPercentageRemainingOfElement[edge] * clientRect[mainAxis.size], // Don't let the hitbox grow too big for big elements
        config.maxMainAxisHitboxSize);
        return DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? clientRect[mainAxis.point] : clientRect[mainAxis.point] + clientRect[mainAxis.size] - mainAxisHitboxSize,
            [crossAxis.point]: clientRect[crossAxis.point],
            [mainAxis.size]: mainAxisHitboxSize,
            [crossAxis.size]: clientRect[crossAxis.size]
        });
    };
}
const $516f0b1290892600$export$b9a449c20abb0e9 = {
    top: $516f0b1290892600$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'top'
    }),
    right: $516f0b1290892600$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'right'
    }),
    bottom: $516f0b1290892600$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'bottom'
    }),
    left: $516f0b1290892600$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'left'
    })
};
module.exports["getOverElementHitbox"] = $516f0b1290892600$export$b9a449c20abb0e9;

});

parcelRegister("eU390", function(module, exports) {
const $5b0e1b1531f93246$var$vertical = {
    start: 'top',
    end: 'bottom',
    point: 'y',
    size: 'height'
};
const $5b0e1b1531f93246$var$horizontal = {
    start: 'left',
    end: 'right',
    point: 'x',
    size: 'width'
};
const $5b0e1b1531f93246$export$42e42cdab35a2b96 = {
    vertical: {
        mainAxis: $5b0e1b1531f93246$var$vertical,
        crossAxis: $5b0e1b1531f93246$var$horizontal
    },
    horizontal: {
        mainAxis: $5b0e1b1531f93246$var$horizontal,
        crossAxis: $5b0e1b1531f93246$var$vertical
    }
};
module.exports["axisLookup"] = $5b0e1b1531f93246$export$42e42cdab35a2b96;

});

parcelRegister("k6QYd", function(module, exports) {
const $51fdf9dde687ea21$export$a45c0cd714a4dbaa = {
    top: 'start',
    right: 'end',
    bottom: 'end',
    left: 'start'
};
module.exports["mainAxisSideLookup"] = $51fdf9dde687ea21$export$a45c0cd714a4dbaa;

});

parcelRegister("drwMb", function(module, exports) {

var $eU390 = parcelRequire("eU390");


var $fYr9O = parcelRequire("fYr9O");


var $k6QYd = parcelRequire("k6QYd");

// We want a consistent scroll speed across devices, regardless of framerate
function $4d516d91c431b939$var$getMaxScrollChange({ timeSinceLastFrame: timeSinceLastFrame, config: config }) {
    const targetScrollPerMs = config.maxPixelScrollPerSecond / 1000;
    // Adjusting out target scroll rate to match the frame rate of the target device
    // This will pull the scroll speed down on high frame rate devices
    // so we get a consistent visual scroll speed regardless of device.
    const proposed = Math.ceil(targetScrollPerMs * timeSinceLastFrame);
    // If lots of time as passed since that last frame (such on lower frame rate devices)
    // we don't want the scroll speed to be too fast, otherwise it can feel jumpy
    // We are capping the scroll speed at what it would be if we were hitting 60fps
    const maximum = config.maxPixelScrollPerSecond / 60;
    return Math.min(proposed, maximum);
}
function $4d516d91c431b939$var$getDistanceDampening({ client: client, axis: axis, edge: edge, hitbox: hitbox, config: config }) {
    const { mainAxis: mainAxis } = (0, $eU390.axisLookup)[axis];
    const side = (0, $k6QYd.mainAxisSideLookup)[edge];
    // We want to hit the max speed before the edge of the hitbox
    const maxSpeedBuffer = hitbox[mainAxis.size] * config.maxScrollAtPercentageRemainingOfHitbox[edge];
    if (side === 'end') return (0, $fYr9O.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start],
        endOfRange: hitbox[mainAxis.end] - maxSpeedBuffer,
        value: client[mainAxis.point]
    });
    // Moving towards start edge
    const raw = (0, $fYr9O.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start] + maxSpeedBuffer,
        endOfRange: hitbox[mainAxis.end],
        value: client[mainAxis.point]
    });
    // When moving near start edge
    // - the 'end' edge is where we start scrolling
    // - the 'start' edge is where we reach max speed
    // So we need to invert the percentage when moving backwards
    return 1 - raw;
}
function $4d516d91c431b939$export$470a2ff46db8cee8({ client: client, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, axis: axis, hitbox: hitbox, edge: edge, isDistanceDampeningEnabled: isDistanceDampeningEnabled, config: config }) {
    // We have two forms of speed dampening:
    // 1. 🗺️ Distance
    // The closer you are to a hitbox edge, the faster the scroll speed will be
    // 2. ⏱️ Time
    // When first entering a scroll container we want to dampening all scrolling
    // This is to prevent super fast auto scrolling when first entering into
    // a scroll container, or when lifting in a scroll container
    const maxScroll = $4d516d91c431b939$var$getMaxScrollChange({
        timeSinceLastFrame: timeSinceLastFrame,
        config: config
    });
    const percentageDistanceDampening = isDistanceDampeningEnabled ? $4d516d91c431b939$var$getDistanceDampening({
        client: client,
        edge: edge,
        hitbox: hitbox,
        axis: axis,
        config: config
    }) : 1;
    // Dampen speed by time
    const percentageThroughTimeDampening = (0, $fYr9O.getPercentageInRange)({
        startOfRange: engagement.timeOfEngagementStart,
        endOfRange: engagement.timeOfEngagementStart + config.timeDampeningDurationMs,
        value: Date.now()
    });
    // Calculate how much of the max scroll we should apply based on dampening
    const percentageOfMaxScroll = percentageDistanceDampening * percentageThroughTimeDampening;
    // We _could_ ease this update (`Math.pow(percentageOfMaxSpeed, 2)`)
    // But linear is feeling really good
    // Always scrolling by at least one pixel, otherwise the scroll does nothing
    const scroll = Math.max(maxScroll * percentageOfMaxScroll, 1);
    const side = (0, $k6QYd.mainAxisSideLookup)[edge];
    // When moving backwards, we will be scrolling backwards
    return side === 'end' ? scroll : -1 * scroll;
}
module.exports["getScrollChange"] = $4d516d91c431b939$export$470a2ff46db8cee8;

});

parcelRegister("fYr9O", function(module, exports) {
function $e40a4c0dcd17caec$export$1a29de000a332d74({ startOfRange: startOfRange, endOfRange: endOfRange, value: value }) {
    // checking inputs
    const isValid = startOfRange < endOfRange;
    if (!isValid) return 0;
    if (value < startOfRange) return 0;
    if (value > endOfRange) return 1;
    const range = endOfRange - startOfRange;
    return (value - startOfRange) / range;
}
module.exports["getPercentageInRange"] = $e40a4c0dcd17caec$export$1a29de000a332d74;

});

parcelRegister("75xM4", function(module, exports) {
function $21de06d925095ccb$export$7120fdbd90bd1292(axis, allowedAxis) {
    return allowedAxis === 'all' || axis === allowedAxis;
}
module.exports["isAxisAllowed"] = $21de06d925095ccb$export$7120fdbd90bd1292;

});

parcelRegister("jNg3h", function(module, exports) {
function $97331151dddf073e$export$cda7a9d4399bf2e3({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
module.exports["isWithin"] = $97331151dddf073e$export$cda7a9d4399bf2e3;

});

parcelRegister("6ojvx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

parcelRequire("bLswh");
var $hBxDy = parcelRequire("hBxDy");

const $59e5036a3fbf2e2e$export$6a671bebd9daad64 = (0, $cozmU.createContext)((0, $hBxDy.ProductEnvironment).PRODUCTION);
module.exports["EnvironmentContext"] = $59e5036a3fbf2e2e$export$6a671bebd9daad64;

});

parcelRegister("bLswh", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("hBxDy")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("hBxDy")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2zscg")).ExtensionEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2zscg")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2zscg")).JiraExtension);
parcelRequire("9iaDP");
var $2zscg = parcelRequire("2zscg");
var $hBxDy = parcelRequire("hBxDy");

parcelRequire("gwrSD");
var $hcYP2 = parcelRequire("hcYP2");
var $31kME = parcelRequire("31kME");
var $d8yi8 = parcelRequire("d8yi8");


});

parcelRegister("9iaDP", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("hBxDy")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("hBxDy")).ForgeCDNEnvironment);
$parcel$export(module.exports, "BitbucketExtension", () => (parcelRequire("2zscg")).BitbucketExtension);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2zscg")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2zscg")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2zscg")).JiraExtension);
$parcel$export(module.exports, "GlobalExtension", () => (parcelRequire("2zscg")).GlobalExtension);

var $2y56N = parcelRequire("2y56N");


var $hBxDy = parcelRequire("hBxDy");


var $iztBQ = parcelRequire("iztBQ");


var $2zscg = parcelRequire("2zscg");


});

parcelRegister("2y56N", function(module, exports) {
const $43f88a3108220757$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $43f88a3108220757$export$3ee8c58bb87b9685 = [
    ...$43f88a3108220757$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];

});

parcelRegister("hBxDy", function(module, exports) {
var $77348f0599087222$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $77348f0599087222$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $77348f0599087222$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $77348f0599087222$export$beaef1891b3e7ca3;

});

parcelRegister("iztBQ", function(module, exports) {
const $6db1db68019c99c9$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("gwrSD", function(module, exports) {

var $d8yi8 = parcelRequire("d8yi8");


var $31kME = parcelRequire("31kME");


var $hcYP2 = parcelRequire("hcYP2");


});

parcelRegister("d8yi8", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $487f0b3478e8e725$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $487f0b3478e8e725$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $487f0b3478e8e725$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $487f0b3478e8e725$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $487f0b3478e8e725$export$20b9f6acb0888554(effect) {
    return $487f0b3478e8e725$export$7e816460364ed464(effect) || $487f0b3478e8e725$export$eb5bd7f371e458af(effect) || $487f0b3478e8e725$export$f632ad3064955f31(effect);
}

});

parcelRegister("31kME", function(module, exports) {
const $7d3783c6a9539d7e$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $7d3783c6a9539d7e$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $7d3783c6a9539d7e$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $7d3783c6a9539d7e$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $7d3783c6a9539d7e$export$caa8cab0db5b0a61(effect) {
    return $7d3783c6a9539d7e$export$65d7078e01574f24(effect) || $7d3783c6a9539d7e$export$709a27a9f80556b8(effect) || $7d3783c6a9539d7e$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("hcYP2", function(module, exports) {
// From forge.ts
const $1da5394af23f0a63$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $1da5394af23f0a63$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $1da5394af23f0a63$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $1da5394af23f0a63$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $1da5394af23f0a63$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $1da5394af23f0a63$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $1da5394af23f0a63$export$881df9824c17587a = (extensionContext)=>extensionContext.type === 'confluence:attachmentAction';
const $1da5394af23f0a63$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $1da5394af23f0a63$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $1da5394af23f0a63$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $1da5394af23f0a63$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $1da5394af23f0a63$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("ix7El", function(module, exports) {
var $04c5b557f78447f3$export$d76ef0f862d061a6 = /*#__PURE__*/ function(GQLExtensionContextsFilterType) {
    GQLExtensionContextsFilterType["Container"] = "CONTAINER";
    GQLExtensionContextsFilterType["DataClassificationTag"] = "DATA_CLASSIFICATION_TAG";
    GQLExtensionContextsFilterType["ExtensionType"] = "EXTENSION_TYPE";
    GQLExtensionContextsFilterType["PrincipalType"] = "PRINCIPAL_TYPE";
    GQLExtensionContextsFilterType["AppIdEnvironmentId"] = "APP_ID_ENVIRONMENT_ID";
    return GQLExtensionContextsFilterType;
}({});
const $04c5b557f78447f3$export$1a949ef92fd30eca = (error)=>{
    return error instanceof Error && error.name === 'RelayNetwork' && 'source' in error && Array.isArray(error.source?.errors);
};
const $04c5b557f78447f3$export$8d1c210bc17223c1 = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'GRAPHQL_GATEWAY';
const $04c5b557f78447f3$export$9c0545f564a8227f = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'UNDERLYING_SERVICE';
module.exports["GQLExtensionContextsFilterType"] = $04c5b557f78447f3$export$d76ef0f862d061a6;
module.exports["isRelayNetworkError"] = $04c5b557f78447f3$export$1a949ef92fd30eca;
module.exports["isGQLGatewayError"] = $04c5b557f78447f3$export$8d1c210bc17223c1;
module.exports["isGQLUnderlyingServiceError"] = $04c5b557f78447f3$export$9c0545f564a8227f;

});

parcelRegister("4K6lC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $852mP = parcelRequire("852mP");


var $3d3WW = parcelRequire("3d3WW");


var $cXtTj = parcelRequire("cXtTj");

const $a3a18abb8f8abee5$export$d28801614368e543 = 'forge-ui';
const $a3a18abb8f8abee5$export$7329bcdc3edcd90e = (client)=>(event)=>{
        switch(event.eventType){
            case 0, $852mP.UI_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendUIEvent(event));
                break;
            case 0, $852mP.OPERATIONAL_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendOperationalEvent(event));
                break;
            case 0, $852mP.TRACK_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendTrackEvent(event));
                break;
            case 0, $852mP.SCREEN_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendScreenEvent(event));
                break;
        }
    };
/** extract the attributes from event context which should be in the top-level payload */ function $a3a18abb8f8abee5$var$getPayloadAttributesFromContext(contexts) {
    return (contexts.find((obj)=>obj && obj.forgeUIAnalyticsContext) ?? {}).forgeUIAnalyticsContext ?? {};
}
// Merge forgeUIAttributes from outermost to innermost analytics contexts, so child contexts can
// override parent values in the final payload. If an inner context replaces extensionKey, keep the
// previous extensionKey separately so embedded macro events can report it as parentExtensionKey.
function $a3a18abb8f8abee5$var$getForgeUIAttributesFromContext(contexts) {
    return contexts.reduce((prev, curr)=>{
        // Only extract attributes passed as an object via the forgeUIAttributes key
        const forgeUIAttributes = curr && curr.forgeUIAttributes && typeof curr.forgeUIAttributes === 'object' ? curr.forgeUIAttributes : {};
        const previousExtensionKey = prev.forgeUIAttributes.extensionKey;
        const nextExtensionKey = forgeUIAttributes.extensionKey;
        const isExtensionKeyOverridden = Boolean(previousExtensionKey && nextExtensionKey && previousExtensionKey !== nextExtensionKey);
        // Capture the first extensionKey that gets replaced by a nested context. That replaced
        // value is the parent macro key once a child renderer context contributes its own key.
        const overriddenExtensionKey = prev.overriddenExtensionKey ?? (isExtensionKeyOverridden ? previousExtensionKey : undefined);
        return {
            forgeUIAttributes: {
                ...prev.forgeUIAttributes,
                ...forgeUIAttributes
            },
            overriddenExtensionKey: overriddenExtensionKey
        };
    }, {
        forgeUIAttributes: {}
    });
}
const $a3a18abb8f8abee5$var$ForgeUIAnalyticsListener = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, client: client, commonAttributes: t1 } = t0;
    let t2;
    if ($[0] !== t1) {
        t2 = t1 === undefined ? {} : t1;
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const commonAttributes = t2;
    let t3;
    if ($[2] !== client || $[3] !== commonAttributes) {
        t3 = (event)=>{
            const { eventType: eventType, data: data } = event.payload;
            const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, tags: tags, source: sourceFromEvent } = data;
            const forgeUIAnalyticsContext = $a3a18abb8f8abee5$var$getPayloadAttributesFromContext(event.context);
            const source = sourceFromEvent ?? forgeUIAnalyticsContext.source ?? "unknown";
            let nestingAnalyticsAttributes;
            if ((0, $cXtTj.default).getExperimentValue("platform_forge_nesting_analytics", "isEnabled", false)) {
                const { forgeUIAttributes: forgeUIAttributes, overriddenExtensionKey: overriddenExtensionKey } = $a3a18abb8f8abee5$var$getForgeUIAttributesFromContext(event.context);
                let parentExtensionKey = {};
                if (action === "rendered" && actionSubject === "forge.ui.renderer" && forgeUIAttributes.isEmbeddedMacro && overriddenExtensionKey) parentExtensionKey = {
                    parentExtensionKey: overriddenExtensionKey
                };
                else if (action === "rendered" && actionSubject === "forge.ui.bodied_macro_embedded_content" && attributes?.extensionKey && forgeUIAttributes.extensionKey) parentExtensionKey = {
                    parentExtensionKey: forgeUIAttributes.extensionKey
                };
                nestingAnalyticsAttributes = {
                    ...forgeUIAttributes,
                    ...parentExtensionKey
                };
            }
            const payload = {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                ...forgeUIAnalyticsContext,
                source: source,
                attributes: {
                    ...commonAttributes,
                    ...nestingAnalyticsAttributes ?? event.context.reduce($a3a18abb8f8abee5$var$_temp, {}),
                    ...attributes
                },
                tags: tags
            };
            $a3a18abb8f8abee5$export$7329bcdc3edcd90e(client)({
                eventType: eventType,
                ...payload
            });
        };
        $[2] = client;
        $[3] = commonAttributes;
        $[4] = t3;
    } else t3 = $[4];
    const listenerHandler = t3;
    let t4;
    if ($[5] !== children || $[6] !== listenerHandler) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
            onEvent: listenerHandler,
            channel: $a3a18abb8f8abee5$export$d28801614368e543
        }, children);
        $[5] = children;
        $[6] = listenerHandler;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ children: children, client: client, commonAttributes: commonAttributes = {} })=>{
    const listenerHandler = (event)=>{
        const { eventType: eventType, data: data } = event.payload;
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, tags: tags, source: sourceFromEvent } = data;
        const forgeUIAnalyticsContext = $a3a18abb8f8abee5$var$getPayloadAttributesFromContext(event.context);
        const source = sourceFromEvent ?? forgeUIAnalyticsContext.source ?? 'unknown';
        // Use the merged nested context attributes and add parentExtensionKey for embedded macro
        // events that override extensionKey.
        let nestingAnalyticsAttributes;
        if ((0, $cXtTj.default).getExperimentValue('platform_forge_nesting_analytics', 'isEnabled', false)) {
            const { forgeUIAttributes: forgeUIAttributes, overriddenExtensionKey: overriddenExtensionKey } = $a3a18abb8f8abee5$var$getForgeUIAttributesFromContext(event.context);
            let parentExtensionKey = {};
            if (action === 'rendered' && actionSubject === 'forge.ui.renderer' && forgeUIAttributes.isEmbeddedMacro && overriddenExtensionKey) // Child Forge renderer contexts replace extensionKey with the child macro key, so the
            // parent key is the previous extensionKey captured during context merging.
            parentExtensionKey = {
                parentExtensionKey: overriddenExtensionKey
            };
            else if (action === 'rendered' && actionSubject === 'forge.ui.bodied_macro_embedded_content' && attributes?.extensionKey && forgeUIAttributes.extensionKey) // Embedded macro events carry the child macro key on the event attributes, while the
            // surrounding context still carries the parent macro extensionKey.
            parentExtensionKey = {
                parentExtensionKey: forgeUIAttributes.extensionKey
            };
            nestingAnalyticsAttributes = {
                ...forgeUIAttributes,
                ...parentExtensionKey
            };
        }
        const payload = {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            ...forgeUIAnalyticsContext,
            source: source,
            attributes: {
                ...commonAttributes,
                ...nestingAnalyticsAttributes ?? event.context.reduce((prev, curr)=>{
                    // Only extract attributes passed as an object via the forgeUIAttributes key
                    const forgeUIAttributes_0 = curr && curr.forgeUIAttributes && typeof curr.forgeUIAttributes === 'object' ? curr.forgeUIAttributes : {};
                    return {
                        ...prev,
                        ...forgeUIAttributes_0
                    };
                }, {}),
                ...attributes
            },
            tags: tags
        };
        $a3a18abb8f8abee5$export$7329bcdc3edcd90e(client)({
            eventType: eventType,
            ...payload
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: listenerHandler,
        channel: $a3a18abb8f8abee5$export$d28801614368e543
    }, children);
};
var $a3a18abb8f8abee5$export$2e2bcd8739ae039 = $a3a18abb8f8abee5$var$ForgeUIAnalyticsListener;
function $a3a18abb8f8abee5$var$_temp(prev, curr) {
    const forgeUIAttributes_0 = curr && curr.forgeUIAttributes && typeof curr.forgeUIAttributes === "object" ? curr.forgeUIAttributes : {};
    return {
        ...prev,
        ...forgeUIAttributes_0
    };
}
module.exports["FORGE_UI_ANALYTICS_CHANNEL"] = $a3a18abb8f8abee5$export$d28801614368e543;
module.exports["sendEvent"] = $a3a18abb8f8abee5$export$7329bcdc3edcd90e;
module.exports["default"] = $a3a18abb8f8abee5$export$2e2bcd8739ae039;

});

parcelRegister("DIyeF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5xQdV = parcelRequire("5xQdV");


var $6ojvx = parcelRequire("6ojvx");

const $5577a309d6f3499e$export$b438ce9ad9530ae5 = /*#__PURE__*/ (0, $cozmU.createContext)({
    environment: undefined,
    product: '',
    page: ''
});
const $5577a309d6f3499e$export$163ecee29aa3a8f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { value: value, children: children } = t0;
    const envFromContext = (0, $cozmU.useContext)((0, $6ojvx.EnvironmentContext));
    const { product: product, page: page, environment: environment } = value;
    let t1;
    let t2;
    if ($[0] !== envFromContext || $[1] !== environment || $[2] !== page || $[3] !== product) {
        t1 = ()=>({
                environment: environment ?? envFromContext,
                product: product,
                page: page
            });
        t2 = [
            page,
            environment,
            envFromContext,
            product
        ];
        $[0] = envFromContext;
        $[1] = environment;
        $[2] = page;
        $[3] = product;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    const memoedValue = (0, $5xQdV.useMemoOne)(t1, t2);
    let t3;
    if ($[6] !== children || $[7] !== memoedValue) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5577a309d6f3499e$export$b438ce9ad9530ae5.Provider, {
            value: memoedValue
        }, children);
        $[6] = children;
        $[7] = memoedValue;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ value: value, children: children })=>{
    const envFromContext = (0, $cozmU.useContext)((0, $6ojvx.EnvironmentContext));
    const { product: product, page: page, environment: environment } = value;
    const memoedValue = (0, $5xQdV.useMemoOne)(()=>{
        return {
            environment: environment ?? envFromContext,
            product: product,
            page: page
        };
    }, [
        page,
        environment,
        envFromContext,
        product
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5577a309d6f3499e$export$b438ce9ad9530ae5.Provider, {
        value: memoedValue
    }, children);
};
const $5577a309d6f3499e$export$dba2dab0d0f39612 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($5577a309d6f3499e$export$b438ce9ad9530ae5);
} : ()=>{
    return (0, $cozmU.useContext)($5577a309d6f3499e$export$b438ce9ad9530ae5);
};
module.exports["MetricsContext"] = $5577a309d6f3499e$export$b438ce9ad9530ae5;
module.exports["MetricsContextProvider"] = $5577a309d6f3499e$export$163ecee29aa3a8f;
module.exports["useMetricsContext"] = $5577a309d6f3499e$export$dba2dab0d0f39612;

});

parcelRegister("iGKcz", function(module, exports) {
// our service
const $fa265340e5382bcc$var$SERVICE = 'forge-ui';
const $fa265340e5382bcc$export$14ef296862e3705e = (workspaceAri)=>{
    return JSON.stringify({
        atlWorkspaceAri: workspaceAri,
        service: $fa265340e5382bcc$var$SERVICE
    });
};
module.exports["createAtlAttributionHeader"] = $fa265340e5382bcc$export$14ef296862e3705e;

});

parcelRegister("2rD5H", function(module, exports) {

var $iLX84 = parcelRequire("iLX84");


var $iDrrr = parcelRequire("iDrrr");

const $2571750a7eec7dec$var$convertDataClassificationTagsToString = (dataClassificationTagIds)=>{
    return `[
    ${dataClassificationTagIds.map((id)=>`"${id}"`).join(', ')}
  ]`;
};
const $2571750a7eec7dec$export$b4649e379af92913 = (expandAppOwner, moduleTypes, dataClassificationTagIds)=>{
    const modules = moduleTypes?.map((m)=>`"${m}"`) || [
        '$type'
    ];
    const userAccessField = (0, $iDrrr.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!${moduleTypes ? '' : ', $type: String!'}, $locale: String) {
    extensionContexts(contextIds: $contextIds) {
      id
      ${modules.map((m)=>`
        extensionsByType(type: ${m}, locale: $locale ) {
          id
          appId
          key
          ${expandAppOwner ? `appOwner {
            name
          }` : ''}
          environmentId
          environmentType
          environmentKey
          properties
          license {
            active
            type
            supportEntitlementNumber
            trialEndDate
            subscriptionEndDate
            isEvaluation
            billingPeriod
            ccpEntitlementId
            ccpEntitlementSlug
						capabilitySet
            modes
          }
          ${userAccessField}
          type
          appVersion
          installationId
          migrationKey
					installationConfig {
						key
						value
					}
          egress {
            type
            addresses
						category
						inScopeEUD
          }
					sandboxPolicies
					scopes
					consentUrl
					currentUserConsent {
						user {
							aaid
						}
						appEnvironmentVersion {
							id
						}
						consentedAt
					}
					requiresUserConsent
          ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
                dataClassificationPolicyDecision(input: {
                  dataClassificationTags: ${$2571750a7eec7dec$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
                }) {
                  status
                }
              ` : ''}
        }`).join('')}
    }
  }`;
    return (0, $iLX84.default)`${query}`;
};
const $2571750a7eec7dec$export$23f6ad93bea7724 = (expandAppOwner, dataClassificationTagIds)=>{
    const userAccessField = (0, $iDrrr.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!, $filter: [ExtensionContextsFilter!]!, $locale: String ) {
    extensionContexts(contextIds: $contextIds) {
      id
      extensions(filter: $filter, locale: $locale) @optIn(to: "Access-Narrowing") {
        id
        appId
        key
        ${expandAppOwner ? `appOwner {
          name
        }` : ''}
        environmentId
        environmentType
        environmentKey
        properties
        license {
          active
          type
          supportEntitlementNumber
          trialEndDate
          subscriptionEndDate
          isEvaluation
          billingPeriod
          ccpEntitlementId
          ccpEntitlementSlug
					capabilitySet
          modes
        }
        ${userAccessField}
        type
        appVersion
        installationId
        migrationKey
				installationConfig {
					key
					value
				}
        egress {
          type
          addresses
					category
					inScopeEUD
        }
				sandboxPolicies
				scopes
				consentUrl
				currentUserConsent {
					user {
						aaid
					}
					appEnvironmentVersion {
						id
					}
					consentedAt
				}
				requiresUserConsent
        ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
              dataClassificationPolicyDecision(input: {
                dataClassificationTags: ${$2571750a7eec7dec$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
              }) {
                status
              }
            ` : ''}
      },
    }
  }`;
    return (0, $iLX84.default)`${query}`;
};
const $2571750a7eec7dec$export$54ff27488d768aba = (0, $iLX84.default)`query FetchPreFilteredForgeAppsQuery($cloudId:ID!$context:ConfluenceExtensionRenderingContextInput$includeHidden:Boolean$locale:String$types:[String]){confluence_forgeExtensionsByType(cloudId:$cloudId context:$context includeHidden:$includeHidden locale:$locale types:$types){id appId appVersion appOwner environmentId environmentType environmentKey consentUrl migrationKey userAccess{enabled hasAccess}key properties{key value}egress{addresses category type inScopeEUD}sandboxPolicies scopes license{active capabilitySet billingPeriod ccpEntitlementId ccpEntitlementSlug isEvaluation subscriptionEndDate trialEndDate type}type installationId hiddenBy}}`;
module.exports["getExtensionListQueryOld"] = $2571750a7eec7dec$export$b4649e379af92913;
module.exports["getExtensionListQuery"] = $2571750a7eec7dec$export$23f6ad93bea7724;
module.exports["FetchPreFilteredForgeAppsQuery"] = $2571750a7eec7dec$export$54ff27488d768aba;

});

parcelRegister("hzmpb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $gGKeL = parcelRequire("gGKeL");


var $cozmU = parcelRequire("cozmU");


var $7EPz1 = parcelRequire("7EPz1");


var $6SsN4 = parcelRequire("6SsN4");


var $852mP = parcelRequire("852mP");


var $9DHhW = parcelRequire("9DHhW");


var $4K6lC = parcelRequire("4K6lC");


var $DIyeF = parcelRequire("DIyeF");


var $iGKcz = parcelRequire("iGKcz");


var $ix7El = parcelRequire("ix7El");


var $2rD5H = parcelRequire("2rD5H");


var $jGizm = parcelRequire("jGizm");

const $c7be4ab3ad813948$export$7f11ec46a05c7477 = (cloudId, context, client, types, locale, includeHidden, queryOptions, contextIds = [
    cloudId
])=>{
    const variables = {
        cloudId: cloudId,
        context: context,
        includeHidden: includeHidden ?? false,
        types: types,
        locale: locale
    };
    return {
        variables: variables,
        ...queryOptions,
        client: client,
        /**
     * We don't want to set 'ignore' because that discards errors and we need to inspect
     * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
     * https://www.apollographql.com/docs/react/data/error-handling/
     */ errorPolicy: 'all',
        context: {
            headers: {
                'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)([
                    ...contextIds
                ].sort().join())
            },
            allowOnExternalPage: true
        }
    };
};
const $c7be4ab3ad813948$export$88e0391b02a3c5c9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, client: client, queryOptions: queryOptions } = t0;
    let t1;
    if ($[0] !== client || $[1] !== cloudId || $[2] !== context || $[3] !== includeHidden || $[4] !== locale || $[5] !== queryOptions || $[6] !== types) {
        t1 = $c7be4ab3ad813948$export$7f11ec46a05c7477(cloudId, context, client, types, locale, includeHidden, queryOptions);
        $[0] = client;
        $[1] = cloudId;
        $[2] = context;
        $[3] = includeHidden;
        $[4] = locale;
        $[5] = queryOptions;
        $[6] = types;
        $[7] = t1;
    } else t1 = $[7];
    const requestOptions = t1;
    const { error: error, loading: loading, data: data } = (0, $7EPz1.useQuery)((0, $2rD5H.FetchPreFilteredForgeAppsQuery), requestOptions);
    let t2;
    if ($[8] !== data || $[9] !== loading) {
        t2 = $c7be4ab3ad813948$export$55348c7eb6377fe1({
            loading: loading,
            data: data
        });
        $[8] = data;
        $[9] = loading;
        $[10] = t2;
    } else t2 = $[10];
    const extensions = t2;
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t3;
    let t4;
    if ($[11] !== createAnalyticsEvent || $[12] !== extensions || $[13] !== page) {
        t3 = ()=>{
            if (extensions) createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: "succeeded",
                    actionSubject: "forge.ui.webClient",
                    source: page,
                    tags: [
                        "forge"
                    ],
                    attributes: {
                        target: "usePrefilteredExtensionList"
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        };
        t4 = [
            extensions,
            page,
            createAnalyticsEvent
        ];
        $[11] = createAnalyticsEvent;
        $[12] = extensions;
        $[13] = page;
        $[14] = t3;
        $[15] = t4;
    } else {
        t3 = $[14];
        t4 = $[15];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[16] !== createAnalyticsEvent || $[17] !== error || $[18] !== extensions || $[19] !== page) {
        t5 = ()=>{
            if (!extensions && error && error.graphQLErrors.length > 0) {
                const err_0 = error.graphQLErrors.find($c7be4ab3ad813948$var$_temp);
                createAnalyticsEvent({
                    eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                    data: {
                        action: "failed",
                        actionSubject: "forge.ui.webClient",
                        source: page,
                        tags: [
                            "forge"
                        ],
                        attributes: {
                            target: "usePrefilteredExtensionList",
                            errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? "componentApi" : "componentGraphQL" : "uncaught"
                        }
                    }
                }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
            }
        };
        t6 = [
            extensions,
            error,
            page,
            createAnalyticsEvent
        ];
        $[16] = createAnalyticsEvent;
        $[17] = error;
        $[18] = extensions;
        $[19] = page;
        $[20] = t5;
        $[21] = t6;
    } else {
        t5 = $[20];
        t6 = $[21];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[22] !== extensions) {
        t7 = extensions || [];
        $[22] = extensions;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== error || $[25] !== loading || $[26] !== t7) {
        t8 = {
            error: error,
            extensions: t7,
            loading: loading
        };
        $[24] = error;
        $[25] = loading;
        $[26] = t7;
        $[27] = t8;
    } else t8 = $[27];
    return t8;
} : ({ cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, client: client, queryOptions: queryOptions })=>{
    const requestOptions = $c7be4ab3ad813948$export$7f11ec46a05c7477(cloudId, context, client, types, locale, includeHidden, queryOptions);
    const { error: error, loading: loading, data: data } = (0, $7EPz1.useQuery)((0, $2rD5H.FetchPreFilteredForgeAppsQuery), requestOptions);
    const extensions = $c7be4ab3ad813948$export$55348c7eb6377fe1({
        loading: loading,
        data: data
    });
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'usePrefilteredExtensionList'
                }
            }
        }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && error.graphQLErrors.length > 0) {
            const err_0 = error.graphQLErrors.find((err)=>(0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'usePrefilteredExtensionList',
                        errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        error: error,
        extensions: extensions || [],
        loading: loading
    };
};
const $c7be4ab3ad813948$export$55348c7eb6377fe1 = ({ loading: loading, data: data })=>{
    const extensions = data?.confluence_forgeExtensionsByType || [];
    if (!loading && extensions.length > 0) return (0, $jGizm.transformPreFilteredExtensions)(extensions);
    return null;
};
const $c7be4ab3ad813948$var$fetchRequests = new Map();
const $c7be4ab3ad813948$export$f55e1916fecb1860 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types } = t0;
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const [extensions, setExtensions] = (0, $cozmU.useState)(null);
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    let t2;
    if ($[0] !== cloudId || $[1] !== context || $[2] !== environment || $[3] !== includeHidden || $[4] !== locale || $[5] !== types) {
        t1 = ()=>{
            const cacheKey = JSON.stringify({
                cloudId: cloudId,
                context: context,
                includeHidden: includeHidden,
                locale: locale,
                types: types
            });
            if (!$c7be4ab3ad813948$var$fetchRequests.has(cacheKey)) {
                const extensions_0 = new Promise((resolve, reject)=>{
                    (0, $6SsN4.fetchQuery)(environment, (0, $gGKeL.default), {
                        cloudId: cloudId,
                        context: context,
                        includeHidden: includeHidden,
                        locale: locale,
                        types: types
                    }, {
                        networkCacheConfig: {
                            metadata: {
                                headers: {
                                    "atl-attribution": (0, $iGKcz.createAtlAttributionHeader)(cloudId)
                                },
                                allowOnExternalPage: true
                            }
                        }
                    }).subscribe({
                        next: (data)=>{
                            resolve($c7be4ab3ad813948$export$55348c7eb6377fe1({
                                data: data,
                                loading: false
                            }));
                        },
                        error: (error_0)=>{
                            $c7be4ab3ad813948$var$fetchRequests.delete(cacheKey);
                            reject(error_0);
                        }
                    });
                });
                $c7be4ab3ad813948$var$fetchRequests.set(cacheKey, extensions_0);
            }
            $c7be4ab3ad813948$var$fetchRequests.get(cacheKey).then((extensions_1)=>{
                setExtensions(extensions_1);
                setLoading(false);
            }).catch((error_1)=>{
                setError(error_1);
                setLoading(false);
            });
        };
        t2 = [
            cloudId,
            context,
            includeHidden,
            locale,
            types,
            environment
        ];
        $[0] = cloudId;
        $[1] = context;
        $[2] = environment;
        $[3] = includeHidden;
        $[4] = locale;
        $[5] = types;
        $[6] = t1;
        $[7] = t2;
    } else {
        t1 = $[6];
        t2 = $[7];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[8] !== createAnalyticsEvent || $[9] !== extensions || $[10] !== page) {
        t3 = ()=>{
            if (extensions) createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: "succeeded",
                    actionSubject: "forge.ui.webClient",
                    source: page,
                    tags: [
                        "forge"
                    ],
                    attributes: {
                        target: "usePrefilteredExtensionList"
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        };
        t4 = [
            extensions,
            page,
            createAnalyticsEvent
        ];
        $[8] = createAnalyticsEvent;
        $[9] = extensions;
        $[10] = page;
        $[11] = t3;
        $[12] = t4;
    } else {
        t3 = $[11];
        t4 = $[12];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[13] !== createAnalyticsEvent || $[14] !== error || $[15] !== extensions || $[16] !== page) {
        t5 = ()=>{
            if (!extensions && error && (0, $ix7El.isRelayNetworkError)(error)) {
                const err_0 = error.source.errors.find($c7be4ab3ad813948$var$_temp2);
                createAnalyticsEvent({
                    eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                    data: {
                        action: "failed",
                        actionSubject: "forge.ui.webClient",
                        source: page,
                        tags: [
                            "forge"
                        ],
                        attributes: {
                            target: "useExtensionList",
                            errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? "componentApi" : "componentGraphQL" : "uncaught"
                        }
                    }
                }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
            }
        };
        t6 = [
            extensions,
            error,
            page,
            createAnalyticsEvent
        ];
        $[13] = createAnalyticsEvent;
        $[14] = error;
        $[15] = extensions;
        $[16] = page;
        $[17] = t5;
        $[18] = t6;
    } else {
        t5 = $[17];
        t6 = $[18];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[19] !== extensions) {
        t7 = extensions || [];
        $[19] = extensions;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== error || $[22] !== loading || $[23] !== t7) {
        t8 = {
            extensions: t7,
            loading: loading,
            error: error
        };
        $[21] = error;
        $[22] = loading;
        $[23] = t7;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
} : ({ cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types })=>{
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const [extensions, setExtensions] = (0, $cozmU.useState)(null);
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const cacheKey = JSON.stringify({
            cloudId: cloudId,
            context: context,
            includeHidden: includeHidden,
            locale: locale,
            types: types
        });
        if (!$c7be4ab3ad813948$var$fetchRequests.has(cacheKey)) {
            const extensions_0 = new Promise((resolve, reject)=>{
                (0, $6SsN4.fetchQuery)(environment, (0, $gGKeL.default), {
                    cloudId: cloudId,
                    context: // @ts-ignore - the generated types convert GQL Long to a number, which may truncate the id. The type will be changed to string
                    context,
                    includeHidden: includeHidden,
                    locale: locale,
                    types: types
                }, {
                    networkCacheConfig: {
                        metadata: {
                            headers: {
                                'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)(cloudId)
                            },
                            allowOnExternalPage: true
                        }
                    }
                }).subscribe({
                    next: (data)=>{
                        resolve($c7be4ab3ad813948$export$55348c7eb6377fe1({
                            data: data,
                            loading: false
                        }));
                    },
                    error: (error_0)=>{
                        $c7be4ab3ad813948$var$fetchRequests.delete(cacheKey);
                        reject(error_0);
                    }
                });
            });
            $c7be4ab3ad813948$var$fetchRequests.set(cacheKey, extensions_0);
        }
        $c7be4ab3ad813948$var$fetchRequests.get(cacheKey).then((extensions_1)=>{
            setExtensions(extensions_1);
            setLoading(false);
        }).catch((error_1)=>{
            setError(error_1);
            setLoading(false);
        });
    }, [
        cloudId,
        context,
        includeHidden,
        locale,
        types,
        environment
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'usePrefilteredExtensionList'
                }
            }
        }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && (0, $ix7El.isRelayNetworkError)(error)) {
            const err_0 = error.source.errors.find((err)=>(0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'useExtensionList',
                        errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        extensions: extensions || [],
        loading: loading,
        error: error
    };
};
function $c7be4ab3ad813948$var$_temp(err) {
    return (0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err);
}
function $c7be4ab3ad813948$var$_temp2(err) {
    return (0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err);
}
module.exports["createUsePrefilteredExtensionListQueryOptions"] = $c7be4ab3ad813948$export$7f11ec46a05c7477;
module.exports["usePrefilteredExtensionList"] = $c7be4ab3ad813948$export$88e0391b02a3c5c9;
module.exports["getPrefilteredExtensionsGQLResult"] = $c7be4ab3ad813948$export$55348c7eb6377fe1;
module.exports["usePrefilteredExtensionListRelay"] = $c7be4ab3ad813948$export$f55e1916fecb1860;

});

parcelRegister("gGKeL", function(module, exports) {
/**
 * @generated SignedSource<<0f5c3c24344d3900f0ac53d7aab68fae>>
 * @relayHash 3c7314efdc53f274caf83358ee897ee6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 904e5a459b011295a8e77317b65201f644f4b1769c4e8d76d1712b4870225d5e
const $57d2af88a889106f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "context"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeHidden"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "types"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "key"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "context",
                    "variableName": "context"
                },
                {
                    "kind": "Variable",
                    "name": "includeHidden",
                    "variableName": "includeHidden"
                },
                {
                    "kind": "Variable",
                    "name": "locale",
                    "variableName": "locale"
                },
                {
                    "kind": "Variable",
                    "name": "types",
                    "variableName": "types"
                }
            ],
            "concreteType": "ConfluenceForgeExtension",
            "kind": "LinkedField",
            "name": "confluence_forgeExtensionsByType",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "appId"
                },
                {
                    "kind": "ScalarField",
                    "name": "appVersion"
                },
                {
                    "kind": "ScalarField",
                    "name": "appOwner"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentType"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "consentUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "migrationKey"
                },
                {
                    "concreteType": "ConfluenceUserAccess",
                    "kind": "LinkedField",
                    "name": "userAccess",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "enabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasAccess"
                        }
                    ]
                },
                v1 /*: any*/ ,
                {
                    "concreteType": "KeyValueHierarchyMap",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceExtensionEgressDeclaration",
                    "kind": "LinkedField",
                    "name": "egress",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "addresses"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "inScopeEUD"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "sandboxPolicies"
                },
                {
                    "kind": "ScalarField",
                    "name": "scopes"
                },
                {
                    "concreteType": "ConfluenceAppInstallationLicense",
                    "kind": "LinkedField",
                    "name": "license",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "active"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "capabilitySet"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "billingPeriod"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementSlug"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isEvaluation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionEndDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "trialEndDate"
                        },
                        v2 /*: any*/ 
                    ]
                },
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "installationId"
                },
                {
                    "kind": "ScalarField",
                    "name": "hiddenBy"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "id": "904e5a459b011295a8e77317b65201f644f4b1769c4e8d76d1712b4870225d5e",
            "metadata": {},
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$57d2af88a889106f$var$node.hash = "1b992f547bdf43b63a7ddd13074a26b2";
var $57d2af88a889106f$export$2e2bcd8739ae039 = $57d2af88a889106f$var$node;
module.exports["default"] = $57d2af88a889106f$export$2e2bcd8739ae039;

});

parcelRegister("4ewzf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4K6lC = parcelRequire("4K6lC");


var $6ojvx = parcelRequire("6ojvx");

var $DIyeF = parcelRequire("DIyeF");

const $4d5d83f604ebdb2f$export$64f0f7e9be5f8ff = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { analyticsWebClient: analyticsWebClient, environment: environment, product: product, page: page, children: children } = t0;
    let t1;
    if ($[0] !== page || $[1] !== product) {
        t1 = {
            product: product,
            page: page
        };
        $[0] = page;
        $[1] = product;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== page) {
        t2 = {
            moduleType: page
        };
        $[3] = page;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== analyticsWebClient || $[6] !== children || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4K6lC.default), {
            client: analyticsWebClient,
            commonAttributes: t2
        }, children);
        $[5] = analyticsWebClient;
        $[6] = children;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== t1 || $[10] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $DIyeF.MetricsContextProvider), {
            value: t1
        }, t3);
        $[9] = t1;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== environment || $[13] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ojvx.EnvironmentContext).Provider, {
            value: environment
        }, t4);
        $[12] = environment;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
} : ({ analyticsWebClient: analyticsWebClient, environment: environment, product: product, page: page, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ojvx.EnvironmentContext).Provider, {
        value: environment
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $DIyeF.MetricsContextProvider), {
        value: {
            product: product,
            page: page
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4K6lC.default), {
        client: analyticsWebClient,
        commonAttributes: {
            moduleType: page
        }
    }, children)));
};
module.exports["ForgeUIExtensionPointProvider"] = $4d5d83f604ebdb2f$export$64f0f7e9be5f8ff;

});

parcelRegister("2j0AL", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("9ivsj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $dX6FL = parcelRequire("dX6FL");


var $jlWUB = parcelRequire("jlWUB");

const $68c74ae30c005fed$export$c537e63161742ce3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $cozmU.useState)((0, $jlWUB.isReducedMotion));
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            if (!(0, $dX6FL.isMatchMediaAvailable)()) return;
            const mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
            const onChange = (event)=>setPrefersReducedMotion(event.matches);
            return (0, $cbY7C.bind)(mediaQueryList, {
                type: "change",
                listener: onChange
            });
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return prefersReducedMotion;
} : ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $cozmU.useState)((0, $jlWUB.isReducedMotion));
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $dX6FL.isMatchMediaAvailable)()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $cbY7C.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
module.exports["useIsReducedMotion"] = $68c74ae30c005fed$export$c537e63161742ce3;

});

parcelRegister("8BldL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $f1df1ad831df9f5a$export$6107f09ca09b8b5f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    embeddedParentModalKey: undefined,
    setEmbeddedParentModalKey: ()=>{},
    forwarder: ()=>Promise.resolve()
});
module.exports["EmbeddedModalContext"] = $f1df1ad831df9f5a$export$6107f09ca09b8b5f;

});

parcelRegister("eLuPt", function(module, exports) {
/* ForgeErrorBoundary.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $852mP = parcelRequire("852mP");


var $9DHhW = parcelRequire("9DHhW");


var $1VhsF = parcelRequire("1VhsF");


var $4K6lC = parcelRequire("4K6lC");


var $6ojvx = parcelRequire("6ojvx");

var $DIyeF = parcelRequire("DIyeF");


var $h48r4 = parcelRequire("h48r4");


var $k26hW = parcelRequire("k26hW");

function $b57f2c4814ca99d9$var$_defineProperty(e, r, t) {
    return (r = $b57f2c4814ca99d9$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $b57f2c4814ca99d9$var$_toPropertyKey(t) {
    var i = $b57f2c4814ca99d9$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $b57f2c4814ca99d9$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $b57f2c4814ca99d9$var$ForgeErrorBoundary extends (0, $cozmU.Component) {
    componentDidCatch(error, errorInfo) {
        this.setState({
            thrownError: {
                error: error,
                errorInfo: errorInfo
            }
        });
        const { page: page } = this.props;
        const environment = this.props.environment;
        (0, $h48r4.captureAndReportError)({
            error: error,
            errorExtensionDetails: this.props.extension ? {
                type: this.props.extension.type,
                environmentType: this.props.extension.environmentType,
                appOwnerAccountId: this.props.extension.appOwner?.accountId,
                properties: this.props.extension.properties,
                id: this.props.extension?.id
            } : undefined,
            errorInfo: errorInfo,
            page: page,
            environment: environment
        });
        if (!(error instanceof (0, $k26hW.APIError))) this.props.createAnalyticsEvent({
            eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'failed',
                actionSubject: 'forge.ui.renderer',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'errorBoundary',
                    errorName: error.name
                }
            }
        }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
    }
    render() {
        const { thrownError: thrownError } = this.state;
        if (!thrownError) return this.props.children;
        return /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "ForgeErrorBoundary"
        }, /*#__PURE__*/ $cozmU.createElement((0, $1VhsF.default), {
            appearance: "error",
            title: "Error rendering app"
        }, thrownError.error.message));
    }
    constructor(...args){
        super(...args);
        $b57f2c4814ca99d9$var$_defineProperty(this, "state", {
            thrownError: undefined
        });
    }
}
const $b57f2c4814ca99d9$var$withAnalyticsContext = (Component)=>({ extension: extension, children: children })=>{
        const { page: page, environment: envFromContext } = (0, $DIyeF.useMetricsContext)();
        const environment = (0, $cozmU.useContext)((0, $6ojvx.EnvironmentContext));
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
        return /*#__PURE__*/ $cozmU.createElement(Component, {
            environment: envFromContext ?? environment,
            extension: extension,
            page: page,
            createAnalyticsEvent: createAnalyticsEvent
        }, children);
    };
const $b57f2c4814ca99d9$var$_default_1 = $b57f2c4814ca99d9$var$withAnalyticsContext($b57f2c4814ca99d9$var$ForgeErrorBoundary);
var $b57f2c4814ca99d9$export$2e2bcd8739ae039 = $b57f2c4814ca99d9$var$_default_1;
module.exports["default"] = $b57f2c4814ca99d9$export$2e2bcd8739ae039;

});

parcelRegister("k26hW", function(module, exports) {
class $0e4aafd74f221aa2$export$3e5b797e39668f84 extends Error {
    constructor(message){
        super(message);
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $0e4aafd74f221aa2$export$3e5b797e39668f84.prototype);
    }
}
module.exports["APIError"] = $0e4aafd74f221aa2$export$3e5b797e39668f84;

});

parcelRegister("4BZVV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $d5gEx = parcelRequire("d5gEx");


var $8yKod = parcelRequire("8yKod");


var $cIUmi = parcelRequire("cIUmi");


var $fTCJP = parcelRequire("fTCJP");


var $6FQr4 = parcelRequire("6FQr4");


var $DIyeF = parcelRequire("DIyeF");


var $iUEMs = parcelRequire("iUEMs");


var $ix7El = parcelRequire("ix7El");


var $f53nH = parcelRequire("f53nH");


var $lCGo1 = parcelRequire("lCGo1");


var $gKVSw = parcelRequire("gKVSw");


var $8BldL = parcelRequire("8BldL");


var $lWtBU = parcelRequire("lWtBU");


var $4v1ex = parcelRequire("4v1ex");


var $kKOjD = parcelRequire("kKOjD");

let $931bc75652dbffc6$var$cachedPostRobotSend;

const $931bc75652dbffc6$var$getPostRobotSend = ()=>{
    if ($931bc75652dbffc6$var$cachedPostRobotSend !== undefined) $931bc75652dbffc6$var$cachedPostRobotSend;
    if (typeof window === 'undefined') return null;
    try {
        $931bc75652dbffc6$var$cachedPostRobotSend = (parcelRequire("9rzZK")).postRobotSend;
    } catch (_) {
        $931bc75652dbffc6$var$cachedPostRobotSend = null;
    }
    return $931bc75652dbffc6$var$cachedPostRobotSend;
};
// Container for supporting inline macros
const $931bc75652dbffc6$var$MacroExtensionContainer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { isInline: isInline, children: children } = t0;
    const inlineEnabled = (0, $iDrrr.fg)("platform_forge_ui_embedded_inline_macro") && isInline;
    const t1 = inlineEnabled ? "inline-block" : "block";
    const t2 = inlineEnabled ? "middle" : "";
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = {
            display: t1,
            verticalAlign: t2
        };
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== children || $[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-forge-extension-container": "true",
            "data-testid": "ForgeExtensionContainer",
            style: t3
        }, children);
        $[3] = children;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : ({ isInline: isInline, children: children })=>{
    const inlineEnabled = (0, $iDrrr.fg)('platform_forge_ui_embedded_inline_macro') && isInline;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-forge-extension-container": "true",
        "data-testid": "ForgeExtensionContainer",
        style: {
            display: inlineEnabled ? 'inline-block' : 'block',
            verticalAlign: inlineEnabled ? 'middle' : ''
        }
    }, children);
};
const $931bc75652dbffc6$var$getLoadingComponent = (loadingComponent)=>{
    if (loadingComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, loadingComponent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lCGo1.Loader), null);
};
const $931bc75652dbffc6$var$EmbeddedMacroRenderedAnalyticsTrigger = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { extensionId: extensionId } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { page: source } = (0, $DIyeF.useMetricsContext)();
    let t1;
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== extensionId || $[2] !== source) {
        t1 = ()=>{
            const { extensionKey: extensionKey } = (0, $cIUmi.extensionIdToAnalyticsAttributes)(extensionId);
            (0, $6FQr4.trackBodiedMacroEmbeddedContent)(createAnalyticsEvent, {
                source: source,
                extensionKey: extensionKey
            });
        };
        t2 = [
            createAnalyticsEvent,
            extensionId,
            source
        ];
        $[0] = createAnalyticsEvent;
        $[1] = extensionId;
        $[2] = source;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
} : ({ extensionId: extensionId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { page: source } = (0, $DIyeF.useMetricsContext)();
    (0, $cozmU.useEffect)(()=>{
        const { extensionKey: extensionKey } = (0, $cIUmi.extensionIdToAnalyticsAttributes)(extensionId);
        (0, $6FQr4.trackBodiedMacroEmbeddedContent)(createAnalyticsEvent, {
            source: source,
            extensionKey: extensionKey
        });
    }, [
        createAnalyticsEvent,
        extensionId,
        source
    ]);
    return null;
};
const $931bc75652dbffc6$var$EmbeddedMacroRendererInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(20);
    const { extensionId: extensionId, contextIds: contextIds, loadingComponent: loadingComponent, createGetContextToken: createGetContextToken, extensionData: extensionData, embeddedParentLocalId: embeddedParentLocalId, localId: localId, extensionPayload: extensionPayload, isInCustomUI: isInCustomUI, embeddedMacroParentType: embeddedMacroParentType, isInline: isInline, isMigrated: isMigrated, entryPoint: entryPoint, customBridge: customBridge, ...rest } = props;
    const [embeddedParentModalKey, setEmbeddedParentModalKey] = (0, $cozmU.useState)(undefined);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            {
                type: (0, $ix7El.GQLExtensionContextsFilterType).ExtensionType,
                value: [
                    "xen:macro"
                ]
            }
        ];
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== contextIds) {
        t1 = {
            contextIds: contextIds,
            filter: t0
        };
        $[1] = contextIds;
        $[2] = t1;
    } else t1 = $[2];
    const { extensions: extensions, loading: loading } = (0, $f53nH.useExtensionListRelay)(t1);
    const extension = extensions?.find((ext)=>ext.id === extensionId);
    const queryCompleted = extensions !== undefined;
    const notInstalled = queryCompleted && !extension && (0, $iDrrr.fg)("platform_validate_embedded_macro_installation");
    if (loading || !queryCompleted) {
        let t2;
        if ($[3] !== loadingComponent) {
            t2 = $931bc75652dbffc6$var$getLoadingComponent(loadingComponent);
            $[3] = loadingComponent;
            $[4] = t2;
        } else t2 = $[4];
        return t2;
    }
    if (notInstalled) {
        let t2;
        if ($[5] !== extensionId) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lWtBU.ExtensionNotInstalled), {
                extensionId: extensionId
            });
            $[5] = extensionId;
            $[6] = t2;
        } else t2 = $[6];
        return t2;
    }
    if (!extension) return null;
    const contentId = extensionData?.content?.id;
    const resolvedEmbeddedMacroParentType = embeddedMacroParentType ?? (isInCustomUI ? "CustomUI" : "UIKit");
    let getContextToken = props.getContextToken;
    if (createGetContextToken) getContextToken = createGetContextToken(extension);
    else if (getContextToken && (0, $iDrrr.fg)("forge-ui-bridge-core-reset")) {
        const innerGetContextToken = getContextToken;
        getContextToken = (options)=>innerGetContextToken({
                contextIdsOverride: options?.contextIdsOverride ?? contextIds,
                extensionOverride: {
                    extension: extension,
                    localId: localId
                }
            });
    }
    const isEmbeddedUIKitInCustomUI = (0, $iDrrr.fg)("platform_forge_ui_refactor_macro_parent_type") ? embeddedMacroParentType === "CustomUI" && !(0, $8yKod.isCustomUI)(extension, entryPoint) : isInCustomUI && !(0, $8yKod.isCustomUI)(extension, entryPoint);
    const embeddedMacroType = (0, $8yKod.isCustomUI)(extension, entryPoint) ? "CustomUI" : "UIKit";
    const t2 = getContextToken;
    let t3;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $iDrrr.fg)("platform_forge_ui_refactor_macro_parent_type");
        $[7] = t3;
    } else t3 = $[7];
    const forgeRendererProps = {
        ...rest,
        customBridge: customBridge,
        contextIds: contextIds,
        extension: extension,
        loadingComponent: loadingComponent,
        getContextToken: t2,
        extensionData: extensionData,
        embeddedParentLocalId: embeddedParentLocalId,
        localId: localId,
        extensionPayload: extensionPayload,
        entryPoint: entryPoint,
        isEmbeddedUIKitInCustomUI: isEmbeddedUIKitInCustomUI,
        isEmbeddedMacro: !t3,
        embeddedMacroParentType: (0, $iDrrr.fg)("platform_forge_ui_refactor_macro_parent_type") ? resolvedEmbeddedMacroParentType : undefined,
        height: extension.properties?.viewportSize && (0, $iDrrr.fg)("platform_forge_ui_embedded_inline_macro") ? (0, $gKVSw.calculateViewportSizeHeight)(extension.properties.viewportSize) : undefined
    };
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $4o0zT.isExperimentEnabled)("platform_forge_nesting_analytics");
        $[8] = t4;
    } else t4 = $[8];
    const shouldTrackNestingAnalytics = t4;
    if (isEmbeddedUIKitInCustomUI && (0, $iDrrr.fg)("platform_forge_ui_uikit_modal_in_custom_ui_parent")) {
        const postRobotSend = $931bc75652dbffc6$var$getPostRobotSend();
        let t5;
        if ($[9] !== customBridge?.setEmbeddedMacroModalForgeDoc) {
            t5 = (0, $iDrrr.fg)("forge-ui-bridge-core-reset") && customBridge?.setEmbeddedMacroModalForgeDoc;
            $[9] = customBridge?.setEmbeddedMacroModalForgeDoc;
            $[10] = t5;
        } else t5 = $[10];
        const uiKitModalForwarder = t5;
        const forwarder = uiKitModalForwarder ? (t6)=>{
            const { data: data } = t6;
            return uiKitModalForwarder(undefined, data);
        } : (0, $iUEMs.createMessageForwarder)("setEmbeddedMacroModalForgeDoc", {
            embeddedMacroExtensionDetails: undefined,
            embeddedMacroLocalId: localId,
            extension: extension,
            extensionData: extensionData,
            extensionPayload: extensionPayload,
            isEmbeddedMacroModal: true,
            sourceAppId: extension?.appId ?? "",
            sourceEnvironmentId: extension?.environmentKey,
            sourceInstallationId: extension?.installationId
        }, postRobotSend, embeddedParentLocalId, {
            appId: extension?.appId ?? "",
            id: extension?.id ?? "",
            installationId: extension?.installationId
        });
        let t7;
        if ($[11] !== embeddedParentModalKey || $[12] !== forwarder) {
            t7 = {
                embeddedParentModalKey: embeddedParentModalKey,
                setEmbeddedParentModalKey: setEmbeddedParentModalKey,
                forwarder: forwarder
            };
            $[11] = embeddedParentModalKey;
            $[12] = forwarder;
            $[13] = t7;
        } else t7 = $[13];
        let t8;
        if ($[14] !== extensionId || $[15] !== shouldTrackNestingAnalytics) {
            t8 = shouldTrackNestingAnalytics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($931bc75652dbffc6$var$EmbeddedMacroRenderedAnalyticsTrigger, {
                extensionId: extensionId
            });
            $[14] = extensionId;
            $[15] = shouldTrackNestingAnalytics;
            $[16] = t8;
        } else t8 = $[16];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kKOjD.ReservedHeightWrapper), {
            extension: extension
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fTCJP.ForgeUIEmbeddedMacroAnalyticsContext), {
            contentId: contentId,
            isInline: isInline,
            isMigrated: isMigrated,
            embeddedMacroType: embeddedMacroType,
            embeddedMacroParentType: resolvedEmbeddedMacroParentType
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8BldL.EmbeddedModalContext).Provider, {
            value: t7
        }, t8, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4v1ex.ForgeUIRenderer), forgeRendererProps))));
    }
    let t5;
    if ($[17] !== extensionId || $[18] !== shouldTrackNestingAnalytics) {
        t5 = shouldTrackNestingAnalytics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($931bc75652dbffc6$var$EmbeddedMacroRenderedAnalyticsTrigger, {
            extensionId: extensionId
        });
        $[17] = extensionId;
        $[18] = shouldTrackNestingAnalytics;
        $[19] = t5;
    } else t5 = $[19];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kKOjD.ReservedHeightWrapper), {
        extension: extension
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fTCJP.ForgeUIEmbeddedMacroAnalyticsContext), {
        contentId: contentId,
        isInline: isInline,
        isMigrated: isMigrated,
        embeddedMacroType: embeddedMacroType,
        embeddedMacroParentType: resolvedEmbeddedMacroParentType
    }, t5, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4v1ex.ForgeUIRenderer), forgeRendererProps)));
} : (props)=>{
    const { extensionId: extensionId, contextIds: contextIds, loadingComponent: loadingComponent, createGetContextToken: createGetContextToken, extensionData: extensionData, embeddedParentLocalId: embeddedParentLocalId, localId: localId, extensionPayload: extensionPayload, isInCustomUI: isInCustomUI, embeddedMacroParentType: embeddedMacroParentType, isInline: isInline, isMigrated: isMigrated, entryPoint: entryPoint, customBridge: customBridge, ...rest } = props;
    const [embeddedParentModalKey, setEmbeddedParentModalKey] = (0, $cozmU.useState)(undefined);
    const { extensions: extensions, loading: loading } = (0, $f53nH.useExtensionListRelay)({
        contextIds: contextIds,
        filter: [
            {
                type: (0, $ix7El.GQLExtensionContextsFilterType).ExtensionType,
                value: [
                    'xen:macro'
                ]
            }
        ]
    });
    const extension = extensions?.find((ext)=>ext.id === extensionId);
    const queryCompleted = extensions !== undefined;
    const notInstalled = queryCompleted && !extension && (0, $iDrrr.fg)('platform_validate_embedded_macro_installation');
    if (loading || !queryCompleted) return $931bc75652dbffc6$var$getLoadingComponent(loadingComponent);
    if (notInstalled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lWtBU.ExtensionNotInstalled), {
        extensionId: extensionId
    });
    if (!extension) return null;
    const contentId = extensionData?.content?.id;
    const resolvedEmbeddedMacroParentType = embeddedMacroParentType ?? (isInCustomUI ? 'CustomUI' : 'UIKit');
    let getContextToken = props.getContextToken;
    // createGetContextToken is the FAUS version of useGetContextToken — it is used for embedded
    // macros with a Custom UI bodied parent.
    if (createGetContextToken) getContextToken = createGetContextToken(extension);
    else if (getContextToken && (0, $iDrrr.fg)('forge-ui-bridge-core-reset')) {
        // For embedded macros with a UI Kit parent, getContextToken is
        // passed in by Confluence rather than constructed here.
        // We inject the embedded macro's
        // contextIds, extension, and localId — so bridge calls that uses getContextToken(invoke,
        // realtime, etc.) use the embedded macro's context, not the parent's.
        const innerGetContextToken = getContextToken;
        getContextToken = (options)=>innerGetContextToken({
                contextIdsOverride: options?.contextIdsOverride ?? contextIds,
                extensionOverride: {
                    extension: extension,
                    localId: localId
                }
            });
    }
    const isEmbeddedUIKitInCustomUI = (0, $iDrrr.fg)('platform_forge_ui_refactor_macro_parent_type') ? embeddedMacroParentType === 'CustomUI' && !(0, $8yKod.isCustomUI)(extension, entryPoint) : isInCustomUI && !(0, $8yKod.isCustomUI)(extension, entryPoint);
    const embeddedMacroType = (0, $8yKod.isCustomUI)(extension, entryPoint) ? 'CustomUI' : 'UIKit';
    const forgeRendererProps = {
        ...rest,
        customBridge: customBridge,
        contextIds: contextIds,
        extension: extension,
        loadingComponent: loadingComponent,
        getContextToken: getContextToken,
        extensionData: extensionData,
        embeddedParentLocalId: embeddedParentLocalId,
        localId: localId,
        extensionPayload: extensionPayload,
        entryPoint: entryPoint,
        isEmbeddedUIKitInCustomUI: isEmbeddedUIKitInCustomUI,
        isEmbeddedMacro: !(0, $iDrrr.fg)('platform_forge_ui_refactor_macro_parent_type'),
        embeddedMacroParentType: (0, $iDrrr.fg)('platform_forge_ui_refactor_macro_parent_type') ? resolvedEmbeddedMacroParentType : undefined,
        height: extension.properties?.viewportSize && (0, $iDrrr.fg)('platform_forge_ui_embedded_inline_macro') ? (0, $gKVSw.calculateViewportSizeHeight)(extension.properties.viewportSize) : undefined
    };
    const shouldTrackNestingAnalytics = (0, $4o0zT.isExperimentEnabled)('platform_forge_nesting_analytics');
    if (isEmbeddedUIKitInCustomUI && (0, $iDrrr.fg)('platform_forge_ui_uikit_modal_in_custom_ui_parent')) {
        const postRobotSend = $931bc75652dbffc6$var$getPostRobotSend(); // This prop is used to determine if the embedded macro is rendered within a Custom UI macro. Since the EmbeddedMacroRenderer is only used for rendering macros within Custom UI, we can set this to true.
        const uiKitModalForwarder = (0, $iDrrr.fg)('forge-ui-bridge-core-reset') && customBridge?.['setEmbeddedMacroModalForgeDoc'];
        const forwarder = uiKitModalForwarder ? ({ data: data })=>uiKitModalForwarder(undefined, data) : (0, $iUEMs.createMessageForwarder)('setEmbeddedMacroModalForgeDoc', {
            embeddedMacroExtensionDetails: undefined,
            embeddedMacroLocalId: localId,
            extension: extension,
            extensionData: extensionData,
            extensionPayload: extensionPayload,
            isEmbeddedMacroModal: true,
            sourceAppId: extension?.appId ?? '',
            sourceEnvironmentId: extension?.environmentKey,
            sourceInstallationId: extension?.installationId
        }, postRobotSend, embeddedParentLocalId, {
            appId: extension?.appId ?? '',
            id: extension?.id ?? '',
            installationId: extension?.installationId
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kKOjD.ReservedHeightWrapper), {
            extension: extension
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fTCJP.ForgeUIEmbeddedMacroAnalyticsContext), {
            contentId: contentId,
            isInline: isInline,
            isMigrated: isMigrated,
            embeddedMacroType: embeddedMacroType,
            embeddedMacroParentType: resolvedEmbeddedMacroParentType
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8BldL.EmbeddedModalContext).Provider, {
            value: {
                embeddedParentModalKey: embeddedParentModalKey,
                setEmbeddedParentModalKey: setEmbeddedParentModalKey,
                forwarder: forwarder
            }
        }, shouldTrackNestingAnalytics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($931bc75652dbffc6$var$EmbeddedMacroRenderedAnalyticsTrigger, {
            extensionId: extensionId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4v1ex.ForgeUIRenderer), forgeRendererProps))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kKOjD.ReservedHeightWrapper), {
        extension: extension
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fTCJP.ForgeUIEmbeddedMacroAnalyticsContext), {
        contentId: contentId,
        isInline: isInline,
        isMigrated: isMigrated,
        embeddedMacroType: embeddedMacroType,
        embeddedMacroParentType: resolvedEmbeddedMacroParentType
    }, shouldTrackNestingAnalytics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($931bc75652dbffc6$var$EmbeddedMacroRenderedAnalyticsTrigger, {
        extensionId: extensionId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4v1ex.ForgeUIRenderer), forgeRendererProps)));
};
const $931bc75652dbffc6$export$329644bef0dce3f7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($931bc75652dbffc6$var$EmbeddedMacroRendererInner, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props.isInline || $[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($931bc75652dbffc6$var$MacroExtensionContainer, {
            isInline: props.isInline
        }, t0));
        $[2] = props.isInline;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($931bc75652dbffc6$var$MacroExtensionContainer, {
        isInline: props.isInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($931bc75652dbffc6$var$EmbeddedMacroRendererInner, props)));
};
module.exports["EmbeddedMacroRenderer"] = $931bc75652dbffc6$export$329644bef0dce3f7;

});

parcelRegister("fTCJP", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5xQdV = parcelRequire("5xQdV");


var $gBjHb = parcelRequire("gBjHb");

const $7e5b733cbcedd00c$export$2067d1940da125b6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { contentId: contentId, isInline: isInline, isMigrated: isMigrated, embeddedMacroParentType: embeddedMacroParentType, embeddedMacroType: embeddedMacroType, children: children } = t0;
    let t1;
    let t2;
    if ($[0] !== contentId || $[1] !== embeddedMacroParentType || $[2] !== embeddedMacroType || $[3] !== isInline || $[4] !== isMigrated) {
        t1 = ()=>({
                forgeUIAttributes: {
                    contentId: contentId,
                    isEmbeddedMacro: true,
                    ...isInline !== undefined ? {
                        isInline: isInline
                    } : {},
                    ...isMigrated ? {
                        isMigrated: isMigrated
                    } : {},
                    embeddedMacroParentType: embeddedMacroParentType,
                    embeddedMacroType: embeddedMacroType
                }
            });
        t2 = [
            contentId,
            isInline,
            isMigrated,
            embeddedMacroParentType,
            embeddedMacroType
        ];
        $[0] = contentId;
        $[1] = embeddedMacroParentType;
        $[2] = embeddedMacroType;
        $[3] = isInline;
        $[4] = isMigrated;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    const data = (0, $5xQdV.useMemoOne)(t1, t2);
    let t3;
    if ($[7] !== children || $[8] !== data) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
            data: data
        }, children);
        $[7] = children;
        $[8] = data;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ contentId: contentId, isInline: isInline, isMigrated: isMigrated, embeddedMacroParentType: embeddedMacroParentType, embeddedMacroType: embeddedMacroType, children: children })=>{
    const data = (0, $5xQdV.useMemoOne)(()=>({
            forgeUIAttributes: {
                contentId: contentId,
                isEmbeddedMacro: true,
                ...isInline !== undefined ? {
                    isInline: isInline
                } : {},
                ...isMigrated ? {
                    isMigrated: isMigrated
                } : {},
                embeddedMacroParentType: embeddedMacroParentType,
                embeddedMacroType: embeddedMacroType
            }
        }), [
        contentId,
        isInline,
        isMigrated,
        embeddedMacroParentType,
        embeddedMacroType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: data
    }, children);
};
module.exports["ForgeUIEmbeddedMacroAnalyticsContext"] = $7e5b733cbcedd00c$export$2067d1940da125b6;

});

parcelRegister("gKVSw", function(module, exports) {
const $16b1ea7c28597489$var$macroHeights = {
    small: '112px',
    medium: '262px',
    default: '262px',
    large: '524px',
    xlarge: '1048px'
};
const $16b1ea7c28597489$export$d27eb2c49eeaf1b4 = (size)=>{
    return $16b1ea7c28597489$var$macroHeights[size ?? 'default'];
};
module.exports["calculateViewportSizeHeight"] = $16b1ea7c28597489$export$d27eb2c49eeaf1b4;

});

parcelRegister("lWtBU", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $4aRua = parcelRequire("4aRua");


var $1VhsF = parcelRequire("1VhsF");


var $6FQr4 = parcelRequire("6FQr4");

const $bb155dfc087093a5$var$messages = (0, $kSwu1.defineMessages)({
    title: {
        id: "forge.ui.extension.not.installed.title",
        defaultMessage: "App not available"
    },
    message: {
        id: "forge.ui.extension.not.installed.message",
        defaultMessage: "We can't display this content because the app isn't installed. Contact your administrator to install it."
    }
});
const $bb155dfc087093a5$export$8fa4e6bbdc2e95d1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { extensionId: extensionId } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== extensionId) {
        t1 = ()=>{
            (0, $6FQr4.trackEmbeddedMacroRejected)(createAnalyticsEvent, {
                source: "forgeUIRenderer",
                extensionId: extensionId,
                reason: "not_installed"
            });
        };
        t2 = [
            createAnalyticsEvent,
            extensionId
        ];
        $[0] = createAnalyticsEvent;
        $[1] = extensionId;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[4] !== intl) {
        t3 = intl.formatMessage($bb155dfc087093a5$var$messages.title);
        $[4] = intl;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $bb155dfc087093a5$var$messages.message));
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== t3) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
            title: t3,
            appearance: "warning",
            testId: "extension-not-installed"
        }, t4);
        $[7] = t3;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ extensionId: extensionId })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        (0, $6FQr4.trackEmbeddedMacroRejected)(createAnalyticsEvent, {
            source: 'forgeUIRenderer',
            extensionId: extensionId,
            reason: 'not_installed'
        });
    }, [
        createAnalyticsEvent,
        extensionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        title: intl.formatMessage($bb155dfc087093a5$var$messages.title),
        appearance: "warning",
        testId: "extension-not-installed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $bb155dfc087093a5$var$messages.message)));
};
module.exports["ExtensionNotInstalled"] = $bb155dfc087093a5$export$8fa4e6bbdc2e95d1;

});

parcelRegister("kKOjD", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $8yKod = parcelRequire("8yKod");


var $gKVSw = parcelRequire("gKVSw");

const $8b08db13a4c8c729$export$eea1b756e7867f29 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { extension: extension, children: children, isInlinePresentation: t1 } = t0;
    const isInlinePresentation = t1 === undefined ? false : t1;
    const extensionViewportSize = extension?.properties?.viewportSize;
    if (extensionViewportSize && (0, $iDrrr.fg)("confluence_forge_early_render_reserve_height") && !isInlinePresentation) {
        let t2;
        if ($[0] !== extensionViewportSize) {
            t2 = (0, $gKVSw.calculateViewportSizeHeight)(extensionViewportSize);
            $[0] = extensionViewportSize;
            $[1] = t2;
        } else t2 = $[1];
        const viewportSizeHeight = t2;
        if ((0, $8yKod.isCustomUI)(extension)) {
            let t3;
            if ($[2] !== viewportSizeHeight) {
                t3 = {
                    height: viewportSizeHeight
                };
                $[2] = viewportSizeHeight;
                $[3] = t3;
            } else t3 = $[3];
            let t4;
            if ($[4] !== children || $[5] !== t3) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    style: t3,
                    "data-testid": "reserved-height-wrapper-custom-ui"
                }, children);
                $[4] = children;
                $[5] = t3;
                $[6] = t4;
            } else t4 = $[6];
            return t4;
        } else {
            let t3;
            if ($[7] !== viewportSizeHeight) {
                t3 = {
                    minHeight: viewportSizeHeight
                };
                $[7] = viewportSizeHeight;
                $[8] = t3;
            } else t3 = $[8];
            let t4;
            if ($[9] !== children || $[10] !== t3) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    style: t3,
                    "data-testid": "reserved-height-wrapper-uikit"
                }, children);
                $[9] = children;
                $[10] = t3;
                $[11] = t4;
            } else t4 = $[11];
            return t4;
        }
    }
    let t2;
    if ($[12] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
        $[12] = children;
        $[13] = t2;
    } else t2 = $[13];
    return t2;
} : ({ extension: extension, children: children, isInlinePresentation: isInlinePresentation = false })=>{
    const extensionViewportSize = extension?.properties?.viewportSize;
    // Only apply reserved height if the feature flag is on AND viewportSize is defined
    if (extensionViewportSize && (0, $iDrrr.fg)('confluence_forge_early_render_reserve_height') && !isInlinePresentation) {
        const viewportSizeHeight = (0, $gKVSw.calculateViewportSizeHeight)(extensionViewportSize);
        // Custom UI extensions have full support for viewportSize, leading to a strict height.
        // UI Kit 2 extensions, while they can define viewportSize in their manifest, primarily
        // have dynamic sizing. This means viewportSize is not a strict constraint for them as it
        // is for Custom UI. Using minHeight based on a manifest-defined viewportSize is therefore
        // a best-effort approach to proactively reserve space. This aims to reduce layout shift
        // while still allowing the extension to grow dynamically if its content requires more space.
        if ((0, $8yKod.isCustomUI)(extension)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                height: viewportSizeHeight
            },
            "data-testid": "reserved-height-wrapper-custom-ui"
        }, children);
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                minHeight: viewportSizeHeight
            },
            "data-testid": "reserved-height-wrapper-uikit"
        }, children);
    }
    // If FF is off, or if viewportSize is undefined, render children directly
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
};
module.exports["ReservedHeightWrapper"] = $8b08db13a4c8c729$export$eea1b756e7867f29;

});

parcelRegister("dHQOi", function(module, exports) {
const $78331c9b4265087f$export$27903d543b563e39 = (attrs)=>(...content)=>({
            type: 'bodiedExtension',
            attrs: attrs,
            content: content
        });
module.exports["bodiedExtension"] = $78331c9b4265087f$export$27903d543b563e39;

});

parcelRegister("lvJqX", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6JrSr = parcelRequire("6JrSr");


var $4n1IT = parcelRequire("4n1IT");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");

var $4aRua = parcelRequire("4aRua");


var $cEipP = parcelRequire("cEipP");

const $7c29b2adacb89176$var$styles = {
    contentStyles: "_4bt5LAIZbP _2WAcuGIZbP _0LQT5ENHnM _03SyCPNHnM _46hvQm5zaO _0xmtko5zaO _1EqgXlhPwX _0NUa3rhPwX",
    rootStyles: "_3iDTPbvbI6 _1EqgXlN91d _4GplSjDF1i _2fqI0W7iY9",
    pressableStyles: "_0bjKvDKTcp _2sNsIgmnOE _4c065UPgdg _2Y7lL4Pgdg _3iDTPbccYA _0KLXru66of _1UtDYzZpcK _1ANEUSLRg7 _1mT5xdRAKS _0hPCNLQame _1EqgXlN91d _0jFU0VIZbP _39xV02IZbP _1RrJLiQame _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8"
};
const $7c29b2adacb89176$var$iconColor = {
    connectivity: "_2bHMMpZFWO",
    confirmation: "_2bHMMpfyEX",
    info: "_2bHMMpTNil",
    warning: "_2bHMMpspgB",
    error: "_2bHMMp7j8z"
}; /**
    * __Inline message__
    *
    * An inline message lets users know when important information is available or when an action is required.
    *
    * - [Examples](https://atlassian.design/components/inline-message/examples)
    * - [Code](https://atlassian.design/components/inline-message/code)
    * - [Usage](https://atlassian.design/components/inline-message/usage)
    *
    * @example
    *
    * ```jsx
    * const Component = () => (
    *   <InlineMessage
    *    title="Inline Message Title Example"
    *    secondaryText="Secondary Text"
    *   >
    *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
    *   </InlineMessage>
    * );
    * ```
    */ 
const $7c29b2adacb89176$var$InlineMessage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { placement: t1, secondaryText: t2, title: t3, appearance: t4, spacing: t5, children: children, testId: testId, iconLabel: iconLabel, fallbackPlacements: fallbackPlacements } = t0;
    const placement = t1 === undefined ? "bottom-start" : t1;
    const secondaryText = t2 === undefined ? "" : t2;
    const title = t3 === undefined ? "" : t3;
    const appearance = t4 === undefined ? "connectivity" : t4;
    const spacing = t5 === undefined ? "spacious" : t5;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const id = (0, $6JrSr.useId)();
    let t6;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setIsOpen($7c29b2adacb89176$var$_temp);
        };
        $[0] = t6;
    } else t6 = $[0];
    const toggleDialog = t6;
    let t7;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>setIsOpen(false);
        $[1] = t7;
    } else t7 = $[1];
    const onCloseDialog = t7;
    const t8 = $7c29b2adacb89176$var$iconColor[appearance];
    let t9;
    if ($[2] !== t8) {
        t9 = (0, $hekY6.default)([
            $7c29b2adacb89176$var$styles.rootStyles,
            t8
        ]);
        $[2] = t8;
        $[3] = t9;
    } else t9 = $[3];
    let t10;
    if ($[4] !== children) {
        t10 = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $7c29b2adacb89176$var$styles.contentStyles,
                children: children
            });
        $[4] = children;
        $[5] = t10;
    } else t10 = $[5];
    const t11 = testId && `${testId}--popup`;
    let t12;
    if ($[6] !== appearance || $[7] !== iconLabel || $[8] !== id || $[9] !== isOpen || $[10] !== secondaryText || $[11] !== spacing || $[12] !== testId || $[13] !== title) {
        t12 = (t13)=>{
            const { ref: ref, ...triggerProps } = t13;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                ...triggerProps,
                ref: ref,
                id: id,
                "data-ds--inline-message--button": true,
                onClick: toggleDialog,
                testId: testId && `${testId}--button`,
                xcss: $7c29b2adacb89176$var$styles.pressableStyles,
                "aria-expanded": isOpen,
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                    as: "span",
                    space: "space.050",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cEipP.default), {
                            isOpen: isOpen,
                            appearance: appearance,
                            label: iconLabel,
                            spacing: spacing
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                            as: "span",
                            space: "space.100",
                            children: [
                                title && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                    weight: "medium",
                                    testId: testId && `${testId}--title`,
                                    children: title
                                }),
                                secondaryText && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                    weight: "medium",
                                    color: "color.text.subtlest",
                                    maxLines: 1,
                                    testId: testId && `${testId}--text`,
                                    children: secondaryText
                                })
                            ]
                        })
                    ]
                })
            });
        };
        $[6] = appearance;
        $[7] = iconLabel;
        $[8] = id;
        $[9] = isOpen;
        $[10] = secondaryText;
        $[11] = spacing;
        $[12] = testId;
        $[13] = title;
        $[14] = t12;
    } else t12 = $[14];
    let t13;
    if ($[15] !== fallbackPlacements || $[16] !== id || $[17] !== isOpen || $[18] !== placement || $[19] !== t10 || $[20] !== t11 || $[21] !== t12) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4n1IT.Popup), {
            onClose: onCloseDialog,
            content: t10,
            isOpen: isOpen,
            placement: placement,
            testId: t11,
            fallbackPlacements: fallbackPlacements,
            shouldRenderToParent: true,
            role: "dialog",
            titleId: id,
            trigger: t12
        });
        $[15] = fallbackPlacements;
        $[16] = id;
        $[17] = isOpen;
        $[18] = placement;
        $[19] = t10;
        $[20] = t11;
        $[21] = t12;
        $[22] = t13;
    } else t13 = $[22];
    let t14;
    if ($[23] !== t13 || $[24] !== t9 || $[25] !== testId) {
        t14 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": testId,
            className: t9,
            children: t13
        });
        $[23] = t13;
        $[24] = t9;
        $[25] = testId;
        $[26] = t14;
    } else t14 = $[26];
    return t14;
} : ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', appearance: appearance = 'connectivity', spacing: spacing = 'spacious', children: children, testId: testId, iconLabel: iconLabel, fallbackPlacements: fallbackPlacements })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const id = (0, $6JrSr.useId)();
    const toggleDialog = (0, $cozmU.useCallback)(()=>{
        setIsOpen((oldState)=>!oldState);
    }, [
        setIsOpen
    ]);
    const onCloseDialog = (0, $cozmU.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $7c29b2adacb89176$var$styles.rootStyles,
            $7c29b2adacb89176$var$iconColor[appearance]
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4n1IT.Popup), {
            onClose: onCloseDialog,
            content: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    xcss: $7c29b2adacb89176$var$styles.contentStyles,
                    children: children
                }),
            isOpen: isOpen,
            placement: placement,
            testId: testId && `${testId}--popup`,
            fallbackPlacements: fallbackPlacements,
            shouldRenderToParent: true,
            role: "dialog",
            titleId: id,
            trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                    ...triggerProps,
                    ref: ref,
                    id: id,
                    "data-ds--inline-message--button": true,
                    onClick: toggleDialog,
                    testId: testId && `${testId}--button`,
                    xcss: $7c29b2adacb89176$var$styles.pressableStyles,
                    "aria-expanded": isOpen,
                    children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                        as: "span",
                        space: "space.050",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cEipP.default), {
                                isOpen: isOpen,
                                appearance: appearance,
                                label: iconLabel,
                                spacing: spacing
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                                as: "span",
                                space: "space.100",
                                children: [
                                    title && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                        weight: "medium",
                                        testId: testId && `${testId}--title`,
                                        children: title
                                    }),
                                    secondaryText && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                        weight: "medium",
                                        color: "color.text.subtlest",
                                        maxLines: 1,
                                        testId: testId && `${testId}--text`,
                                        children: secondaryText
                                    })
                                ]
                            })
                        ]
                    })
                })
        })
    });
};
var $7c29b2adacb89176$export$2e2bcd8739ae039 = $7c29b2adacb89176$var$InlineMessage;
function $7c29b2adacb89176$var$_temp(oldState) {
    return !oldState;
}
module.exports["default"] = $7c29b2adacb89176$export$2e2bcd8739ae039;

});

parcelRegister("cEipP", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $axHIJ = parcelRequire("axHIJ");

const $fe4d2a60aea58684$var$iconColor = {
    connectivity: "_1UtDYzZFWO",
    confirmation: "_1UtDYzfyEX",
    info: "_1UtDYzTNil",
    warning: "_1UtDYzspgB",
    error: "_1UtDYz7j8z"
};
const $fe4d2a60aea58684$var$iconWrapperStyles = null;
const $fe4d2a60aea58684$var$iconColorStyles = null; /**
                               * __Selected icon__
                               *
                               * The selected icon is used as the primary interactive element for the dialog.
                               * Can be used with or without supporting text.
                               */ 
const $fe4d2a60aea58684$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label, spacing: spacing })=>{
    const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, $axHIJ.typesMapping);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-ds--inline-message--icon": true,
        className: (0, $hekY6.default)([
            "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _3iDTPbQ4SZ _0hPCNLDIqT",
            $fe4d2a60aea58684$var$iconColor[appearance],
            isOpen && "_1UtDYzDF1i"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            testId: "inline-message-icon",
            label: label || defaultLabel,
            color: "currentColor",
            spacing: spacing
        })
    });
};
var $fe4d2a60aea58684$export$2e2bcd8739ae039 = $fe4d2a60aea58684$var$SelectedIcon;
module.exports["default"] = $fe4d2a60aea58684$export$2e2bcd8739ae039;

});

parcelRegister("axHIJ", function(module, exports) {

var $24dy7 = parcelRequire("24dy7");


var $fodiz = parcelRequire("fodiz");


var $chu6R = parcelRequire("chu6R");


var $lMGh1 = parcelRequire("lMGh1");

const $0c91ff1a933c23ee$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($chu6R))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fodiz))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($24dy7))),
        defaultLabel: 'error inline message'
    }
};
module.exports["typesMapping"] = $0c91ff1a933c23ee$export$4d111645c0b39d5d;

});

parcelRegister("3xwCI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c5429223205b4172af0cbd0d2ddcaa04>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $293dc2808d336068$var$_react = $293dc2808d336068$var$_interopRequireDefault((parcelRequire("cozmU")));

var $293dc2808d336068$var$_iconNew = $293dc2808d336068$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $293dc2808d336068$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pencil".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/pencil
 * Usage guidance:
 * Known uses: compose video title in Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $293dc2808d336068$var$PencilIcon = (props)=>/*#__PURE__*/ $293dc2808d336068$var$_react.default.createElement($293dc2808d336068$var$_iconNew.default, Object.assign({
        name: "PencilIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.336 1.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.099 8.099a2 2 0 0 1-1.022.547l-3.379.675a.75.75 0 0 1-.882-.882l.675-3.379a2 2 0 0 1 .547-1.022zm1.768 1.06a.5.5 0 0 0-.707 0l-.961.961 1.939 1.94.96-.961a.5.5 0 0 0 0-.707zm-.79 3.961-1.939-1.94-6.077 6.078a.5.5 0 0 0-.137.255l-.455 2.276 2.276-.455a.5.5 0 0 0 .255-.137zM16 15H8v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$293dc2808d336068$var$PencilIcon.displayName = 'PencilIcon';
var $293dc2808d336068$var$_default = module.exports.default = $293dc2808d336068$var$PencilIcon;

});

parcelRegister("aBKty", function(module, exports) {

var $6EphZ = parcelRequire("6EphZ");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/site/manifest.ts
var $7b91693551a8064f$var$confluenceSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $6EphZ.ConfluenceSiteAriResourceOwner),
    resourceType: (0, $6EphZ.ConfluenceSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/confluence/site/index.ts
var $7b91693551a8064f$export$82e6693d75ffdd8 = class _ConfluenceSiteAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7b91693551a8064f$var$confluenceSiteAriStaticOpts.qualifier,
            platformQualifier: $7b91693551a8064f$var$confluenceSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $7b91693551a8064f$var$confluenceSiteAriStaticOpts.resourceOwner,
            resourceType: $7b91693551a8064f$var$confluenceSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $7b91693551a8064f$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $7b91693551a8064f$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["ConfluenceSiteAri"] = $7b91693551a8064f$export$82e6693d75ffdd8;

});

parcelRegister("6EphZ", function(module, exports) {
// src/confluence/site/types.ts
var $4d7a18635b736c71$export$9e07499cd8b0bde5 = "confluence", $4d7a18635b736c71$export$57b7cabbf31f1f68 = "site";
module.exports["ConfluenceSiteAriResourceOwner"] = $4d7a18635b736c71$export$9e07499cd8b0bde5;
module.exports["ConfluenceSiteAriResourceType"] = $4d7a18635b736c71$export$57b7cabbf31f1f68;

});

parcelRegister("eToX6", function(module, exports) {
/**
 * Utility functions for detecting and working with preview panels
 */ // Types for preview panel detection
// Preview panel indicators
const $cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS = {
    EMBEDDED_SOURCE: 'embeddedConfluenceSource',
    PREVIEW_PANELS: 'previewPanels',
    CONFLUENCE_PAGE_PREVIEW: 'confluence-page-preview-panel'
};
/**
 * Gets URL search parameters safely
 */ const $cf00e918e2c1556d$var$getUrlSearchParams = (url)=>{
    try {
        return new URLSearchParams(url);
    } catch  {
        return null;
    }
};
const $cf00e918e2c1556d$export$5c3b154013d00c5f = (searchParams)=>{
    return searchParams.has($cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.PREVIEW_PANELS) || searchParams.get($cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.EMBEDDED_SOURCE) === $cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.CONFLUENCE_PAGE_PREVIEW;
};
const $cf00e918e2c1556d$export$cd88bef28d20da33 = ()=>{
    try {
        const currentSearch = window.location.search;
        if (currentSearch) {
            const currentParams = $cf00e918e2c1556d$var$getUrlSearchParams(currentSearch);
            if (currentParams && $cf00e918e2c1556d$export$5c3b154013d00c5f(currentParams)) return true;
        }
        return false;
    } catch  {
        return false;
    }
};
const $cf00e918e2c1556d$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
module.exports["hasPreviewPanelIndicators"] = $cf00e918e2c1556d$export$5c3b154013d00c5f;
module.exports["isInPreviewPanel"] = $cf00e918e2c1556d$export$cd88bef28d20da33;
module.exports["isInIframe"] = $cf00e918e2c1556d$export$9f140ed41af5108c;

});

parcelRegister("5YDZX", function(module, exports) {
const $d9d643acafd25457$var$BLOCK_CONTROLS_SUPPRESSION_ATTRIBUTE = 'data-block-controls-suppression';
const $d9d643acafd25457$var$BLOCK_CONTROLS_SUPPRESSION_SELECTOR = `[${$d9d643acafd25457$var$BLOCK_CONTROLS_SUPPRESSION_ATTRIBUTE}]`;
const $d9d643acafd25457$export$7a4820babe675d08 = {
    [$d9d643acafd25457$var$BLOCK_CONTROLS_SUPPRESSION_ATTRIBUTE]: 'true'
};
const $d9d643acafd25457$export$8d5d08f345eecbf1 = (target)=>target instanceof Element && target.closest($d9d643acafd25457$var$BLOCK_CONTROLS_SUPPRESSION_SELECTOR) !== null;
module.exports["blockControlsSuppressionProps"] = $d9d643acafd25457$export$7a4820babe675d08;
module.exports["isBlockControlsSuppressionTarget"] = $d9d643acafd25457$export$8d5d08f345eecbf1;

});

parcelRegister("kOUwv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $d684465712516a35$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $d684465712516a35$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $d684465712516a35$export$2d97e7bb018b0cfb = (0, $8s9DV.createStore)({
    initialState: $d684465712516a35$var$initialState,
    actions: $d684465712516a35$var$actions,
    name: 'siteTraitsStore'
});
const $d684465712516a35$export$c84f691b170cbee3 = (0, $kBr4q.createHook)($d684465712516a35$export$2d97e7bb018b0cfb);
const $d684465712516a35$export$2aca02eeb1d46515 = (0, $kBr4q.createActionsHook)($d684465712516a35$export$2d97e7bb018b0cfb);
async function $d684465712516a35$var$fetchSiteTraitsData(cloudId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $d684465712516a35$var$hasFetched = false;
function $d684465712516a35$export$f1fbc6ad89f91b89() {
    $d684465712516a35$var$hasFetched = false;
}
function $d684465712516a35$var$getSiteTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.site);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.site);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $d684465712516a35$export$fcebe75065597a98({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $cozmU.useMemo)(()=>$d684465712516a35$var$getSiteTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $d684465712516a35$export$c84f691b170cbee3();
    const { accessStatus: accessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $cozmU.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($d684465712516a35$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !cloudId) return;
        $d684465712516a35$var$hasFetched = true;
        storeActions.start();
        $d684465712516a35$var$fetchSiteTraitsData(cloudId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        cloudId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSiteTraits"] = $d684465712516a35$export$fcebe75065597a98;

});

parcelRegister("9Z1sw", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $eq95w = parcelRequire("eq95w");


var $cozmU = parcelRequire("cozmU");


var $ah4BL = parcelRequire("ah4BL");


var $bavCP = parcelRequire("bavCP");


var $8wW9d = parcelRequire("8wW9d");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $ep3mz = parcelRequire("ep3mz");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $eSLr0 = parcelRequire("eSLr0");


var $3QyBm = parcelRequire("3QyBm");


var $iqPSe = parcelRequire("iqPSe");

const $0aea74171df1eb15$export$d97dfe528d83a912 = (0, $eq95w.default);
const $0aea74171df1eb15$var$WebPanelLocationBatchContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $0aea74171df1eb15$export$784950ebf49d8a5f = (location)=>{
    const $ = (0, $bDgLe.c)(3);
    const batchContext = (0, $cozmU.useContext)($0aea74171df1eb15$var$WebPanelLocationBatchContext);
    let t0;
    if ($[0] !== batchContext || $[1] !== location) {
        t0 = batchContext?.locations.includes(location) ? batchContext.getResultForLocation(location) : null;
        $[0] = batchContext;
        $[1] = location;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
const $0aea74171df1eb15$var$getUniqueLocations = (locations)=>Array.from(new Set(locations.filter(Boolean)));
const $0aea74171df1eb15$var$groupPanelsByLocation = (webPanels)=>{
    const panelsByLocation = new Map();
    webPanels?.forEach((panel)=>{
        if (panel?.location) {
            const panels = panelsByLocation.get(panel.location) ?? [];
            panels.push(panel);
            panelsByLocation.set(panel.location, panels);
        }
    });
    return panelsByLocation;
};
const $0aea74171df1eb15$var$getWebPanelLocationVariables = ({ location: location, locations: locations, contentIdentifier: contentIdentifier, spaceIdentifier: spaceIdentifier })=>{
    const selectedLocations = locations ?? (location ? [
        location
    ] : []);
    const locationVariables = selectedLocations.length > 1 ? {
        location: null,
        locations: selectedLocations
    } : {
        location: selectedLocations[0]
    };
    return {
        ...locationVariables,
        ...contentIdentifier != null ? {
            contentId: contentIdentifier
        } : {},
        ...contentIdentifier == null && spaceIdentifier != null ? {
            spaceKey: spaceIdentifier
        } : {}
    };
};
const $0aea74171df1eb15$var$useWebPanelLocationIdentifiers = ()=>{
    const $ = (0, $bDgLe.c)(8);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    let t0;
    let t1;
    if ($[0] !== contentId || $[1] !== getQueryParams || $[2] !== spaceKey) {
        const queryParams = getQueryParams();
        t0 = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, "spaceKey") || (0, $c3Qwv.getSingleParam)(queryParams, "key");
        t1 = contentId || (0, $c3Qwv.getSingleParam)(queryParams, "pageId");
        $[0] = contentId;
        $[1] = getQueryParams;
        $[2] = spaceKey;
        $[3] = t0;
        $[4] = t1;
    } else {
        t0 = $[3];
        t1 = $[4];
    }
    let t2;
    if ($[5] !== t0 || $[6] !== t1) {
        t2 = {
            spaceIdentifier: t0,
            contentIdentifier: t1
        };
        $[5] = t0;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
const $0aea74171df1eb15$var$UFOWebPanelLocationWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, locationName: locationName, panels: panels } = t0;
    const panelHasContent = panels?.length && panels.some($0aea74171df1eb15$var$_temp);
    let t1;
    let t2;
    if ($[0] !== panels) {
        t1 = ()=>{
            (0, $8wW9d.recordNonContentAppKeys)("web-panel", (panels ?? []).map($0aea74171df1eb15$var$_temp2));
        };
        t2 = [
            panels
        ];
        $[0] = panels;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    if (!panelHasContent) return children;
    const t3 = `web-panel-${locationName}`;
    let t4;
    if ($[3] !== children || $[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ah4BL.UFOThirdPartySegment), {
            name: t3
        }, children);
        $[3] = children;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
};
const $0aea74171df1eb15$var$MemoizedAtlGeneralWebPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { panel: panel } = t0;
    let t1;
    if ($[0] !== panel.completeKey || $[1] !== panel.html) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqPSe.WebPanel), {
            panelId: panel.completeKey,
            html: panel.html,
            panelLocation: (0, $eSLr0.ATL_GENERAL)
        });
        $[0] = panel.completeKey;
        $[1] = panel.html;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
}, (prevProps, nextProps)=>prevProps.panel.completeKey === nextProps.panel.completeKey);
const $0aea74171df1eb15$var$WebPanelLocationBatchContextProvider = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { data: data, loading: loading, error: error, locations: locations, children: children } = t0;
    data?.webPanels;
    const t1 = data?.webPanels;
    let t2;
    if ($[0] !== t1) {
        t2 = $0aea74171df1eb15$var$groupPanelsByLocation(t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const panelsByLocation = t2;
    let t3;
    if ($[2] !== data || $[3] !== error || $[4] !== loading || $[5] !== panelsByLocation) {
        t3 = (location)=>({
                data: data ? {
                    webPanels: panelsByLocation.get(location) ?? []
                } : data,
                loading: loading,
                error: error
            });
        $[2] = data;
        $[3] = error;
        $[4] = loading;
        $[5] = panelsByLocation;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== locations || $[8] !== t3) {
        t4 = {
            locations: locations,
            getResultForLocation: t3
        };
        $[7] = locations;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    const contextValue = t4;
    let t5;
    if ($[10] !== children || $[11] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$WebPanelLocationBatchContext.Provider, {
            value: contextValue
        }, children);
        $[10] = children;
        $[11] = contextValue;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
};
const $0aea74171df1eb15$export$2c530b46a1768809 = (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { locations: locations, children: children } = t0;
    const { spaceIdentifier: spaceIdentifier, contentIdentifier: contentIdentifier } = $0aea74171df1eb15$var$useWebPanelLocationIdentifiers();
    let t1;
    if ($[0] !== locations) {
        t1 = locations.join("\0");
        $[0] = locations;
        $[1] = t1;
    } else t1 = $[1];
    const locationsKey = t1;
    let t2;
    if ($[2] !== locationsKey) {
        t2 = $0aea74171df1eb15$var$getUniqueLocations(locationsKey.split("\0"));
        $[2] = locationsKey;
        $[3] = t2;
    } else t2 = $[3];
    const uniqueLocations = t2;
    let t3;
    if ($[4] !== contentIdentifier || $[5] !== spaceIdentifier || $[6] !== uniqueLocations) {
        t3 = $0aea74171df1eb15$var$getWebPanelLocationVariables({
            locations: uniqueLocations,
            contentIdentifier: contentIdentifier,
            spaceIdentifier: spaceIdentifier
        });
        $[4] = contentIdentifier;
        $[5] = spaceIdentifier;
        $[6] = uniqueLocations;
        $[7] = t3;
    } else t3 = $[7];
    const variables = t3;
    if (spaceIdentifier === "byDraft" || uniqueLocations.length === 0) {
        let t4;
        if ($[8] !== children) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[8] = children;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    let t4;
    if ($[10] !== children || $[11] !== uniqueLocations) {
        t4 = (t5)=>{
            const { data: data, loading: loading, error: error } = t5;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$WebPanelLocationBatchContextProvider, {
                data: data,
                loading: loading,
                error: error,
                locations: uniqueLocations
            }, children);
        };
        $[10] = children;
        $[11] = uniqueLocations;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== t4 || $[14] !== variables) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
            query: $0aea74171df1eb15$export$d97dfe528d83a912,
            variables: variables,
            fetchPolicy: "cache-first",
            __callerPackage__: "web-panel-location"
        }, t4);
        $[13] = t4;
        $[14] = variables;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
};
const $0aea74171df1eb15$export$2482f01f112556a = ({ location: location, style: style = {}, renderWhenLoading: renderWhenLoading, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', children: children, onCompleted: onCompleted })=>{
    const { spaceIdentifier: spaceIdentifier, contentIdentifier: contentIdentifier } = $0aea74171df1eb15$var$useWebPanelLocationIdentifiers();
    const batchResult = $0aea74171df1eb15$export$784950ebf49d8a5f(location);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const completedBatchResultKeyRef = (0, $cozmU.useRef)(null);
    const EXPERIENCE_NAME_BY_LOCATION = {
        [(0, $eSLr0.ATL_FOOTER)]: (0, $irVI7.EXTENSION_POINT_HOME_FOOTER_EXPERIENCE),
        [(0, $eSLr0.ATL_GENERAL)]: (0, $irVI7.EXTENSION_POINT_HOME_HEADER_EXPERIENCE),
        [(0, $eSLr0.ATL_EDITOR_SAVEBAR)]: (0, $irVI7.EXTENSION_POINT_EDITOR_SAVEBAR_EXPERIENCE)
    };
    const experienceName = EXPERIENCE_NAME_BY_LOCATION[location] || null;
    (0, $cozmU.useEffect)(()=>{
        if (experienceName) experienceTracker.start({
            name: experienceName
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const variables = $0aea74171df1eb15$var$getWebPanelLocationVariables({
        location: location,
        contentIdentifier: contentIdentifier,
        spaceIdentifier: spaceIdentifier
    });
    (0, $cozmU.useEffect)(()=>{
        if (batchResult?.loading || batchResult?.error || !batchResult?.data || !onCompleted) return;
        const batchResultKey = `${contentIdentifier || ''}:${spaceIdentifier || ''}:${location}`;
        if (completedBatchResultKeyRef.current !== batchResultKey) {
            completedBatchResultKeyRef.current = batchResultKey;
            onCompleted();
        }
    }, [
        batchResult,
        contentIdentifier,
        location,
        onCompleted,
        spaceIdentifier
    ]);
    // TODO: The task to remove this hack is captured in CFE-1873.
    // There's some weird scenario where the UI ends up with a space key of "byDraft" relating to the way tinymce
    // creates content. Given that it's tinymce specific, I'm applying this hack for now and we can remove it once we're
    // at 100% rollout for the Fabric editor.
    if (spaceIdentifier === 'byDraft') return null;
    const renderWebPanels = ({ data: data, loading: loading, error: error })=>{
        if (!renderWhenLoading) {
            if (error || !data || loading && !(0, $9wGTI.fg)('confluence_web_panel_location_render_loading')) return null;
        }
        let panels = (data?.webPanels || []).filter((panel)=>panel);
        panels = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, panels);
        // For panels that don't have a placeholder
        if (!renderWhenLoading && !panels.length) {
            if (experienceName) experienceTracker.succeed({
                name: experienceName
            });
            return null;
        }
        const shouldMemoizeAtlGeneralWebPanel = location === (0, $eSLr0.ATL_GENERAL) && (0, $6mKj3.expValEquals)('confluence_memorize_atl_general_connect', 'isEnabled', true);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$UFOWebPanelLocationWrapper, {
            locationName: location,
            panels: panels
        }, children ? children({
            panels: panels
        }) : panels.map((panel)=>{
            return shouldMemoizeAtlGeneralWebPanel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$MemoizedAtlGeneralWebPanel, {
                key: panel.completeKey,
                panel: panel
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqPSe.WebPanel), {
                key: panel.completeKey,
                panelId: panel.completeKey,
                html: panel.html,
                panelLocation: location
            });
        })), experienceName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: experienceName
        }) : null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        /* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: style,
        "data-vc-ignore-if-no-layout-shift": true
    }, batchResult ? renderWebPanels(batchResult) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
        query: $0aea74171df1eb15$export$d97dfe528d83a912,
        variables: variables,
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted,
        __callerPackage__: "web-panel-location"
    }, renderWebPanels));
};
function $0aea74171df1eb15$var$_temp(panel) {
    return panel.html !== "";
}
function $0aea74171df1eb15$var$_temp2(panel_0) {
    return panel_0.completeKey;
}
module.exports["WebPanelLocationQuery"] = $0aea74171df1eb15$export$d97dfe528d83a912;
module.exports["useWebPanelLocationBatchResult"] = $0aea74171df1eb15$export$784950ebf49d8a5f;
module.exports["WebPanelLocationBatchProvider"] = $0aea74171df1eb15$export$2c530b46a1768809;
module.exports["WebPanelLocation"] = $0aea74171df1eb15$export$2482f01f112556a;

});

parcelRegister("1eaCJ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $03574d8c2683228e$export$4962f3898bd5c829(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { name: name, attributes: attributes } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== experienceTracker || $[2] !== name) {
        t1 = ()=>experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        t2 = [
            name,
            attributes,
            experienceTracker
        ];
        $[0] = attributes;
        $[1] = experienceTracker;
        $[2] = name;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceSuccess"] = $03574d8c2683228e$export$4962f3898bd5c829;

});

parcelRegister("3QyBm", function(module, exports) {

var $1xpoY = parcelRequire("1xpoY");

const $e9dc2b5b8bc8054b$export$888fec185e58bf9c = (location, items)=>{
    const locationsToHideConnectApps = (0, $1xpoY.default).getStringList('confluence_frontend_hidden_extension_points', []);
    const loc = Array.isArray(location) ? location[0] : location;
    if (locationsToHideConnectApps.includes(loc)) items = items.filter((item)=>!item?.completeKey?.startsWith('com.atlassian.plugins.atlassian-connect-plugin:'));
    return items;
};
module.exports["filterConnectAppsFromExtensionPoints"] = $e9dc2b5b8bc8054b$export$888fec185e58bf9c;

});

parcelRegister("iqPSe", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $brpfO = parcelRequire("brpfO");


var $gH1Fi = parcelRequire("gH1Fi");


var $ep3mz = parcelRequire("ep3mz");


var $eSLr0 = parcelRequire("eSLr0");

function $c50a10795e04dcb9$export$bbe14c99ac0820b3(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { html: html, panelId: panelId, panelLocation: panelLocation } = t0;
    const containerRef = (0, $cozmU.useRef)(null);
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentId: contentId, spaceKey: spaceKey } = t1;
    const dimensionsRef = (0, $gH1Fi.useExtensionDimensions)(panelLocation === (0, $eSLr0.ATL_GENERAL) ? (0, $eSLr0.ATL_GENERAL) : undefined, panelId, contentId || spaceKey || "");
    let t2;
    if ($[0] !== dimensionsRef) {
        t2 = (element)=>{
            containerRef.current = element;
            dimensionsRef(element);
        };
        $[0] = dimensionsRef;
        $[1] = t2;
    } else t2 = $[1];
    const panelRef = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const container = containerRef.current;
            if (!container) return;
            (0, $brpfO.evalLegacyConnectInlineScripts)(container);
        };
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== html || $[4] !== panelId) {
        t4 = [
            html,
            panelId
        ];
        $[3] = html;
        $[4] = panelId;
        $[5] = t4;
    } else t4 = $[5];
    (0, $cozmU.useLayoutEffect)(t3, t4);
    let t5;
    if ($[6] !== html) {
        t5 = {
            __html: html
        };
        $[6] = html;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== panelRef || $[9] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: panelRef,
            "data-vc-ignore-if-no-layout-shift": true,
            dangerouslySetInnerHTML: t5
        });
        $[8] = panelRef;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
}
module.exports["WebPanel"] = $c50a10795e04dcb9$export$bbe14c99ac0820b3;

});

parcelRegister("brpfO", function(module, exports) {

var $cpjd2 = parcelRequire("cpjd2");

const $5886a35f608ee97f$var$evalScripts = (allScripts)=>{
    allScripts.forEach((elementScript)=>{
        /**
		 * When evaluating the connect scripts, the eval function inherits the context in which is it called.
		 *
		 * This means that the eval function will have access to the variables and functions
		 * in the current scope. One of these variables is the `require` passed in from Atlaspack's module system.
		 *
		 * Since the eval scripts rely on AMD's require being globally available, and Atlaspack
		 * is now shadowing that variable, we need to evaluate the scripts in the global scope.
		 *
		 * We can do this using "indirect" eval, see the MDN docs for more info:
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/eval#direct_and_indirect_eval
		 *
		 * Assigning the eval function to a variable is enough to trigger the indirect eval behavior,
		 * and the scripts will be able to access the global require.
		 */ const evalInGlobalScope = eval;
        evalInGlobalScope(elementScript.innerHTML);
    });
};
function $5886a35f608ee97f$export$5beb7086100d432e(container, isEarlyInitFGEnabled = false) {
    // Connect macros have an inline script that doesn't work automatically when
    // rendered in react using dangerouslySetInnerHTML. This script evaluates any
    // connect macro.
    if (!container) return Promise.reject(new Error('evalLegacyConnectInlineScripts missing container argument'));
    const connectScripts = Array.from(container.querySelectorAll('script.ap-iframe-body-script'));
    const macroScripts = Array.from(container.querySelectorAll('script.cc-macro-body-script'));
    const allScripts = connectScripts.concat(macroScripts);
    // If the connect resources are preloaded, we don't need to download them again, just evaluate the scripts.
    if (window.__CONNECT_RESOURCES_PRELOADED__ && isEarlyInitFGEnabled) {
        $5886a35f608ee97f$var$evalScripts(allScripts);
        return Promise.resolve(null);
    }
    return new Promise((resolve)=>{
        if (allScripts.length > 0) // Download the connect web resources required to render an add-on before evaluating the inline scripts.
        (0, $cpjd2.requireLegacyWRM)([
            // ensure navigator-context misc dep is loaded before navigator-context
            'wr!confluence.web.resources:querystring',
            // resource to provide the context value of AP.navigator.getLocation
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ], ()=>{
            $5886a35f608ee97f$var$evalScripts(allScripts);
            resolve(null);
        }, ()=>{});
        else resolve(null);
    });
}
module.exports["evalLegacyConnectInlineScripts"] = $5886a35f608ee97f$export$5beb7086100d432e;

});

parcelRegister("gH1Fi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $e4o8D = parcelRequire("e4o8D");


var $7W9kD = parcelRequire("7W9kD");

const $46bdebab359d4884$export$8adc0cb9461bf99f = (source, extensionId, contextKey)=>{
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const cleanup = (0, $cozmU.useRef)(undefined);
    // The observation belongs to this page context, even when React reuses its DOM node.
    const observationContext = (0, $cozmU.useMemo)(()=>({
            source: source,
            extensionId: extensionId,
            contextKey: contextKey
        }), [
        source,
        extensionId,
        contextKey
    ]);
    return (0, $cozmU.useCallback)((element)=>{
        const { source: source, extensionId: extensionId } = observationContext;
        cleanup.current?.();
        cleanup.current = undefined;
        if (!renderServerPlaceholder && element && source && extensionId && (0, $9wGTI.fg)('confluence_ufo_banner_extension_dimensions')) cleanup.current = (0, $7W9kD.observeExtensionDimensions)(element, source, extensionId);
    }, [
        observationContext,
        renderServerPlaceholder
    ]);
};
module.exports["useExtensionDimensions"] = $46bdebab359d4884$export$8adc0cb9461bf99f;

});

parcelRegister("1PPDm", function(module, exports) {
"use strict";
var $15629b4bdedac47d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @name catchError
 */ function $15629b4bdedac47d$var$catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new $15629b4bdedac47d$var$CatchOperator(selector);
        var caught = source.lift(operator);
        return operator.caught = caught;
    };
}
module.exports.catchError = $15629b4bdedac47d$var$catchError;
var $15629b4bdedac47d$var$CatchOperator = function() {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $15629b4bdedac47d$var$CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $15629b4bdedac47d$var$CatchSubscriber = function(_super) {
    $15629b4bdedac47d$var$__extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        _super.call(this, destination);
        this.selector = selector;
        this.caught = caught;
    }
    // NOTE: overriding `error` instead of `_error` because we don't want
    // to have this flag this subscriber as `isStopped`. We can mimic the
    // behavior of the RetrySubscriber (from the `retry` operator), where
    // we unsubscribe from our source chain, reset our Subscriber flags,
    // then subscribe to the selector result.
    CatchSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            } catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            this.add($863V0.subscribeToResult(this, result));
        }
    };
    return CatchSubscriber;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=catchError.js.map

});

parcelRegister("1xJn2", function(module, exports) {
"use strict";
var $11fc112c79ff43c4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $aRdp2 = parcelRequire("aRdp2");


var $iMtch = parcelRequire("iMtch");

/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */ function $11fc112c79ff43c4$var$distinctUntilChanged(compare, keySelector) {
    return function(source) {
        return source.lift(new $11fc112c79ff43c4$var$DistinctUntilChangedOperator(compare, keySelector));
    };
}
module.exports.distinctUntilChanged = $11fc112c79ff43c4$var$distinctUntilChanged;
var $11fc112c79ff43c4$var$DistinctUntilChangedOperator = function() {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $11fc112c79ff43c4$var$DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $11fc112c79ff43c4$var$DistinctUntilChangedSubscriber = function(_super) {
    $11fc112c79ff43c4$var$__extends(DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.hasKey = false;
        if (typeof compare === 'function') this.compare = compare;
    }
    DistinctUntilChangedSubscriber.prototype.compare = function(x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function(value) {
        var keySelector = this.keySelector;
        var key = value;
        if (keySelector) {
            key = $aRdp2.tryCatch(this.keySelector)(value);
            if (key === $iMtch.errorObject) return this.destination.error($iMtch.errorObject.e);
        }
        var result = false;
        if (this.hasKey) {
            result = $aRdp2.tryCatch(this.compare)(this.key, key);
            if (result === $iMtch.errorObject) return this.destination.error($iMtch.errorObject.e);
        } else this.hasKey = true;
        if (Boolean(result) === false) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=distinctUntilChanged.js.map

});

parcelRegister("ebEo2", function(module, exports) {
"use strict";
var $a5416bba69d7cff3$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */ function $a5416bba69d7cff3$var$skipWhile(predicate) {
    return function(source) {
        return source.lift(new $a5416bba69d7cff3$var$SkipWhileOperator(predicate));
    };
}
module.exports.skipWhile = $a5416bba69d7cff3$var$skipWhile;
var $a5416bba69d7cff3$var$SkipWhileOperator = function() {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a5416bba69d7cff3$var$SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a5416bba69d7cff3$var$SkipWhileSubscriber = function(_super) {
    $a5416bba69d7cff3$var$__extends(SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.skipping = true;
        this.index = 0;
    }
    SkipWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (this.skipping) this.tryCallPredicate(value);
        if (!this.skipping) destination.next(value);
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function(value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=skipWhile.js.map

});

parcelRegister("c7Xul", function(module, exports) {
"use strict";
var $8d4448aad9d90f95$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */ function $8d4448aad9d90f95$var$switchMap(project, resultSelector) {
    return function switchMapOperatorFunction(source) {
        return source.lift(new $8d4448aad9d90f95$var$SwitchMapOperator(project, resultSelector));
    };
}
module.exports.switchMap = $8d4448aad9d90f95$var$switchMap;
var $8d4448aad9d90f95$var$SwitchMapOperator = function() {
    function SwitchMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $8d4448aad9d90f95$var$SwitchMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchMapOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $8d4448aad9d90f95$var$SwitchMapSubscriber = function(_super) {
    $8d4448aad9d90f95$var$__extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapSubscriber.prototype._next = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result, value, index);
    };
    SwitchMapSubscriber.prototype._innerSub = function(result, value, index) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        this.add(this.innerSubscription = $863V0.subscribeToResult(this, result, value, index));
    };
    SwitchMapSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ SwitchMapSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = null;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) this._tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex);
        else this.destination.next(innerValue);
    };
    SwitchMapSubscriber.prototype._tryNotifyNext = function(outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return SwitchMapSubscriber;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=switchMap.js.map

});

parcelRegister("1mLOG", function(module, exports) {
"use strict";
var $0fecefdacae1f75b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $zAMIg = parcelRequire("zAMIg");

function $0fecefdacae1f75b$var$timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = $zAMIg.async;
    return function(source) {
        return source.lift(new $0fecefdacae1f75b$var$TimeIntervalOperator(scheduler));
    };
}
module.exports.timeInterval = $0fecefdacae1f75b$var$timeInterval;
var $0fecefdacae1f75b$var$TimeInterval = function() {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}();
module.exports.TimeInterval = $0fecefdacae1f75b$var$TimeInterval;
var $0fecefdacae1f75b$var$TimeIntervalOperator = function() {
    function TimeIntervalOperator(scheduler) {
        this.scheduler = scheduler;
    }
    TimeIntervalOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $0fecefdacae1f75b$var$TimeIntervalSubscriber(observer, this.scheduler));
    };
    return TimeIntervalOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $0fecefdacae1f75b$var$TimeIntervalSubscriber = function(_super) {
    $0fecefdacae1f75b$var$__extends(TimeIntervalSubscriber, _super);
    function TimeIntervalSubscriber(destination, scheduler) {
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.lastTime = 0;
        this.lastTime = scheduler.now();
    }
    TimeIntervalSubscriber.prototype._next = function(value) {
        var now = this.scheduler.now();
        var span = now - this.lastTime;
        this.lastTime = now;
        this.destination.next(new $0fecefdacae1f75b$var$TimeInterval(value, span));
    };
    return TimeIntervalSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=timeInterval.js.map

});

parcelRegister("cmyqT", function(module, exports) {
"use strict";
var $90023fbe608f4f3c$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $zAMIg = parcelRequire("zAMIg");


var $fEWBj = parcelRequire("fEWBj");


var $fNVRJ = parcelRequire("fNVRJ");


var $a6ieS = parcelRequire("a6ieS");

/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */ function $90023fbe608f4f3c$var$timeout(due, scheduler) {
    if (scheduler === void 0) scheduler = $zAMIg.async;
    var absoluteTimeout = $fEWBj.isDate(due);
    var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
    return function(source) {
        return source.lift(new $90023fbe608f4f3c$var$TimeoutOperator(waitFor, absoluteTimeout, scheduler, new $a6ieS.TimeoutError()));
    };
}
module.exports.timeout = $90023fbe608f4f3c$var$timeout;
var $90023fbe608f4f3c$var$TimeoutOperator = function() {
    function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
    }
    TimeoutOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $90023fbe608f4f3c$var$TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
    };
    return TimeoutOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $90023fbe608f4f3c$var$TimeoutSubscriber = function(_super) {
    $90023fbe608f4f3c$var$__extends(TimeoutSubscriber, _super);
    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutSubscriber.dispatchTimeout = function(subscriber) {
        subscriber.error(subscriber.errorInstance);
    };
    TimeoutSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.errorInstance = null;
    };
    return TimeoutSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=timeout.js.map

});

parcelRegister("a6ieS", function(module, exports) {
"use strict";
var $75a89ccb17a412ff$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when duetime elapses.
 *
 * @see {@link timeout}
 *
 * @class TimeoutError
 */ var $75a89ccb17a412ff$var$TimeoutError = function(_super) {
    $75a89ccb17a412ff$var$__extends(TimeoutError, _super);
    function TimeoutError() {
        var err = _super.call(this, 'Timeout has occurred');
        this.name = err.name = 'TimeoutError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return TimeoutError;
}(Error);
module.exports.TimeoutError = $75a89ccb17a412ff$var$TimeoutError; //# sourceMappingURL=TimeoutError.js.map

});

parcelRegister("4Otfs", function(module, exports) {
"use strict";
var $3812850d794e9fac$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gGP9M = parcelRequire("gGP9M");


var $371EO = parcelRequire("371EO");

/**
 * @class BehaviorSubject<T>
 */ var $3812850d794e9fac$var$BehaviorSubject = function(_super) {
    $3812850d794e9fac$var$__extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        _super.call(this);
        this._value = _value;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    /** @deprecated internal use only */ BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        if (this.hasError) throw this.thrownError;
        else if (this.closed) throw new $371EO.ObjectUnsubscribedError();
        else return this._value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}($gGP9M.Subject);
module.exports.BehaviorSubject = $3812850d794e9fac$var$BehaviorSubject; //# sourceMappingURL=BehaviorSubject.js.map

});

parcelRegister("1a6Dn", function(module, exports) {

var $hrAmX = parcelRequire("hrAmX");


var $a4dgs = parcelRequire("a4dgs");

class $d3905c2d386f370c$export$c59406a16f2704a5 extends (0, $a4dgs.BaseStateContainer) {
    constructor(...args){
        super(...args);
        this.state = {
            floatingBanners: []
        };
        this.showFloating = (name, height)=>{
            // The lookup has to happen inside the updater: updates queued in the same microtask are
            // applied in sequence, so an index resolved beforehand would already be stale.
            this.setState((state)=>{
                const index = (0, $hrAmX.findBanner)(name, state.floatingBanners);
                if (index === -1) return {
                    ...state,
                    floatingBanners: [
                        ...state.floatingBanners,
                        {
                            name: name,
                            height: height
                        }
                    ]
                };
                if (state.floatingBanners[index].height !== height) {
                    const newArray = [
                        ...state.floatingBanners
                    ];
                    // Replace rather than mutate, so the previous state keeps the old height.
                    newArray[index] = {
                        name: name,
                        height: height
                    };
                    return {
                        ...state,
                        floatingBanners: newArray
                    };
                }
                return undefined;
            });
        };
        this.hideFloating = (name)=>{
            this.setState((state)=>{
                const index = (0, $hrAmX.findBanner)(name, state.floatingBanners);
                if (index > -1) {
                    const newArray = [
                        ...state.floatingBanners
                    ];
                    newArray.splice(index, 1);
                    return {
                        ...state,
                        floatingBanners: newArray
                    };
                }
                return undefined;
            });
        };
        this.getFloatingHeightBefore = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) return 0;
            return this.state.floatingBanners.slice(0, index).reduce((height, banner)=>{
                return height + banner.height;
            }, 0);
        };
        this.getFloatingHeight = ()=>this.state.floatingBanners.reduce((height, banner)=>height + banner.height, 0);
    }
}
module.exports["FloatingBannerStateContainer"] = $d3905c2d386f370c$export$c59406a16f2704a5;

});

parcelRegister("8WfxO", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eSLr0 = parcelRequire("eSLr0");


var $ep3mz = parcelRequire("ep3mz");


var $6mKj3 = parcelRequire("6mKj3");


var $dS3n9 = parcelRequire("dS3n9");

const $720c81ac24834d84$export$dc9cc84753faedac = ()=>{
    const $ = (0, $bDgLe.c)(10);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const atlGeneralHeightChanges = (0, $cozmU.useRef)(t0);
    const [webPanelHeight, setWebPanelHeight] = (0, $cozmU.useState)($720c81ac24834d84$var$_temp);
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentId: contentId, spaceKey: spaceKey } = t1;
    let t2;
    if ($[1] !== contentId || $[2] !== spaceKey) {
        t2 = {
            location: (0, $eSLr0.ATL_GENERAL),
            fetchPolicy: "cache-first",
            spaceKey: spaceKey,
            contentId: contentId
        };
        $[1] = contentId;
        $[2] = spaceKey;
        $[3] = t2;
    } else t2 = $[3];
    const { panels: panels } = (0, $dS3n9.useWebPanelLocation)(t2);
    const isATLGeneralWebPanelFixed = panels.length > 0;
    let t3;
    let t4;
    if ($[4] !== isATLGeneralWebPanelFixed) {
        t3 = ()=>{
            const listener = (e)=>{
                let newHeight;
                if ((0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) {
                    setWebPanelHeight(e?.detail?.height ?? 0);
                    newHeight = e?.detail?.height ?? 0;
                } else {
                    setWebPanelHeight($720c81ac24834d84$var$getAtlGeneralWebPanelHeight());
                    newHeight = $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
                }
                if (typeof window !== "undefined" && Boolean(window.__SSR_RENDERED__)) {
                    const lastHeight = atlGeneralHeightChanges.current.length === 0 ? window.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__ || 0 : atlGeneralHeightChanges.current[atlGeneralHeightChanges.current.length - 1];
                    if (lastHeight !== newHeight) atlGeneralHeightChanges.current.push(newHeight);
                    window.__ATL_GENERAL_WEBPANEL_HEIGHT_CHANGES__ = atlGeneralHeightChanges.current;
                }
            };
            if (isATLGeneralWebPanelFixed) document.addEventListener("atlGeneralWebPanelHeightUpdated", listener);
            return ()=>{
                if (isATLGeneralWebPanelFixed) document.removeEventListener("atlGeneralWebPanelHeightUpdated", listener);
            };
        };
        t4 = [
            isATLGeneralWebPanelFixed
        ];
        $[4] = isATLGeneralWebPanelFixed;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[7] !== isATLGeneralWebPanelFixed || $[8] !== webPanelHeight) {
        t5 = {
            isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed,
            atlGeneralWebPanelHeight: webPanelHeight
        };
        $[7] = isATLGeneralWebPanelFixed;
        $[8] = webPanelHeight;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
};
const $720c81ac24834d84$var$getAtlGeneralWebPanelHeight = ()=>{
    if (typeof document === 'undefined') return 0;
    return parseInt(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    getComputedStyle(document.documentElement).getPropertyValue('--atl-general-webpanel-height')) || 0;
};
function $720c81ac24834d84$var$_temp() {
    if (typeof window !== "undefined" && Boolean(window.__SSR_RENDERED__) && (0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) {
        const initialHeight = window.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__;
        return initialHeight ?? 0;
    } else return $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
}
module.exports["useATLGeneralWebPanelListener"] = $720c81ac24834d84$export$dc9cc84753faedac;

});

parcelRegister("dS3n9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $eSLr0 = parcelRequire("eSLr0");


var $9Z1sw = parcelRequire("9Z1sw");

const $9fffd50bbcc7c343$export$c8daa7260f75e213 = ({ spaceKey: spaceKey, contentId: contentId, location: location, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', onCompleted: onCompleted })=>{
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    const spaceIdentifier = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, 'spaceKey') || (0, $c3Qwv.getSingleParam)(queryParams, 'key');
    const contentIdentifier = contentId || (0, $c3Qwv.getSingleParam)(queryParams, 'pageId');
    const variables = contentIdentifier ? {
        contentId: contentIdentifier,
        location: location
    } : {
        spaceKey: spaceIdentifier,
        location: location
    };
    const batchResult = (0, $9Z1sw.useWebPanelLocationBatchResult)(location);
    const batchResultData = batchResult?.data;
    const batchResultError = batchResult?.error;
    const batchResultLoading = batchResult?.loading;
    const completedBatchResultKeyRef = (0, $cozmU.useRef)(null);
    const baseOptions = {
        variables: variables,
        skip: Boolean(batchResult),
        ...onCompleted && {
            onCompleted: onCompleted
        }
    };
    // Keep watching query for home route to avoid VC90 regression
    const useNoFurtherUpdate = location !== (0, $eSLr0.DASHBOARD_SECONDARY);
    const { loading: loading, data: data, error: error } = useNoFurtherUpdate ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        __callerPackage__: "web-panel-location"
    }) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: fetchPolicy,
        __callerPackage__: "web-panel-location"
    });
    const result = batchResult ?? {
        loading: loading,
        data: data,
        error: error
    };
    (0, $cozmU.useEffect)(()=>{
        if (batchResultLoading || batchResultError || !batchResultData || !onCompleted) return;
        const batchResultKey = `${contentIdentifier || ''}:${spaceIdentifier || ''}:${location}`;
        if (completedBatchResultKeyRef.current !== batchResultKey) {
            completedBatchResultKeyRef.current = batchResultKey;
            onCompleted();
        }
    }, [
        batchResultData,
        batchResultError,
        batchResultLoading,
        contentIdentifier,
        location,
        onCompleted,
        spaceIdentifier
    ]);
    const panels = (result.data?.webPanels || []).filter((panel)=>panel);
    return {
        panels: panels,
        loading: result.loading,
        error: result.error
    };
};
module.exports["useWebPanelLocation"] = $9fffd50bbcc7c343$export$c8daa7260f75e213;

});

parcelRegister("7VJPz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6B1vK = parcelRequire("6B1vK");

var $aBKty = parcelRequire("aBKty");


var $aJPUt = parcelRequire("aJPUt");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");


var $au7xi = parcelRequire("au7xi");


var $1lyRS = parcelRequire("1lyRS");

const $cd53535796fd282e$export$16ffa5f7b88dc45f = ({ contentId: contentId, contentType: contentType, cloudId: cloudId })=>{
    const extensionHandlers = {};
    extensionHandlers[0, $au7xi.smartButtonExtensionType] = (extension)=>{
        const pageAri = contentId ? (0, $6B1vK.ConfluencePageAri).create({
            siteId: cloudId,
            pageId: contentId
        }).toString() : undefined;
        const site = (0, $aBKty.ConfluenceSiteAri).create({
            siteId: cloudId
        }).toString();
        const experienceName = (0, $5kjCz.getExperienceName)((0, $5kjCz.RENDERER), extension);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4KFTW.MacroExperienceStart), {
            name: experienceName,
            contentId: contentId ?? '',
            mode: (0, $5kjCz.RENDERER),
            extensionKey: extension.extensionKey,
            attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(extension),
            timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1lyRS.SmartButtonLoader), {
            ruleId: extension.parameters?.ruleId,
            scopeId: extension.parameters?.scopeId,
            pageAri: pageAri,
            site: site,
            smartButtonName: extension.parameters?.smartButtonName,
            experienceTrackerName: experienceName,
            contentId: contentId ?? '',
            contentType: contentType ?? '',
            isViewMode: true
        }));
    };
    return extensionHandlers;
};
module.exports["getRendererSmartButtonExtensionHandlers"] = $cd53535796fd282e$export$16ffa5f7b88dc45f;

});

parcelRegister("5kjCz", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $irVI7 = parcelRequire("irVI7");


var $glCMv = parcelRequire("glCMv");


var $fGzMp = parcelRequire("fGzMp");


var $kmyYx = parcelRequire("kmyYx");


var $aJPUt = parcelRequire("aJPUt");


var $04e9M = parcelRequire("04e9M");


var $78QFu = parcelRequire("78QFu");


var $9Cbhx = parcelRequire("9Cbhx");

const $44f37a86f8c1409e$export$c3c3c3f81a03570c = 'renderer';
const $44f37a86f8c1409e$export$e70b8cd540123fd4 = 'editor';
const $44f37a86f8c1409e$export$f783453b83c906eb = 'pdf';
const $44f37a86f8c1409e$var$ACTION = {
    SUCCESS: 'taskSuccess',
    FAIL: 'taskFail',
    ABORT: 'taskAbort',
    START: 'taskStart'
};
const $44f37a86f8c1409e$export$84a4de0ef6621278 = (name)=>name.split('.').slice(1).join('.');
const $44f37a86f8c1409e$export$b94fa6ed199caed2 = (macroEventRegister = new Map())=>{
    const macros = [];
    // @ts-ignore
    for (const v of macroEventRegister.values()){
        const { name: name } = v;
        if (name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) {
            const macro = {
                uniqueHash: $44f37a86f8c1409e$export$84a4de0ef6621278(name),
                ...$44f37a86f8c1409e$export$ae13022b12e7d19a(v)
            };
            macros.push(macro);
        }
    }
    return macros;
};
const $44f37a86f8c1409e$export$c1196ba2be68e8d3 = (macro)=>{
    return {
        type: macro?.type || '',
        macroId: (0, $9Cbhx.getMacroId)(macro?.parameters),
        extensionKey: (0, $9Cbhx.getExtensionKey)(macro),
        extensionType: macro?.extensionType || ''
    };
};
const $44f37a86f8c1409e$export$ae13022b12e7d19a = (macroEvent)=>{
    return {
        extensionKey: (0, $9Cbhx.getExtensionKey)(macroEvent?.experienceAttributes),
        extensionType: macroEvent?.experienceAttributes?.extensionType || '',
        type: macroEvent?.experienceAttributes?.type || '',
        macroId: macroEvent?.experienceAttributes?.macroId || '',
        duration: macroEvent?.duration || '',
        status: macroEvent?.status || '',
        pageId: macroEvent?.pageId || ''
    };
};
const $44f37a86f8c1409e$export$b16b3cab64ff0bd4 = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) return;
    $44f37a86f8c1409e$export$f7c63e38d5d9fd0b(mode, contentId).start({
        attributes: {
            mode: mode
        },
        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
        id: contentId
    });
};
const $44f37a86f8c1409e$export$f9ebd83e8406755f = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) {
        if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister)) {
            const macroAttributes = {
                mode: mode,
                macros: null
            };
            if ($44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) macroAttributes.macros = $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister);
            (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    ...macroAttributes
                }
            });
        } else (0, $fGzMp.getExperienceTracker)().abort({
            name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
            reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
            attributes: {
                macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                mode: mode
            }
        });
        const jiraMacro = $44f37a86f8c1409e$export$32db3a6a0c8b81ea(macroEventRegister);
        jiraMacro.forEach((macro)=>{
            const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
            const status = macro.status;
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: status,
                    attributes: {
                        ...macro.experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`
                    }
                });
            });
        });
        // clean up after aborting all event
        macroEventRegister.clear();
        $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
    }
};
const $44f37a86f8c1409e$export$d693932e457c5586 = (eventRegister = new Map())=>{
    if (eventRegister.size === 0) return true;
    // only check whether all sub-experience has finished
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) return false;
    }
    return true;
};
const $44f37a86f8c1409e$export$375cf77d729480fb = (eventRegister = new Map())=>{
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) return true;
    }
    return false;
};
const $44f37a86f8c1409e$export$faf154bb66b40b64 = (name)=>name.includes((0, $9Cbhx.JIRA_EXTENSION_KEY));
const $44f37a86f8c1409e$export$f2ada44de4a33ea1 = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$32db3a6a0c8b81ea = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name)) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$98d7b4463a1de442 = (contentId, mode)=>{
    (function macroTimeout() {
        setTimeout(()=>{
            const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
            if (!macroEventRegister.has(contentId)) return;
            const pageEvent = macroEventRegister.get(contentId);
            const isTimedOut = Math.round(window.performance.now() - pageEvent.startTime) > (0, $aJPUt.ExperienceTimeout).MACRO_LOAD;
            // 1. all macro loaded or main-experience timeout and have sub-experience
            //    succeed the main experience and report to experience tracker and done
            if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister) && $44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            else if (isTimedOut) {
                // 2a. timeout does not has sub-experience, succeed the main experience
                if (!$44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                    name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                    attributes: {
                        mode: mode
                    }
                });
                else {
                    (0, $fGzMp.getExperienceTracker)().abort({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
                        attributes: {
                            macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                            mode: mode
                        }
                    });
                    const unsuceededJIRAMacro = $44f37a86f8c1409e$export$f2ada44de4a33ea1(macroEventRegister);
                    unsuceededJIRAMacro.forEach((macro)=>{
                        const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
                        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                            analyticsWebClient.sendOperationalEvent({
                                source: 'ui',
                                actionSubject: 'macroTracker',
                                action: 'taskAbort',
                                attributes: {
                                    ...macro.experienceAttributes,
                                    extensionKey: extensionKey,
                                    mode: mode,
                                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                                    reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                                }
                            });
                        });
                    });
                }
                // clean up after aborting all event
                macroEventRegister.clear();
                $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            } else macroTimeout();
        }, 2000);
    })();
};
const $44f37a86f8c1409e$var$macroEventRegisterHash = new Map();
const $44f37a86f8c1409e$export$adf8cb42c7fe1834 = (mode, contentId)=>{
    if ($44f37a86f8c1409e$var$macroEventRegisterHash.has(`${mode}.${contentId}`)) return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, new Map());
    return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
};
const $44f37a86f8c1409e$export$d7fca4196d2b6b6c = (mode, contentId, name, experienceAttributes)=>{
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
            analyticsWebClient.sendOperationalEvent({
                source: 'ui',
                actionSubject: 'macroTracker',
                action: 'taskStart',
                attributes: {
                    ...experienceAttributes,
                    extensionKey: extensionKey,
                    mode: mode,
                    pageId: contentId,
                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            });
        });
    }
};
const $44f37a86f8c1409e$export$d10b6dded8392899 = (mode, contentId, name, experienceAttributes)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    const macroId = experienceAttributes?.macroId;
    if (!macroEventRegister.has(macroId)) return;
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        const { status: status } = macroEventRegister.get(macroId);
        if (status === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskSuccess',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.ABORT) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskAbort',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.FAIL) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskFail',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        error: new (0, $glCMv.ExperienceTimeoutError)(`JIRA macro failed to complete in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`)
                    }
                });
            });
        }
    }
};
const $44f37a86f8c1409e$export$f7c63e38d5d9fd0b = (0, $dOBRD.default)((mode, contentId)=>{
    const macroTracker = new (0, $kmyYx.ExperienceTracker)();
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    macroTracker.subscribe((event)=>{
        const { action: action, name: name, attributes: experienceAttributes, ...rest } = event;
        const macroId = experienceAttributes?.macroId;
        if (action === $44f37a86f8c1409e$var$ACTION.START) {
            // prevent triggering of event
            const current = macroEventRegister.get(macroId);
            if (current && current.id === macroId) return;
            if (name === (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) // prevent firing the same view-all-macro more than once
            {
                if (!macroEventRegister.has(contentId)) {
                    // clear the event register, prevent event being re-tracked between SPA transition
                    macroEventRegister.clear();
                    (0, $fGzMp.getExperienceTracker)().start({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
                        id: contentId,
                        attributes: {
                            mode: mode
                        }
                    });
                    macroEventRegister.set(contentId, {
                        status: $44f37a86f8c1409e$var$ACTION.START,
                        name: name,
                        mode: mode,
                        ...rest
                    });
                    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
                }
            } else {
                // tracking each macro, report to MacroTracker
                macroEventRegister.set(macroId, {
                    status: $44f37a86f8c1409e$var$ACTION.START,
                    name: name,
                    experienceAttributes: {
                        ...experienceAttributes,
                        extensionKey: (0, $9Cbhx.getExtensionKey)(experienceAttributes)
                    },
                    pageId: contentId,
                    mode: mode,
                    ...rest
                });
                $44f37a86f8c1409e$export$d7fca4196d2b6b6c(mode, contentId, name, experienceAttributes);
            }
        } else if (action === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, name: name } = event;
            // tracking each macro when it successfully loads
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.SUCCESS,
                duration: duration,
                pageId: contentId
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action === $44f37a86f8c1409e$var$ACTION.ABORT) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, reason: reason, name: name } = event;
            // tracking each macro when it aborts loading
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.ABORT,
                duration: duration,
                pageId: contentId,
                reason: reason
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro aborts to load, aborts the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().abort({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                reason: 'Macro abort loading',
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action == $44f37a86f8c1409e$var$ACTION.FAIL) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, error: error, name: name } = event;
            // tracking each macro when it fails to load
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.FAIL,
                duration: duration,
                pageId: contentId,
                error: error
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro fails to load, fails the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().fail({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                error: error,
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode,
                    ...experienceAttributes
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        }
        $44f37a86f8c1409e$export$98d7b4463a1de442(contentId, mode);
    });
    return macroTracker;
});
const $44f37a86f8c1409e$export$4ce0bedef4e84bb7 = (mode, extension)=>{
    const attributes = $44f37a86f8c1409e$export$c1196ba2be68e8d3(extension);
    return `${mode}.${(0, $9Cbhx.getExtensionKey)(attributes)}.${attributes.macroId}`;
};
module.exports["RENDERER"] = $44f37a86f8c1409e$export$c3c3c3f81a03570c;
module.exports["EDITOR"] = $44f37a86f8c1409e$export$e70b8cd540123fd4;
module.exports["PDF"] = $44f37a86f8c1409e$export$f783453b83c906eb;
module.exports["getMacroAttributesFromADFNode"] = $44f37a86f8c1409e$export$c1196ba2be68e8d3;
module.exports["startMacroExperience"] = $44f37a86f8c1409e$export$b16b3cab64ff0bd4;
module.exports["getMacroExperienceTracker"] = $44f37a86f8c1409e$export$f7c63e38d5d9fd0b;
module.exports["stopMacroExperience"] = $44f37a86f8c1409e$export$f9ebd83e8406755f;
module.exports["stopJIRAMacro"] = $44f37a86f8c1409e$export$d10b6dded8392899;
module.exports["getExperienceName"] = $44f37a86f8c1409e$export$4ce0bedef4e84bb7;

});

parcelRegister("9Cbhx", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $hukUK = parcelRequire("hukUK");

const $9293ebd9645c82d6$export$7486394da5136452 = 'jira';
const $9293ebd9645c82d6$export$8d178e7efa3ed0e7 = 'issue-count';
const $9293ebd9645c82d6$export$c3f023baaa9b214b = 'table-view';
const $9293ebd9645c82d6$export$7d601f5ae4a82040 = 'single-issue';
const $9293ebd9645c82d6$export$47eae2202f029f6b = (parameters)=>{
    if (!parameters) return (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    const idFromNode = parameters?.macroMetadata?.macroId?.value;
    if (idFromNode) return idFromNode;
    // for macro that does not have unique macro id, we want to generate some unique id
    return (0, $hukUK.objectHash)(parameters);
};
const $9293ebd9645c82d6$export$218d96312e385949 = (attributes)=>{
    if (!attributes) return '';
    const { extensionKey: extensionKey } = attributes;
    const macroParams = attributes?.parameters?.macroParams;
    if (extensionKey === $9293ebd9645c82d6$export$7486394da5136452) return `${extensionKey}${$9293ebd9645c82d6$export$cc2f094f034c7f8f(macroParams)}`;
    return extensionKey;
};
const $9293ebd9645c82d6$export$cc2f094f034c7f8f = (macroParams)=>{
    const prefix = '-';
    if (macroParams?.count?.value === 'true') return prefix + $9293ebd9645c82d6$export$8d178e7efa3ed0e7;
    else if (macroParams?.columns && macroParams?.maximumIssues) return prefix + $9293ebd9645c82d6$export$c3f023baaa9b214b;
    else if (macroParams?.key?.value) return prefix + $9293ebd9645c82d6$export$7d601f5ae4a82040;
    return '';
};
module.exports["JIRA_EXTENSION_KEY"] = $9293ebd9645c82d6$export$7486394da5136452;
module.exports["getMacroId"] = $9293ebd9645c82d6$export$47eae2202f029f6b;
module.exports["getExtensionKey"] = $9293ebd9645c82d6$export$218d96312e385949;

});

parcelRegister("4KFTW", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $38a1fdadc870189c$export$ed05b2901e9d7d22({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name, timeout: timeout }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).start({
            attributes: attributes,
            name: name,
            timeout: timeout,
            id: attributes?.macroId || contentId
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name,
        timeout
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceStart"] = $38a1fdadc870189c$export$ed05b2901e9d7d22;

});

parcelRegister("2bAZx", function(module, exports) {
// inspired by https://github.com/kentcdodds/use-deep-compare-effect/blob/master/src/index.js
/* eslint react-hooks/exhaustive-deps: 0 */ //Todo: this is flawed because callback is not included in the dependency array generated by useDeepCompareMemoize
// if the callback function (all use cases I found were inline functions and therfore not passed as a ref, were passes to the dep array they would trigger a re-evaluation every render defeating the purpose
// in order to properly work and handle the callback function being changed, the callback argument must be a useCallback or other function passed by ref and have it be included in the memoized depenedency array

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");

function $a4fa77695d2683a4$export$db77f469fe79526e(callback, dependencies) {
    (0, $cozmU.useEffect)(callback, $a4fa77695d2683a4$var$useDeepCompareMemoize(dependencies));
}
//eslint-ignore react-hooks/exhaustive-deps
function $a4fa77695d2683a4$var$useDeepCompareMemoize(value) {
    const ref = (0, $cozmU.useRef)();
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(value, ref.current)) ref.current = value;
    return ref.current;
}
module.exports["useDeepCompareEffect"] = $a4fa77695d2683a4$export$db77f469fe79526e;

});

parcelRegister("au7xi", function(module, exports) {
const $ea41547e1b4f38b6$export$73185dbd06fc0dd8 = 'com.atlassian.automation.smart-button';
module.exports["smartButtonExtensionType"] = $ea41547e1b4f38b6$export$73185dbd06fc0dd8;

});

parcelRegister("1lyRS", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $16e92128cf9491a8$export$32d8d71ddecea49c = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "LmILK",
    name: "SmartButtonLoader",
    loader: async ()=>(await (parcelRequire("3oElO"))).SmartButton
});
module.exports["SmartButtonLoader"] = $16e92128cf9491a8$export$32d8d71ddecea49c;

});

parcelRegister("3oElO", function(module, exports) {

let $2792e9d5e9491ef8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2792e9d5e9491ef8$var$load("excC5"),
    $2792e9d5e9491ef8$var$load("6wr18"),
    $2792e9d5e9491ef8$var$load("2xKrc"),
    $2792e9d5e9491ef8$var$load("4AElS"),
    $2792e9d5e9491ef8$var$load("hhss7"),
    $2792e9d5e9491ef8$var$load("ffEVr"),
    $2792e9d5e9491ef8$var$load("lhkXg")
]).then(()=>parcelRequire('hLSQl'));

});

parcelRegister("cLo2u", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    const $ = (0, $bDgLe.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("hUS75", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $50ff55d614a641f6$export$720dc4209419df4e(name, error, mode, contentId, attributes, source) {
    if ((0, $6fil2.containsNetworkError)(error)) {
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).abort({
            name: name,
            reason: `Aborted ${name} because of network error: ${error.toString()}`,
            checkForTimeout: false,
            attributes: {
                ...attributes,
                source: source
            }
        });
        return;
    }
    (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
        name: name,
        error: error,
        attributes: {
            ...attributes,
            source: source
        }
    });
}
function $50ff55d614a641f6$export$d22b49804594ed4d({ attributes: attributes, children: children = null, error: error, contentId: contentId, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        if (error) $50ff55d614a641f6$export$720dc4209419df4e(name, error, mode, contentId, attributes, source);
        else (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        error,
        mode,
        name,
        source
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceStop"] = $50ff55d614a641f6$export$d22b49804594ed4d;

});

parcelRegister("bX5uj", function(module, exports) {

var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $b23c2b4e39153eb4$export$3462df5a881e125d({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceSuccess"] = $b23c2b4e39153eb4$export$3462df5a881e125d;

});

parcelRegister("lOeVN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8aF6s = parcelRequire("8aF6s");


var $jmjWc = parcelRequire("jmjWc");

function $926167cc1656a619$export$4be696be8a3bff13(props) {
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const propsRef = (0, $cozmU.useRef)();
    propsRef.current = props;
    return (0, $cozmU.useCallback)(()=>showModal($926167cc1656a619$var$FeedbackCollectorLoader, propsRef.current), [
        showModal
    ]);
}

const $926167cc1656a619$var$FeedbackCollectorLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "nSIir",
    name: "FeedbackCollectorLoader",
    loader: async ()=>(await (parcelRequire("5E8QK"))).FeedbackCollector
});
module.exports["useFeedbackCollector"] = $926167cc1656a619$export$4be696be8a3bff13;

});

parcelRegister("5E8QK", function(module, exports) {

let $41c78d93fde5dc21$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $41c78d93fde5dc21$var$load("4nZ85"),
    $41c78d93fde5dc21$var$load("hhss7"),
    $41c78d93fde5dc21$var$load("kHXvF"),
    $41c78d93fde5dc21$var$load("bUC6C")
]).then(()=>parcelRequire('cz7bE'));

});

parcelRegister("bflGB", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EemN = parcelRequire("9EemN");

parcelRequire("1syzX");


var $l65Bo = parcelRequire("l65Bo");


var $7aRa9 = parcelRequire("7aRa9");


var $1k6sE = parcelRequire("1k6sE");


var $4q9NN = parcelRequire("4q9NN");

if (typeof window !== 'undefined') {
    // allow to track events on specific elements
    const originalStopCallback = (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).prototype.stopCallback;
    // Note here should be function instead of arrow function as we want to preserve the context of this
    (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).prototype.stopCallback = function(...[e, element, combo]) {
        const isAllowed = (0, $1k6sE.MOUSETRAP_ALLOWED_ELEMENTS).map((className)=>element.classList.contains(className)).some((truthful)=>truthful);
        const isAllowedInModal = (0, $1k6sE.MOUSETRAP_ALLOWED_MODALS).map((className)=>element.closest(`.${className}`)).some((truthful)=>truthful);
        return isAllowed || isAllowedInModal ? false : originalStopCallback.call(this, e, element, combo);
    };
}
const $299ae5ea83dc6310$var$ALLOWED_MIN_TIME = 150;
var $299ae5ea83dc6310$export$99058db374262376 = /*#__PURE__*/ function(ShortcutType) {
    ShortcutType["Confluence"] = "Confluence";
    ShortcutType["Forge"] = "Forge";
    return ShortcutType;
}({});
class $299ae5ea83dc6310$export$d29b063d6e86bfeb extends (0, $cozmU.PureComponent) {
    componentDidMount() {
        const { accelerator: accelerator, shortcutType: shortcutType = "Confluence" } = this.props;
        this.checkConflictThenBindAccelerator(accelerator, shortcutType);
    }
    componentDidUpdate(prevProps) {
        const { accelerator: prevAccelerator } = prevProps;
        const { accelerator: accelerator, shortcutType: shortcutType = "Confluence" } = this.props;
        const prevAccelerators = this.getAccelerators(prevAccelerator);
        // Using JSON.stringify to compare because accelerator may be a list of strings
        if (JSON.stringify(prevAccelerator) !== JSON.stringify(accelerator)) {
            this.unbindAccelerators(prevAccelerators);
            this.checkConflictThenBindAccelerator(accelerator, shortcutType);
        }
    }
    componentWillUnmount() {
        const { accelerator: accelerator } = this.props;
        const accelerators = this.getAccelerators(accelerator);
        this.unbindAccelerators(accelerators);
    }
    getAccelerators(accelerator) {
        return Array.isArray(accelerator) ? accelerator : [
            accelerator
        ];
    }
    getShortcutConflicts(accelerators) {
        return accelerators.map((a)=>({
                accelerator: a,
                conflictType: $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a]
            })).filter((o)=>o.conflictType);
    }
    isConfluenceShortcutAndAllConflictsAreForgeShortcuts(shortcutType, shortcutConflicts) {
        return shortcutType === "Confluence" && shortcutConflicts.every((o)=>o.conflictType === "Forge");
    }
    checkConflictThenBindAccelerator(accelerator, shortcutType) {
        const accelerators = this.getAccelerators(accelerator);
        const shortcutConflicts = this.getShortcutConflicts(accelerators);
        if (!shortcutConflicts.length) this.bindAccelerators(accelerators, shortcutType);
        else if (this.isConfluenceShortcutAndAllConflictsAreForgeShortcuts(shortcutType, shortcutConflicts)) {
            shortcutConflicts.forEach((c)=>(0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).unbind(c.accelerator));
            this.bindAccelerators(accelerators, shortcutType);
        }
    }
    bindAccelerators(accelerators, shortcutType) {
        accelerators.forEach((a)=>{
            if (a.includes('+') && shortcutType !== "Forge" && typeof (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).bindGlobal === 'function') // bindGlobal allows shortcut to work when a input field is focused, see https://github.com/ccampbell/mousetrap/blob/master/plugins/global-bind/README.md
            // This allows user to use shortcut to publish the page when focusing on editor title
            (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).bindGlobal(a, this._call);
            else (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).bind(a, this._call);
            $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a] = shortcutType;
        });
    }
    unbindAccelerators(accelerators) {
        accelerators.forEach((a)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).unbind(a);
            delete $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a];
        });
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        this.listeners = {};
        this.lastFired = 0;
        this._call = (e, combo)=>{
            // User can only fire a shortcut event in every 150ms
            // This can avoid a part of sequence being recognized as a single key shortcut
            // eg: "s" will be triggered when user enters "g s" without this
            const now = Date.now();
            if (now - this.lastFired >= $299ae5ea83dc6310$var$ALLOWED_MIN_TIME) {
                if (this.props.allowInDialog || !(0, $l65Bo.isDialogShown)()) {
                    this.lastFired = now;
                    this.props.listener(e, combo);
                }
            }
        };
    }
}
$299ae5ea83dc6310$export$d29b063d6e86bfeb.defaultProps = {
    allowInDialog: false,
    shortcutType: "Confluence"
};
$299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners = {};
const $299ae5ea83dc6310$var$ShortcutListenerFC = (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    let accelerator;
    let deprecatedAccelerator;
    let flags;
    let listener;
    let otherProps;
    if ($[0] !== t0) {
        ({ flags: flags, deprecatedAccelerator: deprecatedAccelerator, accelerator: accelerator, listener: listener, ...otherProps } = t0);
        $[0] = t0;
        $[1] = accelerator;
        $[2] = deprecatedAccelerator;
        $[3] = flags;
        $[4] = listener;
        $[5] = otherProps;
    } else {
        accelerator = $[1];
        deprecatedAccelerator = $[2];
        flags = $[3];
        listener = $[4];
        otherProps = $[5];
    }
    let t1;
    if ($[6] !== accelerator || $[7] !== deprecatedAccelerator || $[8] !== flags || $[9] !== listener) {
        t1 = (e, combo)=>{
            (0, $4q9NN.maybeShowDeprecatedShortcutFlag)({
                flags: flags,
                acceleratorTriggered: combo,
                accelerator: accelerator,
                deprecatedAccelerator: deprecatedAccelerator
            });
            listener(e, combo);
        };
        $[6] = accelerator;
        $[7] = deprecatedAccelerator;
        $[8] = flags;
        $[9] = listener;
        $[10] = t1;
    } else t1 = $[10];
    const deprecatedListener = t1;
    let t2;
    if ($[11] !== deprecatedAccelerator || $[12] !== deprecatedListener || $[13] !== otherProps) {
        t2 = deprecatedAccelerator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($299ae5ea83dc6310$export$d29b063d6e86bfeb, {
            accelerator: deprecatedAccelerator,
            listener: deprecatedListener,
            ...otherProps
        });
        $[11] = deprecatedAccelerator;
        $[12] = deprecatedListener;
        $[13] = otherProps;
        $[14] = t2;
    } else t2 = $[14];
    let t3;
    if ($[15] !== accelerator || $[16] !== listener || $[17] !== otherProps) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($299ae5ea83dc6310$export$d29b063d6e86bfeb, {
            accelerator: accelerator,
            listener: listener,
            ...otherProps
        });
        $[15] = accelerator;
        $[16] = listener;
        $[17] = otherProps;
        $[18] = t3;
    } else t3 = $[18];
    let t4;
    if ($[19] !== t2 || $[20] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t2, t3);
        $[19] = t2;
        $[20] = t3;
        $[21] = t4;
    } else t4 = $[21];
    return t4;
};
const $299ae5ea83dc6310$export$52e6eadeebf8c534 = (0, $7aRa9.withFlags)($299ae5ea83dc6310$var$ShortcutListenerFC);
module.exports["ShortcutType"] = $299ae5ea83dc6310$export$99058db374262376;
module.exports["ShortcutListener"] = $299ae5ea83dc6310$export$52e6eadeebf8c534;

});

parcelRegister("1syzX", function(module, exports) {
/**
 * adds a bindGlobal method to Mousetrap that allows you to
 * bind specific keyboard shortcuts that will still work
 * inside a text input field
 *
 * usage:
 * Mousetrap.bindGlobal('ctrl+s', _saveChanges);
 */ /* global Mousetrap:true */ (function(Mousetrap1) {
    if (!Mousetrap1) return;
    var _globalCallbacks = {};
    var _originalStopCallback = Mousetrap1.prototype.stopCallback;
    Mousetrap1.prototype.stopCallback = function(e, element, combo, sequence) {
        var self = this;
        if (self.paused) return true;
        if (_globalCallbacks[combo] || _globalCallbacks[sequence]) return false;
        return _originalStopCallback.call(self, e, element, combo);
    };
    Mousetrap1.prototype.bindGlobal = function(keys, callback, action) {
        var self = this;
        self.bind(keys, callback, action);
        if (keys instanceof Array) {
            for(var i = 0; i < keys.length; i++)_globalCallbacks[keys[i]] = true;
            return;
        }
        _globalCallbacks[keys] = true;
    };
    Mousetrap1.init();
})(typeof Mousetrap !== "undefined" ? Mousetrap : undefined);

});

parcelRegister("l65Bo", function(module, exports) {
// we'd like to be able to check if the dialog is displaying right now
const $0afa19b4dc37db45$export$f0b76e53a3d1db73 = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const portals = Array.from(document.getElementsByClassName('atlaskit-portal')).filter((portal)=>portal.firstChild);
    const isAtlaskitDialogShown = Boolean(portals.filter((item)=>item.querySelectorAll('[role="dialog"]').length).length);
    const isLoomRecorderDialogShown = Boolean(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.getElementById('loom-sdk-record-overlay-shadow-root-id')?.shadowRoot?.getElementById('preview-recording'));
    return isAtlaskitDialogShown || isLoomRecorderDialogShown;
};
module.exports["isDialogShown"] = $0afa19b4dc37db45$export$f0b76e53a3d1db73;

});

parcelRegister("1k6sE", function(module, exports) {

var $gnkil = parcelRequire("gnkil");


var $9aQ0J = parcelRequire("9aQ0J");

const $ca7c59da1dc6c0fe$export$d05888cf23195902 = 'shortcuts-are-allowed';
const $ca7c59da1dc6c0fe$export$ccca490433ac184a = 'shortcuts-are-allowed-in-modal';
const $ca7c59da1dc6c0fe$export$95466aa5e4023a13 = [
    'ProseMirror-focused',
    $ca7c59da1dc6c0fe$export$d05888cf23195902
];
const $ca7c59da1dc6c0fe$export$eca1f9acdad825ae = [
    $ca7c59da1dc6c0fe$export$ccca490433ac184a
];
const $ca7c59da1dc6c0fe$export$a6834c81db6fbcc7 = Object.values($gnkil).reduce((0, $9aQ0J.getShortcutValues), []);
module.exports["ALLOW_SHORTCUTS_CLASS"] = $ca7c59da1dc6c0fe$export$d05888cf23195902;
module.exports["ALLOW_SHORTCUTS_CLASS_IN_MODAL"] = $ca7c59da1dc6c0fe$export$ccca490433ac184a;
module.exports["MOUSETRAP_ALLOWED_ELEMENTS"] = $ca7c59da1dc6c0fe$export$95466aa5e4023a13;
module.exports["MOUSETRAP_ALLOWED_MODALS"] = $ca7c59da1dc6c0fe$export$eca1f9acdad825ae;
module.exports["RESERVED_SHORTCUTS"] = $ca7c59da1dc6c0fe$export$a6834c81db6fbcc7;

});

parcelRegister("9aQ0J", function(module, exports) {
const $a5d5607ba4daeddb$export$58cbf3bcb054e9cd = (accumulated, current)=>{
    if (typeof current === 'string') accumulated.push(current);
    else if (typeof current === 'object') accumulated.push(...Object.values(current).reduce($a5d5607ba4daeddb$export$58cbf3bcb054e9cd, []));
    return accumulated;
};
module.exports["getShortcutValues"] = $a5d5607ba4daeddb$export$58cbf3bcb054e9cd;

});

parcelRegister("4q9NN", function(module, exports) {
/* DeprecatedShortcutFlag.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $4tOXV = parcelRequire("4tOXV");

const $3c4669a4d8882aac$var$i18n = (0, $kSwu1.defineMessages)({
    deprecatedShortcutFlagTitle: {
        id: "shortcuts.deprecated-shortcut-flag.title",
        defaultMessage: "This shortcut is about to change"
    },
    deprecatedShortcutFlagDescription: {
        id: "shortcuts.deprecated-shortcut-flag.description",
        defaultMessage: "Shortcuts are switching to a <supportLink>universal format</supportLink>. <inline>{oldShortcut} will now be {newShortcut}</inline>"
    },
    remindMeLaterButton: {
        id: "shortcuts.deprecated-shortcut-flag.button.remind-me-later",
        defaultMessage: "Remind me later"
    },
    dontTellMeAgainButton: {
        id: "shortcuts.deprecated-shortcut-flag.button.dont-tell-me-again",
        defaultMessage: "Don\u2019t tell me again"
    }
});
const $3c4669a4d8882aac$var$KEYBOARD_SHORTCUTS_SUPPORT_LINK = 'https://support.atlassian.com/confluence-cloud/docs/keyboard-shortcuts-markdown-and-autocomplete/';
const $3c4669a4d8882aac$var$shortcutSentenceCss = null;
const $3c4669a4d8882aac$var$getShortcutDescription = ({ oldShortcut: oldShortcut, newShortcut: newShortcut, acceleratorTriggered: acceleratorTriggered })=>{
    let newS = Array.isArray(newShortcut) ? newShortcut[0] : newShortcut; // ShortcutListener allows for multiple accelerators to be specified for one callback.  Ex. ["a", "mod+9"].
    // If any of those are triggerred, the callback will activate.
    // This makes it a little tricky to figure out what accelerator to recommend as a replacement.
    // Ex. deprecatedAccelerator: ["a", "b"], accelerator: ["mod+a", "mod+b"]
    // - If multiple accelerators are available in `newShortcut`, we default to the first one.
    // - However, if an equal number of accelerators are available in `oldShortcut` and `newShortcut`,
    //   then we look for the accelerator corresponding with the one that was actually triggered,
    //   based on array index.
    if (Array.isArray(oldShortcut) && Array.isArray(newShortcut) && oldShortcut.length === newShortcut.length) {
        const triggeredIndex = oldShortcut.indexOf(acceleratorTriggered);
        if (triggeredIndex >= 0 && triggeredIndex < newShortcut.length) newS = newShortcut[triggeredIndex];
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$3c4669a4d8882aac$var$i18n.deprecatedShortcutFlagDescription,
        values: {
            supportLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    target: "_blank",
                    href: $3c4669a4d8882aac$var$KEYBOARD_SHORTCUTS_SUPPORT_LINK
                }, chunks),
            oldShortcut: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: acceleratorTriggered
            }),
            newShortcut: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: newS
            }),
            inline: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    className: (0, $hekY6.default)([
                        "_2mHwu8FQfX _3iDTPbQ4SZ _0hPCNLDIqT"
                    ])
                }, chunks)
        }
    });
};
const $3c4669a4d8882aac$var$FOREVER = 'forever';
const $3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID = 'deprecatedShortcutFlag';
const $3c4669a4d8882aac$var$shouldShowDeprecationFlag = ()=>{
    const hiddenUntilTime = (0, $17wUi.confluenceLocalStorageInstance)?.getItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL) || '';
    if (hiddenUntilTime === $3c4669a4d8882aac$var$FOREVER) return false;
    else if (hiddenUntilTime !== '') {
        const hiddenUntilTimeInMs = Number(hiddenUntilTime);
        if (!isNaN(hiddenUntilTimeInMs)) return Date.now() > hiddenUntilTimeInMs;
    }
    return true;
};
const $3c4669a4d8882aac$export$799f01f4b30e66c7 = ({ flags: flags, acceleratorTriggered: acceleratorTriggered, accelerator: accelerator, deprecatedAccelerator: deprecatedAccelerator })=>{
    if ($3c4669a4d8882aac$var$shouldShowDeprecationFlag()) flags.showFlag({
        id: $3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3c4669a4d8882aac$var$i18n.deprecatedShortcutFlagTitle),
        description: $3c4669a4d8882aac$var$getShortcutDescription({
            oldShortcut: deprecatedAccelerator,
            newShortcut: accelerator,
            acceleratorTriggered: acceleratorTriggered
        }),
        type: 'success',
        close: 'never',
        // Needed to bypass the flags.hideAllFlags() that happens on some page transitions.
        actions: [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3c4669a4d8882aac$var$i18n.remindMeLaterButton),
                onClick: ()=>{
                    // Hide the prompt for 7 days.
                    (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL, Date.now() + 1000 * 60 * 60 * 24 * 7);
                    flags.hideFlag($3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID);
                }
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3c4669a4d8882aac$var$i18n.dontTellMeAgainButton),
                onClick: ()=>{
                    (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL, $3c4669a4d8882aac$var$FOREVER);
                    flags.hideFlag($3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID);
                }
            }
        ]
    });
};
module.exports["maybeShowDeprecatedShortcutFlag"] = $3c4669a4d8882aac$export$799f01f4b30e66c7;

});

parcelRegister("1SPMi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3d3WW = parcelRequire("3d3WW");


var $iTJtk = parcelRequire("iTJtk");


var $hcnuR = parcelRequire("hcnuR");


var $bQm3c = parcelRequire("bQm3c");


var $e4o8D = parcelRequire("e4o8D");


var $2SowE = parcelRequire("2SowE");


var $8ld8H = parcelRequire("8ld8H");

const $c749b0358b0b3fb9$export$46da93e796378064 = (props)=>{
    const { objectId: objectId, objectType: objectType, children: children, source: source } = props;
    // setting default to development so in tests it doesn't fail due to being undefined
    const { environment: environment } = (0, $bQm3c.useSessionData)() || {};
    // setting default to development so in tests it doesn't fail due to being undefined
    const safeEnvironment = environment || 'DEVELOPMENT';
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const nonProductionBuildAnalyticsAttributes = (0, $cozmU.useMemo)(()=>(0, $hcnuR.getNonProductionBuildAnalyticsAttributes)(()=>renderServerPlaceholder ? undefined : (0, $8ld8H.getConfluenceNonProductionBuild)()), [
        renderServerPlaceholder
    ]);
    const handleEvent = (0, $cozmU.useCallback)((event)=>{
        const instanceName = safeEnvironment;
        event.update((payload)=>{
            let newPayload = (0, $2SowE.extendPayloadAttributes)(payload, {
                objectId: objectId,
                objectType: objectType,
                rendererSource: source
            });
            if (instanceName) newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, {
                instance: instanceName
            });
            if (nonProductionBuildAnalyticsAttributes.isNonProductionBuild !== undefined) newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, nonProductionBuildAnalyticsAttributes);
            return newPayload;
        });
    }, [
        safeEnvironment,
        objectId,
        objectType,
        source,
        nonProductionBuildAnalyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: handleEvent,
        channel: (0, $iTJtk.FabricChannel).editor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: handleEvent,
        channel: (0, $iTJtk.FabricChannel).media
    }, children));
};
module.exports["RendererAnalyticsListener"] = $c749b0358b0b3fb9$export$46da93e796378064;

});

parcelRegister("iP9x4", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $2j0AL = parcelRequire("2j0AL");


var $8fBh8 = parcelRequire("8fBh8");


var $4h1jl = parcelRequire("4h1jl");


var $9wGTI = parcelRequire("9wGTI");


var $4IoVL = parcelRequire("4IoVL");

const $2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR = 'mediaProvider unavailable, must use initialAuth';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $2c59df77bd212c3d$var$isServerEnvironment = ()=>undefined;
const $2c59df77bd212c3d$var$isClientEnvironment = ()=>window.__SSR_RENDERED__;
const $2c59df77bd212c3d$var$getInitialAuth = (config)=>{
    const recordedAuth = config.contentProduct === 'jira-work-item' ? (0, $4h1jl.jiraMediaConfigRecorder)?.get() : (0, $4h1jl.mediaConfigRecorder)?.get();
    if (!recordedAuth) return undefined;
    return {
        ...recordedAuth,
        // If the mediaToken is provided in the config, use it.
        // This ensures the correct token is used in cases where the token differs from
        // the initial page, such as media included through an `include` macro.
        token: config?.mediaToken || recordedAuth.token
    };
};
const $2c59df77bd212c3d$var$getInitialEnforceDataSecurityPolicy = ()=>{
    if (!(0, $9wGTI.fg)('dlp_attachment_download_respects_data_export_dsp')) return false;
    const shouldEnforceDataSecurityPolicy = (0, $4h1jl.mediaConfigEnforceDSPRecorder)?.get();
    return !!shouldEnforceDataSecurityPolicy;
};
const $2c59df77bd212c3d$var$getInitialSsrMediaItems = (mediaItems)=>{
    if (!Array.isArray(mediaItems) || mediaItems.length === 0) return undefined;
    return mediaItems;
};
const $2c59df77bd212c3d$var$getServerModeConfig = (config)=>({
        mode: 'server',
        config: {
            authProvider: ()=>Promise.reject(new Error($2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR)),
            initialAuth: $2c59df77bd212c3d$var$getInitialAuth(config),
            enforceDataSecurityPolicy: $2c59df77bd212c3d$var$getInitialEnforceDataSecurityPolicy()
        },
        ssrMediaItems: $2c59df77bd212c3d$var$getInitialSsrMediaItems((0, $8fBh8.getMediaNodes)())
    });
const $2c59df77bd212c3d$var$createClientAuthProvider = ({ contentAri: contentAri, contentId: contentId, contentProduct: contentProduct, spaceKey: spaceKey, isExternalShare: isExternalShare, mediaToken: mediaToken })=>async (authContext)=>{
        if (!!contentId && (!!spaceKey || contentProduct === 'jira-work-item')) {
            const { viewMediaClientConfig: viewMediaClientConfig } = await (0, $4IoVL.createRendererMediaProvider)({
                contentAri: contentAri,
                contentId: contentId,
                contentProduct: contentProduct,
                spaceKey: spaceKey,
                isExternalShare: isExternalShare,
                mediaToken: mediaToken
            });
            return viewMediaClientConfig.authProvider(authContext);
        } else throw new Error($2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR);
    };
const $2c59df77bd212c3d$var$getClientModeConfig = (config)=>({
        mode: 'client',
        config: {
            authProvider: $2c59df77bd212c3d$var$createClientAuthProvider(config),
            initialAuth: config.contentProduct === 'jira-work-item' ? window.__JIRA_MEDIA_CONFIG__ : window.__MEDIA_CONFIG__,
            enforceDataSecurityPolicy: window.__MEDIA_CONFIG_ENFORCE_DSP__
        },
        ssrMediaItems: $2c59df77bd212c3d$var$getInitialSsrMediaItems(window.__MEDIA_NODE_META_DATA__)
    });
const $2c59df77bd212c3d$var$getMediaSSRModeAndAuthConfig = (config)=>{
    if ($2c59df77bd212c3d$var$isServerEnvironment()) return $2c59df77bd212c3d$var$getServerModeConfig(config);
    else if ($2c59df77bd212c3d$var$isClientEnvironment()) return $2c59df77bd212c3d$var$getClientModeConfig(config);
};
const $2c59df77bd212c3d$export$85decadf1b9d641b = (0, $dOBRD.default)($2c59df77bd212c3d$var$getMediaSSRModeAndAuthConfig, (0, (/*@__PURE__*/$parcel$interopDefault($2j0AL))));
const $2c59df77bd212c3d$export$45c8e19bd67cadee = (config)=>{
    return $2c59df77bd212c3d$export$85decadf1b9d641b(config);
};
module.exports["getMediaSSRModeAndAuthConfigMemoized"] = $2c59df77bd212c3d$export$85decadf1b9d641b;
module.exports["useMediaSSRModeAndAuthConfig"] = $2c59df77bd212c3d$export$45c8e19bd67cadee;

});

parcelRegister("8fBh8", function(module, exports) {
/**
 * A simple module-level singleton used to hand media node metadata from the
 * SSR data-preload phase to the render phase.
 *
 * During SSR, Confluence preloads media node metadata and
 * records it here via {@link setMediaNodes}. It is later read via
 * {@link getMediaNodes} both by the product's render pipeline and by platform
 * consumers such as `@atlaskit/media-file-preview`.
 *
 * This lives in `@atlaskit/media-common` (rather than a product package) so that
 * both product code and platform packages can share the exact same singleton
 * instance without platform depending on a product package.
 */ let $b78ae25b6276049e$var$mediaNodes = null;
const $b78ae25b6276049e$export$cfabe671d3a31c35 = (nodes)=>{
    $b78ae25b6276049e$var$mediaNodes = nodes;
};
const $b78ae25b6276049e$export$684919eb15443d6b = ()=>$b78ae25b6276049e$var$mediaNodes;
const $b78ae25b6276049e$export$d55d7b4fc145db9 = ()=>{
    $b78ae25b6276049e$var$mediaNodes = null;
};
module.exports["getMediaNodes"] = $b78ae25b6276049e$export$684919eb15443d6b;

});

parcelRegister("4h1jl", function(module, exports) {

var $2BiLx = parcelRequire("2BiLx");

const $c75b7ce9b9db2aec$export$279f2f878f49d0df = new (0, $2BiLx.ObjectRecorder)();
const $c75b7ce9b9db2aec$export$269fe681eda28e68 = new (0, $2BiLx.ObjectRecorder)();
const $c75b7ce9b9db2aec$export$e125b144e38aa5db = new (0, $2BiLx.ObjectRecorder)();
module.exports["mediaConfigRecorder"] = $c75b7ce9b9db2aec$export$279f2f878f49d0df;
module.exports["jiraMediaConfigRecorder"] = $c75b7ce9b9db2aec$export$269fe681eda28e68;
module.exports["mediaConfigEnforceDSPRecorder"] = $c75b7ce9b9db2aec$export$e125b144e38aa5db;

});

parcelRegister("2BiLx", function(module, exports) {
class $53dcea44a491523c$export$e411414ea02dd271 {
    set(object) {
        this.object = object;
    }
    get() {
        return this.object;
    }
    reset() {
        this.object = null;
    }
    constructor(){
        this.object = null;
    }
}
module.exports["ObjectRecorder"] = $53dcea44a491523c$export$e411414ea02dd271;

});

parcelRegister("7EIq6", function(module, exports) {

var $dd33Q = parcelRequire("dd33Q");


var $jtuBN = parcelRequire("jtuBN");


var $iLgzu = parcelRequire("iLgzu");

const $649b778bbd82b1bb$var$useSpaceEnabledContentTypesQuery = (0, $dd33Q.default);
function $649b778bbd82b1bb$export$1defcb29347f9ac6(spaceKey) {
    const { data: defaultSpaceKeyData, loading: isDefaultSpaceKeyLoading } = (0, $iLgzu.useExperimentalPromotedSpacesQuery)({
        skip: spaceKey !== undefined,
        variables: {
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1,
            promotedSpaceKey: null
        }
    });
    const spaceEnabledContentTypesQueryOptions = {
        errorPolicy: 'all',
        skip: !spaceKey && !defaultSpaceKeyData,
        variables: {
            spaceKey: spaceKey || defaultSpaceKeyData?.experimentalPromotedSpaces?.nodes?.[0]?.id
        }
    };
    const { data: enabledContentTypesData, loading: isAnyContentTypesLoading } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($649b778bbd82b1bb$var$useSpaceEnabledContentTypesQuery, {
        ...spaceEnabledContentTypesQueryOptions,
        __callerPackage__: "create-blank-fabric-page"
    });
    const enabledContentTypes = enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes;
    const hasUndefinedContentTypes = enabledContentTypes === undefined || Object.values(enabledContentTypes).some((type)=>type === undefined);
    const isLoading = isDefaultSpaceKeyLoading || isAnyContentTypesLoading || hasUndefinedContentTypes;
    return {
        isCreateWhiteboardEnabled: Boolean(enabledContentTypes?.isWhiteboardsEnabled),
        isCreateBlogEnabled: Boolean(enabledContentTypes?.isBlogsEnabled),
        isCreateDatabaseEnabled: Boolean(enabledContentTypes?.isDatabasesEnabled),
        isCreateSmartLinkEnabled: Boolean(enabledContentTypes?.isEmbedsEnabled),
        isCreateLiveDocEnabled: Boolean(enabledContentTypes?.isLivePagesEnabled),
        isCreateFolderEnabled: Boolean(enabledContentTypes?.isFoldersEnabled),
        isCreateSlidesEnabled: Boolean(enabledContentTypes?.isSlidesEnabled),
        isLoading: isLoading
    };
}
module.exports["useSpaceEnabledContentTypes"] = $649b778bbd82b1bb$export$1defcb29347f9ac6;

});

parcelRegister("iLgzu", function(module, exports) {

var $jaPWl = parcelRequire("jaPWl");


var $dK51B = parcelRequire("dK51B");

const $e671a111e943b77f$export$409ac92b3aba27f5 = ({ skip: skip, onError: onError, variables: variables = {}, fetchPolicy: fetchPolicy } = {})=>{
    const promotedSpacesLimit = variables.promotedSpacesLimit || 10;
    const otherSpacesLimit = variables.otherSpacesLimit || 10;
    const promotedSpaceKey = variables.promotedSpaceKey || '';
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $jaPWl.MediaType).JSON
        },
        parseResult: (json)=>{
            const matchedPromotedSpaces = json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces || [];
            const nodes = (json.promotedSpaces && json.promotedSpaces.spaces || []).concat(json.otherSpaces && json.otherSpaces.spaces || []);
            return {
                experimentalPromotedSpaces: {
                    nodes: nodes,
                    matchedPromotedSpaces: matchedPromotedSpaces,
                    __typename: 'ExperimentalPromotedSpaces'
                }
            };
        },
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalPromotedSpacesQuery"] = $e671a111e943b77f$export$409ac92b3aba27f5;

});

parcelRegister("jaPWl", function(module, exports) {
var $5e96abf23293f6d5$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $5e96abf23293f6d5$export$483c11740a902fcd;

});

parcelRegister("kDja4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dUvcQ = parcelRequire("dUvcQ");


var $9wGTI = parcelRequire("9wGTI");


var $yuLaV = parcelRequire("yuLaV");

// These flags are no longer used in confluence and can be removed from this array entirely after we confirm that have been removed from the whiteboards side too
const $9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS = [
    'headerV1',
    'headerV2',
    'whiteboardArchive',
    'removeWhiteboardsHome',
    'removeWhiteboardsHomeInSideNav',
    'whiteboardCreation',
    'whiteboardsEnabled',
    'whiteboardBifrost',
    'whiteboardVersionHistory'
];
const $9cbb170f29556407$export$6f83cfa4fd660300 = ()=>{
    const isWhiteboardsEnabledInEnv = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isWhiteboardFeatureEnabled = (0, $cozmU.useCallback)((featureName)=>{
        if (featureName === 'whiteboardsEnabled') return isWhiteboardsEnabledInEnv;
        // If the FF has been cleaned up on our end just return true
        if ($9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS.some((feature)=>feature === featureName)) return true;
        // Use static feature gate calls to satisfy confluence-feature-gating/static-feature-gates
        switch(featureName){
            case 'whiteboardSolidHeader':
                return (0, $9wGTI.fg)('confluence_frontend_solid_whiteboard_header');
            case 'whiteboardOptOut':
                return (0, $9wGTI.fg)('whiteboards_compliance_opt_out');
            case 'digitalTeammate':
                return (0, $9wGTI.fg)('cc-ai-whiteboards-enable-digital-teammate');
            case 'aiFirstCreation':
                return true;
            default:
                return false;
        }
    }, [
        isWhiteboardsEnabledInEnv
    ]);
    const isWhiteboardCreationDropdownEnabled = (0, $cozmU.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    const isWhiteboardGAOnboardingEnabled = (0, $cozmU.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    return {
        platformFeatureFlagResolver: (0, $dUvcQ.getBooleanFF),
        isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled,
        isWhiteboardCreationDropdownEnabled: isWhiteboardCreationDropdownEnabled,
        isWhiteboardGAOnboardingEnabled: isWhiteboardGAOnboardingEnabled
    };
};
module.exports["useIsWhiteboardFeatureEnabled"] = $9cbb170f29556407$export$6f83cfa4fd660300;

});

parcelRegister("dUvcQ", function(module, exports) {

var $7FQjS = parcelRequire("7FQjS");

function $c3d67b941c4ebe95$export$470e5c2be1411c89(name) {
    return (0, $7FQjS.resolveBooleanFlag)(name);
}
module.exports["getBooleanFF"] = $c3d67b941c4ebe95$export$470e5c2be1411c89;

});

parcelRegister("eVXGa", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $1337beb96693807c$var$isAllowedToCreate = (accessStatus)=>accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
const $1337beb96693807c$export$1060ff57674ca8ef = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $1337beb96693807c$var$isAllowedToCreate(accessStatus);
};
module.exports["useIsAllowedToCreateWhiteboard"] = $1337beb96693807c$export$1060ff57674ca8ef;

});

parcelRegister("bMPhU", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $7SV4J = parcelRequire("7SV4J");


var $ep3mz = parcelRequire("ep3mz");


var $jMyy4 = parcelRequire("jMyy4");

const $337a96ad81fe0f87$export$a1e0cd72fc64ef6 = (spaceKey)=>{
    const $ = (0, $bDgLe.c)(5);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    spaceKey = spaceKey ?? pageContextSpaceKey;
    let t0;
    if ($[0] !== spaceKey) {
        t0 = {
            spaceKey: spaceKey
        };
        $[0] = spaceKey;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = !spaceKey;
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
        t2 = {
            variables: t0,
            skip: t1
        };
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $7SV4J.default), {
        ...t2,
        __callerPackage__: "space-utils"
    });
    return data?.space?.homepage?.id || undefined;
};
module.exports["useSpaceHomepageId"] = $337a96ad81fe0f87$export$a1e0cd72fc64ef6;

});

parcelRegister("7SV4J", function(module, exports) {
/**
 * @generated SignedSource<<9c89aa0352f7d1dca5a5a1271100cc40>>
 * @relayHash be53943df43514309a4d7c908c1c0fa2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5
const $6972c51ac50ce9bf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                },
                v1 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "be53943df43514309a4d7c908c1c0fa2",
            "id": "7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5",
            "metadata": {},
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "operationKind": "query",
            "text": "query useSpaceHomepageIdSpaceHomepageIdQuery($spaceKey:String){space(key:$spaceKey){homepage{id},id}}"
        }
    };
}();
$6972c51ac50ce9bf$var$node.hash = "008609f21691e19f9c101d43e2e78e81";
var $6972c51ac50ce9bf$export$2e2bcd8739ae039 = $6972c51ac50ce9bf$var$node;
module.exports["default"] = $6972c51ac50ce9bf$export$2e2bcd8739ae039;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("kvJHJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $gXfti = parcelRequire("gXfti");


var $knAY5 = parcelRequire("knAY5");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");


var $2O7Qv = parcelRequire("2O7Qv");


var $18R9N = parcelRequire("18R9N");

const $d2938061b4a1e388$var$noop = ()=>{};
const $d2938061b4a1e388$var$EMBEDDED_PREFIX = 'embedded-';
const $d2938061b4a1e388$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { customData: customData = {}, onComplete: onComplete = $d2938061b4a1e388$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of Props guarantees that exactly one of `metricKey` or `metric`
    // is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$d2938061b4a1e388$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const stopTimeRef = (0, $cozmU.useRef)(stopTime);
    const customDataRef = (0, $cozmU.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $cozmU.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handleSegmentLoadEnd = (0, $cozmU.useCallback)(()=>{
        onComplete();
        let finalCustomData;
        if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
        else finalCustomData = customDataRef.current;
        (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${prefixedKey}`);
        (0, $2O7Qv.addCustomTimingForMetric)(prefixedKey);
        (0, $gXfti.addUFOCustomData)({
            ...finalCustomData,
            viewTransitionSource: (0, $lXYVJ.getViewTransitionSource)(),
            ...typeof stopTimeRef.current === 'number' ? {
                stopTime: stopTimeRef.current
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        });
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadEnd, timing);
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
const $d2938061b4a1e388$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($d2938061b4a1e388$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $d2938061b4a1e388$export$a267cdf45880b07b;

});

parcelRegister("N1nBh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
   * This will perform the given action at a scheduled time after the
   * component has painted.
   *
   * This is the default behavior.
   */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
   * This will perform the given action at the next animation frame (after the
   * component has been painted).
   */ ActionTiming["PAINT"] = "PAINT";
    /**
   * This will perform the given action at the moment its render function
   * fires.
   *
   * NOTE: This is called _within_ the render body, making it unpure. The
   * component is memoized, so it will fire this only once for a given set
   * of props. Be careful when using this, since it is unsafe.
   */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $cozmU.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $cozmU.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("2O7Qv", function(module, exports) {

var $a33Aa = parcelRequire("a33Aa");

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */ function $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interactionId, marks, metricKey) {
    let startTime;
    let endTime;
    for (const mark of marks){
        if (mark.type !== 'custom') continue;
        if (mark.name === `segment-start:${metricKey}`) startTime = mark.time;
        else if (mark.name === `segment-end:${metricKey}`) endTime = mark.time;
    }
    if (typeof startTime === 'number' && typeof endTime === 'number') (0, $a33Aa.addCustomTiming)(interactionId, [], {
        [`wf/react/${metricKey}`]: {
            startTime: startTime,
            endTime: endTime
        }
    });
}
function $7bc5b7230c0461d4$export$46796e5c908ea08e(metricKey) {
    const interaction = (0, $a33Aa.getActiveInteraction)();
    if (interaction) $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
}
module.exports["addCustomTimingForMetric"] = $7bc5b7230c0461d4$export$46796e5c908ea08e;

});

parcelRegister("18R9N", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6b4f0c0629e8427f$export$fda153f959d0066f = /*#__PURE__*/ (0, $cozmU.createContext)(false);
const $6b4f0c0629e8427f$export$b6c7102a78eb7f7f = ()=>(0, $cozmU.useContext)($6b4f0c0629e8427f$export$fda153f959d0066f);
module.exports["EmbeddedConfluenceTrackingContext"] = $6b4f0c0629e8427f$export$fda153f959d0066f;
module.exports["useIsEmbeddedTracking"] = $6b4f0c0629e8427f$export$b6c7102a78eb7f7f;

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$f6bd20f4f796eb89 = 'folder-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
const $fa0ea3428ec5aa62$export$b3aade49b91bdeba = 'comments-panel-mentions-me-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$687913e127f52cc3;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["FOLDER_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f6bd20f4f796eb89;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;
module.exports["COMMENTS_PANEL_MENTIONS_ME_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b3aade49b91bdeba;

});

parcelRegister("3h37U", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $koEBx = parcelRequire("koEBx");


var $d7j1D = parcelRequire("d7j1D");


var $2lPWP = parcelRequire("2lPWP");


var $8MmI7 = parcelRequire("8MmI7");

const $706a470437238efe$export$5252bd745392dcde = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(8);
    const { onChange: onChange, defaultValue: defaultValue, features: features, isDisabled: isDisabled } = props.forgeDoc.props;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = new (0, $2lPWP.JSONTransformer)();
        $[0] = t0;
    } else t0 = $[0];
    const transformer = t0;
    const { preset: preset } = (0, $8MmI7.usePresetByFeatures)("chromeless", features);
    let t1;
    if ($[1] !== onChange) {
        t1 = (editorView)=>{
            const jsonDocNode = transformer.encode(editorView.state.doc);
            onChange?.(jsonDocNode);
        };
        $[1] = onChange;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== defaultValue || $[4] !== isDisabled || $[5] !== preset || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7j1D.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $koEBx.ChromelessEditor), {
            disabled: isDisabled,
            defaultValue: defaultValue,
            preset: preset,
            onChange: t1
        }));
        $[3] = defaultValue;
        $[4] = isDisabled;
        $[5] = preset;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : (props)=>{
    const { onChange: onChange, defaultValue: defaultValue, features: features, isDisabled: isDisabled } = props.forgeDoc.props;
    const transformer = (0, $cozmU.useMemo)(()=>new (0, $2lPWP.JSONTransformer)(), []);
    const { preset: preset } = (0, $8MmI7.usePresetByFeatures)('chromeless', features);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7j1D.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $koEBx.ChromelessEditor), {
        disabled: isDisabled,
        defaultValue: defaultValue,
        preset: preset,
        onChange: (editorView)=>{
            const jsonDocNode = transformer.encode(editorView.state.doc);
            onChange?.(jsonDocNode);
        }
    }));
};
module.exports["ChromelessEditor"] = $706a470437238efe$export$5252bd745392dcde;

});

parcelRegister("8MmI7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $dVPAB = parcelRequire("dVPAB");


var $9Qt8c = parcelRequire("9Qt8c");


var $k1GzU = parcelRequire("k1GzU");

const $d7b2d2844e329581$export$cdae2f05238f63a2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (appearance, features)=>{
    const $ = (0, $bDgLe.c)(5);
    const memoisedFeatures = (0, $k1GzU.useMemoisedFeatures)(features);
    let t0;
    if ($[0] !== appearance || $[1] !== memoisedFeatures) {
        t0 = (builder)=>(0, $9Qt8c.createPreset)(builder, appearance, memoisedFeatures);
        $[0] = appearance;
        $[1] = memoisedFeatures;
        $[2] = t0;
    } else t0 = $[2];
    let t1;
    if ($[3] !== memoisedFeatures) {
        t1 = [
            memoisedFeatures
        ];
        $[3] = memoisedFeatures;
        $[4] = t1;
    } else t1 = $[4];
    const preset = (0, $dVPAB.usePreset)(t0, t1);
    return preset;
} : (appearance, features)=>{
    const memoisedFeatures = (0, $k1GzU.useMemoisedFeatures)(features);
    const preset = (0, $dVPAB.usePreset)((builder)=>(0, $9Qt8c.createPreset)(builder, appearance, memoisedFeatures), [
        memoisedFeatures
    ]);
    return preset;
};
module.exports["usePresetByFeatures"] = $d7b2d2844e329581$export$cdae2f05238f63a2;

});

parcelRegister("9Qt8c", function(module, exports) {

var $3HCXM = parcelRequire("3HCXM");


var $1171P = parcelRequire("1171P");


var $7Upsh = parcelRequire("7Upsh");


var $lK9Pz = parcelRequire("lK9Pz");


var $fKdaf = parcelRequire("fKdaf");


var $bkj40 = parcelRequire("bkj40");


var $e6Dq9 = parcelRequire("e6Dq9");


var $1ZhW4 = parcelRequire("1ZhW4");


var $2QN3e = parcelRequire("2QN3e");


var $e273U = parcelRequire("e273U");


var $5tMpU = parcelRequire("5tMpU");


var $5HQgD = parcelRequire("5HQgD");


var $hFvHs = parcelRequire("hFvHs");


var $hYOOW = parcelRequire("hYOOW");


var $hHtwA = parcelRequire("hHtwA");


var $gkbos = parcelRequire("gkbos");


var $grjTL = parcelRequire("grjTL");


var $d1HsG = parcelRequire("d1HsG");

const $7be6a40f5b04921d$var$shouldShow = (option)=>{
    // if option is not defined, return false
    if (option === undefined) return false;
    return option;
};
const $7be6a40f5b04921d$export$b956d067c5bcf6b = (builder, appearance, features)=>{
    const defaultFeatures = {
        blockType: true,
        textFormatting: true,
        list: true,
        insertBlock: true,
        textColor: true,
        hyperLink: true,
        quickInsert: true,
        codeBlock: true
    };
    // if `features` is not defined, set all options to true
    // if `features` is provided, only options that are set to true by the developer will render. This is so any new plugin additions made by us will not be rendered by default as the developer has intentionally only set certain options to appear
    const enabledPlugins = features ?? defaultFeatures;
    return builder.add((0, $7Upsh.default)).maybeAdd((0, $fKdaf.blockTypePlugin), $7be6a40f5b04921d$var$shouldShow(enabledPlugins?.blockType)) // allows for different text tags(paragraphs, heading levels) and quote blocks to be added
    .add((0, $lK9Pz.betterTypeHistoryPlugin)) // required for paste plugin
    .add([
        (0, $hYOOW.pastePlugin),
        {}
    ]) // allows links to be converted to hyper link on paste
    .add((0, $d1HsG.typeAheadPlugin)).maybeAdd((0, $hHtwA.quickInsertPlugin), $7be6a40f5b04921d$var$shouldShow(enabledPlugins?.quickInsert)) // allows for `/` to insert nodes from a menu
    .maybeAdd((0, $grjTL.textFormattingPlugin), $7be6a40f5b04921d$var$shouldShow(enabledPlugins?.textFormatting)).maybeAdd((0, $gkbos.textColorPlugin), $7be6a40f5b04921d$var$shouldShow(enabledPlugins?.textColor)).maybeAdd((0, $hFvHs.listPlugin), $7be6a40f5b04921d$var$shouldShow(enabledPlugins?.list)) // required for `-` to insert lists
    .maybeAdd([
        (0, $1171P.toolbarListsIndentationPlugin),
        // adds the list indentation section to the toolbar
        {
            showIndentationButtons: false,
            allowHeadingAndParagraphIndentation: false
        }
    ], $7be6a40f5b04921d$var$shouldShow(enabledPlugins?.list)).add((0, $1ZhW4.copyButtonPlugin)) // required for floating toolbar plugins
    .add((0, $e273U.editorDisabledPlugin)) // required for floating toolbar and `disabled` prop
    .add((0, $2QN3e.decorationsPlugin)) // required for floating toolbar
    .add((0, $5tMpU.floatingToolbarPlugin)) // required for toolbar to appear under links
    .maybeAdd([
        (0, $3HCXM.hyperlinkPlugin),
        // allows for hyper link to be added to text
        {
            editorAppearance: appearance,
            lpLinkPicker: true
        }
    ], $7be6a40f5b04921d$var$shouldShow(enabledPlugins?.hyperLink)).add((0, $e6Dq9.compositionPlugin)) // required for codeblock
    .maybeAdd([
        (0, $bkj40.default),
        {}
    ], $7be6a40f5b04921d$var$shouldShow(enabledPlugins?.codeBlock)).maybeAdd([
        (0, $5HQgD.insertBlockPlugin),
        // this controls the last set of toolbar insertions(link, codeblock and quote block)
        {
            appearance: appearance
        }
    ], $7be6a40f5b04921d$var$shouldShow(enabledPlugins?.insertBlock));
};
module.exports["createPreset"] = $7be6a40f5b04921d$export$b956d067c5bcf6b;

});

parcelRegister("k1GzU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");

const $12df64cf02a24e7a$var$featuresAreEqual = (_previousFeatures, _currentFeatures)=>{
    // If both are references point to the same object, return true
    if (_previousFeatures === _currentFeatures) return true;
    const previousFeatures = _previousFeatures || {};
    const currentFeatures = _currentFeatures || {};
    if (Object.keys(previousFeatures).length !== Object.keys(currentFeatures).length) return false;
    // if any properties has changed, return false
    for(const key in previousFeatures){
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(previousFeatures[key], currentFeatures[key])) return false;
    }
    return true;
};
const $12df64cf02a24e7a$export$67693d05a6051899 = (features)=>{
    const previousFeatures = (0, $cozmU.useRef)();
    const shouldUpdate = !$12df64cf02a24e7a$var$featuresAreEqual(previousFeatures.current, features);
    if (shouldUpdate) previousFeatures.current = features;
    return previousFeatures.current;
};
module.exports["useMemoisedFeatures"] = $12df64cf02a24e7a$export$67693d05a6051899;

});

parcelRegister("dYD92", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $g8bbY = parcelRequire("g8bbY");


var $d7j1D = parcelRequire("d7j1D");


var $iMnC5 = parcelRequire("iMnC5");


var $8MmI7 = parcelRequire("8MmI7");

const $05cce7c0e751361c$export$4153d6fbc2386422 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(17);
    const { onChange: onChange, defaultValue: defaultValue, features: features, isDisabled: isDisabled, onSave: onSave, onCancel: onCancel } = props.forgeDoc.props;
    const { preset: preset, editorApi: editorApi } = (0, $8MmI7.usePresetByFeatures)("comment", features);
    const wrapperRef = (0, $cozmU.useRef)(null);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            const element = wrapperRef.current;
            if (!element) return;
            return (0, $cbY7C.bind)(element, {
                type: "keypress",
                listener: $05cce7c0e751361c$var$_temp
            });
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[2] !== editorApi?.core.actions || $[3] !== onSave) {
        t2 = onSave ? ()=>{
            editorApi?.core.actions.requestDocument((jsonDocNode)=>{
                onSave?.(jsonDocNode);
            });
        } : undefined;
        $[2] = editorApi?.core.actions;
        $[3] = onSave;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== onCancel) {
        t3 = onCancel ? ()=>onCancel() : undefined;
        $[5] = onCancel;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== editorApi?.core.actions || $[8] !== onChange) {
        t4 = ()=>{
            editorApi?.core.actions.requestDocument((jsonDocNode_0)=>{
                onChange?.(jsonDocNode_0);
            });
        };
        $[7] = editorApi?.core.actions;
        $[8] = onChange;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== defaultValue || $[11] !== isDisabled || $[12] !== preset || $[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: wrapperRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7j1D.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g8bbY.CommentEditor), {
            disabled: isDisabled,
            defaultValue: defaultValue,
            preset: preset,
            onSave: t2,
            onCancel: t3,
            onChange: t4
        })));
        $[10] = defaultValue;
        $[11] = isDisabled;
        $[12] = preset;
        $[13] = t2;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
    } else t5 = $[16];
    return t5;
} : (props)=>{
    const { onChange: onChange, defaultValue: defaultValue, features: features, isDisabled: isDisabled, onSave: onSave, onCancel: onCancel } = props.forgeDoc.props;
    const { preset: preset, editorApi: editorApi } = (0, $8MmI7.usePresetByFeatures)('comment', features);
    const wrapperRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        const element = wrapperRef.current;
        if (!element) return;
        return (0, $cbY7C.bind)(element, {
            type: 'keypress',
            listener: (e)=>e.stopImmediatePropagation()
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: wrapperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7j1D.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g8bbY.CommentEditor), {
        disabled: isDisabled,
        defaultValue: defaultValue,
        preset: preset,
        onSave: onSave ? ()=>{
            editorApi?.core.actions.requestDocument((jsonDocNode)=>{
                onSave?.(jsonDocNode);
            });
        } : undefined,
        onCancel: onCancel ? ()=>onCancel() : undefined,
        onChange: ()=>{
            editorApi?.core.actions.requestDocument((jsonDocNode_0)=>{
                onChange?.(jsonDocNode_0);
            });
        }
    })));
};
function $05cce7c0e751361c$var$_temp(e) {
    return e.stopImmediatePropagation();
}
module.exports["CommentEditor"] = $05cce7c0e751361c$export$4153d6fbc2386422;

});

parcelRegister("qeywr", function(module, exports) {
/* adf-renderer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $jTt8P = parcelRequire("jTt8P");


var $eNbr2 = parcelRequire("eNbr2");


var $cXtTj = parcelRequire("cXtTj");


var $lNvN4 = parcelRequire("lNvN4");


var $iDrrr = parcelRequire("iDrrr");


var $3BY7M = parcelRequire("3BY7M");


var $hRnS5 = parcelRequire("hRnS5");


var $6BvLK = parcelRequire("6BvLK");

var $4BZVV = parcelRequire("4BZVV");

var $HHXWG = parcelRequire("HHXWG");

var $fTOZ6 = parcelRequire("fTOZ6");

var $9XnlZ = parcelRequire("9XnlZ");

var $gFIer = parcelRequire("gFIer");

var $67Hav = parcelRequire("67Hav");


var $a005x = parcelRequire("a005x");


var $4G9b9 = parcelRequire("4G9b9");


var $35FNt = parcelRequire("35FNt");


var $2Ni8p = parcelRequire("2Ni8p");

const $108ec996f4c4b6a3$export$1aac8cfda4bbc254 = 10;
const $108ec996f4c4b6a3$var$EMPTY_EXTENSION_VIEW_DATA = Object.freeze({});
const $108ec996f4c4b6a3$var$baseRendererFontStyles = null;
const $108ec996f4c4b6a3$var$makeProductMacroCoreHandlerWithBaseFontStyles = (productHandlerEntry)=>{
    const wrapProductHandler = (productHandler)=>{
        return (extensionProps, doc)=>{
            const result = productHandler(extensionProps, doc);
            if (result == null) return result;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            , {
                style: {
                    '--ak-renderer-base-font-size': '16px'
                },
                className: (0, $hekY6.default)([
                    "_4ya3eEb9Wl"
                ])
            }, result);
        };
    };
    return typeof productHandlerEntry === 'function' ? wrapProductHandler(productHandlerEntry) : {
        ...productHandlerEntry,
        render: wrapProductHandler(productHandlerEntry.render)
    };
};
const $108ec996f4c4b6a3$var$filterInvalidMediaUrls = (appDomainName, egressServices, adfDocument)=>{
    const invalidUrls = new Set();
    const visitors = {
        media: (node)=>{
            const url = node?.attrs?.url;
            if (url && !egressServices.some((service)=>(0, $HHXWG.isValidImageUrl)(url, service, appDomainName))) {
                invalidUrls.add(url);
                return {
                    ...node,
                    attrs: {
                        ...node.attrs,
                        // Remove the URL so it fails to load
                        // We use a space because an empty string causes an infinite loading spinner
                        url: ' '
                    }
                };
            }
        }
    };
    const filteredDocument = (0, $jTt8P.traverse)(adfDocument, visitors);
    return {
        filteredDocument: filteredDocument ? filteredDocument : adfDocument,
        invalidUrls: Array.from(invalidUrls)
    };
};
const $108ec996f4c4b6a3$var$useSupportsMedia = ()=>{
    try {
        (0, $lNvN4.useMediaClient)();
        return true; // eslint-disable-next-line no-unused-vars
    } catch (e) {
        // Throws if no MediaClientProvider is found
        return false;
    }
}; // Module-level cache keyed on `cloudId:userId` — created once per page load, reused across all extensions
const $108ec996f4c4b6a3$var$emojiProviderCache = new Map();
const $108ec996f4c4b6a3$export$2d71cf17ec7ade05 = (cloudId, userId)=>{
    if (!(0, $iDrrr.fg)('platform_forge_ui_custom_emoji_ui_kit_adf_renderer') || !cloudId) return undefined;
    const cacheKey = `${cloudId}:${userId ?? ''}`;
    const cached = $108ec996f4c4b6a3$var$emojiProviderCache.get(cacheKey);
    if (cached) return cached;
    const emojiProvider = (0, $4G9b9.getEmojiProvider)(cloudId, userId ?? null);
    $108ec996f4c4b6a3$var$emojiProviderCache.set(cacheKey, emojiProvider);
    return emojiProvider;
}; // Reads the current value of a provider off a ProviderFactory without leaving a lingering
// subscription. Returns `undefined` when the factory or provider is absent.
const $108ec996f4c4b6a3$var$getProviderFromFactory = (factory, name)=>{
    if (!factory) return undefined;
    const noop = ()=>{};
    const provider = factory.subscribe(name, noop);
    factory.unsubscribe(name, noop);
    return provider;
}; // Reads a single provider off the first supplied source factory that exposes it, returning a
// spreadable `{ [name]: provider }` fragment (or `undefined` when no source has it). When several
// sources expose the same provider, earlier sources win.
const $108ec996f4c4b6a3$var$pickProvider = (name, ...sources)=>{
    const source = sources.find((factory)=>factory?.hasProvider(name));
    return source ? {
        [name]: $108ec996f4c4b6a3$var$getProviderFromFactory(source, name)
    } : undefined;
}; // Builds the single ProviderFactory handed to the nested renderer: the custom emoji provider passed
// in directly, plus the task-decision and context-identifier providers copied off the host factory
// (never mutating it) so action items inside a bodied macro body can persist their checked state.
const $108ec996f4c4b6a3$var$mergeNestedDataProviders = (hostDataProviders, emojiProvider, nestedAdfMediaProvider)=>(0, $eNbr2.default).create({
        ...emojiProvider ? {
            emojiProvider: emojiProvider
        } : {},
        // Action items (checklist toggle) need BOTH providers to persist their checked state:
        // - taskDecisionProvider performs the actual write (toggleTask -> backend mutation).
        // - contextIdentifierProvider supplies the objectId that ResourcedTaskItem resolves into the
        //   objectAri key for that write. Without it the provider has no target to persist against, so
        //   ResourcedTaskItem falls back to local-only state and the toggle is lost on refresh.
        ...$108ec996f4c4b6a3$var$pickProvider('taskDecisionProvider', hostDataProviders),
        ...$108ec996f4c4b6a3$var$pickProvider('contextIdentifierProvider', hostDataProviders),
        ...nestedAdfMediaProvider ? {
            mediaProvider: nestedAdfMediaProvider
        } : {}
    });
const $108ec996f4c4b6a3$export$a504d7ec22d4b3f4 = ({ bridge: bridge, cloudId: cloudId, customBridgeMethods: customBridgeMethods, customBridge: customBridge, getContextToken: getContextToken, extensionData: extensionData, forgeMacroExtensions: forgeMacroExtensions, isEditing: isEditing, productContextIds: productContextIds, productExtensionHandlers: productExtensionHandlers, dataProviders: hostDataProviders, nestedAdfMediaProvider: nestedAdfMediaProvider, userId: userId })=>{
    const dataProviderFactory = $108ec996f4c4b6a3$var$mergeNestedDataProviders(hostDataProviders, $108ec996f4c4b6a3$export$2d71cf17ec7ade05(cloudId, userId), nestedAdfMediaProvider);
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($108ec996f4c4b6a3$export$c334f442ba514f7d, {
            bridge: bridge,
            cloudId: cloudId,
            dataProviders: dataProviderFactory,
            getContextToken: getContextToken,
            extensionData: extensionData,
            forgeMacroExtensions: forgeMacroExtensions,
            customBridgeMethods: customBridgeMethods,
            customBridge: customBridge,
            isEditing: isEditing,
            productContextIds: productContextIds,
            productExtensionHandlers: productExtensionHandlers,
            userId: userId,
            ...props
        });
}; // Retain the generic UI Kit renderer for text, links, media and Forge extension nodes. Only
// macro.core nodes use Confluence's handler, and this factory is reached only for gated nesting.
const $108ec996f4c4b6a3$var$makeNestedADFRenderer = (dependencies, nestingDepth)=>{
    if (nestingDepth >= $108ec996f4c4b6a3$export$1aac8cfda4bbc254) return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($108ec996f4c4b6a3$export$c334f442ba514f7d, {
            ...dependencies,
            ...props,
            nestingDepth: nestingDepth
        });
};
// its own content context and the host's macro.core handler.
const $108ec996f4c4b6a3$var$EmbeddedMacroWithNestedHandler = ({ autoConvertLink: autoConvertLink, forgeMacroExtensions: forgeMacroExtensions, isEditing: isEditing, nestingDepth: nestingDepth, productExtensionHandlers: productExtensionHandlers, ...embeddedMacroProps })=>{
    const { accountId: accountId, bridge: bridge, cloudId: cloudId, contextIds: contextIds, customBridge: customBridge, customBridgeMethods: customBridgeMethods, extensionData: extensionData, getContextToken: getContextToken } = embeddedMacroProps;
    const augmentedExtensionData = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            ...extensionData,
            autoConvertLink: autoConvertLink
        }), [
        extensionData,
        autoConvertLink
    ]);
    const nestedProductExtensionHandlers = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        const macroCoreHandler = productExtensionHandlers?.['com.atlassian.confluence.macro.core'];
        return macroCoreHandler ? {
            'com.atlassian.confluence.macro.core': macroCoreHandler
        } : undefined;
    }, [
        productExtensionHandlers
    ]);
    const nestedComponents = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            AdfRenderer: $108ec996f4c4b6a3$var$makeNestedADFRenderer({
                bridge: bridge,
                cloudId: cloudId,
                customBridge: customBridge,
                customBridgeMethods: customBridgeMethods,
                extensionData: augmentedExtensionData,
                forgeMacroExtensions: forgeMacroExtensions,
                getContextToken: // Carry the original host getter to descendants. EmbeddedMacroRenderer binds it to
                // each macro's runtime; chaining those bindings would pin grandchildren to an ancestor.
                getContextToken,
                isEditing: isEditing,
                productContextIds: contextIds,
                productExtensionHandlers: nestedProductExtensionHandlers,
                userId: accountId
            }, nestingDepth)
        }), [
        accountId,
        augmentedExtensionData,
        bridge,
        cloudId,
        contextIds,
        customBridge,
        customBridgeMethods,
        forgeMacroExtensions,
        getContextToken,
        isEditing,
        nestingDepth,
        nestedProductExtensionHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4BZVV.EmbeddedMacroRenderer), {
        ...embeddedMacroProps,
        components: nestedComponents,
        extensionData: augmentedExtensionData
    });
}; /**
    * The AdfRenderer component provides a way to render a valid ADF document, using the same renderer that Atlassian uses internally to render ADF content in Confluence pages, Jira work items, and so on.
    * It allows you to replace node types that are unsupported in the context of a Forge app with replacement content, or remove them entirely.
    * See [Atlassian Document Format](/cloud/jira/platform/apis/document/structure/) for information on valid nodes.
    *
    * This component uses [@atlaskit/renderer](https://www.npmjs.com/package/@atlaskit/renderer) under the hood.
    *
    * Visit [Renderer editor](https://atlaskit.atlassian.com/examples/editor/renderer/basic) for a comprehensive list of different ADF document examples
    */ 
const $108ec996f4c4b6a3$var$makeExtensionHandlers = ({ bridge: bridge, cloudId: cloudId, embeddedMacroCustomBridgeMethods: embeddedMacroCustomBridgeMethods, customBridge: customBridge, nestedRendererDependencies: nestedRendererDependencies, extensionData: extensionData, forgeMacroExtensions: forgeMacroExtensions, isEditing: isEditing, getContextToken: getContextToken, productContextIds: productContextIds, productExtensionHandlers: productExtensionHandlers = {}, userId: userId })=>{
    const forgeMacroHandler = (props)=>{
        const { localId: localId, parameters: parameters } = props;
        const isMigrated = parameters?.isMigrated;
        const autoConvertLink = parameters?.autoConvertLink;
        const isInline = (0, $iDrrr.fg)('platform_forge_ui_embedded_inline_macro') && parameters?.layout === 'inlineExtension'; // Extract config from extension parameters (can be in guestParams or config)
        const config = parameters.guestParams || parameters.config;
        const extensionPayload = {
            config: config,
            isEditing: isEditing
        };
        const extensionProperties = parameters.extensionProperties;
        const embeddedMacroContext = parameters.embeddedMacroContext ?? extensionProperties;
        const extensionId = parameters.extensionId ?? extensionProperties?.extension?.id;
        if (!embeddedMacroContext || !extensionId) return null;
        const { accountId: accountId, cloudId: cloudId, contextIds: contextIds, extensionData: extensionData } = embeddedMacroContext; // Supplied only when pcs_3804532_nested_render_support is enabled. Keep the existing
        // renderer path below unchanged for the control cohort.
        if (nestedRendererDependencies) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($108ec996f4c4b6a3$var$EmbeddedMacroWithNestedHandler, {
            accountId: accountId,
            cloudId: cloudId,
            contextIds: contextIds,
            extensionId: extensionId,
            extensionData: extensionData,
            extensionPayload: extensionPayload,
            localId: localId,
            product: "confluence",
            extensionViewData: $108ec996f4c4b6a3$var$EMPTY_EXTENSION_VIEW_DATA,
            bridge: bridge,
            customBridgeMethods: embeddedMacroCustomBridgeMethods,
            customBridge: customBridge,
            getContextToken: getContextToken,
            isInline: isInline,
            isMigrated: isMigrated,
            embeddedMacroParentType: (0, $iDrrr.fg)('platform_forge_ui_refactor_macro_parent_type') ? 'UIKit' : undefined,
            autoConvertLink: autoConvertLink,
            forgeMacroExtensions: forgeMacroExtensions,
            isEditing: isEditing,
            nestingDepth: nestedRendererDependencies.nestingDepth + 1,
            productExtensionHandlers: nestedRendererDependencies.productExtensionHandlers
        });
        const augmentedExtensionData = {
            ...extensionData,
            autoConvertLink: autoConvertLink
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4BZVV.EmbeddedMacroRenderer), {
            accountId: accountId,
            cloudId: cloudId,
            contextIds: contextIds,
            extensionId: extensionId,
            extensionData: augmentedExtensionData,
            extensionPayload: extensionPayload,
            localId: localId,
            product: "confluence",
            extensionViewData: $108ec996f4c4b6a3$var$EMPTY_EXTENSION_VIEW_DATA,
            bridge: bridge,
            customBridgeMethods: embeddedMacroCustomBridgeMethods,
            customBridge: customBridge,
            getContextToken: getContextToken,
            isInline: isInline,
            isMigrated: isMigrated,
            embeddedMacroParentType: (0, $iDrrr.fg)('platform_forge_ui_refactor_macro_parent_type') ? 'UIKit' : undefined
        });
    };
    const baseExtensionHandlers = {
        'com.atlassian.ecosystem': forgeMacroHandler
    };
    const productMacroCoreHandlerEntry = productExtensionHandlers['com.atlassian.confluence.macro.core'];
    const productMacroCoreHandler = productMacroCoreHandlerEntry && (0, $iDrrr.fg)('platform_forge_nested_macro_font_fix') ? $108ec996f4c4b6a3$var$makeProductMacroCoreHandlerWithBaseFontStyles(productMacroCoreHandlerEntry) : productMacroCoreHandlerEntry;
    const renderProductMacroCoreHandler = typeof productMacroCoreHandler === 'function' ? productMacroCoreHandler : productMacroCoreHandler?.render;
    const renderProductMacroCore = (props, doc)=>renderProductMacroCoreHandler?.(props, doc) ?? null;
    const renderProductMacroCoreWithAnalytics = (props, doc)=>{
        const result = renderProductMacroCore(props, doc);
        if (!result) return result;
        const isInline = props.type === 'inlineExtension';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a005x.ForgeUIBodiedMacroEmbeddedContentAnalytics), {
            contentId: extensionData?.content?.id,
            embeddedMacroParentType: "UIKit",
            embeddedMacroType: "productMacroCore",
            extensionKey: props.extensionKey,
            isInline: isInline
        }, result);
    };
    const shouldTrackNestingAnalytics = (0, $cXtTj.default).getExperimentValue('platform_forge_nesting_analytics', 'isEnabled', false);
    const renderProductCoreHandlerOrForgeMacroHandler = (props, doc)=>{
        if (forgeMacroExtensions !== undefined) {
            if (forgeMacroExtensions === null) return null;
            const migratedForgeExtension = (0, $35FNt.getMigratedForgeMacroExtension)(forgeMacroExtensions, props.extensionKey);
            if (migratedForgeExtension) {
                const parameters = (0, $35FNt.createForgeParametersForConnectMacro)({
                    accountId: userId,
                    cloudId: cloudId,
                    extension: migratedForgeExtension,
                    extensionData: extensionData,
                    productContextIds: productContextIds,
                    props: props
                });
                if (!parameters) return null;
                const result = forgeMacroHandler({
                    ...props,
                    parameters: {
                        ...parameters,
                        isMigrated: shouldTrackNestingAnalytics ? true : undefined
                    }
                }, doc);
                return result;
            }
            if (!productMacroCoreHandler) return null;
            return shouldTrackNestingAnalytics ? renderProductMacroCoreWithAnalytics(props, doc) : renderProductMacroCore(props, doc);
        }
        if (!productMacroCoreHandler) return null;
        return shouldTrackNestingAnalytics ? renderProductMacroCoreWithAnalytics(props, doc) : renderProductMacroCore(props, doc);
    };
    const productMigrationHandler = productExtensionHandlers?.['com.atlassian.confluence.migration'];
    const renderProductMigrationHandler = typeof productMigrationHandler === 'function' ? productMigrationHandler : productMigrationHandler?.render;
    const renderProductMigrationWithAnalytics = (props, doc)=>{
        const result = renderProductMigrationHandler?.(props, doc) ?? null;
        if (!result) return result;
        const isInline = props.type === 'inlineExtension';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a005x.ForgeUIBodiedMacroEmbeddedContentAnalytics), {
            contentId: extensionData?.content?.id,
            embeddedMacroParentType: "UIKit",
            embeddedMacroType: "productMigration",
            extensionKey: props.extensionKey,
            isInline: isInline
        }, result);
    };
    const productMigrationHandlerWithAnalytics = productMigrationHandler && shouldTrackNestingAnalytics ? renderProductMigrationWithAnalytics : productMigrationHandler;
    return {
        ...baseExtensionHandlers,
        'com.atlassian.confluence.macro.core': renderProductCoreHandlerOrForgeMacroHandler,
        ...productMigrationHandlerWithAnalytics && {
            'com.atlassian.confluence.migration': productMigrationHandlerWithAnalytics
        }
    };
};
const $108ec996f4c4b6a3$export$c334f442ba514f7d = (props)=>{
    const supportsMedia = $108ec996f4c4b6a3$var$useSupportsMedia();
    const { egress: egress, properties: properties, appDomainName: appDomainName, forgeEnvironment: forgeEnvironment, appId: appId, openNewTabAsPopupWindow: openNewTabAsPopupWindow } = (0, $cozmU.useContext)((0, $fTOZ6.RendererContext));
    const imagesEgressService = (0, $gFIer.useEgressPermissionService)('IMAGES', egress);
    const mediaEgressService = (0, $gFIer.useEgressPermissionService)('MEDIA', egress);
    const { bridge: bridge, cloudId: cloudId, customBridgeMethods: embeddedMacroCustomBridgeMethods, customBridge: customBridge, dataProviders: dataProviders, extensionData: extensionData, forgeMacroExtensions: forgeMacroExtensions, isEditing: isEditing, getContextToken: getContextToken, productContextIds: productContextIds, productExtensionHandlers: productExtensionHandlers, nestingDepth: nestingDepth = 0, userId: userId } = props;
    const { onNavigate: onNavigate, getModalJsx: getModalJsx } = (0, $67Hav.useNavigation)({
        extension: {
            egress: egress,
            properties: properties
        },
        appId: appId,
        onNavigate: bridge?.onNavigate,
        openNewTabAsPopupWindow: openNewTabAsPopupWindow
    });
    const { document: adfDocument, documentWithoutMedia: documentWithoutMedia, ...adfRendererProps } = props.forgeDoc.props;
    const isNestedExtensionTableWidthFixEnabled = (0, $iDrrr.fg)('platform_forge_nested_table_width_fix'); // The client provides both the document with media and without media, as it doesn't know whether the MediaClientProvider is present
    // Then, in the parent product, we can decide whether to render the document with media or without media
    const doc = !supportsMedia && documentWithoutMedia ? documentWithoutMedia : adfDocument;
    const { nestedExtensionTableMinWidth: nestedExtensionTableMinWidth } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>isNestedExtensionTableWidthFixEnabled ? (0, $2Ni8p.getNestedExtensionTableAnalysis)(doc) : {
            containsExtension: false,
            nestedExtensionTableMinWidth: undefined
        }, [
        doc,
        isNestedExtensionTableWidthFixEnabled
    ]);
    const { extensionContainerWidth: extensionContainerWidth, rendererContainerRef: rendererContainerRef } = (0, $2Ni8p.useForgeExtensionContainerWidth)(nestedExtensionTableMinWidth !== undefined);
    const nestedExtensionTableWidth = (0, $2Ni8p.getNestedExtensionTableWidth)(nestedExtensionTableMinWidth, extensionContainerWidth);
    const nestedExtensionRendererMinWidth = nestedExtensionTableWidth ? nestedExtensionTableWidth + (0, $2Ni8p.NESTED_EXTENSION_TABLE_INLINE_START_OFFSET) : undefined;
    const rendererWidth = Math.max(extensionContainerWidth ?? 0, nestedExtensionRendererMinWidth ?? 0);
    (0, $2Ni8p.useNestedExtensionTableWidth)(rendererContainerRef, nestedExtensionTableWidth);
    const rendererContainerStyle = rendererWidth ? {
        width: `${rendererWidth}px`
    } : undefined;
    const { filteredDocument: filteredDocument, invalidUrls: invalidUrls } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>doc ? $108ec996f4c4b6a3$var$filterInvalidMediaUrls(appDomainName, [
            imagesEgressService,
            mediaEgressService
        ], doc) : {
            filteredDocument: undefined,
            invalidUrls: []
        }, [
        appDomainName,
        doc,
        imagesEgressService,
        mediaEgressService
    ]);
    const rendererDocument = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>filteredDocument && nestedExtensionTableWidth ? (0, $2Ni8p.resizeNestedExtensionTables)(filteredDocument, nestedExtensionTableWidth) : filteredDocument, [
        filteredDocument,
        nestedExtensionTableWidth
    ]);
    if (!doc || !rendererDocument) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    const renderer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hRnS5.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
        ...adfRendererProps,
        ...isNestedExtensionTableWidthFixEnabled && {
            appearance: 'full-width',
            UNSTABLE_allowTableAlignment: true,
            UNSTABLE_allowTableResizing: true,
            allowFixedColumnWidthOption: true
        },
        allowCustomPanels: true,
        dataProviders: dataProviders,
        eventHandlers: {
            link: {
                onClick: (e)=>{
                    e.preventDefault();
                    adfRendererProps?.eventHandlers?.link?.onClick?.(e, e.currentTarget.href);
                    onNavigate({
                        type: 'same-tab',
                        url: (0, $9XnlZ.sanitizeUrl)(e.currentTarget.href)
                    });
                }
            }
        },
        document: rendererDocument,
        extensionHandlers: $108ec996f4c4b6a3$var$makeExtensionHandlers({
            bridge: bridge,
            cloudId: cloudId,
            embeddedMacroCustomBridgeMethods: embeddedMacroCustomBridgeMethods,
            customBridge: customBridge,
            extensionData: extensionData,
            forgeMacroExtensions: forgeMacroExtensions,
            isEditing: isEditing,
            getContextToken: getContextToken,
            productContextIds: productContextIds,
            productExtensionHandlers: productExtensionHandlers,
            userId: userId,
            ...(0, $iDrrr.fg)('pcs_3804532_nested_render_support') && {
                nestedRendererDependencies: {
                    nestingDepth: nestingDepth,
                    productExtensionHandlers: productExtensionHandlers
                }
            }
        })
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, forgeEnvironment === 'DEVELOPMENT' && invalidUrls.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6BvLK.EgressErrorMessage), {
            key: url,
            url: url
        })), getModalJsx(), isNestedExtensionTableWidthFixEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: rendererContainerRef,
        style: rendererContainerStyle
    }, renderer) : renderer);
};
module.exports["makeADFRenderer"] = $108ec996f4c4b6a3$export$a504d7ec22d4b3f4;
module.exports["AdfRenderer"] = $108ec996f4c4b6a3$export$c334f442ba514f7d;

});

parcelRegister("a005x", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $DIyeF = parcelRequire("DIyeF");


var $fTCJP = parcelRequire("fTCJP");


var $6FQr4 = parcelRequire("6FQr4");

const $8c747d61f3d69552$var$EmbeddedMacroRenderedAnalyticsTrigger = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { extensionKey: extensionKey, source: source } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const analyticsSource = source ?? page;
    let t1;
    let t2;
    if ($[0] !== analyticsSource || $[1] !== createAnalyticsEvent || $[2] !== extensionKey) {
        t1 = ()=>{
            (0, $6FQr4.trackBodiedMacroEmbeddedContent)(createAnalyticsEvent, {
                source: analyticsSource,
                extensionKey: extensionKey
            });
        };
        t2 = [
            analyticsSource,
            createAnalyticsEvent,
            extensionKey
        ];
        $[0] = analyticsSource;
        $[1] = createAnalyticsEvent;
        $[2] = extensionKey;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
} : ({ extensionKey: extensionKey, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const analyticsSource = source ?? page;
    (0, $cozmU.useEffect)(()=>{
        (0, $6FQr4.trackBodiedMacroEmbeddedContent)(createAnalyticsEvent, {
            source: analyticsSource,
            extensionKey: extensionKey
        });
    }, [
        analyticsSource,
        createAnalyticsEvent,
        extensionKey
    ]);
    return null;
};
const $8c747d61f3d69552$export$22c58ed2c6d282da = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children, contentId: contentId, embeddedMacroParentType: t1, embeddedMacroType: t2, extensionKey: extensionKey, isInline: isInline, source: source } = t0;
    const embeddedMacroParentType = t1 === undefined ? "UIKit" : t1;
    const embeddedMacroType = t2 === undefined ? "productMacroCore" : t2;
    let t3;
    if ($[0] !== extensionKey || $[1] !== source) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8c747d61f3d69552$var$EmbeddedMacroRenderedAnalyticsTrigger, {
            extensionKey: extensionKey,
            source: source
        });
        $[0] = extensionKey;
        $[1] = source;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== children || $[4] !== contentId || $[5] !== embeddedMacroParentType || $[6] !== embeddedMacroType || $[7] !== isInline || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fTCJP.ForgeUIEmbeddedMacroAnalyticsContext), {
            contentId: contentId,
            embeddedMacroParentType: embeddedMacroParentType,
            embeddedMacroType: embeddedMacroType,
            isInline: isInline
        }, t3, children);
        $[3] = children;
        $[4] = contentId;
        $[5] = embeddedMacroParentType;
        $[6] = embeddedMacroType;
        $[7] = isInline;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ children: children, contentId: contentId, embeddedMacroParentType: embeddedMacroParentType = 'UIKit', embeddedMacroType: embeddedMacroType = 'productMacroCore', extensionKey: extensionKey, isInline: isInline, source: source })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fTCJP.ForgeUIEmbeddedMacroAnalyticsContext), {
        contentId: contentId,
        embeddedMacroParentType: embeddedMacroParentType,
        embeddedMacroType: embeddedMacroType,
        isInline: isInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8c747d61f3d69552$var$EmbeddedMacroRenderedAnalyticsTrigger, {
        extensionKey: extensionKey,
        source: source
    }), children);
};
module.exports["ForgeUIBodiedMacroEmbeddedContentAnalytics"] = $8c747d61f3d69552$export$22c58ed2c6d282da;

});

parcelRegister("4G9b9", function(module, exports) {

var $kwzZh = parcelRequire("kwzZh");

const $24a0bc86fd9eb2ae$export$8210f5f78c0bcf27 = (cloudId, userId)=>new (0, $kwzZh.default)({
        providers: [
            {
                url: '/gateway/api/emoji/standard'
            },
            {
                url: '/gateway/api/emoji/atlassian'
            },
            {
                url: `/gateway/api/emoji/${cloudId}/site`
            }
        ],
        currentUser: userId ? {
            id: userId
        } : undefined
    }).getEmojiProvider();
module.exports["getEmojiProvider"] = $24a0bc86fd9eb2ae$export$8210f5f78c0bcf27;

});

parcelRegister("35FNt", function(module, exports) {
const $28462bf0a1463e2a$var$FORGE_MACRO_MODULE_TYPE = 'xen:macro';
const $28462bf0a1463e2a$var$STATIC_MODULE_KEY_SEGMENT = '/static/';
const $28462bf0a1463e2a$export$10e34576c0b0b7c2 = (extensionId)=>{
    if (!extensionId) return;
    const staticModuleKeyIndex = extensionId.indexOf($28462bf0a1463e2a$var$STATIC_MODULE_KEY_SEGMENT);
    if (staticModuleKeyIndex === -1) return;
    return extensionId.slice(staticModuleKeyIndex + $28462bf0a1463e2a$var$STATIC_MODULE_KEY_SEGMENT.length);
};
const $28462bf0a1463e2a$export$157b3a147b626a8d = (forgeMacroExtensions, extensionKey)=>{
    if (!extensionKey || !forgeMacroExtensions) return;
    return forgeMacroExtensions.find((extension)=>extension.type === $28462bf0a1463e2a$var$FORGE_MACRO_MODULE_TYPE && Boolean(extension.migrationKey) && $28462bf0a1463e2a$export$10e34576c0b0b7c2(extension.id) === extensionKey);
};
const $28462bf0a1463e2a$export$2d02be23603c7977 = (extension)=>{
    if (extension?.properties?.layout === 'inline') return 'inlineExtension';
    return undefined;
};
const $28462bf0a1463e2a$export$32ee00d981bcfb18 = ({ accountId: accountId, cloudId: cloudId, extension: extension, extensionData: extensionData, productContextIds: productContextIds, props: props })=>{
    if (!cloudId || !productContextIds || !accountId) return;
    const parameters = {
        ...props.parameters ?? {}
    };
    const guestParams = {
        ...parameters.guestParams ?? {}
    };
    Object.entries(parameters.macroParams ?? {}).forEach(([key, macroParam])=>{
        if (typeof guestParams[key] === 'undefined') guestParams[key] = macroParam?.value;
    });
    return {
        ...parameters,
        embeddedMacroContext: {
            ...parameters.embeddedMacroContext,
            accountId: parameters.embeddedMacroContext?.accountId ?? accountId,
            cloudId: parameters.embeddedMacroContext?.cloudId ?? cloudId,
            contextIds: parameters.embeddedMacroContext?.contextIds ?? productContextIds,
            extensionData: parameters.embeddedMacroContext?.extensionData ?? extensionData
        },
        extensionId: parameters.extensionId ?? extension.id,
        extensionTitle: parameters.extensionTitle ?? (typeof extension.properties?.title === 'string' ? extension.properties.title : undefined),
        guestParams: guestParams,
        layout: parameters.layout ?? $28462bf0a1463e2a$export$2d02be23603c7977(extension)
    };
};
module.exports["getMigratedForgeMacroExtension"] = $28462bf0a1463e2a$export$157b3a147b626a8d;
module.exports["createForgeParametersForConnectMacro"] = $28462bf0a1463e2a$export$32ee00d981bcfb18;

});

parcelRegister("2Ni8p", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $b7e4f66189f2b64b$var$FORGE_EXTENSION_CONTAINER_SELECTOR = '[data-forge-extension-container]';
const $b7e4f66189f2b64b$var$MIN_TABLE_COLUMN_WIDTH_WITH_EXTENSION = 160;
// Ignore subpixel differences from zoom and layout rounding to avoid ResizeObserver churn.
const $b7e4f66189f2b64b$var$CONTAINER_WIDTH_TOLERANCE_PX = 1;
const $b7e4f66189f2b64b$export$6624bbff07c1eebb = 32;
const $b7e4f66189f2b64b$var$isExtensionNode = (node)=>node.type === 'extension' || node.type === 'bodiedExtension' || node.type === 'inlineExtension';
const $b7e4f66189f2b64b$var$getTableColumnCount = (tableNode)=>{
    if (!Array.isArray(tableNode.content)) return 0;
    return tableNode.content.reduce((maxColumns, row)=>{
        if (row.type !== 'tableRow' || !Array.isArray(row.content)) return maxColumns;
        const columns = row.content.reduce((count, cell)=>{
            const colspan = typeof cell.attrs?.colspan === 'number' ? cell.attrs.colspan : 1;
            return count + colspan;
        }, 0);
        return Math.max(maxColumns, columns);
    }, 0);
};
const $b7e4f66189f2b64b$export$ad52afba6f15d589 = (node)=>{
    if (!node || typeof node !== 'object') return {
        containsExtension: false
    };
    const adfNode = node;
    const childAnalyses = adfNode.content?.map($b7e4f66189f2b64b$export$ad52afba6f15d589) ?? [];
    const containsExtension = $b7e4f66189f2b64b$var$isExtensionNode(adfNode) || childAnalyses.some((analysis)=>analysis.containsExtension);
    const childMinWidth = Math.max(0, ...childAnalyses.map((analysis)=>analysis.nestedExtensionTableMinWidth ?? 0));
    if (adfNode.type !== 'table' || !containsExtension) return {
        containsExtension: containsExtension,
        nestedExtensionTableMinWidth: childMinWidth || undefined
    };
    const columnCount = $b7e4f66189f2b64b$var$getTableColumnCount(adfNode);
    const currentWidth = typeof adfNode.attrs?.width === 'number' ? adfNode.attrs.width : 0;
    const minWidth = columnCount * $b7e4f66189f2b64b$var$MIN_TABLE_COLUMN_WIDTH_WITH_EXTENSION;
    return {
        containsExtension: containsExtension,
        nestedExtensionTableMinWidth: Math.max(childMinWidth, currentWidth, minWidth) || undefined
    };
};
const $b7e4f66189f2b64b$var$resizeNestedExtensionTablesInternal = (node, tableWidth)=>{
    const resizedChildren = node.content?.map((child)=>$b7e4f66189f2b64b$var$resizeNestedExtensionTablesInternal(child, tableWidth));
    const containsExtension = $b7e4f66189f2b64b$var$isExtensionNode(node) || Boolean(resizedChildren?.some((child)=>child.containsExtension));
    const resizedContent = resizedChildren?.map((child)=>child.node);
    const resizedNode = resizedContent ? {
        ...node,
        content: resizedContent
    } : node;
    if (node.type !== 'table' || !containsExtension) return {
        containsExtension: containsExtension,
        node: resizedNode
    };
    const currentWidth = typeof node.attrs?.width === 'number' ? node.attrs.width : 0;
    return {
        containsExtension: containsExtension,
        node: {
            ...resizedNode,
            attrs: {
                ...node.attrs,
                width: Math.max(currentWidth, tableWidth)
            }
        }
    };
};
const $b7e4f66189f2b64b$export$1677922b5cecc89e = (node, tableWidth)=>$b7e4f66189f2b64b$var$resizeNestedExtensionTablesInternal(node, tableWidth).node;
const $b7e4f66189f2b64b$export$c258ed5f7aead2c7 = (minWidth, extensionContainerWidth)=>minWidth ? Math.max(minWidth, (extensionContainerWidth ?? 0) - $b7e4f66189f2b64b$export$6624bbff07c1eebb) : undefined;
const $b7e4f66189f2b64b$export$4d03f4495375fd0f = (enabled)=>{
    const rendererContainerRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const [extensionContainerWidth, setExtensionContainerWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState();
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!enabled) {
            setExtensionContainerWidth(undefined);
            return;
        }
        const rendererContainer = rendererContainerRef.current;
        const extensionContainer = rendererContainer?.closest($b7e4f66189f2b64b$var$FORGE_EXTENSION_CONTAINER_SELECTOR);
        if (!rendererContainer || !extensionContainer) return;
        // Nested ADF can inherit a narrower saved width than the Forge host. Expand only when the
        // host currently offers more space, preserving the renderer width in every other case.
        const updateWidth = ()=>{
            const availableWidth = extensionContainer.getBoundingClientRect().width;
            const parentWidth = rendererContainer.parentElement?.getBoundingClientRect().width ?? 0;
            setExtensionContainerWidth(availableWidth > parentWidth + $b7e4f66189f2b64b$var$CONTAINER_WIDTH_TOLERANCE_PX ? Math.round(availableWidth) : undefined);
        };
        updateWidth();
        if (typeof ResizeObserver === 'undefined') return;
        const resizeObserver = new ResizeObserver(updateWidth);
        resizeObserver.observe(extensionContainer);
        if (rendererContainer.parentElement) resizeObserver.observe(rendererContainer.parentElement);
        return ()=>resizeObserver.disconnect();
    }, [
        enabled
    ]);
    return {
        extensionContainerWidth: extensionContainerWidth,
        rendererContainerRef: rendererContainerRef
    };
};
const $b7e4f66189f2b64b$var$setImportantStyles = (element, styles)=>{
    const isCurrent = Object.entries(styles).every(([property, value])=>element.style.getPropertyValue(property) === value && element.style.getPropertyPriority(property) === 'important');
    if (isCurrent) return;
    // cloneNode preserves attributes, including inline styles. Update the detached declaration so
    // the live element is mutated once without discarding unrelated Atlaskit styles.
    const nextStyle = element.cloneNode(false).style;
    Object.entries(styles).forEach(([property, value])=>{
        nextStyle.setProperty(property, value, 'important');
    });
    element.style.cssText = nextStyle.cssText;
};
const $b7e4f66189f2b64b$export$ab610de09e5e6264 = (rendererContainerRef, tableWidth)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!tableWidth) return;
        const rendererContainer = rendererContainerRef.current;
        if (!rendererContainer) return;
        const applyTableWidth = ()=>{
            const tableContainers = rendererContainer.querySelectorAll('.pm-table-container');
            const width = `${tableWidth}px`;
            tableContainers.forEach((tableContainer)=>{
                const table = tableContainer.querySelector('table');
                const tableWrapper = tableContainer.querySelector('.pm-table-wrapper');
                const styleContainer = tableContainer.closest('[role="none"]');
                if (styleContainer) $b7e4f66189f2b64b$var$setImportantStyles(styleContainer, {
                    width: width,
                    'max-width': 'none',
                    'margin-inline-start': `${$b7e4f66189f2b64b$export$6624bbff07c1eebb}px`,
                    'margin-inline-end': '0px'
                });
                $b7e4f66189f2b64b$var$setImportantStyles(tableContainer, {
                    width: width,
                    'max-width': 'none'
                });
                if (tableWrapper) $b7e4f66189f2b64b$var$setImportantStyles(tableWrapper, {
                    width: width
                });
                if (table) $b7e4f66189f2b64b$var$setImportantStyles(table, {
                    width: width
                });
            });
        };
        applyTableWidth();
        const animationFrameId = typeof requestAnimationFrame === 'undefined' ? undefined : requestAnimationFrame(applyTableWidth);
        const mutationObserver = typeof MutationObserver === 'undefined' ? undefined : new MutationObserver(applyTableWidth);
        mutationObserver?.observe(rendererContainer, {
            attributeFilter: [
                'style'
            ],
            attributes: true,
            subtree: true
        });
        if (typeof ResizeObserver === 'undefined') return ()=>{
            if (animationFrameId !== undefined) cancelAnimationFrame(animationFrameId);
            mutationObserver?.disconnect();
        };
        const resizeObserver = new ResizeObserver(applyTableWidth);
        resizeObserver.observe(rendererContainer);
        return ()=>{
            if (animationFrameId !== undefined) cancelAnimationFrame(animationFrameId);
            mutationObserver?.disconnect();
            resizeObserver.disconnect();
        };
    }, [
        rendererContainerRef,
        tableWidth
    ]);
};
module.exports["NESTED_EXTENSION_TABLE_INLINE_START_OFFSET"] = $b7e4f66189f2b64b$export$6624bbff07c1eebb;
module.exports["getNestedExtensionTableAnalysis"] = $b7e4f66189f2b64b$export$ad52afba6f15d589;
module.exports["resizeNestedExtensionTables"] = $b7e4f66189f2b64b$export$1677922b5cecc89e;
module.exports["getNestedExtensionTableWidth"] = $b7e4f66189f2b64b$export$c258ed5f7aead2c7;
module.exports["useForgeExtensionContainerWidth"] = $b7e4f66189f2b64b$export$4d03f4495375fd0f;
module.exports["useNestedExtensionTableWidth"] = $b7e4f66189f2b64b$export$ab610de09e5e6264;

});

parcelRegister("dPlMJ", function(module, exports) {
/* ConnectEosBanner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $cXtTj = parcelRequire("cXtTj");


var $lvJqX = parcelRequire("lvJqX");


var $1VhsF = parcelRequire("1VhsF");


var $jtT80 = parcelRequire("jtT80");


var $7dBf8 = parcelRequire("7dBf8");


var $7OuPp = parcelRequire("7OuPp");


var $lEfEl = parcelRequire("lEfEl");

function $3d63ea7a98a3f43b$var$_defineProperty(e, r, t) {
    return (r = $3d63ea7a98a3f43b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $3d63ea7a98a3f43b$var$_toPropertyKey(t) {
    var i = $3d63ea7a98a3f43b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $3d63ea7a98a3f43b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $3d63ea7a98a3f43b$export$4f5b90a6ce229aa1 = 'customer-messaging-iframe-banner-dismiss-days';
const $3d63ea7a98a3f43b$export$5b9fb60c3fa87c1a = 'customer_messaging_apps_blocked_by_atlassian';
const $3d63ea7a98a3f43b$export$461103d5504d4d8b = 'connect-eos-banner_dismissed';
const $3d63ea7a98a3f43b$var$BSC_SUCCESS_STATUS = 'SUCCESS';
const $3d63ea7a98a3f43b$var$BSC_BLOCKED_STATUS = 'BLOCKED';
const $3d63ea7a98a3f43b$export$9d00c95780551685 = 30;
const $3d63ea7a98a3f43b$export$10cefe68e4bb6b44 = 86400000;
const $3d63ea7a98a3f43b$export$a916575f88d9889f = 'customer-messaging-iframe-banner-enabled';
const $3d63ea7a98a3f43b$export$35fbf2628e8debb2 = 'customer_messaging_iframes_phase_2';
const $3d63ea7a98a3f43b$export$61abdb4e3a264073 = 'customer_messaging_iframes_phase_3';
const $3d63ea7a98a3f43b$var$FEATURE_GATE_DEV_CANARY_ENABLED = 'customer-messaging-is-dev-canary';
const $3d63ea7a98a3f43b$var$DEVELOPER_CANARY_PROGRAM_URL = 'https://developer.atlassian.com/cloud/jira/platform/developer-canary-program/';
const $3d63ea7a98a3f43b$var$FORGE_CHANGELOG_URL = 'https://developer.atlassian.com/platform/forge/changelog/';
const $3d63ea7a98a3f43b$var$DEFAULT_LOCALE = 'en';
const $3d63ea7a98a3f43b$var$defaultIntlCache = (0, $kSwu1.createIntlCache)();
const $3d63ea7a98a3f43b$var$defaultIntl = (0, $kSwu1.createIntl)({
    locale: $3d63ea7a98a3f43b$var$DEFAULT_LOCALE
}, $3d63ea7a98a3f43b$var$defaultIntlCache);
const $3d63ea7a98a3f43b$var$containerStyles = {
    marginBottom: '8px'
};
const $3d63ea7a98a3f43b$var$devCanaryMessageStyles = null;
function $3d63ea7a98a3f43b$export$e6e73547b6ec2430(appKey) {
    return `${appKey}-${$3d63ea7a98a3f43b$export$461103d5504d4d8b}`;
}
class $3d63ea7a98a3f43b$var$ConnectEosBannerComponent extends $cozmU.PureComponent {
    _getDismissDurationMs() {
        const days = (0, $cXtTj.default).getExperiment($3d63ea7a98a3f43b$export$4f5b90a6ce229aa1, {
            fireExperimentExposure: false
        }).get('value', $3d63ea7a98a3f43b$export$9d00c95780551685);
        return (typeof days === 'number' && days > 0 ? days : $3d63ea7a98a3f43b$export$9d00c95780551685) * $3d63ea7a98a3f43b$export$10cefe68e4bb6b44;
    }
    _isDismissed() {
        if (typeof window === 'undefined') return false;
        const dismissStorageKey = $3d63ea7a98a3f43b$export$e6e73547b6ec2430(this.props.appKey);
        const storedItem = (0, $7dBf8.AtlBrowserStorageLocal).getItem(dismissStorageKey);
        if (!storedItem) return false;
        let dismissedAt;
        try {
            const parsedItem = JSON.parse(storedItem);
            dismissedAt = parsedItem.value;
        } catch (e) {
            (0, $7OuPp.logger).warn('Failed to parse Connect EOS banner dismissal', {
                key: dismissStorageKey,
                error: e
            });
            return false;
        }
        if (!dismissedAt) return false;
        const dismissedTimestamp = Number(dismissedAt);
        if (isNaN(dismissedTimestamp)) return false;
        return Date.now() - dismissedTimestamp < this._getDismissDurationMs();
    }
    _shouldShowBanner() {
        // Don't show if the main feature gate is not enabled
        if (!(0, $cXtTj.default).checkGate($3d63ea7a98a3f43b$export$a916575f88d9889f)) return false;
         // Don't show for system apps
        if (this.props.isSystemApp) return false;
        if (this._isBlockedByAtlassian()) return false;
        const phaseGate = this._getPhaseGate();
        if (phaseGate && !(0, $cXtTj.default).checkGate(phaseGate)) return false;
         // Don't show if previously dismissed (within configured dismiss duration)
        if (this.state.dismissed) return false;
        return true;
    }
    _getMigrationCohort() {
        const migration = this.props.connectToForgeMigration;
        if (!migration?.defined) return 'UNDECLARED';
        switch(migration.willMigrateToForgeBeforeEOS){
            case 'NO':
            case 'YES':
            case 'UNDECIDED':
                return migration.willMigrateToForgeBeforeEOS;
            default:
                return 'UNDECIDED';
        }
    }
    _getPhaseGate() {
        switch(this._getMigrationCohort()){
            case 'NO':
                return undefined;
            case 'YES':
                return $3d63ea7a98a3f43b$export$61abdb4e3a264073;
            case 'UNDECLARED':
            case 'UNDECIDED':
            default:
                return $3d63ea7a98a3f43b$export$35fbf2628e8debb2;
        }
    }
    _isBlockedByAtlassian() {
        const blockedAppKeys = (0, $cXtTj.default).getExperiment($3d63ea7a98a3f43b$export$5b9fb60c3fa87c1a, {
            fireExperimentExposure: false
        }).get('value', []);
        return Array.isArray(blockedAppKeys) && typeof this.props.appKey === 'string' && blockedAppKeys.includes(this.props.appKey);
    }
    _isProd() {
        if (typeof window === 'undefined') return false;
        return window.location.hostname.endsWith('.atlassian.net');
    }
    _isSiteAdmin() {
        return this.props.isSiteAdmin ?? false;
    }
    _isDevCanary() {
        return (0, $cXtTj.default).checkGate($3d63ea7a98a3f43b$var$FEATURE_GATE_DEV_CANARY_ENABLED);
    }
    _getConnectedAppsUrl() {
        const cloudId = this.props.cloudId ?? (typeof document !== 'undefined' ? document.querySelector('meta[name="ajs-cloud-id"]')?.content : undefined) ?? undefined;
        const adminHost = this._isProd() ? 'admin.atlassian.com' : 'admin.stg.atlassian.com';
        if (!cloudId) return undefined;
        return `https://${adminHost}/s/${cloudId}/user-connected-apps/tab/installed`;
    }
    _getMessageBody() {
        const { appName: appName } = this.props;
        const isSiteAdmin = this._isSiteAdmin();
        const connectedAppsUrl = this._getConnectedAppsUrl();
        const migrationGuideUrl = this.props.connectToForgeMigration?.migrationGuideUrl?.trim();
        const cohort = this._getMigrationCohort();
        const messageCohort = cohort !== 'UNDECLARED' && !migrationGuideUrl ? 'UNDECLARED' : cohort;
        const messages = {
            UNDECLARED: isSiteAdmin ? (0, $lEfEl.connectEosBannerMessages).undeclaredAdmin : (0, $lEfEl.connectEosBannerMessages).undeclaredNonAdmin,
            NO: isSiteAdmin ? (0, $lEfEl.connectEosBannerMessages).noAdmin : (0, $lEfEl.connectEosBannerMessages).noNonAdmin,
            UNDECIDED: isSiteAdmin ? (0, $lEfEl.connectEosBannerMessages).undecidedAdmin : (0, $lEfEl.connectEosBannerMessages).undecidedNonAdmin,
            YES: isSiteAdmin ? (0, $lEfEl.connectEosBannerMessages).yesAdmin : (0, $lEfEl.connectEosBannerMessages).yesNonAdmin
        };
        const connectedApps = (chunks)=>/*#__PURE__*/ $cozmU.createElement("strong", null, connectedAppsUrl ? /*#__PURE__*/ $cozmU.createElement("a", {
                href: connectedAppsUrl
            }, chunks) : /*#__PURE__*/ $cozmU.createElement("span", null, chunks));
        const migrationGuide = (chunks)=>migrationGuideUrl ? /*#__PURE__*/ $cozmU.createElement("a", {
                href: migrationGuideUrl,
                target: "_blank",
                rel: "noopener noreferrer"
            }, chunks) : /*#__PURE__*/ $cozmU.createElement("span", null, chunks);
        const strong = (chunks)=>/*#__PURE__*/ $cozmU.createElement("strong", null, chunks);
        return /*#__PURE__*/ $cozmU.createElement("p", null, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
            ...messages[messageCohort],
            values: {
                appName: appName ?? '',
                hasAppName: Boolean(appName),
                strong: strong,
                connectedApps: connectedApps,
                migrationGuide: migrationGuide
            }
        }));
    }
    _getDevCanaryMessageBody() {
        if (!this._isDevCanary()) return null;
        const developerCanaryProgram = (chunks)=>/*#__PURE__*/ $cozmU.createElement("a", {
                href: $3d63ea7a98a3f43b$var$DEVELOPER_CANARY_PROGRAM_URL,
                target: "_blank",
                rel: "noopener noreferrer"
            }, chunks);
        const forgeChangelog = (chunks)=>/*#__PURE__*/ $cozmU.createElement("a", {
                href: $3d63ea7a98a3f43b$var$FORGE_CHANGELOG_URL,
                target: "_blank",
                rel: "noopener noreferrer"
            }, chunks);
        return /*#__PURE__*/ $cozmU.createElement("p", {
            className: (0, $hekY6.default)([
                "_313842Pgdg"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $lEfEl.connectEosBannerMessages).devCanaryMessage,
            values: {
                developerCanaryProgram: developerCanaryProgram,
                forgeChangelog: forgeChangelog
            }
        }));
    }
    _getDismissAction() {
        return /*#__PURE__*/ $cozmU.createElement((0, $jtT80.default), {
            onClick: this._dismiss,
            key: "dismiss"
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $lEfEl.connectEosBannerMessages).dismiss));
    }
    getSectionWarningBanner() {
        return /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "connect-eos-banner",
            style: $3d63ea7a98a3f43b$var$containerStyles
        }, /*#__PURE__*/ $cozmU.createElement((0, $1VhsF.default), {
            appearance: "warning"
        }, this._getMessageBody(), this._getDevCanaryMessageBody(), this._getDismissAction()));
    }
    getInlineBanner() {
        return /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "connect-eos-v2-banner"
        }, /*#__PURE__*/ $cozmU.createElement((0, $lvJqX.default), {
            appearance: "warning",
            secondaryText: (this.props.intl ?? $3d63ea7a98a3f43b$var$defaultIntl).formatMessage((0, $lEfEl.connectEosBannerMessages).inlineSecondaryText)
        }, this._getMessageBody(), this._getDevCanaryMessageBody(), this._getDismissAction()));
    }
    render() {
        if (!this._shouldShowBanner()) return null;
        const banner = this.props.moduleType === 'webPanels' ? this.getInlineBanner() : this.getSectionWarningBanner();
        if (!this.props.intl) return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.RawIntlProvider), {
            value: $3d63ea7a98a3f43b$var$defaultIntl
        }, banner);
        return banner;
    }
    constructor(props){
        super(props);
        $3d63ea7a98a3f43b$var$_defineProperty(this, "_dismiss", ()=>{
            const dismissedAt = Date.now();
            const storedItem = JSON.stringify({
                value: dismissedAt
            });
            const dismissStorageKey = $3d63ea7a98a3f43b$export$e6e73547b6ec2430(this.props.appKey); // @browser-storage setter
            (0, $7dBf8.AtlBrowserStorageLocal).setItem(dismissStorageKey, storedItem).then((result)=>{
                if (result?.status && result.status !== $3d63ea7a98a3f43b$var$BSC_SUCCESS_STATUS && result.status !== $3d63ea7a98a3f43b$var$BSC_BLOCKED_STATUS) (0, $7OuPp.logger).warn('Failed to persist Connect EOS banner dismissal', {
                    key: dismissStorageKey,
                    result: result
                });
            }).catch((error)=>{
                (0, $7OuPp.logger).warn('Failed to persist Connect EOS banner dismissal', {
                    key: dismissStorageKey,
                    error: error
                });
            });
            this.setState({
                dismissed: true
            });
        });
        this.state = {
            dismissed: this._isDismissed()
        };
    }
}
$3d63ea7a98a3f43b$var$_defineProperty($3d63ea7a98a3f43b$var$ConnectEosBannerComponent, "defaultProps", {
    isSystemApp: false,
    moduleType: ''
});
const $3d63ea7a98a3f43b$export$70b82b13309d5477 = (0, $kSwu1.injectIntl)($3d63ea7a98a3f43b$var$ConnectEosBannerComponent, {
    enforceContext: false
});
module.exports["ConnectEosBanner"] = $3d63ea7a98a3f43b$export$70b82b13309d5477;

});

parcelRegister("7OuPp", function(module, exports) {
/* eslint-disable */ // @ts-nocheck

var $jDYJM = parcelRequire("jDYJM");

class $8825011921e30ce8$var$LoggerController {
    isDebugEnabled() {
        return this.debugEnabled;
    }
    isInfoEnabled() {
        return this.infoEnabled;
    }
    constructor(){
        this.debugEnabled = false;
        this.infoEnabled = true;
    }
}
/**
 * This class serves two purposes:
 *   - It provides the ability for products to register their implementations
 *     of LoggerAPI for use by the connect front end code.
 *   - It provides the LoggerAPI implementation that connect front end code
 *     should use. This implementation delegates to the registered LoggerAPI
 *     implementation. This class should be used within the connect front end
 *     code as follows:
 *
 *     import logger from '../adaptors/logger/LoggerAdaptor';
 *
 *     logger.info('My message', extraStuffOfInterest, etc, ...);
 */ class $8825011921e30ce8$var$LoggerAdaptor {
    /**
   * Implementation of AnalyticsRegistry#registerAnalyticsAPI().
   */ registerLoggerAPI(loggerAPI) {
        this.loggerAPI = loggerAPI;
    }
    /**
   * Implementation of LoggerAPI#debug() for use by connect-module-core code.
   */ debug(message, ...optionalParams) {
        try {
            if (this.loggerController.isDebugEnabled()) this.loggerAPI.debug.apply(this.loggerAPI, arguments);
        } catch (exception) {
        // Ignore
        }
    }
    /**
   * Implementation of LoggerAPI#info() for use by connect-module-core code.
   */ info(message, ...optionalParams) {
        try {
            if (this.loggerController.isInfoEnabled()) this.loggerAPI.info.apply(this.loggerAPI, arguments);
        } catch (exception) {
        // Ignore
        }
    }
    /**
   * Implementation of LoggerAPI#warn() for use by connect-module-core code.
   */ warn(message, ...optionalParams) {
        try {
            this.loggerAPI.warn.apply(this.loggerAPI, arguments);
        } catch (exception) {
            const logger = console.warn || console.log;
            if (logger) logger.apply(logger, arguments);
        }
    }
    /**
   * Implementation of LoggerAPI#error() for use by connect-module-core code.
   */ error(message, ...optionalParams) {
        try {
            this.loggerAPI.error.apply(this.loggerAPI, arguments);
        } catch (exception) {
            const logger = console.error || console.log;
            if (logger) logger.apply(logger, arguments);
        }
    }
    constructor(){
        this.loggerController = void 0;
        this.loggerAPI = (0, $jDYJM.default);
        this.loggerController = new $8825011921e30ce8$var$LoggerController();
        window._loggerController = this.loggerController;
    }
}
const $8825011921e30ce8$export$af88d00dbe7f521 = new $8825011921e30ce8$var$LoggerAdaptor();
module.exports["logger"] = $8825011921e30ce8$export$af88d00dbe7f521;

});

parcelRegister("jDYJM", function(module, exports) {
$parcel$export(module.exports, "default", () => $14ab1827b564829e$export$2e2bcd8739ae039);
/* eslint-disable */ // @ts-nocheck
class $14ab1827b564829e$var$DefaultLoggerAPI {
    debug(message, ...optionalParams) {
        console.debug.apply(console, arguments);
    }
    info(message, ...optionalParams) {
        console.info.apply(console, arguments);
    }
    warn(message, ...optionalParams) {
        console.warn.apply(console, arguments);
    }
    error(message, ...optionalParams) {
        console.error.apply(console, arguments);
    }
}
var $14ab1827b564829e$export$2e2bcd8739ae039 = new $14ab1827b564829e$var$DefaultLoggerAPI();

});

parcelRegister("lEfEl", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $e33f058366d031a5$export$db71c19e7db05343 = (0, $kSwu1.defineMessages)({
    undeclaredAdmin: {
        id: "connect-module-core.modules.app.undeclaredAdmin",
        defaultMessage: "{hasAppName, select, true {The <strong>{appName}</strong> app} other {This app}} is running on a platform we\u2019ll no longer support after January 2027. Check <connectedApps>Connected apps</connectedApps> to see what options are available for all similar apps."
    },
    undeclaredNonAdmin: {
        id: "connect-module-core.modules.app.undeclaredNonAdmin",
        defaultMessage: "{hasAppName, select, true {The <strong>{appName}</strong> app} other {This app}} is running on a platform we\u2019ll no longer support after January 2027. To explore your options, contact your site admin."
    },
    noAdmin: {
        id: "connect-module-core.modules.app.noAdmin",
        defaultMessage: "{hasAppName, select, true {The <strong>{appName}</strong> app} other {This app}} is running on a platform we\u2019ll no longer support after January 2027; after that, the vendor <migrationGuide><strong>will discontinue supporting it as well</strong></migrationGuide>. Check <connectedApps>Connected apps</connectedApps> to see what options are available for all similar apps."
    },
    noNonAdmin: {
        id: "connect-module-core.modules.app.noNonAdmin",
        defaultMessage: "{hasAppName, select, true {The <strong>{appName}</strong> app} other {This app}} is running on a platform we\u2019ll no longer support after January 2027. To explore your options, contact your site admin."
    },
    undecidedAdmin: {
        id: "connect-module-core.modules.app.undecidedAdmin",
        defaultMessage: "{hasAppName, select, true {The <strong>{appName}</strong> app} other {This app}} is running on a platform we\u2019ll no longer support after January 2027. <migrationGuide><strong>Learn more</strong></migrationGuide> about the vendor's plans to migrate app users (including you). Check <connectedApps>Connected apps</connectedApps> to see what options are available for all similar apps."
    },
    undecidedNonAdmin: {
        id: "connect-module-core.modules.app.undecidedNonAdmin",
        defaultMessage: "{hasAppName, select, true {The <strong>{appName}</strong> app} other {This app}} is running on a platform we\u2019ll no longer support after January 2027. <migrationGuide><strong>Learn more</strong></migrationGuide> about the vendor's plans to migrate app users (including you). To explore your options, contact your site admin."
    },
    yesAdmin: {
        id: "connect-module-core.modules.app.yesAdmin",
        defaultMessage: "{hasAppName, select, true {This version of <strong>{appName}</strong>} other {This app}} is running on a platform we\u2019ll no longer support after January 2027. The app developer is creating a new version; read about their <migrationGuide>migration plans for app users</migrationGuide>."
    },
    yesNonAdmin: {
        id: "connect-module-core.modules.app.yesNonAdmin",
        defaultMessage: "{hasAppName, select, true {This version of <strong>{appName}</strong>} other {This app}} is running on a platform we\u2019ll no longer support after January 2027. The app developer is creating a new version; read about their <migrationGuide>migration plans for app users</migrationGuide>."
    },
    devCanaryMessage: {
        id: "connect-module-core.eos.devCanaryMessage",
        defaultMessage: "You're seeing this message because your tenant is enrolled in the <developerCanaryProgram>Developer Canary Program</developerCanaryProgram>. For updates on when this goes live in production, watch the <forgeChangelog>Forge changelog</forgeChangelog>."
    },
    dismiss: {
        id: "connect-module-core.eos.dismiss",
        defaultMessage: "Dismiss"
    },
    inlineSecondaryText: {
        id: "connect-module-core.eos.inlineSecondaryText",
        defaultMessage: "This app might stop working soon"
    }
});
module.exports["connectEosBannerMessages"] = $e33f058366d031a5$export$db71c19e7db05343;

});

parcelRegister("jAI8J", function(module, exports) {
/**
 * Set of system app addon keys.
 * These are special built-in applications that are part of the system.
 */ const $252ad196ad9bae6b$var$SYSTEM_APP_ADDON_KEYS = new Set([
    'jira-slack-integration',
    'com.atlassian.servicedesk.embedded',
    'com.atlassian.servicedesk.embedded.moderate',
    'stspg-jira-ops',
    'com.atlassian.jira.spreadsheets',
    'atlassian-outlook-integration',
    'com.codebarrel.addons.automation',
    'com.codebarrel.addons.automation.moderate',
    'opsgenie-jira-adapter',
    'opsgenie-jira-adapter.moderate',
    'halp.com',
    'halp.moderate.com',
    'msteams-jira',
    'com.atlassian.atlas.jira',
    'cello',
    'msteams-confluence',
    'opsgenie-incident-timeline-lab',
    'com.addonengine.analytics'
]);
function $252ad196ad9bae6b$export$4d755424ce1abae9(addonKey) {
    return $252ad196ad9bae6b$var$SYSTEM_APP_ADDON_KEYS.has(addonKey);
}
module.exports["isSystemApp"] = $252ad196ad9bae6b$export$4d755424ce1abae9;

});

parcelRegister("kksmx", function(module, exports) {
const $e82f7a932bbd9bed$export$66373c7c22b9de3c = '__LEGACY_MACRO_SSRED__';
const $e82f7a932bbd9bed$export$583da28e18e772e3 = (macroOutput, macroData)=>{
    if (macroOutput) return 'ssr-new';
    else if (macroData) return 'ssr-exp';
    return 'ssr-legacy';
};
const $e82f7a932bbd9bed$export$90da570939dfebac = (macroId)=>window[$e82f7a932bbd9bed$export$66373c7c22b9de3c]?.[macroId];
const $e82f7a932bbd9bed$export$b0e8f73fcaf60c5c = ({ macroId: macroId, renderType: renderType })=>{
    return null;
};
module.exports["getRenderType"] = $e82f7a932bbd9bed$export$583da28e18e772e3;
module.exports["getExtensionSSRMark"] = $e82f7a932bbd9bed$export$90da570939dfebac;
module.exports["ExtensionSSRMark"] = $e82f7a932bbd9bed$export$b0e8f73fcaf60c5c;

});

parcelRegister("4JC0x", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");

const $98c2a7811aa5a89d$export$fe853ff85807a350 = new Map();
let $98c2a7811aa5a89d$export$576fafc5561e06f5 = null;
const $98c2a7811aa5a89d$var$getListOfPreloadedMacrosFromApolloState = (0, $dOBRD.default)(()=>{
    const rootQueryList = window?.__APOLLO_STATE__?.ROOT_QUERY || {};
    return Object.keys(rootQueryList).filter((query)=>query.startsWith('macroBodyRenderer'));
});
function $98c2a7811aa5a89d$var$isMacroPreloaded(macroId) {
    const preloadedMacros = $98c2a7811aa5a89d$var$getListOfPreloadedMacrosFromApolloState();
    return preloadedMacros.some((preloaded)=>preloaded.includes(macroId));
}
const $98c2a7811aa5a89d$export$1441f92d09a5c3ee = ()=>window.__SSR_RENDERED__ && !!window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__;
function $98c2a7811aa5a89d$var$getPreloadFailedMacrosImpl() {
    const cacheMismatches = $98c2a7811aa5a89d$var$getPreloadCacheMismatches();
    const reportedFails = window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__ || {};
    if (cacheMismatches.length == 0 && (!reportedFails || typeof reportedFails !== 'object' || Object.keys(reportedFails).length === 0)) return;
    const failedMacros = {};
    function addFailed(reason, macroId, extensionKey) {
        failedMacros[macroId] = {
            reason: reason,
            extensionKey: extensionKey
        };
    }
    Object.entries(reportedFails).forEach(([keyAndId, reason])=>{
        if (keyAndId === 'general') return;
        const [extensionKey, macroId] = keyAndId.split(':');
        if (reason === 'timeout') {
            if ($98c2a7811aa5a89d$var$isMacroPreloaded(macroId)) addFailed('falseTimeouts', macroId, extensionKey);
            else addFailed('trueTimeouts', macroId, extensionKey);
        } else addFailed(reason, macroId, extensionKey);
    });
    cacheMismatches.forEach(([macroId, extensionKey])=>addFailed('cacheMismatch', macroId, extensionKey));
    return failedMacros;
}
function $98c2a7811aa5a89d$export$622ff65a4d6eaaaf() {
    if (!$98c2a7811aa5a89d$export$576fafc5561e06f5) $98c2a7811aa5a89d$export$576fafc5561e06f5 = {
        value: $98c2a7811aa5a89d$var$getPreloadFailedMacrosImpl()
    };
    return $98c2a7811aa5a89d$export$576fafc5561e06f5.value;
}
function $98c2a7811aa5a89d$export$de5406af81980582() {
    $98c2a7811aa5a89d$export$576fafc5561e06f5 = null;
}
function $98c2a7811aa5a89d$export$3288a79f0c713f52(macroId) {
    const failedMacros = $98c2a7811aa5a89d$export$622ff65a4d6eaaaf();
    return failedMacros?.[macroId]?.reason;
}
function $98c2a7811aa5a89d$export$34734b475a3fd7b9() {
    const reportedFails = window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__ || {};
    if (!reportedFails || typeof reportedFails !== 'object' || Object.keys(reportedFails).length === 0) return;
    return reportedFails?.['general'];
}
function $98c2a7811aa5a89d$export$4d6ac53bc9b1b8bd(macroId, extensionKey) {
    $98c2a7811aa5a89d$export$576fafc5561e06f5 = null;
    $98c2a7811aa5a89d$export$fe853ff85807a350.set(macroId, extensionKey || '');
    window['__MISSING_DATA_MACROS__'] = window['__MISSING_DATA_MACROS__'] || [];
    window['__MISSING_DATA_MACROS__'].push(macroId);
}
function $98c2a7811aa5a89d$var$getPreloadCacheMismatches() {
    return [
        ...$98c2a7811aa5a89d$export$fe853ff85807a350
    ].filter(([macroId])=>$98c2a7811aa5a89d$var$isMacroPreloaded(macroId));
}
module.exports["macrosPreloadPerformed"] = $98c2a7811aa5a89d$export$1441f92d09a5c3ee;
module.exports["getPreloadFailedMacros"] = $98c2a7811aa5a89d$export$622ff65a4d6eaaaf;
module.exports["getPreloadFailures"] = $98c2a7811aa5a89d$export$3288a79f0c713f52;
module.exports["getGeneralFailures"] = $98c2a7811aa5a89d$export$34734b475a3fd7b9;
module.exports["markMissingMacroData"] = $98c2a7811aa5a89d$export$4d6ac53bc9b1b8bd;

});

parcelRegister("foRF9", function(module, exports) {

var $aoRTi = parcelRequire("aoRTi");


var $8pcS0 = parcelRequire("8pcS0");


var $fgbpl = parcelRequire("fgbpl");


var $aMlgD = parcelRequire("aMlgD");


var $6mEZ3 = parcelRequire("6mEZ3");

const $5faed47790e8728c$var$isBlueprint = (contentId)=>!/^[0-9]+$/.test(contentId);
const $5faed47790e8728c$export$74ec65bf601b5f8c = async (options)=>{
    const { macroDefinition: macroDefinition, contentId: contentId, selectedMacro: selectedMacro, intl: intl } = options;
    const results = await (0, $aoRTi.experimentalMacroPlaceholderADFQuery)({
        variables: {
            contentId: $5faed47790e8728c$var$isBlueprint(contentId) ? '0' : contentId ?? '0',
            macroDefinition: JSON.stringify(macroDefinition)
        }
    });
    let placeholderAdf;
    try {
        if (results?.data) placeholderAdf = JSON.parse(results?.data?.experimentalMacroPlaceholderADF?.json);
    } catch  {
        // eslint-disable-next-line no-console
        console.error('Error getting placeholder ADF');
    }
    const adf = {
        ...placeholderAdf
    };
    if ((0, $fgbpl.isBodiedExtension)(adf.type)) {
        if (selectedMacro) // Copy the macro contents into the adf node
        adf.content = selectedMacro.content;
        else if (!adf.content || adf.content.length === 0) {
            if (adf.type === (0, $8pcS0.BODIED_EXTENSION_TYPE)) adf.content = (0, $8pcS0.EMPTY_ADF_CONTENT);
            if (adf.type === (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE)) adf.content = (0, $8pcS0.MULTI_BODIED_INITIAL_CONTENT);
        }
    }
    const macroAttributes = (0, $6mEZ3.formatAsMacroAttributes)(adf);
    if (intl) {
        const macroTitleOverride = (0, $aMlgD.getMacroTitleOverride)(macroDefinition.name, intl);
        if (macroTitleOverride && macroAttributes.attrs.parameters?.macroMetadata) macroAttributes.attrs.parameters.macroMetadata.title = macroTitleOverride;
    }
    return macroAttributes;
};
module.exports["fetchMacroAttributes"] = $5faed47790e8728c$export$74ec65bf601b5f8c;

});

parcelRegister("aoRTi", function(module, exports) {

var $iS5Ay = parcelRequire("iS5Ay");


var $aBfpe = parcelRequire("aBfpe");


var $hBkCm = parcelRequire("hBkCm");

const $fef05c831d419c6c$export$145bdd0c11f23103 = async ({ variables: variables })=>{
    const result = await (0, $iS5Ay.experimentalQuery)({
        url: '/wiki/rest/internal/1.0/macro/placeholder',
        method: 'POST',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        body: JSON.stringify({
            macro: JSON.parse(variables.macroDefinition),
            contentId: variables.contentId
        }),
        parseResponseOnError: (error)=>{
            if ((0, $hBkCm.BadStatusError).isBadStatusError(error)) return {
                __badStatusError: true
            };
            throw error;
        },
        parseResult: (json)=>{
            if (json && typeof json === 'object' && '__badStatusError' in json) return {
                experimentalMacroPlaceholderADF: {
                    json: ''
                }
            };
            return {
                experimentalMacroPlaceholderADF: {
                    json: JSON.stringify(json)
                }
            };
        },
        variables: variables
    });
    return {
        data: result.data
    };
};
module.exports["experimentalMacroPlaceholderADFQuery"] = $fef05c831d419c6c$export$145bdd0c11f23103;

});

parcelRegister("fgbpl", function(module, exports) {

var $8pcS0 = parcelRequire("8pcS0");

const $aba988feb2cb54c3$export$b05e83f63451e97 = (extensionType)=>{
    return [
        (0, $8pcS0.BODIED_EXTENSION_TYPE),
        (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE)
    ].indexOf(extensionType) >= 0;
};
module.exports["isBodiedExtension"] = $aba988feb2cb54c3$export$b05e83f63451e97;

});

parcelRegister("bD3fd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::57a3a98d1c0cdf17dca67c7ba0624f0f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8775da7cfc706ac1$var$_react = $8775da7cfc706ac1$var$_interopRequireDefault((parcelRequire("cozmU")));

var $8775da7cfc706ac1$var$_iconNew = $8775da7cfc706ac1$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $8775da7cfc706ac1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Jira".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/jira
 * Usage guidance:
 * Representing JIRA
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8775da7cfc706ac1$var$JiraIcon = (props)=>/*#__PURE__*/ $8775da7cfc706ac1$var$_react.default.createElement($8775da7cfc706ac1$var$_iconNew.default, Object.assign({
        name: "JiraIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 1.25A.75.75 0 0 1 7.75.5h7a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-.75.75h-1.625A2.6 2.6 0 0 1 12 8.747v3.003a.75.75 0 0 1-.75.75H9.625a2.6 2.6 0 0 1-1.125-.253v3.003a.75.75 0 0 1-.75.75H6.125A2.625 2.625 0 0 1 3.5 13.375V12.5h-.875A2.625 2.625 0 0 1 0 9.875V8.25a.75.75 0 0 1 .75-.75h3.003A2.6 2.6 0 0 1 3.5 6.375V4.75A.75.75 0 0 1 4.25 4h3.003A2.6 2.6 0 0 1 7 2.875zM9.625 4h1.625a.75.75 0 0 1 .75.75v1.625c0 .621.504 1.125 1.125 1.125H14V2H8.5v.875C8.5 3.496 9.004 4 9.625 4m.875 1.5H5v.875C5 6.996 5.504 7.5 6.125 7.5H7.75a.75.75 0 0 1 .75.75v1.625c0 .621.504 1.125 1.125 1.125h.875zM7 9H1.5v.875c0 .621.504 1.125 1.125 1.125H4.25a.75.75 0 0 1 .75.75v1.625c0 .621.504 1.125 1.125 1.125H7z" clip-rule="evenodd"/>`
    }, props));
$8775da7cfc706ac1$var$JiraIcon.displayName = 'JiraIcon';
var $8775da7cfc706ac1$var$_default = module.exports.default = $8775da7cfc706ac1$var$JiraIcon;

});

parcelRegister("c2cyb", function(module, exports) {
/* TemplateIcon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $7zsi1 = parcelRequire("7zsi1");


var $arQY7 = parcelRequire("arQY7");


var $cJ0FD = parcelRequire("cJ0FD");


var $kkFbH = parcelRequire("kkFbH");


var $dAyZN = parcelRequire("dAyZN");


var $8nXYN = parcelRequire("8nXYN");

const $41adb9ebadfabbfe$var$iconWrapperStyles = null;
const $41adb9ebadfabbfe$var$imageWrapperStyles = null;
const $41adb9ebadfabbfe$var$InjectedTemplateIcon = ({ template: template, isDisabled: isDisabled = false, size: size = 'medium' })=>{
    if (template.iconURL) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "template-icon-avatar",
        className: (0, $hekY6.default)([
            "_4xdlr0chRC"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        appearance: "square",
        size: size,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _3iDTPbQ4SZ _24h04i2Njc _0adFHs1Y8M _3YEZNOdnbC _2O5VijdnbC _4xdlr0chRC _2OUyjtYbGa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7zsi1.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        alt: "",
        src: template.iconURL || '',
        srcDark: template.darkModeIconURL || ''
    })))));
    else if (template.styleClass) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dAyZN.TemplateLegacyIcon), {
        size: size,
        template: template
    });
    else // Ideally, this code will never be used. However, if the BE response is missing an iconURL for some reason,
    // this will return an icon with a grey background color that looks like the icon for 3rd party templates.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8nXYN.DefaultIcon), {
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), {
        spacing: "spacious",
        color: "var(--ds-icon-inverse, #FFFFFF)",
        label: ""
    }));
};
// The avatar-item component, which actually renders TemplateIcon, passes a backgroundColor
// prop to the TemplateIcon. The TemplateIcon and InjectedTemplateIcon disregard this backgroundColor
// prop. Therefore, we can ignore the backgroundColor prop for memoization.
const $41adb9ebadfabbfe$var$areEqual = (prevProps, nextProps)=>{
    return prevProps.template === nextProps.template && prevProps.isDisabled === nextProps.isDisabled && prevProps.size === nextProps.size;
};
const $41adb9ebadfabbfe$export$17f8b5fdc0dde895 = /*#__PURE__*/ (0, $cozmU.memo)($41adb9ebadfabbfe$var$InjectedTemplateIcon, $41adb9ebadfabbfe$var$areEqual);
module.exports["TemplateIcon"] = $41adb9ebadfabbfe$export$17f8b5fdc0dde895;

});

parcelRegister("dAyZN", function(module, exports) {
/* TemplateLegacyIcon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $cozmU = parcelRequire("cozmU");

const $c41888ccf34d17d9$var$smallBackgroundSize = null;
const $c41888ccf34d17d9$var$mediumBackgroundSize = null;
const $c41888ccf34d17d9$var$largeBackgroundSize = null;
const $c41888ccf34d17d9$var$smallSize = null;
const $c41888ccf34d17d9$var$mediumSize = null;
const $c41888ccf34d17d9$var$largeSize = null;
const $c41888ccf34d17d9$var$styles = {
    classIconWrapperStyles: "_0aNu0LYbGa",
    classIconStyles: "_0bjKvDzXzM",
    iconStyles: "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _24h04i2Njc _0adFHs1Y8M _3YEZNOdnbC _2O5VijdnbC _4xdlr0chRC _2OUyjtYbGa"
};
const $c41888ccf34d17d9$var$backgroundSizeMapping = {
    small: $c41888ccf34d17d9$var$smallBackgroundSize,
    medium: $c41888ccf34d17d9$var$mediumBackgroundSize,
    large: $c41888ccf34d17d9$var$largeBackgroundSize
};
const $c41888ccf34d17d9$var$sizeMapping = {
    small: $c41888ccf34d17d9$var$smallSize,
    medium: $c41888ccf34d17d9$var$mediumSize,
    large: $c41888ccf34d17d9$var$largeSize
}; // The avatar-item component, which actually renders TemplateLegacyIcon, passes a backgroundColor
// prop to the TemplateLegacyIcon. The TemplateLegacyIcon disregards this backgroundColor
// prop. Therefore, we can ignore the backgroundColor prop for memoization.
const $c41888ccf34d17d9$var$areEqual = (prevProps, nextProps)=>{
    return prevProps.template === nextProps.template;
};
const $c41888ccf34d17d9$export$7da270837ef49506 = /*#__PURE__*/ (0, $cozmU.memo)(({ template: template, size: size = 'medium' })=>{
    const styleClass = template.styleClass || '';
    const itemModuleCompleteKey = template.itemModuleCompleteKey || '';
    const blueprintModuleCompleteKey = template.blueprintModuleCompleteKey || '';
    const contentBlueprintId = template.contentBlueprintId || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            $c41888ccf34d17d9$var$styles.iconStyles,
            $c41888ccf34d17d9$var$styles.classIconWrapperStyles,
            "template"
        ]),
        "data-item-module-complete-key": itemModuleCompleteKey,
        "data-blueprint-module-complete-key": blueprintModuleCompleteKey,
        "data-content-blueprint-id": contentBlueprintId,
        "data-testid": "template-icon-legacy"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            $c41888ccf34d17d9$var$styles.iconStyles,
            "_2QcWTwbGuW _2SqxC464sR _2JgCDVNDbq",
            "_2QcWTwLoGj _2SqxC4BE2a _2JgCDVoynL",
            $c41888ccf34d17d9$var$styles.classIconStyles,
            styleClass
        ]),
        style: {
            "--_1sqmkfg": (0, $9aYkv.default)($c41888ccf34d17d9$var$smallSize),
            "--_1clui7k": (0, $9aYkv.default)($c41888ccf34d17d9$var$mediumSize),
            "--_1ok9ig": (0, $9aYkv.default)($c41888ccf34d17d9$var$largeSize),
            "--_10y2yj4": (0, $9aYkv.default)($c41888ccf34d17d9$var$smallBackgroundSize),
            "--_b7jail": (0, $9aYkv.default)($c41888ccf34d17d9$var$mediumBackgroundSize),
            "--_w9udt4": (0, $9aYkv.default)($c41888ccf34d17d9$var$largeBackgroundSize)
        }
    }));
}, $c41888ccf34d17d9$var$areEqual);
module.exports["TemplateLegacyIcon"] = $c41888ccf34d17d9$export$7da270837ef49506;

});

parcelRegister("8nXYN", function(module, exports) {
/* TemplateIconStyles.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $cozmU = parcelRequire("cozmU");

const $978a137b0603779d$var$defaultIconCss = null;
const $978a137b0603779d$var$smallSize = null;
const $978a137b0603779d$var$mediumSize = null;
const $978a137b0603779d$var$largeSize = null;
const $978a137b0603779d$var$iconStyles = null;
const $978a137b0603779d$var$sizeMapping = {
    small: $978a137b0603779d$var$smallSize,
    medium: $978a137b0603779d$var$mediumSize,
    large: $978a137b0603779d$var$largeSize
};
const $978a137b0603779d$export$d206ce4c12e8ddf6 = ({ children: children, size: size = 'medium' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "template-icon-default",
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _0Of8r21Y8M _2fwxA5DIqT _0KLXrurxgm",
            "_2QcWTwbGuW _2SqxC464sR _2JgCDVNDbq",
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _24h04i2Njc _0adFHs1Y8M _3YEZNOdnbC _2O5VijdnbC _4xdlr0chRC _2OUyjtYbGa"
        ]),
        style: {
            "--_1sqmkfg": (0, $9aYkv.default)($978a137b0603779d$var$smallSize),
            "--_1clui7k": (0, $9aYkv.default)($978a137b0603779d$var$mediumSize),
            "--_1ok9ig": (0, $9aYkv.default)($978a137b0603779d$var$largeSize)
        }
    }, children);
};
module.exports["DefaultIcon"] = $978a137b0603779d$export$d206ce4c12e8ddf6;

});

parcelRegister("6Ywr0", function(module, exports) {

var $3d5UI = parcelRequire("3d5UI");

function $bb082ed2371b78b6$export$dfb0c4efd029859d(module) {
    try {
        window.require(module);
        return true;
    } catch (err) {
        return false;
    }
}
function $bb082ed2371b78b6$export$2b551419a2839406({ listener: listener, module: module, interval: interval = 250 }, callback) {
    (0, $3d5UI.waitForGlobal)({
        listener: `wait-for-required-module ${module}`,
        globalProperty: 'require'
    }, ()=>{
        if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
            callback();
            return;
        }
        const waitForRequiredModuleInterval = setInterval(()=>{
            if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
                clearInterval(waitForRequiredModuleInterval);
                callback();
            }
        }, interval);
    });
}
module.exports["isRequiredModuleLoaded"] = $bb082ed2371b78b6$export$dfb0c4efd029859d;
module.exports["waitForRequiredModule"] = $bb082ed2371b78b6$export$2b551419a2839406;

});

parcelRegister("10Oe6", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $dOBRD = parcelRequire("dOBRD");


var $5cryL = parcelRequire("5cryL");


var $9wGTI = parcelRequire("9wGTI");


var $iacta = parcelRequire("iacta");


var $ae5hk = parcelRequire("ae5hk");

const $f4c21c880d0229da$var$i18n = (0, $kSwu1.defineMessages)({
    featuredCategoryName: {
        id: "template-utils.featured.category.name",
        defaultMessage: "Featured"
    },
    myTemplatesCategoryName: {
        id: "template-utils.my-templates.category.name",
        defaultMessage: "My Templates"
    },
    starredCategoryName: {
        id: "template-utils.starred.category.name",
        defaultMessage: "Starred"
    },
    promotedCategoryName: {
        id: "template-utils.promoted.category.name",
        defaultMessage: "Promoted"
    }
});
const $f4c21c880d0229da$export$612b286afa12407b = '00000000-0000-0000-0000-000000000001';
const $f4c21c880d0229da$export$3b0b898c62947fee = (templateId)=>!/^[0-9]+$/.test(templateId);
const $f4c21c880d0229da$export$47ee581a4caa8fa2 = (templateId)=>!templateId || templateId === '';
const $f4c21c880d0229da$export$13d482a11efa2b43 = (template)=>{
    return template?.blueprintModuleCompleteKey || template?.templateId || template?.itemModuleCompleteKey || '';
};
const $f4c21c880d0229da$export$c095b4283dffab05 = (template)=>{
    return template.contentBlueprintId || template.templateId || '';
};
const $f4c21c880d0229da$export$3abed2086f3435f9 = (template)=>{
    if (!template) return null;
    if (template.templateType === 'blueprint' && template.hasGlobalBlueprintContent && template.contentBlueprintId !== $f4c21c880d0229da$export$612b286afa12407b) return template.blueprintModuleCompleteKey ?? null;
    return $f4c21c880d0229da$export$c095b4283dffab05(template);
};
const $f4c21c880d0229da$export$f19afdee92cfd543 = (templates, selectedSortOrder)=>{
    const nonFeaturedTemplates = [];
    const promotedTemplates = [];
    const customTemplates = [];
    templates.forEach((template)=>{
        if (template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')) {
            if (!template.categoryIds.includes((0, $iacta.FEATURED_CATEGORY_ID))) template.categoryIds.push((0, $iacta.FEATURED_CATEGORY_ID));
            // We want to show all promoted templates first, regardless of
            // whether or not the template is custom
            if (template.categoryIds.includes('template.category.promoted')) promotedTemplates.push(template);
            else customTemplates.push(template);
        } else nonFeaturedTemplates.push(template);
    });
    // If alphabetical sort is on, we don't care to show featured categories first
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) return [
        ...promotedTemplates,
        ...customTemplates,
        ...nonFeaturedTemplates
    ];
    else return templates;
};
const $f4c21c880d0229da$export$6d6fdbfe01edf136 = (templates, currentUserId, additionalTemplateIdsList)=>{
    templates.forEach((t)=>{
        const isStarredTemplateOrCreatedByCurrentUser = t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || // checks for recently unstarred templates that we still want to display
        additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(t)) || t.author === currentUserId;
        if (isStarredTemplateOrCreatedByCurrentUser && !t.categoryIds.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) t.categoryIds.push((0, $iacta.MY_TEMPLATES_CATEGORY_ID));
    });
};
const $f4c21c880d0229da$export$dea26c1eb71953eb = (templates)=>templates?.filter((template)=>template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')).length;
const $f4c21c880d0229da$export$e4f285fe1dc6eb6 = (templates, currentUserId)=>templates?.filter((template)=>template.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || template.author === currentUserId).length;
const $f4c21c880d0229da$export$c5981f9aba761c29 = (availableCategories, lastSelectedCategoryIds)=>availableCategories.filter((category)=>lastSelectedCategoryIds.includes(category.id)).map((category)=>category.id);
const $f4c21c880d0229da$export$cdc91788760e8bf8 = (0, $dOBRD.default)((templates, additionalTemplateIdsList)=>{
    return templates.filter((t)=>t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || additionalTemplateIdsList.has($f4c21c880d0229da$export$3abed2086f3435f9(t)));
});
const $f4c21c880d0229da$export$1caa21769d3bff9a = (templates, categoryIds, selectedSortOrder, currentUserId, additionalTemplateIdsList)=>{
    if (!categoryIds.length) return templates;
    if (categoryIds?.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) $f4c21c880d0229da$export$6d6fdbfe01edf136(templates, currentUserId, additionalTemplateIdsList);
    const isFeaturedCategorySelected = categoryIds?.includes((0, $iacta.FEATURED_CATEGORY_ID));
    const templatesToBeFiltered = isFeaturedCategorySelected ? $f4c21c880d0229da$export$f19afdee92cfd543(templates, selectedSortOrder) : templates;
    return templatesToBeFiltered?.filter((template)=>template?.categoryIds?.some((categoryId)=>categoryIds?.includes(categoryId) || additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template))));
};
const $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter = (categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList)=>{
    const isRecentlyUnstarred = additionalUnstarredTemplateIdsList && additionalUnstarredTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName)) && isFavourite || isRecentlyUnstarred) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName));
    else if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName)) && isPromoted) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName));
    const isFeaturedCategoryTemplate = categoryIds.includes('template.category.promoted') || categoryIds.includes('template.category.custom');
    const isMyTemplatesCategoryTemplate = categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || author === currentUserId;
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName)) && isFeaturedCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName)) && isMyTemplatesCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName));
    const keywordsIncludesSearchQuery = (keyword)=>keyword?.toLowerCase().includes(lowercaseQuery);
    return keywords.some(keywordsIncludesSearchQuery);
};
const $f4c21c880d0229da$export$698b1171e770b401 = (query, intl, currentUserId, additionalUnstarredTemplateIdsList)=>{
    return (template)=>{
        const lowercaseQuery = query.toLowerCase();
        const name = template.name || '';
        const description = template.description || '';
        const author = template.author || '';
        const keywords = template.keywords || [];
        const categoryIds = template.categoryIds || [];
        const isFavourite = template.isFavourite || false;
        const isPromoted = template.isPromoted || false;
        const blueprintAuthor = template.blueprintModuleCompleteKey ? author : '';
        const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList);
        return name.toLowerCase().includes(lowercaseQuery) || description.toLowerCase().includes(lowercaseQuery) || blueprintAuthor.toLowerCase().includes(lowercaseQuery) || keywordsIncludeSearchQuery;
    };
};
const $f4c21c880d0229da$export$bf559da1453b0f39 = (0, $dOBRD.default)((templates, intl, currentUserId, searchQuery, additionalUnstarredTemplateIdsList)=>{
    if (searchQuery) {
        const searchQueryFilter = $f4c21c880d0229da$export$698b1171e770b401(searchQuery, intl, currentUserId, additionalUnstarredTemplateIdsList);
        templates = templates.filter(searchQueryFilter);
    }
    return templates;
});
const $f4c21c880d0229da$export$23b29992d53f1142 = (template, intl, currentUserId, searchQuery)=>{
    if (!searchQuery) return {
        searchQueryMatchesTitle: false,
        searchQueryMatchesDescription: false,
        searchQueryMatchesAuthor: false,
        searchQueryMatchesKeywords: false
    };
    const lowercaseQuery = searchQuery.toLowerCase();
    const name = template.name || '';
    const description = template.description || '';
    const author = template.author || '';
    const keywords = template.keywords || [];
    const categoryIds = template.categoryIds || [];
    const isFavourite = template.isFavourite;
    const isPromoted = template.isPromoted;
    const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId);
    return {
        searchQueryMatchesTitle: name.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesDescription: description.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesAuthor: author.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesKeywords: keywordsIncludeSearchQuery
    };
};
const $f4c21c880d0229da$export$16f4535f1b52f11d = (0, $dOBRD.default)((templates, includeEditorTutorialTemplate, selectedSortOrder)=>{
    // filter out null templates
    const nonNullTemplates = templates.filter((template)=>!!template);
    const tutorialIndex = nonNullTemplates.findIndex((element)=>// only one should appear at the same time
        (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED) : element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY));
    if (tutorialIndex === -1) return nonNullTemplates;
    const tutorial = nonNullTemplates[tutorialIndex];
    // Remove the editor tutorial template if it shouldn't be included
    if (!includeEditorTutorialTemplate) {
        nonNullTemplates.splice(tutorialIndex, 1);
        return nonNullTemplates;
    }
    // If the sorting order is not alphabetical
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) {
        // Remove the tutorial template, and then add it to the front.
        nonNullTemplates.splice(tutorialIndex, 1);
        nonNullTemplates.unshift(tutorial);
    }
    return nonNullTemplates;
});
const $f4c21c880d0229da$export$9b34fbf9a069b426 = (0, $dOBRD.default)((templates, allowList)=>{
    if (!allowList.length) return templates;
    return templates.filter((template)=>allowList.includes($f4c21c880d0229da$export$13d482a11efa2b43(template)));
});
const $f4c21c880d0229da$export$d444d78112a48f41 = (template)=>{
    if (template.blueprintModuleCompleteKey) return {
        idType: 'blueprint',
        id: template.blueprintModuleCompleteKey
    };
    if (template.templateId) return {
        idType: 'template',
        id: template.templateId
    };
    return {
        idType: 'other',
        id: template.itemModuleCompleteKey
    };
};
const $f4c21c880d0229da$export$9fd27f38e4a8e848 = (templates, favouritedTemplatesList)=>{
    // filter out null templates
    const filteredTemplates = templates.filter((template)=>!!template);
    if (!favouritedTemplatesList) return filteredTemplates;
    return filteredTemplates.map((template)=>{
        const isFavourite = favouritedTemplatesList.some((favouritedTemplateId)=>favouritedTemplateId === $f4c21c880d0229da$export$3abed2086f3435f9(template));
        // avoid re-adding starred category to a template that has already been starred
        const categoryIds = template.categoryIds.filter((category)=>category !== (0, $iacta.STARRED_CATEGORY_ID));
        if (isFavourite) categoryIds.push((0, $iacta.STARRED_CATEGORY_ID));
        return {
            ...template,
            isFavourite: isFavourite,
            categoryIds: categoryIds
        };
    });
};
module.exports["BLOG_CONTENT_BLUEPRINT_ID"] = $f4c21c880d0229da$export$612b286afa12407b;
module.exports["isBlueprint"] = $f4c21c880d0229da$export$3b0b898c62947fee;
module.exports["getTemplateKey"] = $f4c21c880d0229da$export$13d482a11efa2b43;
module.exports["getTemplateId"] = $f4c21c880d0229da$export$c095b4283dffab05;
module.exports["getTemplateIdForUserPreferences"] = $f4c21c880d0229da$export$3abed2086f3435f9;
module.exports["getFeaturedCategoryCount"] = $f4c21c880d0229da$export$dea26c1eb71953eb;
module.exports["getMyTemplatesCategoryCount"] = $f4c21c880d0229da$export$e4f285fe1dc6eb6;
module.exports["getExistingCategoryIds"] = $f4c21c880d0229da$export$c5981f9aba761c29;
module.exports["filterTemplatesByCategoryIds"] = $f4c21c880d0229da$export$1caa21769d3bff9a;
module.exports["filterTemplatesBySearchQuery"] = $f4c21c880d0229da$export$bf559da1453b0f39;
module.exports["getSearchQueryMatches"] = $f4c21c880d0229da$export$23b29992d53f1142;
module.exports["filterEditorTutorialTemplate"] = $f4c21c880d0229da$export$16f4535f1b52f11d;
module.exports["filterTemplatesByAllowList"] = $f4c21c880d0229da$export$9b34fbf9a069b426;
module.exports["getTemplateIdAttributesForAnalytics"] = $f4c21c880d0229da$export$d444d78112a48f41;
module.exports["updateFavouriteTemplates"] = $f4c21c880d0229da$export$9fd27f38e4a8e848;

});

parcelRegister("iacta", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");

const $1c68435f253b2047$export$b1a62972d9cddd78 = 'template.category.featured';
const $1c68435f253b2047$export$5aacf8f53708daf0 = 'template.category.my-templates';
const $1c68435f253b2047$export$c2a29eb4a43ff314 = 'template.category.starred';
const $1c68435f253b2047$export$d01d2d40a80eb4a1 = (0, $dOBRD.default)((templates, categories, mandatoryCategoryIdToShow = '')=>{
    const categoryIdToCountMap = {};
    for (const template of templates)// eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
    for (const categoryId of template.categoryIds){
        if (!categoryId) continue;
        if (!categoryIdToCountMap[categoryId]) categoryIdToCountMap[categoryId] = 0;
        categoryIdToCountMap[categoryId]++;
    }
    const countedCategories = [];
    for (const category of categories){
        if (!category?.id || !category?.name) continue;
        const count = categoryIdToCountMap[category.id];
        const shouldForceShowCategory = category.id === mandatoryCategoryIdToShow;
        if (count || shouldForceShowCategory) countedCategories.push({
            id: category.id,
            name: category.name,
            count: count
        });
    }
    return countedCategories;
});
const $1c68435f253b2047$export$b36f54982a81becd = (categoryId, categories)=>{
    return Object.values(categories).some((existingCategory)=>existingCategory.id === categoryId);
};
module.exports["FEATURED_CATEGORY_ID"] = $1c68435f253b2047$export$b1a62972d9cddd78;
module.exports["MY_TEMPLATES_CATEGORY_ID"] = $1c68435f253b2047$export$5aacf8f53708daf0;
module.exports["STARRED_CATEGORY_ID"] = $1c68435f253b2047$export$c2a29eb4a43ff314;
module.exports["getCountedCategories"] = $1c68435f253b2047$export$d01d2d40a80eb4a1;
module.exports["isCategoryIdInCategories"] = $1c68435f253b2047$export$b36f54982a81becd;

});

parcelRegister("ae5hk", function(module, exports) {
var $5ff79979c9f78c44$export$edd0ae81c67ebc59 = /*#__PURE__*/ function(SortOrders) {
    SortOrders["RELEVANCY_SORT"] = "web.item.sorting.scheme.relevancy";
    SortOrders["ALPHABETICAL_SORT"] = "web.item.sorting.scheme.alphabetical";
    return SortOrders;
}({});
module.exports["SortOrders"] = $5ff79979c9f78c44$export$edd0ae81c67ebc59;

});

parcelRegister("4eJH6", function(module, exports) {
var $7dcc17f1ea6ba5ae$export$b573856c46cc9357 = /*#__PURE__*/ function(CalendarView) {
    CalendarView["dayGridMonth"] = "dayGridMonth";
    CalendarView["timeGridWeek"] = "timeGridWeek";
    CalendarView["listMonth"] = "listMonth";
    CalendarView["list"] = "list";
    CalendarView["timeline"] = "timeline";
    return CalendarView;
}({});
var $7dcc17f1ea6ba5ae$export$2f3a5af09227bbc8 = /*#__PURE__*/ function(CalendarViewPreference) {
    CalendarViewPreference["month"] = "month";
    CalendarViewPreference["agendaWeek"] = "agendaWeek";
    CalendarViewPreference["basicDay"] = "basicDay";
    CalendarViewPreference["timeline"] = "timeline";
    return CalendarViewPreference;
}({});
module.exports["CalendarView"] = $7dcc17f1ea6ba5ae$export$b573856c46cc9357;
module.exports["CalendarViewPreference"] = $7dcc17f1ea6ba5ae$export$2f3a5af09227bbc8;

});

parcelRegister("ltKTq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

var $c9e0854a72739c18$export$feb9e2d8bc9b9b85 = /*#__PURE__*/ function(CALENDAR_CONTEXT) {
    CALENDAR_CONTEXT["SPACE_CALENDARS"] = "spaceCalendars";
    CALENDAR_CONTEXT["MY_CALENDARS"] = "myCalendars";
    CALENDAR_CONTEXT["SPACE_SUBCALENDAR"] = "spaceSubCalendar";
    CALENDAR_CONTEXT["EMBEDDED_SUBCALENDAR"] = "embeddedSubCalendar";
    CALENDAR_CONTEXT["MULTIPLE_CALENDARS"] = "multipleCalendars";
    CALENDAR_CONTEXT["EMBEDDED_MULTIPLE_CALENDARS"] = "embeddedMultipleCalendars";
    CALENDAR_CONTEXT["MACRO"] = "macro";
    return CALENDAR_CONTEXT;
}({});
const $c9e0854a72739c18$var$TCContext = /*#__PURE__*/ (0, $cozmU.createContext)({});
const $c9e0854a72739c18$export$5f8036cb54c4d559 = ()=>{
    const context = (0, $cozmU.useContext)($c9e0854a72739c18$var$TCContext);
    if (context === undefined) throw new Error('useTCContextDispatch must be used within TCContextProvider');
    return context;
};
let $c9e0854a72739c18$var$initialState;
const $c9e0854a72739c18$var$getInitialState = ({ calendars: calendars, calendarContext: calendarContext, userTimeZoneId: userTimeZoneId, userTimeFormat: userTimeFormat, isLoadingEvents: isLoadingEvents, firstDay: firstDay })=>{
    return(// @ts-expect-error - TS2454 Typescript 5.9.2 upgrade
    $c9e0854a72739c18$var$initialState || {
        calendars: calendars,
        events: [],
        calendarContext: calendarContext,
        userTimeZoneId: userTimeZoneId,
        userTimeFormat: userTimeFormat,
        viewDate: new Date(),
        dateTimeFormatOptions: {
            hour: 'numeric',
            minute: 'numeric',
            hourCycle: userTimeFormat === 'displayTimeFormat12' ? 'h12' : 'h23',
            timeZone: userTimeZoneId
        },
        calendarErrors: [],
        isLoadingEvents: isLoadingEvents,
        firstDay: firstDay
    });
};
const $c9e0854a72739c18$var$AT = {
    SET_EVENTS: 'SET_EVENTS',
    SET_CALENDAR_EVENTS: 'SET_CALENDAR_EVENTS',
    SET_CALENDARS: 'SET_CALENDARS',
    SET_VIEW_DATE: 'SET_VIEW_DATE',
    SET_CALENDAR_ERRORS: 'SET_CALENDAR_ERRORS',
    SET_IS_LOADING_EVENTS: 'SET_IS_LOADING_EVENTS',
    SET_FIRST_DAY: 'SET_FIRST_DAY'
};
const $c9e0854a72739c18$export$97f0c60a5aa0f317 = ({ calendars: calendars, calendarContext: calendarContext, userTimeZoneId: userTimeZoneId, children: children, userTimeFormat: userTimeFormat, isLoadingEvents: isLoadingEvents = false, firstDay: firstDay = 1 })=>{
    const initialState = $c9e0854a72739c18$var$getInitialState({
        calendars: calendars,
        calendarContext: calendarContext,
        userTimeZoneId: userTimeZoneId,
        userTimeFormat: userTimeFormat,
        isLoadingEvents: isLoadingEvents,
        firstDay: firstDay
    });
    const reducer = (0, $cozmU.useCallback)((state, action)=>{
        switch(action.type){
            case $c9e0854a72739c18$var$AT.SET_EVENTS:
                return {
                    ...state,
                    events: action.events
                };
            case $c9e0854a72739c18$var$AT.SET_CALENDAR_EVENTS:
                {
                    const calendarIds = action.calendarIds;
                    const newEvents = action.events;
                    const oldEvents = state.events.filter((event)=>!calendarIds.includes(event.subCalendarId));
                    const updatedEvents = oldEvents.concat(newEvents);
                    return {
                        ...state,
                        events: updatedEvents
                    };
                }
            case $c9e0854a72739c18$var$AT.SET_CALENDARS:
                return {
                    ...state,
                    calendars: action.calendars
                };
            case $c9e0854a72739c18$var$AT.SET_VIEW_DATE:
                return {
                    ...state,
                    viewDate: action.viewDate
                };
            case $c9e0854a72739c18$var$AT.SET_CALENDAR_ERRORS:
                if (state.calendarErrors.length === 0 && action.calendarErrors.length === 0) return state;
                return {
                    ...state,
                    calendarErrors: action.calendarErrors
                };
            case $c9e0854a72739c18$var$AT.SET_IS_LOADING_EVENTS:
                return {
                    ...state,
                    isLoadingEvents: action.isLoadingEvents
                };
            case $c9e0854a72739c18$var$AT.SET_FIRST_DAY:
                return {
                    ...state,
                    firstDay: action.firstDay
                };
            default:
                return initialState;
        }
    }, [
        initialState
    ]);
    const [state, dispatch] = (0, $cozmU.useReducer)(reducer, initialState);
    const actions = (0, $cozmU.useMemo)(()=>({
            setEvents: (events)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_EVENTS,
                    events: events
                });
            },
            setCalendarEvents: (calendarIds, events)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_CALENDAR_EVENTS,
                    calendarIds: calendarIds,
                    events: events
                });
            },
            setCalendars: (calendars)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_CALENDARS,
                    calendars: calendars
                });
            },
            setViewDate: (viewDate)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_VIEW_DATE,
                    viewDate: viewDate
                });
            },
            setCalendarErrors: (calendarErrors)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_CALENDAR_ERRORS,
                    calendarErrors: calendarErrors
                });
            },
            setIsLoadingEvents: (isLoadingEvents)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_IS_LOADING_EVENTS,
                    isLoadingEvents: isLoadingEvents
                });
            },
            setFirstDay: (firstDay)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_FIRST_DAY,
                    firstDay: firstDay
                });
            }
        }), []);
    const tcContextValue = (0, $cozmU.useMemo)(()=>({
            state: state,
            actions: actions
        }), [
        state,
        actions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9e0854a72739c18$var$TCContext.Provider, {
        value: tcContextValue
    }, children);
};
module.exports["CALENDAR_CONTEXT"] = $c9e0854a72739c18$export$feb9e2d8bc9b9b85;
module.exports["useTCContextDispatch"] = $c9e0854a72739c18$export$5f8036cb54c4d559;
module.exports["TCContextProvider"] = $c9e0854a72739c18$export$97f0c60a5aa0f317;

});

parcelRegister("ipqo7", function(module, exports) {

var $8VCvx = parcelRequire("8VCvx");

const $989e58fe30d54eff$var$backgroundColorMessages = (0, $8VCvx.backgroundPaletteTooltipMessages).light;
const $989e58fe30d54eff$var$createTabColorAppearance = ({ backgroundColor: backgroundColor, backgroundColorHovered: backgroundColorHovered, borderColor: borderColor, textColor: textColor, swatchBackgroundColor: swatchBackgroundColor = backgroundColor, labelMessage: labelMessage, activeBackgroundColor: activeBackgroundColor, activeBorderColor: activeBorderColor = borderColor, activeTextColor: activeTextColor })=>({
        swatch: {
            backgroundColor: swatchBackgroundColor,
            labelMessage: labelMessage
        },
        tabPill: {
            inactive: {
                backgroundColor: backgroundColor,
                backgroundColorHovered: backgroundColorHovered,
                borderColor: borderColor,
                textColor: textColor
            },
            active: {
                backgroundColor: activeBackgroundColor,
                borderColor: activeBorderColor,
                textColor: activeTextColor
            }
        }
    });
const $989e58fe30d54eff$export$15f93407aad64edb = {
    'blue-subtlest': {
        panelColor: '#DEEBFF',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#DEEBFF'],
                backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
                backgroundColorHovered: "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
                borderColor: "var(--ds-border-accent-blue, #357DE8)",
                textColor: "var(--ds-text-accent-blue, #1558BC)",
                activeBackgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
                activeTextColor: "var(--ds-text-accent-blue-bolder, #123263)"
            })
        }
    },
    'blue-subtler': {
        panelColor: '#B3D4FF',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#B3D4FF'],
                backgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
                backgroundColorHovered: "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
                borderColor: "var(--ds-border-accent-blue, #357DE8)",
                textColor: "var(--ds-text-accent-blue, #1558BC)",
                activeBackgroundColor: "var(--ds-background-accent-blue-subtle, #669DF1)",
                activeTextColor: "var(--ds-text-accent-blue-bolder, #123263)"
            })
        }
    },
    'blue-subtle': {
        panelColor: '#ADCBFB',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#ADCBFB'],
                backgroundColor: "var(--ds-background-accent-blue-subtle, #669DF1)",
                backgroundColorHovered: "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
                borderColor: "var(--ds-border-accent-blue, #357DE8)",
                textColor: "var(--ds-text-accent-blue-bolder, #123263)",
                activeBackgroundColor: "var(--ds-background-accent-blue-bolder, #1868DB)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#ADCBFB'],
                backgroundColor: "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
                backgroundColorHovered: "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
                borderColor: "var(--ds-border-accent-blue, #357DE8)",
                textColor: "var(--ds-text-accent-blue-bolder, #123263)",
                activeBackgroundColor: "var(--ds-background-accent-blue-bolder, #1868DB)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    },
    'teal-subtlest': {
        panelColor: '#E6FCFF',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#E6FCFF'],
                backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
                backgroundColorHovered: "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
                borderColor: "var(--ds-border-accent-teal, #2898BD)",
                textColor: "var(--ds-text-accent-teal, #206A83)",
                activeBackgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
                activeTextColor: "var(--ds-text-accent-teal-bolder, #164555)"
            })
        }
    },
    'teal-subtler': {
        panelColor: '#B3F5FF',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#B3F5FF'],
                backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
                backgroundColorHovered: "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
                borderColor: "var(--ds-border-accent-teal, #2898BD)",
                textColor: "var(--ds-text-accent-teal, #206A83)",
                activeBackgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
                activeTextColor: "var(--ds-text-accent-teal-bolder, #164555)"
            })
        }
    },
    'teal-subtle': {
        panelColor: '#B1E4F7',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#B1E4F7'],
                backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
                backgroundColorHovered: "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
                borderColor: "var(--ds-border-accent-teal, #2898BD)",
                textColor: "var(--ds-text-accent-teal-bolder, #164555)",
                activeBackgroundColor: "var(--ds-background-accent-teal-bolder, #227D9B)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#B1E4F7'],
                backgroundColor: "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
                backgroundColorHovered: "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
                borderColor: "var(--ds-border-accent-teal, #2898BD)",
                textColor: "var(--ds-text-accent-teal-bolder, #164555)",
                activeBackgroundColor: "var(--ds-background-accent-teal-bolder, #227D9B)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    },
    'green-subtlest': {
        panelColor: '#E3FCEF',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#E3FCEF'],
                backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
                backgroundColorHovered: "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
                borderColor: "var(--ds-border-accent-green, #22A06B)",
                textColor: "var(--ds-text-accent-green, #216E4E)",
                activeBackgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
                activeTextColor: "var(--ds-text-accent-green-bolder, #164B35)"
            })
        }
    },
    'green-subtler': {
        panelColor: '#ABF5D1',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#ABF5D1'],
                backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
                backgroundColorHovered: "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
                borderColor: "var(--ds-border-accent-green, #22A06B)",
                textColor: "var(--ds-text-accent-green, #216E4E)",
                activeBackgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
                activeTextColor: "var(--ds-text-accent-green-bolder, #164B35)"
            })
        }
    },
    'green-subtle': {
        panelColor: '#97EDC9',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#97EDC9'],
                backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
                backgroundColorHovered: "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
                borderColor: "var(--ds-border-accent-green, #22A06B)",
                textColor: "var(--ds-text-accent-green-bolder, #164B35)",
                activeBackgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#97EDC9'],
                backgroundColor: "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
                backgroundColorHovered: "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
                borderColor: "var(--ds-border-accent-green, #22A06B)",
                textColor: "var(--ds-text-accent-green-bolder, #164B35)",
                activeBackgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    },
    'lime-subtlest': {
        panelColor: '#EFFFD6',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#EFFFD6'],
                backgroundColor: "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
                backgroundColorHovered: "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
                borderColor: "var(--ds-border-accent-lime, #6A9A23)",
                textColor: "var(--ds-text-accent-lime, #4C6B1F)",
                activeBackgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
                activeTextColor: "var(--ds-text-accent-lime-bolder, #37471F)"
            })
        }
    },
    'lime-subtler': {
        panelColor: '#D3F1A7',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#D3F1A7'],
                backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
                backgroundColorHovered: "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
                borderColor: "var(--ds-border-accent-lime, #6A9A23)",
                textColor: "var(--ds-text-accent-lime, #4C6B1F)",
                activeBackgroundColor: "var(--ds-background-accent-lime-subtle, #94C748)",
                activeTextColor: "var(--ds-text-accent-lime-bolder, #37471F)"
            })
        }
    },
    'lime-subtle': {
        panelColor: '#BDE97C',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#BDE97C'],
                backgroundColor: "var(--ds-background-accent-lime-subtle, #94C748)",
                backgroundColorHovered: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
                borderColor: "var(--ds-border-accent-lime, #6A9A23)",
                textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
                activeBackgroundColor: "var(--ds-background-accent-lime-bolder, #5B7F24)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#BDE97C'],
                backgroundColor: "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
                backgroundColorHovered: "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
                borderColor: "var(--ds-border-accent-lime, #6A9A23)",
                textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
                activeBackgroundColor: "var(--ds-background-accent-lime-bolder, #5B7F24)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    },
    'yellow-subtlest': {
        panelColor: '#FFFAE6',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FFFAE6'],
                backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
                backgroundColorHovered: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
                borderColor: "var(--ds-border-accent-yellow, #B38600)",
                textColor: "var(--ds-text-accent-yellow, #7F5F01)",
                activeBackgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
                activeTextColor: "var(--ds-text-accent-yellow-bolder, #533F04)"
            })
        }
    },
    'yellow-subtler': {
        panelColor: '#FFF0B3',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FFF0B3'],
                backgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
                backgroundColorHovered: "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
                borderColor: "var(--ds-border-accent-yellow, #B38600)",
                textColor: "var(--ds-text-accent-yellow, #7F5F01)",
                activeBackgroundColor: "var(--ds-background-accent-yellow-subtle, #EED12B)",
                activeTextColor: "var(--ds-text-accent-yellow-bolder, #533F04)"
            })
        }
    },
    'yellow-subtle': {
        panelColor: '#EFDD4E',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#EFDD4E'],
                backgroundColor: "var(--ds-background-accent-yellow-subtle, #EED12B)",
                backgroundColorHovered: "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
                borderColor: "var(--ds-border-accent-yellow, #B38600)",
                textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
                activeBackgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#EFDD4E'],
                backgroundColor: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
                backgroundColorHovered: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
                borderColor: "var(--ds-border-accent-yellow, #B38600)",
                textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
                activeBackgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    },
    'orange-subtlest': {
        panelColor: '#FFF5DB',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FFF5DB'],
                backgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
                backgroundColorHovered: "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
                borderColor: "var(--ds-border-accent-orange, #E06C00)",
                textColor: "var(--ds-text-accent-orange, #9E4C00)",
                activeBackgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
                activeTextColor: "var(--ds-text-accent-orange-bolder, #693200)"
            })
        }
    },
    'orange-subtler': {
        panelColor: '#FCE4A6',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FCE4A6'],
                backgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
                backgroundColorHovered: "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
                borderColor: "var(--ds-border-accent-orange, #E06C00)",
                textColor: "var(--ds-text-accent-orange, #9E4C00)",
                activeBackgroundColor: "var(--ds-background-accent-orange-subtle, #FCA700)",
                activeTextColor: "var(--ds-text-accent-orange-bolder, #693200)"
            })
        }
    },
    'orange-subtle': {
        panelColor: '#FBD779',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FBD779'],
                backgroundColor: "var(--ds-background-accent-orange-subtle, #FCA700)",
                backgroundColorHovered: "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
                borderColor: "var(--ds-border-accent-orange, #E06C00)",
                textColor: "var(--ds-text-accent-orange-bolder, #693200)",
                activeBackgroundColor: "var(--ds-background-accent-orange-bolder, #BD5B00)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FBD779'],
                backgroundColor: "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
                backgroundColorHovered: "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
                borderColor: "var(--ds-border-accent-orange, #E06C00)",
                textColor: "var(--ds-text-accent-orange-bolder, #693200)",
                activeBackgroundColor: "var(--ds-background-accent-orange-bolder, #BD5B00)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    },
    'red-subtlest': {
        panelColor: '#FFEBE6',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FFEBE6'],
                backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
                backgroundColorHovered: "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
                borderColor: "var(--ds-border-accent-red, #E2483D)",
                textColor: "var(--ds-text-accent-red, #AE2E24)",
                activeBackgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                activeTextColor: "var(--ds-text-accent-red-bolder, #5D1F1A)"
            })
        }
    },
    'red-subtler': {
        panelColor: '#FFBDAD',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FFBDAD'],
                backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                backgroundColorHovered: "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
                borderColor: "var(--ds-border-accent-red, #E2483D)",
                textColor: "var(--ds-text-accent-red, #AE2E24)",
                activeBackgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
                activeTextColor: "var(--ds-text-accent-red-bolder, #5D1F1A)"
            })
        }
    },
    'red-subtle': {
        panelColor: '#FFB8B2',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FFB8B2'],
                backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
                backgroundColorHovered: "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
                borderColor: "var(--ds-border-accent-red, #E2483D)",
                textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
                activeBackgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FFB8B2'],
                backgroundColor: "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
                backgroundColorHovered: "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
                borderColor: "var(--ds-border-accent-red, #E2483D)",
                textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
                activeBackgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    },
    'magenta-subtlest': {
        panelColor: '#FFECF8',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FFECF8'],
                backgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
                backgroundColorHovered: "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
                borderColor: "var(--ds-border-accent-magenta, #CD519D)",
                textColor: "var(--ds-text-accent-magenta, #943D73)",
                activeBackgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
                activeTextColor: "var(--ds-text-accent-magenta-bolder, #50253F)"
            })
        }
    },
    'magenta-subtler': {
        panelColor: '#FDD0EC',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FDD0EC'],
                backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
                backgroundColorHovered: "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
                borderColor: "var(--ds-border-accent-magenta, #CD519D)",
                textColor: "var(--ds-text-accent-magenta, #943D73)",
                activeBackgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)",
                activeTextColor: "var(--ds-text-accent-magenta-bolder, #50253F)"
            })
        }
    },
    'magenta-subtle': {
        panelColor: '#FCB6E1',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FCB6E1'],
                backgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)",
                backgroundColorHovered: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
                borderColor: "var(--ds-border-accent-magenta, #CD519D)",
                textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
                activeBackgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FCB6E1'],
                backgroundColor: "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
                backgroundColorHovered: "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
                borderColor: "var(--ds-border-accent-magenta, #CD519D)",
                textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
                activeBackgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    },
    'purple-subtlest': {
        panelColor: '#EAE6FF',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#EAE6FF'],
                backgroundColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
                backgroundColorHovered: "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
                borderColor: "var(--ds-border-accent-purple, #AF59E1)",
                textColor: "var(--ds-text-accent-purple, #803FA5)",
                activeBackgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)",
                activeTextColor: "var(--ds-text-accent-purple-bolder, #48245D)"
            })
        }
    },
    'purple-subtler': {
        panelColor: '#C0B6F2',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#C0B6F2'],
                backgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)",
                backgroundColorHovered: "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
                borderColor: "var(--ds-border-accent-purple, #AF59E1)",
                textColor: "var(--ds-text-accent-purple, #803FA5)",
                activeBackgroundColor: "var(--ds-background-accent-purple-subtle, #C97CF4)",
                activeTextColor: "var(--ds-text-accent-purple-bolder, #48245D)"
            })
        }
    },
    'purple-subtle': {
        panelColor: '#E3BDFA',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#E3BDFA'],
                backgroundColor: "var(--ds-background-accent-purple-subtle, #C97CF4)",
                backgroundColorHovered: "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
                borderColor: "var(--ds-border-accent-purple, #AF59E1)",
                textColor: "var(--ds-text-accent-purple-bolder, #48245D)",
                activeBackgroundColor: "var(--ds-background-accent-purple-bolder, #964AC0)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#E3BDFA'],
                backgroundColor: "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
                backgroundColorHovered: "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
                borderColor: "var(--ds-border-accent-purple, #AF59E1)",
                textColor: "var(--ds-text-accent-purple-bolder, #48245D)",
                activeBackgroundColor: "var(--ds-background-accent-purple-bolder, #964AC0)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    },
    'gray-subtler': {
        panelColor: '#F4F5F7',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#F4F5F7'],
                backgroundColor: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
                backgroundColorHovered: "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
                borderColor: "var(--ds-border-accent-gray, #7D818A)",
                textColor: "var(--ds-text-accent-gray, #505258)",
                activeBackgroundColor: "var(--ds-background-accent-gray-subtle, #8C8F97)",
                activeTextColor: "var(--ds-text-accent-gray-bolder, #1E1F21)"
            })
        }
    },
    'gray-subtle': {
        panelColor: '#B7B9BE',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#B7B9BE'],
                backgroundColor: "var(--ds-background-accent-gray-subtle, #8C8F97)",
                backgroundColorHovered: "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
                borderColor: "var(--ds-border-accent-gray, #7D818A)",
                textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
                activeBackgroundColor: "var(--ds-background-accent-gray-bolder, #6B6E76)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#B7B9BE'],
                backgroundColor: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
                backgroundColorHovered: "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
                borderColor: "var(--ds-border-accent-gray, #7D818A)",
                textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
                activeBackgroundColor: "var(--ds-background-accent-gray-bolder, #6B6E76)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    }
};
const $989e58fe30d54eff$var$tabColorDefinitionsByKey = $989e58fe30d54eff$export$15f93407aad64edb;
const $989e58fe30d54eff$var$panelColorToTabColor = new Map(Object.entries($989e58fe30d54eff$export$15f93407aad64edb).map(([colorKey, definition])=>[
        definition.panelColor.toLowerCase(),
        colorKey
    ]));
const $989e58fe30d54eff$export$6cb7a3ac5d38a331 = (color, appearanceMode = 'legacy')=>{
    const appearances = $989e58fe30d54eff$export$15f93407aad64edb[color].appearances;
    return appearanceMode === 'legacy' ? appearances.legacy ?? appearances.standard : appearances.standard;
};
const $989e58fe30d54eff$export$f020e6c7ee6351cc = (color)=>{
    if (typeof color !== 'string') return undefined;
    return $989e58fe30d54eff$var$tabColorDefinitionsByKey[color]?.panelColor;
};
const $989e58fe30d54eff$export$dba9f85b52f8dfa0 = (panelColor)=>{
    if (typeof panelColor !== 'string') return undefined;
    return $989e58fe30d54eff$var$panelColorToTabColor.get(panelColor.toLowerCase());
};
module.exports["getTabColorAppearance"] = $989e58fe30d54eff$export$6cb7a3ac5d38a331;
module.exports["getPanelColorForTabColor"] = $989e58fe30d54eff$export$f020e6c7ee6351cc;
module.exports["getTabColorForPanelColor"] = $989e58fe30d54eff$export$dba9f85b52f8dfa0;

});

parcelRegister("j4RIK", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $cdc6aab464c1fae2$export$6122306715c85017 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "qKe_8",
    name: "PageTreeMacroHandler",
    loader: async ()=>(await (parcelRequire("7L3V9"))).PageTreeMacroRenderer
});
module.exports["PageTreeMacroHandler"] = $cdc6aab464c1fae2$export$6122306715c85017;

});

parcelRegister("7L3V9", function(module, exports) {

let $5a5ff6c3f63c5995$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5a5ff6c3f63c5995$var$load("Wowvf"),
    $5a5ff6c3f63c5995$var$load("5is1n"),
    $5a5ff6c3f63c5995$var$load("3PgFB")
]).then(()=>parcelRequire('hD0Hb'));

});

parcelRegister("dF6Hu", function(module, exports) {
const $c19c056402cab920$export$aacbed104b7824d = {
    version: 1,
    type: 'doc',
    content: []
};
const $c19c056402cab920$export$92be905df4143632 = (adf)=>({
        version: 1,
        type: 'doc',
        content: adf
    });
const $c19c056402cab920$export$d287f5fb15383464 = (adfString)=>{
    try {
        const parsed = JSON.parse(adfString ?? '');
        return Array.isArray(parsed.content) ? $c19c056402cab920$export$92be905df4143632(parsed.content) : $c19c056402cab920$export$aacbed104b7824d;
    } catch  {
        return $c19c056402cab920$export$aacbed104b7824d;
    }
};
const $c19c056402cab920$export$6952557fbb0fdd5b = (adf)=>({
        content: {
            nodes: [
                {
                    body: {
                        dynamic: {
                            representation: 'atlas_doc_format',
                            value: JSON.stringify({
                                content: adf,
                                type: 'doc'
                            })
                        }
                    }
                }
            ]
        }
    });
module.exports["createNestedAdfDocument"] = $c19c056402cab920$export$92be905df4143632;
module.exports["parseNestedAdfDocument"] = $c19c056402cab920$export$d287f5fb15383464;
module.exports["createNestedRendererData"] = $c19c056402cab920$export$6952557fbb0fdd5b;

});

parcelRegister("ZJvdP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $543e3a9ad9cfc398$export$3ad73c971369d052 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "sYDyD",
    name: "PageIncludeMacroHandler",
    loader: async ()=>(await (parcelRequire("gIDv4"))).PageIncludeMacroRenderer
});
module.exports["PageIncludeMacroHandler"] = $543e3a9ad9cfc398$export$3ad73c971369d052;

});

parcelRegister("gIDv4", function(module, exports) {

let $c2bf65516d0474fe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c2bf65516d0474fe$var$load("5h4De").then(()=>parcelRequire('doY9Y'));

});

parcelRegister("8Ksv7", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $11414ac1857ca883$export$cfa4ed6e2f4ad26 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "lJE6O",
    name: "BlogPostsMacroHandler",
    loader: async ()=>(await (parcelRequire("hXZWW"))).BlogPostsMacroRenderer
});
module.exports["BlogPostsMacroHandler"] = $11414ac1857ca883$export$cfa4ed6e2f4ad26;

});

parcelRegister("hXZWW", function(module, exports) {

let $d1480049bff2c5a9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d1480049bff2c5a9$var$load("30b92"),
    $d1480049bff2c5a9$var$load("zUKwV"),
    $d1480049bff2c5a9$var$load("fUeur"),
    $d1480049bff2c5a9$var$load("1GCFv"),
    $d1480049bff2c5a9$var$load("bV5bW"),
    $d1480049bff2c5a9$var$load("28h7Y")
]).then(()=>parcelRequire('5iRsI'));

});

parcelRegister("jJli4", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $f9KPY = parcelRequire("f9KPY");


const $7549d063fe593b21$export$2800e3d415e59020 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "8zrD8",
    name: "ExcerptIncludeLoader",
    loader: async ()=>(await (parcelRequire("2h5Yc"))).ExcerptInclude,
    // Component shadow is a subset of ExcerptIncludeProps so this would generate a TS error here as Loadable
    // expects the prop types to match.
    // @ts-expect-error
    loading: (0, $f9KPY.ExcerptIncludeComponentShadow)
});
module.exports["ExcerptIncludeLoader"] = $7549d063fe593b21$export$2800e3d415e59020;

});

parcelRegister("f9KPY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $lOkIA = parcelRequire("lOkIA");


var $dhEYL = parcelRequire("dhEYL");

class $747c563e4499b240$export$8f88facf076a2d46 extends (0, $cozmU.PureComponent) {
    render() {
        const { shouldPanelBeDisplayed: shouldPanelBeDisplayed, targetContentTitle: targetContentTitle } = this.props;
        return shouldPanelBeDisplayed ? // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "data-testid": "excerpt-include-panel",
            style: (0, $dhEYL.panel)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            style: (0, $dhEYL.panelHeader)
        }, targetContentTitle || // eslint-disable-next-line check-i18n-id-prefix/i18n-id-prefix-with-package-name-FormattedMessage
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "editor.excerpt.include.panel.title.loading"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            style: (0, $dhEYL.panelBody)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lOkIA.CenteredSpinner), {
            size: "medium",
            style: {
                minHeight: 100
            }
        }))) : // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lOkIA.CenteredSpinner), {
            size: "medium",
            style: {
                minHeight: 100
            }
        });
    }
}
module.exports["ExcerptIncludeComponentShadow"] = $747c563e4499b240$export$8f88facf076a2d46;

});

parcelRegister("lOkIA", function(module, exports) {
/* CenteredSpinner.js generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");

function $fe0e56b204487583$var$_defineProperty(e, r, t) {
    return (r = $fe0e56b204487583$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fe0e56b204487583$var$_toPropertyKey(t) {
    var i = $fe0e56b204487583$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fe0e56b204487583$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $fe0e56b204487583$export$57732b6846a8df7c = {
    small: 12,
    medium: 26,
    large: 36
};
const $fe0e56b204487583$var$wrapperStyles = null;
const $fe0e56b204487583$var$spinnerStyles = null;
class $fe0e56b204487583$export$a2638930496865a0 extends (0, $cozmU.PureComponent) {
    render() {
        const { style: style, size: size } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: style,
            "data-test-id": "wrapper-spinner",
            className: (0, $hekY6.default)([
                "_39xV02N91d _0jFU0VN91d _1mT5xdRAKS"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-test-id": "spinner",
            style: {
                marginLeft: `${-$fe0e56b204487583$export$57732b6846a8df7c[size] / 2}px`,
                marginTop: `${-$fe0e56b204487583$export$57732b6846a8df7c[size] / 2}px`
            },
            className: (0, $hekY6.default)([
                "_1mT5xdWVPG _3OE6xY715P _2IhTon715P _42Yu6BgtVO"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: $fe0e56b204487583$export$57732b6846a8df7c[size]
        })));
    }
}
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "displayName", 'CenteredSpinner');
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "propTypes", {
    /**
   * custom spinner style
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    /**
   * Size of spinner
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).oneOf([
        'small',
        'medium',
        'large'
    ])
});
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "defaultProps", {
    size: 'small'
});
module.exports["CenteredSpinner"] = $fe0e56b204487583$export$a2638930496865a0;

});

parcelRegister("dhEYL", function(module, exports) {
const $9b021e0aba5455d5$export$21f42ab9b6679f44 = {
    display: 'block',
    // DEBUGGING
    borderWidth: "var(--ds-border-width, 1px)",
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderRadius: "var(--ds-radius-small, 3px)",
    borderStyle: 'solid',
    borderColor: "var(--ds-border, #0B120E24)",
    borderImage: 'initial'
};
const $9b021e0aba5455d5$export$92937d9937dc7ce9 = {
    display: 'block',
    // DEBUGGING
    backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    minWidth: '128px',
    padding: "var(--ds-space-100, 8px)",
    font: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $9b021e0aba5455d5$export$d763905bda51ef54 = {
    display: 'block',
    // DEBUGGING
    minWidth: '128px',
    borderWidth: `${"var(--ds-border-width, 1px)"} 0px 0px 0px`,
    borderStyle: 'solid',
    borderColor: "var(--ds-border, #0B120E24)",
    padding: "var(--ds-space-100, 8px)"
};
const $9b021e0aba5455d5$export$99e3f651fb62ec86 = {
    color: "var(--ds-text-subtlest, #6B6E76)",
    paddingLeft: "var(--ds-space-050, 4px)"
};
module.exports["panel"] = $9b021e0aba5455d5$export$21f42ab9b6679f44;
module.exports["panelHeader"] = $9b021e0aba5455d5$export$92937d9937dc7ce9;
module.exports["panelBody"] = $9b021e0aba5455d5$export$d763905bda51ef54;
module.exports["panelHeaderExcerpt"] = $9b021e0aba5455d5$export$99e3f651fb62ec86;

});

parcelRegister("2h5Yc", function(module, exports) {

let $1a81ccd1c64f7f5e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1a81ccd1c64f7f5e$var$load("fWCBZ"),
    $1a81ccd1c64f7f5e$var$load("1JeTB"),
    $1a81ccd1c64f7f5e$var$load("86OhX"),
    $1a81ccd1c64f7f5e$var$load("6wr18"),
    $1a81ccd1c64f7f5e$var$load("djtIp"),
    $1a81ccd1c64f7f5e$var$load("ffEVr"),
    $1a81ccd1c64f7f5e$var$load("Wowvf"),
    $1a81ccd1c64f7f5e$var$load("excC5"),
    $1a81ccd1c64f7f5e$var$load("9tNcH")
]).then(()=>parcelRequire('c6u22'));

});

parcelRegister("5LTS4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $6VdZc = parcelRequire("6VdZc");


var $4JC0x = parcelRequire("4JC0x");


var $1xpoY = parcelRequire("1xpoY");


var $bF1aY = parcelRequire("bF1aY");


var $h8C1D = parcelRequire("h8C1D");


var $kksmx = parcelRequire("kksmx");

const $ebb4d303074e1a0c$var$NOT_SSRED = 'none';
const $ebb4d303074e1a0c$var$NOT_SSRED_BLOCKED = 'ssr-blocked';
// Limit performance tracking for only top 10 extensions on initial load.
// The value is semi-arbitrary, as this is +2 to the number of extensions
// we attempt to SSR on initial load - this will give us an idea how the
// non-SSRed extensions are performing.
// This will lead to ~39% more tracking events send overall, comparing to
// 50/50 rollout we had before, but will prevent from sending huge amount
// of events for individual pages with a lot of extensions.
const $ebb4d303074e1a0c$var$TRACKING_LIMIT = 10;
const $ebb4d303074e1a0c$var$isBlocklisted = (ssrPreloadFailure)=>ssrPreloadFailure?.startsWith('blocklist') ? $ebb4d303074e1a0c$var$NOT_SSRED_BLOCKED : $ebb4d303074e1a0c$var$NOT_SSRED;
// This check is being made only upon initial render, and therefore is sufficient for
// checking whether element (in our case the marker) appears above the fold when rendered.
const $ebb4d303074e1a0c$var$isMarkerAboveTheFold = (el)=>{
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight));
};
const $ebb4d303074e1a0c$var$getPerformanceEntry = (entryName)=>{
    if (performance && typeof performance.getEntriesByName === 'function') return performance.getEntriesByName(entryName);
    return [];
};
const $ebb4d303074e1a0c$export$64e91845ba744516 = ({ node: node, contentId: contentId, extensionKey: extensionKey })=>{
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { localId: localId } = node;
    const macroId = node.parameters?.macroMetadata?.macroId?.value;
    const extensionBlocklist = (0, $1xpoY.default).getString('confluence-extensions-server-render-blocklist', '');
    const markerRef = (0, $cozmU.useRef)(null);
    const { extensionIndex: extensionIndex, isUnsupportedExtension: isUnsupportedExtension } = (0, $h8C1D.useExtensionIndex)(macroId);
    const doNotTrackExtension = extensionIndex === (0, $h8C1D.UNKNOWN_INDEX) || extensionIndex >= $ebb4d303074e1a0c$var$TRACKING_LIMIT;
    (0, $cozmU.useEffect)(()=>{
        // NOTE: as of now, this metric is tailored to monitoring the performance of extensions
        // on initial load. We're not planning to use this metric in any way on transitions yet
        // thus we don't want to spam analytics with the data we don't use.
        if (doNotTrackExtension || !(0, $6VdZc.isInitial)()) return;
        // WARN: Complexity alert! The logic of fmp/tti/duration calculation is convoluted
        // here because of several reasons. Due to the timing of creating performance marks
        // that we use here, we may report extension timing *before* TTI measure is evaluated,
        // since TTI measure is waiting for several page segments. Thus on initial load we have
        // to rely on other reference points, that are available before extensions are rendered.
        const pageTTI = (0, $6VdZc.isInitial)() ? $ebb4d303074e1a0c$var$getPerformanceEntry('rendererRendered.end')?.pop()?.startTime : $ebb4d303074e1a0c$var$getPerformanceEntry('browser-metric:tti')?.pop()?.duration;
        const pageFMP = (0, $6VdZc.isInitial)() ? $ebb4d303074e1a0c$var$getPerformanceEntry('CFP-63.ssr-ttr')?.pop()?.startTime : pageTTI;
        const clientRouteStart = $ebb4d303074e1a0c$var$getPerformanceEntry('browser-metric.start')?.pop()?.startTime;
        const ssrPreloadFailure = (0, $4JC0x.getPreloadFailures)(macroId) || '';
        const ssrGeneralFailure = (0, $4JC0x.getGeneralFailures)() || '';
        const isExtensionSSRed = (0, $6VdZc.isInitial)() ? (0, $kksmx.getExtensionSSRMark)(macroId) || $ebb4d303074e1a0c$var$isBlocklisted(ssrPreloadFailure) : $ebb4d303074e1a0c$var$NOT_SSRED;
        // On transition we cannot reliably expect that "browser-metric:tti" measure is there
        // before macro rendering. Thus, use routing start as a base point for extension performance
        // measurement on transition. Note that FMP=TTI on transition.
        const startTime = ((0, $6VdZc.isInitial)() ? pageFMP : clientRouteStart) ?? 0;
        const customData = {
            isExtensionSSRed: isExtensionSSRed,
            extensionIndex: extensionIndex,
            extensionKey: extensionKey,
            contentId: contentId,
            pageFMP: pageFMP ?? 0,
            pageTTI: pageTTI ?? 0,
            isATF: $ebb4d303074e1a0c$var$isMarkerAboveTheFold(markerRef.current),
            ssrPreloadFailure: isUnsupportedExtension ? 'unsupportedContentInternalExtension' : ssrPreloadFailure || ssrGeneralFailure,
            clientRouteStart: clientRouteStart ?? 0,
            hydratable: window?.__HYDRATABLE__ || false,
            hydrationFailed: window?.__HYDRATION_FAILED__ || false
        };
        const metric = (0, $bF1aY.LEGACY_EXTENSION_LOADING_METRIC)(`${extensionKey}.${contentId}.${localId}`);
        metric.start({
            startTime: startTime
        });
        metric.stop({
            customData: customData
        });
    }, [
        doNotTrackExtension,
        extensionBlocklist,
        extensionKey,
        extensionIndex,
        isUnsupportedExtension,
        routeName,
        localId,
        contentId,
        macroId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ref: markerRef
    });
};
module.exports["ExtensionLoadingComplete"] = $ebb4d303074e1a0c$export$64e91845ba744516;

});

parcelRegister("bF1aY", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $63112e910a0def69$export$841f5507db609445 = (0, $lSOAM.createConcurrentCustomMetric)({
    key: (0, $fd6g2.LEGACY_EXTENSION_LOADING_CUSTOM_KEY)
});
module.exports["LEGACY_EXTENSION_LOADING_METRIC"] = $63112e910a0def69$export$841f5507db609445;

});

parcelRegister("h8C1D", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $llqlc = parcelRequire("llqlc");


var $8pcS0 = parcelRequire("8pcS0");

const $028a91b33dee434b$export$7affafe0528b70b1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    indexes: new Map()
});
const $028a91b33dee434b$var$extractExtensions = (adf)=>(0, $llqlc.filter)(adf, (node)=>(0, $8pcS0.supportedExtensions).has(node.type));
const $028a91b33dee434b$export$e4ac003417d6dace = 'UNKNOWN';
const $028a91b33dee434b$export$981cab9712b3b1a3 = ({ document: document, children: children })=>{
    const indexes = (0, $cozmU.useMemo)(()=>{
        const extensions = $028a91b33dee434b$var$extractExtensions(document);
        return new Map(extensions.map((node, idx)=>{
            window['unsupportedExtension'] = window['unsupportedExtension'] || {};
            if (node.attrs?.parameters?.nestedContent?.content && node.attrs.extensionKey === '__confluenceADFMigrationUnsupportedContentInternalExtension__') node.attrs.parameters.nestedContent.content.forEach((each)=>{
                window['unsupportedExtension'][each.attrs?.parameters?.macroMetadata?.macroId?.value] = idx;
            });
            return [
                node.attrs?.parameters?.macroMetadata?.macroId?.value,
                idx
            ];
        }));
    }, [
        document
    ]);
    const value = (0, $cozmU.useMemo)(()=>({
            indexes: indexes
        }), [
        indexes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($028a91b33dee434b$export$7affafe0528b70b1.Provider, {
        value: value
    }, children);
};
const $028a91b33dee434b$export$ea9830505fbaa6ad = (macroId)=>{
    const { indexes: indexes } = (0, $cozmU.useContext)($028a91b33dee434b$export$7affafe0528b70b1);
    let index = indexes.get(macroId);
    const unsupportedExtensions = window['unsupportedExtension'];
    let isUnsupportedExtension = false;
    if (unsupportedExtensions && unsupportedExtensions[macroId]) {
        index = unsupportedExtensions[macroId];
        isUnsupportedExtension = true;
    }
    return {
        extensionIndex: typeof index === 'number' ? index : $028a91b33dee434b$export$e4ac003417d6dace,
        isUnsupportedExtension: isUnsupportedExtension
    };
};
module.exports["UNKNOWN_INDEX"] = $028a91b33dee434b$export$e4ac003417d6dace;
module.exports["ExtrensionIndexProvider"] = $028a91b33dee434b$export$981cab9712b3b1a3;
module.exports["useExtensionIndex"] = $028a91b33dee434b$export$ea9830505fbaa6ad;

});

parcelRegister("7bpSh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $9dee672aff5abe3d$export$c4ffab2abecc9a7c = (0, $cozmU.createContext)(null);
module.exports["ContentModeFragmentContext"] = $9dee672aff5abe3d$export$c4ffab2abecc9a7c;

});

parcelRegister("e1Stz", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $36f7db2a9cac59c0$export$7cf7439e5d7797c5 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ymRP0",
    name: "PagePropertiesReportRenderer",
    loader: async ()=>(await (parcelRequire("04x0i"))).PagePropertiesReportRenderer
});
module.exports["PagePropertiesReportRenderer"] = $36f7db2a9cac59c0$export$7cf7439e5d7797c5;

});

parcelRegister("04x0i", function(module, exports) {

let $00d9f9b79a5cc0d2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $00d9f9b79a5cc0d2$var$load("efUj2"),
    $00d9f9b79a5cc0d2$var$load("4Gdnz"),
    $00d9f9b79a5cc0d2$var$load("4UAag"),
    $00d9f9b79a5cc0d2$var$load("6wr18"),
    $00d9f9b79a5cc0d2$var$load("hhss7"),
    $00d9f9b79a5cc0d2$var$load("ffEVr"),
    $00d9f9b79a5cc0d2$var$load("dnwTC")
]).then(()=>parcelRequire('3Jp28'));

});

parcelRegister("l7BGZ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $076f2e82bb035170$export$b5586d12ffc2e1b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Qw8xt",
    name: "LiveSearchLoader",
    loader: async ()=>(await (parcelRequire("7Bf0A"))).LiveSearch
});

const $076f2e82bb035170$export$e7e4bc50f3fd132e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cgOQy",
    name: "LazyLiveSearchLoader",
    loader: async ()=>(await (parcelRequire("7Bf0A"))).LiveSearch
});
module.exports["LiveSearchLoader"] = $076f2e82bb035170$export$b5586d12ffc2e1b;
module.exports["LazyLiveSearchLoader"] = $076f2e82bb035170$export$e7e4bc50f3fd132e;

});

parcelRegister("7Bf0A", function(module, exports) {

let $5887a1743727607a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5887a1743727607a$var$load("zUKwV"),
    $5887a1743727607a$var$load("fUeur"),
    $5887a1743727607a$var$load("6wr18"),
    $5887a1743727607a$var$load("jYRaq"),
    $5887a1743727607a$var$load("7G12e"),
    $5887a1743727607a$var$load("ffEVr"),
    $5887a1743727607a$var$load("io0qR"),
    $5887a1743727607a$var$load("aC3bY"),
    $5887a1743727607a$var$load("Wowvf"),
    $5887a1743727607a$var$load("4g6rd"),
    $5887a1743727607a$var$load("7EorR"),
    $5887a1743727607a$var$load("hhss7"),
    $5887a1743727607a$var$load("2IX0x")
]).then(()=>parcelRequire('jF1MT'));

});

parcelRegister("dwS6P", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f07e1d0389c2db40$export$4b3001e460e8e078 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "CSP7X",
    name: "TableOfContentsLoader",
    loader: async ()=>(await (parcelRequire("64Zz9"))).TableOfContents
});

const $f07e1d0389c2db40$export$fa76cea84aad7618 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "JVXm_",
    name: "LazyTableOfContentsLoader",
    loader: async ()=>(await (parcelRequire("64Zz9"))).TableOfContents
});
module.exports["TableOfContentsLoader"] = $f07e1d0389c2db40$export$4b3001e460e8e078;
module.exports["LazyTableOfContentsLoader"] = $f07e1d0389c2db40$export$fa76cea84aad7618;

});

parcelRegister("64Zz9", function(module, exports) {

let $46d2df84b42ff8b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $46d2df84b42ff8b7$var$load("bPC3R"),
    $46d2df84b42ff8b7$var$load("bHb1X"),
    $46d2df84b42ff8b7$var$load("6gMrU"),
    $46d2df84b42ff8b7$var$load("fWCBZ"),
    $46d2df84b42ff8b7$var$load("86OhX"),
    $46d2df84b42ff8b7$var$load("6wr18"),
    $46d2df84b42ff8b7$var$load("djtIp"),
    $46d2df84b42ff8b7$var$load("53Y0O"),
    $46d2df84b42ff8b7$var$load("kYlwR"),
    $46d2df84b42ff8b7$var$load("1tqsw"),
    $46d2df84b42ff8b7$var$load("dtNxV"),
    $46d2df84b42ff8b7$var$load("excC5"),
    $46d2df84b42ff8b7$var$load("iTOzX"),
    $46d2df84b42ff8b7$var$load("ipkwd"),
    $46d2df84b42ff8b7$var$load("ffEVr"),
    $46d2df84b42ff8b7$var$load("8Jd6S"),
    $46d2df84b42ff8b7$var$load("fwbNS"),
    $46d2df84b42ff8b7$var$load("6zCMk"),
    $46d2df84b42ff8b7$var$load("zUKwV"),
    $46d2df84b42ff8b7$var$load("fUeur"),
    $46d2df84b42ff8b7$var$load("ckGjo"),
    $46d2df84b42ff8b7$var$load("kGmwI"),
    $46d2df84b42ff8b7$var$load("1JeTB"),
    $46d2df84b42ff8b7$var$load("ayJxT"),
    $46d2df84b42ff8b7$var$load("hhss7"),
    $46d2df84b42ff8b7$var$load("kT6dz"),
    $46d2df84b42ff8b7$var$load("aAWLw"),
    $46d2df84b42ff8b7$var$load("jjWia")
]).then(()=>parcelRequire('c8BWz'));

});

parcelRegister("202oG", function(module, exports) {

var $2lPWP = parcelRequire("2lPWP");

function $2cfd9ea7d82f1add$export$dbad71934afee167(node, headingIds) {
    if (!node?.content?.length) return;
    // We are not use node.textContent here, because we would like to handle cases where
    // headings only contain inline blocks like emoji, status and date.
    const nodeContent = node.content.reduce((acc, currentNode)=>acc.concat($2cfd9ea7d82f1add$var$getText(currentNode) || ''), '').trim().replace(/\s/g, '-');
    if (!nodeContent) return;
    return $2cfd9ea7d82f1add$var$getUniqueHeadingId(nodeContent, headingIds);
}
const $2cfd9ea7d82f1add$var$getText = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : ''}]`;
};
function $2cfd9ea7d82f1add$var$getUniqueHeadingId(baseId, headingIds, counter = 0) {
    if (counter === 0 && !headingIds.has(baseId)) {
        headingIds.add(baseId);
        return baseId;
    } else if (counter !== 0) {
        const headingId = `${baseId}.${counter}`;
        if (!headingIds.has(headingId)) {
            headingIds.add(headingId);
            return headingId;
        }
    }
    return $2cfd9ea7d82f1add$var$getUniqueHeadingId(baseId, headingIds, counter + 1);
}
const $2cfd9ea7d82f1add$var$HEADINGS = new Set([
    'H1',
    'H2',
    'H3',
    'H4',
    'H5',
    'H6'
]);
function* $2cfd9ea7d82f1add$var$getHeadingIds() {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const editorElement = document.getElementById('ak-editor-textarea');
    const children = editorElement?.getElementsByTagName('*') ?? [];
    const headingIds = new Set();
    const editorTransformer = new (0, $2lPWP.JSONTransformer)();
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($2cfd9ea7d82f1add$var$HEADINGS.has(child.tagName)) {
            const pmNode = child.pmViewDesc?.node;
            if (!pmNode) continue;
            // Copied from TOC
            const adf = editorTransformer.encode(pmNode);
            let adfObject = adf;
            if (typeof adf === 'string') try {
                adfObject = JSON.parse(adf);
            } catch (err) {
            // Swallow the error as ADF format error handling is expected to be done earlier,
            // in the component that renders the entire content
            }
            const headingId = $2cfd9ea7d82f1add$export$dbad71934afee167(adfObject, headingIds);
            if (!headingId) continue;
            yield [
                headingId,
                child,
                pmNode
            ];
        }
    }
}
const $2cfd9ea7d82f1add$export$817005c72dc2688 = ()=>{
    const headingIdToElement = new Map();
    for (const [headingId, child, _] of $2cfd9ea7d82f1add$var$getHeadingIds()){
        headingIdToElement.set(headingId, child);
        // A bit inefficient, but there's sometimes a discrepancy between the hashed ID and the generated ID. The least impactful solution is to just add both.
        headingIdToElement.set(encodeURIComponent(headingId), child);
    }
    return headingIdToElement;
};
const $2cfd9ea7d82f1add$export$e2a78e613c648859 = (node)=>{
    for (const [headingId, _, pmNode] of $2cfd9ea7d82f1add$var$getHeadingIds()){
        if (node === pmNode) return headingId;
    }
    return undefined;
};
module.exports["getHeadingId"] = $2cfd9ea7d82f1add$export$dbad71934afee167;
module.exports["getHeadingIdsToElements"] = $2cfd9ea7d82f1add$export$817005c72dc2688;
module.exports["getHeadingIdForNode"] = $2cfd9ea7d82f1add$export$e2a78e613c648859;

});

parcelRegister("iNIw3", function(module, exports) {
const $2008359fb3515e18$export$38c6526d67de94bb = 'xen:macro';
const $2008359fb3515e18$export$8d4b803281599c6a = 'com.atlassian.ecosystem';
const $2008359fb3515e18$export$d7168699755008a = 'com.atlassian.confluence.macro.core';
const $2008359fb3515e18$export$46fc26821adc3495 = 'connectAddon';
const $2008359fb3515e18$export$95077f102dafd025 = 'migratedServerP2Addon';
const $2008359fb3515e18$export$981e47da3e2dfc13 = 'bodiedExtension';
const $2008359fb3515e18$export$4506b39eefa6dc94 = 'multiBodiedExtension';
const $2008359fb3515e18$export$d2cde58d8ae019a9 = 'forge.ui.extension';
const $2008359fb3515e18$export$bf4c163a4c708db1 = 'forgeDocUpdated';
const $2008359fb3515e18$export$973a451c50b864fd = 'atlassianMacroOutputType';
const $2008359fb3515e18$export$3551f8d01dfac8f1 = 'atlassianForgeInlineBodied';
module.exports["MODULE_NAME"] = $2008359fb3515e18$export$38c6526d67de94bb;
module.exports["EXTENSION_NAMESPACE"] = $2008359fb3515e18$export$8d4b803281599c6a;
module.exports["P2_OR_CONNECT_CONFLUENCE_MACRO_EXTENSION_TYPE"] = $2008359fb3515e18$export$d7168699755008a;
module.exports["CONNECT_ADDON_ACTION_SUBJECT"] = $2008359fb3515e18$export$46fc26821adc3495;
module.exports["MIGRATED_SERVER_P2_ADDON_ACTION_SUBJECT"] = $2008359fb3515e18$export$95077f102dafd025;
module.exports["EXTENSION_TYPE_MULTI_BODIED"] = $2008359fb3515e18$export$4506b39eefa6dc94;
module.exports["FORGE_EXTENSION"] = $2008359fb3515e18$export$d2cde58d8ae019a9;
module.exports["FORGE_DOC_UPDATED_EVENT"] = $2008359fb3515e18$export$bf4c163a4c708db1;
module.exports["MACRO_OUTPUT_TYPE_PARAM"] = $2008359fb3515e18$export$973a451c50b864fd;
module.exports["FORGE_INLINE_BODIED_PARAM"] = $2008359fb3515e18$export$3551f8d01dfac8f1;

});

parcelRegister("2igSQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dUI0h = parcelRequire("dUI0h");


var $2xdp1 = parcelRequire("2xdp1");


var $kwjRd = parcelRequire("kwjRd");


var $idCCS = parcelRequire("idCCS");

const $f852cc0c808326c8$export$cdee65ffaf9b2fb7 = ({ parameters: parameters })=>{
    // https://github.com/final-form/react-final-form/issues/103
    // If users name variables using numbers it breaks the form
    // hacky fix added a $ character in front
    const inputName = `$${parameters?.name}`;
    const inputPlaceholder = `${parameters?.placeholder || parameters?.name}`;
    // . [ or ] in the variable name causes Final Form to throw an error
    const validInputName = inputName.replace(/[`.\[\]\/]/gi, '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwjRd.TemplateVariableInputWrapper), null, parameters?.type === (0, $2xdp1.MULTI_LINES_TYPE) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwjRd.TemplateVariableTextareaInputFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            display: 'inline-block',
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: validInputName,
        defaultValue: ""
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $idCCS.TemplateVariableInputComponent), {
            ...fieldProps,
            parameters: parameters,
            inputName: validInputName,
            placeholder: inputPlaceholder
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwjRd.TemplateVariableInputFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: '0px 0px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: validInputName,
        defaultValue: ""
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $idCCS.TemplateVariableInputComponent), {
            ...fieldProps,
            parameters: parameters,
            inputName: validInputName,
            placeholder: inputPlaceholder
        })))));
};
module.exports["TemplateVariableInput"] = $f852cc0c808326c8$export$cdee65ffaf9b2fb7;

});

parcelRegister("2xdp1", function(module, exports) {

var $55ggG = parcelRequire("55ggG");

const $df54c7f294e74661$export$178c63c1bbc65458 = (0, $55ggG.i18n).templateVariableDefault.defaultMessage;
const $df54c7f294e74661$export$ae3b897442224943 = 'text';
const $df54c7f294e74661$export$a43e313f04be91d7 = 'textarea';
const $df54c7f294e74661$export$22c50a44ec8aa5dd = 'select';
const $df54c7f294e74661$export$d1952e7dbe0fefc9 = 5;
const $df54c7f294e74661$export$777b44f8413b254e = 100;
module.exports["defaultVariableName"] = $df54c7f294e74661$export$178c63c1bbc65458;
module.exports["TEXT_TYPE"] = $df54c7f294e74661$export$ae3b897442224943;
module.exports["MULTI_LINES_TYPE"] = $df54c7f294e74661$export$a43e313f04be91d7;
module.exports["LIST_TYPE"] = $df54c7f294e74661$export$22c50a44ec8aa5dd;
module.exports["ROWS_DEFAULT"] = $df54c7f294e74661$export$d1952e7dbe0fefc9;
module.exports["COLUMNS_DEFAULT"] = $df54c7f294e74661$export$777b44f8413b254e;

});

parcelRegister("55ggG", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $446fbea06bd2a31f$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    propertyPanelVariableDisplayString: {
        id: "template-variable.property.panel.variable.display.string",
        defaultMessage: "Text"
    },
    propertyPanelVariableDisplayStringTooltip: {
        id: "template-variable.property.panel.variable.display.string.tooltip",
        defaultMessage: "Single line text input field."
    },
    propertyPanelVariableDisplayTextArea: {
        id: "template-variable.property.panel.variable.display.textarea",
        defaultMessage: "Multi-line Text"
    },
    propertyPanelVariableDisplayTextAreaTooltip: {
        id: "template-variable.property.panel.variable.display.textarea.tooltip",
        defaultMessage: "Multi-line text input field."
    },
    propertyPanelVariableDisplayList: {
        id: "template-variable.property.panel.variable.display.list",
        defaultMessage: "List"
    },
    propertyPanelVariableDisplayListTooltip: {
        id: "template-variable.property.panel.variable.display.list.tooltip",
        defaultMessage: "Drop down list."
    },
    templateEditorChangingVariableDialogTitle: {
        id: "template-variable.template.editor.changing.variable.dialog.title",
        defaultMessage: "Edit template variable"
    },
    templateEditorVariableNameField: {
        id: "template-variable.template.editor.variable.name.field",
        defaultMessage: "Variable name"
    },
    propertyPanelVariableDisplayTextAreaRowsTooltip: {
        id: "template-variable.property.panel.variable.textarea.rows.tooltip",
        defaultMessage: "Number of rows to display for the field."
    },
    propertyPanelVariableDisplayTextAreaColumnsTooltip: {
        id: "template-variable.property.panel.variable.textarea.columns.tooltip",
        defaultMessage: "Number of columns to display for the field."
    },
    propertyPanelVariableListValuesTooltip: {
        id: "template-variable.property.panel.variable.list.values.tooltip",
        defaultMessage: "Enter each item for the list, separating each with a comma."
    },
    templateEditorVariableListFieldPlaceholder: {
        id: "template-variable.template.editor.variable.list.field.placeholder",
        defaultMessage: "option 1, option 2, option 3"
    },
    templateEditorVariableSaveButtonLabel: {
        id: "template-variable.template.editor.variable.save.button.label",
        defaultMessage: "Save"
    },
    templateVariableDefault: {
        id: "template-variable.template.editor.variable.name.default",
        defaultMessage: "variable_name"
    }
});
module.exports["i18n"] = $446fbea06bd2a31f$export$a7357cdd1f0b0168;

});

parcelRegister("kwjRd", function(module, exports) {
/* SharedComponents.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $f809923cf8cfa046$export$4af78215734bfe2b = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_313842B0rP _1DCdHi5zaO _1wydGWFQfX _3iDTPbvbI6",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$59d0bfd82baefce0 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYEV9lr _0bjKvDXPZg _0KLXruVva3",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$8eff3c6bf5b8c758 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3W2Oc84hR5 _1UtDYzy7kJ _1kk5TkzUZr",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$b4ff36272a61159f = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYEV9lr _0bjKvD7Zry _1UtDYzKGUX _0KLXruVva3 _3W2Oc84hR5",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$e3cad7a6d45ce703 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _1EqgXlN91d _1ANEUSzUZr",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$e9df20cb66227872 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _1EqgXlN91d _1mT5xdRAKS _1RrJLiBwqQ",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$bdc3c19374266b98 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_25VRdPZqHV",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$c996e1cc40266f34 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2XsHFMFQfX",
            __cmplp.className
        ])
    });
});
module.exports["TemplateVariableInputWrapper"] = $f809923cf8cfa046$export$4af78215734bfe2b;
module.exports["TemplateVariableNameWrapper"] = $f809923cf8cfa046$export$59d0bfd82baefce0;
module.exports["TemplateVariableName"] = $f809923cf8cfa046$export$8eff3c6bf5b8c758;
module.exports["TemplateVariableType"] = $f809923cf8cfa046$export$b4ff36272a61159f;
module.exports["TemplateVariableInputFieldWrapper"] = $f809923cf8cfa046$export$e3cad7a6d45ce703;
module.exports["TemplateVariableTextareaInputFieldWrapper"] = $f809923cf8cfa046$export$e9df20cb66227872;
module.exports["ButtonStyle"] = $f809923cf8cfa046$export$bdc3c19374266b98;
module.exports["DropDownInputWrapper"] = $f809923cf8cfa046$export$c996e1cc40266f34;

});

parcelRegister("idCCS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7sJoX = parcelRequire("7sJoX");


var $e3Wrf = parcelRequire("e3Wrf");


var $4yg9g = parcelRequire("4yg9g");


var $3GNtk = parcelRequire("3GNtk");


var $5SGpQ = parcelRequire("5SGpQ");


var $lpNn5 = parcelRequire("lpNn5");


var $kwjRd = parcelRequire("kwjRd");


var $2xdp1 = parcelRequire("2xdp1");

const $ab3c5e793706abd9$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    invalidVariableNameError: {
        id: "template-variable.description.invalid.variable.name",
        defaultMessage: "This template contains a variable using invalid character(s) (. , [ , ], /). Please have the template owner remove these characters from the variable to use it."
    }
});
const $ab3c5e793706abd9$var$generateDropdownOptionsList = (options)=>options ? options.map((option)=>({
            label: option,
            value: option
        })) : [];
const $ab3c5e793706abd9$var$styles = {
    option: (provided)=>({
            ...provided,
            wordBreak: 'break-word'
        })
};
const $ab3c5e793706abd9$var$checkTemplateVariableValidity = (variableName)=>{
    const invalidVariableCharacters = [
        '.',
        '[',
        ']',
        '/'
    ];
    return invalidVariableCharacters.some((invalidVariableCharacter)=>variableName?.includes(invalidVariableCharacter));
};
const $ab3c5e793706abd9$export$25a5c8174bd010d5 = ({ parameters: parameters, onChange: onChange, value: value, placeholder: placeholder })=>{
    const intl = (0, $kSwu1.useIntl)();
    // We are passing in placeholder as the validity check b/c it hasn't been stripped of . [ or ]
    const hasInvalidVariableName = $ab3c5e793706abd9$var$checkTemplateVariableValidity(placeholder);
    const parameterOptions = parameters.params && parameters.params.options;
    const options = (0, $cozmU.useMemo)(()=>$ab3c5e793706abd9$var$generateDropdownOptionsList(parameterOptions), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        parameterOptions
    ]);
    const onChangeHandler = (0, $cozmU.useMemo)(()=>(option)=>{
            onChange(option.value);
        }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, hasInvalidVariableName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: intl.formatMessage($ab3c5e793706abd9$export$a7357cdd1f0b0168.invalidVariableNameError)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwjRd.DropDownInputWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3GNtk.PopupSelect), {
        options: options,
        placeholder: `${value || placeholder}`,
        onChange: onChangeHandler,
        target: ({ ref: ref, isOpen: isOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwjRd.ButtonStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
                ref: ref,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    label: "dropdown icon",
                    size: "small"
                }),
                isSelected: isOpen,
                isDisabled: hasInvalidVariableName
            }, `${value || placeholder}`)),
        popperProps: {
            placement: 'auto',
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: 'clippingParents'
                    }
                }
            ]
        },
        maxMenuHeight: 200,
        maxMenuWidth: 200,
        searchThreshold: 10,
        // eslint-disable-next-line @atlaskit/design-system/enforce-inline-styles-in-select
        styles: $ab3c5e793706abd9$var$styles,
        value: {
            label: value,
            value: value
        }
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwjRd.DropDownInputWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3GNtk.PopupSelect), {
        options: options,
        placeholder: `${value || placeholder}`,
        onChange: onChangeHandler,
        target: ({ ref: ref, isOpen: isOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwjRd.ButtonStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
                ref: ref,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    label: "dropdown icon",
                    size: "small"
                }),
                isSelected: isOpen,
                isDisabled: parameters.isDisabled
            }, `${value || placeholder}`)),
        popperProps: {
            placement: 'auto',
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: 'clippingParents'
                    }
                }
            ]
        },
        maxMenuHeight: 200,
        maxMenuWidth: 200,
        searchThreshold: 10,
        // eslint-disable-next-line @atlaskit/design-system/enforce-inline-styles-in-select
        styles: $ab3c5e793706abd9$var$styles,
        value: {
            label: value,
            value: value
        }
    })));
};
const $ab3c5e793706abd9$export$b9055edfa32ac8b4 = ({ onChange: onChange, value: value, inputName: inputName, parameters: parameters, placeholder: placeholder })=>{
    const intl = (0, $kSwu1.useIntl)();
    // We are passing in placeholder as the validity check b/c it hasn't been stripped of . [ or ]
    const hasInvalidVariableName = $ab3c5e793706abd9$var$checkTemplateVariableValidity(placeholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, hasInvalidVariableName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: intl.formatMessage($ab3c5e793706abd9$export$a7357cdd1f0b0168.invalidVariableNameError)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
            ...tooltipProps,
            testId: "text-field-input",
            name: inputName,
            onChange: onChange,
            value: value || '',
            placeholder: placeholder,
            isDisabled: hasInvalidVariableName,
            width: 200,
            isCompact: true
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        testId: "text-field-input",
        name: inputName,
        onChange: onChange,
        value: value || '',
        placeholder: placeholder,
        isDisabled: parameters?.isDisabled,
        width: 200,
        isCompact: true
    }));
};
const $ab3c5e793706abd9$export$9a5caaaacb4c92d3 = ({ parameters: parameters, onChange: onChange, value: value, placeholder: placeholder })=>{
    const intl = (0, $kSwu1.useIntl)();
    // We are passing in placeholder as the validity check b/c it hasn't been stripped of . [ or ]
    const hasInvalidVariableName = $ab3c5e793706abd9$var$checkTemplateVariableValidity(placeholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, hasInvalidVariableName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: intl.formatMessage($ab3c5e793706abd9$export$a7357cdd1f0b0168.invalidVariableNameError)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
            ...tooltipProps,
            testId: "text-area-input",
            onChange: onChange,
            value: value || '',
            minimumRows: parameters.params && parameters.params.rows || 1,
            cols: parameters.params && parameters.params.columns || 30,
            resize: "vertical",
            isDisabled: hasInvalidVariableName,
            placeholder: placeholder
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
        testId: "text-area-input",
        onChange: onChange,
        value: value || '',
        minimumRows: parameters.params && parameters.params.rows || 1,
        cols: parameters.params && parameters.params.columns || 30,
        resize: "vertical",
        isDisabled: parameters?.isDisabled,
        placeholder: placeholder
    }));
};
const $ab3c5e793706abd9$export$f57c870ff73570c7 = (props)=>{
    const { parameters: parameters } = props;
    switch(parameters.type){
        case 0, $2xdp1.LIST_TYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ab3c5e793706abd9$export$25a5c8174bd010d5, props);
        case 0, $2xdp1.MULTI_LINES_TYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ab3c5e793706abd9$export$9a5caaaacb4c92d3, props);
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ab3c5e793706abd9$export$b9055edfa32ac8b4, props);
    }
};
module.exports["TemplateVariableInputComponent"] = $ab3c5e793706abd9$export$f57c870ff73570c7;

});

parcelRegister("jn9ek", function(module, exports) {
const $2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'third party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Edited 1st party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Content created or updated with invalid arguments: Invalid space key specified.' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isExceededRateError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message).includes('rate limit exceeded');
};
const $2f7d9ade7a6b90fb$export$9ae592643c1ef19b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$af33641014b57bba = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$b6b21a057779c53b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError);
};
const $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08 = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isExceededRateError);
};
const $2f7d9ade7a6b90fb$export$69408b85ed2a0e77 = (error)=>{
    if (error && 'graphQLErrors' in error) {
        const originalError = error.graphQLErrors?.[0]?.originalError;
        return originalError?.traceId || '';
    }
    return '';
};
module.exports["isBadThirdPartyBlueprintError"] = $2f7d9ade7a6b90fb$export$9ae592643c1ef19b;
module.exports["isBadEditedFirstPartyBlueprintError"] = $2f7d9ade7a6b90fb$export$af33641014b57bba;
module.exports["isInvalidSpaceKeyError"] = $2f7d9ade7a6b90fb$export$b6b21a057779c53b;
module.exports["isRateExceededError"] = $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08;
module.exports["getTraceIdFromApolloError"] = $2f7d9ade7a6b90fb$export$69408b85ed2a0e77;

});

parcelRegister("hHZWk", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $jlIaF = parcelRequire("jlIaF");


var $a6t12 = parcelRequire("a6t12");


var $4qzKl = parcelRequire("4qzKl");

/**
 * This component processes the DOM Node for ContentBody, Likes, & CommentBody to find all User Mentions
 * and User Links and replaces them with a React Element for @atlaskit/profilecard
 */ const $fe7178b75f06350f$var$LEGACY_USER_ELEMENT_SELECTORS = [
    'a.user-mention',
    'a.confluence-userlink',
    'a.userLogoLink',
    'span.user-hover-trigger',
    'img.confluence-userlink'
];
class $fe7178b75f06350f$export$549ba0a29911d5ee extends (0, $cozmU.Component) {
    shouldComponentUpdate(nextProps) {
        return nextProps.node !== this.props.node;
    }
    getLegacyUserElements() {
        const { node: node } = this.props;
        if (!node) return [];
        return Array.from(node.querySelectorAll($fe7178b75f06350f$var$LEGACY_USER_ELEMENT_SELECTORS.join(',')));
    }
    render() {
        return (0, $4qzKl.replaceUserElementsWithPlaceholders)(this.getLegacyUserElements()).map((item)=>this.renderPortal(item));
    }
    constructor(...args){
        super(...args);
        this.renderPortal = (item)=>{
            const { position: position } = this.props;
            const userId = item.props['data-account-id'];
            item.props.href = (0, $4qzKl.getAtlassianPeopleProfileUrl)(item.props['data-account-id'], null, (0, $jlIaF.CONTEXT_PATH));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fe7178b75f06350f$export$b688bc1b9fd324b6, {
                placeholder: item.placeholder
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: !userId,
                userId: userId,
                position: position
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", item.props, item.props.children))), item.placeholder);
        };
    }
}
function $fe7178b75f06350f$export$b688bc1b9fd324b6(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { placeholder: placeholder, children: children } = t0;
    let t1;
    let t2;
    if ($[0] !== placeholder) {
        t1 = ()=>{
            const markPlaceholderIgnored = (e)=>{
                if (e?.tagName === "SPAN") {
                    e.setAttribute("data-ssr-placeholder-ignored", "true");
                    Array.from(e.children).forEach((child)=>markPlaceholderIgnored(child));
                }
            };
            markPlaceholderIgnored(placeholder);
        };
        t2 = [
            placeholder
        ];
        $[0] = placeholder;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
}
module.exports["LegacyUserElementsHover"] = $fe7178b75f06350f$export$549ba0a29911d5ee;

});

parcelRegister("8eAX8", function(module, exports) {

var $k5ycH = parcelRequire("k5ycH");


var $cpjd2 = parcelRequire("cpjd2");


var $8n9tL = parcelRequire("8n9tL");


var $64KID = parcelRequire("64KID");


var $9fLxI = parcelRequire("9fLxI");

const $d0091e97ce884599$var$MACRO_STATIC_CONNECT_WRM_RESOURCES = [
    'wr!com.atlassian.confluence.plugins.confluence-view-file-macro:view-file-macro-resources'
];
const $d0091e97ce884599$var$MACRO_DEFAULT_WRM_RESOURCES = [
    'wr!confluence.web.resources:view-content',
    'wr!confluence.macros.advanced:get-more'
];
const $d0091e97ce884599$export$1d71148f13231a96 = ()=>[
        // transitional and implicit dependencies
        'wrc!com.atlassian.confluence.extra.team-calendars:amd',
        'wrc!com.atlassian.confluence.extra.team-calendars:user-timezone-setup',
        // editor context
        'wrc!com.atlassian.confluence.extra.team-calendars:calendar-init-editor',
        // macro-browser (not loaded by macro browser for some reason)
        'wrc!com.atlassian.confluence.extra.team-calendars:macro-browser-web-resources'
    ];
function $d0091e97ce884599$export$c3c980ae518bc695(webresources, macroRenderedOutputFromSSR, macroOutput, callback, scriptContainer, unavailableCallback) {
    const defaultWrmResources = $d0091e97ce884599$var$MACRO_DEFAULT_WRM_RESOURCES;
    const staticConnectWrmResources = $d0091e97ce884599$var$MACRO_STATIC_CONNECT_WRM_RESOURCES;
    let deps = [], jsTags;
    if (macroRenderedOutputFromSSR || macroOutput) deps = [
        ...defaultWrmResources
    ];
    else {
        if (!webresources) return Promise.resolve();
        jsTags = webresources?.tags?.js ?? null;
        const contexts = !jsTags || !scriptContainer ? webresources.contexts && webresources.contexts.map((context)=>`wrc!${context}`) || [] : [];
        const keys = !jsTags || !scriptContainer ? webresources.keys && webresources.keys.map((key)=>`wr!${key}`) || [] : [];
        deps = [
            ...defaultWrmResources,
            ...staticConnectWrmResources,
            ...contexts,
            ...keys
        ];
    }
    return new Promise((resolve)=>{
        (0, $cpjd2.requireLegacyWRM)(deps, ()=>{
            // Callback
            if (callback) callback();
            if (scriptContainer && jsTags) (0, $k5ycH.loadResources)(scriptContainer, jsTags).then(resolve);
            else resolve();
        }, ()=>{
            // Unavailable Callback
            // eslint-disable-next-line no-console
            console.error(`Cannot loadMacroWebResources: ${deps}`);
            if (unavailableCallback) unavailableCallback();
        });
    });
}
function $d0091e97ce884599$export$a144665563142e() {
    let macrosMetadataCache = null;
    const macrosMetadataSpaceAwareCache = {};
    return async function metadataLoader() {
        const spaceKey = $d0091e97ce884599$var$getSpaceKey();
        if (spaceKey) {
            if (!macrosMetadataSpaceAwareCache[spaceKey]) macrosMetadataSpaceAwareCache[spaceKey] = $d0091e97ce884599$var$fetchMacroMetadata(spaceKey);
            return macrosMetadataSpaceAwareCache[spaceKey];
        }
        if (!macrosMetadataCache) macrosMetadataCache = $d0091e97ce884599$var$fetchMacroMetadata();
        return macrosMetadataCache;
    };
}
function $d0091e97ce884599$var$getSpaceKey() {
    const pageUrl = window.location.toString();
    const match = (0, $8n9tL.findAndMatchRoute)((0, $64KID.namedRoutes), pageUrl);
    // There's a race condition when the space key is not yet available in AJS upon
    // calling metadataLoader, therefore we fallback to the space key in the URL.
    return window.AJS?.Meta?.get('space-key') || match?.params?.spaceKey;
}
function $d0091e97ce884599$var$fetchMacroMetadata(spaceKey) {
    return (0, $9fLxI.getExtensionManifest)({
        spaceKey: spaceKey
    }).then((manifest)=>{
        const macros = manifest?.macros || [];
        return macros;
    });
}
module.exports["teamCalendarWRM"] = $d0091e97ce884599$export$1d71148f13231a96;
module.exports["loadMacroWebResources"] = $d0091e97ce884599$export$c3c980ae518bc695;
module.exports["createMetadataLoader"] = $d0091e97ce884599$export$a144665563142e;

});

parcelRegister("k5ycH", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $l6Xaz = parcelRequire("l6Xaz");

const $980b898db1533800$var$logger = (0, $7W8i8.getLogger)('wrm');
function $980b898db1533800$export$d3d08d944062d7e(container, tags, // Process tags as an array of links when linksMode = true
// We don't have tags info in CustomHeaderFooter.
linksMode = false) {
    if (!tags.length) return Promise.resolve();
    const fragment = window.document.createDocumentFragment();
    const promises = (0, $l6Xaz.parseScriptTags)(tags, linksMode).map(({ src: src, ...attributes })=>new Promise((resolve, reject)=>{
            if (window.document.querySelector(`script[data-wrm-key='${attributes['data-wrm-key']}']`)) // next/packages/content-renderer/src/TinyMCEServerFullRenderer.tsx will put script as defer to <head>
            // We don't want to re-initialize those scripts when rehydrate
            resolve(null);
            else {
                const scriptElement = window.document.createElement('script');
                scriptElement.async = false;
                scriptElement.src = src;
                scriptElement.onload = resolve;
                scriptElement.onerror = reject;
                Object.keys(attributes).forEach((attributeKey)=>scriptElement.setAttribute(attributeKey, attributes[attributeKey]));
                fragment.appendChild(scriptElement);
            }
        }));
    container.appendChild(fragment);
    return Promise.all(promises).catch((...args)=>{});
}
module.exports["loadResources"] = $980b898db1533800$export$d3d08d944062d7e;

});

parcelRegister("8cOoD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $cpjd2 = parcelRequire("cpjd2");


var $gEtAQ = parcelRequire("gEtAQ");


var $fySJw = parcelRequire("fySJw");


var $3LvmY = parcelRequire("3LvmY");

const $198de0e1d1f1ab22$export$f1a6c160e5107221 = 'dataProvider';
const $198de0e1d1f1ab22$export$57b0f508e89cfdbb = ({ connectHost: connectHost })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const isViewPage = (0, $gEtAQ.isViewPage)();
        $198de0e1d1f1ab22$export$eb1900d465fb2cb9({
            connectHost: connectHost,
            createAnalyticsEvent: createAnalyticsEvent,
            isViewPage: isViewPage
        });
    }, [
        connectHost,
        createAnalyticsEvent
    ]);
    return null;
};
const $198de0e1d1f1ab22$export$594716b2dbd4f0f9 = ()=>!!window['connectHost']?.isModuleDefined($198de0e1d1f1ab22$export$f1a6c160e5107221);
const $198de0e1d1f1ab22$export$eb1900d465fb2cb9 = ({ connectHost: connectHost, createAnalyticsEvent: createAnalyticsEvent, isViewPage: isViewPage })=>{
    const isDPModuleDefined = $198de0e1d1f1ab22$export$594716b2dbd4f0f9();
    const dataProviderModule = {
        emitToDataProvider: async (...args)=>{
            const data = args.length > 1 ? args[0] : null;
            const sendResponse = args.length > 1 ? args[args.length - 1] : args[0];
            const context = sendResponse?._context;
            const fragmentLocalId = context?.extension?.options?.productContext?.['macro.fragmentLocalId'];
            const extensionKey = context?.extension?.key;
            const event = (0, $3LvmY.getReceivedConnectRefDataEvent)({
                isViewPage: isViewPage,
                extensionKey: extensionKey
            });
            createAnalyticsEvent(event).fire();
            if (!extensionKey) throw Error('Missing Connect app extensionKey while transferring data.');
            const connectDataListener = (0, $fySJw.getConnectDataListener)();
            const status = await connectDataListener.transfer(extensionKey, fragmentLocalId, data, createAnalyticsEvent, isViewPage);
            return sendResponse(status);
        }
    };
    if (!isDPModuleDefined) connectHost.defineModule($198de0e1d1f1ab22$export$f1a6c160e5107221, dataProviderModule);
};
const $198de0e1d1f1ab22$export$8738a87451e0e0f8 = async ({ logger: logger, isViewPage: isViewPage, createAnalyticsEvent: createAnalyticsEvent })=>{
    await new Promise((resolve)=>{
        (0, $cpjd2.requireLegacyWRM)([
            'wr!confluence.web.resources:querystring',
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ], ()=>{
            const connectHost = window['connectHost'];
            $198de0e1d1f1ab22$export$eb1900d465fb2cb9({
                connectHost: connectHost,
                createAnalyticsEvent: createAnalyticsEvent,
                isViewPage: isViewPage
            });
            resolve();
        }, ()=>{
            logger.error`Error loading WRM for dataProvider!`;
            resolve();
        });
    });
};
module.exports["DataProviderModule"] = $198de0e1d1f1ab22$export$57b0f508e89cfdbb;
module.exports["checkIsDPModuleDefined"] = $198de0e1d1f1ab22$export$594716b2dbd4f0f9;
module.exports["loadDataProviderModule"] = $198de0e1d1f1ab22$export$8738a87451e0e0f8;

});

parcelRegister("fySJw", function(module, exports) {

var $2XKS9 = parcelRequire("2XKS9");


var $dc2v6 = parcelRequire("dc2v6");


var $3LvmY = parcelRequire("3LvmY");


var $1AM4E = parcelRequire("1AM4E");

let $8e595456ec3aa5d5$var$connectDataListener;


class $8e595456ec3aa5d5$var$ConnectDataListener {
    init({ emit: emit }) {
        this.emit = emit;
    }
    static async validate(extensionKey, data) {
        const { validateSchema: validateSchema, DataTransferValidationError: DataTransferValidationError } = await (parcelRequire("31KN8"));
        if (!data.eventData) throw new DataTransferValidationError({
            message: "Passed data is missing 'eventData'."
        });
        const keys = Object.keys(data.eventData);
        if (keys.length !== 1) throw new DataTransferValidationError({
            message: "'eventData' should only include a single key. The key should be same with 'refDataSchema.outputType'."
        });
        const connectMacroKeyRefOutputTypeMap = await (0, $dc2v6.getConnectMacroKeyRefOutputTypeMap)();
        if (!connectMacroKeyRefOutputTypeMap.has(extensionKey)) // This is a case that shouldn't really happen. Throwing a regular error instead of DataTransferValidationError
        // because this error is not related to what the vendor emitted data.
        throw new Error('extensionKey is not found in the macro metadata.');
        if (connectMacroKeyRefOutputTypeMap.get(extensionKey) !== keys[0]) throw new DataTransferValidationError({
            message: `'eventData' should contain 'refDataSchema.outputType' defined in the app manifest (${connectMacroKeyRefOutputTypeMap.get(extensionKey)}).`
        });
        validateSchema(keys[0], data.eventData[keys[0]]);
    }
    async transfer(extensionKey, localId, data, createAnalyticsEvent, isViewPage) {
        if (this.emit && localId && data) {
            const transfer = {
                extensionKey: extensionKey,
                localId: localId,
                data: data,
                isViewPage: isViewPage
            };
            const isTrackable = (0, $1AM4E.ConnectReferentialityExperienceTrackerSupport).isTrackable(transfer);
            let didStartExperience = false;
            const shouldTrack = isTrackable;
            const { DataTransferValidationError: DataTransferValidationError } = await (parcelRequire("31KN8"));
            try {
                await $8e595456ec3aa5d5$var$ConnectDataListener.validate(extensionKey, data);
            } catch (e) {
                const event = (0, $3LvmY.getValidationFailedEvent)({
                    isViewPage: isViewPage,
                    extensionKey: extensionKey,
                    error: e
                });
                createAnalyticsEvent(event).fire();
                if (shouldTrack && !didStartExperience && !(e instanceof DataTransferValidationError)) {
                    (0, $1AM4E.ConnectReferentialityExperienceTrackerSupport).start(transfer);
                    didStartExperience = true;
                }
                if (didStartExperience) (0, $1AM4E.ConnectReferentialityExperienceTrackerSupport).fail(e instanceof Error ? e : String(e));
                if (e instanceof DataTransferValidationError) return {
                    status: (0, $2XKS9.ConnectDataTransferStatus).Error,
                    message: e.message,
                    module: 'data_provider',
                    errors: e.errors
                };
                throw e;
            }
            if (shouldTrack && !didStartExperience) {
                (0, $1AM4E.ConnectReferentialityExperienceTrackerSupport).start(transfer);
                didStartExperience = true;
            }
            this.emit(localId, data.eventData);
            if (didStartExperience) (0, $1AM4E.ConnectReferentialityExperienceTrackerSupport).succeed();
            return {
                status: (0, $2XKS9.ConnectDataTransferStatus).Success,
                message: 'Data accepted and emitted',
                module: 'data_provider'
            };
        }
        return {
            status: (0, $2XKS9.ConnectDataTransferStatus).Error,
            message: 'There was an issue accepting the data',
            module: 'data_provider'
        };
    }
    constructor(){
        this.emit = void 0;
    }
}
const $8e595456ec3aa5d5$export$605049a72d9f563 = ()=>{
    if (!$8e595456ec3aa5d5$var$connectDataListener) $8e595456ec3aa5d5$var$connectDataListener = new $8e595456ec3aa5d5$var$ConnectDataListener();
    return $8e595456ec3aa5d5$var$connectDataListener;
};
module.exports["getConnectDataListener"] = $8e595456ec3aa5d5$export$605049a72d9f563;

});

parcelRegister("2XKS9", function(module, exports) {
var $606590dfce3163d6$export$f9f405499e653992 = /*#__PURE__*/ function(ConnectDataTransferStatus) {
    ConnectDataTransferStatus["Success"] = "Success";
    ConnectDataTransferStatus["Error"] = "Error";
    return ConnectDataTransferStatus;
}({});
module.exports["ConnectDataTransferStatus"] = $606590dfce3163d6$export$f9f405499e653992;

});

parcelRegister("dc2v6", function(module, exports) {

var $3IXUB = parcelRequire("3IXUB");

let $a1018373af446f97$var$connectMacroKeyRefOutputTypeMap;
let $a1018373af446f97$var$initialized = false;
async function $a1018373af446f97$var$createMacroKeyRefOutputTypeMap() {
    const macros = await (0, $3IXUB.getMacroMetaData)();
    const result = macros.filter((macro)=>macro.refDataSchema != null).map((macro)=>[
            macro.macroName,
            macro.refDataSchema.outputType
        ]);
    return new Map(result);
}
async function $a1018373af446f97$export$9fde119d071a7062() {
    // used this initialized variable because I was seeing that connectMacroKeyRefOutputTypeMap may
    // be null errors otherwise
    if (!$a1018373af446f97$var$initialized) {
        $a1018373af446f97$var$connectMacroKeyRefOutputTypeMap = await $a1018373af446f97$var$createMacroKeyRefOutputTypeMap();
        $a1018373af446f97$var$initialized = true;
    }
    return $a1018373af446f97$var$connectMacroKeyRefOutputTypeMap;
}
module.exports["getConnectMacroKeyRefOutputTypeMap"] = $a1018373af446f97$export$9fde119d071a7062;

});

parcelRegister("3IXUB", function(module, exports) {

var $8eAX8 = parcelRequire("8eAX8");


var $6OgRG = parcelRequire("6OgRG");


var $l21Jh = parcelRequire("l21Jh");

const $a3d4cd842e4cfa1b$var$loadMacroMetadata = (0, $8eAX8.createMetadataLoader)();
function $a3d4cd842e4cfa1b$export$e08f75a9d86fcdf4(browserConfig) {
    return (0, $l21Jh.autoConvert)($a3d4cd842e4cfa1b$export$82582a527779c20, browserConfig);
}
const $a3d4cd842e4cfa1b$export$82582a527779c20 = async ()=>{
    const macros = await $a3d4cd842e4cfa1b$var$loadMacroMetadata();
    const isAllowed = (0, $6OgRG.isAllowedWithFeatureFlags)();
    return macros.filter((macroMetadata)=>{
        if (macroMetadata.hidden) return false;
        return isAllowed(macroMetadata);
    });
};
module.exports["getAutoConverter"] = $a3d4cd842e4cfa1b$export$e08f75a9d86fcdf4;
module.exports["getMacroMetaData"] = $a3d4cd842e4cfa1b$export$82582a527779c20;

});

parcelRegister("6OgRG", function(module, exports) {
// This blocklist should reflect what is in https://pug.jira-dev.com/wiki/spaces/AEC/pages/3239608672/Macro+blocklist so if you want to add or remove something, please remember to update the page.
const $38fb99c52e3447fe$var$blocklist = {
    align: true,
    bgcolor: true,
    center: true,
    cheese: true,
    clickable: true,
    code: true,
    colgroup: true,
    column: true,
    'content-by-user': true,
    copyright: true,
    'create-space-button': true,
    div: true,
    expand: true,
    'fancy-bullets': true,
    'google-drive-docs': true,
    'google-drive-sheets': true,
    'google-drive-slides': true,
    favpages: true,
    'gadget-b7a6531b1c147f2e175f1209bed5c0ad': true,
    'gadget-01c2ed272e88f7333da124a03a481477': true,
    'gadget-d2450e06a9a285cf57eedb2d502d9d65b964eb847382938b6c57809bac2261bb': true,
    'global-reports': true,
    highlight: true,
    htmlcomment: true,
    im: true,
    img: true,
    info: true,
    junitreport: true,
    li: true,
    loremipsum: true,
    lozenge: true,
    multimedia: true,
    navmap: true,
    network: true,
    noformat: true,
    note: true,
    ol: true,
    OneDrive: true,
    p: true,
    panel: true,
    pre: true,
    'privacy-policy': true,
    'privacy-mark': true,
    'recently-used-labels': true,
    'reg-tm': true,
    rollover: true,
    roundrect: true,
    search: true,
    section: true,
    sm: true,
    'space-attachments': true,
    'space-details': true,
    span: true,
    status: true,
    strike: true,
    style: true,
    table: true,
    tbody: true,
    td: true,
    th: true,
    thead: true,
    tr: true,
    'trello-board': true,
    'trello-card': true,
    tip: true,
    tm: true,
    ul: true,
    warning: true
};
function $38fb99c52e3447fe$export$1c6721fad2c8cfa0(macroMetadata, blocklistOverrides = {}) {
    const key = macroMetadata.alternateId || (macroMetadata.id ? macroMetadata.id.replace('macro-', '') : macroMetadata.macroName);
    return blocklistOverrides.hasOwnProperty(key) ? blocklistOverrides[key] : Boolean($38fb99c52e3447fe$var$blocklist[key]);
}
function $38fb99c52e3447fe$export$1dba5c5d55fad37f() {
    const overrides = {};
    return (macroMetadata)=>!$38fb99c52e3447fe$export$1c6721fad2c8cfa0(macroMetadata, overrides);
}
async function $38fb99c52e3447fe$export$f38acf7431de7e2b(macroBrowser) {
    const originalList = [
        ...macroBrowser.metadataList
    ];
    // Currently no FF info is needed to create the blocklist but if it was, need to pass featureFlagClient to isAllowedWithFeatureFlags()
    const isAllowed = $38fb99c52e3447fe$export$1dba5c5d55fad37f();
    macroBrowser.metadataList = macroBrowser.metadataList.filter(isAllowed);
    /**
	 * Bring blocklisted items back so they show up elsewhere
	 */ return function restore() {
        macroBrowser.metadataList = originalList;
    };
}
module.exports["isAllowedWithFeatureFlags"] = $38fb99c52e3447fe$export$1dba5c5d55fad37f;
module.exports["applyBlocklist"] = $38fb99c52e3447fe$export$f38acf7431de7e2b;

});

parcelRegister("l21Jh", function(module, exports) {

var $3CRZ9 = parcelRequire("3CRZ9");


var $8PZXE = parcelRequire("8PZXE");

const $159df558ca333321$var$noop = ()=>null;
const $159df558ca333321$export$65b04260b3a15835 = async (loadMacroMetadata, browserConfig)=>{
    const { contentId: contentId } = browserConfig;
    if (!contentId) return $159df558ca333321$var$noop;
    const [jiraAutoConvert, connectAddonAutoConvert] = await Promise.all([
        (0, $3CRZ9.createJiraConverter)(contentId),
        (0, $8PZXE.createConnectAddonConverter)(loadMacroMetadata, contentId)
    ]);
    return (link)=>jiraAutoConvert(link) || connectAddonAutoConvert(link);
};
module.exports["autoConvert"] = $159df558ca333321$export$65b04260b3a15835;

});

parcelRegister("3CRZ9", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $1i7uI = parcelRequire("1i7uI");


var $foRF9 = parcelRequire("foRF9");


var $6mEZ3 = parcelRequire("6mEZ3");

function $3fcae9e87e9104a7$var$convertLink(link, defaultJiraMacroAttributes) {
    const noop = ()=>{};
    const legacyHandler = (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).require('confluence/jim/editor-plugins/jira-paste-link');
    // jira paste handler needs object in this format
    const uri = {
        source: link
    };
    const jimPasteHandlerResult = legacyHandler.pasteHandler(uri, null, noop);
    if (!jimPasteHandlerResult || !jimPasteHandlerResult.params) return null;
    /**
	 * use JSON.parse , JSON.stringify to deeply clone object, avoid any reference
	 */ const macroAttributes = JSON.parse(JSON.stringify(defaultJiraMacroAttributes));
    if (!macroAttributes.attrs.parameters) macroAttributes.attrs.parameters = {};
    macroAttributes.attrs.parameters.macroParams = (0, $6mEZ3.wrapMacroParams)(jimPasteHandlerResult.params);
    return macroAttributes;
}
async function $3fcae9e87e9104a7$export$2264c7423a8e6d34(contentId) {
    const placeholderMacro = {
        macroDefinition: {
            name: 'jira'
        },
        contentId: contentId
    };
    // fetch ADF structure of JIM, and modify it to provide to editor later
    const jiraADFNode = await (0, $foRF9.fetchMacroAttributes)(placeholderMacro);
    return (link)=>$3fcae9e87e9104a7$var$convertLink(link, jiraADFNode);
}
module.exports["createJiraConverter"] = $3fcae9e87e9104a7$export$2264c7423a8e6d34;

});

parcelRegister("8PZXE", function(module, exports) {

var $foRF9 = parcelRequire("foRF9");


var $6mEZ3 = parcelRequire("6mEZ3");

/*
This script adds autoconvert handlers to the confluence editor.

It executes on editor initialisation, registering the handlers defined in the original add-on descriptors of whatever
add-ons are installed. Each one is associated with a particular macro (although a macro can be associated with many
handlers.

On pattern match, the each handler will be asked if they match and will be processed by the first matching handler.
The macro object is then created, using the matched uri and the information already existing in the JS context, and
the macro is inserted into the editor.
*/ const $44631a970962135a$var$TRELLO_MACRO_NAME = 'trello-card';
const $44631a970962135a$var$escapePattern = (str)=>{
    return str.replace(/[\-\[\]\/\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
};
const $44631a970962135a$var$replaceAll = (find, replace, str)=>{
    return str.replace(new RegExp(find, 'g'), replace);
};
const $44631a970962135a$var$convertPatternToRegex = (pattern)=>{
    // Consolidate any double up wildcards
    while(pattern.indexOf('{}{}') !== -1)pattern = pattern.replace('{}{}', '{}');
    // build a regex from the defined autoconvert pattern
    pattern = $44631a970962135a$var$escapePattern(pattern);
    pattern = $44631a970962135a$var$replaceAll('{}', '[^/]*?', pattern);
    // eslint-disable-next-line prefer-template
    pattern = '^' + pattern + '$';
    return pattern;
};
const $44631a970962135a$var$isPatternSafe = (pattern)=>{
    const patternBlockList = [
        'http://',
        'https://',
        'http://{}',
        'https://{}',
        'http://{}.{}',
        'https://{}.{}',
        'http://{}.{}.{}',
        'https://{}.{}.{}'
    ];
    // check the url pattern is not banned
    return patternBlockList.every((bannedPattern)=>bannedPattern !== pattern);
};
const $44631a970962135a$var$hasAutoconvertData = (macro)=>{
    return macro.autoconvertData && macro.autoconvertData.urlParameter && macro.autoconvertData.patterns;
};
const $44631a970962135a$var$getADFNodeForMacros = async (macros, contentId)=>{
    const macroAttributesArray = await Promise.all(Array.from(macros).map((macroName)=>(0, $foRF9.fetchMacroAttributes)({
            macroDefinition: {
                name: macroName
            },
            contentId: contentId
        })));
    return macroAttributesArray.reduce((accu, macroAttributes)=>{
        accu[macroAttributes.attrs.extensionKey] = macroAttributes;
        return accu;
    }, {});
};
const $44631a970962135a$var$convertLink = (link, autoconvertDefs, macroAttributesMap)=>{
    const matchedAcd = autoconvertDefs.find((acd)=>{
        return !!link.match(acd.matcher);
    });
    if (matchedAcd) {
        const { macroName: macroName, urlParameter: urlParameter } = matchedAcd;
        const params = {};
        params[urlParameter] = link;
        const macroAttributes = macroAttributesMap[macroName];
        const convertedMacroAttributes = JSON.parse(JSON.stringify(macroAttributes));
        convertedMacroAttributes.attrs.text = `${urlParameter} = ${link}`;
        convertedMacroAttributes.attrs.extensionKey = macroName;
        if (!convertedMacroAttributes.attrs.parameters) convertedMacroAttributes.attrs.parameters = {};
        convertedMacroAttributes.attrs.parameters.macroParams = (0, $6mEZ3.wrapMacroParams)(params);
        return convertedMacroAttributes;
    } else return null;
};
async function $44631a970962135a$export$13c25ccf87e8cca2(loadMacroMetadata, contentId) {
    const autoconvertDefs = [];
    const macros = await loadMacroMetadata();
    // this object contains name of macros which have correct autoconvertData
    const filteredMacros = new Set();
    macros.forEach((macro)=>{
        if (// Don't convert any new Trello links to Trello macro due to new Trello smart links
        !$44631a970962135a$var$hasAutoconvertData(macro) || macro.macroName === $44631a970962135a$var$TRELLO_MACRO_NAME) return;
        // only macro with autoconvertData can be converted
        macro.autoconvertData.patterns.forEach((pattern)=>{
            if ($44631a970962135a$var$isPatternSafe(pattern)) {
                const acd = {
                    macroName: macro.macroName,
                    urlParameter: macro.autoconvertData.urlParameter,
                    matcher: $44631a970962135a$var$convertPatternToRegex(pattern)
                };
                filteredMacros.add(acd.macroName);
                autoconvertDefs.push(acd);
            }
        });
    });
    const macroAttributes = await $44631a970962135a$var$getADFNodeForMacros(filteredMacros, contentId);
    return (link)=>$44631a970962135a$var$convertLink(link, autoconvertDefs, macroAttributes);
}
module.exports["createConnectAddonConverter"] = $44631a970962135a$export$13c25ccf87e8cca2;

});

parcelRegister("3LvmY", function(module, exports) {
const $a60398d8d7606d16$export$16d909a88d49df97 = ({ isViewPage: isViewPage, extensionKey: extensionKey, error: error })=>{
    return {
        type: 'sendTrackEvent',
        data: {
            containerType: 'page',
            objectType: 'connectAddon',
            source: isViewPage ? 'viewPageScreen' : 'editPageScreen',
            action: 'failed',
            actionSubject: 'connectRefEventDataValidation',
            attributes: {
                extensionKey: extensionKey,
                message: error.message
            }
        }
    };
};
const $a60398d8d7606d16$export$f472af28e6312d6e = ({ isViewPage: isViewPage, extensionKey: extensionKey })=>{
    return {
        type: 'sendTrackEvent',
        data: {
            containerType: 'page',
            objectType: 'connectAddon',
            source: isViewPage ? 'viewPageScreen' : 'editPageScreen',
            action: 'received',
            actionSubject: 'connectRefEventData',
            attributes: {
                extensionKey: extensionKey
            }
        }
    };
};
module.exports["getValidationFailedEvent"] = $a60398d8d7606d16$export$16d909a88d49df97;
module.exports["getReceivedConnectRefDataEvent"] = $a60398d8d7606d16$export$f472af28e6312d6e;

});

parcelRegister("1AM4E", function(module, exports) {

var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");

const $b8656fd966301400$var$getError = (messageOrError)=>{
    if (messageOrError instanceof Error) return messageOrError;
    return new Error(messageOrError);
};
const $b8656fd966301400$export$9e19abdf0a0245fe = new class ConnectReferentialityExperienceTrackerSupport {
    isTrackable(transfer) {
        return Boolean(transfer?.extensionKey) && Boolean(transfer?.localId) && Boolean(transfer?.data);
    }
    start(transfer) {
        (0, $fGzMp.getExperienceTracker)().start({
            name: (0, $irVI7.CONNECT_REFERENTIALITY_EXPERIENCE),
            attributes: {
                extensionKey: transfer?.extensionKey,
                isViewPage: transfer?.isViewPage
            }
        });
    }
    succeed() {
        (0, $fGzMp.getExperienceTracker)().succeed({
            name: (0, $irVI7.CONNECT_REFERENTIALITY_EXPERIENCE)
        });
    }
    fail(messageOrError) {
        (0, $fGzMp.getExperienceTracker)().fail({
            name: (0, $irVI7.CONNECT_REFERENTIALITY_EXPERIENCE),
            error: $b8656fd966301400$var$getError(messageOrError)
        });
    }
}();
module.exports["ConnectReferentialityExperienceTrackerSupport"] = $b8656fd966301400$export$9e19abdf0a0245fe;

});

parcelRegister("31KN8", function(module, exports) {

let $2345c2ebf53cd779$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2345c2ebf53cd779$var$load("iEvs6").then(()=>parcelRequire('bppNh'));

});

parcelRegister("euF5O", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $914eacf4cf3bd652$export$26c05f52dcf7c5f2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    shouldRefetchMacroQuery: false
});
module.exports["LegacyMacroRendererContext"] = $914eacf4cf3bd652$export$26c05f52dcf7c5f2;

});

parcelRegister("hl0fg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $55fM8 = parcelRequire("55fM8");

const $9b206d933744c82f$export$42c02f33970a2afa = ()=>{
    const isClient = typeof window === 'object';
    const getSize = ()=>{
        return {
            width: isClient ? window.innerWidth : 0,
            height: isClient ? window.innerHeight : 0
        };
    };
    const [windowSize, setWindowSize] = (0, $cozmU.useState)(getSize);
    (0, $cozmU.useEffect)(()=>{
        const handleResize = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
            setWindowSize(getSize());
        }, 200);
        window.addEventListener('resize', handleResize);
        return ()=>{
            window.removeEventListener('resize', handleResize);
            handleResize.cancel();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty array ensures that effect is only run on mount and unmount
    return windowSize;
};
module.exports["useWindowSize"] = $9b206d933744c82f$export$42c02f33970a2afa;

});

parcelRegister("iXzFq", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $71e3d8e13a87be5f$var$getLegacyActionUrl = (redirectToEditor, contentId)=>{
    if (redirectToEditor) return `${0, $jlIaF.CONTEXT_PATH}/pages/resumedraft.action?draftId=${contentId}`;
    return `${0, $jlIaF.CONTEXT_PATH}/pages/viewpage.action?pageId=${contentId}`;
};
const $71e3d8e13a87be5f$export$11b68a3633074ac0 = ({ contentType: contentType, contentSubType: contentSubType = null, contentId: contentId, spaceKey: spaceKey, redirectToEditor: redirectToEditor = false, useLegacyActionUrl: useLegacyActionUrl = false })=>{
    if (!contentId) return null;
    // assume all page sub types will only redirect to view page
    // can refactor to be more specific if needed
    if (contentType === 'page' && contentSubType !== null) return (0, $1NBp8.VIEW_PAGE).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
    if (contentType === 'page' && useLegacyActionUrl) return $71e3d8e13a87be5f$var$getLegacyActionUrl(redirectToEditor, contentId);
    if (contentType === 'page' && redirectToEditor) return (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        spaceKey: spaceKey,
        contentType: 'pages',
        contentId: contentId
    });
    if (contentType === 'blogpost' && redirectToEditor) return (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: 'blog'
    });
    switch(contentType){
        case 'page':
            return (0, $1NBp8.VIEW_PAGE).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'blogpost':
            return (0, $1NBp8.VIEW_BLOG).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'whiteboard':
            return (0, $1NBp8.WHITEBOARD_BOARD).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'database':
            return (0, $1NBp8.DATABASE_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'slide':
            return (0, $1NBp8.SLIDES_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'embed':
            return (0, $1NBp8.EMBED_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'folder':
            return (0, $1NBp8.FOLDER_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
    }
    return null;
};
module.exports["getUrlForContentType"] = $71e3d8e13a87be5f$export$11b68a3633074ac0;

});

parcelRegister("hQnHK", function(module, exports) {
const $0037b6bfd6daf741$export$8cda2e6ee87e510b = 'openTemplatePicker';
const $0037b6bfd6daf741$export$a90803a9f656fd5f = 'showCreateWithRovo';
const $0037b6bfd6daf741$export$2deb4fd8c7cecd6b = 'isNewWhiteboard';
const $0037b6bfd6daf741$export$58465f9d39dce215 = 'insertTemplateWithKey';
const $0037b6bfd6daf741$export$6b4bb9c01a5ea809 = 'headless';
const $0037b6bfd6daf741$export$fe7e318da6d65170 = 'canvas-server';
const $0037b6bfd6daf741$export$f356f97db9b96f17 = 'canvas-relay';
const $0037b6bfd6daf741$export$1cebfc86ac630bb9 = 'whiteboard-frame';
const $0037b6bfd6daf741$export$3078341395c8cb8e = 'whiteboard-locale';
const $0037b6bfd6daf741$export$8103f24eb51911e7 = 'whiteboard-linked-object';
const $0037b6bfd6daf741$export$d7fb875e30263264 = 'initial-theme';
const $0037b6bfd6daf741$export$57f29eb0a90c2092 = 'initial-background-style';
const $0037b6bfd6daf741$export$abce116b94c493f9 = 'bifrost-override';
const $0037b6bfd6daf741$export$d3cf0d39019c8c7f = 'deactivationIdentifier';
const $0037b6bfd6daf741$export$390fc29767c845fc = 'whiteboardPaywallUpsellButton';
const $0037b6bfd6daf741$export$7864364f55e7d48e = 'whiteboardPaywallLearnMoreButton';
const $0037b6bfd6daf741$export$4541324acb17bf12 = 'whiteboardCreationPaywall-';
const $0037b6bfd6daf741$export$c896c362d8b74a87 = 'openJiraImportTool';
const $0037b6bfd6daf741$export$54b9795b714f5c18 = 'autoImportJiraIssues';
const $0037b6bfd6daf741$export$321c00d8e9c04c4f = 'jiraImportJql';
const $0037b6bfd6daf741$export$72b22303fb080064 = 'openMiroImportTool';
const $0037b6bfd6daf741$export$1ef18edc28f65989 = 'openMuralImportTool';
const $0037b6bfd6daf741$export$cbbd90bf5df877bd = 'cloudId';
const $0037b6bfd6daf741$export$2f0c01c772bbe851 = 'projectUuid';
const $0037b6bfd6daf741$export$f045456260cdfa6f = new Date('2024-02-29T00:00Z');
const $0037b6bfd6daf741$export$1c237a39a0b4e9d9 = 'parentProduct';
const $0037b6bfd6daf741$export$2fe42b7bd8ad9641 = 'parentDomain';
const $0037b6bfd6daf741$export$e75d2079ca761674 = 'presentationMode';
const $0037b6bfd6daf741$export$6c706ba208a447e = 'themeState';
const $0037b6bfd6daf741$export$8b639ae03e233763 = 'visualRefresh';
const $0037b6bfd6daf741$export$628c002e5c2252ee = 'createdAt';
const $0037b6bfd6daf741$export$cab138e355452790 = 'focusedCommentId';
const $0037b6bfd6daf741$export$fc53afa4d35a37cf = 'focusedMentionId';
const $0037b6bfd6daf741$export$95e280144fb6ae44 = 'replyToComment';
const $0037b6bfd6daf741$export$4f5dbfe1c54c9e86 = 'version';
const $0037b6bfd6daf741$export$4b9f8234d01d21e9 = 'createdFromSlug';
const $0037b6bfd6daf741$export$8718ad6f6cf65056 = 'debugLayouts';
const $0037b6bfd6daf741$export$326bc0b4b25bc0cb = 'racing';
const $0037b6bfd6daf741$export$148d5c0fade1be8d = 'slides';
const $0037b6bfd6daf741$export$8896acdfcdaf8f6d = 'hideBorder';
const $0037b6bfd6daf741$export$39abeb28b3f870c6 = 'embed';
const $0037b6bfd6daf741$export$f0568a870cb93dbd = 'nativeEmbedView';
module.exports["TEMPLATE_PICKER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8cda2e6ee87e510b;
module.exports["SHOW_CREATE_WITH_ROVO_QUERY_PARAM"] = $0037b6bfd6daf741$export$a90803a9f656fd5f;
module.exports["NEW_WHITEBOARD_QUERY_PARAM"] = $0037b6bfd6daf741$export$2deb4fd8c7cecd6b;
module.exports["INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM"] = $0037b6bfd6daf741$export$58465f9d39dce215;
module.exports["HEADLESS_QUERY_PARAM"] = $0037b6bfd6daf741$export$6b4bb9c01a5ea809;
module.exports["SERVER_SPOT_PARAM"] = $0037b6bfd6daf741$export$fe7e318da6d65170;
module.exports["RELAY_SPOT_PARAM"] = $0037b6bfd6daf741$export$f356f97db9b96f17;
module.exports["WHITEBOARD_IFRAME_TITLE"] = $0037b6bfd6daf741$export$1cebfc86ac630bb9;
module.exports["WHITEBOARD_LOCALE"] = $0037b6bfd6daf741$export$3078341395c8cb8e;
module.exports["WHITEBOARD_LINKED_OBJECT"] = $0037b6bfd6daf741$export$8103f24eb51911e7;
module.exports["INITIAL_THEME_PARAM"] = $0037b6bfd6daf741$export$d7fb875e30263264;
module.exports["INITIAL_BACKGROUND_STYLE_QUERY_PARAM"] = $0037b6bfd6daf741$export$57f29eb0a90c2092;
module.exports["BIFROST_OVERRIDE_PARAM"] = $0037b6bfd6daf741$export$abce116b94c493f9;
module.exports["PAYWALL_DEACTIVATION_IDENTIFIER"] = $0037b6bfd6daf741$export$d3cf0d39019c8c7f;
module.exports["WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$390fc29767c845fc;
module.exports["WHITEBOARD_PAYWALL_INFO_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$7864364f55e7d48e;
module.exports["WHITEBOARD_CREATION_PAYWALL_SOURCE_PREFIX"] = $0037b6bfd6daf741$export$4541324acb17bf12;
module.exports["JIRA_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$c896c362d8b74a87;
module.exports["AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM"] = $0037b6bfd6daf741$export$54b9795b714f5c18;
module.exports["JIRA_IMPORT_JQL"] = $0037b6bfd6daf741$export$321c00d8e9c04c4f;
module.exports["MIRO_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$72b22303fb080064;
module.exports["MURAL_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$1ef18edc28f65989;
module.exports["CLOUD_ID"] = $0037b6bfd6daf741$export$cbbd90bf5df877bd;
module.exports["PROJECT_UUID"] = $0037b6bfd6daf741$export$2f0c01c772bbe851;
module.exports["PARENT_PRODUCT_QUERY_PARAM"] = $0037b6bfd6daf741$export$1c237a39a0b4e9d9;
module.exports["PARENT_DOMAIN_QUERY_PARAM"] = $0037b6bfd6daf741$export$2fe42b7bd8ad9641;
module.exports["PRESENTATION_MODE_QUERY_PARAM"] = $0037b6bfd6daf741$export$e75d2079ca761674;
module.exports["EMBEDDED_THEME_STATE"] = $0037b6bfd6daf741$export$6c706ba208a447e;
module.exports["VISUAL_REFRESH_PARAM"] = $0037b6bfd6daf741$export$8b639ae03e233763;
module.exports["EMBEDDED_WHITEBOARD_CREATED_AT_QUERY_PARAM"] = $0037b6bfd6daf741$export$628c002e5c2252ee;
module.exports["FOCUSED_COMMENT_ID"] = $0037b6bfd6daf741$export$cab138e355452790;
module.exports["FOCUSED_MENTION_ID"] = $0037b6bfd6daf741$export$fc53afa4d35a37cf;
module.exports["REPLY_TO_COMMENT"] = $0037b6bfd6daf741$export$95e280144fb6ae44;
module.exports["WHITEBOARD_VERSION_ID"] = $0037b6bfd6daf741$export$4f5dbfe1c54c9e86;
module.exports["CREATED_FROM_SLUG"] = $0037b6bfd6daf741$export$4b9f8234d01d21e9;
module.exports["DEBUG_LAYOUTS_QUERY_PARAM"] = $0037b6bfd6daf741$export$8718ad6f6cf65056;
module.exports["RACING_QUERY_PARAM"] = $0037b6bfd6daf741$export$326bc0b4b25bc0cb;
module.exports["SLIDES_QUERY_PARAM"] = $0037b6bfd6daf741$export$148d5c0fade1be8d;
module.exports["HIDE_BORDER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8896acdfcdaf8f6d;
module.exports["EMBED_QUERY_PARAM"] = $0037b6bfd6daf741$export$39abeb28b3f870c6;
module.exports["NATIVE_EMBED_VIEW_QUERY_PARAM"] = $0037b6bfd6daf741$export$f0568a870cb93dbd;

});

parcelRegister("3Xfhj", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $bf3492583e212e7a$export$cf8a0a38543b2f6c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EfLS5",
    loader: async ()=>(await (parcelRequire("hngpw"))).PageContentRendererFabric,
    name: 'PageContentRendererFabric'
});

const $bf3492583e212e7a$export$43e0568dbf658f88 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "VZbpe",
    loader: async ()=>(await (parcelRequire("gRCmX"))).PageContentRendererTiny,
    name: 'PageContentRendererTiny'
});
module.exports["PageContentRendererFabric"] = $bf3492583e212e7a$export$cf8a0a38543b2f6c;
module.exports["PageContentRendererTiny"] = $bf3492583e212e7a$export$43e0568dbf658f88;

});

parcelRegister("hngpw", function(module, exports) {

let $ca61507ba35ba616$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ca61507ba35ba616$var$load("kT6dz"),
    $ca61507ba35ba616$var$load("iY1NC"),
    $ca61507ba35ba616$var$load("ezYRV"),
    $ca61507ba35ba616$var$load("dfVz8"),
    $ca61507ba35ba616$var$load("bPC3R"),
    $ca61507ba35ba616$var$load("bHb1X"),
    $ca61507ba35ba616$var$load("4Gdnz"),
    $ca61507ba35ba616$var$load("4UAag"),
    $ca61507ba35ba616$var$load("6Qybl"),
    $ca61507ba35ba616$var$load("fxlto"),
    $ca61507ba35ba616$var$load("2F69B"),
    $ca61507ba35ba616$var$load("53Y0O"),
    $ca61507ba35ba616$var$load("kYlwR"),
    $ca61507ba35ba616$var$load("1tqsw"),
    $ca61507ba35ba616$var$load("jgr2j"),
    $ca61507ba35ba616$var$load("9Oxea"),
    $ca61507ba35ba616$var$load("cxCk7"),
    $ca61507ba35ba616$var$load("ly931"),
    $ca61507ba35ba616$var$load("7SteV"),
    $ca61507ba35ba616$var$load("eNgZ8"),
    $ca61507ba35ba616$var$load("lAHCT"),
    $ca61507ba35ba616$var$load("hs6P3"),
    $ca61507ba35ba616$var$load("k8nz9"),
    $ca61507ba35ba616$var$load("dxcsb"),
    $ca61507ba35ba616$var$load("ksOjm"),
    $ca61507ba35ba616$var$load("jAsJw"),
    $ca61507ba35ba616$var$load("eUsnQ"),
    $ca61507ba35ba616$var$load("jisiR"),
    $ca61507ba35ba616$var$load("icVON"),
    $ca61507ba35ba616$var$load("90SZm"),
    $ca61507ba35ba616$var$load("crfrC"),
    $ca61507ba35ba616$var$load("4x9Jx"),
    $ca61507ba35ba616$var$load("7gL7H"),
    $ca61507ba35ba616$var$load("ea3NB"),
    $ca61507ba35ba616$var$load("6wr18"),
    $ca61507ba35ba616$var$load("59hV4"),
    $ca61507ba35ba616$var$load("aNyWk"),
    $ca61507ba35ba616$var$load("gSKF7"),
    $ca61507ba35ba616$var$load("dtNxV"),
    $ca61507ba35ba616$var$load("iTOzX"),
    $ca61507ba35ba616$var$load("ipkwd"),
    $ca61507ba35ba616$var$load("a7sEM"),
    $ca61507ba35ba616$var$load("aLbuU"),
    $ca61507ba35ba616$var$load("ffEVr"),
    $ca61507ba35ba616$var$load("dIY7W"),
    $ca61507ba35ba616$var$load("zUKwV"),
    $ca61507ba35ba616$var$load("fUeur"),
    $ca61507ba35ba616$var$load("1sii7"),
    $ca61507ba35ba616$var$load("6gMrU"),
    $ca61507ba35ba616$var$load("iECXC"),
    $ca61507ba35ba616$var$load("Wowvf"),
    $ca61507ba35ba616$var$load("4g6rd"),
    $ca61507ba35ba616$var$load("fq1gG"),
    $ca61507ba35ba616$var$load("1JeTB"),
    $ca61507ba35ba616$var$load("4UHov"),
    $ca61507ba35ba616$var$load("hhss7"),
    $ca61507ba35ba616$var$load("cWL7t"),
    $ca61507ba35ba616$var$load("gbJtu"),
    $ca61507ba35ba616$var$load("86OhX"),
    $ca61507ba35ba616$var$load("7EorR"),
    $ca61507ba35ba616$var$load("kNILH")
]).then(()=>parcelRequire('8ThhQ'));

});

parcelRegister("gRCmX", function(module, exports) {

let $c46f5befe65594da$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c46f5befe65594da$var$load("4g6rd"),
    $c46f5befe65594da$var$load("fq1gG"),
    $c46f5befe65594da$var$load("bm0oR"),
    $c46f5befe65594da$var$load("61Bv2"),
    $c46f5befe65594da$var$load("30b92"),
    $c46f5befe65594da$var$load("90SZm"),
    $c46f5befe65594da$var$load("crfrC"),
    $c46f5befe65594da$var$load("4x9Jx"),
    $c46f5befe65594da$var$load("ea3NB"),
    $c46f5befe65594da$var$load("6wr18"),
    $c46f5befe65594da$var$load("59hV4"),
    $c46f5befe65594da$var$load("fuOfV"),
    $c46f5befe65594da$var$load("jL1Ke"),
    $c46f5befe65594da$var$load("5MQ0D"),
    $c46f5befe65594da$var$load("ffEVr"),
    $c46f5befe65594da$var$load("fwbNS"),
    $c46f5befe65594da$var$load("zUKwV"),
    $c46f5befe65594da$var$load("fUeur"),
    $c46f5befe65594da$var$load("h4Nf7"),
    $c46f5befe65594da$var$load("Wowvf"),
    $c46f5befe65594da$var$load("fWCBZ"),
    $c46f5befe65594da$var$load("hhss7"),
    $c46f5befe65594da$var$load("86OhX"),
    $c46f5befe65594da$var$load("7EorR"),
    $c46f5befe65594da$var$load("e9VVN")
]).then(()=>parcelRequire('ixmFo'));

});

parcelRegister("huSww", function(module, exports) {
/* ForgeMacro.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");


var $9wGTI = parcelRequire("9wGTI");


var $1XIV5 = parcelRequire("1XIV5");


var $6m0us = parcelRequire("6m0us");

const $689e73fff1c3c213$var$spinnerWrapperStyles = null;
const $689e73fff1c3c213$export$23218f6079f92c07 = 7000;
const $689e73fff1c3c213$export$6c47eb21e290b9d2 = 5000;
const $689e73fff1c3c213$export$428754a896652d4f = 10000;
const $689e73fff1c3c213$export$9a740f7442111961 = 60000;
function $689e73fff1c3c213$var$getNestedMacroLocalIds(node) {
    const localIds = new Set();
    const visit = (nodes)=>{
        const childNodes = Array.isArray(nodes) ? nodes : typeof nodes === 'object' && nodes !== null && Array.isArray(nodes.content) ? nodes.content : [];
        childNodes.forEach((child)=>{
            const type = typeof child.type === 'string' ? child.type : child.type?.name;
            if ([
                'extension',
                'bodiedExtension',
                'inlineExtension'
            ].includes(type)) {
                const localId = child.localId ?? child.attrs?.localId ?? child.parameters?.localId ?? child.attrs?.parameters?.localId;
                if (localId) localIds.add(localId);
            }
            visit(child.content);
        });
    };
    visit(node?.content);
    return Array.from(localIds);
}
function $689e73fff1c3c213$export$7914a38f4e6c4db9(isEditing, isLivePage) {
    if (!(0, $9wGTI.fg)('conf_frontend_forge_static_macro_mvp')) return undefined;
    return (node, renderFn)=>{
        // Untouched Connect macros keep extensionType `com.atlassian.confluence.macro.core` and are
        // keyed in `confluence_staticMacros` by `parameters.macroMetadata.macroId`, not `localId`.
        const isConnectShapedNode = node?.extensionType === 'com.atlassian.confluence.macro.core';
        const localId = isConnectShapedNode ? node?.parameters?.macroMetadata?.macroId?.value : node?.localId ?? node?.parameters?.localId;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($689e73fff1c3c213$export$4dada8c8c9499dbf, {
            localId: localId,
            extensionKey: node?.extensionKey?.split('/').at(-1),
            guestParams: node?.parameters?.guestParams || node?.parameters?.config,
            renderIframe: ()=>renderFn({
                    references: []
                }),
            isEditing: isEditing,
            isLivePage: isLivePage,
            isConnectShapedNode: isConnectShapedNode,
            nestedMacroLocalIds: $689e73fff1c3c213$var$getNestedMacroLocalIds(node)
        });
    };
}
function $689e73fff1c3c213$export$4dada8c8c9499dbf({ localId: localId, extensionKey: extensionKey, guestParams: guestParams, renderIframe: renderIframe, isEditing: isEditing, isLivePage: isLivePage, isConnectShapedNode: isConnectShapedNode, nestedMacroLocalIds: nestedMacroLocalIds = [] }) {
    const ctx = (0, $6m0us.useStaticMacroStoreContext)();
    const store = ctx?.storeRef.current;
    const [, forceUpdate] = (0, $cozmU.useReducer)((n)=>n + 1, 0);
    const [isRefetching, setIsRefetching] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const readyEventEmittedRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false);
    const postEditTimeoutsRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef([]);
    const cancelPostEditRefetch = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        postEditTimeoutsRef.current.forEach(clearTimeout);
        postEditTimeoutsRef.current = [];
    }, []); // Check if this extension supports staticView, based on preloaded extension data.
    // extensionsLoaded is true when __SSR_FORGE_EXTENSIONS__ has been populated.
    // isStatic may be false either because (a) extensions not loaded yet, or (b) not a static macro.
    // We only use isStatic as a fallback signal when we know extensions ARE loaded.
    //
    // Connect-shaped nodes aren't in that preloaded list, so treat them as "maybe static" and rely
    // on store.fullyLoaded below instead.
    const isStatic = isConnectShapedNode ? true : ctx && extensionKey ? ctx.isStaticExtension(extensionKey) : false;
    const extensionsLoaded = !!window.__SSR_FORGE_EXTENSIONS__?.['xen:macro']?.extensions?.length;
    (0, $cozmU.useEffect)(()=>{
        if (!ctx || !localId) return;
        const handleUpdate = ({ type: type })=>{
            // Bulk-query completion changes the fallback decision, but only an update for this macro
            // completes a post-edit refetch. In particular, do not cancel a pending refetch when the
            // initial bulk query happens to complete after a parameter change.
            if (type === 'static-macro-result') {
                cancelPostEditRefetch();
                setIsRefetching(false);
            }
            forceUpdate();
        };
        const unsubscribe = ctx.subscribe(localId, handleUpdate); // Data may have already arrived before we subscribed — check immediately.
        if (store?.html.has(localId) || store?.errors.has(localId)) handleUpdate({
            type: 'static-macro-result'
        });
        else if (store?.fullyLoaded) handleUpdate({
            type: 'fully-loaded'
        });
        return unsubscribe;
    }, [
        ctx,
        localId,
        forceUpdate,
        store,
        cancelPostEditRefetch
    ]);
    const startPostEditRefetch = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        if (!ctx || !localId) return undefined; // Hide the now-stale HTML immediately. The delay applies only to the first network request,
        // giving the backend time to render the changed macro state.
        setIsRefetching(true);
        cancelPostEditRefetch();
        const schedulePostEditTimer = (callback, delay)=>{
            const timeoutId = setTimeout(callback, delay);
            postEditTimeoutsRef.current.push(timeoutId);
        }; // A successful refetch (HTML or an error) notifies the store subscription above, which clears
        // any pending timer. A null response does not notify it, so retry once before restoring the
        // previous HTML and stopping the spinner.
        const scheduleSpinnerFallback = ()=>{
            schedulePostEditTimer(()=>setIsRefetching(false), $689e73fff1c3c213$export$6c47eb21e290b9d2);
        };
        const scheduleRetry = ()=>{
            schedulePostEditTimer(()=>{
                scheduleSpinnerFallback();
                ctx.triggerRefetch(localId, 'edit');
            }, $689e73fff1c3c213$export$6c47eb21e290b9d2);
        };
        schedulePostEditTimer(()=>{
            scheduleRetry();
            ctx.triggerRefetch(localId, 'edit');
        }, $689e73fff1c3c213$export$23218f6079f92c07);
        return cancelPostEditRefetch;
    }, [
        ctx,
        localId,
        cancelPostEditRefetch
    ]);
    const deferPostEditRefetchUntilDraftSync = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        if (!ctx || !localId) return undefined;
        const removeDeferredRefetch = ctx.deferUntilDraftSync(localId, ()=>{
            startPostEditRefetch();
        });
        return ()=>{
            removeDeferredRefetch();
            cancelPostEditRefetch();
        };
    }, [
        ctx,
        localId,
        startPostEditRefetch,
        cancelPostEditRefetch
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!ctx || !localId || !isStatic) return undefined;
        if (!isEditing || !isLivePage) return undefined;
        if (!ctx.hasMountedBefore(localId)) {
            ctx.markMounted(localId);
            return undefined;
        }
        if (nestedMacroLocalIds.length > 0) return startPostEditRefetch();
        return deferPostEditRefetchUntilDraftSync(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const guestParamsRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(undefined);
    const serializedGuestParams = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>JSON.stringify(guestParams ?? null), [
        guestParams
    ]);
    const html = localId ? store?.html.get(localId) : undefined;
    const errorCode = localId ? store?.errors.get(localId) : undefined;
    const resultMetadata = localId ? store?.resultMetadata.get(localId) : undefined;
    (0, $1XIV5.useStaticMacroRenderAnalytics)({
        html: html,
        errorCode: errorCode,
        result: resultMetadata,
        isEditing: Boolean(isEditing),
        isLivePage: Boolean(isLivePage)
    }); // Signal cc-puppeteer that this static macro has finished rendering.
    // cc-puppeteer's waitForAllExtensionReadyEvents() waits for EXTENSION_READY from every
    // Forge extension it finds in the ADF (regardless of emitsReadyEvent manifest declaration).
    // Without this signal, the full 10s timeout is consumed on every PDF export with a static macro.
    // Guarded by a ref so it only fires once per ForgeMacro instance.
    (0, $cozmU.useEffect)(()=>{
        if (html && localId && !readyEventEmittedRef.current) {
            readyEventEmittedRef.current = true;
            window.postMessage({
                source: 'forge-extension',
                type: 'EXTENSION_READY',
                localId: localId
            }, window.location.origin);
        }
    }, [
        html,
        localId
    ]); // When a config changes, we want to trigger a re-render.
    (0, $cozmU.useEffect)(()=>{
        if (!ctx || !localId || !isStatic || !isEditing) return undefined;
        const serialized = serializedGuestParams;
        const prev = guestParamsRef.current;
        guestParamsRef.current = serialized; // Skip on first render for this macro instance — only refetch on subsequent changes.
        if (prev === undefined || prev === serialized) return undefined;
        return deferPostEditRefetchUntilDraftSync();
    }, [
        ctx,
        localId,
        isStatic,
        isEditing,
        serializedGuestParams,
        deferPostEditRefetchUntilDraftSync
    ]);
    const isFullyLoaded = !!store?.fullyLoaded;
    (0, $cozmU.useEffect)(()=>{
        if (!ctx || !localId || !isStatic || !isEditing) return undefined;
        if (!isFullyLoaded) return undefined;
        if (html !== undefined || errorCode !== undefined) return undefined;
        const currentStore = ctx.storeRef.current;
        if (!currentStore || currentStore.insertionRefetchGaveUp.has(localId)) return undefined;
        let giveUpTimeoutId;
        const scheduleIframeFallback = (deadline)=>{
            giveUpTimeoutId = setTimeout(()=>{
                currentStore.insertionRefetchGaveUp.add(localId);
                forceUpdate();
            }, Math.max(0, deadline - Date.now()));
        };
        const startedAt = currentStore.insertionRefetchStartedAt.get(localId);
        if (startedAt !== undefined) {
            scheduleIframeFallback(startedAt + $689e73fff1c3c213$export$9a740f7442111961);
            return ()=>clearTimeout(giveUpTimeoutId);
        }
        let started = false;
        const startInsertionRefetch = ()=>{
            if (started) return;
            started = true;
            const firedAt = Date.now();
            currentStore.insertionRefetchStartedAt.set(localId, firedAt);
            ctx.triggerRefetch(localId, 'insertion');
            scheduleIframeFallback(firedAt + $689e73fff1c3c213$export$9a740f7442111961);
        };
        let fetchTimeoutId = setTimeout(startInsertionRefetch, $689e73fff1c3c213$export$428754a896652d4f);
        const removeDeferredRefetch = ctx.deferUntilDraftSync(localId, ()=>{
            clearTimeout(fetchTimeoutId);
            fetchTimeoutId = setTimeout(startInsertionRefetch, $689e73fff1c3c213$export$428754a896652d4f);
        });
        return ()=>{
            removeDeferredRefetch();
            clearTimeout(fetchTimeoutId);
            clearTimeout(giveUpTimeoutId);
        };
    }, [
        ctx,
        localId,
        isStatic,
        isEditing,
        isFullyLoaded,
        html,
        errorCode,
        forceUpdate
    ]);
    if (!ctx || !localId || !store) return renderIframe();
    if (isRefetching) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "small"
    }));
    if (html) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "forge-static-macro-content",
        dangerouslySetInnerHTML: {
            __html: html
        }
    });
    if (errorCode) return renderIframe();
     // Once the query is fully loaded, any macro without html/error is not a static macro → iframe.
    // Also fall back immediately if we KNOW this extension doesn't support staticView —
    // only treat !isStatic as definitive when extensions have actually been loaded.
    // If extensions aren't loaded yet, show spinner and wait (preloader may still be in-flight).
    const isAwaitingInsertedContent = isStatic && isEditing && !store.insertionRefetchGaveUp.has(localId);
    if ((store.fullyLoaded || extensionsLoaded && !isStatic) && !isAwaitingInsertedContent) return renderIframe();
     // Extension supports staticView but data hasn't arrived yet — show spinner briefly.
    // Use the same testid as the iframe loader so cc-puppeteer waits for it to disappear.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "forge-app-loading-spinner",
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "small"
    }));
}
module.exports["INSERTION_REFETCH_GIVE_UP_DELAY_MS"] = $689e73fff1c3c213$export$9a740f7442111961;
module.exports["createForgeMacroExtensionHandler"] = $689e73fff1c3c213$export$7914a38f4e6c4db9;

});

parcelRegister("1XIV5", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kcIQr = parcelRequire("kcIQr");

const $a0009ac6b88376d4$export$b3b7b4b4f7dc8ee9 = (0, $3u0dr.isReactCompilerActiveV2)() ? function useStaticMacroRenderAnalytics(t0) {
    const $ = (0, $bDgLe.c)(16);
    const { html: html, errorCode: errorCode, result: result, isEditing: isEditing, isLivePage: isLivePage } = t0;
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = new Set();
        $[0] = t1;
    } else t1 = $[0];
    const reportedResultVersionsRef = (0, $cozmU.useRef)(t1);
    let t2;
    let t3;
    if ($[1] !== createEvent || $[2] !== html || $[3] !== isEditing || $[4] !== isLivePage || $[5] !== result) {
        t2 = ()=>{
            if (!html || !result || reportedResultVersionsRef.current.has(result.version)) return;
            reportedResultVersionsRef.current.add(result.version);
            createEvent({
                type: "sendOperationalEvent",
                data: {
                    source: "forgeStaticMacro",
                    action: "rendered",
                    actionSubject: "staticMacro",
                    attributes: {
                        attempt: result.attempt,
                        renderMode: "static",
                        isEditing: isEditing,
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        };
        t3 = [
            createEvent,
            html,
            isEditing,
            isLivePage,
            result
        ];
        $[1] = createEvent;
        $[2] = html;
        $[3] = isEditing;
        $[4] = isLivePage;
        $[5] = result;
        $[6] = t2;
        $[7] = t3;
    } else {
        t2 = $[6];
        t3 = $[7];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[8] !== createEvent || $[9] !== errorCode || $[10] !== html || $[11] !== isEditing || $[12] !== isLivePage || $[13] !== result) {
        t4 = ()=>{
            if (!errorCode || html || !result || reportedResultVersionsRef.current.has(result.version)) return;
            reportedResultVersionsRef.current.add(result.version);
            createEvent({
                type: "sendOperationalEvent",
                data: {
                    source: "forgeStaticMacro",
                    action: "failed",
                    actionSubject: "staticMacro",
                    attributes: {
                        attempt: result.attempt,
                        renderMode: "iframe-fallback",
                        errorCode: errorCode,
                        isEditing: isEditing,
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        };
        t5 = [
            createEvent,
            errorCode,
            html,
            isEditing,
            isLivePage,
            result
        ];
        $[8] = createEvent;
        $[9] = errorCode;
        $[10] = html;
        $[11] = isEditing;
        $[12] = isLivePage;
        $[13] = result;
        $[14] = t4;
        $[15] = t5;
    } else {
        t4 = $[14];
        t5 = $[15];
    }
    (0, $cozmU.useEffect)(t4, t5);
} : function useStaticMacroRenderAnalytics({ html: html, errorCode: errorCode, result: result, isEditing: isEditing, isLivePage: isLivePage }) {
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const reportedResultVersionsRef = (0, $cozmU.useRef)(new Set());
    (0, $cozmU.useEffect)(()=>{
        if (!html || !result || reportedResultVersionsRef.current.has(result.version)) return;
        reportedResultVersionsRef.current.add(result.version);
        createEvent({
            type: 'sendOperationalEvent',
            data: {
                source: 'forgeStaticMacro',
                action: 'rendered',
                actionSubject: 'staticMacro',
                attributes: {
                    attempt: result.attempt,
                    renderMode: 'static',
                    isEditing: isEditing,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        createEvent,
        html,
        isEditing,
        isLivePage,
        result
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!errorCode || html || !result || reportedResultVersionsRef.current.has(result.version)) return;
        reportedResultVersionsRef.current.add(result.version);
        createEvent({
            type: 'sendOperationalEvent',
            data: {
                source: 'forgeStaticMacro',
                action: 'failed',
                actionSubject: 'staticMacro',
                attributes: {
                    attempt: result.attempt,
                    renderMode: 'iframe-fallback',
                    errorCode: errorCode,
                    isEditing: isEditing,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        createEvent,
        errorCode,
        html,
        isEditing,
        isLivePage,
        result
    ]);
};
module.exports["useStaticMacroRenderAnalytics"] = $a0009ac6b88376d4$export$b3b7b4b4f7dc8ee9;

});

parcelRegister("6m0us", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");

function $bc133074e939e7bd$var$createStaticMacroStore() {
    return {
        html: new Map(),
        errors: new Map(),
        resultMetadata: new Map(),
        nextResultVersion: 0,
        fullyLoaded: false,
        mountedLocalIds: new Set(),
        insertionRefetchStartedAt: new Map(),
        insertionRefetchGaveUp: new Set(),
        pendingDraftSyncCallbacks: new Map()
    };
}
/**
 * Builds a set of extensionKeys for Forge macro types that support staticView,
 * by reading the preloaded extensions from window.__SSR_FORGE_EXTENSIONS__.
 * An extension is considered static if it has a `static` property (e.g. `properties.static`).
 */ function $bc133074e939e7bd$var$buildStaticExtensionKeys() {
    const staticKeys = new Set();
    try {
        const extensions = window.__SSR_FORGE_EXTENSIONS__?.['xen:macro']?.extensions ?? [];
        for (const ext of extensions)if (ext?.properties?.static != null) staticKeys.add(ext.key);
    } catch  {
    // Defensive: if window access fails, return empty set (all macros fall back to iframe)
    }
    return staticKeys;
}
const $bc133074e939e7bd$var$StaticMacroStoreContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $bc133074e939e7bd$export$fe63a9c79eca4b07 = (0, $3u0dr.isReactCompilerActiveV2)() ? function StaticMacroStoreProvider(t0) {
    const $ = (0, $bDgLe.c)(18);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = $bc133074e939e7bd$var$createStaticMacroStore();
        $[0] = t1;
    } else t1 = $[0];
    const storeRef = (0, $cozmU.useRef)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = new Map();
        $[1] = t2;
    } else t2 = $[1];
    const listenersRef = (0, $cozmU.useRef)(t2);
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = new Set();
        $[2] = t3;
    } else t3 = $[2];
    const fullyLoadedListenersRef = (0, $cozmU.useRef)(t3);
    const getStaticExtensionKeys = $bc133074e939e7bd$var$_temp;
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (localId, cb)=>{
            const listeners = listenersRef.current;
            if (!listeners.has(localId)) listeners.set(localId, new Set());
            listeners.get(localId).add(cb);
            fullyLoadedListenersRef.current.add(cb);
            return ()=>{
                listeners.get(localId)?.delete(cb);
                fullyLoadedListenersRef.current.delete(cb);
            };
        };
        $[3] = t4;
    } else t4 = $[3];
    const subscribe = t4;
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (localId_0, html, options)=>{
            const store = storeRef.current;
            if (store.html.has(localId_0) && !options?.force) return;
            store.html.set(localId_0, html);
            if (options?.force) store.errors.delete(localId_0);
            store.nextResultVersion = store.nextResultVersion + 1;
            store.resultMetadata.set(localId_0, {
                attempt: options?.attempt ?? "initial",
                version: store.nextResultVersion
            });
            listenersRef.current.get(localId_0)?.forEach($bc133074e939e7bd$var$_temp2);
        };
        $[4] = t5;
    } else t5 = $[4];
    const register = t5;
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (localId_1, errorCode, options_0)=>{
            const store_0 = storeRef.current;
            if (store_0.errors.has(localId_1) && !options_0?.force) return;
            store_0.errors.set(localId_1, errorCode);
            if (options_0?.force) store_0.html.delete(localId_1);
            store_0.nextResultVersion = store_0.nextResultVersion + 1;
            store_0.resultMetadata.set(localId_1, {
                attempt: options_0?.attempt ?? "initial",
                version: store_0.nextResultVersion
            });
            listenersRef.current.get(localId_1)?.forEach($bc133074e939e7bd$var$_temp3);
        };
        $[5] = t6;
    } else t6 = $[5];
    const registerError = t6;
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>{
            storeRef.current.fullyLoaded = true;
            fullyLoadedListenersRef.current.forEach($bc133074e939e7bd$var$_temp4);
        };
        $[6] = t7;
    } else t7 = $[6];
    const markFullyLoaded = t7;
    let t8;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (extensionKey)=>getStaticExtensionKeys().has(extensionKey);
        $[7] = t8;
    } else t8 = $[7];
    const isStaticExtension = t8;
    let t9;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (localId_2)=>storeRef.current.mountedLocalIds.has(localId_2);
        $[8] = t9;
    } else t9 = $[8];
    const hasMountedBefore = t9;
    let t10;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = (localId_3)=>{
            storeRef.current.mountedLocalIds.add(localId_3);
        };
        $[9] = t10;
    } else t10 = $[9];
    const markMounted = t10;
    const refetchTriggerRef = (0, $cozmU.useRef)(null);
    let t11;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (localId_4, attempt)=>{
            refetchTriggerRef.current?.(localId_4, attempt);
        };
        $[10] = t11;
    } else t11 = $[10];
    const triggerRefetch = t11;
    let t12;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = (fn)=>{
            refetchTriggerRef.current = fn;
        };
        $[11] = t12;
    } else t12 = $[11];
    const setRefetchTrigger = t12;
    let t13;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = (localId_5, callback)=>{
            const callbacks = storeRef.current.pendingDraftSyncCallbacks;
            callbacks.set(localId_5, callback);
            return ()=>{
                if (callbacks.get(localId_5) === callback) callbacks.delete(localId_5);
            };
        };
        $[12] = t13;
    } else t13 = $[12];
    const deferUntilDraftSync = t13;
    let t14;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = ()=>{
            const callbacks_0 = Array.from(storeRef.current.pendingDraftSyncCallbacks.values());
            storeRef.current.pendingDraftSyncCallbacks.clear();
            callbacks_0.forEach($bc133074e939e7bd$var$_temp5);
        };
        $[13] = t14;
    } else t14 = $[13];
    const notifyDraftSyncCompleted = t14;
    let t15;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = {
            storeRef: storeRef,
            subscribe: subscribe,
            register: register,
            registerError: registerError,
            markFullyLoaded: markFullyLoaded,
            isStaticExtension: isStaticExtension,
            hasMountedBefore: hasMountedBefore,
            markMounted: markMounted,
            triggerRefetch: triggerRefetch,
            deferUntilDraftSync: deferUntilDraftSync,
            notifyDraftSyncCompleted: notifyDraftSyncCompleted,
            setRefetchTrigger: setRefetchTrigger
        };
        $[14] = t15;
    } else t15 = $[14];
    const contextValue = t15;
    let t16;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = (0, $9wGTI.fg)("conf_frontend_forge_static_macro_mvp") ? contextValue : null;
        $[15] = t16;
    } else t16 = $[15];
    let t17;
    if ($[16] !== children) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bc133074e939e7bd$var$StaticMacroStoreContext.Provider, {
            value: t16
        }, children);
        $[16] = children;
        $[17] = t17;
    } else t17 = $[17];
    return t17;
} : function StaticMacroStoreProvider({ children: children }) {
    const storeRef = (0, $cozmU.useRef)($bc133074e939e7bd$var$createStaticMacroStore());
    const listenersRef = (0, $cozmU.useRef)(new Map()); // localId -> listener callbacks
    const fullyLoadedListenersRef = (0, $cozmU.useRef)(new Set());
    const getStaticExtensionKeys = (0, $cozmU.useCallback)(()=>$bc133074e939e7bd$var$buildStaticExtensionKeys(), []);
    const subscribe = (0, $cozmU.useCallback)((localId, cb)=>{
        const listeners = listenersRef.current;
        if (!listeners.has(localId)) listeners.set(localId, new Set());
        listeners.get(localId).add(cb);
        fullyLoadedListenersRef.current.add(cb);
        return ()=>{
            listeners.get(localId)?.delete(cb);
            fullyLoadedListenersRef.current.delete(cb);
        };
    }, []);
    const register = (0, $cozmU.useCallback)((localId_0, html, options)=>{
        const store = storeRef.current;
        if (store.html.has(localId_0) && !options?.force) return;
        store.html.set(localId_0, html);
        // A forced (refetch) registration supersedes any previous error for this localId too.
        if (options?.force) store.errors.delete(localId_0);
        store.resultMetadata.set(localId_0, {
            attempt: options?.attempt ?? 'initial',
            version: store.nextResultVersion++
        });
        listenersRef.current.get(localId_0)?.forEach((cb_0)=>cb_0({
                type: 'static-macro-result'
            }));
    }, []);
    const registerError = (0, $cozmU.useCallback)((localId_1, errorCode, options_0)=>{
        const store_0 = storeRef.current;
        if (store_0.errors.has(localId_1) && !options_0?.force) return;
        store_0.errors.set(localId_1, errorCode);
        if (options_0?.force) store_0.html.delete(localId_1);
        store_0.resultMetadata.set(localId_1, {
            attempt: options_0?.attempt ?? 'initial',
            version: store_0.nextResultVersion++
        });
        listenersRef.current.get(localId_1)?.forEach((cb_1)=>cb_1({
                type: 'static-macro-result'
            }));
    }, []);
    const markFullyLoaded = (0, $cozmU.useCallback)(()=>{
        storeRef.current.fullyLoaded = true;
        fullyLoadedListenersRef.current.forEach((cb_2)=>cb_2({
                type: 'fully-loaded'
            }));
    }, []);
    const isStaticExtension = (0, $cozmU.useCallback)((extensionKey)=>getStaticExtensionKeys().has(extensionKey), [
        getStaticExtensionKeys
    ]);
    const hasMountedBefore = (0, $cozmU.useCallback)((localId_2)=>storeRef.current.mountedLocalIds.has(localId_2), []);
    const markMounted = (0, $cozmU.useCallback)((localId_3)=>{
        storeRef.current.mountedLocalIds.add(localId_3);
    }, []);
    const refetchTriggerRef = (0, $cozmU.useRef)(null);
    const triggerRefetch = (0, $cozmU.useCallback)((localId_4, attempt)=>{
        refetchTriggerRef.current?.(localId_4, attempt);
    }, []);
    const setRefetchTrigger = (0, $cozmU.useCallback)((fn)=>{
        refetchTriggerRef.current = fn;
    }, []);
    const deferUntilDraftSync = (0, $cozmU.useCallback)((localId_5, callback)=>{
        const callbacks = storeRef.current.pendingDraftSyncCallbacks;
        callbacks.set(localId_5, callback);
        return ()=>{
            if (callbacks.get(localId_5) === callback) callbacks.delete(localId_5);
        };
    }, []);
    const notifyDraftSyncCompleted = (0, $cozmU.useCallback)(()=>{
        const callbacks_0 = Array.from(storeRef.current.pendingDraftSyncCallbacks.values());
        storeRef.current.pendingDraftSyncCallbacks.clear();
        callbacks_0.forEach((callback_0)=>callback_0());
    }, []);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            storeRef: storeRef,
            subscribe: subscribe,
            register: register,
            registerError: registerError,
            markFullyLoaded: markFullyLoaded,
            isStaticExtension: isStaticExtension,
            hasMountedBefore: hasMountedBefore,
            markMounted: markMounted,
            triggerRefetch: triggerRefetch,
            deferUntilDraftSync: deferUntilDraftSync,
            notifyDraftSyncCompleted: notifyDraftSyncCompleted,
            setRefetchTrigger: setRefetchTrigger
        }), [
        storeRef,
        subscribe,
        register,
        registerError,
        markFullyLoaded,
        isStaticExtension,
        hasMountedBefore,
        markMounted,
        triggerRefetch,
        deferUntilDraftSync,
        notifyDraftSyncCompleted,
        setRefetchTrigger
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bc133074e939e7bd$var$StaticMacroStoreContext.Provider, {
        value: (0, $9wGTI.fg)('conf_frontend_forge_static_macro_mvp') ? contextValue : null
    }, children);
};
function $bc133074e939e7bd$var$_temp5(callback_0) {
    return callback_0();
}
function $bc133074e939e7bd$var$_temp4(cb_2) {
    return cb_2({
        type: "fully-loaded"
    });
}
function $bc133074e939e7bd$var$_temp3(cb_1) {
    return cb_1({
        type: "static-macro-result"
    });
}
function $bc133074e939e7bd$var$_temp2(cb_0) {
    return cb_0({
        type: "static-macro-result"
    });
}
function $bc133074e939e7bd$var$_temp() {
    return $bc133074e939e7bd$var$buildStaticExtensionKeys();
}
const $bc133074e939e7bd$export$ae4400d9e980652e = (0, $3u0dr.isReactCompilerActiveV2)() ? function useStaticMacroStoreContext() {
    return (0, $cozmU.useContext)($bc133074e939e7bd$var$StaticMacroStoreContext);
} : function useStaticMacroStoreContext() {
    return (0, $cozmU.useContext)($bc133074e939e7bd$var$StaticMacroStoreContext);
};
const $bc133074e939e7bd$export$519dc241c1a942d0 = (0, $3u0dr.isReactCompilerActiveV2)() ? function ResetStaticMacroStoreContext(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bc133074e939e7bd$var$StaticMacroStoreContext.Provider, {
            value: null
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function ResetStaticMacroStoreContext({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bc133074e939e7bd$var$StaticMacroStoreContext.Provider, {
        value: null
    }, children);
};
module.exports["StaticMacroStoreProvider"] = $bc133074e939e7bd$export$fe63a9c79eca4b07;
module.exports["useStaticMacroStoreContext"] = $bc133074e939e7bd$export$ae4400d9e980652e;
module.exports["ResetStaticMacroStoreContext"] = $bc133074e939e7bd$export$519dc241c1a942d0;

});

parcelRegister("id4ij", function(module, exports) {
function $21c1903a8ac50cbe$export$f25538161b7e9c17(element) {
    let top = element.offsetTop;
    while(element.offsetParent){
        element = element.offsetParent;
        top += element.offsetTop;
    }
    return top;
}
function $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container) {
    if (!element) return false;
    container = container || // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.scrollingElement || // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.body.parentNode;
    if (!container) return false;
    const height = element.offsetHeight;
    const top = $21c1903a8ac50cbe$export$f25538161b7e9c17(element);
    const containerTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(container) + container.scrollTop;
    const containerHeight = container.offsetHeight;
    return top >= containerTop && top + height <= containerTop + containerHeight;
}
function $21c1903a8ac50cbe$export$e41e80160bed5714(node) {
    // @ts-ignore
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (!node || node === document) return null;
    const nodeStyle = window.getComputedStyle(node);
    if (node.scrollHeight > node.clientHeight && node.style.overflow !== 'hidden' && nodeStyle.overflow !== 'visible') return node;
    else return $21c1903a8ac50cbe$export$e41e80160bed5714(node.parentNode);
}
function $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2(element, container) {
    container = container || $21c1903a8ac50cbe$export$e41e80160bed5714(element);
    if (!element || !container || $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container)) return;
    container.scrollTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(element) - $21c1903a8ac50cbe$export$f25538161b7e9c17(container) - container.clientHeight / 2;
}
function $21c1903a8ac50cbe$export$abe5643cba19555f(element) {
    return element.getBoundingClientRect();
}
function $21c1903a8ac50cbe$export$4c0864c7defafad3(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top, bottom: bottom } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    const bottomIsVisible = 0 <= bottom && bottom <= viewportHeight;
    const isBiggerThanViewPort = top <= 0 && 0 <= bottom && bottom >= viewportHeight;
    return topIsVisible || bottomIsVisible || isBiggerThanViewPort;
}
function $21c1903a8ac50cbe$export$4acade851e875ad4(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    return topIsVisible;
}
function $21c1903a8ac50cbe$export$5513bf0589d602a4(targetDomElementId, htmlMarkup) {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    let el = document.getElementById(targetDomElementId);
    if (!el) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        el = document.createElement('div');
        el.setAttribute('id', targetDomElementId);
        el.setAttribute('style', 'display: none');
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.body.appendChild(el);
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        el = document.getElementById(targetDomElementId);
    }
    if (!el) return;
    el.innerHTML = '';
    if (htmlMarkup) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const range = document.createRange();
        const fragment = range.createContextualFragment(htmlMarkup);
        el.appendChild(fragment);
    }
}
module.exports["getElementTop"] = $21c1903a8ac50cbe$export$f25538161b7e9c17;
module.exports["isElementInViewport"] = $21c1903a8ac50cbe$export$7cc0e9dd2435cb30;
module.exports["scrollElementToViewCenter"] = $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2;
module.exports["getElementBounds"] = $21c1903a8ac50cbe$export$abe5643cba19555f;
module.exports["isPartOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4c0864c7defafad3;
module.exports["isTopOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4acade851e875ad4;
module.exports["replaceDomElementContent"] = $21c1903a8ac50cbe$export$5513bf0589d602a4;

});

parcelRegister("2HGN8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $hYoU4 = parcelRequire("hYoU4");


var $8VcPj = parcelRequire("8VcPj");


var $1d2ww = parcelRequire("1d2ww");

const $652df36b21c46ede$var$ContentAppearanceContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    contentAppearance: {
        appearance: (0, $1d2ww.ContentAppearanceType).DEFAULT,
        version: 0
    },
    setContentAppearance: ()=>{},
    contentAppearanceLoading: false
});
const $652df36b21c46ede$export$53c04435be7a0acf = ({ contentId: contentId, children: children })=>{
    const [contentAppearanceOverride, setContentAppearanceOverride] = (0, $cozmU.useState)();
    // Clear the override state when navigating to a different page
    (0, $cozmU.useEffect)(()=>{
        setContentAppearanceOverride(undefined);
    }, [
        contentId
    ]);
    const [{ collabEditProvider: collabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    // Subscribe to metadata:changed events to update the content appearance for collaborators
    (0, $cozmU.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleMetadataChanged = (metadata)=>{
            const editorWidth = metadata?.editorWidth;
            const widthValue = editorWidth?.value;
            const version = editorWidth?.version;
            if (widthValue && version !== undefined) setContentAppearanceOverride((currentAppearance)=>{
                if (!currentAppearance || version > currentAppearance.version) return {
                    appearance: widthValue,
                    version: version
                };
                else return currentAppearance;
            });
        };
        collabEditProvider.on('metadata:changed', handleMetadataChanged);
        return ()=>{
            collabEditProvider.off('metadata:changed', handleMetadataChanged);
        };
    }, [
        collabEditProvider
    ]);
    /*
  	Previous check was:
  	const draftAppearanceQuery = getContentAppearanceQuery(ContentAppearancePropertyKey.DRAFT);
  	which always returns contentAppearanceQuery
  */ const { data: initialContentAppearanceData, loading: initialContentAppearanceLoading } = (0, $jMyy4.useQueryInterop)((0, $8VcPj.contentAppearanceQuery), {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ]
        },
        __callerPackage__: "content-appearance"
    });
    const context = (0, $cozmU.useMemo)(()=>{
        const initialContentAppearance = (0, $8VcPj.getContentAppearanceFromQueryData)(initialContentAppearanceData, (0, $1d2ww.ContentAppearancePropertyKey).DRAFT);
        // Under certain circumstances due to a previous bug with the content appearance during legacy editor autoconvert, an incorrect value may have been sent to collab service.
        // In this circumstance favour the initial content appearance value.
        const shouldUseInitial = contentAppearanceOverride && initialContentAppearance && contentAppearanceOverride.version === initialContentAppearance.version && contentAppearanceOverride.appearance !== initialContentAppearance.appearance;
        return {
            contentAppearance: shouldUseInitial ? initialContentAppearance : contentAppearanceOverride || initialContentAppearance,
            setContentAppearance: setContentAppearanceOverride,
            contentAppearanceLoading: initialContentAppearanceLoading
        };
    }, [
        initialContentAppearanceData,
        initialContentAppearanceLoading,
        contentAppearanceOverride
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($652df36b21c46ede$var$ContentAppearanceContext.Provider, {
        value: context
    }, children);
};
const $652df36b21c46ede$export$c3c73be39a08fc97 = ({ children: children })=>{
    const context = $652df36b21c46ede$export$4cedbdf2fdf3340d();
    return children(context);
};
const $652df36b21c46ede$export$4cedbdf2fdf3340d = ()=>{
    return (0, $cozmU.useContext)($652df36b21c46ede$var$ContentAppearanceContext);
};
module.exports["ContentAppearanceContextProvider"] = $652df36b21c46ede$export$53c04435be7a0acf;
module.exports["ContentAppearanceContextConsumer"] = $652df36b21c46ede$export$c3c73be39a08fc97;
module.exports["useContentAppearance"] = $652df36b21c46ede$export$4cedbdf2fdf3340d;

});

parcelRegister("2zdC2", function(module, exports) {
"use strict";
var $1de968d0bde0a175$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $zAMIg = parcelRequire("zAMIg");

/**
 * Emits a value from the source Observable only after a particular time span
 * has passed without another source emission.
 *
 * <span class="informal">It's like {@link delay}, but passes only the most
 * recent value from each burst of emissions.</span>
 *
 * <img src="./img/debounceTime.png" width="100%">
 *
 * `debounceTime` delays values emitted by the source Observable, but drops
 * previous pending delayed emissions if a new value arrives on the source
 * Observable. This operator keeps track of the most recent value from the
 * source Observable, and emits that only when `dueTime` enough time has passed
 * without any other value appearing on the source Observable. If a new value
 * appears before `dueTime` silence occurs, the previous value will be dropped
 * and will not be emitted on the output Observable.
 *
 * This is a rate-limiting operator, because it is impossible for more than one
 * value to be emitted in any time window of duration `dueTime`, but it is also
 * a delay-like operator since output emissions do not occur at the same time as
 * they did on the source Observable. Optionally takes a {@link IScheduler} for
 * managing timers.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounceTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} dueTime The timeout duration in milliseconds (or the time
 * unit determined internally by the optional `scheduler`) for the window of
 * time required to wait for emission silence before emitting the most recent
 * source value.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the timeout for each value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified `dueTime`, and may drop some values if they occur
 * too frequently.
 * @method debounceTime
 * @owner Observable
 */ function $1de968d0bde0a175$var$debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = $zAMIg.async;
    return function(source) {
        return source.lift(new $1de968d0bde0a175$var$DebounceTimeOperator(dueTime, scheduler));
    };
}
module.exports.debounceTime = $1de968d0bde0a175$var$debounceTime;
var $1de968d0bde0a175$var$DebounceTimeOperator = function() {
    function DebounceTimeOperator(dueTime, scheduler) {
        this.dueTime = dueTime;
        this.scheduler = scheduler;
    }
    DebounceTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $1de968d0bde0a175$var$DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
    };
    return DebounceTimeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1de968d0bde0a175$var$DebounceTimeSubscriber = function(_super) {
    $1de968d0bde0a175$var$__extends(DebounceTimeSubscriber, _super);
    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
        _super.call(this, destination);
        this.dueTime = dueTime;
        this.scheduler = scheduler;
        this.debouncedSubscription = null;
        this.lastValue = null;
        this.hasValue = false;
    }
    DebounceTimeSubscriber.prototype._next = function(value) {
        this.clearDebounce();
        this.lastValue = value;
        this.hasValue = true;
        this.add(this.debouncedSubscription = this.scheduler.schedule($1de968d0bde0a175$var$dispatchNext, this.dueTime, this));
    };
    DebounceTimeSubscriber.prototype._complete = function() {
        this.debouncedNext();
        this.destination.complete();
    };
    DebounceTimeSubscriber.prototype.debouncedNext = function() {
        this.clearDebounce();
        if (this.hasValue) {
            this.destination.next(this.lastValue);
            this.lastValue = null;
            this.hasValue = false;
        }
    };
    DebounceTimeSubscriber.prototype.clearDebounce = function() {
        var debouncedSubscription = this.debouncedSubscription;
        if (debouncedSubscription !== null) {
            this.remove(debouncedSubscription);
            debouncedSubscription.unsubscribe();
            this.debouncedSubscription = null;
        }
    };
    return DebounceTimeSubscriber;
}($fNVRJ.Subscriber);
function $1de968d0bde0a175$var$dispatchNext(subscriber) {
    subscriber.debouncedNext();
} //# sourceMappingURL=debounceTime.js.map

});

parcelRegister("dmKyV", function(module, exports) {
$parcel$export(module.exports, "WRM", () => (parcelRequire("1UB3e")).default);
$parcel$export(module.exports, "withWRMDependencies", () => (parcelRequire("6u5YI")).default);

var $1UB3e = parcelRequire("1UB3e");


var $6u5YI = parcelRequire("6u5YI");


});

parcelRegister("1UB3e", function(module, exports) {

var $cpjd2 = parcelRequire("cpjd2");

/**
 * ========================================================
 * DEPRECATED, DO NOT MOVE THIS FILE TO NEXT.
 * Refactor your component to use @confluence/wrm directly.
 * ========================================================
 */ const $1647c2fd90c2cc68$var$WRM = {
    require (dependencies, callback) {
        return new Promise((resolve)=>{
            (0, $cpjd2.requireLegacyWRM)(dependencies, (modules)=>{
                resolve(modules);
                if (callback) callback(modules);
            }, ()=>{});
        });
    }
};
var $1647c2fd90c2cc68$export$2e2bcd8739ae039 = $1647c2fd90c2cc68$var$WRM;
module.exports["default"] = $1647c2fd90c2cc68$export$2e2bcd8739ae039;

});

parcelRegister("6u5YI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cpjd2 = parcelRequire("cpjd2");

/**
 * ========================================================
 * DEPRECATED, DO NOT MOVE THIS FILE TO NEXT.
 * Refactor your component to use @confluence/wrm directly.
 * ========================================================
 *
 * withWRMDependencies is a decorator for loading WRM dependencies.
 *
 * It's a helper which besides loading dependencies will also hide the component
 * while the dependencies are not loaded avoiding FOUC and weird behaviours.
 *
 * usage:
 *
 * withWRMDependencies('wr!mypluginkey')(
 *  class MyComponent extends Component {}
 * )
 *
 * or
 *
 * withWRMDependencies(['wrc!myContext', 'wr!myWebResource'])(
 *  class MyComponent extends Component {}
 * )
 */ function $4b8a2e9a57493429$var$withWRMDependencies(dependencies, options) {
    const configs = {
        isBlocking: true,
        ...options
    };
    return (BaseComponent)=>{
        class WRMComponent extends (0, $cozmU.Component) {
            componentDidMount() {
                this.mounted = true;
                if (dependencies && dependencies.length > 0) (0, $cpjd2.requireLegacyWRM)(dependencies, this.markAsLoaded, ()=>{});
                else this.markAsLoaded();
            }
            componentWillUnmount() {
                this.mounted = false;
            }
            render() {
                const { dependenciesLoaded: dependenciesLoaded } = this.state;
                if (dependenciesLoaded || !configs.isBlocking) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BaseComponent, {
                    ...this.props,
                    wrmDependenciesLoaded: dependenciesLoaded
                });
                else return null;
            }
            constructor(...args){
                super(...args);
                this.state = {
                    dependenciesLoaded: false
                };
                this.markAsLoaded = ()=>{
                    if (this.mounted) this.setState({
                        dependenciesLoaded: true
                    });
                };
            }
        }
        WRMComponent.displayName = `WRMComponent(${BaseComponent.displayName || BaseComponent.name})`;
        return WRMComponent;
    };
}
var $4b8a2e9a57493429$export$2e2bcd8739ae039 = $4b8a2e9a57493429$var$withWRMDependencies;
module.exports["default"] = $4b8a2e9a57493429$export$2e2bcd8739ae039;

});

parcelRegister("fBjVq", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $3141cf32c54bf764$var$RendererLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AfRhk",
    // Name needs to match the one in next/packages/view-page/src/index.ts
    name: "ClassicRendererLoader",
    loader: ()=>(parcelRequire("gCdbQ"))
});
var $3141cf32c54bf764$export$2e2bcd8739ae039 = $3141cf32c54bf764$var$RendererLoader;
module.exports["default"] = $3141cf32c54bf764$export$2e2bcd8739ae039;

});

parcelRegister("gCdbQ", function(module, exports) {

let $c18a6d3a588f163a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c18a6d3a588f163a$var$load("kT6dz"),
    $c18a6d3a588f163a$var$load("cL90P"),
    $c18a6d3a588f163a$var$load("fob67"),
    $c18a6d3a588f163a$var$load("hUbK8"),
    $c18a6d3a588f163a$var$load("6Qybl"),
    $c18a6d3a588f163a$var$load("fxlto"),
    $c18a6d3a588f163a$var$load("2F69B"),
    $c18a6d3a588f163a$var$load("53Y0O"),
    $c18a6d3a588f163a$var$load("kYlwR"),
    $c18a6d3a588f163a$var$load("1tqsw"),
    $c18a6d3a588f163a$var$load("9cVML"),
    $c18a6d3a588f163a$var$load("aGpvE"),
    $c18a6d3a588f163a$var$load("fqrmE"),
    $c18a6d3a588f163a$var$load("7SteV"),
    $c18a6d3a588f163a$var$load("eNgZ8"),
    $c18a6d3a588f163a$var$load("lAHCT"),
    $c18a6d3a588f163a$var$load("b5lq6"),
    $c18a6d3a588f163a$var$load("hs6P3"),
    $c18a6d3a588f163a$var$load("k8nz9"),
    $c18a6d3a588f163a$var$load("a9LoI"),
    $c18a6d3a588f163a$var$load("8MaGw"),
    $c18a6d3a588f163a$var$load("ksOjm"),
    $c18a6d3a588f163a$var$load("jAsJw"),
    $c18a6d3a588f163a$var$load("eUsnQ"),
    $c18a6d3a588f163a$var$load("jisiR"),
    $c18a6d3a588f163a$var$load("icVON"),
    $c18a6d3a588f163a$var$load("bPC3R"),
    $c18a6d3a588f163a$var$load("bHb1X"),
    $c18a6d3a588f163a$var$load("90SZm"),
    $c18a6d3a588f163a$var$load("crfrC"),
    $c18a6d3a588f163a$var$load("4x9Jx"),
    $c18a6d3a588f163a$var$load("7gL7H"),
    $c18a6d3a588f163a$var$load("ea3NB"),
    $c18a6d3a588f163a$var$load("6wr18"),
    $c18a6d3a588f163a$var$load("59hV4"),
    $c18a6d3a588f163a$var$load("aNyWk"),
    $c18a6d3a588f163a$var$load("gSKF7"),
    $c18a6d3a588f163a$var$load("dtNxV"),
    $c18a6d3a588f163a$var$load("iTOzX"),
    $c18a6d3a588f163a$var$load("ipkwd"),
    $c18a6d3a588f163a$var$load("a7sEM"),
    $c18a6d3a588f163a$var$load("aLbuU"),
    $c18a6d3a588f163a$var$load("ffEVr"),
    $c18a6d3a588f163a$var$load("8Jd6S"),
    $c18a6d3a588f163a$var$load("4Gdnz"),
    $c18a6d3a588f163a$var$load("4UAag"),
    $c18a6d3a588f163a$var$load("zUKwV"),
    $c18a6d3a588f163a$var$load("fUeur"),
    $c18a6d3a588f163a$var$load("1sii7"),
    $c18a6d3a588f163a$var$load("6gMrU"),
    $c18a6d3a588f163a$var$load("iECXC"),
    $c18a6d3a588f163a$var$load("Wowvf"),
    $c18a6d3a588f163a$var$load("4g6rd"),
    $c18a6d3a588f163a$var$load("fq1gG"),
    $c18a6d3a588f163a$var$load("fWCBZ"),
    $c18a6d3a588f163a$var$load("5sZTx"),
    $c18a6d3a588f163a$var$load("deTdD"),
    $c18a6d3a588f163a$var$load("1JeTB"),
    $c18a6d3a588f163a$var$load("4UHov"),
    $c18a6d3a588f163a$var$load("hhss7"),
    $c18a6d3a588f163a$var$load("cWL7t"),
    $c18a6d3a588f163a$var$load("gbJtu"),
    $c18a6d3a588f163a$var$load("86OhX"),
    $c18a6d3a588f163a$var$load("7EorR"),
    $c18a6d3a588f163a$var$load("8CeYz")
]).then(()=>parcelRequire('djmKw'));

});

parcelRegister("lvcLD", function(module, exports) {
/* recommendation.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $cXtTj = parcelRequire("cXtTj");


var $7Px0t = parcelRequire("7Px0t");


var $eN31l = parcelRequire("eN31l");


var $bGVJw = parcelRequire("bGVJw");


var $b5YqG = parcelRequire("b5YqG");

parcelRequire("63sT2");
var $8NccQ = parcelRequire("8NccQ");

parcelRequire("kgHuu");
var $3qdJ0 = parcelRequire("3qdJ0");


var $9SeNW = parcelRequire("9SeNW");


var $6a9Mm = parcelRequire("6a9Mm");


var $7NHN3 = parcelRequire("7NHN3");


var $9ME8P = parcelRequire("9ME8P");


var $5ovkh = parcelRequire("5ovkh");


var $e9abE = parcelRequire("e9abE");


var $6BjHJ = parcelRequire("6BjHJ");


var $jNuZJ = parcelRequire("jNuZJ");


var $kSwu1 = parcelRequire("kSwu1");


var $6vvuE = parcelRequire("6vvuE");

const $d5ce83d27bea3823$var$CROSS_FLOW_SOURCE_COMPONENT = 'atlassian-switcher';
const $d5ce83d27bea3823$var$CROSS_FLOW_SOURCE_CONTEXT = 'try';
const $d5ce83d27bea3823$var$JSMGROWTH_462_EXPERIMENT_KEY = 'jsmgrowth_462_improve_switcher_signups_v2';
const $d5ce83d27bea3823$var$LOOM_HAMS_ID = 'loom'; /*--body--*/ 
const $d5ce83d27bea3823$var$bodyPositioningStyles = null;
const $d5ce83d27bea3823$var$BodyTitle = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2mHwu81Y8M _4ya3eEEbN9 _1kk5Tk3fRC _3138421Y8M _4ouGXIdnbC _26BoRwey7F _1UtDYzy7kJ _3iDTPbQ4SZ _0hPCNLchRC",
            __cmplp.className
        ])
    });
});
const $d5ce83d27bea3823$var$BodyTitleName = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _39HuIbz8Lp _1ANEUSLRg7 _4ouGXIdnbC _1EqgXlE6Kk",
            __cmplp.className
        ])
    });
});
const $d5ce83d27bea3823$var$BodyTitleLozenge = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3YEZNOdnbC",
            __cmplp.className
        ])
    });
});
const $d5ce83d27bea3823$var$BodyDescription = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isInWacContext: isInWacContext, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $8aG6j.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_11a2nkr": (0, $9aYkv.default)(__cmplp.isInWacContext ? "var(--ds-space-025, 2px)" : "var(--ds-space-050, 4px)"),
            "--_ei4eat": (0, $9aYkv.default)(__cmplp.isInWacContext ? '12px' : '11px')
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _2sNsIg7NXe _313842tvno _39HuIbz8Lp _1ANEUSLRg7 _1UtDYzKGUX _26BoRw5zaO _4ya3eEJ1vw",
            __cmplp.className
        ])
    });
});
const $d5ce83d27bea3823$export$4b2c32e08f77ff18 = ({ name: name, description: description, lozenge: lozenge })=>{
    const isInWacContext = (0, $6a9Mm.useIsWacContext)();
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1kk5Tk3fRC _3iDTPbQ4SZ _0aFT5vbt8w"
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)($d5ce83d27bea3823$var$BodyTitle, {
                isInWacContext: isInWacContext,
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)($d5ce83d27bea3823$var$BodyTitleName, {
                        children: name
                    }),
                    lozenge && /*#__PURE__*/ (0, $8aG6j.jsx)($d5ce83d27bea3823$var$BodyTitleLozenge, {
                        children: lozenge
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)($d5ce83d27bea3823$var$BodyDescription, {
                isInWacContext: isInWacContext,
                children: description
            })
        ]
    });
};
const $d5ce83d27bea3823$var$logoPositioningStyles = null;
const $d5ce83d27bea3823$var$LogoContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasShadow: hasShadow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $8aG6j.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_e05ckt": (0, $9aYkv.default)(__cmplp.hasShadow ? "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)" : undefined)
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _39xV02Va5s _0jFU0VVa5s _24h04i2Njc _0KLXruDMqu _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _2OUyjtNONO",
            __cmplp.className
        ])
    });
});
const $d5ce83d27bea3823$var$logoImageStyles = null;
const $d5ce83d27bea3823$var$RecommendationLogo = ({ Logo: Logo })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        className: (0, $hekY6.default)([
            "_0adFHs2ADO _3iDTPbQ4SZ _0hPCNLDIqT"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($d5ce83d27bea3823$var$LogoContainer, {
            hasShadow: false,
            children: typeof Logo === 'string' ? /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
                src: Logo,
                alt: "",
                className: (0, $hekY6.default)([
                    "_39xV02Va5s _0jFU0VVa5s"
                ])
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)(Logo, {
                appearance: "brand",
                size: "medium"
            })
        })
    });
}; /*--recommendation--*/ 
const $d5ce83d27bea3823$var$recommendationPositioningStyles = null;
const $d5ce83d27bea3823$var$recommendationContainerStyles = null;
const $d5ce83d27bea3823$var$recommendationContainerWithHoverStyles = null;
const $d5ce83d27bea3823$export$28bbc8e042015ff9 = ({ app: app, onDismissed: onDismissed, onClick: onClick, extraAnalyticsAttributes: extraAnalyticsAttributes, lozenge: lozenge })=>{
    // This is to handle a specific design requirement to hightlight the dropdown on hover
    // Couldn't work out how to do this in css, so its js :(
    const crossFlow = (0, $8NccQ.useCrossFlow)();
    const { messageClicked: messageClicked } = (0, $9ME8P.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $7NHN3.useMessageInstanceEvent)();
    const { fireInteractedUIEvent: fireCrossFlowInteractedUIEvent } = (0, $b5YqG.useFireCrossFlowAnalyticsEvents)();
    const isInWacContext = (0, $6a9Mm.useIsWacContext)();
    const { isSiteAdmin: isSiteAdmin, tenantId: tenantId } = (0, $bGVJw.usePostOfficeContext)();
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const [isLoomInterceptModalOpen, setIsLoomInterceptModalOpen] = (0, $cozmU.useState)(false);
    const isJsmOrJpdRecommendation = app.hamsIdentifier === (0, $3qdJ0.Targets).JIRA_SERVICE_DESK || app.hamsIdentifier === (0, $3qdJ0.Targets).JIRA_PRODUCT_DISCOVERY;
    const isSwitcherSignupModalVariation = isSiteAdmin && isJsmOrJpdRecommendation && (0, $cXtTj.default).getExperimentValue($d5ce83d27bea3823$var$JSMGROWTH_462_EXPERIMENT_KEY, 'isEnabled', false, {
        fireExperimentExposure: false
    });
    const crossFlowModalContextParams = (0, $cozmU.useMemo)(()=>(0, $jNuZJ.getProjectCreationContextParams)({
            targetProduct: app.hamsIdentifier,
            templateKey: app.templateKey,
            formatMessage: formatMessage
        }), [
        app.hamsIdentifier,
        app.templateKey,
        formatMessage
    ]);
    const handleInstallApp = (0, $cozmU.useCallback)(async ()=>{
        await messageClicked();
        await messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'recommendation',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'acknowledge'
            },
            additionalMetadataFromFrontend: {}
        });
        fireCrossFlowInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'listItem',
            actionSubjectId: 'product'
        }, {
            source: 'atlassianSwitcherDiscoverProductsSection',
            targetProductId: app.ccpProductId
        }, {
            ...extraAnalyticsAttributes,
            isSiteAdmin: isSiteAdmin
        });
        if (onClick) {
            onClick();
            return;
        }
        if (isSiteAdmin && isJsmOrJpdRecommendation) (0, $cXtTj.default).manuallyLogExperimentExposure($d5ce83d27bea3823$var$JSMGROWTH_462_EXPERIMENT_KEY);
        if (isSwitcherSignupModalVariation) return;
        const crossFlowProps = {
            journey: (0, $6vvuE.getJourney)(app),
            targetProduct: app.hamsIdentifier,
            sourceComponent: $d5ce83d27bea3823$var$CROSS_FLOW_SOURCE_COMPONENT,
            sourceContext: $d5ce83d27bea3823$var$CROSS_FLOW_SOURCE_CONTEXT,
            ...app.extensions ? {
                extensions: app.extensions
            } : {},
            ...extraAnalyticsAttributes ? {
                extraAnalyticsAttributes: extraAnalyticsAttributes
            } : {}
        };
        if (isInWacContext) crossFlowProps.extraAnalyticsAttributes = {
            ...crossFlowProps.extraAnalyticsAttributes ?? {},
            flagKey: 'wac_switcher_recommendations',
            cohort: 'experiment'
        };
        if (crossFlow.isEnabled) {
            const { sourceComponent: sourceComponent } = crossFlowProps;
            const targetProduct = app.hamsIdentifier;
            const isLoomInterceptEnabled = sourceComponent === 'atlassian-switcher' && targetProduct === $d5ce83d27bea3823$var$LOOM_HAMS_ID && !!tenantId;
            if (isLoomInterceptEnabled) setIsLoomInterceptModalOpen(true);
            else crossFlow.api.open({
                ...crossFlowProps
            });
        }
    }, [
        app,
        crossFlow,
        fireCrossFlowInteractedUIEvent,
        isInWacContext,
        messageClicked,
        messageInstanceClicked,
        onClick,
        isSiteAdmin,
        extraAnalyticsAttributes,
        isSwitcherSignupModalVariation,
        isJsmOrJpdRecommendation,
        tenantId
    ]); // Button content shared between both cohorts
    const buttonContent = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)($d5ce83d27bea3823$var$RecommendationLogo, {
                Logo: app.logo
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)($d5ce83d27bea3823$export$4b2c32e08f77ff18, {
                name: app.appName,
                lozenge: app.appNameLozenge,
                description: app.description
            })
        ]
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("li", {
            "data-testid": "recommendation-list-item",
            className: (0, $hekY6.default)([
                "_2mHwu8FQfX _2XghbEPgdg _3iDTPbQ4SZ _39xV02N91d _0pI6nMFlnN _37wbyuz9WS _0jFU0Vp0Oa _0hPCNLDIqT _4fJQwjOLYo",
                "_23rrnHSHWv _0Am33zKxmn _1eOmH6o126"
            ]),
            children: [
                isSwitcherSignupModalVariation ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $e9abE.FullScreenModalTrigger), {
                    entryPoint: (0, $6BjHJ.crossFlowModalEntryPoint),
                    entryPointParams: {},
                    entryPointProps: {
                        sourceComponent: $d5ce83d27bea3823$var$CROSS_FLOW_SOURCE_COMPONENT,
                        sourceContext: $d5ce83d27bea3823$var$CROSS_FLOW_SOURCE_CONTEXT,
                        targetProduct: app.hamsIdentifier,
                        shouldRedirectOnSuccess: true,
                        fakeBackground: 'jira',
                        contextParams: crossFlowModalContextParams,
                        width: (0, $5ovkh.CROSS_FLOW_MODAL_WIDTH),
                        height: (0, $5ovkh.CROSS_FLOW_MODAL_HEIGHT)
                    },
                    modalProps: {
                        shouldCloseOnEscapePress: true
                    },
                    children: ({ ref: ref })=>/*#__PURE__*/ (0, $8aG6j.jsx)("button", {
                            ...ref && {
                                ref: ref
                            },
                            onClick: handleInstallApp,
                            className: (0, $hekY6.default)([
                                "_0bjKvDzXzM _2uo31fYbGa _30huDKYbGa _4FKVYE3NPf _2fwxA5ecOK _3iDTPbQ4SZ _2O5Vij7dHp _0KLXrujOvk _26BoRw70UD _0hPCNLFlnN _4ouGXIdnbC _1UtDYzy7kJ _2xIroYnXvL _0jFU0Vp0Oa _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0ReiIH7zJH _1eOmH666of _0clgaMy7kJ"
                            ]),
                            children: buttonContent
                        })
                }) : /*#__PURE__*/ (0, $8aG6j.jsx)("button", {
                    onClick: handleInstallApp,
                    className: (0, $hekY6.default)([
                        "_0bjKvDzXzM _2uo31fYbGa _30huDKYbGa _4FKVYE3NPf _2fwxA5ecOK _3iDTPbQ4SZ _2O5Vij7dHp _0KLXrujOvk _26BoRw70UD _0hPCNLFlnN _4ouGXIdnbC _1UtDYzy7kJ _2xIroYnXvL _0jFU0Vp0Oa _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0ReiIH7zJH _1eOmH666of _0clgaMy7kJ"
                    ]),
                    children: buttonContent
                }),
                lozenge ? lozenge : null,
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9SeNW.RecommendationControls), {
                    app: app,
                    onDismissed: onDismissed,
                    additionalAnalyticsAttributes: extraAnalyticsAttributes,
                    iconSize: 'medium'
                }),
                isLoomInterceptModalOpen && tenantId && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eN31l.default), {
                    cloudId: tenantId,
                    locale: locale,
                    onClose: ()=>setIsLoomInterceptModalOpen(false),
                    sourceComponent: (0, $7Px0t.SOURCE_COMPONENT).ATLASSIAN_SWITCHER,
                    sourceContext: (0, $7Px0t.SOURCE_CONTEXT).ATLASSIAN_SWITCHER_LOOM_INTERCEPT
                })
            ]
        })
    });
};
module.exports["FirstPartyRecommendation"] = $d5ce83d27bea3823$export$28bbc8e042015ff9;

});

parcelRegister("9SeNW", function(module, exports) {
/* recommendation.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $hekY6 = parcelRequire("hekY6");


var $7ZB0A = parcelRequire("7ZB0A");


var $3vgx3 = parcelRequire("3vgx3");


var $6TaGl = parcelRequire("6TaGl");


var $bGVJw = parcelRequire("bGVJw");


var $6iRGV = parcelRequire("6iRGV");


var $aHfj2 = parcelRequire("aHfj2");


var $k4HA2 = parcelRequire("k4HA2");


var $7NHN3 = parcelRequire("7NHN3");


var $3jNKT = parcelRequire("3jNKT");


var $9ME8P = parcelRequire("9ME8P");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $bR9H6 = parcelRequire("bR9H6");


var $cuTJY = parcelRequire("cuTJY");


var $fMKy7 = parcelRequire("fMKy7");


var $Nj9rC = parcelRequire("Nj9rC");

const $ee24b55ee4a01e95$var$dropdownButtonSizeMedium = null;
const $ee24b55ee4a01e95$var$dropdownButtonSize = null;
const $ee24b55ee4a01e95$var$dropdownTriggerStyles = null;
const $ee24b55ee4a01e95$var$dropdownTriggerWithHoverStyles = null;
const $ee24b55ee4a01e95$var$DropdownTrigger = ({ triggerRef: triggerRef, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, isHovered: isHovered, name: name, iconSize: iconSize = 'small', spacing: spacing = 'default', isSelected: isSelected, ...triggerProps })=>{
    const intl = (0, $kSwu1.useIntl)();
    const ariaLabel = intl.formatMessage({
        id: "growth.recommendation-jsw.recommendations.dropdown-menu-trigger.aria-label",
        defaultMessage: "{productName} options"
    }, {
        productName: name
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZB0A.default), {
        ...triggerProps,
        "aria-label": ariaLabel,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        appearance: "subtle",
        spacing: spacing,
        ref: triggerRef,
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
            label: undefined
        }),
        className: (0, $hekY6.default)([
            iconSize === 'medium' ? "_4ouGXIVa5s _0jFU0VVa5s" : "_4ouGXIp0Oa _0jFU0Vp0Oa",
            "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _3SamIHdnbC _2YLqiKk9Lk _1ubuxo98eZ _1NDpvbDHe6 _2wtOC9T6kp _34b3D2dnbC _1ubuxonXvL",
            isHovered && !isSelected && "_23rrnHSHWv _0KLXruo126 _1eOmH6o126"
        ])
    });
}; /*--recommendation--*/ 
const $ee24b55ee4a01e95$export$9d12ea8b06492b3a = ({ app: app, onDismissed: onDismissed, iconSize: iconSize, spacing: spacing, additionalAnalyticsAttributes: additionalAnalyticsAttributes = {} })=>{
    // This is to handle a specific design requirement to hightlight the dropdown on hover
    // Couldn't work out how to do this in css, so its js :(
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const [isWhyAmISeeingThisModelOpened, setIsWhyAmISeeingThisModelOpened] = (0, $cozmU.useState)(false);
    const { messageDismissed: messageDismissed, messageAcknowledged: messageAcknowledged } = (0, $9ME8P.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $7NHN3.useMessageInstanceEvent)();
    const { onDeclined: onDeclined } = (0, $3jNKT.usePostOfficeUserInteractions)();
    const { messageInstanceId: messageInstanceId } = (0, $k4HA2.useMessageContext)();
    const context = (0, $bGVJw.usePostOfficeContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $aHfj2.useFirePostOfficeAnalyticsEvents)();
    const { fireInteractedUIEvent: fireAdControlInteractedUIEvent } = (0, $6iRGV.useFireAdControlAnalyticsEvents)();
    const { showFlag: showFlag, onDismissFlag: onDismissFlag, dismissedApps: dismissedApps } = (0, $bR9H6.useAdControlsFlags)();
    const { isSiteAdmin: isSiteAdmin } = (0, $bGVJw.usePostOfficeContext)();
    const handleNotInterested = async ()=>{
        await messageDismissed();
        onDeclined({
            interactionIdentifier: 'notInterested',
            additionalMetadata: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'notInterested'
        }, {
            isSiteAdmin: isSiteAdmin,
            ...additionalAnalyticsAttributes
        });
        const success = await (0, $Nj9rC.dismissApp)(app.ccpProductId, context);
        if (messageInstanceId && success) onDismissed(messageInstanceId);
        showFlag(app);
    };
    const handleWhyAmISeeingThis = async ()=>{
        setIsWhyAmISeeingThisModelOpened(true);
        await messageAcknowledged();
        await messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'adControlsReasons',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'acknowledge'
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'adControlsReasons'
        }, {
            ...additionalAnalyticsAttributes
        });
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'adControlsReasonsModal'
        }, {
            ...additionalAnalyticsAttributes
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3vgx3.default), {
                trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $8aG6j.jsx)($ee24b55ee4a01e95$var$DropdownTrigger, {
                        name: app.appName,
                        triggerRef: triggerRef,
                        onMouseEnter: ()=>setIsHovered(true),
                        onMouseLeave: ()=>setIsHovered(false),
                        isHovered: isHovered,
                        iconSize: iconSize,
                        spacing: spacing,
                        ...triggerProps
                    }),
                shouldRenderToParent: true,
                onOpenChange: (args)=>{
                    if (args.isOpen) {
                        fireAdControlInteractedUIEvent({
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'adControlsDropdown'
                        }, {
                            source: 'atlassianSwitcherDiscoverProductsSection',
                            targetProductId: app.ccpProductId
                        });
                        fireAnalyticsEvent({
                            eventType: 'ui',
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'adControlsDropdown'
                        });
                    }
                },
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cuTJY.AppSwitcherDropdown), {
                    onNotInterested: handleNotInterested,
                    onWhyAmISeeingThis: handleWhyAmISeeingThis
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fMKy7.WhyAmISeeingThisModal), {
                isOpen: isWhyAmISeeingThisModelOpened,
                onClose: ()=>{
                    setIsWhyAmISeeingThisModelOpened(false);
                    fireAnalyticsEvent({
                        eventType: 'ui',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'adControlsReasonsClose'
                    }, {
                        ...additionalAnalyticsAttributes
                    });
                },
                app: {
                    ccpProductId: app.ccpProductId,
                    appName: app.adControlsName || app.appName
                }
            }),
            dismissedApps.includes(app) && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bR9H6.AdControlsFlags), {
                dismissedApps: [
                    app
                ],
                onDismissFlag: ()=>onDismissFlag(app)
            })
        ]
    });
};
module.exports["RecommendationControls"] = $ee24b55ee4a01e95$export$9d12ea8b06492b3a;

});

parcelRegister("6iRGV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $6AG3B = parcelRequire("6AG3B");


var $hnuQ8 = parcelRequire("hnuQ8");

const $c9f3a188d17ee879$export$376b8a99b8453b1 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const firedViewedScreenEventName = (0, $cozmU.useRef)();
    const mapToCcpProductKeys = (0, $cozmU.useCallback)((recommendedProductIds, targetProductId)=>{
        const ccpProductIds = recommendedProductIds.reduce((acc, curr)=>{
            acc.push((0, $6AG3B.SURFACE_ANALYTICS_PRODUCT_MAP).products[curr] ?? curr);
            return acc;
        }, []);
        const ccpTargetProductId = targetProductId && (0, $6AG3B.SURFACE_ANALYTICS_PRODUCT_MAP).products[targetProductId];
        return {
            recommendedProductIds: ccpProductIds,
            targetProductId: ccpTargetProductId ?? targetProductId
        };
    }, []);
    const fireViewedScreenEvent = (0, $cozmU.useCallback)((name, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedScreenEventName.current === name) return;
        const { recommendedProductIds: recommendedProductIds, targetProductId: targetProductId, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds, targetProductId: ccpTargetProductId } = mapToCcpProductKeys(recommendedProductIds, targetProductId);
        createAnalyticsEvent({
            eventType: (0, $hnuQ8.eventTypes).SCREEN,
            name: name,
            attributes: {
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId,
                ...rest,
                ...attributes
            }
        }).fire((0, $hnuQ8.CROSS_FLOW_CHANNEL));
        firedViewedScreenEventName.current = name;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireInteractedUIEvent = (0, $cozmU.useCallback)((event, commonAttributes, attributes)=>{
        const { source: source, recommendedProductIds: recommendedProductIds, targetProductId: targetProductId, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds, targetProductId: ccpTargetProductId } = mapToCcpProductKeys(recommendedProductIds ?? [], targetProductId);
        createAnalyticsEvent({
            eventType: (0, $hnuQ8.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId,
                ...rest,
                ...attributes
            }
        }).fire((0, $hnuQ8.CROSS_FLOW_CHANNEL));
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    return {
        fireViewedScreenEvent: fireViewedScreenEvent,
        fireInteractedUIEvent: fireInteractedUIEvent
    };
};
module.exports["useFireAdControlAnalyticsEvents"] = $c9f3a188d17ee879$export$376b8a99b8453b1;

});

parcelRegister("bR9H6", function(module, exports) {
/* dismissalFlag.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $a2foB = parcelRequire("a2foB");


var $lqtHz = parcelRequire("lqtHz");


var $chu6R = parcelRequire("chu6R");


var $iMnC5 = parcelRequire("iMnC5");


var $kSwu1 = parcelRequire("kSwu1");


var $6YRp0 = parcelRequire("6YRp0");


var $eau24 = parcelRequire("eau24");

const $5065a1833355e270$var$APP_REC_FLAG_WRAPPER = 'app-rec-flag-wrapper';
/**-Title--**/ const $5065a1833355e270$var$styles = {
    titleContainer: "_2sNsIgEqul"
};
const $5065a1833355e270$var$Title = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $5065a1833355e270$var$styles.titleContainer,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "recommendations.ad-controls.dismiss-flag.not-interested.title",
            defaultMessage: "Got it, thanks for letting us know"
        })
    }); /**--Description--**/ 
const $5065a1833355e270$var$Description = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
        id: "recommendations.ad-controls.dismiss-flag.not-interested.subtitle",
        defaultMessage: "You won\u2019t see this here as often."
    }); /**--Confirm Icon--*/ 
const $5065a1833355e270$var$ConfirmIcon = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
        spacing: "spacious",
        label: "Success",
        color: "var(--ds-icon-success, #6A9A23)"
    }); /**-Confirm Dismiss Flag--*/ 
const $5065a1833355e270$var$AdControlsFlag = ({ app: app, onDismissFlag: onDismissFlag })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        id: $5065a1833355e270$var$APP_REC_FLAG_WRAPPER,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a2foB.default), {
            icon: /*#__PURE__*/ (0, $8aG6j.jsx)($5065a1833355e270$var$ConfirmIcon, {}),
            title: /*#__PURE__*/ (0, $8aG6j.jsx)($5065a1833355e270$var$Title, {}),
            description: /*#__PURE__*/ (0, $8aG6j.jsx)($5065a1833355e270$var$Description, {}),
            id: app.ccpProductId,
            onDismissed: ()=>onDismissFlag(app)
        }, app.ccpProductId)
    }); /**--Confirm Dismiss Flags--**/ 
const $5065a1833355e270$export$75b265d47874fa00 = ()=>{
    const [dismissedApps, setApps] = (0, $cozmU.useState)([]);
    return {
        dismissedApps: dismissedApps,
        showFlag: (app)=>{
            setApps((current)=>[
                    ...current,
                    app
                ]);
        },
        onDismissFlag: (app)=>{
            setApps((0, $6YRp0.removeApp)(app));
        }
    };
};
const $5065a1833355e270$export$9817a6acf70b573d = ({ dismissedApps: dismissedApps, onDismissFlag: onDismissFlag })=>{
    (0, $eau24.portalZIndexFix)($5065a1833355e270$var$APP_REC_FLAG_WRAPPER);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
        children: dismissedApps.map((app)=>/*#__PURE__*/ (0, $8aG6j.jsx)($5065a1833355e270$var$AdControlsFlag, {
                onDismissFlag: ()=>onDismissFlag(app),
                app: app
            }, app.ccpProductId))
    });
};
module.exports["useAdControlsFlags"] = $5065a1833355e270$export$75b265d47874fa00;
module.exports["AdControlsFlags"] = $5065a1833355e270$export$9817a6acf70b573d;

});

parcelRegister("6YRp0", function(module, exports) {
const $abe08c3ff5311b23$export$c6f8e2bf49f88f03 = (app)=>(currentApps)=>{
        return currentApps.filter((_app)=>_app.ccpProductId !== app.ccpProductId);
    };
const $abe08c3ff5311b23$export$9bbd96a5d633f721 = (originalApps)=>()=>originalApps;
module.exports["removeApp"] = $abe08c3ff5311b23$export$c6f8e2bf49f88f03;

});

parcelRegister("eau24", function(module, exports) {
const $e703748dd759eb83$var$collectionHas = (all, curr)=>{
    for(let i = 0, len = all.length; i < len; i++){
        if (all[i] === curr) return true;
    }
    return false;
};
const $e703748dd759eb83$var$findParentBySelector = (elm, selector)=>{
    const all = globalThis.document.querySelectorAll(selector);
    let cur = elm?.parentNode;
    while(cur && !$e703748dd759eb83$var$collectionHas(all, cur))cur = cur.parentNode;
    return cur;
};
const $e703748dd759eb83$export$cef2f5415067aeab = (wrapperId)=>{
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    setTimeout(()=>{
        if (globalThis.document) {
            const modalContent = globalThis.document.getElementById(wrapperId);
            const portalSelector = '.atlaskit-portal';
            const parentPortal = $e703748dd759eb83$var$findParentBySelector(modalContent, portalSelector);
            if (parentPortal) parentPortal.setAttribute('style', 'z-index:900;');
        }
    });
// DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
};
module.exports["portalZIndexFix"] = $e703748dd759eb83$export$cef2f5415067aeab;

});

parcelRegister("cuTJY", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $kSwu1 = parcelRequire("kSwu1");

const $0b0fedcbbfc835a6$export$99f2c116e7ad8950 = (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default), {
        ...props,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "switcher.ad-controls.dropdown-item.why-am-i-seeing-this.label",
            defaultMessage: "Why am I seeing this?"
        })
    });
const $0b0fedcbbfc835a6$export$80eb3e3679dfe382 = (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default), {
        ...props,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "switcher.ad-controls.dropdown-item.not-interested.label",
            defaultMessage: "Not interested"
        })
    });
const $0b0fedcbbfc835a6$export$f7775fa9fa3b6543 = ({ onWhyAmISeeingThis: onWhyAmISeeingThis, onNotInterested: onNotInterested })=>/*#__PURE__*/ (0, $8aG6j.jsxs)((0, $9erVg.default), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)($0b0fedcbbfc835a6$export$80eb3e3679dfe382, {
                onClick: onNotInterested
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)($0b0fedcbbfc835a6$export$99f2c116e7ad8950, {
                onClick: onWhyAmISeeingThis
            })
        ]
    });
module.exports["AppSwitcherDropdown"] = $0b0fedcbbfc835a6$export$f7775fa9fa3b6543;

});

parcelRegister("fMKy7", function(module, exports) {
/* modal.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $hekY6 = parcelRequire("hekY6");


var $7ZB0A = parcelRequire("7ZB0A");


var $7aRdF = parcelRequire("7aRdF");


var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $aRGok = parcelRequire("aRGok");


var $iMnC5 = parcelRequire("iMnC5");


var $aHfj2 = parcelRequire("aHfj2");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $eau24 = parcelRequire("eau24");

const $74e01cef873f72c1$var$APP_REC_MODAL_CONTENT = 'app-rec-modal-content'; /*--Modal--*/ 
const $74e01cef873f72c1$var$REASONS = [
    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
        id: "recommendation-controls.team-size",
        defaultMessage: "the size of your team"
    }),
    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
        id: "recommendation-controls.existing-products",
        defaultMessage: "your existing Atlassian products"
    })
];
const $74e01cef873f72c1$export$2b77a92f1a5ad772 = ({ children: children, isOpen: isOpen, onClose: onClose })=>{
    (0, $eau24.portalZIndexFix)($74e01cef873f72c1$var$APP_REC_MODAL_CONTENT);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aRGok.default), {
        children: isOpen && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7aRdF.default), {
            shouldCloseOnEscapePress: true,
            onClose: onClose,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                id: $74e01cef873f72c1$var$APP_REC_MODAL_CONTENT,
                children: children
            })
        })
    });
}; /*--Confirm Button--*/ 
const $74e01cef873f72c1$var$AcceptButton = ({ onClick: onClick })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZB0A.default), {
        appearance: "primary",
        onClick: onClick,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "recommendations.ad-controls.reasons-modal.accept-button.label-ok",
            defaultMessage: "OK"
        })
    }); /*--Title--*/ 
const $74e01cef873f72c1$var$styles = {
    titleContainer: "_2sNsIgWSk4"
};
const $74e01cef873f72c1$var$Title = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $74e01cef873f72c1$var$styles.titleContainer,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "recommendations.ad-controls.reasons-modal.title",
            defaultMessage: "Why am I seeing this?"
        })
    }); /*--Body--*/ 
const $74e01cef873f72c1$var$Body = (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)("p", {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            id: "recommendations.ad-controls.reasons-modal.body",
            defaultMessage: "We think that {productName} will improve your team's productivity. The recommendation is based on:",
            values: {
                productName: /*#__PURE__*/ (0, $8aG6j.jsx)("strong", {
                    children: props.productName
                })
            }
        })
    }); /*--Reasons List--*/ 
const $74e01cef873f72c1$var$reasonsListStyles = null;
const $74e01cef873f72c1$var$ReasonsList = ({ reasons: reasons })=>/*#__PURE__*/ (0, $8aG6j.jsx)("ul", {
        className: (0, $hekY6.default)([
            "_0aNu0LC2EI _2Zuz6QkG2W _3138428HPE"
        ]),
        children: reasons.map((reason, index)=>/*#__PURE__*/ (0, $8aG6j.jsx)("li", {
                children: reason
            }, index))
    }); /*--Privacy Policy Link--*/ 
const $74e01cef873f72c1$var$privacyPolicyLinkStyles = null;
const $74e01cef873f72c1$var$PrivacyPolicyLink = ({ onClick: onClick })=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            "_3138428HPE"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("a", {
            href: 'https://www.atlassian.com/legal/privacy-policy',
            target: "_blank",
            onClick: onClick,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                id: "recommendations.ad-controls.reasons-modal.privacy-policy-link.text",
                defaultMessage: "Learn more about your data privacy with Atlassian"
            })
        })
    }); /*--Reason Modal--*/ 
const $74e01cef873f72c1$var$ReasonsModalBody = ({ app: app, onClose: onClose })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $aHfj2.useFirePostOfficeAnalyticsEvents)();
    const handleOnPrivacyPolicy = ()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'adControlsPrivacyPolicy'
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9Umtx.default), {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jq995.default), {
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)($74e01cef873f72c1$var$Title, {})
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $fEPJS.default), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)($74e01cef873f72c1$var$Body, {
                        productName: app.appName
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)($74e01cef873f72c1$var$ReasonsList, {
                        reasons: $74e01cef873f72c1$var$REASONS
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)($74e01cef873f72c1$var$PrivacyPolicyLink, {
                        onClick: ()=>handleOnPrivacyPolicy()
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eQiT1.default), {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)($74e01cef873f72c1$var$AcceptButton, {
                    onClick: onClose
                })
            })
        ]
    });
};
const $74e01cef873f72c1$export$b29014abf8076d54 = (props)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($74e01cef873f72c1$export$2b77a92f1a5ad772, {
        isOpen: props.isOpen,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($74e01cef873f72c1$var$ReasonsModalBody, {
            ...props
        })
    });
};
module.exports["WhyAmISeeingThisModal"] = $74e01cef873f72c1$export$b29014abf8076d54;

});

parcelRegister("Nj9rC", function(module, exports) {
const $a4655b01d4091ad0$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $a4655b01d4091ad0$var$dismissAppMutation = `
                mutation DismissRecommendation($args: AppRecDismissRecommendationInput!){
                  appRecommendations {
                    dismissRecommendation(input:$args){
                      success
                      errors{
                        message
                      }
                    }
                  }
                }
                `;
const $a4655b01d4091ad0$export$d32365bd6abc60d2 = async (productId, context)=>{
    try {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        const request = new Request($a4655b01d4091ad0$var$GRAPHQL_ENDPOINT, {
            method: 'POST',
            credentials: 'include',
            mode: 'cors',
            headers: headers,
            body: JSON.stringify({
                query: $a4655b01d4091ad0$var$dismissAppMutation,
                variables: {
                    args: {
                        productId: productId,
                        context: context
                    }
                }
            })
        });
        const response = await (await fetch(request)).json();
        return response.data.appRecommendations.dismissRecommendation.success;
    } catch (error) {
        return false;
    }
};
module.exports["dismissApp"] = $a4655b01d4091ad0$export$d32365bd6abc60d2;

});

parcelRegister("5ovkh", function(module, exports) {
const $a4a681b7bf6f7540$export$a907de02f9639d20 = 968;
const $a4a681b7bf6f7540$export$3ff3f7444e69a59d = 620;
module.exports["CROSS_FLOW_MODAL_WIDTH"] = $a4a681b7bf6f7540$export$a907de02f9639d20;
module.exports["CROSS_FLOW_MODAL_HEIGHT"] = $a4a681b7bf6f7540$export$3ff3f7444e69a59d;

});

parcelRegister("e9abE", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $2VwyL = parcelRequire("2VwyL");


var $5WvJi = parcelRequire("5WvJi");


var $iDrrr = parcelRequire("iDrrr");


var $ln34A = parcelRequire("ln34A");


var $ghNlj = parcelRequire("ghNlj");


var $bPFqZ = parcelRequire("bPFqZ");


var $d5gEx = parcelRequire("d5gEx");


var $lBLkF = parcelRequire("lBLkF");


var $jyfWY = parcelRequire("jyfWY");


var $1xDc3 = parcelRequire("1xDc3");


var $fweCp = parcelRequire("fweCp");

const $f49eddef0331bb8e$var$emptyEntryPointParams = {};
const $f49eddef0331bb8e$var$emptyEntryPointProps = {};
function $f49eddef0331bb8e$export$ad55650562d4c65b({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, title: title, modalProps: modalProps, forwardedRef: forwardedRef, onError: onError, preloadOnFocus: preloadOnFocus = true, loadingText: loadingText }) {
    const { openModal: openModal } = (0, $cozmU.useContext)((0, $lBLkF.ModalContext));
    const environmentProvider = (0, $d5gEx.useRelayEnvironmentProvider)();
    const { GlobalModalErrorFallback: GlobalModalErrorFallback } = (0, $ln34A.useEntryPointConfig)();
    const modalRef = (0, $cozmU.useRef)(null);
    const metricName = (0, $cozmU.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $cozmU.useCallback)(()=>(0, $6SsN4.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $f49eddef0331bb8e$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $cozmU.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = (extraInformation)=>{
                entryPointProps?.onClose?.(extraInformation);
                closeModal();
                dispose();
            };
            const container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bPFqZ.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorFallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(GlobalModalErrorFallback, {
                        error: error,
                        closeModal: closeModal,
                        fallback: (0, $iDrrr.fg)('platform_dst-a11y_accessible-error-modal') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jyfWY.ErrorFallback), {
                            error: error,
                            closeModal: onClose
                        }) : undefined
                    }),
                onError: ({ error: error, errorInfo: errorInfo })=>{
                    onError?.({
                        error: error,
                        errorInfo: errorInfo
                    });
                },
                fallback: Fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Fallback, {
                    onClose: closeModal
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fweCp.Loading), {
                    title: title,
                    loadingText: loadingText
                }),
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                runtimeProps: {
                    ...entryPointProps ?? $f49eddef0331bb8e$var$emptyEntryPointProps,
                    onClose: onClose,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick
                }
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5WvJi.FullScreenModalDialog), {
                ...modalProps,
                onClose: onClose,
                ref: modalRef,
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? modalProps?.shouldCloseOnEscapePress
            }, container, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1xDc3.FocusInsideOnLoad), {
                entryPointReference: entryPointReference,
                autoFocusRef: modalProps?.autoFocus,
                modalRef: modalRef
            }));
        });
    }, [
        openModal,
        title,
        modalProps,
        Fallback,
        metricName,
        entryPointProps,
        GlobalModalErrorFallback,
        onError,
        loadingText
    ]);
    const triggerRef = (0, $ghNlj.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad,
        preloadOnFocus: preloadOnFocus
    });
    const mergedRef = (0, $2VwyL.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    if ((0, $iDrrr.fg)('platform_dst-a11y_modal-trigger-haspopup')) return children({
        ref: mergedRef,
        'aria-haspopup': 'dialog'
    });
    return children({
        ref: mergedRef
    });
}
module.exports["FullScreenModalTrigger"] = $f49eddef0331bb8e$export$ad55650562d4c65b;

});

parcelRegister("6BjHJ", function(module, exports) {

var $7qZTr = parcelRequire("7qZTr");


var $ONTtp = parcelRequire("ONTtp");


const $46a84b8c63bb5672$export$339fed52d8b037b0 = (0, $ONTtp.createEntryPoint)({
    root: (0, $7qZTr.JSResourceForInteraction)(()=>(parcelRequire("lJYwa")), {
        moduleId: "880484c6",
        priority: "interaction",
        moduleId: 'post-office-cross-flow-modal'
    }),
    getPreloadProps: ()=>({})
});
module.exports["crossFlowModalEntryPoint"] = $46a84b8c63bb5672$export$339fed52d8b037b0;

});

parcelRegister("lJYwa", function(module, exports) {

let $fd3cbe865871c7d3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fd3cbe865871c7d3$var$load("lya9W"),
    $fd3cbe865871c7d3$var$load("6wr18"),
    $fd3cbe865871c7d3$var$load("56XHJ"),
    $fd3cbe865871c7d3$var$load("8Y23K"),
    $fd3cbe865871c7d3$var$load("BKxAI"),
    $fd3cbe865871c7d3$var$load("9w623"),
    $fd3cbe865871c7d3$var$load("aOIZj"),
    $fd3cbe865871c7d3$var$load("6Q7Wr"),
    $fd3cbe865871c7d3$var$load("kHXvF"),
    $fd3cbe865871c7d3$var$load("ffEVr"),
    $fd3cbe865871c7d3$var$load("kDgSd")
]).then(()=>parcelRequire('d2jZA'));

});

parcelRegister("jNuZJ", function(module, exports) {
parcelRequire("kgHuu");
var $3qdJ0 = parcelRequire("3qdJ0");

const $4ab2d99fe5552182$var$JSM_GENERAL_SERVICE_MANAGEMENT_KEY = 'jsm.general-service-management';
const $4ab2d99fe5552182$var$JSM_GENERAL_SERVICE_MANAGEMENT_CMP_KEY = 'com.atlassian.servicedesk:company-managed-general-service-project';
const $4ab2d99fe5552182$var$JSM_IT_SERVICE_MANAGEMENT_KEY = 'jsm.it-service-management';
const $4ab2d99fe5552182$var$JSM_IT_SERVICE_MANAGEMENT_BASIC_KEY = 'jsm.it-service-management-basic';
const $4ab2d99fe5552182$var$JSM_IT_SERVICE_MANAGEMENT_ADVANCED_KEY = 'jsm.it-service-management-advanced';
const $4ab2d99fe5552182$var$JSM_BLANK_SERVICE_MANAGEMENT_KEY = 'jsm.blank-service-management';
const $4ab2d99fe5552182$var$JSM_IT_SERVICE_MANAGEMENT_BASIC_CMP_KEY = 'com.atlassian.servicedesk:simplified-it-service-management-basic';
const $4ab2d99fe5552182$var$JSM_IT_SERVICE_MANAGEMENT_ADVANCED_CMP_KEY = 'com.atlassian.servicedesk:simplified-it-service-management';
const $4ab2d99fe5552182$var$JSM_CUSTOMER_SERVICE_MANAGEMENT_KEY = 'jsm.customer-service-management';
const $4ab2d99fe5552182$var$JSM_CUSTOMER_SERVICE_MANAGEMENT_CMP_KEY = 'com.atlassian.jcs:customer-service-management';
const $4ab2d99fe5552182$var$JIRA_CUSTOMER_SERVICE_TARGET = 'jira-customer-service';
const $4ab2d99fe5552182$var$JPD_PRODUCT_DISCOVERY_KEY = 'jpd.product-discovery';
const $4ab2d99fe5552182$var$JPD_PRODUCT_DISCOVERY_TMP_KEY = 'jira.polaris:discovery';
const $4ab2d99fe5552182$var$JPD_PRODUCT_ROADMAP_KEY = 'jpd.product-roadmap';
const $4ab2d99fe5552182$var$JPD_PRODUCT_ROADMAP_TMP_KEY = 'jira.polaris:roadmap';
const $4ab2d99fe5552182$var$JPD_PRIORITIZATION_KEY = 'jpd.prioritization';
const $4ab2d99fe5552182$var$JPD_PRIORITIZATION_TMP_KEY = 'jira.polaris:prioritization';
const $4ab2d99fe5552182$var$projectNameMessages = {
    support: {
        id: 'jsm-auto-create-project-name.support',
        description: 'This is the name for a project that is automatically created when cross-flowing to JSM. This will be the name used for the "General service management for IT teams" template',
        defaultMessage: 'Support'
    },
    requests: {
        id: 'jsm-auto-create-project-name.requests',
        description: 'This is the name for a project that is automatically created when cross-flowing to JSM. This will be the name used for the "General service management for business teams" template',
        defaultMessage: 'Requests'
    },
    customerService: {
        id: 'jsm-auto-create-project-name.customer-service',
        description: 'This is the name for a project that is automatically created when cross-flowing to JSM. This will be the name used for the "Customer service management" template',
        defaultMessage: 'Customer service'
    },
    ideas: {
        id: 'jpd-auto-create-project-name.ideas',
        description: 'This is the name for a project that is automatically created when cross-flowing to JPD. This will be the name used for the "Product discovery" template',
        defaultMessage: 'My discovery project'
    },
    prioritization: {
        id: 'jpd-auto-create-project-name.prioritization',
        description: 'This is the name for a project that is automatically created when cross-flowing to JPD. This will be the name used for the "Prioritization" template',
        defaultMessage: 'Prioritization'
    }
};
const $4ab2d99fe5552182$var$jsmSupportTemplateKeys = new Set([
    $4ab2d99fe5552182$var$JSM_GENERAL_SERVICE_MANAGEMENT_KEY,
    $4ab2d99fe5552182$var$JSM_GENERAL_SERVICE_MANAGEMENT_CMP_KEY,
    $4ab2d99fe5552182$var$JSM_IT_SERVICE_MANAGEMENT_KEY,
    $4ab2d99fe5552182$var$JSM_IT_SERVICE_MANAGEMENT_BASIC_KEY,
    $4ab2d99fe5552182$var$JSM_IT_SERVICE_MANAGEMENT_ADVANCED_KEY,
    $4ab2d99fe5552182$var$JSM_BLANK_SERVICE_MANAGEMENT_KEY,
    $4ab2d99fe5552182$var$JSM_IT_SERVICE_MANAGEMENT_BASIC_CMP_KEY,
    $4ab2d99fe5552182$var$JSM_IT_SERVICE_MANAGEMENT_ADVANCED_CMP_KEY
]);
const $4ab2d99fe5552182$var$csmTemplateKeys = new Set([
    $4ab2d99fe5552182$var$JSM_CUSTOMER_SERVICE_MANAGEMENT_KEY,
    $4ab2d99fe5552182$var$JSM_CUSTOMER_SERVICE_MANAGEMENT_CMP_KEY
]);
const $4ab2d99fe5552182$var$jpdProjectNameMessageByTemplateKey = new Map([
    [
        $4ab2d99fe5552182$var$JPD_PRODUCT_DISCOVERY_KEY,
        $4ab2d99fe5552182$var$projectNameMessages.ideas
    ],
    [
        $4ab2d99fe5552182$var$JPD_PRODUCT_DISCOVERY_TMP_KEY,
        $4ab2d99fe5552182$var$projectNameMessages.ideas
    ],
    // Keep roadmap aligned with growth-kit control:
    // cross-flow-frontend/src/common/services/create-project/constants.ts maps
    // PRODUCT_ROADMAP_KEY and PRODUCT_ROADMAP_TMP_KEY to messages.ideas.
    [
        $4ab2d99fe5552182$var$JPD_PRODUCT_ROADMAP_KEY,
        $4ab2d99fe5552182$var$projectNameMessages.ideas
    ],
    [
        $4ab2d99fe5552182$var$JPD_PRODUCT_ROADMAP_TMP_KEY,
        $4ab2d99fe5552182$var$projectNameMessages.ideas
    ],
    [
        $4ab2d99fe5552182$var$JPD_PRIORITIZATION_KEY,
        $4ab2d99fe5552182$var$projectNameMessages.prioritization
    ],
    [
        $4ab2d99fe5552182$var$JPD_PRIORITIZATION_TMP_KEY,
        $4ab2d99fe5552182$var$projectNameMessages.prioritization
    ]
]);
const $4ab2d99fe5552182$var$defaultProjectNameMessageByTargetProduct = new Map([
    [
        (0, $3qdJ0.Targets).JIRA_SERVICE_DESK,
        $4ab2d99fe5552182$var$projectNameMessages.requests
    ],
    [
        (0, $3qdJ0.Targets).JIRA_PRODUCT_DISCOVERY,
        $4ab2d99fe5552182$var$projectNameMessages.ideas
    ],
    [
        $4ab2d99fe5552182$var$JIRA_CUSTOMER_SERVICE_TARGET,
        $4ab2d99fe5552182$var$projectNameMessages.customerService
    ]
]);
const $4ab2d99fe5552182$var$getProjectNameMessage = (targetProduct, templateKey)=>{
    if (targetProduct === (0, $3qdJ0.Targets).JIRA_SERVICE_DESK && $4ab2d99fe5552182$var$jsmSupportTemplateKeys.has(templateKey)) return $4ab2d99fe5552182$var$projectNameMessages.support;
    if (targetProduct === $4ab2d99fe5552182$var$JIRA_CUSTOMER_SERVICE_TARGET && $4ab2d99fe5552182$var$csmTemplateKeys.has(templateKey)) return $4ab2d99fe5552182$var$projectNameMessages.customerService;
    if (targetProduct === (0, $3qdJ0.Targets).JIRA_PRODUCT_DISCOVERY) return $4ab2d99fe5552182$var$jpdProjectNameMessageByTemplateKey.get(templateKey) ?? $4ab2d99fe5552182$var$defaultProjectNameMessageByTargetProduct.get(targetProduct);
    return $4ab2d99fe5552182$var$defaultProjectNameMessageByTargetProduct.get(targetProduct);
};
const $4ab2d99fe5552182$export$5c75876f63f298f7 = ({ targetProduct: targetProduct, templateKey: templateKey, formatMessage: formatMessage })=>{
    if (!templateKey) return undefined;
    const projectNameMessage = $4ab2d99fe5552182$var$getProjectNameMessage(targetProduct, templateKey);
    const projectName = projectNameMessage ? formatMessage(projectNameMessage) : undefined;
    return {
        templateKey: templateKey,
        ...projectName ? {
            projectName: projectName
        } : {}
    };
};
module.exports["getProjectCreationContextParams"] = $4ab2d99fe5552182$export$5c75876f63f298f7;

});

parcelRegister("6vvuE", function(module, exports) {
parcelRequire("63sT2");
var $dYn3u = parcelRequire("dYn3u");

parcelRequire("kgHuu");
var $3qdJ0 = parcelRequire("3qdJ0");

const $91ce0015513c1b29$var$DEFAULT_RECOMMENDATION_JOURNEY = (0, $dYn3u.Journeys).DECIDE;
const $91ce0015513c1b29$var$TARGET_LOOM = (0, $3qdJ0.Targets).LOOM || 'loom'; // adminHub Targets.LOOM is not defined
const $91ce0015513c1b29$export$5b22abe81e256ff7 = (app)=>{
    // TODO - Investigate whether Jira should use the GET_STARTED journey
    if (app.hamsIdentifier === (0, $3qdJ0.Targets).CONFLUENCE) return (0, $dYn3u.Journeys).GET_STARTED;
    if (app.hamsIdentifier === (0, $3qdJ0.Targets).JIRA_SERVICE_DESK) return (0, $dYn3u.Journeys).GET_STARTED;
    if (app.hamsIdentifier === (0, $3qdJ0.Targets).JIRA_PRODUCT_DISCOVERY) return (0, $dYn3u.Journeys).GET_STARTED;
    if (app.hamsIdentifier === $91ce0015513c1b29$var$TARGET_LOOM) return (0, $dYn3u.Journeys).GET_STARTED;
    return $91ce0015513c1b29$var$DEFAULT_RECOMMENDATION_JOURNEY;
};
module.exports["getJourney"] = $91ce0015513c1b29$export$5b22abe81e256ff7;

});

parcelRegister("eDAGu", function(module, exports) {

var $2c1Wz = parcelRequire("2c1Wz");


var $i7t6K = parcelRequire("i7t6K");

let $7ca3f558dc62e54e$var$pe = null;
const $7ca3f558dc62e54e$var$getObserver = ()=>{
    if ($7ca3f558dc62e54e$var$pe !== null) return $7ca3f558dc62e54e$var$pe;
    $7ca3f558dc62e54e$var$pe = new PerformanceObserver((list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $2c1Wz.PerformanceObserverEntryTypes).LayoutShift) (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $2c1Wz.PerformanceObserverEntryTypes).LongTask) (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LongTask].push(entry);
            if (entry.entryType === (0, $2c1Wz.PerformanceObserverEntryTypes).Event) (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).Event].push(entry);
        });
    });
    return $7ca3f558dc62e54e$var$pe;
};
const $7ca3f558dc62e54e$export$231c167ad8c908df = ()=>{
    if ($7ca3f558dc62e54e$var$pe) {
        // Disconnect the observer if it's already set up
        $7ca3f558dc62e54e$var$pe.disconnect();
        $7ca3f558dc62e54e$var$pe = null;
    }
    for (const type of Object.values((0, $2c1Wz.PerformanceObserverEntryTypes)))$7ca3f558dc62e54e$var$getObserver().observe({
        type: type,
        buffered: true
    });
};
module.exports["startLightHouseObservers"] = $7ca3f558dc62e54e$export$231c167ad8c908df;

});

parcelRegister("lTjel", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $94ecb5e99e218b76$export$b602c35a55c29946 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "-DYr1",
    name: "ErrorAppLoader",
    loader: async ()=>(await (parcelRequire("1E17N"))).ErrorApp
});
module.exports["ErrorAppLoader"] = $94ecb5e99e218b76$export$b602c35a55c29946;

});

parcelRegister("aFgFx", function(module, exports) {

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");




var $a2zQR = parcelRequire("a2zQR");

async function $457aeee54b862c4a$export$b1c9c77d4871a337(spaceKey, contentId) {
    return (0, $lyWac.waitForAllReturnWhenError)([
        $457aeee54b862c4a$var$preloadContentData(contentId, spaceKey),
        $457aeee54b862c4a$var$preloadContentTree(contentId, spaceKey)
    ]);
}
async function $457aeee54b862c4a$var$preloadContentData(contentId, spaceKey) {
    await (0, $dYU3e.query)({
        query: (0, $a2zQR.default),
        variables: {
            contentId: contentId,
            spaceKey: spaceKey
        },
        __callerPackage__: "confluence-embeds"
    });
}
async function $457aeee54b862c4a$var$preloadContentTree(contentId, spaceKey) {}
module.exports["preloadEmbedData"] = $457aeee54b862c4a$export$b1c9c77d4871a337;

});

parcelRegister("kyd3u", function(module, exports) {

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $xwvlW = parcelRequire("xwvlW");


var $fHLuR = parcelRequire("fHLuR");


var $6mKj3 = parcelRequire("6mKj3");



var $9ycGg = parcelRequire("9ycGg");




var $1xpoY = parcelRequire("1xpoY");


var $fxLAA = parcelRequire("fxLAA");


var $80xNa = parcelRequire("80xNa");

function $7f1954fc7a2cd99f$export$c628356b573f8241({ isUnpublishedDraft: isUnpublishedDraft, spaceKey: spaceKey, contentId: contentId }) {
    const queries = [
        (0, $dYU3e.query)({
            query: (0, $fxLAA.default),
            variables: {
                contentId: contentId,
                spaceKey: spaceKey,
                versionOverride: null,
                embeddedContentRender: null,
                limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
                isMarkdownModeEnabled: (0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true),
                includeDevDocsBylineConnection: (0, $6mKj3.isExperimentEnabled)('confluence_1p_and_3p_connection_byline_experiment') || (0, $6mKj3.isExperimentEnabled)('confluence_dev_docs'),
                useObjectHeaderFragment: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_obj_header_frag_dedup') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
                includeClassification: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_classification_context_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
                ...isUnpublishedDraft && {
                    status: [
                        'draft'
                    ]
                }
            },
            __callerPackage__: "content-header"
        }),
        (0, $9ycGg.preloadPageReactions)({
            pageId: contentId,
            containerId: spaceKey
        })
    ];
    if (contentId && spaceKey && (0, $6mKj3.expValEquals)('dual_agent_avatar_card', 'isEnabled', true)) {
        const { cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
        if (cloudId) queries.push((0, $fHLuR.preloadContentOwnershipCollaborators)({
            cloudId: cloudId,
            contentId: contentId,
            spaceKey: spaceKey
        }));
    }
    return (0, $lyWac.waitForAllReturnWhenError)(queries);
}
module.exports["preloadEditorByLineData"] = $7f1954fc7a2cd99f$export$c628356b573f8241;

});

parcelRegister("ddSqr", function(module, exports) {

var $5rHrW = parcelRequire("5rHrW");


var $wPrRK = parcelRequire("wPrRK");


var $dYU3e = parcelRequire("dYU3e");


var $lyWac = parcelRequire("lyWac");


var $cRQNp = parcelRequire("cRQNp");


var $eP7b6 = parcelRequire("eP7b6");


var $9HhEw = parcelRequire("9HhEw");

function $1b23138cfdb36f61$export$77aa43a33b3d905d(contentId) {
    // This preloader is shared by the public-link and access-link routes and always fires the
    // external-share queries. When cc_perms_ga_access_links is on, the render-side components
    // correctly switch to ContentHeaderUnifiedQuery, so these preloads go unused for access-link
    // viewers. Aligning the preloader with the GA access-link path is tracked in CCPERMS-7263.
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)({
            query: (0, $eP7b6.default),
            variables: {
                contentId: contentId
            },
            context: {
                allowOnExternalPage: true
            },
            __callerPackage__: "content-header"
        }),
        (0, $dYU3e.query)({
            query: (0, $9HhEw.default),
            variables: {
                contentId: contentId
            },
            context: {
                allowOnExternalPage: true
            },
            __callerPackage__: "content-header"
        }),
        (0, $cRQNp.preloadReadTime)({
            contentId: contentId,
            includeContentBody: true,
            useCache: true
        }),
        (0, $wPrRK.slowQueryGuard)('preloadContentAnalyticsViewers', ()=>(0, $5rHrW.preloadContentAnalyticsViewers)(contentId), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT))
    ]);
}
module.exports["preloadContentTitleWithByLineExternal"] = $1b23138cfdb36f61$export$77aa43a33b3d905d;

});

parcelRegister("6YxJf", function(module, exports) {

var $MyxIQ = parcelRequire("MyxIQ");

const $3050fc659ed4bb43$export$4be2eb0104d640dc = async ()=>{
    return (0, $MyxIQ.preloadPostOfficePlacementWithSessionContext)('confluence-home-banner');
};
module.exports["preloadPostOfficeConfluenceHomeBanner"] = $3050fc659ed4bb43$export$4be2eb0104d640dc;

});

parcelRegister("iujy9", function(module, exports) {
/**
 * @generated SignedSource<<6bf0e1a50f8992ea9d07f341c336c62c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b5846c5488337040$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "watchContentHeaderTemplateDataContentFragment",
    "selections": [
        {
            "concreteType": "ContentMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "sourceTemplateEntityId"
                }
            ]
        }
    ],
    "type": "Content"
};
$b5846c5488337040$var$node.hash = "ef4f3064f901b2dcf745ba396c56f142";
var $b5846c5488337040$export$2e2bcd8739ae039 = $b5846c5488337040$var$node;



var $fFmJj = parcelRequire("fFmJj");

const $a95c3ab6a4f11e9d$var$contentHeaderTemplateDataFragment = (0, $b5846c5488337040$export$2e2bcd8739ae039);
const $a95c3ab6a4f11e9d$var$CACHE_RETRY_INTERVAL_MS = 100;
const $a95c3ab6a4f11e9d$var$MAX_CACHE_READ_ATTEMPTS = 50;
const $a95c3ab6a4f11e9d$var$readTemplateData = (contentId)=>{
    try {
        const data = (0, $fFmJj.readFragmentInterop)({
            id: `Content:${contentId}`,
            fragment: $a95c3ab6a4f11e9d$var$contentHeaderTemplateDataFragment,
            __callerPackage__: "content-header"
        });
        const sourceTemplateEntityId = data?.metadata?.sourceTemplateEntityId;
        return sourceTemplateEntityId === undefined ? {
            status: 'pending'
        } : {
            status: 'ready',
            sourceTemplateEntityId: sourceTemplateEntityId
        };
    } catch  {
        return {
            status: 'pending'
        };
    }
};
const $a95c3ab6a4f11e9d$export$389493eddb34bcab = (contentId, onTemplateData)=>{
    let attempt = 0;
    let timeoutId;
    let unsubscribed = false;
    const read = ()=>{
        if (unsubscribed) return;
        attempt += 1;
        const result = $a95c3ab6a4f11e9d$var$readTemplateData(contentId);
        if (result.status === 'ready') {
            onTemplateData(result.sourceTemplateEntityId);
            return;
        }
        if (attempt < $a95c3ab6a4f11e9d$var$MAX_CACHE_READ_ATTEMPTS) timeoutId = setTimeout(read, $a95c3ab6a4f11e9d$var$CACHE_RETRY_INTERVAL_MS);
    };
    read();
    return {
        unsubscribe: ()=>{
            unsubscribed = true;
            if (timeoutId !== undefined) clearTimeout(timeoutId);
        }
    };
};
module.exports["watchContentHeaderTemplateData"] = $a95c3ab6a4f11e9d$export$389493eddb34bcab;

});

parcelRegister("h3nb6", function(module, exports) {
/* eslint-disable no-restricted-syntax */ 
var $cozmU = parcelRequire("cozmU");


var $64KID = parcelRequire("64KID");


var $kE2cJ = parcelRequire("kE2cJ");


var $jmjWc = parcelRequire("jmjWc");


const $e9270d50e13c4524$export$58ad04e57ec143c3 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "DOtt7",
    name: "RedirectLegacyCopyPageLoader",
    loader: async ()=>(await (parcelRequire("k1GeI"))).RedirectLegacyCopyPage
});
$e9270d50e13c4524$export$58ad04e57ec143c3.NAVIGATION_PARAMS = ()=>false;






const $1547fdfac1788133$export$70a5a4ee184a1106 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "hF4WF",
    name: "RedirectLegacyViewPageLoader",
    loader: async ()=>(await (parcelRequire("eMS5h"))).RedirectLegacyViewPage
});
$1547fdfac1788133$export$70a5a4ee184a1106.NAVIGATION_PARAMS = ()=>false;




/* eslint-disable check-multiple-entry-point-exports/check-multiple-entry-point-exports */ // These are routes shared between SSR and SPA

var $jiFpb = parcelRequire("jiFpb");


var $4lJOK = parcelRequire("4lJOK");


var $hDf9e = parcelRequire("hDf9e");


var $hkCxu = parcelRequire("hkCxu");


var $k1285 = parcelRequire("k1285");


var $SwMnm = parcelRequire("SwMnm");




var $jiJCD = parcelRequire("jiJCD");





var $bEYte = parcelRequire("bEYte");


var $kJOOQ = parcelRequire("kJOOQ");

parcelRequire("1i7uI");


var $aTWRz = parcelRequire("aTWRz");

var $iyEDi = parcelRequire("iyEDi");

const $8012954d5e28a430$export$33ab8fb3f76d8b14 = ()=>{
    const location = (0, $bEYte.useSelector)((0, $iyEDi.getLocation));
    const dispatch = (0, $bEYte.useDispatch)();
    (0, $cozmU.useEffect)(()=>{
        const { query: query, pathname: pathname } = location;
        let contentType;
        if (pathname.indexOf('/createpage.action') !== -1 || pathname.indexOf('/createpage-entervariables.action') !== -1) contentType = 'pages';
        else if (pathname.indexOf('/createblogpost.action') !== -1) contentType = 'blog';
        else {
            dispatch((0, $kJOOQ.replace)({
                pathname: (0, $aTWRz.CONTEXT_PATH)
            }));
            return;
        }
        let spaceKey;
        if (typeof query.spaceKey !== 'undefined' && query.spaceKey) spaceKey = query.spaceKey;
        else if (typeof query.draftId !== 'undefined' && /^[0-9]+$/.test(query.draftId)) spaceKey = 'byDraft';
        else {
            dispatch((0, $kJOOQ.replace)({
                pathname: (0, $aTWRz.CONTEXT_PATH)
            }));
            return;
        }
        const newQuery = {};
        Object.keys(query).filter((param)=>param !== 'spaceKey').forEach((param)=>newQuery[param] = query[param]);
        const nextLocation = {
            ...location,
            pathname: `${(0, $aTWRz.CONTEXT_PATH)}/spaces/${spaceKey}/${contentType}/create`,
            query: newQuery,
            search: (0, $jiJCD.format)({
                query: newQuery
            })
        };
        dispatch((0, $kJOOQ.replace)(nextLocation));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
$8012954d5e28a430$export$33ab8fb3f76d8b14.NAVIGATION_PARAMS = ()=>false;






var $lFjPc = parcelRequire("lFjPc");


var $aVKfT = parcelRequire("aVKfT");

const $d553d8b4da7f3160$export$25552d6a584e1fb8 = ({ params: { appId: appId, envId: envId, forgeManifestRoute: forgeManifestRoute } })=>{
    // Construct the module id from URL params to match the format expected by ForgeGlobalSettingsExtensionPoint
    // Format: ari:cloud:ecosystem::extension/{appId}/{envId}/static/{moduleKey}
    // This matches against app.id in the Forge extensions list
    const id = `ari:cloud:ecosystem::extension/${appId}/${envId}/static/${forgeManifestRoute}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aVKfT.ForgeGlobalSettingsExtensionPoint), {
        key: id,
        id: id
    });
};
$d553d8b4da7f3160$export$25552d6a584e1fb8.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminForgeApps'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $5d42f987126d0d25$var$AdminForgeAppsRedirect = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "vKaNx",
    name: "AdminForgeAppsRedirect",
    loader: async ()=>(await (parcelRequire("imDYW"))).AdminForgeAppsRedirect
});
const $5d42f987126d0d25$export$1eaead8b8e68953c = ({ params: params, query: query })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5d42f987126d0d25$var$AdminForgeAppsRedirect, {
        params: params,
        query: query
    });
};
$5d42f987126d0d25$export$1eaead8b8e68953c.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminForgeAppsRedirect'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









var $aF1vZ = parcelRequire("aF1vZ");


var $9wGTI = parcelRequire("9wGTI");

const $f2fc7f6fc64d8f4e$export$dbb0a9dfd98720f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aF1vZ.AdvancedSearch), null);
$f2fc7f6fc64d8f4e$export$dbb0a9dfd98720f.NAVIGATION_PARAMS = ()=>{
    return {
        Screen: (0, $9wGTI.fg)('unified_search_in_confluence') ? null : {
            screenEvent: {
                name: 'advancedSearchScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID),
            disableMinWidth: true
        }
    };
};


/* eslint react/prop-types:0 */ 









const $f9284ca1d97b2b7a$export$32926c3a37851958 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Rr_Hq",
    name: "BetaFeaturesSiteSettingsPageLoader",
    loader: async ()=>(await (parcelRequire("g9BPs"))).BetaFeaturesSiteSettingsPage
});


const $7949c11e9e78d917$export$39279dc1d0cb138f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f9284ca1d97b2b7a$export$32926c3a37851958), null);
$7949c11e9e78d917$export$39279dc1d0cb138f.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'betaFeaturesScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });








var $8g7sM = parcelRequire("8g7sM");




var $bUMKD = parcelRequire("bUMKD");


var $78QFu = parcelRequire("78QFu");

const $b4ceb88d52b227e6$export$2f64eafbbfb5bb9f = ({ params: { contentId: contentId, externalToken: externalToken }, hash: hash })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bUMKD.ExternalSharePageLoader), {
        contentId: contentId === 'undefined' ? undefined : contentId,
        shareToken: externalToken,
        queryHash: hash,
        ContentRenderer: (0, $8g7sM.default)
    });
$b4ceb88d52b227e6$export$2f64eafbbfb5bb9f.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId } })=>({
        Screen: {
            screenEvent: {
                name: 'viewPageScreen',
                id: contentId,
                attributes: {
                    isPublicView: true,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            },
            pageState: {
                contentId: contentId,
                routeName: name
            }
        },
        MainLayout: false,
        BannerContext: {
            includeTopNav: false
        }
    });












const $2a1308b9f924bd74$export$dceb5680f254ba0d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "4i8AJ",
    name: "ForgeGlobalPageExtensionPoint",
    loader: async ()=>(await (parcelRequire("dOgQ2"))).GlobalPage
});


const $88f9531119605f50$export$a0e2b6c59fd25a4e = ({ params: { appId: appId, envId: envId, forgeManifestRoute: forgeManifestRoute } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2a1308b9f924bd74$export$dceb5680f254ba0d), {
        key: `${appId}-${envId}-${forgeManifestRoute}`,
        appId: appId,
        envId: envId,
        forgeManifestRoute: forgeManifestRoute
    });
$88f9531119605f50$export$a0e2b6c59fd25a4e.NAVIGATION_PARAMS = ({ params: { appId: appId, envId: envId, forgeManifestRoute: forgeManifestRoute } })=>{
    return {
        Screen: {
            screenEvent: {
                name: 'globalPageScreen',
                id: appId,
                attributes: {
                    appId: appId,
                    envId: envId,
                    forgeManifestRoute: forgeManifestRoute
                }
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID)
        }
    };
};












const $5651b1434c6bae88$var$SitePermissions = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "8YbJt",
    name: "SitePermissions",
    loader: async ()=>(await (parcelRequire("6tpf2"))).SitePermissions
});
const $5651b1434c6bae88$export$72e24cb8f0330a61 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5651b1434c6bae88$var$SitePermissions, null);
$5651b1434c6bae88$export$72e24cb8f0330a61.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'sitePermissionsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









var $6X8o4 = parcelRequire("6X8o4");


var $1NBp8 = parcelRequire("1NBp8");


var $ge2sX = parcelRequire("ge2sX");


var $d9tcB = parcelRequire("d9tcB");

function $5340377d047d37c6$export$3c0681f7b17941c4(routeMatch) {
    if (routeMatch?.name === (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).name || routeMatch?.name === (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name && // Hub Dashboard aka Consolidated Settings (https://hello.atlassian.net/wiki/spaces/CLI/pages/4111377280/Project+Poster+Hub+Dashboard) uses /admin/permissions/hub without the tab param and doesn't use the site admin nav there:
    routeMatch?.params?.tab) {
        // https://hello.atlassian.net/wiki/spaces/~701217e532d6bdc7846948a0f4e8afe31a122/pages/3993181421/Company+Hub+-+Beta+Tag+Removal
        // documents the product and design folks of Company Hub want Hub permissions to be among the site admin screens of the product,
        // specifically next to permissions-related screens such as Global permissions, Space permissions, Analytics permissions, etc in
        // the Security section.
        const sessionData = (0, $6X8o4.getValue)((0, $ge2sX.getSessionData)());
        // But for non-site admins the site admin side nav is pretty much empty and, more importantly, there are no other
        // permissions-related screens there. Then Hub permissions in the site admin side nav can only make sense to site admins.
        if (sessionData?.accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS) return true;
    }
    return false;
}



var $9HNv5 = parcelRequire("9HNv5");







var $agglT = parcelRequire("agglT");


const $b11848dc615e604f$export$b212d6e1ccf8d345 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uZr6h",
    loader: async ()=>(await (parcelRequire("69fdq"))).CompanyHubSettingsPage,
    name: 'CompanyHubSettingsPage'
});



var $8NC5Z = parcelRequire("8NC5Z");


var $cEgMD = parcelRequire("cEgMD");


var $1ytiN = parcelRequire("1ytiN");




var $2Uf3N = parcelRequire("2Uf3N");










var $6mKj3 = parcelRequire("6mKj3");















var $iquRY = parcelRequire("iquRY");


const $3dace45d43821ccc$var$SpacePermissionsSettingsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "3C38l",
    name: "SpacePermissionsSettingsRouteComponent",
    loader: async ()=>(parcelRequire("7q2U7"))
});
const $3dace45d43821ccc$var$DEFAULT_TAB = 'users';
const $3dace45d43821ccc$export$c4e68572e7b94bc6 = ({ name: routeName, params: { spaceKey: spaceKey, tab: tab = $3dace45d43821ccc$var$DEFAULT_TAB } })=>{
    //
    // Warning:
    // "Hub permissions" is a customization of "Space permissions" predating RBAC so
    // "Hub permissions" is to be used in the Company Hub-type of space and
    // "Space permissions" or RBAC are to be used in all other types of space!
    //
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    if (tab === 'public-links' && (0, $6mKj3.expValEquals)('shareable_links_m0', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_SETTINGS_ACCESS_LINKS).name,
        params: {
            spaceKey: spaceKey
        }
    });
    if (isCompanyHub) {
        if (routeName !== (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name,
            params: {
                tab: 'users'
            }
        });
    } else {
        //RBAC Milestone 2 Redirect Logic in case users try to access via url
        const isSpacePermissionsTab = tab === 'users' || tab === 'groups' || tab === 'guests';
        if (isSpacePermissionsTab && isRbacEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.SPACE_MEMBERS).name,
            params: {
                spaceKey: spaceKey
            }
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3dace45d43821ccc$var$SpacePermissionsSettingsRouteComponent, {
        spaceKey: spaceKey,
        tab: tab
    });
};
$3dace45d43821ccc$export$c4e68572e7b94bc6.NAVIGATION_PARAMS = (routeMatch)=>{
    const { name: name, params: { spaceKey: spaceKey, tab: tab = $3dace45d43821ccc$var$DEFAULT_TAB } } = routeMatch;
    return {
        Screen: {
            screenEvent: {
                name: tab === 'public-links' ? 'spacePermissionsPublicLinksScreen' : `${tab}SpacePermissionsScreen`,
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: $3dace45d43821ccc$var$getSideNav(routeMatch),
            spaceKey: spaceKey
        }
    };
};
const $3dace45d43821ccc$var$getSideNav = (routeMatch)=>(0, $cEgMD.isCompanyHubSpaceKey)(routeMatch.params.spaceKey) && (0, $5340377d047d37c6$export$3c0681f7b17941c4)(routeMatch) ? (0, $lFjPc.ADMIN_HOME_ID) : (0, $lFjPc.CONTAINER_ADMIN_HOME_ID);









const $94454e5f287d76d5$export$a9d78c41686becfd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "2UE21",
    loader: async ()=>(await (parcelRequire("91mzO"))).SpaceRoleManagementPage,
    name: 'SpaceRoleManagementPage'
});

















const $f9fff28badc7670c$export$214350c926cc60f2 = ({ name: routeName, params: { spaceKey: spaceKey } })=>{
    const { isRbacEnabled: isRbacEnabled, loading: loading } = (0, $iquRY.useSpaceRoleMode)();
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    if (isCompanyHub && routeName !== (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name,
        params: {
            tab: 'users'
        }
    });
    if (!loading && !isRbacEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_OVERVIEW).name,
        params: {
            spaceKey: spaceKey
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $94454e5f287d76d5$export$a9d78c41686becfd), {
        spaceKey: spaceKey
    });
};
$f9fff28badc7670c$export$214350c926cc60f2.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceMembersScreen',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey
        }
    });





/**
 * The routes "Company Hub settings > Users" and "Hub permissions" in the Confluence app.
 * `AdminCompanyHubPermissionsRoute` wraps this one to implement the Company Hub pseudo app.
 */ function $ce2a2ee7f6871785$var$ConfluenceAppHubPermissionsRoute({ params: params, ...props }) {
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    if (isSiteAdmin && shouldShowPremiumUpsell) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9HNv5.CompanyHomeBuilderUpsellPage), {
        featureName: "companyHubPermissions"
    });
    if (!params.tab) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b11848dc615e604f$export$b212d6e1ccf8d345), {
        tab: (0, $agglT.CompanyHubSettingsPageTabsType).USERS
    });
    const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
    if (isRbacEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f9fff28badc7670c$export$214350c926cc60f2), {
        ...props,
        params: {
            spaceKey: spaceKey,
            ...params
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3dace45d43821ccc$export$c4e68572e7b94bc6), {
        ...props,
        params: {
            spaceKey: spaceKey,
            ...params
        }
    });
}
$ce2a2ee7f6871785$var$ConfluenceAppHubPermissionsRoute.NAVIGATION_PARAMS = (routeMatch)=>{
    const { name: name, params: params } = routeMatch;
    const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
    const navView = (0, $5340377d047d37c6$export$3c0681f7b17941c4)(routeMatch) ? (0, $lFjPc.ADMIN_HOME_ID) : (0, $lFjPc.COMPANY_HUB_SETTINGS_ID);
    return {
        Screen: {
            screenEvent: {
                name: `${params.tab || 'consolidated'}HubPermissionsScreen`,
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: navView,
            spaceKey: spaceKey
        }
    };
};
const $ce2a2ee7f6871785$export$eeb7368e8bf944ac = (0, $2Uf3N.getCompanyHubPseudoAppRoute)($ce2a2ee7f6871785$var$ConfluenceAppHubPermissionsRoute);


















const $4fa13b181dc663ad$var$CustomizeNavigation = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Ss1hK",
    name: "CustomizeNavigation",
    loader: async ()=>(await (parcelRequire("eCuyg"))).CustomizeNavigation
});
const $4fa13b181dc663ad$export$3206f56dd9eda6e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4fa13b181dc663ad$var$CustomizeNavigation, null);
$4fa13b181dc663ad$export$3206f56dd9eda6e.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'customizeNavigationScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });
const $4fa13b181dc663ad$export$5744f34ed241a45c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_CUSTOMIZE_NAVIGATION).name
    });
$4fa13b181dc663ad$export$5744f34ed241a45c.NAVIGATION_PARAMS = ()=>false;









const $9dff8dc763109b25$export$a4a7c409f3d3e524 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "LLjB-",
    name: "GlobalAutomationRoute",
    loader: async ()=>(await (parcelRequire("9cEOX"))).Automation
});
$9dff8dc763109b25$export$a4a7c409f3d3e524.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'globalAutomationRoute'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $3e17cd15ad9a2d77$var$UserDetails = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "4otHM",
    name: "UserDetails",
    loader: async ()=>(await (parcelRequire("8RCcR"))).UserDetails
});
const $3e17cd15ad9a2d77$export$ef0ae9b94af7599 = ({ params: { accountId: accountId } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3e17cd15ad9a2d77$var$UserDetails, {
        accountId: accountId
    });
$3e17cd15ad9a2d77$export$ef0ae9b94af7599.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'sitePermissionsUserDetailsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $a311429dbe08f666$export$6b6e4f47fea5bdb9 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "w4gXW",
    name: "ViewPagePdfExportLoader",
    loader: async ()=>(await (parcelRequire("bD1dS"))).ViewPagePdfExportPage
});


parcelRequire("4Yv1J");
var $f5aR2 = parcelRequire("f5aR2");

parcelRequire("crTA1");
var $iqZzD = parcelRequire("iqZzD");

const $de365c057d45c0f8$export$d4d3fe32e0af1ab9 = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a311429dbe08f666$export$6b6e4f47fea5bdb9), {
        contentId: String(contentId),
        spaceKey: String(spaceKey)
    })));
$de365c057d45c0f8$export$d4d3fe32e0af1ab9.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            pageState: {
                contentId: contentId,
                routeName: name,
                spaceKey: spaceKey
            },
            screenEvent: {
                name: 'pdfExportScreen'
            }
        },
        MainLayout: {
            enableNavigation: false,
            spaceKey: spaceKey
        }
    });






var $iJ8K8 = parcelRequire("iJ8K8");


var $djZz9 = parcelRequire("djZz9");

parcelRequire("4Yv1J");


parcelRequire("crTA1");


const $cdc5bb1b4ce25ace$export$f10520cd46ef45dd = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $djZz9.SpaceOverviewLoader), {
        spaceKey: String(spaceKey)
    })));
$cdc5bb1b4ce25ace$export$f10520cd46ef45dd.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            pageState: {
                routeName: name,
                contentId: (0, $iJ8K8.SPACE_OVERVIEW),
                spaceKey: spaceKey
            },
            screenEvent: {
                name: 'pdfExportScreen'
            },
            spaceKey: spaceKey
        },
        MainLayout: {
            enableNavigation: false
        }
    });












var $56QzY = parcelRequire("56QzY");


const $24a857c7c96255d7$var$PeopleDirectory = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "zWQBJ",
    name: "PeopleDirectory",
    loader: async ()=>(await (parcelRequire("1zUsX"))).PeopleDirectory
});
const $24a857c7c96255d7$export$c7bf94fd367d52ef = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($24a857c7c96255d7$var$PeopleDirectory, null);
$24a857c7c96255d7$export$c7bf94fd367d52ef.NAVIGATION_PARAMS = ()=>{
    return {
        Screen: {
            name: 'inProdPeopleDirectory',
            attributes: {
                navdexPointType: (0, $56QzY.START_TOUCH)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID)
        }
    };
};












const $a6aaee7eaacb3bc0$export$1696ac6f866195be = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "MGscQ",
    name: "MarketplaceRoute",
    loader: async ()=>(await (parcelRequire("fb73Z"))).Marketplace
});
$a6aaee7eaacb3bc0$export$1696ac6f866195be.NAVIGATION_PARAMS = ({ name: name })=>{
    let eventName = '';
    let navView = (0, $lFjPc.PRODUCT_HOME_ID);
    if (name === (0, $1NBp8.MARKETPLACE_FIND_APPS).name) {
        eventName = 'marketplaceFindApps';
        navView = (0, $lFjPc.PRODUCT_HOME_ID);
    } else if (name === (0, $1NBp8.MARKETPLACE_APP_REQUESTS).name) {
        eventName = 'marketplaceAppRequests';
        navView = (0, $lFjPc.ADMIN_HOME_ID);
    } else if ((0, $1NBp8.MARKETPLACE_MANAGE_PROMOTIONS).name) {
        eventName = 'marketplacePromotions';
        navView = (0, $lFjPc.ADMIN_HOME_ID);
    }
    return {
        Screen: {
            screenEvent: {
                name: eventName,
                id: eventName
            },
            pageState: {
                routeName: name
            }
        },
        MainLayout: {
            navView: navView
        }
    };
};












const $3dce15286068fd34$export$f2df3d24f362ca75 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "QJy0w",
    name: "ForgeSpacePageExtensionPoint",
    loader: async ()=>(await (parcelRequire("d6uSg"))).SpacePage
});


parcelRequire("crTA1");


const $e20a45805838a7c5$export$16cbc228d727cb5e = ({ params: { appId: appId, envId: envId, forgeManifestRoute: forgeManifestRoute, spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3dce15286068fd34$export$f2df3d24f362ca75), {
        key: appId + envId + forgeManifestRoute,
        spaceKey: spaceKey,
        appId: appId,
        envId: envId,
        forgeManifestRoute: forgeManifestRoute
    }));
};
$e20a45805838a7c5$export$16cbc228d727cb5e.NAVIGATION_PARAMS = ({ name: name, params: { appId: appId, envId: envId, forgeManifestRoute: forgeManifestRoute, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceForgeApps',
                id: spaceKey,
                attributes: {
                    appId: appId,
                    envId: envId,
                    forgeManifestRoute: forgeManifestRoute
                }
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });


/* eslint react/prop-types:0 */ 









const $70d1956925899c9e$var$SpaceSettingsForgeAppsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "zXYF3",
    name: "SpaceSettingsForgeAppsRouteComponent",
    loader: ()=>(parcelRequire("7oqPI"))
});
const $70d1956925899c9e$export$21a09e0ddc77eafe = ({ params: { appId: appId, forgeManifestRoute: forgeManifestRoute, envId: envId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($70d1956925899c9e$var$SpaceSettingsForgeAppsRouteComponent, {
        spaceKey: spaceKey,
        appId: appId,
        envId: envId,
        forgeManifestRoute: forgeManifestRoute
    });
$70d1956925899c9e$export$21a09e0ddc77eafe.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey, appId: appId, envId: envId } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsForgeApps',
                id: spaceKey,
                attributes: {
                    appId: appId,
                    envId: envId
                }
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });


/* eslint react/prop-types:0 */ 









const $3d2592d831aaf97c$var$SpaceSettingsArchiveSpaceRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ZLKey",
    name: "SpaceSettingsArchiveSpaceRouteComponent",
    loader: ()=>(parcelRequire("anIt2"))
});
const $3d2592d831aaf97c$export$c5e406a0947cdc56 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3d2592d831aaf97c$var$SpaceSettingsArchiveSpaceRouteComponent, {
        spaceKey: spaceKey
    });
$3d2592d831aaf97c$export$c5e406a0947cdc56.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsArchiveSpace',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });


/* eslint react/prop-types:0 */ 









const $c1c9698c93be07c8$var$SpaceSettingsEditorConversionRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "640l2",
    name: "SpaceSettingsEditorConversionRouteComponent",
    loader: ()=>(parcelRequire("3X0K1"))
});
const $c1c9698c93be07c8$export$698dfc3fe326e6d2 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c1c9698c93be07c8$var$SpaceSettingsEditorConversionRouteComponent, {
        spaceKey: spaceKey
    });
$c1c9698c93be07c8$export$698dfc3fe326e6d2.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsEditorConversion',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });


/* eslint react/prop-types:0 */ 









const $ada82682e35c0989$var$SpaceSettingsContentStateRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "dJgx9",
    name: "SpaceSettingsContentStateRouteComponent",
    loader: ()=>(parcelRequire("bNraL"))
});
const $ada82682e35c0989$export$9cf7aa4fa48eb220 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ada82682e35c0989$var$SpaceSettingsContentStateRouteComponent, {
        spaceKey: spaceKey
    });
$ada82682e35c0989$export$9cf7aa4fa48eb220.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsContentState',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });












const $5fd2607ebf0fb934$var$SpaceSettingsRelatedPagesRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "z-Bup",
    name: "SpaceSettingsRelatedPagesRouteComponent",
    loader: async ()=>(await (parcelRequire("7ce46"))).SpaceSettingsRelatedPagesRouteComponent
});
const $5fd2607ebf0fb934$export$50efde5a87cc8957 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5fd2607ebf0fb934$var$SpaceSettingsRelatedPagesRouteComponent, {
        spaceKey: spaceKey
    });
$5fd2607ebf0fb934$export$50efde5a87cc8957.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsRelatedPages',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });


/* eslint react/prop-types:0 */ 









const $c991c60ce35a3f45$var$SpaceSettingsEditFeaturesRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "iFso2",
    name: "SpaceSettingsEditFeaturesRouteComponent",
    loader: async ()=>(await (parcelRequire("6NpxL"))).SpaceSettingsEditFeaturesRouteComponent
});
const $c991c60ce35a3f45$export$769dfef0447f3a55 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c991c60ce35a3f45$var$SpaceSettingsEditFeaturesRouteComponent, {
        spaceKey: spaceKey
    });
$c991c60ce35a3f45$export$769dfef0447f3a55.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsEditFeatures',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });






var $feuG2 = parcelRequire("feuG2");




parcelRequire("crTA1");


const $ae6364090fd3faa0$export$45c01163cd56b3a2 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $feuG2.LazySpaceDetailsPage), {
        spaceKey: spaceKey
    }));
};
$ae6364090fd3faa0$export$45c01163cd56b3a2.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: (0, $feuG2.SPACE_SETTINGS_DETAILS_ANALYTICS_SOURCE)
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID)
        }
    });









const $bd0ed31e3ea4d2cc$export$6e087ccb94d5f2ed = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "K9oKK",
    name: "AgentContextPageLoader",
    loader: async ()=>(await (parcelRequire("JHU7C"))).AgentContextPage
});









var $wtSEP = parcelRequire("wtSEP");


var $bQm3c = parcelRequire("bQm3c");

parcelRequire("crTA1");


const $d79bba560e75ebc3$export$5cb7b3311cd85f89 = ({ params: { spaceKey: spaceKey } })=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled } = (0, $bQm3c.useSessionData)();
    if (!isAdminHubAIEnabled || !isAIEarlyAccessEnabled || !(0, $6mKj3.expValEquals)('cc_space_agents_md_context', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $wtSEP.NotFound), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bd0ed31e3ea4d2cc$export$6e087ccb94d5f2ed), {
        spaceKey: spaceKey
    }));
};
$d79bba560e75ebc3$export$5cb7b3311cd85f89.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'agenticSpaceInstructions'
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID)
        }
    });












const $ea3042d7dfb4b938$var$SpaceLookAndFeelSettingsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EJBqs",
    name: "SpaceLookAndFeelSettingsRouteComponent",
    loader: async ()=>(parcelRequire("dVOc4"))
});
const $ea3042d7dfb4b938$export$9ebf5b01b0356442 = ({ params: { spaceKey: spaceKey, tab: tab } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ea3042d7dfb4b938$var$SpaceLookAndFeelSettingsRouteComponent, {
        spaceKey: spaceKey,
        tab: tab
    });
};
$ea3042d7dfb4b938$export$9ebf5b01b0356442.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingLookAndFeelPage',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey
        }
    });












var $8dwdz = parcelRequire("8dwdz");

parcelRequire("crTA1");



const $6079beeead36a4aa$var$ArchivedPagesListContainer = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "mIHzp",
    name: "ArchivedPagesListContainer",
    loader: async ()=>(await (parcelRequire("dJYdT"))).ArchivedPagesListContainer
});
const $6079beeead36a4aa$export$77792abc2bfae7a1 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6079beeead36a4aa$var$ArchivedPagesListContainer, {
        spaceKey: spaceKey
    }));
};
$6079beeead36a4aa$export$77792abc2bfae7a1.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>{
    const isMobile = (0, $8dwdz.shouldShowMobileWeb)();
    return {
        Screen: {
            screenEvent: {
                name: 'spaceArchivedPages',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey,
            enableNavigation: !isMobile
        }
    };
};














/* SpaceContributors.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $iMnC5 = parcelRequire("iMnC5");


var $dinVW = parcelRequire("dinVW");

/* SpaceContributorsList.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");








var $RfroO = parcelRequire("RfroO");








var $4aRua = parcelRequire("4aRua");


var $lfoFx = parcelRequire("lfoFx");


var $3IBnw = parcelRequire("3IBnw");


var $b3j2Y = parcelRequire("b3j2Y");


var $eCryJ = parcelRequire("eCryJ");

/* ContributorCard.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $arQY7 = parcelRequire("arQY7");


var $cJ0FD = parcelRequire("cJ0FD");





var $hS5Ee = parcelRequire("hS5Ee");





var $1l0kj = parcelRequire("1l0kj");








var $a6t12 = parcelRequire("a6t12");

var $5408d211f58300e4$exports = {};
$5408d211f58300e4$exports = new URL("abstract_blue.ba013008.png", import.meta.url).toString();


var $be699ab12dc43aa9$exports = {};
$be699ab12dc43aa9$exports = new URL("abstract_gray.49aefa84.png", import.meta.url).toString();


var $7ee742c354fd2752$exports = {};
$7ee742c354fd2752$exports = new URL("abstract_lime.614f08cd.png", import.meta.url).toString();


var $5fee51c4b71a3fd7$exports = {};
$5fee51c4b71a3fd7$exports = new URL("abstract_orange.75bb3294.png", import.meta.url).toString();


var $391f9026f9bc0e84$exports = {};
$391f9026f9bc0e84$exports = new URL("abstract_purple.32c2eaba.png", import.meta.url).toString();


var $4f6cff1274f63d16$exports = {};
$4f6cff1274f63d16$exports = new URL("abstract_2_blue.92cdf214.png", import.meta.url).toString();


var $7124ae07608a9ac7$exports = {};
$7124ae07608a9ac7$exports = new URL("abstract_2_gray.a253343b.png", import.meta.url).toString();


var $1627504052ef1311$exports = {};
$1627504052ef1311$exports = new URL("abstract_2_lime.3f0a3533.png", import.meta.url).toString();


var $5549486cda89f704$exports = {};
$5549486cda89f704$exports = new URL("abstract_2_orange.ba5b7dd0.png", import.meta.url).toString();


var $ba73b990ff542752$exports = {};
$ba73b990ff542752$exports = new URL("abstract_2_purple.dd28c3fc.png", import.meta.url).toString();


var $bf73f4d1117b01ca$exports = {};
$bf73f4d1117b01ca$exports = new URL("cloud_blue.aed012f6.png", import.meta.url).toString();


var $640deabf51ee99b8$exports = {};
$640deabf51ee99b8$exports = new URL("cloud_gray.a167c078.png", import.meta.url).toString();


var $badb2b526642b3d6$exports = {};
$badb2b526642b3d6$exports = new URL("cloud_lime.d827708d.png", import.meta.url).toString();


var $3fad6f63e411f1ce$exports = {};
$3fad6f63e411f1ce$exports = new URL("cloud_orange.0a9d30da.png", import.meta.url).toString();


var $c024621255868f2d$exports = {};
$c024621255868f2d$exports = new URL("cloud_purple.db3e6e0e.png", import.meta.url).toString();


var $e5810e6e99c81e39$exports = {};
$e5810e6e99c81e39$exports = new URL("default_blue.a7d8e57a.png", import.meta.url).toString();


var $062ac0e813f16ac2$exports = {};
$062ac0e813f16ac2$exports = new URL("default_gray.62ae8414.png", import.meta.url).toString();


var $e9656e196be12691$exports = {};
$e9656e196be12691$exports = new URL("default_lime.68e476a8.png", import.meta.url).toString();


var $83950ecddf4072ac$exports = {};
$83950ecddf4072ac$exports = new URL("default_orange.bbf67771.png", import.meta.url).toString();


var $f94163b506c65aaf$exports = {};
$f94163b506c65aaf$exports = new URL("default_purple.863e0469.png", import.meta.url).toString();


var $9bc9109a3b819555$exports = {};
$9bc9109a3b819555$exports = new URL("default_2_blue.9968944b.png", import.meta.url).toString();


var $b6f9f2c16fd45484$exports = {};
$b6f9f2c16fd45484$exports = new URL("default_2_gray.3bed0158.png", import.meta.url).toString();


var $9ccce80298538a8c$exports = {};
$9ccce80298538a8c$exports = new URL("default_2_lime.1b02187b.png", import.meta.url).toString();


var $72e3bf68db6677b8$exports = {};
$72e3bf68db6677b8$exports = new URL("default_2_orange.9138d10b.png", import.meta.url).toString();


var $ff3249c10f9ae76e$exports = {};
$ff3249c10f9ae76e$exports = new URL("default_2_purple.51ed90f3.png", import.meta.url).toString();


var $37f10eae34a4c388$exports = {};
$37f10eae34a4c388$exports = new URL("dev_blue.c51e69f0.png", import.meta.url).toString();


var $517134280e31bfbc$exports = {};
$517134280e31bfbc$exports = new URL("dev_gray.9f2b2ad6.png", import.meta.url).toString();


var $bad00f909f6e636b$exports = {};
$bad00f909f6e636b$exports = new URL("dev_lime.62d11101.png", import.meta.url).toString();


var $06ef2ec623858b8c$exports = {};
$06ef2ec623858b8c$exports = new URL("dev_orange.aaa9d6d8.png", import.meta.url).toString();


var $74d0b7a6a8ecbb33$exports = {};
$74d0b7a6a8ecbb33$exports = new URL("dev_purple.31b25562.png", import.meta.url).toString();


var $229f49d7cae85b1f$exports = {};
$229f49d7cae85b1f$exports = new URL("launch_blue.a76d899d.png", import.meta.url).toString();


var $0382458999fd864c$exports = {};
$0382458999fd864c$exports = new URL("launch_gray.1c67bf3d.png", import.meta.url).toString();


var $1da9f6aa63e26f2a$exports = {};
$1da9f6aa63e26f2a$exports = new URL("launch_lime.d253b1e6.png", import.meta.url).toString();


var $bc8976d6d52c9436$exports = {};
$bc8976d6d52c9436$exports = new URL("launch_orange.4675ff98.png", import.meta.url).toString();


var $a97c73c89a4a7c02$exports = {};
$a97c73c89a4a7c02$exports = new URL("launch_purple.a73bfdf5.png", import.meta.url).toString();


var $037f1160dd55938b$exports = {};
$037f1160dd55938b$exports = new URL("meetings_blue.77ac6747.png", import.meta.url).toString();


var $6a474b500d957868$exports = {};
$6a474b500d957868$exports = new URL("meetings_gray.68e6f7ea.png", import.meta.url).toString();


var $ade36522d6c5b655$exports = {};
$ade36522d6c5b655$exports = new URL("meetings_lime.7adbc297.png", import.meta.url).toString();


var $15d4a7103a79c114$exports = {};
$15d4a7103a79c114$exports = new URL("meetings_orange.cd5e170c.png", import.meta.url).toString();


var $a87f8560011410ac$exports = {};
$a87f8560011410ac$exports = new URL("meetings_purple.605f1d57.png", import.meta.url).toString();


const $74e1981ac7fa4f8b$var$HEADER_IMAGES = [
    (0, (/*@__PURE__*/$parcel$interopDefault($5408d211f58300e4$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($391f9026f9bc0e84$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($7ee742c354fd2752$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($5fee51c4b71a3fd7$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($be699ab12dc43aa9$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4f6cff1274f63d16$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($ba73b990ff542752$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($1627504052ef1311$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($5549486cda89f704$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($7124ae07608a9ac7$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($bf73f4d1117b01ca$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($c024621255868f2d$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($badb2b526642b3d6$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($3fad6f63e411f1ce$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($640deabf51ee99b8$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($e5810e6e99c81e39$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($f94163b506c65aaf$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($e9656e196be12691$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($83950ecddf4072ac$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($062ac0e813f16ac2$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($9bc9109a3b819555$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($ff3249c10f9ae76e$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($9ccce80298538a8c$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($72e3bf68db6677b8$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b6f9f2c16fd45484$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($37f10eae34a4c388$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($74d0b7a6a8ecbb33$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($bad00f909f6e636b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($06ef2ec623858b8c$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($517134280e31bfbc$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($229f49d7cae85b1f$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($a97c73c89a4a7c02$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($1da9f6aa63e26f2a$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($bc8976d6d52c9436$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($0382458999fd864c$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($037f1160dd55938b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($a87f8560011410ac$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($ade36522d6c5b655$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($15d4a7103a79c114$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($6a474b500d957868$exports)))
];
/**
 * Simple hash function that converts a string to a numeric hash.
 * Uses a multiplicative hash for good distribution.
 */ const $74e1981ac7fa4f8b$var$hashString = (str)=>{
    let hash = 5381;
    for(let i = 0; i < str.length; i++)hash = Math.abs((hash * 33 + str.charCodeAt(i)) % 2147483647);
    return hash;
};
const $74e1981ac7fa4f8b$export$f4539ec1c290b2c9 = (accountId)=>{
    const index = $74e1981ac7fa4f8b$var$hashString(accountId) % $74e1981ac7fa4f8b$var$HEADER_IMAGES.length;
    return $74e1981ac7fa4f8b$var$HEADER_IMAGES[index];
};


const $4005975cfd549f33$var$i18n = (0, $kSwu1.defineMessages)({
    deactivated: {
        id: "space-contributors.card.deactivated",
        defaultMessage: "({label})"
    },
    deactivatedLabel: {
        id: "space-contributors.card.deactivated.label",
        defaultMessage: "Deactivated"
    },
    roleAdmin: {
        id: "space-contributors.card.role.space-admin",
        defaultMessage: "Space Admin"
    },
    roleOwner: {
        id: "space-contributors.card.role.space-owner",
        defaultMessage: "Space Owner"
    },
    roleAuthor: {
        id: "space-contributors.card.role.author",
        defaultMessage: "Author"
    },
    roleReviewer: {
        id: "space-contributors.card.role.content-reviewer",
        defaultMessage: "Content Reviewer"
    }
});
const $4005975cfd549f33$var$roleLabels = {
    admin: $4005975cfd549f33$var$i18n.roleAdmin,
    owner: $4005975cfd549f33$var$i18n.roleOwner,
    author: $4005975cfd549f33$var$i18n.roleAuthor,
    reviewer: $4005975cfd549f33$var$i18n.roleReviewer
}; // Separator between role labels.
const $4005975cfd549f33$var$ROLE_SEPARATOR = " \xb7 ";
const $4005975cfd549f33$var$styles = {
    card: "_0bjKvDyzSk _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0aFT5vbt8w _0jFU0VN91d _0KLXrulfZc _3e6OgrLl21 _0wOv4Q7zJH",
    cardSelected: "_0bjKvDyzSk _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0aFT5vbt8w _0jFU0VN91d _0KLXrulfZc _2zndIC2M4S _497WNw6wH8 _2xIroYrzt2 _3e6OgrLl21 _0wOv4Q7zJH",
    cardDeactivated: "_0bjKvDyzSk _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0aFT5vbt8w _0jFU0VN91d _0KLXruDMqu _3e6OgrLl21 _0wOv4Q7zJH",
    headerImageContainer: "_4bt5LAnQyn _2WAcuGnQyn _0jFU0VOYQB _39xV02N91d _2C2kUQyzSk _1Lz9loyzSk",
    content: "_2mHwu82ADO _2Y7lL45zaO _3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _0hPCNLchRC _0xmtko5zaO _43nrzTYfXA",
    details: "_2mHwu81Y8M _3iDTPbQ4SZ _0aFT5vbt8w",
    locationPill: "_0bjKvDKTcp _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _2Y7lL4gVvo _3iDTPbQ4SZ _0hPCNLDIqT _0jFU0VoWWg _0KLXruDMqu _43nrzTIZbP"
};
const $4005975cfd549f33$export$3f45fa6d1e6fb5fe = ({ contributor: contributor })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [isSelected, setIsSelected] = (0, $cozmU.useState)(false);
    const handleVisibilityChange = (0, $cozmU.useCallback)((isVisible)=>{
        setIsSelected(isVisible);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
        userId: contributor.accountId,
        trigger: "click",
        position: (0, $6mKj3.expValEquals)('confluence_profile_card_consistent_updates', 'isEnabled', true) ? 'bottom-start' : 'right-start',
        onVisibilityChange: handleVisibilityChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box // eslint-disable-next-line no-nested-ternary -- simple 3-way style selection
    ), {
        xcss: contributor.isDeactivated ? $4005975cfd549f33$var$styles.cardDeactivated : isSelected ? $4005975cfd549f33$var$styles.cardSelected : $4005975cfd549f33$var$styles.card,
        testId: `contributor-card-${contributor.accountId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4005975cfd549f33$var$styles.headerImageContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, $74e1981ac7fa4f8b$export$f4539ec1c290b2c9)(contributor.accountId),
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4005975cfd549f33$var$styles.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        name: contributor.displayName,
        src: contributor.avatarUrl,
        size: "large",
        borderColor: "transparent"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small"
    }, contributor.displayName), contributor.isDeactivated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        size: "small"
    }, intl.formatMessage($4005975cfd549f33$var$i18n.deactivated, {
        label: intl.formatMessage($4005975cfd549f33$var$i18n.deactivatedLabel)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4005975cfd549f33$var$styles.details
    }, contributor.jobTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        size: "small",
        weight: "bold"
    }, contributor.jobTitle), contributor.roles.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        size: "small"
    }, contributor.roles.map((role)=>intl.formatMessage($4005975cfd549f33$var$roleLabels[role])).join($4005975cfd549f33$var$ROLE_SEPARATOR))), contributor.location && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4005975cfd549f33$var$styles.locationPill
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hS5Ee))), {
        label: "",
        color: "var(--ds-icon-subtlest, #6B6E76)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        size: "small"
    }, contributor.location))))));
};


/**
 * @generated SignedSource<<ff50d48748c63ec4cdd5bb639c59dda0>>
 * @relayHash 6d398f53c96bfaf582af7d85174c1481
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b8f4bcff577614f0cd50804d51d1a52bedfe13340434f25cdb870ac70f0d0576
const $c404042e788b052b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceId"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "spaceId"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceSpaceDetailsSpaceOwner",
                    "kind": "LinkedField",
                    "name": "spaceOwner",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "ownerId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ownerType"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "excludeAddOns",
                            "value": true
                        },
                        {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "first"
                        }
                    ],
                    "concreteType": "PaginatedPersonList",
                    "kind": "LinkedField",
                    "name": "spaceAdmins",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "accountId"
                                        }
                                    ],
                                    "type": "KnownUser"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSpaceContributorsSpaceRolesQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSpaceContributorsSpaceRolesQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "6d398f53c96bfaf582af7d85174c1481",
            "id": "b8f4bcff577614f0cd50804d51d1a52bedfe13340434f25cdb870ac70f0d0576",
            "metadata": {},
            "name": "useSpaceContributorsSpaceRolesQuery",
            "operationKind": "query",
            "text": "query useSpaceContributorsSpaceRolesQuery($spaceId:ID!,$first:Int){space(id:$spaceId){id,spaceOwner{ownerId,ownerType},spaceAdmins(first:$first,excludeAddOns:true){nodes{__typename,...on KnownUser{accountId}}}}}"
        }
    };
}();
$c404042e788b052b$var$node.hash = "70920be3ede0d2e90eadf91c05d60d4d";
var $c404042e788b052b$export$2e2bcd8739ae039 = $c404042e788b052b$var$node;


/**
 * @generated SignedSource<<b464c3df6969ab84d10211fa30ac7b69>>
 * @relayHash d75d16a26345da232a85278f7f8a7f26
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6fee2900d8282f6ef6eb1192ccf06760e28526158f2ceb7b0067ceb74e5220ba
const $d66f845f28280c4a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "AtlassianAccountUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jobTitle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "location"
                    }
                ]
            }
        ],
        "type": "AtlassianAccountUser"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceContributorsFetchUsersBatchQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceContributorsFetchUsersBatchQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "d75d16a26345da232a85278f7f8a7f26",
            "id": "6fee2900d8282f6ef6eb1192ccf06760e28526158f2ceb7b0067ceb74e5220ba",
            "metadata": {},
            "name": "useSpaceContributorsFetchUsersBatchQuery",
            "operationKind": "query",
            "text": "query useSpaceContributorsFetchUsersBatchQuery($accountIds:[ID!]!){users(accountIds:$accountIds){__typename,accountId,picture,name,accountStatus,...on AtlassianAccountUser{extendedProfile{jobTitle,location}},id}}"
        }
    };
}();
$d66f845f28280c4a$var$node.hash = "3c787c59d546902e58ea64ec5829ab7f";
var $d66f845f28280c4a$export$2e2bcd8739ae039 = $d66f845f28280c4a$var$node;






var $c0rhi = parcelRequire("c0rhi");





var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $aBfpe = parcelRequire("aBfpe");


var $dK51B = parcelRequire("dK51B");





var $7QM6o = parcelRequire("7QM6o");

// Max role labels shown per contributor.
const $8fbc34173e9b34f3$var$MAX_ROLES = 2;
const $8fbc34173e9b34f3$var$FetchUsersBatchQuery = (0, $d66f845f28280c4a$export$2e2bcd8739ae039);
const $8fbc34173e9b34f3$var$AGG_USERS_BATCH_LIMIT = 90;
const $8fbc34173e9b34f3$var$normalizeLocation = (location)=>{
    if (!location) return undefined;
    return location.replace(/^Home office:\s*/i, '').trim() || undefined;
};
const $8fbc34173e9b34f3$var$MIN_CREATED_THRESHOLD = 5;
const $8fbc34173e9b34f3$var$MIN_UPDATED_THRESHOLD = 10;
const $8fbc34173e9b34f3$var$MIN_COMMENT_THRESHOLD = 10;
const $8fbc34173e9b34f3$var$hasSignificantActivity = (entry)=>(entry.created ?? 0) >= $8fbc34173e9b34f3$var$MIN_CREATED_THRESHOLD || (entry.updated ?? 0) >= $8fbc34173e9b34f3$var$MIN_UPDATED_THRESHOLD || (entry.commentCreated ?? 0) >= $8fbc34173e9b34f3$var$MIN_COMMENT_THRESHOLD;
const $8fbc34173e9b34f3$export$18cd2142783a34b5 = (entry, spaceRoles)=>{
    const roles = [];
    if ((entry.created ?? 0) >= $8fbc34173e9b34f3$var$MIN_CREATED_THRESHOLD) roles.push('author');
    if ((entry.updated ?? 0) >= $8fbc34173e9b34f3$var$MIN_UPDATED_THRESHOLD || (entry.commentCreated ?? 0) >= $8fbc34173e9b34f3$var$MIN_COMMENT_THRESHOLD) roles.push('reviewer');
    // Owner takes precedence over admin, and both lead the list when present.
    if (spaceRoles.ownerId === entry.accountId) roles.unshift('owner');
    else if (spaceRoles.adminIds.has(entry.accountId) && roles.length > 0) // Only surface the admin role when the user also has at least one other role.
    roles.unshift('admin');
    return roles.slice(0, $8fbc34173e9b34f3$var$MAX_ROLES);
};
const $8fbc34173e9b34f3$var$compareContributors = (a, b)=>{
    // Pages created is the primary sort (more superior)
    const createdDiff = (b.created ?? 0) - (a.created ?? 0);
    if (createdDiff !== 0) return createdDiff;
    // Edits (updated) as secondary sort
    const updatedDiff = (b.updated ?? 0) - (a.updated ?? 0);
    if (updatedDiff !== 0) return updatedDiff;
    // Comments as tertiary sort
    return (b.commentCreated ?? 0) - (a.commentCreated ?? 0);
};
const $8fbc34173e9b34f3$var$fetchUserProfiles = async (accountIds, signal)=>{
    const profileMap = new Map();
    if (accountIds.length === 0 || signal.aborted) return profileMap;
    const batches = [];
    for(let i = 0; i < accountIds.length; i += $8fbc34173e9b34f3$var$AGG_USERS_BATCH_LIMIT)batches.push(accountIds.slice(i, i + $8fbc34173e9b34f3$var$AGG_USERS_BATCH_LIMIT));
    const processBatch = async (batch)=>{
        if (signal.aborted) return;
        try {
            const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
                query: $8fbc34173e9b34f3$var$FetchUsersBatchQuery,
                variables: {
                    accountIds: batch
                },
                interopApolloAggClient: true,
                __callerPackage__: "space-contributors"
            });
            if (error?.graphQLErrors) error.graphQLErrors.forEach((0, $7Sm4c.markErrorAsHandled));
            const users = data?.users ?? [];
            for (const user of users)if (user !== null) profileMap.set(user.accountId, {
                displayName: user.name ?? user.accountId,
                avatarUrl: user.picture ?? undefined,
                jobTitle: user.extendedProfile?.jobTitle ?? undefined,
                location: $8fbc34173e9b34f3$var$normalizeLocation(user.extendedProfile?.location),
                isDeactivated: user.accountStatus !== 'active'
            });
        } catch  {
        // Silently handle batch failures
        }
    };
    await Promise.all(batches.map(processBatch));
    return profileMap;
};
const $8fbc34173e9b34f3$var$FetchSpaceRolesQuery = (0, $c404042e788b052b$export$2e2bcd8739ae039);
const $8fbc34173e9b34f3$var$SPACE_ADMINS_LIMIT = 50;
const $8fbc34173e9b34f3$var$fetchSpaceRoles = async (spaceId, signal)=>{
    const adminIds = new Set();
    let ownerId;
    if (!spaceId || signal.aborted) return {
        adminIds: adminIds,
        ownerId: ownerId
    };
    try {
        const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
            query: $8fbc34173e9b34f3$var$FetchSpaceRolesQuery,
            variables: {
                spaceId: spaceId,
                first: $8fbc34173e9b34f3$var$SPACE_ADMINS_LIMIT
            },
            interopApolloAggClient: true,
            __callerPackage__: "space-contributors"
        });
        if (error?.graphQLErrors) error.graphQLErrors.forEach((0, $7Sm4c.markErrorAsHandled));
        for (const node of data?.space?.spaceAdmins?.nodes ?? [])if (node?.accountId) adminIds.add(node.accountId);
        const owner = data?.space?.spaceOwner;
        if (owner?.ownerType === 'USER' && owner.ownerId) ownerId = owner.ownerId;
    } catch (error) {
        // Roles are additive; report the failure but still render contributors.
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).DISCO
        });
    }
    return {
        adminIds: adminIds,
        ownerId: ownerId
    };
};
const $8fbc34173e9b34f3$var$TODAY = new Date();
const $8fbc34173e9b34f3$var$SIX_MONTHS_AGO = new Date($8fbc34173e9b34f3$var$TODAY);
$8fbc34173e9b34f3$var$SIX_MONTHS_AGO.setMonth($8fbc34173e9b34f3$var$TODAY.getMonth() - 6);
const $8fbc34173e9b34f3$var$FROM_DATE = $8fbc34173e9b34f3$var$SIX_MONTHS_AGO.toISOString().split('T')[0];
const $8fbc34173e9b34f3$var$TO_DATE = $8fbc34173e9b34f3$var$TODAY.toISOString().split('T')[0];
const $8fbc34173e9b34f3$var$TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;
const $8fbc34173e9b34f3$var$EMPTY_VARIABLES = {};
const $8fbc34173e9b34f3$var$parseActivityResult = (json)=>({
        experimentalAnalyticsActivityByUser: json
    });
const $8fbc34173e9b34f3$export$57e3e2823ad3ffc8 = (spaceKey)=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const spaceId = (0, $7QM6o.useSpaceId)(spaceKey);
    const [contributors, setContributors] = (0, $cozmU.useState)([]);
    const [profilesLoading, setProfilesLoading] = (0, $cozmU.useState)(true);
    const [profilesError, setProfilesError] = (0, $cozmU.useState)(null);
    const abortControllerRef = (0, $cozmU.useRef)(null);
    const url = (0, $cozmU.useMemo)(()=>{
        if (!cloudId || !spaceId) return '';
        const params = new URLSearchParams({
            fromDate: $8fbc34173e9b34f3$var$FROM_DATE,
            toDate: $8fbc34173e9b34f3$var$TO_DATE,
            timezone: $8fbc34173e9b34f3$var$TIMEZONE,
            content: 'page,livedoc',
            spaceId: spaceId,
            sortBy: 'created',
            sortOrder: 'desc',
            limit: '50'
        });
        return `/gateway/api/ex/confluence/${cloudId}/analytics/v2/activityByUser?${params.toString()}`;
    }, [
        cloudId,
        spaceId
    ]);
    const { data: data, loading: activityLoading, error: error } = (0, $dK51B.useExperimentalQuery)({
        url: url,
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResult: $8fbc34173e9b34f3$var$parseActivityResult,
        skip: !cloudId || !spaceId,
        variables: $8fbc34173e9b34f3$var$EMPTY_VARIABLES
    });
    const activeEntries = (0, $cozmU.useMemo)(()=>(data?.experimentalAnalyticsActivityByUser?.activityByUser ?? []).filter($8fbc34173e9b34f3$var$hasSignificantActivity).sort($8fbc34173e9b34f3$var$compareContributors), [
        data
    ]);
    const resolveProfiles = (0, $cozmU.useCallback)(async (entries, resolvedSpaceId)=>{
        // Cancel any in-flight profile fetch
        abortControllerRef.current?.abort();
        const controller = new AbortController();
        abortControllerRef.current = controller;
        setProfilesLoading(true);
        setProfilesError(null);
        try {
            // Roles and the activity-entry profiles have no interdependency, so
            // fetch them concurrently rather than waterfalling.
            const entryIds = entries.map((entry)=>entry.accountId);
            const [spaceRoles, profileMap] = await Promise.all([
                $8fbc34173e9b34f3$var$fetchSpaceRoles(resolvedSpaceId, controller.signal),
                $8fbc34173e9b34f3$var$fetchUserProfiles(entryIds, controller.signal)
            ]);
            // Account ids with a space-level role.
            const roleIds = new Set(spaceRoles.adminIds);
            if (spaceRoles.ownerId) roleIds.add(spaceRoles.ownerId);
            // Owners/admins not already among the activity entries still need
            // their profiles resolved.
            const fetchedIds = new Set(entryIds);
            const extraIds = Array.from(roleIds).filter((id)=>!fetchedIds.has(id));
            if (extraIds.length > 0 && !controller.signal.aborted) {
                const extraProfiles = await $8fbc34173e9b34f3$var$fetchUserProfiles(extraIds, controller.signal);
                extraProfiles.forEach((profile, id)=>profileMap.set(id, profile));
            }
            // Merge activity entries with owners/admins, deduping by accountId.
            // Owners/admins without activity are added with zero counts.
            const mergedEntries = new Map();
            for (const entry of entries)mergedEntries.set(entry.accountId, entry);
            for (const accountId of roleIds)if (!mergedEntries.has(accountId)) mergedEntries.set(accountId, {
                accountId: accountId,
                created: 0,
                updated: 0,
                commentCreated: 0,
                viewed: 0
            });
            const dedupedEntries = Array.from(mergedEntries.values()).sort($8fbc34173e9b34f3$var$compareContributors);
            if (!controller.signal.aborted) {
                // Single pass over the (already activity-sorted) entries: resolve
                // each profile and drop contributors with no surfaced role. In
                // practice the dropped ones are admins who have not authored or
                // reviewed any content, which should not appear on the list at all.
                const resolved = [];
                for (const entry of dedupedEntries){
                    const roles = $8fbc34173e9b34f3$export$18cd2142783a34b5(entry, spaceRoles);
                    if (roles.length === 0) continue;
                    const profile = profileMap.get(entry.accountId);
                    resolved.push({
                        ...entry,
                        displayName: profile?.displayName ?? entry.accountId,
                        avatarUrl: profile?.avatarUrl,
                        jobTitle: profile?.jobTitle,
                        location: profile?.location,
                        isDeactivated: profile?.isDeactivated ?? false,
                        roles: roles
                    });
                }
                // Sink deactivated users to the bottom while preserving the
                // activity-based order within each group (Array.sort is stable).
                resolved.sort((a, b)=>Number(a.isDeactivated) - Number(b.isDeactivated));
                setContributors(resolved);
            }
        } catch (err) {
            if (!controller.signal.aborted) setProfilesError(err instanceof Error ? err : new Error('Failed to load contributor profiles'));
        } finally{
            setProfilesLoading(false);
        }
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (activityLoading) return;
        if (spaceId) resolveProfiles(activeEntries, spaceId);
        else {
            setContributors([]);
            setProfilesLoading(false);
        }
        return ()=>{
            abortControllerRef.current?.abort();
        };
    }, [
        activeEntries,
        resolveProfiles,
        activityLoading,
        spaceId
    ]);
    return {
        contributors: contributors,
        loading: activityLoading || profilesLoading,
        error: error ?? profilesError
    };
};


const $ca40d910a8d2b8d4$var$i18n = (0, $kSwu1.defineMessages)({
    empty: {
        id: "space-contributors.list.empty",
        defaultMessage: "No contributors found for this space."
    },
    loading: {
        id: "space-contributors.list.loading",
        defaultMessage: "Loading contributors\u2026"
    },
    errorHeading: {
        id: "space-contributors.list.error.heading",
        defaultMessage: "We couldn't load contributors"
    },
    errorDescription: {
        id: "space-contributors.list.error.description",
        defaultMessage: "Something went wrong while loading the contributors for this space. Try refreshing the page."
    }
});
const $ca40d910a8d2b8d4$var$styles = {
    container: "",
    loadingContainer: "_4c065UVa5s _3iDTPbQ4SZ _37wbyuDIqT"
};
const $ca40d910a8d2b8d4$var$gridStyles = null;
const $ca40d910a8d2b8d4$var$SpaceContributorsListComponent = ({ spaceKey: spaceKey })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { contributors: contributors, loading: loading, error: error } = (0, $8fbc34173e9b34f3$export$57e3e2823ad3ffc8)(spaceKey);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ca40d910a8d2b8d4$var$styles.loadingContainer,
        testId: "space-contributors-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "medium",
        label: intl.formatMessage($ca40d910a8d2b8d4$var$i18n.loading)
    }));
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $RfroO.default), {
        header: intl.formatMessage($ca40d910a8d2b8d4$var$i18n.errorHeading),
        description: intl.formatMessage($ca40d910a8d2b8d4$var$i18n.errorDescription),
        testId: "space-contributors-error"
    }));
    if (contributors.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ca40d910a8d2b8d4$var$styles.container,
        testId: "space-contributors-empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, intl.formatMessage($ca40d910a8d2b8d4$var$i18n.empty)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ca40d910a8d2b8d4$var$styles.container,
        testId: "space-contributors-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "space-contributors-grid",
        className: (0, $hekY6.default)([
            "_2mHwu85zaO _3iDTPbgBM8 _2iEGP2COKq _2PYtbaPTnU"
        ])
    }, contributors.map((contributor)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4005975cfd549f33$export$3f45fa6d1e6fb5fe), {
            key: contributor.accountId,
            contributor: contributor
        })))));
};
const $ca40d910a8d2b8d4$var$renderErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ca40d910a8d2b8d4$var$i18n.errorHeading);
const $ca40d910a8d2b8d4$export$5f10e7078a8df25b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        renderOnError: $ca40d910a8d2b8d4$var$renderErrorFallback,
        attribution: (0, $3IBnw.Attribution).DISCO
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ca40d910a8d2b8d4$var$SpaceContributorsListComponent, props));


const $262ca66c88e39807$var$i18n = (0, $kSwu1.defineMessages)({
    pageTitle: {
        id: "space-contributors.page.title",
        defaultMessage: "Contributors"
    }
});
const $262ca66c88e39807$var$styles = {
    page: "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _4c065UVa5s _2Y7lL4Va5s _1EqgXlNy1d _0u2WMmrU95"
};
const $262ca66c88e39807$export$e06119d84e0ded1e = ({ spaceKey: spaceKey })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $262ca66c88e39807$var$styles.page,
        testId: "space-contributors-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "large"
    }, intl.formatMessage($262ca66c88e39807$var$i18n.pageTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ca40d910a8d2b8d4$export$5f10e7078a8df25b), {
        spaceKey: spaceKey
    })));
};


parcelRequire("crTA1");


const $4a57d37907c9234e$export$68e37a802707fb55 = ({ params: { spaceKey: spaceKey } })=>{
    if (!(0, $6mKj3.expVal)('confluence_space_contributors', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $wtSEP.NotFound), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $262ca66c88e39807$export$e06119d84e0ded1e), {
        spaceKey: spaceKey
    }));
};
$4a57d37907c9234e$export$68e37a802707fb55.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>{
    if (!(0, $6mKj3.expVal)('confluence_space_contributors', 'isEnabled', false)) return false;
    return {
        Screen: {
            screenEvent: {
                name: 'spaceContributorsScreen',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    };
};












const $b162f5655e630145$export$9fe8c29db9617eb = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "uRwN3",
    name: "ContentIntelligenceLoader",
    loader: async ()=>(await (parcelRequire("h3iF6"))).ContentIntelligenceRouter
});












const $66b672cbde35247d$export$985a05086f0c4fb5 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Z6Ec2",
    name: "SpaceSuggestionsLoader",
    loader: async ()=>(await (parcelRequire("eJcP8"))).SpaceSuggestions
});


parcelRequire("crTA1");


const $2593d4b17876c400$export$a3041cafa4dd68cd = ({ params: { spaceKey: spaceKey } })=>{
    if (!(0, $6mKj3.expVal)('confluence_space_organizer', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $wtSEP.NotFound), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, (0, $6mKj3.expVal)('confluence_content_intelligence', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b162f5655e630145$export$9fe8c29db9617eb), {
        spaceKey: spaceKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $66b672cbde35247d$export$985a05086f0c4fb5), {
        spaceKey: spaceKey
    }));
};
$2593d4b17876c400$export$a3041cafa4dd68cd.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>{
    if (!(0, $6mKj3.expVal)('confluence_space_organizer', 'isEnabled', false)) return false;
    return {
        Screen: {
            screenEvent: {
                name: 'spaceSuggestionsScreen',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    };
};


/* eslint react/prop-types:0 */ 









const $9ad8ac092b3ce6dd$var$SpaceSettingsDataClassificationRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EYcHq",
    name: "SpaceSettingsDataClassificationRouteComponent",
    loader: ()=>(parcelRequire("knHrR"))
});
const $9ad8ac092b3ce6dd$export$4b1ffbf66f0e44ca = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9ad8ac092b3ce6dd$var$SpaceSettingsDataClassificationRouteComponent, {
        spaceKey: spaceKey
    });
$9ad8ac092b3ce6dd$export$4b1ffbf66f0e44ca.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsDataClassification',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });


/* eslint react/prop-types:0 */ 









const $0db33795337c2a26$var$SpaceSettingsWatermarkConfigurationRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "oooFg",
    name: "SpaceSettingsWatermarkConfigurationRouteComponent",
    loader: ()=>(parcelRequire("8VPuN"))
});
const $0db33795337c2a26$export$2bb331cf926ecae2 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0db33795337c2a26$var$SpaceSettingsWatermarkConfigurationRouteComponent, {
        spaceKey: spaceKey
    });
$0db33795337c2a26$export$2bb331cf926ecae2.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsWatermarkConfiguration',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });






var $bDjCi = parcelRequire("bDjCi");

const $e84d6ad8839aa142$export$355693d248632c9a = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bDjCi.LazyTeamCalendars), {
        calendarContext: (0, $bDjCi.CALENDAR_CONTEXT).MY_CALENDARS
    });
};
$e84d6ad8839aa142$export$355693d248632c9a.NAVIGATION_PARAMS = ({ spaceKey: spaceKey })=>({
        Screen: {
            screenEvent: {
                name: 'myCalendarsScreen',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            spaceKey: spaceKey
        }
    });








const $d017e5de5f44817e$export$6443958a7203f769 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bDjCi.LazyTeamCalendars), {
        calendarContext: (0, $bDjCi.CALENDAR_CONTEXT).MULTIPLE_CALENDARS
    });
};
$d017e5de5f44817e$export$6443958a7203f769.NAVIGATION_PARAMS = ({ spaceKey: spaceKey })=>({
        Screen: {
            screenEvent: {
                name: 'multipleCalendarsScreen',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            spaceKey: spaceKey
        }
    });








const $d3bef7a856c272ba$export$5984a4822491c8de = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bDjCi.LazyTeamCalendars), {
        calendarContext: (0, $bDjCi.CALENDAR_CONTEXT).EMBEDDED_MULTIPLE_CALENDARS
    });
};
$d3bef7a856c272ba$export$5984a4822491c8de.NAVIGATION_PARAMS = ({ spaceKey: spaceKey })=>({
        Screen: {
            screenEvent: {
                name: 'embeddedMultipleCalendarsScreen',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            enableNavigation: false,
            spaceKey: spaceKey
        }
    });


/* eslint-disable react/prop-types */ 












const $116a232d5237eb91$var$SpaceTeamCalendarsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "tO6zv",
    name: "SpaceTeamCalendarsRouteComponent",
    loader: ()=>(parcelRequire("h1QnW"))
});
const $116a232d5237eb91$export$c1ba174e1a668b1a = ({ params: { subCalendarId: subCalendarId } })=>{
    const calendarContext = subCalendarId ? (0, $bDjCi.CALENDAR_CONTEXT).SPACE_SUBCALENDAR : (0, $bDjCi.CALENDAR_CONTEXT).SPACE_CALENDARS;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($116a232d5237eb91$var$SpaceTeamCalendarsRouteComponent, {
        subCalendarId: subCalendarId,
        calendarContext: calendarContext
    });
};
$116a232d5237eb91$export$c1ba174e1a668b1a.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, subCalendarId: subCalendarId } })=>{
    return {
        Screen: {
            screenEvent: {
                name: 'spaceTeamCalendarsScreen',
                id: spaceKey,
                attributes: {
                    isSingleCalendar: !!subCalendarId
                }
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    };
};








const $40c2c72cc1663e14$export$b6ba0c14cb68dffc = ({ params: { subCalendarId: subCalendarId } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bDjCi.LazyTeamCalendars), {
        calendarContext: (0, $bDjCi.CALENDAR_CONTEXT).EMBEDDED_SUBCALENDAR,
        subCalendarId: subCalendarId
    });
};
$40c2c72cc1663e14$export$b6ba0c14cb68dffc.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, subCalendarId: subCalendarId } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceEmbeddedSubcalendarScreen',
                id: spaceKey,
                attributes: {
                    subCalendarId: subCalendarId
                }
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            enableNavigation: false,
            spaceKey: spaceKey
        }
    });












const $8089a5c0318e4300$export$d299494231e51197 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "XYKgm",
    name: "LazySpaceDirectory",
    loader: async ()=>(await (parcelRequire("9C1qb"))).SpaceDirectory
});


const $6b9376eebbcdd446$export$e2f6c7ec524fdd6a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8089a5c0318e4300$export$d299494231e51197), null);
$6b9376eebbcdd446$export$e2f6c7ec524fdd6a.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'spaceDirectoryScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID),
            disableMinWidth: true
        }
    });





















const $bdfe305fbc319d8d$var$SpaceSettingsLandingPageRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EHSjL",
    name: "SpaceSettingsLandingPageRouteComponent",
    loader: ()=>(parcelRequire("lEzA0"))
});
const $bdfe305fbc319d8d$export$b0e13503df86295 = ({ params: { spaceKey: spaceKey } })=>{
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).name,
        params: {
            spaceKey: spaceKey,
            tab: 'users'
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bdfe305fbc319d8d$var$SpaceSettingsLandingPageRouteComponent, {
        spaceKey: spaceKey
    });
};
$bdfe305fbc319d8d$export$b0e13503df86295.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsLandingPage',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey
        }
    });









var $6O2BV = parcelRequire("6O2BV");





var $lTECB = parcelRequire("lTECB");


var $ep3mz = parcelRequire("ep3mz");





var $3d5UI = parcelRequire("3d5UI");





var $7EX8o = parcelRequire("7EX8o");

parcelRequire("4Yv1J");



var $4H46k = parcelRequire("4H46k");


var $9pOEz = parcelRequire("9pOEz");

const $6c697104f01a0e5d$var$EmbeddedSpaceOverview = ({ spaceKey: spaceKey, contentId: contentId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        padding: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7EX8o.EmbeddedViewPageLoader), {
        contentId: contentId,
        spaceKey: spaceKey,
        ClassicEditorContextProviderLoader: (0, $6O2BV.ClassicEditorContextProviderLoader),
        showHeaderButtons: false
    }));
};
const $6c697104f01a0e5d$var$SpaceOverview = ({ spaceKey: spaceKey, onExperienceResolved: onExperienceResolved })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $djZz9.SpaceOverviewSwitcherLoader), {
        spaceKey: spaceKey,
        onExperienceResolved: onExperienceResolved
    });
};
const $6c697104f01a0e5d$export$495cec58911c040d = ({ spaceKey: spaceKey })=>{
    const [contextContentId] = (0, $ep3mz.usePageContentId)();
    const [spaceOverviewExperience, setSpaceOverviewExperience] = (0, $cozmU.useState)('unknown');
    const contentId = contextContentId ?? '';
    (0, $cozmU.useEffect)(()=>{
        if (!contentId || !(0, $9wGTI.fg)('cc-dlp-ensure-content-id-for-legacy-space-overview')) return;
        (0, $3d5UI.waitForGlobal)({
            listener: 'SpaceOverviewRouteComponent.tsx',
            globalProperty: 'AJS.Meta.set'
        }, ()=>{
            window.AJS.Meta.set('content-id-alt', contentId);
        });
        return ()=>{
            window.AJS?.Meta?.set?.('content-id-alt', undefined);
        };
    }, [
        contentId
    ]);
    const component = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6c697104f01a0e5d$var$EmbeddedSpaceOverview, {
        contentId: contentId,
        spaceKey: spaceKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6c697104f01a0e5d$var$SpaceOverview, {
        spaceKey: spaceKey,
        onExperienceResolved: setSpaceOverviewExperience
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9pOEz.CommentContextWrapper), null, component)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H46k.LazyDwellTime), {
        attributes: {
            spaceOverviewExperience: spaceOverviewExperience
        }
    }));
};
var $6c697104f01a0e5d$export$2e2bcd8739ae039 = $6c697104f01a0e5d$export$495cec58911c040d;


const $8290afb66ac54848$export$200c90655ff1c697 = (0, $4lJOK.getSpaceOverviewRoute)((0, $6c697104f01a0e5d$export$495cec58911c040d));





















const $0b1718e5f1e38843$export$26b856d756d6b8dc = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "h8KkD",
    name: "HubRendererLoader",
    loader: async ()=>(await (parcelRequire("g6gor"))).HubRendererComponent
});








parcelRequire("4Yv1J");









const $f6b27607b6d81126$var$EmbeddedHubRenderer = ({ spaceKey: spaceKey, contentId: contentId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        padding: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7EX8o.EmbeddedViewPageLoader), {
        contentId: contentId,
        spaceKey: spaceKey,
        ClassicEditorContextProviderLoader: (0, $6O2BV.ClassicEditorContextProviderLoader),
        showHeaderButtons: false
    }));
};
const $f6b27607b6d81126$export$964c57d73cd4c096 = ({ spaceKey: spaceKey })=>{
    const [contextContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = contextContentId ?? '';
    const component = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f6b27607b6d81126$var$EmbeddedHubRenderer, {
        contentId: contentId,
        spaceKey: spaceKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0b1718e5f1e38843$export$26b856d756d6b8dc), {
        spaceKey: spaceKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9pOEz.CommentContextWrapper), null, component)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H46k.LazyDwellTime), null));
};
const $f6b27607b6d81126$export$d8819c37d45ffdfc = (0, $hDf9e.getCompanyHubRoute)((0, $6c697104f01a0e5d$export$495cec58911c040d));


























/**
 * The route "Company Hub settings > Analytics" in the Confluence app.
 * `CompanyHubAnalyticsRoute` wraps this one to implement the Company Hub pseudo app.
 */ function $b5f6e0dacae3f98e$var$ConfluenceAppHubAnalyticsRoute() {
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
    if (shouldShowPremiumUpsell) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9HNv5.CompanyHomeBuilderUpsellPage), {
        featureName: "companyHub"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b11848dc615e604f$export$b212d6e1ccf8d345), {
        tab: (0, $agglT.CompanyHubSettingsPageTabsType).ANALYTICS
    });
}
$b5f6e0dacae3f98e$var$ConfluenceAppHubAnalyticsRoute.NAVIGATION_PARAMS = ()=>{
    const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
    const navView = (0, $lFjPc.COMPANY_HUB_SETTINGS_ID);
    return {
        Screen: {
            screenEvent: {
                name: 'companyHubAnalytics'
            },
            pageState: {
                routeName: (0, $1NBp8.COMPANY_HUB_ANALYTICS).name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: navView
        }
    };
};
const $b5f6e0dacae3f98e$export$ccf9c625603cc873 = (0, $2Uf3N.getCompanyHubPseudoAppRoute)($b5f6e0dacae3f98e$var$ConfluenceAppHubAnalyticsRoute);









var $eXODy = parcelRequire("eXODy");








var $65DSU = parcelRequire("65DSU");


var $8zMP3 = parcelRequire("8zMP3");


var $2VZOl = parcelRequire("2VZOl");


var $8KbKw = parcelRequire("8KbKw");


var $hQm1C = parcelRequire("hQm1C");


var $eqNP8 = parcelRequire("eqNP8");








var $39rFu = parcelRequire("39rFu");


var $8Hqv7 = parcelRequire("8Hqv7");


var $6gETM = parcelRequire("6gETM");


var $8jRXE = parcelRequire("8jRXE");


var $3gyyc = parcelRequire("3gyyc");

const $6a336fa33a376cf7$var$EditPageLoaderInternal = ({ contentId: contentId, spaceKey: spaceKey, draftShareId: draftShareId, contentType: contentType, ClassicEditorContextProviderLoader: ClassicEditorContextProviderLoader })=>{
    const [prevContentId, setPrevContentId] = (0, $cozmU.useState)(contentId);
    const [prevContentType, setPrevContentType] = (0, $cozmU.useState)(contentType);
    const { referredFromLivePage: referredFromLivePage } = (0, $39rFu.useEditPageLoadingValues)();
    const { loadEditor: setEditPageLoadingValues } = (0, $39rFu.useEditPageLoadingActions)();
    const [livePageTransitionHandled, setLivePageTransitionHandled] = (0, $cozmU.useState)(false);
    // This useEffect allows us to unmount and remount the ClassicEditorContextProvider,
    // NativeCollabLoader, and FullPageEditor when switching from one edit page to another edit page.
    // This is necessary to reset the editor properly for edit -> edit transitions.
    (0, $cozmU.useEffect)(()=>{
        setPrevContentId(contentId);
        setLivePageTransitionHandled(false);
    }, [
        contentId
    ]);
    (0, $cozmU.useEffect)(()=>{
        setPrevContentType(contentType);
    }, [
        contentType
    ]);
    // Be careful when modifying this useEffect as this can break live page -> edit page transitions
    // This effect is a temporary solution to address an issue where the editor does not reset properly when navigating from a live page.
    // The editor tends to hold onto state from the previous page, causing problems when switching between pages if a full unmount doesn't occur.
    // This effects resets the editor by force-unmounting it by showing the loading screen when it detects a transition from a live page.
    (0, $cozmU.useEffect)(()=>{
        // livePageTransitionHandled is used to prevent the editor from showing the loading screen endlessly
        if (referredFromLivePage && !livePageTransitionHandled) {
            setLivePageTransitionHandled(true);
            // Need to reset this property or it'll be retained when the browser back button is used.
            // In that case, it doesn't go through the flow that sets the value again.
            setEditPageLoadingValues({
                referredFromLivePage: undefined
            });
        }
    }, [
        referredFromLivePage,
        livePageTransitionHandled,
        setEditPageLoadingValues
    ]);
    if (contentId !== prevContentId || contentType !== prevContentType || referredFromLivePage && !livePageTransitionHandled) // isLoading is set to true by a state change, which does not happen immediately after content id changes
    // To make sure loading screen shows up immediately after content id changes, compare new content id with the content id in ref
    // This is smilar to how componentWillUpdate works in a classic react component
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eqNP8.FullPageLoadingScreen), null);
    const EditPageWrapper = ClassicEditorContextProviderLoader ?? (({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "edit-page-default-wrapper"
        }, children));
    return(// @ts-ignore - Property 'isWithinEditor' is missing in type '{ children: Element; }' but required in type '{ children: any; isWithinEditor: any; }'
    // This error was introduced after upgrading to TypeScript 5
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(EditPageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2VZOl.NativeCollabPresenceStateContainer), {
        scope: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hQm1C.NativeCollabLoader), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType,
        permissionTokenRefresh: (0, $8KbKw.fetchCollabPermissionToken)(contentId, draftShareId)
    }, (propsFromNativeCollab)=>{
        if (propsFromNativeCollab.subType === 'live' && !propsFromNativeCollab.isOverviewPage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.VIEW_PAGE).name,
            params: {
                contentId: contentId,
                spaceKey: spaceKey
            }
        });
        return (0, $3gyyc.isSSRStreaming)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
            dataFetcherName: "content-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gETM.TreeRootForServerPlaceholderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jRXE.FullPageEditorLoader), {
            ...propsFromNativeCollab,
            extensionContextProvider: {
                ClassicEditorContextProvider: ClassicEditorContextProviderLoader
            }
        }))) : // This TreeRootForServerPlaceholderWrapper placed here to ensure the proper lookup of the placeholders for
        // SSRed loadables. Due to different component trees between server (EditPageLoader) and client (EditPageLoaderServer)
        // the placeholder ids hierarchy is different. This wrapper terminates the lookup for placeholder ids on the common parent,
        // so it matches on both server and client.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Hqv7.FullCycleRenderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gETM.TreeRootForServerPlaceholderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jRXE.FullPageEditorLoader), {
            ...propsFromNativeCollab,
            extensionContextProvider: {
                ClassicEditorContextProvider: ClassicEditorContextProviderLoader
            }
        })));
    }))));
};
const $6a336fa33a376cf7$export$b6d447abe5222d2c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
        name: "edit-page-loader"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6a336fa33a376cf7$var$EditPageLoaderInternal, props));
};



var $ak57N = parcelRequire("ak57N");


var $34NZw = parcelRequire("34NZw");


var $5vi32 = parcelRequire("5vi32");














var $cZa7r = parcelRequire("cZa7r");










const $0e80cf500c4229e5$var$EditPageContent = ({ contentId: contentId, spaceKey: spaceKey, draftShareId: draftShareId, contentType: contentType })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6a336fa33a376cf7$export$b6d447abe5222d2c), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType,
        ClassicEditorContextProviderLoader: (0, $6O2BV.ClassicEditorContextProviderLoader)
    });
const $0e80cf500c4229e5$export$5cc0e8d070ec38e9 = ({ params: { contentId: contentId, spaceKey: spaceKey, contentType: editRouteTypeParam }, query: query, pathname: pathname })=>{
    const draftShareId = typeof query?.draftShareId === 'string' ? query.draftShareId : undefined;
    // editRouteTypeParam !== contentType !== pageType
    // editContentType is blog or pages
    // contentType is blogpost or page
    // pageType is blog or page
    const contentType = editRouteTypeParam === 'blog' ? 'blogpost' : 'page';
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const shouldRedirectCompanyHubEditRoute = isCompanyHub && (0, $1NBp8.COMPANY_HUB_EDIT).pattern !== pathname;
    if (shouldRedirectCompanyHubEditRoute) // The company hub edit route should handle upsell scenarios and other cases
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.COMPANY_HUB_EDIT).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cZa7r.AnnotationsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, (0, $3gyyc.isSSRStreaming)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e80cf500c4229e5$var$EditPageContent, {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ak57N.EditPageLoaderServer), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6a336fa33a376cf7$export$b6d447abe5222d2c), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType,
        ClassicEditorContextProviderLoader: (0, $6O2BV.ClassicEditorContextProviderLoader)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $34NZw.PageShownPublicLinksEventLoader), {
        contentId: contentId,
        isPage: editRouteTypeParam === 'page',
        isEditPage: true
    })));
};
$0e80cf500c4229e5$export$5cc0e8d070ec38e9.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey, contentType: editRouteTypeParam } })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const showPremiumOnboarding = !isEmbeddedConfluence;
    const isPageLikeContent = editRouteTypeParam === 'pages' || editRouteTypeParam === 'blog';
    const isBlog = editRouteTypeParam === 'blog';
    // editRouteTypeParam !== contentType
    // editRouteTypeParam is blog or pages
    // contentType is blogpost or page
    const contentType = editRouteTypeParam === 'blog' ? 'blogpost' : 'page';
    let viewId = (0, $lFjPc.CONTAINER_HOME_ID);
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) viewId = (0, $lFjPc.PRODUCT_HOME_ID);
    else if (isBlog) viewId = (0, $lFjPc.CONTAINER_HOME_ID);
    return {
        Screen: {
            screenEvent: {
                name: 'editPageScreen',
                id: contentId,
                attributes: {
                    isPublicView: false,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)(),
                    navdexPointType: (0, $56QzY.END)
                }
            },
            pageState: {
                routeName: routeName,
                spaceKey: spaceKey,
                contentId: contentId,
                contentType: contentType
            },
            showPremiumOnboarding: isPageLikeContent ? showPremiumOnboarding : false
        },
        MainLayout: {
            navView: viewId,
            spaceKey: spaceKey,
            editorPreloader: isPageLikeContent ? (0, $eXODy.getEditorPreloader) : undefined,
            disableMinWidth: false,
            isViewPage: true,
            isEdit: true
        }
    };
};


const $1f7939e43bf6965f$export$335f265b0f783405 = (0, $hkCxu.getCompanyHubEditRoute)((0, $0e80cf500c4229e5$export$5cc0e8d070ec38e9));












var $hjUDQ = parcelRequire("hjUDQ");


var $eX4up = parcelRequire("eX4up");

















var $6gbpH = parcelRequire("6gbpH");


var $7f6xB = parcelRequire("7f6xB");


var $cbvYp = parcelRequire("cbvYp");




const $ca035e1fc91a5c2a$export$b1a4eb0063bc2123 = ({ params: { contentId: contentId, contentType: editRouteTypeParam } })=>{
    const sessionData = (0, $bQm3c.useSessionData)();
    // Don't render until session data is available to prevent context errors
    if (!sessionData) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gbpH.HubEditorWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cbvYp.ConfluenceDependenciesProvider), {
        mode: (0, $hjUDQ.ExtensionMode).EDITOR,
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7f6xB.HeadingLinksStyleWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eX4up.default), {
        contentId: contentId,
        product: "CONFLUENCE",
        hasEditPermission: true,
        viewMode: "edit",
        userPreferencesProvider: undefined,
        isLoomPluginEnabled: false,
        editorPluginAIOptions: undefined,
        editorPluginAIDefinitionsEnabled: false,
        editorPluginAIDefinitionsConfig: undefined,
        isDesktop: false,
        contextPanelOptions: undefined,
        getExtensionHeight: undefined,
        __rendererExtensionOptions: undefined,
        PropsProvider: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $34NZw.PageShownPublicLinksEventLoader), {
        contentId: contentId,
        isPage: editRouteTypeParam === 'page',
        isEditPage: true
    })))));
};
$ca035e1fc91a5c2a$export$b1a4eb0063bc2123.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey } })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const showPremiumOnboarding = !isEmbeddedConfluence;
    const contentType = 'page';
    const viewId = (0, $lFjPc.PRODUCT_HOME_ID);
    const screenEventName = 'companyHubEditorScreen';
    const screenIsInSpace = false;
    return {
        Screen: {
            screenEvent: {
                name: screenEventName,
                id: spaceKey,
                attributes: {
                    isPublicView: false,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)(),
                    navdexPointType: (0, $56QzY.END),
                    screenIsInSpace: screenIsInSpace
                }
            },
            pageState: {
                routeName: routeName,
                spaceKey: spaceKey,
                contentId: contentId,
                contentType: contentType
            },
            showPremiumOnboarding: showPremiumOnboarding
        },
        MainLayout: {
            navView: viewId,
            spaceKey: spaceKey,
            editorPreloader: (0, $eXODy.getEditorPreloader),
            disableMinWidth: true,
            isViewPage: true,
            isEdit: true
        }
    };
};


const $437f27e114bb0121$export$29545d7913f7e4d9 = (0, $k1285.getCompanyHubEditorRoute)((0, $ca035e1fc91a5c2a$export$b1a4eb0063bc2123));


















/**
 * The route "Company Hub settings" in the Confluence app.
 * `CompanyHubSettingsRoute` wraps this one to implement the Company Hub pseudo app.
 */ const $dbfb738401d21a8a$var$ConfluenceAppHubSettingsRoute = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b11848dc615e604f$export$b212d6e1ccf8d345), null);
$dbfb738401d21a8a$var$ConfluenceAppHubSettingsRoute.NAVIGATION_PARAMS = ()=>{
    const navView = (0, $lFjPc.COMPANY_HUB_SETTINGS_ID);
    return {
        Screen: {
            screenEvent: {
                name: 'companyHubSettingsScreen',
                attributes: {
                    // Company Hub hides its space from the user, doesn't refer to its page
                    // as such, is rather presented to the user as "a new surface", and thus
                    // doesn't constitute space usage from the perspective of the user.
                    screenIsInSpace: false
                }
            },
            pageState: {
                routeName: (0, $1NBp8.COMPANY_HUB_SETTINGS).name,
                spaceKey: (0, $cEgMD.getCompanyHubSpaceKey)()
            }
        },
        MainLayout: {
            navView: navView
        }
    };
};
const $dbfb738401d21a8a$export$5df4bb70a888e6ef = (0, $2Uf3N.getCompanyHubPseudoAppRoute)($dbfb738401d21a8a$var$ConfluenceAppHubSettingsRoute);

















parcelRequire("crTA1");



const $3ae3b5e6a32b9f05$var$SpacePages = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Mg0yj",
    name: "SpacePages",
    loader: async ()=>(await (parcelRequire("aJzDd"))).SpacePages
});
const $3ae3b5e6a32b9f05$export$64ef8a59e56631d4 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3ae3b5e6a32b9f05$var$SpacePages, null));
};
$3ae3b5e6a32b9f05$export$64ef8a59e56631d4.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spacePagesScreen',
                attributes: {
                    navigationLayer: 'container',
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            editorPreloader: (0, $eXODy.getEditorPreloader),
            disableMinWidth: true
        }
    });








parcelRequire("crTA1");





const $5fbf62dcc2c7f9c7$export$59ba7d1ff575355e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H46k.LazySpaceBlogRedirect), null));
$5fbf62dcc2c7f9c7$export$59ba7d1ff575355e.NAVIGATION_PARAMS = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'blogHomeScreen'
            },
            pageState: {
                spaceKey: spaceKey,
                contentId: contentId
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });












const $604611f3b9c6a1bd$export$6fe611e4bd8a9f83 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "KbMaW",
    name: 'ManagePagesLoader',
    loader: async ()=>{
        return (await (parcelRequire("hzmgd"))).ManagePagesV2;
    }
});






var $lt6Lx = parcelRequire("lt6Lx");




parcelRequire("crTA1");


const $95e685c28d9f350e$export$690ececaf2f5ac01 = ({ params: { spaceKey: spaceKey } })=>{
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lt6Lx.DocumentContentTitle), {
        notFound: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $wtSEP.NotFound), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $604611f3b9c6a1bd$export$6fe611e4bd8a9f83), {
        spaceKey: spaceKey
    }));
};
$95e685c28d9f350e$export$690ececaf2f5ac01.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceBulkTools',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey
        }
    });









const $c51c7f4fbe27db1f$export$e8ec235e2dc3d2c4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1mKe4",
    name: "TemplateMigrationPreviewLoader",
    loader: async ()=>(await (parcelRequire("6ymI6"))).TemplateMigrationPreview
});


const $a310d6589e3c6137$export$2549ad5558b468ce = ({ params: { contentId: contentId } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c51c7f4fbe27db1f$export$e8ec235e2dc3d2c4), {
        templateId: contentId
    });
$a310d6589e3c6137$export$2549ad5558b468ce.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId } })=>({
        Screen: {
            screenEvent: {
                name: 'templateMigrationPreviewScreen'
            },
            pageState: {
                routeName: name,
                contentId: contentId
            }
        },
        MainLayout: false
    });












const $ab6a74840300f72c$export$8cf1c696fd3c0922 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-xoDL",
    name: "TemplateEditorLoader",
    loader: async ()=>{
        const { TemplateEditor: TemplateEditor } = await (parcelRequire("9gpO8"));
        return TemplateEditor;
    }
});


function $db60bab822fccf44$var$getId(params) {
    const { contentId: contentId, pluginKey: pluginKey, moduleKey: moduleKey } = params;
    return !contentId && moduleKey ? `${pluginKey}:${moduleKey}` : contentId;
}
const $db60bab822fccf44$export$b015e9e7191a93bd = ({ params: params })=>{
    const id = $db60bab822fccf44$var$getId(params);
    const { spaceKey: spaceKey } = params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6O2BV.ClassicEditorContextProviderLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ab6a74840300f72c$export$8cf1c696fd3c0922), {
        templateId: id,
        spaceKey: spaceKey
    }));
};
$db60bab822fccf44$export$b015e9e7191a93bd.NAVIGATION_PARAMS = ({ params: params })=>{
    const id = $db60bab822fccf44$var$getId(params);
    const { spaceKey: spaceKey } = params;
    return {
        Screen: {
            screenEvent: {
                name: 'editTemplatePageScreen',
                id: id || ''
            },
            pageState: {
                contentId: id,
                spaceKey: spaceKey
            }
        },
        MainLayout: false,
        BannerContext: {
            includeTopNav: false
        }
    };
};









const $e6c819a73b1c7672$export$70238cd3868b67c9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "gd8xC",
    name: "Onboarding",
    loader: async ()=>(await (parcelRequire("5xPzo"))).Onboarding
});






var $4PPzL = parcelRequire("4PPzL");

const $52219feed318a69e$export$329ee42b27a3306e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).CE_MAU
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e6c819a73b1c7672$export$70238cd3868b67c9), null));
$52219feed318a69e$export$329ee42b27a3306e.NAVIGATION_PARAMS = ({ name: name })=>({
        Screen: {
            screenEvent: {
                name: 'onboardingContainerScreen'
            },
            pageState: {
                routeName: name
            }
        },
        MainLayout: false
    });















const $9c31020ce936d864$export$e63bb7d08a16e003 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "krpYG",
    name: "NewContentHistory",
    loader: async ()=>(await (parcelRequire("2pjLv"))).NewContentHistory
});








const $48c85dee1e05da94$var$parseVersionParam = (value)=>{
    if (!value || Array.isArray(value)) return undefined;
    const parsedValue = parseInt(value, 10);
    return isNaN(parsedValue) ? undefined : parsedValue;
};
const $48c85dee1e05da94$var$ContentHistoryRouteComponent = ({ params: { spaceKey: spaceKey, contentId: contentId }, query: query })=>{
    const version1 = $48c85dee1e05da94$var$parseVersionParam(query?.version1);
    const version2 = $48c85dee1e05da94$var$parseVersionParam(query?.version2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6O2BV.ClassicEditorContextProviderLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9c31020ce936d864$export$e63bb7d08a16e003), {
        contentId: contentId,
        spaceKey: spaceKey,
        ClassicEditorContextProviderLoader: (0, $6O2BV.ClassicEditorContextProviderLoader),
        version1: version1,
        version2: version2
    }));
};
$48c85dee1e05da94$var$ContentHistoryRouteComponent.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, contentId: contentId, contentSlug: contentSlug } })=>{
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    return {
        Screen: {
            screenEvent: {
                name: isCompanyHub ? 'hubHistoryScreen' : 'pageHistoryScreen',
                id: contentId
            },
            pageState: {
                spaceKey: spaceKey,
                contentId: contentId,
                contentSlug: contentSlug
            }
        },
        MainLayout: {
            spaceKey: spaceKey,
            navView: isCompanyHub ? (0, $lFjPc.COMPANY_HUB_SETTINGS_ID) : (0, $lFjPc.CONTAINER_HOME_ID)
        }
    };
};
const $48c85dee1e05da94$export$e510023ce2e8f364 = (0, $2Uf3N.getCompanyHubPseudoAppRoute)($48c85dee1e05da94$var$ContentHistoryRouteComponent, (route)=>(0, $cEgMD.isCompanyHubSpaceKey)(route?.params?.spaceKey));












const $64e99ecf69e59c34$export$9defecaf7509c9ff = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "NjYCL",
    name: "TemplateGalleryLoader",
    loader: async ()=>(await (parcelRequire("aTtll"))).TemplateGallery
});


const $0f81c6a8d9931e4d$export$e2ed88affe37abdc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $64e99ecf69e59c34$export$9defecaf7509c9ff), null);
$0f81c6a8d9931e4d$export$e2ed88affe37abdc.NAVIGATION_PARAMS = ({ name: name })=>({
        Screen: {
            screenEvent: {
                name: 'templateGalleryScreen'
            },
            pageState: {
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID),
            disableMinWidth: true
        }
    });









const $eedda2b5abe28404$export$25901255b411dbc4 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "hLwu8",
    name: "MacroRendererPageLoader",
    loader: async ()=>(await (parcelRequire("99E45"))).MacroRendererPage
});


parcelRequire("4Yv1J");


const $fcdf58a0a381c832$export$29b5dbba9b9e21d8 = ({ params: { contentId: contentId } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eedda2b5abe28404$export$25901255b411dbc4), {
        contentId: contentId,
        ContentExtensionsProvider: (0, $f5aR2.ContentExtensionsProvider)
    });
};
$fcdf58a0a381c832$export$29b5dbba9b9e21d8.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId } })=>({
        Screen: {
            screenEvent: {
                name: 'mobileMacroRendererScreen',
                id: contentId,
                attributes: {
                    contentId: contentId
                }
            },
            pageState: {
                routeName: name,
                contentId: contentId
            }
        },
        MainLayout: false // No navigation layout needed for mobile app view
    });









const $7b810fd40f00ac37$var$MobileAppTakeoverPageLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "oLwa7",
    name: "MobileAppTakeoverPageLoader",
    loader: async ()=>(await (parcelRequire("dVA4j"))).MobileAppTakeoverPage
});
const $7b810fd40f00ac37$export$1a98ae7373202607 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7b810fd40f00ac37$var$MobileAppTakeoverPageLoader, null);
$7b810fd40f00ac37$export$1a98ae7373202607.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'mobileTakeoverPage'
            }
        },
        MainLayout: false
    });









var $hwzJf = parcelRequire("hwzJf");


var $idSff = parcelRequire("idSff");

const $75f6c666a9c742b2$export$e5707bd7e32dbf9b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $idSff.SiteHomepageRedirectLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hwzJf.GoToHomeLoader), null));
$75f6c666a9c742b2$export$e5707bd7e32dbf9b.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'wikiScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID)
        }
    });

















const $4625b8b3d160569d$export$48d3d184aade51b1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hwzJf.GoToHomeLoader), null);
$4625b8b3d160569d$export$48d3d184aade51b1.NAVIGATION_PARAMS = ({ name: name })=>({
        Screen: {
            screenEvent: {
                name: 'homeScreen',
                attributes: {
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            },
            pageState: {
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID),
            editorPreloader: (0, $eXODy.getEditorPreloader)
        }
    });











const $92a0e12da2d6b5f0$export$bf305e48a79a981b = {
    attributes: {
        navdexPointType: (0, $56QzY.END)
    }
};


const $c3c08e13adc00b49$export$daeca97aa431dd80 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H46k.LazySpaceCreatePage), {
        contentType: "blogpost"
    });
$c3c08e13adc00b49$export$daeca97aa431dd80.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageScreen',
                ...(0, $92a0e12da2d6b5f0$export$bf305e48a79a981b)
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: false
    });









const $93e08279e521422d$export$92431fd1ef2a3e02 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H46k.LazySpaceCreatePage), {
        contentType: "page"
    });
$93e08279e521422d$export$92431fd1ef2a3e02.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageScreen',
                ...(0, $92a0e12da2d6b5f0$export$bf305e48a79a981b)
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: false
    });






var $8MiHL = parcelRequire("8MiHL");





const $2807fe6645e49e0b$export$6a3218472cdf374a = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8MiHL.LazyRouteToRightEditor), {
        contentType: "pages",
        contentId: contentId,
        spaceKey: spaceKey
    });
$2807fe6645e49e0b$export$6a3218472cdf374a.NAVIGATION_PARAMS = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageScreen',
                id: contentId,
                attributes: {
                    ...(0, $92a0e12da2d6b5f0$export$bf305e48a79a981b).attributes,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey
            }
        },
        MainLayout: false
    });











const $cdf2efa932a544ee$export$657999c2675036a8 = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8MiHL.LazyRouteToRightEditor), {
        contentType: "blog",
        contentId: contentId,
        spaceKey: spaceKey
    });
$cdf2efa932a544ee$export$657999c2675036a8.NAVIGATION_PARAMS = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageScreen',
                id: contentId,
                attributes: {
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'blogpost'
            }
        },
        MainLayout: false
    });













const $9ba53981e2ca7f45$export$a835caedc175b18 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "c8AJW",
    name: "EmbeddedEditPageLoader",
    loader: async ()=>(await (parcelRequire("3W396"))).EmbeddedEditPage
});



const $dde5e37bf0f94188$export$a338f76d183c610 = ({ params: { contentId: contentId, spaceKey: spaceKey }, query: { draftShareId: draftShareId } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6O2BV.ClassicEditorContextProviderLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ba53981e2ca7f45$export$a835caedc175b18), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: String(draftShareId),
        contentType: "page"
    }));
$dde5e37bf0f94188$export$a338f76d183c610.NAVIGATION_PARAMS = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageEmbedScreen',
                id: contentId,
                ...(0, $92a0e12da2d6b5f0$export$bf305e48a79a981b)
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'page'
            }
        },
        MainLayout: false,
        BannerContext: {
            includeTopNav: false
        }
    });












const $91e544e3fd3704c7$export$bae7b470830e7536 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EbSw2",
    name: "SmartCreatePageEditorLoader",
    loader: async ()=>(await (parcelRequire("9kowg"))).SmartCreatePageEditorDataWrapper
});



const $bb42a89ba72dd22d$export$997e52ba9fce325c = ({ params: { contentId: contentId }, query: { iframeHostProduct: iframeHostProduct, sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId } })=>{
    const iframeHostProductParam = typeof iframeHostProduct === 'string' ? iframeHostProduct : undefined;
    const sharedFeaturesInstrumentationIdParam = typeof sharedFeaturesInstrumentationId === 'string' ? sharedFeaturesInstrumentationId : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6O2BV.ClassicEditorContextProviderLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91e544e3fd3704c7$export$bae7b470830e7536), {
        contentId: contentId,
        iframeHostProduct: iframeHostProductParam,
        sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationIdParam
    }));
};
$bb42a89ba72dd22d$export$997e52ba9fce325c.NAVIGATION_PARAMS = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageSmartCreateScreen',
                id: contentId,
                ...(0, $92a0e12da2d6b5f0$export$bf305e48a79a981b)
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'page'
            }
        },
        MainLayout: false,
        BannerContext: {
            includeTopNav: false
        }
    });





const $819b80c2c59a2565$var$AI_PLANNER_BRIDGE_NAVIGATION_PARAMS = {
    Screen: {
        showPremiumOnboarding: false,
        screenEvent: {
            name: 'aiPlannerConfluenceBridgeScreen'
        }
    },
    MainLayout: false,
    BannerContext: {
        includeTopNav: false
    }
};

const $819b80c2c59a2565$export$bb48d26d51801617 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "VA3-t",
    name: "AIPlannerConfluenceBridgeRoute",
    loader: async ()=>(await (parcelRequire("1TygC"))).AIPlannerConfluenceBridgeRoute
});
$819b80c2c59a2565$export$bb48d26d51801617.NAVIGATION_PARAMS = ()=>$819b80c2c59a2565$var$AI_PLANNER_BRIDGE_NAVIGATION_PARAMS;


/* eslint react/prop-types:0 */ 









const $d6b8391ba067d418$var$SpaceSettingsAutomationRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "xxPa8",
    name: "SpaceSettingsAutomationRouteComponent",
    loader: ()=>(parcelRequire("7uit2"))
});
const $d6b8391ba067d418$export$3e7656e40361b9c3 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d6b8391ba067d418$var$SpaceSettingsAutomationRouteComponent, {
        spaceKey: spaceKey
    });
$d6b8391ba067d418$export$3e7656e40361b9c3.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingAutomationRoute',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });












const $90cab0c9e6efa470$export$c5b2c959a5ee5a4a = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Lsv8X",
    name: "ConnectSpaceCustomContentListView",
    loader: async ()=>(await (parcelRequire("cov6Y"))).ConnectSpaceCustomContentListView
});


const $25fdeb0a789de125$export$1045fc666c352ae6 = ({ params: { spaceKey: spaceKey, type: type } })=>{
    const [stateKey, setStateKey] = (0, $cozmU.useState)(history?.state?.key || Math.random());
    // Updating a key state and reload ConnectSpaceCustomContentListView component.
    //
    // Connect Apps can have an inner history state (created with AP.history), which add
    // hashtag to URL (for example: #!state1)
    // When user navigates to this route again the URL is reset to initial state and
    // hashtag is removed, but inner app does not get any notifications about that and
    // don't reset inner app state.
    //
    // To fix this issue we are listening history.state.key, and when it's changed
    // (user create a new entry in history) refresh component
    (0, $cozmU.useEffect)(()=>{
        // We rely on history.state.key that is not documented, but major browsers have it
        if (history?.state?.key) setStateKey(history.state.key);
        else if (!history?.state?._AP) setStateKey(Math.random());
    /* eslint-disable react-hooks/exhaustive-deps */ }, [
        history?.state,
        setStateKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $90cab0c9e6efa470$export$c5b2c959a5ee5a4a), {
        spaceKey: spaceKey,
        type: type,
        key: stateKey
    });
};
$25fdeb0a789de125$export$1045fc666c352ae6.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey, type: type } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceCustomContent',
                id: spaceKey,
                attributes: {
                    type: type
                }
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });









const $ae3041c2a586590e$export$cc376322db18bf6e = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "sjwPy",
    name: "CustomContentOnPageComponentLoader",
    loader: async ()=>(await (parcelRequire("cKOYh"))).CustomContentOnPageComponent
});





const $4af991445198673b$export$80477c996ae74379 = ({ params: { contentId: contentId, spaceKey: spaceKey, type: type } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ae3041c2a586590e$export$cc376322db18bf6e), {
        contentId: contentId,
        spaceKey: spaceKey,
        type: type === 'undefined' ? '' : type
    });
};
$4af991445198673b$export$80477c996ae74379.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'customContentOnPage',
                id: contentId
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey,
                contentId: contentId
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });












const $95bd051929613722$export$f536037c46d4c012 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "9X2ye",
    name: "CustomContentView",
    loader: async ()=>(await (parcelRequire("lR1Cm"))).CustomContentView
});


const $c7473af47fe3192c$export$b836ebd0f49cc9f5 = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95bd051929613722$export$f536037c46d4c012), {
        spaceKey: spaceKey,
        contentId: contentId
    });
};
$c7473af47fe3192c$export$b836ebd0f49cc9f5.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'customContentView',
                id: contentId
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey,
                contentId: contentId
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });












const $0960da40109465b4$var$PublicLinksSettingsPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rP97Y",
    name: "PublicLinksSettingsPageRouteComponent",
    loader: async ()=>(parcelRequire("hlyKe"))
});
const $0960da40109465b4$export$af4daa43ca1332b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0960da40109465b4$var$PublicLinksSettingsPageRouteComponent, null);
$0960da40109465b4$export$af4daa43ca1332b9.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'publicLinksSettingsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $d86fe9bfb21b5293$var$AnonymousAccessSettingsPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7xkbS",
    name: "AnonymousAccessSettingsPageRouteComponent",
    loader: async ()=>(parcelRequire("4AgSW"))
});
const $d86fe9bfb21b5293$export$1d391e6d67538b19 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d86fe9bfb21b5293$var$AnonymousAccessSettingsPageRouteComponent, null);
$d86fe9bfb21b5293$export$1d391e6d67538b19.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'anonymousAccessSettingsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $4fabe80bae5e8d04$var$SpaceManagementPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VdX74",
    name: "SpaceManagementPageRouteComponent",
    loader: async ()=>(parcelRequire("im0Dk"))
});
const $4fabe80bae5e8d04$export$fd1cbd536f2e61b4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4fabe80bae5e8d04$var$SpaceManagementPageRouteComponent, null);
$4fabe80bae5e8d04$export$fd1cbd536f2e61b4.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'spaceManagementScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $25cfc5c41bd5d05f$var$SpaceDefaultsPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "PWywz",
    name: "SpaceDefaultsPageRouteComponent",
    loader: async ()=>(parcelRequire("CCF2O"))
});
const $25cfc5c41bd5d05f$export$5425f152a964e2a4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($25cfc5c41bd5d05f$var$SpaceDefaultsPageRouteComponent, null);
$25cfc5c41bd5d05f$export$5425f152a964e2a4.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'spaceDefaultsPermissionsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $815c579597235468$var$SpaceRolesPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Jbnxb",
    name: "SpaceRolesPageRouteComponent",
    loader: async ()=>(parcelRequire("eYhV2"))
});
const $815c579597235468$export$3d75421a82ac4ef3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($815c579597235468$var$SpaceRolesPageRouteComponent, null);
$815c579597235468$export$3d75421a82ac4ef3.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'spaceRolesScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $139f96c2577c166d$var$SitePermissionsPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Y2xVK",
    name: "SitePermissionsPageRouteComponent",
    loader: async ()=>(parcelRequire("5D5gD"))
});
const $139f96c2577c166d$export$29c72ea3332ea2cc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($139f96c2577c166d$var$SitePermissionsPageRouteComponent, null);
$139f96c2577c166d$export$29c72ea3332ea2cc.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'sitePermissionsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $e5c5bd5a8c7b0d6f$var$GuestsSettingsPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "vk7Ko",
    name: "GuestsSettingsPageRouteComponent",
    loader: async ()=>(parcelRequire("fi2Nx"))
});
const $e5c5bd5a8c7b0d6f$export$16c169bdc6cd5ebe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e5c5bd5a8c7b0d6f$var$GuestsSettingsPageRouteComponent, null);
$e5c5bd5a8c7b0d6f$export$16c169bdc6cd5ebe.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'guestsSettingsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $9cf8f85dda9fbba2$var$AppsPermissionsSettingsPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HIGKF",
    name: "AppsPermissionsSettingsPageRouteComponent",
    loader: async ()=>(parcelRequire("6Crlg"))
});
const $9cf8f85dda9fbba2$export$74dc62432aba2eaa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9cf8f85dda9fbba2$var$AppsPermissionsSettingsPageRouteComponent, null);
$9cf8f85dda9fbba2$export$74dc62432aba2eaa.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'appPermissionsSettingsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $862979a48c317517$var$JsmAccessSettingsPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1MuLn",
    name: "JsmAccessSettingsPageRouteComponent",
    loader: async ()=>(parcelRequire("gYtMe"))
});
const $862979a48c317517$export$bc6803ac9d998199 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($862979a48c317517$var$JsmAccessSettingsPageRouteComponent, null);
$862979a48c317517$export$bc6803ac9d998199.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'jsmAccessSettingsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $95bdd88deead3c11$export$ecc44bd892306adb = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "00c23",
    name: "ContactAdministratorRoute",
    loader: async ()=>(await (parcelRequire("WDJHu"))).ContactAdministratorPage
});
$95bdd88deead3c11$export$ecc44bd892306adb.NAVIGATION_PARAMS = ()=>{
    return {
        Screen: {
            screenEvent: {
                name: 'contactAdministratorScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID)
        }
    };
};













const $1fb601398675b5a1$var$RoleBasedAccessControlHubRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "FJbMa",
    name: "RoleBasedAccessControlHubRouteComponent",
    loader: async ()=>(parcelRequire("aZGfx"))
});
const $1fb601398675b5a1$export$23838e4b7dc196e5 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1fb601398675b5a1$var$RoleBasedAccessControlHubRouteComponent, null);
};
$1fb601398675b5a1$export$23838e4b7dc196e5.NAVIGATION_PARAMS = (routeMatch)=>{
    const { name: name } = routeMatch;
    return {
        Screen: {
            screenEvent: {
                name: 'roleBasedAccessControlHubScreen'
            },
            pageState: {
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    };
};












const $e77b8eed9c4fe03f$var$AdminAnnouncementBannerRenderer = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "LCRNu",
    name: "AdminAnnouncementBannerRenderer",
    loader: async ()=>(await (parcelRequire("01i9E"))).AdminAnnouncementBannerRenderer
});
const $e77b8eed9c4fe03f$export$81a4ecf687c4a61b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e77b8eed9c4fe03f$var$AdminAnnouncementBannerRenderer, null);
};
$e77b8eed9c4fe03f$export$81a4ecf687c4a61b.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminAnnouncementBannerRenderer'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });















const $36a63e56cd2b2984$var$AdminCenterPage = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "yN5_D",
    name: "AdminCenterPage",
    loader: async ()=>(await (parcelRequire("jdXW8"))).AdminCenterPage
});
const $36a63e56cd2b2984$export$60c1a30975370191 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($36a63e56cd2b2984$var$AdminCenterPage, null);
$36a63e56cd2b2984$export$60c1a30975370191.NAVIGATION_PARAMS = ()=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    return {
        Screen: {
            screenEvent: {
                name: 'adminCenter',
                attributes: {
                    edition: edition
                }
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    };
};














parcelRequire("crTA1");



const $015145ca08e6a13a$var$AdminCenterSpacePage = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "1dPKI",
    name: "AdminCenterSpacePage",
    loader: async ()=>(await (parcelRequire("jdXW8"))).AdminCenterSpacePage
});
const $015145ca08e6a13a$export$bd929b984ffc4a9 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($015145ca08e6a13a$var$AdminCenterSpacePage, {
        spaceKey: spaceKey
    }));
};
$015145ca08e6a13a$export$bd929b984ffc4a9.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    return {
        Screen: {
            screenEvent: {
                name: 'adminCenterSpace',
                id: spaceKey,
                attributes: {
                    edition: edition
                }
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID)
        }
    };
};















var $euL71 = parcelRequire("euL71");

const $6f06338c7fe23a44$export$44bc7d6c094dc951 = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    if (edition === (0, $euL71.ConfluenceEdition).PREMIUM) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_CENTER).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_CONFIGURATION).name
    });
};
$6f06338c7fe23a44$export$44bc7d6c094dc951.NAVIGATION_PARAMS = ()=>false;


/* eslint react/prop-types:0 */ 









const $e2d8d9818dde6381$var$SpaceSettingsExportSpaceUnavailableRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "HYdso",
    name: "SpaceSettingsExportSpaceUnavailableRouteComponent",
    loader: ()=>(parcelRequire("3VOtu"))
});
const $e2d8d9818dde6381$export$1d1f8d0ef7c7a185 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e2d8d9818dde6381$var$SpaceSettingsExportSpaceUnavailableRouteComponent, {
        spaceKey: spaceKey
    });
$e2d8d9818dde6381$export$1d1f8d0ef7c7a185.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsExportSpaceUnavailable',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });














var $9TVBV = parcelRequire("9TVBV");


const $55b7ec62080e1638$export$405a6cc8f1c994c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "LzFeC",
    loader: async ()=>(await Promise.resolve((parcelRequire("9TVBV")))).BulkSpacePermissionsPage,
    name: 'BulkSpacePermissionsPage'
});







const $fe2917192dc4f6b9$export$db2035bfb5892b74 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VMbza",
    loader: async ()=>(await Promise.resolve((parcelRequire("kAGh9")))).BulkAccessManagementPage,
    name: 'BulkAccessManagementPage'
});






var $7siXU = parcelRequire("7siXU");




const $4255a2123073399b$export$a1ed7a563d6f8c80 = ()=>{
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    if (!isRbacEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7siXU.AdminSecurityPageWrapper), {
        bannerVariant: "space"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $55b7ec62080e1638$export$405a6cc8f1c994c8), null));
    if ((0, $6mKj3.expVal)('cc_perms_enable_rbac_admin_modernization', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7siXU.AdminSecurityPageWrapper), {
        bannerVariant: "space"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe2917192dc4f6b9$export$db2035bfb5892b74), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7siXU.AdminSecurityPageWrapper), {
        bannerVariant: "space"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe2917192dc4f6b9$export$db2035bfb5892b74), null));
};
$4255a2123073399b$export$a1ed7a563d6f8c80.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $9TVBV.ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });

















const $d1361d4d835db3f1$export$5164e66822dc5aec = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    if (edition !== (0, $euL71.ConfluenceEdition).PREMIUM) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bDjCi.LazyTeamCalendarSiteSettingsPage), null);
};
$d1361d4d835db3f1$export$5164e66822dc5aec.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $bDjCi.ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












var $4VuiN = parcelRequire("4VuiN");

/* AdminControls.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $4ez2K = parcelRequire("4ez2K");














var $4ikjJ = parcelRequire("4ikjJ");


var $ad7Ou = parcelRequire("ad7Ou");


var $i1t43 = parcelRequire("i1t43");


var $dTHYM = parcelRequire("dTHYM");


var $dUI0h = parcelRequire("dUI0h");


var $j7cLK = parcelRequire("j7cLK");


var $V3JOP = parcelRequire("V3JOP");


var $hMCZS = parcelRequire("hMCZS");


var $9DHhW = parcelRequire("9DHhW");





var $7akNQ = parcelRequire("7akNQ");











var $1kHsc = parcelRequire("1kHsc");

parcelRequire("6V36D");
var $hVSC8 = parcelRequire("hVSC8");


var $1BYn9 = parcelRequire("1BYn9");


var $6MSEP = parcelRequire("6MSEP");








var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");





var $7joZr = parcelRequire("7joZr");








var $lsxnT = parcelRequire("lsxnT");

/**
 * @generated SignedSource<<854134a3a69b1d840cfbb29220ff4613>>
 * @relayHash f9b10ce854bd3b612917f0d940680b5b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f61aa3a25666da7daba04ef61b2c17cddfcb8277a20e02879d3acd04ad2a3aff
const $dab459a150882bfc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useConfluenceSiteTeamConfigurationsMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "ConfluenceUpdateTeamAdminControlsSettingsPayload",
                            "kind": "LinkedField",
                            "name": "updateTeamAdminControlsSettings",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useConfluenceSiteTeamConfigurationsMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "ConfluenceUpdateTeamAdminControlsSettingsPayload",
                            "kind": "LinkedField",
                            "name": "updateTeamAdminControlsSettings",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f9b10ce854bd3b612917f0d940680b5b",
            "id": "f61aa3a25666da7daba04ef61b2c17cddfcb8277a20e02879d3acd04ad2a3aff",
            "metadata": {},
            "name": "useConfluenceSiteTeamConfigurationsMutation",
            "operationKind": "mutation",
            "text": "mutation useConfluenceSiteTeamConfigurationsMutation($input:ConfluenceTeamAdminControlsMode!){confluence{updateTeamAdminControlsSettings(input:$input){success,errors{message,extensions{statusCode,errorType,__typename,...on BulkMutationErrorExtension{id}},__typename},__typename}}}"
        }
    };
}();
$dab459a150882bfc$var$node.hash = "cb12cbeaf9954a0e8247aceccec6df18";
var $dab459a150882bfc$export$2e2bcd8739ae039 = $dab459a150882bfc$var$node;


/**
 * @generated SignedSource<<68ede829ccd8475ef7718dac6a1a3df6>>
 * @relayHash 39d6a72d5b5b54c388e853287b5b83d9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bcdafa25a8ff8d9dade01defb15b8941be3356093ed52cf164bb281b32a6ceb4
const $4ee2724dd2a3884a$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceQueryApi",
            "kind": "LinkedField",
            "name": "confluence",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceSiteConfiguration",
                    "kind": "LinkedField",
                    "name": "siteConfiguration",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceTeamAdminControlsSettings",
                            "kind": "LinkedField",
                            "name": "teamAdminControlsSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "teamAdminControlsMode"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useConfluenceSiteTeamConfigurationsQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useConfluenceSiteTeamConfigurationsQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "39d6a72d5b5b54c388e853287b5b83d9",
            "id": "bcdafa25a8ff8d9dade01defb15b8941be3356093ed52cf164bb281b32a6ceb4",
            "metadata": {},
            "name": "useConfluenceSiteTeamConfigurationsQuery",
            "operationKind": "query",
            "text": "query useConfluenceSiteTeamConfigurationsQuery{confluence{siteConfiguration{teamAdminControlsSettings{teamAdminControlsMode}}}}"
        }
    };
}();
$4ee2724dd2a3884a$var$node.hash = "dc96564c26929e9d164a8c5239b5e482";
var $4ee2724dd2a3884a$export$2e2bcd8739ae039 = $4ee2724dd2a3884a$var$node;






var $308Wd = parcelRequire("308Wd");


var $jMyy4 = parcelRequire("jMyy4");








var $irVI7 = parcelRequire("irVI7");








var $4MnFz = parcelRequire("4MnFz");


var $eh6Ml = parcelRequire("eh6Ml");


var $24dy7 = parcelRequire("24dy7");

const $b453cb24cea38560$var$i18nFlags = (0, $kSwu1.defineMessages)({
    successTitle: {
        id: "team-admin-controls.flag.success.title",
        defaultMessage: "Settings saved"
    },
    errorTitle: {
        id: "team-admin-controls.flag.error.title",
        defaultMessage: "Error"
    },
    errorDescription: {
        id: "team-admin-controls.flag.error.description",
        defaultMessage: "Something went wrong. Please try again."
    }
});
const $b453cb24cea38560$export$b8f59813a918ec2 = ()=>{
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const showSuccessFlag = ()=>{
        showFlag({
            id: `team-admin-controls-success-${Date.now()}`,
            title: formatMessage($b453cb24cea38560$var$i18nFlags.successTitle),
            isAutoDismiss: true,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                label: formatMessage($b453cb24cea38560$var$i18nFlags.successTitle)
            })
        });
    };
    const showErrorFlag = ()=>{
        showFlag({
            id: `team-admin-controls-error-${Date.now()}`,
            title: formatMessage($b453cb24cea38560$var$i18nFlags.errorTitle),
            description: formatMessage($b453cb24cea38560$var$i18nFlags.errorDescription),
            isAutoDismiss: true,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                label: formatMessage($b453cb24cea38560$var$i18nFlags.errorTitle)
            })
        });
    };
    return {
        showSuccessFlag: showSuccessFlag,
        showErrorFlag: showErrorFlag
    };
};


var $44851797bb5ee99f$export$640f4d7e68eecbe5 = /*#__PURE__*/ function(ConfluenceTeamAdminControlsMode) {
    ConfluenceTeamAdminControlsMode["ALL_TEAMS"] = "ALL_TEAMS";
    ConfluenceTeamAdminControlsMode["VERIFIED_TEAMS"] = "VERIFIED_TEAMS";
    ConfluenceTeamAdminControlsMode["NO_TEAMS"] = "NO_TEAMS";
    ConfluenceTeamAdminControlsMode["MEMBER_MANAGED_TEAMS"] = "MEMBER_MANAGED_TEAMS";
    return ConfluenceTeamAdminControlsMode;
}({});
const $44851797bb5ee99f$var$ConfluenceSiteConfigurationQuery = (0, $4ee2724dd2a3884a$export$2e2bcd8739ae039);
const $44851797bb5ee99f$var$UpdateTeamAdminControlsSettingsMutation = (0, $dab459a150882bfc$export$2e2bcd8739ae039);
const $44851797bb5ee99f$export$6c26751b3fc2f7e9 = ()=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { showErrorFlag: showErrorFlag, showSuccessFlag: showSuccessFlag } = (0, $b453cb24cea38560$export$b8f59813a918ec2)();
    const { data: data, loading: siteConfigurationLoading, error: siteConfigurationError } = (0, $jMyy4.useQueryInterop)($44851797bb5ee99f$var$ConfluenceSiteConfigurationQuery, {
        fetchPolicy: 'network-only',
        __callerPackage__: "team-admin-controls"
    });
    const [runMutation, { loading: updateTeamAdminControlsSettingsLoading }] = (0, $308Wd.useMutationInterop)($44851797bb5ee99f$var$UpdateTeamAdminControlsSettingsMutation, {
        __callerPackage__: "team-admin-controls"
    });
    async function updateTeamAdminControlsSettings(newTeamAdminControlsMode) {
        await runMutation({
            variables: {
                input: newTeamAdminControlsMode
            }
        }).catch((error)=>{
            (0, $7Sm4c.markErrorAsHandled)(error);
            showErrorFlag();
            experienceTracker.fail({
                name: (0, $irVI7.TEAM_ADMIN_CONTROLS_UPDATE_EXPERIENCE),
                error: error
            });
        });
        showSuccessFlag();
        experienceTracker.succeed({
            name: (0, $irVI7.TEAM_ADMIN_CONTROLS_UPDATE_EXPERIENCE)
        });
    }
    const currentTeamAdminControlsMode = data?.confluence?.siteConfiguration?.teamAdminControlsSettings?.teamAdminControlsMode;
    return {
        siteConfigurationLoading: siteConfigurationLoading,
        siteConfigurationError: siteConfigurationError,
        currentTeamAdminControlsMode: currentTeamAdminControlsMode,
        updateTeamAdminControlsSettings: updateTeamAdminControlsSettings,
        updateTeamAdminControlsSettingsLoading: updateTeamAdminControlsSettingsLoading
    };
};


const $14c1e67c9ac9a79b$var$i18n = (0, $kSwu1.defineMessages)({
    mayLoseAccessFrictionModalTitle: {
        id: "team-admin-controls.friction-modal.lose-some-access-title",
        defaultMessage: "Member-managed teams will lose access"
    },
    noTeamsFrictionModalTitle: {
        id: "team-admin-controls.friction-modal.no-teams-title",
        defaultMessage: "Teams will lose access"
    },
    mayLoseAccessFrictionModalBody: {
        id: "team-admin-controls.friction-modal.lose-some-access-body",
        defaultMessage: "Limiting the use of <b>open teams</b> to may cause unintended loss of access that is already configured across your site."
    },
    loseAccessFrictionModalBodyAdditional: {
        id: "team-admin-controls.friction-modal.lose-some-access-body-additional",
        defaultMessage: "<b>This can\u2019t be undone.</b>"
    },
    willLoseAccessFrictionModalBody: {
        id: "team-admin-controls.friction-modal.no-teams-body",
        defaultMessage: "Any member-managed teams currently assigned access on this site will lose that access."
    },
    noTeamsFrictionModalBody: {
        id: "team-admin-controls.friction-modal.no-teams-body",
        defaultMessage: "Any teams currently assigned access on this site will lose that access."
    },
    noTeamsFrictionModalBodyAdditional: {
        id: "team-admin-controls.friction-modal.no-teams-body-additional",
        defaultMessage: "<b>This can\u2019t be undone.</b>"
    },
    verifiedTeamsFrictionModalBody: {
        id: "team-admin-controls.friction-modal.verified-teams-body",
        defaultMessage: "Atlassian team is a collection of users that are part of your real-world team. Limiting the use teams to <b>only verified</b> may cause unintended loss of access across your site."
    },
    verifiedTeamsFrictionModalBodyAdditional: {
        id: "team-admin-controls.friction-modal.verified-teams-body-additional",
        defaultMessage: "<b>You can restore this later.</b>"
    },
    frictionModalContinueButton: {
        id: "team-admin-controls.friction-modal.continue-button",
        defaultMessage: "Continue"
    },
    frictionModalCancelButton: {
        id: "team-admin-controls.friction-modal.cancel-button",
        defaultMessage: "Cancel"
    }
});
const $14c1e67c9ac9a79b$export$fe53eaaf4efb0181 = ({ title: title, onConfirm: onConfirm, onClose: onClose, width: width = 'small', teamAccessType: teamAccessType })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const modalText = (0, $cozmU.useMemo)(()=>{
        switch(teamAccessType){
            case (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).VERIFIED_TEAMS:
                return {
                    title: formatMessage($14c1e67c9ac9a79b$var$i18n.mayLoseAccessFrictionModalTitle),
                    body: formatMessage($14c1e67c9ac9a79b$var$i18n.willLoseAccessFrictionModalBody, {
                        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks)
                    }),
                    bodyAdditional: formatMessage($14c1e67c9ac9a79b$var$i18n.loseAccessFrictionModalBodyAdditional, {
                        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks)
                    })
                };
            case (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).NO_TEAMS:
                return {
                    title: formatMessage($14c1e67c9ac9a79b$var$i18n.noTeamsFrictionModalTitle),
                    body: formatMessage($14c1e67c9ac9a79b$var$i18n.noTeamsFrictionModalBody, {
                        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks)
                    }),
                    bodyAdditional: formatMessage($14c1e67c9ac9a79b$var$i18n.noTeamsFrictionModalBodyAdditional, {
                        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks)
                    })
                };
            default:
                return {
                    title: formatMessage($14c1e67c9ac9a79b$var$i18n.mayLoseAccessFrictionModalTitle),
                    body: formatMessage($14c1e67c9ac9a79b$var$i18n.mayLoseAccessFrictionModalBody, {
                        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks)
                    }),
                    bodyAdditional: formatMessage($14c1e67c9ac9a79b$var$i18n.loseAccessFrictionModalBodyAdditional, {
                        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks)
                    })
                };
        }
    }, [
        teamAccessType,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
        width: width,
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), {
        appearance: "warning"
    }, title ?? modalText.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, " ", modalText.body), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, modalText.bodyAdditional))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7joZr.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: ()=>onClose()
    }, formatMessage($14c1e67c9ac9a79b$var$i18n.frictionModalCancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "warning",
        onClick: ()=>onConfirm()
    }, formatMessage($14c1e67c9ac9a79b$var$i18n.frictionModalContinueButton)))));
};



const $4cdac1dfe86e0470$var$i18n = (0, $kSwu1.defineMessages)({
    title: {
        id: "team-admin-controls.admin-controls.page.title",
        defaultMessage: "Teams"
    },
    manageTeamsButton: {
        id: "team-admin-controls.admin-controls.page.manage-teams-button",
        defaultMessage: "Manage teams"
    },
    description1: {
        id: "team-admin-controls.admin-controls.page.description1",
        defaultMessage: "Decide whether users on your site can assign access to teams (for example, by adding a team to a space and assigning it specific access). When enabled, users can assign access to teams, in addition to groups and individual users."
    },
    description2: {
        id: "team-admin-controls.admin-controls.page.description2",
        defaultMessage: "Atlassian teams let you collaborate quickly and easily with your project team across most Atlassian apps by sharing important links and resources, easily notifying all members, tracking work across apps on the team profile, and more. <link>Learn more about teams</link>"
    },
    radioGroupLabel: {
        id: "team-admin-controls.admin-controls.page.radio-group-label",
        defaultMessage: "Which teams can be assigned access?"
    },
    radioGroupOption1: {
        id: "team-admin-controls.admin-controls.page.radio-group-option-1",
        defaultMessage: "All teams"
    },
    radioGroupOption2: {
        id: "team-admin-controls.admin-controls.page.radio-group-option-2",
        defaultMessage: "Only admin-managed teams"
    },
    radioGroupOption3: {
        id: "team-admin-controls.admin-controls.page.radio-group-option-3",
        defaultMessage: "No teams can be assigned access"
    },
    radioGroupDescription1: {
        id: "team-admin-controls.admin-controls.page.radio-group-description-1",
        defaultMessage: "Both admin-managed and member-managed teams"
    },
    radioGroupDescription2: {
        id: "team-admin-controls.admin-controls.page.radio-group-description-2",
        defaultMessage: "All admin-managed teams will be marked with a blue check. <link>More about admin-managed teams</link>"
    },
    radioGroupDescription3: {
        id: "team-admin-controls.admin-controls.page.radio-group-description-3",
        defaultMessage: "Access can only be assigned to groups and individual users"
    },
    membershipControlRadioGroupLabel: {
        id: "team-admin-controls.admin-controls.page.membership-control-radio-group-label",
        defaultMessage: "Membership control"
    },
    membershipControlRadioGroupOption1: {
        id: "team-admin-controls.admin-controls.page.membership-control-radio-group-option-1",
        defaultMessage: "Allow teams that anyone can join"
    },
    membershipControlRadioGroupOption2: {
        id: "team-admin-controls.admin-controls.page.membership-control-radio-group-option-2",
        defaultMessage: "Only allow teams that require approval to join"
    },
    saveButton: {
        id: "team-admin-controls.admin-controls.page.save-button",
        defaultMessage: "Save"
    },
    cancelButton: {
        id: "team-admin-controls.admin-controls.page.cancel-button",
        defaultMessage: "Cancel"
    }
});
const $4cdac1dfe86e0470$var$styles = {
    container: "_4c065UGXk2 _2Y7lL4GXk2 _2YLqiKIZbP _1EqgXlNy1d",
    description: "_2xTnZxyFLW",
    radioGroupDescription: "_0GTcwRVa5s"
};
const $4cdac1dfe86e0470$var$membershipControlRadioOptions = [
    {
        value: 'open-membership',
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4cdac1dfe86e0470$var$i18n.membershipControlRadioGroupOption1)
    },
    {
        value: (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).MEMBER_MANAGED_TEAMS,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4cdac1dfe86e0470$var$i18n.membershipControlRadioGroupOption2)
    }
];
const $4cdac1dfe86e0470$export$997e23a0aec74966 = 'https://support.atlassian.com/platform-experiences/docs/teams-in-confluence-permissions/';
const $4cdac1dfe86e0470$var$AdminControlsContent = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { cloudId: cloudId, orgId: orgId, edition: edition } = (0, $bQm3c.useSessionData)();
    const { isProductAdmin: isProductAdmin } = (0, $1BYn9.useIsProductAdmin)();
    const { href: href } = (0, $hMCZS.navigateToTeamsApp)({
        type: 'LANDING',
        cloudId: cloudId,
        orgId: orgId,
        userHasNav4Enabled: true
    });
    const onClickManageTeams = ()=>{
        window.open(href, '_blank');
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'adminControls',
                actionSubject: 'adminControls',
                action: 'clicked manage teams button'
            }
        }).fire();
    };
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { siteConfigurationLoading: siteConfigurationLoading, currentTeamAdminControlsMode: currentTeamAdminControlsMode, updateTeamAdminControlsSettings: updateTeamAdminControlsSettings, updateTeamAdminControlsSettingsLoading: updateTeamAdminControlsSettingsLoading } = (0, $44851797bb5ee99f$export$6c26751b3fc2f7e9)();
    const [hasChanged, setHasChanged] = (0, $cozmU.useState)(false);
    const [membershipControlType, setMembershipControlType] = (0, $cozmU.useState)('open-membership');
    const [lastSavedMembershipControlType, setLastSavedMembershipControlType] = (0, $cozmU.useState)('open-membership');
    const [showFrictionModal, setShowFrictionModal] = (0, $cozmU.useState)(false);
    const [selectedTeamAccessType, setSelectedTeamAccessType] = (0, $cozmU.useState)(undefined); // Track the last saved mode locally to avoid stale server data affecting shouldShowFrictionModal
    const [lastSavedMode, setLastSavedMode] = (0, $cozmU.useState)(undefined);
    (0, $cozmU.useEffect)(()=>{
        if (!siteConfigurationLoading && currentTeamAdminControlsMode) {
            if (currentTeamAdminControlsMode === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).MEMBER_MANAGED_TEAMS) {
                setSelectedTeamAccessType((0, $44851797bb5ee99f$export$640f4d7e68eecbe5).ALL_TEAMS);
                setLastSavedMode((0, $44851797bb5ee99f$export$640f4d7e68eecbe5).ALL_TEAMS);
                const membershipControlTypeValue = (0, $6mKj3.expVal)('confluence_frontend_perms_teams_ga_fast_follow', 'isEnabled', false) ? (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).MEMBER_MANAGED_TEAMS : 'open-membership';
                setMembershipControlType(membershipControlTypeValue);
                setLastSavedMembershipControlType(membershipControlTypeValue);
            } else {
                setSelectedTeamAccessType(currentTeamAdminControlsMode);
                setLastSavedMode(currentTeamAdminControlsMode);
            }
        }
    }, [
        siteConfigurationLoading,
        currentTeamAdminControlsMode
    ]);
    const onTeamAccessTypeChange = (value)=>{
        setHasChanged(value !== lastSavedMode);
        setSelectedTeamAccessType(value);
        if (value !== (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).ALL_TEAMS) setMembershipControlType(lastSavedMembershipControlType);
    };
    const onMembershipControlTypeChange = (value)=>{
        setHasChanged(value !== lastSavedMembershipControlType);
        setMembershipControlType(value);
    }; // We want to show the friction modal only when there is possible access loss:
    // so going from All teams -> Verified/No teams, or Verified -> No teams
    // Going from No teams -> any level above will result in access gain so we don't show the modal.
    // We use lastSavedMode (local state) instead of currentTeamAdminControlsMode (server state)
    // to avoid stale data issues after a save.
    const shouldShowFrictionModal = (0, $cozmU.useCallback)(()=>{
        if (lastSavedMode === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).ALL_TEAMS) return true;
        else if (lastSavedMode === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).VERIFIED_TEAMS && selectedTeamAccessType === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).NO_TEAMS) return true;
        else if (lastSavedMode === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).NO_TEAMS) return false;
        return false;
    }, [
        lastSavedMode,
        selectedTeamAccessType
    ]);
    const onSaveClick = ()=>{
        if (shouldShowFrictionModal()) setShowFrictionModal(true);
        else onConfirmFrictionModal();
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'adminControls',
                actionSubject: 'adminControls',
                action: 'saved team access type',
                attributes: {
                    teamAccessType: selectedTeamAccessType || '(empty)',
                    membershipControlType: membershipControlType
                }
            }
        }).fire();
    };
    const onConfirmFrictionModal = async ()=>{
        setShowFrictionModal(false);
        experienceTracker.start({
            name: 'updateTeamAdminControlsSettings'
        });
        if (selectedTeamAccessType === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).ALL_TEAMS && membershipControlType === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).MEMBER_MANAGED_TEAMS) {
            await updateTeamAdminControlsSettings((0, $44851797bb5ee99f$export$640f4d7e68eecbe5).MEMBER_MANAGED_TEAMS);
            setLastSavedMembershipControlType(membershipControlType);
            setMembershipControlType(membershipControlType);
        } else {
            await updateTeamAdminControlsSettings(selectedTeamAccessType);
            setLastSavedMembershipControlType('open-membership');
            setMembershipControlType('open-membership');
        }
        setLastSavedMode(selectedTeamAccessType);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'adminControls',
                actionSubject: 'adminControls',
                action: 'confirmed friction modal',
                attributes: {
                    teamAccessType: selectedTeamAccessType,
                    membershipControlType: membershipControlType
                }
            }
        }).fire();
        setHasChanged(false);
    };
    if (!isProductAdmin || edition === (0, $euL71.ConfluenceEdition).FREE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6MSEP.RestrictedPage), null);
    const onCancel = ()=>{
        setHasChanged(false);
        setShowFrictionModal(false);
        setSelectedTeamAccessType(lastSavedMode);
        setMembershipControlType(lastSavedMembershipControlType);
    };
    return siteConfigurationLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $6mKj3.expVal)('cc_perms_enable_rbac_admin_modernization', 'isEnabled', false) ? undefined : $4cdac1dfe86e0470$var$styles.container
    }, showFrictionModal && selectedTeamAccessType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $14c1e67c9ac9a79b$export$fe53eaaf4efb0181), {
        width: "medium",
        teamAccessType: selectedTeamAccessType,
        onConfirm: ()=>onConfirmFrictionModal(),
        onClose: ()=>setShowFrictionModal(false)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "large"
    }, formatMessage($4cdac1dfe86e0470$var$i18n.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
        appearance: (0, $6mKj3.expVal)('cc_perms_enable_rbac_admin_modernization', 'isEnabled', false) ? 'default' : 'subtle',
        onClick: ()=>onClickManageTeams()
    }, formatMessage($4cdac1dfe86e0470$var$i18n.manageTeamsButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200",
        xcss: $4cdac1dfe86e0470$var$styles.description
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage($4cdac1dfe86e0470$var$i18n.description1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage($4cdac1dfe86e0470$var$i18n.description2, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                href: $4cdac1dfe86e0470$export$997e23a0aec74966,
                target: "_blank"
            }, chunks)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingBlockStart: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: ()=>{
            // TODO: Implement save functionality
            return Promise.resolve();
        }
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200",
            spread: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "small"
        }, formatMessage($4cdac1dfe86e0470$var$i18n.radioGroupLabel)), siteConfigurationLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "teamAccessType",
            defaultValue: currentTeamAdminControlsMode ?? undefined
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.100",
                spread: "space-between"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ikjJ.default), {
                ...fieldProps,
                value: (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).ALL_TEAMS,
                label: formatMessage($4cdac1dfe86e0470$var$i18n.radioGroupOption1),
                onChange: (e)=>onTeamAccessTypeChange(e.target.value),
                isChecked: selectedTeamAccessType === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).ALL_TEAMS
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignInline: "start",
                space: "space.050",
                xcss: $4cdac1dfe86e0470$var$styles.radioGroupDescription
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "small",
                color: "color.text.subtlest"
            }, formatMessage($4cdac1dfe86e0470$var$i18n.radioGroupDescription1))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ikjJ.default), {
                ...fieldProps,
                value: (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).VERIFIED_TEAMS,
                label: formatMessage($4cdac1dfe86e0470$var$i18n.radioGroupOption2),
                onChange: (e)=>onTeamAccessTypeChange(e.target.value),
                isChecked: selectedTeamAccessType === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).VERIFIED_TEAMS
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignInline: "start",
                alignBlock: "center",
                space: "space.050",
                xcss: $4cdac1dfe86e0470$var$styles.radioGroupDescription
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hVSC8.VerifiedTeamLozenge), {
                spacing: "none"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "small",
                color: "color.text.subtlest"
            }, formatMessage($4cdac1dfe86e0470$var$i18n.radioGroupDescription2, {
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                        href: $4cdac1dfe86e0470$export$997e23a0aec74966,
                        target: "_blank"
                    }, chunks)
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ikjJ.default), {
                ...fieldProps,
                value: (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).NO_TEAMS,
                label: formatMessage($4cdac1dfe86e0470$var$i18n.radioGroupOption3),
                onChange: (e)=>onTeamAccessTypeChange(e.target.value),
                isChecked: selectedTeamAccessType === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).NO_TEAMS
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignInline: "start",
                space: "space.050",
                xcss: $4cdac1dfe86e0470$var$styles.radioGroupDescription
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "small",
                color: "color.text.subtlest"
            }, formatMessage($4cdac1dfe86e0470$var$i18n.radioGroupDescription3))))), selectedTeamAccessType === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).ALL_TEAMS && (0, $6mKj3.expVal)('confluence_frontend_perms_teams_ga_fast_follow', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "small"
        }, formatMessage($4cdac1dfe86e0470$var$i18n.membershipControlRadioGroupLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "membershipControlType",
            defaultValue: membershipControlType
        }, ({ fieldProps: membershipFieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.150",
                spread: "space-between"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ikjJ.default), {
                ...membershipFieldProps,
                value: $4cdac1dfe86e0470$var$membershipControlRadioOptions[0].value,
                label: $4cdac1dfe86e0470$var$membershipControlRadioOptions[0].label,
                onChange: (e)=>onMembershipControlTypeChange(e.target.value),
                isChecked: membershipControlType === $4cdac1dfe86e0470$var$membershipControlRadioOptions[0].value
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ikjJ.default), {
                ...membershipFieldProps,
                value: $4cdac1dfe86e0470$var$membershipControlRadioOptions[1].value,
                label: $4cdac1dfe86e0470$var$membershipControlRadioOptions[1].label,
                onChange: (e)=>onMembershipControlTypeChange(e.target.value),
                isChecked: membershipControlType === $4cdac1dfe86e0470$var$membershipControlRadioOptions[1].value
            }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j7cLK.FormFooter), {
            align: "start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            type: "submit",
            isDisabled: !hasChanged,
            isLoading: updateTeamAdminControlsSettingsLoading,
            appearance: "primary",
            onClick: ()=>onSaveClick()
        }, formatMessage($4cdac1dfe86e0470$var$i18n.saveButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            type: "button",
            appearance: "subtle",
            onClick: onCancel,
            isDisabled: !hasChanged
        }, formatMessage($4cdac1dfe86e0470$var$i18n.cancelButton)))))))));
};
const $4cdac1dfe86e0470$export$c6013ec0ca71e14e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4cdac1dfe86e0470$var$AdminControlsContent, null));


const $7793a666921a34a3$export$ee12bdabe55b87f5 = ()=>{
    if ((0, $6mKj3.expVal)('cc_perms_enable_rbac_admin_modernization', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4VuiN.AdminPageLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4cdac1dfe86e0470$export$c6013ec0ca71e14e), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4cdac1dfe86e0470$export$c6013ec0ca71e14e), null);
};
$7793a666921a34a3$export$ee12bdabe55b87f5.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminTeamControlsSettings'
            }
        },
        sideNavigationId: (0, $lFjPc.ADMIN_HOME_ID),
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $f1b6649640833ae0$export$acaa2dba3cb8a594 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "sV2io",
    name: "LazyConfigurationPage",
    loader: async ()=>(await (parcelRequire("jBoKV"))).ConfigurationPage
});



var $go5PI = parcelRequire("go5PI");




const $daea30cdb73fa105$export$9a9547459861b1d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f1b6649640833ae0$export$acaa2dba3cb8a594), null);
$daea30cdb73fa105$export$9a9547459861b1d.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $go5PI.ADMIN_CONFIGURATION_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $26ef48198c7a4b22$export$c666402e8e189c20 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "XqQyJ",
    name: "LazyDefaultSpaceLogoConfigPage",
    loader: async ()=>(await (parcelRequire("jcorh"))).DefaultSpaceLogoConfigPage
});



var $87xWZ = parcelRequire("87xWZ");




const $cf2a30228181ae7a$export$12cd952fb663f2a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $26ef48198c7a4b22$export$c666402e8e189c20), null);
$cf2a30228181ae7a$export$12cd952fb663f2a5.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $87xWZ.ADMIN_DEFAULT_SPACE_LOGO_CONFIG_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $0035ce34a536ea29$export$b15e4e022e4cf20b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Gs9zR",
    name: "LazyHeaderAndFooterPage",
    loader: async ()=>(await (parcelRequire("iPL9h"))).HeaderAndFooterPage
});



var $9VF1g = parcelRequire("9VF1g");




const $d9d1782c5d23f713$export$66aaa3e4fa4fb446 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0035ce34a536ea29$export$b15e4e022e4cf20b), null);
$d9d1782c5d23f713$export$66aaa3e4fa4fb446.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $9VF1g.ADMIN_MIGRATION_HEADER_AND_FOOTER_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $20670991d47ae85d$export$eeb35ce919747456 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "g_FZa",
    name: "LazyTemplatesAndBlueprintsPage",
    loader: async ()=>(await (parcelRequire("3OVbT"))).TemplatesAndBlueprintsPage
});



var $kzcPl = parcelRequire("kzcPl");




const $3de5f90ca85ac387$export$fb8cddd2e05884ff = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20670991d47ae85d$export$eeb35ce919747456), null);
$3de5f90ca85ac387$export$fb8cddd2e05884ff.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $kzcPl.ADMIN_MIGRATION_TEMPLATES_AND_BLUEPRINTS_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });


/* eslint react/prop-types:0 */ 







// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 



var $3Tdyk = parcelRequire("3Tdyk");


const $ee7f717a6b819a49$export$9be270b9ed22878c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "v1sq_",
    name: "LazyNotificationsSiteSettingsPageLoader",
    loader: async ()=>(await (parcelRequire("97Mow"))).NotificationsSiteSettingsPage
});


const $5035325f0c8b9a13$export$65794158c09a379 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ee7f717a6b819a49$export$9be270b9ed22878c), null);
$5035325f0c8b9a13$export$65794158c09a379.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $3Tdyk.ADMIN_NOTIFICATIONS_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });















const $9611af456809fa37$export$ed3910c19b60b97e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "YLxm0",
    name: "LazyCreateWithRovoPage",
    loader: async ()=>(await (parcelRequire("kL15w"))).CreateWithRovoPage
});



var $1fUU3 = parcelRequire("1fUU3");

const $ccbb2c9664b7c084$export$f201f4e6a65cd2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9611af456809fa37$export$ed3910c19b60b97e), null);
$ccbb2c9664b7c084$export$f201f4e6a65cd2.ROUTE_NAME = (0, $1NBp8.ADMIN_CREATE_WITH_ROVO).name;
$ccbb2c9664b7c084$export$f201f4e6a65cd2.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $1fUU3.ADMIN_CREATE_WITH_ROVO_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });



























const $4a6faff2aaf4384e$export$26695507154f3759 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "6TCL1",
    name: "PerformanceInsightsPage",
    loader: async ()=>(await (parcelRequire("fraUx"))).PerformanceInsightsPage
});





const $50fb216eea7c3440$var$USER_SETUP_DETAIL_ROUTE_NAMES = new Set([
    (0, $1NBp8.PERFORMANCE_INSIGHTS_NETWORK_SPEED).name,
    (0, $1NBp8.PERFORMANCE_INSIGHTS_CPU_CORES).name,
    (0, $1NBp8.PERFORMANCE_INSIGHTS_NETWORK_PROTOCOL).name,
    (0, $1NBp8.PERFORMANCE_INSIGHTS_OPERATING_SYSTEM).name
]);
const $50fb216eea7c3440$var$resolveTab = ({ legacyTab: legacyTab, routeName: routeName, tab: tab })=>{
    if ($50fb216eea7c3440$var$USER_SETUP_DETAIL_ROUTE_NAMES.has(routeName) || tab === 'user-setup') return 'user-setup';
    if (tab === 'overview' || tab === undefined && legacyTab === 'overview') return 'overview';
    if (tab === 'content-metrics' || tab === undefined && legacyTab === 'content-metrics') return 'content-metrics';
    return 'load-times';
};
const $50fb216eea7c3440$export$66e6ee80c1ffed5a = ()=>{
    const { isProductAdmin: isProductAdmin, isAdminCheckLoading: isAdminCheckLoading } = (0, $1BYn9.useIsProductAdmin)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    if (isAdminCheckLoading) return null;
    const canAccessPerformanceInsights = isProductAdmin && edition === (0, $euL71.ConfluenceEdition).PREMIUM && (0, $6mKj3.expValEquals)('cc-perf-insights-monitoring', 'isEnabled', true);
    return canAccessPerformanceInsights ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4a6faff2aaf4384e$export$26695507154f3759), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6MSEP.RestrictedPage), null);
};
$50fb216eea7c3440$export$66e6ee80c1ffed5a.NAVIGATION_PARAMS = ({ name: name, params: { tab: tab }, query: query })=>{
    const legacyTab = Array.isArray(query.tab) ? query.tab[0] : query.tab;
    const resolvedTab = $50fb216eea7c3440$var$resolveTab({
        legacyTab: legacyTab,
        routeName: name,
        tab: tab
    });
    return {
        Screen: {
            screenEvent: {
                name: 'performanceInsightsScreen',
                attributes: {
                    tab: resolvedTab
                }
            },
            pageState: {
                routeName: name,
                tab: resolvedTab
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    };
};














var $i6ccO = parcelRequire("i6ccO");


const $13b2a397a1cc2782$export$bac0713ec898bd76 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "CRbee",
    name: "LazySpaceReportsSiteSettings",
    loader: async ()=>(await (parcelRequire("1QKcJ"))).SpaceReports
});


const $ba2c2ff5f89f0551$export$2667c61817b129fd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13b2a397a1cc2782$export$bac0713ec898bd76), null);
$ba2c2ff5f89f0551$export$2667c61817b129fd.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $i6ccO.ADMIN_SPACE_REPORT_SCREEN)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $a1651aa6544b68ec$export$d90af831494c8387 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "HbgyC",
    name: "LazyCodeMacroConfigurationPage",
    loader: async ()=>(await (parcelRequire("k0EFK"))).ConfigureCodeMacroPage
});



var $jPtik = parcelRequire("jPtik");




const $2e9a50b174f89446$export$761483e0f415164e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1651aa6544b68ec$export$d90af831494c8387), null);
$2e9a50b174f89446$export$761483e0f415164e.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $jPtik.ADMIN_CONFIGURE_CODE_MACRO_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });











const $0fb617f0ce9f4007$export$8984debadcec9d93 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_CUSTOMIZE_NAVIGATION).name
    });
$0fb617f0ce9f4007$export$8984debadcec9d93.NAVIGATION_PARAMS = ()=>false;















const $2ce4a32a2c9693ca$export$302da857ce3de1de = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "rig9z",
    name: "AccessRequestSettingsPageLoader",
    loader: async ()=>(await (parcelRequire("iMyEa"))).AccessRequestSettingsPage
});














const $640b7346d02500f9$var$i18n = (0, $kSwu1.defineMessages)({
    pageTitle: {
        id: "access-requests.admin-controls.settings-page.route-title",
        defaultMessage: "Access requests"
    }
});
const $640b7346d02500f9$var$AdminAccessRequestsRouteComponent = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const pageTitle = formatMessage($640b7346d02500f9$var$i18n.pageTitle);
    // Access requests are not available on Free edition, and the nav item is hidden
    // there — block direct navigation to the URL too.
    if (edition === (0, $euL71.ConfluenceEdition).FREE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6MSEP.RestrictedPage), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7siXU.AdminSecurityPageWrapper), {
        documentTitle: pageTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2ce4a32a2c9693ca$export$302da857ce3de1de), null));
};
$640b7346d02500f9$var$AdminAccessRequestsRouteComponent.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'productAdminAccessRequestsSettingsScreen'
            }
        },
        sideNavigationId: (0, $lFjPc.ADMIN_HOME_ID),
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });
const $640b7346d02500f9$export$e43d8e128566b1eb = $640b7346d02500f9$var$AdminAccessRequestsRouteComponent;









const $545b6e8effa8c8db$export$a21466da6a7c3088 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "9Xsqa",
    name: "LazySecurityConfigurationPage",
    loader: async ()=>(await (parcelRequire("bDmqn"))).SecurityConfigurationPage
});



var $5vGLM = parcelRequire("5vGLM");




const $7fe52c8ec8c71cab$export$b882bc9c4e633e9b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $545b6e8effa8c8db$export$a21466da6a7c3088), null);
$7fe52c8ec8c71cab$export$b882bc9c4e633e9b.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $5vGLM.ADMIN_SECURITY_CONFIGURATION_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $4af95de4de8abb48$export$c1761e3376ce94d1 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Wm-3z",
    name: "AccessLinkSiteAdminControlsLoader",
    loader: async ()=>(await (parcelRequire("lSstv"))).AccessLinkSiteAdminControls
});





const $ebbc45da5498e408$export$968567891972d6d4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4af95de4de8abb48$export$c1761e3376ce94d1), null);
$ebbc45da5498e408$export$968567891972d6d4.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'siteSettingsAccessLinksScreen'
            }
        },
        sideNavigationId: (0, $lFjPc.ADMIN_HOME_ID),
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












var $dPJCf = parcelRequire("dPJCf");








const $d9741d166e932512$export$2b380a73df3593c8 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "pkFJl",
    name: "AccessLinkSiteAdminConfigurationLoader",
    loader: async ()=>(await (parcelRequire("4tdkm"))).SiteConfigPage
});





const $30cc72374591e2a1$export$ac0bb92ad015adc6 = ()=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const handleBack = (0, $cozmU.useCallback)(()=>push((0, $1NBp8.ADMIN_ACCESS_LINKS).toUrl()), [
        push
    ]);
    if (!(0, $6mKj3.expValEquals)('shareable_links_m0', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.HOME).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d9741d166e932512$export$2b380a73df3593c8), {
        onBack: handleBack
    });
};
$30cc72374591e2a1$export$ac0bb92ad015adc6.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'siteSettingsAccessLinksConfigurationScreen'
            }
        },
        sideNavigationId: (0, $lFjPc.ADMIN_HOME_ID),
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $78ef366567be569a$export$80059957d731c042 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "w8ZSB",
    name: "LazyApplicationNavigatorPage",
    loader: async ()=>(await (parcelRequire("f1bqy"))).ApplicationNavigatorPage
});



var $dWfBt = parcelRequire("dWfBt");




const $98f73671c286928d$export$55ff18e8dde17771 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $78ef366567be569a$export$80059957d731c042), null);
$98f73671c286928d$export$55ff18e8dde17771.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $dWfBt.ADMIN_APPLICATION_NAVIGATOR_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $b750d916e554f7df$export$93a51467d25d0499 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "84mIg",
    name: "LazyMacroUsagePage",
    loader: async ()=>(await (parcelRequire("ldb17"))).MacroUsagePage
});



var $9JmJC = parcelRequire("9JmJC");




const $2395a25321aca708$export$1e71122b3eac56e4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b750d916e554f7df$export$93a51467d25d0499), null);
$2395a25321aca708$export$1e71122b3eac56e4.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $9JmJC.ADMIN_MACRO_USAGE_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $b1c56f7f0cd3abfc$export$db3288808f1d2cee = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "TlnkG",
    name: "LazyTrashedSpacesPage",
    loader: async ()=>(await (parcelRequire("lsdAl"))).TrashedSpacesPage
});



var $4l9JY = parcelRequire("4l9JY");




const $b9260b374d11ae03$export$154b40ed25137a69 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b1c56f7f0cd3abfc$export$db3288808f1d2cee), null);
$b9260b374d11ae03$export$154b40ed25137a69.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $4l9JY.ADMIN_TRASHED_SPACES_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });





















const $2cc036891fb5d716$var$AdminConfluenceChatsIntegrationComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "EPuLA",
    name: "AdminConfluenceChatsIntegrationComponent",
    loader: async ()=>(parcelRequire("6hRE4"))
});
const $2cc036891fb5d716$export$2e4708beaaa8ed13 = ()=>{
    if (!(0, $9wGTI.fg)('twcg-2215-confluence-chats-integration-migration')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_CONFIGURATION).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2cc036891fb5d716$var$AdminConfluenceChatsIntegrationComponent, null);
};
$2cc036891fb5d716$export$2e4708beaaa8ed13.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminConfluenceChatsIntegrationScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












var $7Snc9 = parcelRequire("7Snc9");


const $db04f75f13f6a54c$var$ConfluenceMsTeamsSignInConfirmationComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Cw2vj",
    name: "ConfluenceMsTeamsSignInConfirmationComponent",
    loader: async ()=>(parcelRequire("5LuQ6"))
});
const $db04f75f13f6a54c$export$946acfb57ab420fd = ({ query: query })=>{
    if (!(0, $9wGTI.fg)('confluence-msteams-signin-confirmation-migration')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7Snc9.NotFound), null);
    const successValue = typeof query.successValue === 'string' ? query.successValue : undefined;
    const baseUrl = typeof query.baseUrl === 'string' ? query.baseUrl : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($db04f75f13f6a54c$var$ConfluenceMsTeamsSignInConfirmationComponent, {
        successValue: successValue,
        baseUrl: baseUrl
    });
};
// Shown inside a small sign-in popup, not the main Confluence chrome — no nav/breadcrumb to set,
// matching the pattern other chromeless routes (e.g. `ActionRedirectLegacyRoute`) use.
$db04f75f13f6a54c$export$946acfb57ab420fd.NAVIGATION_PARAMS = ()=>false;









const $b17503f7798017b5$export$2ed44b7640eeeaea = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "X7LBt",
    name: "LazyImportSpacesPage",
    loader: async ()=>(await (parcelRequire("kmD3E"))).ImportSpacesPage
});



var $434W4 = parcelRequire("434W4");




const $d9481fcbb25a62a6$export$6078cc5c61cdb00c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b17503f7798017b5$export$2ed44b7640eeeaea), null);
$d9481fcbb25a62a6$export$6078cc5c61cdb00c.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $434W4.ADMIN_IMPORT_SPACES_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $856e303ba52ed6c6$export$f522a213bf45cbaf = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "s23-1",
    name: "LazyJiraMacroRepairPage",
    loader: async ()=>(await (parcelRequire("42aQi"))).JiraMacroRepairPage
});



var $2i0P8 = parcelRequire("2i0P8");




const $3ed31ec1d64e85a3$export$1162e5a60ee7576b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $856e303ba52ed6c6$export$f522a213bf45cbaf), null);
$3ed31ec1d64e85a3$export$1162e5a60ee7576b.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $2i0P8.ADMIN_JIRA_MACRO_REPAIR_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $c621c947d336edb6$export$39b0a52384de05d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "MZ13C",
    name: "LazyThemesPage",
    loader: async ()=>(await (parcelRequire("aFVWt"))).ThemesPage
});



var $ft9Jc = parcelRequire("ft9Jc");




const $95678b1264993b8d$export$cdc2bb4346e935c9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c621c947d336edb6$export$39b0a52384de05d), null);
$95678b1264993b8d$export$cdc2bb4346e935c9.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $ft9Jc.ADMIN_THEMES_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $94ac68953a95a3c6$export$def53ea7cb291102 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "4g9eZ",
    name: "LazyPdfExportPage",
    loader: async ()=>(await (parcelRequire("9uVbY"))).PdfExportPage
});



var $fmC2G = parcelRequire("fmC2G");




const $d726f64aa7b98b71$export$81e12ffb7d442c0c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $94ac68953a95a3c6$export$def53ea7cb291102), null);
$d726f64aa7b98b71$export$81e12ffb7d442c0c.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $fmC2G.ADMIN_PDF_EXPORT_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $9f03bd3fce1c6524$export$e1745bf2bc7b6d75 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "e-VGC",
    name: "LazyWatermarkConfigurationPage",
    loader: async ()=>(await (parcelRequire("3EZ1I"))).WatermarkConfigurationPage
});





const $1cb4912c670744a4$export$ee4273463a3d48ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9f03bd3fce1c6524$export$e1745bf2bc7b6d75), null);
$1cb4912c670744a4$export$ee4273463a3d48ad.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminWatermarkConfiguration'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









var $8Nhaa = parcelRequire("8Nhaa");




const $b39b3b8c8cb41baf$export$9334d2c8540310e3 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ge6Hg",
    name: "SpaceManagerLoader",
    loader: async ()=>(await (parcelRequire("hPrtH"))).SpaceManager
});


const $244c44f585122129$export$986d179bc3f7f637 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b39b3b8c8cb41baf$export$9334d2c8540310e3), null);
$244c44f585122129$export$986d179bc3f7f637.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $8Nhaa.SPACE_MANAGER_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });



/* eslint react/prop-types:0 */ 









const $d3d38e453fe82603$var$LazyDefaultSpacePermissionsPage = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "9HaD7",
    name: "LazyDefaultSpacePermissionsPage",
    loader: async ()=>(await (parcelRequire("35CyX"))).DefaultSpacePermissionsPage
});
const $d3d38e453fe82603$export$6b4028c8cfa4e9e1 = (routeMatch)=>{
    const { params: { tab: tab } } = routeMatch;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d3d38e453fe82603$var$LazyDefaultSpacePermissionsPage, {
        activeTab: tab
    });
};
$d3d38e453fe82603$export$6b4028c8cfa4e9e1.NAVIGATION_PARAMS = (routeMatch)=>({
        Screen: {
            screenEvent: {
                name: 'siteSpacePermissionsScreen',
                attributes: {
                    tab: routeMatch.params.tab
                }
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });











const $09759410f0cf9b55$export$e7dd35a659f967b8 = ({ params: { key: key, spaceKey: spaceKey }, query: query })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_OVERVIEW).name,
        params: {
            spaceKey: key || spaceKey,
            query: query
        }
    });
};
$09759410f0cf9b55$export$e7dd35a659f967b8.NAVIGATION_PARAMS = ()=>false;











function $26b63860644dba7c$export$7bc70d297bcfbf4f(extra) {
    const redirectComponent = ({ query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.HOME).name,
            params: {
                query: {
                    ...query,
                    ...extra
                }
            }
        });
    redirectComponent.NAVIGATION_PARAMS = ()=>false;
    return redirectComponent;
}











const $7cf8f51aa88b9ccf$export$df2de76576f721a1 = ({ pathname: pathname, search: search, query: query })=>{
    if (query['unmatched-route']) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7Snc9.NotFound), null);
    search = search.startsWith('?') ? `${search}&unmatched-route=true` : `?unmatched-route=true`;
    return(//Redirect for .action pages that forces a full page reload
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        href: `${pathname}${search}`,
        forceReload: true
    }));
};
$7cf8f51aa88b9ccf$export$df2de76576f721a1.NAVIGATION_PARAMS = ()=>false;











const $0a13ad86816c36c0$export$cdc5cf7d787e5e31 = ({ pathname: pathname, search: search, query: query })=>{
    const { draftId: draftId } = query;
    if (typeof draftId !== 'string' || !/^[0-9]+$/.test(draftId)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.WIKI).name
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        href: `${pathname}${search}`,
        forceReload: true
    });
};
$0a13ad86816c36c0$export$cdc5cf7d787e5e31.NAVIGATION_PARAMS = ()=>false;









var $bcVE2 = parcelRequire("bcVE2");





var $jxpvN = parcelRequire("jxpvN");

const $a474944cbbe3347a$var$bannerContextValue = {
    includeTopNav: false
};
const $a474944cbbe3347a$export$300afabe53226c5d = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jxpvN.BannerContext).Provider, {
        value: $a474944cbbe3347a$var$bannerContextValue
    }, children);






var $d73E7 = parcelRequire("d73E7");

const $09a888bb83dd7791$var$isEmbeddedWhiteboard = ({ query: query })=>(0, $bcVE2.isEmbeddedWhiteboardMode)({
        parentProduct: query.parentProduct,
        presentationMode: query.presentationMode
    });
const $09a888bb83dd7791$export$d584a39bdee41574 = (match)=>{
    const { params: { contentId: contentId, spaceKey: spaceKey } } = match;
    const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d73E7.WhiteboardRouteComponentLoader), {
        spaceKey: spaceKey,
        contentId: contentId
    });
    if ($09a888bb83dd7791$var$isEmbeddedWhiteboard(match) && (0, $9wGTI.fg)('confluence_ssr_embedded_whiteboard_preload_cache')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a474944cbbe3347a$export$300afabe53226c5d), null, element);
    return element;
};
$09a888bb83dd7791$export$d584a39bdee41574.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey }, query: { focusedCommentId: focusedCommentId, focusedMentionId: focusedMentionId, parentProduct: parentProduct, presentationMode: presentationMode } })=>({
        Screen: {
            screenEvent: {
                name: 'whiteboardScreen',
                id: contentId,
                attributes: {
                    contentId: contentId,
                    focusedCommentId: focusedCommentId,
                    focusedMentionId: focusedMentionId
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'whiteboard',
                routeName: routeName
            }
        },
        MainLayout: (0, $bcVE2.isEmbeddedWhiteboardMode)({
            parentProduct: parentProduct,
            presentationMode: presentationMode
        }) && (0, $9wGTI.fg)('confluence_ssr_embedded_whiteboard_preload_cache') ? false : {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: true
        }
    });


// Slides route — renders the whiteboard shell in slides mode.
// Downstream whiteboard components now derive slides mode from the route name
// (SLIDES_VIEW) rather than from a ?slides=true query param, so no query-param
// bridge is needed.













const $4e31866782374d42$var$isEmbeddedWhiteboard = ({ query: query })=>(0, $bcVE2.isEmbeddedWhiteboardMode)({
        parentProduct: query.parentProduct,
        presentationMode: query.presentationMode
    });
const $4e31866782374d42$export$3a64ee6cc47e86a4 = (match)=>{
    const { params: { contentId: contentId, spaceKey: spaceKey } } = match;
    const isEmbeddedMode = $4e31866782374d42$var$isEmbeddedWhiteboard(match);
    const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d73E7.WhiteboardRouteComponentLoader), {
        spaceKey: spaceKey,
        contentId: contentId,
        isEmbeddedWhiteboard: isEmbeddedMode
    });
    if (isEmbeddedMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a474944cbbe3347a$export$300afabe53226c5d), null, element);
    return element;
};
$4e31866782374d42$export$3a64ee6cc47e86a4.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey }, query: { focusedCommentId: focusedCommentId, focusedMentionId: focusedMentionId, parentProduct: parentProduct, presentationMode: presentationMode } })=>({
        Screen: {
            screenEvent: {
                name: 'slideScreen',
                id: contentId,
                attributes: {
                    contentId: contentId,
                    focusedCommentId: focusedCommentId,
                    focusedMentionId: focusedMentionId
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'slide',
                routeName: routeName
            }
        },
        MainLayout: (0, $bcVE2.isEmbeddedWhiteboardMode)({
            parentProduct: parentProduct,
            presentationMode: presentationMode
        }) ? false : {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: true
        }
    });












const $47326de99f5119ec$export$cdb01b3d24a21485 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "OUrjG",
    name: "FolderContainerLoader",
    loader: async ()=>(await (parcelRequire("kY72s"))).FolderContainer
});


const $6e131d5d0e81b5af$export$110a009c083fc1fc = ({ params: { contentId: contentId } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $47326de99f5119ec$export$cdb01b3d24a21485), {
        contentId: contentId
    });
$6e131d5d0e81b5af$export$110a009c083fc1fc.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey, contentSlug: contentSlug } })=>({
        Screen: {
            screenEvent: {
                name: 'folderScreen',
                id: contentId,
                attributes: {
                    contentId: contentId
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentSlug: contentSlug,
                contentType: 'folder',
                routeName: routeName
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: true
        }
    });












const $1f4e11c8ff1e70c5$export$e1cd63b567cc2910 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "LWjU2",
    name: "EmbedRouteLoader",
    loader: async ()=>(await (parcelRequire("iWviJ"))).EmbedContainer
});





parcelRequire("crTA1");





const $a86e8bdaaaef979c$export$1a870b21a11af9ae = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1f4e11c8ff1e70c5$export$e1cd63b567cc2910), {
        contentId: contentId,
        spaceKey: spaceKey
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H46k.LazyDwellTime), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H46k.LazyConsumptionViewedAndCompletedEventTracker), {
        spaceKey: spaceKey,
        source: "EmbedViewRoute"
    }));
$a86e8bdaaaef979c$export$1a870b21a11af9ae.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'smartLinkEmbedPageScreen',
                id: contentId,
                attributes: {
                    contentId: contentId,
                    contentType: 'embed'
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'embed',
                routeName: routeName
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: true
        }
    });









const $ff966974ac17a8ae$export$d5b2cc659cf7a894 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "K1tWi",
    name: "DatabaseContainerLoader",
    loader: async ()=>(await (parcelRequire("5IJBK"))).DatabaseContainer
});









var $bwC5h = parcelRequire("bwC5h");




const $b443bc65ee980e3b$export$2b633aba04c212bb = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>(0, $9wGTI.fg)('confluence-fix-space-db-redirect-behaviour') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bwC5h.default), {
        spaceKey: spaceKey,
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ff966974ac17a8ae$export$d5b2cc659cf7a894), {
        contentId: contentId,
        spaceKey: spaceKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H46k.LazyDwellTime), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H46k.LazyConsumptionViewedAndCompletedEventTracker), {
        spaceKey: spaceKey,
        source: "DatabaseViewRoute"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bwC5h.default), {
        spaceKey: spaceKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ff966974ac17a8ae$export$d5b2cc659cf7a894), {
        contentId: contentId,
        spaceKey: spaceKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H46k.LazyDwellTime), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H46k.LazyConsumptionViewedAndCompletedEventTracker), {
        spaceKey: spaceKey,
        source: "DatabaseViewRoute"
    }));
$b443bc65ee980e3b$export$2b633aba04c212bb.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'databaseScreen',
                id: contentId,
                attributes: {
                    contentId: contentId
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'database',
                routeName: routeName
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: true
        }
    });














const $88d3e4eaff5b722d$export$4c4704aeef10cf08 = (0, $4lJOK.getSpaceOverviewRoute)(({ spaceKey: spaceKey, query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_OVERVIEW).name,
        params: {
            spaceKey: spaceKey,
            query: query
        }
    }));









const $79a774581f86de14$export$e7975a21b41d4767 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "hYSgM",
    name: "LazyLoader",
    loader: ()=>(parcelRequire("332hs"))
});









var $iufgB = parcelRequire("iufgB");







var $6CEg5 = parcelRequire("6CEg5");




const $4da47b9dcf27590f$export$9af206dbb2b6a483 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iufgB.CreateContentRouteComponentLoader), {
        preloadWhiteboardRouteComponent: (0, $d73E7.WhiteboardRouteComponentLoader).preload,
        preloadDatabaseRouteComponent: (0, $ff966974ac17a8ae$export$d5b2cc659cf7a894).preload,
        preloadPageAndBlogRouteComponent: (0, $79a774581f86de14$export$e7975a21b41d4767).preload,
        preloadSmartLinkEmbedRouteComponent: (0, $1f4e11c8ff1e70c5$export$e1cd63b567cc2910).preload
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6CEg5.PerformanceStart), {
        subject: "PageTree",
        subjectId: "newContentRendered"
    }));
$4da47b9dcf27590f$export$9af206dbb2b6a483.NAVIGATION_PARAMS = ({ name: routeName, params: { spaceKey: spaceKey, contentType: createRouteTypeParam }, query: query })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const showPremiumOnboarding = !isEmbeddedConfluence;
    // spaceKey comes from query object while on creation route
    const currentSpaceKey = spaceKey || query?.spaceKey;
    const isPageLikeContent = createRouteTypeParam === 'page' || createRouteTypeParam === 'blog';
    return {
        Screen: {
            screenEvent: {
                name: 'createContentScreen'
            },
            pageState: {
                spaceKey: currentSpaceKey,
                routeName: routeName
            },
            showPremiumOnboarding: isPageLikeContent ? showPremiumOnboarding : false
        },
        MainLayout: {
            // CREATE_CONTENT route can return an undefined spaceKey during creation so we render a loading screen
            navView: query.spaceKey ? (0, $lFjPc.CONTAINER_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_LOADING_ID),
            spaceKey: currentSpaceKey,
            editorPreloader: isPageLikeContent ? (0, $eXODy.getEditorPreloader) : undefined,
            disableMinWidth: true,
            isViewPage: true,
            isEdit: true
        }
    };
};


















const $5b463946eccb17c7$export$7bd9ae6d5c998c1f = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "78c05",
    name: "SplitPageResultsLoader",
    loader: async ()=>(await (parcelRequire("4Y6DR"))).SplitPageResults
});


const $f39a8f3c45c29808$export$5fb3818945ba48e4 = ({ params: params })=>{
    const { contentId: contentId, spaceKey: spaceKey } = params;
    if (!(0, $6mKj3.expValEquals)('confluence-page-splitter', 'isEnabled', 'Test')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $wtSEP.NotFound), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5b463946eccb17c7$export$7bd9ae6d5c998c1f), {
        spaceKey: spaceKey,
        contentId: contentId
    });
};
$f39a8f3c45c29808$export$5fb3818945ba48e4.NAVIGATION_PARAMS = ({ name: name, params: params })=>{
    const { contentId: contentId, spaceKey: spaceKey, contentSlug: contentSlug } = params;
    if (!(0, $6mKj3.expValEquals)('confluence-page-splitter', 'isEnabled', 'Test')) return false;
    return {
        Screen: {
            screenEvent: {
                name: 'pageSplitScreen',
                id: contentId
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey,
                contentId: contentId,
                contentType: 'page',
                contentSlug: contentSlug || ''
            },
            showPremiumOnboarding: false
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: false
        }
    };
};






var $1xpoY = parcelRequire("1xpoY");


var $6jrkJ = parcelRequire("6jrkJ");


var $cbQWR = parcelRequire("cbQWR");























var $ko9Ek = parcelRequire("ko9Ek");




















var $4D2qK = parcelRequire("4D2qK");





const $37eba1df63470b23$export$f574cd97f97b4d34 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "XaRNl",
    name: "ViewPageLiteHeaderLoader",
    loader: async ()=>(await (parcelRequire("1ptJE"))).ViewPageLiteHeader
});


parcelRequire("8pBIa");
var $6Evf5 = parcelRequire("6Evf5");

parcelRequire("4Yv1J");


parcelRequire("crTA1");





const $92d3732f6f6decb7$export$e537bc4c45dc607c = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey, contentSlug: contentSlug } })=>{
    const isPage = routeName === (0, $1NBp8.VIEW_PAGE).name;
    const isBlog = routeName === (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name || routeName === (0, $1NBp8.VIEW_BLOG).name;
    let contentType;
    // any one of VIEW_BLOG_DATE_LEGACY, VIEW_BLOG or VIEW_PAGE route can end up here from ViewPageOrBlogRoute
    if (isBlog) contentType = 'blogpost';
    else if (isPage) contentType = 'page';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJ8K8.Screen), {
        showPremiumOnboarding: false,
        screenEvent: {
            name: 'viewPageScreen',
            id: contentId,
            attributes: {
                isPublicView: false,
                pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
            },
            objectType: contentType,
            objectId: contentId
        },
        pageState: {
            contentId: contentId,
            spaceKey: spaceKey,
            routeName: routeName,
            contentSlug: contentSlug,
            isLite: true,
            contentType: contentType
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $37eba1df63470b23$export$f574cd97f97b4d34), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4D2qK.ViewPageLiteLoader), {
        spaceKey: spaceKey,
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Evf5.default), {
        pageType: contentType
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H46k.LazyDwellTime), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H46k.LazyConsumptionViewedAndCompletedEventTracker), {
        spaceKey: spaceKey,
        source: "ViewPageLiteRoute"
    }));
};



var $lJlG6 = parcelRequire("lJlG6");

function $7a7b7faa4141aa1d$var$isLite(query) {
    return Boolean(query?.lite);
}
function $7a7b7faa4141aa1d$var$parseContentSlugFromSSR() {
    return window?.__SSR_RENDERED__ && window?.__DELAYED_CONTENT_REDIRECTION__?.contentSlug || '';
}
const $7a7b7faa4141aa1d$export$51ff3cc323c1250d = (props)=>{
    const isMobile = (0, $8dwdz.shouldShowMobileWeb)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isMobileApp = (0, $lJlG6.isMobileApp_DO_NOT_USE)();
    const { name: name, params: params, query: query } = props;
    const { contentId: contentId, spaceKey: spaceKey } = params;
    const isViewPage = name === (0, $1NBp8.VIEW_PAGE).name;
    if ($7a7b7faa4141aa1d$var$isLite(query)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $92d3732f6f6decb7$export$e537bc4c45dc607c), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ko9Ek.ViewPageRouteComponentLoader), {
        spaceKey: spaceKey,
        contentId: contentId,
        isMobile: isMobile,
        isPage: isViewPage,
        // TODO: When we have a new `<MobileAppViewPageLoader />` component for the mobile app, update this component to
        //   pass `isMobileApp` here as an additional prop, and inside the component, check if `isMobileApp` is true and
        //   if so, use the new `<MobileAppViewPageLoader />` component
        // https://product-fabric.atlassian.net/browse/REACT-8691
        isEmbeddedConfluence: isEmbeddedConfluence || isMobileApp
    }));
};
$7a7b7faa4141aa1d$export$51ff3cc323c1250d.NAVIGATION_PARAMS = ({ name: name, params: params, query: query })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isMobileApp = (0, $lJlG6.isMobileApp_DO_NOT_USE)();
    const showPremiumOnboarding = !isEmbeddedConfluence && !isMobileApp;
    const { contentId: contentId, spaceKey: spaceKey, contentSlug: contentSlug } = params;
    const isViewBlog = name === (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name || name === (0, $1NBp8.VIEW_BLOG).name;
    const contentType = isViewBlog ? 'blogpost' : 'page';
    if ($7a7b7faa4141aa1d$var$isLite(query)) return false;
    // Use contentSlug from SSR delayed-redirection if available
    const correctContentSlug = $7a7b7faa4141aa1d$var$parseContentSlugFromSSR() || contentSlug || '';
    return {
        Screen: {
            screenEvent: {
                name: 'viewPageScreen',
                id: contentId,
                attributes: {
                    isPublicView: false,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                },
                objectType: contentType,
                objectId: contentId
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey,
                contentId: contentId,
                contentType: contentType,
                contentSlug: correctContentSlug
            },
            showPremiumOnboarding: showPremiumOnboarding,
            deferPageRestrictions: (0, $cbQWR.canDeferPageRestrictions)({
                name: name,
                query: query
            }) && !isEmbeddedConfluence && !isMobileApp && !(0, $6jrkJ.getSuperAdminClaim)() && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_restrictions_on_demand') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false)
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            editorPreloader: (0, $eXODy.getEditorPreloader),
            isViewPage: true
        }
    };
};









const $674c97fafa39ddaa$export$c8774699c65926c8 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "djuV7",
    name: "TopicHomepage",
    loader: async ()=>(await (parcelRequire("agrhv"))).TopicHomepageComponent
});














const $ad7e3274b7fede14$export$54f890efdb9a624 = ({ params: { topicId: topicId } })=>{
    if (!(0, $9wGTI.fg)('confluence_enable_ai_topics_homepage')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.HOME).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $674c97fafa39ddaa$export$c8774699c65926c8), {
        topicId: topicId
    });
};
$ad7e3274b7fede14$export$54f890efdb9a624.NAVIGATION_PARAMS = ({ params: { topicId: topicId } })=>({
        Screen: {
            screenEvent: {
                name: 'topicsScreen'
            },
            pageState: {
                topicId: topicId
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID),
            topicId: topicId
        }
    });












const $44ff6e33806985ff$var$QuestionsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ULKKd",
    name: "QuestionsRouteComponent",
    loader: ()=>(parcelRequire("i0WZi"))
});
const $44ff6e33806985ff$export$384dd5b6b76557b1 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($44ff6e33806985ff$var$QuestionsRouteComponent, {
        spaceKey: spaceKey
    });
};
const $44ff6e33806985ff$export$9f80bcb940c350e6 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($44ff6e33806985ff$var$QuestionsRouteComponent, {
        spaceKey: spaceKey,
        openCreateQuestionModal: true
    });
};
$44ff6e33806985ff$export$384dd5b6b76557b1.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'questionsScreen'
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });
$44ff6e33806985ff$export$9f80bcb940c350e6.NAVIGATION_PARAMS = $44ff6e33806985ff$export$384dd5b6b76557b1.NAVIGATION_PARAMS;






var $dY5Vp = parcelRequire("dY5Vp");




const $281ce5bf20714bdc$export$aea18e9fd89afe15 = ({ params: { spaceKey: spaceKey, questionId: questionId } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dY5Vp.LazyQuestions), {
        spaceKey: spaceKey,
        questionId: questionId
    });
};
$281ce5bf20714bdc$export$aea18e9fd89afe15.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, questionId: questionId } })=>({
        Screen: {
            screenEvent: {
                name: 'questionScreen',
                questionId: questionId
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });









const $34607f68a2922062$export$5d828b79b8aa9d27 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "y34AA",
    name: "SiteAnalyticsPageLoader",
    loader: async ()=>(await (parcelRequire("7c80G"))).SiteAnalyticsPage
});





const $63dcc013c61b21bf$export$ccfda76403f5bd22 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $34607f68a2922062$export$5d828b79b8aa9d27), null);
};
$63dcc013c61b21bf$export$ccfda76403f5bd22.NAVIGATION_PARAMS = ({ name: name, params: { tab: tab } })=>{
    return {
        Screen: {
            // screenEvent will be handled in the page components
            pageState: {
                routeName: name,
                tab: tab
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    };
};









const $421f3eadd830fd14$export$6dd852c6aabadfda = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rTAZ6",
    name: "SitePermissionsPageLoader",
    loader: async ()=>(await (parcelRequire("1nBet"))).SitePermissionsPage
});





const $2dd41eaa3836b7ed$export$7ed59daacefa1324 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $421f3eadd830fd14$export$6dd852c6aabadfda), null);
};
$2dd41eaa3836b7ed$export$7ed59daacefa1324.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'instanceAnalyticsPermissions'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $b925f878325ca863$export$1c22a22c4bc3d8e9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "D9x42",
    name: "PageAnalyticsPageLoader",
    loader: async ()=>(await (parcelRequire("4pwh9"))).PageAnalyticsPage
});





const $2ddeeae61cd450c5$export$77b30b491c5d0ee0 = ({ params: { contentId: contentId } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b925f878325ca863$export$1c22a22c4bc3d8e9), {
        contentId: contentId
    });
};
$2ddeeae61cd450c5$export$77b30b491c5d0ee0.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, contentId: contentId, tab: tab } })=>({
        Screen: {
            // screenEvent will be handled in the page components
            pageState: {
                spaceKey: spaceKey,
                contentId: contentId,
                tab: tab
            }
        },
        MainLayout: {
            spaceKey: spaceKey,
            navView: (0, $lFjPc.CONTAINER_HOME_ID)
        }
    });









const $9c22efa8f8a6df7c$export$5c0ffde074fc4758 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VV9sG",
    name: "SpaceAnalyticsPageLoader",
    loader: async ()=>(await (parcelRequire("iXYvb"))).SpaceAnalyticsPage
});





parcelRequire("crTA1");


const $e76c2474e57ea114$export$af7907eff44c835f = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9c22efa8f8a6df7c$export$5c0ffde074fc4758), {
        spaceKey: spaceKey
    }));
};
$e76c2474e57ea114$export$af7907eff44c835f.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey, tab: tab } })=>({
        Screen: {
            // screenEvent will be handled in the page components
            pageState: {
                routeName: name,
                spaceKey: spaceKey,
                tab: tab
            }
        },
        MainLayout: {
            spaceKey: spaceKey,
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID)
        }
    });














const $4a724484ea837e6c$export$703d82918dc06325 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        href: (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).toUrl({
            spaceKey: spaceKey,
            tab: 'analytics'
        })
    });
$4a724484ea837e6c$export$703d82918dc06325.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceAnalyticsPermissions',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            spaceKey: spaceKey,
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID)
        }
    });





















const $b819de32c6839e12$var$LazySpaceLegacyContentRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Fm82P",
    name: "LazySpaceLegacyContentRouteComponent",
    loader: async ()=>(await (parcelRequire("jK9jP"))).SpaceLegacyContentRouteComponent
});
const $b819de32c6839e12$export$f983b39883686021 = ({ params: { spaceKey: spaceKey } })=>{
    if (!(0, $6mKj3.expVal)('cc-admin-exp-legacy-content-report', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_SETTINGS_LANDING_PAGE).name,
        params: {
            spaceKey: spaceKey
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b819de32c6839e12$var$LazySpaceLegacyContentRouteComponent, {
        spaceKey: spaceKey
    });
};
$b819de32c6839e12$export$f983b39883686021.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            pageState: {
                spaceKey: spaceKey
            },
            screenEvent: {
                name: 'legacyContentScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey
        }
    });





















const $baeceeb2053ed280$var$LazySpaceAvatarsSettingsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "6fQBw",
    name: "LazySpaceAvatarsSettingsRouteComponent",
    loader: async ()=>(await (parcelRequire("lHEvX"))).SpaceAvatarsSettingsRouteComponent
});
const $baeceeb2053ed280$export$232f775b06326172 = ({ params: { spaceKey: spaceKey } })=>{
    if (!(0, $6mKj3.expVal)('confluence_approvals_eap', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_SETTINGS_LANDING_PAGE).name,
        params: {
            spaceKey: spaceKey
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($baeceeb2053ed280$var$LazySpaceAvatarsSettingsRouteComponent, {
        spaceKey: spaceKey
    });
};
$baeceeb2053ed280$export$232f775b06326172.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            pageState: {
                spaceKey: spaceKey
            },
            screenEvent: {
                name: 'avatarsSettingsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey
        }
    });





















const $1a46d2ab385e41f3$var$LazySpaceStatusAndApprovalsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "szUQW",
    name: "LazySpaceStatusAndApprovalsRouteComponent",
    loader: async ()=>(await (parcelRequire("kR2MJ"))).SpaceStatusAndApprovalsRouteComponent
});
const $1a46d2ab385e41f3$export$905b6f7e554c11f5 = ({ params: { spaceKey: spaceKey } })=>{
    if (!(0, $6mKj3.expVal)('confluence_approvals_eap', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_SETTINGS_LANDING_PAGE).name,
        params: {
            spaceKey: spaceKey
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a46d2ab385e41f3$var$LazySpaceStatusAndApprovalsRouteComponent, {
        spaceKey: spaceKey
    });
};
$1a46d2ab385e41f3$export$905b6f7e554c11f5.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            pageState: {
                spaceKey: spaceKey
            },
            screenEvent: {
                name: 'statusAndApprovalsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey
        }
    });









const $bab2dace65c311d3$export$2b00c7dac5a350a7 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "c1xIf",
    name: "SmartCreateSpaceLoader",
    loader: async ()=>(await (parcelRequire("kI5BG"))).SmartCreateSpace
});











const $f9a064f293d5119a$export$683599b1d0dc8e7b = ()=>{
    if (!(0, $9wGTI.fg)('aifc_space_creation_enabled')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        href: (0, $1NBp8.HOME).toUrl()
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bab2dace65c311d3$export$2b00c7dac5a350a7), null);
};
$f9a064f293d5119a$export$683599b1d0dc8e7b.NAVIGATION_PARAMS = ()=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'spaceSmartCreateScreen'
            }
        },
        MainLayout: false,
        BannerContext: {
            includeTopNav: false
        }
    });












const $e1b3581d111cffc5$export$d563a43e58d8e249 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "nNYrs",
    name: "LazyUserAccessPage",
    loader: async ()=>(await (parcelRequire("lGHR2"))).UserAccessPage
});



var $l5PUQ = parcelRequire("l5PUQ");

const $c4bba5ee88869a52$export$45dbe3e1239d2b94 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e1b3581d111cffc5$export$d563a43e58d8e249), null);
$c4bba5ee88869a52$export$45dbe3e1239d2b94.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $l5PUQ.ADMIN_USER_ACCESS_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });






var $6b4nE = parcelRequire("6b4nE");


var $iDrrr = parcelRequire("iDrrr");













const $69b9df17dc76bcc3$export$31b05ec87f8c8c11 = 'confluence-fe-space-settings-enable-afm-pdf';

const $69b9df17dc76bcc3$var$LazyExportSpaceRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EoQbw",
    name: "LazyExportSpaceRouteComponent",
    loader: async ()=>(await (parcelRequire("11Lo8"))).ExportSpaceRouteComponent
});
const $69b9df17dc76bcc3$export$4d1bd2808cfd2f38 = ({ params: { spaceKey: spaceKey } })=>{
    if (!(0, $iDrrr.fg)($69b9df17dc76bcc3$export$31b05ec87f8c8c11)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.LEGACY_SPACE_PDF_EXPORT).name,
        params: {
            spaceKey: spaceKey
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($69b9df17dc76bcc3$var$LazyExportSpaceRouteComponent, {
        spaceKey: spaceKey
    });
};
$69b9df17dc76bcc3$export$4d1bd2808cfd2f38.propTypes = {
    params: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).shape({
        spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired
    }).isRequired
};
$69b9df17dc76bcc3$export$4d1bd2808cfd2f38.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'ExportSpaceScreen'
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });












const $8e1d38472579226f$var$QuestionsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "yT4rd",
    name: "QuestionsRouteComponent",
    loader: ()=>(parcelRequire("i0WZi"))
});
const $8e1d38472579226f$export$6cff3d6e80ecc64 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8e1d38472579226f$var$QuestionsRouteComponent, {
        isGlobalPage: true
    });
};
$8e1d38472579226f$export$6cff3d6e80ecc64.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'globalQuestionsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID)
        }
    });












const $a488bad1e68dd6a7$var$QuestionsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "6VNHf",
    name: "QuestionsRouteComponent",
    loader: ()=>(parcelRequire("i0WZi"))
});
const $a488bad1e68dd6a7$export$5c0c86e79c0609bd = ({ params: { questionId: questionId, spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a488bad1e68dd6a7$var$QuestionsRouteComponent, {
        questionId: questionId,
        spaceKey: spaceKey,
        isGlobalPage: true
    });
};
$a488bad1e68dd6a7$export$5c0c86e79c0609bd.NAVIGATION_PARAMS = ({ params: { questionId: questionId } })=>({
        Screen: {
            screenEvent: {
                name: 'globalQuestionScreen',
                questionId: questionId
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID)
        }
    });








// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 




const $ce2cb80274e3a560$export$67d9d65bd2b4815 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "PsbBz",
    name: "ImporterDashboardLoader",
    loader: async ()=>(await (parcelRequire("j983T"))).ImporterDashboard
});


const $e2dae4d283de07f2$export$abf2f9d0f3a44f9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ce2cb80274e3a560$export$67d9d65bd2b4815), null);
$e2dae4d283de07f2$export$abf2f9d0f3a44f9c.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'IMPORTER_STATUS_DASHBOARD'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $95bf1213cdd8988b$export$989c0e84e4723f09 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "e5N_k",
    name: "LazyNBMPage",
    loader: async ()=>(await (parcelRequire("8Uy7i"))).NBMPage
});





const $0a6ea19b0fb236e1$export$e644f8e819f9f36 = ({ params: { scanId: scanId } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95bf1213cdd8988b$export$989c0e84e4723f09), {
        scanId: scanId
    });
$0a6ea19b0fb236e1$export$e644f8e819f9f36.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminNBMMigration'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $198dcbe4d14ced85$export$a3c0c81377169fa4 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "7zyLS",
    name: "LazyDCScriptMigrationPage",
    loader: async ()=>(await (parcelRequire("7MqK7"))).DCScriptMigrationPage
});





const $a58212c7e75084fc$export$4b568b9f0da70fe4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $198dcbe4d14ced85$export$a3c0c81377169fa4), null);
$a58212c7e75084fc$export$4b568b9f0da70fe4.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminDCScriptMigration'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $2eac21f7c787ce68$export$e9527e3d8dc95465 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "2Y2rY",
    name: "AttachmentsPageLoader",
    loader: async ()=>(await (parcelRequire("hSLUF"))).AttachmentsPage
});


const $167b5527ac95ab07$export$fd9e136112feb41f = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2eac21f7c787ce68$export$e9527e3d8dc95465), {
        contentId: contentId,
        spaceKey: spaceKey
    });
};
$167b5527ac95ab07$export$fd9e136112feb41f.NAVIGATION_PARAMS = ({ name: routeName, params: params })=>{
    const { spaceKey: spaceKey, contentId: contentId } = params;
    return {
        Screen: {
            screenEvent: {
                name: 'attachmentsPage',
                id: contentId
            },
            pageState: {
                routeName: routeName,
                contentId: contentId,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    };
};












const $04345605d1454f1c$export$445b3236f9b51df = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "qw_9Z",
    name: "ChatLoader",
    loader: async ()=>(await (parcelRequire("6Ah2q"))).Chat
});











const $123d32deac7bf460$export$4fc17ec31b01e987 = ()=>{
    if (!(0, $9wGTI.fg)('rovo_search_chat_convergence')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.HOME).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $04345605d1454f1c$export$445b3236f9b51df), null);
};
$123d32deac7bf460$export$4fc17ec31b01e987.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'chatScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID)
        }
    });





















const $fd49b5c0edd0f211$var$InferredProjectPage = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "0utsc",
    name: "InferredProjectPage",
    loader: async ()=>(await (parcelRequire("8INZr"))).InferredProjectPage
});
const $fd49b5c0edd0f211$export$8d789824df52a6bc = ()=>{
    if (!(0, $9wGTI.fg)('confluence_inferred_project_page_enabled')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.HOME).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fd49b5c0edd0f211$var$InferredProjectPage, null);
};
$fd49b5c0edd0f211$export$8d789824df52a6bc.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'inferredProjectPageScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID),
            disableMinWidth: true
        }
    });












const $c07bb757e3ef4c47$export$8fc14d22356d64d4 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "DN5QL",
    name: "LazyPermissionsExportPage",
    loader: async ()=>(await (parcelRequire("lhsIn"))).PermissionsExportPage
});


const $6deffcd0919e3152$var$PERMISSIONS_EXPORT_ANALYTICS_SOURCE = 'adminPermissionsExport';
const $6deffcd0919e3152$export$9dc6a62d8cf9ae06 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c07bb757e3ef4c47$export$8fc14d22356d64d4), null);
$6deffcd0919e3152$export$9dc6a62d8cf9ae06.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: $6deffcd0919e3152$var$PERMISSIONS_EXPORT_ANALYTICS_SOURCE
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $1c99ee2f9e6230fc$export$a1aaf5446f2374eb = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "DKV9I",
    name: "LazyAssignRolesPage",
    loader: async ()=>(await (parcelRequire("01pje"))).AssignRolesPage
});


const $5fcbb229533ae7f5$var$PERMISSIONS_COMBINATIONS_ANALYTICS_SOURCE = 'adminPermissionsCombinations';
const $5fcbb229533ae7f5$export$2cdfcdcf001693ff = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1c99ee2f9e6230fc$export$a1aaf5446f2374eb), null);
$5fcbb229533ae7f5$export$2cdfcdcf001693ff.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: $5fcbb229533ae7f5$var$PERMISSIONS_COMBINATIONS_ANALYTICS_SOURCE
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $6581a5926a1ce066$export$9950ebbef62306b5 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "5bwAU",
    name: "LazySystemOperationsPage",
    loader: async ()=>(await (parcelRequire("ejpdO"))).SystemOperationsPage
});


const $7fda056324955ad3$var$SYSTEM_OPERATIONS_ANALYTICS_SOURCE = 'adminSystemOperations';
const $7fda056324955ad3$export$26979a3c4ac291c5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6581a5926a1ce066$export$9950ebbef62306b5), null);
$7fda056324955ad3$export$26979a3c4ac291c5.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: $7fda056324955ad3$var$SYSTEM_OPERATIONS_ANALYTICS_SOURCE
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });











var $92IuX = parcelRequire("92IuX");



const $beac86ab997501a9$var$AUDIT_LOG_ANALYTICS_SOURCE = 'audit-log';
const $beac86ab997501a9$export$b6dab1e8a8b6a66d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $92IuX.AuditLogLoader), null);
$beac86ab997501a9$export$b6dab1e8a8b6a66d.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: $beac86ab997501a9$var$AUDIT_LOG_ANALYTICS_SOURCE
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });











parcelRequire("4Yv1J");


const $4afa1bc9a87a9b40$export$58816268cacd10b6 = (0, $SwMnm.getAccessLinkRoute)({
    ContextProvider: (0, $f5aR2.ContentExtensionsProvider),
    NotFound: $wtSEP.NotFound,
    ClassicEditorContextProviderLoader: // A live doc reached through an access link mounts the live editor, which needs extension-v1
    // context. Injected here for the same reason `ContextProvider` is: it lives in a classic package
    // that `ssr-app` and `external-share` cannot import.
    $6O2BV.ClassicEditorContextProviderLoader
});












const $588899442361c83f$export$c445ef06d03a3a71 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "9TGJG",
    name: "AccessLinkSpaceAdminControlsLoader",
    loader: async ()=>(await (parcelRequire("bAoUu"))).AccessLinkSpaceAdminControls
});


const $306fa1afbc47dc82$export$9357b91a8ce986c5 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $588899442361c83f$export$c445ef06d03a3a71), {
        spaceKey: spaceKey
    });
};
$306fa1afbc47dc82$export$9357b91a8ce986c5.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsAccessLinksScreen',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey
        }
    });
























const $425aeba0958814d7$export$bcccc707e876610d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "GL8A5",
    name: "AccessLinkSpaceAdminConfigurationLoader",
    loader: async ()=>(await (parcelRequire("aUXwM"))).SpaceConfigPage
});


const $b81de96a75fad070$export$e64a7ea2c0613adc = ({ params: { spaceKey: spaceKey } })=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const handleBack = (0, $cozmU.useCallback)(()=>push((0, $1NBp8.SPACE_SETTINGS_ACCESS_LINKS).toUrl({
            spaceKey: spaceKey
        })), [
        push,
        spaceKey
    ]);
    if (!(0, $6mKj3.expValEquals)('shareable_links_m0', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.HOME).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $425aeba0958814d7$export$bcccc707e876610d), {
        onBack: handleBack,
        spaceKey: spaceKey
    });
};
$b81de96a75fad070$export$e64a7ea2c0613adc.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsAccessLinksConfigurationScreen',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey
        }
    });


function $c6a4b2258628a516$var$redirect(name) {
    const redirectComponent = ({ params: params = {} })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
            name: name,
            params: params
        });
    redirectComponent.NAVIGATION_PARAMS = ()=>false;
    return redirectComponent;
}
const $c6a4b2258628a516$export$4d9abfe5519d76c6 = (0, $jiFpb.processNavigationParams)({
    [(0, $64KID.namedRoutes).BASE.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).WIKI.name),
    [(0, $64KID.namedRoutes).WIKI.name]: (0, $75f6c666a9c742b2$export$e5707bd7e32dbf9b),
    [(0, $64KID.namedRoutes).HOME.name]: (0, $4625b8b3d160569d$export$48d3d184aade51b1),
    [(0, $64KID.namedRoutes).MOBILE_TAKEOVER_PAGE.name]: (0, $7b810fd40f00ac37$export$1a98ae7373202607),
    [(0, $64KID.namedRoutes).MOBILE_MACRO_RENDERER.name]: (0, $fcdf58a0a381c832$export$29b5dbba9b9e21d8),
    [(0, $64KID.namedRoutes).TEMPLATE_GALLERY.name]: (0, $0f81c6a8d9931e4d$export$e2ed88affe37abdc),
    [(0, $64KID.namedRoutes).EDIT_PAGE.name]: (0, $2807fe6645e49e0b$export$6a3218472cdf374a),
    [(0, $64KID.namedRoutes).EDIT_BLOG.name]: (0, $cdf2efa932a544ee$export$657999c2675036a8),
    [(0, $64KID.namedRoutes).EDIT_PAGE_V2.name]: (0, $0e80cf500c4229e5$export$5cc0e8d070ec38e9),
    [(0, $64KID.namedRoutes).EDIT_BLOG_V2.name]: (0, $0e80cf500c4229e5$export$5cc0e8d070ec38e9),
    [(0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name]: (0, $dde5e37bf0f94188$export$a338f76d183c610),
    [(0, $64KID.namedRoutes).EDIT_PAGE_SMART_CREATE.name]: (0, $bb42a89ba72dd22d$export$997e52ba9fce325c),
    [(0, $64KID.namedRoutes).AI_PLANNER_CONFLUENCE_BRIDGE.name]: (0, $819b80c2c59a2565$export$bb48d26d51801617),
    [(0, $64KID.namedRoutes).CREATE_CONTENT.name]: (0, $4da47b9dcf27590f$export$9af206dbb2b6a483),
    [(0, $64KID.namedRoutes).CREATE_PAGE.name]: (0, $93e08279e521422d$export$92431fd1ef2a3e02),
    [(0, $64KID.namedRoutes).CREATE_BLOG.name]: (0, $c3c08e13adc00b49$export$daeca97aa431dd80),
    [(0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name]: (0, $8012954d5e28a430$export$33ab8fb3f76d8b14),
    [(0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name]: (0, $8012954d5e28a430$export$33ab8fb3f76d8b14),
    [(0, $64KID.namedRoutes).CREATE_PAGE_VARIABLES_ACTION_LEGACY.name]: (0, $8012954d5e28a430$export$33ab8fb3f76d8b14),
    [(0, $64KID.namedRoutes).RESUME_DRAFT_LEGACY.name]: (0, $0a13ad86816c36c0$export$cdc5cf7d787e5e31),
    [(0, $64KID.namedRoutes).COPY_PAGE_LEGACY.name]: (0, $e9270d50e13c4524$export$58ad04e57ec143c3),
    [(0, $64KID.namedRoutes).DASHBOARD_ACTION_LEGACY.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).HOME.name),
    [(0, $64KID.namedRoutes).SPA_ACTION_LEGACY.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).HOME.name),
    [(0, $64KID.namedRoutes).INDEX_ACTION_LEGACY.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).HOME.name),
    [(0, $64KID.namedRoutes).VIEW_PAGE_ACTION_LEGACY.name]: (0, $1547fdfac1788133$export$70a5a4ee184a1106),
    [(0, $64KID.namedRoutes).SPACE_OVERVIEW_INDEX_ACTION_LEGACY.name]: (0, $09759410f0cf9b55$export$e7dd35a659f967b8),
    [(0, $64KID.namedRoutes).SPACE_INDEX_ACTION_LEGACY.name]: (0, $09759410f0cf9b55$export$e7dd35a659f967b8),
    // it should be after "INDEX_ACTION_LEGACY", and can't be the last one, as it will brake navigation to space settings
    [(0, $64KID.namedRoutes).ACTION_REDIRECT_LEGACY.name]: (0, $7cf8f51aa88b9ccf$export$df2de76576f721a1),
    [(0, $64KID.namedRoutes).SPACE_DIRECTORY.name]: (0, $6b9376eebbcdd446$export$e2f6c7ec524fdd6a),
    [(0, $64KID.namedRoutes).SPACE_OVERVIEW_REDIRECT_LEGACY.name]: (0, $09759410f0cf9b55$export$e7dd35a659f967b8),
    [(0, $64KID.namedRoutes).SPACE_INDEX.name]: (0, $88d3e4eaff5b722d$export$4c4704aeef10cf08),
    [(0, $64KID.namedRoutes).SPACE_OVERVIEW.name]: (0, $8290afb66ac54848$export$200c90655ff1c697),
    [(0, $64KID.namedRoutes).HUB.name]: (0, $f6b27607b6d81126$export$d8819c37d45ffdfc),
    [(0, $64KID.namedRoutes).HUB_EDIT.name]: (0, $437f27e114bb0121$export$29545d7913f7e4d9),
    [(0, $64KID.namedRoutes).COMPANY_HUB.name]: (0, $f6b27607b6d81126$export$d8819c37d45ffdfc),
    [(0, $64KID.namedRoutes).COMPANY_HUB_ANALYTICS.name]: (0, $b5f6e0dacae3f98e$export$ccf9c625603cc873),
    [(0, $64KID.namedRoutes).COMPANY_HUB_EDIT.name]: (0, $1f7939e43bf6965f$export$335f265b0f783405),
    [(0, $64KID.namedRoutes).COMPANY_HUB_SETTINGS.name]: (0, $dbfb738401d21a8a$export$5df4bb70a888e6ef),
    [(0, $64KID.namedRoutes).GLOBAL_PAGE_FORGE.name]: (0, $88f9531119605f50$export$a0e2b6c59fd25a4e),
    [(0, $64KID.namedRoutes).SPACE_PAGES.name]: (0, $3ae3b5e6a32b9f05$export$64ef8a59e56631d4),
    [(0, $64KID.namedRoutes).VIEW_PAGE.name]: (0, $7a7b7faa4141aa1d$export$51ff3cc323c1250d),
    [(0, $64KID.namedRoutes).PAGE_SPLIT.name]: (0, $f39a8f3c45c29808$export$5fb3818945ba48e4),
    [(0, $64KID.namedRoutes).BLOG_HOME.name]: (0, $5fbf62dcc2c7f9c7$export$59ba7d1ff575355e),
    [(0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name]: (0, $7a7b7faa4141aa1d$export$51ff3cc323c1250d),
    [(0, $64KID.namedRoutes).VIEW_BLOG.name]: (0, $7a7b7faa4141aa1d$export$51ff3cc323c1250d),
    [(0, $64KID.namedRoutes).WHITEBOARD_HOME.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).SPACE_PAGES.name),
    [(0, $64KID.namedRoutes).WHITEBOARD_BOARD.name]: (0, $09a888bb83dd7791$export$d584a39bdee41574),
    [(0, $64KID.namedRoutes).SLIDES_VIEW.name]: (0, $4e31866782374d42$export$3a64ee6cc47e86a4),
    [(0, $64KID.namedRoutes).DATABASE_VIEW.name]: (0, $b443bc65ee980e3b$export$2b633aba04c212bb),
    [(0, $64KID.namedRoutes).EMBED_VIEW.name]: (0, $a86e8bdaaaef979c$export$1a870b21a11af9ae),
    [(0, $64KID.namedRoutes).FOLDER_VIEW.name]: (0, $6e131d5d0e81b5af$export$110a009c083fc1fc),
    [(0, $64KID.namedRoutes).CONTACT_ADMINISTRATOR.name]: (0, $95bdd88deead3c11$export$ecc44bd892306adb),
    [(0, $64KID.namedRoutes).SPACE_CALENDARS.name]: (0, $116a232d5237eb91$export$c1ba174e1a668b1a),
    [(0, $64KID.namedRoutes).SPACE_CALENDARS_SUBCALENDAR.name]: (0, $116a232d5237eb91$export$c1ba174e1a668b1a),
    [(0, $64KID.namedRoutes).SPACE_EMBEDDED_SUBCALENDAR.name]: (0, $40c2c72cc1663e14$export$b6ba0c14cb68dffc),
    [(0, $64KID.namedRoutes).MULTIPLE_SUBCALENDAR.name]: (0, $d017e5de5f44817e$export$6443958a7203f769),
    [(0, $64KID.namedRoutes).EMBEDDED_MULTIPLE_SUBCALENDAR.name]: (0, $d3bef7a856c272ba$export$5984a4822491c8de),
    [(0, $64KID.namedRoutes).DISCOVER.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        feed: ''
    }),
    [(0, $64KID.namedRoutes).ALL_UPDATES.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        feed: 0
    }),
    [(0, $64KID.namedRoutes).POPULAR.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        feed: 1,
        feedType: 'POPULAR'
    }),
    [(0, $64KID.namedRoutes).MY_WORK_HOME.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 1
    }),
    [(0, $64KID.namedRoutes).MY_WORK_DRAFTS.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 2
    }),
    [(0, $64KID.namedRoutes).RECENT_DRAFTS.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 2
    }),
    [(0, $64KID.namedRoutes).MY_WORK_RECENT.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 1,
        filter: 'WORKED_ON'
    }),
    [(0, $64KID.namedRoutes).RECENT_PAGES.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 1
    }),
    [(0, $64KID.namedRoutes).MY_RECENTLY_VISITED.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 0
    }),
    [(0, $64KID.namedRoutes).RECENT_VISITED.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 0
    }),
    [(0, $64KID.namedRoutes).MY_SAVED_FOR_LATER.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 3
    }),
    [(0, $64KID.namedRoutes).RECENT_SAVED.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 3
    }),
    [(0, $64KID.namedRoutes).TEMPLATE_MIGRATION_PREVIEW.name]: (0, $a310d6589e3c6137$export$2549ad5558b468ce),
    [(0, $64KID.namedRoutes).EDIT_TEMPLATE.name]: (0, $db60bab822fccf44$export$b015e9e7191a93bd),
    [(0, $64KID.namedRoutes).EDIT_TEMPLATE_BLUEPRINT.name]: (0, $db60bab822fccf44$export$b015e9e7191a93bd),
    [(0, $64KID.namedRoutes).EDIT_TEMPLATE_SPACE.name]: (0, $db60bab822fccf44$export$b015e9e7191a93bd),
    [(0, $64KID.namedRoutes).CREATE_TEMPLATE.name]: (0, $db60bab822fccf44$export$b015e9e7191a93bd),
    [(0, $64KID.namedRoutes).CREATE_TEMPLATE_SPACE.name]: (0, $db60bab822fccf44$export$b015e9e7191a93bd),
    [(0, $64KID.namedRoutes).ADVANCED_SEARCH.name]: (0, $f2fc7f6fc64d8f4e$export$dbb0a9dfd98720f),
    [(0, $64KID.namedRoutes).EXTERNAL_SHARE.name]: (0, $b4ceb88d52b227e6$export$2f64eafbbfb5bb9f),
    [(0, $64KID.namedRoutes).ACCESS_LINK.name]: (0, $4afa1bc9a87a9b40$export$58816268cacd10b6),
    [(0, $64KID.namedRoutes).PEOPLE_DIRECTORY.name]: (0, $24a857c7c96255d7$export$c7bf94fd367d52ef),
    [(0, $64KID.namedRoutes).MARKETPLACE_APP_REQUESTS.name]: (0, $a6aaee7eaacb3bc0$export$1696ac6f866195be),
    [(0, $64KID.namedRoutes).MARKETPLACE_MANAGE_PROMOTIONS.name]: (0, $a6aaee7eaacb3bc0$export$1696ac6f866195be),
    [(0, $64KID.namedRoutes).MARKETPLACE_FIND_APPS.name]: (0, $a6aaee7eaacb3bc0$export$1696ac6f866195be),
    [(0, $64KID.namedRoutes).CONTENT_HISTORY.name]: (0, $48c85dee1e05da94$export$e510023ce2e8f364),
    [(0, $64KID.namedRoutes).ONBOARDING.name]: (0, $52219feed318a69e$export$329ee42b27a3306e),
    [(0, $64KID.namedRoutes).ADMIN_GLOBAL_AUTOMATION.name]: (0, $9dff8dc763109b25$export$a4a7c409f3d3e524),
    [(0, $64KID.namedRoutes).ADMIN_NEW_GLOBAL_PERMISSIONS.name]: (0, $5651b1434c6bae88$export$72e24cb8f0330a61),
    [(0, $64KID.namedRoutes).ADMIN_COMPANY_HUB_PERMISSIONS.name]: (0, $ce2a2ee7f6871785$export$eeb7368e8bf944ac),
    [(0, $64KID.namedRoutes).ADMIN_COMPANY_HOME_BUILDER.name]: (0, $4fa13b181dc663ad$export$5744f34ed241a45c),
    [(0, $64KID.namedRoutes).ADMIN_CUSTOMIZE_NAVIGATION.name]: (0, $4fa13b181dc663ad$export$3206f56dd9eda6e),
    [(0, $64KID.namedRoutes).ADMIN_NEW_GLOBAL_PERMISSIONS_USER_DETAILS.name]: (0, $3e17cd15ad9a2d77$export$ef0ae9b94af7599),
    [(0, $64KID.namedRoutes).ADMIN_EDIT_EXTERNAL_SHARING.name]: (0, $0960da40109465b4$export$af4daa43ca1332b9),
    [(0, $64KID.namedRoutes).ADMIN_ANONYMOUS_ACCESS.name]: (0, $d86fe9bfb21b5293$export$1d391e6d67538b19),
    [(0, $64KID.namedRoutes).ADMIN_SPACE_MANAGEMENT.name]: (0, $4fabe80bae5e8d04$export$fd1cbd536f2e61b4),
    [(0, $64KID.namedRoutes).ADMIN_SPACE_DEFAULTS.name]: (0, $25cfc5c41bd5d05f$export$5425f152a964e2a4),
    [(0, $64KID.namedRoutes).ADMIN_GUESTS.name]: (0, $e5c5bd5a8c7b0d6f$export$16c169bdc6cd5ebe),
    [(0, $64KID.namedRoutes).ADMIN_APP_PERMISSIONS.name]: (0, $9cf8f85dda9fbba2$export$74dc62432aba2eaa),
    [(0, $64KID.namedRoutes).ADMIN_JSM_ACCESS.name]: (0, $862979a48c317517$export$bc6803ac9d998199),
    [(0, $64KID.namedRoutes).ADMIN_SPACE_ROLES.name]: (0, $815c579597235468$export$3d75421a82ac4ef3),
    [(0, $64KID.namedRoutes).ADMIN_SITE_PERMISSIONS.name]: (0, $139f96c2577c166d$export$29c72ea3332ea2cc),
    [(0, $64KID.namedRoutes).ADMIN_FORGE_APPS_REDIRECT.name]: (0, $5d42f987126d0d25$export$1eaead8b8e68953c),
    [(0, $64KID.namedRoutes).ADMIN_FORGE_APPS.name]: (0, $d553d8b4da7f3160$export$25552d6a584e1fb8),
    [(0, $64KID.namedRoutes).ADMIN_BETA_FEATURES.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).ADMIN_NEW_FEATURES.name),
    [(0, $64KID.namedRoutes).ADMIN_NEW_FEATURES.name]: (0, $7949c11e9e78d917$export$39279dc1d0cb138f),
    [(0, $64KID.namedRoutes).ADMIN_NOTIFICATIONS.name]: (0, $5035325f0c8b9a13$export$65794158c09a379),
    [(0, $ccbb2c9664b7c084$export$f201f4e6a65cd2).ROUTE_NAME]: (0, $ccbb2c9664b7c084$export$f201f4e6a65cd2),
    [(0, $64KID.namedRoutes).PERFORMANCE_INSIGHTS_CPU_CORES.name]: (0, $50fb216eea7c3440$export$66e6ee80c1ffed5a),
    [(0, $64KID.namedRoutes).PERFORMANCE_INSIGHTS_NETWORK_SPEED.name]: (0, $50fb216eea7c3440$export$66e6ee80c1ffed5a),
    [(0, $64KID.namedRoutes).PERFORMANCE_INSIGHTS_NETWORK_PROTOCOL.name]: (0, $50fb216eea7c3440$export$66e6ee80c1ffed5a),
    [(0, $64KID.namedRoutes).PERFORMANCE_INSIGHTS_OPERATING_SYSTEM.name]: (0, $50fb216eea7c3440$export$66e6ee80c1ffed5a),
    [(0, $64KID.namedRoutes).PERFORMANCE_INSIGHTS.name]: (0, $50fb216eea7c3440$export$66e6ee80c1ffed5a),
    [(0, $64KID.namedRoutes).SITE_ANALYTICS.name]: (0, $63dcc013c61b21bf$export$ccfda76403f5bd22),
    [(0, $64KID.namedRoutes).SITE_ANALYTICS_PERMISSIONS.name]: (0, $2dd41eaa3836b7ed$export$7ed59daacefa1324),
    [(0, $64KID.namedRoutes).SPACE_ANALYTICS.name]: (0, $e76c2474e57ea114$export$af7907eff44c835f),
    [(0, $64KID.namedRoutes).SPACE_ANALYTICS_PERMISSIONS.name]: (0, $4a724484ea837e6c$export$703d82918dc06325),
    [(0, $64KID.namedRoutes).SPACE_SMART_CREATE.name]: (0, $f9a064f293d5119a$export$683599b1d0dc8e7b),
    [(0, $64KID.namedRoutes).PAGE_ANALYTICS.name]: (0, $2ddeeae61cd450c5$export$77b30b491c5d0ee0),
    [(0, $64KID.namedRoutes).SPACE_ARCHIVED_PAGES.name]: (0, $6079beeead36a4aa$export$77792abc2bfae7a1),
    [(0, $64KID.namedRoutes).SPACE_CONTRIBUTORS.name]: (0, $4a57d37907c9234e$export$68e37a802707fb55),
    [(0, $64KID.namedRoutes).SPACE_SUGGESTIONS.name]: (0, $2593d4b17876c400$export$a3041cafa4dd68cd),
    [(0, $64KID.namedRoutes).SPACE_BULK_TOOLS.name]: (0, $95e685c28d9f350e$export$690ececaf2f5ac01),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_LANDING_PAGE.name]: (0, $bdfe305fbc319d8d$export$b0e13503df86295),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_LANDING_PAGE_ALT.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).SPACE_SETTINGS_LANDING_PAGE.name),
    [(0, $64KID.namedRoutes).SPACE_FORGE_APPS.name]: (0, $e20a45805838a7c5$export$16cbc228d727cb5e),
    [(0, $64KID.namedRoutes).SPACE_CUSTOM_CONTENT_LIST.name]: (0, $25fdeb0a789de125$export$1045fc666c352ae6),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_FORGE_APPS.name]: (0, $70d1956925899c9e$export$21a09e0ddc77eafe),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_ARCHIVE_SPACE.name]: (0, $3d2592d831aaf97c$export$c5e406a0947cdc56),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_EDITOR_CONVERSION.name]: (0, $c1c9698c93be07c8$export$698dfc3fe326e6d2),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_AUTOMATION.name]: (0, $d6b8391ba067d418$export$3e7656e40361b9c3),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_AVATARS_AND_STATUS.name]: (0, $ada82682e35c0989$export$9cf7aa4fa48eb220),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_CONTENT_STATE.name]: (0, $ada82682e35c0989$export$9cf7aa4fa48eb220),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_DATA_CLASSIFICATION.name]: (0, $9ad8ac092b3ce6dd$export$4b1ffbf66f0e44ca),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_WATERMARK_CONFIGURATION.name]: (0, $0db33795337c2a26$export$2bb331cf926ecae2),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_EXPORT_SPACE_UNAVAILABLE.name]: (0, $e2d8d9818dde6381$export$1d1f8d0ef7c7a185),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_EXPORT.name]: (0, $69b9df17dc76bcc3$export$4d1bd2808cfd2f38),
    [(0, $64KID.namedRoutes).SPACE_LEGACY_CONTENT.name]: (0, $b819de32c6839e12$export$f983b39883686021),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_AVATARS.name]: (0, $baeceeb2053ed280$export$232f775b06326172),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_STATUS_AND_APPROVALS.name]: (0, $1a46d2ab385e41f3$export$905b6f7e554c11f5),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_RELATED_PAGES.name]: (0, $5fd2607ebf0fb934$export$50efde5a87cc8957),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_EDIT_FEATURES.name]: (0, $c991c60ce35a3f45$export$769dfef0447f3a55),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_AGENT_CONTEXT.name]: (0, $d79bba560e75ebc3$export$5cb7b3311cd85f89),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_DETAILS.name]: (0, $ae6364090fd3faa0$export$45c01163cd56b3a2),
    [(0, $64KID.namedRoutes).SPACE_QUESTIONS_NATIVE.name]: (0, $44ff6e33806985ff$export$384dd5b6b76557b1),
    [(0, $64KID.namedRoutes).SPACE_QUESTIONS_ASK_NATIVE.name]: (0, $44ff6e33806985ff$export$9f80bcb940c350e6),
    [(0, $64KID.namedRoutes).SPACE_QUESTION_NATIVE.name]: (0, $281ce5bf20714bdc$export$aea18e9fd89afe15),
    [(0, $64KID.namedRoutes).QUESTIONS_NATIVE.name]: (0, $8e1d38472579226f$export$6cff3d6e80ecc64),
    [(0, $64KID.namedRoutes).QUESTION_NATIVE.name]: (0, $a488bad1e68dd6a7$export$5c0c86e79c0609bd),
    [(0, $64KID.namedRoutes).QUESTIONS_TOPICS_NATIVE.name]: (0, $a488bad1e68dd6a7$export$5c0c86e79c0609bd),
    [(0, $64KID.namedRoutes).QUESTIONS_TOPIC_NATIVE.name]: (0, $a488bad1e68dd6a7$export$5c0c86e79c0609bd),
    [(0, $64KID.namedRoutes).QUESTIONS_EXPERTS_NATIVE.name]: (0, $a488bad1e68dd6a7$export$5c0c86e79c0609bd),
    [(0, $64KID.namedRoutes).MY_CALENDAR.name]: (0, $e84d6ad8839aa142$export$355693d248632c9a),
    [(0, $64KID.namedRoutes).PDF_EXPORT_PAGE.name]: (0, $de365c057d45c0f8$export$d4d3fe32e0af1ab9),
    [(0, $64KID.namedRoutes).PDF_EXPORT_SPACE.name]: (0, $cdc5bb1b4ce25ace$export$f10520cd46ef45dd),
    [(0, $64KID.namedRoutes).CUSTOM_CONTENTS_ON_PAGE_LIST.name]: (0, $4af991445198673b$export$80477c996ae74379),
    [(0, $64KID.namedRoutes).CUSTOM_CONTENT_VIEW.name]: (0, $c7473af47fe3192c$export$b836ebd0f49cc9f5),
    [(0, $64KID.namedRoutes).SPACE_PERMISSIONS_SETTINGS.name]: (0, $3dace45d43821ccc$export$c4e68572e7b94bc6),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_ACCESS_LINKS.name]: (0, $306fa1afbc47dc82$export$9357b91a8ce986c5),
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_ACCESS_LINKS_CONFIGURATION.name]: (0, $b81de96a75fad070$export$e64a7ea2c0613adc),
    [(0, $64KID.namedRoutes).ROLE_BASED_ACCESS_CONTROL_HUB.name]: (0, $1fb601398675b5a1$export$23838e4b7dc196e5),
    [(0, $64KID.namedRoutes).SPACE_LOOK_AND_FEEL_SETTINGS.name]: (0, $ea3042d7dfb4b938$export$9ebf5b01b0356442),
    [(0, $64KID.namedRoutes).ADMIN_ANNOUNCEMENT_BANNER_RENDERER.name]: (0, $e77b8eed9c4fe03f$export$81a4ecf687c4a61b),
    [(0, $64KID.namedRoutes).SPACE_MANAGER.name]: (0, $244c44f585122129$export$986d179bc3f7f637),
    [(0, $64KID.namedRoutes).USER_ACCESS.name]: (0, $c4bba5ee88869a52$export$45dbe3e1239d2b94),
    [(0, $64KID.namedRoutes).ADMIN_CENTER.name]: (0, $36a63e56cd2b2984$export$60c1a30975370191),
    [(0, $64KID.namedRoutes).ADMIN_CENTER_SPACE.name]: (0, $015145ca08e6a13a$export$bd929b984ffc4a9),
    [(0, $64KID.namedRoutes).ADMIN_SETTINGS.name]: (0, $6f06338c7fe23a44$export$44bc7d6c094dc951),
    [(0, $64KID.namedRoutes).ADMIN_BULK_PERMISSIONS.name]: (0, $4255a2123073399b$export$a1ed7a563d6f8c80),
    [(0, $64KID.namedRoutes).ADMIN_SITE_SPACE_PERMISSIONS.name]: (0, $d3d38e453fe82603$export$6b4028c8cfa4e9e1),
    [(0, $64KID.namedRoutes).ADMIN_TEAM_CALENDARS.name]: (0, $d1361d4d835db3f1$export$5164e66822dc5aec),
    [(0, $64KID.namedRoutes).ADMIN_TEAM_CONTROLS.name]: (0, $7793a666921a34a3$export$ee12bdabe55b87f5),
    [(0, $64KID.namedRoutes).ADMIN_CONFIGURATION.name]: (0, $daea30cdb73fa105$export$9a9547459861b1d),
    [(0, $64KID.namedRoutes).ADMIN_DEFAULT_SPACE_LOGO.name]: (0, $cf2a30228181ae7a$export$12cd952fb663f2a5),
    [(0, $64KID.namedRoutes).ADMIN_HEADER_AND_FOOTER.name]: (0, $d9d1782c5d23f713$export$66aaa3e4fa4fb446),
    [(0, $64KID.namedRoutes).ADMIN_TEMPLATES_AND_BLUEPRINTS.name]: (0, $3de5f90ca85ac387$export$fb8cddd2e05884ff),
    [(0, $64KID.namedRoutes).ADMIN_CODE_MACRO_CONFIGURATION.name]: (0, $2e9a50b174f89446$export$761483e0f415164e),
    [(0, $64KID.namedRoutes).ADMIN_COLOR_SCHEME.name]: (0, $0fb617f0ce9f4007$export$8984debadcec9d93),
    [(0, $64KID.namedRoutes).ADMIN_ACCESS_REQUESTS.name]: (0, $640b7346d02500f9$export$e43d8e128566b1eb),
    [(0, $64KID.namedRoutes).ADMIN_SECURITY_CONFIGURATION.name]: (0, $7fe52c8ec8c71cab$export$b882bc9c4e633e9b),
    [(0, $64KID.namedRoutes).ADMIN_ACCESS_LINKS.name]: (0, $ebbc45da5498e408$export$968567891972d6d4),
    [(0, $64KID.namedRoutes).ADMIN_ACCESS_LINKS_CONFIGURATION.name]: (0, $30cc72374591e2a1$export$ac0bb92ad015adc6),
    [(0, $64KID.namedRoutes).ADMIN_SPACE_REPORTS.name]: (0, $ba2c2ff5f89f0551$export$2667c61817b129fd),
    [(0, $64KID.namedRoutes).ADMIN_APPLICATION_NAVIGATOR.name]: (0, $98f73671c286928d$export$55ff18e8dde17771),
    [(0, $64KID.namedRoutes).ADMIN_TRASHED_SPACES.name]: (0, $b9260b374d11ae03$export$154b40ed25137a69),
    [(0, $64KID.namedRoutes).ADMIN_CONFLUENCE_CHATS_INTEGRATION.name]: (0, $2cc036891fb5d716$export$2e4708beaaa8ed13),
    [(0, $64KID.namedRoutes).CONFLUENCE_MSTEAMS_SIGNIN_CONFIRMATION.name]: (0, $db04f75f13f6a54c$export$946acfb57ab420fd),
    [(0, $64KID.namedRoutes).ADMIN_IMPORT_SPACES.name]: (0, $d9481fcbb25a62a6$export$6078cc5c61cdb00c),
    [(0, $64KID.namedRoutes).ADMIN_JIRA_MACRO_REPAIR.name]: (0, $3ed31ec1d64e85a3$export$1162e5a60ee7576b),
    [(0, $64KID.namedRoutes).ADMIN_MACRO_USAGE.name]: (0, $2395a25321aca708$export$1e71122b3eac56e4),
    [(0, $64KID.namedRoutes).ADMIN_THEMES.name]: (0, $95678b1264993b8d$export$cdc2bb4346e935c9),
    [(0, $64KID.namedRoutes).ADMIN_PDF_EXPORT.name]: (0, $d726f64aa7b98b71$export$81e12ffb7d442c0c),
    [(0, $64KID.namedRoutes).ADMIN_WATERMARK_CONFIGURATION.name]: (0, $1cb4912c670744a4$export$ee4273463a3d48ad),
    [(0, $64KID.namedRoutes).ADMIN_DC_SCRIPT_MIGRATION.name]: (0, $a58212c7e75084fc$export$4b568b9f0da70fe4),
    [(0, $64KID.namedRoutes).ADMIN_NBM_MIGRATION.name]: (0, $0a6ea19b0fb236e1$export$e644f8e819f9f36),
    [(0, $64KID.namedRoutes).ADMIN_NBM_MIGRATION_SCANS.name]: (0, $0a6ea19b0fb236e1$export$e644f8e819f9f36),
    [(0, $64KID.namedRoutes).ADMIN_NBM_MIGRATION_SCAN.name]: (0, $0a6ea19b0fb236e1$export$e644f8e819f9f36),
    [(0, $64KID.namedRoutes).ADMIN_NBM_MIGRATION_UNVERIFIED.name]: (0, $0a6ea19b0fb236e1$export$e644f8e819f9f36),
    [(0, $64KID.namedRoutes).ADMIN_NBM_MIGRATION_UNSUPPORTED.name]: (0, $0a6ea19b0fb236e1$export$e644f8e819f9f36),
    [(0, $64KID.namedRoutes).ADMIN_NBM_MIGRATION_RUN_TRANSFORMATIONS.name]: (0, $0a6ea19b0fb236e1$export$e644f8e819f9f36),
    [(0, $64KID.namedRoutes).ADMIN_NBM_MIGRATION_TRANSFORMATIONS.name]: (0, $0a6ea19b0fb236e1$export$e644f8e819f9f36),
    [(0, $64KID.namedRoutes).SPACE_MEMBERS.name]: (0, $f9fff28badc7670c$export$214350c926cc60f2),
    [(0, $64KID.namedRoutes).TOPICS.name]: (0, $ad7e3274b7fede14$export$54f890efdb9a624),
    [(0, $64KID.namedRoutes).IMPORTER_STATUS_DASHBOARD.name]: (0, $e2dae4d283de07f2$export$abf2f9d0f3a44f9c),
    [(0, $64KID.namedRoutes).ATTACHMENTS_PAGE.name]: (0, $167b5527ac95ab07$export$fd9e136112feb41f),
    [(0, $64KID.namedRoutes).CHAT.name]: (0, $123d32deac7bf460$export$4fc17ec31b01e987),
    [(0, $64KID.namedRoutes).INFERRED_PROJECT_PAGE.name]: (0, $fd49b5c0edd0f211$export$8d789824df52a6bc),
    [(0, $64KID.namedRoutes).INFERRED_PROJECT_PAGE_WITH_ARI.name]: (0, $fd49b5c0edd0f211$export$8d789824df52a6bc),
    [(0, $64KID.namedRoutes).PERMISSIONS_EXPORT.name]: (0, $6deffcd0919e3152$export$9dc6a62d8cf9ae06),
    [(0, $64KID.namedRoutes).PERMISSIONS_COMBINATIONS.name]: (0, $5fcbb229533ae7f5$export$2cdfcdcf001693ff),
    [(0, $64KID.namedRoutes).ADMIN_SYSTEM_OPERATIONS.name]: (0, $7fda056324955ad3$export$26979a3c4ac291c5),
    [(0, $64KID.namedRoutes).NEW_AUDIT_LOG.name]: (0, $beac86ab997501a9$export$b6dab1e8a8b6a66d)
});
module.exports["routeComponents"] = $c6a4b2258628a516$export$4d9abfe5519d76c6;

});

parcelRegister("7Snc9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lFjPc = parcelRequire("lFjPc");


var $iJ8K8 = parcelRequire("iJ8K8");


var $5gmpn = parcelRequire("5gmpn");


var $4H46k = parcelRequire("4H46k");

function $1cae7e3e681988dd$export$271f9f08425019c7() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJ8K8.Screen), {
        screenEvent: {
            name: 'notFoundScreen'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5gmpn.MainLayout), {
        navView: (0, $lFjPc.PRODUCT_HOME_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H46k.LazyConfluenceNotFound), null)));
}
module.exports["NotFound"] = $1cae7e3e681988dd$export$271f9f08425019c7;

});

parcelRegister("bTZ0F", function(module, exports) {
const $b7dd8cf53c436032$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};
module.exports["PerformanceObserverEntryTypes"] = $b7dd8cf53c436032$export$a4def92db6fc8e17;

});

parcelRegister("bH6Zn", function(module, exports) {

var $bTZ0F = parcelRequire("bTZ0F");

class $2247f8d9b00b1359$export$2c6e86519c9e8188 {
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
    constructor(maxLength = 1000){
        this.buffer = [];
        this.maxLength = void 0;
        this.full = false;
        this.maxLength = maxLength;
    }
}
const $2247f8d9b00b1359$export$f7dc16cbd16f7bbe = {
    [(0, $bTZ0F.PerformanceObserverEntryTypes).LongTask]: new $2247f8d9b00b1359$export$2c6e86519c9e8188(),
    [(0, $bTZ0F.PerformanceObserverEntryTypes).LayoutShift]: new $2247f8d9b00b1359$export$2c6e86519c9e8188()
};
module.exports["EntriesBuffer"] = $2247f8d9b00b1359$export$f7dc16cbd16f7bbe;

});

parcelRegister("cKmxI", function(module, exports) {
$parcel$export(module.exports, "useRouter", () => (parcelRequire("fcvZw")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("idnP4")).useRouterActions);

var $kkBFa = parcelRequire("kkBFa");


var $hSxV5 = parcelRequire("hSxV5");


var $bPYAw = parcelRequire("bPYAw");


var $ebiij = parcelRequire("ebiij");


var $hFkZi = parcelRequire("hFkZi");


var $6GERo = parcelRequire("6GERo");


var $96I48 = parcelRequire("96I48");


var $fcvZw = parcelRequire("fcvZw");


var $idnP4 = parcelRequire("idnP4");


var $4Yqy7 = parcelRequire("4Yqy7");


});

parcelRegister("eCzAr", function(module, exports) {
$parcel$export(module.exports, "Link", () => (parcelRequire("8Dc6h")).default);

var $8Dc6h = parcelRequire("8Dc6h");


var $eJQlm = parcelRequire("eJQlm");


});

parcelRegister("htyBH", function(module, exports) {
$parcel$export(module.exports, "generateLocationFromPath", () => (parcelRequire("k9z7m")).generateLocationFromPath);
$parcel$export(module.exports, "generatePath", () => (parcelRequire("epPJ3")).generatePath);
$parcel$export(module.exports, "isServerEnvironment", () => (parcelRequire("9qwq6")).isServerEnvironment);
$parcel$export(module.exports, "warmupMatchRouteCache", () => (parcelRequire("iL7a3")).warmupMatchRouteCache);
$parcel$export(module.exports, "findRouterContext", () => (parcelRequire("jwQVI")).findRouterContext);
$parcel$export(module.exports, "createRouterContext", () => (parcelRequire("jwQVI")).createRouterContext);
$parcel$export(module.exports, "isSameRouteMatch", () => (parcelRequire("3UFvg")).isSameRouteMatch);

var $ac1eE = parcelRequire("ac1eE");


var $k9z7m = parcelRequire("k9z7m");


var $epPJ3 = parcelRequire("epPJ3");


var $9qwq6 = parcelRequire("9qwq6");


var $iL7a3 = parcelRequire("iL7a3");


var $jwQVI = parcelRequire("jwQVI");


var $3UFvg = parcelRequire("3UFvg");


});

parcelRegister("3xrKK", function(module, exports) {
parcelRequire("htyBH");
var $jwQVI = parcelRequire("jwQVI");

const $2939fb557696c2f9$export$c36ce69a82764756 = (plugins, { routes: routes, history: history, basePath: basePath })=>{
    const context = (0, $jwQVI.findRouterContext)(routes, {
        location: history.location,
        basePath: basePath
    });
    plugins.forEach((p)=>{
        p.routeLoad == null || p.routeLoad({
            context: context
        });
    });
};

});

parcelRegister("hFkZi", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $lI7ls = parcelRequire("lI7ls");


var $iTvlA = parcelRequire("iTvlA");

var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");


var $jjIOx = parcelRequire("jjIOx");

parcelRequire("htyBH");
var $jwQVI = parcelRequire("jwQVI");
var $k9z7m = parcelRequire("k9z7m");
var $epPJ3 = parcelRequire("epPJ3");
var $9qwq6 = parcelRequire("9qwq6");
var $iL7a3 = parcelRequire("iL7a3");


var $4NiRC = parcelRequire("4NiRC");

parcelRequire("htyBH");
var $3UFvg = parcelRequire("3UFvg");

const $fbc5c35deb3fef4f$var$stripTrailingSlash = (path)=>path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
const $fbc5c35deb3fef4f$var$addLeadingSlash = (path)=>path.charAt(0) === '/' ? path : '/' + path;
const $fbc5c35deb3fef4f$export$b8ce2e8154d1dff1 = (path, prefix = '')=>{
    if (prefix) {
        prefix = $fbc5c35deb3fef4f$var$stripTrailingSlash(prefix);
        prefix = $fbc5c35deb3fef4f$var$addLeadingSlash(prefix);
        path = $fbc5c35deb3fef4f$var$addLeadingSlash(path);
    }
    return prefix + path;
};
const $fbc5c35deb3fef4f$export$e83e3719fc818ee5 = (path)=>{
    const regex = new RegExp('^([a-z]+://|//)', 'i');
    return regex.test(path);
};
const $fbc5c35deb3fef4f$export$2fa6dede99f181e5 = (path)=>{
    if (typeof path !== 'string' || !$fbc5c35deb3fef4f$export$e83e3719fc818ee5(path)) return false;
    const pathHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($4NiRC)))(path).hostname;
    const currentHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($4NiRC)))(window.location.href).hostname;
    return pathHostname !== currentHostname;
};
const $fbc5c35deb3fef4f$export$ae9fda833d91ed65 = (path, prefix = '')=>{
    if (typeof path !== 'string') return path;
    if (!$fbc5c35deb3fef4f$export$e83e3719fc818ee5(path)) {
        path = $fbc5c35deb3fef4f$export$b8ce2e8154d1dff1(path, prefix);
        return path;
    }
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($4NiRC)))(path);
    return `${url.pathname}${url.query}${url.hash}`;
};
const $fbc5c35deb3fef4f$export$92377f461a797888 = (location, query)=>{
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $4NiRC.qs).stringify(query, true);
    return `${location.pathname}${stringifiedQuery}${location.hash}`;
};
const $fbc5c35deb3fef4f$export$9ae1c7c875ef309d = (location)=>{
    return `${location.pathname}${location.search}${location.hash}`;
};
const $fbc5c35deb3fef4f$export$c9237620ff7fdf7c = ({ context: context, prevContext: prevContext, pluginId: pluginId })=>{
    const sameRoute = (0, $3UFvg.isSameRouteMatch)({
        prevContextMatch: prevContext.match,
        nextContextMatch: context.match
    });
    // keep old behaviour for Resources plugin
    // load Route only if path/query/params changed, and ignore the rest of query-params
    const defaultShouldReload = pluginId === 'resources-plugin' || !sameRoute;
    if (context.route === prevContext.route && context.route.EXPERIMENTAL__shouldReload) {
        const routeChoice = context.route.EXPERIMENTAL__shouldReload({
            context: context,
            prevContext: prevContext,
            pluginId: pluginId,
            defaultShouldReload: defaultShouldReload
        });
        if (typeof routeChoice === 'boolean') return routeChoice;
    }
    return defaultShouldReload;
};


const $cdc68bbb9513070c$export$36d128238e6b60f5 = {
    action: (0, $jjIOx.DEFAULT_ACTION),
    basePath: '',
    location: (0, $jjIOx.DEFAULT_HISTORY).location,
    history: (0, $jjIOx.DEFAULT_HISTORY),
    match: (0, $jjIOx.DEFAULT_MATCH),
    onPrefetch: undefined,
    query: {},
    route: (0, $jjIOx.DEFAULT_ROUTE),
    routes: [],
    unlisten: null,
    plugins: []
};
const $cdc68bbb9513070c$var$actions = {
    /**
   * Bootstraps the store with initial data.
   *
   */ bootstrapStore: (props)=>({ setState: setState, dispatch: dispatch })=>{
            const { basePath: basePath = '', history: history, initialRoute: initialRoute, onPrefetch: onPrefetch, routes: routes, plugins: plugins } = props;
            const routerContext = (0, $jwQVI.findRouterContext)(initialRoute ? [
                initialRoute
            ] : routes, {
                location: history.location,
                basePath: basePath
            });
            setState((0, $eb3ax.default)({}, routerContext, {
                basePath: basePath,
                history: history,
                onPrefetch: onPrefetch,
                routes: routes,
                location: history.location,
                action: history.action,
                plugins: plugins
            }));
            if (!(0, $9qwq6.isServerEnvironment)()) dispatch($cdc68bbb9513070c$var$actions.listen());
        },
    /**
   * Starts listening to browser history and sets the unlisten function in state.
   * Will request route resources on route change.
   *
   */ listen: ()=>({ getState: getState, setState: setState })=>{
            const { history: history, unlisten: unlisten } = getState();
            if (unlisten) unlisten();
            const stopListening = history.listen((...update)=>{
                const location = update.length === 2 ? update[0] : update[0].location;
                const action = update.length === 2 ? update[1] : update[0].action;
                const { plugins: plugins, routes: routes, basePath: basePath, match: currentMatch, route: currentRoute, query: currentQuery } = getState();
                const nextContext = (0, $jwQVI.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
                const prevContext = {
                    route: currentRoute,
                    match: currentMatch,
                    query: currentQuery
                };
                const shouldReloadByPlugin = new Map(plugins.map((plugin)=>[
                        plugin.id,
                        (0, $fbc5c35deb3fef4f$export$c9237620ff7fdf7c)({
                            context: nextContext,
                            prevContext: prevContext,
                            pluginId: plugin.id
                        })
                    ]));
                /* Explicitly batch update
       * as we need resources cleaned + route changed + resource fetch started together
       * If we do not batch, React might be re-render when route changes but resource
       * fetching has not started yet, making the app render with data null */ (0, $iTvlA.batch)(()=>{
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.beforeRouteLoad == null || p.beforeRouteLoad({
                            context: prevContext,
                            nextContext: nextContext
                        });
                    });
                    setState((0, $eb3ax.default)({}, nextContext, {
                        location: location,
                        action: action
                    }));
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.routeLoad == null || p.routeLoad({
                            context: nextContext,
                            prevContext: prevContext
                        });
                    });
                });
            });
            setState({
                unlisten: stopListening
            });
        },
    push: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $fbc5c35deb3fef4f$export$2fa6dede99f181e5)(path)) window.location.assign(path);
            else history.push((0, $fbc5c35deb3fef4f$export$ae9fda833d91ed65)(path, basePath), state);
        },
    pushTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $k9z7m.generateLocationFromPath)(route.path, (0, $eb3ax.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $iL7a3.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.push(location, attributes == null ? void 0 : attributes.state);
        },
    replace: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $fbc5c35deb3fef4f$export$2fa6dede99f181e5)(path)) window.location.replace(path);
            else history.replace((0, $fbc5c35deb3fef4f$export$ae9fda833d91ed65)(path, basePath), state);
        },
    replaceTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $k9z7m.generateLocationFromPath)(route.path, (0, $eb3ax.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $iL7a3.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.replace(location, attributes == null ? void 0 : attributes.state);
        },
    goBack: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goBack(), history@5 uses back()
            if ('goBack' in history) history.goBack();
            else if ('back' in history) history.back();
            else throw new Error('History does not support goBack');
        },
    goForward: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goForward(), history@5 uses forward()
            if ('goForward' in history) history.goForward();
            else if ('forward' in history) history.forward();
            else throw new Error('History does not support goForward');
        },
    registerBlock: (blocker)=>({ getState: getState })=>{
            const { history: history } = getState();
            return history.block(blocker);
        },
    getContext: ()=>({ getState: getState })=>{
            const { query: query, route: route, match: match } = getState();
            return {
                query: query,
                route: route,
                match: match
            };
        },
    getBasePath: ()=>({ getState: getState })=>{
            const { basePath: basePath } = getState();
            return basePath;
        },
    updateQueryParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { query: existingQueryParams, history: history, location: location } = getState();
            const updatedQueryParams = (0, $eb3ax.default)({}, existingQueryParams, params);
            // remove undefined keys
            Object.keys(updatedQueryParams).forEach((key)=>updatedQueryParams[key] === undefined && delete updatedQueryParams[key]);
            const existingPath = (0, $fbc5c35deb3fef4f$export$92377f461a797888)(location, existingQueryParams);
            const updatedPath = (0, $fbc5c35deb3fef4f$export$92377f461a797888)(location, updatedQueryParams);
            if (updatedPath !== existingPath) history[updateType](updatedPath);
        },
    updatePathParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { history: history, location: location, route: { path: path }, match: { params: existingPathParams }, basePath: basePath } = getState();
            const pathWithBasePath = basePath + path;
            const updatedPathParams = (0, $eb3ax.default)({}, existingPathParams, params);
            const updatedPath = (0, $epPJ3.generatePath)(pathWithBasePath, updatedPathParams);
            const updatedLocation = (0, $eb3ax.default)({}, location, {
                pathname: updatedPath
            });
            const existingRelativePath = (0, $fbc5c35deb3fef4f$export$9ae1c7c875ef309d)(location);
            const updatedRelativePath = (0, $fbc5c35deb3fef4f$export$9ae1c7c875ef309d)(updatedLocation);
            if (updatedRelativePath !== existingRelativePath) history[updateType](updatedRelativePath);
        },
    loadPlugins: ()=>({ getState: getState })=>{
            const { plugins: plugins, match: match, query: query, route: route } = getState();
            plugins.forEach((p)=>p.routeLoad == null ? void 0 : p.routeLoad({
                    context: {
                        match: match,
                        query: query,
                        route: route
                    }
                }));
        },
    prefetchRoute: (path, nextContext)=>({ getState: getState })=>{
            const { plugins: plugins, routes: routes, basePath: basePath, onPrefetch: onPrefetch } = getState();
            const { route: route, match: match, query: query } = $cdc68bbb9513070c$export$ebf37f7e180b13a9();
            if (!nextContext && !(0, $fbc5c35deb3fef4f$export$2fa6dede99f181e5)(path)) {
                const location = (0, $lI7ls.parsePath)((0, $fbc5c35deb3fef4f$export$ae9fda833d91ed65)(path, basePath));
                nextContext = (0, $jwQVI.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
            }
            if (nextContext == null) return;
            const nextLocationContext = nextContext;
            (0, $iTvlA.batch)(()=>{
                plugins.forEach((p)=>p.routePrefetch == null ? void 0 : p.routePrefetch({
                        context: {
                            route: route,
                            match: match,
                            query: query
                        },
                        nextContext: nextLocationContext
                    }));
                if (onPrefetch) onPrefetch(nextLocationContext);
            });
        }
};
const $cdc68bbb9513070c$export$1cf0ecab63b1963c = (0, $8s9DV.createStore)({
    initialState: $cdc68bbb9513070c$export$36d128238e6b60f5,
    actions: $cdc68bbb9513070c$var$actions,
    name: 'router'
});
const $cdc68bbb9513070c$export$d6b817abe7a77ea5 = (0, $j8on0.createContainer)($cdc68bbb9513070c$export$1cf0ecab63b1963c, {
    displayName: 'RouterContainer',
    onInit: ()=>({ dispatch: dispatch }, props)=>{
            dispatch($cdc68bbb9513070c$var$actions.bootstrapStore(props));
            !(0, $9qwq6.isServerEnvironment)() && dispatch($cdc68bbb9513070c$var$actions.loadPlugins());
        },
    onCleanup: ()=>(state)=>{
            if (!(0, $9qwq6.isServerEnvironment)()) {
                const { unlisten: unlisten } = state.getState();
                unlisten && unlisten();
            }
        }
});
const $cdc68bbb9513070c$export$9569010eab09ae9e = (0, $kBr4q.createHook)($cdc68bbb9513070c$export$1cf0ecab63b1963c);
const $cdc68bbb9513070c$export$ada49399abf7a3a1 = (0, $kBr4q.createActionsHook)($cdc68bbb9513070c$export$1cf0ecab63b1963c);
function $cdc68bbb9513070c$export$95ab46bba7ea7a22(selector) {
    const useHook = (0, $kBr4q.createHook)($cdc68bbb9513070c$export$1cf0ecab63b1963c, {
        selector: selector
    });
    return function useRouterSelector(...args) {
        return useHook(...args)[0];
    };
}
const $cdc68bbb9513070c$export$5ccad187366c8494 = ()=>// @ts-ignore calling `getStore` without providing a scopeId
    (0, $c6StJ.defaultRegistry).getStore($cdc68bbb9513070c$export$1cf0ecab63b1963c);
const $cdc68bbb9513070c$export$ebf37f7e180b13a9 = ()=>$cdc68bbb9513070c$export$5ccad187366c8494().storeState.getState();
module.exports["RouterStore"] = $cdc68bbb9513070c$export$1cf0ecab63b1963c;
module.exports["RouterContainer"] = $cdc68bbb9513070c$export$d6b817abe7a77ea5;
module.exports["useRouterStore"] = $cdc68bbb9513070c$export$9569010eab09ae9e;
module.exports["useRouterStoreActions"] = $cdc68bbb9513070c$export$ada49399abf7a3a1;

});

parcelRegister("jjIOx", function(module, exports) {

var $eO7Xs = parcelRequire("eO7Xs");


var $ac1eE = parcelRequire("ac1eE");

const $e1028dcd9b3deb96$export$7c22f8f9552f689e = {
    pathname: '',
    search: '',
    hash: ''
};
const $e1028dcd9b3deb96$export$2de13e891a662beb = {
    params: {},
    isExact: false,
    path: '',
    url: '',
    query: {}
};
const $e1028dcd9b3deb96$export$4eadc79233226325 = {
    path: '',
    component: ()=>null,
    name: ''
};
const $e1028dcd9b3deb96$export$39607c9878cf5148 = (0, $ac1eE.createLegacyHistory)();
const $e1028dcd9b3deb96$export$1515254c8c90bebb = {
    location: $e1028dcd9b3deb96$export$7c22f8f9552f689e,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    listen: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    block: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    createHref: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs)))
};
const $e1028dcd9b3deb96$export$fa440ddf675c8a93 = 'POP';
module.exports["DEFAULT_MATCH"] = $e1028dcd9b3deb96$export$2de13e891a662beb;
module.exports["DEFAULT_ROUTE"] = $e1028dcd9b3deb96$export$4eadc79233226325;
module.exports["DEFAULT_HISTORY"] = $e1028dcd9b3deb96$export$39607c9878cf5148;
module.exports["DEFAULT_ACTION"] = $e1028dcd9b3deb96$export$fa440ddf675c8a93;

});

parcelRegister("9Nkr4", function(module, exports) {

var $91pEK = parcelRequire("91pEK");


var $RNy7H = parcelRequire("RNy7H");


var $3ct2F = parcelRequire("3ct2F");


var $d9oWA = parcelRequire("d9oWA");


var $97ZVl = parcelRequire("97ZVl");





var $e5SM2 = parcelRequire("e5SM2");


});

parcelRegister("cvj4z", function(module, exports) {
$parcel$export(module.exports, "RouterSubscriber", () => (parcelRequire("aO6HO")).RouterSubscriber);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("j4NNn")).useRouterActions);
$parcel$export(module.exports, "Link", () => (parcelRequire("imtAv")).default);
$parcel$export(module.exports, "RouterStore", () => (parcelRequire("kZkvy")).RouterStore);
$parcel$export(module.exports, "useRouterStoreActions", () => (parcelRequire("kZkvy")).useRouterStoreActions);

parcelRequire("9vmeB");
var $aO6HO = parcelRequire("aO6HO");
var $j4NNn = parcelRequire("j4NNn");

parcelRequire("6BZrm");
var $imtAv = parcelRequire("imtAv");

parcelRequire("bDcGz");
var $lKKkr = parcelRequire("lKKkr");
var $fHQWF = parcelRequire("fHQWF");
var $fEoYr = parcelRequire("fEoYr");
var $bDcGz = parcelRequire("bDcGz");


var $8WqGQ = parcelRequire("8WqGQ");


var $kZkvy = parcelRequire("kZkvy");


var $3yk4a = parcelRequire("3yk4a");

parcelRequire("2Tnfk");
var $jPvl5 = parcelRequire("jPvl5");
var $c7RYO = parcelRequire("c7RYO");
var $2s5nZ = parcelRequire("2s5nZ");


});

parcelRegister("8A6YM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fodiz = parcelRequire("fodiz");


var $3izAL = parcelRequire("3izAL");


var $kz1Yj = parcelRequire("kz1Yj");


var $buxP3 = parcelRequire("buxP3");


var $4ikjJ = parcelRequire("4ikjJ");


var $1sCHt = parcelRequire("1sCHt");


var $lpNn5 = parcelRequire("lpNn5");


var $iquRY = parcelRequire("iquRY");

const $ec94e17fe3441559$var$i18n = (0, $kSwu1.defineMessages)({
    archivedSpacesTooltip: {
        id: "bulk-permissions.space.archived-spaces-tooltip",
        defaultMessage: "Archived spaces are not included in bulk permissions actions."
    },
    archivedSpacesTooltipBulkAccess: {
        id: "bulk-permissions.space.archived-spaces-tooltip-bulk-access",
        defaultMessage: "Archived spaces are not included in bulk access actions."
    },
    archivedSpacesTooltipIconLabel: {
        id: "bulk-permissions.space.archived-spaces-tooltip-icon-label",
        defaultMessage: "Archived space information"
    },
    spaceSelectionHeader: {
        id: "bulk-permissions.space.space-selection-header",
        defaultMessage: "Choose which spaces"
    },
    spaceAccessSelectionHeader: {
        id: "bulk-permissions.space.space-access-selection-header",
        defaultMessage: "On which spaces<asterisk>*</asterisk>"
    },
    spaceSelectionOne: {
        id: "bulk-permissions.space.space-selection-one",
        defaultMessage: "All"
    },
    spaceSelectionOneDescription: {
        id: "bulk-permissions.space.space-selection-one.description.non-final",
        defaultMessage: "All spaces within your tenant"
    },
    spaceSelectionTwo: {
        id: "bulk-permissions.space.space-selection-two",
        defaultMessage: "All (excluding personal)"
    },
    spaceSelectionTwoDescription: {
        id: "bulk-permissions.space.space-selection-two.description.non-final",
        defaultMessage: "All spaces within your tenant, except for personal spaces."
    },
    spaceSelectionFour: {
        id: "bulk-permissions.space.space-selection-four",
        defaultMessage: "Only personal"
    },
    spaceSelectionFourDescription: {
        id: "bulk-permissions.space.space-selection-four.description.non-final",
        defaultMessage: "Only select personal spaces within this tenant"
    }
});
var $ec94e17fe3441559$export$463c90b38fc542de = /*#__PURE__*/ function(SpaceSelection) {
    SpaceSelection["AllExcludingPersonal"] = "all-excluding-personal";
    SpaceSelection["AllIncludingPersonal"] = "all-including-personal";
    SpaceSelection["OnlyPersonal"] = "only-personal";
    return SpaceSelection;
}({});
const $ec94e17fe3441559$var$spaceSelectionHeaderStyle = (0, $buxP3.xcss)({
    font: 'font.body.large',
    fontWeight: 'font.weight.medium',
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 'space.300',
    paddingBottom: 'space.100'
});
const $ec94e17fe3441559$var$spaceSelectionRadioButtonStyle = (0, $buxP3.xcss)({
    marginBottom: 'space.300'
});
const $ec94e17fe3441559$var$asteriskStyle = (0, $buxP3.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
    color: 'color.text.accent.red'
});
const $ec94e17fe3441559$export$1117068039e5ec07 = ({ spaceSelection: spaceSelection, onRadioChange: onRadioChange, isDisabled: isDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    const spaceSelectionHeader = ()=>{
        if (isRbacEnabled) return $ec94e17fe3441559$var$i18n.spaceAccessSelectionHeader;
        return $ec94e17fe3441559$var$i18n.spaceSelectionHeader;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        xcss: $ec94e17fe3441559$var$spaceSelectionHeaderStyle,
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $ec94e17fe3441559$var$spaceSelectionHeaderStyle
    }, formatMessage(spaceSelectionHeader(), {
        asterisk: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $ec94e17fe3441559$var$asteriskStyle
            }, chunks)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: isRbacEnabled ? formatMessage($ec94e17fe3441559$var$i18n.archivedSpacesTooltipBulkAccess) : formatMessage($ec94e17fe3441559$var$i18n.archivedSpacesTooltip),
        position: "right"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
                    ...iconProps,
                    size: "small"
                }),
            appearance: "subtle",
            label: formatMessage($ec94e17fe3441559$var$i18n.archivedSpacesTooltipIconLabel),
            spacing: "compact",
            shape: "circle",
            ...tooltipProps
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $ec94e17fe3441559$var$spaceSelectionRadioButtonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ikjJ.default), {
        value: "all-including-personal",
        onChange: onRadioChange,
        isChecked: spaceSelection === "all-including-personal",
        isDisabled: isDisabled,
        name: "space-selection",
        label: formatMessage($ec94e17fe3441559$var$i18n.spaceSelectionOne)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ikjJ.default), {
        value: "all-excluding-personal",
        onChange: onRadioChange,
        isChecked: spaceSelection === "all-excluding-personal",
        isDisabled: isDisabled,
        name: "space-selection",
        label: formatMessage($ec94e17fe3441559$var$i18n.spaceSelectionTwo)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ikjJ.default), {
        value: "only-personal",
        onChange: onRadioChange,
        isChecked: spaceSelection === "only-personal",
        isDisabled: isDisabled,
        name: "space-selection",
        label: formatMessage($ec94e17fe3441559$var$i18n.spaceSelectionFour)
    })));
};
module.exports["SpaceSelection"] = $ec94e17fe3441559$export$463c90b38fc542de;
module.exports["SpaceSelectionRadioButtons"] = $ec94e17fe3441559$export$1117068039e5ec07;

});

parcelRegister("ilq3G", function(module, exports) {
/* AgentAccessWarning.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1VhsF = parcelRequire("1VhsF");


var $1sCHt = parcelRequire("1sCHt");


var $l3wuH = parcelRequire("l3wuH");


var $iMnC5 = parcelRequire("iMnC5");


var $9wGTI = parcelRequire("9wGTI");


var $9DHhW = parcelRequire("9DHhW");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $277fe46309fe3848$var$i18n = (0, $kSwu1.defineMessages)({
    body: {
        id: "bulk-permissions.agent-access-warning.body",
        defaultMessage: "Adding an agent to all spaces makes all open content in the spaces accessible to anyone who can use the agent, even if they wouldn\u2019t have content access otherwise."
    },
    dismiss: {
        id: "bulk-permissions.agent-access-warning.dismiss",
        defaultMessage: "Dismiss"
    }
});
const $277fe46309fe3848$var$STORAGE_SURFACE_KEY = 'bulk-permissions';
const $277fe46309fe3848$var$AGENT_WARNING_DISMISSED_KEY = (0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_AGENT_ACCESS_WARNING_DISMISSED;
const $277fe46309fe3848$export$c2f7ab9e26a4f003 = ({ stagedPrincipals: stagedPrincipals })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isDismissed, setIsDismissed] = (0, $cozmU.useState)(()=>{
        try {
            const dismissed = JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem($277fe46309fe3848$var$AGENT_WARNING_DISMISSED_KEY));
            return $277fe46309fe3848$var$STORAGE_SURFACE_KEY in (dismissed ?? {});
        } catch  {
            return false;
        }
    });
    const hasAgent = stagedPrincipals.some((p)=>p?.appType === 'agent');
    (0, $cozmU.useEffect)(()=>{
        if (!hasAgent || isDismissed || !(0, $9wGTI.fg)('aa-296_fe_rovo_agents_can_take_actions')) return;
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'agentAccessWarningBannerScreen',
                action: 'viewed',
                actionSubject: 'screen',
                source: 'bulkPermissions'
            }
        }).fire();
    }, [
        hasAgent,
        isDismissed,
        createAnalyticsEvent
    ]);
    const handleDismiss = (0, $cozmU.useCallback)(()=>{
        try {
            const existing = JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem($277fe46309fe3848$var$AGENT_WARNING_DISMISSED_KEY)) ?? {};
            (0, $17wUi.confluenceLocalStorageInstance).setItem($277fe46309fe3848$var$AGENT_WARNING_DISMISSED_KEY, JSON.stringify({
                ...existing,
                [$277fe46309fe3848$var$STORAGE_SURFACE_KEY]: 1
            }));
            setIsDismissed(true);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'agentAccessWarningDismissClick',
                    source: 'bulkPermissions'
                }
            }).fire();
        } catch  {
            return;
        }
    }, [
        createAnalyticsEvent
    ]);
    if (!hasAgent || isDismissed || !(0, $9wGTI.fg)('aa-296_fe_rovo_agents_can_take_actions')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $277fe46309fe3848$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        appearance: "warning",
        testId: "agent-access-warning-bulk-permissions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $277fe46309fe3848$var$styles.body
    }, formatMessage($277fe46309fe3848$var$i18n.body))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $277fe46309fe3848$var$styles.dismissButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage($277fe46309fe3848$var$i18n.dismiss),
        appearance: "subtle",
        onClick: handleDismiss,
        testId: "agent-access-warning-dismiss-bulk-permissions"
    })));
};
const $277fe46309fe3848$var$styles = {
    container: "_1mT5xdRAKS _3138422ADO _1DCdHi2ADO",
    body: "_1ZnuxbVa5s",
    dismissButton: "_1mT5xdWVPG _2IhTon2ADO _4ApkO22ADO"
};
module.exports["AgentAccessWarning"] = $277fe46309fe3848$export$c2f7ab9e26a4f003;

});

parcelRegister("eIwUX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $auKqk = parcelRequire("auKqk");


var $7JV3d = parcelRequire("7JV3d");


var $8OTdS = parcelRequire("8OTdS");

const $57959768319b5632$var$i18n = (0, $kSwu1.defineMessages)({
    title: {
        id: "bulk-permissions.restricted.title",
        defaultMessage: "This item is restricted"
    },
    message: {
        id: "bulk-permissions.space-settings.restricted.message",
        defaultMessage: "If you think you should have access, try asking the person who sent you here for help."
    }
});
const $57959768319b5632$export$b5dab984a2ed58cb = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $auKqk.ErrorPageComponent), {
        errorImage: (0, (/*@__PURE__*/$parcel$interopDefault($7JV3d))),
        errorImageDark: (0, (/*@__PURE__*/$parcel$interopDefault($8OTdS))),
        errorTitle: intl.formatMessage($57959768319b5632$var$i18n.title),
        errorMessage: intl.formatMessage($57959768319b5632$var$i18n.message)
    });
};
module.exports["RestrictedView"] = $57959768319b5632$export$b5dab984a2ed58cb;

});

parcelRegister("lM2MU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fEPJS = parcelRequire("fEPJS");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $2wCqQ = parcelRequire("2wCqQ");


var $buxP3 = parcelRequire("buxP3");


var $ig7dg = parcelRequire("ig7dg");


var $2ZJmt = parcelRequire("2ZJmt");

const $b25698afe0cbfe9a$var$i18n = (0, $kSwu1.defineMessages)({
    loadingTitle: {
        id: "bulk-permissions.space.loading-title",
        defaultMessage: "We\u2019re processing your change"
    },
    loadingDialogDescription: {
        id: "bulk-permissions.space.loading-dialog-description",
        defaultMessage: "Don\u2019t navigate away or refresh."
    }
});
const $b25698afe0cbfe9a$var$LoadingSubSectionStyle = (0, $buxP3.xcss)({
    rowGap: 'space.300',
    paddingBottom: 'space.800'
});
const $b25698afe0cbfe9a$export$7d8626d803788e96 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $b25698afe0cbfe9a$var$i18n.loadingTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        xcss: $b25698afe0cbfe9a$var$LoadingSubSectionStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $b25698afe0cbfe9a$var$i18n.loadingDialogDescription), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ig7dg.default), {
        isIndeterminate: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2ZJmt.NavigationLockout), null));
module.exports["LoadingDialog"] = $b25698afe0cbfe9a$export$7d8626d803788e96;

});

parcelRegister("5BMKF", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $284ed2dc30431279$export$462fa05039a3a9e6 = (0, $kSwu1.defineMessages)({
    roleDisabledLabel: {
        id: "space-roles.view-role-permissions-modal.role-disabled-label",
        defaultMessage: "Role disabled"
    }
});
module.exports["viewRolePermissionsMessages"] = $284ed2dc30431279$export$462fa05039a3a9e6;

});

parcelRegister("2c1Wz", function(module, exports) {
var $49cc78e79e334ef6$export$a4def92db6fc8e17 = /*#__PURE__*/ function(PerformanceObserverEntryTypes) {
    PerformanceObserverEntryTypes["LayoutShift"] = "layout-shift";
    PerformanceObserverEntryTypes["LongTask"] = "longtask";
    PerformanceObserverEntryTypes["Event"] = "event";
    return PerformanceObserverEntryTypes;
}({});
module.exports["PerformanceObserverEntryTypes"] = $49cc78e79e334ef6$export$a4def92db6fc8e17;

});

parcelRegister("i7t6K", function(module, exports) {

var $2c1Wz = parcelRequire("2c1Wz");

class $4313abb7a0000648$export$2c6e86519c9e8188 {
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
    // Default maxLength is an arbitrary number but it is long enough to capture tasks within the full experience
    // 1000 x 50ms = 50s which should be long enough for every healthy experience
    constructor(maxLength = 1000){
        this.buffer = [];
        this.maxLength = void 0;
        this.full = false;
        this.maxLength = maxLength;
    }
}
const $4313abb7a0000648$export$f7dc16cbd16f7bbe = {
    [(0, $2c1Wz.PerformanceObserverEntryTypes).LongTask]: new $4313abb7a0000648$export$2c6e86519c9e8188(),
    [(0, $2c1Wz.PerformanceObserverEntryTypes).LayoutShift]: new $4313abb7a0000648$export$2c6e86519c9e8188(),
    [(0, $2c1Wz.PerformanceObserverEntryTypes).Event]: new $4313abb7a0000648$export$2c6e86519c9e8188()
};
// This function is exposed to the window object to be used in the integration tests
// to fail the test if there is a layout shift in the page
const $4313abb7a0000648$var$hadLayoutShift = (predicate)=>{
    const buffer = $4313abb7a0000648$export$f7dc16cbd16f7bbe[(0, $2c1Wz.PerformanceObserverEntryTypes).LayoutShift].buffer;
    return predicate(buffer);
};
window.__hadLayoutShift = $4313abb7a0000648$var$hadLayoutShift;
module.exports["EntriesBuffer"] = $4313abb7a0000648$export$f7dc16cbd16f7bbe;

});

parcelRegister("jiFpb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iJ8K8 = parcelRequire("iJ8K8");


var $5gmpn = parcelRequire("5gmpn");


var $8dwdz = parcelRequire("8dwdz");


var $6pwLK = parcelRequire("6pwLK");

const $6a421125f8ad1b8e$var$routeWithNavigationMapping = new Map();
function $6a421125f8ad1b8e$export$658b4fa209be6b36(match) {
    // We need to ensure all the entries calling processNavigationParams are returning the same RouteWithNavigation instance
    // So that they won't get re-mounted when switching between routes
    const RouteWithNavParams = $6a421125f8ad1b8e$var$routeWithNavigationMapping.get(match.name);
    if (!RouteWithNavParams) return null;
    const { NAVIGATION_PARAMS: NAVIGATION_PARAMS } = RouteWithNavParams;
    if (typeof NAVIGATION_PARAMS !== 'function') return null;
    const isMobile = (0, $8dwdz.shouldShowMobileWeb)();
    const spaceNavParams = NAVIGATION_PARAMS(match);
    const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RouteWithNavParams, match);
    if (spaceNavParams === false) return element;
    const { Screen: screen, MainLayout: mainLayout, BannerContext: bannerContext } = spaceNavParams;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJ8K8.Screen), screen, mainLayout === false ? element : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5gmpn.MainLayout), {
        enableNavigation: !isMobile,
        ...mainLayout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6pwLK.BannerContextProvider), {
        includeTopNav: bannerContext?.includeTopNav
    }, element)));
}
function $6a421125f8ad1b8e$export$5ce5fb2a75a2a873(routes) {
    for(const name in routes){
        const RouteWithNavParams = routes[name];
        if (typeof RouteWithNavParams.NAVIGATION_PARAMS !== 'function') throw new Error(`Route must define a static NAVIGATION_PARAMS function. ${name} is missing the NAVIGATION_PARAMS function. Please read patterns/routing.md`);
        $6a421125f8ad1b8e$var$routeWithNavigationMapping.set(name, RouteWithNavParams);
        routes[name] = $6a421125f8ad1b8e$export$658b4fa209be6b36;
    }
    return routes;
}
module.exports["processNavigationParams"] = $6a421125f8ad1b8e$export$5ce5fb2a75a2a873;

});

parcelRegister("4lJOK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cEgMD = parcelRequire("cEgMD");


var $kE2cJ = parcelRequire("kE2cJ");


var $iJ8K8 = parcelRequire("iJ8K8");


var $djZz9 = parcelRequire("djZz9");


var $lFjPc = parcelRequire("lFjPc");


var $1NBp8 = parcelRequire("1NBp8");


var $56QzY = parcelRequire("56QzY");


var $iqPBi = parcelRequire("iqPBi");

function $3dad7419d64a8662$export$3731f94d374dc29b(Component) {
    const SpaceOverviewRoute = (match)=>{
        const { params: { spaceKey: spaceKey = '', contentId: contentId = '' }, query: query } = match;
        if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.COMPANY_HUB).name
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqPBi.SpaceBase), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            spaceKey: spaceKey,
            contentId: contentId,
            query: query
        }));
    };
    SpaceOverviewRoute.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey = '' }, query: { mode: mode = '' } })=>({
            Screen: {
                screenEvent: {
                    name: 'spaceOverviewScreen',
                    id: spaceKey,
                    attributes: {
                        isGlobalMode: mode === 'global',
                        navdexPointType: (0, $56QzY.START_TOUCH),
                        spaceKey: spaceKey
                    }
                },
                pageState: {
                    spaceKey: spaceKey,
                    contentId: (0, $iJ8K8.SPACE_OVERVIEW),
                    routeName: (0, $1NBp8.SPACE_OVERVIEW).name,
                    contentType: 'page'
                }
            },
            MainLayout: {
                navView: (0, $lFjPc.CONTAINER_HOME_ID),
                spaceKey: spaceKey,
                isViewPage: true
            }
        });
    return SpaceOverviewRoute;
}
const $3dad7419d64a8662$export$2df060b942be85a7 = $3dad7419d64a8662$export$3731f94d374dc29b((0, $djZz9.SpaceOverviewSwitcherLoader));
module.exports["getSpaceOverviewRoute"] = $3dad7419d64a8662$export$3731f94d374dc29b;

});

parcelRegister("hDf9e", function(module, exports) {

var $cozmU = parcelRequire("cozmU");





var $9DHhW = parcelRequire("9DHhW");


var $3d3WW = parcelRequire("3d3WW");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");

const $0d72b6e269966c48$var$isOnCompanyHubRouteArgs = {
    selector: (routeName)=>(0, $1NBp8.COMPANY_HUB).name === routeName
};

const $0d72b6e269966c48$export$83316d703678f96f = ({ children: children })=>{
    const isOnCompanyHubRoute = (0, $dPJCf.useRouteName)($0d72b6e269966c48$var$isOnCompanyHubRouteArgs);
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleAnalyticCaught = (0, $cozmU.useCallback)(async (event, channel)=>{
        if (event?.payload?.action === 'clicked' || event?.payload?.actionSubject === 'smartLink' && event?.payload?.action === 'renderSuccess') await (parcelRequire("jNRDO")).then(async ({ handleEventCaught: handleEventCaught })=>{
            await handleEventCaught(activationId, cloudId, createAnalyticsEvent, event, !!isOnCompanyHubRoute, channel, spaceId);
        });
    }, [
        activationId,
        cloudId,
        createAnalyticsEvent,
        isOnCompanyHubRoute,
        spaceId
    ]);
    if (!isOnCompanyHubRoute) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        channel: "*",
        onEvent: handleAnalyticCaught
    }, children);
};



var $lFjPc = parcelRequire("lFjPc");


var $9HNv5 = parcelRequire("9HNv5");


var $8NC5Z = parcelRequire("8NC5Z");


var $7CeAz = parcelRequire("7CeAz");





var $56QzY = parcelRequire("56QzY");


var $cEgMD = parcelRequire("cEgMD");


var $kE2cJ = parcelRequire("kE2cJ");


var $iJ8K8 = parcelRequire("iJ8K8");


var $djZz9 = parcelRequire("djZz9");


var $eqNP8 = parcelRequire("eqNP8");





var $jKzCD = parcelRequire("jKzCD");


var $e4o8D = parcelRequire("e4o8D");


var $eCfJ3 = parcelRequire("eCfJ3");


var $2Uf3N = parcelRequire("2Uf3N");

function $8d67d674949172ba$export$d135e6fd61f0ae86(Component) {
    const CompanyHubRoute = ()=>{
        const { isCompanyHubEntryPointEnabled: isCompanyHubEntryPointEnabled, isCompanyHubPublished: isCompanyHubPublished, loading: loading } = (0, $7CeAz.useIsCompanyHubEnabled)();
        const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
        const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
        const { push: push } = (0, $dPJCf.useRouteActions)();
        const { isCreatingHub: isCreatingHub, creationError: creationError } = (0, $jKzCD.useCompanyHubOnRouteCreationFlow)({
            onSuccess: (homepageId)=>{
                push((0, $1NBp8.COMPANY_HUB_EDIT).toUrl({}, {
                    query: {
                        redirect: 'first-time',
                        contentId: homepageId
                    }
                }));
            },
            route: (0, $1NBp8.COMPANY_HUB).pattern
        });
        if (isCreatingHub) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eqNP8.FullPageLoadingScreen), null);
        screenEventAttributes.publishedCompanyHub = isCompanyHubPublished;
        if (shouldShowPremiumUpsell) {
            /**
       * SSR compatibility: CompanyHomeBuilderUpsellPage uses UpsellLooknFeel/SectionMessage
       * which lacks SSR support. Rendering during SSR would cause:
       * - Hydration mismatches between server/client renders
       * - Visible layout shift (CLS) during client hydration since SectionMessage
       *   appears at the top of the content area
       *
       * For now, client-side rendering only, until components are refactored for SSR support.
       */ if (renderServerPlaceholder) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9HNv5.CompanyHomeBuilderUpsellPage), {
                featureName: "companyHub"
            });
        }
        if (creationError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCfJ3.HubErrorPageComponent), {
            error: creationError
        });
        if (!isCompanyHubEntryPointEnabled) {
            // `isCompanyHubEntryPointEnabled` defaults to false until the eligibility data
            // (`frontCoverState` from SPAViewContext) resolves. Redirecting during that window
            // sends eligible users to Home — this happens during SSR and on the first client
            // render in Relay mode, where the read is not synchronously warm the way Apollo is.
            // Wait for the data to load before redirecting. Gated for safe rollout.
            if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eqNP8.FullPageLoadingScreen), null);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
                name: (0, $1NBp8.HOME).name
            });
        }
        // The only different between SPA and SSR is we don't render space base in SSR
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0d72b6e269966c48$export$83316d703678f96f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            spaceKey: spaceKey,
            contentId: ""
        }));
    };
    const screenEventAttributes = {
        navdexPointType: (0, $56QzY.START_TOUCH),
        // Company Hub hides its space from the user, doesn't refer to its page
        // as such, is rather presented to the user as "a new surface", and thus
        // doesn't constitute space usage from the perspective of the user.
        screenIsInSpace: false
    };
    /**
   * Warning: Though the function NAVIGATION_PARAMS is invoked during render,
   * each route has its own implementation. Consequently, it cannot invoke
   * hooks or, during route transitions between implementations that invoke
   * different hooks, the rule of hooks to invoke a hook the same number of
   * times during each render would be violated and an error would be thrown
   * by React that would damage the DOM.
   */ CompanyHubRoute.NAVIGATION_PARAMS = ()=>{
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        return {
            Screen: {
                screenEvent: {
                    name: 'companyHub',
                    id: spaceKey,
                    // Warning: The value of the analytics event attribute
                    // publishedCompanyHub that ScreenEvent sends will be
                    // inaccurate on initial SPA load without SSR, because
                    // ScreenEvent sends before SPAViewContext has loaded.
                    attributes: screenEventAttributes
                },
                pageState: {
                    spaceKey: spaceKey,
                    contentId: (0, $iJ8K8.SPACE_OVERVIEW),
                    routeName: (0, $1NBp8.COMPANY_HUB).name
                }
            },
            MainLayout: {
                navView: (0, $lFjPc.PRODUCT_HOME_ID),
                spaceKey: spaceKey,
                isViewPage: true
            }
        };
    };
    return (0, $2Uf3N.getCompanyHubPseudoAppRoute)(CompanyHubRoute);
}
const $8d67d674949172ba$export$ea13ab632841088 = $8d67d674949172ba$export$d135e6fd61f0ae86((0, $djZz9.SpaceOverviewLoader));
module.exports["getCompanyHubRoute"] = $8d67d674949172ba$export$d135e6fd61f0ae86;

});

parcelRegister("hkCxu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cEgMD = parcelRequire("cEgMD");


var $lFjPc = parcelRequire("lFjPc");


var $jKzCD = parcelRequire("jKzCD");


var $8NC5Z = parcelRequire("8NC5Z");


var $1NBp8 = parcelRequire("1NBp8");


var $9HNv5 = parcelRequire("9HNv5");


var $eqNP8 = parcelRequire("eqNP8");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $56QzY = parcelRequire("56QzY");


var $eCfJ3 = parcelRequire("eCfJ3");








var $5gmpn = parcelRequire("5gmpn");


var $iJ8K8 = parcelRequire("iJ8K8");


var $ak57N = parcelRequire("ak57N");


var $8dwdz = parcelRequire("8dwdz");











var $6pwLK = parcelRequire("6pwLK");

function $ef4380efcf1da8eb$export$b5c57a98f1ddfa55(uri) {
    return uri.includes('/edit-v2/');
}
function $ef4380efcf1da8eb$export$4ceedc3d36a46889(query) {
    const draftShareId = query?.draftShareId;
    return Array.isArray(draftShareId) ? draftShareId?.[0] : draftShareId;
}


const $ec45f4b8e7cc34aa$export$6a3218472cdf374a = ({ name: name, params: { contentId: contentId, spaceKey: spaceKey }, query: query })=>{
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)({
        skip: !isCompanyHub
    });
    const contentType = name === (0, $1NBp8.EDIT_PAGE_V2).name || name === (0, $1NBp8.COMPANY_HUB_EDIT).name ? 'page' : 'blogpost';
    const draftShareId = (0, $ef4380efcf1da8eb$export$4ceedc3d36a46889)(query);
    const children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6pwLK.BannerContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ak57N.EditPageLoaderServer), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType
    }));
    //
    // navView
    //
    let navView = (0, $lFjPc.CONTAINER_HOME_ID);
    if (isCompanyHub) {
        if (shouldShowPremiumUpsell) return null;
        else if (name === (0, $1NBp8.COMPANY_HUB_EDIT).name) // CompanyHubEditRoute provides its own Screen and MainLayout.
        return children;
        navView = (0, $lFjPc.PRODUCT_HOME_ID);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJ8K8.Screen), {
        showPremiumOnboarding: false,
        pageState: {
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType
        },
        screenEvent: {
            name: 'editPageScreen',
            id: contentId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5gmpn.MainLayout), {
        enableNavigation: !(0, $8dwdz.shouldShowMobileWeb)(),
        spaceKey: spaceKey,
        navView: navView,
        isEdit: true
    }, children));
};



var $2Uf3N = parcelRequire("2Uf3N");

function $aa6dab5502f2e37f$export$39a78a0252c20555(component) {
    const CompanyHubEditRoute = (routeProps)=>{
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        const [contentId] = (0, $ep3mz.usePageContentId)();
        const [queriedContentId, setQueriedContentId] = (0, $cozmU.useState)(null);
        const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
        const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
        const { isCreatingHub: isCreatingHub, creationError: creationError } = (0, $jKzCD.useCompanyHubOnRouteCreationFlow)({
            onSuccess: (homepageId)=>{
                setQueriedContentId(homepageId);
                setQueryParams({
                    redirect: 'first-time'
                });
            },
            onExists: (homepageId)=>{
                setQueriedContentId(homepageId);
            },
            route: (0, $1NBp8.COMPANY_HUB_EDIT).pattern
        });
        if (creationError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCfJ3.HubErrorPageComponent), {
            error: creationError
        });
        if (shouldShowPremiumUpsell) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9HNv5.CompanyHomeBuilderUpsellPage), {
            featureName: "companyHub"
        });
        // If there is no contentId in SSR then we will just see the FullPageLoadingScreen being rendered
        // So we skip the loading screen component to ensure the EditPageRoute is rendered instead
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if ((isCreatingHub || !queriedContentId && !contentId) && true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eqNP8.FullPageLoadingScreen), null);
        const Component = component;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            ...routeProps,
            params: {
                contentId: contentId ?? (queriedContentId || ''),
                spaceKey: spaceKey,
                contentType: 'pages'
            }
        });
    };
    CompanyHubEditRoute.NAVIGATION_PARAMS = (routeProps)=>{
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        return {
            Screen: {
                screenEvent: {
                    name: 'companyHubEditScreen',
                    id: spaceKey,
                    attributes: {
                        navdexPointType: (0, $56QzY.END),
                        // Company Hub hides its space from the user, doesn't refer to its page
                        // as such, is rather presented to the user as "a new surface", and thus
                        // doesn't constitute space usage from the perspective of the user.
                        screenIsInSpace: false
                    }
                },
                // When no contentId is passed, Screen.js handles querying it and updating pageState with it.
                // usually, this is done by the Screen.js component, but in this case, we need to do it here
                // because contentId is not getting queried properly on route creation.
                pageState: {
                    spaceKey: spaceKey,
                    contentId: routeProps?.query?.contentId
                }
            },
            MainLayout: {
                navView: (0, $lFjPc.PRODUCT_HOME_ID)
            }
        };
    };
    return (0, $2Uf3N.getCompanyHubPseudoAppRoute)(CompanyHubEditRoute);
}
const $aa6dab5502f2e37f$export$31ce72eecdb1dd8 = $aa6dab5502f2e37f$export$39a78a0252c20555((0, $ec45f4b8e7cc34aa$export$6a3218472cdf374a));
module.exports["getCompanyHubEditRoute"] = $aa6dab5502f2e37f$export$39a78a0252c20555;

});

parcelRegister("k1285", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $eX4up = parcelRequire("eX4up");


var $cEgMD = parcelRequire("cEgMD");


var $lFjPc = parcelRequire("lFjPc");


var $jKzCD = parcelRequire("jKzCD");


var $8NC5Z = parcelRequire("8NC5Z");


var $1NBp8 = parcelRequire("1NBp8");


var $9HNv5 = parcelRequire("9HNv5");


var $eqNP8 = parcelRequire("eqNP8");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $56QzY = parcelRequire("56QzY");


var $eCfJ3 = parcelRequire("eCfJ3");


var $2Uf3N = parcelRequire("2Uf3N");

function $7c7def46d7360d1a$export$340541672a1ec29f(component) {
    const CompanyHubEditorRoute = (routeProps)=>{
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        const [contentId] = (0, $ep3mz.usePageContentId)();
        const [queriedContentId, setQueriedContentId] = (0, $cozmU.useState)(null);
        const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
        const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
        const { isCreatingHub: isCreatingHub, creationError: creationError } = (0, $jKzCD.useCompanyHubOnRouteCreationFlow)({
            onSuccess: (homepageId)=>{
                setQueriedContentId(homepageId);
                setQueryParams({
                    redirect: 'first-time'
                });
            },
            onExists: (homepageId)=>{
                setQueriedContentId(homepageId);
            },
            route: (0, $1NBp8.COMPANY_HUB_EDIT).pattern
        });
        if (creationError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCfJ3.HubErrorPageComponent), {
            error: creationError
        });
        if (shouldShowPremiumUpsell) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9HNv5.CompanyHomeBuilderUpsellPage), {
            featureName: "companyHub"
        });
        // If there is no contentId in SSR then we will just see the FullPageLoadingScreen being rendered
        // So we skip the loading screen component to ensure the HubEditor is rendered instead
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if ((isCreatingHub || !queriedContentId && !contentId) && true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eqNP8.FullPageLoadingScreen), null);
        const Component = component;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            ...routeProps,
            params: {
                contentId: contentId ?? (queriedContentId || ''),
                spaceKey: spaceKey,
                contentType: 'pages'
            }
        });
    };
    CompanyHubEditorRoute.NAVIGATION_PARAMS = (routeProps)=>{
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        return {
            Screen: {
                screenEvent: {
                    name: 'companyHubEditorScreen',
                    id: spaceKey,
                    attributes: {
                        navdexPointType: (0, $56QzY.END),
                        screenIsInSpace: false
                    }
                },
                pageState: {
                    spaceKey: spaceKey,
                    contentId: routeProps?.query?.contentId
                }
            },
            MainLayout: {
                navView: (0, $lFjPc.PRODUCT_HOME_ID)
            }
        };
    };
    return (0, $2Uf3N.getCompanyHubPseudoAppRoute)(CompanyHubEditorRoute);
}
const $7c7def46d7360d1a$export$5c9c0a4930517099 = $7c7def46d7360d1a$export$340541672a1ec29f((0, $eX4up.default));
module.exports["getCompanyHubEditorRoute"] = $7c7def46d7360d1a$export$340541672a1ec29f;

});

parcelRegister("SwMnm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lFjPc = parcelRequire("lFjPc");


var $bUMKD = parcelRequire("bUMKD");


var $6mKj3 = parcelRequire("6mKj3");


var $78QFu = parcelRequire("78QFu");

function $fadd80cba2fb56d8$export$4464cf8f058e6616({ ContextProvider: ContextProvider = (0, $cozmU.Fragment), NotFound: NotFound = (0, $cozmU.Fragment), ClassicEditorContextProviderLoader: ClassicEditorContextProviderLoader } = {}) {
    function AccessLinkRoute({ params: { shareToken: shareToken }, hash: hash }) {
        if (!(0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(NotFound, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ContextProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bUMKD.ExternalSharePageLoader), {
            shareToken: shareToken,
            queryHash: hash,
            ClassicEditorContextProviderLoader: ClassicEditorContextProviderLoader
        }));
    }
    AccessLinkRoute.NAVIGATION_PARAMS = ({ name: name })=>({
            Screen: {
                screenEvent: {
                    name: 'viewPageScreen',
                    attributes: {
                        isPublicView: false,
                        isAccessLinkView: true,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                    }
                },
                pageState: {
                    routeName: name
                }
            },
            MainLayout: {
                navView: (0, $lFjPc.PRODUCT_HOME_ID)
            }
        });
    return AccessLinkRoute;
}
const $fadd80cba2fb56d8$export$7fef32ef76619e1b = $fadd80cba2fb56d8$export$4464cf8f058e6616();
module.exports["getAccessLinkRoute"] = $fadd80cba2fb56d8$export$4464cf8f058e6616;

});

parcelRegister("8g7sM", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $kb9X9 = parcelRequire("kb9X9");

const $c3f88486f5953222$var$CONTENT_RENDERER_DOWNLOAD = `confluence.fabric.content.renderer.download`;

const $c3f88486f5953222$var$_default_1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cDY9-",
    name: 'ClassicContentRendererLoader',
    loader: async ()=>{
        (0, $kb9X9.performanceMarkInProd)(`${$c3f88486f5953222$var$CONTENT_RENDERER_DOWNLOAD}.start`);
        const module = await (parcelRequire("lSd9S"));
        (0, $kb9X9.performanceMarkInProd)(`${$c3f88486f5953222$var$CONTENT_RENDERER_DOWNLOAD}.end`);
        return module;
    }
});
var $c3f88486f5953222$export$2e2bcd8739ae039 = $c3f88486f5953222$var$_default_1;
module.exports["default"] = $c3f88486f5953222$export$2e2bcd8739ae039;

});

parcelRegister("2Uf3N", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


const $44a1291d5f4bf190$export$bbf3d8e57337c75 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "xoU6a",
    _reactTreeRootForServerPlaceholderId: true,
    name: 'CompanyHubMainLayout',
    loader: async ()=>(await (parcelRequire("3I7mv"))).CompanyHubMainLayout
});


function $13aed4a881b0bcc1$export$f5fe5ef796a4c528(Wrapped, routeMatchPredicate = ()=>true) {
    const CompanyHubPseudoAppRoute = (props)=>{
        const wrapped = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Wrapped, props);
        if (routeMatchPredicate(props)) // The Company Hub app-like experience uses its own, doesn't use Confluence's `MainLayout`:
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $44a1291d5f4bf190$export$bbf3d8e57337c75), null, wrapped);
        return wrapped;
    };
    CompanyHubPseudoAppRoute.NAVIGATION_PARAMS = (...args)=>{
        const wrappedNavParams = Wrapped.NAVIGATION_PARAMS(...args);
        if (routeMatchPredicate(args[0])) // The Company Hub app-like experience uses its own, doesn't use Confluence's `MainLayout`:
        return typeof wrappedNavParams === 'object' ? {
            ...wrappedNavParams,
            MainLayout: false
        } : false;
        return wrappedNavParams;
    };
    return CompanyHubPseudoAppRoute;
}
module.exports["getCompanyHubPseudoAppRoute"] = $13aed4a881b0bcc1$export$f5fe5ef796a4c528;

});

parcelRegister("cbQWR", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

function $0496f75a09655c3f$export$5fce3f8f63379b78({ name: name, query: query = {} }) {
    return (name === (0, $1NBp8.VIEW_PAGE).name || name === (0, $1NBp8.VIEW_BLOG).name) && !query.lite && !query.versionOverride && !query.version && !query.draftId && !query.draftShareId && !query.embeddedContentRender && !query.embedded && !query.parentProduct;
}
module.exports["canDeferPageRestrictions"] = $0496f75a09655c3f$export$5fce3f8f63379b78;

});

parcelRegister("92IuX", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $cf6f9a67c56b1fae$export$a52edf641f55b288 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "qAAZg",
    name: "AuditLogLoader",
    loader: async ()=>(await (parcelRequire("4u39n"))).AuditLog
});
module.exports["AuditLogLoader"] = $cf6f9a67c56b1fae$export$a52edf641f55b288;

});

parcelRegister("kkBFa", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $eb3ax = parcelRequire("eb3ax");


var $ccS36 = parcelRequire("ccS36");


var $lI7ls = parcelRequire("lI7ls");


var $cozmU = parcelRequire("cozmU");

parcelRequire("htyBH");
var $k9z7m = parcelRequire("k9z7m");


var $fcvZw = parcelRequire("fcvZw");

class $ecd2e3fcbc47ba9f$var$Redirector extends (0, $cozmU.Component) {
    componentDidMount() {
        const { to: to, location: location, push: push, params: params, query: query, actions: actions } = this.props;
        const routeAttributes = {
            params: params,
            query: query,
            basePath: actions.getBasePath()
        };
        const newPath = typeof to === 'object' ? 'path' in to ? (0, $lI7ls.createPath)((0, $k9z7m.generateLocationFromPath)(to.path, routeAttributes)) : (0, $lI7ls.createPath)(to) : to;
        const currentPath = (0, $lI7ls.createPath)(location);
        const action = push ? actions.push : actions.replace;
        if (currentPath === newPath) return;
        action(newPath);
    }
    render() {
        return null;
    }
}
(0, $ccS36.default)($ecd2e3fcbc47ba9f$var$Redirector, "defaultProps", {
    push: false
});
const $ecd2e3fcbc47ba9f$export$2d8d895a0a0f636e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const [t0, actions] = (0, $fcvZw.useRouter)();
    const { location: location } = t0;
    let t1;
    if ($[0] !== actions || $[1] !== location || $[2] !== props) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ecd2e3fcbc47ba9f$var$Redirector, (0, $eb3ax.default)({
            actions: actions,
            location: location
        }, props));
        $[0] = actions;
        $[1] = location;
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (props)=>{
    const [{ location: location }, actions] = (0, $fcvZw.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ecd2e3fcbc47ba9f$var$Redirector, (0, $eb3ax.default)({
        actions: actions,
        location: location
    }, props));
};

});

parcelRegister("hSxV5", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $lI7ls = parcelRequire("lI7ls");


var $cozmU = parcelRequire("cozmU");


var $hFkZi = parcelRequire("hFkZi");

const $d041ca8faab7d1e5$export$55185c17a0fcbe46 = ({ basePath: basePath, children: children, history: history, initialRoute: initialRoute, isGlobal: isGlobal = true, plugins: plugins, onPrefetch: onPrefetch, routes: routes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hFkZi.RouterContainer), {
        basePath: basePath,
        history: history,
        initialRoute: initialRoute,
        isGlobal: isGlobal,
        onPrefetch: onPrefetch,
        plugins: plugins != null ? plugins : [],
        routes: routes
    }, children);
};
function $d041ca8faab7d1e5$export$ae46f04cfaffe093(props) {
    var _props$plugins;
    const history = (0, $cozmU.useMemo)(()=>(0, $lI7ls.createMemoryHistory)(props.location ? {
            initialEntries: [
                props.location
            ]
        } : {}), [
        props.location
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d041ca8faab7d1e5$export$55185c17a0fcbe46, (0, $eb3ax.default)({}, props, {
        history: history,
        isGlobal: false,
        plugins: (_props$plugins = props == null ? void 0 : props.plugins) != null ? _props$plugins : []
    }));
}

});

parcelRegister("bPYAw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $idnP4 = parcelRequire("idnP4");

const $89e374a8e3383481$export$b371fa9cf762ad06 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    const actions = (0, $idnP4.useRouterActions)();
    let t1;
    if ($[0] !== actions || $[1] !== children) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(actions));
        $[0] = actions;
        $[1] = children;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children })=>{
    const actions = (0, $idnP4.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(actions));
};
$89e374a8e3383481$export$b371fa9cf762ad06.displayName = 'RouterActions';

});

parcelRegister("ebiij", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $1eVGO = parcelRequire("1eVGO");


var $cozmU = parcelRequire("cozmU");

parcelRequire("htyBH");
var $9qwq6 = parcelRequire("9qwq6");


var $hFkZi = parcelRequire("hFkZi");

const $a53048aabd17c88e$var$_excluded = [
    "listen"
];
const $a53048aabd17c88e$export$672d721d310ff5f0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children } = t0;
    const [state, _ref] = (0, $hFkZi.useRouterStore)();
    const { listen: listen } = _ref;
    let t1;
    if ($[0] !== _ref || $[1] !== children || $[2] !== listen || $[3] !== state) {
        const actions = (0, $1eVGO.default)(_ref, $a53048aabd17c88e$var$_excluded);
        if (!state.unlisten && !(0, $9qwq6.isServerEnvironment)()) listen();
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(state, actions));
        $[0] = _ref;
        $[1] = children;
        $[2] = listen;
        $[3] = state;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ children: children })=>{
    const [state, _ref] = (0, $hFkZi.useRouterStore)();
    const { listen: listen } = _ref, actions = (0, $1eVGO.default)(_ref, $a53048aabd17c88e$var$_excluded);
    if (!state.unlisten && !(0, $9qwq6.isServerEnvironment)()) listen();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(state, actions));
};

});

parcelRegister("6GERo", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");


var $hFkZi = parcelRequire("hFkZi");

const $4de65c525241a249$var$createPathParamHook = (0, $kBr4q.createHook)((0, $hFkZi.RouterStore), {
    selector: ({ match: { params: params } }, { paramKey: paramKey })=>params[paramKey]
});
const $4de65c525241a249$export$8c8591dcd57728e6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (paramKey)=>{
    const $ = (0, $bDgLe.c)(8);
    let t0;
    if ($[0] !== paramKey) {
        t0 = $4de65c525241a249$var$createPathParamHook({
            paramKey: paramKey
        });
        $[0] = paramKey;
        $[1] = t0;
    } else t0 = $[1];
    const [paramVal, routerActions] = t0;
    let t1;
    if ($[2] !== paramKey || $[3] !== routerActions) {
        t1 = (newValue, updateType)=>{
            routerActions.updatePathParam({
                [paramKey]: newValue
            }, updateType);
        };
        $[2] = paramKey;
        $[3] = routerActions;
        $[4] = t1;
    } else t1 = $[4];
    const setPathParam = t1;
    let t2;
    if ($[5] !== paramVal || $[6] !== setPathParam) {
        t2 = [
            paramVal,
            setPathParam
        ];
        $[5] = paramVal;
        $[6] = setPathParam;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : (paramKey)=>{
    const [paramVal, routerActions] = $4de65c525241a249$var$createPathParamHook({
        paramKey: paramKey
    });
    const setPathParam = (0, $cozmU.useCallback)((newValue, updateType)=>{
        routerActions.updatePathParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setPathParam
    ];
};

});

parcelRegister("96I48", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");


var $hFkZi = parcelRequire("hFkZi");

const $6a16db1a31422dbd$var$createQueryParamHook = (0, $kBr4q.createHook)((0, $hFkZi.RouterStore), {
    selector: ({ query: query }, { paramKey: paramKey })=>query[paramKey]
});
const $6a16db1a31422dbd$export$ae316f0eeb712a36 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (paramKey)=>{
    const $ = (0, $bDgLe.c)(8);
    let t0;
    if ($[0] !== paramKey) {
        t0 = $6a16db1a31422dbd$var$createQueryParamHook({
            paramKey: paramKey
        });
        $[0] = paramKey;
        $[1] = t0;
    } else t0 = $[1];
    const [paramVal, routerActions] = t0;
    let t1;
    if ($[2] !== paramKey || $[3] !== routerActions) {
        t1 = (newValue, updateType)=>{
            routerActions.updateQueryParam({
                [paramKey]: newValue
            }, updateType);
        };
        $[2] = paramKey;
        $[3] = routerActions;
        $[4] = t1;
    } else t1 = $[4];
    const setQueryParam = t1;
    let t2;
    if ($[5] !== paramVal || $[6] !== setQueryParam) {
        t2 = [
            paramVal,
            setQueryParam
        ];
        $[5] = paramVal;
        $[6] = setQueryParam;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : (paramKey)=>{
    const [paramVal, routerActions] = $6a16db1a31422dbd$var$createQueryParamHook({
        paramKey: paramKey
    });
    const setQueryParam = (0, $cozmU.useCallback)((newValue, updateType)=>{
        routerActions.updateQueryParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setQueryParam
    ];
};

});

parcelRegister("fcvZw", function(module, exports) {

var $hFkZi = parcelRequire("hFkZi");

const $b110cad1cdf17f37$export$9a302a45f65d0572 = (0, $hFkZi.useRouterStore);
module.exports["useRouter"] = $b110cad1cdf17f37$export$9a302a45f65d0572;

});

parcelRegister("idnP4", function(module, exports) {

var $hFkZi = parcelRequire("hFkZi");

const $d42beb9135fb341f$export$402e82ff1b20594b = (0, $hFkZi.useRouterStoreActions);
module.exports["useRouterActions"] = $d42beb9135fb341f$export$402e82ff1b20594b;

});

parcelRegister("4Yqy7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $eb3ax = parcelRequire("eb3ax");


var $cozmU = parcelRequire("cozmU");


var $hFkZi = parcelRequire("hFkZi");

const $39f15c286baf7d10$var$getWrappedComponentDisplayName = (component)=>{
    let componentDisplayName = 'UNDEFINED';
    const { displayName: displayName, name: name } = component;
    if (displayName) componentDisplayName = displayName;
    if (name) componentDisplayName = name;
    return `withRouter(${componentDisplayName})`;
};
const $39f15c286baf7d10$export$369b6b2b30582e8e = (WrappedComponent)=>{
    const displayName = $39f15c286baf7d10$var$getWrappedComponentDisplayName(WrappedComponent);
    const Component = WrappedComponent;
    const ComponentWithRouter = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
        const $ = (0, $bDgLe.c)(10);
        const [t0, t1] = (0, $hFkZi.useRouterStore)();
        const { action: action, history: history, location: location, match: match, query: query, route: route } = t0;
        const { push: push, replace: replace } = t1;
        let t2;
        if ($[0] !== action || $[1] !== history || $[2] !== location || $[3] !== match || $[4] !== props || $[5] !== push || $[6] !== query || $[7] !== replace || $[8] !== route) {
            t2 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, (0, $eb3ax.default)({}, props, {
                action: action,
                history: history,
                location: location,
                match: match,
                push: push,
                query: query,
                replace: replace,
                route: route
            }));
            $[0] = action;
            $[1] = history;
            $[2] = location;
            $[3] = match;
            $[4] = props;
            $[5] = push;
            $[6] = query;
            $[7] = replace;
            $[8] = route;
            $[9] = t2;
        } else t2 = $[9];
        return t2;
    } : (props)=>{
        const [{ action: action, history: history, location: location, match: match, query: query, route: route }, { push: push, replace: replace }] = (0, $hFkZi.useRouterStore)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, (0, $eb3ax.default)({}, props, {
            action: action,
            history: history,
            location: location,
            match: match,
            push: push,
            query: query,
            replace: replace,
            route: route
        }));
    };
    ComponentWithRouter.displayName = displayName;
    return ComponentWithRouter;
};

});

parcelRegister("8Dc6h", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $1eVGO = parcelRequire("1eVGO");


var $lI7ls = parcelRequire("lI7ls");


var $cozmU = parcelRequire("cozmU");

parcelRequire("htyBH");
var $jwQVI = parcelRequire("jwQVI");
var $k9z7m = parcelRequire("k9z7m");


var $hFkZi = parcelRequire("hFkZi");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");




const $c4f86f985468509c$export$d8e6abf214c9ec0f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (delay)=>{
    const $ = (0, $bDgLe.c)(5);
    const timeoutId = (0, $cozmU.useRef)();
    let t0;
    if ($[0] !== delay) {
        t0 = (callback)=>{
            if (timeoutId.current) clearTimeout(timeoutId.current);
            timeoutId.current = setTimeout(callback, delay);
        };
        $[0] = delay;
        $[1] = t0;
    } else t0 = $[1];
    const schedule = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            clearTimeout(timeoutId.current);
        };
        $[2] = t1;
    } else t1 = $[2];
    const cancel = t1;
    let t2;
    if ($[3] !== schedule) {
        t2 = {
            schedule: schedule,
            cancel: cancel
        };
        $[3] = schedule;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : (delay)=>{
    const timeoutId = (0, $cozmU.useRef)();
    const schedule = (0, $cozmU.useCallback)((callback)=>{
        if (timeoutId.current) clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay);
    }, [
        delay
    ]);
    const cancel = (0, $cozmU.useCallback)(()=>{
        clearTimeout(timeoutId.current);
    }, []);
    return {
        schedule: schedule,
        cancel: cancel
    };
};





var $6fVzX = parcelRequire("6fVzX");


var $et2nj = parcelRequire("et2nj");



const $648b5a1d497791d1$var$_excluded = [
    "children",
    "target",
    "replace",
    "href",
    "to",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "onPointerDown",
    "onFocus",
    "onBlur",
    "type",
    "params",
    "query",
    "prefetch",
    "state"
];
const $648b5a1d497791d1$var$PREFETCH_DELAY = 225;
const $648b5a1d497791d1$var$Link = /*#__PURE__*/ (0, $cozmU.forwardRef)((_ref, ref)=>{
    let { children: children, target: target = '_self', replace: replace = false, href: href, to: to, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerDown: onPointerDown, onFocus: onFocus, onBlur: onBlur, type: linkType = 'a', params: params, query: query, prefetch: prefetch = false, state: state } = _ref, rest = (0, $1eVGO.default)(_ref, $648b5a1d497791d1$var$_excluded);
    const routerActions = (0, $hFkZi.useRouterStoreActions)();
    const { schedule: schedule, cancel: cancel } = (0, $c4f86f985468509c$export$d8e6abf214c9ec0f)($648b5a1d497791d1$var$PREFETCH_DELAY);
    const validLinkType = (0, $6fVzX.getValidLinkType)(linkType);
    const [route, setRoute] = (0, $cozmU.useState)(()=>{
        if (to && typeof to !== 'string') {
            if ('then' in to) to.then((r)=>setRoute('default' in r ? r.default : r));
            else return to;
        }
    });
    const routeAttributes = {
        params: params,
        query: query,
        basePath: routerActions.getBasePath()
    };
    const linkDestination = href != null ? href : typeof to !== 'string' ? route && (0, $lI7ls.createPath)((0, $k9z7m.generateLocationFromPath)(route.path, routeAttributes)) || '' : to;
    const staticBasePath = href == null && typeof to === 'string' ? routeAttributes.basePath : '';
    const triggerPrefetch = (0, $cozmU.useCallback)(()=>{
        // ignore if async route not ready yet
        if (typeof to !== 'string' && !route) return;
        const context = typeof to !== 'string' && route ? (0, $jwQVI.createRouterContext)(route, {
            params: params,
            query: query
        }) : null;
        routerActions.prefetchRoute(linkDestination, context);
    // omit params & query as already in linkDestination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        linkDestination,
        routerActions
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (prefetch === 'mount') schedule(triggerPrefetch);
        return cancel;
    }, [
        prefetch,
        schedule,
        cancel,
        triggerPrefetch
    ]);
    const handleLinkPress = (e)=>(0, $et2nj.handleNavigation)(e, {
            onClick: onClick,
            target: target,
            replace: replace,
            routerActions: routerActions,
            href: linkDestination,
            to: route && [
                route,
                {
                    params: params,
                    query: query
                }
            ],
            state: state
        });
    const handleMouseEnter = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onMouseEnter && onMouseEnter(e);
    };
    const handleMouseLeave = (e)=>{
        if (prefetch === 'hover') cancel();
        onMouseLeave && onMouseLeave(e);
    };
    const handleFocus = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onFocus && onFocus(e);
    };
    const handleBlur = (e)=>{
        if (prefetch === 'hover') cancel();
        onBlur && onBlur(e);
    };
    const handlePointerDown = (e)=>{
        if (prefetch === 'hover') {
            cancel();
            triggerPrefetch();
        }
        onPointerDown && onPointerDown(e);
    };
    return /*#__PURE__*/ (0, $cozmU.createElement)(validLinkType, (0, $eb3ax.default)({}, rest, {
        href: `${staticBasePath}${linkDestination}`,
        target: target,
        onClick: handleLinkPress,
        onKeyDown: handleLinkPress,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onPointerDown: handlePointerDown,
        ref: ref
    }), children);
});
$648b5a1d497791d1$var$Link.displayName = 'Link';
var $648b5a1d497791d1$export$2e2bcd8739ae039 = $648b5a1d497791d1$var$Link;
module.exports["default"] = $648b5a1d497791d1$export$2e2bcd8739ae039;

});

parcelRegister("eJQlm", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

parcelRequire("cKmxI");
var $fcvZw = parcelRequire("fcvZw");

const $abaddef82b916071$export$7903e4b73fc7d6c3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(6);
    const [t0] = (0, $fcvZw.useRouter)();
    const { action: action, location: location, match: match, query: query, route: route } = t0;
    if (!route || !route.component) return null;
    let t1;
    if ($[0] !== action || $[1] !== location || $[2] !== match || $[3] !== query || $[4] !== route) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(route.component, {
            action: action,
            location: location,
            match: match,
            query: query,
            route: route
        });
        $[0] = action;
        $[1] = location;
        $[2] = match;
        $[3] = query;
        $[4] = route;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ()=>{
    const [{ action: action, location: location, match: match, query: query, route: route }] = (0, $fcvZw.useRouter)();
    if (!route || !route.component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(route.component, {
        action: action,
        location: location,
        match: match,
        query: query,
        route: route
    });
};

});

parcelRegister("ac1eE", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $lI7ls = parcelRequire("lI7ls");


var $7SeeH = parcelRequire("7SeeH");


var $eO7Xs = parcelRequire("eO7Xs");

const $76bbfba75c24c32f$var$hasWindow = ()=>typeof window !== 'undefined';
const $76bbfba75c24c32f$var$methodsPlaceholders = {
    push: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    listen: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs)))
};
const $76bbfba75c24c32f$var$getLocation = ()=>{
    // todo - don't force non-optional search and hash
    const { pathname: pathname = '', search: search = '', hash: hash = '' } = $76bbfba75c24c32f$var$hasWindow() && window.location || {};
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
};
const $76bbfba75c24c32f$var$createLegacyListener = (updateExposedLocation)=>{
    const node = document.querySelector('#content');
    let prevHref = window.location.href;
    let listeners = [];
    const historyStack = [
        prevHref
    ];
    // note: window.history.length is capped at 50 entries
    let prevHistoryLength = window.history.length;
    let historyIndex = 0;
    const getAction = ()=>{
        const currentHref = window.location.href;
        if (prevHistoryLength === window.history.length) {
            if (historyStack[historyIndex - 1] === currentHref) {
                historyIndex -= 1;
                return 'POP';
            }
            if (historyStack[historyIndex + 1] === currentHref) {
                historyIndex += 1;
                return 'POP';
            }
            historyStack[historyStack.length - 1] = currentHref;
            return 'REPLACE';
        }
        historyStack.push(currentHref);
        historyIndex += 1;
        prevHistoryLength = window.history.length;
        return 'PUSH';
    };
    const onNodeChanges = (0, (/*@__PURE__*/$parcel$interopDefault($7SeeH)))(()=>{
        if (prevHref !== window.location.href) {
            const newLocation = $76bbfba75c24c32f$var$getLocation();
            const action = getAction();
            updateExposedLocation(newLocation, action);
            listeners.forEach((listener)=>listener(newLocation, action));
            prevHref = window.location.href;
        }
    }, 50);
    if (node) {
        const observer = new window.MutationObserver(onNodeChanges);
        observer.observe(node, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }
    return (listener)=>{
        listeners = listeners.concat(listener);
        return ()=>{
            listeners = listeners.filter((lst)=>lst !== listener);
        };
    };
};
const $76bbfba75c24c32f$export$883c3f3b6c000133 = ()=>{
    let currentLocation = $76bbfba75c24c32f$var$getLocation();
    let currentAction = 'PUSH';
    const updateExposedLocation = (v, a)=>{
        currentLocation = v;
        currentAction = a;
    };
    return (0, $eb3ax.default)({
        get location () {
            return currentLocation;
        },
        get length () {
            return $76bbfba75c24c32f$var$hasWindow() ? window.history.length : 1; // default length is 1
        },
        get action () {
            return currentAction;
        }
    }, $76bbfba75c24c32f$var$hasWindow() ? {
        push: (path)=>window.location.assign(typeof path === 'string' ? path : (0, $lI7ls.createPath)(path || {})),
        replace: (path)=>window.history.replaceState({}, document.title, typeof path === 'string' ? path : (0, $lI7ls.createPath)(path || {})),
        goBack: ()=>window.history.back(),
        goForward: ()=>window.history.forward(),
        listen: $76bbfba75c24c32f$var$createLegacyListener(updateExposedLocation),
        block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
        createHref: (location)=>(0, $lI7ls.createPath)(location)
    } : $76bbfba75c24c32f$var$methodsPlaceholders);
};
module.exports["createLegacyHistory"] = $76bbfba75c24c32f$export$883c3f3b6c000133;

});

parcelRegister("k9z7m", function(module, exports) {

var $6XX9c = parcelRequire("6XX9c");


var $4NiRC = parcelRequire("4NiRC");

function $eabfe38de06df22e$export$37e0729cc751960b(pattern = '/', options = {}) {
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $4NiRC.qs).stringify(query, true);
    const pathname = pattern === '/' ? pattern : (0, $6XX9c.compile)(pattern)(params);
    return {
        pathname: `${basePath}${pathname}`,
        search: stringifiedQuery,
        hash: ''
    };
}
module.exports["generateLocationFromPath"] = $eabfe38de06df22e$export$37e0729cc751960b;

});

parcelRegister("epPJ3", function(module, exports) {

var $6XX9c = parcelRequire("6XX9c");

const $a7eb8621e301eeac$export$82476f982757e71e = (pattern = '/', params)=>pattern === '/' ? pattern : (0, $6XX9c.compile)(pattern)(params);
module.exports["generatePath"] = $a7eb8621e301eeac$export$82476f982757e71e;

});

parcelRegister("9qwq6", function(module, exports) {
/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ 
var $1P2f3 = parcelRequire("1P2f3");

const $6dcfb0b3fdb0fcc1$var$isJsDomEnvironment = ()=>{
    var _navigator, _navigator2;
    return window.name === 'nodejs' || ((_navigator = navigator) == null ? void 0 : _navigator.userAgent.includes('Node.js')) || ((_navigator2 = navigator) == null ? void 0 : _navigator2.userAgent.includes('jsdom'));
};
const $6dcfb0b3fdb0fcc1$export$455cc18296abe008 = ()=>{
    if (typeof window === 'undefined' || typeof $1P2f3 !== 'undefined' && $1P2f3.versions != null && $1P2f3.versions.node != null) return true;
    if ($6dcfb0b3fdb0fcc1$var$isJsDomEnvironment()) return true;
    return false;
};
module.exports["isServerEnvironment"] = $6dcfb0b3fdb0fcc1$export$455cc18296abe008;

});

parcelRegister("iL7a3", function(module, exports) {
$parcel$export(module.exports, "default", () => $da822bd664e445bf$export$2e2bcd8739ae039);

var $4NiRC = parcelRequire("4NiRC");


var $eb3ax = parcelRequire("eb3ax");

// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

var $6XX9c = parcelRequire("6XX9c");

const $d2b6545da2f42c36$var$cache = {};
const $d2b6545da2f42c36$var$cacheLimit = 10000;
let $d2b6545da2f42c36$var$cacheCount = 0;
function $d2b6545da2f42c36$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $d2b6545da2f42c36$var$cache[cacheKey] || ($d2b6545da2f42c36$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, $6XX9c.pathToRegexp)(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($d2b6545da2f42c36$var$cacheCount < $d2b6545da2f42c36$var$cacheLimit) {
        pathCache[path] = result;
        $d2b6545da2f42c36$var$cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function $d2b6545da2f42c36$var$matchPath(pathname, options = {}) {
    if (typeof options === 'string' || Array.isArray(options)) options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = '' } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== '') return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $d2b6545da2f42c36$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === '/' && url === '' ? '/' : url,
            isExact: // the matched portion of the URL
            isExact,
            // whether or not we matched exactly
            params: keys.reduce((memo, key, index)=>{
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
var $d2b6545da2f42c36$export$2e2bcd8739ae039 = $d2b6545da2f42c36$var$matchPath;





/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function $80619751575f829b$var$matchQuery(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split('=');
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split('|').map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? (0, $eb3ax.default)({}, pathMatch, {
        query: queryMatch
    }) : null;
}
var $80619751575f829b$export$2e2bcd8739ae039 = $80619751575f829b$var$matchQuery;


/* This should match what react-router does to compute a root match. */ const $72661a82c5c63ed1$var$computeRootMatch = (pathname)=>({
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    });
function $72661a82c5c63ed1$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $d2b6545da2f42c36$export$2e2bcd8739ae039)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $72661a82c5c63ed1$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $80619751575f829b$export$2e2bcd8739ae039)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = (0, $eb3ax.default)({}, pathMatch, {
        query: {}
    });
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
var $72661a82c5c63ed1$export$2e2bcd8739ae039 = $72661a82c5c63ed1$var$execRouteMatching;


const $306d1e727bba178f$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $306d1e727bba178f$var$MAX_CACHE_SIZE = 1000;
function $306d1e727bba178f$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!$306d1e727bba178f$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $306d1e727bba178f$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($306d1e727bba178f$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $306d1e727bba178f$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $306d1e727bba178f$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};


/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */ const $da822bd664e445bf$var$matchRoute = (routes, pathname, queryParams = {}, basePath = '')=>{
    const queryParamObject = typeof queryParams === 'string' ? (0, $4NiRC.qs).parse(queryParams) : queryParams;
    const cachedMatch = (0, $306d1e727bba178f$export$f594abf16a5ad948).get(pathname, queryParamObject, basePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    for(let i = 0; i < routes.length; i++){
        const matchedRoute = (0, $72661a82c5c63ed1$export$2e2bcd8739ae039)(routes[i], pathname, queryParamObject, basePath);
        if (matchedRoute) {
            (0, $306d1e727bba178f$export$f594abf16a5ad948).set(pathname, queryParamObject, basePath, matchedRoute);
            return matchedRoute;
        }
    }
    return null;
};
const $da822bd664e445bf$export$ce5b73cebfeaa567 = (routes, pathname, queryParams, basePath = '')=>$da822bd664e445bf$var$matchRoute(routes, pathname, queryParams, basePath);
const $da822bd664e445bf$export$4e76f1d455ef7c95 = (route, pathname, queryParams, basePath = '')=>{
    $da822bd664e445bf$var$matchRoute([
        route
    ], pathname, queryParams, basePath);
};
var $da822bd664e445bf$export$2e2bcd8739ae039 = (routes, pathname, queryParams, basePath = '')=>$da822bd664e445bf$var$matchRoute(routes, pathname, queryParams, basePath);
module.exports["warmupMatchRouteCache"] = $da822bd664e445bf$export$4e76f1d455ef7c95;

});

parcelRegister("jwQVI", function(module, exports) {

var $4NiRC = parcelRequire("4NiRC");


var $jjIOx = parcelRequire("jjIOx");


var $epPJ3 = parcelRequire("epPJ3");


var $iL7a3 = parcelRequire("iL7a3");

const $e37a104447146b46$export$faed15f35ddc6f99 = (route, options = {})=>{
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    const pathname = (0, $epPJ3.generatePath)(route.path, params);
    const matchedRoute = (0, $iL7a3.default)([
        route
    ], pathname, query, basePath);
    return {
        route: route,
        match: matchedRoute ? matchedRoute.match : (0, $jjIOx.DEFAULT_MATCH),
        query: query
    };
};
const $e37a104447146b46$export$a0bd0313cbeabd49 = (routes, options)=>{
    const { location: location, basePath: basePath = '' } = options;
    const { pathname: pathname, search: search } = location;
    const query = (0, $4NiRC.qs).parse(search);
    const matchedRoute = (0, $iL7a3.default)(routes, pathname, query, basePath);
    return {
        query: query,
        route: matchedRoute ? matchedRoute.route : (0, $jjIOx.DEFAULT_ROUTE),
        match: matchedRoute ? matchedRoute.match : (0, $jjIOx.DEFAULT_MATCH)
    };
};
module.exports["createRouterContext"] = $e37a104447146b46$export$faed15f35ddc6f99;
module.exports["findRouterContext"] = $e37a104447146b46$export$a0bd0313cbeabd49;

});

parcelRegister("3UFvg", function(module, exports) {
const $2d96cbc130ddb5fd$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $2d96cbc130ddb5fd$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $2d96cbc130ddb5fd$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $2d96cbc130ddb5fd$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);
module.exports["isSameRouteMatch"] = $2d96cbc130ddb5fd$export$5997e70fc4543270;

});

parcelRegister("91pEK", function(module, exports) {

var $97ZVl = parcelRequire("97ZVl");

parcelRequire("hq2yE");
var $hNpL3 = parcelRequire("hNpL3");

const $69181bd2ca549fd5$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $69181bd2ca549fd5$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $97ZVl.getResourceStore)().actions;
    const nextResources = (0, $hNpL3.getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $69181bd2ca549fd5$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $97ZVl.getResourceStore)().actions;
    const nextResources = (0, $hNpL3.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $69181bd2ca549fd5$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $97ZVl.getResourceStore)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $69181bd2ca549fd5$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $69181bd2ca549fd5$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $69181bd2ca549fd5$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $97ZVl.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $97ZVl.getResourceStore)().actions;
            const nextResources = (0, $hNpL3.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $97ZVl.getResourceStore)().actions.getSafeData();
        }
    };
};

});

parcelRegister("RNy7H", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3ct2F = parcelRequire("3ct2F");

const $0a1b62d34dfcc57c$export$fee1a6213543bd78 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, resource: resource, options: options } = t0;
    const result = (0, $3ct2F.useResource)(resource, options);
    let t1;
    if ($[0] !== children || $[1] !== result) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(result));
        $[0] = children;
        $[1] = result;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children, resource: resource, options: options })=>{
    const result = (0, $3ct2F.useResource)(resource, options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(result));
};

});

parcelRegister("3ct2F", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

parcelRequire("fMvIa");
var $hFkZi = parcelRequire("hFkZi");


var $97ZVl = parcelRequire("97ZVl");

const $2549053b6bb87d65$export$9f6abfd74295843b = (resource, options)=>{
    const actions = (0, $97ZVl.useResourceStoreActions)();
    const { getContext: getRouterContext } = (0, $hFkZi.useRouterStoreActions)();
    // Dynamically generate a router subscriber based on the resource:
    // makes the component re-render only when key changes instead of
    // after every route change
    const useKey = (0, $cozmU.useMemo)(()=>(0, $kBr4q.createHook)((0, $hFkZi.RouterStore), {
            selector: ({ match: match, query: query, route: route }, keyArg)=>resource.getKey(keyArg != null ? keyArg : {
                    match: match,
                    query: query,
                    route: route
                }, actions.getContext())
        }), [
        resource,
        actions
    ]);
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    const key = useKey(options == null ? void 0 : options.routerContext)[0];
    const [slice] = (0, $97ZVl.useResourceStore)({
        type: resource.type,
        key: key
    });
    // we keep route context bound to key, so route context won't refresh
    // unless key changes. This allows refresh to be called on effect cleanup
    // or asynchronously, when route context might already have changed
    const routerContext = (0, $cozmU.useMemo)(// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    ()=>(options == null ? void 0 : options.routerContext) || getRouterContext(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key
    ]);
    const update = (0, $cozmU.useCallback)((updater)=>{
        actions.updateResourceState(resource, routerContext, updater);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clear = (0, $cozmU.useCallback)(()=>{
        actions.clearResource(resource, routerContext);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clearAll = (0, $cozmU.useCallback)(()=>{
        actions.clearResource(resource);
    }, [
        resource,
        actions
    ]);
    const refresh = (0, $cozmU.useCallback)(()=>{
        actions.getResourceFromRemote(resource, routerContext, {
            prefetch: false
        });
    }, [
        resource,
        routerContext,
        actions
    ]);
    return (0, $eb3ax.default)({}, slice, {
        update: update,
        key: key,
        refresh: refresh,
        clear: clear,
        clearAll: clearAll
    });
};
module.exports["useResource"] = $2549053b6bb87d65$export$9f6abfd74295843b;

});

parcelRegister("d9oWA", function(module, exports) {

var $97ZVl = parcelRequire("97ZVl");

const $992f76f5f24d2f55$export$dee7bf9fc0ff48c3 = (fn)=>(0, $97ZVl.getResourceStore)().storeState.subscribe(fn);

});

parcelRegister("97ZVl", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $1eVGO = parcelRequire("1eVGO");


var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");

var $5GOpG = parcelRequire("5GOpG");

var $c6StJ = parcelRequire("c6StJ");

parcelRequire("htyBH");
var $9qwq6 = parcelRequire("9qwq6");




parcelRequire("hq2yE");
var $htr8O = parcelRequire("htr8O");

const $1fdc05e75ba2d1af$export$c9ed509724feb827 = (state, props)=>{
    const { type: type, key: key } = props;
    const slice = state.data[type] && state.data[type][key];
    return slice ? (0, $eb3ax.default)({}, slice) : (0, $htr8O.getDefaultStateSlice)();
};
const $1fdc05e75ba2d1af$export$6a0b1779210de0ee = (state)=>state.context;


parcelRequire("hq2yE");
var $8RoZS = parcelRequire("8RoZS");
var $lHNk5 = parcelRequire("lHNk5");
var $iiKpy = parcelRequire("iiKpy");
var $hBrfJ = parcelRequire("hBrfJ");
var $9RVC0 = parcelRequire("9RVC0");
var $lTQd7 = parcelRequire("lTQd7");
var $8Z7ra = parcelRequire("8Z7ra");
var $8jRWn = parcelRequire("8jRWn");
var $dV1xE = parcelRequire("dV1xE");
var $5aFDI = parcelRequire("5aFDI");
var $7kOId = parcelRequire("7kOId");

const $6a54cd4daabb37f7$var$_excluded = [
    "context"
], $6a54cd4daabb37f7$var$_excluded2 = [
    "error",
    "expiresAt",
    "loading"
];
const $6a54cd4daabb37f7$export$3f1be494d407b77a = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   */ clearResource: (resource, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            if (routerStoreContext) {
                const key = getKey(routerStoreContext, context);
                dispatch((0, $iiKpy.deleteResourceState)(type, key));
                dispatch((0, $8RoZS.executeForDependents)(resource, (dependentResource)=>$6a54cd4daabb37f7$export$3f1be494d407b77a.clearResource(dependentResource, routerStoreContext)));
            } else dispatch((0, $iiKpy.deleteResourceState)(type));
        },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const _getState = getState(), { context: context } = _getState, resourceStoreState = (0, $1eVGO.default)(_getState, $6a54cd4daabb37f7$var$_excluded);
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $1fdc05e75ba2d1af$export$c9ed509724feb827)(resourceStoreState, {
                type: type,
                key: key
            });
            const data = getNewSliceData(prevSlice.data);
            const changes = prevSlice.loading ? {
                data: data,
                error: null,
                loading: true
            } : {
                data: data,
                error: null,
                loading: false,
                promise: Promise.resolve(data)
            };
            const newSlice = (0, $eb3ax.default)({}, prevSlice, changes, {
                expiresAt: (0, $lTQd7.getExpiresAt)(maxAge),
                accessedAt: (0, $9RVC0.getAccessedAt)()
            });
            dispatch((0, $iiKpy.setResourceState)(type, key, newSlice));
            // trigger dependent resources on change
            if (newSlice.data !== prevSlice.data) dispatch((0, $8RoZS.executeForDependents)(resource, (dependentResource)=>$6a54cd4daabb37f7$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, {})));
        },
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   */ getResource: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            let cached = dispatch((0, $iiKpy.getResourceState)(type, key));
            if (cached && (0, $8Z7ra.shouldUseCache)(cached)) {
                if ((0, $8Z7ra.isFromSsr)(cached)) {
                    const withResolvedPromise = (0, $8jRWn.setSsrDataPromise)(cached);
                    cached = (0, $lTQd7.setExpiresAt)(withResolvedPromise, maxAge);
                }
                cached.accessedAt = (0, $9RVC0.getAccessedAt)();
                dispatch((0, $iiKpy.setResourceState)(type, key, cached));
                return cached;
            }
            return dispatch($6a54cd4daabb37f7$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options));
        },
    /**
   * Request a single resource and update the resource cache.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = dispatch((0, $iiKpy.getResourceState)(type, key)) || (0, $htr8O.getDefaultStateSlice)();
            // abort request if already in flight
            if (prevSlice.loading) return prevSlice;
            dispatch((0, $7kOId.validateLRUCache)(resource, key));
            const loadingSlice = dispatch((0, $iiKpy.getPrefetchSlice)(type, key)) || (0, $lHNk5.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $8RoZS.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            let resolvedSlice;
            if (loadingSlice.data === prevSlice.data) // same data (by reference) means nothing has changed and we can avoid loading state
            resolvedSlice = {};
            else {
                // enter loading state
                dispatch((0, $iiKpy.setResourceState)(type, key, (0, $eb3ax.default)({}, prevSlice, loadingSlice, {
                    data: maxAge === 0 ? null : prevSlice.data,
                    error: maxAge === 0 ? null : prevSlice.error,
                    loading: true,
                    accessedAt: (0, $9RVC0.getAccessedAt)()
                })));
                // trigger dependent resources to also load
                dispatch((0, $8RoZS.executeForDependents)(resource, (dependentResource)=>$6a54cd4daabb37f7$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, options)));
                // in case another action occurred while loading promise may not be the one we started with
                // we need to re-assign promise consistent with error/data that we are assigning here
                try {
                    var _loadingSlice$data;
                    const data = (_loadingSlice$data = loadingSlice.data) != null ? _loadingSlice$data : await loadingSlice.promise;
                    resolvedSlice = {
                        data: data,
                        error: null,
                        // any existing error is cleared
                        loading: false,
                        promise: loadingSlice.promise
                    };
                } catch (error) {
                    if (error instanceof (0, $dV1xE.TimeoutError)) resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: true,
                        // this condition cannot recover so must only be present in static/server router
                        promise: null // special case for timeout
                    };
                    else resolvedSlice = {
                        error: // data: do not replace existing data
                        // @ts-ignore
                        error,
                        loading: false,
                        promise: loadingSlice.promise
                    };
                }
            }
            // ensure most recent data when return occurs
            const recentSlice = dispatch((0, $iiKpy.getResourceState)(type, key));
            const finalSlice = (0, $eb3ax.default)({}, recentSlice || prevSlice, resolvedSlice, {
                accessedAt: (0, $9RVC0.getAccessedAt)(),
                expiresAt: (0, $lTQd7.getExpiresAt)(maxAge)
            });
            // protect against race conditions: if resources get cleared while await happens, we discard the result
            if (recentSlice || loadingSlice.data !== undefined) dispatch((0, $iiKpy.setResourceState)(type, key, finalSlice));
            return finalSlice;
        },
    /**
   * Prefetch a single resource and store in the prefetch cache.
   */ prefetchResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const loadingSlice = dispatch((0, $iiKpy.getPrefetchSlice)(type, key)) || (0, $lHNk5.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $8RoZS.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            // save deferred value to be used also by dependants
            dispatch((0, $iiKpy.setPrefetchSlice)(type, key, loadingSlice));
            // trigger dependent resources to also prefetch
            dispatch((0, $8RoZS.executeForDependents)(resource, (dependentResource)=>$6a54cd4daabb37f7$export$3f1be494d407b77a.prefetchResourceFromRemote(dependentResource, routerStoreContext, options)));
        }
};
const $6a54cd4daabb37f7$export$e324594224ef24da = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   * Execute such that dependencies on current route will be cleared.
   */ clearResource: (resource, routerStoreContext)=>{
        var _routerStoreContext$r;
        return (0, $8RoZS.actionWithDependencies)(routerStoreContext == null || (_routerStoreContext$r = routerStoreContext.route) == null ? void 0 : _routerStoreContext$r.resources, resource, $6a54cd4daabb37f7$export$3f1be494d407b77a.clearResource(resource, routerStoreContext != null ? routerStoreContext : null));
    },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   * Execute such that dependencies on current route will be updated.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>(0, $8RoZS.actionWithDependencies)(routerStoreContext.route.resources, resource, $6a54cd4daabb37f7$export$3f1be494d407b77a.updateResourceState(resource, routerStoreContext, getNewSliceData)),
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   * Execute such that dependencies on current route will be updated.
   */ getResource: (resource, routerStoreContext, options)=>(0, $8RoZS.actionWithDependencies)(routerStoreContext.route.resources, resource, $6a54cd4daabb37f7$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options)),
    /**
   * Request a single resource and update the resource cache.
   * Execute such that dependencies on current route will be updated.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>(0, $8RoZS.actionWithDependencies)(routerStoreContext.route.resources, resource, $6a54cd4daabb37f7$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options)),
    /**
   * Request all resources.
   */ requestAllResources: (routerStoreContext, options = {})=>({ dispatch: dispatch })=>{
            const { route: routeDefault } = routerStoreContext || {};
            const route = routeDefault;
            if (!route || !route.resources) return Promise.all([]);
            return Promise.all(dispatch($6a54cd4daabb37f7$export$e324594224ef24da.requestResources(route.resources, routerStoreContext, options)));
        },
    /**
   * Cleans expired resources and resets them back to their initial state.
   * We need to do this when transitioning into a route.
   */ cleanExpiredResources: (resources, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { context: resourceContext } = getState();
            resources.forEach((resource)=>{
                const { type: type, getKey: getKey } = resource;
                const key = getKey(routerStoreContext, resourceContext);
                const slice = dispatch((0, $iiKpy.getResourceState)(type, key));
                if (slice && (!slice.expiresAt || slice.expiresAt < Date.now())) dispatch((0, $iiKpy.deleteResourceState)(type, key));
            });
        },
    /**
   * Requests a specific set of resources.
   */ requestResources: (resources, routerStoreContext, options)=>{
        var _resources;
        const predicate = (0, $9qwq6.isServerEnvironment)() ? ({ isBrowserOnly: isBrowserOnly })=>!isBrowserOnly : ()=>true;
        return (0, $8RoZS.mapActionWithDependencies)((_resources = routerStoreContext.route.resources) == null ? void 0 : _resources.filter(predicate), resources.filter(predicate), (resource)=>$6a54cd4daabb37f7$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options));
    },
    /**
   * Prefetch a specific set of resources.
   */ prefetchResources: (resources, routerStoreContext, options)=>(0, $8RoZS.mapActionWithDependencies)(routerStoreContext.route.resources, resources, (resource)=>$6a54cd4daabb37f7$export$3f1be494d407b77a.prefetchResourceFromRemote(resource, routerStoreContext, (0, $eb3ax.default)({}, options, {
                prefetch: true
            }))),
    /**
   * Hydrates the store with state.
   * Will not override pre-hydrated state.
   */ hydrate: ({ resourceData: resourceData, resourceContext: resourceContext })=>({ getState: getState, setState: setState })=>{
            const { data: data, context: context } = getState();
            function getNextStateValue(prev, next) {
                if (!Object.keys(prev).length && next && Object.keys(next).length) return next;
                return prev;
            }
            const hydratedData = (0, $5aFDI.transformData)(getNextStateValue(data, resourceData), (_ref)=>{
                let { error: error, expiresAt: expiresAt, loading: loading } = _ref, rest = (0, $1eVGO.default)(_ref, $6a54cd4daabb37f7$var$_excluded2);
                const deserializedError = !error ? null : (0, $hBrfJ.deserializeError)(error);
                const isTimeoutError = (deserializedError == null ? void 0 : deserializedError.name) === 'TimeoutError';
                return (0, $eb3ax.default)({}, rest, {
                    expiresAt: isTimeoutError ? Date.now() - 1 : expiresAt,
                    loading: isTimeoutError ? false : loading,
                    error: deserializedError
                });
            });
            setState({
                data: hydratedData,
                context: getNextStateValue(context, resourceContext)
            });
        },
    /**
   * Gets the store's context
   */ getContext: ()=>({ getState: getState })=>getState().context,
    /**
   * Returns safe, portable and rehydratable data.
   */ getSafeData: ()=>({ getState: getState })=>(0, $5aFDI.transformData)(getState().data, ({ data: data, key: key, error: error, loading: loading })=>({
                    data: data,
                    key: key,
                    promise: null,
                    expiresAt: null,
                    accessedAt: null,
                    error: !error ? null : (0, $hBrfJ.serializeError)(error instanceof Error ? error : new Error(JSON.stringify(error))),
                    loading: error instanceof (0, $dV1xE.TimeoutError) ? loading : false
                }))
};
const $6a54cd4daabb37f7$export$94f50dade551bd01 = (0, $8s9DV.createStore)({
    initialState: {
        data: {},
        context: {},
        executing: null,
        prefetching: null
    },
    actions: $6a54cd4daabb37f7$export$e324594224ef24da,
    name: 'router-resources'
});
const $6a54cd4daabb37f7$export$cc90fb9c37c5589d = (0, $j8on0.createContainer)($6a54cd4daabb37f7$export$94f50dade551bd01, {
    displayName: 'ResourceContainer'
});
const $6a54cd4daabb37f7$export$fee1a6213543bd78 = (0, $5GOpG.createSubscriber)($6a54cd4daabb37f7$export$94f50dade551bd01, {
    displayName: 'ResourceSelectorSubscriber',
    selector: (state, props)=>(0, $1fdc05e75ba2d1af$export$c9ed509724feb827)(state, {
            type: props.resourceType,
            key: props.resourceKey
        })
});
const $6a54cd4daabb37f7$export$6f6057d42352becb = ()=>// @ts-ignore not providing a scopeId param
    (0, $c6StJ.defaultRegistry).getStore($6a54cd4daabb37f7$export$94f50dade551bd01);
const $6a54cd4daabb37f7$export$ac3608e0bb357c7 = (0, $kBr4q.createHook)($6a54cd4daabb37f7$export$94f50dade551bd01, {
    selector: (0, $1fdc05e75ba2d1af$export$c9ed509724feb827)
});
const $6a54cd4daabb37f7$export$98e41a62c9bef75e = (0, $kBr4q.createActionsHook)($6a54cd4daabb37f7$export$94f50dade551bd01);
const $6a54cd4daabb37f7$export$e59f52df235ac7b3 = (0, $kBr4q.createHook)($6a54cd4daabb37f7$export$94f50dade551bd01, {
    selector: (0, $1fdc05e75ba2d1af$export$6a0b1779210de0ee)
});
module.exports["getResourceStore"] = $6a54cd4daabb37f7$export$6f6057d42352becb;
module.exports["useResourceStore"] = $6a54cd4daabb37f7$export$ac3608e0bb357c7;
module.exports["useResourceStoreActions"] = $6a54cd4daabb37f7$export$98e41a62c9bef75e;

});

parcelRegister("e5SM2", function(module, exports) {
const $a42c053e9c00defc$export$d4864d13105dc5ed = {
    loading: false,
    error: null,
    data: {
        foo: 'bar'
    },
    promise: null,
    expiresAt: Date.now(),
    accessedAt: Date.now(),
    key: ''
};

});

parcelRegister("9vmeB", function(module, exports) {
$parcel$export(module.exports, "RouterSubscriber", () => (parcelRequire("aO6HO")).RouterSubscriber);
$parcel$export(module.exports, "useRouter", () => (parcelRequire("6nY8H")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("j4NNn")).useRouterActions);

var $8CJk6 = parcelRequire("8CJk6");


var $5ZHAX = parcelRequire("5ZHAX");


var $k8KD8 = parcelRequire("k8KD8");


var $aO6HO = parcelRequire("aO6HO");


var $kZkvy = parcelRequire("kZkvy");


var $33dCY = parcelRequire("33dCY");


var $d7HEO = parcelRequire("d7HEO");


var $6nY8H = parcelRequire("6nY8H");


var $j4NNn = parcelRequire("j4NNn");


var $7wvhg = parcelRequire("7wvhg");


});

parcelRegister("6BZrm", function(module, exports) {
$parcel$export(module.exports, "Link", () => (parcelRequire("imtAv")).default);

var $imtAv = parcelRequire("imtAv");


var $h1RxD = parcelRequire("h1RxD");


});

parcelRegister("bDcGz", function(module, exports) {
$parcel$export(module.exports, "generateLocationFromPath", () => (parcelRequire("7MFOM")).generateLocationFromPath);
$parcel$export(module.exports, "generatePath", () => (parcelRequire("fEoYr")).generatePath);
$parcel$export(module.exports, "isServerEnvironment", () => (parcelRequire("2kK4E")).isServerEnvironment);
$parcel$export(module.exports, "warmupMatchRouteCache", () => (parcelRequire("aNi3F")).warmupMatchRouteCache);
$parcel$export(module.exports, "findRouterContext", () => (parcelRequire("fHQWF")).findRouterContext);
$parcel$export(module.exports, "createRouterContext", () => (parcelRequire("fHQWF")).createRouterContext);
$parcel$export(module.exports, "isSameRouteMatch", () => (parcelRequire("5l9sO")).isSameRouteMatch);

var $lKKkr = parcelRequire("lKKkr");


var $7MFOM = parcelRequire("7MFOM");


var $fEoYr = parcelRequire("fEoYr");


var $2kK4E = parcelRequire("2kK4E");


var $aNi3F = parcelRequire("aNi3F");


var $fHQWF = parcelRequire("fHQWF");


var $5l9sO = parcelRequire("5l9sO");


});

parcelRegister("8WqGQ", function(module, exports) {
parcelRequire("bDcGz");
var $fHQWF = parcelRequire("fHQWF");

const $6828719e23c31b7d$export$c36ce69a82764756 = (plugins, { routes: routes, history: history, basePath: basePath })=>{
    const context = (0, $fHQWF.findRouterContext)(routes, {
        location: history.location,
        basePath: basePath
    });
    plugins.forEach((p)=>{
        p.routeLoad == null || p.routeLoad({
            context: context
        });
    });
};

});

parcelRegister("kZkvy", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $lI7ls = parcelRequire("lI7ls");


var $iTvlA = parcelRequire("iTvlA");

var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");


var $3yk4a = parcelRequire("3yk4a");

parcelRequire("bDcGz");
var $fHQWF = parcelRequire("fHQWF");
var $7MFOM = parcelRequire("7MFOM");
var $fEoYr = parcelRequire("fEoYr");
var $2kK4E = parcelRequire("2kK4E");
var $aNi3F = parcelRequire("aNi3F");


var $4NiRC = parcelRequire("4NiRC");

parcelRequire("bDcGz");
var $5l9sO = parcelRequire("5l9sO");

const $2166f2d465f767ab$var$stripTrailingSlash = (path)=>path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
const $2166f2d465f767ab$var$addLeadingSlash = (path)=>path.charAt(0) === '/' ? path : '/' + path;
const $2166f2d465f767ab$export$b8ce2e8154d1dff1 = (path, prefix = '')=>{
    if (prefix) {
        prefix = $2166f2d465f767ab$var$stripTrailingSlash(prefix);
        prefix = $2166f2d465f767ab$var$addLeadingSlash(prefix);
        path = $2166f2d465f767ab$var$addLeadingSlash(path);
    }
    return prefix + path;
};
const $2166f2d465f767ab$export$e83e3719fc818ee5 = (path)=>{
    const regex = new RegExp('^([a-z]+://|//)', 'i');
    return regex.test(path);
};
const $2166f2d465f767ab$export$2fa6dede99f181e5 = (path)=>{
    if (typeof path !== 'string' || !$2166f2d465f767ab$export$e83e3719fc818ee5(path)) return false;
    const pathHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($4NiRC)))(path).hostname;
    const currentHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($4NiRC)))(window.location.href).hostname;
    return pathHostname !== currentHostname;
};
const $2166f2d465f767ab$export$ae9fda833d91ed65 = (path, prefix = '')=>{
    if (typeof path !== 'string') return path;
    if (!$2166f2d465f767ab$export$e83e3719fc818ee5(path)) {
        path = $2166f2d465f767ab$export$b8ce2e8154d1dff1(path, prefix);
        return path;
    }
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($4NiRC)))(path);
    return `${url.pathname}${url.query}${url.hash}`;
};
const $2166f2d465f767ab$export$92377f461a797888 = (location, query)=>{
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $4NiRC.qs).stringify(query, true);
    return `${location.pathname}${stringifiedQuery}${location.hash}`;
};
const $2166f2d465f767ab$export$9ae1c7c875ef309d = (location)=>{
    return `${location.pathname}${location.search}${location.hash}`;
};
const $2166f2d465f767ab$export$c9237620ff7fdf7c = ({ context: context, prevContext: prevContext, pluginId: pluginId })=>{
    const sameRoute = (0, $5l9sO.isSameRouteMatch)({
        prevContextMatch: prevContext.match,
        nextContextMatch: context.match
    });
    // keep old behaviour for Resources plugin
    // load Route only if path/query/params changed, and ignore the rest of query-params
    const defaultShouldReload = pluginId === 'resources-plugin' || !sameRoute;
    if (context.route === prevContext.route && context.route.EXPERIMENTAL__shouldReload) {
        const routeChoice = context.route.EXPERIMENTAL__shouldReload({
            context: context,
            prevContext: prevContext,
            pluginId: pluginId,
            defaultShouldReload: defaultShouldReload
        });
        if (typeof routeChoice === 'boolean') return routeChoice;
    }
    return defaultShouldReload;
};


const $f479699de2602c3e$export$36d128238e6b60f5 = {
    action: (0, $3yk4a.DEFAULT_ACTION),
    basePath: '',
    location: (0, $3yk4a.DEFAULT_HISTORY).location,
    history: (0, $3yk4a.DEFAULT_HISTORY),
    match: (0, $3yk4a.DEFAULT_MATCH),
    onPrefetch: undefined,
    query: {},
    route: (0, $3yk4a.DEFAULT_ROUTE),
    routes: [],
    unlisten: null,
    plugins: []
};
const $f479699de2602c3e$var$actions = {
    /**
   * Bootstraps the store with initial data.
   *
   */ bootstrapStore: (props)=>({ setState: setState, dispatch: dispatch })=>{
            const { basePath: basePath = '', history: history, initialRoute: initialRoute, onPrefetch: onPrefetch, routes: routes, plugins: plugins } = props;
            const routerContext = (0, $fHQWF.findRouterContext)(initialRoute ? [
                initialRoute
            ] : routes, {
                location: history.location,
                basePath: basePath
            });
            setState((0, $eb3ax.default)({}, routerContext, {
                basePath: basePath,
                history: history,
                onPrefetch: onPrefetch,
                routes: routes,
                location: history.location,
                action: history.action,
                plugins: plugins
            }));
            if (!(0, $2kK4E.isServerEnvironment)()) dispatch($f479699de2602c3e$var$actions.listen());
        },
    /**
   * Starts listening to browser history and sets the unlisten function in state.
   * Will request route resources on route change.
   *
   */ listen: ()=>({ getState: getState, setState: setState })=>{
            const { history: history, unlisten: unlisten } = getState();
            if (unlisten) unlisten();
            const stopListening = history.listen((...update)=>{
                const location = update.length === 2 ? update[0] : update[0].location;
                const action = update.length === 2 ? update[1] : update[0].action;
                const { plugins: plugins, routes: routes, basePath: basePath, match: currentMatch, route: currentRoute, query: currentQuery } = getState();
                const nextContext = (0, $fHQWF.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
                const prevContext = {
                    route: currentRoute,
                    match: currentMatch,
                    query: currentQuery
                };
                const shouldReloadByPlugin = new Map(plugins.map((plugin)=>[
                        plugin.id,
                        (0, $2166f2d465f767ab$export$c9237620ff7fdf7c)({
                            context: nextContext,
                            prevContext: prevContext,
                            pluginId: plugin.id
                        })
                    ]));
                /* Explicitly batch update
       * as we need resources cleaned + route changed + resource fetch started together
       * If we do not batch, React might be re-render when route changes but resource
       * fetching has not started yet, making the app render with data null */ (0, $iTvlA.batch)(()=>{
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.beforeRouteLoad == null || p.beforeRouteLoad({
                            context: prevContext,
                            nextContext: nextContext
                        });
                    });
                    setState((0, $eb3ax.default)({}, nextContext, {
                        location: location,
                        action: action
                    }));
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.routeLoad == null || p.routeLoad({
                            context: nextContext,
                            prevContext: prevContext
                        });
                    });
                });
            });
            setState({
                unlisten: stopListening
            });
        },
    push: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $2166f2d465f767ab$export$2fa6dede99f181e5)(path)) window.location.assign(path);
            else history.push((0, $2166f2d465f767ab$export$ae9fda833d91ed65)(path, basePath), state);
        },
    pushTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $7MFOM.generateLocationFromPath)(route.path, (0, $eb3ax.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $aNi3F.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.push(location, attributes == null ? void 0 : attributes.state);
        },
    replace: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $2166f2d465f767ab$export$2fa6dede99f181e5)(path)) window.location.replace(path);
            else history.replace((0, $2166f2d465f767ab$export$ae9fda833d91ed65)(path, basePath), state);
        },
    replaceTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $7MFOM.generateLocationFromPath)(route.path, (0, $eb3ax.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $aNi3F.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.replace(location, attributes == null ? void 0 : attributes.state);
        },
    goBack: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goBack(), history@5 uses back()
            if ('goBack' in history) history.goBack();
            else if ('back' in history) history.back();
            else throw new Error('History does not support goBack');
        },
    goForward: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goForward(), history@5 uses forward()
            if ('goForward' in history) history.goForward();
            else if ('forward' in history) history.forward();
            else throw new Error('History does not support goForward');
        },
    registerBlock: (blocker)=>({ getState: getState })=>{
            const { history: history } = getState();
            return history.block(blocker);
        },
    getContext: ()=>({ getState: getState })=>{
            const { query: query, route: route, match: match } = getState();
            return {
                query: query,
                route: route,
                match: match
            };
        },
    getBasePath: ()=>({ getState: getState })=>{
            const { basePath: basePath } = getState();
            return basePath;
        },
    updateQueryParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { query: existingQueryParams, history: history, location: location } = getState();
            const updatedQueryParams = (0, $eb3ax.default)({}, existingQueryParams, params);
            // remove undefined keys
            Object.keys(updatedQueryParams).forEach((key)=>updatedQueryParams[key] === undefined && delete updatedQueryParams[key]);
            const existingPath = (0, $2166f2d465f767ab$export$92377f461a797888)(location, existingQueryParams);
            const updatedPath = (0, $2166f2d465f767ab$export$92377f461a797888)(location, updatedQueryParams);
            if (updatedPath !== existingPath) history[updateType](updatedPath);
        },
    updatePathParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { history: history, location: location, route: { path: path }, match: { params: existingPathParams }, basePath: basePath } = getState();
            const pathWithBasePath = basePath + path;
            const updatedPathParams = (0, $eb3ax.default)({}, existingPathParams, params);
            const updatedPath = (0, $fEoYr.generatePath)(pathWithBasePath, updatedPathParams);
            const updatedLocation = (0, $eb3ax.default)({}, location, {
                pathname: updatedPath
            });
            const existingRelativePath = (0, $2166f2d465f767ab$export$9ae1c7c875ef309d)(location);
            const updatedRelativePath = (0, $2166f2d465f767ab$export$9ae1c7c875ef309d)(updatedLocation);
            if (updatedRelativePath !== existingRelativePath) history[updateType](updatedRelativePath);
        },
    loadPlugins: ()=>({ getState: getState })=>{
            const { plugins: plugins, match: match, query: query, route: route } = getState();
            plugins.forEach((p)=>p.routeLoad == null ? void 0 : p.routeLoad({
                    context: {
                        match: match,
                        query: query,
                        route: route
                    }
                }));
        },
    prefetchRoute: (path, nextContext)=>({ getState: getState })=>{
            const { plugins: plugins, routes: routes, basePath: basePath, onPrefetch: onPrefetch } = getState();
            const { route: route, match: match, query: query } = $f479699de2602c3e$export$ebf37f7e180b13a9();
            if (!nextContext && !(0, $2166f2d465f767ab$export$2fa6dede99f181e5)(path)) {
                const location = (0, $lI7ls.parsePath)((0, $2166f2d465f767ab$export$ae9fda833d91ed65)(path, basePath));
                nextContext = (0, $fHQWF.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
            }
            if (nextContext == null) return;
            const nextLocationContext = nextContext;
            (0, $iTvlA.batch)(()=>{
                plugins.forEach((p)=>p.routePrefetch == null ? void 0 : p.routePrefetch({
                        context: {
                            route: route,
                            match: match,
                            query: query
                        },
                        nextContext: nextLocationContext
                    }));
                if (onPrefetch) onPrefetch(nextLocationContext);
            });
        }
};
const $f479699de2602c3e$export$1cf0ecab63b1963c = (0, $8s9DV.createStore)({
    initialState: $f479699de2602c3e$export$36d128238e6b60f5,
    actions: $f479699de2602c3e$var$actions,
    name: 'router'
});
const $f479699de2602c3e$export$d6b817abe7a77ea5 = (0, $j8on0.createContainer)($f479699de2602c3e$export$1cf0ecab63b1963c, {
    displayName: 'RouterContainer',
    onInit: ()=>({ dispatch: dispatch }, props)=>{
            dispatch($f479699de2602c3e$var$actions.bootstrapStore(props));
            !(0, $2kK4E.isServerEnvironment)() && dispatch($f479699de2602c3e$var$actions.loadPlugins());
        },
    onCleanup: ()=>(state)=>{
            if (!(0, $2kK4E.isServerEnvironment)()) {
                const { unlisten: unlisten } = state.getState();
                unlisten && unlisten();
            }
        }
});
const $f479699de2602c3e$export$9569010eab09ae9e = (0, $kBr4q.createHook)($f479699de2602c3e$export$1cf0ecab63b1963c);
const $f479699de2602c3e$export$ada49399abf7a3a1 = (0, $kBr4q.createActionsHook)($f479699de2602c3e$export$1cf0ecab63b1963c);
function $f479699de2602c3e$export$95ab46bba7ea7a22(selector) {
    const useHook = (0, $kBr4q.createHook)($f479699de2602c3e$export$1cf0ecab63b1963c, {
        selector: selector
    });
    return function useRouterSelector(...args) {
        return useHook(...args)[0];
    };
}
const $f479699de2602c3e$export$5ccad187366c8494 = ()=>// @ts-ignore calling `getStore` without providing a scopeId
    (0, $c6StJ.defaultRegistry).getStore($f479699de2602c3e$export$1cf0ecab63b1963c);
const $f479699de2602c3e$export$ebf37f7e180b13a9 = ()=>$f479699de2602c3e$export$5ccad187366c8494().storeState.getState();
module.exports["RouterStore"] = $f479699de2602c3e$export$1cf0ecab63b1963c;
module.exports["RouterContainer"] = $f479699de2602c3e$export$d6b817abe7a77ea5;
module.exports["useRouterStore"] = $f479699de2602c3e$export$9569010eab09ae9e;
module.exports["useRouterStoreActions"] = $f479699de2602c3e$export$ada49399abf7a3a1;

});

parcelRegister("3yk4a", function(module, exports) {

var $eO7Xs = parcelRequire("eO7Xs");


var $lKKkr = parcelRequire("lKKkr");

const $29641cc851fe8a2d$export$7c22f8f9552f689e = {
    pathname: '',
    search: '',
    hash: ''
};
const $29641cc851fe8a2d$export$2de13e891a662beb = {
    params: {},
    isExact: false,
    path: '',
    url: '',
    query: {}
};
const $29641cc851fe8a2d$export$4eadc79233226325 = {
    path: '',
    component: ()=>null,
    name: ''
};
const $29641cc851fe8a2d$export$39607c9878cf5148 = (0, $lKKkr.createLegacyHistory)();
const $29641cc851fe8a2d$export$1515254c8c90bebb = {
    location: $29641cc851fe8a2d$export$7c22f8f9552f689e,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    listen: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    block: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    createHref: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs)))
};
const $29641cc851fe8a2d$export$fa440ddf675c8a93 = 'POP';
module.exports["DEFAULT_MATCH"] = $29641cc851fe8a2d$export$2de13e891a662beb;
module.exports["DEFAULT_ROUTE"] = $29641cc851fe8a2d$export$4eadc79233226325;
module.exports["DEFAULT_HISTORY"] = $29641cc851fe8a2d$export$39607c9878cf5148;
module.exports["DEFAULT_ACTION"] = $29641cc851fe8a2d$export$fa440ddf675c8a93;

});

parcelRegister("2Tnfk", function(module, exports) {

var $4C2bB = parcelRequire("4C2bB");


var $c7RYO = parcelRequire("c7RYO");


var $2s5nZ = parcelRequire("2s5nZ");


var $bNqcK = parcelRequire("bNqcK");


var $jPvl5 = parcelRequire("jPvl5");





var $gLGm7 = parcelRequire("gLGm7");


});

parcelRegister("7JV3d", function(module, exports) {
module.exports = new URL("RestrictedContentIcon-Light.e0fef1fb.svg", import.meta.url).toString();

});

parcelRegister("8OTdS", function(module, exports) {
module.exports = new URL("RestrictedContentIcon-Dark.bc90ae31.svg", import.meta.url).toString();

});

parcelRegister("9HNv5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d561062df6e47d30$export$4047609c83584c4b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "nCrwB",
    name: "CompanyHomeBuilderUpsellPage",
    loader: async ()=>(await (parcelRequire("1DpTu"))).CompanyHomeBuilderUpsellPage
});
module.exports["CompanyHomeBuilderUpsellPage"] = $d561062df6e47d30$export$4047609c83584c4b;

});

parcelRegister("jKzCD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $1uFM6 = parcelRequire("1uFM6");


var $cEgMD = parcelRequire("cEgMD");


var $1ytiN = parcelRequire("1ytiN");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $8NC5Z = parcelRequire("8NC5Z");


var $gi8UL = parcelRequire("gi8UL");

function $6d8995f9c98e457c$export$567b73f497a151cb({ onSuccess: onSuccess, onExists: onExists, route: route }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isCreatingHub, setIsCreatingHub] = (0, $cozmU.useState)(false);
    const [creationError, setCreationError] = (0, $cozmU.useState)(null);
    const { isSiteAdmin: isSiteAdmin, frontCoverState: frontCoverState } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
    const isCompanyHubUnset = frontCoverState === (0, $cEgMD.FrontCoverStateEnum).UNSET;
    const hasCreatedHub = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!hasCreatedHub.current) {
            const shouldCreateHub = isCompanyHubUnset && isSiteAdmin && !shouldShowPremiumUpsell && !isCreatingHub;
            if (shouldCreateHub) {
                let wasHubCreated = false;
                setIsCreatingHub(true);
                hasCreatedHub.current = true;
                experienceTracker.start({
                    name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                    timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
                });
                (0, $gi8UL.createCompanyHubSpace)().then(({ didCreateSpace: didCreateSpace, homepageId: homepageId })=>{
                    if (didCreateSpace) {
                        experienceTracker.succeed({
                            name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE)
                        });
                        wasHubCreated = true;
                        onSuccess?.(homepageId);
                    } else {
                        experienceTracker.abort({
                            name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                            reason: 'Hub space already exists. Handled by redirecting user to Hub editor without first time experience'
                        });
                        onExists?.(homepageId);
                    }
                }).catch((error)=>{
                    setCreationError(error);
                    if ((0, $gi8UL.hasStalePermissionsErrorMessage)(error)) experienceTracker.abort({
                        name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                        reason: 'User has stale admin permissions'
                    });
                    else if ((0, $1uFM6.isUnauthorizedError)(error)) experienceTracker.abort({
                        name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                        reason: 'User is not authenticated'
                    });
                    else experienceTracker.fail({
                        name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                        error: error
                    });
                }).finally(()=>{
                    setIsCreatingHub(false);
                    createAnalyticsEvent({
                        type: 'sendTrackEvent',
                        data: {
                            source: 'companyHub',
                            action: 'created',
                            actionSubject: 'onRouteStart',
                            actionSubjectId: 'companyHubOnRouteCreation',
                            attributes: {
                                created: wasHubCreated,
                                route: route
                            }
                        }
                    }).fire();
                });
            }
        }
    }, [
        isCompanyHubUnset,
        isSiteAdmin,
        createAnalyticsEvent,
        shouldShowPremiumUpsell,
        isCreatingHub,
        experienceTracker,
        onSuccess,
        onExists,
        route
    ]);
    return {
        isCreatingHub: isCreatingHub,
        creationError: creationError
    };
}
module.exports["useCompanyHubOnRouteCreationFlow"] = $6d8995f9c98e457c$export$567b73f497a151cb;

});

parcelRegister("eCfJ3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $RfroO = parcelRequire("RfroO");


var $eKMV3 = parcelRequire("eKMV3");


var $kA6Zo = parcelRequire("kA6Zo");


var $buxP3 = parcelRequire("buxP3");


var $i1t43 = parcelRequire("i1t43");


var $1NBp8 = parcelRequire("1NBp8");


var $1uFM6 = parcelRequire("1uFM6");


var $gi8UL = parcelRequire("gi8UL");


var $bv42K = parcelRequire("bv42K");


var $8x1Nr = parcelRequire("8x1Nr");

const $3f49c0dd8d66c83c$var$containerStyles = (0, $buxP3.xcss)({
    height: '90vh',
    paddingInline: 'space.200'
});
const $3f49c0dd8d66c83c$export$c09c08db0e42b276 = ({ error: error })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const errorConfig = (0, $cozmU.useMemo)(()=>{
        if ((0, $gi8UL.hasStalePermissionsErrorMessage)(error)) return {
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($8x1Nr))),
            title: formatMessage((0, $gi8UL.i18n).createCompanyHubSpaceStalePermissionsErrorFlagTitle),
            description: formatMessage((0, $gi8UL.i18n).createCompanyHubSpaceStalePermissionsErrorFlagDescription, {
                a: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                        href: "https://support.atlassian.com/confluence-cloud/docs/create-and-customize-a-company-hub",
                        target: "_blank",
                        rel: "noopener noreferrer"
                    }, chunks)
            })
        };
        if ((0, $1uFM6.isUnauthorizedError)(error)) return {
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($8x1Nr))),
            title: formatMessage((0, $gi8UL.i18n).createCompanyHubSpacePermissionsErrorFlagTitle),
            description: formatMessage((0, $gi8UL.i18n).createCompanyHubSpacePermissionsErrorFlagDescription, {
                b: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks)
            }),
            buttonLabel: formatMessage((0, $gi8UL.i18n).createCompanyHubSpacePermissionsErrorFlagButton),
            buttonLink: (0, $1NBp8.ADMIN_NEW_GLOBAL_PERMISSIONS).toUrl()
        };
        return {
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($bv42K))),
            title: formatMessage((0, $gi8UL.i18n).createCompanyHubSpaceErrorFlagTitle),
            description: formatMessage((0, $gi8UL.i18n).createCompanyHubSpaceErrorFlagDescription)
        };
    }, [
        error,
        formatMessage
    ]);
    const { imageUrl: imageUrl, title: title, description: description, buttonLabel: buttonLabel, buttonLink: buttonLink } = errorConfig;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $3f49c0dd8d66c83c$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $RfroO.default), {
        header: title,
        description: description,
        primaryAction: buttonLabel && buttonLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
            appearance: "primary",
            href: buttonLink
        }, buttonLabel) : undefined,
        imageUrl: imageUrl
    }));
};
module.exports["HubErrorPageComponent"] = $3f49c0dd8d66c83c$export$c09c08db0e42b276;

});

parcelRegister("eX4up", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $faAj4 = parcelRequire("faAj4");


var $jlRK6 = parcelRequire("jlRK6");


var $d7j1D = parcelRequire("d7j1D");


var $dVPAB = parcelRequire("dVPAB");


var $4yccB = parcelRequire("4yccB");


var $c2Doe = parcelRequire("c2Doe");


var $iMnC5 = parcelRequire("iMnC5");


var $b8pma = parcelRequire("b8pma");


var $lfoFx = parcelRequire("lfoFx");


var $3eDML = parcelRequire("3eDML");

var $ame4Z = parcelRequire("ame4Z");

var $bIp5p = parcelRequire("bIp5p");

var $r8hvx = parcelRequire("r8hvx");


var $2VrNo = parcelRequire("2VrNo");

var $9tqV4 = parcelRequire("9tqV4");


var $8NddB = parcelRequire("8NddB");


var $kETeF = parcelRequire("kETeF");

var $jcnIS = parcelRequire("jcnIS");


var $fXxXz = parcelRequire("fXxXz");


var $9YzZs = parcelRequire("9YzZs");


var $2rwbd = parcelRequire("2rwbd");


var $8XweJ = parcelRequire("8XweJ");

const $2105bf85746b7ad8$var$hubEditorStyles = {
    spinnerContainer: "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _0jFU0VWP8C"
};
const $2105bf85746b7ad8$var$EditorInternal = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(81);
    const intl = (0, $kSwu1.useIntl)();
    const [editorApi, setEditorApi] = (0, $cozmU.useState)(undefined);
    const { editorActions: editorActions, contentId: contentId, userId: userId, cloudId: cloudId, product: product, mediaProvider: mediaProvider, setExternalEditorApi: setExternalEditorApi, additionalExtensionProviders: t0, loadAdditionalExtensionProviders: loadAdditionalExtensionProviders, onExtensionProvidersLoaded: onExtensionProvidersLoaded, PropsProvider: PropsProvider, linkPickerOptions: linkPickerOptions, isEditingLocked: isEditingLocked, isTemplateLocked: isTemplateLocked } = props;
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? [] : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const additionalExtensionProviders = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = new (0, $4yccB.default)();
        $[2] = t2;
    } else t2 = $[2];
    const smartCardClient = t2;
    const { pageMediaConfig: pageMediaConfig } = (0, $r8hvx.useHubContext)();
    const { closeConfigPanel: closeConfigPanel, openConfigPanel: openConfigPanel } = (0, $9tqV4.useHubEditorExtensionConfigPanel)(editorActions);
    const [t3] = (0, $bIp5p.useExtensionsState)();
    const { selectedExtensionLocalId: selectedExtensionLocalId } = t3;
    const { setIsInViewMode: setIsInViewMode, setIsEditingLocked: setIsEditingLocked } = (0, $bIp5p.useExtensionsActions)();
    const { featureFlags: featureFlags } = (0, $r8hvx.useHubContext)();
    let t4;
    if ($[3] !== PropsProvider || $[4] !== contentId || $[5] !== editorActions || $[6] !== intl || $[7] !== openConfigPanel) {
        t4 = {
            contentId: contentId,
            intl: intl,
            PropsProvider: PropsProvider,
            editorActions: editorActions,
            openConfigPanel: openConfigPanel
        };
        $[3] = PropsProvider;
        $[4] = contentId;
        $[5] = editorActions;
        $[6] = intl;
        $[7] = openConfigPanel;
        $[8] = t4;
    } else t4 = $[8];
    const hubExtensionProviders = (0, $jcnIS.useHubExtensionProviders)(t4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t5;
    let t6;
    if ($[9] !== editorActions || $[10] !== loadAdditionalExtensionProviders || $[11] !== openConfigPanel) {
        t5 = ()=>{
            if (loadAdditionalExtensionProviders && editorActions) loadAdditionalExtensionProviders({
                editorActions: editorActions,
                openConfigPanel: openConfigPanel
            });
        };
        t6 = [
            loadAdditionalExtensionProviders,
            editorActions,
            openConfigPanel
        ];
        $[9] = editorActions;
        $[10] = loadAdditionalExtensionProviders;
        $[11] = openConfigPanel;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t5, t6);
    let t7;
    if ($[14] !== additionalExtensionProviders || $[15] !== hubExtensionProviders) {
        t7 = [
            ...hubExtensionProviders,
            ...additionalExtensionProviders
        ];
        $[14] = additionalExtensionProviders;
        $[15] = hubExtensionProviders;
        $[16] = t7;
    } else t7 = $[16];
    const allExtensionProviders = t7;
    let t8;
    let t9;
    if ($[17] !== allExtensionProviders || $[18] !== onExtensionProvidersLoaded) {
        t8 = ()=>{
            if (onExtensionProvidersLoaded && allExtensionProviders.length > 0) onExtensionProvidersLoaded(allExtensionProviders);
        };
        t9 = [
            onExtensionProvidersLoaded,
            allExtensionProviders
        ];
        $[17] = allExtensionProviders;
        $[18] = onExtensionProvidersLoaded;
        $[19] = t8;
        $[20] = t9;
    } else {
        t8 = $[19];
        t9 = $[20];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t8, t9);
    let t10;
    if ($[21] !== contentId || $[22] !== editorApi || $[23] !== mediaProvider || $[24] !== pageMediaConfig) {
        t10 = {
            contentId: contentId,
            editorAPI: editorApi,
            customMediaProvider: mediaProvider,
            mediaConfig: pageMediaConfig
        };
        $[21] = contentId;
        $[22] = editorApi;
        $[23] = mediaProvider;
        $[24] = pageMediaConfig;
        $[25] = t10;
    } else t10 = $[25];
    const mediaOptions = (0, $2rwbd.useMediaOptions)(t10);
    let t11;
    if ($[26] !== featureFlags || $[27] !== intl || $[28] !== isEditingLocked || $[29] !== isTemplateLocked || $[30] !== linkPickerOptions || $[31] !== mediaOptions || $[32] !== props) {
        t11 = ()=>(0, $9YzZs.createHubEditorPreset)({
                ...props,
                intl: intl,
                mediaOptions: mediaOptions,
                linkPickerOptions: linkPickerOptions,
                featureFlags: featureFlags,
                isEditingLocked: isEditingLocked,
                isTemplateLocked: isTemplateLocked
            });
        $[26] = featureFlags;
        $[27] = intl;
        $[28] = isEditingLocked;
        $[29] = isTemplateLocked;
        $[30] = linkPickerOptions;
        $[31] = mediaOptions;
        $[32] = props;
        $[33] = t11;
    } else t11 = $[33];
    let t12;
    if ($[34] !== contentId || $[35] !== intl || $[36] !== isEditingLocked || $[37] !== isTemplateLocked || $[38] !== linkPickerOptions || $[39] !== mediaOptions || $[40] !== props.editorPluginAIDefinitionsEnabled || $[41] !== props.editorPluginHubTextColorEnabled || $[42] !== props.hasEditPermission || $[43] !== props.isDesktop || $[44] !== props.isLoomPluginEnabled) {
        t12 = [
            intl,
            props.hasEditPermission,
            isEditingLocked,
            isTemplateLocked,
            props.isLoomPluginEnabled,
            props.editorPluginAIDefinitionsEnabled,
            props.editorPluginHubTextColorEnabled,
            props.isDesktop,
            contentId,
            mediaOptions,
            linkPickerOptions
        ];
        $[34] = contentId;
        $[35] = intl;
        $[36] = isEditingLocked;
        $[37] = isTemplateLocked;
        $[38] = linkPickerOptions;
        $[39] = mediaOptions;
        $[40] = props.editorPluginAIDefinitionsEnabled;
        $[41] = props.editorPluginHubTextColorEnabled;
        $[42] = props.hasEditPermission;
        $[43] = props.isDesktop;
        $[44] = props.isLoomPluginEnabled;
        $[45] = t12;
    } else t12 = $[45];
    const { preset: preset, editorApi: presetEditorApi } = (0, $dVPAB.usePreset)(t11, t12);
    let t13;
    let t14;
    if ($[46] !== setIsInViewMode) {
        t13 = ()=>{
            setIsInViewMode(false);
        };
        t14 = [
            setIsInViewMode
        ];
        $[46] = setIsInViewMode;
        $[47] = t13;
        $[48] = t14;
    } else {
        t13 = $[47];
        t14 = $[48];
    }
    (0, $cozmU.useEffect)(t13, t14);
    let t15;
    let t16;
    if ($[49] !== isEditingLocked || $[50] !== setIsEditingLocked) {
        t15 = ()=>{
            setIsEditingLocked(Boolean(isEditingLocked));
        };
        t16 = [
            setIsEditingLocked,
            isEditingLocked
        ];
        $[49] = isEditingLocked;
        $[50] = setIsEditingLocked;
        $[51] = t15;
        $[52] = t16;
    } else {
        t15 = $[51];
        t16 = $[52];
    }
    (0, $cozmU.useEffect)(t15, t16);
    let t17;
    let t18;
    if ($[53] !== presetEditorApi || $[54] !== setExternalEditorApi) {
        t17 = ()=>{
            setEditorApi(presetEditorApi);
            if (!setExternalEditorApi || !presetEditorApi) return;
            setExternalEditorApi(presetEditorApi);
        };
        t18 = [
            presetEditorApi,
            setExternalEditorApi
        ];
        $[53] = presetEditorApi;
        $[54] = setExternalEditorApi;
        $[55] = t17;
        $[56] = t18;
    } else {
        t17 = $[55];
        t18 = $[56];
    }
    (0, $cozmU.useEffect)(t17, t18);
    let t19;
    if ($[57] !== PropsProvider || $[58] !== additionalExtensionProviders || $[59] !== allExtensionProviders || $[60] !== closeConfigPanel || $[61] !== cloudId || $[62] !== contentId || $[63] !== editorActions || $[64] !== editorApi || $[65] !== formatMessage || $[66] !== hubExtensionProviders.length || $[67] !== isEditingLocked || $[68] !== preset || $[69] !== props || $[70] !== selectedExtensionLocalId || $[71] !== userId) {
        t19 = (linkingFeatures)=>hubExtensionProviders.length > 0 && additionalExtensionProviders.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jlRK6.ComposableEditor), {
                appearance: "full-page",
                ...linkingFeatures,
                ...props,
                disabled: isEditingLocked,
                preset: preset,
                ...allExtensionProviders.length > 0 ? {
                    extensionProviders: allExtensionProviders
                } : {},
                editorActions: editorActions,
                contextPanel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2VrNo.HubEditorConfigPanelEntryPoint), {
                    localId: selectedExtensionLocalId || "",
                    closeConfigPanel: closeConfigPanel,
                    editorActions: editorActions,
                    contentId: contentId,
                    editorApi: editorApi,
                    propsProvider: PropsProvider
                }),
                emojiProvider: (0, $kETeF.getEmojiProvider)({
                    cloudId: cloudId,
                    userId: userId
                })
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
                name: "hub-extensions-loader"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $2105bf85746b7ad8$var$hubEditorStyles.spinnerContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
                size: "large",
                label: formatMessage((0, $8XweJ.default).hubStudioLoadingSpinnerLabel)
            })));
        $[57] = PropsProvider;
        $[58] = additionalExtensionProviders;
        $[59] = allExtensionProviders;
        $[60] = closeConfigPanel;
        $[61] = cloudId;
        $[62] = contentId;
        $[63] = editorActions;
        $[64] = editorApi;
        $[65] = formatMessage;
        $[66] = hubExtensionProviders.length;
        $[67] = isEditingLocked;
        $[68] = preset;
        $[69] = props;
        $[70] = selectedExtensionLocalId;
        $[71] = userId;
        $[72] = t19;
    } else t19 = $[72];
    let t20;
    if ($[73] !== cloudId || $[74] !== linkPickerOptions || $[75] !== product || $[76] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8NddB.EditorLinkingFeatures), {
            product: product,
            cloudId: cloudId,
            options: (0, $fXxXz.LINKING_FEATURES_CARD_OPTIONS),
            linkPickerOptions: linkPickerOptions
        }, t19);
        $[73] = cloudId;
        $[74] = linkPickerOptions;
        $[75] = product;
        $[76] = t19;
        $[77] = t20;
    } else t20 = $[77];
    let t21;
    if ($[78] !== product || $[79] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c2Doe.SmartCardProvider), {
            product: product,
            client: smartCardClient
        }, t20);
        $[78] = product;
        $[79] = t20;
        $[80] = t21;
    } else t21 = $[80];
    return t21;
} : (props)=>{
    const intl = (0, $kSwu1.useIntl)();
    const [editorApi, setEditorApi] = (0, $cozmU.useState)(undefined);
    const { editorActions: editorActions, contentId: contentId, userId: userId, cloudId: cloudId, product: product, mediaProvider: mediaProvider, setExternalEditorApi: setExternalEditorApi, additionalExtensionProviders: additionalExtensionProviders = [], loadAdditionalExtensionProviders: loadAdditionalExtensionProviders, onExtensionProvidersLoaded: onExtensionProvidersLoaded, PropsProvider: PropsProvider, linkPickerOptions: linkPickerOptions, isEditingLocked: isEditingLocked, isTemplateLocked: isTemplateLocked } = props;
    const smartCardClient = (0, $cozmU.useMemo)(()=>new (0, $4yccB.default)(), []);
    const { pageMediaConfig: pageMediaConfig } = (0, $r8hvx.useHubContext)();
    const { closeConfigPanel: closeConfigPanel, openConfigPanel: openConfigPanel } = (0, $9tqV4.useHubEditorExtensionConfigPanel)(editorActions);
    const [{ selectedExtensionLocalId: selectedExtensionLocalId }] = (0, $bIp5p.useExtensionsState)();
    const { setIsInViewMode: setIsInViewMode, setIsEditingLocked: setIsEditingLocked } = (0, $bIp5p.useExtensionsActions)();
    const { featureFlags: featureFlags } = (0, $r8hvx.useHubContext)();
    const hubExtensionProviders = (0, $jcnIS.useHubExtensionProviders)({
        contentId: contentId,
        intl: intl,
        PropsProvider: PropsProvider,
        editorActions: editorActions,
        openConfigPanel: openConfigPanel
    });
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)(); // Load additional extension providers when editor is ready; we need to inject
    // editor-specific props
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (loadAdditionalExtensionProviders && editorActions) loadAdditionalExtensionProviders({
            editorActions: editorActions,
            openConfigPanel: openConfigPanel
        });
    }, [
        loadAdditionalExtensionProviders,
        editorActions,
        openConfigPanel
    ]);
    // Combine hub extensions with additional extensions
    const allExtensionProviders = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        return [
            ...hubExtensionProviders,
            ...additionalExtensionProviders
        ];
    }, [
        hubExtensionProviders,
        additionalExtensionProviders
    ]); // Notify parent when all extension providers (hub + additional) are available
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (onExtensionProvidersLoaded && allExtensionProviders.length > 0) onExtensionProvidersLoaded(allExtensionProviders);
    }, [
        onExtensionProvidersLoaded,
        allExtensionProviders
    ]);
    const mediaOptions = (0, $2rwbd.useMediaOptions)({
        contentId: contentId,
        editorAPI: editorApi,
        customMediaProvider: mediaProvider,
        mediaConfig: pageMediaConfig
    });
    const { preset: preset, editorApi: presetEditorApi } = (0, $dVPAB.usePreset)(()=>{
        return (0, $9YzZs.createHubEditorPreset)({
            ...props,
            intl: intl,
            mediaOptions: mediaOptions,
            linkPickerOptions: linkPickerOptions,
            featureFlags: featureFlags,
            isEditingLocked: isEditingLocked,
            isTemplateLocked: isTemplateLocked
        });
    }, [
        intl,
        props.hasEditPermission,
        isEditingLocked,
        isTemplateLocked,
        props.isLoomPluginEnabled,
        props.editorPluginAIDefinitionsEnabled,
        props.editorPluginHubTextColorEnabled,
        props.isDesktop,
        contentId,
        mediaOptions,
        linkPickerOptions
    ]);
    (0, $cozmU.useEffect)(()=>{
        setIsInViewMode(false);
    }, [
        setIsInViewMode
    ]); // Shared with extensions so their own edit affordances match the editor's lock.
    (0, $cozmU.useEffect)(()=>{
        setIsEditingLocked(Boolean(isEditingLocked));
    }, [
        setIsEditingLocked,
        isEditingLocked
    ]);
    (0, $cozmU.useEffect)(()=>{
        setEditorApi(presetEditorApi);
        if (!setExternalEditorApi || !presetEditorApi) return;
        setExternalEditorApi(presetEditorApi);
    }, [
        presetEditorApi,
        setExternalEditorApi
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c2Doe.SmartCardProvider), {
        product: product,
        client: smartCardClient
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8NddB.EditorLinkingFeatures), {
        product: product,
        cloudId: cloudId,
        options: (0, $fXxXz.LINKING_FEATURES_CARD_OPTIONS),
        linkPickerOptions: linkPickerOptions
    }, (linkingFeatures)=>{
        return hubExtensionProviders.length > 0 && additionalExtensionProviders.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jlRK6.ComposableEditor), {
            appearance: "full-page",
            ...linkingFeatures,
            ...props,
            disabled: isEditingLocked,
            preset: preset,
            ...allExtensionProviders.length > 0 ? {
                extensionProviders: allExtensionProviders
            } : {},
            editorActions: editorActions,
            contextPanel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2VrNo.HubEditorConfigPanelEntryPoint), {
                localId: selectedExtensionLocalId || '',
                closeConfigPanel: closeConfigPanel,
                editorActions: editorActions,
                contentId: contentId,
                editorApi: editorApi,
                propsProvider: PropsProvider
            }),
            emojiProvider: (0, $kETeF.getEmojiProvider)({
                cloudId: cloudId,
                userId: userId
            })
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "hub-extensions-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $2105bf85746b7ad8$var$hubEditorStyles.spinnerContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: 'large',
            label: formatMessage((0, $8XweJ.default).hubStudioLoadingSpinnerLabel)
        })));
    }));
};
const $2105bf85746b7ad8$var$HubEditor = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eDML.GenericErrorPage), null);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ame4Z.HubErrorBoundary), {
            packageName: "@atlassian/hub-editor",
            id: "hub-editor",
            fallback: t0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7j1D.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $faAj4.default), {
            render: (editorActions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2105bf85746b7ad8$var$EditorInternal, {
                    editorActions: editorActions,
                    ...props
                })
        })));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ame4Z.HubErrorBoundary), {
        packageName: "@atlassian/hub-editor",
        id: "hub-editor",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eDML.GenericErrorPage), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7j1D.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $faAj4.default), {
        render: (editorActions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2105bf85746b7ad8$var$EditorInternal, {
                editorActions: editorActions,
                ...props
            })
    })));
};
var $2105bf85746b7ad8$export$2e2bcd8739ae039 = $2105bf85746b7ad8$var$HubEditor;
module.exports["default"] = $2105bf85746b7ad8$export$2e2bcd8739ae039;

});

parcelRegister("bUMKD", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $bab760cfbd2a476f$export$efc60a58bfe62d46 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "CsDwr",
    name: "ExternalSharePageLoader",
    loader: async ()=>(await (parcelRequire("bT8wR"))).ExternalSharePage
});
module.exports["ExternalSharePageLoader"] = $bab760cfbd2a476f$export$efc60a58bfe62d46;

});

parcelRegister("6fVzX", function(module, exports) {
const $48e0cec07a1313a2$var$VALID_LINK_TYPES = [
    'a',
    'button'
];
const $48e0cec07a1313a2$export$855ece989b15eb57 = (type)=>$48e0cec07a1313a2$var$VALID_LINK_TYPES.includes(type) ? type : 'a';
module.exports["getValidLinkType"] = $48e0cec07a1313a2$export$855ece989b15eb57;

});

parcelRegister("et2nj", function(module, exports) {
const $83b16c63dab14b97$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $83b16c63dab14b97$export$130b789831072f4c = (event)=>[
        'keypress',
        'keydown',
        'keyup'
    ].includes(event.type);


const $a8859dbb9c1926d9$export$706ad1af8096e280 = (event, { onClick: onClick, target: target, replace: replace, routerActions: routerActions, href: href, to: to, state: state })=>{
    if ((0, $83b16c63dab14b97$export$130b789831072f4c)(event) && event.key !== 'Enter') return;
    onClick && onClick(event);
    if (!event.defaultPrevented && // onClick prevented default
    ((0, $83b16c63dab14b97$export$130b789831072f4c)(event) && event.key === 'Enter' || event.button === 0) && // ignore everything but left clicks and Enter key
    (!target || target === '_self') && // let browser handle "target=_blank" etc.
    !(0, $83b16c63dab14b97$export$642c6f14f6d4bbd5)(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        if (to) {
            const method = replace ? routerActions.replaceTo : routerActions.pushTo;
            method(...to, state);
        } else {
            const method = replace ? routerActions.replace : routerActions.push;
            method(href, state);
        }
    }
};
module.exports["handleNavigation"] = $a8859dbb9c1926d9$export$706ad1af8096e280;

});

parcelRegister("9RVC0", function(module, exports) {
const $72f5c0d3161385ca$export$9ccb639b7a119f61 = ()=>Date.now();
module.exports["getAccessedAt"] = $72f5c0d3161385ca$export$9ccb639b7a119f61;

});

parcelRegister("lHNk5", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $ayVUo = parcelRequire("ayVUo");


var $lTQd7 = parcelRequire("lTQd7");


var $e2AvM = parcelRequire("e2AvM");


var $dV1xE = parcelRequire("dV1xE");

const $2e024aa0d080fc95$export$37d3126be6549b13 = 10000;


function $fcd3df9f15446c01$export$dc62515c8f0b52dd({ context: context, dependencies: dependencies, options: options, resource: resource, routerStoreContext: routerStoreContext }) {
    var _promiseOrData, _resource$maxAge;
    const { type: type, getData: getData } = resource;
    const { prefetch: prefetch, timeout: timeout } = options;
    // hard errors in dependencies or getData are converted into softer async error
    let promiseOrData;
    try {
        promiseOrData = getData((0, $eb3ax.default)({}, routerStoreContext, {
            isPrefetch: !!prefetch,
            dependencies: dependencies()
        }), context);
    } catch (error) {
        promiseOrData = Promise.reject(error);
    }
    // ensure the promise includes any timeout error
    const timeoutGuard = timeout ? (0, $e2AvM.generateTimeGuard)(timeout) : null;
    // check if getData was sync, by looking for a Promise-like shape
    const data = typeof ((_promiseOrData = promiseOrData) == null ? void 0 : _promiseOrData.then) === 'function' ? undefined : promiseOrData;
    const promise = timeout ? Promise.race([
        promiseOrData,
        timeoutGuard == null ? void 0 : timeoutGuard.promise
    ]).then((maybeData)=>{
        if (timeoutGuard && !timeoutGuard.isPending) throw new (0, $dV1xE.TimeoutError)(type);
        (timeoutGuard == null ? void 0 : timeoutGuard.timerId) && clearTimeout(timeoutGuard.timerId);
        return maybeData;
    }) : // if we already have a result, wrap it so consumers can access it via same API
    data !== undefined ? Promise.resolve(data) : promiseOrData;
    const resourceMaxAge = (0, $lTQd7.getExpiresAt)((_resource$maxAge = resource.maxAge) != null ? _resource$maxAge : (0, $ayVUo.DEFAULT_RESOURCE_MAX_AGE));
    return {
        promise: promise,
        data: data,
        expiresAt: prefetch ? Math.max(resourceMaxAge, (0, $lTQd7.getExpiresAt)((0, $2e024aa0d080fc95$export$37d3126be6549b13))) : resourceMaxAge
    };
}
module.exports["createLoadingSlice"] = $fcd3df9f15446c01$export$dc62515c8f0b52dd;

});

parcelRegister("231PG", function(module, exports) {

var $ayVUo = parcelRequire("ayVUo");

/**
 * Utility method to created async versions of getData functions
 */ const $17dd48841fdc286a$var$handleGetDataLoader = (asyncImport)=>async (...args)=>{
        const { default: getDataFn } = await asyncImport();
        return getDataFn(...args);
    };
const $17dd48841fdc286a$export$edd172c6c83c39cc = (arg)=>{
    var _getData, _arg$depends;
    return {
        type: arg.type,
        getKey: arg.getKey,
        getData: (_getData = arg.getData) != null ? _getData : $17dd48841fdc286a$var$handleGetDataLoader(arg.getDataLoader),
        maxAge: typeof arg.maxAge === 'number' ? arg.maxAge : (0, $ayVUo.DEFAULT_RESOURCE_MAX_AGE),
        maxCache: typeof arg.maxCache === 'number' ? arg.maxCache : (0, $ayVUo.DEFAULT_CACHE_MAX_LIMIT),
        isBrowserOnly: typeof arg.isBrowserOnly === 'boolean' ? arg.isBrowserOnly : (0, $ayVUo.DEFAULT_RESOURCE_BROWSER_ONLY),
        depends: (_arg$depends = arg.depends) != null ? _arg$depends : null
    };
};

});

parcelRegister("8RoZS", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $htr8O = parcelRequire("htr8O");


var $iiKpy = parcelRequire("iiKpy");

var $6736a9db7ca34e4c$var$_Object$fromEntries;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
const $6736a9db7ca34e4c$var$fromEntries = ($6736a9db7ca34e4c$var$_Object$fromEntries = Object.fromEntries) != null ? $6736a9db7ca34e4c$var$_Object$fromEntries : (entries)=>Object.assign({}, ...entries.map(([k, v])=>({
            [k]: v
        })));
const $6736a9db7ca34e4c$var$matchType = (a)=>(b)=>{
        const [{ type: typeA }] = Array.isArray(a) ? a : [
            a
        ];
        const [{ type: typeB }] = Array.isArray(b) ? b : [
            b
        ];
        return typeA === typeB;
    };
class $6736a9db7ca34e4c$export$492ad57edfe1e919 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResourceDependencyError';
    }
}
const $6736a9db7ca34e4c$export$12600f2e0e7fb2cc = (routeResources, tuples)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        var _routeResources$some;
        if (getState().executing) throw new Error('execution is already in progress');
        // check if there are resources and if so if there are any resources with dependencies
        const hasDependentResources = (_routeResources$some = routeResources == null ? void 0 : routeResources.some(({ depends: depends })=>depends == null ? void 0 : depends.length)) != null ? _routeResources$some : false;
        if (!hasDependentResources) return tuples.map(([, action])=>dispatch(action));
        // some resources might not be listed on the route resources so must be dispatched separate from executing state
        const listedTuples = tuples.filter(([resource])=>routeResources == null ? void 0 : routeResources.some($6736a9db7ca34e4c$var$matchType(resource)));
        if (listedTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // accumulate the dependency types for all executing resources
        // find downstream resources that may also execute and include their dependencies too
        // include the resource type as well in the list
        // we don't validate that these are legal dependencies
        const [dependentTypes] = routeResources.reduce((acc, { type: type, depends: depends })=>{
            const [dependencies, executableTypes] = acc;
            const isExecutable = executableTypes.includes(type) || !!(depends != null && depends.some((dependency)=>executableTypes.includes(dependency)));
            return isExecutable ? [
                depends ? [
                    ...dependencies,
                    ...depends,
                    type
                ] : dependencies,
                [
                    ...executableTypes,
                    type
                ]
            ] : acc;
        }, [
            [],
            listedTuples.map(([{ type: type }])=>type)
        ]).filter((v, i, a)=>a.indexOf(v) === i);
        // resources that are completely independent are preferable to be dispatched separate from executing state
        const dependentTuples = listedTuples.filter(([{ type: type }])=>dependentTypes.includes(type));
        if (dependentTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // additionally find all direct dependencies of these executing or possibly executing resources
        // we don't validate that these are legal dependencies
        const dependentAndDependencyTypes = routeResources.filter(({ type: type })=>dependentTypes.includes(type)).reduce((acc, { type: type, depends: depends })=>depends ? [
                ...acc,
                ...depends,
                type
            ] : [
                ...acc,
                type
            ], []).filter((v, i, a)=>a.indexOf(v) === i);
        // setup executing tuples in route resource order
        // this state allows actions to call executeForDependents() to influence actions that follow
        // the list includes dependency resources so that getDependencies() may validate without needing route resources
        // we use the resource definition of the given tuple where present or otherwise the definition from route resources
        const executingTuples = routeResources.filter(({ type: type })=>dependentAndDependencyTypes.includes(type)).map((resource)=>{
            var _tuples$find;
            return (_tuples$find = tuples.find($6736a9db7ca34e4c$var$matchType(resource))) != null ? _tuples$find : [
                resource,
                null
            ];
        });
        setState({
            executing: executingTuples
        });
        // dispatch sequentially during which executeForDependents() can cause tuples to change
        const executedResults = executingTuples.map(([{ type: expectedType }], i)=>{
            var _getState$executing;
            const latestTuple = (_getState$executing = getState().executing) == null ? void 0 : _getState$executing[i];
            const [{ type: latestType }, maybeAction] = latestTuple != null ? latestTuple : [
                {}
            ];
            if (latestType !== expectedType) {
                setState({
                    executing: null
                });
                throw new Error('execution reached an inconsistent state');
            }
            return maybeAction ? dispatch(maybeAction) : undefined;
        });
        setState({
            executing: null
        });
        // pick existing execution result or dispatch any remaining independent actions
        return tuples.map(([resource, action])=>{
            const index = executingTuples.findIndex($6736a9db7ca34e4c$var$matchType(resource));
            return index < 0 ? dispatch(action) : executedResults[index];
        });
    };
const $6736a9db7ca34e4c$export$5f7e1fd85734e71e = (routeResources, resource, action)=>({ dispatch: dispatch })=>dispatch($6736a9db7ca34e4c$export$12600f2e0e7fb2cc(routeResources, [
            [
                resource,
                action
            ]
        ]))[0];
const $6736a9db7ca34e4c$export$f71a65c89c987a02 = (routeResources, resources, actionCreator)=>$6736a9db7ca34e4c$export$12600f2e0e7fb2cc(routeResources, resources.map((resource)=>[
            resource,
            actionCreator(resource)
        ]));
const $6736a9db7ca34e4c$export$7d1ffac63c68405d = (resource, actionCreator)=>({ getState: getState, setState: setState })=>{
        var _tuples$findIndex;
        const { executing: tuples } = getState();
        // find the given resource in the currently executing tuples
        const indexForResource = (_tuples$findIndex = tuples == null ? void 0 : tuples.findIndex($6736a9db7ca34e4c$var$matchType(resource))) != null ? _tuples$findIndex : -1;
        if (indexForResource < 0) return;
        // find dependent resources following given resource and revise their action
        const executing = tuples.map((tuple, i)=>{
            var _tupleResource$depend;
            const [tupleResource] = tuple;
            return i > indexForResource && (_tupleResource$depend = tupleResource.depends) != null && _tupleResource$depend.includes(resource.type) ? [
                tupleResource,
                actionCreator(tupleResource)
            ] : tuple;
        });
        setState({
            executing: executing
        });
    };
const $6736a9db7ca34e4c$export$75915f81f2a6540a = (resource, routerStoreContext, options)=>({ getState: getState, dispatch: dispatch })=>{
        var _tuples$findIndex2;
        const { type: type, depends: depends } = resource;
        // optimise the case of no dependencies
        if (!(depends != null && depends.length)) return {};
        const { executing: tuples, context: resourceStoreContext } = getState();
        // dependent resource cannot be called outside execution state
        // find the given resource type in the currently executing tuples
        const indexForResource = (_tuples$findIndex2 = tuples == null ? void 0 : tuples.findIndex($6736a9db7ca34e4c$var$matchType(resource))) != null ? _tuples$findIndex2 : -1;
        if (indexForResource < 0) throw new $6736a9db7ca34e4c$export$492ad57edfe1e919(`Missing resource: "${type}" has dependencies so must not be missing`);
        // find tuples index for all the dependency elements
        const dependencyIndexTuples = depends.map((dependency)=>[
                dependency,
                tuples.findIndex($6736a9db7ca34e4c$var$matchType({
                    type: dependency
                }))
            ]);
        // we rely on executing tuples including all dependencies of the caller resource
        dependencyIndexTuples.forEach(([dependency, index])=>{
            if (index < 0) throw new $6736a9db7ca34e4c$export$492ad57edfe1e919(`Missing resource: "${type}" depends "${dependency}" which is missing`);
            if (index > indexForResource) throw new $6736a9db7ca34e4c$export$492ad57edfe1e919(`Illegal dependency: "${type}" depends "${dependency}" so "${dependency}" must precede "${type}"`);
        });
        return $6736a9db7ca34e4c$var$fromEntries(dependencyIndexTuples.map(([dependencyType, index])=>{
            const { getKey: getKey } = tuples[index][0];
            const key = getKey(routerStoreContext, resourceStoreContext);
            let slice = dispatch((0, $iiKpy.getResourceState)(dependencyType, key)) || (0, $htr8O.getDefaultStateSlice)();
            // when prefetching we provide only the promise to dependands
            const prefetchSlice = options.prefetch ? dispatch((0, $iiKpy.getPrefetchSlice)(dependencyType, key)) : undefined;
            if (prefetchSlice) slice = (0, $eb3ax.default)({}, slice, {
                // not spreading prefetchSlice to persist previous slice data
                promise: prefetchSlice.promise,
                expiresAt: prefetchSlice.expiresAt,
                loading: true
            });
            return [
                dependencyType,
                slice
            ];
        }));
    };
module.exports["actionWithDependencies"] = $6736a9db7ca34e4c$export$5f7e1fd85734e71e;
module.exports["mapActionWithDependencies"] = $6736a9db7ca34e4c$export$f71a65c89c987a02;
module.exports["executeForDependents"] = $6736a9db7ca34e4c$export$7d1ffac63c68405d;
module.exports["getDependencies"] = $6736a9db7ca34e4c$export$75915f81f2a6540a;

});

parcelRegister("lTQd7", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");

const $ff173bfb28e1acd4$export$b65d7ba7fbf150f1 = (maxAge)=>Date.now() + maxAge;
const $ff173bfb28e1acd4$export$18d1d420fd588368 = (slice, maxAge)=>slice.expiresAt === null ? (0, $eb3ax.default)({}, slice, {
        expiresAt: $ff173bfb28e1acd4$export$b65d7ba7fbf150f1(maxAge)
    }) : slice;
module.exports["getExpiresAt"] = $ff173bfb28e1acd4$export$b65d7ba7fbf150f1;
module.exports["setExpiresAt"] = $ff173bfb28e1acd4$export$18d1d420fd588368;

});

parcelRegister("e2AvM", function(module, exports) {
const $a38d930b50e2721e$export$58634b3a58ae66b7 = (duration)=>{
    const promiseState = {
        timerId: null,
        isPending: true,
        promise: undefined
    };
    promiseState.promise = new Promise((r)=>{
        const timerId = setTimeout(()=>{
            promiseState.isPending = false;
            r();
        }, duration);
        promiseState.timerId = timerId;
    });
    return promiseState;
};
module.exports["generateTimeGuard"] = $a38d930b50e2721e$export$58634b3a58ae66b7;

});

parcelRegister("htr8O", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $9RVC0 = parcelRequire("9RVC0");


var $ayVUo = parcelRequire("ayVUo");


var $lTQd7 = parcelRequire("lTQd7");

/**
 * The base defaults which should be fed into any factory that needs to derive other props.
 */ const $a37958bdf929e185$export$2df85a734ff5ed27 = {
    data: null,
    error: null,
    loading: false,
    promise: null
};


const $cb8a32c52501d499$export$fa8e33c3301e2e94 = ()=>(0, $eb3ax.default)({}, (0, $a37958bdf929e185$export$2df85a734ff5ed27), {
        expiresAt: (0, $lTQd7.getExpiresAt)((0, $ayVUo.DEFAULT_RESOURCE_MAX_AGE)),
        accessedAt: (0, $9RVC0.getAccessedAt)()
    });
module.exports["getDefaultStateSlice"] = $cb8a32c52501d499$export$fa8e33c3301e2e94;

});

parcelRegister("6gRks", function(module, exports) {
const $490d9ab8531b6967$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $490d9ab8531b6967$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$490d9ab8531b6967$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));
module.exports["getResourceIdentifier"] = $490d9ab8531b6967$export$c616b176adf9ad4a;
module.exports["getResourceIdentifiers"] = $490d9ab8531b6967$export$cd7fbe7e979df558;

});

parcelRegister("hNpL3", function(module, exports) {

var $6gRks = parcelRequire("6gRks");


var $koXzF = parcelRequire("koXzF");

const $cf4afe494b6c8347$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $koXzF.routeHasResources)(nextRoute)) return [];
    if ((0, $koXzF.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $6gRks.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $6gRks.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};
module.exports["getResourcesForNextLocation"] = $cf4afe494b6c8347$export$7cbbc763e2f3d65d;

});

parcelRegister("7kOId", function(module, exports) {

var $iiKpy = parcelRequire("iiKpy");

const $5571bd0df36ef9b1$export$65824bf86829963 = (routeResourceDataForType, currentKey)=>Object.keys(routeResourceDataForType).filter((resourceDataKey)=>{
        const { [resourceDataKey]: { expiresAt: expiresAt } } = routeResourceDataForType;
        return resourceDataKey !== currentKey && expiresAt && expiresAt <= Date.now();
    });
const $5571bd0df36ef9b1$export$6288d3096045088f = (maxCache, resourceDataForType, currentKey)=>{
    if (maxCache === Infinity || maxCache < 1) return null;
    const resourceDataKeys = Object.keys(resourceDataForType);
    if (resourceDataKeys.length < maxCache) return null;
    const expiredResourceDataKeys = $5571bd0df36ef9b1$export$65824bf86829963(resourceDataForType, currentKey);
    if (expiredResourceDataKeys.length > 0) return expiredResourceDataKeys[0];
    return resourceDataKeys.reduce((leastRecentKey, key)=>{
        const { [key]: { accessedAt: accessedAt }, [leastRecentKey]: { accessedAt: leastRecentAccessedAt } } = resourceDataForType;
        if (accessedAt && leastRecentAccessedAt && accessedAt < leastRecentAccessedAt) return key;
        return leastRecentKey;
    }, resourceDataKeys[0]);
};
const $5571bd0df36ef9b1$export$89440b7623c2c75c = (resource, key)=>({ getState: getState, dispatch: dispatch })=>{
        const { type: type, maxCache: maxCache } = resource;
        const { data: { [type]: resourceDataForType } } = getState();
        if (!resourceDataForType) return;
        const keyTobeDeleted = $5571bd0df36ef9b1$export$6288d3096045088f(maxCache, resourceDataForType, key);
        if (!keyTobeDeleted) return;
        dispatch((0, $iiKpy.deleteResourceState)(type, keyTobeDeleted));
    };
module.exports["validateLRUCache"] = $5571bd0df36ef9b1$export$89440b7623c2c75c;

});

parcelRegister("iiKpy", function(module, exports) {

var $1eVGO = parcelRequire("1eVGO");


var $eb3ax = parcelRequire("eb3ax");

function $d52de8b966e6efd1$var$_toPropertyKey(t) {
    var i = $d52de8b966e6efd1$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : String(i);
}
function $d52de8b966e6efd1$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $d52de8b966e6efd1$export$11374758be89e40 = (type, key)=>({ getState: getState })=>{
        var _prefetching$type;
        const { prefetching: prefetching } = getState();
        const slice = prefetching == null || (_prefetching$type = prefetching[type]) == null ? void 0 : _prefetching$type[key];
        // check if slice is still fresh
        if (slice && Date.now() < Number(slice.expiresAt)) return slice;
        return undefined;
    };
const $d52de8b966e6efd1$export$1e32615dc8354436 = (type, key, slice)=>({ setState: setState, getState: getState })=>{
        var _prefetching$type2, _slice$promise;
        const { prefetching: prefetching } = getState();
        // avoid doing extra set if same value
        if ((prefetching == null || (_prefetching$type2 = prefetching[type]) == null ? void 0 : _prefetching$type2[key]) === slice) return;
        // cheap optimisation to provide prefetched result syncronously
        slice == null || (_slice$promise = slice.promise) == null || _slice$promise.then((maybeData)=>slice.data = maybeData);
        setState({
            prefetching: (0, $eb3ax.default)({}, prefetching, {
                [type]: (0, $eb3ax.default)({}, prefetching == null ? void 0 : prefetching[type], {
                    [key]: slice
                })
            })
        });
    };
const $d52de8b966e6efd1$export$704f800f263b050e = (type, key, state)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { data: data } = getState();
        // every time we override a resource we kill its prefetched
        dispatch($d52de8b966e6efd1$export$1e32615dc8354436(type, key, undefined));
        setState({
            data: (0, $eb3ax.default)({}, data, {
                [type]: (0, $eb3ax.default)({}, data[type] || {}, {
                    [key]: state
                })
            })
        });
    };
const $d52de8b966e6efd1$export$5fc90c33b03fffb = (type, key)=>({ getState: getState })=>{
        const { data: { [type]: resourceDataForType } } = getState();
        return resourceDataForType == null ? void 0 : resourceDataForType[key];
    };
const $d52de8b966e6efd1$export$d40f35dc5952864b = (type, key)=>({ getState: getState, setState: setState })=>{
        const { data: data } = getState();
        const { [type]: resourceForType } = data, remainingData = (0, $1eVGO.default)(data, [
            type
        ].map($d52de8b966e6efd1$var$_toPropertyKey));
        if (key === undefined) setState({
            data: remainingData
        });
        else if (resourceForType) {
            const remainingForType = (0, $1eVGO.default)(resourceForType, [
                key
            ].map($d52de8b966e6efd1$var$_toPropertyKey));
            setState({
                data: (0, $eb3ax.default)({}, remainingData, {
                    [type]: remainingForType
                })
            });
        }
    };
module.exports["getPrefetchSlice"] = $d52de8b966e6efd1$export$11374758be89e40;
module.exports["setPrefetchSlice"] = $d52de8b966e6efd1$export$1e32615dc8354436;
module.exports["setResourceState"] = $d52de8b966e6efd1$export$704f800f263b050e;
module.exports["getResourceState"] = $d52de8b966e6efd1$export$5fc90c33b03fffb;
module.exports["deleteResourceState"] = $d52de8b966e6efd1$export$d40f35dc5952864b;

});

parcelRegister("koXzF", function(module, exports) {
const $eda442c6180d8a83$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $eda442c6180d8a83$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;
module.exports["routeHasResources"] = $eda442c6180d8a83$export$740886389191c640;
module.exports["routeHasChanged"] = $eda442c6180d8a83$export$221027ff1aa38f82;

});

parcelRegister("hBrfJ", function(module, exports) {
// NOTE! This has been copy pasted from https://github.com/sindresorhus/serialize-error/blob/master/index.js
// When the router moves to its own package, this must become a dependency
// For now, we have put it here so that we don't need to get it included in Jira's vendor bundle
class $cd0b08331022c28a$var$NonError extends Error {
    constructor(message){
        super(message);
        this.name = 'NonError';
        if (Error.captureStackTrace) Error.captureStackTrace(this, $cd0b08331022c28a$var$NonError);
    }
}
const $cd0b08331022c28a$var$commonProperties = [
    'name',
    'message',
    'stack',
    'code'
];
const $cd0b08331022c28a$var$destroyCircular = (from, seen, to_)=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof value === 'function') continue;
        if (!value || typeof value !== 'object') {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            to[key] = $cd0b08331022c28a$var$destroyCircular(from[key], seen.slice());
            continue;
        }
        to[key] = '[Circular]';
    }
    for (const property of $cd0b08331022c28a$var$commonProperties)if (typeof from[property] === 'string') to[property] = from[property];
    return to;
};
const $cd0b08331022c28a$export$46ff38bc6bdea8fb = (value)=>{
    if (typeof value === 'object' && value !== null) return $cd0b08331022c28a$var$destroyCircular(value, []);
    // People sometimes throw things besides Error objects…
    if (typeof value === 'function') // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || 'anonymous'}]`;
    return value;
};
const $cd0b08331022c28a$export$64cddc1e268e9046 = (value)=>{
    if (value instanceof Error) return value;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        $cd0b08331022c28a$var$destroyCircular(value, [], newError);
        return newError;
    }
    return new $cd0b08331022c28a$var$NonError(value);
};
module.exports["serializeError"] = $cd0b08331022c28a$export$46ff38bc6bdea8fb;
module.exports["deserializeError"] = $cd0b08331022c28a$export$64cddc1e268e9046;

});

parcelRegister("8Z7ra", function(module, exports) {
const $68a9ca20984f3164$export$b25d2963b8a3488a = ({ expiresAt: expiresAt })=>expiresAt === null;
const $68a9ca20984f3164$var$isFresh = (resource)=>{
    if ($68a9ca20984f3164$export$b25d2963b8a3488a(resource)) return true;
    return Date.now() < Number(resource.expiresAt);
};
const $68a9ca20984f3164$export$399de8c43d0ece3c = (resource)=>{
    var _resource$error;
    if ((resource == null || (_resource$error = resource.error) == null ? void 0 : _resource$error.name) === 'TimeoutError') return false;
    if (resource.loading) return true;
    if ($68a9ca20984f3164$var$isFresh(resource)) return true;
    return false;
};
module.exports["isFromSsr"] = $68a9ca20984f3164$export$b25d2963b8a3488a;
module.exports["shouldUseCache"] = $68a9ca20984f3164$export$399de8c43d0ece3c;

});

parcelRegister("8jRWn", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");

const $60e9f087f6ede995$export$2e4da1b414980956 = (slice)=>slice.promise === null ? (0, $eb3ax.default)({}, slice, {
        promise: Promise.resolve(slice.data)
    }) : slice;
module.exports["setSsrDataPromise"] = $60e9f087f6ede995$export$2e4da1b414980956;

});

parcelRegister("dV1xE", function(module, exports) {
class $a221cb6617a20e07$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super('Resource timed out: ' + message);
        this.name = 'TimeoutError';
    }
}
module.exports["TimeoutError"] = $a221cb6617a20e07$export$66d311bf29d5c89c;

});

parcelRegister("5aFDI", function(module, exports) {
const $3c3e2fb015a18dfb$export$3ceb62baab058c6b = (data, transformer)=>Object.keys(data).reduce((acc, type)=>{
        if (!acc[type]) acc[type] = {};
        Object.keys(data[type]).forEach((key)=>{
            const slice = data[type][key];
            acc[type][key] = transformer(slice);
        });
        return acc;
    }, {});
module.exports["transformData"] = $3c3e2fb015a18dfb$export$3ceb62baab058c6b;

});

parcelRegister("hq2yE", function(module, exports) {
$parcel$export(module.exports, "getAccessedAt", () => (parcelRequire("9RVC0")).getAccessedAt);
$parcel$export(module.exports, "createLoadingSlice", () => (parcelRequire("lHNk5")).createLoadingSlice);
$parcel$export(module.exports, "actionWithDependencies", () => (parcelRequire("8RoZS")).actionWithDependencies);
$parcel$export(module.exports, "mapActionWithDependencies", () => (parcelRequire("8RoZS")).mapActionWithDependencies);
$parcel$export(module.exports, "executeForDependents", () => (parcelRequire("8RoZS")).executeForDependents);
$parcel$export(module.exports, "getDependencies", () => (parcelRequire("8RoZS")).getDependencies);
$parcel$export(module.exports, "getExpiresAt", () => (parcelRequire("lTQd7")).getExpiresAt);
$parcel$export(module.exports, "setExpiresAt", () => (parcelRequire("lTQd7")).setExpiresAt);
$parcel$export(module.exports, "getDefaultStateSlice", () => (parcelRequire("htr8O")).getDefaultStateSlice);
$parcel$export(module.exports, "getResourcesForNextLocation", () => (parcelRequire("hNpL3")).getResourcesForNextLocation);
$parcel$export(module.exports, "validateLRUCache", () => (parcelRequire("7kOId")).validateLRUCache);
$parcel$export(module.exports, "deleteResourceState", () => (parcelRequire("iiKpy")).deleteResourceState);
$parcel$export(module.exports, "getResourceState", () => (parcelRequire("iiKpy")).getResourceState);
$parcel$export(module.exports, "setResourceState", () => (parcelRequire("iiKpy")).setResourceState);
$parcel$export(module.exports, "getPrefetchSlice", () => (parcelRequire("iiKpy")).getPrefetchSlice);
$parcel$export(module.exports, "setPrefetchSlice", () => (parcelRequire("iiKpy")).setPrefetchSlice);
$parcel$export(module.exports, "serializeError", () => (parcelRequire("hBrfJ")).serializeError);
$parcel$export(module.exports, "deserializeError", () => (parcelRequire("hBrfJ")).deserializeError);
$parcel$export(module.exports, "shouldUseCache", () => (parcelRequire("8Z7ra")).shouldUseCache);
$parcel$export(module.exports, "isFromSsr", () => (parcelRequire("8Z7ra")).isFromSsr);
$parcel$export(module.exports, "setSsrDataPromise", () => (parcelRequire("8jRWn")).setSsrDataPromise);
$parcel$export(module.exports, "TimeoutError", () => (parcelRequire("dV1xE")).TimeoutError);
$parcel$export(module.exports, "transformData", () => (parcelRequire("5aFDI")).transformData);

var $9RVC0 = parcelRequire("9RVC0");


var $lHNk5 = parcelRequire("lHNk5");


var $231PG = parcelRequire("231PG");


var $8RoZS = parcelRequire("8RoZS");


var $lTQd7 = parcelRequire("lTQd7");


var $e2AvM = parcelRequire("e2AvM");


var $htr8O = parcelRequire("htr8O");


var $6gRks = parcelRequire("6gRks");


var $hNpL3 = parcelRequire("hNpL3");


var $7kOId = parcelRequire("7kOId");


var $iiKpy = parcelRequire("iiKpy");


var $koXzF = parcelRequire("koXzF");


var $hBrfJ = parcelRequire("hBrfJ");


var $8Z7ra = parcelRequire("8Z7ra");


var $8jRWn = parcelRequire("8jRWn");


var $dV1xE = parcelRequire("dV1xE");


var $5aFDI = parcelRequire("5aFDI");


});

parcelRegister("8CJk6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $eb3ax = parcelRequire("eb3ax");


var $ccS36 = parcelRequire("ccS36");


var $lI7ls = parcelRequire("lI7ls");


var $cozmU = parcelRequire("cozmU");

parcelRequire("bDcGz");
var $7MFOM = parcelRequire("7MFOM");


var $6nY8H = parcelRequire("6nY8H");

class $64750795b7972098$var$Redirector extends (0, $cozmU.Component) {
    componentDidMount() {
        const { to: to, location: location, push: push, params: params, query: query, actions: actions } = this.props;
        const routeAttributes = {
            params: params,
            query: query,
            basePath: actions.getBasePath()
        };
        const newPath = typeof to === 'object' ? 'path' in to ? (0, $lI7ls.createPath)((0, $7MFOM.generateLocationFromPath)(to.path, routeAttributes)) : (0, $lI7ls.createPath)(to) : to;
        const currentPath = (0, $lI7ls.createPath)(location);
        const action = push ? actions.push : actions.replace;
        if (currentPath === newPath) return;
        action(newPath);
    }
    render() {
        return null;
    }
}
(0, $ccS36.default)($64750795b7972098$var$Redirector, "defaultProps", {
    push: false
});
const $64750795b7972098$export$2d8d895a0a0f636e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const [t0, actions] = (0, $6nY8H.useRouter)();
    const { location: location } = t0;
    let t1;
    if ($[0] !== actions || $[1] !== location || $[2] !== props) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($64750795b7972098$var$Redirector, (0, $eb3ax.default)({
            actions: actions,
            location: location
        }, props));
        $[0] = actions;
        $[1] = location;
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (props)=>{
    const [{ location: location }, actions] = (0, $6nY8H.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($64750795b7972098$var$Redirector, (0, $eb3ax.default)({
        actions: actions,
        location: location
    }, props));
};

});

parcelRegister("5ZHAX", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $lI7ls = parcelRequire("lI7ls");


var $cozmU = parcelRequire("cozmU");


var $kZkvy = parcelRequire("kZkvy");

const $45d47754d4ad67f0$export$55185c17a0fcbe46 = ({ basePath: basePath, children: children, history: history, initialRoute: initialRoute, isGlobal: isGlobal = true, plugins: plugins, onPrefetch: onPrefetch, routes: routes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kZkvy.RouterContainer), {
        basePath: basePath,
        history: history,
        initialRoute: initialRoute,
        isGlobal: isGlobal,
        onPrefetch: onPrefetch,
        plugins: plugins != null ? plugins : [],
        routes: routes
    }, children);
};
function $45d47754d4ad67f0$export$ae46f04cfaffe093(props) {
    var _props$plugins;
    const history = (0, $cozmU.useMemo)(()=>(0, $lI7ls.createMemoryHistory)(props.location ? {
            initialEntries: [
                props.location
            ]
        } : {}), [
        props.location
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45d47754d4ad67f0$export$55185c17a0fcbe46, (0, $eb3ax.default)({}, props, {
        history: history,
        isGlobal: false,
        plugins: (_props$plugins = props == null ? void 0 : props.plugins) != null ? _props$plugins : []
    }));
}

});

parcelRegister("k8KD8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $j4NNn = parcelRequire("j4NNn");

const $ea98b9cde87f8635$export$b371fa9cf762ad06 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    const actions = (0, $j4NNn.useRouterActions)();
    let t1;
    if ($[0] !== actions || $[1] !== children) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(actions));
        $[0] = actions;
        $[1] = children;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children })=>{
    const actions = (0, $j4NNn.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(actions));
};
$ea98b9cde87f8635$export$b371fa9cf762ad06.displayName = 'RouterActions';

});

parcelRegister("aO6HO", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $1eVGO = parcelRequire("1eVGO");


var $cozmU = parcelRequire("cozmU");

parcelRequire("bDcGz");
var $2kK4E = parcelRequire("2kK4E");


var $kZkvy = parcelRequire("kZkvy");

const $7de3c684772f52ab$var$_excluded = [
    "listen"
];
const $7de3c684772f52ab$export$672d721d310ff5f0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children } = t0;
    const [state, _ref] = (0, $kZkvy.useRouterStore)();
    const { listen: listen } = _ref;
    let t1;
    if ($[0] !== _ref || $[1] !== children || $[2] !== listen || $[3] !== state) {
        const actions = (0, $1eVGO.default)(_ref, $7de3c684772f52ab$var$_excluded);
        if (!state.unlisten && !(0, $2kK4E.isServerEnvironment)()) listen();
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(state, actions));
        $[0] = _ref;
        $[1] = children;
        $[2] = listen;
        $[3] = state;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ children: children })=>{
    const [state, _ref] = (0, $kZkvy.useRouterStore)();
    const { listen: listen } = _ref, actions = (0, $1eVGO.default)(_ref, $7de3c684772f52ab$var$_excluded);
    if (!state.unlisten && !(0, $2kK4E.isServerEnvironment)()) listen();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(state, actions));
};
module.exports["RouterSubscriber"] = $7de3c684772f52ab$export$672d721d310ff5f0;

});

parcelRegister("33dCY", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");


var $kZkvy = parcelRequire("kZkvy");

const $238c390c92a1ce3e$var$createPathParamHook = (0, $kBr4q.createHook)((0, $kZkvy.RouterStore), {
    selector: ({ match: { params: params } }, { paramKey: paramKey })=>params[paramKey]
});
const $238c390c92a1ce3e$export$8c8591dcd57728e6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (paramKey)=>{
    const $ = (0, $bDgLe.c)(8);
    let t0;
    if ($[0] !== paramKey) {
        t0 = $238c390c92a1ce3e$var$createPathParamHook({
            paramKey: paramKey
        });
        $[0] = paramKey;
        $[1] = t0;
    } else t0 = $[1];
    const [paramVal, routerActions] = t0;
    let t1;
    if ($[2] !== paramKey || $[3] !== routerActions) {
        t1 = (newValue, updateType)=>{
            routerActions.updatePathParam({
                [paramKey]: newValue
            }, updateType);
        };
        $[2] = paramKey;
        $[3] = routerActions;
        $[4] = t1;
    } else t1 = $[4];
    const setPathParam = t1;
    let t2;
    if ($[5] !== paramVal || $[6] !== setPathParam) {
        t2 = [
            paramVal,
            setPathParam
        ];
        $[5] = paramVal;
        $[6] = setPathParam;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : (paramKey)=>{
    const [paramVal, routerActions] = $238c390c92a1ce3e$var$createPathParamHook({
        paramKey: paramKey
    });
    const setPathParam = (0, $cozmU.useCallback)((newValue, updateType)=>{
        routerActions.updatePathParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setPathParam
    ];
};

});

parcelRegister("d7HEO", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");


var $kZkvy = parcelRequire("kZkvy");

const $98ddcb3f98ad0748$var$createQueryParamHook = (0, $kBr4q.createHook)((0, $kZkvy.RouterStore), {
    selector: ({ query: query }, { paramKey: paramKey })=>query[paramKey]
});
const $98ddcb3f98ad0748$export$ae316f0eeb712a36 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (paramKey)=>{
    const $ = (0, $bDgLe.c)(8);
    let t0;
    if ($[0] !== paramKey) {
        t0 = $98ddcb3f98ad0748$var$createQueryParamHook({
            paramKey: paramKey
        });
        $[0] = paramKey;
        $[1] = t0;
    } else t0 = $[1];
    const [paramVal, routerActions] = t0;
    let t1;
    if ($[2] !== paramKey || $[3] !== routerActions) {
        t1 = (newValue, updateType)=>{
            routerActions.updateQueryParam({
                [paramKey]: newValue
            }, updateType);
        };
        $[2] = paramKey;
        $[3] = routerActions;
        $[4] = t1;
    } else t1 = $[4];
    const setQueryParam = t1;
    let t2;
    if ($[5] !== paramVal || $[6] !== setQueryParam) {
        t2 = [
            paramVal,
            setQueryParam
        ];
        $[5] = paramVal;
        $[6] = setQueryParam;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : (paramKey)=>{
    const [paramVal, routerActions] = $98ddcb3f98ad0748$var$createQueryParamHook({
        paramKey: paramKey
    });
    const setQueryParam = (0, $cozmU.useCallback)((newValue, updateType)=>{
        routerActions.updateQueryParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setQueryParam
    ];
};

});

parcelRegister("6nY8H", function(module, exports) {

var $kZkvy = parcelRequire("kZkvy");

const $4a638a741202ff87$export$9a302a45f65d0572 = (0, $kZkvy.useRouterStore);
module.exports["useRouter"] = $4a638a741202ff87$export$9a302a45f65d0572;

});

parcelRegister("j4NNn", function(module, exports) {

var $kZkvy = parcelRequire("kZkvy");

const $de350461d6c0d763$export$402e82ff1b20594b = (0, $kZkvy.useRouterStoreActions);
module.exports["useRouterActions"] = $de350461d6c0d763$export$402e82ff1b20594b;

});

parcelRegister("7wvhg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $eb3ax = parcelRequire("eb3ax");


var $cozmU = parcelRequire("cozmU");


var $kZkvy = parcelRequire("kZkvy");

const $57a3c89bff66d73d$var$getWrappedComponentDisplayName = (component)=>{
    let componentDisplayName = 'UNDEFINED';
    const { displayName: displayName, name: name } = component;
    if (displayName) componentDisplayName = displayName;
    if (name) componentDisplayName = name;
    return `withRouter(${componentDisplayName})`;
};
const $57a3c89bff66d73d$export$369b6b2b30582e8e = (WrappedComponent)=>{
    const displayName = $57a3c89bff66d73d$var$getWrappedComponentDisplayName(WrappedComponent);
    const Component = WrappedComponent;
    const ComponentWithRouter = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
        const $ = (0, $bDgLe.c)(10);
        const [t0, t1] = (0, $kZkvy.useRouterStore)();
        const { action: action, history: history, location: location, match: match, query: query, route: route } = t0;
        const { push: push, replace: replace } = t1;
        let t2;
        if ($[0] !== action || $[1] !== history || $[2] !== location || $[3] !== match || $[4] !== props || $[5] !== push || $[6] !== query || $[7] !== replace || $[8] !== route) {
            t2 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, (0, $eb3ax.default)({}, props, {
                action: action,
                history: history,
                location: location,
                match: match,
                push: push,
                query: query,
                replace: replace,
                route: route
            }));
            $[0] = action;
            $[1] = history;
            $[2] = location;
            $[3] = match;
            $[4] = props;
            $[5] = push;
            $[6] = query;
            $[7] = replace;
            $[8] = route;
            $[9] = t2;
        } else t2 = $[9];
        return t2;
    } : (props)=>{
        const [{ action: action, history: history, location: location, match: match, query: query, route: route }, { push: push, replace: replace }] = (0, $kZkvy.useRouterStore)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, (0, $eb3ax.default)({}, props, {
            action: action,
            history: history,
            location: location,
            match: match,
            push: push,
            query: query,
            replace: replace,
            route: route
        }));
    };
    ComponentWithRouter.displayName = displayName;
    return ComponentWithRouter;
};

});

parcelRegister("imtAv", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $1eVGO = parcelRequire("1eVGO");


var $lI7ls = parcelRequire("lI7ls");


var $cozmU = parcelRequire("cozmU");

parcelRequire("bDcGz");
var $fHQWF = parcelRequire("fHQWF");
var $7MFOM = parcelRequire("7MFOM");


var $kZkvy = parcelRequire("kZkvy");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");




const $f6123e28cc74d57b$export$d8e6abf214c9ec0f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (delay)=>{
    const $ = (0, $bDgLe.c)(5);
    const timeoutId = (0, $cozmU.useRef)();
    let t0;
    if ($[0] !== delay) {
        t0 = (callback)=>{
            if (timeoutId.current) clearTimeout(timeoutId.current);
            timeoutId.current = setTimeout(callback, delay);
        };
        $[0] = delay;
        $[1] = t0;
    } else t0 = $[1];
    const schedule = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            clearTimeout(timeoutId.current);
        };
        $[2] = t1;
    } else t1 = $[2];
    const cancel = t1;
    let t2;
    if ($[3] !== schedule) {
        t2 = {
            schedule: schedule,
            cancel: cancel
        };
        $[3] = schedule;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : (delay)=>{
    const timeoutId = (0, $cozmU.useRef)();
    const schedule = (0, $cozmU.useCallback)((callback)=>{
        if (timeoutId.current) clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay);
    }, [
        delay
    ]);
    const cancel = (0, $cozmU.useCallback)(()=>{
        clearTimeout(timeoutId.current);
    }, []);
    return {
        schedule: schedule,
        cancel: cancel
    };
};





var $cK9FA = parcelRequire("cK9FA");


var $bHq0V = parcelRequire("bHq0V");



const $d5e13b95edab2cc2$var$_excluded = [
    "children",
    "target",
    "replace",
    "href",
    "to",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "onPointerDown",
    "onFocus",
    "onBlur",
    "type",
    "params",
    "query",
    "prefetch",
    "state"
];
const $d5e13b95edab2cc2$var$PREFETCH_DELAY = 225;
const $d5e13b95edab2cc2$var$Link = /*#__PURE__*/ (0, $cozmU.forwardRef)((_ref, ref)=>{
    let { children: children, target: target = '_self', replace: replace = false, href: href, to: to, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerDown: onPointerDown, onFocus: onFocus, onBlur: onBlur, type: linkType = 'a', params: params, query: query, prefetch: prefetch = false, state: state } = _ref, rest = (0, $1eVGO.default)(_ref, $d5e13b95edab2cc2$var$_excluded);
    const routerActions = (0, $kZkvy.useRouterStoreActions)();
    const { schedule: schedule, cancel: cancel } = (0, $f6123e28cc74d57b$export$d8e6abf214c9ec0f)($d5e13b95edab2cc2$var$PREFETCH_DELAY);
    const validLinkType = (0, $cK9FA.getValidLinkType)(linkType);
    const [route, setRoute] = (0, $cozmU.useState)(()=>{
        if (to && typeof to !== 'string') {
            if ('then' in to) to.then((r)=>setRoute('default' in r ? r.default : r));
            else return to;
        }
    });
    const routeAttributes = {
        params: params,
        query: query,
        basePath: routerActions.getBasePath()
    };
    const linkDestination = href != null ? href : typeof to !== 'string' ? route && (0, $lI7ls.createPath)((0, $7MFOM.generateLocationFromPath)(route.path, routeAttributes)) || '' : to;
    const staticBasePath = href == null && typeof to === 'string' ? routeAttributes.basePath : '';
    const triggerPrefetch = (0, $cozmU.useCallback)(()=>{
        // ignore if async route not ready yet
        if (typeof to !== 'string' && !route) return;
        const context = typeof to !== 'string' && route ? (0, $fHQWF.createRouterContext)(route, {
            params: params,
            query: query
        }) : null;
        routerActions.prefetchRoute(linkDestination, context);
    // omit params & query as already in linkDestination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        linkDestination,
        routerActions
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (prefetch === 'mount') schedule(triggerPrefetch);
        return cancel;
    }, [
        prefetch,
        schedule,
        cancel,
        triggerPrefetch
    ]);
    const handleLinkPress = (e)=>(0, $bHq0V.handleNavigation)(e, {
            onClick: onClick,
            target: target,
            replace: replace,
            routerActions: routerActions,
            href: linkDestination,
            to: route && [
                route,
                {
                    params: params,
                    query: query
                }
            ],
            state: state
        });
    const handleMouseEnter = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onMouseEnter && onMouseEnter(e);
    };
    const handleMouseLeave = (e)=>{
        if (prefetch === 'hover') cancel();
        onMouseLeave && onMouseLeave(e);
    };
    const handleFocus = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onFocus && onFocus(e);
    };
    const handleBlur = (e)=>{
        if (prefetch === 'hover') cancel();
        onBlur && onBlur(e);
    };
    const handlePointerDown = (e)=>{
        if (prefetch === 'hover') {
            cancel();
            triggerPrefetch();
        }
        onPointerDown && onPointerDown(e);
    };
    return /*#__PURE__*/ (0, $cozmU.createElement)(validLinkType, (0, $eb3ax.default)({}, rest, {
        href: `${staticBasePath}${linkDestination}`,
        target: target,
        onClick: handleLinkPress,
        onKeyDown: handleLinkPress,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onPointerDown: handlePointerDown,
        ref: ref
    }), children);
});
$d5e13b95edab2cc2$var$Link.displayName = 'Link';
var $d5e13b95edab2cc2$export$2e2bcd8739ae039 = $d5e13b95edab2cc2$var$Link;
module.exports["default"] = $d5e13b95edab2cc2$export$2e2bcd8739ae039;

});

parcelRegister("h1RxD", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

parcelRequire("9vmeB");
var $6nY8H = parcelRequire("6nY8H");

const $c65c0fe48c146c8d$export$7903e4b73fc7d6c3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(6);
    const [t0] = (0, $6nY8H.useRouter)();
    const { action: action, location: location, match: match, query: query, route: route } = t0;
    if (!route || !route.component) return null;
    let t1;
    if ($[0] !== action || $[1] !== location || $[2] !== match || $[3] !== query || $[4] !== route) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(route.component, {
            action: action,
            location: location,
            match: match,
            query: query,
            route: route
        });
        $[0] = action;
        $[1] = location;
        $[2] = match;
        $[3] = query;
        $[4] = route;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ()=>{
    const [{ action: action, location: location, match: match, query: query, route: route }] = (0, $6nY8H.useRouter)();
    if (!route || !route.component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(route.component, {
        action: action,
        location: location,
        match: match,
        query: query,
        route: route
    });
};

});

parcelRegister("lKKkr", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $lI7ls = parcelRequire("lI7ls");


var $7SeeH = parcelRequire("7SeeH");


var $eO7Xs = parcelRequire("eO7Xs");

const $fd61d4c8ffe72819$var$hasWindow = ()=>typeof window !== 'undefined';
const $fd61d4c8ffe72819$var$methodsPlaceholders = {
    push: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    listen: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs)))
};
const $fd61d4c8ffe72819$var$getLocation = ()=>{
    // todo - don't force non-optional search and hash
    const { pathname: pathname = '', search: search = '', hash: hash = '' } = $fd61d4c8ffe72819$var$hasWindow() && window.location || {};
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
};
const $fd61d4c8ffe72819$var$createLegacyListener = (updateExposedLocation)=>{
    const node = document.querySelector('#content');
    let prevHref = window.location.href;
    let listeners = [];
    const historyStack = [
        prevHref
    ];
    // note: window.history.length is capped at 50 entries
    let prevHistoryLength = window.history.length;
    let historyIndex = 0;
    const getAction = ()=>{
        const currentHref = window.location.href;
        if (prevHistoryLength === window.history.length) {
            if (historyStack[historyIndex - 1] === currentHref) {
                historyIndex -= 1;
                return 'POP';
            }
            if (historyStack[historyIndex + 1] === currentHref) {
                historyIndex += 1;
                return 'POP';
            }
            historyStack[historyStack.length - 1] = currentHref;
            return 'REPLACE';
        }
        historyStack.push(currentHref);
        historyIndex += 1;
        prevHistoryLength = window.history.length;
        return 'PUSH';
    };
    const onNodeChanges = (0, (/*@__PURE__*/$parcel$interopDefault($7SeeH)))(()=>{
        if (prevHref !== window.location.href) {
            const newLocation = $fd61d4c8ffe72819$var$getLocation();
            const action = getAction();
            updateExposedLocation(newLocation, action);
            listeners.forEach((listener)=>listener(newLocation, action));
            prevHref = window.location.href;
        }
    }, 50);
    if (node) {
        const observer = new window.MutationObserver(onNodeChanges);
        observer.observe(node, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }
    return (listener)=>{
        listeners = listeners.concat(listener);
        return ()=>{
            listeners = listeners.filter((lst)=>lst !== listener);
        };
    };
};
const $fd61d4c8ffe72819$export$883c3f3b6c000133 = ()=>{
    let currentLocation = $fd61d4c8ffe72819$var$getLocation();
    let currentAction = 'PUSH';
    const updateExposedLocation = (v, a)=>{
        currentLocation = v;
        currentAction = a;
    };
    return (0, $eb3ax.default)({
        get location () {
            return currentLocation;
        },
        get length () {
            return $fd61d4c8ffe72819$var$hasWindow() ? window.history.length : 1; // default length is 1
        },
        get action () {
            return currentAction;
        }
    }, $fd61d4c8ffe72819$var$hasWindow() ? {
        push: (path)=>window.location.assign(typeof path === 'string' ? path : (0, $lI7ls.createPath)(path || {})),
        replace: (path)=>window.history.replaceState({}, document.title, typeof path === 'string' ? path : (0, $lI7ls.createPath)(path || {})),
        goBack: ()=>window.history.back(),
        goForward: ()=>window.history.forward(),
        listen: $fd61d4c8ffe72819$var$createLegacyListener(updateExposedLocation),
        block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
        createHref: (location)=>(0, $lI7ls.createPath)(location)
    } : $fd61d4c8ffe72819$var$methodsPlaceholders);
};
module.exports["createLegacyHistory"] = $fd61d4c8ffe72819$export$883c3f3b6c000133;

});

parcelRegister("7MFOM", function(module, exports) {

var $6XX9c = parcelRequire("6XX9c");


var $4NiRC = parcelRequire("4NiRC");

function $5aad744e29dba80d$export$37e0729cc751960b(pattern = '/', options = {}) {
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $4NiRC.qs).stringify(query, true);
    const pathname = pattern === '/' ? pattern : (0, $6XX9c.compile)(pattern)(params);
    return {
        pathname: `${basePath}${pathname}`,
        search: stringifiedQuery,
        hash: ''
    };
}
module.exports["generateLocationFromPath"] = $5aad744e29dba80d$export$37e0729cc751960b;

});

parcelRegister("fEoYr", function(module, exports) {

var $6XX9c = parcelRequire("6XX9c");

const $b64df6be97c2557a$export$82476f982757e71e = (pattern = '/', params)=>pattern === '/' ? pattern : (0, $6XX9c.compile)(pattern)(params);
module.exports["generatePath"] = $b64df6be97c2557a$export$82476f982757e71e;

});

parcelRegister("2kK4E", function(module, exports) {
/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ 
var $1P2f3 = parcelRequire("1P2f3");

const $1b31305ee778cb0e$var$isJsDomEnvironment = ()=>{
    var _navigator, _navigator2;
    return window.name === 'nodejs' || ((_navigator = navigator) == null ? void 0 : _navigator.userAgent.includes('Node.js')) || ((_navigator2 = navigator) == null ? void 0 : _navigator2.userAgent.includes('jsdom'));
};
const $1b31305ee778cb0e$export$455cc18296abe008 = ()=>{
    if (typeof window === 'undefined' || typeof $1P2f3 !== 'undefined' && $1P2f3.versions != null && $1P2f3.versions.node != null) return true;
    if ($1b31305ee778cb0e$var$isJsDomEnvironment()) return true;
    return false;
};
module.exports["isServerEnvironment"] = $1b31305ee778cb0e$export$455cc18296abe008;

});

parcelRegister("aNi3F", function(module, exports) {
$parcel$export(module.exports, "default", () => $7dbc7cf12b42c499$export$2e2bcd8739ae039);

var $4NiRC = parcelRequire("4NiRC");


var $eb3ax = parcelRequire("eb3ax");

// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

var $6XX9c = parcelRequire("6XX9c");

const $a65491a041b5b4e0$var$cache = {};
const $a65491a041b5b4e0$var$cacheLimit = 10000;
let $a65491a041b5b4e0$var$cacheCount = 0;
function $a65491a041b5b4e0$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $a65491a041b5b4e0$var$cache[cacheKey] || ($a65491a041b5b4e0$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, $6XX9c.pathToRegexp)(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($a65491a041b5b4e0$var$cacheCount < $a65491a041b5b4e0$var$cacheLimit) {
        pathCache[path] = result;
        $a65491a041b5b4e0$var$cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function $a65491a041b5b4e0$var$matchPath(pathname, options = {}) {
    if (typeof options === 'string' || Array.isArray(options)) options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = '' } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== '') return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $a65491a041b5b4e0$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === '/' && url === '' ? '/' : url,
            isExact: // the matched portion of the URL
            isExact,
            // whether or not we matched exactly
            params: keys.reduce((memo, key, index)=>{
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
var $a65491a041b5b4e0$export$2e2bcd8739ae039 = $a65491a041b5b4e0$var$matchPath;





/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function $03bb44c31a936060$var$matchQuery(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split('=');
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split('|').map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? (0, $eb3ax.default)({}, pathMatch, {
        query: queryMatch
    }) : null;
}
var $03bb44c31a936060$export$2e2bcd8739ae039 = $03bb44c31a936060$var$matchQuery;


/* This should match what react-router does to compute a root match. */ const $3a427a59380bdb41$var$computeRootMatch = (pathname)=>({
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    });
function $3a427a59380bdb41$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $a65491a041b5b4e0$export$2e2bcd8739ae039)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $3a427a59380bdb41$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $03bb44c31a936060$export$2e2bcd8739ae039)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = (0, $eb3ax.default)({}, pathMatch, {
        query: {}
    });
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
var $3a427a59380bdb41$export$2e2bcd8739ae039 = $3a427a59380bdb41$var$execRouteMatching;


const $1b66ba6664274cb1$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $1b66ba6664274cb1$var$MAX_CACHE_SIZE = 1000;
function $1b66ba6664274cb1$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!$1b66ba6664274cb1$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $1b66ba6664274cb1$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($1b66ba6664274cb1$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $1b66ba6664274cb1$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $1b66ba6664274cb1$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};


/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */ const $7dbc7cf12b42c499$var$matchRoute = (routes, pathname, queryParams = {}, basePath = '')=>{
    const queryParamObject = typeof queryParams === 'string' ? (0, $4NiRC.qs).parse(queryParams) : queryParams;
    const cachedMatch = (0, $1b66ba6664274cb1$export$f594abf16a5ad948).get(pathname, queryParamObject, basePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    for(let i = 0; i < routes.length; i++){
        const matchedRoute = (0, $3a427a59380bdb41$export$2e2bcd8739ae039)(routes[i], pathname, queryParamObject, basePath);
        if (matchedRoute) {
            (0, $1b66ba6664274cb1$export$f594abf16a5ad948).set(pathname, queryParamObject, basePath, matchedRoute);
            return matchedRoute;
        }
    }
    return null;
};
const $7dbc7cf12b42c499$export$ce5b73cebfeaa567 = (routes, pathname, queryParams, basePath = '')=>$7dbc7cf12b42c499$var$matchRoute(routes, pathname, queryParams, basePath);
const $7dbc7cf12b42c499$export$4e76f1d455ef7c95 = (route, pathname, queryParams, basePath = '')=>{
    $7dbc7cf12b42c499$var$matchRoute([
        route
    ], pathname, queryParams, basePath);
};
var $7dbc7cf12b42c499$export$2e2bcd8739ae039 = (routes, pathname, queryParams, basePath = '')=>$7dbc7cf12b42c499$var$matchRoute(routes, pathname, queryParams, basePath);
module.exports["warmupMatchRouteCache"] = $7dbc7cf12b42c499$export$4e76f1d455ef7c95;

});

parcelRegister("fHQWF", function(module, exports) {

var $4NiRC = parcelRequire("4NiRC");


var $3yk4a = parcelRequire("3yk4a");


var $fEoYr = parcelRequire("fEoYr");


var $aNi3F = parcelRequire("aNi3F");

const $b6f3f0fc046f7aa2$export$faed15f35ddc6f99 = (route, options = {})=>{
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    const pathname = (0, $fEoYr.generatePath)(route.path, params);
    const matchedRoute = (0, $aNi3F.default)([
        route
    ], pathname, query, basePath);
    return {
        route: route,
        match: matchedRoute ? matchedRoute.match : (0, $3yk4a.DEFAULT_MATCH),
        query: query
    };
};
const $b6f3f0fc046f7aa2$export$a0bd0313cbeabd49 = (routes, options)=>{
    const { location: location, basePath: basePath = '' } = options;
    const { pathname: pathname, search: search } = location;
    const query = (0, $4NiRC.qs).parse(search);
    const matchedRoute = (0, $aNi3F.default)(routes, pathname, query, basePath);
    return {
        query: query,
        route: matchedRoute ? matchedRoute.route : (0, $3yk4a.DEFAULT_ROUTE),
        match: matchedRoute ? matchedRoute.match : (0, $3yk4a.DEFAULT_MATCH)
    };
};
module.exports["createRouterContext"] = $b6f3f0fc046f7aa2$export$faed15f35ddc6f99;
module.exports["findRouterContext"] = $b6f3f0fc046f7aa2$export$a0bd0313cbeabd49;

});

parcelRegister("5l9sO", function(module, exports) {
const $3e364132720b27d6$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $3e364132720b27d6$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $3e364132720b27d6$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $3e364132720b27d6$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);
module.exports["isSameRouteMatch"] = $3e364132720b27d6$export$5997e70fc4543270;

});

parcelRegister("4C2bB", function(module, exports) {

var $jPvl5 = parcelRequire("jPvl5");

parcelRequire("fZ3NV");
var $fFk7n = parcelRequire("fFk7n");

const $35bc682839831bf6$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $35bc682839831bf6$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $jPvl5.getResourceStore)().actions;
    const nextResources = (0, $fFk7n.getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $35bc682839831bf6$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $jPvl5.getResourceStore)().actions;
    const nextResources = (0, $fFk7n.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $35bc682839831bf6$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $jPvl5.getResourceStore)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $35bc682839831bf6$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $35bc682839831bf6$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $35bc682839831bf6$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $jPvl5.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $jPvl5.getResourceStore)().actions;
            const nextResources = (0, $fFk7n.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $jPvl5.getResourceStore)().actions.getSafeData();
        }
    };
};

});

parcelRegister("c7RYO", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $2s5nZ = parcelRequire("2s5nZ");

const $8d4002c4c9333d5d$export$fee1a6213543bd78 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, resource: resource, options: options } = t0;
    const result = (0, $2s5nZ.useResource)(resource, options);
    let t1;
    if ($[0] !== children || $[1] !== result) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(result));
        $[0] = children;
        $[1] = result;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children, resource: resource, options: options })=>{
    const result = (0, $2s5nZ.useResource)(resource, options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(result));
};

});

parcelRegister("2s5nZ", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

parcelRequire("cvj4z");
var $kZkvy = parcelRequire("kZkvy");


var $jPvl5 = parcelRequire("jPvl5");

const $1c925fd4a4f4a47e$export$9f6abfd74295843b = (resource, options)=>{
    const actions = (0, $jPvl5.useResourceStoreActions)();
    const { getContext: getRouterContext } = (0, $kZkvy.useRouterStoreActions)();
    // Dynamically generate a router subscriber based on the resource:
    // makes the component re-render only when key changes instead of
    // after every route change
    const useKey = (0, $cozmU.useMemo)(()=>(0, $kBr4q.createHook)((0, $kZkvy.RouterStore), {
            selector: ({ match: match, query: query, route: route }, keyArg)=>resource.getKey(keyArg != null ? keyArg : {
                    match: match,
                    query: query,
                    route: route
                }, actions.getContext())
        }), [
        resource,
        actions
    ]);
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    const key = useKey(options == null ? void 0 : options.routerContext)[0];
    const [slice] = (0, $jPvl5.useResourceStore)({
        type: resource.type,
        key: key
    });
    // we keep route context bound to key, so route context won't refresh
    // unless key changes. This allows refresh to be called on effect cleanup
    // or asynchronously, when route context might already have changed
    const routerContext = (0, $cozmU.useMemo)(// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    ()=>(options == null ? void 0 : options.routerContext) || getRouterContext(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key
    ]);
    const update = (0, $cozmU.useCallback)((updater)=>{
        actions.updateResourceState(resource, routerContext, updater);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clear = (0, $cozmU.useCallback)(()=>{
        actions.clearResource(resource, routerContext);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clearAll = (0, $cozmU.useCallback)(()=>{
        actions.clearResource(resource);
    }, [
        resource,
        actions
    ]);
    const refresh = (0, $cozmU.useCallback)(()=>{
        actions.getResourceFromRemote(resource, routerContext, {
            prefetch: false
        });
    }, [
        resource,
        routerContext,
        actions
    ]);
    return (0, $eb3ax.default)({}, slice, {
        update: update,
        key: key,
        refresh: refresh,
        clear: clear,
        clearAll: clearAll
    });
};
module.exports["useResource"] = $1c925fd4a4f4a47e$export$9f6abfd74295843b;

});

parcelRegister("bNqcK", function(module, exports) {

var $jPvl5 = parcelRequire("jPvl5");

const $896898fc64e230bd$export$dee7bf9fc0ff48c3 = (fn)=>(0, $jPvl5.getResourceStore)().storeState.subscribe(fn);

});

parcelRegister("jPvl5", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $1eVGO = parcelRequire("1eVGO");


var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");

var $5GOpG = parcelRequire("5GOpG");

var $c6StJ = parcelRequire("c6StJ");

parcelRequire("bDcGz");
var $2kK4E = parcelRequire("2kK4E");




parcelRequire("fZ3NV");
var $abmiw = parcelRequire("abmiw");

const $d29544a1b182e469$export$c9ed509724feb827 = (state, props)=>{
    const { type: type, key: key } = props;
    const slice = state.data[type] && state.data[type][key];
    return slice ? (0, $eb3ax.default)({}, slice) : (0, $abmiw.getDefaultStateSlice)();
};
const $d29544a1b182e469$export$6a0b1779210de0ee = (state)=>state.context;


parcelRequire("fZ3NV");
var $l6MXV = parcelRequire("l6MXV");
var $59XiK = parcelRequire("59XiK");
var $1hI4C = parcelRequire("1hI4C");
var $aezOD = parcelRequire("aezOD");
var $8PAPC = parcelRequire("8PAPC");
var $ejHIX = parcelRequire("ejHIX");
var $gTkjN = parcelRequire("gTkjN");
var $kNFFp = parcelRequire("kNFFp");
var $8MtAf = parcelRequire("8MtAf");
var $4q31l = parcelRequire("4q31l");
var $VL9K0 = parcelRequire("VL9K0");

const $e6fb1709e9cfaa9f$var$_excluded = [
    "context"
], $e6fb1709e9cfaa9f$var$_excluded2 = [
    "error",
    "expiresAt",
    "loading"
];
const $e6fb1709e9cfaa9f$export$3f1be494d407b77a = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   */ clearResource: (resource, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            if (routerStoreContext) {
                const key = getKey(routerStoreContext, context);
                dispatch((0, $1hI4C.deleteResourceState)(type, key));
                dispatch((0, $l6MXV.executeForDependents)(resource, (dependentResource)=>$e6fb1709e9cfaa9f$export$3f1be494d407b77a.clearResource(dependentResource, routerStoreContext)));
            } else dispatch((0, $1hI4C.deleteResourceState)(type));
        },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const _getState = getState(), { context: context } = _getState, resourceStoreState = (0, $1eVGO.default)(_getState, $e6fb1709e9cfaa9f$var$_excluded);
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $d29544a1b182e469$export$c9ed509724feb827)(resourceStoreState, {
                type: type,
                key: key
            });
            const data = getNewSliceData(prevSlice.data);
            const changes = prevSlice.loading ? {
                data: data,
                error: null,
                loading: true
            } : {
                data: data,
                error: null,
                loading: false,
                promise: Promise.resolve(data)
            };
            const newSlice = (0, $eb3ax.default)({}, prevSlice, changes, {
                expiresAt: (0, $ejHIX.getExpiresAt)(maxAge),
                accessedAt: (0, $8PAPC.getAccessedAt)()
            });
            dispatch((0, $1hI4C.setResourceState)(type, key, newSlice));
            // trigger dependent resources on change
            if (newSlice.data !== prevSlice.data) dispatch((0, $l6MXV.executeForDependents)(resource, (dependentResource)=>$e6fb1709e9cfaa9f$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, {})));
        },
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   */ getResource: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            let cached = dispatch((0, $1hI4C.getResourceState)(type, key));
            if (cached && (0, $gTkjN.shouldUseCache)(cached)) {
                if ((0, $gTkjN.isFromSsr)(cached)) {
                    const withResolvedPromise = (0, $kNFFp.setSsrDataPromise)(cached);
                    cached = (0, $ejHIX.setExpiresAt)(withResolvedPromise, maxAge);
                }
                cached.accessedAt = (0, $8PAPC.getAccessedAt)();
                dispatch((0, $1hI4C.setResourceState)(type, key, cached));
                return cached;
            }
            return dispatch($e6fb1709e9cfaa9f$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options));
        },
    /**
   * Request a single resource and update the resource cache.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = dispatch((0, $1hI4C.getResourceState)(type, key)) || (0, $abmiw.getDefaultStateSlice)();
            // abort request if already in flight
            if (prevSlice.loading) return prevSlice;
            dispatch((0, $VL9K0.validateLRUCache)(resource, key));
            const loadingSlice = dispatch((0, $1hI4C.getPrefetchSlice)(type, key)) || (0, $59XiK.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $l6MXV.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            let resolvedSlice;
            if (loadingSlice.data === prevSlice.data) // same data (by reference) means nothing has changed and we can avoid loading state
            resolvedSlice = {};
            else {
                // enter loading state
                dispatch((0, $1hI4C.setResourceState)(type, key, (0, $eb3ax.default)({}, prevSlice, loadingSlice, {
                    data: maxAge === 0 ? null : prevSlice.data,
                    error: maxAge === 0 ? null : prevSlice.error,
                    loading: true,
                    accessedAt: (0, $8PAPC.getAccessedAt)()
                })));
                // trigger dependent resources to also load
                dispatch((0, $l6MXV.executeForDependents)(resource, (dependentResource)=>$e6fb1709e9cfaa9f$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, options)));
                // in case another action occurred while loading promise may not be the one we started with
                // we need to re-assign promise consistent with error/data that we are assigning here
                try {
                    var _loadingSlice$data;
                    const data = (_loadingSlice$data = loadingSlice.data) != null ? _loadingSlice$data : await loadingSlice.promise;
                    resolvedSlice = {
                        data: data,
                        error: null,
                        // any existing error is cleared
                        loading: false,
                        promise: loadingSlice.promise
                    };
                } catch (error) {
                    if (error instanceof (0, $8MtAf.TimeoutError)) resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: true,
                        // this condition cannot recover so must only be present in static/server router
                        promise: null // special case for timeout
                    };
                    else resolvedSlice = {
                        error: // data: do not replace existing data
                        // @ts-ignore
                        error,
                        loading: false,
                        promise: loadingSlice.promise
                    };
                }
            }
            // ensure most recent data when return occurs
            const recentSlice = dispatch((0, $1hI4C.getResourceState)(type, key));
            const finalSlice = (0, $eb3ax.default)({}, recentSlice || prevSlice, resolvedSlice, {
                accessedAt: (0, $8PAPC.getAccessedAt)(),
                expiresAt: (0, $ejHIX.getExpiresAt)(maxAge)
            });
            // protect against race conditions: if resources get cleared while await happens, we discard the result
            if (recentSlice || loadingSlice.data !== undefined) dispatch((0, $1hI4C.setResourceState)(type, key, finalSlice));
            return finalSlice;
        },
    /**
   * Prefetch a single resource and store in the prefetch cache.
   */ prefetchResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const loadingSlice = dispatch((0, $1hI4C.getPrefetchSlice)(type, key)) || (0, $59XiK.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $l6MXV.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            // save deferred value to be used also by dependants
            dispatch((0, $1hI4C.setPrefetchSlice)(type, key, loadingSlice));
            // trigger dependent resources to also prefetch
            dispatch((0, $l6MXV.executeForDependents)(resource, (dependentResource)=>$e6fb1709e9cfaa9f$export$3f1be494d407b77a.prefetchResourceFromRemote(dependentResource, routerStoreContext, options)));
        }
};
const $e6fb1709e9cfaa9f$export$e324594224ef24da = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   * Execute such that dependencies on current route will be cleared.
   */ clearResource: (resource, routerStoreContext)=>{
        var _routerStoreContext$r;
        return (0, $l6MXV.actionWithDependencies)(routerStoreContext == null || (_routerStoreContext$r = routerStoreContext.route) == null ? void 0 : _routerStoreContext$r.resources, resource, $e6fb1709e9cfaa9f$export$3f1be494d407b77a.clearResource(resource, routerStoreContext != null ? routerStoreContext : null));
    },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   * Execute such that dependencies on current route will be updated.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>(0, $l6MXV.actionWithDependencies)(routerStoreContext.route.resources, resource, $e6fb1709e9cfaa9f$export$3f1be494d407b77a.updateResourceState(resource, routerStoreContext, getNewSliceData)),
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   * Execute such that dependencies on current route will be updated.
   */ getResource: (resource, routerStoreContext, options)=>(0, $l6MXV.actionWithDependencies)(routerStoreContext.route.resources, resource, $e6fb1709e9cfaa9f$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options)),
    /**
   * Request a single resource and update the resource cache.
   * Execute such that dependencies on current route will be updated.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>(0, $l6MXV.actionWithDependencies)(routerStoreContext.route.resources, resource, $e6fb1709e9cfaa9f$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options)),
    /**
   * Request all resources.
   */ requestAllResources: (routerStoreContext, options = {})=>({ dispatch: dispatch })=>{
            const { route: routeDefault } = routerStoreContext || {};
            const route = routeDefault;
            if (!route || !route.resources) return Promise.all([]);
            return Promise.all(dispatch($e6fb1709e9cfaa9f$export$e324594224ef24da.requestResources(route.resources, routerStoreContext, options)));
        },
    /**
   * Cleans expired resources and resets them back to their initial state.
   * We need to do this when transitioning into a route.
   */ cleanExpiredResources: (resources, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { context: resourceContext } = getState();
            resources.forEach((resource)=>{
                const { type: type, getKey: getKey } = resource;
                const key = getKey(routerStoreContext, resourceContext);
                const slice = dispatch((0, $1hI4C.getResourceState)(type, key));
                if (slice && (!slice.expiresAt || slice.expiresAt < Date.now())) dispatch((0, $1hI4C.deleteResourceState)(type, key));
            });
        },
    /**
   * Requests a specific set of resources.
   */ requestResources: (resources, routerStoreContext, options)=>{
        var _resources;
        const predicate = (0, $2kK4E.isServerEnvironment)() ? ({ isBrowserOnly: isBrowserOnly })=>!isBrowserOnly : ()=>true;
        return (0, $l6MXV.mapActionWithDependencies)((_resources = routerStoreContext.route.resources) == null ? void 0 : _resources.filter(predicate), resources.filter(predicate), (resource)=>$e6fb1709e9cfaa9f$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options));
    },
    /**
   * Prefetch a specific set of resources.
   */ prefetchResources: (resources, routerStoreContext, options)=>(0, $l6MXV.mapActionWithDependencies)(routerStoreContext.route.resources, resources, (resource)=>$e6fb1709e9cfaa9f$export$3f1be494d407b77a.prefetchResourceFromRemote(resource, routerStoreContext, (0, $eb3ax.default)({}, options, {
                prefetch: true
            }))),
    /**
   * Hydrates the store with state.
   * Will not override pre-hydrated state.
   */ hydrate: ({ resourceData: resourceData, resourceContext: resourceContext })=>({ getState: getState, setState: setState })=>{
            const { data: data, context: context } = getState();
            function getNextStateValue(prev, next) {
                if (!Object.keys(prev).length && next && Object.keys(next).length) return next;
                return prev;
            }
            const hydratedData = (0, $4q31l.transformData)(getNextStateValue(data, resourceData), (_ref)=>{
                let { error: error, expiresAt: expiresAt, loading: loading } = _ref, rest = (0, $1eVGO.default)(_ref, $e6fb1709e9cfaa9f$var$_excluded2);
                const deserializedError = !error ? null : (0, $aezOD.deserializeError)(error);
                const isTimeoutError = (deserializedError == null ? void 0 : deserializedError.name) === 'TimeoutError';
                return (0, $eb3ax.default)({}, rest, {
                    expiresAt: isTimeoutError ? Date.now() - 1 : expiresAt,
                    loading: isTimeoutError ? false : loading,
                    error: deserializedError
                });
            });
            setState({
                data: hydratedData,
                context: getNextStateValue(context, resourceContext)
            });
        },
    /**
   * Gets the store's context
   */ getContext: ()=>({ getState: getState })=>getState().context,
    /**
   * Returns safe, portable and rehydratable data.
   */ getSafeData: ()=>({ getState: getState })=>(0, $4q31l.transformData)(getState().data, ({ data: data, key: key, error: error, loading: loading })=>({
                    data: data,
                    key: key,
                    promise: null,
                    expiresAt: null,
                    accessedAt: null,
                    error: !error ? null : (0, $aezOD.serializeError)(error instanceof Error ? error : new Error(JSON.stringify(error))),
                    loading: error instanceof (0, $8MtAf.TimeoutError) ? loading : false
                }))
};
const $e6fb1709e9cfaa9f$export$94f50dade551bd01 = (0, $8s9DV.createStore)({
    initialState: {
        data: {},
        context: {},
        executing: null,
        prefetching: null
    },
    actions: $e6fb1709e9cfaa9f$export$e324594224ef24da,
    name: 'router-resources'
});
const $e6fb1709e9cfaa9f$export$cc90fb9c37c5589d = (0, $j8on0.createContainer)($e6fb1709e9cfaa9f$export$94f50dade551bd01, {
    displayName: 'ResourceContainer'
});
const $e6fb1709e9cfaa9f$export$fee1a6213543bd78 = (0, $5GOpG.createSubscriber)($e6fb1709e9cfaa9f$export$94f50dade551bd01, {
    displayName: 'ResourceSelectorSubscriber',
    selector: (state, props)=>(0, $d29544a1b182e469$export$c9ed509724feb827)(state, {
            type: props.resourceType,
            key: props.resourceKey
        })
});
const $e6fb1709e9cfaa9f$export$6f6057d42352becb = ()=>// @ts-ignore not providing a scopeId param
    (0, $c6StJ.defaultRegistry).getStore($e6fb1709e9cfaa9f$export$94f50dade551bd01);
const $e6fb1709e9cfaa9f$export$ac3608e0bb357c7 = (0, $kBr4q.createHook)($e6fb1709e9cfaa9f$export$94f50dade551bd01, {
    selector: (0, $d29544a1b182e469$export$c9ed509724feb827)
});
const $e6fb1709e9cfaa9f$export$98e41a62c9bef75e = (0, $kBr4q.createActionsHook)($e6fb1709e9cfaa9f$export$94f50dade551bd01);
const $e6fb1709e9cfaa9f$export$e59f52df235ac7b3 = (0, $kBr4q.createHook)($e6fb1709e9cfaa9f$export$94f50dade551bd01, {
    selector: (0, $d29544a1b182e469$export$6a0b1779210de0ee)
});
module.exports["getResourceStore"] = $e6fb1709e9cfaa9f$export$6f6057d42352becb;
module.exports["useResourceStore"] = $e6fb1709e9cfaa9f$export$ac3608e0bb357c7;
module.exports["useResourceStoreActions"] = $e6fb1709e9cfaa9f$export$98e41a62c9bef75e;

});

parcelRegister("gLGm7", function(module, exports) {
const $c351e41bf6b2ebd2$export$d4864d13105dc5ed = {
    loading: false,
    error: null,
    data: {
        foo: 'bar'
    },
    promise: null,
    expiresAt: Date.now(),
    accessedAt: Date.now(),
    key: ''
};

});

parcelRegister("bv42K", function(module, exports) {
module.exports = new URL("GenericError.cd21964e.svg", import.meta.url).toString();

});

parcelRegister("8x1Nr", function(module, exports) {
module.exports = new URL("RestrictedError.e0fef1fb.svg", import.meta.url).toString();

});

parcelRegister("2VrNo", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $b8pma = parcelRequire("b8pma");


var $3eDML = parcelRequire("3eDML");

var $ame4Z = parcelRequire("ame4Z");


const $0e2973feb2ae067a$var$HubEditorConfigPanelLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("hKzt8")).then((mod)=>({
            default: mod.HubEditorConfigPanel
        })));
const $0e2973feb2ae067a$export$99ce0b7d4622b2b7 = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { localId: localId, closeConfigPanel: closeConfigPanel, contentId: contentId, editorActions: editorActions, editorApi: editorApi, propsProvider: propsProvider } = t0;
    if (localId) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3eDML.GenericErrorPage), {});
            $[0] = t1;
        } else t1 = $[0];
        let t2;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b8pma.default), {
                name: "editor-config-panel-chunk-loader"
            });
            $[1] = t2;
        } else t2 = $[1];
        let t3;
        if ($[2] !== closeConfigPanel || $[3] !== contentId || $[4] !== editorActions || $[5] !== editorApi || $[6] !== localId || $[7] !== propsProvider) {
            t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ame4Z.HubErrorBoundary), {
                id: "hub-editor-config-panel",
                packageName: "@atlassian/hub-editor-config-panel",
                fallback: t1,
                shouldForceError: true,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
                    fallback: t2,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)($0e2973feb2ae067a$var$HubEditorConfigPanelLazy, {
                        localId: localId,
                        closeConfigPanel: closeConfigPanel,
                        contentId: contentId,
                        editorActions: editorActions,
                        editorApi: editorApi,
                        propsProvider: propsProvider
                    })
                })
            });
            $[2] = closeConfigPanel;
            $[3] = contentId;
            $[4] = editorActions;
            $[5] = editorApi;
            $[6] = localId;
            $[7] = propsProvider;
            $[8] = t3;
        } else t3 = $[8];
        return t3;
    }
    return null;
} : ({ localId: localId, closeConfigPanel: closeConfigPanel, contentId: contentId, editorActions: editorActions, editorApi: editorApi, propsProvider: propsProvider })=>{
    if (localId) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ame4Z.HubErrorBoundary), {
        id: "hub-editor-config-panel",
        packageName: "@atlassian/hub-editor-config-panel",
        fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3eDML.GenericErrorPage), {}),
        shouldForceError: true,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b8pma.default), {
                name: "editor-config-panel-chunk-loader"
            }),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($0e2973feb2ae067a$var$HubEditorConfigPanelLazy, {
                localId: localId,
                closeConfigPanel: closeConfigPanel,
                contentId: contentId,
                editorActions: editorActions,
                editorApi: editorApi,
                propsProvider: propsProvider
            })
        })
    });
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
module.exports["HubEditorConfigPanelEntryPoint"] = $0e2973feb2ae067a$export$99ce0b7d4622b2b7;

});

parcelRegister("9tqV4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kCECX = parcelRequire("kCECX");


var $eYg5X = parcelRequire("eYg5X");


var $bIp5p = parcelRequire("bIp5p");


var $6EuQn = parcelRequire("6EuQn");

const $10b126cdcdd7239e$var$UFOPRESS_EVENT = 'editor-config-panel-edit';
const $10b126cdcdd7239e$export$b3c1b53ec616df30 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (editorActions)=>{
    const $ = (0, $bDgLe.c)(8);
    const { setSelectedExtensionLocalId: setSelectedExtensionLocalId } = (0, $bIp5p.useExtensionsActions)();
    let t0;
    if ($[0] !== editorActions || $[1] !== setSelectedExtensionLocalId) {
        t0 = (localId)=>{
            if (!localId) return;
            const { attrs: attrs, type: type } = editorActions?.getNodeByLocalId(localId)?.toJSON() || {};
            const { extensionType: extensionType, extensionKey: extensionKey } = attrs || {};
            const editorView = editorActions._privateGetEditorView();
            const selection = editorView?.state?.selection;
            if (selection instanceof (0, $kCECX.NodeSelection)) {
                if ((0, $6EuQn.ALLOWED_EXTENSIONS).includes(extensionType)) {
                    (0, $eYg5X.default)($10b126cdcdd7239e$var$UFOPRESS_EVENT);
                    setSelectedExtensionLocalId(localId);
                }
            } else {
                if (type !== "multiBodiedExtension" || !editorView?.state) return;
                let multiBodiedExtensionPosition = editorView.state.selection.from;
                editorView.state.tr.doc.descendants((node, pos)=>{
                    if (node.attrs?.localId === localId) {
                        multiBodiedExtensionPosition = pos;
                        return;
                    }
                });
                editorView.dispatch(editorView.state.tr?.setSelection?.((0, $kCECX.NodeSelection).create(editorView.state.tr.doc, multiBodiedExtensionPosition)));
                if ((0, $6EuQn.ALLOWED_EXTENSIONS).includes(extensionType)) {
                    (0, $eYg5X.default)($10b126cdcdd7239e$var$UFOPRESS_EVENT);
                    setSelectedExtensionLocalId(localId);
                }
            }
            !!extensionKey && extensionType;
        };
        $[0] = editorActions;
        $[1] = setSelectedExtensionLocalId;
        $[2] = t0;
    } else t0 = $[2];
    const openConfigPanel = t0;
    let t1;
    if ($[3] !== setSelectedExtensionLocalId) {
        t1 = ()=>{
            setSelectedExtensionLocalId(null);
        };
        $[3] = setSelectedExtensionLocalId;
        $[4] = t1;
    } else t1 = $[4];
    const closeConfigPanel = t1;
    let t2;
    if ($[5] !== closeConfigPanel || $[6] !== openConfigPanel) {
        t2 = {
            openConfigPanel: openConfigPanel,
            closeConfigPanel: closeConfigPanel
        };
        $[5] = closeConfigPanel;
        $[6] = openConfigPanel;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : (editorActions)=>{
    const { setSelectedExtensionLocalId: setSelectedExtensionLocalId } = (0, $bIp5p.useExtensionsActions)();
    const openConfigPanel = (0, $cozmU.useCallback)((localId)=>{
        if (!localId) return;
        const { attrs: attrs, type: type } = editorActions?.getNodeByLocalId(localId)?.toJSON() || {};
        const { extensionType: extensionType, extensionKey: extensionKey } = attrs || {};
        const editorView = editorActions._privateGetEditorView();
        const selection = editorView?.state?.selection;
        if (selection instanceof (0, $kCECX.NodeSelection)) {
            if ((0, $6EuQn.ALLOWED_EXTENSIONS).includes(extensionType)) {
                (0, $eYg5X.default)($10b126cdcdd7239e$var$UFOPRESS_EVENT);
                setSelectedExtensionLocalId(localId);
            }
        } else {
            if (type !== 'multiBodiedExtension' || !editorView?.state) return;
            // Handle MultiBodiedExtension config panel
            let multiBodiedExtensionPosition = editorView.state.selection.from;
            editorView.state.tr.doc.descendants((node, pos)=>{
                if (node.attrs?.localId === localId) {
                    multiBodiedExtensionPosition = pos;
                    return;
                }
            });
            editorView.dispatch(editorView.state.tr?.setSelection?.((0, $kCECX.NodeSelection).create(editorView.state.tr.doc, multiBodiedExtensionPosition)));
            if ((0, $6EuQn.ALLOWED_EXTENSIONS).includes(extensionType)) {
                (0, $eYg5X.default)($10b126cdcdd7239e$var$UFOPRESS_EVENT);
                setSelectedExtensionLocalId(localId);
            }
        }
        !!extensionKey && extensionType;
    }, [
        setSelectedExtensionLocalId,
        editorActions
    ]);
    const closeConfigPanel = (0, $cozmU.useCallback)(()=>{
        setSelectedExtensionLocalId(null);
    }, [
        setSelectedExtensionLocalId
    ]);
    return (0, $cozmU.useMemo)(()=>({
            openConfigPanel: openConfigPanel,
            closeConfigPanel: closeConfigPanel
        }), [
        openConfigPanel,
        closeConfigPanel
    ]);
};
module.exports["useHubEditorExtensionConfigPanel"] = $10b126cdcdd7239e$export$b3c1b53ec616df30;

});

parcelRegister("8NddB", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dOBRD = parcelRequire("dOBRD");


var $6RwwD = parcelRequire("6RwwD");


var $cDpdq = parcelRequire("cDpdq");

const $0e60b1a500b568da$export$2a89c15ccab17d33 = (0, $dOBRD.default)((product)=>{
    /**
   * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
   * (only supports Cloud single-issue URLs right now)
   */ const smartLinksBeforeMacros = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
    // Make smart links connect to staging when developing locally.
    const environment = undefined;
    const cardProvider = Promise.resolve(new (0, $6RwwD.EditorCardProvider)(environment, undefined, product));
    // IMPORTANT: If you change the code below, please also update the
    // platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/pastePluginOptions.ts
    // platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/cardPluginOptions.ts
    return {
        provider: cardProvider,
        resolveBeforeMacros: smartLinksBeforeMacros,
        allowBlockCards: true,
        allowEmbeds: true
    };
});
const $0e60b1a500b568da$export$5681a80d8b7b2bfb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (product)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== product) {
        t0 = $0e60b1a500b568da$export$2a89c15ccab17d33(product);
        $[0] = product;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (product)=>{
    return (0, $cozmU.useMemo)(()=>{
        return $0e60b1a500b568da$export$2a89c15ccab17d33(product);
    }, [
        product
    ]);
};
const $0e60b1a500b568da$export$535281304894bcdc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (product, cardOptions)=>{
    const $ = (0, $bDgLe.c)(3);
    const baseSmartLinks = $0e60b1a500b568da$export$5681a80d8b7b2bfb(product);
    let t0;
    if ($[0] !== baseSmartLinks || $[1] !== cardOptions) {
        t0 = {
            linking: {
                smartLinks: {
                    ...baseSmartLinks,
                    ...cardOptions
                }
            }
        };
        $[0] = baseSmartLinks;
        $[1] = cardOptions;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (product, cardOptions)=>{
    const baseSmartLinks = $0e60b1a500b568da$export$5681a80d8b7b2bfb(product);
    return (0, $cozmU.useMemo)(()=>({
            linking: {
                smartLinks: {
                    ...baseSmartLinks,
                    ...cardOptions
                }
            }
        }), [
        baseSmartLinks,
        cardOptions
    ]);
};
const $0e60b1a500b568da$export$78db118acf87bd21 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (product, options, cloudId, linkPickerOptions)=>{
    const $ = (0, $bDgLe.c)(15);
    const config = $0e60b1a500b568da$export$535281304894bcdc(product, options);
    let t0;
    if ($[0] !== cloudId || $[1] !== product) {
        t0 = {
            product: product,
            cloudId: cloudId
        };
        $[0] = cloudId;
        $[1] = product;
        $[2] = t0;
    } else t0 = $[2];
    const productConfig = t0;
    const linkPickerProps = (0, $cDpdq.useLinkPickerEditorProps)(undefined, productConfig);
    const linkPickerPlugins = linkPickerOptions?.linkPickerPlugins;
    const t1 = config.linking?.linkPicker;
    let t2;
    if ($[3] !== linkPickerPlugins) {
        t2 = linkPickerPlugins && {
            plugins: linkPickerPlugins
        };
        $[3] = linkPickerPlugins;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== linkPickerProps || $[6] !== t1 || $[7] !== t2) {
        t3 = {
            ...t1,
            ...linkPickerProps,
            ...t2
        };
        $[5] = linkPickerProps;
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    const t4 = config.linking?.smartLinks;
    let t5;
    if ($[9] !== t4) {
        t5 = {
            ...t4
        };
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== config.linking || $[12] !== t3 || $[13] !== t5) {
        t6 = {
            linking: {
                ...config.linking,
                linkPicker: t3,
                smartLinks: t5
            }
        };
        $[11] = config.linking;
        $[12] = t3;
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    return t6;
} : (product, options, cloudId, linkPickerOptions)=>{
    const config = $0e60b1a500b568da$export$535281304894bcdc(product, options);
    const productConfig = (0, $cozmU.useMemo)(()=>({
            product: product,
            cloudId: cloudId
        }), [
        product,
        cloudId
    ]);
    const linkPickerProps = (0, $cDpdq.useLinkPickerEditorProps)(undefined, productConfig);
    const linkPickerPlugins = linkPickerOptions?.linkPickerPlugins;
    return (0, $cozmU.useMemo)(()=>({
            linking: {
                ...config.linking,
                linkPicker: {
                    ...config.linking?.linkPicker,
                    ...linkPickerProps,
                    ...linkPickerPlugins && {
                        plugins: linkPickerPlugins
                    }
                },
                smartLinks: {
                    ...config.linking?.smartLinks
                }
            }
        }), [
        config,
        linkPickerProps,
        linkPickerPlugins
    ]);
};
const $0e60b1a500b568da$export$9b0cf83b2bedfd63 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, options: options, cloudId: cloudId, product: t1, linkPickerOptions: linkPickerOptions } = t0;
    const product = t1 === undefined ? "CONFLUENCE" : t1;
    const mergedProps = $0e60b1a500b568da$export$78db118acf87bd21(product, options, cloudId, linkPickerOptions);
    let t2;
    if ($[0] !== children || $[1] !== mergedProps) {
        t2 = children(mergedProps);
        $[0] = children;
        $[1] = mergedProps;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children, options: options, cloudId: cloudId, product: product = 'CONFLUENCE', linkPickerOptions: linkPickerOptions })=>{
    const mergedProps = $0e60b1a500b568da$export$78db118acf87bd21(product, options, cloudId, linkPickerOptions);
    return children(mergedProps);
};
module.exports["EditorLinkingFeatures"] = $0e60b1a500b568da$export$9b0cf83b2bedfd63;

});

parcelRegister("kETeF", function(module, exports) {
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $1UWNP = parcelRequire("1UWNP");


var $kwzZh = parcelRequire("kwzZh");

const $832ae9c6f820540e$var$BASE_URL = '/gateway/api/emoji';
const $832ae9c6f820540e$var$getEmojiConfig = (cloudId, userId, disableUpload, emojiSSRConfig, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const providers = [
        {
            url: `${$832ae9c6f820540e$var$BASE_URL}/standard`
        },
        {
            url: `${$832ae9c6f820540e$var$BASE_URL}/atlassian`
        }
    ];
    if (cloudId) providers.push({
        url: `${$832ae9c6f820540e$var$BASE_URL}/${cloudId}/site`
    });
    const config = {
        providers: providers,
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks || {}
    };
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $832ae9c6f820540e$var$resolverOfMemoize = (extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const disableUpload = extraConfig?.disableUpload ?? false;
    const emojiSSRConfigString = extraConfig?.emojiSSRConfig ? JSON.stringify(extraConfig.emojiSSRConfig) : '';
    return `${cloudId}_${userId}_${disableUpload}_${emojiSSRConfigString}`;
};
const $832ae9c6f820540e$var$getEmojiResource = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const emojiConfig = $832ae9c6f820540e$var$getEmojiConfig(cloudId, userId, disableUpload, emojiSSRConfig);
    return new (0, $kwzZh.default)(emojiConfig);
}, $832ae9c6f820540e$var$resolverOfMemoize);
const $832ae9c6f820540e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((extraConfig)=>{
    const emojiResource = $832ae9c6f820540e$var$getEmojiResource(extraConfig);
    return emojiResource.getEmojiProvider();
}, $832ae9c6f820540e$var$resolverOfMemoize);
module.exports["getEmojiProvider"] = $832ae9c6f820540e$export$8210f5f78c0bcf27;

});

parcelRegister("jcnIS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3cB3o = parcelRequire("3cB3o");


var $FSvRW = parcelRequire("FSvRW");


var $hjUDQ = parcelRequire("hjUDQ");

var $4pfdN = parcelRequire("4pfdN");


var $4pBmf = parcelRequire("4pBmf");


var $6Rsxa = parcelRequire("6Rsxa");


var $6THkE = parcelRequire("6THkE");


var $87QCv = parcelRequire("87QCv");


var $aNrj7 = parcelRequire("aNrj7");


var $bm134 = parcelRequire("bm134");

const $0434f6981cf431fe$export$c7edf67c9c07ecac = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(13);
    const { contentId: contentId, intl: intl, PropsProvider: PropsProvider, editorActions: editorActions, openConfigPanel: openConfigPanel } = props;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const [extensionProviders, setExtensionProviders] = (0, $cozmU.useState)(t0);
    const theming = (0, $4pBmf.useHubTheming)();
    const palette = theming?.isAdvancedThemingEnabled ? theming.palette : undefined;
    const isBrandPaletteLocked = theming?.isBrandPaletteLocked;
    const primaryColor = theming?.primaryColor;
    let t1;
    if ($[1] !== PropsProvider || $[2] !== contentId || $[3] !== editorActions || $[4] !== intl || $[5] !== isBrandPaletteLocked || $[6] !== openConfigPanel || $[7] !== palette || $[8] !== primaryColor) {
        t1 = async ()=>{
            const hubExtensionProviders = [];
            const defaultExtensionProviderProps = {
                contentId: contentId,
                propsProvider: PropsProvider,
                mode: (0, $hjUDQ.ExtensionMode).EDITOR,
                defaultParameters: (0, $4pfdN.getHubDefaultParameters)({
                    palette: palette,
                    isBrandPaletteLocked: isBrandPaletteLocked,
                    primaryColor: primaryColor
                })
            };
            const defaultExtensionInstanceProps = {
                editorActions: editorActions,
                openConfigPanel: openConfigPanel,
                intl: intl,
                contentId: contentId
            };
            try {
                const DEFAULT_EXTENSION_PROVIDERS = [
                    (0, $aNrj7.spotlightExtensionProvider),
                    (0, $6THkE.linksMenuExtensionProvider),
                    (0, $3cB3o.cardsExtensionProvider),
                    (0, $FSvRW.carouselExtensionProvider)
                ];
                DEFAULT_EXTENSION_PROVIDERS.forEach(async (extensionProvider)=>{
                    const providerInstance = await extensionProvider(defaultExtensionProviderProps);
                    const provider = await providerInstance(defaultExtensionInstanceProps);
                    hubExtensionProviders.push(provider);
                });
                const sectionExtProviderInstance = await (0, $87QCv.sectionExtensionProvider)({
                    ...defaultExtensionProviderProps,
                    defaultParameters: (0, $4pfdN.getHubDefaultParameters)({
                        palette: palette,
                        element: "section",
                        isBrandPaletteLocked: isBrandPaletteLocked,
                        primaryColor: primaryColor
                    }),
                    getSectionExtensionContents: $bm134.getSectionExtensionContents
                });
                const sectionExtProvider = await sectionExtProviderInstance(defaultExtensionInstanceProps);
                hubExtensionProviders.push(sectionExtProvider);
                const hubElementPlaceholderExtensionProviderInstance = await (0, $6Rsxa.hubElementPlaceholderExtensionProvider)(defaultExtensionInstanceProps);
                hubExtensionProviders.push(hubElementPlaceholderExtensionProviderInstance);
                setExtensionProviders(hubExtensionProviders);
            } catch (t2) {
                const error = t2;
            }
        };
        $[1] = PropsProvider;
        $[2] = contentId;
        $[3] = editorActions;
        $[4] = intl;
        $[5] = isBrandPaletteLocked;
        $[6] = openConfigPanel;
        $[7] = palette;
        $[8] = primaryColor;
        $[9] = t1;
    } else t1 = $[9];
    const loadProviders = t1;
    let t2;
    let t3;
    if ($[10] !== loadProviders) {
        t2 = ()=>{
            loadProviders();
        };
        t3 = [
            loadProviders
        ];
        $[10] = loadProviders;
        $[11] = t2;
        $[12] = t3;
    } else {
        t2 = $[11];
        t3 = $[12];
    }
    (0, $cozmU.useEffect)(t2, t3);
    return extensionProviders;
} : (props)=>{
    const { contentId: contentId, intl: intl, PropsProvider: PropsProvider, editorActions: editorActions, openConfigPanel: openConfigPanel } = props;
    const [extensionProviders, setExtensionProviders] = (0, $cozmU.useState)([]);
    // When advanced theming is enabled, seed new extension instances with
    // palette-backed default colors (e.g. var(--hub-color-primary-200)). Falls
    // back to legacy single-color defaults when the framework isn't mounted.
    const theming = (0, $4pBmf.useHubTheming)();
    const palette = theming?.isAdvancedThemingEnabled ? theming.palette : undefined;
    const isBrandPaletteLocked = theming?.isBrandPaletteLocked;
    const primaryColor = theming?.primaryColor;
    const loadProviders = (0, $cozmU.useCallback)(async ()=>{
        const hubExtensionProviders = [];
        const defaultExtensionProviderProps = {
            contentId: contentId,
            propsProvider: PropsProvider,
            mode: (0, $hjUDQ.ExtensionMode).EDITOR,
            defaultParameters: (0, $4pfdN.getHubDefaultParameters)({
                palette: palette,
                isBrandPaletteLocked: isBrandPaletteLocked,
                primaryColor: primaryColor
            })
        };
        const defaultExtensionInstanceProps = {
            editorActions: editorActions,
            openConfigPanel: openConfigPanel,
            intl: intl,
            contentId: contentId
        };
        try {
            const DEFAULT_EXTENSION_PROVIDERS = [
                (0, $aNrj7.spotlightExtensionProvider),
                (0, $6THkE.linksMenuExtensionProvider),
                (0, $3cB3o.cardsExtensionProvider),
                (0, $FSvRW.carouselExtensionProvider)
            ];
            DEFAULT_EXTENSION_PROVIDERS.forEach(async (extensionProvider)=>{
                const providerInstance = await extensionProvider(defaultExtensionProviderProps);
                const provider = await providerInstance(defaultExtensionInstanceProps);
                hubExtensionProviders.push(provider);
            });
            // section provider — uses the section-specific bg shade (accent.100)
            // when advanced theming is on; otherwise inherits the generic seed.
            const sectionExtProviderInstance = await (0, $87QCv.sectionExtensionProvider)({
                ...defaultExtensionProviderProps,
                defaultParameters: (0, $4pfdN.getHubDefaultParameters)({
                    palette: palette,
                    element: 'section',
                    isBrandPaletteLocked: isBrandPaletteLocked,
                    primaryColor: primaryColor
                }),
                getSectionExtensionContents: $bm134.getSectionExtensionContents
            });
            const sectionExtProvider = await sectionExtProviderInstance(defaultExtensionInstanceProps);
            hubExtensionProviders.push(sectionExtProvider);
            const hubElementPlaceholderExtensionProviderInstance = await (0, $6Rsxa.hubElementPlaceholderExtensionProvider)(defaultExtensionInstanceProps);
            hubExtensionProviders.push(hubElementPlaceholderExtensionProviderInstance);
            setExtensionProviders(hubExtensionProviders);
        } catch (error) {
        // todo: log error to analytics
        }
    }, [
        editorActions,
        openConfigPanel,
        intl,
        PropsProvider,
        contentId,
        palette,
        isBrandPaletteLocked,
        primaryColor
    ]);
    (0, $cozmU.useEffect)(()=>{
        loadProviders();
    }, [
        loadProviders
    ]);
    return extensionProviders;
};
module.exports["useHubExtensionProviders"] = $0434f6981cf431fe$export$c7edf67c9c07ecac;

});

parcelRegister("fXxXz", function(module, exports) {
const $2121ccb7c28b974f$export$c5dfd3b79761d51f = {
    allowDatasource: true
};
const $2121ccb7c28b974f$export$71250061dd993259 = true;
module.exports["LINKING_FEATURES_CARD_OPTIONS"] = $2121ccb7c28b974f$export$c5dfd3b79761d51f;
module.exports["IS_UPLOAD_MEDIA_CONFIG_REQUIRED"] = $2121ccb7c28b974f$export$71250061dd993259;

});

parcelRegister("9YzZs", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $aMXsk = parcelRequire("aMXsk");

function $8fd9040868868fa3$export$3f6a2f4541d2f102(props) {
    const { intl: intl, mediaOptions: mediaOptions, linkPickerOptions: linkPickerOptions, featureFlags: featureFlags, isEditingLocked: isEditingLocked } = props;
    const isTemplateLocked = Boolean(props.isTemplateLocked);
    const __livePage = false;
    // const editorPluginAIOptions = createPageEditorPluginAIOptions({
    // 	product,
    // 	aiGlobalOptIn: { status: 'disabled', triggerOptInFlow: () => { } },
    // 	PromptEditor: createPromptEditor({
    // 		enableLinks: false,
    // 		linking: {
    // 			smartLinks: { provider: undefined },
    // 		},
    // 		mentionProvider: undefined,
    // 		featureFlags: {},
    // 	}),
    // 	isRovoEnabled: false,
    // });
    return (0, $aMXsk.hubPreset)({
        intl: intl,
        pluginOptions: {
            base: {
                __livePage: __livePage
            },
            helpDialog: {
                imageUploadProviderExists: Boolean(mediaOptions?.provider),
                aiEnabled: false
            },
            hyperlink: {
                linkPicker: {
                    plugins: linkPickerOptions?.linkPickerPlugins || []
                },
                onClickCallback: undefined
            },
            quickInsert: {
                emptyStateHandler: undefined,
                quickInsert: props.quickInsert,
                isTemplateLocked: isTemplateLocked
            },
            placeholder: {
                viewMode: props.viewMode,
                isAIEnabled: false
            },
            selection: {
                __livePage: __livePage
            },
            editorDisabled: {
                disabled: isEditingLocked || undefined
            },
            annotation: {
                annotationManager: undefined,
                createCommentExperience: undefined,
                selectCommentExperience: undefined,
                viewInlineCommentTraceUFOPress: undefined
            },
            tasksAndDecisions: {
                hasEditPermission: props.hasEditPermission,
                requestToEditContent: undefined,
                hasRequestedEditPermission: undefined
            },
            contextPanel: props.contextPanelOptions ? {
                objectSideBar: props.contextPanelOptions.objectSideBar
            } : undefined,
            extension: {
                extensionHandlers: props.extensionHandlers,
                __rendererExtensionOptions: props.__rendererExtensionOptions,
                getExtensionHeight: props.getExtensionHeight,
                isTemplateLocked: isTemplateLocked
            },
            card: {
                __livePage: __livePage,
                linkPicker: props.linking?.linkPicker,
                onClickCallback: props.linking?.smartLinks?.onClickCallback
            },
            avatarGroup: {
                collabEdit: undefined
            },
            // ai: editorPluginAIOptions,
            loom: {
                renderButton: ()=>null
            },
            editorViewMode: {
                viewMode: props.viewMode
            },
            // aiDefinitions: props.editorPluginAIDefinitionsConfig,
            selectionMarker: {
                __livePage: __livePage
            },
            engagementPlatform: {
                coordinationClient: {
                    start: ()=>Promise.resolve(false),
                    stop: ()=>Promise.resolve(false)
                }
            },
            selectionExtension: {},
            metrics: {},
            primaryToolbar: {
                contextualFormattingEnabled: true
            },
            selectionToolbar: {
                contextualFormattingEnabled: true
            }
        },
        providers: {
            userPreferencesProvider: props.userPreferencesProvider,
            userPreferencesProviderNext: props.userPreferencesProviderNext,
            cardProvider: props.linking?.smartLinks?.provider,
            contextIdentifierProvider: props.contextIdentifierProvider,
            inlineCommentAnnotationProvider: props.annotationProviders?.inlineComment,
            mediaProvider: mediaOptions?.provider,
            syncMediaProvider: props.media?.syncProvider,
            mentionProvider: props.mentionProvider,
            profilecardProvider: props.mention?.profilecardProvider,
            emojiProvider: props.emojiProvider,
            autoformattingProvider: props.autoformattingProvider,
            taskDecisionProvider: props.taskDecisionProvider
        },
        enabledOptionalPlugins: {
            // Must stay on when locked: dropping it makes `areToolbarFlagsEnabled`
            // false, which downgrades the editor to legacy chrome and renders a full
            // primary toolbar at the top.
            toolbar: true,
            // A locked template has no drag handles to reorder with and no insert
            // menu to add from; the guard plugin refuses both anyway.
            blockControls: !isTemplateLocked,
            insertBlock: !isTemplateLocked,
            hubTemplateLock: isTemplateLocked,
            findReplace: Boolean(props.allowFindReplace),
            loom: props.isLoomPluginEnabled,
            aiDefinitions: props.editorPluginAIDefinitionsEnabled,
            connectivity: props.isDesktop,
            metrics: (0, $iDrrr.fg)('platform_editor_ease_of_use_metrics'),
            codeBlockAdvanced: true,
            selectionExtension: (0, $ieeJu.expValEquals)('platform_editor_controls', 'cohort', 'variant1'),
            // aiExperience: Boolean(props.editorPluginAIOptions?.aiGlobalOptIn?.status !== 'disabled'),
            interaction: true,
            userPreferences: true,
            companyHubTextColor: props.editorPluginHubTextColorEnabled ?? false,
            // This plugin provides support for showing an indicator when we drag and drop components from components panel
            hubExternalInsert: featureFlags?.hub_editor_floating_toolbar ?? false
        }
    });
}
module.exports["createHubEditorPreset"] = $8fd9040868868fa3$export$3f6a2f4541d2f102;

});

parcelRegister("2rwbd", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $r8hvx = parcelRequire("r8hvx");


var $fXxXz = parcelRequire("fXxXz");

const $9fce710bde60562d$export$74fedad14355d824 = ({ contentId: contentId, editorAPI: editorAPI, customMediaProvider: customMediaProvider, mediaConfig: mediaConfig })=>{
    const resolver = (0, $cozmU.useRef)();
    (0, $cozmU.useEffect)(()=>{
        if (!contentId) return;
        const createMediaProvider = ()=>{
            return (0, $r8hvx.getMediaProvider)(mediaConfig?.mediaCollectionName ?? '', mediaConfig?.asapIssuer ?? '', mediaConfig?.mediaToken ?? '', mediaConfig?.mediaUrl ?? '', (0, $fXxXz.IS_UPLOAD_MEDIA_CONFIG_REQUIRED));
        };
        const mediaProvider = createMediaProvider();
        if (mediaProvider) {
            if (editorAPI?.media?.actions) editorAPI.media.actions.setProvider(Promise.resolve(mediaProvider));
            if (resolver.current) resolver.current(mediaProvider);
        }
    }, [
        contentId,
        mediaConfig,
        editorAPI
    ]);
    return (0, $cozmU.useMemo)(()=>{
        const provider = customMediaProvider ?? new Promise((resolve)=>{
            resolver.current = resolve;
        });
        return {
            provider: provider,
            allowMediaSingle: true,
            allowMediaGroup: true,
            allowResizing: true,
            allowLinking: true,
            allowResizingInTables: true,
            allowAltTextOnImages: true,
            allowMediaSingleEditable: true,
            allowRemoteDimensionsFetch: true,
            allowCaptions: true,
            allowLazyLoading: true,
            allowAdvancedToolBarOptions: true,
            allowDropzoneDropLine: true,
            allowTemplatePlaceholders: true,
            featureFlags: {}
        };
    }, [
        customMediaProvider
    ]);
};
module.exports["useMediaOptions"] = $9fce710bde60562d$export$74fedad14355d824;

});

parcelRegister("8XweJ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $848606140a75633f$var$_default_1 = (0, $kSwu1.defineMessages)({
    hubStudioLoadingSpinnerLabel: {
        id: "hub-editor.loading-spinner-label",
        defaultMessage: "Loading hub"
    }
});
var $848606140a75633f$export$2e2bcd8739ae039 = $848606140a75633f$var$_default_1;
module.exports["default"] = $848606140a75633f$export$2e2bcd8739ae039;

});

parcelRegister("ayVUo", function(module, exports) {
const $7b09ffcb6b77a96c$export$881d135f98d8d7d0 = 100;
const $7b09ffcb6b77a96c$export$9ab5bdcb8a1d6c34 = false;
const $7b09ffcb6b77a96c$export$12c1dc38ea1692da = 0;
module.exports["DEFAULT_CACHE_MAX_LIMIT"] = $7b09ffcb6b77a96c$export$881d135f98d8d7d0;
module.exports["DEFAULT_RESOURCE_BROWSER_ONLY"] = $7b09ffcb6b77a96c$export$9ab5bdcb8a1d6c34;
module.exports["DEFAULT_RESOURCE_MAX_AGE"] = $7b09ffcb6b77a96c$export$12c1dc38ea1692da;

});

parcelRegister("cK9FA", function(module, exports) {
const $947148201ec260dc$var$VALID_LINK_TYPES = [
    'a',
    'button'
];
const $947148201ec260dc$export$855ece989b15eb57 = (type)=>$947148201ec260dc$var$VALID_LINK_TYPES.includes(type) ? type : 'a';
module.exports["getValidLinkType"] = $947148201ec260dc$export$855ece989b15eb57;

});

parcelRegister("bHq0V", function(module, exports) {
const $d4fc30302334d642$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $d4fc30302334d642$export$130b789831072f4c = (event)=>[
        'keypress',
        'keydown',
        'keyup'
    ].includes(event.type);


const $8847e3ab0aa88b0e$export$706ad1af8096e280 = (event, { onClick: onClick, target: target, replace: replace, routerActions: routerActions, href: href, to: to, state: state })=>{
    if ((0, $d4fc30302334d642$export$130b789831072f4c)(event) && event.key !== 'Enter') return;
    onClick && onClick(event);
    if (!event.defaultPrevented && // onClick prevented default
    ((0, $d4fc30302334d642$export$130b789831072f4c)(event) && event.key === 'Enter' || event.button === 0) && // ignore everything but left clicks and Enter key
    (!target || target === '_self') && // let browser handle "target=_blank" etc.
    !(0, $d4fc30302334d642$export$642c6f14f6d4bbd5)(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        if (to) {
            const method = replace ? routerActions.replaceTo : routerActions.pushTo;
            method(...to, state);
        } else {
            const method = replace ? routerActions.replace : routerActions.push;
            method(href, state);
        }
    }
};
module.exports["handleNavigation"] = $8847e3ab0aa88b0e$export$706ad1af8096e280;

});

parcelRegister("8PAPC", function(module, exports) {
const $66dfa8208bd42e69$export$9ccb639b7a119f61 = ()=>Date.now();
module.exports["getAccessedAt"] = $66dfa8208bd42e69$export$9ccb639b7a119f61;

});

parcelRegister("59XiK", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $gD7r0 = parcelRequire("gD7r0");


var $ejHIX = parcelRequire("ejHIX");


var $9ou2L = parcelRequire("9ou2L");


var $8MtAf = parcelRequire("8MtAf");

const $5fd15fe2b7c3d3e5$export$37d3126be6549b13 = 10000;


function $3c1bcb0519a04560$export$dc62515c8f0b52dd({ context: context, dependencies: dependencies, options: options, resource: resource, routerStoreContext: routerStoreContext }) {
    var _promiseOrData, _resource$maxAge;
    const { type: type, getData: getData } = resource;
    const { prefetch: prefetch, timeout: timeout } = options;
    // hard errors in dependencies or getData are converted into softer async error
    let promiseOrData;
    try {
        promiseOrData = getData((0, $eb3ax.default)({}, routerStoreContext, {
            isPrefetch: !!prefetch,
            dependencies: dependencies()
        }), context);
    } catch (error) {
        promiseOrData = Promise.reject(error);
    }
    // ensure the promise includes any timeout error
    const timeoutGuard = timeout ? (0, $9ou2L.generateTimeGuard)(timeout) : null;
    // check if getData was sync, by looking for a Promise-like shape
    const data = typeof ((_promiseOrData = promiseOrData) == null ? void 0 : _promiseOrData.then) === 'function' ? undefined : promiseOrData;
    const promise = timeout ? Promise.race([
        promiseOrData,
        timeoutGuard == null ? void 0 : timeoutGuard.promise
    ]).then((maybeData)=>{
        if (timeoutGuard && !timeoutGuard.isPending) throw new (0, $8MtAf.TimeoutError)(type);
        (timeoutGuard == null ? void 0 : timeoutGuard.timerId) && clearTimeout(timeoutGuard.timerId);
        return maybeData;
    }) : // if we already have a result, wrap it so consumers can access it via same API
    data !== undefined ? Promise.resolve(data) : promiseOrData;
    const resourceMaxAge = (0, $ejHIX.getExpiresAt)((_resource$maxAge = resource.maxAge) != null ? _resource$maxAge : (0, $gD7r0.DEFAULT_RESOURCE_MAX_AGE));
    return {
        promise: promise,
        data: data,
        expiresAt: prefetch ? Math.max(resourceMaxAge, (0, $ejHIX.getExpiresAt)((0, $5fd15fe2b7c3d3e5$export$37d3126be6549b13))) : resourceMaxAge
    };
}
module.exports["createLoadingSlice"] = $3c1bcb0519a04560$export$dc62515c8f0b52dd;

});

parcelRegister("kP3dg", function(module, exports) {

var $gD7r0 = parcelRequire("gD7r0");

/**
 * Utility method to created async versions of getData functions
 */ const $f28b101a533d77cb$var$handleGetDataLoader = (asyncImport)=>async (...args)=>{
        const { default: getDataFn } = await asyncImport();
        return getDataFn(...args);
    };
const $f28b101a533d77cb$export$edd172c6c83c39cc = (arg)=>{
    var _getData, _arg$depends;
    return {
        type: arg.type,
        getKey: arg.getKey,
        getData: (_getData = arg.getData) != null ? _getData : $f28b101a533d77cb$var$handleGetDataLoader(arg.getDataLoader),
        maxAge: typeof arg.maxAge === 'number' ? arg.maxAge : (0, $gD7r0.DEFAULT_RESOURCE_MAX_AGE),
        maxCache: typeof arg.maxCache === 'number' ? arg.maxCache : (0, $gD7r0.DEFAULT_CACHE_MAX_LIMIT),
        isBrowserOnly: typeof arg.isBrowserOnly === 'boolean' ? arg.isBrowserOnly : (0, $gD7r0.DEFAULT_RESOURCE_BROWSER_ONLY),
        depends: (_arg$depends = arg.depends) != null ? _arg$depends : null
    };
};

});

parcelRegister("l6MXV", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $abmiw = parcelRequire("abmiw");


var $1hI4C = parcelRequire("1hI4C");

var $f5e02408fa722745$var$_Object$fromEntries;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
const $f5e02408fa722745$var$fromEntries = ($f5e02408fa722745$var$_Object$fromEntries = Object.fromEntries) != null ? $f5e02408fa722745$var$_Object$fromEntries : (entries)=>Object.assign({}, ...entries.map(([k, v])=>({
            [k]: v
        })));
const $f5e02408fa722745$var$matchType = (a)=>(b)=>{
        const [{ type: typeA }] = Array.isArray(a) ? a : [
            a
        ];
        const [{ type: typeB }] = Array.isArray(b) ? b : [
            b
        ];
        return typeA === typeB;
    };
class $f5e02408fa722745$export$492ad57edfe1e919 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResourceDependencyError';
    }
}
const $f5e02408fa722745$export$12600f2e0e7fb2cc = (routeResources, tuples)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        var _routeResources$some;
        if (getState().executing) throw new Error('execution is already in progress');
        // check if there are resources and if so if there are any resources with dependencies
        const hasDependentResources = (_routeResources$some = routeResources == null ? void 0 : routeResources.some(({ depends: depends })=>depends == null ? void 0 : depends.length)) != null ? _routeResources$some : false;
        if (!hasDependentResources) return tuples.map(([, action])=>dispatch(action));
        // some resources might not be listed on the route resources so must be dispatched separate from executing state
        const listedTuples = tuples.filter(([resource])=>routeResources == null ? void 0 : routeResources.some($f5e02408fa722745$var$matchType(resource)));
        if (listedTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // accumulate the dependency types for all executing resources
        // find downstream resources that may also execute and include their dependencies too
        // include the resource type as well in the list
        // we don't validate that these are legal dependencies
        const [dependentTypes] = routeResources.reduce((acc, { type: type, depends: depends })=>{
            const [dependencies, executableTypes] = acc;
            const isExecutable = executableTypes.includes(type) || !!(depends != null && depends.some((dependency)=>executableTypes.includes(dependency)));
            return isExecutable ? [
                depends ? [
                    ...dependencies,
                    ...depends,
                    type
                ] : dependencies,
                [
                    ...executableTypes,
                    type
                ]
            ] : acc;
        }, [
            [],
            listedTuples.map(([{ type: type }])=>type)
        ]).filter((v, i, a)=>a.indexOf(v) === i);
        // resources that are completely independent are preferable to be dispatched separate from executing state
        const dependentTuples = listedTuples.filter(([{ type: type }])=>dependentTypes.includes(type));
        if (dependentTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // additionally find all direct dependencies of these executing or possibly executing resources
        // we don't validate that these are legal dependencies
        const dependentAndDependencyTypes = routeResources.filter(({ type: type })=>dependentTypes.includes(type)).reduce((acc, { type: type, depends: depends })=>depends ? [
                ...acc,
                ...depends,
                type
            ] : [
                ...acc,
                type
            ], []).filter((v, i, a)=>a.indexOf(v) === i);
        // setup executing tuples in route resource order
        // this state allows actions to call executeForDependents() to influence actions that follow
        // the list includes dependency resources so that getDependencies() may validate without needing route resources
        // we use the resource definition of the given tuple where present or otherwise the definition from route resources
        const executingTuples = routeResources.filter(({ type: type })=>dependentAndDependencyTypes.includes(type)).map((resource)=>{
            var _tuples$find;
            return (_tuples$find = tuples.find($f5e02408fa722745$var$matchType(resource))) != null ? _tuples$find : [
                resource,
                null
            ];
        });
        setState({
            executing: executingTuples
        });
        // dispatch sequentially during which executeForDependents() can cause tuples to change
        const executedResults = executingTuples.map(([{ type: expectedType }], i)=>{
            var _getState$executing;
            const latestTuple = (_getState$executing = getState().executing) == null ? void 0 : _getState$executing[i];
            const [{ type: latestType }, maybeAction] = latestTuple != null ? latestTuple : [
                {}
            ];
            if (latestType !== expectedType) {
                setState({
                    executing: null
                });
                throw new Error('execution reached an inconsistent state');
            }
            return maybeAction ? dispatch(maybeAction) : undefined;
        });
        setState({
            executing: null
        });
        // pick existing execution result or dispatch any remaining independent actions
        return tuples.map(([resource, action])=>{
            const index = executingTuples.findIndex($f5e02408fa722745$var$matchType(resource));
            return index < 0 ? dispatch(action) : executedResults[index];
        });
    };
const $f5e02408fa722745$export$5f7e1fd85734e71e = (routeResources, resource, action)=>({ dispatch: dispatch })=>dispatch($f5e02408fa722745$export$12600f2e0e7fb2cc(routeResources, [
            [
                resource,
                action
            ]
        ]))[0];
const $f5e02408fa722745$export$f71a65c89c987a02 = (routeResources, resources, actionCreator)=>$f5e02408fa722745$export$12600f2e0e7fb2cc(routeResources, resources.map((resource)=>[
            resource,
            actionCreator(resource)
        ]));
const $f5e02408fa722745$export$7d1ffac63c68405d = (resource, actionCreator)=>({ getState: getState, setState: setState })=>{
        var _tuples$findIndex;
        const { executing: tuples } = getState();
        // find the given resource in the currently executing tuples
        const indexForResource = (_tuples$findIndex = tuples == null ? void 0 : tuples.findIndex($f5e02408fa722745$var$matchType(resource))) != null ? _tuples$findIndex : -1;
        if (indexForResource < 0) return;
        // find dependent resources following given resource and revise their action
        const executing = tuples.map((tuple, i)=>{
            var _tupleResource$depend;
            const [tupleResource] = tuple;
            return i > indexForResource && (_tupleResource$depend = tupleResource.depends) != null && _tupleResource$depend.includes(resource.type) ? [
                tupleResource,
                actionCreator(tupleResource)
            ] : tuple;
        });
        setState({
            executing: executing
        });
    };
const $f5e02408fa722745$export$75915f81f2a6540a = (resource, routerStoreContext, options)=>({ getState: getState, dispatch: dispatch })=>{
        var _tuples$findIndex2;
        const { type: type, depends: depends } = resource;
        // optimise the case of no dependencies
        if (!(depends != null && depends.length)) return {};
        const { executing: tuples, context: resourceStoreContext } = getState();
        // dependent resource cannot be called outside execution state
        // find the given resource type in the currently executing tuples
        const indexForResource = (_tuples$findIndex2 = tuples == null ? void 0 : tuples.findIndex($f5e02408fa722745$var$matchType(resource))) != null ? _tuples$findIndex2 : -1;
        if (indexForResource < 0) throw new $f5e02408fa722745$export$492ad57edfe1e919(`Missing resource: "${type}" has dependencies so must not be missing`);
        // find tuples index for all the dependency elements
        const dependencyIndexTuples = depends.map((dependency)=>[
                dependency,
                tuples.findIndex($f5e02408fa722745$var$matchType({
                    type: dependency
                }))
            ]);
        // we rely on executing tuples including all dependencies of the caller resource
        dependencyIndexTuples.forEach(([dependency, index])=>{
            if (index < 0) throw new $f5e02408fa722745$export$492ad57edfe1e919(`Missing resource: "${type}" depends "${dependency}" which is missing`);
            if (index > indexForResource) throw new $f5e02408fa722745$export$492ad57edfe1e919(`Illegal dependency: "${type}" depends "${dependency}" so "${dependency}" must precede "${type}"`);
        });
        return $f5e02408fa722745$var$fromEntries(dependencyIndexTuples.map(([dependencyType, index])=>{
            const { getKey: getKey } = tuples[index][0];
            const key = getKey(routerStoreContext, resourceStoreContext);
            let slice = dispatch((0, $1hI4C.getResourceState)(dependencyType, key)) || (0, $abmiw.getDefaultStateSlice)();
            // when prefetching we provide only the promise to dependands
            const prefetchSlice = options.prefetch ? dispatch((0, $1hI4C.getPrefetchSlice)(dependencyType, key)) : undefined;
            if (prefetchSlice) slice = (0, $eb3ax.default)({}, slice, {
                // not spreading prefetchSlice to persist previous slice data
                promise: prefetchSlice.promise,
                expiresAt: prefetchSlice.expiresAt,
                loading: true
            });
            return [
                dependencyType,
                slice
            ];
        }));
    };
module.exports["actionWithDependencies"] = $f5e02408fa722745$export$5f7e1fd85734e71e;
module.exports["mapActionWithDependencies"] = $f5e02408fa722745$export$f71a65c89c987a02;
module.exports["executeForDependents"] = $f5e02408fa722745$export$7d1ffac63c68405d;
module.exports["getDependencies"] = $f5e02408fa722745$export$75915f81f2a6540a;

});

parcelRegister("ejHIX", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");

const $a6c4c1bc3da909d9$export$b65d7ba7fbf150f1 = (maxAge)=>Date.now() + maxAge;
const $a6c4c1bc3da909d9$export$18d1d420fd588368 = (slice, maxAge)=>slice.expiresAt === null ? (0, $eb3ax.default)({}, slice, {
        expiresAt: $a6c4c1bc3da909d9$export$b65d7ba7fbf150f1(maxAge)
    }) : slice;
module.exports["getExpiresAt"] = $a6c4c1bc3da909d9$export$b65d7ba7fbf150f1;
module.exports["setExpiresAt"] = $a6c4c1bc3da909d9$export$18d1d420fd588368;

});

parcelRegister("9ou2L", function(module, exports) {
const $6d6da8f737e3708e$export$58634b3a58ae66b7 = (duration)=>{
    const promiseState = {
        timerId: null,
        isPending: true,
        promise: undefined
    };
    promiseState.promise = new Promise((r)=>{
        const timerId = setTimeout(()=>{
            promiseState.isPending = false;
            r();
        }, duration);
        promiseState.timerId = timerId;
    });
    return promiseState;
};
module.exports["generateTimeGuard"] = $6d6da8f737e3708e$export$58634b3a58ae66b7;

});

parcelRegister("abmiw", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $8PAPC = parcelRequire("8PAPC");


var $gD7r0 = parcelRequire("gD7r0");


var $ejHIX = parcelRequire("ejHIX");

/**
 * The base defaults which should be fed into any factory that needs to derive other props.
 */ const $22fab916b9fbd836$export$2df85a734ff5ed27 = {
    data: null,
    error: null,
    loading: false,
    promise: null
};


const $769c3a586f674cb6$export$fa8e33c3301e2e94 = ()=>(0, $eb3ax.default)({}, (0, $22fab916b9fbd836$export$2df85a734ff5ed27), {
        expiresAt: (0, $ejHIX.getExpiresAt)((0, $gD7r0.DEFAULT_RESOURCE_MAX_AGE)),
        accessedAt: (0, $8PAPC.getAccessedAt)()
    });
module.exports["getDefaultStateSlice"] = $769c3a586f674cb6$export$fa8e33c3301e2e94;

});

parcelRegister("k6a2t", function(module, exports) {
const $ea1c27b821238263$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $ea1c27b821238263$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$ea1c27b821238263$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));
module.exports["getResourceIdentifier"] = $ea1c27b821238263$export$c616b176adf9ad4a;
module.exports["getResourceIdentifiers"] = $ea1c27b821238263$export$cd7fbe7e979df558;

});

parcelRegister("fFk7n", function(module, exports) {

var $k6a2t = parcelRequire("k6a2t");


var $904MU = parcelRequire("904MU");

const $b67a4a5ddb48e53d$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $904MU.routeHasResources)(nextRoute)) return [];
    if ((0, $904MU.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $k6a2t.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $k6a2t.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};
module.exports["getResourcesForNextLocation"] = $b67a4a5ddb48e53d$export$7cbbc763e2f3d65d;

});

parcelRegister("VL9K0", function(module, exports) {

var $1hI4C = parcelRequire("1hI4C");

const $0ad9e73537d91699$export$65824bf86829963 = (routeResourceDataForType, currentKey)=>Object.keys(routeResourceDataForType).filter((resourceDataKey)=>{
        const { [resourceDataKey]: { expiresAt: expiresAt } } = routeResourceDataForType;
        return resourceDataKey !== currentKey && expiresAt && expiresAt <= Date.now();
    });
const $0ad9e73537d91699$export$6288d3096045088f = (maxCache, resourceDataForType, currentKey)=>{
    if (maxCache === Infinity || maxCache < 1) return null;
    const resourceDataKeys = Object.keys(resourceDataForType);
    if (resourceDataKeys.length < maxCache) return null;
    const expiredResourceDataKeys = $0ad9e73537d91699$export$65824bf86829963(resourceDataForType, currentKey);
    if (expiredResourceDataKeys.length > 0) return expiredResourceDataKeys[0];
    return resourceDataKeys.reduce((leastRecentKey, key)=>{
        const { [key]: { accessedAt: accessedAt }, [leastRecentKey]: { accessedAt: leastRecentAccessedAt } } = resourceDataForType;
        if (accessedAt && leastRecentAccessedAt && accessedAt < leastRecentAccessedAt) return key;
        return leastRecentKey;
    }, resourceDataKeys[0]);
};
const $0ad9e73537d91699$export$89440b7623c2c75c = (resource, key)=>({ getState: getState, dispatch: dispatch })=>{
        const { type: type, maxCache: maxCache } = resource;
        const { data: { [type]: resourceDataForType } } = getState();
        if (!resourceDataForType) return;
        const keyTobeDeleted = $0ad9e73537d91699$export$6288d3096045088f(maxCache, resourceDataForType, key);
        if (!keyTobeDeleted) return;
        dispatch((0, $1hI4C.deleteResourceState)(type, keyTobeDeleted));
    };
module.exports["validateLRUCache"] = $0ad9e73537d91699$export$89440b7623c2c75c;

});

parcelRegister("1hI4C", function(module, exports) {

var $1eVGO = parcelRequire("1eVGO");


var $eb3ax = parcelRequire("eb3ax");

function $0ef9910bed54f85b$var$_toPropertyKey(t) {
    var i = $0ef9910bed54f85b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : String(i);
}
function $0ef9910bed54f85b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $0ef9910bed54f85b$export$11374758be89e40 = (type, key)=>({ getState: getState })=>{
        var _prefetching$type;
        const { prefetching: prefetching } = getState();
        const slice = prefetching == null || (_prefetching$type = prefetching[type]) == null ? void 0 : _prefetching$type[key];
        // check if slice is still fresh
        if (slice && Date.now() < Number(slice.expiresAt)) return slice;
        return undefined;
    };
const $0ef9910bed54f85b$export$1e32615dc8354436 = (type, key, slice)=>({ setState: setState, getState: getState })=>{
        var _prefetching$type2, _slice$promise;
        const { prefetching: prefetching } = getState();
        // avoid doing extra set if same value
        if ((prefetching == null || (_prefetching$type2 = prefetching[type]) == null ? void 0 : _prefetching$type2[key]) === slice) return;
        // cheap optimisation to provide prefetched result syncronously
        slice == null || (_slice$promise = slice.promise) == null || _slice$promise.then((maybeData)=>slice.data = maybeData);
        setState({
            prefetching: (0, $eb3ax.default)({}, prefetching, {
                [type]: (0, $eb3ax.default)({}, prefetching == null ? void 0 : prefetching[type], {
                    [key]: slice
                })
            })
        });
    };
const $0ef9910bed54f85b$export$704f800f263b050e = (type, key, state)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { data: data } = getState();
        // every time we override a resource we kill its prefetched
        dispatch($0ef9910bed54f85b$export$1e32615dc8354436(type, key, undefined));
        setState({
            data: (0, $eb3ax.default)({}, data, {
                [type]: (0, $eb3ax.default)({}, data[type] || {}, {
                    [key]: state
                })
            })
        });
    };
const $0ef9910bed54f85b$export$5fc90c33b03fffb = (type, key)=>({ getState: getState })=>{
        const { data: { [type]: resourceDataForType } } = getState();
        return resourceDataForType == null ? void 0 : resourceDataForType[key];
    };
const $0ef9910bed54f85b$export$d40f35dc5952864b = (type, key)=>({ getState: getState, setState: setState })=>{
        const { data: data } = getState();
        const { [type]: resourceForType } = data, remainingData = (0, $1eVGO.default)(data, [
            type
        ].map($0ef9910bed54f85b$var$_toPropertyKey));
        if (key === undefined) setState({
            data: remainingData
        });
        else if (resourceForType) {
            const remainingForType = (0, $1eVGO.default)(resourceForType, [
                key
            ].map($0ef9910bed54f85b$var$_toPropertyKey));
            setState({
                data: (0, $eb3ax.default)({}, remainingData, {
                    [type]: remainingForType
                })
            });
        }
    };
module.exports["getPrefetchSlice"] = $0ef9910bed54f85b$export$11374758be89e40;
module.exports["setPrefetchSlice"] = $0ef9910bed54f85b$export$1e32615dc8354436;
module.exports["setResourceState"] = $0ef9910bed54f85b$export$704f800f263b050e;
module.exports["getResourceState"] = $0ef9910bed54f85b$export$5fc90c33b03fffb;
module.exports["deleteResourceState"] = $0ef9910bed54f85b$export$d40f35dc5952864b;

});

parcelRegister("904MU", function(module, exports) {
const $68d7d3e5e57e90ba$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $68d7d3e5e57e90ba$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;
module.exports["routeHasResources"] = $68d7d3e5e57e90ba$export$740886389191c640;
module.exports["routeHasChanged"] = $68d7d3e5e57e90ba$export$221027ff1aa38f82;

});

parcelRegister("aezOD", function(module, exports) {
// NOTE! This has been copy pasted from https://github.com/sindresorhus/serialize-error/blob/master/index.js
// When the router moves to its own package, this must become a dependency
// For now, we have put it here so that we don't need to get it included in Jira's vendor bundle
class $7736fe6ff412453e$var$NonError extends Error {
    constructor(message){
        super(message);
        this.name = 'NonError';
        if (Error.captureStackTrace) Error.captureStackTrace(this, $7736fe6ff412453e$var$NonError);
    }
}
const $7736fe6ff412453e$var$commonProperties = [
    'name',
    'message',
    'stack',
    'code'
];
const $7736fe6ff412453e$var$destroyCircular = (from, seen, to_)=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof value === 'function') continue;
        if (!value || typeof value !== 'object') {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            to[key] = $7736fe6ff412453e$var$destroyCircular(from[key], seen.slice());
            continue;
        }
        to[key] = '[Circular]';
    }
    for (const property of $7736fe6ff412453e$var$commonProperties)if (typeof from[property] === 'string') to[property] = from[property];
    return to;
};
const $7736fe6ff412453e$export$46ff38bc6bdea8fb = (value)=>{
    if (typeof value === 'object' && value !== null) return $7736fe6ff412453e$var$destroyCircular(value, []);
    // People sometimes throw things besides Error objects…
    if (typeof value === 'function') // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || 'anonymous'}]`;
    return value;
};
const $7736fe6ff412453e$export$64cddc1e268e9046 = (value)=>{
    if (value instanceof Error) return value;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        $7736fe6ff412453e$var$destroyCircular(value, [], newError);
        return newError;
    }
    return new $7736fe6ff412453e$var$NonError(value);
};
module.exports["serializeError"] = $7736fe6ff412453e$export$46ff38bc6bdea8fb;
module.exports["deserializeError"] = $7736fe6ff412453e$export$64cddc1e268e9046;

});

parcelRegister("gTkjN", function(module, exports) {
const $c4c18b33346fd9e9$export$b25d2963b8a3488a = ({ expiresAt: expiresAt })=>expiresAt === null;
const $c4c18b33346fd9e9$var$isFresh = (resource)=>{
    if ($c4c18b33346fd9e9$export$b25d2963b8a3488a(resource)) return true;
    return Date.now() < Number(resource.expiresAt);
};
const $c4c18b33346fd9e9$export$399de8c43d0ece3c = (resource)=>{
    var _resource$error;
    if ((resource == null || (_resource$error = resource.error) == null ? void 0 : _resource$error.name) === 'TimeoutError') return false;
    if (resource.loading) return true;
    if ($c4c18b33346fd9e9$var$isFresh(resource)) return true;
    return false;
};
module.exports["isFromSsr"] = $c4c18b33346fd9e9$export$b25d2963b8a3488a;
module.exports["shouldUseCache"] = $c4c18b33346fd9e9$export$399de8c43d0ece3c;

});

parcelRegister("kNFFp", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");

const $f248b4707601a448$export$2e4da1b414980956 = (slice)=>slice.promise === null ? (0, $eb3ax.default)({}, slice, {
        promise: Promise.resolve(slice.data)
    }) : slice;
module.exports["setSsrDataPromise"] = $f248b4707601a448$export$2e4da1b414980956;

});

parcelRegister("8MtAf", function(module, exports) {
class $01a659d301bc04d7$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super('Resource timed out: ' + message);
        this.name = 'TimeoutError';
    }
}
module.exports["TimeoutError"] = $01a659d301bc04d7$export$66d311bf29d5c89c;

});

parcelRegister("4q31l", function(module, exports) {
const $337beefdcf0a29ac$export$3ceb62baab058c6b = (data, transformer)=>Object.keys(data).reduce((acc, type)=>{
        if (!acc[type]) acc[type] = {};
        Object.keys(data[type]).forEach((key)=>{
            const slice = data[type][key];
            acc[type][key] = transformer(slice);
        });
        return acc;
    }, {});
module.exports["transformData"] = $337beefdcf0a29ac$export$3ceb62baab058c6b;

});

parcelRegister("fZ3NV", function(module, exports) {
$parcel$export(module.exports, "getAccessedAt", () => (parcelRequire("8PAPC")).getAccessedAt);
$parcel$export(module.exports, "createLoadingSlice", () => (parcelRequire("59XiK")).createLoadingSlice);
$parcel$export(module.exports, "actionWithDependencies", () => (parcelRequire("l6MXV")).actionWithDependencies);
$parcel$export(module.exports, "mapActionWithDependencies", () => (parcelRequire("l6MXV")).mapActionWithDependencies);
$parcel$export(module.exports, "executeForDependents", () => (parcelRequire("l6MXV")).executeForDependents);
$parcel$export(module.exports, "getDependencies", () => (parcelRequire("l6MXV")).getDependencies);
$parcel$export(module.exports, "getExpiresAt", () => (parcelRequire("ejHIX")).getExpiresAt);
$parcel$export(module.exports, "setExpiresAt", () => (parcelRequire("ejHIX")).setExpiresAt);
$parcel$export(module.exports, "getDefaultStateSlice", () => (parcelRequire("abmiw")).getDefaultStateSlice);
$parcel$export(module.exports, "getResourcesForNextLocation", () => (parcelRequire("fFk7n")).getResourcesForNextLocation);
$parcel$export(module.exports, "validateLRUCache", () => (parcelRequire("VL9K0")).validateLRUCache);
$parcel$export(module.exports, "deleteResourceState", () => (parcelRequire("1hI4C")).deleteResourceState);
$parcel$export(module.exports, "getResourceState", () => (parcelRequire("1hI4C")).getResourceState);
$parcel$export(module.exports, "setResourceState", () => (parcelRequire("1hI4C")).setResourceState);
$parcel$export(module.exports, "getPrefetchSlice", () => (parcelRequire("1hI4C")).getPrefetchSlice);
$parcel$export(module.exports, "setPrefetchSlice", () => (parcelRequire("1hI4C")).setPrefetchSlice);
$parcel$export(module.exports, "serializeError", () => (parcelRequire("aezOD")).serializeError);
$parcel$export(module.exports, "deserializeError", () => (parcelRequire("aezOD")).deserializeError);
$parcel$export(module.exports, "shouldUseCache", () => (parcelRequire("gTkjN")).shouldUseCache);
$parcel$export(module.exports, "isFromSsr", () => (parcelRequire("gTkjN")).isFromSsr);
$parcel$export(module.exports, "setSsrDataPromise", () => (parcelRequire("kNFFp")).setSsrDataPromise);
$parcel$export(module.exports, "TimeoutError", () => (parcelRequire("8MtAf")).TimeoutError);
$parcel$export(module.exports, "transformData", () => (parcelRequire("4q31l")).transformData);

var $8PAPC = parcelRequire("8PAPC");


var $59XiK = parcelRequire("59XiK");


var $kP3dg = parcelRequire("kP3dg");


var $l6MXV = parcelRequire("l6MXV");


var $ejHIX = parcelRequire("ejHIX");


var $9ou2L = parcelRequire("9ou2L");


var $abmiw = parcelRequire("abmiw");


var $k6a2t = parcelRequire("k6a2t");


var $fFk7n = parcelRequire("fFk7n");


var $VL9K0 = parcelRequire("VL9K0");


var $1hI4C = parcelRequire("1hI4C");


var $904MU = parcelRequire("904MU");


var $aezOD = parcelRequire("aezOD");


var $gTkjN = parcelRequire("gTkjN");


var $kNFFp = parcelRequire("kNFFp");


var $8MtAf = parcelRequire("8MtAf");


var $4q31l = parcelRequire("4q31l");


});

parcelRegister("6EuQn", function(module, exports) {

var $dBD3L = parcelRequire("dBD3L");


var $gXR7h = parcelRequire("gXR7h");


var $5KWZf = parcelRequire("5KWZf");


var $KDPGa = parcelRequire("KDPGa");


var $5w0mC = parcelRequire("5w0mC");


var $9MYUp = parcelRequire("9MYUp");


var $239dQ = parcelRequire("239dQ");


var $1ovy4 = parcelRequire("1ovy4");


var $bQmwQ = parcelRequire("bQmwQ");


var $6Q9UP = parcelRequire("6Q9UP");

const $bb26d5a7514740fd$export$fe220054b070cbc4 = [
    (0, $9MYUp.HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE),
    (0, $5KWZf.SPOTLIGHT_EXTENSION_TYPE),
    (0, $dBD3L.CARDS_EXTENSION_TYPE),
    (0, $bQmwQ.LINKS_MENU_EXTENSION_TYPE),
    (0, $5KWZf.SECTION_EXTENSION_TYPE),
    (0, $KDPGa.SEARCH_EXTENSION_TYPE),
    (0, $gXR7h.carouselExtensionType),
    (0, $5KWZf.RESOURCE_TILES_EXTENSION_TYPE),
    (0, $6Q9UP.CALLOUT_BANNER_EXTENSION_TYPE),
    (0, $1ovy4.JSM_HELP_EXTENSION_TYPE),
    (0, $239dQ.HUB_FORGE_EXTENSION_TYPE),
    (0, $5w0mC.HUB_CONNECT_EXTENSION_TYPE)
];
module.exports["ALLOWED_EXTENSIONS"] = $bb26d5a7514740fd$export$fe220054b070cbc4;

});

parcelRegister("aMXsk", function(module, exports) {

var $a31lS = parcelRequire("a31lS");


var $7eCZG = parcelRequire("7eCZG");


var $dYbu7 = parcelRequire("dYbu7");


var $1CaNG = parcelRequire("1CaNG");


var $gLxaI = parcelRequire("gLxaI");


var $60Pfj = parcelRequire("60Pfj");


var $7Upsh = parcelRequire("7Upsh");


var $cX2jD = parcelRequire("cX2jD");


var $lK9Pz = parcelRequire("lK9Pz");


var $dHFAY = parcelRequire("dHFAY");


var $fKdaf = parcelRequire("fKdaf");


var $9ki8I = parcelRequire("9ki8I");


var $fLS6B = parcelRequire("fLS6B");


var $cud1R = parcelRequire("cud1R");


var $40ukF = parcelRequire("40ukF");


var $5VZEy = parcelRequire("5VZEy");


var $ifkCZ = parcelRequire("ifkCZ");


var $kaUwk = parcelRequire("kaUwk");


var $bkj40 = parcelRequire("bkj40");


var $51qBv = parcelRequire("51qBv");


var $e6Dq9 = parcelRequire("e6Dq9");


var $e4SgJ = parcelRequire("e4SgJ");


var $8PVlW = parcelRequire("8PVlW");


var $lDJPY = parcelRequire("lDJPY");


var $l5MIu = parcelRequire("l5MIu");


var $1ZhW4 = parcelRequire("1ZhW4");


var $f2WDp = parcelRequire("f2WDp");


var $7gk7g = parcelRequire("7gk7g");


var $4y9hw = parcelRequire("4y9hw");


var $2QN3e = parcelRequire("2QN3e");


var $e273U = parcelRequire("e273U");


var $iFdOW = parcelRequire("iFdOW");


var $k7vUa = parcelRequire("k7vUa");


var $47YIB = parcelRequire("47YIB");


var $k8SUN = parcelRequire("k8SUN");


var $3gmKQ = parcelRequire("3gmKQ");


var $h0KOi = parcelRequire("h0KOi");


var $dGnqc = parcelRequire("dGnqc");


var $5tMpU = parcelRequire("5tMpU");


var $4Kyof = parcelRequire("4Kyof");


var $7iL2d = parcelRequire("7iL2d");


var $iVGec = parcelRequire("iVGec");


var $eHllO = parcelRequire("eHllO");


var $laiso = parcelRequire("laiso");


var $1U7Jq = parcelRequire("1U7Jq");


var $6WRJZ = parcelRequire("6WRJZ");


var $3HCXM = parcelRequire("3HCXM");


var $HGu9Y = parcelRequire("HGu9Y");


var $5HQgD = parcelRequire("5HQgD");


var $jT02V = parcelRequire("jT02V");


var $4exuQ = parcelRequire("4exuQ");


var $hFvHs = parcelRequire("hFvHs");


var $jdplc = parcelRequire("jdplc");


var $5bzSg = parcelRequire("5bzSg");


var $7gEjc = parcelRequire("7gEjc");


var $4OMM6 = parcelRequire("4OMM6");


var $jeuMk = parcelRequire("jeuMk");


var $hYOOW = parcelRequire("hYOOW");


var $4Bdub = parcelRequire("4Bdub");


var $f3DNZ = parcelRequire("f3DNZ");


var $1K7sQ = parcelRequire("1K7sQ");


var $hBGxo = parcelRequire("hBGxo");


var $hHtwA = parcelRequire("hHtwA");


var $2hEu6 = parcelRequire("2hEu6");


var $3VDvd = parcelRequire("3VDvd");


var $fb3SZ = parcelRequire("fb3SZ");


var $dvcAA = parcelRequire("dvcAA");


var $3RHCI = parcelRequire("3RHCI");


var $dxDD9 = parcelRequire("dxDD9");


var $drevR = parcelRequire("drevR");


var $ljXAk = parcelRequire("ljXAk");


var $gUZEQ = parcelRequire("gUZEQ");


var $jIG3b = parcelRequire("jIG3b");


var $gkbos = parcelRequire("gkbos");


var $grjTL = parcelRequire("grjTL");


var $4gNvG = parcelRequire("4gNvG");


var $1171P = parcelRequire("1171P");


var $d1HsG = parcelRequire("d1HsG");


var $ctVsO = parcelRequire("ctVsO");


var $abOD2 = parcelRequire("abOD2");


var $cjuKO = parcelRequire("cjuKO");


var $4lpx1 = parcelRequire("4lpx1");


var $5C5Mq = parcelRequire("5C5Mq");


var $lfQQe = parcelRequire("lfQQe");


var $7Krw2 = parcelRequire("7Krw2");


var $7s1mJ = parcelRequire("7s1mJ");


var $lWQ1U = parcelRequire("lWQ1U");


var $771jm = parcelRequire("771jm");


var $ekz2H = parcelRequire("ekz2H");


var $apdxZ = parcelRequire("apdxZ");


var $e9gyG = parcelRequire("e9gyG");


var $6vkVa = parcelRequire("6vkVa");


var $8cJvF = parcelRequire("8cJvF");


var $iaIX4 = parcelRequire("iaIX4");


var $2X43x = parcelRequire("2X43x");


var $50Cc6 = parcelRequire("50Cc6");


var $ggRZd = parcelRequire("ggRZd");


var $6UNH9 = parcelRequire("6UNH9");


var $7iKiU = parcelRequire("7iKiU");


var $8PiK3 = parcelRequire("8PiK3");


var $e6aYN = parcelRequire("e6aYN");


var $3R7tk = parcelRequire("3R7tk");


var $3n1ek = parcelRequire("3n1ek");


var $d12Gs = parcelRequire("d12Gs");


var $aaAHl = parcelRequire("aaAHl");


var $lPi6l = parcelRequire("lPi6l");


var $kfpQF = parcelRequire("kfpQF");


var $kAvtp = parcelRequire("kAvtp");


var $3dDDp = parcelRequire("3dDDp");


var $3FB7u = parcelRequire("3FB7u");


var $5jAJS = parcelRequire("5jAJS");


var $akUNu = parcelRequire("akUNu");


var $gFQSq = parcelRequire("gFQSq");


var $1HUbj = parcelRequire("1HUbj");


var $BxpF2 = parcelRequire("BxpF2");


var $eCrhY = parcelRequire("eCrhY");


var $8zIDz = parcelRequire("8zIDz");


var $fIEjp = parcelRequire("fIEjp");


var $8Kn1J = parcelRequire("8Kn1J");


var $isesA = parcelRequire("isesA");


var $jTMzh = parcelRequire("jTMzh");


var $aXEqL = parcelRequire("aXEqL");


var $5Wjk2 = parcelRequire("5Wjk2");


var $bgFDc = parcelRequire("bgFDc");


var $jOQaR = parcelRequire("jOQaR");


var $bSmYV = parcelRequire("bSmYV");


var $gNOjs = parcelRequire("gNOjs");


var $fntyu = parcelRequire("fntyu");


var $58oEb = parcelRequire("58oEb");


var $7NK0A = parcelRequire("7NK0A");


var $17MYP = parcelRequire("17MYP");


var $eThC5 = parcelRequire("eThC5");


var $d5MkD = parcelRequire("d5MkD");


var $cSnzL = parcelRequire("cSnzL");


var $8ytSX = parcelRequire("8ytSX");


var $g1jxz = parcelRequire("g1jxz");


var $hyfqk = parcelRequire("hyfqk");


var $cELP4 = parcelRequire("cELP4");

function $b9c572bfe9ab6fce$export$b21c20e4234a3291(props) {
    const { intl: intl, providers: providers, enabledOptionalPlugins: enabledOptionalPlugins } = props;
    // We remove all `never` properties from the HubPresetProps.pluginOptions,
    // we need to return them back.
    const pluginOptions = props.pluginOptions;
    return new (0, $a31lS.EditorPresetBuilder)().add([
        (0, $h0KOi.featureFlagsPlugin),
        (0, $3dDDp.featureFlagsPluginOptions)({
            options: pluginOptions.featureFlags
        })
    ]).add([
        (0, $1CaNG.analyticsPlugin),
        (0, $apdxZ.analyticsPluginOptions)({
            options: pluginOptions.analytics
        })
    ]).add((0, $lK9Pz.betterTypeHistoryPlugin)).add([
        (0, $hYOOW.pastePlugin),
        (0, $isesA.pastePluginOptions)({
            options: pluginOptions.paste,
            providers: providers
        })
    ]).add((0, $ifkCZ.default)).add((0, $4Kyof.focusPlugin)).add((0, $e6Dq9.compositionPlugin)).add([
        (0, $lDJPY.contextIdentifierPlugin),
        (0, $7iKiU.contextIdentifierPluginOptions)({
            options: pluginOptions.contextIdentifier,
            providers: providers
        })
    ]).add([
        (0, $7Upsh.default),
        (0, $8cJvF.basePluginOptions)({
            options: pluginOptions.base
        })
    ]).maybeAdd([
        (0, $5C5Mq.userPreferencesPlugin),
        (0, $hyfqk.userPreferencesPluginOptions)({
            providers: providers
        })
    ], Boolean(enabledOptionalPlugins.interaction)).add((0, $2QN3e.decorationsPlugin)).add([
        (0, $d1HsG.typeAheadPlugin),
        (0, $g1jxz.typeAheadPluginOptions)({
            options: pluginOptions.typeAhead
        })
    ]).add((0, $6WRJZ.default)).maybeAdd([
        (0, $4gNvG.toolbarPlugin),
        {
            contextualFormattingEnabled: 'always-inline'
        }
    ], Boolean(enabledOptionalPlugins.toolbar)).add([
        (0, $hBGxo.primaryToolbarPlugin),
        (0, $5Wjk2.primaryToolbarPluginOptions)({
            options: pluginOptions.primaryToolbar
        })
    ]).add((0, $abOD2.undoRedoPlugin)).add([
        (0, $fKdaf.blockTypePlugin),
        (0, $iaIX4.blockTypePluginOptions)({
            options: pluginOptions.blockType
        })
    ]).add((0, $5VZEy.clearMarksOnEmptyDocPlugin)).add([
        (0, $dxDD9.selectionToolbarPlugin),
        (0, $fntyu.selectionToolbarPluginOptions)({
            options: pluginOptions.selectionToolbar,
            providers: providers
        })
    ]).add([
        (0, $3HCXM.hyperlinkPlugin),
        (0, $gFQSq.hyperlinkPluginOptions)({
            options: pluginOptions.hyperlink
        })
    ]).add([
        (0, $grjTL.textFormattingPlugin),
        (0, $cSnzL.textFormattingPluginOptions)({
            options: pluginOptions.textFormatting
        })
    ]).add((0, $lfQQe.widthPlugin)).add([
        (0, $hHtwA.quickInsertPlugin),
        (0, $bgFDc.quickInsertPluginOptions)({
            options: pluginOptions.quickInsert
        })
    ]).add([
        (0, $f3DNZ.placeholderPlugin),
        (0, $jTMzh.placeholderPluginOptions)({
            intl: intl,
            options: pluginOptions.placeholder
        })
    ]).add((0, $cjuKO.unsupportedContentPlugin)).add([
        (0, $e273U.editorDisabledPlugin),
        (0, $3n1ek.editorDisabledPluginOptions)({
            options: pluginOptions.editorDisabled
        })
    ]).add([
        (0, $ljXAk.submitEditorPlugin),
        (0, $7NK0A.submitEditorPluginOptions)({
            options: pluginOptions.submitEditor
        })
    ]).add((0, $1ZhW4.copyButtonPlugin)).add((0, $5tMpU.floatingToolbarPlugin)).maybeAdd((0, $jT02V.interactionPlugin), Boolean(enabledOptionalPlugins.interaction)).add([
        (0, $fb3SZ.selectionPlugin),
        (0, $gNOjs.selectionPluginOptions)({
            options: pluginOptions.selection
        })
    ]).add([
        (0, $bkj40.default),
        (0, $6UNH9.codeBlockPluginOptions)({
            options: pluginOptions.codeBlock
        })
    ]).add((0, $ctVsO.ufoPlugin)).add((0, $7gk7g.dataConsumerPlugin)).add((0, $7eCZG.accessibilityUtilsPlugin)).add((0, $8PVlW.contentInsertionPlugin)).add((0, $cX2jD.batchAttributeUpdatesPlugin)).add([
        (0, $fLS6B.breakoutPlugin),
        (0, $2X43x.breakoutPluginOptions)()
    ]).add((0, $dYbu7.alignmentPlugin)).add([
        (0, $gkbos.textColorPlugin),
        (0, $d5MkD.textColorPluginOptions)({
            options: pluginOptions.textColor,
            // remove the textColorPlugin only when companyHubTextColor plugin is enabled
            isPluginEnabled: !Boolean(enabledOptionalPlugins.companyHubTextColor)
        })
    ]).maybeAdd((0, $7s1mJ.companyHubTextColorPlugin), Boolean(enabledOptionalPlugins.companyHubTextColor)).add((0, $hFvHs.listPlugin)).add((0, $2hEu6.rulePlugin)).add([
        (0, $k8SUN.expandPlugin),
        (0, $kfpQF.expandPluginOptions)()
    ]).add((0, $eHllO.guidelinePlugin)).add([
        (0, $iVGec.gridPlugin),
        (0, $5jAJS.gridPluginOptions)({
            options: pluginOptions.grid
        })
    ]).add([
        (0, $gLxaI.annotationPlugin),
        (0, $e9gyG.annotationPluginOptions)({
            options: pluginOptions.annotation,
            providers: providers
        })
    ]).add([
        (0, $5bzSg.mediaPlugin),
        (0, $8zIDz.mediaPluginOptions)({
            intl: intl,
            providers: providers
        })
    ]).add((0, $7gEjc.mediaInsertPlugin)).add((0, $cud1R.default)).add([
        (0, $k7vUa.emojiPlugin),
        (0, $aaAHl.emojiPluginOptions)({
            options: pluginOptions.emoji,
            providers: providers
        })
    ]).add([
        (0, $gUZEQ.default),
        (0, $17MYP.tablePluginOptions)()
    ]).add([
        (0, $jIG3b.tasksAndDecisionsPlugin),
        (0, $eThC5.tasksAndDecisionsPluginOptions)({
            options: pluginOptions.tasksAndDecisions,
            providers: providers
        })
    ]).add([
        (0, $laiso.helpDialogPlugin),
        (0, $akUNu.helpDialogPluginOptions)({
            options: {
                imageUploadProviderExists: false,
                // aiEnabled: enabledOptionalPlugins.aiExperience,
                aiEnabled: false
            }
        })
    ]).add([
        (0, $jeuMk.default),
        (0, $8Kn1J.panelPluginOptions)({
            options: pluginOptions.panel
        })
    ]).add([
        (0, $l5MIu.contextPanelPlugin),
        (0, $8PiK3.contextPanelPluginOptions)({
            options: pluginOptions.contextPanel
        })
    ]).add([
        (0, $3gmKQ.extensionPlugin),
        (0, $kAvtp.extensionPluginOptions)({
            options: pluginOptions.extension
        })
    ]).add([
        (0, $4y9hw.default),
        (0, $3R7tk.datePluginOptions)({
            options: pluginOptions.date
        })
    ]).add([
        (0, $1K7sQ.default),
        (0, $aXEqL.placeholderTextPluginOptions)({
            options: pluginOptions.placeholderText
        })
    ]).add([
        (0, $4exuQ.layoutPlugin),
        (0, $BxpF2.layoutPluginOptions)()
    ]).add([
        (0, $40ukF.cardPlugin),
        (0, $50Cc6.cardPluginOptions)({
            options: pluginOptions.card,
            providers: providers
        })
    ]).add([
        (0, $f2WDp.customAutoformatPlugin),
        (0, $e6aYN.customAutoformatPluginOptions)({
            options: pluginOptions.customAutoformat,
            providers: providers
        })
    ]).add([
        (0, $drevR.statusPlugin),
        (0, $58oEb.statusPluginOptions)({
            options: pluginOptions.status
        })
    ]).add((0, $HGu9Y.indentationPlugin)).add((0, $3VDvd.scrollIntoViewPlugin)).add([
        (0, $1171P.toolbarListsIndentationPlugin),
        (0, $8ytSX.toolbarListsIndentationPluginOptions)({
            options: pluginOptions.toolbarListsIndentation
        })
    ]).maybeAdd([
        (0, $5HQgD.insertBlockPlugin),
        (0, $1HUbj.insertBlockPluginOptions)()
    ], Boolean(enabledOptionalPlugins.insertBlock)).add([
        (0, $60Pfj.avatarGroupPlugin),
        (0, $6vkVa.avatarGroupPluginOptions)({
            options: pluginOptions.avatarGroup
        })
    ]).maybeAdd([
        (0, $dGnqc.findReplacePlugin),
        (0, $3FB7u.findReplacePluginOptions)({
            options: pluginOptions.findReplace
        })
    ], enabledOptionalPlugins.findReplace).add((0, $9ki8I.borderPlugin)).add((0, $7iL2d.fragmentPlugin)).add((0, $4Bdub.pasteOptionsToolbarPlugin)).add([
        (0, $kaUwk.codeBidiWarningPlugin),
        (0, $ggRZd.codeBidiWarningPluginOptions)()
    ])// .maybeAdd(
    // 	[aiPlugin, aiPluginOptions({ options: pluginOptions.ai })],
    // 	enabledOptionalPlugins.aiExperience,
    // )
    .maybeAdd([
        (0, $jdplc.loomPlugin),
        (0, $eCrhY.loomPluginOptions)({
            options: pluginOptions.loom
        })
    ], enabledOptionalPlugins.loom).add([
        (0, $iFdOW.editorViewModePlugin),
        (0, $d12Gs.editorViewModePluginOptions)({
            options: pluginOptions.editorViewMode
        })
    ])// aiDefinitionsPlugin depends on editorViewModePlugin
    .maybeAdd([
        (0, $7Krw2.aiDefinitionsPlugin),
        (0, $ekz2H.aiDefinitionsPluginOptions)({
            options: pluginOptions.aiDefinitions
        })
    ], enabledOptionalPlugins.aiDefinitions).add([
        (0, $3RHCI.selectionMarkerPlugin),
        (0, $bSmYV.selectionMarkerPluginOptions)({
            options: pluginOptions.selectionMarker
        })
    ]).maybeAdd((0, $dHFAY.blockControlsPlugin), Boolean(enabledOptionalPlugins.blockControls)).add((0, $1U7Jq.highlightPlugin)).add([
        (0, $47YIB.engagementPlatformPlugin),
        (0, $lPi6l.engagementPlatformPluginOptions)({
            options: pluginOptions.engagementPlatform
        })
    ]).maybeAdd((0, $e4SgJ.connectivityPlugin), enabledOptionalPlugins.connectivity).maybeAdd([
        (0, $4OMM6.metricsPlugin),
        (0, $fIEjp.metricsPluginOptions)({
            options: pluginOptions.metrics
        })
    ], enabledOptionalPlugins.metrics).maybeAdd((0, $51qBv.codeBlockAdvancedPlugin), enabledOptionalPlugins.codeBlockAdvanced).maybeAdd([
        (0, $dvcAA.selectionExtensionPlugin),
        (0, $jOQaR.selectionExtensionPluginOptions)({
            options: pluginOptions.selectionExtension
        })
    ], enabledOptionalPlugins.selectionExtension).maybeAdd((0, $lWQ1U.hubExternalInsertPlugin), enabledOptionalPlugins.hubExternalInsert)// Takes no options: its presence is the lock. See hubTemplateLockPlugin.
    .maybeAdd((0, $cELP4.hubTemplateLockPlugin), Boolean(enabledOptionalPlugins.hubTemplateLock)).add((0, $771jm.hubShellPlugin)).add((0, $4lpx1.userIntentPlugin));
}
module.exports["hubPreset"] = $b9c572bfe9ab6fce$export$b21c20e4234a3291;

});

parcelRegister("gD7r0", function(module, exports) {
const $c1b60e317b8b2148$export$881d135f98d8d7d0 = 100;
const $c1b60e317b8b2148$export$9ab5bdcb8a1d6c34 = false;
const $c1b60e317b8b2148$export$12c1dc38ea1692da = 0;
module.exports["DEFAULT_CACHE_MAX_LIMIT"] = $c1b60e317b8b2148$export$881d135f98d8d7d0;
module.exports["DEFAULT_RESOURCE_BROWSER_ONLY"] = $c1b60e317b8b2148$export$9ab5bdcb8a1d6c34;
module.exports["DEFAULT_RESOURCE_MAX_AGE"] = $c1b60e317b8b2148$export$12c1dc38ea1692da;

});

parcelRegister("kaUwk", function(module, exports) {

var $5Ga4m = parcelRequire("5Ga4m");

const $1e6fd84d2484c0b4$export$d7bb9295cdf61833 = ({ config: config, api: api })=>({
        name: 'codeBidiWarning',
        pmPlugins () {
            return [
                {
                    name: 'codeBidiWarning',
                    plugin: (options)=>{
                        return (0, $5Ga4m.createPlugin)(api, options, config ?? {});
                    }
                }
            ];
        }
    });
module.exports["codeBidiWarningPlugin"] = $1e6fd84d2484c0b4$export$d7bb9295cdf61833;

});

parcelRegister("7s1mJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jj5Xg = parcelRequire("jj5Xg");


var $lH6tf = parcelRequire("lH6tf");


var $fT5ir = parcelRequire("fT5ir");


var $9Kz25 = parcelRequire("9Kz25");


var $CiIZe = parcelRequire("CiIZe");

const $394ca90b950223d6$var$pluginConfig = (textColorConfig)=>{
    if (!textColorConfig || typeof textColorConfig === 'boolean') return undefined;
    return textColorConfig;
};
const $394ca90b950223d6$export$164d98bc1a6b118 = ({ config: textColorConfig, api: api })=>{
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const primaryToolbarComponent = ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, dispatchAnalyticsEvent: dispatchAnalyticsEvent, disabled: disabled })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Kz25.PrimaryToolbarComponent), {
            isReducedSpacing: isToolbarReducedSpacing,
            editorView: editorView,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            disabled: disabled,
            api: api
        });
    };
    if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $CiIZe.getToolbarComponents)(api));
    else api?.primaryToolbar?.actions.registerComponent({
        name: 'textColor',
        component: primaryToolbarComponent
    });
    return {
        name: 'companyHubTextColor',
        marks () {
            return [
                {
                    name: 'companyHubTextColor',
                    mark: (0, $jj5Xg.textColor)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'companyHubTextColor',
                    plugin: ({ dispatch: dispatch })=>(0, $fT5ir.createPlugin)(dispatch, $394ca90b950223d6$var$pluginConfig(textColorConfig))
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $fT5ir.pluginKey).getState(editorState);
        },
        actions: {
            changeColor: (color)=>{
                return (0, $lH6tf.changeColor)(color, api?.analytics?.actions);
            }
        },
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
};
module.exports["companyHubTextColorPlugin"] = $394ca90b950223d6$export$164d98bc1a6b118;

});

parcelRegister("lWQ1U", function(module, exports) {

var $cf6oG = parcelRequire("cf6oG");

const $13b343b815acf651$export$ff4d2b674c5a359b = ({ api: api })=>({
        name: 'hubExternalInsert',
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $cf6oG.key).getState(editorState);
            return pluginState ? {
                dropTargetPos: pluginState.dropTargetPos
            } : undefined;
        },
        pmPlugins () {
            return [
                {
                    name: 'hubExternalInsert',
                    plugin: ({ nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        return (0, $cf6oG.createPlugin)(api, nodeViewPortalProviderAPI);
                    }
                }
            ];
        }
    });
module.exports["hubExternalInsertPlugin"] = $13b343b815acf651$export$ff4d2b674c5a359b;

});

parcelRegister("771jm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2hH3E = parcelRequire("2hH3E");

const $2ed588dbdf2b5ae3$export$f271121a021219d3 = ()=>({
        name: 'hubShell',
        contentComponent ({ editorView: editorView }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2hH3E.HubShellContentComponent), {
                editorView: editorView
            });
        }
    });
module.exports["hubShellPlugin"] = $2ed588dbdf2b5ae3$export$f271121a021219d3;

});

parcelRegister("ekz2H", function(module, exports) {
function $63bda7e2a288b120$export$13aeab2a71badd1e({ options: options }) {
    // Options not declared here as they are all nested inside hooks, starting with `useEditorPluginAIDefinitionsConfig`.
    return options;
}
module.exports["aiDefinitionsPluginOptions"] = $63bda7e2a288b120$export$13aeab2a71badd1e;

});

parcelRegister("apdxZ", function(module, exports) {
function $04af3dc826dcd9c8$export$bfd53895e8497571({}) {
    return {};
}
module.exports["analyticsPluginOptions"] = $04af3dc826dcd9c8$export$bfd53895e8497571;

});

parcelRegister("e9gyG", function(module, exports) {
function $5a011a881d0671fc$export$b3e029fd31f94f55({ options: options, providers: providers }) {
    if (!providers.inlineCommentAnnotationProvider) return undefined;
    return {
        inlineComment: providers.inlineCommentAnnotationProvider,
        createCommentExperience: options.createCommentExperience,
        selectCommentExperience: {
            selectAnnotation: {
                complete: (annotationId)=>{
                    options.selectCommentExperience?.selectAnnotation.complete({
                        pageClass: 'editor',
                        annotationId: annotationId,
                        entryPoint: 'annotation-change'
                    });
                }
            }
        },
        viewInlineCommentTraceUFOPress: undefined,
        annotationManager: options.annotationManager
    };
}
module.exports["annotationPluginOptions"] = $5a011a881d0671fc$export$b3e029fd31f94f55;

});

parcelRegister("6vkVa", function(module, exports) {
function $ab9fdcc320174221$export$eeaea850bc5c5797({ options: options }) {
    return {
        // When Edit in Context is enabled primaryToolbarComponents is undefined
        // For more details please check
        // https://hello.atlassian.net/wiki/spaces/PCG/pages/2851572180/Editor+toolbar+for+live+pages+and+edit+in+context+projects
        collabEdit: options.collabEdit,
        // originally depends on !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
        takeFullWidth: true,
        showAvatarGroup: false
    };
}
module.exports["avatarGroupPluginOptions"] = $ab9fdcc320174221$export$eeaea850bc5c5797;

});

parcelRegister("8cJvF", function(module, exports) {
function $74a64fdcbc288e59$export$a23b3fa66082f163({ options: options }) {
    return {
        allowInlineCursorTarget: true,
        allowScrollGutter: undefined
    };
}
module.exports["basePluginOptions"] = $74a64fdcbc288e59$export$a23b3fa66082f163;

});

parcelRegister("iaIX4", function(module, exports) {
function $e4f13d43a5cb210d$export$817c0e398e6ff750({}) {
    return {
        includeBlockQuoteAsTextstyleOption: true,
        lastNodeMustBeParagraph: false,
        isUndoRedoButtonsEnabled: true,
        allowBlockType: undefined
    };
}
module.exports["blockTypePluginOptions"] = $e4f13d43a5cb210d$export$817c0e398e6ff750;

});

parcelRegister("2X43x", function(module, exports) {
function $914cf568e023e359$export$3be6b735d5cbc3e6() {
    return {
        allowBreakoutButton: true
    };
}
module.exports["breakoutPluginOptions"] = $914cf568e023e359$export$3be6b735d5cbc3e6;

});

parcelRegister("50Cc6", function(module, exports) {

var $4iudd = parcelRequire("4iudd");

/**
 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
 * (only supports Cloud single-issue URLs right now)
 */ const $236ac6fe5d915e12$var$SMART_LINKS_BEFORE_MACROS = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
function $236ac6fe5d915e12$export$514131654bb897e2({ options: options, providers: providers }) {
    return {
        allowDatasource: false,
        provider: providers.cardProvider,
        resolveBeforeMacros: $236ac6fe5d915e12$var$SMART_LINKS_BEFORE_MACROS,
        allowBlockCards: true,
        allowEmbeds: true,
        onClickCallback: options.onClickCallback,
        fullWidthMode: false,
        linkPicker: options.linkPicker,
        lpLinkPicker: true,
        editorAppearance: 'full-page',
        // @ts-ignore Temporary solution to check for Live Page editor.
        __livePage: options.__livePage,
        isPageSSRed: Boolean((0, $4iudd.isSSR)() || window.__SSR_RENDERED__),
        CompetitorPrompt: options.CompetitorPrompt
    };
}
module.exports["cardPluginOptions"] = $236ac6fe5d915e12$export$514131654bb897e2;

});

parcelRegister("ggRZd", function(module, exports) {
function $74df3d1bf9d03e75$export$3f0ff0bcf72f4d98() {
    return {
        appearance: 'full-page'
    };
}
module.exports["codeBidiWarningPluginOptions"] = $74df3d1bf9d03e75$export$3f0ff0bcf72f4d98;

});

parcelRegister("6UNH9", function(module, exports) {
function $77761212702e3032$export$74cc43e84bb9c20({}) {
    return {
        allowCopyToClipboard: true,
        useLongPressSelection: false,
        allowCompositionInputOverride: false
    };
}
module.exports["codeBlockPluginOptions"] = $77761212702e3032$export$74cc43e84bb9c20;

});

parcelRegister("7iKiU", function(module, exports) {
function $8c8a0d1870f293c5$export$2c26eb5ff90afcfd({ providers: providers }) {
    return {
        contextIdentifierProvider: providers.contextIdentifierProvider
    };
}
module.exports["contextIdentifierPluginOptions"] = $8c8a0d1870f293c5$export$2c26eb5ff90afcfd;

});

parcelRegister("8PiK3", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

function $1461db1c8d7b87c4$export$48a60d81b6bb28e3({ options: options }) {
    if (!options) return undefined;
    return(// If object-sidebar is not enabled, then we don't need to pass the contextPanelOptions
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $iDrrr.fg)('platform_editor_ai_object_sidebar_injection') ? {
        objectSideBar: options.objectSideBar
    } : undefined);
}
module.exports["contextPanelPluginOptions"] = $1461db1c8d7b87c4$export$48a60d81b6bb28e3;

});

parcelRegister("e6aYN", function(module, exports) {
function $011a55ca178e44cf$export$f18d68682e981a91({ providers: providers }) {
    return {
        autoformattingProvider: providers.autoformattingProvider
    };
}
module.exports["customAutoformatPluginOptions"] = $011a55ca178e44cf$export$f18d68682e981a91;

});

parcelRegister("3R7tk", function(module, exports) {
function $59a5e91fe5cc8e4b$export$5598bb2314a53fa8({}) {
    return {
        weekStartDay: undefined
    };
}
module.exports["datePluginOptions"] = $59a5e91fe5cc8e4b$export$5598bb2314a53fa8;

});

parcelRegister("3n1ek", function(module, exports) {
function $bcbb2e696afa1258$export$de47eee62065048e({ options: options }) {
    return {
        initialDisabledState: options?.disabled
    };
}
module.exports["editorDisabledPluginOptions"] = $bcbb2e696afa1258$export$de47eee62065048e;

});

parcelRegister("d12Gs", function(module, exports) {
function $0f06e306ecbec1ef$export$36a79e2b5698697a({ options: options }) {
    return {
        mode: options.viewMode
    };
}
module.exports["editorViewModePluginOptions"] = $0f06e306ecbec1ef$export$36a79e2b5698697a;

});

parcelRegister("aaAHl", function(module, exports) {
function $b4a4dcc6b564a90e$export$7adcaf18ca5c72c4({ providers: providers }) {
    return {
        emojiProvider: providers.emojiProvider
    };
}
module.exports["emojiPluginOptions"] = $b4a4dcc6b564a90e$export$7adcaf18ca5c72c4;

});

parcelRegister("lPi6l", function(module, exports) {
function $9a06a776a7d73ee3$export$128eafe7f843e327({ options: options }) {
    return {
        coordinationClient: options.coordinationClient
    };
}
module.exports["engagementPlatformPluginOptions"] = $9a06a776a7d73ee3$export$128eafe7f843e327;

});

parcelRegister("kfpQF", function(module, exports) {
function $0161774cdd594eee$export$ed53f0c49fce09d6() {
    return {
        allowInsertion: true,
        useLongPressSelection: false,
        appearance: 'full-page',
        allowInteractiveExpand: true,
        __livePage: false
    };
}
module.exports["expandPluginOptions"] = $0161774cdd594eee$export$ed53f0c49fce09d6;

});

parcelRegister("kAvtp", function(module, exports) {
function $d58ebc08dd85125f$export$c18b9102cd0790c9({ options: options }) {
    const isTemplateLocked = Boolean(options.isTemplateLocked);
    return {
        breakoutEnabled: true,
        copyEnabled: !isTemplateLocked,
        deleteEnabled: !isTemplateLocked,
        extensionHandlers: options.extensionHandlers,
        useLongPressSelection: false,
        appearance: 'full-page',
        __rendererExtensionOptions: options.__rendererExtensionOptions,
        getExtensionHeight: options.getExtensionHeight
    };
}
module.exports["extensionPluginOptions"] = $d58ebc08dd85125f$export$c18b9102cd0790c9;

});

parcelRegister("3dDDp", function(module, exports) {

var $jkcNT = parcelRequire("jkcNT");

function $eed6f969b476c491$export$3bff061e5229a7({}) {
    /**
	 * @private
	 * @deprecated Don't add any new feature flags here!
	 *             If you need a new feature flag, use:
	 *             - {@link editorExperiment} for new experiments.
	 *             - {@link fg} for new feature gates.
	 */ return {
        lpLinkPicker: true,
        tableWithFixedColumnWidthsOption: true,
        tableSelector: (0, $jkcNT.editorExperiment)('platform_editor_tables_table_selector', true),
        macroInteractionUpdates: true,
        moreElementsInQuickInsertView: true,
        catchAllTracking: false,
        showAvatarGroupAsPlugin: false,
        errorBoundaryDocStructure: false,
        synchronyErrorDocStructure: false,
        enableViewUpdateSubscription: false,
        collabAvatarScroll: false,
        twoLineEditorToolbar: false,
        disableSpellcheckByBrowser: undefined
    };
}
module.exports["featureFlagsPluginOptions"] = $eed6f969b476c491$export$3bff061e5229a7;

});

parcelRegister("3FB7u", function(module, exports) {
function $0b478bd471366f52$export$d9e183f0607e1b5d({}) {
    return {
        // originally depends on !!featureFlags.showAvatarGroupAsPlugin === false && !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
        takeFullWidth: true,
        twoLineEditorToolbar: false
    };
}
module.exports["findReplacePluginOptions"] = $0b478bd471366f52$export$d9e183f0607e1b5d;

});

parcelRegister("5jAJS", function(module, exports) {
function $679bc4e8ddf2dfed$export$c66d0d1462a05bd({}) {
    return {
        shouldCalcBreakoutGridLines: true
    };
}
module.exports["gridPluginOptions"] = $679bc4e8ddf2dfed$export$c66d0d1462a05bd;

});

parcelRegister("akUNu", function(module, exports) {
function $c1b63ea8f9ccb33f$export$2a67100cd9c61f05({ options: options }) {
    return options;
}
module.exports["helpDialogPluginOptions"] = $c1b63ea8f9ccb33f$export$2a67100cd9c61f05;

});

parcelRegister("gFQSq", function(module, exports) {
function $9081b6536eb02b4f$export$ab9ae3984d5aef33({ options: options }) {
    return {
        editorAppearance: 'full-page',
        lpLinkPicker: true,
        linkPicker: options.linkPicker,
        onClickCallback: options.onClickCallback,
        platform: 'web'
    };
}
module.exports["hyperlinkPluginOptions"] = $9081b6536eb02b4f$export$ab9ae3984d5aef33;

});

parcelRegister("1HUbj", function(module, exports) {

var $jkcNT = parcelRequire("jkcNT");

function $f79fa31c8674d1dd$export$1e11b615e9dc119e() {
    return {
        allowTables: true,
        allowExpand: true,
        horizontalRuleEnabled: true,
        tableSelectorSupported: (0, $jkcNT.editorExperiment)('platform_editor_tables_table_selector', true),
        nativeStatusSupported: true,
        showElementBrowserLink: true,
        appearance: 'full-page'
    };
}
module.exports["insertBlockPluginOptions"] = $f79fa31c8674d1dd$export$1e11b615e9dc119e;

});

parcelRegister("BxpF2", function(module, exports) {
function $432691c7c1116ba2$export$33fb6c6592b2cd5f() {
    return {
        allowBreakout: true,
        UNSAFE_addSidebarLayouts: true,
        useLongPressSelection: false,
        UNSAFE_allowSingleColumnLayout: undefined,
        editorAppearance: 'full-page'
    };
}
module.exports["layoutPluginOptions"] = $432691c7c1116ba2$export$33fb6c6592b2cd5f;

});

parcelRegister("eCrhY", function(module, exports) {
function $3cb19dba5c0a4727$export$feaee25faac0c640({ options: options }) {
    return {
        renderButton: options.renderButton,
        shouldShowToolbarButton: undefined
    };
}
module.exports["loomPluginOptions"] = $3cb19dba5c0a4727$export$feaee25faac0c640;

});

parcelRegister("8zIDz", function(module, exports) {

var $8Y2vc = parcelRequire("8Y2vc");

function $bda3a672ea4486c5$export$484123ae56f6fbd9({ intl: intl, providers: providers }) {
    return {
        provider: providers.mediaProvider,
        syncProvider: providers.syncMediaProvider,
        allowMediaSingle: true,
        allowResizing: true,
        allowResizingInTables: true,
        allowLinking: true,
        allowAltTextOnImages: true,
        allowCaptions: true,
        allowMediaInlineImages: true,
        allowPixelResizing: true,
        altTextValidator: (text)=>{
            const storageSupports = RegExp("^([\\p{L}\\p{N},'\\.\\s\\-_\\(\\)]|&amp;[0-9]{2};)*$", "u");
            if (!storageSupports.test(text)) return [
                intl.formatMessage((0, $8Y2vc.i18n).invalidAltText)
            ];
            return [];
        },
        featureFlags: {
            mediaInline: true
        },
        allowLazyLoading: true,
        allowBreakoutSnapPoints: true,
        allowAdvancedToolBarOptions: true,
        allowCommentsOnMedia: true,
        allowDropzoneDropLine: true,
        allowMediaSingleEditable: true,
        allowRemoteDimensionsFetch: true,
        allowMarkingUploadsAsIncomplete: false,
        allowImagePreview: true,
        fullWidthEnabled: false,
        editorAppearance: 'full-page',
        isCopyPasteEnabled: true,
        alignLeftOnInsert: false,
        waitForMediaUpload: true
    };
}
module.exports["mediaPluginOptions"] = $bda3a672ea4486c5$export$484123ae56f6fbd9;

});

parcelRegister("fIEjp", function(module, exports) {
function $64dd438f52997ff4$export$4677177d82484aef({ options: options }) {
    return options;
}
module.exports["metricsPluginOptions"] = $64dd438f52997ff4$export$4677177d82484aef;

});

parcelRegister("8Kn1J", function(module, exports) {
function $73416c62fc01c864$export$c18e432f323b002e({}) {
    return {
        useLongPressSelection: false,
        allowCustomPanel: true,
        allowCustomPanelEdit: true
    };
}
module.exports["panelPluginOptions"] = $73416c62fc01c864$export$c18e432f323b002e;

});

parcelRegister("isesA", function(module, exports) {
/**
 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
 * (only supports Cloud single-issue URLs right now)
 */ const $27c18ad3a33d1184$var$SMART_LINKS_BEFORE_MACROS = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
function $27c18ad3a33d1184$export$6b1ad42d09c74964({ providers: providers }) {
    return {
        cardOptions: {
            provider: providers.cardProvider,
            allowBlockCards: true,
            allowDatasource: true,
            allowEmbeds: true,
            resolveBeforeMacros: $27c18ad3a33d1184$var$SMART_LINKS_BEFORE_MACROS
        },
        sanitizePrivateContent: true,
        isFullPage: true
    };
}
module.exports["pastePluginOptions"] = $27c18ad3a33d1184$export$6b1ad42d09c74964;

});

parcelRegister("jTMzh", function(module, exports) {

var $8dxef = parcelRequire("8dxef");


var $iDrrr = parcelRequire("iDrrr");


var $jkcNT = parcelRequire("jkcNT");


var $iU997 = parcelRequire("iU997");

function $92a9daf3ddadf6ba$export$c6841f879d4c8aef({ intl: intl, options: options }) {
    const placeholder = (()=>{
        if (options.viewMode === 'view') return undefined;
        if (!options.isAIEnabled) {
            if ((0, $iDrrr.fg)('hub_editor_placeholder_without_ai')) return intl.formatMessage((0, $iU997.i18n).defaultPlaceholder);
            const browser = (0, $8dxef.getBrowserInfo)();
            const key = browser.mac ? "\u2318" : 'Ctrl';
            return intl.formatMessage((0, $iU997.i18n).editorEmptyDocumentPlaceholderAI, {
                key: key
            });
        }
        if ((0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) return intl.formatMessage((0, $iU997.i18n).defaultPlaceholder);
        return intl.formatMessage((0, $iU997.i18n).easyCommandsPlaceholder);
    })();
    return {
        placeholder: placeholder
    };
}
module.exports["placeholderPluginOptions"] = $92a9daf3ddadf6ba$export$c6841f879d4c8aef;

});

parcelRegister("aXEqL", function(module, exports) {
function $40f6d9aa894c5234$export$8b53e6ddc7cf96b4({}) {
    return {};
}
module.exports["placeholderTextPluginOptions"] = $40f6d9aa894c5234$export$8b53e6ddc7cf96b4;

});

parcelRegister("5Wjk2", function(module, exports) {
function $0aff776e39efcf69$export$44901d053a58e418({ options: options }) {
    return {
        contextualFormattingEnabled: options.contextualFormattingEnabled
    };
}
module.exports["primaryToolbarPluginOptions"] = $0aff776e39efcf69$export$44901d053a58e418;

});

parcelRegister("bgFDc", function(module, exports) {
function $6f657f766755e7fa$export$26cff1f2fe9f781b({ options: options }) {
    const isTemplateLocked = Boolean(options?.isTemplateLocked);
    return {
        enableElementBrowser: !isTemplateLocked,
        elementBrowserHelpUrl: '',
        disableDefaultItems: isTemplateLocked,
        headless: isTemplateLocked,
        emptyStateHandler: options?.emptyStateHandler,
        prioritySortingFn: typeof options.quickInsert === 'object' ? options.quickInsert.prioritySortingFn : undefined,
        onInsert: typeof options.quickInsert === 'object' ? options.quickInsert.onInsert : undefined
    };
}
module.exports["quickInsertPluginOptions"] = $6f657f766755e7fa$export$26cff1f2fe9f781b;

});

parcelRegister("jOQaR", function(module, exports) {
function $36ce728f217c6048$export$222c5aa4c9fb0805({ options: options }) {
    return options;
}
module.exports["selectionExtensionPluginOptions"] = $36ce728f217c6048$export$222c5aa4c9fb0805;

});

parcelRegister("bSmYV", function(module, exports) {
function $66a89cabd873c5cc$export$197b78e13e8987d2({ options: options }) {
    return {
        hideCursorOnInit: true
    };
}
module.exports["selectionMarkerPluginOptions"] = $66a89cabd873c5cc$export$197b78e13e8987d2;

});

parcelRegister("gNOjs", function(module, exports) {
function $0007e12533958e13$export$ddc2936355c1da67({ options: options }) {
    return {
        useLongPressSelection: false,
        // @ts-ignore Temporary solution to check for Live Page editor.
        __livePage: options.__livePage
    };
}
module.exports["selectionPluginOptions"] = $0007e12533958e13$export$ddc2936355c1da67;

});

parcelRegister("fntyu", function(module, exports) {
function $b79940cdb8c833b5$export$bc6dcb3c2a6112e1({ options: options, providers: providers }) {
    return {
        preferenceToolbarAboveSelection: false,
        contextualFormattingEnabled: options.contextualFormattingEnabled,
        userPreferencesProvider: providers.userPreferencesProvider
    };
}
module.exports["selectionToolbarPluginOptions"] = $b79940cdb8c833b5$export$bc6dcb3c2a6112e1;

});

parcelRegister("58oEb", function(module, exports) {
function $1fca5eecbf74e87e$export$9d286ea8d36eb908({}) {
    return {
        menuDisabled: false,
        allowZeroWidthSpaceAfter: true
    };
}
module.exports["statusPluginOptions"] = $1fca5eecbf74e87e$export$9d286ea8d36eb908;

});

parcelRegister("7NK0A", function(module, exports) {
function $edd84adbe6a26519$export$3612ff8a6b94af71({}) {
    return undefined;
}
module.exports["submitEditorPluginOptions"] = $edd84adbe6a26519$export$3612ff8a6b94af71;

});

parcelRegister("17MYP", function(module, exports) {

var $jkcNT = parcelRequire("jkcNT");

function $4cad62635571ebe1$export$9868b594778cf535() {
    return {
        tableOptions: {
            allowTableResizing: true,
            allowTableAlignment: true,
            allowBackgroundColor: true,
            allowColumnResizing: true,
            allowColumnSorting: true,
            allowDistributeColumns: true,
            allowHeaderColumn: true,
            allowHeaderRow: true,
            allowMergeCells: true,
            allowNumberColumn: true,
            allowNestedTables: true,
            allowControls: true,
            stickyHeaders: true,
            allowAddColumnWithCustomStep: false
        },
        isTableScalingEnabled: true,
        allowContextualMenu: true,
        fullWidthEnabled: false,
        wasFullWidthEnabled: false,
        getEditorFeatureFlags: ()=>({
                tableWithFixedColumnWidthsOption: true,
                tableSelector: (0, $jkcNT.editorExperiment)('platform_editor_tables_table_selector', true)
            }),
        isCommentEditor: false,
        isChromelessEditor: false
    };
}
module.exports["tablePluginOptions"] = $4cad62635571ebe1$export$9868b594778cf535;

});

parcelRegister("eThC5", function(module, exports) {
function $1db1f1afc6b4c645$export$1d23e03c42bfc1ac({ options: options, providers: providers }) {
    return {
        allowNestedTasks: true,
        consumeTabs: true,
        useLongPressSelection: false,
        taskDecisionProvider: providers.taskDecisionProvider,
        hasEditPermission: options.hasEditPermission,
        requestToEditContent: options.requestToEditContent,
        hasRequestedEditPermission: options.hasRequestedEditPermission
    };
}
module.exports["tasksAndDecisionsPluginOptions"] = $1db1f1afc6b4c645$export$1d23e03c42bfc1ac;

});

parcelRegister("d5MkD", function(module, exports) {
function $94706055a8988c96$export$a4eedeb4455295f2({ isPluginEnabled: isPluginEnabled = true }) {
    return {
        toolbarConfig: {
            enabled: isPluginEnabled
        }
    };
}
module.exports["textColorPluginOptions"] = $94706055a8988c96$export$a4eedeb4455295f2;

});

parcelRegister("cSnzL", function(module, exports) {
function $86c5907c8b556041$export$cb883a3a9320698e({}) {
    return {
        responsiveToolbarMenu: true
    };
}
module.exports["textFormattingPluginOptions"] = $86c5907c8b556041$export$cb883a3a9320698e;

});

parcelRegister("8ytSX", function(module, exports) {
function $bdaf1cb09cc59563$export$bd221c449644c740({}) {
    return {
        showIndentationButtons: true,
        allowHeadingAndParagraphIndentation: true
    };
}
module.exports["toolbarListsIndentationPluginOptions"] = $bdaf1cb09cc59563$export$bd221c449644c740;

});

parcelRegister("g1jxz", function(module, exports) {
function $2d0b3f96d253bbc0$export$612ea2d32c3e4c96({}) {
    return {
        isMobile: false
    };
}
module.exports["typeAheadPluginOptions"] = $2d0b3f96d253bbc0$export$612ea2d32c3e4c96;

});

parcelRegister("hyfqk", function(module, exports) {
function $5508e9588d62f557$export$abdb0d09187eec69({ providers: providers }) {
    return {
        userPreferencesProvider: providers.userPreferencesProviderNext,
        initialUserPreferences: undefined
    };
}
module.exports["userPreferencesPluginOptions"] = $5508e9588d62f557$export$abdb0d09187eec69;

});

parcelRegister("cELP4", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $iDrrr = parcelRequire("iDrrr");


var $fAG95 = parcelRequire("fAG95");

const $91819ec27f9cabcf$var$signatureOf = (doc)=>{
    const nodes = [];
    doc.forEach((node)=>{
        nodes.push(node);
    });
    return (0, $fAG95.getTopLevelSignature)(nodes);
};
const $91819ec27f9cabcf$export$56a135055230e899 = ({ api: api })=>({
        name: 'hubTemplateLock',
        pmPlugins () {
            return [
                {
                    name: 'hubTemplateLock',
                    plugin: ()=>new (0, $kpCD8.SafePlugin)({
                            view: ()=>{
                                const shouldHideCursor = (0, $iDrrr.fg)('hubs_hide_cursor_on_topic_pages');
                                let destroyed = false;
                                // Defer the command until ProseMirror has completed plugin-view setup.
                                queueMicrotask(()=>{
                                    if (!destroyed && shouldHideCursor) api?.core.actions.execute(api?.selection?.commands.hideCursor(true));
                                });
                                return {
                                    destroy: ()=>{
                                        destroyed = true;
                                        if (shouldHideCursor) api?.core.actions.execute(api?.selection?.commands.hideCursor(false));
                                    }
                                };
                            },
                            // The whole top-level sequence is compared, not just the extension
                            // nodes, so a locked page cannot grow stray paragraphs either.
                            filterTransaction: (tr, state)=>!tr.docChanged || $91819ec27f9cabcf$var$signatureOf(tr.doc) === $91819ec27f9cabcf$var$signatureOf(state.doc)
                        })
                }
            ];
        }
    });
module.exports["hubTemplateLockPlugin"] = $91819ec27f9cabcf$export$56a135055230e899;

});

parcelRegister("5Ga4m", function(module, exports) {

var $7Glgp = parcelRequire("7Glgp");


var $kpCD8 = parcelRequire("kpCD8");


var $8nvEM = parcelRequire("8nvEM");


var $iFduB = parcelRequire("iFduB");


var $13p4p = parcelRequire("13p4p");

const $e33c8cb52afde5db$export$ae829ec7b2625219 = (api, { dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }, { appearance: appearance })=>{
    const intl = getIntl();
    const codeBidiWarningLabel = intl.formatMessage((0, $7Glgp.codeBidiWarningMessages).label);
    const { createPluginState: createPluginState, getPluginState: getPluginState } = (0, $13p4p.pluginFactoryCreator)(nodeViewPortalProviderAPI);
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $iFduB.codeBidiWarningPluginKey),
        state: createPluginState(dispatch, (state)=>{
            if (api?.limitedMode?.sharedState.currentState()?.enabled) return {
                decorationSet: (0, $8nvEM.DecorationSet).empty,
                codeBidiWarningLabel: '',
                tooltipEnabled: false
            };
            return {
                decorationSet: (0, $13p4p.createBidiWarningsDecorationSetFromDoc)({
                    doc: state.doc,
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    tooltipEnabled: true,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                }),
                codeBidiWarningLabel: codeBidiWarningLabel,
                tooltipEnabled: true
            };
        }),
        props: {
            decorations: (state)=>{
                const { decorationSet: decorationSet } = getPluginState(state);
                return decorationSet;
            }
        }
    });
};
module.exports["createPlugin"] = $e33c8cb52afde5db$export$ae829ec7b2625219;

});

parcelRegister("lH6tf", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $eEdSM = parcelRequire("eEdSM");


var $fT5ir = parcelRequire("fT5ir");


var $4rOon = parcelRequire("4rOon");


var $dkuG1 = parcelRequire("dkuG1");


var $lAUnx = parcelRequire("lAUnx");

/**
 * Helper to create a higher order analytics command
 * @param newColor  - Color to be change in hex code
 * @param previousColor - Active color in hex code
 * @param palette - Current palette of colors
 * @return Higher order command with analytics logic inside.
 */ function $0555a528cbb73663$var$createWithColorAnalytics(newColor, previousColor, editorAnalyticsApi) {
    return (0, $eEdSM.withAnalytics)(editorAnalyticsApi, {
        action: (0, $krYZG.ACTION).FORMATTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_COLOR,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            newColor: newColor.toLowerCase(),
            previousColor: previousColor?.toLowerCase() || ''
        }
    });
}
const $0555a528cbb73663$export$917538e4f4eb20f9 = (color, editorAnalyticsApi)=>(state, dispatch)=>{
        const { textColor: textColor } = state.schema.marks;
        if (textColor) {
            const pluginState = (0, $fT5ir.pluginKey).getState(state);
            const activeColor = (0, $4rOon.getActiveColor)(state);
            const withColorAnalytics = $0555a528cbb73663$var$createWithColorAnalytics(color, activeColor, editorAnalyticsApi);
            if (pluginState?.disabled) return false;
            if (color === pluginState?.defaultColor) {
                withColorAnalytics((0, $dkuG1.removeColor)())(state, dispatch);
                return true;
            }
            withColorAnalytics((0, $lAUnx.toggleColor)(color))(state, dispatch);
            return true;
        }
        return false;
    };
module.exports["changeColor"] = $0555a528cbb73663$export$917538e4f4eb20f9;

});

parcelRegister("fT5ir", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $4rOon = parcelRequire("4rOon");


var $cLfUm = parcelRequire("cLfUm");


var $hpWwK = parcelRequire("hpWwK");

function $71fad57c8216033b$var$createInitialPluginState(editorState, pluginConfig) {
    const defaultColor = pluginConfig?.defaultColor || (0, $cLfUm.DEFAULT_COLOR);
    const state = {
        color: (0, $4rOon.getActiveColor)(editorState),
        disabled: (0, $hpWwK.getDisabledState)(editorState),
        defaultColor: defaultColor.color
    };
    return state;
}
var $71fad57c8216033b$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS[ACTIONS["RESET_COLOR"] = 0] = "RESET_COLOR";
    ACTIONS[ACTIONS["SET_COLOR"] = 1] = "SET_COLOR";
    ACTIONS[ACTIONS["DISABLE"] = 2] = "DISABLE";
    return ACTIONS;
}({});
const $71fad57c8216033b$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('companyHubTextColorPlugin');
function $71fad57c8216033b$export$ae829ec7b2625219(dispatch, pluginConfig) {
    return new (0, $kpCD8.SafePlugin)({
        key: $71fad57c8216033b$export$18d4026d1ea86bb1,
        state: {
            init (_, editorState) {
                return $71fad57c8216033b$var$createInitialPluginState(editorState, pluginConfig);
            },
            apply (tr, pluginState, _, newState) {
                const meta = tr.getMeta($71fad57c8216033b$export$18d4026d1ea86bb1) || {};
                let nextState;
                switch(meta.action){
                    case 0:
                        nextState = {
                            ...pluginState,
                            color: pluginState.defaultColor
                        };
                        break;
                    case 1:
                        nextState = {
                            ...pluginState,
                            color: meta.color,
                            disabled: false
                        };
                        break;
                    case 2:
                        nextState = {
                            ...pluginState,
                            disabled: true
                        };
                        break;
                    default:
                        nextState = {
                            ...pluginState,
                            color: (0, $4rOon.getActiveColor)(newState),
                            disabled: (0, $hpWwK.getDisabledState)(newState)
                        };
                }
                if (pluginState && pluginState.color !== nextState.color || pluginState && pluginState.disabled !== nextState.disabled) {
                    dispatch($71fad57c8216033b$export$18d4026d1ea86bb1, nextState);
                    return nextState;
                }
                return pluginState;
            }
        },
        props: {
            attributes: ()=>({
                    'data-company-hub-text-color-plugin': 'true'
                })
        }
    });
}
module.exports["ACTIONS"] = $71fad57c8216033b$export$92a1a3b7554e9387;
module.exports["pluginKey"] = $71fad57c8216033b$export$18d4026d1ea86bb1;
module.exports["createPlugin"] = $71fad57c8216033b$export$ae829ec7b2625219;

});

parcelRegister("9Kz25", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3k5Tv = parcelRequire("3k5Tv");


var $7qyDa = parcelRequire("7qyDa");

const $2fb70005c3c06c59$export$94516d5cccf573e3 = (0, $kSwu1.injectIntl)(({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isReducedSpacing: isReducedSpacing, dispatchAnalyticsEvent: dispatchAnalyticsEvent, disabled: disabled, api: api })=>{
    const { color: color, defaultColor: defaultColor, disabled: textColorDisabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'companyHubTextColor'
    ], (states)=>({
            color: states.companyHubTextColorState?.color,
            defaultColor: states.companyHubTextColorState?.defaultColor,
            disabled: states.companyHubTextColorState?.disabled
        }));
    if (color === undefined || defaultColor === undefined) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7qyDa.ToolbarCompanyHubTextColor), {
        pluginState: {
            color: color,
            defaultColor: defaultColor,
            disabled: textColorDisabled
        },
        editorView: editorView,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        isReducedSpacing: isReducedSpacing,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        disabled: disabled,
        pluginInjectionApi: api,
        toolbarType: (0, $7qyDa.ToolbarType).PRIMARY
    });
});
module.exports["PrimaryToolbarComponent"] = $2fb70005c3c06c59$export$94516d5cccf573e3;

});

parcelRegister("CiIZe", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3nacY = parcelRequire("3nacY");

var $hVLmg = parcelRequire("hVLmg");


var $5AKbu = parcelRequire("5AKbu");


var $gUU6c = parcelRequire("gUU6c");

const $a635e27daad1901d$export$a758406ca53b86a5 = (api)=>{
    return [
        {
            ...(0, $3nacY.TEXT_COLOR_HIGHLIGHT_GROUP),
            parents: [
                {
                    ...(0, $3nacY.TEXT_SECTION),
                    rank: (0, $hVLmg.TEXT_SECTION_RANK)[(0, $3nacY.TEXT_COLOR_HIGHLIGHT_GROUP).key]
                },
                {
                    type: (0, $3nacY.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $3nacY.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $hVLmg.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $3nacY.TEXT_COLOR_HIGHLIGHT_GROUP).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AKbu.ToolbarButtonGroup), null, children)
        },
        {
            type: 'button',
            key: 'company-hub-text-color-button-inline-toolbar',
            parents: [
                {
                    ...(0, $3nacY.TEXT_COLOR_HIGHLIGHT_GROUP),
                    rank: 100
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gUU6c.CompanyHubTextColorButton), {
                    api: api,
                    parents: parents
                })
        }
    ];
};
module.exports["getToolbarComponents"] = $a635e27daad1901d$export$a758406ca53b86a5;

});

parcelRegister("cf6oG", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $8nvEM = parcelRequire("8nvEM");


var $4Vdlk = parcelRequire("4Vdlk");


var $arMIH = parcelRequire("arMIH");

const $cf6b6ccb25dee134$var$HUB_EXTENSION_DRAG_TYPE = 'hub-extension';
const $cf6b6ccb25dee134$export$df61b30b684217c0 = new (0, $kCECX.PluginKey)('hubExternalInsert');
const $cf6b6ccb25dee134$var$initialState = {
    decorations: (0, $8nvEM.DecorationSet).empty,
    showCursorDropIndicator: false,
    dropTargetPos: null
};
/**
 * Container node types we deliberately descend INTO when resolving a drop
 * position. When the cursor is over content nested inside one of these
 * containers, we keep the resolved position inside the container instead
 * of clamping it back up to the document root.
 *
 * This is what enables drag-and-drop into:
 *   - layouts (`layoutSection` → `layoutColumn`)
 *   - hub `section` extension (a `multiBodiedExtension` with
 *     `extensionFrame` content holes)
 *   - bodied / nested expand / standard bodiedExtension containers
 *
 * Anything not in this set behaves like a leaf for the purposes of drop
 * resolution — the position is clamped to the nearest ancestor in the set
 * (or to the doc root). This matches the deny-list intuition used by
 * `editor-plugin-block-controls` for in-editor drag-and-drop.
 */ const $cf6b6ccb25dee134$var$DESCEND_INTO_NODES = new Set([
    'doc',
    'layoutSection',
    'layoutColumn',
    'multiBodiedExtension',
    'extensionFrame',
    'bodiedExtension',
    'expand',
    'nestedExpand'
]);
/**
 * Pick the boundary (before or after the child at the given depth) that
 * matches the cursor's vertical position. Reads the block DOM rect
 * directly to avoid calling `coordsAtPos`, which forces a full
 * synchronous layout reflow and is extremely slow when complex React
 * node views are present.
 */ function $cf6b6ccb25dee134$var$pickBoundaryForDepth(editorView, resolvedPos, depth, clientY, rawPos) {
    const blockStart = resolvedPos.before(depth);
    const blockEnd = resolvedPos.after(depth);
    const domNode = editorView.nodeDOM(blockStart);
    if (domNode instanceof HTMLElement) {
        const rect = domNode.getBoundingClientRect();
        const blockMidY = (rect.top + rect.bottom) / 2;
        return clientY < blockMidY ? blockStart : blockEnd;
    }
    // Fallback when the DOM node isn't available (e.g. during transient
    // node-view mount): use the proportional position within the block.
    const blockSize = blockEnd - blockStart;
    const offsetInBlock = rawPos - blockStart;
    return offsetInBlock < blockSize / 2 ? blockStart : blockEnd;
}
/**
 * Resolves a document position from mouse coordinates by using
 * ProseMirror's posAtCoords API and walking inward from the cursor's
 * deepest level outward, picking the **innermost** ancestor that we
 * recognise as a "descend-into" container. This means a drop inside a
 * `layoutColumn` resolves to a position inside the column (not above
 * the whole layout), and a drop inside a hub `section` resolves to a
 * position inside the section's content body.
 *
 * Returns the position at the chosen child boundary (above or below
 * the inner block), or null if the coordinates don't map to a position
 * inside the editor.
 *
 * NOTE: We avoid `coordsAtPos` for the same perf reason as before —
 * `pickBoundaryForDepth()` reads `nodeDOM().getBoundingClientRect()`
 * which is cheap.
 */ function $cf6b6ccb25dee134$var$resolveDropPosition(editorView, clientX, clientY) {
    try {
        const posInfo = editorView.posAtCoords({
            left: clientX,
            top: clientY
        });
        if (!posInfo) return null;
        const rawPos = Math.min(posInfo.pos, editorView.state.doc.content.size);
        const resolvedPos = editorView.state.doc.resolve(rawPos);
        // Walk from the deepest depth INWARD (towards depth 1), stopping
        // at the first ancestor whose parent is a known descend-into
        // container. This is the inverse of the previous `depth >= 1`
        // clamp, which always forced the position up to the document
        // root and prevented drops into layouts / sections / extensions.
        //
        // `resolvedPos.depth` is the parent depth at the cursor; the
        // child sitting at that level lives at `depth + 1`. We walk
        // from the cursor's parent upward, and as soon as we find a
        // parent that is in DESCEND_INTO_NODES we pick the boundary of
        // the child at that level.
        for(let d = resolvedPos.depth; d >= 1; d--){
            const parent = resolvedPos.node(d - 1);
            if ($cf6b6ccb25dee134$var$DESCEND_INTO_NODES.has(parent.type.name)) return $cf6b6ccb25dee134$var$pickBoundaryForDepth(editorView, resolvedPos, d, clientY, rawPos);
        }
        // Cursor is at depth 0 (over the doc itself, e.g. between
        // blocks at the very top). Fall back to the raw position.
        return resolvedPos.pos;
    } catch  {
        return null;
    }
}
function $cf6b6ccb25dee134$export$ae829ec7b2625219(api, nodeViewPortalProviderAPI) {
    // If portal API is missing (e.g. wrong editor wiring), run as no-op so the page doesn't break
    if (!nodeViewPortalProviderAPI || typeof nodeViewPortalProviderAPI.render !== 'function') return new (0, $kpCD8.SafePlugin)({
        key: $cf6b6ccb25dee134$export$df61b30b684217c0,
        state: {
            init: ()=>$cf6b6ccb25dee134$var$initialState,
            apply: (_tr, state)=>state
        },
        props: {
            decorations: (state)=>$cf6b6ccb25dee134$export$df61b30b684217c0.getState(state)?.decorations
        }
    });
    return new (0, $kpCD8.SafePlugin)({
        key: $cf6b6ccb25dee134$export$df61b30b684217c0,
        state: {
            init: ()=>$cf6b6ccb25dee134$var$initialState,
            apply: (tr, currentState, _oldState, newState)=>{
                try {
                    const meta = tr.getMeta($cf6b6ccb25dee134$export$df61b30b684217c0);
                    // If there is no meta for this plugin and the doc hasn't changed,
                    // nothing can affect our state — return early to avoid expensive
                    // decoration teardown/recreation (which involves React portals).
                    if (!meta && !tr.docChanged) return currentState;
                    const showCursorDropIndicator = meta?.showCursorDropIndicator ?? currentState.showCursorDropIndicator;
                    const dropTargetPos = meta?.dropTargetPos !== undefined ? meta.dropTargetPos : currentState.dropTargetPos;
                    // If nothing meaningful changed, keep the current state as-is
                    // to avoid destroying and recreating the React portal decoration.
                    if (showCursorDropIndicator === currentState.showCursorDropIndicator && dropTargetPos === currentState.dropTargetPos && !tr.docChanged) return currentState;
                    let decorations = currentState.decorations;
                    if (tr.docChanged) decorations = decorations.map(tr.mapping, tr.doc);
                    // Only remove and recreate decorations when the indicator
                    // visibility or position actually changed.
                    const indicatorChanged = showCursorDropIndicator !== currentState.showCursorDropIndicator || dropTargetPos !== currentState.dropTargetPos;
                    if (indicatorChanged) {
                        const cursorDecs = (0, $arMIH.findCursorIndicatorDecs)(decorations);
                        if (cursorDecs.length > 0) decorations = decorations.remove(cursorDecs);
                        if (showCursorDropIndicator && dropTargetPos != null) {
                            const clampedPos = Math.min(dropTargetPos, newState.doc.content.size);
                            const resolvedPos = newState.doc.resolve(clampedPos);
                            // Render the indicator at exactly the position the
                            // pointer resolved to. `resolveDropPosition()` has
                            // already placed `dropTargetPos` at a valid child
                            // boundary inside the innermost descend-into
                            // container — the document root, a `layoutColumn`,
                            // a hub `section`, etc. We must therefore read
                            // the surrounding `prevNode` / `nextNode` /
                            // `parentNode` from THAT depth, not from the
                            // document root, otherwise the gap/offset hints
                            // passed to `createCursorIndicatorDecoration` will
                            // describe the wrong siblings and the indicator
                            // will visually misalign inside nested containers.
                            const indicatorDepth = resolvedPos.depth;
                            const parentNode = resolvedPos.node(indicatorDepth);
                            const indexInParent = resolvedPos.index(indicatorDepth);
                            const prevNode = indexInParent > 0 ? parentNode.child(indexInParent - 1) : null;
                            const nextNode = indexInParent < parentNode.childCount ? parentNode.child(indexInParent) : null;
                            // `lineLength` is intentionally NOT passed any more.
                            // The indicator now sizes itself to its container's
                            // natural width via CSS (`left: 0; right: 0` on an
                            // absolute child of a `width: 100%` host). This is
                            // what makes the indicator behave correctly inside
                            // `layoutColumn`s of differing widths and inside
                            // hub `section` extension frames.
                            const dec = (0, $arMIH.createCursorIndicatorDecoration)(clampedPos, nodeViewPortalProviderAPI, prevNode, nextNode, parentNode);
                            decorations = decorations.add(newState.doc, [
                                dec
                            ]);
                        }
                    }
                    return {
                        decorations: decorations,
                        showCursorDropIndicator: showCursorDropIndicator,
                        dropTargetPos: dropTargetPos
                    };
                } catch  {
                    return currentState;
                }
            }
        },
        props: {
            decorations: (state)=>$cf6b6ccb25dee134$export$df61b30b684217c0.getState(state)?.decorations
        },
        view (editorView) {
            let cleanup;
            try {
                // Track pending rAF to throttle onDrag updates to at most once per frame.
                let rafId = null;
                cleanup = (0, $4Vdlk.monitorForElements)({
                    canMonitor: ({ source: source })=>source.data.type === $cf6b6ccb25dee134$var$HUB_EXTENSION_DRAG_TYPE,
                    onDragStart: ({ location: location })=>{
                        const coords = location.current.input;
                        const dropPos = $cf6b6ccb25dee134$var$resolveDropPosition(editorView, coords.clientX, coords.clientY);
                        editorView.dispatch(editorView.state.tr.setMeta($cf6b6ccb25dee134$export$df61b30b684217c0, {
                            showCursorDropIndicator: true,
                            dropTargetPos: dropPos
                        }));
                    },
                    onDrag: ({ location: location })=>{
                        const coords = location.current.input;
                        const clientX = coords.clientX;
                        const clientY = coords.clientY;
                        // Throttle to one update per animation frame to avoid excessive
                        // ProseMirror transactions while the user is dragging.
                        if (rafId != null) cancelAnimationFrame(rafId);
                        rafId = requestAnimationFrame(()=>{
                            rafId = null;
                            const dropPos = $cf6b6ccb25dee134$var$resolveDropPosition(editorView, clientX, clientY);
                            const currentState = $cf6b6ccb25dee134$export$df61b30b684217c0.getState(editorView.state);
                            // Only dispatch if position actually changed to avoid unnecessary updates
                            if (currentState?.dropTargetPos !== dropPos) editorView.dispatch(editorView.state.tr.setMeta($cf6b6ccb25dee134$export$df61b30b684217c0, {
                                dropTargetPos: dropPos
                            }));
                        });
                    },
                    onDrop: ()=>{
                        if (rafId != null) {
                            cancelAnimationFrame(rafId);
                            rafId = null;
                        }
                        // Always ensure the indicator is cleaned up when a drag
                        // ends. The EditorDropTarget's onDrop already clears the
                        // indicator and inserts content in its own transaction,
                        // but we still need this for drags that end outside the
                        // drop target (cancelled or missed). The apply function's
                        // early-return optimisation ensures this is a no-op when
                        // the indicator was already cleared by EditorDropTarget.
                        const currentState = $cf6b6ccb25dee134$export$df61b30b684217c0.getState(editorView.state);
                        if (currentState?.showCursorDropIndicator) editorView.dispatch(editorView.state.tr.setMeta($cf6b6ccb25dee134$export$df61b30b684217c0, {
                            showCursorDropIndicator: false,
                            dropTargetPos: null
                        }));
                    }
                });
            } catch  {}
            return {
                destroy () {
                    try {
                        cleanup?.();
                    } catch  {}
                }
            };
        }
    });
}
module.exports["key"] = $cf6b6ccb25dee134$export$df61b30b684217c0;
module.exports["createPlugin"] = $cf6b6ccb25dee134$export$ae829ec7b2625219;

});

parcelRegister("2hH3E", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $r8hvx = parcelRequire("r8hvx");


var $57S2y = parcelRequire("57S2y");


var $a6uUc = parcelRequire("a6uUc");

const $707330b843c278a7$export$6bbf8dcb80fbe27c = ({ editorView: editorView })=>{
    const navbarContainerRef = (0, $cozmU.useRef)(null);
    const [mounted, setMounted] = (0, $cozmU.useState)(false);
    const { isInPreviewMode: isInPreviewMode } = (0, $r8hvx.useHubContext)();
    (0, $cozmU.useEffect)(()=>{
        const pmDom = editorView?.dom;
        if (!pmDom) return;
        const pmParent = pmDom.parentElement;
        if (!pmParent) return;
        // Insert the Navbar wrapper BEFORE the ProseMirror editable div.
        //
        // To make the navbar span the editor's full width (matching how
        // `full-width` layout extensions break out of the line-length
        // constraint), we mirror the structure used by editor breakout marks
        // (see `BreakoutView` in `@atlaskit/editor-plugin-breakout`):
        //
        //   - The outer element is a flex container that centers its child.
        //     `transform: none` neutralises any inherited transforms that
        //     would otherwise interfere with the inner element overflowing
        //     past the line-length-constrained parent.
        //   - The inner element gets a `min-width` matching the breakout
        //     formula. It uses the same CSS variables the editor exposes on
        //     its content container, so the navbar automatically scales with
        //     the editor's full-width layout, the viewport, and the
        //     guttering/context-panel state.
        const navbarOuterEl = document.createElement('div');
        navbarOuterEl.setAttribute('data-hub-shell-navbar', 'true');
        navbarOuterEl.style.display = 'flex';
        navbarOuterEl.style.justifyContent = 'center';
        navbarOuterEl.style.transform = 'none';
        const navbarInnerEl = document.createElement('div');
        // This is the same width as set for hub editor
        navbarInnerEl.style.minWidth = 'min(calc(100cqw - var(--hub-editor-gutter-padding-inline) * 2 - 8px), var(--ak-editor--full-width-layout-width))';
        navbarOuterEl.appendChild(navbarInnerEl);
        pmParent.insertBefore(navbarOuterEl, pmDom);
        navbarContainerRef.current = navbarInnerEl;
        setMounted(true);
        return ()=>{
            navbarOuterEl.remove();
            navbarContainerRef.current = null;
        };
    }, [
        editorView
    ]);
    if (!mounted || !navbarContainerRef.current) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, $9kbTQ.createPortal)(// In preview mode the navbar should be fully interactive so authors
    // can test navigation. In edit mode pointer-events are disabled to
    // prevent accidental navigation while editing.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6uUc.Navbar), {
        isEditMode: !isInPreviewMode
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57S2y.HubBreadcrumbs), null)), navbarContainerRef.current));
};
module.exports["HubShellContentComponent"] = $707330b843c278a7$export$6bbf8dcb80fbe27c;

});

parcelRegister("8Y2vc", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $4911ab1221aefa96$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    invalidAltText: {
        id: "editor-presets-hub.media.alt-text.invalid",
        defaultMessage: "We aren\u2019t able to accept every possible character in Alt text. All Unicode letters and numbers are OK, but these are the only acceptable symbols: , ' . - _ ( )."
    }
});
module.exports["i18n"] = $4911ab1221aefa96$export$a7357cdd1f0b0168;

});

parcelRegister("iU997", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $0843f63249b71140$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    easyCommandsPlaceholder: {
        id: "editor-presets-hub.placeholder.easy-commands-placeholder",
        defaultMessage: "Type / for all elements."
    },
    aiPlaceholder: {
        id: "editor-presets-hub.placeholder.ai-placeholder",
        defaultMessage: "Type /ai for Atlassian Intelligence or / to add elements."
    },
    defaultPlaceholder: {
        id: "editor-presets-hub.placeholder.default-placeholder",
        defaultMessage: "Type / to insert elements"
    },
    editorEmptyDocumentPlaceholderAI: {
        id: "editor-presets-hub.placeholder.default-placeholder-ai",
        defaultMessage: "Use {key}+' to ask AI, or type / to insert elements"
    }
});
module.exports["i18n"] = $0843f63249b71140$export$a7357cdd1f0b0168;

});

parcelRegister("fAG95", function(module, exports) {
/**
 * The shape of a top-level node in a hub page layout that the template lock
 * cares about. Kept structural so the signature can be unit tested without
 * building a ProseMirror document.
 */ const $40262846c97d9181$export$d103a0257b5710e = (nodes)=>nodes.map((node)=>{
        const { extensionKey: extensionKey, localId: localId } = node.attrs ?? {};
        return `${node.type.name}/${extensionKey ?? ''}/${localId ?? ''}`;
    }).join('|');
module.exports["getTopLevelSignature"] = $40262846c97d9181$export$d103a0257b5710e;

});

parcelRegister("iFduB", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $1c1ce65b3ebcdf77$export$bdb7e84dad6ef3a = new (0, $kCECX.PluginKey)('codeBidiWarningPlugin');
module.exports["codeBidiWarningPluginKey"] = $1c1ce65b3ebcdf77$export$bdb7e84dad6ef3a;

});

parcelRegister("13p4p", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $03RpJ = parcelRequire("03RpJ");


var $fYRS9 = parcelRequire("fYRS9");


var $cOjjv = parcelRequire("cOjjv");


var $cI8RZ = parcelRequire("cI8RZ");

var $gLqwM = parcelRequire("gLqwM");


var $8nvEM = parcelRequire("8nvEM");


var $iFduB = parcelRequire("iFduB");


var $2XAa3 = parcelRequire("2XAa3");

const $f6bb13725f8284cf$export$a4805b2c1b031d72 = (nodeViewPortalProviderAPI)=>(0, $cI8RZ.pluginFactory)((0, $iFduB.codeBidiWarningPluginKey), (0, $2XAa3.default), {
        onDocChanged: (tr, pluginState)=>{
            if (!tr.steps.find((0, $gLqwM.stepHasSlice))) return pluginState;
            const newBidiWarningsDecorationSet = $f6bb13725f8284cf$export$f1e73511389847e5({
                doc: tr.doc,
                codeBidiWarningLabel: pluginState.codeBidiWarningLabel,
                tooltipEnabled: pluginState.tooltipEnabled,
                nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
            });
            return {
                ...pluginState,
                decorationSet: newBidiWarningsDecorationSet
            };
        }
    });
function $f6bb13725f8284cf$export$f1e73511389847e5({ doc: doc, codeBidiWarningLabel: codeBidiWarningLabel, tooltipEnabled: tooltipEnabled, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }) {
    const bidiCharactersAndTheirPositions = [];
    doc.descendants((node, pos)=>{
        const isTextWithCodeMark = node.type.name === 'text' && node.marks && node.marks.some((mark)=>mark.type.name === 'code');
        if (isTextWithCodeMark) {
            (0, $cOjjv.default)(node.textContent, ({ bidiCharacter: bidiCharacter, index: index })=>{
                bidiCharactersAndTheirPositions.push({
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    position: pos + index,
                    bidiCharacter: bidiCharacter
                });
            });
            return false;
        }
        const isCodeBlock = node.type.name === 'codeBlock';
        if (isCodeBlock) (0, $cOjjv.default)(node.textContent, ({ bidiCharacter: bidiCharacter, index: index })=>{
            bidiCharactersAndTheirPositions.push({
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                position: pos + index + 1,
                bidiCharacter: bidiCharacter
            });
        });
    });
    // Bidi characters are not expected to commonly appear in code snippets, so recreating the decoration set
    // for documents rather than reusing existing decorations seems a reasonable performance/complexity tradeoff.
    if (bidiCharactersAndTheirPositions.length === 0) return (0, $8nvEM.DecorationSet).empty;
    const newBidiWarningsDecorationSet = (0, $8nvEM.DecorationSet).create(doc, bidiCharactersAndTheirPositions.map(({ position: position, bidiCharacter: bidiCharacter })=>{
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const renderKey = (0, $03RpJ.default)();
        return (0, $8nvEM.Decoration).widget(position, (_el)=>$f6bb13725f8284cf$var$renderDOM({
                bidiCharacter: bidiCharacter,
                codeBidiWarningLabel: codeBidiWarningLabel,
                tooltipEnabled: tooltipEnabled,
                nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                renderKey: renderKey
            }), {
            destroy: (_el)=>{
            // removing portalprovider clean up due to a rendering bug
            // with this plugin under React 18. This matches the previous
            // React 16 behaviour which never cleaned up rendering.
            //
            // This will mean CodeBidi instances are not cleaned up, but
            // this is expected to be minimal due to the low frequency of
            // bidi characters in code blocks.
            //
            // We will fix this in a follow up ticket to rewrite the plugin
            // to use pure toDOM -> ED-26540
            // nodeViewPortalProviderAPI.remove(renderKey);
            }
        });
    }));
    return newBidiWarningsDecorationSet;
}
function $f6bb13725f8284cf$var$renderDOM({ bidiCharacter: bidiCharacter, codeBidiWarningLabel: codeBidiWarningLabel, tooltipEnabled: tooltipEnabled, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, renderKey: renderKey }) {
    const element = document.createElement('span');
    nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $fYRS9.default), {
            bidiCharacter: bidiCharacter,
            skipChildren: true,
            label: codeBidiWarningLabel,
            tooltipEnabled: tooltipEnabled
        }), element, renderKey);
    return element;
}
module.exports["pluginFactoryCreator"] = $f6bb13725f8284cf$export$a4805b2c1b031d72;
module.exports["createBidiWarningsDecorationSetFromDoc"] = $f6bb13725f8284cf$export$f1e73511389847e5;

});

parcelRegister("4rOon", function(module, exports) {

var $cLfUm = parcelRequire("cLfUm");

const $3bb5f782f18f51c6$export$1c6fa8f53a5fb47f = (state)=>{
    const { $from: $from, $to: $to, $cursor: $cursor } = state.selection;
    const { textColor: textColor } = state.schema.marks;
    // Filter out other marks
    let marks = [];
    if ($cursor) marks.push(textColor.isInSet(state.storedMarks || $cursor.marks()) || undefined);
    else state.doc.nodesBetween($from.pos, $to.pos, (currentNode)=>{
        if (currentNode.isLeaf) {
            const mark = textColor.isInSet(currentNode.marks) || undefined;
            marks.push(mark);
            return !mark;
        }
        return true;
    });
    // Merge consecutive same color marks
    let prevMark;
    marks = marks.filter((mark)=>{
        if (mark && prevMark && mark.attrs.color === prevMark.attrs.color) return false;
        prevMark = mark;
        return true;
    });
    const marksWithColor = marks.filter((mark)=>!!mark);
    // When multiple colors are selected revert back to default color
    if (marksWithColor.length > 1 || marksWithColor.length === 1 && marks.length > 1) return null;
    return marksWithColor.length ? marksWithColor[0].attrs.color : (0, $cLfUm.DEFAULT_COLOR).color;
};
module.exports["getActiveColor"] = $3bb5f782f18f51c6$export$1c6fa8f53a5fb47f;

});

parcelRegister("dkuG1", function(module, exports) {

var $5tsXu = parcelRequire("5tsXu");


var $fT5ir = parcelRequire("fT5ir");

const $fbf45ef4bd2aa8fb$export$4a26621adcb675d6 = ()=>(state, dispatch)=>{
        const { schema: schema } = state;
        const { textColor: textColor } = schema.marks;
        const tr = state.tr;
        (0, $5tsXu.removeMark)(textColor)({
            tr: tr
        });
        if (dispatch) dispatch(tr.setMeta((0, $fT5ir.pluginKey), {
            action: (0, $fT5ir.ACTIONS).RESET_COLOR
        }));
        return true;
    };
module.exports["removeColor"] = $fbf45ef4bd2aa8fb$export$4a26621adcb675d6;

});

parcelRegister("lAUnx", function(module, exports) {

var $5tsXu = parcelRequire("5tsXu");

var $bhf6v = parcelRequire("bhf6v");


var $fT5ir = parcelRequire("fT5ir");


var $cLfUm = parcelRequire("cLfUm");


var $hpWwK = parcelRequire("hpWwK");

const $1e41a971fe6a78b9$export$afb561a73dff6672 = (color)=>(state, dispatch)=>{
        const { textColor: textColor } = state.schema.marks;
        const tr = state.tr;
        const disabledState = (0, $hpWwK.getDisabledState)(state);
        if (disabledState) {
            if (dispatch) dispatch(tr.setMeta((0, $fT5ir.pluginKey), {
                action: (0, $fT5ir.ACTIONS).DISABLE
            }));
            return false;
        }
        if (dispatch) {
            (0, $cLfUm.overrideMarks).forEach((mark)=>{
                const { marks: marks } = tr.doc.type.schema;
                if (marks[mark]) (0, $5tsXu.removeMark)(marks[mark])({
                    tr: tr
                });
            });
            (0, $bhf6v.toggleMark)(textColor, {
                color: color
            })({
                tr: tr
            });
            dispatch(tr);
        }
        return true;
    };
module.exports["toggleColor"] = $1e41a971fe6a78b9$export$afb561a73dff6672;

});

parcelRegister("cLfUm", function(module, exports) {

var $89bON = parcelRequire("89bON");

const $b7fcef61cccb20d5$export$ccbc17c7832f26ef = [
    'backgroundColor'
];
const $b7fcef61cccb20d5$export$37394b0fa44b998c = {
    color: (0, $89bON.getTokenValue)('color.text'),
    label: 'Default'
};
module.exports["overrideMarks"] = $b7fcef61cccb20d5$export$ccbc17c7832f26ef;
module.exports["DEFAULT_COLOR"] = $b7fcef61cccb20d5$export$37394b0fa44b998c;

});

parcelRegister("hpWwK", function(module, exports) {

var $kzHT3 = parcelRequire("kzHT3");

var $adJV7 = parcelRequire("adJV7");


var $cLfUm = parcelRequire("cLfUm");

const $f1be6582f99aecf7$var$hasLinkMark = ($pos)=>{
    const { doc: { type: { schema: { marks: { link: linkMarkType } } } }, pos: pos } = $pos;
    if (!linkMarkType) return false;
    return $pos.doc.rangeHasMark(pos, Math.min(pos + 1, $pos.doc.content.size), linkMarkType);
};
const $f1be6582f99aecf7$export$4af1020a67b5ec91 = (state)=>{
    const { textColor: textColor } = state.schema.marks;
    if (textColor) {
        const { empty: empty, ranges: ranges, $cursor: $cursor } = state.selection;
        if (empty && !$cursor || $cursor && $f1be6582f99aecf7$var$hasLinkMark($cursor) || (0, $kzHT3.isMarkAllowedInRange)(state.doc, ranges, textColor) === false) return true;
        // Allow "excluded" marks that can be overridden
        // These marks are explicitly removed before applying the new mark (see toggleColor command)
        const omitOverrides = (mark)=>{
            return !(0, $cLfUm.overrideMarks).includes(mark.type.name);
        };
        if ((0, $adJV7.isMarkExcluded)(textColor, state.storedMarks?.filter(omitOverrides) || $cursor && $cursor.marks().filter(omitOverrides))) return true;
        return false;
    }
    return true;
};
module.exports["getDisabledState"] = $f1be6582f99aecf7$export$4af1020a67b5ec91;

});

parcelRegister("7qyDa", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $12XbP = parcelRequire("12XbP");


var $cXCJB = parcelRequire("cXCJB");

var $5tPGk = parcelRequire("5tPGk");


var $4pBmf = parcelRequire("4pBmf");


var $lH6tf = parcelRequire("lH6tf");


var $6lSx6 = parcelRequire("6lSx6");

var $39b0034b97410c1c$export$a5d11b3163e4b1a5 = /*#__PURE__*/ function(ToolbarType) {
    ToolbarType["PRIMARY"] = "primary";
    ToolbarType["FLOATING"] = "floating";
    return ToolbarType;
}({});
const $39b0034b97410c1c$export$803d4933f12f6ddc = (0, $kSwu1.injectIntl)(({ pluginState: pluginState, editorView: editorView, pluginInjectionApi: pluginInjectionApi, disabled: disabled })=>{
    const blackWhiteColorMap = (0, $5tPGk.createBuiltInColorMap)({
        knownColors: [
            "var(--ds-text-inverse, #FFFFFF)",
            "var(--ds-text, #292A2E)"
        ]
    });
    // Help Hub advanced theming: surface the 22-swatch brand palette
    // (20 palette shades + white + black) in the text-color picker so
    // heading/normal text can use brand colours. Gated on the advanced
    // theming flag via `isAdvancedThemingEnabled` — when OFF (or outside a
    // HubThemingProvider, e.g. cross-host) `useHubTheming()` is undefined
    // and we fall back to the black/white default.
    const theming = (0, $4pBmf.useHubTheming)();
    const builtInColorMap = theming?.isAdvancedThemingEnabled && theming.brandBackgroundColorMap ? theming.brandBackgroundColorMap : blackWhiteColorMap;
    const changeTextColor = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((color)=>{
        if (color && !disabled) (0, $lH6tf.changeColor)(color, pluginInjectionApi?.analytics?.actions)(editorView.state, editorView.dispatch);
        editorView?.focus();
        return false;
    }, [
        disabled,
        editorView,
        pluginInjectionApi?.analytics?.actions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $12XbP.ToolbarDropdownWrapper), {
        "data-testid": "company-hub-text-color-picker"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
        analyticsSource: "companyHubToolbarTextColor",
        builtInColorMap: builtInColorMap,
        onChange: changeTextColor,
        value: pluginState.color || pluginState.defaultColor,
        isDisabled: disabled || pluginState.disabled,
        pickerTitle: (0, $6lSx6.messages).colorPickerTitle,
        showCustomPalette: true,
        showTextIcon: true,
        enableBorderLessStyle: true
    }));
});
module.exports["ToolbarType"] = $39b0034b97410c1c$export$a5d11b3163e4b1a5;
module.exports["ToolbarCompanyHubTextColor"] = $39b0034b97410c1c$export$803d4933f12f6ddc;

});

parcelRegister("gUU6c", function(module, exports) {
/* CompanyHubTextColorButton.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3k5Tv = parcelRequire("3k5Tv");


var $c2kFl = parcelRequire("c2kFl");


var $bFSJa = parcelRequire("bFSJa");


var $7XIuB = parcelRequire("7XIuB");


var $uyXFl = parcelRequire("uyXFl");

var $9Muxb = parcelRequire("9Muxb");


var $9Rqjc = parcelRequire("9Rqjc");

var $g8ETs = parcelRequire("g8ETs");


var $7Y8M5 = parcelRequire("7Y8M5");


var $imx1A = parcelRequire("imx1A");

var $6t3CY = parcelRequire("6t3CY");

var $WcuYo = parcelRequire("WcuYo");

var $lslMH = parcelRequire("lslMH");

var $b2jdX = parcelRequire("b2jdX");


var $dinVW = parcelRequire("dinVW");


var $89bON = parcelRequire("89bON");


var $xYZ24 = parcelRequire("xYZ24");

var $5tPGk = parcelRequire("5tPGk");


var $4pBmf = parcelRequire("4pBmf");


var $lH6tf = parcelRequire("lH6tf");


var $lpukL = parcelRequire("lpukL");


var $dRHIT = parcelRequire("dRHIT");

const $e2c4bfa16fd24619$var$popupComponentStyles = {
    popupWrapper: "_0bjKvDKxmn _0KLXrulfZc _2OUyjtGk8v _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE"
};
const $e2c4bfa16fd24619$var$getHighlightColorIcon = (highlightColor)=>{
    if (highlightColor) return (0, $9Rqjc.hexToEditorTextBackgroundPaletteColor)(highlightColor);
    return undefined;
};
const $e2c4bfa16fd24619$var$PopupWithListeners = (0, $9Muxb.default)((0, $7XIuB.default));
const $e2c4bfa16fd24619$export$5738d006e3bc472b = ({ api: api, parents: parents })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const buttonRef = (0, $cozmU.useRef)(null);
    const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement } = (0, $b2jdX.useToolbarUI)();
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const { color: color, defaultColor: defaultColor, disabled: textColorDisabled, highlightColor: highlightColor } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'companyHubTextColor',
        'highlight'
    ], (states)=>({
            color: states.companyHubTextColorState?.color,
            defaultColor: states.companyHubTextColorState?.defaultColor,
            disabled: states.companyHubTextColorState?.disabled,
            highlightColor: states.highlightState?.activeColor
        }));
    const blackWhiteColorMap = (0, $cozmU.useMemo)(()=>(0, $5tPGk.createBuiltInColorMap)({
            knownColors: [
                (0, $89bON.getTokenValue)('color.text.inverse'),
                (0, $89bON.getTokenValue)('color.text')
            ]
        }), []); // Help Hub advanced theming: surface the 22-swatch brand palette (20
    // palette shades + white + black) in the text-color picker so heading /
    // normal text can use brand colours. Gated on the advanced theming flag
    // via `isAdvancedThemingEnabled` — when OFF (or outside a
    // HubThemingProvider, e.g. cross-host) `useHubTheming()` is undefined and
    // we fall back to the black/white default.
    const theming = (0, $4pBmf.useHubTheming)();
    const builtInColorMap = theming?.isAdvancedThemingEnabled && theming.brandBackgroundColorMap ? theming.brandBackgroundColorMap : blackWhiteColorMap;
    const getIconColor = (0, $cozmU.useCallback)(()=>{
        if (!color || color === defaultColor) return (0, $89bON.getTokenValue)('color.text');
         // find a matching editor text palette color for the hex color
        // if none is found, return the hex color itself
        return (0, $g8ETs.hexToEditorTextPaletteColor)(color) || color || (0, $89bON.getTokenValue)('color.text');
    }, [
        color,
        defaultColor
    ]);
    const handleColorChange = (0, $cozmU.useCallback)((color_0)=>{
        if (color_0 && !textColorDisabled && editorView?.state && editorView?.dispatch) {
            (0, $lH6tf.changeColor)(color_0, api?.analytics?.actions)(editorView.state, editorView.dispatch);
            editorView.focus();
        }
        setIsOpen(false);
        return false;
    }, [
        textColorDisabled,
        editorView,
        api?.analytics?.actions
    ]);
    const handleInternalClick = (0, $cozmU.useCallback)((evt)=>{
        // Stop propagation of clicks inside the popup to prevent the document click listener from triggering
        // Without this, clicking on RGB/HEX/HSL dropdown would close the popup immediately
        evt.stopPropagation();
    }, []);
    const handleInternalKeyDown = (0, $cozmU.useCallback)((evt_0)=>{
        // Stop propagation of keyboard events inside the popup to prevent the document listener from triggering
        // Support standard keyboard interactions for interactive elements within the popup
        if (evt_0.key === 'Enter' || evt_0.key === ' ') evt_0.stopPropagation();
    }, []);
    const closeMenu = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        setIsOpen(!isOpen);
    }, [
        setIsOpen,
        isOpen
    ]);
    if (!api?.companyHubTextColor || color === undefined || defaultColor === undefined) return null;
    const iconColor = getIconColor();
    const isDisabled = Boolean(textColorDisabled);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isOpen && buttonRef.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e2c4bfa16fd24619$var$PopupWithListeners, {
        target: buttonRef.current,
        zIndex: (0, $7Y8M5.akEditorFloatingOverlapPanelZIndex),
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        alignY: "top",
        alignX: "left",
        handleClickOutside: closeMenu,
        handleEscapeKeydown: closeMenu,
        allowOutOfBounds: true,
        fitHeight: 350,
        fitWidth: 350,
        preventOverflow: true,
        stick: false,
        offset: [
            0,
            10
        ],
        focusTrap: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyXFl.OutsideClickTargetRefContext).Consumer, null, (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            role: "none",
            "data-test-id": 'company-hub-text-color-picker',
            onClick: handleInternalClick,
            onKeyDown: handleInternalKeyDown,
            ref: setOutsideClickTargetRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $e2c4bfa16fd24619$var$popupComponentStyles.popupWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $xYZ24.ColorPickerDropdown), {
            appearance: "embedded",
            analyticsSource: "companyHubToolbarTextColor",
            builtInColorMap: builtInColorMap,
            onChange: handleColorChange,
            value: color || defaultColor,
            pickerTitle: (0, $c2kFl.companyHubTextColorMessages).colorPickerTitle,
            showCustomPalette: true,
            isOpen: true,
            update: ()=>Promise.resolve(null),
            setInitialFocusRef: ()=>null
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpukL.HighlightColorSection), {
            api: api,
            parents: parents
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dRHIT.RemoveColorSection), {
            api: api,
            parents: parents
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
        content: formatMessage((0, $c2kFl.companyHubTextColorMessages).colorPickerTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t3CY.ToolbarButton), {
        testId: "company-hub-text-color-toolbar-button",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $WcuYo.ToolbarColorSwatch), {
            highlightColor: $e2c4bfa16fd24619$var$getHighlightColorIcon(highlightColor)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $imx1A.TextColorIcon), {
            label: formatMessage((0, $c2kFl.companyHubTextColorMessages).colorPickerTitle),
            iconColor: iconColor,
            size: 'small',
            isDisabled: isDisabled,
            spacing: 'compact'
        })),
        ref: buttonRef,
        onClick: handleClick,
        isSelected: isOpen,
        isDisabled: isDisabled
    })));
};
module.exports["CompanyHubTextColorButton"] = $e2c4bfa16fd24619$export$5738d006e3bc472b;

});

parcelRegister("arMIH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $03RpJ = parcelRequire("03RpJ");


var $8nvEM = parcelRequire("8nvEM");


var $91TKv = parcelRequire("91TKv");

const $058315dbd776c173$export$b81140debd8a9739 = 'hub-external-insert-cursor';
function $058315dbd776c173$export$f06d6d3dfe4b012f(decorations) {
    return decorations.find(0, 1e9, (spec)=>spec.type === $058315dbd776c173$export$b81140debd8a9739);
}
/** Minimal gap/offset for cursor indicator alignment (first version – constants). */ function $058315dbd776c173$var$getGapAndOffset(_prevNode, _nextNode, _parentNode) {
    if (!_prevNode && _nextNode) return {
        gap: 0,
        offset: 0
    };
    if (_prevNode && !_nextNode) return {
        gap: 0,
        offset: 0
    };
    return {
        gap: 4,
        offset: 0
    };
}
function $058315dbd776c173$export$f9707a82f2564638(pos, nodeViewPortalProviderAPI, prevNode, nextNode, parentNode) {
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const key = `hub-external-insert-cursor-${(0, $03RpJ.default)()}`;
    const { gap: gap, offset: offset } = $058315dbd776c173$var$getGapAndOffset(prevNode, nextNode, parentNode);
    return (0, $8nvEM.Decoration).widget(pos, ()=>{
        const element = document.createElement('div');
        element.setAttribute('data-hub-external-insert-cursor', 'true');
        element.style.clear = 'unset';
        element.style.display = 'block';
        // `position: relative` makes this host the offset parent of
        // the indicator's `position: absolute` container, so the
        // indicator's `left: 0; right: 0` resolves against this
        // host's natural (container-constrained) width.
        element.style.position = 'relative';
        element.style.width = '100%';
        element.style.setProperty((0, $91TKv.CURSOR_DROP_INDICATOR_OFFSET), `${offset}px`);
        element.style.setProperty((0, $91TKv.CURSOR_DROP_INDICATOR_GAP), `${gap}px`);
        try {
            nodeViewPortalProviderAPI.render(()=>(0, $cozmU.createElement)((0, $91TKv.CursorDropIndicator)), element, key, undefined, true);
        } catch  {}
        return element;
    }, {
        type: $058315dbd776c173$export$b81140debd8a9739,
        destroy: ()=>{
            nodeViewPortalProviderAPI.remove(key);
        }
    });
}
module.exports["findCursorIndicatorDecs"] = $058315dbd776c173$export$f06d6d3dfe4b012f;
module.exports["createCursorIndicatorDecoration"] = $058315dbd776c173$export$f9707a82f2564638;

});

parcelRegister("57S2y", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

parcelRequire("cvj4z");
var $j4NNn = parcelRequire("j4NNn");


var $gBjHb = parcelRequire("gBjHb");


var $33jh4 = parcelRequire("33jh4");


var $dX71b = parcelRequire("dX71b");


var $6cA3O = parcelRequire("6cA3O");


var $lnxfH = parcelRequire("lnxfH");


var $7gqwM = parcelRequire("7gqwM");


var $iMnC5 = parcelRequire("iMnC5");


var $4aRua = parcelRequire("4aRua");


var $4HuLY = parcelRequire("4HuLY");


var $r8hvx = parcelRequire("r8hvx");


var $6D10p = parcelRequire("6D10p");


var $1hWe9 = parcelRequire("1hWe9");


var $805yB = parcelRequire("805yB");

const $58d98241c60e9c9d$var$styles = {
    container: "_24h04i2Njc _4ouGXIdnbC _1wydGWNHnM _2Zuz6QNHnM _1ZnuxbNHnM _39xV02N91d",
    item: "_2sNsIgmnOE _3iDTPbQ4SZ _24h04i2Njc _4ouGXIdnbC _1EqgXlN91d _0hPCNLDIqT _4xdlr0DIqT _0aFT5v1qpb _313842dnbC",
    separator: "_4c065UFQfX _2Y7lL42ADO _39xV02Jg58 _3YEZNOdnbC _2fwxA5DIqT",
    itemText: "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _39HuIbz8Lp _1ANEUSLRg7"
};
const $58d98241c60e9c9d$var$StaticHubParentBreadcrumb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { item: item } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $58d98241c60e9c9d$var$styles.itemText
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== item.text) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest",
            maxLines: 1
        }, item.text));
        $[1] = item.text;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-hidden": true,
            className: (0, $hekY6.default)([
                $58d98241c60e9c9d$var$styles.separator
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest"
        }, "/"));
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t2) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $58d98241c60e9c9d$var$styles.item,
            as: "li"
        }, t2, t3);
        $[4] = t2;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : ({ item: item })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $58d98241c60e9c9d$var$styles.item,
        as: "li"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $58d98241c60e9c9d$var$styles.itemText
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: 'color.text.subtlest',
        maxLines: 1
    }, item.text)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "aria-hidden": true,
        className: (0, $hekY6.default)([
            $58d98241c60e9c9d$var$styles.separator
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, "/")));
};
const $58d98241c60e9c9d$var$StaticHubCurrentBreadcrumb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { item: item } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $58d98241c60e9c9d$var$styles.itemText
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== item.text) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $58d98241c60e9c9d$var$styles.item,
            as: "li"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-current": "page",
            className: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            maxLines: 1
        }, item.text)));
        $[1] = item.text;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ item: item })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $58d98241c60e9c9d$var$styles.item,
        as: "li"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "aria-current": "page",
        className: (0, $hekY6.default)([
            $58d98241c60e9c9d$var$styles.itemText
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        maxLines: 1
    }, item.text)));
};
const $58d98241c60e9c9d$export$e610d88d5224ae75 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { itemCount: itemCount } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            (0, $4HuLY.HUB_FEATURES).BREADCRUMBS
        ];
        $[0] = t1;
    } else t1 = $[0];
    const [isBreadcrumbsEnabled] = (0, $4HuLY.useIsHubFeatureEnabled)(t1);
    if (!isBreadcrumbsEnabled) return null;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $58d98241c60e9c9d$var$styles.container
        ]);
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== itemCount) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lnxfH.default), null, Array.from({
            length: itemCount
        }).map($58d98241c60e9c9d$var$_temp));
        $[2] = itemCount;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t2 || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t2
        }, t3);
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ itemCount: itemCount })=>{
    const [isBreadcrumbsEnabled] = (0, $4HuLY.useIsHubFeatureEnabled)([
        (0, $4HuLY.HUB_FEATURES).BREADCRUMBS
    ]);
    if (!isBreadcrumbsEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $58d98241c60e9c9d$var$styles.container
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lnxfH.default), null, Array.from({
        length: itemCount
    }).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7gqwM.default), {
            width: 60,
            key: index
        }))));
};
const $58d98241c60e9c9d$export$cc8c957f0e477af0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(26);
    const intl = (0, $kSwu1.useIntl)();
    const items = (0, $1hWe9.useHubBreadcrumbItems)();
    const currentItem = items[items.length - 1];
    const { env: t0 } = (0, $r8hvx.useHubContext)();
    const { relativeBaseUrl: relativeBaseUrl } = t0;
    const { push: push } = (0, $j4NNn.useRouterActions)();
    if (!currentItem) return null;
    let t1;
    if ($[0] !== intl) {
        t1 = intl.formatMessage((0, $805yB.messages).label);
        $[0] = intl;
        $[1] = t1;
    } else t1 = $[1];
    const label = t1;
    let t2;
    if ($[2] !== intl) {
        t2 = intl.formatMessage((0, $805yB.messages).showMore);
        $[2] = intl;
        $[3] = t2;
    } else t2 = $[3];
    const ellipsisLabel = t2;
    let t3;
    if ($[4] !== push) {
        t3 = (href)=>(event)=>{
                const isPrimaryClick = "button" in event && event.button === 0;
                const isEnterKey = "key" in event && event.key === "Enter";
                if (!event.defaultPrevented && (isPrimaryClick || isEnterKey) && !event.metaKey && !event.ctrlKey && !event.altKey && !event.shiftKey) {
                    event.preventDefault();
                    push(href);
                }
            };
        $[4] = push;
        $[5] = t3;
    } else t3 = $[5];
    const onBreadcrumbItemClick = t3;
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            $58d98241c60e9c9d$var$styles.container
        ]);
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== items || $[8] !== onBreadcrumbItemClick || $[9] !== relativeBaseUrl) {
        let t6;
        if ($[11] !== onBreadcrumbItemClick || $[12] !== relativeBaseUrl) {
            t6 = (item, index)=>item.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                    data: {
                        attributes: {
                            itemType: item.id,
                            position: index + 1
                        }
                    },
                    key: item.id
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cA3O.default), {
                    href: (0, $6D10p.getHubBreadcrumbHref)(relativeBaseUrl, item.href),
                    onClick: onBreadcrumbItemClick(item.href),
                    text: item.text
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($58d98241c60e9c9d$var$StaticHubParentBreadcrumb, {
                    item: item,
                    key: item.id
                });
            $[11] = onBreadcrumbItemClick;
            $[12] = relativeBaseUrl;
            $[13] = t6;
        } else t6 = $[13];
        t5 = items.slice(0, -1).map(t6);
        $[7] = items;
        $[8] = onBreadcrumbItemClick;
        $[9] = relativeBaseUrl;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[14] !== currentItem || $[15] !== items.length || $[16] !== relativeBaseUrl) {
        t6 = currentItem.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
            data: {
                attributes: {
                    itemType: currentItem.id,
                    position: items.length
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dX71b.default), {
            href: (0, $6D10p.getHubBreadcrumbHref)(relativeBaseUrl, currentItem.href),
            text: currentItem.text
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($58d98241c60e9c9d$var$StaticHubCurrentBreadcrumb, {
            item: currentItem
        });
        $[14] = currentItem;
        $[15] = items.length;
        $[16] = relativeBaseUrl;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== ellipsisLabel || $[19] !== label || $[20] !== t5 || $[21] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $33jh4.default), {
            ellipsisLabel: ellipsisLabel,
            label: label,
            size: "medium",
            testId: "hub-breadcrumbs"
        }, t5, t6);
        $[18] = ellipsisLabel;
        $[19] = label;
        $[20] = t5;
        $[21] = t6;
        $[22] = t7;
    } else t7 = $[22];
    let t8;
    if ($[23] !== t4 || $[24] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "hub-breadcrumbs-container",
            className: t4
        }, t7);
        $[23] = t4;
        $[24] = t7;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
} : ()=>{
    const intl = (0, $kSwu1.useIntl)();
    const items = (0, $1hWe9.useHubBreadcrumbItems)();
    const currentItem = items[items.length - 1];
    const { env: { relativeBaseUrl: relativeBaseUrl } } = (0, $r8hvx.useHubContext)();
    const { push: push } = (0, $j4NNn.useRouterActions)();
    if (!currentItem) return null;
    const label = intl.formatMessage((0, $805yB.messages).label);
    const ellipsisLabel = intl.formatMessage((0, $805yB.messages).showMore);
    const onBreadcrumbItemClick = (href)=>(event)=>{
            const isPrimaryClick = 'button' in event && event.button === 0;
            const isEnterKey = 'key' in event && event.key === 'Enter';
            if (!event.defaultPrevented && (isPrimaryClick || isEnterKey) && !event.metaKey && !event.ctrlKey && !event.altKey && !event.shiftKey) {
                // The anchor needs the Hub base path, but browser history adds it on navigation.
                event.preventDefault();
                push(href);
            }
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "hub-breadcrumbs-container",
        className: (0, $hekY6.default)([
            $58d98241c60e9c9d$var$styles.container
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $33jh4.default), {
        ellipsisLabel: ellipsisLabel,
        label: label,
        size: "medium",
        testId: "hub-breadcrumbs"
    }, items.slice(0, -1).map((item, index)=>item.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
            data: {
                attributes: {
                    itemType: item.id,
                    position: index + 1
                }
            },
            key: item.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cA3O.default), {
            href: (0, $6D10p.getHubBreadcrumbHref)(relativeBaseUrl, item.href),
            onClick: onBreadcrumbItemClick(item.href),
            text: item.text
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($58d98241c60e9c9d$var$StaticHubParentBreadcrumb, {
            item: item,
            key: item.id
        })), currentItem.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: {
            attributes: {
                itemType: currentItem.id,
                position: items.length
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dX71b.default), {
        href: (0, $6D10p.getHubBreadcrumbHref)(relativeBaseUrl, currentItem.href),
        text: currentItem.text
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($58d98241c60e9c9d$var$StaticHubCurrentBreadcrumb, {
        item: currentItem
    })));
};
function $58d98241c60e9c9d$var$_temp(_, index) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7gqwM.default), {
        width: 60,
        key: index
    });
}
module.exports["HubBreadcrumbs"] = $58d98241c60e9c9d$export$cc8c957f0e477af0;

});

parcelRegister("a6uUc", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");

parcelRequire("fMvIa");
var $8Dc6h = parcelRequire("8Dc6h");
var $idnP4 = parcelRequire("idnP4");


var $2lscT = parcelRequire("2lscT");


var $arQY7 = parcelRequire("arQY7");


var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $l3wuH = parcelRequire("l3wuH");


var $untPk = parcelRequire("untPk");


var $lskrC = parcelRequire("lskrC");


var $7Mix9 = parcelRequire("7Mix9");


var $iFlah = parcelRequire("iFlah");


var $iODl6 = parcelRequire("iODl6");


var $iDrrr = parcelRequire("iDrrr");


var $4n1IT = parcelRequire("4n1IT");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $jg3tF = parcelRequire("jg3tF");


var $gMq3e = parcelRequire("gMq3e");

var $r8hvx = parcelRequire("r8hvx");

var $d7SWg = parcelRequire("d7SWg");


var $hhnRo = parcelRequire("hhnRo");


var $4WDWC = parcelRequire("4WDWC");


var $eafQX = parcelRequire("eafQX");


var $51SAu = parcelRequire("51SAu");


var $1STAw = parcelRequire("1STAw");


var $ceKKZ = parcelRequire("ceKKZ");


var $hIH5w = parcelRequire("hIH5w");


const $ee5d7114683e59af$var$MobileMenuOverlay = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("kPBMe")).then((m)=>({
            default: m.MobileMenuOverlay
        })));
const $ee5d7114683e59af$var$motionStyles = {
    slideEntering: "_1gBibyJtnr _0nFVCGLrT7 _43vdfTjwM9",
    slideExiting: "_1gBibyMmpp _0nFVCGLrT7 _43vdfTyNAO"
};
const $ee5d7114683e59af$var$styles = {
    navbarStacking: "_1mT5xdRAKS _42Yu6Bbhqd",
    navbar: "_0Of8r2NHnM _1ZnuxbNHnM _1wydGWNHnM _2Zuz6QNHnM",
    navbarUpdated: "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    navBarDisabled: "_1pp6NdYbGa",
    logoContainer: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT",
    rightSection: "_2mHwu88HPE _3iDTPbQ4SZ _0hPCNLDIqT _3YEZNOdnbC"
};
const $ee5d7114683e59af$export$42cfbb80f7861e77 = ({ isEditMode: isEditMode = false })=>{
    (0, $6cFsl.di)((0, $iDrrr.fg), (0, $r8hvx.useHubContext), (0, $idnP4.useRouterActions));
    const [isAvatarMenuOpen, setIsAvatarMenuOpen] = (0, $cozmU.useState)(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = (0, $cozmU.useState)(false);
    const [viewportMatches, setViewportMatches] = (0, $cozmU.useState)();
    const navbarRef = (0, $cozmU.useRef)(null);
    const isMobileViewEnabled = (0, $iDrrr.fg)('hubs_nav_mobile_view');
    const isViewportSwitchEnabled = (0, $iDrrr.fg)('switch-hub-nav-bar') && isMobileViewEnabled;
    const handleViewportChange = (0, $cozmU.useCallback)((event)=>{
        setViewportMatches(event.matches);
        setIsMobileMenuOpen(false);
        setIsAvatarMenuOpen(false);
    }, []);
    const mediaQuery = (0, $jg3tF.UNSAFE_useMediaQuery)('below.sm', isViewportSwitchEnabled ? handleViewportChange : undefined);
    const isBelowSm = (isViewportSwitchEnabled ? viewportMatches : undefined) ?? mediaQuery?.matches ?? false;
    const hubContext = (0, $r8hvx.useHubContext)();
    const { featureFlags: featureFlags, hubType: hubType } = hubContext;
    const { options: navStyle } = (0, $d7SWg.useNavigationStyle)(); // Keep a black/white navbar label legible against the live brand colour. The
    // navbar's day-0 background is the darkest brand shade, so a brand change can
    // invert which of black/white is readable. An explicit colour is left alone.
    // See `hub-auto-text-color`.
    const resolveNavTextColor = (0, $hhnRo.useHubAutoTextColor)('hub-app-shell');
    const navTextColor = resolveNavTextColor({
        backgroundColor: navStyle?.backgroundColor,
        textColor: navStyle?.textColor,
        defaultRef: 'primary.1000'
    });
    const isNavBarUpdated = featureFlags?.hub_component_upgrade ?? false;
    const isLoginButtonContrastGateEnabled = (0, $iDrrr.fg)('hubs_nav_login_button_contrast');
    const isLoginButtonContrastEnabled = isNavBarUpdated && isLoginButtonContrastGateEnabled;
    const isMenuStackingFixEnabled = (0, $iDrrr.fg)('hubs_nav_menu_stacking_fix');
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)(); // A navbar-specific corner radius is Premium. Suppressing it makes the navbar
    // inherit the hub-wide radius, which the backend resets to the 8px default.
    // Only the gated path is neutralised: the legacy path below has no hub-wide
    // value to fall back to, so it keeps applying the saved radius.
    const isCornerRadiusLocked = (0, $51SAu.useShouldShowPremiumUpsell)();
    const shouldShowMobileNavLinks = isNavBarUpdated && isBelowSm && isMobileViewEnabled;
    const dynamicStyle = (0, $cozmU.useMemo)(()=>{
        if (!navStyle) return undefined;
        const border = `1px solid ${navStyle.borderColor}`; // Gate ON: always drive from the hub-wide CSS var; pin it locally only when
        // this navbar has an explicit numeric radius, otherwise inherit the global.
        // Gate OFF: legacy fixed px (cornerRadius is always a number here).
        const cornerRadiusStyle = isCornerRadiusEnabled ? {
            borderRadius: navStyle.padding ? `var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})` : '0',
            ...!isCornerRadiusLocked && navStyle.padding && typeof navStyle.cornerRadius === 'number' ? {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                [(0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR)]: `${(0, $4WDWC.resolveHubCornerRadius)(navStyle.cornerRadius)}px`
            } : {}
        } : // Gate OFF: legacy fixed px. `cornerRadius` is typed `number | null`; if an
        // unset (null) value ever reaches this branch, fall back to the legacy
        // 8px default (matching the mapper's gate-off coercion) rather than
        // rendering an invalid "nullpx".
        {
            borderRadius: navStyle.padding ? `${navStyle.cornerRadius ?? 8}px` : '0'
        };
        return {
            backgroundColor: navStyle.backgroundColor,
            color: navTextColor,
            ...cornerRadiusStyle,
            border: navStyle.borderType === 'ALL_BORDER' ? border : 'none',
            // this will be the css 'none' value
            borderBottom: [
                'BOTTOM_BORDER',
                'ALL_BORDER'
            ].includes(navStyle.borderType) ? border : undefined,
            // bottom border is always applied for all borders
            position: navStyle.fixedAtTop ? 'sticky' : 'relative',
            top: navStyle.padding && navStyle.fixedAtTop ? "var(--ds-space-300, 24px)" : '0px',
            // Gate ON: z-index lives in `styles.navbarStacking`; an inline one would override it.
            zIndex: !isMenuStackingFixEnabled && navStyle.fixedAtTop ? 1 : undefined,
            marginTop: navStyle.padding ? "var(--ds-space-300, 24px)" : undefined,
            marginLeft: navStyle.padding ? "var(--ds-space-300, 24px)" : undefined,
            marginRight: navStyle.padding ? "var(--ds-space-300, 24px)" : undefined,
            marginBottom: "var(--ds-space-300, 24px)",
            // we always add a margin bottom to the navbar
            transition: 'margin 0.3s ease, border-radius 0.3s ease, top 0.3s ease'
        };
    }, [
        navStyle,
        navTextColor,
        isCornerRadiusEnabled,
        isCornerRadiusLocked,
        isMenuStackingFixEnabled
    ]);
    const iconColor = isNavBarUpdated ? navTextColor : undefined;
    const { push: push } = (0, $idnP4.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const logoUrl = hubContext.branding.logo.url;
    const { avatarSrc: avatarSrc, email: email } = hubContext.user;
    const { renderCustomNavActions: renderCustomNavActions, renderRightNavActions: renderRightNavActions } = hubContext;
    const isAnonymousRoute = hubContext.layout?.isAnonymousRoute || false;
    const homePath = isAnonymousRoute ? '/user/login' : '/';
    const isHomeLinkHrefEnabled = (0, $iDrrr.fg)('csm_support_site_home_link_href');
    const handleHomeClick = (0, $cozmU.useCallback)((event_0)=>{
        if (event_0.defaultPrevented || event_0.metaKey || event_0.ctrlKey || event_0.shiftKey || event_0.altKey || 'button' in event_0 && event_0.button !== 0) return;
         // Keep router navigation relative; the href includes the hub base path.
        event_0.preventDefault();
        push(homePath);
    }, [
        homePath,
        push
    ]);
    const handleInboxClick = (0, $cozmU.useCallback)(()=>{
        push(`/user/requests`);
    }, [
        push
    ]);
    const handleProfileClick = (0, $cozmU.useCallback)(()=>{
        setIsAvatarMenuOpen(!isAvatarMenuOpen);
    }, [
        isAvatarMenuOpen
    ]);
    const handleAvatarMenuClose = (0, $cozmU.useCallback)(()=>{
        setIsAvatarMenuOpen(false);
    }, []);
    const handleHamburgerClick = (0, $cozmU.useCallback)(()=>{
        setIsMobileMenuOpen(true);
    }, []);
    const handleMobileMenuClose = (0, $cozmU.useCallback)(()=>{
        setIsMobileMenuOpen(false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: navbarRef,
        "data-testId": "navbar",
        xcss: (0, $w6R6I.cx)(isMenuStackingFixEnabled && $ee5d7114683e59af$var$styles.navbarStacking, isNavBarUpdated ? $ee5d7114683e59af$var$styles.navbarUpdated : $ee5d7114683e59af$var$styles.navbar, isEditMode && $ee5d7114683e59af$var$styles.navBarDisabled),
        style: isNavBarUpdated ? dynamicStyle : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ee5d7114683e59af$var$styles.logoContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Dc6h.default), {
        to: homePath,
        ...isHomeLinkHrefEnabled ? {
            href: `${hubContext.env.relativeBaseUrl.replace(/\/$/, '')}${homePath}`,
            onClick: handleHomeClick
        } : {}
    }, logoUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        height: (0, $gMq3e.getHubLogoHeight)(hubType),
        src: logoUrl,
        alt: formatMessage((0, $ceKKZ.default).hubLogo)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: isLoginButtonContrastEnabled ? 'subtle' : 'default',
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($untPk))), {
                ...iconProps,
                color: iconColor
            }),
        label: formatMessage((0, $ceKKZ.default).hubLogo),
        color: navTextColor
    }))), !isAnonymousRoute && email && isNavBarUpdated && !isBelowSm && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hIH5w.NavLinks), {
        textColor: navTextColor,
        backgroundColor: navStyle?.backgroundColor
    }), !isAnonymousRoute && email && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ee5d7114683e59af$var$styles.rightSection
    }, !isNavBarUpdated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, renderRightNavActions && renderRightNavActions()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (iconProps_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lskrC))), {
                ...iconProps_0,
                color: iconColor
            }),
        label: "User requests",
        onClick: handleInboxClick
    })), shouldShowMobileNavLinks ? isMobileMenuOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (iconProps_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...iconProps_1,
                color: iconColor
            }),
        label: formatMessage((0, $ceKKZ.default).closeMenu),
        onClick: handleMobileMenuClose
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (iconProps_2)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Mix9))), {
                ...iconProps_2,
                color: iconColor
            }),
        label: formatMessage((0, $ceKKZ.default).openMenu),
        onClick: handleHamburgerClick
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderCustomNavActions && renderCustomNavActions(iconColor), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2lscT.Profile), {
                ...triggerProps,
                tooltip: "Profile and settings",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
                    appearance: "circle",
                    size: "medium",
                    src: avatarSrc
                }),
                onClick: handleProfileClick
            }),
        shouldRenderToParent: true,
        placement: "bottom-end",
        isOpen: isAvatarMenuOpen,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1STAw.AvatarMenu), null),
        onClose: handleAvatarMenuClose
    }))), !isAnonymousRoute && !email && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Dc6h.default), {
        to: `/user/login`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: isLoginButtonContrastEnabled ? 'subtle' : 'default'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        style: isLoginButtonContrastEnabled ? {
            color: navTextColor
        } : undefined
    }, formatMessage((0, $ceKKZ.default).login)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
        appear: true
    }, isMobileMenuOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iFlah.default), {
        enteringAnimationXcss: $ee5d7114683e59af$var$motionStyles.slideEntering,
        exitingAnimationXcss: $ee5d7114683e59af$var$motionStyles.slideExiting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ee5d7114683e59af$var$MobileMenuOverlay, {
        onClose: handleMobileMenuClose,
        navbarRef: navbarRef
    })))));
};
module.exports["Navbar"] = $ee5d7114683e59af$export$42cfbb80f7861e77;

});

parcelRegister("2XAa3", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8497d9ba474775b$export$2e2bcd8739ae039);
var $f8497d9ba474775b$export$2e2bcd8739ae039 = (pluginState, action)=>{
    return pluginState;
};

});

parcelRegister("6lSx6", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $b8ecbb7b641c04ff$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    colorPickerTitle: {
        id: "companyHub.editor.textColor.pickerTitle",
        defaultMessage: "Text Color"
    }
});
module.exports["messages"] = $b8ecbb7b641c04ff$export$defe85febe8b728c;

});

parcelRegister("lpukL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3k5Tv = parcelRequire("3k5Tv");


var $hzZPp = parcelRequire("hzZPp");


var $is7KY = parcelRequire("is7KY");


var $evFm2 = parcelRequire("evFm2");


var $9Rqjc = parcelRequire("9Rqjc");


var $74bCf = parcelRequire("74bCf");

var $kwf4Z = parcelRequire("kwf4Z");


var $I7hWB = parcelRequire("I7hWB");


var $eh6Ml = parcelRequire("eh6Ml");


var $9FyRG = parcelRequire("9FyRG");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");

const $4359f0ef005af088$var$styles = {
    container: "_2mHwu8gVvo _3138425zaO",
    removeHighlightButton: "_0bjKvDKxmn _2YLqiKFQfX _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67",
    icon: "_3iDTPbvbI6 _2XsHFMA17z"
};
const $4359f0ef005af088$var$TextColorIconDecorator = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { label: label, isSelected: isSelected } = t0;
    let t1;
    if ($[0] !== isSelected || $[1] !== label) {
        t1 = isSelected ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            color: "var(--ds-icon, #292A2E)",
            label: label
        }) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $4359f0ef005af088$var$styles.icon
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9FyRG))), {
            label: label,
            color: "var(--ds-icon, #292A2E)",
            shouldRecommendSmallIcon: true,
            spacing: "spacious",
            size: "small"
        }));
        $[0] = isSelected;
        $[1] = label;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ label: label, isSelected: isSelected })=>{
    const iconColor = "var(--ds-icon, #292A2E)";
    return isSelected ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        color: iconColor,
        label: label
    }) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $4359f0ef005af088$var$styles.icon
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9FyRG))), {
        label: label,
        color: iconColor,
        shouldRecommendSmallIcon: true,
        spacing: "spacious",
        size: "small"
    }));
};
const $4359f0ef005af088$export$586c660b6a27552f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function HighlightColorSection(t0) {
    const $ = (0, $bDgLe.c)(24);
    const { api: api, parents: parents } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            "highlight"
        ];
        $[0] = t1;
    } else t1 = $[0];
    const activeColor = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, t1, $4359f0ef005af088$var$_temp);
    const context = (0, $kwf4Z.useToolbarDropdownMenu)();
    const closeMenu = context?.closeMenu;
    let t2;
    if ($[1] !== api || $[2] !== closeMenu || $[3] !== parents) {
        t2 = (color, event)=>{
            if (api?.highlight?.commands?.changeColor) {
                api.core.actions.execute(api.highlight.commands.changeColor({
                    color: color,
                    inputMethod: (0, $is7KY.getInputMethodFromParentKeys)(parents)
                }));
                closeMenu?.(event);
            }
        };
        $[1] = api;
        $[2] = closeMenu;
        $[3] = parents;
        $[4] = t2;
    } else t2 = $[4];
    const handleHighlightColorChange = t2;
    let t3;
    if ($[5] !== activeColor) {
        const isSelected = (color_0)=>color_0.value === activeColor;
        t3 = (0, $evFm2.highlightColorPalette).filter($4359f0ef005af088$var$_temp2).map((color_2)=>({
                ...color_2,
                decorator: /*#__PURE__*/ $cozmU.createElement($4359f0ef005af088$var$TextColorIconDecorator, {
                    label: color_2.label,
                    isSelected: isSelected(color_2)
                })
            }));
        $[5] = activeColor;
        $[6] = t3;
    } else t3 = $[6];
    const colorPalette = t3;
    let t4;
    if ($[7] !== formatMessage) {
        t4 = formatMessage((0, $hzZPp.highlightMessages).highlight);
        $[7] = formatMessage;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "xxsmall"
        }, t4);
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== handleHighlightColorChange) {
        t6 = (color_3, _, event_0)=>{
            handleHighlightColorChange(color_3, event_0);
        };
        $[11] = handleHighlightColorChange;
        $[12] = t6;
    } else t6 = $[12];
    const t7 = activeColor || null;
    let t8;
    if ($[13] !== colorPalette) {
        t8 = colorPalette || [];
        $[13] = colorPalette;
        $[14] = t8;
    } else t8 = $[14];
    let t9;
    if ($[15] !== t8) {
        t9 = {
            palette: t8,
            hexToPaletteColor: (0, $9Rqjc.hexToEditorTextBackgroundPaletteColor)
        };
        $[15] = t8;
        $[16] = t9;
    } else t9 = $[16];
    let t10;
    if ($[17] !== t6 || $[18] !== t7 || $[19] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $74bCf.default), {
            onClick: t6,
            selectedColor: t7,
            paletteOptions: t9
        });
        $[17] = t6;
        $[18] = t7;
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== t10 || $[22] !== t5) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            xcss: $4359f0ef005af088$var$styles.container,
            testId: "highlight-color-menu-item"
        }, t5, t10);
        $[21] = t10;
        $[22] = t5;
        $[23] = t11;
    } else t11 = $[23];
    return t11;
} : function HighlightColorSection({ api: api, parents: parents }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const activeColor = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'highlight'
    ], (states)=>states.highlightState?.activeColor);
    const context = (0, $kwf4Z.useToolbarDropdownMenu)();
    const closeMenu = context?.closeMenu;
    const handleHighlightColorChange = (0, $cozmU.useCallback)((color, event)=>{
        if (api?.highlight?.commands?.changeColor) {
            api.core.actions.execute(api.highlight.commands.changeColor({
                color: color,
                inputMethod: (0, $is7KY.getInputMethodFromParentKeys)(parents)
            }));
            closeMenu?.(event);
        }
    }, [
        api,
        closeMenu,
        parents
    ]);
    const colorPalette = (0, $cozmU.useMemo)(()=>{
        const isSelected = (color_0)=>color_0.value === activeColor;
        return (0, $evFm2.highlightColorPalette).filter((color_1)=>color_1.value !== (0, $evFm2.REMOVE_HIGHLIGHT_COLOR)).map((color_2)=>({
                ...color_2,
                decorator: /*#__PURE__*/ $cozmU.createElement($4359f0ef005af088$var$TextColorIconDecorator, {
                    label: color_2.label,
                    isSelected: isSelected(color_2)
                })
            }));
    }, [
        activeColor
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        xcss: $4359f0ef005af088$var$styles.container,
        testId: "highlight-color-menu-item"
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "xxsmall"
    }, formatMessage((0, $hzZPp.highlightMessages).highlight)), /*#__PURE__*/ $cozmU.createElement((0, $74bCf.default), {
        onClick: (color_3, _, event_0)=>{
            handleHighlightColorChange(color_3, event_0);
        },
        selectedColor: activeColor || null,
        paletteOptions: {
            palette: colorPalette || [],
            hexToPaletteColor: (0, $9Rqjc.hexToEditorTextBackgroundPaletteColor)
        }
    }));
};
function $4359f0ef005af088$var$_temp2(color_1) {
    return color_1.value !== (0, $evFm2.REMOVE_HIGHLIGHT_COLOR);
}
function $4359f0ef005af088$var$_temp(states) {
    return states.highlightState?.activeColor;
}
module.exports["HighlightColorSection"] = $4359f0ef005af088$export$586c660b6a27552f;

});

parcelRegister("dRHIT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $hzZPp = parcelRequire("hzZPp");


var $is7KY = parcelRequire("is7KY");


var $evFm2 = parcelRequire("evFm2");


var $kwf4Z = parcelRequire("kwf4Z");


var $4aRua = parcelRequire("4aRua");

const $9fc2c218313bc9ba$var$styles = {
    removeColorButton: "_0bjKvDKxmn _2YLqiKFQfX _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _313842gVvo"
};
const $9fc2c218313bc9ba$export$c6c1c71256ced33c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { api: api, parents: parents } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const context = (0, $kwf4Z.useToolbarDropdownMenu)();
    const closeMenu = context?.closeMenu;
    let t1;
    if ($[0] !== api || $[1] !== closeMenu || $[2] !== parents) {
        t1 = (event)=>{
            if (!api) return;
            const defaultColor = api.textColor.sharedState.currentState()?.defaultColor;
            if (!defaultColor) return;
            api.core.actions.execute((t2)=>{
                const { tr: tr } = t2;
                api.textColor.commands.changeColor(defaultColor, (0, $is7KY.getInputMethodFromParentKeys)(parents))({
                    tr: tr
                });
                api.highlight?.commands.changeColor({
                    color: (0, $evFm2.REMOVE_HIGHLIGHT_COLOR),
                    inputMethod: (0, $is7KY.getInputMethodFromParentKeys)(parents)
                })({
                    tr: tr
                });
                return tr;
            });
            closeMenu?.(event);
        };
        $[0] = api;
        $[1] = closeMenu;
        $[2] = parents;
        $[3] = t1;
    } else t1 = $[3];
    const onClick = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $9fc2c218313bc9ba$var$styles.removeColorButton
        ]);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== formatMessage) {
        t3 = formatMessage((0, $hzZPp.highlightMessages).removeColor);
        $[5] = formatMessage;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            weight: "medium"
        }, t3);
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== onClick || $[10] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t2
        }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            shouldFitContainer: true,
            appearance: "subtle",
            onClick: onClick
        }, t4));
        $[9] = onClick;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ api: api, parents: parents })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const context = (0, $kwf4Z.useToolbarDropdownMenu)();
    const closeMenu = context?.closeMenu;
    const onClick = (event)=>{
        if (!api) return;
        const defaultColor = api.textColor.sharedState.currentState()?.defaultColor;
        if (!defaultColor) return;
        api.core.actions.execute(({ tr: tr })=>{
            api.textColor.commands.changeColor(defaultColor, (0, $is7KY.getInputMethodFromParentKeys)(parents))({
                tr: tr
            });
            api.highlight?.commands.changeColor({
                color: (0, $evFm2.REMOVE_HIGHLIGHT_COLOR),
                inputMethod: (0, $is7KY.getInputMethodFromParentKeys)(parents)
            })({
                tr: tr
            });
            return tr;
        });
        closeMenu?.(event);
    };
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $9fc2c218313bc9ba$var$styles.removeColorButton
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        shouldFitContainer: true,
        appearance: "subtle",
        onClick: onClick
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "medium"
    }, formatMessage((0, $hzZPp.highlightMessages).removeColor))));
};
module.exports["RemoveColorSection"] = $9fc2c218313bc9ba$export$c6c1c71256ced33c;

});

parcelRegister("91TKv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $vZEJe = parcelRequire("vZEJe");


var $iMnC5 = parcelRequire("iMnC5");

const $e250cf21d08e0f9e$export$5c1bdc10c885b45b = '--editor-cursor-drop-indicator-offset';
const $e250cf21d08e0f9e$export$386f7807bfc7e1a9 = '--editor-cursor-drop-indicator-gap';
const $e250cf21d08e0f9e$var$styles = {
    container: "_1mT5xdWVPG _3OE6xYdnbC _4ApkO2dnbC _3iDTPbvLZJ _42Yu6BgtVO _1VJPca1Ctc",
    dropIndicator: "_0jFU0VN91d _39xV02N91d _1mT5xdRAKS _3iDTPbvLZJ"
};
const $e250cf21d08e0f9e$export$94ce81ee629276a7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CursorDropIndicator() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e250cf21d08e0f9e$var$styles.container,
            testId: "hub-external-insert-cursor-drop-indicator"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e250cf21d08e0f9e$var$styles.dropIndicator,
            testId: "hub-external-insert-cursor-drop-indicator-box"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $vZEJe.DropIndicator), {
            edge: "bottom"
        })));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function CursorDropIndicator() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e250cf21d08e0f9e$var$styles.container,
        testId: "hub-external-insert-cursor-drop-indicator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e250cf21d08e0f9e$var$styles.dropIndicator,
        testId: "hub-external-insert-cursor-drop-indicator-box"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $vZEJe.DropIndicator), {
        edge: "bottom"
    })));
};
module.exports["CURSOR_DROP_INDICATOR_OFFSET"] = $e250cf21d08e0f9e$export$5c1bdc10c885b45b;
module.exports["CURSOR_DROP_INDICATOR_GAP"] = $e250cf21d08e0f9e$export$386f7807bfc7e1a9;
module.exports["CursorDropIndicator"] = $e250cf21d08e0f9e$export$94ce81ee629276a7;

});

parcelRegister("lnxfH", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $7gqwM = parcelRequire("7gqwM");


var $caqWd = parcelRequire("caqWd");

const $3097a2e680b35ec0$var$styles = {
    nav: "_1EqgXlN91d",
    list: "_3iDTPbQ4SZ _0hPCNLDIqT _3TGfC9HnLE _0aNu0LYbGa _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg"
};
const $3097a2e680b35ec0$var$defaultItems = [
    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7gqwM.default), {
        width: 64
    }, "home"),
    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7gqwM.default), {
        width: 96
    }, "parent"),
    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7gqwM.default), {
        width: 80
    }, "current")
]; /**
                                                                                                                                                                                      * __BreadcrumbsSkeleton__
                                                                                                                                                                                      *
                                                                                                                                                                                      * A placeholder skeleton for breadcrumbs while navigation data is loading.
                                                                                                                                                                                      */ 
const $3097a2e680b35ec0$var$BreadcrumbsSkeleton = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BreadcrumbsSkeleton(t0) {
    const $ = (0, $bDgLe.c)(14);
    const { children: children, isShimmering: t1, label: t2, size: t3, testId: testId } = t0;
    const isShimmering = t1 === undefined ? true : t1;
    const label = t2 === undefined ? "Loading breadcrumbs" : t2;
    const size = t3 === undefined ? "medium" : t3;
    const renderedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) > 0 ? children : $3097a2e680b35ec0$var$defaultItems;
    let t4;
    if ($[0] !== isShimmering || $[1] !== size) {
        t4 = {
            isShimmering: isShimmering,
            size: size
        };
        $[0] = isShimmering;
        $[1] = size;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $hekY6.default)([
            $3097a2e680b35ec0$var$styles.nav
        ]);
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            $3097a2e680b35ec0$var$styles.list
        ]);
        $[4] = t6;
    } else t6 = $[4];
    let t7;
    if ($[5] !== renderedChildren || $[6] !== testId) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)("ol", {
            "aria-hidden": "true",
            "data-testid": testId,
            className: t6,
            children: renderedChildren
        });
        $[5] = renderedChildren;
        $[6] = testId;
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== label || $[9] !== t7) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)("nav", {
            "aria-busy": "true",
            "aria-label": label,
            className: t5,
            children: t7
        });
        $[8] = label;
        $[9] = t7;
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] !== t4 || $[12] !== t8) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $caqWd.BreadcrumbsSkeletonContext).Provider, {
            value: t4,
            children: t8
        });
        $[11] = t4;
        $[12] = t8;
        $[13] = t9;
    } else t9 = $[13];
    return t9;
} : function BreadcrumbsSkeleton({ children: children, isShimmering: isShimmering = true, label: label = 'Loading breadcrumbs', size: size = 'medium', testId: testId }) {
    const renderedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) > 0 ? children : $3097a2e680b35ec0$var$defaultItems;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $caqWd.BreadcrumbsSkeletonContext).Provider, {
        value: {
            isShimmering: isShimmering,
            size: size
        },
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("nav", {
            "aria-busy": "true",
            "aria-label": label,
            className: (0, $hekY6.default)([
                $3097a2e680b35ec0$var$styles.nav
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("ol", {
                "aria-hidden": "true",
                "data-testid": testId,
                className: (0, $hekY6.default)([
                    $3097a2e680b35ec0$var$styles.list
                ]),
                children: renderedChildren
            })
        })
    });
};
var $3097a2e680b35ec0$export$2e2bcd8739ae039 = $3097a2e680b35ec0$var$BreadcrumbsSkeleton;
module.exports["default"] = $3097a2e680b35ec0$export$2e2bcd8739ae039;

});

parcelRegister("7gqwM", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");

parcelRequire("cozmU");


var $a9aSv = parcelRequire("a9aSv");


var $7IEOV = parcelRequire("7IEOV");

const $a148696a5738f95d$var$styles = {
    item: "_3iDTPbQ4SZ _0hPCNLDIqT _24h04i2Njc _0jFU0V9DVM _1EqgXlN91d",
    iconWrapper: "_3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _2xTnZxFQfX"
};
const $a148696a5738f95d$var$unboundedStyles = {
    item: "_2QysXmFQfX _2kjhZi2ADO _01IvHGJg58 _1OhcLddnbC _1z9enHKGUX _0y3UDVfzt3 _1wqIxfDIqT"
}; /**
    * __BreadcrumbsSkeletonItem__
    *
    * A placeholder skeleton item for use inside `BreadcrumbsSkeleton`.
    */ 
const $a148696a5738f95d$var$BreadcrumbsSkeletonItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BreadcrumbsSkeletonItem(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { hasIcon: hasIcon, width: width } = t0;
    const { isShimmering: isShimmering, size: size } = (0, $7IEOV.useBreadcrumbsSkeleton)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $a148696a5738f95d$var$styles.item,
            $a148696a5738f95d$var$unboundedStyles.item
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== hasIcon || $[2] !== isShimmering) {
        t2 = hasIcon ? /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: (0, $hekY6.default)([
                $a148696a5738f95d$var$styles.iconWrapper
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                height: 16,
                isShimmering: isShimmering,
                width: 16
            })
        }) : null;
        $[1] = hasIcon;
        $[2] = isShimmering;
        $[3] = t2;
    } else t2 = $[3];
    const t3 = size === "small" ? 12 : 14;
    let t4;
    if ($[4] !== isShimmering || $[5] !== t3 || $[6] !== width) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
            height: t3,
            isShimmering: isShimmering,
            width: width
        });
        $[4] = isShimmering;
        $[5] = t3;
        $[6] = width;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t2 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsxs)("li", {
            className: t1,
            children: [
                t2,
                t4
            ]
        });
        $[8] = t2;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : function BreadcrumbsSkeletonItem({ hasIcon: hasIcon, width: width }) {
    const { isShimmering: isShimmering, size: size } = (0, $7IEOV.useBreadcrumbsSkeleton)();
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("li", {
        className: (0, $hekY6.default)([
            $a148696a5738f95d$var$styles.item,
            $a148696a5738f95d$var$unboundedStyles.item
        ]),
        children: [
            hasIcon ? /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: (0, $hekY6.default)([
                    $a148696a5738f95d$var$styles.iconWrapper
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                    height: 16,
                    isShimmering: isShimmering,
                    width: 16
                })
            }) : null,
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                height: size === 'small' ? 12 : 14,
                isShimmering: isShimmering,
                width: width
            })
        ]
    });
};
var $a148696a5738f95d$export$2e2bcd8739ae039 = $a148696a5738f95d$var$BreadcrumbsSkeletonItem;
module.exports["default"] = $a148696a5738f95d$export$2e2bcd8739ae039;

});

parcelRegister("6D10p", function(module, exports) {
const $959e4ecadfc481b4$export$657a9453714bdcb9 = (relativeBaseUrl, routePath)=>{
    const basePath = relativeBaseUrl.replace(/\/+$/, '');
    if (/^https?:\/\//.test(routePath)) return routePath;
    if (basePath && (routePath === basePath || routePath.startsWith(`${basePath}/`))) return routePath;
    const path = routePath === '/' ? '' : `/${routePath.replace(/^\/+/, '')}`;
    return `${basePath}${path}` || '/';
};
module.exports["getHubBreadcrumbHref"] = $959e4ecadfc481b4$export$657a9453714bdcb9;

});

parcelRegister("1hWe9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $33a1809fc814c211$var$HubBreadcrumbsContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $33a1809fc814c211$var$areBreadcrumbsEqual = (currentItems, nextItems)=>currentItems.length === nextItems.length && currentItems.every((item, index)=>{
        const nextItem = nextItems[index];
        return nextItem !== undefined && item.href === nextItem.href && item.id === nextItem.id && item.text === nextItem.text;
    });
const $33a1809fc814c211$export$cf2b9e6505681ebf = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [items, setItems] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (nextItems)=>{
            setItems((currentItems)=>$33a1809fc814c211$var$areBreadcrumbsEqual(currentItems, nextItems) ? currentItems : nextItems);
        };
        $[1] = t2;
    } else t2 = $[1];
    const setBreadcrumbs = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>setItems([]);
        $[2] = t3;
    } else t3 = $[2];
    const clearBreadcrumbs = t3;
    let t4;
    if ($[3] !== items) {
        t4 = {
            clearBreadcrumbs: clearBreadcrumbs,
            items: items,
            setBreadcrumbs: setBreadcrumbs
        };
        $[3] = items;
        $[4] = t4;
    } else t4 = $[4];
    const value = t4;
    let t5;
    if ($[5] !== children || $[6] !== value) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($33a1809fc814c211$var$HubBreadcrumbsContext.Provider, {
            value: value
        }, children);
        $[5] = children;
        $[6] = value;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
} : ({ children: children })=>{
    const [items, setItems] = (0, $cozmU.useState)([]);
    const setBreadcrumbs = (0, $cozmU.useCallback)((nextItems)=>{
        setItems((currentItems)=>$33a1809fc814c211$var$areBreadcrumbsEqual(currentItems, nextItems) ? currentItems : nextItems);
    }, []);
    const clearBreadcrumbs = (0, $cozmU.useCallback)(()=>setItems([]), []);
    const value = (0, $cozmU.useMemo)(()=>({
            clearBreadcrumbs: clearBreadcrumbs,
            items: items,
            setBreadcrumbs: setBreadcrumbs
        }), [
        clearBreadcrumbs,
        items,
        setBreadcrumbs
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($33a1809fc814c211$var$HubBreadcrumbsContext.Provider, {
        value: value
    }, children);
};
const $33a1809fc814c211$var$useHubBreadcrumbsContext = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)($33a1809fc814c211$var$HubBreadcrumbsContext);
    if (!context) throw new Error("Hub breadcrumb hooks must be used within HubBreadcrumbsProvider");
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)($33a1809fc814c211$var$HubBreadcrumbsContext);
    if (!context) throw new Error('Hub breadcrumb hooks must be used within HubBreadcrumbsProvider');
    return context;
};
const $33a1809fc814c211$export$695acbe2b31cd25f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (items)=>{
    const $ = (0, $bDgLe.c)(7);
    const { clearBreadcrumbs: clearBreadcrumbs, setBreadcrumbs: setBreadcrumbs } = $33a1809fc814c211$var$useHubBreadcrumbsContext();
    let t0;
    let t1;
    if ($[0] !== items || $[1] !== setBreadcrumbs) {
        t0 = ()=>{
            setBreadcrumbs(items);
        };
        t1 = [
            items,
            setBreadcrumbs
        ];
        $[0] = items;
        $[1] = setBreadcrumbs;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    let t3;
    if ($[4] !== clearBreadcrumbs) {
        t2 = ()=>()=>{
                clearBreadcrumbs();
            };
        t3 = [
            clearBreadcrumbs
        ];
        $[4] = clearBreadcrumbs;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useEffect)(t2, t3);
} : (items)=>{
    const { clearBreadcrumbs: clearBreadcrumbs, setBreadcrumbs: setBreadcrumbs } = $33a1809fc814c211$var$useHubBreadcrumbsContext();
    (0, $cozmU.useEffect)(()=>{
        setBreadcrumbs(items);
    }, [
        items,
        setBreadcrumbs
    ]);
    (0, $cozmU.useEffect)(()=>()=>{
            clearBreadcrumbs();
        }, [
        clearBreadcrumbs
    ]);
};
const $33a1809fc814c211$export$e623729f7cd92c6b = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $33a1809fc814c211$var$useHubBreadcrumbsContext().items;
} : ()=>$33a1809fc814c211$var$useHubBreadcrumbsContext().items;
module.exports["useHubBreadcrumbItems"] = $33a1809fc814c211$export$e623729f7cd92c6b;

});

parcelRegister("805yB", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $7b2dc9b0aea56864$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    label: {
        id: "company-hub-common.hub-breadcrumbs.label.non-final",
        defaultMessage: "Breadcrumbs"
    },
    showMore: {
        id: "company-hub-common.hub-breadcrumbs.showMore.non-final",
        defaultMessage: "Show more breadcrumbs"
    }
});
module.exports["messages"] = $7b2dc9b0aea56864$export$defe85febe8b728c;

});

parcelRegister("gMq3e", function(module, exports) {

var $5KWZf = parcelRequire("5KWZf");

const $a3acc295eb36bae5$export$8eeba3862e4455cf = (hubType)=>{
    // Help hubs always use new height
    if (hubType === 'HELP_HUB') return 0, $5KWZf.HUB_LOGO_HEIGHT;
    // CSM hubs always use new height
    if (hubType === 'CUSTOMER_SERVICE') return 0, $5KWZf.HUB_LOGO_HEIGHT;
    // Fallback to legacy height for other hub types
    return 0, $5KWZf.HUB_LOGO_HEIGHT_LEGACY;
};
module.exports["getHubLogoHeight"] = $a3acc295eb36bae5$export$8eeba3862e4455cf;

});

parcelRegister("1STAw", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");

parcelRequire("fMvIa");
var $8Dc6h = parcelRequire("8Dc6h");
var $fcvZw = parcelRequire("fcvZw");


var $9d7Pd = parcelRequire("9d7Pd");


var $kD4eB = parcelRequire("kD4eB");


var $8oBbn = parcelRequire("8oBbn");


var $6IL1T = parcelRequire("6IL1T");


var $8FgJC = parcelRequire("8FgJC");


var $iDrrr = parcelRequire("iDrrr");


var $r8hvx = parcelRequire("r8hvx");


var $67z7B = parcelRequire("67z7B");


var $kE9MM = parcelRequire("kE9MM");


var $dS16R = parcelRequire("dS16R");

const $e8e476bcf8ac50ca$var$styles = {
    menu: "_39xV022k7g"
};
const $e8e476bcf8ac50ca$export$f7f58290278dd286 = ()=>{
    (0, $6cFsl.di)((0, $r8hvx.useHubContext), (0, $iDrrr.fg));
    const hubContext = (0, $r8hvx.useHubContext)();
    const [{ match: match }] = (0, $fcvZw.useRouter)();
    const { user: user, env: env, actions: actions, renderAvatarMenuOptions: renderAvatarMenuOptions, cloudUrl: cloudUrl } = hubContext;
    const { isJiraAdmin: isJiraAdmin } = user;
    const { helpCenterId: helpCenterId, hoistedProjectKey: hoistedProjectKey } = env;
    const { id: pageId } = match.params;
    const { onLogoutClick: onLogoutClick } = actions;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const shouldUseConsumerAvatarMenu = (0, $iDrrr.fg)('enable-jsm-in-hubs');
    const consumerAvatarMenuContent = shouldUseConsumerAvatarMenu && typeof renderAvatarMenuOptions === 'function' ? renderAvatarMenuOptions() : null;
    const csmEditorUrl = (0, $iDrrr.fg)('csm_appification_standalone_navigation') ? `${cloudUrl}/jira/customer-service-management/experiences/${hoistedProjectKey}/settings/${helpCenterId}/support-website/edit${pageId ? `/${pageId}` : ''}` : `${cloudUrl}/jira/helpcenter/projects/${hoistedProjectKey}/settings/${helpCenterId}/support-website/edit${pageId ? `/${pageId}` : ''}`;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $e8e476bcf8ac50ca$var$styles.menu
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $6IL1T.default), {
        spacing: "cozy"
    }, /*#__PURE__*/ $cozmU.createElement((0, $8FgJC.default), null, /*#__PURE__*/ $cozmU.createElement((0, $kE9MM.AccountDetails), null)), consumerAvatarMenuContent || isJiraAdmin && /*#__PURE__*/ $cozmU.createElement((0, $8FgJC.default), {
        hasSeparator: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $8oBbn.default), {
        href: csmEditorUrl,
        className: "cv-exclude-from-customisation"
    }, formatMessage((0, $dS16R.default).editSite))), /*#__PURE__*/ $cozmU.createElement((0, $8FgJC.default), {
        hasSeparator: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $kD4eB.default), {
        component: (0, $iDrrr.fg)('jsm_help_extension_link_href_base_fix') ? (0, $67z7B.default) : (0, $8Dc6h.default),
        to: `/user/profile`,
        className: "cv-exclude-from-customisation"
    }, formatMessage((0, $dS16R.default).profile)), /*#__PURE__*/ $cozmU.createElement((0, $9d7Pd.default), {
        onClick: onLogoutClick
    }, formatMessage((0, $dS16R.default).logout)))));
};
module.exports["AvatarMenu"] = $e8e476bcf8ac50ca$export$f7f58290278dd286;

});

parcelRegister("ceKKZ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $994023d7f92e2ddb$var$_default_1 = (0, $kSwu1.defineMessages)({
    hubLogo: {
        id: "company-hub.hub-app-shell.navbar.hub.logo",
        defaultMessage: "Support home"
    },
    login: {
        id: "company-hub.hub-app-shell.navbar.hub.log-in",
        defaultMessage: "Log in"
    },
    openMenu: {
        id: "company-hub.hub-app-shell.navbar.open-menu.non-final",
        defaultMessage: "Open navigation menu"
    },
    closeMenu: {
        id: "company-hub.hub-app-shell.navbar.close-menu.non-final",
        defaultMessage: "Close navigation menu"
    }
});
var $994023d7f92e2ddb$export$2e2bcd8739ae039 = $994023d7f92e2ddb$var$_default_1;
module.exports["default"] = $994023d7f92e2ddb$export$2e2bcd8739ae039;

});

parcelRegister("hIH5w", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $dk27U = parcelRequire("dk27U");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");

parcelRequire("fMvIa");
var $idnP4 = parcelRequire("idnP4");


var $7ZB0A = parcelRequire("7ZB0A");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $b8pma = parcelRequire("b8pma");


var $r8hvx = parcelRequire("r8hvx");


var $51SAu = parcelRequire("51SAu");


var $iK7lw = parcelRequire("iK7lw");


var $fk4YO = parcelRequire("fk4YO");


var $7TPw9 = parcelRequire("7TPw9");


var $59YRu = parcelRequire("59YRu");


var $jDOHN = parcelRequire("jDOHN");


var $i4PiE = parcelRequire("i4PiE");

const $313e1630e2530993$var$styles = {
    countBadge: "_0bjKvDyzSk _0jFU0VSPN1 _4ouGXISPN1 _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _0KLXrugozt _1UtDYze5R3 _2Zuz6Q1Y8M _1Znuxb1Y8M",
    siteTreeNavLinks: "_2O5Vij7dHp _3YEZNO7dHp _4ouGXIdnbC"
};
// network request when the data has already been fetched for this hub.
// Only used when hubs_fix_rerendering_bootstrap_page_media is ON.
const $313e1630e2530993$var$requestCountCache = new Map();
const $313e1630e2530993$var$getCacheKey = (cloudUrl, helpCenterAri)=>`${cloudUrl}::${helpCenterAri}`; /**
                                                                                                   * Test-only helper: clears the module-level request count cache so unit tests
                                                                                                   * can simulate a "first mount with no cached data" scenario without resetting
                                                                                                   * the entire jest module registry.
                                                                                                   */ 
const $313e1630e2530993$export$7a00ed33b23e6d4d = ()=>{
    $313e1630e2530993$var$requestCountCache.clear();
};
const $313e1630e2530993$var$NavLinkItems = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(64);
    const { backgroundColor: t1, requestCount: requestCount, textColor: t2 } = t0;
    const backgroundColor = t1 === undefined ? "var(--ds-background-neutral-bold, #292A2E)" : t1;
    const textColor = t2 === undefined ? "var(--ds-text-inverse, #FFFFFF)" : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { push: push } = (0, $idnP4.useRouterActions)();
    const { cloudId: cloudId, env: t3, featureFlags: featureFlags } = (0, $r8hvx.useHubContext)();
    const { helpCenterAri: helpCenterAri, hubEditMode: hubEditMode } = t3;
    let t4;
    if ($[0] !== featureFlags?.help_hubs_draft_mode) {
        t4 = (0, $iDrrr.fg)("help_hubs_draft_mode") && featureFlags?.help_hubs_draft_mode === true;
        $[0] = featureFlags?.help_hubs_draft_mode;
        $[1] = t4;
    } else t4 = $[1];
    const isDraftModeEnabled = t4;
    let t5;
    if ($[2] !== featureFlags?.help_hubs_configurable_site_tree) {
        t5 = (0, $iDrrr.fg)("help_hubs_configurable_site_tree") && featureFlags?.help_hubs_configurable_site_tree === true;
        $[2] = featureFlags?.help_hubs_configurable_site_tree;
        $[3] = t5;
    } else t5 = $[3];
    const isConfigurableSiteTreeEnabled = t5;
    let t6;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $iDrrr.fg)("hubs_premium_upsell");
        $[4] = t6;
    } else t6 = $[4];
    const isTopicsEnabled = t6;
    const isPremiumLocked = (0, $51SAu.useShouldShowPremiumUpsell)();
    const fetchDraftPages = Boolean(hubEditMode) && isDraftModeEnabled;
    let t7;
    if ($[5] !== cloudId || $[6] !== fetchDraftPages || $[7] !== helpCenterAri || $[8] !== isConfigurableSiteTreeEnabled) {
        t7 = {
            cloudId: cloudId,
            hubAri: helpCenterAri,
            isDraft: fetchDraftPages,
            isConfigurableSiteTreeEnabled: isConfigurableSiteTreeEnabled,
            isTopicsEnabled: isTopicsEnabled
        };
        $[5] = cloudId;
        $[6] = fetchDraftPages;
        $[7] = helpCenterAri;
        $[8] = isConfigurableSiteTreeEnabled;
        $[9] = t7;
    } else t7 = $[9];
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $dk27U.default), t7);
    const helpCenterById = data?.helpCenter?.helpCenterById;
    const helpCenterRef = helpCenterById?.__typename === "HelpCenter" ? helpCenterById : null;
    let t8;
    if ($[10] !== push) {
        t8 = ()=>{
            push("/");
        };
        $[10] = push;
        $[11] = t8;
    } else t8 = $[11];
    const handleHomeClick = t8;
    let t9;
    if ($[12] !== push) {
        t9 = ()=>{
            push("/user/requests");
        };
        $[12] = push;
        $[13] = t9;
    } else t9 = $[13];
    const handleRequestsClick = t9;
    let t10;
    if ($[14] !== push) {
        t10 = ()=>{
            push("/user/approvals");
        };
        $[14] = push;
        $[15] = t10;
    } else t10 = $[15];
    const handleApprovalsClick = t10;
    if (!requestCount || !helpCenterById) return null;
    const t11 = isConfigurableSiteTreeEnabled ? $313e1630e2530993$var$styles.siteTreeNavLinks : undefined;
    const t12 = isConfigurableSiteTreeEnabled ? "center" : undefined;
    let t13;
    if ($[16] !== textColor) {
        t13 = {
            color: textColor
        };
        $[16] = textColor;
        $[17] = t13;
    } else t13 = $[17];
    let t14;
    if ($[18] !== formatMessage) {
        t14 = formatMessage((0, $fk4YO.default).home);
        $[18] = formatMessage;
        $[19] = t14;
    } else t14 = $[19];
    let t15;
    if ($[20] !== handleHomeClick || $[21] !== t13 || $[22] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: "subtle",
            onClick: handleHomeClick,
            style: t13
        }, t14);
        $[20] = handleHomeClick;
        $[21] = t13;
        $[22] = t14;
        $[23] = t15;
    } else t15 = $[23];
    let t16;
    let t17;
    if ($[24] !== helpCenterRef || $[25] !== textColor) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $59YRu.PortalDropdown), {
            queryRef: helpCenterRef,
            textColor: textColor
        });
        t17 = isTopicsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i4PiE.TopicDropdown), {
            queryRef: helpCenterRef,
            textColor: textColor
        });
        $[24] = helpCenterRef;
        $[25] = textColor;
        $[26] = t16;
        $[27] = t17;
    } else {
        t16 = $[26];
        t17 = $[27];
    }
    let t18;
    if ($[28] !== textColor) {
        t18 = {
            color: textColor
        };
        $[28] = textColor;
        $[29] = t18;
    } else t18 = $[29];
    let t19;
    if ($[30] !== formatMessage) {
        t19 = formatMessage((0, $fk4YO.default).requests);
        $[30] = formatMessage;
        $[31] = t19;
    } else t19 = $[31];
    let t20;
    if ($[32] !== backgroundColor || $[33] !== requestCount.request || $[34] !== textColor) {
        t20 = requestCount.request > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            style: {
                backgroundColor: textColor,
                color: backgroundColor
            },
            xcss: $313e1630e2530993$var$styles.countBadge
        }, requestCount.request);
        $[32] = backgroundColor;
        $[33] = requestCount.request;
        $[34] = textColor;
        $[35] = t20;
    } else t20 = $[35];
    let t21;
    if ($[36] !== t19 || $[37] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.075"
        }, t19, t20);
        $[36] = t19;
        $[37] = t20;
        $[38] = t21;
    } else t21 = $[38];
    let t22;
    if ($[39] !== handleRequestsClick || $[40] !== t18 || $[41] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: "subtle",
            onClick: handleRequestsClick,
            style: t18
        }, t21);
        $[39] = handleRequestsClick;
        $[40] = t18;
        $[41] = t21;
        $[42] = t22;
    } else t22 = $[42];
    let t23;
    if ($[43] !== backgroundColor || $[44] !== formatMessage || $[45] !== handleApprovalsClick || $[46] !== requestCount.approvals || $[47] !== requestCount.pendingApprovals || $[48] !== textColor) {
        t23 = (requestCount.approvals > 0 || requestCount.pendingApprovals > 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: "subtle",
            onClick: handleApprovalsClick,
            style: {
                color: textColor
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.075"
        }, formatMessage((0, $fk4YO.default).approvals), requestCount.pendingApprovals > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            style: {
                backgroundColor: textColor,
                color: backgroundColor
            },
            xcss: $313e1630e2530993$var$styles.countBadge
        }, requestCount.pendingApprovals)));
        $[43] = backgroundColor;
        $[44] = formatMessage;
        $[45] = handleApprovalsClick;
        $[46] = requestCount.approvals;
        $[47] = requestCount.pendingApprovals;
        $[48] = textColor;
        $[49] = t23;
    } else t23 = $[49];
    let t24;
    if ($[50] !== helpCenterRef || $[51] !== isConfigurableSiteTreeEnabled || $[52] !== isPremiumLocked || $[53] !== textColor) {
        t24 = !isPremiumLocked && (isConfigurableSiteTreeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jDOHN.SiteNavigation), {
            queryRef: helpCenterRef,
            textColor: textColor
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7TPw9.MoreDropdown), {
            queryRef: helpCenterRef,
            textColor: textColor
        }));
        $[50] = helpCenterRef;
        $[51] = isConfigurableSiteTreeEnabled;
        $[52] = isPremiumLocked;
        $[53] = textColor;
        $[54] = t24;
    } else t24 = $[54];
    let t25;
    if ($[55] !== t11 || $[56] !== t12 || $[57] !== t15 || $[58] !== t16 || $[59] !== t17 || $[60] !== t22 || $[61] !== t23 || $[62] !== t24) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            testId: "nav-links",
            space: "space.050",
            xcss: t11,
            alignInline: t12
        }, t15, t16, t17, t22, t23, t24);
        $[55] = t11;
        $[56] = t12;
        $[57] = t15;
        $[58] = t16;
        $[59] = t17;
        $[60] = t22;
        $[61] = t23;
        $[62] = t24;
        $[63] = t25;
    } else t25 = $[63];
    return t25;
} : ({ backgroundColor: backgroundColor = "var(--ds-background-neutral-bold, #292A2E)", requestCount: requestCount, textColor: textColor = "var(--ds-text-inverse, #FFFFFF)" })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { push: push } = (0, $idnP4.useRouterActions)();
    const { cloudId: cloudId, env: { helpCenterAri: helpCenterAri, hubEditMode: hubEditMode }, featureFlags: featureFlags } = (0, $r8hvx.useHubContext)();
    const isDraftModeEnabled = (0, $iDrrr.fg)('help_hubs_draft_mode') && featureFlags?.help_hubs_draft_mode === true;
    const isConfigurableSiteTreeEnabled = (0, $iDrrr.fg)('help_hubs_configurable_site_tree') && featureFlags?.help_hubs_configurable_site_tree === true; // Gates the topics fetch as well as the menu, so hubs without the feature do
    // not pay for a field nothing renders.
    const isTopicsEnabled = (0, $iDrrr.fg)('hubs_premium_upsell'); // Folders and custom pages are Premium-only, so un-entitled tenants get no
    // entry point to them — from the site tree or the legacy More dropdown.
    const isPremiumLocked = (0, $51SAu.useShouldShowPremiumUpsell)();
    const fetchDraftPages = Boolean(hubEditMode) && isDraftModeEnabled;
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $dk27U.default), {
        cloudId: cloudId,
        hubAri: helpCenterAri,
        isDraft: fetchDraftPages,
        isConfigurableSiteTreeEnabled: isConfigurableSiteTreeEnabled,
        isTopicsEnabled: isTopicsEnabled
    });
    const helpCenterById = data?.helpCenter?.helpCenterById;
    const helpCenterRef = helpCenterById?.__typename === 'HelpCenter' ? helpCenterById : null;
    const handleHomeClick = (0, $cozmU.useCallback)(()=>{
        push('/');
    }, [
        push
    ]);
    const handleRequestsClick = (0, $cozmU.useCallback)(()=>{
        push('/user/requests');
    }, [
        push
    ]);
    const handleApprovalsClick = (0, $cozmU.useCallback)(()=>{
        push('/user/approvals');
    }, [
        push
    ]);
    if (!requestCount || !helpCenterById) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        testId: "nav-links",
        space: "space.050",
        xcss: isConfigurableSiteTreeEnabled ? $313e1630e2530993$var$styles.siteTreeNavLinks : undefined,
        alignInline: isConfigurableSiteTreeEnabled ? 'center' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        onClick: handleHomeClick,
        style: {
            color: textColor
        }
    }, formatMessage((0, $fk4YO.default).home)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $59YRu.PortalDropdown), {
        queryRef: helpCenterRef,
        textColor: textColor
    }), isTopicsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i4PiE.TopicDropdown), {
        queryRef: helpCenterRef,
        textColor: textColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        onClick: handleRequestsClick,
        style: {
            color: textColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.075"
    }, formatMessage((0, $fk4YO.default).requests), requestCount.request > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        style: {
            backgroundColor: textColor,
            color: backgroundColor
        },
        xcss: $313e1630e2530993$var$styles.countBadge
    }, requestCount.request))), (requestCount.approvals > 0 || requestCount.pendingApprovals > 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        onClick: handleApprovalsClick,
        style: {
            color: textColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.075"
    }, formatMessage((0, $fk4YO.default).approvals), requestCount.pendingApprovals > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        style: {
            backgroundColor: textColor,
            color: backgroundColor
        },
        xcss: $313e1630e2530993$var$styles.countBadge
    }, requestCount.pendingApprovals))), !isPremiumLocked && (isConfigurableSiteTreeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jDOHN.SiteNavigation), {
        queryRef: helpCenterRef,
        textColor: textColor
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7TPw9.MoreDropdown), {
        queryRef: helpCenterRef,
        textColor: textColor
    })));
};
const $313e1630e2530993$export$b615cd9717379c80 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { backgroundColor: t1, textColor: t2 } = t0;
    const backgroundColor = t1 === undefined ? "var(--ds-background-neutral-bold, #292A2E)" : t1;
    const textColor = t2 === undefined ? "var(--ds-text-inverse, #FFFFFF)" : t2;
    const { cloudUrl: cloudUrl, env: t3 } = (0, $r8hvx.useHubContext)();
    const { helpCenterAri: helpCenterAri } = t3;
    let t4;
    if ($[0] !== cloudUrl || $[1] !== helpCenterAri) {
        t4 = ()=>(0, $iDrrr.fg)("hubs_fix_rerendering_bootstrap_page_media") ? $313e1630e2530993$var$requestCountCache.get($313e1630e2530993$var$getCacheKey(cloudUrl, helpCenterAri)) ?? null : null;
        $[0] = cloudUrl;
        $[1] = helpCenterAri;
        $[2] = t4;
    } else t4 = $[2];
    const [requestCount, setRequestCount] = (0, $cozmU.useState)(t4);
    let t5;
    let t6;
    if ($[3] !== cloudUrl || $[4] !== helpCenterAri) {
        t5 = ()=>{
            if ((0, $iDrrr.fg)("hubs_fix_rerendering_bootstrap_page_media")) {
                const cacheKey = $313e1630e2530993$var$getCacheKey(cloudUrl, helpCenterAri);
                const cached = $313e1630e2530993$var$requestCountCache.get(cacheKey);
                (0, $iK7lw.getRequestCount)(cloudUrl, helpCenterAri).then((data)=>{
                    const next = {
                        approvals: data.userRequestsCounts.approvalsCount,
                        pendingApprovals: data.userRequestsCounts.pendingApprovalsCount,
                        request: data.userRequestsCounts.allOpenRequestsCount + data.userRequestsCounts.pendingApprovalsCount
                    };
                    $313e1630e2530993$var$requestCountCache.set(cacheKey, next);
                    setRequestCount(next);
                }).catch(()=>{
                    if (cached) return;
                    const fallback = {
                        approvals: 0,
                        pendingApprovals: 0,
                        request: 0
                    };
                    $313e1630e2530993$var$requestCountCache.set(cacheKey, fallback);
                    setRequestCount(fallback);
                });
            } else (0, $iK7lw.getRequestCount)(cloudUrl, helpCenterAri).then((data_0)=>{
                setRequestCount({
                    approvals: data_0.userRequestsCounts.approvalsCount,
                    pendingApprovals: data_0.userRequestsCounts.pendingApprovalsCount,
                    request: data_0.userRequestsCounts.allOpenRequestsCount + data_0.userRequestsCounts.pendingApprovalsCount
                });
            }).catch(()=>{
                setRequestCount({
                    approvals: 0,
                    pendingApprovals: 0,
                    request: 0
                });
            });
        };
        t6 = [
            cloudUrl,
            helpCenterAri
        ];
        $[3] = cloudUrl;
        $[4] = helpCenterAri;
        $[5] = t5;
        $[6] = t6;
    } else {
        t5 = $[5];
        t6 = $[6];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "nav-links-loader"
        });
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== backgroundColor || $[9] !== requestCount || $[10] !== textColor) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: t7
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($313e1630e2530993$var$NavLinkItems, {
            textColor: textColor,
            backgroundColor: backgroundColor,
            requestCount: requestCount
        }));
        $[8] = backgroundColor;
        $[9] = requestCount;
        $[10] = textColor;
        $[11] = t8;
    } else t8 = $[11];
    return t8;
} : ({ backgroundColor: backgroundColor = "var(--ds-background-neutral-bold, #292A2E)", textColor: textColor = "var(--ds-text-inverse, #FFFFFF)" })=>{
    const { cloudUrl: cloudUrl, env: { helpCenterAri: helpCenterAri } } = (0, $r8hvx.useHubContext)();
    const [requestCount, setRequestCount] = (0, $cozmU.useState)(()=>(0, $iDrrr.fg)('hubs_fix_rerendering_bootstrap_page_media') ? $313e1630e2530993$var$requestCountCache.get($313e1630e2530993$var$getCacheKey(cloudUrl, helpCenterAri)) ?? null : null);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $iDrrr.fg)('hubs_fix_rerendering_bootstrap_page_media')) {
            const cacheKey = $313e1630e2530993$var$getCacheKey(cloudUrl, helpCenterAri);
            const cached = $313e1630e2530993$var$requestCountCache.get(cacheKey);
            (0, $iK7lw.getRequestCount)(cloudUrl, helpCenterAri).then((data)=>{
                // Always refresh both the request and approvals counts from the
                // latest API response. The Approvals tab is rendered only when
                // `approvals > 0`, so updating to a fresh value of 0 will
                // correctly remove the tab when there is nothing to show.
                const next = {
                    approvals: data.userRequestsCounts.approvalsCount,
                    pendingApprovals: data.userRequestsCounts.pendingApprovalsCount,
                    request: data.userRequestsCounts.allOpenRequestsCount + data.userRequestsCounts.pendingApprovalsCount
                };
                $313e1630e2530993$var$requestCountCache.set(cacheKey, next);
                setRequestCount(next);
            }).catch(()=>{
                if (cached) // Keep showing the cached values on refresh failure.
                return;
                 // fallback count to zero if request count API fails on first load
                const fallback = {
                    approvals: 0,
                    pendingApprovals: 0,
                    request: 0
                };
                $313e1630e2530993$var$requestCountCache.set(cacheKey, fallback);
                setRequestCount(fallback);
            });
        } else (0, $iK7lw.getRequestCount)(cloudUrl, helpCenterAri).then((data_0)=>{
            setRequestCount({
                approvals: data_0.userRequestsCounts.approvalsCount,
                pendingApprovals: data_0.userRequestsCounts.pendingApprovalsCount,
                request: data_0.userRequestsCounts.allOpenRequestsCount + data_0.userRequestsCounts.pendingApprovalsCount
            });
        }).catch(()=>{
            // fallback count to zero if request count API fails
            setRequestCount({
                approvals: 0,
                pendingApprovals: 0,
                request: 0
            });
        });
    }, [
        cloudUrl,
        helpCenterAri
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "nav-links-loader"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($313e1630e2530993$var$NavLinkItems, {
        textColor: textColor,
        backgroundColor: backgroundColor,
        requestCount: requestCount
    }));
};
module.exports["NavLinks"] = $313e1630e2530993$export$b615cd9717379c80;

});

parcelRegister("caqWd", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $a56148aa6f0ab9b5$export$ea207007e4cd246c = /*#__PURE__*/ (0, $cozmU.createContext)({
    isShimmering: true,
    size: 'medium'
});
module.exports["BreadcrumbsSkeletonContext"] = $a56148aa6f0ab9b5$export$ea207007e4cd246c;

});

parcelRegister("7IEOV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $caqWd = parcelRequire("caqWd");

const $36b36ea00209802f$export$15d0b942535a287 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useBreadcrumbsSkeleton() {
    return (0, $cozmU.useContext)((0, $caqWd.BreadcrumbsSkeletonContext));
} : function useBreadcrumbsSkeleton() {
    return (0, $cozmU.useContext)((0, $caqWd.BreadcrumbsSkeletonContext));
};
module.exports["useBreadcrumbsSkeleton"] = $36b36ea00209802f$export$15d0b942535a287;

});

parcelRegister("kE9MM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $arQY7 = parcelRequire("arQY7");


var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $r8hvx = parcelRequire("r8hvx");

const $c0432c8533e4daa6$var$styles = {
    displayName: "_2sNsIgmnOE",
    root: "_0Of8r22ADO _1wydGW2ADO _2Zuz6Q5zaO _1Znuxb5zaO",
    emailText: "_4bt5LAnQyn _2WAcuGnQyn _1ANEUSLRg7 _39HuIbz8Lp _39xV02N91d _3iDTPbvbI6 _1EqgXloaux"
};
const $c0432c8533e4daa6$export$66e04d0aacdb3b2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(15);
    const { user: user } = (0, $r8hvx.useHubContext)();
    const { avatarSrc: avatarSrc, displayName: displayName, email: email } = user;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            $c0432c8533e4daa6$var$styles.root
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== avatarSrc) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            alignItems: "center",
            justifyContent: "center",
            gap: "space.100"
        }, /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
            appearance: "circle",
            size: "medium",
            src: avatarSrc
        }));
        $[1] = avatarSrc;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $c0432c8533e4daa6$var$styles.displayName
        ]);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== displayName) {
        t3 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t2
        }, displayName);
        $[4] = displayName;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            $c0432c8533e4daa6$var$styles.emailText
        ]);
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== email) {
        t5 = /*#__PURE__*/ $cozmU.createElement("small", {
            className: t4
        }, email);
        $[7] = email;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== t3 || $[10] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, t3, t5);
        $[9] = t3;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== t1 || $[13] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t0
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.100"
        }, t1, t6));
        $[12] = t1;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    return t7;
} : ()=>{
    const { user: user } = (0, $r8hvx.useHubContext)();
    const { avatarSrc: avatarSrc, displayName: displayName, email: email } = user;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $c0432c8533e4daa6$var$styles.root
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        justifyContent: "center",
        gap: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
        appearance: "circle",
        size: "medium",
        src: avatarSrc
    })), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $c0432c8533e4daa6$var$styles.displayName
        ])
    }, displayName), /*#__PURE__*/ $cozmU.createElement("small", {
        className: (0, $hekY6.default)([
            $c0432c8533e4daa6$var$styles.emailText
        ])
    }, email))));
};
module.exports["AccountDetails"] = $c0432c8533e4daa6$export$66e04d0aacdb3b2;

});

parcelRegister("dk27U", function(module, exports) {
/**
 * @generated SignedSource<<bb9e2d5b252c543aa90ead2a8d446276>>
 * @relayHash 6feddd3cd0ebd8c6c0af996a95e0351e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0d55a64482985de626434869bb8931fe079c5b408aae97a6df2713c9281c2589
const $02e557899f4f35e0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hubAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConfigurableSiteTreeEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTopicsEnabled"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v6 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "hubAri"
        },
        {
            "kind": "Variable",
            "name": "isDraft",
            "variableName": "isDraft"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = [
        {
            "kind": "ScalarField",
            "name": "default"
        }
    ], v10 = [
        v8 /*: any*/ ,
        {
            "concreteType": "HelpCenterPageName",
            "kind": "LinkedField",
            "name": "name",
            "plural": false,
            "selections": v9 /*: any*/ 
        }
    ], v11 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "HelpCenterPage"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            v8 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "navLinksQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "portalDropdown_AtlassianHubAppShell"
                                        },
                                        {
                                            "condition": "isTopicsEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "topicDropdown_AtlassianHubAppShell"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isConfigurableSiteTreeEnabled",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "moreDropdown_AtlassianHubAppShell"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isConfigurableSiteTreeEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "siteNavigation_AtlassianHubAppShell"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "navLinksQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterPortals",
                                            "kind": "LinkedField",
                                            "name": "portals",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterPortal",
                                                    "kind": "LinkedField",
                                                    "name": "portalsList",
                                                    "plural": true,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isTopicsEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "alias": "topicPages",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": {
                                                                "ids": [],
                                                                "type": "TOPIC"
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "HelpCenterPage",
                                                    "kind": "LinkedField",
                                                    "name": "pages",
                                                    "plural": true,
                                                    "selections": v10 /*: any*/ ,
                                                    "storageKey": "pages(filter:{\"ids\":[],\"type\":\"TOPIC\"})"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isConfigurableSiteTreeEnabled",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "alias": "customPages",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": {
                                                                "ids": [],
                                                                "type": "CUSTOM"
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "HelpCenterPage",
                                                    "kind": "LinkedField",
                                                    "name": "pages",
                                                    "plural": true,
                                                    "selections": v10 /*: any*/ ,
                                                    "storageKey": "pages(filter:{\"ids\":[],\"type\":\"CUSTOM\"})"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isConfigurableSiteTreeEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterSiteTree",
                                                    "kind": "LinkedField",
                                                    "name": "siteTree",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterFolder",
                                                            "kind": "LinkedField",
                                                            "name": "root",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpCenterSiteTreeNodeConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "contents",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "nodes",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v8 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpCenterFolderName",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "name",
                                                                                            "plural": false,
                                                                                            "selections": v9 /*: any*/ 
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpCenterSiteTreeNodeConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "contents",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "nodes",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v7 /*: any*/ ,
                                                                                                        v11 /*: any*/ ,
                                                                                                        v12 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "HelpCenterFolder"
                                                                                },
                                                                                v12 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v8 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0d55a64482985de626434869bb8931fe079c5b408aae97a6df2713c9281c2589",
            "metadata": {},
            "name": "navLinksQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$02e557899f4f35e0$var$node.hash = "8632fa4c2480ce4d0cf74a6703739408";
var $02e557899f4f35e0$export$2e2bcd8739ae039 = $02e557899f4f35e0$var$node;
module.exports["default"] = $02e557899f4f35e0$export$2e2bcd8739ae039;

});

parcelRegister("fk4YO", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $38732bf3e7790039$var$messages = (0, $kSwu1.defineMessages)({
    downIcon: {
        id: "company-hub.hub-app-shell.navbar.nav-links.down-icon",
        defaultMessage: "Open dropdown"
    },
    home: {
        id: "company-hub.hub-app-shell.navbar.nav-links.home",
        defaultMessage: "Home"
    },
    more: {
        id: "company-hub.hub-app-shell.navbar.nav-links.more",
        defaultMessage: "More"
    },
    openFolderSubmenu: {
        id: "company-hub.hub-app-shell.navbar.nav-links.openFolderSubmenu",
        defaultMessage: "Open folder"
    },
    portals: {
        id: "company-hub.hub-app-shell.navbar.nav-links.portals",
        defaultMessage: "Portals"
    },
    requests: {
        id: "company-hub.hub-app-shell.navbar.nav-links.requests",
        defaultMessage: "Requests"
    },
    approvals: {
        id: "company-hub.hub-app-shell.navbar.nav-links.approvals",
        defaultMessage: "Approvals"
    }
});
var $38732bf3e7790039$export$2e2bcd8739ae039 = $38732bf3e7790039$var$messages;
module.exports["default"] = $38732bf3e7790039$export$2e2bcd8739ae039;

});

parcelRegister("jDOHN", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $j5TDY = parcelRequire("j5TDY");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");

parcelRequire("fMvIa");
var $idnP4 = parcelRequire("idnP4");


var $w6R6I = parcelRequire("w6R6I");


var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");


var $geKL9 = parcelRequire("geKL9");


var $fk4YO = parcelRequire("fk4YO");


var $eOe1k = parcelRequire("eOe1k");

const $b95d7135bf311635$var$EMPTY_SITE_NAVIGATION_ITEMS = [];
const $b95d7135bf311635$var$styles = {
    centerSlot: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIdnbC _1mT5xdRAKS",
    navItemLabel: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _1EqgXlgZxp _39HuIbz8Lp _1ANEUSLRg7",
    trigger: "_0bjKvDKTcp _2sNsIgmnOE _4c065UPgdg _2Y7lL48HPE _3iDTPbccYA _24h04i2Njc _0hPCNLDIqT _17lj8p1Y8M _0jFU0VZ49V _0KLXru66of _1kk5Tkf7mX _1eOmH6o126 _3gzVzLN4oS",
    triggerSelected: "_0KLXruY9q9 _1UtDYzjTy9 _1eOmH6sumd _3gzVzLXsxn",
    measurementViewport: "_1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _39xV02N91d _4bt5LAnQyn _0fKRyPnQyn _1pp6NdYbGa",
    measurementRow: "_2mHwu81Y8M _3iDTPbQ4SZ _39xV02W9qI"
};
const $b95d7135bf311635$var$NavItemLabel = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $b95d7135bf311635$var$styles.navItemLabel
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $b95d7135bf311635$var$styles.navItemLabel
    }, children);
const $b95d7135bf311635$var$NavTrigger = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? function NavTrigger(t0, ref) {
    const $ = (0, $bDgLe.c)(25);
    let children;
    let props;
    let t1;
    let t2;
    let t3;
    let t4;
    let textColor;
    if ($[0] !== t0) {
        ({ children: children, iconLabel: t1, isSelected: t2, showIcon: t3, textColor: textColor, truncate: t4, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
        $[7] = textColor;
    } else {
        children = $[1];
        props = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
        textColor = $[7];
    }
    const iconLabel = t1 === undefined ? "" : t1;
    const isSelected = t2 === undefined ? false : t2;
    const showIcon = t3 === undefined ? true : t3;
    const truncate = t4 === undefined ? false : t4;
    const t5 = isSelected ? undefined : textColor;
    let t6;
    if ($[8] !== t5) {
        t6 = {
            color: t5
        };
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    const t7 = isSelected && $b95d7135bf311635$var$styles.triggerSelected;
    let t8;
    if ($[10] !== t7) {
        t8 = (0, $w6R6I.cx)($b95d7135bf311635$var$styles.trigger, t7);
        $[10] = t7;
        $[11] = t8;
    } else t8 = $[11];
    let t9;
    if ($[12] !== children || $[13] !== truncate) {
        t9 = truncate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavItemLabel, null, children) : children;
        $[12] = children;
        $[13] = truncate;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== iconLabel || $[16] !== showIcon) {
        t10 = showIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            color: "currentColor",
            label: iconLabel
        });
        $[15] = iconLabel;
        $[16] = showIcon;
        $[17] = t10;
    } else t10 = $[17];
    let t11;
    if ($[18] !== props || $[19] !== ref || $[20] !== t10 || $[21] !== t6 || $[22] !== t8 || $[23] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            ...props,
            ref: ref,
            style: t6,
            xcss: t8
        }, t9, t10);
        $[18] = props;
        $[19] = ref;
        $[20] = t10;
        $[21] = t6;
        $[22] = t8;
        $[23] = t9;
        $[24] = t11;
    } else t11 = $[24];
    return t11;
} : function NavTrigger({ children: children, iconLabel: iconLabel = '', isSelected: isSelected = false, showIcon: showIcon = true, textColor: textColor, truncate: truncate = false, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        ...props,
        ref: ref,
        style: {
            color: isSelected ? undefined : textColor
        },
        xcss: (0, $w6R6I.cx)($b95d7135bf311635$var$styles.trigger, isSelected && $b95d7135bf311635$var$styles.triggerSelected)
    }, truncate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavItemLabel, null, children) : children, showIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        color: "currentColor",
        label: iconLabel
    }));
});
const $b95d7135bf311635$var$getFolderPages = (folder)=>folder.contents.nodes.filter((node)=>node.__typename === 'HelpCenterPage');
const $b95d7135bf311635$var$getPageId = (page)=>{
    try {
        return (0, $geKL9.HelpPageAri).parse(page.id).pageId;
    } catch  {
        return null;
    }
};
const $b95d7135bf311635$var$PageItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { page: page } = t0;
    const { push: push } = (0, $idnP4.useRouterActions)();
    let t1;
    if ($[0] !== page) {
        t1 = $b95d7135bf311635$var$getPageId(page);
        $[0] = page;
        $[1] = t1;
    } else t1 = $[1];
    const pageId = t1;
    if (!pageId) return null;
    let t2;
    if ($[2] !== pageId || $[3] !== push) {
        t2 = ()=>push(`/page/${pageId}`);
        $[2] = pageId;
        $[3] = push;
        $[4] = t2;
    } else t2 = $[4];
    const t3 = page.name?.default ?? "";
    let t4;
    if ($[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavItemLabel, null, t3);
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== t2 || $[8] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            onClick: t2
        }, t4);
        $[7] = t2;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : ({ page: page })=>{
    const { push: push } = (0, $idnP4.useRouterActions)();
    const pageId = $b95d7135bf311635$var$getPageId(page);
    if (!pageId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        onClick: ()=>push(`/page/${pageId}`)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavItemLabel, null, page.name?.default ?? ''));
};
const $b95d7135bf311635$var$FolderMenuItems = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { pages: pages } = t0;
    let t1;
    if ($[0] !== pages) {
        t1 = pages.map($b95d7135bf311635$var$_temp);
        $[0] = pages;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, t1);
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ pages: pages })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, pages.map((page)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$PageItem, {
            key: page.id,
            page: page
        })));
const $b95d7135bf311635$var$PromotedFolderMenu = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { folder: folder, textColor: textColor } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== folder.name?.default || $[1] !== formatMessage || $[2] !== textColor) {
        t1 = (t2)=>{
            const { triggerRef: triggerRef, ...props } = t2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavTrigger, {
                ...props,
                iconLabel: formatMessage((0, $fk4YO.default).downIcon),
                ref: triggerRef,
                textColor: textColor,
                truncate: true
            }, folder.name?.default ?? "");
        };
        $[0] = folder.name?.default;
        $[1] = formatMessage;
        $[2] = textColor;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== folder) {
        t2 = $b95d7135bf311635$var$getFolderPages(folder);
        $[4] = folder;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$FolderMenuItems, {
            pages: t2
        });
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t1 || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            placement: "bottom-start",
            shouldRenderToParent: true,
            trigger: t1
        }, t3);
        $[8] = t1;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ({ folder: folder, textColor: textColor })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        placement: "bottom-start",
        shouldRenderToParent: true,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavTrigger, {
                ...props,
                iconLabel: formatMessage((0, $fk4YO.default).downIcon),
                ref: triggerRef,
                textColor: textColor,
                truncate: true
            }, folder.name?.default ?? '')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$FolderMenuItems, {
        pages: $b95d7135bf311635$var$getFolderPages(folder)
    }));
};
const $b95d7135bf311635$var$PromotedPage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { page: page, textColor: textColor } = t0;
    const { push: push } = (0, $idnP4.useRouterActions)();
    let t1;
    if ($[0] !== page) {
        t1 = $b95d7135bf311635$var$getPageId(page);
        $[0] = page;
        $[1] = t1;
    } else t1 = $[1];
    const pageId = t1;
    if (!pageId) return null;
    let t2;
    if ($[2] !== pageId || $[3] !== push) {
        t2 = ()=>push(`/page/${pageId}`);
        $[2] = pageId;
        $[3] = push;
        $[4] = t2;
    } else t2 = $[4];
    const t3 = page.name?.default ?? "";
    let t4;
    if ($[5] !== t2 || $[6] !== t3 || $[7] !== textColor) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavTrigger, {
            onClick: t2,
            showIcon: false,
            textColor: textColor,
            truncate: true
        }, t3);
        $[5] = t2;
        $[6] = t3;
        $[7] = textColor;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : ({ page: page, textColor: textColor })=>{
    const { push: push } = (0, $idnP4.useRouterActions)();
    const pageId = $b95d7135bf311635$var$getPageId(page);
    if (!pageId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavTrigger, {
        onClick: ()=>push(`/page/${pageId}`),
        showIcon: false,
        textColor: textColor,
        truncate: true
    }, page.name?.default ?? '');
};
const $b95d7135bf311635$var$OverflowFolderMenu = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { folder: folder } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== folder.name?.default || $[1] !== formatMessage) {
        t1 = (t2)=>{
            const { triggerRef: triggerRef, ...props } = t2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                ...props,
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    label: formatMessage((0, $fk4YO.default).openFolderSubmenu),
                    size: "small"
                }),
                ref: triggerRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavItemLabel, null, folder.name?.default ?? ""));
        };
        $[0] = folder.name?.default;
        $[1] = formatMessage;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== folder) {
        t2 = $b95d7135bf311635$var$getFolderPages(folder);
        $[3] = folder;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$FolderMenuItems, {
            pages: t2
        });
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t1 || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            placement: "right-start",
            shouldFlip: true,
            shouldRenderToParent: true,
            trigger: t1
        }, t3);
        $[7] = t1;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ folder: folder })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        placement: "right-start",
        shouldFlip: true,
        shouldRenderToParent: true,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                ...props,
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    label: formatMessage((0, $fk4YO.default).openFolderSubmenu),
                    size: "small"
                }),
                ref: triggerRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavItemLabel, null, folder.name?.default ?? ''))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$FolderMenuItems, {
        pages: $b95d7135bf311635$var$getFolderPages(folder)
    }));
};
const $b95d7135bf311635$var$OverflowItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { item: item } = t0;
    let t1;
    if ($[0] !== item) {
        t1 = item.__typename === "HelpCenterPage" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$PageItem, {
            page: item
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$OverflowFolderMenu, {
            folder: item
        });
        $[0] = item;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ item: item })=>item.__typename === 'HelpCenterPage' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$PageItem, {
        page: item
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$OverflowFolderMenu, {
        folder: item
    });
const $b95d7135bf311635$export$c14b2ae736940562 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { overflowItems: overflowItems, promotedItems: promotedItems, textColor: textColor } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (promotedItems.length === 0 && overflowItems.length === 0) return null;
    let t1;
    if ($[0] !== promotedItems || $[1] !== textColor) {
        let t2;
        if ($[3] !== textColor) {
            t2 = (item)=>item.__typename === "HelpCenterFolder" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$PromotedFolderMenu, {
                    key: item.id,
                    folder: item,
                    textColor: textColor
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$PromotedPage, {
                    key: item.id,
                    page: item,
                    textColor: textColor
                });
            $[3] = textColor;
            $[4] = t2;
        } else t2 = $[4];
        t1 = promotedItems.map(t2);
        $[0] = promotedItems;
        $[1] = textColor;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[5] !== formatMessage || $[6] !== overflowItems || $[7] !== textColor) {
        t2 = overflowItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            shouldRenderToParent: true,
            trigger: (t3)=>{
                const { triggerRef: triggerRef, ...props } = t3;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavTrigger, {
                    ...props,
                    iconLabel: formatMessage((0, $fk4YO.default).downIcon),
                    ref: triggerRef,
                    testId: "site-navigation-more",
                    textColor: textColor
                }, formatMessage((0, $fk4YO.default).more));
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, overflowItems.map($b95d7135bf311635$var$_temp2)));
        $[5] = formatMessage;
        $[6] = overflowItems;
        $[7] = textColor;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== t1 || $[10] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1, t2);
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : ({ overflowItems: overflowItems, promotedItems: promotedItems, textColor: textColor })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (promotedItems.length === 0 && overflowItems.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, promotedItems.map((item)=>item.__typename === 'HelpCenterFolder' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$PromotedFolderMenu, {
            key: item.id,
            folder: item,
            textColor: textColor
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$PromotedPage, {
            key: item.id,
            page: item,
            textColor: textColor
        })), overflowItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        shouldRenderToParent: true,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavTrigger, {
                ...props,
                iconLabel: formatMessage((0, $fk4YO.default).downIcon),
                ref: triggerRef,
                testId: "site-navigation-more",
                textColor: textColor
            }, formatMessage((0, $fk4YO.default).more))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, overflowItems.map((item_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$OverflowItem, {
            key: item_0.id,
            item: item_0
        })))));
};
const $b95d7135bf311635$export$42c2afabaf9bb88e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { queryRef: queryRef, textColor: textColor } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const slotRef = (0, $cozmU.useRef)(null);
    const measurementRowRef = (0, $cozmU.useRef)(null);
    const data = (0, $6SsN4.useFragment)((0, $j5TDY.default), queryRef);
    const nodes = data?.siteTree?.root?.contents.nodes;
    let t1;
    if ($[0] !== nodes) {
        t1 = nodes?.filter($b95d7135bf311635$var$_temp3) ?? $b95d7135bf311635$var$EMPTY_SITE_NAVIGATION_ITEMS;
        $[0] = nodes;
        $[1] = t1;
    } else t1 = $[1];
    const items = t1;
    let t2;
    if ($[2] !== items) {
        t2 = {
            items: items,
            measurementRowRef: measurementRowRef,
            slotRef: slotRef
        };
        $[2] = items;
        $[3] = t2;
    } else t2 = $[3];
    const { overflowItems: overflowItems, promotedItems: promotedItems } = (0, $eOe1k.useSiteNavigationOverflow)(t2);
    let t3;
    if ($[4] !== overflowItems || $[5] !== promotedItems || $[6] !== textColor) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$export$c14b2ae736940562, {
            overflowItems: overflowItems,
            promotedItems: promotedItems,
            textColor: textColor
        });
        $[4] = overflowItems;
        $[5] = promotedItems;
        $[6] = textColor;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== items || $[9] !== textColor) {
        let t5;
        if ($[11] !== textColor) {
            t5 = (item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    "data-site-navigation-item-id": item.id,
                    key: item.id
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavTrigger, {
                    iconLabel: "",
                    tabIndex: -1,
                    textColor: textColor,
                    truncate: true
                }, item.name?.default));
            $[11] = textColor;
            $[12] = t5;
        } else t5 = $[12];
        t4 = items.map(t5);
        $[8] = items;
        $[9] = textColor;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[13] !== formatMessage) {
        t5 = formatMessage((0, $fk4YO.default).more);
        $[13] = formatMessage;
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== t5 || $[16] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            "data-site-navigation-more-item": true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavTrigger, {
            iconLabel: "",
            tabIndex: -1,
            textColor: textColor
        }, t5));
        $[15] = t5;
        $[16] = textColor;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== t4 || $[19] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            "aria-hidden": "true",
            testId: "site-navigation-measurement-viewport",
            xcss: $b95d7135bf311635$var$styles.measurementViewport
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            "aria-hidden": "true",
            ref: measurementRowRef,
            testId: "site-navigation-measurement-row",
            xcss: $b95d7135bf311635$var$styles.measurementRow
        }, t4, t6));
        $[18] = t4;
        $[19] = t6;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== t3 || $[22] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: slotRef,
            testId: "nav-links-center-slot",
            xcss: $b95d7135bf311635$var$styles.centerSlot
        }, t3, t7);
        $[21] = t3;
        $[22] = t7;
        $[23] = t8;
    } else t8 = $[23];
    return t8;
} : ({ queryRef: queryRef, textColor: textColor })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const slotRef = (0, $cozmU.useRef)(null);
    const measurementRowRef = (0, $cozmU.useRef)(null);
    const data = (0, $6SsN4.useFragment)((0, $j5TDY.default), queryRef);
    const nodes = data?.siteTree?.root?.contents.nodes;
    const items = (0, $cozmU.useMemo)(()=>nodes?.filter((node)=>node.__typename === 'HelpCenterPage' || node.__typename === 'HelpCenterFolder') ?? $b95d7135bf311635$var$EMPTY_SITE_NAVIGATION_ITEMS, [
        nodes
    ]);
    const { overflowItems: overflowItems, promotedItems: promotedItems } = (0, $eOe1k.useSiteNavigationOverflow)({
        items: items,
        measurementRowRef: measurementRowRef,
        slotRef: slotRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: slotRef,
        testId: "nav-links-center-slot",
        xcss: $b95d7135bf311635$var$styles.centerSlot
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$export$c14b2ae736940562, {
        overflowItems: overflowItems,
        promotedItems: promotedItems,
        textColor: textColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        "aria-hidden": "true",
        testId: "site-navigation-measurement-viewport",
        xcss: $b95d7135bf311635$var$styles.measurementViewport
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        "aria-hidden": "true",
        ref: measurementRowRef,
        testId: "site-navigation-measurement-row",
        xcss: $b95d7135bf311635$var$styles.measurementRow
    }, items.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            "data-site-navigation-item-id": item.id,
            key: item.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavTrigger, {
            iconLabel: "",
            tabIndex: -1,
            textColor: textColor,
            truncate: true
        }, item.name?.default))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        "data-site-navigation-more-item": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavTrigger, {
        iconLabel: "",
        tabIndex: -1,
        textColor: textColor
    }, formatMessage((0, $fk4YO.default).more))))));
};
function $b95d7135bf311635$var$_temp(page) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$PageItem, {
        key: page.id,
        page: page
    });
}
function $b95d7135bf311635$var$_temp2(item_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$OverflowItem, {
        key: item_0.id,
        item: item_0
    });
}
function $b95d7135bf311635$var$_temp3(node) {
    return node.__typename === "HelpCenterPage" || node.__typename === "HelpCenterFolder";
}
module.exports["SiteNavigation"] = $b95d7135bf311635$export$42c2afabaf9bb88e;

});

parcelRegister("j5TDY", function(module, exports) {
/**
 * @generated SignedSource<<7a74aadd35812656d4f189fff568b4c0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d51e409169beb237$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "kind": "ScalarField",
            "name": "default"
        }
    ], v3 = {
        "kind": "InlineFragment",
        "selections": [
            v1 /*: any*/ ,
            {
                "concreteType": "HelpCenterPageName",
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": v2 /*: any*/ 
            }
        ],
        "type": "HelpCenterPage"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "siteNavigation_AtlassianHubAppShell",
        "selections": [
            {
                "concreteType": "HelpCenterSiteTree",
                "kind": "LinkedField",
                "name": "siteTree",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "HelpCenterFolder",
                        "kind": "LinkedField",
                        "name": "root",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "HelpCenterSiteTreeNodeConnection",
                                "kind": "LinkedField",
                                "name": "contents",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            v3 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v1 /*: any*/ ,
                                                    {
                                                        "concreteType": "HelpCenterFolderName",
                                                        "kind": "LinkedField",
                                                        "name": "name",
                                                        "plural": false,
                                                        "selections": v2 /*: any*/ 
                                                    },
                                                    {
                                                        "concreteType": "HelpCenterSiteTreeNodeConnection",
                                                        "kind": "LinkedField",
                                                        "name": "contents",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "nodes",
                                                                "plural": true,
                                                                "selections": [
                                                                    v0 /*: any*/ ,
                                                                    v3 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "HelpCenterFolder"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    };
}();
$d51e409169beb237$var$node.hash = "758f2701bd08a1f04afa67c01cd4f843";
var $d51e409169beb237$export$2e2bcd8739ae039 = $d51e409169beb237$var$node;
module.exports["default"] = $d51e409169beb237$export$2e2bcd8739ae039;

});

parcelRegister("eOe1k", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $e9dqk = parcelRequire("e9dqk");

const $6c553aeebda47205$var$getLeftoverWidth = (row, slot)=>{
    const rowWidth = row.getBoundingClientRect().width;
    const gapWidth = Number.parseFloat(window.getComputedStyle(row).columnGap) || Number.parseFloat(window.getComputedStyle(row).gap) || 0;
    const children = Array.from(row.children);
    const siblingWidth = children.filter((child)=>child !== slot).reduce((total, child)=>total + child.getBoundingClientRect().width, 0);
    const gapCount = Math.max(children.length - 1, 0);
    return rowWidth - siblingWidth - gapCount * gapWidth;
};
const $6c553aeebda47205$export$afacae323adcfe97 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { items: items, measurementRowRef: measurementRowRef, slotRef: slotRef } = t0;
    let t1;
    if ($[0] !== items) {
        t1 = ()=>({
                promotedItems: [],
                overflowItems: [
                    ...items
                ]
            });
        $[0] = items;
        $[1] = t1;
    } else t1 = $[1];
    const [split, setSplit] = (0, $cozmU.useState)(t1);
    let t2;
    let t3;
    if ($[2] !== items || $[3] !== measurementRowRef || $[4] !== slotRef) {
        t2 = ()=>{
            const slot = slotRef.current;
            const measurementRow = measurementRowRef.current;
            const row = slot?.parentElement;
            if (!slot || !measurementRow || !row) return;
            let animationFrame = null;
            let hasUsableMeasurement = false;
            const measure = ()=>{
                const itemWidths = Object.fromEntries(Array.from(measurementRow.querySelectorAll("[data-site-navigation-item-id]"), $6c553aeebda47205$var$_temp));
                const moreItem = measurementRow.querySelector("[data-site-navigation-more-item]");
                const gapWidth = Number.parseFloat(window.getComputedStyle(measurementRow).columnGap) || 0;
                const availableWidth = $6c553aeebda47205$var$getLeftoverWidth(row, slot);
                if (availableWidth <= 0) return;
                hasUsableMeasurement = true;
                const next = (0, $e9dqk.splitSiteNavigation)(items, {
                    availableWidth: availableWidth,
                    itemWidths: itemWidths,
                    gapWidth: gapWidth,
                    moreWidth: moreItem?.getBoundingClientRect().width ?? 0
                });
                setSplit((previous)=>(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(previous, next) ? previous : next);
            };
            const scheduleMeasurement = ()=>{
                if (!hasUsableMeasurement) {
                    measure();
                    return;
                }
                if (animationFrame === null) animationFrame = requestAnimationFrame(()=>{
                    animationFrame = null;
                    measure();
                });
            };
            measure();
            const observer = new ResizeObserver(scheduleMeasurement);
            observer.observe(row);
            observer.observe(measurementRow);
            return ()=>{
                if (animationFrame !== null) cancelAnimationFrame(animationFrame);
                observer.disconnect();
            };
        };
        t3 = [
            items,
            measurementRowRef,
            slotRef
        ];
        $[2] = items;
        $[3] = measurementRowRef;
        $[4] = slotRef;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useLayoutEffect)(t2, t3);
    return split;
} : ({ items: items, measurementRowRef: measurementRowRef, slotRef: slotRef })=>{
    const [split, setSplit] = (0, $cozmU.useState)(()=>({
            promotedItems: [],
            overflowItems: [
                ...items
            ]
        }));
    (0, $cozmU.useLayoutEffect)(()=>{
        const slot = slotRef.current;
        const measurementRow = measurementRowRef.current;
        const row = slot?.parentElement;
        if (!slot || !measurementRow || !row) return;
        let animationFrame = null;
        let hasUsableMeasurement = false;
        const measure = ()=>{
            const itemWidths = Object.fromEntries(Array.from(measurementRow.querySelectorAll('[data-site-navigation-item-id]'), (element)=>[
                    element.getAttribute('data-site-navigation-item-id') ?? '',
                    element.getBoundingClientRect().width
                ]));
            const moreItem = measurementRow.querySelector('[data-site-navigation-more-item]');
            const gapWidth = Number.parseFloat(window.getComputedStyle(measurementRow).columnGap) || 0;
            // Centering hugs the slot, so leftover width is the row minus Home /
            // Portals / Requests (and their gaps), not the slot's own box.
            const availableWidth = $6c553aeebda47205$var$getLeftoverWidth(row, slot);
            // The navbar row is `display: none` until its responsive breakpoint
            // resolves, so wait until leftover width is usable.
            if (availableWidth <= 0) return;
            hasUsableMeasurement = true;
            const next = (0, $e9dqk.splitSiteNavigation)(items, {
                availableWidth: availableWidth,
                itemWidths: itemWidths,
                gapWidth: gapWidth,
                moreWidth: moreItem?.getBoundingClientRect().width ?? 0
            });
            // Deep-compare so renames (same ids, new names) still update the nav.
            setSplit((previous)=>(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(previous, next) ? previous : next);
        };
        // Coalesce resize callbacks after the first usable synchronous measure.
        const scheduleMeasurement = ()=>{
            if (!hasUsableMeasurement) {
                measure();
                return;
            }
            if (animationFrame === null) animationFrame = requestAnimationFrame(()=>{
                animationFrame = null;
                measure();
            });
        };
        // Measure before the browser paints so the first frame already shows the
        // correct split, rather than briefly rendering everything under More.
        measure();
        const observer = new ResizeObserver(scheduleMeasurement);
        observer.observe(row);
        observer.observe(measurementRow);
        return ()=>{
            if (animationFrame !== null) cancelAnimationFrame(animationFrame);
            observer.disconnect();
        };
    }, [
        items,
        measurementRowRef,
        slotRef
    ]);
    return split;
};
function $6c553aeebda47205$var$_temp(element) {
    return [
        element.getAttribute("data-site-navigation-item-id") ?? "",
        element.getBoundingClientRect().width
    ];
}
module.exports["useSiteNavigationOverflow"] = $6c553aeebda47205$export$afacae323adcfe97;

});

parcelRegister("e9dqk", function(module, exports) {
// Allow 1px of sub-pixel rounding so the split does not flap.
const $641217715532bb5f$var$COMPARISON_TOLERANCE = 1;
const $641217715532bb5f$var$getRowWidth = ({ itemWidths: itemWidths, items: items, gapWidth: gapWidth, moreWidth: moreWidth, showMore: showMore })=>{
    const visibleItemCount = items.length + (showMore ? 1 : 0);
    const visibleGapCount = Math.max(visibleItemCount - 1, 0);
    // An unmeasured item is unfittable, so it stays in More.
    const promotedItemWidth = items.reduce((total, { id: id })=>total + (itemWidths[id] ?? Number.MAX_SAFE_INTEGER), 0);
    return promotedItemWidth + (showMore ? moreWidth : 0) + visibleGapCount * gapWidth;
};
const $641217715532bb5f$export$b77a77786b18d4b = (items, measurements)=>{
    const conservativeSplit = {
        promotedItems: [],
        overflowItems: [
            ...items
        ]
    };
    if (measurements.availableWidth === null || items.length === 0) return conservativeSplit;
    const availableWidth = measurements.availableWidth;
    const fits = (candidateItems, showMore)=>$641217715532bb5f$var$getRowWidth({
            ...measurements,
            items: candidateItems,
            showMore: showMore
        }) <= availableWidth + $641217715532bb5f$var$COMPARISON_TOLERANCE;
    // "More" is optional when every item fits.
    if (fits([
        ...items
    ], false)) return {
        promotedItems: [
            ...items
        ],
        overflowItems: []
    };
    // Reserve "More" and promote root items left to right while they still fit beside it.
    const promotedItems = [];
    for (const item of items){
        const candidateItems = [
            ...promotedItems,
            item
        ];
        if (!fits(candidateItems, true)) break;
        promotedItems.push(item);
    }
    return {
        promotedItems: promotedItems,
        overflowItems: items.slice(promotedItems.length)
    };
};
module.exports["splitSiteNavigation"] = $641217715532bb5f$export$b77a77786b18d4b;

});

$parcel$global.rwr("aFBfl", () => { 
var $cozmU = parcelRequire("cozmU");


var $fRQ3t = parcelRequire("fRQ3t");


var $4jxwi = parcelRequire("4jxwi");


var $7D1yr = parcelRequire("7D1yr");


var $gJN0g = parcelRequire("gJN0g");


var $9kbTQ = parcelRequire("9kbTQ");


var $9HkI0 = parcelRequire("9HkI0");


var $65DSU = parcelRequire("65DSU");


var $fAsH0 = parcelRequire("fAsH0");


var $lTECB = parcelRequire("lTECB");


var $lJlG6 = parcelRequire("lJlG6");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $cRN1p = parcelRequire("cRN1p");


var $hvG5K = parcelRequire("hvG5K");


var $59ylD = parcelRequire("59ylD");

function $127d9b8e16c6a735$export$a311cb1baa7d2d62() {
    (0, $59ylD.resourceTimingBuffer).start();
}



var $e1XeN = parcelRequire("e1XeN");


var $8NKQ9 = parcelRequire("8NKQ9");


var $04e9M = parcelRequire("04e9M");


var $i7t6K = parcelRequire("i7t6K");


var $2c1Wz = parcelRequire("2c1Wz");

const $dc2c9e680a6dd356$var$MAX_REPORTED_SHIFTS = 50;
// JSON uses at most three UTF-8 bytes per UTF-16 code unit. Bound the detailed
// array to roughly 30 KB even for non-ASCII selectors, plus the small summary.
const $dc2c9e680a6dd356$var$MAX_DETAIL_CHARACTERS = 10000;
function $dc2c9e680a6dd356$var$findFiberNode(domNode) {
    if (!domNode) return undefined;
    const key = Object.keys(domNode).find((k)=>k.startsWith('__reactFiber$'));
    return key ? Reflect.get(domNode, key) : undefined;
}
function $dc2c9e680a6dd356$var$attributionByClosestFiberNode(fiberNode) {
    let current = fiberNode;
    while(current){
        if (current.memoizedProps?.__boundaryMarker) return current.memoizedProps?.attribution ?? 'unknown';
        current = current.return;
    }
    return 'not-attributed';
}
function $dc2c9e680a6dd356$var$toQuerySelector(node) {
    const path = [];
    if (node instanceof HTMLElement) {
        if (node.tagName) path.push(node.tagName.toLowerCase());
        // DOM IDs can contain user-authored heading text. Never include them.
        if (node.className) path.push(`.${node.className.split(' ').join('.')}`);
        if (node.dataset) Object.entries(node.dataset).forEach(([key, value])=>{
            path.push(`[data-${key}=${value}]`);
        });
    }
    return path.join('');
}
function $dc2c9e680a6dd356$var$toRect(rect) {
    return [
        rect.left,
        rect.top,
        rect.right,
        rect.bottom
    ];
}
function $dc2c9e680a6dd356$var$hasChangedRect({ previousRect: previousRect, currentRect: currentRect }) {
    return previousRect.x !== currentRect.x || previousRect.y !== currentRect.y || previousRect.width !== currentRect.width || previousRect.height !== currentRect.height || previousRect.top !== currentRect.top || previousRect.right !== currentRect.right || previousRect.bottom !== currentRect.bottom || previousRect.left !== currentRect.left;
}
function $dc2c9e680a6dd356$var$assignSessionWindows(records) {
    let current;
    let maxValue = 0;
    let maxSessionRef = null;
    for (const record of records){
        const { shift: shift } = record;
        // Match UFO's lighthouse-metrics/cls eligibility and burst boundaries.
        // UFO currently includes hadRecentInput entries; preserve that flag in
        // the details rather than silently applying a different metric policy.
        // The browser reports at most five sources per shift, so this scan is bounded.
        if (!shift.sources.some($dc2c9e680a6dd356$var$hasChangedRect)) continue;
        const end = shift.startTime + shift.duration;
        if (!current || shift.startTime - current.end > 1000 || end - current.start > 5000) current = {
            ref: (current?.ref ?? 0) + 1,
            start: shift.startTime,
            end: end,
            value: 0
        };
        current.end = end;
        current.value += shift.value;
        record.sessionRef = current.ref;
        if (current.value > maxValue) {
            maxValue = current.value;
            maxSessionRef = current.ref;
        }
    }
    return maxSessionRef;
}
const $dc2c9e680a6dd356$export$36b44777ebe5656d = (experienceName, clsAttributionConfig, { start: start, end: end, type: type, getCLS: getCLS })=>{
    const buffer = (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LayoutShift];
    const shifts = buffer.buffer.filter((shift)=>shift.startTime >= start && shift.startTime <= end);
    const payload = {
        version: 2,
        totalShift: shifts.reduce((total, shift)=>total + shift.value, 0),
        shiftCount: shifts.length,
        bufferTruncated: buffer.full,
        shifts: [],
        omittedShiftCount: 0
    };
    // Preserve the existing per-experience switch. No DOM/fiber traversal,
    // geometry serialization, or session analysis when details are disabled.
    if (!clsAttributionConfig.includeEntries?.[experienceName]) return payload;
    const { loadType: loadType } = clsAttributionConfig;
    const matchesLoadType = loadType === undefined || (loadType === 'initial' || loadType === 'both') && type === 'page_load' || (loadType === 'transition' || loadType === 'both') && type === 'transition';
    if (!matchesLoadType) return payload;
    const threshold = clsAttributionConfig.clsDetailsThreshold ?? 0;
    // Only read UFO's metric when needed, never the separate attribution buffer.
    // An absent metric cannot satisfy a positive threshold.
    if (threshold > 0) {
        const cls = getCLS?.();
        if (cls === undefined || cls < threshold) return payload;
    }
    shifts.sort((a, b)=>a.startTime - b.startTime);
    const records = shifts.map((shift, index)=>({
            shift: shift,
            shiftRef: index + 1,
            sessionRef: null
        }));
    const maxSessionRef = $dc2c9e680a6dd356$var$assignSessionWindows(records);
    const nodeRefs = new WeakMap();
    let nextNodeRef = 1;
    let detailCharacters = 2;
    // Prefer the largest shifts when the detail budget is exhausted. The
    // summary and window membership always use all retained in-window shifts.
    for (const { shift: shift, shiftRef: shiftRef, sessionRef: sessionRef } of records.sort((a, b)=>b.shift.value - a.shift.value).slice(0, $dc2c9e680a6dd356$var$MAX_REPORTED_SHIFTS)){
        const entry = {
            shiftRef: shiftRef,
            time: shift.startTime - start,
            value: shift.value,
            hadRecentInput: shift.hadRecentInput,
            sessionRef: sessionRef,
            inMaxSession: sessionRef !== null && sessionRef === maxSessionRef,
            // At most five browser-provided sources for each of at most 50 selected shifts.
            sources: shift.sources.map((source)=>{
                let nodeRef = null;
                if (source.node) {
                    nodeRef = nodeRefs.get(source.node) ?? nextNodeRef++;
                    nodeRefs.set(source.node, nodeRef);
                }
                const fiberNode = $dc2c9e680a6dd356$var$findFiberNode(source.node);
                return {
                    nodeRef: nodeRef,
                    attribution: fiberNode ? $dc2c9e680a6dd356$var$attributionByClosestFiberNode(fiberNode) : 'nonReact',
                    element: source.node ? $dc2c9e680a6dd356$var$toQuerySelector(source.node) : 'undefined',
                    previousRect: $dc2c9e680a6dd356$var$toRect(source.previousRect),
                    currentRect: $dc2c9e680a6dd356$var$toRect(source.currentRect),
                    hasInsideShift: source.previousRect.width !== source.currentRect.width || source.previousRect.height !== source.currentRect.height,
                    hasOutsideShift: source.previousRect.x !== source.currentRect.x || source.previousRect.y !== source.currentRect.y
                };
            })
        };
        const characters = JSON.stringify(entry).length + 1;
        if (detailCharacters + characters <= $dc2c9e680a6dd356$var$MAX_DETAIL_CHARACTERS) {
            payload.shifts.push(entry);
            detailCharacters += characters;
        }
    }
    payload.shifts.sort((a, b)=>a.shiftRef - b.shiftRef);
    payload.omittedShiftCount = shifts.length - payload.shifts.length;
    return payload;
};





const $4f467cf502568ccb$export$2d8f8d64dc343d7b = ()=>{
    if (typeof window === 'undefined' || !window.__HYDRATABLE__) return undefined;
    return {
        successful: !window.__HYDRATION_ERRORS__?.length,
        warningCount: 0,
        minWarningComponentDepth: 0,
        maxWarningComponentDepth: 0
    };
};



var $5ZqQS = parcelRequire("5ZqQS");


var $9eE57 = parcelRequire("9eE57");


var $1xpoY = parcelRequire("1xpoY");


var $kGrzq = parcelRequire("kGrzq");

const $ebf4d3ce910d3665$export$6adfe6668ae1a7f8 = (prefix)=>{
    const filteredMarkers = (window.performance?.getEntriesByType?.('mark') || []).filter((marker)=>marker.name.startsWith(prefix));
    filteredMarkers.sort((a, b)=>a.startTime - b.startTime);
    return filteredMarkers;
};
const $ebf4d3ce910d3665$export$a52fc5851be9b858 = (prefix)=>{
    const measures = new (0, $kGrzq.BaseMeasures)();
    for (const { name: name, startTime: startTime } of $ebf4d3ce910d3665$export$6adfe6668ae1a7f8(prefix)){
        const fieldName = name.replace(/\.start|\.end$/, '').replace(prefix, '');
        // Handle multiple pairs of markers due to re-renders
        if (name.endsWith('.start')) measures.markMeasureStart(fieldName, Math.floor(startTime));
        else measures.markMeasureEnd(fieldName, Math.floor(startTime), true);
    }
    const durations = {};
    for (const [name, { duration: duration }] of Object.entries(measures.getMeasures()))durations[name] = duration;
    return durations;
};


function $316168ab5c690743$export$9dbd6bda36500fa9() {
    const entries = (0, $ebf4d3ce910d3665$export$6adfe6668ae1a7f8)('wf/');
    const startTimes = {};
    const timings = {};
    for (const { name: name, startTime: startTime } of entries){
        if (name.endsWith('.start')) {
            const key = name.slice(0, -6);
            startTimes[key] = startTime;
        } else if (name.endsWith('.end')) {
            const key = name.slice(0, -4);
            if (typeof startTimes[key] === 'number') timings[key] = {
                startTime: startTimes[key],
                endTime: startTime
            };
        }
    }
    return timings;
}



var $6VdZc = parcelRequire("6VdZc");


var $8Lf0D = parcelRequire("8Lf0D");

var $jy3Cx = parcelRequire("jy3Cx");


var $5leFG = parcelRequire("5leFG");

const $2ba6133bff070823$export$8c5248f0cec8446d = new (0, $5leFG.EventBus)();


var $80c67148001d6fe8$var$_JSCacheRate;
class $80c67148001d6fe8$export$aca60c726e4e7838 {
    /**
   * Clear Cache
   *
   * Clears all existing cache entries
   */ static clearCache() {
        this.IDs.reset();
        this.Cache.clear();
    }
    /**
   * Compute Cache Rate
   *
   * Iterates the cache looking for the LRU cache compute
   * and creates a new compute based upon the results of
   * it (if it exists). If not, it'll compute cache rate
   * using a bottom-up iteration of loaded assets
   */ static computeCacheRate(time) {
        let lastKey = '';
        const entries = this.Cache.keys;
        const maxIndex = entries.length - 1;
        for(let i = maxIndex; i > -1; i--){
            const key = entries[i];
            const { time: stopTime } = this.Cache.get(key);
            if (time > stopTime) {
                lastKey = key;
                break;
            }
        }
        let newEntry;
        if (lastKey) newEntry = this.mergeFromLastKey(lastKey, time);
        else newEntry = this.iterateResources(time);
        const ID = $80c67148001d6fe8$export$aca60c726e4e7838.IDs.ID();
        $80c67148001d6fe8$export$aca60c726e4e7838.Cache.set(ID, {
            time: time,
            ...newEntry
        });
        return $80c67148001d6fe8$export$aca60c726e4e7838.Cache.get(ID);
    }
    /**
   * Merge From Last Key
   *
   * Combines the LRU cache rate with a cache rate being computed
   */ static mergeFromLastKey(key, time) {
        const { lastIndex: lastIndex, criticalPath: criticalPath } = $80c67148001d6fe8$export$aca60c726e4e7838.Cache.get(key);
        const { lastIndex: newIndex, criticalPath: newCriticalPath } = this.iterateResources(time, lastIndex + 1);
        return {
            lastIndex: newIndex,
            criticalPath: this.merge(criticalPath, newCriticalPath)
        };
    }
    /**
   * Iterate Resources
   *
   * Iterates performance resource timings given a time and from (index)
   * filter. While iterating, this method will accumulate the scripts
   * that have loaded prior to the input time and capture the last index
   * of the final script loaded within that scope
   */ static iterateResources(time, from = 0) {
        const criticalPath = this.criticalPath;
        const resources = window.performance.getEntriesByType('resource');
        const { length: length } = resources;
        let lastIndex = from;
        for(let i = lastIndex; i < length; i++){
            const entry = resources[i];
            if (entry.initiatorType !== 'script' || entry.responseEnd > time) continue;
            lastIndex = i;
            if (entry.transferSize) criticalPath.nonCachedSize += entry.encodedBodySize;
            else {
                criticalPath.cachedCount += 1;
                criticalPath.cachedSize += entry.encodedBodySize;
            }
            criticalPath.totalSize += entry.encodedBodySize;
            criticalPath.scripts.push({
                name: entry.name.split('/').pop() || '',
                start: entry.startTime,
                end: entry.responseEnd,
                size: entry.encodedBodySize
            });
        }
        return {
            criticalPath: criticalPath,
            lastIndex: lastIndex
        };
    }
    /**
   * Critical Path
   *
   * Returns an initialized `CriticalPath` object
   */ static get criticalPath() {
        return {
            scripts: [],
            totalSize: 0,
            cachedCount: 0,
            cachedSize: 0,
            nonCachedSize: 0
        };
    }
    /**
   * Merge
   *
   * Merges the properties of two critical path objects
   */ static merge(cachedCP, newCP) {
        return {
            scripts: cachedCP.scripts.concat(newCP.scripts),
            totalSize: cachedCP.totalSize + newCP.totalSize,
            cachedCount: cachedCP.cachedCount + newCP.cachedCount,
            cachedSize: cachedCP.cachedSize + newCP.cachedSize,
            nonCachedSize: cachedCP.nonCachedSize + newCP.nonCachedSize
        };
    }
}
$80c67148001d6fe8$var$_JSCacheRate = $80c67148001d6fe8$export$aca60c726e4e7838;
$80c67148001d6fe8$export$aca60c726e4e7838.IDs = new (0, $8Lf0D.AutoIncrementingID)();
$80c67148001d6fe8$export$aca60c726e4e7838.Cache = new (0, $jy3Cx.Cache)();
$80c67148001d6fe8$export$aca60c726e4e7838.Listener = (0, $2ba6133bff070823$export$8c5248f0cec8446d).on('page-transition', $80c67148001d6fe8$var$_JSCacheRate.clearCache.bind($80c67148001d6fe8$var$_JSCacheRate));


const $798e13e8b010d13b$export$2ae1dd61fa7d6fb4 = (stop)=>{
    const { criticalPath: { scripts: scripts, totalSize: totalSize, cachedCount: cachedCount, cachedSize: cachedSize, nonCachedSize: nonCachedSize } } = (0, $80c67148001d6fe8$export$aca60c726e4e7838).computeCacheRate(stop);
    return {
        cachedRate: cachedCount / scripts.length * 100,
        count: scripts.length,
        size: totalSize,
        cachedSize: cachedSize,
        nonCachedSize: nonCachedSize,
        sizeBasedCachedRate: cachedSize / (cachedSize + nonCachedSize)
    };
};


const $1f8015dad40e09ac$export$4a5a528f9e4c1e63 = ()=>window.jQuery?.fn?.jquery;


const $8476ac2738811490$export$30c543c9fd9ad97 = ({ stop: stop })=>{
    const customAttributes = {
        initial: (0, $6VdZc.isInitial)(),
        criticalAssets: (0, $798e13e8b010d13b$export$2ae1dd61fa7d6fb4)(stop),
        jqVer: (0, $1f8015dad40e09ac$export$4a5a528f9e4c1e63)()
    };
    return customAttributes;
};


var $lqJ5I = parcelRequire("lqJ5I");




const $8b39c089fbdae2d5$export$96934690d8345a62 = (obj)=>{
    if (typeof obj !== 'object' || !obj) return {};
    const recursivelyBuildCustomValues = (obj)=>{
        const customValues = {};
        Object.entries(obj).forEach(([key, value])=>{
            if (Array.isArray(value)) customValues[key] = value.map((e)=>JSON.stringify(e)).join(',');
            else if (typeof value === 'object' && value) {
                const nestedValues = recursivelyBuildCustomValues(value);
                Object.entries(nestedValues).forEach(([nestedKey, nestedValue])=>{
                    customValues[`${key}:${nestedKey}`] = nestedValue;
                });
            } else {
                if (typeof value === 'number') customValues[key] = Math.round(value);
                else if (typeof value === 'boolean') customValues[key] = value;
                else customValues[key] = String(value);
            }
        });
        return customValues;
    };
    return recursivelyBuildCustomValues(obj);
};


const $894ba807f7f34abc$export$3f2fb183b6cd13c4 = ({})=>{
    // Only track frontend calls, skip during SSR
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    if (typeof window === 'undefined') return {
        frontendTotalOperations: 0,
        apiCsrCount: 0,
        fetchCount: 0
    };
    const stats = (0, $lqJ5I.networkTracker).getStats();
    const pageLoadStats = (0, $lqJ5I.networkTracker).getStatsSincePageLoadStart();
    const navigationType = (0, $6VdZc.browserMetricsState).transitionId === 0 ? 'initial' : 'transition';
    const boundaryNames = Object.keys(pageLoadStats.byBoundary ?? {}).sort();
    const boundaryFirstApiMetrics = (0, $8b39c089fbdae2d5$export$96934690d8345a62)({
        apiByStreamingBoundary: Object.fromEntries(boundaryNames.map((boundaryName)=>[
                boundaryName,
                {
                    csr: {
                        [navigationType]: {
                            count: pageLoadStats.byBoundary[boundaryName]
                        }
                    }
                }
            ]))
    });
    return {
        frontendTotalOperations: stats.totalOperations,
        apiCsrCount: pageLoadStats.totalOperations,
        fetchCount: window.__FETCH_COUNT__ ?? 0,
        ...boundaryFirstApiMetrics
    };
};


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $4c29a57cb1cefaed$var$isAssets = (x)=>{
    if (typeof x !== 'object' || !x) return false;
    for (const value of Object.values(x)){
        if (typeof value !== 'string') return false;
    }
    return true;
};
const $4c29a57cb1cefaed$var$scriptInitiator = {
    script: true,
    other: true,
    link: true
};
const $4c29a57cb1cefaed$var$criticalChunkPrefixes = {
    'query-preloader': true,
    'translations.en-US': true,
    runtime: true,
    atlaskit: true,
    afp: true,
    static: true,
    vendors: true,
    app: true
};
const $4c29a57cb1cefaed$var$getCachedAssets = ()=>{
    try {
        const assets = JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).CACHED_ASSETS)) || {};
        if (!$4c29a57cb1cefaed$var$isAssets(assets)) return {};
        return assets;
    } catch  {
        return {};
    }
};
const $4c29a57cb1cefaed$var$updateCachedAssets = (assets)=>{
    try {
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).CACHED_ASSETS, JSON.stringify(assets));
    } catch  {
    // NOOP
    }
};
const $4c29a57cb1cefaed$export$445ccb86da5ca9ca = (endTime)=>{
    const cachedChunks = $4c29a57cb1cefaed$var$getCachedAssets();
    const loadedChunks = {};
    const criticalChunks = {};
    let totalChunkCount = 0;
    performance.getEntriesByType('resource').forEach((entry)=>{
        const { initiatorType: initiatorType, responseEnd: responseEnd, duration: duration, name: name } = entry;
        // Discard non-scripts and scripts that were loaded after the end time
        if (!$4c29a57cb1cefaed$var$scriptInitiator[initiatorType] || responseEnd > endTime) return;
        const chunkName = name.split('/').pop();
        if (!chunkName) return;
        const chunkPrefix = chunkName.split('~').shift();
        if (!chunkPrefix) return;
        // Match loaded chunk name with cached chunk name for all critical chunks
        if ($4c29a57cb1cefaed$var$criticalChunkPrefixes[chunkPrefix]) {
            loadedChunks[chunkPrefix] = chunkName;
            criticalChunks[chunkPrefix] = {
                cached: cachedChunks[chunkPrefix] === chunkName,
                duration: duration
            };
        }
        totalChunkCount++;
    });
    $4c29a57cb1cefaed$var$updateCachedAssets(loadedChunks);
    return {
        criticalChunks: criticalChunks,
        totalChunkCount: totalChunkCount
    };
};

















const $ac2afaf945b706af$var$getElementSelector = (element)=>{
    if (!element || !element.tagName) return 'n/a';
    const selector = `${element.tagName.toLowerCase()}.${element.className?.split(' ').join('.')}`;
    if (element.dataset?.testid) return `${selector}[data-testid="${element.dataset?.testid}"]`;
    return selector;
};
const $ac2afaf945b706af$export$2980a1865b8e55dd = (hydrationErrors)=>{
    let loggingConfig = {};
    try {
        loggingConfig = JSON.parse((0, $1xpoY.default).getString('confluence_hydration_error_logging', '{}'));
    } catch  {
    // no-op, if an error occurs here, there's really nowhere to submit it
    }
    return hydrationErrors.reduce((accumulator, error)=>{
        if (!error.type || !error.msg) return accumulator;
        // Log selectors for mismatched hydration errors. The presense of parentNode or parent
        // depend on actual hydration error / patch used.
        const finalParent = error.parent || error.parentNode;
        if (loggingConfig.selectors && (finalParent || error.child)) {
            if (!accumulator.selectors) accumulator.selectors = '';
            const parent = finalParent ? $ac2afaf945b706af$var$getElementSelector(finalParent) : 'n/a';
            const child = error.child ? $ac2afaf945b706af$var$getElementSelector(error.child) : 'n/a';
            accumulator.selectors += `${parent}->${child}; `;
        }
        // For UNSAFE_TEXT_MISMATCH errors, only track the count
        // Don't log the actual text content as it contains sensitive data
        // Similarly, UNSAFE_CLIENT_MISMATCH and UNSAFE_SERVER_MISMATCH contain user content in text nodes
        if (loggingConfig.errors) {
            if (error.type === 'UNSAFE_TEXT_MISMATCH') accumulator.unsafeTextMismatches = (accumulator.unsafeTextMismatches || 0) + 1;
            else if (error.type === 'UNSAFE_CLIENT_MISMATCH') accumulator.unsafeClientMismatches = (accumulator.unsafeClientMismatches || 0) + 1;
            else if (error.type === 'UNSAFE_SERVER_MISMATCH') accumulator.unsafeServerMismatches = (accumulator.unsafeServerMismatches || 0) + 1;
            else {
                if (!accumulator[error.type]) accumulator[error.type] = '';
                accumulator[error.type] += (accumulator[error.type] ? ' ; ' : '') + error.msg;
            }
        }
        // Add error stack
        if (loggingConfig.stack && error.stack) {
            if (!accumulator.stack) accumulator.stack = '';
            accumulator.stack += `Stack: ${error.stack} \n`;
        }
        return accumulator;
    }, {});
};

const $58d4f470662e1918$export$494b6359b6a45bfd = ()=>{
    const heightChanges = window?.__ATL_GENERAL_WEBPANEL_HEIGHT_CHANGES__;
    const result = {
        initialHeight: window?.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__ || 0,
        changes: heightChanges?.length || 0
    };
    if (heightChanges?.length) result.finalHeight = heightChanges[heightChanges.length - 1];
    return result;
};


var $lXQLs = parcelRequire("lXQLs");
/**
 * Normalizes a hydration error type by stripping the "UNSAFE_" prefix.
 *
 * Returns null if the error has no type.
 */ const $ca8fa84470cae806$var$normalizeHydrationErrorType = (error)=>{
    if (!error.type) return null;
    return error.type.startsWith('UNSAFE_') ? error.type.slice(7) : error.type;
};
const $ca8fa84470cae806$export$92d14dc1fbc3f3a3 = (hydrationErrors)=>{
    const counts = {};
    for (const error of hydrationErrors){
        const normalizedType = $ca8fa84470cae806$var$normalizeHydrationErrorType(error);
        if (normalizedType) counts[normalizedType] = (counts[normalizedType] || 0) + 1;
    }
    return counts;
};

const $32c078c7f61fe0e3$export$d966f1e92068ec2e = (stats)=>{
    if (!stats) return {
        totalLinks: 0,
        totalResolved: 0
    };
    const { links: links } = stats;
    let totalLinks = 0;
    let totalResolved = 0;
    Object.values(links).forEach((byAppearance)=>{
        Object.values(byAppearance).forEach(({ total: total, resolved: resolved })=>{
            totalLinks += total;
            totalResolved += resolved;
        });
    });
    return {
        totalLinks: totalLinks,
        totalResolved: totalResolved
    };
};



var $8wW9d = parcelRequire("8wW9d");


var $5w0J2 = parcelRequire("5w0J2");


function $31b0fb0fb1951a4c$var$limitTop10(obj) {
    return Object.fromEntries(Object.entries(obj).sort((a, b)=>b[1] - a[1]).slice(0, 10));
}
const $31b0fb0fb1951a4c$var$sanitizeSsrMeasureName = (value)=>value.replace(/[^\-.\w]/g, '_');
const $31b0fb0fb1951a4c$var$emptySSRDataFetcherStats = ()=>({
        boundaries: [],
        fetchCounts: {}
    });
const $31b0fb0fb1951a4c$var$getSSRDataFetcherStats = (ssrMeasures)=>{
    if (!ssrMeasures) return $31b0fb0fb1951a4c$var$emptySSRDataFetcherStats();
    const stats = $31b0fb0fb1951a4c$var$emptySSRDataFetcherStats();
    const boundaryNames = new Set();
    Object.keys(ssrMeasures).forEach((measureKey)=>{
        const dataFetcherMatch = measureKey.match(/(?:^|\/)dataFetcher:([^/]+)/);
        if (!dataFetcherMatch) return;
        const boundaryName = $31b0fb0fb1951a4c$var$sanitizeSsrMeasureName(dataFetcherMatch[1]);
        const measureLeaf = measureKey.substring(measureKey.lastIndexOf('/') + 1);
        if (measureLeaf?.startsWith('fetch:')) {
            boundaryNames.add(boundaryName);
            stats.fetchCounts[boundaryName] = (stats.fetchCounts[boundaryName] ?? 0) + 1;
        }
    });
    stats.boundaries = Array.from(boundaryNames).sort();
    return stats;
};
const $31b0fb0fb1951a4c$var$getSSRBoundaryFirstApiMetrics = (ssrDataFetcherStats, navigationType)=>(0, $8b39c089fbdae2d5$export$96934690d8345a62)({
        apiByStreamingBoundary: Object.fromEntries(ssrDataFetcherStats.boundaries.map((boundaryName)=>[
                boundaryName,
                {
                    ssr: {
                        [navigationType]: {
                            count: ssrDataFetcherStats.fetchCounts[boundaryName] ?? 0
                        }
                    }
                }
            ]))
    });
const $31b0fb0fb1951a4c$export$7908ff149a3cbadd = ({ stop: stop })=>{
    const isInitialPageLoad = (0, $6VdZc.browserMetricsState).transitionId === 0;
    const isSsrRendered = isInitialPageLoad && Boolean(window.__SSR_RENDERED__);
    const customAttributes = {
        transitionId: (0, $6VdZc.browserMetricsState).transitionId,
        // HTTP protocol used to fetch resources
        // Use multiple domains for http/1.1 users
        // Set in packages/confluence-frontend-server/templates/generator.js
        domainSharding: Boolean(window.__GET_CC_ASSET_URL),
        // HTTP protocol used to fetch resources
        httpProtocol: (0, $lXQLs.getHTTPProtocol)(performance.getEntriesByType('resource')),
        // Add the critical path JS assets size stats
        criticalAssets: (0, $798e13e8b010d13b$export$2ae1dd61fa7d6fb4)(stop),
        // Send stats on expensive queries and unnecessary watches
        apolloDiffStoreStats: (0, $8b39c089fbdae2d5$export$96934690d8345a62)($31b0fb0fb1951a4c$var$limitTop10(window?.__APOLLO_STATS__?.diffStore || {})),
        // Content + non-content 3P app keys for this navigation.
        //
        // Emitted for BOTH initial page loads and SPA transitions, unlike the
        // legacy `connectAppKeys` below which is initial-load only. Experiences
        // that are almost always reached via a transition (`edit-page`,
        // `live-edit`, `confluence-home`) therefore only ever report app keys
        // through this attribute.
        //
        // `connectAppKeys` is intentionally left as-is so existing dashboards
        // keep their current semantics; on an initial page load the two
        // attributes hold identical values.
        ...(0, $6mKj3.expVal)('confluence_app_keys_transition', 'isEnabled', false) ? {
            appKeys: (0, $5w0J2.getAppKeys)()
        } : {}
    };
    const navigationType = isInitialPageLoad ? 'initial' : 'transition';
    const ssrDataFetcherStats = isInitialPageLoad ? $31b0fb0fb1951a4c$var$getSSRDataFetcherStats(window.__SSR_MEASURES__) : $31b0fb0fb1951a4c$var$emptySSRDataFetcherStats();
    Object.assign(customAttributes, {
        navigationType: navigationType,
        renderMode: isSsrRendered ? 'ssr' : 'csr',
        apiSsrCount: isInitialPageLoad ? window.__SSR_OPERATIONS_COUNT__ ?? 0 : 0,
        ...$31b0fb0fb1951a4c$var$getSSRBoundaryFirstApiMetrics(ssrDataFetcherStats, navigationType)
    });
    Object.entries((0, $ebf4d3ce910d3665$export$a52fc5851be9b858)('CFP-63.')).forEach(([fieldName, value])=>{
        customAttributes[`cfp63Durations:${fieldName}`] = value;
    });
    if (isInitialPageLoad) {
        const navigationTimings = window.performance.getEntriesByType('navigation');
        if (navigationTimings.length) {
            // TypeScript isn't returning the proper type for this, so some
            // casting here
            const firstTiming = navigationTimings[0];
            if (firstTiming.transferSize != null) customAttributes.pageLoadedFromCache = firstTiming.transferSize === 0;
        }
        // Record the current version of jQuery
        customAttributes.jqVer = window.jQuery?.fn?.jquery;
        // Record if page is rendered by React SSR service
        customAttributes.ssr = isSsrRendered;
        // Some SSR render errors (e.g.: edit page content area failed to SSR) are considered critical even when window.__SSR_RENDERED__ is true
        customAttributes.ssrHasCriticalError = Boolean(window.__SSR_HAS_CRITICAL_ERROR__);
        customAttributes.ssrTraceId = window.__SSR_TRACE_ID__ ?? '';
        // only send ssr macro metrics if there is at least one macro on the SSRd page
        if (window?.__SSR_MACROS_INFO__) customAttributes.ssrMacrosInfo = window.__SSR_MACROS_INFO__;
        if (window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__) customAttributes.macrosPreloadFails = window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__;
        // Record user clicks and intent to click on SSR placeholder elements
        customAttributes.ssrInteractions = window?.__SSR_INTERACTIONS__ || {};
        // @ts-ignore `__SSR_INTERACTIONS_DURATIONS__` maintains an array of numbers, but browser-metrics doesn't really accept arrays. Might make sense to comma-join the values
        customAttributes.ssrInteractionsDurations = window?.__SSR_INTERACTIONS_DURATIONS__ || {};
        customAttributes.ssrQueryTimeouts = window?.__SSR_QUERY_TIMEOUTS__ || {};
        customAttributes.ssrPartialSuccess = window?.__SSR_PARTIAL_SUCCESS__ || {};
        if (window?.__SSR_STREAM_END__) customAttributes.ssrStreamEnd = window.__SSR_STREAM_END__;
        customAttributes.reactStreaming = window.__SSR_REACT_STREAMING__ || false;
        // Record loadable ids that timed out
        customAttributes.loadableTimeouts = Array.from(new Set(window?.__LOADABLE_TIMEOUTS__ || [])).join(',');
        if (window?.__HYDRATION_ERRORS__) {
            customAttributes.hydrationErrors = (0, $ac2afaf945b706af$export$2980a1865b8e55dd)(window.__HYDRATION_ERRORS__);
            if ((0, $1xpoY.default).getBoolean('confluence_hydration_error_type_logging', false)) customAttributes.hydrationErrorCounts = (0, $ca8fa84470cae806$export$92d14dc1fbc3f3a3)(window.__HYDRATION_ERRORS__);
            if (window.__HYDRATION_ERRORS__.length > 0) (0, $5ZqQS.getMonitoringClient)().incrementCounter('hydrationErrorSessions');
        }
        customAttributes.hydratable = window?.__HYDRATABLE__ || false;
        customAttributes.hydrationFailed = window?.__HYDRATION_FAILED__ || false;
        // Record the number of SSRed elements
        customAttributes.totalSSRedElements = window?.__TOTAL_SSR_ELEMENTS__ || 0;
        if (window?.__SSR_SMARTLINKS_STATS__) customAttributes.ssrSmartLinksStats = (0, $32c078c7f61fe0e3$export$d966f1e92068ec2e)(window.__SSR_SMARTLINKS_STATS__);
        if (window?.__SSR_SHORTCUTS_STATS__) customAttributes.ssrShortcutsStats = window.__SSR_SHORTCUTS_STATS__;
        // Calculates which query is the long pole, as well as its duration
        customAttributes.longPoleQuery = window?.__SSR_LONG_POLE_QUERY__ || {};
        // Node counts from AK renderer, available in fabric only
        customAttributes.rendererNodesCount = window?.__RENDERER_NODES_COUNT__ || {};
        customAttributes.remoteLocalStorage = window?.__REMOTE_LOCAL_STORAGE__?.length || 0;
        customAttributes.wrmKeys = window?.__WRM_KEYS__ || {};
        // Combine content connect app keys (from LegacyMacroRendererComponent) with
        // non-content 3P app keys (byline/page banner/context menu/web panels/etc.)
        // so both land in the same `connectAppKeys` extra_property. Deduped via a Set.
        customAttributes.connectAppKeys = [
            ...new Set([
                ...window?.__APP_KEYS__ || [],
                ...(0, $8wW9d.getNonContentAppKeys)()
            ])
        ].join(',');
        customAttributes.atlGeneralHeightChanges = (0, $8b39c089fbdae2d5$export$96934690d8345a62)((0, $58d4f470662e1918$export$494b6359b6a45bfd)());
        // Add the caching status of each asset
        const cacheStatus = (0, $8b39c089fbdae2d5$export$96934690d8345a62)({
            cacheStatus: (0, $4c29a57cb1cefaed$export$445ccb86da5ca9ca)(stop)
        });
        for (const [key, value] of Object.entries(cacheStatus))customAttributes[key] = value;
    }
    return customAttributes;
};

const $47229cc534a9628f$export$79c58f8fef22ebf2 = ()=>{
    const customAttributes = {
        ssrRegion: window.__SSR_REGION__ ?? ''
    };
    return customAttributes;
};



var $eSuZj = parcelRequire("eSuZj");





var $7W9kD = parcelRequire("7W9kD");

/**
 * collectPerfProbe — client performance diagnostic covariates for UFO payloads.
 *
 * Purpose: existing metrics (TBT, page-load timings) tell us the main thread was
 * blocked or the load was slow, but not *why*. This module emits a small set of
 * explanatory covariates so the "slow client" bucket can be decomposed into:
 *   (a) slow per-core CPU                → `perfProbe:cpuMs`
 *   (b) GPU / software-rendering fallback → `perfProbe:softwareGL`
 *   (c) HTML buffered upstream (e.g. AV)  → `perfProbe:earlyHtmlToScriptMs`
 *
 * Signals split into two kinds:
 *   - The CPU benchmark (cpuMs): the only expensive signal, so it is measured off
 *     the critical path in idle time and persisted via the Confluence storage
 *     manager (local only) along with the epoch ms it was taken (`perfProbe:t`), so
 *     the initial-load payload can carry the previous load's sample without ever
 *     blocking the current load.
 *   - Cheap per-load reads (softwareGL, earlyHtmlToScriptMs): computed inline when
 *     the payload is generated — never persisted — since a canvas/WebGL probe and a
 *     Performance Timeline read are both trivial.
 *
 * Performance-safety contract: this module must never affect the page it measures.
 * The CPU benchmark only ever runs inside requestIdleCallback — with no timer
 * fallback, so it is simply skipped where that API is unavailable — one small sample
 * per idle slot; every entry point is wrapped so any failure yields an empty object.
 */ 
var $7W8i8 = parcelRequire("7W8i8");







const $dc78d25e9ffa5ac9$var$logger = (0, $7W8i8.getLogger)('collectPerfProbe');
const $dc78d25e9ffa5ac9$var$SCHEMA_VERSION = 1;
// Number of timed runs of the fixed workload; we report the min (contention
// stripped out). Runs one-per-idle-slot so we always yield between samples.
const $dc78d25e9ffa5ac9$var$SAMPLE_COUNT = 5;
// Fixed iteration count. Chosen so a single sample takes a few ms — comfortably
// above performance.now() resolution (which browsers clamp for privacy) yet small
// enough to fit inside a single idle slot. Never adaptive.
const $dc78d25e9ffa5ac9$var$ITERATIONS = 2000000;
const $dc78d25e9ffa5ac9$var$IDLE_TIMEOUT_MS = 60000;
// The CPU benchmark is refreshed at most once every 3 days. The persisted sample is
// kept (never consumed) so every load in between reports the last value; a fresh
// benchmark only runs once the stored sample is at least this old.
const $dc78d25e9ffa5ac9$var$REFRESH_INTERVAL_MS = 259200000;
// Renderer substrings that indicate hardware acceleration is off and WebGL is
// running on a software rasteriser.
const $dc78d25e9ffa5ac9$var$SOFTWARE_RENDERER_HINTS = [
    'swiftshader',
    'llvmpipe',
    'basic render driver',
    'software'
];
const $dc78d25e9ffa5ac9$var$round2 = (n)=>Math.round(n * 100) / 100;
let $dc78d25e9ffa5ac9$var$refreshRunning = false;
let $dc78d25e9ffa5ac9$var$pendingSamples = [];
function $dc78d25e9ffa5ac9$export$7e2d586540f6b439() {
    const payload = {};
    try {
        const stored = $dc78d25e9ffa5ac9$var$readStored();
        if (stored) {
            payload['perfProbe:cpuMs'] = stored.cpuMs;
            payload['perfProbe:t'] = stored.t;
        }
        // Refresh the CPU sample off the critical path, but no more than once every 3
        // days: run only when there is no sample yet or the stored one has aged past
        // the interval. The persisted entry is never cleared here.
        if (!stored || Date.now() - stored.t >= $dc78d25e9ffa5ac9$var$REFRESH_INTERVAL_MS) $dc78d25e9ffa5ac9$var$scheduleRefresh();
    } catch  {
    // never let the CPU covariate affect the payload
    }
    try {
        // Cheap to compute, so read it live rather than persisting it.
        if (typeof document !== 'undefined') payload['perfProbe:softwareGL'] = $dc78d25e9ffa5ac9$var$detectSoftwareGL();
    } catch  {
    // GL probe is best-effort
    }
    try {
        payload['perfProbe:earlyHtmlToScriptMs'] = $dc78d25e9ffa5ac9$var$getEarlyHtmlToScriptMs();
    } catch  {
    // per-load timing is best-effort
    }
    return payload;
}
// --- (a) CPU benchmark: idle sampling + persistence ---------------------------
function $dc78d25e9ffa5ac9$var$scheduleRefresh() {
    if ($dc78d25e9ffa5ac9$var$refreshRunning) return;
    $dc78d25e9ffa5ac9$var$refreshRunning = true;
    $dc78d25e9ffa5ac9$var$pendingSamples = [];
    $dc78d25e9ffa5ac9$var$scheduleNextSample();
}
function $dc78d25e9ffa5ac9$var$scheduleNextSample() {
    $dc78d25e9ffa5ac9$var$requestIdle(()=>{
        if ($dc78d25e9ffa5ac9$var$pendingSamples.length === 0) $dc78d25e9ffa5ac9$var$logger.info`collectPerfProbe: running CPU benchmark — ${$dc78d25e9ffa5ac9$var$SAMPLE_COUNT} samples of ${$dc78d25e9ffa5ac9$var$ITERATIONS} iterations`;
        let sample;
        try {
            sample = $dc78d25e9ffa5ac9$var$runCpuSample();
        } catch  {
            // abandon this cycle; leave any previously stored sample untouched
            $dc78d25e9ffa5ac9$var$refreshRunning = false;
            return;
        }
        $dc78d25e9ffa5ac9$var$pendingSamples.push(sample);
        if ($dc78d25e9ffa5ac9$var$pendingSamples.length < $dc78d25e9ffa5ac9$var$SAMPLE_COUNT) {
            $dc78d25e9ffa5ac9$var$scheduleNextSample();
            return;
        }
        try {
            $dc78d25e9ffa5ac9$var$writeStored({
                v: $dc78d25e9ffa5ac9$var$SCHEMA_VERSION,
                cpuMs: $dc78d25e9ffa5ac9$var$round2(Math.min(...$dc78d25e9ffa5ac9$var$pendingSamples)),
                t: Date.now()
            });
        } catch  {
        // persistence failure is non-fatal
        } finally{
            $dc78d25e9ffa5ac9$var$refreshRunning = false;
        }
    });
}
function $dc78d25e9ffa5ac9$var$runCpuSample() {
    let checksum = 0;
    const start = performance.now();
    for(let i = 0; i < $dc78d25e9ffa5ac9$var$ITERATIONS; i++)// Unsigned 32-bit wrap keeps the checksum a small int and is intrinsic to the
    // fixed workload we're timing; the bitwise op is deliberate here.
    // eslint-disable-next-line no-bitwise
    checksum = checksum * 31 + i >>> 0;
    const elapsed = performance.now() - start;
    globalThis.__ccPerfProbeChecksum = checksum;
    return elapsed;
}
// --- (b) software-rendering probe: cheap inline canvas/WebGL read -------------
function $dc78d25e9ffa5ac9$var$detectSoftwareGL() {
    // Guard browser globals for SSR; callers already gate on `document`, but the
    // access is kept lexically inside the positive guard.
    if (typeof document !== 'undefined') {
        const canvas = document.createElement('canvas');
        canvas.width = 1;
        canvas.height = 1;
        const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
        if (!gl) // No hardware-accelerated WebGL path available at all.
        return true;
        let renderer = '';
        const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
        if (debugInfo) renderer = String(gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) || '');
        // Release the context promptly rather than waiting for GC.
        gl.getExtension('WEBGL_lose_context')?.loseContext();
        const normalized = renderer.toLowerCase();
        // If the renderer string is unavailable (some browsers restrict it) we
        // cannot tell — default to false so we never produce a false (b) positive.
        return $dc78d25e9ffa5ac9$var$SOFTWARE_RENDERER_HINTS.some((hint)=>normalized.includes(hint));
    }
    return false;
}
// --- (c) per-load early-HTML delivery signal: passive timeline read -----------
/**
 * How long after the first HTML byte arrived could the browser first fetch JS?
 *
 *   earlyHtmlToScriptMs = max(0, earliestScript.startTime - navigation.responseStart)
 *
 * The preload scanner initiates a <script> fetch the instant it parses the tag out
 * of the arriving markup, so the earliest script's startTime marks when the early
 * HTML first became actionable — independent of whether that script then resolves
 * from cache or the network.
 *
 * small  → the <head> streamed in right behind the first byte and JS started almost
 *          immediately (healthy streaming).
 * large  → the script-bearing early markup only landed well after the first byte,
 *          i.e. the document was buffered/drip-fed upstream (AV/content-inspection
 *          proxy is the leading suspect on managed fleets) — the "early part of the
 *          HTML reaching the customer late" symptom.
 * 'unknown' → the timeline could not be read (no Performance API, no navigation
 *          entry, no responseStart, or no script resource to anchor on).
 *
 * Anchored on the earliest-started script — the best case. Cache hits are included:
 * a cache hit still means the browser discovered and acted on the tag, and its
 * startTime is the cleanest discovery timestamp (no network download confounding
 * it). A negative delta — a script discovered before responseStart, e.g. via an
 * HTTP 103 Early Hints preload — is floored to 0; that is ultra-healthy delivery,
 * not a defect.
 */ function $dc78d25e9ffa5ac9$var$getEarlyHtmlToScriptMs() {
    if (typeof performance === 'undefined' || typeof performance.getEntriesByType !== 'function') return 'unknown';
    const nav = performance.getEntriesByType('navigation')[0];
    if (!nav || !nav.responseStart) return 'unknown';
    const scripts = performance.getEntriesByType('resource').filter((entry)=>entry.initiatorType === 'script' && entry.startTime > 0);
    if (scripts.length === 0) return 'unknown';
    const earliest = scripts.reduce((a, b)=>a.startTime <= b.startTime ? a : b);
    return Math.round(Math.max(0, earliest.startTime - nav.responseStart));
}
// --- persistence via the sanctioned Confluence storage manager ----------------
// Local-only key (not in PERSISTED_KEYS_ON_SERVER), so nothing syncs to the
// server. The instance is a module singleton initialised at app boot; it may be
// undefined very early, and its own methods no-op during SSR.
function $dc78d25e9ffa5ac9$var$readStored() {
    try {
        const raw = (0, $17wUi.confluenceLocalStorageInstance)?.getItem((0, $1UApO.keys).PERF_PROBE_DIAGNOSTIC);
        if (!raw) return undefined;
        const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
        if (parsed && parsed.v === $dc78d25e9ffa5ac9$var$SCHEMA_VERSION && typeof parsed.cpuMs === 'number' && typeof parsed.t === 'number') return {
            v: parsed.v,
            cpuMs: parsed.cpuMs,
            t: parsed.t
        };
        return undefined;
    } catch  {
        return undefined;
    }
}
function $dc78d25e9ffa5ac9$var$writeStored(value) {
    try {
        (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.keys).PERF_PROBE_DIAGNOSTIC, JSON.stringify(value));
    } catch  {
    // quota / disabled storage — non-fatal
    }
}
function $dc78d25e9ffa5ac9$var$requestIdle(callback) {
    // In Confluence bundles `window` is replaced at build time and always exists, so a
    // `typeof window` check is not a valid SSR guard — probe the specific API instead
    // (Confluence SSR rule §2). Only run the benchmark when requestIdleCallback is
    // available: we never want to schedule the compute workload on a timer that could
    // fire while the main thread is busy. No fallback — if it's unavailable, the sample
    // is simply skipped.
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(callback, {
        timeout: $dc78d25e9ffa5ac9$var$IDLE_TIMEOUT_MS
    });
}


const $65f6d9e9d3e9996f$export$3def7672244bab0c = ()=>{
    const ssrTTRMark = performance?.getEntriesByName('CFP-63.ssr-ttr');
    if (!ssrTTRMark || !ssrTTRMark[0]) return undefined;
    // rounded to the nearest integer as the VC component log only uses integers as keys
    return Math.round(ssrTTRMark[0].startTime);
};
const $65f6d9e9d3e9996f$export$bf7408e83532dcd0 = ()=>{
    if (!window.__SSR_MEASURES__) return [];
    const ssrTimings = Object.keys(window.__SSR_MEASURES__).map((key)=>{
        return {
            label: key,
            data: window.__SSR_MEASURES__[key]
        };
    });
    return ssrTimings || [];
};


const $535b2ac93dbeac9a$export$4ace2d93f0a81ca0 = ()=>typeof window === 'undefined' ? 'na' : window.__SSR_STICKY_VERSION_STATE__ ?? 'na';


const $18160efac3c2d8a9$export$8f5840779a8ebb97 = (interaction, otherMetadataFromSessionData)=>{
    let fmpPatch = {};
    if (interaction.type === 'page_load') {
        Object.entries((0, $316168ab5c690743$export$9dbd6bda36500fa9)()).forEach(([key, value])=>{
            interaction.customTimings.push({
                labelStack: [],
                data: {
                    [key]: value
                }
            });
        });
        // In UFO realm, there's seemingly a bug causing `metric:fmp` to be populated in ~10-15%
        // of cases probably due to some race condition. Adding it here as a fallback until
        // investigation with #help-devinfra-fe-observability is completed.
        // Covered by ticket https://product-fabric.atlassian.net/browse/CCP-7117
        const fmpTime = (0, $65f6d9e9d3e9996f$export$3def7672244bab0c)();
        if (fmpTime) fmpPatch = {
            'metric:fmp': fmpTime
        };
    } else if (interaction.type === 'transition') {
        // For transitions, FMP is tracked via the UFOTransitionMarkFMP component which places
        // an 'fmp' custom mark on the interaction. We read the mark time and compute the
        // relative FMP as the offset from interaction start.
        const fmpMark = interaction.marks.find((mark)=>mark.type === 'custom' && mark.name === 'fmp');
        if (fmpMark) fmpPatch = {
            'metric:fmp': Math.round(fmpMark.time - interaction.start)
        };
    }
    const buildInfoData = (0, $eSuZj.getBuildInfo)();
    const buildInfo = {};
    if (buildInfoData) Object.keys(buildInfoData).forEach((item)=>{
        const newKey = `buildInfo:${item}`;
        buildInfo[newKey] = buildInfoData[item];
    });
    const data = {
        ...(0, $31b0fb0fb1951a4c$export$7908ff149a3cbadd)({
            stop: interaction.end,
            start: interaction.start,
            key: interaction.ufoName
        }),
        ...(0, $8476ac2738811490$export$30c543c9fd9ad97)({
            stop: interaction.end,
            start: interaction.start,
            key: interaction.ufoName
        }),
        ...(0, $894ba807f7f34abc$export$3f2fb183b6cd13c4)({
            stop: interaction.end,
            start: interaction.start,
            key: interaction.ufoName
        }),
        ...(0, $47229cc534a9628f$export$79c58f8fef22ebf2)(),
        ...buildInfo,
        ...otherMetadataFromSessionData,
        'stickyVersions:state': (0, $535b2ac93dbeac9a$export$4ace2d93f0a81ca0)(),
        postOfficeAssetsDisplayed: window.__PO_ASSET_DISPLAYED__,
        ...(interaction.type === 'page_load' || interaction.type === 'transition') && (0, $9wGTI.fg)('confluence_ufo_banner_extension_dimensions') ? (0, $7W9kD.getExtensionDimensions)() : {},
        // Client performance diagnostic covariates (cpuMs, softwareGL,
        // scriptStartAfterHtml). Initial load only — the signals explain
        // device/environment causes of a slow first load, not transitions.
        ...interaction.type === 'page_load' ? (0, $dc78d25e9ffa5ac9$export$7e2d586540f6b439)() : {}
    };
    return {
        ...fmpPatch,
        confluence: data
    };
};




var $7A3xy = parcelRequire("7A3xy");




function $9d8d828ea9fa0be5$export$29dd34cf1269f6da(traceId) {
    return !!traceId && /^[a-z0-9]+$/i.test(traceId) && traceId.length >= 16;
}
function $9d8d828ea9fa0be5$export$47cd5ebc723ead8d() {
    const traceId = window.__SSR_TRACE_ID__;
    const traceSampled = window.__SSR_TRACE_SAMPLED__;
    // Only enable trace propagation if the trace is sampled unless the gate disables this check.
    // Keep per-request unique traceIds for prod traffic until we have the x-request-id solution.
    // See: https://hello.atlassian.net/wiki/spaces/~71202065d425fcbfb345c9a5639940cc3845bb/pages/4187050054/Trace+Propagation+Across+an+Experience
    if (!traceSampled) {
        if (!(0, $9wGTI.fg)('confluence_disable_ufo_trace_sampling_check')) return;
    }
    const validTraceId = $9d8d828ea9fa0be5$export$29dd34cf1269f6da(traceId) ? traceId : undefined;
    const validSpanId = validTraceId ? validTraceId.substring(validTraceId.length - 16) : undefined;
    // If the traceId is invalid, we ignore it and don't set the trace context.
    // This would fallback to default behavior where trace context is not propagated.
    if (validTraceId && validSpanId) (0, $7A3xy.setActiveTrace)(validTraceId, validSpanId, '' /* trace type param is unused */ );
}


const $7d85b53d694de3c0$export$5fc9317dcf7889c3 = {
    sanitiseEndpoints: (url)=>url,
    mapResources: (url)=>url,
    hasTimingHeaders: (url)=>url.includes('graphql')
};


const $30ba73f8286a8f5a$export$69f5225124bf14a6 = {
    typingMethod: 'timeout',
    kind: {
        hover: 0,
        legacy: 0,
        typing: 0,
        press: 1,
        page_load: 1,
        transition: 1,
        generic: 0
    },
    rates: {
        unknown: 1000
    },
    removeInteractionsUFOPrefixes: true,
    enableEditorLnvHandler: true,
    autoGeneratedRate: 1000,
    rules: [],
    awaitBM3TTI: [],
    ufoNameOverrides: {},
    killswitch: [],
    segmentPrefix: 'ufo-',
    enabled: true,
    doNotAbortActivePressInteraction: [],
    doNotAbortActivePressInteractionOnTransition: [],
    enableCompleteUsingDoubleRAF: true,
    capability: {
        feature_flag_access: 1,
        react_profiler: 1
    },
    namePrefix: 'ufo-',
    removePageSegmentsUFOPrefixes: false
};
const $30ba73f8286a8f5a$var$getConfig = (configName)=>{
    try {
        return JSON.parse((0, $1xpoY.default).getString(configName, ''));
    } catch  {
        // TODO: AFO-4167: Change the fallback to be `{}` once we have a stable config for FedRamp environment
        return $30ba73f8286a8f5a$export$69f5225124bf14a6;
    }
};
function $30ba73f8286a8f5a$var$runConfigureSsrTiming() {
    (0, $e1XeN.configure)({
        getDoneMark: ()=>(0, $9eE57.getMark)('CFP-63.ssr-ttr') ?? null,
        // from confluence/next/packages/browser-metrics/src/initializeBrowserMetrics.ts
        // TODO: add correct functions to `getTimings` and `getFeatureFlags`
        getTimings: ()=>null,
        getFeatureFlags: ()=>null
    });
}
function $30ba73f8286a8f5a$export$6381c51f97ce9880({ shard: shard, cloudId: cloudId }) {
    const config = (0, $9wGTI.fg)('ufo-use-statsig-config-confluence-new') ? $30ba73f8286a8f5a$var$getConfig('confluence_ufo_config') : $30ba73f8286a8f5a$export$69f5225124bf14a6;
    if (!config?.enabled) return;
    (0, $hvG5K.configure)((0, $7d85b53d694de3c0$export$5fc9317dcf7889c3));
    (0, $127d9b8e16c6a735$export$a311cb1baa7d2d62)();
    $30ba73f8286a8f5a$var$runConfigureSsrTiming();
    (0, $9d8d828ea9fa0be5$export$47cd5ebc723ead8d)();
    const perfPushExperienceRates = {
        'view-page': 1,
        'edit-page': 1,
        'live-edit': 1,
        'space-overview': 1,
        'confluence-home': 1,
        'advanced-search': 1,
        'unified-search': 1,
        'embedded-view-page': 1,
        'embedded-live-edit': 1,
        'edit-page-embed': 1,
        'whiteboard-view-page': 1,
        'database-view-page': 1,
        'public-link-shared-page': 1,
        'folder-page': 1
    };
    const assetsConfig = {
        classification: {
            all: true,
            allAtlassian: ({ entry: entry })=>entry.name.includes('atl-paas.net/') || entry.name.includes('cloudfront') && entry.name.includes('batch.js'),
            preloaded: ({ entry: entry, SSRDoneTime: SSRDoneTime })=>Boolean(SSRDoneTime && entry.startTime <= SSRDoneTime)
        }
    };
    (0, $cRN1p.init)((0, $04e9M.getAnalyticsWebClient)(), {
        postInteractionLog: {
            enabled: true,
            rates: perfPushExperienceRates
        },
        extraInteractionMetrics: {
            enabled: true,
            rates: perfPushExperienceRates
        },
        enableSegmentHighlighting: false,
        enableAdditionalPerformanceMarks: false,
        shouldCalculateLighthouseMetricsFromTTAI: true,
        manuallyTrackReactProfilerMounts: true,
        product: 'confluence',
        population: (0, $1xpoY.default).getString('cc_ufo_group', 'unknown'),
        region: shard || 'unknown',
        ...config,
        getReactHydrationStats: $4f467cf502568ccb$export$2d8f8d64dc343d7b,
        // vc config must come after ...config spread to prevent the Statsig dynamic config
        // from overwriting locally-controlled settings (e.g. enabledVCRevisions).
        vc: {
            ...config?.vc,
            enabled: true,
            heatmapSize: 200,
            oldDomUpdates: false,
            selectorConfig: {
                id: false,
                role: false,
                className: true,
                testId: true
            },
            devToolsEnabled: (0, $1xpoY.default).isKillSwitchOn('confluence_enable_ttvc_devtool'),
            enabledVCRevisions: {
                all: (0, $9wGTI.fg)('ufo_disable_ttvc_v4') ? [] : [
                    'fy26.04'
                ]
            },
            includeSSRInV3: true,
            includeSSRRatio: true,
            trackLayoutShiftOffenders: false
        },
        minorInteractions: [
            'space-navigation-hover',
            'hover-page-card'
        ],
        ssr: {
            getSSRDoneTime: $65f6d9e9d3e9996f$export$3def7672244bab0c,
            getSSRTimings: $65f6d9e9d3e9996f$export$bf7408e83532dcd0
        },
        additionalPayloadData: (interaction)=>(0, $18160efac3c2d8a9$export$8f5840779a8ebb97)(interaction, {
                cloudId: cloudId,
                isShardPreProd: shard ? shard.startsWith('conf-prod-us-preprod') : false,
                layoutShiftWithAttribution: (0, $dc2c9e680a6dd356$export$36b44777ebe5656d)(interaction.ufoName, $30ba73f8286a8f5a$var$getConfig('confluence_cls_attribution_config'), {
                    start: interaction.start,
                    end: interaction.end,
                    type: interaction.type,
                    getCLS: ()=>(0, $8NKQ9.getPPSMetrics)(interaction)['metric:cls']
                })
            }),
        extraSearchPageInteraction: {
            enabled: true,
            searchPageMetricName: 'unified_search',
            searchPageRoute: '/wiki/search'
        },
        enableBetterPageVisibilityApi: true,
        assetsConfig: assetsConfig
    });
    // When client-side TTVC calculation is disabled, the __on_ufo_vc_debug_data_ready callback
    // is never called (no VC calculators run). Listen for UFO_FINISH_INTERACTION instead to
    // ensure __TTVC_READY__ is set and Apollo stats are still reported on interaction completion.
    if (typeof window !== 'undefined') window.addEventListener('UFO_FINISH_INTERACTION', ()=>{
        if (!(0, $9wGTI.fg)('ufo_disable_ttvc_v4')) return;
        $30ba73f8286a8f5a$var$reportApolloDiffStoreStats();
        // @ts-ignore
        window.__TTVC_READY__ = true;
    }, {
        once: true
    });
}
// Helper: report Apollo diffStore stats to monitoring
function $30ba73f8286a8f5a$var$reportApolloDiffStoreStats() {
    const apolloStats = window['__APOLLO_STATS__'];
    if (apolloStats?.diffStore) {
        const monitoringClient = (0, $5ZqQS.getMonitoringClient)();
        const entries = Object.entries(apolloStats?.diffStore).sort((a, b)=>b[1] - a[1]).slice(0, 10);
        for (const [query, value] of entries)// cc_fe_telemetry_apolloDiffStore in SFX
        monitoringClient.gauge(`apolloDiffStore`, value, [
            `query:${query}`
        ]);
    }
}
// UFO library invokes this callback once VC debug data is available.
// https://hello.atlassian.net/wiki/spaces/APD/pages/5398802024/RUNBOOK+Emitting+and+receiving+TTVC+debug+data+from+UFO
if (typeof window !== 'undefined') // @ts-ignore
window.__on_ufo_vc_debug_data_ready = function() {
    // When TTVC v4 client-side calculation is active (flag off), Apollo stats fire here.
    // When it's disabled (flag on), they fire via UFO_FINISH_INTERACTION instead.
    if (!(0, $9wGTI.fg)('ufo_disable_ttvc_v4')) $30ba73f8286a8f5a$var$reportApolloDiffStoreStats();
    // This is to inform external tools/tests that page finished loading and "performance measured" events were emitted.
    // @ts-ignore
    window.__TTVC_READY__ = true;
};



var $eFgM7 = parcelRequire("eFgM7");







function $e8bac4b2464d29b3$export$77f9905a9b9e760d(_sessionData) {
    (0, $eFgM7.init)({
        getAnalyticsWebClient: (0, $04e9M.getAnalyticsWebClient)(),
        experiences: {
            'edit-page': {
                enabled: true
            },
            'live-edit': {
                enabled: true
            }
        },
        population: (0, $1xpoY.default).getString('cc_ufo_group', 'unknown')
    });
}






var $cXtTj = parcelRequire("cXtTj");


var $8RwKN = parcelRequire("8RwKN");




















var $hpjl4 = parcelRequire("hpjl4");

const $b48399af2cf0b1aa$export$1a2bb347935fc536 = {
    mapPerformanceMark: (mark)=>{
        if (mark.endsWith((0, $hpjl4.JS_LOAD_START))) return {
            name: mark.substring(0, mark.indexOf((0, $hpjl4.JS_LOAD_START))),
            type: 'start'
        };
        if (mark.endsWith((0, $hpjl4.JS_LOAD_END))) return {
            name: mark.substring(0, mark.indexOf((0, $hpjl4.JS_LOAD_END))),
            type: 'end'
        };
        return null;
    }
};



var $lCTbz = parcelRequire("lCTbz");




// used for page-load and page-segment-load events
const $a7aad5d0a1d87072$export$eb13033bc77c7e96 = [
    'confluence.ssr.page-statuses',
    'confluence_react_streaming',
    'nav4_confluence_global_links',
    'confluence_use_atlaspack',
    'confluence_use_atlaspack_variant_1',
    'confluence_use_atlaspack_variant_2',
    'confluence_frontend_statlas_redirect',
    'confluence_use_react-compiler',
    'confluence_ssr_cookie_banner_black_space',
    'cc_mohiti_restricted_content_screen_ab_exp',
    'cc_perms_ga_access_requests'
];
const $a7aad5d0a1d87072$export$e669174961337a38 = [];



var $78QFu = parcelRequire("78QFu");

const $105e628ab69b7692$export$fc6227831ee7c7 = (start, stop, buffer)=>{
    const clsData = {
        score: 0,
        nodeCounts: {}
    };
    const allLayoutShifts = buffer.getAll();
    const layoutShifts = allLayoutShifts.filter(// Filter for layoutShifts within start and stop time and if entry had no recent user input (which can cause CLS)
    (entry)=>entry.startTime >= start && entry.startTime <= stop && !entry.hadRecentInput);
    const sessionWindows = [];
    let currentWindow = null;
    // Record CLS offenderes by node type
    layoutShifts.forEach((layoutShift)=>{
        layoutShift.sources.forEach((source)=>{
            const { node: node } = source;
            const nodeKey = `${node?.localName || '-'}(:)${node?.className || '-'}`;
            const count = clsData.nodeCounts[nodeKey];
            if (count > 0) clsData.nodeCounts[nodeKey] += 1;
            else clsData.nodeCounts[nodeKey] = 1;
        });
    });
    // Group layout shifts into session windows and calculate score
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric rounded to 4 decimal places
    clsData.score = Math.round(maxScore * 10000) / 10000;
    return clsData;
};


const $f69af1ee3d00be57$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
const $f69af1ee3d00be57$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter(// filter entries that are long tasks (greater than MAX_ACCEPTABLE_TASK_DURATION)
    // and overlap with the start and stop window in any way
    (entry)=>entry.startTime <= stop && entry.duration > $f69af1ee3d00be57$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $f69af1ee3d00be57$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // accumulate observed tbt even when the entry's duration is outside the stop window
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $f69af1ee3d00be57$var$MAX_ACCEPTABLE_TASK_DURATION;
        // accumulate total tbt within start and stop window
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });


const $35573fd923792093$export$f878c419d6dfad3e = 10;
const $35573fd923792093$var$getEstimatedP98LongestInteraction = (interactionEvents)=>{
    const sortedInteractions = [
        ...interactionEvents
    ].sort((a, b)=>b.duration - a.duration);
    sortedInteractions.splice($35573fd923792093$export$f878c419d6dfad3e);
    // If we have an usually high number of interactions,
    // ignore the longest interaction and take the next one.
    // https://web.dev/articles/inp#what-is-inp -> "Details on how INP is calculated"
    const p98Index = Math.min(sortedInteractions.length - 1, Math.floor(interactionEvents.length / 50));
    return {
        p98: sortedInteractions[p98Index],
        interactionCount: sortedInteractions.length
    };
};
const $35573fd923792093$export$6693a9916ea977ef = (start, stop, buffer)=>{
    const inpData = {
        score: 0,
        interactionCounts: {}
    };
    const allEvents = buffer.getAll();
    const interactionEvents = allEvents.filter((entry)=>entry.startTime >= start && entry.startTime <= stop && entry.entryType !== 'first-input' && //@ts-ignore for some reason our Typecheck says this property doesn't exist but its in the reference https://developer.mozilla.org/en-US/docs/Web/API/PerformanceEventTiming
        entry.interactionId);
    if (interactionEvents.length) {
        const { p98: p98, interactionCount: interactionCount } = $35573fd923792093$var$getEstimatedP98LongestInteraction(interactionEvents);
        inpData.score = p98.duration;
        inpData.interactionCounts = interactionCount;
    }
    return inpData;
};








// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 




const $6947188617eea69c$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
const $6947188617eea69c$export$b7f047fd73089148 = (start, stop, buffer)=>buffer.getAll().filter(// filter entries that are long tasks (greater than MAX_ACCEPTABLE_TASK_DURATION)
    (entry)=>entry.duration > $6947188617eea69c$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((longTaskTiming, entry)=>{
        longTaskTiming += entry.duration - $6947188617eea69c$var$MAX_ACCEPTABLE_TASK_DURATION;
        return longTaskTiming;
    }, 0);






var $eDAGu = parcelRequire("eDAGu");

const $21a76cadeda71c1e$export$1391212d75b2ee65 = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $21a76cadeda71c1e$export$b46cecdf698e4bb5 = async ({ start: start, stop: stop })=>{
    // PerformanceObserver is not deterministic in reporting entries, so a 500ms delay is needed
    // 500ms was tested in Jira and it captured enough data without causing a volume drop in reported events
    await $21a76cadeda71c1e$export$1391212d75b2ee65(500);
    const tbt = (0, $f69af1ee3d00be57$export$2d6e933b35bd3407)(start, stop, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $105e628ab69b7692$export$fc6227831ee7c7)(start, stop, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LayoutShift]);
    const longTaskTiming = (0, $6947188617eea69c$export$b7f047fd73089148)(start, stop, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LongTask]);
    const metrics = {
        'metric:tbt': Math.round(tbt.total),
        // sum of blocking time for long tasks within the 'start' and 'stop' time
        'metric:tbt:observed': Math.round(tbt.observed),
        // sum of blocking time for long tasks that might end beyond the 'stop' time
        'metric:cls': cls.score,
        'metric:clsNodeCounts': cls.nodeCounts,
        'metric:longTaskTiming': Math.round(longTaskTiming)
    };
    return metrics;
};


const $834cc9c1e99eabd0$var$EXTEND_STOP_TIME_MS = 8000;
const $834cc9c1e99eabd0$export$d4724968c3d7ea5 = async ({ start: start, stop: stop })=>{
    const webVitalsAttributes = {
        uuid: (0, $78QFu.getUniquePageLoadId)().uuid ?? ''
    };
    // wait for 8 seconds to calculate CLS to account for macros causing page layout shifts
    await (0, $21a76cadeda71c1e$export$1391212d75b2ee65)($834cc9c1e99eabd0$var$EXTEND_STOP_TIME_MS);
    const cls = (0, $105e628ab69b7692$export$fc6227831ee7c7)(start, stop + $834cc9c1e99eabd0$var$EXTEND_STOP_TIME_MS, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LayoutShift]);
    // for slow pages, TTI is marked too early which causes TBT numbers to be inaccurate so we extend the stop time
    const tbt = (0, $f69af1ee3d00be57$export$2d6e933b35bd3407)(start, stop + $834cc9c1e99eabd0$var$EXTEND_STOP_TIME_MS, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LongTask]);
    const inp = (0, $35573fd923792093$export$6693a9916ea977ef)(start, stop + $834cc9c1e99eabd0$var$EXTEND_STOP_TIME_MS, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).Event]);
    webVitalsAttributes['metric:inpForInitialLoad'] = inp.score;
    webVitalsAttributes['metric:clsForInitialLoad'] = cls.score;
    webVitalsAttributes['metric:clsOffendersForInitialLoad'] = cls.nodeCounts;
    webVitalsAttributes['metric:tbtForInitialLoad'] = Math.round(tbt.total); // sum of blocking time for long tasks within the 'start' and 'stop' time
    return webVitalsAttributes;
};





const $eaeb1ca3a97f458a$export$e3f9d1444e2c5f5d = (sessionData)=>{
    const { cloudId: cloudId, environment: environment, shard: shard } = sessionData;
    const plugins = [];
    plugins.push((0, $21a76cadeda71c1e$export$b46cecdf698e4bb5));
    /**
	 * https://product-fabric.atlassian.net/browse/CCP-1320
	 * Remove unused attributes in page-segment-load event
	 */ const buildInfo = (0, $8b39c089fbdae2d5$export$96934690d8345a62)({
        buildInfo: (0, $eSuZj.getBuildInfo)()
    });
    /**
	 * Data to be added to all events.
	 */ const allEventConfig = {
        custom: (0, $8b39c089fbdae2d5$export$96934690d8345a62)({
            cloudId: cloudId,
            environment: environment,
            shard: shard,
            ssr: Boolean(window.__SSR_RENDERED__)
        }),
        featureFlags: (0, $a7aad5d0a1d87072$export$e669174961337a38),
        sfxEvents: {
            activeTab: (0, $lCTbz.PageVisibleFields).pageVisibleState
        },
        plugins: plugins
    };
    /**
	 * Data to be added to only page-load events.
	 */ const pageLoadEventConfig = {
        custom: buildInfo,
        plugins: [
            (0, $31b0fb0fb1951a4c$export$7908ff149a3cbadd),
            (0, $47229cc534a9628f$export$79c58f8fef22ebf2),
            (0, $894ba807f7f34abc$export$3f2fb183b6cd13c4)
        ],
        histogram: {
            initial: {
                fmp: '1000_2000_2500_3000_4000_5000',
                tti: '2000_2500_3000_3500_4000_5000_6000'
            },
            transition: {
                fmp: '500_1000_1500_2000_2500_3000',
                tti: '1000_1500_2000_2500_3000_4000'
            }
        },
        // page-load type event will include allEventConfig.featureFlags + the following list.
        featureFlags: (0, $a7aad5d0a1d87072$export$eb13033bc77c7e96)
    };
    /**
	 * Data to be added to only custom events.
	 */ const pageSegmentLoadEventConfig = {
        plugins: [
            (0, $8476ac2738811490$export$30c543c9fd9ad97),
            (0, $47229cc534a9628f$export$79c58f8fef22ebf2)
        ],
        histogram: {
            initial: {
                fmp: '1000_2000_2500_3000_4000_5000',
                tti: '2000_2500_3000_3500_4000_5000_6000'
            },
            transition: {
                fmp: '500_1000_1500_2000_2500_3000',
                tti: '1000_1500_2000_2500_3000_4000'
            }
        },
        // page-segment-load type event will include allEventConfig.featureFlags + the following list.
        featureFlags: (0, $a7aad5d0a1d87072$export$eb13033bc77c7e96),
        enableBundleEvalTimings: false
    };
    const customEventConfig = {
        custom: buildInfo,
        plugins: [
            (0, $8476ac2738811490$export$30c543c9fd9ad97)
        ]
    };
    const webVitalsConfig = {
        custom: buildInfo,
        enabled: true,
        plugins: [
            (0, $834cc9c1e99eabd0$export$d4724968c3d7ea5)
        ],
        // Undefined timeout defaults to 30000ms, increasing timeout here on Cypress tests to prevent flakiness.
        timeout: window?.Cypress ? undefined : 10000,
        ttciEnabled: false,
        featureFlags: (0, $a7aad5d0a1d87072$export$eb13033bc77c7e96)
    };
    return {
        all: allEventConfig,
        [(0, $lCTbz.BMEventsType).PAGE_LOAD]: pageLoadEventConfig,
        [(0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD]: pageSegmentLoadEventConfig,
        [(0, $lCTbz.BMEventsType).CUSTOM]: customEventConfig,
        [(0, $lCTbz.BMEventsType).WEB_VITALS]: webVitalsConfig
    };
};





let $ae045ed661bc53ec$var$isBrowserMetricsInitialized = false;
const $ae045ed661bc53ec$var$logger = (0, $7W8i8.getLogger)('initializeBrowserMetrics');
const $ae045ed661bc53ec$var$criticalAssetsList = [
    'app',
    'atl',
    'runtime',
    'vendors',
    'ssr-scripts',
    'stable_vendors',
    'query-preloader',
    'browser-not-supported'
];
function $ae045ed661bc53ec$var$mapResources(url) {
    return $ae045ed661bc53ec$var$criticalAssetsList.find((asset)=>url.includes(`/${asset}.`)) || 'ignored';
}

const $ae045ed661bc53ec$export$efcab8bd082cbc1f = (sessionData)=>{
    if (!$ae045ed661bc53ec$var$isBrowserMetricsInitialized) {
        const { shard: shard } = sessionData;
        const getAnalyticsWebClientPromise = (0, $04e9M.getAnalyticsWebClient)();
        const product = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)() ? 'embeddedConfluence' : 'confluence';
        (parcelRequire("cG9jM")).then((ufo)=>ufo.setup(sessionData, getAnalyticsWebClientPromise)).catch((error)=>{
            $ae045ed661bc53ec$var$logger.error`Fail to import UFO client: ${error}`;
        });
        (0, $eDAGu.startLightHouseObservers)();
        (0, $8RwKN.browserMetrics).init({
            info: {
                app: {
                    framework: {
                        name: 'react',
                        version: (0, $cozmU.version)
                    },
                    version: {
                        web: (0, $eSuZj.getBuildInfo)().FRONTEND_VERSION,
                        ssr: window.__SSR_BUILD__
                    }
                },
                hostname: window.location.hostname,
                product: product,
                population: (0, $1xpoY.default).getString('cc_ufo_group', 'unknown'),
                region: shard
            },
            plugins: {
                featureFlags: {
                    client: Promise.resolve({
                        getValue: (featureFlagKey)=>{
                            // Using `FeatureGates.checkGate` here to avoid triggering exposure tracking
                            // eslint-disable-next-line confluence-feature-gating/use-recommended-utils
                            return (0, $cXtTj.default).checkGate(featureFlagKey);
                        }
                    })
                },
                resourceTimings: {
                    mapResources: $ae045ed661bc53ec$var$mapResources,
                    // Not interested in fetch requests as we have already marked wf/
                    sanitiseEndpoints: ()=>'ignored'
                },
                bundleEvalTimings: $b48399af2cf0b1aa$export$1a2bb347935fc536
            },
            endpoints: {
                eventPipelineClient: getAnalyticsWebClientPromise
            },
            events: (0, $eaeb1ca3a97f458a$export$e3f9d1444e2c5f5d)(sessionData),
            ssr: {
                getDoneMark: ()=>(0, $9eE57.getMark)('CFP-63.ssr-ttr') ?? null,
                getTimings: ()=>window.__SSR_MEASURES__ || {}
            },
            enableReactUFOTracker: true
        });
        $ae045ed661bc53ec$var$isBrowserMetricsInitialized = true;
    }
};



var $KcDWk = parcelRequire("KcDWk");


var $fcgrS = parcelRequire("fcgrS");


var $iC5L0 = parcelRequire("iC5L0");


var $hp2SH = parcelRequire("hp2SH");


var $eHj6r = parcelRequire("eHj6r");

function $ca1d37ec2e96c685$export$c25b3a02c2d5dc72() {
    return 0, $eHj6r.apolloCache;
}



var $gKr8t = parcelRequire("gKr8t");



function $0b6b84530a4d34b5$export$b4a2d416bf2548b() {
    return 0, $gKr8t.apolloAGGCache;
}



var $9HB34 = parcelRequire("9HB34");


var $ezH4I = parcelRequire("ezH4I");

var $3GQl6 = parcelRequire("3GQl6");


var $hZpML = parcelRequire("hZpML");





var $cMvQV = parcelRequire("cMvQV");


var $9j59h = parcelRequire("9j59h");




var $lTjel = parcelRequire("lTjel");









/* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */ 


const $db1172108b431747$export$bc237d627614fc48 = `!function(e,t){const n=t.__SSR_INTERACTIONS__={},i=t.__SSR_INTERACTIONS_DURATIONS__={},o=t.__SSR_EVENT_LISTENERS__=[];Array.from(e.getElementsByClassName("ssrMouseEvent")).forEach((t=>{t.previousSibling&&((t,s)=>{if(!t||!s)return;const r=e=>{if(!e)return!1;if(e.disabled)return!0;let t=!1;for(let n=0;n<e.childNodes.length;n++)if(r(e.childNodes[n])){t=!0;break}return t};if(r(t)){var c;const n=e.createElement("div");n.style.cssText="display: inline-block; position: relative;",n.setAttribute("data-testid","".concat(s,"_CLICK_CONTAINER"));const i=e.createElement("div");i.style.cssText="content: ''; position: absolute; top: 0; left: 0; bottom: 0; right: 0;",i.setAttribute("data-testid","".concat(s,"_CLICK_AREA")),null===(c=t.parentElement)||void 0===c||c.replaceChild(n,t),n.append(t),n.append(i),t=i}const a=e=>{n[e]=!0,i[e]=[...i[e]||[],performance.now()]};let l,d=!1;const u=()=>{a("".concat(s,"_CLICK"))},_=()=>{d=!0,l=setTimeout((function(){d&&(a("".concat(s,"_HOVER")),d=!1)}),100)},E=()=>{l&&clearTimeout(l),d=!1};t.addEventListener("click",u,!0),t.addEventListener("mouseenter",_),t.addEventListener("mouseleave",E),o.push([t,"click",u,!0]),o.push([t,"mouseenter",_,void 0]),o.push([t,"mouseleave",E,void 0])})(t.previousSibling,t.value)}))}(document,window);`;


const $c07037197fae7cb7$export$a6f691eaa46471c3 = ()=>{
    const nonceValue = window.__SSR_NONCE_VALUE__;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("script", {
        ...nonceValue !== undefined ? {
            nonce: nonceValue
        } : {},
        dangerouslySetInnerHTML: {
            __html: `if(window["__SSR_RENDERED__"]){${(0, $db1172108b431747$export$bc237d627614fc48)}}`
        }
    });
};



var $bDgLe = parcelRequire("bDgLe");










const $ab36569cbfed18a7$export$857c9d19bfa05cb5 = (t0)=>{
    const $ = (0, $bDgLe.c)(1);
    if (!window.__SSR_INLINE_COMMENT_MARKS__ || window.__SSR_INLINE_COMMENT_MARKS__ && window.__SSR_INLINE_COMMENT_MARKS__.length < 1) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            id: "inline-comments-script",
            "data-testid": "inline-comments-script",
            "data-marks": window.__SSR_INLINE_COMMENT_MARKS__,
            "data-focused": window.__SSR_FOCUSED_INLINE_COMMENTS__
        });
        $[0] = t1;
    } else t1 = $[0];
    return t1;
};


const $2eff8a40a60fa79f$export$708921e5c63e07ae = (t0)=>{
    const $ = (0, $bDgLe.c)(1);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ab36569cbfed18a7$export$857c9d19bfa05cb5), null);
        $[0] = t1;
    } else t1 = $[0];
    return t1;
};








function $a6e2c333ce8dee1c$export$d2cb5cf8969d339e() {
    const script = `window.performance.mark("${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_FORCE_LAYOUT}.start");` + // Accessing clientHeight causes the browser to perform a synchronous layout recalculation.
    // While this doesn't directly trigger a "paint" operation, it increases the likelihood of one
    // occurring shortly afterward. This means it is less likely that users will see a partially
    // painted screen while the browser processes imported JavaScript modules.
    `window.document.documentElement.clientHeight;` + `window.performance.mark("${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_FORCE_LAYOUT}.end")`;
    const nonceValue = window.__SSR_NONCE_VALUE__;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("script", {
        ...nonceValue !== undefined ? {
            nonce: nonceValue
        } : {},
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: script
        }
    });
}


const $8714b2bec379cfae$export$bd148a921cde8da1 = ()=>{
    const nonceValue = window.__SSR_NONCE_VALUE__;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6e2c333ce8dee1c$export$d2cb5cf8969d339e), null), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SSR_SCRIPTS}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c07037197fae7cb7$export$a6f691eaa46471c3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2eff8a40a60fa79f$export$708921e5c63e07ae), null), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SSR_SCRIPTS}.end`), !window.__SSR_REACT_STREAMING__ && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("script", {
        ...nonceValue !== undefined ? {
            nonce: nonceValue
        } : {},
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            // Suppress error when performance API failed.
            // Note: in MicrosoftEdge version 18 and prior, performance.measure(name, startMark, endMark) API will throw SyntaxError if startMark is undefined.
            // That's why wrap with try catch statement.
            __html: 'if(window["__SSR_RENDERED__"]){try{window.performance.mark("CFP-63.ssr-ttr");window.performance.measure("browser-metric:fmp",undefined,"CFP-63.ssr-ttr")}catch(e){}}'
        }
    }));
};







/* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */ 



var $iDrrr = parcelRequire("iDrrr");

const $08436a2f9d11149e$export$cc97c2566f53fd12 = 'data-scrollbar-harmonisation';
const $08436a2f9d11149e$export$61a626af8f32e59e = 'data-scrollbar-harmonisation-transparent';


function $50800b842657c8fb$export$879bd7480c95c3a0(isEnabled) {
    const isGateEnabled = (0, $iDrrr.fg)('platform_dst_scrollbar_harmonisation');
    const shouldEnable = isEnabled ?? isGateEnabled;
    if (!shouldEnable) return {};
    const result = {
        [(0, $08436a2f9d11149e$export$cc97c2566f53fd12)]: ''
    };
    const isTransparentTrackGateEnabled = (0, $iDrrr.fg)('platform_dst_scrollbar_harmonisation_transparent');
    if (isGateEnabled && isTransparentTrackGateEnabled) result[0, $08436a2f9d11149e$export$61a626af8f32e59e] = '';
    return result;
}
var $50800b842657c8fb$export$2e2bcd8739ae039 = $50800b842657c8fb$export$879bd7480c95c3a0;






var $koUFz = parcelRequire("koUFz");


var $9eS5w = parcelRequire("9eS5w");

const $932b9916adc5c98b$export$e628ea48b560f375 = (colorMode, contrastMode)=>{
    if (colorMode !== 'auto' && contrastMode !== 'auto') return undefined;
    const setColorMode = colorMode === 'auto' ? `\n  try {
    const darkModeMql = window.matchMedia('${0, $9eS5w.darkModeMediaQuery}');
    const colorMode = darkModeMql.matches ? 'dark' : 'light';
    document.documentElement.setAttribute('${0, $koUFz.COLOR_MODE_ATTRIBUTE}', colorMode);
  } catch (e) {}` : '';
    const setContrastMode = contrastMode === 'auto' && (0, $iDrrr.fg)('platform_increased-contrast-themes') ? `\n  try {
    const contrastModeMql = window.matchMedia('${0, $9eS5w.moreContrastMediaQuery}');
    const contrastMode = contrastModeMql.matches ? 'more' : 'no-preference';
    document.documentElement.setAttribute('${0, $koUFz.CONTRAST_MODE_ATTRIBUTE}', contrastMode);
  } catch (e) {}` : '';
    return `(() => {${setColorMode}${setContrastMode}})()`;
};
var $932b9916adc5c98b$export$2e2bcd8739ae039 = $932b9916adc5c98b$export$e628ea48b560f375;



var $9gVcL = parcelRequire("9gVcL");


var $8BCWr = parcelRequire("8BCWr");


var $58u2L = parcelRequire("58u2L");

class $60061fec709c0fa4$export$f9bc2ffe605f0ec0 {
    setThemeStateBasedOnSavedThemeState(theme) {
        // If theme is undefined, no reason to set that in themeState as it's not actually a theme (just Original)
        if (theme) this.themeState = {
            ...this.getThemeState(),
            ...theme,
            typography: 'typography'
        };
    }
    getThemeState() {
        return this.themeState;
    }
    async getThemeStylesScript() {
        // Generates an array of styles
        if (this.getThemeState().colorMode) {
            const modifiedThemeState = {
                ...this.getThemeState(),
                typography: 'typography'
            };
            const themeStyles = await (0, $9gVcL.getThemeStyles)(modifiedThemeState);
            // Add a stylesheet for each theme being used
            return themeStyles.map((theme)=>{
                const attributes = Object.entries(theme.attrs).map(([key, value])=>`${key}="${value}"`);
                return `<style ${attributes}>${theme.css}</style>`;
            }).join('');
        } else return '';
    }
    getSSRAutoColorModeScript() {
        // Creates and returns the script used to set the html attributes if the user choose 'auto'
        const currentColorMode = this.getThemeState().colorMode;
        if (currentColorMode === 'auto') {
            const nonceValue = window.__SSR_NONCE_VALUE__;
            const scriptContent = (0, $932b9916adc5c98b$export$e628ea48b560f375)(currentColorMode);
            return nonceValue !== undefined ? `<script nonce="${nonceValue}">${scriptContent}</script>` : `<script>${scriptContent}</script>`;
        } else return '';
    }
    getThemeHtmlAttrsScript({ forceAuto: forceAuto = false } = {}) {
        // Simple script to add theme attributes to HTML tag based on users codeMode selection
        const currentThemeState = this.getThemeState();
        if (currentThemeState.colorMode) {
            const themeAttrs = (0, $8BCWr.getThemeHtmlAttrs)(currentThemeState);
            if (currentThemeState.colorMode === 'auto' || forceAuto) /*
               If the colorMode is auto, we don't want to just default to "light" because if the user's
               browser setting is "dark", this would set the "data-color-mode" to "light" and then set
               again with "dark" with the script from getSSRAutoColorModeScript(). Removing the "data-color-mode"
               setAttribute for "auto" makes sure that it is only set once by the getSSRAutoColorModeScript()
             */ delete themeAttrs['data-color-mode'];
            const attributeSetters = Object.entries(themeAttrs).map(([attr, value])=>`document?.documentElement?.setAttribute("${attr}", "${value}");`).join('');
            return `try { ${attributeSetters} } catch (e) {}`;
        } else return '';
    }
    getScrollbarHarmonisationHtmlAttrsScript() {
        // Simple script to add scrollbar harmonisation attributes to the HTML tag based on the gate
        const scrollbarAttrs = (0, $50800b842657c8fb$export$879bd7480c95c3a0)();
        if (Object.keys(scrollbarAttrs).length === 0) return '';
        const attributeSetters = Object.entries(scrollbarAttrs).map(([attr, value])=>`document?.documentElement?.setAttribute("${attr}", "${value}");`).join('');
        return `try { ${attributeSetters} } catch (e) {}`;
    }
    constructor(){
        this.themeState = void 0;
        // If colorMode doesn't get set, you don't want to return anything
        this.themeState = (0, $58u2L.getDefaultTheme)();
    }
}


const $cad415a4c0599362$export$fd920a796bc0c5e = new (0, $60061fec709c0fa4$export$f9bc2ffe605f0ec0)();



var $bj5fB = parcelRequire("bj5fB");

const $ef8ede6c338f8be6$export$6838ff380832204f = ({ uri: uri })=>{
    const nonceValue = window.__SSR_NONCE_VALUE__;
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)(uri);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("script", {
        ...nonceValue !== undefined ? {
            nonce: nonceValue
        } : {},
        dangerouslySetInnerHTML: {
            __html: `if(window["__SSR_RENDERED__"]){${(0, $cad415a4c0599362$export$fd920a796bc0c5e).getThemeHtmlAttrsScript({
                forceAuto: isMobileApp
            })}${(0, $cad415a4c0599362$export$fd920a796bc0c5e).getScrollbarHarmonisationHtmlAttrsScript()}}`
        }
    });
};


const $d847caf3274d14b7$export$f3385cdc6645f7e3 = ({ uri: uri })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_THEME_INIT}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ef8ede6c338f8be6$export$6838ff380832204f), {
        uri: uri
    }), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_THEME_INIT}.end`));







const $799291abed68198f$export$640957ec8f6fdf34 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_REACT_ROOT}.start`), children, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_REACT_ROOT}.end`));
};


// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $irVI7 = parcelRequire("irVI7");


var $dYU3e = parcelRequire("dYU3e");


var $emNvf = parcelRequire("emNvf");

function $c63485f681d81d31$export$693b572d94b96722() {
    return (0, $dYU3e.query)({
        query: (0, $emNvf.default),
        __callerPackage__: "page-layout"
    });
}



var $lyWac = parcelRequire("lyWac");


var $xwvlW = parcelRequire("xwvlW");








var $bPDOf = parcelRequire("bPDOf");


var $8Z78B = parcelRequire("8Z78B");

const $07b476ef513689d8$export$e5077e9c81abf107 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: Object.values((0, $bPDOf.AIFC_ONBOARDING_STATE_KEYS))
        },
        __callerPackage__: "onboarding-helpers"
    });
};



var $hAiCi = parcelRequire("hAiCi");





var $74VX5 = parcelRequire("74VX5");

const $b7ee762a3100e127$export$18585825cd8ca022 = ()=>{
    return (0, $dYU3e.queryAgg)({
        query: (0, $74VX5.default),
        __callerPackage__: "app-navigation"
    });
};


async function $a6a4fe9083f3db22$export$d46e9819bcc1eb51() {
    const { userId: userId } = (0, $xwvlW.getPreloaderFnContext)();
    const topNavigationPromises = [
        (0, $dYU3e.query)({
            query: (0, $hAiCi.default),
            __callerPackage__: "app-navigation"
        })
    ];
    topNavigationPromises.push((0, $07b476ef513689d8$export$e5077e9c81abf107)());
    if (userId) topNavigationPromises.push((0, $b7ee762a3100e127$export$18585825cd8ca022)());
    return (0, $lyWac.waitForAllReturnWhenError)(topNavigationPromises);
}


function $1d20c0a68123b7f2$export$2d0f6d5aa0911699() {
    return (0, $a6a4fe9083f3db22$export$d46e9819bcc1eb51)();
}









/**
 * @generated SignedSource<<4578650f7a6fe4e1474f11e8181e051b>>
 * @relayHash 21354ce056af321d3c9a22d041061cbd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 995f0038c2de9764a22d6b1084f25ff437d0af79bc8d777102ec6b571d9ec00a
const $c79c1229f6775c21$var$node = function() {
    var v0 = [
        {
            "concreteType": "SiteOperations",
            "kind": "LinkedField",
            "name": "siteOperations",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "userProfile"
                },
                {
                    "kind": "ScalarField",
                    "name": "application"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "preloadOperationsQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "preloadOperationsQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "21354ce056af321d3c9a22d041061cbd",
            "id": "995f0038c2de9764a22d6b1084f25ff437d0af79bc8d777102ec6b571d9ec00a",
            "metadata": {},
            "name": "preloadOperationsQuery",
            "operationKind": "query",
            "text": "query preloadOperationsQuery{siteOperations{userProfile,application}}"
        }
    };
}();
$c79c1229f6775c21$var$node.hash = "abad04e66f2fedacc515f8a26b1558e3";
var $c79c1229f6775c21$export$2e2bcd8739ae039 = $c79c1229f6775c21$var$node;


async function $969a3e14c27be3bd$export$9930aa21f1e6a4e3() {
    const { userId: userId } = (0, $xwvlW.getPreloaderFnContext)();
    if (!userId) return;
    return (0, $dYU3e.query)({
        query: (0, $c79c1229f6775c21$export$2e2bcd8739ae039),
        __callerPackage__: "site-operations"
    });
}



var $eiCiP = parcelRequire("eiCiP");


var $9fLxI = parcelRequire("9fLxI");





var $eqB7W = parcelRequire("eqB7W");


var $b1ypt = parcelRequire("b1ypt");

function $88b2ba3b9422ec6a$export$3837c35a0d92ab93() {
    const macroParams = window['__LEGACY_MACRO_PARAMS__'] || [];
    window['__LEGACY_MACRO_PARAMS__'] = [];
    // eslint-disable-next-line check-preloaders/no-promise-all
    return Promise.all(macroParams.map(({ isMacroContentAndBody: isMacroContentAndBody, ...rest })=>{
        return isMacroContentAndBody ? (0, $dYU3e.query)({
            query: (0, $eqB7W.default),
            variables: rest,
            context: {
                single: true
            },
            __callerPackage__: "fabric-extension-handlers"
        }) : (0, $dYU3e.query)({
            query: (0, $b1ypt.default),
            variables: rest,
            context: {
                single: true
            },
            __callerPackage__: "fabric-extension-handlers"
        });
    }));
}






var $iHLZT = parcelRequire("iHLZT");


var $l6Xaz = parcelRequire("l6Xaz");


var $d1d56 = parcelRequire("d1d56");

async function $821e100427ee88aa$export$ce64f7b5556cdb62({ preloadSuperBatchForSSR: preloadSuperBatchForSSR = false } = {}) {
    if (preloadSuperBatchForSSR) {
        const superbatchData = await (0, $dYU3e.query)({
            query: (0, $d1d56.default),
            __callerPackage__: "wrm"
        });
        const resourceList = superbatchData?.data?.internalFrontendResource?.resourceList || [];
        const { js: js, css: css } = resourceList.reduce((acc, resource)=>{
            const html = (0, $l6Xaz.convertSuperBatchResourceToTags)(resource);
            acc[resource.type].push(html);
            return acc;
        }, {
            js: [],
            css: []
        });
        (0, $iHLZT.superbatchJSRecorder).add((0, $l6Xaz.removeJquery)(js.join('\n')));
        (0, $iHLZT.superbatchCSSRecorder).add(css.join('\n'));
    } else if (!window.__SUPERBATCH_REQUESTED__) return (0, $dYU3e.query)({
        query: (0, $d1d56.default),
        __callerPackage__: "wrm"
    });
    return Promise.resolve();
}



var $fkeeB = parcelRequire("fkeeB");


var $8SjBl = parcelRequire("8SjBl");


var $9WAeG = parcelRequire("9WAeG");


var $f7B1p = parcelRequire("f7B1p");


var $3mugH = parcelRequire("3mugH");


var $d6NtA = parcelRequire("d6NtA");


var $60cDW = parcelRequire("60cDW");


var $cgNzK = parcelRequire("cgNzK");

const $29df517881fdeca7$export$c2d188ccf9271ffd = 'CookiePreferencesQuery';
const $29df517881fdeca7$var$preloadCookiePreferencesForBanner = async ()=>{
    if (window.__COOKIE_CONSENT_PREFERENCES__) return window.__COOKIE_CONSENT_PREFERENCES__;
    const { cookiesConsentToken: cookiesConsentToken, cookiesFallbackToken: cookiesFallbackToken, userId: userId, perimeter: perimeter, isBifrostIcRequest: isBifrostIcRequest, environment: environment } = (0, $60cDW.getSSRRenderInputs)();
    // If the consent token cookie exists (user has already set their preferences), there is no need to
    // fetch the preferences from ConsentHub.
    if (cookiesConsentToken) {
        window.__COOKIE_CONSENT_PREFERENCES__ = {
            consentToken: cookiesConsentToken,
            ...cookiesFallbackToken ? {
                fallbackConsentToken: cookiesFallbackToken
            } : {}
        };
        return window.__COOKIE_CONSENT_PREFERENCES__;
    }
    if (!userId) {
        // For anonymous users, if only the fallback token exists (the primary consent token has
        // expired but the long-lived fallback is still present), include the fallback as a consent
        // signal so that SSR and client hydration make consistent banner visibility decisions.
        const anonymousConsentToken = (0, $8SjBl.serializeConsents)({});
        if (!anonymousConsentToken && !cookiesFallbackToken) {
            window.__COOKIE_CONSENT_PREFERENCES__ = null;
            return window.__COOKIE_CONSENT_PREFERENCES__;
        }
        window.__COOKIE_CONSENT_PREFERENCES__ = {
            ...anonymousConsentToken ? {
                consentToken: anonymousConsentToken
            } : {},
            ...cookiesFallbackToken ? {
                fallbackConsentToken: cookiesFallbackToken
            } : {}
        };
        return window.__COOKIE_CONSENT_PREFERENCES__;
    }
    if (perimeter === 'fedramp-moderate' || isBifrostIcRequest === true) {
        window.__COOKIE_CONSENT_PREFERENCES__ = null;
        return window.__COOKIE_CONSENT_PREFERENCES__;
    }
    if (!environment) {
        window.__COOKIE_CONSENT_PREFERENCES__ = null;
        (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error('Cannot preload Cookie Consent Preferences: missing environment'));
        return window.__COOKIE_CONSENT_PREFERENCES__;
    }
    const hostEnv = environment === 'PRODUCTION' ? 'prod' : 'staging';
    return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/fetch:CookieConsentPreferences', async ()=>{
        let result = null;
        const isLocalPillar = (0, $d6NtA.isLocal)();
        const url = isLocalPillar ? '/gateway/api/consenthub/session/user/consents/cookies' : `https://atl-preferences-center-elb.${hostEnv}.atl-paas.net/rest/user/${userId}/consents/cookies`;
        try {
            const res = await (0, $f7B1p.cfetch)(url, (0, $cgNzK.constructCompatibleRequestInit)({
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
                    ...Boolean(undefined) && Boolean(undefined) && !isLocalPillar ? {
                        'x-ssr-service-name': 'atl-preferences-center'
                    } : {}
                },
                credentials: 'include'
            }));
            if (!res.ok) throw new Error(`Cannot load Cookie Consent Preferences: ${res.statusText}`);
            result = await res.json();
        } catch (e) {
            (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Fetching cookie preferences failed: ${e.message}`));
        }
        if (result && Object.keys(result).length) {
            window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign({}, result, {
                fallbackConsentToken: cookiesFallbackToken
            });
            return window.__COOKIE_CONSENT_PREFERENCES__;
        } else {
            window.__COOKIE_CONSENT_PREFERENCES__ = null;
            return window.__COOKIE_CONSENT_PREFERENCES__;
        }
    });
};
const $29df517881fdeca7$var$getCookiePreferencesForBanner = ()=>{
    if (window.__COOKIE_CONSENT_PREFERENCES__ !== undefined) return Promise.resolve(window.__COOKIE_CONSENT_PREFERENCES__);
    if (!window.__COOKIE_CONSENT_PREFERENCES_PRELOAD_PROMISE__) window.__COOKIE_CONSENT_PREFERENCES_PRELOAD_PROMISE__ = $29df517881fdeca7$var$preloadCookiePreferencesForBanner().finally(()=>{
        window.__COOKIE_CONSENT_PREFERENCES_PRELOAD_PROMISE__ = null;
    });
    return window.__COOKIE_CONSENT_PREFERENCES_PRELOAD_PROMISE__;
};
const $29df517881fdeca7$export$990c5eb6cb59ce1c = async ()=>{
    const cookiePreferences = await $29df517881fdeca7$var$getCookiePreferencesForBanner();
    if (window.__PRELOADED_COOKIE_PREFERENCES__ === undefined) {
        const { prefs: prefs } = (0, $fkeeB.initializePreferencesData)(cookiePreferences ?? undefined);
        window.__PRELOADED_COOKIE_PREFERENCES__ = prefs ?? null;
    }
    return cookiePreferences;
};








parcelRequire("8nle6");
var $5SzHz = parcelRequire("5SzHz");





var $eS4vC = parcelRequire("eS4vC");

// When firing preload functions we don't have experience tracker started thus we can only annotate the request through URL match
function $df23aac6d1130849$export$7388eaba0b85ff24(exp) {
    window['GLOBAL_FALLBACK_ATL_EXP'] = exp;
}













var $lesra = parcelRequire("lesra");




/**
 * @generated SignedSource<<665e9f622479d8b8a25b05a0d8f0fe94>>
 * @relayHash fe3341ed930f93ccf29cba79d0a71a5f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fd2b05a3bb62454654b6b992f1679f4ed4910edc57ce1d395f4c143c40888dc2
const $83b1dd2d3bda0ead$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isNotLicensed"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "suggestion"
    }, v2 = {
        "kind": "ScalarField",
        "name": "dismissalDateTime"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "condition": "isNotLicensed",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "concreteType": "UserPreferences",
                    "kind": "LinkedField",
                    "name": "userPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "shouldShowCardOnPageTreeHover"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "feedRecommendedUserSettingsDismissTimestamp"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "userSpacesNotifiedOfExternalCollab"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "favouriteTemplateEntityIds"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "homePagesDisplayView"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "feedType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "feedTab"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "recentFilter"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "missionControlOverview"
                        },
                        {
                            "concreteType": "MissionControlMetricSuggestionState",
                            "kind": "LinkedField",
                            "name": "missionControlMetricSuggestions",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                v2 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "ConfluenceEditorSettings",
                            "kind": "LinkedField",
                            "name": "confluenceEditorSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "toolbarDockingInitialPosition"
                                }
                            ]
                        },
                        {
                            "concreteType": "MissionControlFeatureDiscoverySuggestionState",
                            "kind": "LinkedField",
                            "name": "missionControlFeatureDiscoverySuggestions",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "globalPageCardAppearancePreference"
                        },
                        {
                            "concreteType": "HomeWidget",
                            "kind": "LinkedField",
                            "name": "homeWidgets",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "state"
                                },
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isHomeOnboardingDismissed"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "theme"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "watchMyOwnContent"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "commentsPanelSorting"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isCommentsPanelAutomaticSummariesEnabled"
                        },
                        v3 /*: any*/ 
                    ]
                }
            ]
        },
        {
            "concreteType": "DiscoveredFeature",
            "kind": "LinkedField",
            "name": "featureDiscovery",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pluginKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "featureKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "userKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "date"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "UserSettingsQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "UserSettingsQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "fe3341ed930f93ccf29cba79d0a71a5f",
            "id": "fd2b05a3bb62454654b6b992f1679f4ed4910edc57ce1d395f4c143c40888dc2",
            "metadata": {},
            "name": "UserSettingsQuery",
            "operationKind": "query",
            "text": "query UserSettingsQuery($isNotLicensed:Boolean!){userPreferences@skip(if:$isNotLicensed){shouldShowCardOnPageTreeHover,feedRecommendedUserSettingsDismissTimestamp,userSpacesNotifiedOfExternalCollab,favouriteTemplateEntityIds,homePagesDisplayView,feedType,feedTab,recentFilter,missionControlOverview,missionControlMetricSuggestions{suggestion,value,dismissalDateTime},confluenceEditorSettings{toolbarDockingInitialPosition},missionControlFeatureDiscoverySuggestions{suggestion,dismissalDateTime},globalPageCardAppearancePreference,homeWidgets{id,state,__typename},isHomeOnboardingDismissed,theme,watchMyOwnContent,commentsPanelSorting,isCommentsPanelAutomaticSummariesEnabled,__typename},featureDiscovery{pluginKey,featureKey,userKey,date}}"
        }
    };
}();
$83b1dd2d3bda0ead$var$node.hash = "3c17a61cf39923f903a643933ae0bf4d";
var $83b1dd2d3bda0ead$export$2e2bcd8739ae039 = $83b1dd2d3bda0ead$var$node;









var $arxGM = parcelRequire("arxGM");


var $dBy7h = parcelRequire("dBy7h");

const $fb5b21f5b81a7b59$export$8ff552280f2680c = async ()=>{
    const { cloudId: cloudId, activationId: activationId, userId: userId } = (0, $xwvlW.getPreloaderFnContext)();
    // Can only fetch shared theme when we have all required params
    if (!userId || !cloudId || !activationId) return null;
    try {
        const workspaceAri = (0, $dBy7h.getWorkspaceARI)({
            cloudId: cloudId,
            activationId: activationId
        });
        const response = await (0, $dYU3e.queryAgg)({
            query: (0, $arxGM.default),
            variables: {
                workspaceAri: workspaceAri,
                accountId: userId
            },
            __callerPackage__: "preload-storage-queries"
        });
        const theme = response?.data?.settings_userPreferencesResolved?.theme;
        return theme === undefined ? null : theme;
    } catch  {
        // Errors are handled by waitForAllReturnWhenError in the parent function
        return null;
    }
};


const $96ee7afaced2313e$export$758dd268a3743917 = 'default';
const $96ee7afaced2313e$export$e0e94d96f49a1aa = async ({ themeState: themeState })=>{
    const { isLicensed: isLicensed, isLoggedIn: isLoggedIn } = (0, $xwvlW.getPreloaderFnContext)();
    if (!isLoggedIn) return;
    // Apply themeState immediately if provided via query param (always defined for embedded pages)
    if (themeState) (0, $cad415a4c0599362$export$fd920a796bc0c5e).setThemeStateBasedOnSavedThemeState((0, $lesra.getEffectiveThemeState)(decodeURIComponent(themeState)));
    // Always fetch user settings
    // When shared-user-preferences flag is on, also fetch the workspace theme from AGG in parallel
    const userSettingsPromise = (0, $dYU3e.query)({
        query: (0, $83b1dd2d3bda0ead$export$2e2bcd8739ae039),
        variables: {
            isNotLicensed: !isLicensed
        },
        __callerPackage__: "preload-storage-queries"
    });
    const sharedThemePromise = (0, $9wGTI.fg)('shared-user-preferences') ? (0, $fb5b21f5b81a7b59$export$8ff552280f2680c)() : Promise.resolve(null);
    await (0, $lyWac.waitForAllReturnWhenError)([
        userSettingsPromise,
        sharedThemePromise
    ]);
    const userSettingsResponse = await userSettingsPromise;
    const workspaceTheme = await sharedThemePromise;
    const response = userSettingsResponse;
    const legacyTheme = response?.data?.userPreferences?.theme;
    let theme;
    if ((0, $9wGTI.fg)('shared-user-preferences')) // Empty theme returned from API means there is no preference set, which should be treated as default (Auto color mode)
    theme = workspaceTheme === '' ? $96ee7afaced2313e$export$758dd268a3743917 : workspaceTheme;
    else theme = legacyTheme;
    // Apply user preference theme only when no themeState is provided (prevents flicker from mismatch)
    if (!themeState && theme) (0, $cad415a4c0599362$export$fd920a796bc0c5e).setThemeStateBasedOnSavedThemeState((0, $lesra.getEffectiveThemeState)(theme));
    return response;
};



var $5Wig1 = parcelRequire("5Wig1");

var $as9lu = parcelRequire("as9lu");

















var $iQzVo = parcelRequire("iQzVo");


var $gikGR = parcelRequire("gikGR");


var $ljH80 = parcelRequire("ljH80");


var $iGpO4 = parcelRequire("iGpO4");


var $7N8s0 = parcelRequire("7N8s0");

const $29e73fd15ceba733$export$9865c9c16b8cbabb = async (userId)=>{
    if (!(0, $9wGTI.fg)('twcg-1489-cc-3p-connector-onboarding-rollout')) return;
    const { isRovoEnabled: isRovoEnabled, orgId: orgId, cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
    if (!isRovoEnabled) return;
    // Always preload onboarding state first. It is lightweight and tells us
    // whether the more expensive AGG queries are still needed.
    const onboardingResult = await (0, $dYU3e.queryAgg)({
        query: (0, $gikGR.default),
        variables: {},
        __callerPackage__: "experiment-twcg-1489-cc-3p-connector-onboarding"
    }).catch(()=>null);
    // Extract the enrolment date and skip the AGG queries when the experiment
    // is past its active window.
    const enrolmentDateStr = onboardingResult?.data?.userPreferences?.onboardingState?.find((entry)=>entry.key === (0, $iQzVo.TWCG_1489_CONNECTOR_ONBOARDING).ENROLMENT_DATE)?.value ?? undefined;
    if (!(0, $7N8s0.isWithinEnrolmentWindow)(enrolmentDateStr)) return;
    // The sidebar is the only remaining promo surface. Once it has been dismissed
    // (on its own or as part of 'both') nothing can render, so skip the AGG queries.
    const promoDismissed = onboardingResult?.data?.userPreferences?.onboardingState?.find((entry)=>entry.key === (0, $iQzVo.TWCG_1489_CONNECTOR_ONBOARDING).PROMO_DISMISSED)?.value;
    if (promoDismissed === 'sidebar' || promoDismissed === 'both') return;
    // Within the window — fire the AGG queries in parallel.
    const tasks = [];
    if (userId) tasks.push((0, $dYU3e.queryAgg)({
        query: (0, $ljH80.default),
        variables: {
            userId: userId
        },
        __callerPackage__: "experiment-twcg-1489-cc-3p-connector-onboarding"
    }));
    if (orgId && cloudId) tasks.push((0, $dYU3e.queryAgg)({
        query: (0, $iGpO4.default),
        variables: {
            orgId: orgId,
            resourceId: cloudId,
            first: 75
        },
        __callerPackage__: "experiment-twcg-1489-cc-3p-connector-onboarding"
    }));
    if (tasks.length > 0) await (0, $lyWac.waitForAllReturnWhenError)(tasks);
};






var $dBcar = parcelRequire("dBcar");




const $e0b364cfa44ad6fc$export$6c6d6d173d015704 = ()=>(0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: [
                ...(0, $dBcar.NAV_EXPERIMENT_ONBOARDING_KEYS)
            ]
        },
        __callerPackage__: "onboarding-helpers"
    });












var $d9tcB = parcelRequire("d9tcB");


var $cwUrm = parcelRequire("cwUrm");


var $4YUBg = parcelRequire("4YUBg");


var $4vyfK = parcelRequire("4vyfK");





var $8dUjs = parcelRequire("8dUjs");

const $0253e305bf4bf030$export$8b5d8927d613430e = async ()=>{
    const { edition: edition, accessStatus: accessStatus } = (0, $xwvlW.getPreloaderFnContext)();
    const { webItemParams: webItemParams } = (0, $8dUjs.getGlobalAppsParams)({
        edition: edition,
        accessStatus: accessStatus
    });
    return (0, $4vyfK.preloadWebItemLocation)(webItemParams);
};



var $hPkGG = parcelRequire("hPkGG");

const $34aa8f5c495a6ba2$export$3efc211209d16247 = async ()=>{
    const { cloudId: cloudId, userId: userId, activationId: activationId, accessStatus: accessStatus } = (0, $xwvlW.getPreloaderFnContext)();
    const promises = [
        (0, $0253e305bf4bf030$export$8b5d8927d613430e)()
    ];
    if (userId && !(0, $9wGTI.fg)('navx-global-side-nav-confluence')) promises.push((0, $dYU3e.queryAgg)({
        query: (0, $hPkGG.default),
        context: {
            headers: {
                'Atl-Client-Name': 'confluence-frontend'
            }
        },
        variables: {
            entityAri: (0, $5Wig1.ConfluenceWorkspaceAri).create({
                siteId: cloudId,
                activationId: activationId
            }).toString(),
            ownerAri: (0, $as9lu.IdentityUserAri).create({
                userId: userId
            }).toString()
        },
        __callerPackage__: "side-navigation"
    }));
    // Preload the GRS invited-app-shortcuts recommendations
    // query for the LEGACY nav via interop (queryAgg → Apollo AGG cache), so the render-time
    // `useQueryInterop` read in `LegacyInvitedAppShortcutsRecommendations` hits the SSR-seeded cache
    // with no second network request. Gated ONLY on the legacy surface (FG off) + the kill-switch gate
    // — NOT the experiment — so BOTH experiment arms (treatment and control) get the store hit. This
    // keeps exposure balanced: the render-time hook fires the exposure for both arms, and control must
    // not incur a client waterfall the treatment arm avoids. GSN preloads this operation separately via
    // platform Relay (`preloadInvitedAppShortcutsRecommendationsQuery`).
    if (userId && cloudId && !(0, $9wGTI.fg)('navx-global-side-nav-confluence') && (0, $9wGTI.fg)('twcg-460-preload-grs-invited-app-shortcuts-gate')) promises.push((0, $dYU3e.queryAgg)({
        query: (0, $4YUBg.default),
        variables: (0, $cwUrm.buildInvitedAppShortcutsRecommendationsVariables)(cloudId),
        __callerPackage__: "side-navigation"
    }));
    if (accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS) promises.push((0, $e0b364cfa44ad6fc$export$6c6d6d173d015704)());
    if (accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS) promises.push((0, $29e73fd15ceba733$export$9865c9c16b8cbabb)(userId ?? undefined));
    return (0, $lyWac.waitForAllReturnWhenError)(promises);
};






var $aQN68 = parcelRequire("aQN68");

async function $e44b2547c6a8e817$export$dfd129d3c3f4c561() {
    return (0, $dYU3e.query)({
        query: (0, $aQN68.default),
        __callerPackage__: "side-navigation"
    });
}












var $cbHql = parcelRequire("cbHql");

const $da1fd1e44d7582fe$export$b4f1825d0b62630d = ()=>(0, $dYU3e.query)({
        query: (0, $cbHql.default),
        __callerPackage__: "editor-presets"
    });



var $iUV81 = parcelRequire("iUV81");


var $9sGCn = parcelRequire("9sGCn");


var $3y1ko = parcelRequire("3y1ko");



















const $9c2bd2b1923ffb30$export$20203945a91bbda3 = ()=>{
    const preloadedSessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const { userId: userId, accessStatus: accessStatus } = preloadedSessionContext;
    const isLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const tasks = [];
    if (isLicensed && userId) tasks.push((0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: Object.values((0, $dBcar.CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH))
        },
        __callerPackage__: "onboarding-helpers"
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};



var $hXDOc = parcelRequire("hXDOc");


var $kM8fE = parcelRequire("kM8fE");


var $g277M = parcelRequire("g277M");



var $cbQWR = parcelRequire("cbQWR");


var $wPrRK = parcelRequire("wPrRK");











var $kkLBe = parcelRequire("kkLBe");


var $kquO1 = parcelRequire("kquO1");


var $f9opb = parcelRequire("f9opb");

var $jgc4t = parcelRequire("jgc4t");
/**
 * @generated SignedSource<<47f9a4e427f341e84adc1057bf9cd2de>>
 * @relayHash ea9da9f484ea7ee984b438476b85f726
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0067b3533a30bc8bb310216ac6ca2782b5f6c9318b1efb780b3aaff9e31223f0
const $aa72a6013de18737$var$node = function() {
    var v0 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "agentSessionsPropertyKey"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "autohighlightsEntityAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "autohighlightsWorkspaceId"
    }, v3 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "externalLabelsAri"
    }, v4 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "externalLabelsCloudId"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "fetchAgentSessionsMarker"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeAgentTrustReceiptData"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeAudioContent"
    }, v8 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeAutohighlights"
    }, v9 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeAutomationDiscoveries"
    }, v10 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeBylineContributors"
    }, v11 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeClassification"
    }, v12 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeConnectionAncestors"
    }, v13 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeContentHeader"
    }, v14 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeContentHeaderAccess"
    }, v15 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeExternalLabels"
    }, v16 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeFabricEditorEligibility"
    }, v17 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeReactions"
    }, v18 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeRendererAssetsCustomChrome"
    }, v19 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeRendererAssetsMedia"
    }, v20 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeRestrictionAncestors"
    }, v21 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeRestrictions"
    }, v22 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isSSR"
    }, v23 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "preloadLabels"
    }, v24 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v25 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useContentModeFragment"
    }, v26 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useNewContentTopper"
    }, v27 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionOverride"
    }, v28 = [
        {
            "kind": "Variable",
            "name": "spaceKey",
            "variableName": "spaceKey"
        },
        {
            "kind": "Variable",
            "name": "version",
            "variableName": "versionOverride"
        }
    ], v29 = {
        "kind": "ScalarField",
        "name": "id"
    }, v30 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v31 = {
        "kind": "ScalarField",
        "name": "type"
    }, v32 = {
        "kind": "ScalarField",
        "name": "status"
    }, v33 = [
        {
            "kind": "ScalarField",
            "name": "contentMode"
        }
    ], v34 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": v33 /*: any*/ 
            },
            {
                "concreteType": "DraftContentProperties",
                "kind": "LinkedField",
                "name": "draft",
                "plural": false,
                "selections": v33 /*: any*/ 
            }
        ]
    }, v35 = {
        "kind": "ScalarField",
        "name": "name"
    }, v36 = {
        "kind": "ScalarField",
        "name": "color"
    }, v37 = {
        "args": [
            {
                "kind": "Literal",
                "name": "isDraft",
                "value": false
            }
        ],
        "concreteType": "ContentState",
        "kind": "LinkedField",
        "name": "contentState",
        "plural": false,
        "selections": [
            v29 /*: any*/ ,
            v35 /*: any*/ ,
            v36 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "restrictionLevel"
            }
        ],
        "storageKey": "contentState(isDraft:false)"
    }, v38 = {
        "kind": "ScalarField",
        "name": "value"
    }, v39 = {
        "args": [
            {
                "kind": "Literal",
                "name": "format",
                "value": "USER_FRIENDLY"
            }
        ],
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "contentStateLastUpdated",
        "plural": false,
        "selections": [
            v38 /*: any*/ 
        ],
        "storageKey": "contentStateLastUpdated(format:\"USER_FRIENDLY\")"
    }, v40 = {
        "kind": "ScalarField",
        "name": "title"
    }, v41 = {
        "kind": "ScalarField",
        "name": "key"
    }, v42 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v29 /*: any*/ ,
            v35 /*: any*/ ,
            v41 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            }
        ]
    }, v43 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v44 = [
        v41 /*: any*/ ,
        v38 /*: any*/ 
    ], v45 = {
        "alias": "smartFolderProperties",
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "smartFolderProperties"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": v44 /*: any*/ 
            }
        ],
        "storageKey": "properties(keys:[\"smartFolderProperties\"])"
    }, v46 = {
        "kind": "ScalarField",
        "name": "contentTypeModified"
    }, v47 = {
        "kind": "ScalarField",
        "name": "number"
    }, v48 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v49 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v50 = [
        v49 /*: any*/ 
    ], v51 = {
        "kind": "LinkedField",
        "name": "by",
        "plural": false,
        "selections": v50 /*: any*/ 
    }, v52 = {
        "kind": "ScalarField",
        "name": "when"
    }, v53 = {
        "kind": "ScalarField",
        "name": "confRev"
    }, v54 = [
        {
            "kind": "ScalarField",
            "name": "coverPictureWidth"
        }
    ], v55 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                "kind": "LinkedField",
                "name": "frontend",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "fabricEditorSupported"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "embedded"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "collabService"
                    },
                    {
                        "condition": "useNewContentTopper",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": v54 /*: any*/ 
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            }
        ]
    }, v56 = {
        "kind": "ScalarField",
        "name": "representation"
    }, v57 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            v47 /*: any*/ 
        ]
    }, v58 = {
        "kind": "ScalarField",
        "name": "js"
    }, v59 = {
        "kind": "ScalarField",
        "name": "css"
    }, v60 = {
        "concreteType": "WebResourceTags",
        "kind": "LinkedField",
        "name": "tags",
        "plural": false,
        "selections": [
            v58 /*: any*/ ,
            v59 /*: any*/ 
        ]
    }, v61 = [
        v60 /*: any*/ 
    ], v62 = {
        "concreteType": "ContentBodyPerRepresentation",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentBody",
                "kind": "LinkedField",
                "name": "dynamic",
                "plural": false,
                "selections": [
                    v56 /*: any*/ ,
                    v38 /*: any*/ ,
                    {
                        "concreteType": "Content",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                            v29 /*: any*/ ,
                            v57 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "WebResourceDependencies",
                        "kind": "LinkedField",
                        "name": "webresource",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "SuperBatchWebResources",
                                "kind": "LinkedField",
                                "name": "superbatch",
                                "plural": false,
                                "selections": v61 /*: any*/ 
                            },
                            v60 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v63 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v29 /*: any*/ ,
                v41 /*: any*/ ,
                v38 /*: any*/ ,
                v57 /*: any*/ 
            ]
        }
    ], v64 = {
        "alias": "appearancePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "content-appearance-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v63 /*: any*/ ,
        "storageKey": "properties(key:\"content-appearance-published\")"
    }, v65 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "cover-picture-id-published",
                    "emoji-title-published",
                    "editor",
                    "import-source",
                    "imported-page-modified-date"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v63 /*: any*/ ,
        "storageKey": "properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"])"
    }, v66 = {
        "alias": "pageTitlePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "page-title-property-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v63 /*: any*/ ,
        "storageKey": "properties(key:\"page-title-property-published\")"
    }, v67 = {
        "alias": "pageTitleDraft",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "page-title-property-draft"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v63 /*: any*/ ,
        "storageKey": "properties(key:\"page-title-property-draft\")"
    }, v68 = {
        "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
        "kind": "LinkedField",
        "name": "frontend",
        "plural": false,
        "selections": v54 /*: any*/ 
    }, v69 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            v68 /*: any*/ 
        ]
    }, v70 = {
        "alias": "coverPictureProperties",
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "cover-picture-id-draft",
                    "cover-picture-id-published"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v63 /*: any*/ ,
        "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
    }, v71 = {
        "kind": "ScalarField",
        "name": "hasInheritedRestrictions"
    }, v72 = {
        "kind": "ScalarField",
        "name": "hasRestrictions"
    }, v73 = {
        "kind": "ScalarField",
        "name": "hasViewRestrictions"
    }, v74 = [
        {
            "kind": "Literal",
            "name": "orderBy",
            "value": {
                "direction": "ASCENDING",
                "sortField": "LABELLING_CREATIONDATE"
            }
        }
    ], v75 = {
        "kind": "ScalarField",
        "name": "count"
    }, v76 = {
        "kind": "ScalarField",
        "name": "label"
    }, v77 = {
        "kind": "ScalarField",
        "name": "prefix"
    }, v78 = {
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "contentReactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    v75 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    },
                    v29 /*: any*/ 
                ]
            }
        ]
    }, v79 = [
        {
            "kind": "Literal",
            "name": "key",
            "value": "emoji-title-published"
        }
    ], v80 = {
        "alias": "emoji",
        "args": v79 /*: any*/ ,
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v29 /*: any*/ ,
                    v38 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v81 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v82 = [
        v49 /*: any*/ ,
        v81 /*: any*/ 
    ], v83 = {
        "kind": "ScalarField",
        "name": "webui"
    }, v84 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            v83 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "base"
            }
        ]
    }, v85 = {
        "alias": "audioProperties",
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "editor"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v38 /*: any*/ ,
                    v41 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"editor\"])"
    }, v86 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
            v29 /*: any*/ ,
            v40 /*: any*/ ,
            v72 /*: any*/ ,
            {
                "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                    v83 /*: any*/ 
                ]
            }
        ]
    }, v87 = {
        "concreteType": "ClassificationLevelDetails",
        "kind": "LinkedField",
        "name": "classificationLevelDetails",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentDataClassificationLevel",
                "kind": "LinkedField",
                "name": "classificationLevel",
                "plural": false,
                "selections": [
                    v29 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "guideline"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "guidelineADF"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    v36 /*: any*/ ,
                    v35 /*: any*/ ,
                    v32 /*: any*/ 
                ]
            },
            {
                "kind": "ScalarField",
                "name": "featureEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "source"
            },
            {
                "kind": "ScalarField",
                "name": "isReclassificationPermitted"
            },
            {
                "kind": "ScalarField",
                "name": "canManageSpaceSettings"
            },
            {
                "kind": "ScalarField",
                "name": "classificationControlSetting"
            },
            {
                "kind": "ScalarField",
                "name": "userOverrideSetting"
            }
        ]
    }, v88 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v89 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "generatedBy"
                    }
                ]
            }
        ]
    }, v90 = {
        "condition": "fetchAgentSessionsMarker",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": "agentSessionsMarker",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "key",
                        "variableName": "agentSessionsPropertyKey"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v63 /*: any*/ 
            }
        ]
    }, v91 = [
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "spaceKey"
        }
    ], v92 = {
        "concreteType": "Theme",
        "kind": "LinkedField",
        "name": "theme",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "themeKey"
            },
            v35 /*: any*/ 
        ]
    }, v93 = {
        "kind": "ScalarField",
        "name": "background"
    }, v94 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v95 = {
        "kind": "ScalarField",
        "name": "backgroundImage"
    }, v96 = {
        "kind": "ScalarField",
        "name": "backgroundPosition"
    }, v97 = {
        "kind": "ScalarField",
        "name": "backgroundSize"
    }, v98 = {
        "kind": "ScalarField",
        "name": "backgroundRepeat"
    }, v99 = {
        "kind": "ScalarField",
        "name": "backgroundOrigin"
    }, v100 = {
        "kind": "ScalarField",
        "name": "backgroundClip"
    }, v101 = {
        "kind": "ScalarField",
        "name": "backgroundAttachment"
    }, v102 = {
        "kind": "ScalarField",
        "name": "backgroundBlendMode"
    }, v103 = {
        "concreteType": "ScreenLookAndFeel",
        "kind": "LinkedField",
        "name": "screen",
        "plural": false,
        "selections": [
            v93 /*: any*/ ,
            v94 /*: any*/ ,
            v95 /*: any*/ ,
            v96 /*: any*/ ,
            v97 /*: any*/ ,
            v98 /*: any*/ ,
            v99 /*: any*/ ,
            v100 /*: any*/ ,
            v101 /*: any*/ ,
            v102 /*: any*/ ,
            {
                "concreteType": "LayerScreenLookAndFeel",
                "kind": "LinkedField",
                "name": "layer",
                "plural": false,
                "selections": [
                    v93 /*: any*/ ,
                    v94 /*: any*/ ,
                    v95 /*: any*/ ,
                    v96 /*: any*/ ,
                    v97 /*: any*/ ,
                    v98 /*: any*/ ,
                    v99 /*: any*/ ,
                    v100 /*: any*/ ,
                    v101 /*: any*/ ,
                    v102 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "width"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "height"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "gutterTop"
            },
            {
                "kind": "ScalarField",
                "name": "gutterRight"
            },
            {
                "kind": "ScalarField",
                "name": "gutterBottom"
            },
            {
                "kind": "ScalarField",
                "name": "gutterLeft"
            }
        ]
    }, v104 = {
        "kind": "ScalarField",
        "name": "padding"
    }, v105 = {
        "kind": "ScalarField",
        "name": "borderRadius"
    }, v106 = {
        "concreteType": "ContainerLookAndFeel",
        "kind": "LinkedField",
        "name": "container",
        "plural": false,
        "selections": [
            v93 /*: any*/ ,
            v94 /*: any*/ ,
            v95 /*: any*/ ,
            v96 /*: any*/ ,
            v97 /*: any*/ ,
            v98 /*: any*/ ,
            v99 /*: any*/ ,
            v100 /*: any*/ ,
            v101 /*: any*/ ,
            v102 /*: any*/ ,
            v104 /*: any*/ ,
            v105 /*: any*/ 
        ]
    }, v107 = {
        "concreteType": "SpaceSettings",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "routeOverrideEnabled"
            }
        ]
    }, v108 = {
        "concreteType": "SpaceUserMetadata",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isAnonymouslyAuthorized"
            }
        ]
    }, v109 = [
        {
            "kind": "ScalarField",
            "name": "html"
        },
        v58 /*: any*/ ,
        v59 /*: any*/ ,
        {
            "concreteType": "SpaUnfriendlyMacro",
            "kind": "LinkedField",
            "name": "spaUnfriendlyMacros",
            "plural": true,
            "selections": [
                v35 /*: any*/ 
            ]
        }
    ], v110 = {
        "condition": "includeRendererAssetsCustomChrome",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "SpaceSettings",
                "kind": "LinkedField",
                "name": "settings",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "SpaceSettingsMetadata",
                        "kind": "LinkedField",
                        "name": "customHeaderAndFooter",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "HtmlMeta",
                                "kind": "LinkedField",
                                "name": "header",
                                "plural": false,
                                "selections": v109 /*: any*/ 
                            },
                            {
                                "concreteType": "HtmlMeta",
                                "kind": "LinkedField",
                                "name": "footer",
                                "plural": false,
                                "selections": v109 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ]
    }, v111 = {
        "condition": "includeRendererAssetsMedia",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "MediaConfiguration",
                "kind": "LinkedField",
                "name": "mediaConfiguration",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "clientId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "fileStoreUrl"
                    }
                ]
            }
        ]
    }, v112 = [
        {
            "kind": "Variable",
            "name": "entityAri",
            "variableName": "autohighlightsEntityAri"
        },
        {
            "kind": "Variable",
            "name": "workspaceId",
            "variableName": "autohighlightsWorkspaceId"
        }
    ], v113 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "externalLabelsCloudId"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "externalLabelsAri"
        }
    ], v114 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v115 = [
        v114 /*: any*/ ,
        v49 /*: any*/ 
    ], v116 = {
        "kind": "LinkedField",
        "name": "by",
        "plural": false,
        "selections": v115 /*: any*/ 
    }, v117 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v29 /*: any*/ ,
                v41 /*: any*/ ,
                v38 /*: any*/ 
            ]
        }
    ], v118 = {
        "kind": "ScalarField",
        "name": "sourceTemplateEntityId"
    }, v119 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v120 = [
        v114 /*: any*/ ,
        v31 /*: any*/ ,
        v49 /*: any*/ ,
        v119 /*: any*/ ,
        v81 /*: any*/ 
    ], v121 = {
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": v115 /*: any*/ 
    }, v122 = [
        v71 /*: any*/ ,
        v72 /*: any*/ ,
        v73 /*: any*/ 
    ], v123 = [
        v114 /*: any*/ ,
        v49 /*: any*/ ,
        v81 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                v25 /*: any*/ ,
                v26 /*: any*/ ,
                v27 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ContentUnifiedWithSpaceKeyQuery",
            "selections": [
                {
                    "args": v28 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "spaceHomepage",
                    "plural": false,
                    "selections": [
                        v29 /*: any*/ ,
                        v30 /*: any*/ ,
                        v31 /*: any*/ ,
                        v32 /*: any*/ ,
                        v34 /*: any*/ ,
                        v37 /*: any*/ ,
                        v39 /*: any*/ ,
                        v40 /*: any*/ ,
                        v42 /*: any*/ ,
                        v43 /*: any*/ ,
                        v45 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                v46 /*: any*/ ,
                                v47 /*: any*/ ,
                                v48 /*: any*/ ,
                                v51 /*: any*/ ,
                                v52 /*: any*/ ,
                                v53 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "draftVersion",
                            "plural": false,
                            "selections": [
                                v46 /*: any*/ ,
                                v47 /*: any*/ ,
                                v48 /*: any*/ ,
                                v51 /*: any*/ ,
                                v52 /*: any*/ 
                            ]
                        },
                        v55 /*: any*/ ,
                        v62 /*: any*/ ,
                        v64 /*: any*/ ,
                        v65 /*: any*/ ,
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "ViewPageCommentsPanelPermission_content"
                                    }
                                ],
                                "type": "Content"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "commentsPanelPermission"
                        },
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "ArchivedPageBannerV2Status_content"
                                    }
                                ],
                                "type": "Content"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "archivedPageBannerStatusFragment"
                        },
                        {
                            "condition": "useContentModeFragment",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ContentModeFragmentProvider_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "viewPageContentMode"
                                }
                            ]
                        },
                        {
                            "condition": "includeBylineContributors",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "includeConnectionAncestors",
                                                        "variableName": "includeConnectionAncestors"
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "useNewContentTopper",
                                                        "variableName": "useNewContentTopper"
                                                    }
                                                ],
                                                "kind": "FragmentSpread",
                                                "name": "ContentTitleWithByLine_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "contentTitleWithByLine"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "useTitleContentPropertiesForPublishedPage_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "rendererTitleContentProperties"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "CoverPictureQuery_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "rendererCoverPicture"
                                }
                            ]
                        },
                        {
                            "condition": "includeAutomationDiscoveries",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "MeetingNotesAutomationDiscoveryFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "meetingNotesAutomationDiscoveryFragment"
                                }
                            ]
                        },
                        {
                            "condition": "includeContentHeader",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "includeAccessButton",
                                                        "variableName": "includeContentHeaderAccess"
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "includeFabricEditorEligibility",
                                                        "variableName": "includeFabricEditorEligibility"
                                                    }
                                                ],
                                                "kind": "FragmentSpread",
                                                "name": "ContentHeader_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "contentHeaderFragment"
                                }
                            ]
                        },
                        {
                            "condition": "useNewContentTopper",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v29 /*: any*/ ,
                                            v66 /*: any*/ ,
                                            v67 /*: any*/ ,
                                            v69 /*: any*/ 
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "titleContentProperties"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v29 /*: any*/ ,
                                            v70 /*: any*/ 
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "coverPicture"
                                },
                                v66 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "includeRestrictions",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v29 /*: any*/ ,
                                            v71 /*: any*/ ,
                                            v72 /*: any*/ ,
                                            v73 /*: any*/ ,
                                            v40 /*: any*/ 
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "shareAndRestrictButtonData"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v29 /*: any*/ ,
                                            v71 /*: any*/ ,
                                            v73 /*: any*/ ,
                                            v72 /*: any*/ 
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "pageRestrictionsContext"
                                }
                            ]
                        },
                        {
                            "condition": "preloadLabels",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ViewPageLabelsContentFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "viewPageLabels"
                                },
                                {
                                    "args": v74 /*: any*/ ,
                                    "concreteType": "PaginatedLabelList",
                                    "kind": "LinkedField",
                                    "name": "labels",
                                    "plural": false,
                                    "selections": [
                                        v75 /*: any*/ ,
                                        {
                                            "concreteType": "Label",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v29 /*: any*/ ,
                                                v76 /*: any*/ ,
                                                v35 /*: any*/ ,
                                                v77 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                                }
                            ]
                        },
                        {
                            "condition": "includeReactions",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v29 /*: any*/ ,
                                            v78 /*: any*/ 
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "reactionsContent"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ReactionsContentFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "reactionsContentFragment"
                                }
                            ]
                        },
                        {
                            "condition": "includeAudioContent",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v29 /*: any*/ ,
                                            v40 /*: any*/ ,
                                            v43 /*: any*/ ,
                                            v80 /*: any*/ ,
                                            {
                                                "concreteType": "History",
                                                "kind": "LinkedField",
                                                "name": "history",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "createdBy",
                                                        "plural": false,
                                                        "selections": v82 /*: any*/ 
                                                    },
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "ownedBy",
                                                        "plural": false,
                                                        "selections": v82 /*: any*/ 
                                                    }
                                                ]
                                            },
                                            v84 /*: any*/ ,
                                            v85 /*: any*/ 
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "audioContent"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "AudioContentFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "audioContentFragment"
                                }
                            ]
                        },
                        {
                            "condition": "includeRestrictionAncestors",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v29 /*: any*/ ,
                                            v86 /*: any*/ 
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "pageRestrictionsContextAncestors"
                                }
                            ]
                        },
                        {
                            "condition": "includeClassification",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "BylineClassification_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "bylineClassificationFragment"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v29 /*: any*/ ,
                                            v87 /*: any*/ 
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "contentClassification"
                                }
                            ]
                        },
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "PageContentRenderer_content"
                                    }
                                ],
                                "type": "Content"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "pageContentRendererFragment"
                        },
                        {
                            "condition": "includeAgentTrustReceiptData",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        v88 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": v50 /*: any*/ 
                                        }
                                    ]
                                },
                                v89 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "includeRendererAssetsMedia",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ViewPageExtensionsAndRendererAssetsContentFragment_mediaContent"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "rendererAssetsMedia"
                                }
                            ]
                        },
                        {
                            "condition": "isSSR",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ViewPageExtensionsAndRendererAssetsContentFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "rendererAssetsMacroOutput"
                                }
                            ]
                        },
                        v90 /*: any*/ 
                    ]
                },
                {
                    "args": v91 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v29 /*: any*/ ,
                        v92 /*: any*/ ,
                        {
                            "concreteType": "LookAndFeel",
                            "kind": "LinkedField",
                            "name": "lookAndFeel",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v103 /*: any*/ ,
                                        v106 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v107 /*: any*/ ,
                        v108 /*: any*/ ,
                        v110 /*: any*/ ,
                        {
                            "condition": "includeContentHeader",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ContentHeader_space"
                                            }
                                        ],
                                        "type": "Space"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "contentHeaderFragment"
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "ContentTitle_space"
                        },
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "PageContentRenderer_space"
                                    }
                                ],
                                "type": "Space"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "pageContentRendererFragment"
                        }
                    ]
                },
                v111 /*: any*/ ,
                {
                    "condition": "includeAutohighlights",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": v112 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "preloadAutohighlightsQuery_query"
                                    }
                                ],
                                "type": "Query"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "autohighlightsQueryFragment"
                        }
                    ]
                },
                {
                    "condition": "includeExternalLabels",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": v113 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "useExternalLabels_query"
                                    }
                                ],
                                "type": "Query"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "externalLabelsFragment"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v24 /*: any*/ ,
                v27 /*: any*/ ,
                v22 /*: any*/ ,
                v19 /*: any*/ ,
                v18 /*: any*/ ,
                v26 /*: any*/ ,
                v23 /*: any*/ ,
                v0 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v10 /*: any*/ ,
                v12 /*: any*/ ,
                v9 /*: any*/ ,
                v7 /*: any*/ ,
                v17 /*: any*/ ,
                v21 /*: any*/ ,
                v20 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v16 /*: any*/ ,
                v25 /*: any*/ ,
                v8 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v15 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ContentUnifiedWithSpaceKeyQuery",
            "selections": [
                {
                    "args": v28 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "spaceHomepage",
                    "plural": false,
                    "selections": [
                        v29 /*: any*/ ,
                        v30 /*: any*/ ,
                        v31 /*: any*/ ,
                        v32 /*: any*/ ,
                        v34 /*: any*/ ,
                        v37 /*: any*/ ,
                        v39 /*: any*/ ,
                        v40 /*: any*/ ,
                        v42 /*: any*/ ,
                        v43 /*: any*/ ,
                        v45 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                v46 /*: any*/ ,
                                v47 /*: any*/ ,
                                v48 /*: any*/ ,
                                v116 /*: any*/ ,
                                v52 /*: any*/ ,
                                v53 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "draftVersion",
                            "plural": false,
                            "selections": [
                                v46 /*: any*/ ,
                                v47 /*: any*/ ,
                                v48 /*: any*/ ,
                                v116 /*: any*/ ,
                                v52 /*: any*/ 
                            ]
                        },
                        v55 /*: any*/ ,
                        v62 /*: any*/ ,
                        v64 /*: any*/ ,
                        v65 /*: any*/ ,
                        {
                            "condition": "includeBylineContributors",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "emojiTitlePublished",
                                    "args": v79 /*: any*/ ,
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v63 /*: any*/ ,
                                    "storageKey": "properties(key:\"emoji-title-published\")"
                                },
                                {
                                    "alias": "editorProperty",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "editor"
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v117 /*: any*/ ,
                                    "storageKey": "properties(key:\"editor\")"
                                },
                                {
                                    "concreteType": "ContentMetadata",
                                    "kind": "LinkedField",
                                    "name": "metadata",
                                    "plural": false,
                                    "selections": [
                                        v68 /*: any*/ ,
                                        v118 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "homepageId"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        v88 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": v120 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v120 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "lastOwnedBy",
                                            "plural": false,
                                            "selections": v120 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v31 /*: any*/ ,
                                                v81 /*: any*/ ,
                                                v119 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v89 /*: any*/ ,
                                v66 /*: any*/ ,
                                v67 /*: any*/ ,
                                v70 /*: any*/ ,
                                {
                                    "condition": "includeConnectionAncestors",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "ancestors",
                                            "plural": true,
                                            "selections": [
                                                v29 /*: any*/ ,
                                                v40 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                v43 /*: any*/ ,
                                                {
                                                    "concreteType": "History",
                                                    "kind": "LinkedField",
                                                    "name": "history",
                                                    "plural": false,
                                                    "selections": [
                                                        v121 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "keys",
                                                            "value": [
                                                                "devdocsProperties",
                                                                "smartFolderProperties"
                                                            ]
                                                        }
                                                    ],
                                                    "concreteType": "PaginatedJsonContentPropertyList",
                                                    "kind": "LinkedField",
                                                    "name": "properties",
                                                    "plural": false,
                                                    "selections": v117 /*: any*/ ,
                                                    "storageKey": "properties(keys:[\"devdocsProperties\",\"smartFolderProperties\"])"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "includeAutomationDiscoveries",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata",
                                    "kind": "LinkedField",
                                    "name": "metadata",
                                    "plural": false,
                                    "selections": [
                                        v118 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "includeContentHeader",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "condition": "includeFabricEditorEligibility",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "ContentMetadata",
                                            "kind": "LinkedField",
                                            "name": "metadata",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                                    "kind": "LinkedField",
                                                    "name": "frontend",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fabricEditorEligibility"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "contentHash"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeContentHeaderAccess",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": v122 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "condition": "useNewContentTopper",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                v66 /*: any*/ ,
                                v67 /*: any*/ ,
                                v69 /*: any*/ ,
                                v70 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "includeRestrictions",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": v122 /*: any*/ 
                        },
                        {
                            "condition": "preloadLabels",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v74 /*: any*/ ,
                                    "concreteType": "PaginatedLabelList",
                                    "kind": "LinkedField",
                                    "name": "labels",
                                    "plural": false,
                                    "selections": [
                                        v75 /*: any*/ ,
                                        {
                                            "concreteType": "Label",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v114 /*: any*/ ,
                                                v29 /*: any*/ ,
                                                v76 /*: any*/ ,
                                                v35 /*: any*/ ,
                                                v77 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                                }
                            ]
                        },
                        {
                            "condition": "includeReactions",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                v78 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "includeAudioContent",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                v80 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": v123 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v123 /*: any*/ 
                                        }
                                    ]
                                },
                                v84 /*: any*/ ,
                                v85 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "includeRestrictionAncestors",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                v86 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "includeClassification",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                v87 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "includeAgentTrustReceiptData",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        v88 /*: any*/ ,
                                        v121 /*: any*/ 
                                    ]
                                },
                                v89 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "includeRendererAssetsMedia",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "atlas_doc_format",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "EmbeddedMediaToken",
                                                    "kind": "LinkedField",
                                                    "name": "mediaToken",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "token"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isSSR",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "MapOfStringToFormattedBody",
                                    "kind": "LinkedField",
                                    "name": "macroRenderedOutput",
                                    "plural": true,
                                    "selections": [
                                        v41 /*: any*/ ,
                                        {
                                            "concreteType": "FormattedBody",
                                            "kind": "LinkedField",
                                            "name": "value",
                                            "plural": false,
                                            "selections": [
                                                v38 /*: any*/ ,
                                                v56 /*: any*/ ,
                                                {
                                                    "concreteType": "WebResourceDependencies",
                                                    "kind": "LinkedField",
                                                    "name": "webresource",
                                                    "plural": false,
                                                    "selections": v61 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v90 /*: any*/ 
                    ]
                },
                {
                    "args": v91 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v29 /*: any*/ ,
                        v92 /*: any*/ ,
                        {
                            "concreteType": "LookAndFeel",
                            "kind": "LinkedField",
                            "name": "lookAndFeel",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "MapOfStringToString",
                                    "kind": "LinkedField",
                                    "name": "headings",
                                    "plural": true,
                                    "selections": v44 /*: any*/ 
                                },
                                {
                                    "concreteType": "ContentLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContainerLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "header",
                                            "plural": false,
                                            "selections": [
                                                v93 /*: any*/ ,
                                                v101 /*: any*/ ,
                                                v102 /*: any*/ ,
                                                v100 /*: any*/ ,
                                                v94 /*: any*/ ,
                                                v95 /*: any*/ ,
                                                v99 /*: any*/ ,
                                                v96 /*: any*/ ,
                                                v98 /*: any*/ ,
                                                v97 /*: any*/ ,
                                                v105 /*: any*/ ,
                                                v104 /*: any*/ 
                                            ]
                                        },
                                        v103 /*: any*/ ,
                                        v106 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v107 /*: any*/ ,
                        v108 /*: any*/ ,
                        v110 /*: any*/ 
                    ]
                },
                v111 /*: any*/ ,
                {
                    "condition": "includeAutohighlights",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "KnowledgeDiscoveryQueryApi",
                            "kind": "LinkedField",
                            "name": "knowledgeDiscovery",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v112 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "keyPhrases",
                                    "plural": false,
                                    "selections": [
                                        v114 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "KnowledgeDiscoveryKeyPhrase",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "keyPhrase"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "category"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "KnowledgeDiscoveryKeyPhraseConnection"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "message"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeExternalLabels",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v113 /*: any*/ ,
                            "concreteType": "ConfluenceExternalLabel",
                            "kind": "LinkedField",
                            "name": "confluence_externalLabels",
                            "plural": true,
                            "selections": [
                                v29 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "kind"
                                },
                                v35 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "ea9da9f484ea7ee984b438476b85f726",
            "id": "0067b3533a30bc8bb310216ac6ca2782b5f6c9318b1efb780b3aaff9e31223f0",
            "metadata": {},
            "name": "ContentUnifiedWithSpaceKeyQuery",
            "operationKind": "query",
            "text": "query ContentUnifiedWithSpaceKeyQuery($spaceKey:String!,$versionOverride:Int,$isSSR:Boolean=false,$includeRendererAssetsMedia:Boolean=false,$includeRendererAssetsCustomChrome:Boolean=false,$useNewContentTopper:Boolean=false,$preloadLabels:Boolean=false,$agentSessionsPropertyKey:String=\"\",$fetchAgentSessionsMarker:Boolean=false,$includeAgentTrustReceiptData:Boolean=false,$includeBylineContributors:Boolean=false,$includeConnectionAncestors:Boolean=false,$includeAutomationDiscoveries:Boolean=false,$includeAudioContent:Boolean=false,$includeReactions:Boolean=false,$includeRestrictions:Boolean=false,$includeRestrictionAncestors:Boolean=false,$includeClassification:Boolean=false,$includeContentHeader:Boolean=false,$includeContentHeaderAccess:Boolean=false,$includeFabricEditorEligibility:Boolean=false,$useContentModeFragment:Boolean=false,$includeAutohighlights:Boolean=false,$autohighlightsEntityAri:String,$autohighlightsWorkspaceId:String,$includeExternalLabels:Boolean=false,$externalLabelsCloudId:ID=\"\",$externalLabelsAri:ID=\"\"){mediaConfiguration@include(if:$includeRendererAssetsMedia){clientId,fileStoreUrl},...preloadAutohighlightsQuery_query_deyB3@include(if:$includeAutohighlights),...useExternalLabels_query_2n00s0@include(if:$includeExternalLabels),spaceHomepage(spaceKey:$spaceKey,version:$versionOverride){...ViewPageCommentsPanelPermission_content,id,operations{operation,targetType},type,status,...ArchivedPageBannerV2Status_content,contentProperties{latest{contentMode},draft{contentMode}},...ContentModeFragmentProvider_content@include(if:$useContentModeFragment),contentState(isDraft:false){id,name,color,restrictionLevel},contentStateLastUpdated(format:USER_FRIENDLY){value},...ContentTitleWithByLine_content_1jvjSB@include(if:$includeBylineContributors)\n    ...useTitleContentPropertiesForPublishedPage_content@include(if:$includeBylineContributors)\n    ...CoverPictureQuery_content@include(if:$includeBylineContributors),...MeetingNotesAutomationDiscoveryFragment_content@include(if:$includeAutomationDiscoveries),title,space{id,name,key,alias},subType,smartFolderProperties:properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when,confRev,when@include(if:$includeAgentTrustReceiptData)},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},...ContentHeader_content_118EQH@include(if:$includeContentHeader),metadata{frontend{fabricEditorSupported,embedded,collabService,coverPictureWidth@include(if:$useNewContentTopper)},lastModifiedDate},id@include(if:$useNewContentTopper)\n    pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}}\n    pageTitleDraft:properties(key:\"page-title-property-draft\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}}\n    metadata@include(if:$useNewContentTopper){frontend{coverPictureWidth}}\n    coverPictureProperties:properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},id@include(if:$includeRestrictions)\n    hasInheritedRestrictions@include(if:$includeRestrictions)\n    hasRestrictions@include(if:$includeRestrictions)\n    hasViewRestrictions@include(if:$includeRestrictions)\n    title@include(if:$includeRestrictions),...ViewPageLabelsContentFragment_content@include(if:$preloadLabels)\n    labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING})@include(if:$preloadLabels){count,nodes{id,label,name,prefix}},id@include(if:$includeReactions)\n    contentReactionsSummary@include(if:$includeReactions){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}\n    ...ReactionsContentFragment_content@include(if:$includeReactions),id@include(if:$includeAudioContent)\n    title@include(if:$includeAudioContent)\n    subType@include(if:$includeAudioContent)\n    emoji:properties(key:\"emoji-title-published\")@include(if:$includeAudioContent){nodes{id,value}}\n    history@include(if:$includeAudioContent){createdBy{__typename,displayName,profilePicture{path}},ownedBy{__typename,displayName,profilePicture{path}}}\n    links@include(if:$includeAudioContent){webui,base}\n    audioProperties:properties(keys:[\"emoji-title-published\",\"editor\"])@include(if:$includeAudioContent){nodes{value,key}}\n    ...AudioContentFragment_content@include(if:$includeAudioContent),id@include(if:$includeRestrictionAncestors)\n    ancestors@include(if:$includeRestrictionAncestors){id,title,hasRestrictions,links{webui}},...BylineClassification_content@include(if:$includeClassification)\n    id@include(if:$includeClassification)\n    classificationLevelDetails@include(if:$includeClassification){classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting},...PageContentRenderer_content,body{dynamic{representation,value,content{id,version{number}},webresource{superbatch{tags{js,css}},tags{js,css}}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}},history@include(if:$includeAgentTrustReceiptData){createdDate,createdBy{__typename,displayName}}\n    contentProperties@include(if:$includeAgentTrustReceiptData){latest{generatedBy}},...ViewPageExtensionsAndRendererAssetsContentFragment_mediaContent@include(if:$includeRendererAssetsMedia),...ViewPageExtensionsAndRendererAssetsContentFragment_content@include(if:$isSSR),agentSessionsMarker:properties(key:$agentSessionsPropertyKey)@include(if:$fetchAgentSessionsMarker){nodes{id,key,value,version{number}}}},space(key:$spaceKey){id@include(if:$includeRendererAssetsCustomChrome)\n    settings@include(if:$includeRendererAssetsCustomChrome){customHeaderAndFooter{header{html,js,css,spaUnfriendlyMacros{name}},footer{html,js,css,spaUnfriendlyMacros{name}}}},...ContentHeader_space@include(if:$includeContentHeader),...ContentTitle_space,...PageContentRenderer_space,id,theme{themeKey,name},lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}},settings{routeOverrideEnabled},currentUser{isAnonymouslyAuthorized}}}fragment ArchivedPageBannerV2Status_content on Content{id,status}fragment AudioContentFragment_content on Content{id,title,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},history{createdBy{__typename,displayName,profilePicture{path}},ownedBy{__typename,displayName,profilePicture{path}}},links{webui,base},audioProperties:properties(keys:[\"emoji-title-published\",\"editor\"]){nodes{value,key}}}fragment ByLine_content_1jvjSB on Content{...useReadTime_content,id,type,subType,history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},ownedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},version{by{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},friendlyWhen,when,number,contentTypeModified},contentProperties{latest{generatedBy}},...RendererContentState_content,pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},editorProperty:properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{coverPictureWidth@include(if:$useNewContentTopper)}},ancestors@include(if:$includeConnectionAncestors){id,title,type,subType,history{createdBy{__typename,displayName}},properties(keys:[\"devdocsProperties\",\"smartFolderProperties\"]){nodes{id,key,value}}}}fragment BylineClassification_content on Content{id,title,type,status,operations{operation,targetType},space{id,name,key,alias},...useContentClassification_content}fragment ContentHeader_content_118EQH on Content{id,type,subType,title,status,metadata{lastModifiedDate,frontend{fabricEditorSupported}},...useFabricEligibilityMigrationQuery_content@include(if:$includeFabricEditorEligibility),...ContentTypesHeader_content,...EditContentButton_content,...useShareAndRestrictButtonData_content@include(if:$includeContentHeaderAccess)}fragment ContentHeader_space on Space{id,theme{themeKey}}fragment ContentModeFragmentProvider_content on Content{id,contentProperties{latest{contentMode},draft{contentMode}}}fragment ContentTitleWithByLine_content_1jvjSB on Content{...ContentTitle_content_2SjeOj,...ByLine_content_1jvjSB,...ArchivedPageBannerV2Status_content,...MeetingNotesAutomationDiscoveryFragment_content}fragment ContentTitle_content_2SjeOj on Content{id,type,title,appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},editorProperty:properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}},space{id,name,homepageId}}fragment ContentTitle_space on Space{id,theme{themeKey},lookAndFeel{headings{key,value},content{header{background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundRepeat,backgroundSize,borderRadius,padding}}}}fragment ContentTypesHeader_content on Content{id,title,operations{operation,targetType},space{id,name,key,alias},type,subType,status,smartFolderProperties:properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when}}fragment CoverPictureQuery_content on Content{id,coverPictureProperties:properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"]){nodes{id,key,value,version{number}}}}fragment EditContentButton_content on Content{id,type,operations{operation,targetType},metadata{frontend{fabricEditorSupported,embedded,collabService}},subType,space{id,key}}fragment MeetingNotesAutomationDiscoveryFragment_content on Content{id,title,body{dynamic{value}},metadata{sourceTemplateEntityId}}fragment PageContentRenderer_content on Content{id,title,type,status,version{confRev,number},metadata{lastModifiedDate},body{dynamic{representation,value,content{id,version{number}},webresource{superbatch{tags{js,css}},tags{js,css}}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}}}fragment PageContentRenderer_space on Space{id,theme{themeKey}}fragment ReactionsContentFragment_content on Content{id,contentReactionsSummary{reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}fragment RendererContentState_content on Content{id,contentState(isDraft:false){id,name,color,restrictionLevel},contentStateLastUpdated(format:USER_FRIENDLY){value}}fragment ViewPageCommentsPanelPermission_content on Content{id,operations{operation,targetType}}fragment ViewPageExtensionsAndRendererAssetsContentFragment_content on Content{macroRenderedOutput{key,value{value,representation,webresource{tags{js,css}}}}}fragment ViewPageExtensionsAndRendererAssetsContentFragment_mediaContent on Content{id,body{atlas_doc_format{mediaToken{token}}}}fragment ViewPageLabelsContentFragment_content on Content{id,type,status,operations{operation,targetType},space{id},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){count,nodes{__typename,id,label,name,prefix}}}fragment preloadAutohighlightsQuery_query_deyB3 on Query{knowledgeDiscovery{keyPhrases(entityAri:$autohighlightsEntityAri,workspaceId:$autohighlightsWorkspaceId)@optIn(to:\"KnowledgeDiscovery Get Key Phrases\"){__typename,...on KnowledgeDiscoveryKeyPhraseConnection{nodes{keyPhrase,category}},...on QueryError{message}}}}fragment useContentClassification_content on Content{id,classificationLevelDetails{classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}fragment useExternalLabels_query_2n00s0 on Query{confluence_externalLabels(cloudId:$externalLabelsCloudId,id:$externalLabelsAri){id,kind,name}}fragment useFabricEligibilityMigrationQuery_content on Content{id,metadata{frontend{fabricEditorEligibility,contentHash}}}fragment useReadTime_content on Content{id,type,body{dynamic{value,representation}},operations{operation,targetType}}fragment useShareAndRestrictButtonData_content on Content{id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title}fragment useTitleContentPropertiesForPublishedPage_content on Content{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}"
        }
    };
}();
$aa72a6013de18737$var$node.hash = "ed2ac3a2f38758139965d6532cf790eb";
var $aa72a6013de18737$export$2e2bcd8739ae039 = $aa72a6013de18737$var$node;


var $3qGQ7 = parcelRequire("3qGQ7");








var $2GGOW = parcelRequire("2GGOW");





var $fEmGS = parcelRequire("fEmGS");


var $hNtOj = parcelRequire("hNtOj");




/** A 403 on the root `space` field only nulls that field; the content still comes back. */ const $1acff4ea84553836$var$isSpaceScopedError = (error)=>error.path?.[0] === 'space';
const $1acff4ea84553836$var$isContentScopedError = (error)=>error.path?.[0] === 'content';
const $1acff4ea84553836$var$isPathlessError = (error)=>!error.path?.length;
function $1acff4ea84553836$var$processContentPreloadPermissionError(result, isAccessLinkRoute) {
    result?.errors?.forEach((error)=>{
        // The "Cannot find space" condition is handled by redirecting to the correct space
        // even if error is not propagated to ContentPrerequisites where it is normally handled.
        if ((0, $2GGOW.isUnauthorizedError)(error)) {
            // An access-link viewer has no space membership by design, so a space-scoped 403 must
            // not blank a page whose content resolved.
            if (isAccessLinkRoute && $1acff4ea84553836$var$isSpaceScopedError(error)) return;
            if ((0, $9wGTI.fg)('confluence_preload_perm_error_path_check')) {
                if ($1acff4ea84553836$var$isContentScopedError(error) || $1acff4ea84553836$var$isPathlessError(error)) (0, $hNtOj.ssrPermissionsErrorHandler).markSSRPreloadPermissionError('view', error);
                return;
            }
            (0, $hNtOj.ssrPermissionsErrorHandler).markSSRPreloadPermissionError('view', error);
        }
    });
}
const $1acff4ea84553836$export$dba3e11e87da376f = (data)=>({
        content: data?.spaceHomepage ? {
            nodes: [
                data?.spaceHomepage
            ],
            // @ts-ignore
            __typename: 'PaginatedContentListWithChild'
        } : null,
        space: data?.space || null
    });
function $1acff4ea84553836$export$97ce9ab4bdd6b3fc({ contentId: contentId, spaceKey: spaceKey, isBlog: isBlog, versionOverride: versionOverride = null, userId: userId, agentSessionsEnabled: agentSessionsEnabled = false, autohighlightsQueryVariables: autohighlightsQueryVariables, externalLabelsQueryVariables: externalLabelsQueryVariables, includeRendererAssetsDsp: includeRendererAssetsDsp = false, rendererAssetsDspAction: rendererAssetsDspAction, hasDocumentContractAnalyticsByline: hasDocumentContractAnalyticsByline = false, hasDocumentContractContentHeader: hasDocumentContractContentHeader = false, includeRendererAssetsMedia: includeRendererAssetsMedia = false, includeRendererAssetsCustomChrome: includeRendererAssetsCustomChrome = false, isAccessLinkRoute: isAccessLinkRoute = false }) {
    window.performance.mark('CFP-63.preloadContent.start');
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    const shouldUseContentHeaderFragment = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    hasDocumentContractContentHeader && // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_header_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false);
    const shouldUseFabricEligibilityFragment = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    shouldUseContentHeaderFragment && // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_fabric_eligibility_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false);
    // Space overview
    if (spaceKey && !contentId) return (0, $dYU3e.query)({
        query: (0, $aa72a6013de18737$export$2e2bcd8739ae039),
        variables: {
            ...(0, $3qGQ7.createContentUnifiedWithSpaceKeyQueryVariables)({
                spaceKey: spaceKey,
                versionOverride: versionOverride,
                isSSR: isSSR,
                includeRendererAssetsMedia: includeRendererAssetsMedia,
                includeRendererAssetsCustomChrome: includeRendererAssetsCustomChrome,
                agentSessionsUserId: agentSessionsEnabled ? userId : undefined,
                includeAgentTrustReceiptData: (0, $9wGTI.fg)('cc_sparks_agent_trust_receipt'),
                includeConnectionAncestors: (0, $6mKj3.isExperimentEnabled)('confluence_1p_and_3p_connection_byline_experiment'),
                includeMetadata: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_meta_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
                includeClassification: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_classification_context_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
                includeReactions: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_reactions_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
                includeAudioContent: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_audio_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
                autohighlightsQueryVariables: autohighlightsQueryVariables
            }),
            ...!(0, $1xpoY.default).isKillSwitchOn('confluence_vp_mode_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false) ? {
                useContentModeFragment: true
            } : {}
        },
        errorPolicy: 'all',
        __callerPackage__: "content-body"
    }).then((result)=>{
        // Record the end mark and timestamp to track *both* duration of preloading
        // and timestamp of the moment when preloading finished
        window.performance.mark('CFP-63.preloadContent.end');
        window.performance.mark('CFP-63.preloadContentEnd');
        const data = result?.data;
        const homepageId = data?.spaceHomepage?.id;
        if (homepageId) {
            // update result with transformed data
            result.data = $1acff4ea84553836$export$dba3e11e87da376f(data);
            (0, $fEmGS.writeQueryInterop)({
                query: (0, $jgc4t.default),
                variables: {
                    ...(0, $3qGQ7.createContentUnifiedQueryVariables)({
                        contentId: homepageId,
                        spaceKey: spaceKey,
                        versionOverride: versionOverride,
                        isSSR: isSSR,
                        includeRendererAssetsMedia: includeRendererAssetsMedia,
                        includeRendererAssetsCustomChrome: includeRendererAssetsCustomChrome,
                        agentSessionsUserId: agentSessionsEnabled ? userId : undefined,
                        includeAgentTrustReceiptData: (0, $9wGTI.fg)('cc_sparks_agent_trust_receipt'),
                        includeConnectionAncestors: (0, $6mKj3.isExperimentEnabled)('confluence_1p_and_3p_connection_byline_experiment'),
                        includeMetadata: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_meta_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
                        includeClassification: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_classification_context_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
                        includeReactions: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_reactions_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
                        includeAudioContent: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_audio_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
                        autohighlightsQueryVariables: autohighlightsQueryVariables
                    }),
                    ...!(0, $1xpoY.default).isKillSwitchOn('confluence_vp_mode_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false) ? {
                        useContentModeFragment: true
                    } : {}
                },
                data: {
                    ...result.data
                },
                __callerPackage__: "content-body"
            });
        }
        $1acff4ea84553836$var$processContentPreloadPermissionError(result, isAccessLinkRoute);
        return {
            result: result,
            hasErrors: result?.hasErrors
        };
    });
    const chooseContentUnifiedQuery = isBlog ? (0, $f9opb.default) : (0, $jgc4t.default);
    const queryVariables = isBlog ? {
        ...(0, $3qGQ7.createContentBlogUnifiedQueryVariables)({
            contentId: contentId,
            spaceKey: spaceKey,
            versionOverride: versionOverride,
            isSSR: isSSR,
            includeRendererAssetsMedia: includeRendererAssetsMedia,
            includeRendererAssetsCustomChrome: includeRendererAssetsCustomChrome,
            preloadLabels: isSSR,
            includeAgentTrustReceiptData: (0, $9wGTI.fg)('cc_sparks_agent_trust_receipt'),
            includeBylineContributors: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_title_byline_frag_dedup') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeAutomationDiscoveries: (0, $9wGTI.fg)('cc_automations_discovery_nudges'),
            includeMetadata: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_meta_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeClassification: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_classification_context_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeReactions: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_reactions_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeAudioContent: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_audio_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            // @ts-ignore -- Downstream packages are checked against the last generated content-unified-query declaration.
            includeAnalyticsByline: hasDocumentContractAnalyticsByline && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_analytics_byline_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            // @ts-ignore -- Downstream packages are checked against the last generated content-unified-query declaration.
            includeContentHeader: shouldUseContentHeaderFragment,
            includeContentHeaderAccess: shouldUseContentHeaderFragment && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_access_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeFabricEditorEligibility: shouldUseFabricEligibilityFragment,
            includeContentHeaderPublicLink: shouldUseContentHeaderFragment && !isBlog && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_access_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeRendererAssetsDsp: // @ts-ignore -- Downstream packages are checked against the last generated content-unified-query declaration.
            includeRendererAssetsDsp,
            rendererAssetsDspAction: rendererAssetsDspAction,
            autohighlightsQueryVariables: autohighlightsQueryVariables
        }),
        ...!(0, $1xpoY.default).isKillSwitchOn('confluence_vp_mode_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false) ? {
            useContentModeFragment: true
        } : {}
    } : {
        ...(0, $3qGQ7.createContentUnifiedQueryVariables)({
            contentId: contentId,
            spaceKey: spaceKey,
            versionOverride: versionOverride,
            isSSR: isSSR,
            includeRendererAssetsMedia: includeRendererAssetsMedia,
            includeRendererAssetsCustomChrome: includeRendererAssetsCustomChrome,
            preloadLabels: isSSR,
            agentSessionsUserId: agentSessionsEnabled ? userId : undefined,
            includeAgentTrustReceiptData: (0, $9wGTI.fg)('cc_sparks_agent_trust_receipt'),
            includeBylineContributors: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_title_byline_frag_dedup') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeConnectionAncestors: (0, $6mKj3.isExperimentEnabled)('confluence_1p_and_3p_connection_byline_experiment'),
            includeAutomationDiscoveries: (0, $9wGTI.fg)('cc_automations_discovery_nudges'),
            includeMetadata: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_meta_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeClassification: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_classification_context_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeReactions: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_reactions_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeAudioContent: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_audio_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            // @ts-ignore -- Downstream packages are checked against the last generated content-unified-query declaration.
            includeAnalyticsByline: hasDocumentContractAnalyticsByline && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_analytics_byline_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            // @ts-ignore -- Downstream packages are checked against the last generated content-unified-query declaration.
            includeContentHeader: shouldUseContentHeaderFragment,
            includeContentHeaderAccess: shouldUseContentHeaderFragment && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_access_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeFabricEditorEligibility: shouldUseFabricEligibilityFragment,
            includeContentHeaderPublicLink: shouldUseContentHeaderFragment && !isBlog && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_access_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeRendererAssetsDsp: // @ts-ignore -- Downstream packages are checked against the last generated content-unified-query declaration.
            includeRendererAssetsDsp,
            rendererAssetsDspAction: rendererAssetsDspAction,
            autohighlightsQueryVariables: autohighlightsQueryVariables,
            externalLabelsQueryVariables: // @ts-ignore -- Downstream packages are checked against the last generated content-unified-query declaration.
            externalLabelsQueryVariables
        }),
        ...!(0, $1xpoY.default).isKillSwitchOn('confluence_vp_mode_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false) ? {
            useContentModeFragment: true
        } : {}
    };
    return (0, $dYU3e.query)({
        query: chooseContentUnifiedQuery,
        variables: queryVariables,
        errorPolicy: 'all',
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr -- This controls request-scoped cache retention, not rendered output.
        ...(0, $6mKj3.expVal)('confluence_relay_vp_preload_retention', 'isEnabled', false) ? {
            relayQueryPreloadRetention: 'environment'
        } : {},
        __callerPackage__: "content-body"
    }).then((result)=>{
        // Record the end mark and timestamp to track *both* duration of preloading
        // and timestamp of the moment when preloading finished
        window.performance.mark('CFP-63.preloadContent.end');
        window.performance.mark('CFP-63.preloadContentEnd');
        $1acff4ea84553836$var$processContentPreloadPermissionError(result, isAccessLinkRoute);
        return {
            result: result,
            hasErrors: result?.hasErrors
        };
    });
}



var $furnK = parcelRequire("furnK");


var $9L8Ms = parcelRequire("9L8Ms");


var $lcQ5b = parcelRequire("lcQ5b");





var $b2p4s = parcelRequire("b2p4s");

const $6dc053709e1de01d$export$4a518872c59a5d22 = ({ contentId: contentId, draftShareId: draftShareId })=>{
    return (0, $dYU3e.query)({
        query: (0, $b2p4s.default),
        variables: {
            contentId: contentId,
            draftShareId: draftShareId,
            status: [
                'draft'
            ]
        },
        __callerPackage__: "content-prerequisites"
    });
};


/**
 * @generated SignedSource<<866dc102e183b81e455633e98b448937>>
 * @relayHash c6cf9ac584fd64aa5d844966682fd423
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cf7fffeece47720251193fedf84eaf651e60962e8058f57b9b428bc916676a2c
const $034d91236594c738$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "smartLinksFromDraft"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = [
        {
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "ScalarField",
                    "name": "url"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "emojiTitle"
                },
                {
                    "kind": "ScalarField",
                    "name": "canView"
                },
                {
                    "kind": "ScalarField",
                    "name": "product"
                },
                {
                    "kind": "ScalarField",
                    "name": "resourceType"
                },
                {
                    "kind": "ScalarField",
                    "name": "subType"
                },
                {
                    "kind": "ScalarField",
                    "name": "iconUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "resolved"
                }
            ]
        }
    ], v3 = [
        {
            "condition": "smartLinksFromDraft",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedSmartLinkList",
                    "kind": "LinkedField",
                    "name": "contentSmartLinks",
                    "plural": false,
                    "selections": v2 /*: any*/ 
                }
            ]
        },
        {
            "condition": "smartLinksFromDraft",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedSmartLinkList",
                    "kind": "LinkedField",
                    "name": "confluence_contentSmartLinksForDraft",
                    "plural": false,
                    "selections": v2 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "c6cf9ac584fd64aa5d844966682fd423",
            "id": "cf7fffeece47720251193fedf84eaf651e60962e8058f57b9b428bc916676a2c",
            "metadata": {},
            "name": "preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery",
            "operationKind": "query",
            "text": "query preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery($contentId:ID!,$smartLinksFromDraft:Boolean=false){contentSmartLinks(id:$contentId)@skip(if:$smartLinksFromDraft){nodes{__typename,url,title,emojiTitle,canView,product,resourceType,subType,iconUrl,resolved}},confluence_contentSmartLinksForDraft(id:$contentId)@include(if:$smartLinksFromDraft){nodes{__typename,url,title,emojiTitle,canView,product,resourceType,subType,iconUrl,resolved}}}"
        }
    };
}();
$034d91236594c738$var$node.hash = "a7b959d9a7e601a6bc9a5abbe599241a";
var $034d91236594c738$export$2e2bcd8739ae039 = $034d91236594c738$var$node;









var $8tmcF = parcelRequire("8tmcF");

















var $jhATi = parcelRequire("jhATi");


var $hR977 = parcelRequire("hR977");

const $7da0fb3e82be6868$export$c5bb6d638f1fa69c = (node)=>{
    return node?.['__typename'] === 'InlineSmartLink';
};
const $7da0fb3e82be6868$var$parseSmartlinksResponse = (res, isDraft)=>{
    if (isDraft) return res?.data?.confluence_contentSmartLinksForDraft?.nodes || [];
    return res?.data?.contentSmartLinks?.nodes || [];
};
const $7da0fb3e82be6868$export$7df91b88e675cedb = (res, isDraft = false)=>{
    const content = $7da0fb3e82be6868$var$parseSmartlinksResponse(res, isDraft);
    // filter to only inline smartlins and limit to the max number of smartlinks allowed per call by ORS
    const inputSmartLinks = content.filter($7da0fb3e82be6868$export$c5bb6d638f1fa69c).slice(0, 50);
    return inputSmartLinks.filter((node)=>!!node).map((node)=>{
        return {
            appearance: 'inline',
            resourceUrl: node?.url,
            title: node?.title,
            emojiTitle: node?.emojiTitle,
            canView: node?.canView,
            product: node?.product,
            resourceType: node?.resourceType,
            subType: node?.subType,
            iconUrl: node?.iconUrl,
            resolved: node?.resolved
        };
    });
};



var $3y0Sn = parcelRequire("3y0Sn");



var $cS4kb = parcelRequire("cS4kb");

const $9eb88ac593a96a41$export$92162a33dbbd338d = 250;
const $9eb88ac593a96a41$export$5fc2ebe451bbe5aa = 350;
const $9eb88ac593a96a41$export$83d9e8edcbcda504 = 1;
const $9eb88ac593a96a41$export$c048e241ec0ff835 = 50;
const $9eb88ac593a96a41$export$604acd6b31b9e629 = (0, $034d91236594c738$export$2e2bcd8739ae039);
const $9eb88ac593a96a41$var$getContentSmartLinksORSMeasureName = ()=>{
    const queryBoundary = (0, $g277M.getQueryBoundary)();
    if (!queryBoundary || queryBoundary === 'default') return 'ssr-app/prepare/preloadQuery/fetch:contentSmartLinksORS';
    return `ssr-app/prepare/preloadQuery/dataFetcher:${queryBoundary}/fetch:contentSmartLinksORS`;
};
const $9eb88ac593a96a41$export$3b6cf89022ccdd35 = async (contentId, isDraft = false)=>{
    const smartLinksRes = await (0, $dYU3e.query)({
        query: (0, $034d91236594c738$export$2e2bcd8739ae039),
        variables: {
            contentId: contentId,
            smartLinksFromDraft: isDraft
        },
        __callerPackage__: "content-smartlinks"
    });
    return (0, $7da0fb3e82be6868$export$7df91b88e675cedb)(smartLinksRes, isDraft);
};
const $9eb88ac593a96a41$export$d966f1e92068ec2e = (orsCalls, smartLinks, resolvedSmartLinks, fetchTimeout)=>{
    const resolvedLinks = resolvedSmartLinks.reduce((acc, { status: status, body: body })=>{
        if (status === 504) acc[body?.data?.url] = 'timeout';
        if (status === 200) acc[body?.data?.url] = 'resolved';
        return acc;
    }, {});
    return {
        fetch: orsCalls.length,
        fetchTimeout: fetchTimeout,
        links: smartLinks.reduce((acc, { resourceUrl: resourceUrl, appearance: appearance })=>{
            const linkType = (0, $cS4kb.getLinkType)(resourceUrl);
            if (!acc?.[linkType]?.[appearance]) acc[linkType] = {
                [appearance]: {
                    total: 0,
                    timeout: 0,
                    resolved: 0
                }
            };
            acc[linkType][appearance].total++;
            if (resolvedLinks[resourceUrl]) {
                if (resolvedLinks[resourceUrl] === 'timeout') acc[linkType][appearance].timeout++;
                if (resolvedLinks[resourceUrl] === 'resolved') acc[linkType][appearance].resolved++;
            }
            return acc;
        }, {})
    };
};
async function $9eb88ac593a96a41$export$6ef3ef384e337a5(links, timeout, batchTimeout, fetchTimeout, shouldSkipTimeGuard) {
    if (links.length === 0) return [];
    const { customURLs: customURLs, userContext: userContext } = (0, $60cDW.getSSRRenderInputs)();
    const objectResolverURL = (0, $d6NtA.isLocal)() ? '/gateway/api/object-resolver/resolve/batch' : customURLs?.['object-resolver-service'];
    const firstLink = links[0].resourceUrl;
    const type = (0, $cS4kb.getLinkType)(firstLink);
    const task = async ()=>{
        try {
            // ORS only expects resourceURL and appearance, otherwise it throws a 400 for any unrecognized fields
            // GQL can return any number of fields (title, emoji, resolved state, etc) but ORS should only accept
            // resourceURL and appearance
            const sanitizedLinksForORS = links.map(({ resourceUrl: resourceUrl, appearance: appearance })=>({
                    resourceUrl: resourceUrl,
                    appearance: appearance
                }));
            const res = await (0, $jhATi.fetchORSForSSR)({
                // Despite the API has a timeout it does not respect it. It can easily go over time.
                url: `${objectResolverURL}?timeout=${timeout}`,
                body: JSON.stringify(sanitizedLinksForORS),
                userContext: userContext
            });
            if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
            return res.json();
        } catch (e) {
            (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Smart link content ORS call failed: ${e.message}`));
        }
        return [];
    };
    if (shouldSkipTimeGuard) return task();
    return (0, $8tmcF.timeGuard)(task, ()=>{
        fetchTimeout[type] = fetchTimeout[type] || 0;
        fetchTimeout[type]++;
        return [];
    }, batchTimeout);
}
const $9eb88ac593a96a41$export$dc2d6742e80fba3c = async (contentId, isDraft = false)=>{
    const smartLinks = await $9eb88ac593a96a41$export$3b6cf89022ccdd35(contentId, isDraft);
    if (!smartLinks?.length) return;
    // How long a single ORS resolution can take
    const timeout = (0, $1xpoY.default).getNumber('confluence_ssr_content_smart_link_max_time', $9eb88ac593a96a41$export$92162a33dbbd338d);
    // How long a batch of ORS resolution can take
    const batchTimeout = (0, $1xpoY.default).getNumber('confluence_ssr_content_smart_link_batch_max_time', $9eb88ac593a96a41$export$5fc2ebe451bbe5aa);
    // How many links should be packed in a batch
    const min = (0, $1xpoY.default).getNumber('confluence_ssr_content_smart_link_min_batch_count', $9eb88ac593a96a41$export$83d9e8edcbcda504);
    const max = Math.max(min, (0, $1xpoY.default).getNumber('confluence_ssr_content_smart_link_max_batch_count', $9eb88ac593a96a41$export$c048e241ec0ff835));
    const { resolvedFromGql: resolvedFromGql, linksForORS: linksForORS } = (0, $3y0Sn.partitionResolvedLinks)(smartLinks);
    // format resolved links to match that of getInitialState
    const gqlResolvedState = (0, $3y0Sn.buildResolvedSmartLinkState)(resolvedFromGql);
    const gqlStats = {
        totalLinks: smartLinks.length,
        resolvedFromGqlCount: resolvedFromGql?.length,
        linksForORSCount: linksForORS?.length,
        skippedORS: linksForORS?.length === 0
    };
    const orsCalls = [];
    const fetchTimeout = {};
    let resolvedSmartLinks = [];
    if (linksForORS.length > 0) await (0, $9WAeG.SSRMeasures).run($9eb88ac593a96a41$var$getContentSmartLinksORSMeasureName(), async ()=>{
        let smartLinksBatches = (0, $cS4kb.groupSmartLinksByHostname)(linksForORS);
        smartLinksBatches = (0, $cS4kb.mergeSmallThirdPartyBatches)(smartLinksBatches, min);
        smartLinksBatches = (0, $cS4kb.splitLinksIntoBatches)(smartLinksBatches, max);
        for (const smartLinksBatch of smartLinksBatches)orsCalls.push($9eb88ac593a96a41$export$6ef3ef384e337a5(smartLinksBatch, timeout, batchTimeout, fetchTimeout));
        // eslint-disable-next-line check-preloaders/no-promise-all
        resolvedSmartLinks = (await Promise.all(orsCalls)).flat();
    });
    const titles = {};
    for (const link of linksForORS)if (link.title) titles[link.resourceUrl] = link.title;
    if (Object.keys(titles).length > 0) window['__SSR_SMARTLINKS_TITLES__'] = titles;
    // Format response to fit SmartCard Provider storeOptions initial state
    // Save correctly formatted response to window obj so it can be used on SSR and SPA (no duplicate calls)
    // Merge GraphQL-resolved state with ORS-resolved state
    window['__SSR_SMARTLINKS__'] = {
        ...gqlResolvedState,
        ...(0, $hR977.getInitialState)(resolvedSmartLinks)
    };
    window['__SSR_SMARTLINKS_STATS__'] = {
        ...$9eb88ac593a96a41$export$d966f1e92068ec2e(orsCalls, smartLinks, resolvedSmartLinks, fetchTimeout),
        gql: gqlStats
    };
};



var $4zhNK = parcelRequire("4zhNK");


var $fyUox = parcelRequire("fyUox");


var $gKMkU = parcelRequire("gKMkU");


var $hu6Tz = parcelRequire("hu6Tz");


var $iV8Fk = parcelRequire("iV8Fk");





var $ld6xp = parcelRequire("ld6xp");


var $dOBRD = parcelRequire("dOBRD");


var $llqlc = parcelRequire("llqlc");


var $2y2x3 = parcelRequire("2y2x3");


var $2K3wo = parcelRequire("2K3wo");


var $4XbfY = parcelRequire("4XbfY");


var $hSTGC = parcelRequire("hSTGC");


var $c9US3 = parcelRequire("c9US3");


var $8pcS0 = parcelRequire("8pcS0");





var $6mEZ3 = parcelRequire("6mEZ3");








var $92uc5 = parcelRequire("92uc5");


var $8mIlz = parcelRequire("8mIlz");


var $6Cce7 = parcelRequire("6Cce7");










const $cd2d56ef117b2819$export$e87714e2a0c200ee = 8;
const $cd2d56ef117b2819$export$717eaf20c85e91ca = 'confluence-extensions-server-render-blocklist';


// Instead of gating the static constant, we will filter out Calendars here unless the flag is enabled
const $64a1b8a95751bd5c$var$knownExtensionSet = new Set((0, $8pcS0.serverRenderedExtensions).filter((ext)=>ext !== (0, $8pcS0.EXTENSION_KEY).TEAM_CALENDARS || (0, $6mKj3.expValEquals)('cc-engagement-team-calendar-macro-afm-migration', 'isEnabled', true)));
const $64a1b8a95751bd5c$var$getMacroId = (node)=>node.attrs?.parameters?.macroMetadata?.macroId?.value;
const $64a1b8a95751bd5c$var$extractExtensions = (adf)=>(0, $llqlc.filter)(adf, (node)=>(0, $8pcS0.supportedExtensions).has(node.type));
const $64a1b8a95751bd5c$var$augmentWithMarks = (marks)=>{
    if (!marks?.length) return {};
    const fragments = marks.filter((mark)=>mark.type === 'fragment');
    if (fragments.length) return {
        fragmentLocalId: fragments[0].attrs.localId
    };
    return {};
};
const $64a1b8a95751bd5c$var$blocklistCache = new Map();
const $64a1b8a95751bd5c$export$80c99e8065c92427 = ()=>$64a1b8a95751bd5c$var$blocklistCache.clear();
const $64a1b8a95751bd5c$var$isBlocklisted = (blocklist, extensionKey)=>{
    if (blocklist.length === 0) return false;
    if ($64a1b8a95751bd5c$var$blocklistCache.has(extensionKey)) return $64a1b8a95751bd5c$var$blocklistCache.get(extensionKey);
    const isBlocked = blocklist.length > 0 && blocklist.some((block)=>{
        try {
            const blockRegex = new RegExp(block, 'ig');
            return blockRegex.test(extensionKey);
        } catch  {
            // Malformed regex/input, consider extension being not blocked
            return false;
        }
    });
    $64a1b8a95751bd5c$var$blocklistCache.set(extensionKey, isBlocked);
    return isBlocked;
};
// The rule of excluding extensions from querying in the prepare phase of SSR are the following:
//  - extension should be located at the top of the page, assuming extensions returned by the
//    adf-utils/filter are in the order from top to down of the page;
//  - extension should be common/legacy, i.e. of type "com.atlassian.confluence.macro.core";
//  - extension should not be a part of those we have a special handling in SPA (excepting children macro);
//  - extensions shouldn't have an output in a content query.
const $64a1b8a95751bd5c$var$byExcluded = (excludeExtensionIdSet, numberOfExtensionsToSSR = 0)=>(node, index)=>{
        const { parameters: parameters, extensionKey: extensionKey, extensionType: extensionType } = node.attrs || {};
        return index < numberOfExtensionsToSSR && extensionType === (0, $8pcS0.EXTENSION_TYPE).MACRO_CORE && (!$64a1b8a95751bd5c$var$knownExtensionSet.has(extensionKey) || extensionKey === 'children') && !parameters.macroOutput && !excludeExtensionIdSet.has($64a1b8a95751bd5c$var$getMacroId(node));
    };
const $64a1b8a95751bd5c$var$getSchema = (0, $dOBRD.default)(()=>(0, $4XbfY.getSchemaBasedOnStage)((0, $2y2x3.ADFStages).STAGE_0));
const $64a1b8a95751bd5c$var$createMacroQueryParamsProvider = (documentADF)=>{
    // This code (both `getRendererDocument` and `getRendererNodeContent`) inspired by `renderDocument`
    // function in `platform/packages/editor/renderer/src/render-document.ts`
    // Here we convert the `content` of our adf node to renderer/editor/ProseMirror node,
    // which ensures `content` in preloader and in SSR render would match and would not cause apollo cache mismatch.
    const getRendererDocument = (0, $dOBRD.default)(()=>{
        const schema = $64a1b8a95751bd5c$var$getSchema();
        const validDocumentADF = (0, $2K3wo.validateADFEntity)(schema, documentADF);
        const pnDoc = schema.nodeFromJSON(validDocumentADF);
        return {
            version: 1,
            type: 'doc',
            content: pnDoc.content.toJSON()
        };
    });
    const getRendererNodeContent = (macroId)=>{
        const rendererDocument = getRendererDocument();
        const [rendererNode] = (0, $llqlc.filter)(rendererDocument, (n)=>$64a1b8a95751bd5c$var$getMacroId(n) === macroId);
        return rendererNode.content || [];
    };
    return (node)=>{
        const requestADF = (0, $6mEZ3.extensionToADF)(node);
        requestADF.attrs = {
            ...requestADF.attrs,
            ...$64a1b8a95751bd5c$var$augmentWithMarks(node.marks)
        };
        if (requestADF.type === (0, $8pcS0.BODIED_EXTENSION_TYPE)) requestADF.content = getRendererNodeContent($64a1b8a95751bd5c$var$getMacroId(node));
        delete requestADF.attrs.layout;
        return {
            ...requestADF,
            type: node.type
        };
    };
};
const $64a1b8a95751bd5c$var$preloadMacrosSSRAndReturnTopXFailed = async (contentId, contentNodes, numberOfExtensionsToSSR, renderOnlyExtensionKeys, extensionsBlocklist)=>{
    if (renderOnlyExtensionKeys && renderOnlyExtensionKeys.length === 0) return {};
    // NOTE: prealod is not a type. It was created with a typo https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/confluence_frontend_prealod_macro_timeout
    const macroTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_prealod_macro_timeout', (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    const blocklistedExtensions = extensionsBlocklist.split(',').map((extensionName)=>extensionName.trim()).filter(Boolean);
    // Catch error if contentNodes is empty
    if (!contentNodes || !contentNodes[0]) return {
        general: 'contentNodesEmpty'
    };
    // Leave early when there's TinyMCE or borked content
    if (contentNodes[0].body.dynamic?.representation !== 'atlas_doc_format') return {};
    // Exclude extensions that are included into the content response as we don't need
    // to load any data for these extensions.
    const excludeExtensionIdSet = new Set((contentNodes[0].macroRenderedOutput || []).map((ext)=>ext.key));
    let documentADF;
    let candidateExtensions;
    if ((0, $6mKj3.expValEquals)('cc-proj-xl-dedup-macro-preload-adf-parsing', 'isEnabled', true)) {
        documentADF = (0, $c9US3.parseContentNodesAdf)(contentNodes);
        if (!documentADF) return;
        candidateExtensions = (0, $hSTGC.collectExtensionNodes)(documentADF).filter((node)=>(0, $8pcS0.supportedExtensions).has(node.type));
    } else {
        try {
            documentADF = JSON.parse(contentNodes[0].body.dynamic.value);
        } catch  {
            // While contentNodes[0].body.dynamic.value should be defined in all valid cases,
            // and should it not, the experience for the user will be broken anyway, we want
            // to swallow this error, skip macros preloading and let SPA handle the case, as
            // SPA already have proper experience tracking.
            return;
        }
        candidateExtensions = $64a1b8a95751bd5c$var$extractExtensions(documentADF);
    }
    const toMacroQueryParams = $64a1b8a95751bd5c$var$createMacroQueryParamsProvider(documentADF);
    const extensions = candidateExtensions.filter($64a1b8a95751bd5c$var$byExcluded(excludeExtensionIdSet, numberOfExtensionsToSSR || (0, $cd2d56ef117b2819$export$e87714e2a0c200ee))).filter((node)=>!renderOnlyExtensionKeys || renderOnlyExtensionKeys.includes(node?.attrs?.extensionKey)).map(toMacroQueryParams);
    if (numberOfExtensionsToSSR === 0) return extensions.length === 0 ? {} : undefined;
    // eslint-disable-next-line check-preloaders/no-promise-all
    const preloadResult = await Promise.all(extensions.map(async (extensionADF)=>{
        const { isMacroContentAndBody: isMacroContentAndBody, ...variables } = (0, $8mIlz.getMacroQueryVariables)({
            adf: extensionADF,
            contentId: contentId
        });
        const attr = extensionADF.attrs;
        const extensionKey = attr?.extensionKey;
        const failure = (reason)=>({
                [`${extensionKey}:${$64a1b8a95751bd5c$var$getMacroId(extensionADF)}`]: reason
            });
        const failureIfNotSuccess = (reason)=>(success)=>success ? undefined : failure(reason);
        // we may block some extensions via feature flags
        if ($64a1b8a95751bd5c$var$isBlocklisted(blocklistedExtensions, extensionKey)) return failure('blocklist');
        let macroBodyPreloadPromise = Promise.resolve(undefined);
        if (extensionADF.type === (0, $8pcS0.BODIED_EXTENSION_TYPE)) macroBodyPreloadPromise = (0, $wPrRK.slowQueryGuard)(`ExtensionContentConverter_${extensionKey || 'unknown'}`, ()=>{
            return (0, $dYU3e.query)({
                variables: (0, $92uc5.getContentConverterVariables)({
                    content: extensionADF.content,
                    contentId: contentId
                }),
                query: (0, $6Cce7.ContentConverterQuery),
                context: {
                    single: true
                },
                __callerPackage__: "fabric-extension-handlers"
            });
        }, macroTimeout).then(failureIfNotSuccess('timeout-macrobody'));
        const macroPreloadPromise = (0, $wPrRK.slowQueryGuard)(`Extension_${extensionKey || 'unknown'}`, ()=>{
            return isMacroContentAndBody ? (0, $dYU3e.query)({
                query: (0, $eqB7W.default),
                variables: variables,
                context: {
                    single: true
                },
                __callerPackage__: "fabric-extension-handlers"
            }) : (0, $dYU3e.query)({
                query: (0, $b1ypt.default),
                variables: variables,
                context: {
                    single: true
                },
                __callerPackage__: "fabric-extension-handlers"
            });
        }, macroTimeout).then(failureIfNotSuccess('timeout'));
        // eslint-disable-next-line check-preloaders/no-promise-all
        const [macroPreloadResult, macroBodyPreloadResult] = await Promise.all([
            macroPreloadPromise,
            macroBodyPreloadPromise
        ]);
        return {
            ...macroPreloadResult,
            ...macroBodyPreloadResult
        };
    }));
    const preloadFailures = preloadResult ? preloadResult.filter((item)=>!!item) : [];
    return Object.assign({}, ...preloadFailures);
};
async function $64a1b8a95751bd5c$export$f860aab1074a1289(contentId, contentNodes, extensionsBlocklist, numberOfExtensionsToSSR = (0, $cd2d56ef117b2819$export$e87714e2a0c200ee), renderOnlyExtensionIds) {
    // Function has early return so we extracted it out to avoid setting global in every return
    return window['__SSR_MACRO_PRELOAD_TOPX_FAILS__'] = await $64a1b8a95751bd5c$var$preloadMacrosSSRAndReturnTopXFailed(contentId, contentNodes, numberOfExtensionsToSSR, renderOnlyExtensionIds, extensionsBlocklist);
}





















var $gK2Sc = parcelRequire("gK2Sc");














const $eb281dfded33b271$var$NIL_UUID = '00000000-0000-0000-0000-000000000000';
const $eb281dfded33b271$var$extractExtensions = (adf)=>(0, $llqlc.filter)(adf, (node)=>(0, $8pcS0.supportedExtensions).has(node.type));
const $eb281dfded33b271$export$62987d2cbce2773d = (contentNodes)=>{
    try {
        if ((0, $6mKj3.expValEquals)('cc-proj-xl-dedup-macro-preload-adf-parsing', 'isEnabled', true)) {
            const adf = (0, $c9US3.parseContentNodesAdf)(contentNodes);
            return !!adf && (0, $hSTGC.collectExtensionNodes)(adf).some((node)=>(0, $8pcS0.supportedExtensions).has(node.type));
        }
        const adf = JSON.parse(contentNodes[0].body.dynamic.value);
        const extensions = $eb281dfded33b271$var$extractExtensions(adf);
        return extensions.length > 0;
    } catch  {
        return false;
    }
};
const $eb281dfded33b271$var$failureIfNotSuccess = (reason)=>(success)=>success ? undefined : {
            MacrosQuery_extensions: reason
        };
const $eb281dfded33b271$var$preloadMacrosSSRAndReturnTopXFailed = async (contentId, contentNodesOrPromise)=>{
    const { cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
    const blocklist = (0, $ld6xp.getEffectiveMultiMacroQueryBlocklist)();
    const isContentNodePromise = typeof contentNodesOrPromise?.then === 'function';
    if (contentNodesOrPromise && !isContentNodePromise) {
        if (!$eb281dfded33b271$export$62987d2cbce2773d(contentNodesOrPromise)) return {};
    }
    const noExtensionsSignal = new Promise((resolve)=>{
        if (isContentNodePromise) contentNodesOrPromise.then((contentNodes)=>{
            if (!$eb281dfded33b271$export$62987d2cbce2773d(contentNodes)) resolve();
        });
    });
    // NOTE: prealod is not a type. It was created with a typo https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/confluence_frontend_prealod_macro_timeout
    const macroTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_prealod_macro_timeout', (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    const macrosQueryTask = ()=>(0, $wPrRK.slowQueryGuard)('MacrosQuery_preload', ()=>(0, $dYU3e.query)({
                variables: {
                    first: (0, $cd2d56ef117b2819$export$e87714e2a0c200ee),
                    staticFirst: (0, $cd2d56ef117b2819$export$e87714e2a0c200ee),
                    contentId: contentId,
                    cloudId: cloudId || $eb281dfded33b271$var$NIL_UUID,
                    blocklist: blocklist
                },
                query: (0, $gK2Sc.default),
                context: {
                    single: true
                },
                __callerPackage__: "fabric-extension-handlers"
            }), macroTimeout, noExtensionsSignal).then($eb281dfded33b271$var$failureIfNotSuccess('timeout-rendered-macros'));
    const preloadResult = await macrosQueryTask();
    return preloadResult ? Object.assign({}, preloadResult) : {};
};
async function $eb281dfded33b271$export$b470c165ef60e727(contentId, contentNodesOrPromise) {
    const topXFailed = await $eb281dfded33b271$var$preloadMacrosSSRAndReturnTopXFailed(contentId, contentNodesOrPromise);
    window['__SSR_MACRO_PRELOAD_TOPX_FAILS__'] = topXFailed;
    return topXFailed;
}



const $7411787db12277fb$var$preloadMacrosSSRQuery = async ({ contentId: contentId, useMultipleMacrosQuery: useMultipleMacrosQuery, contentNodes: contentNodes, numberOfExtensionsToSSR: numberOfExtensionsToSSR = (0, $cd2d56ef117b2819$export$e87714e2a0c200ee) })=>{
    if (useMultipleMacrosQuery) return (0, $eb281dfded33b271$export$b470c165ef60e727)(contentId, contentNodes);
    else {
        const legacyBlocklistedExtensions = (0, $1xpoY.default).getString((0, $cd2d56ef117b2819$export$717eaf20c85e91ca), '');
        // if we're using MacrosQuery but this is the call for the old query, we need to
        // check if there are any blocklisted (for the Macros query) macros on the page
        // and attempt to use the old queries to render them instead
        const blocklistedExtensions = (0, $ld6xp.getLegacyIndividualMacroQueryKeys)();
        return (0, $64a1b8a95751bd5c$export$f860aab1074a1289)(contentId, contentNodes, legacyBlocklistedExtensions, numberOfExtensionsToSSR, blocklistedExtensions);
    }
};
const $7411787db12277fb$export$64dcb3aec0dc81b3 = async ({ contentId: contentId, useMultipleMacrosQuery: useMultipleMacrosQuery, contentNodes: contentNodes, numberOfExtensionsToSSR: numberOfExtensionsToSSR = (0, $cd2d56ef117b2819$export$e87714e2a0c200ee) })=>{
    return $7411787db12277fb$var$preloadMacrosSSRQuery({
        contentId: contentId,
        useMultipleMacrosQuery: useMultipleMacrosQuery,
        contentNodes: contentNodes,
        numberOfExtensionsToSSR: numberOfExtensionsToSSR
    });
};



var $7K6Nt = parcelRequire("7K6Nt");


var $1i2qc = parcelRequire("1i2qc");











var $bS81H = parcelRequire("bS81H");

const $151aa4f2ef9a59b5$export$94fce4b5db3cb85f = ()=>(0, $9wGTI.fg)('cc-dlp_split-attachment-dl-from-export-dsp') ? 'ATTACHMENT_DOWNLOAD' : 'PAGE_EXPORT';
const $151aa4f2ef9a59b5$export$1b20920d4fbafebb = async (contentId, spaceKey, action, data)=>{
    const isActionEnabledForContent = data?.dataSecurityPolicy?.isActionEnabledForContent ? {
        action: action,
        allowed: data.dataSecurityPolicy.isActionEnabledForContent.allowed || false
    } : null;
    const cacheData = isActionEnabledForContent ? {
        dataSecurityPolicy: {
            isActionEnabledForContent: isActionEnabledForContent
        }
    } : {
        dataSecurityPolicy: null
    };
    (0, $fEmGS.writeQueryInterop)({
        query: (0, $bS81H.default),
        variables: {
            action: action,
            contentId: contentId,
            contentStatus: 'CURRENT',
            contentVersion: 1,
            spaceKey: spaceKey
        },
        data: cacheData,
        __callerPackage__: "fabric-media-support"
    });
};
const $151aa4f2ef9a59b5$export$dc87c93837fe9dba = async (contentId, spaceKey)=>{
    const action = $151aa4f2ef9a59b5$export$94fce4b5db3cb85f();
    const response = await (0, $dYU3e.query)({
        query: (0, $bS81H.default),
        variables: {
            action: action,
            contentId: contentId,
            contentStatus: 'CURRENT',
            contentVersion: 1,
            spaceKey: spaceKey
        },
        __callerPackage__: "fabric-media-support"
    });
    return response;
};



var $aOHMQ = parcelRequire("aOHMQ");


var $iffSy = parcelRequire("iffSy");


var $28DDG = parcelRequire("28DDG");


var $22UVa = parcelRequire("22UVa");


var $1NBp8 = parcelRequire("1NBp8");


var $dhOY2 = parcelRequire("dhOY2");


var $7tT2b = parcelRequire("7tT2b");





var $axutP = parcelRequire("axutP");

function $853f14d41fe05930$export$fb43949e55e0c9d2({ cloudId: cloudId, spaceKey: spaceKey }) {
    return (0, $dYU3e.query)({
        query: (0, $axutP.default),
        variables: {
            cloudId: cloudId,
            spaceKey: spaceKey
        },
        __callerPackage__: "team-presence"
    });
}






var $9ycGg = parcelRequire("9ycGg");

parcelRequire("8nle6");



var $gBI6h = parcelRequire("gBI6h");


var $lt4mJ = parcelRequire("lt4mJ");


var $eSLr0 = parcelRequire("eSLr0");


var $5Rwa0 = parcelRequire("5Rwa0");








var $7Ndnw = parcelRequire("7Ndnw");


var $8CHHT = parcelRequire("8CHHT");


var $gDMf3 = parcelRequire("gDMf3");





var $e5EnV = parcelRequire("e5EnV");

function $c44bc7c35ccb995d$export$b39ebabf96e926c8(id) {
    return (0, $dYU3e.query)({
        query: (0, $e5EnV.default),
        variables: {
            id: id
        },
        __callerPackage__: "no-permission"
    });
}


/**
 * @generated SignedSource<<6cfad544b1efb06291d5fcad35698373>>
 * @relayHash e7d986c9db7dfd3a42ef96015dfa9ca2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fec66635336d0d806dec6091a699738ecb8314e2e4abfaa9b3a98e3d7d6f4de4
const $3b467652a5c14364$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accessRequestedAaid"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accessRequestedAaid",
                    "variableName": "accessRequestedAaid"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ConfluencePendingAccessRequest",
            "kind": "LinkedField",
            "name": "confluence_pendingRequestExists",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isPendingAccessRequestExists"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadPendingRequestExistsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadPendingRequestExistsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "e7d986c9db7dfd3a42ef96015dfa9ca2",
            "id": "fec66635336d0d806dec6091a699738ecb8314e2e4abfaa9b3a98e3d7d6f4de4",
            "metadata": {},
            "name": "preloadPendingRequestExistsQuery",
            "operationKind": "query",
            "text": "query preloadPendingRequestExistsQuery($accessRequestedAaid:String!,$cloudId:ID!,$contentId:ID!){confluence_pendingRequestExists(accessRequestedAaid:$accessRequestedAaid,cloudId:$cloudId,contentId:$contentId){isPendingAccessRequestExists}}"
        }
    };
}();
$3b467652a5c14364$var$node.hash = "cdc10e1c835031af29b6e3680fe359e2";
var $3b467652a5c14364$export$2e2bcd8739ae039 = $3b467652a5c14364$var$node;





const $5df28dcef89e2fae$var$PreloadPendingRequestExistsQuery = (0, $3b467652a5c14364$export$2e2bcd8739ae039);
function $5df28dcef89e2fae$export$c898ae6157713bd7(contentId, cloudId, accessRequestedAaid) {
    return (0, $dYU3e.query)({
        query: $5df28dcef89e2fae$var$PreloadPendingRequestExistsQuery,
        variables: {
            accessRequestedAaid: accessRequestedAaid,
            cloudId: cloudId,
            contentId: contentId
        },
        __callerPackage__: "no-permission"
    });
}









var $6jrkJ = parcelRequire("6jrkJ");


var $hiC7Y = parcelRequire("hiC7Y");

async function $9388622078562d65$export$8a2490b7cfbfffb0() {
    const { isLoggedIn: isLoggedIn } = (0, $xwvlW.getPreloaderFnContext)();
    if (!isLoggedIn || !(0, $6jrkJ.getSuperAdminClaim)()) return;
    return (0, $dYU3e.query)({
        query: (0, $hiC7Y.default),
        __callerPackage__: "super-admin"
    });
}



var $3U5ab = parcelRequire("3U5ab");










async function $e85a231992f6246b$export$2563ff426f0d0b3b() {
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: [
                (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN
            ]
        },
        __callerPackage__: "experiment-omnibar"
    });
}



var $jsQRz = parcelRequire("jsQRz");





var $eDV4X = parcelRequire("eDV4X");


var $fD4xZ = parcelRequire("fD4xZ");

function $4e24c7560d847d2b$export$1c5f808d33dd5bee({ contentId: contentId }) {
    if (!contentId) return Promise.resolve();
    return (0, $dYU3e.query)({
        query: (0, $fD4xZ.default),
        variables: {
            contentId: contentId,
            status: (0, $eDV4X.ALLOWED_CONTENT_STATUSES)
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "labels"
    });
}



var $jkwMx = parcelRequire("jkwMx");








var $9xoMO = parcelRequire("9xoMO");




const $ae623fc05873186d$export$8770175d3079e1c0 = [
    'onboarding-origin-state:attributes',
    'onboarding-state:isFoundingAdmin',
    'onboarding-state:isRedactionsTourVisible',
    'onboarding-state:isContentWrapperLabelsTourDismissed',
    'onboarding-state:isMoreActionsTourVisible',
    'onboarding-state:isMoreActionsHintVisible',
    'random:ShareAndRestrictDialog:spotlightSeen',
    'home-onboarding-takeover-v2:hasSeenHomeNudge',
    'home-onboarding-takeover-v2:isHomeNudgeScheduledAt',
    'home-onboarding-takeover-v2:takeoverSeenAt',
    'home-onboarding-takeover-v2:onboardingActionStates',
    'home-onboarding-takeover-v2:isCollapsed',
    'home-onboarding-takeover-v2:hasSeenConfetti',
    'home-onboarding-takeover-v2:hasDismissedCarousel',
    'home-onboarding-takeover-v2:hasDismissedLearningResources',
    'home-onboarding-takeover-v2:hasDismissedTakeover',
    'editor-state:editorOnboardingEligiblity',
    'editor-state:editorVisited',
    'editor-state:wasDraftBannerSeen',
    'editor-state:isDraftBannerVisible',
    'editor-state:isLandInEditorBannerVisible',
    'editor-state:hasUserPublished',
    'editor-state:successFlagCompleted',
    'editor-state:recentSpotlightOpen',
    'editor-state:recentSpotlightCompleted',
    'editor-state:editorTutorialSuccessFlagCompleted',
    'editor-state:wasEditorConversionModalSeen',
    'onboarding-intent-experiences:onboardingIntentExperienceClosed',
    'onboarding-intent-experience:isOnboardingExperienceEligibleUser',
    'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt',
    'onboarding-intent-experiences:onboardingIntentExperienceLandClosed',
    'page:pagePresenceAvatarGroupSpotlightSeen',
    'page:pageTelepointerAvatarGroupSpotlightSeen',
    'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed',
    'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt',
    'onboarding-insights:hasContextualFloatingButtonBeenSeen',
    'trial-components:dismissedTrialnullDayFlag',
    'onboarding-contextual-invite-nudge:contextualInviteNudgeEligibleTag',
    'onboarding-contextual-invite-nudge:wasFirstPublishConfettiSeen',
    'land-in-sample-space:hasDismissedBanner',
    'land-in-sample-space:hasSeenSampleContentFlag',
    'live-page-nudge:wasLivePageNudgeSeen',
    'nav4:isNav4GlobalSpotlightDismissed',
    'nav4:isNav4SpaceTourDismissed',
    'personalized-templates-v2:onboardingActionStates',
    'personalized-templates-v2:hasDismissedOnboardingActions',
    'personalized-templates-v2:takeoverSeenAt',
    'personalized-templates-v2:isTemplateListDismissed',
    'personalized-templates-v2:templateUsageValues',
    'templates-collection:isTaggedForTemplatesCollectionExperiment',
    'templates-collection:isTemplatesSectionDismissed',
    'onboarding-state:introWorkflow',
    'onboarding-state:legacy',
    'onboarding-state:isSampleContentV2SpotlightVisible',
    'onboarding-state:landOnPath',
    'onboarding-state:teamSpaceCreated',
    'onboarding-state:improvedGetStartedPath',
    'onboarding-state:improvedGetStartedWhiteboardPath',
    'nav4:isNav4CollapseReminderSpotlightDismissed',
    'storage-enforcement-state:flagsDismissedFreeThreshold',
    'onboarding-state:nthUserOnboardingFlagViewed',
    'onboarding-state:nthUserOnboardingCompletedTimestamp',
    'onboarding-state:nthUserOnboardingPageViewed',
    'onboarding-state:nthUserGSPagePath',
    'onboarding-state:nthUserBannerDismissed'
];
const $ae623fc05873186d$export$c279cfd6dfc47585 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: (0, $9wGTI.fg)('confluence_preload_all_onboarding_keys') ? (0, $9xoMO.OnboardingKeysCombined) : $ae623fc05873186d$export$8770175d3079e1c0
        },
        __callerPackage__: "onboarding-helpers"
    });
};






var $1swiX = parcelRequire("1swiX");





var $dpyxe = parcelRequire("dpyxe");





var $cRQNp = parcelRequire("cRQNp");


var $3Tnjq = parcelRequire("3Tnjq");


var $2QBQR = parcelRequire("2QBQR");














var $aqBZ0 = parcelRequire("aqBZ0");


var $ccWUN = parcelRequire("ccWUN");


var $gFF2G = parcelRequire("gFF2G");

function $12c3454d795c5c51$export$3ae0996a709f5fba(contentId) {
    if (!contentId) return Promise.resolve();
    return (0, $dYU3e.query)({
        query: (0, $gFF2G.default),
        variables: {
            contentId: contentId
        },
        __callerPackage__: "archive-pages"
    }).then(({ data: data })=>{
        const contentStatus = data?.content?.nodes?.[0]?.status;
        const isContentArchived = contentStatus === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED);
        if (isContentArchived) return (0, $dYU3e.query)({
            query: (0, $ccWUN.default),
            variables: {
                contentId: contentId
            },
            __callerPackage__: "archive-pages"
        });
        return Promise.resolve();
    });
}


function $d3f749dabb808bb9$export$8114133102d6f1fd(contentId, spaceKey) {
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $fyUox.preloadPageTitleContentProperties)({
            contentId: contentId,
            spaceKey: spaceKey
        }),
        (0, $12c3454d795c5c51$export$3ae0996a709f5fba)(contentId)
    ]);
}



var $4trRg = parcelRequire("4trRg");









var $gad6U = parcelRequire("gad6U");

const $cc003fd311374024$export$7261e64a95ae02eb = (contentId)=>{
    return (0, $dYU3e.query)({
        query: (0, $gad6U.default),
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "audio"
    });
};


/**
 * Preloads approval data for SSR.
 */ 
var $c0rhi = parcelRequire("c0rhi");





var $lKLmX = parcelRequire("lKLmX");


var $iOp5s = parcelRequire("iOp5s");

function $fa8eaa7cdcb1d432$export$2d00200c8fdc5d86({ cloudId: cloudId, contentId: contentId, contentStatus: contentStatus, spaceKey: spaceKey }) {
    const otherContentStatus = contentStatus === 'CURRENT' ? 'DRAFT' : 'CURRENT';
    return (0, $c0rhi.queryInterop)({
        query: (0, $lKLmX.default),
        errorPolicy: 'all',
        variables: {
            cloudId: cloudId,
            contentId: contentId,
            contentStatus: contentStatus,
            otherContentStatus: otherContentStatus,
            transitionType: null,
            spaceKey: spaceKey,
            includeApprovalsBetaFeatures: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true),
            includeApprovalExpirationConfig: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) && (0, $6mKj3.expValEquals)('confluence_approvals_expiration', 'isEnabled', true)
        },
        __callerPackage__: "approvals"
    }).then((result)=>{
        (0, $iOp5s.markApprovalsDisabledErrorAsHandled)(result.error);
        return result;
    });
}



var $3HGWr = parcelRequire("3HGWr");


var $cHjca = parcelRequire("cHjca");







const $74a3014e04345b66$export$a1e3459e1c2dacd8 = ()=>{
    const participantStatuses = [];
    return {
        schedule: (participant, createTask)=>{
            participantStatuses.push({
                participant: participant,
                status: 'scheduled'
            });
            return createTask();
        },
        skip: (participant)=>{
            participantStatuses.push({
                participant: participant,
                status: 'skipped'
            });
        },
        getParticipantStatuses: ()=>participantStatuses
    };
};


const $445d6fd463fd83fa$var$DEFAULT_PRELOAD_RECOMMENDATION_TIMEOUT = 700;
const $445d6fd463fd83fa$var$createPreloadContentTask = (contentId, isBlog, spaceKey, cloudId, activationId, isLoggedIn, contentNodesPromiseResolve, userId, agentSessionsEnabled, isAccessLinkRoute, shouldUseRouteOwnedMedia = false, shouldUseRouteOwnedDsp = false, shouldUseRouteOwnedCustomChrome = false, deferRestrictions = false, includeRestrictionAncestors = false)=>{
    const autohighlightsQueryVariables = isLoggedIn && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_autohighlights_unified_query') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false) ? (0, $hu6Tz.getAutohighlightsQueryVariables)({
        contentId: contentId,
        cloudId: cloudId,
        activationId: activationId,
        contentType: isBlog ? 'blogpost' : 'page'
    }) : undefined;
    // Managed (external) labels: warm the `useExternalLabels_query` spread on
    // `ContentUnifiedQuery` when the managed-labels feature is on. Blogs are
    // excluded (managed labels are page-scoped). This net-new feature has no
    // existing read path to migrate, so it is gated solely on its own feature gate
    // (not the `confluence_exp_vp_document` document-contract experiment). Derived
    // identically to the client read (`buildExternalLabelsAri` +
    // `useExternalLabelsFragmentVariables`) so SSR warm and hydrated read share one
    // logical operation.
    const externalLabelsQueryVariables = !isBlog && cloudId && contentId && (0, $9wGTI.fg)('confluence_managed_external_labels_endpoint') ? {
        cloudId: cloudId,
        ari: (0, $jkwMx.buildExternalLabelsAri)(cloudId, contentId)
    } : undefined;
    const dspAction = shouldUseRouteOwnedDsp ? (0, $151aa4f2ef9a59b5$export$94fce4b5db3cb85f)() : undefined;
    return (0, $kkLBe.prepareGuardExceptionTask)('Content', ()=>(0, $1acff4ea84553836$export$97ce9ab4bdd6b3fc)({
            contentId: contentId,
            isBlog: isBlog,
            spaceKey: spaceKey,
            userId: userId,
            agentSessionsEnabled: agentSessionsEnabled,
            isAccessLinkRoute: // @ts-ignore -- Downstream packages are checked against the last generated package declaration.
            isAccessLinkRoute,
            // @ts-ignore -- Downstream packages are checked against the last generated package declaration.
            hasDocumentContractAnalyticsByline: true,
            // @ts-ignore -- Downstream packages are checked against the last generated package declaration.
            hasDocumentContractContentHeader: true,
            ...autohighlightsQueryVariables ? {
                autohighlightsQueryVariables: autohighlightsQueryVariables
            } : {},
            // @ts-ignore -- Downstream packages are checked against the last generated content-body declaration.
            ...externalLabelsQueryVariables ? {
                externalLabelsQueryVariables: externalLabelsQueryVariables
            } : {},
            // @ts-ignore -- Downstream packages are checked against the last generated package declaration.
            includeRendererAssetsMedia: shouldUseRouteOwnedMedia,
            // @ts-ignore -- Downstream packages are checked against the last generated content-body declaration.
            ...dspAction ? {
                includeRendererAssetsDsp: true,
                rendererAssetsDspAction: dspAction
            } : {},
            // @ts-ignore -- Downstream packages are checked against the last generated content-body declaration.
            ...shouldUseRouteOwnedCustomChrome ? {
                includeRendererAssetsCustomChrome: true
            } : {}
        }).then(async ({ result: result, hasErrors: hasErrors })=>{
            contentNodesPromiseResolve?.(result?.data?.content?.nodes);
            const content = result?.data?.content?.nodes?.[0];
            if (deferRestrictions && (hasErrors || !content || content.id !== contentId || content.subType === 'live' || content.subType === undefined || content.status !== 'current' && content.status !== 'archived')) await (0, $lyWac.waitForAllReturnWhenError)((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, includeRestrictionAncestors));
            if (shouldUseRouteOwnedMedia) {
                if (hasErrors) await (0, $1i2qc.preloadMediaToken)(contentId, cloudId);
                else try {
                    await (0, $1i2qc.primeMediaTokenFromRouteData)(contentId, result?.data);
                } catch (error) {
                    (0, $3mugH.ssrPrepareErrorsClient).submitError(error instanceof Error ? error : new Error('Failed to seed the media token cache from route data'), {
                        contentId: contentId,
                        cloudId: cloudId,
                        isBlog: isBlog,
                        reason: 'route-owned-media-cache-prime-failed'
                    });
                    await (0, $1i2qc.preloadMediaToken)(contentId, cloudId);
                }
            }
            if (shouldUseRouteOwnedDsp && dspAction) {
                if (hasErrors) await (0, $151aa4f2ef9a59b5$export$dc87c93837fe9dba)(contentId, spaceKey);
                else await (0, $151aa4f2ef9a59b5$export$1b20920d4fbafebb)(contentId, spaceKey, dspAction, result?.data);
            }
            if (shouldUseRouteOwnedCustomChrome) {
                if (hasErrors) await (0, $iV8Fk.preloadCustomHeaderAndFooter)(spaceKey);
                else (0, $iV8Fk.primeCustomHeaderAndFooterFromRouteData)(spaceKey, result?.data);
            }
            // Report the content query's own errors as SSR prepare errors. `preloadContent` runs with
            // `errorPolicy: 'all'`, so a failing content query resolves rather than rejecting, and this
            // task resolves with its follow-up preloads instead of the query result — so nothing ever
            // inspected `result.errors`, and a page whose body failed to load reached the renderer with
            // nothing logged anywhere. Passing the settled result (rather than a task) is intentional:
            // `waitForAllReturnWhenError` reads the `{ hasErrors, errors }` shape that `query()`
            // resolves with, and skips the expected shapes (restricted page, not found) that `query()`
            // has already marked as handled — so only unexpected failures are reported.
            await (0, $lyWac.waitForAllReturnWhenError)(result);
            if (hasErrors) {
                const restrictedPageTasks = [
                    (0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey),
                    (0, $c44bc7c35ccb995d$export$b39ebabf96e926c8)(contentId),
                    (0, $6dc053709e1de01d$export$4a518872c59a5d22)({
                        contentId: contentId,
                        draftShareId: window.location.search.match(/draftShareId=(.*?)(#|&|$)/)?.[1] ?? ''
                    })
                ];
                // Preload the pending-access-request check so the restricted-content screen can
                // render the resolved title/message during SSR instead of blanking them
                if (userId && cloudId && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc_mohiti_restricted_content_screen_ab_exp', 'isEnabled', true) && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_frontend_existing_access_request_checks', 'cohort', 'experiment')) restrictedPageTasks.push((0, $wPrRK.slowQueryGuard)('preloadPendingRequestExists', ()=>(0, $5df28dcef89e2fae$export$c898ae6157713bd7)(contentId, cloudId, userId), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT)));
                return (0, $lyWac.waitForAllReturnWhenError)(restrictedPageTasks);
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            } else var error;
        }, async (error)=>{
            // A failed document request must not remove the old restrictions preload.
            contentNodesPromiseResolve?.(undefined);
            if (deferRestrictions) await (0, $lyWac.waitForAllReturnWhenError)((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, includeRestrictionAncestors));
            throw error;
        }));
};
const $445d6fd463fd83fa$var$createContentMainTasks = (params)=>{
    const { spaceKey: spaceKey, contentId: contentId, username: username, edition: edition, isPrevEditRoute: isPrevEditRoute, isBlog: isBlog, cloudId: cloudId, activationId: activationId, isLoggedIn: isLoggedIn, contentNodesPromiseResolve: contentNodesPromiseResolve, contentNodesPromise: contentNodesPromise, isInitialLoad: isInitialLoad, userId: userId, agentSessionsEnabled: agentSessionsEnabled, isAccessLinkRoute: isAccessLinkRoute, shouldUseRouteOwnedDsp: shouldUseRouteOwnedDsp, shouldUseRouteOwnedCustomChrome: shouldUseRouteOwnedCustomChrome, routeAssetsCoordinator: routeAssetsCoordinator } = params;
    const shouldUseReadTimeFragment = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_title_byline_frag_dedup') && // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_body_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false);
    const shouldUseRouteOwnedPageMetadataBanner = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_metadata_banner_preload_dedup') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false);
    const shouldUseRouteOwnedMedia = !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_media_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false) && !(0, $6mKj3.expVal)('confluence_media_token_preload_agg_query', 'isEnabled', false);
    return [
        (0, $furnK.preloadContentHeader)({
            spaceKey: spaceKey,
            contentId: contentId,
            username: username,
            edition: edition,
            isPrevEditRoute: isPrevEditRoute,
            useNewContentTopper: true,
            isContentTypePublicLinkEligible: !isBlog,
            hasDocumentContractMetadata: true,
            hasDocumentContractClassification: true,
            hasDocumentContractBody: true,
            hasDocumentContractAnalyticsByline: true,
            hasDocumentContractContentHeader: true,
            // @ts-ignore -- Downstream packages are checked against the last generated content-body declaration.
            includeRendererAssetsMedia: shouldUseRouteOwnedMedia,
            // @ts-ignore -- Downstream packages are checked against the last generated package declaration.
            shouldPreloadPageMetadataBanner: !shouldUseRouteOwnedPageMetadataBanner,
            deferRestrictions: params.deferRestrictions
        }),
        ...!(0, $1xpoY.default).isKillSwitchOn('confluence_vp_title_byline_frag_dedup') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false) ? [] : [
            (0, $d3f749dabb808bb9$export$8114133102d6f1fd)(contentId, spaceKey),
            (0, $fyUox.preloadPageTitleContentProperties)({
                contentId: contentId,
                spaceKey: spaceKey
            })
        ],
        routeAssetsCoordinator.schedule('macro-ssr', ()=>(0, $kkLBe.prepareGuardExceptionTask)('Macros', ()=>(0, $7411787db12277fb$export$64dcb3aec0dc81b3)({
                    contentId: contentId,
                    useMultipleMacrosQuery: true,
                    contentNodes: contentNodesPromise
                }))),
        routeAssetsCoordinator.schedule('macro-data', ()=>(0, $kkLBe.prepareGuardExceptionTask)('MacroData', ()=>(0, $7K6Nt.preloadMacroData)({
                    contentNodes: contentNodesPromise,
                    context: {
                        contentId: contentId,
                        spaceKey: spaceKey
                    },
                    route: 'view'
                }))),
        routeAssetsCoordinator.schedule('content', ()=>$445d6fd463fd83fa$var$createPreloadContentTask(contentId, isBlog, spaceKey, cloudId || '', activationId, isLoggedIn, contentNodesPromiseResolve, userId, agentSessionsEnabled, isAccessLinkRoute, shouldUseRouteOwnedMedia, shouldUseRouteOwnedDsp, shouldUseRouteOwnedCustomChrome, params.deferRestrictions, edition === (0, $2QBQR.CONFLUENCE_EDITION).FREE)),
        ...!(0, $1xpoY.default).isKillSwitchOn('confluence_frontend_view_page_relay_fragment_dedup') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false) ? [] : [
            (0, $gBI6h.preloadPageStatusQuery)(contentId)
        ],
        (0, $lt4mJ.preloadLegacyBridge)({
            contentId: contentId,
            isBlog: isBlog
        }),
        ...shouldUseReadTimeFragment ? [] : [
            (0, $cRQNp.preloadReadTime)({
                contentId: contentId,
                includeContentBody: false,
                useCache: true
            })
        ],
        // SmartLinks are only preloaded on initial load, never on transitions.
        ...isInitialLoad ? [
            routeAssetsCoordinator.schedule('smart-links', ()=>(0, $9eb88ac593a96a41$export$dc2d6742e80fba3c)(contentId))
        ] : (routeAssetsCoordinator.skip('smart-links'), [])
    ];
};
const $445d6fd463fd83fa$export$9503d022471fff24 = async (match, url, isTransition = false, previousMatch = null, /**
 * Route-specific behaviour for callers that delegate here. `isAccessLinkRoute` is set by
 * `preloadAccessLinkRoute`, which knows what route it is without having to inspect the URL.
 */ options = {})=>{
    const { isLicensed: isLicensed, userId: userId, edition: edition, cloudId: cloudId, accessStatus: accessStatus, isLoggedIn: isLoggedIn, isAdminHubAIEnabled: isAdminHubAIEnabled, activationId: activationId } = (0, $xwvlW.getPreloaderFnContext)();
    const tasks = [];
    // following functions will be triggered after we load data
    const postLoadingTasks = [];
    const { spaceKey: spaceKey, contentId: contentId } = match.params;
    const username = (0, $1swiX.getUsername)(match);
    const isEmbeddedConfluence = (0, $1swiX.getIsEmbeddedConfluence)(match);
    const isBlog = Boolean((0, $kM8fE.matchBlogPage)(url));
    const isInitialLoad = !isTransition;
    const deferRestrictions = (0, $cbQWR.canDeferPageRestrictions)(match) && !options.isAccessLinkRoute && !isEmbeddedConfluence && !(0, $lJlG6.isMobileApp_DO_NOT_USE)() && !(0, $6jrkJ.getSuperAdminClaim)() && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_restrictions_on_demand') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false);
    const shouldUseRouteOwnedMedia = !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_media_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false) && !(0, $6mKj3.expVal)('confluence_media_token_preload_agg_query', 'isEnabled', false);
    const shouldUseRouteOwnedDsp = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_dsp_reader') && // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false) && (0, $9wGTI.fg)('dlp_attachment_download_respects_data_export_dsp');
    const shouldUseRouteOwnedCustomChrome = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_custom_chrome_reader') && // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false);
    const shouldUseRouteOwnedForgeExtensionList = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_forge_extension_list_reader') && // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false);
    const routeAssetsCoordinator = (0, $74a3014e04345b66$export$a1e3459e1c2dacd8)();
    // This guard schedules server-only preload work; it does not alter the React tree.
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isReactSsr = Boolean(undefined);
    const shouldPreloadNavigation = !isEmbeddedConfluence && (isInitialLoad || (0, $1swiX.shouldPreloadNavigationForTransition)(previousMatch));
    const shouldPreloadBylineConnections = isReactSsr && isInitialLoad && isLoggedIn && Boolean(cloudId) && Boolean(contentId) && !isBlog && // The existing byline UI owns exposure for this experiment.
    // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
    (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_1p_and_3p_connection_byline_experiment', 'isEnabled', true);
    // Get isArchived from cached page data
    const { isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(contentId);
    // Don't preload queries that will be updated by editor if previous route is edit_page
    const isPrevEditRoute = previousMatch?.name === (0, $1NBp8.EDIT_PAGE_V2).name || previousMatch?.name === (0, $1NBp8.EDIT_BLOG_V2).name || previousMatch?.name === (0, $1NBp8.COMPANY_HUB_EDIT).name || previousMatch?.name === (0, $1NBp8.HUB_EDIT).name;
    if (isPrevEditRoute && isTransition) // Preload for edit -> view transition
    return (0, $furnK.preloadContentHeader)({
        spaceKey: spaceKey,
        contentId: contentId,
        username: username,
        edition: edition,
        isPrevEditRoute: isPrevEditRoute,
        useNewContentTopper: true,
        isContentTypePublicLinkEligible: !isBlog,
        hasDocumentContractMetadata: true,
        hasDocumentContractClassification: true,
        // @ts-ignore -- Downstream packages are checked against the last generated package declaration.
        hasDocumentContractAnalyticsByline: true,
        hasDocumentContractContentHeader: true,
        // @ts-ignore -- Downstream packages are checked against the last generated content-body declaration.
        includeRendererAssetsMedia: shouldUseRouteOwnedMedia
    });
    // ViewPageGateway wraps the entire page and renders nothing until useIsSuperAdmin settles, so
    // this has to resolve before render or no content is emitted. See preloadIsSuperAdmin for the
    // conditions under which it issues a request; it is a no-op for everyone else.
    tasks.push((0, $9388622078562d65$export$8a2490b7cfbfffb0)());
    if (!isPrevEditRoute && !deferRestrictions) tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, edition === (0, $2QBQR.CONFLUENCE_EDITION).FREE));
    if (isLoggedIn && edition === (0, $2QBQR.CONFLUENCE_EDITION).PREMIUM && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) tasks.push((0, $fa8eaa7cdcb1d432$export$2d00200c8fdc5d86)({
        cloudId: cloudId,
        contentId: contentId,
        contentStatus: 'CURRENT',
        spaceKey: spaceKey
    }));
    // Content types header (object header) + Unified Share and Restrict Button
    tasks.push((0, $eS4vC.createDataFetcherForSuspense)('content-types-header', ()=>{
        const contentTypesHeaderPreloadTasks = [];
        if ((0, $1xpoY.default).isKillSwitchOn('confluence_vp_access_frag_reader') || !(0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false)) {
            if ((0, $9wGTI.fg)('confluence_frontend_usd_ssr')) contentTypesHeaderPreloadTasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
        }
        if ((0, $1xpoY.default).isKillSwitchOn('confluence_vp_obj_header_frag_dedup') || !(0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false)) contentTypesHeaderPreloadTasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId));
        // preload data for whether "unpublished changes" label should show in view page object header
        contentTypesHeaderPreloadTasks.push((0, $4vyfK.preloadWebItemLocation)({
            location: 'page.metadata.banner',
            contentId: contentId
        }));
        // (No need to call preloadPageRestrictionsQuery() here; it will be called by
        //  preloadContentHeader() )
        return contentTypesHeaderPreloadTasks;
    }));
    if (isReactSsr && isInitialLoad && // Bifrost cannot deliver Statsig exposures. The byline render callsites evaluate the
    // same experiment through the Statsig client after SSR hydration.
    // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
    (0, $6mKj3.UNSAFE_expValNoExposure)('confluence_ssr_byline', 'isEnabled', false)) tasks.push((0, $eS4vC.createDataFetcherForSuspense)('byline-apps', ()=>[
            (0, $4vyfK.preloadWebItemLocation)({
                contentId: contentId,
                location: (0, $eSLr0.SYSTEM_CONTENT_BYLINE)
            }),
            (0, $8CHHT.preloadUseExtensionList)({
                contentId: contentId,
                spaceKey: spaceKey,
                moduleType: (0, $7Ndnw.FORGE_MODULE_BYLINE)
            }).then(// Property keys depend on Forge discovery, not the rest of content-main.
            ()=>(0, $9L8Ms.preloadBylineAppContentProperties)(contentId))
        ]));
    // Content main
    let contentNodesPromiseResolve = undefined;
    const contentNodesPromise = new Promise((resolve)=>{
        contentNodesPromiseResolve = resolve;
    });
    tasks.push((0, $eS4vC.createDataFetcherForSuspense)('content-main', ()=>{
        const mainTasks = $445d6fd463fd83fa$var$createContentMainTasks({
            spaceKey: spaceKey,
            contentId: contentId,
            username: username,
            edition: edition,
            isPrevEditRoute: isPrevEditRoute,
            isBlog: isBlog,
            cloudId: cloudId,
            activationId: activationId,
            isLoggedIn: isLoggedIn,
            contentNodesPromiseResolve: contentNodesPromiseResolve,
            contentNodesPromise: contentNodesPromise,
            isInitialLoad: isInitialLoad,
            userId: userId,
            // confluence-feature-gating/inline-usage: must be inlined
            agentSessionsEnabled: (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true),
            isAccessLinkRoute: options.isAccessLinkRoute,
            shouldUseRouteOwnedDsp: shouldUseRouteOwnedDsp,
            shouldUseRouteOwnedCustomChrome: shouldUseRouteOwnedCustomChrome,
            deferRestrictions: deferRestrictions,
            routeAssetsCoordinator: routeAssetsCoordinator
        });
        if (shouldPreloadBylineConnections) {
            mainTasks.push((0, $3HGWr.preloadIncomingLinksSsrState)({
                cloudId: cloudId,
                contentId: contentId,
                route: 'view'
            }));
            mainTasks.push((0, $cHjca.preloadOutboundBylineSsrState)(contentId));
        }
        if (isInitialLoad && isLoggedIn) {
            const preloadRecommendations = ()=>(0, $dhOY2.preloadEndOfPageRecommendation)({
                    contentId: contentId,
                    spaceKey: spaceKey,
                    contentType: isBlog ? 'blogpost' : 'page',
                    cloudId: cloudId
                });
            const createEndOfPageDataFetcher = (includeRecommendations)=>(0, $eS4vC.createDataFetcherForSuspense)('end-of-page-recommendations', ()=>{
                    const endOfPageTasks = includeRecommendations ? [
                        preloadRecommendations()
                    ] : [];
                    if (!isBlog && // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
                    (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_3p_in_related_content', 'shouldEvaluate', true)) endOfPageTasks.push((0, $kquO1.preloadOutgoingLinks)(contentId));
                    return endOfPageTasks;
                });
            if ((0, $9wGTI.fg)('confluence_eop_recs_content_main_preload')) // Layout and comment consumers share this query with the end-of-page widget,
            // so the common content-main ancestor owns it in the treatment path.
            mainTasks.push(preloadRecommendations(), createEndOfPageDataFetcher(false));
            else mainTasks.push(createEndOfPageDataFetcher(true));
        }
        return mainTasks;
    }));
    if ((0, $1xpoY.default).isKillSwitchOn('confluence_vp_mode_frag_reader') || !(0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false)) tasks.push((0, $4trRg.preloadContentMode)({
        contentId: contentId,
        isDraft: false,
        useCache: true,
        isArchived: isArchived
    }));
    // Navigation, Page tree and blog tree for blog post
    if (shouldPreloadNavigation) tasks.push((0, $eS4vC.createDataFetcherForSuspense)('side-navigation', ()=>{
        return (0, $dpyxe.preloadNavigationTasks)(spaceKey, contentId, isLicensed, isBlog, previousMatch?.params?.spaceKey);
    }));
    // Space details
    tasks.push((0, $5SzHz.preloadSpaceDetail)(spaceKey));
    // Inline Comments
    if (match?.query.focusedCommentId && !((0, $iffSy.isRelayEnabled)('@confluence/object-comments', {
        operationName: 'ObjectCommentContainerPreloadObjectCommentsQuery'
    }) && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_conversation_query') && (0, $6mKj3.expVal)('confluence_exp_conversation_contract', 'isEnabled', false))) tasks.push((0, $aOHMQ.preloadFocusedInlineComment)(match?.query.focusedCommentId, contentId));
    // Reactions
    if (!isEmbeddedConfluence || (0, $1swiX.hasEmbeddedAllowedFeatures)('page-reactions', match)) {
        // Preload whether the server has enabled reactions at all to show placeholder
        tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
            contentId: contentId,
            location: (0, $eSLr0.ATL_PAGE_CONTENT_FOOTER_ACTIONS)
        }));
        // Preload reactions asynchronously so SSR won't wait for it
        // it's best effort preloading so if it preloads then we have the data, otherwise SPA can load it
        if ((0, $1xpoY.default).isKillSwitchOn('confluence_vp_reactions_frag_reader') || !(0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false)) tasks.push((0, $9ycGg.preloadPageReactions)({
            pageId: contentId,
            containerId: spaceKey
        }));
    }
    // Recommendations
    // On initial load these are preloaded inside a suspense data fetcher above, so only transitions
    // need this standalone preload. Recommendations are only
    // preloaded for authenticated users (knowledge_discovery service requires auth).
    if (!isInitialLoad && isLoggedIn) {
        const recommendationsTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_preload_recommendation_timeout', $445d6fd463fd83fa$var$DEFAULT_PRELOAD_RECOMMENDATION_TIMEOUT);
        tasks.push((0, $wPrRK.slowQueryGuard)('preloadEndOfPageRecommendation', ()=>{
            return (0, $dhOY2.preloadEndOfPageRecommendation)({
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: isBlog ? 'blogpost' : 'page',
                cloudId: cloudId
            });
        }, recommendationsTimeout));
    }
    // Stuff only needed for initial load
    if (isInitialLoad) {
        if (!shouldUseRouteOwnedMedia) tasks.push(// We only refresh token when it is about to expire.
        (0, $1i2qc.preloadMediaToken)(contentId, cloudId || ''));
        if (!shouldUseRouteOwnedCustomChrome) tasks.push((0, $iV8Fk.preloadCustomHeaderAndFooter)(spaceKey));
        if (!shouldUseRouteOwnedDsp && (0, $9wGTI.fg)('dlp_attachment_download_respects_data_export_dsp')) tasks.push((0, $151aa4f2ef9a59b5$export$dc87c93837fe9dba)(contentId, spaceKey));
    }
    // Labels
    if (isTransition && ((0, $1xpoY.default).isKillSwitchOn('confluence_vp_meta_frag_reader') || !(0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false))) tasks.push((0, $4e24c7560d847d2b$export$1c5f808d33dd5bee)({
        contentId: contentId
    }));
    // Managed (external) labels are warmed via the `useExternalLabels_query`
    // fragment on `ContentUnifiedQuery` (see `externalLabelsQueryVariables` above),
    // so a dedicated preload task is no longer needed. The legacy label picker's
    // standalone `useExternalLabels` read is `store-or-network`, so it reads that
    // warmed store or falls back to network on dialog open.
    // Preload web panel atl_general
    if ((0, $6mKj3.expValEquals)('web_panel_query_batch_call', 'isEnabled', true)) tasks.push((0, $5Rwa0.preloadWebPanelLocations)({
        contentId: contentId,
        locations: [
            (0, $eSLr0.ATL_GENERAL),
            (0, $eSLr0.ATL_FOOTER)
        ]
    }));
    else tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_GENERAL)
    }), (0, $5Rwa0.preloadWebPanelLocation)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_FOOTER)
    }));
    // Object Sidebar Control + AI Button
    if (isAdminHubAIEnabled) tasks.push((0, $eS4vC.createDataFetcherForSuspense)('ai-floating-context-menu', ()=>(0, $28DDG.preloadAIFloatingContextMenu)(contentId, isBlog)));
    // Preload Audio Listen Button
    if ((0, $1xpoY.default).isKillSwitchOn('confluence_vp_audio_frag_reader') || !(0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false)) tasks.push((0, $cc003fd311374024$export$7261e64a95ae02eb)(contentId));
    const extensionListLoader = ()=>(0, $8CHHT.preloadUseExtensionList)({
            contentId: contentId,
            spaceKey: spaceKey,
            moduleType: (0, $7Ndnw.FORGE_MODULE_XEN_MACRO)
        });
    if (shouldUseRouteOwnedForgeExtensionList) {
        if ((0, $9wGTI.fg)('conf_frontend_forge_static_macro_mvp')) tasks.push(routeAssetsCoordinator.schedule('forge-extension-list', extensionListLoader));
        else routeAssetsCoordinator.skip('forge-extension-list');
    } else tasks.push(extensionListLoader());
    // Preload Loom button in Action Bar
    if ((accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS) && isLoggedIn) tasks.push((0, $7tT2b.preloadRecordLoomButton)({
        cloudId: cloudId,
        activationId: activationId,
        accessStatus: accessStatus,
        isLoggedIn: isLoggedIn,
        userId: userId
    }));
    // Presence Avatar Visibility
    tasks.push((0, $853f14d41fe05930$export$fb43949e55e0c9d2)({
        cloudId: cloudId,
        spaceKey: spaceKey
    }));
    // Preload definition autohighlights
    // Only preload autohighlights for authenticated users (knowledge_discovery service requires auth)
    if (isLoggedIn && ((0, $1xpoY.default).isKillSwitchOn('confluence_vp_autohighlights_unified_query') || !(0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false))) tasks.push((0, $gKMkU.preloadAutohighlights)({
        contentId: contentId,
        cloudId: cloudId,
        activationId: activationId,
        contentType: isBlog ? 'blogpost' : 'page'
    }));
    tasks.push((0, $eS4vC.createDataFetcherForSuspense)('object-comments', ()=>[
            // Preload footer comments. SSRing live pages necessitates non-server (i.e. transition)
            // preloading, so enable here too for consistency in the footer component.
            (0, $3U5ab.preloadObjectComments)(contentId, match?.query.focusedCommentId),
            // The conversation query owns this permission data when its fragment reader is enabled.
            ...!(0, $1xpoY.default).isKillSwitchOn('confluence_vp_conversation_data_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_conversation_contract', 'isEnabled', false) ? [] : [
                (0, $jsQRz.preloadAddCommentPermissionCheck)(contentId, [
                    'draft',
                    'current'
                ])
            ]
        ]));
    // Preload onboarding state for view page
    if ((accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS) && (0, $6mKj3.expVal)('confluence_pgxp_p2m_batch_1', 'isEnabled', false)) tasks.push((0, $ae623fc05873186d$export$c279cfd6dfc47585)());
    if ((0, $9wGTI.fg)('cc-ai-growth-preload-omnibar')) tasks.push((0, $e85a231992f6246b$export$2563ff426f0d0b3b)());
    // Preload Smart Create Feedback Banner
    tasks.push((0, $22UVa.preloadSmartCreateFeedbackBanner)(contentId));
    const errors = await (0, $lyWac.waitForAllReturnWhenError)(tasks);
    const postLoadingErrors = await (0, $lyWac.waitForAllReturnWhenError)(postLoadingTasks.map((task)=>task()));
    if (errors || postLoadingErrors) return [
        ...errors || [],
        ...postLoadingErrors || []
    ];
};








/**
 * @generated SignedSource<<e1d07984b577db48b7ecdd332628cb11>>
 * @relayHash 9db18599ae8276f38e57885f4b3ed842
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID edafd438720a1dc9f3ad7178421078636892a9a16b7d545d094272279358a150
const $05c40bb113a7d622$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "homepageId"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOverviewIdQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOverviewIdQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "9db18599ae8276f38e57885f4b3ed842",
            "id": "edafd438720a1dc9f3ad7178421078636892a9a16b7d545d094272279358a150",
            "metadata": {},
            "name": "SpaceOverviewIdQuery",
            "operationKind": "query",
            "text": "query SpaceOverviewIdQuery($spaceKey:String){space(key:$spaceKey){id,homepageId}}"
        }
    };
}();
$05c40bb113a7d622$var$node.hash = "7fd7786f0088a31ebf4c6fb6bedcf998";
var $05c40bb113a7d622$export$2e2bcd8739ae039 = $05c40bb113a7d622$var$node;


function $12a2f5ca95176b67$export$c390629d140bb37e(spaceKey) {
    return (0, $dYU3e.query)({
        query: (0, $05c40bb113a7d622$export$2e2bcd8739ae039),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "content-types-header"
    }).then((result)=>({
            result: result,
            hasErrors: result.hasErrors
        }));
}















var $7tHGa = parcelRequire("7tHGa");





var $gSfo4 = parcelRequire("gSfo4");


var $79mss = parcelRequire("79mss");

function $2257f3db82626244$export$fc412545d4d6ad12(contentId, contentStatus) {
    return (0, $dYU3e.query)({
        query: (0, $79mss.default),
        variables: {
            contentId: contentId,
            lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)([
                contentStatus
            ])
        },
        __callerPackage__: "data-classification"
    });
}


async function $c7f6674d8ea135ae$export$137d64ae0bf4fe94(contentId) {
    const queries = [];
    queries.push((0, $2257f3db82626244$export$fc412545d4d6ad12)(contentId, (0, $7tHGa.ContentStatus).CURRENT));
    return (0, $lyWac.waitForAllReturnWhenError)(queries);
}
































var $d3OVq = parcelRequire("d3OVq");

function $5fc5440e5bdafbe2$export$f73e4f65960ffd6e(spaceKey) {
    return (0, $dYU3e.query)({
        query: (0, $d3OVq.default),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "space-base"
    });
}












var $cEgMD = parcelRequire("cEgMD");





var $6SSyC = parcelRequire("6SSyC");

function $7df05aa0881398cb$export$ac86736f8ee66015(spaceKey) {
    return (0, $dYU3e.query)({
        query: (0, $6SSyC.default),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "screen"
    });
}






var $ixL26 = parcelRequire("ixL26");











var $3hHGU = parcelRequire("3hHGU");


var $jpSPX = parcelRequire("jpSPX");








var $3D1KL = parcelRequire("3D1KL");

function $428e758fdbd08d59$export$9a90cdaf2bd47339({ contentId: contentId, spaceKey: spaceKey }) {
    return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/fetch:pageButtons', async ()=>{
        const tasks = [
            (0, $3D1KL.preloadEditButton)({
                spaceKey: spaceKey,
                contentId: contentId
            })
        ];
        return (0, $lyWac.waitForAllReturnWhenError)(tasks);
    });
}


const $79570d1de8e3464e$export$ba9b2fb7540ef84 = (spaceKey)=>(0, $dYU3e.query)({
        query: (0, $ixL26.default),
        variables: {
            spaceKey: spaceKey,
            excludeOperations: Boolean(!(0, $cEgMD.isCompanyHubSpaceKey)(spaceKey))
        },
        __callerPackage__: "space-overview"
    });
const $79570d1de8e3464e$export$50a212ec809090eb = (spaceKey)=>{
    const { cloudId: cloudId, isRovoEnabled: isRovoEnabled } = (0, $xwvlW.getPreloaderFnContext)();
    if (!(0, $jpSPX.isSmartSpaceOverviewEnabled)({
        spaceKey: spaceKey,
        cloudId: cloudId,
        isRovoEnabled: isRovoEnabled
    })) return Promise.resolve(null);
    return (0, $dYU3e.query)({
        query: (0, $3hHGU.default),
        variables: {
            cloudId: cloudId,
            spaceKey: spaceKey
        },
        __callerPackage__: "space-overview"
    });
};
const $79570d1de8e3464e$var$preloadSpaceOverviewQueries = async ({ homepageId: homepageId = '', spaceKey: spaceKey, versionOverride: versionOverride })=>{
    const tasks = [];
    const { activationId: activationId, userId: userId, cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
    let contentNodesPromiseResolve = undefined;
    const contentNodesPromise = new Promise((resolve)=>{
        contentNodesPromiseResolve = resolve;
    });
    if (homepageId) {
        // If we know the homepageId, preload early
        tasks.push((0, $c7f6674d8ea135ae$export$137d64ae0bf4fe94)(homepageId));
        if ((0, $9wGTI.fg)('conf_frontend_forge_static_macro_mvp')) tasks.push((0, $8CHHT.preloadUseExtensionList)({
            contentId: homepageId,
            spaceKey: spaceKey,
            moduleType: (0, $7Ndnw.FORGE_MODULE_XEN_MACRO)
        }));
        if ((0, $6mKj3.expVal)('confluence_preload_content_types_header_query', 'isEnabled', false)) tasks.push((0, $4zhNK.preloadContentTypesHeader)(homepageId));
        tasks.push((0, $kkLBe.prepareGuardExceptionTask)('MacroData', ()=>(0, $7K6Nt.preloadMacroData)({
                contentNodes: contentNodesPromise,
                context: {
                    contentId: homepageId,
                    spaceKey: spaceKey
                },
                route: 'space-overview'
            })));
    }
    const autohighlightsQueryVariables = homepageId && userId && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_autohighlights_unified_query') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false) ? (0, $hu6Tz.getAutohighlightsQueryVariables)({
        contentId: homepageId,
        cloudId: cloudId,
        activationId: activationId,
        contentType: 'page'
    }) : undefined;
    tasks.push((0, $kkLBe.prepareGuardExceptionTask)('ContentAndMacros', ()=>(0, $1acff4ea84553836$export$97ce9ab4bdd6b3fc)({
            contentId: homepageId,
            spaceKey: spaceKey,
            isBlog: false,
            versionOverride: versionOverride,
            userId: userId,
            // Mirror preloadViewPageRoute so the space-overview homepage preload uses the same
            // ContentUnifiedQuery variable shape (and cache key) as the live ViewPageContainer read.
            // confluence-feature-gating/inline-usage: expValEquals must be inlined at the callsite.
            agentSessionsEnabled: (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true),
            ...autohighlightsQueryVariables ? {
                autohighlightsQueryVariables: autohighlightsQueryVariables
            } : {}
        }).then(async ({ result: result, hasErrors: hasErrors })=>{
            const preloadedContentId = result?.data?.content?.nodes?.[0]?.id;
            if (hasErrors || homepageId && preloadedContentId !== homepageId) (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`SpaceOverview preload did not produce the expected ContentUnifiedQuery entry; spaceKey=${spaceKey}; requestedHomepageId=${homepageId}; preloadedContentId=${preloadedContentId}; hasErrors=${Boolean(hasErrors)}`), {
                attribution: 'next-space-overview'
            });
            // Report the content query's own errors as SSR prepare errors. `preloadContent` runs
            // with `errorPolicy: 'all'`, so a failing content query resolves rather than rejecting,
            // and this task resolves with its follow-up preloads instead of the query result — so
            // nothing ever inspected `result.errors`. `waitForAllReturnWhenError` skips the
            // expected shapes (restricted page, not found) that `query()` marked as handled.
            await (0, $lyWac.waitForAllReturnWhenError)(result);
            const contentId = homepageId || result?.data?.content?.nodes[0]?.id;
            // in the event that there are errors (no id from result) and the homepageId is not valid (error when loading the space),
            // bypass preloadContentPrereqs since contentId is undefined
            if (!contentId) return;
            contentNodesPromiseResolve?.(result?.data?.content?.nodes);
            const promises = [];
            if (!homepageId) {
                // If we don't know the homepageId, preloadContent will tell us the id
                promises.push((0, $7411787db12277fb$export$64dcb3aec0dc81b3)({
                    contentId: contentId,
                    cloudId: cloudId,
                    useMultipleMacrosQuery: true,
                    contentNodes: result?.data?.content?.nodes
                }));
                if ((0, $9wGTI.fg)('conf_frontend_forge_static_macro_mvp')) promises.push((0, $8CHHT.preloadUseExtensionList)({
                    contentId: contentId,
                    spaceKey: spaceKey,
                    moduleType: (0, $7Ndnw.FORGE_MODULE_XEN_MACRO)
                }));
                tasks.push((0, $c7f6674d8ea135ae$export$137d64ae0bf4fe94)(contentId));
                if ((0, $6mKj3.expVal)('confluence_preload_content_types_header_query', 'isEnabled', false)) tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId));
                promises.push((0, $7K6Nt.preloadMacroData)({
                    contentNodes: result?.data?.content?.nodes,
                    context: {
                        contentId: contentId,
                        spaceKey: spaceKey
                    },
                    route: 'space-overview'
                }));
            }
            if (hasErrors) promises.push((0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey, {
                versionOverride: versionOverride
            }));
            return (0, $lyWac.waitForAllReturnWhenError)(promises);
        })), (0, $428e758fdbd08d59$export$9a90cdaf2bd47339)({
        contentId: homepageId,
        spaceKey: spaceKey
    }));
    tasks.push((0, $fyUox.preloadPageTitleContentProperties)({
        contentId: homepageId,
        spaceKey: spaceKey
    }));
    // Navigation (including page tree + blog tree) is preloaded by preloadSpaceOverviewRoute via
    // preloadNavigationTasks, so it is intentionally not preloaded here.
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};
async function $79570d1de8e3464e$export$2fae7b45037154b8({ spaceKey: spaceKey, homepageId: homepageId, homepageIdPromise: homepageIdPromise, versionOverride: versionOverride }) {
    const promises = [
        (0, $7df05aa0881398cb$export$ac86736f8ee66015)(spaceKey),
        (0, $5fc5440e5bdafbe2$export$f73e4f65960ffd6e)(spaceKey),
        (0, $iV8Fk.preloadCustomHeaderAndFooter)(spaceKey),
        $79570d1de8e3464e$export$50a212ec809090eb(spaceKey)
    ];
    if (homepageId || homepageIdPromise) {
        const resolvedHomepageId = homepageId ?? await homepageIdPromise;
        // In some case we append homepageId as a query param. Then preload with it.
        // next/packages/space-overview/src/SpaceOverview.tsx still needs SpaceOverviewQuery but others are not depending on it
        promises.push($79570d1de8e3464e$export$ba9b2fb7540ef84(spaceKey), $79570d1de8e3464e$var$preloadSpaceOverviewQueries({
            homepageId: resolvedHomepageId,
            spaceKey: spaceKey,
            versionOverride: versionOverride
        }));
        if ((0, $6mKj3.expVal)('confluence_preload_share_and_restrict_button_query', 'isEnabled', false)) promises.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(resolvedHomepageId, spaceKey));
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    } else {
        if ((0, $6mKj3.expVal)('confluence_preload_share_and_restrict_button_query', 'isEnabled', false)) // Preload share button data with spaceKey early (before homepageId is known)
        promises.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(undefined, spaceKey));
        // If we have no information on home id and yet using old query, we need to fetch it first.
        promises.push($79570d1de8e3464e$export$ba9b2fb7540ef84(spaceKey).then((res)=>{
            // Because homepageId was provided by the function caller, it may or may
            // not be out of sync with backend:
            const actualHomepageId = res?.data?.space?.homepage?.id;
            if (actualHomepageId) return $79570d1de8e3464e$var$preloadSpaceOverviewQueries({
                homepageId: actualHomepageId,
                spaceKey: spaceKey,
                versionOverride: versionOverride
            });
        }));
    }
    return (0, $lyWac.waitForAllReturnWhenError)(promises);
}











parcelRequire("8nle6");






var $jtfsl = parcelRequire("jtfsl");

function $3c8474b5b6cc7016$export$986e86a20e675444({ accountId: accountId }) {
    return (0, $dYU3e.query)({
        query: (0, $jtfsl.default),
        variables: {
            accountId: accountId
        },
        __callerPackage__: "custom-sites-extensions"
    });
}














const $de1bf574523c3b16$export$7237b12e4aa9c6c = async ()=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
    if (activationId && cloudId) return `~HUB-${cloudId}-${activationId}~`;
};











var $c3Qwv = parcelRequire("c3Qwv");































const $5cdf3a7c2cbff10f$export$2cbe0869fedf40d1 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: [
                (0, $dBcar.CROSS_JOIN_NTH_USER_ONBOARDING).TRENDING_PAGES,
                (0, $dBcar.CROSS_JOIN_NTH_USER_ONBOARDING).DISMISSED
            ]
        },
        __callerPackage__: "onboarding-helpers"
    });
};


const $fe22b38e04163065$var$homepageIdPromiseMap = new Map();
const $fe22b38e04163065$var$homepageIdMap = new Map();
const $fe22b38e04163065$var$loadHomepageId = async (spaceKey)=>{
    const { result: result, hasErrors: hasErrors } = await (0, $12a2f5ca95176b67$export$c390629d140bb37e)(spaceKey);
    return !hasErrors && result?.data?.space?.homepageId || null;
};
const $fe22b38e04163065$export$75a73f2fbf5e96e8 = async (match)=>{
    const { spaceKey: spaceKey } = match.params;
    const homepageId = match.query ? (0, $c3Qwv.getSingleParam)(match.query, (0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY) : undefined;
    if (homepageId) return;
    const homepageIdPromise = $fe22b38e04163065$var$homepageIdPromiseMap.get(spaceKey) ?? $fe22b38e04163065$var$loadHomepageId(spaceKey);
    // Keep both maps in sync - promises and actual values for synchronous access
    $fe22b38e04163065$var$homepageIdPromiseMap.set(spaceKey, homepageIdPromise);
    return homepageIdPromise.then((homepageId)=>{
        $fe22b38e04163065$var$homepageIdMap.set(spaceKey, homepageId);
    });
};
const $fe22b38e04163065$export$75071d943b36f58f = async (match, previousMatch, _url)=>{
    const { cloudId: cloudId, isLicensed: isLicensed, userId: userId, activationId: activationId, isLoggedIn: isLoggedIn } = (0, $xwvlW.getPreloaderFnContext)();
    const { spaceKey: spaceKey } = match.params;
    const initialHomepageId = match.query ? (0, $c3Qwv.getSingleParam)(match.query, (0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY) : undefined;
    const tasks = [];
    // SpaceOverview renders ViewPageContainer, so it sits behind the same ViewPageGateway
    // AdminKeyQuery gate as the view page. See preloadIsSuperAdmin for the conditions under which
    // it issues a request; it is a no-op for everyone else.
    tasks.push((0, $9388622078562d65$export$8a2490b7cfbfffb0)());
    const isCompanyHub = match.name === (0, $1NBp8.COMPANY_HUB).name;
    const companyHubSpaceKey = isCompanyHub ? await (0, $de1bf574523c3b16$export$7237b12e4aa9c6c)() : undefined;
    const versionOverride = companyHubSpaceKey && match.query ? (0, $c3Qwv.getSingleParamInt)(match.query, 'versionOverride') : null;
    const homepageId = initialHomepageId || $fe22b38e04163065$var$homepageIdMap.get(spaceKey ?? companyHubSpaceKey);
    if (spaceKey) {
        // Consolidated navigation preloading: use the shared helper (page tree + blog tree included)
        // like the view page route, instead of splitting nav queries between this route and
        // preloadSpaceOverview. Company hub has no `spaceKey` route param, so it is naturally excluded
        // here — preserving the prior behaviour where the page tree was not preloaded for company hub.
        const isCrossSpaceTransition = Boolean(previousMatch && previousMatch.params?.spaceKey !== spaceKey);
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if (isCrossSpaceTransition) tasks.push((0, $dpyxe.preloadNavigationTasks)(spaceKey, // Route-backed readers use the homepage variant even when the homepage ID is known.
        !(0, $1xpoY.default).isKillSwitchOn('confluence_space_nav_trees_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_space_nav_contract', 'isEnabled', false) ? '' : homepageId ?? '', isLicensed, false, // space overview is never a blog
        previousMatch?.params?.spaceKey));
    }
    tasks.push((0, $79570d1de8e3464e$export$2fae7b45037154b8)({
        spaceKey: spaceKey ?? companyHubSpaceKey,
        homepageId: homepageId,
        homepageIdPromise: $fe22b38e04163065$var$homepageIdPromiseMap.get(spaceKey ?? companyHubSpaceKey),
        versionOverride: versionOverride
    }));
    if (homepageId) {
        // Get isArchived from cached page data
        const { isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(homepageId ?? undefined);
        tasks.push((0, $4trRg.preloadContentMode)({
            contentId: homepageId,
            isDraft: true,
            useCache: true,
            isArchived: isArchived
        }));
    }
    tasks.push((0, $fyUox.preloadPageTitleContentProperties)({
        contentId: homepageId || '',
        contentIdPromise: $fe22b38e04163065$var$homepageIdPromiseMap.get(spaceKey ?? companyHubSpaceKey),
        spaceKey: spaceKey ?? companyHubSpaceKey
    }));
    tasks.push((0, $5SzHz.preloadSpaceDetail)(spaceKey));
    if ((0, $6mKj3.expValEquals)('cc_ssr_crossjoin_nth_user_onboarding', 'isEnabled', true)) tasks.push((0, $5cdf3a7c2cbff10f$export$2cbe0869fedf40d1)());
    if (isCompanyHub && userId) tasks.push((0, $3c8474b5b6cc7016$export$986e86a20e675444)({
        accountId: userId
    }));
    // Presence Avatar Visibility
    tasks.push((0, $853f14d41fe05930$export$fb43949e55e0c9d2)({
        cloudId: cloudId,
        spaceKey: spaceKey
    }));
    // Space Overview's homepageId is needed for the content types header, but may not be in the URL
    // depending on which route was used.  skip preloading if it's not in the url because sequential calls block SSR
    if (!isCompanyHub && homepageId) {
        tasks.push((0, $4zhNK.preloadContentTypesHeader)(homepageId));
        // Standalone Restrictions button needs to have its data preloaded)
        tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(homepageId, false));
    }
    // Unified Share and Restrict Button
    if (!isCompanyHub && homepageId && (0, $9wGTI.fg)('confluence_frontend_usd_ssr')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(homepageId));
    // Preload definition autohighlights
    // Only preload autohighlights for authenticated users (knowledge_discovery service requires auth)
    if (homepageId && isLoggedIn && (!userId || (0, $1xpoY.default).isKillSwitchOn('confluence_vp_autohighlights_unified_query') || !(0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false))) tasks.push((0, $gKMkU.preloadAutohighlights)({
        contentId: homepageId,
        cloudId: cloudId,
        activationId: activationId,
        contentType: 'page'
    }));
    // Preload media token for cover image
    if (homepageId) tasks.push((0, $1i2qc.preloadMediaToken)(homepageId, cloudId));
    if (homepageId) {
        if ((0, $6mKj3.expValEquals)('web_panel_query_batch_call', 'isEnabled', true)) tasks.push((0, $5Rwa0.preloadWebPanelLocations)({
            contentId: homepageId,
            locations: [
                (0, $eSLr0.ATL_GENERAL),
                (0, $eSLr0.ATL_FOOTER)
            ]
        }));
        else tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
            contentId: homepageId,
            location: (0, $eSLr0.ATL_GENERAL)
        }), (0, $5Rwa0.preloadWebPanelLocation)({
            contentId: homepageId,
            location: (0, $eSLr0.ATL_FOOTER)
        }));
    }
    if (!isCompanyHub && !homepageId) {
        // Unified Share and Restrict Button - preload using spaceKey to avoid chained queries
        if ((0, $9wGTI.fg)('confluence_frontend_usd_ssr')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(undefined, spaceKey));
        //moved chained queries to the bottom to unblock other queries needed to preload & to combine the contentId query
        const homepageIdPromise = $fe22b38e04163065$var$homepageIdPromiseMap.get(spaceKey) || $fe22b38e04163065$var$loadHomepageId(spaceKey);
        await homepageIdPromise.then((contentId)=>{
            tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId));
            tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId ?? '', false));
            if (contentId) {
                // Preload web panel atl_general
                if ((0, $6mKj3.expValEquals)('web_panel_query_batch_call', 'isEnabled', true)) tasks.push((0, $5Rwa0.preloadWebPanelLocations)({
                    contentId: contentId,
                    locations: [
                        (0, $eSLr0.ATL_GENERAL),
                        (0, $eSLr0.ATL_FOOTER)
                    ]
                }));
                else tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
                    contentId: contentId,
                    location: (0, $eSLr0.ATL_GENERAL)
                }), (0, $5Rwa0.preloadWebPanelLocation)({
                    contentId: contentId,
                    location: (0, $eSLr0.ATL_FOOTER)
                }));
                // Preload media token for cover image
                tasks.push((0, $1i2qc.preloadMediaToken)(contentId, cloudId));
            }
        });
    }
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};
const $fe22b38e04163065$export$d1ef19b00f2c3147 = ()=>{
    $fe22b38e04163065$var$homepageIdMap.clear();
    $fe22b38e04163065$var$homepageIdPromiseMap.clear();
};



var $7A94k = parcelRequire("7A94k");





















/**
 * @generated SignedSource<<c6f52d76f40a36d5184d0bf9735570f1>>
 * @relayHash 692b310473739d80af6d43542c26df31
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 80d9be10877ca72fa849742e6835bc1972fa04172f344617d7d379ae9262fa7b
const $f4ed30693011df84$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "referenceId",
                    "variableName": "id"
                }
            ],
            "kind": "ScalarField",
            "name": "contentIdByReferenceId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentIdByReferenceIdQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentIdByReferenceIdQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "692b310473739d80af6d43542c26df31",
            "id": "80d9be10877ca72fa849742e6835bc1972fa04172f344617d7d379ae9262fa7b",
            "metadata": {},
            "name": "ContentIdByReferenceIdQuery",
            "operationKind": "query",
            "text": "query ContentIdByReferenceIdQuery($id:String!){contentIdByReferenceId(referenceId:$id)}"
        }
    };
}();
$f4ed30693011df84$var$node.hash = "d1f8ea313ddf642c92d2df2b0f67af0d";
var $f4ed30693011df84$export$2e2bcd8739ae039 = $f4ed30693011df84$var$node;



var $d5h4f = parcelRequire("d5h4f");


var $kwaj3 = parcelRequire("kwaj3");

async function $7ba44aaf109d7b00$export$69c63edd0aeaee0b({ spaceKey: spaceKey, contentId: contentId, skipPageTree: skipPageTree = false }) {
    const preloadPromises = [
        $7ba44aaf109d7b00$var$preloadContentData(contentId, spaceKey),
        $7ba44aaf109d7b00$var$preloadSpace(spaceKey)
    ];
    return (0, $lyWac.waitForAllReturnWhenError)(preloadPromises);
}
async function $7ba44aaf109d7b00$var$preloadContentData(contentId, spaceKey) {
    const UUIDRegex = /[-]/;
    const isUuidBasedId = UUIDRegex.test(contentId);
    if (isUuidBasedId) await (0, $dYU3e.query)({
        query: (0, $f4ed30693011df84$export$2e2bcd8739ae039),
        variables: {
            id: contentId
        },
        __callerPackage__: "whiteboard-common"
    });
    else await (0, $dYU3e.query)({
        query: (0, $d5h4f.default),
        variables: {
            contentId: contentId,
            spaceKey: spaceKey === '_' && (0, $9wGTI.fg)('cc-cns-28262-fix-bad-space-key-preload') ? null : spaceKey,
            // The DSP query doesn't currently user the content version value, so using a fixed value
            contentVersion: 1
        },
        __callerPackage__: "whiteboard-common"
    });
}
async function $7ba44aaf109d7b00$var$preloadSpace(spaceKey) {
    await (0, $dYU3e.query)({
        query: (0, $kwaj3.default),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "whiteboard-common"
    });
}





















var $bcVE2 = parcelRequire("bcVE2");

const $58246c7bb1bd3b0e$var$getSingle = (value)=>Array.isArray(value) ? value[0] : value ?? undefined;
const $58246c7bb1bd3b0e$export$a8738b3e8374c78c = (match)=>{
    const isEmbedded = (0, $bcVE2.isEmbeddedWhiteboardMode)({
        parentProduct: match.query?.parentProduct,
        presentationMode: match.query?.presentationMode
    });
    const parentProduct = $58246c7bb1bd3b0e$var$getSingle(match.query?.parentProduct);
    return {
        isEmbeddedWhiteboardMode: isEmbedded,
        bypassesMainLayout: isEmbedded && (0, $9wGTI.fg)('confluence_ssr_embedded_whiteboard_preload_cache'),
        parentProduct: parentProduct,
        isSmartLinkEmbed: parentProduct === 'smartLink',
        isRovoEmbed: parentProduct === 'rovo'
    };
};


const $d639d659544153c3$export$a107836a8bcfc0c9 = async (match, _url, isTransition = false)=>{
    const { isLicensed: isLicensed } = (0, $xwvlW.getPreloaderFnContext)();
    const { bypassesMainLayout: bypassesMainLayout, isSmartLinkEmbed: isSmartLinkEmbed, isRovoEmbed: isRovoEmbed } = (0, $58246c7bb1bd3b0e$export$a8738b3e8374c78c)(match);
    const tasks = [];
    const { spaceKey: spaceKey, contentId: contentId } = match.params;
    if (!bypassesMainLayout) {
        if (!isTransition) tasks.push((0, $7A94k.preloadSpaceViews)(spaceKey, isLicensed));
    }
    // Content types header (object header)
    if (!(bypassesMainLayout && isSmartLinkEmbed)) {
        tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId));
        // Standalone Restrictions button needs to have its data preloaded)
        if (!(bypassesMainLayout && isRovoEmbed)) tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, false));
    }
    // Unified Share and Restrict Button
    if (!(bypassesMainLayout && (isSmartLinkEmbed || isRovoEmbed)) && (0, $9wGTI.fg)('confluence_frontend_usd_ssr')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
    if (!(bypassesMainLayout && isRovoEmbed)) tasks.push((0, $22UVa.preloadSmartCreateFeedbackBanner)(contentId));
    tasks.push((0, $7ba44aaf109d7b00$export$69c63edd0aeaee0b)({
        spaceKey: spaceKey,
        contentId: contentId,
        skipPageTree: bypassesMainLayout
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};























var $c7BJC = parcelRequire("c7BJC");

async function $6ac7363a4b3b3fec$export$de0a909710c86263(spaceKey, contentId) {
    return (0, $lyWac.waitForAllReturnWhenError)([
        $6ac7363a4b3b3fec$var$preloadContentData(contentId, spaceKey),
        $6ac7363a4b3b3fec$var$preloadContentTree(contentId, spaceKey)
    ]);
}
async function $6ac7363a4b3b3fec$var$preloadContentData(contentId, spaceKey) {
    await (0, $dYU3e.query)({
        query: (0, $c7BJC.default),
        variables: {
            contentId: contentId,
            spaceKey: spaceKey === '_' && (0, $9wGTI.fg)('cc-cns-28262-fix-bad-space-key-preload') ? null : spaceKey,
            // The DSP query doesn't currently user the content version value, so using a fixed value
            contentVersion: 1
        },
        __callerPackage__: "confluence-databases"
    });
}
async function $6ac7363a4b3b3fec$var$preloadContentTree(contentId, spaceKey) {}














const $f7a595baa9e6d446$export$f9f9f93ef86bfae1 = async (match, _url, isTransition = false)=>{
    const { isLicensed: isLicensed } = (0, $xwvlW.getPreloaderFnContext)();
    const tasks = [];
    const { spaceKey: spaceKey, contentId: contentId } = match.params;
    if (!isTransition) tasks.push((0, $7A94k.preloadSpaceViews)(spaceKey, isLicensed));
    tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId));
    // (No need to call preloadPageRestrictionsQuery() here; the item's restriction data will be
    //  loaded by preloadDatabaseData() below)
    // Unified Share and Restrict Button
    if ((0, $9wGTI.fg)('confluence_frontend_usd_ssr')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
    tasks.push((0, $6ac7363a4b3b3fec$export$de0a909710c86263)(spaceKey, contentId));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};


















var $1TElT = parcelRequire("1TElT");


var $65pdw = parcelRequire("65pdw");


var $4TRDb = parcelRequire("4TRDb");

const $136b2b02116ae317$var$preloadEditorData = async (contentId)=>{
    return (0, $dYU3e.query)({
        query: (0, $4TRDb.default),
        variables: {
            contentId: contentId
        },
        __callerPackage__: "smart-create-page-editor"
    });
};
const $136b2b02116ae317$export$6e1d336ae32be6c2 = async (contentId)=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        $136b2b02116ae317$var$preloadEditorData(contentId),
        (0, $1TElT.preloadEmojiTitle)(contentId, '', false),
        (0, $65pdw.preloadEditorPageCoverPicture)(contentId, '', false)
    ]);
};


const $ff76ae367134cd26$export$2a230d51c69b591b = async (contentId)=>{
    const { cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $136b2b02116ae317$export$6e1d336ae32be6c2)(contentId),
        (0, $1i2qc.preloadMediaToken)(contentId, cloudId)
    ]);
};














var $aFgFx = parcelRequire("aFgFx");


















const $a17ca091e4cf9f3d$export$18e29f32c47bffc9 = async (match, _url, isTransition = false)=>{
    const { isLicensed: isLicensed } = (0, $xwvlW.getPreloaderFnContext)();
    const tasks = [];
    const { spaceKey: spaceKey, contentId: contentId } = match.params;
    if (!isTransition) tasks.push((0, $7A94k.preloadSpaceViews)(spaceKey, isLicensed));
    // Content types header (object header)
    tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId));
    // (No need to call preloadPageRestrictionsQuery() here; the item's restriction data will be
    //  loaded by preloadEmbedData() below)
    tasks.push((0, $4trRg.preloadContentMode)({
        contentId: contentId,
        isDraft: false,
        useCache: true
    }));
    // Unified Share and Restrict Button
    if ((0, $9wGTI.fg)('confluence_frontend_usd_ssr')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
    tasks.push((0, $aFgFx.preloadEmbedData)(spaceKey, contentId));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};



var $cvj7x = parcelRequire("cvj7x");





var $fywGr = parcelRequire("fywGr");


var $h8QBE = parcelRequire("h8QBE");













const $8401ee2f6eb43799$export$6316c27636a04811 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: [
                (0, $dBcar.NTH_USER_EMOJI_TITLE_DISCOVERED).EMOJI_TITLE_DISCOVERED
            ]
        },
        __callerPackage__: "onboarding-helpers"
    });
};











const $4b6107ec1852de14$export$f487e1233221fed9 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: [
                (0, $dBcar.ONBOARDING_EXPERIENCES).NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP
            ]
        },
        __callerPackage__: "onboarding-helpers"
    });
};






var $7PLO8 = parcelRequire("7PLO8");


var $32Xjk = parcelRequire("32Xjk");

const $8332e6e273585306$export$3e6908d03c4e3a25 = (contentId)=>{
    return (0, $dYU3e.query)({
        query: (0, $32Xjk.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
        },
        __callerPackage__: "emoji-title"
    });
};


parcelRequire("8nle6");









var $8R0gj = parcelRequire("8R0gj");




var $kyd3u = parcelRequire("kyd3u");













async function $a0c935b54d4370ec$export$c6954e5932c9c91f(contentId) {
    const queries = [];
    queries.push((0, $2257f3db82626244$export$fc412545d4d6ad12)(contentId, (0, $7tHGa.ContentStatus).DRAFT));
    return (0, $lyWac.waitForAllReturnWhenError)(queries);
}



















































var $3gyyc = parcelRequire("3gyyc");


var $euL71 = parcelRequire("euL71");

/**
 * Fire-and-forget warm-up of the third-party connector-config *code chunk* that
 * `useConnectedThirdPartyProductKeys` loads at editor mount (for the
 * `confluence_quick_insert_embeds` experiment).
 *
 * Dynamically importing `@atlassian/rovo-connectors-config/hooks` during the
 * edit-route preload — before `FullPageEditorComponent` mounts — means the
 * module and its dependency graph are already fetched, parsed, and evaluated by
 * the time the editor needs them, keeping that JS cost off the hydration
 * critical path.
 *
 * IMPORTANT: this intentionally does NOT call `get3pProductKeys` / issue the
 * connector-config network request. That request is served by a shared
 * stale-while-revalidate cache (`SEARCH_3P_CONFIG`). Firing it here — before the
 * editor mounts — plants a fresh-TTL, still-pending cache entry; the editor-mount
 * hook then sees a "not expired" entry and, because the cache serves the last
 * resolved value during refresh, is handed the previously-persisted (stale)
 * connector list instead of awaiting the fresh response. `useThirdPartyConfig`
 * commits that value once and never re-fetches, so the quick-insert menu gets
 * stuck showing a stale/partial set of apps (e.g. only Figma). Leaving the
 * network request to the editor-mount hook keeps it as the first cache caller,
 * so it awaits fresh data.
 *
 * Client-only: the underlying module assumes a browser environment, so callers
 * must not invoke this during SSR.
 */ 
const $40a9d2820cf67538$export$d8f603dd70536f4f = ()=>{
    (parcelRequire("5Ff2j")).catch(()=>{
    // Best-effort chunk warm-up only. Any failure is swallowed so it can never
    // affect the route transition; the editor-mount hook loads it on demand.
    });
};


const $32e736695aa13b8b$export$8abf4a07f4444858 = async (match, _url, isTransition = false)=>{
    const { userId: userId, isLicensed: isLicensed, cloudId: cloudId, activationId: activationId, accessStatus: accessStatus, isLoggedIn: isLoggedIn, edition: edition } = (0, $xwvlW.getPreloaderFnContext)();
    const tasks = [];
    const { contentId: contentId, spaceKey: spaceKey } = match.params;
    const isBlog = Boolean((0, $kM8fE.matchEditBlog)(_url));
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    const shouldPreloadMentionsProvider = isSSR;
    const isEmbeddedConfluence = (0, $1swiX.getIsEmbeddedConfluence)(match);
    const shouldPreloadNavigation = !isEmbeddedConfluence;
    const isStreaming = isSSR || (0, $3gyyc.isSSRStreaming)();
    let contentStatePreloadPromise;
    if (isSSR) contentStatePreloadPromise = (0, $cvj7x.preloadEditorDataContentState)({
        contentId: contentId,
        useCache: false,
        isLivePage: false
    });
    if (contentStatePreloadPromise) tasks.push((0, $kkLBe.prepareGuardExceptionTask)('EditorContentState', ()=>contentStatePreloadPromise));
    const preloadPromise = (0, $kkLBe.prepareGuardExceptionTask)('EditorData', ()=>(0, $cvj7x.preloadEditorData)({
            spaceKey: spaceKey,
            contentId: contentId,
            cloudId: cloudId,
            shouldPreloadMentionsProvider: shouldPreloadMentionsProvider,
            useCache: false,
            isBlog: isBlog,
            contentStatePreloadPromise: contentStatePreloadPromise
        }));
    if (isStreaming) tasks.push((0, $eS4vC.createDataFetcherForSuspense)('content-main', ()=>preloadPromise));
    else tasks.push(preloadPromise);
    // we dont know if a page is unpublished until we get data back. guess based on the draftShareId being in the url
    const guessIsUnpublishedDraft = Boolean(match?.query?.draftShareId);
    tasks.push((0, $kyd3u.preloadEditorByLineData)({
        isUnpublishedDraft: guessIsUnpublishedDraft,
        spaceKey: spaceKey,
        contentId: contentId
    }));
    if (isStreaming) tasks.push((0, $eS4vC.createDataFetcherForSuspense)('content-types-header', ()=>{
        const contentTypesHeaderPreloadTasks = [];
        contentTypesHeaderPreloadTasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId));
        // Standalone Restrictions button needs to have its data preloaded
        contentTypesHeaderPreloadTasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, false));
        if ((0, $9wGTI.fg)('confluence_frontend_usd_ssr')) contentTypesHeaderPreloadTasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
        return contentTypesHeaderPreloadTasks;
    }));
    else {
        tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId));
        // Standalone Restrictions button needs to have its data preloaded
        tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, false));
        // Unified Share and Restrict Button
        if ((0, $9wGTI.fg)('confluence_frontend_usd_ssr')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
    }
    if (isLicensed) {
        tasks.push((0, $fywGr.preloadEditorOnboardingState)());
        tasks.push((0, $h8QBE.preloadLandUsersInEditorWithRevampedBpqa)());
        tasks.push((0, $4b6107ec1852de14$export$f487e1233221fed9)());
        tasks.push((0, $8401ee2f6eb43799$export$6316c27636a04811)());
        tasks.push((0, $8332e6e273585306$export$3e6908d03c4e3a25)(contentId));
    }
    // Warm the third-party connector-config *code chunk* off the editor's critical
    // path so `useConnectedThirdPartyProductKeys` has its module ready at editor
    // mount. This intentionally does NOT issue the connector-config network request
    // — doing so here plants a stale-while-revalidate cache entry that the
    // editor-mount hook then serves stale from, wedging the quick-insert menu on a
    // partial app list. See preloadConnectedThirdPartyConfig for the full rationale.
    // Client-only, scoped to the `confluence_quick_insert_embeds` experiment cohort.
    // Read without exposure — the authoritative exposure fires inside the provider
    // builder at editor mount. Fire-and-forget: intentionally not pushed into `tasks`.
    if ((0, $6mKj3.UNSAFE_expValNoExposure)('confluence_quick_insert_embeds', 'cohort', 'control') !== 'control') (0, $40a9d2820cf67538$export$d8f603dd70536f4f)();
    if (isTransition) {
        if ((0, $6mKj3.expValEquals)('web_panel_query_batch_call', 'isEnabled', true)) tasks.push((0, $5Rwa0.preloadWebPanelLocations)({
            contentId: contentId,
            locations: [
                (0, $eSLr0.ATL_GENERAL),
                (0, $eSLr0.ATL_FOOTER)
            ]
        }));
        return (0, $lyWac.waitForAllReturnWhenError)(tasks);
    }
    if (isSSR) {
        if (isStreaming) {
            if (shouldPreloadNavigation) tasks.push((0, $eS4vC.createDataFetcherForSuspense)('side-navigation', ()=>{
                // Navigation and page tree
                return (0, $dpyxe.preloadNavigationTasks)(spaceKey, contentId, isLicensed, isBlog);
            }));
        } else // Navigation and page tree
        if (shouldPreloadNavigation) tasks.push((0, $dpyxe.preloadNavigationTasks)(spaceKey, contentId, isLicensed, isBlog));
        tasks.push((0, $1i2qc.preloadMediaToken)(contentId, cloudId), (0, $a0c935b54d4370ec$export$c6954e5932c9c91f)(contentId));
    } else tasks.push((0, $8R0gj.preloadDraft)(contentId));
    tasks.push((0, $5SzHz.preloadSpaceDetail)(spaceKey));
    if ((0, $6mKj3.expValEquals)('web_panel_query_batch_call', 'isEnabled', true)) tasks.push((0, $5Rwa0.preloadWebPanelLocations)({
        contentId: contentId,
        locations: [
            (0, $eSLr0.ATL_GENERAL),
            (0, $eSLr0.ATL_FOOTER)
        ]
    }));
    else tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_GENERAL)
    }), (0, $5Rwa0.preloadWebPanelLocation)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_FOOTER)
    }));
    tasks.push((0, $c44bc7c35ccb995d$export$b39ebabf96e926c8)(contentId));
    if (isLoggedIn && edition === (0, $euL71.ConfluenceEdition).PREMIUM && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) tasks.push((0, $fa8eaa7cdcb1d432$export$2d00200c8fdc5d86)({
        cloudId: cloudId,
        contentId: contentId,
        contentStatus: 'DRAFT',
        spaceKey: spaceKey
    }));
    // Preload Loom button in Action Bar
    if ((accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS) && isLoggedIn) tasks.push((0, $7tT2b.preloadRecordLoomButton)({
        cloudId: cloudId,
        activationId: activationId,
        accessStatus: accessStatus,
        isLoggedIn: isLoggedIn,
        userId: userId
    }));
    // Preload forge extension manifest
    if ((0, $9wGTI.fg)('confluence_preload_forge_viewport_heights_editor') || (0, $9wGTI.fg)('conf_frontend_forge_static_macro_mvp')) tasks.push((0, $8CHHT.preloadUseExtensionList)({
        contentId: contentId,
        spaceKey: spaceKey,
        moduleType: (0, $7Ndnw.FORGE_MODULE_XEN_MACRO)
    }));
    // Preload Smart Create Feedback Banner
    tasks.push((0, $22UVa.preloadSmartCreateFeedbackBanner)(contentId));
    // Preload Audio Listen Button
    tasks.push((0, $cc003fd311374024$export$7261e64a95ae02eb)(contentId));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};





async function $73df6e46d3afaa7c$export$9c3872cc60e7dbce(match, _url) {
    const { contentId: contentId, draftShareId: draftShareId } = match.params;
    await (0, $8R0gj.preloadDraft)(contentId, draftShareId);
}









var $2XqLa = parcelRequire("2XqLa");


var $jG2Es = parcelRequire("jG2Es");


var $khheP = parcelRequire("khheP");


var $dC2j7 = parcelRequire("dC2j7");

const $61c2bc00711f31ff$export$e56b81ae74d866fc = (options)=>{
    const variables = (0, $dC2j7.getPreloadAggSpacePagesQueryVariables)(options);
    const { spaceKey: spaceKey, isLoggedIn: isLoggedIn, spaceId: spaceId = '' } = options;
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.queryAgg)({
            query: (0, $khheP.default),
            variables: variables,
            __callerPackage__: "space-pages"
        }),
        ...!spaceId ? [
            (0, $dYU3e.query)({
                query: (0, $2XqLa.default),
                variables: {
                    spaceKey: spaceKey
                },
                __callerPackage__: "space-pages"
            })
        ] : [],
        ...isLoggedIn ? [
            (0, $dYU3e.query)({
                query: (0, $jG2Es.default),
                variables: {
                    spaceKey: spaceKey
                },
                __callerPackage__: "space-pages"
            })
        ] : []
    ]);
};






var $yuLaV = parcelRequire("yuLaV");




const $106eac55bed5d4af$export$206b1c2d74bc11a2 = async (match)=>{
    const { userId: userId, isLoggedIn: isLoggedIn, accessStatus: accessStatus, cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
    const { spaceKey: spaceKey } = match.params;
    const isDatabasesEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const isSlidesEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('slide');
    const isWhiteboardsEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    return (0, $61c2bc00711f31ff$export$e56b81ae74d866fc)({
        cloudId: cloudId,
        spaceKey: spaceKey,
        queryParams: match.query,
        userId: userId,
        isLicensed: isLicensed,
        isLoggedIn: isLoggedIn,
        spaceId: '',
        isWhiteboardEnabled: isWhiteboardsEnabled,
        isDatabaseEnabled: isDatabasesEnabled,
        isSlidesEnabled: isSlidesEnabled
    });
};



var $aYbn7 = parcelRequire("aYbn7");




var $ddSqr = parcelRequire("ddSqr");



















var $73cd2 = parcelRequire("73cd2");

const $189a8a30ba3005c8$export$517a8e5c755236cc = async ({ shareToken: shareToken, contentId: contentId })=>{
    const sharedContentResult = await (0, $dYU3e.query)({
        query: (0, $73cd2.default),
        variables: {
            shareToken: shareToken,
            contentId: contentId
        },
        context: {
            allowOnExternalPage: true
        },
        __callerPackage__: "external-share"
    });
    const singleContent = sharedContentResult?.data?.singleContent;
    const resolvedContentId = contentId ?? singleContent?.id;
    const spaceKey = singleContent?.space?.key;
    const isPage = singleContent?.type === 'page';
    if (!resolvedContentId || !isPage) return (0, $lyWac.waitForAllReturnWhenError)([
        Promise.resolve(sharedContentResult)
    ]);
    return (0, $lyWac.waitForAllReturnWhenError)([
        Promise.resolve(sharedContentResult),
        (0, $dYU3e.query)({
            query: (0, $aYbn7.default),
            variables: {
                contentId: resolvedContentId
            },
            context: {
                allowOnExternalPage: true
            },
            __callerPackage__: "external-share"
        }),
        (0, $ddSqr.preloadContentTitleWithByLineExternal)(resolvedContentId),
        ...spaceKey && (0, $9wGTI.fg)('conf_frontend_forge_static_macro_mvp') ? [
            (0, $8CHHT.preloadUseExtensionList)({
                contentId: resolvedContentId,
                spaceKey: spaceKey,
                moduleType: (0, $7Ndnw.FORGE_MODULE_XEN_MACRO)
            })
        ] : []
    ]);
};








const $149b2696471ec09e$export$5ff0d8e28a402df2 = async (shareToken)=>{
    const result = await (0, $dYU3e.query)({
        query: (0, $73cd2.default),
        variables: {
            shareToken: shareToken
        },
        context: {
            // Without this the GraphQL middleware silently blocks the request.
            allowOnExternalPage: true
        },
        __callerPackage__: "external-share"
    });
    const singleContent = result?.data?.singleContent;
    const contentId = singleContent?.id;
    const space = singleContent?.space;
    const spaceKey = space?.alias || space?.key;
    if (!contentId || !spaceKey) return undefined;
    return {
        contentId: contentId,
        spaceKey: spaceKey,
        type: singleContent?.type ?? null,
        subType: singleContent?.subType ?? null
    };
};









var $83sfO = parcelRequire("83sfO");














var $fdq4F = parcelRequire("fdq4F");


var $ezNhb = parcelRequire("ezNhb");


var $5WLjq = parcelRequire("5WLjq");





/**
 * The token is resolved to `contentId`/`spaceKey` first because the URL carries neither. Delegating
 * to the same preloader the content type would use off this route keeps the preloaded query
 * variables identical to the ones the rendered components use; a partial match misses the cache and
 * re-requests during render.
 *
 * The live-doc branch needs no `isAccessLinkRoute` equivalent: the only consumer of that option is
 * `preloadContent`, which `preloadLivePageRoute` never calls.
 */ const $1f9d1c86f6a99b0e$var$preloadAccessLinkContent = async (match, url, isTransition, previousMatch)=>{
    const { shareToken: shareToken } = match.params;
    if (!(0, $6mKj3.expValEquals)('cc_perms_ga_access_links', 'isEnabled', true)) return (0, $189a8a30ba3005c8$export$517a8e5c755236cc)({
        shareToken: shareToken
    });
    const content = await (0, $149b2696471ec09e$export$5ff0d8e28a402df2)(shareToken);
    // Whiteboards and anything that is not a page still render through the simplified path.
    if (!content || content.type !== 'page') return (0, $189a8a30ba3005c8$export$517a8e5c755236cc)({
        shareToken: shareToken
    });
    const syntheticParams = {
        ...match.params,
        contentId: content.contentId,
        spaceKey: content.spaceKey
    };
    if (content.subType === (0, $83sfO.LIVE_PAGE_SUBTYPE)) return (0, $iUV81.preloadLivePageRoute)({
        ...match,
        params: syntheticParams
    }, url);
    return (0, $445d6fd463fd83fa$export$9503d022471fff24)({
        ...match,
        params: syntheticParams
    }, url, isTransition, previousMatch, // Lets a space-scoped 403 through rather than showing the restriction screen. A flag, not
    // URL sniffing, so it holds under SSR.
    {
        isAccessLinkRoute: true
    });
};
const $1f9d1c86f6a99b0e$export$5da6d89b949b94fc = (match, url, isTransition = false, previousMatch = null)=>{
    const tasks = [];
    if ((0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false)) // Pushed as a task, not awaited: `waitForAllReturnWhenError` only absorbs rejections from
    // promises inside this array, and awaiting would serialise the side-nav preloads below
    // behind the token lookup even when the gate is off.
    tasks.push($1f9d1c86f6a99b0e$var$preloadAccessLinkContent(match, url, isTransition, previousMatch));
    const { accessStatus: accessStatus } = (0, $xwvlW.getPreloaderFnContext)();
    const isLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (isLicensed) tasks.push((0, $eS4vC.createDataFetcherForSuspense)('side-navigation', ()=>{
        const sideNavTasks = [
            (0, $5WLjq.preloadSpacesList)({
                isLicensed: isLicensed
            })
        ];
        if ((0, $9wGTI.fg)('navx-global-side-nav-confluence')) {
            sideNavTasks.push((0, $fdq4F.preloadPlatformNavigationQuery)());
            // Self-gates on the kill-switch gate + experiment; no-ops for non-cohort users.
            sideNavTasks.push((0, $ezNhb.preloadInvitedAppShortcutsRecommendationsQuery)());
        }
        return sideNavTasks;
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};






const $d3b88206c55934ef$export$bd1c07b274fefbd7 = (match)=>(0, $lyWac.waitForAllReturnWhenError)([
        (0, $189a8a30ba3005c8$export$517a8e5c755236cc)({
            shareToken: match.params.externalToken,
            contentId: match.params.contentId === 'undefined' ? undefined : match.params.contentId
        })
    ]);




























const $0ef4e79dd69588ad$export$9f53340e87bacbbd = async (match)=>{
    const tasks = [];
    const { contentId: contentId, spaceKey: spaceKey } = match.params;
    // ContentHistory renders PagePrerequisites, so it sits behind the same ViewPageGateway
    // AdminKeyQuery gate as the view page. See preloadIsSuperAdmin for the conditions under which
    // it issues a request; it is a no-op for everyone else.
    tasks.push((0, $9388622078562d65$export$8a2490b7cfbfffb0)());
    const preloadedSessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const { cloudId: cloudId } = preloadedSessionContext;
    // Since this query is not called in ContentPrerequisites when contentId is
    // missing, we should follow the same reasoning and skip preload when content is
    // missing.
    if (contentId) tasks.push((0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey));
    tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId));
    // Standalone Restrictions button needs to have its data preloaded
    tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, false));
    // Presence Avatar Visibility
    tasks.push((0, $853f14d41fe05930$export$fb43949e55e0c9d2)({
        cloudId: cloudId,
        spaceKey: spaceKey
    }));
    if ((0, $9wGTI.fg)('conf_frontend_forge_static_macro_mvp')) tasks.push((0, $8CHHT.preloadUseExtensionList)({
        contentId: contentId,
        spaceKey: spaceKey,
        moduleType: (0, $7Ndnw.FORGE_MODULE_XEN_MACRO)
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};












const $29ace679d934655d$export$7cbbf2d30ca863e7 = async (match)=>{
    const tasks = [];
    const { contentId: contentId, spaceKey: spaceKey } = match.params;
    // AttachmentsPage renders PagePrerequisites, so it sits behind the same ViewPageGateway
    // AdminKeyQuery gate as the view page. See preloadIsSuperAdmin for the conditions under which
    // it issues a request; it is a no-op for everyone else.
    tasks.push((0, $9388622078562d65$export$8a2490b7cfbfffb0)());
    // Since this query is not called in ContentPrerequisites when contentId is
    // missing, we should follow the same reasoning and skip preload when content is
    // missing.
    if (contentId) tasks.push((0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey, {
        status: [
            'current',
            'draft',
            'archived'
        ]
    }));
    tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};












var $gGK1T = parcelRequire("gGK1T");


var $2E1L5 = parcelRequire("2E1L5");

function $434ee60a7b6c6c34$export$b00a1ce9bc36f6f2(contentId) {
    return (0, $dYU3e.query)({
        query: (0, $gGK1T.default),
        variables: {
            contentId: contentId,
            limit: (0, $2E1L5.DEFAULT_CONTRIBUTORS_FETCH_LIMIT)
        },
        __callerPackage__: "content-ownership"
    });
}















var $duklN = parcelRequire("duklN");


var $5Sm9D = parcelRequire("5Sm9D");


var $8N95V = parcelRequire("8N95V");


var $fDjhq = parcelRequire("fDjhq");


var $7jfZt = parcelRequire("7jfZt");

/**
 * Warms `FolderOverviewChildrenContentQuery` (child history + collaborators) once
 * the overview result is known.
 *
 * This is a chained preload: the enrichment query's `ids` depend on the child ids
 * returned by the first-page query. It runs last so it does not block the
 * independent preloads. The `ids` must match the component's first-render request
 * exactly (order included) or the SSR-warmed store snapshot is treated as
 * incomplete and the columns render blank — see `FolderOverview.tsx`.
 */ async function $fbd9f14d3be2d912$var$preloadChildrenContent(overviewTask, extractChildIds) {
    const { data: data, hasErrors: hasErrors } = await overviewTask;
    if (hasErrors || !data) return;
    const childIds = extractChildIds(data);
    if (childIds.length === 0) return;
    return (0, $dYU3e.query)({
        query: (0, $8N95V.default),
        variables: {
            ids: childIds
        },
        __callerPackage__: "folder"
    });
}
/** Child ids from the legacy first-page query, in `ptpage.children.nodes` order. */ const $fbd9f14d3be2d912$var$legacyChildIds = (data)=>{
    const ids = [];
    for (const node of data.ptpage?.children?.nodes ?? [])if (node?.id) ids.push(node.id);
    return ids;
};
async function $fbd9f14d3be2d912$export$238042884af28457(contentId, { cloudId: cloudId, spaceKey: spaceKey } = {}) {
    // Preload the folder header title. `FolderHeader` → `FolderInlineTitle`
    // consumes it via `usePageTitle`, which only fetches on the client; without
    // this the folder title renders empty during SSR.
    const titleQueryTask = (0, $dYU3e.query)({
        query: (0, $duklN.default),
        variables: {
            contentId: contentId
        },
        __callerPackage__: "folder"
    });
    let overviewQueryTask;
    let childrenQueryTask;
    // The render path branches on `cc_folder_view_type_filtered_children`
    // (see FolderOverview.tsx): the dual-stream path fires
    // `DualStreamQueriesFirstPageQuery` while the legacy path fires
    // `FolderOverviewFirstPageQuery`. Preload whichever one the render will
    // actually consume so its data is in the store before the first SSR render,
    // then chain the children-content preload off its result.
    if ((0, $6mKj3.expVal)('cc_folder_view_type_filtered_children', 'isEnabled', false)) {
        const dualStreamTask = (0, $dYU3e.query)({
            query: (0, $fDjhq.default),
            // These variables MUST match the ones passed by `useDualStreamPagination`
            // (empty-string fallbacks for cloudId/spaceKey included) so the store
            // snapshot is complete for the component's operation on SSR.
            variables: {
                cloudId: cloudId ?? '',
                parentId: contentId,
                spaceKey: spaceKey ?? '',
                contentId: contentId,
                first: (0, $7jfZt.FETCH_SIZE),
                includeDevDocsSyncStatus: (0, $6mKj3.expVal)('confluence_dev_docs', 'isEnabled', false),
                includeAutomationDiscovery: (0, $9wGTI.fg)('cc_automations_discovery_nudges'),
                includeFolderSummary: (0, $6mKj3.expVal)('confluence_folder_summary', 'isEnabled', false),
                // The byline render owns exposure; preloading must use the same non-exposing decision.
                // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation -- exposure is recorded when the byline can render
                includeJiraPlannerConnection: (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('ai_planner_icon_with_confluence_folder', 'isEnabled', true)
            },
            __callerPackage__: "folder"
        });
        overviewQueryTask = dualStreamTask;
        childrenQueryTask = $fbd9f14d3be2d912$var$preloadChildrenContent(dualStreamTask, (data)=>(0, $7jfZt.getInitialVisibleChildIds)(data.folders, data.content));
    } else {
        const legacyTask = (0, $dYU3e.query)({
            query: (0, $5Sm9D.default),
            variables: {
                id: contentId,
                after: null,
                contentId: contentId,
                includeDevDocsSyncStatus: (0, $6mKj3.expVal)('confluence_dev_docs', 'isEnabled', false),
                includeAutomationDiscovery: (0, $9wGTI.fg)('cc_automations_discovery_nudges'),
                includeFolderSummary: (0, $6mKj3.expVal)('confluence_folder_summary', 'isEnabled', false),
                // The byline render owns exposure; preloading must use the same non-exposing decision.
                // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation -- exposure is recorded when the byline can render
                includeJiraPlannerConnection: (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('ai_planner_icon_with_confluence_folder', 'isEnabled', true)
            },
            __callerPackage__: "folder"
        });
        overviewQueryTask = legacyTask;
        childrenQueryTask = $fbd9f14d3be2d912$var$preloadChildrenContent(legacyTask, $fbd9f14d3be2d912$var$legacyChildIds);
    }
    // `waitForAllReturnWhenError` submits any task errors for observability and
    // resolves to `Error[]` on failure or `undefined` on success — its
    // `Awaited<T>[]` return arm is never produced at runtime, so narrow to the
    // real success/error contract.
    const errors = await (0, $lyWac.waitForAllReturnWhenError)([
        overviewQueryTask,
        titleQueryTask,
        childrenQueryTask
    ]);
    return Array.isArray(errors) ? errors : undefined;
}



















var $ieWRE = parcelRequire("ieWRE");


var $84kyw = parcelRequire("84kyw");

const $2c7b09695f067c18$export$d0af89ed4f3cce26 = ({ contentId: contentId, spaceKey: spaceKey, isRovoEnabled: isRovoEnabled })=>{
    if (!contentId || !spaceKey || !isRovoEnabled || (0, $6mKj3.expVal)('confluence_smart_folders_milestone', 'value', 0) < 2) return Promise.resolve([]);
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)({
            query: (0, $ieWRE.default),
            variables: {
                spaceKey: spaceKey
            },
            __callerPackage__: "smart-folder"
        }),
        (0, $dYU3e.query)({
            query: (0, $84kyw.default),
            variables: {
                contentId: contentId
            },
            __callerPackage__: "smart-folder"
        })
    ]);
};


const $ae578b27499cf6ef$export$4286139fad35252 = async (match)=>{
    const { isLicensed: isLicensed, isRovoEnabled: isRovoEnabled, cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
    const { contentId: contentId, spaceKey: spaceKey } = match.params;
    const tasks = [];
    if (contentId) {
        // Core folder data: the active overview content query (legacy or dual-stream,
        // depending on the cc_folder_view_type_filtered_children experiment),
        // the children-content query, and the folder header title.
        // cloudId + spaceKey are required by the dual-stream content query.
        tasks.push((0, $fbd9f14d3be2d912$export$238042884af28457)(contentId, {
            cloudId: cloudId,
            spaceKey: spaceKey
        }));
        // Fetch content status/redirect — required by FolderPrerequisites
        tasks.push((0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey));
        // Preload the sticky ContentTypesHeader shown at the top of FolderOverview
        tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId));
        // Warm the ownership/contributors query consumed by BadgeStylePageOwnershipByline in FolderHeader
        tasks.push((0, $434ee60a7b6c6c34$export$b00a1ce9bc36f6f2)(contentId));
        if (spaceKey) // Warm smart-folder enablement + ancestor data used to decide whether the
        // empty-state connection UX can render during SSR.
        tasks.push((0, $2c7b09695f067c18$export$d0af89ed4f3cce26)({
            contentId: contentId,
            spaceKey: spaceKey,
            isRovoEnabled: isRovoEnabled
        }));
    }
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};














const $e6a21086b65e01ae$export$878ae3f236acea00 = async (match)=>{
    const tasks = [];
    const { contentId: contentId, spaceKey: spaceKey } = match.params;
    // Preload the Forge extension list so that window.__SSR_FORGE_EXTENSIONS__ is populated
    // before ForgeMacro mounts. Without this, ForgeMacro's isStaticExtension() check returns
    // false (the extension list query hasn't resolved yet), causing it to skip subscribing to
    // the store and render the iframe fallback instead of the static HTML from confluence_staticMacros.
    if (contentId && (0, $9wGTI.fg)('conf_frontend_forge_static_macro_mvp')) tasks.push((0, $8CHHT.preloadUseExtensionList)({
        contentId: contentId,
        spaceKey: spaceKey,
        moduleType: (0, $7Ndnw.FORGE_MODULE_XEN_MACRO)
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};


parcelRequire("8nle6");
var $jLyos = parcelRequire("jLyos");








var $5IsL6 = parcelRequire("5IsL6");





























var $iaK3p = parcelRequire("iaK3p");

const $8741a5de3be893c9$export$3764d460af2e353f = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $iaK3p.default),
        __callerPackage__: "feature-discovery"
    });
};








const $69ec3a471529e315$export$34e54806d88e1d6d = ()=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)({
            query: (0, $8Z78B.default),
            variables: {
                key: (0, $dBcar.NTH_USER_AUTO_FOLLOW_SPACES).HAS_AUTO_FOLLOWED_SPACES
            },
            __callerPackage__: "onboarding-helpers"
        }),
        (0, $8741a5de3be893c9$export$3764d460af2e353f)()
    ]);
};


















var $Yc1IN = parcelRequire("Yc1IN");


var $gFJ3I = parcelRequire("gFJ3I");


var $3cztU = parcelRequire("3cztU");


var $g4evd = parcelRequire("g4evd");


var $lNpDX = parcelRequire("lNpDX");


var $d7td2 = parcelRequire("d7td2");

const $f413d4da5ba15b92$export$77a2c40a93849218 = ({ isLoggedIn: isLoggedIn })=>{
    // If the user is not logged in we show the following feed by default
    // so only preload that feed. If the user is logged in preload both
    // feeds and the feed preference
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $xwvlW.getPreloaderFnContext)();
    const followingFeedQuery = (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_in_following_popular_feeds', 'isEnabled', true) ? (0, $dYU3e.queryAgg)({
        query: (0, $Yc1IN.default),
        variables: {
            first: (0, $6mKj3.expVal)('confluence_home_feed_initial_page_size', 'following_ssr', 5)
        },
        __callerPackage__: "feed"
    }) : (0, $dYU3e.query)({
        query: (0, $3cztU.default),
        variables: {
            first: (0, $6mKj3.expVal)('confluence_home_feed_initial_page_size', 'following_ssr', 5)
        },
        __callerPackage__: "feed"
    });
    // Select the popular-feed query to preload. Decision order MUST mirror
    // `usePopularFeedWithTimeGranularityStorage`'s client-side selection so the
    // SSR-cached response matches the query the client fires on hydration.
    // Otherwise SSR users would suffer a cache miss + re-fetch, negating the
    // latency win for the very users we care most about (first paint).
    //
    // The V2 experiment in Statsig (`confluence_ai_snippets_popular_feed`) is
    // configured with an `isEnabled` boolean param (NOT a `cohort` string param).
    // All branch checks use `('isEnabled', true)` to detect the treatment arm.
    //
    //   - V2 (parallel)            when popular_feed isEnabled=true AND isRovoLLMEnabled
    //   - V1-with-snippets         when in_following_popular_feeds isEnabled=true AND NOT V2-treatment
    //   - vanilla V1               otherwise (incl. non-Rovo V2-treatment users)
    const popularFirstCount = (0, $9wGTI.fg)('confluence_ai_feeds_home_banner') ? 10 : (0, $6mKj3.expVal)('confluence_home_feed_initial_page_size', 'popular_ssr', 5);
    let popularFeedDataQuery;
    if (isRovoLLMEnabled && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_popular_feed', 'isEnabled', true)) // V2 (parallel hydration) — node-level aiProperty, AGG calls cc-smarts
    // in parallel with the Confluence content hop. We only enter this
    // branch when `isRovoLLMEnabled` is true, so the V2 query variable can
    // be passed `true` unconditionally — no need to re-evaluate the
    // prereq experiment here.
    popularFeedDataQuery = (0, $dYU3e.queryAgg)({
        query: (0, $d7td2.default),
        variables: {
            first: popularFirstCount,
            isRovoLLMEnabled: true
        },
        __callerPackage__: "feed"
    });
    else if (// V1-with-snippets is suppressed for ANY user in the V2-treatment arm
    // (Rovo or not), matching the client-side hook's skipQuery condition.
    // Without this guard, non-Rovo users with popular_feed isEnabled=true
    // would receive a V1-with-snippets SSR preload while the client fires
    // vanilla V1, causing an SSR cache miss + re-fetch (negating the
    // latency win for the very users we care most about — first paint).
    //
    // Gate order: V2-treatment exclusion FIRST so the in-following gate
    // stays at the end of the expression and satisfies the
    // `confluence-feature-gating/no-preconditioning` ESLint rule.
    !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_popular_feed', 'isEnabled', true) && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_in_following_popular_feeds', 'isEnabled', true)) // V1-with-snippets (legacy serial path). Use the NO-exposure variant
    // for the prereq experiment check — SSR fires before the user sees the
    // page, so we must NOT log a real exposure here. The client-side hook
    // (usePopularFeedWithTimeGranularityStorage) uses `expVal` for the
    // same check and is the single source of truth for exposure logging —
    // SSR and client both return the same `isRovoLLMEnabled` variable
    // value, ensuring the SSR-cached response matches what the client
    // would have fetched. The intentional divergence is exposure logging.
    // Semantics preserved from the original `expVal('...', 'isEnabled', false)`
    // which returned the boolean `isEnabled` value: when the gate is ON
    // (isEnabled=true) honor the user's real Rovo flag, otherwise pass
    // `true` (legacy pre-prereq behaviour).
    popularFeedDataQuery = (0, $dYU3e.queryAgg)({
        query: (0, $gFJ3I.default),
        variables: {
            first: popularFirstCount,
            isRovoLLMEnabled: (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_ai_snippets_popular_feed_for_ai_enabled', 'isEnabled', true) ? isRovoLLMEnabled : true
        },
        __callerPackage__: "feed"
    });
    else // Vanilla V1 (no AI snippets). Used by: users outside both gates, and
    // non-Rovo users in the V2-treatment arm (V2 cannot serve them, and
    // V1-with-snippets is suppressed for V2-treatment users — vanilla V1
    // is the safe fallback).
    popularFeedDataQuery = (0, $dYU3e.query)({
        query: (0, $lNpDX.default),
        variables: {
            first: popularFirstCount
        },
        __callerPackage__: "feed"
    });
    const popularFeedQuery = [
        popularFeedDataQuery,
        (0, $dYU3e.query)({
            query: (0, $g4evd.default),
            __callerPackage__: "feed"
        })
    ];
    const tasks = [
        followingFeedQuery
    ];
    if (isLoggedIn) tasks.push(...popularFeedQuery);
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};





var $6YxJf = parcelRequire("6YxJf");



/* eslint-disable import-extensions/file-extension-required */ 

















var $1gy7x = parcelRequire("1gy7x");

const $e192ddb06e08d8ca$export$853a2dce20c9140 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: [
                (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
                ...Object.values((0, $1gy7x.PERSONALIZED_TEMPLATES_V2_ONBOARDING_STATE_KEYS))
            ]
        },
        __callerPackage__: "experiment-personalized-templates-v2"
    });
};









var $eyUJP = parcelRequire("eyUJP");



const $fe35e2c6f7a7af9b$export$67d796e2874a7983 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: [
                (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
                ...Object.values((0, $eyUJP.NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS))
            ]
        },
        __callerPackage__: "experiment-personalized-templates-v2"
    });
};



var $byPOx = parcelRequire("byPOx");


var $lWFZM = parcelRequire("lWFZM");


var $l57Xv = parcelRequire("l57Xv");


var $c8Y4F = parcelRequire("c8Y4F");

const $6dafd0e2e7720a45$export$3687d58480022124 = (userId, accessStatus)=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)({
            query: (0, $byPOx.default),
            __callerPackage__: "experiment-personalized-templates-v2"
        }),
        (0, $dYU3e.query)({
            query: (0, $lWFZM.default),
            __callerPackage__: "experiment-personalized-templates-v2"
        }),
        ...accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS ? [
            (0, $dYU3e.queryAgg)({
                query: (0, $l57Xv.default),
                variables: {
                    accountId: userId || ''
                },
                __callerPackage__: "experiment-personalized-templates-v2"
            })
        ] : [],
        ...accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS ? [
            (0, $e192ddb06e08d8ca$export$853a2dce20c9140)()
        ] : [],
        (0, $fe35e2c6f7a7af9b$export$67d796e2874a7983)(),
        (0, $dYU3e.query)({
            query: (0, $c8Y4F.default),
            __callerPackage__: "experiment-personalized-templates-v2"
        })
    ]);
};











const $c81a9dc13c505c10$export$42b064b77c9ba75f = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: [
                (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
                // For the banner and cards
                (0, $dBcar.USE_CASES_NTH_USER_ONBOARDING).SELECTED_TEMPLATES,
                (0, $dBcar.USE_CASES_NTH_USER_ONBOARDING).VIEWED_AT,
                (0, $dBcar.USE_CASES_NTH_USER_ONBOARDING).DISMISSED_HEADER,
                (0, $dBcar.USE_CASES_NTH_USER_ONBOARDING).VIEWED_HEADER
            ]
        },
        __callerPackage__: "onboarding-helpers"
    });
};









var $b4VFP = parcelRequire("b4VFP");




const $e5a69db009315bb4$export$f8fb9f2632d64c50 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: [
                (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
                ...Object.values((0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS))
            ]
        },
        __callerPackage__: "onboarding-helpers"
    });
};






var $2fsJn = parcelRequire("2fsJn");










/**
 * @generated SignedSource<<614722153aca82d9dabeb40fc48ec31c>>
 * @relayHash ddee5bcc7d51d2ed5555d8cc6f48ec88
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 28d394c12f422131aed5b9fb5279cc5096ef0d8e677d3789fcf89b22b34d31b6
const $724e41e8cbd5c99e$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "key"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "key",
                    "value": [
                        "templates-collection:isTaggedForTemplatesCollectionExperiment",
                        "templates-collection:isTemplatesSectionDismissed",
                        "onboarding-state:introWorkflow",
                        "onboarding-state:legacy",
                        "onboarding-state:isFoundingAdmin",
                        "onboarding-state:isSampleContentV2SpotlightVisible",
                        "onboarding-state:landOnPath",
                        "onboarding-state:teamSpaceCreated",
                        "onboarding-state:isMoreActionsTourVisible",
                        "onboarding-state:isMoreActionsHintVisible",
                        "onboarding-state:improvedGetStartedPath",
                        "onboarding-state:improvedGetStartedWhiteboardPath",
                        "onboarding-state:nthUserGSPagePath",
                        "onboarding-state:isRedactionsTourVisible",
                        "onboarding-state:xflowSpaceCreated",
                        "onboarding-state:templateOnboardingViewedTime",
                        "onboarding-state:nthUserOnboardingCompletedTimestamp",
                        "onboarding-state:nthUserOnboardingFlagViewed",
                        "onboarding-state:nthUserOnboardingPageViewed",
                        "onboarding-state:nthUserBannerDismissed"
                    ]
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": [
                v0 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ],
            "storageKey": "onboardingState(key:[\"templates-collection:isTaggedForTemplatesCollectionExperiment\",\"templates-collection:isTemplatesSectionDismissed\",\"onboarding-state:introWorkflow\",\"onboarding-state:legacy\",\"onboarding-state:isFoundingAdmin\",\"onboarding-state:isSampleContentV2SpotlightVisible\",\"onboarding-state:landOnPath\",\"onboarding-state:teamSpaceCreated\",\"onboarding-state:isMoreActionsTourVisible\",\"onboarding-state:isMoreActionsHintVisible\",\"onboarding-state:improvedGetStartedPath\",\"onboarding-state:improvedGetStartedWhiteboardPath\",\"onboarding-state:nthUserGSPagePath\",\"onboarding-state:isRedactionsTourVisible\",\"onboarding-state:xflowSpaceCreated\",\"onboarding-state:templateOnboardingViewedTime\",\"onboarding-state:nthUserOnboardingCompletedTimestamp\",\"onboarding-state:nthUserOnboardingFlagViewed\",\"onboarding-state:nthUserOnboardingPageViewed\",\"onboarding-state:nthUserBannerDismissed\"])"
        },
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        },
        {
            "alias": "user",
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "team"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasPersonalSpace"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v0 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "preloadTemplatesCollectionEligibleQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "preloadTemplatesCollectionEligibleQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ddee5bcc7d51d2ed5555d8cc6f48ec88",
            "id": "28d394c12f422131aed5b9fb5279cc5096ef0d8e677d3789fcf89b22b34d31b6",
            "metadata": {},
            "name": "preloadTemplatesCollectionEligibleQuery",
            "operationKind": "query",
            "text": "query preloadTemplatesCollectionEligibleQuery{onboardingState(key:[\"templates-collection:isTaggedForTemplatesCollectionExperiment\",\"templates-collection:isTemplatesSectionDismissed\",\"onboarding-state:introWorkflow\",\"onboarding-state:legacy\",\"onboarding-state:isFoundingAdmin\",\"onboarding-state:isSampleContentV2SpotlightVisible\",\"onboarding-state:landOnPath\",\"onboarding-state:teamSpaceCreated\",\"onboarding-state:isMoreActionsTourVisible\",\"onboarding-state:isMoreActionsHintVisible\",\"onboarding-state:improvedGetStartedPath\",\"onboarding-state:improvedGetStartedWhiteboardPath\",\"onboarding-state:nthUserGSPagePath\",\"onboarding-state:isRedactionsTourVisible\",\"onboarding-state:xflowSpaceCreated\",\"onboarding-state:templateOnboardingViewedTime\",\"onboarding-state:nthUserOnboardingCompletedTimestamp\",\"onboarding-state:nthUserOnboardingFlagViewed\",\"onboarding-state:nthUserOnboardingPageViewed\",\"onboarding-state:nthUserBannerDismissed\"]){key,value},confluence_tenantContext{licensedProducts{licenseStatus,productKey}},user:confluence_atlassianUser{id,team,confluence{hasPersonalSpace,space{id,key}}}}"
        }
    };
}();
$724e41e8cbd5c99e$var$node.hash = "2e478de184cf22dbf9c640f31ec7f723";
var $724e41e8cbd5c99e$export$2e2bcd8739ae039 = $724e41e8cbd5c99e$var$node;





const $b7411e454a753e13$var$PreloadTemplatesCollectionEligibleQuery = (0, $724e41e8cbd5c99e$export$2e2bcd8739ae039);
const $b7411e454a753e13$export$61d1d0b9775c631b = ()=>(0, $dYU3e.query)({
        query: $b7411e454a753e13$var$PreloadTemplatesCollectionEligibleQuery,
        __callerPackage__: "home"
    });











const $fedd9a86a97c3653$export$520ec834118606cc = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: Object.values({
                ...(0, $dBcar.ONBOARDING_INTENT_EXPERIENCES),
                ...(0, $dBcar.ONBOARDING_EXPERIENCES)
            })
        },
        __callerPackage__: "onboarding-helpers"
    });
};






var $aSQ2H = parcelRequire("aSQ2H");

const $94117ca0130c8194$export$1cf448b10191509a = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $aSQ2H.default),
        __callerPackage__: "onboarding-helpers"
    });
};





const $b8044be2d73de97b$export$609c06e14413a6a4 = ()=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $fedd9a86a97c3653$export$520ec834118606cc)(),
        (0, $94117ca0130c8194$export$1cf448b10191509a)()
    ]);
};






var $lkQRq = parcelRequire("lkQRq");

function $d85b408e33b913ac$export$d97df32fa415897c({ isLicensed: isLicensed }) {
    if (!isLicensed) return Promise.resolve();
    return (0, $dYU3e.query)({
        query: (0, $lkQRq.default),
        __callerPackage__: "home"
    });
}


const $ef1b2e92c64fee29$export$3e66106e6cf0fa15 = ({ isLicensed: isLicensed })=>{
    return (0, $d85b408e33b913ac$export$d97df32fa415897c)({
        isLicensed: isLicensed
    });
};






var $cMfVN = parcelRequire("cMfVN");

function $4f0b16a97f4cdcc7$export$a3d255f35641358b() {
    return (0, $dYU3e.query)({
        query: (0, $cMfVN.default),
        __callerPackage__: "home"
    });
}



var $fFEmG = parcelRequire("fFEmG");


var $ka7BG = parcelRequire("ka7BG");


var $kCweT = parcelRequire("kCweT");


var $a67vB = parcelRequire("a67vB");


var $y9T5W = parcelRequire("y9T5W");

const $5a0086fce17702fe$var$preloadRecentAgentSessions = async ({ cloudId: cloudId, userId: userId })=>{
    const rovoActivationResult = await (0, $dYU3e.queryAgg)({
        query: (0, $ka7BG.default),
        variables: {
            cloudId: cloudId
        },
        __callerPackage__: "home"
    });
    const rovoActivationData = rovoActivationResult.data;
    const rovoActivationId = rovoActivationData?.tenantContexts?.[0]?.activationIdByProduct?.active;
    if (!rovoActivationId) return rovoActivationResult;
    const agentSessionsResult = await (0, $dYU3e.queryAgg)({
        query: (0, $fFEmG.default),
        variables: (0, $kCweT.getRecentAgentSessionsQueryVariables)({
            userId: userId,
            rovoActivationId: rovoActivationId
        }),
        __callerPackage__: "home"
    });
    return [
        rovoActivationResult,
        agentSessionsResult
    ];
};
const $5a0086fce17702fe$var$preloadRecentWork = (args)=>{
    const queryOptions = (0, $a67vB.getRecentWorkQueryOptions)(args);
    if (queryOptions.skip) return Promise.resolve({});
    return (0, $dYU3e.queryAgg)({
        ...queryOptions,
        __callerPackage__: "home"
    });
};
const $5a0086fce17702fe$export$afe654e7a7c068fa = ({ userId: userId, cloudId: cloudId, isLicensed: isLicensed, isWhiteboardViewedEnabled: isWhiteboardViewedEnabled = false, isDatabaseEnabled: isDatabaseEnabled = false, isSlidesEnabled: isSlidesEnabled = false })=>{
    const preloadedSessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const { accessStatus: accessStatus } = preloadedSessionContext;
    const canAccessHome = accessStatus !== 'ANONYMOUS_ACCESS' && accessStatus !== 'UNLICENSED_AUTHENTICATED_ACCESS';
    const tasks = [
        $5a0086fce17702fe$var$preloadRecentWork({
            cloudId: cloudId,
            isLoggedIn: !!userId,
            isWhiteboardViewedEnabled: isWhiteboardViewedEnabled,
            isDatabaseEnabled: isDatabaseEnabled,
            isSlidesEnabled: isSlidesEnabled,
            first: (0, $y9T5W.ALL_RECENT_ITEMS_COUNT_HOME_REFRESH)
        }),
        (0, $f413d4da5ba15b92$export$77a2c40a93849218)({
            isLoggedIn: !!userId
        }),
        (0, $ef1b2e92c64fee29$export$3e66106e6cf0fa15)({
            isLicensed: isLicensed
        }),
        (0, $4f0b16a97f4cdcc7$export$a3d255f35641358b)()
    ];
    if (userId) {
        if ((0, $6mKj3.expValEquals)('cc_ai_agentic_sessions', 'isEnabled', true)) tasks.push($5a0086fce17702fe$var$preloadRecentAgentSessions({
            cloudId: cloudId,
            userId: userId
        }));
        tasks.push((0, $b8044be2d73de97b$export$609c06e14413a6a4)(), (0, $b7411e454a753e13$export$61d1d0b9775c631b)());
        if (isLicensed && canAccessHome) {
            tasks.push((0, $69ec3a471529e315$export$34e54806d88e1d6d)());
            tasks.push((0, $e5a69db009315bb4$export$f8fb9f2632d64c50)());
            tasks.push((0, $c81a9dc13c505c10$export$42b064b77c9ba75f)());
        }
    }
    if (isLicensed && canAccessHome && userId && accessStatus) tasks.push((0, $6dafd0e2e7720a45$export$3687d58480022124)(userId, accessStatus));
    const unifiedSpacePreloader = (0, $2fsJn.preloadPersistentInviteButtonEligible)({
        spaceKey: undefined
    }, false);
    if (unifiedSpacePreloader) // @ts-ignore-next-line
    tasks.push(unifiedSpacePreloader); //type can be undefined, but the surrounding conditional prevents it
    // https://switcheroo.atlassian.com/ui/gates/e8661ed8-caef-4eed-a747-bf4d58be15c9/key/post-office_enable-confluence-home-banner
    if (userId && canAccessHome && isLicensed && (0, $9wGTI.fg)('post-office_enable-confluence-home-banner')) {
        // Confluence Home Banner in SSR
        const preloadPostOfficeHomeBanner = async ()=>{
            return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/postOffice:ConfluenceHomeBanner', async ()=>{
                const result = await (0, $6YxJf.preloadPostOfficeConfluenceHomeBanner)();
                return result ?? {};
            });
        };
        tasks.push(preloadPostOfficeHomeBanner());
    }
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};















var $igBnm = parcelRequire("igBnm");

const $e4b2bfbed97961bc$export$a8fc7c44e5aafa61 = ({ isLoggedIn: isLoggedIn })=>{
    if (!isLoggedIn) return Promise.resolve({});
    return (0, $dYU3e.query)({
        query: (0, $igBnm.default),
        __callerPackage__: "home"
    });
};



var $k2RxH = parcelRequire("k2RxH");


var $5dcQK = parcelRequire("5dcQK");

const $914eb87cd194adde$export$daee90b6ccc653e0 = ({ cloudId: cloudId, isLoggedIn: isLoggedIn, isWhiteboardViewedEnabled: isWhiteboardViewedEnabled, isWhiteboardUpdatedEnabled: isWhiteboardUpdatedEnabled, isDatabaseEnabled: isDatabaseEnabled })=>{
    const isDatabaseEnabledResolved = isDatabaseEnabled ?? (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.queryAgg)({
            ...(0, $k2RxH.getRecentQueryOptions)({
                pill: 'all',
                cloudId: cloudId,
                endCursor: '',
                isWhiteboardViewedEnabled: isWhiteboardViewedEnabled,
                isWhiteboardUpdatedEnabled: isWhiteboardUpdatedEnabled,
                isDatabaseEnabled: isDatabaseEnabledResolved
            }),
            __callerPackage__: "home"
        }),
        (0, $e4b2bfbed97961bc$export$a8fc7c44e5aafa61)({
            isLoggedIn: isLoggedIn
        }),
        ...isLoggedIn ? [
            (0, $dYU3e.query)({
                query: (0, $5dcQK.default),
                __callerPackage__: "home"
            })
        ] : []
    ]);
};










var $1abNy = parcelRequire("1abNy");

const $82a332f3eb0b7b32$var$PAGE_SIZE = 24;
const $82a332f3eb0b7b32$export$9151a9689f071b49 = ({ isLoggedIn: isLoggedIn })=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)({
            query: (0, $1abNy.default),
            variables: {
                limit: $82a332f3eb0b7b32$var$PAGE_SIZE,
                start: 0
            },
            __callerPackage__: "home"
        }),
        (0, $e4b2bfbed97961bc$export$a8fc7c44e5aafa61)({
            isLoggedIn: isLoggedIn
        })
    ]);
};


/* eslint-disable import-extensions/file-extension-required */ 







var $d64J2 = parcelRequire("d64J2");


var $kgC8N = parcelRequire("kgC8N");

const $db48a3960bd53439$export$ef22b7398f0c0746 = ({ isLoggedIn: isLoggedIn })=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)({
            query: (0, $d64J2.default),
            variables: (0, $kgC8N.DRAFTS_QUERY_OPTIONS).variables,
            __callerPackage__: "home"
        }),
        (0, $e4b2bfbed97961bc$export$a8fc7c44e5aafa61)({
            isLoggedIn: isLoggedIn
        })
    ]);
};



var $01STT = parcelRequire("01STT");

const $f65ab46c8acdebd2$var$getSelectedView = (matchParams)=>{
    const view = matchParams?.view;
    return Object.values((0, $01STT.View)).includes(view) ? view : (0, $01STT.View).OVERVIEW;
};
const $f65ab46c8acdebd2$var$preloadSelectedView = ({ cloudId: cloudId, isLicensed: isLicensed, userId: userId, matchParams: matchParams, isWhiteboardViewedEnabled: isWhiteboardViewedEnabled = false, isDatabaseEnabled: isDatabaseEnabled = false, isSlidesEnabled: isSlidesEnabled = false })=>{
    if (!cloudId) return Promise.resolve({});
    const isLoggedIn = Boolean(userId);
    const selectedView = $f65ab46c8acdebd2$var$getSelectedView(matchParams);
    switch(selectedView){
        case (0, $01STT.View).RECENT:
            return (0, $914eb87cd194adde$export$daee90b6ccc653e0)({
                cloudId: cloudId,
                isLoggedIn: isLoggedIn,
                isWhiteboardViewedEnabled: isWhiteboardViewedEnabled,
                isDatabaseEnabled: isDatabaseEnabled
            });
        case (0, $01STT.View).STARRED:
            return (0, $82a332f3eb0b7b32$export$9151a9689f071b49)({
                isLoggedIn: isLoggedIn
            });
        case (0, $01STT.View).DRAFTS:
            return (0, $db48a3960bd53439$export$ef22b7398f0c0746)({
                isLoggedIn: isLoggedIn
            });
        case (0, $01STT.View).OVERVIEW:
        default:
            return (0, $5a0086fce17702fe$export$afe654e7a7c068fa)({
                userId: userId,
                cloudId: cloudId,
                isLicensed: isLicensed,
                isWhiteboardViewedEnabled: isWhiteboardViewedEnabled,
                isDatabaseEnabled: isDatabaseEnabled,
                isSlidesEnabled: isSlidesEnabled
            });
    }
};
const $f65ab46c8acdebd2$export$ae91664215c56ac5 = (options)=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $eS4vC.createDataFetcherForSuspense)('side-navigation', ()=>{
            const sideNavTasks = [
                (0, $5WLjq.preloadSpacesList)({
                    //preloads left nav
                    isLicensed: options.isLicensed
                })
            ];
            if ((0, $9wGTI.fg)('navx-global-side-nav-confluence')) {
                sideNavTasks.push((0, $fdq4F.preloadPlatformNavigationQuery)());
                // Self-gates on the productionisation gate + experiment; no-ops for non-cohort users.
                sideNavTasks.push((0, $ezNhb.preloadInvitedAppShortcutsRecommendationsQuery)());
            }
            return sideNavTasks;
        }),
        (0, $5IsL6.preloadCreateSpace)({
            isLicensed: options.isLicensed
        }),
        $f65ab46c8acdebd2$var$preloadSelectedView(options)
    ]);
};









var $bFNdd = parcelRequire("bFNdd");







const $179951d621935e1e$export$cefc517f3ae2aa98 = async (match)=>{
    const preloadedSessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const { userId: userId, cloudId: cloudId, accessStatus: accessStatus } = preloadedSessionContext;
    const isDatabasesEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const isSlidesEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('slide');
    const isWhiteboardsEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const tasks = [];
    const isLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const canAccessHome = accessStatus !== 'ANONYMOUS_ACCESS' && accessStatus !== 'UNLICENSED_AUTHENTICATED_ACCESS';
    //All top Navigation preloading is done in next/packages/query-preloaders/src/index.ts
    if (isLicensed && canAccessHome) tasks.push((0, $f65ab46c8acdebd2$export$ae91664215c56ac5)({
        cloudId: cloudId,
        isLicensed: isLicensed,
        userId: userId,
        matchParams: match.params,
        isWhiteboardViewedEnabled: isWhiteboardsEnabled,
        isDatabaseEnabled: isDatabasesEnabled,
        isSlidesEnabled: isSlidesEnabled
    }));
    // Preload current user's personal space metadata for home route consumers(onboarding etc).
    tasks.push((0, $jLyos.preloadPersonalSpaceDetail)());
    tasks.push((0, $bFNdd.preloadPostOfficeConfluenceSideNav)());
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};









var $iwZYw = parcelRequire("iwZYw");

const $dfe1021c2b61fce7$export$eec5c6a2cd111615 = ()=>(0, $dYU3e.query)({
        query: (0, $iwZYw.default),
        __callerPackage__: "admin-announcement-banner"
    });






var $1hmAp = parcelRequire("1hmAp");

const $b5b554d7930e19fd$export$91ccde13a31d1982 = ()=>(0, $dYU3e.query)({
        query: (0, $1hmAp.default),
        __callerPackage__: "storage-enforcement"
    });


const $5368439faec350a5$export$6c7e4784651f052f = async ()=>{
    const { edition: edition } = (0, $xwvlW.getPreloaderFnContext)();
    const upperCaseEdition = edition?.toUpperCase() || '';
    if (upperCaseEdition === 'PREMIUM' || upperCaseEdition === 'STANDARD') return (0, $dfe1021c2b61fce7$export$eec5c6a2cd111615)();
    else if (upperCaseEdition === 'FREE') return (0, $b5b554d7930e19fd$export$91ccde13a31d1982)();
};






var $8aG6j = parcelRequire("8aG6j");


var $ibNn3 = parcelRequire("ibNn3");


var $6U5eU = parcelRequire("6U5eU");




/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/ const $57786d38307be613$export$a5cfae247d8360ef = 'screen-space-flags';


/**
 * This file was automatically generated using "yarn generate:all" command.
 * Please do not edit it manually.
 * 
 * Generate source: local/cli/src/commands/placements/generate-intl-provider.ts
 **/ 
var $4fmou = parcelRequire("4fmou");

/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $dJkmj = parcelRequire("dJkmj");


var $cUcPn = parcelRequire("cUcPn");

// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e6415930b3d4f363$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $e6415930b3d4f363$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("ksfN5")));
        case 'da':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("1WW3i")));
        case 'de':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("8JNw5")));
        case 'en-GB':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("b4Dfp")));
        case 'en-US':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("7N8K6")));
        case 'en-XA':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("caZSr")));
        case 'en-XB':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("7baG8")));
        case 'en-ZZ':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("iG5Z7")));
        case 'en':
            return $e6415930b3d4f363$var$importHelper(await Promise.resolve((parcelRequire("dJkmj"))));
        case 'es':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("z0NfQ")));
        case 'et':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("lay1O")));
        case 'fi':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("c09TU")));
        case 'fr':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("hbyeW")));
        case 'hr':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("ihfOC")));
        case 'hu':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("iTVjy")));
        case 'it':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("jambV")));
        case 'ja':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("bgRQf")));
        case 'ko':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("fkCwb")));
        case 'nb':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("e1R9y")));
        case 'nl':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("8y7KT")));
        case 'pl':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("llaTT")));
        case 'pt-BR':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("bFqV5")));
        case 'ro':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("52S0G")));
        case 'ru':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("9oOUi")));
        case 'sl':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("5NwB0")));
        case 'sr-RS':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("hEUq2")));
        case 'sr-YR':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("7XWIt")));
        case 'sr':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("jFYco")));
        case 'sv':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("5sLxi")));
        case 'th':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("bYnX5")));
        case 'tr':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("fRuEg")));
        case 'uk':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("etig5")));
        case 'vi':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("g9XuR")));
        case 'zh-CN':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("87dWx")));
        case 'zh-TW':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("b66vN")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($dJkmj));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $jn6Vd = parcelRequire("jn6Vd");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8ba4c3dbe149cf45$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $8ba4c3dbe149cf45$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("6DVal")));
        case 'da':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("dnviE")));
        case 'de':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("inQF0")));
        case 'en-GB':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("3pSD4")));
        case 'en-US':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("l7JF3")));
        case 'en-XA':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("9EPTJ")));
        case 'en-XB':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("bi9fn")));
        case 'en-ZZ':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("6eRZW")));
        case 'en':
            return $8ba4c3dbe149cf45$var$importHelper(await Promise.resolve((parcelRequire("jn6Vd"))));
        case 'es':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("c5itn")));
        case 'et':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("5Lkat")));
        case 'fi':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("2RTex")));
        case 'fr':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("8UQU8")));
        case 'hr':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("4iWGP")));
        case 'hu':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("e6L7b")));
        case 'it':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("4JoIz")));
        case 'ja':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("6JOFf")));
        case 'ko':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("84Cal")));
        case 'nb':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("1bYEh")));
        case 'nl':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("28r74")));
        case 'pl':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("gx9jb")));
        case 'pt-BR':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("l8Kdm")));
        case 'ro':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("3TFWR")));
        case 'ru':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("9kURA")));
        case 'sl':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("4a06L")));
        case 'sr-RS':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("abJUx")));
        case 'sr-YR':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("4t3lo")));
        case 'sr':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("4ESb7")));
        case 'sv':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("5pKn7")));
        case 'th':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("jqAt5")));
        case 'tr':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("2rLoo")));
        case 'uk':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("fiPK2")));
        case 'vi':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("k9ukf")));
        case 'zh-CN':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("9ig6e")));
        case 'zh-TW':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("7MsWr")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($jn6Vd));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $i2fPX = parcelRequire("i2fPX");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d79f2b154c851db0$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $d79f2b154c851db0$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("bRqeA")));
        case 'da':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("9jD1I")));
        case 'de':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("cZ3uF")));
        case 'en-GB':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("dmPno")));
        case 'en-US':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("d63z9")));
        case 'en-XA':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("dYrFI")));
        case 'en-XB':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("fwUrk")));
        case 'en-ZZ':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("aSvJn")));
        case 'en':
            return $d79f2b154c851db0$var$importHelper(await Promise.resolve((parcelRequire("i2fPX"))));
        case 'es':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("hJ4rW")));
        case 'et':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("57BZh")));
        case 'fi':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("48G6M")));
        case 'fr':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("ce9jn")));
        case 'hr':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("8uzv1")));
        case 'hu':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("kvD9W")));
        case 'it':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("8ala4")));
        case 'ja':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("hhTMG")));
        case 'ko':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("j9FdF")));
        case 'nb':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("8DcID")));
        case 'nl':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("g93PL")));
        case 'pl':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("38C5h")));
        case 'pt-BR':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("1j6R2")));
        case 'ro':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("db8Mq")));
        case 'ru':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("dAssT")));
        case 'sl':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("hXhj2")));
        case 'sr-RS':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("ijv9f")));
        case 'sr-YR':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("bwFNp")));
        case 'sr':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("7EuHF")));
        case 'sv':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("824Zb")));
        case 'th':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("3Vtyt")));
        case 'tr':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("bzZRD")));
        case 'uk':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("5PAsW")));
        case 'vi':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("f2STn")));
        case 'zh-CN':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("iNdWn")));
        case 'zh-TW':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("7LKZI")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($i2fPX));
    }
};



var $1Neys = parcelRequire("1Neys");

/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $e0FlU = parcelRequire("e0FlU");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $95873db9729f07c3$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $95873db9729f07c3$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("eabg7")));
        case 'da':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("jZeAX")));
        case 'de':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("2axJb")));
        case 'en-GB':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("lUsnv")));
        case 'en-US':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("8c7JZ")));
        case 'en-XA':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("abUmM")));
        case 'en-XB':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("eXUz1")));
        case 'en-ZZ':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("fEYiZ")));
        case 'en':
            return $95873db9729f07c3$var$importHelper(await Promise.resolve((parcelRequire("e0FlU"))));
        case 'es':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("5ptAs")));
        case 'et':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("1VQcl")));
        case 'fi':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("4xiJB")));
        case 'fr':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("g7kN0")));
        case 'hr':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("5aDHN")));
        case 'hu':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("6Db5r")));
        case 'it':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("7EnAW")));
        case 'ja':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("1NMC1")));
        case 'ko':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("h7mrz")));
        case 'nb':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("dJrN5")));
        case 'nl':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("kIiRu")));
        case 'pl':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("6cC5U")));
        case 'pt-BR':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("jOK5M")));
        case 'ro':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("3cL9D")));
        case 'ru':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("3sD7h")));
        case 'sl':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("5TuXS")));
        case 'sr-RS':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("7PMPV")));
        case 'sr-YR':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("4fQN1")));
        case 'sr':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("2sOFs")));
        case 'sv':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("aFgC3")));
        case 'th':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("idbW5")));
        case 'tr':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("kY8vo")));
        case 'uk':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("7t28c")));
        case 'vi':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("877yj")));
        case 'zh-CN':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("6J3MX")));
        case 'zh-TW':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("bjFRG")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($e0FlU));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $17jnj = parcelRequire("17jnj");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1d8c72db0ac48249$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $1d8c72db0ac48249$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("6ClI5")));
        case 'da':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("8hGTN")));
        case 'de':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("kgAWE")));
        case 'en-GB':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("5i55E")));
        case 'en-US':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("6lzM7")));
        case 'en-XA':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("c6grN")));
        case 'en-XB':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("eXr6z")));
        case 'en-ZZ':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("7Waeo")));
        case 'en':
            return $1d8c72db0ac48249$var$importHelper(await Promise.resolve((parcelRequire("17jnj"))));
        case 'es':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("av8hd")));
        case 'et':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("iinO3")));
        case 'fi':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("6aSdw")));
        case 'fr':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("8IdGC")));
        case 'hr':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("5Ljvt")));
        case 'hu':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("h9UHK")));
        case 'it':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("exAVp")));
        case 'ja':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("fkdWp")));
        case 'ko':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("g930E")));
        case 'nb':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("fWgxi")));
        case 'nl':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("fDLGH")));
        case 'pl':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("lTuyI")));
        case 'pt-BR':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("hfwWF")));
        case 'ro':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("iYOer")));
        case 'ru':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("b7HfY")));
        case 'sl':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("e12Gu")));
        case 'sr-RS':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("khLm8")));
        case 'sr-YR':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("bxTdC")));
        case 'sr':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("7zpdc")));
        case 'sv':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("eeoPq")));
        case 'th':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("5Bt1H")));
        case 'tr':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("lMJex")));
        case 'uk':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("8ggZy")));
        case 'vi':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("gOpNc")));
        case 'zh-CN':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("9JALx")));
        case 'zh-TW':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("e2NTg")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($17jnj));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $aDXRl = parcelRequire("aDXRl");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $817dacc1d76f8cd5$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $817dacc1d76f8cd5$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("dhgg6")));
        case 'da':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("4quJN")));
        case 'de':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("4YtW3")));
        case 'en-GB':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("1dXJ4")));
        case 'en-US':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("hpIew")));
        case 'en-XA':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("l91fK")));
        case 'en-XB':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("7OnNX")));
        case 'en-ZZ':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("hnOZU")));
        case 'en':
            return $817dacc1d76f8cd5$var$importHelper(await Promise.resolve((parcelRequire("aDXRl"))));
        case 'es':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("fgbrU")));
        case 'et':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("iT7rO")));
        case 'fi':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("4YZ6d")));
        case 'fr':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("lO34q")));
        case 'hr':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("2LAgN")));
        case 'hu':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("lAEfc")));
        case 'it':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("eVqNW")));
        case 'ja':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("ioF3u")));
        case 'ko':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("1EU5y")));
        case 'nb':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("d50eo")));
        case 'nl':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("5UW3g")));
        case 'pl':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("2qyIm")));
        case 'pt-BR':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("6UYsU")));
        case 'ro':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("5Jp07")));
        case 'ru':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("hjwpd")));
        case 'sl':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("1dgn9")));
        case 'sr-RS':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("ajJkr")));
        case 'sr-YR':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("gIgCg")));
        case 'sr':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("lxn1t")));
        case 'sv':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("3ZONs")));
        case 'th':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("eZukP")));
        case 'tr':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("1Zm20")));
        case 'uk':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("fzP1A")));
        case 'vi':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("5cVsx")));
        case 'zh-CN':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("jDEId")));
        case 'zh-TW':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("gxVgn")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($aDXRl));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8DLD7 = parcelRequire("8DLD7");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b29cafa707c395e0$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $b29cafa707c395e0$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("5vdvc")));
        case 'da':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("qEMXn")));
        case 'de':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("5jrVu")));
        case 'en-GB':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("koJIg")));
        case 'en-US':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("aw7Dc")));
        case 'en-XA':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("jXjZI")));
        case 'en-XB':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("db8ly")));
        case 'en-ZZ':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("kTwQy")));
        case 'en':
            return $b29cafa707c395e0$var$importHelper(await Promise.resolve((parcelRequire("8DLD7"))));
        case 'es':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("7lkyB")));
        case 'et':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("dCvJo")));
        case 'fi':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("jTB0l")));
        case 'fr':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("5S1zV")));
        case 'hr':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("5TqnL")));
        case 'hu':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("bvhrU")));
        case 'it':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("58giV")));
        case 'ja':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("6hkl8")));
        case 'ko':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("f8pos")));
        case 'nb':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("ajGUp")));
        case 'nl':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("ixanl")));
        case 'pl':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("lAjmB")));
        case 'pt-BR':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("jWwky")));
        case 'ro':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("3qo0Q")));
        case 'ru':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("k3qFk")));
        case 'sl':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("793El")));
        case 'sr-RS':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("25ZVe")));
        case 'sr-YR':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("2bv7j")));
        case 'sr':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("520hK")));
        case 'sv':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("fRJ7g")));
        case 'th':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("1WZFn")));
        case 'tr':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("eYvVI")));
        case 'uk':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("4aDKk")));
        case 'vi':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("kIThW")));
        case 'zh-CN':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("k618X")));
        case 'zh-TW':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("bqSK2")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8DLD7));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $aQHtk = parcelRequire("aQHtk");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ba63a4b1a3bf734f$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $ba63a4b1a3bf734f$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("fMSEy")));
        case 'da':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("3G9it")));
        case 'de':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("aM2FB")));
        case 'en-GB':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("bF4VV")));
        case 'en-US':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("2SbnI")));
        case 'en-XA':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("hDNJd")));
        case 'en-XB':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("3elgK")));
        case 'en-ZZ':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("iYqND")));
        case 'en':
            return $ba63a4b1a3bf734f$var$importHelper(await Promise.resolve((parcelRequire("aQHtk"))));
        case 'es':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("dZkOi")));
        case 'et':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("7Kl9V")));
        case 'fi':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("1jiqi")));
        case 'fr':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("kwgrL")));
        case 'hr':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("9cjc7")));
        case 'hu':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("eY6Xm")));
        case 'it':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("8b476")));
        case 'ja':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("6AL9N")));
        case 'ko':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("TQ212")));
        case 'nb':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("8gBYS")));
        case 'nl':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("h1EBA")));
        case 'pl':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("2rKwb")));
        case 'pt-BR':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("bs9HJ")));
        case 'ro':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("SxP1K")));
        case 'ru':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("848Jl")));
        case 'sl':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("d6B6Y")));
        case 'sr-RS':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("aHbdn")));
        case 'sr-YR':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("lqWIu")));
        case 'sr':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("d7OQl")));
        case 'sv':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("8eV38")));
        case 'th':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("huJQM")));
        case 'tr':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("d65j7")));
        case 'uk':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("7zcwB")));
        case 'vi':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("e2I4y")));
        case 'zh-CN':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("87swa")));
        case 'zh-TW':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("bE3B0")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($aQHtk));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $gHvGn = parcelRequire("gHvGn");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1c3c2e9ecd539937$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;




































const $1c3c2e9ecd539937$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("hWly3")));
        case 'da':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("kD2jz")));
        case 'de':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("1w2IL")));
        case 'en-GB':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("8RbOE")));
        case 'en-US':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("63Yel")));
        case 'en-XA':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("5M5pV")));
        case 'en-XB':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("2nT0u")));
        case 'en-ZZ':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("3e8DW")));
        case 'en':
            return $1c3c2e9ecd539937$var$importHelper(await Promise.resolve((parcelRequire("gHvGn"))));
        case 'es':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("7OtJ9")));
        case 'et':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("c9erU")));
        case 'fi':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("jxNdA")));
        case 'fr':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("fdsXl")));
        case 'hr':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("fNRe5")));
        case 'hu':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("kPor2")));
        case 'it':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("2kbU2")));
        case 'ja-JP':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("fZi6C")));
        case 'ja':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("eRwKc")));
        case 'ko':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("yg9gZ")));
        case 'nb':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("zjuWb")));
        case 'nl':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("enIzW")));
        case 'pl':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("8rNKP")));
        case 'pt-BR':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("hzrWy")));
        case 'ro':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("M9Xz5")));
        case 'ru':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("2I4JV")));
        case 'sl':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("026q8")));
        case 'sr-RS':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("46mMR")));
        case 'sr-YR':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("kezJr")));
        case 'sr':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("dsfVu")));
        case 'sv':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("j1a5i")));
        case 'th':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("kuDvi")));
        case 'tr':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("9jMo8")));
        case 'uk':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("hrIu5")));
        case 'vi':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("04ndd")));
        case 'zh-CN':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("gnNML")));
        case 'zh-TW':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("evz1y")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($gHvGn));
    }
};



var $6XRKH = parcelRequire("6XRKH");


var $4Vy0p = parcelRequire("4Vy0p");

/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $k2auA = parcelRequire("k2auA");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $03374d02ecd95d7d$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $03374d02ecd95d7d$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("FwuiN")));
        case 'da':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("eNgNU")));
        case 'de':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("lUgKS")));
        case 'en-GB':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("7ThjH")));
        case 'en-US':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("9sv9x")));
        case 'en-XA':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("782SK")));
        case 'en-XB':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("fKkKP")));
        case 'en-ZZ':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("5cj9Q")));
        case 'en':
            return $03374d02ecd95d7d$var$importHelper(await Promise.resolve((parcelRequire("k2auA"))));
        case 'es':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("i1khq")));
        case 'et':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("SNoUr")));
        case 'fi':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("1cRIF")));
        case 'fr':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("dzVtf")));
        case 'hr':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("gRM9j")));
        case 'hu':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("9Mae7")));
        case 'it':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("8qc8Y")));
        case 'ja':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("hENPP")));
        case 'ko':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("h9rEa")));
        case 'nb':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("4Uw1Y")));
        case 'nl':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("a2LSY")));
        case 'pl':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("jTUwT")));
        case 'pt-BR':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("6kNHQ")));
        case 'ro':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("dLmOX")));
        case 'ru':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("aCYfF")));
        case 'sl':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("fWbyw")));
        case 'sr-RS':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("as9ur")));
        case 'sr-YR':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("5x5w9")));
        case 'sr':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("eJkio")));
        case 'sv':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("e1SWB")));
        case 'th':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("e8j4V")));
        case 'tr':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("4ZM8U")));
        case 'uk':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("kljmN")));
        case 'vi':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("eZ572")));
        case 'zh-CN':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("62Cc4")));
        case 'zh-TW':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("8MpM5")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($k2auA));
    }
};



var $cPGgH = parcelRequire("cPGgH");


var $eaqtE = parcelRequire("eaqtE");

/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $9aKzs = parcelRequire("9aKzs");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3859a8d2f07ca507$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $3859a8d2f07ca507$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("8GURh")));
        case 'da':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("4zGtD")));
        case 'de':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("aid6F")));
        case 'en-GB':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("4Clyy")));
        case 'en-US':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("8uQPR")));
        case 'en-XA':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("hOrRF")));
        case 'en-XB':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("2yPxv")));
        case 'en-ZZ':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("2jMAY")));
        case 'en':
            return $3859a8d2f07ca507$var$importHelper(await Promise.resolve((parcelRequire("9aKzs"))));
        case 'es':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("biFM8")));
        case 'et':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("krKp5")));
        case 'fi':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("269w2")));
        case 'fr':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("JEIM5")));
        case 'hr':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("hByEB")));
        case 'hu':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("bUhBn")));
        case 'it':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("lgRkc")));
        case 'ja':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("fqI37")));
        case 'ko':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("6oC6u")));
        case 'nb':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("cnzYU")));
        case 'nl':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("IzJ62")));
        case 'pl':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("9Ze4j")));
        case 'pt-BR':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("6z72A")));
        case 'ro':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("irxYM")));
        case 'ru':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("OrW9M")));
        case 'sl':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("8TWgT")));
        case 'sr-RS':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("h75Oa")));
        case 'sr-YR':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("1MpTu")));
        case 'sr':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("lhybn")));
        case 'sv':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("iMfuZ")));
        case 'th':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("ie2Ua")));
        case 'tr':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("aolZxO")));
        case 'uk':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("4SSNj")));
        case 'vi':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("aXc5k")));
        case 'zh-CN':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("hpKAi")));
        case 'zh-TW':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("2QCge")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($9aKzs));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8l5Vh = parcelRequire("8l5Vh");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5a423455785561de$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $5a423455785561de$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $5a423455785561de$var$importHelper(await (parcelRequire("2S5KU")));
        case 'da':
            return $5a423455785561de$var$importHelper(await (parcelRequire("g4LNg")));
        case 'de':
            return $5a423455785561de$var$importHelper(await (parcelRequire("exKg5")));
        case 'en-GB':
            return $5a423455785561de$var$importHelper(await (parcelRequire("gaFGJ")));
        case 'en-US':
            return $5a423455785561de$var$importHelper(await (parcelRequire("6e45s")));
        case 'en-XA':
            return $5a423455785561de$var$importHelper(await (parcelRequire("32aVk")));
        case 'en-XB':
            return $5a423455785561de$var$importHelper(await (parcelRequire("iiAkf")));
        case 'en-ZZ':
            return $5a423455785561de$var$importHelper(await (parcelRequire("2kve5")));
        case 'en':
            return $5a423455785561de$var$importHelper(await Promise.resolve((parcelRequire("8l5Vh"))));
        case 'es':
            return $5a423455785561de$var$importHelper(await (parcelRequire("avBPq")));
        case 'et':
            return $5a423455785561de$var$importHelper(await (parcelRequire("bRMrv")));
        case 'fi':
            return $5a423455785561de$var$importHelper(await (parcelRequire("9OSuz")));
        case 'fr':
            return $5a423455785561de$var$importHelper(await (parcelRequire("6htpd")));
        case 'hr':
            return $5a423455785561de$var$importHelper(await (parcelRequire("7NeIw")));
        case 'hu':
            return $5a423455785561de$var$importHelper(await (parcelRequire("8lAlf")));
        case 'it':
            return $5a423455785561de$var$importHelper(await (parcelRequire("eqRMq")));
        case 'ja':
            return $5a423455785561de$var$importHelper(await (parcelRequire("fZnKc")));
        case 'ko':
            return $5a423455785561de$var$importHelper(await (parcelRequire("eXwQn")));
        case 'nb':
            return $5a423455785561de$var$importHelper(await (parcelRequire("3HgGd")));
        case 'nl':
            return $5a423455785561de$var$importHelper(await (parcelRequire("iLuVk")));
        case 'pl':
            return $5a423455785561de$var$importHelper(await (parcelRequire("4ECdt")));
        case 'pt-BR':
            return $5a423455785561de$var$importHelper(await (parcelRequire("l5Xon")));
        case 'ro':
            return $5a423455785561de$var$importHelper(await (parcelRequire("2QxFd")));
        case 'ru':
            return $5a423455785561de$var$importHelper(await (parcelRequire("5uSzX")));
        case 'sl':
            return $5a423455785561de$var$importHelper(await (parcelRequire("eUzIC")));
        case 'sr-RS':
            return $5a423455785561de$var$importHelper(await (parcelRequire("4lKDT")));
        case 'sr-YR':
            return $5a423455785561de$var$importHelper(await (parcelRequire("78WuP")));
        case 'sr':
            return $5a423455785561de$var$importHelper(await (parcelRequire("63SLp")));
        case 'sv':
            return $5a423455785561de$var$importHelper(await (parcelRequire("5VwrO")));
        case 'th':
            return $5a423455785561de$var$importHelper(await (parcelRequire("lSRnF")));
        case 'tr':
            return $5a423455785561de$var$importHelper(await (parcelRequire("2QwtB")));
        case 'uk':
            return $5a423455785561de$var$importHelper(await (parcelRequire("cTmP6")));
        case 'vi':
            return $5a423455785561de$var$importHelper(await (parcelRequire("9vcQi")));
        case 'zh-CN':
            return $5a423455785561de$var$importHelper(await (parcelRequire("01AdQ")));
        case 'zh-TW':
            return $5a423455785561de$var$importHelper(await (parcelRequire("8bawX")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8l5Vh));
    }
};



var $jWOGk = parcelRequire("jWOGk");

/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $hExow = parcelRequire("hExow");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b306bc40bc4d5af7$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $b306bc40bc4d5af7$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("7TLih")));
        case 'da':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("7mTau")));
        case 'de':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("aQ5Te")));
        case 'en-GB':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("3mJ4S")));
        case 'en-US':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("ehEnr")));
        case 'en-XA':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("bhKPe")));
        case 'en-XB':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("8aPOA")));
        case 'en-ZZ':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("5c04W")));
        case 'en':
            return $b306bc40bc4d5af7$var$importHelper(await Promise.resolve((parcelRequire("hExow"))));
        case 'es':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("iElhp")));
        case 'et':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("2MSuk")));
        case 'fi':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("gyU53")));
        case 'fr':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("hUMS7")));
        case 'hr':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("eCwrg")));
        case 'hu':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("2vIBs")));
        case 'it':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("ipMGk")));
        case 'ja':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("gre8P")));
        case 'ko':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("ahKBm")));
        case 'nb':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("lpVTB")));
        case 'nl':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("bNzyH")));
        case 'pl':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("9TBwA")));
        case 'pt-BR':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("6Uq1z")));
        case 'ro':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("krNGI")));
        case 'ru':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("eRkHK")));
        case 'sl':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("9X0Cq")));
        case 'sr-RS':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("kgvwa")));
        case 'sr-YR':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("6l3j3")));
        case 'sr':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("h0a3n")));
        case 'sv':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("3Mq6j")));
        case 'th':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("71Rjt")));
        case 'tr':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("cTrN7")));
        case 'uk':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("aUto0")));
        case 'vi':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("jcOzM")));
        case 'zh-CN':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("f9Xq7")));
        case 'zh-TW':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("e0QjB")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($hExow));
    }
};



var $bq5SV = parcelRequire("bq5SV");


var $7QguR = parcelRequire("7QguR");

/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $9RDCk = parcelRequire("9RDCk");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c2e2bac96bf01516$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $c2e2bac96bf01516$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("lupz6")));
        case 'da':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("7XJiU")));
        case 'de':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("9j5hY")));
        case 'en-GB':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("6ylJH")));
        case 'en-US':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("8ue0N")));
        case 'en-XA':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("6p26I")));
        case 'en-XB':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("1zirR")));
        case 'en-ZZ':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("htPBS")));
        case 'en':
            return $c2e2bac96bf01516$var$importHelper(await Promise.resolve((parcelRequire("9RDCk"))));
        case 'es':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("4lKRE")));
        case 'et':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("gRWyk")));
        case 'fi':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("aWiRr")));
        case 'fr':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("53Kck")));
        case 'hr':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("8hHOm")));
        case 'hu':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("bVckf")));
        case 'it':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("h6uCG")));
        case 'ja':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("eRZcr")));
        case 'ko':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("7PDrO")));
        case 'nb':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("i7KWJ")));
        case 'nl':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("9A01X")));
        case 'pl':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("6vNhc")));
        case 'pt-BR':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("b7AO3")));
        case 'ro':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("18xT8")));
        case 'ru':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("dXfvT")));
        case 'sl':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("cw89E")));
        case 'sr-RS':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("amZIT")));
        case 'sr-YR':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("jAmh8")));
        case 'sr':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("7q4Iv")));
        case 'sv':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("dk9wT")));
        case 'th':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("iVH0Y")));
        case 'tr':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("5QhtO")));
        case 'uk':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("f1A3H")));
        case 'vi':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("4frRm")));
        case 'zh-CN':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("2ac9b")));
        case 'zh-TW':
            return $c2e2bac96bf01516$var$importHelper(await (parcelRequire("h8OJ6")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($9RDCk));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $b9HG5 = parcelRequire("b9HG5");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $134e70f7aecb7824$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $134e70f7aecb7824$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("cG81y")));
        case 'da':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("2NyU9")));
        case 'de':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("ietP8")));
        case 'en-GB':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("1eovA")));
        case 'en-US':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("5k7oO")));
        case 'en-XA':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("88KU9")));
        case 'en-XB':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("etvON")));
        case 'en-ZZ':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("9kCgZ")));
        case 'en':
            return $134e70f7aecb7824$var$importHelper(await Promise.resolve((parcelRequire("b9HG5"))));
        case 'es':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("kxQKy")));
        case 'et':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("fqcA7")));
        case 'fi':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("1k6j7")));
        case 'fr':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("8rJtX")));
        case 'hr':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("37RbN")));
        case 'hu':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("bCAVJ")));
        case 'it':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("d3t0X")));
        case 'ja':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("bMGI1")));
        case 'ko':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("8hbyi")));
        case 'nb':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("d1DSE")));
        case 'nl':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("iugLC")));
        case 'pl':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("hAZGJ")));
        case 'pt-BR':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("6gViH")));
        case 'ro':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("69cDb")));
        case 'ru':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("4myJI")));
        case 'sl':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("9cxEo")));
        case 'sr-RS':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("kalAm")));
        case 'sr-YR':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("7Fzov")));
        case 'sr':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("8OFrP")));
        case 'sv':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("5gsuk")));
        case 'th':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("5U4bf")));
        case 'tr':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("44BT5")));
        case 'uk':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("4MR8N")));
        case 'vi':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("6fdO5")));
        case 'zh-CN':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("86TRc")));
        case 'zh-TW':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("lKnw1")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($b9HG5));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $iwQJq = parcelRequire("iwQJq");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ded7a36a0b579197$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $ded7a36a0b579197$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("esDHJ")));
        case 'da':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("9AMHt")));
        case 'de':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("4eLN9")));
        case 'en-GB':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("hkPKW")));
        case 'en-US':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("beYaH")));
        case 'en-XA':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("6ZiaS")));
        case 'en-XB':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("h2Q2Q")));
        case 'en-ZZ':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("bU500")));
        case 'en':
            return $ded7a36a0b579197$var$importHelper(await Promise.resolve((parcelRequire("iwQJq"))));
        case 'es':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("awDKW")));
        case 'et':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("AzXWa")));
        case 'fi':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("eF6Ya")));
        case 'fr':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("dd9cR")));
        case 'hr':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("a1Acb")));
        case 'hu':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("4LZ3t")));
        case 'it':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("9bTeQ")));
        case 'ja':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("5HqKc")));
        case 'ko':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("4uo0N")));
        case 'nb':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("1juUo")));
        case 'nl':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("cwrME")));
        case 'pl':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("8Qg1Z")));
        case 'pt-BR':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("2EI43")));
        case 'ro':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("daXaK")));
        case 'ru':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("e9mhf")));
        case 'sl':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("aoRDp")));
        case 'sr-RS':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("1FZc3")));
        case 'sr-YR':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("3gHqI")));
        case 'sr':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("dtwRs")));
        case 'sv':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("kOGAu")));
        case 'th':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("dRke1")));
        case 'tr':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("4bMpu")));
        case 'uk':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("3QLtk")));
        case 'vi':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("8hTGT")));
        case 'zh-CN':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("bXeCN")));
        case 'zh-TW':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("9wqIE")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($iwQJq));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $f5lVB = parcelRequire("f5lVB");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $baf792afd2d6d0ed$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $baf792afd2d6d0ed$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("eJARV")));
        case 'da':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("c8HEb")));
        case 'de':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("3S5og")));
        case 'en-GB':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("1DOsy")));
        case 'en-US':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("5A0e0")));
        case 'en-XA':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("1BlH8")));
        case 'en-XB':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("eIS6p")));
        case 'en-ZZ':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("937y2")));
        case 'en':
            return $baf792afd2d6d0ed$var$importHelper(await Promise.resolve((parcelRequire("f5lVB"))));
        case 'es':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("cn7N4")));
        case 'et':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("7RVtq")));
        case 'fi':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("2C8PW")));
        case 'fr':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("2grYS")));
        case 'hr':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("hPl05")));
        case 'hu':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("2VzBa")));
        case 'it':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("1BrDj")));
        case 'ja':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("11EUE")));
        case 'ko':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("aMBi9")));
        case 'nb':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("27hut")));
        case 'nl':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("6OsG3")));
        case 'pl':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("33ogS")));
        case 'pt-BR':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("cDzdi")));
        case 'ro':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("hTXg4")));
        case 'ru':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("4yGSl")));
        case 'sl':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("67VKj")));
        case 'sr-RS':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("7CdPL")));
        case 'sr-YR':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("9fzK8")));
        case 'sr':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("9BrJT")));
        case 'sv':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("1tMpf")));
        case 'th':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("5toJp")));
        case 'tr':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("9bd4K")));
        case 'uk':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("9VH07")));
        case 'vi':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("kPern")));
        case 'zh-CN':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("eCFB3")));
        case 'zh-TW':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("9Joxq")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($f5lVB));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $fnjwM = parcelRequire("fnjwM");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $85b4d2dabc381287$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $85b4d2dabc381287$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("alZ6t")));
        case 'da':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("jjI9T")));
        case 'de':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("4CGwT")));
        case 'en-GB':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("hLcE3")));
        case 'en-US':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("b968C")));
        case 'en-XA':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("7AD3N")));
        case 'en-XB':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("lQ73y")));
        case 'en-ZZ':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("jdijK")));
        case 'en':
            return $85b4d2dabc381287$var$importHelper(await Promise.resolve((parcelRequire("fnjwM"))));
        case 'es':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("c4QmP")));
        case 'et':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("aJgCR")));
        case 'fi':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("1B4TH")));
        case 'fr':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("hRqHT")));
        case 'hr':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("jyUGx")));
        case 'hu':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("bi7ue")));
        case 'it':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("63Oos")));
        case 'ja':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("cPVbs")));
        case 'ko':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("lUbkO")));
        case 'nb':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("fojmp")));
        case 'nl':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("1Im5h")));
        case 'pl':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("b7PuI")));
        case 'pt-BR':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("awCZh")));
        case 'ro':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("fX5Gv")));
        case 'ru':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("5vsDw")));
        case 'sl':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("jRjmb")));
        case 'sr-RS':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("bzsYJ")));
        case 'sr-YR':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("jP49l")));
        case 'sr':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("7wWJW")));
        case 'sv':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("2n8d7")));
        case 'th':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("lmH7k")));
        case 'tr':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("6ua4X")));
        case 'uk':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("iFzjG")));
        case 'vi':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("3WTZO")));
        case 'zh-CN':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("fXzfL")));
        case 'zh-TW':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("haLUf")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($fnjwM));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $kDvBY = parcelRequire("kDvBY");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0b5cba97a6571227$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $0b5cba97a6571227$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("3qG4F")));
        case 'da':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("6vgTR")));
        case 'de':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("5uH1o")));
        case 'en-GB':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("eycDR")));
        case 'en-US':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("71unu")));
        case 'en-XA':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("7QImw")));
        case 'en-XB':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("esvWB")));
        case 'en-ZZ':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("wwoSG")));
        case 'en':
            return $0b5cba97a6571227$var$importHelper(await Promise.resolve((parcelRequire("kDvBY"))));
        case 'es':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("d9FaO")));
        case 'et':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("bcEp6")));
        case 'fi':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("cPisg")));
        case 'fr':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("gKvel")));
        case 'hr':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("iexSm")));
        case 'hu':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("3cwM2")));
        case 'it':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("6rvzd")));
        case 'ja':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("2TrDa")));
        case 'ko':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("8bc2h")));
        case 'nb':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("SJxrG")));
        case 'nl':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("bdFPK")));
        case 'pl':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("dn4qr")));
        case 'pt-BR':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("4ukYk")));
        case 'ro':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("7qtmD")));
        case 'ru':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("8RiMF")));
        case 'sl':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("lWsSi")));
        case 'sr-RS':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("ftx15")));
        case 'sr-YR':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("4pFQf")));
        case 'sr':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("lq0RK")));
        case 'sv':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("gdfv9")));
        case 'th':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("ifomm")));
        case 'tr':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("d8v7l")));
        case 'uk':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("8fuUJ")));
        case 'vi':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("8aMn9")));
        case 'zh-CN':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("8TCeu")));
        case 'zh-TW':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("iV0ke")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($kDvBY));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $eKgSp = parcelRequire("eKgSp");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7b3732ffccb37f07$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $7b3732ffccb37f07$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("429nu")));
        case 'da':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("lkJRX")));
        case 'de':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("lTmRO")));
        case 'en-GB':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("kVSfW")));
        case 'en-US':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("lga3Q")));
        case 'en-XA':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("4lqx1")));
        case 'en-XB':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("8ESoT")));
        case 'en-ZZ':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("gWvPm")));
        case 'en':
            return $7b3732ffccb37f07$var$importHelper(await Promise.resolve((parcelRequire("eKgSp"))));
        case 'es':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("9A72q")));
        case 'et':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("gx1CC")));
        case 'fi':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("bBCYv")));
        case 'fr':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("8CdyV")));
        case 'hr':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("dMuHY")));
        case 'hu':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("kMCDP")));
        case 'it':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("dWA2c")));
        case 'ja':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("izvSu")));
        case 'ko':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("7Lxrh")));
        case 'nb':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("jdwgw")));
        case 'nl':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("cHuDH")));
        case 'pl':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("keqsm")));
        case 'pt-BR':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("bKddi")));
        case 'ro':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("eZBaS")));
        case 'ru':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("d2EqJ")));
        case 'sl':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("8yPmT")));
        case 'sr-RS':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("lkxV9")));
        case 'sr-YR':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("lLCIC")));
        case 'sr':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("lkqfj")));
        case 'sv':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("efFK4")));
        case 'th':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("krC0o")));
        case 'tr':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("9muly")));
        case 'uk':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("apk7s")));
        case 'vi':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("fDi4x")));
        case 'zh-CN':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("gpcYc")));
        case 'zh-TW':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("ib4T9")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($eKgSp));
    }
};



var $gIcFu = parcelRequire("gIcFu");

/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $lzOvC = parcelRequire("lzOvC");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3976b1c3d1c141aa$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $3976b1c3d1c141aa$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("62vgI")));
        case 'da':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("gPR4R")));
        case 'de':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("5g3kR")));
        case 'en-GB':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("c1drX")));
        case 'en-US':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("Sjgmg")));
        case 'en-XA':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("6MB91")));
        case 'en-XB':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("2oCab")));
        case 'en-ZZ':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("hzd9l")));
        case 'en':
            return $3976b1c3d1c141aa$var$importHelper(await Promise.resolve((parcelRequire("lzOvC"))));
        case 'es':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("3t2D5")));
        case 'et':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("2pKAa")));
        case 'fi':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("45Usu")));
        case 'fr':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("bHjty")));
        case 'hr':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("alPmq")));
        case 'hu':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("4M6FR")));
        case 'it':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("iyYoP")));
        case 'ja':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("kZwkd")));
        case 'ko':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("dHoaX")));
        case 'nb':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("3raFD")));
        case 'nl':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("exitT")));
        case 'pl':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("bVXPj")));
        case 'pt-BR':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("c0zow")));
        case 'ro':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("jZhFg")));
        case 'ru':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("fV7bw")));
        case 'sl':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("fPID5")));
        case 'sr-RS':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("fYROS")));
        case 'sr-YR':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("eRbae")));
        case 'sr':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("15Kks")));
        case 'sv':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("6vg3U")));
        case 'th':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("lrnaw")));
        case 'tr':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("9LzqH")));
        case 'uk':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("jbbJk")));
        case 'vi':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("jZeNQ")));
        case 'zh-CN':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("jQ2cU")));
        case 'zh-TW':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("4HVs6")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($lzOvC));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $2Zd3Q = parcelRequire("2Zd3Q");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7c5c9ef5c83558a9$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $7c5c9ef5c83558a9$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("iUZnC")));
        case 'da':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("9N4Up")));
        case 'de':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("1n5UH")));
        case 'en-GB':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("g6ptF")));
        case 'en-US':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("7wcyl")));
        case 'en-XA':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("gRTcM")));
        case 'en-XB':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("hKBiq")));
        case 'en-ZZ':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("3Rtoa")));
        case 'en':
            return $7c5c9ef5c83558a9$var$importHelper(await Promise.resolve((parcelRequire("2Zd3Q"))));
        case 'es':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("l7W0z")));
        case 'et':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("cbXiM")));
        case 'fi':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("sUJqP")));
        case 'fr':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("lzFjf")));
        case 'hr':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("99T91")));
        case 'hu':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("9M8yL")));
        case 'it':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("bKsZA")));
        case 'ja':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("4VyCo")));
        case 'ko':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("2QyXe")));
        case 'nb':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("lKFwf")));
        case 'nl':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("k14ay")));
        case 'pl':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("clUv1")));
        case 'pt-BR':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("btmDe")));
        case 'ro':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("byka9")));
        case 'ru':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("5ydME")));
        case 'sl':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("gGpon")));
        case 'sr-RS':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("9eo1c")));
        case 'sr-YR':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("jKqGZ")));
        case 'sr':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("aK5dI")));
        case 'sv':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("l7CJr")));
        case 'th':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("bODaF")));
        case 'tr':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("kZji1")));
        case 'uk':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("1CKFL")));
        case 'vi':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("bEOB5")));
        case 'zh-CN':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("kKovn")));
        case 'zh-TW':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("3LkYB")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($2Zd3Q));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $5LXn7 = parcelRequire("5LXn7");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $70f71d801b11c9d6$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $70f71d801b11c9d6$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("lNvx6")));
        case 'da':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("gazYW")));
        case 'de':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("kxeq9")));
        case 'en-GB':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("1IDHd")));
        case 'en-US':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("AT11t")));
        case 'en-XA':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("bmVIy")));
        case 'en-XB':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("c1Sw8")));
        case 'en-ZZ':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("lp3zR")));
        case 'en':
            return $70f71d801b11c9d6$var$importHelper(await Promise.resolve((parcelRequire("5LXn7"))));
        case 'es':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("283aW")));
        case 'et':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("dZ4om")));
        case 'fi':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("3sUkb")));
        case 'fr':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("jBmNc")));
        case 'hr':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("15qwh")));
        case 'hu':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("5PzhD")));
        case 'it':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("7UkhN")));
        case 'ja':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("2tRH7")));
        case 'ko':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("e1zmU")));
        case 'nb':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("87I2q")));
        case 'nl':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("6WREV")));
        case 'pl':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("2sB85")));
        case 'pt-BR':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("hY2q5")));
        case 'ro':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("l5xuT")));
        case 'ru':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("2ksgB")));
        case 'sl':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("9cyWu")));
        case 'sr-RS':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("5UvXI")));
        case 'sr-YR':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("7zFF6")));
        case 'sr':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("6RotY")));
        case 'sv':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("02GWY")));
        case 'th':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("gyLnY")));
        case 'tr':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("37a11")));
        case 'uk':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("gieR4")));
        case 'vi':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("cfoJK")));
        case 'zh-CN':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("7MnUN")));
        case 'zh-TW':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("9u4Zn")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($5LXn7));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $d9Kla = parcelRequire("d9Kla");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a28bd0d7be6a48f1$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $a28bd0d7be6a48f1$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("ktcOp")));
        case 'da':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("iBniq")));
        case 'de':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("9E25K")));
        case 'en-GB':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("6anjp")));
        case 'en-US':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("luucs")));
        case 'en-XA':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("f5joJ")));
        case 'en-XB':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("6nrI0")));
        case 'en-ZZ':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("bxaDU")));
        case 'en':
            return $a28bd0d7be6a48f1$var$importHelper(await Promise.resolve((parcelRequire("d9Kla"))));
        case 'es':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("98EBs")));
        case 'et':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("gE99x")));
        case 'fi':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("hlhL8")));
        case 'fr':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("9yRox")));
        case 'hr':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("lQ8wg")));
        case 'hu':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("jnLzZ")));
        case 'it':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("2C8Xo")));
        case 'ja':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("5h5os")));
        case 'ko':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("ei1op")));
        case 'nb':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("9fvHg")));
        case 'nl':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("hLER0")));
        case 'pl':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("aFnwY")));
        case 'pt-BR':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("0sqpa")));
        case 'ro':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("fVd32")));
        case 'ru':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("bmLRy")));
        case 'sl':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("k3mzK")));
        case 'sr-RS':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("1Uxdk")));
        case 'sr-YR':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("k7AMr")));
        case 'sr':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("kum9N")));
        case 'sv':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("1kfoi")));
        case 'th':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("2UjWQ")));
        case 'tr':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("jaQ6u")));
        case 'uk':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("hMVdN")));
        case 'vi':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("6pAEW")));
        case 'zh-CN':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("kzCrI")));
        case 'zh-TW':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("gKRAQ")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($d9Kla));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $3NgrG = parcelRequire("3NgrG");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3105d7182dae50be$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $3105d7182dae50be$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("7UFKR")));
        case 'da':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("7xrR7")));
        case 'de':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("5x31x")));
        case 'en-GB':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("irJXn")));
        case 'en-US':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("aj07G")));
        case 'en-XA':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("5KdSc")));
        case 'en-XB':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("elzTc")));
        case 'en-ZZ':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("jpvXg")));
        case 'en':
            return $3105d7182dae50be$var$importHelper(await Promise.resolve((parcelRequire("3NgrG"))));
        case 'es':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("iyt6Y")));
        case 'et':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("kGz6V")));
        case 'fi':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("feZ8g")));
        case 'fr':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("Gh97v")));
        case 'hr':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("lQTvq")));
        case 'hu':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("j0D9N")));
        case 'it':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("7u6a1")));
        case 'ja':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("78jBd")));
        case 'ko':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("kk9UR")));
        case 'nb':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("p0vY1")));
        case 'nl':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("5Z0g7")));
        case 'pl':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("5i3XF")));
        case 'pt-BR':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("aVvtu")));
        case 'ro':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("7Fvbt")));
        case 'ru':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("2RDu2")));
        case 'sl':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("c2ndM")));
        case 'sr-RS':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("gUTaH")));
        case 'sr-YR':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("lCWMS")));
        case 'sr':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("hm9Dy")));
        case 'sv':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("3ONYW")));
        case 'th':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("hRI0p")));
        case 'tr':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("gTtok")));
        case 'uk':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("hb44P")));
        case 'vi':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("hX03y")));
        case 'zh-CN':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("fYaiw")));
        case 'zh-TW':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("6VwSN")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($3NgrG));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $bEUWX = parcelRequire("bEUWX");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $355fa0babacd352f$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $355fa0babacd352f$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("2RLjC")));
        case 'da':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("dGu50")));
        case 'de':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("aOiiW")));
        case 'en-GB':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("funYt")));
        case 'en-US':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("i24EM")));
        case 'en-XA':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("jhXoI")));
        case 'en-XB':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("L5WWk")));
        case 'en-ZZ':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("h0oUr")));
        case 'en':
            return $355fa0babacd352f$var$importHelper(await Promise.resolve((parcelRequire("bEUWX"))));
        case 'es':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("13Wsv")));
        case 'et':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("gVqQl")));
        case 'fi':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("aSf2F")));
        case 'fr':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("iaMoz")));
        case 'hr':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("cpDmt")));
        case 'hu':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("1Crzy")));
        case 'it':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("2NSFh")));
        case 'ja':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("2Durl")));
        case 'ko':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("2fH5g")));
        case 'nb':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("de9J4")));
        case 'nl':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("2w5Qd")));
        case 'pl':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("ht60R")));
        case 'pt-BR':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("l8Lmn")));
        case 'ro':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("e07cw")));
        case 'ru':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("jKS37")));
        case 'sl':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("cdolv")));
        case 'sr-RS':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("eDzD9")));
        case 'sr-YR':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("2mx5U")));
        case 'sr':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("1PMkZ")));
        case 'sv':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("hWVm9")));
        case 'th':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("jSqbS")));
        case 'tr':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("1VVPw")));
        case 'uk':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("3xs7D")));
        case 'vi':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("dNusO")));
        case 'zh-CN':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("dilgY")));
        case 'zh-TW':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("7sfMS")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($bEUWX));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $yNAPT = parcelRequire("yNAPT");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $388818403434a675$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $388818403434a675$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $388818403434a675$var$importHelper(await (parcelRequire("at6ge")));
        case 'da':
            return $388818403434a675$var$importHelper(await (parcelRequire("h3LQV")));
        case 'de':
            return $388818403434a675$var$importHelper(await (parcelRequire("iDANl")));
        case 'en-GB':
            return $388818403434a675$var$importHelper(await (parcelRequire("bsAiM")));
        case 'en-US':
            return $388818403434a675$var$importHelper(await (parcelRequire("6lyYa")));
        case 'en-XA':
            return $388818403434a675$var$importHelper(await (parcelRequire("8qi8n")));
        case 'en-XB':
            return $388818403434a675$var$importHelper(await (parcelRequire("6XkOd")));
        case 'en-ZZ':
            return $388818403434a675$var$importHelper(await (parcelRequire("d67Hj")));
        case 'en':
            return $388818403434a675$var$importHelper(await Promise.resolve((parcelRequire("yNAPT"))));
        case 'es':
            return $388818403434a675$var$importHelper(await (parcelRequire("1keZ4")));
        case 'et':
            return $388818403434a675$var$importHelper(await (parcelRequire("2nKnU")));
        case 'fi':
            return $388818403434a675$var$importHelper(await (parcelRequire("gWLXI")));
        case 'fr':
            return $388818403434a675$var$importHelper(await (parcelRequire("1BDAL")));
        case 'hr':
            return $388818403434a675$var$importHelper(await (parcelRequire("jtjTT")));
        case 'hu':
            return $388818403434a675$var$importHelper(await (parcelRequire("e1N2p")));
        case 'it':
            return $388818403434a675$var$importHelper(await (parcelRequire("9lyX3")));
        case 'ja':
            return $388818403434a675$var$importHelper(await (parcelRequire("dTUIP")));
        case 'ko':
            return $388818403434a675$var$importHelper(await (parcelRequire("04MZU")));
        case 'nb':
            return $388818403434a675$var$importHelper(await (parcelRequire("dVWXL")));
        case 'nl':
            return $388818403434a675$var$importHelper(await (parcelRequire("a8PaN")));
        case 'pl':
            return $388818403434a675$var$importHelper(await (parcelRequire("jCefS")));
        case 'pt-BR':
            return $388818403434a675$var$importHelper(await (parcelRequire("9V8bE")));
        case 'ro':
            return $388818403434a675$var$importHelper(await (parcelRequire("1mMbt")));
        case 'ru':
            return $388818403434a675$var$importHelper(await (parcelRequire("1F49G")));
        case 'sl':
            return $388818403434a675$var$importHelper(await (parcelRequire("a7MkY")));
        case 'sr-RS':
            return $388818403434a675$var$importHelper(await (parcelRequire("c736q")));
        case 'sr-YR':
            return $388818403434a675$var$importHelper(await (parcelRequire("fYv7t")));
        case 'sr':
            return $388818403434a675$var$importHelper(await (parcelRequire("5GFdo")));
        case 'sv':
            return $388818403434a675$var$importHelper(await (parcelRequire("aBTMj")));
        case 'th':
            return $388818403434a675$var$importHelper(await (parcelRequire("bDOVy")));
        case 'tr':
            return $388818403434a675$var$importHelper(await (parcelRequire("euBtw")));
        case 'uk':
            return $388818403434a675$var$importHelper(await (parcelRequire("cMpDF")));
        case 'vi':
            return $388818403434a675$var$importHelper(await (parcelRequire("cPYe2")));
        case 'zh-CN':
            return $388818403434a675$var$importHelper(await (parcelRequire("fgCrG")));
        case 'zh-TW':
            return $388818403434a675$var$importHelper(await (parcelRequire("hkOdi")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($yNAPT));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $fyclM = parcelRequire("fyclM");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $dd065fd1382b4a2f$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $dd065fd1382b4a2f$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("cGd1k")));
        case 'da':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("3HDjE")));
        case 'de':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("hAAl0")));
        case 'en-GB':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("ky6Rt")));
        case 'en-US':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("aU26J")));
        case 'en-XA':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("4FonW")));
        case 'en-XB':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("6uKj4")));
        case 'en-ZZ':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("3tAQa")));
        case 'en':
            return $dd065fd1382b4a2f$var$importHelper(await Promise.resolve((parcelRequire("fyclM"))));
        case 'es':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("1HVDx")));
        case 'et':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("9CafP")));
        case 'fi':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("6ltLd")));
        case 'fr':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("i16Fe")));
        case 'hr':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("6r2ld")));
        case 'hu':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("kf1O9")));
        case 'it':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("b4nzq")));
        case 'ja':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("ljPEV")));
        case 'ko':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("8KduJ")));
        case 'nb':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("hMJjt")));
        case 'nl':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("40c6r")));
        case 'pl':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("6LxVi")));
        case 'pt-BR':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("7p3Ya")));
        case 'ro':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("dIGoT")));
        case 'ru':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("aX1s8")));
        case 'sl':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("c3rCu")));
        case 'sr-RS':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("dVLoB")));
        case 'sr-YR':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("j5CRW")));
        case 'sr':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("lg8vL")));
        case 'sv':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("9jSrV")));
        case 'th':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("92SVU")));
        case 'tr':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("aghh8")));
        case 'uk':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("kksE6")));
        case 'vi':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("2Di42")));
        case 'zh-CN':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("mhkYP")));
        case 'zh-TW':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("bAQal")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($fyclM));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $c8Pyb = parcelRequire("c8Pyb");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $cecaf353d0a30194$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $cecaf353d0a30194$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("72yBg")));
        case 'da':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("34CHz")));
        case 'de':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("kMKcN")));
        case 'en-GB':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("apltJ")));
        case 'en-US':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("3K0Yv")));
        case 'en-XA':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("djKWK")));
        case 'en-XB':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("01utY")));
        case 'en-ZZ':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("24m3m")));
        case 'en':
            return $cecaf353d0a30194$var$importHelper(await Promise.resolve((parcelRequire("c8Pyb"))));
        case 'es':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("96EuC")));
        case 'et':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("2U42d")));
        case 'fi':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("7Gz2R")));
        case 'fr':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("eJudw")));
        case 'hr':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("jWXSm")));
        case 'hu':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("d0CCF")));
        case 'it':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("hVgMi")));
        case 'ja':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("aqAkV")));
        case 'ko':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("8jPAN")));
        case 'nb':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("hJ1Ua")));
        case 'nl':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("a9ymm")));
        case 'pl':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("dqohW")));
        case 'pt-BR':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("c5L14")));
        case 'ro':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("1xaV8")));
        case 'ru':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("htHe6")));
        case 'sl':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("8xsok")));
        case 'sr-RS':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("id7hU")));
        case 'sr-YR':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("fy3FM")));
        case 'sr':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("5NLRP")));
        case 'sv':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("94DnD")));
        case 'th':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("juHGP")));
        case 'tr':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("a2UWN")));
        case 'uk':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("5PbVc")));
        case 'vi':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("amBbx")));
        case 'zh-CN':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("fkh2h")));
        case 'zh-TW':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("40r0l")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($c8Pyb));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $gK3zM = parcelRequire("gK3zM");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $17036b5e3995711b$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $17036b5e3995711b$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("dC2IS")));
        case 'da':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("aIZAP")));
        case 'de':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("hWcFz")));
        case 'en-GB':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("i96r9")));
        case 'en-US':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("3nia2")));
        case 'en-XA':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("da2r6")));
        case 'en-XB':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("bXNpI")));
        case 'en-ZZ':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("66n3X")));
        case 'en':
            return $17036b5e3995711b$var$importHelper(await Promise.resolve((parcelRequire("gK3zM"))));
        case 'es':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("cpZ6Z")));
        case 'et':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("4ET6R")));
        case 'fi':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("9VSom")));
        case 'fr':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("SDfFq")));
        case 'hr':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("bt1SJ")));
        case 'hu':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("lzChE")));
        case 'it':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("hXmDf")));
        case 'ja':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("aUZ8j")));
        case 'ko':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("1u6AF")));
        case 'nb':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("sImHY")));
        case 'nl':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("fcZIE")));
        case 'pl':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("16P0m")));
        case 'pt-BR':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("7vwBZ")));
        case 'ro':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("cVRT2")));
        case 'ru':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("8JdZ1")));
        case 'sl':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("guipf")));
        case 'sr-RS':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("k0CnR")));
        case 'sr-YR':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("b8ebr")));
        case 'sr':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("6NLKW")));
        case 'sv':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("kh1Vy")));
        case 'th':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("3gqHa")));
        case 'tr':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("gVvdw")));
        case 'uk':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("3vvpd")));
        case 'vi':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("4yDFm")));
        case 'zh-CN':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("9ZMNS")));
        case 'zh-TW':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("dFCLX")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($gK3zM));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $h89dU = parcelRequire("h89dU");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $08ae4730ccae252e$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $08ae4730ccae252e$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("18AbW")));
        case 'da':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("5TrQ9")));
        case 'de':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("apcQm")));
        case 'en-GB':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("38Pio")));
        case 'en-US':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("ePu5I")));
        case 'en-XA':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("3ie9X")));
        case 'en-XB':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("f3eB3")));
        case 'en-ZZ':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("4L0cU")));
        case 'en':
            return $08ae4730ccae252e$var$importHelper(await Promise.resolve((parcelRequire("h89dU"))));
        case 'es':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("eQsRU")));
        case 'et':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("hWyGN")));
        case 'fi':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("aVyPi")));
        case 'fr':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("hkaHC")));
        case 'hr':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("7BPcO")));
        case 'hu':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("iiAOW")));
        case 'it':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("7vYJq")));
        case 'ja':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("7UAe1")));
        case 'ko':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("alQ7v")));
        case 'nb':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("9R1Vi")));
        case 'nl':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("9Y5Ly")));
        case 'pl':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("cV5oE")));
        case 'pt-BR':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("7eC1l")));
        case 'ro':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("3DmQG")));
        case 'ru':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("a0gCC")));
        case 'sl':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("fkXoM")));
        case 'sr-RS':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("bkkFx")));
        case 'sr-YR':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("4xEEU")));
        case 'sr':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("cgoSX")));
        case 'sv':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("4A4dR")));
        case 'th':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("3tX10")));
        case 'tr':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("9XdYK")));
        case 'uk':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("kMafC")));
        case 'vi':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("lleYH")));
        case 'zh-CN':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("g1YnZ")));
        case 'zh-TW':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("1LJzY")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($h89dU));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $kYoj6 = parcelRequire("kYoj6");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a9d3619dfc2a8f0b$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $a9d3619dfc2a8f0b$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("eiM2m")));
        case 'da':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("65wfA")));
        case 'de':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("1ZTvk")));
        case 'en-GB':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("Z8qZU")));
        case 'en-US':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("8DQF6")));
        case 'en-XA':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("lBaPq")));
        case 'en-XB':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("hu2Y1")));
        case 'en-ZZ':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("fFJVd")));
        case 'en':
            return $a9d3619dfc2a8f0b$var$importHelper(await Promise.resolve((parcelRequire("kYoj6"))));
        case 'es':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("7S9Yp")));
        case 'et':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("82UKL")));
        case 'fi':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("fN6YI")));
        case 'fr':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("aXPnF")));
        case 'hr':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("kQdee")));
        case 'hu':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("ck1Qm")));
        case 'it':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("e3a29")));
        case 'ja':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("8Co6l")));
        case 'ko':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("2lIfS")));
        case 'nb':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("joXxg")));
        case 'nl':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("77CA0")));
        case 'pl':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("7Fdds")));
        case 'pt-BR':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("4fva7")));
        case 'ro':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("3IxoF")));
        case 'ru':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("gH2aF")));
        case 'sl':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("bljMD")));
        case 'sr-RS':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("h4Lqr")));
        case 'sr-YR':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("6Rozx")));
        case 'sr':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("4G3JL")));
        case 'sv':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("95bn1")));
        case 'th':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("4j19V")));
        case 'tr':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("1FQvq")));
        case 'uk':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("4P9pt")));
        case 'vi':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("MhCQ6")));
        case 'zh-CN':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("aeOW7")));
        case 'zh-TW':
            return $a9d3619dfc2a8f0b$var$importHelper(await (parcelRequire("d6JHs")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($kYoj6));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $6HVff = parcelRequire("6HVff");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2c58b23859af77ab$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $2c58b23859af77ab$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("2Kd6C")));
        case 'da':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("lw41y")));
        case 'de':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("crUJD")));
        case 'en-GB':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("b1wqV")));
        case 'en-US':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("g6r7n")));
        case 'en-XA':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("3VXaK")));
        case 'en-XB':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("6dDc8")));
        case 'en-ZZ':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("aIzii")));
        case 'en':
            return $2c58b23859af77ab$var$importHelper(await Promise.resolve((parcelRequire("6HVff"))));
        case 'es':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("83hQf")));
        case 'et':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("cQcQk")));
        case 'fi':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("6YyWh")));
        case 'fr':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("5Z7pM")));
        case 'hr':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("2rBOg")));
        case 'hu':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("aVKau")));
        case 'it':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("e0dbW")));
        case 'ja':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("h7c5Y")));
        case 'ko':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("3zn4F")));
        case 'nb':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("6Pqb8")));
        case 'nl':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("f09u8")));
        case 'pl':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("f8znK")));
        case 'pt-BR':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("bKnCl")));
        case 'ro':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("9Tbjf")));
        case 'ru':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("7tpoI")));
        case 'sl':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("1NbHf")));
        case 'sr-RS':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("3HIVY")));
        case 'sr-YR':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("a8ohm")));
        case 'sr':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("ivZD4")));
        case 'sv':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("iSxsK")));
        case 'th':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("RcCEN")));
        case 'tr':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("bgfWq")));
        case 'uk':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("imUvr")));
        case 'vi':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("gCVPz")));
        case 'zh-CN':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("afU4v")));
        case 'zh-TW':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("aK9R1")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($6HVff));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $b9hxd = parcelRequire("b9hxd");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8c19776cd00b41d0$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $8c19776cd00b41d0$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("gFZts")));
        case 'da':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("eWItg")));
        case 'de':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("78918")));
        case 'en-GB':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("gJib5")));
        case 'en-US':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("1sFPA")));
        case 'en-XA':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("cwUFF")));
        case 'en-XB':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("6dvF9")));
        case 'en-ZZ':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("csb1s")));
        case 'en':
            return $8c19776cd00b41d0$var$importHelper(await Promise.resolve((parcelRequire("b9hxd"))));
        case 'es':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("bCHa3")));
        case 'et':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("553z6")));
        case 'fi':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("14QYC")));
        case 'fr':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("iTvo8")));
        case 'hr':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("22MCk")));
        case 'hu':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("3W3fm")));
        case 'it':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("5k5XS")));
        case 'ja':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("kGoGQ")));
        case 'ko':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("eyOq1")));
        case 'nb':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("2desL")));
        case 'nl':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("6ruAp")));
        case 'pl':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("gxAUL")));
        case 'pt-BR':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("7xXf0")));
        case 'ro':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("6xmsq")));
        case 'ru':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("lStcL")));
        case 'sl':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("dwuVP")));
        case 'sr-RS':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("9uf6k")));
        case 'sr-YR':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("19tni")));
        case 'sr':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("fI7ZB")));
        case 'sv':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("4QBCK")));
        case 'th':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("lf5sD")));
        case 'tr':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("ewCAm")));
        case 'uk':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("gSOTt")));
        case 'vi':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("9b0w8")));
        case 'zh-CN':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("9ejEW")));
        case 'zh-TW':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("bMYzJ")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($b9hxd));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $62SxZ = parcelRequire("62SxZ");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $207575139b947a55$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $207575139b947a55$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $207575139b947a55$var$importHelper(await (parcelRequire("jMin0")));
        case 'da':
            return $207575139b947a55$var$importHelper(await (parcelRequire("jOOLq")));
        case 'de':
            return $207575139b947a55$var$importHelper(await (parcelRequire("dFsO2")));
        case 'en-GB':
            return $207575139b947a55$var$importHelper(await (parcelRequire("7RHRl")));
        case 'en-US':
            return $207575139b947a55$var$importHelper(await (parcelRequire("2yal3")));
        case 'en-XA':
            return $207575139b947a55$var$importHelper(await (parcelRequire("aqy1O")));
        case 'en-XB':
            return $207575139b947a55$var$importHelper(await (parcelRequire("c9kh3")));
        case 'en-ZZ':
            return $207575139b947a55$var$importHelper(await (parcelRequire("7HGdd")));
        case 'en':
            return $207575139b947a55$var$importHelper(await Promise.resolve((parcelRequire("62SxZ"))));
        case 'es':
            return $207575139b947a55$var$importHelper(await (parcelRequire("gsysz")));
        case 'et':
            return $207575139b947a55$var$importHelper(await (parcelRequire("gWeg4")));
        case 'fi':
            return $207575139b947a55$var$importHelper(await (parcelRequire("kL6H0")));
        case 'fr':
            return $207575139b947a55$var$importHelper(await (parcelRequire("damiK")));
        case 'hr':
            return $207575139b947a55$var$importHelper(await (parcelRequire("7N3rm")));
        case 'hu':
            return $207575139b947a55$var$importHelper(await (parcelRequire("5Xelr")));
        case 'it':
            return $207575139b947a55$var$importHelper(await (parcelRequire("gpKRP")));
        case 'ja':
            return $207575139b947a55$var$importHelper(await (parcelRequire("1v10D")));
        case 'ko':
            return $207575139b947a55$var$importHelper(await (parcelRequire("9ghzJ")));
        case 'nb':
            return $207575139b947a55$var$importHelper(await (parcelRequire("heZJy")));
        case 'nl':
            return $207575139b947a55$var$importHelper(await (parcelRequire("fn69F")));
        case 'pl':
            return $207575139b947a55$var$importHelper(await (parcelRequire("asfgE")));
        case 'pt-BR':
            return $207575139b947a55$var$importHelper(await (parcelRequire("gwAVU")));
        case 'ro':
            return $207575139b947a55$var$importHelper(await (parcelRequire("iTmWZ")));
        case 'ru':
            return $207575139b947a55$var$importHelper(await (parcelRequire("fg2Cq")));
        case 'sl':
            return $207575139b947a55$var$importHelper(await (parcelRequire("3sB2n")));
        case 'sr-RS':
            return $207575139b947a55$var$importHelper(await (parcelRequire("a8Wlb")));
        case 'sr-YR':
            return $207575139b947a55$var$importHelper(await (parcelRequire("hc9RE")));
        case 'sr':
            return $207575139b947a55$var$importHelper(await (parcelRequire("kGBbT")));
        case 'sv':
            return $207575139b947a55$var$importHelper(await (parcelRequire("2CDZ1")));
        case 'th':
            return $207575139b947a55$var$importHelper(await (parcelRequire("7sB4Q")));
        case 'tr':
            return $207575139b947a55$var$importHelper(await (parcelRequire("5t147")));
        case 'uk':
            return $207575139b947a55$var$importHelper(await (parcelRequire("krmx4")));
        case 'vi':
            return $207575139b947a55$var$importHelper(await (parcelRequire("lPcPF")));
        case 'zh-CN':
            return $207575139b947a55$var$importHelper(await (parcelRequire("l14WC")));
        case 'zh-TW':
            return $207575139b947a55$var$importHelper(await (parcelRequire("hD4Qb")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($62SxZ));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $lpVVF = parcelRequire("lpVVF");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2293023ccb53b013$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $2293023ccb53b013$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("acziF")));
        case 'da':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("jP4Dk")));
        case 'de':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("g9Mmd")));
        case 'en-GB':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("c8CIX")));
        case 'en-US':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("cLyLc")));
        case 'en-XA':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("6huTR")));
        case 'en-XB':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("02XSw")));
        case 'en-ZZ':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("5CNqE")));
        case 'en':
            return $2293023ccb53b013$var$importHelper(await Promise.resolve((parcelRequire("lpVVF"))));
        case 'es':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("iPbDx")));
        case 'et':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("j3Rl4")));
        case 'fi':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("1uoXH")));
        case 'fr':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("lNTqV")));
        case 'hr':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("6Wm8l")));
        case 'hu':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("iRCg9")));
        case 'it':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("3kGub")));
        case 'ja':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("1QZp2")));
        case 'ko':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("01qRf")));
        case 'nb':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("uwqzU")));
        case 'nl':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("mKEZ8")));
        case 'pl':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("l0rWL")));
        case 'pt-BR':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("4ALsf")));
        case 'ro':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("aBQpk")));
        case 'ru':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("9aVqg")));
        case 'sl':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("6nZlF")));
        case 'sr-RS':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("danHd")));
        case 'sr-YR':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("6G461")));
        case 'sr':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("2OLQd")));
        case 'sv':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("be6SR")));
        case 'th':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("lVSd3")));
        case 'tr':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("cpdri")));
        case 'uk':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("3Bixi")));
        case 'vi':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("3Yuu3")));
        case 'zh-CN':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("k3dTn")));
        case 'zh-TW':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("56e4D")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($lpVVF));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $03a7D = parcelRequire("03a7D");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $87af2e221c22354b$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $87af2e221c22354b$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("iUFhM")));
        case 'da':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("6kbnv")));
        case 'de':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("isMeM")));
        case 'en-GB':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("6ePtG")));
        case 'en-US':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("8h36A")));
        case 'en-XA':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("iGK1b")));
        case 'en-XB':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("cdt3d")));
        case 'en-ZZ':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("6wWfH")));
        case 'en':
            return $87af2e221c22354b$var$importHelper(await Promise.resolve((parcelRequire("03a7D"))));
        case 'es':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("2Neoq")));
        case 'et':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("enz3X")));
        case 'fi':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("9fEIL")));
        case 'fr':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("2RZTm")));
        case 'hr':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("bm8hE")));
        case 'hu':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("ccxy3")));
        case 'it':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("fF1ow")));
        case 'ja':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("7sapK")));
        case 'ko':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("6tBdX")));
        case 'nb':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("5DiPD")));
        case 'nl':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("4KOk9")));
        case 'pl':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("4IrS3")));
        case 'pt-BR':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("8oujl")));
        case 'ro':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("DIrQ3")));
        case 'ru':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("gZQ9s")));
        case 'sl':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("clvP4")));
        case 'sr-RS':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("KfxtW")));
        case 'sr-YR':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("2z4QG")));
        case 'sr':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("d713K")));
        case 'sv':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("h9naC")));
        case 'th':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("7prL8")));
        case 'tr':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("937zY")));
        case 'uk':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("dclGe")));
        case 'vi':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("kkNoL")));
        case 'zh-CN':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("34TFK")));
        case 'zh-TW':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("iO9wq")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($03a7D));
    }
};



var $9l5Wa = parcelRequire("9l5Wa");


var $afYui = parcelRequire("afYui");


var $jUaOQ = parcelRequire("jUaOQ");

/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $6QKF0 = parcelRequire("6QKF0");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4cc9a871892cf5dd$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $4cc9a871892cf5dd$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("58F0p")));
        case 'da':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("kIii3")));
        case 'de':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("eppSn")));
        case 'en-GB':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("2UIqY")));
        case 'en-US':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("fZuj0")));
        case 'en-XA':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("5TuVS")));
        case 'en-XB':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("fULde")));
        case 'en-ZZ':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("dVNJ2")));
        case 'en':
            return $4cc9a871892cf5dd$var$importHelper(await Promise.resolve((parcelRequire("6QKF0"))));
        case 'es':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("kdH7o")));
        case 'et':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("girve")));
        case 'fi':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("91l9v")));
        case 'fr':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("jrZjR")));
        case 'hr':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("kEqGy")));
        case 'hu':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("9g7V6")));
        case 'it':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("awfIw")));
        case 'ja':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("50HSs")));
        case 'ko':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("k7EOY")));
        case 'nb':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("avOKD")));
        case 'nl':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("8aJGT")));
        case 'pl':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("b2n8Q")));
        case 'pt-BR':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("1FdUP")));
        case 'ro':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("1PBOf")));
        case 'ru':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("ayxE3")));
        case 'sl':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("3yI8C")));
        case 'sr-RS':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("hmA7l")));
        case 'sr-YR':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("8suUU")));
        case 'sr':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("1f1ta")));
        case 'sv':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("gwAcJ")));
        case 'th':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("6odmS")));
        case 'tr':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("dNgup")));
        case 'uk':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("8rgs7")));
        case 'vi':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("aowj5")));
        case 'zh-CN':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("8Mkmm")));
        case 'zh-TW':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("i9CdS")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($6QKF0));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $5WcjV = parcelRequire("5WcjV");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d8b349b01a649e7f$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $d8b349b01a649e7f$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("bGmWa")));
        case 'da':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("3Cd3y")));
        case 'de':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("goDhu")));
        case 'en-GB':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("hewKr")));
        case 'en-US':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("dZJcY")));
        case 'en-XA':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("f3DVu")));
        case 'en-XB':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("gCXvv")));
        case 'en-ZZ':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("boVWr")));
        case 'en':
            return $d8b349b01a649e7f$var$importHelper(await Promise.resolve((parcelRequire("5WcjV"))));
        case 'es':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("6x9hI")));
        case 'et':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("h3xxR")));
        case 'fi':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("fsMMj")));
        case 'fr':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("db4Xx")));
        case 'hr':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("a8FB5")));
        case 'hu':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("2q9wP")));
        case 'it':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("fOqRP")));
        case 'ja':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("5iWHo")));
        case 'ko':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("l4pkE")));
        case 'nb':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("dpxdg")));
        case 'nl':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("d0DKq")));
        case 'pl':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("irNuw")));
        case 'pt-BR':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("8A21B")));
        case 'ro':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("dAg7u")));
        case 'ru':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("bkcEB")));
        case 'sl':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("2BQks")));
        case 'sr-RS':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("e3rpj")));
        case 'sr-YR':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("gJfty")));
        case 'sr':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("cOMKb")));
        case 'sv':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("gSl3D")));
        case 'th':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("aZ3u6")));
        case 'tr':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("1ZacD")));
        case 'uk':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("5poTN")));
        case 'vi':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("4ddjz")));
        case 'zh-CN':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("5XYFn")));
        case 'zh-TW':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("gWZMd")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($5WcjV));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8IaD6 = parcelRequire("8IaD6");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ad24903dddc35718$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $ad24903dddc35718$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("fjK1g")));
        case 'da':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("7Cxrz")));
        case 'de':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("gm21G")));
        case 'en-GB':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("f0OVj")));
        case 'en-US':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("baPkP")));
        case 'en-XA':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("acwEe")));
        case 'en-XB':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("1F7Fi")));
        case 'en-ZZ':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("bYaRo")));
        case 'en':
            return $ad24903dddc35718$var$importHelper(await Promise.resolve((parcelRequire("8IaD6"))));
        case 'es':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("7o16o")));
        case 'et':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("dlX8d")));
        case 'fi':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("eEXjN")));
        case 'fr':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("7Tvwf")));
        case 'hr':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("8G60n")));
        case 'hu':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("iEFhI")));
        case 'it':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("5J4lr")));
        case 'ja':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("7TAVK")));
        case 'ko':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("8K6Nr")));
        case 'nb':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("7Afq7")));
        case 'nl':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("5gNbS")));
        case 'pl':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("88tHU")));
        case 'pt-BR':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("4LNoh")));
        case 'ro':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("3UJPP")));
        case 'ru':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("8BoSL")));
        case 'sl':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("5bseM")));
        case 'sr-RS':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("8Taz6")));
        case 'sr-YR':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("dSUn6")));
        case 'sr':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("fV2yV")));
        case 'sv':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("7dIJm")));
        case 'th':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("23tal")));
        case 'tr':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("dMbaR")));
        case 'uk':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("hfWR0")));
        case 'vi':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("91jOk")));
        case 'zh-CN':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("f6wto")));
        case 'zh-TW':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("4PWHz")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8IaD6));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $kPr2b = parcelRequire("kPr2b");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8d10a33c36e367dc$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $8d10a33c36e367dc$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("4ZWNt")));
        case 'da':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("jmb7g")));
        case 'de':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("lV852")));
        case 'en-GB':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("2N2rV")));
        case 'en-US':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("5q0jV")));
        case 'en-XA':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("kwUKZ")));
        case 'en-XB':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("hhfhU")));
        case 'en-ZZ':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("iboJb")));
        case 'en':
            return $8d10a33c36e367dc$var$importHelper(await Promise.resolve((parcelRequire("kPr2b"))));
        case 'es':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("9Vsjx")));
        case 'et':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("27sh5")));
        case 'fi':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("6oIvE")));
        case 'fr':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("1wxZ1")));
        case 'hr':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("g7Mce")));
        case 'hu':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("d6Xn9")));
        case 'it':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("f1A8G")));
        case 'ja':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("20HRd")));
        case 'ko':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("gi6su")));
        case 'nb':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("fkjiw")));
        case 'nl':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("f86Qv")));
        case 'pl':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("gd6Pb")));
        case 'pt-BR':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("fPpTt")));
        case 'ro':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("jdobf")));
        case 'ru':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("iCCpE")));
        case 'sl':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("hHzOZ")));
        case 'sr-RS':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("g9fh6")));
        case 'sr-YR':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("5wENs")));
        case 'sr':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("4jY0a")));
        case 'sv':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("4ErJP")));
        case 'th':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("dA83e")));
        case 'tr':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("hXgoQ")));
        case 'uk':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("bRXbf")));
        case 'vi':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("dJRZ3")));
        case 'zh-CN':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("1fZEx")));
        case 'zh-TW':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("ahjHi")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($kPr2b));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $ce9f2 = parcelRequire("ce9f2");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c62971c5e7ad3fa5$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $c62971c5e7ad3fa5$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("h4XLq")));
        case 'da':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("aSIuu")));
        case 'de':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("23l4O")));
        case 'en-GB':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("cChEl")));
        case 'en-US':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("f3rj4")));
        case 'en-XA':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("gcN2A")));
        case 'en-XB':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("bzeFj")));
        case 'en-ZZ':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("iaQTW")));
        case 'en':
            return $c62971c5e7ad3fa5$var$importHelper(await Promise.resolve((parcelRequire("ce9f2"))));
        case 'es':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("3VbYR")));
        case 'et':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("66euP")));
        case 'fi':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("dWdh5")));
        case 'fr':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("6L5mq")));
        case 'hr':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("8d9mp")));
        case 'hu':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("6oh7C")));
        case 'it':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("5Ih8N")));
        case 'ja':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("aiIM4")));
        case 'ko':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("ezVJc")));
        case 'nb':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("d5Py7")));
        case 'nl':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("l460a")));
        case 'pl':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("ktgFI")));
        case 'pt-BR':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("5RWbp")));
        case 'ro':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("akrpS")));
        case 'ru':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("9su3t")));
        case 'sl':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("krb0o")));
        case 'sr-RS':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("ax70l")));
        case 'sr-YR':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("Mb2FM")));
        case 'sr':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("5hvFc")));
        case 'sv':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("i9uou")));
        case 'th':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("bqXXX")));
        case 'tr':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("bwbqM")));
        case 'uk':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("d4pv2")));
        case 'vi':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("4im8D")));
        case 'zh-CN':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("8RCWw")));
        case 'zh-TW':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("c6FoP")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($ce9f2));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $2N9a7 = parcelRequire("2N9a7");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $aeaec42c95afaea0$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $aeaec42c95afaea0$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("c2txx")));
        case 'da':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("5bfTF")));
        case 'de':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("yv2PF")));
        case 'en-GB':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("5ytEt")));
        case 'en-US':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("84xPc")));
        case 'en-XA':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("g50do")));
        case 'en-XB':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("ldTqI")));
        case 'en-ZZ':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("1P4Bo")));
        case 'en':
            return $aeaec42c95afaea0$var$importHelper(await Promise.resolve((parcelRequire("2N9a7"))));
        case 'es':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("kLuUQ")));
        case 'et':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("17Z99")));
        case 'fi':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("7WGGY")));
        case 'fr':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("jeifm")));
        case 'hr':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("dM9Ko")));
        case 'hu':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("9dS55")));
        case 'it':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("aruux")));
        case 'ja':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("6z61k")));
        case 'ko':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("5kRoJ")));
        case 'nb':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("feR2c")));
        case 'nl':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("4etg2")));
        case 'pl':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("8nZQJ")));
        case 'pt-BR':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("8lFmQ")));
        case 'ro':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("g8jnN")));
        case 'ru':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("jBETK")));
        case 'sl':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("3rMHk")));
        case 'sr-RS':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("dIytw")));
        case 'sr-YR':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("ISfPl")));
        case 'sr':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("9vqSC")));
        case 'sv':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("dcv25")));
        case 'th':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("6DwO1")));
        case 'tr':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("4iphv")));
        case 'uk':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("fxZOi")));
        case 'vi':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("9GOzA")));
        case 'zh-CN':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("dfTVS")));
        case 'zh-TW':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("Nzu2E")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($2N9a7));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $jZkCD = parcelRequire("jZkCD");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $05a146ac2e533fa7$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $05a146ac2e533fa7$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("6ZT3C")));
        case 'da':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("5cTfJ")));
        case 'de':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("camC3")));
        case 'en-GB':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("a1edG")));
        case 'en-US':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("hozy7")));
        case 'en-XA':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("3sU7B")));
        case 'en-XB':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("ad5pE")));
        case 'en-ZZ':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("lTULb")));
        case 'en':
            return $05a146ac2e533fa7$var$importHelper(await Promise.resolve((parcelRequire("jZkCD"))));
        case 'es':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("dAEiR")));
        case 'et':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("9nH1R")));
        case 'fi':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("kjKfL")));
        case 'fr':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("g2PTm")));
        case 'hr':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("6q5Fg")));
        case 'hu':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("lghd1")));
        case 'it':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("64AMJ")));
        case 'ja':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("a7XXP")));
        case 'ko':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("b5VVj")));
        case 'nb':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("jlOJT")));
        case 'nl':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("hIhOs")));
        case 'pl':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("28Vku")));
        case 'pt-BR':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("2sxxn")));
        case 'ro':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("aRIgT")));
        case 'ru':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("9ciVU")));
        case 'sl':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("5DLSN")));
        case 'sr-RS':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("jMFNQ")));
        case 'sr-YR':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("72eR9")));
        case 'sr':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("8Vo2l")));
        case 'sv':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("8sK49")));
        case 'th':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("jvQHv")));
        case 'tr':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("i2Vpd")));
        case 'uk':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("8qoY9")));
        case 'vi':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("1hFwa")));
        case 'zh-CN':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("4nr8Z")));
        case 'zh-TW':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("kBX89")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($jZkCD));
    }
};


const $ebebe8b4c85be972$export$d5a462ce7bd04520 = async (locale)=>{
    return Promise.allSettled([
        (0, $e6415930b3d4f363$export$720676d8cac8fbb)(locale),
        (0, $8ba4c3dbe149cf45$export$720676d8cac8fbb)(locale),
        (0, $d79f2b154c851db0$export$720676d8cac8fbb)(locale),
        (0, $1Neys.messagesLoader)(locale),
        (0, $95873db9729f07c3$export$720676d8cac8fbb)(locale),
        (0, $1d8c72db0ac48249$export$720676d8cac8fbb)(locale),
        (0, $817dacc1d76f8cd5$export$720676d8cac8fbb)(locale),
        (0, $b29cafa707c395e0$export$720676d8cac8fbb)(locale),
        (0, $ba63a4b1a3bf734f$export$720676d8cac8fbb)(locale),
        (0, $1c3c2e9ecd539937$export$720676d8cac8fbb)(locale),
        (0, $6XRKH.messagesLoader)(locale),
        (0, $4Vy0p.messagesLoader)(locale),
        (0, $03374d02ecd95d7d$export$720676d8cac8fbb)(locale),
        (0, $cPGgH.messagesLoader)(locale),
        (0, $eaqtE.messagesLoader)(locale),
        (0, $3859a8d2f07ca507$export$720676d8cac8fbb)(locale),
        (0, $5a423455785561de$export$720676d8cac8fbb)(locale),
        (0, $jWOGk.messagesLoader)(locale),
        (0, $b306bc40bc4d5af7$export$720676d8cac8fbb)(locale),
        (0, $bq5SV.messagesLoader)(locale),
        (0, $7QguR.messagesLoader)(locale),
        (0, $c2e2bac96bf01516$export$720676d8cac8fbb)(locale),
        (0, $134e70f7aecb7824$export$720676d8cac8fbb)(locale),
        (0, $ded7a36a0b579197$export$720676d8cac8fbb)(locale),
        (0, $baf792afd2d6d0ed$export$720676d8cac8fbb)(locale),
        (0, $85b4d2dabc381287$export$720676d8cac8fbb)(locale),
        (0, $0b5cba97a6571227$export$720676d8cac8fbb)(locale),
        (0, $7b3732ffccb37f07$export$720676d8cac8fbb)(locale),
        (0, $gIcFu.messagesLoader)(locale),
        (0, $3976b1c3d1c141aa$export$720676d8cac8fbb)(locale),
        (0, $7c5c9ef5c83558a9$export$720676d8cac8fbb)(locale),
        (0, $70f71d801b11c9d6$export$720676d8cac8fbb)(locale),
        (0, $a28bd0d7be6a48f1$export$720676d8cac8fbb)(locale),
        (0, $3105d7182dae50be$export$720676d8cac8fbb)(locale),
        (0, $355fa0babacd352f$export$720676d8cac8fbb)(locale),
        (0, $388818403434a675$export$720676d8cac8fbb)(locale),
        (0, $dd065fd1382b4a2f$export$720676d8cac8fbb)(locale),
        (0, $cecaf353d0a30194$export$720676d8cac8fbb)(locale),
        (0, $17036b5e3995711b$export$720676d8cac8fbb)(locale),
        (0, $08ae4730ccae252e$export$720676d8cac8fbb)(locale),
        (0, $a9d3619dfc2a8f0b$export$720676d8cac8fbb)(locale),
        (0, $2c58b23859af77ab$export$720676d8cac8fbb)(locale),
        (0, $8c19776cd00b41d0$export$720676d8cac8fbb)(locale),
        (0, $207575139b947a55$export$720676d8cac8fbb)(locale),
        (0, $2293023ccb53b013$export$720676d8cac8fbb)(locale),
        (0, $87af2e221c22354b$export$720676d8cac8fbb)(locale),
        (0, $9l5Wa.messagesLoader)(locale),
        (0, $afYui.messagesLoader)(locale),
        (0, $jUaOQ.messagesLoader)(locale),
        (0, $4cc9a871892cf5dd$export$720676d8cac8fbb)(locale),
        (0, $d8b349b01a649e7f$export$720676d8cac8fbb)(locale),
        (0, $ad24903dddc35718$export$720676d8cac8fbb)(locale),
        (0, $8d10a33c36e367dc$export$720676d8cac8fbb)(locale),
        (0, $c62971c5e7ad3fa5$export$720676d8cac8fbb)(locale),
        (0, $aeaec42c95afaea0$export$720676d8cac8fbb)(locale),
        (0, $05a146ac2e533fa7$export$720676d8cac8fbb)(locale)
    ]).then((results)=>{
        return results.reduce((acc, result)=>{
            if (result.status === 'fulfilled') return {
                messages: {
                    ...acc.messages,
                    ...result.value
                },
                errors: [
                    ...acc.errors
                ]
            };
            else if (result.status === 'rejected') return {
                messages: {
                    ...acc.messages
                },
                errors: [
                    ...acc.errors,
                    `Failed to load translations with ${result.reason}`
                ]
            };
            return acc;
        }, {
            messages: {},
            errors: []
        });
    });
};
const $ebebe8b4c85be972$export$b0eee5de066b2bf5 = (Component)=>{
    return (0, $4fmou.withIntlProvider)({
        messagesLoader: $ebebe8b4c85be972$export$d5a462ce7bd04520
    }, Component);
};


const $f250ed0d244ef04b$export$54a06e3f4a159ad8 = [
    {
        name: 'all',
        when: {
            route: {
                pathname: {
                    matches: '.*'
                }
            }
        }
    },
    {
        name: 'admin/all',
        when: {
            context: {
                product: 'admin'
            }
        }
    },
    {
        name: 'admin/dashboard',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    // Anchored: the dashboard is the AdminHub root and only the root.
                    matches: '^/$'
                }
            }
        }
    },
    {
        name: 'admin/overview',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'overview'
                }
            }
        }
    },
    {
        name: 'admin/products',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'atlassian-apps'
                }
            }
        }
    },
    {
        name: 'admin/discovered-products',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'shadow-it-apps'
                }
            }
        }
    },
    {
        name: 'admin/domains',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'domains'
                }
            }
        }
    },
    {
        name: 'admin/user-requests',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'user-requests'
                }
            }
        }
    },
    {
        name: 'admin/user-requests-with-tab-interests',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'user-requests'
                },
                search: {
                    matches: '(?:\\?|^|&)tab=interests(?:&|$)'
                }
            }
        }
    },
    {
        name: 'admin/user-access-settings',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'app-access-settings'
                }
            }
        }
    },
    {
        name: 'admin/authentication-policies',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'authentication-policies'
                }
            }
        }
    },
    {
        name: 'admin/users',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'users'
                }
            }
        }
    },
    {
        name: 'admin/audit-log',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'audit-log'
                }
            }
        }
    },
    {
        name: 'admin/billing-preview',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'billing-preview'
                }
            }
        }
    },
    {
        name: 'admin/billing/addapplication',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'billing/addapplication'
                }
            }
        }
    },
    {
        name: 'admin/billing/addapplication-with-product',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'billing/addapplication'
                },
                search: {
                    matches: '(?:\\?|^|&)product='
                }
            }
        }
    },
    {
        name: 'admin/data-residency',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'data-residency'
                }
            }
        }
    },
    {
        name: 'admin/encryption',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'encryption'
                }
            }
        }
    },
    {
        name: 'admin/data-security-policies',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'data-security-policies'
                }
            }
        }
    },
    {
        name: 'admin/backups',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'backups'
                }
            }
        }
    },
    {
        name: 'admin/system-health',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'status-hub'
                }
            }
        }
    },
    {
        name: 'admin/performance-monitoring',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    // Anchored: performance-monitoring/* also serves user-setup/:dimension.
                    matches: 'performance-monitoring/?$'
                }
            }
        }
    },
    {
        name: 'admin/rovo',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'rovo'
                }
            }
        }
    },
    {
        name: 'admin/units',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'units'
                }
            }
        }
    },
    {
        name: 'admin/unit-profile',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'units/[^/]+/?$'
                }
            }
        }
    },
    {
        name: 'admin/unit-profile-tab-users',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'units/[^/]+/?$'
                },
                search: {
                    matches: '(?:\\?|^|&)tab=users(?:&|$)'
                }
            }
        }
    },
    {
        name: 'admin/unit-profile-tab-groups',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'units/[^/]+/?$'
                },
                search: {
                    matches: '(?:\\?|^|&)tab=groups(?:&|$)'
                }
            }
        }
    },
    {
        name: 'admin/unit-profile-tab-settings',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'units/[^/]+/?$'
                },
                search: {
                    matches: '(?:\\?|^|&)tab=settings(?:&|$)'
                }
            }
        }
    },
    {
        name: 'admin/user-access-settings',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'user-access-settings'
                }
            }
        }
    },
    {
        name: 'admin/user-connected-apps',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'user-connected-apps'
                }
            }
        }
    },
    {
        name: 'admin/changelog',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'changelog'
                }
            }
        }
    },
    {
        name: 'admin/product-insights',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'product-insights'
                }
            }
        }
    },
    {
        name: 'jira/all',
        when: {
            context: {
                product: 'jira'
            }
        }
    },
    {
        name: 'jira/kanban',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'board'
                }
            }
        }
    },
    {
        name: 'confluence/all',
        when: {
            context: {
                product: 'confluence'
            }
        }
    },
    {
        name: 'confluence/wiki-home',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/home'
                }
            }
        }
    },
    {
        name: 'confluence/wiki-welcome',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/welcome'
                }
            }
        }
    },
    {
        name: 'confluence/space-overview',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/[^/]+/overview.*'
                }
            }
        }
    },
    {
        name: 'confluence/pages-without-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: '^(?!.*edit).*wiki/spaces/.*/pages.*'
                }
            }
        }
    },
    {
        name: 'confluence/pages-with-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*/pages/.*edit.*'
                }
            }
        }
    },
    {
        name: 'confluence/blogs-without-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: '^(?!.*edit).*wiki/spaces/.*/blog.*'
                }
            }
        }
    },
    {
        name: 'confluence/blogs-with-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*/blog/.*edit.*'
                }
            }
        }
    },
    {
        name: 'confluence/pages',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/pages/.*'
                }
            }
        }
    },
    {
        name: 'confluence/all-content',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/*/.*'
                }
            }
        }
    },
    {
        name: 'confluence/wiki-space-settings',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.+?/settings(/.*)?$'
                }
            }
        }
    },
    {
        name: 'confluence/blogs',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/blog/.*'
                }
            }
        }
    },
    {
        name: 'confluence/all-without-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/(?!.*/edit-v2/).*'
                }
            }
        }
    },
    {
        name: 'confluence/edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/.*edit.*'
                }
            }
        }
    },
    {
        name: 'confluence/whiteboard',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/.*whiteboard.*'
                }
            }
        }
    },
    {
        name: 'confluence/database',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/database/.*'
                }
            }
        }
    },
    {
        name: 'confluence/slides',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/slide/.*'
                }
            }
        }
    },
    {
        name: 'pop3/all',
        when: {
            context: {
                product: 'pop3'
            }
        }
    },
    {
        name: 'pop3/send-it',
        when: {
            context: {
                product: 'pop3'
            },
            route: {
                pathname: {
                    matches: 'send-it'
                }
            }
        }
    },
    {
        name: 'trello/all',
        when: {
            context: {
                product: 'trello'
            }
        }
    },
    {
        name: 'jira/queue',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'queue'
                }
            }
        }
    },
    {
        name: 'jira/browse',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'browse'
                }
            }
        }
    },
    {
        name: 'jira/browse/software',
        when: {
            context: {
                product: 'jira',
                subproduct: 'software'
            },
            route: {
                pathname: {
                    matches: 'browse'
                }
            }
        }
    },
    {
        name: 'jira/browse/issue',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'browse/.*?'
                }
            }
        }
    },
    {
        name: 'jira/issues',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'list'
                }
            }
        }
    },
    {
        name: 'jira/itsm/changes-list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*?/section/changes/custom/.*?'
                }
            }
        }
    },
    {
        name: 'jira/itsm/changes-list/detail',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*?/section/changes/custom/.*?/.*?'
                }
            }
        }
    },
    {
        name: 'jira/itsm/risk-insights',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*?/settings/change-management?tab=risk-insights'
                }
            }
        }
    },
    {
        name: 'jira/itsm/incidents-list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*?/section/incidents/custom/.*?'
                }
            }
        }
    },
    {
        name: 'jira/get-started',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/get-started'
                }
            }
        }
    },
    {
        name: 'jira/project-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/issues(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'projects/selectedissue',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'projects'
                },
                search: {
                    matches: '.*selectedIssue.*'
                }
            }
        }
    },
    {
        name: 'jira/global-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '/issues'
                },
                search: {
                    matches: '.*filter.*'
                }
            }
        }
    },
    {
        name: 'jira/issues-full-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'issues'
                },
                search: {
                    matches: '.*selectedIssue.*'
                }
            }
        }
    },
    {
        name: 'jira/software',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software'
                }
            }
        }
    },
    {
        name: 'jira/rapidboard-board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '^/secure/RapidBoard\\.jspa$'
                },
                search: {
                    matches: '^(?=.*(?:\\?|^|&)rapidView=)(?!.*(?:\\?|^|&)view=(?:planning(?:\\.nodetail)?|reporting)(?:&|$)).*$'
                }
            }
        }
    },
    {
        name: 'jira/rapidboard-board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '^/jira/software/c/projects/[^/]+/boards/[^/]+/?$'
                }
            }
        }
    },
    {
        name: 'jira/software-backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '^/jira/software/projects/[^/]+/boards/[^/]+/backlog/?$'
                }
            }
        }
    },
    {
        name: 'jira/software-boards',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '^/jira/software/projects/[^/]+/boards/[^/]+/?$'
                }
            }
        }
    },
    {
        name: 'jira/polaris',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/polaris'
                }
            }
        }
    },
    {
        name: 'jira/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'backlog'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk'
                }
            }
        }
    },
    {
        name: 'jira/helpcenter',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/helpcenter'
                }
            }
        }
    },
    {
        name: 'jira/ops',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops'
                }
            }
        }
    },
    {
        // JSM Operations Reports (new experience).
        // Route: /jira/ops/reports-new/:spaceId?/:tabId?
        // Matches the bare route and any spaceId/tabId sub-paths.
        name: 'jira/ops/reports-new',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/reports-new'
                }
            }
        }
    },
    {
        // Jira Plans timeline/list view
        name: 'jira/plan/timeline',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/.*/scenarios/.*/timeline'
                }
            }
        }
    },
    {
        // Jira Plans calendar view
        name: 'jira/plan/calendar',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/.*/scenarios/.*/calendar'
                }
            }
        }
    },
    {
        // Jira Plans program board
        name: 'jira/plan/program',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/.*/scenarios/.*/program'
                }
            }
        }
    },
    {
        // Any pages within Jira Plan
        name: 'jira/plan',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/.*/scenarios/.*'
                }
            }
        }
    },
    {
        name: 'jira/project',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '.*(?=.*project)(?=.*setting).*'
                }
            }
        }
    },
    {
        name: 'jira/your-work',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '^/issues/?$'
                }
            }
        }
    },
    {
        name: 'jira/ops/alerts',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/alerts'
                }
            }
        }
    },
    {
        name: 'jira/ops/alert-details',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/alerts/.*?'
                }
            }
        }
    },
    {
        name: 'jira/ops/team/integration',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/teams/.*?/integrations/.*?'
                }
            }
        }
    },
    {
        name: 'jira/ops/team-policies',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/teams/.*?/policies'
                }
            }
        }
    },
    {
        name: 'jira/ops/group-detail',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/group-detail'
                }
            }
        }
    },
    {
        name: 'jira/ops/heartbeats',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/teams/.*?/heartbeats'
                }
            }
        }
    },
    {
        name: 'jira/ops/who-is-on-call',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/who-is-on-call'
                }
            }
        }
    },
    {
        name: 'jira/ops/team/on-call',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/teams/.*?/on-call'
                }
            }
        }
    },
    {
        name: 'jira/ops/alert-notifications',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/settings/personal/alert-notifications'
                }
            }
        }
    },
    {
        name: 'jira/settings/products/ops/incoming-call',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/settings/products/ops/incoming-call(/.*)?'
                }
            }
        }
    },
    {
        name: 'jira/settings/automation',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'settings/automation'
                }
            }
        }
    },
    {
        name: 'jira/for-you',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/for-you'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/settings',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*/settings(/.*)?'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/settings/request-types',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*/settings/request-types(/.*)?'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/settings/request-types/cases',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*/settings/request-types/category/cases'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/projects/incidents',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*/section/incidents/custom/.*?/.*?'
                }
            }
        }
    },
    {
        name: 'jira/business/forms/form-directory',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/form'
                }
            }
        }
    },
    {
        name: 'jira/business/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/board'
                }
            }
        }
    },
    {
        name: 'jira/business/board/not/embedded',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/board(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/business/timeline',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*/timeline(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/business/calendar',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*/calendar(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/calendar',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*/boards/.*/calendar(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/calendar',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*/boards/.*/calendar(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/software/timeline',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*/boards/.*/timeline(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/timeline',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*/boards/.*/timeline(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/software/forms/form-directory',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/form'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*?/boards/[^/]*?$'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/boards/[^/]*?$'
                }
            }
        }
    },
    {
        name: 'jira/software/board/not/embedded',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/boards/(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*?/boards/.*?/backlog'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/boards/.*?/backlog'
                }
            }
        }
    },
    {
        name: 'jira/software/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/boards/.*?/backlog(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/list-detail-view',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '.*list.*'
                },
                search: {
                    matches: '.*selectedIssue.*'
                }
            }
        }
    },
    {
        name: 'jira/software/list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/list'
                }
            }
        }
    },
    {
        name: 'jira/business/list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/list'
                }
            }
        }
    },
    {
        name: 'jira/software/list-project-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/list(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/business/list-project-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/list(?!.*\\/embed)'
                }
            }
        }
    },
    {
        // Handles both CMP Software and Business
        name: 'jira/cmp/project-settings/people',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'plugins/servlet/project-config/.*?/people'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/project-settings/access',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/settings/access'
                }
            }
        }
    },
    {
        name: 'jira/business/tmp/project-settings/access',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/access'
                }
            }
        }
    },
    {
        // Any project route in JSW
        name: 'jira/software/project',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?'
                }
            }
        }
    },
    {
        // Any project settings route in JSW
        name: 'jira/software/project-settings',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/settings/.*?'
                }
            }
        }
    },
    {
        // Any project route in JWM
        name: 'jira/business/project',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?'
                }
            }
        }
    },
    {
        // Any project settings route in JWM
        name: 'jira/business/project-settings',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/.*?'
                }
            }
        }
    },
    {
        // Project directory
        name: 'jira/projects',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/projects'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/.+?/list'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/project-summary',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/[^/]+/summary'
                }
            }
        }
    },
    {
        name: 'jira/software/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/[^/]+)?/projects/[^/]+/boards'
                }
            }
        }
    },
    {
        name: 'loom/all',
        when: {
            context: {
                product: 'loom'
            }
        }
    },
    {
        name: 'loom/home',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'home'
                }
            }
        }
    },
    {
        name: 'loom/looms/videos',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'looms/videos'
                }
            }
        }
    },
    {
        name: 'loom/meetings',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'meetings'
                }
            }
        }
    },
    {
        name: 'loom/notifications/all',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'notifications/all'
                }
            }
        }
    },
    {
        name: 'loom/watch-later',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'watch-later'
                }
            }
        }
    },
    {
        name: 'loom/history',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'history'
                }
            }
        }
    },
    {
        name: 'loom/settings/account',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'settings/account'
                }
            }
        }
    },
    {
        name: 'loom/settings/workspace',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'settings/workspace'
                }
            }
        }
    },
    {
        name: 'jira/business/tmp/project-settings/fields',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/fields'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/project-settings/fields',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/settings/fields'
                }
            }
        }
    },
    {
        name: 'jira/software/forms/form-builder',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/form/.*?/builder'
                }
            }
        }
    },
    {
        name: 'jira/business/forms/form-builder',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/form/.*?/builder'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/project-settings/issue-types',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/settings/issuetypes/.*?'
                }
            }
        }
    },
    {
        name: 'jira/business/tmp/project-settings/issue-types',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/issuetypes/.*?'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/project-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*?/issues(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/cmp/project-settings/project-config/issuelayout',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'plugins/servlet/project-config/.*?/issuelayout'
                }
            }
        }
    },
    {
        name: 'studio/rovo-agents',
        when: {
            context: {
                product: 'atlassianStudio'
            },
            route: {
                pathname: {
                    matches: '/agents(?:/|$)'
                }
            }
        }
    },
    {
        name: 'studio/all',
        when: {
            context: {
                product: 'atlassianStudio'
            }
        }
    },
    {
        name: 'cpq',
        when: {
            context: {
                product: 'cpq'
            }
        }
    },
    {
        name: 'welcome/software',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'welcome/software'
                }
            }
        }
    },
    {
        name: 'bitbucket/all',
        when: {
            context: {
                product: 'bitbucket'
            }
        }
    },
    {
        name: 'bitbucket/home',
        when: {
            context: {
                product: 'bitbucket'
            },
            route: {
                pathname: {
                    matches: 'workspace/overview'
                }
            }
        }
    },
    {
        name: 'bitbucket/admin',
        when: {
            context: {
                product: 'bitbucket'
            },
            route: {
                pathname: {
                    matches: 'admin'
                }
            }
        }
    },
    {
        name: 'bitbucket/settings',
        when: {
            context: {
                product: 'bitbucket'
            },
            route: {
                pathname: {
                    matches: 'workspace/settings'
                }
            }
        }
    },
    {
        name: 'bitbucket/pull-requests/new',
        when: {
            context: {
                product: 'bitbucket'
            },
            route: {
                pathname: {
                    matches: 'pull-requests/new'
                }
            }
        }
    },
    {
        name: 'bitbucket/pull-requests/list',
        when: {
            context: {
                product: 'bitbucket'
            },
            route: {
                pathname: {
                    matches: 'pull-requests/?$'
                }
            }
        }
    },
    {
        name: 'bitbucket/pull-request/view',
        when: {
            context: {
                product: 'bitbucket'
            },
            route: {
                pathname: {
                    matches: 'pull-requests/\\d+'
                }
            }
        }
    },
    {
        name: 'jira/rovo-search',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/rovo-search'
                }
            }
        }
    },
    {
        name: 'confluence/rovo-search',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/search'
                }
            }
        }
    },
    {
        name: 'jira/assets/dashboards',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    // Dashboard id in product is a UUID (path segment after …/dashboards/)
                    matches: 'jira/assets/dashboards/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}'
                }
            }
        }
    },
    {
        name: 'jira/assets/schemas',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/assets/schemas$'
                }
            }
        }
    },
    {
        // JSM project directory (e.g. .../jira/servicedesk/projects/ACM/summary)
        name: 'jira/servicedesk/projects',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects'
                }
            }
        }
    },
    {
        // Any JSW project route (TMP or CMP)
        name: 'jira/software/projects',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects'
                }
            }
        }
    },
    {
        // JSM project dashboards (e.g. .../jira/servicedesk/projects/ACM/dashboards)
        name: 'jira/servicedesk/dashboards',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/[^/]+/dashboards'
                }
            }
        }
    },
    {
        // JSM virtual agent settings (e.g. .../jira/servicedesk/projects/ACM/settings/virtual-agent)
        name: 'jira/servicedesk/virtual-agent',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/[^/]+/settings/virtual-agent'
                }
            }
        }
    },
    {
        // JSW project settings (e.g. .../jira/software/projects/TT/settings/details)
        name: 'jira/software/settings',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/[^/]+/settings'
                }
            }
        }
    },
    {
        // JSM queue board (e.g. .../jira/servicedesk/projects/ACM/queues/custom/11627/board/19488)
        name: 'jira/servicedesk/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/[^/]+/queues/[^/]+/[^/]+/board'
                }
            }
        }
    },
    {
        // JSW project summary (e.g. .../jira/software/projects/MT/summary)
        name: 'jira/software/summary',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/[^/]+/summary'
                }
            }
        }
    },
    {
        // Jira Plans timeline (e.g. .../jira/plans/123/scenarios/456/timeline)
        name: 'jira/plans',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/[^/]+/[^/]+/[^/]+/timeline'
                }
            }
        }
    }
];












var $di43e = parcelRequire("di43e");





var $2tp0D = parcelRequire("2tp0D");


var $gfQZH = parcelRequire("gfQZH");


var $6ETv4 = parcelRequire("6ETv4");

const $94d72c94d7d7862e$export$963cdca6c7580c53 = [
    {
        messageTemplateId: 'confluence-auto-provisioning-edition-parity-trial-dialog',
        // https://switcheroo.atlassian.com/ui/gates/d0ba1046-934a-4af7-8294-e6ca8b846ab3/key/confluence_autoprovisioning_edition_parity
        statsigExperiment: 'confluence_autoprovisioning_edition_parity',
        statsigParameterName: 'cohort',
        statsigTestCohorts: [
            'variation'
        ]
    },
    {
        messageTemplateId: 'confluence-ai-audio-player-spotlight-tour',
        // https://switcheroo.atlassian.com/ui/gates/e9b0503b-0486-48e3-a511-123e409058f4/key/confluence_audio_v3_changeboarding
        statsigExperiment: 'confluence_audio_v3_changeboarding',
        statsigParameterName: 'isEnabled',
        statsigTestCohorts: [
            'true'
        ]
    },
    {
        messageTemplateId: 'rovo-growth-nudge-end-user-highly-connected-apps',
        // https://switcheroo.atlassian.com/ui/gates/f36896ce-14dc-4a48-9888-dd0df3c671e0/key/rovo_nudge_end_user_highly_connected_apps_exp
        statsigExperiment: 'rovo_nudge_end_user_highly_connected_apps_exp',
        statsigParameterName: 'cohort',
        statsigTestCohorts: [
            'variant1',
            'variant2'
        ]
    },
    {
        messageTemplateId: 'commerce-subscription-auto-upgrade-ccp',
        // https://switcheroo.atlassian.com/ui/gates/3b39fad7-0834-4007-9b28-73367d7231fd/key/auto-upgrades_w_pde_legal_update_ab_test,
        statsigExperiment: 'auto-upgrades_w_pde_legal_update_ab_test',
        statsigParameterName: 'cohort',
        statsigTestCohorts: [
            'variation'
        ]
    },
    {
        messageTemplateId: 'cross-flow-product-request-approval',
        // https://switcheroo.atlassian.com/ui/gates/23e1a5f6-5e78-4073-9379-b3bf2583507f/key/pcgrw-522_jpd_invite_toast
        statsigExperiment: 'pcgrw-522_jpd_invite_toast',
        statsigParameterName: 'isEnabled',
        statsigTestCohorts: [
            'true'
        ]
    }
];





const $8cb0e79684b84cac$export$86fac4eb228cc5e9 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $8cb0e79684b84cac$export$60075266d0d5c9c4 = ()=>(0, $cozmU.useContext)($8cb0e79684b84cac$export$86fac4eb228cc5e9);









var $aHfj2 = parcelRequire("aHfj2");




const $6c7b574341cd8f67$export$32c78d11bbf53e24 = ({ children: children })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $aHfj2.useFirePostOfficeAnalyticsEvents)();
    const [isVisible, setIsVisible] = (0, $cozmU.useState)(true);
    const handleVisibilityChange = (0, $cozmU.useCallback)((modalOnScreen)=>{
        const shouldShow = !modalOnScreen;
        if (!shouldShow) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'suppressed',
            actionSubject: 'screenSpaceFlags'
        });
        setIsVisible(shouldShow);
    }, [
        fireAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        const modalOnScreen = !!globalThis.document.querySelector('.atlaskit-portal-container .atlaskit-portal [role=dialog]');
        handleVisibilityChange(modalOnScreen);
    }, [
        handleVisibilityChange
    ]);
    return (0, $cXtTj.default).checkGate('post-office-screen-space-flags-modal-detector') ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: isVisible && children
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/ 




























































































































































const $77db742053a85ab4$export$e30378e28ad3e6ab = {
    'admin-hub-app-access-settings-access-message-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("akYdf"))),
    'adminhub-performance-monitoring-first-run': (0, $cozmU.lazy)(()=>(parcelRequire("lvMF9"))),
    'adminhub-platform-usage-m5-spotlight-tour': (0, $cozmU.lazy)(()=>(parcelRequire("kqpHz"))),
    'adminhub-rovo-bookmarks-onboarding-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("8VcfZ"))),
    'adminhub-rovo-chat-button-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("kIyJU"))),
    'adminhub-rovo-chat-toggle-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("iM7Ej"))),
    'adminhub-system-health-dashboard-app-status-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("gUOKX"))),
    'adminhub-system-health-dashboard-app-status-spotlight-v2': (0, $cozmU.lazy)(()=>(parcelRequire("16MwB"))),
    'adminhub-system-health-dashboard-status-hub-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("7tCfz"))),
    'adminhub-theme-darkmode': (0, $cozmU.lazy)(()=>(parcelRequire("drLlu"))),
    'adminhub-unit-create-ga-spotlight-tour': (0, $cozmU.lazy)(()=>(parcelRequire("aodZl"))),
    'adminhub-unit-profile-groups-tab-spotlight-tour': (0, $cozmU.lazy)(()=>(parcelRequire("jcbnX"))),
    'adminhub-unit-profile-settings-tab-spotlight-tour': (0, $cozmU.lazy)(()=>(parcelRequire("04kNl"))),
    'adminhub-unit-profile-users-tab-ga-spotlight-tour': (0, $cozmU.lazy)(()=>(parcelRequire("4sOmk"))),
    'adminhub-units-ga-onboarding-modal': (0, $cozmU.lazy)(()=>(parcelRequire("jI7Xz"))),
    'adminhub-urm-rank-ra-using-ml-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("96uhU"))),
    'adminhub-user-requests-count-message-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("d2Z9e"))),
    'agent-profile-reasoning-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("jOQRj"))),
    'assets-deeplinking-modal': (0, $cozmU.lazy)(()=>(parcelRequire("9Jdil"))),
    'assets-osc-onboarding-object-graph-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("hNsLK"))),
    'cases': (0, $cozmU.lazy)(()=>(parcelRequire("fSfFb"))),
    'cases-request-types-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("lpr3v"))),
    'cc-changeboarding-block-menu-primary-new': (0, $cozmU.lazy)(()=>(parcelRequire("kefFC"))),
    'cc-changeboarding-block-menu-templates': (0, $cozmU.lazy)(()=>(parcelRequire("9ye8Q"))),
    'cc-changeboarding-block-menu-transform': (0, $cozmU.lazy)(()=>(parcelRequire("2X25C"))),
    'cc-changeboarding-synced-blocks': (0, $cozmU.lazy)(()=>(parcelRequire("l37gC"))),
    'cc-editor-table-cell-menu-changes': (0, $cozmU.lazy)(()=>(parcelRequire("gE6P6"))),
    'commerce-subscription-auto-upgrade-ccp': (0, $cozmU.lazy)(()=>(parcelRequire("TsHLR"))),
    'commerce-subscription-auto-upgrade-no-payment-method-ccp': (0, $cozmU.lazy)(()=>(parcelRequire("1zg1j"))),
    'confluence-3p-connector-nudge': (0, $cozmU.lazy)(()=>(parcelRequire("4oES9"))),
    'confluence-agents-spotlights': (0, $cozmU.lazy)(()=>(parcelRequire("b8UKN"))),
    'confluence-ai-audio-player-spotlight-tour': (0, $cozmU.lazy)(()=>(parcelRequire("5ty5K"))),
    'confluence-auto-provisioning-edition-parity-trial-dialog': (0, $cozmU.lazy)(()=>(parcelRequire("3yrzt"))),
    'confluence-continue-reading-nudge': (0, $cozmU.lazy)(()=>(parcelRequire("b1mpA"))),
    'confluence-create-agent-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("kG8cA"))),
    'confluence-edit-with-mcp-discovery': (0, $cozmU.lazy)(()=>(parcelRequire("1u6TY"))),
    'confluence-editor-agentic-typeahead-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("5fNzV"))),
    'confluence-editor-smart-links-draggable-changeboard': (0, $cozmU.lazy)(()=>(parcelRequire("a9DE8"))),
    'confluence-founding-admin-connect-tools-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("fbFbW"))),
    'confluence-inline-reactions-mau-nudge': (0, $cozmU.lazy)(()=>(parcelRequire("5IcfZ"))),
    'confluence-inline-reactions-mcu-nudge': (0, $cozmU.lazy)(()=>(parcelRequire("5pIHD"))),
    'confluence-inline-reactions-nudge': (0, $cozmU.lazy)(()=>(parcelRequire("68rmX"))),
    'confluence-invite-reminder-flag': (0, $cozmU.lazy)(()=>(parcelRequire("HP62w"))),
    'confluence-lovability-survey': (0, $cozmU.lazy)(()=>(parcelRequire("hG4QL"))),
    'confluence-maui-changeboarding': (0, $cozmU.lazy)(()=>(parcelRequire("Ijp39"))),
    'confluence-maui-changeboarding-remix-tour': (0, $cozmU.lazy)(()=>(parcelRequire("iQvb4"))),
    'confluence-maui-slides-create-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("hQgYM"))),
    'confluence-maui-slides-edit-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("9Ngej"))),
    'confluence-maui-slides-modal': (0, $cozmU.lazy)(()=>(parcelRequire("bOWz0"))),
    'confluence-maui-slides-toolbar-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("js75E"))),
    'confluence-nudge-for-jira': (0, $cozmU.lazy)(()=>(parcelRequire("gjWy6"))),
    'confluence-object-sidebar-remix-changeboarding': (0, $cozmU.lazy)(()=>(parcelRequire("6wCsT"))),
    'confluence-onboarding-flag-to-share': (0, $cozmU.lazy)(()=>(parcelRequire("kioN8"))),
    'confluence-onboarding-flag-to-share-database': (0, $cozmU.lazy)(()=>(parcelRequire("iUEn1"))),
    'confluence-onboarding-flag-to-share-whiteboard': (0, $cozmU.lazy)(()=>(parcelRequire("b5lrF"))),
    'confluence-ootb-daily-brief-agent-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("hbhxM"))),
    'confluence-performance-diagnstic-survey': (0, $cozmU.lazy)(()=>(parcelRequire("4o0P9"))),
    'cpq-user-feedback': (0, $cozmU.lazy)(()=>(parcelRequire("1hX93"))),
    'cross-flow-product-request': (0, $cozmU.lazy)(()=>(parcelRequire("hDwOy"))),
    'cross-flow-product-request-approval': (0, $cozmU.lazy)(()=>(parcelRequire("8xMKh"))),
    'edition-benefits-modal': (0, $cozmU.lazy)(()=>(parcelRequire("8pT27"))),
    'encryption-policy-page-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("kio1C"))),
    'end-of-trial-extension': (0, $cozmU.lazy)(()=>(parcelRequire("gfw4h"))),
    'ep-migration-external-messages': (0, $cozmU.lazy)(()=>(parcelRequire("hbRQf"))),
    'ep-migration-inapp-1736': (0, $cozmU.lazy)(()=>(parcelRequire("7pPRq"))),
    'ep-migration-inapp-1737': (0, $cozmU.lazy)(()=>(parcelRequire("hl7od"))),
    'ep-migration-inapp-2055': (0, $cozmU.lazy)(()=>(parcelRequire("a7REi"))),
    'ep-migration-inapp-2271': (0, $cozmU.lazy)(()=>(parcelRequire("doOUt"))),
    'ep-migration-inapp-3273': (0, $cozmU.lazy)(()=>(parcelRequire("lXnAF"))),
    'ep-migration-inapp-3280': (0, $cozmU.lazy)(()=>(parcelRequire("1nz0n"))),
    'ep-migration-inapp-3282': (0, $cozmU.lazy)(()=>(parcelRequire("jRQub"))),
    'ep-migration-inapp-715': (0, $cozmU.lazy)(()=>(parcelRequire("5e1aL"))),
    'ep-migration-jira-ops-team-heartbeats': (0, $cozmU.lazy)(()=>(parcelRequire("9jKBC"))),
    'example-generated-spotlight-template': (0, $cozmU.lazy)(()=>(parcelRequire("20CQe"))),
    'jira-assets-schemas-display-name': (0, $cozmU.lazy)(()=>(parcelRequire("72pu6"))),
    'jira-business-saved-views-admin-changeboarding-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("9yg4r"))),
    'jira-business-saved-views-user-changeboarding-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("8aSEo"))),
    'jira-filter-refinement': (0, $cozmU.lazy)(()=>(parcelRequire("6F7Hq"))),
    'jira-filter-refinement-board-and-backlog': (0, $cozmU.lazy)(()=>(parcelRequire("iEC4s"))),
    'jira-filter-refinement-standalone-release-changeboarding': (0, $cozmU.lazy)(()=>(parcelRequire("dGdpq"))),
    'jira-forms-public-forms-changeboarding': (0, $cozmU.lazy)(()=>(parcelRequire("95IHj"))),
    'jira-forms-public-forms-changeboarding-flag': (0, $cozmU.lazy)(()=>(parcelRequire("4BIn1"))),
    'jira-fps-to-gnin-cta-changeboarding': (0, $cozmU.lazy)(()=>(parcelRequire("hxkIJ"))),
    'jira-glance-panel-navigation-arrows': (0, $cozmU.lazy)(()=>(parcelRequire("8To3x"))),
    'jira-gnin-to-fps-cta-changeboarding': (0, $cozmU.lazy)(()=>(parcelRequire("5OQC6"))),
    'jira-hamonisation-software-timeline': (0, $cozmU.lazy)(()=>(parcelRequire("fvpvd"))),
    'jira-in-context-config-sidebar-changeboarding': (0, $cozmU.lazy)(()=>(parcelRequire("iIKcH"))),
    'jira-issue-view-loom-image-editing-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("3pcqi"))),
    'jira-issueview-description-title-final': (0, $cozmU.lazy)(()=>(parcelRequire("kEMl5"))),
    'jira-messaging-research-recruitment': (0, $cozmU.lazy)(()=>(parcelRequire("cQEz0"))),
    'jira-nl2jql-ai-filter-changeboarding': (0, $cozmU.lazy)(()=>(parcelRequire("2rla6"))),
    'jira-onboarding-hub-welcome-modal': (0, $cozmU.lazy)(()=>(parcelRequire("64lbb"))),
    'jira-ops-group-customisation': (0, $cozmU.lazy)(()=>(parcelRequire("OV8r1"))),
    'jira-ops-reports-changeboarding': (0, $cozmU.lazy)(()=>(parcelRequire("eNTpv"))),
    'jira-ops-unified-view-revamp': (0, $cozmU.lazy)(()=>(parcelRequire("6Rp58"))),
    'jira-pre-dunning-confirm-plan-modal': (0, $cozmU.lazy)(()=>(parcelRequire("4Z92t"))),
    'jira-project-term-refresh-changeboarding-flag': (0, $cozmU.lazy)(()=>(parcelRequire("8lUMZ"))),
    'jira-quick-find-intent-detection-changeboarding': (0, $cozmU.lazy)(()=>(parcelRequire("dvWh4"))),
    'jira-rovo-dev-survey': (0, $cozmU.lazy)(()=>(parcelRequire("dVkYh"))),
    'jira-rovo-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("lLPkH"))),
    'jira-screen-modal': (0, $cozmU.lazy)(()=>(parcelRequire("gox8X"))),
    'jira-side-nav-mature-example-project-space-setup': (0, $cozmU.lazy)(()=>(parcelRequire("lyjZN"))),
    'jira-software-backlog-bulk-agents-changeboarding': (0, $cozmU.lazy)(()=>(parcelRequire("hhPGR"))),
    'jira-software-list-bulk-agent-changeboarding': (0, $cozmU.lazy)(()=>(parcelRequire("7H2QT"))),
    'jira-software-timeline-hide-top-level-changeboarding': (0, $cozmU.lazy)(()=>(parcelRequire("3M2FJ"))),
    'jira-software-timeline-hierarchy-changeboarding': (0, $cozmU.lazy)(()=>(parcelRequire("aoisw"))),
    'jira-software-timeline-inline-hierarchy-changeboarding': (0, $cozmU.lazy)(()=>(parcelRequire("axN0I"))),
    'jira-space-settings-playbooks-navigation-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("2S5mH"))),
    'jira-sprints-auto-managed-feature-discovery': (0, $cozmU.lazy)(()=>(parcelRequire("3pAtC"))),
    'jira-timeline-10k-issues-message': (0, $cozmU.lazy)(()=>(parcelRequire("eaVnl"))),
    'jira-timeline-feedback-collector-changeboarding': (0, $cozmU.lazy)(()=>(parcelRequire("5AtIC"))),
    'jira-work-item-view-native-projects-field': (0, $cozmU.lazy)(()=>(parcelRequire("bsVJx"))),
    'jsm-edition-awareness-button-popup': (0, $cozmU.lazy)(()=>(parcelRequire("hl2or"))),
    'jsm-edition-awareness-premium-upsell-modal': (0, $cozmU.lazy)(()=>(parcelRequire("8BCeg"))),
    'jsm-help-center-management-update-help-center': (0, $cozmU.lazy)(()=>(parcelRequire("cMQQT"))),
    'jsm-project-summary-onboarding': (0, $cozmU.lazy)(()=>(parcelRequire("c2XVQ"))),
    'jsm-wfm-setup-completion-reminder': (0, $cozmU.lazy)(()=>(parcelRequire("6JKcV"))),
    'marketing-screen-space-flag-contentful-usecase': (0, $cozmU.lazy)(()=>(parcelRequire("9Dx2i"))),
    'message-template-template': (0, $cozmU.lazy)(()=>(parcelRequire("6fJFQ"))),
    'navx-smartlink-full-picture-auth-nudge': (0, $cozmU.lazy)(()=>(parcelRequire("EvCCI"))),
    'post-office-gold-1': (0, $cozmU.lazy)(()=>(parcelRequire("33XCl"))),
    'project-pages-revamp-onboarding-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("fcrtA"))),
    'ptr-changeboarding-space-navigation-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("lVNzU"))),
    'rovo-3p-celebrate-nudge': (0, $cozmU.lazy)(()=>(parcelRequire("3DW81"))),
    'rovo-3rd-party-integration-admin-nudge': (0, $cozmU.lazy)(()=>(parcelRequire("ez7mF"))),
    'rovo-agents-scenario-onboarding': (0, $cozmU.lazy)(()=>(parcelRequire("8uN0M"))),
    'rovo-button-onboarding-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("iAv3R"))),
    'rovo-chat-memory-settings-onboarding-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("gU4dn"))),
    'rovo-chat-welcome-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("2RRYh"))),
    'rovo-extension-gdocs-definitions-install-cta-flag': (0, $cozmU.lazy)(()=>(parcelRequire("4fgeJ"))),
    'rovo-growth-3p-smartlink-admin-paste-nudge': (0, $cozmU.lazy)(()=>(parcelRequire("jnxGd"))),
    'rovo-growth-3p-smartlink-paste-nudge': (0, $cozmU.lazy)(()=>(parcelRequire("8BjjX"))),
    'rovo-growth-nudge-end-user-highly-connected-apps': (0, $cozmU.lazy)(()=>(parcelRequire("jeNBR"))),
    'shared-user-preferences-onboarding': (0, $cozmU.lazy)(()=>(parcelRequire("3V7up"))),
    'sharepoint-smartlink-app-migration-test': (0, $cozmU.lazy)(()=>(parcelRequire("lDtJn"))),
    'solcom-create-space-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("7AhJG"))),
    'starburst-screen-space-flags-twc-welcome-modal': (0, $cozmU.lazy)(()=>(parcelRequire("1LjTk"))),
    'statuspage-navigation-spotlight': (0, $cozmU.lazy)(()=>(parcelRequire("aWcR9"))),
    'statuspage-navigation-spotlight-v2': (0, $cozmU.lazy)(()=>(parcelRequire("igktx"))),
    'team-wolverine-jira-migration-success': (0, $cozmU.lazy)(()=>(parcelRequire("2ktat"))),
    'test-message-config-sets': (0, $cozmU.lazy)(()=>(parcelRequire("dAUhM"))),
    'test-message-inapp': (0, $cozmU.lazy)(()=>(parcelRequire("2NY4P"))),
    'test-message-inapp-ep-modal': (0, $cozmU.lazy)(()=>(parcelRequire("1TZuF"))),
    'test-message-inapp-implicit-pendo': (0, $cozmU.lazy)(()=>(parcelRequire("31vhh"))),
    'test-message-load-test-pull-screen-space-flags': (0, $cozmU.lazy)(()=>(parcelRequire("3ZuMa"))),
    'test-message-tap-ingestion-trigger-subscription': (0, $cozmU.lazy)(()=>(parcelRequire("j5KnW"))),
    'test-screen-space-flags-message': (0, $cozmU.lazy)(()=>(parcelRequire("1H3tc"))),
    'test-simple-ipm-spotlight-page-load': (0, $cozmU.lazy)(()=>(parcelRequire("7rWc9"))),
    'twc-conf-sample-page-tour': (0, $cozmU.lazy)(()=>(parcelRequire("ftvk5"))),
    'twc-onboarding-provisioned': (0, $cozmU.lazy)(()=>(parcelRequire("amsNh"))),
    'twc-xflow-modal-v2': (0, $cozmU.lazy)(()=>(parcelRequire("d42xT")))
};
const $77db742053a85ab4$var$messageRenderer = (0, $2tp0D.asMessageRenderer)($77db742053a85ab4$export$e30378e28ad3e6ab, 'screen-space-flags');
const $77db742053a85ab4$export$bce4e5106d86e473 = $77db742053a85ab4$var$messageRenderer.initializeMessageRenderer;
const $77db742053a85ab4$export$2df1250b8f917a59 = $77db742053a85ab4$var$messageRenderer.MessageRenderer;




var $5h1mk = parcelRequire("5h1mk");

const $7a54097da521ce9f$export$e343914da553b968 = ()=>{
    const route = (0, $5h1mk.usePostOfficeRoute)();
    let result = {};
    if (route?.searchParams) result = Object.fromEntries(route.searchParams);
    if (typeof window !== 'undefined' && typeof window.location?.pathname === 'string') result = {
        ...result,
        pathname: window.location.pathname
    };
    return result;
};


const $0df8a9d50021190a$export$f6564e60882bdf90 = ({ initialData: initialData, preloadedInitialData: preloadedInitialData, setPreloadedInitialData: setPreloadedInitialData, jiraFlagsService: jiraFlagsService, reportExpectedError: reportExpectedError, reportUnexpectedError: reportUnexpectedError })=>{
    const injectedMessageTemplates = (0, $8cb0e79684b84cac$export$60075266d0d5c9c4)();
    // https://switcheroo.atlassian.com/ui/gates/3088e603-a723-449e-a763-b42e9db2a626/key/post-office_enable_ssf_injected_messages
    const isInjectedMessagesEnabled = (0, $cXtTj.default).checkGate('post-office_enable_ssf_injected_messages');
    const injectedMessageRenderer = (0, $cozmU.useMemo)(()=>injectedMessageTemplates ? (0, $2tp0D.asMessageRenderer)(injectedMessageTemplates, 'screen-space-flags').MessageRenderer : (0, $77db742053a85ab4$export$2df1250b8f917a59), [
        injectedMessageTemplates
    ]);
    const MessageRenderer = isInjectedMessagesEnabled ? injectedMessageRenderer : (0, $77db742053a85ab4$export$2df1250b8f917a59);
    const isEPExternalMessageSSREnabled = (0, $cXtTj.default).checkGate('post-office_enabled_ep_external_message_ssr');
    const [localMessageState, setLocalMessageState] = (0, $cozmU.useState)(()=>{
        const messages = preloadedInitialData?.messages?.length ? preloadedInitialData.messages : undefined;
        const triggeredMessages = preloadedInitialData?.triggeredMessages?.length ? preloadedInitialData.triggeredMessages : undefined;
        return {
            messages: messages,
            triggeredMessages: triggeredMessages
        };
    });
    // Dismissals are stored locally to keep the local state relatively immutable,
    // except unless explicitly refreshed from the server.
    const [dismissedMessageInstanceIds, setDismissedMessageInstanceIds] = (0, $cozmU.useState)([]);
    const filterByDismissed = (0, $cozmU.useCallback)((list)=>list?.filter((msg)=>!dismissedMessageInstanceIds.includes(msg.messageInstanceId)), [
        dismissedMessageInstanceIds
    ]);
    // Filter the messages at runtime to ensure they are always accurate and
    // so we don't need to manage the dismissed messages in the state.
    const { filteredMessages: filteredMessages, filteredTriggeredMessages: filteredTriggeredMessages } = (0, $cozmU.useMemo)(()=>({
            filteredMessages: filterByDismissed(localMessageState.messages),
            filteredTriggeredMessages: filterByDismissed(localMessageState.triggeredMessages)
        }), [
        localMessageState.messages,
        localMessageState.triggeredMessages,
        filterByDismissed
    ]);
    (0, $gfQZH.useInitialData)(initialData);
    const { onMessageDismiss: onMessageDismiss, onMessageClicked: onMessageClicked, onMessageSnooze: onMessageSnooze } = (0, $di43e.useMessagePlacementHooks)();
    const handleDismiss = (0, $cozmU.useCallback)(({ messageInstanceId: messageInstanceId })=>{
        if (messageInstanceId) // dismiss the current message instance
        setDismissedMessageInstanceIds((current)=>[
                ...current,
                messageInstanceId
            ]);
        else // eslint-disable-next-line no-console
        console.error(`A valid messageInstanceId is required to dismiss a message: ${messageInstanceId}`);
    }, []);
    const onDismissed = (0, $cozmU.useCallback)((messageInstanceId)=>{
        handleDismiss({
            messageInstanceId: messageInstanceId
        });
    }, [
        handleDismiss
    ]);
    (0, $cozmU.useEffect)(()=>onMessageDismiss(handleDismiss), [
        onMessageDismiss
    ]);
    (0, $cozmU.useEffect)(()=>onMessageClicked(handleDismiss), [
        onMessageClicked
    ]);
    (0, $cozmU.useEffect)(()=>onMessageSnooze(handleDismiss), [
        onMessageSnooze
    ]);
    (0, $cozmU.useEffect)(()=>{
        // update the preloaded initial data with the accurate filtered messages
        if (typeof setPreloadedInitialData === 'function') {
            if (isEPExternalMessageSSREnabled) setPreloadedInitialData({
                messages: filteredMessages ?? [],
                triggeredMessages: filteredTriggeredMessages ?? []
            });
            else setPreloadedInitialData({
                messages: filteredMessages ?? [],
                triggeredMessages: filteredTriggeredMessages ?? []
            });
        }
    }, [
        filteredMessages,
        filteredTriggeredMessages,
        isEPExternalMessageSSREnabled,
        setPreloadedInitialData
    ]);
    const activeScopes = (0, $ibNn3.usePostOfficeContextScope)({
        scopes: $f250ed0d244ef04b$export$54a06e3f4a159ad8,
        treatIntersectionAsSame: true
    });
    const searchParams = (0, $7a54097da521ce9f$export$e343914da553b968)();
    const messagesState = (0, $6ETv4.usePlacementApi)('/update-messages', {
        queryParams: {
            ...searchParams,
            updateKey: activeScopes.updateKey ?? ''
        },
        requestOptions: {
            method: 'POST',
            body: JSON.stringify(activeScopes)
        },
        throttleTime: 100,
        autoRefetch: {
            isEnabled: (0, $cXtTj.default).checkGate('post-office-ssf-enable-continuous-auto-refetch') ? !!activeScopes.updateKey && !filteredMessages?.length : !!activeScopes.updateKey && typeof filteredMessages === 'undefined',
            updateKey: activeScopes.updateKey ?? ''
        }
    });
    (0, $cozmU.useEffect)(()=>{
        const data = messagesState?.data;
        if (!data) return;
        setLocalMessageState((prev)=>{
            const messages = data.messages ?? [];
            let selectedMessages = [];
            if (messages.length > 0) {
                let selectedMessage;
                // New experiments in the screen-space-flags placement must be added to the EXPERIMENTAL_MESSAGES list
                for (const message of messages){
                    const experimentalMessage = (0, $94d72c94d7d7862e$export$963cdca6c7580c53).find((p)=>p.messageTemplateId === message.messageTemplateId);
                    if (experimentalMessage) {
                        const cohort = (0, $cXtTj.default).getExperimentValue(experimentalMessage.statsigExperiment, experimentalMessage.statsigParameterName, 'not-enrolled', {
                            fireExperimentExposure: true
                        });
                        if (experimentalMessage?.statsigAAExperiment) (0, $cXtTj.default).getExperimentValue(experimentalMessage.statsigAAExperiment, experimentalMessage.statsigParameterName, 'not-enrolled', {
                            fireExperimentExposure: true
                        });
                        if (experimentalMessage.statsigTestCohorts.includes(cohort)) {
                            selectedMessage = message;
                            break;
                        }
                    } else {
                        selectedMessage = message;
                        break;
                    }
                }
                selectedMessages = selectedMessage ? [
                    selectedMessage
                ] : [];
            }
            const triggeredMessages = data.triggeredMessages ?? [];
            return {
                ...prev,
                messages: selectedMessages,
                triggeredMessages: triggeredMessages
            };
        });
    }, [
        messagesState.data
    ]);
    const messageToRender = filteredMessages?.[0];
    const content = (0, $cXtTj.default).checkGate('post-office-screen-space-flags-shadow') ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $6c7b574341cd8f67$export$32c78d11bbf53e24), {
        children: [
            messageToRender ? /*#__PURE__*/ (0, $cozmU.createElement)(MessageRenderer, {
                ...messageToRender,
                key: messageToRender.messageInstanceId,
                id: messageToRender.messageInstanceId,
                messageInstanceId: messageToRender.messageInstanceId,
                onDismissed: onDismissed,
                SuspenseBoundary: (0, $2tp0D.MaybeSuspenseBoundary),
                jiraFlagsService: jiraFlagsService,
                onError: reportUnexpectedError,
                reportExpectedError: reportExpectedError
            }) : null,
            filteredTriggeredMessages?.map((msg)=>/*#__PURE__*/ (0, $cozmU.createElement)(MessageRenderer, {
                    ...msg,
                    key: msg.messageInstanceId,
                    id: msg.messageInstanceId,
                    messageInstanceId: msg.messageInstanceId,
                    onDismissed: onDismissed,
                    SuspenseBoundary: (0, $2tp0D.MaybeSuspenseBoundary),
                    jiraFlagsService: jiraFlagsService,
                    onError: reportUnexpectedError,
                    reportExpectedError: reportExpectedError
                }))
        ]
    }) : null;
    return content;
};


const $c77431eeb6335bee$export$c32237a999261c49 = (input)=>(0, $ibNn3.createMatchScopes)({
        scopes: $f250ed0d244ef04b$export$54a06e3f4a159ad8
    })(input);
const $c77431eeb6335bee$export$c60b43809441c5b0 = (0, $ebebe8b4c85be972$export$b0eee5de066b2bf5)((0, $6U5eU.createPlacementComponent)((0, $57786d38307be613$export$a5cfae247d8360ef), /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0df8a9d50021190a$export$f6564e60882bdf90), {
        ...props
    });
}), {
    choreographer: {
        isDefaultEnabled: true // this is the default value, but leaving it as explicitly defined
    }
}));
var $c77431eeb6335bee$export$2e2bcd8739ae039 = $c77431eeb6335bee$export$c60b43809441c5b0;



var $5vi32 = parcelRequire("5vi32");


var $5kbLE = parcelRequire("5kbLE");











var $gswTK = parcelRequire("gswTK");

const $e71193158df615d9$export$e5ffd38dcf6e5c53 = `/gateway/api/post-office/api/v1/placements/`;
const $e71193158df615d9$export$85c4756977e87c75 = `/gateway/api/post-office/api/v1/placement-preview/`;
const $e71193158df615d9$export$52e362b70e115c68 = ({ returnOverride: returnOverride, eligibleMessages: eligibleMessages, children: children })=>{
    const fetch = (0, $cozmU.useMemo)(()=>{
        if (returnOverride) return $e71193158df615d9$export$fb5156757134712c({
            returnOverride: returnOverride
        });
        return $e71193158df615d9$export$c05392ff95b4319d({
            eligibleMessages: eligibleMessages
        });
    }, [
        eligibleMessages,
        returnOverride
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gswTK.PlacementFetchingProvider), {
        fetch: fetch
    }, children);
};
const $e71193158df615d9$export$fb5156757134712c = ({ returnOverride: returnOverride })=>async ()=>{
        return new Response(JSON.stringify(returnOverride), {
            status: 200,
            statusText: 'ok'
        });
    };
const $e71193158df615d9$export$c05392ff95b4319d = ({ eligibleMessages: eligibleMessages })=>(url, options)=>{
        const finalUrl = url.replace($e71193158df615d9$export$e5ffd38dcf6e5c53, $e71193158df615d9$export$85c4756977e87c75);
        const payload = {
            originalMethod: options?.method || 'GET',
            originalBody: $e71193158df615d9$var$parseBody(options?.body),
            eligibleMessages: eligibleMessages
        };
        return globalThis.fetch(finalUrl, {
            ...options,
            method: 'POST',
            headers: {
                ...options?.headers || {}
            },
            body: $e71193158df615d9$var$stringifyPayload(payload)
        });
    };
const $e71193158df615d9$var$objectHasKeys = (input)=>!!Object.keys(input).length;
const $e71193158df615d9$var$parseBody = (body)=>{
    if (typeof body === 'undefined' || body === null) return undefined;
    try {
        const parsedBody = JSON.parse(body);
        if ($e71193158df615d9$var$objectHasKeys(parsedBody)) return parsedBody;
        throw new Error();
    } catch  {
        throw new Error('Unable to parse preview body. Is it a valid object?');
    }
};
const $e71193158df615d9$var$stringifyPayload = (payload)=>{
    try {
        return JSON.stringify(payload);
    } catch  {
        throw new Error('Unable to parse preview body. Is it a valid object?');
    }
};


const $6712e9ecdde63a04$export$52e362b70e115c68 = (0, $e71193158df615d9$export$52e362b70e115c68);
const $6712e9ecdde63a04$export$c05392ff95b4319d = (0, $e71193158df615d9$export$c05392ff95b4319d);




var $9EOlJ = parcelRequire("9EOlJ");




const $d60c5d3424a92ca3$export$16e97e6603eadea = ({ PlacementComponent: PlacementComponent, placementId: placementId, eligibleMessages: eligibleMessages, errorFallback: errorFallback = null, onError: onError, returnOverride: returnOverride, disableInitialData: disableInitialData })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $9EOlJ.ErrorBoundary), {
        fallback: errorFallback,
        onError: onError,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6712e9ecdde63a04$export$52e362b70e115c68), {
            eligibleMessages: eligibleMessages,
            returnOverride: returnOverride,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5kbLE.default), {
                PlacementComponent: PlacementComponent,
                placementId: placementId,
                disableInitialData: disableInitialData
            })
        })
    });
const $d60c5d3424a92ca3$export$46db7cd62b063064 = ({ isEnabled: isEnabled, children: children })=>{
    const { searchParams: searchParams } = (0, $5h1mk.usePostOfficeRoute)();
    const previewId = searchParams?.get('contentfulPreviewId');
    const hasPreviewType = Boolean(searchParams?.get('contentfulPreviewId'));
    const localeForPreview = searchParams?.get('locale');
    const eligibleMessage = [
        {
            messageInstanceId: 'messageInstanceId',
            messageTemplateId: 'marketing-screen-space-flag-contentful-usecase',
            messageCategory: 'Engagement',
            context: {
                id: previewId,
                localeForPreview: localeForPreview
            },
            createdAt: new Date().toString(),
            eventTime: new Date().toString(),
            triggerId: 'triggerId',
            messageCreationType: 'explicit'
        }
    ];
    if (isEnabled && hasPreviewType) return /*#__PURE__*/ (0, $8aG6j.jsx)($d60c5d3424a92ca3$export$16e97e6603eadea, {
        placementId: "screen-space-flags",
        PlacementComponent: (0, $c77431eeb6335bee$export$c60b43809441c5b0),
        eligibleMessages: eligibleMessage
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};



var $9oJIg = parcelRequire("9oJIg");

var $MyxIQ = parcelRequire("MyxIQ");


var $b3j2Y = parcelRequire("b3j2Y");


var $7Sm4c = parcelRequire("7Sm4c");








var $8MKuN = parcelRequire("8MKuN");


var $bQm3c = parcelRequire("bQm3c");







const $d59515e7454a98b6$export$9c1a9b8d86d81805 = ()=>{
    const isSyntheticTenant = (0, $1xpoY.default).getBoolean('confluence_frontend_pollinator_synthetic_tenants', false);
    if (!isSyntheticTenant) return false;
    // Allow Post Office's own Pollinator accounts through (they rely on hitting the
    // Placement API for their own monitoring).
    return !(0, $9wGTI.fg)('post-office-is-post-office-synthetic');
};






var $0VKZa = parcelRequire("0VKZa");

const $ccd0dc06d2167081$export$f6564e60882bdf90 = /*#__PURE__*/ (0, $cozmU.memo)(()=>{
    const [messageErrorToReport, setMessageErrorToReport] = (0, $cozmU.useState)();
    const [preloadedInitialData, setPreloadedInitialData] = (0, $MyxIQ.usePlacementPreloadedData)('screen-space-flags/update-messages');
    const memoizedPlacementProps = (0, $cozmU.useMemo)(()=>({
            reportExpectedError: (0, $7Sm4c.markErrorAsHandled),
            reportUnexpectedError: setMessageErrorToReport,
            preloadedInitialData: preloadedInitialData,
            setPreloadedInitialData: setPreloadedInitialData
        }), [
        preloadedInitialData,
        setPreloadedInitialData
    ]);
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const isEmbeddedView = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    if (isEmbeddedView) return null;
    if (!userId) return null;
    // Suppress the placement (and its Placement API request) for non-Post-Office synthetic
    // test tenants, which otherwise generate large volumes of Placement API traffic and
    // trigger Stargate rate-limit alerts.
    if ((0, $d59515e7454a98b6$export$9c1a9b8d86d81805)()) return null;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d60c5d3424a92ca3$export$46db7cd62b063064), {
        isEnabled: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9oJIg.PlacementFetchProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5kbLE.default), {
        placementId: "screen-space-flags",
        // @ts-ignore - Type 'ComponentType<ErrorBoundariedProps<Placement>>' is not assignable to type 'PlacementComponent<LocalPlacementProps>'
        PlacementComponent: (0, $c77431eeb6335bee$export$c60b43809441c5b0),
        placementProps: memoizedPlacementProps,
        disableInitialData: true
    }), messageErrorToReport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: messageErrorToReport
    })));
    return (0, $6mKj3.expVal)('confluence_edit_page_conditional_ufohold_ignore', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8MKuN.ConditionalUfoHoldIgnore), null, content) : content;
});
const $ccd0dc06d2167081$export$1966d6abb8c3b6 = async (match)=>{
    // Skip preloading (and the associated Placement API request) for non-Post-Office
    // synthetic test tenants. Without this, test tenants still hit the Placement API via the
    // SSR/preload path even though the component itself renders null.
    if ((0, $d59515e7454a98b6$export$9c1a9b8d86d81805)()) return undefined;
    const sessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const activeScopes = (0, $c77431eeb6335bee$export$c32237a999261c49)({
        route: {
            hostname: '',
            pathname: match?.pathname ?? '',
            search: match?.search ?? ''
        },
        context: (0, $0VKZa.sessionToPostOfficeContext)(sessionContext)
    });
    const updateMessagesBody = {
        current: activeScopes,
        previous: []
    };
    return (0, $MyxIQ.preloadPostOfficePlacementWithSessionContext)('screen-space-flags', {
        resource: '/update-messages',
        requestInit: {
            method: 'POST',
            body: JSON.stringify(updateMessagesBody)
        }
    });
};








async function $f217a7781374a3c1$export$5ab53e93f975c926(match) {
    const { userId: userId } = (0, $xwvlW.getPreloaderFnContext)();
    if (!userId || !match) return;
    return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/postOffice:ScreenSpaceFlags', async ()=>{
        return (0, $ccd0dc06d2167081$export$1966d6abb8c3b6)(match);
    });
}












var $ctTo0 = parcelRequire("ctTo0");

async function $b018a9de51ee5cc4$export$daad0bec45611c67() {
    const { cloudId: cloudId, isLoggedIn: isLoggedIn } = (0, $xwvlW.getPreloaderFnContext)();
    if (!isLoggedIn || !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc_perms_ga_access_requests', 'isEnabled', true)) return;
    return (0, $dYU3e.query)({
        query: (0, $ctTo0.default),
        variables: {
            cloudId: cloudId
        },
        __callerPackage__: "access-requests"
    });
}












var $kdKo9 = parcelRequire("kdKo9");

async function $143cdfd4eb3dc7a0$export$f8ed1334515840af(spaceKey) {
    const result = await (0, $dYU3e.query)({
        query: (0, $kdKo9.default),
        variables: {
            spaceKey: spaceKey
        },
        errorPolicy: 'all',
        // Preloaders are called both on server at initial load AND transition on client-side.
        // On server-side it doesn't matter fetch policy because we only gonna request once.
        // On client-side it must be network-only to get fresh data.
        fetchPolicy: 'network-only',
        __callerPackage__: "restrictions"
    });
    window['__SPACE_RESTRICTED_CHECK_ERROR__'] = false;
    window['__SPACE_NOTFOUND_CHECK_ERROR__'] = false;
    if (result?.errors) result.errors.forEach((error)=>{
        const status_code = error?.extensions?.statusCode;
        if (status_code === 403) {
            window['__SPACE_RESTRICTED_CHECK_ERROR__'] = true;
            (0, $7Sm4c.markErrorAsHandled)(error);
        } else if (status_code === 404 || status_code === 400) {
            window['__SPACE_NOTFOUND_CHECK_ERROR__'] = true;
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    });
}


const $f7b10b9020854fc7$export$6fb7f9b73aaa748e = async (spaceKey)=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $143cdfd4eb3dc7a0$export$f8ed1334515840af)(spaceKey),
        // Any route with a space key can land on RestrictedSpaceScreen, so this belongs here rather
        // than in individual route preloaders. Gating it on __SPACE_RESTRICTED_CHECK_ERROR__ was
        // tried and reverted — that global isn't reliably set by the time this task reads it.
        (0, $b018a9de51ee5cc4$export$daad0bec45611c67)()
    ]);
};


















async function $b4d670122e111714$export$e77946254f7ce879(match) {
    const tasks = [];
    const preloadedSessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId, isRovoEnabled: isRovoEnabled } = preloadedSessionContext;
    const isLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    tasks.push((0, $5WLjq.preloadSpacesList)({
        isLicensed: isLicensed
    }));
    const isFullPageSearchEnabled = ((0, $9wGTI.fg)('unified_search_in_confluence') || isRovoEnabled) && !(0, $9wGTI.fg)('confluence_rovo_search_opt_out');
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
}



async function $e80763d537fd4542$export$6aefe8c2dfd7fe98(url) {
    const match = $e80763d537fd4542$var$matchRoute(url);
    if (match?.experience === (0, $irVI7.VIEW_PAGE_EXPERIENCE) || match?.experience === (0, $irVI7.SPACE_OVERVIEW_EXPERIENCE) || match?.experience === (0, $irVI7.EDIT_PAGE_EXPERIENCE)) return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $9fLxI.getExtensionManifest)({
            spaceKey: match.params.spaceKey
        }),
        (0, $5SzHz.preloadSpaceDetail)(match.params.spaceKey),
        (0, $821e100427ee88aa$export$ce64f7b5556cdb62)(),
        (0, $88b2ba3b9422ec6a$export$3837c35a0d92ab93)()
    ]);
}
async function $e80763d537fd4542$export$57d895781a697848(...args) {
    // All the function calls originated from this entry point are attached to a query boundary.
    // This is used to help us identify fetches fired from components.
    return (0, $g277M.runInQueryBoundary)('default', ()=>{
        return $e80763d537fd4542$var$preloadQueryBasedOnRouteImpl(...args);
    });
}
async function $e80763d537fd4542$var$preloadQueryBasedOnRouteImpl(url, isTransition = false, previousMatch = null, preloadOptions) {
    const commonTasks = [];
    const match = $e80763d537fd4542$var$matchRoute(url);
    if (match?.experience) (0, $df23aac6d1130849$export$7388eaba0b85ff24)(match.experience);
    const isEmbeddedWhiteboard = match?.experience === (0, $irVI7.WHITEBOARD_EXPERIENCE) && (0, $58246c7bb1bd3b0e$export$a8738b3e8374c78c)(match).bypassesMainLayout;
    /**
   * There are synchronous operations in preparing session data.
   * All queries that independent to session data should be fired first.
   */ if (!isTransition) {
        commonTasks.push((0, $29df517881fdeca7$export$990c5eb6cb59ce1c)());
        if (match?.experience === (0, $irVI7.PDF_EXPORT_PAGE_EXPERIENCE)) // The PDF export route only renders a specific Confluence page's title and content.
        // So, we don't need to fetch data for certain common Confluence features and preferences such as navigation and user settings.
        // Note 1: PDF export is not a SSR capability and also need not support SPA transitions, as it is only accessible via direct URL.
        commonTasks.push(// Remote local storage
        (0, $eiCiP.preloadLocalStorage)(), // Forge UI user profile
        (0, $969a3e14c27be3bd$export$9930aa21f1e6a4e3)());
        else if (isEmbeddedWhiteboard) {
            commonTasks.push((0, $eiCiP.preloadLocalStorage)());
            // https://switcheroo.atlassian.com/ui/gates/0d974cd3-c266-43ed-9312-0980df443012/key/post-office_screen-space-flags-confluence-ssr
            if ((0, $9wGTI.fg)('post-office_screen-space-flags-confluence-ssr')) commonTasks.push((0, $f217a7781374a3c1$export$5ab53e93f975c926)(match));
            commonTasks.push((0, $96ee7afaced2313e$export$e0e94d96f49a1aa)({
                themeState: undefined
            }));
            commonTasks.push((0, $3y1ko.preloadShortcutEnabledState)());
        } else if (match?.experience !== (0, $irVI7.EXTERNAL_SHARE_EXPERIENCE)) {
            // external share doesn't have navigation, returns only errors
            commonTasks.push((0, $eiCiP.preloadLocalStorage)(), (0, $5368439faec350a5$export$6c7e4784651f052f)());
            commonTasks.push((0, $c63485f681d81d31$export$693b572d94b96722)());
            commonTasks.push((0, $e44b2547c6a8e817$export$dfd129d3c3f4c561)());
            commonTasks.push((0, $eS4vC.createDataFetcherForSuspense)('top-nav', ()=>[
                    (0, $a6a4fe9083f3db22$export$d46e9819bcc1eb51)(),
                    (0, $1d20c0a68123b7f2$export$2d0f6d5aa0911699)(),
                    (0, $3y1ko.preloadShortcutEnabledState)()
                ]));
            commonTasks.push((0, $34aa8f5c495a6ba2$export$3efc211209d16247)());
            if ((0, $6mKj3.UNSAFE_expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1')) commonTasks.push((0, $da1fd1e44d7582fe$export$b4f1825d0b62630d)());
            // https://switcheroo.atlassian.com/ui/gates/0d974cd3-c266-43ed-9312-0980df443012/key/post-office_screen-space-flags-confluence-ssr
            if ((0, $9wGTI.fg)('post-office_screen-space-flags-confluence-ssr')) commonTasks.push((0, $f217a7781374a3c1$export$5ab53e93f975c926)(match));
            commonTasks.push((0, $969a3e14c27be3bd$export$9930aa21f1e6a4e3)());
            const experience = match?.experience;
            commonTasks.push((0, $96ee7afaced2313e$export$e0e94d96f49a1aa)({
                themeState: [
                    (0, $irVI7.EDIT_PAGE_EMBED_EXPERIENCE),
                    (0, $irVI7.VIEW_PAGE_EXPERIENCE)
                ].includes(experience) ? match?.query?.themeState : undefined
            }));
        }
    }
    if (!match) // Following code are specific to each route.
    // If we don't get a match here then there is nothing interesting
    return Promise.resolve();
    let routeTasks = Promise.resolve();
    const commonRouteTasks = [];
    // Routes can have common data if the route has a space key
    const spaceKey = match?.params?.spaceKey;
    if (spaceKey) commonRouteTasks.push((0, $f7b10b9020854fc7$export$6fb7f9b73aaa748e)(spaceKey));
    // TODO: We should do similar for content id here
    // but currently preloadPageRestrictionsQuery is spread out in each individual route.
    if (!isEmbeddedWhiteboard && (0, $9wGTI.fg)('aifc_onboarding_ga_enabled')) commonRouteTasks.push((0, $9c2bd2b1923ffb30$export$20203945a91bbda3)());
    if (match.experience === (0, $irVI7.VIEW_PAGE_EXPERIENCE)) {
        const { isLivePage: isLivePageSSR } = (0, $60cDW.getSSRRenderInputs)();
        // On transition or SSR revisit, validate whether we're a live doc. If so, only preload live doc routes, not all view page routes.
        // Prevents unnecessary GQL calls, e.g. ContentUnifiedQuery.
        let isCachedLivePage = false;
        const contentId = match?.params?.contentId;
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const shouldCheckCachedLivePage = isTransition || Boolean(undefined);
        if (contentId && !isLivePageSSR && shouldCheckCachedLivePage) {
            const { subType: subType, isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(contentId);
            isCachedLivePage = subType === 'live' && isArchived === false;
        }
        routeTasks = isLivePageSSR || isCachedLivePage ? (0, $iUV81.preloadLivePageRoute)(match, url) : (0, $445d6fd463fd83fa$export$9503d022471fff24)(match, url, isTransition, previousMatch);
    } else if (match.experience === (0, $irVI7.SPACE_OVERVIEW_EXPERIENCE) || match.experience === (0, $irVI7.FRONT_COVER_LOAD_EXPERIENCE)) {
        if (preloadOptions?.preloadingMode === (0, $hXDOc.PreloadingMode).onlyJSAndCriticalData) routeTasks = (0, $fe22b38e04163065$export$75a73f2fbf5e96e8)(match);
        else routeTasks = (0, $fe22b38e04163065$export$75071d943b36f58f)(match, previousMatch, url);
    } else if (match.experience === (0, $irVI7.WHITEBOARD_EXPERIENCE)) routeTasks = (0, $d639d659544153c3$export$a107836a8bcfc0c9)(match, url, isTransition);
    else if (match.experience === (0, $irVI7.DATABASE_EXPERIENCE)) routeTasks = (0, $f7a595baa9e6d446$export$f9f9f93ef86bfae1)(match, url, isTransition);
    else if (match.experience === (0, $irVI7.EMBED_EXPERIENCE)) routeTasks = (0, $a17ca091e4cf9f3d$export$18e29f32c47bffc9)(match, url, isTransition);
    else if (match.experience === (0, $irVI7.EDIT_PAGE_SMART_CREATE_LOAD_EXPERIENCE)) routeTasks = (0, $ff76ae367134cd26$export$2a230d51c69b591b)(match.params.contentId);
    else if (match.experience === (0, $irVI7.EDIT_PAGE_EXPERIENCE)) routeTasks = (0, $32e736695aa13b8b$export$8abf4a07f4444858)(match, url, isTransition);
    else if (match.experience === (0, $irVI7.HOME_EXPERIENCE)) routeTasks = (0, $179951d621935e1e$export$cefc517f3ae2aa98)(match);
    else if (match.experience === (0, $irVI7.SPACE_PAGES_EXPERIENCE)) routeTasks = (0, $106eac55bed5d4af$export$206b1c2d74bc11a2)(match);
    else if (match.experience === (0, $irVI7.CONTENT_HISTORY_EXPERIENCE)) routeTasks = (0, $0ef4e79dd69588ad$export$9f53340e87bacbbd)(match);
    else if (match.experience === (0, $irVI7.ATTACHMENTS_PAGE_EXPERIENCE)) routeTasks = (0, $29ace679d934655d$export$7cbbf2d30ca863e7)(match);
    else if (match.experience === (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE)) routeTasks = (0, $b4d670122e111714$export$e77946254f7ce879)(match);
    else if (match.experience === (0, $irVI7.ACCESS_LINK_EXPERIENCE)) routeTasks = (0, $1f9d1c86f6a99b0e$export$5da6d89b949b94fc)(match, url, isTransition, previousMatch);
    else if (match.experience === (0, $irVI7.EXTERNAL_SHARE_EXPERIENCE)) routeTasks = (0, $d3b88206c55934ef$export$bd1c07b274fefbd7)(match);
    else if (match.experience === (0, $irVI7.PDF_EXPORT_PAGE_EXPERIENCE)) routeTasks = (0, $e6a21086b65e01ae$export$878ae3f236acea00)(match);
    else if (match.experience === (0, $irVI7.FOLDER_EXPERIENCE)) routeTasks = (0, $ae578b27499cf6ef$export$4286139fad35252)(match);
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $eS4vC.createDataFetcherForSuspense)('default', ()=>[
                routeTasks,
                ...commonRouteTasks
            ]),
        ...commonTasks
    ]).then((errors)=>{
        if (errors) for (const e of errors)(0, $3mugH.ssrPrepareErrorsClient).submitError(e);
    });
}
async function $e80763d537fd4542$export$faa68b5324f40037(pageUrl) {
    const match = $e80763d537fd4542$var$matchRoute(pageUrl);
    if (!match) return;
    if (match.experience === (0, $irVI7.EDIT_PAGE_EXPERIENCE)) return (0, $73df6e46d3afaa7c$export$9c3872cc60e7dbce)(match, pageUrl);
}
function $e80763d537fd4542$var$matchRoute(url) {
    let match;
    let experience;
    if (match = (0, $kM8fE.matchViewPage)(url)) experience = (0, $irVI7.VIEW_PAGE_EXPERIENCE);
    else if (match = (0, $kM8fE.matchWhiteboardPage)(url)) experience = (0, $irVI7.WHITEBOARD_EXPERIENCE);
    else if (match = (0, $kM8fE.matchSpaceOverview)(url)) experience = (0, $irVI7.SPACE_OVERVIEW_EXPERIENCE);
    else if (match = (0, $kM8fE.matchCompanyHub)(url)) experience = (0, $irVI7.FRONT_COVER_LOAD_EXPERIENCE);
    else if (match = (0, $kM8fE.matchHome)(url)) experience = (0, $irVI7.HOME_EXPERIENCE);
    else if (match = (0, $kM8fE.matchFabricEditor)(url)) experience = (0, $irVI7.EDIT_PAGE_EXPERIENCE);
    else if (match = (0, $kM8fE.matchExternalShare)(url)) experience = (0, $irVI7.EXTERNAL_SHARE_EXPERIENCE);
    else if (match = (0, $kM8fE.matchAccessLink)(url)) experience = (0, $irVI7.ACCESS_LINK_EXPERIENCE);
    else if (match = (0, $kM8fE.matchSpacePages)(url)) experience = (0, $irVI7.SPACE_PAGES_EXPERIENCE);
    else if (match = (0, $kM8fE.matchContentHistory)(url)) experience = (0, $irVI7.CONTENT_HISTORY_EXPERIENCE);
    else if (match = (0, $kM8fE.matchAttachmentsPage)(url)) experience = (0, $irVI7.ATTACHMENTS_PAGE_EXPERIENCE);
    else if (match = (0, $kM8fE.matchEmbeddedEditor)(url)) experience = (0, $irVI7.EDIT_PAGE_EMBED_EXPERIENCE);
    else if (match = (0, $kM8fE.matchDatabasePage)(url)) experience = (0, $irVI7.DATABASE_EXPERIENCE);
    else if (match = (0, $kM8fE.matchEmbedPage)(url)) experience = (0, $irVI7.EMBED_EXPERIENCE);
    else if (match = (0, $kM8fE.matchSmartCreateEditor)(url)) experience = (0, $irVI7.EDIT_PAGE_SMART_CREATE_LOAD_EXPERIENCE);
    else if (match = (0, $kM8fE.matchSearch)(url)) experience = (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE);
    else if ((0, $kM8fE.matchPdfExport)(url)) {
        match = (0, $kM8fE.matchPdfExport)(url);
        experience = (0, $irVI7.PDF_EXPORT_PAGE_EXPERIENCE);
    } else if (match = (0, $kM8fE.matchFolderPage)(url)) experience = (0, $irVI7.FOLDER_EXPERIENCE);
    return match && {
        ...match,
        experience: experience
    };
}
async function $e80763d537fd4542$export$bd8e570400e2d126() {
    const pageUrl = window.location.toString();
    // Extensions Manifest and extensions data (when preloading is requested for them)
    // are heavy and should not be loaded on server side and embedded into HTML.
    $e80763d537fd4542$export$6aefe8c2dfd7fe98(pageUrl);
    if (window.__SSR_RENDERED__) $e80763d537fd4542$export$faa68b5324f40037(pageUrl);
    else $e80763d537fd4542$export$57d895781a697848(pageUrl);
}






var $8PKGr = parcelRequire("8PKGr");


var $aXEzU = parcelRequire("aXEzU");





var $dtDUi = parcelRequire("dtDUi");


var $dA1Sn = parcelRequire("dA1Sn");


var $gnYQc = parcelRequire("gnYQc");











var $2DVQX = parcelRequire("2DVQX");


var $7ZzSP = parcelRequire("7ZzSP");


var $3Tw8v = parcelRequire("3Tw8v");


var $9F7Qb = parcelRequire("9F7Qb");


var $6b4nE = parcelRequire("6b4nE");





var $bEYte = parcelRequire("bEYte");


var $kNIYN = parcelRequire("kNIYN");


var $hpWmZ = parcelRequire("hpWmZ");





var $8sZwv = parcelRequire("8sZwv");


var $l08Du = parcelRequire("l08Du");








var $7zgzO = parcelRequire("7zgzO");








var $5nuFe = parcelRequire("5nuFe");


var $kwzZh = parcelRequire("kwzZh");


var $7Px0t = parcelRequire("7Px0t");


var $jmjWc = parcelRequire("jmjWc");





var $32x2E = parcelRequire("32x2E");

const $b765bc6fd36943f2$export$e2036a91fb26c8cf = (url)=>{
    /* Extracting Confluence page data from URL because we don't have access to the page context
	 * from the Screen Space Flags placement.
	 *
	 * Sample page URL: wiki/spaces/{spaceKey}/pages/{contentId}/This+is+the+title+of+a+page
	 * Sample blog URL: wiki/spaces/{spaceKey}/blog/2025/04/11/{contentId}/This+is+the+title+of+a+blog+post
	 */ const [, spaceKey, rawContentType, contentId] = url.match(/\/wiki\/spaces\/([^/]+)\/(pages|blog|whiteboard|database)(?:\/\d{4}\/\d{2}\/\d{2})?\/(?:edit-v2\/)?([^/?#]+)/) || [];
    const contentType = rawContentType === 'pages' ? 'page' : rawContentType === 'blog' ? 'blogpost' : rawContentType;
    return {
        spaceKey: spaceKey,
        contentType: contentType,
        contentId: contentId
    };
};






var $8dbvt = parcelRequire("8dbvt");


var $2HQyh = parcelRequire("2HQyh");


var $1AapX = parcelRequire("1AapX");


var $jMyy4 = parcelRequire("jMyy4");


const $19a192258e8db8bc$export$1d93f080b8c40251 = (skip = false)=>{
    const { contentId: contentId, spaceKey: spaceKey } = (0, $b765bc6fd36943f2$export$e2036a91fb26c8cf)(globalThis.location.href);
    // Get recommendation data
    const { data: recPageData, loading: recPageLoading, error: recPageError } = (0, $jMyy4.useQueryInterop)((0, $2HQyh.default), {
        variables: {
            type: 'page',
            id: contentId ?? '',
            exp: 'end_of_page_v5',
            key: spaceKey ?? '',
            keyString: spaceKey ?? ''
        },
        skip: !contentId || !spaceKey || skip,
        __callerPackage__: "confluence-post-office-provider"
    });
    // Transform/sort data and grab first rec
    const recommendedPage = (0, $cozmU.useMemo)(()=>{
        const rankedPages = $19a192258e8db8bc$var$transformAndOrderRecs(recPageData?.getRecommendedPages?.recommendedPages);
        return rankedPages?.[0];
    }, [
        recPageData
    ]);
    // Get avatar and name of the page owner
    const { data: hoverPageData, loading: hoverPageLoading, error: hoverPageError } = (0, $jMyy4.useQueryInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $1AapX.default), {
        variables: {
            id: recommendedPage ? recommendedPage.id : ''
        },
        skip: !recommendedPage || skip,
        __callerPackage__: "confluence-post-office-provider"
    });
    const pageRecommendationData = {
        data: undefined,
        loading: hoverPageLoading || recPageLoading,
        hoverPageError: hoverPageError,
        recPageError: recPageError
    };
    if (hoverPageData?.singleContent?.history?.ownedBy?.displayName && hoverPageData?.singleContent?.history?.ownedBy?.profilePicture?.path && recommendedPage?.links?.webui && recommendedPage?.title.text) pageRecommendationData.data = {
        pageOwner: {
            name: hoverPageData.singleContent.history.ownedBy.displayName,
            avatarUrl: hoverPageData.singleContent.history.ownedBy.profilePicture.path
        },
        page: {
            title: recommendedPage.title.text,
            url: `/wiki${recommendedPage.links.webui}`
        }
    };
    return pageRecommendationData;
};
/**
 * The ordering of recs array is determined by the "ranking" in the backend.
 * Each rec will have a corresponding "strategies" array that can have one or multiple strategies.
 * We want to ensure that we are choosing strategies from each rec in a way that avoids monotony on the UI.
 * To accomplish this, we must first sort the recs array depending on the number of strategies each rec has, in
 * ascending order. We then pass each rec to transformEndOfPageRecContent which helps to choose the strategy, and
 * finally we return the transformed array back to the intial ranking order determind by the backend
 */ const $19a192258e8db8bc$var$transformAndOrderRecs = (recs)=>{
    if (!recs) return;
    const strategiesCounter = new Map();
    const recsSortedByStrategyCount = [
        ...recs
    ].sort((a, b)=>a.strategy.length > b.strategy.length ? 1 : -1);
    const transformedRecs = recsSortedByStrategyCount.map((rec)=>(0, $8dbvt.transformEndOfPageRecContent)(rec, strategiesCounter));
    // return to initial order
    const pageCards = new Array();
    recs.forEach((rec)=>{
        const el = transformedRecs.find((card)=>card.id === rec.content.id);
        pageCards.push(el);
    });
    return pageCards;
};


/* eslint-disable graphql-relay-compat/no-import-graphql-operations */ /* eslint-disable no-restricted-imports */ 






var $3V1KT = parcelRequire("3V1KT");


var $2OQgp = parcelRequire("2OQgp");











const $f95c9b8c12af7d64$var$INITIAL_REACTED_USER_QUERY_RESULT = {
    data: undefined,
    loading: false,
    error: undefined
};
// Helper function to fetch the specific names of users who reacted to a specific emoji
const $f95c9b8c12af7d64$var$getReactedUsersForEmoji = async (contentId, contentType, emojiId)=>{
    const { data: data } = await (0, $c0rhi.queryInterop)({
        query: (0, $2OQgp.ReactedUsersQuery),
        variables: {
            contentId: contentId,
            contentType: contentType.toUpperCase(),
            containerId: contentId,
            containerType: contentType.toUpperCase(),
            emojiId: emojiId
        },
        __callerPackage__: "confluence-post-office-provider"
    });
    return data;
};
// Helper function to get unique users who reacted to any emoji
const $f95c9b8c12af7d64$var$getUniqueReactedUsers = async (contentId, contentType, emojiIds)=>{
    const uniqueUsers = {};
    // Process all emojis in parallel to get all unique users
    await Promise.allSettled(emojiIds.filter(Boolean).map(async (emojiId)=>{
        const data = await $f95c9b8c12af7d64$var$getReactedUsersForEmoji(contentId, contentType, emojiId);
        // Add all users to the unique users map
        for (const user of data?.reactedUsers?.confluencePerson ?? [])if (user?.displayName && user.accountId) uniqueUsers[user.accountId] = user.displayName;
    }));
    return uniqueUsers;
};
const $f95c9b8c12af7d64$export$a35f2f61e0cb4308 = (numberOfReactedUsers, skip = false)=>{
    // Needed for Confluence-required analytic events
    const { userId: userId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { contentId: contentId, contentType: contentType } = (0, $b765bc6fd36943f2$export$e2036a91fb26c8cf)(window.location.href);
    const [reactedUsers, setReactedUsers] = (0, $cozmU.useState)($f95c9b8c12af7d64$var$INITIAL_REACTED_USER_QUERY_RESULT);
    const [uniqueUsersCount, setUniqueUsersCount] = (0, $cozmU.useState)(0);
    // Fetch page author and author's avatar URL
    const { data: spaceHoverPageCardResult, loading: spaceHoverPageCardLoading, error: spaceHoverPageCardError } = (0, $jMyy4.useQueryInterop)((0, $1AapX.default), {
        variables: {
            id: contentId
        },
        skip: !contentId || skip,
        __callerPackage__: "confluence-post-office-provider"
    });
    // Fetch total reactions count and emoji ID summary
    const { data: reactionsContentData, loading: reactionsLoading, error: reactionsError } = (0, $jMyy4.useQueryInterop)((0, $3V1KT.ReactionsContentQuery), {
        variables: {
            contentId: contentId
        },
        skip: !contentId || skip,
        __callerPackage__: "confluence-post-office-provider"
    });
    // Use the emoji ID summary from reactionsContentData to fetch the specific names of users who reacted
    (0, $cozmU.useEffect)(()=>{
        const emojiIds = reactionsContentData?.content?.nodes?.[0]?.contentReactionsSummary?.reactionsSummaryForEmoji?.flatMap((reaction)=>reaction?.emojiId ?? []);
        // Need to put this in a function and then call it because we can't use async/await in useEffect
        const getReactedUsers = async ()=>{
            if (!contentId || !contentType || !emojiIds || reactedUsers.data || reactedUsers.loading) return;
            setReactedUsers({
                loading: true
            });
            try {
                // Get all unique users in parallel
                const uniqueUsers = await $f95c9b8c12af7d64$var$getUniqueReactedUsers(contentId, contentType, emojiIds);
                // Take only the first numberOfReactedUsers users for the reactedUsers state
                const limitedUsers = Object.values(uniqueUsers).slice(0, numberOfReactedUsers);
                // Update state
                setUniqueUsersCount(Object.keys(uniqueUsers).length);
                setReactedUsers({
                    data: limitedUsers,
                    loading: false
                });
            } catch (error) {
                setReactedUsers({
                    loading: false,
                    error: error
                });
            }
        };
        getReactedUsers();
    }, [
        contentId,
        contentType,
        reactionsContentData,
        reactedUsers,
        numberOfReactedUsers
    ]);
    // Transform this so that it matches Post Office's expected shape (for use with the ReactionWrapper component)
    const transformedReactionsSummary = (0, $cozmU.useMemo)(()=>({
            reactionsSummary: {
                ari: reactionsContentData?.content?.nodes?.[0]?.contentReactionsSummary?.ari || '',
                containerAri: reactionsContentData?.content?.nodes?.[0]?.contentReactionsSummary?.containerAri || '',
                reactionsSummaryForEmoji: reactionsContentData?.content?.nodes?.[0]?.contentReactionsSummary?.reactionsSummaryForEmoji?.map((emoji)=>{
                    // Only return emoji objects that have all required non-null values
                    if (emoji?.count != null && emoji?.emojiId != null && emoji?.reacted != null) return {
                        count: emoji.count,
                        emojiId: emoji.emojiId,
                        reacted: emoji.reacted,
                        __typename: 'ReactionsSummaryForEmoji'
                    };
                    return null; // Return null for incomplete emoji data
                }) || [],
                // Provide empty array as fallback if the whole map operation is undefined
                __typename: 'ReactionsSummaryResponse'
            }
        }), [
        reactionsContentData
    ]);
    return {
        data: {
            authorName: spaceHoverPageCardResult?.singleContent?.history?.ownedBy?.displayName ?? undefined,
            authorAvatar: spaceHoverPageCardResult?.singleContent?.history?.ownedBy?.profilePicture?.path,
            reactionsCount: uniqueUsersCount,
            reactionsSummary: transformedReactionsSummary,
            reactedUsers: reactedUsers.data,
            userId: userId || undefined,
            activationId: activationId
        },
        loading: spaceHoverPageCardLoading || reactionsLoading || reactedUsers.loading,
        error: spaceHoverPageCardError || reactionsError || reactedUsers.error
    };
};


/**
 * @generated SignedSource<<bc3a084bfc2eed316fa9e2a440d02e87>>
 * @relayHash bac4a2c505ddb0928dcfd829d8b73cc2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a19c1f562c3d11c91bd9cdd93497d65e0a16577502386c1a6f1dae0f07f393a7
const $8f0c846bb639e51e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudIds",
            "variableName": "cloudIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "cloudId"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "hamsProductKey",
            "value": "confluence.ondemand"
        }
    ], v4 = {
        "args": [
            {
                "kind": "Literal",
                "name": "relationshipTypes",
                "value": "COLLECTION"
            }
        ],
        "concreteType": "CcpEntitlementRelationship",
        "kind": "LinkedField",
        "name": "relatesFromEntitlements",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "relationshipType"
            }
        ],
        "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCurrentPageTemplateDataTwcEligibilityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "alias": "confluenceEntitlementInfo",
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCurrentPageTemplateDataTwcEligibilityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "alias": "confluenceEntitlementInfo",
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "bac4a2c505ddb0928dcfd829d8b73cc2",
            "id": "a19c1f562c3d11c91bd9cdd93497d65e0a16577502386c1a6f1dae0f07f393a7",
            "metadata": {},
            "name": "useCurrentPageTemplateDataTwcEligibilityQuery",
            "operationKind": "query",
            "text": "query useCurrentPageTemplateDataTwcEligibilityQuery($cloudIds:[ID!]!){tenantContexts(cloudIds:$cloudIds){cloudId,confluenceEntitlementInfo:entitlementInfo(hamsProductKey:\"confluence.ondemand\"){__typename,...on CommerceEntitlementInfoCcp{entitlement{relatesFromEntitlements(relationshipTypes:\"COLLECTION\"){relationshipType},id}}}}}"
        }
    };
}();
$8f0c846bb639e51e$var$node.hash = "3657f0983787cc9196bfd162ed5af82a";
var $8f0c846bb639e51e$export$2e2bcd8739ae039 = $8f0c846bb639e51e$var$node;






var $6m3nS = parcelRequire("6m3nS");





var $fcGzf = parcelRequire("fcGzf");


var $kcIQr = parcelRequire("kcIQr");







var $iujy9 = parcelRequire("iujy9");














var $f7MuR = parcelRequire("f7MuR");

const $d929e2d623c6dbcd$export$c3f27a0a768c104a = 'twc_xflow_conf_meeting_pages_templates_reminder';
const $d929e2d623c6dbcd$export$783f3c94b6a1a499 = 'remind';
const $d929e2d623c6dbcd$export$daee443c5629dac6 = 'dismissed';
const $d929e2d623c6dbcd$export$63772118c24d0125 = ({ enabled: enabled })=>{
    const { data: data, loading: loading, error: error } = (0, $f7MuR.useSiteUserTraits)({
        skip: !enabled
    });
    if (!enabled) return {
        reminder: 'absent',
        error: null
    };
    if (loading) return {
        reminder: 'loading',
        error: null
    };
    if (error) return {
        reminder: 'error',
        error: error
    };
    const reminder = data?.attributes?.find(({ name: name })=>name === $d929e2d623c6dbcd$export$c3f27a0a768c104a);
    const reminderValue = reminder?.value;
    return {
        reminder: reminderValue === $d929e2d623c6dbcd$export$783f3c94b6a1a499 || reminderValue === $d929e2d623c6dbcd$export$daee443c5629dac6 ? reminderValue : reminder ? 'unexpected' : 'absent',
        error: null
    };
};


const $459457513b092e8e$export$afd4a1b9337ac2c2 = 'twcg-2112-template-view-trigger';
const $459457513b092e8e$export$54281e223bf51d14 = 'twcg-2112-template-applied-trigger';
const $459457513b092e8e$var$TEMPLATE_XFLOW_EXPERIMENT = 'twcg-2112-twc-xflow-conf-pages-templates';
const $459457513b092e8e$var$TEMPLATE_XFLOW_GATE = 'twcg-2112-twc-xflow-conf-pages-templates-gate';
const $459457513b092e8e$var$CurrentPageTemplateTwcEligibilityQuery = (0, $8f0c846bb639e51e$export$2e2bcd8739ae039);
const $459457513b092e8e$var$canonicalTemplateKeyBySourceTemplateEntityId = {
    ...Object.values((0, $fcGzf.CANONICAL_TEMPLATE_KEYS)).reduce((mapping, key)=>({
            ...mapping,
            [key]: key
        }), {}),
    'ec8ecc7e-7e4b-4f8a-aa3f-a6a7f2df4ac9': (0, $fcGzf.CANONICAL_TEMPLATE_KEYS).MEETING_NOTES,
    'f7a9afa1-19c0-4558-abd4-f8060829f9fc': (0, $fcGzf.CANONICAL_TEMPLATE_KEYS).PROJECT_PLAN,
    '6873d89c-765f-4677-b370-048005c7470b': (0, $fcGzf.CANONICAL_TEMPLATE_KEYS).EOW_STATUS_REPORT,
    '7edaef4a-329f-47c9-abfe-7e241c9e17ba': (0, $fcGzf.CANONICAL_TEMPLATE_KEYS).DECISIONS,
    'be29e5eb-fbe7-4213-b16f-5fb25b13f2d8': (0, $fcGzf.CANONICAL_TEMPLATE_KEYS).REQUIREMENTS_RACI,
    'f877653e-87e1-4654-a915-3591b3dd0db3': (0, $fcGzf.CANONICAL_TEMPLATE_KEYS).BUSINESS_STATUS_UPDATE,
    '7c19a101-d13e-4d67-870b-279e6342c6bc': (0, $fcGzf.CANONICAL_TEMPLATE_KEYS).RECURRING_MEETING_MINUTES,
    'a2484be7-df58-4f17-a347-2fecb7b22bb9': (0, $fcGzf.CANONICAL_TEMPLATE_KEYS).PROJECT_STATUS
};
const $459457513b092e8e$export$fdcffc4fc857301d = (sourceTemplateEntityId)=>sourceTemplateEntityId ? $459457513b092e8e$var$canonicalTemplateKeyBySourceTemplateEntityId[sourceTemplateEntityId] : undefined;
const $459457513b092e8e$var$isPaidEdition = (edition)=>edition === 'STANDARD' || edition === 'PREMIUM';
const $459457513b092e8e$export$c27570bca364b692 = ({ shouldCheck: shouldCheck, cloudId: cloudId, data: data, loading: loading, error: error })=>{
    if (!shouldCheck) return 'notRequested';
    if (!cloudId) return 'missing';
    if (loading) return 'loading';
    if (error) return 'failed';
    const tenantContext = data?.tenantContexts?.find((context)=>context?.cloudId === cloudId);
    const relatesFromEntitlements = tenantContext?.confluenceEntitlementInfo?.entitlement?.relatesFromEntitlements;
    if (!tenantContext || !relatesFromEntitlements) return 'missing';
    return relatesFromEntitlements.some((relationship)=>relationship?.relationshipType === 'COLLECTION') ? 'existingTwcCustomer' : 'eligible';
};
const $459457513b092e8e$export$cb06c0969c9f1bbb = ()=>{
    const { current: href } = (0, $5h1mk.usePostOfficeRoute)();
    const { contentId: contentId } = (0, $b765bc6fd36943f2$export$e2036a91fb26c8cf)(href ?? '');
    const { cloudId: cloudId, edition: edition, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const isTemplateXflowGateEnabled = (0, $9wGTI.fg)($459457513b092e8e$var$TEMPLATE_XFLOW_GATE);
    const { fireTrigger: fireTemplateViewTrigger } = (0, $6m3nS.useFirePostOfficeTrigger)({
        triggerId: $459457513b092e8e$export$afd4a1b9337ac2c2
    });
    const { fireTrigger: fireTemplateAppliedTrigger } = (0, $6m3nS.useFirePostOfficeTrigger)({
        triggerId: $459457513b092e8e$export$54281e223bf51d14
    });
    const [currentPageTemplateData, setCurrentPageTemplateData] = (0, $cozmU.useState)({
        contentId: contentId,
        blueprintModuleCompleteKey: undefined,
        isEligible: false
    });
    const [activeTemplateTrigger, setActiveTemplateTrigger] = (0, $cozmU.useState)();
    const [hasEvaluatedExperiment, setHasEvaluatedExperiment] = (0, $cozmU.useState)(false);
    const [isTerminallyDismissed, setIsTerminallyDismissed] = (0, $cozmU.useState)(false);
    const experimentEligibilityRef = (0, $cozmU.useRef)();
    const eligibilityAnalyticsKeyRef = (0, $cozmU.useRef)();
    const appliedTemplateContentIdRef = (0, $cozmU.useRef)();
    const hasPaidLicensedAccess = $459457513b092e8e$var$isPaidEdition(edition) && isLicensed;
    const exposedCurrentPageTemplateData = (0, $cozmU.useMemo)(()=>currentPageTemplateData.contentId === contentId ? currentPageTemplateData : {
            contentId: contentId,
            blueprintModuleCompleteKey: undefined,
            isEligible: false
        }, [
        contentId,
        currentPageTemplateData
    ]);
    const shouldCheckTwcEligibility = isTemplateXflowGateEnabled && Boolean(contentId) && hasPaidLicensedAccess && exposedCurrentPageTemplateData.blueprintModuleCompleteKey !== undefined;
    const { data: twcEligibilityData, loading: twcEligibilityLoading, error: twcEligibilityError } = (0, $jMyy4.useQueryInterop)($459457513b092e8e$var$CurrentPageTemplateTwcEligibilityQuery, {
        variables: {
            cloudIds: cloudId ? [
                cloudId
            ] : []
        },
        skip: !shouldCheckTwcEligibility || !cloudId,
        fetchPolicy: 'cache-first',
        interopApolloAggClient: true,
        __callerPackage__: "confluence-post-office-provider"
    });
    const twcEligibilityDecision = $459457513b092e8e$export$c27570bca364b692({
        shouldCheck: shouldCheckTwcEligibility,
        cloudId: cloudId,
        data: twcEligibilityData,
        loading: twcEligibilityLoading,
        error: twcEligibilityError
    });
    const evaluateExperimentForCurrentPage = (0, $cozmU.useCallback)(()=>{
        if (!contentId) return false;
        if (experimentEligibilityRef.current?.contentId === contentId) return experimentEligibilityRef.current.isVariation;
        const nextExperimentEligibilityState = {
            contentId: contentId,
            isVariation: (0, $6mKj3.expValEquals)($459457513b092e8e$var$TEMPLATE_XFLOW_EXPERIMENT, 'cohort', 'variation')
        };
        experimentEligibilityRef.current = nextExperimentEligibilityState;
        return nextExperimentEligibilityState.isVariation;
    }, [
        contentId
    ]);
    (0, $cozmU.useEffect)(()=>{
        const blueprintModuleCompleteKey = exposedCurrentPageTemplateData.blueprintModuleCompleteKey;
        const entryPoint = activeTemplateTrigger === 'view' ? 'templateView' : activeTemplateTrigger === 'applied' ? 'templateApplied' : undefined;
        const hasResolvedTwcEligibility = twcEligibilityDecision !== 'notRequested' && twcEligibilityDecision !== 'loading';
        if (isTemplateXflowGateEnabled && contentId && blueprintModuleCompleteKey && entryPoint && hasPaidLicensedAccess && hasResolvedTwcEligibility) {
            const experimentExposureRequested = !isTerminallyDismissed && twcEligibilityDecision === 'eligible';
            const analyticsKey = [
                contentId,
                blueprintModuleCompleteKey,
                entryPoint,
                twcEligibilityDecision,
                experimentExposureRequested
            ].join(':');
            if (eligibilityAnalyticsKeyRef.current !== analyticsKey) {
                eligibilityAnalyticsKeyRef.current = analyticsKey;
                createEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'decided',
                        actionSubject: 'twcTemplateXflowEligibility',
                        source: entryPoint,
                        attributes: {
                            blueprintModuleCompleteKey: blueprintModuleCompleteKey,
                            entryPoint: entryPoint,
                            experimentExposureRequested: experimentExposureRequested,
                            experimentKey: $459457513b092e8e$var$TEMPLATE_XFLOW_EXPERIMENT,
                            featureGateEnabled: isTemplateXflowGateEnabled,
                            hasPaidLicensedAccess: hasPaidLicensedAccess,
                            twcEligibilityDecision: twcEligibilityDecision
                        }
                    }
                }).fire();
            }
        }
        if (isTerminallyDismissed || !contentId || !blueprintModuleCompleteKey || twcEligibilityDecision !== 'eligible') {
            setCurrentPageTemplateData((current)=>current.isEligible ? {
                    ...current,
                    isEligible: false
                } : current);
            setHasEvaluatedExperiment(false);
            return;
        }
        const isVariation = evaluateExperimentForCurrentPage();
        setCurrentPageTemplateData((current)=>current.contentId === contentId && current.blueprintModuleCompleteKey === blueprintModuleCompleteKey ? {
                ...current,
                isEligible: isVariation
            } : current);
        setHasEvaluatedExperiment(true);
    }, [
        activeTemplateTrigger,
        contentId,
        createEvent,
        evaluateExperimentForCurrentPage,
        exposedCurrentPageTemplateData.blueprintModuleCompleteKey,
        hasPaidLicensedAccess,
        isTemplateXflowGateEnabled,
        isTerminallyDismissed,
        twcEligibilityDecision
    ]);
    const { reminder: reminderState } = (0, $d929e2d623c6dbcd$export$63772118c24d0125)({
        enabled: !isTerminallyDismissed && hasEvaluatedExperiment && twcEligibilityDecision === 'eligible' && exposedCurrentPageTemplateData.blueprintModuleCompleteKey !== undefined
    });
    const isTemplateXflowSuppressed = isTerminallyDismissed || reminderState === 'dismissed';
    (0, $cozmU.useEffect)(()=>{
        if (experimentEligibilityRef.current?.contentId !== contentId) {
            experimentEligibilityRef.current = undefined;
            eligibilityAnalyticsKeyRef.current = undefined;
        }
        if (appliedTemplateContentIdRef.current !== contentId) appliedTemplateContentIdRef.current = undefined;
        setCurrentPageTemplateData({
            contentId: contentId,
            blueprintModuleCompleteKey: undefined,
            isEligible: false
        });
        setActiveTemplateTrigger(undefined);
        setHasEvaluatedExperiment(false);
        if (!isTemplateXflowGateEnabled) return;
        if (!contentId || !hasPaidLicensedAccess) return;
        const subscription = (0, $iujy9.watchContentHeaderTemplateData)(contentId, (sourceTemplateEntityId)=>{
            if (appliedTemplateContentIdRef.current === contentId) return;
            const blueprintModuleCompleteKey = $459457513b092e8e$export$fdcffc4fc857301d(sourceTemplateEntityId);
            setCurrentPageTemplateData({
                contentId: contentId,
                blueprintModuleCompleteKey: blueprintModuleCompleteKey,
                isEligible: false
            });
            setActiveTemplateTrigger(blueprintModuleCompleteKey ? 'view' : undefined);
        });
        return ()=>{
            subscription.unsubscribe();
            fireTemplateViewTrigger({
                isActive: false
            });
            fireTemplateAppliedTrigger({
                isActive: false
            });
        };
    }, [
        contentId,
        fireTemplateAppliedTrigger,
        fireTemplateViewTrigger,
        hasPaidLicensedAccess,
        isTemplateXflowGateEnabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isTemplateXflowGateEnabled) return;
        fireTemplateViewTrigger({
            isActive: hasEvaluatedExperiment && twcEligibilityDecision === 'eligible' && activeTemplateTrigger === 'view' && !isTemplateXflowSuppressed
        });
        fireTemplateAppliedTrigger({
            isActive: hasEvaluatedExperiment && twcEligibilityDecision === 'eligible' && activeTemplateTrigger === 'applied' && !isTemplateXflowSuppressed
        });
    }, [
        activeTemplateTrigger,
        fireTemplateAppliedTrigger,
        fireTemplateViewTrigger,
        hasEvaluatedExperiment,
        isTemplateXflowGateEnabled,
        isTemplateXflowSuppressed,
        twcEligibilityDecision
    ]);
    const onTemplateApplied = (0, $cozmU.useCallback)((blueprintModuleCompleteKey)=>{
        if (!isTemplateXflowGateEnabled) return;
        if (!contentId || !hasPaidLicensedAccess) {
            setActiveTemplateTrigger(undefined);
            setCurrentPageTemplateData({
                contentId: contentId,
                blueprintModuleCompleteKey: undefined,
                isEligible: false
            });
            return;
        }
        const canonicalTemplateKey = $459457513b092e8e$export$fdcffc4fc857301d(blueprintModuleCompleteKey);
        appliedTemplateContentIdRef.current = contentId;
        setActiveTemplateTrigger(canonicalTemplateKey ? 'applied' : undefined);
        setCurrentPageTemplateData({
            contentId: contentId,
            blueprintModuleCompleteKey: canonicalTemplateKey,
            isEligible: false
        });
    }, [
        contentId,
        hasPaidLicensedAccess,
        isTemplateXflowGateEnabled
    ]);
    const dismissForSession = (0, $cozmU.useCallback)(()=>{
        setIsTerminallyDismissed(true);
        fireTemplateViewTrigger({
            isActive: false
        });
        fireTemplateAppliedTrigger({
            isActive: false
        });
    }, [
        fireTemplateAppliedTrigger,
        fireTemplateViewTrigger
    ]);
    return (0, $cozmU.useMemo)(()=>({
            currentPageTemplateData: exposedCurrentPageTemplateData,
            twcEligibilityDecision: twcEligibilityDecision,
            reminderState: reminderState,
            isTerminallyDismissed: isTerminallyDismissed,
            dismissForSession: dismissForSession,
            onTemplateApplied: onTemplateApplied
        }), [
        dismissForSession,
        exposedCurrentPageTemplateData,
        isTerminallyDismissed,
        onTemplateApplied,
        reminderState,
        twcEligibilityDecision
    ]);
};



const $a730e736ff2c0fdb$var$TwcXflowModal = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ynFaa",
    name: "TwcXflowModal",
    loader: async ()=>(await (parcelRequire("lh7DM"))).default
});
const $a730e736ff2c0fdb$export$50c48a5a1548e4da = ({ children: children })=>{
    const { userId: userId, cloudId: cloudId, locale: locale, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const currentPageTemplateData = (0, $459457513b092e8e$export$cb06c0969c9f1bbb)();
    const [modalSourceContext, setModalSourceContext] = (0, $cozmU.useState)();
    const openTwcXflowModal = (0, $cozmU.useCallback)((sourceContext)=>{
        setModalSourceContext(sourceContext);
    }, []);
    const closeTwcXflowModal = (0, $cozmU.useCallback)(()=>setModalSourceContext(undefined), []);
    const templateXflow = (0, $cozmU.useMemo)(()=>({
            ...currentPageTemplateData,
            openTwcXflowModal: openTwcXflowModal
        }), [
        currentPageTemplateData,
        openTwcXflowModal
    ]);
    const experimentsContextValue = (0, $cozmU.useMemo)(()=>{
        return {
            templateXflow: templateXflow,
            usePageRecommendationData: $19a192258e8db8bc$export$1d93f080b8c40251,
            useInlineReactionsData: $f95c9b8c12af7d64$export$a35f2f61e0cb4308,
            getPageDataFromUrl: $b765bc6fd36943f2$export$e2036a91fb26c8cf,
            emojiProvider: (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
                userId: userId,
                cloudId: cloudId
            })
        };
    }, [
        userId,
        cloudId,
        templateXflow
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5nuFe.ConfluenceExperimentsContext).Provider, {
        value: experimentsContextValue
    }, children, cloudId && modalSourceContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a730e736ff2c0fdb$var$TwcXflowModal, {
        cloudId: cloudId,
        locale: locale,
        onClose: closeTwcXflowModal,
        orgId: orgId ?? undefined,
        sourceComponent: (0, $7Px0t.SOURCE_COMPONENT).TWC_XFLOW_CONFLUENCE_TEMPLATE,
        sourceContext: modalSourceContext
    }) : null);
};






var $3d3WW = parcelRequire("3d3WW");




const $f6be7463febe9936$var$GASV3_DWELL_TRIGGER_TIME = 40000; // ms
const $f6be7463febe9936$var$PO_DWELL_TRIGGER_TIME = 60000; // ms
const $f6be7463febe9936$export$2855524b2284c48 = ({ children: children })=>{
    const { fireTrigger: fireTrigger } = (0, $6m3nS.useFirePostOfficeTrigger)({
        triggerId: 'confluence-page-dwelled'
    });
    const onEvent = (0, $cozmU.useCallback)((event)=>{
        if (event.payload?.data?.action === 'dwelled' && event.payload?.data?.actionSubject === 'page') {
            const dwellTime = event.payload.data.attributes?.dwellTime;
            // Dwell events are triggered at 5, 10, 20, 40, 80s, but we want 60s
            if (event.payload.data.attributes?.finalDwellEvent) fireTrigger({
                isActive: false
            });
            else if (dwellTime && dwellTime >= $f6be7463febe9936$var$GASV3_DWELL_TRIGGER_TIME && dwellTime <= $f6be7463febe9936$var$PO_DWELL_TRIGGER_TIME) fireTrigger({
                isActive: true
            });
        }
    }, [
        fireTrigger
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: onEvent,
        channel: "*"
    }, children);
};


const $074500c4d6f25c0d$var$ConfluencePostOfficeProvider = ({ children: children })=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId, environment: environment, locale: locale, orgId: orgId, edition: edition } = (0, $bQm3c.useSessionData)();
    const context = (0, $cozmU.useMemo)(()=>({
            current: (0, $0VKZa.sessionToPostOfficeContext)({
                accessStatus: accessStatus,
                activationId: activationId,
                cloudId: cloudId,
                locale: locale,
                orgId: orgId,
                edition: edition
            })
        }), [
        activationId,
        cloudId,
        accessStatus,
        locale,
        orgId,
        edition
    ]);
    const env = (0, $cozmU.useMemo)(()=>({
            env: (0, $0VKZa.transformConfluenceEnvToPostOfficeEnvironment)(environment)
        }), [
        environment
    ]);
    const analyticsClientInstance = (0, $cozmU.useMemo)(()=>(0, $04e9M.getAnalyticsWebClient)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8sZwv.PostOfficeProvider), {
        context: context,
        environment: env,
        analyticsClientInstance: analyticsClientInstance
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f6be7463febe9936$export$2855524b2284c48), null, children));
};
const $074500c4d6f25c0d$export$fb465b6e855c1e85 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($074500c4d6f25c0d$var$ConfluencePostOfficeProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a730e736ff2c0fdb$export$50c48a5a1548e4da), null, children));
};
const $074500c4d6f25c0d$var$ConfluenceRouterListener = ({ children: children })=>{
    const routeContext = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    (0, $l08Du.usePostOfficeRouteUpdate)([
        routeContext.getHref() ?? '',
        routeContext.match?.name ?? ''
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
const $074500c4d6f25c0d$export$9f8d3084fd3d5fc0 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($074500c4d6f25c0d$var$ConfluenceRouterListener, null, children);
};







var $lonEO = parcelRequire("lonEO");


var $kZDrw = parcelRequire("kZDrw");


var $1kHsc = parcelRequire("1kHsc");


var $fGzMp = parcelRequire("fGzMp");


var $f7i8j = parcelRequire("f7i8j");


var $jVK0t = parcelRequire("jVK0t");





var $aDyoj = parcelRequire("aDyoj");







// Data Plugin definition and utility types
const $5cab8e2303c72867$export$a235a73f7b906dce = {
    GetContainers: 'GetContainers',
    GetUsers: 'GetUsers',
    GetSuggestedSiteNames: 'GetSuggestedSiteNames',
    GetAvailableSites: 'GetAvailableSites'
};
const $5cab8e2303c72867$export$6e383182a26455ff = {
    BITBUCKET_WORKSPACE: 'bitbucket-workspace',
    ATLASSIAN_CLOUD_ID: 'ATLASSIAN_CLOUD_ID',
    JIRA_SOFTWARE_PROJECT: 'JIRA_SOFTWARE_PROJECT'
};
const $5cab8e2303c72867$export$e391bab95adb8396 = {
    ATLASSIAN_ACCOUNT_ID: 'ATLASSIAN_ACCOUNT_ID',
    TRELLO_ID: 'TRELLO_ID'
};
const $5cab8e2303c72867$export$4f378ba35c571906 = {
    JIRA_BUSINESS: 'JIRA_BUSINESS',
    JIRA_SERVICE_DESK: 'JIRA_SERVICE_DESK',
    JIRA_SOFTWARE: 'JIRA_SOFTWARE',
    CONFLUENCE: 'CONFLUENCE',
    OPSGENIE: 'OPSGENIE',
    BITBUCKET: 'BITBUCKET',
    STATUSPAGE: 'STATUSPAGE',
    TRELLO: 'TRELLO',
    COMPASS: 'COMPASS'
};



const $62c03eaa9b0b743b$export$76378b0f825c024c = (fetch)=>{
    return [
        (0, $5cab8e2303c72867$export$a235a73f7b906dce).GetContainers,
        fetch
    ];
};
const $62c03eaa9b0b743b$export$8feb7eae83cf8cd5 = (fetch)=>{
    return [
        (0, $5cab8e2303c72867$export$a235a73f7b906dce).GetUsers,
        fetch
    ];
};
const $62c03eaa9b0b743b$export$21d120847be2aff4 = (fetch)=>{
    return [
        (0, $5cab8e2303c72867$export$a235a73f7b906dce).GetSuggestedSiteNames,
        fetch
    ];
};
const $62c03eaa9b0b743b$export$d7c1699c6a2ca18a = (fetch)=>{
    return [
        (0, $5cab8e2303c72867$export$a235a73f7b906dce).GetAvailableSites,
        fetch
    ];
};






var $fKdEy = parcelRequire("fKdEy");

function $3dc98590eeed1246$var$hasSiteSettings(data) {
    return data && typeof data === 'object' && data['siteSettings'] && data['tenant'];
}
const $3dc98590eeed1246$var$getCloudId = async ()=>{
    const { data: data } = await (0, $c0rhi.queryInterop)({
        query: (0, $fKdEy.default),
        __callerPackage__: "cross-flow"
    });
    const containers = [];
    if ($3dc98590eeed1246$var$hasSiteSettings(data)) {
        const { siteTitle: siteTitle } = data.siteSettings;
        const tenantId = data.tenant.cloudId;
        containers.push({
            id: tenantId,
            displayName: siteTitle,
            type: (0, $5cab8e2303c72867$export$6e383182a26455ff).ATLASSIAN_CLOUD_ID
        });
    }
    return {
        type: (0, $5cab8e2303c72867$export$6e383182a26455ff).ATLASSIAN_CLOUD_ID,
        containers: containers
    };
};
const $3dc98590eeed1246$export$81d1d40061d190bc = (0, $62c03eaa9b0b743b$export$76378b0f825c024c)($3dc98590eeed1246$var$getCloudId);






const $c394a569c7bfdabb$var$getUsers = async (containerId)=>{
    const getUsersUrl = `/gateway/api/xflow/${containerId}/fetch-instance-users`;
    try {
        const response = await (0, $f7B1p.cfetch)(getUsersUrl, {
            credentials: 'same-origin'
        });
        if (response.ok) {
            const data = await response.json();
            return data.map((value)=>({
                    idType: (0, $5cab8e2303c72867$export$e391bab95adb8396).ATLASSIAN_ACCOUNT_ID,
                    id: value.id,
                    displayName: value.displayName
                }));
        }
        throw new Error(`Unexpected response from ${getUsersUrl} ${response.status} ${response.statusText}`);
    } catch (error) {
        throw new Error(`Unable to fetch ${getUsersUrl} ${error.message}`);
    }
};
const $c394a569c7bfdabb$export$7c44908d2777db01 = (0, $62c03eaa9b0b743b$export$8feb7eae83cf8cd5)($c394a569c7bfdabb$var$getUsers);


const $70d683a301b7be27$export$d900e4062895cd7c = ({ children: children })=>{
    const { cloudId: cloudId, locale: locale } = (0, $bQm3c.useSessionData)();
    const analyticWebClient = (0, $cozmU.useMemo)(()=>(0, $04e9M.getAnalyticsWebClient)(), []);
    const isMarketingOptOut = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("meta[name='ajs-marketing-opt-out']")?.getAttribute('content') === 'true';
    if (isMarketingOptOut) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aDyoj.default), {
        cloudId: cloudId,
        analyticsClient: analyticWebClient,
        locale: locale,
        plugins: [
            (0, $c394a569c7bfdabb$export$7c44908d2777db01),
            (0, $3dc98590eeed1246$export$81d1d40061d190bc)
        ]
    }, children);
};



var $fcF01 = parcelRequire("fcF01");


var $d5ap9 = parcelRequire("d5ap9");


var $1ytiN = parcelRequire("1ytiN");





var $3ricL = parcelRequire("3ricL");


var $lsxnT = parcelRequire("lsxnT");











var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $hSHWm = parcelRequire("hSHWm");





const $639a6e255dabf06b$export$96cfefeef4383728 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "mA5-d",
    name: "CoreInvitesLoadable",
    loader: async ()=>(await (parcelRequire("5tvD8"))).CoreInvites
});



var $koZ31 = parcelRequire("koZ31");







const $8855e66edaf78755$var$INVITE_DIALOG_PARAM = 'inviteDialog';
const $8855e66edaf78755$var$getOpenModalParam = ()=>{
    return new URLSearchParams(window.location.search.substring(1)).get($8855e66edaf78755$var$INVITE_DIALOG_PARAM) || '';
};
function $8855e66edaf78755$export$fd22f9b0c5d723c2(openCoreInvites) {
    (0, $cozmU.useEffect)(()=>{
        if (!window) return;
        if ($8855e66edaf78755$var$getOpenModalParam() !== 'open') return;
        openCoreInvites((0, $koZ31.CoreInvitesSource).OPEN_MODAL_QUERY_PARAM);
        // remove the query param from the URL without reloading the page
        const url = new URL(window.location.href);
        url.searchParams.delete($8855e66edaf78755$var$INVITE_DIALOG_PARAM);
        window.history.replaceState({}, document.title, url.toString());
    }, [
        openCoreInvites
    ]);
}


const $685338b3d2a4b0a3$var$noop = ()=>{
    return undefined;
};
function $685338b3d2a4b0a3$export$2e865a7ec399eb55({ children: children }) {
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [initialInvitees, setInitialInvitees] = (0, $cozmU.useState)([]);
    const [source, setSource] = (0, $cozmU.useState)((0, $koZ31.CoreInvitesSource).UNKNOWN);
    const [showSpotlight, setShowSpotlight] = (0, $cozmU.useState)(false);
    const [productContext, setProductContext] = (0, $cozmU.useState)(undefined);
    const [touchpoint, setTouchpoint] = (0, $cozmU.useState)(undefined);
    const stablePropsRef = (0, $cozmU.useRef)({
        onInviteCompleted: $685338b3d2a4b0a3$var$noop,
        onModalClose: $685338b3d2a4b0a3$var$noop
    });
    const { useChoreographer: useChoreographer } = (0, $lsxnT.useChoreographerAssets)();
    const contextualInviteNudgeChoreographer = useChoreographer('cc-contextual-invite-nudge', {
        start: ()=>setShowSpotlight(true),
        stop: ()=>setShowSpotlight(false)
    });
    const { orgId: orgId } = (0, $bQm3c.useSessionData)();
    const handleModalOpen = (0, $cozmU.useCallback)((touchPoint, { onModalClosed: onModalClosed = $685338b3d2a4b0a3$var$noop, onInviteCompleted: onInviteCompleted = $685338b3d2a4b0a3$var$noop, getContextualInviteNudgeProps: getContextualInviteNudgeProps } = {}, initialInvitees = [], productContextMetadata, enablementTouchpoint)=>{
        setInitialInvitees(initialInvitees);
        setSource(touchPoint || (0, $koZ31.CoreInvitesSource).UNKNOWN);
        setProductContext(productContextMetadata);
        setTouchpoint(enablementTouchpoint);
        stablePropsRef.current.onModalClose = onModalClosed;
        stablePropsRef.current.onInviteCompleted = onInviteCompleted;
        setIsOpen(true);
        const shouldShow = getContextualInviteNudgeProps?.()?.showSpotlight;
        if (shouldShow) contextualInviteNudgeChoreographer.startMessage();
    }, [
        contextualInviteNudgeChoreographer,
        setInitialInvitees,
        setSource,
        setIsOpen
    ]);
    const handleModalClose = (0, $cozmU.useCallback)(()=>{
        setSource((0, $koZ31.CoreInvitesSource).UNKNOWN);
        setProductContext(undefined);
        setTouchpoint(undefined);
        // remember the current value for later invocation, since we're about to override it
        const onClosed = stablePropsRef.current.onModalClose;
        stablePropsRef.current.onModalClose = $685338b3d2a4b0a3$var$noop;
        stablePropsRef.current.onInviteCompleted = $685338b3d2a4b0a3$var$noop;
        setIsOpen(false);
        onClosed();
        contextualInviteNudgeChoreographer.stopMessage();
    }, [
        contextualInviteNudgeChoreographer,
        setSource,
        setIsOpen
    ]);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const failExperienceOnError = (0, $cozmU.useCallback)((error)=>{
        experienceTracker.stopOnError({
            name: (0, $irVI7.CORE_INVITES_EXPERIENCE),
            error: error
        });
    }, [
        experienceTracker
    ]);
    const isInvitationsEnabled = (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-invitations');
    const coreInviteContext = (0, $cozmU.useMemo)(()=>({
            openCoreInvites: isInvitationsEnabled ? handleModalOpen : undefined
        }), [
        handleModalOpen,
        isInvitationsEnabled
    ]);
    const displayInfiSpotlight = true;
    const inviteCompletedHandler = (0, $cozmU.useCallback)((result)=>{
        stablePropsRef.current.onInviteCompleted(result);
    }, [
        stablePropsRef
    ]);
    (0, $8855e66edaf78755$export$fd22f9b0c5d723c2)(isInvitationsEnabled ? handleModalOpen : $685338b3d2a4b0a3$var$noop);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSHWm.CoreInvitesContext).Provider, {
        value: coreInviteContext
    }, children, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH,
        onError: failExperienceOnError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $639a6e255dabf06b$export$96cfefeef4383728), {
        initialInvitees: initialInvitees,
        onSendHandler: handleModalClose,
        onCancelHandler: handleModalClose,
        onInviteCompletedHandler: inviteCompletedHandler,
        source: source,
        orgId: orgId,
        displayInfiSpotlight: displayInfiSpotlight,
        showSpotlight: showSpotlight,
        experimentalProductContext: productContext,
        touchpoint: touchpoint
    })));
}



var $hrAmX = parcelRequire("hrAmX");


var $bJX6u = parcelRequire("bJX6u");


var $ktUCG = parcelRequire("ktUCG");


var $brNvA = parcelRequire("brNvA");


var $cryCi = parcelRequire("cryCi");


var $fN9wG = parcelRequire("fN9wG");


var $97W74 = parcelRequire("97W74");








var $1i7uI = parcelRequire("1i7uI");





var $dBmJE = parcelRequire("dBmJE");


var $eXODy = parcelRequire("eXODy");


var $iV00x = parcelRequire("iV00x");


var $kCeSx = parcelRequire("kCeSx");


var $gtMdU = parcelRequire("gtMdU");








var $1hQ0e = parcelRequire("1hQ0e");





function $c321319b844a3888$export$4d0b2e184ba12ee7(targetDocument, attribute, controllers) {
    const existingController = controllers.get(targetDocument);
    if (existingController) {
        existingController.references += 1;
        let isReleased = false;
        return ()=>{
            if (isReleased) return;
            isReleased = true;
            existingController.references -= 1;
            if (existingController.references === 0) {
                existingController.release();
                controllers.delete(targetDocument);
            }
        };
    }
    const rootElement = targetDocument.documentElement;
    const controller = {
        references: 1,
        release: ()=>rootElement.removeAttribute(attribute)
    };
    rootElement.setAttribute(attribute, '');
    controllers.set(targetDocument, controller);
    let isReleased = false;
    return ()=>{
        if (isReleased) return;
        isReleased = true;
        controller.references -= 1;
        if (controller.references === 0) {
            controller.release();
            controllers.delete(targetDocument);
        }
    };
}


const $2eb847c66780bfc8$var$controllers = new WeakMap();
function $2eb847c66780bfc8$export$f289ecff4a99e09d(targetDocument) {
    return (0, $c321319b844a3888$export$4d0b2e184ba12ee7)(targetDocument, (0, $08436a2f9d11149e$export$cc97c2566f53fd12), $2eb847c66780bfc8$var$controllers);
}




const $5d828ff9d8b1e796$var$controllers = new WeakMap();
function $5d828ff9d8b1e796$export$9fc37946dc3c0ebd(targetDocument) {
    return (0, $c321319b844a3888$export$4d0b2e184ba12ee7)(targetDocument, (0, $08436a2f9d11149e$export$61a626af8f32e59e), $5d828ff9d8b1e796$var$controllers);
}


const $10fd4e7f95cabba0$export$6a82770d3a3903f7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useScrollbarHarmonisation(isEnabled) {
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $iDrrr.fg)("platform_dst_scrollbar_harmonisation");
        $[0] = t0;
    } else t0 = $[0];
    const isGateEnabled = t0;
    const shouldEnable = isEnabled ?? isGateEnabled;
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $iDrrr.fg)("platform_dst_scrollbar_harmonisation_transparent");
        $[1] = t1;
    } else t1 = $[1];
    const isTransparentTrackGateEnabled = t1;
    const shouldUseTransparentTrack = isGateEnabled && isTransparentTrackGateEnabled;
    let t2;
    let t3;
    if ($[2] !== shouldEnable) {
        t2 = ()=>{
            if (!shouldEnable) return;
            const targetDocument = (0, $1hQ0e.getDocument)();
            if (!targetDocument) return;
            const cleanupHarmonisation = (0, $2eb847c66780bfc8$export$f289ecff4a99e09d)(targetDocument);
            const cleanupTransparentTrack = shouldUseTransparentTrack ? (0, $5d828ff9d8b1e796$export$9fc37946dc3c0ebd)(targetDocument) : undefined;
            return ()=>{
                cleanupTransparentTrack?.();
                cleanupHarmonisation();
            };
        };
        t3 = [
            shouldEnable,
            shouldUseTransparentTrack
        ];
        $[2] = shouldEnable;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $cozmU.useEffect)(t2, t3);
} : function useScrollbarHarmonisation(isEnabled) {
    const isGateEnabled = (0, $iDrrr.fg)('platform_dst_scrollbar_harmonisation');
    const shouldEnable = isEnabled ?? isGateEnabled;
    const isTransparentTrackGateEnabled = (0, $iDrrr.fg)('platform_dst_scrollbar_harmonisation_transparent');
    const shouldUseTransparentTrack = isGateEnabled && isTransparentTrackGateEnabled;
    (0, $cozmU.useEffect)(()=>{
        if (!shouldEnable) return;
        const targetDocument = (0, $1hQ0e.getDocument)();
        if (!targetDocument) return;
        const cleanupHarmonisation = (0, $2eb847c66780bfc8$export$f289ecff4a99e09d)(targetDocument);
        const cleanupTransparentTrack = shouldUseTransparentTrack ? (0, $5d828ff9d8b1e796$export$9fc37946dc3c0ebd)(targetDocument) : undefined;
        return ()=>{
            cleanupTransparentTrack?.();
            cleanupHarmonisation();
        };
    }, [
        shouldEnable,
        shouldUseTransparentTrack
    ]);
};



var $gXfti = parcelRequire("gXfti");


var $7SkLu = parcelRequire("7SkLu");






var $aXWtB = parcelRequire("aXWtB");





var $kSwu1 = parcelRequire("kSwu1");








var $7aRa9 = parcelRequire("7aRa9");


var $gLUd5 = parcelRequire("gLUd5");











var $gEtAQ = parcelRequire("gEtAQ");


var $jlIaF = parcelRequire("jlIaF");








var $i1t43 = parcelRequire("i1t43");

const $b59268334a98f13b$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    genericSSRErrorFlagReason: {
        id: "ssr-render-failure-notification.flag.generic.message",
        defaultMessage: "Reason: {reason}. "
    },
    branchDeployErrorFlagReason: {
        id: "ssr-render-failure-notification.flag.branch.deploy.message",
        defaultMessage: "Possible outdated branch deploy detected. Your PR changes might not be tested against SSR accurately. "
    },
    runbookLink: {
        id: "ssr-render-failure-notification.runbook.link",
        defaultMessage: "See <runbookLink>this page</runbookLink> for information on how to debug this failure."
    }
});
const $b59268334a98f13b$var$BRANCH_DEPLOY_RUNBOOK_LINK = `https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4898451942/Branch+Deploys`;
const $b59268334a98f13b$var$GENERIC_SSR_FAILURE_RUNBOOK_LINK = `https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4911008649/SSR+Render+Failures`;
const $b59268334a98f13b$export$487f09dcd3f678bf = ({ ssrErrors: ssrErrors, isBranchDeployFailure: isBranchDeployFailure })=>{
    const runbookLink = isBranchDeployFailure ? $b59268334a98f13b$var$BRANCH_DEPLOY_RUNBOOK_LINK : $b59268334a98f13b$var$GENERIC_SSR_FAILURE_RUNBOOK_LINK;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": "flagErrorMessage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, isBranchDeployFailure ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $b59268334a98f13b$export$a7357cdd1f0b0168.branchDeployErrorFlagReason) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$b59268334a98f13b$export$a7357cdd1f0b0168.genericSSRErrorFlagReason,
        values: {
            reason: ssrErrors[0]
        }
    })), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$b59268334a98f13b$export$a7357cdd1f0b0168.runbookLink,
        values: {
            runbookLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    target: "_blank",
                    href: runbookLink
                }, chunks)
        }
    }));
};











const $5e5853def1ddf657$var$i18n = (0, $kSwu1.defineMessages)({
    hydrationErrorMessage: {
        id: "ssr-render-failure-notification.hydration.flag.message",
        defaultMessage: "To view the hydration mismatches, refer to window.__HYDRATION_ERRORS__ in the browser console."
    },
    runbookLink: {
        id: "ssr-render-failure-notification.hydration.runbook.link",
        defaultMessage: "See <runbookLink>this page</runbookLink> for information on how to debug the mismatches."
    }
});
const $5e5853def1ddf657$export$7922b21049d03e3b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": "flagErrorMessage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $5e5853def1ddf657$var$i18n.hydrationErrorMessage)), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$5e5853def1ddf657$var$i18n.runbookLink,
        values: {
            runbookLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    target: "_blank",
                    href: "https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4848884799/Debugging+Hydration+Mismatches"
                }, chunks)
        }
    }));
};


const $008c5cd8cb4c3a95$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    ssrRenderErrorFlagTitle: {
        id: "ssr-render-failure-notification.flag",
        defaultMessage: "This page was NOT SSR RENDERED!"
    },
    hydrationErrorFlagTitle: {
        id: "ssr-render-failure-notification.hydration.flag",
        defaultMessage: "This page was NOT HYDRATED PROPERLY!"
    }
});
const $008c5cd8cb4c3a95$export$475a1abe7cf690a3 = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const hasShownErrorFlagRef = (0, $cozmU.useRef)(false);
    const { environment: environment } = (0, $bQm3c.useSessionData)();
    // we want to exclude testing environments and pollinator tenants from showing the error flag
    const isTestEnvironment = (0, $1xpoY.default).isKillSwitchOn('confluence_frontend_ssr_failure_notification');
    // We only want to show the error flag in the dev/staging environment
    // however, branch deploys on production will default to process.env.CLOUD_ENV = 'branch'
    const isStagingEnvironment = // @ts-expect-error - ts(2345) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    [
        'dev',
        'branch',
        'staging',
        'stg-fedm'
    ].includes("production") && environment !== 'PRODUCTION';
    (0, $cozmU.useEffect)(()=>{
        if (!isStagingEnvironment || isTestEnvironment) return;
        // regex to match /spaces/:spaceKey/blogs (blogs overview)
        const blogsOverviewRegex = new RegExp(`^${(0, $jlIaF.CONTEXT_PATH)}/spaces/[^/]+/blogs$`);
        // Helper function to determine if we should skip error checking for certain paths
        const isAllowedPath = (pathname)=>{
            return (0, $gEtAQ.isHomePage)() || (0, $gEtAQ.isViewPage)() || (0, $gEtAQ.isSpaceOverview)() || (0, $gEtAQ.isBlogPage)() || (0, $gEtAQ.isWhiteboard)() || (0, $gEtAQ.isDatabase)() || Boolean((0, $1NBp8.EDIT_PAGE).match(pathname)) || Boolean((0, $1NBp8.EDIT_PAGE_V2).match(pathname)) || Boolean((0, $1NBp8.EDIT_BLOG).match(pathname)) || Boolean((0, $1NBp8.EDIT_BLOG_V2).match(pathname)) || Boolean((0, $1NBp8.EDIT_PAGE_EMBED).match(pathname)) || Boolean(blogsOverviewRegex.test(pathname)) || Boolean((0, $1NBp8.COMPANY_HUB).match(pathname)) || Boolean((0, $1NBp8.COMPANY_HUB_EDIT).match(pathname)) || Boolean((0, $1NBp8.EMBED_VIEW).match(pathname)) || Boolean((0, $1NBp8.EDIT_PAGE_SMART_CREATE).match(pathname)) || Boolean('/'.match(pathname));
        };
        if (isAllowedPath(window.location.pathname)) {
            const showHydrationError = ()=>{
                if (!hasShownErrorFlagRef.current) {
                    flags.showErrorFlag({
                        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $008c5cd8cb4c3a95$export$a7357cdd1f0b0168.hydrationErrorFlagTitle),
                        isAutoDismiss: false,
                        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5e5853def1ddf657$export$7922b21049d03e3b), null)
                    });
                    hasShownErrorFlagRef.current = true;
                }
            };
            if ((0, $1xpoY.default).getBoolean('confluence_frontend_hydration_error_event', false)) window.addEventListener('hydrationError', showHydrationError);
            // sometimes errors exist but the page is still SSRd successfully - we don't want to show the SSR render error flag in this case
            if (window.__SSR_RENDERED__) {
                // if the page is SSRd successfully we check if the page was hydrated successfully, and show a hydration error flag if not
                if (window.__HYDRATION_FAILED__) showHydrationError();
                return ()=>{
                    window.removeEventListener('hydrationError', showHydrationError);
                };
            }
            // COMPILED dev warnings show up on every SSRd page even if the page is SSRd successfully,
            // so we need to filter them out to distinguish from actual errors being reported for local dev ssr
            const ssrErrors = window.__SSR_ERROR__?.filter((err)=>!err.includes('DEV WARNING')) ?? [];
            // on old branch deploys, ssr errors can still be empty but the page might not be SSRd successfully
            const isBranchDeployFailure = (0, $gLUd5.isBranchDeployFn)() && !window.__SSR_RENDERED__ && !ssrErrors?.length;
            if (!hasShownErrorFlagRef.current && (isBranchDeployFailure || ssrErrors.length)) {
                flags.showErrorFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $008c5cd8cb4c3a95$export$a7357cdd1f0b0168.ssrRenderErrorFlagTitle),
                    isAutoDismiss: false,
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b59268334a98f13b$export$487f09dcd3f678bf), {
                        ssrErrors: ssrErrors,
                        isBranchDeployFailure: isBranchDeployFailure
                    })
                });
                hasShownErrorFlagRef.current = true;
            }
            return ()=>{
                window.removeEventListener('hydrationError', showHydrationError);
            };
        }
    }, [
        isStagingEnvironment,
        flags,
        isTestEnvironment
    ]);
    return null;
});
const $008c5cd8cb4c3a95$export$4e5ff544be3ec09b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($008c5cd8cb4c3a95$export$475a1abe7cf690a3, null));
};



var $iJELi = parcelRequire("iJELi");


var $8n9tL = parcelRequire("8n9tL");


var $4o1RV = parcelRequire("4o1RV");


var $aFbGo = parcelRequire("aFbGo");


var $64KID = parcelRequire("64KID");











var $4PPzL = parcelRequire("4PPzL");


var $5q601 = parcelRequire("5q601");










const $e7cb2c525109c7cf$var$MIN_LONG_TASK_DURATION = 50;
const $e7cb2c525109c7cf$export$de3c307012927947 = (start, stop, idleThreshold, buffer)=>{
    const entires = buffer.getAll().filter((entry)=>entry.duration >= $e7cb2c525109c7cf$var$MIN_LONG_TASK_DURATION).map((entry)=>({
            start: entry.startTime,
            stop: entry.startTime + entry.duration
        })).filter((entry)=>entry.stop > start && entry.start < stop).concat([
        // Add a fake entry to simplify the logic below
        {
            start: stop,
            stop: stop
        }
    ]).sort((a, b)=>a.start - b.start);
    let lastStop = start;
    for (const entry of entires){
        if (lastStop + idleThreshold < entry.start) return lastStop;
        lastStop = entry.stop;
    }
    return null;
};









var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $682a207fed74bf66$export$e49353726941624a = (0, $lSOAM.createConcurrentCustomMetric)({
    key: (0, $fd6g2.TIME_TO_APP_IDLE_KEY)
});



const $f6158bccfa436061$var$IDLE_THRESHOLD = 3000;
const $f6158bccfa436061$var$RETRY_INTERVAL = $f6158bccfa436061$var$IDLE_THRESHOLD * 2;
const $f6158bccfa436061$var$TIMEOUT_INTERVAL = 300000; // 5 minutes
const $f6158bccfa436061$var$PERFORMANCE_OBSERVER_LATENCY_ADJUSTMENT = 1000;
const $f6158bccfa436061$var$performance = window.performance;
const $f6158bccfa436061$var$delay = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $f6158bccfa436061$var$wainNextIdle = ()=>{
    // eslint-disable-next-line compat/compat -- This has a fallback to requestAnimationFrame if requestIdleCallback is unsupported.
    const onIdleCallback = window.requestIdleCallback || window.requestAnimationFrame;
    const cancelCallback = (id)=>{
        if (onIdleCallback === window.requestIdleCallback) window.cancelIdleCallback(id);
        else window.cancelAnimationFrame(id);
    };
    return new Promise((resolve)=>{
        const callbackId = onIdleCallback(()=>{
            cancelCallback(callbackId);
            resolve();
        });
    });
};
const $f6158bccfa436061$export$560b992b8a813cfb = /*#__PURE__*/ (0, $cozmU.memo)(({})=>{
    const routes = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const routeName = routes.match?.name || '';
    const contentId = routes.match?.params?.contentId || '';
    const transitionId = routes.transitionId || 0;
    (0, $cozmU.useEffect)(()=>{
        const htmlTime = $f6158bccfa436061$var$performance?.getEntriesByName?.('CFP-63.html').pop()?.startTime || 0;
        const isInitialLoad = transitionId === 0;
        const metric = (0, $682a207fed74bf66$export$e49353726941624a)(`${transitionId}-${routeName}-${contentId}`);
        // we have two different 'startTime' variables in this context:
        // 'metricStartTime' - This is used for reporting to the metric and for calculating duration.
        // 'startTime' - This is used as a boundary for idle time calculation. There may be instances where the HTML is ready,
        // but the component is not yet rendered. In such cases, we use the component's first render time as the start boundary.
        const startTime = $f6158bccfa436061$var$performance?.now();
        const metricStartTime = isInitialLoad ? htmlTime : startTime;
        let abortedTime = 0;
        metric.start({
            startTime: metricStartTime
        });
        async function measureTimeToAppIdle() {
            while(true){
                await $f6158bccfa436061$var$delay($f6158bccfa436061$var$RETRY_INTERVAL);
                // wait for current long task to complete
                await $f6158bccfa436061$var$wainNextIdle();
                const endTime = $f6158bccfa436061$var$performance?.now();
                // wait to allow performance observer to collect recent entries
                // note that `endTime` somewhat behind after this line, but it's ok
                await $f6158bccfa436061$var$delay($f6158bccfa436061$var$PERFORMANCE_OBSERVER_LATENCY_ADJUSTMENT);
                const idleTime = (0, $e7cb2c525109c7cf$export$de3c307012927947)(startTime, endTime, $f6158bccfa436061$var$IDLE_THRESHOLD, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LongTask]);
                const aborted = abortedTime && (!idleTime || abortedTime < idleTime) ? 'transition' : false;
                const timedOut = endTime - metricStartTime > $f6158bccfa436061$var$TIMEOUT_INTERVAL;
                if (idleTime || timedOut || aborted) {
                    const stopTime = idleTime || endTime;
                    const duration = stopTime - metricStartTime;
                    const tbt = (0, $f69af1ee3d00be57$export$2d6e933b35bd3407)(startTime, stopTime, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LongTask]);
                    const customData = {
                        duration: duration,
                        startTime: metricStartTime,
                        stopTime: stopTime,
                        aborted: aborted,
                        transitionId: transitionId,
                        routeName: routeName,
                        contentId: contentId,
                        timedOut: timedOut,
                        idleThreshold: $f6158bccfa436061$var$IDLE_THRESHOLD,
                        tbtObserved: Math.round(tbt.observed),
                        tbtTotal: Math.round(tbt.total),
                        totalElementsToHydrate: (0, $ezH4I.getTotalHydratedElements)()
                    };
                    metric.stop({
                        stopTime: stopTime,
                        customData: customData
                    });
                    return;
                }
            }
        }
        measureTimeToAppIdle();
        return ()=>{
            abortedTime = $f6158bccfa436061$var$performance?.now();
        };
    }, [
        transitionId,
        routeName,
        contentId
    ]);
    return null;
});







var $iFjdQ = parcelRequire("iFjdQ");




function $192302f00fa5cc0a$export$8c3a984654991d73(routeName) {
    if (!routeName) return;
    switch(routeName){
        // edit route names taken from @confluence/browser-metrics/src/metricKeys.ts
        case (0, $1NBp8.EDIT_PAGE_EMBED).name:
        case (0, $1NBp8.EDIT_PAGE_V2).name:
        case (0, $1NBp8.EDIT_BLOG_V2).name:
        case (0, $1NBp8.EDIT_PAGE).name:
        case (0, $1NBp8.EDIT_BLOG).name:
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.EDIT_ROUTE_CHANGE_ACTION));
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EDIT_ROUTE_CHANGE_TO_FMP_ACTION));
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EDIT_ROUTE_CHANGE_TO_TTI_ACTION));
            return;
        default:
            return;
    }
}



var $jfrcs = parcelRequire("jfrcs");





var $aeSHO = parcelRequire("aeSHO");


var $25MM7 = parcelRequire("25MM7");


var $NAPtM = parcelRequire("NAPtM");


var $iJiK8 = parcelRequire("iJiK8");














var $ikfiQ = parcelRequire("ikfiQ");


const $8bd37d13e213b9df$var$NetworkStatusFlagLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "_Umim",
    name: "NetworkStatusFlagLoader",
    loader: ()=>(parcelRequire("loJVf")).then((module)=>module.NetworkStatusFlagWithFlags)
});
const $8bd37d13e213b9df$export$529640d4682c2 = ()=>{
    const $ = (0, $bDgLe.c)(2);
    const networkStatus = (0, $ikfiQ.useNetworkStatusListenerCache)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let reason;
    bb0: switch(networkStatus){
        case (0, $ikfiQ.ClientNetworkStatus).IP_BLOCKED:
            reason = "IP blocked";
            break bb0;
        case (0, $ikfiQ.ClientNetworkStatus).OFFLINE:
            reason = "Network unavailable";
    }
    if (reason) experienceTracker.abort({
        reason: reason,
        checkForTimeout: false
    });
    let t0;
    if ($[0] !== networkStatus) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bd37d13e213b9df$var$NetworkStatusFlagLoader, {
            status: networkStatus
        });
        $[0] = networkStatus;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};



var $itS9i = parcelRequire("itS9i");


var $hmRc4 = parcelRequire("hmRc4");


var $8Ss4E = parcelRequire("8Ss4E");








var $hzVuz = parcelRequire("hzVuz");





const $af5e1b3a6aa255af$export$38f39b921d5551c1 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "Bc3Ba",
    name: "Heartbeat",
    loader: async ()=>(await (parcelRequire("hmDFY"))).Heartbeat
});



var $39rFu = parcelRequire("39rFu");











var $9DHhW = parcelRequire("9DHhW");


var $gqqjz = parcelRequire("gqqjz");

const $e4d79357fba42d43$var$i18n = (0, $kSwu1.defineMessages)({
    localStorageQuotaExceededTitle: {
        id: "local-storage-quota-subscriber.flag.quota-exceeded.title",
        defaultMessage: "We ran into a problem"
    },
    localStorageQuotaExceededDescription: {
        id: "local-storage-quota-subscriber.flag.quota-exceeded.description",
        defaultMessage: "We've noticed an issue that may affect your experience on Confluence. Select \u201CRefresh\u201D below to fix it."
    },
    refreshLocalStorage: {
        id: "local-storage-quota-subscriber.flag.refresh.title",
        defaultMessage: "Refresh"
    }
});
const $e4d79357fba42d43$export$b2c5189af5b5e948 = ()=>{
    const [isOverflown, setIsOverflown] = (0, $cozmU.useState)(false);
    const [wasShown, setWasShown] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const onQuotaExceeded = ()=>setIsOverflown(true);
        window.addEventListener('local-storage.quota.exceeded', onQuotaExceeded);
        return ()=>{
            setIsOverflown(false);
            window.removeEventListener('local-storage.quota.exceeded', onQuotaExceeded);
        };
    }, [
        setIsOverflown
    ]);
    const clearLocalStorage = ()=>{
        window.localStorage.clear();
        window.location.reload();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'LocalStorageQuotaSubscriber',
                action: 'clicked',
                actionSubject: 'LocalStorageQuotaExceededFlag',
                actionSubjectId: 'localStorageQuotaCleared'
            }
        }).fire();
    };
    const showFlag = (flags)=>{
        if (wasShown) return;
        flags.showWarningFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e4d79357fba42d43$var$i18n.localStorageQuotaExceededTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e4d79357fba42d43$var$i18n.localStorageQuotaExceededDescription),
            actions: [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e4d79357fba42d43$var$i18n.refreshLocalStorage),
                    href: '',
                    onClick: ()=>clearLocalStorage()
                }
            ]
        });
        setWasShown(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>{
        if (isOverflown) showFlag(flags);
        return null;
    });
};



var $iMLPM = parcelRequire("iMLPM");





var $7J5Uc = parcelRequire("7J5Uc");

const $0f25e4f8facf0d0e$export$913cb5ed19d2180b = (initialTheme)=>{
    const { initializeTheme: initializeTheme } = (0, $7J5Uc.useThemingActions)();
    (0, $cozmU.useEffect)(()=>{
        initializeTheme(initialTheme);
    // Only execute upon initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};



var $cBuRD = parcelRequire("cBuRD");





var $6UYek = parcelRequire("6UYek");











const $852a6819cc9585c3$export$5f8d39834fd61797 = ({ children: children })=>{
    // allow developers to disable strict mode for local development
    const isStrictModeDisabled = false;
    if (isStrictModeDisabled) return children;
    // React.StrictMode usage is enabled via dynamic config or environment variable
    if ((0, $1xpoY.default).getBoolean('confluence_strict_mode_config', false) || false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).StrictMode, null, children);
    else return children;
};



var $2JYae = parcelRequire("2JYae");





var $3WLLD = parcelRequire("3WLLD");








var $ek3aD = parcelRequire("ek3aD");










var $1z9oK = parcelRequire("1z9oK");











var $4aRua = parcelRequire("4aRua");

const $003e065b50dd1979$var$RUNBOOK_URL = 'https://hello.atlassian.net/wiki/spaces/~7120202da6a0b2c4184c0da3ba8ade6d08feaa/pages/5761728624/React+suspense+boundary+errors+run-book';
const $003e065b50dd1979$var$i18n = (0, $kSwu1.defineMessages)({
    outsideBoundaryError: {
        id: "streaming-boundary-error-notification.outside-boundary.message",
        defaultMessage: "Query \"{operationName}\" preloaded in [{expectedBoundaries}] but accessed outside any suspense boundary."
    },
    boundaryMismatchError: {
        id: "streaming-boundary-error-notification.boundary-mismatch.message",
        defaultMessage: "Query \"{operationName}\" preloaded in [{expectedBoundaries}] but accessed in \"{currentBoundaries}\" boundary."
    },
    runbookLink: {
        id: "streaming-boundary-error-notification.runbook.link",
        defaultMessage: "See <runbookLink>this page</runbookLink> for details."
    }
});
const $003e065b50dd1979$export$4f6d1b579f9e99e4 = ({ operationName: operationName, errorType: errorType, args: args })=>{
    const expectedBoundaries = args?.expectedBoundaries?.join(', ') || '';
    const currentBoundaries = args?.currentBoundaries?.join(" \u2192 ") || '';
    const renderMessage = ()=>{
        switch(errorType){
            case 'outside-boundary':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...$003e065b50dd1979$var$i18n.outsideBoundaryError,
                    values: {
                        operationName: operationName,
                        expectedBoundaries: expectedBoundaries
                    }
                });
            case 'boundary-mismatch':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...$003e065b50dd1979$var$i18n.boundaryMismatchError,
                    values: {
                        operationName: operationName,
                        expectedBoundaries: expectedBoundaries,
                        currentBoundaries: currentBoundaries
                    }
                });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "queryBoundaryErrorMessage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, renderMessage()), (errorType === 'boundary-mismatch' || errorType === 'outside-boundary') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$003e065b50dd1979$var$i18n.runbookLink,
        values: {
            runbookLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    target: "_blank",
                    href: $003e065b50dd1979$var$RUNBOOK_URL
                }, chunks)
        }
    }));
};


class $82be4d32af71312a$var$BoundaryErrorHandler {
    constructor(flags){
        this.flags = flags;
        this.errorStream = void 0;
        this.cleanup = ()=>{
            if (this.errorStream) this.errorStream.removeListener(this.handleBoundaryError);
        };
        this.handleBoundaryError = (error)=>{
            const flagId = `query-boundary-${error.errorType}-${error.operationName}`;
            let flagTitle = null;
            switch(error.errorType){
                case 'outside-boundary':
                    flagTitle = 'Query Used Outside Suspense Boundary!';
                    break;
                case 'boundary-mismatch':
                    flagTitle = 'Query Boundary Mismatch!';
                    break;
            }
            if (flagTitle) this.flags.showErrorFlag({
                id: flagId,
                title: flagTitle,
                isAutoDismiss: false,
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $003e065b50dd1979$export$4f6d1b579f9e99e4), error)
            });
        };
        if (window.__SSR_REACT_STREAMING__) {
            this.errorStream = (0, $1z9oK.getClientStream)('query-boundary-errors');
            this.errorStream.addListener(this.handleBoundaryError);
        }
    }
}
const $82be4d32af71312a$export$edc06ce642e48a51 = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    (0, $cozmU.useEffect)(()=>{
        if (!window.__SSR_REACT_STREAMING__) return;
        // Create the handler which will automatically set up the listener
        const handler = new $82be4d32af71312a$var$BoundaryErrorHandler(flags);
        return ()=>{
            handler.cleanup();
        };
    }, [
        flags
    ]);
    return null;
});
const $82be4d32af71312a$export$5413c6653c828d95 = ()=>{
    return null;
};












const $875130f53b935742$export$9bfc14d39c192dcd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Tqz5C",
    name: "InconsistentLicenseFlag",
    loader: async ()=>(await (parcelRequire("l1eT4"))).InconsistentLicenseFlag
});





var $h3nb6 = parcelRequire("h3nb6");


var $7Snc9 = parcelRequire("7Snc9");




var $arkw6 = parcelRequire("arkw6");


var $3j0Cc = parcelRequire("3j0Cc");


var $jwv1p = parcelRequire("jwv1p");


var $eIKcA = parcelRequire("eIKcA");


var $4QflW = parcelRequire("4QflW");





const $a409a9cb99445cc0$var$ShortcutsProvider = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zhDj6",
    name: "ShortcutsProvider",
    loader: ()=>(parcelRequire("gjZQ9"))
});
var $a409a9cb99445cc0$export$2e2bcd8739ae039 = $a409a9cb99445cc0$var$ShortcutsProvider;


















const $1f18aab14ff5333d$export$4a5ef4d351acbcfc = async (url, isTransition)=>{
    const shouldPreload = isTransition || !window.__SSR_RENDERED__;
    let match;
    if (match = (0, $kM8fE.matchHome)(url)) (0, $jwv1p.preloadHome)(match);
    else if ((0, $kM8fE.matchSpaceOverview)(url)) {
        if (shouldPreload) (0, $jwv1p.preloadSpaceOverview)();
    } else if ((0, $kM8fE.matchLivePage)(url) && shouldPreload) {
        if (await (0, $aXEzU.waitUntilStatsigInitialized)()) (0, $jwv1p.preloadLivePagesComponents)();
    } else if ((match = (0, $kM8fE.matchAccessLink)(url)) && shouldPreload) // Neither `matchLivePage` nor `matchViewPage` can match here: they need a VIEW_PAGE match plus
    // cached page data, and an access-link URL carries only a token. So the chunks have to be
    // resolved explicitly, and which set to preload depends on what the token resolves to.
    {
        if (await (0, $aXEzU.waitUntilStatsigInitialized)() && (0, $6mKj3.expValEquals)('cc_perms_ga_access_links', 'isEnabled', true)) {
            const content = await (0, $149b2696471ec09e$export$5ff0d8e28a402df2)(match.params.shareToken);
            if (content?.subType === (0, $83sfO.LIVE_PAGE_SUBTYPE)) (0, $jwv1p.preloadLivePagesComponents)();
            else if (content?.type === 'page') (0, $jwv1p.preloadAccessLinkViewPageComponents)({
                ...match,
                params: {
                    ...match.params,
                    contentId: content.contentId,
                    spaceKey: content.spaceKey
                }
            });
        }
    } else if (match = (0, $kM8fE.matchViewPage)(url)) {
        if (shouldPreload) (0, $jwv1p.preloadViewPageComponents)(match);
    } else if ((0, $kM8fE.matchFabricEditor)(url)) (0, $jwv1p.preloadNativeEditorComponentsPreloader)();
    else if ((0, $kM8fE.matchCreateContent)(url)) (0, $jwv1p.preloadCreateContent)();
    else if ((0, $kM8fE.matchWhiteboardPage)(url)) (0, $jwv1p.preloadWhiteboardPage)();
    else if ((0, $kM8fE.matchSearch)(url)) (0, $jwv1p.preloadSearch)();
};






var $50adebb1075ad3af$export$2e2bcd8739ae039 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "exd9t",
    name: "packages.confluence-frontend-server.src.components.ReduxError.src.index",
    loader: ()=>(parcelRequire("aTktW"))
});


const $126a66f6ad21916b$var$browserHistory = (0, $hmRc4.getBrowserHistory)();
const $126a66f6ad21916b$var$appNamedRoutes = {
    ...(0, $64KID.namedRoutes),
    [(0, $1NBp8.ADMIN_CREATE_WITH_ROVO).name]: (0, $1NBp8.ADMIN_CREATE_WITH_ROVO)
};
function $126a66f6ad21916b$export$86fbec116b87613f({ sessionData: sessionData }) {
    (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).performance.mark('CFP-63.app-component-render');
    (0, $10fd4e7f95cabba0$export$6a82770d3a3903f7)();
    (0, $cozmU.useEffect)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).__SSR_ERROR__) (0, $5ZqQS.getMonitoringClient)().submitError(JSON.stringify({
            ssrError: (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).__SSR_ERROR__
        }), {
            // Having '-ssr' suffix to not mix with FE Error detector. Set another dedicated cc-fe-performance detector.
            attribution: 'backbone-ssr'
        });
    }, []);
    const { routePolicy: routePolicy } = (0, $4o1RV.useNavigationPolicy)();
    const { isDesktop: isDesktop } = (0, $2JYae.useIsDesktop)();
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const isPdfExportRoute = typeof (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))) !== 'undefined' && (0, $1NBp8.PDF_EXPORT_PAGE).match((0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).location.pathname);
    const { isLoggedIn: isLoggedIn, isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isRovoEnabled = isRovoLLMEnabled && isLoggedIn && accessStatus !== (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
    // When loading confluence from the mobile app, we need the theme to respect the system color mode of the app
    const initialTheme = isMobileApp ? (0, $3WLLD.mobileAppTheme) : undefined;
    // Initializing the theme in a non-blocking way, instead of using <ThemeContainer>, so
    // that the app does not flash and re-paint after the SPA loads on top of the SSR page.
    (0, $0f25e4f8facf0d0e$export$913cb5ed19d2180b)(initialTheme);
    // Lite Mode™ check outside of the router
    // For certain pages supporting lite mode some functionality is not needed
    const isLite = (0, $aFbGo.isViewPageLite)();
    // Check if app is being loaded in iFrame
    // We don't want to render the Rovo Chat wrapper if in iFrame
    const isIframe = typeof (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))) !== 'undefined' && (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).self !== (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).top;
    const startPageLoadMetrics = (0, $cozmU.useCallback)((routeName = '', ufoName = routeName, transitionId, contentId = '')=>{
        (0, $jfrcs.startBrowserMetricsPageLoad)(routeName, ufoName, transitionId, contentId);
        if ((0, $9wGTI.fg)('platform_ufo_custom_cohort_data_migration')) (0, $7SkLu.addUFOCustomCohortData)('isDesktop', isDesktop);
        else (0, $gXfti.addUFOCustomData)({
            isDesktop: isDesktop
        });
    }, [
        isDesktop
    ]);
    const onRoute = (0, $cozmU.useCallback)(async (match, transitionId)=>{
        // Reset window.__APOLLO_STATS__ on transition
        (0, $eHj6r.resetApolloStats)();
        // transitionId = 0 when it is initial load, and 0 is falsey
        if (transitionId) {
            // The page can't be rendered by SSR if is a transition
            (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI)))['__SSR_RENDERED__'] = false;
            //hydrateRoot and related logic should not be enabled on transitions
            //as its only for ssr rendered page
            (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI)))['__HYDRATABLE__'] = false;
            (0, $KcDWk.releaseSSRedLegacyMacros)();
            // Delayed content redirection is not needed on transitions
            (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI)))['__DELAYED_CONTENT_REDIRECTION__'] = {};
            if (0, $itS9i.debuggerEnabled) (0, $itS9i.clearAnalyticsDebugger)();
        } else {
            (0, $5ZqQS.getMonitoringClient)().incrementCounter('confluence-spa.react-initialized');
            (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).performance.mark('CFP-63.route-manager-initialized');
        }
        (0, $78QFu.setUniquePageLoadId)(match?.name ?? '', match, transitionId, sessionData);
        (0, $8Ss4E.startExperienceForRoute)(match, transitionId, sessionData);
        (0, $2ba6133bff070823$export$8c5248f0cec8446d).stream([
            {
                type: 'page-transition',
                ID: transitionId
            }
        ]);
        const transitionPreloaderCurrentCallbackIDs = (0, $ek3aD.getGlobalTransitionPreloader)().getCurrentRouteCallbackIds();
        const isSeamlessTransition = (0, $9wGTI.fg)('confluence_frontend_transition_preloading_system') ? transitionPreloaderCurrentCallbackIDs.includes('live_doc_preloading_transition_callback_id') && transitionId !== 0 : false;
        //if the new editor metrics FF is on, start BM here only if the route is not edit page or if it is initial load, or an embedded editor.
        if (!isSeamlessTransition && (!(0, $gEtAQ.isEditPage)(match?.name) || transitionId === 0 || (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)())) {
            (0, $jfrcs.startBrowserMetricsPageLoad)(match?.name ?? '', match?.ufoName, transitionId, match?.params.contentId);
            if ((0, $9wGTI.fg)('platform_ufo_custom_cohort_data_migration')) (0, $7SkLu.addUFOCustomCohortData)('isDesktop', isDesktop);
            else (0, $gXfti.addUFOCustomData)({
                isDesktop: isDesktop
            });
            //If it is an embedded editor, start the BM right here since it does a full page reload
            if ((0, $gEtAQ.isEditPage)(match?.name) && (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)()) {
                (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EMBEDDED_EDIT_FMP_ACTION));
                (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EMBEDDED_EDIT_TTI_ACTION));
            }
        }
        // add SSR stats to initial page load only
        // we will be utilizing serverTime to track BE perf in Statsig
        if (transitionId === 0) {
            /** @type {Object<string, {startTime: number, duration: number} | undefined>} */ const ssrMeasure = (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI)))['__SSR_MEASURES__'];
            const serverTime = ssrMeasure ? Object.keys(ssrMeasure).filter((key)=>key.includes('prepare/preloadQuery/fetch')).reduce((total, key)=>total + (ssrMeasure[key]?.duration ?? 0), 0) : 0;
            /** @type {number | undefined} */ const serverCallCount = (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI)))['__FETCH_COUNT__'];
            if (serverTime && serverCallCount) (0, $gXfti.addUFOCustomData)({
                serverTime: serverTime,
                serverCallCount: serverCallCount
            });
        }
        // mark edit experience after transition to new route is complete
        (0, $192302f00fa5cc0a$export$8c3a984654991d73)(match?.name);
        (0, $5ZqQS.getMonitoringClient)().updateContext({
            pageName: match?.name ?? 'unknown',
            transitionId: transitionId,
            product: (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)() ? 'embeddedConfluence' : 'confluence'
        });
    }, [
        sessionData,
        isDesktop
    ]);
    /**
   * Please note this App is a pure component.
   * This means following components will NOT re-render when user navigates.
   * Please be careful when adding any component that requires router information.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $852a6819cc9585c3$export$5f8d39834fd61797), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iV00x.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $008c5cd8cb4c3a95$export$4e5ff544be3ec09b), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $82be4d32af71312a$export$5413c6653c828d95), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dBmJE.ConnectedRouter), {
        history: $126a66f6ad21916b$var$browserHistory,
        context: (0, $bEYte.ReactReduxContext)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kCeSx.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hzVuz.ExternalShareContextProvider), {
        path: $126a66f6ad21916b$var$browserHistory.location.pathname
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NAPtM.CreateDialogContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39rFu.EditPageLoadingContextProvider), {
        nativeEditorComponentsPreloader: (0, $eXODy.nativeEditorComponentsPreloader),
        livePageComponentsPreloader: (0, $jwv1p.preloadLivePagesComponents)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6UYek.SubscriptionsContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8n9tL.RouteManager), {
        routeComponents: (0, $h3nb6.routeComponents),
        namedRoutes: $126a66f6ad21916b$var$appNamedRoutes,
        notFound: (0, $7Snc9.NotFound),
        onInitialize: onRoute,
        onTransition: onRoute,
        onPreload: $126a66f6ad21916b$var$onPreloadRoute,
        routePolicy: routePolicy,
        setBrowserHistoryListener: (0, $hmRc4.setBrowserHistoryListener),
        startPageLoadMetrics: startPageLoadMetrics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4QflW.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af5e1b3a6aa255af$export$38f39b921d5551c1), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cBuRD.NotificationLandedEvent), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f6158bccfa436061$export$560b992b8a813cfb), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $074500c4d6f25c0d$export$9f8d3084fd3d5fc0), null), !isLite && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJiK8.Dialogs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arkw6.LazyCreateDialogQueryRenderer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3j0Cc.LazyCreateDialogBlueprintWizardRenderer), null)), !isIframe && isRovoEnabled && !isPdfExportRoute && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXWtB.ConfluenceConversationAssistant), {
        skipChatUI: true
    }), !isPdfExportRoute && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMLPM.RemixWatcherMount), null)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eIKcA.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8bd37d13e213b9df$export$529640d4682c2), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a409a9cb99445cc0$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $50adebb1075ad3af$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJELi.ConnectSupport), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $25MM7.Flags), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $875130f53b935742$export$9bfc14d39c192dcd), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e4d79357fba42d43$export$b2c5189af5b5e948), null), !isLite && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aeSHO.CopySpacePermissionsForLegacyNewSpace), null))));
}
$126a66f6ad21916b$export$86fbec116b87613f.propTypes = {
    sessionData: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object.isRequired
};
function $126a66f6ad21916b$var$onPreloadRoute({ url: url }, previousMatch, options) {
    (0, $1f18aab14ff5333d$export$4a5ef4d351acbcfc)(url, true);
    if (options?.preloadingMode === (0, $hXDOc.PreloadingMode).onlyJS) return;
    (0, $e80763d537fd4542$export$57d895781a697848)(url, true, previousMatch, options);
    if (options?.preloadingMode === (0, $hXDOc.PreloadingMode).onlyJSAndCriticalData) return;
    (0, $e80763d537fd4542$export$6aefe8c2dfd7fe98)(url);
}


class $2652ca00a3968b71$export$2e2bcd8739ae039 extends (0, $cozmU.Component) {
    render() {
        window.performance.mark('CFP-63.root-component-render');
        const { store: store, apolloClient: apolloClient, sessionData: sessionData } = this.props;
        return(// This is at the top because the root-level UnstatedProvider must not re-render
        // otherwise it will lose and recreate its instances
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Provider), {
            inject: [
                new (0, $hrAmX.BannerStateContainer)({
                    initialState: {
                        banners: window.__SSR_BANNERS__
                    }
                }),
                new (0, $bJX6u.ContentStateStateContainer)(window.__SSR_CONTENT_STATE__),
                new (0, $ktUCG.EmojiTitleStateContainer)(window.__SSR_EMOJI_TITLE__)
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lonEO.GraphqlProvider), {
            client: apolloClient
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bEYte.Provider), {
            store: store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7i8j.SessionDataContext).Provider, {
            value: sessionData
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cryCi.Provider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1ytiN.SPAViewContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1kHsc.ExperienceTrackerContext).Provider, {
            value: (0, $fGzMp.getExperienceTracker)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jVK0t.I18nProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $70d683a301b7be27$export$d900e4062895cd7c), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpWmZ.default), {
            client: (0, $04e9M.getAnalyticsWebClient)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kZDrw.NavdexListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97W74.EngagementProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5ap9.ConfluenceAnalyticsListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fcF01.UpFlowProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $685338b3d2a4b0a3$export$2e865a7ec399eb55), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fN9wG.XProductUserInviteProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $brNvA.ReattachCommentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $074500c4d6f25c0d$export$fb465b6e855c1e85), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $126a66f6ad21916b$export$86fbec116b87613f), {
            sessionData: sessionData
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ccd0dc06d2167081$export$f6564e60882bdf90), null))))))))))))))))))));
    }
}
$2652ca00a3968b71$export$2e2bcd8739ae039.displayName = 'Root';
$2652ca00a3968b71$export$2e2bcd8739ae039.propTypes = {
    /**
   * Global store
   */ store: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object.isRequired,
    apolloClient: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object.isRequired,
    sessionData: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object.isRequired
};






const $64ffce910ca717e1$var$ErrorType = Object.freeze({
    REMOVE_CHILD_ERROR: 'removeChildError',
    INSERT_BEFORE_ERROR: 'insertBeforeError'
});
function $64ffce910ca717e1$export$d1215808cd22e615() {
    if (typeof Node === 'function' && Node.prototype) {
        const originalRemoveChild = Node.prototype.removeChild;
        Node.prototype.removeChild = function(child) {
            if (child.parentNode !== this) {
                if (console) {
                    console.error('Cannot remove a child from a different parent', child, this);
                    $64ffce910ca717e1$var$sendRemoveChildErrorAnalyticsEvent(child);
                }
                return child;
            }
            return originalRemoveChild.apply(this, arguments);
        };
        const originalInsertBefore = Node.prototype.insertBefore;
        Node.prototype.insertBefore = function(newNode, referenceNode) {
            if (referenceNode && referenceNode.parentNode !== this) {
                if (console) {
                    console.error('Cannot insert before a reference node from a different parent', referenceNode, this);
                    $64ffce910ca717e1$var$sendInsertBeforeErrorAnalyticsEvent(referenceNode, newNode);
                }
                return newNode;
            }
            return originalInsertBefore.apply(this, arguments);
        };
    }
}
/**
 * Send an analytics event when a 'removeChild' error occurs. This function helps to track the occurrence of this suppressed error.
 * @param {Node} childNode - The node that is attempted to be removed.
 */ function $64ffce910ca717e1$var$sendRemoveChildErrorAnalyticsEvent(childNode) {
    const nodeData = {
        nodeToBeRemoved: $64ffce910ca717e1$var$extractNodeData(childNode)
    };
    $64ffce910ca717e1$var$sendAnalyticsEvent($64ffce910ca717e1$var$ErrorType.REMOVE_CHILD_ERROR, nodeData);
}
/**
 * Send an analytics event when an 'insertBefore' error occurs.  This function helps to track the occurrence of this suppressed error.
 * @param {Node} referenceNode - The existing node in the DOM tree. The new node is intended to be inserted before this node.
 * @param {Node} newNode - The new node that is attempted to be inserted.
 */ function $64ffce910ca717e1$var$sendInsertBeforeErrorAnalyticsEvent(referenceNode, newNode) {
    const nodeData = {
        newNode: $64ffce910ca717e1$var$extractNodeData(newNode),
        referenceNode: $64ffce910ca717e1$var$extractNodeData(referenceNode)
    };
    $64ffce910ca717e1$var$sendAnalyticsEvent($64ffce910ca717e1$var$ErrorType.INSERT_BEFORE_ERROR, nodeData);
}
function $64ffce910ca717e1$var$sendAnalyticsEvent(action, nodeData) {
    (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
        client.sendOperationalEvent({
            source: 'confluenceFrontendServer',
            actionSubject: 'domManipulationError',
            action: 'error',
            attributes: {
                suppressedError: action,
                ...nodeData
            }
        });
    });
}
function $64ffce910ca717e1$var$extractNodeData(node) {
    if (!node) return {};
    return {
        nodeName: node.nodeName,
        parentElementNodeName: node.parentElement?.nodeName,
        isConnected: node.isConnected
    };
}



var $7LuKf = parcelRequire("7LuKf");







function $55460e99d99202dd$export$841e9db237ec2bdb(rootNode) {
    const walker = document.createTreeWalker(rootNode, NodeFilter.SHOW_COMMENT, {
        acceptNode: (node)=>{
            return node.nodeValue === '$' ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
        }
    });
    const suspenseComments = [];
    let currentNode = null;
    while(currentNode = walker.nextNode())suspenseComments.push(currentNode);
    return suspenseComments;
}
function $55460e99d99202dd$export$c4c689e5d93ba5b6(node) {
    // Check if the node itself has data-hydration-shield
    if (node.nodeType === Node.ELEMENT_NODE && node.hasAttribute('data-hydration-shield')) return true;
    // Check if the parent has data-hydration-shield
    const parent = node.parentNode;
    if (parent?.nodeType === Node.ELEMENT_NODE && parent.hasAttribute('data-hydration-shield')) return true;
    return false;
}
function $55460e99d99202dd$export$9efc73f328295609(boundary) {
    let nextNode = boundary.nextSibling;
    // Skip text nodes that are just whitespace
    while(nextNode && nextNode.nodeType === Node.TEXT_NODE && !nextNode.textContent?.trim())nextNode = nextNode.nextSibling;
    // Return the next node if it is an element node
    if (nextNode && nextNode.nodeType === Node.ELEMENT_NODE) return nextNode;
}
function $55460e99d99202dd$export$b5009d2dcc72fd5c(rootNode, root) {
    (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).flushSync(()=>{
        $55460e99d99202dd$export$841e9db237ec2bdb(rootNode).forEach((boundary)=>{
            const node = $55460e99d99202dd$export$9efc73f328295609(boundary);
            if (node && $55460e99d99202dd$export$c4c689e5d93ba5b6(node)) {
                if (!(0, $6mKj3.expVal)('confluence_frontend_skip_activatable_hydration', 'isEnabled', false)) return;
            }
            if (node) root.unstable_scheduleHydration(node);
        });
        root.unstable_scheduleHydration(rootNode);
    });
}



var $8Zvnr = parcelRequire("8Zvnr");


var $hSZic = parcelRequire("hSZic");


var $gx9wu = parcelRequire("gx9wu");

function $f31af9c25e6171d9$export$b3bc47985717b49e(opts = {}) {
    if (!globalThis.__vcObserver) {
        const shouldMockVCObserver = !(0, $8Zvnr.isEnvironmentSupported)();
        globalThis.__vcObserver = shouldMockVCObserver ? new (0, $hSZic.VCObserverNOOP)() : new (0, $gx9wu.VCObserverWrapper)(opts);
    }
    return globalThis.__vcObserver;
}


const $cff4f803b29c74e8$export$e99e0154cbe3afef = (rootNode)=>{
    const vcObserver = (0, $f31af9c25e6171d9$export$b3bc47985717b49e)();
    vcObserver.setSSRElement(rootNode);
    vcObserver.setReactRootRenderStart();
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            vcObserver.setReactRootRenderStop();
        });
    });
};


function $82f3624e89bd584a$export$62028ff70825ead9(callback) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback);
    else callback();
}





const $c641ec602c55a36e$var$MAX_ERROR_STACK_LENGTH = 100000;
const $c641ec602c55a36e$var$DEFAULT_STACK_LENGTH = 1000;
const $c641ec602c55a36e$export$423e2732e9c54334 = ({ componentStack: componentStack })=>{
    if (!componentStack) return '';
    let loggingConfig = {};
    try {
        loggingConfig = JSON.parse((0, $1xpoY.default).getString('confluence_hydration_error_logging', '{}'));
    } catch (error) {
    // no-op, if an error occurs here, there's really nowhere to submit it
    }
    if (loggingConfig.stack) {
        const errorStackLogLen = loggingConfig.stackLength ?? $c641ec602c55a36e$var$DEFAULT_STACK_LENGTH;
        const clampedErrorStackLog = Math.min($c641ec602c55a36e$var$MAX_ERROR_STACK_LENGTH, errorStackLogLen);
        return componentStack.toString().substring(0, clampedErrorStackLog) ?? '';
    }
    return '';
};



function $301b91f6022f88c3$export$6f190738a936fdf9(error, errorInfo) {
    if (typeof window !== 'undefined' && window.dispatchEvent) window.dispatchEvent(new CustomEvent('hydrationError', {
        detail: {
            error: error.message,
            stack: (0, $c641ec602c55a36e$export$423e2732e9c54334)(errorInfo),
            timestamp: Date.now()
        }
    }));
}



var $awd1Q = parcelRequire("awd1Q");





var $7RVQB = parcelRequire("7RVQB");

let $c4a23b150b65622f$var$translationPromise = null;
async function $c4a23b150b65622f$export$d72c30eb19cf29ca() {
    if ($c4a23b150b65622f$var$translationPromise === null) $c4a23b150b65622f$var$translationPromise = (0, $hZpML.WaterfallMeasures).run((0, $hZpML.WATERFALL_INITIAL_MEASURES).BOOTSTRAP_TRANSLATION, ()=>(0, $awd1Q.loadTranslation)((0, $7RVQB.lazyLanguage)));
    return $c4a23b150b65622f$var$translationPromise;
}








function $2430be288db8ba8d$export$7424fb7c300d6ad9() {
    const maxStackSize = (0, $1xpoY.default).getNumber('confluence_frontend_dev_console_max_stack_size', 0);
    // Default value means don't trim stacks.
    if (maxStackSize === 0 || !(0, $cMvQV.isChrome)()) return;
    // The code below takes many hints from React devtools code
    // https://github.com/facebook/react/blob/c80a07509582daadf275f36ffe7a88c3b12e9db4/packages/react-devtools-shared/src/hook.js#L456
    for (const method of [
        'error',
        'warn'
    ]){
        const originalMethod = console[method];
        console[method] = function(...args) {
            if (args.length === 0) return;
            const lastArg = args[args.length - 1];
            // React's custom built component stack strings match "\s{4}in"
            // Chrome's prefix matches "\s{4}at"
            if (typeof lastArg === 'string' && /\s{4}(in|at)\s{1}/.test(lastArg)) {
                const firstArg = args[0];
                const newArgs = args.slice();
                if (args.length > 1 && typeof firstArg === 'string' && firstArg.endsWith('%s')) newArgs[0] = firstArg.slice(0, firstArg.length - 2); // Strip the %s param
                // Create a fake Error so that when we print it we get native source maps. Every
                // browser will print the .stack property of the error and then parse it back for source
                // mapping.
                const fakeError = new Error('');
                // It has to start with ^[\w.]*Error\b to trigger stack formatting.
                fakeError.name = 'Error Component Stack';
                // Overwrite the stack property with the trimmed stack trace.
                fakeError.stack = lastArg.split('\n').slice(0, maxStackSize + 1).join('\n');
                newArgs[newArgs.length - 1] = fakeError;
                // If the developer has React devtools extension installed, it contains its own override logic for console methods,
                // which is downstream of our implementation here. If the extension's "append component stacks" setting is on,
                // then it will end up appending a second stack trace to the one we're providing. Thus we need to force that
                // setting to be off temporarily.
                let originalAppendComponentStack;
                const reactDevtoolsSettings = window.__REACT_DEVTOOLS_GLOBAL_HOOK__?.settings;
                if (reactDevtoolsSettings) {
                    originalAppendComponentStack = reactDevtoolsSettings.appendComponentStack;
                    reactDevtoolsSettings.appendComponentStack = false;
                }
                originalMethod(...newArgs);
                if (reactDevtoolsSettings) reactDevtoolsSettings.appendComponentStack = originalAppendComponentStack;
            } else originalMethod(...args);
        };
    }
}





const $ba6acd3d9f4d6907$export$1efb2e25dea8cbfc = ()=>{
    (0, $6mKj3.expVal)('move_statsig_bootstrap_after_fmp', 'isEnabled', false);
    (0, $6mKj3.expVal)('confluence_media_token_preload_agg_query', 'isEnabled', false);
};


if (window?.performance) {
    window.performance.mark('CFP-63.app');
    window.performance.mark('navigation-fmp.NavigationFMP.start');
    window.performance.mark('side-navigation-fmp.SideNavigationFMP.start');
}
const $67148092cd3543c6$var$logger = (0, $7W8i8.getLogger)('SPAEntry');
// Try load translation early if we know locale from SSR
if (window.__SSR_LOCALE__) (0, $c4a23b150b65622f$export$d72c30eb19cf29ca)();


(0, $82f3624e89bd584a$export$62028ff70825ead9)(async function() {
    /**
   * setupUFOGlobalErrorHandler MUST be the first thing executed before any rendering operations.
   * This ensures we catch and track any errors that occur during the app's initialization,
   * including async operations and React rendering. Moving this call later would risk missing
   * early errors.
   * it provides ufo:errors:globalCount is the count of all errors which occurred on the client all up
   */ (0, $fAsH0.default)();
    // When page is being refreshed or redirected from server we run into a condition when redirect
    // url requested from the server and SPA (which resources are loaded via early HTML flush) is
    // being initialized at the same time. We don't want to waste browser resources/make network
    // calls when page is going to be redirected anyway, so bail out early.
    if (document.querySelector(`meta[http-equiv="Refresh"]`)) return;
    const rootNode = document.getElementById('confluence-ui');
    if (window.__HYDRATABLE__) {
        // remove nonce attributes from style tags to support react hydration
        document.querySelectorAll('style[nonce]').forEach((styleTag)=>{
            styleTag.removeAttribute('nonce');
        });
        (0, $dA1Sn.saveFullCycleOutput)();
    }
    const { client: client, aggClient: aggClient } = (0, $hZpML.WaterfallMeasures).run((0, $hZpML.WATERFALL_INITIAL_MEASURES).CREATE_APOLLO_CLIENTS, ()=>{
        const apolloClient = (0, $hp2SH.getApolloClient)();
        const apolloAggClient = (0, $gKr8t.getAGGClient)();
        // Initialize the Relay environment alongside the Apollo clients so
        // `window.GLOBAL_RELAY_ENV` is set before any Relay-enabled interop
        // call (including the preloader interop path in
        // `@confluence/query-preloader-tools`). Mirrors how
        // `GLOBAL_APOLLO_AGG_CLIENT` is set during `getAGGClient()`.
        (0, $9HB34.getRelayEnvironment)();
        return {
            client: apolloClient,
            aggClient: apolloAggClient
        };
    });
    let initializeEmbeddedConfluencePromise;
    // @TODO: Update this to use `isMobileApp_DO_NOT_USE()` once we remove the experiment-gate
    if ((0, $lJlG6.isMobileApp_checkGateViaSSR_DO_NOT_USE)()) initializeEmbeddedConfluencePromise = (await (parcelRequire("7PF1e"))).initialize();
    else if ((0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)()) initializeEmbeddedConfluencePromise = (await (parcelRequire("hSMRQ"))).initialize();
    let browserNotSupported;
    // Must call this before any browser-helper functions, to ensure user agent has been set first
    (0, $cMvQV.setUserAgent)();
    // Bypass browser compatibility checks in the case of the Confluence native mobile app;
    // it is the responsibility of the mobile app to ensure the rendering of Confluence
    const shouldCheckBrowserCompatibility = !(0, $cMvQV.isNativeMobile)();
    if (shouldCheckBrowserCompatibility) {
        browserNotSupported = (0, $2DVQX.coreBrowserNotSupported)();
        if (browserNotSupported) // eslint-disable-next-line react/no-deprecated
        return void (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9j59h.BrowserNotSupportedLoader), null), rootNode);
    }
    const sessionDataPromise = (async ()=>{
        const sessionData = await (0, $hZpML.WaterfallMeasures).run((0, $hZpML.WATERFALL_INITIAL_MEASURES).BOOTSTRAP_SESSION_DATA, ()=>(0, $aXEzU.getSessionDataAndInitializeStatsig)());
        const { userId: userId, isLicensed: isLicensed, monolithRegion: monolithRegion } = sessionData;
        // Expose synthetic environment flag to the window so downstream consumers
        // can detect it without importing @confluence/statsig-client avoiding possible circular dependencies.
        if ((0, $1xpoY.default).isKillSwitchOn('cc_e2e_stable_ui')) window.__IS_SYNTHETIC_ENV__ = true;
        // Note: this MUST be done before preload queries below
        // in order to ensure performant AGG queries
        (0, $8PKGr.initializeAggRegionSteeringHint)(monolithRegion);
        // If page is SSRed preload data that is only needed for hydration
        // If page is not SSRed, preload all the data.
        (0, $xwvlW.initializePreloaderFnContext)(sessionData);
        (0, $e80763d537fd4542$export$bd8e570400e2d126)();
        try {
            await (0, $hZpML.WaterfallMeasures).run((0, $hZpML.WATERFALL_INITIAL_MEASURES).BOOTSTRAP_INITIALIZE_STORAGE_MANAGER, async ()=>{
                // Initialize browser storage controls after Statsig is ready (for proper feature gate evaluation)
                // This must happen before initializeStorageManager
                await (0, $7ZzSP.initializeBootstrapStorage)({
                    userId: userId,
                    cloudId: sessionData.cloudId
                });
                await (0, $17wUi.initializeStorageManager)({
                    userId: userId,
                    isLicensed: isLicensed
                });
                (0, $gnYQc.applyPersistedStatsigOverrides)();
                (0, $ae045ed661bc53ec$export$efcab8bd082cbc1f)(sessionData);
                (0, $30ba73f8286a8f5a$export$6381c51f97ce9880)(sessionData);
                (0, $e8bac4b2464d29b3$export$77f9905a9b9e760d)(sessionData);
            });
            return sessionData;
        } catch  {
            // HOT-89887: server is giving 403 errors on an expired token, causing Apollo
            // to throw. Uncaught, the React app wouldn't start, and can't acknowledge
            // messages from the service worker; thus the service worker can't trigger a
            // redirect to the login page; thus user gets stuck at the Confluence logo
            // screen. By catching here, we can at least bootstrap the app and proceed to
            // the redirect.
            //
            // https://jira.atlassian.com/browse/CONFCLOUD-71974: IP allowlisting is
            // causing a 403 scenario similar to HOT-89887 above.
            return (0, $iC5L0.getEmptySessionData)();
        }
    })();
    // Preload loadable id defined in the global __LOADABLE__ array
    // If the page is rendered by React SSR service this promise will be blocking.
    // On normal SPA it is not blocking.
    const preloadLoadablePromise = (0, $hZpML.WaterfallMeasures).run((0, $hZpML.WATERFALL_INITIAL_MEASURES).BOOTSTRAP_LOADABLE, ()=>(0, $3GQl6.preloadLoadable)());
    // Preload components/JS chunks as early as possible, when entry point is loaded and
    // route is known, so they'll be ready by the moment when they're actually used.
    (0, $1f18aab14ff5333d$export$4a5ef4d351acbcfc)(window.location.toString(), false);
    Promise.all([
        sessionDataPromise,
        // No-Op if load translation is already called earlier
        (0, $c4a23b150b65622f$export$d72c30eb19cf29ca)(),
        preloadLoadablePromise,
        initializeEmbeddedConfluencePromise
    ]).then(([sessionData])=>{
        // If cloudId is not present in sessionData, we can assume sessionData did not load successfully. Instead of
        // allowing the app to render the red error message, we can render our simplified Error App that fires key analytics
        // events and shows a more pleasing error UI.
        if (sessionData.cloudId === '') {
            let isMobileTakeoverPage = false;
            let isExternalSharePage = false;
            try {
                if (window?.location?.pathname) {
                    isMobileTakeoverPage = Boolean((0, $1NBp8.MOBILE_TAKEOVER_PAGE).match(window.location.pathname));
                    // Users with qm:-scoped guest session tokens (returning external share visitors)
                    // receive tenant: null from SiteInformationQuery because their tokens cannot
                    // authenticate against the tenant GraphQL resolver. This causes cloudId to be
                    // empty even though the session is valid. ExternalSharePage fetches content via
                    // the share token and does not require cloudId, so ErrorAppLoader must not render.
                    if ((0, $6mKj3.expValEquals)('permissions_reliability_error_resolution', 'cohort', 'experiment')) isExternalSharePage = Boolean((0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname)) || Boolean((0, $1NBp8.ACCESS_LINK).match(window.location.pathname));
                }
            } catch  {
                // If anything goes wrong, default to false (don't skip ErrorAppLoader)
                isMobileTakeoverPage = false;
                isExternalSharePage = false;
            }
            if (!isMobileTakeoverPage && !isExternalSharePage) {
                const root = (0, $fRQ3t.createRoot)(rootNode);
                root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lTjel.ErrorAppLoader), {
                    entryPoint: "confluence-frontend",
                    sessionDataError: (0, $fcgrS.getSessionDataError)()
                }));
                return;
            }
        }
        if (!crypto.randomUUID && (0, $9wGTI.fg)('confluence_pollyfill_crypto_randomuuid')) crypto.randomUUID = (0, $9HkI0.v4);
        // Redux store
        const store = (0, $3Tw8v.default)();
        (0, $9F7Qb.subscribe)(store);
        // When __APOLLO_STATE__ is available in the global variable it means we are bootstrapping SPA over a SSR rendered page.
        // __APOLLO_STATE__ is the serialized apollo cache that is enough to render everything that has already preloaded in preloadLoadable.
        // We are disabling network so on the first render so the components will read from cache only not firing queries again.
        // See https://github.com/apollographql/apollo-client/issues/4814
        if (window['__APOLLO_STATE__'] || window.__SSR_REACT_STREAMING__) client.disableNetworkFetches = true;
        if (window['__APOLLO_AGG_STATE__'] || window.__SSR_REACT_STREAMING__) aggClient.disableNetworkFetches = true;
        if (typeof window !== 'undefined') window.__CC_REACT_DOM_CONTEXT_PATCH__ = true;
        // Workaround for a race condition between Google Translate and React's DOM reconciliation.
        // Google Translate mutates the DOM by wrapping text nodes in <font> elements, reparenting
        // them under a new parent. When React later tries to removeChild or insertBefore on the
        // original parent, the node is no longer a child of that parent, causing a crash.
        // This patches Node.prototype.removeChild and insertBefore to gracefully handle the
        // mismatch instead of throwing.
        //
        // These patches must be applied unconditionally at startup. An on-demand approach that
        // used a MutationObserver to lazily install the patches only when Google Translate was
        // detected was attempted, but there is a race condition: Google Translate can reparent
        // nodes and trigger React's removeChild/insertBefore before the MutationObserver
        // callback fires to install the patches, so React still crashes.
        //
        // See: https://github.com/facebook/react/issues/11538#issuecomment-417504600
        // See: https://product-fabric.atlassian.net/browse/CCP-2409
        (0, $64ffce910ca717e1$export$d1215808cd22e615)();
        // code for regression drill logic. Systematic way of indentifying and tracking performance regressions in web pages
        // will be used to test out criterion, a new perfomacne tracking software
        // for more info visit https://hello.atlassian.net/wiki/spaces/CVMAI/pages/3761808800/Regression+Drill+Plan
        const delayValueForRegression = (0, $1xpoY.default).getNumber('confluence_frontend_preprod_slow', 0);
        delayValueForRegression;
        /**
     * Emotion has 2 ways of SSR support
     * 1. Render style tags along with the component
     * 2. Extract the styles with createEmotionServer
     * Normally we don't need t client side extraction because all the style tags should be in <head>
     * However with streaming there is no good way to support it.
     * The "css" key here is special it runs the logic of moving all the style tags to <head> before React hydrates on the the client side.
     * Reference: https://github.com/emotion-js/emotion/blob/38db311adf024fe8a24b57c687824c47abbd0957/packages/cache/src/index.ts#L63
     */ const cache = (0, $4jxwi.default)({
            key: 'css'
        });
        const App = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
            name: "confluence-root"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d847caf3274d14b7$export$f3385cdc6645f7e3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7D1yr.C), {
            value: cache
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $799291abed68198f$export$640957ec8f6fdf34), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2652ca00a3968b71$export$2e2bcd8739ae039), {
            store: store,
            apolloClient: client,
            sessionData: sessionData
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8714b2bec379cfae$export$bd148a921cde8da1), null));
        const renderCallback = ()=>{
            // This is important broadcast in Apollo allows hooks that subscribe to the cache to be updated.
            // Broadcast is disabled until here.
            (0, $ca1d37ec2e96c685$export$c25b3a02c2d5dc72)().startBroadcast();
            (0, $0b6b84530a4d34b5$export$b4a2d416bf2548b)().startBroadcast();
            if (window['__APOLLO_STATE__'] || window.__SSR_REACT_STREAMING__) client.disableNetworkFetches = false;
            if (window['__APOLLO_AGG_STATE__'] || window.__SSR_REACT_STREAMING__) aggClient.disableNetworkFetches = false;
            const userAgentParser = new (0, (/*@__PURE__*/$parcel$interopDefault($gJN0g)))(navigator.userAgent);
            const { name: browserName, version: browserVersion } = userAgentParser.getBrowser();
            (0, $7LuKf.initialization)(sessionData, {
                browserName: browserName
            });
            // Inside of cleanUpLoadablePlaceholders function, it delayed cleaning up loadable placeholders.
            (0, $ezH4I.cleanUpLoadablePlaceholders)();
            (0, $KcDWk.releaseUnusedSSRedLegacyMacrosWithDelay)();
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsClient)=>{
                // GASv3 analytics client is initialized inside of initialization() so we
                // must call the analytics client after that function has been called.
                if (shouldCheckBrowserCompatibility) analyticsClient.sendOperationalEvent({
                    source: 'confluenceRoot',
                    action: 'executed',
                    actionSubject: 'browserRuntimeCheck',
                    attributes: {
                        failedCoreBrowserCheck: browserNotSupported,
                        browserName: browserName,
                        browserVersion: browserVersion
                    }
                });
            });
            if (rootNode) (0, $cff4f803b29c74e8$export$e99e0154cbe3afef)(rootNode);
        };
        const ConcurrentApp = ()=>{
            (0, $cozmU.useEffect)(()=>{
                if (window['__HYDRATION_START__']) $67148092cd3543c6$var$logger.debug`Hydration finished in ${Math.floor(performance.now() - window['__HYDRATION_START__'])}ms`;
                renderCallback();
            }, []);
            return App;
        };
        // If there are loadable timeouts, there is a very high chance hydration will also fail
        // Trying to hydrate and failing is more expensive than running createRoot from the start so we skip hydration in this case
        if (window['__LOADABLE_TIMEOUTS__']?.length) window['__HYDRATABLE__'] = false;
        const isHydratable = window['__HYDRATABLE__'];
        // Fire exposure for cc_performance_holdout - this is needed to monitor the performance of
        // the holdout group as a custom cohort in Glance / via UFO.
        (0, $9wGTI.fg)('cc_performance_holdout');
        // The browser Statsig client is initialized by sessionDataPromise before this callback runs.
        (0, $ba6acd3d9f4d6907$export$1efb2e25dea8cbfc)();
        if (isHydratable) {
            window['__HYDRATION_START__'] = performance.now();
            window['__HYDRATION_FAILED__'] = false;
            $67148092cd3543c6$var$logger.debug`Starting hydration`;
            const root = (0, $fRQ3t.hydrateRoot)(rootNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ConcurrentApp, null), {
                onRecoverableError: (error, errorInfo)=>{
                    if (window['__HYDRATION_ERRORS__'] && error?.message) window['__HYDRATION_ERRORS__'].push({
                        type: 'ERROR_MESSAGES_FROM_REACT',
                        msg: error.message,
                        stack: (0, $c641ec602c55a36e$export$423e2732e9c54334)(errorInfo)
                    });
                    const { hydrationFailed: hydrationFailed, friendlyMessage: friendlyMessage, docLink: docLink } = (0, $dtDUi.matchHydrationError)(error);
                    if (hydrationFailed) {
                        window['__HYDRATION_FAILED__'] = true;
                        if ((0, $1xpoY.default).getBoolean('confluence_frontend_hydration_error_event', false)) (0, $301b91f6022f88c3$export$6f190738a936fdf9)(error, errorInfo);
                    }
                }
            });
            window.__REACT_ROOT__ = root;
            if (window.__SSR_REACT_STREAMING__) // When streaming is enabled, we can schedule a synchronous hydration for all
            // resolved suspense boundaries in the root node as otherwise there is a
            // performance regression in React 18 that impacts TTAI
            //
            // https://hello.atlassian.net/wiki/spaces/~moates/pages/5497372057/Challenges+with+Selective+Hydration
            //
            // When we move to React 19 we can remove this.
            //
            // @see scheduleSyncHydration
            (0, $55460e99d99202dd$export$b5009d2dcc72fd5c)(rootNode, root);
        } else {
            const concurrentRoot = (0, $fRQ3t.createRoot)(rootNode);
            concurrentRoot.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ConcurrentApp, null));
        }
    });
});
 }, ["7EorR","k5AqE","dBvR6","aZinD","eiF7i","gbJtu","cWL7t","hhss7","1JeTB","deTdD","5sZTx","gGPOl","2D1RT","cRrl7","j0mEJ","fq1gG","4g6rd","ffEVr","Wowvf","6gMrU","fUeur","zUKwV","4UAag","4Gdnz","fob67","cL90P","a7sEM","ipkwd","iTOzX","gSKF7","aNyWk","2VXwF","8P3cI","1lDWJ","fEMSy","6ijE0","hLKNw","crfrC","90SZm","bHb1X","bPC3R","1yIye","c7nj5","a92TB","ca0UP","icVON","jisiR","jAsJw","ksOjm","dZYhM","8MaGw","a9LoI","lAHCT","eNgZ8","gd133","Nnc5n","7SteV","fqrmE","aGpvE","4dKZ4","fgnsT","bSWYL","iy7LF","4xGtR","3Xf9v","hMfq4","fNwGw","1tqsw","5SpB1","glcJK","kYlwR","53Y0O","6wr18","hUbK8","kT6dz","1QTBI"]);

$parcel$global.rlb("aFBfl")
//# sourceMappingURL=dashboard-spa-container-jquery3.8f509063.js.map
